// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"f6pFz":[function(require,module,exports,__globalThis) {
require("78c62313968fcccf").register(require("b39efc6ddf8058cd").getBundleURL('aXUmi'), JSON.parse("[\"aXUmi\",\"index.4842bf58.js\",\"5rJ1p\",\"../node_modules/@blueprintjs/icons/lib/esm/paths-loaders/allPathsLoader.ec9dabbe.js\",\"4RRE6\",\"../node_modules/@blueprintjs/icons/lib/esm/paths-loaders/splitPathsBySizeLoader.b049cbcf.js\",\"c0SK8\",\"index.611556fe.css\"]"));

},{"78c62313968fcccf":"gSiLw","b39efc6ddf8058cd":"a2ypy"}],"gSiLw":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"a2ypy":[function(require,module,exports,__globalThis) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"7zcRT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _indexCss = require("./index.css");
var _appContainer = require("./AppContainer");
var _appContainerDefault = parcelHelpers.interopDefault(_appContainer);
var _serviceWorker = require("./serviceWorker");
var _constants = require("./constants");
var _react1 = require("@honeybadger-io/react");
var _core = require("@blueprintjs/core");
const pos = document.location.host.indexOf('.');
const client = pos == -1 ? 'test' : document.location.host.substr(0, pos);
(0, _react1.Honeybadger).configure({
    apiKey: (0, _constants.HONEY_BADGER_API_KEY),
    environment: (0, _constants.ENVIRONMENT),
    disabled: (0, _constants.ENVIRONMENT) != 'production',
    revision: (0, _constants.HONEY_BADGER_REVISION)
});
(0, _react1.Honeybadger).setContext({
    client
});
(0, _reactDomDefault.default).render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.HoneybadgerErrorBoundary), {
    honeybadger: (0, _react1.Honeybadger),
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.OverlaysProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appContainerDefault.default), {
            client: client
        })
    })
}), document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
_serviceWorker.unregister();

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dom":"2ApDx","./index.css":"83Cio","./AppContainer":"iAuWr","./serviceWorker":"lj4sn","./constants":"g9BKl","@honeybadger-io/react":"jFoJ4","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1dlk8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"8eUfv"}],"8eUfv":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
require("ea59cf80247f96ff");
var f = require("3fd2a064dc1f3641"), g = 60103;
exports.Fragment = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    exports.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: m.current
    };
}
exports.jsx = q;
exports.jsxs = q;

},{"ea59cf80247f96ff":"dudAz","3fd2a064dc1f3641":"9njXz"}],"dudAz":[function(require,module,exports,__globalThis) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"9njXz":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"kgZgX"}],"kgZgX":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = require("f790cf940e488cc5"), n = 60103, p = 60106;
exports.Fragment = 60107;
exports.StrictMode = 60108;
exports.Profiler = 60114;
var q = 60109, r = 60110, t = 60112;
exports.Suspense = 60113;
var u = 60115, v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var w = Symbol.for;
    n = w("react.element");
    p = w("react.portal");
    exports.Fragment = w("react.fragment");
    exports.StrictMode = w("react.strict_mode");
    exports.Profiler = w("react.profiler");
    q = w("react.provider");
    r = w("react.context");
    t = w("react.forward_ref");
    exports.Suspense = w("react.suspense");
    u = w("react.memo");
    v = w("react.lazy");
}
var x = "function" === typeof Symbol && Symbol.iterator;
function y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = x && a[x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, B = {};
function C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
C.prototype.isReactComponent = {};
C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function D() {}
D.prototype = C.prototype;
function E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
var F = E.prototype = new D;
F.constructor = E;
l(F, C.prototype);
F.isPureReactComponent = !0;
var G = {
    current: null
}, H = Object.prototype.hasOwnProperty, I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)H.call(b, e) && !I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: G.current
    };
}
function K(a, b) {
    return {
        $$typeof: n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === n;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var M = /\/+/g;
function N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case n:
                case p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace(M, "$&/") + "/"), O(d, b, c, "", function(a) {
        return a;
    })) : null != d && (L(d) && (d = K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace(M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + N(k, g);
        h += O(k, b, c, f, d);
    }
    else if (f = y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + N(k, g++), h += O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error(z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var R = {
    current: null
};
function S() {
    var a = R.current;
    if (null === a) throw Error(z(321));
    return a;
}
var T = {
    ReactCurrentDispatcher: R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: l
};
exports.Children = {
    map: P,
    forEach: function(a, b, c) {
        P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!L(a)) throw Error(z(143));
        return a;
    }
};
exports.Component = C;
exports.PureComponent = E;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = T;
exports.cloneElement = function(a, b, c) {
    if (null === a || void 0 === a) throw Error(z(267, a));
    var e = l({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)H.call(b, f) && !I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
exports.createContext = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: q,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = J;
exports.createFactory = function(a) {
    var b = J.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: t,
        render: a
    };
};
exports.isValidElement = L;
exports.lazy = function(a) {
    return {
        $$typeof: v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: Q
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.useCallback = function(a, b) {
    return S().useCallback(a, b);
};
exports.useContext = function(a, b) {
    return S().useContext(a, b);
};
exports.useDebugValue = function() {};
exports.useEffect = function(a, b) {
    return S().useEffect(a, b);
};
exports.useImperativeHandle = function(a, b, c) {
    return S().useImperativeHandle(a, b, c);
};
exports.useLayoutEffect = function(a, b) {
    return S().useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return S().useMemo(a, b);
};
exports.useReducer = function(a, b, c) {
    return S().useReducer(a, b, c);
};
exports.useRef = function(a) {
    return S().useRef(a);
};
exports.useState = function(a) {
    return S().useState(a);
};
exports.version = "17.0.2";

},{"f790cf940e488cc5":"dudAz"}],"2ApDx":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"3ekrv"}],"3ekrv":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), m = require("dc13beaf0535b548"), r = require("ece50e903283a22f");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!aa) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return m({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    aa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = m({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return m({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = m({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        r.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = r.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = r.unstable_UserBlockingPriority, ed = r.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    m(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = m({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = m({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = m({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = m({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = m({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = m({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = m({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = m({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = m({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = m({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = m({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = m({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return m({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = r.unstable_runWithPriority, Of = r.unstable_scheduleCallback, Pf = r.unstable_cancelCallback, Qf = r.unstable_shouldYield, Rf = r.unstable_requestPaint, Sf = r.unstable_now, Tf = r.unstable_getCurrentPriorityLevel, Uf = r.unstable_ImmediatePriority, Vf = r.unstable_UserBlockingPriority, Wf = r.unstable_NormalPriority, Xf = r.unstable_LowPriority, Yf = r.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = m({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = m({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new aa.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : m({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = m({}, e, {
                    value: void 0
                });
                d = m({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = m({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

},{"5393afc8c463ef07":"9njXz","dc13beaf0535b548":"dudAz","ece50e903283a22f":"eTyLO"}],"eTyLO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"i8Rha"}],"i8Rha":[function(require,module,exports,__globalThis) {
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f, g, h, k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var t = null, u = null, w = function() {
        if (null !== t) try {
            var a = exports.unstable_now();
            t(!0, a);
            t = null;
        } catch (b) {
            throw setTimeout(w, 0), b;
        }
    };
    f = function(a) {
        null !== t ? setTimeout(f, 0, a) : (t = a, setTimeout(w, 0));
    };
    g = function(a, b) {
        u = setTimeout(a, b);
    };
    h = function() {
        clearTimeout(u);
    };
    exports.unstable_shouldYield = function() {
        return !1;
    };
    k = exports.unstable_forceFrameRate = function() {};
} else {
    var x = window.setTimeout, y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var A = !1, B = null, C = -1, D = 5, E = 0;
    exports.unstable_shouldYield = function() {
        return exports.unstable_now() >= E;
    };
    k = function() {};
    exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var F = new MessageChannel, G = F.port2;
    F.port1.onmessage = function() {
        if (null !== B) {
            var a = exports.unstable_now();
            E = a + D;
            try {
                B(!0, a) ? G.postMessage(null) : (A = !1, B = null);
            } catch (b) {
                throw G.postMessage(null), b;
            }
        } else A = !1;
    };
    f = function(a) {
        B = a;
        A || (A = !0, G.postMessage(null));
    };
    g = function(a, b) {
        C = x(function() {
            a(exports.unstable_now());
        }, b);
    };
    h = function() {
        y(C);
        C = -1;
    };
}
function H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > I(n, c)) void 0 !== r && 0 > I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var L = [], M = [], N = 1, O = null, P = 3, Q = !1, R = !1, S = !1;
function T(a) {
    for(var b = J(M); null !== b;){
        if (null === b.callback) K(M);
        else if (b.startTime <= a) K(M), b.sortIndex = b.expirationTime, H(L, b);
        else break;
        b = J(M);
    }
}
function U(a) {
    S = !1;
    T(a);
    if (!R) {
        if (null !== J(L)) R = !0, f(V);
        else {
            var b = J(M);
            null !== b && g(U, b.startTime - a);
        }
    }
}
function V(a, b) {
    R = !1;
    S && (S = !1, h());
    Q = !0;
    var c = P;
    try {
        T(b);
        for(O = J(L); null !== O && (!(O.expirationTime > b) || a && !exports.unstable_shouldYield());){
            var d = O.callback;
            if ("function" === typeof d) {
                O.callback = null;
                P = O.priorityLevel;
                var e = d(O.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? O.callback = e : O === J(L) && K(L);
                T(b);
            } else K(L);
            O = J(L);
        }
        if (null !== O) var m = !0;
        else {
            var n = J(M);
            null !== n && g(U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        O = null, P = c, Q = !1;
    }
}
var W = k;
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    R || Q || (R = !0, f(V));
};
exports.unstable_getCurrentPriorityLevel = function() {
    return P;
};
exports.unstable_getFirstCallbackNode = function() {
    return J(L);
};
exports.unstable_next = function(a) {
    switch(P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = P;
    }
    var c = P;
    P = b;
    try {
        return a();
    } finally{
        P = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = W;
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = P;
    P = a;
    try {
        return b();
    } finally{
        P = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, H(M, a), null === J(L) && a === J(M) && (S ? h() : S = !0, g(U, c - d))) : (a.sortIndex = e, H(L, a), R || Q || (R = !0, f(V)));
    return a;
};
exports.unstable_wrapCallback = function(a) {
    var b = P;
    return function() {
        var c = P;
        P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            P = c;
        }
    };
};

},{}],"83Cio":[function() {},{}],"iAuWr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AppContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toolkit = require("@reduxjs/toolkit");
var _rootReducer = require("./reducers/RootReducer");
var _rootReducerDefault = parcelHelpers.interopDefault(_rootReducer);
var _reactRedux = require("react-redux");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _app = require("./App");
var _appDefault = parcelHelpers.interopDefault(_app);
var _constants = require("./constants");
var _userSlice = require("./slices/UserSlice");
var _localStorageHelper = require("./helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
function AppContainer(props) {
    const store = (0, _toolkit.configureStore)({
        reducer: (0, _rootReducerDefault.default),
        preloadedState: {
            //if you add anything here, consider adding it to App.storeLoaded function
            ConstantsSlice: {
                api_url: (0, _constants.API_URL).replace('{client}', props.client),
                client: props.client,
                ws_changes_url: (0, _constants.WS_CHANGES_URL),
                ws_print_url: (0, _constants.WS_PRINT_URL)
            },
            SettingsSlice: {
                api_url: (0, _constants.API_URL).replace('{client}', props.client),
                due_day_count: 8,
                current_id_cash_register: (0, _localStorageHelperDefault.default).GetValue(props.client + '__current_id_cash_register'),
                general: null
            },
            CodeTablesSlice: {
                api_url: (0, _constants.API_URL).replace('{client}', props.client),
                countries: null,
                post_offices: null,
                business_premises: null,
                business_premise_fiscal_registrations: null,
                business_premise_fiscal_registrations_by_id_business_premises: null,
                channels: null,
                customers: null,
                measuring_units: null,
                payment_types: null,
                tax_rates: null,
                warehouses: null,
                accommodations: null,
                accommodation_items: null,
                accommodation_item_places: null,
                accommodation_item_items: null,
                accommodation_item_place_items: null,
                accommodation_item_schedules: null,
                accommodation_item_schedule_time_slots: null,
                accommodation_item_schedule_time_slot_activities: null,
                items: null,
                market_segmentation: null,
                activities: null,
                identification_types: null,
                tourist_taxes: null,
                daily_logbook_activities: null,
                work_types: null
            },
            ReservationSlice: {
                api_url: (0, _constants.API_URL).replace('{client}', props.client),
                reservations: null,
                reservation_customers: null,
                reservation_customers_by_id_reservations: null,
                activity_reservations: null,
                activity_daily_logbooks: null,
                reservation_customer_items: null,
                reservation_requests: null,
                reservation_request_accommodations: null,
                public_accommodations: null,
                public_accommodation_settings: null
            },
            BusinessSlice: {
                api_url: (0, _constants.API_URL).replace('{client}', props.client),
                invoices: null,
                invoice_fiscal_verifications: null,
                advance_invoice_consumptions: null,
                id_advance_invoice_consumption_by_id_advance_invoices: null,
                id_advance_invoice_consumption_by_id_consumer_invoices: null
            },
            UserSlice: {
                token: (0, _jsCookieDefault.default).get('assistpro_token') === 'null' ? null : (0, _jsCookieDefault.default).get('assistpro_token'),
                user: null,
                api_url: (0, _constants.API_URL).replace('{client}', props.client),
                users: null,
                users_by_username: null,
                user_work_types: null
            },
            DocumentSlice: {
                api_url: (0, _constants.API_URL).replace('{client}', props.client),
                document_associations: null,
                document_associations_id_documents: null,
                document_types: null
            },
            GuestSlice: {
                api_url: (0, _constants.API_URL).replace('{client}', props.client),
                guest_book_items: null,
                monthly_guest_book_reports: null
            },
            CashRegisterSlice: {
                api_url: (0, _constants.API_URL).replace('{client}', props.client),
                cash_registers: null,
                cash_register_daily_states: null,
                cash_register_documents: null
            },
            AppSlice: {
                pos_printer_queue: [],
                pos_printer_connected: false,
                a4_printer_queue: [],
                a4_printer_connected: false,
                printers: [],
                label_printer_queue: [],
                label_printer_connected: false,
                label_printers: [],
                critical_error: null,
                force_retention_years: null
            },
            WarehouseSlice: {
                api_url: (0, _constants.API_URL).replace('{client}', props.client),
                stock_acquisition_documents: {},
                delivery_notes: {},
                stock_inventory_items: {},
                stock_inventory_detailed: {},
                stock_inventory_detailed_acquired_items: {},
                stock_inventory_detailed_spent_items: {},
                stock_state: {},
                stock_inventory_by_date: {
                },
                last_stock_data_by_date: {
                },
                detailed_stock_state: {}
            }
        }
    });
    let prev_token = store.getState().UserSlice.token;
    store.subscribe(()=>{
        let new_token = store.getState().UserSlice.token;
        if (prev_token != new_token) {
            prev_token = new_token; //should be set before we do any dispatching, to prevent an endless loop
            console.log([
                'token changed',
                prev_token,
                new_token
            ]);
            (0, _jsCookieDefault.default).set('assistpro_token', new_token === undefined ? null : new_token);
            store.dispatch((0, _userSlice.setUser)({
                user: null,
                token: new_token
            }));
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRedux.Provider), {
        store: store,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {})
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@reduxjs/toolkit":"frlQC","./reducers/RootReducer":"4dJb2","react-redux":"5DyKE","js-cookie":"2d7Fe","./App":"4sGPJ","./constants":"g9BKl","./slices/UserSlice":"ikKoo","./helpers/LocalStorageHelper":"9I9tm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"frlQC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnhancerArray", ()=>EnhancerArray);
parcelHelpers.export(exports, "MiddlewareArray", ()=>MiddlewareArray);
parcelHelpers.export(exports, "SHOULD_AUTOBATCH", ()=>SHOULD_AUTOBATCH);
parcelHelpers.export(exports, "TaskAbortError", ()=>TaskAbortError);
parcelHelpers.export(exports, "addListener", ()=>addListener);
parcelHelpers.export(exports, "autoBatchEnhancer", ()=>autoBatchEnhancer);
parcelHelpers.export(exports, "clearAllListeners", ()=>clearAllListeners);
parcelHelpers.export(exports, "configureStore", ()=>configureStore);
parcelHelpers.export(exports, "createAction", ()=>createAction);
parcelHelpers.export(exports, "createActionCreatorInvariantMiddleware", ()=>createActionCreatorInvariantMiddleware);
parcelHelpers.export(exports, "createAsyncThunk", ()=>createAsyncThunk);
parcelHelpers.export(exports, "createDraftSafeSelector", ()=>createDraftSafeSelector);
parcelHelpers.export(exports, "createEntityAdapter", ()=>createEntityAdapter);
parcelHelpers.export(exports, "createImmutableStateInvariantMiddleware", ()=>createImmutableStateInvariantMiddleware);
parcelHelpers.export(exports, "createListenerMiddleware", ()=>createListenerMiddleware);
parcelHelpers.export(exports, "createNextState", ()=>(0, _immerDefault.default));
parcelHelpers.export(exports, "createReducer", ()=>createReducer);
parcelHelpers.export(exports, "createSelector", ()=>(0, _reselect.createSelector));
parcelHelpers.export(exports, "createSerializableStateInvariantMiddleware", ()=>createSerializableStateInvariantMiddleware);
parcelHelpers.export(exports, "createSlice", ()=>createSlice);
parcelHelpers.export(exports, "current", ()=>(0, _immer.current));
parcelHelpers.export(exports, "findNonSerializableValue", ()=>findNonSerializableValue);
parcelHelpers.export(exports, "freeze", ()=>(0, _immer.freeze));
parcelHelpers.export(exports, "getDefaultMiddleware", ()=>getDefaultMiddleware);
parcelHelpers.export(exports, "getType", ()=>getType);
parcelHelpers.export(exports, "isAction", ()=>isAction);
parcelHelpers.export(exports, "isActionCreator", ()=>isActionCreator);
parcelHelpers.export(exports, "isAllOf", ()=>isAllOf);
parcelHelpers.export(exports, "isAnyOf", ()=>isAnyOf);
parcelHelpers.export(exports, "isAsyncThunkAction", ()=>isAsyncThunkAction);
parcelHelpers.export(exports, "isDraft", ()=>(0, _immer.isDraft));
parcelHelpers.export(exports, "isFluxStandardAction", ()=>isFSA);
parcelHelpers.export(exports, "isFulfilled", ()=>isFulfilled);
parcelHelpers.export(exports, "isImmutableDefault", ()=>isImmutableDefault);
parcelHelpers.export(exports, "isPending", ()=>isPending);
parcelHelpers.export(exports, "isPlain", ()=>isPlain);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isRejected", ()=>isRejected);
parcelHelpers.export(exports, "isRejectedWithValue", ()=>isRejectedWithValue);
parcelHelpers.export(exports, "miniSerializeError", ()=>miniSerializeError);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "original", ()=>(0, _immer.original));
parcelHelpers.export(exports, "prepareAutoBatched", ()=>prepareAutoBatched);
parcelHelpers.export(exports, "removeListener", ()=>removeListener);
parcelHelpers.export(exports, "unwrapResult", ()=>unwrapResult);
// src/index.ts
var _immer = require("immer");
var _redux = require("redux");
parcelHelpers.exportAll(_redux, exports);
var _immerDefault = parcelHelpers.interopDefault(_immer);
var _reselect = require("reselect");
// src/getDefaultMiddleware.ts
var _reduxThunk = require("redux-thunk");
var _reduxThunkDefault = parcelHelpers.interopDefault(_reduxThunk);
var process = require("728135d01089d859");
var global = arguments[3];
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for(var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = function(a, b) {
    return __defProps(a, __getOwnPropDescs(b));
};
var __async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var createDraftSafeSelector = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, _reselect.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, __spreadArray([
            (0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, _redux.compose;
    return (0, _redux.compose).apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function isPlainObject(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function isAction(action) {
    return isPlainObject(action) && "type" in action;
}
function isActionCreator(action) {
    return typeof action === "function" && "type" in action && hasMatchFunction(action);
}
function isFSA(action) {
    return isAction(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function createActionCreatorInvariantMiddleware(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var MiddlewareArray = /** @class */ function(_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var EnhancerArray = /** @class */ function(_super) {
    __extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function freezeDraftable(val) {
    return (0, _immer.isDraftable)(val) ? (0, _immerDefault.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var isProduction = true;
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = isPlain;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && isNestedFrozen(value)) cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) middlewareArray.push((0, _reduxThunkDefault.default));
        else middlewareArray.push((0, _reduxThunkDefault.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = true;
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if (isPlainObject(reducer)) rootReducer = (0, _redux.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, _redux.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, _redux.compose);
    if (devTools) finalCompose = composeWithDevTools(__spreadValues({
        trace: !IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new EnhancerArray(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = __spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, _redux.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
var hasWarnedAboutObjectNotation = false;
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) getInitialState = function() {
        return freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, _immer.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, _immer.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, _immerDefault.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var hasWarnedAboutObjectNotation2 = false;
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof process;
    var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createDraftSafeSelector(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, _immer.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, _immerDefault.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !(selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) options = {};
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var miniSerializeError = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var createAsyncThunk = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = createAction(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = createAction(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = createAction(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return __async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return __generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof RejectWithValue) throw result;
                                                if (result instanceof FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var matches = function(matcher, action) {
    if (hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function isAnyOf() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return matches(matcher, action);
        });
    };
}
function isAllOf() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return matches(matcher, action);
        });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isPending()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isRejected()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isRejectedWithValue()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isFulfilled()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isAsyncThunkAction()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var noop = function() {};
var catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = noop;
    promise2.catch(onError);
    return promise2;
};
var addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = task + " " + cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var validateActive = function(signal) {
    if (signal.aborted) throw new TaskAbortError(signal.reason);
};
function raceWithSignal(signal, promise2) {
    var cleanup = noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new TaskAbortError(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = noop;
    });
}
var runTask = function(task2, cleanUp) {
    return __async(void 0, null, function() {
        var value, error_1;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var createPause = function(signal) {
    return function(promise2) {
        return catchRejection(raceWithSignal(signal, promise2).then(function(output) {
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = function(signal) {
    var pause = createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return addAbortSignalListener(parentAbortSignal, function() {
            return abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = runTask(function() {
            return __async(void 0, null, function() {
                var result2;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            validateActive(parentAbortSignal);
                            validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: createPause(childAbortController.signal),
                                    delay: createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return abortControllerWithReason(childAbortController, taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: createPause(parentAbortSignal)(result),
            cancel: function() {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return __async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return catchRejection(take(predicate, timeout));
    };
};
var getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = createAction(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var createListenerEntry = function(options) {
    var _c = getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = nanoid();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        abortControllerWithReason(controller, listenerCancelled);
    });
};
var createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, __spreadArray([
        alm + "/error"
    ], args));
};
function createListenerMiddleware(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? defaultErrorHandler : _c;
    assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return __async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: createDelay(internalTaskController.signal),
                                pause: createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            abortControllerWithReason(controller, listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof TaskAbortError)) safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        abortControllerWithReason(internalTaskController, listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!isAction(action)) return next(action);
                if (addListener.match(action)) return startListening(action.payload);
                if (clearAllListeners.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if (removeListener.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === INTERNAL_NIL_TOKEN) throw new Error(alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[SHOULD_AUTOBATCH] = true, _c)
        };
    };
};
var promise;
var queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : globalThis) : function(cb) {
    return (promise || (promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? queueMicrotaskShim : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, _immer.enableES5)();

},{"728135d01089d859":"5jT8D","immer":"8Hnng","redux":"ikKU1","reselect":"aLeEG","redux-thunk":"1uf85","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jT8D":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"8Hnng":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>un);
parcelHelpers.export(exports, "applyPatches", ()=>pn);
parcelHelpers.export(exports, "castDraft", ()=>K);
parcelHelpers.export(exports, "castImmutable", ()=>$);
parcelHelpers.export(exports, "createDraft", ()=>ln);
parcelHelpers.export(exports, "current", ()=>R);
parcelHelpers.export(exports, "enableAllPlugins", ()=>J);
parcelHelpers.export(exports, "enableES5", ()=>F);
parcelHelpers.export(exports, "enableMapSet", ()=>C);
parcelHelpers.export(exports, "enablePatches", ()=>T);
parcelHelpers.export(exports, "finishDraft", ()=>dn);
parcelHelpers.export(exports, "freeze", ()=>d);
parcelHelpers.export(exports, "immerable", ()=>L);
parcelHelpers.export(exports, "isDraft", ()=>r);
parcelHelpers.export(exports, "isDraftable", ()=>t);
parcelHelpers.export(exports, "nothing", ()=>H);
parcelHelpers.export(exports, "original", ()=>e);
parcelHelpers.export(exports, "produce", ()=>fn);
parcelHelpers.export(exports, "produceWithPatches", ()=>cn);
parcelHelpers.export(exports, "setAutoFreeze", ()=>sn);
parcelHelpers.export(exports, "setUseProxies", ()=>vn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(_n) {
                            void 0 !== o[_n] || u(o, _n) || (f[_n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
exports.default = fn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiucr":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"ikKU1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if (isDate(val)) return 'date';
    if (isError(val)) return 'error';
    var constructorName = ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error(formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error(formatProdErrorMessage(8));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === 'undefined') throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error(formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59BsR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"5zOJa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5zOJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"61Sn9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"61Sn9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"la19k","./toPrimitive.js":"cVPci","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"la19k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVPci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"la19k","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aLeEG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMemoize", ()=>(0, _defaultMemoize.defaultMemoize));
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>(0, _defaultMemoize.defaultEqualityCheck));
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
var _defaultMemoize = require("./defaultMemoize");
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var createSelector = /* #__PURE__ */ createSelectorCreator((0, _defaultMemoize.defaultMemoize));
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

},{"./defaultMemoize":"47j0e","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"47j0e":[function(require,module,exports,__globalThis) {
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>defaultEqualityCheck);
parcelHelpers.export(exports, "createCacheKeyComparator", ()=>createCacheKeyComparator);
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
parcelHelpers.export(exports, "defaultMemoize", ()=>defaultMemoize);
var NOT_FOUND = 'NOT_FOUND';
function createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
    return a === b;
};
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1uf85":[function(require,module,exports,__globalThis) {
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
thunk.withExtraArgument = createThunkMiddleware;
exports.default = thunk;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4dJb2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _redux = require("redux");
var _codeTablesSlice = require("../slices/CodeTablesSlice");
var _codeTablesSliceDefault = parcelHelpers.interopDefault(_codeTablesSlice);
var _reservationSlice = require("../slices/ReservationSlice");
var _reservationSliceDefault = parcelHelpers.interopDefault(_reservationSlice);
var _businessSlice = require("../slices/BusinessSlice");
var _businessSliceDefault = parcelHelpers.interopDefault(_businessSlice);
var _userSlice = require("../slices/UserSlice");
var _userSliceDefault = parcelHelpers.interopDefault(_userSlice);
var _constantsSlice = require("../slices/ConstantsSlice");
var _constantsSliceDefault = parcelHelpers.interopDefault(_constantsSlice);
var _documentSlice = require("../slices/DocumentSlice");
var _documentSliceDefault = parcelHelpers.interopDefault(_documentSlice);
var _settingsSlice = require("../slices/SettingsSlice");
var _settingsSliceDefault = parcelHelpers.interopDefault(_settingsSlice);
var _guestSlice = require("../slices/GuestSlice");
var _guestSliceDefault = parcelHelpers.interopDefault(_guestSlice);
var _cashRegisterSlice = require("../slices/CashRegisterSlice");
var _cashRegisterSliceDefault = parcelHelpers.interopDefault(_cashRegisterSlice);
var _appSlice = require("../slices/AppSlice");
var _appSliceDefault = parcelHelpers.interopDefault(_appSlice);
var _warehouseSlice = require("../slices/WarehouseSlice");
var _warehouseSliceDefault = parcelHelpers.interopDefault(_warehouseSlice);
exports.default = (0, _redux.combineReducers)({
    CodeTablesSlice: (0, _codeTablesSliceDefault.default),
    ReservationSlice: (0, _reservationSliceDefault.default),
    BusinessSlice: (0, _businessSliceDefault.default),
    UserSlice: (0, _userSliceDefault.default),
    ConstantsSlice: (0, _constantsSliceDefault.default),
    DocumentSlice: (0, _documentSliceDefault.default),
    SettingsSlice: (0, _settingsSliceDefault.default),
    GuestSlice: (0, _guestSliceDefault.default),
    CashRegisterSlice: (0, _cashRegisterSliceDefault.default),
    AppSlice: (0, _appSliceDefault.default),
    WarehouseSlice: (0, _warehouseSliceDefault.default)
});

},{"redux":"ikKU1","../slices/CodeTablesSlice":"hfPGz","../slices/ReservationSlice":"kTPna","../slices/BusinessSlice":"47JXm","../slices/UserSlice":"ikKoo","../slices/ConstantsSlice":"fIlI9","../slices/DocumentSlice":"6gdAm","../slices/SettingsSlice":"ajHkF","../slices/GuestSlice":"bE5rS","../slices/CashRegisterSlice":"1FTf7","../slices/AppSlice":"aByTQ","../slices/WarehouseSlice":"8QIEM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfPGz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addCountry", ()=>addCountry);
parcelHelpers.export(exports, "addCountries", ()=>addCountries);
parcelHelpers.export(exports, "deleteCountry", ()=>deleteCountry);
parcelHelpers.export(exports, "addPostOffice", ()=>addPostOffice);
parcelHelpers.export(exports, "addPostOffices", ()=>addPostOffices);
parcelHelpers.export(exports, "deletePostOffice", ()=>deletePostOffice);
parcelHelpers.export(exports, "addBusinessPremise", ()=>addBusinessPremise);
parcelHelpers.export(exports, "addBusinessPremises", ()=>addBusinessPremises);
parcelHelpers.export(exports, "deleteBusinessPremise", ()=>deleteBusinessPremise);
parcelHelpers.export(exports, "addChannel", ()=>addChannel);
parcelHelpers.export(exports, "addChannels", ()=>addChannels);
parcelHelpers.export(exports, "deleteChannel", ()=>deleteChannel);
parcelHelpers.export(exports, "addCustomer", ()=>addCustomer);
parcelHelpers.export(exports, "addCustomers", ()=>addCustomers);
parcelHelpers.export(exports, "deleteCustomer", ()=>deleteCustomer);
parcelHelpers.export(exports, "addMeasuringUnit", ()=>addMeasuringUnit);
parcelHelpers.export(exports, "addMeasuringUnits", ()=>addMeasuringUnits);
parcelHelpers.export(exports, "deleteMeasuringUnit", ()=>deleteMeasuringUnit);
parcelHelpers.export(exports, "addPaymentType", ()=>addPaymentType);
parcelHelpers.export(exports, "addPaymentTypes", ()=>addPaymentTypes);
parcelHelpers.export(exports, "deletePaymentType", ()=>deletePaymentType);
parcelHelpers.export(exports, "addTaxRate", ()=>addTaxRate);
parcelHelpers.export(exports, "addTaxRates", ()=>addTaxRates);
parcelHelpers.export(exports, "deleteTaxRate", ()=>deleteTaxRate);
parcelHelpers.export(exports, "addWarehouse", ()=>addWarehouse);
parcelHelpers.export(exports, "addWarehouses", ()=>addWarehouses);
parcelHelpers.export(exports, "deleteWarehouse", ()=>deleteWarehouse);
parcelHelpers.export(exports, "addAccommodation", ()=>addAccommodation);
parcelHelpers.export(exports, "addAccommodations", ()=>addAccommodations);
parcelHelpers.export(exports, "deleteAccommodation", ()=>deleteAccommodation);
parcelHelpers.export(exports, "addAccommodationItem", ()=>addAccommodationItem);
parcelHelpers.export(exports, "addAccommodationItems", ()=>addAccommodationItems);
parcelHelpers.export(exports, "deleteAccommodationItem", ()=>deleteAccommodationItem);
parcelHelpers.export(exports, "addAccommodationItemPlace", ()=>addAccommodationItemPlace);
parcelHelpers.export(exports, "addAccommodationItemPlaces", ()=>addAccommodationItemPlaces);
parcelHelpers.export(exports, "deleteAccommodationItemPlace", ()=>deleteAccommodationItemPlace);
parcelHelpers.export(exports, "addAccommodationItemItem", ()=>addAccommodationItemItem);
parcelHelpers.export(exports, "addAccommodationItemItems", ()=>addAccommodationItemItems);
parcelHelpers.export(exports, "deleteAccommodationItemItem", ()=>deleteAccommodationItemItem);
parcelHelpers.export(exports, "addAccommodationItemPlaceItem", ()=>addAccommodationItemPlaceItem);
parcelHelpers.export(exports, "addAccommodationItemPlaceItems", ()=>addAccommodationItemPlaceItems);
parcelHelpers.export(exports, "deleteAccommodationItemPlaceItem", ()=>deleteAccommodationItemPlaceItem);
parcelHelpers.export(exports, "addAccommodationItemSchedule", ()=>addAccommodationItemSchedule);
parcelHelpers.export(exports, "addAccommodationItemSchedules", ()=>addAccommodationItemSchedules);
parcelHelpers.export(exports, "deleteAccommodationItemSchedule", ()=>deleteAccommodationItemSchedule);
parcelHelpers.export(exports, "addAccommodationItemScheduleTimeSlot", ()=>addAccommodationItemScheduleTimeSlot);
parcelHelpers.export(exports, "addAccommodationItemScheduleTimeSlots", ()=>addAccommodationItemScheduleTimeSlots);
parcelHelpers.export(exports, "deleteAccommodationItemScheduleTimeSlot", ()=>deleteAccommodationItemScheduleTimeSlot);
parcelHelpers.export(exports, "addAccommodationItemScheduleTimeSlotActivity", ()=>addAccommodationItemScheduleTimeSlotActivity);
parcelHelpers.export(exports, "addAccommodationItemScheduleTimeSlotActivities", ()=>addAccommodationItemScheduleTimeSlotActivities);
parcelHelpers.export(exports, "deleteAccommodationItemScheduleTimeSlotActivity", ()=>deleteAccommodationItemScheduleTimeSlotActivity);
parcelHelpers.export(exports, "addItem", ()=>addItem);
parcelHelpers.export(exports, "addItems", ()=>addItems);
parcelHelpers.export(exports, "deleteItem", ()=>deleteItem);
parcelHelpers.export(exports, "addMarketSegmentationItem", ()=>addMarketSegmentationItem);
parcelHelpers.export(exports, "addMarketSegmentation", ()=>addMarketSegmentation);
parcelHelpers.export(exports, "deleteMarketSegmentationItem", ()=>deleteMarketSegmentationItem);
parcelHelpers.export(exports, "addActivity", ()=>addActivity);
parcelHelpers.export(exports, "addActivities", ()=>addActivities);
parcelHelpers.export(exports, "deleteActivity", ()=>deleteActivity);
parcelHelpers.export(exports, "addIdentificationType", ()=>addIdentificationType);
parcelHelpers.export(exports, "addIdentificationTypes", ()=>addIdentificationTypes);
parcelHelpers.export(exports, "deleteIdentificationType", ()=>deleteIdentificationType);
parcelHelpers.export(exports, "addTouristTax", ()=>addTouristTax);
parcelHelpers.export(exports, "addTouristTaxes", ()=>addTouristTaxes);
parcelHelpers.export(exports, "deleteTouristTax", ()=>deleteTouristTax);
parcelHelpers.export(exports, "addBusinessPremiseFiscalRegistrations", ()=>addBusinessPremiseFiscalRegistrations);
parcelHelpers.export(exports, "addDailyLogbookActivity", ()=>addDailyLogbookActivity);
parcelHelpers.export(exports, "addDailyLogbookActivities", ()=>addDailyLogbookActivities);
parcelHelpers.export(exports, "addWorkType", ()=>addWorkType);
parcelHelpers.export(exports, "addWorkTypes", ()=>addWorkTypes);
var _toolkit = require("@reduxjs/toolkit");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _codeTables = require("../api/CodeTables");
function addItemToState(state_key_name, key_name, payload, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    const item = payload.item;
    const token = payload.token;
    if (item[key_name] == -1) item[key_name] = (0, _uuidDefault.default).v4();
    state[state_key_name][item[key_name]] = item;
    if (payload.save_to_api === true) (0, _codeTables.saveCodeTableItem)(state.api_url, state_key_name, item, token);
}
function addItemsToState(state_key_name, key_name, items, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        if (state_key_name == 'items') {
            const price_lists = {};
            for(let j = 0; j < item.price_lists.length; j++)price_lists[item.price_lists[j].id_item_price_list] = item.price_lists[j];
            item.price_lists = price_lists;
        }
        state[state_key_name][items[i][key_name]] = items[i];
    }
}
function deleteItemFromState(state_key_name, payload, state) {
    const key_value = payload.key_value;
    const token = payload.token;
    delete state[state_key_name][key_value];
    (0, _codeTables.deleteCodeTableItem)(state.api_url, state_key_name, key_value, token);
}
const CodeTablesSlice = (0, _toolkit.createSlice)({
    name: 'code_tables',
    initialState: {},
    reducers: {
        addCountry: (state, action)=>addItemToState('countries', 'id_country', action.payload, state),
        addCountries: (state, action)=>addItemsToState('countries', 'id_country', action.payload, state),
        deleteCountry: (state, action)=>deleteItemFromState('countries', action.payload, state),
        addPostOffice: (state, action)=>addItemToState('post_offices', 'id_post_office', action.payload, state),
        addPostOffices: (state, action)=>addItemsToState('post_offices', 'id_post_office', action.payload, state),
        deletePostOffice: (state, action)=>deleteItemFromState('post_offices', action.payload, state),
        addBusinessPremise: (state, action)=>addItemToState('business_premises', 'id_business_premise', action.payload, state),
        addBusinessPremises: (state, action)=>addItemsToState('business_premises', 'id_business_premise', action.payload, state),
        deleteBusinessPremise: (state, action)=>deleteItemFromState('business_premises', action.payload, state),
        addChannel: (state, action)=>addItemToState('channels', 'id_channel', action.payload, state),
        addChannels: (state, action)=>addItemsToState('channels', 'id_channel', action.payload, state),
        deleteChannel: (state, action)=>deleteItemFromState('channels', action.payload, state),
        addCustomer: (state, action)=>addItemToState('customers', 'id_customer', action.payload, state),
        addCustomers: (state, action)=>addItemsToState('customers', 'id_customer', action.payload, state),
        deleteCustomer: (state, action)=>deleteItemFromState('customers', action.payload, state),
        addMeasuringUnit: (state, action)=>addItemToState('measuring_units', 'id_measuring_unit', action.payload, state),
        addMeasuringUnits: (state, action)=>addItemsToState('measuring_units', 'id_measuring_unit', action.payload, state),
        deleteMeasuringUnit: (state, action)=>deleteItemFromState('measuring_units', action.payload, state),
        addPaymentType: (state, action)=>addItemToState('payment_types', 'id_payment_type', action.payload, state),
        addPaymentTypes: (state, action)=>addItemsToState('payment_types', 'id_payment_type', action.payload, state),
        deletePaymentType: (state, action)=>deleteItemFromState('payment_types', action.payload, state),
        addTaxRate: (state, action)=>addItemToState('tax_rates', 'id_tax_rate', action.payload, state),
        addTaxRates: (state, action)=>addItemsToState('tax_rates', 'id_tax_rate', action.payload, state),
        deleteTaxRate: (state, action)=>deleteItemFromState('tax_rates', action.payload, state),
        addWarehouse: (state, action)=>addItemToState('warehouses', 'id_warehouse', action.payload, state),
        addWarehouses: (state, action)=>addItemsToState('warehouses', 'id_warehouse', action.payload, state),
        deleteWarehouse: (state, action)=>deleteItemFromState('warehouses', action.payload, state),
        addAccommodation: (state, action)=>addItemToState('accommodations', 'id_accommodation', action.payload, state),
        addAccommodations: (state, action)=>addItemsToState('accommodations', 'id_accommodation', action.payload, state),
        deleteAccommodation: (state, action)=>deleteItemFromState('accommodations', action.payload, state),
        addAccommodationItem: (state, action)=>addItemToState('accommodation_items', 'id_accommodation_item', action.payload, state),
        addAccommodationItems: (state, action)=>addItemsToState('accommodation_items', 'id_accommodation_item', action.payload, state),
        deleteAccommodationItem: (state, action)=>deleteItemFromState('accommodation_items', action.payload, state),
        addAccommodationItemPlace: (state, action)=>addItemToState('accommodation_item_places', 'id_accommodation_item_place', action.payload, state),
        addAccommodationItemPlaces: (state, action)=>addItemsToState('accommodation_item_places', 'id_accommodation_item_place', action.payload, state),
        deleteAccommodationItemPlace: (state, action)=>deleteItemFromState('accommodation_item_places', action.payload, state),
        addAccommodationItemItem: (state, action)=>addItemToState('accommodation_item_items', 'id_accommodation_item_item', action.payload, state),
        addAccommodationItemItems: (state, action)=>addItemsToState('accommodation_item_items', 'id_accommodation_item_item', action.payload, state),
        deleteAccommodationItemItem: (state, action)=>deleteItemFromState('accommodation_item_items', action.payload, state),
        addAccommodationItemPlaceItem: (state, action)=>addItemToState('accommodation_item_place_items', 'id_accommodation_item_place_item', action.payload, state),
        addAccommodationItemPlaceItems: (state, action)=>addItemsToState('accommodation_item_place_items', 'id_accommodation_item_place_item', action.payload, state),
        deleteAccommodationItemPlaceItem: (state, action)=>deleteItemFromState('accommodation_item_place_items', action.payload, state),
        addAccommodationItemSchedule: (state, action)=>addItemToState('accommodation_item_schedules', 'id_accommodation_item_schedule', action.payload, state),
        addAccommodationItemSchedules: (state, action)=>addItemsToState('accommodation_item_schedules', 'id_accommodation_item_schedule', action.payload, state),
        deleteAccommodationItemSchedule: (state, action)=>deleteItemFromState('accommodation_item_schedules', action.payload, state),
        addAccommodationItemScheduleTimeSlot: (state, action)=>addItemToState('accommodation_item_schedule_time_slots', 'id_accommodation_item_schedule_time_slot', action.payload, state),
        addAccommodationItemScheduleTimeSlots: (state, action)=>addItemsToState('accommodation_item_schedule_time_slots', 'id_accommodation_item_schedule_time_slot', action.payload, state),
        deleteAccommodationItemScheduleTimeSlot: (state, action)=>deleteItemFromState('accommodation_item_schedule_time_slots', action.payload, state),
        addAccommodationItemScheduleTimeSlotActivity: (state, action)=>addItemToState('accommodation_item_schedule_time_slot_activities', 'id_accommodation_item_schedule_time_slot_activity', action.payload, state),
        addAccommodationItemScheduleTimeSlotActivities: (state, action)=>addItemsToState('accommodation_item_schedule_time_slot_activities', 'id_accommodation_item_schedule_time_slot_activity', action.payload, state),
        deleteAccommodationItemScheduleTimeSlotActivity: (state, action)=>deleteItemFromState('accommodation_item_schedule_time_slot_activities', action.payload, state),
        addItem: (state, action)=>addItemToState('items', 'id_item', action.payload, state),
        addItems: (state, action)=>addItemsToState('items', 'id_item', action.payload, state),
        deleteItem: (state, action)=>deleteItemFromState('items', action.payload, state),
        addMarketSegmentationItem: (state, action)=>addItemToState('market_segmentation', 'id_market_segmentation', action.payload, state),
        addMarketSegmentation: (state, action)=>addItemsToState('market_segmentation', 'id_market_segmentation', action.payload, state),
        deleteMarketSegmentationItem: (state, action)=>deleteItemFromState('market_segmentation', action.payload, state),
        addActivity: (state, action)=>addItemToState('activities', 'id_activity', action.payload, state),
        addActivities: (state, action)=>addItemsToState('activities', 'id_activity', action.payload, state),
        deleteActivity: (state, action)=>deleteItemFromState('activities', action.payload, state),
        addIdentificationType: (state, action)=>addItemToState('identification_types', 'id_identification_type', action.payload, state),
        addIdentificationTypes: (state, action)=>addItemsToState('identification_types', 'id_identification_type', action.payload, state),
        deleteIdentificationType: (state, action)=>deleteItemFromState('identification_types', action.payload, state),
        addTouristTax: (state, action)=>addItemToState('tourist_taxes', 'id_tourist_tax', action.payload, state),
        addTouristTaxes: (state, action)=>addItemsToState('tourist_taxes', 'id_tourist_tax', action.payload, state),
        deleteTouristTax: (state, action)=>deleteItemFromState('tourist_taxes', action.payload, state),
        addBusinessPremiseFiscalRegistrations: (state, action)=>{
            addItemsToState('business_premise_fiscal_registrations', 'id_business_premise_fiscal_registration', action.payload, state);
            // add by id business premise
            const items = action.payload;
            const items_by_id_business_premise = {};
            for(let i = 0; i < items.length; i++){
                if (items_by_id_business_premise[items[i].id_business_premise] === undefined) items_by_id_business_premise[items[i].id_business_premise] = [];
                items_by_id_business_premise[items[i].id_business_premise].push(items[i]);
            }
            state['business_premise_fiscal_registrations_by_id_business_premises'] = items_by_id_business_premise;
        },
        //	const todo = state.find(todo => todo.id === action.payload)
        //	if (todo) {
        //		todo.completed = !todo.completed
        //	}
        //}
        addDailyLogbookActivity: (state, action)=>addItemToState('daily_logbook_activities', 'id_daily_logbook_activity', action.payload, state),
        addDailyLogbookActivities: (state, action)=>addItemsToState('daily_logbook_activities', 'id_daily_logbook_activity', action.payload, state),
        addWorkType: (state, action)=>addItemToState('work_types', 'id_work_type', action.payload, state),
        addWorkTypes: (state, action)=>addItemsToState('work_types', 'id_work_type', action.payload, state)
    }
});
const { addCountry, addCountries, deleteCountry, addPostOffice, addPostOffices, deletePostOffice, addBusinessPremise, addBusinessPremises, deleteBusinessPremise, addChannel, addChannels, deleteChannel, addCustomer, addCustomers, deleteCustomer, addMeasuringUnit, addMeasuringUnits, deleteMeasuringUnit, addPaymentType, addPaymentTypes, deletePaymentType, addTaxRate, addTaxRates, deleteTaxRate, addWarehouse, addWarehouses, deleteWarehouse, addAccommodation, addAccommodations, deleteAccommodation, addAccommodationItem, addAccommodationItems, deleteAccommodationItem, addAccommodationItemPlace, addAccommodationItemPlaces, deleteAccommodationItemPlace, addAccommodationItemItem, addAccommodationItemItems, deleteAccommodationItemItem, addAccommodationItemPlaceItem, addAccommodationItemPlaceItems, deleteAccommodationItemPlaceItem, addAccommodationItemSchedule, addAccommodationItemSchedules, deleteAccommodationItemSchedule, addAccommodationItemScheduleTimeSlot, addAccommodationItemScheduleTimeSlots, deleteAccommodationItemScheduleTimeSlot, addAccommodationItemScheduleTimeSlotActivity, addAccommodationItemScheduleTimeSlotActivities, deleteAccommodationItemScheduleTimeSlotActivity, addItem, addItems, deleteItem, addMarketSegmentationItem, addMarketSegmentation, deleteMarketSegmentationItem, addActivity, addActivities, deleteActivity, addIdentificationType, addIdentificationTypes, deleteIdentificationType, addTouristTax, addTouristTaxes, deleteTouristTax, addBusinessPremiseFiscalRegistrations, addDailyLogbookActivity, addDailyLogbookActivities, addWorkType, addWorkTypes } = CodeTablesSlice.actions;
exports.default = CodeTablesSlice.reducer;

},{"@reduxjs/toolkit":"frlQC","uuid":"b52pV","../api/CodeTables":"4GMYC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b52pV":[function(require,module,exports,__globalThis) {
var v1 = require("c6df88204e1f4299");
var v4 = require("3855f0864044f01d");
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
module.exports = uuid;

},{"c6df88204e1f4299":"21w4e","3855f0864044f01d":"cJ9OH"}],"21w4e":[function(require,module,exports,__globalThis) {
var rng = require("3d2d1ae5ae56a8b5");
var bytesToUuid = require("862e80dd3f0567cf");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = rng();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : bytesToUuid(b);
}
module.exports = v1;

},{"3d2d1ae5ae56a8b5":"c2OZN","862e80dd3f0567cf":"98fmI"}],"c2OZN":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}

},{}],"98fmI":[function(require,module,exports,__globalThis) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = bytesToUuid;

},{}],"cJ9OH":[function(require,module,exports,__globalThis) {
var rng = require("24932e89aef21842");
var bytesToUuid = require("5cc20217cefb381c");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"24932e89aef21842":"c2OZN","5cc20217cefb381c":"98fmI"}],"4GMYC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadCountries", ()=>loadCountries);
parcelHelpers.export(exports, "loadPostOffices", ()=>loadPostOffices);
parcelHelpers.export(exports, "loadBusinessPremises", ()=>loadBusinessPremises);
parcelHelpers.export(exports, "loadChannels", ()=>loadChannels);
parcelHelpers.export(exports, "loadCustomers", ()=>loadCustomers);
parcelHelpers.export(exports, "loadMeasuringUnits", ()=>loadMeasuringUnits);
parcelHelpers.export(exports, "loadPaymentTypes", ()=>loadPaymentTypes);
parcelHelpers.export(exports, "loadTaxRates", ()=>loadTaxRates);
parcelHelpers.export(exports, "loadWarehouses", ()=>loadWarehouses);
parcelHelpers.export(exports, "loadAccommodations", ()=>loadAccommodations);
parcelHelpers.export(exports, "loadItems", ()=>loadItems);
parcelHelpers.export(exports, "loadItem", ()=>loadItem);
parcelHelpers.export(exports, "loadMarketSegmentation", ()=>loadMarketSegmentation);
parcelHelpers.export(exports, "loadActivities", ()=>loadActivities);
parcelHelpers.export(exports, "loadIdentificationTypes", ()=>loadIdentificationTypes);
parcelHelpers.export(exports, "loadTouristTaxes", ()=>loadTouristTaxes);
parcelHelpers.export(exports, "loadDailyLogbookActivities", ()=>loadDailyLogbookActivities);
parcelHelpers.export(exports, "loadWorkTypes", ()=>loadWorkTypes);
parcelHelpers.export(exports, "saveCodeTableItem", ()=>saveCodeTableItem);
parcelHelpers.export(exports, "deleteCodeTableItem", ()=>deleteCodeTableItem);
parcelHelpers.export(exports, "loadBusinessPremiseFiscalRegistrations", ()=>loadBusinessPremiseFiscalRegistrations);
parcelHelpers.export(exports, "saveAccommodationItemPlace", ()=>saveAccommodationItemPlace);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _codeTablesSlice = require("../slices/CodeTablesSlice");
var _userSlice = require("../slices/UserSlice");
async function loadCountries(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/countries', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addCountries)(items));
}
async function loadPostOffices(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/post-offices', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addPostOffices)(items));
}
async function loadBusinessPremises(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/business-premises', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addBusinessPremises)(items));
}
async function loadChannels(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/channels', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addChannels)(items));
}
async function loadCustomers(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Customers/v1/customers', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addCustomers)(items));
}
async function loadMeasuringUnits(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/measuring-units', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addMeasuringUnits)(items));
}
async function loadPaymentTypes(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/payment-types', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addPaymentTypes)(items));
}
async function loadTaxRates(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/tax-rates', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addTaxRates)(items));
}
async function loadWarehouses(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Warehouses/v1/warehouses', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addWarehouses)(items));
}
async function loadAccommodations(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Accommodations/v1/accommodations', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else {
        dispatch((0, _codeTablesSlice.addAccommodations)(items.accommodations));
        dispatch((0, _codeTablesSlice.addAccommodationItems)(items.accommodation_items));
        dispatch((0, _codeTablesSlice.addAccommodationItemPlaces)(items.accommodation_item_places));
        dispatch((0, _codeTablesSlice.addAccommodationItemItems)(items.accommodation_item_items));
        dispatch((0, _codeTablesSlice.addAccommodationItemPlaceItems)(items.accommodation_item_place_items));
        dispatch((0, _codeTablesSlice.addAccommodationItemSchedules)(items.accommodation_item_schedules));
        dispatch((0, _codeTablesSlice.addAccommodationItemScheduleTimeSlots)(items.accommodation_item_schedule_time_slots));
        dispatch((0, _codeTablesSlice.addAccommodationItemScheduleTimeSlotActivities)(items.accommodation_item_schedule_time_slot_activities));
    }
}
async function loadItems(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Items/v1/items', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addItems)(items));
}
async function loadItem(api_url, id_item, dispatch, token) {
    let response = await fetch(api_url + 'Items/v1/item?id_item=' + id_item, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let item = await response.json();
    if (item.error_code !== undefined) {
        if (item.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addItem)({
        item
    }));
    return item;
}
async function loadMarketSegmentation(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/market-segmentations', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addMarketSegmentation)(items));
}
async function loadActivities(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/activities', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addActivities)(items));
}
async function loadIdentificationTypes(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/identification-types', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addIdentificationTypes)(items));
}
async function loadTouristTaxes(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/tourist-taxes', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addTouristTaxes)(items));
}
async function loadDailyLogbookActivities(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/daily-logbook-activities', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addDailyLogbookActivities)(items));
}
async function loadWorkTypes(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/work-types', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addWorkTypes)(items));
}
async function saveCodeTableItem(api_url, name, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    const table_names_to_urls = {
        countries: 'CodeTables/v1/save-country',
        post_offices: 'CodeTables/v1/save-post-office',
        business_premises: 'CodeTables/v1/save-business-premise',
        channels: 'CodeTables/v1/save-channel',
        customers: 'Customers/v1/save-customer',
        measuring_units: 'CodeTables/v1/save-measuring-unit',
        payment_types: 'CodeTables/v1/save-payment-type',
        tax_rates: 'CodeTables/v1/save-tax-rate',
        warehouses: 'Warehouses/v1/save-warehouse',
        accommodations: 'Accommodations/v1/save-accommodation',
        items: 'Items/v1/save-item',
        market_segmentation: 'CodeTables/v1/save-market-segmentation',
        activities: 'CodeTables/v1/save-activity',
        identification_types: 'CodeTables/v1/save-identification-type',
        tourist_taxes: 'CodeTables/v1/save-tourist-tax',
        work_types: 'CodeTables/v1/save-work-type',
        daily_logbook_activities: 'CodeTables/v1/save-daily-logbook-activity'
    };
    const url = table_names_to_urls[name];
    if (url === undefined) return;
    let response = await fetch(api_url + url, {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function deleteCodeTableItem(api_url, name, id, token) {
    const form_data = new FormData();
    form_data.set('id', id);
    const table_names_to_urls = {
        countries: 'CodeTables/v1/delete-country',
        post_offices: 'CodeTables/v1/delete-post-office',
        business_premises: 'CodeTables/v1/delete-business-premise',
        cash_registers: 'CashRegisters/v1/delete-cash-register',
        channels: 'CodeTables/v1/delete-channel',
        customers: 'Customers/v1/delete-customer',
        measuring_units: 'CodeTables/v1/delete-measuring-unit',
        payment_types: 'CodeTables/v1/delete-payment-type',
        tax_rates: 'CodeTables/v1/delete-tax-rate',
        warehouses: 'Warehouses/v1/delete-warehouse',
        accommodations: 'Accommodations/v1/delete-accommodation',
        items: 'Items/v1/delete-item',
        market_segmentation: 'CodeTables/v1/delete-market-segmentation',
        activities: 'CodeTables/v1/delete-activity',
        identification_types: 'CodeTables/v1/delete-identification-type',
        tourist_taxes: 'CodeTables/v1/delete-tourist-tax'
    };
    const url = table_names_to_urls[name];
    if (url === undefined) return;
    await fetch(api_url + url, {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
//TODO check for invalid token
}
async function loadBusinessPremiseFiscalRegistrations(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CodeTables/v1/business-premise-fiscal-registrations', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _codeTablesSlice.addBusinessPremiseFiscalRegistrations)(items));
}
async function saveAccommodationItemPlace(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Accommodations/v1/save-accommodation-item-place', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}

},{"js-cookie":"2d7Fe","../slices/CodeTablesSlice":"hfPGz","../slices/UserSlice":"ikKoo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2d7Fe":[function(require,module,exports,__globalThis) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

},{}],"ikKoo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setUser", ()=>setUser);
parcelHelpers.export(exports, "addUsers", ()=>addUsers);
parcelHelpers.export(exports, "addUserWorkType", ()=>addUserWorkType);
parcelHelpers.export(exports, "addUserWorkTypes", ()=>addUserWorkTypes);
parcelHelpers.export(exports, "addUserDailyLogbookActivity", ()=>addUserDailyLogbookActivity);
parcelHelpers.export(exports, "addUserDailyLogbookActivities", ()=>addUserDailyLogbookActivities);
var _toolkit = require("@reduxjs/toolkit");
function addItemToState(state_key_name, key_name, payload, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    const item = payload.item;
    const token = payload.token;
    if (item[key_name] == -1) item[key_name] = uuid.v4();
    state[state_key_name][item[key_name]] = item;
    if (payload.save_to_api === true) saveCodeTableItem(state.api_url, state_key_name, item, token);
}
function addItemsToState(state_key_name, key_name, items, state, clear) {
    clear = clear || false;
    if (state[state_key_name] === null || clear) state[state_key_name] = {};
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        state[state_key_name][items[i][key_name]] = items[i];
    }
}
const UserSlice = (0, _toolkit.createSlice)({
    name: 'user',
    initialState: {},
    reducers: {
        setUser: (state, action)=>{
            state.token = action.payload.token;
            state.user = action.payload.user_info;
        },
        addUsers: (state, action)=>{
            addItemsToState('users', 'id_user', action.payload, state);
            addItemsToState('users_by_username', 'username', action.payload, state);
        },
        addUserWorkType: (state, action)=>addItemToState('user_work_types', 'id_user_work_type', action.payload, state),
        addUserWorkTypes: (state, action)=>addItemsToState('user_work_types', 'id_user_work_type', action.payload, state, true),
        addUserDailyLogbookActivity: (state, action)=>addItemToState('user_daily_logbook_activities', 'id_user_daily_logbook_activity', action.payload, state),
        addUserDailyLogbookActivities: (state, action)=>addItemsToState('user_daily_logbook_activities', 'id_user_daily_logbook_activity', action.payload, state, true)
    }
});
const { setUser, addUsers, addUserWorkType, addUserWorkTypes, addUserDailyLogbookActivity, addUserDailyLogbookActivities } = UserSlice.actions;
exports.default = UserSlice.reducer;

},{"@reduxjs/toolkit":"frlQC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kTPna":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addReservation", ()=>addReservation);
parcelHelpers.export(exports, "addReservations", ()=>addReservations);
parcelHelpers.export(exports, "deleteReservation", ()=>deleteReservation);
parcelHelpers.export(exports, "addReservationCustomer", ()=>addReservationCustomer);
parcelHelpers.export(exports, "batchAddReservationCustomers", ()=>batchAddReservationCustomers);
parcelHelpers.export(exports, "addReservationCustomers", ()=>addReservationCustomers);
parcelHelpers.export(exports, "removeReservationCustomer", ()=>removeReservationCustomer);
parcelHelpers.export(exports, "addActivityReservation", ()=>addActivityReservation);
parcelHelpers.export(exports, "addActivityReservations", ()=>addActivityReservations);
parcelHelpers.export(exports, "deleteActivityReservation", ()=>deleteActivityReservation);
parcelHelpers.export(exports, "addActivityDailyLogbook", ()=>addActivityDailyLogbook);
parcelHelpers.export(exports, "addActivityDailyLogbooks", ()=>addActivityDailyLogbooks);
parcelHelpers.export(exports, "deleteActivityDailyLogbook", ()=>deleteActivityDailyLogbook);
parcelHelpers.export(exports, "addReservationCustomerItem", ()=>addReservationCustomerItem);
parcelHelpers.export(exports, "addReservationCustomerItems", ()=>addReservationCustomerItems);
parcelHelpers.export(exports, "removeReservationCustomerItem", ()=>removeReservationCustomerItem);
parcelHelpers.export(exports, "addReservationRequest", ()=>addReservationRequest);
parcelHelpers.export(exports, "addReservationRequests", ()=>addReservationRequests);
parcelHelpers.export(exports, "addReservationRequestAccommodations", ()=>addReservationRequestAccommodations);
parcelHelpers.export(exports, "deleteReservationRequest", ()=>deleteReservationRequest);
parcelHelpers.export(exports, "addPublicAccommodations", ()=>addPublicAccommodations);
parcelHelpers.export(exports, "addPublicAccommodationSettings", ()=>addPublicAccommodationSettings);
parcelHelpers.export(exports, "addWorkerStats", ()=>addWorkerStats);
parcelHelpers.export(exports, "addActivityDailyNotes", ()=>addActivityDailyNotes);
parcelHelpers.export(exports, "addWorkerNotes", ()=>addWorkerNotes);
var _toolkit = require("@reduxjs/toolkit");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
function addItem(state_key_name, key_name, item, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    if (item[key_name] == -1) item[key_name] = (0, _uuidDefault.default).v4();
    state[state_key_name][item[key_name]] = item;
    if (state_key_name == 'reservation_customers') {
        if (state.reservation_customers_by_id_reservations[item.id_reservation] === undefined) state.reservation_customers_by_id_reservations[item.id_reservation] = {};
        state.reservation_customers_by_id_reservations[item.id_reservation][item.id_reservation_customer] = item;
    }
    return item;
}
function addItems(state_key_name, key_name, items, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    if (state_key_name == 'reservation_customers') state.reservation_customers_by_id_reservations = {};
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        if (state_key_name == 'reservations') {
            const items = {};
            for(let j = 0; j < item.items.length; j++)items[item.items[j].id_reservation_item] = item.items[j];
            item.items = items;
        } else if (state_key_name == 'reservation_customers') {
            if (state.reservation_customers_by_id_reservations[item.id_reservation] === undefined) state.reservation_customers_by_id_reservations[item.id_reservation] = {};
            state.reservation_customers_by_id_reservations[item.id_reservation][item.id_reservation_customer] = item;
        }
        state[state_key_name][items[i][key_name]] = items[i];
    }
}
const ReservationSlice = (0, _toolkit.createSlice)({
    name: 'reservations',
    initialState: {},
    reducers: {
        addReservation: (state, action)=>{
            const item = addItem('reservations', 'id_reservation', action.payload.item, state);
        },
        addReservations: (state, action)=>addItems('reservations', 'id_reservation', action.payload, state),
        deleteReservation: (state, action)=>{
            delete state.reservations[action.payload];
        /*saveReservations(state.api_url, {
				reservations:          Object.values(state.reservations),
				reservation_customers: Object.values(state.reservation_customers),
				activity_reservations: Object.values(state.activity_reservations),
			}, null);*/ },
        addReservationCustomer: (state, action)=>{
            addItem('reservation_customers', 'id_reservation_customer', action.payload.item, state);
        },
        batchAddReservationCustomers: (state, action)=>{
            for(let i = 0; i < action.payload.items.length; i++)addItem('reservation_customers', 'id_reservation_customer', action.payload.items[i], state);
        },
        addReservationCustomers: (state, action)=>addItems('reservation_customers', 'id_reservation_customer', action.payload, state),
        removeReservationCustomer: (state, action)=>{
            delete state.reservation_customers[action.payload.item.id_reservation_customer];
            delete state.reservation_customers_by_id_reservations[action.payload.item.id_reservation][action.payload.item.id_reservation_customer];
        },
        addActivityReservation: (state, action)=>{
            const item = addItem('activity_reservations', 'id_activity_reservation', action.payload.item, state);
        /*
			if (action.payload.save_to_api === true) {
				saveActivityReservation(state.api_url, item, action.payload.token);
			}*/ },
        addActivityReservations: (state, action)=>addItems('activity_reservations', 'id_activity_reservation', action.payload, state),
        deleteActivityReservation: (state, action)=>{
            delete state.reservation_customers[action.payload];
        /*saveReservations(state.api_url, {
				reservations:          Object.values(state.reservations),
				reservation_customers: Object.values(state.reservation_customers),
				activity_reservations: Object.values(state.activity_reservations),
			}, null);*/ },
        addActivityDailyLogbook: (state, action)=>{
            addItem('activity_daily_logbooks', 'id_activity_daily_logbook', action.payload.item, state);
        },
        addActivityDailyLogbooks: (state, action)=>addItems('activity_daily_logbooks', 'id_activity_daily_logbook', action.payload, state),
        deleteActivityDailyLogbook: (state, action)=>{
            delete state.activity_daily_logbooks[action.payload];
        },
        addReservationCustomerItem: (state, action)=>{
            addItem('reservation_customer_items', 'id_reservation_customer_item', action.payload.item, state);
        },
        addReservationCustomerItems: (state, action)=>addItems('reservation_customer_items', 'id_reservation_customer_item', action.payload, state),
        removeReservationCustomerItem: (state, action)=>{
            delete state.reservation_customer_items[action.payload.item.id_reservation_customer_item];
        },
        addReservationRequest: (state, action)=>{
            addItem('reservation_requests', 'id_reservation_request', action.payload.item, state);
        },
        addReservationRequests: (state, action)=>addItems('reservation_requests', 'id_reservation_request', action.payload, state),
        addReservationRequestAccommodations: (state, action)=>{
            state['reservation_request_accommodations'] = action.payload;
        },
        deleteReservationRequest: (state, action)=>{
            delete state.reservation_requests[action.payload];
        },
        addPublicAccommodations: (state, action)=>{
            state['public_accommodations'] = action.payload;
        },
        addPublicAccommodationSettings: (state, action)=>{
            state['public_accommodation_settings'] = action.payload;
        },
        addWorkerStats: (state, action)=>addItems('worker_stats', 'id_worker_stats', action.payload, state),
        addActivityDailyNotes: (state, action)=>addItems('activity_daily_notes', 'id_activity_daily_note', action.payload, state),
        addWorkerNotes: (state, action)=>addItems('worker_notes', 'id_worker_note', action.payload, state)
    }
});
const { addReservation, addReservations, deleteReservation, addReservationCustomer, batchAddReservationCustomers, addReservationCustomers, removeReservationCustomer, addActivityReservation, addActivityReservations, deleteActivityReservation, addActivityDailyLogbook, addActivityDailyLogbooks, deleteActivityDailyLogbook, addReservationCustomerItem, addReservationCustomerItems, removeReservationCustomerItem, addReservationRequest, addReservationRequests, addReservationRequestAccommodations, deleteReservationRequest, addPublicAccommodations, addPublicAccommodationSettings, addWorkerStats, addActivityDailyNotes, addWorkerNotes } = ReservationSlice.actions;
exports.default = ReservationSlice.reducer;

},{"@reduxjs/toolkit":"frlQC","uuid":"b52pV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"47JXm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addInvoice", ()=>addInvoice);
parcelHelpers.export(exports, "addInvoices", ()=>addInvoices);
parcelHelpers.export(exports, "addInvoiceFiscalVerification", ()=>addInvoiceFiscalVerification);
parcelHelpers.export(exports, "addInvoiceFiscalVerifications", ()=>addInvoiceFiscalVerifications);
parcelHelpers.export(exports, "deleteInvoice", ()=>deleteInvoice);
parcelHelpers.export(exports, "addAdvanceInvoiceConsumption", ()=>addAdvanceInvoiceConsumption);
parcelHelpers.export(exports, "addAdvanceInvoiceConsumptions", ()=>addAdvanceInvoiceConsumptions);
var _toolkit = require("@reduxjs/toolkit");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
function addItem(state_key_name, key_name, item, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    if (item[key_name] == -1) item[key_name] = (0, _uuidDefault.default).v4();
    if (state_key_name == 'invoices') {
        if (item.items !== undefined) {
            for(let i = 0; i < item.items.length; i++)if (item.items[i].id_invoice_item == -1) item.items[i].id_invoice_item = (0, _uuidDefault.default).v4();
        }
    }
    state[state_key_name][item[key_name]] = item;
    return item;
}
function addItems(state_key_name, key_name, items, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    for(let i = 0; i < items.length; i++)state[state_key_name][items[i][key_name]] = items[i];
}
function deleteItem(state_key_name, id_item, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    delete state[state_key_name][id_item];
}
function addAdvanceInvoiceConsumptionItems(items, state) {
    if (state.advance_invoice_consumptions === null) state.advance_invoice_consumptions = {};
    const advance_id_invoice_to_ids = {};
    const consumer_id_invoice_to_ids = {};
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        state.advance_invoice_consumptions[item.id_advance_invoice_consumption] = item;
        if (advance_id_invoice_to_ids[item.advance_id_invoice] === undefined) advance_id_invoice_to_ids[item.advance_id_invoice] = [];
        advance_id_invoice_to_ids[item.advance_id_invoice].push(item.id_advance_invoice_consumption);
        if (consumer_id_invoice_to_ids[item.consumer_id_invoice] === undefined) consumer_id_invoice_to_ids[item.consumer_id_invoice] = [];
        consumer_id_invoice_to_ids[item.consumer_id_invoice].push(item.id_advance_invoice_consumption);
    }
    state.id_advance_invoice_consumption_by_id_advance_invoices = advance_id_invoice_to_ids;
    state.id_advance_invoice_consumption_by_id_consumer_invoices = consumer_id_invoice_to_ids;
}
function addAdvanceInvoiceConsumptionItem(item, state) {
    if (state.advance_invoice_consumptions === null) state.advance_invoice_consumptions = {};
    const advance_id_invoice_to_ids = {
        ...state.id_advance_invoice_consumption_by_id_advance_invoices || {}
    };
    const consumer_id_invoice_to_ids = {
        ...state.id_advance_invoice_consumption_by_id_consumer_invoices || {}
    };
    state.advance_invoice_consumptions[item.id_advance_invoice_consumption] = item;
    if (advance_id_invoice_to_ids[item.advance_id_invoice] === undefined) advance_id_invoice_to_ids[item.advance_id_invoice] = [];
    advance_id_invoice_to_ids[item.advance_id_invoice].push(item.id_advance_invoice_consumption);
    if (consumer_id_invoice_to_ids[item.consumer_id_invoice] === undefined) consumer_id_invoice_to_ids[item.consumer_id_invoice] = [];
    consumer_id_invoice_to_ids[item.consumer_id_invoice].push(item.id_advance_invoice_consumption);
    state.id_advance_invoice_consumption_by_id_advance_invoices = advance_id_invoice_to_ids;
    state.id_advance_invoice_consumption_by_id_consumer_invoices = consumer_id_invoice_to_ids;
}
const BusinessSlice = (0, _toolkit.createSlice)({
    name: 'business',
    initialState: {},
    reducers: {
        addInvoice: (state, action)=>{
            const item = addItem('invoices', 'id_invoice', action.payload.item, state);
        },
        addInvoices: (state, action)=>addItems('invoices', 'id_invoice', action.payload, state),
        addInvoiceFiscalVerifications: (state, action)=>{
            addItems('invoice_fiscal_verifications', 'id_invoice_fiscal_verification', action.payload, state);
            // add by id invoices
            const items = action.payload;
            const items_by_id_invoice = {
                ...state['invoice_fiscal_verifications_by_id_invoice'] || {}
            };
            for(let i = 0; i < items.length; i++){
                if (items_by_id_invoice[items[i].id_invoice] === undefined) items_by_id_invoice[items[i].id_invoice] = [];
                items_by_id_invoice[items[i].id_invoice].push(items[i]);
            }
            state['invoice_fiscal_verifications_by_id_invoice'] = items_by_id_invoice;
        },
        addInvoiceFiscalVerification: (state, action)=>{
            const item = addItem('invoice_fiscal_verifications', 'id_invoice_fiscal_verification', action.payload.item, state);
            // add by id invoices
            const items_by_id_invoice = {
                ...state['invoice_fiscal_verifications_by_id_invoice'] || {}
            };
            if (items_by_id_invoice[item.id_invoice] === undefined) items_by_id_invoice[item.id_invoice] = [];
            items_by_id_invoice[item.id_invoice].push(item);
            state['invoice_fiscal_verifications_by_id_invoice'] = items_by_id_invoice;
        },
        deleteInvoice: (state, action)=>deleteItem('invoices', action.payload.id_invoice, state),
        addAdvanceInvoiceConsumptions: (state, action)=>addAdvanceInvoiceConsumptionItems(action.payload, state),
        addAdvanceInvoiceConsumption: (state, action)=>addAdvanceInvoiceConsumptionItem(action.payload.item, state)
    }
});
const { addInvoice, addInvoices, addInvoiceFiscalVerification, addInvoiceFiscalVerifications, deleteInvoice, addAdvanceInvoiceConsumption, addAdvanceInvoiceConsumptions } = BusinessSlice.actions;
exports.default = BusinessSlice.reducer;

},{"@reduxjs/toolkit":"frlQC","uuid":"b52pV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fIlI9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toolkit = require("@reduxjs/toolkit");
const ConstantsSlice = (0, _toolkit.createSlice)({
    name: 'constants',
    initialState: {
        api_url: null
    },
    reducers: {}
});
const {} = ConstantsSlice.actions;
exports.default = ConstantsSlice.reducer;

},{"@reduxjs/toolkit":"frlQC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6gdAm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addDocumentAssociation", ()=>addDocumentAssociation);
parcelHelpers.export(exports, "addDocumentAssociations", ()=>addDocumentAssociations);
parcelHelpers.export(exports, "addDocumentTypes", ()=>addDocumentTypes);
parcelHelpers.export(exports, "deleteDocumentAssociation", ()=>deleteDocumentAssociation);
parcelHelpers.export(exports, "addDocumentType", ()=>addDocumentType);
var _toolkit = require("@reduxjs/toolkit");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
function addItem(state_key_name, key_name, item, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    if (state.document_associations_id_documents === null) state.document_associations_id_documents = {};
    if (item[key_name] == -1) item[key_name] = (0, _uuidDefault.default).v4();
    if (state_key_name == 'document_associations') addDocumentToAssociations(state, item);
    state[state_key_name][item[key_name]] = item;
    return item;
}
function addDocumentToAssociations(state, item) {
    if (state.document_associations_id_documents === null) state.document_associations_id_documents = {};
    if (state.document_associations_id_documents[item.source_id_document] === undefined) state.document_associations_id_documents[item.source_id_document] = {};
    state.document_associations_id_documents[item.source_id_document][item.id_document_association] = item;
    if (item.target_id_document != item.source_id_document) {
        if (state.document_associations_id_documents[item.target_id_document] === undefined) state.document_associations_id_documents[item.target_id_document] = {};
        state.document_associations_id_documents[item.target_id_document][item.id_document_association] = item;
    }
}
function addItems(state_key_name, key_name, items, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    if (state.document_associations_id_documents === null) state.document_associations_id_documents = {};
    for(let i = 0; i < items.length; i++){
        if (state_key_name == 'document_associations') addDocumentToAssociations(state, items[i]);
        state[state_key_name][items[i][key_name]] = items[i];
    }
}
function deleteItemFromState(state_key_name, payload, state) {
    const key_value = payload;
    for(let id_document in state.document_associations_id_documents)if (state.document_associations_id_documents[id_document][key_value] !== undefined) delete state.document_associations_id_documents[id_document][key_value];
    delete state[state_key_name][key_value];
}
const DocumentSlice = (0, _toolkit.createSlice)({
    name: 'documents',
    initialState: {},
    reducers: {
        addDocumentAssociation: (state, action)=>{
            const item = addItem('document_associations', 'id_document_association', action.payload.item, state);
        },
        addDocumentAssociations: (state, action)=>addItems('document_associations', 'id_document_association', action.payload, state),
        addDocumentTypes: (state, action)=>addItems('document_types', 'type', action.payload, state),
        deleteDocumentAssociation: (state, action)=>{
            console.log({
                action,
                payload: action.payload
            });
            deleteItemFromState('document_associations', action.payload.id_document_association, state);
        },
        addDocumentType: (state, action)=>{
            const item = addItem('document_types', 'type', action.payload.item, state);
        }
    }
});
const { addDocumentAssociation, addDocumentAssociations, addDocumentTypes, deleteDocumentAssociation, addDocumentType } = DocumentSlice.actions;
exports.default = DocumentSlice.reducer;

},{"@reduxjs/toolkit":"frlQC","uuid":"b52pV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ajHkF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setCurrentIdCashRegister", ()=>setCurrentIdCashRegister);
parcelHelpers.export(exports, "setGeneralSettings", ()=>setGeneralSettings);
var _toolkit = require("@reduxjs/toolkit");
const SettingsSlice = (0, _toolkit.createSlice)({
    name: 'settings',
    initialState: {},
    reducers: {
        setCurrentIdCashRegister: (state, action)=>{
            state.current_id_cash_register = action.payload.current_id_cash_register;
        },
        setGeneralSettings: (state, action)=>{
            state.general = action.payload;
        }
    }
});
const { setCurrentIdCashRegister, setGeneralSettings } = SettingsSlice.actions;
exports.default = SettingsSlice.reducer;

},{"@reduxjs/toolkit":"frlQC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bE5rS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGuestBookItem", ()=>addGuestBookItem);
parcelHelpers.export(exports, "batchAddGuestBookItems", ()=>batchAddGuestBookItems);
parcelHelpers.export(exports, "addGuestBookItems", ()=>addGuestBookItems);
parcelHelpers.export(exports, "addMonthlyGuestBookReport", ()=>addMonthlyGuestBookReport);
parcelHelpers.export(exports, "addMonthlyGuestBookReports", ()=>addMonthlyGuestBookReports);
var _toolkit = require("@reduxjs/toolkit");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
function addItem(state_key_name, key_name, item, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    if (item[key_name] == -1) item[key_name] = (0, _uuidDefault.default).v4();
    state[state_key_name][item[key_name]] = item;
    return item;
}
function addItems(state_key_name, key_name, items, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    for(let i = 0; i < items.length; i++)state[state_key_name][items[i][key_name]] = items[i];
}
const GuestSlice = (0, _toolkit.createSlice)({
    name: 'guests',
    initialState: {},
    reducers: {
        addGuestBookItem: (state, action)=>{
            const item = addItem('guest_book_items', 'id_guest_book', action.payload.item, state);
        },
        batchAddGuestBookItems: (state, action)=>{
            for(let i = 0; i < action.payload.items.length; i++)addItem('guest_book_items', 'id_guest_book', action.payload.items[i], state);
        },
        addGuestBookItems: (state, action)=>addItems('guest_book_items', 'id_guest_book', action.payload, state),
        addMonthlyGuestBookReport: (state, action)=>{
            const item = addItem('monthly_guest_book_reports', 'id_monthly_guest_book_report', action.payload.item, state);
        },
        addMonthlyGuestBookReports: (state, action)=>addItems('monthly_guest_book_reports', 'id_monthly_guest_book_report', action.payload, state)
    }
});
const { addGuestBookItem, batchAddGuestBookItems, addGuestBookItems, addMonthlyGuestBookReport, addMonthlyGuestBookReports } = GuestSlice.actions;
exports.default = GuestSlice.reducer;

},{"@reduxjs/toolkit":"frlQC","uuid":"b52pV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1FTf7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addCashRegister", ()=>addCashRegister);
parcelHelpers.export(exports, "addCashRegisters", ()=>addCashRegisters);
parcelHelpers.export(exports, "addCashRegisterDailyState", ()=>addCashRegisterDailyState);
parcelHelpers.export(exports, "addCashRegisterDailyStates", ()=>addCashRegisterDailyStates);
parcelHelpers.export(exports, "addCashRegisterDocument", ()=>addCashRegisterDocument);
parcelHelpers.export(exports, "addCashRegisterDocuments", ()=>addCashRegisterDocuments);
parcelHelpers.export(exports, "deleteCashRegisterDailyState", ()=>deleteCashRegisterDailyState);
var _toolkit = require("@reduxjs/toolkit");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
function addItem(state_key_name, key_name, item, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    if (item[key_name] == -1) item[key_name] = (0, _uuidDefault.default).v4();
    state[state_key_name][item[key_name]] = item;
}
function addItems(state_key_name, key_name, items, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    for(let i = 0; i < items.length; i++)state[state_key_name][items[i][key_name]] = items[i];
}
function deleteItemFromState(state_key_name, payload, state) {
    delete state[state_key_name][payload];
}
const CashRegisterSlice = (0, _toolkit.createSlice)({
    name: 'cash-registers',
    initialState: {},
    reducers: {
        addCashRegister: (state, action)=>addItem('cash_registers', 'id_cash_register', action.payload, state),
        addCashRegisters: (state, action)=>addItems('cash_registers', 'id_cash_register', action.payload, state),
        addCashRegisterDailyState: (state, action)=>addItem('cash_register_daily_states', 'id_cash_register_daily_state', action.payload, state),
        addCashRegisterDailyStates: (state, action)=>addItems('cash_register_daily_states', 'id_cash_register_daily_state', action.payload, state),
        addCashRegisterDocument: (state, action)=>addItem('cash_register_documents', 'id_cash_register_document', action.payload, state),
        addCashRegisterDocuments: (state, action)=>addItems('cash_register_documents', 'id_cash_register_document', action.payload, state),
        deleteCashRegisterDailyState: (state, action)=>deleteItemFromState('cash_register_daily_states', action.payload, state)
    }
});
const { addCashRegister, addCashRegisters, addCashRegisterDailyState, addCashRegisterDailyStates, addCashRegisterDocument, addCashRegisterDocuments, deleteCashRegisterDailyState } = CashRegisterSlice.actions;
exports.default = CashRegisterSlice.reducer;

},{"@reduxjs/toolkit":"frlQC","uuid":"b52pV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aByTQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setPosPrinterConnectedStatus", ()=>setPosPrinterConnectedStatus);
parcelHelpers.export(exports, "enqueueInvoiceOnPosPrinterQueue", ()=>enqueueInvoiceOnPosPrinterQueue);
parcelHelpers.export(exports, "requeueInvoiceOnPosPrinterQueue", ()=>requeueInvoiceOnPosPrinterQueue);
parcelHelpers.export(exports, "removeInvoiceFromPosPrinterQueue", ()=>removeInvoiceFromPosPrinterQueue);
parcelHelpers.export(exports, "setA4PrinterConnectedStatus", ()=>setA4PrinterConnectedStatus);
parcelHelpers.export(exports, "setLabelPrinterConnectedStatus", ()=>setLabelPrinterConnectedStatus);
parcelHelpers.export(exports, "enqueueInvoiceOnA4PrinterQueue", ()=>enqueueInvoiceOnA4PrinterQueue);
parcelHelpers.export(exports, "requeueInvoiceOnA4PrinterQueue", ()=>requeueInvoiceOnA4PrinterQueue);
parcelHelpers.export(exports, "removeInvoiceFromA4PrinterQueue", ()=>removeInvoiceFromA4PrinterQueue);
parcelHelpers.export(exports, "setPrinters", ()=>setPrinters);
parcelHelpers.export(exports, "enqueueItemOnLabelPrinterQueue", ()=>enqueueItemOnLabelPrinterQueue);
parcelHelpers.export(exports, "requeueItemOnLabelPrinterQueue", ()=>requeueItemOnLabelPrinterQueue);
parcelHelpers.export(exports, "removeItemFromLabelPrinterQueue", ()=>removeItemFromLabelPrinterQueue);
parcelHelpers.export(exports, "setLabelPrinters", ()=>setLabelPrinters);
parcelHelpers.export(exports, "setCriticalError", ()=>setCriticalError);
parcelHelpers.export(exports, "enqueueAvailableAccommodationsPosPrinterQueue", ()=>enqueueAvailableAccommodationsPosPrinterQueue);
var _toolkit = require("@reduxjs/toolkit");
//import ErrorReportingHelper from '../helpers/ErrorReportingHelper';
const AppSlice = (0, _toolkit.createSlice)({
    name: 'app',
    initialState: {},
    reducers: {
        setPosPrinterConnectedStatus: (state, action)=>{
            state.pos_printer_connected = action.payload.connected;
        },
        enqueueInvoiceOnPosPrinterQueue: (state, action)=>{
            console.log('Enqueuing POS invoice');
            /*if (action.payload.type == 'invoice') {
				ErrorReportingHelper.ReportPosPrintInfo(
					JSON.stringify({ op: 'AppSlice.enqueueInvoiceOnPosPrinterQueue: step 1', ts: (new Date()).toISOString(), id_invoice: action.payload.invoice.id_invoice }),
					{ tags: 'pos_print, step_1, item_' + action.payload.invoice.id_invoice }
				);
			}*/ state.pos_printer_queue = state.pos_printer_queue.concat([
                action.payload
            ]);
        },
        requeueInvoiceOnPosPrinterQueue: (state, action)=>{
            const pos_printer_queue = state.pos_printer_queue;
            pos_printer_queue.splice(0, 0, action.payload.invoice);
            state.pos_printer_queue = pos_printer_queue;
        },
        removeInvoiceFromPosPrinterQueue: (state, action)=>{
            const pos_printer_queue = state.pos_printer_queue;
            pos_printer_queue.splice(0, 1);
            state.pos_printer_queue = pos_printer_queue;
        },
        setA4PrinterConnectedStatus: (state, action)=>{
            state.a4_printer_connected = action.payload.connected;
        },
        setLabelPrinterConnectedStatus: (state, action)=>{
            state.label_printer_connected = action.payload.connected;
        },
        enqueueInvoiceOnA4PrinterQueue: (state, action)=>{
            /*if (action.payload.type == 'invoice') {
				ErrorReportingHelper.ReportA4PrintInfo(
					JSON.stringify({ op: 'AppSlice.enqueueInvoiceOnA4PrinterQueue: step 1', ts: (new Date()).toISOString(), id_invoice: action.payload.invoice.id_invoice }),
					{ tags: 'a4_print, step_1, item_' + action.payload.invoice.id_invoice }
				);
			}*/ state.a4_printer_queue = state.a4_printer_queue.concat([
                action.payload
            ]);
        },
        requeueInvoiceOnA4PrinterQueue: (state, action)=>{
            const a4_printer_queue = state.a4_printer_queue;
            a4_printer_queue.splice(0, 0, action.payload.invoice);
            state.a4_printer_queue = a4_printer_queue;
        },
        removeInvoiceFromA4PrinterQueue: (state, action)=>{
            const a4_printer_queue = state.a4_printer_queue;
            a4_printer_queue.splice(0, 1);
            state.a4_printer_queue = a4_printer_queue;
        },
        setPrinters: (state, action)=>{
            state.printers = action.payload.printers;
        },
        enqueueItemOnLabelPrinterQueue: (state, action)=>{
            state.label_printer_queue = state.label_printer_queue.concat([
                action.payload
            ]);
        },
        requeueItemOnLabelPrinterQueue: (state, action)=>{
            const label_printer_queue = state.label_printer_queue;
            label_printer_queue.splice(0, 0, action.payload.item);
            state.label_printer_queue = label_printer_queue;
        },
        removeItemFromLabelPrinterQueue: (state, action)=>{
            const label_printer_queue = state.label_printer_queue;
            label_printer_queue.splice(0, 1);
            state.label_printer_queue = label_printer_queue;
        },
        setLabelPrinters: (state, action)=>{
            state.label_printers = action.payload.printers;
        },
        setCriticalError: (state, action)=>{
            state.critical_error = action.payload;
        },
        enqueueAvailableAccommodationsPosPrinterQueue: (state, action)=>{
            console.log('Enqueuing POS available accommodations');
            console.log({
                action
            });
            state.pos_printer_queue = state.pos_printer_queue.concat([
                action.payload
            ]);
        }
    }
});
const { setPosPrinterConnectedStatus, enqueueInvoiceOnPosPrinterQueue, requeueInvoiceOnPosPrinterQueue, removeInvoiceFromPosPrinterQueue, setA4PrinterConnectedStatus, setLabelPrinterConnectedStatus, enqueueInvoiceOnA4PrinterQueue, requeueInvoiceOnA4PrinterQueue, removeInvoiceFromA4PrinterQueue, setPrinters, enqueueItemOnLabelPrinterQueue, requeueItemOnLabelPrinterQueue, removeItemFromLabelPrinterQueue, setLabelPrinters, setCriticalError, enqueueAvailableAccommodationsPosPrinterQueue } = AppSlice.actions;
exports.default = AppSlice.reducer;

},{"@reduxjs/toolkit":"frlQC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8QIEM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addStockAcquisitionDocument", ()=>addStockAcquisitionDocument);
parcelHelpers.export(exports, "addStockAcquisitionDocuments", ()=>addStockAcquisitionDocuments);
parcelHelpers.export(exports, "addDeliveryNote", ()=>addDeliveryNote);
parcelHelpers.export(exports, "addDeliveryNotes", ()=>addDeliveryNotes);
parcelHelpers.export(exports, "addStockInventoryItems", ()=>addStockInventoryItems);
parcelHelpers.export(exports, "addStockInventoryDetailed", ()=>addStockInventoryDetailed);
parcelHelpers.export(exports, "addStockInventoryDetailedAcquiredItems", ()=>addStockInventoryDetailedAcquiredItems);
parcelHelpers.export(exports, "addStockInventoryDetailedSpentItems", ()=>addStockInventoryDetailedSpentItems);
parcelHelpers.export(exports, "addStockInventoryStockState", ()=>addStockInventoryStockState);
parcelHelpers.export(exports, "addDetailedStockInventoryStockState", ()=>addDetailedStockInventoryStockState);
parcelHelpers.export(exports, "addStockInventoryItemsByDate", ()=>addStockInventoryItemsByDate);
parcelHelpers.export(exports, "addStockInventoryDetailedByDate", ()=>addStockInventoryDetailedByDate);
parcelHelpers.export(exports, "addStockInventoryDetailedAcquiredItemsByDate", ()=>addStockInventoryDetailedAcquiredItemsByDate);
parcelHelpers.export(exports, "addStockInventoryDetailedSpentItemsByDate", ()=>addStockInventoryDetailedSpentItemsByDate);
parcelHelpers.export(exports, "addStockInventoryStockStateByDate", ()=>addStockInventoryStockStateByDate);
parcelHelpers.export(exports, "addLastStockDataByDate", ()=>addLastStockDataByDate);
var _toolkit = require("@reduxjs/toolkit");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
function addItem(state_key_name, key_name, item, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    if (item[key_name] == -1) item[key_name] = (0, _uuidDefault.default).v4();
    state[state_key_name][item[key_name]] = item;
}
function addItems(state_key_name, key_name, items, state) {
    if (state[state_key_name] === null) state[state_key_name] = {};
    if (state_key_name == 'stock_state' || state_key_name == 'detailed_stock_state') state[state_key_name] = items;
    else for(let i = 0; i < items.length; i++)state[state_key_name][items[i][key_name]] = items[i];
}
function addItemsByDate(state_key_name, key_name, payload, state) {
    const date = payload.date;
    const items = payload.items;
    if (state['stock_inventory_by_date'] === null) state['stock_inventory_by_date'] = {};
    if (state['stock_inventory_by_date'][date] === undefined) state['stock_inventory_by_date'][date] = {
        stock_inventory_items: {},
        stock_inventory_detailed: {},
        stock_inventory_detailed_acquired_items: {},
        stock_inventory_detailed_spent_items: {},
        stock_state: {}
    };
    if (state_key_name == 'stock_state') state['stock_inventory_by_date'][date][state_key_name] = items;
    else for(let i = 0; i < items.length; i++)state['stock_inventory_by_date'][date][state_key_name][items[i][key_name]] = items[i];
}
function addLastStockDataItemsByDate(state_key_name, key_name, payload, state) {
    const date = payload.date;
    const items = payload.items;
    if (state['last_stock_data_by_date'] === null) state['last_stock_data_by_date'] = {};
    if (state['last_stock_data_by_date'][date] === undefined) state['last_stock_data_by_date'][date] = {};
    if (state_key_name == 'last_stock_data') state['last_stock_data_by_date'][date][state_key_name] = items;
    else for(let i = 0; i < items.length; i++)state['last_stock_data_by_date'][date][state_key_name][items[i][key_name]] = items[i];
}
function deleteItemFromState(state_key_name, payload, state) {
    delete state[state_key_name][payload];
}
const WarehouseSlice = (0, _toolkit.createSlice)({
    name: 'warehouses',
    initialState: {},
    reducers: {
        addStockAcquisitionDocument: (state, action)=>addItem('stock_acquisition_documents', 'id_stock_acquisition_document', action.payload, state),
        addStockAcquisitionDocuments: (state, action)=>addItems('stock_acquisition_documents', 'id_stock_acquisition_document', action.payload, state),
        addDeliveryNote: (state, action)=>addItem('delivery_notes', 'id_delivery_note', action.payload, state),
        addDeliveryNotes: (state, action)=>addItems('delivery_notes', 'id_delivery_note', action.payload, state),
        addStockInventoryItems: (state, action)=>addItems('stock_inventory_items', 'key', action.payload, state),
        addStockInventoryDetailed: (state, action)=>addItems('stock_inventory_detailed', 'id_item', action.payload, state),
        addStockInventoryDetailedAcquiredItems: (state, action)=>addItems('stock_inventory_detailed_acquired_items', 'key', action.payload, state),
        addStockInventoryDetailedSpentItems: (state, action)=>addItems('stock_inventory_detailed_spent_items', 'key', action.payload, state),
        addStockInventoryStockState: (state, action)=>addItems('stock_state', '', action.payload, state),
        addDetailedStockInventoryStockState: (state, action)=>addItems('detailed_stock_state', '', action.payload, state),
        addStockInventoryItemsByDate: (state, action)=>addItemsByDate('stock_inventory_items', 'key', action.payload, state),
        addStockInventoryDetailedByDate: (state, action)=>addItemsByDate('stock_inventory_detailed', 'id_item', action.payload, state),
        addStockInventoryDetailedAcquiredItemsByDate: (state, action)=>addItemsByDate('stock_inventory_detailed_acquired_items', 'key', action.payload, state),
        addStockInventoryDetailedSpentItemsByDate: (state, action)=>addItemsByDate('stock_inventory_detailed_spent_items', 'key', action.payload, state),
        addStockInventoryStockStateByDate: (state, action)=>addItemsByDate('stock_state', '', action.payload, state),
        //addLastStockDataByDate:                       (state, action) => addItemsByDate('last_stock_data',            '',                      action.payload, state),
        addLastStockDataByDate: (state, action)=>addLastStockDataItemsByDate('last_stock_data', '', action.payload, state)
    }
});
const { addStockAcquisitionDocument, addStockAcquisitionDocuments, addDeliveryNote, addDeliveryNotes, addStockInventoryItems, addStockInventoryDetailed, addStockInventoryDetailedAcquiredItems, addStockInventoryDetailedSpentItems, addStockInventoryStockState, addDetailedStockInventoryStockState, addStockInventoryItemsByDate, addStockInventoryDetailedByDate, addStockInventoryDetailedAcquiredItemsByDate, addStockInventoryDetailedSpentItemsByDate, addStockInventoryStockStateByDate, addLastStockDataByDate } = WarehouseSlice.actions;
exports.default = WarehouseSlice.reducer;

},{"@reduxjs/toolkit":"frlQC","uuid":"b52pV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5DyKE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "batch", ()=>(0, _reactBatchedUpdates.unstable_batchedUpdates));
var _exports = require("./exports");
parcelHelpers.exportAll(_exports, exports);
var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");
var _batch = require("./utils/batch"); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, _batch.setBatch)((0, _reactBatchedUpdates.unstable_batchedUpdates));

},{"./exports":"iw5OK","./utils/reactBatchedUpdates":"czlKX","./utils/batch":"3QbYr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iw5OK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>(0, _providerDefault.default));
parcelHelpers.export(exports, "connectAdvanced", ()=>(0, _connectAdvancedDefault.default));
parcelHelpers.export(exports, "ReactReduxContext", ()=>(0, _context.ReactReduxContext));
parcelHelpers.export(exports, "connect", ()=>(0, _connectDefault.default));
parcelHelpers.export(exports, "useDispatch", ()=>(0, _useDispatch.useDispatch));
parcelHelpers.export(exports, "createDispatchHook", ()=>(0, _useDispatch.createDispatchHook));
parcelHelpers.export(exports, "useSelector", ()=>(0, _useSelector.useSelector));
parcelHelpers.export(exports, "createSelectorHook", ()=>(0, _useSelector.createSelectorHook));
parcelHelpers.export(exports, "useStore", ()=>(0, _useStore.useStore));
parcelHelpers.export(exports, "createStoreHook", ()=>(0, _useStore.createStoreHook));
parcelHelpers.export(exports, "shallowEqual", ()=>(0, _shallowEqualDefault.default));
var _provider = require("./components/Provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _connectAdvanced = require("./components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _context = require("./components/Context");
var _connect = require("./connect/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _useDispatch = require("./hooks/useDispatch");
var _useSelector = require("./hooks/useSelector");
var _useStore = require("./hooks/useStore");
var _shallowEqual = require("./utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);

},{"./components/Provider":"6Zf6f","./components/connectAdvanced":"CRPbv","./components/Context":"d7pPF","./connect/connect":"gM7QG","./hooks/useDispatch":"b8uv3","./hooks/useSelector":"jdZfi","./hooks/useStore":"2t65h","./utils/shallowEqual":"2ovfJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Zf6f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _context = require("./Context");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
function Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, _react.useMemo)(function() {
        var subscription = (0, _subscription.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, _react.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, _context.ReactReduxContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
exports.default = Provider;

},{"react":"9njXz","prop-types":"bnNSm","./Context":"d7pPF","../utils/Subscription":"4gS0I","../utils/useIsomorphicLayoutEffect":"9y2R9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bnNSm":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"aLk8j"}],"aLk8j":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"di8d9"}],"di8d9":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"d7pPF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactReduxContext", ()=>ReactReduxContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ReactReduxContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
exports.default = ReactReduxContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4gS0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscription", ()=>createSubscription);
var _batch = require("./batch"); // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function createListenerCollection() {
    var batch = (0, _batch.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

},{"./batch":"3QbYr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QbYr":[function(require,module,exports,__globalThis) {
// Default to a dummy "batch" implementation that just runs the callback
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBatch", ()=>setBatch);
parcelHelpers.export(exports, "getBatch", ()=>getBatch);
function defaultNoopBatch(callback) {
    callback();
}
var batch = defaultNoopBatch; // Allow injecting another batching function later
var setBatch = function setBatch(newBatch) {
    return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var getBatch = function getBatch() {
    return batch;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9y2R9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react"); // React currently throws a warning when using useLayoutEffect on the server.
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"CRPbv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>connectAdvanced);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIs = require("react-is");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _context = require("./Context"); // Define some constant arrays just to avoid re-creating these
var _excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], _excluded2 = [
    "reactReduxForwardedRef"
];
var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function connectAdvanced(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, _context.ReactReduxContext) : _ref2$context, connectOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, _extendsDefault.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, _react.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, _react.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, _react.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)(/*#__PURE__*/ (0, _reactDefault.default).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, _react.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, _react.useMemo)(function() {
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, _subscription.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, _react.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, _extendsDefault.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, _react.useRef)();
            var lastWrapperProps = (0, _react.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, _react.useRef)();
            var renderIsScheduled = (0, _react.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, _react.useMemo)(function() {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, (0, _extendsDefault.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, _react.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, _reactDefault.default).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, _reactDefault.default).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(Connect, (0, _extendsDefault.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, _hoistNonReactStaticsDefault.default)(forwarded, WrappedComponent);
        }
        return (0, _hoistNonReactStaticsDefault.default)(Connect, WrappedComponent);
    };
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","hoist-non-react-statics":"59Kh2","react":"9njXz","react-is":"halvy","../utils/Subscription":"4gS0I","../utils/useIsomorphicLayoutEffect":"9y2R9","./Context":"d7pPF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAOJb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGdYV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59Kh2":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"3b6hO"}],"3b6hO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"easHU"}],"easHU":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"halvy":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c09df6e873313925");

},{"c09df6e873313925":"aIgSz"}],"aIgSz":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = 60103, c = 60106, d = 60107, e = 60108, f = 60114, g = 60109, h = 60110, k = 60112, l = 60113, m = 60120, n = 60115, p = 60116, q = 60121, r = 60122, u = 60117, v = 60129, w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
}
function y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case l:
                    case m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case h:
                            case k:
                            case p:
                            case n:
                            case g:
                                return a;
                            default:
                                return t;
                        }
                }
            case c:
                return t;
        }
    }
}
var z = g, A = b, B = k, C = d, D = p, E = n, F = c, G = f, H = e, I = l;
exports.ContextConsumer = h;
exports.ContextProvider = z;
exports.Element = A;
exports.ForwardRef = B;
exports.Fragment = C;
exports.Lazy = D;
exports.Memo = E;
exports.Portal = F;
exports.Profiler = G;
exports.StrictMode = H;
exports.Suspense = I;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return y(a) === h;
};
exports.isContextProvider = function(a) {
    return y(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return y(a) === k;
};
exports.isFragment = function(a) {
    return y(a) === d;
};
exports.isLazy = function(a) {
    return y(a) === p;
};
exports.isMemo = function(a) {
    return y(a) === n;
};
exports.isPortal = function(a) {
    return y(a) === c;
};
exports.isProfiler = function(a) {
    return y(a) === f;
};
exports.isStrictMode = function(a) {
    return y(a) === e;
};
exports.isSuspense = function(a) {
    return y(a) === l;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? !0 : !1;
};
exports.typeOf = y;

},{}],"gM7QG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// different options opens up some testing and extensibility scenarios
parcelHelpers.export(exports, "createConnect", ()=>createConnect);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _connectAdvanced = require("../components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _shallowEqual = require("../utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _mapDispatchToProps = require("./mapDispatchToProps");
var _mapDispatchToPropsDefault = parcelHelpers.interopDefault(_mapDispatchToProps);
var _mapStateToProps = require("./mapStateToProps");
var _mapStateToPropsDefault = parcelHelpers.interopDefault(_mapStateToProps);
var _mergeProps = require("./mergeProps");
var _mergePropsDefault = parcelHelpers.interopDefault(_mergeProps);
var _selectorFactory = require("./selectorFactory");
var _selectorFactoryDefault = parcelHelpers.interopDefault(_selectorFactory);
var _excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function createConnect(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, _connectAdvancedDefault.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, _mapStateToPropsDefault.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, _mapDispatchToPropsDefault.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, _mergePropsDefault.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, _selectorFactoryDefault.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areMergedPropsE, extraOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref3, _excluded);
        var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, _extendsDefault.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
exports.default = /*#__PURE__*/ createConnect();

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","../components/connectAdvanced":"CRPbv","../utils/shallowEqual":"2ovfJ","./mapDispatchToProps":"fLd6L","./mapStateToProps":"gQxwI","./mergeProps":"5ZrHy","./selectorFactory":"fMozN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ovfJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shallowEqual);
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fLd6L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsFunction", ()=>whenMapDispatchToPropsIsFunction);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsMissing", ()=>whenMapDispatchToPropsIsMissing);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsObject", ()=>whenMapDispatchToPropsIsObject);
var _bindActionCreators = require("../utils/bindActionCreators");
var _bindActionCreatorsDefault = parcelHelpers.interopDefault(_bindActionCreators);
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return (0, _bindActionCreatorsDefault.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
exports.default = [
    whenMapDispatchToPropsIsFunction,
    whenMapDispatchToPropsIsMissing,
    whenMapDispatchToPropsIsObject
];

},{"../utils/bindActionCreators":"dPxnl","./wrapMapToProps":"9sZ9X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dPxnl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bindActionCreators);
function bindActionCreators(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9sZ9X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapMapToPropsConstant", ()=>wrapMapToPropsConstant) // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
;
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
parcelHelpers.export(exports, "getDependsOnOwnProps", ()=>getDependsOnOwnProps) // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
;
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//
parcelHelpers.export(exports, "wrapMapToPropsFunc", ()=>wrapMapToPropsFunc);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

},{"../utils/verifyPlainObject":"fAwaf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fAwaf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifyPlainObject);
var _isPlainObject = require("./isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verifyPlainObject(value, displayName, methodName) {
    if (!(0, _isPlainObjectDefault.default)(value)) (0, _warningDefault.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

},{"./isPlainObject":"626mb","./warning":"9tQ5l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"626mb":[function(require,module,exports,__globalThis) {
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPlainObject);
function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9tQ5l":[function(require,module,exports,__globalThis) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>warning);
function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gQxwI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapStateToPropsIsFunction", ()=>whenMapStateToPropsIsFunction);
parcelHelpers.export(exports, "whenMapStateToPropsIsMissing", ()=>whenMapStateToPropsIsMissing);
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapStateToPropsIsFunction(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
    return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
exports.default = [
    whenMapStateToPropsIsFunction,
    whenMapStateToPropsIsMissing
];

},{"./wrapMapToProps":"9sZ9X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5ZrHy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMergeProps", ()=>defaultMergeProps);
parcelHelpers.export(exports, "wrapMergePropsFunc", ()=>wrapMergePropsFunc);
parcelHelpers.export(exports, "whenMergePropsIsFunction", ()=>whenMergePropsIsFunction);
parcelHelpers.export(exports, "whenMergePropsIsOmitted", ()=>whenMergePropsIsOmitted);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return (0, _extendsDefault.default)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function whenMergePropsIsFunction(mergeProps) {
    return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
    return !mergeProps ? function() {
        return defaultMergeProps;
    } : undefined;
}
exports.default = [
    whenMergePropsIsFunction,
    whenMergePropsIsOmitted
];

},{"@babel/runtime/helpers/esm/extends":"aAOJb","../utils/verifyPlainObject":"fAwaf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fMozN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "impureFinalPropsSelectorFactory", ()=>impureFinalPropsSelectorFactory);
parcelHelpers.export(exports, "pureFinalPropsSelectorFactory", ()=>pureFinalPropsSelectorFactory) // TODO: Add more comments
;
parcelHelpers.export(exports, "default", ()=>finalPropsSelectorFactory);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _verifySubselectors = require("./verifySubselectors");
var _verifySubselectorsDefault = parcelHelpers.interopDefault(_verifySubselectors);
var _excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","./verifySubselectors":"g8pTJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g8pTJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifySubselectors);
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, _warningDefault.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    verify(mapStateToProps, 'mapStateToProps', displayName);
    verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    verify(mergeProps, 'mergeProps', displayName);
}

},{"../utils/warning":"9tQ5l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b8uv3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createDispatchHook", ()=>createDispatchHook);
parcelHelpers.export(exports, "useDispatch", ()=>useDispatch);
var _context = require("../components/Context");
var _useStore = require("./useStore");
function createDispatchHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useStore = context === (0, _context.ReactReduxContext) ? (0, _useStore.useStore) : (0, _useStore.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var useDispatch = /*#__PURE__*/ createDispatchHook();

},{"../components/Context":"d7pPF","./useStore":"2t65h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2t65h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createStoreHook", ()=>createStoreHook);
parcelHelpers.export(exports, "useStore", ()=>useStore);
var _react = require("react");
var _context = require("../components/Context");
var _useReduxContext = require("./useReduxContext");
function createStoreHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : function() {
        return (0, _react.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var useStore = /*#__PURE__*/ createStoreHook();

},{"react":"9njXz","../components/Context":"d7pPF","./useReduxContext":"jdjJX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jdjJX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */ parcelHelpers.export(exports, "useReduxContext", ()=>useReduxContext);
var _react = require("react");
var _context = require("../components/Context");
function useReduxContext() {
    var contextValue = (0, _react.useContext)((0, _context.ReactReduxContext));
    return contextValue;
}

},{"react":"9njXz","../components/Context":"d7pPF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jdZfi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createSelectorHook", ()=>createSelectorHook);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
var _react = require("react");
var _useReduxContext = require("./useReduxContext");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _context = require("../components/Context");
var refEquality = function refEquality(a, b) {
    return a === b;
};
function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, _react.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, _react.useMemo)(function() {
        return (0, _subscription.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, _react.useRef)();
    var latestSelector = (0, _react.useRef)();
    var latestStoreState = (0, _react.useRef)();
    var latestSelectedState = (0, _react.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function createSelectorHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : function() {
        return (0, _react.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, _react.useDebugValue)(selectedState);
        return selectedState;
    };
}
var useSelector = /*#__PURE__*/ createSelectorHook();

},{"react":"9njXz","./useReduxContext":"jdjJX","../utils/Subscription":"4gS0I","../utils/useIsomorphicLayoutEffect":"9y2R9","../components/Context":"d7pPF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"czlKX":[function(require,module,exports,__globalThis) {
/* eslint-disable import/no-unresolved */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>(0, _reactDom.unstable_batchedUpdates));
var _reactDom = require("react-dom");

},{"react-dom":"2ApDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4sGPJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "throttle", ()=>throttle);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _reactBus = require("react-bus");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
//import { Icons } from '@blueprintjs/icons';
var _raviger = require("raviger");
var _tinycolor2 = require("tinycolor2");
var _tinycolor2Default = parcelHelpers.interopDefault(_tinycolor2);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _login = require("./components/Login");
var _loginDefault = parcelHelpers.interopDefault(_login);
var _cashRegisterSelector = require("./components/CashRegisterSelector");
var _cashRegisterSelectorDefault = parcelHelpers.interopDefault(_cashRegisterSelector);
var _reservations = require("./components/reservations/Reservations");
var _reservationsDefault = parcelHelpers.interopDefault(_reservations);
var _dashboard = require("./components/dashboard/Dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
var _countries = require("./components/code_tables/Countries");
var _countriesDefault = parcelHelpers.interopDefault(_countries);
var _measuringUnits = require("./components/code_tables/MeasuringUnits");
var _measuringUnitsDefault = parcelHelpers.interopDefault(_measuringUnits);
var _paymentTypes = require("./components/code_tables/PaymentTypes");
var _paymentTypesDefault = parcelHelpers.interopDefault(_paymentTypes);
var _postOffices = require("./components/code_tables/PostOffices");
var _postOfficesDefault = parcelHelpers.interopDefault(_postOffices);
var _warehouses = require("./components/code_tables/Warehouses");
var _warehousesDefault = parcelHelpers.interopDefault(_warehouses);
var _cashRegisters = require("./components/code_tables/CashRegisters");
var _cashRegistersDefault = parcelHelpers.interopDefault(_cashRegisters);
var _channels = require("./components/code_tables/Channels");
var _channelsDefault = parcelHelpers.interopDefault(_channels);
var _taxRates = require("./components/code_tables/TaxRates");
var _taxRatesDefault = parcelHelpers.interopDefault(_taxRates);
var _businessPremises = require("./components/code_tables/BusinessPremises");
var _businessPremisesDefault = parcelHelpers.interopDefault(_businessPremises);
var _customers = require("./components/code_tables/Customers");
var _customersDefault = parcelHelpers.interopDefault(_customers);
var _items = require("./components/code_tables/Items");
var _itemsDefault = parcelHelpers.interopDefault(_items);
var _marketSegmentation = require("./components/code_tables/MarketSegmentation");
var _marketSegmentationDefault = parcelHelpers.interopDefault(_marketSegmentation);
var _identificationTypes = require("./components/code_tables/IdentificationTypes");
var _identificationTypesDefault = parcelHelpers.interopDefault(_identificationTypes);
var _touristTaxes = require("./components/code_tables/TouristTaxes");
var _touristTaxesDefault = parcelHelpers.interopDefault(_touristTaxes);
var _activities = require("./components/code_tables/Activities");
var _activitiesDefault = parcelHelpers.interopDefault(_activities);
var _users = require("./components/code_tables/Users");
var _usersDefault = parcelHelpers.interopDefault(_users);
var _invoices = require("./components/business/Invoices");
var _invoicesDefault = parcelHelpers.interopDefault(_invoices);
var _businessInvoices = require("./components/business/BusinessInvoices");
var _businessInvoicesDefault = parcelHelpers.interopDefault(_businessInvoices);
var _offers = require("./components/business/Offers");
var _offersDefault = parcelHelpers.interopDefault(_offers);
var _salesInvoiceBookItems = require("./components/business/SalesInvoiceBookItems");
var _salesInvoiceBookItemsDefault = parcelHelpers.interopDefault(_salesInvoiceBookItems);
var _prepaymentBookItems = require("./components/business/PrepaymentBookItems");
var _prepaymentBookItemsDefault = parcelHelpers.interopDefault(_prepaymentBookItems);
var _guestBook = require("./components/etourism/GuestBook");
var _guestBookDefault = parcelHelpers.interopDefault(_guestBook);
var _monthlyGuestBookReports = require("./components/etourism/MonthlyGuestBookReports");
var _monthlyGuestBookReportsDefault = parcelHelpers.interopDefault(_monthlyGuestBookReports);
var _touristTaxes1 = require("./components/etourism/TouristTaxes");
var _touristTaxesDefault1 = parcelHelpers.interopDefault(_touristTaxes1);
var _reservationList = require("./components/reservations/ReservationList");
var _reservationListDefault = parcelHelpers.interopDefault(_reservationList);
var _activitiesList = require("./components/reservations/ActivitiesList");
var _activitiesListDefault = parcelHelpers.interopDefault(_activitiesList);
var _generalSettings = require("./components/settings/GeneralSettings");
var _generalSettingsDefault = parcelHelpers.interopDefault(_generalSettings);
var _statusSettings = require("./components/settings/StatusSettings");
var _statusSettingsDefault = parcelHelpers.interopDefault(_statusSettings);
var _printSettings = require("./components/settings/PrintSettings");
var _printSettingsDefault = parcelHelpers.interopDefault(_printSettings);
var _documentSettings = require("./components/settings/DocumentSettings");
var _documentSettingsDefault = parcelHelpers.interopDefault(_documentSettings);
var _parameterSettings = require("./components/settings/ParameterSettings");
var _parameterSettingsDefault = parcelHelpers.interopDefault(_parameterSettings);
var _journals = require("./components/cash_registers/Journals");
var _journalsDefault = parcelHelpers.interopDefault(_journals);
var _cashRegisterDocuments = require("./components/cash_registers/CashRegisterDocuments");
var _cashRegisterDocumentsDefault = parcelHelpers.interopDefault(_cashRegisterDocuments);
var _stockAcquisitionDocuments = require("./components/stock/StockAcquisitionDocuments");
var _stockAcquisitionDocumentsDefault = parcelHelpers.interopDefault(_stockAcquisitionDocuments);
var _deliveryNotes = require("./components/stock/DeliveryNotes");
var _deliveryNotesDefault = parcelHelpers.interopDefault(_deliveryNotes);
var _stockInventory = require("./components/stock/StockInventory");
var _stockInventoryDefault = parcelHelpers.interopDefault(_stockInventory);
var _itemsAndServices = require("./components/reports/ItemsAndServices");
var _itemsAndServicesDefault = parcelHelpers.interopDefault(_itemsAndServices);
var _activityReservations = require("./components/reports/ActivityReservations");
var _activityReservationsDefault = parcelHelpers.interopDefault(_activityReservations);
var _reservationsReport = require("./components/reports/ReservationsReport");
var _reservationsReportDefault = parcelHelpers.interopDefault(_reservationsReport);
var _appToaster = require("./components/AppToaster");
var _posPrinterWatcher = require("./components/PosPrinterWatcher");
var _posPrinterWatcherDefault = parcelHelpers.interopDefault(_posPrinterWatcher);
var _a4PrinterWatcher = require("./components/A4PrinterWatcher");
var _a4PrinterWatcherDefault = parcelHelpers.interopDefault(_a4PrinterWatcher);
var _labelPrinterWatcher = require("./components/LabelPrinterWatcher");
var _labelPrinterWatcherDefault = parcelHelpers.interopDefault(_labelPrinterWatcher);
var _healthLog = require("./components/HealthLog");
var _healthLogDefault = parcelHelpers.interopDefault(_healthLog);
var _reservationRequestsList = require("./components/reservation_requests/ReservationRequestsList");
var _reservationRequestsListDefault = parcelHelpers.interopDefault(_reservationRequestsList);
var _settingsSlice = require("./slices/SettingsSlice");
var _codeTables = require("./api/CodeTables");
var _reservations1 = require("./api/Reservations");
var _business = require("./api/Business");
var _users1 = require("./api/Users");
var _documents = require("./api/Documents");
var _guests = require("./api/Guests");
var _cashRegisters1 = require("./api/CashRegisters");
var _settings = require("./api/Settings");
var _warehouses1 = require("./api/Warehouses");
var _userSlice = require("./slices/UserSlice");
var _cashRegisterSlice = require("./slices/CashRegisterSlice");
var _editInvoiceDialogHelper = require("./components/EditInvoiceDialogHelper");
var _localStorageHelper = require("./helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
var _documentSlice = require("./slices/DocumentSlice");
//import './App.css';
// from https://stackoverflow.com/a/15762794
// improved for some situations, e.g. 10.5545 -> 10.56
Math.properRound = (x, digits)=>{
    let n = x;
    let negative = false;
    if (digits === undefined) digits = 0;
    if (n < 0) {
        negative = true;
        n = n * -1;
    }
    for(let d = 8; d >= digits; d--){
        const multiplicator = Math.pow(10, d);
        n = parseFloat((n * multiplicator).toFixed(11));
        n = (Math.round(n) / multiplicator).toFixed(d);
        if (negative) n = (n * -1).toFixed(d);
        n = parseFloat(n);
    }
    return n;
};
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// from https://codeburst.io/throttling-and-debouncing-in-javascript-b01cad5c8edf
const throttle = (func, limit)=>{
    let inThrottle;
    return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
};
function EmptyRoute() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {});
}
let first_time = true;
let prev_load_token = null;
async function load(api_url, dispatch, token) {
    if (token === null || token === undefined) return;
    //if (first_time) {
    //	Icons.setLoaderOptions({ loader: 'all' });
    //	// optionally, load the icons up-front so that future usage does not trigger a network request
    //	await Icons.loadAll();
    //}
    if (first_time && token != prev_load_token) {
        first_time = false;
        prev_load_token = token;
        (0, _codeTables.loadCountries)(api_url, dispatch, token);
        (0, _codeTables.loadPostOffices)(api_url, dispatch, token);
        (0, _codeTables.loadBusinessPremises)(api_url, dispatch, token);
        (0, _codeTables.loadChannels)(api_url, dispatch, token);
        (0, _codeTables.loadCustomers)(api_url, dispatch, token);
        (0, _codeTables.loadMeasuringUnits)(api_url, dispatch, token);
        (0, _codeTables.loadPaymentTypes)(api_url, dispatch, token);
        (0, _codeTables.loadTaxRates)(api_url, dispatch, token);
        (0, _codeTables.loadWarehouses)(api_url, dispatch, token);
        (0, _codeTables.loadAccommodations)(api_url, dispatch, token);
        (0, _codeTables.loadItems)(api_url, dispatch, token);
        (0, _codeTables.loadMarketSegmentation)(api_url, dispatch, token);
        (0, _codeTables.loadActivities)(api_url, dispatch, token);
        (0, _codeTables.loadIdentificationTypes)(api_url, dispatch, token);
        (0, _codeTables.loadTouristTaxes)(api_url, dispatch, token);
        (0, _codeTables.loadBusinessPremiseFiscalRegistrations)(api_url, dispatch, token);
        (0, _reservations1.loadReservations)(api_url, dispatch, token);
        (0, _reservations1.loadActivityDailyLogbooks)(api_url, dispatch, token);
        (0, _reservations1.loadReservationRequests)(api_url, dispatch, token);
        (0, _reservations1.loadReservationRequestAccommodations)(api_url, dispatch, token);
        (0, _reservations1.loadPublicAccommodations)(api_url, dispatch, token);
        (0, _reservations1.loadPublicAccommodationSettings)(api_url, dispatch, token);
        (0, _business.loadInvoices)(api_url, dispatch, token);
        (0, _business.loadLatestInvoiceFiscalVerifications)(api_url, dispatch, token);
        (0, _business.loadAdvanceInvoiceConsumptions)(api_url, dispatch, token);
        (0, _documents.loadDocumentAssociations)(api_url, dispatch, token);
        (0, _documents.loadDocumentTypes)(api_url, dispatch, token);
        (0, _guests.loadGuestBookItems)(api_url, dispatch, token);
        (0, _guests.loadMonthlyGuestBookReports)(api_url, dispatch, token);
        (0, _cashRegisters1.loadCashRegisters)(api_url, dispatch, token);
        (0, _cashRegisters1.loadCashRegisterDailyStates)(api_url, dispatch, token);
        (0, _cashRegisters1.loadCashRegisterDocuments)(api_url, dispatch, token);
        (0, _settings.loadGeneralSettings)(api_url, dispatch, token);
        (0, _users1.loadUsers)(api_url, dispatch, token);
        (0, _warehouses1.loadStockAcquisitionDocuments)(api_url, dispatch, token);
        (0, _warehouses1.loadDeliveryNotes)(api_url, dispatch, token);
        (0, _warehouses1.loadStockInventoryItems)(api_url, dispatch, token);
        (0, _codeTables.loadDailyLogbookActivities)(api_url, dispatch, token);
        (0, _codeTables.loadWorkTypes)(api_url, dispatch, token);
        (0, _users1.loadUserWorkTypes)(api_url, dispatch, token);
    }
}
function useInitFirstTime(api_url, token) {
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        load(api_url, dispatch, token);
    });
}
class UserStateWatcher extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {};
    }
    componentDidUpdate(prevProps) {
        // check if user changed
        if (this.props.token != prevProps.token) {
            first_time = true;
            load(this.props.api_url, this.props.dispatch, this.props.token);
        }
        if (this.props.token != prevProps.token && this.props.token !== null && (this.props.user === null || this.props.user === undefined)) (0, _users1.loadUserInfo)(this.props.api_url, this.props.dispatch, this.props.token);
    }
    componentDidMount() {
        if (this.props.token !== null && this.props.user === null) (0, _users1.loadUserInfo)(this.props.api_url, this.props.dispatch, this.props.token);
    }
    render() {
        return null;
    }
}
const ConnectedUserStateWatcher = (0, _reactRedux.connect)((state)=>{
    return {
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        api_url: state.ConstantsSlice.api_url
    };
})(UserStateWatcher);
const EventWatcher = ()=>{
    (0, _reactBus.useListener)('notification-message', (0, _reactDefault.default).useCallback((event)=>{
        let intent = '';
        let icon = '';
        switch(event.type){
            case 'error':
                intent = 'danger';
                icon = 'issue';
                break;
            case 'warning':
                intent = 'warning';
                icon = 'warning-sign';
                break;
            case 'info':
                intent = 'primary';
                icon = 'info-sign';
                break;
            case 'success':
                intent = 'success';
                icon = 'tick';
                break;
        }
        (0, _appToaster.AppToaster).show({
            message: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: event.message
            }),
            intent,
            icon
        });
    }, []));
    return null;
};
const AppLoadBarrier = (0, _reactRedux.connect)((state)=>{
    return {
        SettingsSlice: state.SettingsSlice,
        CodeTablesSlice: state.CodeTablesSlice,
        ReservationSlice: state.ReservationSlice,
        BusinessSlice: state.BusinessSlice,
        UserSlice: state.UserSlice,
        DocumentSlice: state.DocumentSlice,
        GuestSlice: state.GuestSlice,
        CashRegisterSlice: state.CashRegisterSlice,
        WarehouseSlice: state.WarehouseSlice
    };
})((props)=>{
    const states = [
        props.SettingsSlice.general,
        props.CodeTablesSlice.countries,
        props.CodeTablesSlice.post_offices,
        props.CodeTablesSlice.business_premises,
        props.CodeTablesSlice.business_premise_fiscal_registrations,
        props.CodeTablesSlice.business_premise_fiscal_registrations_by_id_business_premises,
        props.CodeTablesSlice.channels,
        props.CodeTablesSlice.customers,
        props.CodeTablesSlice.measuring_units,
        props.CodeTablesSlice.payment_types,
        props.CodeTablesSlice.tax_rates,
        props.CodeTablesSlice.warehouses,
        props.CodeTablesSlice.accommodations,
        props.CodeTablesSlice.accommodation_items,
        props.CodeTablesSlice.accommodation_item_places,
        props.CodeTablesSlice.accommodation_item_items,
        props.CodeTablesSlice.accommodation_item_place_items,
        props.CodeTablesSlice.accommodation_item_schedules,
        props.CodeTablesSlice.accommodation_item_schedule_time_slots,
        props.CodeTablesSlice.accommodation_item_schedule_time_slot_activities,
        props.CodeTablesSlice.items,
        props.CodeTablesSlice.market_segmentation,
        props.CodeTablesSlice.activities,
        props.CodeTablesSlice.identification_types,
        props.CodeTablesSlice.tourist_taxes,
        props.CodeTablesSlice.daily_logbook_activities,
        props.CodeTablesSlice.work_types,
        props.ReservationSlice.reservations,
        props.ReservationSlice.reservation_customers,
        props.ReservationSlice.reservation_customers_by_id_reservations,
        props.ReservationSlice.activity_reservations,
        props.ReservationSlice.activity_daily_logbooks,
        props.ReservationSlice.public_accommodations,
        props.ReservationSlice.public_accommodation_settings,
        props.BusinessSlice.invoices,
        props.BusinessSlice.invoice_fiscal_verifications,
        props.BusinessSlice.advance_invoice_consumptions,
        props.BusinessSlice.id_advance_invoice_consumption_by_id_advance_invoices,
        props.BusinessSlice.id_advance_invoice_consumption_by_id_consumer_invoices,
        props.UserSlice.users,
        props.UserSlice.user_work_types,
        props.DocumentSlice.document_associations,
        props.DocumentSlice.document_associations_id_documents,
        props.DocumentSlice.document_types,
        props.GuestSlice.guest_book_items,
        props.GuestSlice.monthly_guest_book_reports,
        props.CashRegisterSlice.cash_registers,
        props.CashRegisterSlice.cash_register_daily_states,
        props.CashRegisterSlice.cash_register_documents,
        props.WarehouseSlice.stock_acquisition_documents,
        props.WarehouseSlice.stock_inventory_items
    ];
    const loaded_count = states.filter((x)=>x !== null).length;
    if (loaded_count != states.length) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "text-center p-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "p-2 text-xl",
                children: "nalagam"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("pre", {
                children: [
                    "\u25FC".repeat(loaded_count),
                    "\u25FB".repeat(states.length - loaded_count)
                ]
            })
        ]
    });
    return props.content();
});
let previous_settings = null;
const HealthLogger = (props)=>{
    (0, _react.useEffect)(()=>{
        const timer = setInterval(async ()=>{
            const start = (0, _momentDefault.default)();
            let log_str = (0, _localStorageHelperDefault.default).GetValue('health_log');
            if (log_str === null || log_str === undefined) log_str = '[]';
            let log = JSON.parse(log_str);
            if (log.length > 86400) log.shift();
            // test assistpro server
            const start_1 = (0, _momentDefault.default)();
            let response_1 = null;
            let error_1 = null;
            try {
                response_1 = await fetch(props.api_url + 'health.php');
            } catch (e) {
                error_1 = e;
            }
            const end_1 = (0, _momentDefault.default)();
            // test other server
            const start_2 = (0, _momentDefault.default)();
            let response_2 = null;
            let error_2 = null;
            try {
                response_2 = await fetch('https://tadej.ncode.si:790');
            } catch (e) {
                error_2 = e;
            }
            const end_2 = (0, _momentDefault.default)();
            log.push({
                ts: start.toISOString(true),
                assistpro_latency: end_1.diff(start_1),
                assistpro_status: response_1 === null ? null : response_1.status,
                assistpro_error_message: error_1 === null ? null : error_1.message,
                other_latency: end_2.diff(start_2),
                other_status: response_2 === null ? null : response_2.status,
                other_error_message: error_2 === null ? null : error_2.message
            });
            (0, _localStorageHelperDefault.default).SetValue('health_log', JSON.stringify(log));
        }, 5000);
        return ()=>clearInterval(timer);
    }, []);
    return null;
};
function mapStateToProps(state) {
    return {
        api_url: state.ConstantsSlice.api_url
    };
}
const ConnectedHealthLogger = (0, _reactRedux.connect)(mapStateToProps)(HealthLogger);
function App(props) {
    console.log('RENDERING APP');
    const dispatch = (0, _reactRedux.useDispatch)();
    const [invoice_dialog_open, setInvoiceDialogOpen] = (0, _react.useState)(false);
    const [invoice_dialog_item, setInvoiceDialogItem] = (0, _react.useState)(null);
    const [invoice_dialog_type, setInvoiceDialogType] = (0, _react.useState)(null);
    const [invoice_dialog_advance_invoices_amounts, setInvoiceDialogAdvanceInvoicesAmounts] = (0, _react.useState)(null);
    const [invoice_dialog_document_associations, setInvoiceDialogDocumentAssociations] = (0, _react.useState)(null);
    const [wait_fiscal_verification_dialog_id_invoice, setWaitFiscalVerificationDialogIdInvoice] = (0, _react.useState)(null);
    const openInvoiceDialog = (item, type, advance_invoices_amounts, document_associations)=>{
        setInvoiceDialogOpen(true);
        setInvoiceDialogItem(item);
        setInvoiceDialogType(type);
        setInvoiceDialogAdvanceInvoicesAmounts(advance_invoices_amounts || {});
        setInvoiceDialogDocumentAssociations(document_associations || []);
    };
    const addAndSaveDocumentAssociation = async (source_id_document, source_type, target_id_document, target_type)=>{
        const item = {
            id_document_association: (0, _uuidDefault.default).v4(),
            source_id_document,
            source_type,
            target_id_document,
            target_type
        };
        dispatch((0, _documentSlice.addDocumentAssociation)({
            item,
            token: props.token
        }));
        const new_item = await (0, _documents.saveDocumentAssociation)(props.api_url, item, props.token);
        if (new_item !== null) dispatch((0, _documentSlice.addDocumentAssociation)({
            item: new_item,
            token: props.token
        }));
    };
    const closeInvoiceDialog = async (item, open_create_invoice_type, finish_invoice)=>{
        setInvoiceDialogOpen(false);
        setInvoiceDialogItem(null);
        setInvoiceDialogType(null);
        setInvoiceDialogAdvanceInvoicesAmounts(null);
        (0, _editInvoiceDialogHelper.EditInvoiceDialogHelperCloseDialog)(dispatch, props.token, props.api_url, props.document_types, setWaitFiscalVerificationDialogIdInvoice, openInvoiceDialog, item, open_create_invoice_type, finish_invoice);
        for(let i = 0; i < invoice_dialog_document_associations.length; i++)await addAndSaveDocumentAssociation(item.id_invoice, item.invoice_type, invoice_dialog_document_associations[i].id_document, invoice_dialog_document_associations[i].document_type);
        setInvoiceDialogDocumentAssociations(null);
    };
    const routes = {
        '/test': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "test"
            }),
        '/status': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _healthLogDefault.default), {}),
        '/': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardDefault.default), {}),
        '/reservations*': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reservationsDefault.default), {}),
        '/reservation-list': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reservationListDefault.default), {}),
        '/reservation-activities-list': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _activitiesListDefault.default), {}),
        '/business': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/business/cash-invoices': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _invoicesDefault.default), {
                openInvoiceDialog: openInvoiceDialog
            }),
        '/business/invoices': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _businessInvoicesDefault.default), {}),
        '/business/offers': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offersDefault.default), {}),
        '/business/invoices-book': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _salesInvoiceBookItemsDefault.default), {}),
        '/business/prepayment-book': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prepaymentBookItemsDefault.default), {}),
        '/business/:module': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/reservation-requests/list': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reservationRequestsListDefault.default), {}),
        '/reservation-requests/:module': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/cash-register': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/cash-register/journal': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _journalsDefault.default), {}),
        '/cash-register/documents': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cashRegisterDocumentsDefault.default), {}),
        '/cash-register/:module': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/stock': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/stock/acquisition': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stockAcquisitionDocumentsDefault.default), {}),
        '/stock/inventory': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stockInventoryDefault.default), {}),
        '/stock/delivery-notes': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deliveryNotesDefault.default), {
                openInvoiceDialog: openInvoiceDialog
            }),
        '/stock/:module': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/etourism': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/etourism/guest-book': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guestBookDefault.default), {}),
        '/etourism/monthly-statistics': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _monthlyGuestBookReportsDefault.default), {}),
        '/etourism/tourist-taxes': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _touristTaxesDefault1.default), {}),
        '/etourism/:module': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/reports': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/reports/items-and-services': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemsAndServicesDefault.default), {}),
        '/reports/activity-reservations': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _activityReservationsDefault.default), {
                openInvoiceDialog: openInvoiceDialog
            }),
        '/reports/reservations-report': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reservationsReportDefault.default), {}),
        '/reports/:module': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/code-tables': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/code-tables/customers': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersDefault.default), {}),
        '/code-tables/items-and-services': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemsDefault.default), {}),
        '/code-tables/payment-types': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentTypesDefault.default), {}),
        '/code-tables/measuring-units': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measuringUnitsDefault.default), {}),
        '/code-tables/post-offices': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _postOfficesDefault.default), {}),
        '/code-tables/countries': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countriesDefault.default), {}),
        '/code-tables/warehouses': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warehousesDefault.default), {}),
        '/code-tables/cash-registers': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cashRegistersDefault.default), {}),
        '/code-tables/channels': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _channelsDefault.default), {}),
        '/code-tables/tax-rates': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _taxRatesDefault.default), {}),
        '/code-tables/business-premises': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _businessPremisesDefault.default), {}),
        '/code-tables/market-segmentation': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _marketSegmentationDefault.default), {}),
        '/code-tables/identification-types': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _identificationTypesDefault.default), {}),
        '/code-tables/tourist-taxes': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _touristTaxesDefault.default), {}),
        '/code-tables/activities': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _activitiesDefault.default), {}),
        '/code-tables/users': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersDefault.default), {}),
        '/code-tables/:module': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/settings': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {}),
        '/settings/general': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalSettingsDefault.default), {}),
        '/settings/statuses': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusSettingsDefault.default), {}),
        '/settings/print': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _printSettingsDefault.default), {}),
        '/settings/documents': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentSettingsDefault.default), {}),
        '/settings/parameters': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _parameterSettingsDefault.default), {}),
        '/settings/:module': ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyRoute, {})
    };
    let route = (0, _raviger.useRoutes)(routes);
    let path = route === null ? '/' : route.props.path;
    if (path.length == 0 || path.substring(path.length - 1) != '/') path += '/';
    const path_first_parts = /\/(.+?)\//.exec(path);
    const path_first_part = path_first_parts === null || path_first_parts.length != 2 ? 'dashboard' : path_first_parts[1];
    const path_second_parts = /\/.+?\/(.+?)\//.exec(path);
    const path_second_part = path_second_parts === null || path_second_parts.length != 2 ? '' : path_second_parts[1];
    if (props.general_settings !== null && (previous_settings === null || previous_settings.color_status_new != props.general_settings.color_status_new || previous_settings.color_status_waiting_for_confirmation != props.general_settings.color_status_waiting_for_confirmation || previous_settings.color_status_offer_sent != props.general_settings.color_status_offer_sent || previous_settings.color_status_confirmed != props.general_settings.color_status_confirmed || previous_settings.color_status_advance_invoice_sent != props.general_settings.color_status_advance_invoice_sent || previous_settings.color_status_closed != props.general_settings.color_status_closed || previous_settings.color_status_dragging != props.general_settings.color_status_dragging || previous_settings.color_status_deleting != props.general_settings.color_status_deleting || previous_settings.color_status_deleted != props.general_settings.color_status_deleting || previous_settings.color_status_reversed != props.general_settings.color_status_reversed || previous_settings.color_status_no_show != props.general_settings.color_status_no_show || previous_settings.color_status_not_for_rent != props.general_settings.color_status_not_for_rent || previous_settings.color_status_invalid != props.general_settings.color_status_invalid || previous_settings.color_custom_status_1 != props.general_settings.color_custom_status_1 || previous_settings.color_custom_status_2 != props.general_settings.color_custom_status_2 || previous_settings.color_custom_status_3 != props.general_settings.color_custom_status_3 || previous_settings.color_custom_status_4 != props.general_settings.color_custom_status_4 || previous_settings.color_custom_status_5 != props.general_settings.color_custom_status_5 || previous_settings.color_custom_status_6 != props.general_settings.color_custom_status_6 || previous_settings.color_custom_status_7 != props.general_settings.color_custom_status_7)) {
        previous_settings = props.general_settings;
        const text_color = (color)=>(0, _tinycolor2Default.default)(color).getLuminance() > 0.25 ? '#000000' : '#ffffff';
        const sett = props.general_settings;
        const style = document.createElement('style');
        style.textContent = `
			.timeline .reservation-bar.status-new                      .reservation-bar-background { fill: ${sett.color_status_new}; }
			.timeline .reservation-bar.status-waiting-for-confirmation .reservation-bar-background { fill: ${sett.color_status_waiting_for_confirmation}; }
			.timeline .reservation-bar.status-offer-sent               .reservation-bar-background { fill: ${sett.color_status_offer_sent}; }
			.timeline .reservation-bar.status-confirmed                .reservation-bar-background { fill: ${sett.color_status_confirmed}; }
			.timeline .reservation-bar.status-advance-invoice-sent     .reservation-bar-background { fill: ${sett.color_status_advance_invoice_sent}; }
			.timeline .reservation-bar.status-closed                   .reservation-bar-background { fill: ${sett.color_status_closed}; }
			.timeline .reservation-bar.status-dragging                 .reservation-bar-background { fill: ${sett.color_status_dragging}; }
			.timeline .reservation-bar.status-deleting                 .reservation-bar-background { fill: ${sett.color_status_deleting}; }
			.timeline .reservation-bar.status-deleted                  .reservation-bar-background { fill: ${sett.color_status_deleting}; }
			.timeline .reservation-bar.status-reversed                 .reservation-bar-background { fill: ${sett.color_status_reversed}; }
			.timeline .reservation-bar.status-no-show                  .reservation-bar-background { fill: ${sett.color_status_no_show}; }
			.timeline .reservation-bar.status-not-for-rent             .reservation-bar-background { fill: ${sett.color_status_not_for_rent}; }
			.timeline .reservation-bar.status-invalid                  .reservation-bar-background { fill: ${sett.color_status_invalid}; }
			.timeline .reservation-bar.custom-status-1                 .custom-status-indicator    { fill: ${sett.color_custom_status_1}; }
			.timeline .reservation-bar.custom-status-2                 .custom-status-indicator    { fill: ${sett.color_custom_status_2}; }
			.timeline .reservation-bar.custom-status-3                 .custom-status-indicator    { fill: ${sett.color_custom_status_3}; }
			.timeline .reservation-bar.custom-status-4                 .custom-status-indicator    { fill: ${sett.color_custom_status_4}; }
			.timeline .reservation-bar.custom-status-5                 .custom-status-indicator    { fill: ${sett.color_custom_status_5}; }
			.timeline .reservation-bar.custom-status-6                 .custom-status-indicator    { fill: ${sett.color_custom_status_6}; }
			.timeline .reservation-bar.custom-status-7                 .custom-status-indicator    { fill: ${sett.color_custom_status_7}; }
			
			.timeline .reservation-bar.status-new                      text { fill: ${text_color(sett.color_status_new)}; }
			.timeline .reservation-bar.status-waiting-for-confirmation text { fill: ${text_color(sett.color_status_waiting_for_confirmation)}; }
			.timeline .reservation-bar.status-offer-sent               text { fill: ${text_color(sett.color_status_offer_sent)}; }
			.timeline .reservation-bar.status-confirmed                text { fill: ${text_color(sett.color_status_confirmed)}; }
			.timeline .reservation-bar.status-advance-invoice-sent     text { fill: ${text_color(sett.color_status_advance_invoice_sent)}; }
			.timeline .reservation-bar.status-closed                   text { fill: ${text_color(sett.color_status_closed)}; }
			.timeline .reservation-bar.status-dragging                 text { fill: ${text_color(sett.color_status_dragging)}; }
			.timeline .reservation-bar.status-deleting                 text { fill: ${text_color(sett.color_status_deleting)}; }
			.timeline .reservation-bar.status-deleted                  text { fill: ${text_color(sett.color_status_deleting)}; }
			.timeline .reservation-bar.status-reversed                 text { fill: ${text_color(sett.color_status_reversed)}; }
			.timeline .reservation-bar.status-no-show                  text { fill: ${text_color(sett.color_status_no_show)}; }
			.timeline .reservation-bar.status-not-for-rent             text { fill: ${text_color(sett.color_status_not_for_rent)}; }
			.timeline .reservation-bar.status-invalid                  text { fill: ${text_color(sett.color_status_invalid)}; }
			.timeline .reservation-bar.custom-status-1                 text { fill: ${text_color(sett.color_custom_status_1)}; }
			.timeline .reservation-bar.custom-status-2                 text { fill: ${text_color(sett.color_custom_status_2)}; }
			.timeline .reservation-bar.custom-status-3                 text { fill: ${text_color(sett.color_custom_status_3)}; }
			.timeline .reservation-bar.custom-status-4                 text { fill: ${text_color(sett.color_custom_status_4)}; }
			.timeline .reservation-bar.custom-status-5                 text { fill: ${text_color(sett.color_custom_status_5)}; }
			.timeline .reservation-bar.custom-status-6                 text { fill: ${text_color(sett.color_custom_status_6)}; }
			.timeline .reservation-bar.custom-status-7                 text { fill: ${text_color(sett.color_custom_status_7)}; }
			
			.timeline .reservation-request-bar.status-new              .reservation-bar-background { fill: ${sett.color_status_new}; }
			.timeline .reservation-request-bar.status-confirmed        .reservation-bar-background { fill: ${sett.color_status_waiting_for_confirmation}; }
			
			.timeline .reservation-request-bar.status-new              text { fill: ${text_color(sett.color_status_new)}; }
			.timeline .reservation-request-bar.status-confirmed        text { fill: ${text_color(sett.color_status_waiting_for_confirmation)}; }
			
			.activities-guests-table.custom-status-1 .custom-status path { fill: ${sett.color_custom_status_1}; }
			.activities-guests-table.custom-status-2 .custom-status path { fill: ${sett.color_custom_status_2}; }
			.activities-guests-table.custom-status-3 .custom-status path { fill: ${sett.color_custom_status_3}; }
			.activities-guests-table.custom-status-4 .custom-status path { fill: ${sett.color_custom_status_4}; }
			.activities-guests-table.custom-status-5 .custom-status path { fill: ${sett.color_custom_status_5}; }
			.activities-guests-table.custom-status-6 .custom-status path { fill: ${sett.color_custom_status_6}; }
			.activities-guests-table.custom-status-7 .custom-status path { fill: ${sett.color_custom_status_7}; }
			
			.reservation-list .results .results-table.custom-status-1 .custom-status path { fill: ${sett.color_custom_status_1}; }
			.reservation-list .results .results-table.custom-status-2 .custom-status path { fill: ${sett.color_custom_status_2}; }
			.reservation-list .results .results-table.custom-status-3 .custom-status path { fill: ${sett.color_custom_status_3}; }
			.reservation-list .results .results-table.custom-status-4 .custom-status path { fill: ${sett.color_custom_status_4}; }
			.reservation-list .results .results-table.custom-status-5 .custom-status path { fill: ${sett.color_custom_status_5}; }
			.reservation-list .results .results-table.custom-status-6 .custom-status path { fill: ${sett.color_custom_status_6}; }
			.reservation-list .results .results-table.custom-status-7 .custom-status path { fill: ${sett.color_custom_status_7}; }
			
			.activity-reservation-list .results .results-table.custom-status-1 .custom-status path { fill: ${sett.color_custom_status_1}; }
			.activity-reservation-list .results .results-table.custom-status-2 .custom-status path { fill: ${sett.color_custom_status_2}; }
			.activity-reservation-list .results .results-table.custom-status-3 .custom-status path { fill: ${sett.color_custom_status_3}; }
			.activity-reservation-list .results .results-table.custom-status-4 .custom-status path { fill: ${sett.color_custom_status_4}; }
			.activity-reservation-list .results .results-table.custom-status-5 .custom-status path { fill: ${sett.color_custom_status_5}; }
			.activity-reservation-list .results .results-table.custom-status-6 .custom-status path { fill: ${sett.color_custom_status_6}; }
			.activity-reservation-list .results .results-table.custom-status-7 .custom-status path { fill: ${sett.color_custom_status_7}; }
			
			.activities-guests-table.status-new {
				background-color: ${sett.color_status_new};
				color: ${text_color(sett.color_status_new)};
			}
			.activities-guests-table.status-waiting-for-confirmation {
				background-color: ${sett.color_status_waiting_for_confirmation};
				color: ${text_color(sett.color_status_waiting_for_confirmation)};
			}
			.activities-guests-table.status-offer-sent {
				background-color: ${sett.color_status_offer_sent};
				color: ${text_color(sett.color_status_offer_sent)};
			}
			.activities-guests-table.status-confirmed {
				background-color: ${sett.color_status_confirmed};
				color: ${text_color(sett.color_status_confirmed)};
			}
			.activities-guests-table.status-advance-invoice-sent {
				background-color: ${sett.color_status_advance_invoice_sent};
				color: ${text_color(sett.color_status_advance_invoice_sent)};
			}
			.activities-guests-table.status-closed {
				background-color: ${sett.color_status_closed};
				color: ${text_color(sett.color_status_closed)};
			}
			.activities-guests-table.status-dragging {
				background-color: ${sett.color_status_dragging};
				color: ${text_color(sett.color_status_dragging)};
			}
			.activities-guests-table.status-deleting {
				background-color: ${sett.color_status_deleting};
				color: ${text_color(sett.color_status_deleting)};
			}
			.activities-guests-table.status-deleted {
				background-color: ${sett.color_status_deleting};
				color: ${text_color(sett.color_status_deleting)};
			}
			.activities-guests-table.status-reversed {
				background-color: ${sett.color_status_reversed};
				color: ${text_color(sett.color_status_reversed)};
			}
			.activities-guests-table.status-no-show {
				background-color: ${sett.color_status_no_show};
				color: ${text_color(sett.color_status_no_show)};
			}
			.activities-guests-table.status-not-for-rent {
				background-color: ${sett.color_status_not_for_rent};
				color: ${text_color(sett.color_status_not_for_rent)};
			}
			.activities-guests-table.status-invalid {
				background-color: ${sett.color_status_invalid};
				color: ${text_color(sett.color_status_invalid)};
			}
			
			.reservation-list .results .results-table.status-new                      .results-table-col {
				background-color: ${sett.color_status_new};
				color: ${text_color(sett.color_status_new)};
			}
			.reservation-list .results .results-table.status-waiting-for-confirmation .results-table-col {
				background-color: ${sett.color_status_waiting_for_confirmation};
				color: ${text_color(sett.color_status_waiting_for_confirmation)};
			}
			.reservation-list .results .results-table.status-offer-sent               .results-table-col {
				background-color: ${sett.color_status_offer_sent};
				color: ${text_color(sett.color_status_offer_sent)};
			}
			.reservation-list .results .results-table.status-confirmed                .results-table-col {
				background-color: ${sett.color_status_confirmed};
				color: ${text_color(sett.color_status_confirmed)};
			}
			.reservation-list .results .results-table.status-advance-invoice-sent     .results-table-col {
				background-color: ${sett.color_status_advance_invoice_sent};
				color: ${text_color(sett.color_status_advance_invoice_sent)};
			}
			.reservation-list .results .results-table.status-closed                   .results-table-col {
				background-color: ${sett.color_status_closed};
				color: ${text_color(sett.color_status_closed)};
			}
			.reservation-list .results .results-table.status-dragging                 .results-table-col {
				background-color: ${sett.color_status_dragging};
				color: ${text_color(sett.color_status_dragging)};
			}
			.reservation-list .results .results-table.status-deleting                 .results-table-col {
				background-color: ${sett.color_status_deleting};
				color: ${text_color(sett.color_status_deleting)};
			}
			.reservation-list .results .results-table.status-deleted                  .results-table-col {
				background-color: ${sett.color_status_deleting};
				color: ${text_color(sett.color_status_deleting)};
			}
			.reservation-list .results .results-table.status-reversed                 .results-table-col {
				background-color: ${sett.color_status_reversed};
				color: ${text_color(sett.color_status_reversed)};
			}
			.reservation-list .results .results-table.status-no-show                  .results-table-col {
				background-color: ${sett.color_status_no_show};
				color: ${text_color(sett.color_status_no_show)};
			}
			.reservation-list .results .results-table.status-not-for-rent             .results-table-col {
				background-color: ${sett.color_status_not_for_rent};
				color: ${text_color(sett.color_status_not_for_rent)};
			}
			.reservation-list .results .results-table.status-invalid                  .results-table-col {
				background-color: ${sett.color_status_invalid};
				color: ${text_color(sett.color_status_invalid)};
			}
			
			.reservation-requests-list .results .results-table .results-table-col.status-new {
				background-color: ${sett.color_status_new};
				color: ${text_color(sett.color_status_new)};
			}
			.reservation-requests-list .results .results-table .results-table-col.status-confirmed {
				background-color: ${sett.color_status_confirmed};
				color: ${text_color(sett.color_status_confirmed)};
			}
			.reservation-requests-list .results .results-table .results-table-col.status-closed {
				background-color: ${sett.color_status_closed};
				color: ${text_color(sett.color_status_closed)};
			}
			.reservation-requests-list .results .results-table .results-table-col.status-reversed {
				background-color: ${sett.color_status_reversed};
				color: ${text_color(sett.color_status_reversed)};
			}
			.reservation-requests-list .results .results-table .results-table-col.status-processed {
				background-color: ${sett.color_status_waiting_for_confirmation};
				color: ${text_color(sett.color_status_waiting_for_confirmation)};
			}
			
			.activity-reservation-list .results .results-table.status-new                      .results-table-col {
				background-color: ${sett.color_status_new};
				color: ${text_color(sett.color_status_new)};
			}
			.activity-reservation-list .results .results-table.status-waiting-for-confirmation .results-table-col {
				background-color: ${sett.color_status_waiting_for_confirmation};
				color: ${text_color(sett.color_status_waiting_for_confirmation)};
			}
			.activity-reservation-list .results .results-table.status-offer-sent               .results-table-col {
				background-color: ${sett.color_status_offer_sent};
				color: ${text_color(sett.color_status_offer_sent)};
			}
			.activity-reservation-list .results .results-table.status-confirmed                .results-table-col {
				background-color: ${sett.color_status_confirmed};
				color: ${text_color(sett.color_status_confirmed)};
			}
			.activity-reservation-list .results .results-table.status-advance-invoice-sent     .results-table-col {
				background-color: ${sett.color_status_advance_invoice_sent};
				color: ${text_color(sett.color_status_advance_invoice_sent)};
			}
			.activity-reservation-list .results .results-table.status-closed                   .results-table-col {
				background-color: ${sett.color_status_closed};
				color: ${text_color(sett.color_status_closed)};
			}
			.activity-reservation-list .results .results-table.status-dragging                 .results-table-col {
				background-color: ${sett.color_status_dragging};
				color: ${text_color(sett.color_status_dragging)};
			}
			.activity-reservation-list .results .results-table.status-deleting                 .results-table-col {
				background-color: ${sett.color_status_deleting};
				color: ${text_color(sett.color_status_deleting)};
			}
			.activity-reservation-list .results .results-table.status-deleted                  .results-table-col {
				background-color: ${sett.color_status_deleting};
				color: ${text_color(sett.color_status_deleting)};
			}
			.activity-reservation-list .results .results-table.status-reversed                 .results-table-col {
				background-color: ${sett.color_status_reversed};
				color: ${text_color(sett.color_status_reversed)};
			}
			.activity-reservation-list .results .results-table.status-no-show                  .results-table-col {
				background-color: ${sett.color_status_no_show};
				color: ${text_color(sett.color_status_no_show)};
			}
			.activity-reservation-list .results .results-table.status-not-for-rent             .results-table-col {
				background-color: ${sett.color_status_not_for_rent};
				color: ${text_color(sett.color_status_not_for_rent)};
			}
			.activity-reservation-list .results .results-table.status-invalid                  .results-table-col {
				background-color: ${sett.color_status_invalid};
				color: ${text_color(sett.color_status_invalid)};
			}
			
			.reports-activity-reservations-list .col.status-new {
				background-color: ${sett.color_status_new};
				color: ${text_color(sett.color_status_new)};
			}
			.reports-activity-reservations-list .col.status-waiting-for-confirmation {
				background-color: ${sett.color_status_waiting_for_confirmation};
				color: ${text_color(sett.color_status_waiting_for_confirmation)};
			}
			.reports-activity-reservations-list .col.status-offer-sent {
				background-color: ${sett.color_status_offer_sent};
				color: ${text_color(sett.color_status_offer_sent)};
			}
			.reports-activity-reservations-list .col.status-confirmed {
				background-color: ${sett.color_status_confirmed};
				color: ${text_color(sett.color_status_confirmed)};
			}
			.reports-activity-reservations-list .col.status-advance-invoice-sent {
				background-color: ${sett.color_status_advance_invoice_sent};
				color: ${text_color(sett.color_status_advance_invoice_sent)};
			}
			.reports-activity-reservations-list .col.status-closed {
				background-color: ${sett.color_status_closed};
				color: ${text_color(sett.color_status_closed)};
			}
			.reports-activity-reservations-list .col.status-dragging {
				background-color: ${sett.color_status_dragging};
				color: ${text_color(sett.color_status_dragging)};
			}
			.reports-activity-reservations-list .col.status-deleting {
				background-color: ${sett.color_status_deleting};
				color: ${text_color(sett.color_status_deleting)};
			}
			.reports-activity-reservations-list .col.status-deleted {
				background-color: ${sett.color_status_deleting};
				color: ${text_color(sett.color_status_deleting)};
			}
			.reports-activity-reservations-list .col.status-reversed {
				background-color: ${sett.color_status_reversed};
				color: ${text_color(sett.color_status_reversed)};
			}
			.reports-activity-reservations-list .col.status-no-show {
				background-color: ${sett.color_status_no_show};
				color: ${text_color(sett.color_status_no_show)};
			}
			.reports-activity-reservations-list .col.status-not-for-rent {
				background-color: ${sett.color_status_not_for_rent};
				color: ${text_color(sett.color_status_not_for_rent)};
			}
			.reports-activity-reservations-list .col.status-invalid {
				background-color: ${sett.color_status_invalid};
				color: ${text_color(sett.color_status_invalid)};
			}
		`;
        document.head.appendChild(style);
    }
    const access_roles = props.user === null || props.user === undefined ? [] : props.user.access_roles ?? [];
    const submenu_items = {
        'business': [
            access_roles.indexOf('business--cash-invoices') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'business' && path_second_part == 'cash-invoices',
                icon: "floppy-disk",
                text: "Blagajni\u0161ki ra\u010Duni",
                onClick: ()=>(0, _raviger.navigate)('/business/cash-invoices')
            }, 'submenu-3-1'),
            access_roles.indexOf('business--business-invoices') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'business' && path_second_part == 'invoices',
                icon: "document",
                text: "Fakturiranje",
                onClick: ()=>(0, _raviger.navigate)('/business/invoices')
            }, 'submenu-3-2'),
            access_roles.indexOf('business--offers') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'business' && path_second_part == 'offers',
                icon: "bank-account",
                text: "Ponudbe",
                onClick: ()=>(0, _raviger.navigate)('/business/offers')
            }, 'submenu-3-4'),
            access_roles.indexOf('business--invoices-book') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'business' && path_second_part == 'invoices-book',
                icon: "bank-account",
                text: "Knjiga izdanih ra\u010Dunov",
                onClick: ()=>(0, _raviger.navigate)('/business/invoices-book')
            }, 'submenu-3-6'),
            access_roles.indexOf('business--prepayment-book') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'business' && path_second_part == 'prepayment-book',
                icon: "bank-account",
                text: "Knjiga prejetih avansov",
                onClick: ()=>(0, _raviger.navigate)('/business/prepayment-book')
            }, 'submenu-3-7')
        ],
        'reservation-requests': [
            access_roles.indexOf('reservations') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'reservation-requests' && path_second_part == 'list',
                icon: "floppy-disk",
                text: "Povpra\u0161evanja",
                onClick: ()=>(0, _raviger.navigate)('/reservation-requests/list')
            }, 'submenu-2-1')
        ],
        'cash-register': [
            access_roles.indexOf('cash-register--journals') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'cash-register' && path_second_part == 'journal',
                icon: "manually-entered-data",
                text: "Blagajni\u0161ki dnevnik",
                onClick: ()=>(0, _raviger.navigate)('/cash-register/journal')
            }, 'submenu-4-2'),
            access_roles.indexOf('cash-register--documents') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'cash-register' && path_second_part == 'documents',
                icon: "manually-entered-data",
                text: "Blagajni\u0161ki dokumenti",
                onClick: ()=>(0, _raviger.navigate)('/cash-register/documents')
            }, 'submenu-4-1')
        ],
        'stock': [
            access_roles.indexOf('stock--acquisitions') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'stock' && path_second_part == 'acquisition',
                icon: "floppy-disk",
                text: "Prevzem",
                onClick: ()=>(0, _raviger.navigate)('/stock/acquisition')
            }, 'submenu-5-1'),
            access_roles.indexOf('stock--delivery-notes') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'stock' && path_second_part == 'delivery-notes',
                icon: "document",
                text: "Dobavnica",
                onClick: ()=>(0, _raviger.navigate)('/stock/delivery-notes')
            }, 'submenu-5-2'),
            access_roles.indexOf('stock--inventory') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'stock' && path_second_part == 'inventory',
                icon: "bank-account",
                text: "Stanje zalog",
                onClick: ()=>(0, _raviger.navigate)('/stock/inventory')
            }, 'submenu-5-4')
        ],
        'etourism': [
            access_roles.indexOf('etourism--guest-book') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'etourism' && path_second_part == 'guest-book',
                icon: "bank-account",
                text: "Prijava/Knjiga gostov",
                onClick: ()=>(0, _raviger.navigate)('/etourism/guest-book')
            }, 'submenu-6-1'),
            access_roles.indexOf('etourism--monthly-statistics') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'etourism' && path_second_part == 'monthly-statistics',
                icon: "document",
                text: "Mese\u010Dna statistika",
                onClick: ()=>(0, _raviger.navigate)('/etourism/monthly-statistics')
            }, 'submenu-6-2'),
            access_roles.indexOf('etourism--tourist-taxes') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'etourism' && path_second_part == 'tourist-taxes',
                icon: "bank-account",
                text: "Turisti\u010Dna taksa",
                onClick: ()=>(0, _raviger.navigate)('/etourism/tourist-taxes')
            }, 'submenu-6-3')
        ],
        'reports': [
            /*<Button
				key={'submenu-7-1'}
				minimal={true}
				active={ path_first_part == 'reports' && path_second_part == 'reservations' }
				icon='floppy-disk'
				text='Rezervacije'
				onClick={() => navigate('/reports/reservations')} />,
			<Button
				key={'submenu-7-2'}
				minimal={true}
				active={ path_first_part == 'reports' && path_second_part == 'turnover' }
				icon='document'
				text='Promet'
				onClick={() => navigate('/reports/turnover')} />,*/ access_roles.indexOf('reports--activity-reservations') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'reports' && path_second_part == 'items-and-services',
                icon: "bank-account",
                text: "Artikli/storitve",
                onClick: ()=>(0, _raviger.navigate)('/reports/items-and-services')
            }, 'submenu-7-3'),
            access_roles.indexOf('reports--realization') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'reports' && path_second_part == 'activity-reservations',
                icon: "bank-account",
                text: "Realizacija",
                onClick: ()=>(0, _raviger.navigate)('/reports/activity-reservations')
            }, 'submenu-7-4'),
            access_roles.indexOf('reports--reservations-report') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'reports' && path_second_part == 'reservations-report',
                icon: "bank-account",
                text: "Rezervacije",
                onClick: ()=>(0, _raviger.navigate)('/reports/reservations-report')
            }, 'submenu-7-5')
        ],
        'code-tables': [
            access_roles.indexOf('code-tables') === -1 || access_roles.indexOf('code-tables--customers') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'customers',
                icon: "floppy-disk",
                text: "Stranke",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/customers')
            }, 'submenu-8-1'),
            access_roles.indexOf('code-tables') === -1 || access_roles.indexOf('code-tables--items-and-services') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'items-and-services',
                icon: "document",
                text: "Artikli/storitve",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/items-and-services')
            }, 'submenu-8-2'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'payment-types',
                icon: "bank-account",
                text: "Na\u010Dini pla\u010Dila",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/payment-types')
            }, 'submenu-8-3'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'measuring-units',
                icon: "bank-account",
                text: "Enote mere",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/measuring-units')
            }, 'submenu-8-4'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'post-offices',
                icon: "bank-account",
                text: "Po\u0161te",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/post-offices')
            }, 'submenu-8-5'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'countries',
                icon: "bank-account",
                text: "Dr\u017Eave",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/countries')
            }, 'submenu-8-6'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'warehouses',
                icon: "bank-account",
                text: "Skladi\u0161\u010Da",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/warehouses')
            }, 'submenu-8-7'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'cash-registers',
                icon: "bank-account",
                text: "Blagajna",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/cash-registers')
            }, 'submenu-8-8'),
            access_roles.indexOf('code-tables') === -1 || access_roles.indexOf('code-tables--users') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'users',
                icon: "bank-account",
                text: "Uporabniki",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/users')
            }, 'submenu-8-9'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'reservations',
                icon: "bank-account",
                text: "Rezervacije",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/reservations')
            }, 'submenu-8-10'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'channels',
                icon: "bank-account",
                text: "Prodajni kanali",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/channels')
            }, 'submenu-8-11'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'business-premises',
                icon: "bank-account",
                text: "Poslovni prostor",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/business-premises')
            }, 'submenu-8-12'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'tax-rates',
                icon: "bank-account",
                text: "Dav\u010Dne stopnje",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/tax-rates')
            }, 'submenu-8-13'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'market-segmentation',
                icon: "bank-account",
                text: "Tr\u017Eni segment",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/market-segmentation')
            }, 'submenu-8-14'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'identification-types',
                icon: "bank-account",
                text: "Vrste osebnih dokumentov",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/identification-types')
            }, 'submenu-8-15'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'tourist-taxes',
                icon: "bank-account",
                text: "Turisti\u010Dne takse",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/tourist-taxes')
            }, 'submenu-8-16'),
            access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'code-tables' && path_second_part == 'activities',
                icon: "bank-account",
                text: "Aktivnosti",
                onClick: ()=>(0, _raviger.navigate)('/code-tables/activities')
            }, 'submenu-8-17')
        ],
        'settings': [].concat([
            access_roles.indexOf('settings--general') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'settings' && path_second_part == 'general',
                icon: "floppy-disk",
                text: "Splo\u0161ne nastavitve",
                onClick: ()=>(0, _raviger.navigate)('/settings/general')
            }, 'submenu-9-1'),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'settings' && path_second_part == 'statuses',
                icon: "document",
                text: "Statusi",
                onClick: ()=>(0, _raviger.navigate)('/settings/statuses')
            }, 'submenu-9-2'),
            access_roles.indexOf('settings--reports') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'settings' && path_second_part == 'documents',
                icon: "document",
                text: "Izpisi dokumentov",
                onClick: ()=>(0, _raviger.navigate)('/settings/documents')
            }, 'submenu-9-3'),
            access_roles.indexOf('settings--print') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'settings' && path_second_part == 'print',
                icon: "print",
                text: "Tiskanje",
                onClick: ()=>(0, _raviger.navigate)('/settings/print')
            }, 'submenu-9-6'),
            access_roles.indexOf('settings--parameters') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                minimal: true,
                active: path_first_part == 'settings' && path_second_part == 'parameters',
                icon: "document",
                text: "Parametri",
                onClick: ()=>(0, _raviger.navigate)('/settings/parameters')
            }, 'submenu-9-7')
        ])
    };
    const curr_submenu_items = submenu_items[path_first_part] === undefined ? [] : submenu_items[path_first_part];
    useInitFirstTime(props.api_url, props.token);
    const [changes_web_socket, setChangesWS] = (0, _react.useState)(null);
    const loadInvoicesDebounced = debounce(()=>(0, _business.loadInvoices)(props.api_url, dispatch, props.token), 800);
    const loadLatestInvoiceFiscalVerificationsDebounced = debounce(()=>(0, _business.loadLatestInvoiceFiscalVerifications)(props.api_url, dispatch, props.token), 800);
    const loadAdvanceInvoiceConsumptionsDebounced = debounce(()=>(0, _business.loadAdvanceInvoiceConsumptions)(props.api_url, dispatch, props.token), 800);
    const loadBusinessPremisesDebounced = debounce(()=>(0, _codeTables.loadBusinessPremises)(props.api_url, dispatch, props.token), 800);
    const loadBusinessPremiseFiscalRegistrationsDebounced = debounce(()=>(0, _codeTables.loadBusinessPremiseFiscalRegistrations)(props.api_url, dispatch, props.token), 800);
    const loadReservationsDebounced = debounce(()=>(0, _reservations1.loadReservations)(props.api_url, dispatch, props.token), 800);
    const loadReservationRequestsDebounced = debounce(()=>(0, _reservations1.loadReservationRequests)(props.api_url, dispatch, props.token), 800);
    const loadCashRegisterDailyStatesDebounced = debounce(()=>(0, _cashRegisters1.loadCashRegisterDailyStates)(props.api_url, dispatch, props.token), 800);
    const loadStockAcquisitionDocumentsDebounced = debounce(()=>(0, _warehouses1.loadStockAcquisitionDocuments)(props.api_url, dispatch, props.token), 800);
    const loadDeliveryNotesDebounced = debounce(()=>(0, _warehouses1.loadDeliveryNotes)(props.api_url, dispatch, props.token), 800);
    const loadCustomersDebounced = debounce(()=>(0, _codeTables.loadCustomers)(props.api_url, dispatch, props.token), 800);
    const loadGuestBookItemsDebounced = debounce(()=>(0, _guests.loadGuestBookItems)(props.api_url, dispatch, props.token), 800);
    const loadAccommodationsDebounced = debounce(()=>(0, _codeTables.loadAccommodations)(props.api_url, dispatch, props.token), 800);
    const loadItemsDebounced = debounce(()=>(0, _codeTables.loadItems)(props.api_url, dispatch, props.token), 800);
    (0, _react.useEffect)(()=>{
        const init_ws = ()=>{
            console.log('init changes ws');
            const changes_ws = new WebSocket(props.ws_changes_url);
            changes_ws.onmessage = (event)=>{
                console.log({
                    event
                });
                // handle empty token, which can happen after login
                if (props.token === null) {
                    console.log('Changes WS onMessage, token is null');
                    return;
                }
                const arr = event.data.split(':');
                if (arr.length != 3) return;
                const table_name = arr[0];
                const operation = arr[1];
                const id_item = arr[2].replaceAll('"', '');
                console.log({
                    op: 'change',
                    table_name,
                    operation,
                    id_item
                });
                if (table_name == 'invoices.invoice') {
                    if (operation == 'DELETE') loadInvoicesDebounced();
                    else (0, _business.loadInvoice)(props.api_url, id_item, dispatch, props.token);
                } else if (table_name == 'invoices.invoice_fiscal_verification') {
                    if (operation == 'DELETE') loadLatestInvoiceFiscalVerificationsDebounced();
                    else (0, _business.loadInvoiceFiscalVerification)(props.api_url, id_item, dispatch, props.token);
                } else if (table_name == 'invoices.advance_invoice_consumption') {
                    if (operation == 'DELETE') loadAdvanceInvoiceConsumptionsDebounced();
                    else (0, _business.loadAdvanceInvoiceConsumption)(props.api_url, id_item, dispatch, props.token);
                } else if (table_name == 'code_tables.business_premise') loadBusinessPremisesDebounced();
                else if (table_name == 'code_tables.business_premise_fiscal_registration') loadBusinessPremiseFiscalRegistrationsDebounced();
                else if (table_name == 'reservations.reservation' || table_name == 'reservations.activity_reservation') loadReservationsDebounced();
                else if (table_name == 'reservations.reservation_request') loadReservationRequestsDebounced();
                else if (table_name == 'cash_registers.cash_register_daily_state') {
                    if (operation == 'DELETE') dispatch((0, _cashRegisterSlice.deleteCashRegisterDailyState)(id_item));
                    else loadCashRegisterDailyStatesDebounced();
                } else if (table_name == 'cash_registers.cash_register_document') {
                    if (operation == 'DELETE') ;
                    else (0, _cashRegisters1.loadCashRegisterDocument)(props.api_url, id_item, dispatch, props.token);
                } else if (table_name == 'warehouses.stock_acquisition_document') {
                    if (operation == 'DELETE') loadStockAcquisitionDocumentsDebounced();
                    else (0, _warehouses1.loadStockAcquisitionDocument)(props.api_url, id_item, dispatch, props.token);
                } else if (table_name == 'warehouses.delivery_note') {
                    if (operation == 'DELETE') loadDeliveryNotesDebounced();
                    else (0, _warehouses1.loadDeliveryNote)(props.api_url, id_item, dispatch, props.token);
                } else if (table_name == 'customers.customer') loadCustomersDebounced();
                else if (table_name == 'guests.guest_book' || table_name == 'guests.guest_book_log') {
                    loadGuestBookItemsDebounced();
                    loadReservationsDebounced();
                } else if (table_name == 'accommodations.accommodation_item_place') loadAccommodationsDebounced();
                else if (table_name == 'items.item') {
                    if (operation == 'DELETE') loadItemsDebounced();
                    else (0, _codeTables.loadItem)(props.api_url, id_item, dispatch, props.token);
                }
            };
            changes_ws.onopen = (event)=>{
                if (changes_ws.readyState != WebSocket.OPEN) return;
                changes_ws.send('{ "token": "' + props.token + '", "client": "' + props.client + '", "action": "listen", "data": "" }');
            };
            changes_ws.onclose = (event)=>{
                setTimeout(init_ws, 5000);
            };
            setChangesWS(changes_ws);
        };
        init_ws();
        // cleanup when needed
        return ()=>{
            if (changes_web_socket !== undefined && changes_web_socket !== null) {
                // prevent auto reconnect
                changes_web_socket.onclose = (event)=>{};
                changes_web_socket.close();
            }
        };
    }, [
        props.ws_changes_url,
        props.token
    ]);
    let show_navigation = props.token !== null && props.current_id_cash_register !== null;
    route = props.current_id_cash_register === null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cashRegisterSelectorDefault.default), {}) : route;
    if (props.user !== null && props.user !== undefined && access_roles.indexOf('main') === -1) {
        show_navigation = false;
        route = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col items-center w-full p-10",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: "Dostop zavrnjen"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                    intent: "primary",
                    className: "mt-4",
                    onClick: async ()=>{
                        props.setUser({
                            token: null,
                            user: null
                        });
                    },
                    children: "Prijava"
                })
            ]
        });
    }
    let label_printer_watcher = null;
    if (props.general_settings !== null && props.general_settings.label_printer_enabled) label_printer_watcher = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelPrinterWatcherDefault.default), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBus.Provider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col flex-grow",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConnectedUserStateWatcher, {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventWatcher, {}),
                props.critical_error === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: true,
                    className: "bg-red-700 text-white text-2xl font-thin",
                    style: {
                        width: 600
                    },
                    canOutsideClickClose: false,
                    canEscapeKeyClose: false,
                    isCloseButtonShown: false,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "p-6 pb-3 text-center",
                        children: [
                            "Pri zadnji operaciji je pri\u0161lo do napake!",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            "Osve\u017Eite aplikacijo (Ctrl+R oz. F5 oz. klik na spodnji gumb) in preverite zadnje podatke.",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                large: true,
                                onClick: ()=>window.location.reload(),
                                children: "Osve\u017Ei aplikacijo"
                            })
                        ]
                    })
                }),
                props.token === null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex flex-col flex-grow main-content",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginDefault.default), {})
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(AppLoadBarrier, {
                    content: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _posPrinterWatcherDefault.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _a4PrinterWatcherDefault.default), {}),
                                label_printer_watcher,
                                !show_navigation ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                            fixedToTop: false,
                                            className: "bp5-dark",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Group, {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                                            children: "AssistPRO \u2022 " + (props.client === undefined || props.client === null ? '' : props.client.toUpperCase())
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Divider, {}),
                                                        access_roles.indexOf('dashboard') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            minimal: true,
                                                            active: path == '/',
                                                            icon: "home",
                                                            text: "",
                                                            onClick: ()=>(0, _raviger.navigate)('/')
                                                        }),
                                                        access_roles.indexOf('reservations') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            minimal: true,
                                                            active: path_first_part == 'reservations',
                                                            icon: "document",
                                                            text: "Rezervacije",
                                                            onClick: ()=>(0, _raviger.navigate)('/reservations/accommodation/0')
                                                        }),
                                                        access_roles.indexOf('reservations') === -1 || props.general_settings === null || props.general_settings.feature_flags.reservation_requests !== true ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            minimal: true,
                                                            active: path_first_part == 'reservation-requests',
                                                            icon: "document",
                                                            text: "Povpra\u0161evanja",
                                                            onClick: ()=>(0, _raviger.navigate)('/reservation-requests/list')
                                                        }),
                                                        access_roles.indexOf('business') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            minimal: true,
                                                            active: path_first_part == 'business',
                                                            icon: "bank-account",
                                                            text: "Poslovanje",
                                                            onClick: ()=>(0, _raviger.navigate)(props.current_id_cash_register == 0 ? '/business/invoices' : '/business/cash-invoices')
                                                        }),
                                                        access_roles.indexOf('cash-register') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            minimal: true,
                                                            active: path_first_part == 'cash-register',
                                                            icon: "manually-entered-data",
                                                            text: "Blagajna",
                                                            onClick: ()=>(0, _raviger.navigate)('/cash-register/journal')
                                                        }),
                                                        access_roles.indexOf('stock') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            minimal: true,
                                                            active: path_first_part == 'stock',
                                                            icon: "manually-entered-data",
                                                            text: "Zaloge",
                                                            onClick: ()=>(0, _raviger.navigate)('/stock/acquisition')
                                                        }),
                                                        access_roles.indexOf('etourism') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            minimal: true,
                                                            active: path_first_part == 'etourism',
                                                            icon: "manually-entered-data",
                                                            text: "Poro\u010Danje - eTurizem",
                                                            onClick: ()=>(0, _raviger.navigate)('/etourism/guest-book')
                                                        }),
                                                        access_roles.indexOf('reports') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            minimal: true,
                                                            active: path_first_part == 'reports',
                                                            icon: "manually-entered-data",
                                                            text: "Poro\u010Dila",
                                                            onClick: ()=>(0, _raviger.navigate)('/reports/items-and-services')
                                                        }),
                                                        access_roles.indexOf('code-tables') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            minimal: true,
                                                            active: path_first_part == 'code-tables',
                                                            icon: "manually-entered-data",
                                                            text: "\u0160ifranti",
                                                            onClick: ()=>(0, _raviger.navigate)('/code-tables/customers')
                                                        }),
                                                        access_roles.indexOf('settings') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            minimal: true,
                                                            active: path_first_part == 'settings',
                                                            icon: "manually-entered-data",
                                                            text: "Nastavitve",
                                                            onClick: ()=>(0, _raviger.navigate)('/settings/general')
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Group, {
                                                    align: (0, _core.Alignment).RIGHT,
                                                    children: [
                                                        props.pos_printer_queue.length + props.a4_printer_queue.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "mr-4",
                                                            style: {
                                                                position: 'relative',
                                                                width: 60,
                                                                height: 29
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    style: {
                                                                        position: 'absolute',
                                                                        bottom: 0,
                                                                        left: 0,
                                                                        right: 0,
                                                                        top: 0
                                                                    },
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "bp5-progress-bar bp5-intent-primary",
                                                                        style: {
                                                                            height: '100%'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "bp5-progress-meter"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    style: {
                                                                        position: 'absolute',
                                                                        bottom: 0,
                                                                        left: 25,
                                                                        right: 3,
                                                                        top: 7,
                                                                        textAlign: 'center'
                                                                    },
                                                                    children: props.pos_printer_queue.length + props.a4_printer_queue.length
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    style: {
                                                                        position: 'absolute',
                                                                        left: 7,
                                                                        top: 5
                                                                    },
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                                        icon: "print",
                                                                        iconSize: 20
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        ((0, _jsCookieDefault.default).get('force_retention_years') ?? '') == '' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mr-4 text-red-500",
                                                            children: "PRIKAZANI VSI PODATKI"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            style: {
                                                                position: 'relative'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                                    icon: "notifications"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    style: {
                                                                        position: 'absolute',
                                                                        fontSize: 12,
                                                                        right: -4,
                                                                        top: -8,
                                                                        color: '#00E676'
                                                                    },
                                                                    children: null
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ml-4",
                                                            children: props.user === null || props.user === undefined ? null : props.user.name + (props.user.surname === undefined || props.user.surname.length == 0 ? '' : ' ' + props.user.surname.substring(0, 1))
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            className: "ml-4 change-register-button",
                                                            onClick: async ()=>{
                                                                props.setCurrentIdCashRegister({
                                                                    current_id_cash_register: null
                                                                });
                                                                (0, _localStorageHelperDefault.default).SetValue(props.client + '__current_id_cash_register', null);
                                                            },
                                                            children: props.current_id_cash_register == 0 || props.cash_registers[props.current_id_cash_register] === undefined ? '-' : props.cash_registers[props.current_id_cash_register].internal_code
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            intent: "primary",
                                                            className: "ml-4",
                                                            onClick: async ()=>{
                                                                props.setUser({
                                                                    token: null,
                                                                    user: null
                                                                });
                                                                (0, _raviger.navigate)('/');
                                                            },
                                                            children: "Odjava"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        curr_submenu_items.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar), {
                                            fixedToTop: false,
                                            className: "auto",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                                children: curr_submenu_items
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-col flex-grow main-content",
                                    children: route
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editInvoiceDialogHelper.EditInvoiceDialogHelperComponent), {
                                    invoice_dialog_open: invoice_dialog_open,
                                    closeInvoiceDialog: closeInvoiceDialog,
                                    invoice_dialog_item: invoice_dialog_item,
                                    invoice_dialog_type: invoice_dialog_type,
                                    invoice_dialog_advance_invoices_amounts: invoice_dialog_advance_invoices_amounts,
                                    wait_fiscal_verification_dialog_id_invoice: wait_fiscal_verification_dialog_id_invoice,
                                    invoices: props.invoices,
                                    general_settings: props.general_settings,
                                    dispatch: dispatch,
                                    setWaitFiscalVerificationDialogIdInvoice: setWaitFiscalVerificationDialogIdInvoice
                                })
                            ]
                        })
                })
            ]
        })
    });
}
function mapStateToProps(state) {
    return {
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        api_url: state.ConstantsSlice.api_url,
        ws_changes_url: state.ConstantsSlice.ws_changes_url,
        client: state.ConstantsSlice.client,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        general_settings: state.SettingsSlice.general,
        cash_registers: state.CashRegisterSlice.cash_registers,
        pos_printer_queue: state.AppSlice.pos_printer_queue,
        a4_printer_queue: state.AppSlice.a4_printer_queue,
        critical_error: state.AppSlice.critical_error,
        document_types: state.DocumentSlice.document_types,
        invoices: state.BusinessSlice.invoices
    };
}
function mapDispatchToProps(dispatch) {
    return {
        setUser: (data)=>{
            dispatch((0, _userSlice.setUser)(data));
        },
        setCurrentIdCashRegister: (data)=>{
            dispatch((0, _settingsSlice.setCurrentIdCashRegister)(data));
        }
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","react-bus":"azSKq","uuid":"b52pV","@blueprintjs/core":"6Mq52","raviger":"knnT1","tinycolor2":"4AVaN","moment":"1e4qG","js-cookie":"2d7Fe","./components/Login":"8RKt0","./components/CashRegisterSelector":"bdIxi","./components/reservations/Reservations":"8MvmD","./components/dashboard/Dashboard":"f3krn","./components/code_tables/Countries":"i8GW2","./components/code_tables/MeasuringUnits":"g9R6b","./components/code_tables/PaymentTypes":"8XhRw","./components/code_tables/PostOffices":"72AIt","./components/code_tables/Warehouses":"qWzAp","./components/code_tables/CashRegisters":"cMjQs","./components/code_tables/Channels":"1bO6f","./components/code_tables/TaxRates":"ffdTv","./components/code_tables/BusinessPremises":"2RD0p","./components/code_tables/Customers":"cnpWa","./components/code_tables/Items":"jpSHb","./components/code_tables/MarketSegmentation":"4LGr9","./components/code_tables/IdentificationTypes":"h4jEN","./components/code_tables/TouristTaxes":"9PDJk","./components/code_tables/Activities":"2wx2I","./components/code_tables/Users":"abacm","./components/business/Invoices":"67EhN","./components/business/BusinessInvoices":"dsp7f","./components/business/Offers":"hOUjD","./components/business/SalesInvoiceBookItems":"lTOaW","./components/business/PrepaymentBookItems":"3Wn7j","./components/etourism/GuestBook":"avBi4","./components/etourism/MonthlyGuestBookReports":"dzqJD","./components/etourism/TouristTaxes":"cBLJ4","./components/reservations/ReservationList":"krMZM","./components/reservations/ActivitiesList":"eAUIs","./components/settings/GeneralSettings":"cS8Ej","./components/settings/StatusSettings":"fTMNn","./components/settings/PrintSettings":"6rYmF","./components/settings/DocumentSettings":"dSAhz","./components/settings/ParameterSettings":"10r98","./components/cash_registers/Journals":"jW4K8","./components/cash_registers/CashRegisterDocuments":"livgl","./components/stock/StockAcquisitionDocuments":"hGtgc","./components/stock/DeliveryNotes":"1wmZH","./components/stock/StockInventory":"l0cLh","./components/reports/ItemsAndServices":"4jVwT","./components/reports/ActivityReservations":"bM41S","./components/reports/ReservationsReport":"57O8F","./components/AppToaster":"izixN","./components/PosPrinterWatcher":"e91Vn","./components/A4PrinterWatcher":"4Z4Ol","./components/LabelPrinterWatcher":"e9soj","./components/HealthLog":"4w2Vj","./components/reservation_requests/ReservationRequestsList":"imQtD","./slices/SettingsSlice":"ajHkF","./api/CodeTables":"4GMYC","./api/Reservations":"8B3n3","./api/Business":"fC7Hd","./api/Users":"keHdn","./api/Documents":"hSEi5","./api/Guests":"8327Q","./api/CashRegisters":"ixrrZ","./api/Settings":"51MNf","./api/Warehouses":"WVdXb","./slices/UserSlice":"ikKoo","./slices/CashRegisterSlice":"1FTf7","./components/EditInvoiceDialogHelper":"jDyVS","./helpers/LocalStorageHelper":"9I9tm","./slices/DocumentSlice":"6gdAm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"azSKq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BusContext", ()=>BusContext);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "useBus", ()=>useBus);
parcelHelpers.export(exports, "useListener", ()=>useListener);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mitt = require("mitt");
var _mittDefault = parcelHelpers.interopDefault(_mitt);
var BusContext = (0, _reactDefault.default).createContext(null);
var P = BusContext.Provider;
function useBus() {
    return (0, _reactDefault.default).useContext(BusContext);
}
function useListener(name, fn) {
    var bus = useBus();
    (0, _reactDefault.default).useEffect(function() {
        bus.on(name, fn);
        return function() {
            bus.off(name, fn);
        };
    }, [
        bus,
        name,
        fn
    ]);
}
function Provider(ref) {
    var children = ref.children;
    var ref$1 = (0, _reactDefault.default).useState(function() {
        return (0, _mittDefault.default)();
    });
    var bus = ref$1[0];
    return (0, _reactDefault.default).createElement(P, {
        value: bus
    }, children);
}

},{"react":"9njXz","mitt":"9BXQ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9BXQ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(n) {
        return {
            all: n = n || new Map,
            on: function(t, e) {
                var i = n.get(t);
                i && i.push(e) || n.set(t, [
                    e
                ]);
            },
            off: function(t, e) {
                var i = n.get(t);
                i && i.splice(i.indexOf(e) >>> 0, 1);
            },
            emit: function(t, e) {
                (n.get(t) || []).slice().map(function(n) {
                    n(e);
                }), (n.get("*") || []).slice().map(function(n) {
                    n(t, e);
                });
            }
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Mq52":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusStyleManager", ()=>(0, _focusStyleManager.FocusStyleManager));
parcelHelpers.export(exports, "HotkeysTarget", ()=>(0, _hotkeysTargetLegacy.HotkeysTargetLegacy));
parcelHelpers.export(exports, "isHotkeysDialogShowing", ()=>(0, _hotkeysDialogLegacy.isHotkeysDialogShowing));
parcelHelpers.export(exports, "setHotkeysDialogProps", ()=>(0, _hotkeysDialogLegacy.setHotkeysDialogProps));
parcelHelpers.export(exports, "showHotkeysDialog", ()=>(0, _hotkeysDialogLegacy.showHotkeysDialog));
parcelHelpers.export(exports, "hideHotkeysDialog", ()=>(0, _hotkeysDialogLegacy.hideHotkeysDialog));
parcelHelpers.export(exports, "hideHotkeysDialogAfterDelay", ()=>(0, _hotkeysDialogLegacy.hideHotkeysDialogAfterDelay));
parcelHelpers.export(exports, "ContextMenuTargetLegacy", ()=>(0, _contextMenuTargetLegacy.ContextMenuTargetLegacy));
var _focusStyleManager = require("./accessibility/focusStyleManager");
var _common = require("./common");
parcelHelpers.exportAll(_common, exports);
var _components = require("./components");
parcelHelpers.exportAll(_components, exports);
var _context = require("./context");
parcelHelpers.exportAll(_context, exports);
var _hooks = require("./hooks");
parcelHelpers.exportAll(_hooks, exports);
/* eslint-disable deprecation/deprecation */ var _deprecatedTypeAliases = require("./deprecatedTypeAliases");
parcelHelpers.exportAll(_deprecatedTypeAliases, exports);
var _hotkeysTargetLegacy = require("./legacy/hotkeysTargetLegacy");
var _hotkeysDialogLegacy = require("./legacy/hotkeysDialogLegacy");
var _contextMenuTargetLegacy = require("./legacy/contextMenuTargetLegacy");

},{"./accessibility/focusStyleManager":"8H9C3","./common":"3QDnh","./components":"6Av90","./context":"TFWBE","./hooks":"fCH16","./deprecatedTypeAliases":"5T3u5","./legacy/hotkeysTargetLegacy":"9IlGS","./legacy/hotkeysDialogLegacy":"gsHhS","./legacy/contextMenuTargetLegacy":"lpIlT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8H9C3":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusStyleManager", ()=>FocusStyleManager);
var _classes = require("../common/classes");
var _interactionMode = require("../common/interactionMode");
var fakeFocusEngine = {
    isActive: function() {
        return true;
    },
    start: function() {
        return true;
    },
    stop: function() {
        return true;
    }
};
var focusEngine = typeof document !== "undefined" ? new (0, _interactionMode.InteractionModeEngine)(document.documentElement, (0, _classes.FOCUS_DISABLED)) : fakeFocusEngine;
var FocusStyleManager = {
    alwaysShowFocus: function() {
        return focusEngine.stop();
    },
    isActive: function() {
        return focusEngine.isActive();
    },
    onlyShowFocusOnTabs: function() {
        return focusEngine.start();
    }
};

},{"../common/classes":"2PICA","../common/interactionMode":"dJ36n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2PICA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACTIVE", ()=>ACTIVE);
parcelHelpers.export(exports, "ALIGN_LEFT", ()=>ALIGN_LEFT);
parcelHelpers.export(exports, "ALIGN_RIGHT", ()=>ALIGN_RIGHT);
parcelHelpers.export(exports, "COMPACT", ()=>COMPACT);
parcelHelpers.export(exports, "DARK", ()=>DARK);
parcelHelpers.export(exports, "DISABLED", ()=>DISABLED);
parcelHelpers.export(exports, "FILL", ()=>FILL);
parcelHelpers.export(exports, "FIXED", ()=>FIXED);
parcelHelpers.export(exports, "FIXED_TOP", ()=>FIXED_TOP);
parcelHelpers.export(exports, "INLINE", ()=>INLINE);
parcelHelpers.export(exports, "INTERACTIVE", ()=>INTERACTIVE);
parcelHelpers.export(exports, "LARGE", ()=>LARGE);
parcelHelpers.export(exports, "LOADING", ()=>LOADING);
parcelHelpers.export(exports, "MINIMAL", ()=>MINIMAL);
parcelHelpers.export(exports, "OUTLINED", ()=>OUTLINED);
parcelHelpers.export(exports, "PADDED", ()=>PADDED);
parcelHelpers.export(exports, "MULTILINE", ()=>MULTILINE);
parcelHelpers.export(exports, "READ_ONLY", ()=>READ_ONLY);
parcelHelpers.export(exports, "ROUND", ()=>ROUND);
parcelHelpers.export(exports, "SELECTED", ()=>SELECTED);
parcelHelpers.export(exports, "SMALL", ()=>SMALL);
parcelHelpers.export(exports, "VERTICAL", ()=>VERTICAL);
parcelHelpers.export(exports, "POSITION_TOP", ()=>POSITION_TOP);
parcelHelpers.export(exports, "POSITION_BOTTOM", ()=>POSITION_BOTTOM);
parcelHelpers.export(exports, "POSITION_LEFT", ()=>POSITION_LEFT);
parcelHelpers.export(exports, "POSITION_RIGHT", ()=>POSITION_RIGHT);
parcelHelpers.export(exports, "ELEVATION_0", ()=>ELEVATION_0);
parcelHelpers.export(exports, "ELEVATION_1", ()=>ELEVATION_1);
parcelHelpers.export(exports, "ELEVATION_2", ()=>ELEVATION_2);
parcelHelpers.export(exports, "ELEVATION_3", ()=>ELEVATION_3);
parcelHelpers.export(exports, "ELEVATION_4", ()=>ELEVATION_4);
parcelHelpers.export(exports, "INTENT_PRIMARY", ()=>INTENT_PRIMARY);
parcelHelpers.export(exports, "INTENT_SUCCESS", ()=>INTENT_SUCCESS);
parcelHelpers.export(exports, "INTENT_WARNING", ()=>INTENT_WARNING);
parcelHelpers.export(exports, "INTENT_DANGER", ()=>INTENT_DANGER);
parcelHelpers.export(exports, "FOCUS_DISABLED", ()=>FOCUS_DISABLED);
parcelHelpers.export(exports, "FOCUS_STYLE_MANAGER_IGNORE", ()=>FOCUS_STYLE_MANAGER_IGNORE);
parcelHelpers.export(exports, "UI_TEXT", ()=>UI_TEXT);
parcelHelpers.export(exports, "RUNNING_TEXT", ()=>RUNNING_TEXT);
parcelHelpers.export(exports, "MONOSPACE_TEXT", ()=>MONOSPACE_TEXT);
parcelHelpers.export(exports, "TEXT_LARGE", ()=>TEXT_LARGE);
parcelHelpers.export(exports, "TEXT_SMALL", ()=>TEXT_SMALL);
parcelHelpers.export(exports, "TEXT_MUTED", ()=>TEXT_MUTED);
parcelHelpers.export(exports, "TEXT_DISABLED", ()=>TEXT_DISABLED);
parcelHelpers.export(exports, "TEXT_OVERFLOW_ELLIPSIS", ()=>TEXT_OVERFLOW_ELLIPSIS);
parcelHelpers.export(exports, "BLOCKQUOTE", ()=>BLOCKQUOTE);
parcelHelpers.export(exports, "CODE", ()=>CODE);
parcelHelpers.export(exports, "CODE_BLOCK", ()=>CODE_BLOCK);
parcelHelpers.export(exports, "HEADING", ()=>HEADING);
parcelHelpers.export(exports, "LIST", ()=>LIST);
parcelHelpers.export(exports, "LIST_UNSTYLED", ()=>LIST_UNSTYLED);
parcelHelpers.export(exports, "RTL", ()=>RTL);
parcelHelpers.export(exports, "ALERT", ()=>ALERT);
parcelHelpers.export(exports, "ALERT_BODY", ()=>ALERT_BODY);
parcelHelpers.export(exports, "ALERT_CONTENTS", ()=>ALERT_CONTENTS);
parcelHelpers.export(exports, "ALERT_FOOTER", ()=>ALERT_FOOTER);
parcelHelpers.export(exports, "BREADCRUMB", ()=>BREADCRUMB);
parcelHelpers.export(exports, "BREADCRUMB_CURRENT", ()=>BREADCRUMB_CURRENT);
parcelHelpers.export(exports, "BREADCRUMBS", ()=>BREADCRUMBS);
parcelHelpers.export(exports, "BREADCRUMBS_COLLAPSED", ()=>BREADCRUMBS_COLLAPSED);
parcelHelpers.export(exports, "BUTTON", ()=>BUTTON);
parcelHelpers.export(exports, "BUTTON_GROUP", ()=>BUTTON_GROUP);
parcelHelpers.export(exports, "BUTTON_SPINNER", ()=>BUTTON_SPINNER);
parcelHelpers.export(exports, "BUTTON_TEXT", ()=>BUTTON_TEXT);
parcelHelpers.export(exports, "CALLOUT", ()=>CALLOUT);
parcelHelpers.export(exports, "CALLOUT_HAS_BODY_CONTENT", ()=>CALLOUT_HAS_BODY_CONTENT);
parcelHelpers.export(exports, "CALLOUT_ICON", ()=>CALLOUT_ICON);
parcelHelpers.export(exports, "CARD", ()=>CARD);
parcelHelpers.export(exports, "CONTROL_CARD", ()=>CONTROL_CARD);
parcelHelpers.export(exports, "CONTROL_CARD_LABEL", ()=>CONTROL_CARD_LABEL);
parcelHelpers.export(exports, "SWITCH_CONTROL_CARD", ()=>SWITCH_CONTROL_CARD);
parcelHelpers.export(exports, "CHECKBOX_CONTROL_CARD", ()=>CHECKBOX_CONTROL_CARD);
parcelHelpers.export(exports, "RADIO_CONTROL_CARD", ()=>RADIO_CONTROL_CARD);
parcelHelpers.export(exports, "CARD_LIST", ()=>CARD_LIST);
parcelHelpers.export(exports, "CARD_LIST_BORDERED", ()=>CARD_LIST_BORDERED);
parcelHelpers.export(exports, "COLLAPSE", ()=>COLLAPSE);
parcelHelpers.export(exports, "COLLAPSE_BODY", ()=>COLLAPSE_BODY);
parcelHelpers.export(exports, "CONTEXT_MENU", ()=>CONTEXT_MENU);
parcelHelpers.export(exports, "CONTEXT_MENU_VIRTUAL_TARGET", ()=>CONTEXT_MENU_VIRTUAL_TARGET);
parcelHelpers.export(exports, "CONTEXT_MENU_POPOVER", ()=>CONTEXT_MENU_POPOVER);
parcelHelpers.export(exports, "CONTEXT_MENU_BACKDROP", ()=>CONTEXT_MENU_BACKDROP);
parcelHelpers.export(exports, "CONTROL_GROUP", ()=>CONTROL_GROUP);
parcelHelpers.export(exports, "DIALOG", ()=>DIALOG);
parcelHelpers.export(exports, "DIALOG_CONTAINER", ()=>DIALOG_CONTAINER);
parcelHelpers.export(exports, "DIALOG_HEADER", ()=>DIALOG_HEADER);
parcelHelpers.export(exports, "DIALOG_BODY", ()=>DIALOG_BODY);
parcelHelpers.export(exports, "DIALOG_BODY_SCROLL_CONTAINER", ()=>DIALOG_BODY_SCROLL_CONTAINER);
parcelHelpers.export(exports, "DIALOG_CLOSE_BUTTON", ()=>DIALOG_CLOSE_BUTTON);
parcelHelpers.export(exports, "DIALOG_FOOTER", ()=>DIALOG_FOOTER);
parcelHelpers.export(exports, "DIALOG_FOOTER_FIXED", ()=>DIALOG_FOOTER_FIXED);
parcelHelpers.export(exports, "DIALOG_FOOTER_MAIN_SECTION", ()=>DIALOG_FOOTER_MAIN_SECTION);
parcelHelpers.export(exports, "DIALOG_FOOTER_ACTIONS", ()=>DIALOG_FOOTER_ACTIONS);
parcelHelpers.export(exports, "DIALOG_STEP", ()=>DIALOG_STEP);
parcelHelpers.export(exports, "DIALOG_STEP_CONTAINER", ()=>DIALOG_STEP_CONTAINER);
parcelHelpers.export(exports, "DIALOG_STEP_TITLE", ()=>DIALOG_STEP_TITLE);
parcelHelpers.export(exports, "DIALOG_STEP_ICON", ()=>DIALOG_STEP_ICON);
parcelHelpers.export(exports, "DIALOG_STEP_VIEWED", ()=>DIALOG_STEP_VIEWED);
parcelHelpers.export(exports, "DIVIDER", ()=>DIVIDER);
parcelHelpers.export(exports, "DRAWER", ()=>DRAWER);
parcelHelpers.export(exports, "DRAWER_BODY", ()=>DRAWER_BODY);
parcelHelpers.export(exports, "DRAWER_FOOTER", ()=>DRAWER_FOOTER);
parcelHelpers.export(exports, "DRAWER_HEADER", ()=>DRAWER_HEADER);
parcelHelpers.export(exports, "EDITABLE_TEXT", ()=>EDITABLE_TEXT);
parcelHelpers.export(exports, "EDITABLE_TEXT_CONTENT", ()=>EDITABLE_TEXT_CONTENT);
parcelHelpers.export(exports, "EDITABLE_TEXT_EDITING", ()=>EDITABLE_TEXT_EDITING);
parcelHelpers.export(exports, "EDITABLE_TEXT_INPUT", ()=>EDITABLE_TEXT_INPUT);
parcelHelpers.export(exports, "EDITABLE_TEXT_PLACEHOLDER", ()=>EDITABLE_TEXT_PLACEHOLDER);
parcelHelpers.export(exports, "ENTITY_TITLE", ()=>ENTITY_TITLE);
parcelHelpers.export(exports, "ENTITY_TITLE_ELLIPSIZE", ()=>ENTITY_TITLE_ELLIPSIZE);
parcelHelpers.export(exports, "ENTITY_TITLE_HAS_SUBTITLE", ()=>ENTITY_TITLE_HAS_SUBTITLE);
parcelHelpers.export(exports, "ENTITY_TITLE_ICON_CONTAINER", ()=>ENTITY_TITLE_ICON_CONTAINER);
parcelHelpers.export(exports, "ENTITY_TITLE_SUBTITLE", ()=>ENTITY_TITLE_SUBTITLE);
parcelHelpers.export(exports, "ENTITY_TITLE_TAGS_CONTAINER", ()=>ENTITY_TITLE_TAGS_CONTAINER);
parcelHelpers.export(exports, "ENTITY_TITLE_TEXT", ()=>ENTITY_TITLE_TEXT);
parcelHelpers.export(exports, "ENTITY_TITLE_TITLE", ()=>ENTITY_TITLE_TITLE);
parcelHelpers.export(exports, "ENTITY_TITLE_TITLE_AND_TAGS", ()=>ENTITY_TITLE_TITLE_AND_TAGS);
parcelHelpers.export(exports, "FLEX_EXPANDER", ()=>FLEX_EXPANDER);
parcelHelpers.export(exports, "HTML_SELECT", ()=>HTML_SELECT);
parcelHelpers.export(exports, "SELECT", ()=>SELECT);
parcelHelpers.export(exports, "HTML_TABLE", ()=>HTML_TABLE);
parcelHelpers.export(exports, "HTML_TABLE_BORDERED", ()=>HTML_TABLE_BORDERED);
parcelHelpers.export(exports, "HTML_TABLE_STRIPED", ()=>HTML_TABLE_STRIPED);
parcelHelpers.export(exports, "INPUT", ()=>INPUT);
parcelHelpers.export(exports, "INPUT_GHOST", ()=>INPUT_GHOST);
parcelHelpers.export(exports, "INPUT_GROUP", ()=>INPUT_GROUP);
parcelHelpers.export(exports, "INPUT_LEFT_CONTAINER", ()=>INPUT_LEFT_CONTAINER);
parcelHelpers.export(exports, "INPUT_ACTION", ()=>INPUT_ACTION);
parcelHelpers.export(exports, "RESIZABLE_INPUT_SPAN", ()=>RESIZABLE_INPUT_SPAN);
parcelHelpers.export(exports, "TEXT_AREA", ()=>TEXT_AREA);
parcelHelpers.export(exports, "TEXT_AREA_AUTO_RESIZE", ()=>TEXT_AREA_AUTO_RESIZE);
parcelHelpers.export(exports, "CONTROL", ()=>CONTROL);
parcelHelpers.export(exports, "CONTROL_INDICATOR", ()=>CONTROL_INDICATOR);
parcelHelpers.export(exports, "CONTROL_INDICATOR_CHILD", ()=>CONTROL_INDICATOR_CHILD);
parcelHelpers.export(exports, "CHECKBOX", ()=>CHECKBOX);
parcelHelpers.export(exports, "RADIO", ()=>RADIO);
parcelHelpers.export(exports, "RADIO_GROUP", ()=>RADIO_GROUP);
parcelHelpers.export(exports, "SWITCH", ()=>SWITCH);
parcelHelpers.export(exports, "SWITCH_INNER_TEXT", ()=>SWITCH_INNER_TEXT);
parcelHelpers.export(exports, "FILE_INPUT", ()=>FILE_INPUT);
parcelHelpers.export(exports, "FILE_INPUT_HAS_SELECTION", ()=>FILE_INPUT_HAS_SELECTION);
parcelHelpers.export(exports, "FILE_UPLOAD_INPUT", ()=>FILE_UPLOAD_INPUT);
parcelHelpers.export(exports, "FILE_UPLOAD_INPUT_CUSTOM_TEXT", ()=>FILE_UPLOAD_INPUT_CUSTOM_TEXT);
parcelHelpers.export(exports, "KEY", ()=>KEY);
parcelHelpers.export(exports, "KEY_COMBO", ()=>KEY_COMBO);
parcelHelpers.export(exports, "MODIFIER_KEY", ()=>MODIFIER_KEY);
parcelHelpers.export(exports, "HOTKEY", ()=>HOTKEY);
parcelHelpers.export(exports, "HOTKEY_LABEL", ()=>HOTKEY_LABEL);
parcelHelpers.export(exports, "HOTKEY_COLUMN", ()=>HOTKEY_COLUMN);
parcelHelpers.export(exports, "HOTKEY_DIALOG", ()=>HOTKEY_DIALOG);
parcelHelpers.export(exports, "LABEL", ()=>LABEL);
parcelHelpers.export(exports, "FORM_GROUP", ()=>FORM_GROUP);
parcelHelpers.export(exports, "FORM_CONTENT", ()=>FORM_CONTENT);
parcelHelpers.export(exports, "FORM_HELPER_TEXT", ()=>FORM_HELPER_TEXT);
parcelHelpers.export(exports, "FORM_GROUP_SUB_LABEL", ()=>FORM_GROUP_SUB_LABEL);
parcelHelpers.export(exports, "MENU", ()=>MENU);
parcelHelpers.export(exports, "MENU_ITEM", ()=>MENU_ITEM);
parcelHelpers.export(exports, "MENU_ITEM_IS_SELECTABLE", ()=>MENU_ITEM_IS_SELECTABLE);
parcelHelpers.export(exports, "MENU_ITEM_SELECTED_ICON", ()=>MENU_ITEM_SELECTED_ICON);
parcelHelpers.export(exports, "MENU_ITEM_ICON", ()=>MENU_ITEM_ICON);
parcelHelpers.export(exports, "MENU_ITEM_LABEL", ()=>MENU_ITEM_LABEL);
parcelHelpers.export(exports, "MENU_SUBMENU", ()=>MENU_SUBMENU);
parcelHelpers.export(exports, "MENU_SUBMENU_ICON", ()=>MENU_SUBMENU_ICON);
parcelHelpers.export(exports, "MENU_DIVIDER", ()=>MENU_DIVIDER);
parcelHelpers.export(exports, "MENU_HEADER", ()=>MENU_HEADER);
parcelHelpers.export(exports, "MULTISTEP_DIALOG", ()=>MULTISTEP_DIALOG);
parcelHelpers.export(exports, "MULTISTEP_DIALOG_PANELS", ()=>MULTISTEP_DIALOG_PANELS);
parcelHelpers.export(exports, "MULTISTEP_DIALOG_LEFT_PANEL", ()=>MULTISTEP_DIALOG_LEFT_PANEL);
parcelHelpers.export(exports, "MULTISTEP_DIALOG_RIGHT_PANEL", ()=>MULTISTEP_DIALOG_RIGHT_PANEL);
parcelHelpers.export(exports, "MULTISTEP_DIALOG_NAV_TOP", ()=>MULTISTEP_DIALOG_NAV_TOP);
parcelHelpers.export(exports, "MULTISTEP_DIALOG_NAV_RIGHT", ()=>MULTISTEP_DIALOG_NAV_RIGHT);
parcelHelpers.export(exports, "SECTION", ()=>SECTION);
parcelHelpers.export(exports, "SECTION_COLLAPSED", ()=>SECTION_COLLAPSED);
parcelHelpers.export(exports, "SECTION_HEADER", ()=>SECTION_HEADER);
parcelHelpers.export(exports, "SECTION_HEADER_LEFT", ()=>SECTION_HEADER_LEFT);
parcelHelpers.export(exports, "SECTION_HEADER_TITLE", ()=>SECTION_HEADER_TITLE);
parcelHelpers.export(exports, "SECTION_HEADER_SUB_TITLE", ()=>SECTION_HEADER_SUB_TITLE);
parcelHelpers.export(exports, "SECTION_HEADER_DIVIDER", ()=>SECTION_HEADER_DIVIDER);
parcelHelpers.export(exports, "SECTION_HEADER_TABS", ()=>SECTION_HEADER_TABS);
parcelHelpers.export(exports, "SECTION_HEADER_RIGHT", ()=>SECTION_HEADER_RIGHT);
parcelHelpers.export(exports, "SECTION_CARD", ()=>SECTION_CARD);
parcelHelpers.export(exports, "NAVBAR", ()=>NAVBAR);
parcelHelpers.export(exports, "NAVBAR_GROUP", ()=>NAVBAR_GROUP);
parcelHelpers.export(exports, "NAVBAR_HEADING", ()=>NAVBAR_HEADING);
parcelHelpers.export(exports, "NAVBAR_DIVIDER", ()=>NAVBAR_DIVIDER);
parcelHelpers.export(exports, "NON_IDEAL_STATE", ()=>NON_IDEAL_STATE);
parcelHelpers.export(exports, "NON_IDEAL_STATE_VISUAL", ()=>NON_IDEAL_STATE_VISUAL);
parcelHelpers.export(exports, "NON_IDEAL_STATE_TEXT", ()=>NON_IDEAL_STATE_TEXT);
parcelHelpers.export(exports, "NUMERIC_INPUT", ()=>NUMERIC_INPUT);
parcelHelpers.export(exports, "OVERFLOW_LIST", ()=>OVERFLOW_LIST);
parcelHelpers.export(exports, "OVERFLOW_LIST_SPACER", ()=>OVERFLOW_LIST_SPACER);
parcelHelpers.export(exports, "OVERLAY", ()=>OVERLAY);
parcelHelpers.export(exports, "OVERLAY_BACKDROP", ()=>OVERLAY_BACKDROP);
parcelHelpers.export(exports, "OVERLAY_CONTAINER", ()=>OVERLAY_CONTAINER);
parcelHelpers.export(exports, "OVERLAY_CONTENT", ()=>OVERLAY_CONTENT);
parcelHelpers.export(exports, "OVERLAY_INLINE", ()=>OVERLAY_INLINE);
parcelHelpers.export(exports, "OVERLAY_OPEN", ()=>OVERLAY_OPEN);
parcelHelpers.export(exports, "OVERLAY_SCROLL_CONTAINER", ()=>OVERLAY_SCROLL_CONTAINER);
parcelHelpers.export(exports, "OVERLAY_START_FOCUS_TRAP", ()=>OVERLAY_START_FOCUS_TRAP);
parcelHelpers.export(exports, "OVERLAY_END_FOCUS_TRAP", ()=>OVERLAY_END_FOCUS_TRAP);
parcelHelpers.export(exports, "PANEL_STACK", ()=>PANEL_STACK);
parcelHelpers.export(exports, "PANEL_STACK_HEADER", ()=>PANEL_STACK_HEADER);
parcelHelpers.export(exports, "PANEL_STACK_HEADER_BACK", ()=>PANEL_STACK_HEADER_BACK);
parcelHelpers.export(exports, "PANEL_STACK_VIEW", ()=>PANEL_STACK_VIEW);
parcelHelpers.export(exports, "PANEL_STACK2", ()=>PANEL_STACK2);
parcelHelpers.export(exports, "PANEL_STACK2_HEADER", ()=>PANEL_STACK2_HEADER);
parcelHelpers.export(exports, "PANEL_STACK2_HEADER_BACK", ()=>PANEL_STACK2_HEADER_BACK);
parcelHelpers.export(exports, "PANEL_STACK2_VIEW", ()=>PANEL_STACK2_VIEW);
parcelHelpers.export(exports, "POPOVER", ()=>POPOVER);
parcelHelpers.export(exports, "POPOVER_ARROW", ()=>POPOVER_ARROW);
parcelHelpers.export(exports, "POPOVER_BACKDROP", ()=>POPOVER_BACKDROP);
parcelHelpers.export(exports, "POPOVER_CAPTURING_DISMISS", ()=>POPOVER_CAPTURING_DISMISS);
parcelHelpers.export(exports, "POPOVER_CONTENT", ()=>POPOVER_CONTENT);
parcelHelpers.export(exports, "POPOVER_CONTENT_PLACEMENT", ()=>POPOVER_CONTENT_PLACEMENT);
parcelHelpers.export(exports, "POPOVER_CONTENT_SIZING", ()=>POPOVER_CONTENT_SIZING);
parcelHelpers.export(exports, "POPOVER_DISMISS", ()=>POPOVER_DISMISS);
parcelHelpers.export(exports, "POPOVER_DISMISS_OVERRIDE", ()=>POPOVER_DISMISS_OVERRIDE);
parcelHelpers.export(exports, "POPOVER_MATCH_TARGET_WIDTH", ()=>POPOVER_MATCH_TARGET_WIDTH);
parcelHelpers.export(exports, "POPOVER_OPEN", ()=>POPOVER_OPEN);
parcelHelpers.export(exports, "POPOVER_POPPER_ESCAPED", ()=>POPOVER_POPPER_ESCAPED);
parcelHelpers.export(exports, "POPOVER_REFERENCE_HIDDEN", ()=>POPOVER_REFERENCE_HIDDEN);
parcelHelpers.export(exports, "POPOVER_TARGET", ()=>POPOVER_TARGET);
parcelHelpers.export(exports, "POPOVER_TRANSITION_CONTAINER", ()=>POPOVER_TRANSITION_CONTAINER);
parcelHelpers.export(exports, "POPOVER_WRAPPER", ()=>POPOVER_WRAPPER);
parcelHelpers.export(exports, "PROGRESS_BAR", ()=>PROGRESS_BAR);
parcelHelpers.export(exports, "PROGRESS_METER", ()=>PROGRESS_METER);
parcelHelpers.export(exports, "PROGRESS_NO_STRIPES", ()=>PROGRESS_NO_STRIPES);
parcelHelpers.export(exports, "PROGRESS_NO_ANIMATION", ()=>PROGRESS_NO_ANIMATION);
parcelHelpers.export(exports, "PORTAL", ()=>PORTAL);
parcelHelpers.export(exports, "SKELETON", ()=>SKELETON);
parcelHelpers.export(exports, "SLIDER", ()=>SLIDER);
parcelHelpers.export(exports, "SLIDER_AXIS", ()=>SLIDER_AXIS);
parcelHelpers.export(exports, "SLIDER_HANDLE", ()=>SLIDER_HANDLE);
parcelHelpers.export(exports, "SLIDER_LABEL", ()=>SLIDER_LABEL);
parcelHelpers.export(exports, "SLIDER_TRACK", ()=>SLIDER_TRACK);
parcelHelpers.export(exports, "SLIDER_PROGRESS", ()=>SLIDER_PROGRESS);
parcelHelpers.export(exports, "START", ()=>START);
parcelHelpers.export(exports, "END", ()=>END);
parcelHelpers.export(exports, "SPINNER", ()=>SPINNER);
parcelHelpers.export(exports, "SPINNER_ANIMATION", ()=>SPINNER_ANIMATION);
parcelHelpers.export(exports, "SPINNER_HEAD", ()=>SPINNER_HEAD);
parcelHelpers.export(exports, "SPINNER_NO_SPIN", ()=>SPINNER_NO_SPIN);
parcelHelpers.export(exports, "SPINNER_TRACK", ()=>SPINNER_TRACK);
parcelHelpers.export(exports, "SEGMENTED_CONTROL", ()=>SEGMENTED_CONTROL);
parcelHelpers.export(exports, "TAB", ()=>TAB);
parcelHelpers.export(exports, "TAB_ICON", ()=>TAB_ICON);
parcelHelpers.export(exports, "TAB_TAG", ()=>TAB_TAG);
parcelHelpers.export(exports, "TAB_INDICATOR", ()=>TAB_INDICATOR);
parcelHelpers.export(exports, "TAB_INDICATOR_WRAPPER", ()=>TAB_INDICATOR_WRAPPER);
parcelHelpers.export(exports, "TAB_LIST", ()=>TAB_LIST);
parcelHelpers.export(exports, "TAB_PANEL", ()=>TAB_PANEL);
parcelHelpers.export(exports, "TABS", ()=>TABS);
parcelHelpers.export(exports, "TAG", ()=>TAG);
parcelHelpers.export(exports, "TAG_REMOVE", ()=>TAG_REMOVE);
parcelHelpers.export(exports, "COMPOUND_TAG", ()=>COMPOUND_TAG);
parcelHelpers.export(exports, "COMPOUND_TAG_LEFT", ()=>COMPOUND_TAG_LEFT);
parcelHelpers.export(exports, "COMPOUND_TAG_LEFT_CONTENT", ()=>COMPOUND_TAG_LEFT_CONTENT);
parcelHelpers.export(exports, "COMPOUND_TAG_RIGHT", ()=>COMPOUND_TAG_RIGHT);
parcelHelpers.export(exports, "COMPOUND_TAG_RIGHT_CONTENT", ()=>COMPOUND_TAG_RIGHT_CONTENT);
parcelHelpers.export(exports, "TAG_INPUT", ()=>TAG_INPUT);
parcelHelpers.export(exports, "TAG_INPUT_ICON", ()=>TAG_INPUT_ICON);
parcelHelpers.export(exports, "TAG_INPUT_VALUES", ()=>TAG_INPUT_VALUES);
parcelHelpers.export(exports, "TOAST", ()=>TOAST);
parcelHelpers.export(exports, "TOAST_CONTAINER", ()=>TOAST_CONTAINER);
parcelHelpers.export(exports, "TOAST_MESSAGE", ()=>TOAST_MESSAGE);
parcelHelpers.export(exports, "TOOLTIP", ()=>TOOLTIP);
parcelHelpers.export(exports, "TOOLTIP_INDICATOR", ()=>TOOLTIP_INDICATOR);
parcelHelpers.export(exports, "TREE", ()=>TREE);
parcelHelpers.export(exports, "TREE_NODE", ()=>TREE_NODE);
parcelHelpers.export(exports, "TREE_NODE_CARET", ()=>TREE_NODE_CARET);
parcelHelpers.export(exports, "TREE_NODE_CARET_CLOSED", ()=>TREE_NODE_CARET_CLOSED);
parcelHelpers.export(exports, "TREE_NODE_CARET_NONE", ()=>TREE_NODE_CARET_NONE);
parcelHelpers.export(exports, "TREE_NODE_CARET_OPEN", ()=>TREE_NODE_CARET_OPEN);
parcelHelpers.export(exports, "TREE_NODE_CONTENT", ()=>TREE_NODE_CONTENT);
parcelHelpers.export(exports, "TREE_NODE_EXPANDED", ()=>TREE_NODE_EXPANDED);
parcelHelpers.export(exports, "TREE_NODE_ICON", ()=>TREE_NODE_ICON);
parcelHelpers.export(exports, "TREE_NODE_LABEL", ()=>TREE_NODE_LABEL);
parcelHelpers.export(exports, "TREE_NODE_LIST", ()=>TREE_NODE_LIST);
parcelHelpers.export(exports, "TREE_NODE_SECONDARY_LABEL", ()=>TREE_NODE_SECONDARY_LABEL);
parcelHelpers.export(exports, "TREE_NODE_SELECTED", ()=>TREE_NODE_SELECTED);
parcelHelpers.export(exports, "TREE_ROOT", ()=>TREE_ROOT);
parcelHelpers.export(exports, "ICON", ()=>ICON);
parcelHelpers.export(exports, "ICON_STANDARD", ()=>ICON_STANDARD);
parcelHelpers.export(exports, "ICON_LARGE", ()=>ICON_LARGE);
parcelHelpers.export(exports, "ICON_MUTED", ()=>ICON_MUTED);
/**
 * Returns the namespace prefix for all Blueprint CSS classes.
 * Customize this namespace at build time by defining it with `webpack.DefinePlugin`.
 */ parcelHelpers.export(exports, "getClassNamespace", ()=>getClassNamespace);
/** Return CSS class for alignment. */ parcelHelpers.export(exports, "alignmentClass", ()=>alignmentClass);
parcelHelpers.export(exports, "elevationClass", ()=>elevationClass);
parcelHelpers.export(exports, "iconClass", ()=>iconClass);
parcelHelpers.export(exports, "intentClass", ()=>intentClass);
parcelHelpers.export(exports, "positionClass", ()=>positionClass);
var _alignment = require("./alignment");
var _elevation = require("./elevation");
var _intent = require("./intent");
var _position = require("./position");
var NS = "bp5";
if (typeof BLUEPRINT_NAMESPACE !== "undefined") NS = BLUEPRINT_NAMESPACE;
else if (typeof REACT_APP_BLUEPRINT_NAMESPACE !== "undefined") NS = REACT_APP_BLUEPRINT_NAMESPACE;
var ACTIVE = "".concat(NS, "-active");
var ALIGN_LEFT = "".concat(NS, "-align-left");
var ALIGN_RIGHT = "".concat(NS, "-align-right");
var COMPACT = "".concat(NS, "-compact");
var DARK = "".concat(NS, "-dark");
var DISABLED = "".concat(NS, "-disabled");
var FILL = "".concat(NS, "-fill");
var FIXED = "".concat(NS, "-fixed");
var FIXED_TOP = "".concat(NS, "-fixed-top");
var INLINE = "".concat(NS, "-inline");
var INTERACTIVE = "".concat(NS, "-interactive");
var LARGE = "".concat(NS, "-large");
var LOADING = "".concat(NS, "-loading");
var MINIMAL = "".concat(NS, "-minimal");
var OUTLINED = "".concat(NS, "-outlined");
var PADDED = "".concat(NS, "-padded");
var MULTILINE = "".concat(NS, "-multiline");
var READ_ONLY = "".concat(NS, "-read-only");
var ROUND = "".concat(NS, "-round");
var SELECTED = "".concat(NS, "-selected");
var SMALL = "".concat(NS, "-small");
var VERTICAL = "".concat(NS, "-vertical");
var POSITION_TOP = positionClass((0, _position.Position).TOP);
var POSITION_BOTTOM = positionClass((0, _position.Position).BOTTOM);
var POSITION_LEFT = positionClass((0, _position.Position).LEFT);
var POSITION_RIGHT = positionClass((0, _position.Position).RIGHT);
var ELEVATION_0 = elevationClass((0, _elevation.Elevation).ZERO);
var ELEVATION_1 = elevationClass((0, _elevation.Elevation).ONE);
var ELEVATION_2 = elevationClass((0, _elevation.Elevation).TWO);
var ELEVATION_3 = elevationClass((0, _elevation.Elevation).THREE);
var ELEVATION_4 = elevationClass((0, _elevation.Elevation).FOUR);
var INTENT_PRIMARY = intentClass((0, _intent.Intent).PRIMARY);
var INTENT_SUCCESS = intentClass((0, _intent.Intent).SUCCESS);
var INTENT_WARNING = intentClass((0, _intent.Intent).WARNING);
var INTENT_DANGER = intentClass((0, _intent.Intent).DANGER);
var FOCUS_DISABLED = "".concat(NS, "-focus-disabled");
var FOCUS_STYLE_MANAGER_IGNORE = "".concat(NS, "-focus-style-manager-ignore");
var UI_TEXT = "".concat(NS, "-ui-text");
var RUNNING_TEXT = "".concat(NS, "-running-text");
var MONOSPACE_TEXT = "".concat(NS, "-monospace-text");
var TEXT_LARGE = "".concat(NS, "-text-large");
var TEXT_SMALL = "".concat(NS, "-text-small");
var TEXT_MUTED = "".concat(NS, "-text-muted");
var TEXT_DISABLED = "".concat(NS, "-text-disabled");
var TEXT_OVERFLOW_ELLIPSIS = "".concat(NS, "-text-overflow-ellipsis");
var BLOCKQUOTE = "".concat(NS, "-blockquote");
var CODE = "".concat(NS, "-code");
var CODE_BLOCK = "".concat(NS, "-code-block");
var HEADING = "".concat(NS, "-heading");
var LIST = "".concat(NS, "-list");
var LIST_UNSTYLED = "".concat(NS, "-list-unstyled");
var RTL = "".concat(NS, "-rtl");
var ALERT = "".concat(NS, "-alert");
var ALERT_BODY = "".concat(ALERT, "-body");
var ALERT_CONTENTS = "".concat(ALERT, "-contents");
var ALERT_FOOTER = "".concat(ALERT, "-footer");
var BREADCRUMB = "".concat(NS, "-breadcrumb");
var BREADCRUMB_CURRENT = "".concat(BREADCRUMB, "-current");
var BREADCRUMBS = "".concat(BREADCRUMB, "s");
var BREADCRUMBS_COLLAPSED = "".concat(BREADCRUMB, "s-collapsed");
var BUTTON = "".concat(NS, "-button");
var BUTTON_GROUP = "".concat(BUTTON, "-group");
var BUTTON_SPINNER = "".concat(BUTTON, "-spinner");
var BUTTON_TEXT = "".concat(BUTTON, "-text");
var CALLOUT = "".concat(NS, "-callout");
var CALLOUT_HAS_BODY_CONTENT = "".concat(CALLOUT, "-has-body-content");
var CALLOUT_ICON = "".concat(CALLOUT, "-icon");
var CARD = "".concat(NS, "-card");
var CONTROL_CARD = "".concat(NS, "-control-card");
var CONTROL_CARD_LABEL = "".concat(CONTROL_CARD, "-label");
var SWITCH_CONTROL_CARD = "".concat(NS, "-switch-control-card");
var CHECKBOX_CONTROL_CARD = "".concat(NS, "-checkbox-control-card");
var RADIO_CONTROL_CARD = "".concat(NS, "-radio-control-card");
var CARD_LIST = "".concat(NS, "-card-list");
var CARD_LIST_BORDERED = "".concat(CARD_LIST, "-bordered");
var COLLAPSE = "".concat(NS, "-collapse");
var COLLAPSE_BODY = "".concat(COLLAPSE, "-body");
var CONTEXT_MENU = "".concat(NS, "-context-menu");
var CONTEXT_MENU_VIRTUAL_TARGET = "".concat(CONTEXT_MENU, "-virtual-target");
var CONTEXT_MENU_POPOVER = "".concat(CONTEXT_MENU, "-popover");
var CONTEXT_MENU_BACKDROP = "".concat(CONTEXT_MENU, "-backdrop");
var CONTROL_GROUP = "".concat(NS, "-control-group");
var DIALOG = "".concat(NS, "-dialog");
var DIALOG_CONTAINER = "".concat(DIALOG, "-container");
var DIALOG_HEADER = "".concat(DIALOG, "-header");
var DIALOG_BODY = "".concat(DIALOG, "-body");
var DIALOG_BODY_SCROLL_CONTAINER = "".concat(DIALOG, "-body-scroll-container");
var DIALOG_CLOSE_BUTTON = "".concat(DIALOG, "-close-button");
var DIALOG_FOOTER = "".concat(DIALOG, "-footer");
var DIALOG_FOOTER_FIXED = "".concat(DIALOG, "-footer-fixed");
var DIALOG_FOOTER_MAIN_SECTION = "".concat(DIALOG, "-footer-main-section");
var DIALOG_FOOTER_ACTIONS = "".concat(DIALOG, "-footer-actions");
var DIALOG_STEP = "".concat(NS, "-dialog-step");
var DIALOG_STEP_CONTAINER = "".concat(DIALOG_STEP, "-container");
var DIALOG_STEP_TITLE = "".concat(DIALOG_STEP, "-title");
var DIALOG_STEP_ICON = "".concat(DIALOG_STEP, "-icon");
var DIALOG_STEP_VIEWED = "".concat(DIALOG_STEP, "-viewed");
var DIVIDER = "".concat(NS, "-divider");
var DRAWER = "".concat(NS, "-drawer");
var DRAWER_BODY = "".concat(DRAWER, "-body");
var DRAWER_FOOTER = "".concat(DRAWER, "-footer");
var DRAWER_HEADER = "".concat(DRAWER, "-header");
var EDITABLE_TEXT = "".concat(NS, "-editable-text");
var EDITABLE_TEXT_CONTENT = "".concat(EDITABLE_TEXT, "-content");
var EDITABLE_TEXT_EDITING = "".concat(EDITABLE_TEXT, "-editing");
var EDITABLE_TEXT_INPUT = "".concat(EDITABLE_TEXT, "-input");
var EDITABLE_TEXT_PLACEHOLDER = "".concat(EDITABLE_TEXT, "-placeholder");
var ENTITY_TITLE = "".concat(NS, "-entity-title");
var ENTITY_TITLE_ELLIPSIZE = "".concat(NS, "-entity-title-ellipsize");
var ENTITY_TITLE_HAS_SUBTITLE = "".concat(ENTITY_TITLE, "-has-subtitle");
var ENTITY_TITLE_ICON_CONTAINER = "".concat(ENTITY_TITLE, "-icon-container");
var ENTITY_TITLE_SUBTITLE = "".concat(ENTITY_TITLE, "-subtitle");
var ENTITY_TITLE_TAGS_CONTAINER = "".concat(ENTITY_TITLE, "-tags-container");
var ENTITY_TITLE_TEXT = "".concat(ENTITY_TITLE, "-text");
var ENTITY_TITLE_TITLE = "".concat(ENTITY_TITLE, "-title");
var ENTITY_TITLE_TITLE_AND_TAGS = "".concat(ENTITY_TITLE, "-title-and-tags");
var FLEX_EXPANDER = "".concat(NS, "-flex-expander");
var HTML_SELECT = "".concat(NS, "-html-select");
var SELECT = "".concat(NS, "-select");
var HTML_TABLE = "".concat(NS, "-html-table");
var HTML_TABLE_BORDERED = "".concat(HTML_TABLE, "-bordered");
var HTML_TABLE_STRIPED = "".concat(HTML_TABLE, "-striped");
var INPUT = "".concat(NS, "-input");
var INPUT_GHOST = "".concat(INPUT, "-ghost");
var INPUT_GROUP = "".concat(INPUT, "-group");
var INPUT_LEFT_CONTAINER = "".concat(INPUT, "-left-container");
var INPUT_ACTION = "".concat(INPUT, "-action");
var RESIZABLE_INPUT_SPAN = "".concat(NS, "-resizable-input-span");
var TEXT_AREA = "".concat(NS, "-text-area");
var TEXT_AREA_AUTO_RESIZE = "".concat(TEXT_AREA, "-auto-resize");
var CONTROL = "".concat(NS, "-control");
var CONTROL_INDICATOR = "".concat(CONTROL, "-indicator");
var CONTROL_INDICATOR_CHILD = "".concat(CONTROL_INDICATOR, "-child");
var CHECKBOX = "".concat(NS, "-checkbox");
var RADIO = "".concat(NS, "-radio");
var RADIO_GROUP = "".concat(NS, "-radio-group");
var SWITCH = "".concat(NS, "-switch");
var SWITCH_INNER_TEXT = "".concat(SWITCH, "-inner-text");
var FILE_INPUT = "".concat(NS, "-file-input");
var FILE_INPUT_HAS_SELECTION = "".concat(NS, "-file-input-has-selection");
var FILE_UPLOAD_INPUT = "".concat(NS, "-file-upload-input");
var FILE_UPLOAD_INPUT_CUSTOM_TEXT = "".concat(NS, "-file-upload-input-custom-text");
var KEY = "".concat(NS, "-key");
var KEY_COMBO = "".concat(KEY, "-combo");
var MODIFIER_KEY = "".concat(NS, "-modifier-key");
var HOTKEY = "".concat(NS, "-hotkey");
var HOTKEY_LABEL = "".concat(HOTKEY, "-label");
var HOTKEY_COLUMN = "".concat(HOTKEY, "-column");
var HOTKEY_DIALOG = "".concat(HOTKEY, "-dialog");
var LABEL = "".concat(NS, "-label");
var FORM_GROUP = "".concat(NS, "-form-group");
var FORM_CONTENT = "".concat(NS, "-form-content");
var FORM_HELPER_TEXT = "".concat(NS, "-form-helper-text");
var FORM_GROUP_SUB_LABEL = "".concat(NS, "-form-group-sub-label");
var MENU = "".concat(NS, "-menu");
var MENU_ITEM = "".concat(MENU, "-item");
var MENU_ITEM_IS_SELECTABLE = "".concat(MENU_ITEM, "-is-selectable");
var MENU_ITEM_SELECTED_ICON = "".concat(MENU_ITEM, "-selected-icon");
var MENU_ITEM_ICON = "".concat(MENU_ITEM, "-icon");
var MENU_ITEM_LABEL = "".concat(MENU_ITEM, "-label");
var MENU_SUBMENU = "".concat(NS, "-submenu");
var MENU_SUBMENU_ICON = "".concat(MENU_SUBMENU, "-icon");
var MENU_DIVIDER = "".concat(MENU, "-divider");
var MENU_HEADER = "".concat(MENU, "-header");
var MULTISTEP_DIALOG = "".concat(NS, "-multistep-dialog");
var MULTISTEP_DIALOG_PANELS = "".concat(MULTISTEP_DIALOG, "-panels");
var MULTISTEP_DIALOG_LEFT_PANEL = "".concat(MULTISTEP_DIALOG, "-left-panel");
var MULTISTEP_DIALOG_RIGHT_PANEL = "".concat(MULTISTEP_DIALOG, "-right-panel");
var MULTISTEP_DIALOG_NAV_TOP = "".concat(MULTISTEP_DIALOG, "-nav-top");
var MULTISTEP_DIALOG_NAV_RIGHT = "".concat(MULTISTEP_DIALOG, "-nav-right");
var SECTION = "".concat(NS, "-section");
var SECTION_COLLAPSED = "".concat(SECTION, "-collapsed");
var SECTION_HEADER = "".concat(SECTION, "-header");
var SECTION_HEADER_LEFT = "".concat(SECTION_HEADER, "-left");
var SECTION_HEADER_TITLE = "".concat(SECTION_HEADER, "-title");
var SECTION_HEADER_SUB_TITLE = "".concat(SECTION_HEADER, "-sub-title");
var SECTION_HEADER_DIVIDER = "".concat(SECTION_HEADER, "-divider");
var SECTION_HEADER_TABS = "".concat(SECTION_HEADER, "-tabs");
var SECTION_HEADER_RIGHT = "".concat(SECTION_HEADER, "-right");
var SECTION_CARD = "".concat(SECTION, "-card");
var NAVBAR = "".concat(NS, "-navbar");
var NAVBAR_GROUP = "".concat(NAVBAR, "-group");
var NAVBAR_HEADING = "".concat(NAVBAR, "-heading");
var NAVBAR_DIVIDER = "".concat(NAVBAR, "-divider");
var NON_IDEAL_STATE = "".concat(NS, "-non-ideal-state");
var NON_IDEAL_STATE_VISUAL = "".concat(NON_IDEAL_STATE, "-visual");
var NON_IDEAL_STATE_TEXT = "".concat(NON_IDEAL_STATE, "-text");
var NUMERIC_INPUT = "".concat(NS, "-numeric-input");
var OVERFLOW_LIST = "".concat(NS, "-overflow-list");
var OVERFLOW_LIST_SPACER = "".concat(OVERFLOW_LIST, "-spacer");
var OVERLAY = "".concat(NS, "-overlay");
var OVERLAY_BACKDROP = "".concat(OVERLAY, "-backdrop");
var OVERLAY_CONTAINER = "".concat(OVERLAY, "-container");
var OVERLAY_CONTENT = "".concat(OVERLAY, "-content");
var OVERLAY_INLINE = "".concat(OVERLAY, "-inline");
var OVERLAY_OPEN = "".concat(OVERLAY, "-open");
var OVERLAY_SCROLL_CONTAINER = "".concat(OVERLAY, "-scroll-container");
var OVERLAY_START_FOCUS_TRAP = "".concat(OVERLAY, "-start-focus-trap");
var OVERLAY_END_FOCUS_TRAP = "".concat(OVERLAY, "-end-focus-trap");
var PANEL_STACK = "".concat(NS, "-panel-stack");
var PANEL_STACK_HEADER = "".concat(PANEL_STACK, "-header");
var PANEL_STACK_HEADER_BACK = "".concat(PANEL_STACK, "-header-back");
var PANEL_STACK_VIEW = "".concat(PANEL_STACK, "-view");
var PANEL_STACK2 = "".concat(NS, "-panel-stack2");
var PANEL_STACK2_HEADER = "".concat(PANEL_STACK2, "-header");
var PANEL_STACK2_HEADER_BACK = "".concat(PANEL_STACK2, "-header-back");
var PANEL_STACK2_VIEW = "".concat(PANEL_STACK2, "-view");
var POPOVER = "".concat(NS, "-popover");
var POPOVER_ARROW = "".concat(POPOVER, "-arrow");
var POPOVER_BACKDROP = "".concat(POPOVER, "-backdrop");
var POPOVER_CAPTURING_DISMISS = "".concat(POPOVER, "-capturing-dismiss");
var POPOVER_CONTENT = "".concat(POPOVER, "-content");
var POPOVER_CONTENT_PLACEMENT = "".concat(POPOVER, "-placement");
var POPOVER_CONTENT_SIZING = "".concat(POPOVER_CONTENT, "-sizing");
var POPOVER_DISMISS = "".concat(POPOVER, "-dismiss");
var POPOVER_DISMISS_OVERRIDE = "".concat(POPOVER_DISMISS, "-override");
var POPOVER_MATCH_TARGET_WIDTH = "".concat(POPOVER, "-match-target-width");
var POPOVER_OPEN = "".concat(POPOVER, "-open");
var POPOVER_POPPER_ESCAPED = "".concat(POPOVER, "-popper-escaped");
var POPOVER_REFERENCE_HIDDEN = "".concat(POPOVER, "-reference-hidden");
var POPOVER_TARGET = "".concat(POPOVER, "-target");
var POPOVER_TRANSITION_CONTAINER = "".concat(POPOVER, "-transition-container");
var POPOVER_WRAPPER = "".concat(POPOVER, "-wrapper");
var PROGRESS_BAR = "".concat(NS, "-progress-bar");
var PROGRESS_METER = "".concat(NS, "-progress-meter");
var PROGRESS_NO_STRIPES = "".concat(NS, "-no-stripes");
var PROGRESS_NO_ANIMATION = "".concat(NS, "-no-animation");
var PORTAL = "".concat(NS, "-portal");
var SKELETON = "".concat(NS, "-skeleton");
var SLIDER = "".concat(NS, "-slider");
var SLIDER_AXIS = "".concat(SLIDER, "-axis");
var SLIDER_HANDLE = "".concat(SLIDER, "-handle");
var SLIDER_LABEL = "".concat(SLIDER, "-label");
var SLIDER_TRACK = "".concat(SLIDER, "-track");
var SLIDER_PROGRESS = "".concat(SLIDER, "-progress");
var START = "".concat(NS, "-start");
var END = "".concat(NS, "-end");
var SPINNER = "".concat(NS, "-spinner");
var SPINNER_ANIMATION = "".concat(SPINNER, "-animation");
var SPINNER_HEAD = "".concat(SPINNER, "-head");
var SPINNER_NO_SPIN = "".concat(NS, "-no-spin");
var SPINNER_TRACK = "".concat(SPINNER, "-track");
var SEGMENTED_CONTROL = "".concat(NS, "-segmented-control");
var TAB = "".concat(NS, "-tab");
var TAB_ICON = "".concat(TAB, "-icon");
var TAB_TAG = "".concat(TAB, "-tag");
var TAB_INDICATOR = "".concat(TAB, "-indicator");
var TAB_INDICATOR_WRAPPER = "".concat(TAB_INDICATOR, "-wrapper");
var TAB_LIST = "".concat(TAB, "-list");
var TAB_PANEL = "".concat(TAB, "-panel");
var TABS = "".concat(TAB, "s");
var TAG = "".concat(NS, "-tag");
var TAG_REMOVE = "".concat(TAG, "-remove");
var COMPOUND_TAG = "".concat(NS, "-compound-tag");
var COMPOUND_TAG_LEFT = "".concat(COMPOUND_TAG, "-left");
var COMPOUND_TAG_LEFT_CONTENT = "".concat(COMPOUND_TAG, "-left-content");
var COMPOUND_TAG_RIGHT = "".concat(COMPOUND_TAG, "-right");
var COMPOUND_TAG_RIGHT_CONTENT = "".concat(COMPOUND_TAG, "-right-content");
var TAG_INPUT = "".concat(NS, "-tag-input");
var TAG_INPUT_ICON = "".concat(TAG_INPUT, "-icon");
var TAG_INPUT_VALUES = "".concat(TAG_INPUT, "-values");
var TOAST = "".concat(NS, "-toast");
var TOAST_CONTAINER = "".concat(TOAST, "-container");
var TOAST_MESSAGE = "".concat(TOAST, "-message");
var TOOLTIP = "".concat(NS, "-tooltip");
var TOOLTIP_INDICATOR = "".concat(TOOLTIP, "-indicator");
var TREE = "".concat(NS, "-tree");
var TREE_NODE = "".concat(NS, "-tree-node");
var TREE_NODE_CARET = "".concat(TREE_NODE, "-caret");
var TREE_NODE_CARET_CLOSED = "".concat(TREE_NODE_CARET, "-closed");
var TREE_NODE_CARET_NONE = "".concat(TREE_NODE_CARET, "-none");
var TREE_NODE_CARET_OPEN = "".concat(TREE_NODE_CARET, "-open");
var TREE_NODE_CONTENT = "".concat(TREE_NODE, "-content");
var TREE_NODE_EXPANDED = "".concat(TREE_NODE, "-expanded");
var TREE_NODE_ICON = "".concat(TREE_NODE, "-icon");
var TREE_NODE_LABEL = "".concat(TREE_NODE, "-label");
var TREE_NODE_LIST = "".concat(TREE_NODE, "-list");
var TREE_NODE_SECONDARY_LABEL = "".concat(TREE_NODE, "-secondary-label");
var TREE_NODE_SELECTED = "".concat(TREE_NODE, "-selected");
var TREE_ROOT = "".concat(NS, "-tree-root");
var ICON = "".concat(NS, "-icon");
var ICON_STANDARD = "".concat(ICON, "-standard");
var ICON_LARGE = "".concat(ICON, "-large");
var ICON_MUTED = "".concat(ICON, "-muted");
function getClassNamespace() {
    return NS;
}
function alignmentClass(alignment) {
    switch(alignment){
        case (0, _alignment.Alignment).LEFT:
            return ALIGN_LEFT;
        case (0, _alignment.Alignment).RIGHT:
            return ALIGN_RIGHT;
        default:
            return undefined;
    }
}
function elevationClass(elevation) {
    if (elevation === undefined) return undefined;
    return "".concat(NS, "-elevation-").concat(elevation);
}
function iconClass(iconName) {
    if (iconName == null) return undefined;
    return iconName.indexOf("".concat(NS, "-icon-")) === 0 ? iconName : "".concat(NS, "-icon-").concat(iconName);
}
function intentClass(intent) {
    if (intent == null || intent === (0, _intent.Intent).NONE) return undefined;
    return "".concat(NS, "-intent-").concat(intent.toLowerCase());
}
function positionClass(position) {
    if (position === undefined) return undefined;
    return "".concat(NS, "-position-").concat(position);
}

},{"./alignment":"cQB2Y","./elevation":"5d8mV","./intent":"5Cn0u","./position":"1PCvS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cQB2Y":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Alignment along the horizontal axis. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alignment", ()=>Alignment);
var Alignment = {
    CENTER: "center",
    LEFT: "left",
    RIGHT: "right"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5d8mV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // tslint:disable:object-literal-sort-keys
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Elevation", ()=>Elevation);
var Elevation = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Cn0u":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // tslint:disable:object-literal-sort-keys
/**
 * The four basic intents.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Intent", ()=>Intent);
var Intent = {
    NONE: "none",
    PRIMARY: "primary",
    SUCCESS: "success",
    WARNING: "warning",
    DANGER: "danger"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1PCvS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Position", ()=>Position);
parcelHelpers.export(exports, "isPositionHorizontal", ()=>isPositionHorizontal);
parcelHelpers.export(exports, "isPositionVertical", ()=>isPositionVertical);
parcelHelpers.export(exports, "getPositionIgnoreAngles", ()=>getPositionIgnoreAngles);
var Position = {
    BOTTOM: "bottom",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    LEFT: "left",
    LEFT_BOTTOM: "left-bottom",
    LEFT_TOP: "left-top",
    RIGHT: "right",
    RIGHT_BOTTOM: "right-bottom",
    RIGHT_TOP: "right-top",
    TOP: "top",
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right"
};
function isPositionHorizontal(position) {
    /* istanbul ignore next */ return position === Position.TOP || position === Position.TOP_LEFT || position === Position.TOP_RIGHT || position === Position.BOTTOM || position === Position.BOTTOM_LEFT || position === Position.BOTTOM_RIGHT;
}
function isPositionVertical(position) {
    /* istanbul ignore next */ return position === Position.LEFT || position === Position.LEFT_TOP || position === Position.LEFT_BOTTOM || position === Position.RIGHT || position === Position.RIGHT_TOP || position === Position.RIGHT_BOTTOM;
}
function getPositionIgnoreAngles(position) {
    if (position === Position.TOP || position === Position.TOP_LEFT || position === Position.TOP_RIGHT) return Position.TOP;
    else if (position === Position.BOTTOM || position === Position.BOTTOM_LEFT || position === Position.BOTTOM_RIGHT) return Position.BOTTOM;
    else if (position === Position.LEFT || position === Position.LEFT_TOP || position === Position.LEFT_BOTTOM) return Position.LEFT;
    else return Position.RIGHT;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dJ36n":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* istanbul ignore next */ /**
 * A nifty little class that maintains event handlers to add a class to the container element
 * when entering "mouse mode" (on a `mousedown` event) and remove it when entering "keyboard mode"
 * (on a `tab` key `keydown` event).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InteractionModeEngine", ()=>InteractionModeEngine);
var InteractionModeEngine = /** @class */ function() {
    function InteractionModeEngine(container, className) {
        var _this = this;
        this.container = container;
        this.className = className;
        this.isRunning = false;
        this.handleKeyDown = function(e) {
            if (e.key === "Tab") {
                _this.reset();
                _this.container.addEventListener("mousedown", _this.handleMouseDown);
            }
        };
        this.handleMouseDown = function() {
            _this.reset();
            _this.container.classList.add(_this.className);
            _this.container.addEventListener("keydown", _this.handleKeyDown);
        };
    }
    /** Returns whether the engine is currently running. */ InteractionModeEngine.prototype.isActive = function() {
        return this.isRunning;
    };
    /** Enable behavior which applies the given className when in mouse mode. */ InteractionModeEngine.prototype.start = function() {
        this.container.addEventListener("mousedown", this.handleMouseDown);
        this.isRunning = true;
    };
    /** Disable interaction mode behavior and remove className from container. */ InteractionModeEngine.prototype.stop = function() {
        this.reset();
        this.isRunning = false;
    };
    InteractionModeEngine.prototype.reset = function() {
        this.container.classList.remove(this.className);
        this.container.removeEventListener("keydown", this.handleKeyDown);
        this.container.removeEventListener("mousedown", this.handleMouseDown);
    };
    return InteractionModeEngine;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QDnh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Colors", ()=>(0, _colors.Colors));
parcelHelpers.export(exports, "AbstractComponent", ()=>(0, _abstractComponent.AbstractComponent));
parcelHelpers.export(exports, "AbstractPureComponent", ()=>(0, _abstractPureComponent.AbstractPureComponent));
parcelHelpers.export(exports, "Alignment", ()=>(0, _alignment.Alignment));
parcelHelpers.export(exports, "Boundary", ()=>(0, _boundary.Boundary));
parcelHelpers.export(exports, "Elevation", ()=>(0, _elevation.Elevation));
parcelHelpers.export(exports, "Intent", ()=>(0, _intent.Intent));
// eslint-disable-next-line deprecation/deprecation
parcelHelpers.export(exports, "Keys", ()=>(0, _keyCodes.KeyCodes));
parcelHelpers.export(exports, "Position", ()=>(0, _position.Position));
parcelHelpers.export(exports, "removeNonHTMLProps", ()=>(0, _props.removeNonHTMLProps));
parcelHelpers.export(exports, "DISPLAYNAME_PREFIX", ()=>(0, _props.DISPLAYNAME_PREFIX));
parcelHelpers.export(exports, "getRef", ()=>(0, _refs.getRef));
parcelHelpers.export(exports, "isRefCallback", ()=>(0, _refs.isRefCallback));
parcelHelpers.export(exports, "isRefObject", ()=>(0, _refs.isRefObject));
parcelHelpers.export(exports, "mergeRefs", ()=>(0, _refs.mergeRefs));
parcelHelpers.export(exports, "refHandler", ()=>(0, _refs.refHandler));
parcelHelpers.export(exports, "setRef", ()=>(0, _refs.setRef));
parcelHelpers.export(exports, "Classes", ()=>_classes) // NOTE: Errors is not exported in public API
;
parcelHelpers.export(exports, "Utils", ()=>_utils);
var _colors = require("@blueprintjs/colors");
var _abstractComponent = require("./abstractComponent");
var _abstractPureComponent = require("./abstractPureComponent");
var _alignment = require("./alignment");
var _boundary = require("./boundary");
var _elevation = require("./elevation");
var _intent = require("./intent");
var _keyCodes = require("./keyCodes");
var _position = require("./position");
var _props = require("./props");
var _refs = require("./refs");
var _classes = require("./classes");
var _utils = require("./utils");

},{"@blueprintjs/colors":"gDSfT","./abstractComponent":"hwWE1","./abstractPureComponent":"bXQVd","./alignment":"cQB2Y","./boundary":"0lXiF","./elevation":"5d8mV","./intent":"5Cn0u","./keyCodes":"4qg7S","./position":"1PCvS","./props":"dBcIV","./refs":"krjx8","./classes":"2PICA","./utils":"56UdR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gDSfT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Colors", ()=>(0, _colors.Colors));
// eslint-disable-next-line deprecation/deprecation
parcelHelpers.export(exports, "LegacyColors", ()=>(0, _legacyColors.LegacyColors));
var _colors = require("./colors");
var _legacyColors = require("./legacyColors");

},{"./colors":"3b5HX","./legacyColors":"j9X2r","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3b5HX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Colors", ()=>Colors);
var _tslib = require("tslib");
var grayScale = {
    BLACK: "#111418",
    DARK_GRAY1: "#1C2127",
    DARK_GRAY2: "#252A31",
    DARK_GRAY3: "#2F343C",
    DARK_GRAY4: "#383E47",
    DARK_GRAY5: "#404854",
    GRAY1: "#5F6B7C",
    GRAY2: "#738091",
    GRAY3: "#8F99A8",
    GRAY4: "#ABB3BF",
    GRAY5: "#C5CBD3",
    LIGHT_GRAY1: "#D3D8DE",
    LIGHT_GRAY2: "#DCE0E5",
    LIGHT_GRAY3: "#E5E8EB",
    LIGHT_GRAY4: "#EDEFF2",
    LIGHT_GRAY5: "#F6F7F9",
    WHITE: "#FFFFFF"
};
var coreColors = {
    BLUE1: "#184A90",
    BLUE2: "#215DB0",
    BLUE3: "#2D72D2",
    BLUE4: "#4C90F0",
    BLUE5: "#8ABBFF",
    GREEN1: "#165A36",
    GREEN2: "#1C6E42",
    GREEN3: "#238551",
    GREEN4: "#32A467",
    GREEN5: "#72CA9B",
    ORANGE1: "#77450D",
    ORANGE2: "#935610",
    ORANGE3: "#C87619",
    ORANGE4: "#EC9A3C",
    ORANGE5: "#FBB360",
    RED1: "#8E292C",
    RED2: "#AC2F33",
    RED3: "#CD4246",
    RED4: "#E76A6E",
    RED5: "#FA999C"
};
var extendedColors = {
    CERULEAN1: "#0C5174",
    CERULEAN2: "#0F6894",
    CERULEAN3: "#147EB3",
    CERULEAN4: "#3FA6DA",
    CERULEAN5: "#68C1EE",
    FOREST1: "#1D7324",
    FOREST2: "#238C2C",
    FOREST3: "#29A634",
    FOREST4: "#43BF4D",
    FOREST5: "#62D96B",
    GOLD1: "#5C4405",
    GOLD2: "#866103",
    GOLD3: "#D1980B",
    GOLD4: "#F0B726",
    GOLD5: "#FBD065",
    INDIGO1: "#5642A6",
    INDIGO2: "#634DBF",
    INDIGO3: "#7961DB",
    INDIGO4: "#9881F3",
    INDIGO5: "#BDADFF",
    LIME1: "#43501B",
    LIME2: "#5A701A",
    LIME3: "#8EB125",
    LIME4: "#B6D94C",
    LIME5: "#D4F17E",
    ROSE1: "#A82255",
    ROSE2: "#C22762",
    ROSE3: "#DB2C6F",
    ROSE4: "#F5498B",
    ROSE5: "#FF66A1",
    SEPIA1: "#5E4123",
    SEPIA2: "#7A542E",
    SEPIA3: "#946638",
    SEPIA4: "#AF855A",
    SEPIA5: "#D0B090",
    TURQUOISE1: "#004D46",
    TURQUOISE2: "#007067",
    TURQUOISE3: "#00A396",
    TURQUOISE4: "#13C9BA",
    TURQUOISE5: "#7AE1D8",
    VERMILION1: "#96290D",
    VERMILION2: "#B83211",
    VERMILION3: "#D33D17",
    VERMILION4: "#EB6847",
    VERMILION5: "#FF9980",
    VIOLET1: "#5C255C",
    VIOLET2: "#7C327C",
    VIOLET3: "#9D3F9D",
    VIOLET4: "#BD6BBD",
    VIOLET5: "#D69FD6"
};
var Colors = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, grayScale), coreColors), extendedColors);

},{"tslib":"b4wpY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4wpY":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j9X2r":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Blueprint 3.x colors
 *
 * @deprecated use `{ Colors } from "@blueprintjs/colors"`
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LegacyColors", ()=>LegacyColors);
var LegacyColors = {
    BLACK: "#10161A",
    BLUE1: "#0E5A8A",
    BLUE2: "#106BA3",
    BLUE3: "#137CBD",
    BLUE4: "#2B95D6",
    BLUE5: "#48AFF0",
    COBALT1: "#1F4B99",
    COBALT2: "#2458B3",
    COBALT3: "#2965CC",
    COBALT4: "#4580E6",
    COBALT5: "#669EFF",
    DARK_GRAY1: "#182026",
    DARK_GRAY2: "#202B33",
    DARK_GRAY3: "#293742",
    DARK_GRAY4: "#30404D",
    DARK_GRAY5: "#394B59",
    FOREST1: "#1D7324",
    FOREST2: "#238C2C",
    FOREST3: "#29A634",
    FOREST4: "#43BF4D",
    FOREST5: "#62D96B",
    GOLD1: "#A67908",
    GOLD2: "#BF8C0A",
    GOLD3: "#D99E0B",
    GOLD4: "#F2B824",
    GOLD5: "#FFC940",
    GRAY1: "#5C7080",
    GRAY2: "#738694",
    GRAY3: "#8A9BA8",
    GRAY4: "#A7B6C2",
    GRAY5: "#BFCCD6",
    GREEN1: "#0A6640",
    GREEN2: "#0D8050",
    GREEN3: "#0F9960",
    GREEN4: "#15B371",
    GREEN5: "#3DCC91",
    INDIGO1: "#5642A6",
    INDIGO2: "#634DBF",
    INDIGO3: "#7157D9",
    INDIGO4: "#9179F2",
    INDIGO5: "#AD99FF",
    LIGHT_GRAY1: "#CED9E0",
    LIGHT_GRAY2: "#D8E1E8",
    LIGHT_GRAY3: "#E1E8ED",
    LIGHT_GRAY4: "#EBF1F5",
    LIGHT_GRAY5: "#F5F8FA",
    LIME1: "#728C23",
    LIME2: "#87A629",
    LIME3: "#9BBF30",
    LIME4: "#B6D94C",
    LIME5: "#D1F26D",
    ORANGE1: "#A66321",
    ORANGE2: "#BF7326",
    ORANGE3: "#D9822B",
    ORANGE4: "#F29D49",
    ORANGE5: "#FFB366",
    RED1: "#A82A2A",
    RED2: "#C23030",
    RED3: "#DB3737",
    RED4: "#F55656",
    RED5: "#FF7373",
    ROSE1: "#A82255",
    ROSE2: "#C22762",
    ROSE3: "#DB2C6F",
    ROSE4: "#F5498B",
    ROSE5: "#FF66A1",
    SEPIA1: "#63411E",
    SEPIA2: "#7D5125",
    SEPIA3: "#96622D",
    SEPIA4: "#B07B46",
    SEPIA5: "#C99765",
    TURQUOISE1: "#008075",
    TURQUOISE2: "#00998C",
    TURQUOISE3: "#00B3A4",
    TURQUOISE4: "#14CCBD",
    TURQUOISE5: "#2EE6D6",
    VERMILION1: "#9E2B0E",
    VERMILION2: "#B83211",
    VERMILION3: "#D13913",
    VERMILION4: "#EB532D",
    VERMILION5: "#FF6E4A",
    VIOLET1: "#5C255C",
    VIOLET2: "#752F75",
    VIOLET3: "#8F398F",
    VIOLET4: "#A854A8",
    VIOLET5: "#C274C2",
    WHITE: "#FFFFFF"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hwWE1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2019 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractComponent", ()=>AbstractComponent);
var _tslib = require("tslib");
var _react = require("react");
var _utils = require("./utils");
/**
 * An abstract component that Blueprint components can extend
 * in order to add some common functionality like runtime props validation.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
var AbstractComponent = /** @class */ function(_super) {
    (0, _tslib.__extends)(AbstractComponent, _super);
    function AbstractComponent(props) {
        var _this = _super.call(this, props) || this;
        // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
        _this.timeoutIds = [];
        _this.requestIds = [];
        /**
         * Clear all known timeouts.
         */ _this.clearTimeouts = function() {
            if (_this.timeoutIds.length > 0) {
                for(var _i = 0, _a = _this.timeoutIds; _i < _a.length; _i++){
                    var timeoutId = _a[_i];
                    window.clearTimeout(timeoutId);
                }
                _this.timeoutIds = [];
            }
        };
        /**
         * Clear all known animation frame requests.
         */ _this.cancelAnimationFrames = function() {
            if (_this.requestIds.length > 0) {
                for(var _i = 0, _a = _this.requestIds; _i < _a.length; _i++){
                    var requestId = _a[_i];
                    window.cancelAnimationFrame(requestId);
                }
                _this.requestIds = [];
            }
        };
        if (!(0, _utils.isNodeEnv)("production")) _this.validateProps(_this.props);
        return _this;
    }
    AbstractComponent.prototype.componentDidUpdate = function(_prevProps, _prevState, _snapshot) {
        if (!(0, _utils.isNodeEnv)("production")) this.validateProps(this.props);
    };
    AbstractComponent.prototype.componentWillUnmount = function() {
        this.clearTimeouts();
        this.cancelAnimationFrames();
    };
    /**
     * Request an animation frame and remember its ID.
     * All pending requests will be canceled when component unmounts.
     *
     * @returns a "cancel" function that will cancel the request when invoked.
     */ AbstractComponent.prototype.requestAnimationFrame = function(callback) {
        var handle = window.requestAnimationFrame(callback);
        this.requestIds.push(handle);
        return function() {
            return window.cancelAnimationFrame(handle);
        };
    };
    /**
     * Set a timeout and remember its ID.
     * All stored timeouts will be cleared when component unmounts.
     *
     * @returns a "cancel" function that will clear timeout when invoked.
     */ AbstractComponent.prototype.setTimeout = function(callback, timeout) {
        var handle = window.setTimeout(callback, timeout);
        this.timeoutIds.push(handle);
        return function() {
            return window.clearTimeout(handle);
        };
    };
    /**
     * Ensures that the props specified for a component are valid.
     * Implementations should check that props are valid and usually throw an Error if they are not.
     * Implementations should not duplicate checks that the type system already guarantees.
     *
     * This method should be used instead of React's
     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
     * Like propTypes, these runtime checks run only in development mode.
     */ AbstractComponent.prototype.validateProps = function(_props) {
    // implement in subclass
    };
    return AbstractComponent;
}(_react.Component);

},{"tslib":"b4wpY","react":"9njXz","./utils":"56UdR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"56UdR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clickElementOnKeyPress", ()=>(0, _domUtils.clickElementOnKeyPress));
parcelHelpers.export(exports, "elementIsOrContains", ()=>(0, _domUtils.elementIsOrContains));
parcelHelpers.export(exports, "elementIsTextInput", ()=>(0, _domUtils.elementIsTextInput));
parcelHelpers.export(exports, "getActiveElement", ()=>(0, _domUtils.getActiveElement));
parcelHelpers.export(exports, "throttle", ()=>(0, _domUtils.throttle));
parcelHelpers.export(exports, "throttleEvent", ()=>(0, _domUtils.throttleEvent));
parcelHelpers.export(exports, "throttleReactEventCallback", ()=>(0, _domUtils.throttleReactEventCallback));
parcelHelpers.export(exports, "isFunction", ()=>(0, _functionUtils.isFunction));
parcelHelpers.export(exports, "isDarkTheme", ()=>(0, _isDarkTheme.isDarkTheme));
// ref utils used to live in this folder, but got refactored and moved elsewhere.
// we keep this export here for backwards compatibility
parcelHelpers.export(exports, "setRef", ()=>(0, _refs.setRef));
parcelHelpers.export(exports, "getRef", ()=>(0, _refs.getRef));
var _compareUtils = require("./compareUtils");
parcelHelpers.exportAll(_compareUtils, exports);
var _domUtils = require("./domUtils");
var _functionUtils = require("./functionUtils");
var _jsUtils = require("./jsUtils");
parcelHelpers.exportAll(_jsUtils, exports);
var _reactUtils = require("./reactUtils");
parcelHelpers.exportAll(_reactUtils, exports);
var _keyboardUtils = require("./keyboardUtils");
parcelHelpers.exportAll(_keyboardUtils, exports);
var _isDarkTheme = require("./isDarkTheme");
var _refs = require("../refs");

},{"./compareUtils":"95A8W","./domUtils":"K845P","./functionUtils":"hfL7v","./jsUtils":"4NYrB","./reactUtils":"3wQbM","./keyboardUtils":"dVvHj","./isDarkTheme":"fQ3IJ","../refs":"krjx8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"95A8W":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns true if the arrays are equal. Elements will be shallowly compared by
 * default, or they will be compared using the custom `compare` function if one
 * is provided.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arraysEqual", ()=>arraysEqual);
/**
 * Shallow comparison between objects. If `keys` is provided, just that subset
 * of keys will be compared; otherwise, all keys will be compared.
 *
 * @returns true if items are equal.
 */ parcelHelpers.export(exports, "shallowCompareKeys", ()=>shallowCompareKeys);
/**
 * Deep comparison between objects. If `keys` is provided, just that subset of
 * keys will be compared; otherwise, all keys will be compared.
 *
 * @returns true if items are equal.
 */ parcelHelpers.export(exports, "deepCompareKeys", ()=>deepCompareKeys);
/**
 * Returns a descriptive object for each key whose values are deeply unequal
 * between two provided objects. Useful for debugging shouldComponentUpdate.
 */ parcelHelpers.export(exports, "getDeepUnequalKeyValues", ()=>getDeepUnequalKeyValues);
function arraysEqual(arrA, arrB, compare) {
    if (compare === void 0) compare = function(a, b) {
        return a === b;
    };
    // treat `null` and `undefined` as the same
    if (arrA == null && arrB == null) return true;
    else if (arrA == null || arrB == null || arrA.length !== arrB.length) return false;
    else return arrA.every(function(a, i) {
        return compare(a, arrB[i]);
    });
}
function shallowCompareKeys(objA, objB, keys) {
    // treat `null` and `undefined` as the same
    if (objA == null && objB == null) return true;
    else if (objA == null || objB == null) return false;
    else if (Array.isArray(objA) || Array.isArray(objB)) return false;
    else if (keys != null) return shallowCompareKeysImpl(objA, objB, keys);
    else {
        // shallowly compare all keys from both objects
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        return shallowCompareKeysImpl(objA, objB, {
            include: keysA
        }) && shallowCompareKeysImpl(objA, objB, {
            include: keysB
        });
    }
}
function deepCompareKeys(objA, objB, keys) {
    if (objA === objB) return true;
    else if (objA == null && objB == null) // treat `null` and `undefined` as the same
    return true;
    else if (objA == null || objB == null) return false;
    else if (Array.isArray(objA) || Array.isArray(objB)) return arraysEqual(objA, objB, deepCompareKeys);
    else if (isSimplePrimitiveType(objA) || isSimplePrimitiveType(objB)) return objA === objB;
    else if (keys != null) return deepCompareKeysImpl(objA, objB, keys);
    else if (objA.constructor !== objB.constructor) return false;
    else {
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA == null || keysB == null) return false;
        if (keysA.length === 0 && keysB.length === 0) return true;
        return arraysEqual(keysA, keysB) && deepCompareKeysImpl(objA, objB, keysA);
    }
}
function getDeepUnequalKeyValues(objA, objB, keys) {
    if (objA === void 0) objA = {};
    if (objB === void 0) objB = {};
    var filteredKeys = keys == null ? unionKeys(objA, objB) : keys;
    return getUnequalKeyValues(objA, objB, filteredKeys, function(a, b, key) {
        return deepCompareKeys(a, b, [
            key
        ]);
    });
}
// Private helpers
// ===============
/**
 * Partial shallow comparison between objects using the given list of keys.
 */ function shallowCompareKeysImpl(objA, objB, keys) {
    return filterKeys(objA, objB, keys).every(function(key) {
        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && objA[key] === objB[key];
    });
}
/**
 * Partial deep comparison between objects using the given list of keys.
 */ function deepCompareKeysImpl(objA, objB, keys) {
    return keys.every(function(key) {
        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && deepCompareKeys(objA[key], objB[key]);
    });
}
function isSimplePrimitiveType(value) {
    return typeof value === "number" || typeof value === "string" || typeof value === "boolean";
}
function filterKeys(objA, objB, keys) {
    if (isAllowlist(keys)) return keys.include;
    else if (isDenylist(keys)) {
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        // merge keys from both objects into a big set for quick access
        var keySet_1 = arrayToObject(keysA.concat(keysB));
        // delete denied keys from the key set
        keys.exclude.forEach(function(key) {
            return delete keySet_1[key];
        });
        // return the remaining keys as an array
        return Object.keys(keySet_1);
    }
    return [];
}
function isAllowlist(keys) {
    return keys != null && keys.include != null;
}
function isDenylist(keys) {
    return keys != null && keys.exclude != null;
}
function arrayToObject(arr) {
    return arr.reduce(function(obj, element) {
        obj[element] = true;
        return obj;
    }, {});
}
function getUnequalKeyValues(objA, objB, keys, compareFn) {
    var unequalKeys = keys.filter(function(key) {
        return !compareFn(objA, objB, key);
    });
    var unequalKeyValues = unequalKeys.map(function(key) {
        return {
            key: key,
            valueA: objA[key],
            valueB: objB[key]
        };
    });
    return unequalKeyValues;
}
function unionKeys(objA, objB) {
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    var concatKeys = keysA.concat(keysB);
    var keySet = arrayToObject(concatKeys);
    return Object.keys(keySet);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"K845P":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @returns true if React is running in a client environment, and false if it's in a server */ parcelHelpers.export(exports, "hasDOMEnvironment", ()=>hasDOMEnvironment);
parcelHelpers.export(exports, "elementIsOrContains", ()=>elementIsOrContains);
/**
 * Checks whether the given element is inside something that looks like a text input.
 * This is particularly useful to determine if a keyboard event inside this element should take priority over hotkey
 * bindings / keyboard shortcut handlers.
 *
 * @returns true if the element is inside a text input
 */ parcelHelpers.export(exports, "elementIsTextInput", ()=>elementIsTextInput);
/**
 * Gets the active element in the document or shadow root (if an element is provided, and it's in the shadow DOM).
 */ parcelHelpers.export(exports, "getActiveElement", ()=>getActiveElement);
/**
 * Throttle an event on an EventTarget by wrapping it in a
 * `requestAnimationFrame` call. Returns the event handler that was bound to
 * given eventName so you can clean up after yourself.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/Events/scroll
 */ /* istanbul ignore next */ parcelHelpers.export(exports, "throttleEvent", ()=>throttleEvent);
/**
 * Throttle a callback by wrapping it in a `requestAnimationFrame` call. Returns
 * the throttled function.
 *
 * @see https://www.html5rocks.com/en/tutorials/speed/animations/
 */ parcelHelpers.export(exports, "throttleReactEventCallback", ()=>throttleReactEventCallback);
/**
 * Throttle a method by wrapping it in a `requestAnimationFrame` call. Returns
 * the throttled function.
 */ /* istanbul ignore next */ // eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "throttle", ()=>throttle);
parcelHelpers.export(exports, "clickElementOnKeyPress", ()=>clickElementOnKeyPress);
var _tslib = require("tslib");
function hasDOMEnvironment() {
    return typeof window !== "undefined" && window.document != null;
}
function elementIsOrContains(element, testElement) {
    return element === testElement || element.contains(testElement);
}
function elementIsTextInput(elem) {
    // we check these cases for unit testing, but this should not happen
    // during normal operation
    if (elem == null || elem.closest == null) return false;
    var editable = elem.closest("input, textarea, [contenteditable=true]");
    if (editable == null) return false;
    // don't let checkboxes, switches, and radio buttons prevent hotkey behavior
    if (editable.tagName.toLowerCase() === "input") {
        var inputType = editable.type;
        if (inputType === "checkbox" || inputType === "radio") return false;
    }
    // don't let read-only fields prevent hotkey behavior
    if (editable.readOnly) return false;
    return true;
}
function getActiveElement(element, options) {
    var _a;
    var rootNode = (_a = element === null || element === void 0 ? void 0 : element.getRootNode(options)) !== null && _a !== void 0 ? _a : document;
    var activeElement = rootNode.activeElement;
    return activeElement instanceof HTMLElement ? activeElement : null;
}
function throttleEvent(target, eventName, newEventName) {
    var throttledFunc = throttleImpl(function(event) {
        target.dispatchEvent(new CustomEvent(newEventName, event));
    });
    target.addEventListener(eventName, throttledFunc);
    return throttledFunc;
}
function throttleReactEventCallback(callback, options) {
    if (options === void 0) options = {};
    var throttledFunc = throttleImpl(callback, function(event2) {
        if (options.preventDefault) event2.preventDefault();
    }, // prevent React from reclaiming the event object before we reference it
    function(event2) {
        return event2.persist();
    });
    return throttledFunc;
}
function throttle(method) {
    return throttleImpl(method);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function throttleImpl(onAnimationFrameRequested, onBeforeIsRunningCheck, onAfterIsRunningCheck) {
    var isRunning = false;
    var func = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        onBeforeIsRunningCheck === null || onBeforeIsRunningCheck === void 0 || onBeforeIsRunningCheck.apply(void 0, args);
        if (isRunning) return;
        isRunning = true;
        onAfterIsRunningCheck === null || onAfterIsRunningCheck === void 0 || onAfterIsRunningCheck.apply(void 0, args);
        requestAnimationFrame(function() {
            onAnimationFrameRequested.apply(void 0, args);
            isRunning = false;
        });
    };
    return func;
}
function clickElementOnKeyPress(keys) {
    return function(e) {
        if (keys.some(function(key) {
            return e.key === key;
        })) {
            // Prevent spacebar from scrolling the page unless we're in a text field
            if (!elementIsTextInput(e.target)) e.preventDefault();
            e.target.dispatchEvent(new MouseEvent("click", (0, _tslib.__assign)((0, _tslib.__assign)({}, e), {
                view: undefined
            })));
        }
    };
}

},{"tslib":"b4wpY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfL7v":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns whether the value is a function. Acts as a type guard. */ /* istanbul ignore next */ // eslint-disable-next-line @typescript-eslint/ban-types
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
function isFunction(value) {
    return typeof value === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4NYrB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Returns whether bundler-injected variable `NODE_ENV` equals `env`. */ parcelHelpers.export(exports, "isNodeEnv", ()=>isNodeEnv);
/**
 * Returns the difference in length between two arrays. A `null` argument is
 * considered an empty list. The return value will be positive if `a` is longer
 * than `b`, negative if the opposite is true, and zero if their lengths are
 * equal.
 */ parcelHelpers.export(exports, "arrayLengthCompare", ()=>arrayLengthCompare);
/**
 * Returns true if the two numbers are within the given tolerance of each other.
 * This is useful to correct for floating point precision issues, less useful
 * for integers.
 */ parcelHelpers.export(exports, "approxEqual", ()=>approxEqual);
/**
 * Clamps the given number between min and max values. Returns value if within
 * range, or closest bound.
 */ parcelHelpers.export(exports, "clamp", ()=>clamp);
/** Returns the number of decimal places in the given number. */ parcelHelpers.export(exports, "countDecimalPlaces", ()=>countDecimalPlaces);
/** Generate a unique ID within a given namespace, using a simple counter-based implementation to avoid collisions. */ parcelHelpers.export(exports, "uniqueId", ()=>uniqueId);
/**
 * @returns `true` if the value is an empty string after trimming whitespace
 */ parcelHelpers.export(exports, "isEmptyString", ()=>isEmptyString);
var _errors = require("../errors");
function isNodeEnv(env) {
    return typeof NODE_ENV !== "undefined" && NODE_ENV === env;
}
function arrayLengthCompare(a, b) {
    if (a === void 0) a = [];
    if (b === void 0) b = [];
    return a.length - b.length;
}
function approxEqual(a, b, tolerance) {
    if (tolerance === void 0) tolerance = 0.00001;
    return Math.abs(a - b) <= tolerance;
}
function clamp(val, min, max) {
    if (val == null) return val;
    if (max < min) throw new Error((0, _errors.CLAMP_MIN_MAX));
    return Math.min(Math.max(val, min), max);
}
function countDecimalPlaces(num) {
    if (!isFinite(num)) return 0;
    var e = 1;
    var p = 0;
    while(Math.round(num * e) / e !== num){
        e *= 10;
        p++;
    }
    return p;
}
var uniqueCountForNamespace = new Map();
function uniqueId(namespace) {
    var _a;
    var curCount = (_a = uniqueCountForNamespace.get(namespace)) !== null && _a !== void 0 ? _a : 0;
    uniqueCountForNamespace.set(namespace, curCount + 1);
    return "".concat(namespace, "-").concat(curCount);
}
function isEmptyString(val) {
    return typeof val === "string" && val.trim().length === 0;
}

},{"../errors":"lyD8m","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lyD8m":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLAMP_MIN_MAX", ()=>CLAMP_MIN_MAX);
parcelHelpers.export(exports, "ALERT_WARN_CANCEL_PROPS", ()=>ALERT_WARN_CANCEL_PROPS);
parcelHelpers.export(exports, "ALERT_WARN_CANCEL_ESCAPE_KEY", ()=>ALERT_WARN_CANCEL_ESCAPE_KEY);
parcelHelpers.export(exports, "ALERT_WARN_CANCEL_OUTSIDE_CLICK", ()=>ALERT_WARN_CANCEL_OUTSIDE_CLICK);
parcelHelpers.export(exports, "HOTKEYS_HOTKEY_CHILDREN", ()=>HOTKEYS_HOTKEY_CHILDREN);
parcelHelpers.export(exports, "HOTKEYS_PROVIDER_NOT_FOUND", ()=>HOTKEYS_PROVIDER_NOT_FOUND);
parcelHelpers.export(exports, "HOTKEYS_TARGET_CHILDREN_LOCAL_HOTKEYS", ()=>HOTKEYS_TARGET_CHILDREN_LOCAL_HOTKEYS);
parcelHelpers.export(exports, "INPUT_WARN_LEFT_ELEMENT_LEFT_ICON_MUTEX", ()=>INPUT_WARN_LEFT_ELEMENT_LEFT_ICON_MUTEX);
parcelHelpers.export(exports, "NUMERIC_INPUT_MIN_MAX", ()=>NUMERIC_INPUT_MIN_MAX);
parcelHelpers.export(exports, "NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND", ()=>NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND);
parcelHelpers.export(exports, "NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND", ()=>NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND);
parcelHelpers.export(exports, "NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE", ()=>NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE);
parcelHelpers.export(exports, "NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE", ()=>NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE);
parcelHelpers.export(exports, "NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE", ()=>NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE);
parcelHelpers.export(exports, "NUMERIC_INPUT_CONTROLLED_VALUE_INVALID", ()=>NUMERIC_INPUT_CONTROLLED_VALUE_INVALID);
parcelHelpers.export(exports, "PANEL_STACK_INITIAL_PANEL_STACK_MUTEX", ()=>PANEL_STACK_INITIAL_PANEL_STACK_MUTEX);
parcelHelpers.export(exports, "PANEL_STACK_REQUIRES_PANEL", ()=>PANEL_STACK_REQUIRES_PANEL);
parcelHelpers.export(exports, "OVERFLOW_LIST_OBSERVE_PARENTS_CHANGED", ()=>OVERFLOW_LIST_OBSERVE_PARENTS_CHANGED);
parcelHelpers.export(exports, "POPOVER_REQUIRES_TARGET", ()=>POPOVER_REQUIRES_TARGET);
parcelHelpers.export(exports, "POPOVER_HAS_BACKDROP_INTERACTION", ()=>POPOVER_HAS_BACKDROP_INTERACTION);
parcelHelpers.export(exports, "POPOVER_WARN_TOO_MANY_CHILDREN", ()=>POPOVER_WARN_TOO_MANY_CHILDREN);
parcelHelpers.export(exports, "POPOVER_WARN_DOUBLE_TARGET", ()=>POPOVER_WARN_DOUBLE_TARGET);
parcelHelpers.export(exports, "POPOVER_WARN_EMPTY_CONTENT", ()=>POPOVER_WARN_EMPTY_CONTENT);
parcelHelpers.export(exports, "POPOVER_WARN_HAS_BACKDROP_INLINE", ()=>POPOVER_WARN_HAS_BACKDROP_INLINE);
parcelHelpers.export(exports, "POPOVER_WARN_PLACEMENT_AND_POSITION_MUTEX", ()=>POPOVER_WARN_PLACEMENT_AND_POSITION_MUTEX);
parcelHelpers.export(exports, "POPOVER_WARN_UNCONTROLLED_ONINTERACTION", ()=>POPOVER_WARN_UNCONTROLLED_ONINTERACTION);
parcelHelpers.export(exports, "POPOVER_WARN_TARGET_PROPS_WITH_RENDER_TARGET", ()=>POPOVER_WARN_TARGET_PROPS_WITH_RENDER_TARGET);
parcelHelpers.export(exports, "PORTAL_CONTEXT_CLASS_NAME_STRING", ()=>PORTAL_CONTEXT_CLASS_NAME_STRING);
parcelHelpers.export(exports, "PORTAL_LEGACY_CONTEXT_API", ()=>PORTAL_LEGACY_CONTEXT_API);
parcelHelpers.export(exports, "RADIOGROUP_WARN_CHILDREN_OPTIONS_MUTEX", ()=>RADIOGROUP_WARN_CHILDREN_OPTIONS_MUTEX);
parcelHelpers.export(exports, "SLIDER_ZERO_STEP", ()=>SLIDER_ZERO_STEP);
parcelHelpers.export(exports, "SLIDER_ZERO_LABEL_STEP", ()=>SLIDER_ZERO_LABEL_STEP);
parcelHelpers.export(exports, "SLIDER_MIN", ()=>SLIDER_MIN);
parcelHelpers.export(exports, "SLIDER_MAX", ()=>SLIDER_MAX);
parcelHelpers.export(exports, "RANGESLIDER_NULL_VALUE", ()=>RANGESLIDER_NULL_VALUE);
parcelHelpers.export(exports, "MULTISLIDER_INVALID_CHILD", ()=>MULTISLIDER_INVALID_CHILD);
parcelHelpers.export(exports, "MULTISLIDER_WARN_LABEL_STEP_SIZE_LABEL_VALUES_MUTEX", ()=>MULTISLIDER_WARN_LABEL_STEP_SIZE_LABEL_VALUES_MUTEX);
parcelHelpers.export(exports, "SPINNER_WARN_CLASSES_SIZE", ()=>SPINNER_WARN_CLASSES_SIZE);
parcelHelpers.export(exports, "TOASTER_CREATE_NULL", ()=>TOASTER_CREATE_NULL);
parcelHelpers.export(exports, "TOASTER_CREATE_ASYNC_NULL", ()=>TOASTER_CREATE_ASYNC_NULL);
parcelHelpers.export(exports, "TOASTER_MAX_TOASTS_INVALID", ()=>TOASTER_MAX_TOASTS_INVALID);
parcelHelpers.export(exports, "TOASTER_WARN_INLINE", ()=>TOASTER_WARN_INLINE);
parcelHelpers.export(exports, "DIALOG_WARN_NO_HEADER_ICON", ()=>DIALOG_WARN_NO_HEADER_ICON);
parcelHelpers.export(exports, "DIALOG_WARN_NO_HEADER_CLOSE_BUTTON", ()=>DIALOG_WARN_NO_HEADER_CLOSE_BUTTON);
parcelHelpers.export(exports, "DRAWER_ANGLE_POSITIONS_ARE_CASTED", ()=>DRAWER_ANGLE_POSITIONS_ARE_CASTED);
parcelHelpers.export(exports, "OVERLAY2_REQUIRES_OVERLAY_PROVDER", ()=>OVERLAY2_REQUIRES_OVERLAY_PROVDER);
parcelHelpers.export(exports, "OVERLAY_CHILD_REF_AND_REFS_MUTEX", ()=>OVERLAY_CHILD_REF_AND_REFS_MUTEX);
parcelHelpers.export(exports, "OVERLAY_WITH_MULTIPLE_CHILDREN_REQUIRES_CHILD_REFS", ()=>OVERLAY_WITH_MULTIPLE_CHILDREN_REQUIRES_CHILD_REFS);
parcelHelpers.export(exports, "OVERLAY_CHILD_REQUIRES_KEY", ()=>OVERLAY_CHILD_REQUIRES_KEY);
var ns = "[Blueprint]";
var CLAMP_MIN_MAX = ns + " clamp: max cannot be less than min";
var ALERT_WARN_CANCEL_PROPS = ns + " <Alert> cancelButtonText and onCancel should be set together.";
var ALERT_WARN_CANCEL_ESCAPE_KEY = ns + " <Alert> canEscapeKeyCancel enabled without onCancel or onClose handler.";
var ALERT_WARN_CANCEL_OUTSIDE_CLICK = ns + " <Alert> canOutsideClickCancel enabled without onCancel or onClose handler.";
var HOTKEYS_HOTKEY_CHILDREN = ns + " <Hotkeys> only accepts <Hotkey> children.";
var HOTKEYS_PROVIDER_NOT_FOUND = ns + " useHotkeys() was used outside of a <HotkeysProvider> context. These hotkeys will not be shown in the hotkeys help dialog.";
var HOTKEYS_TARGET_CHILDREN_LOCAL_HOTKEYS = ns + " <HotkeysTarget2> was configured with local hotkeys, but you did not use the generated event handlers to bind their event handlers. Try using a render function as the child of this component.";
var INPUT_WARN_LEFT_ELEMENT_LEFT_ICON_MUTEX = ns + " <InputGroup> leftElement and leftIcon prop are mutually exclusive, with leftElement taking priority.";
var NUMERIC_INPUT_MIN_MAX = ns + " <NumericInput> requires min to be no greater than max if both are defined.";
var NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND = ns + " <NumericInput> requires minorStepSize to be no greater than stepSize.";
var NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND = ns + " <NumericInput> requires stepSize to be no greater than majorStepSize.";
var NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires minorStepSize to be strictly greater than zero.";
var NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires majorStepSize to be strictly greater than zero.";
var NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires stepSize to be strictly greater than zero.";
var NUMERIC_INPUT_CONTROLLED_VALUE_INVALID = ns + " <NumericInput> controlled value prop does not adhere to stepSize, min, and/or max constraints.";
var PANEL_STACK_INITIAL_PANEL_STACK_MUTEX = ns + " <PanelStack> requires exactly one of initialPanel and stack prop";
var PANEL_STACK_REQUIRES_PANEL = ns + " <PanelStack> requires at least one panel in the stack";
var OVERFLOW_LIST_OBSERVE_PARENTS_CHANGED = ns + " <OverflowList> does not support changing observeParents after mounting.";
var POPOVER_REQUIRES_TARGET = "".concat(ns, " <Popover> requires renderTarget prop or a child element.");
var POPOVER_HAS_BACKDROP_INTERACTION = "".concat(ns, " <Popover hasBackdrop={true}> requires interactionKind=\"click\".");
var POPOVER_WARN_TOO_MANY_CHILDREN = "".concat(ns, " <Popover> supports only one child which is rendered as its target; additional children are ignored.");
var POPOVER_WARN_DOUBLE_TARGET = ns + " <Popover> with children ignores renderTarget prop; use either prop or children.";
var POPOVER_WARN_EMPTY_CONTENT = ns + " Disabling <Popover> with empty/whitespace content...";
var POPOVER_WARN_HAS_BACKDROP_INLINE = ns + " <Popover usePortal={false}> ignores hasBackdrop";
var POPOVER_WARN_PLACEMENT_AND_POSITION_MUTEX = ns + " <Popover> supports either placement or position prop, not both.";
var POPOVER_WARN_UNCONTROLLED_ONINTERACTION = ns + " <Popover> onInteraction is ignored when uncontrolled.";
var POPOVER_WARN_TARGET_PROPS_WITH_RENDER_TARGET = ns + " <Popover> targetProps value is ignored when renderTarget API is used.";
var PORTAL_CONTEXT_CLASS_NAME_STRING = ns + " <Portal> context blueprintPortalClassName must be string";
var PORTAL_LEGACY_CONTEXT_API = ns + " setting blueprintPortalClassName via legacy React context API is deprecated, use <PortalProvider> instead.";
var RADIOGROUP_WARN_CHILDREN_OPTIONS_MUTEX = ns + " <RadioGroup> children and options prop are mutually exclusive, with options taking priority.";
var SLIDER_ZERO_STEP = ns + " <Slider> stepSize must be greater than zero.";
var SLIDER_ZERO_LABEL_STEP = ns + " <Slider> labelStepSize must be greater than zero.";
var SLIDER_MIN = ns + " <Slider> min prop must be a finite number.";
var SLIDER_MAX = ns + " <Slider> max prop must be a finite number.";
var RANGESLIDER_NULL_VALUE = ns + " <RangeSlider> value prop must be an array of two non-null numbers.";
var MULTISLIDER_INVALID_CHILD = ns + " <MultiSlider> children must be <SliderHandle>s or <SliderTrackStop>s";
var MULTISLIDER_WARN_LABEL_STEP_SIZE_LABEL_VALUES_MUTEX = ns + " <MultiSlider> labelStepSize and labelValues prop are mutually exclusive, with labelStepSize taking priority.";
var SPINNER_WARN_CLASSES_SIZE = ns + " <Spinner> Classes.SMALL/LARGE are ignored if size prop is set.";
var TOASTER_CREATE_NULL = ns + " OverlayToaster.create() is not supported inside React lifecycle methods in React 16." + " See usage example on the docs site. https://blueprintjs.com/docs/#core/components/toast.example";
var TOASTER_CREATE_ASYNC_NULL = ns + " OverlayToaster.createAsync() received a null component ref. This can happen if called inside React lifecycle " + "methods in React 16. See usage example on the docs site. " + "https://blueprintjs.com/docs/#core/components/toast.example";
var TOASTER_MAX_TOASTS_INVALID = ns + " <OverlayToaster> maxToasts is set to an invalid number, must be greater than 0";
var TOASTER_WARN_INLINE = ns + " OverlayToaster.create() ignores inline prop as it always creates a new element.";
var DIALOG_WARN_NO_HEADER_ICON = ns + " <Dialog> iconName is ignored if title is omitted.";
var DIALOG_WARN_NO_HEADER_CLOSE_BUTTON = ns + " <Dialog> isCloseButtonShown prop is ignored if title is omitted.";
var DRAWER_ANGLE_POSITIONS_ARE_CASTED = ns + " <Drawer> all angle positions are casted into pure position (TOP, BOTTOM, LEFT or RIGHT)";
var OVERLAY2_REQUIRES_OVERLAY_PROVDER = ns + " <Overlay2> was used outside of a <OverlaysProvider> context. This will no longer be supported in " + "Blueprint v6. See https://github.com/palantir/blueprint/wiki/Overlay2-migration";
var OVERLAY_CHILD_REF_AND_REFS_MUTEX = ns + " <Overlay2> cannot use childRef and childRefs props simultaneously";
var OVERLAY_WITH_MULTIPLE_CHILDREN_REQUIRES_CHILD_REFS = ns + " <Overlay2> requires childRefs prop when rendering multiple child elements";
var OVERLAY_CHILD_REQUIRES_KEY = ns + " <Overlay2> requires each child element to have a unique key prop when childRefs is used";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3wQbM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns true if `node` is null/undefined, false, empty string, or an array
 * composed of those. If `node` is an array, only one level of the array is
 * checked, for performance reasons.
 */ parcelHelpers.export(exports, "isReactNodeEmpty", ()=>isReactNodeEmpty);
/**
 * Returns true if children are a mappable children array
 *
 * @internal
 */ parcelHelpers.export(exports, "isReactChildrenElementOrElements", ()=>isReactChildrenElementOrElements);
/**
 * Converts a React node to an element. Non-empty strings, numbers, and Fragments will be wrapped in given tag name;
 * empty strings and booleans will be discarded.
 *
 * @param child     the React node to convert
 * @param tagName   the HTML tag name to use when a wrapper element is needed
 * @param props     additional props to spread onto the element, if any. If the child is a React element and this argument
 *                  is defined, the child will be cloned and these props will be merged in.
 */ parcelHelpers.export(exports, "ensureElement", ()=>ensureElement);
parcelHelpers.export(exports, "isReactElement", ()=>isReactElement);
/**
 * Returns true if the given JSX element matches the given component type.
 *
 * NOTE: This function only checks equality of `displayName` for performance and
 * to tolerate multiple minor versions of a component being included in one
 * application bundle.
 *
 * @param element JSX element in question
 * @param ComponentType desired component type of element
 */ // eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "isElementOfType", ()=>isElementOfType);
parcelHelpers.export(exports, "isReact18", ()=>isReact18);
var _react = require("react");
var _jsUtils = require("./jsUtils");
function isReactNodeEmpty(node, skipArray) {
    if (skipArray === void 0) skipArray = false;
    return node == null || node === "" || node === false || !skipArray && Array.isArray(node) && // only recurse one level through arrays, for performance
    (node.length === 0 || node.every(function(n) {
        return isReactNodeEmpty(n, true);
    }));
}
function isReactChildrenElementOrElements(children) {
    return !isReactNodeEmpty(children, true) && children !== true;
}
function ensureElement(child, tagName, props) {
    if (tagName === void 0) tagName = "span";
    if (props === void 0) props = {};
    if (child == null || typeof child === "boolean" || (0, _jsUtils.isEmptyString)(child)) return undefined;
    else if (typeof child === "string" || typeof child === "number" || isReactFragment(child) || isReactNodeArray(child)) // wrap the child element
    return _react.createElement(tagName, props, child);
    else if (isReactElement(child)) {
        if (Object.keys(props).length > 0) // clone the element and merge props
        return _react.cloneElement(child, props);
        else // nothing to do, it's a valid ReactElement
        return child;
    } else // child is inferred as {}
    return undefined;
}
function isReactElement(child) {
    return typeof child === "object" && typeof child.type !== "undefined" && typeof child.props !== "undefined";
}
function isReactFragment(child) {
    // bit hacky, but generally works
    return typeof child.type === "symbol";
}
function isReactNodeArray(child) {
    return Array.isArray(child);
}
function isElementOfType(element, ComponentType) {
    return element != null && element.type != null && element.type.displayName != null && element.type.displayName === ComponentType.displayName;
}
function isReact18() {
    return _react.version.startsWith("18");
}

},{"react":"9njXz","./jsUtils":"4NYrB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dVvHj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns whether the keyboard event was triggered by Enter or Space, the two keys that are expected to trigger
 * interactive elements like buttons.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isKeyboardClick", ()=>isKeyboardClick);
parcelHelpers.export(exports, "isArrowKey", ()=>isArrowKey);
/** Direction multiplier */ parcelHelpers.export(exports, "getArrowKeyDirection", ()=>getArrowKeyDirection);
function isKeyboardClick(event) {
    return event.key === "Enter" || event.key === " ";
}
var ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
function isArrowKey(event) {
    return ARROW_KEYS.includes(event.key);
}
function getArrowKeyDirection(event, /** Keys that result in a return of -1 */ negativeKeys, /** Keys that result in a return of 1 */ positiveKeys) {
    if (negativeKeys.includes(event.key)) return -1;
    else if (positiveKeys.includes(event.key)) return 1;
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fQ3IJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDarkTheme", ()=>isDarkTheme);
var _classes = require("../classes");
function isDarkTheme(element) {
    return element != null && element instanceof Element && element.closest(".".concat(_classes.DARK)) != null;
}

},{"../classes":"2PICA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"krjx8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRefObject", ()=>isRefObject);
parcelHelpers.export(exports, "isRefCallback", ()=>isRefCallback);
/**
 * Assign the given ref to a target, either a React ref object or a callback which takes the ref as its first argument.
 */ parcelHelpers.export(exports, "setRef", ()=>setRef);
/**
 * Utility for merging refs into one singular callback ref.
 * If using in a functional component, would recomend using `useMemo` to preserve function identity.
 */ parcelHelpers.export(exports, "mergeRefs", ()=>mergeRefs);
parcelHelpers.export(exports, "getRef", ()=>getRef);
/**
 * Creates a ref handler which assigns the ref returned by React for a mounted component to a field on the target object.
 * The target object is usually a component class.
 *
 * If provided, it will also update the given `refProp` with the value of the ref.
 */ parcelHelpers.export(exports, "refHandler", ()=>refHandler);
function isRefObject(value) {
    return value != null && typeof value !== "function";
}
function isRefCallback(value) {
    return typeof value === "function";
}
function setRef(refTarget, ref) {
    if (isRefObject(refTarget)) // HACKHACK: .current property is readonly
    refTarget.current = ref;
    else if (isRefCallback(refTarget)) refTarget(ref);
}
function mergeRefs() {
    var refs = [];
    for(var _i = 0; _i < arguments.length; _i++)refs[_i] = arguments[_i];
    return function(value) {
        refs.forEach(function(ref) {
            setRef(ref, value);
        });
    };
}
function getRef(ref) {
    if (ref === null) return null;
    if (typeof ref.current === "undefined") return ref;
    return ref.current;
}
function refHandler(refTargetParent, refTargetKey, refProp) {
    return function(ref) {
        refTargetParent[refTargetKey] = ref;
        setRef(refProp, ref);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bXQVd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2019 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractPureComponent", ()=>AbstractPureComponent);
var _tslib = require("tslib");
var _react = require("react");
var _utils = require("./utils");
/**
 * An abstract component that Blueprint components can extend
 * in order to add some common functionality like runtime props validation.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
var AbstractPureComponent = /** @class */ function(_super) {
    (0, _tslib.__extends)(AbstractPureComponent, _super);
    function AbstractPureComponent(props) {
        var _this = _super.call(this, props) || this;
        // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
        _this.timeoutIds = [];
        _this.requestIds = [];
        /**
         * Clear all known timeouts.
         */ _this.clearTimeouts = function() {
            if (_this.timeoutIds.length > 0) {
                for(var _i = 0, _a = _this.timeoutIds; _i < _a.length; _i++){
                    var timeoutId = _a[_i];
                    window.clearTimeout(timeoutId);
                }
                _this.timeoutIds = [];
            }
        };
        /**
         * Clear all known animation frame requests.
         */ _this.cancelAnimationFrames = function() {
            if (_this.requestIds.length > 0) {
                for(var _i = 0, _a = _this.requestIds; _i < _a.length; _i++){
                    var requestId = _a[_i];
                    window.cancelAnimationFrame(requestId);
                }
                _this.requestIds = [];
            }
        };
        if (!(0, _utils.isNodeEnv)("production")) _this.validateProps(_this.props);
        return _this;
    }
    AbstractPureComponent.prototype.componentDidUpdate = function(_prevProps, _prevState, _snapshot) {
        if (!(0, _utils.isNodeEnv)("production")) this.validateProps(this.props);
    };
    AbstractPureComponent.prototype.componentWillUnmount = function() {
        this.clearTimeouts();
        this.cancelAnimationFrames();
    };
    /**
     * Request an animation frame and remember its ID.
     * All pending requests will be canceled when component unmounts.
     *
     * @returns a "cancel" function that will cancel the request when invoked.
     */ AbstractPureComponent.prototype.requestAnimationFrame = function(callback) {
        var handle = window.requestAnimationFrame(callback);
        this.requestIds.push(handle);
        return function() {
            return window.cancelAnimationFrame(handle);
        };
    };
    /**
     * Set a timeout and remember its ID.
     * All pending timeouts will be cleared when component unmounts.
     *
     * @returns a "cancel" function that will clear timeout when invoked.
     */ AbstractPureComponent.prototype.setTimeout = function(callback, timeout) {
        var handle = window.setTimeout(callback, timeout);
        this.timeoutIds.push(handle);
        return function() {
            return window.clearTimeout(handle);
        };
    };
    /**
     * Ensures that the props specified for a component are valid.
     * Implementations should check that props are valid and usually throw an Error if they are not.
     * Implementations should not duplicate checks that the type system already guarantees.
     *
     * This method should be used instead of React's
     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
     * Like propTypes, these runtime checks run only in development mode.
     */ AbstractPureComponent.prototype.validateProps = function(_props) {
    // implement in subclass
    };
    return AbstractPureComponent;
}(_react.PureComponent);

},{"tslib":"b4wpY","react":"9njXz","./utils":"56UdR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0lXiF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Boundary of a one-dimensional interval. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Boundary", ()=>Boundary);
var Boundary = {
    START: "start",
    // tslint:disable-next-line:object-literal-sort-keys
    END: "end"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4qg7S":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // tslint:disable object-literal-sort-keys
/** @deprecated use named keys instead of key codes */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyCodes", ()=>KeyCodes);
var KeyCodes = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    ESCAPE: 27,
    SPACE: 32,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    DELETE: 46
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dBcIV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DISPLAYNAME_PREFIX", ()=>DISPLAYNAME_PREFIX);
/**
 * Typically applied to HTMLElements to filter out disallowed props. When applied to a Component,
 * can filter props from being passed down to the children. Can also filter by a combined list of
 * supplied prop keys and the denylist (only appropriate for HTMLElements).
 *
 * @param props The original props object to filter down.
 * @param {string[]} invalidProps If supplied, overwrites the default denylist.
 * @param {boolean} shouldMerge If true, will merge supplied invalidProps and denylist together.
 */ parcelHelpers.export(exports, "removeNonHTMLProps", ()=>removeNonHTMLProps);
var _tslib = require("tslib");
var DISPLAYNAME_PREFIX = "Blueprint5";
/** A collection of curated prop keys used across our Components which are not valid HTMLElement props. */ var INVALID_PROPS = [
    "active",
    "alignText",
    "asyncControl",
    "containerRef",
    "current",
    "elementRef",
    "ellipsizeText",
    "fill",
    "icon",
    "iconSize",
    "inputClassName",
    "inputRef",
    "intent",
    "inline",
    "large",
    "loading",
    "leftElement",
    "leftIcon",
    "minimal",
    "onRemove",
    "outlined",
    "panel",
    "panelClassName",
    "popoverProps",
    "rightElement",
    "rightIcon",
    "round",
    "selectedValue",
    "size",
    "small",
    "tagName",
    "text",
    "textClassName"
];
function removeNonHTMLProps(props, invalidProps, shouldMerge) {
    if (invalidProps === void 0) invalidProps = INVALID_PROPS;
    if (shouldMerge === void 0) shouldMerge = false;
    if (shouldMerge) invalidProps = invalidProps.concat(INVALID_PROPS);
    return invalidProps.reduce(function(prev, curr) {
        // Props with hyphens (e.g. data-*) are always considered html props
        if (curr.indexOf("-") !== -1) return prev;
        if (prev.hasOwnProperty(curr)) delete prev[curr];
        return prev;
    }, (0, _tslib.__assign)({}, props));
}

},{"tslib":"b4wpY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Av90":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alert", ()=>(0, _alert.Alert));
parcelHelpers.export(exports, "Breadcrumb", ()=>(0, _breadcrumb.Breadcrumb));
parcelHelpers.export(exports, "Breadcrumbs", ()=>(0, _breadcrumbs.Breadcrumbs));
parcelHelpers.export(exports, "AnchorButton", ()=>(0, _buttons.AnchorButton));
parcelHelpers.export(exports, "Button", ()=>(0, _buttons.Button));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroup.ButtonGroup));
parcelHelpers.export(exports, "Callout", ()=>(0, _callout.Callout));
parcelHelpers.export(exports, "Card", ()=>(0, _card.Card));
parcelHelpers.export(exports, "CardList", ()=>(0, _cardList.CardList));
parcelHelpers.export(exports, "Collapse", ()=>(0, _collapse.Collapse));
parcelHelpers.export(exports, "ContextMenu", ()=>(0, _contextMenu.ContextMenu));
parcelHelpers.export(exports, "ContextMenuPopover", ()=>(0, _contextMenuPopover.ContextMenuPopover));
parcelHelpers.export(exports, "showContextMenu", ()=>(0, _contextMenuSingleton.showContextMenu));
parcelHelpers.export(exports, "hideContextMenu", ()=>(0, _contextMenuSingleton.hideContextMenu));
parcelHelpers.export(exports, "Dialog", ()=>(0, _dialog.Dialog));
parcelHelpers.export(exports, "DialogBody", ()=>(0, _dialogBody.DialogBody));
parcelHelpers.export(exports, "DialogFooter", ()=>(0, _dialogFooter.DialogFooter));
parcelHelpers.export(exports, "DialogStep", ()=>(0, _dialogStep.DialogStep));
parcelHelpers.export(exports, "MultistepDialog", ()=>(0, _multistepDialog.MultistepDialog));
parcelHelpers.export(exports, "Divider", ()=>(0, _divider.Divider));
parcelHelpers.export(exports, "Drawer", ()=>(0, _drawer.Drawer));
parcelHelpers.export(exports, "DrawerSize", ()=>(0, _drawer.DrawerSize));
parcelHelpers.export(exports, "EditableText", ()=>(0, _editableText.EditableText));
parcelHelpers.export(exports, "ControlGroup", ()=>(0, _controlGroup.ControlGroup));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _controls.Checkbox));
parcelHelpers.export(exports, "Radio", ()=>(0, _controls.Radio));
parcelHelpers.export(exports, "Switch", ()=>(0, _controls.Switch));
parcelHelpers.export(exports, "EntityTitle", ()=>(0, _entityTitle.EntityTitle));
parcelHelpers.export(exports, "FileInput", ()=>(0, _fileInput.FileInput));
parcelHelpers.export(exports, "FormGroup", ()=>(0, _formGroup.FormGroup));
parcelHelpers.export(exports, "InputGroup", ()=>(0, _inputGroup.InputGroup));
parcelHelpers.export(exports, "NumericInput", ()=>(0, _numericInput.NumericInput));
parcelHelpers.export(exports, "RadioGroup", ()=>(0, _radioGroup.RadioGroup));
parcelHelpers.export(exports, "TextArea", ()=>(0, _textArea.TextArea));
parcelHelpers.export(exports, "Blockquote", ()=>(0, _html.Blockquote));
parcelHelpers.export(exports, "Code", ()=>(0, _html.Code));
parcelHelpers.export(exports, "H1", ()=>(0, _html.H1));
parcelHelpers.export(exports, "H2", ()=>(0, _html.H2));
parcelHelpers.export(exports, "H3", ()=>(0, _html.H3));
parcelHelpers.export(exports, "H4", ()=>(0, _html.H4));
parcelHelpers.export(exports, "H5", ()=>(0, _html.H5));
parcelHelpers.export(exports, "H6", ()=>(0, _html.H6));
parcelHelpers.export(exports, "Label", ()=>(0, _html.Label));
parcelHelpers.export(exports, "OL", ()=>(0, _html.OL));
parcelHelpers.export(exports, "Pre", ()=>(0, _html.Pre));
parcelHelpers.export(exports, "UL", ()=>(0, _html.UL));
parcelHelpers.export(exports, "HTMLSelect", ()=>(0, _htmlSelect.HTMLSelect));
parcelHelpers.export(exports, "HTMLTable", ()=>(0, _htmlTable.HTMLTable));
parcelHelpers.export(exports, "Icon", ()=>(0, _icon.Icon));
parcelHelpers.export(exports, "IconSize", ()=>(0, _icon.IconSize));
parcelHelpers.export(exports, "Menu", ()=>(0, _menu.Menu));
parcelHelpers.export(exports, "MenuDivider", ()=>(0, _menuDivider.MenuDivider));
parcelHelpers.export(exports, "MenuItem", ()=>(0, _menuItem.MenuItem));
parcelHelpers.export(exports, "Navbar", ()=>(0, _navbar.Navbar));
parcelHelpers.export(exports, "NavbarDivider", ()=>(0, _navbarDivider.NavbarDivider));
parcelHelpers.export(exports, "NavbarGroup", ()=>(0, _navbarGroup.NavbarGroup));
parcelHelpers.export(exports, "NavbarHeading", ()=>(0, _navbarHeading.NavbarHeading));
parcelHelpers.export(exports, "NonIdealState", ()=>(0, _nonIdealState.NonIdealState));
parcelHelpers.export(exports, "NonIdealStateIconSize", ()=>(0, _nonIdealState.NonIdealStateIconSize));
parcelHelpers.export(exports, "OverflowList", ()=>(0, _overflowList.OverflowList));
// eslint-disable-next-line deprecation/deprecation
parcelHelpers.export(exports, "Overlay", ()=>(0, _overlay.Overlay));
parcelHelpers.export(exports, "Overlay2", ()=>(0, _overlay2.Overlay2));
parcelHelpers.export(exports, "Text", ()=>(0, _text.Text));
// eslint-disable-next-line deprecation/deprecation
parcelHelpers.export(exports, "PanelStack", ()=>(0, _panelStack.PanelStack));
parcelHelpers.export(exports, "PanelStack2", ()=>(0, _panelStack2.PanelStack2));
parcelHelpers.export(exports, "Popover", ()=>(0, _popover.Popover));
parcelHelpers.export(exports, "PopoverInteractionKind", ()=>(0, _popover.PopoverInteractionKind));
parcelHelpers.export(exports, "PopoverPosition", ()=>(0, _popoverPosition.PopoverPosition));
parcelHelpers.export(exports, "PopperPlacements", ()=>(0, _popperUtils.PopperPlacements));
parcelHelpers.export(exports, "PopupKind", ()=>(0, _popupKind.PopupKind));
parcelHelpers.export(exports, "Portal", ()=>(0, _portal.Portal));
parcelHelpers.export(exports, "ProgressBar", ()=>(0, _progressBar.ProgressBar));
parcelHelpers.export(exports, "ResizeSensor", ()=>(0, _resizeSensor.ResizeSensor));
parcelHelpers.export(exports, "HandleInteractionKind", ()=>(0, _handleProps.HandleInteractionKind));
parcelHelpers.export(exports, "HandleType", ()=>(0, _handleProps.HandleType));
parcelHelpers.export(exports, "MultiSlider", ()=>(0, _multiSlider.MultiSlider));
parcelHelpers.export(exports, "RangeSlider", ()=>(0, _rangeSlider.RangeSlider));
parcelHelpers.export(exports, "Section", ()=>(0, _section.Section));
parcelHelpers.export(exports, "SectionCard", ()=>(0, _sectionCard.SectionCard));
parcelHelpers.export(exports, "SegmentedControl", ()=>(0, _segmentedControl.SegmentedControl));
parcelHelpers.export(exports, "Slider", ()=>(0, _slider.Slider));
parcelHelpers.export(exports, "Spinner", ()=>(0, _spinner.Spinner));
parcelHelpers.export(exports, "SpinnerSize", ()=>(0, _spinner.SpinnerSize));
parcelHelpers.export(exports, "CheckboxCard", ()=>(0, _checkboxCard.CheckboxCard));
parcelHelpers.export(exports, "RadioCard", ()=>(0, _radioCard.RadioCard));
parcelHelpers.export(exports, "SwitchCard", ()=>(0, _switchCard.SwitchCard));
parcelHelpers.export(exports, "Tab", ()=>(0, _tab.Tab));
parcelHelpers.export(exports, "TabPanel", ()=>(0, _tabPanel.TabPanel));
// eslint-disable-next-line deprecation/deprecation
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabs.Tabs));
parcelHelpers.export(exports, "TabsExpander", ()=>(0, _tabs.TabsExpander));
parcelHelpers.export(exports, "Expander", ()=>(0, _tabs.Expander));
parcelHelpers.export(exports, "CompoundTag", ()=>(0, _compoundTag.CompoundTag));
parcelHelpers.export(exports, "Tag", ()=>(0, _tag.Tag));
parcelHelpers.export(exports, "TagInput", ()=>(0, _tagInput.TagInput));
parcelHelpers.export(exports, "OverlayToaster", ()=>(0, _overlayToaster.OverlayToaster));
// eslint-disable-next-line deprecation/deprecation
parcelHelpers.export(exports, "Toast", ()=>(0, _toast.Toast));
parcelHelpers.export(exports, "Toast2", ()=>(0, _toast2.Toast2));
parcelHelpers.export(exports, "Toaster", ()=>(0, _toaster.Toaster));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltip.Tooltip));
parcelHelpers.export(exports, "Tree", ()=>(0, _tree.Tree));
parcelHelpers.export(exports, "TreeNode", ()=>(0, _treeNode.TreeNode));
var _alert = require("./alert/alert");
var _breadcrumb = require("./breadcrumbs/breadcrumb");
var _breadcrumbs = require("./breadcrumbs/breadcrumbs");
var _buttons = require("./button/buttons");
var _buttonGroup = require("./button/buttonGroup");
var _callout = require("./callout/callout");
var _card = require("./card/card");
var _cardList = require("./card-list/cardList");
var _collapse = require("./collapse/collapse");
var _contextMenu = require("./context-menu/contextMenu");
var _contextMenuPopover = require("./context-menu/contextMenuPopover");
var _contextMenuSingleton = require("./context-menu/contextMenuSingleton");
var _dialog = require("./dialog/dialog");
var _dialogBody = require("./dialog/dialogBody");
var _dialogFooter = require("./dialog/dialogFooter");
var _dialogStep = require("./dialog/dialogStep");
var _multistepDialog = require("./dialog/multistepDialog");
var _divider = require("./divider/divider");
var _drawer = require("./drawer/drawer");
var _editableText = require("./editable-text/editableText");
var _controlGroup = require("./forms/controlGroup");
var _controls = require("./forms/controls");
var _entityTitle = require("./entity-title/entityTitle");
var _fileInput = require("./forms/fileInput");
var _formGroup = require("./forms/formGroup");
var _inputGroup = require("./forms/inputGroup");
var _numericInput = require("./forms/numericInput");
var _radioGroup = require("./forms/radioGroup");
var _textArea = require("./forms/textArea");
var _html = require("./html/html");
var _htmlSelect = require("./html-select/htmlSelect");
var _htmlTable = require("./html-table/htmlTable");
var _hotkeys = require("./hotkeys");
parcelHelpers.exportAll(_hotkeys, exports);
var _icon = require("./icon/icon");
var _menu = require("./menu/menu");
var _menuDivider = require("./menu/menuDivider");
var _menuItem = require("./menu/menuItem");
var _navbar = require("./navbar/navbar");
var _navbarDivider = require("./navbar/navbarDivider");
var _navbarGroup = require("./navbar/navbarGroup");
var _navbarHeading = require("./navbar/navbarHeading");
var _nonIdealState = require("./non-ideal-state/nonIdealState");
var _overflowList = require("./overflow-list/overflowList");
var _overlay = require("./overlay/overlay");
var _overlay2 = require("./overlay2/overlay2");
var _text = require("./text/text");
var _panelStack = require("./panel-stack/panelStack");
var _panelStack2 = require("./panel-stack2/panelStack2");
var _popover = require("./popover/popover");
var _popoverPosition = require("./popover/popoverPosition");
var _popperUtils = require("./popover/popperUtils");
var _popupKind = require("./popover/popupKind");
var _portal = require("./portal/portal");
var _progressBar = require("./progress-bar/progressBar");
var _resizeSensor = require("./resize-sensor/resizeSensor");
var _handleProps = require("./slider/handleProps");
var _multiSlider = require("./slider/multiSlider");
var _rangeSlider = require("./slider/rangeSlider");
var _section = require("./section/section");
var _sectionCard = require("./section/sectionCard");
var _segmentedControl = require("./segmented-control/segmentedControl");
var _slider = require("./slider/slider");
var _spinner = require("./spinner/spinner");
var _checkboxCard = require("./control-card/checkboxCard");
var _radioCard = require("./control-card/radioCard");
var _switchCard = require("./control-card/switchCard");
var _tab = require("./tabs/tab");
var _tabPanel = require("./tabs/tabPanel");
var _tabs = require("./tabs/tabs");
var _compoundTag = require("./tag/compoundTag");
var _tag = require("./tag/tag");
var _tagInput = require("./tag-input/tagInput");
var _overlayToaster = require("./toast/overlayToaster");
var _toast = require("./toast/toast");
var _toast2 = require("./toast/toast2");
var _toaster = require("./toast/toaster");
var _tooltip = require("./tooltip/tooltip");
var _tree = require("./tree/tree");
var _treeNode = require("./tree/treeNode");

},{"./alert/alert":"dm0qs","./breadcrumbs/breadcrumb":"fC1tD","./breadcrumbs/breadcrumbs":"11MZa","./button/buttons":"glm43","./button/buttonGroup":"kDaEn","./callout/callout":"7CqlL","./card/card":"3tOjJ","./card-list/cardList":"c1VFK","./collapse/collapse":"6TvyY","./context-menu/contextMenu":"RjXVq","./context-menu/contextMenuPopover":"cGifI","./context-menu/contextMenuSingleton":"84kGc","./dialog/dialog":"6MadC","./dialog/dialogBody":"ixDB1","./dialog/dialogFooter":"P111Z","./dialog/dialogStep":"6e1tf","./dialog/multistepDialog":"1cg8y","./divider/divider":"7alHo","./drawer/drawer":"aaN6c","./editable-text/editableText":"1sFf4","./forms/controlGroup":"5BVO1","./forms/controls":"33npD","./entity-title/entityTitle":"1aimB","./forms/fileInput":"562ZG","./forms/formGroup":"2vfIg","./forms/inputGroup":"a7nva","./forms/numericInput":"js8Bo","./forms/radioGroup":"2ZFes","./forms/textArea":"ipx5z","./html/html":"6epty","./html-select/htmlSelect":"iGR3j","./html-table/htmlTable":"4eVsz","./hotkeys":"bcidX","./icon/icon":"duMtK","./menu/menu":"dIGTR","./menu/menuDivider":"iROtW","./menu/menuItem":"cZFqh","./navbar/navbar":"auMQg","./navbar/navbarDivider":"kr60P","./navbar/navbarGroup":"hHUaR","./navbar/navbarHeading":"bUl3D","./non-ideal-state/nonIdealState":"48IBA","./overflow-list/overflowList":"iHnqf","./overlay/overlay":"gfqUm","./overlay2/overlay2":"3eEFv","./text/text":"cIHFN","./panel-stack/panelStack":"if8KV","./panel-stack2/panelStack2":"au9wW","./popover/popover":"2UrEu","./popover/popoverPosition":"bXDBV","./popover/popperUtils":"7UxZg","./popover/popupKind":"4x8hV","./portal/portal":"kksjR","./progress-bar/progressBar":"3yhOK","./resize-sensor/resizeSensor":"lnJHO","./slider/handleProps":"7HHpG","./slider/multiSlider":"363Ok","./slider/rangeSlider":"c4Wuy","./section/section":"capO4","./section/sectionCard":"c6Ou6","./segmented-control/segmentedControl":"6qurk","./slider/slider":"5whZv","./spinner/spinner":"19P1J","./control-card/checkboxCard":"l7snT","./control-card/radioCard":"fCpjP","./control-card/switchCard":"2hI3z","./tabs/tab":"jvFX9","./tabs/tabPanel":"gYC2T","./tabs/tabs":"gmXlb","./tag/compoundTag":"bYLhJ","./tag/tag":"dE1bU","./tag-input/tagInput":"6UZ43","./toast/overlayToaster":"cTaXD","./toast/toast":"2jDnj","./toast/toast2":"bQZYd","./toast/toaster":"aQgrO","./tooltip/tooltip":"hMZHg","./tree/tree":"5bB9L","./tree/treeNode":"glI0J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dm0qs":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alert", ()=>Alert);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _buttons = require("../button/buttons");
var _dialog = require("../dialog/dialog");
var _icon = require("../icon/icon");
/**
 * Alert component.
 *
 * @see https://blueprintjs.com/docs/#core/components/alert
 */ var Alert = /** @class */ function(_super) {
    (0, _tslib.__extends)(Alert, _super);
    function Alert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCancel = function(evt) {
            return _this.internalHandleCallbacks(false, evt);
        };
        _this.handleConfirm = function(evt) {
            return _this.internalHandleCallbacks(true, evt);
        };
        return _this;
    }
    Alert.prototype.render = function() {
        var _a = this.props, canEscapeKeyCancel = _a.canEscapeKeyCancel, canOutsideClickCancel = _a.canOutsideClickCancel, children = _a.children, className = _a.className, icon = _a.icon, intent = _a.intent, loading = _a.loading, cancelButtonText = _a.cancelButtonText, confirmButtonText = _a.confirmButtonText, onClose = _a.onClose, overlayProps = (0, _tslib.__rest)(_a, [
            "canEscapeKeyCancel",
            "canOutsideClickCancel",
            "children",
            "className",
            "icon",
            "intent",
            "loading",
            "cancelButtonText",
            "confirmButtonText",
            "onClose"
        ]);
        return _react.createElement((0, _dialog.Dialog), (0, _tslib.__assign)({}, overlayProps, {
            role: "alertdialog",
            className: (0, _classnamesDefault.default)((0, _common.Classes).ALERT, className),
            canEscapeKeyClose: canEscapeKeyCancel,
            canOutsideClickClose: canOutsideClickCancel,
            onClose: this.handleCancel
        }), _react.createElement("div", {
            className: (0, _common.Classes).ALERT_BODY
        }, _react.createElement((0, _icon.Icon), {
            icon: icon,
            size: 40,
            intent: intent
        }), _react.createElement("div", {
            className: (0, _common.Classes).ALERT_CONTENTS
        }, children)), _react.createElement("div", {
            className: (0, _common.Classes).ALERT_FOOTER
        }, _react.createElement((0, _buttons.Button), {
            loading: loading,
            intent: intent,
            text: confirmButtonText,
            onClick: this.handleConfirm
        }), cancelButtonText && _react.createElement((0, _buttons.Button), {
            text: cancelButtonText,
            disabled: loading,
            onClick: this.handleCancel
        })));
    };
    Alert.prototype.validateProps = function(props) {
        if (props.onClose == null && props.cancelButtonText == null !== (props.onCancel == null)) console.warn((0, _errors.ALERT_WARN_CANCEL_PROPS));
        var hasCancelHandler = props.onCancel != null || props.onClose != null;
        if (props.canEscapeKeyCancel && !hasCancelHandler) console.warn((0, _errors.ALERT_WARN_CANCEL_ESCAPE_KEY));
        if (props.canOutsideClickCancel && !hasCancelHandler) console.warn((0, _errors.ALERT_WARN_CANCEL_OUTSIDE_CLICK));
    };
    Alert.prototype.internalHandleCallbacks = function(confirmed, evt) {
        var _a;
        var _b = this.props, onCancel = _b.onCancel, onClose = _b.onClose, onConfirm = _b.onConfirm;
        (_a = confirmed ? onConfirm : onCancel) === null || _a === void 0 || _a(evt);
        onClose === null || onClose === void 0 || onClose(confirmed, evt);
    };
    Alert.defaultProps = {
        canEscapeKeyCancel: false,
        canOutsideClickCancel: false,
        confirmButtonText: "OK",
        isOpen: false,
        loading: false
    };
    Alert.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Alert");
    return Alert;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/errors":"lyD8m","../button/buttons":"glm43","../dialog/dialog":"6MadC","../icon/icon":"duMtK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Een2":[function(require,module,exports,__globalThis) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"glm43":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
parcelHelpers.export(exports, "AnchorButton", ()=>AnchorButton);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _useInteractiveAttributes = require("../../accessibility/useInteractiveAttributes");
var _common = require("../../common");
var _props = require("../../common/props");
var _icon = require("../icon/icon");
var _spinner = require("../spinner/spinner");
var _text = require("../text/text");
var Button = _react.forwardRef(function(props, ref) {
    var commonAttributes = useSharedButtonAttributes(props, ref);
    return _react.createElement("button", (0, _tslib.__assign)({
        type: "button"
    }, (0, _props.removeNonHTMLProps)(props), commonAttributes), renderButtonContents(props));
});
Button.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Button");
var AnchorButton = _react.forwardRef(function(props, ref) {
    var href = props.href;
    var commonProps = useSharedButtonAttributes(props, ref, {
        defaultTabIndex: 0,
        disabledTabIndex: -1
    });
    return _react.createElement("a", (0, _tslib.__assign)({
        role: "button"
    }, (0, _props.removeNonHTMLProps)(props), commonProps, {
        "aria-disabled": commonProps.disabled,
        href: commonProps.disabled ? undefined : href
    }), renderButtonContents(props));
});
AnchorButton.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".AnchorButton");
/**
 * Most of the button logic lives in this shared hook.
 */ function useSharedButtonAttributes(props, ref, options) {
    var _a;
    var alignText = props.alignText, fill = props.fill, large = props.large, _b = props.loading, loading = _b === void 0 ? false : _b, minimal = props.minimal, outlined = props.outlined, small = props.small;
    var disabled = props.disabled || loading;
    var _c = (0, _useInteractiveAttributes.useInteractiveAttributes)(!disabled, props, ref, options), active = _c[0], interactiveProps = _c[1];
    var className = (0, _classnamesDefault.default)((0, _common.Classes).BUTTON, (_a = {}, _a[(0, _common.Classes).ACTIVE] = active, _a[(0, _common.Classes).DISABLED] = disabled, _a[(0, _common.Classes).FILL] = fill, _a[(0, _common.Classes).LARGE] = large, _a[(0, _common.Classes).LOADING] = loading, _a[(0, _common.Classes).MINIMAL] = minimal, _a[(0, _common.Classes).OUTLINED] = outlined, _a[(0, _common.Classes).SMALL] = small, _a), (0, _common.Classes).alignmentClass(alignText), (0, _common.Classes).intentClass(props.intent), props.className);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, interactiveProps), {
        className: className,
        disabled: disabled
    });
}
/**
 * Shared rendering code for button contents.
 */ function renderButtonContents(props) {
    var children = props.children, ellipsizeText = props.ellipsizeText, icon = props.icon, loading = props.loading, rightIcon = props.rightIcon, text = props.text, textClassName = props.textClassName;
    var hasTextContent = !(0, _common.Utils).isReactNodeEmpty(text) || !(0, _common.Utils).isReactNodeEmpty(children);
    return _react.createElement(_react.Fragment, null, loading && _react.createElement((0, _spinner.Spinner), {
        key: "loading",
        className: (0, _common.Classes).BUTTON_SPINNER,
        size: (0, _spinner.SpinnerSize).SMALL
    }), _react.createElement((0, _icon.Icon), {
        key: "leftIcon",
        icon: icon
    }), hasTextContent && _react.createElement((0, _text.Text), {
        key: "text",
        className: (0, _classnamesDefault.default)((0, _common.Classes).BUTTON_TEXT, textClassName),
        ellipsize: ellipsizeText,
        tagName: "span"
    }, text, children), _react.createElement((0, _icon.Icon), {
        key: "rightIcon",
        icon: rightIcon
    }));
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../accessibility/useInteractiveAttributes":"18Zcf","../../common":"3QDnh","../../common/props":"dBcIV","../icon/icon":"duMtK","../spinner/spinner":"19P1J","../text/text":"cIHFN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"18Zcf":[function(require,module,exports,__globalThis) {
/* !
 * (c) Copyright 2024 Palantir Technologies Inc. All rights reserved.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInteractiveAttributes", ()=>useInteractiveAttributes);
var _react = require("react");
var _common = require("../common");
var DEFAULT_OPTIONS = {
    defaultTabIndex: undefined,
    disabledTabIndex: -1
};
function useInteractiveAttributes(interactive, props, ref, options) {
    if (options === void 0) options = DEFAULT_OPTIONS;
    var defaultTabIndex = options.defaultTabIndex, disabledTabIndex = options.disabledTabIndex;
    var active = props.active, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onBlur = props.onBlur, _a = props.tabIndex, tabIndex = _a === void 0 ? defaultTabIndex : _a;
    // the current key being pressed
    var _b = _react.useState(), currentKeyPressed = _b[0], setCurrentKeyPressed = _b[1];
    // whether the button is in "active" state
    var _c = _react.useState(false), isActive = _c[0], setIsActive = _c[1];
    // our local ref for the interactive element, merged with the consumer's own ref in this hook's return value
    var elementRef = _react.useRef(null);
    var handleBlur = _react.useCallback(function(e) {
        if (isActive) setIsActive(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    }, [
        isActive,
        onBlur
    ]);
    var handleKeyDown = _react.useCallback(function(e) {
        if ((0, _common.Utils).isKeyboardClick(e)) {
            e.preventDefault();
            if (e.key !== currentKeyPressed) setIsActive(true);
        }
        setCurrentKeyPressed(e.key);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    }, [
        currentKeyPressed,
        onKeyDown
    ]);
    var handleKeyUp = _react.useCallback(function(e) {
        var _a;
        if ((0, _common.Utils).isKeyboardClick(e)) {
            setIsActive(false);
            (_a = elementRef.current) === null || _a === void 0 || _a.click();
        }
        setCurrentKeyPressed(undefined);
        onKeyUp === null || onKeyUp === void 0 || onKeyUp(e);
    }, [
        onKeyUp,
        elementRef
    ]);
    var resolvedActive = interactive && (active || isActive);
    return [
        resolvedActive,
        {
            onBlur: handleBlur,
            onClick: interactive ? onClick : undefined,
            onFocus: interactive ? onFocus : undefined,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            ref: (0, _common.mergeRefs)(elementRef, ref),
            tabIndex: interactive ? tabIndex : disabledTabIndex
        }
    ];
}

},{"react":"9njXz","../common":"3QDnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"duMtK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// re-export for convenience, since some users won't be importing from or have a direct dependency on the icons package
parcelHelpers.export(exports, "IconSize", ()=>(0, _icons.IconSize));
parcelHelpers.export(exports, "Icon", ()=>Icon);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var Icon = _react.forwardRef(function(props, ref) {
    var _a, _b;
    var autoLoad = props.autoLoad, className = props.className, color = props.color, icon = props.icon, intent = props.intent, tagName = props.tagName, svgProps = props.svgProps, title = props.title, htmlTitle = props.htmlTitle, htmlProps = (0, _tslib.__rest)(props, [
        "autoLoad",
        "className",
        "color",
        "icon",
        "intent",
        "tagName",
        "svgProps",
        "title",
        "htmlTitle"
    ]);
    // Preserve Blueprint v4.x behavior: iconSize prop takes predecence, then size prop, then fall back to default value
    // eslint-disable-next-line deprecation/deprecation
    var size = (_b = (_a = props.iconSize) !== null && _a !== void 0 ? _a : props.size) !== null && _b !== void 0 ? _b : (0, _icons.IconSize).STANDARD;
    var _c = _react.useState(function() {
        return typeof icon === "string" ? (0, _icons.Icons).getPaths(icon, size) : undefined;
    }), iconPaths = _c[0], setIconPaths = _c[1];
    _react.useEffect(function() {
        var shouldCancelIconLoading = false;
        if (typeof icon === "string") {
            // The icon may have been loaded already, in which case we can simply grab it.
            // N.B. when `autoLoad={true}`, we can't rely on simply calling Icons.load() here to re-load an icon module
            // which has already been loaded & cached, since it may have been loaded with special loading options which
            // this component knows nothing about.
            var loadedIconPaths = (0, _icons.Icons).getPaths(icon, size);
            if (loadedIconPaths !== undefined) setIconPaths(loadedIconPaths);
            else if (autoLoad) (0, _icons.Icons).load(icon, size).then(function() {
                // if this effect expired by the time icon loaded, then don't set state
                if (!shouldCancelIconLoading) setIconPaths((0, _icons.Icons).getPaths(icon, size));
            }).catch(function(reason) {
                console.error("[Blueprint] Icon '".concat(icon, "' (").concat(size, "px) could not be loaded."), reason);
            });
            else console.error("[Blueprint] Icon '".concat(icon, "' (").concat(size, "px) is not loaded yet and autoLoad={false}, did you call Icons.load('").concat(icon, "', ").concat(size, ")?"));
        }
        return function() {
            shouldCancelIconLoading = true;
        };
    }, [
        autoLoad,
        icon,
        size
    ]);
    if (icon == null || typeof icon === "boolean") return null;
    else if (typeof icon !== "string") return icon;
    if (iconPaths == null) {
        // fall back to icon font if unloaded or unable to load SVG implementation
        var sizeClass = size === (0, _icons.IconSize).STANDARD ? (0, _common.Classes).ICON_STANDARD : size === (0, _icons.IconSize).LARGE ? (0, _common.Classes).ICON_LARGE : undefined;
        return _react.createElement(tagName || "span", (0, _tslib.__assign)((0, _tslib.__assign)({
            "aria-hidden": title ? undefined : true
        }, (0, _common.removeNonHTMLProps)(htmlProps)), {
            className: (0, _classnamesDefault.default)((0, _common.Classes).ICON, sizeClass, (0, _common.Classes).iconClass(icon), (0, _common.Classes).intentClass(intent), className),
            "data-icon": icon,
            ref: ref,
            title: htmlTitle
        }));
    } else {
        var pathElements = iconPaths.map(function(d, i) {
            return _react.createElement("path", {
                d: d,
                key: i,
                fillRule: "evenodd"
            });
        });
        // HACKHACK: there is no good way to narrow the type of SVGIconContainerProps here because of the use
        // of a conditional type within the type union that defines that interface. So we cast to <any>.
        // see https://github.com/microsoft/TypeScript/issues/24929, https://github.com/microsoft/TypeScript/issues/33014
        return _react.createElement((0, _icons.SVGIconContainer), (0, _tslib.__assign)({
            children: pathElements,
            // don't forward `Classes.ICON` or `Classes.iconClass(icon)` here, since the container will render those classes
            className: (0, _classnamesDefault.default)((0, _common.Classes).intentClass(intent), className),
            color: color,
            htmlTitle: htmlTitle,
            iconName: icon,
            ref: ref,
            size: size,
            svgProps: svgProps,
            tagName: tagName,
            title: title
        }, (0, _common.removeNonHTMLProps)(htmlProps)));
    }
});
Icon.defaultProps = {
    autoLoad: true,
    tagName: "span"
};
Icon.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Icon");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bO9O5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddClip", ()=>(0, _addClip.AddClip));
parcelHelpers.export(exports, "AddColumnLeft", ()=>(0, _addColumnLeft.AddColumnLeft));
parcelHelpers.export(exports, "AddColumnRight", ()=>(0, _addColumnRight.AddColumnRight));
parcelHelpers.export(exports, "AddLocation", ()=>(0, _addLocation.AddLocation));
parcelHelpers.export(exports, "AddRowBottom", ()=>(0, _addRowBottom.AddRowBottom));
parcelHelpers.export(exports, "AddRowTop", ()=>(0, _addRowTop.AddRowTop));
parcelHelpers.export(exports, "AddToArtifact", ()=>(0, _addToArtifact.AddToArtifact));
parcelHelpers.export(exports, "AddToFolder", ()=>(0, _addToFolder.AddToFolder));
parcelHelpers.export(exports, "Add", ()=>(0, _add.Add));
parcelHelpers.export(exports, "AimpointsTarget", ()=>(0, _aimpointsTarget.AimpointsTarget));
parcelHelpers.export(exports, "Airplane", ()=>(0, _airplane.Airplane));
parcelHelpers.export(exports, "AlignCenter", ()=>(0, _alignCenter.AlignCenter));
parcelHelpers.export(exports, "AlignJustify", ()=>(0, _alignJustify.AlignJustify));
parcelHelpers.export(exports, "AlignLeft", ()=>(0, _alignLeft.AlignLeft));
parcelHelpers.export(exports, "AlignRight", ()=>(0, _alignRight.AlignRight));
parcelHelpers.export(exports, "AlignmentBottom", ()=>(0, _alignmentBottom.AlignmentBottom));
parcelHelpers.export(exports, "AlignmentHorizontalCenter", ()=>(0, _alignmentHorizontalCenter.AlignmentHorizontalCenter));
parcelHelpers.export(exports, "AlignmentLeft", ()=>(0, _alignmentLeft.AlignmentLeft));
parcelHelpers.export(exports, "AlignmentRight", ()=>(0, _alignmentRight.AlignmentRight));
parcelHelpers.export(exports, "AlignmentTop", ()=>(0, _alignmentTop.AlignmentTop));
parcelHelpers.export(exports, "AlignmentVerticalCenter", ()=>(0, _alignmentVerticalCenter.AlignmentVerticalCenter));
parcelHelpers.export(exports, "Ammunition", ()=>(0, _ammunition.Ammunition));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchor.Anchor));
parcelHelpers.export(exports, "Annotation", ()=>(0, _annotation.Annotation));
parcelHelpers.export(exports, "Antenna", ()=>(0, _antenna.Antenna));
parcelHelpers.export(exports, "AppHeader", ()=>(0, _appHeader.AppHeader));
parcelHelpers.export(exports, "Application", ()=>(0, _application.Application));
parcelHelpers.export(exports, "Applications", ()=>(0, _applications.Applications));
parcelHelpers.export(exports, "Archive", ()=>(0, _archive.Archive));
parcelHelpers.export(exports, "AreaOfInterest", ()=>(0, _areaOfInterest.AreaOfInterest));
parcelHelpers.export(exports, "ArrayBoolean", ()=>(0, _arrayBoolean.ArrayBoolean));
parcelHelpers.export(exports, "ArrayDate", ()=>(0, _arrayDate.ArrayDate));
parcelHelpers.export(exports, "ArrayFloatingPoint", ()=>(0, _arrayFloatingPoint.ArrayFloatingPoint));
parcelHelpers.export(exports, "ArrayNumeric", ()=>(0, _arrayNumeric.ArrayNumeric));
parcelHelpers.export(exports, "ArrayString", ()=>(0, _arrayString.ArrayString));
parcelHelpers.export(exports, "ArrayTimestamp", ()=>(0, _arrayTimestamp.ArrayTimestamp));
parcelHelpers.export(exports, "Array", ()=>(0, _array.Array));
parcelHelpers.export(exports, "ArrowBottomLeft", ()=>(0, _arrowBottomLeft.ArrowBottomLeft));
parcelHelpers.export(exports, "ArrowBottomRight", ()=>(0, _arrowBottomRight.ArrowBottomRight));
parcelHelpers.export(exports, "ArrowDown", ()=>(0, _arrowDown.ArrowDown));
parcelHelpers.export(exports, "ArrowLeft", ()=>(0, _arrowLeft.ArrowLeft));
parcelHelpers.export(exports, "ArrowRight", ()=>(0, _arrowRight.ArrowRight));
parcelHelpers.export(exports, "ArrowTopLeft", ()=>(0, _arrowTopLeft.ArrowTopLeft));
parcelHelpers.export(exports, "ArrowTopRight", ()=>(0, _arrowTopRight.ArrowTopRight));
parcelHelpers.export(exports, "ArrowUp", ()=>(0, _arrowUp.ArrowUp));
parcelHelpers.export(exports, "ArrowsArc", ()=>(0, _arrowsArc.ArrowsArc));
parcelHelpers.export(exports, "ArrowsHorizontal", ()=>(0, _arrowsHorizontal.ArrowsHorizontal));
parcelHelpers.export(exports, "ArrowsVertical", ()=>(0, _arrowsVertical.ArrowsVertical));
parcelHelpers.export(exports, "Asterisk", ()=>(0, _asterisk.Asterisk));
parcelHelpers.export(exports, "At", ()=>(0, _at.At));
parcelHelpers.export(exports, "AutomaticUpdates", ()=>(0, _automaticUpdates.AutomaticUpdates));
parcelHelpers.export(exports, "Axle", ()=>(0, _axle.Axle));
parcelHelpers.export(exports, "Backlink", ()=>(0, _backlink.Backlink));
parcelHelpers.export(exports, "BackwardTen", ()=>(0, _backwardTen.BackwardTen));
parcelHelpers.export(exports, "Badge", ()=>(0, _badge.Badge));
parcelHelpers.export(exports, "BanCircle", ()=>(0, _banCircle.BanCircle));
parcelHelpers.export(exports, "BankAccount", ()=>(0, _bankAccount.BankAccount));
parcelHelpers.export(exports, "Barcode", ()=>(0, _barcode.Barcode));
parcelHelpers.export(exports, "BinaryNumber", ()=>(0, _binaryNumber.BinaryNumber));
parcelHelpers.export(exports, "Blank", ()=>(0, _blank.Blank));
parcelHelpers.export(exports, "BlockPromote", ()=>(0, _blockPromote.BlockPromote));
parcelHelpers.export(exports, "BlockedPerson", ()=>(0, _blockedPerson.BlockedPerson));
parcelHelpers.export(exports, "Bold", ()=>(0, _bold.Bold));
parcelHelpers.export(exports, "Book", ()=>(0, _book.Book));
parcelHelpers.export(exports, "Bookmark", ()=>(0, _bookmark.Bookmark));
parcelHelpers.export(exports, "Box", ()=>(0, _box.Box));
parcelHelpers.export(exports, "Briefcase", ()=>(0, _briefcase.Briefcase));
parcelHelpers.export(exports, "BringData", ()=>(0, _bringData.BringData));
parcelHelpers.export(exports, "BringForward", ()=>(0, _bringForward.BringForward));
parcelHelpers.export(exports, "BritishPound", ()=>(0, _britishPound.BritishPound));
parcelHelpers.export(exports, "Bug", ()=>(0, _bug.Bug));
parcelHelpers.export(exports, "Buggy", ()=>(0, _buggy.Buggy));
parcelHelpers.export(exports, "Build", ()=>(0, _build.Build));
parcelHelpers.export(exports, "Bullseye", ()=>(0, _bullseye.Bullseye));
parcelHelpers.export(exports, "Calculator", ()=>(0, _calculator.Calculator));
parcelHelpers.export(exports, "Calendar", ()=>(0, _calendar.Calendar));
parcelHelpers.export(exports, "Camera", ()=>(0, _camera.Camera));
parcelHelpers.export(exports, "CaretDown", ()=>(0, _caretDown.CaretDown));
parcelHelpers.export(exports, "CaretLeft", ()=>(0, _caretLeft.CaretLeft));
parcelHelpers.export(exports, "CaretRight", ()=>(0, _caretRight.CaretRight));
parcelHelpers.export(exports, "CaretUp", ()=>(0, _caretUp.CaretUp));
parcelHelpers.export(exports, "CargoShip", ()=>(0, _cargoShip.CargoShip));
parcelHelpers.export(exports, "CellTower", ()=>(0, _cellTower.CellTower));
parcelHelpers.export(exports, "Changes", ()=>(0, _changes.Changes));
parcelHelpers.export(exports, "Chart", ()=>(0, _chart.Chart));
parcelHelpers.export(exports, "Chat", ()=>(0, _chat.Chat));
parcelHelpers.export(exports, "ChevronBackward", ()=>(0, _chevronBackward.ChevronBackward));
parcelHelpers.export(exports, "ChevronDown", ()=>(0, _chevronDown.ChevronDown));
parcelHelpers.export(exports, "ChevronForward", ()=>(0, _chevronForward.ChevronForward));
parcelHelpers.export(exports, "ChevronLeft", ()=>(0, _chevronLeft.ChevronLeft));
parcelHelpers.export(exports, "ChevronRight", ()=>(0, _chevronRight.ChevronRight));
parcelHelpers.export(exports, "ChevronUp", ()=>(0, _chevronUp.ChevronUp));
parcelHelpers.export(exports, "CircleArrowDown", ()=>(0, _circleArrowDown.CircleArrowDown));
parcelHelpers.export(exports, "CircleArrowLeft", ()=>(0, _circleArrowLeft.CircleArrowLeft));
parcelHelpers.export(exports, "CircleArrowRight", ()=>(0, _circleArrowRight.CircleArrowRight));
parcelHelpers.export(exports, "CircleArrowUp", ()=>(0, _circleArrowUp.CircleArrowUp));
parcelHelpers.export(exports, "Circle", ()=>(0, _circle.Circle));
parcelHelpers.export(exports, "Citation", ()=>(0, _citation.Citation));
parcelHelpers.export(exports, "Clean", ()=>(0, _clean.Clean));
parcelHelpers.export(exports, "Clip", ()=>(0, _clip.Clip));
parcelHelpers.export(exports, "ClipboardFile", ()=>(0, _clipboardFile.ClipboardFile));
parcelHelpers.export(exports, "Clipboard", ()=>(0, _clipboard.Clipboard));
parcelHelpers.export(exports, "CloudDownload", ()=>(0, _cloudDownload.CloudDownload));
parcelHelpers.export(exports, "CloudServer", ()=>(0, _cloudServer.CloudServer));
parcelHelpers.export(exports, "CloudTick", ()=>(0, _cloudTick.CloudTick));
parcelHelpers.export(exports, "CloudUpload", ()=>(0, _cloudUpload.CloudUpload));
parcelHelpers.export(exports, "Cloud", ()=>(0, _cloud.Cloud));
parcelHelpers.export(exports, "CodeBlock", ()=>(0, _codeBlock.CodeBlock));
parcelHelpers.export(exports, "Code", ()=>(0, _code.Code));
parcelHelpers.export(exports, "Cog", ()=>(0, _cog.Cog));
parcelHelpers.export(exports, "CollapseAll", ()=>(0, _collapseAll.CollapseAll));
parcelHelpers.export(exports, "ColorFill", ()=>(0, _colorFill.ColorFill));
parcelHelpers.export(exports, "ColumnLayout", ()=>(0, _columnLayout.ColumnLayout));
parcelHelpers.export(exports, "Comment", ()=>(0, _comment.Comment));
parcelHelpers.export(exports, "Comparison", ()=>(0, _comparison.Comparison));
parcelHelpers.export(exports, "Compass", ()=>(0, _compass.Compass));
parcelHelpers.export(exports, "Compressed", ()=>(0, _compressed.Compressed));
parcelHelpers.export(exports, "Confirm", ()=>(0, _confirm.Confirm));
parcelHelpers.export(exports, "Console", ()=>(0, _console.Console));
parcelHelpers.export(exports, "Contrast", ()=>(0, _contrast.Contrast));
parcelHelpers.export(exports, "Control", ()=>(0, _control.Control));
parcelHelpers.export(exports, "CreditCard", ()=>(0, _creditCard.CreditCard));
parcelHelpers.export(exports, "Crop", ()=>(0, _crop.Crop));
parcelHelpers.export(exports, "CrossCircle", ()=>(0, _crossCircle.CrossCircle));
parcelHelpers.export(exports, "Cross", ()=>(0, _cross.Cross));
parcelHelpers.export(exports, "Crown", ()=>(0, _crown.Crown));
parcelHelpers.export(exports, "CssStyle", ()=>(0, _cssStyle.CssStyle));
parcelHelpers.export(exports, "CubeAdd", ()=>(0, _cubeAdd.CubeAdd));
parcelHelpers.export(exports, "CubeEdit", ()=>(0, _cubeEdit.CubeEdit));
parcelHelpers.export(exports, "CubeRemove", ()=>(0, _cubeRemove.CubeRemove));
parcelHelpers.export(exports, "Cube", ()=>(0, _cube.Cube));
parcelHelpers.export(exports, "Cubes", ()=>(0, _cubes.Cubes));
parcelHelpers.export(exports, "CurlyBraces", ()=>(0, _curlyBraces.CurlyBraces));
parcelHelpers.export(exports, "CurvedRangeChart", ()=>(0, _curvedRangeChart.CurvedRangeChart));
parcelHelpers.export(exports, "Cut", ()=>(0, _cut.Cut));
parcelHelpers.export(exports, "Cycle", ()=>(0, _cycle.Cycle));
parcelHelpers.export(exports, "Dashboard", ()=>(0, _dashboard.Dashboard));
parcelHelpers.export(exports, "DataConnection", ()=>(0, _dataConnection.DataConnection));
parcelHelpers.export(exports, "DataLineage", ()=>(0, _dataLineage.DataLineage));
parcelHelpers.export(exports, "DataSearch", ()=>(0, _dataSearch.DataSearch));
parcelHelpers.export(exports, "DataSync", ()=>(0, _dataSync.DataSync));
parcelHelpers.export(exports, "Database", ()=>(0, _database.Database));
parcelHelpers.export(exports, "Delete", ()=>(0, _delete.Delete));
parcelHelpers.export(exports, "Delta", ()=>(0, _delta.Delta));
parcelHelpers.export(exports, "DeriveColumn", ()=>(0, _deriveColumn.DeriveColumn));
parcelHelpers.export(exports, "Desktop", ()=>(0, _desktop.Desktop));
parcelHelpers.export(exports, "Detection", ()=>(0, _detection.Detection));
parcelHelpers.export(exports, "Diagnosis", ()=>(0, _diagnosis.Diagnosis));
parcelHelpers.export(exports, "DiagramTree", ()=>(0, _diagramTree.DiagramTree));
parcelHelpers.export(exports, "DirectionLeft", ()=>(0, _directionLeft.DirectionLeft));
parcelHelpers.export(exports, "DirectionRight", ()=>(0, _directionRight.DirectionRight));
parcelHelpers.export(exports, "Disable", ()=>(0, _disable.Disable));
parcelHelpers.export(exports, "Divide", ()=>(0, _divide.Divide));
parcelHelpers.export(exports, "DocumentOpen", ()=>(0, _documentOpen.DocumentOpen));
parcelHelpers.export(exports, "DocumentShare", ()=>(0, _documentShare.DocumentShare));
parcelHelpers.export(exports, "Document", ()=>(0, _document.Document));
parcelHelpers.export(exports, "Dollar", ()=>(0, _dollar.Dollar));
parcelHelpers.export(exports, "Dot", ()=>(0, _dot.Dot));
parcelHelpers.export(exports, "DoubleCaretHorizontal", ()=>(0, _doubleCaretHorizontal.DoubleCaretHorizontal));
parcelHelpers.export(exports, "DoubleCaretVertical", ()=>(0, _doubleCaretVertical.DoubleCaretVertical));
parcelHelpers.export(exports, "DoubleChevronDown", ()=>(0, _doubleChevronDown.DoubleChevronDown));
parcelHelpers.export(exports, "DoubleChevronLeft", ()=>(0, _doubleChevronLeft.DoubleChevronLeft));
parcelHelpers.export(exports, "DoubleChevronRight", ()=>(0, _doubleChevronRight.DoubleChevronRight));
parcelHelpers.export(exports, "DoubleChevronUp", ()=>(0, _doubleChevronUp.DoubleChevronUp));
parcelHelpers.export(exports, "DoughnutChart", ()=>(0, _doughnutChart.DoughnutChart));
parcelHelpers.export(exports, "Download", ()=>(0, _download.Download));
parcelHelpers.export(exports, "DragHandleHorizontal", ()=>(0, _dragHandleHorizontal.DragHandleHorizontal));
parcelHelpers.export(exports, "DragHandleVertical", ()=>(0, _dragHandleVertical.DragHandleVertical));
parcelHelpers.export(exports, "Draw", ()=>(0, _draw.Draw));
parcelHelpers.export(exports, "DrawerLeftFilled", ()=>(0, _drawerLeftFilled.DrawerLeftFilled));
parcelHelpers.export(exports, "DrawerLeft", ()=>(0, _drawerLeft.DrawerLeft));
parcelHelpers.export(exports, "DrawerRightFilled", ()=>(0, _drawerRightFilled.DrawerRightFilled));
parcelHelpers.export(exports, "DrawerRight", ()=>(0, _drawerRight.DrawerRight));
parcelHelpers.export(exports, "DriveTime", ()=>(0, _driveTime.DriveTime));
parcelHelpers.export(exports, "Duplicate", ()=>(0, _duplicate.Duplicate));
parcelHelpers.export(exports, "Edit", ()=>(0, _edit.Edit));
parcelHelpers.export(exports, "Eject", ()=>(0, _eject.Eject));
parcelHelpers.export(exports, "Emoji", ()=>(0, _emoji.Emoji));
parcelHelpers.export(exports, "Endnote", ()=>(0, _endnote.Endnote));
parcelHelpers.export(exports, "Endorsed", ()=>(0, _endorsed.Endorsed));
parcelHelpers.export(exports, "Envelope", ()=>(0, _envelope.Envelope));
parcelHelpers.export(exports, "Equals", ()=>(0, _equals.Equals));
parcelHelpers.export(exports, "Eraser", ()=>(0, _eraser.Eraser));
parcelHelpers.export(exports, "Error", ()=>(0, _error.Error));
parcelHelpers.export(exports, "Euro", ()=>(0, _euro.Euro));
parcelHelpers.export(exports, "Excavator", ()=>(0, _excavator.Excavator));
parcelHelpers.export(exports, "Exchange", ()=>(0, _exchange.Exchange));
parcelHelpers.export(exports, "ExcludeRow", ()=>(0, _excludeRow.ExcludeRow));
parcelHelpers.export(exports, "ExpandAll", ()=>(0, _expandAll.ExpandAll));
parcelHelpers.export(exports, "Explain", ()=>(0, _explain.Explain));
parcelHelpers.export(exports, "Export", ()=>(0, _export.Export));
parcelHelpers.export(exports, "EyeOff", ()=>(0, _eyeOff.EyeOff));
parcelHelpers.export(exports, "EyeOn", ()=>(0, _eyeOn.EyeOn));
parcelHelpers.export(exports, "EyeOpen", ()=>(0, _eyeOpen.EyeOpen));
parcelHelpers.export(exports, "FastBackward", ()=>(0, _fastBackward.FastBackward));
parcelHelpers.export(exports, "FastForward", ()=>(0, _fastForward.FastForward));
parcelHelpers.export(exports, "FeedSubscribed", ()=>(0, _feedSubscribed.FeedSubscribed));
parcelHelpers.export(exports, "Feed", ()=>(0, _feed.Feed));
parcelHelpers.export(exports, "FighterJet", ()=>(0, _fighterJet.FighterJet));
parcelHelpers.export(exports, "Film", ()=>(0, _film.Film));
parcelHelpers.export(exports, "FilterKeep", ()=>(0, _filterKeep.FilterKeep));
parcelHelpers.export(exports, "FilterList", ()=>(0, _filterList.FilterList));
parcelHelpers.export(exports, "FilterOpen", ()=>(0, _filterOpen.FilterOpen));
parcelHelpers.export(exports, "FilterRemove", ()=>(0, _filterRemove.FilterRemove));
parcelHelpers.export(exports, "FilterSortAsc", ()=>(0, _filterSortAsc.FilterSortAsc));
parcelHelpers.export(exports, "FilterSortDesc", ()=>(0, _filterSortDesc.FilterSortDesc));
parcelHelpers.export(exports, "Filter", ()=>(0, _filter.Filter));
parcelHelpers.export(exports, "Flag", ()=>(0, _flag.Flag));
parcelHelpers.export(exports, "Flame", ()=>(0, _flame.Flame));
parcelHelpers.export(exports, "Flash", ()=>(0, _flash.Flash));
parcelHelpers.export(exports, "FloatingPoint", ()=>(0, _floatingPoint.FloatingPoint));
parcelHelpers.export(exports, "FloppyDisk", ()=>(0, _floppyDisk.FloppyDisk));
parcelHelpers.export(exports, "FlowBranch", ()=>(0, _flowBranch.FlowBranch));
parcelHelpers.export(exports, "FlowEnd", ()=>(0, _flowEnd.FlowEnd));
parcelHelpers.export(exports, "FlowLinear", ()=>(0, _flowLinear.FlowLinear));
parcelHelpers.export(exports, "FlowReviewBranch", ()=>(0, _flowReviewBranch.FlowReviewBranch));
parcelHelpers.export(exports, "FlowReview", ()=>(0, _flowReview.FlowReview));
parcelHelpers.export(exports, "Flows", ()=>(0, _flows.Flows));
parcelHelpers.export(exports, "FolderClose", ()=>(0, _folderClose.FolderClose));
parcelHelpers.export(exports, "FolderNew", ()=>(0, _folderNew.FolderNew));
parcelHelpers.export(exports, "FolderOpen", ()=>(0, _folderOpen.FolderOpen));
parcelHelpers.export(exports, "FolderSharedOpen", ()=>(0, _folderSharedOpen.FolderSharedOpen));
parcelHelpers.export(exports, "FolderShared", ()=>(0, _folderShared.FolderShared));
parcelHelpers.export(exports, "Follower", ()=>(0, _follower.Follower));
parcelHelpers.export(exports, "Following", ()=>(0, _following.Following));
parcelHelpers.export(exports, "Font", ()=>(0, _font.Font));
parcelHelpers.export(exports, "Fork", ()=>(0, _fork.Fork));
parcelHelpers.export(exports, "Form", ()=>(0, _form.Form));
parcelHelpers.export(exports, "ForwardTen", ()=>(0, _forwardTen.ForwardTen));
parcelHelpers.export(exports, "Fuel", ()=>(0, _fuel.Fuel));
parcelHelpers.export(exports, "FullCircle", ()=>(0, _fullCircle.FullCircle));
parcelHelpers.export(exports, "FullStackedChart", ()=>(0, _fullStackedChart.FullStackedChart));
parcelHelpers.export(exports, "Fullscreen", ()=>(0, _fullscreen.Fullscreen));
parcelHelpers.export(exports, "Function", ()=>(0, _function.Function));
parcelHelpers.export(exports, "GanttChart", ()=>(0, _ganttChart.GanttChart));
parcelHelpers.export(exports, "Generate", ()=>(0, _generate.Generate));
parcelHelpers.export(exports, "Geofence", ()=>(0, _geofence.Geofence));
parcelHelpers.export(exports, "Geolocation", ()=>(0, _geolocation.Geolocation));
parcelHelpers.export(exports, "Geosearch", ()=>(0, _geosearch.Geosearch));
parcelHelpers.export(exports, "Geotime", ()=>(0, _geotime.Geotime));
parcelHelpers.export(exports, "GitBranch", ()=>(0, _gitBranch.GitBranch));
parcelHelpers.export(exports, "GitCommit", ()=>(0, _gitCommit.GitCommit));
parcelHelpers.export(exports, "GitMerge", ()=>(0, _gitMerge.GitMerge));
parcelHelpers.export(exports, "GitNewBranch", ()=>(0, _gitNewBranch.GitNewBranch));
parcelHelpers.export(exports, "GitPull", ()=>(0, _gitPull.GitPull));
parcelHelpers.export(exports, "GitPush", ()=>(0, _gitPush.GitPush));
parcelHelpers.export(exports, "GitRepo", ()=>(0, _gitRepo.GitRepo));
parcelHelpers.export(exports, "Glass", ()=>(0, _glass.Glass));
parcelHelpers.export(exports, "GlobeNetworkAdd", ()=>(0, _globeNetworkAdd.GlobeNetworkAdd));
parcelHelpers.export(exports, "GlobeNetwork", ()=>(0, _globeNetwork.GlobeNetwork));
parcelHelpers.export(exports, "Globe", ()=>(0, _globe.Globe));
parcelHelpers.export(exports, "GraphRemove", ()=>(0, _graphRemove.GraphRemove));
parcelHelpers.export(exports, "Graph", ()=>(0, _graph.Graph));
parcelHelpers.export(exports, "GreaterThanOrEqualTo", ()=>(0, _greaterThanOrEqualTo.GreaterThanOrEqualTo));
parcelHelpers.export(exports, "GreaterThan", ()=>(0, _greaterThan.GreaterThan));
parcelHelpers.export(exports, "GridView", ()=>(0, _gridView.GridView));
parcelHelpers.export(exports, "Grid", ()=>(0, _grid.Grid));
parcelHelpers.export(exports, "GroupItem", ()=>(0, _groupItem.GroupItem));
parcelHelpers.export(exports, "GroupObjects", ()=>(0, _groupObjects.GroupObjects));
parcelHelpers.export(exports, "GroupedBarChart", ()=>(0, _groupedBarChart.GroupedBarChart));
parcelHelpers.export(exports, "HandDown", ()=>(0, _handDown.HandDown));
parcelHelpers.export(exports, "HandLeft", ()=>(0, _handLeft.HandLeft));
parcelHelpers.export(exports, "HandRight", ()=>(0, _handRight.HandRight));
parcelHelpers.export(exports, "HandUp", ()=>(0, _handUp.HandUp));
parcelHelpers.export(exports, "Hand", ()=>(0, _hand.Hand));
parcelHelpers.export(exports, "Hat", ()=>(0, _hat.Hat));
parcelHelpers.export(exports, "HeaderOne", ()=>(0, _headerOne.HeaderOne));
parcelHelpers.export(exports, "HeaderThree", ()=>(0, _headerThree.HeaderThree));
parcelHelpers.export(exports, "HeaderTwo", ()=>(0, _headerTwo.HeaderTwo));
parcelHelpers.export(exports, "Header", ()=>(0, _header.Header));
parcelHelpers.export(exports, "Headset", ()=>(0, _headset.Headset));
parcelHelpers.export(exports, "HeartBroken", ()=>(0, _heartBroken.HeartBroken));
parcelHelpers.export(exports, "Heart", ()=>(0, _heart.Heart));
parcelHelpers.export(exports, "HeatGrid", ()=>(0, _heatGrid.HeatGrid));
parcelHelpers.export(exports, "Heatmap", ()=>(0, _heatmap.Heatmap));
parcelHelpers.export(exports, "Helicopter", ()=>(0, _helicopter.Helicopter));
parcelHelpers.export(exports, "Help", ()=>(0, _help.Help));
parcelHelpers.export(exports, "HelperManagement", ()=>(0, _helperManagement.HelperManagement));
parcelHelpers.export(exports, "Hexagon", ()=>(0, _hexagon.Hexagon));
parcelHelpers.export(exports, "HighPriority", ()=>(0, _highPriority.HighPriority));
parcelHelpers.export(exports, "HighVoltagePole", ()=>(0, _highVoltagePole.HighVoltagePole));
parcelHelpers.export(exports, "Highlight", ()=>(0, _highlight.Highlight));
parcelHelpers.export(exports, "History", ()=>(0, _history.History));
parcelHelpers.export(exports, "Home", ()=>(0, _home.Home));
parcelHelpers.export(exports, "HorizontalBarChartAsc", ()=>(0, _horizontalBarChartAsc.HorizontalBarChartAsc));
parcelHelpers.export(exports, "HorizontalBarChartDesc", ()=>(0, _horizontalBarChartDesc.HorizontalBarChartDesc));
parcelHelpers.export(exports, "HorizontalBarChart", ()=>(0, _horizontalBarChart.HorizontalBarChart));
parcelHelpers.export(exports, "HorizontalDistribution", ()=>(0, _horizontalDistribution.HorizontalDistribution));
parcelHelpers.export(exports, "HorizontalInbetween", ()=>(0, _horizontalInbetween.HorizontalInbetween));
parcelHelpers.export(exports, "Hurricane", ()=>(0, _hurricane.Hurricane));
parcelHelpers.export(exports, "IdNumber", ()=>(0, _idNumber.IdNumber));
parcelHelpers.export(exports, "ImageRotateLeft", ()=>(0, _imageRotateLeft.ImageRotateLeft));
parcelHelpers.export(exports, "ImageRotateRight", ()=>(0, _imageRotateRight.ImageRotateRight));
parcelHelpers.export(exports, "Import", ()=>(0, _import.Import));
parcelHelpers.export(exports, "InboxFiltered", ()=>(0, _inboxFiltered.InboxFiltered));
parcelHelpers.export(exports, "InboxGeo", ()=>(0, _inboxGeo.InboxGeo));
parcelHelpers.export(exports, "InboxSearch", ()=>(0, _inboxSearch.InboxSearch));
parcelHelpers.export(exports, "InboxUpdate", ()=>(0, _inboxUpdate.InboxUpdate));
parcelHelpers.export(exports, "Inbox", ()=>(0, _inbox.Inbox));
parcelHelpers.export(exports, "InfoSign", ()=>(0, _infoSign.InfoSign));
parcelHelpers.export(exports, "Inheritance", ()=>(0, _inheritance.Inheritance));
parcelHelpers.export(exports, "InheritedGroup", ()=>(0, _inheritedGroup.InheritedGroup));
parcelHelpers.export(exports, "InnerJoin", ()=>(0, _innerJoin.InnerJoin));
parcelHelpers.export(exports, "Input", ()=>(0, _input.Input));
parcelHelpers.export(exports, "Insert", ()=>(0, _insert.Insert));
parcelHelpers.export(exports, "Intelligence", ()=>(0, _intelligence.Intelligence));
parcelHelpers.export(exports, "Intersection", ()=>(0, _intersection.Intersection));
parcelHelpers.export(exports, "IpAddress", ()=>(0, _ipAddress.IpAddress));
parcelHelpers.export(exports, "IssueClosed", ()=>(0, _issueClosed.IssueClosed));
parcelHelpers.export(exports, "IssueNew", ()=>(0, _issueNew.IssueNew));
parcelHelpers.export(exports, "Issue", ()=>(0, _issue.Issue));
parcelHelpers.export(exports, "Italic", ()=>(0, _italic.Italic));
parcelHelpers.export(exports, "JoinTable", ()=>(0, _joinTable.JoinTable));
parcelHelpers.export(exports, "KeyBackspace", ()=>(0, _keyBackspace.KeyBackspace));
parcelHelpers.export(exports, "KeyCommand", ()=>(0, _keyCommand.KeyCommand));
parcelHelpers.export(exports, "KeyControl", ()=>(0, _keyControl.KeyControl));
parcelHelpers.export(exports, "KeyDelete", ()=>(0, _keyDelete.KeyDelete));
parcelHelpers.export(exports, "KeyEnter", ()=>(0, _keyEnter.KeyEnter));
parcelHelpers.export(exports, "KeyEscape", ()=>(0, _keyEscape.KeyEscape));
parcelHelpers.export(exports, "KeyOption", ()=>(0, _keyOption.KeyOption));
parcelHelpers.export(exports, "KeyShift", ()=>(0, _keyShift.KeyShift));
parcelHelpers.export(exports, "KeyTab", ()=>(0, _keyTab.KeyTab));
parcelHelpers.export(exports, "Key", ()=>(0, _key.Key));
parcelHelpers.export(exports, "KnownVehicle", ()=>(0, _knownVehicle.KnownVehicle));
parcelHelpers.export(exports, "LabTest", ()=>(0, _labTest.LabTest));
parcelHelpers.export(exports, "Label", ()=>(0, _label.Label));
parcelHelpers.export(exports, "LayerOutline", ()=>(0, _layerOutline.LayerOutline));
parcelHelpers.export(exports, "Layer", ()=>(0, _layer.Layer));
parcelHelpers.export(exports, "Layers", ()=>(0, _layers.Layers));
parcelHelpers.export(exports, "LayoutAuto", ()=>(0, _layoutAuto.LayoutAuto));
parcelHelpers.export(exports, "LayoutBalloon", ()=>(0, _layoutBalloon.LayoutBalloon));
parcelHelpers.export(exports, "LayoutBottomRowThreeTiles", ()=>(0, _layoutBottomRowThreeTiles.LayoutBottomRowThreeTiles));
parcelHelpers.export(exports, "LayoutBottomRowTwoTiles", ()=>(0, _layoutBottomRowTwoTiles.LayoutBottomRowTwoTiles));
parcelHelpers.export(exports, "LayoutCircle", ()=>(0, _layoutCircle.LayoutCircle));
parcelHelpers.export(exports, "LayoutGrid", ()=>(0, _layoutGrid.LayoutGrid));
parcelHelpers.export(exports, "LayoutGroupBy", ()=>(0, _layoutGroupBy.LayoutGroupBy));
parcelHelpers.export(exports, "LayoutHierarchy", ()=>(0, _layoutHierarchy.LayoutHierarchy));
parcelHelpers.export(exports, "LayoutLeftColumnThreeTiles", ()=>(0, _layoutLeftColumnThreeTiles.LayoutLeftColumnThreeTiles));
parcelHelpers.export(exports, "LayoutLeftColumnTwoTiles", ()=>(0, _layoutLeftColumnTwoTiles.LayoutLeftColumnTwoTiles));
parcelHelpers.export(exports, "LayoutLinear", ()=>(0, _layoutLinear.LayoutLinear));
parcelHelpers.export(exports, "LayoutRightColumnThreeTiles", ()=>(0, _layoutRightColumnThreeTiles.LayoutRightColumnThreeTiles));
parcelHelpers.export(exports, "LayoutRightColumnTwoTiles", ()=>(0, _layoutRightColumnTwoTiles.LayoutRightColumnTwoTiles));
parcelHelpers.export(exports, "LayoutSkewGrid", ()=>(0, _layoutSkewGrid.LayoutSkewGrid));
parcelHelpers.export(exports, "LayoutSortedClusters", ()=>(0, _layoutSortedClusters.LayoutSortedClusters));
parcelHelpers.export(exports, "LayoutThreeColumns", ()=>(0, _layoutThreeColumns.LayoutThreeColumns));
parcelHelpers.export(exports, "LayoutThreeRows", ()=>(0, _layoutThreeRows.LayoutThreeRows));
parcelHelpers.export(exports, "LayoutTopRowThreeTiles", ()=>(0, _layoutTopRowThreeTiles.LayoutTopRowThreeTiles));
parcelHelpers.export(exports, "LayoutTopRowTwoTiles", ()=>(0, _layoutTopRowTwoTiles.LayoutTopRowTwoTiles));
parcelHelpers.export(exports, "LayoutTwoColumns", ()=>(0, _layoutTwoColumns.LayoutTwoColumns));
parcelHelpers.export(exports, "LayoutTwoRows", ()=>(0, _layoutTwoRows.LayoutTwoRows));
parcelHelpers.export(exports, "Layout", ()=>(0, _layout.Layout));
parcelHelpers.export(exports, "Learning", ()=>(0, _learning.Learning));
parcelHelpers.export(exports, "LeftJoin", ()=>(0, _leftJoin.LeftJoin));
parcelHelpers.export(exports, "LengthenText", ()=>(0, _lengthenText.LengthenText));
parcelHelpers.export(exports, "LessThanOrEqualTo", ()=>(0, _lessThanOrEqualTo.LessThanOrEqualTo));
parcelHelpers.export(exports, "LessThan", ()=>(0, _lessThan.LessThan));
parcelHelpers.export(exports, "Lifesaver", ()=>(0, _lifesaver.Lifesaver));
parcelHelpers.export(exports, "Lightbulb", ()=>(0, _lightbulb.Lightbulb));
parcelHelpers.export(exports, "Lightning", ()=>(0, _lightning.Lightning));
parcelHelpers.export(exports, "Link", ()=>(0, _link.Link));
parcelHelpers.export(exports, "LinkedSquares", ()=>(0, _linkedSquares.LinkedSquares));
parcelHelpers.export(exports, "ListColumns", ()=>(0, _listColumns.ListColumns));
parcelHelpers.export(exports, "ListDetailView", ()=>(0, _listDetailView.ListDetailView));
parcelHelpers.export(exports, "List", ()=>(0, _list.List));
parcelHelpers.export(exports, "Locate", ()=>(0, _locate.Locate));
parcelHelpers.export(exports, "Lock", ()=>(0, _lock.Lock));
parcelHelpers.export(exports, "Locomotive", ()=>(0, _locomotive.Locomotive));
parcelHelpers.export(exports, "LogIn", ()=>(0, _logIn.LogIn));
parcelHelpers.export(exports, "LogOut", ()=>(0, _logOut.LogOut));
parcelHelpers.export(exports, "LowVoltagePole", ()=>(0, _lowVoltagePole.LowVoltagePole));
parcelHelpers.export(exports, "Manual", ()=>(0, _manual.Manual));
parcelHelpers.export(exports, "ManuallyEnteredData", ()=>(0, _manuallyEnteredData.ManuallyEnteredData));
parcelHelpers.export(exports, "ManyToMany", ()=>(0, _manyToMany.ManyToMany));
parcelHelpers.export(exports, "ManyToOne", ()=>(0, _manyToOne.ManyToOne));
parcelHelpers.export(exports, "MapCreate", ()=>(0, _mapCreate.MapCreate));
parcelHelpers.export(exports, "MapMarker", ()=>(0, _mapMarker.MapMarker));
parcelHelpers.export(exports, "Map", ()=>(0, _map.Map));
parcelHelpers.export(exports, "Maximize", ()=>(0, _maximize.Maximize));
parcelHelpers.export(exports, "Media", ()=>(0, _media.Media));
parcelHelpers.export(exports, "MenuClosed", ()=>(0, _menuClosed.MenuClosed));
parcelHelpers.export(exports, "MenuOpen", ()=>(0, _menuOpen.MenuOpen));
parcelHelpers.export(exports, "Menu", ()=>(0, _menu.Menu));
parcelHelpers.export(exports, "MergeColumns", ()=>(0, _mergeColumns.MergeColumns));
parcelHelpers.export(exports, "MergeLinks", ()=>(0, _mergeLinks.MergeLinks));
parcelHelpers.export(exports, "Microphone", ()=>(0, _microphone.Microphone));
parcelHelpers.export(exports, "Minimize", ()=>(0, _minimize.Minimize));
parcelHelpers.export(exports, "Minus", ()=>(0, _minus.Minus));
parcelHelpers.export(exports, "MobilePhone", ()=>(0, _mobilePhone.MobilePhone));
parcelHelpers.export(exports, "MobileVideo", ()=>(0, _mobileVideo.MobileVideo));
parcelHelpers.export(exports, "ModalFilled", ()=>(0, _modalFilled.ModalFilled));
parcelHelpers.export(exports, "Modal", ()=>(0, _modal.Modal));
parcelHelpers.export(exports, "Model", ()=>(0, _model.Model));
parcelHelpers.export(exports, "Moon", ()=>(0, _moon.Moon));
parcelHelpers.export(exports, "More", ()=>(0, _more.More));
parcelHelpers.export(exports, "Mountain", ()=>(0, _mountain.Mountain));
parcelHelpers.export(exports, "Move", ()=>(0, _move.Move));
parcelHelpers.export(exports, "Mugshot", ()=>(0, _mugshot.Mugshot));
parcelHelpers.export(exports, "MultiSelect", ()=>(0, _multiSelect.MultiSelect));
parcelHelpers.export(exports, "Music", ()=>(0, _music.Music));
parcelHelpers.export(exports, "Nest", ()=>(0, _nest.Nest));
parcelHelpers.export(exports, "NewDrawing", ()=>(0, _newDrawing.NewDrawing));
parcelHelpers.export(exports, "NewGridItem", ()=>(0, _newGridItem.NewGridItem));
parcelHelpers.export(exports, "NewLayer", ()=>(0, _newLayer.NewLayer));
parcelHelpers.export(exports, "NewLayers", ()=>(0, _newLayers.NewLayers));
parcelHelpers.export(exports, "NewLink", ()=>(0, _newLink.NewLink));
parcelHelpers.export(exports, "NewObject", ()=>(0, _newObject.NewObject));
parcelHelpers.export(exports, "NewPerson", ()=>(0, _newPerson.NewPerson));
parcelHelpers.export(exports, "NewPrescription", ()=>(0, _newPrescription.NewPrescription));
parcelHelpers.export(exports, "NewShield", ()=>(0, _newShield.NewShield));
parcelHelpers.export(exports, "NewTextBox", ()=>(0, _newTextBox.NewTextBox));
parcelHelpers.export(exports, "Ninja", ()=>(0, _ninja.Ninja));
parcelHelpers.export(exports, "NotEqualTo", ()=>(0, _notEqualTo.NotEqualTo));
parcelHelpers.export(exports, "NotificationsSnooze", ()=>(0, _notificationsSnooze.NotificationsSnooze));
parcelHelpers.export(exports, "NotificationsUpdated", ()=>(0, _notificationsUpdated.NotificationsUpdated));
parcelHelpers.export(exports, "Notifications", ()=>(0, _notifications.Notifications));
parcelHelpers.export(exports, "NumberedList", ()=>(0, _numberedList.NumberedList));
parcelHelpers.export(exports, "Numerical", ()=>(0, _numerical.Numerical));
parcelHelpers.export(exports, "ObjectView", ()=>(0, _objectView.ObjectView));
parcelHelpers.export(exports, "Office", ()=>(0, _office.Office));
parcelHelpers.export(exports, "Offline", ()=>(0, _offline.Offline));
parcelHelpers.export(exports, "OilField", ()=>(0, _oilField.OilField));
parcelHelpers.export(exports, "OneColumn", ()=>(0, _oneColumn.OneColumn));
parcelHelpers.export(exports, "OneToMany", ()=>(0, _oneToMany.OneToMany));
parcelHelpers.export(exports, "OneToOne", ()=>(0, _oneToOne.OneToOne));
parcelHelpers.export(exports, "OpenApplication", ()=>(0, _openApplication.OpenApplication));
parcelHelpers.export(exports, "Outdated", ()=>(0, _outdated.Outdated));
parcelHelpers.export(exports, "Output", ()=>(0, _output.Output));
parcelHelpers.export(exports, "Package", ()=>(0, _package.Package));
parcelHelpers.export(exports, "PageLayout", ()=>(0, _pageLayout.PageLayout));
parcelHelpers.export(exports, "PanelStats", ()=>(0, _panelStats.PanelStats));
parcelHelpers.export(exports, "PanelTable", ()=>(0, _panelTable.PanelTable));
parcelHelpers.export(exports, "Panel", ()=>(0, _panel.Panel));
parcelHelpers.export(exports, "Paperclip", ()=>(0, _paperclip.Paperclip));
parcelHelpers.export(exports, "Paragraph", ()=>(0, _paragraph.Paragraph));
parcelHelpers.export(exports, "PasteVariable", ()=>(0, _pasteVariable.PasteVariable));
parcelHelpers.export(exports, "PathSearch", ()=>(0, _pathSearch.PathSearch));
parcelHelpers.export(exports, "Path", ()=>(0, _path.Path));
parcelHelpers.export(exports, "Pause", ()=>(0, _pause.Pause));
parcelHelpers.export(exports, "People", ()=>(0, _people.People));
parcelHelpers.export(exports, "Percentage", ()=>(0, _percentage.Percentage));
parcelHelpers.export(exports, "Person", ()=>(0, _person.Person));
parcelHelpers.export(exports, "PhoneCall", ()=>(0, _phoneCall.PhoneCall));
parcelHelpers.export(exports, "PhoneForward", ()=>(0, _phoneForward.PhoneForward));
parcelHelpers.export(exports, "Phone", ()=>(0, _phone.Phone));
parcelHelpers.export(exports, "PieChart", ()=>(0, _pieChart.PieChart));
parcelHelpers.export(exports, "Pill", ()=>(0, _pill.Pill));
parcelHelpers.export(exports, "Pin", ()=>(0, _pin.Pin));
parcelHelpers.export(exports, "PivotTable", ()=>(0, _pivotTable.PivotTable));
parcelHelpers.export(exports, "Pivot", ()=>(0, _pivot.Pivot));
parcelHelpers.export(exports, "Play", ()=>(0, _play.Play));
parcelHelpers.export(exports, "Playbook", ()=>(0, _playbook.Playbook));
parcelHelpers.export(exports, "Plus", ()=>(0, _plus.Plus));
parcelHelpers.export(exports, "PolygonFilter", ()=>(0, _polygonFilter.PolygonFilter));
parcelHelpers.export(exports, "Power", ()=>(0, _power.Power));
parcelHelpers.export(exports, "PredictiveAnalysis", ()=>(0, _predictiveAnalysis.PredictiveAnalysis));
parcelHelpers.export(exports, "Prescription", ()=>(0, _prescription.Prescription));
parcelHelpers.export(exports, "Presentation", ()=>(0, _presentation.Presentation));
parcelHelpers.export(exports, "Print", ()=>(0, _print.Print));
parcelHelpers.export(exports, "Projects", ()=>(0, _projects.Projects));
parcelHelpers.export(exports, "Properties", ()=>(0, _properties.Properties));
parcelHelpers.export(exports, "Property", ()=>(0, _property.Property));
parcelHelpers.export(exports, "PublishFunction", ()=>(0, _publishFunction.PublishFunction));
parcelHelpers.export(exports, "Pulse", ()=>(0, _pulse.Pulse));
parcelHelpers.export(exports, "Rain", ()=>(0, _rain.Rain));
parcelHelpers.export(exports, "Random", ()=>(0, _random.Random));
parcelHelpers.export(exports, "RangeRing", ()=>(0, _rangeRing.RangeRing));
parcelHelpers.export(exports, "Record", ()=>(0, _record.Record));
parcelHelpers.export(exports, "RectHeight", ()=>(0, _rectHeight.RectHeight));
parcelHelpers.export(exports, "RectWidth", ()=>(0, _rectWidth.RectWidth));
parcelHelpers.export(exports, "Rectangle", ()=>(0, _rectangle.Rectangle));
parcelHelpers.export(exports, "Redo", ()=>(0, _redo.Redo));
parcelHelpers.export(exports, "Refresh", ()=>(0, _refresh.Refresh));
parcelHelpers.export(exports, "Regex", ()=>(0, _regex.Regex));
parcelHelpers.export(exports, "RegressionChart", ()=>(0, _regressionChart.RegressionChart));
parcelHelpers.export(exports, "RemoveColumnLeft", ()=>(0, _removeColumnLeft.RemoveColumnLeft));
parcelHelpers.export(exports, "RemoveColumnRight", ()=>(0, _removeColumnRight.RemoveColumnRight));
parcelHelpers.export(exports, "RemoveColumn", ()=>(0, _removeColumn.RemoveColumn));
parcelHelpers.export(exports, "RemoveRowBottom", ()=>(0, _removeRowBottom.RemoveRowBottom));
parcelHelpers.export(exports, "RemoveRowTop", ()=>(0, _removeRowTop.RemoveRowTop));
parcelHelpers.export(exports, "Remove", ()=>(0, _remove.Remove));
parcelHelpers.export(exports, "Repeat", ()=>(0, _repeat.Repeat));
parcelHelpers.export(exports, "Reset", ()=>(0, _reset.Reset));
parcelHelpers.export(exports, "Resolve", ()=>(0, _resolve.Resolve));
parcelHelpers.export(exports, "Rig", ()=>(0, _rig.Rig));
parcelHelpers.export(exports, "RightJoin", ()=>(0, _rightJoin.RightJoin));
parcelHelpers.export(exports, "Ring", ()=>(0, _ring.Ring));
parcelHelpers.export(exports, "RocketSlant", ()=>(0, _rocketSlant.RocketSlant));
parcelHelpers.export(exports, "Rocket", ()=>(0, _rocket.Rocket));
parcelHelpers.export(exports, "RotateCcw", ()=>(0, _rotateCcw.RotateCcw));
parcelHelpers.export(exports, "RotateCw", ()=>(0, _rotateCw.RotateCw));
parcelHelpers.export(exports, "RotateDocument", ()=>(0, _rotateDocument.RotateDocument));
parcelHelpers.export(exports, "RotatePage", ()=>(0, _rotatePage.RotatePage));
parcelHelpers.export(exports, "Route", ()=>(0, _route.Route));
parcelHelpers.export(exports, "Satellite", ()=>(0, _satellite.Satellite));
parcelHelpers.export(exports, "Saved", ()=>(0, _saved.Saved));
parcelHelpers.export(exports, "ScatterPlot", ()=>(0, _scatterPlot.ScatterPlot));
parcelHelpers.export(exports, "SearchAround", ()=>(0, _searchAround.SearchAround));
parcelHelpers.export(exports, "SearchTemplate", ()=>(0, _searchTemplate.SearchTemplate));
parcelHelpers.export(exports, "SearchText", ()=>(0, _searchText.SearchText));
parcelHelpers.export(exports, "Search", ()=>(0, _search.Search));
parcelHelpers.export(exports, "SegmentedControl", ()=>(0, _segmentedControl.SegmentedControl));
parcelHelpers.export(exports, "Select", ()=>(0, _select.Select));
parcelHelpers.export(exports, "Selection", ()=>(0, _selection.Selection));
parcelHelpers.export(exports, "SendBackward", ()=>(0, _sendBackward.SendBackward));
parcelHelpers.export(exports, "SendMessage", ()=>(0, _sendMessage.SendMessage));
parcelHelpers.export(exports, "SendToGraph", ()=>(0, _sendToGraph.SendToGraph));
parcelHelpers.export(exports, "SendToMap", ()=>(0, _sendToMap.SendToMap));
parcelHelpers.export(exports, "SendTo", ()=>(0, _sendTo.SendTo));
parcelHelpers.export(exports, "Sensor", ()=>(0, _sensor.Sensor));
parcelHelpers.export(exports, "SeriesAdd", ()=>(0, _seriesAdd.SeriesAdd));
parcelHelpers.export(exports, "SeriesConfiguration", ()=>(0, _seriesConfiguration.SeriesConfiguration));
parcelHelpers.export(exports, "SeriesDerived", ()=>(0, _seriesDerived.SeriesDerived));
parcelHelpers.export(exports, "SeriesFiltered", ()=>(0, _seriesFiltered.SeriesFiltered));
parcelHelpers.export(exports, "SeriesSearch", ()=>(0, _seriesSearch.SeriesSearch));
parcelHelpers.export(exports, "ServerInstall", ()=>(0, _serverInstall.ServerInstall));
parcelHelpers.export(exports, "Server", ()=>(0, _server.Server));
parcelHelpers.export(exports, "Settings", ()=>(0, _settings.Settings));
parcelHelpers.export(exports, "Shapes", ()=>(0, _shapes.Shapes));
parcelHelpers.export(exports, "Share", ()=>(0, _share.Share));
parcelHelpers.export(exports, "SharedFilter", ()=>(0, _sharedFilter.SharedFilter));
parcelHelpers.export(exports, "Shield", ()=>(0, _shield.Shield));
parcelHelpers.export(exports, "Ship", ()=>(0, _ship.Ship));
parcelHelpers.export(exports, "Shop", ()=>(0, _shop.Shop));
parcelHelpers.export(exports, "ShoppingCart", ()=>(0, _shoppingCart.ShoppingCart));
parcelHelpers.export(exports, "ShortenText", ()=>(0, _shortenText.ShortenText));
parcelHelpers.export(exports, "SignalSearch", ()=>(0, _signalSearch.SignalSearch));
parcelHelpers.export(exports, "SimCard", ()=>(0, _simCard.SimCard));
parcelHelpers.export(exports, "Slash", ()=>(0, _slash.Slash));
parcelHelpers.export(exports, "SmallCross", ()=>(0, _smallCross.SmallCross));
parcelHelpers.export(exports, "SmallInfoSign", ()=>(0, _smallInfoSign.SmallInfoSign));
parcelHelpers.export(exports, "SmallMinus", ()=>(0, _smallMinus.SmallMinus));
parcelHelpers.export(exports, "SmallPlus", ()=>(0, _smallPlus.SmallPlus));
parcelHelpers.export(exports, "SmallSquare", ()=>(0, _smallSquare.SmallSquare));
parcelHelpers.export(exports, "SmallTick", ()=>(0, _smallTick.SmallTick));
parcelHelpers.export(exports, "Snowflake", ()=>(0, _snowflake.Snowflake));
parcelHelpers.export(exports, "SoccerBall", ()=>(0, _soccerBall.SoccerBall));
parcelHelpers.export(exports, "SocialMedia", ()=>(0, _socialMedia.SocialMedia));
parcelHelpers.export(exports, "SortAlphabeticalDesc", ()=>(0, _sortAlphabeticalDesc.SortAlphabeticalDesc));
parcelHelpers.export(exports, "SortAlphabetical", ()=>(0, _sortAlphabetical.SortAlphabetical));
parcelHelpers.export(exports, "SortAsc", ()=>(0, _sortAsc.SortAsc));
parcelHelpers.export(exports, "SortDesc", ()=>(0, _sortDesc.SortDesc));
parcelHelpers.export(exports, "SortNumericalDesc", ()=>(0, _sortNumericalDesc.SortNumericalDesc));
parcelHelpers.export(exports, "SortNumerical", ()=>(0, _sortNumerical.SortNumerical));
parcelHelpers.export(exports, "Sort", ()=>(0, _sort.Sort));
parcelHelpers.export(exports, "SpellCheck", ()=>(0, _spellCheck.SpellCheck));
parcelHelpers.export(exports, "SplitColumns", ()=>(0, _splitColumns.SplitColumns));
parcelHelpers.export(exports, "SportsStadium", ()=>(0, _sportsStadium.SportsStadium));
parcelHelpers.export(exports, "Square", ()=>(0, _square.Square));
parcelHelpers.export(exports, "StackedChart", ()=>(0, _stackedChart.StackedChart));
parcelHelpers.export(exports, "StadiumGeometry", ()=>(0, _stadiumGeometry.StadiumGeometry));
parcelHelpers.export(exports, "StarEmpty", ()=>(0, _starEmpty.StarEmpty));
parcelHelpers.export(exports, "Star", ()=>(0, _star.Star));
parcelHelpers.export(exports, "StepBackward", ()=>(0, _stepBackward.StepBackward));
parcelHelpers.export(exports, "StepChart", ()=>(0, _stepChart.StepChart));
parcelHelpers.export(exports, "StepForward", ()=>(0, _stepForward.StepForward));
parcelHelpers.export(exports, "Stop", ()=>(0, _stop.Stop));
parcelHelpers.export(exports, "Stopwatch", ()=>(0, _stopwatch.Stopwatch));
parcelHelpers.export(exports, "Strikethrough", ()=>(0, _strikethrough.Strikethrough));
parcelHelpers.export(exports, "Style", ()=>(0, _style.Style));
parcelHelpers.export(exports, "Subscript", ()=>(0, _subscript.Subscript));
parcelHelpers.export(exports, "Superscript", ()=>(0, _superscript.Superscript));
parcelHelpers.export(exports, "SwapHorizontal", ()=>(0, _swapHorizontal.SwapHorizontal));
parcelHelpers.export(exports, "SwapVertical", ()=>(0, _swapVertical.SwapVertical));
parcelHelpers.export(exports, "Switch", ()=>(0, _switch.Switch));
parcelHelpers.export(exports, "SymbolCircle", ()=>(0, _symbolCircle.SymbolCircle));
parcelHelpers.export(exports, "SymbolCross", ()=>(0, _symbolCross.SymbolCross));
parcelHelpers.export(exports, "SymbolDiamond", ()=>(0, _symbolDiamond.SymbolDiamond));
parcelHelpers.export(exports, "SymbolRectangle", ()=>(0, _symbolRectangle.SymbolRectangle));
parcelHelpers.export(exports, "SymbolSquare", ()=>(0, _symbolSquare.SymbolSquare));
parcelHelpers.export(exports, "SymbolTriangleDown", ()=>(0, _symbolTriangleDown.SymbolTriangleDown));
parcelHelpers.export(exports, "SymbolTriangleUp", ()=>(0, _symbolTriangleUp.SymbolTriangleUp));
parcelHelpers.export(exports, "Syringe", ()=>(0, _syringe.Syringe));
parcelHelpers.export(exports, "TableSync", ()=>(0, _tableSync.TableSync));
parcelHelpers.export(exports, "TagAdd", ()=>(0, _tagAdd.TagAdd));
parcelHelpers.export(exports, "TagPromote", ()=>(0, _tagPromote.TagPromote));
parcelHelpers.export(exports, "TagRefresh", ()=>(0, _tagRefresh.TagRefresh));
parcelHelpers.export(exports, "TagUndo", ()=>(0, _tagUndo.TagUndo));
parcelHelpers.export(exports, "Tag", ()=>(0, _tag.Tag));
parcelHelpers.export(exports, "Tags", ()=>(0, _tags.Tags));
parcelHelpers.export(exports, "TakeAction", ()=>(0, _takeAction.TakeAction));
parcelHelpers.export(exports, "Tank", ()=>(0, _tank.Tank));
parcelHelpers.export(exports, "Target", ()=>(0, _target.Target));
parcelHelpers.export(exports, "Taxi", ()=>(0, _taxi.Taxi));
parcelHelpers.export(exports, "Team", ()=>(0, _team.Team));
parcelHelpers.export(exports, "Temperature", ()=>(0, _temperature.Temperature));
parcelHelpers.export(exports, "TextHighlight", ()=>(0, _textHighlight.TextHighlight));
parcelHelpers.export(exports, "ThAdd", ()=>(0, _thAdd.ThAdd));
parcelHelpers.export(exports, "ThDerived", ()=>(0, _thDerived.ThDerived));
parcelHelpers.export(exports, "ThDisconnect", ()=>(0, _thDisconnect.ThDisconnect));
parcelHelpers.export(exports, "ThFiltered", ()=>(0, _thFiltered.ThFiltered));
parcelHelpers.export(exports, "ThListAdd", ()=>(0, _thListAdd.ThListAdd));
parcelHelpers.export(exports, "ThList", ()=>(0, _thList.ThList));
parcelHelpers.export(exports, "ThVirtualAdd", ()=>(0, _thVirtualAdd.ThVirtualAdd));
parcelHelpers.export(exports, "ThVirtual", ()=>(0, _thVirtual.ThVirtual));
parcelHelpers.export(exports, "Th", ()=>(0, _th.Th));
parcelHelpers.export(exports, "ThirdParty", ()=>(0, _thirdParty.ThirdParty));
parcelHelpers.export(exports, "ThumbsDown", ()=>(0, _thumbsDown.ThumbsDown));
parcelHelpers.export(exports, "ThumbsUp", ()=>(0, _thumbsUp.ThumbsUp));
parcelHelpers.export(exports, "TickCircle", ()=>(0, _tickCircle.TickCircle));
parcelHelpers.export(exports, "Tick", ()=>(0, _tick.Tick));
parcelHelpers.export(exports, "Time", ()=>(0, _time.Time));
parcelHelpers.export(exports, "TimelineAreaChart", ()=>(0, _timelineAreaChart.TimelineAreaChart));
parcelHelpers.export(exports, "TimelineBarChart", ()=>(0, _timelineBarChart.TimelineBarChart));
parcelHelpers.export(exports, "TimelineEvents", ()=>(0, _timelineEvents.TimelineEvents));
parcelHelpers.export(exports, "TimelineLineChart", ()=>(0, _timelineLineChart.TimelineLineChart));
parcelHelpers.export(exports, "Tint", ()=>(0, _tint.Tint));
parcelHelpers.export(exports, "Torch", ()=>(0, _torch.Torch));
parcelHelpers.export(exports, "Tractor", ()=>(0, _tractor.Tractor));
parcelHelpers.export(exports, "Train", ()=>(0, _train.Train));
parcelHelpers.export(exports, "Translate", ()=>(0, _translate.Translate));
parcelHelpers.export(exports, "Trash", ()=>(0, _trash.Trash));
parcelHelpers.export(exports, "Tree", ()=>(0, _tree.Tree));
parcelHelpers.export(exports, "TrendingDown", ()=>(0, _trendingDown.TrendingDown));
parcelHelpers.export(exports, "TrendingUp", ()=>(0, _trendingUp.TrendingUp));
parcelHelpers.export(exports, "Trophy", ()=>(0, _trophy.Trophy));
parcelHelpers.export(exports, "Truck", ()=>(0, _truck.Truck));
parcelHelpers.export(exports, "TwoColumns", ()=>(0, _twoColumns.TwoColumns));
parcelHelpers.export(exports, "Unarchive", ()=>(0, _unarchive.Unarchive));
parcelHelpers.export(exports, "Underline", ()=>(0, _underline.Underline));
parcelHelpers.export(exports, "Undo", ()=>(0, _undo.Undo));
parcelHelpers.export(exports, "UngroupObjects", ()=>(0, _ungroupObjects.UngroupObjects));
parcelHelpers.export(exports, "UnknownVehicle", ()=>(0, _unknownVehicle.UnknownVehicle));
parcelHelpers.export(exports, "Unlink", ()=>(0, _unlink.Unlink));
parcelHelpers.export(exports, "Unlock", ()=>(0, _unlock.Unlock));
parcelHelpers.export(exports, "Unpin", ()=>(0, _unpin.Unpin));
parcelHelpers.export(exports, "Unresolve", ()=>(0, _unresolve.Unresolve));
parcelHelpers.export(exports, "Updated", ()=>(0, _updated.Updated));
parcelHelpers.export(exports, "Upload", ()=>(0, _upload.Upload));
parcelHelpers.export(exports, "User", ()=>(0, _user.User));
parcelHelpers.export(exports, "Variable", ()=>(0, _variable.Variable));
parcelHelpers.export(exports, "Vector", ()=>(0, _vector.Vector));
parcelHelpers.export(exports, "VerticalBarChartAsc", ()=>(0, _verticalBarChartAsc.VerticalBarChartAsc));
parcelHelpers.export(exports, "VerticalBarChartDesc", ()=>(0, _verticalBarChartDesc.VerticalBarChartDesc));
parcelHelpers.export(exports, "VerticalDistribution", ()=>(0, _verticalDistribution.VerticalDistribution));
parcelHelpers.export(exports, "VerticalInbetween", ()=>(0, _verticalInbetween.VerticalInbetween));
parcelHelpers.export(exports, "Video", ()=>(0, _video.Video));
parcelHelpers.export(exports, "Virus", ()=>(0, _virus.Virus));
parcelHelpers.export(exports, "VolumeDown", ()=>(0, _volumeDown.VolumeDown));
parcelHelpers.export(exports, "VolumeOff", ()=>(0, _volumeOff.VolumeOff));
parcelHelpers.export(exports, "VolumeUp", ()=>(0, _volumeUp.VolumeUp));
parcelHelpers.export(exports, "Walk", ()=>(0, _walk.Walk));
parcelHelpers.export(exports, "WarningSign", ()=>(0, _warningSign.WarningSign));
parcelHelpers.export(exports, "WaterfallChart", ()=>(0, _waterfallChart.WaterfallChart));
parcelHelpers.export(exports, "Waves", ()=>(0, _waves.Waves));
parcelHelpers.export(exports, "WidgetButton", ()=>(0, _widgetButton.WidgetButton));
parcelHelpers.export(exports, "WidgetFooter", ()=>(0, _widgetFooter.WidgetFooter));
parcelHelpers.export(exports, "WidgetHeader", ()=>(0, _widgetHeader.WidgetHeader));
parcelHelpers.export(exports, "Widget", ()=>(0, _widget.Widget));
parcelHelpers.export(exports, "Wind", ()=>(0, _wind.Wind));
parcelHelpers.export(exports, "WrenchRedo", ()=>(0, _wrenchRedo.WrenchRedo));
parcelHelpers.export(exports, "WrenchSnooze", ()=>(0, _wrenchSnooze.WrenchSnooze));
parcelHelpers.export(exports, "WrenchTime", ()=>(0, _wrenchTime.WrenchTime));
parcelHelpers.export(exports, "Wrench", ()=>(0, _wrench.Wrench));
parcelHelpers.export(exports, "ZoomIn", ()=>(0, _zoomIn.ZoomIn));
parcelHelpers.export(exports, "ZoomOut", ()=>(0, _zoomOut.ZoomOut));
parcelHelpers.export(exports, "ZoomToFit", ()=>(0, _zoomToFit.ZoomToFit));
var _index = require("../index");
parcelHelpers.exportAll(_index, exports);
var _addClip = require("./components/add-clip");
var _addColumnLeft = require("./components/add-column-left");
var _addColumnRight = require("./components/add-column-right");
var _addLocation = require("./components/add-location");
var _addRowBottom = require("./components/add-row-bottom");
var _addRowTop = require("./components/add-row-top");
var _addToArtifact = require("./components/add-to-artifact");
var _addToFolder = require("./components/add-to-folder");
var _add = require("./components/add");
var _aimpointsTarget = require("./components/aimpoints-target");
var _airplane = require("./components/airplane");
var _alignCenter = require("./components/align-center");
var _alignJustify = require("./components/align-justify");
var _alignLeft = require("./components/align-left");
var _alignRight = require("./components/align-right");
var _alignmentBottom = require("./components/alignment-bottom");
var _alignmentHorizontalCenter = require("./components/alignment-horizontal-center");
var _alignmentLeft = require("./components/alignment-left");
var _alignmentRight = require("./components/alignment-right");
var _alignmentTop = require("./components/alignment-top");
var _alignmentVerticalCenter = require("./components/alignment-vertical-center");
var _ammunition = require("./components/ammunition");
var _anchor = require("./components/anchor");
var _annotation = require("./components/annotation");
var _antenna = require("./components/antenna");
var _appHeader = require("./components/app-header");
var _application = require("./components/application");
var _applications = require("./components/applications");
var _archive = require("./components/archive");
var _areaOfInterest = require("./components/area-of-interest");
var _arrayBoolean = require("./components/array-boolean");
var _arrayDate = require("./components/array-date");
var _arrayFloatingPoint = require("./components/array-floating-point");
var _arrayNumeric = require("./components/array-numeric");
var _arrayString = require("./components/array-string");
var _arrayTimestamp = require("./components/array-timestamp");
var _array = require("./components/array");
var _arrowBottomLeft = require("./components/arrow-bottom-left");
var _arrowBottomRight = require("./components/arrow-bottom-right");
var _arrowDown = require("./components/arrow-down");
var _arrowLeft = require("./components/arrow-left");
var _arrowRight = require("./components/arrow-right");
var _arrowTopLeft = require("./components/arrow-top-left");
var _arrowTopRight = require("./components/arrow-top-right");
var _arrowUp = require("./components/arrow-up");
var _arrowsArc = require("./components/arrows-arc");
var _arrowsHorizontal = require("./components/arrows-horizontal");
var _arrowsVertical = require("./components/arrows-vertical");
var _asterisk = require("./components/asterisk");
var _at = require("./components/at");
var _automaticUpdates = require("./components/automatic-updates");
var _axle = require("./components/axle");
var _backlink = require("./components/backlink");
var _backwardTen = require("./components/backward-ten");
var _badge = require("./components/badge");
var _banCircle = require("./components/ban-circle");
var _bankAccount = require("./components/bank-account");
var _barcode = require("./components/barcode");
var _binaryNumber = require("./components/binary-number");
var _blank = require("./components/blank");
var _blockPromote = require("./components/block-promote");
var _blockedPerson = require("./components/blocked-person");
var _bold = require("./components/bold");
var _book = require("./components/book");
var _bookmark = require("./components/bookmark");
var _box = require("./components/box");
var _briefcase = require("./components/briefcase");
var _bringData = require("./components/bring-data");
var _bringForward = require("./components/bring-forward");
var _britishPound = require("./components/british-pound");
var _bug = require("./components/bug");
var _buggy = require("./components/buggy");
var _build = require("./components/build");
var _bullseye = require("./components/bullseye");
var _calculator = require("./components/calculator");
var _calendar = require("./components/calendar");
var _camera = require("./components/camera");
var _caretDown = require("./components/caret-down");
var _caretLeft = require("./components/caret-left");
var _caretRight = require("./components/caret-right");
var _caretUp = require("./components/caret-up");
var _cargoShip = require("./components/cargo-ship");
var _cellTower = require("./components/cell-tower");
var _changes = require("./components/changes");
var _chart = require("./components/chart");
var _chat = require("./components/chat");
var _chevronBackward = require("./components/chevron-backward");
var _chevronDown = require("./components/chevron-down");
var _chevronForward = require("./components/chevron-forward");
var _chevronLeft = require("./components/chevron-left");
var _chevronRight = require("./components/chevron-right");
var _chevronUp = require("./components/chevron-up");
var _circleArrowDown = require("./components/circle-arrow-down");
var _circleArrowLeft = require("./components/circle-arrow-left");
var _circleArrowRight = require("./components/circle-arrow-right");
var _circleArrowUp = require("./components/circle-arrow-up");
var _circle = require("./components/circle");
var _citation = require("./components/citation");
var _clean = require("./components/clean");
var _clip = require("./components/clip");
var _clipboardFile = require("./components/clipboard-file");
var _clipboard = require("./components/clipboard");
var _cloudDownload = require("./components/cloud-download");
var _cloudServer = require("./components/cloud-server");
var _cloudTick = require("./components/cloud-tick");
var _cloudUpload = require("./components/cloud-upload");
var _cloud = require("./components/cloud");
var _codeBlock = require("./components/code-block");
var _code = require("./components/code");
var _cog = require("./components/cog");
var _collapseAll = require("./components/collapse-all");
var _colorFill = require("./components/color-fill");
var _columnLayout = require("./components/column-layout");
var _comment = require("./components/comment");
var _comparison = require("./components/comparison");
var _compass = require("./components/compass");
var _compressed = require("./components/compressed");
var _confirm = require("./components/confirm");
var _console = require("./components/console");
var _contrast = require("./components/contrast");
var _control = require("./components/control");
var _creditCard = require("./components/credit-card");
var _crop = require("./components/crop");
var _crossCircle = require("./components/cross-circle");
var _cross = require("./components/cross");
var _crown = require("./components/crown");
var _cssStyle = require("./components/css-style");
var _cubeAdd = require("./components/cube-add");
var _cubeEdit = require("./components/cube-edit");
var _cubeRemove = require("./components/cube-remove");
var _cube = require("./components/cube");
var _cubes = require("./components/cubes");
var _curlyBraces = require("./components/curly-braces");
var _curvedRangeChart = require("./components/curved-range-chart");
var _cut = require("./components/cut");
var _cycle = require("./components/cycle");
var _dashboard = require("./components/dashboard");
var _dataConnection = require("./components/data-connection");
var _dataLineage = require("./components/data-lineage");
var _dataSearch = require("./components/data-search");
var _dataSync = require("./components/data-sync");
var _database = require("./components/database");
var _delete = require("./components/delete");
var _delta = require("./components/delta");
var _deriveColumn = require("./components/derive-column");
var _desktop = require("./components/desktop");
var _detection = require("./components/detection");
var _diagnosis = require("./components/diagnosis");
var _diagramTree = require("./components/diagram-tree");
var _directionLeft = require("./components/direction-left");
var _directionRight = require("./components/direction-right");
var _disable = require("./components/disable");
var _divide = require("./components/divide");
var _documentOpen = require("./components/document-open");
var _documentShare = require("./components/document-share");
var _document = require("./components/document");
var _dollar = require("./components/dollar");
var _dot = require("./components/dot");
var _doubleCaretHorizontal = require("./components/double-caret-horizontal");
var _doubleCaretVertical = require("./components/double-caret-vertical");
var _doubleChevronDown = require("./components/double-chevron-down");
var _doubleChevronLeft = require("./components/double-chevron-left");
var _doubleChevronRight = require("./components/double-chevron-right");
var _doubleChevronUp = require("./components/double-chevron-up");
var _doughnutChart = require("./components/doughnut-chart");
var _download = require("./components/download");
var _dragHandleHorizontal = require("./components/drag-handle-horizontal");
var _dragHandleVertical = require("./components/drag-handle-vertical");
var _draw = require("./components/draw");
var _drawerLeftFilled = require("./components/drawer-left-filled");
var _drawerLeft = require("./components/drawer-left");
var _drawerRightFilled = require("./components/drawer-right-filled");
var _drawerRight = require("./components/drawer-right");
var _driveTime = require("./components/drive-time");
var _duplicate = require("./components/duplicate");
var _edit = require("./components/edit");
var _eject = require("./components/eject");
var _emoji = require("./components/emoji");
var _endnote = require("./components/endnote");
var _endorsed = require("./components/endorsed");
var _envelope = require("./components/envelope");
var _equals = require("./components/equals");
var _eraser = require("./components/eraser");
var _error = require("./components/error");
var _euro = require("./components/euro");
var _excavator = require("./components/excavator");
var _exchange = require("./components/exchange");
var _excludeRow = require("./components/exclude-row");
var _expandAll = require("./components/expand-all");
var _explain = require("./components/explain");
var _export = require("./components/export");
var _eyeOff = require("./components/eye-off");
var _eyeOn = require("./components/eye-on");
var _eyeOpen = require("./components/eye-open");
var _fastBackward = require("./components/fast-backward");
var _fastForward = require("./components/fast-forward");
var _feedSubscribed = require("./components/feed-subscribed");
var _feed = require("./components/feed");
var _fighterJet = require("./components/fighter-jet");
var _film = require("./components/film");
var _filterKeep = require("./components/filter-keep");
var _filterList = require("./components/filter-list");
var _filterOpen = require("./components/filter-open");
var _filterRemove = require("./components/filter-remove");
var _filterSortAsc = require("./components/filter-sort-asc");
var _filterSortDesc = require("./components/filter-sort-desc");
var _filter = require("./components/filter");
var _flag = require("./components/flag");
var _flame = require("./components/flame");
var _flash = require("./components/flash");
var _floatingPoint = require("./components/floating-point");
var _floppyDisk = require("./components/floppy-disk");
var _flowBranch = require("./components/flow-branch");
var _flowEnd = require("./components/flow-end");
var _flowLinear = require("./components/flow-linear");
var _flowReviewBranch = require("./components/flow-review-branch");
var _flowReview = require("./components/flow-review");
var _flows = require("./components/flows");
var _folderClose = require("./components/folder-close");
var _folderNew = require("./components/folder-new");
var _folderOpen = require("./components/folder-open");
var _folderSharedOpen = require("./components/folder-shared-open");
var _folderShared = require("./components/folder-shared");
var _follower = require("./components/follower");
var _following = require("./components/following");
var _font = require("./components/font");
var _fork = require("./components/fork");
var _form = require("./components/form");
var _forwardTen = require("./components/forward-ten");
var _fuel = require("./components/fuel");
var _fullCircle = require("./components/full-circle");
var _fullStackedChart = require("./components/full-stacked-chart");
var _fullscreen = require("./components/fullscreen");
var _function = require("./components/function");
var _ganttChart = require("./components/gantt-chart");
var _generate = require("./components/generate");
var _geofence = require("./components/geofence");
var _geolocation = require("./components/geolocation");
var _geosearch = require("./components/geosearch");
var _geotime = require("./components/geotime");
var _gitBranch = require("./components/git-branch");
var _gitCommit = require("./components/git-commit");
var _gitMerge = require("./components/git-merge");
var _gitNewBranch = require("./components/git-new-branch");
var _gitPull = require("./components/git-pull");
var _gitPush = require("./components/git-push");
var _gitRepo = require("./components/git-repo");
var _glass = require("./components/glass");
var _globeNetworkAdd = require("./components/globe-network-add");
var _globeNetwork = require("./components/globe-network");
var _globe = require("./components/globe");
var _graphRemove = require("./components/graph-remove");
var _graph = require("./components/graph");
var _greaterThanOrEqualTo = require("./components/greater-than-or-equal-to");
var _greaterThan = require("./components/greater-than");
var _gridView = require("./components/grid-view");
var _grid = require("./components/grid");
var _groupItem = require("./components/group-item");
var _groupObjects = require("./components/group-objects");
var _groupedBarChart = require("./components/grouped-bar-chart");
var _handDown = require("./components/hand-down");
var _handLeft = require("./components/hand-left");
var _handRight = require("./components/hand-right");
var _handUp = require("./components/hand-up");
var _hand = require("./components/hand");
var _hat = require("./components/hat");
var _headerOne = require("./components/header-one");
var _headerThree = require("./components/header-three");
var _headerTwo = require("./components/header-two");
var _header = require("./components/header");
var _headset = require("./components/headset");
var _heartBroken = require("./components/heart-broken");
var _heart = require("./components/heart");
var _heatGrid = require("./components/heat-grid");
var _heatmap = require("./components/heatmap");
var _helicopter = require("./components/helicopter");
var _help = require("./components/help");
var _helperManagement = require("./components/helper-management");
var _hexagon = require("./components/hexagon");
var _highPriority = require("./components/high-priority");
var _highVoltagePole = require("./components/high-voltage-pole");
var _highlight = require("./components/highlight");
var _history = require("./components/history");
var _home = require("./components/home");
var _horizontalBarChartAsc = require("./components/horizontal-bar-chart-asc");
var _horizontalBarChartDesc = require("./components/horizontal-bar-chart-desc");
var _horizontalBarChart = require("./components/horizontal-bar-chart");
var _horizontalDistribution = require("./components/horizontal-distribution");
var _horizontalInbetween = require("./components/horizontal-inbetween");
var _hurricane = require("./components/hurricane");
var _idNumber = require("./components/id-number");
var _imageRotateLeft = require("./components/image-rotate-left");
var _imageRotateRight = require("./components/image-rotate-right");
var _import = require("./components/import");
var _inboxFiltered = require("./components/inbox-filtered");
var _inboxGeo = require("./components/inbox-geo");
var _inboxSearch = require("./components/inbox-search");
var _inboxUpdate = require("./components/inbox-update");
var _inbox = require("./components/inbox");
var _infoSign = require("./components/info-sign");
var _inheritance = require("./components/inheritance");
var _inheritedGroup = require("./components/inherited-group");
var _innerJoin = require("./components/inner-join");
var _input = require("./components/input");
var _insert = require("./components/insert");
var _intelligence = require("./components/intelligence");
var _intersection = require("./components/intersection");
var _ipAddress = require("./components/ip-address");
var _issueClosed = require("./components/issue-closed");
var _issueNew = require("./components/issue-new");
var _issue = require("./components/issue");
var _italic = require("./components/italic");
var _joinTable = require("./components/join-table");
var _keyBackspace = require("./components/key-backspace");
var _keyCommand = require("./components/key-command");
var _keyControl = require("./components/key-control");
var _keyDelete = require("./components/key-delete");
var _keyEnter = require("./components/key-enter");
var _keyEscape = require("./components/key-escape");
var _keyOption = require("./components/key-option");
var _keyShift = require("./components/key-shift");
var _keyTab = require("./components/key-tab");
var _key = require("./components/key");
var _knownVehicle = require("./components/known-vehicle");
var _labTest = require("./components/lab-test");
var _label = require("./components/label");
var _layerOutline = require("./components/layer-outline");
var _layer = require("./components/layer");
var _layers = require("./components/layers");
var _layoutAuto = require("./components/layout-auto");
var _layoutBalloon = require("./components/layout-balloon");
var _layoutBottomRowThreeTiles = require("./components/layout-bottom-row-three-tiles");
var _layoutBottomRowTwoTiles = require("./components/layout-bottom-row-two-tiles");
var _layoutCircle = require("./components/layout-circle");
var _layoutGrid = require("./components/layout-grid");
var _layoutGroupBy = require("./components/layout-group-by");
var _layoutHierarchy = require("./components/layout-hierarchy");
var _layoutLeftColumnThreeTiles = require("./components/layout-left-column-three-tiles");
var _layoutLeftColumnTwoTiles = require("./components/layout-left-column-two-tiles");
var _layoutLinear = require("./components/layout-linear");
var _layoutRightColumnThreeTiles = require("./components/layout-right-column-three-tiles");
var _layoutRightColumnTwoTiles = require("./components/layout-right-column-two-tiles");
var _layoutSkewGrid = require("./components/layout-skew-grid");
var _layoutSortedClusters = require("./components/layout-sorted-clusters");
var _layoutThreeColumns = require("./components/layout-three-columns");
var _layoutThreeRows = require("./components/layout-three-rows");
var _layoutTopRowThreeTiles = require("./components/layout-top-row-three-tiles");
var _layoutTopRowTwoTiles = require("./components/layout-top-row-two-tiles");
var _layoutTwoColumns = require("./components/layout-two-columns");
var _layoutTwoRows = require("./components/layout-two-rows");
var _layout = require("./components/layout");
var _learning = require("./components/learning");
var _leftJoin = require("./components/left-join");
var _lengthenText = require("./components/lengthen-text");
var _lessThanOrEqualTo = require("./components/less-than-or-equal-to");
var _lessThan = require("./components/less-than");
var _lifesaver = require("./components/lifesaver");
var _lightbulb = require("./components/lightbulb");
var _lightning = require("./components/lightning");
var _link = require("./components/link");
var _linkedSquares = require("./components/linked-squares");
var _listColumns = require("./components/list-columns");
var _listDetailView = require("./components/list-detail-view");
var _list = require("./components/list");
var _locate = require("./components/locate");
var _lock = require("./components/lock");
var _locomotive = require("./components/locomotive");
var _logIn = require("./components/log-in");
var _logOut = require("./components/log-out");
var _lowVoltagePole = require("./components/low-voltage-pole");
var _manual = require("./components/manual");
var _manuallyEnteredData = require("./components/manually-entered-data");
var _manyToMany = require("./components/many-to-many");
var _manyToOne = require("./components/many-to-one");
var _mapCreate = require("./components/map-create");
var _mapMarker = require("./components/map-marker");
var _map = require("./components/map");
var _maximize = require("./components/maximize");
var _media = require("./components/media");
var _menuClosed = require("./components/menu-closed");
var _menuOpen = require("./components/menu-open");
var _menu = require("./components/menu");
var _mergeColumns = require("./components/merge-columns");
var _mergeLinks = require("./components/merge-links");
var _microphone = require("./components/microphone");
var _minimize = require("./components/minimize");
var _minus = require("./components/minus");
var _mobilePhone = require("./components/mobile-phone");
var _mobileVideo = require("./components/mobile-video");
var _modalFilled = require("./components/modal-filled");
var _modal = require("./components/modal");
var _model = require("./components/model");
var _moon = require("./components/moon");
var _more = require("./components/more");
var _mountain = require("./components/mountain");
var _move = require("./components/move");
var _mugshot = require("./components/mugshot");
var _multiSelect = require("./components/multi-select");
var _music = require("./components/music");
var _nest = require("./components/nest");
var _newDrawing = require("./components/new-drawing");
var _newGridItem = require("./components/new-grid-item");
var _newLayer = require("./components/new-layer");
var _newLayers = require("./components/new-layers");
var _newLink = require("./components/new-link");
var _newObject = require("./components/new-object");
var _newPerson = require("./components/new-person");
var _newPrescription = require("./components/new-prescription");
var _newShield = require("./components/new-shield");
var _newTextBox = require("./components/new-text-box");
var _ninja = require("./components/ninja");
var _notEqualTo = require("./components/not-equal-to");
var _notificationsSnooze = require("./components/notifications-snooze");
var _notificationsUpdated = require("./components/notifications-updated");
var _notifications = require("./components/notifications");
var _numberedList = require("./components/numbered-list");
var _numerical = require("./components/numerical");
var _objectView = require("./components/object-view");
var _office = require("./components/office");
var _offline = require("./components/offline");
var _oilField = require("./components/oil-field");
var _oneColumn = require("./components/one-column");
var _oneToMany = require("./components/one-to-many");
var _oneToOne = require("./components/one-to-one");
var _openApplication = require("./components/open-application");
var _outdated = require("./components/outdated");
var _output = require("./components/output");
var _package = require("./components/package");
var _pageLayout = require("./components/page-layout");
var _panelStats = require("./components/panel-stats");
var _panelTable = require("./components/panel-table");
var _panel = require("./components/panel");
var _paperclip = require("./components/paperclip");
var _paragraph = require("./components/paragraph");
var _pasteVariable = require("./components/paste-variable");
var _pathSearch = require("./components/path-search");
var _path = require("./components/path");
var _pause = require("./components/pause");
var _people = require("./components/people");
var _percentage = require("./components/percentage");
var _person = require("./components/person");
var _phoneCall = require("./components/phone-call");
var _phoneForward = require("./components/phone-forward");
var _phone = require("./components/phone");
var _pieChart = require("./components/pie-chart");
var _pill = require("./components/pill");
var _pin = require("./components/pin");
var _pivotTable = require("./components/pivot-table");
var _pivot = require("./components/pivot");
var _play = require("./components/play");
var _playbook = require("./components/playbook");
var _plus = require("./components/plus");
var _polygonFilter = require("./components/polygon-filter");
var _power = require("./components/power");
var _predictiveAnalysis = require("./components/predictive-analysis");
var _prescription = require("./components/prescription");
var _presentation = require("./components/presentation");
var _print = require("./components/print");
var _projects = require("./components/projects");
var _properties = require("./components/properties");
var _property = require("./components/property");
var _publishFunction = require("./components/publish-function");
var _pulse = require("./components/pulse");
var _rain = require("./components/rain");
var _random = require("./components/random");
var _rangeRing = require("./components/range-ring");
var _record = require("./components/record");
var _rectHeight = require("./components/rect-height");
var _rectWidth = require("./components/rect-width");
var _rectangle = require("./components/rectangle");
var _redo = require("./components/redo");
var _refresh = require("./components/refresh");
var _regex = require("./components/regex");
var _regressionChart = require("./components/regression-chart");
var _removeColumnLeft = require("./components/remove-column-left");
var _removeColumnRight = require("./components/remove-column-right");
var _removeColumn = require("./components/remove-column");
var _removeRowBottom = require("./components/remove-row-bottom");
var _removeRowTop = require("./components/remove-row-top");
var _remove = require("./components/remove");
var _repeat = require("./components/repeat");
var _reset = require("./components/reset");
var _resolve = require("./components/resolve");
var _rig = require("./components/rig");
var _rightJoin = require("./components/right-join");
var _ring = require("./components/ring");
var _rocketSlant = require("./components/rocket-slant");
var _rocket = require("./components/rocket");
var _rotateCcw = require("./components/rotate-ccw");
var _rotateCw = require("./components/rotate-cw");
var _rotateDocument = require("./components/rotate-document");
var _rotatePage = require("./components/rotate-page");
var _route = require("./components/route");
var _satellite = require("./components/satellite");
var _saved = require("./components/saved");
var _scatterPlot = require("./components/scatter-plot");
var _searchAround = require("./components/search-around");
var _searchTemplate = require("./components/search-template");
var _searchText = require("./components/search-text");
var _search = require("./components/search");
var _segmentedControl = require("./components/segmented-control");
var _select = require("./components/select");
var _selection = require("./components/selection");
var _sendBackward = require("./components/send-backward");
var _sendMessage = require("./components/send-message");
var _sendToGraph = require("./components/send-to-graph");
var _sendToMap = require("./components/send-to-map");
var _sendTo = require("./components/send-to");
var _sensor = require("./components/sensor");
var _seriesAdd = require("./components/series-add");
var _seriesConfiguration = require("./components/series-configuration");
var _seriesDerived = require("./components/series-derived");
var _seriesFiltered = require("./components/series-filtered");
var _seriesSearch = require("./components/series-search");
var _serverInstall = require("./components/server-install");
var _server = require("./components/server");
var _settings = require("./components/settings");
var _shapes = require("./components/shapes");
var _share = require("./components/share");
var _sharedFilter = require("./components/shared-filter");
var _shield = require("./components/shield");
var _ship = require("./components/ship");
var _shop = require("./components/shop");
var _shoppingCart = require("./components/shopping-cart");
var _shortenText = require("./components/shorten-text");
var _signalSearch = require("./components/signal-search");
var _simCard = require("./components/sim-card");
var _slash = require("./components/slash");
var _smallCross = require("./components/small-cross");
var _smallInfoSign = require("./components/small-info-sign");
var _smallMinus = require("./components/small-minus");
var _smallPlus = require("./components/small-plus");
var _smallSquare = require("./components/small-square");
var _smallTick = require("./components/small-tick");
var _snowflake = require("./components/snowflake");
var _soccerBall = require("./components/soccer-ball");
var _socialMedia = require("./components/social-media");
var _sortAlphabeticalDesc = require("./components/sort-alphabetical-desc");
var _sortAlphabetical = require("./components/sort-alphabetical");
var _sortAsc = require("./components/sort-asc");
var _sortDesc = require("./components/sort-desc");
var _sortNumericalDesc = require("./components/sort-numerical-desc");
var _sortNumerical = require("./components/sort-numerical");
var _sort = require("./components/sort");
var _spellCheck = require("./components/spell-check");
var _splitColumns = require("./components/split-columns");
var _sportsStadium = require("./components/sports-stadium");
var _square = require("./components/square");
var _stackedChart = require("./components/stacked-chart");
var _stadiumGeometry = require("./components/stadium-geometry");
var _starEmpty = require("./components/star-empty");
var _star = require("./components/star");
var _stepBackward = require("./components/step-backward");
var _stepChart = require("./components/step-chart");
var _stepForward = require("./components/step-forward");
var _stop = require("./components/stop");
var _stopwatch = require("./components/stopwatch");
var _strikethrough = require("./components/strikethrough");
var _style = require("./components/style");
var _subscript = require("./components/subscript");
var _superscript = require("./components/superscript");
var _swapHorizontal = require("./components/swap-horizontal");
var _swapVertical = require("./components/swap-vertical");
var _switch = require("./components/switch");
var _symbolCircle = require("./components/symbol-circle");
var _symbolCross = require("./components/symbol-cross");
var _symbolDiamond = require("./components/symbol-diamond");
var _symbolRectangle = require("./components/symbol-rectangle");
var _symbolSquare = require("./components/symbol-square");
var _symbolTriangleDown = require("./components/symbol-triangle-down");
var _symbolTriangleUp = require("./components/symbol-triangle-up");
var _syringe = require("./components/syringe");
var _tableSync = require("./components/table-sync");
var _tagAdd = require("./components/tag-add");
var _tagPromote = require("./components/tag-promote");
var _tagRefresh = require("./components/tag-refresh");
var _tagUndo = require("./components/tag-undo");
var _tag = require("./components/tag");
var _tags = require("./components/tags");
var _takeAction = require("./components/take-action");
var _tank = require("./components/tank");
var _target = require("./components/target");
var _taxi = require("./components/taxi");
var _team = require("./components/team");
var _temperature = require("./components/temperature");
var _textHighlight = require("./components/text-highlight");
var _thAdd = require("./components/th-add");
var _thDerived = require("./components/th-derived");
var _thDisconnect = require("./components/th-disconnect");
var _thFiltered = require("./components/th-filtered");
var _thListAdd = require("./components/th-list-add");
var _thList = require("./components/th-list");
var _thVirtualAdd = require("./components/th-virtual-add");
var _thVirtual = require("./components/th-virtual");
var _th = require("./components/th");
var _thirdParty = require("./components/third-party");
var _thumbsDown = require("./components/thumbs-down");
var _thumbsUp = require("./components/thumbs-up");
var _tickCircle = require("./components/tick-circle");
var _tick = require("./components/tick");
var _time = require("./components/time");
var _timelineAreaChart = require("./components/timeline-area-chart");
var _timelineBarChart = require("./components/timeline-bar-chart");
var _timelineEvents = require("./components/timeline-events");
var _timelineLineChart = require("./components/timeline-line-chart");
var _tint = require("./components/tint");
var _torch = require("./components/torch");
var _tractor = require("./components/tractor");
var _train = require("./components/train");
var _translate = require("./components/translate");
var _trash = require("./components/trash");
var _tree = require("./components/tree");
var _trendingDown = require("./components/trending-down");
var _trendingUp = require("./components/trending-up");
var _trophy = require("./components/trophy");
var _truck = require("./components/truck");
var _twoColumns = require("./components/two-columns");
var _unarchive = require("./components/unarchive");
var _underline = require("./components/underline");
var _undo = require("./components/undo");
var _ungroupObjects = require("./components/ungroup-objects");
var _unknownVehicle = require("./components/unknown-vehicle");
var _unlink = require("./components/unlink");
var _unlock = require("./components/unlock");
var _unpin = require("./components/unpin");
var _unresolve = require("./components/unresolve");
var _updated = require("./components/updated");
var _upload = require("./components/upload");
var _user = require("./components/user");
var _variable = require("./components/variable");
var _vector = require("./components/vector");
var _verticalBarChartAsc = require("./components/vertical-bar-chart-asc");
var _verticalBarChartDesc = require("./components/vertical-bar-chart-desc");
var _verticalDistribution = require("./components/vertical-distribution");
var _verticalInbetween = require("./components/vertical-inbetween");
var _video = require("./components/video");
var _virus = require("./components/virus");
var _volumeDown = require("./components/volume-down");
var _volumeOff = require("./components/volume-off");
var _volumeUp = require("./components/volume-up");
var _walk = require("./components/walk");
var _warningSign = require("./components/warning-sign");
var _waterfallChart = require("./components/waterfall-chart");
var _waves = require("./components/waves");
var _widgetButton = require("./components/widget-button");
var _widgetFooter = require("./components/widget-footer");
var _widgetHeader = require("./components/widget-header");
var _widget = require("./components/widget");
var _wind = require("./components/wind");
var _wrenchRedo = require("./components/wrench-redo");
var _wrenchSnooze = require("./components/wrench-snooze");
var _wrenchTime = require("./components/wrench-time");
var _wrench = require("./components/wrench");
var _zoomIn = require("./components/zoom-in");
var _zoomOut = require("./components/zoom-out");
var _zoomToFit = require("./components/zoom-to-fit");

},{"../index":"5sRCQ","./components/add-clip":"lVdW3","./components/add-column-left":"avrNy","./components/add-column-right":"lRtul","./components/add-location":"jrt3n","./components/add-row-bottom":"cWxpT","./components/add-row-top":"5rL9V","./components/add-to-artifact":"hCuzx","./components/add-to-folder":"hkcTz","./components/add":"aSlbd","./components/aimpoints-target":"78CnI","./components/airplane":"ntnQx","./components/align-center":"1Nnv6","./components/align-justify":"qcQpk","./components/align-left":"cQZgT","./components/align-right":"9LoJ5","./components/alignment-bottom":"6JHem","./components/alignment-horizontal-center":"jrPXA","./components/alignment-left":"kzSO6","./components/alignment-right":"jrNFy","./components/alignment-top":"8nyQN","./components/alignment-vertical-center":"hQAB1","./components/ammunition":"ino6c","./components/anchor":"bn3rH","./components/annotation":"k9UIt","./components/antenna":"8l08a","./components/app-header":"5o4u3","./components/application":"44NV6","./components/applications":"7nZQH","./components/archive":"c7CAX","./components/area-of-interest":"hoKXF","./components/array-boolean":"lwVrh","./components/array-date":"aBFnS","./components/array-floating-point":"9QUKT","./components/array-numeric":"a1qX4","./components/array-string":"2ysNW","./components/array-timestamp":"6fwdY","./components/array":"cpEIL","./components/arrow-bottom-left":"l0Fzm","./components/arrow-bottom-right":"4iZFn","./components/arrow-down":"igNtS","./components/arrow-left":"2PHVM","./components/arrow-right":"3pmoU","./components/arrow-top-left":"dbrAS","./components/arrow-top-right":"PkYIo","./components/arrow-up":"bDXjO","./components/arrows-arc":"2R75V","./components/arrows-horizontal":"dHpiH","./components/arrows-vertical":"gUs3O","./components/asterisk":"aT6TH","./components/at":"hzSQV","./components/automatic-updates":"1FYN6","./components/axle":"cva67","./components/backlink":"kH3wq","./components/backward-ten":"bO0a5","./components/badge":"1iSHO","./components/ban-circle":"lmeQA","./components/bank-account":"9dCA8","./components/barcode":"iePn2","./components/binary-number":"4HBib","./components/blank":"dhdhh","./components/block-promote":"2MPyT","./components/blocked-person":"iLexl","./components/bold":"kbdEx","./components/book":"4J3M0","./components/bookmark":"cdeZw","./components/box":"aIz39","./components/briefcase":"l2KA8","./components/bring-data":"9x5YN","./components/bring-forward":"iHBq0","./components/british-pound":"1lPRd","./components/bug":"7NICm","./components/buggy":"lhhVJ","./components/build":"bbX2e","./components/bullseye":"lC8Xa","./components/calculator":"3gppB","./components/calendar":"lxdmc","./components/camera":"vHSl7","./components/caret-down":"iALAN","./components/caret-left":"fosY9","./components/caret-right":"fBAUG","./components/caret-up":"atJoJ","./components/cargo-ship":"f732N","./components/cell-tower":"klKQK","./components/changes":"dXj1L","./components/chart":"dKm9r","./components/chat":"aZEIT","./components/chevron-backward":"9Qq2s","./components/chevron-down":"dzkD8","./components/chevron-forward":"fNeMM","./components/chevron-left":"cT523","./components/chevron-right":"hy2GQ","./components/chevron-up":"5PLt2","./components/circle-arrow-down":"2xCFH","./components/circle-arrow-left":"iQpBM","./components/circle-arrow-right":"eFs0K","./components/circle-arrow-up":"7rgpT","./components/circle":"igHuU","./components/citation":"4SJGP","./components/clean":"euT4d","./components/clip":"lackh","./components/clipboard-file":"dSKoh","./components/clipboard":"2F14D","./components/cloud-download":"2tkYT","./components/cloud-server":"lBPG0","./components/cloud-tick":"b1Po0","./components/cloud-upload":"4jfc3","./components/cloud":"3wjtR","./components/code-block":"01P5q","./components/code":"f05tp","./components/cog":"9eIfa","./components/collapse-all":"g9MuN","./components/color-fill":"6hKJM","./components/column-layout":"jUIro","./components/comment":"eOEIG","./components/comparison":"lRl7q","./components/compass":"d9vwe","./components/compressed":"2ltCe","./components/confirm":"6Sd58","./components/console":"bn2my","./components/contrast":"8jLQ3","./components/control":"4nx42","./components/credit-card":"67HkW","./components/crop":"5a0rO","./components/cross-circle":"crplJ","./components/cross":"eW4sq","./components/crown":"8I3Ql","./components/css-style":"XLvug","./components/cube-add":"BAbn6","./components/cube-edit":"e1YqF","./components/cube-remove":"aRYMA","./components/cube":"6hCrm","./components/cubes":"d6QxW","./components/curly-braces":"9vORm","./components/curved-range-chart":"eUD0a","./components/cut":"5Ja08","./components/cycle":"8UtxA","./components/dashboard":"5snCX","./components/data-connection":"6YxVb","./components/data-lineage":"9dp69","./components/data-search":"gi27r","./components/data-sync":"lnajB","./components/database":"cocSf","./components/delete":"3Q541","./components/delta":"7Xoqo","./components/derive-column":"6Thvi","./components/desktop":"b2ln4","./components/detection":"7bQ12","./components/diagnosis":"5mffU","./components/diagram-tree":"ihOt5","./components/direction-left":"jYapn","./components/direction-right":"g3hkr","./components/disable":"9ydTO","./components/divide":"8fP8n","./components/document-open":"7M4BR","./components/document-share":"kKcxR","./components/document":"cOLqs","./components/dollar":"XAoln","./components/dot":"45zBM","./components/double-caret-horizontal":"hVoPF","./components/double-caret-vertical":"25ncP","./components/double-chevron-down":"iHyY5","./components/double-chevron-left":"gkJmi","./components/double-chevron-right":"6rJq5","./components/double-chevron-up":"iwPyX","./components/doughnut-chart":"97Tac","./components/download":"bxNdW","./components/drag-handle-horizontal":"lwSnz","./components/drag-handle-vertical":"g8mmJ","./components/draw":"ccrQu","./components/drawer-left-filled":"b6YRC","./components/drawer-left":"dbxmT","./components/drawer-right-filled":"7uJYX","./components/drawer-right":"lehsn","./components/drive-time":"9JKPn","./components/duplicate":"cF57l","./components/edit":"fKo1g","./components/eject":"iD3tq","./components/emoji":"jFkhK","./components/endnote":"9gEbp","./components/endorsed":"eBEbf","./components/envelope":"9a51A","./components/equals":"bT0FL","./components/eraser":"aPdCo","./components/error":"d8PhF","./components/euro":"kkFWA","./components/excavator":"4fczm","./components/exchange":"exbzT","./components/exclude-row":"8PsQh","./components/expand-all":"8FrLl","./components/explain":"abcgL","./components/export":"ja1qA","./components/eye-off":"lRxNZ","./components/eye-on":"30bc2","./components/eye-open":"9nMLv","./components/fast-backward":"hpbb0","./components/fast-forward":"2OKbi","./components/feed-subscribed":"5UsHX","./components/feed":"ltDlR","./components/fighter-jet":"gPbhH","./components/film":"aZXO6","./components/filter-keep":"iyHhU","./components/filter-list":"43Wvs","./components/filter-open":"ePWj4","./components/filter-remove":"kzANK","./components/filter-sort-asc":"7xkxo","./components/filter-sort-desc":"cpD5T","./components/filter":"dmda5","./components/flag":"kd8iq","./components/flame":"i9odL","./components/flash":"6Z4eM","./components/floating-point":"2y8Oj","./components/floppy-disk":"aMjy1","./components/flow-branch":"jn3Xv","./components/flow-end":"kILpt","./components/flow-linear":"9ZO8P","./components/flow-review-branch":"lRhQT","./components/flow-review":"loYvu","./components/flows":"2AxUR","./components/folder-close":"hKHPb","./components/folder-new":"4YfMg","./components/folder-open":"fgTru","./components/folder-shared-open":"2EzSQ","./components/folder-shared":"kc26Y","./components/follower":"9xURw","./components/following":"81RzT","./components/font":"k3B9B","./components/fork":"5X4lV","./components/form":"fYKU9","./components/forward-ten":"ItpEY","./components/fuel":"7ZTtC","./components/full-circle":"4TbkO","./components/full-stacked-chart":"66tk9","./components/fullscreen":"12jUl","./components/function":"iGbS5","./components/gantt-chart":"bDvkw","./components/generate":"ksGp8","./components/geofence":"2K1yx","./components/geolocation":"83Qux","./components/geosearch":"bEnfC","./components/geotime":"6VfO2","./components/git-branch":"b44lo","./components/git-commit":"2ZXXz","./components/git-merge":"Gs4zn","./components/git-new-branch":"ljK9i","./components/git-pull":"3jRMp","./components/git-push":"apd9W","./components/git-repo":"5VtLd","./components/glass":"1s6TD","./components/globe-network-add":"7vYQY","./components/globe-network":"8UB2d","./components/globe":"8Vr10","./components/graph-remove":"hmowO","./components/graph":"2FiUY","./components/greater-than-or-equal-to":"b7NLT","./components/greater-than":"hPYa5","./components/grid-view":"gB9IR","./components/grid":"eDyA8","./components/group-item":"cec7v","./components/group-objects":"dnxkb","./components/grouped-bar-chart":"a9ore","./components/hand-down":"3sLYI","./components/hand-left":"7B7yQ","./components/hand-right":"f0e6d","./components/hand-up":"ik4B9","./components/hand":"fNIb6","./components/hat":"4FUyo","./components/header-one":"kBIrp","./components/header-three":"hy5f5","./components/header-two":"aPvA2","./components/header":"iYPYv","./components/headset":"6AKc1","./components/heart-broken":"fMebq","./components/heart":"1E91Q","./components/heat-grid":"51bLD","./components/heatmap":"gD5Is","./components/helicopter":"jGuh2","./components/help":"kPbGp","./components/helper-management":"7wHni","./components/hexagon":"fRNJP","./components/high-priority":"4nuKQ","./components/high-voltage-pole":"e78ls","./components/highlight":"braiq","./components/history":"4E3ml","./components/home":"gIJo4","./components/horizontal-bar-chart-asc":"7xOmG","./components/horizontal-bar-chart-desc":"c9VYZ","./components/horizontal-bar-chart":"dCqQ2","./components/horizontal-distribution":"76oQQ","./components/horizontal-inbetween":"bi5DX","./components/hurricane":"7sQ59","./components/id-number":"1lOgy","./components/image-rotate-left":"di8PT","./components/image-rotate-right":"3SZ3n","./components/import":"1m1jq","./components/inbox-filtered":"bRgL0","./components/inbox-geo":"8MM1s","./components/inbox-search":"hjA0I","./components/inbox-update":"4LDwr","./components/inbox":"lDykF","./components/info-sign":"cSMcB","./components/inheritance":"cr2Za","./components/inherited-group":"gtq8D","./components/inner-join":"6aYI4","./components/input":"3LNmK","./components/insert":"65daK","./components/intelligence":"60d2M","./components/intersection":"66TBR","./components/ip-address":"42iaU","./components/issue-closed":"8Rq1W","./components/issue-new":"7PVu5","./components/issue":"cU186","./components/italic":"6B4Aw","./components/join-table":"ixbXV","./components/key-backspace":"fuh4U","./components/key-command":"coymA","./components/key-control":"8cmxX","./components/key-delete":"i0ucP","./components/key-enter":"6TkdO","./components/key-escape":"lalRM","./components/key-option":"8TaRn","./components/key-shift":"6RgZP","./components/key-tab":"jmomH","./components/key":"cnNbr","./components/known-vehicle":"5yPUD","./components/lab-test":"iQQKm","./components/label":"76nuU","./components/layer-outline":"dhQhG","./components/layer":"cHP6r","./components/layers":"iCSVt","./components/layout-auto":"3ZyBy","./components/layout-balloon":"k3dQ9","./components/layout-bottom-row-three-tiles":"gUsuP","./components/layout-bottom-row-two-tiles":"hDthG","./components/layout-circle":"flPeO","./components/layout-grid":"02Upx","./components/layout-group-by":"8wMrg","./components/layout-hierarchy":"iJfOt","./components/layout-left-column-three-tiles":"gVUx0","./components/layout-left-column-two-tiles":"dHrrU","./components/layout-linear":"4fWUo","./components/layout-right-column-three-tiles":"e21Uw","./components/layout-right-column-two-tiles":"g0JmJ","./components/layout-skew-grid":"bPzt5","./components/layout-sorted-clusters":"9HX57","./components/layout-three-columns":"l2XuI","./components/layout-three-rows":"4DKme","./components/layout-top-row-three-tiles":"fsB6X","./components/layout-top-row-two-tiles":"3uTTs","./components/layout-two-columns":"SifBi","./components/layout-two-rows":"emC3J","./components/layout":"i5gsV","./components/learning":"71rNn","./components/left-join":"bluGH","./components/lengthen-text":"fJseg","./components/less-than-or-equal-to":"gJfXq","./components/less-than":"qZ3ul","./components/lifesaver":"jFOAP","./components/lightbulb":"7DdSe","./components/lightning":"8fgnQ","./components/link":"9P7Qe","./components/linked-squares":"RzNkA","./components/list-columns":"3zprt","./components/list-detail-view":"9X8TG","./components/list":"f4Gf5","./components/locate":"dlH2T","./components/lock":"ebYad","./components/locomotive":"13QY2","./components/log-in":"cNJAD","./components/log-out":"cJDBJ","./components/low-voltage-pole":"elgVU","./components/manual":"7YtNA","./components/manually-entered-data":"3iQan","./components/many-to-many":"kSM8a","./components/many-to-one":"c8vmd","./components/map-create":"8baFV","./components/map-marker":"bvRmB","./components/map":"7UvNa","./components/maximize":"8gGiZ","./components/media":"lYanV","./components/menu-closed":"kFU5r","./components/menu-open":"iPu4b","./components/menu":"i5R4i","./components/merge-columns":"3CqtS","./components/merge-links":"dYSvh","./components/microphone":"8e0kw","./components/minimize":"9TXRM","./components/minus":"bhEiZ","./components/mobile-phone":"hrzDk","./components/mobile-video":"eUh58","./components/modal-filled":"1T4my","./components/modal":"2jQ8B","./components/model":"d7NcF","./components/moon":"cjrTe","./components/more":"9kmD5","./components/mountain":"d9dmT","./components/move":"4oBfy","./components/mugshot":"agAhm","./components/multi-select":"cnFCN","./components/music":"kZgEx","./components/nest":"1Vxe8","./components/new-drawing":"1uquM","./components/new-grid-item":"dThdU","./components/new-layer":"4eGu8","./components/new-layers":"7o9kp","./components/new-link":"hhqxr","./components/new-object":"7kQvS","./components/new-person":"gjBJV","./components/new-prescription":"9fO8X","./components/new-shield":"9v66y","./components/new-text-box":"43QFo","./components/ninja":"c0U1i","./components/not-equal-to":"22MW2","./components/notifications-snooze":"gsxR7","./components/notifications-updated":"coeDk","./components/notifications":"waksK","./components/numbered-list":"bgPrw","./components/numerical":"7pmf3","./components/object-view":"f20lr","./components/office":"6GoMt","./components/offline":"331kf","./components/oil-field":"4d8qI","./components/one-column":"liko0","./components/one-to-many":"g2FNs","./components/one-to-one":"XhSNp","./components/open-application":"dT3e8","./components/outdated":"19uMc","./components/output":"D1cpF","./components/package":"lxKfz","./components/page-layout":"6AYGJ","./components/panel-stats":"9dnZQ","./components/panel-table":"3AEnp","./components/panel":"8ZgaK","./components/paperclip":"hbQxr","./components/paragraph":"8FVZb","./components/paste-variable":"a6bAp","./components/path-search":"fy2GF","./components/path":"bRXae","./components/pause":"glhIV","./components/people":"gX8VC","./components/percentage":"jszDF","./components/person":"gpbHe","./components/phone-call":"71006","./components/phone-forward":"4oOYt","./components/phone":"7zQpv","./components/pie-chart":"fxTxf","./components/pill":"axJ1i","./components/pin":"nrrGD","./components/pivot-table":"7tE41","./components/pivot":"dGc7U","./components/play":"kfLZj","./components/playbook":"lc37U","./components/plus":"9nkvz","./components/polygon-filter":"528Cr","./components/power":"5nm8G","./components/predictive-analysis":"dv95q","./components/prescription":"lD0nF","./components/presentation":"bscwS","./components/print":"ldWy6","./components/projects":"iu1OD","./components/properties":"13ovW","./components/property":"fk1n7","./components/publish-function":"h4ZJg","./components/pulse":"4xhNY","./components/rain":"cVAlw","./components/random":"5eX2a","./components/range-ring":"e9N4r","./components/record":"jazj9","./components/rect-height":"fi8vo","./components/rect-width":"73Dp4","./components/rectangle":"kWLaS","./components/redo":"eFEEr","./components/refresh":"7ydPz","./components/regex":"fdQM0","./components/regression-chart":"2Eu56","./components/remove-column-left":"jcMS0","./components/remove-column-right":"6KYfF","./components/remove-column":"gnpFL","./components/remove-row-bottom":"iIkEv","./components/remove-row-top":"eZdDr","./components/remove":"8AMLh","./components/repeat":"ioWGH","./components/reset":"fj7An","./components/resolve":"io9BC","./components/rig":"5X9Ab","./components/right-join":"l2ZXW","./components/ring":"98eZm","./components/rocket-slant":"jDDfn","./components/rocket":"4t9Rd","./components/rotate-ccw":"akpQC","./components/rotate-cw":"aq3PI","./components/rotate-document":"gjb1Y","./components/rotate-page":"gM2pU","./components/route":"b6l5S","./components/satellite":"jDvLc","./components/saved":"24WzM","./components/scatter-plot":"jaGex","./components/search-around":"5R1as","./components/search-template":"cdKfH","./components/search-text":"gVlB7","./components/search":"9kMiy","./components/segmented-control":"eAdkM","./components/select":"lanex","./components/selection":"1szIJ","./components/send-backward":"fzKKf","./components/send-message":"hPpp4","./components/send-to-graph":"etLwb","./components/send-to-map":"7pmeH","./components/send-to":"9fomE","./components/sensor":"3OllA","./components/series-add":"1ydZf","./components/series-configuration":"leJHU","./components/series-derived":"1Rzza","./components/series-filtered":"5mCuI","./components/series-search":"6Jn4j","./components/server-install":"8wrbZ","./components/server":"dHgqo","./components/settings":"dgWGZ","./components/shapes":"6yEyz","./components/share":"4381R","./components/shared-filter":"642KR","./components/shield":"i3xYB","./components/ship":"ibnHm","./components/shop":"4vuIS","./components/shopping-cart":"4XfUC","./components/shorten-text":"7YB30","./components/signal-search":"ln5WD","./components/sim-card":"fFP0z","./components/slash":"38K7d","./components/small-cross":"75XfC","./components/small-info-sign":"6RAbr","./components/small-minus":"jM1iY","./components/small-plus":"hrUSA","./components/small-square":"6II6L","./components/small-tick":"6Ek4D","./components/snowflake":"ljODz","./components/soccer-ball":"hiKvq","./components/social-media":"29yvH","./components/sort-alphabetical-desc":"iXq1L","./components/sort-alphabetical":"lFApM","./components/sort-asc":"l0yH7","./components/sort-desc":"71ihm","./components/sort-numerical-desc":"iS1vb","./components/sort-numerical":"gLEH2","./components/sort":"84vyj","./components/spell-check":"dvhJp","./components/split-columns":"kvAkq","./components/sports-stadium":"2goj4","./components/square":"cEhLm","./components/stacked-chart":"77OSR","./components/stadium-geometry":"04HFj","./components/star-empty":"6odjA","./components/star":"3aNRx","./components/step-backward":"bW69N","./components/step-chart":"jIGS6","./components/step-forward":"6anQs","./components/stop":"iKpBm","./components/stopwatch":"klfGK","./components/strikethrough":"5oKdq","./components/style":"aJ1BE","./components/subscript":"eBUFj","./components/superscript":"cHZd6","./components/swap-horizontal":"7ZEtW","./components/swap-vertical":"6Cyjh","./components/switch":"4byok","./components/symbol-circle":"cCXMQ","./components/symbol-cross":"cBgfQ","./components/symbol-diamond":"gHQCb","./components/symbol-rectangle":"5sSrd","./components/symbol-square":"ictTK","./components/symbol-triangle-down":"aHnXd","./components/symbol-triangle-up":"4o2EF","./components/syringe":"cK51V","./components/table-sync":"gPFpv","./components/tag-add":"8qUMX","./components/tag-promote":"iwNsx","./components/tag-refresh":"39bkU","./components/tag-undo":"62KLj","./components/tag":"i4NrP","./components/tags":"i7JIe","./components/take-action":"hyoOG","./components/tank":"aDK7N","./components/target":"iZ66N","./components/taxi":"49Rfr","./components/team":"9HaFv","./components/temperature":"i8BQ2","./components/text-highlight":"bUDM2","./components/th-add":"7NzeN","./components/th-derived":"ccjg5","./components/th-disconnect":"dbc01","./components/th-filtered":"kK6dU","./components/th-list-add":"1MWM8","./components/th-list":"wCc5D","./components/th-virtual-add":"fJvAh","./components/th-virtual":"js4SE","./components/th":"cpHsU","./components/third-party":"2cBy5","./components/thumbs-down":"eq5yE","./components/thumbs-up":"kayj4","./components/tick-circle":"iFGi1","./components/tick":"d6Bzh","./components/time":"RWj6W","./components/timeline-area-chart":"9yku9","./components/timeline-bar-chart":"c9Q3e","./components/timeline-events":"bAHAl","./components/timeline-line-chart":"2WcVU","./components/tint":"ckuZs","./components/torch":"6HAJo","./components/tractor":"g11cF","./components/train":"f1F9x","./components/translate":"k3DCJ","./components/trash":"jbXNV","./components/tree":"5XDof","./components/trending-down":"erZ1h","./components/trending-up":"5sz08","./components/trophy":"eRBiI","./components/truck":"6eh5m","./components/two-columns":"dSHoO","./components/unarchive":"fQXhB","./components/underline":"6NsLr","./components/undo":"79IDH","./components/ungroup-objects":"6mQWy","./components/unknown-vehicle":"gBBTq","./components/unlink":"0TLKI","./components/unlock":"lWJlu","./components/unpin":"3KD60","./components/unresolve":"jVuzR","./components/updated":"ejK5Z","./components/upload":"xgr62","./components/user":"cF9rS","./components/variable":"6sFQa","./components/vector":"gK7GF","./components/vertical-bar-chart-asc":"3A4My","./components/vertical-bar-chart-desc":"i0crC","./components/vertical-distribution":"dPnt9","./components/vertical-inbetween":"eYjL4","./components/video":"64ZxF","./components/virus":"irhqb","./components/volume-down":"bSZXU","./components/volume-off":"jIVs3","./components/volume-up":"lpdiO","./components/walk":"3tyX2","./components/warning-sign":"2z9sB","./components/waterfall-chart":"kuC05","./components/waves":"3YIpB","./components/widget-button":"9ZaDY","./components/widget-footer":"eE3HO","./components/widget-header":"9QbYx","./components/widget":"2niab","./components/wind":"eIHiI","./components/wrench-redo":"e1pj5","./components/wrench-snooze":"dQ4vK","./components/wrench-time":"5KTrQ","./components/wrench":"9P6Fp","./components/zoom-in":"gfKRC","./components/zoom-out":"20PvE","./components/zoom-to-fit":"6LcUx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5sRCQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // N.B. these named imports will trigger bundlers to statically loads all icon path modules
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconSvgPaths16", ()=>(0, _allPaths.IconSvgPaths16));
parcelHelpers.export(exports, "IconSvgPaths20", ()=>(0, _allPaths.IconSvgPaths20));
parcelHelpers.export(exports, "getIconPaths", ()=>(0, _allPaths.getIconPaths));
parcelHelpers.export(exports, "Icons", ()=>(0, _iconLoader.Icons));
parcelHelpers.export(exports, "SVGIconContainer", ()=>(0, _svgIconContainer.SVGIconContainer));
parcelHelpers.export(exports, "getIconContentString", ()=>(0, _iconCodepoints.getIconContentString));
parcelHelpers.export(exports, "IconCodepoints", ()=>(0, _iconCodepoints.IconCodepoints));
parcelHelpers.export(exports, "IconNames", ()=>(0, _iconNames.IconNames));
parcelHelpers.export(exports, "IconSize", ()=>(0, _iconTypes.IconSize));
var _allPaths = require("./allPaths");
var _iconLoader = require("./iconLoader");
var _svgIconContainer = require("./svgIconContainer");
var _iconCodepoints = require("./iconCodepoints");
var _iconNames = require("./iconNames");
var _iconTypes = require("./iconTypes");

},{"./allPaths":"g4jpj","./iconLoader":"34sEn","./svgIconContainer":"1BB1X","./iconCodepoints":"1lD7j","./iconNames":"anJGa","./iconTypes":"kknia","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g4jpj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconSvgPaths16", ()=>_paths);
parcelHelpers.export(exports, "IconSvgPaths20", ()=>_paths1);
/**
 * Get the list of vector paths that define a given icon. These path strings are used to render `<path>`
 * elements inside an `<svg>` icon element. For full implementation details and nuances, see the icon component
 * handlebars template and `generate-icon-components` script in the __@blueprintjs/icons__ package.
 *
 * Note: this function loads all icon definitions __statically__, which means every icon is included in your
 * JS bundle. Only use this API if your app is likely to use all Blueprint icons at runtime. If you are looking for a
 * dynamic icon loader which loads icon definitions on-demand, use `{ Icons } from "@blueprintjs/icons"` instead.
 */ parcelHelpers.export(exports, "getIconPaths", ()=>getIconPaths);
/**
 * Type safe string literal conversion of snake-case icon names to PascalCase icon names.
 * This is useful for indexing into the SVG paths record to extract a single icon's SVG path definition.
 *
 * @deprecated use `getIconPaths` instead
 */ parcelHelpers.export(exports, "iconNameToPathsRecordKey", ()=>iconNameToPathsRecordKey);
var _changeCase = require("change-case");
var _paths = require("./generated/16px/paths");
var _paths1 = require("./generated/20px/paths");
var _iconTypes = require("./iconTypes");
function getIconPaths(name, size) {
    var key = (0, _changeCase.pascalCase)(name);
    return size === (0, _iconTypes.IconSize).STANDARD ? _paths[key] : _paths1[key];
}
function iconNameToPathsRecordKey(name) {
    return (0, _changeCase.pascalCase)(name);
}

},{"change-case":"itgXF","./generated/16px/paths":"E4FcU","./generated/20px/paths":"97non","./iconTypes":"kknia","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"itgXF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _camelCase = require("camel-case");
parcelHelpers.exportAll(_camelCase, exports);
var _capitalCase = require("capital-case");
parcelHelpers.exportAll(_capitalCase, exports);
var _constantCase = require("constant-case");
parcelHelpers.exportAll(_constantCase, exports);
var _dotCase = require("dot-case");
parcelHelpers.exportAll(_dotCase, exports);
var _headerCase = require("header-case");
parcelHelpers.exportAll(_headerCase, exports);
var _noCase = require("no-case");
parcelHelpers.exportAll(_noCase, exports);
var _paramCase = require("param-case");
parcelHelpers.exportAll(_paramCase, exports);
var _pascalCase = require("pascal-case");
parcelHelpers.exportAll(_pascalCase, exports);
var _pathCase = require("path-case");
parcelHelpers.exportAll(_pathCase, exports);
var _sentenceCase = require("sentence-case");
parcelHelpers.exportAll(_sentenceCase, exports);
var _snakeCase = require("snake-case");
parcelHelpers.exportAll(_snakeCase, exports);

},{"camel-case":"dcCsp","capital-case":"5m81I","constant-case":"4S3Bs","dot-case":"cW4nW","header-case":"94y5G","no-case":"fNmjG","param-case":"15MVN","pascal-case":"9LXPm","path-case":"5vSwJ","sentence-case":"36CFS","snake-case":"5EcFm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dcCsp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelCaseTransform", ()=>camelCaseTransform);
parcelHelpers.export(exports, "camelCaseTransformMerge", ()=>camelCaseTransformMerge);
parcelHelpers.export(exports, "camelCase", ()=>camelCase);
var _tslib = require("tslib");
var _pascalCase = require("pascal-case");
function camelCaseTransform(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, _pascalCase.pascalCaseTransform)(input, index);
}
function camelCaseTransformMerge(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, _pascalCase.pascalCaseTransformMerge)(input);
}
function camelCase(input, options) {
    if (options === void 0) options = {};
    return (0, _pascalCase.pascalCase)(input, (0, _tslib.__assign)({
        transform: camelCaseTransform
    }, options));
}

},{"tslib":"b4wpY","pascal-case":"9LXPm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9LXPm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pascalCaseTransform", ()=>pascalCaseTransform);
parcelHelpers.export(exports, "pascalCaseTransformMerge", ()=>pascalCaseTransformMerge);
parcelHelpers.export(exports, "pascalCase", ()=>pascalCase);
var _tslib = require("tslib");
var _noCase = require("no-case");
function pascalCaseTransform(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function pascalCaseTransformMerge(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function pascalCase(input, options) {
    if (options === void 0) options = {};
    return (0, _noCase.noCase)(input, (0, _tslib.__assign)({
        delimiter: "",
        transform: pascalCaseTransform
    }, options));
}

},{"tslib":"b4wpY","no-case":"fNmjG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fNmjG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Normalize the string into something other libraries can manipulate easier.
 */ parcelHelpers.export(exports, "noCase", ()=>noCase);
var _lowerCase = require("lower-case");
// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function noCase(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, _lowerCase.lowerCase) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\0")start++;
    while(result.charAt(end - 1) === "\0")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}

},{"lower-case":"giinL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"giinL":[function(require,module,exports,__globalThis) {
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Localized lower case.
 */ parcelHelpers.export(exports, "localeLowerCase", ()=>localeLowerCase);
/**
 * Lower case as a function.
 */ parcelHelpers.export(exports, "lowerCase", ()=>lowerCase);
var SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            \u0130: "\u0069",
            I: "\u0131",
            I\u0307: "\u0069"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            \u0130: "\u0069",
            I: "\u0131",
            I\u0307: "\u0069"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "\u0069\u0307",
            J: "\u006A\u0307",
            \u012E: "\u012F\u0307",
            "\xcc": "\u0069\u0307\u0300",
            "\xcd": "\u0069\u0307\u0301",
            \u0128: "\u0069\u0307\u0303"
        }
    }
};
function localeLowerCase(str, locale) {
    var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return lowerCase(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return lowerCase(str);
}
function lowerCase(str) {
    return str.toLowerCase();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5m81I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "capitalCaseTransform", ()=>capitalCaseTransform);
parcelHelpers.export(exports, "capitalCase", ()=>capitalCase);
var _tslib = require("tslib");
var _noCase = require("no-case");
var _upperCaseFirst = require("upper-case-first");
function capitalCaseTransform(input) {
    return (0, _upperCaseFirst.upperCaseFirst)(input.toLowerCase());
}
function capitalCase(input, options) {
    if (options === void 0) options = {};
    return (0, _noCase.noCase)(input, (0, _tslib.__assign)({
        delimiter: " ",
        transform: capitalCaseTransform
    }, options));
}

},{"tslib":"b4wpY","no-case":"fNmjG","upper-case-first":"e3jWK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e3jWK":[function(require,module,exports,__globalThis) {
/**
 * Upper case the first character of an input string.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "upperCaseFirst", ()=>upperCaseFirst);
function upperCaseFirst(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4S3Bs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constantCase", ()=>constantCase);
var _tslib = require("tslib");
var _noCase = require("no-case");
var _upperCase = require("upper-case");
function constantCase(input, options) {
    if (options === void 0) options = {};
    return (0, _noCase.noCase)(input, (0, _tslib.__assign)({
        delimiter: "_",
        transform: (0, _upperCase.upperCase)
    }, options));
}

},{"tslib":"b4wpY","no-case":"fNmjG","upper-case":"k2VNt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k2VNt":[function(require,module,exports,__globalThis) {
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Localized upper case.
 */ parcelHelpers.export(exports, "localeUpperCase", ()=>localeUpperCase);
/**
 * Upper case as a function.
 */ parcelHelpers.export(exports, "upperCase", ()=>upperCase);
var SUPPORTED_LOCALE = {
    tr: {
        regexp: /[\u0069]/g,
        map: {
            i: "\u0130"
        }
    },
    az: {
        regexp: /[\u0069]/g,
        map: {
            i: "\u0130"
        }
    },
    lt: {
        regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
        map: {
            i\u0307: "\u0049",
            j\u0307: "\u004A",
            \u012F\u0307: "\u012E",
            i\u0307\u0300: "\u00CC",
            i\u0307\u0301: "\u00CD",
            i\u0307\u0303: "\u0128"
        }
    }
};
function localeUpperCase(str, locale) {
    var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return upperCase(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return upperCase(str);
}
function upperCase(str) {
    return str.toUpperCase();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cW4nW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dotCase", ()=>dotCase);
var _tslib = require("tslib");
var _noCase = require("no-case");
function dotCase(input, options) {
    if (options === void 0) options = {};
    return (0, _noCase.noCase)(input, (0, _tslib.__assign)({
        delimiter: "."
    }, options));
}

},{"tslib":"b4wpY","no-case":"fNmjG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"94y5G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "headerCase", ()=>headerCase);
var _tslib = require("tslib");
var _capitalCase = require("capital-case");
function headerCase(input, options) {
    if (options === void 0) options = {};
    return (0, _capitalCase.capitalCase)(input, (0, _tslib.__assign)({
        delimiter: "-"
    }, options));
}

},{"tslib":"b4wpY","capital-case":"5m81I","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"15MVN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paramCase", ()=>paramCase);
var _tslib = require("tslib");
var _dotCase = require("dot-case");
function paramCase(input, options) {
    if (options === void 0) options = {};
    return (0, _dotCase.dotCase)(input, (0, _tslib.__assign)({
        delimiter: "-"
    }, options));
}

},{"tslib":"b4wpY","dot-case":"cW4nW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5vSwJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pathCase", ()=>pathCase);
var _tslib = require("tslib");
var _dotCase = require("dot-case");
function pathCase(input, options) {
    if (options === void 0) options = {};
    return (0, _dotCase.dotCase)(input, (0, _tslib.__assign)({
        delimiter: "/"
    }, options));
}

},{"tslib":"b4wpY","dot-case":"cW4nW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"36CFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sentenceCaseTransform", ()=>sentenceCaseTransform);
parcelHelpers.export(exports, "sentenceCase", ()=>sentenceCase);
var _tslib = require("tslib");
var _noCase = require("no-case");
var _upperCaseFirst = require("upper-case-first");
function sentenceCaseTransform(input, index) {
    var result = input.toLowerCase();
    if (index === 0) return (0, _upperCaseFirst.upperCaseFirst)(result);
    return result;
}
function sentenceCase(input, options) {
    if (options === void 0) options = {};
    return (0, _noCase.noCase)(input, (0, _tslib.__assign)({
        delimiter: " ",
        transform: sentenceCaseTransform
    }, options));
}

},{"tslib":"b4wpY","no-case":"fNmjG","upper-case-first":"e3jWK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5EcFm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "snakeCase", ()=>snakeCase);
var _tslib = require("tslib");
var _dotCase = require("dot-case");
function snakeCase(input, options) {
    if (options === void 0) options = {};
    return (0, _dotCase.dotCase)(input, (0, _tslib.__assign)({
        delimiter: "_"
    }, options));
}

},{"tslib":"b4wpY","dot-case":"cW4nW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"E4FcU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Add", ()=>(0, _addDefault.default));
parcelHelpers.export(exports, "AddClip", ()=>(0, _addClipDefault.default));
parcelHelpers.export(exports, "AddColumnLeft", ()=>(0, _addColumnLeftDefault.default));
parcelHelpers.export(exports, "AddColumnRight", ()=>(0, _addColumnRightDefault.default));
parcelHelpers.export(exports, "AddLocation", ()=>(0, _addLocationDefault.default));
parcelHelpers.export(exports, "AddRowBottom", ()=>(0, _addRowBottomDefault.default));
parcelHelpers.export(exports, "AddRowTop", ()=>(0, _addRowTopDefault.default));
parcelHelpers.export(exports, "AddToArtifact", ()=>(0, _addToArtifactDefault.default));
parcelHelpers.export(exports, "AddToFolder", ()=>(0, _addToFolderDefault.default));
parcelHelpers.export(exports, "AimpointsTarget", ()=>(0, _aimpointsTargetDefault.default));
parcelHelpers.export(exports, "Airplane", ()=>(0, _airplaneDefault.default));
parcelHelpers.export(exports, "AlignCenter", ()=>(0, _alignCenterDefault.default));
parcelHelpers.export(exports, "AlignJustify", ()=>(0, _alignJustifyDefault.default));
parcelHelpers.export(exports, "AlignLeft", ()=>(0, _alignLeftDefault.default));
parcelHelpers.export(exports, "AlignRight", ()=>(0, _alignRightDefault.default));
parcelHelpers.export(exports, "AlignmentBottom", ()=>(0, _alignmentBottomDefault.default));
parcelHelpers.export(exports, "AlignmentHorizontalCenter", ()=>(0, _alignmentHorizontalCenterDefault.default));
parcelHelpers.export(exports, "AlignmentLeft", ()=>(0, _alignmentLeftDefault.default));
parcelHelpers.export(exports, "AlignmentRight", ()=>(0, _alignmentRightDefault.default));
parcelHelpers.export(exports, "AlignmentTop", ()=>(0, _alignmentTopDefault.default));
parcelHelpers.export(exports, "AlignmentVerticalCenter", ()=>(0, _alignmentVerticalCenterDefault.default));
parcelHelpers.export(exports, "Ammunition", ()=>(0, _ammunitionDefault.default));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchorDefault.default));
parcelHelpers.export(exports, "Annotation", ()=>(0, _annotationDefault.default));
parcelHelpers.export(exports, "Antenna", ()=>(0, _antennaDefault.default));
parcelHelpers.export(exports, "AppHeader", ()=>(0, _appHeaderDefault.default));
parcelHelpers.export(exports, "Application", ()=>(0, _applicationDefault.default));
parcelHelpers.export(exports, "Applications", ()=>(0, _applicationsDefault.default));
parcelHelpers.export(exports, "Archive", ()=>(0, _archiveDefault.default));
parcelHelpers.export(exports, "AreaOfInterest", ()=>(0, _areaOfInterestDefault.default));
parcelHelpers.export(exports, "Array", ()=>(0, _arrayDefault.default));
parcelHelpers.export(exports, "ArrayBoolean", ()=>(0, _arrayBooleanDefault.default));
parcelHelpers.export(exports, "ArrayDate", ()=>(0, _arrayDateDefault.default));
parcelHelpers.export(exports, "ArrayFloatingPoint", ()=>(0, _arrayFloatingPointDefault.default));
parcelHelpers.export(exports, "ArrayNumeric", ()=>(0, _arrayNumericDefault.default));
parcelHelpers.export(exports, "ArrayString", ()=>(0, _arrayStringDefault.default));
parcelHelpers.export(exports, "ArrayTimestamp", ()=>(0, _arrayTimestampDefault.default));
parcelHelpers.export(exports, "ArrowBottomLeft", ()=>(0, _arrowBottomLeftDefault.default));
parcelHelpers.export(exports, "ArrowBottomRight", ()=>(0, _arrowBottomRightDefault.default));
parcelHelpers.export(exports, "ArrowDown", ()=>(0, _arrowDownDefault.default));
parcelHelpers.export(exports, "ArrowLeft", ()=>(0, _arrowLeftDefault.default));
parcelHelpers.export(exports, "ArrowRight", ()=>(0, _arrowRightDefault.default));
parcelHelpers.export(exports, "ArrowTopLeft", ()=>(0, _arrowTopLeftDefault.default));
parcelHelpers.export(exports, "ArrowTopRight", ()=>(0, _arrowTopRightDefault.default));
parcelHelpers.export(exports, "ArrowUp", ()=>(0, _arrowUpDefault.default));
parcelHelpers.export(exports, "ArrowsArc", ()=>(0, _arrowsArcDefault.default));
parcelHelpers.export(exports, "ArrowsHorizontal", ()=>(0, _arrowsHorizontalDefault.default));
parcelHelpers.export(exports, "ArrowsVertical", ()=>(0, _arrowsVerticalDefault.default));
parcelHelpers.export(exports, "Asterisk", ()=>(0, _asteriskDefault.default));
parcelHelpers.export(exports, "At", ()=>(0, _atDefault.default));
parcelHelpers.export(exports, "AutomaticUpdates", ()=>(0, _automaticUpdatesDefault.default));
parcelHelpers.export(exports, "Axle", ()=>(0, _axleDefault.default));
parcelHelpers.export(exports, "Backlink", ()=>(0, _backlinkDefault.default));
parcelHelpers.export(exports, "BackwardTen", ()=>(0, _backwardTenDefault.default));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeDefault.default));
parcelHelpers.export(exports, "BanCircle", ()=>(0, _banCircleDefault.default));
parcelHelpers.export(exports, "BankAccount", ()=>(0, _bankAccountDefault.default));
parcelHelpers.export(exports, "Barcode", ()=>(0, _barcodeDefault.default));
parcelHelpers.export(exports, "BinaryNumber", ()=>(0, _binaryNumberDefault.default));
parcelHelpers.export(exports, "Blank", ()=>(0, _blankDefault.default));
parcelHelpers.export(exports, "BlockPromote", ()=>(0, _blockPromoteDefault.default));
parcelHelpers.export(exports, "BlockedPerson", ()=>(0, _blockedPersonDefault.default));
parcelHelpers.export(exports, "Bold", ()=>(0, _boldDefault.default));
parcelHelpers.export(exports, "Book", ()=>(0, _bookDefault.default));
parcelHelpers.export(exports, "Bookmark", ()=>(0, _bookmarkDefault.default));
parcelHelpers.export(exports, "Box", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "Briefcase", ()=>(0, _briefcaseDefault.default));
parcelHelpers.export(exports, "BringData", ()=>(0, _bringDataDefault.default));
parcelHelpers.export(exports, "BringForward", ()=>(0, _bringForwardDefault.default));
parcelHelpers.export(exports, "BritishPound", ()=>(0, _britishPoundDefault.default));
parcelHelpers.export(exports, "Bug", ()=>(0, _bugDefault.default));
parcelHelpers.export(exports, "Buggy", ()=>(0, _buggyDefault.default));
parcelHelpers.export(exports, "Build", ()=>(0, _buildDefault.default));
parcelHelpers.export(exports, "Bullseye", ()=>(0, _bullseyeDefault.default));
parcelHelpers.export(exports, "Calculator", ()=>(0, _calculatorDefault.default));
parcelHelpers.export(exports, "Calendar", ()=>(0, _calendarDefault.default));
parcelHelpers.export(exports, "Camera", ()=>(0, _cameraDefault.default));
parcelHelpers.export(exports, "CaretDown", ()=>(0, _caretDownDefault.default));
parcelHelpers.export(exports, "CaretLeft", ()=>(0, _caretLeftDefault.default));
parcelHelpers.export(exports, "CaretRight", ()=>(0, _caretRightDefault.default));
parcelHelpers.export(exports, "CaretUp", ()=>(0, _caretUpDefault.default));
parcelHelpers.export(exports, "CargoShip", ()=>(0, _cargoShipDefault.default));
parcelHelpers.export(exports, "CellTower", ()=>(0, _cellTowerDefault.default));
parcelHelpers.export(exports, "Changes", ()=>(0, _changesDefault.default));
parcelHelpers.export(exports, "Chart", ()=>(0, _chartDefault.default));
parcelHelpers.export(exports, "Chat", ()=>(0, _chatDefault.default));
parcelHelpers.export(exports, "ChevronBackward", ()=>(0, _chevronBackwardDefault.default));
parcelHelpers.export(exports, "ChevronDown", ()=>(0, _chevronDownDefault.default));
parcelHelpers.export(exports, "ChevronForward", ()=>(0, _chevronForwardDefault.default));
parcelHelpers.export(exports, "ChevronLeft", ()=>(0, _chevronLeftDefault.default));
parcelHelpers.export(exports, "ChevronRight", ()=>(0, _chevronRightDefault.default));
parcelHelpers.export(exports, "ChevronUp", ()=>(0, _chevronUpDefault.default));
parcelHelpers.export(exports, "Circle", ()=>(0, _circleDefault.default));
parcelHelpers.export(exports, "CircleArrowDown", ()=>(0, _circleArrowDownDefault.default));
parcelHelpers.export(exports, "CircleArrowLeft", ()=>(0, _circleArrowLeftDefault.default));
parcelHelpers.export(exports, "CircleArrowRight", ()=>(0, _circleArrowRightDefault.default));
parcelHelpers.export(exports, "CircleArrowUp", ()=>(0, _circleArrowUpDefault.default));
parcelHelpers.export(exports, "Citation", ()=>(0, _citationDefault.default));
parcelHelpers.export(exports, "Clean", ()=>(0, _cleanDefault.default));
parcelHelpers.export(exports, "Clip", ()=>(0, _clipDefault.default));
parcelHelpers.export(exports, "Clipboard", ()=>(0, _clipboardDefault.default));
parcelHelpers.export(exports, "ClipboardFile", ()=>(0, _clipboardFileDefault.default));
parcelHelpers.export(exports, "Cloud", ()=>(0, _cloudDefault.default));
parcelHelpers.export(exports, "CloudDownload", ()=>(0, _cloudDownloadDefault.default));
parcelHelpers.export(exports, "CloudServer", ()=>(0, _cloudServerDefault.default));
parcelHelpers.export(exports, "CloudTick", ()=>(0, _cloudTickDefault.default));
parcelHelpers.export(exports, "CloudUpload", ()=>(0, _cloudUploadDefault.default));
parcelHelpers.export(exports, "Code", ()=>(0, _codeDefault.default));
parcelHelpers.export(exports, "CodeBlock", ()=>(0, _codeBlockDefault.default));
parcelHelpers.export(exports, "Cog", ()=>(0, _cogDefault.default));
parcelHelpers.export(exports, "CollapseAll", ()=>(0, _collapseAllDefault.default));
parcelHelpers.export(exports, "ColorFill", ()=>(0, _colorFillDefault.default));
parcelHelpers.export(exports, "ColumnLayout", ()=>(0, _columnLayoutDefault.default));
parcelHelpers.export(exports, "Comment", ()=>(0, _commentDefault.default));
parcelHelpers.export(exports, "Comparison", ()=>(0, _comparisonDefault.default));
parcelHelpers.export(exports, "Compass", ()=>(0, _compassDefault.default));
parcelHelpers.export(exports, "Compressed", ()=>(0, _compressedDefault.default));
parcelHelpers.export(exports, "Confirm", ()=>(0, _confirmDefault.default));
parcelHelpers.export(exports, "Console", ()=>(0, _consoleDefault.default));
parcelHelpers.export(exports, "Contrast", ()=>(0, _contrastDefault.default));
parcelHelpers.export(exports, "Control", ()=>(0, _controlDefault.default));
parcelHelpers.export(exports, "CreditCard", ()=>(0, _creditCardDefault.default));
parcelHelpers.export(exports, "Crop", ()=>(0, _cropDefault.default));
parcelHelpers.export(exports, "Cross", ()=>(0, _crossDefault.default));
parcelHelpers.export(exports, "CrossCircle", ()=>(0, _crossCircleDefault.default));
parcelHelpers.export(exports, "Crown", ()=>(0, _crownDefault.default));
parcelHelpers.export(exports, "CssStyle", ()=>(0, _cssStyleDefault.default));
parcelHelpers.export(exports, "Cube", ()=>(0, _cubeDefault.default));
parcelHelpers.export(exports, "CubeAdd", ()=>(0, _cubeAddDefault.default));
parcelHelpers.export(exports, "CubeEdit", ()=>(0, _cubeEditDefault.default));
parcelHelpers.export(exports, "CubeRemove", ()=>(0, _cubeRemoveDefault.default));
parcelHelpers.export(exports, "Cubes", ()=>(0, _cubesDefault.default));
parcelHelpers.export(exports, "CurlyBraces", ()=>(0, _curlyBracesDefault.default));
parcelHelpers.export(exports, "CurvedRangeChart", ()=>(0, _curvedRangeChartDefault.default));
parcelHelpers.export(exports, "Cut", ()=>(0, _cutDefault.default));
parcelHelpers.export(exports, "Cycle", ()=>(0, _cycleDefault.default));
parcelHelpers.export(exports, "Dashboard", ()=>(0, _dashboardDefault.default));
parcelHelpers.export(exports, "DataConnection", ()=>(0, _dataConnectionDefault.default));
parcelHelpers.export(exports, "DataLineage", ()=>(0, _dataLineageDefault.default));
parcelHelpers.export(exports, "DataSearch", ()=>(0, _dataSearchDefault.default));
parcelHelpers.export(exports, "DataSync", ()=>(0, _dataSyncDefault.default));
parcelHelpers.export(exports, "Database", ()=>(0, _databaseDefault.default));
parcelHelpers.export(exports, "Delete", ()=>(0, _deleteDefault.default));
parcelHelpers.export(exports, "Delta", ()=>(0, _deltaDefault.default));
parcelHelpers.export(exports, "DeriveColumn", ()=>(0, _deriveColumnDefault.default));
parcelHelpers.export(exports, "Desktop", ()=>(0, _desktopDefault.default));
parcelHelpers.export(exports, "Detection", ()=>(0, _detectionDefault.default));
parcelHelpers.export(exports, "Diagnosis", ()=>(0, _diagnosisDefault.default));
parcelHelpers.export(exports, "DiagramTree", ()=>(0, _diagramTreeDefault.default));
parcelHelpers.export(exports, "DirectionLeft", ()=>(0, _directionLeftDefault.default));
parcelHelpers.export(exports, "DirectionRight", ()=>(0, _directionRightDefault.default));
parcelHelpers.export(exports, "Disable", ()=>(0, _disableDefault.default));
parcelHelpers.export(exports, "Divide", ()=>(0, _divideDefault.default));
parcelHelpers.export(exports, "Document", ()=>(0, _documentDefault.default));
parcelHelpers.export(exports, "DocumentOpen", ()=>(0, _documentOpenDefault.default));
parcelHelpers.export(exports, "DocumentShare", ()=>(0, _documentShareDefault.default));
parcelHelpers.export(exports, "Dollar", ()=>(0, _dollarDefault.default));
parcelHelpers.export(exports, "Dot", ()=>(0, _dotDefault.default));
parcelHelpers.export(exports, "DoubleCaretHorizontal", ()=>(0, _doubleCaretHorizontalDefault.default));
parcelHelpers.export(exports, "DoubleCaretVertical", ()=>(0, _doubleCaretVerticalDefault.default));
parcelHelpers.export(exports, "DoubleChevronDown", ()=>(0, _doubleChevronDownDefault.default));
parcelHelpers.export(exports, "DoubleChevronLeft", ()=>(0, _doubleChevronLeftDefault.default));
parcelHelpers.export(exports, "DoubleChevronRight", ()=>(0, _doubleChevronRightDefault.default));
parcelHelpers.export(exports, "DoubleChevronUp", ()=>(0, _doubleChevronUpDefault.default));
parcelHelpers.export(exports, "DoughnutChart", ()=>(0, _doughnutChartDefault.default));
parcelHelpers.export(exports, "Download", ()=>(0, _downloadDefault.default));
parcelHelpers.export(exports, "DragHandleHorizontal", ()=>(0, _dragHandleHorizontalDefault.default));
parcelHelpers.export(exports, "DragHandleVertical", ()=>(0, _dragHandleVerticalDefault.default));
parcelHelpers.export(exports, "Draw", ()=>(0, _drawDefault.default));
parcelHelpers.export(exports, "DrawerLeft", ()=>(0, _drawerLeftDefault.default));
parcelHelpers.export(exports, "DrawerLeftFilled", ()=>(0, _drawerLeftFilledDefault.default));
parcelHelpers.export(exports, "DrawerRight", ()=>(0, _drawerRightDefault.default));
parcelHelpers.export(exports, "DrawerRightFilled", ()=>(0, _drawerRightFilledDefault.default));
parcelHelpers.export(exports, "DriveTime", ()=>(0, _driveTimeDefault.default));
parcelHelpers.export(exports, "Duplicate", ()=>(0, _duplicateDefault.default));
parcelHelpers.export(exports, "Edit", ()=>(0, _editDefault.default));
parcelHelpers.export(exports, "Eject", ()=>(0, _ejectDefault.default));
parcelHelpers.export(exports, "Emoji", ()=>(0, _emojiDefault.default));
parcelHelpers.export(exports, "Endnote", ()=>(0, _endnoteDefault.default));
parcelHelpers.export(exports, "Endorsed", ()=>(0, _endorsedDefault.default));
parcelHelpers.export(exports, "Envelope", ()=>(0, _envelopeDefault.default));
parcelHelpers.export(exports, "Equals", ()=>(0, _equalsDefault.default));
parcelHelpers.export(exports, "Eraser", ()=>(0, _eraserDefault.default));
parcelHelpers.export(exports, "Error", ()=>(0, _errorDefault.default));
parcelHelpers.export(exports, "Euro", ()=>(0, _euroDefault.default));
parcelHelpers.export(exports, "Excavator", ()=>(0, _excavatorDefault.default));
parcelHelpers.export(exports, "Exchange", ()=>(0, _exchangeDefault.default));
parcelHelpers.export(exports, "ExcludeRow", ()=>(0, _excludeRowDefault.default));
parcelHelpers.export(exports, "ExpandAll", ()=>(0, _expandAllDefault.default));
parcelHelpers.export(exports, "Explain", ()=>(0, _explainDefault.default));
parcelHelpers.export(exports, "Export", ()=>(0, _exportDefault.default));
parcelHelpers.export(exports, "EyeOff", ()=>(0, _eyeOffDefault.default));
parcelHelpers.export(exports, "EyeOn", ()=>(0, _eyeOnDefault.default));
parcelHelpers.export(exports, "EyeOpen", ()=>(0, _eyeOpenDefault.default));
parcelHelpers.export(exports, "FastBackward", ()=>(0, _fastBackwardDefault.default));
parcelHelpers.export(exports, "FastForward", ()=>(0, _fastForwardDefault.default));
parcelHelpers.export(exports, "Feed", ()=>(0, _feedDefault.default));
parcelHelpers.export(exports, "FeedSubscribed", ()=>(0, _feedSubscribedDefault.default));
parcelHelpers.export(exports, "FighterJet", ()=>(0, _fighterJetDefault.default));
parcelHelpers.export(exports, "Film", ()=>(0, _filmDefault.default));
parcelHelpers.export(exports, "Filter", ()=>(0, _filterDefault.default));
parcelHelpers.export(exports, "FilterKeep", ()=>(0, _filterKeepDefault.default));
parcelHelpers.export(exports, "FilterList", ()=>(0, _filterListDefault.default));
parcelHelpers.export(exports, "FilterOpen", ()=>(0, _filterOpenDefault.default));
parcelHelpers.export(exports, "FilterRemove", ()=>(0, _filterRemoveDefault.default));
parcelHelpers.export(exports, "FilterSortAsc", ()=>(0, _filterSortAscDefault.default));
parcelHelpers.export(exports, "FilterSortDesc", ()=>(0, _filterSortDescDefault.default));
parcelHelpers.export(exports, "Flag", ()=>(0, _flagDefault.default));
parcelHelpers.export(exports, "Flame", ()=>(0, _flameDefault.default));
parcelHelpers.export(exports, "Flash", ()=>(0, _flashDefault.default));
parcelHelpers.export(exports, "FloatingPoint", ()=>(0, _floatingPointDefault.default));
parcelHelpers.export(exports, "FloppyDisk", ()=>(0, _floppyDiskDefault.default));
parcelHelpers.export(exports, "FlowBranch", ()=>(0, _flowBranchDefault.default));
parcelHelpers.export(exports, "FlowEnd", ()=>(0, _flowEndDefault.default));
parcelHelpers.export(exports, "FlowLinear", ()=>(0, _flowLinearDefault.default));
parcelHelpers.export(exports, "FlowReview", ()=>(0, _flowReviewDefault.default));
parcelHelpers.export(exports, "FlowReviewBranch", ()=>(0, _flowReviewBranchDefault.default));
parcelHelpers.export(exports, "Flows", ()=>(0, _flowsDefault.default));
parcelHelpers.export(exports, "FolderClose", ()=>(0, _folderCloseDefault.default));
parcelHelpers.export(exports, "FolderNew", ()=>(0, _folderNewDefault.default));
parcelHelpers.export(exports, "FolderOpen", ()=>(0, _folderOpenDefault.default));
parcelHelpers.export(exports, "FolderShared", ()=>(0, _folderSharedDefault.default));
parcelHelpers.export(exports, "FolderSharedOpen", ()=>(0, _folderSharedOpenDefault.default));
parcelHelpers.export(exports, "Follower", ()=>(0, _followerDefault.default));
parcelHelpers.export(exports, "Following", ()=>(0, _followingDefault.default));
parcelHelpers.export(exports, "Font", ()=>(0, _fontDefault.default));
parcelHelpers.export(exports, "Fork", ()=>(0, _forkDefault.default));
parcelHelpers.export(exports, "Form", ()=>(0, _formDefault.default));
parcelHelpers.export(exports, "ForwardTen", ()=>(0, _forwardTenDefault.default));
parcelHelpers.export(exports, "Fuel", ()=>(0, _fuelDefault.default));
parcelHelpers.export(exports, "FullCircle", ()=>(0, _fullCircleDefault.default));
parcelHelpers.export(exports, "FullStackedChart", ()=>(0, _fullStackedChartDefault.default));
parcelHelpers.export(exports, "Fullscreen", ()=>(0, _fullscreenDefault.default));
parcelHelpers.export(exports, "Function", ()=>(0, _functionDefault.default));
parcelHelpers.export(exports, "GanttChart", ()=>(0, _ganttChartDefault.default));
parcelHelpers.export(exports, "Generate", ()=>(0, _generateDefault.default));
parcelHelpers.export(exports, "Geofence", ()=>(0, _geofenceDefault.default));
parcelHelpers.export(exports, "Geolocation", ()=>(0, _geolocationDefault.default));
parcelHelpers.export(exports, "Geosearch", ()=>(0, _geosearchDefault.default));
parcelHelpers.export(exports, "Geotime", ()=>(0, _geotimeDefault.default));
parcelHelpers.export(exports, "GitBranch", ()=>(0, _gitBranchDefault.default));
parcelHelpers.export(exports, "GitCommit", ()=>(0, _gitCommitDefault.default));
parcelHelpers.export(exports, "GitMerge", ()=>(0, _gitMergeDefault.default));
parcelHelpers.export(exports, "GitNewBranch", ()=>(0, _gitNewBranchDefault.default));
parcelHelpers.export(exports, "GitPull", ()=>(0, _gitPullDefault.default));
parcelHelpers.export(exports, "GitPush", ()=>(0, _gitPushDefault.default));
parcelHelpers.export(exports, "GitRepo", ()=>(0, _gitRepoDefault.default));
parcelHelpers.export(exports, "Glass", ()=>(0, _glassDefault.default));
parcelHelpers.export(exports, "Globe", ()=>(0, _globeDefault.default));
parcelHelpers.export(exports, "GlobeNetwork", ()=>(0, _globeNetworkDefault.default));
parcelHelpers.export(exports, "GlobeNetworkAdd", ()=>(0, _globeNetworkAddDefault.default));
parcelHelpers.export(exports, "Graph", ()=>(0, _graphDefault.default));
parcelHelpers.export(exports, "GraphRemove", ()=>(0, _graphRemoveDefault.default));
parcelHelpers.export(exports, "GreaterThan", ()=>(0, _greaterThanDefault.default));
parcelHelpers.export(exports, "GreaterThanOrEqualTo", ()=>(0, _greaterThanOrEqualToDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "GridView", ()=>(0, _gridViewDefault.default));
parcelHelpers.export(exports, "GroupItem", ()=>(0, _groupItemDefault.default));
parcelHelpers.export(exports, "GroupObjects", ()=>(0, _groupObjectsDefault.default));
parcelHelpers.export(exports, "GroupedBarChart", ()=>(0, _groupedBarChartDefault.default));
parcelHelpers.export(exports, "Hand", ()=>(0, _handDefault.default));
parcelHelpers.export(exports, "HandDown", ()=>(0, _handDownDefault.default));
parcelHelpers.export(exports, "HandLeft", ()=>(0, _handLeftDefault.default));
parcelHelpers.export(exports, "HandRight", ()=>(0, _handRightDefault.default));
parcelHelpers.export(exports, "HandUp", ()=>(0, _handUpDefault.default));
parcelHelpers.export(exports, "Hat", ()=>(0, _hatDefault.default));
parcelHelpers.export(exports, "Header", ()=>(0, _headerDefault.default));
parcelHelpers.export(exports, "HeaderOne", ()=>(0, _headerOneDefault.default));
parcelHelpers.export(exports, "HeaderThree", ()=>(0, _headerThreeDefault.default));
parcelHelpers.export(exports, "HeaderTwo", ()=>(0, _headerTwoDefault.default));
parcelHelpers.export(exports, "Headset", ()=>(0, _headsetDefault.default));
parcelHelpers.export(exports, "Heart", ()=>(0, _heartDefault.default));
parcelHelpers.export(exports, "HeartBroken", ()=>(0, _heartBrokenDefault.default));
parcelHelpers.export(exports, "HeatGrid", ()=>(0, _heatGridDefault.default));
parcelHelpers.export(exports, "Heatmap", ()=>(0, _heatmapDefault.default));
parcelHelpers.export(exports, "Helicopter", ()=>(0, _helicopterDefault.default));
parcelHelpers.export(exports, "Help", ()=>(0, _helpDefault.default));
parcelHelpers.export(exports, "HelperManagement", ()=>(0, _helperManagementDefault.default));
parcelHelpers.export(exports, "Hexagon", ()=>(0, _hexagonDefault.default));
parcelHelpers.export(exports, "HighPriority", ()=>(0, _highPriorityDefault.default));
parcelHelpers.export(exports, "HighVoltagePole", ()=>(0, _highVoltagePoleDefault.default));
parcelHelpers.export(exports, "Highlight", ()=>(0, _highlightDefault.default));
parcelHelpers.export(exports, "History", ()=>(0, _historyDefault.default));
parcelHelpers.export(exports, "Home", ()=>(0, _homeDefault.default));
parcelHelpers.export(exports, "HorizontalBarChart", ()=>(0, _horizontalBarChartDefault.default));
parcelHelpers.export(exports, "HorizontalBarChartAsc", ()=>(0, _horizontalBarChartAscDefault.default));
parcelHelpers.export(exports, "HorizontalBarChartDesc", ()=>(0, _horizontalBarChartDescDefault.default));
parcelHelpers.export(exports, "HorizontalDistribution", ()=>(0, _horizontalDistributionDefault.default));
parcelHelpers.export(exports, "HorizontalInbetween", ()=>(0, _horizontalInbetweenDefault.default));
parcelHelpers.export(exports, "Hurricane", ()=>(0, _hurricaneDefault.default));
parcelHelpers.export(exports, "IdNumber", ()=>(0, _idNumberDefault.default));
parcelHelpers.export(exports, "ImageRotateLeft", ()=>(0, _imageRotateLeftDefault.default));
parcelHelpers.export(exports, "ImageRotateRight", ()=>(0, _imageRotateRightDefault.default));
parcelHelpers.export(exports, "Import", ()=>(0, _importDefault.default));
parcelHelpers.export(exports, "Inbox", ()=>(0, _inboxDefault.default));
parcelHelpers.export(exports, "InboxFiltered", ()=>(0, _inboxFilteredDefault.default));
parcelHelpers.export(exports, "InboxGeo", ()=>(0, _inboxGeoDefault.default));
parcelHelpers.export(exports, "InboxSearch", ()=>(0, _inboxSearchDefault.default));
parcelHelpers.export(exports, "InboxUpdate", ()=>(0, _inboxUpdateDefault.default));
parcelHelpers.export(exports, "InfoSign", ()=>(0, _infoSignDefault.default));
parcelHelpers.export(exports, "Inheritance", ()=>(0, _inheritanceDefault.default));
parcelHelpers.export(exports, "InheritedGroup", ()=>(0, _inheritedGroupDefault.default));
parcelHelpers.export(exports, "InnerJoin", ()=>(0, _innerJoinDefault.default));
parcelHelpers.export(exports, "Input", ()=>(0, _inputDefault.default));
parcelHelpers.export(exports, "Insert", ()=>(0, _insertDefault.default));
parcelHelpers.export(exports, "Intelligence", ()=>(0, _intelligenceDefault.default));
parcelHelpers.export(exports, "Intersection", ()=>(0, _intersectionDefault.default));
parcelHelpers.export(exports, "IpAddress", ()=>(0, _ipAddressDefault.default));
parcelHelpers.export(exports, "Issue", ()=>(0, _issueDefault.default));
parcelHelpers.export(exports, "IssueClosed", ()=>(0, _issueClosedDefault.default));
parcelHelpers.export(exports, "IssueNew", ()=>(0, _issueNewDefault.default));
parcelHelpers.export(exports, "Italic", ()=>(0, _italicDefault.default));
parcelHelpers.export(exports, "JoinTable", ()=>(0, _joinTableDefault.default));
parcelHelpers.export(exports, "Key", ()=>(0, _keyDefault.default));
parcelHelpers.export(exports, "KeyBackspace", ()=>(0, _keyBackspaceDefault.default));
parcelHelpers.export(exports, "KeyCommand", ()=>(0, _keyCommandDefault.default));
parcelHelpers.export(exports, "KeyControl", ()=>(0, _keyControlDefault.default));
parcelHelpers.export(exports, "KeyDelete", ()=>(0, _keyDeleteDefault.default));
parcelHelpers.export(exports, "KeyEnter", ()=>(0, _keyEnterDefault.default));
parcelHelpers.export(exports, "KeyEscape", ()=>(0, _keyEscapeDefault.default));
parcelHelpers.export(exports, "KeyOption", ()=>(0, _keyOptionDefault.default));
parcelHelpers.export(exports, "KeyShift", ()=>(0, _keyShiftDefault.default));
parcelHelpers.export(exports, "KeyTab", ()=>(0, _keyTabDefault.default));
parcelHelpers.export(exports, "KnownVehicle", ()=>(0, _knownVehicleDefault.default));
parcelHelpers.export(exports, "LabTest", ()=>(0, _labTestDefault.default));
parcelHelpers.export(exports, "Label", ()=>(0, _labelDefault.default));
parcelHelpers.export(exports, "Layer", ()=>(0, _layerDefault.default));
parcelHelpers.export(exports, "LayerOutline", ()=>(0, _layerOutlineDefault.default));
parcelHelpers.export(exports, "Layers", ()=>(0, _layersDefault.default));
parcelHelpers.export(exports, "Layout", ()=>(0, _layoutDefault.default));
parcelHelpers.export(exports, "LayoutAuto", ()=>(0, _layoutAutoDefault.default));
parcelHelpers.export(exports, "LayoutBalloon", ()=>(0, _layoutBalloonDefault.default));
parcelHelpers.export(exports, "LayoutBottomRowThreeTiles", ()=>(0, _layoutBottomRowThreeTilesDefault.default));
parcelHelpers.export(exports, "LayoutBottomRowTwoTiles", ()=>(0, _layoutBottomRowTwoTilesDefault.default));
parcelHelpers.export(exports, "LayoutCircle", ()=>(0, _layoutCircleDefault.default));
parcelHelpers.export(exports, "LayoutGrid", ()=>(0, _layoutGridDefault.default));
parcelHelpers.export(exports, "LayoutGroupBy", ()=>(0, _layoutGroupByDefault.default));
parcelHelpers.export(exports, "LayoutHierarchy", ()=>(0, _layoutHierarchyDefault.default));
parcelHelpers.export(exports, "LayoutLeftColumnThreeTiles", ()=>(0, _layoutLeftColumnThreeTilesDefault.default));
parcelHelpers.export(exports, "LayoutLeftColumnTwoTiles", ()=>(0, _layoutLeftColumnTwoTilesDefault.default));
parcelHelpers.export(exports, "LayoutLinear", ()=>(0, _layoutLinearDefault.default));
parcelHelpers.export(exports, "LayoutRightColumnThreeTiles", ()=>(0, _layoutRightColumnThreeTilesDefault.default));
parcelHelpers.export(exports, "LayoutRightColumnTwoTiles", ()=>(0, _layoutRightColumnTwoTilesDefault.default));
parcelHelpers.export(exports, "LayoutSkewGrid", ()=>(0, _layoutSkewGridDefault.default));
parcelHelpers.export(exports, "LayoutSortedClusters", ()=>(0, _layoutSortedClustersDefault.default));
parcelHelpers.export(exports, "LayoutThreeColumns", ()=>(0, _layoutThreeColumnsDefault.default));
parcelHelpers.export(exports, "LayoutThreeRows", ()=>(0, _layoutThreeRowsDefault.default));
parcelHelpers.export(exports, "LayoutTopRowThreeTiles", ()=>(0, _layoutTopRowThreeTilesDefault.default));
parcelHelpers.export(exports, "LayoutTopRowTwoTiles", ()=>(0, _layoutTopRowTwoTilesDefault.default));
parcelHelpers.export(exports, "LayoutTwoColumns", ()=>(0, _layoutTwoColumnsDefault.default));
parcelHelpers.export(exports, "LayoutTwoRows", ()=>(0, _layoutTwoRowsDefault.default));
parcelHelpers.export(exports, "Learning", ()=>(0, _learningDefault.default));
parcelHelpers.export(exports, "LeftJoin", ()=>(0, _leftJoinDefault.default));
parcelHelpers.export(exports, "LengthenText", ()=>(0, _lengthenTextDefault.default));
parcelHelpers.export(exports, "LessThan", ()=>(0, _lessThanDefault.default));
parcelHelpers.export(exports, "LessThanOrEqualTo", ()=>(0, _lessThanOrEqualToDefault.default));
parcelHelpers.export(exports, "Lifesaver", ()=>(0, _lifesaverDefault.default));
parcelHelpers.export(exports, "Lightbulb", ()=>(0, _lightbulbDefault.default));
parcelHelpers.export(exports, "Lightning", ()=>(0, _lightningDefault.default));
parcelHelpers.export(exports, "Link", ()=>(0, _linkDefault.default));
parcelHelpers.export(exports, "LinkedSquares", ()=>(0, _linkedSquaresDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "ListColumns", ()=>(0, _listColumnsDefault.default));
parcelHelpers.export(exports, "ListDetailView", ()=>(0, _listDetailViewDefault.default));
parcelHelpers.export(exports, "Locate", ()=>(0, _locateDefault.default));
parcelHelpers.export(exports, "Lock", ()=>(0, _lockDefault.default));
parcelHelpers.export(exports, "Locomotive", ()=>(0, _locomotiveDefault.default));
parcelHelpers.export(exports, "LogIn", ()=>(0, _logInDefault.default));
parcelHelpers.export(exports, "LogOut", ()=>(0, _logOutDefault.default));
parcelHelpers.export(exports, "LowVoltagePole", ()=>(0, _lowVoltagePoleDefault.default));
parcelHelpers.export(exports, "Manual", ()=>(0, _manualDefault.default));
parcelHelpers.export(exports, "ManuallyEnteredData", ()=>(0, _manuallyEnteredDataDefault.default));
parcelHelpers.export(exports, "ManyToMany", ()=>(0, _manyToManyDefault.default));
parcelHelpers.export(exports, "ManyToOne", ()=>(0, _manyToOneDefault.default));
parcelHelpers.export(exports, "Map", ()=>(0, _mapDefault.default));
parcelHelpers.export(exports, "MapCreate", ()=>(0, _mapCreateDefault.default));
parcelHelpers.export(exports, "MapMarker", ()=>(0, _mapMarkerDefault.default));
parcelHelpers.export(exports, "Maximize", ()=>(0, _maximizeDefault.default));
parcelHelpers.export(exports, "Media", ()=>(0, _mediaDefault.default));
parcelHelpers.export(exports, "Menu", ()=>(0, _menuDefault.default));
parcelHelpers.export(exports, "MenuClosed", ()=>(0, _menuClosedDefault.default));
parcelHelpers.export(exports, "MenuOpen", ()=>(0, _menuOpenDefault.default));
parcelHelpers.export(exports, "MergeColumns", ()=>(0, _mergeColumnsDefault.default));
parcelHelpers.export(exports, "MergeLinks", ()=>(0, _mergeLinksDefault.default));
parcelHelpers.export(exports, "Microphone", ()=>(0, _microphoneDefault.default));
parcelHelpers.export(exports, "Minimize", ()=>(0, _minimizeDefault.default));
parcelHelpers.export(exports, "Minus", ()=>(0, _minusDefault.default));
parcelHelpers.export(exports, "MobilePhone", ()=>(0, _mobilePhoneDefault.default));
parcelHelpers.export(exports, "MobileVideo", ()=>(0, _mobileVideoDefault.default));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "ModalFilled", ()=>(0, _modalFilledDefault.default));
parcelHelpers.export(exports, "Model", ()=>(0, _modelDefault.default));
parcelHelpers.export(exports, "Moon", ()=>(0, _moonDefault.default));
parcelHelpers.export(exports, "More", ()=>(0, _moreDefault.default));
parcelHelpers.export(exports, "Mountain", ()=>(0, _mountainDefault.default));
parcelHelpers.export(exports, "Move", ()=>(0, _moveDefault.default));
parcelHelpers.export(exports, "Mugshot", ()=>(0, _mugshotDefault.default));
parcelHelpers.export(exports, "MultiSelect", ()=>(0, _multiSelectDefault.default));
parcelHelpers.export(exports, "Music", ()=>(0, _musicDefault.default));
parcelHelpers.export(exports, "Nest", ()=>(0, _nestDefault.default));
parcelHelpers.export(exports, "NewDrawing", ()=>(0, _newDrawingDefault.default));
parcelHelpers.export(exports, "NewGridItem", ()=>(0, _newGridItemDefault.default));
parcelHelpers.export(exports, "NewLayer", ()=>(0, _newLayerDefault.default));
parcelHelpers.export(exports, "NewLayers", ()=>(0, _newLayersDefault.default));
parcelHelpers.export(exports, "NewLink", ()=>(0, _newLinkDefault.default));
parcelHelpers.export(exports, "NewObject", ()=>(0, _newObjectDefault.default));
parcelHelpers.export(exports, "NewPerson", ()=>(0, _newPersonDefault.default));
parcelHelpers.export(exports, "NewPrescription", ()=>(0, _newPrescriptionDefault.default));
parcelHelpers.export(exports, "NewShield", ()=>(0, _newShieldDefault.default));
parcelHelpers.export(exports, "NewTextBox", ()=>(0, _newTextBoxDefault.default));
parcelHelpers.export(exports, "Ninja", ()=>(0, _ninjaDefault.default));
parcelHelpers.export(exports, "NotEqualTo", ()=>(0, _notEqualToDefault.default));
parcelHelpers.export(exports, "Notifications", ()=>(0, _notificationsDefault.default));
parcelHelpers.export(exports, "NotificationsSnooze", ()=>(0, _notificationsSnoozeDefault.default));
parcelHelpers.export(exports, "NotificationsUpdated", ()=>(0, _notificationsUpdatedDefault.default));
parcelHelpers.export(exports, "NumberedList", ()=>(0, _numberedListDefault.default));
parcelHelpers.export(exports, "Numerical", ()=>(0, _numericalDefault.default));
parcelHelpers.export(exports, "ObjectView", ()=>(0, _objectViewDefault.default));
parcelHelpers.export(exports, "Office", ()=>(0, _officeDefault.default));
parcelHelpers.export(exports, "Offline", ()=>(0, _offlineDefault.default));
parcelHelpers.export(exports, "OilField", ()=>(0, _oilFieldDefault.default));
parcelHelpers.export(exports, "OneColumn", ()=>(0, _oneColumnDefault.default));
parcelHelpers.export(exports, "OneToMany", ()=>(0, _oneToManyDefault.default));
parcelHelpers.export(exports, "OneToOne", ()=>(0, _oneToOneDefault.default));
parcelHelpers.export(exports, "OpenApplication", ()=>(0, _openApplicationDefault.default));
parcelHelpers.export(exports, "Outdated", ()=>(0, _outdatedDefault.default));
parcelHelpers.export(exports, "Output", ()=>(0, _outputDefault.default));
parcelHelpers.export(exports, "Package", ()=>(0, _packageDefault.default));
parcelHelpers.export(exports, "PageLayout", ()=>(0, _pageLayoutDefault.default));
parcelHelpers.export(exports, "Panel", ()=>(0, _panelDefault.default));
parcelHelpers.export(exports, "PanelStats", ()=>(0, _panelStatsDefault.default));
parcelHelpers.export(exports, "PanelTable", ()=>(0, _panelTableDefault.default));
parcelHelpers.export(exports, "Paperclip", ()=>(0, _paperclipDefault.default));
parcelHelpers.export(exports, "Paragraph", ()=>(0, _paragraphDefault.default));
parcelHelpers.export(exports, "PasteVariable", ()=>(0, _pasteVariableDefault.default));
parcelHelpers.export(exports, "Path", ()=>(0, _pathDefault.default));
parcelHelpers.export(exports, "PathSearch", ()=>(0, _pathSearchDefault.default));
parcelHelpers.export(exports, "Pause", ()=>(0, _pauseDefault.default));
parcelHelpers.export(exports, "People", ()=>(0, _peopleDefault.default));
parcelHelpers.export(exports, "Percentage", ()=>(0, _percentageDefault.default));
parcelHelpers.export(exports, "Person", ()=>(0, _personDefault.default));
parcelHelpers.export(exports, "Phone", ()=>(0, _phoneDefault.default));
parcelHelpers.export(exports, "PhoneCall", ()=>(0, _phoneCallDefault.default));
parcelHelpers.export(exports, "PhoneForward", ()=>(0, _phoneForwardDefault.default));
parcelHelpers.export(exports, "PieChart", ()=>(0, _pieChartDefault.default));
parcelHelpers.export(exports, "Pill", ()=>(0, _pillDefault.default));
parcelHelpers.export(exports, "Pin", ()=>(0, _pinDefault.default));
parcelHelpers.export(exports, "Pivot", ()=>(0, _pivotDefault.default));
parcelHelpers.export(exports, "PivotTable", ()=>(0, _pivotTableDefault.default));
parcelHelpers.export(exports, "Play", ()=>(0, _playDefault.default));
parcelHelpers.export(exports, "Playbook", ()=>(0, _playbookDefault.default));
parcelHelpers.export(exports, "Plus", ()=>(0, _plusDefault.default));
parcelHelpers.export(exports, "PolygonFilter", ()=>(0, _polygonFilterDefault.default));
parcelHelpers.export(exports, "Power", ()=>(0, _powerDefault.default));
parcelHelpers.export(exports, "PredictiveAnalysis", ()=>(0, _predictiveAnalysisDefault.default));
parcelHelpers.export(exports, "Prescription", ()=>(0, _prescriptionDefault.default));
parcelHelpers.export(exports, "Presentation", ()=>(0, _presentationDefault.default));
parcelHelpers.export(exports, "Print", ()=>(0, _printDefault.default));
parcelHelpers.export(exports, "Projects", ()=>(0, _projectsDefault.default));
parcelHelpers.export(exports, "Properties", ()=>(0, _propertiesDefault.default));
parcelHelpers.export(exports, "Property", ()=>(0, _propertyDefault.default));
parcelHelpers.export(exports, "PublishFunction", ()=>(0, _publishFunctionDefault.default));
parcelHelpers.export(exports, "Pulse", ()=>(0, _pulseDefault.default));
parcelHelpers.export(exports, "Rain", ()=>(0, _rainDefault.default));
parcelHelpers.export(exports, "Random", ()=>(0, _randomDefault.default));
parcelHelpers.export(exports, "RangeRing", ()=>(0, _rangeRingDefault.default));
parcelHelpers.export(exports, "Record", ()=>(0, _recordDefault.default));
parcelHelpers.export(exports, "RectHeight", ()=>(0, _rectHeightDefault.default));
parcelHelpers.export(exports, "RectWidth", ()=>(0, _rectWidthDefault.default));
parcelHelpers.export(exports, "Rectangle", ()=>(0, _rectangleDefault.default));
parcelHelpers.export(exports, "Redo", ()=>(0, _redoDefault.default));
parcelHelpers.export(exports, "Refresh", ()=>(0, _refreshDefault.default));
parcelHelpers.export(exports, "Regex", ()=>(0, _regexDefault.default));
parcelHelpers.export(exports, "RegressionChart", ()=>(0, _regressionChartDefault.default));
parcelHelpers.export(exports, "Remove", ()=>(0, _removeDefault.default));
parcelHelpers.export(exports, "RemoveColumn", ()=>(0, _removeColumnDefault.default));
parcelHelpers.export(exports, "RemoveColumnLeft", ()=>(0, _removeColumnLeftDefault.default));
parcelHelpers.export(exports, "RemoveColumnRight", ()=>(0, _removeColumnRightDefault.default));
parcelHelpers.export(exports, "RemoveRowBottom", ()=>(0, _removeRowBottomDefault.default));
parcelHelpers.export(exports, "RemoveRowTop", ()=>(0, _removeRowTopDefault.default));
parcelHelpers.export(exports, "Repeat", ()=>(0, _repeatDefault.default));
parcelHelpers.export(exports, "Reset", ()=>(0, _resetDefault.default));
parcelHelpers.export(exports, "Resolve", ()=>(0, _resolveDefault.default));
parcelHelpers.export(exports, "Rig", ()=>(0, _rigDefault.default));
parcelHelpers.export(exports, "RightJoin", ()=>(0, _rightJoinDefault.default));
parcelHelpers.export(exports, "Ring", ()=>(0, _ringDefault.default));
parcelHelpers.export(exports, "Rocket", ()=>(0, _rocketDefault.default));
parcelHelpers.export(exports, "RocketSlant", ()=>(0, _rocketSlantDefault.default));
parcelHelpers.export(exports, "RotateCcw", ()=>(0, _rotateCcwDefault.default));
parcelHelpers.export(exports, "RotateCw", ()=>(0, _rotateCwDefault.default));
parcelHelpers.export(exports, "RotateDocument", ()=>(0, _rotateDocumentDefault.default));
parcelHelpers.export(exports, "RotatePage", ()=>(0, _rotatePageDefault.default));
parcelHelpers.export(exports, "Route", ()=>(0, _routeDefault.default));
parcelHelpers.export(exports, "Satellite", ()=>(0, _satelliteDefault.default));
parcelHelpers.export(exports, "Saved", ()=>(0, _savedDefault.default));
parcelHelpers.export(exports, "ScatterPlot", ()=>(0, _scatterPlotDefault.default));
parcelHelpers.export(exports, "Search", ()=>(0, _searchDefault.default));
parcelHelpers.export(exports, "SearchAround", ()=>(0, _searchAroundDefault.default));
parcelHelpers.export(exports, "SearchTemplate", ()=>(0, _searchTemplateDefault.default));
parcelHelpers.export(exports, "SearchText", ()=>(0, _searchTextDefault.default));
parcelHelpers.export(exports, "SegmentedControl", ()=>(0, _segmentedControlDefault.default));
parcelHelpers.export(exports, "Select", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "Selection", ()=>(0, _selectionDefault.default));
parcelHelpers.export(exports, "SendBackward", ()=>(0, _sendBackwardDefault.default));
parcelHelpers.export(exports, "SendMessage", ()=>(0, _sendMessageDefault.default));
parcelHelpers.export(exports, "SendTo", ()=>(0, _sendToDefault.default));
parcelHelpers.export(exports, "SendToGraph", ()=>(0, _sendToGraphDefault.default));
parcelHelpers.export(exports, "SendToMap", ()=>(0, _sendToMapDefault.default));
parcelHelpers.export(exports, "Sensor", ()=>(0, _sensorDefault.default));
parcelHelpers.export(exports, "SeriesAdd", ()=>(0, _seriesAddDefault.default));
parcelHelpers.export(exports, "SeriesConfiguration", ()=>(0, _seriesConfigurationDefault.default));
parcelHelpers.export(exports, "SeriesDerived", ()=>(0, _seriesDerivedDefault.default));
parcelHelpers.export(exports, "SeriesFiltered", ()=>(0, _seriesFilteredDefault.default));
parcelHelpers.export(exports, "SeriesSearch", ()=>(0, _seriesSearchDefault.default));
parcelHelpers.export(exports, "Server", ()=>(0, _serverDefault.default));
parcelHelpers.export(exports, "ServerInstall", ()=>(0, _serverInstallDefault.default));
parcelHelpers.export(exports, "Settings", ()=>(0, _settingsDefault.default));
parcelHelpers.export(exports, "Shapes", ()=>(0, _shapesDefault.default));
parcelHelpers.export(exports, "Share", ()=>(0, _shareDefault.default));
parcelHelpers.export(exports, "SharedFilter", ()=>(0, _sharedFilterDefault.default));
parcelHelpers.export(exports, "Shield", ()=>(0, _shieldDefault.default));
parcelHelpers.export(exports, "Ship", ()=>(0, _shipDefault.default));
parcelHelpers.export(exports, "Shop", ()=>(0, _shopDefault.default));
parcelHelpers.export(exports, "ShoppingCart", ()=>(0, _shoppingCartDefault.default));
parcelHelpers.export(exports, "ShortenText", ()=>(0, _shortenTextDefault.default));
parcelHelpers.export(exports, "SignalSearch", ()=>(0, _signalSearchDefault.default));
parcelHelpers.export(exports, "SimCard", ()=>(0, _simCardDefault.default));
parcelHelpers.export(exports, "Slash", ()=>(0, _slashDefault.default));
parcelHelpers.export(exports, "SmallCross", ()=>(0, _smallCrossDefault.default));
parcelHelpers.export(exports, "SmallInfoSign", ()=>(0, _smallInfoSignDefault.default));
parcelHelpers.export(exports, "SmallMinus", ()=>(0, _smallMinusDefault.default));
parcelHelpers.export(exports, "SmallPlus", ()=>(0, _smallPlusDefault.default));
parcelHelpers.export(exports, "SmallSquare", ()=>(0, _smallSquareDefault.default));
parcelHelpers.export(exports, "SmallTick", ()=>(0, _smallTickDefault.default));
parcelHelpers.export(exports, "Snowflake", ()=>(0, _snowflakeDefault.default));
parcelHelpers.export(exports, "SoccerBall", ()=>(0, _soccerBallDefault.default));
parcelHelpers.export(exports, "SocialMedia", ()=>(0, _socialMediaDefault.default));
parcelHelpers.export(exports, "Sort", ()=>(0, _sortDefault.default));
parcelHelpers.export(exports, "SortAlphabetical", ()=>(0, _sortAlphabeticalDefault.default));
parcelHelpers.export(exports, "SortAlphabeticalDesc", ()=>(0, _sortAlphabeticalDescDefault.default));
parcelHelpers.export(exports, "SortAsc", ()=>(0, _sortAscDefault.default));
parcelHelpers.export(exports, "SortDesc", ()=>(0, _sortDescDefault.default));
parcelHelpers.export(exports, "SortNumerical", ()=>(0, _sortNumericalDefault.default));
parcelHelpers.export(exports, "SortNumericalDesc", ()=>(0, _sortNumericalDescDefault.default));
parcelHelpers.export(exports, "SpellCheck", ()=>(0, _spellCheckDefault.default));
parcelHelpers.export(exports, "SplitColumns", ()=>(0, _splitColumnsDefault.default));
parcelHelpers.export(exports, "SportsStadium", ()=>(0, _sportsStadiumDefault.default));
parcelHelpers.export(exports, "Square", ()=>(0, _squareDefault.default));
parcelHelpers.export(exports, "StackedChart", ()=>(0, _stackedChartDefault.default));
parcelHelpers.export(exports, "StadiumGeometry", ()=>(0, _stadiumGeometryDefault.default));
parcelHelpers.export(exports, "Star", ()=>(0, _starDefault.default));
parcelHelpers.export(exports, "StarEmpty", ()=>(0, _starEmptyDefault.default));
parcelHelpers.export(exports, "StepBackward", ()=>(0, _stepBackwardDefault.default));
parcelHelpers.export(exports, "StepChart", ()=>(0, _stepChartDefault.default));
parcelHelpers.export(exports, "StepForward", ()=>(0, _stepForwardDefault.default));
parcelHelpers.export(exports, "Stop", ()=>(0, _stopDefault.default));
parcelHelpers.export(exports, "Stopwatch", ()=>(0, _stopwatchDefault.default));
parcelHelpers.export(exports, "Strikethrough", ()=>(0, _strikethroughDefault.default));
parcelHelpers.export(exports, "Style", ()=>(0, _styleDefault.default));
parcelHelpers.export(exports, "Subscript", ()=>(0, _subscriptDefault.default));
parcelHelpers.export(exports, "Superscript", ()=>(0, _superscriptDefault.default));
parcelHelpers.export(exports, "SwapHorizontal", ()=>(0, _swapHorizontalDefault.default));
parcelHelpers.export(exports, "SwapVertical", ()=>(0, _swapVerticalDefault.default));
parcelHelpers.export(exports, "Switch", ()=>(0, _switchDefault.default));
parcelHelpers.export(exports, "SymbolCircle", ()=>(0, _symbolCircleDefault.default));
parcelHelpers.export(exports, "SymbolCross", ()=>(0, _symbolCrossDefault.default));
parcelHelpers.export(exports, "SymbolDiamond", ()=>(0, _symbolDiamondDefault.default));
parcelHelpers.export(exports, "SymbolRectangle", ()=>(0, _symbolRectangleDefault.default));
parcelHelpers.export(exports, "SymbolSquare", ()=>(0, _symbolSquareDefault.default));
parcelHelpers.export(exports, "SymbolTriangleDown", ()=>(0, _symbolTriangleDownDefault.default));
parcelHelpers.export(exports, "SymbolTriangleUp", ()=>(0, _symbolTriangleUpDefault.default));
parcelHelpers.export(exports, "Syringe", ()=>(0, _syringeDefault.default));
parcelHelpers.export(exports, "TableSync", ()=>(0, _tableSyncDefault.default));
parcelHelpers.export(exports, "Tag", ()=>(0, _tagDefault.default));
parcelHelpers.export(exports, "TagAdd", ()=>(0, _tagAddDefault.default));
parcelHelpers.export(exports, "TagPromote", ()=>(0, _tagPromoteDefault.default));
parcelHelpers.export(exports, "TagRefresh", ()=>(0, _tagRefreshDefault.default));
parcelHelpers.export(exports, "TagUndo", ()=>(0, _tagUndoDefault.default));
parcelHelpers.export(exports, "Tags", ()=>(0, _tagsDefault.default));
parcelHelpers.export(exports, "TakeAction", ()=>(0, _takeActionDefault.default));
parcelHelpers.export(exports, "Tank", ()=>(0, _tankDefault.default));
parcelHelpers.export(exports, "Target", ()=>(0, _targetDefault.default));
parcelHelpers.export(exports, "Taxi", ()=>(0, _taxiDefault.default));
parcelHelpers.export(exports, "Team", ()=>(0, _teamDefault.default));
parcelHelpers.export(exports, "Temperature", ()=>(0, _temperatureDefault.default));
parcelHelpers.export(exports, "TextHighlight", ()=>(0, _textHighlightDefault.default));
parcelHelpers.export(exports, "Th", ()=>(0, _thDefault.default));
parcelHelpers.export(exports, "ThAdd", ()=>(0, _thAddDefault.default));
parcelHelpers.export(exports, "ThDerived", ()=>(0, _thDerivedDefault.default));
parcelHelpers.export(exports, "ThDisconnect", ()=>(0, _thDisconnectDefault.default));
parcelHelpers.export(exports, "ThFiltered", ()=>(0, _thFilteredDefault.default));
parcelHelpers.export(exports, "ThList", ()=>(0, _thListDefault.default));
parcelHelpers.export(exports, "ThListAdd", ()=>(0, _thListAddDefault.default));
parcelHelpers.export(exports, "ThVirtual", ()=>(0, _thVirtualDefault.default));
parcelHelpers.export(exports, "ThVirtualAdd", ()=>(0, _thVirtualAddDefault.default));
parcelHelpers.export(exports, "ThirdParty", ()=>(0, _thirdPartyDefault.default));
parcelHelpers.export(exports, "ThumbsDown", ()=>(0, _thumbsDownDefault.default));
parcelHelpers.export(exports, "ThumbsUp", ()=>(0, _thumbsUpDefault.default));
parcelHelpers.export(exports, "Tick", ()=>(0, _tickDefault.default));
parcelHelpers.export(exports, "TickCircle", ()=>(0, _tickCircleDefault.default));
parcelHelpers.export(exports, "Time", ()=>(0, _timeDefault.default));
parcelHelpers.export(exports, "TimelineAreaChart", ()=>(0, _timelineAreaChartDefault.default));
parcelHelpers.export(exports, "TimelineBarChart", ()=>(0, _timelineBarChartDefault.default));
parcelHelpers.export(exports, "TimelineEvents", ()=>(0, _timelineEventsDefault.default));
parcelHelpers.export(exports, "TimelineLineChart", ()=>(0, _timelineLineChartDefault.default));
parcelHelpers.export(exports, "Tint", ()=>(0, _tintDefault.default));
parcelHelpers.export(exports, "Torch", ()=>(0, _torchDefault.default));
parcelHelpers.export(exports, "Tractor", ()=>(0, _tractorDefault.default));
parcelHelpers.export(exports, "Train", ()=>(0, _trainDefault.default));
parcelHelpers.export(exports, "Translate", ()=>(0, _translateDefault.default));
parcelHelpers.export(exports, "Trash", ()=>(0, _trashDefault.default));
parcelHelpers.export(exports, "Tree", ()=>(0, _treeDefault.default));
parcelHelpers.export(exports, "TrendingDown", ()=>(0, _trendingDownDefault.default));
parcelHelpers.export(exports, "TrendingUp", ()=>(0, _trendingUpDefault.default));
parcelHelpers.export(exports, "Trophy", ()=>(0, _trophyDefault.default));
parcelHelpers.export(exports, "Truck", ()=>(0, _truckDefault.default));
parcelHelpers.export(exports, "TwoColumns", ()=>(0, _twoColumnsDefault.default));
parcelHelpers.export(exports, "Unarchive", ()=>(0, _unarchiveDefault.default));
parcelHelpers.export(exports, "Underline", ()=>(0, _underlineDefault.default));
parcelHelpers.export(exports, "Undo", ()=>(0, _undoDefault.default));
parcelHelpers.export(exports, "UngroupObjects", ()=>(0, _ungroupObjectsDefault.default));
parcelHelpers.export(exports, "UnknownVehicle", ()=>(0, _unknownVehicleDefault.default));
parcelHelpers.export(exports, "Unlink", ()=>(0, _unlinkDefault.default));
parcelHelpers.export(exports, "Unlock", ()=>(0, _unlockDefault.default));
parcelHelpers.export(exports, "Unpin", ()=>(0, _unpinDefault.default));
parcelHelpers.export(exports, "Unresolve", ()=>(0, _unresolveDefault.default));
parcelHelpers.export(exports, "Updated", ()=>(0, _updatedDefault.default));
parcelHelpers.export(exports, "Upload", ()=>(0, _uploadDefault.default));
parcelHelpers.export(exports, "User", ()=>(0, _userDefault.default));
parcelHelpers.export(exports, "Variable", ()=>(0, _variableDefault.default));
parcelHelpers.export(exports, "Vector", ()=>(0, _vectorDefault.default));
parcelHelpers.export(exports, "VerticalBarChartAsc", ()=>(0, _verticalBarChartAscDefault.default));
parcelHelpers.export(exports, "VerticalBarChartDesc", ()=>(0, _verticalBarChartDescDefault.default));
parcelHelpers.export(exports, "VerticalDistribution", ()=>(0, _verticalDistributionDefault.default));
parcelHelpers.export(exports, "VerticalInbetween", ()=>(0, _verticalInbetweenDefault.default));
parcelHelpers.export(exports, "Video", ()=>(0, _videoDefault.default));
parcelHelpers.export(exports, "Virus", ()=>(0, _virusDefault.default));
parcelHelpers.export(exports, "VolumeDown", ()=>(0, _volumeDownDefault.default));
parcelHelpers.export(exports, "VolumeOff", ()=>(0, _volumeOffDefault.default));
parcelHelpers.export(exports, "VolumeUp", ()=>(0, _volumeUpDefault.default));
parcelHelpers.export(exports, "Walk", ()=>(0, _walkDefault.default));
parcelHelpers.export(exports, "WarningSign", ()=>(0, _warningSignDefault.default));
parcelHelpers.export(exports, "WaterfallChart", ()=>(0, _waterfallChartDefault.default));
parcelHelpers.export(exports, "Waves", ()=>(0, _wavesDefault.default));
parcelHelpers.export(exports, "Widget", ()=>(0, _widgetDefault.default));
parcelHelpers.export(exports, "WidgetButton", ()=>(0, _widgetButtonDefault.default));
parcelHelpers.export(exports, "WidgetFooter", ()=>(0, _widgetFooterDefault.default));
parcelHelpers.export(exports, "WidgetHeader", ()=>(0, _widgetHeaderDefault.default));
parcelHelpers.export(exports, "Wind", ()=>(0, _windDefault.default));
parcelHelpers.export(exports, "Wrench", ()=>(0, _wrenchDefault.default));
parcelHelpers.export(exports, "WrenchRedo", ()=>(0, _wrenchRedoDefault.default));
parcelHelpers.export(exports, "WrenchSnooze", ()=>(0, _wrenchSnoozeDefault.default));
parcelHelpers.export(exports, "WrenchTime", ()=>(0, _wrenchTimeDefault.default));
parcelHelpers.export(exports, "ZoomIn", ()=>(0, _zoomInDefault.default));
parcelHelpers.export(exports, "ZoomOut", ()=>(0, _zoomOutDefault.default));
parcelHelpers.export(exports, "ZoomToFit", ()=>(0, _zoomToFitDefault.default));
var _add = require("./add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _addClip = require("./add-clip");
var _addClipDefault = parcelHelpers.interopDefault(_addClip);
var _addColumnLeft = require("./add-column-left");
var _addColumnLeftDefault = parcelHelpers.interopDefault(_addColumnLeft);
var _addColumnRight = require("./add-column-right");
var _addColumnRightDefault = parcelHelpers.interopDefault(_addColumnRight);
var _addLocation = require("./add-location");
var _addLocationDefault = parcelHelpers.interopDefault(_addLocation);
var _addRowBottom = require("./add-row-bottom");
var _addRowBottomDefault = parcelHelpers.interopDefault(_addRowBottom);
var _addRowTop = require("./add-row-top");
var _addRowTopDefault = parcelHelpers.interopDefault(_addRowTop);
var _addToArtifact = require("./add-to-artifact");
var _addToArtifactDefault = parcelHelpers.interopDefault(_addToArtifact);
var _addToFolder = require("./add-to-folder");
var _addToFolderDefault = parcelHelpers.interopDefault(_addToFolder);
var _aimpointsTarget = require("./aimpoints-target");
var _aimpointsTargetDefault = parcelHelpers.interopDefault(_aimpointsTarget);
var _airplane = require("./airplane");
var _airplaneDefault = parcelHelpers.interopDefault(_airplane);
var _alignCenter = require("./align-center");
var _alignCenterDefault = parcelHelpers.interopDefault(_alignCenter);
var _alignJustify = require("./align-justify");
var _alignJustifyDefault = parcelHelpers.interopDefault(_alignJustify);
var _alignLeft = require("./align-left");
var _alignLeftDefault = parcelHelpers.interopDefault(_alignLeft);
var _alignRight = require("./align-right");
var _alignRightDefault = parcelHelpers.interopDefault(_alignRight);
var _alignmentBottom = require("./alignment-bottom");
var _alignmentBottomDefault = parcelHelpers.interopDefault(_alignmentBottom);
var _alignmentHorizontalCenter = require("./alignment-horizontal-center");
var _alignmentHorizontalCenterDefault = parcelHelpers.interopDefault(_alignmentHorizontalCenter);
var _alignmentLeft = require("./alignment-left");
var _alignmentLeftDefault = parcelHelpers.interopDefault(_alignmentLeft);
var _alignmentRight = require("./alignment-right");
var _alignmentRightDefault = parcelHelpers.interopDefault(_alignmentRight);
var _alignmentTop = require("./alignment-top");
var _alignmentTopDefault = parcelHelpers.interopDefault(_alignmentTop);
var _alignmentVerticalCenter = require("./alignment-vertical-center");
var _alignmentVerticalCenterDefault = parcelHelpers.interopDefault(_alignmentVerticalCenter);
var _ammunition = require("./ammunition");
var _ammunitionDefault = parcelHelpers.interopDefault(_ammunition);
var _anchor = require("./anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _annotation = require("./annotation");
var _annotationDefault = parcelHelpers.interopDefault(_annotation);
var _antenna = require("./antenna");
var _antennaDefault = parcelHelpers.interopDefault(_antenna);
var _appHeader = require("./app-header");
var _appHeaderDefault = parcelHelpers.interopDefault(_appHeader);
var _application = require("./application");
var _applicationDefault = parcelHelpers.interopDefault(_application);
var _applications = require("./applications");
var _applicationsDefault = parcelHelpers.interopDefault(_applications);
var _archive = require("./archive");
var _archiveDefault = parcelHelpers.interopDefault(_archive);
var _areaOfInterest = require("./area-of-interest");
var _areaOfInterestDefault = parcelHelpers.interopDefault(_areaOfInterest);
var _array = require("./array");
var _arrayDefault = parcelHelpers.interopDefault(_array);
var _arrayBoolean = require("./array-boolean");
var _arrayBooleanDefault = parcelHelpers.interopDefault(_arrayBoolean);
var _arrayDate = require("./array-date");
var _arrayDateDefault = parcelHelpers.interopDefault(_arrayDate);
var _arrayFloatingPoint = require("./array-floating-point");
var _arrayFloatingPointDefault = parcelHelpers.interopDefault(_arrayFloatingPoint);
var _arrayNumeric = require("./array-numeric");
var _arrayNumericDefault = parcelHelpers.interopDefault(_arrayNumeric);
var _arrayString = require("./array-string");
var _arrayStringDefault = parcelHelpers.interopDefault(_arrayString);
var _arrayTimestamp = require("./array-timestamp");
var _arrayTimestampDefault = parcelHelpers.interopDefault(_arrayTimestamp);
var _arrowBottomLeft = require("./arrow-bottom-left");
var _arrowBottomLeftDefault = parcelHelpers.interopDefault(_arrowBottomLeft);
var _arrowBottomRight = require("./arrow-bottom-right");
var _arrowBottomRightDefault = parcelHelpers.interopDefault(_arrowBottomRight);
var _arrowDown = require("./arrow-down");
var _arrowDownDefault = parcelHelpers.interopDefault(_arrowDown);
var _arrowLeft = require("./arrow-left");
var _arrowLeftDefault = parcelHelpers.interopDefault(_arrowLeft);
var _arrowRight = require("./arrow-right");
var _arrowRightDefault = parcelHelpers.interopDefault(_arrowRight);
var _arrowTopLeft = require("./arrow-top-left");
var _arrowTopLeftDefault = parcelHelpers.interopDefault(_arrowTopLeft);
var _arrowTopRight = require("./arrow-top-right");
var _arrowTopRightDefault = parcelHelpers.interopDefault(_arrowTopRight);
var _arrowUp = require("./arrow-up");
var _arrowUpDefault = parcelHelpers.interopDefault(_arrowUp);
var _arrowsArc = require("./arrows-arc");
var _arrowsArcDefault = parcelHelpers.interopDefault(_arrowsArc);
var _arrowsHorizontal = require("./arrows-horizontal");
var _arrowsHorizontalDefault = parcelHelpers.interopDefault(_arrowsHorizontal);
var _arrowsVertical = require("./arrows-vertical");
var _arrowsVerticalDefault = parcelHelpers.interopDefault(_arrowsVertical);
var _asterisk = require("./asterisk");
var _asteriskDefault = parcelHelpers.interopDefault(_asterisk);
var _at = require("./at");
var _atDefault = parcelHelpers.interopDefault(_at);
var _automaticUpdates = require("./automatic-updates");
var _automaticUpdatesDefault = parcelHelpers.interopDefault(_automaticUpdates);
var _axle = require("./axle");
var _axleDefault = parcelHelpers.interopDefault(_axle);
var _backlink = require("./backlink");
var _backlinkDefault = parcelHelpers.interopDefault(_backlink);
var _backwardTen = require("./backward-ten");
var _backwardTenDefault = parcelHelpers.interopDefault(_backwardTen);
var _badge = require("./badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _banCircle = require("./ban-circle");
var _banCircleDefault = parcelHelpers.interopDefault(_banCircle);
var _bankAccount = require("./bank-account");
var _bankAccountDefault = parcelHelpers.interopDefault(_bankAccount);
var _barcode = require("./barcode");
var _barcodeDefault = parcelHelpers.interopDefault(_barcode);
var _binaryNumber = require("./binary-number");
var _binaryNumberDefault = parcelHelpers.interopDefault(_binaryNumber);
var _blank = require("./blank");
var _blankDefault = parcelHelpers.interopDefault(_blank);
var _blockPromote = require("./block-promote");
var _blockPromoteDefault = parcelHelpers.interopDefault(_blockPromote);
var _blockedPerson = require("./blocked-person");
var _blockedPersonDefault = parcelHelpers.interopDefault(_blockedPerson);
var _bold = require("./bold");
var _boldDefault = parcelHelpers.interopDefault(_bold);
var _book = require("./book");
var _bookDefault = parcelHelpers.interopDefault(_book);
var _bookmark = require("./bookmark");
var _bookmarkDefault = parcelHelpers.interopDefault(_bookmark);
var _box = require("./box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _briefcase = require("./briefcase");
var _briefcaseDefault = parcelHelpers.interopDefault(_briefcase);
var _bringData = require("./bring-data");
var _bringDataDefault = parcelHelpers.interopDefault(_bringData);
var _bringForward = require("./bring-forward");
var _bringForwardDefault = parcelHelpers.interopDefault(_bringForward);
var _britishPound = require("./british-pound");
var _britishPoundDefault = parcelHelpers.interopDefault(_britishPound);
var _bug = require("./bug");
var _bugDefault = parcelHelpers.interopDefault(_bug);
var _buggy = require("./buggy");
var _buggyDefault = parcelHelpers.interopDefault(_buggy);
var _build = require("./build");
var _buildDefault = parcelHelpers.interopDefault(_build);
var _bullseye = require("./bullseye");
var _bullseyeDefault = parcelHelpers.interopDefault(_bullseye);
var _calculator = require("./calculator");
var _calculatorDefault = parcelHelpers.interopDefault(_calculator);
var _calendar = require("./calendar");
var _calendarDefault = parcelHelpers.interopDefault(_calendar);
var _camera = require("./camera");
var _cameraDefault = parcelHelpers.interopDefault(_camera);
var _caretDown = require("./caret-down");
var _caretDownDefault = parcelHelpers.interopDefault(_caretDown);
var _caretLeft = require("./caret-left");
var _caretLeftDefault = parcelHelpers.interopDefault(_caretLeft);
var _caretRight = require("./caret-right");
var _caretRightDefault = parcelHelpers.interopDefault(_caretRight);
var _caretUp = require("./caret-up");
var _caretUpDefault = parcelHelpers.interopDefault(_caretUp);
var _cargoShip = require("./cargo-ship");
var _cargoShipDefault = parcelHelpers.interopDefault(_cargoShip);
var _cellTower = require("./cell-tower");
var _cellTowerDefault = parcelHelpers.interopDefault(_cellTower);
var _changes = require("./changes");
var _changesDefault = parcelHelpers.interopDefault(_changes);
var _chart = require("./chart");
var _chartDefault = parcelHelpers.interopDefault(_chart);
var _chat = require("./chat");
var _chatDefault = parcelHelpers.interopDefault(_chat);
var _chevronBackward = require("./chevron-backward");
var _chevronBackwardDefault = parcelHelpers.interopDefault(_chevronBackward);
var _chevronDown = require("./chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _chevronForward = require("./chevron-forward");
var _chevronForwardDefault = parcelHelpers.interopDefault(_chevronForward);
var _chevronLeft = require("./chevron-left");
var _chevronLeftDefault = parcelHelpers.interopDefault(_chevronLeft);
var _chevronRight = require("./chevron-right");
var _chevronRightDefault = parcelHelpers.interopDefault(_chevronRight);
var _chevronUp = require("./chevron-up");
var _chevronUpDefault = parcelHelpers.interopDefault(_chevronUp);
var _circle = require("./circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _circleArrowDown = require("./circle-arrow-down");
var _circleArrowDownDefault = parcelHelpers.interopDefault(_circleArrowDown);
var _circleArrowLeft = require("./circle-arrow-left");
var _circleArrowLeftDefault = parcelHelpers.interopDefault(_circleArrowLeft);
var _circleArrowRight = require("./circle-arrow-right");
var _circleArrowRightDefault = parcelHelpers.interopDefault(_circleArrowRight);
var _circleArrowUp = require("./circle-arrow-up");
var _circleArrowUpDefault = parcelHelpers.interopDefault(_circleArrowUp);
var _citation = require("./citation");
var _citationDefault = parcelHelpers.interopDefault(_citation);
var _clean = require("./clean");
var _cleanDefault = parcelHelpers.interopDefault(_clean);
var _clip = require("./clip");
var _clipDefault = parcelHelpers.interopDefault(_clip);
var _clipboard = require("./clipboard");
var _clipboardDefault = parcelHelpers.interopDefault(_clipboard);
var _clipboardFile = require("./clipboard-file");
var _clipboardFileDefault = parcelHelpers.interopDefault(_clipboardFile);
var _cloud = require("./cloud");
var _cloudDefault = parcelHelpers.interopDefault(_cloud);
var _cloudDownload = require("./cloud-download");
var _cloudDownloadDefault = parcelHelpers.interopDefault(_cloudDownload);
var _cloudServer = require("./cloud-server");
var _cloudServerDefault = parcelHelpers.interopDefault(_cloudServer);
var _cloudTick = require("./cloud-tick");
var _cloudTickDefault = parcelHelpers.interopDefault(_cloudTick);
var _cloudUpload = require("./cloud-upload");
var _cloudUploadDefault = parcelHelpers.interopDefault(_cloudUpload);
var _code = require("./code");
var _codeDefault = parcelHelpers.interopDefault(_code);
var _codeBlock = require("./code-block");
var _codeBlockDefault = parcelHelpers.interopDefault(_codeBlock);
var _cog = require("./cog");
var _cogDefault = parcelHelpers.interopDefault(_cog);
var _collapseAll = require("./collapse-all");
var _collapseAllDefault = parcelHelpers.interopDefault(_collapseAll);
var _colorFill = require("./color-fill");
var _colorFillDefault = parcelHelpers.interopDefault(_colorFill);
var _columnLayout = require("./column-layout");
var _columnLayoutDefault = parcelHelpers.interopDefault(_columnLayout);
var _comment = require("./comment");
var _commentDefault = parcelHelpers.interopDefault(_comment);
var _comparison = require("./comparison");
var _comparisonDefault = parcelHelpers.interopDefault(_comparison);
var _compass = require("./compass");
var _compassDefault = parcelHelpers.interopDefault(_compass);
var _compressed = require("./compressed");
var _compressedDefault = parcelHelpers.interopDefault(_compressed);
var _confirm = require("./confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
var _console = require("./console");
var _consoleDefault = parcelHelpers.interopDefault(_console);
var _contrast = require("./contrast");
var _contrastDefault = parcelHelpers.interopDefault(_contrast);
var _control = require("./control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _creditCard = require("./credit-card");
var _creditCardDefault = parcelHelpers.interopDefault(_creditCard);
var _crop = require("./crop");
var _cropDefault = parcelHelpers.interopDefault(_crop);
var _cross = require("./cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _crossCircle = require("./cross-circle");
var _crossCircleDefault = parcelHelpers.interopDefault(_crossCircle);
var _crown = require("./crown");
var _crownDefault = parcelHelpers.interopDefault(_crown);
var _cssStyle = require("./css-style");
var _cssStyleDefault = parcelHelpers.interopDefault(_cssStyle);
var _cube = require("./cube");
var _cubeDefault = parcelHelpers.interopDefault(_cube);
var _cubeAdd = require("./cube-add");
var _cubeAddDefault = parcelHelpers.interopDefault(_cubeAdd);
var _cubeEdit = require("./cube-edit");
var _cubeEditDefault = parcelHelpers.interopDefault(_cubeEdit);
var _cubeRemove = require("./cube-remove");
var _cubeRemoveDefault = parcelHelpers.interopDefault(_cubeRemove);
var _cubes = require("./cubes");
var _cubesDefault = parcelHelpers.interopDefault(_cubes);
var _curlyBraces = require("./curly-braces");
var _curlyBracesDefault = parcelHelpers.interopDefault(_curlyBraces);
var _curvedRangeChart = require("./curved-range-chart");
var _curvedRangeChartDefault = parcelHelpers.interopDefault(_curvedRangeChart);
var _cut = require("./cut");
var _cutDefault = parcelHelpers.interopDefault(_cut);
var _cycle = require("./cycle");
var _cycleDefault = parcelHelpers.interopDefault(_cycle);
var _dashboard = require("./dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
var _dataConnection = require("./data-connection");
var _dataConnectionDefault = parcelHelpers.interopDefault(_dataConnection);
var _dataLineage = require("./data-lineage");
var _dataLineageDefault = parcelHelpers.interopDefault(_dataLineage);
var _dataSearch = require("./data-search");
var _dataSearchDefault = parcelHelpers.interopDefault(_dataSearch);
var _dataSync = require("./data-sync");
var _dataSyncDefault = parcelHelpers.interopDefault(_dataSync);
var _database = require("./database");
var _databaseDefault = parcelHelpers.interopDefault(_database);
var _delete = require("./delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _delta = require("./delta");
var _deltaDefault = parcelHelpers.interopDefault(_delta);
var _deriveColumn = require("./derive-column");
var _deriveColumnDefault = parcelHelpers.interopDefault(_deriveColumn);
var _desktop = require("./desktop");
var _desktopDefault = parcelHelpers.interopDefault(_desktop);
var _detection = require("./detection");
var _detectionDefault = parcelHelpers.interopDefault(_detection);
var _diagnosis = require("./diagnosis");
var _diagnosisDefault = parcelHelpers.interopDefault(_diagnosis);
var _diagramTree = require("./diagram-tree");
var _diagramTreeDefault = parcelHelpers.interopDefault(_diagramTree);
var _directionLeft = require("./direction-left");
var _directionLeftDefault = parcelHelpers.interopDefault(_directionLeft);
var _directionRight = require("./direction-right");
var _directionRightDefault = parcelHelpers.interopDefault(_directionRight);
var _disable = require("./disable");
var _disableDefault = parcelHelpers.interopDefault(_disable);
var _divide = require("./divide");
var _divideDefault = parcelHelpers.interopDefault(_divide);
var _document = require("./document");
var _documentDefault = parcelHelpers.interopDefault(_document);
var _documentOpen = require("./document-open");
var _documentOpenDefault = parcelHelpers.interopDefault(_documentOpen);
var _documentShare = require("./document-share");
var _documentShareDefault = parcelHelpers.interopDefault(_documentShare);
var _dollar = require("./dollar");
var _dollarDefault = parcelHelpers.interopDefault(_dollar);
var _dot = require("./dot");
var _dotDefault = parcelHelpers.interopDefault(_dot);
var _doubleCaretHorizontal = require("./double-caret-horizontal");
var _doubleCaretHorizontalDefault = parcelHelpers.interopDefault(_doubleCaretHorizontal);
var _doubleCaretVertical = require("./double-caret-vertical");
var _doubleCaretVerticalDefault = parcelHelpers.interopDefault(_doubleCaretVertical);
var _doubleChevronDown = require("./double-chevron-down");
var _doubleChevronDownDefault = parcelHelpers.interopDefault(_doubleChevronDown);
var _doubleChevronLeft = require("./double-chevron-left");
var _doubleChevronLeftDefault = parcelHelpers.interopDefault(_doubleChevronLeft);
var _doubleChevronRight = require("./double-chevron-right");
var _doubleChevronRightDefault = parcelHelpers.interopDefault(_doubleChevronRight);
var _doubleChevronUp = require("./double-chevron-up");
var _doubleChevronUpDefault = parcelHelpers.interopDefault(_doubleChevronUp);
var _doughnutChart = require("./doughnut-chart");
var _doughnutChartDefault = parcelHelpers.interopDefault(_doughnutChart);
var _download = require("./download");
var _downloadDefault = parcelHelpers.interopDefault(_download);
var _dragHandleHorizontal = require("./drag-handle-horizontal");
var _dragHandleHorizontalDefault = parcelHelpers.interopDefault(_dragHandleHorizontal);
var _dragHandleVertical = require("./drag-handle-vertical");
var _dragHandleVerticalDefault = parcelHelpers.interopDefault(_dragHandleVertical);
var _draw = require("./draw");
var _drawDefault = parcelHelpers.interopDefault(_draw);
var _drawerLeft = require("./drawer-left");
var _drawerLeftDefault = parcelHelpers.interopDefault(_drawerLeft);
var _drawerLeftFilled = require("./drawer-left-filled");
var _drawerLeftFilledDefault = parcelHelpers.interopDefault(_drawerLeftFilled);
var _drawerRight = require("./drawer-right");
var _drawerRightDefault = parcelHelpers.interopDefault(_drawerRight);
var _drawerRightFilled = require("./drawer-right-filled");
var _drawerRightFilledDefault = parcelHelpers.interopDefault(_drawerRightFilled);
var _driveTime = require("./drive-time");
var _driveTimeDefault = parcelHelpers.interopDefault(_driveTime);
var _duplicate = require("./duplicate");
var _duplicateDefault = parcelHelpers.interopDefault(_duplicate);
var _edit = require("./edit");
var _editDefault = parcelHelpers.interopDefault(_edit);
var _eject = require("./eject");
var _ejectDefault = parcelHelpers.interopDefault(_eject);
var _emoji = require("./emoji");
var _emojiDefault = parcelHelpers.interopDefault(_emoji);
var _endnote = require("./endnote");
var _endnoteDefault = parcelHelpers.interopDefault(_endnote);
var _endorsed = require("./endorsed");
var _endorsedDefault = parcelHelpers.interopDefault(_endorsed);
var _envelope = require("./envelope");
var _envelopeDefault = parcelHelpers.interopDefault(_envelope);
var _equals = require("./equals");
var _equalsDefault = parcelHelpers.interopDefault(_equals);
var _eraser = require("./eraser");
var _eraserDefault = parcelHelpers.interopDefault(_eraser);
var _error = require("./error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _euro = require("./euro");
var _euroDefault = parcelHelpers.interopDefault(_euro);
var _excavator = require("./excavator");
var _excavatorDefault = parcelHelpers.interopDefault(_excavator);
var _exchange = require("./exchange");
var _exchangeDefault = parcelHelpers.interopDefault(_exchange);
var _excludeRow = require("./exclude-row");
var _excludeRowDefault = parcelHelpers.interopDefault(_excludeRow);
var _expandAll = require("./expand-all");
var _expandAllDefault = parcelHelpers.interopDefault(_expandAll);
var _explain = require("./explain");
var _explainDefault = parcelHelpers.interopDefault(_explain);
var _export = require("./export");
var _exportDefault = parcelHelpers.interopDefault(_export);
var _eyeOff = require("./eye-off");
var _eyeOffDefault = parcelHelpers.interopDefault(_eyeOff);
var _eyeOn = require("./eye-on");
var _eyeOnDefault = parcelHelpers.interopDefault(_eyeOn);
var _eyeOpen = require("./eye-open");
var _eyeOpenDefault = parcelHelpers.interopDefault(_eyeOpen);
var _fastBackward = require("./fast-backward");
var _fastBackwardDefault = parcelHelpers.interopDefault(_fastBackward);
var _fastForward = require("./fast-forward");
var _fastForwardDefault = parcelHelpers.interopDefault(_fastForward);
var _feed = require("./feed");
var _feedDefault = parcelHelpers.interopDefault(_feed);
var _feedSubscribed = require("./feed-subscribed");
var _feedSubscribedDefault = parcelHelpers.interopDefault(_feedSubscribed);
var _fighterJet = require("./fighter-jet");
var _fighterJetDefault = parcelHelpers.interopDefault(_fighterJet);
var _film = require("./film");
var _filmDefault = parcelHelpers.interopDefault(_film);
var _filter = require("./filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _filterKeep = require("./filter-keep");
var _filterKeepDefault = parcelHelpers.interopDefault(_filterKeep);
var _filterList = require("./filter-list");
var _filterListDefault = parcelHelpers.interopDefault(_filterList);
var _filterOpen = require("./filter-open");
var _filterOpenDefault = parcelHelpers.interopDefault(_filterOpen);
var _filterRemove = require("./filter-remove");
var _filterRemoveDefault = parcelHelpers.interopDefault(_filterRemove);
var _filterSortAsc = require("./filter-sort-asc");
var _filterSortAscDefault = parcelHelpers.interopDefault(_filterSortAsc);
var _filterSortDesc = require("./filter-sort-desc");
var _filterSortDescDefault = parcelHelpers.interopDefault(_filterSortDesc);
var _flag = require("./flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _flame = require("./flame");
var _flameDefault = parcelHelpers.interopDefault(_flame);
var _flash = require("./flash");
var _flashDefault = parcelHelpers.interopDefault(_flash);
var _floatingPoint = require("./floating-point");
var _floatingPointDefault = parcelHelpers.interopDefault(_floatingPoint);
var _floppyDisk = require("./floppy-disk");
var _floppyDiskDefault = parcelHelpers.interopDefault(_floppyDisk);
var _flowBranch = require("./flow-branch");
var _flowBranchDefault = parcelHelpers.interopDefault(_flowBranch);
var _flowEnd = require("./flow-end");
var _flowEndDefault = parcelHelpers.interopDefault(_flowEnd);
var _flowLinear = require("./flow-linear");
var _flowLinearDefault = parcelHelpers.interopDefault(_flowLinear);
var _flowReview = require("./flow-review");
var _flowReviewDefault = parcelHelpers.interopDefault(_flowReview);
var _flowReviewBranch = require("./flow-review-branch");
var _flowReviewBranchDefault = parcelHelpers.interopDefault(_flowReviewBranch);
var _flows = require("./flows");
var _flowsDefault = parcelHelpers.interopDefault(_flows);
var _folderClose = require("./folder-close");
var _folderCloseDefault = parcelHelpers.interopDefault(_folderClose);
var _folderNew = require("./folder-new");
var _folderNewDefault = parcelHelpers.interopDefault(_folderNew);
var _folderOpen = require("./folder-open");
var _folderOpenDefault = parcelHelpers.interopDefault(_folderOpen);
var _folderShared = require("./folder-shared");
var _folderSharedDefault = parcelHelpers.interopDefault(_folderShared);
var _folderSharedOpen = require("./folder-shared-open");
var _folderSharedOpenDefault = parcelHelpers.interopDefault(_folderSharedOpen);
var _follower = require("./follower");
var _followerDefault = parcelHelpers.interopDefault(_follower);
var _following = require("./following");
var _followingDefault = parcelHelpers.interopDefault(_following);
var _font = require("./font");
var _fontDefault = parcelHelpers.interopDefault(_font);
var _fork = require("./fork");
var _forkDefault = parcelHelpers.interopDefault(_fork);
var _form = require("./form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _forwardTen = require("./forward-ten");
var _forwardTenDefault = parcelHelpers.interopDefault(_forwardTen);
var _fuel = require("./fuel");
var _fuelDefault = parcelHelpers.interopDefault(_fuel);
var _fullCircle = require("./full-circle");
var _fullCircleDefault = parcelHelpers.interopDefault(_fullCircle);
var _fullStackedChart = require("./full-stacked-chart");
var _fullStackedChartDefault = parcelHelpers.interopDefault(_fullStackedChart);
var _fullscreen = require("./fullscreen");
var _fullscreenDefault = parcelHelpers.interopDefault(_fullscreen);
var _function = require("./function");
var _functionDefault = parcelHelpers.interopDefault(_function);
var _ganttChart = require("./gantt-chart");
var _ganttChartDefault = parcelHelpers.interopDefault(_ganttChart);
var _generate = require("./generate");
var _generateDefault = parcelHelpers.interopDefault(_generate);
var _geofence = require("./geofence");
var _geofenceDefault = parcelHelpers.interopDefault(_geofence);
var _geolocation = require("./geolocation");
var _geolocationDefault = parcelHelpers.interopDefault(_geolocation);
var _geosearch = require("./geosearch");
var _geosearchDefault = parcelHelpers.interopDefault(_geosearch);
var _geotime = require("./geotime");
var _geotimeDefault = parcelHelpers.interopDefault(_geotime);
var _gitBranch = require("./git-branch");
var _gitBranchDefault = parcelHelpers.interopDefault(_gitBranch);
var _gitCommit = require("./git-commit");
var _gitCommitDefault = parcelHelpers.interopDefault(_gitCommit);
var _gitMerge = require("./git-merge");
var _gitMergeDefault = parcelHelpers.interopDefault(_gitMerge);
var _gitNewBranch = require("./git-new-branch");
var _gitNewBranchDefault = parcelHelpers.interopDefault(_gitNewBranch);
var _gitPull = require("./git-pull");
var _gitPullDefault = parcelHelpers.interopDefault(_gitPull);
var _gitPush = require("./git-push");
var _gitPushDefault = parcelHelpers.interopDefault(_gitPush);
var _gitRepo = require("./git-repo");
var _gitRepoDefault = parcelHelpers.interopDefault(_gitRepo);
var _glass = require("./glass");
var _glassDefault = parcelHelpers.interopDefault(_glass);
var _globe = require("./globe");
var _globeDefault = parcelHelpers.interopDefault(_globe);
var _globeNetwork = require("./globe-network");
var _globeNetworkDefault = parcelHelpers.interopDefault(_globeNetwork);
var _globeNetworkAdd = require("./globe-network-add");
var _globeNetworkAddDefault = parcelHelpers.interopDefault(_globeNetworkAdd);
var _graph = require("./graph");
var _graphDefault = parcelHelpers.interopDefault(_graph);
var _graphRemove = require("./graph-remove");
var _graphRemoveDefault = parcelHelpers.interopDefault(_graphRemove);
var _greaterThan = require("./greater-than");
var _greaterThanDefault = parcelHelpers.interopDefault(_greaterThan);
var _greaterThanOrEqualTo = require("./greater-than-or-equal-to");
var _greaterThanOrEqualToDefault = parcelHelpers.interopDefault(_greaterThanOrEqualTo);
var _grid = require("./grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _gridView = require("./grid-view");
var _gridViewDefault = parcelHelpers.interopDefault(_gridView);
var _groupItem = require("./group-item");
var _groupItemDefault = parcelHelpers.interopDefault(_groupItem);
var _groupObjects = require("./group-objects");
var _groupObjectsDefault = parcelHelpers.interopDefault(_groupObjects);
var _groupedBarChart = require("./grouped-bar-chart");
var _groupedBarChartDefault = parcelHelpers.interopDefault(_groupedBarChart);
var _hand = require("./hand");
var _handDefault = parcelHelpers.interopDefault(_hand);
var _handDown = require("./hand-down");
var _handDownDefault = parcelHelpers.interopDefault(_handDown);
var _handLeft = require("./hand-left");
var _handLeftDefault = parcelHelpers.interopDefault(_handLeft);
var _handRight = require("./hand-right");
var _handRightDefault = parcelHelpers.interopDefault(_handRight);
var _handUp = require("./hand-up");
var _handUpDefault = parcelHelpers.interopDefault(_handUp);
var _hat = require("./hat");
var _hatDefault = parcelHelpers.interopDefault(_hat);
var _header = require("./header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _headerOne = require("./header-one");
var _headerOneDefault = parcelHelpers.interopDefault(_headerOne);
var _headerThree = require("./header-three");
var _headerThreeDefault = parcelHelpers.interopDefault(_headerThree);
var _headerTwo = require("./header-two");
var _headerTwoDefault = parcelHelpers.interopDefault(_headerTwo);
var _headset = require("./headset");
var _headsetDefault = parcelHelpers.interopDefault(_headset);
var _heart = require("./heart");
var _heartDefault = parcelHelpers.interopDefault(_heart);
var _heartBroken = require("./heart-broken");
var _heartBrokenDefault = parcelHelpers.interopDefault(_heartBroken);
var _heatGrid = require("./heat-grid");
var _heatGridDefault = parcelHelpers.interopDefault(_heatGrid);
var _heatmap = require("./heatmap");
var _heatmapDefault = parcelHelpers.interopDefault(_heatmap);
var _helicopter = require("./helicopter");
var _helicopterDefault = parcelHelpers.interopDefault(_helicopter);
var _help = require("./help");
var _helpDefault = parcelHelpers.interopDefault(_help);
var _helperManagement = require("./helper-management");
var _helperManagementDefault = parcelHelpers.interopDefault(_helperManagement);
var _hexagon = require("./hexagon");
var _hexagonDefault = parcelHelpers.interopDefault(_hexagon);
var _highPriority = require("./high-priority");
var _highPriorityDefault = parcelHelpers.interopDefault(_highPriority);
var _highVoltagePole = require("./high-voltage-pole");
var _highVoltagePoleDefault = parcelHelpers.interopDefault(_highVoltagePole);
var _highlight = require("./highlight");
var _highlightDefault = parcelHelpers.interopDefault(_highlight);
var _history = require("./history");
var _historyDefault = parcelHelpers.interopDefault(_history);
var _home = require("./home");
var _homeDefault = parcelHelpers.interopDefault(_home);
var _horizontalBarChart = require("./horizontal-bar-chart");
var _horizontalBarChartDefault = parcelHelpers.interopDefault(_horizontalBarChart);
var _horizontalBarChartAsc = require("./horizontal-bar-chart-asc");
var _horizontalBarChartAscDefault = parcelHelpers.interopDefault(_horizontalBarChartAsc);
var _horizontalBarChartDesc = require("./horizontal-bar-chart-desc");
var _horizontalBarChartDescDefault = parcelHelpers.interopDefault(_horizontalBarChartDesc);
var _horizontalDistribution = require("./horizontal-distribution");
var _horizontalDistributionDefault = parcelHelpers.interopDefault(_horizontalDistribution);
var _horizontalInbetween = require("./horizontal-inbetween");
var _horizontalInbetweenDefault = parcelHelpers.interopDefault(_horizontalInbetween);
var _hurricane = require("./hurricane");
var _hurricaneDefault = parcelHelpers.interopDefault(_hurricane);
var _idNumber = require("./id-number");
var _idNumberDefault = parcelHelpers.interopDefault(_idNumber);
var _imageRotateLeft = require("./image-rotate-left");
var _imageRotateLeftDefault = parcelHelpers.interopDefault(_imageRotateLeft);
var _imageRotateRight = require("./image-rotate-right");
var _imageRotateRightDefault = parcelHelpers.interopDefault(_imageRotateRight);
var _import = require("./import");
var _importDefault = parcelHelpers.interopDefault(_import);
var _inbox = require("./inbox");
var _inboxDefault = parcelHelpers.interopDefault(_inbox);
var _inboxFiltered = require("./inbox-filtered");
var _inboxFilteredDefault = parcelHelpers.interopDefault(_inboxFiltered);
var _inboxGeo = require("./inbox-geo");
var _inboxGeoDefault = parcelHelpers.interopDefault(_inboxGeo);
var _inboxSearch = require("./inbox-search");
var _inboxSearchDefault = parcelHelpers.interopDefault(_inboxSearch);
var _inboxUpdate = require("./inbox-update");
var _inboxUpdateDefault = parcelHelpers.interopDefault(_inboxUpdate);
var _infoSign = require("./info-sign");
var _infoSignDefault = parcelHelpers.interopDefault(_infoSign);
var _inheritance = require("./inheritance");
var _inheritanceDefault = parcelHelpers.interopDefault(_inheritance);
var _inheritedGroup = require("./inherited-group");
var _inheritedGroupDefault = parcelHelpers.interopDefault(_inheritedGroup);
var _innerJoin = require("./inner-join");
var _innerJoinDefault = parcelHelpers.interopDefault(_innerJoin);
var _input = require("./input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _insert = require("./insert");
var _insertDefault = parcelHelpers.interopDefault(_insert);
var _intelligence = require("./intelligence");
var _intelligenceDefault = parcelHelpers.interopDefault(_intelligence);
var _intersection = require("./intersection");
var _intersectionDefault = parcelHelpers.interopDefault(_intersection);
var _ipAddress = require("./ip-address");
var _ipAddressDefault = parcelHelpers.interopDefault(_ipAddress);
var _issue = require("./issue");
var _issueDefault = parcelHelpers.interopDefault(_issue);
var _issueClosed = require("./issue-closed");
var _issueClosedDefault = parcelHelpers.interopDefault(_issueClosed);
var _issueNew = require("./issue-new");
var _issueNewDefault = parcelHelpers.interopDefault(_issueNew);
var _italic = require("./italic");
var _italicDefault = parcelHelpers.interopDefault(_italic);
var _joinTable = require("./join-table");
var _joinTableDefault = parcelHelpers.interopDefault(_joinTable);
var _key = require("./key");
var _keyDefault = parcelHelpers.interopDefault(_key);
var _keyBackspace = require("./key-backspace");
var _keyBackspaceDefault = parcelHelpers.interopDefault(_keyBackspace);
var _keyCommand = require("./key-command");
var _keyCommandDefault = parcelHelpers.interopDefault(_keyCommand);
var _keyControl = require("./key-control");
var _keyControlDefault = parcelHelpers.interopDefault(_keyControl);
var _keyDelete = require("./key-delete");
var _keyDeleteDefault = parcelHelpers.interopDefault(_keyDelete);
var _keyEnter = require("./key-enter");
var _keyEnterDefault = parcelHelpers.interopDefault(_keyEnter);
var _keyEscape = require("./key-escape");
var _keyEscapeDefault = parcelHelpers.interopDefault(_keyEscape);
var _keyOption = require("./key-option");
var _keyOptionDefault = parcelHelpers.interopDefault(_keyOption);
var _keyShift = require("./key-shift");
var _keyShiftDefault = parcelHelpers.interopDefault(_keyShift);
var _keyTab = require("./key-tab");
var _keyTabDefault = parcelHelpers.interopDefault(_keyTab);
var _knownVehicle = require("./known-vehicle");
var _knownVehicleDefault = parcelHelpers.interopDefault(_knownVehicle);
var _labTest = require("./lab-test");
var _labTestDefault = parcelHelpers.interopDefault(_labTest);
var _label = require("./label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _layer = require("./layer");
var _layerDefault = parcelHelpers.interopDefault(_layer);
var _layerOutline = require("./layer-outline");
var _layerOutlineDefault = parcelHelpers.interopDefault(_layerOutline);
var _layers = require("./layers");
var _layersDefault = parcelHelpers.interopDefault(_layers);
var _layout = require("./layout");
var _layoutDefault = parcelHelpers.interopDefault(_layout);
var _layoutAuto = require("./layout-auto");
var _layoutAutoDefault = parcelHelpers.interopDefault(_layoutAuto);
var _layoutBalloon = require("./layout-balloon");
var _layoutBalloonDefault = parcelHelpers.interopDefault(_layoutBalloon);
var _layoutBottomRowThreeTiles = require("./layout-bottom-row-three-tiles");
var _layoutBottomRowThreeTilesDefault = parcelHelpers.interopDefault(_layoutBottomRowThreeTiles);
var _layoutBottomRowTwoTiles = require("./layout-bottom-row-two-tiles");
var _layoutBottomRowTwoTilesDefault = parcelHelpers.interopDefault(_layoutBottomRowTwoTiles);
var _layoutCircle = require("./layout-circle");
var _layoutCircleDefault = parcelHelpers.interopDefault(_layoutCircle);
var _layoutGrid = require("./layout-grid");
var _layoutGridDefault = parcelHelpers.interopDefault(_layoutGrid);
var _layoutGroupBy = require("./layout-group-by");
var _layoutGroupByDefault = parcelHelpers.interopDefault(_layoutGroupBy);
var _layoutHierarchy = require("./layout-hierarchy");
var _layoutHierarchyDefault = parcelHelpers.interopDefault(_layoutHierarchy);
var _layoutLeftColumnThreeTiles = require("./layout-left-column-three-tiles");
var _layoutLeftColumnThreeTilesDefault = parcelHelpers.interopDefault(_layoutLeftColumnThreeTiles);
var _layoutLeftColumnTwoTiles = require("./layout-left-column-two-tiles");
var _layoutLeftColumnTwoTilesDefault = parcelHelpers.interopDefault(_layoutLeftColumnTwoTiles);
var _layoutLinear = require("./layout-linear");
var _layoutLinearDefault = parcelHelpers.interopDefault(_layoutLinear);
var _layoutRightColumnThreeTiles = require("./layout-right-column-three-tiles");
var _layoutRightColumnThreeTilesDefault = parcelHelpers.interopDefault(_layoutRightColumnThreeTiles);
var _layoutRightColumnTwoTiles = require("./layout-right-column-two-tiles");
var _layoutRightColumnTwoTilesDefault = parcelHelpers.interopDefault(_layoutRightColumnTwoTiles);
var _layoutSkewGrid = require("./layout-skew-grid");
var _layoutSkewGridDefault = parcelHelpers.interopDefault(_layoutSkewGrid);
var _layoutSortedClusters = require("./layout-sorted-clusters");
var _layoutSortedClustersDefault = parcelHelpers.interopDefault(_layoutSortedClusters);
var _layoutThreeColumns = require("./layout-three-columns");
var _layoutThreeColumnsDefault = parcelHelpers.interopDefault(_layoutThreeColumns);
var _layoutThreeRows = require("./layout-three-rows");
var _layoutThreeRowsDefault = parcelHelpers.interopDefault(_layoutThreeRows);
var _layoutTopRowThreeTiles = require("./layout-top-row-three-tiles");
var _layoutTopRowThreeTilesDefault = parcelHelpers.interopDefault(_layoutTopRowThreeTiles);
var _layoutTopRowTwoTiles = require("./layout-top-row-two-tiles");
var _layoutTopRowTwoTilesDefault = parcelHelpers.interopDefault(_layoutTopRowTwoTiles);
var _layoutTwoColumns = require("./layout-two-columns");
var _layoutTwoColumnsDefault = parcelHelpers.interopDefault(_layoutTwoColumns);
var _layoutTwoRows = require("./layout-two-rows");
var _layoutTwoRowsDefault = parcelHelpers.interopDefault(_layoutTwoRows);
var _learning = require("./learning");
var _learningDefault = parcelHelpers.interopDefault(_learning);
var _leftJoin = require("./left-join");
var _leftJoinDefault = parcelHelpers.interopDefault(_leftJoin);
var _lengthenText = require("./lengthen-text");
var _lengthenTextDefault = parcelHelpers.interopDefault(_lengthenText);
var _lessThan = require("./less-than");
var _lessThanDefault = parcelHelpers.interopDefault(_lessThan);
var _lessThanOrEqualTo = require("./less-than-or-equal-to");
var _lessThanOrEqualToDefault = parcelHelpers.interopDefault(_lessThanOrEqualTo);
var _lifesaver = require("./lifesaver");
var _lifesaverDefault = parcelHelpers.interopDefault(_lifesaver);
var _lightbulb = require("./lightbulb");
var _lightbulbDefault = parcelHelpers.interopDefault(_lightbulb);
var _lightning = require("./lightning");
var _lightningDefault = parcelHelpers.interopDefault(_lightning);
var _link = require("./link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _linkedSquares = require("./linked-squares");
var _linkedSquaresDefault = parcelHelpers.interopDefault(_linkedSquares);
var _list = require("./list");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listColumns = require("./list-columns");
var _listColumnsDefault = parcelHelpers.interopDefault(_listColumns);
var _listDetailView = require("./list-detail-view");
var _listDetailViewDefault = parcelHelpers.interopDefault(_listDetailView);
var _locate = require("./locate");
var _locateDefault = parcelHelpers.interopDefault(_locate);
var _lock = require("./lock");
var _lockDefault = parcelHelpers.interopDefault(_lock);
var _locomotive = require("./locomotive");
var _locomotiveDefault = parcelHelpers.interopDefault(_locomotive);
var _logIn = require("./log-in");
var _logInDefault = parcelHelpers.interopDefault(_logIn);
var _logOut = require("./log-out");
var _logOutDefault = parcelHelpers.interopDefault(_logOut);
var _lowVoltagePole = require("./low-voltage-pole");
var _lowVoltagePoleDefault = parcelHelpers.interopDefault(_lowVoltagePole);
var _manual = require("./manual");
var _manualDefault = parcelHelpers.interopDefault(_manual);
var _manuallyEnteredData = require("./manually-entered-data");
var _manuallyEnteredDataDefault = parcelHelpers.interopDefault(_manuallyEnteredData);
var _manyToMany = require("./many-to-many");
var _manyToManyDefault = parcelHelpers.interopDefault(_manyToMany);
var _manyToOne = require("./many-to-one");
var _manyToOneDefault = parcelHelpers.interopDefault(_manyToOne);
var _map = require("./map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _mapCreate = require("./map-create");
var _mapCreateDefault = parcelHelpers.interopDefault(_mapCreate);
var _mapMarker = require("./map-marker");
var _mapMarkerDefault = parcelHelpers.interopDefault(_mapMarker);
var _maximize = require("./maximize");
var _maximizeDefault = parcelHelpers.interopDefault(_maximize);
var _media = require("./media");
var _mediaDefault = parcelHelpers.interopDefault(_media);
var _menu = require("./menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuClosed = require("./menu-closed");
var _menuClosedDefault = parcelHelpers.interopDefault(_menuClosed);
var _menuOpen = require("./menu-open");
var _menuOpenDefault = parcelHelpers.interopDefault(_menuOpen);
var _mergeColumns = require("./merge-columns");
var _mergeColumnsDefault = parcelHelpers.interopDefault(_mergeColumns);
var _mergeLinks = require("./merge-links");
var _mergeLinksDefault = parcelHelpers.interopDefault(_mergeLinks);
var _microphone = require("./microphone");
var _microphoneDefault = parcelHelpers.interopDefault(_microphone);
var _minimize = require("./minimize");
var _minimizeDefault = parcelHelpers.interopDefault(_minimize);
var _minus = require("./minus");
var _minusDefault = parcelHelpers.interopDefault(_minus);
var _mobilePhone = require("./mobile-phone");
var _mobilePhoneDefault = parcelHelpers.interopDefault(_mobilePhone);
var _mobileVideo = require("./mobile-video");
var _mobileVideoDefault = parcelHelpers.interopDefault(_mobileVideo);
var _modal = require("./modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalFilled = require("./modal-filled");
var _modalFilledDefault = parcelHelpers.interopDefault(_modalFilled);
var _model = require("./model");
var _modelDefault = parcelHelpers.interopDefault(_model);
var _moon = require("./moon");
var _moonDefault = parcelHelpers.interopDefault(_moon);
var _more = require("./more");
var _moreDefault = parcelHelpers.interopDefault(_more);
var _mountain = require("./mountain");
var _mountainDefault = parcelHelpers.interopDefault(_mountain);
var _move = require("./move");
var _moveDefault = parcelHelpers.interopDefault(_move);
var _mugshot = require("./mugshot");
var _mugshotDefault = parcelHelpers.interopDefault(_mugshot);
var _multiSelect = require("./multi-select");
var _multiSelectDefault = parcelHelpers.interopDefault(_multiSelect);
var _music = require("./music");
var _musicDefault = parcelHelpers.interopDefault(_music);
var _nest = require("./nest");
var _nestDefault = parcelHelpers.interopDefault(_nest);
var _newDrawing = require("./new-drawing");
var _newDrawingDefault = parcelHelpers.interopDefault(_newDrawing);
var _newGridItem = require("./new-grid-item");
var _newGridItemDefault = parcelHelpers.interopDefault(_newGridItem);
var _newLayer = require("./new-layer");
var _newLayerDefault = parcelHelpers.interopDefault(_newLayer);
var _newLayers = require("./new-layers");
var _newLayersDefault = parcelHelpers.interopDefault(_newLayers);
var _newLink = require("./new-link");
var _newLinkDefault = parcelHelpers.interopDefault(_newLink);
var _newObject = require("./new-object");
var _newObjectDefault = parcelHelpers.interopDefault(_newObject);
var _newPerson = require("./new-person");
var _newPersonDefault = parcelHelpers.interopDefault(_newPerson);
var _newPrescription = require("./new-prescription");
var _newPrescriptionDefault = parcelHelpers.interopDefault(_newPrescription);
var _newShield = require("./new-shield");
var _newShieldDefault = parcelHelpers.interopDefault(_newShield);
var _newTextBox = require("./new-text-box");
var _newTextBoxDefault = parcelHelpers.interopDefault(_newTextBox);
var _ninja = require("./ninja");
var _ninjaDefault = parcelHelpers.interopDefault(_ninja);
var _notEqualTo = require("./not-equal-to");
var _notEqualToDefault = parcelHelpers.interopDefault(_notEqualTo);
var _notifications = require("./notifications");
var _notificationsDefault = parcelHelpers.interopDefault(_notifications);
var _notificationsSnooze = require("./notifications-snooze");
var _notificationsSnoozeDefault = parcelHelpers.interopDefault(_notificationsSnooze);
var _notificationsUpdated = require("./notifications-updated");
var _notificationsUpdatedDefault = parcelHelpers.interopDefault(_notificationsUpdated);
var _numberedList = require("./numbered-list");
var _numberedListDefault = parcelHelpers.interopDefault(_numberedList);
var _numerical = require("./numerical");
var _numericalDefault = parcelHelpers.interopDefault(_numerical);
var _objectView = require("./object-view");
var _objectViewDefault = parcelHelpers.interopDefault(_objectView);
var _office = require("./office");
var _officeDefault = parcelHelpers.interopDefault(_office);
var _offline = require("./offline");
var _offlineDefault = parcelHelpers.interopDefault(_offline);
var _oilField = require("./oil-field");
var _oilFieldDefault = parcelHelpers.interopDefault(_oilField);
var _oneColumn = require("./one-column");
var _oneColumnDefault = parcelHelpers.interopDefault(_oneColumn);
var _oneToMany = require("./one-to-many");
var _oneToManyDefault = parcelHelpers.interopDefault(_oneToMany);
var _oneToOne = require("./one-to-one");
var _oneToOneDefault = parcelHelpers.interopDefault(_oneToOne);
var _openApplication = require("./open-application");
var _openApplicationDefault = parcelHelpers.interopDefault(_openApplication);
var _outdated = require("./outdated");
var _outdatedDefault = parcelHelpers.interopDefault(_outdated);
var _output = require("./output");
var _outputDefault = parcelHelpers.interopDefault(_output);
var _package = require("./package");
var _packageDefault = parcelHelpers.interopDefault(_package);
var _pageLayout = require("./page-layout");
var _pageLayoutDefault = parcelHelpers.interopDefault(_pageLayout);
var _panel = require("./panel");
var _panelDefault = parcelHelpers.interopDefault(_panel);
var _panelStats = require("./panel-stats");
var _panelStatsDefault = parcelHelpers.interopDefault(_panelStats);
var _panelTable = require("./panel-table");
var _panelTableDefault = parcelHelpers.interopDefault(_panelTable);
var _paperclip = require("./paperclip");
var _paperclipDefault = parcelHelpers.interopDefault(_paperclip);
var _paragraph = require("./paragraph");
var _paragraphDefault = parcelHelpers.interopDefault(_paragraph);
var _pasteVariable = require("./paste-variable");
var _pasteVariableDefault = parcelHelpers.interopDefault(_pasteVariable);
var _path = require("./path");
var _pathDefault = parcelHelpers.interopDefault(_path);
var _pathSearch = require("./path-search");
var _pathSearchDefault = parcelHelpers.interopDefault(_pathSearch);
var _pause = require("./pause");
var _pauseDefault = parcelHelpers.interopDefault(_pause);
var _people = require("./people");
var _peopleDefault = parcelHelpers.interopDefault(_people);
var _percentage = require("./percentage");
var _percentageDefault = parcelHelpers.interopDefault(_percentage);
var _person = require("./person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _phone = require("./phone");
var _phoneDefault = parcelHelpers.interopDefault(_phone);
var _phoneCall = require("./phone-call");
var _phoneCallDefault = parcelHelpers.interopDefault(_phoneCall);
var _phoneForward = require("./phone-forward");
var _phoneForwardDefault = parcelHelpers.interopDefault(_phoneForward);
var _pieChart = require("./pie-chart");
var _pieChartDefault = parcelHelpers.interopDefault(_pieChart);
var _pill = require("./pill");
var _pillDefault = parcelHelpers.interopDefault(_pill);
var _pin = require("./pin");
var _pinDefault = parcelHelpers.interopDefault(_pin);
var _pivot = require("./pivot");
var _pivotDefault = parcelHelpers.interopDefault(_pivot);
var _pivotTable = require("./pivot-table");
var _pivotTableDefault = parcelHelpers.interopDefault(_pivotTable);
var _play = require("./play");
var _playDefault = parcelHelpers.interopDefault(_play);
var _playbook = require("./playbook");
var _playbookDefault = parcelHelpers.interopDefault(_playbook);
var _plus = require("./plus");
var _plusDefault = parcelHelpers.interopDefault(_plus);
var _polygonFilter = require("./polygon-filter");
var _polygonFilterDefault = parcelHelpers.interopDefault(_polygonFilter);
var _power = require("./power");
var _powerDefault = parcelHelpers.interopDefault(_power);
var _predictiveAnalysis = require("./predictive-analysis");
var _predictiveAnalysisDefault = parcelHelpers.interopDefault(_predictiveAnalysis);
var _prescription = require("./prescription");
var _prescriptionDefault = parcelHelpers.interopDefault(_prescription);
var _presentation = require("./presentation");
var _presentationDefault = parcelHelpers.interopDefault(_presentation);
var _print = require("./print");
var _printDefault = parcelHelpers.interopDefault(_print);
var _projects = require("./projects");
var _projectsDefault = parcelHelpers.interopDefault(_projects);
var _properties = require("./properties");
var _propertiesDefault = parcelHelpers.interopDefault(_properties);
var _property = require("./property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _publishFunction = require("./publish-function");
var _publishFunctionDefault = parcelHelpers.interopDefault(_publishFunction);
var _pulse = require("./pulse");
var _pulseDefault = parcelHelpers.interopDefault(_pulse);
var _rain = require("./rain");
var _rainDefault = parcelHelpers.interopDefault(_rain);
var _random = require("./random");
var _randomDefault = parcelHelpers.interopDefault(_random);
var _rangeRing = require("./range-ring");
var _rangeRingDefault = parcelHelpers.interopDefault(_rangeRing);
var _record = require("./record");
var _recordDefault = parcelHelpers.interopDefault(_record);
var _rectHeight = require("./rect-height");
var _rectHeightDefault = parcelHelpers.interopDefault(_rectHeight);
var _rectWidth = require("./rect-width");
var _rectWidthDefault = parcelHelpers.interopDefault(_rectWidth);
var _rectangle = require("./rectangle");
var _rectangleDefault = parcelHelpers.interopDefault(_rectangle);
var _redo = require("./redo");
var _redoDefault = parcelHelpers.interopDefault(_redo);
var _refresh = require("./refresh");
var _refreshDefault = parcelHelpers.interopDefault(_refresh);
var _regex = require("./regex");
var _regexDefault = parcelHelpers.interopDefault(_regex);
var _regressionChart = require("./regression-chart");
var _regressionChartDefault = parcelHelpers.interopDefault(_regressionChart);
var _remove = require("./remove");
var _removeDefault = parcelHelpers.interopDefault(_remove);
var _removeColumn = require("./remove-column");
var _removeColumnDefault = parcelHelpers.interopDefault(_removeColumn);
var _removeColumnLeft = require("./remove-column-left");
var _removeColumnLeftDefault = parcelHelpers.interopDefault(_removeColumnLeft);
var _removeColumnRight = require("./remove-column-right");
var _removeColumnRightDefault = parcelHelpers.interopDefault(_removeColumnRight);
var _removeRowBottom = require("./remove-row-bottom");
var _removeRowBottomDefault = parcelHelpers.interopDefault(_removeRowBottom);
var _removeRowTop = require("./remove-row-top");
var _removeRowTopDefault = parcelHelpers.interopDefault(_removeRowTop);
var _repeat = require("./repeat");
var _repeatDefault = parcelHelpers.interopDefault(_repeat);
var _reset = require("./reset");
var _resetDefault = parcelHelpers.interopDefault(_reset);
var _resolve = require("./resolve");
var _resolveDefault = parcelHelpers.interopDefault(_resolve);
var _rig = require("./rig");
var _rigDefault = parcelHelpers.interopDefault(_rig);
var _rightJoin = require("./right-join");
var _rightJoinDefault = parcelHelpers.interopDefault(_rightJoin);
var _ring = require("./ring");
var _ringDefault = parcelHelpers.interopDefault(_ring);
var _rocket = require("./rocket");
var _rocketDefault = parcelHelpers.interopDefault(_rocket);
var _rocketSlant = require("./rocket-slant");
var _rocketSlantDefault = parcelHelpers.interopDefault(_rocketSlant);
var _rotateCcw = require("./rotate-ccw");
var _rotateCcwDefault = parcelHelpers.interopDefault(_rotateCcw);
var _rotateCw = require("./rotate-cw");
var _rotateCwDefault = parcelHelpers.interopDefault(_rotateCw);
var _rotateDocument = require("./rotate-document");
var _rotateDocumentDefault = parcelHelpers.interopDefault(_rotateDocument);
var _rotatePage = require("./rotate-page");
var _rotatePageDefault = parcelHelpers.interopDefault(_rotatePage);
var _route = require("./route");
var _routeDefault = parcelHelpers.interopDefault(_route);
var _satellite = require("./satellite");
var _satelliteDefault = parcelHelpers.interopDefault(_satellite);
var _saved = require("./saved");
var _savedDefault = parcelHelpers.interopDefault(_saved);
var _scatterPlot = require("./scatter-plot");
var _scatterPlotDefault = parcelHelpers.interopDefault(_scatterPlot);
var _search = require("./search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _searchAround = require("./search-around");
var _searchAroundDefault = parcelHelpers.interopDefault(_searchAround);
var _searchTemplate = require("./search-template");
var _searchTemplateDefault = parcelHelpers.interopDefault(_searchTemplate);
var _searchText = require("./search-text");
var _searchTextDefault = parcelHelpers.interopDefault(_searchText);
var _segmentedControl = require("./segmented-control");
var _segmentedControlDefault = parcelHelpers.interopDefault(_segmentedControl);
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _selection = require("./selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _sendBackward = require("./send-backward");
var _sendBackwardDefault = parcelHelpers.interopDefault(_sendBackward);
var _sendMessage = require("./send-message");
var _sendMessageDefault = parcelHelpers.interopDefault(_sendMessage);
var _sendTo = require("./send-to");
var _sendToDefault = parcelHelpers.interopDefault(_sendTo);
var _sendToGraph = require("./send-to-graph");
var _sendToGraphDefault = parcelHelpers.interopDefault(_sendToGraph);
var _sendToMap = require("./send-to-map");
var _sendToMapDefault = parcelHelpers.interopDefault(_sendToMap);
var _sensor = require("./sensor");
var _sensorDefault = parcelHelpers.interopDefault(_sensor);
var _seriesAdd = require("./series-add");
var _seriesAddDefault = parcelHelpers.interopDefault(_seriesAdd);
var _seriesConfiguration = require("./series-configuration");
var _seriesConfigurationDefault = parcelHelpers.interopDefault(_seriesConfiguration);
var _seriesDerived = require("./series-derived");
var _seriesDerivedDefault = parcelHelpers.interopDefault(_seriesDerived);
var _seriesFiltered = require("./series-filtered");
var _seriesFilteredDefault = parcelHelpers.interopDefault(_seriesFiltered);
var _seriesSearch = require("./series-search");
var _seriesSearchDefault = parcelHelpers.interopDefault(_seriesSearch);
var _server = require("./server");
var _serverDefault = parcelHelpers.interopDefault(_server);
var _serverInstall = require("./server-install");
var _serverInstallDefault = parcelHelpers.interopDefault(_serverInstall);
var _settings = require("./settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _shapes = require("./shapes");
var _shapesDefault = parcelHelpers.interopDefault(_shapes);
var _share = require("./share");
var _shareDefault = parcelHelpers.interopDefault(_share);
var _sharedFilter = require("./shared-filter");
var _sharedFilterDefault = parcelHelpers.interopDefault(_sharedFilter);
var _shield = require("./shield");
var _shieldDefault = parcelHelpers.interopDefault(_shield);
var _ship = require("./ship");
var _shipDefault = parcelHelpers.interopDefault(_ship);
var _shop = require("./shop");
var _shopDefault = parcelHelpers.interopDefault(_shop);
var _shoppingCart = require("./shopping-cart");
var _shoppingCartDefault = parcelHelpers.interopDefault(_shoppingCart);
var _shortenText = require("./shorten-text");
var _shortenTextDefault = parcelHelpers.interopDefault(_shortenText);
var _signalSearch = require("./signal-search");
var _signalSearchDefault = parcelHelpers.interopDefault(_signalSearch);
var _simCard = require("./sim-card");
var _simCardDefault = parcelHelpers.interopDefault(_simCard);
var _slash = require("./slash");
var _slashDefault = parcelHelpers.interopDefault(_slash);
var _smallCross = require("./small-cross");
var _smallCrossDefault = parcelHelpers.interopDefault(_smallCross);
var _smallInfoSign = require("./small-info-sign");
var _smallInfoSignDefault = parcelHelpers.interopDefault(_smallInfoSign);
var _smallMinus = require("./small-minus");
var _smallMinusDefault = parcelHelpers.interopDefault(_smallMinus);
var _smallPlus = require("./small-plus");
var _smallPlusDefault = parcelHelpers.interopDefault(_smallPlus);
var _smallSquare = require("./small-square");
var _smallSquareDefault = parcelHelpers.interopDefault(_smallSquare);
var _smallTick = require("./small-tick");
var _smallTickDefault = parcelHelpers.interopDefault(_smallTick);
var _snowflake = require("./snowflake");
var _snowflakeDefault = parcelHelpers.interopDefault(_snowflake);
var _soccerBall = require("./soccer-ball");
var _soccerBallDefault = parcelHelpers.interopDefault(_soccerBall);
var _socialMedia = require("./social-media");
var _socialMediaDefault = parcelHelpers.interopDefault(_socialMedia);
var _sort = require("./sort");
var _sortDefault = parcelHelpers.interopDefault(_sort);
var _sortAlphabetical = require("./sort-alphabetical");
var _sortAlphabeticalDefault = parcelHelpers.interopDefault(_sortAlphabetical);
var _sortAlphabeticalDesc = require("./sort-alphabetical-desc");
var _sortAlphabeticalDescDefault = parcelHelpers.interopDefault(_sortAlphabeticalDesc);
var _sortAsc = require("./sort-asc");
var _sortAscDefault = parcelHelpers.interopDefault(_sortAsc);
var _sortDesc = require("./sort-desc");
var _sortDescDefault = parcelHelpers.interopDefault(_sortDesc);
var _sortNumerical = require("./sort-numerical");
var _sortNumericalDefault = parcelHelpers.interopDefault(_sortNumerical);
var _sortNumericalDesc = require("./sort-numerical-desc");
var _sortNumericalDescDefault = parcelHelpers.interopDefault(_sortNumericalDesc);
var _spellCheck = require("./spell-check");
var _spellCheckDefault = parcelHelpers.interopDefault(_spellCheck);
var _splitColumns = require("./split-columns");
var _splitColumnsDefault = parcelHelpers.interopDefault(_splitColumns);
var _sportsStadium = require("./sports-stadium");
var _sportsStadiumDefault = parcelHelpers.interopDefault(_sportsStadium);
var _square = require("./square");
var _squareDefault = parcelHelpers.interopDefault(_square);
var _stackedChart = require("./stacked-chart");
var _stackedChartDefault = parcelHelpers.interopDefault(_stackedChart);
var _stadiumGeometry = require("./stadium-geometry");
var _stadiumGeometryDefault = parcelHelpers.interopDefault(_stadiumGeometry);
var _star = require("./star");
var _starDefault = parcelHelpers.interopDefault(_star);
var _starEmpty = require("./star-empty");
var _starEmptyDefault = parcelHelpers.interopDefault(_starEmpty);
var _stepBackward = require("./step-backward");
var _stepBackwardDefault = parcelHelpers.interopDefault(_stepBackward);
var _stepChart = require("./step-chart");
var _stepChartDefault = parcelHelpers.interopDefault(_stepChart);
var _stepForward = require("./step-forward");
var _stepForwardDefault = parcelHelpers.interopDefault(_stepForward);
var _stop = require("./stop");
var _stopDefault = parcelHelpers.interopDefault(_stop);
var _stopwatch = require("./stopwatch");
var _stopwatchDefault = parcelHelpers.interopDefault(_stopwatch);
var _strikethrough = require("./strikethrough");
var _strikethroughDefault = parcelHelpers.interopDefault(_strikethrough);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _subscript = require("./subscript");
var _subscriptDefault = parcelHelpers.interopDefault(_subscript);
var _superscript = require("./superscript");
var _superscriptDefault = parcelHelpers.interopDefault(_superscript);
var _swapHorizontal = require("./swap-horizontal");
var _swapHorizontalDefault = parcelHelpers.interopDefault(_swapHorizontal);
var _swapVertical = require("./swap-vertical");
var _swapVerticalDefault = parcelHelpers.interopDefault(_swapVertical);
var _switch = require("./switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _symbolCircle = require("./symbol-circle");
var _symbolCircleDefault = parcelHelpers.interopDefault(_symbolCircle);
var _symbolCross = require("./symbol-cross");
var _symbolCrossDefault = parcelHelpers.interopDefault(_symbolCross);
var _symbolDiamond = require("./symbol-diamond");
var _symbolDiamondDefault = parcelHelpers.interopDefault(_symbolDiamond);
var _symbolRectangle = require("./symbol-rectangle");
var _symbolRectangleDefault = parcelHelpers.interopDefault(_symbolRectangle);
var _symbolSquare = require("./symbol-square");
var _symbolSquareDefault = parcelHelpers.interopDefault(_symbolSquare);
var _symbolTriangleDown = require("./symbol-triangle-down");
var _symbolTriangleDownDefault = parcelHelpers.interopDefault(_symbolTriangleDown);
var _symbolTriangleUp = require("./symbol-triangle-up");
var _symbolTriangleUpDefault = parcelHelpers.interopDefault(_symbolTriangleUp);
var _syringe = require("./syringe");
var _syringeDefault = parcelHelpers.interopDefault(_syringe);
var _tableSync = require("./table-sync");
var _tableSyncDefault = parcelHelpers.interopDefault(_tableSync);
var _tag = require("./tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _tagAdd = require("./tag-add");
var _tagAddDefault = parcelHelpers.interopDefault(_tagAdd);
var _tagPromote = require("./tag-promote");
var _tagPromoteDefault = parcelHelpers.interopDefault(_tagPromote);
var _tagRefresh = require("./tag-refresh");
var _tagRefreshDefault = parcelHelpers.interopDefault(_tagRefresh);
var _tagUndo = require("./tag-undo");
var _tagUndoDefault = parcelHelpers.interopDefault(_tagUndo);
var _tags = require("./tags");
var _tagsDefault = parcelHelpers.interopDefault(_tags);
var _takeAction = require("./take-action");
var _takeActionDefault = parcelHelpers.interopDefault(_takeAction);
var _tank = require("./tank");
var _tankDefault = parcelHelpers.interopDefault(_tank);
var _target = require("./target");
var _targetDefault = parcelHelpers.interopDefault(_target);
var _taxi = require("./taxi");
var _taxiDefault = parcelHelpers.interopDefault(_taxi);
var _team = require("./team");
var _teamDefault = parcelHelpers.interopDefault(_team);
var _temperature = require("./temperature");
var _temperatureDefault = parcelHelpers.interopDefault(_temperature);
var _textHighlight = require("./text-highlight");
var _textHighlightDefault = parcelHelpers.interopDefault(_textHighlight);
var _th = require("./th");
var _thDefault = parcelHelpers.interopDefault(_th);
var _thAdd = require("./th-add");
var _thAddDefault = parcelHelpers.interopDefault(_thAdd);
var _thDerived = require("./th-derived");
var _thDerivedDefault = parcelHelpers.interopDefault(_thDerived);
var _thDisconnect = require("./th-disconnect");
var _thDisconnectDefault = parcelHelpers.interopDefault(_thDisconnect);
var _thFiltered = require("./th-filtered");
var _thFilteredDefault = parcelHelpers.interopDefault(_thFiltered);
var _thList = require("./th-list");
var _thListDefault = parcelHelpers.interopDefault(_thList);
var _thListAdd = require("./th-list-add");
var _thListAddDefault = parcelHelpers.interopDefault(_thListAdd);
var _thVirtual = require("./th-virtual");
var _thVirtualDefault = parcelHelpers.interopDefault(_thVirtual);
var _thVirtualAdd = require("./th-virtual-add");
var _thVirtualAddDefault = parcelHelpers.interopDefault(_thVirtualAdd);
var _thirdParty = require("./third-party");
var _thirdPartyDefault = parcelHelpers.interopDefault(_thirdParty);
var _thumbsDown = require("./thumbs-down");
var _thumbsDownDefault = parcelHelpers.interopDefault(_thumbsDown);
var _thumbsUp = require("./thumbs-up");
var _thumbsUpDefault = parcelHelpers.interopDefault(_thumbsUp);
var _tick = require("./tick");
var _tickDefault = parcelHelpers.interopDefault(_tick);
var _tickCircle = require("./tick-circle");
var _tickCircleDefault = parcelHelpers.interopDefault(_tickCircle);
var _time = require("./time");
var _timeDefault = parcelHelpers.interopDefault(_time);
var _timelineAreaChart = require("./timeline-area-chart");
var _timelineAreaChartDefault = parcelHelpers.interopDefault(_timelineAreaChart);
var _timelineBarChart = require("./timeline-bar-chart");
var _timelineBarChartDefault = parcelHelpers.interopDefault(_timelineBarChart);
var _timelineEvents = require("./timeline-events");
var _timelineEventsDefault = parcelHelpers.interopDefault(_timelineEvents);
var _timelineLineChart = require("./timeline-line-chart");
var _timelineLineChartDefault = parcelHelpers.interopDefault(_timelineLineChart);
var _tint = require("./tint");
var _tintDefault = parcelHelpers.interopDefault(_tint);
var _torch = require("./torch");
var _torchDefault = parcelHelpers.interopDefault(_torch);
var _tractor = require("./tractor");
var _tractorDefault = parcelHelpers.interopDefault(_tractor);
var _train = require("./train");
var _trainDefault = parcelHelpers.interopDefault(_train);
var _translate = require("./translate");
var _translateDefault = parcelHelpers.interopDefault(_translate);
var _trash = require("./trash");
var _trashDefault = parcelHelpers.interopDefault(_trash);
var _tree = require("./tree");
var _treeDefault = parcelHelpers.interopDefault(_tree);
var _trendingDown = require("./trending-down");
var _trendingDownDefault = parcelHelpers.interopDefault(_trendingDown);
var _trendingUp = require("./trending-up");
var _trendingUpDefault = parcelHelpers.interopDefault(_trendingUp);
var _trophy = require("./trophy");
var _trophyDefault = parcelHelpers.interopDefault(_trophy);
var _truck = require("./truck");
var _truckDefault = parcelHelpers.interopDefault(_truck);
var _twoColumns = require("./two-columns");
var _twoColumnsDefault = parcelHelpers.interopDefault(_twoColumns);
var _unarchive = require("./unarchive");
var _unarchiveDefault = parcelHelpers.interopDefault(_unarchive);
var _underline = require("./underline");
var _underlineDefault = parcelHelpers.interopDefault(_underline);
var _undo = require("./undo");
var _undoDefault = parcelHelpers.interopDefault(_undo);
var _ungroupObjects = require("./ungroup-objects");
var _ungroupObjectsDefault = parcelHelpers.interopDefault(_ungroupObjects);
var _unknownVehicle = require("./unknown-vehicle");
var _unknownVehicleDefault = parcelHelpers.interopDefault(_unknownVehicle);
var _unlink = require("./unlink");
var _unlinkDefault = parcelHelpers.interopDefault(_unlink);
var _unlock = require("./unlock");
var _unlockDefault = parcelHelpers.interopDefault(_unlock);
var _unpin = require("./unpin");
var _unpinDefault = parcelHelpers.interopDefault(_unpin);
var _unresolve = require("./unresolve");
var _unresolveDefault = parcelHelpers.interopDefault(_unresolve);
var _updated = require("./updated");
var _updatedDefault = parcelHelpers.interopDefault(_updated);
var _upload = require("./upload");
var _uploadDefault = parcelHelpers.interopDefault(_upload);
var _user = require("./user");
var _userDefault = parcelHelpers.interopDefault(_user);
var _variable = require("./variable");
var _variableDefault = parcelHelpers.interopDefault(_variable);
var _vector = require("./vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _verticalBarChartAsc = require("./vertical-bar-chart-asc");
var _verticalBarChartAscDefault = parcelHelpers.interopDefault(_verticalBarChartAsc);
var _verticalBarChartDesc = require("./vertical-bar-chart-desc");
var _verticalBarChartDescDefault = parcelHelpers.interopDefault(_verticalBarChartDesc);
var _verticalDistribution = require("./vertical-distribution");
var _verticalDistributionDefault = parcelHelpers.interopDefault(_verticalDistribution);
var _verticalInbetween = require("./vertical-inbetween");
var _verticalInbetweenDefault = parcelHelpers.interopDefault(_verticalInbetween);
var _video = require("./video");
var _videoDefault = parcelHelpers.interopDefault(_video);
var _virus = require("./virus");
var _virusDefault = parcelHelpers.interopDefault(_virus);
var _volumeDown = require("./volume-down");
var _volumeDownDefault = parcelHelpers.interopDefault(_volumeDown);
var _volumeOff = require("./volume-off");
var _volumeOffDefault = parcelHelpers.interopDefault(_volumeOff);
var _volumeUp = require("./volume-up");
var _volumeUpDefault = parcelHelpers.interopDefault(_volumeUp);
var _walk = require("./walk");
var _walkDefault = parcelHelpers.interopDefault(_walk);
var _warningSign = require("./warning-sign");
var _warningSignDefault = parcelHelpers.interopDefault(_warningSign);
var _waterfallChart = require("./waterfall-chart");
var _waterfallChartDefault = parcelHelpers.interopDefault(_waterfallChart);
var _waves = require("./waves");
var _wavesDefault = parcelHelpers.interopDefault(_waves);
var _widget = require("./widget");
var _widgetDefault = parcelHelpers.interopDefault(_widget);
var _widgetButton = require("./widget-button");
var _widgetButtonDefault = parcelHelpers.interopDefault(_widgetButton);
var _widgetFooter = require("./widget-footer");
var _widgetFooterDefault = parcelHelpers.interopDefault(_widgetFooter);
var _widgetHeader = require("./widget-header");
var _widgetHeaderDefault = parcelHelpers.interopDefault(_widgetHeader);
var _wind = require("./wind");
var _windDefault = parcelHelpers.interopDefault(_wind);
var _wrench = require("./wrench");
var _wrenchDefault = parcelHelpers.interopDefault(_wrench);
var _wrenchRedo = require("./wrench-redo");
var _wrenchRedoDefault = parcelHelpers.interopDefault(_wrenchRedo);
var _wrenchSnooze = require("./wrench-snooze");
var _wrenchSnoozeDefault = parcelHelpers.interopDefault(_wrenchSnooze);
var _wrenchTime = require("./wrench-time");
var _wrenchTimeDefault = parcelHelpers.interopDefault(_wrenchTime);
var _zoomIn = require("./zoom-in");
var _zoomInDefault = parcelHelpers.interopDefault(_zoomIn);
var _zoomOut = require("./zoom-out");
var _zoomOutDefault = parcelHelpers.interopDefault(_zoomOut);
var _zoomToFit = require("./zoom-to-fit");
var _zoomToFitDefault = parcelHelpers.interopDefault(_zoomToFit);

},{"./add":"bDpid","./add-clip":"cz8U3","./add-column-left":"6w4j9","./add-column-right":"ckukQ","./add-location":"lNvYq","./add-row-bottom":"kCWBC","./add-row-top":"ADddz","./add-to-artifact":"dmAjO","./add-to-folder":"6Kk0M","./aimpoints-target":"ceBYG","./airplane":"kBlJi","./align-center":"h82NL","./align-justify":"gUbUT","./align-left":"6uI8O","./align-right":"4sg9t","./alignment-bottom":"8mMfS","./alignment-horizontal-center":"2su67","./alignment-left":"1Glym","./alignment-right":"bLKVI","./alignment-top":"iPxsG","./alignment-vertical-center":"dq3H9","./ammunition":"ecI20","./anchor":"kScJz","./annotation":"0XkGR","./antenna":"9NphX","./app-header":"f6Itm","./application":"5NEvh","./applications":"l6Sxn","./archive":"kDIZu","./area-of-interest":"8LX9q","./array":"fcLOt","./array-boolean":"25oRC","./array-date":"ldTdV","./array-floating-point":"37MOW","./array-numeric":"gOi7H","./array-string":"gKDBt","./array-timestamp":"gmNNq","./arrow-bottom-left":"dMaAk","./arrow-bottom-right":"jHaet","./arrow-down":"l3ypQ","./arrow-left":"eK5pe","./arrow-right":"chIKz","./arrow-top-left":"8Klg3","./arrow-top-right":"h0pHD","./arrow-up":"bksol","./arrows-arc":"hVGKR","./arrows-horizontal":"7xIUR","./arrows-vertical":"3eAG5","./asterisk":"f1iPv","./at":"kJ5yG","./automatic-updates":"7iVEd","./axle":"2dE3x","./backlink":"9RQSs","./backward-ten":"3EDiy","./badge":"kXSAV","./ban-circle":"l8FVr","./bank-account":"WVS96","./barcode":"04xwZ","./binary-number":"dmbME","./blank":"fQHAm","./block-promote":"jQeVV","./blocked-person":"1GDFQ","./bold":"ePeFx","./book":"8H82G","./bookmark":"gdOrr","./box":"dU9AT","./briefcase":"70L4F","./bring-data":"grJho","./bring-forward":"f92WE","./british-pound":"fzkWW","./bug":"l3uEZ","./buggy":"3C5PP","./build":"kzQWX","./bullseye":"iuFdK","./calculator":"lHlg2","./calendar":"5XU47","./camera":"3mA4o","./caret-down":"cCjAK","./caret-left":"eL6OE","./caret-right":"esewh","./caret-up":"bJ1GM","./cargo-ship":"36Iy5","./cell-tower":"j7aoL","./changes":"iDCnO","./chart":"6jOQh","./chat":"ecrGo","./chevron-backward":"1JmPO","./chevron-down":"4SQkv","./chevron-forward":"bPFgU","./chevron-left":"86x9Z","./chevron-right":"gf5MI","./chevron-up":"dUhad","./circle":"jR1rj","./circle-arrow-down":"kJwqy","./circle-arrow-left":"eXWmc","./circle-arrow-right":"hXHwM","./circle-arrow-up":"8U7ar","./citation":"Qej5v","./clean":"3B3R7","./clip":"05gRP","./clipboard":"9UqUd","./clipboard-file":"4mbom","./cloud":"jdiyB","./cloud-download":"io0Io","./cloud-server":"3BCfV","./cloud-tick":"479Nv","./cloud-upload":"7ryo4","./code":"levLG","./code-block":"glx6G","./cog":"8yPcQ","./collapse-all":"imGZJ","./color-fill":"f9PhO","./column-layout":"kowsQ","./comment":"4vCUS","./comparison":"kzRFp","./compass":"da9Bm","./compressed":"ka5lP","./confirm":"6HcAn","./console":"aZSpx","./contrast":"74lAp","./control":"646KS","./credit-card":"hIGSA","./crop":"9V8q2","./cross":"85xmf","./cross-circle":"hQzEJ","./crown":"k2h4W","./css-style":"3Nixv","./cube":"jlcX6","./cube-add":"52BNC","./cube-edit":"fRGce","./cube-remove":"b3Bkj","./cubes":"8Fx7Q","./curly-braces":"20clI","./curved-range-chart":"agZKL","./cut":"dzjiG","./cycle":"1LBik","./dashboard":"iJ4VJ","./data-connection":"3F2S5","./data-lineage":"kzuov","./data-search":"1sgY1","./data-sync":"eQvvF","./database":"deDRR","./delete":"dikaW","./delta":"7Jshj","./derive-column":"k7VPx","./desktop":"7WAE6","./detection":"7HwJS","./diagnosis":"eQNMa","./diagram-tree":"ddpuH","./direction-left":"5h2lJ","./direction-right":"5zr2T","./disable":"6bCjt","./divide":"sW5CW","./document":"cOLpJ","./document-open":"htwM4","./document-share":"3zNha","./dollar":"8ULKq","./dot":"fjwJE","./double-caret-horizontal":"lu7Bn","./double-caret-vertical":"1yjkK","./double-chevron-down":"iMpoF","./double-chevron-left":"2pJmp","./double-chevron-right":"8MoGk","./double-chevron-up":"cJ2xi","./doughnut-chart":"kc1Rm","./download":"8SU7R","./drag-handle-horizontal":"kGRPY","./drag-handle-vertical":"6ctjb","./draw":"3wmca","./drawer-left":"dnW9N","./drawer-left-filled":"k7U6E","./drawer-right":"dSEd8","./drawer-right-filled":"zQiAd","./drive-time":"3NmCq","./duplicate":"376Y3","./edit":"kGxHJ","./eject":"l1gOR","./emoji":"cLURU","./endnote":"fmfnj","./endorsed":"1SYHD","./envelope":"6L26w","./equals":"fRcfF","./eraser":"e7e4m","./error":"c7671","./euro":"iwubA","./excavator":"2nO1F","./exchange":"grn2O","./exclude-row":"1ztdJ","./expand-all":"4FeDv","./explain":"bbzHK","./export":"6Kcbd","./eye-off":"eq0We","./eye-on":"gGGUq","./eye-open":"kLQa3","./fast-backward":"fHxK4","./fast-forward":"j1uN0","./feed":"bgrRt","./feed-subscribed":"hDik7","./fighter-jet":"cXRJy","./film":"2IPq0","./filter":"6xhUL","./filter-keep":"eM1i5","./filter-list":"7myzg","./filter-open":"759iZ","./filter-remove":"1AGCB","./filter-sort-asc":"fw0BJ","./filter-sort-desc":"8xFEH","./flag":"J3HD6","./flame":"3qNWf","./flash":"fnIVV","./floating-point":"hTUCy","./floppy-disk":"fE3rY","./flow-branch":"aH1cF","./flow-end":"dPP6E","./flow-linear":"b6sU3","./flow-review":"2RbsJ","./flow-review-branch":"bLA46","./flows":"9LQGI","./folder-close":"9JcXp","./folder-new":"ff2Mk","./folder-open":"5y2jj","./folder-shared":"kuWMP","./folder-shared-open":"fyD11","./follower":"8w1Pz","./following":"F8IW5","./font":"5CwfR","./fork":"ixhCm","./form":"4PBfn","./forward-ten":"7BQXb","./fuel":"9w9Kz","./full-circle":"lg1sK","./full-stacked-chart":"4GucW","./fullscreen":"fsht4","./function":"e3m3t","./gantt-chart":"6xRXE","./generate":"8M4r5","./geofence":"gDBI7","./geolocation":"fTToL","./geosearch":"6GEZN","./geotime":"9Jm0Q","./git-branch":"7Y2Bl","./git-commit":"7rNAB","./git-merge":"kkU0A","./git-new-branch":"kI3Jv","./git-pull":"8OvDd","./git-push":"gdmPZ","./git-repo":"5KEgY","./glass":"haIAs","./globe":"ddtp9","./globe-network":"hO5vO","./globe-network-add":"bS5vy","./graph":"6fBHt","./graph-remove":"5qbq4","./greater-than":"1oJTO","./greater-than-or-equal-to":"iFB7U","./grid":"6Fn0o","./grid-view":"aJaej","./group-item":"hBJY1","./group-objects":"2l0Sf","./grouped-bar-chart":"j9dwt","./hand":"2PnuF","./hand-down":"9yFma","./hand-left":"amvZB","./hand-right":"fT7wp","./hand-up":"7cDD3","./hat":"51KEm","./header":"fxmxU","./header-one":"syqnp","./header-three":"bL1Wk","./header-two":"908vC","./headset":"ikehX","./heart":"9wlmL","./heart-broken":"bToMG","./heat-grid":"gcOIr","./heatmap":"fNXuH","./helicopter":"4TwHs","./help":"buAxm","./helper-management":"jk4Jm","./hexagon":"lJdxk","./high-priority":"2Ivtc","./high-voltage-pole":"5fHnO","./highlight":"cJNhZ","./history":"7w6Se","./home":"juJt1","./horizontal-bar-chart":"5Kt8L","./horizontal-bar-chart-asc":"33pih","./horizontal-bar-chart-desc":"8WGGg","./horizontal-distribution":"abrxW","./horizontal-inbetween":"8LIO9","./hurricane":"g7zVf","./id-number":"4dDBC","./image-rotate-left":"7VxAG","./image-rotate-right":"eP4Lt","./import":"4OgCt","./inbox":"iVlHh","./inbox-filtered":"1H1tE","./inbox-geo":"9cmIn","./inbox-search":"9kUPP","./inbox-update":"6VBzo","./info-sign":"dCINI","./inheritance":"7xj1X","./inherited-group":"am6x3","./inner-join":"37UY3","./input":"42o2K","./insert":"6Cieu","./intelligence":"1t4EY","./intersection":"04UWV","./ip-address":"3Rbtl","./issue":"bvQDm","./issue-closed":"b0Adb","./issue-new":"kxoxe","./italic":"cOuZx","./join-table":"c4idB","./key":"hwiGJ","./key-backspace":"8iTzS","./key-command":"ih5KU","./key-control":"3K4jq","./key-delete":"2hArD","./key-enter":"2xsUP","./key-escape":"8MpE9","./key-option":"hUJ3t","./key-shift":"6K9dE","./key-tab":"ito0y","./known-vehicle":"5YEbU","./lab-test":"eQi57","./label":"iorkp","./layer":"hYPry","./layer-outline":"ejMGs","./layers":"aRR8g","./layout":"eCxiK","./layout-auto":"fzuSC","./layout-balloon":"fG8Ke","./layout-bottom-row-three-tiles":"16XPk","./layout-bottom-row-two-tiles":"iQSs3","./layout-circle":"kekLH","./layout-grid":"4p5aX","./layout-group-by":"l2mtf","./layout-hierarchy":"lEhAW","./layout-left-column-three-tiles":"7rKyj","./layout-left-column-two-tiles":"kTFD5","./layout-linear":"cg4Ta","./layout-right-column-three-tiles":"lLCox","./layout-right-column-two-tiles":"h4cYv","./layout-skew-grid":"7PuKT","./layout-sorted-clusters":"8hORe","./layout-three-columns":"fpCNR","./layout-three-rows":"fDkX3","./layout-top-row-three-tiles":"YUZkU","./layout-top-row-two-tiles":"aZrV8","./layout-two-columns":"69F3R","./layout-two-rows":"ak5Po","./learning":"9DXLl","./left-join":"ew5Go","./lengthen-text":"aXN3i","./less-than":"1zhKg","./less-than-or-equal-to":"6xAfl","./lifesaver":"f2ztt","./lightbulb":"8lvzN","./lightning":"c0Tly","./link":"148CP","./linked-squares":"bQ0Bj","./list":"hdFwb","./list-columns":"hNgUQ","./list-detail-view":"lCnCb","./locate":"bdrYW","./lock":"i817y","./locomotive":"eJ1WO","./log-in":"cySYc","./log-out":"8Sed3","./low-voltage-pole":"9D9im","./manual":"gMHcT","./manually-entered-data":"7txwP","./many-to-many":"dITrN","./many-to-one":"e1ORT","./map":"3QXQ3","./map-create":"6VERm","./map-marker":"9m6Al","./maximize":"1ypIk","./media":"6afvH","./menu":"gs8Az","./menu-closed":"8QSbG","./menu-open":"65Y9O","./merge-columns":"h9fct","./merge-links":"cnrzo","./microphone":"99ZBx","./minimize":"gecer","./minus":"15ZVa","./mobile-phone":"4n3Iu","./mobile-video":"bKNzo","./modal":"3BiXQ","./modal-filled":"jNkk6","./model":"kcSgF","./moon":"8hz2b","./more":"99Zti","./mountain":"198Iz","./move":"dOOwK","./mugshot":"gVJjy","./multi-select":"72KKT","./music":"jP2DM","./nest":"j9moZ","./new-drawing":"9bDhw","./new-grid-item":"bszRS","./new-layer":"8x9nZ","./new-layers":"f6k6K","./new-link":"1tdyr","./new-object":"21Uy1","./new-person":"aSROd","./new-prescription":"cLz1w","./new-shield":"9zcc3","./new-text-box":"4dxQ0","./ninja":"iTSZ1","./not-equal-to":"aQ0W1","./notifications":"4rr6w","./notifications-snooze":"4s1Ip","./notifications-updated":"c7PQt","./numbered-list":"1k3xY","./numerical":"a8L2e","./object-view":"6BBup","./office":"7R3xa","./offline":"jOUIa","./oil-field":"eu4ZI","./one-column":"35kSx","./one-to-many":"hqih4","./one-to-one":"5SKOw","./open-application":"bQGnL","./outdated":"d5ydO","./output":"ddPZ5","./package":"6xHiy","./page-layout":"8oo5X","./panel":"cl2bz","./panel-stats":"79elX","./panel-table":"gqyRn","./paperclip":"e9z44","./paragraph":"8cxtn","./paste-variable":"dKtkP","./path":"4E0nf","./path-search":"bxgQW","./pause":"45LmF","./people":"lAV7g","./percentage":"13OXo","./person":"3QPPB","./phone":"75iFE","./phone-call":"iSnlX","./phone-forward":"71pbm","./pie-chart":"2OH21","./pill":"dtH9N","./pin":"hLaKB","./pivot":"3WEAl","./pivot-table":"5YQ4l","./play":"4GIIO","./playbook":"lefYD","./plus":"fP0Ut","./polygon-filter":"4b27Z","./power":"chqxt","./predictive-analysis":"efnIT","./prescription":"1SnUD","./presentation":"ccZEN","./print":"b2Rhv","./projects":"1fgQs","./properties":"3Sl5D","./property":"96dqD","./publish-function":"5ZyTZ","./pulse":"2AgTl","./rain":"jrH82","./random":"2VxLg","./range-ring":"7kAyi","./record":"aLcxO","./rect-height":"hfx1q","./rect-width":"kzNsc","./rectangle":"c2oxl","./redo":"jjvke","./refresh":"fKlb1","./regex":"h7iiE","./regression-chart":"k3VVb","./remove":"k0RSb","./remove-column":"4Fl7I","./remove-column-left":"9MGyw","./remove-column-right":"ekEtn","./remove-row-bottom":"bu22x","./remove-row-top":"czwq2","./repeat":"bNi0X","./reset":"hUEHv","./resolve":"ixfq8","./rig":"hsMPH","./right-join":"dClNP","./ring":"9WwMs","./rocket":"bCqbO","./rocket-slant":"W6Qkk","./rotate-ccw":"7QyPC","./rotate-cw":"ihkNE","./rotate-document":"bBpZO","./rotate-page":"gyAw3","./route":"4m9QH","./satellite":"N5UPY","./saved":"ilOp4","./scatter-plot":"7MiyS","./search":"7R6Ia","./search-around":"7iqBt","./search-template":"5i55n","./search-text":"lRXaW","./segmented-control":"i5SHd","./select":"gNhir","./selection":"75tiA","./send-backward":"8XuLD","./send-message":"fb3rG","./send-to":"7vNqV","./send-to-graph":"1cFJ4","./send-to-map":"1UG1G","./sensor":"5teTy","./series-add":"1Nmgm","./series-configuration":"aOmB7","./series-derived":"96vOL","./series-filtered":"4RK1F","./series-search":"h9bKm","./server":"2a7AI","./server-install":"dGm3G","./settings":"cZbtc","./shapes":"dWKHt","./share":"gcj5J","./shared-filter":"dzTN5","./shield":"esx8N","./ship":"4ldx6","./shop":"Aiubq","./shopping-cart":"hOn17","./shorten-text":"1AB9m","./signal-search":"jHxro","./sim-card":"6HfKc","./slash":"3RDrF","./small-cross":"cyN2G","./small-info-sign":"693F6","./small-minus":"f4QCp","./small-plus":"64fRg","./small-square":"4XaHv","./small-tick":"4glgh","./snowflake":"eSfNc","./soccer-ball":"cGWFS","./social-media":"hQXkD","./sort":"dt4Kg","./sort-alphabetical":"83QEn","./sort-alphabetical-desc":"lU9xU","./sort-asc":"LUDum","./sort-desc":"dlJk7","./sort-numerical":"jg1J1","./sort-numerical-desc":"iLHAR","./spell-check":"j35Jk","./split-columns":"4W1Vb","./sports-stadium":"4eQpW","./square":"1D44N","./stacked-chart":"fgyNq","./stadium-geometry":"cFlzI","./star":"hHbJZ","./star-empty":"1xDCj","./step-backward":"jflGV","./step-chart":"alVMC","./step-forward":"7E09J","./stop":"a7Yp5","./stopwatch":"iuXuS","./strikethrough":"61dFc","./style":"j7u5v","./subscript":"4cqWr","./superscript":"9eVs4","./swap-horizontal":"5kRQ0","./swap-vertical":"vJ9fI","./switch":"bYiBg","./symbol-circle":"cGZ5q","./symbol-cross":"koht5","./symbol-diamond":"5PNwl","./symbol-rectangle":"g18NR","./symbol-square":"yKaXs","./symbol-triangle-down":"6U4Oa","./symbol-triangle-up":"h0Ubm","./syringe":"dLxdr","./table-sync":"kLb2g","./tag":"99MTB","./tag-add":"f7xsT","./tag-promote":"fsMYT","./tag-refresh":"9rQ8R","./tag-undo":"8RmxK","./tags":"gQYTL","./take-action":"S4zYr","./tank":"2XIQm","./target":"1lFSh","./taxi":"geads","./team":"6Ya0g","./temperature":"5OYfO","./text-highlight":"l8kR0","./th":"gpFAV","./th-add":"f3P0X","./th-derived":"kYPJD","./th-disconnect":"j130S","./th-filtered":"3fSHC","./th-list":"iY9iB","./th-list-add":"20Hg0","./th-virtual":"7aFa7","./th-virtual-add":"1sIT2","./third-party":"atR5H","./thumbs-down":"3pPC1","./thumbs-up":"4V40g","./tick":"4Fp6m","./tick-circle":"dYLhZ","./time":"lD8z0","./timeline-area-chart":"6oe3Z","./timeline-bar-chart":"jXZ0n","./timeline-events":"kxQv6","./timeline-line-chart":"1FmQX","./tint":"5vxfq","./torch":"7Dqyp","./tractor":"ipK3R","./train":"34gFL","./translate":"9p6fm","./trash":"cXm0E","./tree":"6oC2q","./trending-down":"bLA2g","./trending-up":"ksGi8","./trophy":"kniiR","./truck":"hrA5J","./two-columns":"dXue4","./unarchive":"1IoHq","./underline":"5aq4G","./undo":"fF9i3","./ungroup-objects":"ataoY","./unknown-vehicle":"9JSjD","./unlink":"goE7P","./unlock":"bRzOy","./unpin":"gUKZ5","./unresolve":"5uPtP","./updated":"kFtgE","./upload":"dipfJ","./user":"iA7Qi","./variable":"aBGRo","./vector":"bnBIh","./vertical-bar-chart-asc":"niKYU","./vertical-bar-chart-desc":"b32w8","./vertical-distribution":"6KGtV","./vertical-inbetween":"5voYE","./video":"1B2U8","./virus":"iZBck","./volume-down":"l3xSM","./volume-off":"8oCMa","./volume-up":"9ljtH","./walk":"afBuD","./warning-sign":"aJ4vj","./waterfall-chart":"jBkmS","./waves":"hrkuG","./widget":"2QWGB","./widget-button":"73BA7","./widget-footer":"bOZ8H","./widget-header":"34V4a","./wind":"jiCzj","./wrench":"hObJX","./wrench-redo":"4ojo7","./wrench-snooze":"asLMh","./wrench-time":"bavGG","./zoom-in":"6BtC3","./zoom-out":"b7NOs","./zoom-to-fit":"4FZiV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bDpid":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.99 6.99h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1zm-3-7c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.68 6-6 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cz8U3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 0a1 1 0 00-1 1v2H9a1 1 0 000 2h2v2a1 1 0 102 0V5h2a1 1 0 100-2h-2V1a1 1 0 00-1-1zM0 4a1 1 0 011-1h3.5a1 1 0 010 2H2v2a1 1 0 01-2 0V4zm1 12a1 1 0 01-1-1v-3a1 1 0 112 0v2h2.5a1 1 0 110 2H1zm11 0a1 1 0 001-1v-3a1 1 0 10-2 0v2H9a1 1 0 100 2h3zm-5.5-4a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6w4j9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-5 14H2V2h8v12zm4 0h-3V2h3v12zM4 9h1v1c0 .55.45 1 1 1s1-.45 1-1V9h1c.55 0 1-.45 1-1s-.45-1-1-1H7V6c0-.55-.45-1-1-1s-1 .45-1 1v1H4c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ckukQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 9h1v1c0 .55.45 1 1 1s1-.45 1-1V9h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V6c0-.55-.45-1-1-1s-1 .45-1 1v1H8c-.55 0-1 .45-1 1s.45 1 1 1zm7-9H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM5 14H2V2h3v12zm9 0H6V2h8v12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lNvYq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0a1 1 0 110 2 6 6 0 106 6 1 1 0 012 0 8 8 0 11-8-8zm0 5a3 3 0 110 6 3 3 0 010-6zm5-5a1 1 0 011 1v.999L15 2a1 1 0 010 2h-1v1a1 1 0 01-2 0V4h-1a1 1 0 010-2h1V1a1 1 0 011-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kCWBC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 11h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1H9V8c0-.55-.45-1-1-1s-1 .45-1 1v1H6c-.55 0-1 .45-1 1s.45 1 1 1zm9-11H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2V6h12v8zm0-9H2V2h12v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ADddz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2v-3h12v3zm0-4H2V2h12v8zM6 7h1v1c0 .55.45 1 1 1s1-.45 1-1V7h1c.55 0 1-.45 1-1s-.45-1-1-1H9V4c0-.55-.45-1-1-1s-1 .45-1 1v1H6c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dmAjO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 4.01h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1 0-.56-.45-1-1-1zm-13 2h6c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm8 6H1c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1 0-.56-.45-1-1-1zm0-4H1c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1 0-.56-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Kk0M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M.01 7V5H16v7c0 .55-.45 1-1 1H9.005v-2.99C8.974 8.332 7.644 7 5.996 7H.01zM15 2H7.416L5.706.29a.996.996 0 00-.71-.29H1C.45 0 0 .45 0 1v3h15.99V3c.01-.55-.44-1-.99-1zM5.997 9H2c-.55 0-1 .45-1 1s.45 1 1 1h1.589L.3 14.29a1.003 1.003 0 001.42 1.42l3.287-3.29v1.59c0 .55.45 1 1 1 .549 0 .999-.45.999-1v-4A1.02 1.02 0 005.996 9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ceBYG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.1 9.101a3.99 3.99 0 00-1.828.974A8 8 0 0110.075.272 3.99 3.99 0 009.1 2.1a6 6 0 00-7 7zM14 8a6.03 6.03 0 00-.1-1.101 3.99 3.99 0 001.828-.974 8 8 0 01-9.803 9.803A3.99 3.99 0 006.9 13.9 6 6 0 0014 8z",
    "M8 3a1 1 0 00-1 1v2a1 1 0 002 0V4a1 1 0 00-1-1zM9 8a1 1 0 011-1h2a1 1 0 010 2h-2a1 1 0 01-1-1zM3 8a1 1 0 011-1h2a1 1 0 010 2H4a1 1 0 01-1-1zM7 10a1 1 0 012 0v2a1 1 0 01-2 0v-2zM5 13a2 2 0 11-4 0 2 2 0 014 0zM13 5a2 2 0 100-4 2 2 0 000 4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kBlJi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 1.5A1.498 1.498 0 0013.44.44L9.91 3.97 2 1 1 3l5.93 3.95L3.88 10H1l-1 1 3 2 2 3 1-1v-2.88l3.05-3.05L13 15l2-1-2.97-7.91 3.53-3.53c.27-.27.44-.65.44-1.06z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h82NL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 4c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H4zM1 3h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm13 10H2c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm1-6H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm-5 5c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1h4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUbUT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 12.98H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm-14-10h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1 0 .56.45 1 1 1zm14 4H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm0-3H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm0 6H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6uI8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 13H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zM1 3h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm0 3h8c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 1H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM1 12h4c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4sg9t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 12.98H3c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm-14-10h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1 0 .56.45 1 1 1zm14 1H7c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm0 6h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zm0-3H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8mMfS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 12h3c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm5 2H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM3 12h3c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2su67":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 7h-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1H7V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4H1c-.55 0-1 .45-1 1s.45 1 1 1h1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9h2v1c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9h1c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Glym":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 9H5c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zM1 0C.45 0 0 .45 0 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm13 2H5c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bLKVI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 9H7c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm4-9c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm-4 2H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iPxsG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H1C.45 0 0 .45 0 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM6 4H3c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm7 0h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dq3H9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 2H9V1c0-.55-.45-1-1-1S7 .45 7 1v1H3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4v2H6c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1H9V7h4c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecI20":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.126 1.1A4.994 4.994 0 014 5v8H0V5c0-1.517.69-2.952 1.874-3.9L2 1l.126.1zM8.126 1.1A4.994 4.994 0 0110 5v8H6V5c0-1.517.69-2.952 1.874-3.9L8 1l.126.1zM16 5c0-1.517-.69-2.952-1.874-3.9L14 1l-.126.1A4.994 4.994 0 0012 5v8h4V5zM4 15v-1H0v1h4zM10 14v1H6v-1h4zM16 15v-1h-4v1h4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kScJz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 2a2 2 0 01-1 1.732V5h2v2H9v6.874a4.004 4.004 0 002.976-3.436l-.269.27a1 1 0 01-1.414-1.415l2-2a1 1 0 011.414 0l2 2a1 1 0 01-1.414 1.414l-.306-.306a6 6 0 01-11.974 0l-.306.306A1 1 0 01.293 9.293l2-2a1 1 0 011.414 0l2 2a1 1 0 01-1.414 1.414l-.27-.27A4.003 4.003 0 007 13.875V7H5V5h2V3.732A2 2 0 1110 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0XkGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.52 2.77c.3-.29.48-.7.48-1.15C16 .73 15.27 0 14.38 0c-.45 0-.85.18-1.15.48l-1.34 1.34 2.3 2.3 1.33-1.35zM7.4 10.9l6.21-6.21-2.3-2.3L5.1 8.6l2.3 2.3zM14 14H2V2h6.34l2-2H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5.66l-2 2V14zM3 13l3.58-1.29-2.29-2.27L3 13z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9NphX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.673 10.758a1.396 1.396 0 01.093.234c.127.442.012.932-.362 1.212-.441.332-1.075.246-1.349-.233a8 8 0 1114.014-.225c-.259.488-.889.594-1.341.277-.382-.269-.513-.755-.4-1.2a1.259 1.259 0 01.085-.238 6 6 0 10-10.74.173zm2.464-1.862a1.783 1.783 0 01.076.404c.03.415-.096.831-.43 1.078-.444.328-1.08.237-1.314-.264a5.003 5.003 0 01-.24-.62l-.004-.011a5 5 0 119.574-.08l-.003.011c-.063.213-.14.422-.23.625-.226.504-.861.606-1.31.285-.338-.241-.47-.654-.448-1.07a1.737 1.737 0 01.07-.405 2.99 2.99 0 00-.216-2.233 3 3 0 00-5.525 2.28zM8 7a1 1 0 011 1v3.586l2.707 2.707a1 1 0 01-1.414 1.414L8 13.414l-2.293 2.293a1 1 0 01-1.414-1.414L7 11.586V8a1 1 0 011-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f6Itm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h14zM6 4a1 1 0 00-1.993-.117L4 4v8a1 1 0 001.993.117L6 12V9h4v3a1 1 0 001.993.117L12 12V4a1 1 0 00-1.993-.117L10 4v3H6V4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5NEvh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.5 7h7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-7c-.28 0-.5.22-.5.5s.22.5.5.5zM15 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm-1 12H2V5h12v8zM3.5 9h4c.28 0 .5-.22.5-.5S7.78 8 7.5 8h-4c-.28 0-.5.22-.5.5s.22.5.5.5zm0 2h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5s.22.5.5.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l6Sxn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.5 11h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-2c-.28 0-.5.22-.5.5s.22.5.5.5zm0-2h5c.28 0 .5-.22.5-.5S8.78 8 8.5 8h-5c-.28 0-.5.22-.5.5s.22.5.5.5zM11 4H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 10H2V7h8v7zm5-14H5c-.55 0-1 .45-1 1v2h2V2h8v7h-1v2h2c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM3.5 13h3c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5s.22.5.5.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kDIZu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.382 0a1 1 0 01.894.553L16 4v11a1 1 0 01-1 1H1a1 1 0 01-1-1V4L1.724.553A1 1 0 012.618 0h10.764zM8 6c-.55 0-1 .45-1 1v2.59l-.29-.29-.081-.076A.97.97 0 006 9a1.003 1.003 0 00-.71 1.71l2 2 .096.084c.168.13.38.206.614.206.28 0 .53-.11.71-.29l2-2 .084-.096A1.003 1.003 0 009.29 9.29l-.29.3V7l-.007-.116A1.004 1.004 0 008 6zm5-4H3L2 4h12l-1-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8LX9q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 3.664C4 1.644 5.793 0 8 0s3.993 1.643 4 3.664C12 5.692 8 11 8 11S4 5.692 4 3.664zM6 4a2 2 0 104.001-.001A2 2 0 006 4zm7.504 6.269l-2.68-1.609.021-.033c.34-.538.688-1.115 1-1.687l3.67 2.202a1 1 0 01.266 1.482l-4 5A1 1 0 0111 16H5a1 1 0 01-.78-.376l-4-5a1 1 0 01.266-1.482l3.67-2.202a30.46 30.46 0 00.999 1.687l.021.033-2.68 1.609 2.985 3.73h5.038l2.985-3.73z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fcLOt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm4 7a1 1 0 110 2 1 1 0 010-2zM5 7a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2 1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"25oRC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm7 6a1 1 0 01.993.883L12 7v2a1 1 0 01-.883.993L11 10H5a1 1 0 01-.993-.883L4 9V7a1 1 0 01.883-.993L5 6h6zm0 1H8v2h3V7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ldTdV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm6.5 4a.5.5 0 01.5.5V5a1 1 0 01.993.883L12 6v5a1 1 0 01-.883.993L11 12H5a1 1 0 01-.993-.883L4 11V6a1 1 0 01.883-.993L5 5v-.5a.5.5 0 011 0V5h4v-.5a.5.5 0 01.5-.5zm.5 3H5v4h6V7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"37MOW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.993.883A1 1 0 0015 0h-3l-.117.007A1 1 0 0011 1l.007.117A1 1 0 0012 2h2v12h-2l-.117.007A1 1 0 0012 16h3l.117-.007A1 1 0 0016 15V1l-.007-.117zM5 1a1 1 0 00-1-1H1L.883.007A1 1 0 000 1v14l.007.117A1 1 0 001 16h3l.117-.007A1 1 0 005 15l-.007-.117A1 1 0 004 14H2V2h2l.117-.007A1 1 0 005 1z",
    "M4.347 5.86c-.177.03-.36.047-.547.047v.703h1.344v3.86h.977V5h-.727a.844.844 0 01-.203.422 1.17 1.17 0 01-.367.281c-.14.073-.3.125-.477.157z",
    "M11.462 5.27c-.236-.176-.542-.264-.918-.264s-.685.088-.925.263a1.79 1.79 0 00-.557.662c-.13.266-.22.56-.27.88-.046.321-.068.632-.068.933 0 .3.022.612.067.933.05.32.14.617.271.887.135.266.321.487.557.662.24.17.549.256.925.256s.682-.085.918-.256c.24-.175.426-.396.556-.662a2.86 2.86 0 00.271-.887c.05-.321.075-.632.075-.933 0-.3-.025-.612-.075-.933a2.775 2.775 0 00-.27-.88 1.702 1.702 0 00-.557-.662zm-.452 4.34a.7.7 0 01-.466.157.711.711 0 01-.474-.158 1.214 1.214 0 01-.293-.436 2.791 2.791 0 01-.15-.647 6.443 6.443 0 01-.046-.782c0-.276.015-.534.045-.775.03-.246.08-.461.15-.647.076-.185.174-.33.294-.436a.69.69 0 01.474-.166.68.68 0 01.466.166c.126.105.223.25.294.436.075.186.128.401.158.647.03.24.045.5.045.775 0 .276-.015.537-.045.782-.03.246-.083.462-.158.647-.07.18-.168.326-.294.436z",
    "M7.082 9.445H8.17V10.5H7.082V9.445z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gOi7H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm6.904 5c.256 0 .483.037.68.112a1.343 1.343 0 01.812.788c.072.184.108.385.108.604 0 .23-.05.441-.152.636a1.314 1.314 0 01-.456.492v.016l.08.04c.055.031.111.072.168.124.085.077.163.172.232.284a1.673 1.673 0 01.24.872c0 .25-.043.477-.128.68a1.518 1.518 0 01-.896.852 1.937 1.937 0 01-.68.116c-.427 0-.792-.101-1.096-.304a1.362 1.362 0 01-.584-.864c-.01-.053.01-.088.064-.104l.696-.16.033-.002c.03.002.051.022.063.058.059.16.155.296.288.408.133.112.312.168.536.168.256 0 .453-.076.592-.228a.827.827 0 00.208-.58c0-.277-.08-.495-.24-.652-.16-.157-.376-.236-.648-.236h-.232l-.035-.005c-.03-.01-.045-.035-.045-.075v-.632l.005-.035c.01-.03.035-.045.075-.045h.216l.138-.009a.734.734 0 00.438-.207c.144-.144.216-.336.216-.576a.745.745 0 00-.192-.532c-.128-.136-.307-.204-.536-.204-.203 0-.363.05-.48.152a.815.815 0 00-.248.408c-.016.048-.048.067-.096.056l-.68-.16-.034-.012c-.028-.016-.038-.044-.03-.084a1.347 1.347 0 01.516-.828c.136-.104.296-.185.48-.244A1.98 1.98 0 0110.904 5zm-6.152.088l.035.005c.03.01.045.035.045.075v5.28l-.005.035c-.01.03-.035.045-.075.045h-.736l-.035-.005c-.03-.01-.045-.035-.045-.075V6.16H3.92l-.832.584-.032.016C3.02 6.773 3 6.751 3 6.696V5.88l.006-.04a.157.157 0 01.05-.072l.872-.632.04-.027a.236.236 0 01.104-.021h.68zM7.344 5c.256 0 .483.04.68.12.197.08.364.188.5.324s.24.296.312.48c.072.184.108.383.108.596 0 .245-.045.47-.136.676-.09.205-.216.404-.376.596l-1.584 1.92v.016h2.016l.035.005c.03.01.045.035.045.075v.64l-.005.035c-.01.03-.035.045-.075.045H5.808l-.035-.005c-.03-.01-.045-.035-.045-.075v-.6l.004-.04a.132.132 0 01.036-.064l1.92-2.392.1-.133a1.95 1.95 0 00.156-.267.985.985 0 00.096-.432.736.736 0 00-.188-.512c-.125-.139-.303-.208-.532-.208-.219 0-.39.061-.512.184a.826.826 0 00-.224.496c-.01.053-.04.075-.088.064L5.792 6.4l-.034-.012c-.028-.016-.038-.044-.03-.084a1.425 1.425 0 01.94-1.192A1.88 1.88 0 017.344 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gKDBt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm1.61 5c.514 0 .962.212 1.343.637.382.425.573.997.573 1.716 0 .838-.258 1.588-.773 2.252-.514.663-1.327 1.2-2.437 1.609v-.465l.233-.095a3.09 3.09 0 001.274-1.017c.366-.505.55-1.03.55-1.577a.478.478 0 00-.057-.26c-.018-.037-.043-.056-.074-.056s-.08.025-.149.075c-.198.142-.446.214-.744.214-.36 0-.675-.145-.944-.433A1.453 1.453 0 014 6.572c0-.422.155-.79.465-1.102.31-.313.692-.47 1.144-.47zm4.474 0c.514 0 .963.212 1.344.637.381.425.572.997.572 1.716 0 .838-.257 1.588-.772 2.252-.515.663-1.327 1.2-2.437 1.609v-.465l.233-.095a3.09 3.09 0 001.274-1.017c.366-.505.549-1.03.549-1.577a.478.478 0 00-.056-.26c-.019-.037-.044-.056-.075-.056-.03 0-.08.025-.149.075-.198.142-.446.214-.744.214-.36 0-.674-.145-.944-.433a1.453 1.453 0 01-.405-1.028c0-.422.155-.79.466-1.102.31-.313.691-.47 1.144-.47z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gmNNq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm4 3a5 5 0 110 10A5 5 0 018 3zm0 1a4 4 0 100 8 4 4 0 000-8zm2.354 1.646a.5.5 0 01.057.638l-.057.07-2 2a.5.5 0 01-.638.057l-.07-.057-1-1a.5.5 0 01.638-.765l.07.057.646.647 1.646-1.647a.5.5 0 01.708 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dMaAk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 3a1.003 1.003 0 00-1.71-.71L4 10.59V6c0-.55-.45-1-1-1s-1 .45-1 1v7c0 .55.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1H5.41l8.29-8.29c.19-.18.3-.43.3-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jHaet":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 5c-.55 0-1 .45-1 1v4.59l-8.29-8.3a1.003 1.003 0 00-1.42 1.42l8.3 8.29H6c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l3ypQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 8c-.3 0-.5.1-.7.3L9 11.6V2c0-.5-.4-1-1-1s-1 .5-1 1v9.6L3.7 8.3C3.5 8.1 3.3 8 3 8c-.5 0-1 .5-1 1 0 .3.1.5.3.7l5 5c.2.2.4.3.7.3s.5-.1.7-.3l5-5c.2-.2.3-.4.3-.7 0-.6-.4-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eK5pe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.99 6.99H4.41L7.7 3.7a1.003 1.003 0 00-1.42-1.42l-5 5a1.014 1.014 0 000 1.42l5 5a1.003 1.003 0 001.42-1.42L4.41 8.99H14c.55 0 1-.45 1-1s-.46-1-1.01-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chIKz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.7 7.29l-5-5a.965.965 0 00-.71-.3 1.003 1.003 0 00-.71 1.71l3.29 3.29H1.99c-.55 0-1 .45-1 1s.45 1 1 1h9.59l-3.29 3.29a1.003 1.003 0 001.42 1.42l5-5c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Klg3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.71 12.29L5.41 4H10c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1s1-.45 1-1V5.41l8.29 8.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h0pHD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 2H6c-.55 0-1 .45-1 1s.45 1 1 1h4.59L2.3 12.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L12 5.41V10c0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bksol":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.7 6.3l-5-5C8.5 1.1 8.3 1 8 1s-.5.1-.7.3l-5 5c-.2.2-.3.4-.3.7 0 .6.5 1 1 1 .3 0 .5-.1.7-.3L7 4.4V14c0 .6.4 1 1 1s1-.4 1-1V4.4l3.3 3.3c.2.2.4.3.7.3.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hVGKR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.396.146a.5.5 0 01.708 0l3.182 3.182a.5.5 0 11-.708.708L4.246 1.704v.002c-.008 1.795-.014 3.149.184 4.315.233 1.367.747 2.455 1.923 3.625 1.182 1.176 2.216 1.686 3.546 1.919 1.149.201 2.507.196 4.39.188h.007l-2.332-2.331a.5.5 0 11.708-.708l3.182 3.182a.5.5 0 010 .708l-3.182 3.182a.5.5 0 11-.708-.708l2.325-2.324c-1.866.008-3.325.013-4.563-.204-1.545-.27-2.761-.885-4.079-2.196C4.323 9.037 3.712 7.76 3.445 6.19c-.213-1.25-.208-2.7-.199-4.478L.922 4.036a.5.5 0 11-.708-.708L3.396.146z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7xIUR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.7 7.3l-4-4c-.2-.2-.4-.3-.7-.3-.6 0-1 .5-1 1 0 .3.1.5.3.7L12.6 7H3.4l2.3-2.3c.2-.2.3-.4.3-.7 0-.5-.4-1-1-1-.3 0-.5.1-.7.3l-4 4c-.2.2-.3.4-.3.7s.1.5.3.7l4 4c.2.2.4.3.7.3.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7L3.4 9h9.2l-2.3 2.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3l4-4c.2-.2.3-.4.3-.7s-.1-.5-.3-.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3eAG5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 10c-.3 0-.5.1-.7.3L9 12.6V3.4l2.3 2.3c.2.2.4.3.7.3.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7l-4-4C8.5.1 8.3 0 8 0s-.5.1-.7.3l-4 4c-.2.2-.3.4-.3.7 0 .6.5 1 1 1 .3 0 .5-.1.7-.3L7 3.4v9.2l-2.3-2.3c-.2-.2-.4-.3-.7-.3-.5 0-1 .4-1 1 0 .3.1.5.3.7l4 4c.2.2.4.3.7.3s.5-.1.7-.3l4-4c.2-.2.3-.4.3-.7 0-.6-.4-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1iPv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.54 11.18l.01-.02L9.8 8l4.75-3.17-.01-.02c.27-.17.46-.46.46-.81 0-.55-.45-1-1-1-.21 0-.39.08-.54.18l-.01-.02L9 6.13V1c0-.55-.45-1-1-1S7 .45 7 1v5.13L2.55 3.17l-.01.01A.969.969 0 002 3c-.55 0-1 .45-1 1 0 .35.19.64.46.82l-.01.01L6.2 8l-4.75 3.17.01.02c-.27.17-.46.46-.46.81 0 .55.45 1 1 1 .21 0 .39-.08.54-.18l.01.02L7 9.87V15c0 .55.45 1 1 1s1-.45 1-1V9.87l4.45 2.96.01-.02c.15.11.33.19.54.19.55 0 1-.45 1-1 0-.35-.19-.64-.46-.82z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kJ5yG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.816 8.371c0 1.515.603 2.274 1.814 2.274 1.273 0 1.971-.954 2.089-2.86l.12-2.331a5.298 5.298 0 00-1.337-.165c-.848 0-1.507.276-1.979.828-.472.554-.707 1.305-.707 2.254M16 7.133c0 .93-.149 1.78-.446 2.55-.297.77-.714 1.372-1.253 1.802a2.913 2.913 0 01-1.868.642c-.521 0-.975-.137-1.356-.41a1.989 1.989 0 01-.773-1.111h-.12c-.323.506-.723.887-1.198 1.14a3.35 3.35 0 01-1.605.38c-1.076 0-1.924-.34-2.541-1.023-.618-.682-.926-1.607-.926-2.77 0-1.341.41-2.428 1.229-3.264.818-.835 1.918-1.253 3.298-1.253.502 0 1.058.043 1.669.13.61.088 1.155.21 1.63.367l-.218 4.536v.234c0 1.04.344 1.562 1.031 1.562.521 0 .935-.332 1.241-.996.308-.664.463-1.508.463-2.537 0-1.112-.232-2.09-.695-2.931a4.762 4.762 0 00-1.97-1.947c-.851-.456-1.83-.682-2.934-.682-1.405 0-2.628.286-3.67.858a5.736 5.736 0 00-2.382 2.455c-.549 1.062-.822 2.296-.822 3.7 0 1.888.512 3.339 1.535 4.353 1.024 1.015 2.492 1.52 4.409 1.52 1.46 0 2.982-.29 4.567-.877v1.6c-1.386.56-2.896.839-4.527.839-2.446 0-4.35-.65-5.717-1.945C.685 12.757 0 10.947 0 8.625c0-1.698.37-3.209 1.11-4.532a7.556 7.556 0 013.076-3.038C5.497.35 6.982 0 8.64 0c1.433 0 2.71.294 3.827.878a6.294 6.294 0 012.607 2.504c.619 1.082.926 2.332.926 3.75"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7iVEd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 14c-3.31 0-6-2.69-6-6 0-1.77.78-3.36 2-4.46V5c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1s.45 1 1 1h1.74A7.95 7.95 0 000 8c0 4.42 3.58 8 8 8 .55 0 1-.45 1-1s-.45-1-1-1zM8 2a5.9 5.9 0 012.95.81l1.47-1.47A7.893 7.893 0 008 0c-.55 0-1 .45-1 1s.45 1 1 1zm2.71 6.71l5-5a1.003 1.003 0 00-1.42-1.42L10 6.59l-1.29-1.3a1.003 1.003 0 00-1.42 1.42l2 2c.18.18.43.29.71.29s.53-.11.71-.29zM16 8c0-.55-.06-1.08-.16-1.6l-1.87 1.87A5.966 5.966 0 0112 12.45V11c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-1.74A7.95 7.95 0 0016 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2dE3x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 13h1v.5a.5.5 0 001 0v-11a.5.5 0 00-1 0V3H1v10zM15 3h-1v-.5a.5.5 0 00-1 0v11a.5.5 0 001 0V13h1V3zM3 6l1.789.894A1 1 0 005.236 7h5.528a1 1 0 00.447-.106L13 6v4l-1.789-.894A1 1 0 0010.764 9H5.236a1 1 0 00-.447.106L3 10V6z",
    "M0 8a1 1 0 011-1h1v2H1a1 1 0 01-1-1zM16 8a1 1 0 01-1 1h-1V7h1a1 1 0 011 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9RQSs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 10a1 1 0 110 2h-.585l2.292 2.293a1 1 0 01-1.32 1.497l-.094-.083L12 13.415V14a1 1 0 11-2 0l.003-3.075.012-.1.012-.059.033-.108.034-.081.052-.098.067-.096.08-.09a1.01 1.01 0 01.112-.097l.11-.071.143-.065.076-.024.091-.02.116-.014L14 10zM6.036 6.136l-3.45 3.45-.117.127a2 2 0 002.818 2.818l.127-.117 3.45-3.449a4 4 0 01-.885 3.704l-.15.16-1 1A4 4 0 011.02 8.33l.15-.16 1-1a3.998 3.998 0 013.865-1.035zm4.671-1.843a1 1 0 01.083 1.32l-.083.094-5 5a1 1 0 01-1.497-1.32l.083-.094 5-5a1 1 0 011.414 0zm3.121-3.121a4 4 0 01.151 5.497l-.15.16-1 1a3.998 3.998 0 01-3.864 1.036l3.45-3.45.116-.128a2 2 0 00-2.818-2.818l-.127.117-3.45 3.45A4 4 0 017.02 2.33l.15-.16 1-1a4 4 0 015.657 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3EDiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.002 16a6.763 6.763 0 01-2.732-.556 7.08 7.08 0 01-2.221-1.509 7.143 7.143 0 01-1.498-2.239A6.88 6.88 0 011 8.955c0-.274.095-.506.285-.698a.938.938 0 01.692-.287c.271 0 .502.096.692.287.19.192.285.424.285.698 0 1.414.49 2.613 1.469 3.598.979.985 2.171 1.478 3.577 1.478 1.406 0 2.598-.494 3.577-1.48.98-.988 1.47-2.19 1.47-3.607 0-1.414-.493-2.613-1.477-3.598-.984-.985-2.177-1.478-3.58-1.478h-.121l.49.496c.162.162.241.355.239.577a.822.822 0 01-.238.578.811.811 0 01-.588.248.783.783 0 01-.588-.24l-1.93-1.945a.97.97 0 01-.294-.7c0-.267.098-.5.294-.697L7.184.24A.783.783 0 017.772 0c.23.003.426.089.588.259a.809.809 0 01.233.583c-.001.226-.082.42-.244.583l-.47.474h.11c.973 0 1.883.185 2.732.556.85.37 1.59.873 2.225 1.51a7.11 7.11 0 011.503 2.233A6.87 6.87 0 0115 8.945c0 .977-.184 1.894-.551 2.751a7.14 7.14 0 01-1.498 2.239 7.086 7.086 0 01-2.219 1.51 6.748 6.748 0 01-2.73.555z",
    "M10 8H9v3h1V8zM9 7a1 1 0 00-1 1v3a1 1 0 001 1h1a1 1 0 001-1V8a1 1 0 00-1-1H9z",
    "M5.5 7a.5.5 0 000 1H6v3.5a.5.5 0 001 0V8a1 1 0 00-1-1h-.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kXSAV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.36 4.59c-.15-1.13.5-2.01 1.1-2.87L13.43.53c-1.72.88-4.12.65-5.63-.53-1.51 1.18-3.91 1.41-5.63.52l-1.03 1.2c.61.86 1.25 1.74 1.1 2.87-.3 2.29-2.45 4.17-1.32 6.68.45 1.14 1.44 1.9 2.72 2.2 1.56.36 3.52.72 4.16 2.53.64-1.81 2.6-2.16 4.16-2.54 1.28-.3 2.27-1.06 2.72-2.2 1.12-2.5-1.03-4.38-1.32-6.67z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l8FVr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3 9H5c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"WVS96":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.36 6.46l-.62-.14c-.31-1.12-.98-2.15-1.87-2.99l.4-1.77a.438.438 0 00-.49-.56c-.85.09-1.6.42-2.14.98-.84-.32-1.87-.51-2.85-.51-2.49 0-4.63 1.17-5.92 2.89-.18-.04-.36-.09-.53-.09-.76 0-1.34.61-1.34 1.4 0 .56.31 1.03.76 1.26-.05.33-.09.7-.09 1.07 0 1.68.71 3.17 1.83 4.34l-.27 1.59c-.09.56.35 1.07.89 1.07h.58c.45 0 .8-.33.89-.79l.04-.37c.94.42 2 .7 3.16.7 1.11 0 2.23-.23 3.16-.7l.05.37c.09.47.45.79.89.79h.58c.53 0 .98-.51.89-1.07l-.27-1.54c.62-.61 1.07-1.35 1.38-2.15l.8-.19c.4-.09.71-.47.71-.93V7.4c.09-.47-.22-.84-.62-.94zM12 8c-.6 0-1-.7-1-1.5S11.4 5 12 5s1 .7 1 1.5S12.6 8 12 8zM6.21 4.92c-.41.2-.91.04-1.12-.36-.21-.4-.04-.88.37-1.07 1.35-.65 2.73-.65 4.08 0 .41.2.58.68.37 1.07-.21.4-.71.56-1.12.36-.87-.43-1.71-.43-2.58 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"04xwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 14h2V2H0v12zm6 0h1V2H6v12zm2 0h1V2H8v12zm-5 0h2V2H3v12zM15 2v12h1V2h-1zm-5 12h1V2h-1v12zm2 0h2V2h-2v12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dmbME":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.004 4.385C6.659 4.128 6.212 4 5.662 4s-1.001.128-1.353.385c-.345.249-.616.571-.814.967-.19.388-.323.816-.396 1.285A9.776 9.776 0 003 8c0 .44.033.894.099 1.363.073.469.205.9.396 1.296.198.389.47.711.814.967.352.25.803.374 1.353.374.55 0 .997-.124 1.342-.374.352-.256.623-.578.814-.967.198-.395.33-.828.396-1.296.073-.47.11-.923.11-1.363 0-.44-.037-.894-.11-1.363a4.052 4.052 0 00-.396-1.285 2.486 2.486 0 00-.814-.967zm-.66 6.34c-.183.154-.41.231-.682.231-.279 0-.51-.077-.693-.23a1.774 1.774 0 01-.429-.638 4.074 4.074 0 01-.22-.945A9.404 9.404 0 014.254 8c0-.403.022-.78.066-1.132.044-.359.117-.674.22-.945.11-.271.253-.483.429-.637.183-.161.414-.242.693-.242.271 0 .499.08.682.242.183.154.326.366.429.637.11.271.187.586.231.945.044.352.066.73.066 1.132 0 .403-.022.784-.066 1.143a3.717 3.717 0 01-.231.945 1.606 1.606 0 01-.429.637zm4.457-5.468c-.26.046-.526.069-.801.069v1.028h1.968V12h1.43V4h-1.064c-.046.244-.145.45-.298.617a1.711 1.711 0 01-.537.412 2.422 2.422 0 01-.698.228z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fQHAm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var p = [];
exports.default = p;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQeVV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 2h10a1 1 0 011 1v4h1a1 1 0 110 2h-1v4a1 1 0 01-1 1H3a1 1 0 01-1-1V9H1a1 1 0 110-2h1V3a1 1 0 011-1zm5.854 3.146a.5.5 0 10-.708.708L10.293 8l-2.147 2.146a.5.5 0 00.708.708l2.5-2.5a.5.5 0 000-.708l-2.5-2.5zm-4.208 0a.5.5 0 000 .708L6.793 8l-2.147 2.146a.5.5 0 00.708.708l2.5-2.5a.498.498 0 00.144-.306.503.503 0 00-.001-.106.498.498 0 00-.143-.296l-2.5-2.5a.5.5 0 00-.708 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1GDFQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.39 12.69c-1.2-.53-1.04-.85-1.08-1.29-.01-.07-.01-.13-.02-.2.41-.37.75-.87.97-1.44 0 0 .01-.03.01-.04.05-.13.09-.26.13-.39.27-.06.43-.36.5-.63.01-.03.03-.08.05-.12C8.18 7.8 6.94 6.04 6.94 4c0-.32.04-.62.09-.92-.17-.03-.35-.08-.51-.08-.65 0-1.37.2-1.88.59-.5.38-.87.92-1.05 1.51-.04.14-.07.27-.09.41-.09.48-.14 1.23-.14 1.74v.06c-.19.08-.36.27-.4.68-.03.31.1.59.16.7.06.28.23.59.51.64.04.14.08.27.13.39 0 .01.01.02.01.02v.01c.22.59.57 1.1.99 1.46 0 .06-.01.12-.01.17-.04.44.08.76-1.12 1.29-1.2.53-3.01 1.1-3.38 1.95C-.12 15.5.03 16 .03 16h12.96s.15-.5-.22-1.36c-.37-.85-2.18-1.42-3.38-1.95zM11.97 0C9.75 0 7.94 1.79 7.94 4s1.8 4 4.03 4S16 6.21 16 4s-1.8-4-4.03-4zM9.96 4c0-1.1.9-2 2.01-2 .37 0 .72.11 1.02.28l-2.75 2.73c-.17-.3-.28-.64-.28-1.01zm2.01 2c-.37 0-.72-.11-1.02-.28l2.75-2.73c.18.3.28.64.28 1.01.01 1.1-.9 2-2.01 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ePeFx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.7 7c.2-.4.3-1 .3-1.5v-.4V5c0-.1 0-.2-.1-.3v-.1C11.4 3.1 10.1 2 8.5 2H4c-.5 0-1 .4-1 1v10c0 .5.4 1 1 1h5c2.2 0 4-1.8 4-4 0-1.2-.5-2.3-1.3-3zM6 5h2c.6 0 1 .4 1 1s-.4 1-1 1H6V5zm3 6H6V9h3c.6 0 1 .4 1 1s-.4 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8H82G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 1v14c0 .55.45 1 1 1h1V0H3c-.55 0-1 .45-1 1zm11-1h-1v7l-2-2-2 2V0H5v16h8c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gdOrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.2.01h-.15C11.03.01 11.02 0 11 0H5c-.02 0-.03.01-.05.01H4.8c-.44 0-.8.37-.8.82v14.75c0 .45.25.56.57.24l2.87-2.94c.31-.32.82-.32 1.13 0l2.87 2.94c.31.32.57.21.57-.24V.83C12 .38 11.64.01 11.2.01z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dU9AT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 10h4c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1zm9.93-4.37v-.02L13.94.63C13.78.26 13.42 0 13 0H3c-.42 0-.78.26-.93.63L.08 5.61l-.01.02C.03 5.74 0 5.87 0 6v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V6c0-.13-.03-.26-.07-.37zM9 2h3.32l1.2 3H9V2zM3.68 2H7v3H2.48l1.2-3zM14 14H2V7h12v7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"70L4F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 3.98h-3v-2c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v2H1c-.55 0-1 .45-1 1v4h3v-1h2v1h6v-1h2v1h3v-4c0-.55-.45-1-1-1zm-5 0H6v-1h4v1zm3 7h-2v-1H5v1H3v-1H0v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-4h-3v1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grJho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 14a1 1 0 010 2H2a1 1 0 010-2h12zM7.995 3.005c.55 0 1 .45 1 .999v5.584l1.29-1.288a1.002 1.002 0 011.42 1.419l-3 2.996a1.015 1.015 0 01-1.42 0l-3-2.997A1.002 1.002 0 015.705 8.3l1.29 1.29V4.013c0-.55.45-1.009 1-1.009zM14 0a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2zM8 0a1 1 0 110 2 1 1 0 010-2zM5 0a1 1 0 110 2 1 1 0 010-2zM2 0a1 1 0 110 2 1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f92WE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.697.29a.99.99 0 00-.7-.29c-.27 0-.53.11-.71.29L4.29 3.28A1.003 1.003 0 005.71 4.7l1.288-1.29L7 7H1a1 1 0 000 2h6v2H1a1 1 0 00-1 1v2a1 1 0 001 1h14a1 1 0 001-1v-2a1 1 0 00-1-1H9V9h6a1 1 0 100-2H9V3.414h-.003V3.41l1.29 1.29c.179.18.429.29.699.29a1.003 1.003 0 00.71-1.71L8.696.29z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fzkWW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.2 1.428A4 4 0 005 5v2H4a1 1 0 000 2h1v1.5c0 1.133-.229 1.79-.457 2.133-.21.315-.413.367-.543.367H3v2h10v-2H6.591c.27-.684.409-1.522.409-2.5V9h3a1 1 0 100-2H7V5a2 2 0 013.732-1l1.732-1a4 4 0 00-4.666-1.815"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l3uEZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 3a3 3 0 016 0 5.022 5.022 0 011.425 1.67L13 4.382V3a1 1 0 112 0v2a1 1 0 01-.553.894l-1.46.731c.008.124.013.249.013.375v1h2a1 1 0 110 2h-2a5 5 0 01-.21 1.439l1.581.633A1 1 0 0115 13v2a1 1 0 11-2 0v-1.323l-1.167-.467A4.99 4.99 0 018 15a4.99 4.99 0 01-3.833-1.79L3 13.677V15a1 1 0 11-2 0v-2a1 1 0 01.629-.928l1.581-.633A5 5 0 013 10H1a1 1 0 110-2h2V7c0-.126.005-.251.014-.375l-1.461-.73A1 1 0 011 5V3a1 1 0 012 0v1.382l.575.288A5.023 5.023 0 015 3zm0 6v1a3 3 0 106 0V7a3 3 0 00-6 0v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3C5PP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.928.629A1 1 0 0012.89.006l-9 1a1 1 0 00-.747.48L.431 6.005A.5.5 0 000 6.5v3a.5.5 0 00.5.5h2.798c.341 0 .672.116.938.329l1.952 1.561A.5.5 0 006.5 12H10a.5.5 0 00.4-.2l.9-1.2a1.5 1.5 0 011.2-.6h3a.5.5 0 00.5-.5v-4a.5.5 0 00-.308-.462L13.928.628zM12.36 2.094l-.006-.016-3.166.352 1.121 3.083 2.052-3.419zm.467 1.166l-1.649 2.748 2.51-.594-.861-2.154zM9.603 6.496L8.166 2.543l-3.563.396L2.766 6H3.5a.5.5 0 01.367.16L6.218 8.7h1.914l1.452-2.177a.5.5 0 01.019-.027zM2.5 16a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm11 0a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kzQWX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.39 12.41L7.7 6l1.07-1.1c.34-.34-.12-.63.12-1.26.88-2.17 3.41-2.35 3.41-2.35s.36-.37.71-.72C9.74-.81 7.53.53 6.54 1.4L3.12 4.9l-.71.72c-.39.4-.39 1.05 0 1.45l-.7.72c-.39-.4-1.02-.4-1.41 0s-.39 1.05 0 1.45l1.41 1.45c.39.4 1.02.4 1.41 0s.39-1.05 0-1.45l.71-.72c.39.4 1.02.4 1.41 0l.8-.82 6.39 7.67c.82.82 2.14.82 2.96 0 .81-.82.81-2.15 0-2.96z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iuFdK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.76 1.35a1 1 0 01-.11 1.41l-7 6a1 1 0 11-1.3-1.52l7-6a1 1 0 011.41.11z",
    "M8 14a6 6 0 005.598-8.164l1.586-1.36A8 8 0 1112.58 1.44L10.994 2.8A6 6 0 108 14z",
    "M9.33 4.226a4 4 0 102.603 3.037l-2.624 2.25a1.993 1.993 0 01-2.114.319 1.992 1.992 0 01-.803-.643 1.993 1.993 0 01-.212-2.02c.123-.27.305-.508.53-.697l2.62-2.246z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lHlg2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM6 14H4v-2h2v2zm0-3H4V9h2v2zm0-3H4V6h2v2zm3 6H7v-2h2v2zm0-3H7V9h2v2zm0-3H7V6h2v2zm3 6h-2V9h2v5zm0-6h-2V6h2v2zm0-3H4V2h8v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5XU47":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 3c.6 0 1-.5 1-1V1c0-.6-.4-1-1-1s-1 .4-1 1v1c0 .5.4 1 1 1zm3-2h-1v1c0 1.1-.9 2-2 2s-2-.9-2-2V1H6v1c0 1.1-.9 2-2 2s-2-.9-2-2V1H1c-.6 0-1 .5-1 1v12c0 .6.4 1 1 1h13c.6 0 1-.4 1-1V2c0-.6-.5-1-1-1zM5 13H2v-3h3v3zm0-4H2V6h3v3zm4 4H6v-3h3v3zm0-4H6V6h3v3zm4 4h-3v-3h3v3zm0-4h-3V6h3v3zM4 3c.6 0 1-.5 1-1V1c0-.6-.4-1-1-1S3 .4 3 1v1c0 .5.4 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3mA4o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 3h-2.59L10.7 1.29A.956.956 0 0010 1H6c-.28 0-.53.11-.71.29L3.59 3H1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h2.56c1.1 1.22 2.67 2 4.44 2s3.34-.78 4.44-2H15c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM3 6H1V5h2v1zm5 6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cCjAK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 6.5c0-.28-.22-.5-.5-.5h-7a.495.495 0 00-.37.83l3.5 4c.09.1.22.17.37.17s.28-.07.37-.17l3.5-4c.08-.09.13-.2.13-.33z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eL6OE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.5 4c-.13 0-.24.05-.33.13l-4 3.5c-.1.09-.17.22-.17.37s.07.28.17.37l4 3.5a.495.495 0 00.83-.37v-7c0-.28-.22-.5-.5-.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"esewh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 8c0-.15-.07-.28-.17-.37l-4-3.5A.495.495 0 006 4.5v7a.495.495 0 00.83.37l4-3.5c.1-.09.17-.22.17-.37z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bJ1GM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.87 9.17s.01 0 0 0l-3.5-4C8.28 5.07 8.15 5 8 5s-.28.07-.37.17l-3.5 4a.495.495 0 00.37.83h7a.495.495 0 00.37-.83z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"36Iy5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 1h3a1 1 0 011 1v2h-4V1zM2.25 4a.25.25 0 00-.25.25V9H.883a.5.5 0 00-.429.757l1.072 1.787c.207.344.477.638.791.87A9.76 9.76 0 011 12.5a.5.5 0 000 1c2.067 0 3.414-.543 4.161-.917.55.373 1.505.917 2.839.917 1.32 0 2.27-.533 2.822-.905l.004.002c.196.105.48.24.856.374.75.268 1.857.529 3.318.529a.5.5 0 000-1c-.326 0-.63-.014-.916-.039.47-.328.848-.79 1.07-1.347l.572-1.428A.5.5 0 0015.26 9H4V4.25A.25.25 0 003.75 4h-1.5zm2.714 9.56a.5.5 0 01.527.033c.455.325 1.277.907 2.509.907s2.054-.582 2.51-.907a.5.5 0 01.579-.001l.006.004.036.023c.034.022.09.055.168.097.154.082.394.197.72.313.649.232 1.642.471 2.981.471a.5.5 0 010 1c-1.46 0-2.568-.261-3.318-.53a6.316 6.316 0 01-.856-.373l-.004-.002c-.552.372-1.502.905-2.822.905-1.334 0-2.289-.544-2.839-.917-.747.374-2.094.917-4.161.917a.5.5 0 010-1c2.129 0 3.384-.63 3.964-.94zM14 5h-4v3h3a1 1 0 001-1V5zM5 2a1 1 0 011-1h3v3H5V2zm4 3H5v2a1 1 0 001 1h3V5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j7aoL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.97 6.76c-.01-.05-.04-.08-.06-.13-.02-.05-.03-.1-.05-.15.08-.14.14-.3.14-.48 0-.55-.45-1-1-1s-1 .45-1 1c0 .18.06.34.14.48-.03.05-.03.1-.05.15-.02.05-.05.08-.06.13l-2 8c-.13.54.19 1.08.73 1.21a.995.995 0 001.21-.73L7.53 13h.94l.56 2.24a1 1 0 001.94-.48l-2-8zM3.72 1.7C4.1 1.3 4.09.67 3.7.28S2.67-.09 2.28.3c-3.05 3.12-3.05 8.28 0 11.4a.996.996 0 101.43-1.39c-2.28-2.35-2.28-6.27.01-8.61zM11.6 3.2c-.44-.33-1.07-.24-1.4.2-.33.44-.24 1.07.2 1.4.43.32.53 1.96-.04 2.43-.42.35-.48.98-.13 1.41.35.42.98.48 1.41.13 1.59-1.33 1.39-4.5-.04-5.57z",
    "M13.72.3c-.39-.4-1.02-.4-1.41-.02s-.41 1.02-.03 1.42c2.29 2.34 2.29 6.26 0 8.6-.39.39-.38 1.03.02 1.41s1.03.38 1.41-.02c3.05-3.11 3.05-8.27.01-11.39zM5.4 7.23c-.57-.47-.47-2.11-.04-2.43.44-.33.53-.96.2-1.4s-.96-.53-1.4-.2c-1.44 1.07-1.63 4.24-.04 5.57.42.35 1.05.3 1.41-.13.35-.42.29-1.06-.13-1.41z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iDCnO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.29 7.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3a1.003 1.003 0 00-1.42-1.42L13 7.59V1c0-.55-.45-1-1-1s-1 .45-1 1v6.59l-1.29-1.3a1.003 1.003 0 00-1.42 1.42zM14.5 13h-13c-.83 0-1.5.67-1.5 1.5S.67 16 1.5 16h13c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5zM1 5c.28 0 .53-.11.71-.29L3 3.41V10c0 .55.45 1 1 1s1-.45 1-1V3.41L6.29 4.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3C4.53.11 4.28 0 4 0s-.53.11-.71.29l-3 3A1.003 1.003 0 001 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6jOQh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 15c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V9.4L0 11v4zm6-5.5V15c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-5l-1 1-3-1.5zM13 7l-1 1v7c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V7.88c-.26.07-.58.12-1 .12-1.96 0-2-1-2-1zm2-6h-3c-.55 0-1 .45-1 1s.45 1 1 1h.59L8.8 6.78 5.45 5.11v.01C5.31 5.05 5.16 5 5 5s-.31.05-.44.11V5.1l-4 2v.01C.23 7.28 0 7.61 0 8c0 .55.45 1 1 1 .16 0 .31-.05.44-.11v.01L5 7.12 8.55 8.9v-.01c.14.06.29.11.45.11.28 0 .53-.11.71-.29L14 4.41V5c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecrGo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 10c-1.1 0-2-.9-2-2V3H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1v2a1.003 1.003 0 001.71.71L5.41 13H10c.55 0 1-.45 1-1v-1.17l-.83-.83H6zm9-10H6c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h4.59l2.71 2.71c.17.18.42.29.7.29.55 0 1-.45 1-1V9c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1JmPO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.41 8l3.29-3.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L6 6.59V4c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1s1-.45 1-1V9.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L7.41 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4SQkv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 5c-.28 0-.53.11-.71.29L8 8.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0012 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bPFgU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 3c-.55 0-1 .45-1 1v2.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42L7.59 8 4.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L9 9.41V12c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"86x9Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.41 8l3.29-3.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C5.11 7.47 5 7.72 5 8c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L7.41 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gf5MI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.71 7.29l-4-4a1.003 1.003 0 00-1.42 1.42L8.59 8 5.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dUhad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.71 9.29l-4-4C8.53 5.11 8.28 5 8 5s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L8 7.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jR1rj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kJwqy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 7c-.28 0-.53.11-.71.29L9 8.59V5c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-1.29-1.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 0011 7zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eXWmc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 7H7.41L8.7 5.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C4.11 7.47 4 7.72 4 8c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L7.41 9H11c.55 0 1-.45 1-1s-.45-1-1-1zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hXHwM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.71 4.29a1.003 1.003 0 00-1.42 1.42L8.59 7H5c-.55 0-1 .45-1 1s.45 1 1 1h3.59L7.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8U7ar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.71 4.29C8.53 4.11 8.28 4 8 4s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L7 7.41V11c0 .55.45 1 1 1s1-.45 1-1V7.41l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Qej5v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.02 5c0-1.66-1.34-3-3-3s-3 1.34-3 3a2.996 2.996 0 003.6 2.94C12.1 9.76 11.14 11 10.02 11c-.55 0-1 .45-1 1s.45 1 1 1c2.76 0 5-3.13 5-7 0-.2-.02-.39-.04-.58.01-.14.04-.28.04-.42zm-11-3c-1.66 0-3 1.34-3 3a2.996 2.996 0 003.6 2.94C4.1 9.76 3.14 11 2.02 11c-.55 0-1 .45-1 1s.45 1 1 1c2.76 0 5-3.13 5-7 0-.2-.02-.39-.04-.58.01-.14.04-.28.04-.42 0-1.66-1.35-3-3-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3B3R7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 8l-1.2 2.796-2.8 1.2 2.8 1.197L12 16l1.2-2.807L16 12l-2.8-1.204zM5 0L3.5 3.5 0 4.995 3.5 6.5 5 10l1.5-3.5L10 5 6.5 3.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"05gRP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 1a1 1 0 011-1h4a1 1 0 010 2H2v3a1 1 0 01-2 0V1zm1 15a1 1 0 01-1-1v-4a1 1 0 112 0v3h3a1 1 0 110 2H1zm14 0a1 1 0 001-1v-4a1 1 0 10-2 0v3h-3a1 1 0 100 2h4zm0-16a1 1 0 011 1v4a1 1 0 11-2 0V2h-3a1 1 0 110-2h4zM8 11a3 3 0 100-6 3 3 0 000 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9UqUd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 2c0-.55-.45-1-1-1h.22C9.88.4 9.24 0 8.5 0S7.12.4 6.78 1H7c-.55 0-1 .45-1 1v1h5V2zm2 0h-1v2H5V2H4c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4mbom":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.586 6a1 1 0 01.707.293l1.414 1.414a1 1 0 01.293.707V15a1 1 0 01-1 1H7a1 1 0 01-1-1V7a1 1 0 011-1h4.586zM8 9a.5.5 0 000 1h4a.5.5 0 000-1H8zm0 2a.5.5 0 000 1h4a.5.5 0 000-1H8zm0 2a.5.5 0 000 1h4a.5.5 0 000-1H8z",
    "M8.09.91c.5 0 .91.408.91.908V2.5H5v-.682c0-.5.41-.909.91-.909h-.2C6.017.364 6.326 0 7 0s.982.364 1.29.91h-.2z",
    "M10 2h1.09c.5 0 .91.41.91.91V5H6a1 1 0 00-1 1v8H2.91c-.5 0-.91-.409-.91-.909V2.91c0-.5.41-.909.91-.909H4v1.5h6V2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jdiyB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 6c-.03 0-.07 0-.1.01A5 5 0 002 7c0 .11.01.22.02.33A3.51 3.51 0 000 10.5C0 12.43 1.57 14 3.5 14H12c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"io0Io":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 11c-.28 0-.53.11-.71.29L9 12.59V8c0-.55-.45-1-1-1s-1 .45-1 1v4.59L5.71 11.3A.965.965 0 005 11a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 0011 11zm1-7c-.03 0-.07 0-.1.01A5 5 0 002 5c0 .11.01.22.02.33A3.51 3.51 0 000 8.5c0 1.41.84 2.61 2.03 3.17C2.2 10.17 3.46 9 5 9c.06 0 .13.02.19.02C5.07 8.7 5 8.36 5 8c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .36-.07.7-.19 1.02.06 0 .13-.02.19-.02 1.48 0 2.7 1.07 2.95 2.47A3.964 3.964 0 0016 8c0-2.21-1.79-4-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3BCfV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 4c-.03 0-.07 0-.1.01A5 5 0 002 5c0 .11.01.22.02.33A3.51 3.51 0 000 8.5C0 10.43 1.57 12 3.5 12H6V9a1 1 0 011-1h8a1 1 0 01.944.67A3.999 3.999 0 0012 4z",
    "M7 9h8v3H7V9zm3 1.5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm-1 0a.5.5 0 11-1 0 .5.5 0 011 0zM7 16v-3h8v3H7zm3-1.5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm-1.5.5a.5.5 0 100-1 .5.5 0 000 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"479Nv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.9 4.01c.03-.01.07-.01.1-.01a4 4 0 013.907 3.14 3 3 0 00-3.028.739L10 10.757l-.879-.878A3 3 0 004 12h-.5C1.57 12 0 10.43 0 8.5c0-1.4.83-2.61 2.02-3.17C2.01 5.22 2 5.11 2 5a5 5 0 019.9-.99z",
    "M15.765 9.356a1 1 0 01-.058 1.351l-5 5a1 1 0 01-1.414 0l-3-3a1 1 0 011.414-1.414L10 13.586l4.293-4.293a1 1 0 011.472.063z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ryo4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.71 7.29C8.53 7.11 8.28 7 8 7s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L7 10.41V15c0 .55.45 1 1 1s1-.45 1-1v-4.59l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3zM12 4c-.03 0-.07 0-.1.01A5 5 0 002 5c0 .11.01.22.02.33a3.495 3.495 0 00.07 6.37c-.05-.23-.09-.46-.09-.7 0-.83.34-1.58.88-2.12l3-3a2.993 2.993 0 014.24 0l3 3c.54.54.88 1.29.88 2.12 0 .16-.02.32-.05.47C15.17 10.78 16 9.5 16 8c0-2.21-1.79-4-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"levLG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.71 7.29l-3-3a1.003 1.003 0 00-1.42 1.42L13.59 8l-2.29 2.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM5 5a1.003 1.003 0 00-1.71-.71l-3 3C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L2.41 8 4.7 5.71c.19-.18.3-.43.3-.71zm4-3c-.48 0-.87.35-.96.81l-2 10c-.01.06-.04.12-.04.19 0 .55.45 1 1 1 .48 0 .87-.35.96-.81l2-10c.01-.06.04-.12.04-.19 0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"glx6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 3h-2V2c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H7V2c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-8.29 8.29a1.003 1.003 0 01-1.42 1.42l-3-3C2.11 9.53 2 9.28 2 9s.11-.53.29-.71l3-3a1.003 1.003 0 011.42 1.42L4.41 9l2.3 2.29zm7-1.58l-3 3a1.003 1.003 0 01-1.42-1.42L11.59 9l-2.3-2.29a1.003 1.003 0 011.42-1.42l3 3c.18.18.29.43.29.71s-.11.53-.29.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8yPcQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.19 6.39h-1.85c-.11-.37-.27-.71-.45-1.04l1.36-1.36c.31-.31.31-.82 0-1.13l-1.13-1.13a.803.803 0 00-1.13 0l-1.36 1.36c-.33-.17-.67-.33-1.04-.44V.79c0-.44-.36-.8-.8-.8h-1.6c-.44 0-.8.36-.8.8v1.86c-.39.12-.75.28-1.1.47l-1.3-1.3c-.3-.3-.79-.3-1.09 0L1.82 2.91c-.3.3-.3.79 0 1.09l1.3 1.3c-.2.34-.36.7-.48 1.09H.79c-.44 0-.8.36-.8.8v1.6c0 .44.36.8.8.8h1.85c.11.37.27.71.45 1.04l-1.36 1.36c-.31.31-.31.82 0 1.13l1.13 1.13c.31.31.82.31 1.13 0l1.36-1.36c.33.18.67.33 1.04.44v1.86c0 .44.36.8.8.8h1.6c.44 0 .8-.36.8-.8v-1.86c.39-.12.75-.28 1.1-.47l1.3 1.3c.3.3.79.3 1.09 0l1.09-1.09c.3-.3.3-.79 0-1.09l-1.3-1.3c.19-.35.36-.71.48-1.1h1.85c.44 0 .8-.36.8-.8v-1.6a.816.816 0 00-.81-.79zm-7.2 4.6c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imGZJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.29 6.71c.18.18.43.29.71.29s.53-.11.71-.29l4-4a1.003 1.003 0 00-1.42-1.42L8 4.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4zm1.42 2.58C8.53 9.11 8.28 9 8 9s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L8 11.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f9PhO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.093 7c.017-.05.036-.1.058-.15.106-.248.225-.397.263-.436L7 2.828 11.172 7H3.093zM6.5 13c1 0 2.5-1 3-1.5l3.086-3.086L14 7l-1.414-1.414-4.172-4.172L7 0 5.586 1.414 2 5c-.5.5-1 1.5-1 2.5s.5 2 1 2.5l2 2c.5.5 1.5 1 2.5 1zm7-4l1.125 1.667c.238.353.375.666.375 1 0 .666-.375 1.333-1.5 1.333s-1.5-.667-1.5-1.333c0-.334.137-.647.375-1L13.5 9zM0 15a1 1 0 011-1h14a1 1 0 110 2H1a1 1 0 01-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kowsQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM4 13H2V3h2v10zm3 0H5V3h2v10zm7 0H8V3h6v10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vCUS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 1H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h2v3a1.003 1.003 0 001.71.71L8.41 12H14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM3.5 8C2.67 8 2 7.33 2 6.5S2.67 5 3.5 5 5 5.67 5 6.5 4.33 8 3.5 8zm4 0C6.67 8 6 7.33 6 6.5S6.67 5 7.5 5 9 5.67 9 6.5 8.33 8 7.5 8zm4 0c-.83 0-1.5-.67-1.5-1.5S10.67 5 11.5 5s1.5.67 1.5 1.5S12.33 8 11.5 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kzRFp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.99-.01c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1v-14c0-.55-.45-1-1-1zm-3 3h-4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm10 0h-4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm0 3h-4v-2h4v2zm0 3h-4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm0 3h-4v-2h4v2zm-10-3h-4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"da9Bm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 8c0 .14-.03.27-.08.39l-3 6.99c-.15.37-.51.62-.92.62s-.77-.25-.92-.61l-3-6.99a1.006 1.006 0 010-.79l3-6.99C7.23.25 7.59 0 8 0s.77.25.92.61l3 6.99c.05.13.08.26.08.4zM8 3.54L6.09 8h3.82L8 3.54z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ka5lP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.93 5.63v-.02L13.94.63C13.78.26 13.42 0 13 0H3c-.42 0-.78.26-.93.63L.08 5.61l-.01.02C.03 5.74 0 5.87 0 6v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V6c0-.13-.03-.26-.07-.37zM9 2h3.32l1.2 3H9V2zM3.68 2H7v3H2.48l1.2-3zM14 14H2V7h5v2.59l-1.29-1.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3a1.003 1.003 0 00-1.42-1.42L9 9.59V7h5v7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HcAn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.7 4.29a.965.965 0 00-.71-.3 1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l5-5a1.003 1.003 0 00-1.42-1.42l-4.29 4.3L8.7 4.29zm5.22 3.01c.03.23.07.45.07.69 0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6c.81 0 1.59.17 2.3.46l1.5-1.5A7.998 7.998 0 00-.01 7.99c0 4.42 3.58 8 8 8s8-3.58 8-8c0-.83-.13-1.64-.36-2.39l-1.71 1.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aZSpx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 15H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zM14 5H2v8h12V5zM4 6c.28 0 .53.11.71.29l2 2c.18.18.29.43.29.71s-.11.53-.29.71l-2 2a1.003 1.003 0 01-1.42-1.42L4.59 9l-1.3-1.29A1.003 1.003 0 014 6zm5 4h3c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"74lAp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.2 6.4h-1.44c-.13-.47-.32-.92-.56-1.34L14.26 4c.31-.31.31-.82 0-1.13l-1.13-1.13a.803.803 0 00-1.13 0L10.94 2.8c-.42-.24-.86-.42-1.34-.56V.8c0-.44-.36-.8-.8-.8H7.2c-.44 0-.8.36-.8.8v1.44c-.5.14-.96.34-1.4.59l-1-1c-.3-.3-.79-.3-1.09 0L1.83 2.91c-.3.3-.3.79 0 1.09l1 1c-.25.44-.45.9-.59 1.4H.8c-.44 0-.8.36-.8.8v1.6c0 .44.36.8.8.8h1.44c.13.47.32.92.56 1.34L1.74 12c-.31.31-.31.82 0 1.13l1.13 1.13c.31.31.82.31 1.13 0l1.06-1.06c.42.24.86.42 1.34.56v1.44c0 .44.36.8.8.8h1.6c.44 0 .8-.36.8-.8v-1.44c.5-.14.96-.33 1.4-.59l1 1c.3.3.79.3 1.09 0l1.09-1.09c.3-.3.3-.79 0-1.09l-1-1c.25-.43.45-.9.59-1.4h1.44c.44 0 .8-.36.8-.8V7.2a.818.818 0 00-.81-.8zM8 12c-2.21 0-4-1.79-4-4s1.79-4 4-4v8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"646KS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 8H8v5h5V8zm0-5H8v4h5V3zm2-3H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2V2h12v12zM7 3H3v10h4V3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hIGSA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.99 2.95h-14c-.55 0-1 .45-1 1v1h16v-1c0-.55-.45-1-1-1zm-15 10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-6h-16v6zm5.5-2h5c.28 0 .5.22.5.5s-.22.5-.5.5h-5c-.28 0-.5-.22-.5-.5s.23-.5.5-.5zm-3 0h1c.28 0 .5.22.5.5s-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5s.23-.5.5-.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9V8q2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 15a1 1 0 102 0v-2h2a1 1 0 100-2H5V1a1 1 0 00-2 0v2H1a1 1 0 100 2h2v7a1 1 0 001 1h7v2z",
    "M12 3H6v2h5v5h2V4a1 1 0 00-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"85xmf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.41 8l3.29-3.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L8 6.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42L6.59 8 3.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L8 9.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L9.41 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hQzEJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 16A8 8 0 108 0a8 8 0 000 16zm3.7-10.29L9.41 8l2.3 2.29A1.003 1.003 0 0111 12c-.28 0-.53-.11-.71-.3L8 9.41l-2.29 2.3A1.003 1.003 0 014 11c0-.28.11-.53.3-.71L6.59 8l-2.3-2.29a1.003 1.003 0 011.42-1.42L8 6.59l2.29-2.3A1.003 1.003 0 0112 5c0 .28-.11.53-.3.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k2h4W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 6l3 2 3-4 3 4 3-2-1 6H3L2 6zm6-5a1 1 0 110 2 1 1 0 010-2zM1 3a1 1 0 110 2 1 1 0 010-2zm14 0a1 1 0 110 2 1 1 0 010-2zM3 13h10v2H3v-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Nixv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 1a1 1 0 011-1h7l5 5v10a1 1 0 01-1 1h-2.518A2.5 2.5 0 0012 14.5c0-.178-.02-.344-.053-.5H13V6H9V2H4v8.514a2.596 2.596 0 00-.492.5A2.34 2.34 0 002 10.046V1z",
    "M7.491 15.988L7.5 16h-.018l.009-.012zM1.5 11a1.42 1.42 0 00-1.035.426c-.262.268-.41.626-.46 1.008L0 12.467V14.5c0 .76.655 1.5 1.5 1.5A1.5 1.5 0 003 14.5a.5.5 0 00-1 0 .5.5 0 01-.5.5c-.26 0-.5-.26-.5-.5v-1.964a.745.745 0 01.18-.412A.421.421 0 011.5 12c.173 0 .264.048.321.104.066.064.146.197.184.466a.5.5 0 10.99-.14c-.057-.406-.2-.773-.474-1.04-.28-.275-.642-.39-1.021-.39zM4 12.5c0-.76.655-1.5 1.5-1.5A1.5 1.5 0 017 12.5a.5.5 0 01-1 0 .5.5 0 00-.5-.5c-.26 0-.5.26-.5.5 0 .092.028.154.129.236.126.103.31.188.575.308l.027.011c.23.104.533.239.773.434.274.225.496.55.496 1.011 0 .76-.655 1.5-1.5 1.5A1.5 1.5 0 014 14.5a.5.5 0 011 0 .5.5 0 00.5.5c.26 0 .5-.26.5-.5 0-.092-.028-.154-.129-.236-.126-.103-.31-.188-.575-.308l-.027-.011c-.23-.104-.533-.239-.773-.434C4.222 13.286 4 12.96 4 12.5zM9.5 11c-.845 0-1.5.74-1.5 1.5 0 .46.222.786.496 1.01.24.196.543.331.773.435l.027.011c.266.12.45.205.575.308.1.082.129.144.129.236 0 .24-.24.5-.5.5a.5.5 0 01-.5-.5.5.5 0 00-1 0A1.5 1.5 0 009.5 16c.845 0 1.5-.74 1.5-1.5 0-.46-.222-.786-.496-1.01-.24-.196-.543-.331-.773-.435l-.027-.011c-.266-.12-.45-.205-.575-.308-.1-.082-.129-.144-.129-.236 0-.24.24-.5.5-.5a.5.5 0 01.5.5.5.5 0 001 0A1.5 1.5 0 009.5 11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jlcX6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.194 3.54L8 7.41 1.806 3.54 7.504.283a1 1 0 01.992 0l5.698 3.255zm.75.71a1 1 0 01.056.33v6.84a1 1 0 01-.504.868L8.5 15.714V8.277l6.444-4.027zm-13.888 0L7.5 8.277v7.437l-5.996-3.426A1 1 0 011 11.42V4.58a1 1 0 01.056-.33z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"52BNC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 2h1a1 1 0 010 2h-1v1a1 1 0 01-2 0V4h-1a1 1 0 010-2h1V1a1 1 0 012 0v1zM9.136.65a3.001 3.001 0 00.992 5.222c.018.058.038.115.059.172L8 7.41 1.806 3.54 7.504.283a1 1 0 01.992 0l.64.365zM15 7.235v4.184a1 1 0 01-.504.868L8.5 15.714V8.277l2.187-1.367A2.994 2.994 0 0013 8c.768 0 1.47-.289 2-.764zM1.056 4.25L7.5 8.277v7.437l-5.996-3.426A1 1 0 011 11.42V4.58a1 1 0 01.056-.33z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fRGce":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.74 9.203L6.8 7.263l5.022-5.021 1.94 1.94zM5 11.008l1.093-3.033 1.942 1.941zM13.657.4c.251-.243.597-.4.975-.4.763 0 1.376.62 1.368 1.367 0 .385-.15.723-.401.974l-1.132 1.132-1.942-1.94zM8.496.284L10.96 1.69 6.301 6.349l-4.495-2.81L7.504.284a1 1 0 01.992 0",
    "M1.056 4.25l4.52 2.824-.193.193a1 1 0 00-.256.44L4.059 10.67a1 1 0 001.28 1.28l2.161-.777v4.542l-5.996-3.426A1 1 0 011 11.42V4.58a1 1 0 01.056-.33M8.5 15.714v-4.912a1 1 0 00.314-.258l5.655-5.655.05-.054.46-.46q.021.101.021.205v6.84a1 1 0 01-.504.868z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b3Bkj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.365 5.933L8 7.41 1.806 3.54 7.504.283a1 1 0 01.992 0l.64.365a3.001 3.001 0 001.228 5.283zM15 6v5.42a1 1 0 01-.504.868L8.5 15.714V8.277L12.143 6H15zM1.056 4.25L7.5 8.277v7.437l-5.996-3.426A1 1 0 011 11.42V4.58a1 1 0 01.056-.33zM11 2h4a1 1 0 010 2h-4a1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Fx7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.978.124a1.12 1.12 0 011.145.073l2.368 1.616c.318.217.509.582.509.973v.668l-.749.305A2.02 2.02 0 006 5.632v.952l-.313-.213a2.12 2.12 0 00-2.164-.138l-2.521 1.29-.493-.336A1.178 1.178 0 010 6.214V2.883c0-.443.245-.848.632-1.046L3.978.124zm3.65 4.561l3.955-1.612a.983.983 0 01.819.035l3.045 1.552c.339.173.553.526.553.912v4.796c0 .417-.249.792-.629.947l-3.954 1.612a.983.983 0 01-.819-.035L7.553 11.34A1.022 1.022 0 017 10.428V5.632c0-.417.249-.792.629-.947z",
    "M6 7.795v2.633c0 .755.418 1.456 1.099 1.803l.901.46v.426c0 .443-.245.848-.632 1.047l-3.346 1.713a1.12 1.12 0 01-1.145-.074L.509 14.188A1.178 1.178 0 010 13.214v-3.33c0-.444.245-.85.632-1.047l3.346-1.713a1.12 1.12 0 011.145.073L6 7.795z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"20clI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.62 3.056C4.102 2.25 5 2 6 2a1 1 0 010 2c-.44 0-.615.065-.67.097a.717.717 0 00-.03.17c-.012.153-.005.342.01.612l.008.118c.03.48.074 1.18-.112 1.854-.113.412-.305.801-.596 1.149.29.348.483.737.596 1.149.186.674.142 1.375.112 1.854l-.007.118a4.68 4.68 0 00-.01.613.716.716 0 00.028.169c.056.032.23.097.671.097a1 1 0 110 2c-1 0-1.897-.25-2.38-1.056a2.389 2.389 0 01-.313-1.05 6.495 6.495 0 01.007-.89l.002-.023c.033-.573.056-.96-.038-1.301-.072-.26-.224-.535-.725-.786a1 1 0 010-1.788c.501-.251.653-.526.725-.786.094-.34.071-.728.038-1.301l-.002-.023a6.495 6.495 0 01-.007-.89c.025-.313.097-.692.312-1.05zm1.687 8.828s.007.004.016.015c-.013-.008-.016-.015-.016-.015zm0-7.768s.003-.006.016-.015c-.009.011-.016.015-.016.015zM12.38 3.056C11.898 2.25 11 2 10 2a1 1 0 000 2c.44 0 .615.065.67.097a.72.72 0 01.03.17c.012.153.005.342-.01.612l-.008.118c-.03.48-.074 1.18.112 1.854.113.412.305.801.595 1.149-.29.348-.482.737-.595 1.149-.186.674-.142 1.375-.112 1.854l.007.118c.016.27.023.46.01.613a.719.719 0 01-.028.169c-.056.032-.23.097-.671.097a1 1 0 100 2c1 0 1.897-.25 2.38-1.056.216-.358.288-.737.313-1.05.025-.31.008-.629-.007-.89l-.002-.023c-.033-.573-.056-.96.038-1.301.072-.26.224-.535.725-.786a1 1 0 000-1.788c-.501-.251-.653-.526-.725-.786-.094-.34-.071-.728-.038-1.301l.002-.023c.015-.261.032-.58.007-.89a2.389 2.389 0 00-.312-1.05zm-1.687 8.828s-.007.004-.016.015c.013-.008.016-.015.016-.015zm0-7.768s-.003-.006-.016-.015c.009.011.016.015.016.015z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"agZKL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 12H3.12l1.81-1.39c1.73 1.01 5.53-.03 9.08-2.61l-1.22-1.5C10.3 8.3 7.86 9.37 6.65 9.29L14.3 3.4l-.6-.8-7.83 6.03c-.01-1.07 1.8-3.19 4.47-5.13L9.12 2C5.38 4.7 3.34 8.1 4.25 9.87L2 11.6V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzjiG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 2s.71-1.29 0-2L8.66 5.07l1.05 1.32L13 2zm.07 8c-.42 0-.82.09-1.18.26L3.31 0c-.69.71 0 2 0 2l3.68 5.02-2.77 3.24A2.996 2.996 0 000 13c0 1.66 1.34 3 3 3s3-1.34 3-3c0-.46-.11-.89-.29-1.27L8.1 8.54l2.33 3.19c-.18.39-.29.82-.29 1.27 0 1.66 1.31 3 2.93 3S16 14.66 16 13s-1.31-3-2.93-3zM3 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm10.07 0c-.54 0-.98-.45-.98-1s.44-1 .98-1 .98.45.98 1-.44 1-.98 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1LBik":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 9a3 3 0 110 6 3 3 0 010-6zM3 9a3 3 0 110 6 3 3 0 010-6zm6.169-5.27l.087.09 1.51 1.746 1.589.549a1 1 0 01.65 1.16l-.032.112a1 1 0 01-1.159.65l-.112-.032-1.843-.636a1 1 0 01-.337-.198l-.092-.093-.959-1.109L7.041 7.5l1.691 1.819a1 1 0 01.26.556L9 10v3a1 1 0 01-1.993.117L7 13l-.001-2.608-2.056-2.211a1 1 0 01-.081-1.264l.082-.1 2.825-3.026a1 1 0 011.4-.061zM13 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-10 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM11 1a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iJ4VJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM4 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-2c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-2 6c0 1.1.9 2 2 2s2-.9 2-2c0-.53-2-5-2-5s-2 4.47-2 5zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm4-9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zm0 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3F2S5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 9.52c.889.641 2.308 1.133 4.003 1.354L5 11a5.994 5.994 0 002.664 4.988c-.217.008-.44.012-.664.012-3.215 0-5.846-.85-5.993-1.906L1 14V9.52zM11 6c2.762 0 5 2.238 5 5s-2.238 5-5 5-5-2.238-5-5 2.238-5 5-5zm1 1l-4 5h2.5l-.5 3 4-5h-2.5l.5-3zm1-3.48v1.822a6.002 6.002 0 00-7.9 4.556l-.248-.03c-2.168-.28-3.733-.966-3.845-1.774L1 8V3.52C2.22 4.4 4.44 5 7 5s4.78-.6 6-1.48zM7 0c3.31 0 6 .9 6 2s-2.69 2-6 2c-3.32 0-6-.9-6-2s2.68-2 6-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kzuov":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.067 0C.477 0 0 .478 0 1.067V3.2c0 .59.478 1.067 1.067 1.067h2.24a5.342 5.342 0 002.9 3.734 5.337 5.337 0 00-2.9 3.733h-2.24C.477 11.733 0 12.21 0 12.8v2.133C0 15.523.478 16 1.067 16H6.4c.59 0 1.067-.478 1.067-1.067V12.8c0-.59-.478-1.067-1.067-1.067H4.401a4.27 4.27 0 013.92-3.194l.212-.006V9.6c0 .59.478 1.067 1.067 1.067h5.333c.59 0 1.067-.478 1.067-1.067V6.4c0-.59-.478-1.067-1.067-1.067H9.6c-.59 0-1.067.478-1.067 1.067v1.067a4.268 4.268 0 01-4.132-3.2H6.4c.59 0 1.067-.478 1.067-1.067V1.067C7.467.477 6.989 0 6.4 0H1.067z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1sgY1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 4c3.31 0 6-.9 6-2s-2.69-2-6-2C3.68 0 1 .9 1 2s2.68 2 6 2z",
    "M1 3.52V8c0 .867 1.672 1.61 4.001 1.886A5 5 0 0113 6V3.52C11.78 4.4 9.56 5 7 5s-4.78-.6-6-1.48zM1 9.52c.902.65 2.35 1.148 4.078 1.363a5.001 5.001 0 006.75 3.772l.352.353C11.137 15.6 9.206 16 7 16c-3.31 0-6-.9-6-2V9.52z",
    "M12.034 13.445l2.256 2.265a1.003 1.003 0 001.42-1.42l-2.265-2.255A3.981 3.981 0 0014 10c0-1.014-.378-1.94-1-2.646a4 4 0 10-.966 6.09zm-3.793-2.493a2 2 0 103.517-1.903 2 2 0 00-3.517 1.903z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eQvvF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 4c3.31 0 6-.9 6-2s-2.69-2-6-2C3.68 0 1 .9 1 2s2.68 2 6 2z",
    "M1 3.52V8c0 .55.67 1.049 1.755 1.411l1.828-1.828A1.997 1.997 0 016 7c.548 0 1.052.218 1.417.583l.59.59A2.282 2.282 0 018 8c0-.527.18-1.044.568-1.432C8.956 6.18 9.473 6 10 6a4.97 4.97 0 013 1.005V3.52C11.78 4.4 9.56 5 7 5s-4.78-.6-6-1.48zM1 9.52c.327.236.725.451 1.182.64A2.003 2.003 0 004.1 12.997a5.017 5.017 0 001.867 2.973C3.148 15.806 1 14.983 1 14V9.52z",
    "M14 11c0-2.2-1.8-4-4-4-.6 0-1 .4-1 1s.4 1 1 1c1.1 0 2 .9 2 2v.59l-.29-.3a1.003 1.003 0 00-1.42 1.42l2 2c.18.18.43.29.71.29.28 0 .53-.11.71-.29l2-2A1.003 1.003 0 0015 11c-.28 0-.53.11-.71.3l-.29.29V11zM4.71 11.71a1.003 1.003 0 01-1.42-1.42l2-2C5.47 8.11 5.72 8 6 8c.28 0 .53.11.71.29l2 2A1.003 1.003 0 018 12c-.28 0-.53-.11-.71-.3L7 11.41V12c0 1.1.9 2 2 2 .6 0 1 .4 1 1s-.4 1-1 1c-2.2 0-4-1.8-4-4v-.59l-.29.3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"deDRR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 4c3.31 0 6-.9 6-2s-2.69-2-6-2C4.68 0 2 .9 2 2s2.68 2 6 2zm-6-.48V8c0 1.1 2.69 2 6 2s6-.9 6-2V3.52C12.78 4.4 10.56 5 8 5s-4.78-.6-6-1.48zm0 6V14c0 1.1 2.69 2 6 2s6-.9 6-2V9.52C12.78 10.4 10.56 11 8 11s-4.78-.6-6-1.48z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dikaW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.99 4.99a1.003 1.003 0 00-1.71-.71l-2.29 2.3L5.7 4.29a.965.965 0 00-.71-.3 1.003 1.003 0 00-.71 1.71l2.29 2.29-2.29 2.29A1.003 1.003 0 005.7 11.7l2.29-2.29 2.29 2.29a1.003 1.003 0 001.42-1.42L9.41 7.99 11.7 5.7c.18-.18.29-.43.29-.71zm-4-5c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.68 6-6 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Jshj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0L0 16h16L8 0zM7 5l5 10H2L7 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k7VPx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.08 6.67h-.84c.24-.92.56-1.6.96-2.03.24-.27.48-.4.71-.4.05 0 .08.01.11.04s.04.06.04.1c0 .04-.03.11-.1.21-.06.1-.1.2-.1.29 0 .13.05.24.15.33.1.09.23.14.39.14.17 0 .31-.06.42-.17A.58.58 0 008 4.73c0-.22-.09-.39-.26-.53-.17-.13-.44-.2-.81-.2-.59 0-1.12.16-1.59.48-.48.32-.93.85-1.36 1.59-.15.26-.29.42-.42.49s-.35.11-.64.1l-.19.65h.81l-1.19 4.37c-.2.72-.33 1.16-.4 1.33-.1.24-.26.45-.46.62-.08.07-.18.1-.3.1-.03 0-.06-.01-.08-.03l-.03-.04c0-.02.03-.06.09-.11.06-.06.09-.14.09-.26 0-.13-.05-.23-.14-.32a.6.6 0 00-.4-.13c-.21 0-.38.05-.51.16s-.21.25-.21.4c0 .16.08.3.23.42.16.12.4.18.74.18.53 0 .99-.13 1.4-.39.41-.26.76-.65 1.07-1.19.3-.54.62-1.4.94-2.59l.68-2.53h.82l.2-.63zM15 0H8c-.55 0-1 .45-1 1v2h2V2h5v12H9v-1H7v2c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM8.3 9.94c.18.52.33.89.46 1.13.13.24.28.4.44.51.17.1.37.16.62.16.24 0 .49-.08.74-.25.33-.21.66-.58 1.01-1.09l-.21-.11c-.23.31-.41.5-.52.57a.44.44 0 01-.26.07c-.12 0-.24-.07-.36-.21-.2-.24-.46-.91-.8-2 .3-.49.55-.81.75-.96.15-.11.3-.16.47-.16.06 0 .17.02.34.06.16.04.31.06.43.06.17 0 .31-.06.43-.17.1-.11.16-.25.16-.43 0-.19-.06-.33-.17-.44-.12-.11-.28-.16-.49-.16-.19 0-.37.04-.54.13-.17.09-.39.27-.65.56-.2.21-.48.58-.87 1.11-.15-.66-.41-1.26-.78-1.81l-2.05.33-.04.21c.15-.03.28-.04.39-.04.2 0 .37.08.5.25.21.26.5 1.03.88 2.33-.29.37-.49.61-.6.72-.18.18-.33.3-.44.36-.09.04-.19.07-.3.07-.09 0-.23-.04-.42-.13a.866.866 0 00-.36-.09c-.2 0-.36.06-.49.18a.59.59 0 00-.19.46c0 .17.06.32.18.43.12.11.28.16.48.16.2 0 .38-.04.55-.11.17-.08.39-.24.65-.49.24-.27.6-.66 1.06-1.21z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7WAE6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H1C.45 0 0 .45 0 1v10c0 .55.45 1 1 1h4.75l-.5 2H4c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-1.25l-.5-2H15c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 10H2V2h12v8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7HwJS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 0a1 1 0 00-1 1v4a1 1 0 002 0V2h3a1 1 0 000-2H1zM0 15a1 1 0 001 1h4a1 1 0 100-2H2v-3a1 1 0 10-2 0v4zM15 16a1 1 0 001-1v-4a1 1 0 10-2 0v3h-3a1 1 0 100 2h4zM16 1a1 1 0 00-1-1h-4a1 1 0 100 2h3v3a1 1 0 102 0V1z",
    "M4 5a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1V5zm2 5V6h4v4H6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eQNMa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.2 1a1 1 0 01.117 1.993L3.2 3H3v3a2 2 0 001.85 1.995L5 8a2 2 0 001.995-1.85L7 6V3h-.2a1 1 0 01-.993-.883L5.8 2a1 1 0 01.883-.993L6.8 1H8a1 1 0 01.993.883L9 2v4a4.002 4.002 0 01-3.007 3.876v.007L6 10a3 3 0 005.995.176L12 10V7.792a2.5 2.5 0 112 0V10a5 5 0 01-10 0c0-.042.003-.084.008-.125A4 4 0 011.005 6.2L1 6V2a1 1 0 01.883-.993L2 1h1.2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ddpuH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 8v3h-2V9H9v2H7V9H3v2H1V8a1 1 0 011-1h5V5h2v2h5a1 1 0 011 1zM1 12h2a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1v-2a1 1 0 011-1zm12 0h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1zm-6 0h2a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1zM7 0h2a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1V1a1 1 0 011-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5h2lJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 1.99l-16 6 16 6-4-6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5zr2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 7.99l-16-6 4 6-4 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6bCjt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.99-.01c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm-6 8c0-3.31 2.69-6 6-6 1.3 0 2.49.42 3.47 1.12l-8.35 8.35c-.7-.98-1.12-2.17-1.12-3.47zm6 6c-1.3 0-2.49-.42-3.47-1.12l8.35-8.35c.7.98 1.12 2.17 1.12 3.47 0 3.32-2.68 6-6 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"sW5CW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 5a1 1 0 11-2 0 1 1 0 012 0zM5 7c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H5zm3 5a1 1 0 100-2 1 1 0 000 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cOLpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5L9 0zm3 14H4V2h4v4h4v8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htwM4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 12c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h1.59L1.3 12.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L6 10.41V12zm4-12H4c-.55 0-1 .45-1 1v4h2V2h4v4h4v8H5.24l-1.8 1.8c.16.12.35.2.56.2h10c.55 0 1-.45 1-1V5l-5-5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3zNha":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 14H2V2h4v4h1c0-.83.36-1.55.91-2.09l-.03-.03.9-.9C8.3 2.45 8 1.77 8 1L7 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V8.22c-.53.48-1.23.78-2 .78v5zm5-14h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59l-3.3 3.29a1.003 1.003 0 001.42 1.42L14 3.41V5c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ULKq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.83 9.51c-.1-.3-.25-.58-.45-.84s-.45-.49-.75-.7c-.3-.2-.65-.36-1.05-.48-.16-.04-.43-.11-.8-.2-.35-.09-.73-.18-1.12-.28-.39-.1-.74-.19-1.06-.27-.31-.08-.49-.12-.54-.13-.43-.12-.78-.29-1.05-.52-.27-.23-.4-.55-.4-.95 0-.29.07-.53.21-.72.14-.19.32-.34.54-.46.22-.11.46-.19.72-.24.26-.05.52-.08.77-.08.74 0 1.35.15 1.83.46.48.3.75.83.81 1.56h2.14c0-.6-.13-1.13-.38-1.58-.25-.45-.59-.84-1.02-1.15-.43-.31-.93-.54-1.49-.7-.24-.06-.49-.1-.75-.14V1c0-.55-.45-1-1-1s-1 .45-1 1v1.08c-.23.03-.46.07-.68.13-.54.13-1.02.34-1.44.61-.42.28-.76.63-1.02 1.05-.26.43-.39.93-.39 1.5 0 .3.04.59.13.88.09.29.23.56.44.82.21.26.48.49.83.7.35.21.79.38 1.31.51.85.21 1.56.38 2.14.52.58.13 1.08.28 1.52.42.25.09.48.23.69.44.21.21.32.53.32.97 0 .21-.05.42-.14.63-.09.21-.24.39-.45.55-.21.16-.47.29-.81.39-.33.1-.73.15-1.2.15-.43 0-.84-.05-1.21-.14-.37-.09-.7-.24-.99-.43-.29-.2-.51-.45-.67-.76-.16-.31-.24-.68-.24-1.12H3c.01.71.15 1.32.43 1.84.27.52.64.94 1.1 1.27.46.33.99.58 1.61.74.27.07.56.12.85.16V15c0 .55.45 1 1 1s1-.45 1-1v-1.05c.3-.03.61-.08.9-.15.58-.13 1.1-.34 1.56-.63.46-.29.83-.66 1.11-1.11.28-.45.42-1 .42-1.64 0-.31-.05-.61-.15-.91z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fjwJE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 5a3 3 0 100 6 3 3 0 100-6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lu7Bn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.71 7.29l-3-3A1.003 1.003 0 009 5v6a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM6 4c-.28 0-.53.11-.71.29l-3 3C2.11 7.47 2 7.72 2 8c0 .28.11.53.29.71l3 3A1.003 1.003 0 007 11V5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1yjkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 7h6a1.003 1.003 0 00.71-1.71l-3-3C8.53 2.11 8.28 2 8 2s-.53.11-.71.29l-3 3A1.003 1.003 0 005 7zm6 2H5a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 0011 9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iMpoF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.29 8.71c.18.18.43.29.71.29s.53-.11.71-.29l4-4a1.003 1.003 0 00-1.42-1.42L8 6.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4zM12 8c-.28 0-.53.11-.71.29L8 11.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0012 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2pJmp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.41 8L7.7 4.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C2.11 7.47 2 7.72 2 8c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L4.41 8zm5 0l3.29-3.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C7.11 7.47 7 7.72 7 8c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L9.41 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MoGk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 8c0-.28-.11-.53-.29-.71l-4-4a1.003 1.003 0 00-1.42 1.42L6.59 8 3.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4C8.89 8.53 9 8.28 9 8zm4.71-.71l-4-4a1.003 1.003 0 00-1.42 1.42L11.59 8 8.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cJ2xi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 8c.28 0 .53-.11.71-.29L8 4.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4C8.53 2.11 8.28 2 8 2s-.53.11-.71.29l-4 4A1.003 1.003 0 004 8zm4.71-.71C8.53 7.11 8.28 7 8 7s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L8 9.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kc1Rm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.86 7h4.05C15.45 3.39 12.61.52 9 .07v4.07A4 4 0 0111.86 7zM12 8c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4V0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8h-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8SU7R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.99-.01c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM11.7 9.7l-3 3c-.18.18-.43.29-.71.29s-.53-.11-.71-.29l-3-3A1.003 1.003 0 015.7 8.28l1.29 1.29V3.99c0-.55.45-1 1-1s1 .45 1 1v5.59l1.29-1.29a1.003 1.003 0 011.71.71c0 .27-.11.52-.29.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kGRPY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm8-2c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-4-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ctjb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-6c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3wmca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.9 11c-.3 0-.5.1-.7.3l-3 3c-.2.2-.3.4-.3.7 0 .6.5 1 1 1 .3 0 .5-.1.7-.3l3-3c.2-.2.3-.4.3-.7 0-.5-.4-1-1-1zm-1-1v-.2l-1-5c-.1-.3-.3-.6-.6-.7l-11-4-.3.3 5.8 5.8c.2-.1.4-.2.6-.2.8 0 1.5.7 1.5 1.5S8.3 9 7.4 9s-1.5-.7-1.5-1.5c0-.2.1-.4.2-.6L.3 1.1l-.3.3 4 11c.1.3.4.6.7.6l5 1h.2c.3 0 .5-.1.7-.3l3-3c.2-.2.3-.4.3-.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dnW9N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 0a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h6zM6 2H2v12h4V2zm2 5h4.59L11.3 5.71A.965.965 0 0111 5a1.003 1.003 0 011.71-.71l3 3c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-3 3a1.003 1.003 0 01-1.42-1.42L12.59 9H8V7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k7U6E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 0h6a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1zm7 7h4.59L11.3 5.71A.965.965 0 0111 5a1.003 1.003 0 011.71-.71l3 3c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-3 3a1.003 1.003 0 01-1.42-1.42L12.59 9H8V7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dSEd8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0a1 1 0 011 1v14a1 1 0 01-1 1H9a1 1 0 01-1-1V1a1 1 0 011-1h6zm-1 2h-4v12h4V2zM8 7H3.41L4.7 5.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L3.41 9H8V7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"zQiAd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 0h6a1 1 0 011 1v14a1 1 0 01-1 1H9a1 1 0 01-1-1V1a1 1 0 011-1zM8 7H3.41L4.7 5.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L3.41 9H8V7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3NmCq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.12 4.76h-1.05l-.76-2.12c-.19-.53-.76-1.08-1.27-1.24 0 0-1.32-.4-4.04-.4-2.72 0-4.04.4-4.04.4-.5.16-1.07.71-1.26 1.24l-.77 2.12H.88c-.48 0-.88.42-.88.94s.4.94.88.94h.38L1 7c-.03.69 0 1.44 0 2v5c0 .66.38 1 1 1s1-.34 1-1v-1h10v1c0 .66.38 1 1 1s1-.34 1-1V9c0-.56-.01-1.37 0-2l-.26-.37h.38c.48 0 .88-.42.88-.93 0-.52-.4-.94-.88-.94zM5 10H3V8h2v2zm8 0h-2V8h2v2zm0-4H3c-.18 0-.06-.82 0-1l.73-1.63C3.79 3.19 3.82 3 4 3h8c.18 0 .21.19.27.37L13 5c.06.18.18 1 0 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"376Y3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H5c-.55 0-1 .45-1 1v2h2V2h8v7h-1v2h2c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-4 4H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 10H2V6h8v8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kGxHJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.25 10.26l2.47 2.47 6.69-6.69-2.46-2.48-6.7 6.7zM.99 14.99l3.86-1.39-2.46-2.44-1.4 3.83zm12.25-14c-.48 0-.92.2-1.24.51l-1.44 1.44 2.47 2.47 1.44-1.44c.32-.32.51-.75.51-1.24.01-.95-.77-1.74-1.74-1.74z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l1gOR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 9h8a1.003 1.003 0 00.71-1.71l-4-4C8.53 3.11 8.28 3 8 3s-.53.11-.71.29l-4 4A1.003 1.003 0 004 9zm8 1H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cLURU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0a8 8 0 110 16A8 8 0 018 0zm0 1a7 7 0 100 14A7 7 0 008 1zM4 8c.228 2.262 2 4 4 4 1.938 0 3.77-1.738 3.984-3.8L12 8h1c-.128 2.888-2.317 5-5 5a5 5 0 01-4.995-4.783L3 8h1zm2-3a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fmfnj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M.594 15.394c.396.404.916.606 1.56.606.435 0 .836-.098 1.202-.295.377-.197.61-.33.936-.62v.729H6v-4.52c0-1.068-.228-1.88-.683-2.44C4.87 8.284 4.193 8 3.282 8a4.46 4.46 0 00-1.633.295c-.505.197-.96.43-1.367.7l.624 1.195c.327-.207.658-.383.995-.528a2.71 2.71 0 011.054-.217c.248 0 .456.041.624.124a.91.91 0 01.401.326c.11.135.183.295.223.482.05.176.08.362.09.559a11.95 11.95 0 00-1.946.357c-.535.155-.98.347-1.337.575a2.225 2.225 0 00-.772.823c-.159.31-.238.668-.238 1.072 0 .673.198 1.217.594 1.631zm2.911-1.01a1.509 1.509 0 01-.802.218c-.307 0-.56-.078-.757-.233-.198-.155-.297-.404-.297-.746 0-.186.044-.362.133-.528.09-.165.238-.31.446-.435.208-.134.48-.254.817-.357a7.495 7.495 0 011.247-.249v1.71c-.277.268-.54.476-.787.62zM9.64 15.755c.365.163.725.245 1.079.245.427 0 .838-.092 1.234-.276.396-.184.745-.45 1.047-.796.302-.348.542-.772.719-1.272.187-.51.281-1.088.281-1.731 0-.582-.068-1.108-.203-1.578a3.408 3.408 0 00-.594-1.195 2.54 2.54 0 00-.953-.766 2.873 2.873 0 00-1.281-.276c-.396 0-.787.087-1.172.26-.375.174-.677.399-1 .675V5H7v10.816h1.797v-.62c.3.294.465.374.772.524l.072.035zm1.985-1.854c-.344.43-.77.643-1.281.643-.23 0-.48-.045-.75-.137-.184-.065-.37-.246-.559-.43-.079-.076-.158-.153-.238-.223V10.5c.583-.562 1.146-.935 1.687-.935.584 0 1.006.21 1.266.629.26.418.39 1.006.39 1.761 0 .858-.171 1.507-.515 1.946z",
    "M13.707 1.257a3.603 3.603 0 01-.707.069v1.028h1.737V8H16V0h-.94c-.04.244-.127.45-.262.617a1.55 1.55 0 01-.475.412 1.97 1.97 0 01-.616.228z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1SYHD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.86 7.5l-.81-1.42V4.5c0-.36-.19-.68-.49-.87l-1.37-.8-.81-1.41c-.19-.31-.51-.49-.86-.49H9.89L8.5.14a.948.948 0 00-1 0l-1.39.8H4.52a1 1 0 00-.86.49l-.8 1.37-1.44.83c-.3.19-.49.51-.49.87v1.65l-.8 1.37c-.08.15-.13.32-.13.49s.05.34.14.49l.8 1.37v1.65c0 .36.19.68.49.87l1.42.81.8 1.37c.19.31.51.49.86.49H6.1l1.39.8c.15.09.32.14.48.14s.34-.05.49-.14l1.39-.8h1.63a1 1 0 00.86-.49l.81-1.41 1.37-.8c.3-.19.49-.51.49-.87V9.93l.81-1.42a.89.89 0 00.04-1.01zm-4.12-.82l-4.01 4.01c-.18.18-.43.29-.71.29s-.53-.11-.71-.29l-2-2c-.18-.19-.3-.44-.3-.71a1.003 1.003 0 011.71-.71l1.3 1.3 3.3-3.3a1.003 1.003 0 011.71.71.95.95 0 01-.29.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6L26w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 3.06v9.88L4.94 8 0 3.06zM14.94 2H1.06L8 8.94 14.94 2zm-6.41 8.53c-.14.14-.32.22-.53.22s-.39-.08-.53-.22L6 9.06 1.06 14h13.88L10 9.06l-1.47 1.47zM11.06 8L16 12.94V3.06L11.06 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fRcfF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 5h10a1 1 0 010 2H3a1 1 0 110-2zm0 4h10a1 1 0 010 2H3a1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e7e4m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.06 13.91l7.63-7.44c.41-.4.41-1.05 0-1.45L10.86.3c-.41-.4-1.08-.4-1.49 0L.31 9.13c-.41.4-.41 1.05 0 1.45l5.58 5.44h8.12v-.01c.55 0 1-.45 1-1s-.45-1-1-1H7.96l.1-.1zm-2.17.06L1.67 9.85l4.22-4.11 4.22 4.11-4.22 4.12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7671":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.99-.01c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm1 13h-2v-2h2v2zm0-3h-2v-7h2v7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iwubA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.52 3.18c.51-.27 1.12-.4 1.83-.4.48 0 .91.06 1.27.18.37.12.68.29.96.51.18.14.3.33.44.51l1.53-1.53c-.12-.11-.23-.22-.36-.32a5.61 5.61 0 00-1.74-.83c-.66-.2-1.36-.3-2.1-.3-.99 0-1.88.18-2.66.53-.79.35-1.45.82-2 1.41-.55.58-.96 1.27-1.26 2.06H2c-.55 0-1 .45-1 1s.45 1 1 1h.04c-.01.17-.04.33-.04.5 0 .17.03.33.04.5H2c-.55 0-1 .45-1 1s.45 1 1 1h.43c0 .01 0 .02.01.02a6.2 6.2 0 001.25 2.07 5.77 5.77 0 002 1.4c.78.34 1.67.51 2.66.51.81 0 1.54-.12 2.21-.36.67-.24 1.25-.59 1.75-1.03l.03-.03-1.55-1.33c-.01.01-.02.03-.03.04-.29.3-.63.53-1.02.69-.4.17-.85.25-1.37.25-.71 0-1.32-.13-1.83-.4s-.93-.62-1.25-1.07c-.19-.24-.34-.49-.46-.76H9c.55 0 1-.45 1-1s-.45-1-1-1H4.35c-.01-.17-.03-.33-.03-.5 0-.17.02-.34.03-.5H10c.55 0 1-.45 1-1s-.45-1-1-1H4.83c.13-.27.27-.52.44-.76.32-.44.74-.8 1.25-1.06zM14 8.98v0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2nO1F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.22 6a1 1 0 01.97.757l.5 2A1 1 0 0114.72 10H8a1 1 0 01-1-1V5.303a1 1 0 01.168-.555l1.535-2.303A1 1 0 019.535 2H12a1 1 0 011 1v3h1.22zm-3.89-2L9 6h2V4h-.67z",
    "M1.722 1.111A1 1 0 013.064.425L5.99 1.596a1 1 0 01.523 1.376L6 4 3 3 2 8h3l-2.237 2.11a.94.94 0 01-.948.221C.782 9.973.045 9.424.002 8.124A.883.883 0 01.03 7.88L.25 7l1.472-5.889z",
    "M3 13.5A2.5 2.5 0 015.5 11h8a2.5 2.5 0 010 5h-8A2.5 2.5 0 013 13.5zm2 0a.5.5 0 01.5-.5h8a.5.5 0 010 1h-8a.5.5 0 01-.5-.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grn2O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.99 5.99c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.89-2-2-2zm4.15 1.86a.495.495 0 10.7-.7L5.7 5.99h5.79c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H5.7l1.15-1.15a.495.495 0 10-.7-.7l-2 2c-.1.09-.16.21-.16.35s.06.26.15.35l2 2.01zm7.85-1.86c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.89-2-2-2zM9.85 8.14a.533.533 0 00-.36-.15.495.495 0 00-.35.85l1.15 1.15h-5.8c-.28 0-.5.22-.5.5s.22.5.5.5h5.79l-1.15 1.15a.495.495 0 10.7.7l2-2c.09-.09.15-.22.15-.35s-.06-.26-.15-.35l-1.98-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ztdJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 10a1.003 1.003 0 001.71.71L3 9.41l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L4.41 8 5.7 6.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L3 6.59l-1.29-1.3A1.003 1.003 0 00.29 6.71L1.59 8 .29 9.29C.11 9.47 0 9.72 0 10zm1-7h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 10H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm-1-7H9c-1.1 0-2 .9-2 2s.9 2 2 2h5c1.1 0 2-.9 2-2s-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4FeDv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 7c.28 0 .53-.11.71-.29L8 3.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4C8.53 1.11 8.28 1 8 1s-.53.11-.71.29l-4 4A1.003 1.003 0 004 7zm8 2c-.28 0-.53.11-.71.29L8 12.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0012 9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bbzHK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0a8 8 0 100 16h8V8a8 8 0 00-8-8zM6 9a1 1 0 011 1v2.49a.51.51 0 00.948.26l2.986-5.039a.47.47 0 00-.405-.71H10a1 1 0 01-1-1V3.51a.51.51 0 00-.948-.26L5.066 8.289A.471.471 0 005.47 9H6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Kcbd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 6c.28 0 .53-.11.71-.29L7 3.41V11c0 .55.45 1 1 1s1-.45 1-1V3.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4C8.53.11 8.28 0 8 0s-.53.11-.71.29l-4 4A1.003 1.003 0 004 6zm11 5c-.55 0-1 .45-1 1v2H2v-2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eq0We":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 7.97v-.02-.01-.02-.02a.672.672 0 00-.17-.36c-.49-.63-1.07-1.2-1.65-1.72l-3.16 2.26a2.978 2.978 0 01-2.98 2.9c-.31 0-.6-.06-.88-.15L5.09 12.3c.44.19.9.36 1.37.47.97.23 1.94.24 2.92.05.88-.17 1.74-.54 2.53-.98 1.25-.7 2.39-1.67 3.38-2.75.18-.2.37-.41.53-.62.09-.1.15-.22.17-.36v-.02-.02-.01-.02-.03c.01-.02.01-.03.01-.04zm-.43-4.17c.25-.18.43-.46.43-.8 0-.55-.45-1-1-1-.22 0-.41.08-.57.2l-.01-.01-2.67 1.91c-.69-.38-1.41-.69-2.17-.87a6.8 6.8 0 00-2.91-.05c-.88.18-1.74.54-2.53.99-1.25.7-2.39 1.67-3.38 2.75-.18.2-.37.41-.53.62-.23.29-.23.63-.01.92.51.66 1.11 1.25 1.73 1.79.18.16.38.29.56.44l-2.09 1.5.01.01c-.25.18-.43.46-.43.8 0 .55.45 1 1 1 .22 0 .41-.08.57-.2l.01.01 14-10-.01-.01zm-10.41 5a3.03 3.03 0 01-.11-.8 2.99 2.99 0 012.99-2.98c.62 0 1.19.21 1.66.53L5.16 8.8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gGGUq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.29 6.7c.18.18.43.29.71.29s.53-.11.71-.29l4-4c.17-.18.29-.43.29-.7a1.003 1.003 0 00-1.71-.71L11 4.58 9.71 3.29A.997.997 0 009 3c-.55 0-1 .44-1 1a1 1 0 00.3.7l1.99 2zM16 7.96v-.02-.01-.02-.02a.64.64 0 00-.17-.36c-.3-.4-.65-.76-1-1.12l-1.7 1.7c-.55.55-1.3.88-2.13.88-.06 0-.11-.01-.17-.02C10.42 10.15 9.32 11 8.01 11A3.005 3.005 0 016.4 5.46c-.24-.43-.39-.93-.39-1.46 0-.26.04-.5.1-.74-.7.2-1.37.5-2.01.86-1.26.7-2.4 1.68-3.4 2.77-.18.21-.36.41-.53.63-.22.29-.22.64 0 .93.51.67 1.12 1.27 1.73 1.81 1.33 1.17 2.85 2.15 4.53 2.55.97.23 1.95.24 2.92.05.89-.18 1.74-.54 2.54-.99 1.25-.71 2.4-1.69 3.39-2.78.18-.2.37-.41.54-.63.09-.1.15-.23.17-.37v-.02-.02-.01-.02-.03c.01-.01.01-.02.01-.03zM8.01 9c.48 0 .87-.35.96-.81a.55.55 0 01-.07-.09l-.02.01L7.8 7.03c-.45.1-.79.48-.79.96 0 .56.45 1.01 1 1.01z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kLQa3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.002 7.003a1.003 1.003 0 000 2.005 1.003 1.003 0 000-2.005zm7.988.972v-.02-.01-.02-.02a.675.675 0 00-.17-.36c-.509-.673-1.118-1.264-1.737-1.806-1.328-1.173-2.846-2.155-4.523-2.546a6.702 6.702 0 00-2.925-.06c-.889.18-1.738.541-2.546.992C2.84 4.837 1.692 5.81.694 6.902c-.18.211-.36.411-.53.632a.742.742 0 000 .932c.51.672 1.119 1.264 1.738 1.805 1.328 1.173 2.846 2.156 4.523 2.547.968.23 1.947.24 2.925.04.889-.18 1.738-.542 2.546-.993 1.248-.712 2.397-1.684 3.395-2.777.18-.2.37-.411.54-.632.09-.1.149-.23.169-.36v-.02-.02-.01-.02-.03c0-.01-.01-.01-.01-.02zm-7.988 3.038a2.998 2.998 0 01-2.995-3.008 2.998 2.998 0 012.995-3.008 2.998 2.998 0 012.996 3.008 2.998 2.998 0 01-2.996 3.008z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fHxK4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 3c-.24 0-.44.09-.62.23l-.01-.01L9 6.72V4c0-.55-.45-1-1-1-.24 0-.44.09-.62.23v-.01l-5 4 .01.01C2.16 7.41 2 7.68 2 8s.16.59.38.77v.01l5 4 .01-.01c.17.14.37.23.61.23.55 0 1-.45 1-1V9.28l4.38 3.5.01-.01c.17.14.37.23.61.23.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j1uN0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 8c0-.32-.16-.59-.38-.77l.01-.01-5-4-.01.01A.987.987 0 009 3c-.55 0-1 .45-1 1v2.72l-4.38-3.5v.01A.987.987 0 003 3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1 .24 0 .44-.09.62-.23l.01.01L8 9.28V12c0 .55.45 1 1 1 .24 0 .44-.09.62-.23l.01.01 5-4-.01-.01c.22-.18.38-.45.38-.77z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bgrRt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.99 11.99c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.89-2-2-2zm1-4c-.55 0-1 .45-1 1s.45 1 1 1c1.66 0 3 1.34 3 3 0 .55.45 1 1 1s1-.45 1-1c0-2.76-2.24-5-5-5zm0-4c-.55 0-1 .45-1 1s.45 1 1 1c3.87 0 7 3.13 7 7 0 .55.45 1 1 1s1-.45 1-1a9 9 0 00-9-9zm0-4c-.55 0-1 .45-1 1s.45 1 1 1c6.08 0 11 4.92 11 11 0 .55.45 1 1 1s1-.45 1-1c0-7.18-5.82-13-13-13z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hDik7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 2c1.06 0 2.08.16 3.06.45.13-.71.52-1.32 1.05-1.76C5.82.25 4.44 0 3 0c-.55 0-1 .45-1 1s.45 1 1 1zM2 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm8.32-6.33a.99.99 0 001.4 0l3.98-3.98c.19-.18.3-.42.3-.7 0-.55-.45-.99-1-.99-.28 0-.52.11-.7.29l-3.28 3.28-1.29-1.29a.99.99 0 00-.7-.29 1 1 0 00-1 .99c0 .27.11.52.29.7l2 1.99zm3.73.53l-.93.93-.02-.02c-.17.17-.35.33-.56.45C13.47 9.16 14 11.02 14 13c0 .55.45 1 1 1s1-.45 1-1c0-2.5-.73-4.82-1.95-6.8zM3 8c-.55 0-1 .45-1 1s.45 1 1 1c1.66 0 3 1.34 3 3 0 .55.45 1 1 1s1-.45 1-1c0-2.76-2.24-5-5-5zm5.91-.91l-.03.03-2-2 .03-.03c-.11-.11-.23-.2-.33-.33A8.9 8.9 0 003 4c-.55 0-1 .45-1 1s.45 1 1 1c3.87 0 7 3.13 7 7 0 .55.45 1 1 1s1-.45 1-1c0-1.87-.57-3.61-1.55-5.06-.61-.11-1.13-.42-1.54-.85z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cXRJy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.693 2.693a.5.5 0 00.654.047L15.44.42c.093-.07.21.047.14.14l-2.32 3.093a.5.5 0 00.047.654l.34.34a.5.5 0 010 .707l-1.47 1.47a.5.5 0 00-.142.423l.93 6.506a.5.5 0 01-.142.424l-.59.59a.5.5 0 01-.54.11L7.275 13.11a.2.2 0 00-.274.185v2.011a.5.5 0 01-.658.475L4.42 15.14a.5.5 0 01-.332-.573l.392-1.962a.2.2 0 00-.055-.18L4 12l-.424-.424a.2.2 0 00-.181-.055l-1.962.392a.5.5 0 01-.573-.332L.22 9.658A.5.5 0 01.693 9h2.01a.2.2 0 00.186-.274l-1.768-4.42a.5.5 0 01.111-.54l.59-.59a.5.5 0 01.424-.14l6.506.929a.5.5 0 00.424-.142l1.47-1.47a.5.5 0 01.707 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2IPq0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1h-5v2H6V1H1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h5v-2h4v2h5c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM4 13H2v-2h2v2zm0-3H2V8h2v2zm0-3H2V5h2v2zm0-3H2V2h2v2zm6 6H6V5h4v5zm4 3h-2v-2h2v2zm0-3h-2V8h2v2zm0-3h-2V5h2v2zm0-3h-2V2h2v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6xhUL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.99.99h-12a1.003 1.003 0 00-.71 1.71l4.71 4.71V14a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71V7.41L14.7 2.7a1.003 1.003 0 00-.71-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eM1i5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 10c-.28 0-.53.11-.71.29L12 12.59l-1.29-1.29A.965.965 0 0010 11a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 0015 10zm-3-8c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L4 6.41V12a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71V6.41l3.71-3.71c.18-.17.29-.42.29-.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7myzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 8c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1h-5c-.55 0-1 .45-1 1zm3-6c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L4 6.41V12a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71V6.41l3.71-3.71c.18-.17.29-.42.29-.7zm3 8h-5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm0 3h-5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"759iZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.707 10.293a1 1 0 010 1.414l-3 3c-.63.63-1.707.184-1.707-.707V8c0-.89 1.077-1.337 1.707-.707l3 3zM12 2c0 .28-.11.53-.29.7L8 6.41V10c0 .28-.11.53-.29.71l-2 2A1.003 1.003 0 014 12V6.41L.29 2.71A1.003 1.003 0 011 1h10c.55 0 1 .45 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1AGCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 2c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L4 6.41V12a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71V6.41l3.71-3.71c.18-.17.29-.42.29-.7zm2.41 10l1.29-1.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L13 10.59 11.71 9.3A.965.965 0 0011 9a1.003 1.003 0 00-.71 1.71l1.3 1.29-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l1.29-1.3 1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L14.41 12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fw0BJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 2c0 .28-.11.53-.29.7L12 6.41V10c0 .28-.11.53-.29.71l-2 2A1.003 1.003 0 018 12V6.41l-3.71-3.7A1.003 1.003 0 015 1h10c.55 0 1 .45 1 1zM5 12.005c-.28 0-.53-.11-.71-.29l-.29-.29v3.576c0 .55-.45 1-1 1s-1-.45-1-1v-3.585l-.29.29a1.002 1.002 0 01-1.42-1.418l2-1.998C2.47 8.11 2.72 8 3 8c.28 0 .53.11.71.29l2 1.997c.18.18.29.43.29.71 0 .559-.45 1.008-1 1.008z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8xFEH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 2c0 .28-.11.53-.29.7L12 6.41V10c0 .28-.11.53-.29.71l-2 2A1.003 1.003 0 018 12V6.41l-3.71-3.7A1.003 1.003 0 015 1h10c.55 0 1 .45 1 1zM5 11.995c-.28 0-.53.11-.71.29l-.29.29V8.998C4 8.449 3.55 8 3 8S2 8.45 2 9v3.585l-.29-.29a1.002 1.002 0 00-1.42 1.418l2 1.998c.18.18.43.29.71.29.28 0 .53-.11.71-.29l2-1.997c.18-.18.29-.43.29-.71 0-.558-.45-1.008-1-1.008z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"J3HD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.99 2.99c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1s1-.45 1-1v-11c0-.55-.45-1-1-1zm0-3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm2 3.03v7.23c2.07-2.11 5.92 1.75 9 0V3.02c-3 2.07-6.94-2.03-9 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3qNWf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.217 0c0 1.368.368 2.462 1.104 3.282C12.774 5.197 14 7.385 14 9.846c0 2.735-1.472 4.786-4.415 6.154 2.165-2.4 1.84-3.385-.368-6.4-2.342 1.2-1.967 2-1.592 3.6-.786 0-1.5 0-1.875-.4 0 .547.898 2 1.464 3.2-2.943-.82-6.092-5.744-4.988-6.154.736-.273 1.594-.137 2.575.41C3.575 5.333 5.047 1.915 9.217 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fnIVV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 8c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1zm4-4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1S7 .45 7 1v2c0 .55.45 1 1 1zM3.79 5.21a1.003 1.003 0 001.42-1.42l-1.5-1.5a1.003 1.003 0 00-1.42 1.42l1.5 1.5zm.71 5.29c-.28 0-.53.11-.71.29l-1.5 1.5a1.003 1.003 0 001.42 1.42l1.5-1.5a1.003 1.003 0 00-.71-1.71zm7-5c.28 0 .53-.11.71-.29l1.5-1.5a1.003 1.003 0 00-1.42-1.42l-1.5 1.5a1.003 1.003 0 00.71 1.71zm.71 5.29a1.003 1.003 0 00-1.42 1.42l1.5 1.5a1.003 1.003 0 001.42-1.42l-1.5-1.5zM15 7h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zM8 5C6.34 5 5 6.34 5 8s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0 3c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hTUCy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 5.326c.274 0 .541-.023.8-.069.259-.046.491-.122.697-.228a1.71 1.71 0 00.537-.412c.153-.167.252-.373.297-.617h1.063v8H2.966V6.354H1V5.326zM12.172 4.01c.55 0 .997.128 1.342.385.352.25.623.572.814.968.198.389.33.818.396 1.287.073.47.11.924.11 1.364 0 .44-.037.895-.11 1.364-.066.47-.198.902-.396 1.298-.19.389-.462.711-.814.968-.345.25-.792.374-1.342.374s-1.001-.125-1.353-.374a2.74 2.74 0 01-.814-.968 4.618 4.618 0 01-.396-1.298 9.795 9.795 0 01-.099-1.364c0-.44.033-.895.099-1.364.073-.47.205-.898.396-1.287.198-.396.47-.719.814-.968.352-.257.803-.385 1.353-.385zm0 6.963c.271 0 .499-.077.682-.231.183-.161.326-.374.429-.638.11-.271.187-.587.231-.946.044-.36.066-.74.066-1.144 0-.403-.022-.781-.066-1.133a3.724 3.724 0 00-.231-.946 1.51 1.51 0 00-.429-.638.995.995 0 00-.682-.242c-.279 0-.51.08-.693.242a1.656 1.656 0 00-.429.638 4.08 4.08 0 00-.22.946c-.044.352-.066.73-.066 1.133s.022.785.066 1.144c.044.36.117.675.22.946.11.264.253.477.429.638.183.154.414.231.693.231zM8.089 10.5H6.5v1.543h1.589V10.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fE3rY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.71 2.29l-2-2A.997.997 0 0013 0h-1v6H4V0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.28-.11-.53-.29-.71zM14 15H2V9c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v6zM11 1H9v4h2V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aH1cF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.643 6.595c.22.418.344.894.344 1.399 0 .439-.094.855-.263 1.231l3.265 3.462-.002-1.75a.973.973 0 01.314-.68.99.99 0 011.388.048c.186.2.316.46.3.715l-.009 4.03a.959.959 0 01-.3.68.972.972 0 01-.698.266l-4.053.002a.97.97 0 01-.679-.314 1.031 1.031 0 01.05-1.42.972.972 0 01.698-.266l1.7-.001-3.305-3.35a2.998 2.998 0 01-4.228-1.653H.999a1 1 0 010-2h4.166a2.998 2.998 0 014.06-1.735l3.449-3.268-1.745.002a.979.979 0 01-.631-1.692c.199-.186.459-.316.713-.3l4.025.009c.247.008.493.1.679.3.186.2.274.451.265.7l.002 4.046a.972.972 0 01-.313.68 1.03 1.03 0 01-1.42-.05.973.973 0 01-.266-.7V3.295l-3.34 3.301z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dPP6E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.702 7.31c.176.176.293.41.293.684a.976.976 0 01-.283.695c-1.888 1.91-2.892 2.918-3.011 3.027-.179.164-.42.284-.693.284a.995.995 0 01-.997-.985c0-.274.112-.541.292-.72.12-.12.624-.551 1.514-1.293H.98c-.536 0-.975-.47-.975-1.008 0-.537.439-.996.975-.996h5.837c-.895-.752-1.4-1.187-1.514-1.304a1.03 1.03 0 01-.292-.705C5.01 4.45 5.464 4 6 4c.272 0 .52.108.695.294A535.7 535.7 0 009.702 7.31zM13 11.002c-1.657 0-3-1.347-3-3.008a3.004 3.004 0 013-3.007c1.657 0 3 1.346 3 3.007a3.004 3.004 0 01-3 3.008z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b6sU3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.16 9.002H.977C.44 9.002 0 8.532 0 7.994c0-.537.44-.99.978-.99h3.18A3.01 3.01 0 016.995 5a3.01 3.01 0 012.839 2.004h2.98c-.898-.756-1.404-1.193-1.518-1.31a1.03 1.03 0 01-.293-.705c0-.538.454-.989.992-.989.274 0 .521.108.697.294.118.124 1.122 1.13 3.014 3.016a.96.96 0 01.293.684.975.975 0 01-.284.695l-3.018 3.027a.974.974 0 01-.694.284c-.553 0-1-.447-1-.985 0-.274.117-.545.293-.72l1.518-1.293H9.833A3.01 3.01 0 016.996 11 3.01 3.01 0 014.16 9.002z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2RbsJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.175 7.004a3.003 3.003 0 012.83-2.001c1.305 0 2.416.835 2.83 2.001h1.985c-.896-.756-1.401-1.193-1.515-1.31a1.03 1.03 0 01-.292-.705c0-.538.453-.989.99-.989a.95.95 0 01.696.294c.117.124 1.12 1.13 3.008 3.016.176.176.293.41.293.684a.976.976 0 01-.283.695l-3.013 3.027a.995.995 0 01-1.691-.702c0-.273.116-.544.292-.72l1.515-1.292h-1.98a3.003 3.003 0 01-2.835 2.016A3.003 3.003 0 015.17 9.002H3.18l1.515 1.292c.176.176.292.447.292.72a.995.995 0 01-1.69.702L.282 8.69A.976.976 0 010 7.994c0-.273.117-.508.293-.684A535.858 535.858 0 003.3 4.294.95.95 0 013.997 4c.537 0 .99.45.99.989 0 .273-.12.528-.292.705-.114.117-.62.554-1.515 1.31h1.995z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bLA46":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.392 10.647A3.002 3.002 0 016.16 8.995H3.37l1.338 1.318c.172.178.287.41.282.683-.01.536-.524.995-.99.995-.465 0-.63-.187-.747-.294L.281 8.682A.956.956 0 010 7.994a.971.971 0 01.294-.687l3.01-3.028a.973.973 0 01.697-.27c.536.01.998.485.989 1.021a.971.971 0 01-.295.687L3.37 6.997h2.79a3.002 3.002 0 014.106-1.716l2.416-2.277-1.732.004a.99.99 0 01-.679-.329.978.978 0 01.05-1.378c.199-.186.459-.315.714-.3l4.012.005c.248.009.493.1.68.3.185.2.273.45.264.699L15.99 6.05a.973.973 0 01-.314.679 1.03 1.03 0 01-1.421-.048.971.971 0 01-.265-.699V4.29L11.65 6.602c.219.416.343.89.343 1.394 0 .451-.1.88-.279 1.263L14 11.68l-.004-1.73a.982.982 0 01.323-.68.978.978 0 011.378.049c.187.2.316.46.3.714l-.004 4.011a.983.983 0 01-.3.691.972.972 0 01-.7.265l-4.046-.001a.987.987 0 01-.679-.326 1.017 1.017 0 01.048-1.41.972.972 0 01.699-.265h1.693l-2.315-2.35z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9LQGI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.5 6a2.5 2.5 0 00-2.45 2h-1.3L5.74 4l-.75.75L8.25 8h-3.3a2.5 2.5 0 100 1h3.3l-3.26 3.25.75.75 4.01-4h1.3a2.5 2.5 0 102.45-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9JcXp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M-.01 14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7h-16v7zm15-10H7.41L5.7 2.3a.965.965 0 00-.71-.3h-4c-.55 0-1 .45-1 1v3h16V5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ff2Mk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.165 7a3.003 3.003 0 002.827 2 3.003 3.003 0 002.827-2H16v7c0 .55-.45 1-1 1H1.01c-.55 0-1-.45-1-1V7h10.155zM8.76 6H0V3c0-.55.45-1 1-1h1.998c.28 0 .53.11.71.29L5.417 4h2.578c0 .768.29 1.469.765 2zm6.23-3c.55 0 1 .45 1 1s-.45 1-1 1h-.999v1c0 .55-.45 1-1 1-.549 0-.998-.45-.998-1V5h-1c-.55 0-1-.45-1-1s.45-1 1-1h1V2c0-.55.45-1 .999-1 .55 0 1 .45 1 1v1h.999z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5y2jj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.06 6.69c.14-.4.5-.69.94-.69h11V5c0-.55-.45-1-1-1H6.41l-1.7-1.71A.997.997 0 004 2H1c-.55 0-1 .45-1 1v9.84l2.05-6.15h.01zM16 8c0-.55-.45-1-1-1H4a.99.99 0 00-.94.69l-2 6c-.04.09-.06.2-.06.31 0 .55.45 1 1 1h11c.44 0 .81-.29.94-.69l2-6c.04-.09.06-.2.06-.31z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kuWMP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.76 5.98c-.47-.53-.77-1.22-.77-1.99h-.58L5.7 2.29a.965.965 0 00-.71-.3h-4c-.55 0-1 .45-1 1v3h8.76l.01-.01zm6.23-2.99h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59l-3.3 3.3a.99.99 0 00-.29.7 1.003 1.003 0 001.71.71l3.29-3.29V8c0 .55.45 1 1 1s1-.45 1-1V4c0-.56-.45-1.01-1-1.01zm-1.98 7.23l-.9.9-.01-.01c-.54.55-1.28.89-2.11.89-1.66 0-3-1.34-3-3 0-.77.3-1.47.78-2H-.01v7c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.18c-.31.11-.65.18-1 .18-.76-.01-1.45-.31-1.98-.78z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fyD11":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.02 10.22l-.9.9-.01-.01c-.54.55-1.28.89-2.11.89-1.66 0-3-1.34-3-3 0-.77.3-1.47.78-2H4a.99.99 0 00-.94.69l-2 6c-.04.09-.06.2-.06.31 0 .55.45 1 1 1h11c.44 0 .81-.29.94-.69l1.11-3.32c-.01 0-.03.01-.05.01-.77 0-1.45-.3-1.98-.78zM2.06 6.69c.14-.4.5-.69.94-.69h5.76l.01-.01C8.3 5.46 8 4.77 8 4H6.41l-1.7-1.71A.997.997 0 004 2H1c-.55 0-1 .45-1 1v9.84l2.05-6.15h.01zM15 3h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59l-3.3 3.29a1.003 1.003 0 001.42 1.42L14 6.41V8c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8w1Pz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.37 12.69c-1.2-.53-1.04-.85-1.08-1.29-.01-.06-.01-.12-.01-.19.41-.37.75-.87.97-1.44 0 0 .01-.03.01-.04.05-.13.09-.26.12-.39.28-.06.44-.36.5-.63.06-.11.19-.39.16-.7-.04-.4-.2-.59-.38-.67v-.07c0-.52-.05-1.26-.14-1.74a2.72 2.72 0 00-.09-.43 3.02 3.02 0 00-1.04-1.51C7.87 3.2 7.15 3 6.5 3c-.64 0-1.36.2-1.87.59-.5.38-.87.92-1.05 1.51-.04.13-.07.27-.09.4-.09.49-.14 1.24-.14 1.75v.06c-.19.07-.36.26-.4.68-.03.31.1.59.16.7.06.28.23.59.51.64.04.14.08.27.13.39 0 .01.01.02.01.02v.01c.22.59.57 1.1.99 1.46 0 .06-.01.12-.01.17-.04.44.08.76-1.12 1.29-1.2.53-3.01 1.1-3.38 1.95C-.13 15.5.02 16 .02 16h12.96s.15-.5-.22-1.36c-.38-.85-2.19-1.42-3.39-1.95zm6.33-10.4l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H9.99c-.55 0-1 .45-1 1s.45 1 1 1h2.58l-.29.29a1.003 1.003 0 001.42 1.42l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"F8IW5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.37 12.69c-1.2-.53-1.04-.85-1.08-1.29-.01-.06-.01-.12-.01-.19.41-.37.75-.87.97-1.44 0 0 .01-.03.01-.04.05-.13.09-.26.12-.39.28-.06.44-.36.5-.63.06-.11.19-.39.16-.7-.04-.4-.2-.59-.38-.67v-.07c0-.52-.05-1.26-.14-1.74a2.72 2.72 0 00-.09-.43 3.02 3.02 0 00-1.04-1.51C7.87 3.2 7.15 3 6.5 3c-.64 0-1.36.2-1.87.59-.5.38-.87.92-1.05 1.51-.04.13-.07.27-.09.4-.09.49-.14 1.24-.14 1.75v.06c-.19.07-.36.26-.4.68-.03.31.1.59.16.7.06.28.23.59.51.64.04.14.08.27.13.39 0 .01.01.02.01.02v.01c.22.59.57 1.1.99 1.46 0 .06-.01.12-.01.17-.04.44.08.76-1.12 1.29-1.2.53-3.01 1.1-3.38 1.95C-.13 15.5.02 16 .02 16h12.96s.15-.5-.22-1.36c-.38-.85-2.19-1.42-3.39-1.95zM14.99 2h-2.58l.29-.29A1.003 1.003 0 0011.28.29l-2 2c-.17.18-.29.43-.29.71 0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L12.41 4h2.58c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5CwfR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 2a1 1 0 01.928.629l3.992 9.979a1 1 0 11-1.857.742l-.94-2.35H5.877l-.94 2.35a1 1 0 11-1.857-.742l3.992-9.98A1 1 0 018 2zM6.677 9h2.646L8 5.693 6.677 9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixhCm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.7 9.29a1.003 1.003 0 00-1.42 1.42l.29.29H11.4l-5-5h6.17l-.29.29a1.003 1.003 0 001.42 1.42l2-2c.18-.18.29-.43.29-.71s-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l.29.29H.99c-.55 0-1 .45-1 1s.45 1 1 1h2.59l6.71 6.71c.18.18.43.29.71.29h1.59l-.29.29a1.003 1.003 0 001.42 1.42l2-2c.18-.18.29-.43.29-.71s-.11-.53-.29-.71l-2.02-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4PBfn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 11v2h2v-2H2zM1 9h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1zm9-6h5c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1zM6 1a1.003 1.003 0 01.71 1.71l-3 4C3.53 6.89 3.28 7 3 7s-.53-.11-.71-.29l-2-2a1.003 1.003 0 011.42-1.42L3 4.59l2.29-3.3C5.47 1.11 5.72 1 6 1zm4 10h5c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7BQXb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.002 16a6.763 6.763 0 01-2.732-.556 7.08 7.08 0 01-2.221-1.509 7.149 7.149 0 01-1.498-2.237A6.896 6.896 0 011 8.947c0-.979.184-1.895.551-2.748a7.114 7.114 0 011.503-2.234 7.147 7.147 0 012.225-1.51A6.755 6.755 0 018.01 1.9h.111l-.47-.474a.803.803 0 01-.244-.583c0-.226.077-.42.233-.583A.795.795 0 018.228 0a.783.783 0 01.588.24l1.93 1.945a.97.97 0 01.294.7c0 .268-.098.5-.294.697l-1.93 1.946a.783.783 0 01-.588.24.811.811 0 01-.588-.249.822.822 0 01-.238-.578.779.779 0 01.238-.577l.491-.496h-.12c-1.404 0-2.597.493-3.581 1.478S2.954 7.53 2.954 8.944c0 1.414.49 2.616 1.469 3.604.979.989 2.171 1.483 3.577 1.483 1.406 0 2.598-.493 3.577-1.478.98-.985 1.47-2.184 1.47-3.598 0-.274.094-.506.284-.698a.938.938 0 01.692-.287c.271 0 .502.096.692.287.19.192.285.424.285.698 0 .97-.184 1.884-.551 2.741a7.14 7.14 0 01-1.498 2.239 7.086 7.086 0 01-2.219 1.51 6.748 6.748 0 01-2.73.555z",
    "M10 8H9v3h1V8zM9 7a1 1 0 00-1 1v3a1 1 0 001 1h1a1 1 0 001-1V8a1 1 0 00-1-1H9z",
    "M5.5 7a.5.5 0 000 1H6v3.5a.5.5 0 001 0V8a1 1 0 00-1-1h-.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9w9Kz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.949 1H0v2h2c.31 0 .6.161.762.426l1.965 3.193-1.352 1.08A1 1 0 003 8.482V13.9c0 .607.448 1.1 1 1.1h11c.552 0 1-.492 1-1.1V2s0-1-1-1H9c-.5 0-1 .5-1 1v2L6.388 5.29 4.455 2.35A3 3 0 001.95 1zM14 3v1h-4V3h4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lg1sK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0a8 8 0 100 16A8 8 0 108 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4GucW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 12h1c.55 0 1-.45 1-1V8h-3v3c0 .55.45 1 1 1zM10 2c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v3h3V2zm0 4H7v3h3V6zm5-4c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v2h3V2zm0 3h-3v2h3V5zM5 5H2v3h3V5zm-2 7h1c.55 0 1-.45 1-1V9H2v2c0 .55.45 1 1 1zm12 1H2c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1s-.45-1-1-1zM5 2c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v2h3V2zm3 10h1c.55 0 1-.45 1-1v-1H7v1c0 .55.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fsht4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.41 2H5c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v4c0 .55.45 1 1 1s1-.45 1-1V3.41L5.29 6.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L3.41 2zM6 9c-.28 0-.53.11-.71.29L2 12.59V11c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.41l3.29-3.29c.19-.18.3-.43.3-.71 0-.55-.45-1-1-1zm9 1c-.55 0-1 .45-1 1v1.59L10.71 9.3A.965.965 0 0010 9a1.003 1.003 0 00-.71 1.71l3.3 3.29H11c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm0-10h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59l-3.3 3.29a1.003 1.003 0 001.42 1.42L14 3.41V5c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e3m3t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.12 4.74H6.98c.33-1.29.75-2.24 1.28-2.84.33-.37.64-.56.95-.56.06 0 .11.02.15.05.04.04.06.09.06.15 0 .05-.04.15-.13.29-.09.14-.13.28-.13.4 0 .18.07.33.2.46.14.13.31.19.52.19.22 0 .41-.08.56-.23.15-.16.23-.37.23-.63 0-.3-.11-.55-.34-.74C10.1 1.09 9.74 1 9.24 1c-.78 0-1.49.22-2.12.67-.64.45-1.24 1.2-1.81 2.23-.2.36-.38.59-.56.69-.18.1-.46.15-.85.15l-.26.9h1.08l-1.59 6.12c-.27 1.01-.44 1.63-.54 1.86-.14.34-.34.63-.62.87-.11.1-.24.15-.4.15a.15.15 0 01-.11-.04l-.04-.05c0-.03.04-.08.12-.16.08-.08.12-.2.12-.36 0-.18-.06-.33-.19-.44-.12-.12-.3-.18-.54-.18-.28 0-.51.08-.68.23-.16.14-.25.32-.25.53 0 .22.1.42.31.59.21.17.53.25.97.25.7 0 1.32-.18 1.87-.54.54-.36 1.02-.92 1.42-1.67.41-.75.82-1.96 1.25-3.63l.91-3.54h1.1l.29-.89zm5.43 1.52c.2-.15.41-.23.62-.23.08 0 .23.03.45.09s.41.09.57.09c.23 0 .42-.08.57-.23.16-.16.24-.36.24-.61 0-.26-.08-.47-.23-.62-.15-.15-.37-.23-.66-.23-.25 0-.5.06-.72.18-.23.12-.51.38-.86.78-.26.3-.64.81-1.15 1.55-.2-.91-.55-1.75-1.05-2.51l-2.72.46-.06.29c.2-.04.37-.06.51-.06.27 0 .49.11.67.34.28.36.67 1.45 1.17 3.26-.39.52-.66.85-.8 1.01-.24.26-.44.42-.59.5-.12.06-.25.09-.41.09-.11 0-.3-.06-.56-.18-.18-.08-.34-.12-.48-.12-.27 0-.48.08-.66.25-.17.17-.26.38-.26.64 0 .25.08.44.24.6.16.15.37.23.64.23.26 0 .5-.05.73-.16.23-.11.52-.34.86-.69.35-.35.82-.9 1.43-1.67.23.73.44 1.25.61 1.58s.37.57.59.71c.22.15.5.22.83.22.32 0 .65-.11.98-.34.44-.3.88-.81 1.34-1.53l-.26-.15c-.31.43-.54.7-.69.8-.1.07-.22.1-.35.1-.16 0-.32-.1-.48-.3-.27-.34-.62-1.27-1.06-2.8.4-.68.73-1.13 1-1.34z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6xRXE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 10c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1zM6 7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1zm9 5H2V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM4 5h3c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8M4r5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 11a1 1 0 00-1-1H4.8a.8.8 0 01-.706-1.176L8.588.397A.75.75 0 0110 .75V5a1 1 0 001 1h1.2a.8.8 0 01.706 1.176l-4.494 8.427A.75.75 0 017 15.25V11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gDBI7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 9c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-1.59l-3.29 3.3A1.003 1.003 0 010 15c0-.28.11-.53.3-.71L3.59 11H2c-.55 0-1-.45-1-1s.45-1 1-1zM9.088.004l.097.013.097.024.057.018.1.042.054.029.095.061.052.04 6 5 .05.046.076.08.053.07.06.095.051.11c.056.141.079.294.067.446l-.014.105-.037.143-.035.087-.043.083-4 7-.034.056-.059.08-.038.044-.096.092-.114.082-.116.062-.086.034-.109.03-.1.017-.069.006H8.83c.088-.25.144-.515.163-.79L9 13v-3a3 3 0 00-2.824-2.995L6 7H3c-.351 0-.689.06-1.002.171L2 5l.002-.07.013-.1.015-.073.025-.085.043-.104.056-.101.045-.066.079-.093.084-.078.083-.062 6-4 .07-.043.12-.056.111-.036.108-.022.083-.01h.031c.046-.002.083 0 .12.003z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fTToL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M-.01 6.66l7.34 2 2 7.33 6.66-16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6GEZN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.82 12.4h.66c.23 0 .36-.17.36-.4v-1.48l.19-.18c-.27.03-.55.06-.83.06-.28 0-.56-.03-.84-.07.02.04.05.08.07.13V12c0 .23.15.4.39.4zM6.4 15.1A5.51 5.51 0 01.9 9.6c0-.49.06-.98.18-1.43.03 0 .05-.01.08-.01h.08v.44c0 .19.17.34.36.34.03 0 .07-.01.1-.01l.71.7c.07.07.19.07.26 0s.07-.19 0-.26l-.7-.72c0-.02.03-.03.03-.05v-.11c0-.15.08-.2.23-.33h.42c.08 0 .15-.01.22-.04h.02c.02-.02.03-.02.04-.04.01-.01.01-.01.02-.01l.02-.01.9-.9c-.13-.26-.24-.52-.34-.8h-.5v-.43c0-.01.05.05.04-.08h.31c-.03-.13-.06-.26-.08-.39h-.57c.16-.12.34-.24.51-.36-.02-.23-.04-.46-.04-.7 0-.12.01-.23.02-.34A6.385 6.385 0 000 9.6C0 13.13 2.87 16 6.4 16c3.1 0 5.67-2.22 6.26-5.15l-.78-.88c-.21 2.85-2.58 5.13-5.48 5.13zm-1.7-2.93v-.28h.12c.23 0 .39-.19.39-.42v-.54s.01-.01 0-.01L3.77 9.45h-.62c-.23 0-.38.19-.38.42v1.6c0 .23.14.42.38.42h.26v1.61c0 .23.22.41.45.41s.45-.18.45-.41v-.97H4.3c.24 0 .4-.13.4-.36zm11.07-2.34l-2.94-2.94c.11-.17.21-.34.3-.52.01-.03.03-.06.04-.09.08-.18.16-.36.22-.55v-.01c.06-.19.1-.38.14-.58.01-.05.01-.09.02-.14.03-.2.05-.4.05-.61a4.4 4.4 0 00-4.4-4.4C6.77 0 4.8 1.97 4.8 4.4s1.97 4.4 4.4 4.4c.21 0 .41-.02.61-.05.04 0 .09-.01.14-.02.2-.03.39-.08.58-.14h.01c.19-.06.37-.14.55-.22.03-.01.06-.03.09-.04.18-.09.35-.19.52-.3l2.94 2.94a.8.8 0 00.57.23c.44 0 .8-.36.8-.8a.895.895 0 00-.24-.57zM9.2 7.6C7.43 7.6 6 6.17 6 4.4c0-1.77 1.43-3.2 3.2-3.2s3.2 1.43 3.2 3.2c0 1.77-1.43 3.2-3.2 3.2zm1.54 4.26v-.52c0-.09-.1-.17-.19-.17s-.19.07-.19.17v.52c0 .09.1.17.19.17s.19-.07.19-.17z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Jm0Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.444 6C10.544 6 9 7.494 9 9.331 9 11.175 12.444 16 12.444 16s3.443-4.825 3.443-6.669C15.881 7.494 14.345 6 12.444 6zm.056 5a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0112.5 11z",
    "M0 6c0-3.315 2.685-6 6-6a6 6 0 015.923 5.036 4.576 4.576 0 00-1.454.433A4.505 4.505 0 006 1.5 4.504 4.504 0 001.5 6a4.504 4.504 0 006.58 3.99c.093.425.265.913.488 1.435A5.98 5.98 0 016 12c-3.315 0-6-2.685-6-6z",
    "M6.75 3.75v1.942l1.283 1.276a.752.752 0 01-1.065 1.065l-1.5-1.5A.748.748 0 015.25 6V3.75c0-.412.338-.75.75-.75s.75.338.75.75z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Y2Bl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 1c-1.66 0-3 1.34-3 3 0 1.25.76 2.32 1.85 2.77A2.02 2.02 0 019 8H7c-.73 0-1.41.2-2 .55V5.82C6.16 5.4 7 4.3 7 3c0-1.66-1.34-3-3-3S1 1.34 1 3c0 1.3.84 2.4 2 2.82v4.37c-1.16.4-2 1.51-2 2.81 0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.04-.53-1.95-1.32-2.49.35-.31.81-.51 1.32-.51h2c1.92 0 3.52-1.35 3.91-3.15A2.996 2.996 0 0012 1zM4 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7rNAB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 7h-3.14c-.45-1.72-2-3-3.86-3S4.59 5.28 4.14 7H1c-.55 0-1 .45-1 1s.45 1 1 1h3.14c.45 1.72 2 3 3.86 3s3.41-1.28 3.86-3H15c.55 0 1-.45 1-1s-.45-1-1-1zm-7 3c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kkU0A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 6c-1.3 0-2.4.84-2.82 2H9c-1.62 0-3-.96-3.63-2.34C6.33 5.16 7 4.16 7 3c0-1.66-1.34-3-3-3S1 1.34 1 3c0 1.3.84 2.4 2 2.81v4.37C1.84 10.6 1 11.7 1 13c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82V8.43A5.89 5.89 0 009 10h.18A2.996 2.996 0 0015 9c0-1.66-1.34-3-3-3zm-8 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kI3Jv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1zm-3.18 4.8C10.51 7.51 9.82 8 9 8H7c-.73 0-1.41.2-2 .55V5.82C6.16 5.4 7 4.3 7 3c0-1.66-1.34-3-3-3S1 1.34 1 3c0 1.3.84 2.4 2 2.82v4.37c-1.16.4-2 1.51-2 2.81 0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.04-.53-1.95-1.32-2.49.35-.31.81-.51 1.32-.51h2c1.9 0 3.49-1.33 3.89-3.11-.29.07-.58.11-.89.11-.41 0-.8-.08-1.18-.2zM4 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8OvDd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 1C1.34 1 0 2.34 0 4c0 1.3.84 2.4 2 2.82v3.37C.84 10.6 0 11.7 0 13c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82V6.82C5.16 6.4 6 5.3 6 4c0-1.66-1.34-3-3-3zm0 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm11 5.18V6c0-1.66-1.34-3-3-3H9.41l1.29-1.29c.19-.18.3-.43.3-.71A1.003 1.003 0 009.29.29l-3 3C6.11 3.47 6 3.72 6 4c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L9.41 5H11c.55 0 1 .45 1 1v4.18A2.996 2.996 0 0013 16c1.66 0 3-1.34 3-3 0-1.3-.84-2.4-2-2.82zM13 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gdmPZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 6h1V5H4v1zm9 3c0-.28-.11-.53-.29-.71l-3-3C9.53 5.11 9.28 5 9 5s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L8 8.41V15c0 .55.45 1 1 1s1-.45 1-1V8.41l1.29 1.29c.18.19.43.3.71.3.55 0 1-.45 1-1zM5 3H4v1h1V3zm10-3H1C.45 0 0 .45 0 1v13c0 .55.45 1 1 1h5v-2H2v-1h4v-1H3V2h11v9h-2v1h2v1h-2v2h3c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5KEgY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 9H4v1h1V9zm10-9H1C.45 0 0 .45 0 1v13c0 .55.45 1 1 1h3v1l2-1 2 1v-1h7c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM4 13H2v-1h2v1zm10 0H8v-1h6v1zm0-2H3V2h11v9zM5 3H4v1h1V3zm0 4H4v1h1V7zm0-2H4v1h1V5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"haIAs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 0v4c0 2.97 2.16 5.43 5 5.91V14H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H9V9.91c2.84-.48 5-2.94 5-5.91V0H2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ddtp9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.45 7.83c-.26 0-.41.21-.41.46v1.75c0 .26.16.46.41.46h.29v1.77c0 .25.24.45.49.45s.49-.2.49-.45V11.2h-.01c.26 0 .44-.14.44-.4v-.3h.14c.26 0 .43-.2.43-.46v-.59s.01-.01 0-.01l-1.58-1.6h-.69zM8.51 3.9h.22c.06 0 .12-.01.12-.07 0-.06-.05-.07-.12-.07h-.22c-.06 0-.12.01-.12.07.01.06.06.07.12.07zm-2.33-.05c.07-.07.07-.19 0-.26l-.5-.5a.187.187 0 00-.26 0c-.07.07-.07.19 0 .26l.5.5c.07.07.19.07.26 0zm3.06.89c.07 0 .14-.06.14-.12v-.31c0-.07-.07-.12-.14-.12s-.14.06-.14.12v.31c0 .07.07.12.14.12zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-.55.1-1.07.23-1.57h.11v.47c0 .2.18.37.39.37.03 0 .08-.01.11-.02l.78.77c.08.08.2.08.28 0 .08-.08.08-.2 0-.28l-.75-.78c0-.02.04-.04.04-.06v-.12c0-.16.09-.22.25-.36h.46c.09 0 .17-.01.24-.05h.02c.02-.01.03-.02.05-.03.01-.01.01-.01.02-.01l.02-.02 1.59-1.58c.18-.18.18-.46 0-.64s-.47-.15-.65.03l-.3.34h-.57v-.48c0-.01.05.05.05-.09h.64c.12 0 .22-.09.22-.21s-.1-.21-.22-.21H4.1c.18-.15.34-.31.54-.44l.01-.01c.21-.14.45-.25.68-.37.15-.07.29-.15.44-.21.17-.07.35-.11.53-.17.18-.05.35-.12.53-.16a6.05 6.05 0 013.47.35c.05.02.1.05.16.08.25.11.48.24.71.39.25.16.49.34.71.55H10.6s0-.03-.01-.03c-.04 0-.09 0-.13.03l-.51.51a.17.17 0 000 .23c.06.06.17.06.23 0l.42-.44.01-.02h.25c0 .14-.07.09-.07.12v.07c0 .22-.15.37-.36.37h-.38c-.19 0-.38.21-.38.4v.17h-.1c-.12 0-.2.06-.2.18v.25h-.23c-.17 0-.3.11-.3.28 0 .17.13.26.3.26.07 0 .14.03.19-.11l.04.01.49-.46h.17l.39.37c.03.03.08.02.12-.01.03-.03.03-.12 0-.15l-.32-.35h.23l.09.12c.18.18.48.17.66-.01l.09-.1h.4c.02 0 .08.05.08.05v.24l-.05-.01h-.36c-.11 0-.21.1-.21.21 0 .11.09.21.21.21h.41v.15c-.14.21-.24.42-.45.42h-.94v-.01l-.44-.44a.47.47 0 00-.66 0l-.42.43v.01H8.6c-.26 0-.49.21-.49.46v.92c0 .26.23.45.49.45h.9c.34.14.57.35.72.69v1.68c0 .26.17.44.42.44h.72c.26 0 .4-.18.4-.44V9l.89-.86.03-.02.02-.01h.03c.07-.08.15-.19.15-.31v-.91c0-.18-.16-.32-.31-.46H13c.01.28.21.42.46.42h.42c.08.37.12.76.12 1.15 0 3.31-2.69 6-6 6zm4.54-4.27c-.1 0-.21.08-.21.18v.57c0 .1.11.18.21.18.1 0 .21-.08.21-.18v-.57c0-.1-.11-.18-.21-.18zM8.37 3.19c0-.25-.2-.42-.46-.42h-.54c-.25 0-.42.18-.42.43 0 .03-.1.04.05.08v.47c0 .15.06.27.21.27s.21-.12.21-.27v-.14h.5c.24 0 .45-.16.45-.42z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hO5vO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm5.17 5h-2.44c-.21-1.11-.51-2.03-.91-2.69 1.43.46 2.61 1.43 3.35 2.69zM10 8c0 .73-.05 1.39-.12 2H6.12C6.05 9.39 6 8.73 6 8s.05-1.39.12-2h3.76c.07.61.12 1.27.12 2zM8 2c.67 0 1.36 1.1 1.73 3H6.27C6.64 3.1 7.33 2 8 2zm-1.82.31c-.4.66-.71 1.58-.91 2.69H2.83a6.025 6.025 0 013.35-2.69zM2 8c0-.7.13-1.37.35-2h2.76C5.04 6.62 5 7.28 5 8s.04 1.38.11 2H2.35C2.13 9.37 2 8.7 2 8zm.83 3h2.44c.21 1.11.51 2.03.91 2.69A6.025 6.025 0 012.83 11zM8 14c-.67 0-1.36-1.1-1.73-3h3.46c-.37 1.9-1.06 3-1.73 3zm1.82-.31c.4-.66.7-1.58.91-2.69h2.44a6.025 6.025 0 01-3.35 2.69zM13.65 10h-2.76c.07-.62.11-1.28.11-2s-.04-1.38-.11-2h2.76c.22.63.35 1.3.35 2s-.13 1.37-.35 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bS5vy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.693 5a2.385 2.385 0 00.767 1H6.12C6.05 6.61 6 7.27 6 8s.05 1.39.12 2h3.76c.053-.46.094-.947.111-1.472a2.384 2.384 0 00.964.76c-.017.244-.039.48-.065.712h2.76c.159-.454.27-.93.32-1.422A2.53 2.53 0 0014.5 7v-.5h.5c.28 0 .563-.042.834-.131A7.998 7.998 0 018 16c-4.42 0-8-3.58-8-8A7.998 7.998 0 019.631.166 2.67 2.67 0 009.5 1v.5H9C7.476 1.5 6.5 2.77 6.5 4v.048c-.086.29-.163.608-.23.952h.423zM5.27 5c.2-1.11.51-2.03.91-2.69A6.025 6.025 0 002.83 5h2.44zM2.35 6C2.13 6.63 2 7.3 2 8s.13 1.37.35 2h2.76C5.04 9.38 5 8.72 5 8s.04-1.38.11-2H2.35zm2.92 5H2.83a6.025 6.025 0 003.35 2.69c-.4-.66-.7-1.58-.91-2.69zm1 0c.37 1.9 1.06 3 1.73 3 .67 0 1.36-1.1 1.73-3H6.27zm4.46 0c-.21 1.11-.51 2.03-.91 2.69A6.025 6.025 0 0013.17 11h-2.44z",
    "M9 5c-.6 0-1-.4-1-1 0-.5.4-1 1-1h2V1c0-.6.4-1 1-1s1 .4 1 1v2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1s-1-.4-1-1V5H9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fBHt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 3c-1.06 0-1.92.83-1.99 1.88l-1.93.97A2.95 2.95 0 008 5c-.56 0-1.08.16-1.52.43L3.97 3.34C3.98 3.23 4 3.12 4 3c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.24 0 .47-.05.68-.13l2.51 2.09C5.08 7.29 5 7.63 5 8c0 .96.46 1.81 1.16 2.35l-.56 1.69c-.91.19-1.6.99-1.6 1.96 0 1.1.9 2 2 2s2-.9 2-2c0-.51-.2-.97-.51-1.32l.56-1.69A2.99 2.99 0 0011 8c0-.12-.02-.24-.04-.36l1.94-.97c.32.21.69.33 1.1.33 1.1 0 2-.9 2-2s-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5qbq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.89 8.11l-.01.01-.38-.38-.38.38-.02-.02c-.54.55-1.27.9-2.1.9-1.66 0-3-1.34-3-3 0-.83.35-1.56.9-2.1l-.02-.02.38-.38-.38-.38.01-.01C7.35 2.57 7 1.83 7 1c0-.34.07-.65.17-.96A8.004 8.004 0 000 8c0 4.42 3.58 8 8 8 4.14 0 7.54-3.14 7.96-7.17-.31.1-.62.17-.96.17-.83 0-1.57-.35-2.11-.89zm1.02-4.61l1.79-1.79c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-1.79 1.8L10.71.3A.965.965 0 0010 0a1.003 1.003 0 00-.71 1.71l1.79 1.79-1.79 1.79a1.003 1.003 0 001.42 1.42l1.79-1.79 1.79 1.79a1.003 1.003 0 001.42-1.42l-1.8-1.79z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1oJTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.713 5.958a1 1 0 01.574-1.916l10 3c.95.285.95 1.63 0 1.916l-10 3a1 1 0 01-.574-1.916L9.52 8 2.713 5.958z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iFB7U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.713 3.958a1 1 0 01.574-1.916l10 3c.95.285.95 1.63 0 1.916l-10 3a1 1 0 01-.574-1.916L9.52 6 2.713 3.958zM3 12h10a1 1 0 010 2H3a1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Fn0o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 9c.55 0 1-.45 1-1s-.45-1-1-1h-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1H9V1c0-.55-.45-1-1-1S7 .45 7 1v1H4V1c0-.55-.45-1-1-1S2 .45 2 1v1H1c-.55 0-1 .45-1 1s.45 1 1 1h1v3H1c-.55 0-1 .45-1 1s.45 1 1 1h1v3H1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h3v1c0 .55.45 1 1 1s1-.45 1-1v-1h3v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V9h1zm-8 3H4V9h3v3zm0-5H4V4h3v3zm5 5H9V9h3v3zm0-5H9V4h3v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJaej":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 1v6h7V0H1C.45 0 0 .45 0 1zm0 14c0 .55.45 1 1 1h6V9H0v6zM15 0H9v7h7V1c0-.55-.45-1-1-1zM9 16h6c.55 0 1-.45 1-1V9H9v7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hBJY1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.602 3.121a1 1 0 000 1.415l2.828 2.828a1 1 0 001.415 0l2.828-2.828a1 1 0 000-1.415L12.845.293a1 1 0 00-1.415 0L8.602 3.12z",
    "M0 1.005a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1H1a1 1 0 01-1-1v-5zm2 4v-3h3v3H2zM10 9.005a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1v-5a1 1 0 00-1-1h-5zm1 2v3h3v-3h-3zM0 10.005a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1H1a1 1 0 01-1-1v-5zm2 4v-3h3v3H2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2l0Sf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6-3H5C2.24 3 0 5.24 0 8s2.24 5 5 5h6c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 9H5c-2.21 0-4-1.79-4-4s1.79-4 4-4h6c2.21 0 4 1.79 4 4s-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j9dwt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 12c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1zm3 0c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1zm2 1H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm-9-1c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1zm-3 0c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1v9c0 .55.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2PnuF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 5c0-.55-.45-1-1-1-.41 0-.76.24-.91.59v.01s0 .01-.01.01L11.57 8h-.36l.78-4.84C12 3.11 12 3.05 12 3a1 1 0 00-1.99-.16v.01L9.18 8H9V1c0-.55-.45-1-1-1S7 .45 7 1v7h-.09l-.93-5.18A1 1 0 005 2c-.55 0-1 .45-1 1 0 .05 0 .11.01.16L5.26 11h-.04L2.83 7.44C2.65 7.18 2.35 7 2 7c-.55 0-1 .45-1 1 0 .17.04.33.12.47l3 5.69h.01v.01A5.002 5.002 0 0013 11v-.59l1.93-5.05c.05-.11.07-.23.07-.36z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9yFma":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.72 7.87c-1.54-.67-2.99-2.68-3.7-3.95C10.11 1.95 9.93 0 6.14 0 4.05 0 2.71.61 1.92 2.12 1.27 3.36 1 5.21 1 7.83v.79c0 .65.6 1.18 1.35 1.18.34 0 .64-.11.88-.29.17.48.68.84 1.29.84.41 0 .78-.16 1.03-.42.23.37.67.63 1.19.63.57 0 1.05-.31 1.25-.74l.01.63v4.05c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V7.9c.58.41 1.55 1.21 2.47 1.29 1.57.14 1.82-1.07 1.25-1.32z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"amvZB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.08 4.97c-1.26-.71-3.27-2.15-3.95-3.7C7.88.7 6.67.96 6.81 2.52c.09.93.89 1.9 1.3 2.48H1.5C.67 5 0 5.67 0 6.5S.67 8 1.5 8h4.05l.63.01c-.44.2-.75.69-.75 1.25 0 .52.26.96.63 1.19-.26.25-.42.61-.42 1.03 0 .61.35 1.12.84 1.29-.18.24-.29.54-.29.88 0 .75.54 1.35 1.19 1.35h.79c2.62 0 4.47-.28 5.71-.92 1.51-.79 2.12-2.14 2.12-4.22 0-3.79-1.95-3.97-3.92-4.89z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fT7wp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.5 5H7.89c.41-.58 1.21-1.55 1.3-2.47C9.34.97 8.12.71 7.87 1.28c-.67 1.54-2.68 2.99-3.95 3.7C1.95 5.89 0 6.07 0 9.86c0 2.09.61 3.43 2.12 4.22 1.24.65 3.09.92 5.71.92h.79c.65 0 1.18-.6 1.18-1.35 0-.34-.11-.64-.29-.88.48-.17.84-.68.84-1.29 0-.41-.16-.78-.42-1.03.37-.23.63-.67.63-1.19 0-.57-.31-1.05-.74-1.25l.63-.01h4.05c.83 0 1.5-.67 1.5-1.5S15.33 5 14.5 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7cDD3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.65 6.19c-.34 0-.64.11-.88.29-.17-.48-.68-.84-1.29-.84-.41 0-.78.16-1.03.42-.23-.37-.67-.63-1.19-.63-.57 0-1.05.31-1.25.74L8 5.55V1.5C8 .67 7.33 0 6.5 0S5 .67 5 1.5v6.61c-.58-.41-1.55-1.21-2.48-1.3C.96 6.67.7 7.88 1.28 8.13c1.54.67 2.99 2.68 3.7 3.95C5.89 14.05 6.07 16 9.86 16c2.09 0 3.43-.61 4.22-2.12.64-1.24.92-3.09.92-5.71v-.79c0-.65-.6-1.19-1.35-1.19z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"51KEm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 10c.495 0 .933.379.993.882L16 11v.505c0 1.461-3.524 2.45-7.707 2.493L8 14c-4.31 0-8-1-8-2.495V11c0-.561.466-1 1-1 .895 0 3 1 7 1l.381-.003C12.135 10.937 14.134 10 15 10zm-4-8c1.13 0 2.02 2.153 2.671 6.46-1.063.266-2.644.652-4.887.727l-.403.01L8 9.2c-2.664 0-4.488-.444-5.673-.74C2.98 4.153 3.87 2 5 2c2 0 1.329 2 3 2s1-2 3-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fxmxU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 2c-.55 0-1 .45-1 1v4H5V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V9h6v4c0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"syqnp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.06 8c-.04.23-.12.44-.25.61-.13.17-.29.3-.48.41-.18.11-.39.18-.62.23-.23.04-.46.07-.71.07v1.03h1.74V16H15V8h-.94zM7 2c-.56 0-1 .45-1 1v4H2V3c0-.55-.45-1-1-1-.56 0-1 .45-1 1v10c0 .55.45 1 1 1 .56 0 1-.45 1-1V9h4v4c0 .55.45 1 1 1 .56 0 1-.45 1-1V3c0-.54-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bL1Wk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 2c-.56 0-1 .45-1 1v10c0 .54.45 1 1 1 .56 0 1-.45 1-1V9h4v4c0 .54.45 1 1 1 .56 0 1-.45 1-1V3c0-.54-.45-1-1-1-.56 0-1 .45-1 1v4H2V3c0-.54-.45-1-1-1zm13.71 9.73c.41.08.72.3.95.651.23.35.34.772.34 1.273 0 .371-.07.702-.2.973-.14.29-.32.54-.55.741-.23.2-.5.361-.8.472-.3.11-.62.16-.96.16-.41 0-.77-.06-1.08-.19-.31-.12-.56-.311-.77-.542a2.43 2.43 0 01-.47-.852c-.11-.33-.16-.702-.17-1.103h1.14c-.01.471.09.862.32 1.173.23.311.57.471 1.02.471.39 0 .71-.12.97-.36.26-.241.39-.582.39-1.023 0-.3-.05-.531-.16-.712-.11-.17-.25-.31-.43-.4a1.56 1.56 0 00-.59-.171c-.22-.02-.44-.03-.67-.02v-.933c.19.01.38 0 .57-.04.19-.03.36-.1.51-.19.14-.09.26-.22.35-.381.09-.16.14-.361.14-.592 0-.33-.1-.591-.31-.792-.2-.2-.47-.3-.79-.3a.99.99 0 00-.53.13c-.15.09-.27.21-.37.36-.1.151-.17.322-.22.512-.05.19-.07.381-.06.582h-1.15c.01-.381.08-.722.19-1.043.11-.32.27-.602.47-.832.19-.23.44-.421.72-.552.28-.13.6-.2.96-.2.28 0 .55.04.82.13.27.08.51.21.72.381.21.17.38.381.51.642.13.26.19.561.19.902 0 .391-.08.732-.24 1.023-.16.29-.42.5-.76.631v.02z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"908vC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 2c-.56 0-1 .45-1 1v10c0 .54.45 1 1 1 .56 0 1-.45 1-1V9h4v4c0 .54.45 1 1 1 .56 0 1-.45 1-1V3c0-.54-.45-1-1-1-.56 0-1 .45-1 1v4H2V3c0-.54-.45-1-1-1zm12.154 11.944l.016-.014c.18-.14.36-.28.57-.42l.63-.45c.21-.16.41-.33.61-.51s.37-.38.52-.59c.15-.21.28-.45.37-.7.09-.25.13-.54.13-.85 0-.25-.04-.51-.12-.79-.07-.29-.2-.55-.39-.79a2.18 2.18 0 00-.73-.6c-.29-.15-.66-.23-1.11-.23-.4 0-.76.08-1.07.23-.31.16-.58.37-.79.62-.22.27-.38.59-.49.96-.11.37-.16.77-.16 1.2h1.19c.01-.27.03-.53.08-.77.04-.24.11-.45.21-.62.09-.18.22-.32.38-.42.16-.1.35-.15.59-.15.26 0 .47.05.63.14.15.09.28.21.37.35.09.14.15.29.18.45.03.16.05.31.05.45-.01.31-.08.58-.22.82-.14.23-.32.45-.53.65-.22.21-.46.39-.71.57-.26.18-.51.36-.75.54-.5.36-.89.78-1.17 1.27-.28.49-.43 1.06-.44 1.71h4.99v-1.14h-3.55c.05-.17.14-.33.27-.49.126-.145.28-.281.444-.426z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ikehX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.85 6.34C14.18 2.72 11.37 0 8 0S1.82 2.72 1.15 6.34C.47 6.9 0 8.1 0 9.5 0 11.43.9 13 2 13c0 1.1.9 2 2 2h2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1H4c-.55 0-1-.45-1-1 .55 0 1-.45 1-1V7c0-.45-.3-.81-.71-.94C3.97 3.7 5.81 2 8 2s4.03 1.7 4.71 4.06c-.41.13-.71.49-.71.94v5c0 .55.45 1 1 1h1c1.1 0 2-1.57 2-3.5 0-1.4-.47-2.6-1.15-3.16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9wlmL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 5.095c0-2.255-1.88-4.083-4.2-4.083-1.682 0-3.13.964-3.8 2.352a4.206 4.206 0 00-3.8-2.352C1.88 1.012 0 2.84 0 5.095c0 .066.007.13.01.194H.004c.001.047.01.096.014.143l.013.142c.07.8.321 1.663.824 2.573C2.073 10.354 4.232 12.018 8 15c3.767-2.982 5.926-4.647 7.144-6.854.501-.905.752-1.766.823-2.562.007-.055.012-.11.016-.164.003-.043.012-.088.013-.13h-.006c.003-.066.01-.13.01-.195z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bToMG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.71 8.87L6.17 6.55l.02-.01A.906.906 0 016 6c0-.07.03-.13.04-.19h-.02l.78-3.92C6.09 1.34 5.19 1 4.2 1 1.88 1 0 2.83 0 5.09c0 .07.01.13.01.19H0c0 .05.01.1.01.14 0 .05.01.1.01.14.07.8.32 1.66.82 2.57 1.07 1.94 2.88 3.47 5.86 5.84l-.68-2.74h.02C6.03 11.16 6 11.08 6 11c0-.28.11-.53.29-.71l1.42-1.42zM16 5.09C16 2.83 14.12 1 11.8 1c-1.2 0-2.27.5-3.04 1.28l-.7 3.51 1.77 2.66-.01.01c.1.15.18.33.18.54 0 .28-.11.53-.29.71l-1.6 1.6.75 3.01c3.23-2.56 5.16-4.15 6.28-6.18.5-.91.75-1.77.82-2.56.01-.05.01-.11.02-.16 0-.04.01-.09.01-.13h-.01c.01-.07.02-.14.02-.2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcOIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 10h5V7H0v3zm1-2h3v1H1V8zm14-5h-4v3h5V4c0-.55-.45-1-1-1zm0 2h-3V4h3v1zM0 4v2h5V3H1c-.55 0-1 .45-1 1zm0 9c0 .55.45 1 1 1h4v-3H0v2zm6-7h4V3H6v3zm0 8h4v-3H6v3zm1-2h2v1H7v-1zm4 2h4c.55 0 1-.45 1-1v-2h-5v3zm0-4h5V7h-5v3zm-5 0h4V7H6v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fNXuH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm11-7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm3 4.5A2.5 2.5 0 0013.5 6c-.98 0-1.82.57-2.23 1.39-.6-.78-1.51-1.3-2.56-1.36.18-.49.29-.99.29-1.53C9 2.01 6.99 0 4.5 0S0 2.01 0 4.5 2.01 9 4.5 9c.19 0 .37-.03.56-.06-.03.19-.06.37-.06.56C5 11.43 6.57 13 8.5 13c1.63 0 2.98-1.11 3.37-2.62.44.38 1 .62 1.63.62A2.5 2.5 0 0016 8.5zM14.5 13c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4TwHs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M.5 2a.5.5 0 01.5.5V4h7V3H2.5a.5.5 0 010-1h13a.5.5 0 010 1H10v1h1c2.26 0 4 1.79 4 4 0 1.87-1.247 3.44-3 3.878V13h.382l1.894-.947a.5.5 0 11.448.894L12.618 14H4.5a.5.5 0 010-1H7v-2.306C5.749 9.736 5 8.368 5 7L1 6v1.5a.5.5 0 01-1 0v-5A.5.5 0 01.5 2zM8 11.316V13h3v-1a6.73 6.73 0 01-3-.684zM11 5v3h3a3 3 0 00-3-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"buAxm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm1 13H7v-2h2v2zm1.93-6.52c-.14.32-.35.64-.62.97L9.25 8.83c-.12.15-.24.29-.28.42-.04.13-.09.3-.09.52V10H7.12V8.88s.05-.51.21-.71L8.4 6.73c.22-.26.35-.49.44-.68.09-.19.12-.38.12-.58 0-.3-.1-.55-.28-.75-.18-.19-.44-.28-.76-.28-.33 0-.59.1-.78.29-.19.19-.33.46-.4.81-.03.11-.1.15-.2.14l-1.7-.25c-.12-.01-.16-.08-.14-.19.12-.82.46-1.47 1.03-1.94.57-.48 1.32-.72 2.25-.72.47 0 .9.07 1.29.22s.72.34 1 .59c.28.25.49.55.65.89.15.35.22.72.22 1.12s-.07.75-.21 1.08z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jk4Jm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 5h-2v2h2V5zm0 6h-2v2h2v-2zm0-3h-2v2h2V8zm2-8H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 14H2V2h12v12zm-7-3H5v2h2v-2zm3 0H8v2h2v-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lJdxk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.63 14.496l-3.496-6a.984.984 0 010-.992l3.495-6c.182-.312.52-.504.885-.504h6.972c.366 0 .703.192.885.504l3.495 6c.179.307.179.685 0 .992l-3.495 6c-.182.312-.52.504-.885.504H4.514c-.366 0-.703-.192-.885-.504zm6.377-2.996H5.993L3.954 8l2.04-3.5h4.013L12.046 8l-2.04 3.5zM5.106 13h5.788l2.913-5-2.913-5H5.106L2.193 8l2.913 5zM8 9c.563 0 1.02-.448 1.02-1S8.562 7 8 7s-1.02.448-1.02 1S7.438 9 8 9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Ivtc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 14v2H7v-2h2zm1-14L9 12H7L6 0h4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5fHnO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 0a1 1 0 00-1 1v3H3V3h.5a.5.5 0 000-1h-2a.5.5 0 000 1H2v1a1 1 0 000 2v1h-.5a.5.5 0 000 1h2a.5.5 0 000-1H3V6h2v9a1 1 0 102 0V6h2v9a1 1 0 102 0V6h2v1h-.5a.5.5 0 000 1h2a.5.5 0 000-1H14V6a1 1 0 100-2V3h.5a.5.5 0 000-1h-2a.5.5 0 000 1h.5v1h-2V1a1 1 0 00-1-1H6zm1 2v2h2V2H7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cJNhZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.12 11.07l2-2.02.71.71 4-4.04L10.17 0l-4 4.04.71.71-2 2.02 4.24 4.3zM2 12.97h4c.28 0 .53-.11.71-.3l1-1.01-3.42-3.45-3 3.03c-.18.18-.29.44-.29.72 0 .55.45 1.01 1 1.01zm13 1.01H1c-.55 0-1 .45-1 1.01S.45 16 1 16h14c.55 0 1-.45 1-1.01s-.45-1.01-1-1.01z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7w6Se":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 3c-.55 0-1 .45-1 1v4c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L9 7.59V4c0-.55-.45-1-1-1zm0-3a7.95 7.95 0 00-6 2.74V1c0-.55-.45-1-1-1S0 .45 0 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.54C4.64 2.78 6.23 2 8 2c3.31 0 6 2.69 6 6 0 2.61-1.67 4.81-4 5.63v-.01c-.63.23-1.29.38-2 .38-3.31 0-6-2.69-6-6 0-.55-.45-1-1-1s-1 .45-1 1c0 4.42 3.58 8 8 8 .34 0 .67-.03 1-.07.02 0 .04-.01.06-.01C12.98 15.4 16 12.06 16 8c0-4.42-3.58-8-8-8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"juJt1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 10v5c0 .55.45 1 1 1h3v-5h4v5h3c.55 0 1-.45 1-1v-5L8 4l-6 6zm13.71-2.71L14 5.59V2c0-.55-.45-1-1-1s-1 .45-1 1v1.59L8.71.29C8.53.11 8.28 0 8 0s-.53.11-.71.29l-7 7a1.003 1.003 0 001.42 1.42L8 2.41l6.29 6.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Kt8L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 5h7c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zM1 1c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1zm14 6H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h11c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-6 5H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"33pih":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 3h5c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h7c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 6H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM1 11h10c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WGGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM8 9H1c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1zm-2 4H1c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm5-8H1c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"abrxW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 0c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm13 0c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm-5 2H7c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8LIO9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 16V0h1a1 1 0 011 1v14a1 1 0 01-1 1H0zM15 0h1v16h-1a1 1 0 01-1-1V1a1 1 0 011-1zM6.707 6.707a1 1 0 00-1.414-1.414l-2 2a1 1 0 000 1.414l2 2a1 1 0 001.414-1.414L5.414 8l1.293-1.293zm4-1.414a1 1 0 00-1.414 1.414L10.586 8 9.293 9.293a1 1 0 101.414 1.414l2-2a1 1 0 000-1.414l-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g7zVf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.5 12c-.86 0-2.5-.5-3.5-1 1 3.5 4.506 4 7 4a7 7 0 007-7l-.006-.004a5.974 5.974 0 00-1.29-3.988c.896.066 2.37.53 3.296.992-1-3.5-4.506-4-7-4a6.998 6.998 0 00-6.14 3.635 5.972 5.972 0 00-.859 3.226L2 8l.006.005a5.98 5.98 0 001.771 3.99A7.469 7.469 0 013.5 12zM8 6a2 2 0 100 4 2 2 0 000-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4dDBC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 5v7h12V5H2zm0-2h12c1.1 0 2 .9 2 2v7c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2z",
    "M7.9 10.48c-.14-.33-.84-.55-1.3-.75-.46-.2-.4-.33-.42-.5v-.07c.16-.14.29-.33.37-.56 0 0 0-.01.01-.02.02-.05.03-.1.05-.15.1-.01.16-.13.19-.23.03-.04.07-.15.06-.27-.02-.16-.08-.24-.15-.26v-.03c0-.2-.02-.48-.05-.67-.01-.05-.02-.1-.03-.16-.07-.23-.21-.44-.4-.58-.2-.15-.48-.23-.73-.23s-.53.08-.72.23c-.19.14-.33.35-.4.58-.02.05-.03.1-.03.16-.05.18-.06.47-.06.67v.03c-.07.03-.14.1-.15.26-.02.12.03.22.06.27.02.1.09.22.2.24.01.05.03.1.05.15v.01c.08.23.22.42.38.56v.07c-.02.17.03.29-.43.5-.46.2-1.16.42-1.3.75s-.09.52-.09.52H8c-.01 0 .05-.19-.1-.52zM10 6h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1-.45-1-1s.45-1 1-1zM10 9h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1-.45-1-1s.45-1 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7VxAG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 2h-1.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C8.11 2.47 8 2.72 8 3c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H13c.55 0 1 .45 1 1v3c0 .55.45 1 1 1s1-.45 1-1V5c0-1.66-1.34-3-3-3zm-5.5 9c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7H1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 6.33L7 12l-1 1-2-3-2 2.67V9h7v4.33z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eP4Lt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.71 5.71l2-2C7.89 3.53 8 3.28 8 3c0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H3C1.34 2 0 3.34 0 5v3c0 .55.45 1 1 1s1-.45 1-1V5c0-.55.45-1 1-1h1.59l-.3.29a1.003 1.003 0 001.42 1.42zM12.5 11c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM15 7H6c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 6.33L12 12l-1 1-2-3-2 2.67V9h7v4.33z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4OgCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.29 11.71c.18.18.43.29.71.29s.53-.11.71-.29l4-4a1.003 1.003 0 00-1.42-1.42L9 8.59V1c0-.55-.45-1-1-1S7 .45 7 1v7.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l4 4zM15 11c-.55 0-1 .45-1 1v2H2v-2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iVlHh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.91 2.6c-.16-.36-.51-.61-.92-.61h-10c-.41 0-.77.25-.92.61L-.01 7.45v5.54c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7.45L13.91 2.6zm-1.92 5.39c-.55 0-1 .45-1 1v1h-6v-1c0-.55-.45-1-1-1H1.94l1.71-4h8.68l1.71 4h-2.05z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1H1tE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.432 2c.094.14.202.273.324.394L8.42 4H3.66L1.95 8H4c.55 0 1 .45 1 1v1h6.557c.693 0 1.363-.262 1.837-.736l.103-.102.85-1.14a2.564 2.564 0 00.623-1.682V5.058L16 7.46V13c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V7.46l2.08-4.85C2.23 2.25 2.59 2 3 2h3.432zm9.048-2c.31 0 .52.26.52.57 0 .16-.06.3-.17.41l-2.86 2.73v2.63c0 .16-.06.3-.17.41l-.82 1.1c-.1.1-.25.17-.41.17-.31 0-.57-.26-.57-.57V3.71L8.17.98A.566.566 0 018 .57c0-.31.26-.57.57-.57h6.91z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9cmIn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.341 2A5.99 5.99 0 006 4H3.66L1.95 8H4c.55 0 1 .45 1 1v1h7a5.978 5.978 0 004-1.528V13c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V7.46l2.08-4.85C2.23 2.25 2.59 2 3 2h3.341zm3.679 2.145c0-.125.075-.23.205-.225h.345l.79.8c.005 0 0 .005 0 .005v.295c0 .13-.085.23-.215.23h-.07v.15c0 .13-.09.2-.215.2v.535c0 .125-.12.225-.245.225s-.245-.1-.245-.225V5.25h-.145c-.125 0-.205-.1-.205-.23v-.875zm2.235-2.195c-.03 0-.055-.005-.06-.035 0-.03.03-.035.06-.035h.11c.035 0 .06.005.06.035 0 .03-.03.035-.06.035h-.11zm-1.165-.025a.094.094 0 01-.13 0l-.25-.25a.094.094 0 010-.13.094.094 0 01.13 0l.25.25a.094.094 0 010 .13zm1.53.445c-.035 0-.07-.025-.07-.06v-.155c0-.03.035-.06.07-.06s.07.025.07.06v.155c0 .03-.035.06-.07.06zM12 0c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 7c1.655 0 3-1.345 3-3 0-.195-.02-.39-.06-.575h-.21c-.125 0-.225-.07-.23-.21h-.215c.075.07.155.14.155.23V3.9c0 .06-.04.115-.075.155h-.015l-.01.005-.015.01-.445.43v.815c0 .13-.07.22-.2.22h-.36c-.125 0-.21-.09-.21-.22v-.84a.627.627 0 00-.36-.345h-.45c-.13 0-.245-.095-.245-.225v-.46c0-.125.115-.23.245-.23l.13-.005.21-.215c.09-.09.24-.09.33 0l.22.225h.47c.105 0 .155-.105.225-.21v-.075h-.205a.106.106 0 01-.105-.105.11.11 0 01.105-.105h.18l.025.005v-.12s-.03-.025-.04-.025h-.2l-.045.05a.235.235 0 01-.33.005l-.045-.06h-.115l.16.175c.015.015.015.06 0 .075-.02.015-.045.02-.06.005l-.195-.185h-.085l-.245.23-.02-.005c-.025.07-.06.055-.095.055-.085 0-.15-.045-.15-.13s.065-.14.15-.14h.115v-.125c0-.06.04-.09.1-.09h.05V2.36c0-.095.095-.2.19-.2h.19c.105 0 .18-.075.18-.185V1.94c0-.015.035.01.035-.06h-.125l-.005.01-.21.22a.085.085 0 01-.115 0 .085.085 0 010-.115l.255-.255c.02-.015.045-.015.065-.015.005 0 .005.015.005.015h.64a2.327 2.327 0 00-.355-.275 2.452 2.452 0 00-.355-.195c-.03-.015-.055-.03-.08-.04a3.025 3.025 0 00-1.735-.175c-.09.02-.175.055-.265.08-.09.03-.18.05-.265.085-.075.03-.145.07-.22.105-.115.06-.235.115-.34.185l-.005.005c-.1.065-.18.145-.27.22h.455c.06 0 .11.045.11.105s-.05.105-.11.105h-.32c0 .07-.025.04-.025.045v.24h.285l.15-.17c.09-.09.235-.105.325-.015.09.09.09.23 0 .32l-.795.79-.01.01c-.005 0-.005 0-.01.005l-.025.015h-.01a.235.235 0 01-.12.025h-.23c-.08.07-.125.1-.125.18v.06c0 .01-.02.02-.02.03l.375.39c.04.04.04.1 0 .14-.04.04-.1.04-.14 0l-.39-.385a.213.213 0 01-.055.01c-.105 0-.195-.085-.195-.185v-.235h-.055A3.1 3.1 0 009 4c0 1.655 1.345 3 3 3zm2.27-2.135c.05 0 .105.04.105.09v.285c0 .05-.055.09-.105.09-.05 0-.105-.04-.105-.09v-.285c0-.05.055-.09.105-.09zm-2.085-3.27c0 .13-.105.21-.225.21h-.25v.07c0 .075-.03.135-.105.135s-.105-.06-.105-.135V1.64c-.075-.02-.025-.025-.025-.04 0-.125.085-.215.21-.215h.27c.13 0 .23.085.23.21z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9kUPP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.639 2a5.391 5.391 0 00-.144 2H3.66L1.95 8H4c.55 0 1 .45 1 1v1h6V9c0-.088.012-.174.033-.255.12-.007.238-.019.39-.038.154-.008.252-.03.442-.077a5.34 5.34 0 00.24-.05h.05l.122-.04 1.266 1.271c.425.47 1.116.769 1.847.769.21 0 .414-.025.61-.071V13c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V7.46l2.08-4.85C2.23 2.25 2.59 2 3 2h2.639zM15.82 7.53c.1.12.17.27.18.44 0 .34-.27.61-.61.61a.57.57 0 01-.43-.18l-2.24-2.25c-.13.08-.26.16-.4.23-.02.01-.05.02-.07.03-.14.06-.27.12-.42.17h-.01c-.14.05-.29.08-.44.11-.04.01-.08.02-.11.02-.15.02-.3.04-.46.04-1.85 0-3.35-1.51-3.35-3.37S8.96.01 10.81 0c1.85 0 3.35 1.51 3.35 3.37 0 .16-.02.31-.04.47-.01.04-.01.07-.02.11-.02.15-.05.29-.1.44v.01c-.05.15-.11.28-.17.42-.01.02-.02.05-.03.07-.07.14-.14.27-.23.4l2.25 2.24zm-5.01-1.94c1.22 0 2.21-.99 2.21-2.22 0-1.23-.99-2.22-2.21-2.22S8.6 2.14 8.6 3.37c0 1.22.99 2.22 2.21 2.22z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6VBzo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.1 2a5.023 5.023 0 000 2H3.66L1.95 8H4c.55 0 1 .45 1 1v1h6V9c0-.55.45-1 1-1h2.05c.708 0 1.352-.241 1.905-.645L16 7.46V13c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V7.46l2.08-4.85C2.23 2.25 2.59 2 3 2h5.1zM13 6a3 3 0 110-6 3 3 0 010 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dCINI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM7 3h2v2H7V3zm3 10H6v-1h1V7H6V6h3v6h1v1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7xj1X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 8c0 1.66 1.34 3 3 3h4.59L11.3 9.71A.965.965 0 0111 9a1.003 1.003 0 011.71-.71l3 3c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-3 3a1.003 1.003 0 01-1.42-1.42l1.3-1.29H8c-2.76 0-5-2.24-5-5H1a1 1 0 01-1-1V1a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5zM2 2v4h4V2H2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"am6x3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 7c.51 0 .935.388.993.884L2 8v3c0 .51.388.935.884.993L3 12h1.59l-.3-.29a1.003 1.003 0 011.324-1.504l.096.084 2 2c.18.18.29.43.29.71 0 .233-.076.446-.206.614l-.084.096-2 2A1.003 1.003 0 014 15c0-.24.08-.458.224-.629l.076-.081.29-.29H3a2.996 2.996 0 01-2.995-2.823L0 11V8c0-.55.45-1 1-1zm5.388-7c.629 0 1.338.21 1.838.6.48.38.85.91 1.019 1.52.04.13.07.27.09.4.09.48.14 1.22.14 1.73v.07c.18.08.34.27.37.67.03.32-.09.59-.16.71-.06.28-.21.58-.48.63-.03.13-.07.26-.12.39 0 .01-.01.04-.01.04-.22.58-.55 1.08-.949 1.45v.18c.04.45-.12.77 1.059 1.3 1.179.53 2.947 1.09 3.307 1.95.37.86.22 1.36.22 1.36H9c0-.539-.21-1.045-.583-1.417l-2-2A1.997 1.997 0 005 9c-.149 0-.296-.015-.442-.045.099-.19.082-.37.101-.575 0-.05.01-.11.01-.17-.41-.35-.75-.86-.969-1.45v-.01s-.01-.01-.01-.02c-.04-.12-.09-.26-.12-.39-.28-.05-.44-.36-.5-.64-.06-.12-.19-.39-.16-.71.04-.41.21-.6.39-.68v-.06c0-.51.05-1.26.14-1.74.02-.13.05-.27.09-.4.17-.6.54-1.13 1.02-1.51C5.048.21 5.757 0 6.387 0zm4.625 2.04c.49 0 1.05.16 1.439.46.38.29.67.7.8 1.17.03.1.05.21.07.31.07.37.11.94.11 1.33v.05c.139.06.269.21.289.51.02.25-.07.45-.13.54-.05.21-.16.44-.38.48a1.711 1.711 0 01-.1.33c-.17.44-.43.83-.749 1.11v.14c.03.35-.09.59.83 1 .929.41 2.317.84 2.597 1.5.29.66.17 1.04.17 1.04H13.66v.01c-.05-.24-.14-.5-.25-.76-.36-.86-1.119-1.33-2.687-2-.14-.06-.59-.25-.6-.25-.21-.09-.36-.15-.5-.22.02-.1.02-.2.03-.31 0-.04.01-.08.01-.13-.07-.06-.13-.12-.19-.19.22-.32.4-.67.54-1.05.02-.06.02-.06.03-.1.29-.23.48-.57.59-.96.16-.33.25-.73.21-1.16-.03-.4-.16-.76-.37-1.03-.02-.53-.07-1.13-.15-1.54-.01-.06-.02-.12-.03-.19.23-.06.48-.09.72-.09z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"37UY3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.6 3.3C5.3 4.4 4.5 6.1 4.5 8s.8 3.6 2.1 4.7c-.5.2-1 .3-1.6.3-2.8 0-5-2.2-5-5s2.2-5 5-5c.6 0 1.1.1 1.6.3zm-1.96 8.68C3.92 10.83 3.5 9.46 3.5 8s.42-2.83 1.14-3.98C2.6 4.2 1 5.91 1 8s1.6 3.8 3.64 3.98zM8 4c-1.2.9-2 2.4-2 4s.8 3.1 2 4c1.2-.9 2-2.3 2-4s-.8-3.1-2-4zm3-1c2.8 0 5 2.2 5 5s-2.2 5-5 5c-.6 0-1.1-.1-1.6-.3 1.3-1.1 2.1-2.9 2.1-4.7s-.8-3.5-2.1-4.7c.5-.2 1-.3 1.6-.3zm.35 1.02c.73 1.15 1.14 2.52 1.14 3.98s-.42 2.83-1.14 3.98c2.04-.18 3.64-1.9 3.64-3.98s-1.6-3.8-3.64-3.98z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"42o2K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 16c4.41 0 8-3.582 8-8.005C16 3.572 12.41 0 8 0c-.94 0-1.86.16-2.74.48-.52.19-.79.76-.6 1.281.19.52.76.79 1.28.6a6.007 6.007 0 018.05 5.644 6.007 6.007 0 01-8.05 5.643.997.997 0 00-1.28.6c-.19.521.08 1.092.6 1.282.88.32 1.8.47 2.74.47z",
    "M11.71 7.295c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-3 3.002a1.003 1.003 0 01-1.71-.71c0-.28.11-.53.3-.71l1.29-1.291H1c-.55 0-1-.45-1-1.001 0-.55.45-1 1-1h7.59l-1.3-1.291a1.003 1.003 0 011.42-1.42l3 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Cieu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 9h2v2c0 .6.4 1 1 1s1-.4 1-1V9h2c.6 0 1-.4 1-1s-.4-1-1-1H9V5c0-.6-.4-1-1-1s-1 .4-1 1v2H5c-.6 0-1 .4-1 1s.4 1 1 1zm10-9H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 14H2V2h12v12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1t4EY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.46-1-1-1zm4.988.976v-.042a.398.398 0 00-.107-.216 7.57 7.57 0 00-1.087-1.082c-.83-.703-1.78-1.292-2.824-1.527a4.315 4.315 0 00-1.818-.024 5.578 5.578 0 00-1.593.595c-.781.427-1.5 1.01-2.125 1.665-.112.12-.225.246-.33.379a.43.43 0 000 .558c.318.403.699.758 1.086 1.082.831.703 1.78 1.292 2.824 1.527a4.37 4.37 0 001.831.024c.556-.108 1.087-.325 1.593-.595a8.695 8.695 0 002.118-1.665c.113-.12.232-.246.338-.379A.42.42 0 0013 8.06V8c-.012-.012-.012-.018-.012-.024zM8 10c-1.107 0-2-.893-2-2s.893-2 2-2 2 .893 2 2-.893 2-2 2zM7 1a1 1 0 00-1-1H1a1 1 0 00-1 1v5a1 1 0 002 0V2h4a1 1 0 001-1zm2 0a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 11-2 0V2h-4a1 1 0 01-1-1zm0 14a1 1 0 001 1h5a1 1 0 001-1v-5a1 1 0 10-2 0v4h-4a1 1 0 00-1 1zm-2 0a1 1 0 01-1 1H1a1 1 0 01-1-1v-5a1 1 0 012 0v4h4a1 1 0 011 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"04UWV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 3c-.92 0-1.76.26-2.5.69C6.76 3.26 5.92 3 5 3 2.24 3 0 5.24 0 8s2.24 5 5 5c.92 0 1.76-.26 2.5-.69.74.43 1.58.69 2.5.69 2.76 0 5-2.24 5-5s-2.24-5-5-5zm-4.1 7.85c-.29.09-.59.15-.9.15-1.66 0-3-1.34-3-3s1.34-3 3-3c.31 0 .61.06.9.15C5.33 5.96 5 6.94 5 8s.33 2.04.9 2.85zM10 11c-.31 0-.61-.06-.9-.15.57-.81.9-1.79.9-2.85s-.33-2.04-.9-2.85c.29-.09.59-.15.9-.15 1.66 0 3 1.34 3 3s-1.34 3-3 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Rbtl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 2.66C5 4.14 8 8 8 8s3-3.86 3-5.34C10.99 1.2 9.66 0 8 0S5 1.2 5 2.66zM7 3c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zM10.5 10H8v5h1v-4h1v1H9v1h2v-3h-.5zM2 9h12c.55 0 1 .45 1 1v5c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1zm4 1v5h1v-5H6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bvQDm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 16A8 8 0 118 0a8 8 0 010 16zm0-2A6 6 0 108 2a6 6 0 000 12zm1-2H7v-2h2v2zm0-3H7V4h2v5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b0Adb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.296.104a2.99 2.99 0 00-1.003.664 2.987 2.987 0 00-.75 1.25 6 6 0 106.28 4.527c.043-.039.085-.079.127-.12l1.456-1.456A8 8 0 119.296.105zm2.532 5.2a.997.997 0 01-.707-.294L9.707 3.596a1 1 0 011.414-1.414l.707.707 1.768-1.768a1 1 0 111.414 1.415L12.536 5.01a.997.997 0 01-.708.293zM9 12H7v-2h2v2zm0-3H7V4h2v5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kxoxe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.568.421c-.01.04-.018.08-.026.121-.837.156-1.53.73-1.85 1.497a6 6 0 105.27 5.273 2.51 2.51 0 001.496-1.854c.04-.008.081-.016.121-.026A8 8 0 1110.568.421zM9 12H7v-2h2v2zm0-3H7V4h2v5zm1-6c0-.55.45-1 1-1h1V1c0-.55.45-1 1-1s1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1v1.005c0 .55-.45 1-1 1s-1-.45-1-1V4h-1c-.55 0-1-.45-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cOuZx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.8 4H11c.5 0 1-.4 1-1s-.4-1-1-1H7c-.5 0-1 .4-1 1s.4 1 1 1h.8l-1.6 8H5c-.5 0-1 .4-1 1s.4 1 1 1h4c.5 0 1-.4 1-1s-.4-1-1-1h-.8l1.6-8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c4idB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 5h-3V2c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h3v3c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-5-1v2H6V4h4zm0 6H6V7h4v3zM2 4h3v2H2V4zm0 5V7h3v2H2zm4 4v-2h4v2H6zm8 0h-3v-2h3v2zm0-3h-3V8h3v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hwiGJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 0C8.24 0 6 2.24 6 5c0 1.02.31 1.96.83 2.75L.29 14.29a1.003 1.003 0 001.42 1.42L3 14.41l1.29 1.29c.18.19.43.3.71.3s.53-.11.71-.29l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71L6.41 11l1.83-1.83c.8.52 1.74.83 2.76.83 2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8c-.23 0-.45-.03-.66-.08-.01 0-.02-.01-.03-.01-.21-.05-.41-.12-.6-.21a3.014 3.014 0 01-1.62-2c0-.01-.01-.02-.01-.03C8.03 5.45 8 5.23 8 5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8iTzS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 2H6c-.28 0-.53.11-.71.29l-5 5C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l5 5c.18.18.43.29.71.29h9c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-2.29 7.29a1.003 1.003 0 01-1.42 1.42L10 9.41 8.71 10.7c-.18.19-.43.3-.71.3a1.003 1.003 0 01-.71-1.71L8.59 8l-1.3-1.29a1.003 1.003 0 011.42-1.42L10 6.59l1.29-1.29c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71L11.41 8l1.3 1.29z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ih5KU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 9h-1V7h1c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3v1H7V4c0-1.66-1.34-3-3-3S1 2.34 1 4s1.34 3 3 3h1v2H4c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3v-1h2v1c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3zm0-6c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM4 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5 4H7V7h2v2zm3 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3K4jq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.71 5.29l-4-4C8.53 1.11 8.28 1 8 1s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L8 3.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2hArD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.71 7.29l-5-5A.997.997 0 0010 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h9c.28 0 .53-.11.71-.29l5-5c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zm-7 2a1.003 1.003 0 01-1.42 1.42L6 9.41 4.71 10.7c-.18.19-.43.3-.71.3a1.003 1.003 0 01-.71-1.71L4.59 8l-1.3-1.29a1.003 1.003 0 011.42-1.42L6 6.59 7.29 5.3c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71L7.41 8l1.3 1.29z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2xsUP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 2c-.55 0-1 .45-1 1v3c0 1.66-1.34 3-3 3H4.41L5.7 7.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L4.41 11H10c2.76 0 5-2.24 5-5V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MpE9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 7c.55 0 1-.45 1-1V4.41L7.29 8.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L4.41 3H6c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm7-5.9v2A5 5 0 113.1 9h-2c.49 3.39 3.38 6 6.9 6 3.87 0 7-3.13 7-7 0-3.52-2.61-6.41-6-6.9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hUJ3t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 4h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1zm4 8h-3.43L5.86 2.49h-.02A.975.975 0 005 2H1c-.55 0-1 .45-1 1s.45 1 1 1h3.43l5.71 9.51.01-.01c.18.3.49.5.85.5h4c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6K9dE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.71 7.29l-5-5C8.53 2.11 8.28 2 8 2s-.53.11-.71.29l-5 5A1.003 1.003 0 003 9h2v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V9h2a1.003 1.003 0 00.71-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ito0y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 10H4.41L5.7 8.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L2 9.59V8c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1s1-.45 1-1v-1.59l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L4.41 12H15c.55 0 1-.45 1-1s-.45-1-1-1zm0-9c-.55 0-1 .45-1 1v1.59L11.71 1.3A.965.965 0 0011 1a1.003 1.003 0 00-.71 1.71L11.59 4H1c-.55 0-1 .45-1 1s.45 1 1 1h10.59L10.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L14 6.41V8c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5YEbU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 3a.997.997 0 00-.707.293L12 5.586l-1.293-1.293a1 1 0 10-1.414 1.414l2 2a.997.997 0 001.414 0l3-3A1 1 0 0015 3zm-.879 6.121l-.007-.007c-.313.309-.69.552-1.114.702V10h-.998H12h-1v-.184c-.424-.15-.8-.395-1.112-.704l-.01.01-2-2 .012-.012A2.978 2.978 0 017.184 6H3c-.176 0-.06-.824 0-1l.73-1.63C3.79 3.192 3.823 3 4 3H7.78C8.328 2.39 9.115 2 10 2c.768 0 1.461.293 1.987.77l.844-.844c-.238-.244-.524-.442-.794-.524C12.037 1.402 10.72 1 8 1c-2.72 0-4.037.402-4.037.402-.508.155-1.078.711-1.268 1.237l-.763 2.117H.88c-.484 0-.88.423-.88.939s.396.939.88.939h.375L1 7c-.034.685 0 1.436 0 2v5c0 .657.384 1 1 1s1-.343 1-1v-1h10v1c0 .657.384 1 1 1s1-.343 1-1V9l-.003-.754-.876.875zM5.001 10H3V8h2v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eQi57":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 1a1 1 0 010 2v3l3 7v1.25a.75.75 0 01-.75.75H2.75a.75.75 0 01-.75-.75V13l3-7V3a1 1 0 110-2h6zM9 3H7v3l-1.714 4h5.428L9 6V3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iorkp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7l-5-5zm3 10H2V4h8v2H3v1h7v1h4v4zm-3-5V4l3 3h-3zm-8 3h10V9H3v1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYPry":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 8c0-.37-.21-.68-.51-.85l.01-.01-7-4-.01.01C8.34 3.06 8.18 3 8 3s-.34.06-.49.15l-.01-.02-7 4 .01.01C.21 7.32 0 7.63 0 8s.21.68.51.85l-.01.01 7 4 .01-.01c.15.09.31.15.49.15s.34-.06.49-.15l.01.01 7-4-.01-.01c.3-.17.51-.48.51-.85z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ejMGs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.504 3.132l-7 4a1 1 0 000 1.736l7 4a1 1 0 00.992 0l7-4a1 1 0 000-1.736l-7-4a1 1 0 00-.992 0zM8 5.152L12.983 8 8 10.847 3.016 8 8 5.152z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRR8g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M.55 4.89l7 3c.14.07.29.11.45.11.16 0 .31-.04.45-.11l7-3a.998.998 0 00-.06-1.81L8.4.08a1.006 1.006 0 00-.79 0l-6.99 3a.992.992 0 00-.07 1.81zM15 11c-.16 0-.31.04-.45.11L8 14l-6.55-2.9c-.14-.06-.29-.1-.45-.1-.55 0-1 .45-1 1 0 .39.23.73.55.89l7 3c.14.07.29.11.45.11.16 0 .31-.04.45-.11l7-3c.32-.16.55-.5.55-.89 0-.55-.45-1-1-1zm0-4c-.16 0-.31.04-.45.11L8 10 1.45 7.11A.997.997 0 001 7c-.55 0-1 .45-1 1 0 .39.23.73.55.89l7 3c.14.07.29.11.45.11.16 0 .31-.04.45-.11l7-3c.32-.16.55-.5.55-.89 0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eCxiK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 4c-1.1 0-2 .9-2 2 0 .47.17.9.44 1.24l-.68.91A1.996 1.996 0 009.07 9.5H7.93C7.71 8.64 6.93 8 6 8c-.47 0-.9.17-1.24.44l-.91-.68c.1-.23.15-.49.15-.76 0-.37-.11-.71-.28-1.01l2.27-2.27c.3.17.64.28 1.01.28 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .37.11.71.28 1.01L3.01 5.28C2.71 5.11 2.37 5 2 5 .9 5 0 5.9 0 7s.9 2 2 2c.47 0 .9-.17 1.24-.44l.91.68c-.1.23-.15.49-.15.76 0 .37.11.71.28 1.01l-1.27 1.27C2.71 12.11 2.37 12 2 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.37-.11-.71-.28-1.01l1.27-1.27c.3.17.64.28 1.01.28.93 0 1.71-.64 1.93-1.5h1.14c.22.86 1 1.5 1.93 1.5 1.1 0 2-.9 2-2 0-.47-.17-.9-.44-1.24l.68-.91c.23.1.49.15.76.15 1.1 0 2-.9 2-2s-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fzuSC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 9.5c-.56 0-1.06.23-1.42.59L8.99 8l3.59-2.09A2.002 2.002 0 0016 4.5c0-1.1-.9-2-2-2s-2 .9-2 2c0 .19.03.37.08.54L8.5 7.13v-3.2c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S6 .9 6 2c0 .93.64 1.71 1.5 1.93v3.2L3.92 5.04c.05-.17.08-.35.08-.54 0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.56 0 1.06-.23 1.42-.59L7.01 8l-3.59 2.09A2.002 2.002 0 000 11.5c0 1.1.9 2 2 2s2-.9 2-2c0-.19-.03-.37-.08-.54L7.5 8.87v3.2c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93v-3.2l3.58 2.09c-.05.17-.08.35-.08.54 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fG8Ke":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 11c-.2 0-.38.04-.56.09L12.42 9.4c.36-.36.58-.85.58-1.4 0-.55-.22-1.04-.58-1.4l1.01-1.69c.19.05.37.09.57.09 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .55.22 1.04.58 1.4l-1.01 1.69C11.38 6.04 11.2 6 11 6c-.93 0-1.71.64-1.93 1.5H6.93C6.71 6.64 5.93 6 5 6c-.2 0-.38.04-.56.09L3.42 4.4C3.78 4.04 4 3.55 4 3c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.2 0 .38-.04.56-.09L3.58 6.6C3.22 6.96 3 7.45 3 8c0 .55.22 1.04.58 1.4l-1.01 1.69C2.38 11.04 2.2 11 2 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.55-.22-1.04-.58-1.4l1.01-1.69c.19.05.37.09.57.09.93 0 1.71-.64 1.93-1.5h2.14c.22.86 1 1.5 1.93 1.5.2 0 .38-.04.56-.09l1.01 1.69c-.35.36-.57.85-.57 1.4 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16XPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 9a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5a1 1 0 00-1-1H7zM1 9a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5a1 1 0 00-1-1H1zM13 9a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5a1 1 0 00-1-1h-2zM1 0a1 1 0 00-1 1v5a1 1 0 001 1h14a1 1 0 001-1V1a1 1 0 00-1-1H1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iQSs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 9a1 1 0 011 1v5a1 1 0 01-1 1H1a1 1 0 01-1-1v-5a1 1 0 011-1h5zM15 9a1 1 0 011 1v5a1 1 0 01-1 1h-5a1 1 0 01-1-1v-5a1 1 0 011-1h5zM15 0a1 1 0 011 1v5a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kekLH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.16 6.02c-.12-.36-.26-.7-.43-1.03.17-.29.27-.63.27-.99 0-1.1-.9-2-2-2-.36 0-.7.1-.99.27-.33-.17-.67-.31-1.03-.43A1.987 1.987 0 008 0C6.95 0 6.1.81 6.02 1.84c-.36.12-.7.26-1.03.43C4.7 2.1 4.36 2 4 2c-1.1 0-2 .9-2 2 0 .36.1.7.27.99-.17.33-.31.67-.43 1.03C.81 6.1 0 6.95 0 8c0 1.05.81 1.9 1.84 1.98.12.36.26.7.43 1.03-.17.29-.27.63-.27.99 0 1.1.9 2 2 2 .36 0 .7-.1.99-.27.33.17.67.32 1.03.43C6.1 15.19 6.95 16 8 16c1.05 0 1.9-.81 1.98-1.84.36-.12.7-.26 1.03-.43.29.17.63.27.99.27 1.1 0 2-.9 2-2 0-.36-.1-.7-.27-.99.17-.33.31-.67.43-1.03C15.19 9.9 16 9.05 16 8c0-1.05-.81-1.9-1.84-1.98zm-.99 3.79c-.05.16-.11.31-.17.46-.3-.17-.64-.27-1-.27-1.1 0-2 .9-2 2 0 .36.1.7.27 1-.15.07-.3.12-.46.17C9.5 12.48 8.81 12 8 12s-1.5.48-1.81 1.17c-.16-.06-.32-.11-.46-.17.17-.3.27-.64.27-1 0-1.1-.9-2-2-2-.36 0-.7.1-1 .27-.07-.15-.12-.3-.17-.46C3.52 9.5 4 8.81 4 8s-.48-1.5-1.17-1.81c.06-.16.11-.32.17-.46.3.17.64.27 1 .27 1.1 0 2-.9 2-2 0-.36-.1-.7-.27-1 .15-.07.3-.12.46-.17C6.5 3.52 7.19 4 8 4s1.5-.48 1.81-1.17c.16.06.32.11.46.17-.17.3-.27.64-.27 1 0 1.1.9 2 2 2 .36 0 .7-.1 1-.27.07.15.12.3.17.46C12.48 6.5 12 7.19 12 8s.48 1.5 1.17 1.81z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4p5aX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM8 0C6.9 0 6 .9 6 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM8 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l2mtf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2 1C.9 1 0 1.9 0 3s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm5 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lEhAW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.5 12.07V9.93c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2-.93 0-1.71.64-1.93 1.5H9.93c-.18-.7-.73-1.25-1.43-1.43V3.93c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S6 .9 6 2c0 .93.64 1.71 1.5 1.93v2.14c-.7.18-1.25.73-1.43 1.43H3.93C3.71 6.64 2.93 6 2 6 .9 6 0 6.9 0 8c0 .93.64 1.71 1.5 1.93v2.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93V9.93c.7-.18 1.25-.73 1.43-1.43h2.14c.18.7.73 1.25 1.43 1.43v2.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93V9.93c.7-.18 1.25-.73 1.43-1.43h2.14c.18.7.73 1.25 1.43 1.43v2.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7rKyj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 7a1 1 0 00-1-1H1a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V7zM7 1a1 1 0 00-1-1H1a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V1zM7 13a1 1 0 00-1-1H1a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1v-2zM16 1a1 1 0 00-1-1h-5a1 1 0 00-1 1v14a1 1 0 001 1h5a1 1 0 001-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kTFD5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 1a1 1 0 00-1-1H1a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1V1zM7 10a1 1 0 00-1-1H1a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1v-5zM16 1a1 1 0 00-1-1h-5a1 1 0 00-1 1v14a1 1 0 001 1h5a1 1 0 001-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cg4Ta":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 6c-.93 0-1.71.64-1.93 1.5H9.93C9.71 6.64 8.93 6 8 6s-1.71.64-1.93 1.5H3.93C3.71 6.64 2.93 6 2 6 .9 6 0 6.9 0 8s.9 2 2 2c.93 0 1.71-.64 1.93-1.5h2.13C6.29 9.36 7.07 10 8 10s1.71-.64 1.93-1.5h2.13c.22.86 1 1.5 1.93 1.5 1.1 0 2-.9 2-2C16 6.9 15.1 6 14 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lLCox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 7a1 1 0 011-1h5a1 1 0 011 1v2a1 1 0 01-1 1h-5a1 1 0 01-1-1V7zM9 1a1 1 0 011-1h5a1 1 0 011 1v2a1 1 0 01-1 1h-5a1 1 0 01-1-1V1zM9 13a1 1 0 011-1h5a1 1 0 011 1v2a1 1 0 01-1 1h-5a1 1 0 01-1-1v-2zM0 1a1 1 0 011-1h5a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h4cYv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 1a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1h-5a1 1 0 01-1-1V1zM9 10a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1h-5a1 1 0 01-1-1v-5zM0 1a1 1 0 011-1h5a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7PuKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6-3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM8 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8hORe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM8 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fpCNR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 1a1 1 0 011-1h2a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V1zM6 1a1 1 0 011-1h2a1 1 0 011 1v14a1 1 0 01-1 1H7a1 1 0 01-1-1V1zM0 1a1 1 0 011-1h2a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fDkX3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 12a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1v-2a1 1 0 011-1h14zM15 6a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1V7a1 1 0 011-1h14zM15 0a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"YUZkU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 7a1 1 0 01-1-1V1a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H7zM1 7a1 1 0 01-1-1V1a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H1zM13 7a1 1 0 01-1-1V1a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1h-2zM1 16a1 1 0 01-1-1v-5a1 1 0 011-1h14a1 1 0 011 1v5a1 1 0 01-1 1H1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aZrV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 7a1 1 0 01-1-1V1a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1h-5zM1 7a1 1 0 01-1-1V1a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1H1zM1 16a1 1 0 01-1-1v-5a1 1 0 011-1h14a1 1 0 011 1v5a1 1 0 01-1 1H1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"69F3R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 1a1 1 0 011-1h5a1 1 0 011 1v14a1 1 0 01-1 1h-5a1 1 0 01-1-1V1zM0 1a1 1 0 011-1h5a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ak5Po":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 10a1 1 0 011-1h14a1 1 0 011 1v5a1 1 0 01-1 1H1a1 1 0 01-1-1v-5zM0 1a1 1 0 011-1h14a1 1 0 011 1v5a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9DXLl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.441 1.104a.985.985 0 00-.882 0L.365 5c-.487.253-.487.747 0 1L7.56 9.896a.985.985 0 00.882 0L15.635 6c.487-.253.487-.747 0-1L8.44 1.104z",
    "M14 5.5l.016 4.514c.002.548.447.99.994.99a.99.99 0 00.99-.99V5.5h-2zM3.371 9.047l4.387 2.432a.5.5 0 00.485 0l4.39-2.432a.25.25 0 01.371.218v2.955a.25.25 0 01-.134.222l-4.635 2.436a.5.5 0 01-.466 0l-4.635-2.436A.25.25 0 013 12.22V9.265a.25.25 0 01.371-.218z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ew5Go":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.6 3.3C6.1 3.1 5.6 3 5 3 2.2 3 0 5.2 0 8s2.2 5 5 5c.6 0 1.1-.1 1.6-.3C5.3 11.6 4.5 9.9 4.5 8s.8-3.6 2.1-4.7zM8 4c-1.2.9-2 2.4-2 4s.8 3.1 2 4c1.2-.9 2-2.3 2-4s-.8-3.1-2-4zm3-1c2.8 0 5 2.2 5 5s-2.2 5-5 5c-.6 0-1.1-.1-1.6-.3 1.3-1.1 2.1-2.9 2.1-4.7s-.8-3.5-2.1-4.7c.5-.2 1-.3 1.6-.3zm.35 1.02c.73 1.15 1.14 2.52 1.14 3.98s-.42 2.83-1.14 3.98c2.04-.18 3.64-1.9 3.64-3.98s-1.6-3.8-3.64-3.98z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aXN3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 9h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm4 3H1c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zm7-1c0 .28.11.53.29.71l.3.29H9c-.55 0-1 .45-1 1s.45 1 1 1h3.59l-.29.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2-2A1.003 1.003 0 0012 11zM1 4h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1zhKg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.287 5.958a1 1 0 00-.574-1.916l-10 3c-.95.285-.95 1.631 0 1.916l10 3a1 1 0 00.574-1.916L6.48 8l6.807-2.042z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6xAfl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.287 3.958a1 1 0 00-.575-1.916l-10 3c-.95.285-.95 1.63 0 1.916l10 3a1 1 0 00.575-1.916L6.48 6l6.807-2.042zM13 12H3a1 1 0 000 2h10a1 1 0 000-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f2ztt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.405 11.746C8.968 11.91 8.495 12 8 12c-.494 0-.968-.09-1.405-.254l-.702 1.873C6.548 13.865 7.258 14 8 14c.742 0 1.452-.135 2.107-.38l-.702-1.874zm2.341-2.341l1.873.702C13.865 9.452 14 8.742 14 8c0-.742-.135-1.452-.38-2.107l-1.874.702c.164.437.254.91.254 1.405 0 .494-.09.968-.254 1.405zM9.405 4.254l.702-1.873A5.987 5.987 0 008 2c-.742 0-1.452.135-2.107.38l.702 1.874C7.032 4.09 7.505 4 8 4c.494 0 .968.09 1.405.254zM4.254 6.595L2.38 5.893A5.987 5.987 0 002 8c0 .742.135 1.452.38 2.107l1.874-.702A3.991 3.991 0 014 8c0-.494.09-.968.254-1.405zM8 16A8 8 0 118 0a8 8 0 010 16zm0-6a2 2 0 100-4 2 2 0 000 4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8lvzN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.01 14h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.44-1-1-1zm1-3h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.44-1-1-1zm-2-11C5.26 0 3.03 1.95 3.03 4.35c0 2.37 1.63 2.64 1.94 5.22 0 .24.22.44.5.44h5.09c.28 0 .5-.19.5-.44C11.37 6.99 13 6.72 13 4.35 13 1.95 10.77 0 8.01 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c0Tly":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 9H5a1 1 0 01-1-1L4.89.876A1 1 0 015.884 0h4.27a.847.847 0 01.793 1.144L9.125 6h2.05a.825.825 0 01.754 1.16L8.16 15.64A.606.606 0 017 15.394V9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"148CP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.99 11.99c.28 0 .53-.11.71-.29l6-6a1.003 1.003 0 00-1.42-1.42l-6 6a1.003 1.003 0 00.71 1.71zm3.85-2.02L6.4 12.41l-1 1-.01-.01c-.36.36-.85.6-1.4.6-1.1 0-2-.9-2-2 0-.55.24-1.04.6-1.4l-.01-.01 1-1 2.44-2.44c-.33-.1-.67-.16-1.03-.16-1.1 0-2.09.46-2.81 1.19l-.02-.02-1 1 .02.02c-.73.72-1.19 1.71-1.19 2.81 0 2.21 1.79 4 4 4 1.1 0 2.09-.46 2.81-1.19l.02.02 1-1-.02-.02c.73-.72 1.19-1.71 1.19-2.81 0-.35-.06-.69-.15-1.02zm7.15-5.98c0-2.21-1.79-4-4-4-1.1 0-2.09.46-2.81 1.19l-.02-.02-1 1 .02.02c-.72.72-1.19 1.71-1.19 2.81 0 .36.06.69.15 1.02l2.44-2.44 1-1 .01.01c.36-.36.85-.6 1.4-.6 1.1 0 2 .9 2 2 0 .55-.24 1.04-.6 1.4l.01.01-1 1-2.43 2.45c.33.09.67.15 1.02.15 1.1 0 2.09-.46 2.81-1.19l.02.02 1-1-.02-.02a3.92 3.92 0 001.19-2.81z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQ0Bj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 3v6a1 1 0 010 2h-.75C.56 11 0 10.44 0 9.75v-7.5C0 1.56.56 1 1.25 1h9.5c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25H8a1 1 0 110-2h2V3H2z",
    "M14 13V7a1 1 0 110-2h.75c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25h-9.5C4.56 15 4 14.44 4 13.75v-7.5C4 5.56 4.56 5 5.25 5H8a1 1 0 110 2H6v6h8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hdFwb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 3h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 10H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hNgUQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 1c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1h5zm9-12c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1h5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lCnCb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 9H1c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm0 4H1c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm9-12h-5c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM6 5H1c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H1c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdrYW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 7h-.09A6.98 6.98 0 009 1.1V1c0-.55-.45-1-1-1S7 .45 7 1v.09A6.98 6.98 0 001.1 7H1c-.55 0-1 .45-1 1s.45 1 1 1h.1A6.969 6.969 0 007 14.91V15c0 .55.45 1 1 1s1-.45 1-1v-.09A6.98 6.98 0 0014.9 9h.1c.55 0 1-.45 1-1s-.45-1-1-1zm-6.02 5.9c-.05-.5-.46-.9-.98-.9s-.93.4-.98.9A5.017 5.017 0 013.1 8.98c.5-.05.9-.46.9-.98s-.4-.93-.9-.98A5.017 5.017 0 017.02 3.1c.05.5.46.9.98.9s.93-.4.98-.9c1.97.39 3.52 1.95 3.92 3.92-.5.05-.9.46-.9.98s.4.93.9.98a5.017 5.017 0 01-3.92 3.92zM8 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i817y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.96 7H12V3.95C12 1.77 10.21 0 8 0S4 1.77 4 3.95V7H1.96c-.55 0-.96.35-.96.9v6.91c0 .54.41 1.19.96 1.19h12c.55 0 1.04-.65 1.04-1.19V7.9c0-.55-.49-.9-1.04-.9zM6 7V3.95c0-1.09.9-1.97 2-1.97s2 .88 2 1.97V7H6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eJ1WO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 2v12h1.706a.523.523 0 00.443-.257c1.847-3.056 3.803-1.42 4.701.004a.529.529 0 00.444.253h.412a.523.523 0 00.443-.257c1.847-3.056 3.803-1.42 4.701.004a.529.529 0 00.444.253h.982a.3.3 0 00.212-.512L13 12c4.4-2.4 1.833-5 0-6V4l1.146-1.146A.5.5 0 0013.793 2h-3.586a.5.5 0 00-.353.854L11 4v2H8V2a1 1 0 00-1-1H1a1 1 0 00-1 1zm1 5h3V2H1v5zm6 0H5V2h2v5z",
    "M4.5 16a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-1a.5.5 0 100-1 .5.5 0 000 1zM10.5 16a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-1a.5.5 0 100-1 .5.5 0 000 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cySYc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 8c0-.28-.11-.53-.29-.71l-3-3a1.003 1.003 0 00-1.42 1.42L7.59 7H1c-.55 0-1 .45-1 1s.45 1 1 1h6.59L6.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71zm4-8H9c-.55 0-1 .45-1 1s.45 1 1 1h5v12H9c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Sed3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 14H2V2h5c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm8.71-6.71l-3-3a1.003 1.003 0 00-1.42 1.42L12.59 7H6c-.55 0-1 .45-1 1s.45 1 1 1h6.59l-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9D9im":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0a1 1 0 00-1 1v1H3v-.5a.5.5 0 00-1 0V2a1 1 0 000 2v1h-.5a.5.5 0 000 1h2a.5.5 0 000-1H3V4h4v11a1 1 0 102 0V4h4v1h-.5a.5.5 0 000 1h2a.5.5 0 000-1H14V4a1 1 0 100-2v-.5a.5.5 0 00-1 0V2H9V1a1 1 0 00-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gMHcT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.99 1.13c-.02-.41-.33-.77-.78-.87C12.26-.36 9.84.13 8 1.7 6.16.13 3.74-.36.78.26.33.35.03.72.01 1.13H0v12c0 .08 0 .17.02.26.12.51.65.82 1.19.71 2.63-.55 4.59-.04 6.01 1.57.02.03.06.04.08.06.02.02.03.04.05.06.04.03.09.04.13.07.05.03.09.05.14.07.11.04.23.07.35.07h.04c.12 0 .24-.03.35-.07.05-.02.09-.05.14-.07.04-.02.09-.04.13-.07.02-.02.03-.04.05-.06.03-.02.06-.03.08-.06 1.42-1.6 3.39-2.12 6.01-1.57.54.11 1.07-.21 1.19-.71.04-.09.04-.18.04-.26l-.01-12zM7 12.99c-1.4-.83-3.07-1.14-5-.93V1.96c2.11-.28 3.75.2 5 1.46v9.57zm7-.92c-1.93-.21-3.6.1-5 .93V3.42c1.25-1.26 2.89-1.74 5-1.46v10.11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7txwP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 8h3.76l2-2H1c-.55 0-1 .45-1 1s.45 1 1 1zm14.49-4.01c.31-.32.51-.76.51-1.24C16 1.78 15.22 1 14.25 1c-.48 0-.92.2-1.24.51l-1.44 1.44 2.47 2.47 1.45-1.43zM1 4h7.76l2-2H1c-.55 0-1 .45-1 1s.45 1 1 1zm0 6c-.55 0-1 .45-1 1 0 .48.35.86.8.96L2.76 10H1zm9.95-6.43l-6.69 6.69 2.47 2.47 6.69-6.69-2.47-2.47zm4.25 2.47L13.24 8H15c.55 0 1-.45 1-1 0-.48-.35-.86-.8-.96zM2 15l3.86-1.39-2.46-2.44L2 15zm13-5h-3.76l-2 2H15c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dITrN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 3a1 1 0 100 2 1 1 0 000-2zm3 1c0 .047-.001.094-.003.14.255.081.538.209.832.41.406.28.8.676 1.171 1.225.37-.549.765-.945 1.171-1.224a3.14 3.14 0 01.832-.411 3 3 0 11.77 1.87 1.038 1.038 0 00-.47.19c-.291.2-.752.672-1.227 1.8.475 1.128.936 1.6 1.227 1.8.183.126.336.173.47.19a3 3 0 11-.77 1.87 3.141 3.141 0 01-.832-.41c-.406-.28-.8-.676-1.171-1.225-.37.549-.765.945-1.171 1.224-.294.202-.577.33-.832.411a3 3 0 11-.77-1.87c.134-.017.287-.064.47-.19.291-.2.752-.672 1.227-1.8-.475-1.128-.936-1.6-1.227-1.8a1.038 1.038 0 00-.47-.19A3 3 0 116 4zm6 0a1 1 0 112 0 1 1 0 01-2 0zm-9 7a1 1 0 100 2 1 1 0 000-2zm9 1a1 1 0 112 0 1 1 0 01-2 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e1ORT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 2a1 1 0 100 2 1 1 0 000-2zm0-2c1.385 0 2.551.94 2.896 2.215.168.044.34.096.51.158 1.076.394 2.237 1.242 2.575 2.93.161.809.664 1.211 1.293 1.443a3 3 0 110 2.508c-.629.232-1.132.634-1.293 1.442-.338 1.69-1.499 2.537-2.575 2.93a5.436 5.436 0 01-.51.159A3.001 3.001 0 010 13a3 3 0 015.726-1.254c.629-.232 1.132-.634 1.293-1.442.216-1.076.765-1.81 1.413-2.304-.648-.493-1.197-1.228-1.413-2.304-.161-.808-.664-1.21-1.293-1.442A3 3 0 113 0zm1 13a1 1 0 10-2 0 1 1 0 002 0zm8-5a1 1 0 102 0 1 1 0 00-2 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QXQ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.55 3.17l-4.49-3A.975.975 0 009.99.15L5.53 2.82 1.56.17A1.003 1.003 0 000 1v11c0 .35.18.65.45.83l4.49 3a.975.975 0 001.07.02l4.46-2.67 3.97 2.65A1.003 1.003 0 0016 15V4c0-.35-.18-.65-.45-.83zM5 13.46l-3-2v-8.6l2.94 1.96c.02.02.04.03.06.04v8.6zm5-2.32s-.01 0-.01.01L6 13.53V4.86s.01 0 .01-.01L10 2.47v8.67zm4 1.99l-2.94-1.96c-.02-.01-.04-.02-.05-.03v-8.6l3 2v8.59z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6VERm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 6.82v6.32l-2.94-1.96c-.02-.01-.04-.02-.05-.03V6.22c-.08-.07-.15-.16-.22-.24-.28-.02-.54-.08-.79-.16v5.32s-.01 0-.01.01L6 13.53V4.86s.01 0 .01-.01l2.05-1.23C8.02 3.42 8 3.21 8 3c0-.98.47-1.84 1.2-2.39l-3.67 2.2L1.56.17A1.003 1.003 0 000 1v11c0 .35.18.65.45.83l4.49 3a.975.975 0 001.07.02l4.46-2.67 3.97 2.65A1.003 1.003 0 0016 15V5.82c-.25.09-.52.14-.8.16-.33.36-.73.67-1.2.84zm-9 6.64l-3-2v-8.6l2.94 1.96c.02.02.04.03.06.04v8.6zM11 4h1v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9m6Al":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C4.96 0 2.49 2.39 2.49 5.33 2.49 8.28 8 16 8 16s5.51-7.72 5.51-10.67C13.5 2.39 11.04 0 8 0zm0 8a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ypIk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.99 8.99c-.28 0-.53.11-.71.29l-3.29 3.29v-1.59c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.41L6.7 10.7a1.003 1.003 0 00-.71-1.71zm9-9h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59l-3.3 3.3a.99.99 0 00-.29.7 1.003 1.003 0 001.71.71l3.29-3.29V5c0 .55.45 1 1 1s1-.45 1-1V1c0-.56-.45-1.01-1-1.01z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6afvH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.99 6.99c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm3-5h-14c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-10c0-.55-.45-1-1-1zm-1 9l-5-3-1 2-3-4-3 5v-7h12v7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gs8Az":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 4h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 8H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm0-5H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8QSbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.99 6.99h-9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm-12-2c-.28 0-.53.11-.71.29l-2 2a1.014 1.014 0 000 1.42l2 2a1.003 1.003 0 001.71-.71v-4c0-.55-.45-1-1-1zm3-1h9c.55 0 1-.45 1-1s-.45-1-1-1h-9c-.55 0-1 .45-1 1s.45 1 1 1zm9 8h-9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"65Y9O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.99 11.99h-9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm0-5h-9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm0-5h-9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm5.71 5.3l-2-2a1.003 1.003 0 00-1.71.71v4a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71s-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h9fct":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.71 5.29a1.003 1.003 0 00-1.42 1.42l.3.29H2V2h3v1.51c.52.06.99.29 1.34.65l.66.66V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-3.82l-.66.66c-.35.35-.82.59-1.34.65V14H2V9h2.59l-.3.29a1.003 1.003 0 001.42 1.42l2-2C7.89 8.53 8 8.28 8 8c0-.28-.11-.53-.29-.71l-2-2zM15 0h-5c-.55 0-1 .45-1 1v3.82l.66-.66c.35-.35.82-.59 1.34-.65V2h3v5h-2.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C8.11 7.47 8 7.72 8 8c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H14v5h-3v-1.51c-.52-.06-.99-.29-1.34-.65L9 11.18V15c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cnrzo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 3c-.93 0-1.71.64-1.93 1.5H11V3c0-1.66-1.34-3-3-3S5 1.34 5 3v4.5H3.93C3.71 6.64 2.93 6 2 6 .9 6 0 6.9 0 8s.9 2 2 2c.93 0 1.71-.64 1.93-1.5H5V13c0 1.66 1.34 3 3 3s3-1.34 3-3V8.5h1.07c.22.86 1 1.5 1.93 1.5 1.1 0 2-.9 2-2s-.9-2-2-2zm-4 7c0 1.1-.9 2-2 2s-2-.9-2-2V3c0-1.1.9-2 2-2s2 .9 2 2v10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99ZBx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0a3 3 0 00-3 3v4a3 3 0 006 0V3a3 3 0 00-3-3zM3 5a1 1 0 011 1v2a3 3 0 003 3h2a3 3 0 003-3V6a1 1 0 112 0v2a5 5 0 01-5 5v1h1a1 1 0 110 2H6a1 1 0 110-2h1v-1a5 5 0 01-5-5V6a1 1 0 011-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gecer":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.99.99a1.003 1.003 0 00-1.71-.71l-3.29 3.29V1.99c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H12.4l3.3-3.29c.18-.18.29-.43.29-.71zm-10 8h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59L.29 14.28a1.003 1.003 0 001.42 1.42L5 12.41V14c0 .55.45 1 1 1s1-.45 1-1v-4a1.02 1.02 0 00-1.01-1.01z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"15ZVa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 7H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4n3Iu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 0H4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM8 15c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3-3H5V3h6v9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bKNzo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 4c-.28 0-.53.11-.71.29L12 6.59V4c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V9.41l2.29 2.29c.18.19.43.3.71.3.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3BiXQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1a1 1 0 011 1v12a1 1 0 01-1 1H1a1 1 0 01-1-1V2a1 1 0 011-1h14zm-1 4H2v8h12V5zm-3-3H9v2h2V2zm3 0h-2v2h2V2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jNkk6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm1 4H0V3h16v2zm-3-2h-2V1h2v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kcSgF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.745 14H1.255A1.251 1.251 0 010 12.704C.058 11.21.223 8.66.7 6.42c.255-1.196.599-2.303 1.063-3.111C2.24 2.48 2.823 2 3.53 2c.752 0 1.322.305 1.777.775.455.469.79 1.094 1.078 1.72.08.175.166.37.248.56l.003.006c.192.443.372.854.539 1.151.113.202.25.413.424.57.159.141.32.218.528.218.707 0 1.12-.436 1.505-.88l.003-.004.107-.122c.222-.249.461-.499.771-.685.308-.186.686-.309 1.19-.309.575 0 1.107.325 1.591.878.48.545.9 1.298 1.265 2.127.66 1.504 1.13 3.254 1.41 4.468A1.25 1.25 0 0114.744 14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8hz2b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 11.38A7.835 7.835 0 017.85 16C3.51 16 0 12.49 0 8.15 0 4.97 1.89 2.23 4.62 1c-.45.99-.7 2.08-.7 3.23a7.85 7.85 0 007.85 7.85c1.15 0 2.24-.25 3.23-.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99Zti":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 6.03a2 2 0 100 4 2 2 0 100-4zM14 6.03a2 2 0 100 4 2 2 0 100-4zM8 6.03a2 2 0 100 4 2 2 0 100-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"198Iz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 13H3l6-9h1l2 2h1l3 7zm-2.5-3.5l-1-2.5h-1l-2-2-3 4.5L9 8l1 1 1-1 2.5 1.5zM5.94 7l-4.122 6H0l5-6h.94z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dOOwK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.71 7.29l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H9V3.41l.29.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-2-2C8.53.11 8.28 0 8 0s-.53.11-.71.29l-2 2a1.003 1.003 0 001.42 1.42l.29-.3V7H3.41l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L3.41 9H7v3.59l-.29-.29A.965.965 0 006 12a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2a1.003 1.003 0 00-1.42-1.42l-.29.3V9h3.59l-.29.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVJjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14h-.15c-.03-.09-.04-.16-.08-.25-.34-.79-2.01-1.31-3.12-1.8-1.11-.49-.96-.79-1-1.2-.01-.06-.01-.12-.01-.18.38-.34.69-.8.89-1.33 0 0 .01-.03.01-.04.04-.12.08-.24.11-.36.25-.05.4-.33.46-.59.06-.1.18-.36.15-.65-.04-.37-.19-.55-.35-.62v-.06c0-.48-.04-1.16-.13-1.61-.02-.12-.05-.25-.08-.37-.16-.55-.51-1.05-.96-1.39C9.26 3.19 8.6 3 8 3c-.59 0-1.26.19-1.73.55-.45.35-.8.84-.96 1.39-.04.13-.06.25-.08.38-.09.45-.13 1.13-.13 1.61v.06c-.18.06-.33.24-.37.62-.03.29.09.54.15.65.06.26.21.54.47.59.03.12.07.25.11.36 0 .01.01.02.01.02v.01c.21.54.53 1.01.92 1.35 0 .05-.01.11-.01.16-.04.41.08.7-1.03 1.2-1.11.49-2.77 1.01-3.12 1.8-.04.09-.05.16-.08.25H2V2h12v12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"72KKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 3.98H4c-.55 0-1 .45-1 1v1h8v5h1c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm3-3H7c-.55 0-1 .45-1 1v1h8v5h1c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-6 6H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-1 5H2v-3h6v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jP2DM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0c-.07 0-.13.03-.19.04V.02l-10 2v.02C4.35 2.13 4 2.52 4 3v9.12c-.31-.07-.65-.12-1-.12-1.66 0-3 .9-3 2s1.34 2 3 2 3-.9 3-2V6.32l8-1.6v5.4c-.31-.07-.65-.12-1-.12-1.66 0-3 .9-3 2s1.34 2 3 2 3-.9 3-2V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j9moZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 2c.55 0 1 .45 1 1v3c0 1.66 1.34 3 3 3h5.59L10.3 7.71A.965.965 0 0110 7a1.003 1.003 0 011.71-.71l3 3c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-3 3a1.003 1.003 0 01-1.42-1.42l1.3-1.29H6c-2.76 0-5-2.24-5-5V3c0-.55.45-1 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9bDhw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.9 11c.6 0 1 .5 1 1 0 .257-.073.44-.22.614l-.08.086-3 3c-.2.2-.4.3-.7.3-.5 0-1-.4-1-1 0-.257.073-.44.22-.614l.08-.086 3-3c.2-.2.4-.3.7-.3zM1.3.1l6.734 2.45a3.005 3.005 0 002.095 3.322 3.005 3.005 0 003.401 2.081L13.9 9.8v.2c0 .257-.073.44-.22.614l-.08.086-3 3c-.171.171-.343.27-.577.294L9.9 14h-.2l-5-1-.1-.01c-.231-.05-.45-.26-.56-.49L4 12.4l-4-11 .3-.3 5.8 5.8c-.1.2-.2.4-.2.6 0 .8.6 1.5 1.5 1.5s1.5-.7 1.5-1.5S8.2 6 7.4 6c-.16 0-.32.064-.48.14l-.12.06L1 .4l.3-.3zM13 0c.55 0 1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1v1c0 .503-.376.922-.861.99l-.013.002A.999.999 0 0113 6l.097-.006-.027.004a1 1 0 01-.037.001L13 6c-.55 0-1-.45-1-1V4h-1a.993.993 0 01-.855-.482A1 1 0 0110 3c0-.55.45-1 1-1h1V1c0-.55.45-1 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bszRS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 0H1C.45 0 0 .45 0 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm5 14c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1zM6 9H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm9 4c-.55 0-1 .45-1 1-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm-4-4h-1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1s1-.45 1-1c.55 0 1-.45 1-1s-.45-1-1-1zm4-9h-5c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm0 9h-1c-.55 0-1 .45-1 1s.45 1 1 1c0 .55.45 1 1 1s1-.45 1-1v-1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8x9nZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.982 6.272l1.518.868-.01.01c.3.17.51.48.51.85s-.21.68-.51.85l.01.01-7 4-.01-.01A.94.94 0 018 13a.94.94 0 01-.49-.15l-.01.01-7-4 .01-.01A.977.977 0 010 8c0-.37.21-.68.51-.86L.5 7.13l7-4 .01.02A.94.94 0 018 3c.086 0 .168.014.246.038a2 2 0 105.736 3.234zM14 3c.55 0 1 .45 1 1s-.45 1-1 1h-1v1c0 .55-.45 1-1 1s-1-.45-1-1V5h-1c-.55 0-1-.45-1-1s.45-1 1-1h1V2c0-.55.45-1 1-1s1 .45 1 1v1h1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f6k6K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 3h2a1 1 0 010 2h-2v2a1 1 0 01-2 0V5H9a1 1 0 110-2h2V1a1 1 0 012 0v2zm-3-1.983V2H9a2 2 0 100 4h1v1c0 .279.057.544.16.785l-1.71.855c-.14.07-.29.11-.45.11-.16 0-.31-.04-.45-.11l-7-3.5a.992.992 0 01.07-1.81l6.99-3a1.006 1.006 0 01.79 0l1.6.687zm.91 7.66a2 2 0 003.085-1.54l.555-.277c.14-.07.29-.11.45-.11.55 0 1 .45 1 1 0 .39-.23.73-.55.89l-7 3.5c-.14.07-.29.11-.45.11-.16 0-.31-.04-.45-.11l-7-3.5C.23 8.48 0 8.14 0 7.75c0-.55.45-1 1-1 .16 0 .31.04.45.11L8 10.13l2.91-1.453zM15 10.25c.55 0 1 .45 1 1 0 .39-.23.73-.55.89l-7 3.5c-.14.07-.29.11-.45.11-.16 0-.31-.04-.45-.11l-7-3.5c-.32-.16-.55-.5-.55-.89 0-.55.45-1 1-1 .16 0 .31.04.45.1L8 13.63l6.55-3.27c.14-.07.29-.11.45-.11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1tdyr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1zm-3.5 6a2.5 2.5 0 00-2.45 2h-4.1a2.5 2.5 0 100 1h4.1a2.5 2.5 0 102.45-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21Uy1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 4c0 .6.4 1 1 1h2v2c0 .6.4 1 1 1s1-.4 1-1V5h2c.6 0 1-.4 1-1s-.4-1-1-1h-2V1c0-.6-.4-1-1-1s-1 .4-1 1v2H9c-.6 0-1 .5-1 1zm6.5 2.5V7c0 1.4-1.1 2.5-2.5 2.5S9.5 8.4 9.5 7v-.5H9C7.6 6.5 6.5 5.4 6.5 4S7.6 1.5 9 1.5h.5V1c0-.3.1-.6.1-.8C9.1.1 8.6 0 8 0 3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8c0-.6-.1-1.3-.2-1.9-.4.3-.8.4-1.3.4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aSROd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.12 12.69c-1.17-.53-1.01-.85-1.05-1.29-.01-.06-.01-.12-.01-.19.4-.37.73-.87.94-1.44 0 0 .01-.03.01-.04.05-.14.09-.27.12-.4.27-.06.43-.36.49-.63.06-.11.19-.39.16-.7-.04-.41-.2-.6-.38-.68v-.07c0-.51-.05-1.25-.14-1.74-.02-.13-.05-.27-.09-.4-.17-.6-.53-1.14-1.01-1.52C7.66 3.2 6.96 3 6.33 3c-.62 0-1.33.2-1.82.59-.49.38-.85.92-1.02 1.52-.04.13-.07.26-.09.4-.09.49-.13 1.23-.13 1.74v.06c-.19.08-.35.27-.39.68-.03.31.1.59.16.7.06.28.22.59.5.64.03.14.07.27.11.4 0 .01.01.02.01.02v.01c.22.59.55 1.1.96 1.46 0 .06-.01.12-.01.17-.04.44.08.76-1.09 1.29-1.17.53-2.93 1.1-3.29 1.95-.35.87-.2 1.37-.2 1.37h12.6s.15-.5-.22-1.36c-.36-.85-2.12-1.42-3.29-1.95zM14.89 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cLz1w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.82 11.66l2.48-2.87c.12-.2.13-.37.04-.53-.11-.19-.3-.26-.52-.26h-1.29c-.27 0-.49.13-.63.34L8.44 9.9 6.95 8a.482.482 0 00-.08-.1L5.82 6.55c.57-.24 1.04-.57 1.42-1.01.49-.57.74-1.27.74-2.08 0-.51-.1-.99-.32-1.42-.21-.43-.51-.8-.89-1.11A4.1 4.1 0 005.42.24C4.91.08 4.34 0 3.72 0H.61C.26 0 0 .23 0 .56v9.89c0 .33.26.55.61.55h.8c.36 0 .61-.23.61-.56V6.99H3.3l3.73 4.74-2.71 3.48c-.12.2-.13.37-.04.53.11.19.3.26.52.26h1.27c.27 0 .51-.12.64-.34l1.69-2.15 1.66 2.14c.12.21.34.35.62.35h1.43c.2 0 .39-.08.5-.25.12-.18.09-.38-.02-.55l-2.77-3.54zM4.18 5H1.99V2.02h2.19c.62 0 1.08.13 1.38.37.29.22.44.62.44 1.08 0 .45-.15.94-.44 1.17-.31.23-.76.36-1.38.36zM15 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1zM9.99 3.01c0 .02.01.04.01.06V2.95c0 .02-.01.04-.01.06z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9zcc3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 4h1v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1z",
    "M8 1C4.889 3.143 2.556 4.214 1 4.214c0 5 2.333 8.929 7 11.786 3.797-2.325 6.05-5.359 6.757-9.102-.557.53-1.266.901-2.055 1.04-.762 2.394-2.32 4.41-4.702 6.088V4 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4dxQ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 6.5c0 .28.22.5.5.5H7v3.5c0 .28.22.5.5.5s.5-.22.5-.5V7h1.5c.28 0 .5-.22.5-.5S9.78 6 9.5 6h-4c-.28 0-.5.22-.5.5zM15 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1zm-2 5c-.55 0-1 .45-1 1v5H3V4h5c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h11c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iTSZ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 5s-2.52 2.11-4.96 1.99C11.03 4.89 10.39.23 5 0c0 0 2.11 2.54 1.96 4.99C4.86 5.01.23 5.65 0 11c0 0 2.56-2.12 5.02-1.95.02 2.11.67 6.72 5.98 6.95 0 0-2.09-2.54-1.94-4.99 2.11-.02 6.71-.68 6.94-6.01zM8 9.5c-.83 0-1.5-.67-1.5-1.5S7.17 6.5 8 6.5s1.5.67 1.5 1.5S8.83 9.5 8 9.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aQ0W1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.58 5l.44-2.196a1 1 0 011.96.392L9.62 5H13a1 1 0 010 2H9.22l-.4 2H13a1 1 0 010 2H8.42l-.44 2.196a1 1 0 01-1.96-.392L6.38 11H3a1 1 0 010-2h3.78l.4-2H3a1 1 0 110-2h4.58z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4rr6w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 16c1.1 0 2-.9 2-2H6c0 1.1.9 2 2 2zm6-5c-.55 0-1-.45-1-1V6c0-2.43-1.73-4.45-4.02-4.9 0-.04.02-.06.02-.1 0-.55-.45-1-1-1S7 .45 7 1c0 .04.02.06.02.1A4.992 4.992 0 003 6v4c0 .55-.45 1-1 1s-1 .45-1 1 .45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4s1Ip":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 14c0 1.1-.9 2-2 2s-2-.9-2-2zM7 0c.404 0 .755.243.912.59L7.9.6c-.7.6-.9 1.36-.9 1.9 0 .8.267 1.433.8 1.9-.533.6-.795 1.222-.784 1.867l.004.358A2.8 2.8 0 009.82 9.4L12 9.399V10c0 .51.388.935.884.993L13 11c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1V6c0-2.43 1.73-4.45 4.02-4.9L6 1c0-.55.45-1 1-1z",
    "M13 6.702a.632.632 0 00-.632-.632h-1.743l2.208-2.734A.75.75 0 0013 2.864v-.3A.565.565 0 0012.435 2H9.561a.561.561 0 100 1.123h1.814L9.221 5.795A1 1 0 009 6.423v.279c0 .349.283.631.632.631h2.736A.632.632 0 0013 6.702z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7PQt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 16c1.1 0 2-.9 2-2H6c0 1.1.9 2 2 2zm3.399-13.667l-.413.412A2.99 2.99 0 009 1.99a3 3 0 00-3 2.99c0 .8.32 1.558.876 2.114l2.002 1.992A2.99 2.99 0 0013 9.184V10c0 .55.45 1 1 1s1 .45 1 1-.45 1-1 1H2c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1V6c0-2.43 1.73-4.45 4.02-4.9 0-.04-.02-.06-.02-.1 0-.55.45-1 1-1s1 .45 1 1c0 .04-.02.06-.02.1a4.97 4.97 0 012.419 1.233zM10.29 7.67l-2-1.99a.99.99 0 01-.29-.7 1 1 0 011-.99c.27 0 .52.11.7.29l1.29 1.29 3.28-3.28c.18-.18.42-.29.7-.29.55 0 1 .44 1 .99 0 .28-.11.52-.3.7l-3.98 3.98a.99.99 0 01-1.4 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1k3xY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.76 7h1.26V0h-.94c-.04.21-.12.39-.25.54-.13.15-.29.27-.48.36-.18.09-.39.16-.62.2-.23.04-.46.06-.71.06v.9h1.74V7zm-.59 7.17c.18-.12.37-.25.58-.37a10.763 10.763 0 001.24-.83c.2-.16.37-.33.52-.51.15-.19.28-.39.37-.61.09-.22.14-.47.14-.74 0-.22-.04-.45-.12-.7-.08-.26-.21-.49-.4-.69-.18-.21-.43-.39-.72-.52-.3-.14-.68-.21-1.12-.21-.41 0-.77.07-1.08.2-.32.14-.58.32-.8.56-.22.23-.38.51-.49.84-.11.32-.16.67-.16 1.05h1.19c.01-.24.03-.47.08-.67.05-.21.11-.39.21-.54.09-.15.22-.27.38-.36.16-.09.35-.13.59-.13.26 0 .47.04.63.12.16.08.29.18.38.3.09.12.15.25.18.39s.05.27.05.4c-.01.27-.08.5-.22.71-.14.21-.32.4-.53.57-.22.18-.45.34-.71.49-.26.15-.51.31-.74.47-.5.31-.89.68-1.17 1.11-.3.41-.44.91-.45 1.48h5v-1H1.43c.05-.15.14-.29.27-.43.14-.13.29-.26.47-.38zM15.01 1.99h-7c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-1c0-.55-.44-1-1-1zm0 9h-7c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-1c0-.55-.44-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a8L2e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.79 4.61c-.13.17-.29.3-.48.41-.18.11-.39.18-.62.23-.23.04-.46.07-.71.07v1.03h1.74V12h1.26V4h-.94c-.04.23-.12.44-.25.61zm4.37 5.31c.18-.14.37-.28.58-.42l.63-.45c.21-.16.41-.33.61-.51s.37-.38.52-.59c.15-.21.28-.45.37-.7.09-.25.13-.54.13-.85 0-.25-.04-.52-.12-.8-.07-.29-.2-.55-.39-.79a2.18 2.18 0 00-.73-.6c-.29-.15-.66-.23-1.11-.23-.41 0-.77.08-1.08.23-.31.16-.58.37-.79.64-.22.27-.38.59-.49.96-.11.37-.16.77-.16 1.2h1.19c.01-.27.03-.53.08-.77.04-.24.11-.45.21-.62.09-.18.22-.32.38-.42.16-.1.35-.15.59-.15.26 0 .47.05.63.14.15.09.28.21.37.35.09.14.15.29.18.45.03.16.05.31.05.45-.01.31-.08.58-.22.82-.14.23-.32.45-.53.65-.22.21-.46.39-.71.57-.26.18-.51.36-.75.54-.5.36-.89.78-1.17 1.27-.28.49-.43 1.06-.44 1.71h5v-1.15H6.43c.05-.17.14-.33.27-.49.13-.15.29-.29.46-.44zm8.5-1.56c-.23-.35-.54-.57-.95-.65v-.02c.34-.13.6-.34.76-.63.16-.29.24-.63.24-1.02 0-.34-.06-.64-.19-.9s-.3-.47-.51-.64c-.21-.17-.45-.3-.72-.38-.27-.09-.54-.13-.82-.13-.36 0-.68.07-.96.2-.28.13-.53.32-.72.55-.2.23-.36.51-.47.83-.11.32-.18.66-.19 1.04h1.15c-.01-.2.01-.39.06-.58.05-.19.12-.36.22-.51.1-.15.22-.27.37-.36.15-.09.32-.13.53-.13.32 0 .59.1.79.3.21.2.31.46.31.79 0 .23-.05.43-.14.59-.09.16-.21.29-.35.38-.15.09-.32.16-.51.19-.19.04-.38.05-.57.04v.93c.23-.01.45 0 .67.02.22.02.42.08.59.17.18.09.32.23.43.4.11.18.16.41.16.71 0 .44-.13.78-.39 1.02s-.58.36-.97.36c-.45 0-.79-.16-1.02-.47-.23-.31-.33-.7-.32-1.17H11c.01.4.06.77.17 1.1.11.33.26.61.47.85.21.23.46.42.77.54.31.13.67.19 1.08.19.34 0 .66-.05.96-.16.3-.11.57-.27.8-.47.23-.2.41-.45.55-.74.13-.27.2-.6.2-.97 0-.5-.11-.92-.34-1.27z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6BBup":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 0a1 1 0 00-1 1v3h2V2h2V0H1zM0 15v-3h2v2h2v2H1a1 1 0 01-1-1zM15 16h-3v-2h2v-2h2v3a1 1 0 01-1 1zM16 1v3h-2V2h-2V0h3a1 1 0 011 1zM8 7l4.5-2.5-4.108-2.407a.823.823 0 00-.76 0L3.57 4.394 8 7zM12.955 5c.026.074.04.153.04.234v4.834a.707.707 0 01-.357.614L8.4 13V7.847L12.955 5zM7.594 7.743L3.04 5c-.026.074-.04.227-.04.308v4.656c0 .254.136.488.356.614L7.594 13V7.743z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7R3xa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 5h-3V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h3v-4h4v4h7c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM5 10H2V7h3v3zm0-5H2V2h3v3zm5 5H7V7h3v3zm0-5H7V2h3v3zm4 9h-2v-2h2v2zm0-4h-2V7h2v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jOUIa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM6 14l1-5H4l6-7-1 5h3l-6 7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eu4ZI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 14h-1.35l-3.34-7.51 2.46-.95 1.45 3.21c.09.2.36.3.6.23.1-.03.18-.08.24-.15.05-.08 1.23-1.56.87-4.2-.11-.79-.52-4.62-3.26-4.62-.93 0-1.68.62-1.67 1.37 0 .14.03.28.09.42l.87 1.92L.64 8.07v.01A.98.98 0 000 9c0 .55.45 1 1 1 .13 0 .25-.03.36-.07v.01l1.04-.4L3.67 14H2c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1s-.45-1-1-1zM4.27 8.81L7.14 7.7 5.2 12.08l-.93-3.27zM6.54 14L9 8.46 11.46 14H6.54z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"35kSx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.99-.01h-3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-14c0-.55-.45-1-1-1zm-6 5c-.28 0-.53.11-.71.29l-2 2a1.014 1.014 0 000 1.42l2 2a1.003 1.003 0 001.71-.71v-4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hqih4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 3a1 1 0 11-2 0 1 1 0 012 0zm-3.726 1.254a3 3 0 10-.17-2.039 5.467 5.467 0 00-.51.158c-1.076.394-2.237 1.242-2.575 2.93-.161.809-.664 1.211-1.293 1.443a3 3 0 100 2.508c.629.232 1.132.634 1.293 1.442.338 1.69 1.499 2.537 2.575 2.93.17.063.342.115.51.159a3.001 3.001 0 10.17-2.04c-.629-.231-1.132-.633-1.293-1.441C8.765 9.228 8.216 8.494 7.568 8c.648-.493 1.197-1.228 1.413-2.304.161-.808.664-1.21 1.293-1.442zM13 14a1 1 0 110-2 1 1 0 010 2zM4 8a1 1 0 10-2 0 1 1 0 002 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5SKOw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 8a1 1 0 112 0 1 1 0 01-2 0zm3.83-1a3.001 3.001 0 100 2h4.34a3.001 3.001 0 100-2H5.83zM13 7a1 1 0 100 2 1 1 0 000-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQGnL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 0h10c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1H8v-2h6V3H6v5H4V1c0-.55.45-1 1-1zm2.5 5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5s.22.5.5.5zm0 2h2c.28 0 .5-.22.5-.5S9.78 6 9.5 6h-2c-.28 0-.5.22-.5.5s.22.5.5.5zM11 8.5c0 .28-.165.5-.375.5h-2.25C8.165 9 8 8.78 8 8.5s.165-.5.375-.5h2.25c.21 0 .375.22.375.5zM5 14c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1h1.59L.3 14.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L5 12.41V14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d5ydO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0c4.42 0 8 3.58 8 8 0 4.06-3.02 7.4-6.94 7.92-.02 0-.04.01-.06.01-.33.04-.66.07-1 .07-4.42 0-8-3.58-8-8 0-.55.45-1 1-1s1 .45 1 1c0 3.31 2.69 6 6 6 .71 0 1.37-.15 2-.38v.01c2.33-.82 4-3.02 4-5.63 0-3.31-2.69-6-6-6-1.78 0-3.36.78-4.46 2H5c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v1.74A7.95 7.95 0 018 0zm1 12H7v-2h2v2zm0-3H7V4h2v5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ddPZ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 16c-4.41 0-8-3.582-8-8.005C0 3.572 3.59 0 8 0c.94 0 1.86.16 2.74.48.52.19.79.76.6 1.281-.19.52-.76.79-1.28.6a6.007 6.007 0 00-8.05 5.644 6.007 6.007 0 008.05 5.643.997.997 0 011.28.6.998.998 0 01-.6 1.282c-.88.32-1.8.47-2.74.47z",
    "M15.71 7.295c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-3 3.002a1.003 1.003 0 01-1.71-.71c0-.28.11-.53.3-.71l1.29-1.291H5c-.55 0-1-.45-1-1.001 0-.55.45-1 1-1h7.59l-1.3-1.291a1.003 1.003 0 011.42-1.42l3 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6xHiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.8.15l5.1 2.6c.7.3 1.1 1 1.1 1.8v6.8c0 .8-.5 1.6-1.3 1.9l-6.9 2.6c-.5.2-1.1.2-1.6 0l-5.1-2.6c-.7-.3-1.1-1-1.1-1.8v-6.8c0-.8.5-1.6 1.3-1.9L8.2.15c.5-.2 1.1-.2 1.6 0zM12 6.193V9.9l-2 .8V6.943l-2 .75v6.018l6-2.261V5.443l-2 .75z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8oo5X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 .95H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-12c0-.55-.45-1-1-1zm-9 12H2v-6h4v6zm8 0H7v-6h7v6zm0-7H2v-3h12v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cl2bz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 16h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1zM2 2h12v12H2V2zm7 11h4V3H9v10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"79elX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 4h3v1h-3zM10 6h3v1h-3zM10 8h3v1h-3zM10 10h3v1h-3z",
    "M15 1H1c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM8 12H2V3h6v9zm6 0H9V3h5v9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gqyRn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1H1c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM8 9H6V7h2v2zm0-3H6V4h2v2zm-6 6V3h3v9H2zm4 0v-2h2v2H6zm8 0H9v-2h5v2zm0-3H9V7h5v2zm0-3H9V4h5v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e9z44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.68 2.31A4.54 4.54 0 0011.46.99c-1.15 0-2.31.44-3.19 1.32L.95 9.63c-.63.63-.95 1.46-.95 2.28a3.21 3.21 0 003.23 3.22c.83 0 1.66-.31 2.3-.95l7.31-7.32c.76-.77.76-1.98.01-2.73s-1.99-.76-2.75 0l-6.07 6.08c-.24.25-.24.65.01.9s.65.25.91.01l6.07-6.08c.25-.25.67-.25.91-.01.25.25.25.67 0 .92l-7.31 7.32c-.75.75-2.04.74-2.76.01-.75-.75-.73-2.02.01-2.76L9.2 3.21c1.24-1.24 3.35-1.26 4.58-.03 1.24 1.24 1.24 3.36 0 4.6l-7.12 7.13c-.24.25-.24.64.01.88.24.24.63.24.88.01v.01l7.13-7.13A4.41 4.41 0 0016 5.51c0-1.16-.44-2.32-1.32-3.2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8cxtn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 1H6C3.8 1 2 2.8 2 5s1.8 4 4 4v5c0 .6.4 1 1 1s1-.5 1-1V3h2v11c0 .6.4 1 1 1s1-.5 1-1V3h1c.5 0 1-.4 1-1s-.4-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dKtkP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 1c.55 0 1 .45 1 1v1H5V2c0-.55.45-1 1-1h-.22c.34-.6.98-1 1.72-1s1.38.4 1.72 1H9z",
    "M11 2h1c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h1v2h7V2zm-.684 9.326l.225.129c-.367.6-.717 1.013-1.051 1.262-.259.189-.517.283-.776.283-.267 0-.484-.06-.66-.18-.174-.12-.333-.318-.466-.584a9.666 9.666 0 01-.484-1.296c-.484.627-.86 1.082-1.135 1.365-.275.283-.5.472-.684.558a1.353 1.353 0 01-.584.128c-.217 0-.384-.06-.51-.188a.677.677 0 01-.191-.49.73.73 0 01.2-.523.694.694 0 01.518-.206c.108 0 .233.034.375.094.2.103.35.155.442.155a.654.654 0 00.326-.078c.125-.06.275-.197.467-.403.117-.129.333-.404.642-.824-.4-1.494-.709-2.386-.926-2.678-.142-.19-.317-.283-.534-.283-.108 0-.25.017-.409.051l.042-.232 2.16-.377c.393.618.668 1.304.81 2.043.41-.601.71-1.03.918-1.27.275-.327.509-.542.684-.636.184-.095.376-.146.576-.146.233 0 .4.06.525.189.126.12.184.292.184.506a.67.67 0 01-.184.49.577.577 0 01-.45.188 1.55 1.55 0 01-.45-.068 1.935 1.935 0 00-.36-.069.773.773 0 00-.492.189c-.217.172-.475.54-.792 1.099.35 1.261.634 2.025.842 2.309.126.154.25.24.376.24a.5.5 0 00.275-.086c.117-.094.3-.309.55-.66z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4E0nf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.5 0h-13C.67 0 0 .67 0 1.5S.67 3 1.5 3H7v3H3.5C2.67 6 2 6.67 2 7.5S2.67 9 3.5 9H7v3H5.5c-.83 0-1.5.67-1.5 1.5S4.67 15 5.5 15h5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H9V9h3.5c.83 0 1.5-.67 1.5-1.5S13.33 6 12.5 6H9V3h5.5c.83 0 1.5-.67 1.5-1.5S15.33 0 14.5 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bxgQW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 14.62l-4-2.4V9.77c-.32.09-.66.15-1 .18v2.27l-4 2.4V8.71c-.38-.31-.72-.66-1-1.06v6.97l-4-2.4V8c.55 0 1-.45 1-1s-.45-1-1-1V1.38l3.15 1.89c.08-.34.18-.66.32-.97L.76.07v.01A.496.496 0 00.5 0C.22 0 0 .22 0 .5v12c0 .18.1.33.25.42v.01l5 3v-.01c.07.05.16.08.25.08s.18-.03.25-.08v.01l4.74-2.85 4.74 2.85v-.01c.09.05.18.08.27.08.28 0 .5-.22.5-.5v-3.78c-.3.17-.63.28-1 .28v2.62zM2 5c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm6-1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm7.75-.92l-1.19-.72c.18.43.29.9.36 1.38l.08.04v3.39l1 1V3.5c0-.18-.1-.33-.25-.42zM10 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3.3 4.89c.44-.7.7-1.51.7-2.39C14 2.01 11.99 0 9.5 0S5 2.01 5 4.5 7.01 9 9.5 9c.88 0 1.69-.26 2.39-.7l2.41 2.41c.17.18.42.29.7.29a1.003 1.003 0 00.71-1.71l-2.41-2.4zM9.5 8C7.57 8 6 6.43 6 4.5S7.57 1 9.5 1 13 2.57 13 4.5 11.43 8 9.5 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45LmF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 3H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm6 0h-2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lAV7g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.69 13.98c-.05-.24-.14-.5-.25-.76-.36-.86-1.12-1.33-2.69-2-.14-.06-.59-.25-.6-.25-.21-.09-.36-.15-.5-.22.02-.1.02-.2.03-.31 0-.04.01-.08.01-.13-.07-.06-.13-.12-.19-.19.22-.32.4-.67.54-1.05.02-.06.02-.06.03-.1.29-.23.48-.57.59-.96.16-.33.25-.73.21-1.16-.03-.4-.16-.76-.37-1.03-.02-.53-.07-1.13-.15-1.54-.01-.06-.02-.12-.03-.19.23-.06.48-.09.72-.09.49 0 1.05.16 1.44.46.38.29.67.7.8 1.17.03.1.05.21.07.31.07.37.11.94.11 1.33v.05c.14.06.27.21.29.51.02.25-.07.45-.13.54-.05.21-.16.44-.38.48-.02.1-.05.2-.09.3 0 .01-.01.03-.01.03-.17.44-.43.83-.75 1.11v.14c.03.35-.09.59.83 1 .93.41 2.32.84 2.6 1.5.29.66.17 1.04.17 1.04h-2.3zm-1.17-.38c.37.86.22 1.36.22 1.36H.06s-.14-.5.22-1.36 2.13-1.43 3.31-1.96c1.17-.54 1.05-.86 1.09-1.3 0-.05.01-.11.01-.17-.41-.35-.75-.86-.97-1.45v-.01s-.01-.01-.01-.02c-.04-.12-.09-.26-.12-.39-.28-.05-.44-.36-.5-.64-.06-.12-.19-.39-.16-.71.04-.41.21-.6.39-.68v-.06c0-.51.05-1.26.14-1.74.02-.13.05-.27.09-.4.17-.6.54-1.13 1.02-1.51.5-.39 1.21-.6 1.84-.6s1.34.21 1.84.6c.48.38.85.91 1.02 1.52.04.13.07.27.09.4.09.48.14 1.22.14 1.73v.07c.18.08.34.27.37.67.03.32-.09.59-.16.71-.06.28-.21.58-.48.63-.03.13-.07.26-.12.39 0 .01-.01.04-.01.04-.22.58-.55 1.08-.95 1.45v.18c.04.45-.12.77 1.06 1.3 1.18.53 2.95 1.09 3.31 1.95z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"13OXo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 6V4c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2zM3.5 6c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5s.5.22.5.5v1c0 .28-.22.5-.5.5zM13 8h-1c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm0 3.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5s.5.22.5.5v1zM12 3a1.003 1.003 0 00-1.87-.5l-5.99 9.98c-.09.15-.14.33-.14.52a1.003 1.003 0 001.87.5l5.99-9.98c.09-.15.14-.33.14-.52z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QPPB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.68 14.32c-.46-1.05-2.68-1.75-4.16-2.4-1.48-.65-1.28-1.05-1.33-1.59-.01-.07-.01-.15-.01-.23.51-.45.92-1.07 1.19-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.34-.07.54-.44.61-.78.08-.14.23-.48.2-.87-.05-.5-.25-.73-.47-.82v-.09c0-.63-.06-1.55-.17-2.15A3.671 3.671 0 0010.32.72C9.68.25 8.79-.01 8-.01c-.79 0-1.68.25-2.31.73-.61.47-1.06 1.13-1.28 1.86-.05.17-.09.33-.11.5-.12.6-.17 1.51-.17 2.15v.08c-.24.09-.45.32-.5.83-.03.38.13.72.2.86.08.35.28.72.63.78.04.17.09.33.15.49 0 .01.01.02.01.03l.01.01c.27.72.7 1.35 1.22 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.37 1.59-1.48.65-3.7 1.35-4.16 2.4-.46 1.05-.27 1.67-.27 1.67h15.92c-.01.01.18-.61-.28-1.66z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"75iFE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.9 12.41c-.06-.06-3.37-2-3.48-2.05a.794.794 0 00-.32-.08c-.15 0-.34.11-.57.32-.23.22-.94 1.19-1.15 1.4-.21.22-.38.32-.52.32-.07 0-.15-.02-.25-.06-.1-.04-1.16-.58-3.36-2.52-2.2-1.93-2.49-3.2-2.5-3.55 0-.14.11-.31.32-.52.22-.21.45-.41.7-.6.25-.19.49-.4.7-.62.22-.23.32-.42.32-.57 0-.11-.03-.21-.08-.32C5.66 3.46 3.66.15 3.59.08 3.44-.07 2.85 0 2.55.16.16 1.46-.03 3.2 0 3.89c.04.71.49 4.46 4.16 7.95C8.72 16.17 11.89 16 12.1 16c.69 0 2.82-.38 3.72-2.55.13-.32.25-.87.08-1.04z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iSnlX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.916 12.41c-.06-.06-3.373-2-3.483-2.05a.795.795 0 00-.32-.08c-.15 0-.34.11-.57.32-.23.22-.941 1.19-1.152 1.4-.21.22-.38.32-.52.32a.69.69 0 01-.25-.06c-.1-.04-1.161-.58-3.363-2.52-2.202-1.929-2.492-3.199-2.502-3.549 0-.14.11-.31.32-.52.22-.21.45-.41.7-.6.25-.19.491-.4.701-.62.22-.23.32-.42.32-.57 0-.109-.03-.209-.08-.319-.05-.1-2.051-3.41-2.121-3.48-.15-.15-.741-.08-1.041.08-2.392 1.3-2.582 3.04-2.552 3.73.04.71.49 4.459 4.163 7.948C8.73 16.17 11.903 16 12.113 16c.69 0 2.822-.38 3.723-2.55.13-.32.25-.87.08-1.04z",
    "M13 7c0 .6-.4 1-1 1s-1-.4-1-1c0-1.1-.9-2-2-2-.6 0-1-.4-1-1s.4-1 1-1c2.2 0 4 1.8 4 4z",
    "M16 7c0 .6-.4 1-1 1s-1-.4-1-1c0-2.8-2.2-5-5-5-.6 0-1-.4-1-1s.4-1 1-1c3.9 0 7 3.1 7 7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"71pbm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.916 12.41c-.06-.06-3.373-2-3.483-2.05a.795.795 0 00-.32-.08c-.15 0-.34.11-.57.32-.23.22-.941 1.19-1.152 1.4-.21.22-.38.32-.52.32a.69.69 0 01-.25-.06c-.1-.04-1.161-.58-3.363-2.52-2.202-1.929-2.492-3.199-2.502-3.549 0-.14.11-.31.32-.52.22-.21.45-.41.7-.6.25-.19.491-.4.701-.62.22-.23.32-.42.32-.57 0-.109-.03-.209-.08-.319-.05-.1-2.051-3.41-2.121-3.48-.15-.15-.741-.08-1.041.08-2.392 1.3-2.582 3.04-2.552 3.73.04.71.49 4.459 4.163 7.948C8.73 16.17 11.903 16 12.113 16c.69 0 2.822-.38 3.723-2.55.13-.32.25-.87.08-1.04z",
    "M15.71 4.3l-2-2A.965.965 0 0013 2a1.003 1.003 0 00-.71 1.71l.29.29H9c-.55 0-1 .45-1 1s.45 1 1 1h3.59l-.29.29a1.003 1.003 0 001.42 1.42l2-2c.18-.18.29-.43.29-.71 0-.28-.12-.52-.3-.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2OH21":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 1.08c-3.37.5-5.97 3.4-5.97 6.92 0 3.87 3.13 7 6.98 7 3.52 0 6.42-2.61 6.91-6H7V1.08z",
    "M8 0v8h8c0-4.42-3.58-8-8-8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dtH9N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 4h3.273c.401 0 .727.326.727.727v6.546a.727.727 0 01-.727.727H4a4 4 0 010-8zm12 4a4 4 0 01-4 4H9.636A.636.636 0 019 11.364V4.636C9 4.285 9.285 4 9.636 4H12a4 4 0 014 4zm-4-2h-1v4h1a2 2 0 100-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hLaKB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.41.92c-.51.51-.41 1.5.15 2.56L4.34 7.54C2.8 6.48 1.45 6.05.92 6.58l3.54 3.54-3.54 4.95 4.95-3.54 3.54 3.54c.53-.53.1-1.88-.96-3.42l4.06-5.22c1.06.56 2.04.66 2.55.15L9.41.92z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3WEAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.57 7.02L.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4.27-4.27c-.58-.35-1.07-.84-1.41-1.42zM15 8c-.55 0-1 .45-1 1v.59l-2.57-2.57c-.34.58-.83 1.07-1.41 1.41L12.59 11H12c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-4-3c0-1.66-1.34-3-3-3S5 3.34 5 5s1.34 3 3 3 3-1.34 3-3zM8 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5YQ4l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 4H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0-4H1C.45 0 0 .45 0 1v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm11.71 4.29C13.53 4.11 13.28 4 13 4s-.53.11-.71.29l-2 2a1.003 1.003 0 001.42 1.42l.29-.3V9c0 1.66-1.34 3-3 3H7.41l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H9c2.76 0 5-2.24 5-5V7.41l.29.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-2-2zM15 0H5c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4GIIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 8c0-.35-.19-.64-.46-.82l.01-.02-6-4-.01.02A.969.969 0 005 3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1 .21 0 .39-.08.54-.18l.01.02 6-4-.01-.02c.27-.18.46-.47.46-.82z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lefYD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.293.293a1 1 0 011.414 1.414L4.414 3l1.293 1.293a1 1 0 01-1.414 1.414L3 4.414 1.707 5.707A1 1 0 01.293 4.293L1.586 3 .293 1.707A1 1 0 011.707.293L3 1.586 4.293.293z",
    "M14.29 4.71L13 3.41V6a3 3 0 01-3 3H4a1 1 0 00-1 1v5a1 1 0 11-2 0v-5a3 3 0 013-3h6a1 1 0 001-1V3.41L9.71 4.7c-.18.19-.43.3-.71.3a1.003 1.003 0 01-.71-1.71l3-3c.18-.18.43-.29.71-.29.28 0 .53.11.71.29l3 3a1.003 1.003 0 01-1.42 1.42z",
    "M16 13a3 3 0 11-6 0 3 3 0 016 0zm-2 0a1 1 0 11-2 0 1 1 0 012 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fP0Ut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 7H9V3c0-.55-.45-1-1-1s-1 .45-1 1v4H3c-.55 0-1 .45-1 1s.45 1 1 1h4v4c0 .55.45 1 1 1s1-.45 1-1V9h4c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4b27Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 5c-.24 0-.47.05-.68.13L9.97 2.34c.01-.11.03-.22.03-.34 0-1.1-.9-2-2-2S6 .9 6 2c0 .04.01.08.01.12L2.88 4.21C2.61 4.08 2.32 4 2 4 .9 4 0 4.9 0 6c0 .74.4 1.38 1 1.72v4.55c-.6.35-1 .99-1 1.73 0 1.1.9 2 2 2 .74 0 1.38-.4 1.72-1h4.55c.35.6.98 1 1.72 1 1.1 0 2-.9 2-2 0-.37-.11-.7-.28-1L14 9c1.11-.01 2-.9 2-2s-.9-2-2-2zm-4.01 7c-.73 0-1.37.41-1.71 1H3.73c-.18-.3-.43-.55-.73-.72V7.72c.6-.34 1-.98 1-1.72 0-.04-.01-.08-.01-.12l3.13-2.09c.27.13.56.21.88.21.24 0 .47-.05.68-.13l3.35 2.79c-.01.11-.03.22-.03.34 0 .37.11.7.28 1l-2.29 4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chqxt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 8c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1S7 .45 7 1v6c0 .55.45 1 1 1zm3-5.32v2.34c1.21.91 2 2.35 2 3.98 0 2.76-2.24 5-5 5s-5-2.24-5-5c0-1.63.79-3.06 2-3.98V2.68C2.64 3.81 1 6.21 1 9c0 3.87 3.13 7 7 7s7-3.13 7-7c0-2.79-1.64-5.19-4-6.32z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"efnIT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 6.41c0-1.01-.49-1.94-1.29-2.49-.43-1.92-2.07-3.28-4-3.28-.46 0-.92.08-1.35.24C8.83.31 8.11 0 7.34 0c-.9 0-1.74.44-2.28 1.16-.12-.01-.24-.02-.36-.02-1.31 0-2.42.89-2.77 2.17C.78 3.72 0 4.84 0 6.13c0 .38.07.76.21 1.12C.07 7.6 0 7.98 0 8.36c0 1.11.58 2.11 1.51 2.63.54.56 1.27.87 2.03.87.49 0 .95-.12 1.37-.36a2.85 2.85 0 002.18 1.04c.52 0 1.03-.14 1.47-.42.49.39 1.07.65 1.69.73 1.04 1.15 1.84 2.63 1.84 2.64 0 0 .28.49.26.49.77 0 1.41-.16 1.32-1.04 0 .02-.73-2.31-.73-2.31.41-.21.75-.55.97-.98.9-.52 1.47-1.53 1.47-2.61 0-.24-.03-.48-.08-.71.45-.52.7-1.21.7-1.92zm-1.23 1.02l-.15-.16-.61-.67c-.27-.29-.54-.94-.58-1.39l-.1-1.01c-.05-.59-.94-.58-.91.11 0 .02.1 1.01.1 1.01.03.29.12.62.24.93-.06-.01-.12-.02-.18-.02 0 0-2.06-.1-2.05-.11-.58-.02-.71.97-.04 1l2.05.11c.42.02 1.04.3 1.29.58l.49.54.02.05c.08.21.12.44.12.66 0 .74-.41 1.41-1.07 1.75l-.16.08-.07.18c-.15.38-.48.66-.88.74l-.54.11.7 2.2c-.38-.61-.95-1.43-1.62-2.14l-.12-.13-.17-.01c-.41-.03-.8-.17-1.14-.38l1.36-1.18c.35-.31.83-.44.99-.39 0 0 .63.17.62.18.63.16.83-.74.23-.97l-.62-.18c-.55-.16-1.33.18-1.79.58l-1.53 1.33-.31.26c-.35.29-.75.44-1.2.44-.64 0-1.23-.33-1.58-.86V9.15c0-.4.17-.79.27-.85 0 0 .52-.34.51-.35.71-.53.18-1.23-.49-.89 0-.01-.52.35-.52.35-.26.15-.45.44-.58.77-.11-.11-.22-.2-.34-.28 0 0-1.53-1.01-1.53-1.02-.65-.45-1.2.51-.49.89 0-.01 1.51 1.02 1.51 1.02.37.24.62.78.62 1.09v.67c-.34.19-.63.29-.99.29-.54 0-1.05-.23-1.41-.63l-.05-.06-.07-.04c-.65-.34-1.05-1-1.05-1.73 0-.3.07-.6.2-.87l.12-.25L1.15 7c-.13-.27-.2-.56-.2-.87 0-.9.61-1.68 1.48-1.89l.31-.08.05-.34a1.926 1.926 0 012.38-1.58l.32.08.18-.31c.35-.6.99-.97 1.67-.97.44 0 .86.15 1.2.42l-.36.36v-.01l-.25.26c-.33.27-.74.42-.89.4 0 0-.67-.1-.67-.11-.67-.13-.87.86-.14 1.02.01 0 .67.11.67.11.02 0 .05 0 .07.01-.11.37-.15.77-.1 1.12 0 0 .17.99.15.99.11.52 1.06.36.93-.18 0-.01-.15-.99-.15-.99-.05-.37.12-.94.36-1.19l.39-.4c.05-.05.1-.09.15-.14l.74-.76c.4-.18.83-.27 1.27-.27 1.55 0 2.86 1.12 3.11 2.67l.04.25.21.12c.61.35.98 1 .98 1.7 0 .36-.1.7-.28 1.01z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1SnUD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.91 8.34c.14-.21.36-.34.63-.34h1.29c.22 0 .41.07.52.26.09.16.08.33-.04.53l-2.49 2.87 2.77 3.54c.12.17.14.37.02.55-.11.17-.3.25-.5.25h-1.44a.69.69 0 01-.61-.35L9.4 13.51l-1.69 2.15c-.13.21-.36.34-.63.34H5.8c-.22 0-.41-.07-.52-.26-.09-.16-.08-.33.04-.53l2.71-3.48L4.3 6.99H3.03v3.47c0 .33-.26.56-.62.56h-.8c-.35-.01-.61-.23-.61-.56V.56c0-.33.26-.56.62-.56h3.11c.62 0 1.19.08 1.7.24.51.16.96.39 1.34.69a3.194 3.194 0 011.21 2.53c0 .81-.25 1.5-.74 2.08-.37.44-.84.77-1.42 1.01L7.88 7.9c.04.04.07.08.08.1l1.49 1.9 1.46-1.56zM5.18 5c.62 0 1.08-.13 1.39-.37.29-.23.44-.71.44-1.16s-.15-.87-.44-1.1C6.26 2.12 5.8 2 5.18 2H2.99v3h2.19z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ccZEN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1H9c0-.55-.45-1-1-1S7 .45 7 1H1c-.55 0-1 .45-1 1s.45 1 1 1v8c0 .55.45 1 1 1h3.59L3.3 14.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L7 13.41V15c0 .55.45 1 1 1s1-.45 1-1v-1.59l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L10.41 12H14c.55 0 1-.45 1-1V3c.55 0 1-.45 1-1s-.45-1-1-1zm-2 9H3V3h10v7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b2Rhv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 2.02c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v1h8v-1zm3 2H1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h1v-3h12v3h1c.55 0 1-.45 1-1v-6c0-.56-.45-1-1-1zm-1 3h-2v-1h2v1zm-3 6H5v-3H3v4c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-4h-2v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1fgQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v1h12V3zm-2-3H4c-.55 0-1 .45-1 1h10c0-.55-.45-1-1-1zm3 5H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-3 6c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V9h1v2h6V9h1v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Sl5D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-3h9c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1zm-4 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm13-5H6c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm0 6H6c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"96dqD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-.5-6.5a2.5 2.5 0 000 5 2.5 2.5 0 000-5zM7 3h8c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1zm8 10H7c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zM3 0C1.9 0 1 .9 1 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 6H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5ZyTZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.16 3.76c.15-.11.3-.16.47-.16.06 0 .17.02.34.06.16.04.31.06.43.06a.58.58 0 00.6-.6c0-.19-.06-.33-.17-.44-.11-.11-.28-.16-.49-.16-.19 0-.37.04-.54.13-.17.09-.39.27-.65.55-.2.21-.48.58-.87 1.11a5.22 5.22 0 00-.78-1.79l-2.05.32-.04.21c.15-.03.28-.04.39-.04.2 0 .37.08.5.25.21.26.5 1.03.88 2.33-.29.36-.49.6-.6.71-.18.19-.33.31-.45.36-.09.04-.19.07-.3.07-.09 0-.23-.04-.42-.13a.904.904 0 00-.36-.09c-.2 0-.36.06-.49.18a.59.59 0 00-.19.46c0 .18.06.32.18.43.12.11.28.16.48.16.2 0 .38-.04.55-.12.17-.08.39-.24.65-.49s.62-.65 1.07-1.19c.18.52.33.89.46 1.13.13.24.28.4.44.51.17.1.37.16.62.16.24 0 .49-.08.74-.25.33-.21.66-.58 1.01-1.09l-.21-.11c-.23.31-.41.5-.52.57a.44.44 0 01-.26.07c-.12 0-.24-.07-.36-.21-.2-.24-.46-.91-.8-2 .29-.49.54-.81.74-.96zM6.37 5.83l.68-2.53h.83l.2-.64h-.84c.24-.91.56-1.59.96-2.01.24-.27.48-.4.71-.4.05 0 .08.01.11.04s.04.06.04.1c0 .04-.03.11-.1.21-.06.1-.1.2-.1.29 0 .13.05.24.15.33.1.09.23.14.39.14.17 0 .31-.06.42-.17.12-.12.18-.27.18-.46 0-.21-.08-.39-.25-.52C9.57.07 9.3 0 8.93 0c-.59 0-1.12.16-1.59.48-.48.32-.93.85-1.36 1.59-.15.26-.29.42-.42.49s-.35.11-.64.1l-.19.65h.81L4.35 7.68c-.2.72-.33 1.16-.4 1.33-.1.24-.26.45-.46.62a.48.48 0 01-.31.1c-.03 0-.06-.01-.08-.03l-.03-.03c0-.02.03-.06.09-.11.06-.06.09-.15.09-.26 0-.13-.05-.23-.14-.32-.1-.09-.23-.13-.41-.13-.21 0-.38.05-.51.16A.52.52 0 002 9.4c0 .16.08.3.23.42.16.12.4.18.74.18.53 0 .99-.13 1.4-.39.41-.26.76-.65 1.07-1.19.3-.53.61-1.39.93-2.59zm2.34 3.46A.997.997 0 008 9c-.28 0-.53.11-.71.29l-2 2a1.003 1.003 0 001.42 1.42l.29-.3V15c0 .55.45 1 1 1s1-.45 1-1v-2.59l.29.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2AgTl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 8h-1.46l-1.7-2.55-.02.01A.984.984 0 0011 5c-.43 0-.79.27-.93.65h-.01l-1.69 4.51-1.38-8.32h-.02A.989.989 0 006 1c-.41 0-.77.25-.92.61L2.34 8H1c-.55 0-1 .45-1 1s.45 1 1 1h2c.41 0 .77-.25.92-.61l1.65-3.86 1.44 8.63h.02c.08.47.47.84.97.84.43 0 .79-.27.93-.65h.01l2.31-6.17.92 1.38.02-.01c.17.26.46.45.81.45h2c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jrH82":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.5 8a2.5 2.5 0 11.608-4.926 4.002 4.002 0 017.381-1.03A3 3 0 1112 8H3.501zM3 10a1 1 0 012 0v4a1 1 0 11-2 0v-4zm7-1a1 1 0 00-1 1v5a1 1 0 102 0v-5a1 1 0 00-1-1zm2 1a1 1 0 112 0v2a1 1 0 11-2 0v-2zM7 9a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2VxLg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.48 4h1.11l-.29.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H11c-.32 0-.59.16-.77.38l-.01-.01L8.28 4.8l1.28 1.6L11.48 4zm2.23 6.29a1.003 1.003 0 00-1.42 1.42l.3.29h-1.11l-7.7-9.62h-.01A.996.996 0 003 2H1c-.55 0-1 .45-1 1s.45 1 1 1h1.52l7.7 9.62.01-.01c.18.23.45.39.77.39h1.59l-.29.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2-2zM2.52 12H1c-.55 0-1 .45-1 1s.45 1 1 1h2c.32 0 .59-.16.77-.38l.01.01 1.94-2.42L4.44 9.6 2.52 12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7kAyi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0c-.353 0-.702.023-1.044.068a1 1 0 10.26 1.983 6.064 6.064 0 011.569 0A1 1 0 009.044.068 8.066 8.066 0 008 0zM4.348 3.24a1 1 0 10-1.219-1.587A8.042 8.042 0 001.653 3.13 1 1 0 003.24 4.348c.32-.416.693-.79 1.109-1.109zm8.523-1.587a1 1 0 10-1.219 1.586c.416.32.79.693 1.109 1.109a1 1 0 101.586-1.219 8.04 8.04 0 00-1.476-1.476zm3.061 5.303a1 1 0 10-1.983.26 6.057 6.057 0 010 1.569 1 1 0 001.983.259 8.068 8.068 0 000-2.088zm-13.881.26a1 1 0 00-1.983-.26 8.066 8.066 0 000 2.088 1 1 0 101.983-.26 6.064 6.064 0 010-1.569zm1.188 4.436a1 1 0 10-1.586 1.219 8.04 8.04 0 001.476 1.476 1 1 0 001.219-1.586 6.042 6.042 0 01-1.109-1.109zm11.108 1.219a1 1 0 00-1.586-1.219c-.32.416-.693.79-1.109 1.109a1 1 0 101.219 1.586 8.038 8.038 0 001.476-1.476zm-5.303 3.061a1 1 0 10-.26-1.983 6.057 6.057 0 01-1.569 0 1 1 0 00-.259 1.983 8.068 8.068 0 002.088 0zM8 6a2 2 0 110 4 2 2 0 010-4zm4 2a4 4 0 10-8 0 4 4 0 008 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aLcxO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 3a5 5 0 100 10A5 5 0 108 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfx1q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 15V1h10v14H3zm0 1a1 1 0 01-1-1V1a1 1 0 011-1h10a1 1 0 011 1v14a1 1 0 01-1 1H3zM8.707 3.293a1 1 0 00-1.414 0l-2 2a1 1 0 001.414 1.414L8 5.414l1.293 1.293a1 1 0 001.414-1.414l-2-2zm-2 6a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L8 10.586 6.707 9.293z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kzNsc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 3h14v10H1V3zM0 3a1 1 0 011-1h14a1 1 0 011 1v10a1 1 0 01-1 1H1a1 1 0 01-1-1V3zm10.707 2.293a1 1 0 00-1.414 1.414L10.586 8 9.293 9.293a1 1 0 001.414 1.414l2-2a1 1 0 000-1.414l-2-2zm-4 1.414a1 1 0 00-1.414-1.414l-2 2a1 1 0 000 1.414l2 2a1 1 0 001.414-1.414L5.414 8l1.293-1.293z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c2oxl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 3h14c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1zm1 2v6h12V5H2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jjvke":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm3.71-6.71l-3-3a1.003 1.003 0 00-1.42 1.42L12.59 4H5C2.24 4 0 6.24 0 9s2.24 5 5 5h4v-2H5c-1.66 0-3-1.34-3-3s1.34-3 3-3h7.59L11.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fKlb1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 3a5 5 0 00-5 5 1 1 0 01-2 0 7 7 0 017-7c1.72 0 3.62.416 5 1.567V2a1 1 0 112 0v3a1 1 0 01-1 1h-3a1 1 0 110-2h.586C10.702 3.334 9.417 3 8 3zM8 13a5 5 0 005-5 1 1 0 112 0 7 7 0 01-7 7c-1.72 0-3.62-.416-5-1.568V14a1 1 0 11-2 0v-3a1 1 0 011-1h3a1 1 0 110 2h-.586c.884.666 2.169 1 3.586 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h7iiE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 14a2 2 0 114 0 2 2 0 01-4 0zM11 0a1 1 0 00-1 1v2.768L7.603 2.384a1 1 0 10-1 1.732L9 5.5 6.603 6.884a1 1 0 001 1.732L10 7.232V10a1 1 0 102 0V7.232l2.397 1.384a1 1 0 101-1.732L13 5.5l2.397-1.384a1 1 0 10-1-1.732L12 3.768V1a1 1 0 00-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k3VVb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 6.5c0 .83.67 1.5 1.5 1.5S16 7.33 16 6.5 15.33 5 14.5 5 13 5.67 13 6.5zM8.5 5c.83 0 1.5-.67 1.5-1.5S9.33 2 8.5 2 7 2.67 7 3.5 7.67 5 8.5 5zM9 9.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S11.33 8 10.5 8 9 8.67 9 9.5zM4.5 8C5.33 8 6 7.33 6 6.5S5.33 5 4.5 5 3 5.67 3 6.5 3.67 8 4.5 8zM15 12H3.26l12.03-8.59-.58-.81L2 11.67V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k0RSb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.99 6.99h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm-3-7c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.68 6-6 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Fl7I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 0H4c-.55 0-1 .45-1 1v3h2V2h3v12H5v-2H3v3c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14h-3V2h3v12zm-8.71-3.29a1.003 1.003 0 001.42-1.42L4.41 8 5.7 6.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L3 6.59l-1.29-1.3A1.003 1.003 0 00.29 6.71L1.59 8 .29 9.29a1.003 1.003 0 001.42 1.42L3 9.41l1.29 1.3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9MGyw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 9h4c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm11-9H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-5 14H2V2h8v12zm4 0h-3V2h3v12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ekEtn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM5 14H2V2h3v12zm9 0H6V2h8v12zM8 9h4c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bu22x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2V6h12v8zm0-9H2V2h12v3zm-8 6h4c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"czwq2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2v-3h12v3zm0-4H2V2h12v8zM6 7h4c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bNi0X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 5c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1.74A7.95 7.95 0 008 0C3.58 0 0 3.58 0 8c0 4.06 3.02 7.4 6.94 7.92.02 0 .04.01.06.01.33.04.66.07 1 .07 4.42 0 8-3.58 8-8 0-.55-.45-1-1-1s-1 .45-1 1c0 3.31-2.69 6-6 6-.71 0-1.37-.15-2-.38v.01C3.67 12.81 2 10.61 2 8c0-3.31 2.69-6 6-6 1.77 0 3.36.78 4.46 2H11c-.55 0-1 .45-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hUEHv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 5c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v1.74A7.95 7.95 0 018 0c4.42 0 8 3.58 8 8 0 4.06-3.02 7.4-6.94 7.92-.02 0-.04.01-.06.01-.33.04-.66.07-1 .07-4.42 0-8-3.58-8-8 0-.55.45-1 1-1s1 .45 1 1c0 3.31 2.69 6 6 6 .71 0 1.37-.15 2-.38v.01c2.33-.82 4-3.02 4-5.63 0-3.31-2.69-6-6-6-1.77 0-3.36.78-4.46 2H5c.55 0 1 .45 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixfq8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.6 3.3C6.1 3.1 5.6 3 5 3 2.2 3 0 5.2 0 8s2.2 5 5 5c.6 0 1.1-.1 1.6-.3C5.3 11.6 4.5 9.9 4.5 8s.8-3.6 2.1-4.7zM8 4c-1.2.9-2 2.4-2 4s.8 3.1 2 4c1.2-.9 2-2.3 2-4s-.8-3.1-2-4zm3-1c-.6 0-1.1.1-1.6.3 1.3 1.2 2.1 2.9 2.1 4.7s-.8 3.6-2.1 4.7c.5.2 1 .3 1.6.3 2.8 0 5-2.2 5-5s-2.2-5-5-5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hsMPH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.71 3c0 1.1.96 2 2.14 2C9.04 5 10 3.96 10 3c0-1.96-1.47-3-2.14-3H5c0 1.96 2.68 1.4.71 3zm2.5 3l.01.01s0-.01-.01-.01zm6.5 8.29L10 9.59V7c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v2.58l-4.71 4.7c-.18.19-.29.44-.29.72a1.003 1.003 0 001.71.71L6 12.42V15c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.58l3.29 3.29a1.003 1.003 0 001.42-1.42z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dClNP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.6 3.3C5.3 4.4 4.5 6.1 4.5 8s.8 3.6 2.1 4.7c-.5.2-1 .3-1.6.3-2.8 0-5-2.2-5-5s2.2-5 5-5c.6 0 1.1.1 1.6.3zm-1.96 8.68C3.92 10.83 3.5 9.46 3.5 8s.42-2.83 1.14-3.98C2.6 4.2 1 5.91 1 8s1.6 3.8 3.64 3.98zM8 4c-1.2.9-2 2.4-2 4s.8 3.1 2 4c1.2-.9 2-2.3 2-4s-.8-3.1-2-4zm3-1c2.8 0 5 2.2 5 5s-2.2 5-5 5c-.6 0-1.1-.1-1.6-.3 1.3-1.1 2.1-2.9 2.1-4.7s-.8-3.5-2.1-4.7c.5-.2 1-.3 1.6-.3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9WwMs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 12c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bCqbO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 12C4.397 7.46 4.415 4.465 8 0c3.585 4.485 3.602 7.48 2 12H6zm3-7a1 1 0 11-2 0 1 1 0 012 0zm-7 8.022l3-1-.054-.158C4.636 10.954 4.076 9.317 4 8L3 9l-1 4.022zm9-1l3 1L13 9l-1-1c-.076 1.317-.635 2.954-.946 3.864l-.054.158zM7 13h2c0 1.5-.5 2.5-1 3-.5-.5-1-1.5-1-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"W6Qkk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.992 10c2-5 5-9 11-9 0 6-4 9-9 11l-2-2zm7.714-4.285a1 1 0 11-1.414-1.414 1 1 0 011.414 1.414zm-6.555-.218L2.992 6l-3 2L3.24 9.195c.542-1.301 1.166-2.556 1.911-3.698zM7.992 16l-1.236-3.232c1.3-.539 2.552-1.158 3.694-1.898L9.992 13l-2 3zm-4.931-4.94L5 13c-.992.991-2.186 1.154-3.001 1-.154-.815.07-1.948 1.06-2.94z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7QyPC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.635 7.672a.609.609 0 01-.03.828l-3.462 3.46a.609.609 0 00.861.862l3.461-3.461c.677-.677.716-1.76.091-2.485l-2.652-3.072h1.105a.609.609 0 100-1.217h-2.435a.609.609 0 00-.609.609V5.63a.609.609 0 001.218 0v-.798l2.452 2.84zM10.293 7.293a1 1 0 010 1.414L6.05 12.95a1 1 0 01-1.414 0L.393 8.707a1 1 0 010-1.414L4.636 3.05a1 1 0 011.414 0l4.243 4.243z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ihkNE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.365 7.672a.609.609 0 00.03.828l3.461 3.46a.609.609 0 11-.86.862L.535 9.36a1.826 1.826 0 01-.091-2.485l2.652-3.072H1.991a.609.609 0 010-1.217h2.435c.336 0 .609.272.609.609V5.63a.609.609 0 11-1.218 0v-.798l-2.452 2.84z",
    "M15.293 7.293a1 1 0 010 1.414L11.05 12.95a1 1 0 01-1.414 0L5.393 8.707a1 1 0 010-1.414L9.636 3.05a1 1 0 011.414 0l4.243 4.243z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bBpZO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 2h-1.59l.29-.29c.19-.18.3-.43.3-.71A1.003 1.003 0 009.29.29l-2 2C7.11 2.47 7 2.72 7 3c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H12c.55 0 1 .45 1 1v3c0 .55.45 1 1 1s1-.45 1-1V5c0-1.66-1.34-3-3-3zM5.71 5.29A.997.997 0 005 5H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V9c0-.28-.11-.53-.29-.71l-3-3zM7 14H2V7h2v2c0 .55.45 1 1 1h2v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gyAw3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 6H2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zm-1 8H3V8h4v6zm5-12h-1.59l.29-.29c.19-.18.3-.43.3-.71A1.003 1.003 0 009.29.29l-2 2C7.11 2.47 7 2.72 7 3c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H12c.55 0 1 .45 1 1v3c0 .55.45 1 1 1s1-.45 1-1V5c0-1.66-1.34-3-3-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4m9QH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.669 5.066l.099.189c.113.213.236.434.367.661.226.39.468.78.709 1.151l-.198-.004-.48-.004c-1.745.003-2.369.233-2.369.688 0 .053.226.19 1.038.436l.84.24C13.9 9.064 15 9.83 15 11.63c0 2.123-1.607 3.122-4.027 3.366-.651.065-1.266.075-2.043.05l-.958-.035H5.196l.268-.406c.336-.517.672-1.052.998-1.593h1.636l.572.023c.857.036 1.475.034 2.103-.03 1.526-.153 2.227-.59 2.227-1.375 0-.531-.402-.84-1.66-1.22l-.691-.198c-1.04-.293-1.764-.562-2.222-.946C8.8 8.366 9 7.612 9 6.997a5.03 5.03 0 00-.184-1.334c.645-.395 1.598-.562 2.853-.597zM4 3a4.007 4.007 0 014 3.997C8 9.21 4 15 4 15l-.416-.62C2.56 12.827 0 8.767 0 6.997A4.002 4.002 0 014 3zm0 2a2 2 0 10.001 4.001A2 2 0 004 5zm10-4c1.103 0 1.996.896 2 1.999C16 4.105 14 7 14 7l-.293-.44C13.15 5.707 12 3.838 12 2.999 12 1.896 12.897 1 14 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"N5UPY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 9c0-.6.4-1 1-1s1 .4 1 1c0 1.1.9 2 2 2 .6 0 1 .4 1 1s-.4 1-1 1c-2.2 0-4-1.8-4-4zM0 9c0-.6.4-1 1-1s1 .4 1 1c0 2.8 2.2 5 5 5 .6 0 1 .4 1 1s-.4 1-1 1c-3.9 0-7-3.1-7-7zm7 1c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1.3-2.8c-.4-.4-.4-1 0-1.4l4.5-4.5c.4-.4 1-.4 1.4 0l.5.5c.4.4.4 1 0 1.4l-4.5 4.5c-.4.4-1 .4-1.4 0l-.5-.5zM5.2.3c.4-.4 1-.4 1.4 0l2.1 2.1c.4.4.4 1 0 1.4l-.9.9c-.4.4-1 .4-1.4 0L4.3 2.6c-.4-.4-.4-1 0-1.4l.9-.9zm7 7c.4-.4 1-.4 1.4 0l2.1 2.1c.4.4.4 1 0 1.4l-.9.9c-.4.4-1 .4-1.4 0l-2.1-2.1c-.4-.4-.4-1 0-1.4l.9-.9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ilOp4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.71 9.29a1.003 1.003 0 00-1.42 1.42l2 2a.997.997 0 001.6-.27h.01l2-4h-.01c.06-.13.11-.28.11-.44 0-.55-.45-1-1-1-.39 0-.72.23-.89.56H9.1l-1.38 2.76-1.01-1.03zM9 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5L9 0zm3 14H4V2h4v4h4v8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7MiyS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 12H2V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm-.5-7c.83 0 1.5-.67 1.5-1.5S15.33 2 14.5 2 13 2.67 13 3.5 13.67 5 14.5 5zm-3 4c.83 0 1.5-.67 1.5-1.5S12.33 6 11.5 6 10 6.67 10 7.5 10.67 9 11.5 9zm-4-2C8.33 7 9 6.33 9 5.5S8.33 4 7.5 4 6 4.67 6 5.5 6.67 7 7.5 7zm-3 4c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7R6Ia":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.55 13.43l-2.67-2.68a6.94 6.94 0 001.11-3.76c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7c1.39 0 2.68-.42 3.76-1.11l2.68 2.67a1.498 1.498 0 102.12-2.12zm-8.56-1.44c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7iqBt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.5 11c-.51 0-.98.15-1.38.42l-2.4-2.41c.17-.3.28-.64.28-1.01s-.11-.71-.28-1.01l2.41-2.41c.39.27.86.42 1.37.42a2.5 2.5 0 000-5A2.5 2.5 0 0011 2.5c0 .51.15.98.42 1.38l-2.41 2.4C8.71 6.11 8.37 6 8 6s-.71.11-1.01.28l-2.41-2.4c.27-.4.42-.87.42-1.38a2.5 2.5 0 00-5 0A2.5 2.5 0 002.5 5c.51 0 .98-.15 1.38-.42l2.41 2.41C6.11 7.29 6 7.63 6 8s.11.71.28 1.01l-2.41 2.41c-.39-.27-.86-.42-1.37-.42a2.5 2.5 0 000 5A2.5 2.5 0 005 13.5c0-.51-.15-.98-.42-1.38l2.41-2.41c.3.18.64.29 1.01.29s.71-.11 1.01-.28l2.41 2.41c-.27.39-.42.86-.42 1.37a2.5 2.5 0 005 0 2.5 2.5 0 00-2.5-2.5zm0-10c.83 0 1.5.67 1.5 1.5S14.33 4 13.5 4 12 3.33 12 2.5 12.67 1 13.5 1zm-11 3C1.67 4 1 3.33 1 2.5S1.67 1 2.5 1 4 1.67 4 2.5 3.33 4 2.5 4zm0 11c-.83 0-1.5-.67-1.5-1.5S1.67 12 2.5 12s1.5.67 1.5 1.5S3.33 15 2.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5i55n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.55 13.43l-2.67-2.67c.7-1.09 1.11-2.38 1.11-3.77 0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7c1.39 0 2.68-.41 3.77-1.11l2.67 2.67a1.498 1.498 0 102.12-2.12zm-8.56-1.44c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm2.5-6h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm0-2h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm0 4h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lRXaW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 4H5c-.55 0-1 .45-1 1s.45 1 1 1h1v3c0 .55.45 1 1 1s1-.45 1-1V6h1c.55 0 1-.45 1-1s-.45-1-1-1zm6.56 9.44l-2.67-2.67C13.59 9.68 14 8.39 14 7c0-3.87-3.13-7-7-7S0 3.13 0 7s3.13 7 7 7c1.39 0 2.68-.41 3.77-1.11l2.67 2.67a1.498 1.498 0 102.12-2.12zM7 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5SHd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 4H1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 6H8V6h6v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gNhir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 15c0-.28-.12-.52-.31-.69l.02-.02-3.12-3.12 3.41-.84-8.05-2.86c.03-.09.05-.17.05-.27V2c0-.55-.45-1-1-1H3c0-.55-.45-1-1-1S1 .45 1 1c-.55 0-1 .45-1 1s.45 1 1 1v4c0 .55.45 1 1 1h5.2c.1 0 .18-.02.27-.05L10.33 16l.85-3.41 3.12 3.12.02-.02c.16.19.4.31.68.31.04 0 .07-.02.1-.02s.06.02.1.02c.44 0 .8-.36.8-.8 0-.04-.02-.07-.02-.1s.02-.06.02-.1zM6 6H3V3h3v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"75tiA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-9C6.34 5 5 6.34 5 8s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8XuLD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.303 15.71c.18.18.43.29.7.29.27 0 .53-.11.71-.29l2.997-2.99a1.003 1.003 0 00-1.42-1.42l-1.288 1.29L9 9h6a1 1 0 100-2H9V5h6a1 1 0 001-1V2a1 1 0 00-1-1H1a1 1 0 00-1 1v2a1 1 0 001 1h6v2H1a1 1 0 100 2h6v3.586h.003v.004l-1.29-1.29a.99.99 0 00-.699-.29 1.003 1.003 0 00-.71 1.71l2.999 2.99z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fb3rG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.399 9.01L1.527 15.875c-.535.267-1.175.081-1.421-.427A.953.953 0 010 15V10l8-2-8-2V1c0-.528.407-1 1.004-1 .169 0 .416.04.567.116L15.403 7.07a1.084 1.084 0 01-.005 1.939z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vNqV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 7.5c-.8 0-1.5-.4-2-1l-1.2 1.2c-.4.5-1.1.7-1.8.7-1.4.1-2.5-1-2.5-2.4 0-.7.3-1.3.7-1.8L9.5 3c-.6-.5-1-1.2-1-2 0-.3.1-.7.2-1H8C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8v-.7c-.3.1-.6.2-1 .2zM15 0h-4c-.6 0-1 .5-1 1s.4 1 1 1h1.6L9.3 5.3c-.2.2-.3.4-.3.7 0 .5.4 1 1 1 .3 0 .5-.1.7-.3L14 3.4V5c0 .6.4 1 1 1 .5 0 1-.4 1-1V1c0-.5-.4-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cFJ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 9H2c-.55 0-1 .45-1 1s.45 1 1 1h1.59L.3 14.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L5 12.41V14c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1zm8 .5c-.56 0-1.06.23-1.42.59l-2.13-1.24L8.99 8l3.59-2.09A2.002 2.002 0 0016 4.5c0-1.1-.9-2-2-2s-2 .9-2 2c0 .19.03.37.08.54L8.5 7.13v-3.2c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S6 .9 6 2c0 .93.64 1.71 1.5 1.93v3.2l-.88-.52-2.7-1.57c.05-.17.08-.35.08-.54 0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.56 0 1.06-.23 1.42-.59l2.13 1.24 3.84 2.24 2.7 1.57c-.06.17-.09.35-.09.54 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1UG1G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 9H2c-.55 0-1 .45-1 1s.45 1 1 1h1.59L.3 14.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L5 12.41V14c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1zm9.55-5.83l-4.49-3A.975.975 0 009.99.15L5.53 2.82 1.56.17A1.003 1.003 0 000 1v6h2V2.87l2.94 1.96.06.03V7h1V4.86s.01 0 .01-.01L10 2.47v8.67s-.01 0-.01.01l-.99.58v2.33l1.47-.88 3.97 2.65A1.003 1.003 0 0016 15V4c0-.35-.18-.65-.45-.83zM14 13.13l-2.94-1.96c-.02-.01-.04-.02-.05-.03v-8.6l3 2v8.59z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5teTy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 15H1v-2h14zM13 13H3l1.707-1.707A1 1 0 015.414 11h5.172a1 1 0 01.707.293L13 13z",
    "M5.199 6.154c-.33.44-.24 1.07.2 1.4.44.329 1.07.239 1.4-.2.32-.43 1.96-.53 2.43.04.35.419.98.479 1.409.13.42-.35.48-.98.13-1.41-1.33-1.59-4.5-1.39-5.57.04z",
    "M2.303 4.278c-.4.39-.4 1.02-.02 1.409.38.39 1.02.41 1.42.03 2.339-2.289 6.258-2.289 8.598 0 .39.39 1.03.38 1.41-.02.38-.4.38-1.03-.02-1.41-3.11-3.048-8.269-3.048-11.389-.01z",
    "M8 8a1 1 0 100 2 1 1 0 100-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Nmgm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.68 7.9c.44.54 1.07.92 1.79 1.05l-2.76 2.76c-.18.18-.43.29-.71.29s-.53-.11-.71-.3L5 8.41l-3 3V13h13c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v4.59l2.29-2.3C4.47 6.11 4.72 6 5 6s.53.11.71.29L9 9.59l1.68-1.69zM15 3c.55 0 1 .45 1 1s-.45 1-1 1h-1v1c0 .55-.45 1-1 1s-1-.45-1-1V5h-1c-.55 0-1-.45-1-1s.45-1 1-1h1V2c0-.55.45-1 1-1s1 .45 1 1v1h1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aOmB7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.94 9.64c.65.23 1.34.36 2.06.36.14 0 .29-.01.43-.01L9.7 12.71c-.18.18-.43.29-.71.29-.28 0-.53-.11-.71-.3L5 9.41l-3 3V14h12.99c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v4.59l2.29-2.3C4.47 7.11 4.72 7 5 7c.28 0 .53.11.71.29L9 10.59l.94-.95zm4.73-6.44h.92c.22 0 .4.18.4.4v.8c0 .22-.18.4-.4.4h-.93c-.06.2-.14.38-.24.55l.66.65c.15.15.15.4 0 .55l-.54.55c-.15.15-.4.15-.55 0l-.65-.65c-.17.1-.36.18-.55.24v.91c0 .22-.18.4-.4.4h-.8c-.22 0-.4-.18-.4-.4v-.93c-.18-.06-.36-.13-.52-.22l-.68.68c-.15.16-.41.16-.57 0l-.56-.56a.417.417 0 010-.57l.68-.68c-.08-.16-.16-.33-.22-.52h-.93c-.22 0-.4-.18-.4-.4v-.8c0-.22.18-.4.4-.4h.93c.06-.2.14-.38.24-.55l-.65-.64a.392.392 0 010-.55l.54-.55a.38.38 0 01.54 0l.65.65c.18-.1.36-.18.55-.24V.4c0-.22.18-.4.4-.4h.8c.22 0 .4.18.4.4v.93c.18.06.35.14.52.22l.68-.68c.15-.16.41-.16.57 0l.57.57c.15.16.15.41 0 .57l-.68.68c.09.16.16.33.22.51zm-4.18.8c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5c-.82 0-1.5.67-1.5 1.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"96vOL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.66 7.92c.44.54 1.07.91 1.8 1.03L9.71 11.7c-.18.19-.43.3-.71.3s-.53-.11-.71-.3L5 8.41l-3 3V13h13c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v4.59l2.29-2.3C4.47 6.11 4.72 6 5 6s.53.11.71.29L9 9.59l1.66-1.67zM12.3 5.3l.3-.3H8c-.6 0-1-.4-1-1s.4-1 1-1h4.6l-.3-.3c-.2-.2-.3-.4-.3-.7 0-.6.5-1 1-1 .3 0 .5.1.7.3l2 2c.2.2.3.4.3.7s-.1.5-.3.7l-2 2c-.2.2-.4.3-.7.3-.6 0-1-.4-1-1 0-.3.1-.5.3-.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RK1F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.29 9.3c.3.62.8 1.12 1.42 1.41l-1 1c-.18.18-.43.29-.71.29s-.53-.11-.71-.3L5 8.41l-3 3V13h13c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v4.59l2.29-2.3C4.47 6.11 4.72 6 5 6s.53.11.71.29L9 9.59l.29-.29zM15.48 1c.31 0 .52.26.52.57 0 .16-.06.3-.17.41l-2.86 2.73v2.63c0 .16-.06.3-.17.41l-.82 1.1c-.1.1-.25.17-.41.17-.31 0-.57-.26-.57-.57V4.71L8.17 1.98A.566.566 0 018 1.57c0-.31.26-.57.57-.57h6.91z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h9bKm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.6 8.94a4.937 4.937 0 001.82.01c.1-.01.22-.04.39-.08l.23-.07c.04-.01.08-.02.11-.04l.22.22-2.7 2.72c-.18.19-.43.3-.71.3s-.53-.11-.71-.3L4.98 8.41l-2.99 3V13h12.94c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V3.99c0-.55.45-1 1-1s1 .45 1 1v4.59l2.28-2.3c.17-.18.42-.29.7-.29s.53.11.7.29l3.28 3.3.64-.64zm6.22-.41c.1.12.17.27.18.44 0 .34-.27.61-.61.61a.57.57 0 01-.43-.18l-2.24-2.25c-.13.08-.26.16-.4.23-.02.01-.05.02-.07.03-.14.06-.27.12-.42.17h-.01c-.14.05-.29.08-.44.11-.04.01-.08.02-.11.02-.15.02-.3.04-.46.04-1.85 0-3.35-1.51-3.35-3.37S8.96 1.01 10.81 1c1.85 0 3.35 1.51 3.35 3.37 0 .16-.02.31-.04.47-.01.04-.01.07-.02.11-.02.15-.05.29-.1.44v.01c-.05.15-.11.28-.17.42-.01.02-.02.05-.03.07-.07.14-.14.27-.23.4l2.25 2.24zm-5.01-1.94c1.22 0 2.21-.99 2.21-2.22 0-1.23-.99-2.22-2.21-2.22S8.6 3.14 8.6 4.37c0 1.22.99 2.22 2.21 2.22z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2a7AI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 0a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V1a1 1 0 011-1h6zm-1 2.667C10 2.3 9.7 2 9.333 2h-.666C8.3 2 8 2.3 8 2.667v.666C8 3.7 8.3 4 8.667 4h.666C9.7 4 10 3.7 10 3.333v-.666zm0 3.666v-.666C10 5.3 9.7 5 9.333 5h-.666C8.3 5 8 5.3 8 5.667v.666C8 6.7 8.3 7 8.667 7h.666C9.7 7 10 6.7 10 6.333zm0 2.334C10 8.3 9.7 8 9.333 8h-.666C8.3 8 8 8.3 8 8.667v.666c0 .367.3.667.667.667h.666C9.7 10 10 9.7 10 9.333v-.666z",
    "M.446 10.358L3 8.66V11a2 2 0 002 2h6a2 2 0 002-2V8.66l2.554 1.698a.999.999 0 01.189 1.502l-3.436 3.809c-.19.21-.46.331-.745.331H4.438c-.284 0-.555-.12-.745-.331l-3.436-3.81a.999.999 0 01.19-1.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGm3G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.29 4.296a1.002 1.002 0 011.42 1.419l-3 2.996a1.015 1.015 0 01-1.42 0l-3-2.997a1.002 1.002 0 011.42-1.419L11 5.586V1a1 1 0 012 0v4.584l1.29-1.288z",
    "M7.583 6.422l3.01 3.006.01.01c.359.34.85.563 1.397.563V11a1 1 0 01-1 1H5a1 1 0 01-1-1V1a1 1 0 011-1h5.268A1.99 1.99 0 0010 1v2.27a2.002 2.002 0 00-2.417 3.152z",
    "M13 9.736c.152-.087.293-.193.417-.317l.29-.29 1.847 1.23a.999.999 0 01.189 1.5l-3.436 3.81c-.19.21-.46.331-.745.331H4.438c-.284 0-.555-.12-.745-.331l-3.436-3.81a.999.999 0 01.19-1.5L3 8.659V11a2 2 0 002 2h6a2 2 0 002-2V9.736z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cZbtc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 1c0-.55-.45-1-1-1S1 .45 1 1v3h2V1zm0 4H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm12-4c0-.55-.45-1-1-1s-1 .45-1 1v2h2V1zM9 1c0-.55-.45-1-1-1S7 .45 7 1v6h2V1zM1 15c0 .55.45 1 1 1s1-.45 1-1v-5H1v5zM15 4h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-2 11c0 .55.45 1 1 1s1-.45 1-1V9h-2v6zM9 8H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-2 7c0 .55.45 1 1 1s1-.45 1-1v-2H7v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dWKHt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.92 8.139c.44-.282 1.006-.121 1.264.358l2.689 4.988c.083.155.127.33.127.51C10 14.55 9.587 15 9.077 15H3.924a.864.864 0 01-.438-.12c-.449-.263-.617-.873-.376-1.362l2.465-4.989c.08-.162.2-.297.346-.39zM12 4a3 3 0 110 6 3 3 0 010-6zM6 1a1 1 0 011 1v4a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcj5J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.99 13.99h-9v-9h4.76l2-2H.99c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h11c.55 0 1-.45 1-1V7.24l-2 2v4.75zm4-14h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L7.29 7.28a1 1 0 00-.3.71 1.003 1.003 0 001.71.71l5.29-5.29V6c0 .55.45 1 1 1s1-.45 1-1V1c0-.56-.45-1.01-1-1.01z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzTN5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.843 15.163c.232.53.138.837.138.837H6.017s-.088-.308.138-.837c.226-.53 1.338-.88 2.079-1.206.735-.332.66-.53.685-.8 0-.03.006-.068.006-.105a2.171 2.171 0 01-.61-.892v-.006s-.006-.006-.006-.012c-.025-.074-.056-.16-.075-.24-.176-.031-.276-.222-.314-.394a.8.8 0 01-.1-.437c.025-.253.131-.37.244-.419v-.037c0-.313.032-.775.088-1.07A1.835 1.835 0 018.85 8.37c.315-.24.76-.37 1.156-.37.396 0 .842.13 1.156.37.301.233.534.56.64.935.026.08.045.166.057.246.057.295.088.75.088 1.064v.043c.113.05.214.167.232.413a.75.75 0 01-.1.437c-.038.172-.132.357-.301.387a1.77 1.77 0 01-.076.24.136.136 0 01-.006.025 2.346 2.346 0 01-.597.892v.111c.025.277-.075.474.666.8.741.326 1.853.67 2.079 1.2z",
    "M14.852 15h1.131s.083-.27-.12-.732c-.16-.373-.82-.641-1.411-.88a15.328 15.328 0 01-.409-.17c-.565-.25-.57-.412-.577-.61-.001-.03-.002-.06-.005-.09v-.097c.22-.2.401-.469.522-.781 0 0 .005-.016.005-.022.028-.07.05-.14.066-.21.149-.026.231-.188.264-.339a.655.655 0 00.088-.382c-.016-.215-.104-.318-.203-.36v-.039c0-.274-.028-.673-.077-.931a1.598 1.598 0 00-.61-1.034 1.736 1.736 0 00-1.285-.3c.236.285.42.622.529.996.038.124.065.248.083.36.048.257.079.578.093.867a1.736 1.736 0 01.08 1.624 1.65 1.65 0 01-.217.453 1.42 1.42 0 01-.176.209c-.08.204-.178.4-.292.585l.202.083c.285.117.64.261.9.387.226.11.475.245.698.414.213.161.476.408.63.764.034.08.065.159.091.235zM12.14 14.12l.09.037zM11 1c.55 0 1 .45 1 1 0 .28-.11.53-.29.7L8 6.41v1.374a2.813 2.813 0 00-.833 1.589 6.925 6.925 0 00-.092.86 1.64 1.64 0 00-.25.739l-.001.004c-.02.217.006.413.046.573L5.71 12.71A1.003 1.003 0 014 12V6.41L.29 2.71A1.003 1.003 0 011 1h10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"esx8N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 16c4.667-3.048 7-7.238 7-12.571-1.556 0-3.889-1.143-7-3.429-3.111 2.286-5.444 3.429-7 3.429C1 8.762 3.333 12.952 8 16zM8 2.121c2.005 1.388 3.715 2.304 5.186 2.735-.342 3.702-2.05 6.683-5.186 9.038V2.121z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ldx6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.44.804L5.2 2H3a1 1 0 00-1 1v3.714l-1.08.309a.988.988 0 00-.69 1.192c.366 1.432.897 3.324 1.309 4.26a.644.644 0 00.005.01c-.175.01-.356.015-.544.015a.5.5 0 000 1c2.067 0 3.414-.543 4.161-.917.55.373 1.505.917 2.839.917 1.32 0 2.27-.533 2.822-.905l.004.002c.196.105.48.24.856.374.75.268 1.857.529 3.318.529a.5.5 0 000-1c-.295 0-.572-.012-.834-.032a.995.995 0 00.308-.458l1.208-3.74a1 1 0 00-.677-1.269L14 6.714V3a1 1 0 00-1-1h-2.2L10.56.804A1 1 0 009.58 0H6.42a1 1 0 00-.98.804zM4 6.143l3-.857V4H4v2.143zm5-.857l3 .857V4H9v1.286zm-4.036 8.273a.5.5 0 01.527.034c.455.325 1.277.907 2.509.907s2.054-.582 2.51-.907a.5.5 0 01.579-.001l.006.004.036.023c.034.022.09.055.168.097.154.082.394.197.72.313.649.232 1.642.471 2.981.471a.5.5 0 010 1c-1.46 0-2.568-.261-3.318-.53a6.316 6.316 0 01-.856-.373l-.004-.002c-.552.372-1.502.905-2.822.905-1.334 0-2.289-.544-2.839-.917-.747.374-2.094.917-4.161.917a.5.5 0 010-1c2.129 0 3.384-.63 3.964-.94z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Aiubq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 2h10c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1zm9 11H4v-3H2v5c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-5h-2v3zm4-6l-1.01-3.17C14.9 3.36 14.49 3 14 3H2c-.49 0-.9.36-.98.83L.01 7H0c0 1.1.9 2 2 2s2-.9 2-2c0 1.1.9 2 2 2s2-.9 2-2c0 1.1.9 2 2 2s2-.9 2-2c0 1.1.9 2 2 2s2-.9 2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hOn17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 10H7.72l-.33-1H13c.39 0 .72-.23.89-.56h.01l2-4h-.01c.06-.13.11-.28.11-.44 0-.55-.45-1-1-1H5.39l-.44-1.32h-.01C4.8 1.29 4.44 1 4 1H1c-.55 0-1 .45-1 1s.45 1 1 1h2.28l2.33 7H4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2h6c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2zM6.05 5h7.33l-1 2H6.72l-.67-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1AB9m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 6h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm4 3H1c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zm7 3c0-.28-.11-.53-.29-.71l-.3-.29H15c.55 0 1-.45 1-1s-.45-1-1-1h-3.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2 2A1.003 1.003 0 0012 12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jHxro":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.474 7.971A5.31 5.31 0 006.66 8.9l.007.019.018.056c.015.038.038.06.045.098l1.5 5.999a.75.75 0 01-1.455.36l-.42-1.68h-.704l-.42 1.68a.746.746 0 01-.907.547.746.746 0 01-.547-.907l1.5-6c.007-.037.03-.06.044-.097.015-.037.015-.075.038-.112a.722.722 0 01-.105-.36c0-.207.084-.394.22-.53zM2.795 5.277a.763.763 0 00-.015-1.065.756.756 0 00-1.065.015c-2.286 2.34-2.286 6.21 0 8.549a.747.747 0 101.072-1.042c-1.709-1.763-1.709-4.702.008-6.457zM7.808 9.388a5.318 5.318 0 001.58.211 2.236 2.236 0 01-.656.98.756.756 0 01-1.057-.098.756.756 0 01.097-1.057l.036-.036zM11.544 9.105l.378.378a6.02 6.02 0 01-1.638 3.285c-.285.3-.757.3-1.057.015a.74.74 0 01-.015-1.057 4.52 4.52 0 001.185-2.24c.4-.083.785-.212 1.147-.381z",
    "M4.054 9.424c-.427-.352-.352-1.582-.03-1.822a.752.752 0 00.15-1.05.752.752 0 00-1.05-.15c-1.079.802-1.221 3.18-.03 4.177a.75.75 0 10.96-1.155zM9.318 0a4.318 4.318 0 014.317 4.318c0 .206-.02.402-.049.598-.01.05-.01.088-.02.138-.039.196-.078.382-.137.569v.01c-.059.186-.137.363-.216.54l-.039.087a5.285 5.285 0 01-.294.51l2.884 2.886a.878.878 0 01.236.559.787.787 0 01-.785.785.785.785 0 01-.56-.226L11.772 7.89a5.285 5.285 0 01-.51.295l-.089.039c-.176.079-.353.157-.54.216h-.01a3.701 3.701 0 01-.568.137c-.05.01-.099.02-.138.02-.196.03-.392.049-.598.049A4.318 4.318 0 015 4.327 4.332 4.332 0 019.318 0zm-.02 1.1A3.195 3.195 0 006.1 4.298a3.195 3.195 0 003.198 3.198 3.195 3.195 0 003.198-3.198A3.195 3.195 0 009.298 1.1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HfKc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.71 4.29l-4-4A.997.997 0 009 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5c0-.28-.11-.53-.29-.71zM7 6h2v2H7V6zM4 6h2v2H4V6zm2 8H4v-2h2v2zm3 0H7v-2h2v2zm3 0h-2v-2h2v2zm0-3H4V9h8v2zm0-3h-2V6h2v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3RDrF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 2a.99.99 0 00-.96.73l-2.99 9.96A1.003 1.003 0 007 14c.46 0 .85-.31.96-.73l2.99-9.96A1.003 1.003 0 0010 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cyN2G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.41 8l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L8 6.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42L6.59 8 4.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L8 9.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L9.41 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"693F6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 8A6 6 0 112 8a6 6 0 0112 0zM9 4v2H7V4h2zm0 3v4h1v1H6v-1h1V8H6V7h3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f4QCp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 7H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"64fRg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 7H9V5c0-.55-.45-1-1-1s-1 .45-1 1v2H5c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V9h2c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XaHv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 5v6h6V5H5zM4 3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V4a1 1 0 00-1-1H4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4glgh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eSfNc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.364 9l.879.879a1 1 0 11-1.415 1.414l-2.12-2.121A1.003 1.003 0 0110.568 9H9v1.604c.042.03.083.065.121.103l2.122 2.121a1 1 0 01-1.415 1.415L9 13.414V15a1 1 0 01-2 0v-1.636l-.879.879a1 1 0 11-1.414-1.415l2.121-2.12c.054-.054.111-.1.172-.139V9H5.38c-.038.06-.084.118-.137.172l-2.122 2.12A1 1 0 111.707 9.88L2.586 9H1a1 1 0 110-2h1.536l-.829-.828a1 1 0 011.414-1.415L5.243 6.88c.038.038.072.079.103.121H7V5.38a1.003 1.003 0 01-.172-.137L4.708 3.12A1 1 0 016.12 1.707L7 2.586V1a1 1 0 112 0v1.536l.828-.829a1 1 0 011.415 1.414L9.12 5.243A1.007 1.007 0 019 5.346V7h1.604c.03-.042.065-.083.103-.121l2.121-2.122a1 1 0 011.415 1.415L13.414 7H15a1 1 0 010 2h-1.636z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGWFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 7.5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zM7.5 13c.694 0 1.357-.128 1.969-.363l.342-1.053-1.132-1.557H6.34L5.202 11.59l.341 1.052A5.487 5.487 0 007.5 13zm5.499-5.39a5.476 5.476 0 01-1.253 3.386H10.62L9.466 9.408l-.002.001.687-2.113 1.67-.542 1.178.856zm-9.74 3.392h1.135L5.54 9.424 4.854 7.31l-1.711-.556-1.142.83a5.477 5.477 0 001.258 3.418zM8 4.963l1.883 1.369 1.628-.53.48-1.477a5.51 5.51 0 00-2.89-2.088L8 3.037v1.926zM5.899 2.237l1.101.8v1.926L5.105 6.34l-1.653-.537-.469-1.442A5.511 5.511 0 015.9 2.237z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hQXkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.5 4c.4 0 .8-.1 1.1-.3C12 4.5 12.9 6 13 7.6c0 .5.5.9 1 .9.6 0 1-.4 1-1v-.2c-.2-2.4-1.5-4.4-3.5-5.5-.1-1-.9-1.8-2-1.8s-2 .9-2 2 .9 2 2 2zM4 8.5c0-.7-.4-1.3-.9-1.7.3-1.4 1.2-2.6 2.5-3.3.3-.1.6-.4.6-.9s-.4-1-1-1c-.2 0-.3 0-.5.1-1.9 1-3.2 2.8-3.6 5C.4 7.1 0 7.8 0 8.5c0 1.1.9 2 2 2s2-.9 2-2zm8.8 1.2c-1.1 0-2 .9-2 2v.3c-.8.6-1.8.9-2.8.9-1.2 0-2.3-.4-3.2-1.1-.2-.2-.4-.3-.7-.3-.6 0-1 .4-1 1 0 .3.1.6.3.8C4.6 14.4 6.2 15 8 15c1.5 0 3-.5 4.1-1.3.2.1.5.1.7.1 1.1 0 2-.9 2-2s-.9-2.1-2-2.1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dt4Kg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 12c-.28 0-.53.11-.71.29l-.29.3V9c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29A.965.965 0 001 12a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 005 12zm3-9h7c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm7 2H8c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1zm0 8H8c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H8c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"83QEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 12c-.28 0-.53.11-.71.29l-.29.3V9c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29A.965.965 0 002 12a1.003 1.003 0 00-.71 1.71l2 2c.19.18.44.29.71.29.28 0 .53-.11.71-.29l2-2c.18-.18.29-.43.29-.71a.99.99 0 00-1-1zm7.93-.95v-1.04H9.25v1.11h2.94L9 14.96V16h5.02v-1.11h-3.27l3.18-3.84zm-1.42-4.84l.62 1.78H15L11.94.01H10.1L7 7.99h1.81l.64-1.78h3.06zm-1.52-4.24h.02l1.03 2.93H9.92l1.07-2.93z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lU9xU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.99 11.99c-.28 0-.53.11-.71.29l-.29.29V8.99c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29a1.003 1.003 0 00-1.42 1.42l2 2c.18.18.43.29.71.29.28 0 .53-.11.71-.29l2-2c.18-.18.29-.43.29-.71 0-.56-.45-1.01-1-1.01zM12.7 10h-1.38L9 15.99h1.36l.48-1.33h2.3l.46 1.33H15L12.7 10zm-1.51 3.67l.8-2.2h.02l.77 2.2h-1.59zm3.8-7.17h-4.57l4.45-5.12V0H8.34v1.48h4.1L7.99 6.59v1.39h7V6.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"LUDum":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 7h3c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0-4h1c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0 8h5c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm-3 1c-.28 0-.53.11-.71.29l-.29.3V9c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29A.965.965 0 001 12a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 005 12zm10 1H8c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dlJk7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 12c-.28 0-.53.11-.71.29l-.29.3V9c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29A.965.965 0 001 12a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 005 12zm4 1H8c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1zm4-8H8c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm-2 4H8c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zm4-8H8c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jg1J1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 11.99c-.28 0-.53.11-.71.29l-.29.3V8.99c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29c-.18-.18-.43-.3-.71-.3a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29.28 0 .53-.11.71-.29l2-2A1.003 1.003 0 006 11.99zm7.91-.08c-.06-.36-.17-.68-.33-.96-.16-.28-.37-.51-.64-.69-.27-.17-.61-.26-1.03-.26-.28 0-.54.06-.78.17-.23.11-.43.26-.6.45-.17.19-.3.41-.39.67a2.492 2.492 0 00-.04 1.52 1.623 1.623 0 00.89 1.03c.22.11.45.16.68.16.26 0 .5-.05.7-.15s.38-.26.53-.5l.02.02c-.01.16-.03.34-.07.54-.03.2-.09.4-.17.57-.08.18-.18.33-.31.45s-.29.19-.5.19a.63.63 0 01-.48-.21c-.13-.14-.21-.31-.25-.5H10.1c.03.25.1.48.19.68.1.2.22.37.38.5.16.14.33.24.54.31s.42.1.65.1c.39 0 .72-.09.99-.27.27-.18.49-.41.66-.7.17-.29.29-.61.37-.97.08-.36.12-.72.12-1.07 0-.36-.03-.72-.09-1.08zm-1.14.54c-.04.13-.09.24-.16.34a.78.78 0 01-.27.24c-.11.06-.24.09-.39.09a.75.75 0 01-.37-.09.777.777 0 01-.26-.25c-.07-.1-.12-.22-.15-.35-.03-.13-.05-.26-.05-.4 0-.13.02-.26.05-.39.04-.13.09-.24.16-.34.07-.1.16-.18.26-.24s.22-.09.35-.09c.14 0 .26.03.37.09.11.06.2.14.28.24a1.32 1.32 0 01.23.74c0 .15-.02.28-.05.41zm-1.56-4.47H13V0h-1.42c-.05.3-.16.56-.31.76-.16.21-.35.37-.58.5-.23.13-.49.21-.78.26-.3.05-.6.07-.91.06V2.8h2.21v5.18z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iLHAR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 11.99c-.28 0-.53.11-.71.29l-.29.3V8.99c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29a.982.982 0 00-.71-.3 1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 006 11.99zm7.86-9.45c-.09-.48-.26-.9-.5-1.28S12.8.58 12.4.35C12 .12 11.49 0 10.86 0c-.43 0-.82.07-1.17.22s-.65.35-.9.6-.44.55-.58.89c-.14.34-.2.71-.2 1.11 0 .31.05.61.15.91.1.3.26.57.48.8.23.24.52.43.85.58.33.14.68.21 1.03.21.4 0 .75-.07 1.05-.2.3-.13.57-.35.79-.66l.02.02c-.02.21-.05.45-.1.73-.05.27-.13.53-.25.76-.12.24-.27.44-.47.6-.19.16-.44.25-.75.25a.98.98 0 01-.72-.29c-.19-.18-.31-.4-.37-.66H8.15c.05.34.14.64.29.9.15.26.34.49.57.67.23.18.5.32.8.41.31.1.63.15.98.15.58 0 1.08-.12 1.48-.36.4-.24.73-.55.99-.93.26-.39.44-.82.56-1.29.12-.48.18-.96.18-1.44s-.05-.96-.14-1.44zm-1.71.72c-.05.17-.14.32-.24.46-.11.13-.24.24-.41.31-.16.08-.36.12-.58.12-.21 0-.39-.04-.55-.13-.16-.08-.29-.19-.39-.33-.12-.14-.19-.29-.24-.46-.05-.17-.08-.35-.08-.54 0-.18.03-.35.08-.52.06-.16.14-.31.25-.44.11-.13.24-.24.4-.32.16-.08.33-.12.52-.12.21 0 .4.04.56.12.16.08.3.19.41.32.11.14.2.29.26.46.06.17.09.35.09.52 0 .2-.03.38-.08.55zm-.46 7.31c-.12.15-.26.28-.44.37-.17.09-.37.16-.58.2-.22.04-.44.05-.67.05v.92h1.65v3.88h1.33V10h-1.06c-.03.23-.11.42-.23.57z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j35Jk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.89.56l4 8c.06.13.11.28.11.44 0 .55-.45 1-1 1-.39 0-.72-.23-.89-.55H9.1L8.38 8H3.62L2.9 9.44h-.01c-.17.33-.5.56-.89.56-.55 0-1-.45-1-1 0-.16.05-.31.12-.44L3.1 4.58 4 2.76 5.11.56C5.28.23 5.61 0 6 0s.72.23.89.56zM14 9c-.28 0-.53.11-.71.29L9 13.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29.28 0 .53-.11.71-.29l5-5A1.003 1.003 0 0014 9zM6 3.24L4.62 6h2.76L6 3.24z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4W1Vb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 10a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H9V2h3v1.71c.31-.13.64-.21 1-.21s.69.08 1 .21V1c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v2.71c.31-.13.64-.21 1-.21s.69.08 1 .21V2h3v5H3.41l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L3.41 9H7v5H4v-1.71c-.31.13-.64.21-1 .21s-.69-.08-1-.21V15c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-2.71c-.31.13-.64.21-1 .21s-.69-.08-1-.21V14H9V9h3.59l-.29.29c-.19.18-.3.43-.3.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4eQpW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 .5a.5.5 0 01.816-.387C7.154-.111 7.652.04 8.182.2 8.811.39 9.486.596 10 .21V2.83c-.51.315-1.085.128-1.618-.046-.538-.176-1.035-.338-1.382.046v1.193C7.328 4.008 7.661 4 8 4c1.06 0 2.074.077 3 .218V.5a.5.5 0 01.816-.387c.338-.224.836-.073 1.366.088.629.19 1.304.395 1.818.01V2.83c-.51.315-1.085.128-1.618-.046-.538-.176-1.035-.338-1.382.046V4.4c2.391.52 4 1.489 4 2.599 0 .552-.398 1.07-1.091 1.514C14.366 7.088 11.479 6 8 6 4.52 6 1.634 7.088 1.091 8.514.398 8.069 0 7.552 0 7c0-.528.364-1.024 1.002-1.455A.507.507 0 011 5.5v-5a.5.5 0 01.816-.387C2.154-.111 2.652.04 3.182.2 3.811.39 4.486.596 5 .21V2.83c-.51.315-1.085.128-1.618-.046-.538-.176-1.035-.338-1.382.046v2.186c1.042-.443 2.428-.77 4-.921V.5z",
    "M14 8.985c-.005-.081-.046-.232-.262-.45-.234-.238-.623-.497-1.182-.737C11.44 7.32 9.83 7 8 7c-1.83 0-3.44.32-4.556.798-.56.24-.948.5-1.182.737-.216.218-.257.369-.262.45C3.466 9.607 5.61 10 8 10s4.534-.393 6-1.015z",
    "M14.008 10.058C12.422 10.653 10.298 11 8 11c-2.297 0-4.422-.348-6.008-.942C1.22 9.768.525 9.439 0 8.985V13c0 1.398 2.55 2.667 6 3v-1a2 2 0 114 0v1c3.45-.333 6-1.602 6-3V8.985c-.525.454-1.22.783-1.992 1.073z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1D44N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2V2h12v12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fgyNq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 2c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v3h3V2zm3 10h1c.55 0 1-.45 1-1V8h-3v3c0 .55.45 1 1 1zm2-7c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v2h3V5zm-5 1H7v3h3V6zM5 7c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v1h3V7zm3 5h1c.55 0 1-.45 1-1v-1H7v1c0 .55.45 1 1 1zm7 1H2c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1s-.45-1-1-1zM3 12h1c.55 0 1-.45 1-1V9H2v2c0 .55.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cFlzI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 6H4a2 2 0 100 4h8a2 2 0 100-4zM4 4a4 4 0 100 8h8a4 4 0 000-8H4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hHbJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0l2.5 5.3 5.5.8-4 4.1.9 5.8L8 13.3 3.1 16l.9-5.8-4-4.1 5.5-.8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1xDCj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 6.11l-5.53-.84L8 0 5.53 5.27 0 6.11l4 4.1L3.06 16 8 13.27 12.94 16 12 10.21l4-4.1zM4.91 13.2l.59-3.62L3 7.02l3.45-.53L8 3.2l1.55 3.29 3.45.53-2.5 2.56.59 3.62L8 11.49 4.91 13.2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jflGV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 3c-.24 0-.44.09-.62.23l-.01-.01L7 6.72V4c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V9.28l4.38 3.5.01-.01c.17.14.37.23.61.23.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"alVMC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 12H2v-2h3c.55 0 1-.45 1-1V7h2v1c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1v3h-2V6c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v2H2V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7E09J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 3h-1c-.55 0-1 .45-1 1v2.72l-4.38-3.5v.01A.987.987 0 005 3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1 .24 0 .44-.09.62-.23l.01.01L10 9.28V12c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a7Yp5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 3H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iuXuS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 2v1.083A6.002 6.002 0 018 15 6 6 0 017 3.083V2H6a1 1 0 110-2h4a1 1 0 010 2H9zM8 5a4 4 0 104 4H8V5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"61dFc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 7H8.65c-.38-.09-.73-.18-1.04-.26-.31-.08-.49-.13-.54-.14-.43-.11-.79-.29-1.05-.52-.27-.23-.4-.55-.4-.95 0-.29.07-.53.21-.72s.32-.34.54-.46c.22-.11.46-.19.72-.24.26-.05.52-.07.77-.07.74 0 1.36.15 1.84.46.32.2.55.5.68.9h2.22c-.06-.33-.17-.64-.32-.92-.25-.45-.59-.84-1.02-1.15-.43-.31-.93-.54-1.49-.7S8.59 2 7.95 2c-.55 0-1.1.07-1.63.2-.54.13-1.02.34-1.45.62-.42.28-.76.63-1.02 1.05-.26.42-.39.92-.39 1.5 0 .3.04.59.13.88.08.26.21.51.39.75H2c-.55 0-1 .45-1 1s.45 1 1 1h7.13c.25.07.49.14.71.22.25.09.48.23.7.44.21.21.32.53.32.97 0 .21-.05.43-.14.63-.09.21-.24.39-.45.55-.21.16-.48.29-.81.39-.33.1-.73.15-1.2.15-.44 0-.84-.05-1.21-.14-.37-.09-.7-.24-.99-.43-.29-.2-.51-.45-.67-.76-.01 0-.01-.01-.02-.02H3.14a3.68 3.68 0 001.39 2.03c.46.34 1 .58 1.62.74.61.15 1.27.23 1.97.23.61 0 1.2-.07 1.79-.2.58-.13 1.11-.34 1.56-.63.46-.29.83-.66 1.11-1.11.28-.45.42-1 .42-1.64 0-.3-.05-.6-.15-.9-.05-.19-.13-.36-.22-.52H14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j7u5v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 14H2V2h8.76l2-2H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V6.24l-2 2V14zm1.4-14L9.7 5.7l2.1 2.1L16 3.6V0h-.6zM4 11.92c2.33.15 4.42.15 6.15-1.5.82-.83.82-2.25 0-3.08-.45-.38-.98-.6-1.5-.6-.53 0-1.05.22-1.43.6-.82.91-1.27 3.38-3.22 4.58z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4cqWr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.2 4.4a1 1 0 011.6 1.2L5.25 9l2.55 3.4a1 1 0 01-1.6 1.2L4 10.667 1.8 13.6a1 1 0 01-1.6-1.2L2.75 9 .2 5.6a1 1 0 011.6-1.2L4 7.333 6.2 4.4zm6.954 9.544l.016-.014c.18-.14.36-.28.57-.42l.63-.45c.21-.16.41-.33.61-.51s.37-.38.52-.59c.15-.21.28-.45.37-.7.09-.25.13-.54.13-.85 0-.25-.04-.51-.12-.79-.07-.29-.2-.55-.39-.79a2.18 2.18 0 00-.73-.6c-.29-.15-.66-.23-1.11-.23-.4 0-.76.08-1.07.23-.31.16-.58.37-.79.62-.22.27-.38.59-.49.96-.11.37-.16.77-.16 1.2h1.19c.01-.27.03-.53.08-.77.04-.24.11-.45.21-.62.09-.18.22-.32.38-.42.16-.1.35-.15.59-.15.26 0 .47.05.63.14.15.09.28.21.37.35.09.14.15.29.18.45.03.16.05.31.05.45-.01.31-.08.58-.22.82-.14.23-.32.45-.53.65-.22.21-.46.39-.71.57-.26.18-.51.36-.75.54-.5.36-.89.78-1.17 1.27-.28.49-.43 1.06-.44 1.71h4.99v-1.14h-3.55c.05-.17.14-.33.27-.49.126-.145.28-.281.444-.426z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9eVs4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.154 5.944l.016-.014c.18-.14.36-.28.57-.42l.63-.45c.21-.16.41-.33.61-.51s.37-.38.52-.59c.15-.21.28-.45.37-.7.09-.25.13-.54.13-.85 0-.25-.04-.51-.12-.79-.07-.29-.2-.55-.39-.79a2.18 2.18 0 00-.73-.6C14.47.08 14.1 0 13.65 0c-.4 0-.76.08-1.07.23-.31.16-.58.37-.79.62-.22.27-.38.59-.49.96-.11.37-.16.77-.16 1.2h1.19c.01-.27.03-.53.08-.77.04-.24.11-.45.21-.62.09-.18.22-.32.38-.42.16-.1.35-.15.59-.15.26 0 .47.05.63.14.15.09.28.21.37.35.09.14.15.29.18.45.03.16.05.31.05.45-.01.31-.08.58-.22.82-.14.23-.32.45-.53.65-.22.21-.46.39-.71.57-.26.18-.51.36-.75.54-.5.36-.89.78-1.17 1.27-.28.49-.43 1.06-.44 1.71h4.99V6.86h-3.55c.05-.17.14-.33.27-.49.126-.145.28-.281.444-.426zM6.2 4.4a1 1 0 011.6 1.2L5.25 9l2.55 3.4a1 1 0 01-1.6 1.2L4 10.667 1.8 13.6a1 1 0 01-1.6-1.2L2.75 9 .2 5.6a1 1 0 011.6-1.2L4 7.333 6.2 4.4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5kRQ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 7.02L.05 7H0v.02zm2-2.03h9.57l-1.29 1.29A1.003 1.003 0 0011.7 7.7l2.99-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2.99-3a1.07 1.07 0 00-.71-.28 1.003 1.003 0 00-.71 1.71L11.57 3H2c-.55 0-1 .45-1 1a1 1 0 001 .99zM15.96 9H16v-.02l-.04.02zM14 11.01H4.43l1.29-1.29A1.003 1.003 0 004.3 8.3l-2.99 3a.99.99 0 00-.29.7c0 .28.11.53.29.71l2.99 3a1.003 1.003 0 001.42-1.42L4.43 13H14c.55 0 1-.45 1-1s-.45-.99-1-.99z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"vJ9fI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 0h-.02L9 .04V0zM7 16h.02L7 15.95V16zM4.7 1.31c-.18-.18-.43-.29-.7-.29s-.53.11-.71.29l-3 2.99a1.003 1.003 0 001.42 1.42L3 4.43V14c0 .55.45 1 1 1s1-.45 1-1V4.43l1.29 1.29c.18.18.43.29.7.29A1.003 1.003 0 007.7 4.3l-3-2.99zM15 9.99c-.28 0-.53.11-.71.29L13 11.57V2c0-.55-.45-1-1-1s-1 .45-1 1v9.57l-1.29-1.29a.99.99 0 00-.7-.29 1.003 1.003 0 00-.71 1.71l3 2.99c.18.18.43.29.71.29.28 0 .53-.11.71-.29l3-2.99c.18-.18.29-.43.29-.71-.01-.55-.46-1-1.01-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bYiBg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.293 2.293l1.414 1.414-4.999 5a3 3 0 11-1.415-1.415l5-5zM13 7a3 3 0 110 6 3 3 0 010-6zM3 9a1 1 0 100 2 1 1 0 000-2zm10 0a1 1 0 100 2 1 1 0 000-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGZ5q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 3.01a5 5 0 100 10 5 5 0 100-10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"koht5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 6.01h-2v-2c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v2H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1v-2c0-.56-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PNwl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 8.01c0-.19-.07-.36-.16-.51l.01-.01-3-5-.01.01c-.17-.29-.48-.49-.84-.49s-.67.2-.84.49l-.02-.01-3 5 .02.01c-.09.15-.16.32-.16.51s.07.36.16.51h-.02l3 5 .01-.01c.18.29.49.5.85.5s.67-.2.84-.49l.01.01 3-5-.01-.01c.09-.16.16-.32.16-.51z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g18NR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 4H3c-.5 0-1 .5-1 1v6c0 .5.5 1 1 1h10c.5 0 1-.5 1-1V5c0-.5-.5-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"yKaXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 3.01H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-8c0-.56-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6U4Oa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 4.01c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 .16.05.31.11.44H3.1l4 8h.01c.16.33.49.56.89.56s.72-.23.89-.56h.01l4-8h-.01c.06-.14.11-.28.11-.44z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h0Ubm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.89 11.56l-3.99-8h-.01c-.17-.32-.5-.55-.89-.55s-.72.23-.89.55H7.1l-4 8h.01c-.06.14-.11.29-.11.45 0 .55.45 1 1 1h8c.55 0 1-.45 1-1 0-.16-.05-.31-.11-.45z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dLxdr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.146.146a.5.5 0 000 .708l.647.646L10.5 2.793 8.854 1.146a.5.5 0 10-.708.708l.647.646-1.146 1.146-5.5 5.5a.5.5 0 000 .708l.646.646-1.647 1.646a.5.5 0 000 .708l.647.646-1.647 1.646a.5.5 0 00.708.708L2.5 14.207l.646.647a.5.5 0 00.708 0L5.5 13.207l.646.647a.5.5 0 00.708 0l5.5-5.5L13.5 7.207l.646.647a.5.5 0 00.708-.708L13.207 5.5 14.5 4.207l.646.647a.5.5 0 00.708-.708l-4-4a.5.5 0 00-.708 0zM11.293 8l-.793.793-1.646-1.647a.5.5 0 10-.708.708L9.793 9.5 8.5 10.793 6.854 9.146a.5.5 0 10-.708.708L7.793 11.5 6.5 12.793 3.207 9.5 8 4.707 11.293 8zM8.707 4L12 7.293l.793-.793L9.5 3.207 8.707 4zm-6.5 8.5L3.5 13.793 4.793 12.5 3.5 11.207 2.207 12.5zm11.586-9L12.5 2.207 11.207 3.5 12.5 4.793 13.793 3.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kLb2g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H1C.4 0 0 .5 0 1v12c0 .6.4 1 1 1h4.126A4.02 4.02 0 015 13a2.002 2.002 0 01-1.731-1H2v-2h1.264c.087-.153.195-.293.319-.417L4.166 9H2V7h12v1.352c.623.705 1 1.632 1 2.648.364 0 .706.098 1 .269V1c0-.5-.4-1-1-1zM6 6H2V4h4v2zm4 0H7V4h3v2zm4 0h-3V4h3v2z",
    "M9.71 10.29l-2-2A.997.997 0 007 8c-.28 0-.53.11-.71.29l-2 2a1.003 1.003 0 001.42 1.42l.29-.3V13c0 1.66 1.34 3 3 3 .55 0 1-.45 1-1s-.45-1-1-1-1-.45-1-1v-1.59l.29.3a1.003 1.003 0 001.42-1.42z",
    "M10.29 13.71l2 2c.18.18.43.29.71.29.28 0 .53-.11.71-.29l2-2a1.003 1.003 0 00-1.42-1.42l-.29.3V11c0-1.66-1.34-3-3-3-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1v1.59l-.29-.3a1.003 1.003 0 00-1.42 1.42z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99MTB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 3a2 2 0 012-2h4.584a2 2 0 011.414.586l5.413 5.412a2 2 0 010 2.829L9.827 14.41a2 2 0 01-2.829 0L1.586 8.998A2 2 0 011 7.584V3zm3.487-.007a1.494 1.494 0 100 2.988 1.494 1.494 0 000-2.988z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f7xsT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 0a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0V5H9a1 1 0 010-2h2V1a1 1 0 011-1z",
    "M7.792 2.406A2 2 0 009 6h1v1a2 2 0 003.594 1.208 2 2 0 01-.183 2.619L8.827 15.41a2 2 0 01-2.829 0L.586 9.998A2 2 0 010 8.584V4a2 2 0 012-2h4.584a2 2 0 011.208.406zm-5.8 3.081a1.494 1.494 0 102.99 0 1.494 1.494 0 00-2.99 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fsMYT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.29.29c.39-.39 1.03-.39 1.42 0l2.98 2.96c.41.41.41 1.07 0 1.48l-2.98 2.961c-.39.39-1.03.39-1.42 0a.996.996 0 010-1.41l2.3-2.29-2.3-2.29a.996.996 0 010-1.411z",
    "M13.61 8.231c.57.78.51 1.89-.2 2.6l-4.58 4.581c-.78.78-2.05.78-2.83 0l-5.41-5.41c-.38-.38-.59-.89-.59-1.42V4c0-1.1.9-2 2-2h4.28c.08.15.18.29.31.42L8.18 4 6.59 5.58a2.007 2.007 0 000 2.84c.38.37.87.58 1.41.58.54 0 1.04-.21 1.42-.58l.71-.71A1.998 1.998 0 0012 9.001c.54 0 1.04-.21 1.42-.58l.19-.19zM3.49 6.991c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5z",
    "M8.71.29l2.98 2.96c.41.41.41 1.07 0 1.48L8.71 7.692c-.39.39-1.03.39-1.42 0a.996.996 0 010-1.41l2.3-2.29-2.3-2.29a.996.996 0 010-1.411c.39-.39 1.03-.39 1.42 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9rQ8R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.29 6.29a1.003 1.003 0 011.42 1.42l-.3.29H13c.55 0 1-.45 1-1s.45-1 1-1 1 .45 1 1c0 1.66-1.34 3-3 3h-1.59l.3.29a1.003 1.003 0 01-1.42 1.42l-2-2A.997.997 0 018 9c0-.28.11-.53.29-.71l2-2zm3.42-.58a1.003 1.003 0 01-1.42-1.42l.3-.29H11c-.55 0-1 .45-1 1s-.45 1-1 1-1-.45-1-1c0-1.66 1.34-3 3-3h1.59l-.3-.29A1.003 1.003 0 0113.71.29l2 2c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2 2z",
    "M7.888 2.484A3.985 3.985 0 007 5c0 .854.539 1.585 1.294 1.871l-.711.712A1.997 1.997 0 007 9c0 .548.217 1.052.583 1.417l2 2a1.997 1.997 0 001.671.567L8.827 15.41a2 2 0 01-2.829 0L.586 9.998A2 2 0 010 8.584V4a2 2 0 012-2h4.584a2 2 0 011.304.484zM1.993 5.487a1.494 1.494 0 102.988 0 1.494 1.494 0 00-2.988 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8RmxK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 1a1 1 0 011-1c1.66 0 3 1.34 3 3s-1.34 3-3 3h-1.59l.3.29a1.003 1.003 0 01-1.42 1.42l-2-2A.997.997 0 018 5c0-.28.11-.53.29-.71l2-2a1.003 1.003 0 011.42 1.42l-.3.29H13c.55 0 1-.45 1-1s-.45-1-1-1a1 1 0 01-1-1z",
    "M12.932 7.519l.48.48a2 2 0 010 2.828L8.826 15.41a2 2 0 01-2.829 0L.586 9.998A2 2 0 010 8.584V4a2 2 0 012-2h4.584a2 2 0 011.414.586l.291.29-.706.707A1.997 1.997 0 007 5c0 .548.217 1.052.583 1.417l2 2a2.004 2.004 0 003.349-.898zM1.992 5.487a1.494 1.494 0 102.99 0 1.494 1.494 0 00-2.99 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gQYTL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 0h4.584a2 2 0 011.414.586l5.413 5.412a2 2 0 010 2.829l-4.584 4.584a2 2 0 01-2.829 0L2.586 7.998A2 2 0 012 6.584V2a2 2 0 012-2zm-.007 3.493a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z",
    "M.263 5.176L1 3.819v2.765a3 3 0 00.879 2.122l5.412 5.412c.312.312.676.541 1.064.687L4.41 15.93c-1.045.297-2.12-.362-2.4-1.473l-1.942-7.7a2.197 2.197 0 01.196-1.58z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"S4zYr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 11a1.003 1.003 0 001.71.71l4-4a1.003 1.003 0 00-1.42-1.42l-4 4c-.18.18-.29.43-.29.71zM4 6c.28 0 .53-.11.71-.29l4-4A1.003 1.003 0 007.29.29l-4 4A1.003 1.003 0 004 6zm4 4l5-5-.79-.79.5-.5a1.003 1.003 0 00-1.42-1.42l-.5.5L10 2 5 7l.79.79-5.5 5.5a1.003 1.003 0 001.42 1.42l5.5-5.5L8 10zm7 4H7c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2XIQm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.7 3.4a1 1 0 01.8-.4h5.086a1 1 0 01.707.293L11 4h3a1 1 0 110 2h-3v1h2.5a2.5 2.5 0 010 5h-11a2.5 2.5 0 010-5H3V4.667a1 1 0 01.2-.6l.5-.667zM2.5 9h11a.5.5 0 010 1h-11a.5.5 0 110-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1lFSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 4a1 1 0 012 0v2a1 1 0 01-2 0V4zM10 7a1 1 0 000 2h2a1 1 0 000-2h-2zM3 8a1 1 0 011-1h2a1 1 0 010 2H4a1 1 0 01-1-1zM8 9a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z",
    "M8 16A8 8 0 108 0a8 8 0 000 16zm0-2A6 6 0 108 2a6 6 0 000 12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"geads":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.12 6.63h-.38L15 7c-.01.3-.01.64 0 .98V8c0 .07-.03.13-.04.19h.02L14 13.1v.9c0 .55-.45 1-1 1s-1-.45-1-1v-1H4v1c0 .55-.45 1-1 1s-1-.45-1-1v-.9l-.98-4.9h.02C1.03 8.13 1 8.07 1 8H.99c0-.33 0-.67.01-1l.26-.37H.88C.4 6.63 0 6.21 0 5.69s.4-.94.88-.94h1.05l.77-2.11c.19-.53.76-1.08 1.26-1.24 0 0 .68-.2 2.05-.32C6.01 1.05 6 1.03 6 1c0-.55.45-1 1-1h2c.55 0 1 .45 1 1 0 .03-.01.05-.02.08 1.37.12 2.05.32 2.05.32.51.15 1.08.71 1.27 1.24l.76 2.12h1.05c.49 0 .89.42.89.93 0 .52-.4.94-.88.94zM11 10h2V8h-2v2zm-8 0h2V8H3v2zm10-5l-.73-1.63C12.21 3.19 12.18 3 12 3H4c-.18 0-.21.19-.27.37L3 5c-.06.18-.18 1 0 1h10c.18 0 .06-.82 0-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Ya0g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.328 10.238c1.015.413 2.16.878 2.439 1.516.303.69.248 2.67.235 3.143L14 15H2s-.113-2.465.232-3.253c.28-.638 1.424-1.104 2.44-1.517.238-.097.47-.191.682-.284.985-.436 1-.722 1.02-1.067.002-.041.004-.083.008-.127 0-.026.002-.052.004-.079.002-.026.004-.052.004-.078a3.348 3.348 0 01-.916-1.351l-.008-.008c0-.003-.001-.007-.003-.01-.002-.005-.004-.008-.004-.012a2.982 2.982 0 01-.113-.368c-.262-.045-.412-.323-.472-.585-.053-.105-.173-.36-.15-.646.037-.382.195-.555.375-.623v-.06c0-.48.037-1.163.127-1.613.015-.128.045-.248.083-.375a2.787 2.787 0 01.96-1.396C6.742 1.188 7.41 1 8.003 1s1.261.195 1.741.548a2.755 2.755 0 011.043 1.77c.083.451.128 1.142.128 1.614V5c.165.068.315.24.353.615.022.293-.09.548-.15.653-.053.255-.203.533-.458.586a2.87 2.87 0 01-.113.36c-.007.007-.015.037-.015.037-.202.533-.51.998-.893 1.336 0 .06 0 .12.008.173.005.052.006.102.008.15.011.335.021.618.99 1.043.212.093.444.187.683.285z",
    "M4.5 7.521a1.637 1.637 0 01-.282-.308 1.957 1.957 0 01-.279-.593c-.304-.652-.29-1.486.153-2.074.023-.628.065-1.278.244-1.884a3.84 3.84 0 01.177-.473A2.896 2.896 0 003.497 2c-.543 0-1.156.179-1.596.502a2.526 2.526 0 00-.956 1.624 9.535 9.535 0 00-.117 1.479v.062c-.152.062-.29.22-.323.564-.021.268.082.502.137.598.048.234.186.489.42.537.027.11.062.227.103.33a3.098 3.098 0 00.832 1.259c0 .055 0 .11-.007.158-.004.048-.006.094-.007.139-.01.306-.02.565-.908.955C.281 10.556 0 11.046 0 12v3h1s-.16-2.356 0-3c.16-.644.572-1.184 1.108-1.59.61-.46 1.333-.753 2.04-1.039l.213-.087c.857-.35.7-.644.421-1.164A4.761 4.761 0 014.5 7.52zM11.5 7.521a1.64 1.64 0 00.282-.308c.136-.193.224-.401.278-.593.305-.652.292-1.486-.152-2.074-.024-.628-.065-1.278-.244-1.884a3.842 3.842 0 00-.177-.473c.327-.125.684-.189 1.016-.189.543 0 1.156.179 1.596.502a2.526 2.526 0 01.956 1.624c.076.412.117 1.045.117 1.479v.062c.151.062.289.22.323.564.021.268-.082.502-.137.598-.048.234-.186.489-.42.537-.027.11-.062.227-.103.33a3.098 3.098 0 01-.832 1.259c0 .055 0 .11.006.158.005.048.006.094.008.139.01.306.02.565.907.955C15.72 10.556 16 11.046 16 12v3h-1s.16-2.356 0-3c-.16-.644-.572-1.184-1.108-1.59-.61-.46-1.333-.753-2.04-1.039l-.213-.087c-.857-.35-.7-.644-.421-1.164a4.77 4.77 0 00.283-.599z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5OYfO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.5 0A1.5 1.5 0 007 1.5v7.837a3.5 3.5 0 103 0V1.5A1.5 1.5 0 008.5 0zM2 5.5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM2.5 1a.5.5 0 000 1h3a.5.5 0 000-1h-3zM4 3.5a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM4.5 7a.5.5 0 000 1h1a.5.5 0 000-1h-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l8kR0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 10H2V6h7V4H1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h8v-2zm4 3h-1V3h1c.55 0 1-.45 1-1s-.45-1-1-1h-1c-.37 0-.7.11-1 .28-.3-.17-.63-.28-1-.28H9c-.55 0-1 .45-1 1s.45 1 1 1h1v10H9c-.55 0-1 .45-1 1s.45 1 1 1h1c.37 0 .7-.11 1-.28.3.17.63.28 1 .28h1c.55 0 1-.45 1-1s-.45-1-1-1zm2-9h-2v2h1v4h-1v2h2c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gpFAV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1H1c-.6 0-1 .5-1 1v12c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1zM6 13H2v-2h4v2zm0-3H2V8h4v2zm0-3H2V5h4v2zm8 6H7v-2h7v2zm0-3H7V8h7v2zm0-3H7V5h7v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f3P0X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 0a1 1 0 00-1 1v1h-1a1 1 0 100 2h1v1a1 1 0 102 0V4h1a1 1 0 100-2h-1V1a1 1 0 00-1-1z",
    "M8.764 5H7v2h3.764a3.001 3.001 0 005.108-1.129A2.95 2.95 0 0016 5.83V14c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V2c0-.5.4-1 1-1h7.764A2.989 2.989 0 008 3c0 .768.289 1.47.764 2zM6 5H2v2h4V5zm0 3H2v2h4V8zm1 2h7V8H7v2zm-1 1H2v2h4v-2zm1 2h7v-2H7v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kYPJD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.6 10l-.3.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3l2-2c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-2-2C6.5 6.1 6.3 6 6 6c-.5 0-1 .4-1 1 0 .3.1.5.3.7l.3.3H1c-.6 0-1 .4-1 1s.4 1 1 1h4.6zM15 1H2c-.5 0-1 .5-1 1v5h2V5h11v2H8.8l.6.6c.1.1.2.3.3.4H14v2H9.7c-.1.1-.2.3-.3.4l-.6.6H14v2H3v-2H1v3c0 .5.5 1 1 1h13c.6 0 1-.5 1-1V2c0-.5-.4-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j130S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 1h3c.6 0 1 .5 1 1v12c0 .6-.4 1-1 1h-4.97l.286-2H14v-2h-3.398l.143-1H14V8h-2.97l.143-1H14V5h-2.541l.51-3.576C11.99 1.282 12 1.14 12 1zM5.97 1l-.572 4H2v2h3.112L4.97 8H2v2h2.684l-.143 1H2v2h2.255l-.225 1.576c-.02.142-.03.284-.03.424H1c-.6 0-1-.4-1-1V2c0-.5.4-1 1-1h4.97zM8.01.859a1 1 0 111.98.282l-2 14a1 1 0 11-1.98-.282l2-14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3fSHC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 10h3l1.78-2.226a1 1 0 00.22-.625V4.3l1-.9V14c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V2c0-.5.4-1 1-1h4.333L9 4.3V5H7v2h2v1H7v2h3zm-4 3v-2H2v2h4zm0-3V8H2v2h4zm0-3V5H2v2h4zm8 6v-2H7v2h7z",
    "M15.48 0c.31 0 .52.26.52.57 0 .16-.06.3-.17.41l-2.86 2.73v2.63c0 .16-.06.3-.17.41l-.82 1.1c-.1.1-.25.17-.41.17-.31 0-.57-.26-.57-.57V3.71L8.17.98A.566.566 0 018 .57c0-.31.26-.57.57-.57h6.91z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iY9iB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1H1c-.6 0-1 .5-1 1v12c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1zm-1 12H2v-2h12v2zm0-3H2V8h12v2zm0-3H2V5h12v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"20Hg0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 1a1 1 0 112 0v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0V4h-1a1 1 0 110-2h1V1zM8 3c0 .768.289 1.47.764 2H2v2h8.764c.55.614 1.348 1 2.236 1H2v2h12V8h-1a3.001 3.001 0 002.872-2.129A2.95 2.95 0 0016 5.83V14c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V2c0-.5.4-1 1-1h7.764A2.989 2.989 0 008 3zM7 13h7v-2H2v2h5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7aFa7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 8a1 1 0 000-2H4a1 1 0 00-1 1v3a1 1 0 002 0v-.637l2.36 2.357a.962.962 0 001.36-1.358L6.355 8H7z",
    "M1 1c-.6 0-1 .5-1 1v12a1 1 0 001 1h14c.6 0 1-.4 1-1V2a1 1 0 00-1-1H1zm13 12H2V5h12v8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1sIT2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 1a.999.999 0 112 0v1h1a.995.995 0 01.83.44.996.996 0 01-.02 1.148A1.004 1.004 0 0115 4h-1v1a.996.996 0 01-.49.86.995.995 0 01-.9.061A1.004 1.004 0 0112 5V4h-1a.996.996 0 01-.83-.44.996.996 0 01.033-1.164A1.004 1.004 0 0111 2h1V1zm2 6.83a3.008 3.008 0 001.872-1.959c.043-.013.086-.027.128-.042V14c0 .6-.4 1-1 1H1a1 1 0 01-1-1V2c0-.5.4-1 1-1h7.764A2.989 2.989 0 008 3c0 .768.289 1.47.764 2H2v8h12V7.83zm-6.64 3.89L5 9.363V10a1 1 0 01-2 0V7a1 1 0 011-1h3a1 1 0 010 2h-.645l2.365 2.362a.962.962 0 01-1.36 1.359z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"atR5H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.448 9h.573c.025-.044.051-.088.079-.13A9.43 9.43 0 015.183 8h-.995A10.424 10.424 0 014 6c0-.717.068-1.391.188-2h3.624c.065.33.114.678.146 1.042A3.42 3.42 0 018.46 5c.168 0 .336.013.502.037A11.089 11.089 0 008.829 4h1.755c.148.338.26.696.33 1.068l.176-.028a2.74 2.74 0 01.5 0c.113 0 .225.006.336.018A6.001 6.001 0 000 6a6 6 0 005.672 5.991 4 4 0 01-.202-.441 1.842 1.842 0 01-.24-.26 1.82 1.82 0 01-.26-.55 2 2 0 01-.185-.92l-.012-.025A6.036 6.036 0 014.448 9zM3.171 8H1.416A4.983 4.983 0 011 6c0-.711.148-1.388.416-2h1.755C3.06 4.626 3 5.299 3 6c0 .701.06 1.374.17 2zM2 9H3.4c.18.618.412 1.167.685 1.62A5.015 5.015 0 012 9zm2.448-6h3.104a6.036 6.036 0 00-.325-.795C6.737 1.225 6.246 1 6 1c-.246 0-.737.225-1.227 1.205-.119.238-.228.504-.325.795zm4.15 0H10a5.016 5.016 0 00-2.086-1.62c.273.453.506 1.002.685 1.62zM4.087 1.38A6.834 6.834 0 003.401 3H2a5.015 5.015 0 012.086-1.62zM13.476 16s.118-.385-.172-1.046c-.228-.533-1.172-.915-2.015-1.257a22.113 22.113 0 01-.584-.243c-.808-.356-.816-.588-.825-.872-.002-.041-.003-.084-.007-.128v-.139c.314-.284.573-.669.745-1.115 0 0 .008-.023.008-.03.04-.1.071-.2.095-.3.212-.04.33-.27.377-.485.054-.093.149-.3.125-.547-.024-.307-.15-.453-.29-.515v-.054c0-.392-.04-.961-.11-1.33a2.16 2.16 0 00-.071-.308 2.283 2.283 0 00-.8-1.17C9.558 6.162 9.001 6 8.506 6c-.495 0-1.052.162-1.445.462A2.294 2.294 0 006.19 7.93c-.07.369-.11.946-.11 1.338v.046c-.14.062-.274.208-.306.523a1 1 0 00.126.547c.047.215.173.453.393.492.02.083.05.172.078.253l.016.047c0 .008.008.015.008.015v.008c.172.454.44.846.761 1.115a.804.804 0 01-.004.072c-.002.02-.004.04-.004.06l-.007.105c-.016.287-.028.523-.848.894-.176.078-.37.156-.568.237-.847.345-1.802.735-2.031 1.27C3.41 15.616 3.52 16 3.52 16h9.955zm2.503-1.25h-1.413a4.05 4.05 0 00-.116-.294c-.192-.445-.52-.753-.787-.955-.278-.21-.59-.38-.873-.517a21.373 21.373 0 00-1.122-.483l-.02-.008-.235-.097c.144-.23.266-.476.366-.731.089-.087.162-.177.22-.26.132-.192.217-.391.271-.568.117-.251.24-.64.199-1.105a2.025 2.025 0 00-.299-.925 8.626 8.626 0 00-.116-1.083 3.426 3.426 0 00-.104-.45 3.476 3.476 0 00-.661-1.246A2.18 2.18 0 0111.63 6c.432 0 .92.141 1.264.404.33.256.584.612.7 1.023.028.087.049.182.062.27.062.322.097.82.097 1.163v.048c.123.053.233.181.254.45a.82.82 0 01-.11.478c-.041.189-.144.391-.33.425a1.92 1.92 0 01-.082.262c0 .007-.007.027-.007.027-.151.39-.378.727-.653.976v.121c.004.038.005.075.006.111v.002c.008.247.015.451.722.762.158.07.332.14.51.213.739.299 1.565.634 1.764 1.1.254.579.151.915.151.915z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3pPC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 2H0v7h2c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm13.99 4.38c.08-.58-.44-1.02-1.15-1.05-.25-.01-.52-.03-.81-.05.02 0 .05-.01.07-.01.7-.1 1.34-.49 1.41-1.07.06-.58-.46-.97-1.17-1.04-.25-.02-.52-.04-.79-.06.47-.15.84-.42.87-.93.04-.58-.79-1.03-1.5-1.09-.27-.02-.51-.04-.73-.05h-.09c-.23-.02-.43-.02-.62-.03C8.35.95 5.66 1.47 4 2.51v6c2.14 1.29 4.76 3.59 4.21 5.51-.18.59.31 1.05.98.98.81-.09 1.37-.91 1.4-1.78.04-1-.15-2.01-.5-2.91-.04-.25.01-.5.37-.53.49-.03 1.11-.06 1.59-.08.26 0 .51-.01.75-.02h.01c.41-.02.8-.05 1.13-.09.7-.09 1.35-.47 1.43-1.05.08-.58-.44-.97-1.15-1.05-.05-.01-.11-.01-.16-.02.17-.01.33-.03.49-.05.72-.08 1.37-.46 1.44-1.04z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4V40g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.99 9.62c-.08-.58-.73-.96-1.43-1.05-.15-.02-.32-.04-.49-.05.06-.01.11-.01.16-.02.71-.08 1.23-.47 1.15-1.05-.08-.58-.73-.96-1.43-1.05-.34-.04-.72-.07-1.13-.09h-.01c-.24-.01-.49-.02-.75-.02-.48-.02-1.11-.04-1.59-.08-.36-.03-.41-.28-.37-.53.35-.9.54-1.91.5-2.91-.04-.85-.6-1.68-1.41-1.77-.67-.07-1.16.39-.99.98C8.76 3.91 6.13 6.2 4 7.49v6c1.66 1.03 4.35 1.56 7.48 1.5.19 0 .39-.01.62-.02h.09c.22-.01.46-.03.73-.05.71-.06 1.54-.51 1.5-1.09-.03-.51-.4-.79-.87-.93.27-.02.54-.04.79-.06.71-.06 1.24-.45 1.17-1.04-.06-.58-.7-.97-1.41-1.07-.02 0-.05-.01-.07-.01.29-.02.57-.03.81-.05.71-.03 1.23-.47 1.15-1.05zM2 7H0v7h2c.55 0 1-.45 1-1V8c0-.56-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Fp6m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 3c-.28 0-.53.11-.71.29L6 10.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29s.53-.11.71-.29l8-8A1.003 1.003 0 0014 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYLhZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 16c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4-11c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lD8z0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm1-6.41V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L9 7.59z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6oe3Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 2.59L9.91 7.68 6.6 5.2l-.01.01C6.42 5.09 6.23 5 6 5c-.24 0-.44.09-.62.23v-.01L3 7.12V11h12V2.59zM15 12H2V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jXZ0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 12h1c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1zm5 0h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm2 1H2c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1s-.45-1-1-1zM3 12h1c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kxQv6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 11H7v1h1v-1zm-4 0H3v1h1v-1zm7-8c.6 0 1-.5 1-1V1c0-.5-.4-1-1-1s-1 .5-1 1v1c0 .5.5 1 1 1zM4 3c.5 0 1-.5 1-1V1c0-.5-.5-1-1-1S3 .5 3 1v1c0 .5.5 1 1 1zm10-2h-1v1c0 1.1-.9 2-2 2s-2-.9-2-2V1H6v1c0 1.1-.9 2-2 2s-2-.9-2-2V1H1c-.5 0-1 .5-1 1v12c0 .5.5 1 1 1h13c.6 0 1-.5 1-1V2c0-.5-.4-1-1-1zM5 13H2v-3h3v3zm0-4H2V6h3v3zm4 4H6v-3h3v3zm0-4H6V6h3v3zm4 4h-3v-3h3v3zm0-4h-3V6h3v3zm-1-2h-1v1h1V7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1FmQX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 12H2V9.41l3-3L8.29 9.7c.18.19.43.3.71.3s.53-.11.71-.29l6-6a1.003 1.003 0 00-1.42-1.42L9 7.59l-3.29-3.3C5.53 4.11 5.28 4 5 4s-.53.11-.71.29L2 6.59V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5vxfq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.88 1s-4.9 6.28-4.9 8.9c.01 2.82 2.34 5.1 4.99 5.1 2.65-.01 5.03-2.3 5.03-5.13C12.99 7.17 7.88 1 7.88 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Dqyp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 15c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H5v1zm7-15H4c-.55 0-1 .45-1 1v1h10V1c0-.55-.45-1-1-1zM5 7v6h6V7l2-4H3l2 4zm2 0c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ipK3R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.5 9a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm9.5 1a3 3 0 110 6 3 3 0 010-6zm-9.5 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm9.5 1a1 1 0 100 2 1 1 0 000-2zM5 0c1.46 0 2.527.668 3 2l.815 3.255a78.9 78.9 0 012.186.195L11 2h2l.001 3.688c.698.095 1.37.198 2.013.312.623.11.986.479.986 1v3.354a4.001 4.001 0 00-6.873 1.645H7.999l-.026-.002A4.5 4.5 0 00.659 9.01l-.654.001v-.829C.003 7.386.002 6.423 0 6.022 0 5.5.376 4.99 1 4.99V1a1 1 0 011-1h3zm1 2H3v2.99c1.29.024 2.554.069 3.781.135L6 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"34gFL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 14h-1l1 2H3l1-2H3c-1.1 0-2-.9-2-2V2C1 .9 4.13 0 8 0s7 .9 7 2v10c0 1.1-.9 2-2 2zm-2-2h2v-2h-2v2zM9 7h4V3H9v4zm-6 5h2v-2H3v2zm0-5h4V3H3v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9p6fm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.89 14.56l-3.99-8h-.01c-.17-.33-.5-.56-.89-.56s-.72.23-.89.56h-.01L9 8.76 7.17 7.38l.23-.18C8.37 6.47 9 5.31 9 4V3h1c.55 0 1-.45 1-1s-.45-1-1-1H7c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1H1c-.55 0-1 .45-1 1s.45 1 1 1h6v1c0 .66-.32 1.25-.82 1.61l-.68.51-.68-.5C4.32 5.25 4 4.66 4 4H2c0 1.31.63 2.47 1.6 3.2l.23.17L1.4 9.2l.01.01C1.17 9.4 1 9.67 1 10c0 .55.45 1 1 1 .23 0 .42-.09.59-.21l.01.01 2.9-2.17 2.6 1.95-1.99 3.98h.01c-.07.13-.12.28-.12.44 0 .55.45 1 1 1 .39 0 .72-.23.89-.56h.01L8.62 14h4.76l.72 1.45h.01c.17.32.5.55.89.55.55 0 1-.45 1-1 0-.16-.05-.31-.11-.44zM9.62 12L11 9.24 12.38 12H9.62z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cXm0E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.49 3.99h-13c-.28 0-.5.22-.5.5s.22.5.5.5h.5v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-10h.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm-8.5 9c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6zm3 0c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6zm3 0c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6zm2-12h-4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1h-4c-.55 0-1 .45-1 1v1h14v-1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6oC2q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 11.857V16H7v-4.143L1 13l3.885-4.44L3 9l3.07-4.297L5 5l3-5 3 5-1.07-.297L13 9l-1.885-.44L15 13l-6-1.143z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bLA2g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 7c-.55 0-1 .45-1 1v.59l-4.29-4.3A.997.997 0 009 4c-.16 0-.31.05-.44.11V4.1L5 5.88 1.45 4.11v.01C1.31 4.05 1.16 4 1 4c-.55 0-1 .45-1 1 0 .39.23.72.56.89v.01l4 2v-.01c.13.06.28.11.44.11s.31-.05.44-.11v.01L8.8 6.22 12.59 10H12c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ksGi8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 4h-3c-.55 0-1 .45-1 1s.45 1 1 1h.59L8.8 9.78 5.45 8.11v.01C5.31 8.05 5.16 8 5 8s-.31.05-.44.11V8.1l-4 2v.01c-.33.17-.56.5-.56.89 0 .55.45 1 1 1 .16 0 .31-.05.44-.11v.01L5 10.12l3.55 1.78v-.01c.14.06.29.11.45.11.28 0 .53-.11.71-.29L14 7.41V8c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kniiR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 .917C4 .41 4.41 0 4.917 0h6.166c.507 0 .917.41.917.917V2h3a1 1 0 011 1v1a5 5 0 01-4.522 4.977A4.008 4.008 0 019 10.874V14h2a1 1 0 110 2H5a1 1 0 110-2h2v-3.126a4.008 4.008 0 01-2.478-1.897A5 5 0 010 4V3a1 1 0 011-1h3V.917zM4 4H2c0 1.306.835 2.417 2 2.83V4zm8 2.83V4h2a3.001 3.001 0 01-2 2.83z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hrA5J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.5 0a.5.5 0 01.5.5V9a1 1 0 011 1v2h.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H13v1a1 1 0 01-2 0v-1H5v1a1 1 0 01-2 0v-1H1.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H2v-2a1 1 0 011-1V.5a.5.5 0 011 0V3a2 2 0 012-2h4a2 2 0 012 2V.5a.5.5 0 01.5-.5zM9 8H7a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1V9a1 1 0 00-1-1zm3.5 3h-1a.5.5 0 100 1h1a.5.5 0 100-1zm-8 0h-1a.5.5 0 100 1h1a.5.5 0 100-1zM9 9a.5.5 0 01.5.5v1l-.008.09A.5.5 0 019 11H7l-.09-.008a.5.5 0 01-.41-.492v-1l.008-.09A.5.5 0 017 9zm2-5H5v2h6V4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dXue4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.99-.01h-3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-14c0-.55-.45-1-1-1zm11.71 7.3l-2-2a1.003 1.003 0 00-1.71.71v4a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71s-.11-.53-.29-.71zM9.99-.01h-3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-14c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1IoHq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.382 0a1 1 0 01.894.553L16 4v11a1 1 0 01-1 1H1a1 1 0 01-1-1V4L1.724.553A1 1 0 012.618 0h10.764zM8 6c-.28 0-.53.11-.71.29l-2 2-.084.096A1.003 1.003 0 006.71 9.71l.29-.3V12l.007.116c.058.496.482.884.993.884.55 0 1-.45 1-1V9.41l.29.29.081.076A.97.97 0 0010 10a1.003 1.003 0 00.71-1.71l-2-2-.096-.084A1.002 1.002 0 008 6zm5-4H3L2 4h12l-1-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5aq4G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 14c2.8 0 5-2.2 5-5V3c0-.6-.4-1-1-1s-1 .4-1 1v6c0 1.7-1.3 3-3 3s-3-1.3-3-3V3c0-.6-.4-1-1-1s-1 .4-1 1v6c0 2.8 2.2 5 5 5zM13.5 15h-11c-.3 0-.5.2-.5.5s.2.5.5.5h11c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fF9i3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H3.41L4.7 2.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C.11 4.47 0 4.72 0 5c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L3.41 6H11c1.66 0 3 1.34 3 3s-1.34 3-3 3H7v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ataoY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.5 5C1.57 5 0 6.57 0 8.5S1.57 12 3.5 12 7 10.43 7 8.5 5.43 5 3.5 5zm9 0C10.57 5 9 6.57 9 8.5s1.57 3.5 3.5 3.5S16 10.43 16 8.5 14.43 5 12.5 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9JSjD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.507 9.75v-3.5c0-.089.023-.171.051-.25h-7.55c-.176 0-.061-.824 0-1l.729-1.63c.06-.177.095-.37.27-.37h4.5V1.01c-.166-.003-.32-.01-.5-.01-2.72 0-4.036.402-4.036.402-.508.155-1.079.711-1.268 1.237L1.94 4.756H.887c-.483 0-.88.423-.88.939s.397.939.88.939h.376L1.008 7c-.034.685 0 1.436 0 2v5c0 .657.384 1 1 1s1-.343 1-1v-1h10v1c0 .657.383 1 1 1s1-.343 1-1v-3.5h-3.75a.75.75 0 01-.75-.75zm-5.5.25h-2V8h2v2zm11-4.305zM15.34.826a2.807 2.807 0 00-.932-.598c-.386-.16-.868-.241-1.445-.241-.447 0-.851.076-1.213.228-.362.153-.67.364-.926.636s-.456.592-.598.963a3.535 3.535 0 00-.218 1.144V3h1.789c.003-.208.023-.405.069-.588.049-.193.124-.362.225-.506.102-.144.232-.259.39-.345.159-.087.348-.13.567-.13.325 0 .58.09.762.272.183.18.275.46.275.839.008.222-.031.407-.116.555a1.654 1.654 0 01-.335.408 7.4 7.4 0 01-.452.37c-.162.123-.316.27-.463.438a2.556 2.556 0 00-.384.611c-.11.239-.177.535-.2.889V6h1.645v-.1c.032-.248.111-.453.237-.618.126-.164.27-.31.433-.438.163-.128.335-.255.518-.383a2.413 2.413 0 00.878-1.117c.102-.255.152-.58.152-.975A2.241 2.241 0 0015.34.826zM12.007 7v2h2V7h-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"goE7P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.998.005a3.996 3.996 0 013.997 3.998c0 1.109-.46 2.088-1.19 2.808l.02.02-.999 1-.02-.02a3.97 3.97 0 01-2.052 1.114l-.93-.929 1.583-1.595 1-1-.01-.01c.36-.36.6-.849.6-1.398 0-1.1-.9-2-2-2-.55 0-1.039.24-1.399.6l-.01-.01L8 5.172l-.924-.925A4.041 4.041 0 018.19 2.194l-.02-.02 1-1 .02.02A3.934 3.934 0 0111.997.005zM2.293 2.293a1 1 0 011.414 0l10 10a1 1 0 01-1.414 1.414L8.936 10.35c.04.212.063.428.063.648 0 1.1-.46 2.089-1.189 2.808l.02.02-1 1-.02-.02a3.934 3.934 0 01-2.807 1.189 3.996 3.996 0 01-3.998-3.997c0-1.1.46-2.09 1.19-2.809l-.02-.02.999-1 .02.02a3.934 3.934 0 012.808-1.188c.223 0 .439.023.649.064L2.293 3.707a1 1 0 010-1.414zm5.71 7.124l.704.704-3.295 3.296-.01-.01c-.36.36-.85.6-1.4.6-1.099 0-1.998-.9-1.998-2 0-.55.24-1.039.6-1.399l-.01-.01 3.295-3.295.694.695-2.29 2.29a1.002 1.002 0 001.42 1.42l2.29-2.291zm.702-3.54l1.419 1.418 1.584-1.584a1.002 1.002 0 00-1.42-1.42L8.706 5.877z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bRzOy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.99-.01c-2.21 0-4 1.79-4 4v3h-7c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-7c0-.55-.45-1-1-1h-3v-3c0-1.1.9-2 2-2s2 .9 2 2v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-2.21-1.79-4-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUKZ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.39 1c-.5.5-.4 1.48.15 2.53L4.38 7.54C2.85 6.5 1.52 6.07 1 6.59l3.5 3.5c-.02.02-1.4 2.8-1.4 2.8l2.8-1.4 3.5 3.5c.53-.53.1-1.86-.95-3.38l4.02-5.16c1.04.55 2.01.65 2.51.14L9.39 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uPtP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 3c-.55 0-1.07.09-1.57.26a6.46 6.46 0 010 9.48c.5.17 1.02.26 1.57.26 2.76 0 5-2.24 5-5s-2.24-5-5-5zM9.78 9.38l.09-.27c.08-.36.13-.73.13-1.11s-.05-.75-.13-1.11l-.09-.27a5.32 5.32 0 00-.29-.79l-.12-.21c-.14-.27-.31-.52-.51-.76a.7.7 0 00-.08-.1c-.24-.27-.49-.52-.78-.74-.43-.32-.92-.58-1.45-.75l.01-.01c-.1-.03-.2-.05-.3-.08-.12-.03-.23-.07-.36-.09A5.28 5.28 0 005 3C2.24 3 0 5.24 0 8s2.24 5 5 5c.31 0 .61-.04.9-.09.12-.02.24-.06.36-.09.1-.03.21-.04.3-.08l-.01-.01c.88-.29 1.64-.8 2.22-1.49.03-.03.06-.07.09-.1.19-.24.36-.49.51-.76.04-.07.08-.14.11-.21.13-.25.23-.52.3-.79z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kFtgE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0a7.95 7.95 0 00-6 2.74V1c0-.55-.45-1-1-1S0 .45 0 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.54C4.64 2.78 6.22 2 8 2c3.31 0 6 2.69 6 6 0 2.61-1.67 4.81-4 5.63-.63.22-1.29.37-2 .37-3.31 0-6-2.69-6-6 0-.55-.45-1-1-1s-1 .45-1 1c0 4.42 3.58 8 8 8 .34 0 .67-.03 1-.07.02 0 .04-.01.06-.01C12.98 15.4 16 12.06 16 8c0-4.42-3.58-8-8-8zm3 5c-.28 0-.53.11-.71.29L7 8.58 5.71 7.29a1.003 1.003 0 00-1.42 1.42l2 2c.18.18.43.29.71.29.28 0 .53-.11.71-.29l4-4A1.003 1.003 0 0011 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dipfJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3 8c-.28 0-.53-.11-.71-.29L9 6.41V12c0 .55-.45 1-1 1s-1-.45-1-1V6.41l-1.29 1.3a1.003 1.003 0 01-1.42-1.42l3-3C7.47 3.11 7.72 3 8 3s.53.11.71.29l3 3A1.003 1.003 0 0111 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iA7Qi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.99-.01A7.998 7.998 0 00.03 8.77c.01.09.03.18.04.28.02.15.04.31.07.47.02.11.05.22.08.34.03.13.06.26.1.38.04.12.08.25.12.37.04.11.08.21.12.32a6.583 6.583 0 00.3.65c.07.14.14.27.22.4.04.07.08.13.12.2l.27.42.1.13a7.973 7.973 0 003.83 2.82c.03.01.05.02.07.03.37.12.75.22 1.14.29l.2.03c.39.06.79.1 1.2.1s.81-.04 1.2-.1l.2-.03c.39-.07.77-.16 1.14-.29.03-.01.05-.02.07-.03a8.037 8.037 0 003.83-2.82c.03-.04.06-.08.09-.13.1-.14.19-.28.28-.42.04-.07.08-.13.12-.2.08-.13.15-.27.22-.41.04-.08.08-.17.12-.26.06-.13.11-.26.17-.39.04-.1.08-.21.12-.32.04-.12.08-.24.12-.37.04-.13.07-.25.1-.38.03-.11.06-.22.08-.34.03-.16.05-.31.07-.47.01-.09.03-.18.04-.28.02-.26.04-.51.04-.78-.03-4.41-3.61-7.99-8.03-7.99zm0 14.4c-1.98 0-3.75-.9-4.92-2.31.67-.36 1.49-.66 2.14-.95 1.16-.52 1.04-.84 1.08-1.27.01-.06.01-.11.01-.17-.41-.36-.74-.86-.96-1.44v-.01c0-.01-.01-.02-.01-.02-.05-.13-.09-.26-.12-.39-.28-.05-.44-.35-.5-.63-.06-.11-.18-.38-.15-.69.04-.41.2-.59.38-.67v-.06c0-.51.05-1.24.14-1.72.02-.13.05-.26.09-.39.17-.59.53-1.12 1.01-1.49.49-.38 1.19-.59 1.82-.59.62 0 1.32.2 1.82.59.48.37.84.9 1.01 1.49.04.13.07.26.09.4.09.48.14 1.21.14 1.72v.07c.18.08.33.26.37.66.03.31-.1.58-.16.69-.06.27-.21.57-.48.62-.03.13-.07.26-.12.38 0 .01-.01.04-.01.04-.21.57-.54 1.06-.94 1.42 0 .06.01.13.01.19.04.43-.12.75 1.05 1.27.65.29 1.47.6 2.14.95a6.415 6.415 0 01-4.93 2.31z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aBGRo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.94 3.15c.47-.66 1.05-1.24 1.76-1.73l.13-.4c-1.11.45-2.05 1.01-2.84 1.7-1.02.88-1.8 1.9-2.32 3.05C.22 6.76 0 7.75 0 8.75c0 1.75.66 3.5 1.99 5.25l.13-.42c-.39-.94-.59-1.82-.59-2.63 0-1.28.22-2.64.67-4.1.45-1.45 1.03-2.69 1.74-3.7zm7.51 6.41l-.27-.15c-.3.41-.52.66-.66.77-.09.06-.21.1-.33.1-.15 0-.3-.1-.45-.28-.25-.33-.59-1.22-1.01-2.69.38-.65.69-1.08.95-1.28.19-.15.39-.22.59-.22.08 0 .22.03.43.08.2.06.39.08.54.08.22 0 .4-.07.54-.22.15-.15.22-.34.22-.57 0-.25-.07-.45-.22-.59-.15-.15-.35-.22-.63-.22-.24 0-.47.06-.69.17-.21.11-.49.36-.82.74-.25.28-.61.78-1.1 1.48a6.72 6.72 0 00-.97-2.38l-2.59.44-.05.27c.19-.04.36-.06.49-.06.26 0 .47.11.64.33.26.34.63 1.38 1.11 3.12-.37.49-.63.81-.77.96-.23.24-.41.4-.56.47-.11.06-.24.09-.39.09-.11 0-.29-.06-.53-.18-.17-.07-.32-.11-.45-.11-.25 0-.46.08-.62.24-.16.16-.24.37-.24.61 0 .23.08.42.23.57.15.15.35.22.61.22.25 0 .48-.05.7-.15.22-.1.49-.32.82-.65.33-.33.78-.86 1.36-1.59.22.69.42 1.19.58 1.51.16.31.35.54.56.68.21.14.47.21.79.21.31 0 .62-.11.93-.33.4-.29.82-.77 1.26-1.47zm2.56-8.54l-.12.42c.39.95.59 1.82.59 2.64 0 1.09-.17 2.26-.5 3.51-.26.96-.6 1.87-1.02 2.71-.42.85-.82 1.51-1.21 1.98-.39.48-.87.92-1.44 1.32l-.14.4c1.11-.45 2.05-1.02 2.84-1.7 1.03-.89 1.81-1.91 2.33-3.05.44-.99.66-1.99.66-3 0-1.73-.66-3.48-1.99-5.23z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bnBIh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.703.29l1.997 2h.01c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-1.997 2a1.002 1.002 0 01-1.418-1.42l.29-.29H4.998C4.449 4 4 3.55 4 3s.45-1 .999-1h3.565l-.29-.29A1.004 1.004 0 018.995 0c.28 0 .53.11.709.29zM9.57 8.64c.2-.51.78-.77 1.29-.57.51.2.77.78.57 1.29l-2.25 5.8c-.2.51-.66.84-1.18.84-.52 0-.98-.33-1.18-.84l-2.25-5.8c-.2-.51.05-1.09.57-1.29.51-.2 1.09.05 1.29.57L8 12.68l1.57-4.04z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"niKYU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 7c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1zM2 9c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1zm8-5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1zm4-4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b32w8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1zM2 0c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm8 7c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1zm4 2c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6KGtV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 2h14c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1s.45 1 1 1zm14 11H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM3 5c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5voYE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 0H0v1a1 1 0 001 1h14a1 1 0 001-1V0zM0 15v1h16v-1a1 1 0 00-1-1H1a1 1 0 00-1 1zM8.707 3.293a1 1 0 00-1.414 0l-2 2a1 1 0 001.414 1.414L8 5.414l1.293 1.293a1 1 0 001.414-1.414l-2-2zm-2 6a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L8 10.586 6.707 9.293z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1B2U8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM5 11V5l6 3-6 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iZBck":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.918 11.107l.737.737.052-.051A1 1 0 0114.2 13.12l-.078.087-1.414 1.414a1 1 0 01-1.492-1.327l.029-.033-.863-.863c-.426.231-.89.402-1.38.502L9 14l.117.007A1 1 0 019 16H7l-.117-.007A1 1 0 017 14v-1.1a4.967 4.967 0 01-1.447-.539l-.846.846.078.087a1 1 0 01-1.492 1.327l-1.414-1.414-.078-.087a1 1 0 011.492-1.327l.744-.744A4.986 4.986 0 013.23 9.5H2a1 1 0 01-1.993.117L0 9.5v-2a1 1 0 011.993-.117L2 7.5h1.025a4.973 4.973 0 01.905-2.405l-.512-.513-.125.125A1 1 0 011.8 3.38l.078-.087 1.414-1.414a1 1 0 011.529 1.277l.573.575a4.969 4.969 0 011.604-.63V2l-.116-.007a1 1 0 010-1.986L7 0h2a1 1 0 01.117 1.993L9 2l.001 1.1c.639.13 1.233.381 1.757.73l.535-.537-.078-.087a1 1 0 011.492-1.327l1.414 1.414.078.087a1 1 0 01-1.492 1.327l-.535.536a4.97 4.97 0 01.803 2.257H14l.007-.117A1 1 0 0116 7.5v2l-.007.117A1 1 0 0114 9.5h-1.229a4.987 4.987 0 01-.853 1.607zM10 9a1 1 0 100 2 1 1 0 000-2zM6.5 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l3xSM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 2c-.28 0-.53.11-.71.29L5.59 5H3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2.59l2.71 2.71c.17.18.42.29.7.29.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm3.57 1.44l-1.59 1.22C11.62 5.61 12 6.76 12 8s-.38 2.39-1.02 3.34l1.59 1.22C13.47 11.27 14 9.7 14 8c0-1.7-.53-3.27-1.43-4.56z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8oCMa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 2c-.28 0-.53.11-.71.29L7.59 5H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2.59l2.71 2.71c.17.18.42.29.7.29.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ljtH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 1.86c-.28 0-.53.11-.71.29l-2.7 2.71H1c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2.59l2.71 2.71a1.003 1.003 0 001.71-.71v-10c-.01-.55-.46-1-1.01-1zm6.74-.99l-1.58 1.22A9.985 9.985 0 0114 7.86c0 2.16-.69 4.15-1.85 5.78l1.58 1.22c1.42-1.97 2.26-4.38 2.26-7 .01-2.61-.84-5.02-2.25-6.99zM8.98 4.52C9.62 5.48 10 6.63 10 7.86s-.38 2.39-1.02 3.34l1.59 1.22c.9-1.29 1.43-2.86 1.43-4.56 0-1.7-.53-3.27-1.43-4.56L8.98 4.52z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"afBuD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 8h-2c-.16 0-.31-.05-.44-.11v.01l-1.02-.51-.37 1.86 1.38.92-.01.02c.27.17.46.46.46.81v4c0 .55-.45 1-1 1s-1-.45-1-1v-3.46l-1.27-.85-1.8 4.67h-.01A.98.98 0 015 16c-.55 0-1-.45-1-1 0-.13.03-.25.07-.36h-.01L7.39 6H5.62l-.73 1.45h-.01C4.72 7.77 4.39 8 4 8c-.55 0-1-.45-1-1 0-.16.05-.31.11-.44H3.1l1-2h.01c.17-.33.5-.56.89-.56h3.16l.29-.75C8.17 2.9 8 2.47 8 2c0-1.1.9-2 2-2s2 .9 2 2c0 1-.73 1.82-1.69 1.97l-.5 1.32 1.43.71H13c.55 0 1 .45 1 1s-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJ4vj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.84 13.5l.01-.01-7-12-.01.01c-.17-.3-.48-.5-.85-.5s-.67.2-.85.5l-.01-.01-7 12 .01.01c-.09.15-.15.31-.15.5 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 0-.19-.06-.35-.15-.5zm-6.85-.51h-2v-2h2v2zm0-3h-2v-5h2v5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jBkmS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 4h1c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm7-6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1zm4-3h-1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm0 10H2V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hrkuG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 1a1 1 0 01.894.553c.102.202.393.607.779.957.419.381.72.49.827.49.108 0 .408-.109.827-.49.386-.35.677-.755.779-.957a1 1 0 011.788 0c.102.202.393.607.779.957.419.381.72.49.827.49.108 0 .408-.109.827-.49.386-.35.677-.755.779-.957a1 1 0 011.788 0c.173.344.38.75.637 1.072.277.347.437.375.469.375a1 1 0 110 2c-.968 0-1.642-.64-2.03-1.125a4.755 4.755 0 01-.076-.097 6.093 6.093 0 01-.221.212C12.175 4.442 11.393 5 10.5 5c-.892 0-1.675-.558-2.173-1.01A6.243 6.243 0 018 3.67c-.105.11-.214.217-.327.32C7.175 4.442 6.393 5 5.5 5c-.892 0-1.675-.558-2.173-1.01a6.119 6.119 0 01-.221-.212l-.075.097C2.64 4.36 1.968 5 1 5a1 1 0 010-2c.032 0 .191-.028.47-.375.256-.321.463-.728.636-1.072A1 1 0 013 1zm0 5a1 1 0 01.894.553c.102.202.393.607.779.957.419.381.72.49.827.49.108 0 .408-.109.827-.49.386-.35.677-.755.779-.957a1 1 0 011.788 0c.102.202.393.607.779.957.419.381.72.49.827.49.108 0 .408-.109.827-.49.386-.35.677-.755.779-.957a1 1 0 011.788 0c.173.344.38.75.637 1.072.277.347.437.375.469.375a1 1 0 110 2c-.968 0-1.642-.639-2.03-1.125a4.726 4.726 0 01-.076-.097 6.093 6.093 0 01-.221.212c-.498.452-1.28 1.01-2.173 1.01-.892 0-1.675-.558-2.173-1.01A6.243 6.243 0 018 8.67c-.105.11-.214.217-.327.32C7.175 9.442 6.393 10 5.5 10c-.892 0-1.675-.558-2.173-1.01a6.119 6.119 0 01-.221-.212l-.075.097C2.64 9.36 1.968 10 1 10a1 1 0 010-2c.032 0 .191-.028.47-.375.256-.321.463-.728.636-1.072A1 1 0 013 6zm.894 5.553a1 1 0 00-1.788 0c-.173.344-.38.75-.637 1.072-.278.347-.437.375-.469.375a1 1 0 100 2c.968 0 1.642-.639 2.03-1.125a4.9 4.9 0 00.076-.097c.072.073.146.143.221.212.498.452 1.28 1.01 2.173 1.01.892 0 1.675-.558 2.173-1.01.113-.103.222-.21.327-.32.105.11.214.217.327.32.498.452 1.28 1.01 2.173 1.01.892 0 1.675-.558 2.173-1.01.075-.069.149-.14.221-.212a4.9 4.9 0 00.075.097C13.36 14.36 14.032 15 15 15a1 1 0 100-2c-.032 0-.191-.028-.47-.375-.256-.321-.463-.728-.636-1.072a1 1 0 00-1.788 0c-.102.202-.393.607-.779.957-.419.381-.72.49-.827.49-.108 0-.408-.109-.827-.49-.386-.35-.677-.755-.779-.957a1 1 0 00-1.788 0c-.102.202-.393.607-.779.957-.419.381-.72.49-.827.49-.108 0-.408-.109-.827-.49-.386-.35-.677-.755-.779-.957z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2QWGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 11h2V5h-2v6zM3 5H1v6h2V5zm11-1c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM5 3h6V1H5v2zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm3 15h6v-2H5v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"73BA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 3h14c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1zm1 2v6h12V5H2zm3 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bOZ8H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 0H2c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H3v-3h10v3zm0-4H3V2h10v8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"34V4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 0H2c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H3V6h10v8zm0-9H3V2h10v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiCzj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 4a2 2 0 112 2H4a1 1 0 000 2h8a4 4 0 10-4-4 1 1 0 002 0zM1 9a1 1 0 100 2h7.5a1.5 1.5 0 010 3c-.749 0-1.386-.538-1.52-1.199a1 1 0 10-1.96.398C5.35 14.82 6.83 16 8.5 16a3.5 3.5 0 100-7H1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hObJX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.83 3.7l-3.06 3.05-2.84-.7-.7-2.83L12.29.17a5.004 5.004 0 00-4.83 1.29 4.967 4.967 0 00-1.12 5.36L.58 12.58c-.36.36-.58.86-.58 1.41 0 1.1.9 2 2 2 .55 0 1.05-.22 1.41-.59l5.77-5.77c1.79.69 3.91.33 5.35-1.12 1.32-1.3 1.74-3.15 1.3-4.81z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ojo7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.71 3.71l-2 2a1.003 1.003 0 01-1.42-1.42l.3-.29H3c-.55 0-1 .45-1 1s.45 1 1 1a1 1 0 110 2C1.34 8 0 6.66 0 5s1.34-3 3-3h1.59l-.3-.29A1.003 1.003 0 015.71.29l2 2c.18.18.29.43.29.71 0 .28-.11.53-.29.71zm1.875 8.863l-2.98 2.98a1.526 1.526 0 01-2.158-2.158l2.98-2.98a4.502 4.502 0 016.013-5.977l-3 3.001a1.5 1.5 0 002.12 2.122l3.002-3.001a4.502 4.502 0 01-5.977 6.013z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"asLMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 0h4a1 1 0 01.775 1.632L3.08 5H5a1 1 0 010 2H1a1 1 0 01-.771-1.636L2.919 2H1a1 1 0 110-2zm8.585 12.573l-2.98 2.98a1.526 1.526 0 01-2.158-2.158l2.98-2.98a4.502 4.502 0 016.013-5.977l-3 3.001a1.5 1.5 0 002.12 2.122l3.002-3.001a4.502 4.502 0 01-5.977 6.013z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bavGG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 3.5C0 1.57 1.57 0 3.5 0S7 1.57 7 3.5 5.43 7 3.5 7 0 5.43 0 3.5zm3-2v2.21l1.56 1.56c.1.09.23.14.36.14.12 0 .25-.05.35-.14.19-.2.19-.51 0-.71L4 3.29V1.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5zm6.585 11.073l-2.98 2.98a1.526 1.526 0 01-2.158-2.158l2.98-2.98a4.502 4.502 0 016.013-5.977l-3 3.001a1.5 1.5 0 002.12 2.122l3.002-3.001a4.502 4.502 0 01-5.977 6.013z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6BtC3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.99 5.99v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-2zm7.56 7.44l-2.67-2.68a6.94 6.94 0 001.11-3.76c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7c1.39 0 2.68-.42 3.76-1.11l2.68 2.67a1.498 1.498 0 102.12-2.12zm-8.56-1.44c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b7NOs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.99 5.99c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-6zm11.56 7.44l-2.67-2.68a6.94 6.94 0 001.11-3.76c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7c1.39 0 2.68-.42 3.76-1.11l2.68 2.67a1.498 1.498 0 102.12-2.12zm-8.56-1.44c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4FZiV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 10a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42L12.59 8 11.3 9.29c-.19.18-.3.43-.3.71zM1 5c.55 0 1-.45 1-1V2h2c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v3c0 .55.45 1 1 1zm4 1a1.003 1.003 0 00-1.71-.71l-2 2C1.11 7.47 1 7.72 1 8c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L3.41 8 4.7 6.71c.19-.18.3-.43.3-.71zm1-1c.28 0 .53-.11.71-.29L8 3.41 9.29 4.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-2-2C8.53 1.11 8.28 1 8 1s-.53.11-.71.29l-2 2A1.003 1.003 0 006 5zm9 6c-.55 0-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm0-11h-3c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zM4 14H2v-2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zm6-3c-.28 0-.53.11-.71.29L8 12.59 6.71 11.3A.965.965 0 006 11a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 0010 11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"97non":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Add", ()=>(0, _addDefault.default));
parcelHelpers.export(exports, "AddClip", ()=>(0, _addClipDefault.default));
parcelHelpers.export(exports, "AddColumnLeft", ()=>(0, _addColumnLeftDefault.default));
parcelHelpers.export(exports, "AddColumnRight", ()=>(0, _addColumnRightDefault.default));
parcelHelpers.export(exports, "AddLocation", ()=>(0, _addLocationDefault.default));
parcelHelpers.export(exports, "AddRowBottom", ()=>(0, _addRowBottomDefault.default));
parcelHelpers.export(exports, "AddRowTop", ()=>(0, _addRowTopDefault.default));
parcelHelpers.export(exports, "AddToArtifact", ()=>(0, _addToArtifactDefault.default));
parcelHelpers.export(exports, "AddToFolder", ()=>(0, _addToFolderDefault.default));
parcelHelpers.export(exports, "AimpointsTarget", ()=>(0, _aimpointsTargetDefault.default));
parcelHelpers.export(exports, "Airplane", ()=>(0, _airplaneDefault.default));
parcelHelpers.export(exports, "AlignCenter", ()=>(0, _alignCenterDefault.default));
parcelHelpers.export(exports, "AlignJustify", ()=>(0, _alignJustifyDefault.default));
parcelHelpers.export(exports, "AlignLeft", ()=>(0, _alignLeftDefault.default));
parcelHelpers.export(exports, "AlignRight", ()=>(0, _alignRightDefault.default));
parcelHelpers.export(exports, "AlignmentBottom", ()=>(0, _alignmentBottomDefault.default));
parcelHelpers.export(exports, "AlignmentHorizontalCenter", ()=>(0, _alignmentHorizontalCenterDefault.default));
parcelHelpers.export(exports, "AlignmentLeft", ()=>(0, _alignmentLeftDefault.default));
parcelHelpers.export(exports, "AlignmentRight", ()=>(0, _alignmentRightDefault.default));
parcelHelpers.export(exports, "AlignmentTop", ()=>(0, _alignmentTopDefault.default));
parcelHelpers.export(exports, "AlignmentVerticalCenter", ()=>(0, _alignmentVerticalCenterDefault.default));
parcelHelpers.export(exports, "Ammunition", ()=>(0, _ammunitionDefault.default));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchorDefault.default));
parcelHelpers.export(exports, "Annotation", ()=>(0, _annotationDefault.default));
parcelHelpers.export(exports, "Antenna", ()=>(0, _antennaDefault.default));
parcelHelpers.export(exports, "AppHeader", ()=>(0, _appHeaderDefault.default));
parcelHelpers.export(exports, "Application", ()=>(0, _applicationDefault.default));
parcelHelpers.export(exports, "Applications", ()=>(0, _applicationsDefault.default));
parcelHelpers.export(exports, "Archive", ()=>(0, _archiveDefault.default));
parcelHelpers.export(exports, "AreaOfInterest", ()=>(0, _areaOfInterestDefault.default));
parcelHelpers.export(exports, "Array", ()=>(0, _arrayDefault.default));
parcelHelpers.export(exports, "ArrayBoolean", ()=>(0, _arrayBooleanDefault.default));
parcelHelpers.export(exports, "ArrayDate", ()=>(0, _arrayDateDefault.default));
parcelHelpers.export(exports, "ArrayFloatingPoint", ()=>(0, _arrayFloatingPointDefault.default));
parcelHelpers.export(exports, "ArrayNumeric", ()=>(0, _arrayNumericDefault.default));
parcelHelpers.export(exports, "ArrayString", ()=>(0, _arrayStringDefault.default));
parcelHelpers.export(exports, "ArrayTimestamp", ()=>(0, _arrayTimestampDefault.default));
parcelHelpers.export(exports, "ArrowBottomLeft", ()=>(0, _arrowBottomLeftDefault.default));
parcelHelpers.export(exports, "ArrowBottomRight", ()=>(0, _arrowBottomRightDefault.default));
parcelHelpers.export(exports, "ArrowDown", ()=>(0, _arrowDownDefault.default));
parcelHelpers.export(exports, "ArrowLeft", ()=>(0, _arrowLeftDefault.default));
parcelHelpers.export(exports, "ArrowRight", ()=>(0, _arrowRightDefault.default));
parcelHelpers.export(exports, "ArrowTopLeft", ()=>(0, _arrowTopLeftDefault.default));
parcelHelpers.export(exports, "ArrowTopRight", ()=>(0, _arrowTopRightDefault.default));
parcelHelpers.export(exports, "ArrowUp", ()=>(0, _arrowUpDefault.default));
parcelHelpers.export(exports, "ArrowsArc", ()=>(0, _arrowsArcDefault.default));
parcelHelpers.export(exports, "ArrowsHorizontal", ()=>(0, _arrowsHorizontalDefault.default));
parcelHelpers.export(exports, "ArrowsVertical", ()=>(0, _arrowsVerticalDefault.default));
parcelHelpers.export(exports, "Asterisk", ()=>(0, _asteriskDefault.default));
parcelHelpers.export(exports, "At", ()=>(0, _atDefault.default));
parcelHelpers.export(exports, "AutomaticUpdates", ()=>(0, _automaticUpdatesDefault.default));
parcelHelpers.export(exports, "Axle", ()=>(0, _axleDefault.default));
parcelHelpers.export(exports, "Backlink", ()=>(0, _backlinkDefault.default));
parcelHelpers.export(exports, "BackwardTen", ()=>(0, _backwardTenDefault.default));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeDefault.default));
parcelHelpers.export(exports, "BanCircle", ()=>(0, _banCircleDefault.default));
parcelHelpers.export(exports, "BankAccount", ()=>(0, _bankAccountDefault.default));
parcelHelpers.export(exports, "Barcode", ()=>(0, _barcodeDefault.default));
parcelHelpers.export(exports, "BinaryNumber", ()=>(0, _binaryNumberDefault.default));
parcelHelpers.export(exports, "Blank", ()=>(0, _blankDefault.default));
parcelHelpers.export(exports, "BlockPromote", ()=>(0, _blockPromoteDefault.default));
parcelHelpers.export(exports, "BlockedPerson", ()=>(0, _blockedPersonDefault.default));
parcelHelpers.export(exports, "Bold", ()=>(0, _boldDefault.default));
parcelHelpers.export(exports, "Book", ()=>(0, _bookDefault.default));
parcelHelpers.export(exports, "Bookmark", ()=>(0, _bookmarkDefault.default));
parcelHelpers.export(exports, "Box", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "Briefcase", ()=>(0, _briefcaseDefault.default));
parcelHelpers.export(exports, "BringData", ()=>(0, _bringDataDefault.default));
parcelHelpers.export(exports, "BringForward", ()=>(0, _bringForwardDefault.default));
parcelHelpers.export(exports, "BritishPound", ()=>(0, _britishPoundDefault.default));
parcelHelpers.export(exports, "Bug", ()=>(0, _bugDefault.default));
parcelHelpers.export(exports, "Buggy", ()=>(0, _buggyDefault.default));
parcelHelpers.export(exports, "Build", ()=>(0, _buildDefault.default));
parcelHelpers.export(exports, "Bullseye", ()=>(0, _bullseyeDefault.default));
parcelHelpers.export(exports, "Calculator", ()=>(0, _calculatorDefault.default));
parcelHelpers.export(exports, "Calendar", ()=>(0, _calendarDefault.default));
parcelHelpers.export(exports, "Camera", ()=>(0, _cameraDefault.default));
parcelHelpers.export(exports, "CaretDown", ()=>(0, _caretDownDefault.default));
parcelHelpers.export(exports, "CaretLeft", ()=>(0, _caretLeftDefault.default));
parcelHelpers.export(exports, "CaretRight", ()=>(0, _caretRightDefault.default));
parcelHelpers.export(exports, "CaretUp", ()=>(0, _caretUpDefault.default));
parcelHelpers.export(exports, "CargoShip", ()=>(0, _cargoShipDefault.default));
parcelHelpers.export(exports, "CellTower", ()=>(0, _cellTowerDefault.default));
parcelHelpers.export(exports, "Changes", ()=>(0, _changesDefault.default));
parcelHelpers.export(exports, "Chart", ()=>(0, _chartDefault.default));
parcelHelpers.export(exports, "Chat", ()=>(0, _chatDefault.default));
parcelHelpers.export(exports, "ChevronBackward", ()=>(0, _chevronBackwardDefault.default));
parcelHelpers.export(exports, "ChevronDown", ()=>(0, _chevronDownDefault.default));
parcelHelpers.export(exports, "ChevronForward", ()=>(0, _chevronForwardDefault.default));
parcelHelpers.export(exports, "ChevronLeft", ()=>(0, _chevronLeftDefault.default));
parcelHelpers.export(exports, "ChevronRight", ()=>(0, _chevronRightDefault.default));
parcelHelpers.export(exports, "ChevronUp", ()=>(0, _chevronUpDefault.default));
parcelHelpers.export(exports, "Circle", ()=>(0, _circleDefault.default));
parcelHelpers.export(exports, "CircleArrowDown", ()=>(0, _circleArrowDownDefault.default));
parcelHelpers.export(exports, "CircleArrowLeft", ()=>(0, _circleArrowLeftDefault.default));
parcelHelpers.export(exports, "CircleArrowRight", ()=>(0, _circleArrowRightDefault.default));
parcelHelpers.export(exports, "CircleArrowUp", ()=>(0, _circleArrowUpDefault.default));
parcelHelpers.export(exports, "Citation", ()=>(0, _citationDefault.default));
parcelHelpers.export(exports, "Clean", ()=>(0, _cleanDefault.default));
parcelHelpers.export(exports, "Clip", ()=>(0, _clipDefault.default));
parcelHelpers.export(exports, "Clipboard", ()=>(0, _clipboardDefault.default));
parcelHelpers.export(exports, "ClipboardFile", ()=>(0, _clipboardFileDefault.default));
parcelHelpers.export(exports, "Cloud", ()=>(0, _cloudDefault.default));
parcelHelpers.export(exports, "CloudDownload", ()=>(0, _cloudDownloadDefault.default));
parcelHelpers.export(exports, "CloudServer", ()=>(0, _cloudServerDefault.default));
parcelHelpers.export(exports, "CloudTick", ()=>(0, _cloudTickDefault.default));
parcelHelpers.export(exports, "CloudUpload", ()=>(0, _cloudUploadDefault.default));
parcelHelpers.export(exports, "Code", ()=>(0, _codeDefault.default));
parcelHelpers.export(exports, "CodeBlock", ()=>(0, _codeBlockDefault.default));
parcelHelpers.export(exports, "Cog", ()=>(0, _cogDefault.default));
parcelHelpers.export(exports, "CollapseAll", ()=>(0, _collapseAllDefault.default));
parcelHelpers.export(exports, "ColorFill", ()=>(0, _colorFillDefault.default));
parcelHelpers.export(exports, "ColumnLayout", ()=>(0, _columnLayoutDefault.default));
parcelHelpers.export(exports, "Comment", ()=>(0, _commentDefault.default));
parcelHelpers.export(exports, "Comparison", ()=>(0, _comparisonDefault.default));
parcelHelpers.export(exports, "Compass", ()=>(0, _compassDefault.default));
parcelHelpers.export(exports, "Compressed", ()=>(0, _compressedDefault.default));
parcelHelpers.export(exports, "Confirm", ()=>(0, _confirmDefault.default));
parcelHelpers.export(exports, "Console", ()=>(0, _consoleDefault.default));
parcelHelpers.export(exports, "Contrast", ()=>(0, _contrastDefault.default));
parcelHelpers.export(exports, "Control", ()=>(0, _controlDefault.default));
parcelHelpers.export(exports, "CreditCard", ()=>(0, _creditCardDefault.default));
parcelHelpers.export(exports, "Crop", ()=>(0, _cropDefault.default));
parcelHelpers.export(exports, "Cross", ()=>(0, _crossDefault.default));
parcelHelpers.export(exports, "CrossCircle", ()=>(0, _crossCircleDefault.default));
parcelHelpers.export(exports, "Crown", ()=>(0, _crownDefault.default));
parcelHelpers.export(exports, "CssStyle", ()=>(0, _cssStyleDefault.default));
parcelHelpers.export(exports, "Cube", ()=>(0, _cubeDefault.default));
parcelHelpers.export(exports, "CubeAdd", ()=>(0, _cubeAddDefault.default));
parcelHelpers.export(exports, "CubeEdit", ()=>(0, _cubeEditDefault.default));
parcelHelpers.export(exports, "CubeRemove", ()=>(0, _cubeRemoveDefault.default));
parcelHelpers.export(exports, "Cubes", ()=>(0, _cubesDefault.default));
parcelHelpers.export(exports, "CurlyBraces", ()=>(0, _curlyBracesDefault.default));
parcelHelpers.export(exports, "CurvedRangeChart", ()=>(0, _curvedRangeChartDefault.default));
parcelHelpers.export(exports, "Cut", ()=>(0, _cutDefault.default));
parcelHelpers.export(exports, "Cycle", ()=>(0, _cycleDefault.default));
parcelHelpers.export(exports, "Dashboard", ()=>(0, _dashboardDefault.default));
parcelHelpers.export(exports, "DataConnection", ()=>(0, _dataConnectionDefault.default));
parcelHelpers.export(exports, "DataLineage", ()=>(0, _dataLineageDefault.default));
parcelHelpers.export(exports, "DataSearch", ()=>(0, _dataSearchDefault.default));
parcelHelpers.export(exports, "DataSync", ()=>(0, _dataSyncDefault.default));
parcelHelpers.export(exports, "Database", ()=>(0, _databaseDefault.default));
parcelHelpers.export(exports, "Delete", ()=>(0, _deleteDefault.default));
parcelHelpers.export(exports, "Delta", ()=>(0, _deltaDefault.default));
parcelHelpers.export(exports, "DeriveColumn", ()=>(0, _deriveColumnDefault.default));
parcelHelpers.export(exports, "Desktop", ()=>(0, _desktopDefault.default));
parcelHelpers.export(exports, "Detection", ()=>(0, _detectionDefault.default));
parcelHelpers.export(exports, "Diagnosis", ()=>(0, _diagnosisDefault.default));
parcelHelpers.export(exports, "DiagramTree", ()=>(0, _diagramTreeDefault.default));
parcelHelpers.export(exports, "DirectionLeft", ()=>(0, _directionLeftDefault.default));
parcelHelpers.export(exports, "DirectionRight", ()=>(0, _directionRightDefault.default));
parcelHelpers.export(exports, "Disable", ()=>(0, _disableDefault.default));
parcelHelpers.export(exports, "Divide", ()=>(0, _divideDefault.default));
parcelHelpers.export(exports, "Document", ()=>(0, _documentDefault.default));
parcelHelpers.export(exports, "DocumentOpen", ()=>(0, _documentOpenDefault.default));
parcelHelpers.export(exports, "DocumentShare", ()=>(0, _documentShareDefault.default));
parcelHelpers.export(exports, "Dollar", ()=>(0, _dollarDefault.default));
parcelHelpers.export(exports, "Dot", ()=>(0, _dotDefault.default));
parcelHelpers.export(exports, "DoubleCaretHorizontal", ()=>(0, _doubleCaretHorizontalDefault.default));
parcelHelpers.export(exports, "DoubleCaretVertical", ()=>(0, _doubleCaretVerticalDefault.default));
parcelHelpers.export(exports, "DoubleChevronDown", ()=>(0, _doubleChevronDownDefault.default));
parcelHelpers.export(exports, "DoubleChevronLeft", ()=>(0, _doubleChevronLeftDefault.default));
parcelHelpers.export(exports, "DoubleChevronRight", ()=>(0, _doubleChevronRightDefault.default));
parcelHelpers.export(exports, "DoubleChevronUp", ()=>(0, _doubleChevronUpDefault.default));
parcelHelpers.export(exports, "DoughnutChart", ()=>(0, _doughnutChartDefault.default));
parcelHelpers.export(exports, "Download", ()=>(0, _downloadDefault.default));
parcelHelpers.export(exports, "DragHandleHorizontal", ()=>(0, _dragHandleHorizontalDefault.default));
parcelHelpers.export(exports, "DragHandleVertical", ()=>(0, _dragHandleVerticalDefault.default));
parcelHelpers.export(exports, "Draw", ()=>(0, _drawDefault.default));
parcelHelpers.export(exports, "DrawerLeft", ()=>(0, _drawerLeftDefault.default));
parcelHelpers.export(exports, "DrawerLeftFilled", ()=>(0, _drawerLeftFilledDefault.default));
parcelHelpers.export(exports, "DrawerRight", ()=>(0, _drawerRightDefault.default));
parcelHelpers.export(exports, "DrawerRightFilled", ()=>(0, _drawerRightFilledDefault.default));
parcelHelpers.export(exports, "DriveTime", ()=>(0, _driveTimeDefault.default));
parcelHelpers.export(exports, "Duplicate", ()=>(0, _duplicateDefault.default));
parcelHelpers.export(exports, "Edit", ()=>(0, _editDefault.default));
parcelHelpers.export(exports, "Eject", ()=>(0, _ejectDefault.default));
parcelHelpers.export(exports, "Emoji", ()=>(0, _emojiDefault.default));
parcelHelpers.export(exports, "Endnote", ()=>(0, _endnoteDefault.default));
parcelHelpers.export(exports, "Endorsed", ()=>(0, _endorsedDefault.default));
parcelHelpers.export(exports, "Envelope", ()=>(0, _envelopeDefault.default));
parcelHelpers.export(exports, "Equals", ()=>(0, _equalsDefault.default));
parcelHelpers.export(exports, "Eraser", ()=>(0, _eraserDefault.default));
parcelHelpers.export(exports, "Error", ()=>(0, _errorDefault.default));
parcelHelpers.export(exports, "Euro", ()=>(0, _euroDefault.default));
parcelHelpers.export(exports, "Excavator", ()=>(0, _excavatorDefault.default));
parcelHelpers.export(exports, "Exchange", ()=>(0, _exchangeDefault.default));
parcelHelpers.export(exports, "ExcludeRow", ()=>(0, _excludeRowDefault.default));
parcelHelpers.export(exports, "ExpandAll", ()=>(0, _expandAllDefault.default));
parcelHelpers.export(exports, "Explain", ()=>(0, _explainDefault.default));
parcelHelpers.export(exports, "Export", ()=>(0, _exportDefault.default));
parcelHelpers.export(exports, "EyeOff", ()=>(0, _eyeOffDefault.default));
parcelHelpers.export(exports, "EyeOn", ()=>(0, _eyeOnDefault.default));
parcelHelpers.export(exports, "EyeOpen", ()=>(0, _eyeOpenDefault.default));
parcelHelpers.export(exports, "FastBackward", ()=>(0, _fastBackwardDefault.default));
parcelHelpers.export(exports, "FastForward", ()=>(0, _fastForwardDefault.default));
parcelHelpers.export(exports, "Feed", ()=>(0, _feedDefault.default));
parcelHelpers.export(exports, "FeedSubscribed", ()=>(0, _feedSubscribedDefault.default));
parcelHelpers.export(exports, "FighterJet", ()=>(0, _fighterJetDefault.default));
parcelHelpers.export(exports, "Film", ()=>(0, _filmDefault.default));
parcelHelpers.export(exports, "Filter", ()=>(0, _filterDefault.default));
parcelHelpers.export(exports, "FilterKeep", ()=>(0, _filterKeepDefault.default));
parcelHelpers.export(exports, "FilterList", ()=>(0, _filterListDefault.default));
parcelHelpers.export(exports, "FilterOpen", ()=>(0, _filterOpenDefault.default));
parcelHelpers.export(exports, "FilterRemove", ()=>(0, _filterRemoveDefault.default));
parcelHelpers.export(exports, "FilterSortAsc", ()=>(0, _filterSortAscDefault.default));
parcelHelpers.export(exports, "FilterSortDesc", ()=>(0, _filterSortDescDefault.default));
parcelHelpers.export(exports, "Flag", ()=>(0, _flagDefault.default));
parcelHelpers.export(exports, "Flame", ()=>(0, _flameDefault.default));
parcelHelpers.export(exports, "Flash", ()=>(0, _flashDefault.default));
parcelHelpers.export(exports, "FloatingPoint", ()=>(0, _floatingPointDefault.default));
parcelHelpers.export(exports, "FloppyDisk", ()=>(0, _floppyDiskDefault.default));
parcelHelpers.export(exports, "FlowBranch", ()=>(0, _flowBranchDefault.default));
parcelHelpers.export(exports, "FlowEnd", ()=>(0, _flowEndDefault.default));
parcelHelpers.export(exports, "FlowLinear", ()=>(0, _flowLinearDefault.default));
parcelHelpers.export(exports, "FlowReview", ()=>(0, _flowReviewDefault.default));
parcelHelpers.export(exports, "FlowReviewBranch", ()=>(0, _flowReviewBranchDefault.default));
parcelHelpers.export(exports, "Flows", ()=>(0, _flowsDefault.default));
parcelHelpers.export(exports, "FolderClose", ()=>(0, _folderCloseDefault.default));
parcelHelpers.export(exports, "FolderNew", ()=>(0, _folderNewDefault.default));
parcelHelpers.export(exports, "FolderOpen", ()=>(0, _folderOpenDefault.default));
parcelHelpers.export(exports, "FolderShared", ()=>(0, _folderSharedDefault.default));
parcelHelpers.export(exports, "FolderSharedOpen", ()=>(0, _folderSharedOpenDefault.default));
parcelHelpers.export(exports, "Follower", ()=>(0, _followerDefault.default));
parcelHelpers.export(exports, "Following", ()=>(0, _followingDefault.default));
parcelHelpers.export(exports, "Font", ()=>(0, _fontDefault.default));
parcelHelpers.export(exports, "Fork", ()=>(0, _forkDefault.default));
parcelHelpers.export(exports, "Form", ()=>(0, _formDefault.default));
parcelHelpers.export(exports, "ForwardTen", ()=>(0, _forwardTenDefault.default));
parcelHelpers.export(exports, "Fuel", ()=>(0, _fuelDefault.default));
parcelHelpers.export(exports, "FullCircle", ()=>(0, _fullCircleDefault.default));
parcelHelpers.export(exports, "FullStackedChart", ()=>(0, _fullStackedChartDefault.default));
parcelHelpers.export(exports, "Fullscreen", ()=>(0, _fullscreenDefault.default));
parcelHelpers.export(exports, "Function", ()=>(0, _functionDefault.default));
parcelHelpers.export(exports, "GanttChart", ()=>(0, _ganttChartDefault.default));
parcelHelpers.export(exports, "Generate", ()=>(0, _generateDefault.default));
parcelHelpers.export(exports, "Geofence", ()=>(0, _geofenceDefault.default));
parcelHelpers.export(exports, "Geolocation", ()=>(0, _geolocationDefault.default));
parcelHelpers.export(exports, "Geosearch", ()=>(0, _geosearchDefault.default));
parcelHelpers.export(exports, "Geotime", ()=>(0, _geotimeDefault.default));
parcelHelpers.export(exports, "GitBranch", ()=>(0, _gitBranchDefault.default));
parcelHelpers.export(exports, "GitCommit", ()=>(0, _gitCommitDefault.default));
parcelHelpers.export(exports, "GitMerge", ()=>(0, _gitMergeDefault.default));
parcelHelpers.export(exports, "GitNewBranch", ()=>(0, _gitNewBranchDefault.default));
parcelHelpers.export(exports, "GitPull", ()=>(0, _gitPullDefault.default));
parcelHelpers.export(exports, "GitPush", ()=>(0, _gitPushDefault.default));
parcelHelpers.export(exports, "GitRepo", ()=>(0, _gitRepoDefault.default));
parcelHelpers.export(exports, "Glass", ()=>(0, _glassDefault.default));
parcelHelpers.export(exports, "Globe", ()=>(0, _globeDefault.default));
parcelHelpers.export(exports, "GlobeNetwork", ()=>(0, _globeNetworkDefault.default));
parcelHelpers.export(exports, "GlobeNetworkAdd", ()=>(0, _globeNetworkAddDefault.default));
parcelHelpers.export(exports, "Graph", ()=>(0, _graphDefault.default));
parcelHelpers.export(exports, "GraphRemove", ()=>(0, _graphRemoveDefault.default));
parcelHelpers.export(exports, "GreaterThan", ()=>(0, _greaterThanDefault.default));
parcelHelpers.export(exports, "GreaterThanOrEqualTo", ()=>(0, _greaterThanOrEqualToDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "GridView", ()=>(0, _gridViewDefault.default));
parcelHelpers.export(exports, "GroupItem", ()=>(0, _groupItemDefault.default));
parcelHelpers.export(exports, "GroupObjects", ()=>(0, _groupObjectsDefault.default));
parcelHelpers.export(exports, "GroupedBarChart", ()=>(0, _groupedBarChartDefault.default));
parcelHelpers.export(exports, "Hand", ()=>(0, _handDefault.default));
parcelHelpers.export(exports, "HandDown", ()=>(0, _handDownDefault.default));
parcelHelpers.export(exports, "HandLeft", ()=>(0, _handLeftDefault.default));
parcelHelpers.export(exports, "HandRight", ()=>(0, _handRightDefault.default));
parcelHelpers.export(exports, "HandUp", ()=>(0, _handUpDefault.default));
parcelHelpers.export(exports, "Hat", ()=>(0, _hatDefault.default));
parcelHelpers.export(exports, "Header", ()=>(0, _headerDefault.default));
parcelHelpers.export(exports, "HeaderOne", ()=>(0, _headerOneDefault.default));
parcelHelpers.export(exports, "HeaderThree", ()=>(0, _headerThreeDefault.default));
parcelHelpers.export(exports, "HeaderTwo", ()=>(0, _headerTwoDefault.default));
parcelHelpers.export(exports, "Headset", ()=>(0, _headsetDefault.default));
parcelHelpers.export(exports, "Heart", ()=>(0, _heartDefault.default));
parcelHelpers.export(exports, "HeartBroken", ()=>(0, _heartBrokenDefault.default));
parcelHelpers.export(exports, "HeatGrid", ()=>(0, _heatGridDefault.default));
parcelHelpers.export(exports, "Heatmap", ()=>(0, _heatmapDefault.default));
parcelHelpers.export(exports, "Helicopter", ()=>(0, _helicopterDefault.default));
parcelHelpers.export(exports, "Help", ()=>(0, _helpDefault.default));
parcelHelpers.export(exports, "HelperManagement", ()=>(0, _helperManagementDefault.default));
parcelHelpers.export(exports, "Hexagon", ()=>(0, _hexagonDefault.default));
parcelHelpers.export(exports, "HighPriority", ()=>(0, _highPriorityDefault.default));
parcelHelpers.export(exports, "HighVoltagePole", ()=>(0, _highVoltagePoleDefault.default));
parcelHelpers.export(exports, "Highlight", ()=>(0, _highlightDefault.default));
parcelHelpers.export(exports, "History", ()=>(0, _historyDefault.default));
parcelHelpers.export(exports, "Home", ()=>(0, _homeDefault.default));
parcelHelpers.export(exports, "HorizontalBarChart", ()=>(0, _horizontalBarChartDefault.default));
parcelHelpers.export(exports, "HorizontalBarChartAsc", ()=>(0, _horizontalBarChartAscDefault.default));
parcelHelpers.export(exports, "HorizontalBarChartDesc", ()=>(0, _horizontalBarChartDescDefault.default));
parcelHelpers.export(exports, "HorizontalDistribution", ()=>(0, _horizontalDistributionDefault.default));
parcelHelpers.export(exports, "HorizontalInbetween", ()=>(0, _horizontalInbetweenDefault.default));
parcelHelpers.export(exports, "Hurricane", ()=>(0, _hurricaneDefault.default));
parcelHelpers.export(exports, "IdNumber", ()=>(0, _idNumberDefault.default));
parcelHelpers.export(exports, "ImageRotateLeft", ()=>(0, _imageRotateLeftDefault.default));
parcelHelpers.export(exports, "ImageRotateRight", ()=>(0, _imageRotateRightDefault.default));
parcelHelpers.export(exports, "Import", ()=>(0, _importDefault.default));
parcelHelpers.export(exports, "Inbox", ()=>(0, _inboxDefault.default));
parcelHelpers.export(exports, "InboxFiltered", ()=>(0, _inboxFilteredDefault.default));
parcelHelpers.export(exports, "InboxGeo", ()=>(0, _inboxGeoDefault.default));
parcelHelpers.export(exports, "InboxSearch", ()=>(0, _inboxSearchDefault.default));
parcelHelpers.export(exports, "InboxUpdate", ()=>(0, _inboxUpdateDefault.default));
parcelHelpers.export(exports, "InfoSign", ()=>(0, _infoSignDefault.default));
parcelHelpers.export(exports, "Inheritance", ()=>(0, _inheritanceDefault.default));
parcelHelpers.export(exports, "InheritedGroup", ()=>(0, _inheritedGroupDefault.default));
parcelHelpers.export(exports, "InnerJoin", ()=>(0, _innerJoinDefault.default));
parcelHelpers.export(exports, "Input", ()=>(0, _inputDefault.default));
parcelHelpers.export(exports, "Insert", ()=>(0, _insertDefault.default));
parcelHelpers.export(exports, "Intelligence", ()=>(0, _intelligenceDefault.default));
parcelHelpers.export(exports, "Intersection", ()=>(0, _intersectionDefault.default));
parcelHelpers.export(exports, "IpAddress", ()=>(0, _ipAddressDefault.default));
parcelHelpers.export(exports, "Issue", ()=>(0, _issueDefault.default));
parcelHelpers.export(exports, "IssueClosed", ()=>(0, _issueClosedDefault.default));
parcelHelpers.export(exports, "IssueNew", ()=>(0, _issueNewDefault.default));
parcelHelpers.export(exports, "Italic", ()=>(0, _italicDefault.default));
parcelHelpers.export(exports, "JoinTable", ()=>(0, _joinTableDefault.default));
parcelHelpers.export(exports, "Key", ()=>(0, _keyDefault.default));
parcelHelpers.export(exports, "KeyBackspace", ()=>(0, _keyBackspaceDefault.default));
parcelHelpers.export(exports, "KeyCommand", ()=>(0, _keyCommandDefault.default));
parcelHelpers.export(exports, "KeyControl", ()=>(0, _keyControlDefault.default));
parcelHelpers.export(exports, "KeyDelete", ()=>(0, _keyDeleteDefault.default));
parcelHelpers.export(exports, "KeyEnter", ()=>(0, _keyEnterDefault.default));
parcelHelpers.export(exports, "KeyEscape", ()=>(0, _keyEscapeDefault.default));
parcelHelpers.export(exports, "KeyOption", ()=>(0, _keyOptionDefault.default));
parcelHelpers.export(exports, "KeyShift", ()=>(0, _keyShiftDefault.default));
parcelHelpers.export(exports, "KeyTab", ()=>(0, _keyTabDefault.default));
parcelHelpers.export(exports, "KnownVehicle", ()=>(0, _knownVehicleDefault.default));
parcelHelpers.export(exports, "LabTest", ()=>(0, _labTestDefault.default));
parcelHelpers.export(exports, "Label", ()=>(0, _labelDefault.default));
parcelHelpers.export(exports, "Layer", ()=>(0, _layerDefault.default));
parcelHelpers.export(exports, "LayerOutline", ()=>(0, _layerOutlineDefault.default));
parcelHelpers.export(exports, "Layers", ()=>(0, _layersDefault.default));
parcelHelpers.export(exports, "Layout", ()=>(0, _layoutDefault.default));
parcelHelpers.export(exports, "LayoutAuto", ()=>(0, _layoutAutoDefault.default));
parcelHelpers.export(exports, "LayoutBalloon", ()=>(0, _layoutBalloonDefault.default));
parcelHelpers.export(exports, "LayoutBottomRowThreeTiles", ()=>(0, _layoutBottomRowThreeTilesDefault.default));
parcelHelpers.export(exports, "LayoutBottomRowTwoTiles", ()=>(0, _layoutBottomRowTwoTilesDefault.default));
parcelHelpers.export(exports, "LayoutCircle", ()=>(0, _layoutCircleDefault.default));
parcelHelpers.export(exports, "LayoutGrid", ()=>(0, _layoutGridDefault.default));
parcelHelpers.export(exports, "LayoutGroupBy", ()=>(0, _layoutGroupByDefault.default));
parcelHelpers.export(exports, "LayoutHierarchy", ()=>(0, _layoutHierarchyDefault.default));
parcelHelpers.export(exports, "LayoutLeftColumnThreeTiles", ()=>(0, _layoutLeftColumnThreeTilesDefault.default));
parcelHelpers.export(exports, "LayoutLeftColumnTwoTiles", ()=>(0, _layoutLeftColumnTwoTilesDefault.default));
parcelHelpers.export(exports, "LayoutLinear", ()=>(0, _layoutLinearDefault.default));
parcelHelpers.export(exports, "LayoutRightColumnThreeTiles", ()=>(0, _layoutRightColumnThreeTilesDefault.default));
parcelHelpers.export(exports, "LayoutRightColumnTwoTiles", ()=>(0, _layoutRightColumnTwoTilesDefault.default));
parcelHelpers.export(exports, "LayoutSkewGrid", ()=>(0, _layoutSkewGridDefault.default));
parcelHelpers.export(exports, "LayoutSortedClusters", ()=>(0, _layoutSortedClustersDefault.default));
parcelHelpers.export(exports, "LayoutThreeColumns", ()=>(0, _layoutThreeColumnsDefault.default));
parcelHelpers.export(exports, "LayoutThreeRows", ()=>(0, _layoutThreeRowsDefault.default));
parcelHelpers.export(exports, "LayoutTopRowThreeTiles", ()=>(0, _layoutTopRowThreeTilesDefault.default));
parcelHelpers.export(exports, "LayoutTopRowTwoTiles", ()=>(0, _layoutTopRowTwoTilesDefault.default));
parcelHelpers.export(exports, "LayoutTwoColumns", ()=>(0, _layoutTwoColumnsDefault.default));
parcelHelpers.export(exports, "LayoutTwoRows", ()=>(0, _layoutTwoRowsDefault.default));
parcelHelpers.export(exports, "Learning", ()=>(0, _learningDefault.default));
parcelHelpers.export(exports, "LeftJoin", ()=>(0, _leftJoinDefault.default));
parcelHelpers.export(exports, "LengthenText", ()=>(0, _lengthenTextDefault.default));
parcelHelpers.export(exports, "LessThan", ()=>(0, _lessThanDefault.default));
parcelHelpers.export(exports, "LessThanOrEqualTo", ()=>(0, _lessThanOrEqualToDefault.default));
parcelHelpers.export(exports, "Lifesaver", ()=>(0, _lifesaverDefault.default));
parcelHelpers.export(exports, "Lightbulb", ()=>(0, _lightbulbDefault.default));
parcelHelpers.export(exports, "Lightning", ()=>(0, _lightningDefault.default));
parcelHelpers.export(exports, "Link", ()=>(0, _linkDefault.default));
parcelHelpers.export(exports, "LinkedSquares", ()=>(0, _linkedSquaresDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "ListColumns", ()=>(0, _listColumnsDefault.default));
parcelHelpers.export(exports, "ListDetailView", ()=>(0, _listDetailViewDefault.default));
parcelHelpers.export(exports, "Locate", ()=>(0, _locateDefault.default));
parcelHelpers.export(exports, "Lock", ()=>(0, _lockDefault.default));
parcelHelpers.export(exports, "Locomotive", ()=>(0, _locomotiveDefault.default));
parcelHelpers.export(exports, "LogIn", ()=>(0, _logInDefault.default));
parcelHelpers.export(exports, "LogOut", ()=>(0, _logOutDefault.default));
parcelHelpers.export(exports, "LowVoltagePole", ()=>(0, _lowVoltagePoleDefault.default));
parcelHelpers.export(exports, "Manual", ()=>(0, _manualDefault.default));
parcelHelpers.export(exports, "ManuallyEnteredData", ()=>(0, _manuallyEnteredDataDefault.default));
parcelHelpers.export(exports, "ManyToMany", ()=>(0, _manyToManyDefault.default));
parcelHelpers.export(exports, "ManyToOne", ()=>(0, _manyToOneDefault.default));
parcelHelpers.export(exports, "Map", ()=>(0, _mapDefault.default));
parcelHelpers.export(exports, "MapCreate", ()=>(0, _mapCreateDefault.default));
parcelHelpers.export(exports, "MapMarker", ()=>(0, _mapMarkerDefault.default));
parcelHelpers.export(exports, "Maximize", ()=>(0, _maximizeDefault.default));
parcelHelpers.export(exports, "Media", ()=>(0, _mediaDefault.default));
parcelHelpers.export(exports, "Menu", ()=>(0, _menuDefault.default));
parcelHelpers.export(exports, "MenuClosed", ()=>(0, _menuClosedDefault.default));
parcelHelpers.export(exports, "MenuOpen", ()=>(0, _menuOpenDefault.default));
parcelHelpers.export(exports, "MergeColumns", ()=>(0, _mergeColumnsDefault.default));
parcelHelpers.export(exports, "MergeLinks", ()=>(0, _mergeLinksDefault.default));
parcelHelpers.export(exports, "Microphone", ()=>(0, _microphoneDefault.default));
parcelHelpers.export(exports, "Minimize", ()=>(0, _minimizeDefault.default));
parcelHelpers.export(exports, "Minus", ()=>(0, _minusDefault.default));
parcelHelpers.export(exports, "MobilePhone", ()=>(0, _mobilePhoneDefault.default));
parcelHelpers.export(exports, "MobileVideo", ()=>(0, _mobileVideoDefault.default));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "ModalFilled", ()=>(0, _modalFilledDefault.default));
parcelHelpers.export(exports, "Model", ()=>(0, _modelDefault.default));
parcelHelpers.export(exports, "Moon", ()=>(0, _moonDefault.default));
parcelHelpers.export(exports, "More", ()=>(0, _moreDefault.default));
parcelHelpers.export(exports, "Mountain", ()=>(0, _mountainDefault.default));
parcelHelpers.export(exports, "Move", ()=>(0, _moveDefault.default));
parcelHelpers.export(exports, "Mugshot", ()=>(0, _mugshotDefault.default));
parcelHelpers.export(exports, "MultiSelect", ()=>(0, _multiSelectDefault.default));
parcelHelpers.export(exports, "Music", ()=>(0, _musicDefault.default));
parcelHelpers.export(exports, "Nest", ()=>(0, _nestDefault.default));
parcelHelpers.export(exports, "NewDrawing", ()=>(0, _newDrawingDefault.default));
parcelHelpers.export(exports, "NewGridItem", ()=>(0, _newGridItemDefault.default));
parcelHelpers.export(exports, "NewLayer", ()=>(0, _newLayerDefault.default));
parcelHelpers.export(exports, "NewLayers", ()=>(0, _newLayersDefault.default));
parcelHelpers.export(exports, "NewLink", ()=>(0, _newLinkDefault.default));
parcelHelpers.export(exports, "NewObject", ()=>(0, _newObjectDefault.default));
parcelHelpers.export(exports, "NewPerson", ()=>(0, _newPersonDefault.default));
parcelHelpers.export(exports, "NewPrescription", ()=>(0, _newPrescriptionDefault.default));
parcelHelpers.export(exports, "NewShield", ()=>(0, _newShieldDefault.default));
parcelHelpers.export(exports, "NewTextBox", ()=>(0, _newTextBoxDefault.default));
parcelHelpers.export(exports, "Ninja", ()=>(0, _ninjaDefault.default));
parcelHelpers.export(exports, "NotEqualTo", ()=>(0, _notEqualToDefault.default));
parcelHelpers.export(exports, "Notifications", ()=>(0, _notificationsDefault.default));
parcelHelpers.export(exports, "NotificationsSnooze", ()=>(0, _notificationsSnoozeDefault.default));
parcelHelpers.export(exports, "NotificationsUpdated", ()=>(0, _notificationsUpdatedDefault.default));
parcelHelpers.export(exports, "NumberedList", ()=>(0, _numberedListDefault.default));
parcelHelpers.export(exports, "Numerical", ()=>(0, _numericalDefault.default));
parcelHelpers.export(exports, "ObjectView", ()=>(0, _objectViewDefault.default));
parcelHelpers.export(exports, "Office", ()=>(0, _officeDefault.default));
parcelHelpers.export(exports, "Offline", ()=>(0, _offlineDefault.default));
parcelHelpers.export(exports, "OilField", ()=>(0, _oilFieldDefault.default));
parcelHelpers.export(exports, "OneColumn", ()=>(0, _oneColumnDefault.default));
parcelHelpers.export(exports, "OneToMany", ()=>(0, _oneToManyDefault.default));
parcelHelpers.export(exports, "OneToOne", ()=>(0, _oneToOneDefault.default));
parcelHelpers.export(exports, "OpenApplication", ()=>(0, _openApplicationDefault.default));
parcelHelpers.export(exports, "Outdated", ()=>(0, _outdatedDefault.default));
parcelHelpers.export(exports, "Output", ()=>(0, _outputDefault.default));
parcelHelpers.export(exports, "Package", ()=>(0, _packageDefault.default));
parcelHelpers.export(exports, "PageLayout", ()=>(0, _pageLayoutDefault.default));
parcelHelpers.export(exports, "Panel", ()=>(0, _panelDefault.default));
parcelHelpers.export(exports, "PanelStats", ()=>(0, _panelStatsDefault.default));
parcelHelpers.export(exports, "PanelTable", ()=>(0, _panelTableDefault.default));
parcelHelpers.export(exports, "Paperclip", ()=>(0, _paperclipDefault.default));
parcelHelpers.export(exports, "Paragraph", ()=>(0, _paragraphDefault.default));
parcelHelpers.export(exports, "PasteVariable", ()=>(0, _pasteVariableDefault.default));
parcelHelpers.export(exports, "Path", ()=>(0, _pathDefault.default));
parcelHelpers.export(exports, "PathSearch", ()=>(0, _pathSearchDefault.default));
parcelHelpers.export(exports, "Pause", ()=>(0, _pauseDefault.default));
parcelHelpers.export(exports, "People", ()=>(0, _peopleDefault.default));
parcelHelpers.export(exports, "Percentage", ()=>(0, _percentageDefault.default));
parcelHelpers.export(exports, "Person", ()=>(0, _personDefault.default));
parcelHelpers.export(exports, "Phone", ()=>(0, _phoneDefault.default));
parcelHelpers.export(exports, "PhoneCall", ()=>(0, _phoneCallDefault.default));
parcelHelpers.export(exports, "PhoneForward", ()=>(0, _phoneForwardDefault.default));
parcelHelpers.export(exports, "PieChart", ()=>(0, _pieChartDefault.default));
parcelHelpers.export(exports, "Pill", ()=>(0, _pillDefault.default));
parcelHelpers.export(exports, "Pin", ()=>(0, _pinDefault.default));
parcelHelpers.export(exports, "Pivot", ()=>(0, _pivotDefault.default));
parcelHelpers.export(exports, "PivotTable", ()=>(0, _pivotTableDefault.default));
parcelHelpers.export(exports, "Play", ()=>(0, _playDefault.default));
parcelHelpers.export(exports, "Playbook", ()=>(0, _playbookDefault.default));
parcelHelpers.export(exports, "Plus", ()=>(0, _plusDefault.default));
parcelHelpers.export(exports, "PolygonFilter", ()=>(0, _polygonFilterDefault.default));
parcelHelpers.export(exports, "Power", ()=>(0, _powerDefault.default));
parcelHelpers.export(exports, "PredictiveAnalysis", ()=>(0, _predictiveAnalysisDefault.default));
parcelHelpers.export(exports, "Prescription", ()=>(0, _prescriptionDefault.default));
parcelHelpers.export(exports, "Presentation", ()=>(0, _presentationDefault.default));
parcelHelpers.export(exports, "Print", ()=>(0, _printDefault.default));
parcelHelpers.export(exports, "Projects", ()=>(0, _projectsDefault.default));
parcelHelpers.export(exports, "Properties", ()=>(0, _propertiesDefault.default));
parcelHelpers.export(exports, "Property", ()=>(0, _propertyDefault.default));
parcelHelpers.export(exports, "PublishFunction", ()=>(0, _publishFunctionDefault.default));
parcelHelpers.export(exports, "Pulse", ()=>(0, _pulseDefault.default));
parcelHelpers.export(exports, "Rain", ()=>(0, _rainDefault.default));
parcelHelpers.export(exports, "Random", ()=>(0, _randomDefault.default));
parcelHelpers.export(exports, "RangeRing", ()=>(0, _rangeRingDefault.default));
parcelHelpers.export(exports, "Record", ()=>(0, _recordDefault.default));
parcelHelpers.export(exports, "RectHeight", ()=>(0, _rectHeightDefault.default));
parcelHelpers.export(exports, "RectWidth", ()=>(0, _rectWidthDefault.default));
parcelHelpers.export(exports, "Rectangle", ()=>(0, _rectangleDefault.default));
parcelHelpers.export(exports, "Redo", ()=>(0, _redoDefault.default));
parcelHelpers.export(exports, "Refresh", ()=>(0, _refreshDefault.default));
parcelHelpers.export(exports, "Regex", ()=>(0, _regexDefault.default));
parcelHelpers.export(exports, "RegressionChart", ()=>(0, _regressionChartDefault.default));
parcelHelpers.export(exports, "Remove", ()=>(0, _removeDefault.default));
parcelHelpers.export(exports, "RemoveColumn", ()=>(0, _removeColumnDefault.default));
parcelHelpers.export(exports, "RemoveColumnLeft", ()=>(0, _removeColumnLeftDefault.default));
parcelHelpers.export(exports, "RemoveColumnRight", ()=>(0, _removeColumnRightDefault.default));
parcelHelpers.export(exports, "RemoveRowBottom", ()=>(0, _removeRowBottomDefault.default));
parcelHelpers.export(exports, "RemoveRowTop", ()=>(0, _removeRowTopDefault.default));
parcelHelpers.export(exports, "Repeat", ()=>(0, _repeatDefault.default));
parcelHelpers.export(exports, "Reset", ()=>(0, _resetDefault.default));
parcelHelpers.export(exports, "Resolve", ()=>(0, _resolveDefault.default));
parcelHelpers.export(exports, "Rig", ()=>(0, _rigDefault.default));
parcelHelpers.export(exports, "RightJoin", ()=>(0, _rightJoinDefault.default));
parcelHelpers.export(exports, "Ring", ()=>(0, _ringDefault.default));
parcelHelpers.export(exports, "Rocket", ()=>(0, _rocketDefault.default));
parcelHelpers.export(exports, "RocketSlant", ()=>(0, _rocketSlantDefault.default));
parcelHelpers.export(exports, "RotateCcw", ()=>(0, _rotateCcwDefault.default));
parcelHelpers.export(exports, "RotateCw", ()=>(0, _rotateCwDefault.default));
parcelHelpers.export(exports, "RotateDocument", ()=>(0, _rotateDocumentDefault.default));
parcelHelpers.export(exports, "RotatePage", ()=>(0, _rotatePageDefault.default));
parcelHelpers.export(exports, "Route", ()=>(0, _routeDefault.default));
parcelHelpers.export(exports, "Satellite", ()=>(0, _satelliteDefault.default));
parcelHelpers.export(exports, "Saved", ()=>(0, _savedDefault.default));
parcelHelpers.export(exports, "ScatterPlot", ()=>(0, _scatterPlotDefault.default));
parcelHelpers.export(exports, "Search", ()=>(0, _searchDefault.default));
parcelHelpers.export(exports, "SearchAround", ()=>(0, _searchAroundDefault.default));
parcelHelpers.export(exports, "SearchTemplate", ()=>(0, _searchTemplateDefault.default));
parcelHelpers.export(exports, "SearchText", ()=>(0, _searchTextDefault.default));
parcelHelpers.export(exports, "SegmentedControl", ()=>(0, _segmentedControlDefault.default));
parcelHelpers.export(exports, "Select", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "Selection", ()=>(0, _selectionDefault.default));
parcelHelpers.export(exports, "SendBackward", ()=>(0, _sendBackwardDefault.default));
parcelHelpers.export(exports, "SendMessage", ()=>(0, _sendMessageDefault.default));
parcelHelpers.export(exports, "SendTo", ()=>(0, _sendToDefault.default));
parcelHelpers.export(exports, "SendToGraph", ()=>(0, _sendToGraphDefault.default));
parcelHelpers.export(exports, "SendToMap", ()=>(0, _sendToMapDefault.default));
parcelHelpers.export(exports, "Sensor", ()=>(0, _sensorDefault.default));
parcelHelpers.export(exports, "SeriesAdd", ()=>(0, _seriesAddDefault.default));
parcelHelpers.export(exports, "SeriesConfiguration", ()=>(0, _seriesConfigurationDefault.default));
parcelHelpers.export(exports, "SeriesDerived", ()=>(0, _seriesDerivedDefault.default));
parcelHelpers.export(exports, "SeriesFiltered", ()=>(0, _seriesFilteredDefault.default));
parcelHelpers.export(exports, "SeriesSearch", ()=>(0, _seriesSearchDefault.default));
parcelHelpers.export(exports, "Server", ()=>(0, _serverDefault.default));
parcelHelpers.export(exports, "ServerInstall", ()=>(0, _serverInstallDefault.default));
parcelHelpers.export(exports, "Settings", ()=>(0, _settingsDefault.default));
parcelHelpers.export(exports, "Shapes", ()=>(0, _shapesDefault.default));
parcelHelpers.export(exports, "Share", ()=>(0, _shareDefault.default));
parcelHelpers.export(exports, "SharedFilter", ()=>(0, _sharedFilterDefault.default));
parcelHelpers.export(exports, "Shield", ()=>(0, _shieldDefault.default));
parcelHelpers.export(exports, "Ship", ()=>(0, _shipDefault.default));
parcelHelpers.export(exports, "Shop", ()=>(0, _shopDefault.default));
parcelHelpers.export(exports, "ShoppingCart", ()=>(0, _shoppingCartDefault.default));
parcelHelpers.export(exports, "ShortenText", ()=>(0, _shortenTextDefault.default));
parcelHelpers.export(exports, "SignalSearch", ()=>(0, _signalSearchDefault.default));
parcelHelpers.export(exports, "SimCard", ()=>(0, _simCardDefault.default));
parcelHelpers.export(exports, "Slash", ()=>(0, _slashDefault.default));
parcelHelpers.export(exports, "SmallCross", ()=>(0, _smallCrossDefault.default));
parcelHelpers.export(exports, "SmallInfoSign", ()=>(0, _smallInfoSignDefault.default));
parcelHelpers.export(exports, "SmallMinus", ()=>(0, _smallMinusDefault.default));
parcelHelpers.export(exports, "SmallPlus", ()=>(0, _smallPlusDefault.default));
parcelHelpers.export(exports, "SmallSquare", ()=>(0, _smallSquareDefault.default));
parcelHelpers.export(exports, "SmallTick", ()=>(0, _smallTickDefault.default));
parcelHelpers.export(exports, "Snowflake", ()=>(0, _snowflakeDefault.default));
parcelHelpers.export(exports, "SoccerBall", ()=>(0, _soccerBallDefault.default));
parcelHelpers.export(exports, "SocialMedia", ()=>(0, _socialMediaDefault.default));
parcelHelpers.export(exports, "Sort", ()=>(0, _sortDefault.default));
parcelHelpers.export(exports, "SortAlphabetical", ()=>(0, _sortAlphabeticalDefault.default));
parcelHelpers.export(exports, "SortAlphabeticalDesc", ()=>(0, _sortAlphabeticalDescDefault.default));
parcelHelpers.export(exports, "SortAsc", ()=>(0, _sortAscDefault.default));
parcelHelpers.export(exports, "SortDesc", ()=>(0, _sortDescDefault.default));
parcelHelpers.export(exports, "SortNumerical", ()=>(0, _sortNumericalDefault.default));
parcelHelpers.export(exports, "SortNumericalDesc", ()=>(0, _sortNumericalDescDefault.default));
parcelHelpers.export(exports, "SpellCheck", ()=>(0, _spellCheckDefault.default));
parcelHelpers.export(exports, "SplitColumns", ()=>(0, _splitColumnsDefault.default));
parcelHelpers.export(exports, "SportsStadium", ()=>(0, _sportsStadiumDefault.default));
parcelHelpers.export(exports, "Square", ()=>(0, _squareDefault.default));
parcelHelpers.export(exports, "StackedChart", ()=>(0, _stackedChartDefault.default));
parcelHelpers.export(exports, "StadiumGeometry", ()=>(0, _stadiumGeometryDefault.default));
parcelHelpers.export(exports, "Star", ()=>(0, _starDefault.default));
parcelHelpers.export(exports, "StarEmpty", ()=>(0, _starEmptyDefault.default));
parcelHelpers.export(exports, "StepBackward", ()=>(0, _stepBackwardDefault.default));
parcelHelpers.export(exports, "StepChart", ()=>(0, _stepChartDefault.default));
parcelHelpers.export(exports, "StepForward", ()=>(0, _stepForwardDefault.default));
parcelHelpers.export(exports, "Stop", ()=>(0, _stopDefault.default));
parcelHelpers.export(exports, "Stopwatch", ()=>(0, _stopwatchDefault.default));
parcelHelpers.export(exports, "Strikethrough", ()=>(0, _strikethroughDefault.default));
parcelHelpers.export(exports, "Style", ()=>(0, _styleDefault.default));
parcelHelpers.export(exports, "Subscript", ()=>(0, _subscriptDefault.default));
parcelHelpers.export(exports, "Superscript", ()=>(0, _superscriptDefault.default));
parcelHelpers.export(exports, "SwapHorizontal", ()=>(0, _swapHorizontalDefault.default));
parcelHelpers.export(exports, "SwapVertical", ()=>(0, _swapVerticalDefault.default));
parcelHelpers.export(exports, "Switch", ()=>(0, _switchDefault.default));
parcelHelpers.export(exports, "SymbolCircle", ()=>(0, _symbolCircleDefault.default));
parcelHelpers.export(exports, "SymbolCross", ()=>(0, _symbolCrossDefault.default));
parcelHelpers.export(exports, "SymbolDiamond", ()=>(0, _symbolDiamondDefault.default));
parcelHelpers.export(exports, "SymbolRectangle", ()=>(0, _symbolRectangleDefault.default));
parcelHelpers.export(exports, "SymbolSquare", ()=>(0, _symbolSquareDefault.default));
parcelHelpers.export(exports, "SymbolTriangleDown", ()=>(0, _symbolTriangleDownDefault.default));
parcelHelpers.export(exports, "SymbolTriangleUp", ()=>(0, _symbolTriangleUpDefault.default));
parcelHelpers.export(exports, "Syringe", ()=>(0, _syringeDefault.default));
parcelHelpers.export(exports, "TableSync", ()=>(0, _tableSyncDefault.default));
parcelHelpers.export(exports, "Tag", ()=>(0, _tagDefault.default));
parcelHelpers.export(exports, "TagAdd", ()=>(0, _tagAddDefault.default));
parcelHelpers.export(exports, "TagPromote", ()=>(0, _tagPromoteDefault.default));
parcelHelpers.export(exports, "TagRefresh", ()=>(0, _tagRefreshDefault.default));
parcelHelpers.export(exports, "TagUndo", ()=>(0, _tagUndoDefault.default));
parcelHelpers.export(exports, "Tags", ()=>(0, _tagsDefault.default));
parcelHelpers.export(exports, "TakeAction", ()=>(0, _takeActionDefault.default));
parcelHelpers.export(exports, "Tank", ()=>(0, _tankDefault.default));
parcelHelpers.export(exports, "Target", ()=>(0, _targetDefault.default));
parcelHelpers.export(exports, "Taxi", ()=>(0, _taxiDefault.default));
parcelHelpers.export(exports, "Team", ()=>(0, _teamDefault.default));
parcelHelpers.export(exports, "Temperature", ()=>(0, _temperatureDefault.default));
parcelHelpers.export(exports, "TextHighlight", ()=>(0, _textHighlightDefault.default));
parcelHelpers.export(exports, "Th", ()=>(0, _thDefault.default));
parcelHelpers.export(exports, "ThAdd", ()=>(0, _thAddDefault.default));
parcelHelpers.export(exports, "ThDerived", ()=>(0, _thDerivedDefault.default));
parcelHelpers.export(exports, "ThDisconnect", ()=>(0, _thDisconnectDefault.default));
parcelHelpers.export(exports, "ThFiltered", ()=>(0, _thFilteredDefault.default));
parcelHelpers.export(exports, "ThList", ()=>(0, _thListDefault.default));
parcelHelpers.export(exports, "ThListAdd", ()=>(0, _thListAddDefault.default));
parcelHelpers.export(exports, "ThVirtual", ()=>(0, _thVirtualDefault.default));
parcelHelpers.export(exports, "ThVirtualAdd", ()=>(0, _thVirtualAddDefault.default));
parcelHelpers.export(exports, "ThirdParty", ()=>(0, _thirdPartyDefault.default));
parcelHelpers.export(exports, "ThumbsDown", ()=>(0, _thumbsDownDefault.default));
parcelHelpers.export(exports, "ThumbsUp", ()=>(0, _thumbsUpDefault.default));
parcelHelpers.export(exports, "Tick", ()=>(0, _tickDefault.default));
parcelHelpers.export(exports, "TickCircle", ()=>(0, _tickCircleDefault.default));
parcelHelpers.export(exports, "Time", ()=>(0, _timeDefault.default));
parcelHelpers.export(exports, "TimelineAreaChart", ()=>(0, _timelineAreaChartDefault.default));
parcelHelpers.export(exports, "TimelineBarChart", ()=>(0, _timelineBarChartDefault.default));
parcelHelpers.export(exports, "TimelineEvents", ()=>(0, _timelineEventsDefault.default));
parcelHelpers.export(exports, "TimelineLineChart", ()=>(0, _timelineLineChartDefault.default));
parcelHelpers.export(exports, "Tint", ()=>(0, _tintDefault.default));
parcelHelpers.export(exports, "Torch", ()=>(0, _torchDefault.default));
parcelHelpers.export(exports, "Tractor", ()=>(0, _tractorDefault.default));
parcelHelpers.export(exports, "Train", ()=>(0, _trainDefault.default));
parcelHelpers.export(exports, "Translate", ()=>(0, _translateDefault.default));
parcelHelpers.export(exports, "Trash", ()=>(0, _trashDefault.default));
parcelHelpers.export(exports, "Tree", ()=>(0, _treeDefault.default));
parcelHelpers.export(exports, "TrendingDown", ()=>(0, _trendingDownDefault.default));
parcelHelpers.export(exports, "TrendingUp", ()=>(0, _trendingUpDefault.default));
parcelHelpers.export(exports, "Trophy", ()=>(0, _trophyDefault.default));
parcelHelpers.export(exports, "Truck", ()=>(0, _truckDefault.default));
parcelHelpers.export(exports, "TwoColumns", ()=>(0, _twoColumnsDefault.default));
parcelHelpers.export(exports, "Unarchive", ()=>(0, _unarchiveDefault.default));
parcelHelpers.export(exports, "Underline", ()=>(0, _underlineDefault.default));
parcelHelpers.export(exports, "Undo", ()=>(0, _undoDefault.default));
parcelHelpers.export(exports, "UngroupObjects", ()=>(0, _ungroupObjectsDefault.default));
parcelHelpers.export(exports, "UnknownVehicle", ()=>(0, _unknownVehicleDefault.default));
parcelHelpers.export(exports, "Unlink", ()=>(0, _unlinkDefault.default));
parcelHelpers.export(exports, "Unlock", ()=>(0, _unlockDefault.default));
parcelHelpers.export(exports, "Unpin", ()=>(0, _unpinDefault.default));
parcelHelpers.export(exports, "Unresolve", ()=>(0, _unresolveDefault.default));
parcelHelpers.export(exports, "Updated", ()=>(0, _updatedDefault.default));
parcelHelpers.export(exports, "Upload", ()=>(0, _uploadDefault.default));
parcelHelpers.export(exports, "User", ()=>(0, _userDefault.default));
parcelHelpers.export(exports, "Variable", ()=>(0, _variableDefault.default));
parcelHelpers.export(exports, "Vector", ()=>(0, _vectorDefault.default));
parcelHelpers.export(exports, "VerticalBarChartAsc", ()=>(0, _verticalBarChartAscDefault.default));
parcelHelpers.export(exports, "VerticalBarChartDesc", ()=>(0, _verticalBarChartDescDefault.default));
parcelHelpers.export(exports, "VerticalDistribution", ()=>(0, _verticalDistributionDefault.default));
parcelHelpers.export(exports, "VerticalInbetween", ()=>(0, _verticalInbetweenDefault.default));
parcelHelpers.export(exports, "Video", ()=>(0, _videoDefault.default));
parcelHelpers.export(exports, "Virus", ()=>(0, _virusDefault.default));
parcelHelpers.export(exports, "VolumeDown", ()=>(0, _volumeDownDefault.default));
parcelHelpers.export(exports, "VolumeOff", ()=>(0, _volumeOffDefault.default));
parcelHelpers.export(exports, "VolumeUp", ()=>(0, _volumeUpDefault.default));
parcelHelpers.export(exports, "Walk", ()=>(0, _walkDefault.default));
parcelHelpers.export(exports, "WarningSign", ()=>(0, _warningSignDefault.default));
parcelHelpers.export(exports, "WaterfallChart", ()=>(0, _waterfallChartDefault.default));
parcelHelpers.export(exports, "Waves", ()=>(0, _wavesDefault.default));
parcelHelpers.export(exports, "Widget", ()=>(0, _widgetDefault.default));
parcelHelpers.export(exports, "WidgetButton", ()=>(0, _widgetButtonDefault.default));
parcelHelpers.export(exports, "WidgetFooter", ()=>(0, _widgetFooterDefault.default));
parcelHelpers.export(exports, "WidgetHeader", ()=>(0, _widgetHeaderDefault.default));
parcelHelpers.export(exports, "Wind", ()=>(0, _windDefault.default));
parcelHelpers.export(exports, "Wrench", ()=>(0, _wrenchDefault.default));
parcelHelpers.export(exports, "WrenchRedo", ()=>(0, _wrenchRedoDefault.default));
parcelHelpers.export(exports, "WrenchSnooze", ()=>(0, _wrenchSnoozeDefault.default));
parcelHelpers.export(exports, "WrenchTime", ()=>(0, _wrenchTimeDefault.default));
parcelHelpers.export(exports, "ZoomIn", ()=>(0, _zoomInDefault.default));
parcelHelpers.export(exports, "ZoomOut", ()=>(0, _zoomOutDefault.default));
parcelHelpers.export(exports, "ZoomToFit", ()=>(0, _zoomToFitDefault.default));
var _add = require("./add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _addClip = require("./add-clip");
var _addClipDefault = parcelHelpers.interopDefault(_addClip);
var _addColumnLeft = require("./add-column-left");
var _addColumnLeftDefault = parcelHelpers.interopDefault(_addColumnLeft);
var _addColumnRight = require("./add-column-right");
var _addColumnRightDefault = parcelHelpers.interopDefault(_addColumnRight);
var _addLocation = require("./add-location");
var _addLocationDefault = parcelHelpers.interopDefault(_addLocation);
var _addRowBottom = require("./add-row-bottom");
var _addRowBottomDefault = parcelHelpers.interopDefault(_addRowBottom);
var _addRowTop = require("./add-row-top");
var _addRowTopDefault = parcelHelpers.interopDefault(_addRowTop);
var _addToArtifact = require("./add-to-artifact");
var _addToArtifactDefault = parcelHelpers.interopDefault(_addToArtifact);
var _addToFolder = require("./add-to-folder");
var _addToFolderDefault = parcelHelpers.interopDefault(_addToFolder);
var _aimpointsTarget = require("./aimpoints-target");
var _aimpointsTargetDefault = parcelHelpers.interopDefault(_aimpointsTarget);
var _airplane = require("./airplane");
var _airplaneDefault = parcelHelpers.interopDefault(_airplane);
var _alignCenter = require("./align-center");
var _alignCenterDefault = parcelHelpers.interopDefault(_alignCenter);
var _alignJustify = require("./align-justify");
var _alignJustifyDefault = parcelHelpers.interopDefault(_alignJustify);
var _alignLeft = require("./align-left");
var _alignLeftDefault = parcelHelpers.interopDefault(_alignLeft);
var _alignRight = require("./align-right");
var _alignRightDefault = parcelHelpers.interopDefault(_alignRight);
var _alignmentBottom = require("./alignment-bottom");
var _alignmentBottomDefault = parcelHelpers.interopDefault(_alignmentBottom);
var _alignmentHorizontalCenter = require("./alignment-horizontal-center");
var _alignmentHorizontalCenterDefault = parcelHelpers.interopDefault(_alignmentHorizontalCenter);
var _alignmentLeft = require("./alignment-left");
var _alignmentLeftDefault = parcelHelpers.interopDefault(_alignmentLeft);
var _alignmentRight = require("./alignment-right");
var _alignmentRightDefault = parcelHelpers.interopDefault(_alignmentRight);
var _alignmentTop = require("./alignment-top");
var _alignmentTopDefault = parcelHelpers.interopDefault(_alignmentTop);
var _alignmentVerticalCenter = require("./alignment-vertical-center");
var _alignmentVerticalCenterDefault = parcelHelpers.interopDefault(_alignmentVerticalCenter);
var _ammunition = require("./ammunition");
var _ammunitionDefault = parcelHelpers.interopDefault(_ammunition);
var _anchor = require("./anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _annotation = require("./annotation");
var _annotationDefault = parcelHelpers.interopDefault(_annotation);
var _antenna = require("./antenna");
var _antennaDefault = parcelHelpers.interopDefault(_antenna);
var _appHeader = require("./app-header");
var _appHeaderDefault = parcelHelpers.interopDefault(_appHeader);
var _application = require("./application");
var _applicationDefault = parcelHelpers.interopDefault(_application);
var _applications = require("./applications");
var _applicationsDefault = parcelHelpers.interopDefault(_applications);
var _archive = require("./archive");
var _archiveDefault = parcelHelpers.interopDefault(_archive);
var _areaOfInterest = require("./area-of-interest");
var _areaOfInterestDefault = parcelHelpers.interopDefault(_areaOfInterest);
var _array = require("./array");
var _arrayDefault = parcelHelpers.interopDefault(_array);
var _arrayBoolean = require("./array-boolean");
var _arrayBooleanDefault = parcelHelpers.interopDefault(_arrayBoolean);
var _arrayDate = require("./array-date");
var _arrayDateDefault = parcelHelpers.interopDefault(_arrayDate);
var _arrayFloatingPoint = require("./array-floating-point");
var _arrayFloatingPointDefault = parcelHelpers.interopDefault(_arrayFloatingPoint);
var _arrayNumeric = require("./array-numeric");
var _arrayNumericDefault = parcelHelpers.interopDefault(_arrayNumeric);
var _arrayString = require("./array-string");
var _arrayStringDefault = parcelHelpers.interopDefault(_arrayString);
var _arrayTimestamp = require("./array-timestamp");
var _arrayTimestampDefault = parcelHelpers.interopDefault(_arrayTimestamp);
var _arrowBottomLeft = require("./arrow-bottom-left");
var _arrowBottomLeftDefault = parcelHelpers.interopDefault(_arrowBottomLeft);
var _arrowBottomRight = require("./arrow-bottom-right");
var _arrowBottomRightDefault = parcelHelpers.interopDefault(_arrowBottomRight);
var _arrowDown = require("./arrow-down");
var _arrowDownDefault = parcelHelpers.interopDefault(_arrowDown);
var _arrowLeft = require("./arrow-left");
var _arrowLeftDefault = parcelHelpers.interopDefault(_arrowLeft);
var _arrowRight = require("./arrow-right");
var _arrowRightDefault = parcelHelpers.interopDefault(_arrowRight);
var _arrowTopLeft = require("./arrow-top-left");
var _arrowTopLeftDefault = parcelHelpers.interopDefault(_arrowTopLeft);
var _arrowTopRight = require("./arrow-top-right");
var _arrowTopRightDefault = parcelHelpers.interopDefault(_arrowTopRight);
var _arrowUp = require("./arrow-up");
var _arrowUpDefault = parcelHelpers.interopDefault(_arrowUp);
var _arrowsArc = require("./arrows-arc");
var _arrowsArcDefault = parcelHelpers.interopDefault(_arrowsArc);
var _arrowsHorizontal = require("./arrows-horizontal");
var _arrowsHorizontalDefault = parcelHelpers.interopDefault(_arrowsHorizontal);
var _arrowsVertical = require("./arrows-vertical");
var _arrowsVerticalDefault = parcelHelpers.interopDefault(_arrowsVertical);
var _asterisk = require("./asterisk");
var _asteriskDefault = parcelHelpers.interopDefault(_asterisk);
var _at = require("./at");
var _atDefault = parcelHelpers.interopDefault(_at);
var _automaticUpdates = require("./automatic-updates");
var _automaticUpdatesDefault = parcelHelpers.interopDefault(_automaticUpdates);
var _axle = require("./axle");
var _axleDefault = parcelHelpers.interopDefault(_axle);
var _backlink = require("./backlink");
var _backlinkDefault = parcelHelpers.interopDefault(_backlink);
var _backwardTen = require("./backward-ten");
var _backwardTenDefault = parcelHelpers.interopDefault(_backwardTen);
var _badge = require("./badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _banCircle = require("./ban-circle");
var _banCircleDefault = parcelHelpers.interopDefault(_banCircle);
var _bankAccount = require("./bank-account");
var _bankAccountDefault = parcelHelpers.interopDefault(_bankAccount);
var _barcode = require("./barcode");
var _barcodeDefault = parcelHelpers.interopDefault(_barcode);
var _binaryNumber = require("./binary-number");
var _binaryNumberDefault = parcelHelpers.interopDefault(_binaryNumber);
var _blank = require("./blank");
var _blankDefault = parcelHelpers.interopDefault(_blank);
var _blockPromote = require("./block-promote");
var _blockPromoteDefault = parcelHelpers.interopDefault(_blockPromote);
var _blockedPerson = require("./blocked-person");
var _blockedPersonDefault = parcelHelpers.interopDefault(_blockedPerson);
var _bold = require("./bold");
var _boldDefault = parcelHelpers.interopDefault(_bold);
var _book = require("./book");
var _bookDefault = parcelHelpers.interopDefault(_book);
var _bookmark = require("./bookmark");
var _bookmarkDefault = parcelHelpers.interopDefault(_bookmark);
var _box = require("./box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _briefcase = require("./briefcase");
var _briefcaseDefault = parcelHelpers.interopDefault(_briefcase);
var _bringData = require("./bring-data");
var _bringDataDefault = parcelHelpers.interopDefault(_bringData);
var _bringForward = require("./bring-forward");
var _bringForwardDefault = parcelHelpers.interopDefault(_bringForward);
var _britishPound = require("./british-pound");
var _britishPoundDefault = parcelHelpers.interopDefault(_britishPound);
var _bug = require("./bug");
var _bugDefault = parcelHelpers.interopDefault(_bug);
var _buggy = require("./buggy");
var _buggyDefault = parcelHelpers.interopDefault(_buggy);
var _build = require("./build");
var _buildDefault = parcelHelpers.interopDefault(_build);
var _bullseye = require("./bullseye");
var _bullseyeDefault = parcelHelpers.interopDefault(_bullseye);
var _calculator = require("./calculator");
var _calculatorDefault = parcelHelpers.interopDefault(_calculator);
var _calendar = require("./calendar");
var _calendarDefault = parcelHelpers.interopDefault(_calendar);
var _camera = require("./camera");
var _cameraDefault = parcelHelpers.interopDefault(_camera);
var _caretDown = require("./caret-down");
var _caretDownDefault = parcelHelpers.interopDefault(_caretDown);
var _caretLeft = require("./caret-left");
var _caretLeftDefault = parcelHelpers.interopDefault(_caretLeft);
var _caretRight = require("./caret-right");
var _caretRightDefault = parcelHelpers.interopDefault(_caretRight);
var _caretUp = require("./caret-up");
var _caretUpDefault = parcelHelpers.interopDefault(_caretUp);
var _cargoShip = require("./cargo-ship");
var _cargoShipDefault = parcelHelpers.interopDefault(_cargoShip);
var _cellTower = require("./cell-tower");
var _cellTowerDefault = parcelHelpers.interopDefault(_cellTower);
var _changes = require("./changes");
var _changesDefault = parcelHelpers.interopDefault(_changes);
var _chart = require("./chart");
var _chartDefault = parcelHelpers.interopDefault(_chart);
var _chat = require("./chat");
var _chatDefault = parcelHelpers.interopDefault(_chat);
var _chevronBackward = require("./chevron-backward");
var _chevronBackwardDefault = parcelHelpers.interopDefault(_chevronBackward);
var _chevronDown = require("./chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _chevronForward = require("./chevron-forward");
var _chevronForwardDefault = parcelHelpers.interopDefault(_chevronForward);
var _chevronLeft = require("./chevron-left");
var _chevronLeftDefault = parcelHelpers.interopDefault(_chevronLeft);
var _chevronRight = require("./chevron-right");
var _chevronRightDefault = parcelHelpers.interopDefault(_chevronRight);
var _chevronUp = require("./chevron-up");
var _chevronUpDefault = parcelHelpers.interopDefault(_chevronUp);
var _circle = require("./circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _circleArrowDown = require("./circle-arrow-down");
var _circleArrowDownDefault = parcelHelpers.interopDefault(_circleArrowDown);
var _circleArrowLeft = require("./circle-arrow-left");
var _circleArrowLeftDefault = parcelHelpers.interopDefault(_circleArrowLeft);
var _circleArrowRight = require("./circle-arrow-right");
var _circleArrowRightDefault = parcelHelpers.interopDefault(_circleArrowRight);
var _circleArrowUp = require("./circle-arrow-up");
var _circleArrowUpDefault = parcelHelpers.interopDefault(_circleArrowUp);
var _citation = require("./citation");
var _citationDefault = parcelHelpers.interopDefault(_citation);
var _clean = require("./clean");
var _cleanDefault = parcelHelpers.interopDefault(_clean);
var _clip = require("./clip");
var _clipDefault = parcelHelpers.interopDefault(_clip);
var _clipboard = require("./clipboard");
var _clipboardDefault = parcelHelpers.interopDefault(_clipboard);
var _clipboardFile = require("./clipboard-file");
var _clipboardFileDefault = parcelHelpers.interopDefault(_clipboardFile);
var _cloud = require("./cloud");
var _cloudDefault = parcelHelpers.interopDefault(_cloud);
var _cloudDownload = require("./cloud-download");
var _cloudDownloadDefault = parcelHelpers.interopDefault(_cloudDownload);
var _cloudServer = require("./cloud-server");
var _cloudServerDefault = parcelHelpers.interopDefault(_cloudServer);
var _cloudTick = require("./cloud-tick");
var _cloudTickDefault = parcelHelpers.interopDefault(_cloudTick);
var _cloudUpload = require("./cloud-upload");
var _cloudUploadDefault = parcelHelpers.interopDefault(_cloudUpload);
var _code = require("./code");
var _codeDefault = parcelHelpers.interopDefault(_code);
var _codeBlock = require("./code-block");
var _codeBlockDefault = parcelHelpers.interopDefault(_codeBlock);
var _cog = require("./cog");
var _cogDefault = parcelHelpers.interopDefault(_cog);
var _collapseAll = require("./collapse-all");
var _collapseAllDefault = parcelHelpers.interopDefault(_collapseAll);
var _colorFill = require("./color-fill");
var _colorFillDefault = parcelHelpers.interopDefault(_colorFill);
var _columnLayout = require("./column-layout");
var _columnLayoutDefault = parcelHelpers.interopDefault(_columnLayout);
var _comment = require("./comment");
var _commentDefault = parcelHelpers.interopDefault(_comment);
var _comparison = require("./comparison");
var _comparisonDefault = parcelHelpers.interopDefault(_comparison);
var _compass = require("./compass");
var _compassDefault = parcelHelpers.interopDefault(_compass);
var _compressed = require("./compressed");
var _compressedDefault = parcelHelpers.interopDefault(_compressed);
var _confirm = require("./confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
var _console = require("./console");
var _consoleDefault = parcelHelpers.interopDefault(_console);
var _contrast = require("./contrast");
var _contrastDefault = parcelHelpers.interopDefault(_contrast);
var _control = require("./control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _creditCard = require("./credit-card");
var _creditCardDefault = parcelHelpers.interopDefault(_creditCard);
var _crop = require("./crop");
var _cropDefault = parcelHelpers.interopDefault(_crop);
var _cross = require("./cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _crossCircle = require("./cross-circle");
var _crossCircleDefault = parcelHelpers.interopDefault(_crossCircle);
var _crown = require("./crown");
var _crownDefault = parcelHelpers.interopDefault(_crown);
var _cssStyle = require("./css-style");
var _cssStyleDefault = parcelHelpers.interopDefault(_cssStyle);
var _cube = require("./cube");
var _cubeDefault = parcelHelpers.interopDefault(_cube);
var _cubeAdd = require("./cube-add");
var _cubeAddDefault = parcelHelpers.interopDefault(_cubeAdd);
var _cubeEdit = require("./cube-edit");
var _cubeEditDefault = parcelHelpers.interopDefault(_cubeEdit);
var _cubeRemove = require("./cube-remove");
var _cubeRemoveDefault = parcelHelpers.interopDefault(_cubeRemove);
var _cubes = require("./cubes");
var _cubesDefault = parcelHelpers.interopDefault(_cubes);
var _curlyBraces = require("./curly-braces");
var _curlyBracesDefault = parcelHelpers.interopDefault(_curlyBraces);
var _curvedRangeChart = require("./curved-range-chart");
var _curvedRangeChartDefault = parcelHelpers.interopDefault(_curvedRangeChart);
var _cut = require("./cut");
var _cutDefault = parcelHelpers.interopDefault(_cut);
var _cycle = require("./cycle");
var _cycleDefault = parcelHelpers.interopDefault(_cycle);
var _dashboard = require("./dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
var _dataConnection = require("./data-connection");
var _dataConnectionDefault = parcelHelpers.interopDefault(_dataConnection);
var _dataLineage = require("./data-lineage");
var _dataLineageDefault = parcelHelpers.interopDefault(_dataLineage);
var _dataSearch = require("./data-search");
var _dataSearchDefault = parcelHelpers.interopDefault(_dataSearch);
var _dataSync = require("./data-sync");
var _dataSyncDefault = parcelHelpers.interopDefault(_dataSync);
var _database = require("./database");
var _databaseDefault = parcelHelpers.interopDefault(_database);
var _delete = require("./delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _delta = require("./delta");
var _deltaDefault = parcelHelpers.interopDefault(_delta);
var _deriveColumn = require("./derive-column");
var _deriveColumnDefault = parcelHelpers.interopDefault(_deriveColumn);
var _desktop = require("./desktop");
var _desktopDefault = parcelHelpers.interopDefault(_desktop);
var _detection = require("./detection");
var _detectionDefault = parcelHelpers.interopDefault(_detection);
var _diagnosis = require("./diagnosis");
var _diagnosisDefault = parcelHelpers.interopDefault(_diagnosis);
var _diagramTree = require("./diagram-tree");
var _diagramTreeDefault = parcelHelpers.interopDefault(_diagramTree);
var _directionLeft = require("./direction-left");
var _directionLeftDefault = parcelHelpers.interopDefault(_directionLeft);
var _directionRight = require("./direction-right");
var _directionRightDefault = parcelHelpers.interopDefault(_directionRight);
var _disable = require("./disable");
var _disableDefault = parcelHelpers.interopDefault(_disable);
var _divide = require("./divide");
var _divideDefault = parcelHelpers.interopDefault(_divide);
var _document = require("./document");
var _documentDefault = parcelHelpers.interopDefault(_document);
var _documentOpen = require("./document-open");
var _documentOpenDefault = parcelHelpers.interopDefault(_documentOpen);
var _documentShare = require("./document-share");
var _documentShareDefault = parcelHelpers.interopDefault(_documentShare);
var _dollar = require("./dollar");
var _dollarDefault = parcelHelpers.interopDefault(_dollar);
var _dot = require("./dot");
var _dotDefault = parcelHelpers.interopDefault(_dot);
var _doubleCaretHorizontal = require("./double-caret-horizontal");
var _doubleCaretHorizontalDefault = parcelHelpers.interopDefault(_doubleCaretHorizontal);
var _doubleCaretVertical = require("./double-caret-vertical");
var _doubleCaretVerticalDefault = parcelHelpers.interopDefault(_doubleCaretVertical);
var _doubleChevronDown = require("./double-chevron-down");
var _doubleChevronDownDefault = parcelHelpers.interopDefault(_doubleChevronDown);
var _doubleChevronLeft = require("./double-chevron-left");
var _doubleChevronLeftDefault = parcelHelpers.interopDefault(_doubleChevronLeft);
var _doubleChevronRight = require("./double-chevron-right");
var _doubleChevronRightDefault = parcelHelpers.interopDefault(_doubleChevronRight);
var _doubleChevronUp = require("./double-chevron-up");
var _doubleChevronUpDefault = parcelHelpers.interopDefault(_doubleChevronUp);
var _doughnutChart = require("./doughnut-chart");
var _doughnutChartDefault = parcelHelpers.interopDefault(_doughnutChart);
var _download = require("./download");
var _downloadDefault = parcelHelpers.interopDefault(_download);
var _dragHandleHorizontal = require("./drag-handle-horizontal");
var _dragHandleHorizontalDefault = parcelHelpers.interopDefault(_dragHandleHorizontal);
var _dragHandleVertical = require("./drag-handle-vertical");
var _dragHandleVerticalDefault = parcelHelpers.interopDefault(_dragHandleVertical);
var _draw = require("./draw");
var _drawDefault = parcelHelpers.interopDefault(_draw);
var _drawerLeft = require("./drawer-left");
var _drawerLeftDefault = parcelHelpers.interopDefault(_drawerLeft);
var _drawerLeftFilled = require("./drawer-left-filled");
var _drawerLeftFilledDefault = parcelHelpers.interopDefault(_drawerLeftFilled);
var _drawerRight = require("./drawer-right");
var _drawerRightDefault = parcelHelpers.interopDefault(_drawerRight);
var _drawerRightFilled = require("./drawer-right-filled");
var _drawerRightFilledDefault = parcelHelpers.interopDefault(_drawerRightFilled);
var _driveTime = require("./drive-time");
var _driveTimeDefault = parcelHelpers.interopDefault(_driveTime);
var _duplicate = require("./duplicate");
var _duplicateDefault = parcelHelpers.interopDefault(_duplicate);
var _edit = require("./edit");
var _editDefault = parcelHelpers.interopDefault(_edit);
var _eject = require("./eject");
var _ejectDefault = parcelHelpers.interopDefault(_eject);
var _emoji = require("./emoji");
var _emojiDefault = parcelHelpers.interopDefault(_emoji);
var _endnote = require("./endnote");
var _endnoteDefault = parcelHelpers.interopDefault(_endnote);
var _endorsed = require("./endorsed");
var _endorsedDefault = parcelHelpers.interopDefault(_endorsed);
var _envelope = require("./envelope");
var _envelopeDefault = parcelHelpers.interopDefault(_envelope);
var _equals = require("./equals");
var _equalsDefault = parcelHelpers.interopDefault(_equals);
var _eraser = require("./eraser");
var _eraserDefault = parcelHelpers.interopDefault(_eraser);
var _error = require("./error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _euro = require("./euro");
var _euroDefault = parcelHelpers.interopDefault(_euro);
var _excavator = require("./excavator");
var _excavatorDefault = parcelHelpers.interopDefault(_excavator);
var _exchange = require("./exchange");
var _exchangeDefault = parcelHelpers.interopDefault(_exchange);
var _excludeRow = require("./exclude-row");
var _excludeRowDefault = parcelHelpers.interopDefault(_excludeRow);
var _expandAll = require("./expand-all");
var _expandAllDefault = parcelHelpers.interopDefault(_expandAll);
var _explain = require("./explain");
var _explainDefault = parcelHelpers.interopDefault(_explain);
var _export = require("./export");
var _exportDefault = parcelHelpers.interopDefault(_export);
var _eyeOff = require("./eye-off");
var _eyeOffDefault = parcelHelpers.interopDefault(_eyeOff);
var _eyeOn = require("./eye-on");
var _eyeOnDefault = parcelHelpers.interopDefault(_eyeOn);
var _eyeOpen = require("./eye-open");
var _eyeOpenDefault = parcelHelpers.interopDefault(_eyeOpen);
var _fastBackward = require("./fast-backward");
var _fastBackwardDefault = parcelHelpers.interopDefault(_fastBackward);
var _fastForward = require("./fast-forward");
var _fastForwardDefault = parcelHelpers.interopDefault(_fastForward);
var _feed = require("./feed");
var _feedDefault = parcelHelpers.interopDefault(_feed);
var _feedSubscribed = require("./feed-subscribed");
var _feedSubscribedDefault = parcelHelpers.interopDefault(_feedSubscribed);
var _fighterJet = require("./fighter-jet");
var _fighterJetDefault = parcelHelpers.interopDefault(_fighterJet);
var _film = require("./film");
var _filmDefault = parcelHelpers.interopDefault(_film);
var _filter = require("./filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _filterKeep = require("./filter-keep");
var _filterKeepDefault = parcelHelpers.interopDefault(_filterKeep);
var _filterList = require("./filter-list");
var _filterListDefault = parcelHelpers.interopDefault(_filterList);
var _filterOpen = require("./filter-open");
var _filterOpenDefault = parcelHelpers.interopDefault(_filterOpen);
var _filterRemove = require("./filter-remove");
var _filterRemoveDefault = parcelHelpers.interopDefault(_filterRemove);
var _filterSortAsc = require("./filter-sort-asc");
var _filterSortAscDefault = parcelHelpers.interopDefault(_filterSortAsc);
var _filterSortDesc = require("./filter-sort-desc");
var _filterSortDescDefault = parcelHelpers.interopDefault(_filterSortDesc);
var _flag = require("./flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _flame = require("./flame");
var _flameDefault = parcelHelpers.interopDefault(_flame);
var _flash = require("./flash");
var _flashDefault = parcelHelpers.interopDefault(_flash);
var _floatingPoint = require("./floating-point");
var _floatingPointDefault = parcelHelpers.interopDefault(_floatingPoint);
var _floppyDisk = require("./floppy-disk");
var _floppyDiskDefault = parcelHelpers.interopDefault(_floppyDisk);
var _flowBranch = require("./flow-branch");
var _flowBranchDefault = parcelHelpers.interopDefault(_flowBranch);
var _flowEnd = require("./flow-end");
var _flowEndDefault = parcelHelpers.interopDefault(_flowEnd);
var _flowLinear = require("./flow-linear");
var _flowLinearDefault = parcelHelpers.interopDefault(_flowLinear);
var _flowReview = require("./flow-review");
var _flowReviewDefault = parcelHelpers.interopDefault(_flowReview);
var _flowReviewBranch = require("./flow-review-branch");
var _flowReviewBranchDefault = parcelHelpers.interopDefault(_flowReviewBranch);
var _flows = require("./flows");
var _flowsDefault = parcelHelpers.interopDefault(_flows);
var _folderClose = require("./folder-close");
var _folderCloseDefault = parcelHelpers.interopDefault(_folderClose);
var _folderNew = require("./folder-new");
var _folderNewDefault = parcelHelpers.interopDefault(_folderNew);
var _folderOpen = require("./folder-open");
var _folderOpenDefault = parcelHelpers.interopDefault(_folderOpen);
var _folderShared = require("./folder-shared");
var _folderSharedDefault = parcelHelpers.interopDefault(_folderShared);
var _folderSharedOpen = require("./folder-shared-open");
var _folderSharedOpenDefault = parcelHelpers.interopDefault(_folderSharedOpen);
var _follower = require("./follower");
var _followerDefault = parcelHelpers.interopDefault(_follower);
var _following = require("./following");
var _followingDefault = parcelHelpers.interopDefault(_following);
var _font = require("./font");
var _fontDefault = parcelHelpers.interopDefault(_font);
var _fork = require("./fork");
var _forkDefault = parcelHelpers.interopDefault(_fork);
var _form = require("./form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _forwardTen = require("./forward-ten");
var _forwardTenDefault = parcelHelpers.interopDefault(_forwardTen);
var _fuel = require("./fuel");
var _fuelDefault = parcelHelpers.interopDefault(_fuel);
var _fullCircle = require("./full-circle");
var _fullCircleDefault = parcelHelpers.interopDefault(_fullCircle);
var _fullStackedChart = require("./full-stacked-chart");
var _fullStackedChartDefault = parcelHelpers.interopDefault(_fullStackedChart);
var _fullscreen = require("./fullscreen");
var _fullscreenDefault = parcelHelpers.interopDefault(_fullscreen);
var _function = require("./function");
var _functionDefault = parcelHelpers.interopDefault(_function);
var _ganttChart = require("./gantt-chart");
var _ganttChartDefault = parcelHelpers.interopDefault(_ganttChart);
var _generate = require("./generate");
var _generateDefault = parcelHelpers.interopDefault(_generate);
var _geofence = require("./geofence");
var _geofenceDefault = parcelHelpers.interopDefault(_geofence);
var _geolocation = require("./geolocation");
var _geolocationDefault = parcelHelpers.interopDefault(_geolocation);
var _geosearch = require("./geosearch");
var _geosearchDefault = parcelHelpers.interopDefault(_geosearch);
var _geotime = require("./geotime");
var _geotimeDefault = parcelHelpers.interopDefault(_geotime);
var _gitBranch = require("./git-branch");
var _gitBranchDefault = parcelHelpers.interopDefault(_gitBranch);
var _gitCommit = require("./git-commit");
var _gitCommitDefault = parcelHelpers.interopDefault(_gitCommit);
var _gitMerge = require("./git-merge");
var _gitMergeDefault = parcelHelpers.interopDefault(_gitMerge);
var _gitNewBranch = require("./git-new-branch");
var _gitNewBranchDefault = parcelHelpers.interopDefault(_gitNewBranch);
var _gitPull = require("./git-pull");
var _gitPullDefault = parcelHelpers.interopDefault(_gitPull);
var _gitPush = require("./git-push");
var _gitPushDefault = parcelHelpers.interopDefault(_gitPush);
var _gitRepo = require("./git-repo");
var _gitRepoDefault = parcelHelpers.interopDefault(_gitRepo);
var _glass = require("./glass");
var _glassDefault = parcelHelpers.interopDefault(_glass);
var _globe = require("./globe");
var _globeDefault = parcelHelpers.interopDefault(_globe);
var _globeNetwork = require("./globe-network");
var _globeNetworkDefault = parcelHelpers.interopDefault(_globeNetwork);
var _globeNetworkAdd = require("./globe-network-add");
var _globeNetworkAddDefault = parcelHelpers.interopDefault(_globeNetworkAdd);
var _graph = require("./graph");
var _graphDefault = parcelHelpers.interopDefault(_graph);
var _graphRemove = require("./graph-remove");
var _graphRemoveDefault = parcelHelpers.interopDefault(_graphRemove);
var _greaterThan = require("./greater-than");
var _greaterThanDefault = parcelHelpers.interopDefault(_greaterThan);
var _greaterThanOrEqualTo = require("./greater-than-or-equal-to");
var _greaterThanOrEqualToDefault = parcelHelpers.interopDefault(_greaterThanOrEqualTo);
var _grid = require("./grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _gridView = require("./grid-view");
var _gridViewDefault = parcelHelpers.interopDefault(_gridView);
var _groupItem = require("./group-item");
var _groupItemDefault = parcelHelpers.interopDefault(_groupItem);
var _groupObjects = require("./group-objects");
var _groupObjectsDefault = parcelHelpers.interopDefault(_groupObjects);
var _groupedBarChart = require("./grouped-bar-chart");
var _groupedBarChartDefault = parcelHelpers.interopDefault(_groupedBarChart);
var _hand = require("./hand");
var _handDefault = parcelHelpers.interopDefault(_hand);
var _handDown = require("./hand-down");
var _handDownDefault = parcelHelpers.interopDefault(_handDown);
var _handLeft = require("./hand-left");
var _handLeftDefault = parcelHelpers.interopDefault(_handLeft);
var _handRight = require("./hand-right");
var _handRightDefault = parcelHelpers.interopDefault(_handRight);
var _handUp = require("./hand-up");
var _handUpDefault = parcelHelpers.interopDefault(_handUp);
var _hat = require("./hat");
var _hatDefault = parcelHelpers.interopDefault(_hat);
var _header = require("./header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _headerOne = require("./header-one");
var _headerOneDefault = parcelHelpers.interopDefault(_headerOne);
var _headerThree = require("./header-three");
var _headerThreeDefault = parcelHelpers.interopDefault(_headerThree);
var _headerTwo = require("./header-two");
var _headerTwoDefault = parcelHelpers.interopDefault(_headerTwo);
var _headset = require("./headset");
var _headsetDefault = parcelHelpers.interopDefault(_headset);
var _heart = require("./heart");
var _heartDefault = parcelHelpers.interopDefault(_heart);
var _heartBroken = require("./heart-broken");
var _heartBrokenDefault = parcelHelpers.interopDefault(_heartBroken);
var _heatGrid = require("./heat-grid");
var _heatGridDefault = parcelHelpers.interopDefault(_heatGrid);
var _heatmap = require("./heatmap");
var _heatmapDefault = parcelHelpers.interopDefault(_heatmap);
var _helicopter = require("./helicopter");
var _helicopterDefault = parcelHelpers.interopDefault(_helicopter);
var _help = require("./help");
var _helpDefault = parcelHelpers.interopDefault(_help);
var _helperManagement = require("./helper-management");
var _helperManagementDefault = parcelHelpers.interopDefault(_helperManagement);
var _hexagon = require("./hexagon");
var _hexagonDefault = parcelHelpers.interopDefault(_hexagon);
var _highPriority = require("./high-priority");
var _highPriorityDefault = parcelHelpers.interopDefault(_highPriority);
var _highVoltagePole = require("./high-voltage-pole");
var _highVoltagePoleDefault = parcelHelpers.interopDefault(_highVoltagePole);
var _highlight = require("./highlight");
var _highlightDefault = parcelHelpers.interopDefault(_highlight);
var _history = require("./history");
var _historyDefault = parcelHelpers.interopDefault(_history);
var _home = require("./home");
var _homeDefault = parcelHelpers.interopDefault(_home);
var _horizontalBarChart = require("./horizontal-bar-chart");
var _horizontalBarChartDefault = parcelHelpers.interopDefault(_horizontalBarChart);
var _horizontalBarChartAsc = require("./horizontal-bar-chart-asc");
var _horizontalBarChartAscDefault = parcelHelpers.interopDefault(_horizontalBarChartAsc);
var _horizontalBarChartDesc = require("./horizontal-bar-chart-desc");
var _horizontalBarChartDescDefault = parcelHelpers.interopDefault(_horizontalBarChartDesc);
var _horizontalDistribution = require("./horizontal-distribution");
var _horizontalDistributionDefault = parcelHelpers.interopDefault(_horizontalDistribution);
var _horizontalInbetween = require("./horizontal-inbetween");
var _horizontalInbetweenDefault = parcelHelpers.interopDefault(_horizontalInbetween);
var _hurricane = require("./hurricane");
var _hurricaneDefault = parcelHelpers.interopDefault(_hurricane);
var _idNumber = require("./id-number");
var _idNumberDefault = parcelHelpers.interopDefault(_idNumber);
var _imageRotateLeft = require("./image-rotate-left");
var _imageRotateLeftDefault = parcelHelpers.interopDefault(_imageRotateLeft);
var _imageRotateRight = require("./image-rotate-right");
var _imageRotateRightDefault = parcelHelpers.interopDefault(_imageRotateRight);
var _import = require("./import");
var _importDefault = parcelHelpers.interopDefault(_import);
var _inbox = require("./inbox");
var _inboxDefault = parcelHelpers.interopDefault(_inbox);
var _inboxFiltered = require("./inbox-filtered");
var _inboxFilteredDefault = parcelHelpers.interopDefault(_inboxFiltered);
var _inboxGeo = require("./inbox-geo");
var _inboxGeoDefault = parcelHelpers.interopDefault(_inboxGeo);
var _inboxSearch = require("./inbox-search");
var _inboxSearchDefault = parcelHelpers.interopDefault(_inboxSearch);
var _inboxUpdate = require("./inbox-update");
var _inboxUpdateDefault = parcelHelpers.interopDefault(_inboxUpdate);
var _infoSign = require("./info-sign");
var _infoSignDefault = parcelHelpers.interopDefault(_infoSign);
var _inheritance = require("./inheritance");
var _inheritanceDefault = parcelHelpers.interopDefault(_inheritance);
var _inheritedGroup = require("./inherited-group");
var _inheritedGroupDefault = parcelHelpers.interopDefault(_inheritedGroup);
var _innerJoin = require("./inner-join");
var _innerJoinDefault = parcelHelpers.interopDefault(_innerJoin);
var _input = require("./input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _insert = require("./insert");
var _insertDefault = parcelHelpers.interopDefault(_insert);
var _intelligence = require("./intelligence");
var _intelligenceDefault = parcelHelpers.interopDefault(_intelligence);
var _intersection = require("./intersection");
var _intersectionDefault = parcelHelpers.interopDefault(_intersection);
var _ipAddress = require("./ip-address");
var _ipAddressDefault = parcelHelpers.interopDefault(_ipAddress);
var _issue = require("./issue");
var _issueDefault = parcelHelpers.interopDefault(_issue);
var _issueClosed = require("./issue-closed");
var _issueClosedDefault = parcelHelpers.interopDefault(_issueClosed);
var _issueNew = require("./issue-new");
var _issueNewDefault = parcelHelpers.interopDefault(_issueNew);
var _italic = require("./italic");
var _italicDefault = parcelHelpers.interopDefault(_italic);
var _joinTable = require("./join-table");
var _joinTableDefault = parcelHelpers.interopDefault(_joinTable);
var _key = require("./key");
var _keyDefault = parcelHelpers.interopDefault(_key);
var _keyBackspace = require("./key-backspace");
var _keyBackspaceDefault = parcelHelpers.interopDefault(_keyBackspace);
var _keyCommand = require("./key-command");
var _keyCommandDefault = parcelHelpers.interopDefault(_keyCommand);
var _keyControl = require("./key-control");
var _keyControlDefault = parcelHelpers.interopDefault(_keyControl);
var _keyDelete = require("./key-delete");
var _keyDeleteDefault = parcelHelpers.interopDefault(_keyDelete);
var _keyEnter = require("./key-enter");
var _keyEnterDefault = parcelHelpers.interopDefault(_keyEnter);
var _keyEscape = require("./key-escape");
var _keyEscapeDefault = parcelHelpers.interopDefault(_keyEscape);
var _keyOption = require("./key-option");
var _keyOptionDefault = parcelHelpers.interopDefault(_keyOption);
var _keyShift = require("./key-shift");
var _keyShiftDefault = parcelHelpers.interopDefault(_keyShift);
var _keyTab = require("./key-tab");
var _keyTabDefault = parcelHelpers.interopDefault(_keyTab);
var _knownVehicle = require("./known-vehicle");
var _knownVehicleDefault = parcelHelpers.interopDefault(_knownVehicle);
var _labTest = require("./lab-test");
var _labTestDefault = parcelHelpers.interopDefault(_labTest);
var _label = require("./label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _layer = require("./layer");
var _layerDefault = parcelHelpers.interopDefault(_layer);
var _layerOutline = require("./layer-outline");
var _layerOutlineDefault = parcelHelpers.interopDefault(_layerOutline);
var _layers = require("./layers");
var _layersDefault = parcelHelpers.interopDefault(_layers);
var _layout = require("./layout");
var _layoutDefault = parcelHelpers.interopDefault(_layout);
var _layoutAuto = require("./layout-auto");
var _layoutAutoDefault = parcelHelpers.interopDefault(_layoutAuto);
var _layoutBalloon = require("./layout-balloon");
var _layoutBalloonDefault = parcelHelpers.interopDefault(_layoutBalloon);
var _layoutBottomRowThreeTiles = require("./layout-bottom-row-three-tiles");
var _layoutBottomRowThreeTilesDefault = parcelHelpers.interopDefault(_layoutBottomRowThreeTiles);
var _layoutBottomRowTwoTiles = require("./layout-bottom-row-two-tiles");
var _layoutBottomRowTwoTilesDefault = parcelHelpers.interopDefault(_layoutBottomRowTwoTiles);
var _layoutCircle = require("./layout-circle");
var _layoutCircleDefault = parcelHelpers.interopDefault(_layoutCircle);
var _layoutGrid = require("./layout-grid");
var _layoutGridDefault = parcelHelpers.interopDefault(_layoutGrid);
var _layoutGroupBy = require("./layout-group-by");
var _layoutGroupByDefault = parcelHelpers.interopDefault(_layoutGroupBy);
var _layoutHierarchy = require("./layout-hierarchy");
var _layoutHierarchyDefault = parcelHelpers.interopDefault(_layoutHierarchy);
var _layoutLeftColumnThreeTiles = require("./layout-left-column-three-tiles");
var _layoutLeftColumnThreeTilesDefault = parcelHelpers.interopDefault(_layoutLeftColumnThreeTiles);
var _layoutLeftColumnTwoTiles = require("./layout-left-column-two-tiles");
var _layoutLeftColumnTwoTilesDefault = parcelHelpers.interopDefault(_layoutLeftColumnTwoTiles);
var _layoutLinear = require("./layout-linear");
var _layoutLinearDefault = parcelHelpers.interopDefault(_layoutLinear);
var _layoutRightColumnThreeTiles = require("./layout-right-column-three-tiles");
var _layoutRightColumnThreeTilesDefault = parcelHelpers.interopDefault(_layoutRightColumnThreeTiles);
var _layoutRightColumnTwoTiles = require("./layout-right-column-two-tiles");
var _layoutRightColumnTwoTilesDefault = parcelHelpers.interopDefault(_layoutRightColumnTwoTiles);
var _layoutSkewGrid = require("./layout-skew-grid");
var _layoutSkewGridDefault = parcelHelpers.interopDefault(_layoutSkewGrid);
var _layoutSortedClusters = require("./layout-sorted-clusters");
var _layoutSortedClustersDefault = parcelHelpers.interopDefault(_layoutSortedClusters);
var _layoutThreeColumns = require("./layout-three-columns");
var _layoutThreeColumnsDefault = parcelHelpers.interopDefault(_layoutThreeColumns);
var _layoutThreeRows = require("./layout-three-rows");
var _layoutThreeRowsDefault = parcelHelpers.interopDefault(_layoutThreeRows);
var _layoutTopRowThreeTiles = require("./layout-top-row-three-tiles");
var _layoutTopRowThreeTilesDefault = parcelHelpers.interopDefault(_layoutTopRowThreeTiles);
var _layoutTopRowTwoTiles = require("./layout-top-row-two-tiles");
var _layoutTopRowTwoTilesDefault = parcelHelpers.interopDefault(_layoutTopRowTwoTiles);
var _layoutTwoColumns = require("./layout-two-columns");
var _layoutTwoColumnsDefault = parcelHelpers.interopDefault(_layoutTwoColumns);
var _layoutTwoRows = require("./layout-two-rows");
var _layoutTwoRowsDefault = parcelHelpers.interopDefault(_layoutTwoRows);
var _learning = require("./learning");
var _learningDefault = parcelHelpers.interopDefault(_learning);
var _leftJoin = require("./left-join");
var _leftJoinDefault = parcelHelpers.interopDefault(_leftJoin);
var _lengthenText = require("./lengthen-text");
var _lengthenTextDefault = parcelHelpers.interopDefault(_lengthenText);
var _lessThan = require("./less-than");
var _lessThanDefault = parcelHelpers.interopDefault(_lessThan);
var _lessThanOrEqualTo = require("./less-than-or-equal-to");
var _lessThanOrEqualToDefault = parcelHelpers.interopDefault(_lessThanOrEqualTo);
var _lifesaver = require("./lifesaver");
var _lifesaverDefault = parcelHelpers.interopDefault(_lifesaver);
var _lightbulb = require("./lightbulb");
var _lightbulbDefault = parcelHelpers.interopDefault(_lightbulb);
var _lightning = require("./lightning");
var _lightningDefault = parcelHelpers.interopDefault(_lightning);
var _link = require("./link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _linkedSquares = require("./linked-squares");
var _linkedSquaresDefault = parcelHelpers.interopDefault(_linkedSquares);
var _list = require("./list");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listColumns = require("./list-columns");
var _listColumnsDefault = parcelHelpers.interopDefault(_listColumns);
var _listDetailView = require("./list-detail-view");
var _listDetailViewDefault = parcelHelpers.interopDefault(_listDetailView);
var _locate = require("./locate");
var _locateDefault = parcelHelpers.interopDefault(_locate);
var _lock = require("./lock");
var _lockDefault = parcelHelpers.interopDefault(_lock);
var _locomotive = require("./locomotive");
var _locomotiveDefault = parcelHelpers.interopDefault(_locomotive);
var _logIn = require("./log-in");
var _logInDefault = parcelHelpers.interopDefault(_logIn);
var _logOut = require("./log-out");
var _logOutDefault = parcelHelpers.interopDefault(_logOut);
var _lowVoltagePole = require("./low-voltage-pole");
var _lowVoltagePoleDefault = parcelHelpers.interopDefault(_lowVoltagePole);
var _manual = require("./manual");
var _manualDefault = parcelHelpers.interopDefault(_manual);
var _manuallyEnteredData = require("./manually-entered-data");
var _manuallyEnteredDataDefault = parcelHelpers.interopDefault(_manuallyEnteredData);
var _manyToMany = require("./many-to-many");
var _manyToManyDefault = parcelHelpers.interopDefault(_manyToMany);
var _manyToOne = require("./many-to-one");
var _manyToOneDefault = parcelHelpers.interopDefault(_manyToOne);
var _map = require("./map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _mapCreate = require("./map-create");
var _mapCreateDefault = parcelHelpers.interopDefault(_mapCreate);
var _mapMarker = require("./map-marker");
var _mapMarkerDefault = parcelHelpers.interopDefault(_mapMarker);
var _maximize = require("./maximize");
var _maximizeDefault = parcelHelpers.interopDefault(_maximize);
var _media = require("./media");
var _mediaDefault = parcelHelpers.interopDefault(_media);
var _menu = require("./menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuClosed = require("./menu-closed");
var _menuClosedDefault = parcelHelpers.interopDefault(_menuClosed);
var _menuOpen = require("./menu-open");
var _menuOpenDefault = parcelHelpers.interopDefault(_menuOpen);
var _mergeColumns = require("./merge-columns");
var _mergeColumnsDefault = parcelHelpers.interopDefault(_mergeColumns);
var _mergeLinks = require("./merge-links");
var _mergeLinksDefault = parcelHelpers.interopDefault(_mergeLinks);
var _microphone = require("./microphone");
var _microphoneDefault = parcelHelpers.interopDefault(_microphone);
var _minimize = require("./minimize");
var _minimizeDefault = parcelHelpers.interopDefault(_minimize);
var _minus = require("./minus");
var _minusDefault = parcelHelpers.interopDefault(_minus);
var _mobilePhone = require("./mobile-phone");
var _mobilePhoneDefault = parcelHelpers.interopDefault(_mobilePhone);
var _mobileVideo = require("./mobile-video");
var _mobileVideoDefault = parcelHelpers.interopDefault(_mobileVideo);
var _modal = require("./modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalFilled = require("./modal-filled");
var _modalFilledDefault = parcelHelpers.interopDefault(_modalFilled);
var _model = require("./model");
var _modelDefault = parcelHelpers.interopDefault(_model);
var _moon = require("./moon");
var _moonDefault = parcelHelpers.interopDefault(_moon);
var _more = require("./more");
var _moreDefault = parcelHelpers.interopDefault(_more);
var _mountain = require("./mountain");
var _mountainDefault = parcelHelpers.interopDefault(_mountain);
var _move = require("./move");
var _moveDefault = parcelHelpers.interopDefault(_move);
var _mugshot = require("./mugshot");
var _mugshotDefault = parcelHelpers.interopDefault(_mugshot);
var _multiSelect = require("./multi-select");
var _multiSelectDefault = parcelHelpers.interopDefault(_multiSelect);
var _music = require("./music");
var _musicDefault = parcelHelpers.interopDefault(_music);
var _nest = require("./nest");
var _nestDefault = parcelHelpers.interopDefault(_nest);
var _newDrawing = require("./new-drawing");
var _newDrawingDefault = parcelHelpers.interopDefault(_newDrawing);
var _newGridItem = require("./new-grid-item");
var _newGridItemDefault = parcelHelpers.interopDefault(_newGridItem);
var _newLayer = require("./new-layer");
var _newLayerDefault = parcelHelpers.interopDefault(_newLayer);
var _newLayers = require("./new-layers");
var _newLayersDefault = parcelHelpers.interopDefault(_newLayers);
var _newLink = require("./new-link");
var _newLinkDefault = parcelHelpers.interopDefault(_newLink);
var _newObject = require("./new-object");
var _newObjectDefault = parcelHelpers.interopDefault(_newObject);
var _newPerson = require("./new-person");
var _newPersonDefault = parcelHelpers.interopDefault(_newPerson);
var _newPrescription = require("./new-prescription");
var _newPrescriptionDefault = parcelHelpers.interopDefault(_newPrescription);
var _newShield = require("./new-shield");
var _newShieldDefault = parcelHelpers.interopDefault(_newShield);
var _newTextBox = require("./new-text-box");
var _newTextBoxDefault = parcelHelpers.interopDefault(_newTextBox);
var _ninja = require("./ninja");
var _ninjaDefault = parcelHelpers.interopDefault(_ninja);
var _notEqualTo = require("./not-equal-to");
var _notEqualToDefault = parcelHelpers.interopDefault(_notEqualTo);
var _notifications = require("./notifications");
var _notificationsDefault = parcelHelpers.interopDefault(_notifications);
var _notificationsSnooze = require("./notifications-snooze");
var _notificationsSnoozeDefault = parcelHelpers.interopDefault(_notificationsSnooze);
var _notificationsUpdated = require("./notifications-updated");
var _notificationsUpdatedDefault = parcelHelpers.interopDefault(_notificationsUpdated);
var _numberedList = require("./numbered-list");
var _numberedListDefault = parcelHelpers.interopDefault(_numberedList);
var _numerical = require("./numerical");
var _numericalDefault = parcelHelpers.interopDefault(_numerical);
var _objectView = require("./object-view");
var _objectViewDefault = parcelHelpers.interopDefault(_objectView);
var _office = require("./office");
var _officeDefault = parcelHelpers.interopDefault(_office);
var _offline = require("./offline");
var _offlineDefault = parcelHelpers.interopDefault(_offline);
var _oilField = require("./oil-field");
var _oilFieldDefault = parcelHelpers.interopDefault(_oilField);
var _oneColumn = require("./one-column");
var _oneColumnDefault = parcelHelpers.interopDefault(_oneColumn);
var _oneToMany = require("./one-to-many");
var _oneToManyDefault = parcelHelpers.interopDefault(_oneToMany);
var _oneToOne = require("./one-to-one");
var _oneToOneDefault = parcelHelpers.interopDefault(_oneToOne);
var _openApplication = require("./open-application");
var _openApplicationDefault = parcelHelpers.interopDefault(_openApplication);
var _outdated = require("./outdated");
var _outdatedDefault = parcelHelpers.interopDefault(_outdated);
var _output = require("./output");
var _outputDefault = parcelHelpers.interopDefault(_output);
var _package = require("./package");
var _packageDefault = parcelHelpers.interopDefault(_package);
var _pageLayout = require("./page-layout");
var _pageLayoutDefault = parcelHelpers.interopDefault(_pageLayout);
var _panel = require("./panel");
var _panelDefault = parcelHelpers.interopDefault(_panel);
var _panelStats = require("./panel-stats");
var _panelStatsDefault = parcelHelpers.interopDefault(_panelStats);
var _panelTable = require("./panel-table");
var _panelTableDefault = parcelHelpers.interopDefault(_panelTable);
var _paperclip = require("./paperclip");
var _paperclipDefault = parcelHelpers.interopDefault(_paperclip);
var _paragraph = require("./paragraph");
var _paragraphDefault = parcelHelpers.interopDefault(_paragraph);
var _pasteVariable = require("./paste-variable");
var _pasteVariableDefault = parcelHelpers.interopDefault(_pasteVariable);
var _path = require("./path");
var _pathDefault = parcelHelpers.interopDefault(_path);
var _pathSearch = require("./path-search");
var _pathSearchDefault = parcelHelpers.interopDefault(_pathSearch);
var _pause = require("./pause");
var _pauseDefault = parcelHelpers.interopDefault(_pause);
var _people = require("./people");
var _peopleDefault = parcelHelpers.interopDefault(_people);
var _percentage = require("./percentage");
var _percentageDefault = parcelHelpers.interopDefault(_percentage);
var _person = require("./person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _phone = require("./phone");
var _phoneDefault = parcelHelpers.interopDefault(_phone);
var _phoneCall = require("./phone-call");
var _phoneCallDefault = parcelHelpers.interopDefault(_phoneCall);
var _phoneForward = require("./phone-forward");
var _phoneForwardDefault = parcelHelpers.interopDefault(_phoneForward);
var _pieChart = require("./pie-chart");
var _pieChartDefault = parcelHelpers.interopDefault(_pieChart);
var _pill = require("./pill");
var _pillDefault = parcelHelpers.interopDefault(_pill);
var _pin = require("./pin");
var _pinDefault = parcelHelpers.interopDefault(_pin);
var _pivot = require("./pivot");
var _pivotDefault = parcelHelpers.interopDefault(_pivot);
var _pivotTable = require("./pivot-table");
var _pivotTableDefault = parcelHelpers.interopDefault(_pivotTable);
var _play = require("./play");
var _playDefault = parcelHelpers.interopDefault(_play);
var _playbook = require("./playbook");
var _playbookDefault = parcelHelpers.interopDefault(_playbook);
var _plus = require("./plus");
var _plusDefault = parcelHelpers.interopDefault(_plus);
var _polygonFilter = require("./polygon-filter");
var _polygonFilterDefault = parcelHelpers.interopDefault(_polygonFilter);
var _power = require("./power");
var _powerDefault = parcelHelpers.interopDefault(_power);
var _predictiveAnalysis = require("./predictive-analysis");
var _predictiveAnalysisDefault = parcelHelpers.interopDefault(_predictiveAnalysis);
var _prescription = require("./prescription");
var _prescriptionDefault = parcelHelpers.interopDefault(_prescription);
var _presentation = require("./presentation");
var _presentationDefault = parcelHelpers.interopDefault(_presentation);
var _print = require("./print");
var _printDefault = parcelHelpers.interopDefault(_print);
var _projects = require("./projects");
var _projectsDefault = parcelHelpers.interopDefault(_projects);
var _properties = require("./properties");
var _propertiesDefault = parcelHelpers.interopDefault(_properties);
var _property = require("./property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _publishFunction = require("./publish-function");
var _publishFunctionDefault = parcelHelpers.interopDefault(_publishFunction);
var _pulse = require("./pulse");
var _pulseDefault = parcelHelpers.interopDefault(_pulse);
var _rain = require("./rain");
var _rainDefault = parcelHelpers.interopDefault(_rain);
var _random = require("./random");
var _randomDefault = parcelHelpers.interopDefault(_random);
var _rangeRing = require("./range-ring");
var _rangeRingDefault = parcelHelpers.interopDefault(_rangeRing);
var _record = require("./record");
var _recordDefault = parcelHelpers.interopDefault(_record);
var _rectHeight = require("./rect-height");
var _rectHeightDefault = parcelHelpers.interopDefault(_rectHeight);
var _rectWidth = require("./rect-width");
var _rectWidthDefault = parcelHelpers.interopDefault(_rectWidth);
var _rectangle = require("./rectangle");
var _rectangleDefault = parcelHelpers.interopDefault(_rectangle);
var _redo = require("./redo");
var _redoDefault = parcelHelpers.interopDefault(_redo);
var _refresh = require("./refresh");
var _refreshDefault = parcelHelpers.interopDefault(_refresh);
var _regex = require("./regex");
var _regexDefault = parcelHelpers.interopDefault(_regex);
var _regressionChart = require("./regression-chart");
var _regressionChartDefault = parcelHelpers.interopDefault(_regressionChart);
var _remove = require("./remove");
var _removeDefault = parcelHelpers.interopDefault(_remove);
var _removeColumn = require("./remove-column");
var _removeColumnDefault = parcelHelpers.interopDefault(_removeColumn);
var _removeColumnLeft = require("./remove-column-left");
var _removeColumnLeftDefault = parcelHelpers.interopDefault(_removeColumnLeft);
var _removeColumnRight = require("./remove-column-right");
var _removeColumnRightDefault = parcelHelpers.interopDefault(_removeColumnRight);
var _removeRowBottom = require("./remove-row-bottom");
var _removeRowBottomDefault = parcelHelpers.interopDefault(_removeRowBottom);
var _removeRowTop = require("./remove-row-top");
var _removeRowTopDefault = parcelHelpers.interopDefault(_removeRowTop);
var _repeat = require("./repeat");
var _repeatDefault = parcelHelpers.interopDefault(_repeat);
var _reset = require("./reset");
var _resetDefault = parcelHelpers.interopDefault(_reset);
var _resolve = require("./resolve");
var _resolveDefault = parcelHelpers.interopDefault(_resolve);
var _rig = require("./rig");
var _rigDefault = parcelHelpers.interopDefault(_rig);
var _rightJoin = require("./right-join");
var _rightJoinDefault = parcelHelpers.interopDefault(_rightJoin);
var _ring = require("./ring");
var _ringDefault = parcelHelpers.interopDefault(_ring);
var _rocket = require("./rocket");
var _rocketDefault = parcelHelpers.interopDefault(_rocket);
var _rocketSlant = require("./rocket-slant");
var _rocketSlantDefault = parcelHelpers.interopDefault(_rocketSlant);
var _rotateCcw = require("./rotate-ccw");
var _rotateCcwDefault = parcelHelpers.interopDefault(_rotateCcw);
var _rotateCw = require("./rotate-cw");
var _rotateCwDefault = parcelHelpers.interopDefault(_rotateCw);
var _rotateDocument = require("./rotate-document");
var _rotateDocumentDefault = parcelHelpers.interopDefault(_rotateDocument);
var _rotatePage = require("./rotate-page");
var _rotatePageDefault = parcelHelpers.interopDefault(_rotatePage);
var _route = require("./route");
var _routeDefault = parcelHelpers.interopDefault(_route);
var _satellite = require("./satellite");
var _satelliteDefault = parcelHelpers.interopDefault(_satellite);
var _saved = require("./saved");
var _savedDefault = parcelHelpers.interopDefault(_saved);
var _scatterPlot = require("./scatter-plot");
var _scatterPlotDefault = parcelHelpers.interopDefault(_scatterPlot);
var _search = require("./search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _searchAround = require("./search-around");
var _searchAroundDefault = parcelHelpers.interopDefault(_searchAround);
var _searchTemplate = require("./search-template");
var _searchTemplateDefault = parcelHelpers.interopDefault(_searchTemplate);
var _searchText = require("./search-text");
var _searchTextDefault = parcelHelpers.interopDefault(_searchText);
var _segmentedControl = require("./segmented-control");
var _segmentedControlDefault = parcelHelpers.interopDefault(_segmentedControl);
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _selection = require("./selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _sendBackward = require("./send-backward");
var _sendBackwardDefault = parcelHelpers.interopDefault(_sendBackward);
var _sendMessage = require("./send-message");
var _sendMessageDefault = parcelHelpers.interopDefault(_sendMessage);
var _sendTo = require("./send-to");
var _sendToDefault = parcelHelpers.interopDefault(_sendTo);
var _sendToGraph = require("./send-to-graph");
var _sendToGraphDefault = parcelHelpers.interopDefault(_sendToGraph);
var _sendToMap = require("./send-to-map");
var _sendToMapDefault = parcelHelpers.interopDefault(_sendToMap);
var _sensor = require("./sensor");
var _sensorDefault = parcelHelpers.interopDefault(_sensor);
var _seriesAdd = require("./series-add");
var _seriesAddDefault = parcelHelpers.interopDefault(_seriesAdd);
var _seriesConfiguration = require("./series-configuration");
var _seriesConfigurationDefault = parcelHelpers.interopDefault(_seriesConfiguration);
var _seriesDerived = require("./series-derived");
var _seriesDerivedDefault = parcelHelpers.interopDefault(_seriesDerived);
var _seriesFiltered = require("./series-filtered");
var _seriesFilteredDefault = parcelHelpers.interopDefault(_seriesFiltered);
var _seriesSearch = require("./series-search");
var _seriesSearchDefault = parcelHelpers.interopDefault(_seriesSearch);
var _server = require("./server");
var _serverDefault = parcelHelpers.interopDefault(_server);
var _serverInstall = require("./server-install");
var _serverInstallDefault = parcelHelpers.interopDefault(_serverInstall);
var _settings = require("./settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _shapes = require("./shapes");
var _shapesDefault = parcelHelpers.interopDefault(_shapes);
var _share = require("./share");
var _shareDefault = parcelHelpers.interopDefault(_share);
var _sharedFilter = require("./shared-filter");
var _sharedFilterDefault = parcelHelpers.interopDefault(_sharedFilter);
var _shield = require("./shield");
var _shieldDefault = parcelHelpers.interopDefault(_shield);
var _ship = require("./ship");
var _shipDefault = parcelHelpers.interopDefault(_ship);
var _shop = require("./shop");
var _shopDefault = parcelHelpers.interopDefault(_shop);
var _shoppingCart = require("./shopping-cart");
var _shoppingCartDefault = parcelHelpers.interopDefault(_shoppingCart);
var _shortenText = require("./shorten-text");
var _shortenTextDefault = parcelHelpers.interopDefault(_shortenText);
var _signalSearch = require("./signal-search");
var _signalSearchDefault = parcelHelpers.interopDefault(_signalSearch);
var _simCard = require("./sim-card");
var _simCardDefault = parcelHelpers.interopDefault(_simCard);
var _slash = require("./slash");
var _slashDefault = parcelHelpers.interopDefault(_slash);
var _smallCross = require("./small-cross");
var _smallCrossDefault = parcelHelpers.interopDefault(_smallCross);
var _smallInfoSign = require("./small-info-sign");
var _smallInfoSignDefault = parcelHelpers.interopDefault(_smallInfoSign);
var _smallMinus = require("./small-minus");
var _smallMinusDefault = parcelHelpers.interopDefault(_smallMinus);
var _smallPlus = require("./small-plus");
var _smallPlusDefault = parcelHelpers.interopDefault(_smallPlus);
var _smallSquare = require("./small-square");
var _smallSquareDefault = parcelHelpers.interopDefault(_smallSquare);
var _smallTick = require("./small-tick");
var _smallTickDefault = parcelHelpers.interopDefault(_smallTick);
var _snowflake = require("./snowflake");
var _snowflakeDefault = parcelHelpers.interopDefault(_snowflake);
var _soccerBall = require("./soccer-ball");
var _soccerBallDefault = parcelHelpers.interopDefault(_soccerBall);
var _socialMedia = require("./social-media");
var _socialMediaDefault = parcelHelpers.interopDefault(_socialMedia);
var _sort = require("./sort");
var _sortDefault = parcelHelpers.interopDefault(_sort);
var _sortAlphabetical = require("./sort-alphabetical");
var _sortAlphabeticalDefault = parcelHelpers.interopDefault(_sortAlphabetical);
var _sortAlphabeticalDesc = require("./sort-alphabetical-desc");
var _sortAlphabeticalDescDefault = parcelHelpers.interopDefault(_sortAlphabeticalDesc);
var _sortAsc = require("./sort-asc");
var _sortAscDefault = parcelHelpers.interopDefault(_sortAsc);
var _sortDesc = require("./sort-desc");
var _sortDescDefault = parcelHelpers.interopDefault(_sortDesc);
var _sortNumerical = require("./sort-numerical");
var _sortNumericalDefault = parcelHelpers.interopDefault(_sortNumerical);
var _sortNumericalDesc = require("./sort-numerical-desc");
var _sortNumericalDescDefault = parcelHelpers.interopDefault(_sortNumericalDesc);
var _spellCheck = require("./spell-check");
var _spellCheckDefault = parcelHelpers.interopDefault(_spellCheck);
var _splitColumns = require("./split-columns");
var _splitColumnsDefault = parcelHelpers.interopDefault(_splitColumns);
var _sportsStadium = require("./sports-stadium");
var _sportsStadiumDefault = parcelHelpers.interopDefault(_sportsStadium);
var _square = require("./square");
var _squareDefault = parcelHelpers.interopDefault(_square);
var _stackedChart = require("./stacked-chart");
var _stackedChartDefault = parcelHelpers.interopDefault(_stackedChart);
var _stadiumGeometry = require("./stadium-geometry");
var _stadiumGeometryDefault = parcelHelpers.interopDefault(_stadiumGeometry);
var _star = require("./star");
var _starDefault = parcelHelpers.interopDefault(_star);
var _starEmpty = require("./star-empty");
var _starEmptyDefault = parcelHelpers.interopDefault(_starEmpty);
var _stepBackward = require("./step-backward");
var _stepBackwardDefault = parcelHelpers.interopDefault(_stepBackward);
var _stepChart = require("./step-chart");
var _stepChartDefault = parcelHelpers.interopDefault(_stepChart);
var _stepForward = require("./step-forward");
var _stepForwardDefault = parcelHelpers.interopDefault(_stepForward);
var _stop = require("./stop");
var _stopDefault = parcelHelpers.interopDefault(_stop);
var _stopwatch = require("./stopwatch");
var _stopwatchDefault = parcelHelpers.interopDefault(_stopwatch);
var _strikethrough = require("./strikethrough");
var _strikethroughDefault = parcelHelpers.interopDefault(_strikethrough);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _subscript = require("./subscript");
var _subscriptDefault = parcelHelpers.interopDefault(_subscript);
var _superscript = require("./superscript");
var _superscriptDefault = parcelHelpers.interopDefault(_superscript);
var _swapHorizontal = require("./swap-horizontal");
var _swapHorizontalDefault = parcelHelpers.interopDefault(_swapHorizontal);
var _swapVertical = require("./swap-vertical");
var _swapVerticalDefault = parcelHelpers.interopDefault(_swapVertical);
var _switch = require("./switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _symbolCircle = require("./symbol-circle");
var _symbolCircleDefault = parcelHelpers.interopDefault(_symbolCircle);
var _symbolCross = require("./symbol-cross");
var _symbolCrossDefault = parcelHelpers.interopDefault(_symbolCross);
var _symbolDiamond = require("./symbol-diamond");
var _symbolDiamondDefault = parcelHelpers.interopDefault(_symbolDiamond);
var _symbolRectangle = require("./symbol-rectangle");
var _symbolRectangleDefault = parcelHelpers.interopDefault(_symbolRectangle);
var _symbolSquare = require("./symbol-square");
var _symbolSquareDefault = parcelHelpers.interopDefault(_symbolSquare);
var _symbolTriangleDown = require("./symbol-triangle-down");
var _symbolTriangleDownDefault = parcelHelpers.interopDefault(_symbolTriangleDown);
var _symbolTriangleUp = require("./symbol-triangle-up");
var _symbolTriangleUpDefault = parcelHelpers.interopDefault(_symbolTriangleUp);
var _syringe = require("./syringe");
var _syringeDefault = parcelHelpers.interopDefault(_syringe);
var _tableSync = require("./table-sync");
var _tableSyncDefault = parcelHelpers.interopDefault(_tableSync);
var _tag = require("./tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _tagAdd = require("./tag-add");
var _tagAddDefault = parcelHelpers.interopDefault(_tagAdd);
var _tagPromote = require("./tag-promote");
var _tagPromoteDefault = parcelHelpers.interopDefault(_tagPromote);
var _tagRefresh = require("./tag-refresh");
var _tagRefreshDefault = parcelHelpers.interopDefault(_tagRefresh);
var _tagUndo = require("./tag-undo");
var _tagUndoDefault = parcelHelpers.interopDefault(_tagUndo);
var _tags = require("./tags");
var _tagsDefault = parcelHelpers.interopDefault(_tags);
var _takeAction = require("./take-action");
var _takeActionDefault = parcelHelpers.interopDefault(_takeAction);
var _tank = require("./tank");
var _tankDefault = parcelHelpers.interopDefault(_tank);
var _target = require("./target");
var _targetDefault = parcelHelpers.interopDefault(_target);
var _taxi = require("./taxi");
var _taxiDefault = parcelHelpers.interopDefault(_taxi);
var _team = require("./team");
var _teamDefault = parcelHelpers.interopDefault(_team);
var _temperature = require("./temperature");
var _temperatureDefault = parcelHelpers.interopDefault(_temperature);
var _textHighlight = require("./text-highlight");
var _textHighlightDefault = parcelHelpers.interopDefault(_textHighlight);
var _th = require("./th");
var _thDefault = parcelHelpers.interopDefault(_th);
var _thAdd = require("./th-add");
var _thAddDefault = parcelHelpers.interopDefault(_thAdd);
var _thDerived = require("./th-derived");
var _thDerivedDefault = parcelHelpers.interopDefault(_thDerived);
var _thDisconnect = require("./th-disconnect");
var _thDisconnectDefault = parcelHelpers.interopDefault(_thDisconnect);
var _thFiltered = require("./th-filtered");
var _thFilteredDefault = parcelHelpers.interopDefault(_thFiltered);
var _thList = require("./th-list");
var _thListDefault = parcelHelpers.interopDefault(_thList);
var _thListAdd = require("./th-list-add");
var _thListAddDefault = parcelHelpers.interopDefault(_thListAdd);
var _thVirtual = require("./th-virtual");
var _thVirtualDefault = parcelHelpers.interopDefault(_thVirtual);
var _thVirtualAdd = require("./th-virtual-add");
var _thVirtualAddDefault = parcelHelpers.interopDefault(_thVirtualAdd);
var _thirdParty = require("./third-party");
var _thirdPartyDefault = parcelHelpers.interopDefault(_thirdParty);
var _thumbsDown = require("./thumbs-down");
var _thumbsDownDefault = parcelHelpers.interopDefault(_thumbsDown);
var _thumbsUp = require("./thumbs-up");
var _thumbsUpDefault = parcelHelpers.interopDefault(_thumbsUp);
var _tick = require("./tick");
var _tickDefault = parcelHelpers.interopDefault(_tick);
var _tickCircle = require("./tick-circle");
var _tickCircleDefault = parcelHelpers.interopDefault(_tickCircle);
var _time = require("./time");
var _timeDefault = parcelHelpers.interopDefault(_time);
var _timelineAreaChart = require("./timeline-area-chart");
var _timelineAreaChartDefault = parcelHelpers.interopDefault(_timelineAreaChart);
var _timelineBarChart = require("./timeline-bar-chart");
var _timelineBarChartDefault = parcelHelpers.interopDefault(_timelineBarChart);
var _timelineEvents = require("./timeline-events");
var _timelineEventsDefault = parcelHelpers.interopDefault(_timelineEvents);
var _timelineLineChart = require("./timeline-line-chart");
var _timelineLineChartDefault = parcelHelpers.interopDefault(_timelineLineChart);
var _tint = require("./tint");
var _tintDefault = parcelHelpers.interopDefault(_tint);
var _torch = require("./torch");
var _torchDefault = parcelHelpers.interopDefault(_torch);
var _tractor = require("./tractor");
var _tractorDefault = parcelHelpers.interopDefault(_tractor);
var _train = require("./train");
var _trainDefault = parcelHelpers.interopDefault(_train);
var _translate = require("./translate");
var _translateDefault = parcelHelpers.interopDefault(_translate);
var _trash = require("./trash");
var _trashDefault = parcelHelpers.interopDefault(_trash);
var _tree = require("./tree");
var _treeDefault = parcelHelpers.interopDefault(_tree);
var _trendingDown = require("./trending-down");
var _trendingDownDefault = parcelHelpers.interopDefault(_trendingDown);
var _trendingUp = require("./trending-up");
var _trendingUpDefault = parcelHelpers.interopDefault(_trendingUp);
var _trophy = require("./trophy");
var _trophyDefault = parcelHelpers.interopDefault(_trophy);
var _truck = require("./truck");
var _truckDefault = parcelHelpers.interopDefault(_truck);
var _twoColumns = require("./two-columns");
var _twoColumnsDefault = parcelHelpers.interopDefault(_twoColumns);
var _unarchive = require("./unarchive");
var _unarchiveDefault = parcelHelpers.interopDefault(_unarchive);
var _underline = require("./underline");
var _underlineDefault = parcelHelpers.interopDefault(_underline);
var _undo = require("./undo");
var _undoDefault = parcelHelpers.interopDefault(_undo);
var _ungroupObjects = require("./ungroup-objects");
var _ungroupObjectsDefault = parcelHelpers.interopDefault(_ungroupObjects);
var _unknownVehicle = require("./unknown-vehicle");
var _unknownVehicleDefault = parcelHelpers.interopDefault(_unknownVehicle);
var _unlink = require("./unlink");
var _unlinkDefault = parcelHelpers.interopDefault(_unlink);
var _unlock = require("./unlock");
var _unlockDefault = parcelHelpers.interopDefault(_unlock);
var _unpin = require("./unpin");
var _unpinDefault = parcelHelpers.interopDefault(_unpin);
var _unresolve = require("./unresolve");
var _unresolveDefault = parcelHelpers.interopDefault(_unresolve);
var _updated = require("./updated");
var _updatedDefault = parcelHelpers.interopDefault(_updated);
var _upload = require("./upload");
var _uploadDefault = parcelHelpers.interopDefault(_upload);
var _user = require("./user");
var _userDefault = parcelHelpers.interopDefault(_user);
var _variable = require("./variable");
var _variableDefault = parcelHelpers.interopDefault(_variable);
var _vector = require("./vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _verticalBarChartAsc = require("./vertical-bar-chart-asc");
var _verticalBarChartAscDefault = parcelHelpers.interopDefault(_verticalBarChartAsc);
var _verticalBarChartDesc = require("./vertical-bar-chart-desc");
var _verticalBarChartDescDefault = parcelHelpers.interopDefault(_verticalBarChartDesc);
var _verticalDistribution = require("./vertical-distribution");
var _verticalDistributionDefault = parcelHelpers.interopDefault(_verticalDistribution);
var _verticalInbetween = require("./vertical-inbetween");
var _verticalInbetweenDefault = parcelHelpers.interopDefault(_verticalInbetween);
var _video = require("./video");
var _videoDefault = parcelHelpers.interopDefault(_video);
var _virus = require("./virus");
var _virusDefault = parcelHelpers.interopDefault(_virus);
var _volumeDown = require("./volume-down");
var _volumeDownDefault = parcelHelpers.interopDefault(_volumeDown);
var _volumeOff = require("./volume-off");
var _volumeOffDefault = parcelHelpers.interopDefault(_volumeOff);
var _volumeUp = require("./volume-up");
var _volumeUpDefault = parcelHelpers.interopDefault(_volumeUp);
var _walk = require("./walk");
var _walkDefault = parcelHelpers.interopDefault(_walk);
var _warningSign = require("./warning-sign");
var _warningSignDefault = parcelHelpers.interopDefault(_warningSign);
var _waterfallChart = require("./waterfall-chart");
var _waterfallChartDefault = parcelHelpers.interopDefault(_waterfallChart);
var _waves = require("./waves");
var _wavesDefault = parcelHelpers.interopDefault(_waves);
var _widget = require("./widget");
var _widgetDefault = parcelHelpers.interopDefault(_widget);
var _widgetButton = require("./widget-button");
var _widgetButtonDefault = parcelHelpers.interopDefault(_widgetButton);
var _widgetFooter = require("./widget-footer");
var _widgetFooterDefault = parcelHelpers.interopDefault(_widgetFooter);
var _widgetHeader = require("./widget-header");
var _widgetHeaderDefault = parcelHelpers.interopDefault(_widgetHeader);
var _wind = require("./wind");
var _windDefault = parcelHelpers.interopDefault(_wind);
var _wrench = require("./wrench");
var _wrenchDefault = parcelHelpers.interopDefault(_wrench);
var _wrenchRedo = require("./wrench-redo");
var _wrenchRedoDefault = parcelHelpers.interopDefault(_wrenchRedo);
var _wrenchSnooze = require("./wrench-snooze");
var _wrenchSnoozeDefault = parcelHelpers.interopDefault(_wrenchSnooze);
var _wrenchTime = require("./wrench-time");
var _wrenchTimeDefault = parcelHelpers.interopDefault(_wrenchTime);
var _zoomIn = require("./zoom-in");
var _zoomInDefault = parcelHelpers.interopDefault(_zoomIn);
var _zoomOut = require("./zoom-out");
var _zoomOutDefault = parcelHelpers.interopDefault(_zoomOut);
var _zoomToFit = require("./zoom-to-fit");
var _zoomToFitDefault = parcelHelpers.interopDefault(_zoomToFit);

},{"./add":"kVgye","./add-clip":"ksbi6","./add-column-left":"1z81k","./add-column-right":"3aKiM","./add-location":"fk3zJ","./add-row-bottom":"lHRRn","./add-row-top":"eRT4r","./add-to-artifact":"fruml","./add-to-folder":"eewyU","./aimpoints-target":"l1xYR","./airplane":"kfjap","./align-center":"hMWGE","./align-justify":"iAKnK","./align-left":"2gl7W","./align-right":"fE4CR","./alignment-bottom":"kEYZF","./alignment-horizontal-center":"6FZ4a","./alignment-left":"eWywb","./alignment-right":"cENjN","./alignment-top":"3eENI","./alignment-vertical-center":"eXN5a","./ammunition":"VD9Z9","./anchor":"Drz15","./annotation":"3cVAu","./antenna":"7DDtr","./app-header":"cnWt5","./application":"02h8z","./applications":"aKBs2","./archive":"bVUT7","./area-of-interest":"9TLTc","./array":"iqp3O","./array-boolean":"JCs2N","./array-date":"5yR7Z","./array-floating-point":"gPq8e","./array-numeric":"dY7mR","./array-string":"cz1UG","./array-timestamp":"4B1hg","./arrow-bottom-left":"c5nxZ","./arrow-bottom-right":"cfN9d","./arrow-down":"2pxQQ","./arrow-left":"8GUj8","./arrow-right":"65v9F","./arrow-top-left":"5evxJ","./arrow-top-right":"1wz2d","./arrow-up":"9gwWr","./arrows-arc":"66Zdh","./arrows-horizontal":"8A2yx","./arrows-vertical":"imCjv","./asterisk":"kskFS","./at":"cHRnh","./automatic-updates":"amW1m","./axle":"b9xl5","./backlink":"l2sxe","./backward-ten":"elD2P","./badge":"eFHBF","./ban-circle":"aqegm","./bank-account":"4mC4p","./barcode":"lxAgi","./binary-number":"gkgAe","./blank":"ayDgu","./block-promote":"iXI7p","./blocked-person":"hu0V1","./bold":"it6b5","./book":"6YC1D","./bookmark":"dh34a","./box":"et0QE","./briefcase":"6LM3e","./bring-data":"aSdXW","./bring-forward":"2BEoa","./british-pound":"1Fv4M","./bug":"5Ce3M","./buggy":"EmFJE","./build":"IsY0G","./bullseye":"aFky1","./calculator":"j0P6V","./calendar":"48NyK","./camera":"g7PLf","./caret-down":"gyGk5","./caret-left":"3K5h3","./caret-right":"cRwLZ","./caret-up":"1gmY0","./cargo-ship":"a0iLT","./cell-tower":"1Cu9l","./changes":"9HNnc","./chart":"bF8Xo","./chat":"2fOls","./chevron-backward":"6v3na","./chevron-down":"bGviy","./chevron-forward":"3fFyF","./chevron-left":"iatvL","./chevron-right":"j8qP1","./chevron-up":"dFQDy","./circle":"5vS7i","./circle-arrow-down":"6hE18","./circle-arrow-left":"2dCET","./circle-arrow-right":"2S3fz","./circle-arrow-up":"hIXOw","./citation":"ePSRN","./clean":"9s8iI","./clip":"1pIaC","./clipboard":"aJmO7","./clipboard-file":"inGae","./cloud":"dFUcw","./cloud-download":"70HUO","./cloud-server":"3W3UV","./cloud-tick":"6BxCw","./cloud-upload":"9tSqE","./code":"5kIf1","./code-block":"28xec","./cog":"5sSXj","./collapse-all":"jQHl0","./color-fill":"jVheJ","./column-layout":"fzXhq","./comment":"bC68k","./comparison":"4dahf","./compass":"7P17o","./compressed":"gDGYK","./confirm":"19yvU","./console":"d7ipo","./contrast":"9fomG","./control":"lVnfU","./credit-card":"jcyp0","./crop":"k52me","./cross":"2UAIU","./cross-circle":"g8xub","./crown":"3n1ik","./css-style":"lLGJU","./cube":"aULJA","./cube-add":"670YV","./cube-edit":"fBAPe","./cube-remove":"eC9JV","./cubes":"NdDuD","./curly-braces":"8glhC","./curved-range-chart":"54GIW","./cut":"9OgJF","./cycle":"gxdEV","./dashboard":"jDLpo","./data-connection":"5Xc71","./data-lineage":"aiS3p","./data-search":"bog7j","./data-sync":"6oWyx","./database":"jJiB6","./delete":"cYv41","./delta":"kZ1wM","./derive-column":"eVgJz","./desktop":"6VUOC","./detection":"1XPf0","./diagnosis":"hvmV8","./diagram-tree":"3IdUU","./direction-left":"iWgSx","./direction-right":"k6283","./disable":"9PNQM","./divide":"iqqvm","./document":"8WMNQ","./document-open":"6aiUZ","./document-share":"4KS5W","./dollar":"egwZQ","./dot":"fKEJk","./double-caret-horizontal":"2AKK1","./double-caret-vertical":"6cZyw","./double-chevron-down":"g2CTj","./double-chevron-left":"39Vzx","./double-chevron-right":"bQopU","./double-chevron-up":"dWaxT","./doughnut-chart":"hYJUx","./download":"dJvHG","./drag-handle-horizontal":"1pLtH","./drag-handle-vertical":"3BBUX","./draw":"6xkgx","./drawer-left":"98GyU","./drawer-left-filled":"3Va4q","./drawer-right":"j9AOb","./drawer-right-filled":"jJcIO","./drive-time":"65TfX","./duplicate":"frn4X","./edit":"hbxaV","./eject":"2FA1D","./emoji":"3SyP0","./endnote":"l6ye2","./endorsed":"gDHS1","./envelope":"fzOIL","./equals":"exUuJ","./eraser":"4Nrox","./error":"a0lsD","./euro":"bRylr","./excavator":"2XImA","./exchange":"cwYDc","./exclude-row":"lk1gX","./expand-all":"hAQpC","./explain":"h6yc5","./export":"6nRsA","./eye-off":"a1sKF","./eye-on":"67CKb","./eye-open":"7JN6Y","./fast-backward":"jbnb7","./fast-forward":"7uVer","./feed":"4J2B0","./feed-subscribed":"9ku7U","./fighter-jet":"4mX2F","./film":"cuzsm","./filter":"fKgQ4","./filter-keep":"bxuGO","./filter-list":"cmEPm","./filter-open":"bDPoX","./filter-remove":"6SiFl","./filter-sort-asc":"iygxH","./filter-sort-desc":"eh0po","./flag":"3oplg","./flame":"jmhWN","./flash":"4rIFS","./floating-point":"gKZIy","./floppy-disk":"7lpWC","./flow-branch":"eYKxa","./flow-end":"6gGR1","./flow-linear":"3UYwQ","./flow-review":"4tyRZ","./flow-review-branch":"1tk2Z","./flows":"8dbEJ","./folder-close":"3ZS05","./folder-new":"6mZQF","./folder-open":"jNMsz","./folder-shared":"dYSXW","./folder-shared-open":"68lqo","./follower":"dQmZP","./following":"7kTYb","./font":"hNvCN","./fork":"4hagU","./form":"akhp2","./forward-ten":"hrAB8","./fuel":"6i6mm","./full-circle":"kDRLl","./full-stacked-chart":"bFnmI","./fullscreen":"5JOtP","./function":"ezVq6","./gantt-chart":"7QtCH","./generate":"88RYW","./geofence":"9mnjA","./geolocation":"93hcI","./geosearch":"7Uhsn","./geotime":"k7RA8","./git-branch":"kTWsA","./git-commit":"kxF2b","./git-merge":"fEgS3","./git-new-branch":"iPT08","./git-pull":"2I5yt","./git-push":"b9E55","./git-repo":"1kKac","./glass":"i5tDy","./globe":"gP3Ks","./globe-network":"hG1ln","./globe-network-add":"03r8I","./graph":"1WHK0","./graph-remove":"gSStV","./greater-than":"1Zp6p","./greater-than-or-equal-to":"kCqRm","./grid":"aOu3r","./grid-view":"dDcYL","./group-item":"eqNPM","./group-objects":"5ofhn","./grouped-bar-chart":"h3Nbg","./hand":"dBmL3","./hand-down":"1N5nF","./hand-left":"5GWSX","./hand-right":"kuCnR","./hand-up":"jOa7q","./hat":"7LNzl","./header":"dMh40","./header-one":"kUnWZ","./header-three":"moBiE","./header-two":"iAMDL","./headset":"80IIj","./heart":"b7FIs","./heart-broken":"8PKiC","./heat-grid":"6Cfks","./heatmap":"6L8NL","./helicopter":"asiTL","./help":"ckTM0","./helper-management":"2ywwH","./hexagon":"5YbeE","./high-priority":"aNaNt","./high-voltage-pole":"5EJie","./highlight":"kqFPH","./history":"gzvpD","./home":"lIMeM","./horizontal-bar-chart":"4fZQN","./horizontal-bar-chart-asc":"3L3dc","./horizontal-bar-chart-desc":"bbIBz","./horizontal-distribution":"9WXYr","./horizontal-inbetween":"g0gco","./hurricane":"kXEJN","./id-number":"51V5k","./image-rotate-left":"dNxdF","./image-rotate-right":"fv6F4","./import":"f3ugY","./inbox":"kx2of","./inbox-filtered":"dpisi","./inbox-geo":"biKuM","./inbox-search":"ljDIq","./inbox-update":"4jCyk","./info-sign":"6VOun","./inheritance":"g5hpM","./inherited-group":"9FEOz","./inner-join":"fjBaq","./input":"bQRpE","./insert":"35X03","./intelligence":"ksOaJ","./intersection":"bcLz2","./ip-address":"h835B","./issue":"jB77G","./issue-closed":"fdDkX","./issue-new":"iriT9","./italic":"4BIQk","./join-table":"aFVIO","./key":"g7TW0","./key-backspace":"5TBKn","./key-command":"dzSIy","./key-control":"i1OlC","./key-delete":"8PbaZ","./key-enter":"i920w","./key-escape":"6XR7p","./key-option":"csfMk","./key-shift":"1SbGP","./key-tab":"eXnzm","./known-vehicle":"bKaqj","./lab-test":"16fjD","./label":"j0PVh","./layer":"hKDS2","./layer-outline":"d5ovR","./layers":"bGsxq","./layout":"4QKdG","./layout-auto":"7xO4D","./layout-balloon":"boQ2o","./layout-bottom-row-three-tiles":"5a69X","./layout-bottom-row-two-tiles":"lyxIi","./layout-circle":"l7m6U","./layout-grid":"8r0fQ","./layout-group-by":"hdknN","./layout-hierarchy":"gQK8b","./layout-left-column-three-tiles":"2To6G","./layout-left-column-two-tiles":"fd0T1","./layout-linear":"8gXyG","./layout-right-column-three-tiles":"408Lk","./layout-right-column-two-tiles":"buQAD","./layout-skew-grid":"1ogi2","./layout-sorted-clusters":"kaFmJ","./layout-three-columns":"eiARR","./layout-three-rows":"47gUw","./layout-top-row-three-tiles":"6k1rs","./layout-top-row-two-tiles":"7KTAq","./layout-two-columns":"d7sv1","./layout-two-rows":"lgGoS","./learning":"97Ptg","./left-join":"5eLLK","./lengthen-text":"drk9K","./less-than":"kFNIJ","./less-than-or-equal-to":"5grpI","./lifesaver":"7x8vh","./lightbulb":"ag6Q2","./lightning":"93F85","./link":"aCboZ","./linked-squares":"bPSmk","./list":"0In9g","./list-columns":"4NMzc","./list-detail-view":"Ve8Sc","./locate":"kf6gC","./lock":"d3yNN","./locomotive":"exX9v","./log-in":"yjnkQ","./log-out":"lP96p","./low-voltage-pole":"9wPwC","./manual":"iW18G","./manually-entered-data":"cGzBj","./many-to-many":"7jSvo","./many-to-one":"lvPp5","./map":"6R6KF","./map-create":"eLTDe","./map-marker":"70QiO","./maximize":"2OhzM","./media":"dBOyu","./menu":"jCCfs","./menu-closed":"dZPQG","./menu-open":"a8AYg","./merge-columns":"4XneN","./merge-links":"6o7SA","./microphone":"lTCQd","./minimize":"76AvL","./minus":"8jEzR","./mobile-phone":"5YiDv","./mobile-video":"jTxgG","./modal":"cqXY4","./modal-filled":"21B9v","./model":"i6Xhp","./moon":"hHIEE","./more":"8rdRC","./mountain":"6kC45","./move":"80vLd","./mugshot":"euVxe","./multi-select":"eGidF","./music":"32x05","./nest":"ilB2x","./new-drawing":"jVxLi","./new-grid-item":"l2P5S","./new-layer":"iDLlQ","./new-layers":"bUX8Z","./new-link":"6zYSZ","./new-object":"jJ8U9","./new-person":"b317U","./new-prescription":"5EtjQ","./new-shield":"kAQiq","./new-text-box":"a4NaI","./ninja":"kz2y8","./not-equal-to":"cEnko","./notifications":"fK0z6","./notifications-snooze":"9utuK","./notifications-updated":"2pWF8","./numbered-list":"gaDuy","./numerical":"cukyD","./object-view":"7YlFE","./office":"8XwbE","./offline":"gidog","./oil-field":"fXzhB","./one-column":"7UL2s","./one-to-many":"4na0P","./one-to-one":"1qSWP","./open-application":"8HbaQ","./outdated":"ecb5E","./output":"lysoC","./package":"c6Q3c","./page-layout":"5fwON","./panel":"a49Cf","./panel-stats":"9Q1mx","./panel-table":"ffEdr","./paperclip":"6B4k9","./paragraph":"hH40l","./paste-variable":"3Qkvc","./path":"7aGaO","./path-search":"2NwLn","./pause":"ddTza","./people":"2A7kj","./percentage":"cdXnv","./person":"h1zqm","./phone":"3AX6C","./phone-call":"7Yccz","./phone-forward":"dbYmi","./pie-chart":"ikhn3","./pill":"94JXz","./pin":"A3nuO","./pivot":"lM81A","./pivot-table":"azH3F","./play":"5PzP5","./playbook":"4LOiw","./plus":"xEKGG","./polygon-filter":"cbq1l","./power":"8KHHH","./predictive-analysis":"cScpJ","./prescription":"iM3N3","./presentation":"18yiu","./print":"7OLNk","./projects":"4WLQU","./properties":"bdRuc","./property":"2SDg3","./publish-function":"i64HD","./pulse":"2y3BV","./rain":"8hxDg","./random":"hf0nv","./range-ring":"iKLnk","./record":"24Yea","./rect-height":"askQP","./rect-width":"cXT81","./rectangle":"5KDm6","./redo":"5gcOt","./refresh":"3LVfg","./regex":"6wGfe","./regression-chart":"dLZDv","./remove":"kgrDs","./remove-column":"d4pSb","./remove-column-left":"2z9vC","./remove-column-right":"gED3j","./remove-row-bottom":"atQBh","./remove-row-top":"9Wpka","./repeat":"4lhab","./reset":"3kbod","./resolve":"OH0F6","./rig":"j11Ca","./right-join":"ihj8H","./ring":"kL3Lg","./rocket":"fvN6k","./rocket-slant":"gPl4P","./rotate-ccw":"cWv1r","./rotate-cw":"jLY1i","./rotate-document":"grbid","./rotate-page":"7AVLR","./route":"QZ7et","./satellite":"6HuEF","./saved":"baSyi","./scatter-plot":"hxyeR","./search":"hfGO4","./search-around":"6BGli","./search-template":"hj1oy","./search-text":"lJ3ae","./segmented-control":"7eoQR","./select":"45YRW","./selection":"9RHqL","./send-backward":"g7C1K","./send-message":"781MV","./send-to":"9acC6","./send-to-graph":"1m5GI","./send-to-map":"cGwB7","./sensor":"1ITi8","./series-add":"6tAoY","./series-configuration":"3qlmR","./series-derived":"6lRcU","./series-filtered":"4qt46","./series-search":"2Y0FD","./server":"3jy2g","./server-install":"G9rfD","./settings":"8Wjan","./shapes":"frEIM","./share":"5fj4G","./shared-filter":"1fqhV","./shield":"ehGH6","./ship":"803hS","./shop":"9rDRU","./shopping-cart":"28k88","./shorten-text":"1kLe2","./signal-search":"4J46i","./sim-card":"cBXx5","./slash":"6LNTO","./small-cross":"kPLv0","./small-info-sign":"3yKWy","./small-minus":"dwfGj","./small-plus":"9Zz5l","./small-square":"5LsAK","./small-tick":"44wrO","./snowflake":"ftYuz","./soccer-ball":"eeAzc","./social-media":"jW7Bi","./sort":"bGyTU","./sort-alphabetical":"91H1Q","./sort-alphabetical-desc":"h6KZH","./sort-asc":"imvri","./sort-desc":"dzKuJ","./sort-numerical":"vXp1h","./sort-numerical-desc":"30D9I","./spell-check":"A8cLj","./split-columns":"lnOO4","./sports-stadium":"iOKMw","./square":"4BloY","./stacked-chart":"dAiSt","./stadium-geometry":"a0CNY","./star":"hIaL6","./star-empty":"6rPM5","./step-backward":"a9Zzr","./step-chart":"cwgAn","./step-forward":"1kGEa","./stop":"g4HKV","./stopwatch":"f4vSj","./strikethrough":"aDvi2","./style":"bjAQj","./subscript":"6knHy","./superscript":"5yET9","./swap-horizontal":"iVJMr","./swap-vertical":"jAKij","./switch":"3aRG7","./symbol-circle":"148VM","./symbol-cross":"iqw7M","./symbol-diamond":"lacUK","./symbol-rectangle":"f1UOT","./symbol-square":"8vbS6","./symbol-triangle-down":"8Ks1R","./symbol-triangle-up":"bkVmP","./syringe":"bJLKe","./table-sync":"8xpZu","./tag":"hfttO","./tag-add":"9fxUi","./tag-promote":"67HWU","./tag-refresh":"hCvxA","./tag-undo":"4Qkvf","./tags":"W3c9s","./take-action":"3O2JC","./tank":"7ztf7","./target":"dvOoU","./taxi":"9QeWE","./team":"4kTOJ","./temperature":"ix2fc","./text-highlight":"eAL6X","./th":"2lyIn","./th-add":"i8RZb","./th-derived":"gXuXJ","./th-disconnect":"ffILc","./th-filtered":"2Gzq4","./th-list":"RlB5N","./th-list-add":"caSzB","./th-virtual":"lMWF1","./th-virtual-add":"aGRFZ","./third-party":"iIFB5","./thumbs-down":"cZkgh","./thumbs-up":"cpUy0","./tick":"kA3r9","./tick-circle":"4EyuI","./time":"fmncb","./timeline-area-chart":"gi10s","./timeline-bar-chart":"97bJU","./timeline-events":"czCb9","./timeline-line-chart":"bsiGI","./tint":"ap2DA","./torch":"4rswT","./tractor":"hfzWP","./train":"7IIbi","./translate":"ffKul","./trash":"5eJLT","./tree":"9IVyN","./trending-down":"hiTKK","./trending-up":"kOi17","./trophy":"9Cfo7","./truck":"491hQ","./two-columns":"aCILT","./unarchive":"gXPqm","./underline":"kxi0w","./undo":"8bSBK","./ungroup-objects":"lgu6l","./unknown-vehicle":"jwQPY","./unlink":"2GuND","./unlock":"1iOaF","./unpin":"d53bh","./unresolve":"5ydUQ","./updated":"7iB73","./upload":"3OpfV","./user":"jPU8O","./variable":"cplpC","./vector":"i3bPx","./vertical-bar-chart-asc":"9y3Kx","./vertical-bar-chart-desc":"5UxLT","./vertical-distribution":"hQqKb","./vertical-inbetween":"4Vs4Z","./video":"1YfkS","./virus":"ljCA0","./volume-down":"fa1hP","./volume-off":"8b3np","./volume-up":"5jW0i","./walk":"2e010","./warning-sign":"lCWts","./waterfall-chart":"2EpkS","./waves":"gBSpY","./widget":"jEDpf","./widget-button":"kqW43","./widget-footer":"9CFWS","./widget-header":"4XHo2","./wind":"7I14p","./wrench":"fOUn4","./wrench-redo":"8bRtf","./wrench-snooze":"avynk","./wrench-time":"7G44s","./zoom-in":"601Ob","./zoom-out":"keNMe","./zoom-to-fit":"3InJX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kVgye":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm5-9h-4V5c0-.55-.45-1-1-1s-1 .45-1 1v4H5c-.55 0-1 .45-1 1s.45 1 1 1h4v4c0 .55.45 1 1 1s1-.45 1-1v-4h4c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ksbi6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0V6h-3a1 1 0 110-2h3V1a1 1 0 011-1zM1 4a1 1 0 00-1 1v4a1 1 0 002 0V6h3a1 1 0 000-2H1zM0 19a1 1 0 001 1h4a1 1 0 100-2H2v-3a1 1 0 10-2 0v4zm15 1h-4a1 1 0 110-2h3v-3a1 1 0 112 0v4a1 1 0 01-1 1zm-7-5a3 3 0 100-6 3 3 0 000 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1z81k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 11h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1H8V7c0-.55-.45-1-1-1s-1 .45-1 1v2H4c-.55 0-1 .45-1 1s.45 1 1 1zM19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-7 18H2V2h10v16zm6 0h-5V2h5v16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3aKiM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 11h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-2V7c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1zm9-11H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM7 18H2V2h5v16zm11 0H8V2h10v16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fk3zJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0a1 1 0 010 2 8 8 0 108 8 1 1 0 012 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 6a4 4 0 110 8 4 4 0 010-8zm6-6c.6 0 1 .4 1 1v2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1s-1-.4-1-1V5h-2c-.6 0-1-.4-1-1 0-.5.4-1 1-1h2V1c0-.6.4-1 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lHRRn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2V8h16v10zm0-11H2V2h16v5zM7 14h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2H7c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eRT4r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 8h2v2c0 .55.45 1 1 1s1-.45 1-1V8h2c.55 0 1-.45 1-1s-.45-1-1-1h-2V4c0-.55-.45-1-1-1s-1 .45-1 1v2H7c-.55 0-1 .45-1 1s.45 1 1 1zm12-8H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2v-5h16v5zm0-6H2V2h16v10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fruml":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 12H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm0 4H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zM1 6h9c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm12 2H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm6-4h-2V2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V6h2c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eewyU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M.01 10V6H20v10c0 .55-.45 1-1 1H9.995v-3.99C9.965 11.332 8.635 10 6.987 10H.01zM19 3c.55 0 1 .45.99 1v1H0V2c0-.55.45-1 1-1h5.997c.28 0 .53.11.71.29L9.414 3H19zM6.987 12c.55 0 .999.45 1.009 1.01v5c0 .55-.45 1-1 1s-.999-.45-.999-1v-2.59l-4.288 4.29a1.003 1.003 0 01-1.42-1.42L4.579 14H1.989c-.55 0-1-.45-1-1s.45-1 1-1h4.998z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l1xYR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.296 12.163a4.492 4.492 0 00-1.792.98A9.99 9.99 0 010 10C0 4.477 4.477 0 10 0a9.99 9.99 0 013.143.504 4.492 4.492 0 00-.98 1.792 8 8 0 00-9.867 9.867zM18 10c0-.75-.103-1.475-.296-2.163a4.491 4.491 0 001.792-.98C19.823 7.847 20 8.903 20 10c0 5.523-4.477 10-10 10a9.992 9.992 0 01-3.142-.504 4.491 4.491 0 00.98-1.792A8 8 0 0018 10zM19 3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM6 16.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    "M10 4a1 1 0 00-1 1v3a1 1 0 002 0V5a1 1 0 00-1-1zM11 10a1 1 0 011-1h3a1 1 0 010 2h-3a1 1 0 01-1-1zM4 10a1 1 0 011-1h3a1 1 0 010 2H5a1 1 0 01-1-1zM9 12a1 1 0 012 0v3a1 1 0 01-2 0v-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kfjap":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 2c0-1.1-.9-2-2-2-.55 0-1.05.22-1.41.59l-4.84 4.84L2 1 1 3l7.53 5.64L4.17 13H1l-1 1 4 2 2 4 1-1v-3.17l4.36-4.36L17 19l2-1-4.43-9.74 4.84-4.84c.37-.37.59-.87.59-1.42z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hMWGE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 5c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1H5zM1 3h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm12 12c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h6zm4 2H3c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm2-8H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iAKnK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 3h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm18 14H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0-12H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0 4H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0 4H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2gl7W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 7h10c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm0-4h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 14H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm4-8H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM1 15h6c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fE4CR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 17H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM1 3h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm18 10h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H9c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kEYZF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 16h4c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1zm7 2H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM4 16h4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6FZ4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 9h-2V7c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v2H9V3c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v6H1c-.55 0-1 .45-1 1s.45 1 1 1h2v6c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-6h2v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eWywb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 0C.45 0 0 .45 0 1v18c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm11 11H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm7-8H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cENjN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm-4 11H8c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm0-8H1c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3eENI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 4H4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm11-4H1C.45 0 0 .45 0 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm-3 4h-4c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eXN5a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 3h-6V1c0-.55-.45-1-1-1S9 .45 9 1v2H3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h6v2H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-2V9h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"VD9Z9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 6v-.172C6 4.018 5.28 2.281 4 1a6.828 6.828 0 00-2 4.828V6h4zM6 18v1H2v-1h4zM6 17V7H2v10h4zM8 19v-1h4v1H8zM12 5.828V6H8v-.172c0-1.81.72-3.547 2-4.828 1.28 1.28 2 3.017 2 4.828zM12 7v10H8V7h4zM14 18v1h4v-1h-4zM18 6v-.172c0-1.81-.72-3.547-2-4.828a6.828 6.828 0 00-2 4.828V6h4zM18 17V7h-4v10h4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Drz15":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 5.83a3.001 3.001 0 10-2 0V7H6v2h3v8.917a6.003 6.003 0 01-4.985-5.488l.278.278a1 1 0 001.414-1.414l-2-2a1 1 0 00-1.414 0l-2 2a1 1 0 101.414 1.414l.303-.303a8 8 0 0015.98 0l.303.303a1 1 0 001.414-1.414l-2-2a1 1 0 00-1.414 0l-2 2a1 1 0 001.414 1.414l.278-.278A6.003 6.003 0 0111 17.917V9h3V7h-3V5.83zM11 3a1 1 0 11-2 0 1 1 0 012 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3cVAu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.41 13.41l7.65-7.65-2.83-2.83-7.65 7.65 2.83 2.83zm10-10c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2-.55 0-1.05.22-1.41.59l-1.65 1.65 2.83 2.83 1.64-1.66zM18 18H2V2h8.93l2-2H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V7.07l-2 2V18zM4 16l4.41-1.59-2.81-2.79L4 16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7DDtr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.01 10.758a8.025 8.025 0 001.01 3.204l.02.035c.034.058.061.117.084.178.163.44.054.951-.33 1.239-.435.328-1.059.242-1.342-.224a9.797 9.797 0 01-.221-.383 10 10 0 1117.48.106c-.269.474-.89.58-1.335.267-.392-.275-.518-.783-.37-1.228a1.19 1.19 0 01.078-.18l.019-.036A8.026 8.026 0 102.01 10.758zm4.272.772a1.464 1.464 0 01.091.32c.07.425-.052.87-.402 1.128-.44.325-1.068.235-1.316-.252a6 6 0 1110.734-.09c-.24.492-.867.593-1.312.275-.354-.253-.483-.695-.42-1.122a1.462 1.462 0 01.085-.321 4.021 4.021 0 00-5.87-4.878 4.02 4.02 0 00-1.59 4.94zm4.712 2.583A.999.999 0 0011 14v-4a1 1 0 10-2 0v4c0 .038.002.076.006.113l-3.753 4.223a1 1 0 001.494 1.328L10 16.005l3.252 3.66a1 1 0 101.495-1.33l-3.753-4.222z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cnWt5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h18zM8 6a1 1 0 00-1.993-.117L6 6v8a1 1 0 001.993.117L8 14v-3h4v3a1 1 0 001.993.117L14 14V6a1 1 0 00-1.993-.117L12 6v3H8V6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"02h8z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.5 9h9c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-9c-.28 0-.5.22-.5.5s.22.5.5.5zm0 2h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5s.22.5.5.5zM19 1H1c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm-1 16H2V6h16v11zM3.5 13h7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-7c-.28 0-.5.22-.5.5s.22.5.5.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aKBs2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 5H1c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 13H2V8h12v10zM3.5 10h7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-7c-.28 0-.5.22-.5.5s.22.5.5.5zm0 2h3c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5s.22.5.5.5zm0 2h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5s.22.5.5.5zM19 0H5c-.55 0-1 .45-1 1v3h2V3h12v10h-1v2h2c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bVUT7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.434 0a1 1 0 01.857.486L20 5v14a1 1 0 01-1 1H1a1 1 0 01-1-1V5L2.709.486A1 1 0 013.566 0h12.868zM10 8c-.55 0-1 .45-1 1v4.58l-1.29-1.29-.081-.073A.996.996 0 007 11.99a1.003 1.003 0 00-.71 1.71l3 3 .096.084c.168.13.38.206.614.206.28 0 .53-.11.71-.29l3-3 .084-.096a1.003 1.003 0 00-1.504-1.324L11 13.58V9l-.007-.116A1.004 1.004 0 0010 8zm6-6H4L2 5.002h16L16 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9TLTc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 4.664C5 2.09 7.241 0 10 0s4.99 2.091 5 4.664C15 7.245 10 14 10 14S5 7.245 5 4.664zM8 5a2 2 0 104.001-.001A2 2 0 008 5zM.504 12.132l4.302-2.458c.322.576.662 1.145.995 1.681l.025.04-3.294 1.881L6.468 18h7.064l3.936-4.724-3.293-1.882.024-.039c.333-.536.673-1.105.995-1.681l4.302 2.458a1 1 0 01.272 1.508l-5 6A1 1 0 0114 20H6a1 1 0 01-.768-.36l-5-6a1 1 0 01.272-1.508z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iqp3O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm5 9a1 1 0 110 2 1 1 0 010-2zM6 9a1 1 0 110 2 1 1 0 010-2zm8 0a1 1 0 110 2 1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"JCs2N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm10 7a1 1 0 01.993.883L16 8v4a1 1 0 01-.883.993L15 13H5a1 1 0 01-.993-.883L4 12V8a1 1 0 01.883-.993L5 7h10zm0 1h-5v4h5V8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5yR7Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm2.5 5a.5.5 0 01.5.5V6h4v-.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V6h1a1 1 0 01.993.883L16 7v7a1 1 0 01-.883.993L15 15H5a1 1 0 01-.993-.883L4 14V7a1 1 0 01.883-.993L5 6h1v-.5a.5.5 0 01.5-.5h1zM15 9H5v5h10V9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPq8e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.992 1.104A1.25 1.25 0 0018.75 0H15c-.47 0-1 .359-1 1s.5 1 1.023 1h3L18 18h-3c-.5 0-1 .359-1 1 0 .69.5 1 1 1h3.75l.146-.008A1.25 1.25 0 0020 18.75V1.25l-.008-.146zM6 1c0-.69-.5-1-1-1H1.25l-.146.008A1.25 1.25 0 000 1.25v17.5l.008.146A1.25 1.25 0 001.25 20H5c.5 0 1-.359 1-1s-.5-1-1-1H2V2h3c.5 0 1-.359 1-1z",
    "M5.434 7.325c-.222.039-.45.058-.684.058v.88h1.68v4.825h1.221V6.25h-.908c-.04.208-.124.384-.254.528-.124.143-.277.26-.46.351a2.067 2.067 0 01-.595.196z",
    "M14.327 6.586c-.294-.219-.677-.329-1.147-.329s-.856.11-1.157.33a2.24 2.24 0 00-.695.827 3.822 3.822 0 00-.339 1.1c-.056.401-.085.79-.085 1.166 0 .376.029.765.085 1.166.063.401.176.77.339 1.11.169.332.4.607.695.827.301.213.687.32 1.157.32s.853-.107 1.147-.32c.301-.22.533-.495.696-.828.17-.338.282-.708.338-1.11a7.55 7.55 0 00.094-1.165 7.55 7.55 0 00-.094-1.166 3.47 3.47 0 00-.338-1.1 2.127 2.127 0 00-.696-.828zm-.564 5.426a.876.876 0 01-.583.197.89.89 0 01-.592-.197 1.516 1.516 0 01-.367-.546 3.485 3.485 0 01-.188-.808 8.056 8.056 0 01-.057-.978c0-.345.02-.668.057-.969.037-.307.1-.576.188-.808.094-.232.216-.414.367-.546a.864.864 0 01.592-.206.85.85 0 01.583.206c.157.132.279.314.367.546.094.232.16.501.197.808.038.301.056.624.056.969s-.018.67-.056.978a3.179 3.179 0 01-.197.808c-.088.226-.21.408-.367.546z",
    "M8.853 11.807h1.358v1.319H8.853v-1.32z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dY7mR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm8.995 6.09c.32 0 .603.047.85.14a1.679 1.679 0 011.015.985c.09.23.135.482.135.755 0 .287-.063.552-.19.795a1.642 1.642 0 01-.57.615v.02l.101.05c.068.039.138.09.209.155.107.097.203.215.29.355a2.09 2.09 0 01.3 1.09c0 .313-.053.597-.16.85a1.898 1.898 0 01-1.12 1.065 2.42 2.42 0 01-.85.145c-.533 0-.99-.127-1.37-.38a1.702 1.702 0 01-.73-1.08c-.013-.067.013-.11.08-.13l.87-.2.041-.003c.038.004.064.028.079.073.073.2.193.37.36.51.167.14.39.21.67.21.32 0 .567-.095.74-.285.173-.19.26-.432.26-.725 0-.347-.1-.618-.3-.815-.2-.197-.47-.295-.81-.295h-.29l-.044-.006c-.037-.013-.056-.044-.056-.094V9.1l.006-.044c.013-.037.044-.056.094-.056h.27l.145-.008a.925.925 0 00.575-.262c.18-.18.27-.42.27-.72 0-.273-.08-.495-.24-.665-.16-.17-.383-.255-.67-.255-.253 0-.453.063-.6.19-.147.127-.25.297-.31.51-.02.06-.06.083-.12.07l-.85-.2-.042-.015c-.035-.02-.048-.055-.038-.105a1.684 1.684 0 01.645-1.035c.17-.13.37-.232.6-.305.23-.073.482-.11.755-.11zm-7.99.11l.044.006c.037.013.056.044.056.094v6.6l-.006.044c-.013.037-.044.056-.094.056h-.92l-.044-.006c-.037-.013-.056-.044-.056-.094V7.54h-.02l-1.04.73-.04.02c-.047.016-.07-.01-.07-.08V7.19l.008-.051a.196.196 0 01.062-.089l1.09-.79.051-.033a.295.295 0 01.129-.027h.85zm3.34-.11c.32 0 .603.05.85.15.247.1.455.235.625.405.17.17.3.37.39.6.09.23.135.478.135.745 0 .307-.057.588-.17.845a3.16 3.16 0 01-.47.745l-1.98 2.4V12h2.52l.044.006c.037.013.056.044.056.094v.8l-.006.044c-.013.037-.044.056-.094.056h-3.82l-.044-.006c-.037-.013-.056-.044-.056-.094v-.75l.006-.05a.165.165 0 01.044-.08l2.4-2.99.124-.167c.077-.11.143-.222.196-.333.08-.167.12-.347.12-.54a.92.92 0 00-.235-.64c-.157-.173-.378-.26-.665-.26-.273 0-.487.077-.64.23-.153.153-.247.36-.28.62-.013.067-.05.093-.11.08l-.88-.18-.043-.015c-.035-.02-.047-.055-.037-.105a1.78 1.78 0 01.56-1.115c.167-.157.372-.282.615-.375a2.35 2.35 0 01.845-.14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cz1UG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm2.012 6c.643 0 1.203.266 1.68.797.477.53.715 1.246.715 2.145a4.472 4.472 0 01-.965 2.814c-.644.83-1.66 1.5-3.047 2.011v-.581l.26-.104a3.87 3.87 0 001.624-1.285c.457-.632.686-1.29.686-1.971 0-.148-.023-.256-.07-.326-.023-.047-.054-.07-.093-.07-.038 0-.1.031-.186.093-.248.179-.558.268-.93.268-.45 0-.843-.18-1.18-.541A1.817 1.817 0 015 7.965c0-.527.194-.986.581-1.378A1.934 1.934 0 017.011 6zm5.593 0c.643 0 1.203.266 1.68.797.477.53.715 1.246.715 2.145a4.472 4.472 0 01-.965 2.814c-.644.83-1.659 1.5-3.047 2.011v-.581l.26-.104a3.87 3.87 0 001.624-1.285c.457-.632.686-1.29.686-1.971 0-.148-.023-.256-.07-.326-.023-.047-.054-.07-.093-.07-.038 0-.1.031-.186.093-.248.179-.558.268-.93.268-.45 0-.843-.18-1.18-.541a1.817 1.817 0 01-.506-1.285c0-.527.194-.986.581-1.378A1.934 1.934 0 0112.604 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4B1hg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm5 4a6 6 0 110 12 6 6 0 010-12zm0 1a5 5 0 100 10 5 5 0 000-10zm2.854 2.146a.5.5 0 01.057.638l-.057.07-2.5 2.5a.5.5 0 01-.638.057l-.07-.057-1.5-1.5a.5.5 0 01.638-.765l.07.057L10 9.293l2.146-2.147a.5.5 0 01.708 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c5nxZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 3a1.003 1.003 0 00-1.71-.71L4 14.59V7c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1H5.41l12.3-12.29c.18-.18.29-.43.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cfN9d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 6c-.55 0-1 .45-1 1v7.59L3.71 2.29a1.003 1.003 0 00-1.42 1.42L14.59 16H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2pxQQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 11c-.3 0-.5.1-.7.3L11 15.6V2c0-.5-.4-1-1-1s-1 .5-1 1v13.6l-4.3-4.3c-.2-.2-.4-.3-.7-.3-.5 0-1 .4-1 1 0 .3.1.5.3.7l6 6c.2.2.4.3.7.3s.5-.1.7-.3l6-6c.2-.2.3-.4.3-.7 0-.6-.5-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8GUj8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 9H4.41L8.7 4.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-6 6c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l6 6a1.003 1.003 0 001.42-1.42L4.41 11H18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"65v9F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.71 9.29l-6-6a1.003 1.003 0 00-1.42 1.42L15.59 9H2c-.55 0-1 .45-1 1s.45 1 1 1h13.59l-4.29 4.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l6-6c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5evxJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17.71 16.29L5.41 4H13c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V5.41L16.29 17.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1wz2d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 2H7c-.55 0-1 .45-1 1s.45 1 1 1h7.59L2.29 16.29a1.003 1.003 0 001.42 1.42L16 5.41V13c0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9gwWr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.7 7.3l-6-6c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3l-6 6c-.2.2-.3.4-.3.7 0 .6.5 1 1 1 .3 0 .5-.1.7-.3L9 4.4V18c0 .5.4 1 1 1s1-.5 1-1V4.4l4.3 4.3c.2.2.4.3.7.3.5 0 1-.4 1-1 0-.3-.1-.5-.3-.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"66Zdh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.246.183a.625.625 0 01.883 0l3.978 3.978a.625.625 0 01-.884.883L5.308 2.13v.004c-.01 2.244-.018 3.935.23 5.393.29 1.708.933 3.07 2.403 4.53 1.478 1.471 2.77 2.11 4.432 2.4 1.437.252 3.134.245 5.488.235h.009l-2.914-2.914a.625.625 0 11.883-.884l3.978 3.978a.625.625 0 010 .883l-3.978 3.978a.625.625 0 11-.883-.884l2.906-2.906c-2.333.01-4.157.016-5.704-.255-1.931-.338-3.452-1.106-5.099-2.744C5.404 11.296 4.64 9.7 4.306 7.736c-.266-1.563-.26-3.374-.248-5.597L1.152 5.044a.625.625 0 11-.884-.883L4.246.183z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8A2yx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.7 9.3l-5-5c-.2-.2-.4-.3-.7-.3-.6 0-1 .4-1 1 0 .3.1.5.3.7L16.6 9H3.4l3.3-3.3c.2-.2.3-.4.3-.7 0-.6-.4-1-1-1-.3 0-.5.1-.7.3l-5 5c-.2.2-.3.4-.3.7s.1.5.3.7l5 5c.2.2.4.3.7.3.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7L3.4 11h13.2l-3.3 3.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3l5-5c.2-.2.3-.4.3-.7s-.1-.5-.3-.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imCjv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 13c-.3 0-.5.1-.7.3L11 16.6V3.4l3.3 3.3c.2.2.4.3.7.3.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7l-5-5c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3l-5 5c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3L9 3.4v13.2l-3.3-3.3c-.2-.2-.4-.3-.7-.3-.6 0-1 .4-1 1 0 .3.1.5.3.7l5 5c.2.2.4.3.7.3s.5-.1.7-.3l5-5c.2-.2.3-.4.3-.7 0-.5-.4-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kskFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.52 14.17l.01-.02L11.89 10l6.64-4.15-.01-.02A.97.97 0 0019 5c0-.55-.45-1-1-1-.2 0-.37.07-.52.17l-.01-.02L11 8.2V1c0-.55-.45-1-1-1S9 .45 9 1v7.2L2.53 4.15l-.01.02A.922.922 0 002 4c-.55 0-1 .45-1 1 0 .36.2.66.48.83l-.01.02L8.11 10l-6.64 4.15.01.02A.97.97 0 001 15c0 .55.45 1 1 1 .2 0 .37-.07.52-.17l.01.02L9 11.8V19c0 .55.45 1 1 1s1-.45 1-1v-7.2l6.47 4.04.01-.02c.15.11.32.18.52.18.55 0 1-.45 1-1 0-.36-.2-.66-.48-.83z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cHRnh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.298 6.818a6.507 6.507 0 00-1.672-.207c-1.057 0-1.881.345-2.472 1.036-.589.691-.884 1.63-.884 2.817 0 1.894.755 2.842 2.266 2.842 1.593 0 2.464-1.192 2.614-3.574l.148-2.914zm6.544-2.592C19.614 5.58 20 7.142 20 8.916c0 1.163-.186 2.224-.556 3.189-.374.963-.894 1.713-1.569 2.25a3.64 3.64 0 01-2.333.803c-.651 0-1.218-.17-1.696-.512a2.486 2.486 0 01-.967-1.39h-.148c-.405.635-.904 1.11-1.498 1.427-.596.318-1.264.475-2.007.475-1.345 0-2.405-.425-3.175-1.279-.774-.854-1.159-2.008-1.159-3.463 0-1.676.512-3.036 1.537-4.08 1.021-1.043 2.396-1.567 4.122-1.567.628 0 1.322.055 2.086.164.764.11 1.443.262 2.037.458l-.272 5.67v.294c0 1.3.43 1.951 1.289 1.951.652 0 1.169-.414 1.553-1.245.384-.829.577-1.886.577-3.171 0-1.39-.291-2.611-.868-3.664a5.948 5.948 0 00-2.463-2.433c-1.065-.569-2.287-.853-3.667-.853-1.757 0-3.287.357-4.588 1.072a7.19 7.19 0 00-2.978 3.069C2.571 7.408 2.23 8.953 2.23 10.708c0 2.358.639 4.172 1.92 5.438 1.279 1.27 3.115 1.902 5.509 1.902 1.826 0 3.729-.365 5.71-1.096v2.001c-1.734.698-3.62 1.047-5.66 1.047-3.056 0-5.437-.811-7.144-2.432C.855 15.945 0 13.683 0 10.781 0 8.659.462 6.77 1.388 5.116c.923-1.653 2.206-2.919 3.845-3.798C6.871.44 8.727 0 10.799 0c1.791 0 3.388.367 4.786 1.098a7.865 7.865 0 013.257 3.128z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"amW1m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 18c-4.42 0-8-3.58-8-8 0-2.52 1.18-4.76 3-6.22V5c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1h2.06C1.61 3.82 0 6.71 0 10c0 5.52 4.48 10 10 10 .55 0 1-.45 1-1s-.45-1-1-1zm0-16c1.64 0 3.15.49 4.42 1.34l1.43-1.43A9.869 9.869 0 0010 0c-.55 0-1 .45-1 1s.45 1 1 1zm10 8c0-1.13-.2-2.21-.54-3.22L17.84 8.4A7.962 7.962 0 0115 16.22V15c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-2.06c2.45-1.82 4.06-4.71 4.06-8zm0-7a1.003 1.003 0 00-1.71-.71L12 8.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l7-7c.18-.18.29-.43.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b9xl5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 15h2v.5a.5.5 0 001 0v-11a.5.5 0 00-1 0V5H2v10zM18 5h-2v-.5a.5.5 0 00-1 0v11a.5.5 0 001 0V15h2V5zM5 8l1.789.894A1 1 0 007.236 9h5.528a1 1 0 00.447-.106L15 8v4l-1.789-.894a.999.999 0 00-.447-.106H7.236a1 1 0 00-.447.106L5 12V8zM0 9h2v2H0V9z",
    "M0 8h1v4H0V8zM19 8h1v4h-1V8z",
    "M20 11h-2V9h2v2zM8 9a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1V9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l2sxe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.387 19.79l-.094-.083L14 15.415V18a1 1 0 01-2 0l.003-5.075.017-.126.03-.111.044-.111.052-.098.067-.096.08-.09a1.01 1.01 0 01.112-.097l.11-.071.114-.054.105-.035.15-.03L13 12h5a1 1 0 110 2h-2.585l4.292 4.293a1 1 0 01-1.32 1.497zM7.036 9.136l-4.45 4.45-.117.127a2 2 0 002.818 2.818l.127-.117 4.45-4.449a4 4 0 01-.885 3.704l-.15.16-2 2A4 4 0 011.02 12.33l.15-.16 2-2a3.998 3.998 0 013.865-1.035zm6.671-3.843a1 1 0 01.083 1.32l-.083.094-7 7a1 1 0 01-1.497-1.32l.083-.094 7-7a1 1 0 011.414 0zm4.121-4.121a4 4 0 01.151 5.497l-.15.16-2 2a3.998 3.998 0 01-3.864 1.036l4.45-4.45.116-.128a2 2 0 00-2.818-2.818l-.127.117-4.45 4.45a4 4 0 01.885-3.705l.15-.16 2-2a4 4 0 015.657 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"elD2P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.754 20a8.469 8.469 0 01-3.417-.693 8.898 8.898 0 01-2.772-1.872 8.898 8.898 0 01-1.872-2.772A8.468 8.468 0 011 11.246c0-.275.093-.506.28-.693a.941.941 0 01.693-.28c.275 0 .506.094.693.28.186.187.28.418.28.693 0 1.897.66 3.506 1.981 4.827 1.321 1.321 2.93 1.982 4.827 1.982 1.896 0 3.505-.66 4.826-1.982 1.321-1.321 1.982-2.93 1.982-4.827 0-1.896-.66-3.505-1.982-4.826-1.32-1.321-2.93-1.982-4.826-1.982h-.146l.826.827a.89.89 0 01.28.68c-.008.26-.101.487-.28.681a.992.992 0 01-.693.304.905.905 0 01-.693-.28L6.544 4.147a.933.933 0 01-.292-.68c0-.26.097-.487.292-.681L9.048.28A.905.905 0 019.741 0c.268.009.499.11.693.304.179.195.272.422.28.681a.89.89 0 01-.28.681l-.826.827h.146c1.215 0 2.354.23 3.416.693a8.897 8.897 0 012.772 1.872 8.898 8.898 0 011.872 2.772c.462 1.062.693 2.2.693 3.416a8.468 8.468 0 01-.693 3.417 8.898 8.898 0 01-1.872 2.772 8.898 8.898 0 01-2.772 1.872A8.469 8.469 0 019.754 20z",
    "M11.5 9.5v3h1v-3h-1zM11 8a1 1 0 00-1 1v4a1 1 0 001 1h2a1 1 0 001-1V9a1 1 0 00-1-1h-2z",
    "M9 9a1 1 0 00-1-1H6.75a.75.75 0 000 1.5h.75v3.75a.75.75 0 001.5 0V9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eFHBF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.94 5.73c-.19-1.41.62-2.52 1.38-3.59L17.03.65C14.89 1.76 11.88 1.48 10 0 8.12 1.48 5.11 1.76 2.97.65L1.68 2.14c.76 1.07 1.57 2.18 1.38 3.59C2.68 8.59 0 10.94 1.4 14.08c.56 1.43 1.81 2.37 3.4 2.75 1.95.46 4.4.91 5.2 3.17.8-2.26 3.25-2.71 5.2-3.17 1.6-.38 2.84-1.32 3.4-2.75 1.4-3.14-1.28-5.49-1.66-8.35z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aqegm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm5 11H5c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4mC4p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.2 8.02l-.78-.18C18.03 6.4 17.2 5.08 16.08 4l.5-2.28c.11-.42-.22-.78-.61-.72-1.06.12-2 .54-2.67 1.26-1.06-.42-2.34-.66-3.56-.66-3.12 0-5.79 1.5-7.4 3.72-.23-.05-.45-.11-.67-.11C.72 5.21 0 5.98 0 7c0 .72.39 1.32.95 1.62-.06.42-.12.9-.12 1.38 0 2.16.89 4.08 2.28 5.58l-.33 2.04c-.11.72.45 1.38 1.12 1.38h.72c.56 0 1-.42 1.11-1.02l.06-.48c1.17.54 2.5.9 3.95.9 1.39 0 2.78-.3 3.95-.9l.06.48c.11.6.56 1.02 1.11 1.02h.72c.67 0 1.22-.66 1.11-1.38l-.33-1.98c.78-.78 1.34-1.74 1.73-2.76l1-.24c.5-.12.89-.6.89-1.2V9.22c.11-.6-.28-1.08-.78-1.2zM15 10c-.6 0-1-.7-1-1.5S14.4 7 15 7s1 .7 1 1.5-.4 1.5-1 1.5zM7.55 5.83a.99.99 0 01-1.38-.28.99.99 0 01.28-1.38c2.34-1.56 4.77-1.56 7.11 0 .46.31.58.93.28 1.39-.31.46-.93.58-1.39.28-1.67-1.12-3.23-1.12-4.9-.01z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lxAgi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 16.98h2v-14H6v14zm3 0h1v-14H9v14zm-6 0h2v-14H3v14zm-3 0h2v-14H0v14zm16 0h2v-14h-2v14zm-4 0h1v-14h-1v14zm7-14v14h1v-14h-1zm-5 14h1v-14h-1v14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gkgAe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.011 5.48C7.58 5.16 7.021 5 6.331 5c-.688 0-1.252.16-1.693.48A3.272 3.272 0 003.62 6.69a5.574 5.574 0 00-.496 1.607A12.204 12.204 0 003 10c0 .55.041 1.117.124 1.703.092.586.257 1.127.496 1.621.247.486.587.889 1.018 1.209.44.311 1.005.467 1.694.467.688 0 1.248-.156 1.68-.467.44-.32.78-.723 1.018-1.209a5.216 5.216 0 00.496-1.62c.091-.587.137-1.155.137-1.704 0-.55-.046-1.117-.137-1.703A5.06 5.06 0 009.03 6.69a3.109 3.109 0 00-1.019-1.21zm-.826 7.927c-.23.192-.514.288-.853.288-.35 0-.638-.096-.868-.288-.22-.202-.399-.467-.537-.797a5.087 5.087 0 01-.275-1.181A11.74 11.74 0 014.57 10c0-.504.028-.975.083-1.415.055-.449.147-.842.275-1.181.138-.339.317-.605.537-.797.23-.201.519-.302.868-.302.34 0 .624.1.853.302.23.192.409.458.537.797.138.339.234.732.29 1.181.054.44.082.911.082 1.415s-.028.98-.083 1.429a4.642 4.642 0 01-.289 1.18c-.128.33-.307.596-.537.798zm5.817-6.836A5.771 5.771 0 0112 6.657v1.286h2.463V15h1.79V5H14.92a1.542 1.542 0 01-.372.771c-.182.21-.406.381-.673.515a3.036 3.036 0 01-.874.285z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ayDgu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var p = [];
exports.default = p;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iXI7p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 9h-1V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v5H2c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-5h1c.55 0 1-.45 1-1s-.45-1-1-1zM6.85 13.35a.47.47 0 01-.35.15.47.47 0 01-.35-.15c-.2-.19-.2-.51 0-.7L8.79 10 6.15 7.35c-.2-.19-.2-.51 0-.7.19-.2.51-.2.7 0l3 3c.2.19.2.51 0 .7l-3 3zm7-3l-3 3a.47.47 0 01-.35.15.47.47 0 01-.35-.15c-.2-.19-.2-.51 0-.7L12.79 10l-2.64-2.65c-.2-.19-.2-.51 0-.7.19-.2.51-.2.7 0l3 3c.2.19.2.51 0 .7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hu0V1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.55 15.92c-1.48-.65-1.28-1.05-1.33-1.59-.01-.07-.01-.15-.01-.23.51-.45.92-1.07 1.19-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.34-.07.54-.44.61-.78.06-.11.14-.35.17-.62C10.33 9.42 8.92 7.38 8.92 5c0-.3.05-.58.09-.87-.33-.08-.67-.13-.99-.13-.79 0-1.68.25-2.31.73-.61.47-1.07 1.13-1.29 1.86-.05.16-.09.33-.11.5-.12.6-.17 1.51-.17 2.14v.08c-.24.09-.45.32-.49.83-.04.39.12.73.2.87.08.35.28.72.63.78.04.17.09.33.15.48 0 .01.01.02.01.03l.01.01c.27.72.7 1.35 1.22 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.38 1.59C3 16.56.77 17.26.32 18.31-.15 19.38.04 20 .04 20h15.95s.18-.62-.27-1.67c-.46-1.06-2.69-1.75-4.17-2.41zM14.97 0c-2.78 0-5.03 2.24-5.03 5s2.25 5 5.03 5S20 7.76 20 5s-2.25-5-5.03-5zm-3.03 5c0-1.66 1.35-3 3.02-3 .47 0 .9.11 1.29.3l-4.01 3.99c-.18-.4-.3-.83-.3-1.29zm3.03 3c-.47 0-.9-.11-1.29-.3l4.01-3.99c.19.39.3.82.3 1.29 0 1.66-1.36 3-3.02 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"it6b5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.3 9c.4-.8.7-1.6.7-2.5C15 4 13 2 10.5 2H5c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h6.5c2.5 0 4.5-2 4.5-4.5 0-1.4-.7-2.7-1.7-3.5zM7 5h3.5c.8 0 1.5.7 1.5 1.5S11.3 8 10.5 8H7V5zm4.5 9H7v-3h4.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6YC1D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 1v18c0 .55.45 1 1 1h2V0H4c-.55 0-1 .45-1 1zm14-1h-2v8l-2-2-2 2V0H7v20h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dh34a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 0c-.55 0-1 .45-1 1v18c0 .55.32.68.71.29L9.3 15.7a.996.996 0 011.41 0l3.59 3.59c.38.39.7.26.7-.29v-8-4.5V1c0-.55-.45-1-1-1H6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"et0QE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.89 6.56l-2.99-6h-.01C16.72.23 16.39 0 16 0H4c-.39 0-.72.23-.89.56H3.1l-3 6h.01C.05 6.69 0 6.84 0 7v12c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V7c0-.16-.05-.31-.11-.44zM11 2h4.38l2 4H11V2zM4.62 2H9v4H2.62l2-4zM18 18H2V8h16v10zM8 12h4c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LM3e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 5h-4V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v3H1c-.55 0-1 .45-1 1v5h4v-1h2v1h8v-1h2v1h4V6c0-.55-.45-1-1-1zm-6 0H7V3h6v2zm3 8h-2v-1H6v1H4v-1H0v6c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-6h-4v1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aSdXW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 18a1 1 0 010 2H2a1 1 0 010-2h16zM9.995 3.005c.55 0 1 .45 1 .999v9.584l1.29-1.288a1.002 1.002 0 011.42 1.419l-3 2.996a1.015 1.015 0 01-1.42 0l-3-2.997a1.002 1.002 0 011.42-1.419l1.29 1.29V4.013c0-.55.45-1.009 1-1.009zM16 0a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2zM7 0a1 1 0 110 2 1 1 0 010-2zM4 0a1 1 0 110 2 1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2BEoa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.293.293a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 3.414V9h8a1 1 0 110 2h-8v3h8a1 1 0 011 1v3a1 1 0 01-1 1H1a1 1 0 01-1-1v-3a1 1 0 011-1h8v-3H1a1 1 0 110-2h8V3.414L6.707 5.707a1 1 0 01-1.414-1.414l4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Fv4M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.62 5.174A3 3 0 009 7v2h4a1 1 0 011 1v1a1 1 0 01-1 1H9v1.377c0 .987-.187 1.867-.534 2.623H17v3H3v-3h.5c.715 0 1.334-.217 1.754-.59.388-.344.746-.944.746-2.033V12H4a1 1 0 01-1-1v-1a1 1 0 011-1h2V7a6 6 0 018.296-5.543C15.516 1.962 16.34 2.857 17 4l-2.402 1.5a3 3 0 00-4.978-.326z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Ce3M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.006 4.272C6.124 2.136 7.866 0 10 0c2.133 0 3.877 2.136 3.994 4.272.49.438.909.956 1.234 1.532L17 5.017V3a1 1 0 112 0v2.667a1 1 0 01-.594.913l-2.5 1.111c.062.344.094.698.094 1.059V10h3a1 1 0 110 2h-3v.5c0 .604-.09 1.187-.255 1.737l2.661 1.182a1 1 0 01.594.914V19a1 1 0 11-2 0v-2.017l-2.147-.954A5.992 5.992 0 0110 18.5a5.992 5.992 0 01-4.853-2.471L3 16.983V19a1 1 0 11-2 0v-2.667a1 1 0 01.594-.913l2.661-1.183A6 6 0 014 12.5V12H1a1 1 0 110-2h3V8.75c0-.361.032-.715.093-1.059l-2.5-1.11A1 1 0 011 5.666V3a1 1 0 012 0v2.017l1.772.787a6.026 6.026 0 011.234-1.532zM6 11v1.5a4 4 0 008 0V8.75a4 4 0 00-8 0V11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"EmFJE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.836 1.014a1 1 0 011.058.539l2.482 4.962.02-.004a.5.5 0 01.604.49v4.5a.5.5 0 01-.5.5h-3.93a1.5 1.5 0 00-1.248.667l-1.406 2.11A.5.5 0 0112.5 15H8a.5.5 0 01-.354-.146l-2.414-2.415A1.5 1.5 0 004.172 12H.5a.5.5 0 01-.5-.5v-3A.5.5 0 01.5 8h.823L3.072 3.63a1 1 0 01.764-.615l12-2zm.289 3.472l1.231 2.462-2.758.591 1.527-3.053zM14.5 3.264l-1.56 3.12-.252-.638-.825-2.043 2.637-.44zm-9.78 1.63l5.122-.854.988 2.445.899 2.27L10.232 11H7.707L4.854 8.147A.5.5 0 004.5 8H3.477l1.242-3.106zM3 19a3 3 0 100-6 3 3 0 000 6zm14 0a3 3 0 100-6 3 3 0 000 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"IsY0G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.43 16.67L9.31 7.81l1.47-1.56c.41-.44-.15-.8.15-1.6 1.08-2.76 4.19-2.99 4.19-2.99s.45-.47.87-.92C11.98-1 9.26.7 8.04 1.8L3.83 6.25l-.86.92c-.48.51-.48 1.33 0 1.84l-.87.92c-.48-.51-1.26-.51-1.74 0s-.48 1.33 0 1.84l1.74 1.84c.48.51 1.26.51 1.74 0s.48-1.33 0-1.84l.87-.92c.48.51 1.26.51 1.74 0l1.41-1.49 8.81 10.07c.76.76 2 .76 2.76 0 .76-.76.76-2 0-2.76z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aFky1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.707.293a1 1 0 010 1.414l-9 9a1 1 0 01-1.414-1.414l9-9a1 1 0 011.414 0z",
    "M14.626 1.132A9.957 9.957 0 0010 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10a9.956 9.956 0 00-1.132-4.626l-1.501 1.502a8 8 0 11-4.243-4.243l1.502-1.501z",
    "M11.554 4.203a6 6 0 104.243 4.243l-1.805 1.804A4 4 0 119.75 6.008l1.804-1.805z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j0P6V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 0H4c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM7 18H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V8h2v2zm4 8H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V8h2v2zm4 8h-2v-6h2v6zm0-8h-2V8h2v2zm0-4H5V2h10v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"48NyK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 5c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1s-1 .5-1 1v2c0 .6.4 1 1 1zM5 5c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1s-1 .5-1 1v2c0 .6.4 1 1 1zm13-2h-1v1c0 1.1-.9 2-2 2s-2-.9-2-2V3H7v1c0 1.1-.9 2-2 2s-2-.9-2-2V3H2c-.5 0-1 .5-1 1v14c0 .5.5 1 1 1h16c.5 0 1-.5 1-1V4c0-.5-.5-1-1-1zM7 17H3v-4h4v4zm0-5H3V8h4v4zm5 5H8v-4h4v4zm0-5H8V8h4v4zm5 5h-4v-4h4v4zm0-5h-4V8h4v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g7PLf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm9-4h-3.59L13.7 2.29A.956.956 0 0013 2H7c-.28 0-.53.11-.71.29L4.59 4H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h4.11c1.26 1.24 2.99 2 4.89 2s3.63-.76 4.89-2H19c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zM4 8H2V6h2v2zm6 8c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gyGk5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 7c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1 0 .24.1.46.24.63l-.01.01 5 6 .01-.01c.19.22.45.37.76.37s.57-.15.76-.37l.01.01 5-6-.01-.01c.14-.17.24-.39.24-.63z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3K5h3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 4c-.24 0-.46.1-.63.24l-.01-.01-6 5 .01.01c-.22.19-.37.45-.37.76s.15.57.37.76l-.01.01 6 5 .01-.01c.17.14.39.24.63.24.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cRwLZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 10c0-.31-.15-.57-.37-.76l.01-.01-6-5-.01.01C7.46 4.1 7.24 4 7 4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1 .24 0 .46-.1.63-.24l.01.01 6-5-.01-.01c.22-.19.37-.45.37-.76z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1gmY0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.76 12.37l.01-.01-5-6-.01.01C10.57 6.15 10.31 6 10 6s-.57.15-.76.37l-.01-.01-5 6 .01.01c-.14.17-.24.39-.24.63 0 .55.45 1 1 1h10c.55 0 1-.45 1-1 0-.24-.1-.46-.24-.63z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a0iLT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.5 1.25h4a1 1 0 011 1V5h-5V1.25zM2.75 5a.25.25 0 00-.25.25v6H.883a.5.5 0 00-.429.757l1.672 2.787c.17.284.384.533.63.741-.458.057-.959.09-1.506.09a.625.625 0 100 1.25c2.583 0 4.268-.68 5.202-1.146.687.466 1.88 1.146 3.548 1.146 1.65 0 2.837-.666 3.528-1.132l.005.003c.244.131.6.3 1.07.468.938.335 2.321.661 4.147.661a.625.625 0 100-1.25c-.319 0-.622-.01-.91-.03.398-.318.717-.738.914-1.23l.972-2.43a.5.5 0 00-.464-.685H5v-6A.25.25 0 004.75 5h-2zm3.455 11.95a.625.625 0 01.658.041c.569.407 1.597 1.134 3.137 1.134s2.568-.727 3.137-1.134a.625.625 0 01.724-.001l.007.005.045.029c.044.027.114.069.21.12.194.104.493.247.9.392.812.29 2.053.589 3.727.589a.625.625 0 110 1.25c-1.826 0-3.21-.326-4.148-.661a7.894 7.894 0 01-1.069-.468l-.005-.003c-.691.466-1.878 1.132-3.528 1.132-1.667 0-2.861-.68-3.548-1.146-.934.467-2.619 1.146-5.202 1.146a.625.625 0 110-1.25c2.66 0 4.23-.787 4.955-1.176zM17.5 6.25h-5V10h4a1 1 0 001-1V6.25zm-11.25-4a1 1 0 011-1h4V5h-5V2.25zm5 4h-5V9a1 1 0 001 1h4V6.25z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Cu9l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.5 8.32c.31-.35.51-.81.51-1.32 0-1.1-.9-2-2-2s-2 .9-2 2c0 .51.2.97.51 1.32L5.06 18.69c-.17.52.11 1.09.63 1.26s1.09-.11 1.26-.63L8.39 15h3.23l1.44 4.32c.17.52.74.81 1.26.63s.81-.74.63-1.26L11.5 8.32zM10.95 13H9.06l.95-2.84.94 2.84zM5.31 10.73a.996.996 0 101.37-1.45c-1.4-1.33-1.28-3.35-.01-4.54.4-.38.43-1.01.05-1.41-.36-.41-1-.43-1.4-.06-2.09 1.95-2.28 5.3-.01 7.46z",
    "M4.6 12.2C3 11.1 2 9 2 7c0-2.1.9-3.9 2.6-5.2.5-.3.5-1 .2-1.4-.3-.5-1-.5-1.4-.2C1.2 1.9-.1 4.2 0 7c.1 2.7 1.4 5.3 3.4 6.8.2.1.4.2.6.2.3 0 .6-.1.8-.4.4-.5.3-1.1-.2-1.4zM13.27 10.69c.38.4 1.01.42 1.41.04 2.27-2.16 2.08-5.51-.01-7.46a.996.996 0 10-1.36 1.46c1.28 1.19 1.39 3.21-.01 4.54-.39.39-.41 1.02-.03 1.42z",
    "M16.6.2c-.4-.3-1.1-.3-1.4.2-.3.4-.3 1.1.2 1.4C17.1 3.1 18 4.9 18 7c0 2-1 4.1-2.6 5.2-.5.3-.6.9-.2 1.4.2.3.5.4.8.4.2 0 .4-.1.6-.2C18.7 12.3 20 9.7 20 7c.09-2.8-1.2-5.1-3.4-6.8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9HNnc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 16H2c-1.1 0-2 .9-2 2s.9 2 2 2h16c1.1 0 2-.9 2-2s-.9-2-2-2zM3 5c.28 0 .53-.11.71-.29L5 3.41V13c0 .55.45 1 1 1s1-.45 1-1V3.41L8.29 4.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3C6.53.11 6.28 0 6 0s-.53.11-.71.29l-3 3A1.003 1.003 0 003 5zm7.29 5.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3a1.003 1.003 0 00-1.42-1.42L15 10.59V1c0-.55-.45-1-1-1s-1 .45-1 1v9.59L11.71 9.3A.965.965 0 0011 9a1.003 1.003 0 00-.71 1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bF8Xo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 11v8c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-8l-2 2-4-2zm-7 8c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-8l-6 3v5zM17 7l-3 3v9c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8.74c-.26.15-.58.26-1 .26-1.92 0-2-2-2-2zm2-6h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59L10.8 8.78 7.45 7.11v.01C7.31 7.05 7.16 7 7 7s-.31.05-.44.11V7.1l-6 3v.01c-.33.17-.56.5-.56.89 0 .55.45 1 1 1 .16 0 .31-.05.44-.11v.01L7 9.12l3.55 1.78v-.01c.14.06.29.11.45.11.28 0 .53-.11.71-.29L18 4.41V6c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2fOls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0H7c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h5.59l3.71 3.71c.17.18.42.29.7.29.55 0 1-.45 1-1v-3h1c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM7 13c-1.1 0-2-.9-2-2V4H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h1v3a1.003 1.003 0 001.71.71L7.41 16H13c.55 0 1-.45 1-1v-.17L12.17 13H7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6v3na":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.41 10l5.29-5.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L7 8.59V4c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55.45 1 1 1s1-.45 1-1v-4.59l5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L8.41 10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bGviy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 6c-.28 0-.53.11-.71.29L10 11.59l-5.29-5.3a1.003 1.003 0 00-1.42 1.42l6 6c.18.18.43.29.71.29s.53-.11.71-.29l6-6A1.003 1.003 0 0016 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3fFyF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 3c-.55 0-1 .45-1 1v4.59l-5.29-5.3a1.003 1.003 0 00-1.42 1.42l5.3 5.29-5.29 5.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l5.29-5.3V16c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iatvL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.41 10l5.29-5.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-6 6c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l6 6a1.003 1.003 0 001.42-1.42L8.41 10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j8qP1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.71 9.29l-6-6a1.003 1.003 0 00-1.42 1.42l5.3 5.29-5.29 5.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l6-6c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dFQDy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.71 12.29l-6-6C10.53 6.11 10.28 6 10 6s-.53.11-.71.29l-6 6a1.003 1.003 0 001.42 1.42L10 8.41l5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5vS7i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6hE18":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 10c-.28 0-.53.11-.71.29L11 12.59V5c0-.55-.45-1-1-1s-1 .45-1 1v7.59L6.71 10.3A.965.965 0 006 10a1.003 1.003 0 00-.71 1.71l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0014 10zM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2dCET":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 9H7.41L9.7 6.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L7.41 11H15c.55 0 1-.45 1-1s-.45-1-1-1zm-5-9C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2S3fz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.71 9.29l-4-4a1.003 1.003 0 00-1.42 1.42L12.59 9H5c-.55 0-1 .45-1 1s.45 1 1 1h7.59l-2.29 2.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hIXOw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.71-13.71C10.53 4.11 10.28 4 10 4s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L9 7.41V15c0 .55.45 1 1 1s1-.45 1-1V7.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ePSRN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 1C1.79 1 0 2.79 0 5s1.79 4 4 4c.1 0 .2-.01.3-.02C3.82 11.32 2.53 13 1 13c-.55 0-1 .45-1 1s.45 1 1 1c3.87 0 7-4.48 7-10 0-2.21-1.79-4-4-4zM16 1c-2.21 0-4 1.79-4 4s1.79 4 4 4c.1 0 .2-.01.3-.02C15.82 11.32 14.53 13 13 13c-.55 0-1 .45-1 1s.45 1 1 1c3.87 0 7-4.48 7-10 0-2.21-1.79-4-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9s8iI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 0L5 5 0 6.998 5 9l2 5 2-5 5-1.995L9 5zM15 10l-1.5 3.496-3.5 1.499 3.5 1.498L15 20l1.5-3.507L20 15l-3.5-1.504z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1pIaC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 1a1 1 0 011-1h5a1 1 0 010 2H2v4a1 1 0 01-2 0V1zm1 19a1 1 0 01-1-1v-5a1 1 0 112 0v4h4a1 1 0 110 2H1zm18 0a1 1 0 001-1v-5a1 1 0 10-2 0v4h-4a1 1 0 100 2h5zm0-20a1 1 0 011 1v5a1 1 0 11-2 0V2h-4a1 1 0 110-2h5zm-9 14a4 4 0 100-8 4 4 0 000 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJmO7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 2c0-.55-.45-1-1-1h-.78a1.98 1.98 0 00-3.44 0H7c-.55 0-1 .45-1 1v2h7V2z",
    "M16 2h-2v3H5V2H3c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"inGae":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 9a1 1 0 011-1h6.586a1 1 0 01.707.293l1.414 1.414a1 1 0 01.293.707V19a1 1 0 01-1 1H8a1 1 0 01-1-1V9zm2.5 2a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 3a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 3a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    "M12 1.943c0-.534-.45-.972-1-.972h-.78A1.99 1.99 0 008.5 0c-.74 0-1.38.389-1.72.971H6c-.55 0-1 .438-1 .972V3h7V1.943z",
    "M13 4H4.04V2H3a1 1 0 00-1 1v14a1 1 0 001 1h3V8a1 1 0 011-1h8V3a1 1 0 00-1-1h-1v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dFUcw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 7c-.12 0-.24.03-.36.04C13.83 4.69 11.62 3 9 3 5.69 3 3 5.69 3 9c0 .05.01.09.01.14A3.98 3.98 0 000 13c0 2.21 1.79 4 4 4h11c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"70HUO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 4c-.12 0-.24.03-.36.04C13.83 1.69 11.62 0 9 0 5.69 0 3 2.69 3 6c0 .05.01.09.01.14A3.98 3.98 0 000 10c0 2.21 1.79 4 4 4h.78c.55-.61 1.34-1 2.22-1v-2c0-1.66 1.34-3 3-3s3 1.34 3 3v2c.88 0 1.66.38 2.2.98C17.87 13.87 20 11.69 20 9c0-2.76-2.24-5-5-5zm-2 11c-.28 0-.53.11-.71.29L11 16.59V11c0-.55-.45-1-1-1s-1 .45-1 1v5.59L7.71 15.3A.965.965 0 007 15a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 0013 15z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3W3UV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 15h11v4H9v-4zm3 2a1 1 0 11-2 0 1 1 0 012 0zm2-1a1 1 0 100 2h4a1 1 0 100-2h-4z",
    "M14.784 5.022C14.856 5.01 14.928 5 15 5a5.004 5.004 0 014.9 4H9a1 1 0 00-1 1v5H4c-2.21 0-4-1.79-4-4a3.98 3.98 0 013.01-3.86c0-.025-.002-.047-.005-.07A.615.615 0 013 7c0-3.31 2.69-6 6-6 2.62 0 4.83 1.69 5.64 4.04.048-.004.096-.011.144-.018z",
    "M9 10h11v4H9v-4zm3 2a1 1 0 11-2 0 1 1 0 012 0zm2-1a1 1 0 100 2h4a1 1 0 100-2h-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6BxCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.784 4.022a2.214 2.214 0 01-.144.018C13.83 1.69 11.62 0 9 0 5.69 0 3 2.69 3 6c0 .025.002.048.005.07a.615.615 0 01.005.07A3.98 3.98 0 000 10c0 2.21 1.79 4 4 4h1.17a3 3 0 014.95-1.121l.88.878 4.879-4.878a3 3 0 014.115-.12A5.002 5.002 0 0015 4c-.072 0-.144.01-.216.022z",
    "M11.707 18.707a1 1 0 01-1.414 0l-3-3a1 1 0 111.414-1.414L11 16.586l6.293-6.293a1 1 0 011.414 1.414l-7 7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9tSqE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.71 10.29c-.18-.18-.43-.29-.71-.29s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L9 13.41V19c0 .55.45 1 1 1s1-.45 1-1v-5.59l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3zM15 4c-.12 0-.24.03-.36.04C13.83 1.69 11.62 0 9 0 5.69 0 3 2.69 3 6c0 .05.01.09.01.14A3.98 3.98 0 000 10c0 2.21 1.79 4 4 4 0-.83.34-1.58.88-2.12l3-3a2.993 2.993 0 014.24 0l3 3-.01.01c.52.52.85 1.23.87 2.02C18.28 13.44 20 11.42 20 9c0-2.76-2.24-5-5-5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5kIf1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 6a1.003 1.003 0 00-1.71-.71l-4 4C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L2.41 10 5.7 6.71c.19-.18.3-.43.3-.71zm6-4c-.46 0-.83.31-.95.73l-4 14c-.02.09-.05.17-.05.27 0 .55.45 1 1 1 .46 0 .83-.31.95-.73l4-14c.02-.09.05-.17.05-.27 0-.55-.45-1-1-1zm7.71 7.29l-4-4a1.003 1.003 0 00-1.42 1.42l3.3 3.29-3.29 3.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"28xec":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 5h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v2H9V3c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8.71 15.29a1.003 1.003 0 01-1.42 1.42l-4-4C3.11 12.53 3 12.28 3 12s.11-.53.29-.71l4-4a1.003 1.003 0 011.42 1.42L5.41 12l3.3 3.29zm8-2.58l-4 4a1.003 1.003 0 01-1.42-1.42l3.3-3.29-3.29-3.29A.965.965 0 0111 8a1.003 1.003 0 011.71-.71l4 4c.18.18.29.43.29.71s-.11.53-.29.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5sSXj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 8h-2.31c-.14-.46-.33-.89-.56-1.3l1.7-1.7a.996.996 0 000-1.41l-1.41-1.41a.996.996 0 00-1.41 0l-1.7 1.7c-.41-.22-.84-.41-1.3-.55V1c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v2.33c-.48.14-.94.34-1.37.58L5 2.28a.972.972 0 00-1.36 0L2.28 3.64c-.37.38-.37.99 0 1.36L3.9 6.62c-.24.44-.44.89-.59 1.38H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2.31c.14.46.33.89.56 1.3L2.17 15a.996.996 0 000 1.41l1.41 1.41c.39.39 1.02.39 1.41 0l1.7-1.7c.41.22.84.41 1.3.55V19c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.33c.48-.14.94-.35 1.37-.59L15 17.72c.37.37.98.37 1.36 0l1.36-1.36c.37-.37.37-.98 0-1.36l-1.62-1.62c.24-.43.45-.89.6-1.38H19c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-9 6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQHl0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.29 8.71c.18.18.43.29.71.29s.53-.11.71-.29l6-6a1.003 1.003 0 00-1.42-1.42L10 6.59l-5.29-5.3a1.003 1.003 0 00-1.42 1.42l6 6zm1.42 2.58c-.18-.18-.43-.29-.71-.29s-.53.11-.71.29l-6 6a1.003 1.003 0 001.42 1.42l5.29-5.3 5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-6-6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jVheJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.188 9h11.984L8 2.828 3.414 7.414C2.811 8.017 2.405 8.48 2.188 9zM8 0L6.586 1.414 2 6c-1 1-2 2.11-2 4 0 2 1 3 2 4l1 1c1 1 2 2 4 2 2.009 0 2.918-.913 3.868-1.867L11 15l4.586-4.586L17 9l-1.414-1.414-6.172-6.172L8 0zm10.5 13.5L17 11l-1.5 2.5c-.318.53-.5 1-.5 1.5 0 1 .5 2 2 2s2-1 2-2c0-.5-.182-.97-.5-1.5zM1 18a1 1 0 100 2h18a1 1 0 100-2H1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fzXhq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 1H1c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM5 17H2V3h3v14zm4 0H6V3h3v14zm9 0h-8V3h8v14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bC68k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3v4a1.003 1.003 0 001.71.71l4.7-4.71H19c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM4 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4dahf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 8H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm13-6h-5c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm0 3h-5V3h5v2zM6 14H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zM6 2H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm4-2c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm9 14h-5c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm0 3h-5v-2h5v2zm0-9h-5c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm0 3h-5V9h5v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7P17o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 10c0 .14-.03.28-.09.4l-3.99 8.98-.01.02a.991.991 0 01-1.82 0l-.01-.02-3.99-8.98c-.06-.12-.09-.26-.09-.4s.03-.28.09-.4L9.08.62 9.09.6a.991.991 0 011.82 0l.01.02 3.99 8.98c.06.12.09.26.09.4zm-5-6.54L7.09 10h5.81L10 3.46z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gDGYK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.89 6.56l-2.99-6h-.01C16.72.23 16.39 0 16 0H4c-.39 0-.72.23-.89.56H3.1l-3 6h.01C.05 6.69 0 6.84 0 7v12c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V7c0-.16-.05-.31-.11-.44zM11 2h4.38l2 4H11V2zM4.62 2H9v4H2.62l2-4zM18 18H2V8h7v4.59L6.71 10.3A.965.965 0 006 10a1.003 1.003 0 00-.71 1.71l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4a1.003 1.003 0 00-1.42-1.42L11 12.59V8h7v10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"19yvU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.71 5.29a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l7-7a1.003 1.003 0 00-1.42-1.42L12 7.59l-2.29-2.3zm7.93 2.32c.23.75.36 1.56.36 2.39 0 4.42-3.58 8-8 8s-8-3.58-8-8a7.998 7.998 0 0111.8-7.04l1.46-1.46C13.73.56 11.93 0 10 0 4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10c0-1.4-.29-2.73-.81-3.95l-1.55 1.56z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d7ipo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 19H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1zM18 6H2v11h16V6zM4 8c.28 0 .53.11.71.29l2 2c.18.18.29.43.29.71s-.11.53-.29.71l-2 2a1.003 1.003 0 01-1.42-1.42L4.59 11l-1.3-1.29A1.003 1.003 0 014 8zm5 4h3c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9fomG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 8h-1.26c-.19-.73-.48-1.42-.85-2.06l.94-.94a.996.996 0 000-1.41l-1.41-1.41a.996.996 0 00-1.41 0l-.94.94c-.65-.38-1.34-.67-2.07-.86V1c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v1.26c-.76.2-1.47.5-2.13.89L5 2.28a.972.972 0 00-1.36 0L2.28 3.64c-.37.38-.37.98 0 1.36l.87.87c-.39.66-.69 1.37-.89 2.13H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h1.26c.19.73.48 1.42.85 2.06l-.94.94a.996.996 0 000 1.41l1.41 1.41c.39.39 1.02.39 1.41 0l.94-.94c.64.38 1.33.66 2.06.85V19c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1.26c.76-.2 1.47-.5 2.13-.89l.88.87c.37.37.98.37 1.36 0l1.36-1.36c.37-.38.37-.98 0-1.36l-.87-.87c.4-.65.7-1.37.89-2.13H19c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-9 7c-2.76 0-5-2.24-5-5s2.24-5 5-5v10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lVnfU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 10h-7v7h7v-7zm0-7h-7v6h7V3zM9 3H3v14h6V3zm10-3H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2V2h16v16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jcyp0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 3H1c-.55 0-1 .45-1 1v2h20V4c0-.55-.45-1-1-1zM0 16c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V8H0v8zm6.5-2h7c.28 0 .5.22.5.5s-.22.5-.5.5h-7c-.28 0-.5-.22-.5-.5s.22-.5.5-.5zm-4 0h2c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k52me":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 19a1 1 0 102 0v-3h3a1 1 0 100-2H6V1a1 1 0 10-2 0v3H1a1 1 0 100 2h3v9a1 1 0 001 1h9v3zm1-15H8v2h6v6h2V5a1 1 0 00-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2UAIU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.41 10l4.29-4.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L10 8.59l-4.29-4.3a1.003 1.003 0 00-1.42 1.42L8.59 10 4.3 14.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4.29-4.3 4.29 4.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L11.41 10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g8xub":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm4.7-13.29L11.41 10l3.3 3.29A1.003 1.003 0 0114 15c-.28 0-.53-.11-.71-.3L10 11.41l-3.29 3.3A1.003 1.003 0 015 14c0-.28.11-.53.3-.71L8.59 10l-3.3-3.29a1.003 1.003 0 011.42-1.42L10 8.59l3.29-3.3A1.003 1.003 0 0115 6c0 .28-.11.53-.3.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3n1ik":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 8l4 2 4-5 4 5 4-2-1 7H3L2 8zm8-6a1 1 0 110 2 1 1 0 010-2zM1 5a1 1 0 110 2 1 1 0 010-2zm18 0a1 1 0 110 2 1 1 0 010-2zM3 16h14v2H3v-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lLGJU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 1a1 1 0 011-1h9l6 6v13a1 1 0 01-1 1h-3.708c.4-.44.708-1.042.708-1.75 0-.086-.004-.17-.012-.25H17V7h-5V2H5v11.72a2.942 2.942 0 00-.498.531 2.703 2.703 0 00-.546-.604A2.77 2.77 0 003 13.142V1z",
    "M2 14c-.518 0-.982.158-1.34.463A1.929 1.929 0 000 15.75v2.5c0 .492.26.933.613 1.238C.97 19.797 1.46 20 2 20c1.015 0 2-.702 2-1.75a.5.5 0 00-1 0c0 .333-.358.75-1 .75a1.13 1.13 0 01-.734-.27c-.19-.163-.266-.347-.266-.48v-2.5c.047-.254.16-.4.308-.526C1.463 15.092 1.69 15 2 15c.334 0 .55.081.69.196.139.113.26.304.317.638a.5.5 0 00.986-.168c-.086-.51-.3-.943-.67-1.244C2.957 14.122 2.494 14 2 14zM5.613 14.512A2.13 2.13 0 017 14c1.015 0 2 .702 2 1.75a.5.5 0 01-1 0c0-.333-.358-.75-1-.75-.289 0-.549.11-.734.27-.19.163-.266.347-.266.48 0 .121.049.229.25.366.221.15.533.27.925.416l.03.01c.353.132.776.29 1.107.516.362.245.688.623.688 1.192 0 .492-.26.933-.613 1.238A2.13 2.13 0 017 20c-1.015 0-2-.702-2-1.75a.5.5 0 011 0c0 .333.358.75 1 .75.289 0 .549-.11.734-.27.19-.163.266-.347.266-.48 0-.121-.049-.229-.25-.366-.288-.195-.632-.306-.955-.427-.353-.131-.776-.289-1.107-.515C5.326 16.697 5 16.32 5 15.75c0-.492.26-.933.613-1.238zM12 14c-.54 0-1.03.203-1.387.512-.353.305-.613.746-.613 1.238 0 .57.326.947.688 1.192.331.226.754.384 1.107.515.323.12.667.232.955.427.201.137.25.245.25.366 0 .133-.076.317-.266.48A1.13 1.13 0 0112 19c-.642 0-1-.417-1-.75a.5.5 0 00-1 0c0 1.048.985 1.75 2 1.75.54 0 1.03-.203 1.387-.512.353-.305.613-.746.613-1.238 0-.57-.326-.947-.688-1.192-.331-.226-.754-.384-1.107-.515l-.03-.011c-.392-.146-.704-.266-.925-.416-.201-.137-.25-.245-.25-.366 0-.133.076-.317.266-.48.185-.16.445-.27.734-.27.642 0 1 .417 1 .75a.5.5 0 001 0c0-1.048-.985-1.75-2-1.75z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aULJA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.953 4.481l7.41-4.02c.394-.215.88-.215 1.275 0l7.409 4.02L10 9.22 1.953 4.48zm-.817.68L9.5 10.085v9.281a1.316 1.316 0 01-.138-.064l-7.714-4.186A1.211 1.211 0 011 14.057v-8.35c0-.193.048-.38.136-.547zm17.728 0c.088.166.136.353.136.546v8.35c0 .438-.247.842-.648 1.06l-7.714 4.186c-.045.024-.091.046-.138.064v-9.281l8.364-4.926z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"670YV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 3h2a1 1 0 010 2h-2v2a1 1 0 01-2 0V5h-2a1 1 0 010-2h2V1a1 1 0 012 0v2zm-3.969 4.435L10 9.22 1.953 4.48l7.41-4.02c.394-.215.88-.215 1.275 0l1.33.721A3.001 3.001 0 0013 7c0 .148.01.293.031.435zm.319.972A3 3 0 0019 7v7.057c0 .438-.247.842-.648 1.06l-7.714 4.186c-.045.024-.091.046-.138.064v-9.281l2.85-1.679zM1.136 5.16L9.5 10.086v9.281a1.316 1.316 0 01-.138-.064l-7.714-4.186A1.211 1.211 0 011 14.057v-8.35c0-.193.048-.38.136-.547z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fBAPe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.809 2.2L10.638.48a1.35 1.35 0 00-1.276 0L1.953 4.5l6.014 3.542zM7.237 8.773L1.136 5.18A1.2 1.2 0 001 5.726v8.35c0 .438.247.843.648 1.06l7.714 4.186q.068.037.138.065v-5.543l-3.168 1.101a1 1 0 01-1.274-1.27l1.345-3.893a1 1 0 01.254-.43zm3.263 4.69v5.924q.07-.028.138-.065l7.714-4.186c.4-.217.648-.622.648-1.06v-8.35c0-.193-.048-.38-.136-.546l-.154.09-.58.58a1 1 0 01-.068.077l-7.415 7.415a1 1 0 01-.147.121",
    "M8.067 9.355l2.575 2.575 6.709-6.709-2.576-2.575zM6 14.002l3.935-1.367-2.573-2.574zM18.221-.004c-.49 0-.969.161-1.29.491l-1.45 1.454 2.57 2.574L19.5 3.06c.32-.33.499-.792.499-1.282 0-.98-.8-1.783-1.779-1.783"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eC9JV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.968 1.182A3.001 3.001 0 0013 7h.77L10 9.22 1.953 4.48l7.41-4.02c.394-.215.88-.215 1.275 0l1.33.721zM19 7v7.057c0 .438-.247.842-.648 1.06l-7.714 4.186c-.045.024-.091.046-.138.064v-9.281L15.74 7H19zM1.136 5.16L9.5 10.086v9.281a1.316 1.316 0 01-.138-.064l-7.714-4.186A1.211 1.211 0 011 14.057v-8.35c0-.193.048-.38.136-.547zM13 3h6a1 1 0 010 2h-6a1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"NdDuD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.707 6.407l4.894-2.292c.367-.172.794-.15 1.142.06l3.662 2.205c.369.223.595.624.595 1.058v5.037c0 .48-.276.916-.707 1.118l-4.894 2.292c-.367.172-.794.15-1.142-.06L9.595 13.62A1.234 1.234 0 019 12.562V7.525c0-.48.276-.915.707-1.117z",
    "M.812 2.098L4.923.139a1.433 1.433 0 011.365.072l3.031 1.857c.423.26.681.718.681 1.213v1.885l-.717.336A2.233 2.233 0 008 7.525v1.562l-1.19-.729a2.433 2.433 0 00-2.317-.122L1.71 9.563.68 8.932A1.423 1.423 0 010 7.719V3.382c0-.548.316-1.048.812-1.284z",
    "M8 10.26v2.302c0 .782.408 1.51 1.08 1.914l.92.555v1.587c0 .548-.316 1.048-.812 1.284l-4.111 1.959a1.433 1.433 0 01-1.365-.072L.681 17.932A1.423 1.423 0 010 16.719v-4.337c0-.548.316-1.048.812-1.284l4.111-1.959a1.433 1.433 0 011.365.072L8 10.26z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8glhC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 3c-1.292 0-2.303.369-2.832 1.305-.234.415-.32.859-.353 1.245-.032.384-.017.781-.001 1.12.034.758.055 1.255-.08 1.644a.853.853 0 01-.253.385c-.124.108-.34.235-.724.33a1 1 0 000 1.941c.384.096.6.223.724.331.12.103.198.225.254.386.134.388.113.885.079 1.643-.016.339-.031.736.001 1.12.033.386.119.83.353 1.245C5.697 16.63 6.708 17 8 17a1 1 0 100-2c-.933 0-1.066-.244-1.089-.286l-.001-.003c-.04-.069-.082-.196-.102-.43a6.887 6.887 0 01.003-.86l.007-.145c.03-.613.073-1.475-.193-2.244A2.874 2.874 0 006.01 10c.293-.314.489-.668.615-1.032.266-.769.223-1.63.193-2.244l-.007-.144a6.887 6.887 0 01-.003-.86c.02-.235.063-.362.102-.432l.001-.002C6.934 5.244 7.067 5 8 5a1 1 0 000-2zM12 3c1.293 0 2.303.369 2.832 1.305.234.415.32.859.353 1.245.032.384.017.781.002 1.12-.035.758-.056 1.255.078 1.644.056.16.134.282.254.385.124.108.34.235.723.33a1 1 0 010 1.941c-.383.096-.599.223-.723.331a.852.852 0 00-.254.386c-.134.388-.113.885-.079 1.643.016.339.031.736-.001 1.12-.033.386-.119.83-.353 1.245C14.302 16.63 13.292 17 12 17a1 1 0 110-2c.933 0 1.066-.244 1.088-.286l.002-.003c.04-.069.082-.196.102-.43.02-.238.012-.513-.004-.86a29.272 29.272 0 00-.006-.145c-.03-.613-.073-1.475.193-2.244.127-.364.322-.718.615-1.032a2.875 2.875 0 01-.615-1.032c-.266-.769-.223-1.63-.193-2.244l.006-.144c.016-.349.024-.623.004-.86-.02-.235-.063-.362-.102-.432l-.002-.002C13.066 5.244 12.934 5 12 5a1 1 0 110-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"54GIW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 16H3.02l2.14-1.74c2.25 1.7 7.33.46 11.83-2.99l-1.29-1.5c-3.56 2.74-7.31 4.03-8.93 3.19l10.55-8.57-.63-.78-10.59 8.6c-.64-1.64 1.46-4.91 5.09-7.7L9.9 3.01c-4.6 3.54-6.91 8.12-5.41 10.51L2 15.54V3c0-.55-.45-1-1-1s-1 .45-1 1v14a.998.998 0 001 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9OgJF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 2s.72-1.28 0-2l-5.29 6.25 1.28 1.54L16 2zm.08 10c-.55 0-1.07.12-1.54.32L4.31 0c-.7.72 0 2 0 2l4.45 6.56-3.19 3.77C5.09 12.12 4.56 12 4 12c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.65-.17-1.26-.45-1.8l2.54-3.67 2.49 3.67c-.27.54-.44 1.15-.44 1.8 0 2.21 1.76 4 3.92 4 2.17 0 3.92-1.79 3.92-4 .02-2.21-1.74-4-3.9-4zM4 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm12.08 0c-1.08 0-1.96-.9-1.96-2s.88-2 1.96-2 1.96.9 1.96 2-.88 2-1.96 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gxdEV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 10a4 4 0 110 8 4 4 0 010-8zM4 10a4 4 0 110 8 4 4 0 010-8zm7.299-5.543l.087.089 1.93 2.232 2.048.708a1 1 0 01.65 1.16l-.031.112a1 1 0 01-1.16.65l-.112-.031-2.302-.796a1 1 0 01-.337-.197l-.092-.094-1.387-1.603-1.891 1.982 2.046 2.274a1 1 0 01.25.547l.007.122v4.24a1 1 0 01-1.993.117l-.007-.117-.001-3.857-2.408-2.676a1 1 0 01-.063-1.26l.082-.099 3.29-3.45a1 1 0 011.394-.053zM16 12a2 2 0 100 4 2 2 0 000-4zM4 12a2 2 0 100 4 2 2 0 000-4zm9.5-10a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jDLpo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM4 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-5C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm6-9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-8 5c0 1.1.9 2 2 2s2-.9 2-2c0-.33-2-8-2-8s-2 7.67-2 8zm6-9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Xc71":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 11.9c.935.674 2.339 1.217 4.023 1.536A6.996 6.996 0 009.393 20c-3.988-.019-7.231-1.083-7.387-2.4L2 17.5v-5.6zM13 8c3.315 0 6 2.685 6 6s-2.685 6-6 6-6-2.685-6-6 2.685-6 6-6zm1 1l-4 6h2.5l-.5 4 4-6h-2.5l.5-4zm3-4.6v3.855a7.003 7.003 0 00-10.779 3.992c-2.408-.391-4.097-1.202-4.214-2.142L2 10V4.4c1.525 1.1 4.3 1.85 7.5 1.85S15.475 5.5 17 4.4zM9.5 0C13.637 0 17 1.125 17 2.5S13.637 5 9.5 5C5.35 5 2 3.875 2 2.5S5.35 0 9.5 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aiS3p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.053 0C.47 0 0 .471 0 1.053V4.21c0 .58.471 1.052 1.053 1.052h3.275a6.332 6.332 0 003.728 4.738 6.33 6.33 0 00-3.728 4.737l-3.275-.001C.47 14.737 0 15.208 0 15.789v3.158C0 19.53.471 20 1.053 20h7.435c.581 0 1.053-.471 1.053-1.053V15.79c0-.58-.472-1.052-1.053-1.052H5.406a5.293 5.293 0 015.195-4.21v2.105c0 .58.471 1.052 1.052 1.052h7.294c.582 0 1.053-.471 1.053-1.052V7.368c0-.58-.471-1.052-1.053-1.052h-7.294c-.581 0-1.052.471-1.052 1.052v2.106a5.293 5.293 0 01-5.194-4.21h3.081c.581 0 1.053-.472 1.053-1.053V1.053C9.54.47 9.069 0 8.488 0H1.053z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bog7j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 9.5V4.1C3.5 5.23 6.52 6 10 6c3.49 0 6.51-.77 8-1.9v5.4a.809.809 0 01-.016.159 6.002 6.002 0 00-10.87 2.173C4.12 11.47 2 10.562 2 9.5zM7 12.906l.003-.105C4.835 12.502 3.047 11.889 2 11.1v5.4c0 1.38 3.58 2.5 8 2.5.697 0 1.373-.028 2.017-.08A6.005 6.005 0 017 13v-.094z",
    "M18 2.5C18 3.88 14.42 5 10 5 5.59 5 2 3.88 2 2.5S5.58 0 10 0s8 1.12 8 2.5z",
    "M15.757 17.172l2.534 2.534a1 1 0 101.415-1.415l-2.534-2.534c.523-.79.828-1.738.828-2.757a5.041 5.041 0 00-.33-1.788A5.002 5.002 0 008 12.922V13a5.002 5.002 0 007.757 4.172zM13 16a3 3 0 100-6 3 3 0 000 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6oWyx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 4.1v5.4c0 1.293 3.145 2.358 7.179 2.487l.404-.404A1.997 1.997 0 0110 11c.548 0 1.052.217 1.417.583l.272.272c.107-.012.213-.024.318-.038.037-.462.218-.906.56-1.25.389-.387.906-.567 1.433-.567a4.96 4.96 0 012.268.546c.47-.318.732-.672.732-1.046V4.1C15.51 5.23 12.49 6 9 6c-3.48 0-6.5-.77-8-1.9zM1 11.1c1.24.934 3.516 1.622 6.233 1.832l-.65.65A2.003 2.003 0 008.1 16.998c.15.74.465 1.42.904 2.003H9c-4.42 0-8-1.12-8-2.5v-5.4z",
    "M9 5c4.42 0 8-1.12 8-2.5S13.42 0 9 0 1 1.12 1 2.5 4.59 5 9 5zM14 11c2.2 0 4 1.8 4 4v.59l.29-.29c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71l-2 2c-.18.18-.43.29-.71.29-.28 0-.53-.11-.71-.29l-2-2a1.003 1.003 0 011.42-1.42l.29.3V15c0-1.1-.9-2-2-2-.6 0-1-.4-1-1s.4-1 1-1zM8 16c.28 0 .53-.11.71-.29l.29-.3V16c0 2.2 1.8 4 4 4 .6 0 1-.4 1-1s-.4-1-1-1c-1.1 0-2-.9-2-2v-.59l.29.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-2-2A.997.997 0 0010 12c-.28 0-.53.11-.71.29l-2 2A1.003 1.003 0 008 16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJiB6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.01 5.1v5.4c0 1.38 3.58 2.5 8 2.5s8-1.12 8-2.5V5.1c-1.49 1.13-4.51 1.9-8 1.9-3.48 0-6.5-.77-8-1.9zm8 .9c4.42 0 8-1.12 8-2.5s-3.58-2.5-8-2.5-8 1.12-8 2.5S5.6 6 10.01 6zm-8 6.1v5.4c0 1.38 3.58 2.5 8 2.5s8-1.12 8-2.5v-5.4c-1.49 1.13-4.51 1.9-8 1.9-3.48 0-6.5-.77-8-1.9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cYv41":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 6a1.003 1.003 0 00-1.71-.71L10 8.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42L8.59 10 5.3 13.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3.29-3.3 3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L11.41 10l3.29-3.29c.19-.18.3-.43.3-.71zm-5-6C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kZ1wM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0L0 20h20L10 0zM9 6l6 12H3L9 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eVgJz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.1 8.2h-.99c.28-1.11.66-1.92 1.12-2.43.28-.32.56-.48.83-.48.05 0 .1.02.13.05.03.03.05.07.05.12 0 .04-.04.13-.11.25a.64.64 0 00-.12.35c0 .15.06.28.18.39.12.11.27.16.45.16.2 0 .36-.07.49-.2s.2-.31.2-.54c0-.26-.1-.47-.3-.63-.19-.16-.51-.24-.95-.24-.68 0-1.3.19-1.85.58-.56.38-1.09 1.02-1.59 1.91-.17.3-.34.5-.49.59-.15.08-.4.13-.74.12l-.23.77h.95l-1.39 5.24c-.23.86-.39 1.39-.47 1.59-.12.29-.3.54-.54.75-.1.08-.21.12-.35.12-.04 0-.07-.01-.1-.03l-.03-.04c0-.02.03-.07.1-.13.07-.07.1-.17.1-.31 0-.15-.05-.28-.16-.38-.11-.1-.27-.15-.47-.15-.25 0-.44.07-.59.2-.15.12-.23.28-.23.46 0 .19.09.36.27.5.19.14.47.21.86.21.61 0 1.16-.15 1.63-.46.48-.31.89-.78 1.25-1.43.35-.64.72-1.68 1.09-3.11l.8-3.03h.96l.24-.77zM19 0h-9c-.55 0-1 .45-1 1v3h2V2h7v16h-7v-2H9v3c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-8.79 13.49c.15.28.32.49.52.61.19.12.44.19.73.19.28 0 .57-.1.86-.3.38-.25.77-.69 1.17-1.31l-.25-.14c-.27.37-.48.6-.61.69-.09.06-.19.09-.31.09-.14 0-.28-.09-.42-.26-.23-.29-.54-1.09-.93-2.4.35-.59.64-.97.87-1.15.17-.13.35-.2.55-.2.07 0 .2.03.39.08s.36.08.5.08c.2 0 .37-.07.5-.2.15-.14.22-.31.22-.52 0-.22-.07-.4-.2-.53s-.33-.2-.58-.2c-.22 0-.43.05-.63.15-.2.1-.45.32-.75.67-.23.25-.56.7-1.01 1.33a6.52 6.52 0 00-.91-2.15l-2.39.39-.05.25c.18-.03.33-.05.45-.05.24 0 .43.1.59.3.25.31.59 1.24 1.02 2.8-.34.44-.58.73-.7.87-.21.22-.38.36-.52.43-.1.05-.22.08-.35.08-.1 0-.26-.05-.49-.16a1.01 1.01 0 00-.42-.11c-.23 0-.42.07-.57.22-.15.14-.23.33-.23.55 0 .21.07.38.21.51.14.13.33.2.56.2.23 0 .44-.05.64-.14.2-.09.45-.29.75-.59s.72-.78 1.25-1.43c.21.61.39 1.06.54 1.35z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6VUOC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0H1C.45 0 0 .45 0 1v13c0 .55.45 1 1 1h5.67l-.5 3H5c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1h-1.17l-.5-3H19c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 13H2V2h16v11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1XPf0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 0a1 1 0 00-1 1v5a1 1 0 002 0V2h4a1 1 0 000-2H1zM0 19a1 1 0 001 1h5a1 1 0 100-2H2v-4a1 1 0 10-2 0v5zM19 20a1 1 0 001-1v-5a1 1 0 10-2 0v4h-4a1 1 0 100 2h5zM20 1a1 1 0 00-1-1h-5a1 1 0 100 2h4v4a1 1 0 102 0V1z",
    "M5 6a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H6a1 1 0 01-1-1V6zm2 7V7h6v6H7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hvmV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 2a1 1 0 01.117 1.993L4 4v5a2 2 0 001.85 1.995L6 11a2 2 0 001.995-1.85L8 9V4a1 1 0 01-.117-1.993L8 2h1a1 1 0 01.993.883L10 3v6a4.002 4.002 0 01-3 3.874V13a3 3 0 003 3 4 4 0 003.995-3.8L14 12V8.792a2.5 2.5 0 112 0V12a6 6 0 01-6 6 5 5 0 01-4.995-4.783L5 13v-.126A4.002 4.002 0 012.005 9.2L2 9V3a1 1 0 01.883-.993L3 2h1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3IdUU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 10v5h-2v-4h-6v4H9v-4H3v4H1v-5a1 1 0 011-1h7V5h2v4h7a1 1 0 011 1zM1 16h2a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1v-2a1 1 0 011-1zm16 0h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1zm-8 0h2a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1v-2a1 1 0 011-1zM9 0h2a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1V1a1 1 0 011-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWgSx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 3.02l-20 7 20 7-5-7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k6283":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 10.02l-20-7 5 7-5 7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9PNQM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM2 10c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L3.69 14.9A7.902 7.902 0 012 10zm8 8c-1.85 0-3.55-.63-4.9-1.69L16.31 5.1A7.902 7.902 0 0118 10c0 4.42-3.58 8-8 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iqqvm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.25 6.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM6 9c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H6zm4 6a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WMNQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.98 0h-8c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V6l-6-6zm4 18h-11V2h6v5h5v11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6aiUZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 15c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h2.59L1.3 16.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L8 12.41V15zm5-15H5c-.55 0-1 .45-1 1v6h2V2h6v5h5v11H6v-.76L4.04 19.2c.1.45.48.8.96.8h13c.55 0 1-.45 1-1V6l-6-6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4KS5W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.09 10.09c-.31.31-.67.57-1.09.72V18H2V2h6v5h1.18c.15-.42.39-.8.7-1.11v-.01l2.45-2.45c-.42-.29-.78-.65-1.01-1.11L9 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V9.24l-.88.88-.03-.03zM19 0h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L11.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 3.41V6c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"egwZQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.57 11.19c-.27-.51-.63-.93-1.07-1.26-.44-.33-.95-.6-1.51-.79-.56-.2-1.14-.36-1.72-.5-.6-.14-1.19-.26-1.75-.38-.57-.13-1.07-.27-1.51-.44-.44-.17-.8-.38-1.07-.63s-.41-.59-.41-1c0-.33.09-.6.28-.81.19-.21.42-.36.69-.47.27-.11.57-.18.88-.22.31-.04.58-.06.8-.06.71 0 1.35.14 1.9.41.55.27.91.81 1.06 1.62h3.36c-.09-.84-.32-1.56-.69-2.16-.37-.6-.83-1.08-1.38-1.45-.56-.37-1.18-.64-1.86-.81-.19-.05-.38-.07-.57-.1V1c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v1.1c-.22.03-.43.05-.66.1-.73.13-1.39.37-1.98.71-.6.34-1.09.8-1.47 1.35-.39.56-.58 1.25-.58 2.08 0 .76.13 1.41.4 1.93.26.52.62.95 1.06 1.28.44.33.94.6 1.5.79.55.2 1.13.36 1.74.5.58.14 1.16.26 1.72.38s1.07.26 1.51.43c.44.17.8.39 1.09.66.28.27.43.63.45 1.06.02.43-.08.78-.3 1.04-.22.26-.49.47-.83.6-.34.14-.7.23-1.09.28-.39.05-.73.07-1.03.07-.87 0-1.61-.2-2.23-.59-.62-.39-.98-1.08-1.07-2.06H3c.02.9.19 1.68.52 2.34.33.66.78 1.21 1.35 1.65.57.44 1.25.77 2.03.98.35.1.71.16 1.08.21V19c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.13c.25-.04.5-.07.76-.13.77-.18 1.47-.46 2.1-.85.63-.39 1.14-.9 1.54-1.53.4-.63.59-1.39.59-2.29.01-.75-.13-1.37-.4-1.88z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fKEJk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 6a4 4 0 100 8 4 4 0 100-8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2AKK1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 4c-.24 0-.46.1-.63.24l-.01-.01-6 5 .01.01c-.22.19-.37.45-.37.76s.15.57.37.76l-.01.01 6 5 .01-.01c.17.14.39.24.63.24.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm11 6c0-.31-.15-.57-.37-.76l.01-.01-6-5-.01.01C12.46 4.1 12.24 4 12 4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1 .24 0 .46-.1.63-.24l.01.01 6-5-.01-.01c.22-.19.37-.45.37-.76z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cZyw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 9h10c.55 0 1-.45 1-1 0-.24-.1-.46-.24-.63l.01-.01-5-6-.01.01C10.57 1.15 10.31 1 10 1s-.57.15-.76.37l-.01-.01-5 6 .01.01C4.1 7.54 4 7.76 4 8c0 .55.45 1 1 1zm10 2H5c-.55 0-1 .45-1 1 0 .24.1.46.24.63l-.01.01 5 6 .01-.01c.19.22.45.37.76.37s.57-.15.76-.37l.01.01 5-6-.01-.01c.14-.17.24-.39.24-.63 0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g2CTj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.29 10.71c.18.18.43.29.71.29s.53-.11.71-.29l6-6a1.003 1.003 0 00-1.42-1.42L10 8.59l-5.29-5.3a1.003 1.003 0 00-1.42 1.42l6 6zM16 9c-.28 0-.53.11-.71.29L10 14.59l-5.29-5.3a1.003 1.003 0 00-1.42 1.42l6 6c.18.18.43.29.71.29s.53-.11.71-.29l6-6A1.003 1.003 0 0016 9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"39Vzx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.41 10l5.29-5.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-6 6c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l6 6a1.003 1.003 0 001.42-1.42L5.41 10zm6 0l5.29-5.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-6 6c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l6 6a1.003 1.003 0 001.42-1.42L11.41 10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQopU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 10c0-.28-.11-.53-.29-.71l-6-6a1.003 1.003 0 00-1.42 1.42L8.59 10 3.3 15.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l6-6c.18-.18.29-.43.29-.71zm5.71-.71l-6-6a1.003 1.003 0 00-1.42 1.42l5.3 5.29-5.29 5.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l6-6c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dWaxT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 11c.28 0 .53-.11.71-.29L10 5.41l5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-6-6A.997.997 0 0010 3c-.28 0-.53.11-.71.29l-6 6A1.003 1.003 0 004 11zm6.71-1.71A.997.997 0 0010 9c-.28 0-.53.11-.71.29l-6 6a1.003 1.003 0 001.42 1.42l5.29-5.3 5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-6-6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYJUx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 10c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6V0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10h-4zm-.09-1h4.04C19.48 4.28 15.72.52 11 .05V4.1A5.98 5.98 0 0115.91 9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dJvHG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm4.71 11.71l-4 4c-.18.18-.43.29-.71.29s-.53-.11-.71-.29l-4-4a1.003 1.003 0 011.42-1.42L9 12.59V5c0-.55.45-1 1-1s1 .45 1 1v7.59l2.29-2.29c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1pLtH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.5 11c-.83 0-1.5.67-1.5 1.5S6.67 14 7.5 14 9 13.33 9 12.5 8.33 11 7.5 11zm-5-5C1.67 6 1 6.67 1 7.5S1.67 9 2.5 9 4 8.33 4 7.5 3.33 6 2.5 6zm0 5c-.83 0-1.5.67-1.5 1.5S1.67 14 2.5 14 4 13.33 4 12.5 3.33 11 2.5 11zm15-2c.83 0 1.5-.67 1.5-1.5S18.33 6 17.5 6 16 6.67 16 7.5 16.67 9 17.5 9zm-5 2c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm5 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-10-5C6.67 6 6 6.67 6 7.5S6.67 9 7.5 9 9 8.33 9 7.5 8.33 6 7.5 6zm5 0c-.83 0-1.5.67-1.5 1.5S11.67 9 12.5 9 14 8.33 14 7.5 13.33 6 12.5 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3BBUX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.5 6C6.67 6 6 6.67 6 7.5S6.67 9 7.5 9 9 8.33 9 7.5 8.33 6 7.5 6zm0 5c-.83 0-1.5.67-1.5 1.5S6.67 14 7.5 14 9 13.33 9 12.5 8.33 11 7.5 11zm0 5c-.83 0-1.5.67-1.5 1.5S6.67 19 7.5 19 9 18.33 9 17.5 8.33 16 7.5 16zm5-12c.83 0 1.5-.67 1.5-1.5S13.33 1 12.5 1 11 1.67 11 2.5 11.67 4 12.5 4zm-5-3C6.67 1 6 1.67 6 2.5S6.67 4 7.5 4 9 3.33 9 2.5 8.33 1 7.5 1zm5 10c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-10c-.83 0-1.5.67-1.5 1.5S11.67 9 12.5 9 14 8.33 14 7.5 13.33 6 12.5 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6xkgx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17.7 12.7c0-.1 0-.2-.1-.3l-2-7c-.1-.3-.3-.6-.6-.7L1.8 0l-.6.5L7.7 7c.3-.2.6-.3 1-.3 1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2c0-.4.1-.7.3-1L.5 1.2l-.5.6L4.7 15c.1.3.4.5.7.6l7 2c.1 0 .2.1.3.1.3 0 .5-.1.7-.3l4-4c.2-.2.3-.5.3-.7zm1 1c-.3 0-.5.1-.7.3l-4 4c-.2.2-.3.4-.3.7 0 .5.4 1 1 1 .3 0 .5-.1.7-.3l4-4c.2-.2.3-.4.3-.7 0-.6-.5-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"98GyU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 0a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h8zM8 2H2v16h6V2zm2 7h6.59L14.3 6.71A.965.965 0 0114 6a1.003 1.003 0 011.71-.71l4 4c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-4 4a1.003 1.003 0 01-1.42-1.42l2.3-2.29H10V9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Va4q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 0h8a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1zm9 9h6.59L14.3 6.71A.965.965 0 0114 6a1.003 1.003 0 011.71-.71l4 4c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-4 4a1.003 1.003 0 01-1.42-1.42l2.3-2.29H10V9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j9AOb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0a1 1 0 011 1v18a1 1 0 01-1 1h-8a1 1 0 01-1-1V1a1 1 0 011-1h8zm-1 2h-6v16h6V2zm-8 7H3.41L5.7 6.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L3.41 11H10V9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJcIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 0h8a1 1 0 011 1v18a1 1 0 01-1 1h-8a1 1 0 01-1-1V1a1 1 0 011-1zm-1 9H3.41L5.7 6.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L3.41 11H10V9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"65TfX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20.01 7.7c0-.63-.5-1.14-1.1-1.14h-1.32l-.95-2.57c-.24-.64-.95-1.31-1.59-1.5 0 0-1.65-.49-5.05-.49s-5.04.49-5.04.49c-.63.19-1.35.86-1.59 1.5l-.95 2.57H1.1C.5 6.56 0 7.07 0 7.7c0 .63.5 1.14 1.1 1.14h.47l-.34.91c-.24.64-.43 1.72-.43 2.4v5.39c0 .8.63 1.45 1.4 1.45.77 0 1.4-.65 1.4-1.45v-.83h12.8v.83c0 .8.63 1.45 1.4 1.45s1.4-.65 1.4-1.45v-5.39c0-.68-.19-1.77-.43-2.4l-.34-.91h.47c.61 0 1.11-.51 1.11-1.14zm-16.47.34l1.12-3.16c.08-.22.32-.39.54-.39h9.6c.22 0 .46.17.54.39l1.12 3.16c.08.21-.04.39-.26.39H3.8c-.22-.01-.34-.18-.26-.39zm.96 4.94c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.68 1.5 1.5c0 .83-.67 1.5-1.5 1.5zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"frn4X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 4H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 14H2V6h12v12zm5-18H5c-.55 0-1 .45-1 1v2h2V2h12v12h-1v2h2c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hbxaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.59 12.59l2.83 2.83 7.65-7.65-2.83-2.83-7.65 7.65zM2 18l4.41-1.59-2.81-2.79L2 18zM16 2c-.55 0-1.05.22-1.41.59l-1.65 1.65 2.83 2.83 1.65-1.65A2.006 2.006 0 0016 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2FA1D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 12h12c.55 0 1-.45 1-1 0-.25-.1-.47-.25-.64l.01-.01-6-7-.01.01C10.57 3.14 10.3 3 10 3s-.57.14-.75.36l-.01-.01-6 7 .01.01c-.15.17-.25.39-.25.64 0 .55.45 1 1 1zm12 1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3SyP0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 2a8 8 0 100 16 8 8 0 000-16zm-4 8l.015.215C6.219 12.42 7.925 14 10 14a4 4 0 003.995-3.8L14 10h2l-.013.238C15.754 13.552 13.163 16 10 16a6 6 0 01-5.996-5.775L4 10h2zm1.5-4a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l6ye2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.943 1.571c-.306.058-.62.086-.943.086v1.286h2.317V10H20V0h-1.253c-.053.305-.17.562-.35.771-.17.21-.381.381-.633.515a2.738 2.738 0 01-.821.285z",
    "M12.833 20c-.408 0-.822-.097-1.242-.29l-.168-.083c-.3-.146-.487-.238-.804-.556v.712H8.55V7h2.07v3.295l-.054 1.485a5.23 5.23 0 011.206-.797 3.19 3.19 0 011.35-.308c.552 0 1.044.11 1.476.326.432.206.798.507 1.098.906.3.386.528.857.684 1.412.156.555.234 1.177.234 1.865 0 .76-.108 1.442-.324 2.046a4.627 4.627 0 01-.828 1.503c-.348.41-.75.724-1.206.941-.456.217-.93.326-1.422.326zm-.432-1.72c.588 0 1.08-.254 1.476-.76.396-.52.594-1.286.594-2.3 0-.893-.15-1.587-.45-2.082-.3-.495-.786-.742-1.458-.742-.624 0-1.272.331-1.944.995v4.147c.312.277.618.47.918.579.312.109.6.163.864.163zM2.61 20c-.78 0-1.41-.236-1.89-.706C.24 18.81 0 18.177 0 17.393c0-.471.096-.888.288-1.25.204-.374.516-.694.936-.96.432-.265.972-.488 1.62-.67.66-.18 1.446-.32 2.358-.416a2.845 2.845 0 00-.108-.652 1.288 1.288 0 00-.27-.56 1.095 1.095 0 00-.486-.381 1.76 1.76 0 00-.756-.145c-.432 0-.858.085-1.278.254a8.75 8.75 0 00-1.206.615l-.756-1.394a8.826 8.826 0 011.656-.815 5.598 5.598 0 011.98-.344c1.104 0 1.926.332 2.466.996.552.652.828 1.6.828 2.843v5.268h-2.07v-.87a4.98 4.98 0 01-1.134.744A3.13 3.13 0 012.61 20zm.666-1.63c.36 0 .684-.084.972-.253.3-.17.618-.41.954-.724V15.4c-.6.072-1.104.169-1.512.29-.408.12-.738.26-.99.416-.252.145-.432.314-.54.507a1.242 1.242 0 00-.162.616c0 .398.12.688.36.869.24.18.546.271.918.271z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gDHS1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.83 9.38L18.81 7.6V5.62c0-.45-.23-.85-.61-1.08l-1.71-1-1.02-1.76a1.25 1.25 0 00-1.08-.61h-2.03l-1.74-1c-.38-.23-.87-.23-1.25 0l-1.74 1H5.65c-.44 0-.85.23-1.08.61L3.58 3.5l-1.8 1.04c-.38.24-.62.64-.62 1.08v2.06L.17 9.4c-.11.19-.17.4-.17.61s.06.42.17.61l.99 1.72v2.06c0 .45.23.85.61 1.08l1.78 1.02.99 1.72c.23.38.63.61 1.08.61h1.99l1.74 1c.19.11.41.17.62.17.21 0 .42-.06.61-.17l1.74-1h2.03c.44 0 .85-.23 1.08-.61l1.02-1.76 1.71-1c.38-.23.61-.64.61-1.08v-1.97l1.02-1.78c.27-.38.27-.85.04-1.25zm-5.08-.71l-5.01 5.01c-.18.18-.43.29-.71.29-.28 0-.53-.11-.71-.29l-3.01-3.01a1.003 1.003 0 011.42-1.42l2.3 2.3 4.31-4.3a1.003 1.003 0 011.71.71c0 .28-.12.53-.3.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fzOIL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 4.01v11.91l6.27-6.27L0 4.01zm18.91-1.03H1.09L10 10.97l8.91-7.99zm-5.18 6.66L20 15.92V4.01l-6.27 5.63zm-3.23 2.9c-.13.12-.31.19-.5.19s-.37-.07-.5-.19l-2.11-1.89-6.33 6.33h17.88l-6.33-6.33-2.11 1.89z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"exUuJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 7h12a1 1 0 010 2H4a1 1 0 110-2zm0 4h12a1 1 0 010 2H4a1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Nrox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.71 8.43c.39-.4.39-1.05 0-1.45l-5.53-5.72a.967.967 0 00-1.4 0L1.29 12.1c-.39.4-.39 1.05 0 1.45l4.25 4.39 2.13 2.05h9.27c.02 0 .03.01.05.01.55 0 1-.45 1-1s-.45-1-1-1H9.46l.05-.05h.01l.81-.84 8.38-8.68zM7.52 17.94l-4.95-5.12 4.46-4.61 4.95 5.12-4.46 4.61z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a0lsD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 16H9v-2h2v2zm0-3H9V4h2v9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bRylr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.89 4.47c.56-.31 1.23-.47 2.03-.47.44 0 .85.07 1.25.22.4.14.76.35 1.07.6.17.14.33.3.47.47l2.32-2.32c-.16-.15-.3-.32-.47-.46-.62-.49-1.33-.87-2.12-1.13-.8-.25-1.64-.38-2.52-.38-1.24 0-2.35.22-3.33.66-.99.44-1.82 1.05-2.49 1.82-.68.78-1.2 1.68-1.56 2.72-.09.26-.13.54-.2.8H2c-.55 0-1 .45-1 1s.45 1 1 1h1.04c-.01.2-.04.38-.04.58 0 .15.03.28.03.42H2c-.55 0-1 .45-1 1s.45 1 1 1h1.31c.07.3.13.6.23.89.36 1.02.88 1.92 1.56 2.67.68.76 1.51 1.35 2.49 1.79.98.43 2.09.65 3.33.65.99 0 1.9-.15 2.73-.46.83-.3 1.55-.74 2.17-1.32.03-.03.05-.06.08-.09l-2.41-2.15c-.01.01-.02.02-.02.03-.61.67-1.46 1-2.54 1-.8 0-1.47-.16-2.03-.47-.56-.31-1.01-.72-1.35-1.24-.28-.38-.47-.83-.63-1.3H12c.55 0 1-.45 1-1s-.45-1-1-1H6.56c0-.14-.02-.28-.02-.42 0-.2.02-.39.03-.58H13c.55 0 1-.45 1-1s-.45-1-1-1H6.94c.15-.46.34-.9.59-1.28.35-.52.8-.94 1.36-1.25zM18 11.38v0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2XImA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.16 9.804A1 1 0 0018.18 9H16V5a1 1 0 00-1-1h-3.5a1 1 0 00-.8.4L9.76 6 8.139 8.766A1 1 0 008 9.272V12a1 1 0 001 1h9.78a1 1 0 00.98-1.196l-.6-2zM10 9l1.76-3H14v3h-4z",
    "M4.25.5c-.555-.278-1.413.044-1.592.639L0 10c0 1.94.952 2.595 2.501 2.912a.95.95 0 00.857-.27L6 10H2l2-7.006L9 5l.372-.557a.998.998 0 00-.383-1.449L4.25.5z",
    "M3 17a3 3 0 013-3h11a3 3 0 110 6H6a3 3 0 01-3-3zm2 0a1 1 0 011-1h11a1 1 0 110 2H6a1 1 0 01-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cwYDc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.5 8a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm10.35 3.15a.495.495 0 10-.7.7L13.3 13H5.5c-.28 0-.5.22-.5.5s.22.5.5.5h7.79l-1.15 1.15c-.08.09-.14.21-.14.35a.495.495 0 00.85.35l2-2c.09-.09.15-.21.15-.35s-.06-.26-.15-.35l-2-2zM17.5 8a2.5 2.5 0 000 5 2.5 2.5 0 000-5zM7.15 9.85a.495.495 0 10.7-.7L6.71 8h7.79c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H6.71l1.15-1.15c.08-.09.14-.21.14-.35a.495.495 0 00-.85-.35l-2 2c-.09.09-.15.21-.15.35s.06.26.15.35l2 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lk1gX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 3h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zM0 13a1.003 1.003 0 001.71.71L4 11.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L5.41 10 7.7 7.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L4 8.59l-2.29-2.3A1.003 1.003 0 00.29 7.71L2.59 10 .3 12.29c-.19.18-.3.43-.3.71zm18-5h-7c-1.1 0-2 .9-2 2s.9 2 2 2h7c1.1 0 2-.9 2-2s-.9-2-2-2zm1 9H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAQpC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 9c.28 0 .53-.11.71-.29L10 3.41l5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-6-6C10.53 1.11 10.28 1 10 1s-.53.11-.71.29l-6 6A1.003 1.003 0 004 9zm12 2c-.28 0-.53.11-.71.29L10 16.59 4.71 11.3A.965.965 0 004 11a1.003 1.003 0 00-.71 1.71l6 6c.18.18.43.29.71.29s.53-.11.71-.29l6-6A1.003 1.003 0 0016 11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h6yc5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10h10V10c0-5.523-4.477-10-10-10zM8 11a1 1 0 011 1v4.37a.63.63 0 001.18.307l3.74-6.733A.635.635 0 0013.365 9H12a1 1 0 01-1-1V3.63a.63.63 0 00-1.18-.306l-3.74 6.732a.635.635 0 00.555.944H8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6nRsA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 7c.28 0 .53-.11.71-.29L9 3.41V15c0 .55.45 1 1 1s1-.45 1-1V3.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-5-5C10.53.11 10.28 0 10 0s-.53.11-.71.29l-5 5A1.003 1.003 0 005 7zm14 7c-.55 0-1 .45-1 1v3H2v-3c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a1sKF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 9.96v-.03-.01-.02-.02a.794.794 0 00-.21-.43c-.55-.69-1.19-1.3-1.85-1.87l-3.93 2.62a3.966 3.966 0 01-3.96 3.77c-.47 0-.91-.1-1.33-.24l-2.24 1.49c.52.21 1.05.39 1.6.51 1.21.27 2.43.28 3.64.05 1.11-.21 2.17-.64 3.17-1.18 1.56-.84 2.99-2 4.23-3.3.23-.24.46-.49.67-.75a.87.87 0 00.21-.43v-.02-.02-.01-.03V10v-.04zm-.46-5.14c.27-.18.46-.47.46-.82 0-.55-.45-1-1-1-.21 0-.39.08-.54.18l-.01-.02L15 5.46c-.95-.53-1.95-.96-3.01-1.2a9.158 9.158 0 00-3.65-.04c-1.11.21-2.17.64-3.17 1.18-1.56.84-2.99 2-4.23 3.3-.23.24-.46.48-.67.75-.27.34-.27.76 0 1.1.64.79 1.39 1.5 2.16 2.15.26.21.52.41.79.61L.44 15.16l.01.02A1 1 0 000 16c0 .55.45 1 1 1 .21 0 .39-.08.54-.18l.01.02 18-12-.01-.02zm-8.67 3.4c-.25-.12-.53-.2-.83-.2-1.1 0-1.99.89-1.99 1.99 0 .03.02.06.02.09l-1.78 1.19c-.14-.4-.22-.83-.22-1.28 0-2.19 1.78-3.97 3.98-3.97 1.01 0 1.91.38 2.61 1l-1.79 1.18z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67CKb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.3 8.71c.18.18.43.29.71.29s.53-.11.71-.29l4.99-5a1.003 1.003 0 00-1.42-1.42L14 6.58l-2.29-2.29a.956.956 0 00-.7-.29 1.003 1.003 0 00-.71 1.71l3 3zM20 9.96v-.03-.01-.02-.02a.823.823 0 00-.21-.44c-.44-.55-.94-1.05-1.46-1.52l-2.2 2.2c-.55.54-1.3.88-2.12.88-.05 0-.09-.01-.14-.01a3.978 3.978 0 01-3.86 3.02 4.007 4.007 0 01-1.66-7.65A2.97 2.97 0 018.02 5c0-.28.05-.54.12-.8-1.05.22-2.07.64-3.02 1.15-1.57.85-3 2.02-4.24 3.33-.23.25-.46.5-.67.76-.28.35-.28.77 0 1.12.64.8 1.4 1.52 2.17 2.17 1.66 1.41 3.56 2.58 5.66 3.06 1.21.27 2.43.29 3.65.05 1.11-.21 2.18-.65 3.18-1.19 1.57-.85 3-2.02 4.24-3.33.23-.24.46-.49.67-.76.11-.12.18-.27.21-.44v-.02-.02-.01-.03V10c.01-.01.01-.03.01-.04zm-9.99 2.05c1.03 0 1.87-.79 1.98-1.8l-.09-.09-.01.01-2.1-2.11c-1 .11-1.77.95-1.77 1.98-.01 1.11.89 2.01 1.99 2.01z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7JN6Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.01 7.984A2.008 2.008 0 008.012 9.99c0 1.103.9 2.006 1.998 2.006a2.008 2.008 0 001.998-2.006c0-1.103-.9-2.006-1.998-2.006zM20 9.96v-.03-.01-.02-.02a.827.827 0 00-.21-.442c-.64-.802-1.398-1.514-2.168-2.166-1.658-1.404-3.566-2.587-5.664-3.058a8.982 8.982 0 00-3.656-.05c-1.11.2-2.178.641-3.177 1.183-1.569.852-2.997 2.016-4.246 3.33-.23.25-.46.49-.67.761-.279.351-.279.773 0 1.124.64.802 1.4 1.514 2.169 2.166 1.658 1.404 3.566 2.577 5.664 3.058 1.209.271 2.438.281 3.656.05 1.11-.21 2.178-.651 3.177-1.193 1.569-.852 2.997-2.016 4.246-3.33.23-.24.46-.49.67-.751.11-.12.179-.271.209-.442v-.02-.02-.01-.03V10v-.04zM10.01 14A4.003 4.003 0 016.014 9.99a4.003 4.003 0 013.996-4.011 4.003 4.003 0 013.996 4.011 4.003 4.003 0 01-3.996 4.011z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jbnb7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 3c-.23 0-.42.09-.59.21l-.01-.01L11 8V4c0-.55-.45-1-1-1-.23 0-.42.09-.59.21L9.4 3.2l-8 6 .01.01C1.17 9.4 1 9.67 1 10s.17.6.41.79l-.01.01 8 6 .01-.01c.17.12.36.21.59.21.55 0 1-.45 1-1v-4l6.4 4.8.01-.01c.17.12.36.21.59.21.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7uVer":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 10c0-.33-.17-.6-.41-.79l.01-.01-8-6-.01.01C10.42 3.09 10.23 3 10 3c-.55 0-1 .45-1 1v4L2.6 3.2l-.01.01C2.42 3.09 2.23 3 2 3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1 .23 0 .42-.09.59-.21l.01.01L9 12v4c0 .55.45 1 1 1 .23 0 .42-.09.59-.21l.01.01 8-6-.01-.01c.24-.19.41-.46.41-.79z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4J2B0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.5 15a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm.5-5c-.55 0-1 .45-1 1s.45 1 1 1c2.76 0 5 2.24 5 5 0 .55.45 1 1 1s1-.45 1-1c0-3.87-3.13-7-7-7zM3 0c-.55 0-1 .45-1 1s.45 1 1 1c8.28 0 15 6.72 15 15 0 .55.45 1 1 1s1-.45 1-1C20 7.61 12.39 0 3 0zm0 5c-.55 0-1 .45-1 1s.45 1 1 1c5.52 0 10 4.48 10 10 0 .55.45 1 1 1s1-.45 1-1C15 10.37 9.63 5 3 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ku7U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.5 15a2.5 2.5 0 000 5 2.5 2.5 0 000-5zM3 2c1.76 0 3.44.31 5.01.87.03-.71.31-1.35.75-1.85C6.96.37 5.03 0 3 0c-.55 0-1 .45-1 1s.45 1 1 1zm10.32 4.67a.99.99 0 001.4 0l4.98-4.98c.19-.17.3-.42.3-.7 0-.55-.45-1-1-1a.99.99 0 00-.7.29l-4.27 4.27-2.28-2.28a.99.99 0 00-.7-.29c-.55 0-.99.45-.99 1 0 .28.11.52.29.7l2.97 2.99zM3 10c-.55 0-1 .45-1 1s.45 1 1 1c2.76 0 5 2.24 5 5 0 .55.45 1 1 1s1-.45 1-1c0-3.87-3.13-7-7-7zm13.94-2.69l-.82.82-.02-.02c-.2.2-.42.37-.67.51A14.8 14.8 0 0118 17c0 .55.45 1 1 1s1-.45 1-1c0-3.61-1.14-6.94-3.06-9.69zM3 5c-.55 0-1 .45-1 1s.45 1 1 1c5.52 0 10 4.48 10 10 0 .55.45 1 1 1s1-.45 1-1C15 10.37 9.63 5 3 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4mX2F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.724 2.724a.5.5 0 00.61.075l3.98-2.387c.178-.108.381.095.274.274l-2.387 3.98a.5.5 0 00.075.61l.37.37a.5.5 0 010 .708L15.17 8.83a.5.5 0 00-.143.409l.947 8.522a.5.5 0 01-.144.409l-.575.575a.5.5 0 01-.577.094l-5.389-2.694a.2.2 0 00-.289.178v2.868a.5.5 0 01-.724.447l-2.934-1.467a.5.5 0 01-.267-.546l.404-2.02a.2.2 0 00-.055-.18l-.848-.85a.2.2 0 00-.181-.054l-2.02.404a.5.5 0 01-.546-.266L.362 11.724A.5.5 0 01.809 11h1.914a.2.2 0 00.19-.263L1.097 5.293a.5.5 0 01.12-.511l.612-.612a.5.5 0 01.409-.143l8.522.947a.5.5 0 00.409-.144l2.476-2.476a.5.5 0 01.708 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cuzsm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 2h-5v3H6V2H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h5v-3h8v3h5c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM4 17H2v-2h2v2zm0-3H2v-2h2v2zm0-3H2V9h2v2zm0-3H2V6h2v2zm0-3H2V3h2v2zm10 8H6V7h8v6zm4 4h-2v-2h2v2zm0-3h-2v-2h2v2zm0-3h-2V9h2v2zm0-3h-2V6h2v2zm0-3h-2V3h2v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fKgQ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 1H2a1.003 1.003 0 00-.71 1.71L7 8.41V18a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71V8.41l5.71-5.71c.18-.17.29-.42.29-.7 0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bxuGO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 2c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L5 7.41V16a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71V7.41l4.71-4.71c.18-.17.29-.42.29-.7zm4 11c-.28 0-.53.11-.71.29L15 16.59l-1.29-1.29A.965.965 0 0013 15a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0019 13z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cmEPm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 2c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L5 7.41V16a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71V7.41l4.71-4.71c.18-.17.29-.42.29-.7zm-4 8c0 .55.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1h-7c-.55 0-1 .45-1 1zm8 7h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1zm0-4h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bDPoX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 2c0 .28-.11.53-.29.7L10 7.41V13c0 .28-.11.53-.29.71l-3 3A1.003 1.003 0 015 16V7.41L.29 2.71A1.003 1.003 0 011 1h13c.55 0 1 .45 1 1zm4.707 11.293a1 1 0 010 1.414l-4 4c-.63.63-1.707.184-1.707-.707v-8c0-.89 1.077-1.337 1.707-.707l4 4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6SiFl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 2c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L5 7.41V16a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71V7.41l4.71-4.71c.18-.17.29-.42.29-.7zm2.91 13.5l1.79-1.79c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-1.79 1.79-1.79-1.79a1.003 1.003 0 00-1.42 1.42l1.79 1.79-1.79 1.79a1.003 1.003 0 001.42 1.42l1.79-1.79 1.79 1.79a1.003 1.003 0 001.42-1.42l-1.8-1.79z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iygxH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 2c0-.55-.45-1-1-1H6a1.003 1.003 0 00-.71 1.71L10 7.41V16a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71V7.41l4.71-4.71c.18-.17.29-.42.29-.7zM4.71 10.29A.997.997 0 004 10c-.28 0-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L3 13.41V19c0 .55.45 1 1 1s1-.45 1-1v-5.59l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eh0po":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 2c0-.55-.45-1-1-1H6a1.003 1.003 0 00-.71 1.71L10 7.41V16a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71V7.41l4.71-4.71c.18-.17.29-.42.29-.7zM4.71 19.71c-.18.18-.43.29-.71.29-.28 0-.53-.11-.71-.29l-3-3a1.003 1.003 0 011.42-1.42L3 16.59V11c0-.55.45-1 1-1s1 .45 1 1v5.59l1.29-1.29c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71l-3 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3oplg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 3c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zm0-3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm2 4.08v8.28c3.01-2.41 8.67 2.64 13 0V4.08C13.61 7.14 8.01 1 5 4.08z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jmhWN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.622 0c0 1.71.49 3.077 1.472 4.103C16.364 6.496 18 9.23 18 12.308c0 3.418-1.962 5.983-5.887 7.692 2.887-3 2.453-4.23-.49-8C8.5 13.5 9 14.5 9.5 16.5c-1.048 0-2 0-2.5-.5 0 .684 1.197 2.5 1.952 4-3.924-1.026-8.123-7.18-6.651-7.692.981-.342 2.126-.171 3.434.513C4.1 6.667 6.062 2.393 11.622 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4rIFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.96 6.37a1.003 1.003 0 001.42-1.42l-2-2a1.07 1.07 0 00-.71-.28 1.003 1.003 0 00-.71 1.71l2 1.99zm9.37.3c.28 0 .53-.11.71-.29l2-2a1.003 1.003 0 00-1.42-1.42l-2 2a1.003 1.003 0 00.71 1.71zM10 5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1S9 .45 9 1v3c0 .55.45 1 1 1zm-5 5c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1zm14-1h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zm-9-3c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm5.04 1.63a1.003 1.003 0 00-1.42 1.42l2 2a1.003 1.003 0 001.42-1.42l-2-2zM10 15c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1zm-4.33-1.67c-.28 0-.53.11-.71.29l-2 2a1.003 1.003 0 001.42 1.42l2-2a1.003 1.003 0 00-.71-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gKZIy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 6.648c.343 0 .676-.028 1-.085.324-.057.614-.152.871-.284.267-.133.49-.303.672-.512.19-.208.314-.464.371-.767h1.329v9.947H3.457v-7.02H1V6.648zm13.965-1.635c.688 0 1.247.16 1.677.478.44.31.78.711 1.018 1.204.247.483.413 1.016.495 1.6.092.583.137 1.149.137 1.696 0 .547-.045 1.112-.137 1.696a5.182 5.182 0 01-.495 1.614 3.234 3.234 0 01-1.018 1.203c-.43.31-.99.465-1.677.465-.688 0-1.251-.155-1.691-.465-.431-.319-.77-.72-1.018-1.203a5.714 5.714 0 01-.495-1.614 12.116 12.116 0 01-.123-1.696c0-.547.04-1.113.123-1.696a5.534 5.534 0 01.495-1.6 3.26 3.26 0 011.018-1.204c.44-.319 1.004-.478 1.691-.478zm0 8.657c.34 0 .623-.096.853-.287.229-.2.407-.465.536-.794a4.61 4.61 0 00.288-1.176c.056-.447.083-.92.083-1.422 0-.502-.027-.971-.083-1.409a4.61 4.61 0 00-.288-1.176c-.129-.337-.307-.602-.536-.793-.23-.2-.514-.301-.853-.301-.348 0-.637.1-.866.3-.22.192-.399.457-.537.794-.128.337-.22.73-.274 1.176-.056.438-.083.907-.083 1.409 0 .501.027.975.082 1.422.055.447.147.84.275 1.176.138.329.317.593.537.794.229.191.518.287.866.287zm-5.104-.588H7.875V15h1.986v-1.918z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7lpWC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 1h-3v5h3V1zm5.71 2.29l-3-3A.997.997 0 0016 0h-1v7H5V0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V4c0-.28-.11-.53-.29-.71zM17 19H3v-8c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eYKxa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.425 7.953a3.98 3.98 0 01.562 2.045 3.98 3.98 0 01-.583 2.08L18 15.671V12.98c0-.248.097-.496.29-.689.379-.379 1.047-.38 1.426 0a.94.94 0 01.283.696l-.001 5.049a.957.957 0 01-.276.69.955.955 0 01-.69.273h-5.059a.971.971 0 01-.689-.289 1.026 1.026 0 010-1.417.972.972 0 01.69-.29h2.702l-3.634-3.573a3.998 3.998 0 01-5.924-2.431H1a1 1 0 010-2h6.12a3.998 3.998 0 015.96-2.409L16.665 3l-2.694-.001a.972.972 0 01-.689-.29 1.035 1.035 0 010-1.425.94.94 0 01.696-.283l5.05.001c.248 0 .497.083.69.276a.954.954 0 01.272.69l.001 5.052a.971.971 0 01-.29.689 1.028 1.028 0 01-1.419 0 .972.972 0 01-.29-.69V4.323l-3.567 3.63z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6gGR1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 9.919a3.998 3.998 0 014-3.92c2.21 0 4 1.79 4 3.997a3.998 3.998 0 01-4 3.996 3.998 3.998 0 01-4-3.916.967.967 0 01-.28.612L7.685 14.71a.958.958 0 01-.686.285c-.536 0-.994-.461-.994-.997 0-.273.107-.528.283-.704l2.379-2.302H.98c-.537 0-.976-.46-.976-.996s.44-.992.976-.992h7.676L6.287 6.687a.957.957 0 01-.283-.686c0-.536.458-.996.994-.996.274 0 .51.1.686.285l4.027 4.024c.159.158.27.365.29.605z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3UYwQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.125 10.997H.976C.439 10.997 0 10.537 0 10c0-.536.44-.993.976-.993h4.148a4.002 4.002 0 017.752 0h3.776L14.293 6.69a.962.962 0 01-.285-.687c0-.537.46-1.001.996-1.001a.96.96 0 01.698.3l4.005 4.015c.176.176.293.41.293.683a.972.972 0 01-.283.693L15.702 14.7a.997.997 0 01-.698.297c-.537 0-.996-.453-.996-.99 0-.273.107-.517.283-.692l2.371-2.318h-3.787a4.002 4.002 0 01-7.75 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4tyRZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.13 9.004A4.005 4.005 0 0110.012 6c1.87 0 3.44 1.278 3.881 3.005h2.768l-2.354-2.317a.97.97 0 01-.283-.691c0-.536.462-.995 1-.995.273 0 .517.107.693.283l4 4.041a.97.97 0 01.284.692.956.956 0 01-.293.682l-3.991 3.997a.944.944 0 01-.694.292c-.537 0-1-.46-1-.997a.97.97 0 01.284-.692l2.345-2.29h-2.765a4.005 4.005 0 01-3.875 2.981 4.005 4.005 0 01-3.874-2.981H3.349l2.376 2.308a.97.97 0 01.283.691 1 1 0 01-.994.983.989.989 0 01-.713-.291L.293 10.699A.956.956 0 010 10.017a.97.97 0 01.283-.692l4.03-4.037a.996.996 0 01.701-.283c.537 0 .994.464.994 1a.97.97 0 01-.283.691L3.34 9.004h2.79z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1tk2Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.04 13.424c-.6.36-1.302.568-2.052.568a4 4 0 01-3.868-2.999H3.342l2.372 2.31c.176.176.283.42.283.694 0 .537-.452.998-.988.998a.935.935 0 01-.691-.289L.292 10.683A.96.96 0 010 9.999c0-.274.107-.518.283-.694l4.035-4.04a.973.973 0 01.691-.288c.536 0 .988.47.988 1.007a.975.975 0 01-.283.694L3.332 8.984h3.786a4 4 0 013.87-3.006c.771 0 1.492.22 2.102.599l3.565-3.57-2.538-.003a.974.974 0 01-.69-.29c-.38-.38-.38-1.052-.002-1.431A.94.94 0 0114.122 1l4.896.005a.96.96 0 01.69.277c.193.193.27.442.27.69l.005 4.9a.971.971 0 01-.289.69 1.023 1.023 0 01-1.416 0 .975.975 0 01-.29-.691l-.003-2.54-3.554 3.62c.351.596.553 1.291.553 2.034 0 .763-.213 1.477-.583 2.084l3.595 3.595.003-2.54c0-.249.097-.497.29-.69.38-.38 1.05-.381 1.429-.002a.94.94 0 01.282.697l-.005 4.9a.927.927 0 01-.277.675.974.974 0 01-.69.291L13.974 19a.97.97 0 01-.69-.29 1.03 1.03 0 01.002-1.42.974.974 0 01.69-.29l2.696-.003-3.632-3.573z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8dbEJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17.5 7.93a2.5 2.5 0 00-2.45 2h-2.3l-4.01-4-.75.75 3.26 3.25h-6.3a2.5 2.5 0 100 1h6.3l-3.26 3.25.75.75 4.01-4h2.3a2.5 2.5 0 102.45-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ZS05":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 17c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V7H0v10zM19 4H9.41l-1.7-1.71A.997.997 0 007 2H1c-.55 0-1 .45-1 1v3h20V5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6mZQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.994 7c0 1.655 1.344 3 2.998 3a3.002 3.002 0 002.999-3H20v10c0 .55-.45 1-1 1H1.01c-.55 0-1-.45-1-1V7h12.984zM10.76 6H0V3c0-.55.45-1 1-1h3.998c.28 0 .53.11.71.29L7.415 4h2.579c0 .768.29 1.469.765 2zm8.23-3c.55 0 1 .45 1 1s-.45 1-1 1h-1.998v2c0 .55-.45 1-1 1s-1-.45-1-1V5h-1.998c-.55 0-1-.45-1-1s.45-1 1-1h1.999V1c0-.55.45-1 .999-1 .55 0 1 .45 1 1v2h1.999z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jNMsz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 9c0-.55-.45-1-1-1H5c-.43 0-.79.27-.93.65h-.01l-3 8h.01c-.04.11-.07.23-.07.35 0 .55.45 1 1 1h14c.43 0 .79-.27.93-.65h.01l3-8h-.01c.04-.11.07-.23.07-.35zM3.07 7.63C3.22 7.26 3.58 7 4 7h14V5c0-.55-.45-1-1-1H8.41l-1.7-1.71A.997.997 0 006 2H1c-.55 0-1 .45-1 1v12.31l3.07-7.68z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYSXW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 4H9.41l-1.7-1.71A.997.997 0 007 2H1c-.55 0-1 .45-1 1v3h11.78C11.3 5.47 11 4.77 11 4zm8-1h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L12.3 9.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 6.41V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zm-2.46 7.7l-1.42 1.42a2.996 2.996 0 11-4.24-4.24l.88-.88H0v10c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-5.18c-.31.11-.65.18-1 .18-1.02 0-1.92-.52-2.46-1.3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"68lqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.07 7.63C3.22 7.26 3.58 7 4 7h7.76l.54-.54A2.97 2.97 0 0111 4H8.41l-1.7-1.71A.997.997 0 006 2H1c-.55 0-1 .45-1 1v12.31l3.07-7.68zm13.47 3.07l-1.42 1.42A2.996 2.996 0 0110 10c0-.77.3-1.47.78-2H5c-.43 0-.79.27-.93.65h-.01l-3 8h.01c-.04.11-.07.23-.07.35 0 .55.45 1 1 1h14c.43 0 .79-.27.93-.65h.01l2.01-5.36c-1-.01-1.88-.52-2.41-1.29zM19 3h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L12.3 9.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 6.41V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dQmZP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.54 15.92c-1.48-.65-1.28-1.05-1.33-1.59-.01-.07-.01-.15-.01-.23.51-.45.92-1.07 1.19-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.34-.07.54-.44.61-.78.08-.14.23-.48.2-.87-.05-.5-.25-.73-.47-.82v-.09c0-.63-.06-1.55-.17-2.15-.02-.17-.06-.33-.11-.5a3.69 3.69 0 00-1.29-1.86C9.69 4.25 8.8 4 8.01 4c-.8 0-1.69.25-2.32.73-.61.47-1.06 1.13-1.28 1.86-.05.17-.09.33-.11.5-.12.6-.18 1.51-.18 2.14v.08c-.23.09-.44.32-.49.83-.04.39.12.73.2.87.08.35.28.72.63.78.04.17.09.33.15.48 0 .01.01.02.01.03l.01.01c.27.72.7 1.35 1.22 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.38 1.59-1.48.65-3.71 1.35-4.16 2.4C-.16 19.38.02 20 .02 20h15.95s.18-.62-.27-1.67c-.46-1.06-2.68-1.75-4.16-2.41zm8.15-12.63l-3-3a.956.956 0 00-.7-.29 1.003 1.003 0 00-.71 1.71L16.58 3H13c-.55 0-1 .45-1 1s.45 1 1 1h3.58l-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.3-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7kTYb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.55 15.92c-1.48-.65-1.28-1.05-1.33-1.59-.01-.07-.01-.15-.01-.23.51-.45.92-1.07 1.19-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.34-.07.54-.44.61-.78.08-.14.23-.48.2-.87-.05-.5-.25-.73-.47-.82v-.09c0-.63-.06-1.55-.17-2.15-.02-.17-.06-.33-.11-.5a3.69 3.69 0 00-1.29-1.86C9.7 4.25 8.81 4 8.02 4c-.79 0-1.68.25-2.31.73-.61.47-1.07 1.13-1.29 1.86-.05.16-.09.33-.11.5-.12.6-.18 1.51-.18 2.14v.08c-.23.09-.44.32-.48.83-.04.39.12.73.2.87.08.35.28.72.63.78.04.17.09.33.15.48 0 .01.01.02.01.03l.01.01c.27.72.7 1.35 1.22 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.38 1.59C3 16.56.77 17.26.32 18.31-.15 19.38.04 20 .04 20h15.95s.18-.62-.27-1.67c-.46-1.06-2.69-1.75-4.17-2.41zM19 3h-3.58l1.29-1.29A1.003 1.003 0 0015.29.29l-3 3c-.17.18-.28.43-.28.71 0 .28.11.53.29.71l3 3c.18.18.43.29.7.29a1.003 1.003 0 00.71-1.71L15.42 5H19c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hNvCN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.933 2.641a1 1 0 00-1.866 0L4.075 15.62a1 1 0 101.867.717L7.225 13h5.55l1.283 3.337a1 1 0 101.867-.717L10.933 2.64zM12.005 11L10 5.786 7.994 11h4.011z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4hagU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.71 11.29a1.003 1.003 0 00-1.42 1.42l1.3 1.29h-2.17l-8-8h10.17L15.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3a1.003 1.003 0 00-1.42 1.42L16.59 4H1c-.55 0-1 .45-1 1s.45 1 1 1h2.59l9.71 9.71c.17.18.42.29.7.29h2.59l-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"akhp2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 13v4h4v-4H2zm-1-2h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1zm11-7h7c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1zM8 1a1.003 1.003 0 01.71 1.71l-5 6C3.53 8.89 3.28 9 3 9s-.53-.11-.71-.29l-2-2a1.003 1.003 0 011.42-1.42L3 6.59l4.29-5.3C7.47 1.11 7.72 1 8 1zm4 13h7c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hrAB8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.754 20a8.469 8.469 0 01-3.417-.693 8.898 8.898 0 01-2.772-1.872 8.898 8.898 0 01-1.872-2.772A8.468 8.468 0 011 11.246c0-1.215.231-2.354.693-3.416a8.898 8.898 0 011.872-2.772 8.898 8.898 0 012.772-1.872 8.469 8.469 0 013.417-.693h.145l-.826-.827a.891.891 0 01-.28-.68c.008-.26.101-.487.28-.682A.992.992 0 019.766 0a.905.905 0 01.693.28l2.504 2.505a.933.933 0 01.292.68c0 .26-.097.487-.292.681L10.46 6.651a.905.905 0 01-.693.28.992.992 0 01-.693-.305 1.026 1.026 0 01-.28-.68.891.891 0 01.28-.681l.826-.827h-.145c-1.897 0-3.506.66-4.827 1.982-1.321 1.32-1.982 2.93-1.982 4.826 0 1.897.66 3.506 1.982 4.827 1.321 1.321 2.93 1.982 4.827 1.982 1.896 0 3.505-.66 4.826-1.982 1.321-1.321 1.982-2.93 1.982-4.827a.94.94 0 01.28-.693.941.941 0 01.693-.28c.275 0 .506.094.692.28a.94.94 0 01.28.693 8.468 8.468 0 01-.693 3.417 8.898 8.898 0 01-1.872 2.772 8.898 8.898 0 01-2.772 1.872A8.469 8.469 0 019.754 20z",
    "M11.5 9.5v3h1v-3h-1zM11 8a1 1 0 00-1 1v4a1 1 0 001 1h2a1 1 0 001-1V9a1 1 0 00-1-1h-2z",
    "M9 9a1 1 0 00-1-1H6.75a.75.75 0 000 1.5h.75v3.75a.75.75 0 001.5 0V9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6i6mm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.196 2H0v2h2c.317 0 .619.139.825.38l3.493 4.075-1.873 1.248a1 1 0 00-.445.832V18c0 .5.5 1 1 1h14c.5 0 1-.5 1-1V7.1c0-.034-.001-.067-.004-.1H20V3s0-1-1-1h-8c-.5 0-1 .5-1 1v3L8.12 7.254 4.463 3.035A3 3 0 002.196 2zM18 4v2h-6V4h6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kDRLl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.96 0a10 10 0 100 20 10 10 0 100-20z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bFnmI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 16h2c.55 0 1-.45 1-1v-5h-4v5c0 .55.45 1 1 1zM12 2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v4h4V2zm6 4h-4v3h4V6zm0-4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v3h4V2zm-6 5H8v5h4V7zm-9 9h2c.55 0 1-.45 1-1v-3H2v3c0 .55.45 1 1 1zm6 0h2c.55 0 1-.45 1-1v-2H8v2c0 .55.45 1 1 1zm10 1H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM6 2c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v3h4V2zm0 4H2v5h4V6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5JOtP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.41 2H6c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v5c0 .55.45 1 1 1s1-.45 1-1V3.41L7.29 8.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L3.41 2zM8 11c-.28 0-.53.11-.71.29L2 16.59V14c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1H3.41l5.29-5.29c.19-.18.3-.43.3-.71 0-.55-.45-1-1-1zM19 0h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L11.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 3.41V6c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm0 13c-.55 0-1 .45-1 1v2.59l-5.29-5.29A.965.965 0 0012 11a1.003 1.003 0 00-.71 1.71l5.3 5.29H14c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ezVq6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.14 5.82H8.73c.4-1.66.94-2.87 1.6-3.64.4-.48.8-.72 1.18-.72.08 0 .14.02.19.07.05.05.07.1.07.18 0 .07-.05.19-.16.37s-.16.36-.16.52c0 .23.08.43.25.59a.9.9 0 00.64.25c.28 0 .51-.1.7-.3.19-.2.28-.47.28-.81 0-.39-.14-.7-.42-.94-.28-.24-.74-.36-1.36-.36-.97 0-1.86.29-2.65.87-.79.56-1.54 1.52-2.26 2.85-.24.46-.48.75-.7.88-.22.13-.57.19-1.06.19l-.32 1.15H5.9l-1.99 7.85c-.33 1.29-.56 2.09-.67 2.39-.17.44-.43.81-.77 1.12a.74.74 0 01-.5.19c-.05 0-.1-.02-.14-.05l-.04-.07c0-.03.05-.1.15-.2.1-.1.15-.26.15-.47 0-.23-.08-.42-.23-.57-.16-.15-.38-.23-.67-.23-.35 0-.63.1-.85.29-.21.2-.32.43-.32.7 0 .29.13.54.39.75.25.22.65.33 1.2.33.88 0 1.66-.23 2.33-.69.68-.46 1.27-1.17 1.78-2.14.51-.96 1.03-2.52 1.56-4.66l1.14-4.54H9.8l.34-1.15zm6.8 1.95c.25-.2.51-.29.78-.29.1 0 .29.04.56.11.27.08.51.11.72.11.29 0 .52-.1.72-.3.18-.19.28-.45.28-.77 0-.33-.1-.6-.29-.8-.19-.2-.47-.29-.82-.29-.32 0-.62.08-.9.23-.28.15-.64.49-1.08 1-.33.38-.81 1.05-1.44 2a9.712 9.712 0 00-1.31-3.22l-3.4.59-.07.37c.25-.05.47-.08.64-.08.34 0 .62.15.84.44.35.46.84 1.85 1.46 4.19-.49.66-.82 1.09-1 1.3-.3.33-.55.54-.74.64-.15.08-.32.12-.51.12-.14 0-.38-.08-.7-.24-.22-.1-.42-.16-.59-.16-.33 0-.6.11-.82.32-.21.22-.32.49-.32.83 0 .31.1.57.3.77.2.2.47.29.8.29.32 0 .63-.07.92-.21.29-.14.64-.43 1.08-.88.43-.45 1.03-1.16 1.79-2.14.29.93.55 1.61.76 2.03.21.42.46.73.74.91.28.19.62.28 1.04.28.4 0 .81-.15 1.23-.44.55-.38 1.1-1.04 1.68-1.97l-.35-.21c-.39.55-.68.89-.87 1.03-.12.09-.27.13-.44.13-.2 0-.4-.13-.59-.38-.33-.43-.77-1.63-1.33-3.6.47-.86.89-1.44 1.23-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7QtCH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 7h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm3 2v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1zm12 3h-6c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm0 4H2V3c0-.55-.45-1-1-1s-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"88RYW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 13a1 1 0 00-1-1H4.942a.942.942 0 01-.81-1.422L10.11.49A1.02 1.02 0 0111 0a1 1 0 011 1v6a1 1 0 001 1h2.058a.942.942 0 01.81 1.422L9.89 19.51A1.02 1.02 0 019 20a1 1 0 01-1-1v-6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9mnjA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 11l.075.003.126.017.111.03.111.044.098.052.096.067.09.08c.036.035.068.073.097.112l.071.11.054.114.035.105.03.148L9 12V18a1 1 0 01-1.993.117L7 18v-3.586l-5.293 5.293a1 1 0 01-1.497-1.32l.083-.094L5.584 13h-3.58a1 1 0 01-.117-1.993L2.004 11H8zm3.018-11a1.003 1.003 0 01.39.087l.12.063.031.02.1.078 8.027 7.026.062.064.068.086.044.068.064.128.04.117.024.113.011.108v.1l-.007.073-.019.103-.037.121-.039.09-.05.087-4.996 7.994c-.06.097-.137.183-.226.254l-.093.067-.095.053-.087.037-.125.037a1.018 1.018 0 01-.218.026H11v-5a3 3 0 00-2.824-2.995L8 9H3V6a1 1 0 01.321-.734l.098-.08 7-5a1.01 1.01 0 01.45-.178L11.018 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"93hcI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 8.33l9.17 2.5 2.5 9.17L20 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Uhsn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 18.88c-3.79 0-6.88-3.09-6.88-6.88 0-.61.08-1.22.23-1.79.03.01.06-.01.1-.01h.09v.55c0 .23.21.42.44.42.04 0 .09-.01.12-.02l.9.88c.09.09.23.09.32 0s.09-.23 0-.32l-.86-.9c0-.02.05-.04.05-.07v-.13c0-.18.1-.25.29-.41h.53c.1 0 .19-.01.27-.05.01-.01.02 0 .03-.01.02-.01.03-.02.05-.04.01-.01.02-.01.02-.02l.02-.02 1.13-1.13c-.16-.32-.3-.65-.42-.99h-.64v-.53c0-.01.06.06.06-.1h.38c-.04-.16-.08-.32-.1-.48h-.71c.2-.16.42-.31.64-.45C4.02 6.09 4 5.8 4 5.5c0-.14.01-.28.02-.43C1.62 6.46 0 9.04 0 12c0 4.41 3.59 8 8 8 3.87 0 7.09-2.77 7.82-6.44l-.97-1.1c-.26 3.57-3.23 6.42-6.85 6.42zm-2.12-3.67v-.35h.15c.29 0 .49-.23.49-.53v-.68c0-.01.01-.01 0-.02L4.71 11.8h-.77c-.29 0-.47.24-.47.53v2c0 .29.18.53.47.53h.33v2.02c0 .28.28.51.56.51s.56-.23.56-.51v-1.22h-.01c.29 0 .5-.16.5-.45zm13.83-2.92l-3.68-3.68c.14-.21.27-.42.38-.65.02-.04.04-.07.05-.11.11-.22.2-.45.28-.69v-.01c.07-.24.13-.48.17-.73l.03-.17c.04-.24.06-.49.06-.75C17 2.46 14.54 0 11.5 0S6 2.46 6 5.5 8.46 11 11.5 11c.26 0 .51-.02.76-.06l.17-.03c.25-.04.49-.1.73-.17h.01c.24-.08.47-.17.69-.28.04-.02.07-.04.11-.05.23-.11.44-.24.65-.38l3.68 3.68c.17.18.42.29.7.29a1.003 1.003 0 00.71-1.71zM11.5 9.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm1.93 5.33v-.65c0-.11-.13-.21-.24-.21-.11 0-.24.09-.24.21v.65c0 .11.13.21.24.21.11 0 .24-.1.24-.21zm-2.41.67h.83c.29 0 .46-.21.46-.5v-1.86l.23-.22c-.34.05-.69.08-1.04.08-.36 0-.7-.03-1.05-.08.03.05.06.1.08.16V15c.01.29.2.5.49.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k7RA8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.555 7c-2.375 0-4.305 1.867-4.305 4.164 0 2.305 4.305 8.836 4.305 8.836s4.304-6.531 4.304-8.836C19.852 8.867 17.93 7 15.555 7zm0 6.25a1.954 1.954 0 11.001-3.908 1.954 1.954 0 01-.001 3.908z",
    "M0 7.5C0 3.356 3.356 0 7.5 0a7.5 7.5 0 017.359 6.044 5.383 5.383 0 00-1.804.566A5.632 5.632 0 007.5 1.875 5.63 5.63 0 001.875 7.5 5.63 5.63 0 007.5 13.125c1.07 0 2.072-.3 2.924-.82.14.525.352 1.078.58 1.608l.078.178A7.47 7.47 0 017.5 15 7.498 7.498 0 010 7.5z",
    "M8.438 3.937v3.179l1.603 1.593A.94.94 0 018.71 10.04L6.833 8.167a.935.935 0 01-.271-.666V3.937A.94.94 0 017.5 3a.94.94 0 01.938.937z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kTWsA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 2c-1.66 0-3 1.34-3 3 0 1.3.84 2.4 2 2.82V9c0 1.1-.9 2-2 2H8c-.73 0-1.41.21-2 .55V5.82C7.16 5.4 8 4.3 8 3c0-1.66-1.34-3-3-3S2 1.34 2 3c0 1.3.84 2.4 2 2.82v8.37C2.84 14.6 2 15.7 2 17c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.25-.77-2.3-1.85-2.75C6.45 13.52 7.16 13 8 13h4c2.21 0 4-1.79 4-4V7.82C17.16 7.4 18 6.3 18 5c0-1.66-1.34-3-3-3zM5 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM15 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kxF2b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 9h-4.1a5 5 0 00-9.8 0H1c-.55 0-1 .45-1 1s.45 1 1 1h4.1a5 5 0 009.8 0H19c.55 0 1-.45 1-1s-.45-1-1-1zm-9 4c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fEgS3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 8c-1.3 0-2.4.84-2.82 2H11c-2.49 0-4.54-1.83-4.92-4.21A2.995 2.995 0 005 0C3.34 0 2 1.34 2 3c0 1.3.84 2.4 2 2.81v8.37C2.84 14.6 2 15.7 2 17c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82V9.86C7.27 11.17 9.03 12 11 12h1.18A2.996 2.996 0 0018 11c0-1.66-1.34-3-3-3zM5 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM5 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm10 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iPT08":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1zm-3 4.86V9c0 1.1-.9 2-2 2H8c-.73 0-1.41.21-2 .55V5.82C7.16 5.4 8 4.3 8 3c0-1.66-1.34-3-3-3S2 1.34 2 3c0 1.3.84 2.4 2 2.82v8.37C2.84 14.6 2 15.7 2 17c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.25-.77-2.3-1.85-2.75C6.45 13.52 7.16 13 8 13h4c2.21 0 4-1.79 4-4V7.86c-.32.08-.65.14-1 .14s-.68-.06-1-.14zM5 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2I5yt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 14.18V7c0-2.21-1.79-4-4-4h-2.59l1.29-1.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C7.11 3.47 7 3.72 7 4c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L10.41 5H13c1.1 0 2 .9 2 2v7.18A2.996 2.996 0 0016 20c1.66 0 3-1.34 3-3 0-1.3-.84-2.4-2-2.82zM16 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4 1C2.34 1 1 2.34 1 4c0 1.3.84 2.4 2 2.82v7.37C1.84 14.6 1 15.7 1 17c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82V6.82C6.16 6.4 7 5.3 7 4c0-1.66-1.34-3-3-3zm0 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b9E55":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 11c0-.28-.11-.53-.29-.71l-3-3C11.53 7.11 11.28 7 11 7s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42l1.29-1.3V19c0 .55.45 1 1 1s1-.45 1-1v-8.59l1.29 1.29c.18.19.43.3.71.3.55 0 1-.45 1-1zm4-11H1C.45 0 0 .45 0 1v16c0 .55.45 1 1 1h7v-2H2v-2h6v-1H4V2h14v11h-4v1h4v2h-4v2h5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM5 8h2V6H5v2zm2-5H5v2h2V3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1kKac":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 3H5v2h2V3zm0 6H5v2h2V9zm0-3H5v2h2V6zm12-6H1C.45 0 0 .45 0 1v16c0 .55.45 1 1 1h4v2l2-1 2 1v-2h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 16H9v-1H5v1H2v-2h16v2zm0-3H4V2h14v11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5tDy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 6V0H3v6c0 3.53 2.61 6.43 6 6.92V18H6c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-3v-5.08c3.39-.49 6-3.39 6-6.92z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gP3Ks":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.53 4.37c.1-.1.1-.26 0-.35l-.68-.68c-.1-.1-.25-.1-.35 0-.1.1-.1.26 0 .35l.68.68c.1.1.25.1.35 0zm3.17.06h.3c.09 0 .16-.01.16-.1 0-.09-.07-.1-.16-.1h-.3c-.09 0-.16.01-.16.1s.07.1.16.1zm.98 1.15c.09 0 .19-.08.19-.17v-.42c0-.09-.1-.17-.19-.17s-.19.08-.19.17v.42c0 .09.1.17.19.17zm-6.5 4.19c-.35 0-.56.28-.56.63v2.37c0 .35.21.62.56.62h.39v2.4c0 .34.33.61.67.61s.67-.27.67-.61v-1.44h-.02c.35 0 .6-.19.6-.54v-.41h.18c.35 0 .58-.28.58-.62v-.81c0-.01.01-.01 0-.02L6.1 9.77h-.92zM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8 0-.74.11-1.46.3-2.14h.03v.65c0 .28.25.5.53.5.05 0 .1-.01.15-.02l1.05 1.05c.1.11.28.11.38 0 .1-.1.11-.27 0-.38L3.42 8.59c0-.03.05-.05.05-.08v-.16c0-.22.12-.3.34-.49h.63c.12 0 .23-.01.32-.07.01-.01.02 0 .03-.01.02-.02.04-.03.06-.04.01-.01.02-.01.03-.02l.02-.02 2.15-2.15c.24-.24.24-.63 0-.86-.23-.24-.62-.19-.86.04l-.41.46H5v-.64c0-.01.07.07.07-.12h.87c.17 0 .3-.12.3-.29 0-.17-.13-.29-.3-.29H4.88C6.27 2.7 8.05 2 10 2s3.73.7 5.12 1.86h-1.58l-.01-.04c-.06 0-.12 0-.17.04l-.71.7c-.09.09-.09.23 0 .31.09.09.23.09.32 0l.56-.6.01-.03h.34c0 .19-.1.13-.1.16v.1c0 .29-.2.5-.49.5h-.51c-.25 0-.52.28-.52.54v.23h-.12c-.16 0-.27.08-.27.24v.33h-.32c-.23 0-.41.15-.41.38 0 .22.18.35.41.35.1 0 .19.04.26-.16l.06.01.66-.59h.23l.53.5c.04.04.11.03.16-.01.04-.04.04-.16 0-.2L13 6.15h.32l.12.16c.25.25.65.23.89-.02l.12-.14H15c.02 0 .11.07.11.07v.33s-.06-.01-.07-.01h-.49c-.16 0-.28.13-.28.29 0 .16.13.29.28.29h.49c.01 0 .07-.01.07-.01v.2c-.19.28-.33.57-.62.57h-1.28s0-.01-.01-.01l-.58-.58a.622.622 0 00-.89 0l-.58.58s0 .01-.01.01h-.34c-.35 0-.67.28-.67.63v1.25c0 .35.32.61.67.61h1.22c.46.19.78.48.97.94v2.28c0 .35.23.6.58.6h.98c.35 0 .54-.25.54-.6v-2.2l1.21-1.17.04-.02.02-.01h.04c.1-.11.2-.26.2-.42V8.49c0-.25-.22-.44-.42-.63h.58c.02.38.29.57.63.57h.43c.13.51.18 1.03.18 1.57 0 4.42-3.58 8-8 8zm6.16-5.65c-.14 0-.29.11-.29.25v.77c0 .14.15.25.29.25.14 0 .29-.11.29-.25v-.77c0-.14-.15-.25-.29-.25zM10.5 3.48c0-.34-.28-.57-.62-.57h-.74c-.34 0-.57.25-.57.59 0 .05-.13.06.06.1v.64c0 .2.09.36.29.36.2 0 .29-.16.29-.36v-.19h.68c.33 0 .61-.23.61-.57z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hG1ln":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm7.39 7h-3.63c-.31-1.99-.92-3.66-1.72-4.73 2.45.65 4.41 2.42 5.35 4.73zM13 10c0 .69-.04 1.36-.11 2H7.11a18.419 18.419 0 010-4h5.77c.08.64.12 1.31.12 2zm-3-8c1.07 0 2.25 2.05 2.75 5h-5.5c.5-2.95 1.68-5 2.75-5zm-2.04.27C7.16 3.34 6.55 5.01 6.24 7H2.61c.94-2.31 2.9-4.08 5.35-4.73zM2 10c0-.69.11-1.36.28-2h3.83a18.419 18.419 0 000 4H2.28c-.17-.64-.28-1.31-.28-2zm.61 3h3.63c.31 1.99.92 3.66 1.72 4.73A7.996 7.996 0 012.61 13zM10 18c-1.07 0-2.25-2.05-2.75-5h5.5c-.5 2.95-1.68 5-2.75 5zm2.04-.27c.79-1.07 1.4-2.74 1.72-4.73h3.63a7.996 7.996 0 01-5.35 4.73zM13.89 12a18.419 18.419 0 000-4h3.83c.17.64.28 1.31.28 2s-.11 1.36-.28 2h-3.83z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"03r8I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.75 7l-.002-.01c.084.007.168.01.252.01 0 .755.26 1.539.86 2.14.041.04.083.079.125.116.038.916.007 1.833-.095 2.744h3.83c.17-.64.28-1.31.28-2 0-.247-.013-.49-.04-.732A2.92 2.92 0 0019 7c.176 0 .351-.016.526-.049.308.961.474 1.986.474 3.049 0 5.52-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0c1.06 0 2.084.165 3.043.472A3.288 3.288 0 0013 1c-1.049 0-1.88.5-2.398 1.204A1.1 1.1 0 0010 2C8.93 2 7.75 4.05 7.25 7h5.5zm.14 5c.07-.64.11-1.31.11-2s-.04-1.36-.12-2H7.11a18.4 18.4 0 000 4h5.78zM6.24 7c.31-1.99.92-3.66 1.72-4.73A8 8 0 002.61 7h3.63zM2 10c0 .69.11 1.36.28 2h3.83a18.4 18.4 0 010-4H2.28C2.11 8.64 2 9.31 2 10zm4.24 3H2.61c.94 2.31 2.9 4.08 5.35 4.73-.8-1.07-1.41-2.74-1.72-4.73zM10 18c1.07 0 2.25-2.05 2.75-5h-5.5c.5 2.95 1.68 5 2.75 5zm3.76-5c-.32 1.99-.93 3.66-1.72 4.73A8.001 8.001 0 0017.39 13h-3.63z",
    "M13 5c-.6 0-1-.4-1-1 0-.5.4-1 1-1h2V1c0-.6.4-1 1-1 .5 0 1 .4 1 1v2h2c.5 0 1 .4 1 1s-.5 1-1 1h-2v2c0 .6-.5 1-1 1-.6 0-1-.4-1-1V5h-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1WHK0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17.5 4A2.5 2.5 0 0015 6.5c0 .06.01.12.02.18l-1.9.84C12.38 6.6 11.27 6 10 6c-.83 0-1.59.25-2.23.68L4.91 4.14c.05-.21.09-.42.09-.64a2.5 2.5 0 00-5 0A2.5 2.5 0 002.5 6c.42 0 .81-.11 1.16-.3l2.79 2.48C6.17 8.73 6 9.34 6 10c0 1.41.73 2.64 1.83 3.35l-.56 1.67A2.498 2.498 0 005 17.5a2.5 2.5 0 005 0c0-.74-.32-1.39-.83-1.85l.56-1.68c.09.01.18.03.27.03 2.21 0 4-1.79 4-4 0-.22-.03-.44-.07-.65l2.02-.9c.43.34.96.55 1.55.55a2.5 2.5 0 000-5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gSStV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17.41 4l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L16 2.59 13.71.3A.965.965 0 0013 0a1.003 1.003 0 00-.71 1.71L14.59 4 12.3 6.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L16 5.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L17.41 4zM19 10c-.83 0-1.55-.36-2.09-.91l-.03.03-.88-.88-.88.88a2.996 2.996 0 11-4.24-4.24l.88-.88-.88-.88.03-.03C10.36 2.55 10 1.83 10 1c0-.35.07-.68.18-.99-.06 0-.12-.01-.18-.01C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10c0-.06-.01-.12-.01-.18-.31.11-.64.18-.99.18z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Zp6p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.838 10l-9.154 3.051a1 1 0 00.632 1.898l12-4c.912-.304.912-1.594 0-1.898l-12-4a1 1 0 00-.632 1.898L12.838 10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kCqRm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.684 11.051a1 1 0 00.632 1.898l12-4c.912-.304.912-1.594 0-1.898l-12-4a1 1 0 00-.632 1.898L12.838 8l-9.154 3.051zM4 15h12a1 1 0 110 2H4a1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aOu3r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 11c.55 0 1-.45 1-1s-.45-1-1-1h-2V5h2c.55 0 1-.45 1-1s-.45-1-1-1h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v2h-4V1c0-.55-.45-1-1-1S9 .45 9 1v2H5V1c0-.55-.45-1-1-1S3 .45 3 1v2H1c-.55 0-1 .45-1 1s.45 1 1 1h2v4H1c-.55 0-1 .45-1 1s.45 1 1 1h2v4H1c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h4v2c0 .55.45 1 1 1s1-.45 1-1v-2h4v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-2v-4h2zM9 15H5v-4h4v4zm0-6H5V5h4v4zm6 6h-4v-4h4v4zm0-6h-4V5h4v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dDcYL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 19c0 .55.45 1 1 1h8v-9H0v8zM0 1v8h9V0H1C.45 0 0 .45 0 1zm19-1h-8v9h9V1c0-.55-.45-1-1-1zm-8 20h8c.55 0 1-.45 1-1v-8h-9v9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eqNPM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.757.703a1 1 0 00-1.414 0l-3.536 3.535a1 1 0 000 1.415l3.536 3.535a1 1 0 001.414 0l3.536-3.535a1 1 0 000-1.415L15.757.703z",
    "M1 1.996a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H2a1 1 0 01-1-1v-6zm2 5v-4h4v4H3zM2 10.996a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1H2zm1 2v4h4v-4H3zM11 11.996a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6zm2 5v-4h4v4h-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5ofhn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm8-3H6c-3.31 0-6 2.69-6 6s2.69 6 6 6h8c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 11H6c-2.76 0-5-2.24-5-5s2.24-5 5-5h8c2.76 0 5 2.24 5 5s-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h3Nbg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 16h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1zm7 1H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm-3-1h1c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1zm-9 0h1c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1zm-4 0h1c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dBmL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 5c-.42 0-.79.27-.93.64L14.38 10h-.77l1.34-6.67c.03-.1.05-.21.05-.33a.998.998 0 00-1.98-.19h-.01L11.57 10H11V1c0-.55-.45-1-1-1S9 .45 9 1v9h-.2L6.97 2.76a.997.997 0 00-1.73-.41l-.03.03c-.01.02-.02.03-.03.04-.01.02-.01.03-.02.04v.01c-.01.01-.02.02-.02.03v.01c-.02.01-.02.02-.03.03 0 0 0 .01-.01.01 0 .01 0 .02-.01.03 0 0 0 .01-.01.01 0 .01-.01.02-.01.03 0 0 0 .01-.01.01 0 .01-.01.02-.01.03 0 .01 0 .01-.01.02 0 .01-.01.02-.01.03 0 .01 0 .01-.01.02 0 .01-.01.02-.01.03v.02c0 .01 0 .02-.01.03V3c0 .05 0 .09.01.14l1.45 10.25L6 12.7v.01L3.84 9.45h-.01A.98.98 0 003 9c-.55 0-1 .45-1 1 0 .2.06.39.17.55L6 18.44C7.06 19.4 8.46 20 10 20c3.31 0 6-2.69 6-6v-1.84l.01-.03v-.06l1.94-5.75A1.003 1.003 0 0017 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1N5nF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17.68 9.84C15.91 9 14.27 6.49 13.45 4.9 12.41 2.43 12.21 0 7.87 0 5.49 0 3.95.76 3.05 2.65 2.31 4.2 2 5.48 2 9.79v.99c0 .82.69 1.48 1.54 1.48.38 0 .73-.14 1-.36.19.6.78 1.05 1.47 1.05.47 0 .89-.2 1.17-.52.26.47.77.79 1.36.79.65 0 1.2-.39 1.43-.93l.03.77v5.44c0 .48.23.91.59 1.18.21.19.5.32.85.32h.06c.83 0 1.5-.67 1.5-1.5v-8.24l.01-.67c.85.98 1.92 1.76 3.24 1.89 1.79.19 2.09-1.33 1.43-1.64z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5GWSX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.1 6.54c-1.58-.81-4.09-2.46-4.94-4.23-.31-.65-1.82-.35-1.64 1.43.13 1.33.91 2.4 1.89 3.24L9.74 7H1.5C.67 7 0 7.67 0 8.5v.06c0 .36.13.64.32.85.27.36.7.59 1.18.59h5.44l.78.01c-.54.23-.93.78-.93 1.43 0 .59.32 1.1.79 1.36-.32.28-.52.7-.52 1.17 0 .69.44 1.28 1.05 1.47-.22.27-.36.62-.36 1 0 .85.66 1.54 1.48 1.54h.99c4.31 0 5.59-.31 7.14-1.05 1.89-.9 2.65-2.44 2.65-4.82-.01-4.32-2.44-4.52-4.91-5.57z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kuCnR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 8.5c0-.83-.67-1.5-1.5-1.5h-8.24l-.67-.01c.98-.85 1.76-1.92 1.89-3.24.18-1.79-1.33-2.08-1.65-1.43-.84 1.76-3.35 3.41-4.93 4.23C2.43 7.59 0 7.79 0 12.13c0 2.38.76 3.92 2.65 4.82C4.2 17.69 5.48 18 9.79 18h.99c.82 0 1.48-.69 1.48-1.54 0-.38-.14-.73-.36-1 .6-.19 1.05-.78 1.05-1.47 0-.47-.2-.89-.52-1.17.47-.26.79-.77.79-1.36 0-.65-.39-1.2-.93-1.43l.77-.03h5.44c.48 0 .91-.23 1.18-.59.19-.21.32-.49.32-.85v-.03-.03z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jOa7q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.46 7.74c-.38 0-.73.14-1 .36-.19-.6-.78-1.05-1.47-1.05-.47 0-.89.2-1.17.52-.26-.47-.77-.79-1.36-.79-.65 0-1.2.39-1.43.93L10 6.94V1.5c0-.48-.23-.91-.59-1.18C9.2.13 8.92 0 8.56 0H8.5C7.67 0 7 .67 7 1.5v8.24l-.01.67c-.84-.98-1.92-1.76-3.24-1.89-1.79-.18-2.08 1.33-1.43 1.65 1.77.84 3.41 3.35 4.23 4.94 1.05 2.47 1.25 4.9 5.58 4.9 2.38 0 3.92-.76 4.82-2.65.74-1.56 1.05-2.84 1.05-7.15v-.99c0-.81-.69-1.48-1.54-1.48z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7LNzl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.5 13c1.118 0 1.466.534 1.498 1.366L20 14.5v.5c0 1.945-5.69 3-10 3S0 16.945 0 15v-.5c0-.908.323-1.5 1.5-1.5.895 0 3.5 1.2 8.5 1.2l.411-.003C15.143 14.134 17.631 13 18.5 13zm-5-10c1.725 0 2.954 2.729 3.688 8.186-1.455.263-3.805.72-6.392.801l-.434.01L10 12c-2.896 0-5.585-.524-7.189-.814C3.546 5.73 4.775 3 6.5 3 8.6 3 8.329 5.5 10 5.5S11.5 3 13.5 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dMh40":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 11v5a1 1 0 11-2 0V3a1 1 0 012 0v6h8V3a1 1 0 112 0v13a1 1 0 11-2 0v-5H6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kUnWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 11v5a1 1 0 11-2 0V3a1 1 0 012 0v6h7V3a1 1 0 112 0v13a1 1 0 11-2 0v-5H2zm15.74-1c-.05.31-.17.57-.34.77-.17.21-.38.39-.64.51-.25.13-.52.23-.83.29-.3.05-.61.08-.93.08v1.24h2.5V20H19V10h-1.26z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"moBiE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 11v5a1 1 0 11-2 0V3a1 1 0 012 0v6h7V3a1 1 0 112 0v13a1 1 0 11-2 0v-5H2zm16.458 3.64c.487.11.865.38 1.134.82.269.439.408.968.408 1.608 0 .46-.08.869-.239 1.229-.159.36-.378.669-.656.919-.27.25-.588.44-.956.58-.368.139-.746.209-1.154.209-.498 0-.925-.08-1.294-.24a2.537 2.537 0 01-.925-.68 2.999 2.999 0 01-.567-1.058c-.13-.42-.199-.88-.209-1.379h1.383c-.02.58.11 1.07.378 1.459.279.39.677.58 1.224.58.468 0 .856-.15 1.164-.45.309-.3.468-.72.468-1.27 0-.369-.07-.668-.2-.888-.128-.22-.298-.39-.507-.5a2.01 2.01 0 00-.706-.21 5.345 5.345 0 00-.806-.03v-1.168c.219.01.448 0 .677-.05.229-.05.428-.13.607-.24.179-.11.318-.27.428-.47.109-.2.159-.45.159-.739 0-.41-.12-.739-.368-.989-.25-.25-.568-.37-.956-.37-.239 0-.448.06-.627.17-.179.11-.328.26-.447.45-.12.19-.2.4-.26.63-.049.23-.079.469-.069.719H14.16c.01-.47.09-.9.23-1.3.138-.399.327-.748.566-1.038.239-.3.528-.53.866-.69.338-.17.726-.25 1.154-.25.328 0 .657.05.975.16.319.11.607.27.866.48.259.21.468.47.617.8.15.32.229.699.229 1.118 0 .48-.09.91-.289 1.27a1.71 1.71 0 01-.915.788v.02z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iAMDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 11v5a1 1 0 11-2 0V3a1 1 0 012 0v6h7V3a1 1 0 112 0v13a1 1 0 11-2 0v-5H2zm14.033 6.96c.16-.19.34-.38.558-.55.21-.18.449-.36.708-.53.25-.18.498-.36.748-.56.249-.2.488-.41.727-.63.23-.22.439-.47.628-.74.18-.27.329-.56.438-.88.11-.32.16-.67.16-1.07 0-.32-.05-.65-.14-1-.09-.35-.249-.68-.468-.97-.22-.3-.508-.55-.867-.74-.359-.2-.807-.29-1.346-.29-.488 0-.926.1-1.295.29-.37.18-.688.44-.947.78-.26.33-.449.73-.578 1.2-.13.46-.2.96-.2 1.5h1.426c.01-.35.04-.67.09-.97.05-.3.139-.56.249-.78.11-.22.259-.39.448-.52.19-.13.429-.19.708-.19.309 0 .558.06.747.18.19.12.34.26.449.43.11.17.18.36.219.56.04.2.06.39.06.57-.01.38-.1.72-.26 1.02-.149.3-.368.57-.627.83-.26.25-.538.49-.847.71-.31.22-.608.45-.887.68-.598.45-1.057.98-1.406 1.58-.349.61-.518 1.32-.528 2.13h5.97v-1.43h-4.266c.06-.21.17-.42.33-.61z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"80IIj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.97 9H19A9 9 0 001 9h.03C.41 9.73 0 10.8 0 12c0 1.74.84 3.2 2 3.76V16c0 1.66 1.34 3 3 3h3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1H5c-.55 0-1-.45-1-1 .55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-.92C3.57 4.61 6.47 2 10 2s6.43 2.61 6.92 6H16c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h1c1.66 0 3-1.79 3-4 0-1.2-.41-2.27-1.03-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b7FIs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 6.25C20 3.35 17.65 1 14.75 1c-1.02 0-1.95.31-2.75.82v-.04c-.09.06-.17.12-.26.19-.04.03-.09.06-.14.1-.68.51-1.24 1.18-1.6 1.96-.4-.86-1.04-1.57-1.8-2.1-.04-.02-.07-.05-.1-.08a7 7 0 00-.6-.33c-.13-.04-.23-.1-.35-.15-.05-.02-.1-.05-.15-.07v.02C6.45 1.13 5.87 1 5.25 1A5.25 5.25 0 000 6.25c0 .09.01.17.01.25H0c0 .06.01.12.02.18s.01.12.02.18C.13 7.89.44 9 1.07 10.17 2.23 12.33 4.1 14.11 7 16.53v.01c.9.75 1.89 1.55 3 2.46.71-.58 1.38-1.12 2-1.63 3.48-2.86 5.64-4.78 6.93-7.18.63-1.17.94-2.27 1.03-3.3.01-.07.01-.14.02-.21 0-.06.01-.11.02-.17h-.01c0-.09.01-.17.01-.26z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8PKiC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.11 7.45C8.05 7.31 8 7.16 8 7c0-.07.03-.13.04-.19h-.02l.86-4.32A5.159 5.159 0 005.25 1 5.25 5.25 0 000 6.25c0 .09.01.17.01.25H0c0 .06.01.12.02.18s.01.12.02.18C.13 7.89.44 9 1.07 10.17c1.38 2.58 3.76 4.6 7.71 7.83l-.76-3.8h.02c-.01-.07-.04-.13-.04-.2 0-.21.08-.39.18-.54l-.02-.01 1.68-2.52-1.73-3.48zM20 6.25C20 3.35 17.65 1 14.75 1c-1.54 0-2.92.67-3.88 1.73l-.83 4.13 1.85 3.69h-.01c.07.14.12.29.12.45 0 .21-.08.39-.18.54l.02.01-1.77 2.66.81 4.07c4.16-3.39 6.63-5.45 8.05-8.1.63-1.17.94-2.27 1.03-3.3.01-.07.01-.14.02-.21 0-.06.01-.11.02-.17h-.01c0-.08.01-.16.01-.25z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Cfks":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 12h6V8h-6v4zM0 12h6V8H0v4zm1-3h4v2H1V9zm-1 7c0 .55.45 1 1 1h5v-4H0v3zM19 3h-5v4h6V4c0-.55-.45-1-1-1zm0 3h-4V4h4v2zM0 4v3h6V3H1c-.55 0-1 .45-1 1zm7 3h6V3H7v4zm7 10h5c.55 0 1-.45 1-1v-3h-6v4zm-7 0h6v-4H7v4zm1-3h4v2H8v-2zm-1-2h6V8H7v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6L8NL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 0a6 6 0 100 12A6 6 0 106 0z",
    "M10.5 8a4.5 4.5 0 100 9 4.5 4.5 0 100-9z",
    "M16.5 7a3.5 3.5 0 100 7 3.5 3.5 0 100-7zM18 16a2 2 0 100 4 2 2 0 100-4zM2.5 14a2.5 2.5 0 100 5 2.5 2.5 0 100-5zM16.5 0a2.5 2.5 0 100 5 2.5 2.5 0 100-5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"asiTL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 3v2H1V3.5a.5.5 0 00-1 0v5a.5.5 0 001 0V7l5 2c0 1.54.824 3.575 3 4.835V16H5.5a.5.5 0 100 1H16.5a.5.5 0 00.224-.053l2-1a.5.5 0 10-.448-.894L16.382 16H15v-1.1A5.002 5.002 0 0014 5h-1V3h6.5a.5.5 0 000-1h-16a.5.5 0 000 1H10zm4 13v-1c-1.608 0-2.928-.258-4-.683V16h4zm0-6V6a4 4 0 014 4h-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ckTM0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM7.41 4.62c.65-.54 1.51-.82 2.56-.82.54 0 1.03.08 1.48.25.44.17.83.39 1.14.68.32.29.56.63.74 1.02.17.39.26.82.26 1.27s-.08.87-.24 1.23c-.16.37-.4.73-.71 1.11l-1.21 1.58c-.14.17-.28.33-.32.48-.05.15-.11.35-.11.6v.97H9v-2s.06-.58.24-.81l1.21-1.64c.25-.3.41-.56.51-.77s.14-.44.14-.67c0-.35-.11-.63-.32-.85s-.5-.33-.88-.33c-.37 0-.67.11-.89.33-.22.23-.37.54-.46.94-.03.12-.11.17-.23.16l-1.95-.29c-.12-.01-.16-.08-.14-.22.13-.93.52-1.67 1.18-2.22zM9 14h2.02L11 16H9v-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ywwH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 10h-3v3h3v-3zm0 4h-3v3h3v-3zm0-8h-3v3h3V6zm2-6H1C.4 0 0 .4 0 1v18c0 .5.4 1 1 1h18c.5 0 1-.5 1-1V1c0-.6-.5-1-1-1zm-1 18H2V2h16v16zm-9-4H6v3h3v-3zm4 0h-3v3h3v-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5YbeE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.35 5h5.3l2.77 5-2.77 5h-5.3l-2.77-5 2.77-5zm1.15 5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5z",
    "M4.63 1.51c.18-.31.52-.51.89-.51h8.95c.37 0 .71.19.89.51l4.52 8c.17.3.17.67 0 .97l-4.51 8c-.18.31-.52.51-.89.51H5.53c-.37 0-.71-.19-.89-.51l-4.51-8a.986.986 0 010-.97l4.5-8zM6.13 17h7.76l3.95-7-3.95-7H6.13l-3.95 7 3.95 7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aNaNt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 16v4H8v-4h4zm1-16l-1 14H8L7 0h6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5EJie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 0a1 1 0 00-1 1v3H4V2a1 1 0 000-2H1a1 1 0 100 2h1v2H1a1 1 0 000 2h1v2H1a1 1 0 100 2h3a1 1 0 000-2V6h2v13a1 1 0 001.928.374L10 14.54l2.073 4.836A1 1 0 0014 19V6h2v2a1 1 0 100 2h3a1 1 0 100-2h-1V6h1a1 1 0 100-2h-1V2h1a1 1 0 100-2h-3a1 1 0 100 2v2h-2V1a1 1 0 00-1-1H7zm1 2v2h4V2H8zm4 12.128L11.088 12 12 9.872v4.256zM8.516 6L10 9.462 11.483 6H8.516zm.396 6L8 9.872v4.256L8.912 12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kqFPH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.22 14.09l3.03-3.03.71.71L20 6.73l-5.71-5.71-5.04 5.04.71.71-3.02 3.04 4.28 4.28zm6.8 3.91h-16c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zm-15-1h4.04c.28 0 .53-.11.71-.3l2.02-2.02-3.44-3.45-4.04 4.04c-.18.18-.3.44-.3.71.01.57.46 1.02 1.01 1.02z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gzvpD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C6.71 0 3.82 1.6 2 4.05V2c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.76C5.23 3.17 7.47 2 10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8c0-.55-.45-1-1-1s-1 .45-1 1c0 5.52 4.48 10 10 10s10-4.48 10-10S15.52 0 10 0zm0 3c-.55 0-1 .45-1 1v6c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L11 9.59V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lIMeM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 12v7c0 .55.45 1 1 1h5v-7h4v7h5c.55 0 1-.45 1-1v-7l-8-8-8 8zm17.71-2.71L17 6.59V3c0-.55-.45-1-1-1s-1 .45-1 1v1.59L10.71.3C10.53.11 10.28 0 10 0s-.53.11-.71.29l-9 9a1.003 1.003 0 001.42 1.42L10 2.41l8.29 8.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4fZQN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 1c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1zm3 5h11c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm8 8H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm7-6H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h15c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3L3dc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 9h11c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm0-5h9c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm18 12H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zM1 14h14c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bbIBz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 16H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm2-5H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h11c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm3-5H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zm4-5H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9WXYr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 2H8c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM1 0C.45 0 0 .45 0 1v18c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm18 0c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g0gco":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.293 13.707a.999.999 0 001.412 0l2.963-2.962a1 1 0 000-1.49l-2.963-2.962a.999.999 0 10-1.412 1.412L13.587 10l-2.294 2.295a.999.999 0 000 1.412zM7.295 13.707a.999.999 0 001.412-1.412L6.413 10l2.294-2.295a.999.999 0 10-1.412-1.412L4.332 9.255A.996.996 0 004 10a.996.996 0 00.332.745l2.963 2.962zM0 20V0h1a1 1 0 011 1v18a1 1 0 01-1 1H0zM20 20V0h-1a1 1 0 00-1 1v18a1 1 0 001 1h1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kXEJN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 14c1.648.775 3 1 4 1-1-1-2-3.112-2-5a5.098 5.098 0 000-.045C2 5.17 6.201 1 11.172 1c3.206 0 6.9.667 8.828 5-1.648-.775-3-1-4-1 1 1 2 3.112 2 5v.045C18 14.83 13.799 19 8.828 19c-3.206 0-6.9-.667-8.828-5zm10-7a3 3 0 100 6 3 3 0 000-6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"51V5k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 5v10h16V5H2zm0-2h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2z",
    "M8.88 12.38c-.17-.39-1.01-.66-1.56-.9-.56-.24-.48-.39-.5-.6v-.09c.19-.17.35-.4.45-.67 0 0 0-.02.01-.02l.06-.18c.13-.03.2-.17.23-.29.03-.05.09-.18.08-.33-.04-.18-.11-.27-.2-.3v-.03c0-.24-.02-.58-.06-.81-.01-.06-.02-.12-.04-.19-.08-.27-.25-.52-.48-.7C6.63 7.09 6.3 7 6 7s-.63.09-.87.27c-.23.17-.4.42-.48.7-.02.06-.03.13-.04.19-.04.22-.06.57-.06.81V9c-.09.03-.17.12-.19.31-.01.14.05.27.08.32.03.14.1.27.23.3.02.06.03.12.06.18v.01c.11.27.27.51.47.68v.08c-.02.2.04.35-.51.6-.56.24-1.39.51-1.56.9-.19.39-.12.62-.12.62h5.98c-.01 0 .06-.23-.11-.62zM12 7h4c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1zM12 11h4c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dNxdF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.5 13c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM14 7H1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 10l-5-3-1 2-2-4-3 4.5V9h11v8zm3-15h-1.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H16c1.1 0 2 .9 2 2v3c0 .55.45 1 1 1s1-.45 1-1V6c0-2.21-1.79-4-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fv6F4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.29 4.29a1.003 1.003 0 001.42 1.42l2-2C8.89 3.53 9 3.28 9 3c0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H4C1.79 2 0 3.79 0 6v3c0 .55.45 1 1 1s1-.45 1-1V6c0-1.1.9-2 2-2h1.59l-.3.29zM15.5 13c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM19 7H6c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 10l-5-3-1 2-2-4-3 4.5V9h11v8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f3ugY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.29 15.71c.18.18.43.29.71.29s.53-.11.71-.29l5-5a1.003 1.003 0 00-1.42-1.42L11 12.59V1c0-.55-.45-1-1-1S9 .45 9 1v11.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l5 5zM19 14c-.55 0-1 .45-1 1v3H2v-3c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kx2of":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.92 3.56l-.01-.02c-.16-.35-.5-.6-.91-.6H4c-.41 0-.76.25-.91.6l-.01.02L0 10.49v6.46c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-6.46l-3.08-6.93zM15 10.95c-.55 0-1 .45-1 1v1H6v-1c0-.55-.45-1-1-1H1.98l2.67-6h10.7l2.67 6H15z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dpisi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.262 3l1.958 1.958v.05H4.65l-2.67 5.997H5c.55 0 1 .45 1 .999v1h8v-1c0-.55.45-1 1-1h3.02l-.635-1.426.625-.63c.354-.353.598-.8.707-1.289L20 10.545v6.456c0 .55-.45.999-1 .999H1c-.55 0-1-.45-1-1v-6.455L3.08 3.62l.01-.02c.15-.35.5-.6.91-.6h6.262zm9.088-3a.642.642 0 01.46 1.1l-3.03 3.03v2.95c0 .18-.07.34-.19.46l-1.28 1.29c-.11.1-.27.17-.45.17-.35 0-.64-.29-.64-.64V4.13L11.19 1.1a.642.642 0 01.45-1.1h7.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"biKuM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.427 3a7.467 7.467 0 00-.411 2.009H4.65l-2.67 5.996H5c.55 0 1 .45 1 .999v1h8V13c.165.01.332 0 .5 0a7.48 7.48 0 005.5-2.4V17c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1v-6.455L3.08 3.62l.01-.02c.15-.35.5-.6.91-.6h3.427zm5.715-.596a.133.133 0 01-.193 0l-.374-.374a.133.133 0 010-.193.133.133 0 01.193 0l.373.374a.133.133 0 010 .193zm1.743.033c-.05 0-.088-.006-.088-.055 0-.05.038-.056.088-.056h.165c.05 0 .088.006.088.055 0 .05-.038.056-.088.056h-.165zm.539.632c-.05 0-.104-.044-.104-.094v-.23c0-.05.054-.094.104-.094.05 0 .104.044.104.094v.23c0 .05-.055.094-.104.094zm-3.575 2.304h.506l1.182 1.2c.006.005 0 .005 0 .01v.446c0 .187-.126.341-.319.341h-.098v.226c0 .192-.138.296-.33.296h.01v.792c0 .188-.181.336-.368.336s-.369-.149-.369-.335v-1.32h-.214c-.193 0-.308-.149-.308-.341V5.72c0-.192.115-.346.308-.346zM14.5 0C17.536 0 20 2.464 20 5.5S17.536 11 14.5 11A5.502 5.502 0 019 5.5C9 2.464 11.464 0 14.5 0zm0 9.9c2.431 0 4.4-1.969 4.4-4.4 0-.297-.027-.583-.099-.864h-.236c-.188 0-.336-.104-.347-.313h-.319c.11.104.231.209.231.346v.705c0 .088-.055.17-.11.23h-.022l-.011.006-.022.011-.666.643v1.21c0 .193-.104.33-.296.33h-.54c-.192 0-.319-.137-.319-.33V6.221a.915.915 0 00-.533-.518h-.671c-.192 0-.368-.143-.368-.335V4.68c0-.192.176-.346.368-.346l.193-.005.319-.32a.342.342 0 01.489 0l.319.32c.005 0 .005.005.005.005h.704c.16 0 .237-.16.341-.313v-.11l-.038.005h-.27a.159.159 0 01-.153-.16c0-.087.066-.159.154-.159h.269l.039.006V3.42s-.05-.038-.061-.038h-.302l-.067.076a.342.342 0 01-.489.011l-.066-.088h-.176l.248.259c.021.022.021.088 0 .11-.028.022-.067.028-.088.006l-.292-.276h-.127l-.363.325-.033-.006c-.038.11-.087.089-.143.089-.126 0-.225-.072-.225-.193 0-.127.099-.209.225-.209h.176v-.182c0-.088.061-.131.149-.131h.066v-.127c0-.143.149-.297.286-.297h.28c.16 0 .27-.115.27-.275V2.42c0-.016.055.017.055-.088h-.187l-.005.017-.308.33a.123.123 0 01-.177 0c-.049-.044-.049-.121 0-.171l.391-.385c.027-.022.06-.022.094-.022l.005.022h.869A4.376 4.376 0 0014.5 1.1a4.402 4.402 0 00-2.816 1.018h.583c.094 0 .165.066.165.159s-.072.16-.165.16h-.478c0 .104-.039.06-.039.066v.351h.429l.226-.252c.132-.127.346-.155.473-.022a.332.332 0 010 .473l-1.183 1.182-.011.011c-.005.005-.011.005-.016.011a.115.115 0 00-.034.022c-.005.006-.01 0-.016.006a.309.309 0 01-.176.038h-.347c-.12.104-.187.148-.187.27v.088c0 .016-.027.027-.027.043l.561.589c.06.06.055.154 0 .209a.143.143 0 01-.209 0l-.578-.578a.425.425 0 01-.082.011c-.154 0-.292-.12-.292-.274v-.358h-.016c-.104.374-.165.77-.165 1.177 0 2.431 1.969 4.4 4.4 4.4zm3.388-3.107c.077 0 .16.06.16.137v.424c0 .077-.083.137-.16.137s-.16-.06-.16-.137V6.93c0-.077.083-.137.16-.137zm-3.113-4.879c0 .187-.154.314-.335.314h-.374v.104c0 .11-.05.198-.16.198s-.16-.088-.16-.198V1.98c-.104-.022-.033-.028-.033-.055 0-.187.127-.325.314-.325h.407c.187 0 .341.127.341.314z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ljDIq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.136 3a6.327 6.327 0 00-.098 2.009H4.65l-2.67 5.996H5c.55 0 1 .45 1 .999v1h8v-1c0-.55.45-1 1-1h1.076l1.14 1.14a2.767 2.767 0 001.974.806c.282 0 .554-.042.81-.12V17c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1v-6.455L3.08 3.62l.01-.02c.15-.35.5-.6.91-.6h3.136zm3.244 1.33c0 1.62 1.31 2.93 2.93 2.93s2.93-1.31 2.93-2.93-1.31-2.93-2.93-2.93-2.93 1.31-2.93 2.93zm6.47 2.43l2.89 2.85c.13.15.22.35.23.56 0 .43-.35.78-.78.78-.23 0-.42-.08-.56-.22l-2.87-2.87c-.17.1-.33.2-.51.29-.03.01-.06.03-.09.04-.18.07-.35.15-.55.21-.19.06-.37.11-.57.14-.05.01-.1.02-.14.02-.2.03-.39.05-.6.05A4.3 4.3 0 019 4.31C9 1.93 10.93.01 13.3 0c2.37 0 4.3 1.93 4.3 4.3 0 .21-.02.4-.05.6-.01.05-.01.09-.02.14-.04.2-.08.38-.14.58-.05.19-.13.36-.21.54-.01.03-.03.06-.04.09-.08.18-.18.34-.29.51z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4jCyk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.083 3a6.04 6.04 0 00.001 2.009H4.65l-2.67 5.996H5c.55 0 1 .45 1 .999v1h8v-1c0-.55.45-1 1-1h3.02l-.53-1.19a5.97 5.97 0 001.824-.811L20 10.545v6.456c0 .55-.45.999-1 .999H1c-.55 0-1-.45-1-1v-6.455L3.08 3.62l.01-.02c.15-.35.5-.6.91-.6h6.083zM16 8a4 4 0 110-8 4 4 0 010 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6VOun":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM9 4h2v2H9V4zm4 12H7v-1h2V8H8V7h3v8h2v1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g5hpM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 10c0 2.21 1.79 4 4 4h6.59l-2.29-2.29A.965.965 0 0114 11a1.003 1.003 0 011.71-.71l4 4c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-4 4a1.003 1.003 0 01-1.42-1.42l2.3-2.29H10c-3.31 0-6-2.69-6-6H1a1 1 0 01-1-1V1a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H6zM2 2v6h6V2H2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9FEOz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 9c.55 0 1 .45 1 1v4c0 1.1.9 2 2 2h2.59l-.3-.29a1.003 1.003 0 011.42-1.42l2 2c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2 2A1.003 1.003 0 016 19c0-.28.11-.53.3-.71l.29-.29H4c-2.21 0-4-1.79-4-4v-4c0-.55.45-1 1-1zm6.996-9c.79 0 1.68.25 2.309.73a3.63 3.63 0 011.4 2.36c.11.6.17 1.52.17 2.15v.09c.22.09.42.32.47.82.03.39-.12.73-.2.87-.07.34-.27.71-.61.78-.04.16-.09.33-.15.48-.01.01-.02.05-.02.05-.27.71-.68 1.33-1.19 1.78 0 .08 0 .16.01.23.05.55-.15.95 1.33 1.6 1.469.66 3.698 1.35 4.178 2.39.45 1.05.27 1.67.27 1.67h-5.227a1.982 1.982 0 00-.319-.417l-2-2A2.003 2.003 0 005 15H4c-.548 0-1-.452-1-1v-1.462c.511-.213 1.023-.413 1.468-.608 1.479-.65 1.329-1.05 1.379-1.59l.01-.21c-.52-.45-.95-1.08-1.22-1.8l-.01-.01-.01-.03c-.07-.15-.12-.32-.16-.49-.34-.06-.54-.43-.62-.78-.08-.14-.24-.48-.2-.87.05-.51.26-.74.49-.83v-.08c0-.64.05-1.55.17-2.15a3.648 3.648 0 011.4-2.36C6.317.25 7.207 0 7.996 0zm5.997 3c.59 0 1.26.19 1.73.55.46.35.8.85.97 1.4.04.13.07.25.08.38.08.45.13 1.14.13 1.61v.07c.16.07.31.24.35.62.02.29-.09.55-.15.65-.05.26-.2.53-.46.59-.03.12-.07.25-.11.36-.01.01-.01.04-.01.04-.2.53-.51 1-.89 1.34 0 .06 0 .12.01.17.04.41-.11.71 1 1.19 1.099.5 2.768 1.01 3.128 1.79.34.79.2 1.25.2 1.25h-3.039V15c-.06-.33-.17-.69-.33-1.06-.45-.97-1.37-1.52-3.238-2.3-.17-.07-.76-.31-.77-.32-.1-.04-.2-.08-.28-.12.05-.14.04-.29.06-.45l.01-.16c-.25-.21-.47-.48-.65-.79.22-.34.41-.71.56-1.12l.028-.078-.002.013-.006.035.06-.15c.36-.26.6-.67.72-1.13.18-.37.29-.82.25-1.3-.05-.5-.21-.92-.47-1.22-.02-.53-.06-1.11-.12-1.59.38-.17.83-.26 1.24-.26z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fjBaq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.7 4.7C7.4 6 6.5 7.9 6.5 10s.8 4 2.2 5.3c-.8.5-1.7.7-2.7.7-3.3 0-6-2.7-6-6s2.7-6 6-6c1 0 1.9.2 2.7.7zm-3.34 9.25c-.55-1.2-.86-2.54-.86-3.95s.31-2.75.86-3.95a4.001 4.001 0 000 7.9zM14 4c3.3 0 6 2.7 6 6s-2.7 6-6 6c-1 0-1.9-.2-2.7-.7 1.3-1.3 2.2-3.2 2.2-5.3s-.8-3.9-2.2-5.3C12.1 4.2 13 4 14 4zm.6 2.05c.55 1.2.86 2.54.86 3.95s-.31 2.75-.86 3.95c1.9-.31 3.36-1.96 3.36-3.95S16.5 6.36 14.6 6.05zM10 5.5C8.8 6.7 8 8.2 8 10s.8 3.3 2 4.4c1.2-1.1 2-2.7 2-4.5s-.8-3.3-2-4.4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQRpE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 10c0 5.51-4.49 10-10 10-1.17 0-2.32-.2-3.42-.6a.998.998 0 01-.6-1.28c.19-.52.76-.79 1.28-.6.88.32 1.8.48 2.74.48 4.41 0 8-3.59 8-8s-3.59-8-8-8c-.94 0-1.86.16-2.74.48a.998.998 0 01-1.28-.6.998.998 0 01.6-1.28C7.68.2 8.83 0 10 0c5.51 0 10 4.49 10 10z",
    "M15.71 9.29l-4-4a1.003 1.003 0 00-1.42 1.42L12.59 9H1a1 1 0 000 2h11.59l-2.29 2.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"35X03":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0H1C.4 0 0 .4 0 1v18c0 .5.4 1 1 1h18c.5 0 1-.5 1-1V1c0-.6-.5-1-1-1zm-1 18H2V2h16v16zM5 11h4v4c0 .6.4 1 1 1s1-.4 1-1v-4h4c.6 0 1-.4 1-1s-.4-1-1-1h-4V5c0-.6-.4-1-1-1s-1 .4-1 1v4H5c-.6 0-1 .4-1 1s.4 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ksOaJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.46-1-1-1zm4.992.975v-.044a.42.42 0 00-.106-.225 7.726 7.726 0 00-1.087-1.125c-.831-.731-1.78-1.343-2.824-1.587a4.153 4.153 0 00-1.819-.025c-.562.112-1.093.337-1.593.619-.78.443-1.5 1.05-2.124 1.73a6.88 6.88 0 00-.331.395.461.461 0 000 .58c.318.42.7.788 1.087 1.126.83.731 1.78 1.343 2.824 1.587.606.144 1.218.15 1.83.025.557-.112 1.088-.337 1.594-.619.78-.443 1.5-1.05 2.118-1.73.113-.126.231-.257.337-.395a.442.442 0 00.107-.225V10c-.013-.012-.013-.019-.013-.025zM10 12c-1.107 0-2-.893-2-2s.893-2 2-2 2 .893 2 2-.893 2-2 2zM7 1a1 1 0 00-1-1H1a1 1 0 00-1 1v5a1 1 0 002 0V2h4a1 1 0 001-1zm6 0a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 11-2 0V2h-4a1 1 0 01-1-1zm0 18a1 1 0 001 1h5a1 1 0 001-1v-5a1 1 0 10-2 0v4h-4a1 1 0 00-1 1zm-6 0a1 1 0 01-1 1H1a1 1 0 01-1-1v-5a1 1 0 112 0v4h4a1 1 0 011 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bcLz2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 4c-1.31 0-2.51.43-3.5 1.14A5.977 5.977 0 006 4c-3.31 0-6 2.69-6 6s2.69 6 6 6c1.31 0 2.51-.43 3.5-1.14.99.71 2.19 1.14 3.5 1.14 3.31 0 6-2.69 6-6s-2.69-6-6-6zm-4.93 9.41c-.61.37-1.31.59-2.07.59-2.21 0-4-1.79-4-4s1.79-4 4-4c.76 0 1.46.22 2.07.59C7.4 7.56 7 8.73 7 10s.4 2.44 1.07 3.41zM13 14c-.76 0-1.46-.22-2.07-.59C11.6 12.44 12 11.27 12 10s-.4-2.44-1.07-3.41C11.54 6.22 12.24 6 13 6c2.21 0 4 1.79 4 4s-1.79 4-4 4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h835B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 3.66C6 5.69 10 11 10 11s4-5.31 4-7.34C13.99 1.64 12.21 0 10 0S6 1.64 6 3.66zM8 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM14 13.5V13h-4v1h3v2h-2v1h3v-3.5zM3 12h14c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1zm4 1v6h1v-6H7zm3 1v5h1v-5h-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jB77G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm1-2H9v-2h2v2zm0-3H9V4h2v9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fdDkX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.364 5.9a.997.997 0 01-.707-.293l-2.121-2.122a1 1 0 111.414-1.414l1.414 1.414L18.192.657a1 1 0 011.414 1.414l-3.535 3.536a.997.997 0 01-.707.292zM11.78.157a3.002 3.002 0 00-1.437 1.85 8 8 0 107.1 5.055l.042-.042 1.472-1.472A9.959 9.959 0 0120 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0c.608 0 1.202.054 1.78.158zM11 16H9v-2h2v2zm0-3H9V4h2v9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iriT9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.167.512a2.98 2.98 0 00-.131.524c-.74.115-1.39.5-1.848 1.052a8 8 0 106.724 6.724 2.997 2.997 0 001.052-1.848 2.98 2.98 0 00.524-.13A9.99 9.99 0 0120 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0a9.99 9.99 0 013.167.512zM11 16H9v-2h2v2zm0-3H9V4h2v9zm6-10h1.5a1 1 0 010 2H17v1.5a1 1 0 01-2 0V5h-1.5a1 1 0 010-2H15V1.5a1 1 0 012 0V3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4BIQk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.7 4H14c.6 0 1-.4 1-1s-.4-1-1-1H7c-.6 0-1 .4-1 1s.4 1 1 1h2.2L7.3 15H5c-.6 0-1 .4-1 1s.4 1 1 1h7c.6 0 1-.4 1-1s-.4-1-1-1H9.8l1.9-11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aFVIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 6h-4V2c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h4v4c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zM6 12H2V9h4v3zm0-4H2V5h4v3zm7 9H7v-3h6v3zm0-4H7V9h6v4zm0-5H7V5h6v3zm5 9h-4v-3h4v3zm0-4h-4v-3h4v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g7TW0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 0c-3.31 0-6 2.69-6 6 0 1.11.32 2.14.85 3.03L.44 17.44a1.498 1.498 0 102.12 2.12l.79-.79.94.94c.18.18.43.29.71.29s.53-.11.71-.29l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-.94-.94 3.2-3.2A5.9 5.9 0 0014 12c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 9c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5TBKn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 3H7c-.28 0-.53.11-.71.29l-6 6C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l6 6c.18.18.43.29.71.29h12c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-2.29 9.29a1.003 1.003 0 01-1.42 1.42L13 11.41l-2.29 2.29c-.18.19-.43.3-.71.3a1.003 1.003 0 01-.71-1.71l2.3-2.29-2.3-2.29a1.003 1.003 0 011.42-1.42L13 8.59l2.29-2.29c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71L14.41 10l2.3 2.29z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzSIy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.5 12H14V8h1.5C17.43 8 19 6.43 19 4.5S17.43 1 15.5 1 12 2.57 12 4.5V6H8V4.5C8 2.57 6.43 1 4.5 1S1 2.57 1 4.5 2.57 8 4.5 8H6v4H4.5C2.57 12 1 13.57 1 15.5S2.57 19 4.5 19 8 17.43 8 15.5V14h4v1.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0-9c.83 0 1.5.67 1.5 1.5S16.33 6 15.5 6 14 5.33 14 4.5 14.67 3 15.5 3zm-11 14c-.83 0-1.5-.67-1.5-1.5S3.67 14 4.5 14s1.5.67 1.5 1.5S5.33 17 4.5 17zm0-11C3.67 6 3 5.33 3 4.5S3.67 3 4.5 3 6 3.67 6 4.5 5.33 6 4.5 6zm7.5 6H8V8h4v4zm3.5 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i1OlC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.71 7.29l-6-6C10.53 1.11 10.28 1 10 1s-.53.11-.71.29l-6 6a1.003 1.003 0 001.42 1.42L10 3.41l5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8PbaZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.71 9.29l-6-6A.997.997 0 0013 3H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.28 0 .53-.11.71-.29l6-6c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zm-9 3a1.003 1.003 0 01-1.42 1.42L7 11.41 4.71 13.7c-.18.19-.43.3-.71.3a1.003 1.003 0 01-.71-1.71L5.59 10l-2.3-2.29a1.003 1.003 0 011.42-1.42L7 8.59 9.29 6.3c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71L8.41 10l2.3 2.29z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i920w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 2c-.55 0-1 .45-1 1v5c0 2.21-1.79 4-4 4H4.41L6.7 9.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L4.41 14H13c3.31 0 6-2.69 6-6V3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6XR7p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 8c.55 0 1-.45 1-1V4.41l6.29 6.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L4.41 3H7c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1zm9-6.94V3.1c3.39.49 6 3.38 6 6.9 0 3.87-3.13 7-7 7-3.52 0-6.41-2.61-6.9-6H1.06c.5 4.5 4.31 8 8.94 8a9 9 0 009-9c0-4.63-3.5-8.44-8-8.94z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"csfMk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 4h6c.55 0 1-.45 1-1s-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1zm6 12h-4.42L6.87 2.5l-.02.01A.977.977 0 006 2H1c-.55 0-1 .45-1 1s.45 1 1 1h4.42l7.71 13.5.01-.01c.18.3.49.51.86.51h5c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1SbGP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17.74 10.35l-6.99-8.01-.01.01C10.56 2.14 10.3 2 10 2s-.56.14-.74.35l-.01-.01-7 8 .01.01A.95.95 0 002 11c0 .55.45 1 1 1h3v5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-5h3c.55 0 1-.45 1-1 0-.25-.1-.48-.26-.65z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eXnzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 13H4.41l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L2 12.59V10c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1s1-.45 1-1v-2.59l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L4.41 15H19c.55 0 1-.45 1-1s-.45-1-1-1zm0-12c-.55 0-1 .45-1 1v2.59L14.71 1.3A.965.965 0 0014 1a1.003 1.003 0 00-.71 1.71L15.59 5H1c-.55 0-1 .45-1 1s.45 1 1 1h14.59L13.3 9.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 7.41V10c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bKaqj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 4a.997.997 0 00-.707.293L14 8.586l-2.293-2.293a1 1 0 00-1.414 1.414l3 3a.997.997 0 001.414 0l5-5A1 1 0 0019 4zm-2.048 7.291c.011.072.048.134.048.209a1.5 1.5 0 01-1.5 1.5c-.225 0-.433-.057-.624-.145-.279.085-.57.145-.876.145a2.99 2.99 0 01-2.121-.879l-3-3 .007-.007A3.027 3.027 0 018.184 8H4V7l1-3h10l.19.568 1.307-1.308c-.336-.356-.758-.658-1.165-.772 0 0-1.74-.488-5.332-.488s-5.332.488-5.332.488c-.67.188-1.424.864-1.674 1.502L2.99 4H3L2 7H1a1 1 0 000 2h.333l-.28.84L1 10v7.5a1.5 1.5 0 103 0V17h12v.5a1.5 1.5 0 003 0V10l-.19-.568-1.858 1.86zM4.5 13a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16fjD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 2a1 1 0 010 2v4l4 8v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-1l4-8V4a1 1 0 110-2h6zm-2 2H9v4l-2 4h6l-2-4V4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j0PVh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 12h14v-1H3v1zm11-9H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V9l-6-6zm4 12H2V5h11v3H3v1h10v1h5v5zm-4-6V5l4 4h-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hKDS2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.5 9.1l-9-5c-.2-.1-.3-.1-.5-.1s-.3 0-.5.1l-9 5c-.3.2-.5.5-.5.9s.2.7.5.9l9 5c.2.1.3.1.5.1s.3 0 .5-.1l9-5c.3-.2.5-.5.5-.9s-.2-.7-.5-.9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d5ovR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.514 4.126l-9 5a1 1 0 000 1.748l9 5a1 1 0 00.972 0l9-5a1 1 0 000-1.748l-9-5a1 1 0 00-.972 0zM10 6.144l6.94 3.855L10 13.855 3.059 9.999 10 6.144z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bGsxq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M.5 6.9l9 5c.2.1.3.1.5.1s.3 0 .5-.1l9-5c.3-.2.5-.5.5-.9s-.2-.7-.5-.9l-9-5c-.2-.1-.3-.1-.5-.1s-.3 0-.5.1l-9 5c-.3.2-.5.5-.5.9s.2.7.5.9z",
    "M19 9c-.2 0-.3 0-.5.1L10 13.9 1.5 9.1C1.3 9 1.2 9 1 9c-.6 0-1 .4-1 1 0 .4.2.7.5.9l9 5c.2.1.3.1.5.1s.3 0 .5-.1l9-5c.3-.2.5-.5.5-.9 0-.6-.4-1-1-1z",
    "M19 13c-.2 0-.3 0-.5.1L10 17.9l-8.5-4.7c-.2-.2-.3-.2-.5-.2-.6 0-1 .4-1 1 0 .4.2.7.5.9l9 5c.2.1.3.1.5.1s.3 0 .5-.1l9-5c.3-.2.5-.5.5-.9 0-.6-.4-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4QKdG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 6c-1.1 0-2 .9-2 2 0 .37.11.71.28 1.01l-2.27 2.27c-.3-.17-.64-.28-1.01-.28-.93 0-1.71.64-1.93 1.5H8.93c-.22-.86-1-1.5-1.93-1.5-.37 0-.71.11-1.01.28L3.72 9.01C3.89 8.71 4 8.37 4 8c0-.34-.09-.66-.24-.94l3.66-3.38c.31.2.68.32 1.08.32 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .34.09.66.24.94L3.08 6.32C2.77 6.12 2.4 6 2 6 .9 6 0 6.9 0 8s.9 2 2 2c.37 0 .71-.11 1.01-.28l2.27 2.27c-.17.3-.28.64-.28 1.01s.11.71.28 1.01l-2.27 2.27C2.71 16.11 2.37 16 2 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.37-.11-.71-.28-1.01l2.27-2.27c.3.17.64.28 1.01.28.93 0 1.71-.64 1.93-1.5h2.14c.22.86 1 1.5 1.93 1.5 1.1 0 2-.9 2-2 0-.37-.11-.71-.28-1.01l2.27-2.27c.3.17.64.28 1.01.28 1.1 0 2-.9 2-2s-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7xO4D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 13c-.53 0-1.01.21-1.37.55L11.9 10.6c.06-.19.1-.39.1-.6s-.04-.41-.1-.6l4.72-2.95c.37.34.85.55 1.38.55 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .21.04.41.1.6l-4.73 2.96c-.24-.23-.54-.4-.87-.48V3.93c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S8 .9 8 2c0 .93.64 1.71 1.5 1.93v4.14c-.33.09-.63.26-.87.48L3.9 5.6c.06-.19.1-.39.1-.6 0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.53 0 1.01-.21 1.37-.55L8.1 9.4c-.06.19-.1.39-.1.6s.04.41.1.6l-4.72 2.95C3.01 13.21 2.53 13 2 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.21-.04-.41-.1-.6l4.73-2.96c.24.23.54.4.87.48v4.14C8.64 16.29 8 17.07 8 18c0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93v-4.14c.33-.09.63-.26.87-.48l4.73 2.96c-.06.18-.1.38-.1.59 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"boQ2o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 16c-.14 0-.28.02-.42.05l-1.73-3.45c.69-.45 1.14-1.22 1.14-2.1s-.46-1.65-1.14-2.1l1.73-3.45c.14.03.28.05.42.05 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .6.27 1.13.69 1.5l-1.77 3.54c-.14-.02-.28-.04-.42-.04a2.5 2.5 0 00-2.45 2h-4.1A2.5 2.5 0 005.5 8c-.14 0-.28.02-.42.04L3.31 4.5C3.73 4.13 4 3.6 4 3c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.14 0 .28-.02.42-.05L4.14 8.4C3.46 8.85 3 9.62 3 10.5s.46 1.65 1.14 2.1l-1.73 3.45A1.84 1.84 0 002 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.6-.27-1.13-.69-1.5l1.77-3.54c.14.02.28.04.42.04a2.5 2.5 0 002.45-2h4.1a2.5 2.5 0 002.45 2c.14 0 .28-.02.42-.04l1.77 3.54c-.42.37-.69.9-.69 1.5 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5a69X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 1a1 1 0 011-1h18a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM0 12a1 1 0 011-1h3a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1v-7zM7 12a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1H8a1 1 0 01-1-1v-7zM15 12a1 1 0 011-1h3a1 1 0 011 1v7a1 1 0 01-1 1h-3a1 1 0 01-1-1v-7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lyxIi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 12a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1v-7zM11 12a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1h-7a1 1 0 01-1-1v-7zM0 1a1 1 0 011-1h18a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l7m6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.3 8c-.2-.9-.6-1.7-1.1-2.5.2-.3.3-.7.3-1 0-1.1-.9-2-2-2-.4 0-.7.1-1 .3-.8-.5-1.6-.8-2.5-1.1-.1-1-1-1.7-2-1.7S8.2.8 8 1.7c-.9.3-1.7.6-2.5 1.1-.3-.2-.7-.3-1-.3-1.1 0-2 .9-2 2 0 .4.1.7.3 1-.5.8-.8 1.6-1.1 2.5C.8 8.2 0 9 0 10s.8 1.8 1.7 2c.2.9.6 1.7 1.1 2.5-.2.3-.3.7-.3 1 0 1.1.9 2 2 2 .4 0 .7-.1 1-.3.8.5 1.6.8 2.5 1.1.1 1 1 1.7 2 1.7s1.8-.8 2-1.7c.9-.2 1.7-.6 2.5-1.1.3.2.7.3 1 .3 1.1 0 2-.9 2-2 0-.4-.1-.7-.3-1 .5-.8.8-1.6 1.1-2.5 1-.1 1.7-1 1.7-2s-.8-1.8-1.7-2zm-1.8 5.8c-.3-.2-.6-.3-1-.3-1.1 0-2 .9-2 2 0 .4.1.7.3 1-.6.3-1.2.6-1.9.8-.3-.7-1-1.3-1.9-1.3-.8 0-1.6.5-1.9 1.3-.7-.2-1.3-.4-1.9-.8.2-.3.3-.6.3-1 0-1.1-.9-2-2-2-.4 0-.7.1-1 .3-.3-.6-.6-1.2-.8-1.9.8-.3 1.3-1.1 1.3-1.9s-.5-1.6-1.2-1.8c.2-.7.4-1.3.8-1.9.3.2.6.3 1 .3 1.1 0 2-.9 2-2 0-.4-.1-.7-.3-1 .6-.3 1.2-.6 1.9-.8.2.7 1 1.2 1.8 1.2s1.6-.5 1.9-1.3c.7.2 1.3.4 1.9.8-.2.3-.3.6-.3 1 0 1.1.9 2 2 2 .4 0 .7-.1 1-.3.3.6.6 1.2.8 1.9-.8.3-1.3 1.1-1.3 1.9s.5 1.6 1.2 1.8c-.1.7-.4 1.4-.7 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8r0fQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 0a2 2 0 100 4 2 2 0 100-4zM10 0a2 2 0 100 4 2 2 0 100-4zM18 0a2 2 0 100 4 2 2 0 100-4zM18 8a2 2 0 100 4 2 2 0 100-4zM18 16a2 2 0 100 4 2 2 0 100-4zM10 16a2 2 0 100 4 2 2 0 100-4zM2 16a2 2 0 100 4 2 2 0 100-4zM2 8a2 2 0 100 4 2 2 0 100-4zM10 8a2 2 0 100 4 2 2 0 100-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hdknN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 2a2 2 0 100 4 2 2 0 100-4zM18 0a2 2 0 100 4 2 2 0 100-4zM18 8a2 2 0 100 4 2 2 0 100-4zM18 16a2 2 0 100 4 2 2 0 100-4zM2 14a2 2 0 100 4 2 2 0 100-4zM2 8a2 2 0 100 4 2 2 0 100-4zM13 12a2 2 0 100 4 2 2 0 100-4zM13 4a2 2 0 100 4 2 2 0 100-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gQK8b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.5 16.07v-4.14c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2-.93 0-1.71.64-1.93 1.5h-4.14c-.18-.7-.73-1.25-1.43-1.43V3.93c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S8 .9 8 2c0 .93.64 1.71 1.5 1.93v4.14c-.7.18-1.25.73-1.43 1.43H3.93C3.71 8.64 2.93 8 2 8c-1.1 0-2 .9-2 2 0 .93.64 1.71 1.5 1.93v4.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93v-4.14c.7-.18 1.25-.73 1.43-1.43h4.14c.18.7.73 1.25 1.43 1.43v4.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93v-4.14c.7-.18 1.25-.73 1.43-1.43h4.14c.18.7.73 1.25 1.43 1.43v4.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2To6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 1a1 1 0 011-1h7a1 1 0 011 1v18a1 1 0 01-1 1h-7a1 1 0 01-1-1V1zM0 1a1 1 0 011-1h7a1 1 0 011 1v3a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM0 8a1 1 0 011-1h7a1 1 0 011 1v4a1 1 0 01-1 1H1a1 1 0 01-1-1V8zM0 16a1 1 0 011-1h7a1 1 0 011 1v3a1 1 0 01-1 1H1a1 1 0 01-1-1v-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fd0T1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 1a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM0 12a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1v-7zM11 1a1 1 0 011-1h7a1 1 0 011 1v18a1 1 0 01-1 1h-7a1 1 0 01-1-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gXyG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.5 7a2.5 2.5 0 00-2.45 2h-2.1a2.5 2.5 0 00-4.9 0h-2.1a2.5 2.5 0 100 1h2.1a2.5 2.5 0 004.9 0h2.1a2.5 2.5 0 102.45-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"408Lk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 1a1 1 0 011-1h7a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM11 1a1 1 0 011-1h7a1 1 0 011 1v3a1 1 0 01-1 1h-7a1 1 0 01-1-1V1zM11 8a1 1 0 011-1h7a1 1 0 011 1v4a1 1 0 01-1 1h-7a1 1 0 01-1-1V8zM11 16a1 1 0 011-1h7a1 1 0 011 1v3a1 1 0 01-1 1h-7a1 1 0 01-1-1v-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"buQAD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 1a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1h-7a1 1 0 01-1-1V1zM11 12a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1h-7a1 1 0 01-1-1v-7zM0 1a1 1 0 011-1h7a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ogi2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 0a2 2 0 100 4 2 2 0 100-4zM18 0a2 2 0 100 4 2 2 0 100-4zM18 8a2 2 0 100 4 2 2 0 100-4zM18 16a2 2 0 100 4 2 2 0 100-4zM2 16a2 2 0 100 4 2 2 0 100-4zM2 8a2 2 0 100 4 2 2 0 100-4zM10 12a2 2 0 100 4 2 2 0 100-4zM10 4a2 2 0 100 4 2 2 0 100-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kaFmJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm16 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-8 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eiARR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 1a1 1 0 011-1h3a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM7 1a1 1 0 011-1h4a1 1 0 011 1v18a1 1 0 01-1 1H8a1 1 0 01-1-1V1zM15 1a1 1 0 011-1h3a1 1 0 011 1v18a1 1 0 01-1 1h-3a1 1 0 01-1-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"47gUw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 1a1 1 0 011-1h18a1 1 0 011 1v3a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM0 8a1 1 0 011-1h18a1 1 0 011 1v4a1 1 0 01-1 1H1a1 1 0 01-1-1V8zM0 16a1 1 0 011-1h18a1 1 0 011 1v3a1 1 0 01-1 1H1a1 1 0 01-1-1v-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6k1rs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 12a1 1 0 011-1h18a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1v-7zM0 1a1 1 0 011-1h3a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM7 1a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1H8a1 1 0 01-1-1V1zM15 1a1 1 0 011-1h3a1 1 0 011 1v7a1 1 0 01-1 1h-3a1 1 0 01-1-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7KTAq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 1a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM11 1a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1h-7a1 1 0 01-1-1V1zM0 12a1 1 0 011-1h18a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1v-7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d7sv1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 1a1 1 0 011-1h7a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM11 1a1 1 0 011-1h7a1 1 0 011 1v18a1 1 0 01-1 1h-7a1 1 0 01-1-1V1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lgGoS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 1a1 1 0 011-1h18a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM0 12a1 1 0 011-1h18a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1v-7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"97Ptg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.551 1.127a1.256 1.256 0 00-1.102 0L.456 5.89c-.608.309-.608.913 0 1.222l8.993 4.762c.334.17.767.17 1.102 0l8.992-4.762c.61-.309.61-.913 0-1.222l-8.992-4.762z",
    "M18 6.5l.016 4.514c.002.548.447.99.994.99a.99.99 0 00.99-.99V6.5h-2zM3.366 10.033l6.401 3.358a.5.5 0 00.465 0l6.406-3.358a.25.25 0 01.366.221v5.109a.25.25 0 01-.139.224l-6.64 3.302a.5.5 0 01-.446 0l-6.64-3.302A.25.25 0 013 15.363v-5.108a.25.25 0 01.366-.222z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5eLLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.7 4.7C7.4 6 6.5 7.9 6.5 10s.8 4 2.2 5.3c-.8.5-1.7.7-2.7.7-3.3 0-6-2.7-6-6s2.7-6 6-6c1 0 1.9.2 2.7.7zM14 4c3.3 0 6 2.7 6 6s-2.7 6-6 6c-1 0-1.9-.2-2.7-.7 1.3-1.3 2.2-3.2 2.2-5.3s-.8-3.9-2.2-5.3C12.1 4.2 13 4 14 4zm.6 2.05c.55 1.2.86 2.54.86 3.95s-.31 2.75-.86 3.95c1.9-.31 3.36-1.96 3.36-3.95S16.5 6.36 14.6 6.05zM10 5.5C8.8 6.7 8 8.2 8 10s.8 3.3 2 4.4c1.2-1.1 2-2.7 2-4.5s-.8-3.3-2-4.4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"drk9K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M.833 16h8.334c.458 0 .833-.45.833-1s-.375-1-.833-1H.833C.375 14 0 14.45 0 15s.375 1 .833 1zM1 11h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm15 2c0 .28.11.53.29.71l.3.29H13c-.55 0-1 .45-1 1s.45 1 1 1h3.59l-.29.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l2-2c.18-.19.29-.44.29-.71 0-.28-.11-.53-.29-.71l-2-2A.997.997 0 0017 12a.99.99 0 00-1 1zM1 6h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kFNIJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.162 10l9.154 3.052a1 1 0 01-.632 1.897l-12-4c-.912-.304-.912-1.594 0-1.897l12-4a1 1 0 01.632 1.897L7.162 10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5grpI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.316 11.051L7.162 8l9.154-3.051a1 1 0 10-.632-1.898l-12 4c-.912.304-.912 1.594 0 1.898l12 4a1 1 0 10.632-1.898zM16 15H4a1 1 0 100 2h12a1 1 0 100-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7x8vh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.143 14.644L7.028 17.43c.919.368 1.922.57 2.972.57s2.053-.202 2.972-.57l-1.115-2.786A4.986 4.986 0 0110 15a4.986 4.986 0 01-1.857-.356zm-2.787-2.787A4.986 4.986 0 015 10c0-.656.126-1.283.356-1.857L2.57 7.028A7.978 7.978 0 002 10c0 1.05.202 2.053.57 2.972l2.786-1.115zm2.787-6.5A4.986 4.986 0 0110 5c.656 0 1.283.126 1.857.356l1.115-2.786A7.978 7.978 0 0010 2c-1.05 0-2.053.202-2.972.57l1.115 2.786zm6.5 2.786c.23.574.357 1.2.357 1.857 0 .656-.126 1.283-.356 1.857l2.786 1.115c.368-.919.57-1.922.57-2.972s-.202-2.053-.57-2.972l-2.786 1.115zM10 13a3 3 0 100-6 3 3 0 000 6zm0 7C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ag6Q2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.33 13.39c0 .34.27.61.6.61h6.13c.33 0 .6-.27.6-.61C14.03 9.78 16 9.4 16 6.09 16 2.72 13.31 0 10 0S4 2.72 4 6.09c0 3.31 1.97 3.69 2.33 7.3zM13 15H7c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm-1 3H8c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"93F85":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 11H6a1 1 0 01-1-1L5.91.9a1 1 0 01.995-.9h6.256a.839.839 0 01.779 1.15L11.2 8h2.978a.822.822 0 01.748 1.162l-4.764 10.481A.608.608 0 019 19.392V11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCboZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.85 11.98l-4.44 4.44-1 1c-.36.36-.86.58-1.41.58-1.1 0-2-.9-2-2 0-.55.22-1.05.59-1.41l5.44-5.44C7.69 9.06 7.36 9 7 9c-1.11 0-2.09.46-2.82 1.18l-.01-.01-3 3 .01.01C.46 13.91 0 14.89 0 16c0 2.21 1.79 4 4 4 1.11 0 2.09-.46 2.82-1.18l.01.01 3-3-.01-.01C10.54 15.09 11 14.11 11 13c0-.36-.06-.69-.15-1.02zM20 4c0-2.21-1.79-4-4-4-1.11 0-2.09.46-2.82 1.18l-.01-.01-3 3 .01.01C9.46 4.91 9 5.89 9 7c0 .36.06.69.15 1.02l4.44-4.44 1-1c.36-.36.86-.58 1.41-.58 1.1 0 2 .9 2 2 0 .55-.22 1.05-.59 1.41l-5.44 5.44c.34.09.67.15 1.03.15 1.11 0 2.09-.46 2.82-1.18l.01.01 3-3-.01-.01C19.54 6.09 20 5.11 20 4zM5 14a1.003 1.003 0 001.71.71l8-8a1.003 1.003 0 00-1.42-1.42l-2 2-2 2-2 2-2 2c-.18.18-.29.43-.29.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bPSmk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.1 1A1.1 1.1 0 000 2.1v10.8A1.1 1.1 0 001.1 14H3a1 1 0 100-2H2V3h11v9H9a1 1 0 100 2h4.9a1.1 1.1 0 001.1-1.1V2.1A1.1 1.1 0 0013.9 1H1.1z",
    "M6.1 19A1.1 1.1 0 015 17.9V7.1A1.1 1.1 0 016.1 6H11a1 1 0 110 2H7v9h11V8h-1a1 1 0 110-2h1.9A1.1 1.1 0 0120 7.1v10.8a1.1 1.1 0 01-1.1 1.1H6.1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0In9g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.03 1C.46 1 0 1.46 0 2.03v.95C0 3.54.46 4 1.03 4h17.95C19.54 4 20 3.54 20 2.97v-.94C20 1.46 19.54 1 18.97 1H1.03zM0 17.97C0 18.54.46 19 1.03 19h17.95c.56 0 1.03-.46 1.03-1.03v-.95c0-.56-.46-1.03-1.03-1.03H1.03C.46 16 0 16.46 0 17.03v.94zM0 12.97C0 13.54.46 14 1.03 14h17.95c.56 0 1.03-.46 1.03-1.03v-.95c0-.56-.46-1.03-1.03-1.03H1.03C.46 11 0 11.46 0 12.03v.94zM0 7.97C0 8.54.46 9 1.03 9h17.95C19.54 9 20 8.54 20 7.97v-.94C20 6.46 19.54 6 18.97 6H1.03C.46 6 0 6.46 0 7.03v.94z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4NMzc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 2.973v-.936C0 1.468.46 1.01 1.029 1H7.97C8.541 1 9 1.468 9 2.027v.946C9 3.542 8.53 4 7.971 4H1.03C.459 4 0 3.542 0 2.973zm0 5v-.936C0 6.468.46 6.01 1.029 6H7.97C8.541 6 9 6.468 9 7.027v.946C9 8.542 8.53 9 7.971 9H1.03C.459 9 0 8.542 0 7.973zm0 5v-.936C0 11.468.46 11.01 1.029 11H7.97C8.541 11 9 11.468 9 12.027v.946C9 13.542 8.53 14 7.971 14H1.03C.459 14 0 13.542 0 12.973zm0 5v-.936C0 16.468.46 16.01 1.029 16H7.97C8.541 16 9 16.468 9 17.027v.946C9 18.542 8.53 19 7.971 19H1.03C.459 19 0 18.542 0 17.973zm11-15v-.936c0-.569.46-1.027 1.029-1.037h6.942C19.541 1 20 1.468 20 2.027v.946C20 3.542 19.53 4 18.971 4H12.03C11.459 4 11 3.542 11 2.973zm0 5v-.936c0-.569.46-1.027 1.029-1.037h6.942C19.541 6 20 6.468 20 7.027v.946C20 8.542 19.53 9 18.971 9H12.03C11.459 9 11 8.542 11 7.973zm0 5v-.936c0-.569.46-1.027 1.029-1.037h6.942c.57 0 1.029.468 1.029 1.027v.946c0 .569-.47 1.027-1.029 1.027H12.03c-.57 0-1.029-.458-1.029-1.027zm0 5v-.936c0-.569.46-1.027 1.029-1.037h6.942c.57 0 1.029.468 1.029 1.027v.946c0 .569-.47 1.027-1.029 1.027H12.03c-.57 0-1.029-.458-1.029-1.027z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Ve8Sc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 6H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zm0 5H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm0 5H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zM8 1H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm11 0h-7c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kf6gC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm9 1h-1.07c-.45-3.61-3.32-6.45-6.93-6.91V1c0-.55-.45-1-1-1S9 .45 9 1v1.09C5.39 2.55 2.52 5.39 2.07 9H1c-.55 0-1 .45-1 1s.45 1 1 1h1.07c.45 3.61 3.32 6.45 6.93 6.91V19c0 .55.45 1 1 1s1-.45 1-1v-1.09c3.61-.46 6.48-3.29 6.93-6.91H19c.55 0 1-.45 1-1s-.45-1-1-1zm-4 2h.9a5.98 5.98 0 01-4.9 4.91V15c0-.55-.45-1-1-1s-1 .45-1 1v.91A5.98 5.98 0 014.1 11H5c.55 0 1-.45 1-1s-.45-1-1-1h-.9A5.98 5.98 0 019 4.09V5c0 .55.45 1 1 1s1-.45 1-1v-.91A5.98 5.98 0 0115.9 9H15c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d3yNN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.93 9H14V4.99c0-2.21-1.79-4-4-4s-4 1.79-4 4V9H3.93c-.55 0-.93.44-.93.99v8c0 .55.38 1.01.93 1.01h12c.55 0 1.07-.46 1.07-1.01v-8c0-.55-.52-.99-1.07-.99zM8 9V4.99c0-1.1.9-2 2-2s2 .9 2 2V9H8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"exX9v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.988 2h-7.99A1 1 0 001 3v13h1.74a.523.523 0 00.412-.21c2.325-3.051 4.623-1.437 5.684-.008.1.134.254.218.42.218h.488c.154 0 .301-.074.399-.194 2.576-3.142 4.762-1.491 5.687-.058a.534.534 0 00.444.252h2.496a.5.5 0 00.353-.854L17.978 14c3.495-3 1.997-5.667-.999-7V5l1.145-1.146A.5.5 0 0017.771 3H14.19a.5.5 0 00-.353.854L14.982 5v2h-3.995V3a1 1 0 00-.999-1zm-6.99 2h2.995v5H2.997V4zM8.99 4H6.992v5H8.99V4z",
    "M5.993 19a1.999 1.999 0 001.998-2 1.999 1.999 0 10-3.995 0c0 1.105.894 2 1.997 2zm0-1a1 1 0 100-1.999 1 1 0 000 1.999zM12.984 19a1.999 1.999 0 001.998-2 1.999 1.999 0 10-3.995 0c0 1.105.894 2 1.997 2zm0-1a1 1 0 100-1.999 1 1 0 000 1.999z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"yjnkQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0h-8c-.55 0-1 .45-1 1s.45 1 1 1h7v16h-7c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-4 10c0-.28-.11-.53-.29-.71l-5-5a1.003 1.003 0 00-1.42 1.42L11.59 9H1c-.55 0-1 .45-1 1s.45 1 1 1h10.59L8.3 14.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l5-5c.18-.18.29-.43.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lP96p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.71 9.29l-5-5a1.003 1.003 0 00-1.42 1.42L16.59 9H6c-.55 0-1 .45-1 1s.45 1 1 1h10.59l-3.29 3.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l5-5c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM9 18H2V2h7c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9wPwC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0a1 1 0 00-1 1v2H5V2a1 1 0 00-2 0v1H2a1 1 0 000 2h1v2H2a1 1 0 000 2h4a1 1 0 000-2H5V5h4v14a1 1 0 102 0V5h4v2h-1a1 1 0 100 2h4a1 1 0 100-2h-1V5h1a1 1 0 100-2h-1V2a1 1 0 10-2 0v1h-4V1a1 1 0 00-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iW18G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 1.1a.976.976 0 00-.83-.88C15.15-.43 12.07.34 10 2.5 7.93.34 4.85-.43.84.22.37.3.03.67 0 1.1v15.01c0 .07 0 .14.01.21.09.52.61.88 1.15.79 3.85-.62 6.4.16 8 2.46.02.02.03.04.05.07.02.02.04.04.06.07l.01.01a1.07 1.07 0 00.28.19c.01 0 .01.01.02.01.03.01.07.03.1.04.01 0 .02.01.04.01.03.01.07.02.1.02.01 0 .02 0 .04.01H10c.04 0 .09 0 .13-.01.01 0 .03 0 .04-.01.03-.01.06-.01.1-.02.01 0 .03-.01.04-.01.03-.01.07-.02.1-.04.01 0 .02-.01.03-.01.07-.03.13-.07.19-.11.01 0 .01-.01.02-.01.02-.02.04-.03.06-.05.01-.01.02-.02.03-.02l.05-.05c.01-.01.02-.02.02-.03.01-.02.02-.03.04-.05 1.61-2.3 4.15-3.09 8-2.46.54.09 1.06-.26 1.15-.79-.01-.05 0-.09 0-.13V1.1zM9 16.63c-1.78-1.31-4.12-1.83-7-1.55V2c3.26-.37 5.51.39 7 2.35v12.28zm9-1.56c-2.88-.28-5.22.24-7 1.55V4.34c1.49-1.96 3.74-2.71 7-2.35v13.08z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGzBj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 12h4.34l2-2H1c-.55 0-1 .45-1 1s.45 1 1 1zm16.77-3.94l1.65-1.65c.36-.36.58-.86.58-1.41 0-1.1-.9-2-2-2-.55 0-1.05.22-1.41.59l-1.65 1.65 2.83 2.82zM1 4h12.34l2-2H1c-.55 0-1 .45-1 1s.45 1 1 1zM0 15c0 .55.45 1 1 1h.34l2-2H1c-.55 0-1 .45-1 1zm1-7h8.34l2-2H1c-.55 0-1 .45-1 1s.45 1 1 1zm18 2h-.34l-2 2H19c.55 0 1-.45 1-1s-.45-1-1-1zm0 4h-4.34l-2 2H19c.55 0 1-.45 1-1s-.45-1-1-1zM4 19l4.41-1.59-2.81-2.79L4 19zM14.23 5.94l-7.65 7.65 2.83 2.83 7.65-7.65-2.83-2.83z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7jSvo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 6a1 1 0 100-2 1 1 0 000 2zm0 2a3 3 0 01-2.73-1.754c-.2.068-.408.154-.617.264-.884.465-1.92 1.418-2.605 3.49.685 2.072 1.721 3.025 2.605 3.49.21.11.416.196.617.264a3 3 0 11-.165 2.034 6.262 6.262 0 01-1.383-.528c-.983-.518-1.948-1.364-2.722-2.705-.774 1.34-1.739 2.187-2.722 2.705-.48.252-.95.419-1.383.528A3.001 3.001 0 010 15a3 3 0 015.73-1.246c.2-.068.408-.154.617-.264.884-.465 1.92-1.418 2.605-3.49-.685-2.072-1.721-3.025-2.605-3.49a4.21 4.21 0 00-.617-.264 3 3 0 11.165-2.034c.433.11.904.276 1.383.528.983.518 1.948 1.364 2.722 2.705.774-1.34 1.739-2.187 2.722-2.705.48-.252.95-.419 1.383-.528A3.001 3.001 0 0120 5a3 3 0 01-3 3zM4 5a1 1 0 10-2 0 1 1 0 002 0zm12 10a1 1 0 102 0 1 1 0 00-2 0zM3 14a1 1 0 110 2 1 1 0 010-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvPp5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 2a1 1 0 100 2 1 1 0 000-2zm0 4c1.296 0 2.4-.821 2.82-1.972.487.039 1.086.13 1.667.347.947.352 1.773 1 2.032 2.318.323 1.644 1.234 2.675 2.264 3.307-1.03.632-1.941 1.663-2.264 3.307-.259 1.318-1.085 1.966-2.032 2.318a6.244 6.244 0 01-1.668.347 3.001 3.001 0 10.019 2.004c.633-.042 1.491-.158 2.347-.476 1.402-.523 2.867-1.625 3.296-3.807.259-1.318 1.085-1.966 2.032-2.318.24-.09.484-.158.722-.21a3 3 0 100-2.33 5.329 5.329 0 01-.722-.21c-.947-.352-1.773-1-2.032-2.318-.428-2.182-1.894-3.284-3.296-3.807-.856-.318-1.714-.434-2.347-.476A3.001 3.001 0 000 3a3 3 0 003 3zm13 4a1 1 0 102 0 1 1 0 00-2 0zM2 17a1 1 0 112 0 1 1 0 01-2 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6R6KF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.54 4.18l.01-.02-6-4-.01.02C13.39.08 13.21 0 13 0s-.39.08-.54.18l-.01-.02L7 3.8 1.55.17l-.01.01A.969.969 0 001 0C.45 0 0 .45 0 1v14c0 .35.19.64.46.82l-.01.02 6 4 .01-.02c.15.1.33.18.54.18s.39-.08.54-.18l.01.02L13 16.2l5.45 3.63.01-.02c.15.11.33.19.54.19.55 0 1-.45 1-1V5c0-.35-.19-.64-.46-.82zM6 17.13l-4-2.67V2.87l4 2.67v11.59zm6-2.67l-4 2.67V5.54l4-2.67v11.59zm6 2.67l-4-2.67V2.87l4 2.67v11.59z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eLTDe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 9.22v7.91l-4-2.67V9.22c-.61-.55-1-1.33-1-2.22-.35 0-.69-.07-1-.18v7.65l-4 2.67V5.54l2.02-1.35c0-.06-.02-.13-.02-.19 0-1.66 1.34-3 3-3 0-.34.07-.66.17-.97C13.12.02 13.06 0 13 0c-.21 0-.39.08-.54.18l-.01-.02L7 3.8 1.55.17l-.01.01A.969.969 0 001 0C.45 0 0 .45 0 1v14c0 .35.19.64.46.82l-.01.02 6 4 .01-.02c.15.1.33.18.54.18s.39-.08.54-.18l.01.02L13 16.2l5.45 3.63.01-.02c.15.11.33.19.54.19.55 0 1-.45 1-1V6.82c-.31.11-.65.18-1 .18 0 .89-.39 1.67-1 2.22zM6 17.13l-4-2.67V2.87l4 2.67v11.59zM12 4c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V5h2c.55 0 1-.45 1-1s-.45-1-1-1h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"70QiO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C6.13 0 3 2.98 3 6.67 3 10.35 10 20 10 20s7-9.65 7-13.33C17 2.99 13.86 0 10 0zm0 10c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2OhzM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L11.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 3.41V6c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zM8 11c-.28 0-.53.11-.71.29L2 16.59V14c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1H3.41l5.29-5.29c.19-.18.3-.43.3-.71 0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dBOyu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4-7H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-1 13l-6-5-2 2-4-5-4 8V4h16v11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jCCfs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 6h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm18 3H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0 5H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dZPQG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 6h11c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM4 6c-.28 0-.53.11-.71.29l-3 3C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l3 3A1.003 1.003 0 005 13V7c0-.55-.45-1-1-1zm15 8H8c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm0-5H8c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a8AYg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 9H1c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm0 5H1c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm0-10H1c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm7.71 5.29l-3-3A1.003 1.003 0 0015 7v6a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XneN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.71 6.29a1.003 1.003 0 00-1.42 1.42L6.59 9H2V2h5v2.18c.42.15.8.39 1.11.7l.01-.01.88.89V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-4.76l-.88.88-.01-.01c-.31.31-.69.56-1.11.71V18H2v-7h4.59L5.3 12.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3zM19 0h-7c-.55 0-1 .45-1 1v4.76l.88-.88.01.01c.31-.31.69-.55 1.11-.7V2h5v7h-4.59l1.29-1.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L13.41 11H18v7h-5v-2.18c-.42-.15-.8-.39-1.11-.7l-.01.01-.88-.89V19c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6o7SA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm8-5c-.93 0-1.71.64-1.93 1.5H14V4c0-2.21-1.79-4-4-4S6 1.79 6 4v5.5H3.93C3.71 8.64 2.93 8 2 8c-1.1 0-2 .9-2 2s.9 2 2 2c.93 0 1.71-.64 1.93-1.5H6V16c0 2.21 1.79 4 4 4s4-1.79 4-4v-5.5h2.07c.22.86 1 1.5 1.93 1.5 1.1 0 2-.9 2-2s-.9-2-2-2zm-5 8c0 1.66-1.34 3-3 3s-3-1.34-3-3V4c0-1.66 1.34-3 3-3s3 1.34 3 3v12zM10 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lTCQd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0a4 4 0 00-4 4v5a4 4 0 008 0V4a4 4 0 00-4-4zM4 7a1 1 0 011 1v1a5 5 0 0010 0V8a1 1 0 112 0v1a7.001 7.001 0 01-6 6.93V18h1a1 1 0 110 2H8a1 1 0 110-2h1v-2.07A7.001 7.001 0 013 9V8a1 1 0 011-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"76AvL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 11H3c-.55 0-1 .45-1 1s.45 1 1 1h2.59L.3 18.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L7 14.41V17c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1zM20 1a1.003 1.003 0 00-1.71-.71L13 5.59V3c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1h-2.59l5.29-5.29c.19-.18.3-.43.3-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8jEzR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 9H4c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5YiDv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 0H5c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-5 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4-3H6V3h8v13z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jTxgG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 5c-.28 0-.53.11-.71.29L15 8.59V5c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h13c.55 0 1-.45 1-1v-3.59l3.29 3.29c.18.19.43.3.71.3.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cqXY4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 1a1 1 0 011 1v16a1 1 0 01-1 1H1a1 1 0 01-1-1V2a1 1 0 011-1h18zm-1 4H2v12h16V5zm-3-3h-2v2h2V2zm3 0h-2v2h2V2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21B9v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 5v13a1 1 0 01-1 1H1a1 1 0 01-1-1V5h20zm-3-4h2a1 1 0 011 1v1h-3V1zm-2 2H0V2a1 1 0 011-1h14v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i6Xhp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.746 17H1.254A1.25 1.25 0 010 15.707c.07-1.927.278-5.273.894-8.196.325-1.544.76-2.947 1.333-3.957C2.815 2.52 3.488 2 4.249 2c.88 0 1.541.357 2.081.92.547.571.961 1.345 1.327 2.151.103.226.21.477.317.726l.003.006c.245.57.482 1.12.706 1.524.338.609.785 1.173 1.471 1.173 1.046 0 1.653-.667 2.147-1.245l.003-.003.135-.157c.283-.32.566-.616.925-.835.35-.213.785-.36 1.383-.36.628 0 1.239.358 1.832 1.042.587.676 1.114 1.623 1.576 2.688.853 1.967 1.458 4.272 1.814 5.848A1.25 1.25 0 0118.746 17z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hHIEE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 14.15A9.94 9.94 0 019.94 20C4.45 20 0 15.55 0 10.06 0 6.03 2.4 2.56 5.85 1a9.811 9.811 0 00-.88 4.09c0 5.49 4.45 9.94 9.94 9.94 1.46 0 2.84-.31 4.09-.88z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8rdRC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.5 8a2.5 2.5 0 100 5 2.5 2.5 0 100-5zM17.5 8a2.5 2.5 0 100 5 2.5 2.5 0 100-5zM10.5 8a2.5 2.5 0 100 5 2.5 2.5 0 100-5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kC45":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 16H4l7-11h1l2 2h1l5 9zm-4-5l-1.5-3h-1l-1-1-1-1L8 11.5l3-1.5 1 1 1-1 3 1zM8.055 8L2.79 16H0l7-8h1.055z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"80vLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.71 9.29l-3-3a1.003 1.003 0 00-1.42 1.42L16.59 9H11V3.41l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3C10.53.11 10.28 0 10 0s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L9 3.41V9H3.41L4.7 7.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L3.41 11H9v5.59L7.71 15.3A.965.965 0 007 15a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3a1.003 1.003 0 00-1.42-1.42L11 16.59V11h5.59l-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"euVxe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18h-.07c-.05-.2-.12-.42-.22-.67-.46-1.05-2.68-1.75-4.16-2.4-1.48-.65-1.28-1.05-1.33-1.59-.01-.07-.01-.15-.01-.23.51-.45.92-1.07 1.19-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.34-.07.54-.44.61-.78.08-.14.23-.48.2-.87-.05-.5-.25-.73-.47-.82v-.09c0-.63-.06-1.55-.17-2.15-.02-.17-.06-.33-.11-.5a3.67 3.67 0 00-1.29-1.86C11.7 3.25 10.81 3 10.02 3s-1.68.25-2.31.73c-.61.47-1.07 1.13-1.29 1.86-.05.16-.09.33-.11.5-.12.6-.17 1.51-.17 2.14v.08c-.24.09-.44.32-.49.83-.04.39.12.73.2.87.08.35.28.72.63.78.04.17.09.33.15.48 0 .01.01.02.01.03l.01.01c.27.72.7 1.35 1.22 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.38 1.59-1.48.65-3.7 1.35-4.16 2.4-.12.27-.18.49-.23.69H2V2h16v16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGidF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 3H7c-.55 0-1 .45-1 1v1h12v6h1c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-6 6H1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm-1 6H2v-4h10v4zm4-9H4c-.55 0-1 .45-1 1v1h12v6h1c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"32x05":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0c-.08 0-.16.03-.24.05V.03l-12 3v.02C6.33 3.16 6 3.53 6 4v11.35c-.59-.22-1.27-.35-2-.35-2.21 0-4 1.12-4 2.5S1.79 20 4 20c1.94 0 3.55-.86 3.92-2H8V7.78l10-2.5v7.07c-.59-.22-1.27-.35-2-.35-2.21 0-4 1.12-4 2.5s1.79 2.5 4 2.5c1.94 0 3.55-.86 3.92-2H20V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ilB2x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 2c.55 0 1 .45 1 1v5c0 2.21 1.79 4 4 4h8.59L13.3 9.71A.965.965 0 0113 9a1.003 1.003 0 011.71-.71l4 4c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-4 4a1.003 1.003 0 01-1.42-1.42l2.3-2.29H7c-3.31 0-6-2.69-6-6V3c0-.55.45-1 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jVxLi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.7 13.7c.5 0 1 .4 1 1 0 .257-.073.44-.22.614l-.08.086-4 4c-.2.2-.4.3-.7.3-.6 0-1-.5-1-1 0-.257.073-.44.22-.614L14 18l4-4c.2-.2.4-.3.7-.3zM1.8 0l8.378 2.982A3.003 3.003 0 0013 7a3.003 3.003 0 003.877 2.87l.723 2.53.049.06a.41.41 0 01.051.24c0 .167-.07.403-.208.593l-.092.107-4 4c-.2.2-.4.3-.7.3-.075 0-.15-.056-.225-.084L12.4 17.6l-7-2-.112-.042c-.223-.094-.431-.244-.542-.45L4.7 15 0 1.8l.5-.6L7 7.7c-.2.3-.3.6-.3 1 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2a1.68 1.68 0 00-.871.22L7.7 7 1.2.5l.6-.5zM16 0c.55 0 1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v2c0 .432-.278.803-.664.941l-.01.004A.989.989 0 0116 8c-.55 0-1-.45-1-1V5h-2c-.55 0-1-.45-1-1l.007-.116C12.065 3.388 12.489 3 13 3h2V1c0-.55.45-1 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l2P5S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0H1C.45 0 0 .45 0 1v7c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm0 11H1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-7c0-.55-.45-1-1-1zm6 7h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zm5-7h-2c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zm0-11h-7c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-5 11h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1zm5 5c-.55 0-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iDLlQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.513 2.663A2 2 0 0013 6h1v1a2 2 0 104 0v-.733l1.5.833c.3.2.5.5.5.9s-.2.7-.5.9l-9 5c-.2.1-.3.1-.5.1s-.3 0-.5-.1l-9-5C.2 8.7 0 8.4 0 8s.2-.7.5-.9l9-5c.2-.1.3-.1.5-.1s.3 0 .5.1l1.013.563zM17 3h2a1 1 0 010 2h-2v2a1 1 0 01-2 0V5h-2a1 1 0 010-2h2V1a1 1 0 012 0v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bUX8Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 3h2a1 1 0 010 2h-2v2a1 1 0 01-2 0V5h-2a1 1 0 010-2h2V1a1 1 0 012 0v2zm-1.252 5.984L10.5 11.9c-.2.1-.3.1-.5.1s-.3 0-.5-.1l-9-5C.2 6.7 0 6.4 0 6s.2-.7.5-.9l9-5c.2-.1.3-.1.5-.1s.3 0 .5.1L13.92 2H13a2 2 0 100 4h1v1a2 2 0 001.748 1.984zm2.07-1.15C17.935 7.58 18 7.298 18 7V6h1c.353 0 .684-.091.972-.251.018.078.028.162.028.251 0 .4-.2.7-.5.9l-1.682.934zM19 9c.6 0 1 .4 1 1 0 .4-.2.7-.5.9l-9 5c-.2.1-.3.1-.5.1s-.3 0-.5-.1l-9-5c-.3-.2-.5-.5-.5-.9 0-.6.4-1 1-1 .2 0 .3 0 .5.1l8.5 4.8 8.5-4.8c.2-.1.3-.1.5-.1zm0 4c.6 0 1 .4 1 1 0 .4-.2.7-.5.9l-9 5c-.2.1-.3.1-.5.1s-.3 0-.5-.1l-9-5c-.3-.2-.5-.5-.5-.9 0-.6.4-1 1-1 .2 0 .3 0 .5.2l8.5 4.7 8.5-4.8c.2-.1.3-.1.5-.1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6zYSZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.5 12a2.5 2.5 0 00-2.45 2h-7.1a2.5 2.5 0 100 1h7.1a2.5 2.5 0 102.45-3zM19 5h-2V3c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V7h2c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJ8U9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 4c0 .6.4 1 1 1h2v2c0 .6.4 1 1 1 .5 0 1-.4 1-1V5h2c.5 0 1-.4 1-1s-.5-1-1-1h-2V1c0-.6-.5-1-1-1-.6 0-1 .4-1 1v2h-2c-.6 0-1 .5-1 1zm7 3c0 1.7-1.3 3-3 3s-3-1.3-3-3c-1.7 0-3-1.3-3-3s1.3-3 3-3c0-.2 0-.4.1-.5-1-.3-2-.5-3.1-.5C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10c0-1.1-.2-2.1-.5-3H19z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b317U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.41 15.92c-1.46-.65-1.26-1.05-1.31-1.59-.01-.07-.01-.15-.01-.23.5-.45.91-1.07 1.18-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.33-.07.53-.44.6-.78.08-.14.23-.48.2-.87-.05-.5-.24-.73-.47-.82v-.09c0-.63-.06-1.55-.17-2.15-.02-.17-.06-.33-.11-.5-.22-.73-.67-1.4-1.27-1.86C9.58 4.25 8.7 4 7.92 4c-.78 0-1.66.25-2.28.73-.61.47-1.06 1.13-1.27 1.86-.05.16-.08.33-.11.5-.12.6-.18 1.51-.18 2.14v.08c-.23.09-.43.32-.48.83-.04.39.12.73.2.87.08.35.28.72.62.78.04.17.09.33.15.48 0 .01.01.02.01.03l.01.01c.27.72.69 1.35 1.21 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.36 1.59-1.46.65-3.66 1.35-4.11 2.4C-.14 19.38.04 20 .04 20h15.75s.18-.62-.27-1.67c-.45-1.06-2.65-1.75-4.11-2.41zM18.87 3h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V5h2c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5EtjQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.95 10.23c.16-.18.22-.22.46-.22h1.48c.25 0 .47.08.59.33.1.2.09.41-.05.66l-2.71 3.58L14.88 19c.13.21.16.46.03.69-.12.21-.34.31-.57.31H12.7c-.31 0-.56-.17-.7-.44l-1.9-2.67-1.93 2.68c-.15.27-.42.43-.73.43H5.98c-.25 0-.47-.08-.59-.33-.1-.2-.09-.41.05-.66l3.09-4.35L4.26 9H3v4.32c0 .41-.3.69-.7.69H.7c-.41 0-.7-.28-.7-.69V.69C0 .28.3 0 .7 0h4.42c.71 0 1.36.1 1.94.3.59.2 1.11.49 1.54.87.44.38.78.84 1.02 1.39.25.54.37 1.13.37 1.77 0 1.01-.28 1.88-.84 2.6-.43.54-1.35 1.29-2 1.59l3.09 3.94 1.71-2.23zM4.71 6.04c.71 0 1.45-.16 1.81-.46.33-.28.5-.69.5-1.25s-.17-.97-.5-1.25c-.35-.3-1.1-.46-1.81-.46h-1.7v3.42h1.7zM19 3c.55 0 1 .45 1 1s-.45 1-1 1h-2v2c0 .55-.45 1-1 1s-1-.45-1-1V5h-2c-.55 0-1-.45-1-1s.45-1 1-1h2V1c0-.55.45-1 1-1s1 .45 1 1v2h2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kAQiq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 4c0 .6.4 1 1 1h2v2c0 .6.4 1 1 1 .5 0 1-.4 1-1V5h2c.5 0 1-.4 1-1s-.5-1-1-1h-2V1c0-.6-.5-1-1-1-.6 0-1 .4-1 1v2h-2c-.6 0-1 .5-1 1z",
    "M15.796 9.994c-1.05 2.868-2.974 5.313-5.796 7.374V2.652 0C6 2.857 3 4.286 1 4.286 1 10.952 4 16.19 10 20c4.634-2.942 7.478-6.736 8.534-11.383a3.066 3.066 0 01-2.738 1.377z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a4NaI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 3h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V5h2c.55 0 1-.45 1-1s-.45-1-1-1zM5 7.5v1c0 .28.22.5.5.5s.5-.22.5-.5V8h2v7h-.5c-.28 0-.5.22-.5.5s.22.5.5.5h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H9V8h2v.5c0 .28.22.5.5.5s.5-.22.5-.5v-1c0-.28-.22-.5-.5-.5h-6c-.28 0-.5.22-.5.5zM16 9c-.55 0-1 .45-1 1v8H2V5h8c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kz2y8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 6s-2.98 2.43-6.12 2.19C13.52 5.31 12.05 0 6 0c0 0 2.41 2.99 2.16 6.12C5.27 6.49 0 7.97 0 14c0 0 2.98-2.43 6.11-2.19C6.47 14.69 7.94 20 14 20c0 0-2.42-2.99-2.16-6.13C14.73 13.51 20 12.02 20 6zm-10 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cEnko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.487 7l.532-3.196a1 1 0 011.962.392L11.513 7H16a1 1 0 010 2h-4.82l-.333 2H16a1 1 0 010 2h-5.487l-.532 3.196a1 1 0 01-1.962-.392L8.487 13H4a1 1 0 010-2h4.82l.333-2H4a1 1 0 110-2h5.487z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fK0z6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 20c1.1 0 2-.9 2-2H8c0 1.1.9 2 2 2zm7-5c-.55 0-1-.45-1-1V8c0-2.61-1.67-4.81-4-5.63V2c0-1.1-.9-2-2-2S8 .9 8 2v.37C5.67 3.19 4 5.39 4 8v6c0 .55-.45 1-1 1s-1 .45-1 1 .45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9utuK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 18c0 1.1-.9 2-2 2s-2-.9-2-2zM8 0c.476 0 .914.168 1.258.448C8.508.878 8.09 1.562 8 2.5c-.133 1.4.4 2.367 1.6 2.9C8.533 6.6 8 7.467 8 8v1.2a2.8 2.8 0 002.8 2.8H14v2c0 .51.388.935.884.993L15 15c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1V8c0-2.61 1.67-4.81 4-5.63V2c0-1.1.9-2 2-2z",
    "M16 9.25v-.395a.75.75 0 00-.75-.75h-2.813L15.834 3.9A.75.75 0 0016 3.43v-.68a.75.75 0 00-.75-.75h-4.5a.75.75 0 00-.75.75v.184c0 .414.336.75.75.75h2.813L10.22 7.831a1 1 0 00-.221.627v.792c0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2pWF8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 20c1.1 0 2-.9 2-2H8c0 1.1.9 2 2 2zm2-17.834A2.994 2.994 0 008 4.99c0 .808.319 1.557.876 2.114l2.97 2.99a2.99 2.99 0 004.154.072V14c0 .55.45 1 1 1s1 .45 1 1-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1V8c0-2.61 1.67-4.81 4-5.63V2c0-1.1.9-2 2-2s2 .9 2 2v.166zm1.26 6.514l-2.97-2.99a.973.973 0 01-.29-.7c0-.55.44-1 .99-1 .27 0 .52.11.7.29l2.28 2.28 4.27-4.27a.99.99 0 01.7-.29c.55 0 1 .45 1 1 0 .28-.11.53-.3.7l-4.98 4.98a.99.99 0 01-1.4 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gaDuy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.74 9.01h1.27V1h-.95c-.04.24-.12.45-.26.62-.13.17-.29.3-.47.41-.19.11-.4.18-.63.23-.23.04-.46.07-.71.07v1.03h1.75v5.65zm.43 7.93c.18-.14.37-.28.58-.43.21-.14.42-.29.63-.45.21-.16.41-.33.61-.5.2-.18.37-.38.52-.59.15-.21.28-.45.37-.7.09-.25.14-.54.14-.85 0-.25-.04-.52-.12-.8-.08-.28-.21-.54-.39-.78-.19-.24-.43-.44-.73-.59-.3-.17-.68-.25-1.12-.25-.41 0-.77.08-1.08.23-.32.16-.58.37-.8.64-.22.27-.38.59-.49.96-.11.37-.16.77-.16 1.21h1.19c.01-.28.03-.53.08-.77s.12-.45.21-.62c.09-.18.22-.31.38-.42.16-.1.35-.15.59-.15.26 0 .47.05.63.14.16.09.29.21.38.35.09.14.15.29.18.45.03.16.05.31.05.45-.01.31-.08.58-.22.81-.14.24-.32.45-.53.66-.22.2-.45.39-.71.57-.26.18-.51.36-.74.54-.5.36-.89.78-1.17 1.27-.3.47-.45 1.04-.46 1.69H5v-1.14H1.43c.05-.17.14-.33.27-.49.13-.15.29-.3.47-.44zM18 4.02H8c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-1c0-.56-.45-1-1-1zm0 9H8c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-1c0-.56-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cukyD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2.39 5.75c-.17.21-.38.39-.63.52s-.52.23-.83.29c-.3.05-.61.08-.93.08v1.24h2.49V15h1.49V4.98H2.73c-.05.31-.17.57-.34.77zm17.2 4.71c-.27-.44-.65-.71-1.14-.82v-.02c.42-.16.72-.43.92-.79.2-.36.29-.79.29-1.27 0-.42-.08-.8-.23-1.12-.15-.33-.36-.59-.62-.8-.26-.21-.55-.37-.87-.48-.32-.11-.65-.16-.98-.16-.43 0-.82.08-1.16.25-.34.16-.63.39-.87.69-.24.29-.43.64-.57 1.04-.14.4-.22.83-.23 1.3h1.39c-.01-.25.02-.49.07-.72.06-.23.14-.44.26-.63s.27-.34.45-.45c.18-.11.39-.17.63-.17.39 0 .71.12.96.37s.37.58.37.99c0 .29-.05.54-.16.74-.11.2-.25.36-.43.47-.18.11-.38.19-.61.24-.23.05-.46.06-.68.05v1.17c.28-.01.55 0 .81.03s.5.1.71.21c.21.11.38.28.51.5.13.22.2.52.2.89 0 .55-.16.97-.47 1.27-.31.3-.7.45-1.17.45-.55 0-.95-.19-1.23-.58-.27-.39-.4-.88-.38-1.46h-1.39c.01.5.08.96.21 1.38.13.41.32.77.57 1.06.25.29.56.52.93.68.37.16.8.24 1.3.24.41 0 .79-.07 1.16-.21.37-.14.69-.33.96-.58.28-.25.5-.56.66-.92a3 3 0 00.24-1.23c0-.64-.14-1.17-.41-1.61zM8.58 12.41c.21-.18.45-.36.7-.53.25-.18.5-.36.75-.56.25-.2.49-.41.73-.63.23-.22.44-.47.63-.74.18-.27.33-.56.44-.88.11-.32.16-.67.16-1.07 0-.32-.05-.65-.14-1-.09-.35-.25-.68-.47-.97-.22-.3-.51-.55-.87-.74-.36-.2-.81-.29-1.35-.29-.49 0-.93.1-1.3.29-.37.18-.69.44-.95.78-.26.33-.45.73-.58 1.2-.13.46-.2.96-.2 1.5h1.43c.01-.35.04-.67.09-.97.05-.3.14-.56.25-.78.11-.22.26-.39.45-.52s.43-.19.71-.19c.31 0 .56.06.75.18.19.12.34.26.45.43.11.17.18.36.22.56.04.2.06.39.06.57-.01.38-.1.72-.26 1.02-.15.3-.37.57-.63.83-.26.25-.54.49-.85.71-.31.22-.61.45-.89.68-.6.45-1.06.98-1.41 1.58-.35.61-.52 1.32-.53 2.13h6.01v-1.43H7.69c.06-.21.17-.42.33-.61s.34-.38.56-.55z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7YlFE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 0H1a1 1 0 00-1 1v4h2V2h3V0zM18 15v3h-3v2h4a1 1 0 001-1v-4h-2zM0 15h2v3h3v2H1a1 1 0 01-1-1v-4zM15 0h4a1 1 0 011 1v4h-2V2h-3V0zM9.55 2.125L3.742 5.252 10 9l6.259-3.748L10.5 2.125a.963.963 0 00-.95 0zM9.5 10L3.106 5.996A.91.91 0 003 6.421V12.7c0 .34.192.655.504.824l5.889 3.426c.035.019.07.035.107.05v-7zM16.894 5.996a.91.91 0 01.106.425V12.7c0 .34-.192.655-.504.824l-5.889 3.426c-.035.019-.07.035-.107.05v-7l6.394-4.004z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8XwbE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 6h-5V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h4v-6h4v6h10c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zM6 12H2V8h4v4zm0-6H2V2h4v4zm6 6H8V8h4v4zm0-6H8V2h4v4zm6 11h-4v-3h4v3zm0-5h-4V8h4v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gidog":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM7 18l2-7H5l8-9-2 7h4l-8 9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fXzhB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 17.99h-1.36l-4.35-9.57 2.91-.86 1.66 4.1c.11.27.43.4.72.31.12-.04.22-.11.28-.2.06-.11 1.47-2.08 1.05-5.6C19.79 5.12 19.3 0 16.01 0 14.89.01 13.99.83 14 1.84c0 .19.04.38.1.56l1.34 3.31L.72 10.03v.02c-.41.12-.72.49-.72.94 0 .55.45 1 1 1 .1 0 .19-.03.28-.06v.02l2-.59 1.47 6.63H3c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zM5.2 10.8l3.95-1.16-2.83 6.22L5.2 10.8zm2.35 7.19l3.95-8.68 3.95 8.68h-7.9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7UL2s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.94 0h-4c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-8 6c-.28 0-.53.11-.71.29l-3 3c-.18.18-.29.43-.29.71s.11.53.29.71l3 3A1.003 1.003 0 007.94 13V7c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4na0P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 3a1 1 0 11-2 0 1 1 0 012 0zm-3.82 1.028a6.243 6.243 0 00-1.667.347c-.947.352-1.773 1-2.032 2.318C10.158 8.337 9.247 9.368 8.217 10c1.03.632 1.941 1.663 2.264 3.307.259 1.318 1.085 1.966 2.032 2.318.581.217 1.18.308 1.668.347a3.001 3.001 0 11-.019 2.004c-.633-.042-1.491-.158-2.347-.476-1.402-.523-2.868-1.625-3.296-3.807-.259-1.318-1.085-1.966-2.032-2.318a5.314 5.314 0 00-.722-.21 3 3 0 110-2.33c.238-.052.481-.12.722-.21.947-.352 1.773-1 2.032-2.318.428-2.182 1.894-3.284 3.296-3.807.856-.318 1.714-.434 2.347-.476A3.001 3.001 0 0120 3a3 3 0 01-5.82 1.028zM4 10a1 1 0 100 .002v-.002zM17 18a1 1 0 100-2 1 1 0 000 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1qSWP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 10a1 1 0 112 0 1 1 0 01-2 0zm3.83-1a3.001 3.001 0 100 2h8.34a3.001 3.001 0 100-2H5.83zM17 9a1 1 0 100 2 1 1 0 000-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8HbaQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 1h14c.55 0 1 .45 1 1v13c0 .55-.45 1-1 1h-8v-2h7V4H5v6H3V2c0-.55.45-1 1-1zm2.5 5h7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-7c-.28 0-.5.22-.5.5s.22.5.5.5zm0 2h3c.28 0 .5-.22.5-.5S9.78 7 9.5 7h-3c-.28 0-.5.22-.5.5s.22.5.5.5zm5 2h-5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h5c.28 0 .5.22.5.5s-.22.5-.5.5zM7 17c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h2.59L.3 18.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L7 14.41V17z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecb5E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10c0-.55.45-1 1-1s1 .45 1 1c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8C7.47 2 5.22 3.17 3.76 5H5c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1s1 .45 1 1v2.05C3.82 1.6 6.71 0 10 0zm1 16H9v-2h2v2zm0-3H9V4h2v9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lysoC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 10c0 5.51 4.49 10 10 10 1.17 0 2.32-.2 3.42-.6.52-.19.79-.76.6-1.28a.998.998 0 00-1.28-.6c-.88.32-1.8.48-2.74.48-4.41 0-8-3.59-8-8s3.59-8 8-8c.94 0 1.86.16 2.74.48a.998.998 0 001.28-.6.998.998 0 00-.6-1.28C12.32.2 11.17 0 10 0 4.49 0 0 4.49 0 10z",
    "M19.71 9.29l-4-4a1.003 1.003 0 00-1.42 1.42L16.59 9H5a1 1 0 000 2h11.59l-2.29 2.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6Q3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.849.306l7.045 3.523A2 2 0 0120 5.618v8.705a2 2 0 01-1.257 1.857l-8.955 3.582a2 2 0 01-1.637-.068L1.106 16.17A2 2 0 010 14.38V5.678A2 2 0 011.257 3.82L10.212.238a2 2 0 011.637.068zM10 9.677v7.846l8-3.2V6.477l-3 1.2v5.159l-2 .793V8.477l-3 1.2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5fwON":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 1H1c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM7 17H2V8h5v9zm11 0H8V8h10v9zm0-10H2V3h16v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a49Cf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 17h6V3h-6v14zM1 20h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1zM2 2h16v16H2V2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Q1mx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 1h18a1 1 0 011 1v15a1 1 0 01-1 1H1a1 1 0 01-1-1V2a1 1 0 011-1zm1 2v13h16V3H2zm9 0h1v13h-1V3zm2 7h3.952v1H13v-1zm0 2h3.952v1H13v-1zm0 2h3.952v1H13v-1zm0-6h3.952v1H13V8zm0-2h3.952v1H13V6zm0-2h3.952v1H13V4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffEdr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 1H1c-.6 0-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm-9 11H7V9h3v3zm0-4H7V5h3v3zm-8 8V3h4v13H2zm5 0v-3h3v3H7zm11 0h-7v-3h7v3zm0-4h-7V9h7v3zm0-4h-7V5h7v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6B4k9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.35 2.67A5.664 5.664 0 0014.33 1c-1.44 0-2.89.56-3.99 1.67l-9.16 9.27C.4 12.73 0 13.78 0 14.83s.39 2.1 1.18 2.9c.78.79 1.82 1.18 2.85 1.18 1.04 0 2.07-.39 2.87-1.2l9.14-9.27c.96-.96.96-2.5.02-3.45-.94-.95-2.49-.96-3.44 0l-7.59 7.69c-.31.32-.3.83.01 1.14.31.31.81.31 1.13.02l7.59-7.69c.31-.31.84-.31 1.13-.02.31.31.31.85 0 1.16l-9.14 9.27c-.93.95-2.54.93-3.45.02-.94-.95-.92-2.55.02-3.49l9.16-9.25c1.55-1.56 4.18-1.59 5.72-.03 1.56 1.57 1.55 4.26 0 5.82l-8.89 9.02c-.3.31-.3.81.01 1.11.3.3.79.31 1.1.01v.01l8.91-9.02A5.645 5.645 0 0020 6.73c0-1.48-.55-2.94-1.65-4.06z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hH40l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.5 1H7C4.2 1 2 3.2 2 6s2.2 5 5 5v6.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V4h2v13.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V4h1.5c.8 0 1.5-.7 1.5-1.5S17.3 1 16.5 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Qkvc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 1c.55 0 1 .45 1 1v2H6V2c0-.55.45-1 1-1h.78a1.98 1.98 0 013.44 0H12z",
    "M14 2h2c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h2v3h9V2zm-.068 12.492l.346.196c-.565.896-1.12 1.525-1.685 1.88-.419.284-.827.422-1.225.422-.418 0-.764-.088-1.036-.265-.272-.178-.523-.473-.733-.876-.209-.403-.46-1.052-.753-1.938-.754.935-1.35 1.614-1.78 2.046-.429.433-.784.718-1.067.846a2.187 2.187 0 01-.91.197c-.335 0-.597-.098-.796-.285A.976.976 0 014 15.977c0-.315.105-.58.324-.787a1.15 1.15 0 01.817-.315c.178 0 .377.05.596.148.325.148.555.226.702.226.188 0 .355-.03.502-.108.188-.088.44-.295.733-.61.188-.197.512-.61 1.004-1.24-.617-2.232-1.109-3.56-1.454-4.002a1.014 1.014 0 00-.838-.423c-.178 0-.387.02-.638.068l.063-.354L9.2 8a9.199 9.199 0 011.298 3.088c.628-.904 1.11-1.544 1.434-1.908.43-.491.785-.806 1.068-.954.283-.147.586-.216.9-.216.356 0 .628.098.816.285.189.187.283.433.283.757 0 .305-.094.551-.283.738a.979.979 0 01-.711.285c-.21 0-.44-.039-.712-.108-.262-.069-.45-.108-.555-.108-.272 0-.534.098-.774.285-.346.256-.754.807-1.246 1.643.555 1.879.995 3.03 1.32 3.442.198.246.397.364.596.364a.81.81 0 00.44-.118c.177-.127.47-.452.857-.983z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7aGaO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 0H2C.9 0 0 .9 0 2s.9 2 2 2h7v4H4c-1.1 0-2 .9-2 2s.9 2 2 2h5v4H6c-1.1 0-2 .9-2 2s.9 2 2 2h8c1.1 0 2-.9 2-2s-.9-2-2-2h-3v-4h5c1.1 0 2-.9 2-2s-.9-2-2-2h-5V4h7c1.1 0 2-.9 2-2s-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2NwLn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 11.69l-5-2.5v-3.63c-.32.11-.66.22-1 .29v3.32l-6 2.57v-7.25c-.36-.27-.69-.57-1-.9v8.1l-5-2.5V10c.55 0 1-.45 1-1s-.45-1-1-1V1.31l3.43 1.71c.11-.31.24-.62.39-.92L.72.05A.545.545 0 00.5 0C.22 0 0 .22 0 .5v16c0 .2.12.36.28.44l6 3c.07.04.14.06.22.06.07 0 .14-.01.2-.04l6.79-2.91 5.79 2.9c.07.03.14.05.22.05.28 0 .5-.22.5-.5v-4.21c-.31.13-.64.21-1 .21v3.19zM10 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3-1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6.72-.94l-1.43-.72c.2.43.36.89.48 1.36l.23.11V5.5c-.55 0-1 .45-1 1s.45 1 1 1v1.96l1 1V3.5c0-.2-.12-.36-.28-.44zm-3.69 5.56c.14-.21.27-.42.38-.65.02-.04.04-.07.05-.11.11-.22.2-.45.28-.69v-.01c.07-.24.13-.48.17-.73l.03-.17c.04-.25.06-.5.06-.76C17 2.46 14.54 0 11.5 0S6 2.46 6 5.5 8.46 11 11.5 11c.26 0 .51-.02.76-.06l.17-.03c.25-.04.49-.1.73-.17h.01c.24-.08.47-.17.69-.28.04-.02.07-.03.11-.05.23-.11.44-.24.65-.38l.18.18 3.5 3.5c.17.18.42.29.7.29a1.003 1.003 0 00.71-1.71l-3.68-3.67zm-4.53.88c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ddTza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 3H4c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm9 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2A7kj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.94 17a4.92 4.92 0 00-.33-1.06c-.45-.97-1.37-1.52-3.24-2.3-.17-.07-.76-.31-.77-.32-.1-.04-.2-.08-.28-.12.05-.14.04-.29.06-.45 0-.05.01-.11.01-.16-.25-.21-.47-.48-.65-.79.22-.34.41-.71.56-1.12l.04-.11c-.01.02-.01.02-.02.08l.06-.15c.36-.26.6-.67.72-1.13.18-.37.29-.82.25-1.3-.05-.5-.21-.92-.47-1.22-.02-.53-.06-1.11-.12-1.59.38-.17.83-.26 1.24-.26.59 0 1.26.19 1.73.55.46.35.8.85.97 1.4.04.13.07.25.08.38.08.45.13 1.14.13 1.61v.07c.16.07.31.24.35.62.02.29-.09.55-.15.65-.05.26-.2.53-.46.59-.03.12-.07.25-.11.36-.01.01-.01.04-.01.04-.2.53-.51 1-.89 1.34 0 .06 0 .12.01.17.04.41-.11.71 1 1.19 1.1.5 2.77 1.01 3.13 1.79.34.79.2 1.25.2 1.25h-3.04zm-5.42-3.06c1.47.66 3.7 1.35 4.18 2.39.45 1.05.27 1.67.27 1.67H.04s-.19-.62.27-1.67c.46-1.05 2.68-1.75 4.16-2.4 1.48-.65 1.33-1.05 1.38-1.59 0-.07.01-.14.01-.21-.52-.45-.95-1.08-1.22-1.8l-.01-.01c0-.01-.01-.02-.01-.03-.07-.15-.12-.32-.16-.49-.34-.06-.54-.43-.62-.78-.08-.14-.24-.48-.2-.87.05-.51.26-.74.49-.83v-.08c0-.64.05-1.55.17-2.15a3.648 3.648 0 011.4-2.36C6.32 2.25 7.21 2 8 2s1.68.25 2.31.73a3.63 3.63 0 011.4 2.36c.11.6.17 1.52.17 2.15v.09c.22.09.42.32.47.82.03.39-.12.73-.2.87-.07.34-.27.71-.61.78-.04.16-.09.33-.15.48-.01.01-.02.05-.02.05-.27.71-.68 1.33-1.19 1.78 0 .08 0 .16.01.23.05.55-.15.95 1.33 1.6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cdXnv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 10c-1.66 0-3 1.34-3 3v2c0 1.66 1.34 3 3 3s3-1.34 3-3v-2c0-1.66-1.34-3-3-3zm1 5c0 .55-.45 1-1 1s-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2zM8 7V5c0-1.66-1.34-3-3-3S2 3.34 2 5v2c0 1.66 1.34 3 3 3s3-1.34 3-3zM4 7V5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1zm11-4a1.003 1.003 0 00-1.88-.48L5.14 16.49a1.003 1.003 0 101.74.99l7.99-13.97c.08-.15.13-.32.13-.51z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h1zqm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.61 17.91c-.57-1.32-3.35-2.19-5.19-3.01-1.85-.82-1.59-1.31-1.66-1.99-.01-.09-.01-.19-.02-.29.63-.56 1.15-1.33 1.49-2.22 0 0 .02-.05.02-.06.07-.19.13-.39.19-.6.42-.09.67-.55.76-.98.1-.17.29-.6.25-1.08-.06-.62-.31-.91-.59-1.03v-.11c0-.79-.07-1.93-.22-2.68A4.55 4.55 0 0012.9.92C12.11.32 11 0 10.01 0s-2.1.32-2.89.92a4.55 4.55 0 00-1.74 2.94c-.14.75-.22 1.89-.22 2.68v.1c-.29.11-.55.4-.61 1.04-.04.48.15.91.25 1.08.1.44.35.91.79.98.05.21.12.41.19.6 0 .01.01.03.01.04l.01.02c.34.91.87 1.69 1.52 2.25 0 .09-.01.18-.02.26-.07.68.13 1.17-1.72 1.99S.96 16.59.39 17.91C-.18 19.23.05 20 .05 20h19.9s.23-.77-.34-2.09z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3AX6C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.91 15.51c-.08-.08-4.21-2.5-4.35-2.57a.876.876 0 00-.4-.1c-.19 0-.42.13-.71.4-.28.27-1.17 1.49-1.43 1.76s-.48.4-.65.4c-.08 0-.19-.02-.32-.07s-1.45-.73-4.2-3.15-3.11-4-3.13-4.44c0-.17.13-.39.4-.65.28-.25.57-.51.89-.74.32-.24.61-.5.88-.78s.4-.52.4-.71c0-.13-.03-.27-.1-.4C7.12 4.32 4.62.19 4.53.1c-.19-.18-.92-.1-1.29.1C.25 1.82 0 4 .05 4.86c.05.89.61 5.58 5.2 9.93 5.7 5.41 9.66 5.2 9.92 5.2.87 0 3.52-.48 4.65-3.19.16-.38.31-1.07.09-1.29z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Yccz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.845 15.51c-.08-.08-4.206-2.5-4.346-2.57a.874.874 0 00-.4-.1c-.189 0-.419.13-.709.4-.28.27-1.168 1.49-1.428 1.76s-.48.4-.65.4c-.08 0-.19-.02-.319-.07-.13-.05-1.449-.73-4.196-3.15s-3.107-4-3.127-4.44c0-.17.13-.39.4-.65.28-.25.57-.51.89-.74.319-.24.609-.5.878-.78.27-.28.4-.52.4-.71 0-.13-.03-.27-.1-.4C7.068 4.32 4.57.19 4.48.1c-.19-.18-.92-.1-1.289.1C.205 1.82-.045 4 .005 4.86c.05.89.61 5.58 5.195 9.93 5.694 5.41 9.65 5.2 9.91 5.2.869 0 3.516-.48 4.645-3.19.16-.38.31-1.07.09-1.29zM11 2c-.6 0-1-.4-1-1s.4-1 1-1c5 0 9 4 9 9 0 .6-.4 1-1 1s-1-.4-1-1c0-3.9-3.1-7-7-7z",
    "M11 6c-.6 0-1-.4-1-1s.4-1 1-1c2.8 0 5 2.2 5 5 0 .6-.4 1-1 1s-1-.4-1-1c0-1.7-1.3-3-3-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dbYmi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.845 15.51c-.08-.08-4.206-2.5-4.346-2.57a.874.874 0 00-.4-.1c-.189 0-.419.13-.709.4-.28.27-1.168 1.49-1.428 1.76s-.48.4-.65.4c-.08 0-.19-.02-.319-.07-.13-.05-1.449-.73-4.196-3.15s-3.107-4-3.127-4.44c0-.17.13-.39.4-.65.28-.25.57-.51.89-.74.319-.24.609-.5.878-.78.27-.28.4-.52.4-.71 0-.13-.03-.27-.1-.4C7.068 4.32 4.57.19 4.48.1c-.19-.18-.92-.1-1.289.1C.205 1.82-.045 4 .005 4.86c.05.89.61 5.58 5.195 9.93 5.694 5.41 9.65 5.2 9.91 5.2.869 0 3.516-.48 4.645-3.19.16-.38.31-1.07.09-1.29z",
    "M11 7h5.58l-1.29 1.29a1 1 0 00-.3.71 1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3a1.003 1.003 0 00-1.42 1.42L16.58 5H11c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ikhn3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 .98c-4.5.5-8 4.31-8 8.94 0 4.97 4.03 9.04 9 9.04 4.63 0 8.44-3.96 8.94-7.96H9V.98z",
    "M10-.08V10h10C20 4 15.52-.08 10-.08z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"94JXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 5h5a1 1 0 011 1v8a1 1 0 01-1 1H5A5 5 0 015 5zm7 .727c0-.401.326-.727.727-.727H15a5 5 0 010 10h-2.273a.727.727 0 01-.727-.727V5.727zM15 13a3 3 0 100-6h-1v6h1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"A3nuO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.77 1.16c-.81.81-.74 2.28.02 3.76L6.1 8.71c-2.17-1.46-4.12-2-4.94-1.18l4.95 4.95-4.95 6.36 6.36-4.95 4.95 4.95c.82-.82.27-2.77-1.19-4.94l3.8-5.69c1.47.76 2.94.84 3.76.02l-7.07-7.07z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lM81A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.83 9.75L.29 15.29a1.003 1.003 0 001.42 1.42l5.54-5.54c-.57-.37-1.05-.85-1.42-1.42zM19 11c-.55 0-1 .45-1 1v1.59l-3.83-3.83c-.37.56-.85 1.04-1.41 1.41L16.59 15H15c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-5-4c0-2.21-1.79-4-4-4S6 4.79 6 7s1.79 4 4 4 4-1.79 4-4zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"azH3F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 5H1c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm0-5H1C.45 0 0 .45 0 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm13.71 5.29C16.53 5.11 16.28 5 16 5s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L15 8.41V11c0 2.21-1.79 4-4 4H8.41l1.29-1.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L8.41 17H11c3.31 0 6-2.69 6-6V8.41l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3zM19 0H6c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PzP5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 10c0-.36-.2-.67-.49-.84l.01-.01-10-6-.01.01A.991.991 0 005 3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1 .19 0 .36-.07.51-.16l.01.01 10-6-.01-.01c.29-.17.49-.48.49-.84z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4LOiw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.707.293A1 1 0 00.293 1.707L2.086 3.5.293 5.293a1 1 0 001.414 1.414L3.5 4.914l1.793 1.793a1 1 0 001.414-1.414L4.914 3.5l1.793-1.793A1 1 0 005.293.293L3.5 2.086 1.707.293z",
    "M16 20a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z",
    "M18.29 5.7L16 3.41V8a3 3 0 01-3 3H4a1 1 0 00-1 1v7a1 1 0 11-2 0v-7a3 3 0 013-3h9a1 1 0 001-1V3.41l-2.29 2.3a1.003 1.003 0 01-1.42-1.42l4-4c.18-.18.43-.29.71-.29.28 0 .53.11.71.29l4 4A1.003 1.003 0 0119 6c-.28 0-.53-.11-.71-.3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"xEKGG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 9h-5V4c0-.55-.45-1-1-1s-1 .45-1 1v5H4c-.55 0-1 .45-1 1s.45 1 1 1h5v5c0 .55.45 1 1 1s1-.45 1-1v-5h5c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cbq1l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 7c-.27 0-.52.05-.75.15l-6.28-4.88c.01-.09.03-.18.03-.27 0-1.1-.9-2-2-2S7 .9 7 2c0 .06.01.12.02.19l-4.19 3C2.57 5.07 2.29 5 2 5 .9 5 0 5.9 0 7c0 .74.4 1.38 1 1.72v7.55c-.6.35-1 .99-1 1.73 0 1.1.9 2 2 2 .74 0 1.38-.4 1.72-1h7.55c.35.6.98 1 1.72 1 1.1 0 2-.9 2-2 0-.37-.11-.72-.29-1.02L18.03 11A2 2 0 0018 7zm-5.03 9c-.72.01-1.35.41-1.69 1H3.72c-.17-.3-.42-.55-.72-.72V8.72c.6-.34 1-.98 1-1.72 0-.06-.01-.12-.02-.19l4.19-3c.26.12.54.19.83.19.27 0 .52-.05.75-.15l6.28 4.88c-.01.09-.03.18-.03.27 0 .37.11.72.29 1.02L12.97 16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8KHHH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1S9 .45 9 1v8c0 .55.45 1 1 1zm3-7.45v2.16c2.36 1.12 4 3.5 4 6.29 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.79 1.64-5.17 4-6.29V2.55C3.51 3.79 1 7.09 1 11a9 9 0 0018 0c0-3.91-2.51-7.21-6-8.45z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cScpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 8.01c0-1.26-.61-2.43-1.61-3.12C17.86 2.5 15.8.79 13.4.79c-.58 0-1.14.1-1.69.29A3.533 3.533 0 009.17 0C8.05 0 7 .55 6.32 1.45c-.15-.02-.3-.03-.45-.03-1.63 0-3.03 1.12-3.46 2.71C.97 4.65 0 6.05 0 7.66c0 .48.09.95.26 1.4-.17.44-.26.91-.26 1.39 0 1.38.72 2.64 1.89 3.29.67.7 1.59 1.09 2.54 1.09.61 0 1.19-.15 1.71-.45.68.82 1.68 1.3 2.73 1.3.66 0 1.28-.18 1.83-.52.61.49 1.34.81 2.11.91 1.3 1.43 2.3 3.28 2.31 3.3 0 0 .35.61.33.61.96-.01 1.77-.2 1.64-1.3.01.02-.92-2.89-.92-2.89.52-.26.94-.69 1.21-1.23 1.12-.66 1.84-1.91 1.84-3.26 0-.3-.03-.6-.1-.89.57-.64.88-1.51.88-2.4zm-1.54 1.28l-.18-.2-.77-.84c-.33-.37-.67-1.17-.73-1.73 0 0-.13-1.25-.13-1.26-.06-.74-1.17-.73-1.13.14 0 .02.13 1.26.13 1.26.04.36.15.77.3 1.17-.08-.01-.15-.02-.22-.02 0 0-2.57-.12-2.57-.13-.73-.03-.89 1.22-.05 1.25l2.57.13c.53.03 1.29.37 1.61.72l.61.67.02.06c.1.27.14.55.14.83 0 .93-.51 1.77-1.34 2.18l-.2.1-.09.23c-.19.48-.6.82-1.1.93l-.67.14.87 2.75c-.48-.76-1.19-1.79-2.02-2.67l-.15-.16-.21-.02c-.51-.04-.99-.21-1.42-.48l1.7-1.48c.44-.39 1.04-.55 1.24-.49 0 0 .78.22.78.23.78.2 1.03-.92.29-1.21l-.78-.23c-.69-.2-1.67.22-2.24.72l-1.91 1.66-.39.32c-.44.36-.93.55-1.5.55-.8 0-1.54-.41-1.97-1.07v-1.88c0-.5.21-.98.34-1.07 0 0 .65-.43.64-.43.87-.69.21-1.57-.64-1.14 0-.01-.65.43-.65.43-.31.2-.54.56-.7.97-.13-.13-.28-.25-.43-.35 0 0-1.91-1.26-1.91-1.28-.81-.56-1.5.63-.61 1.11 0-.02 1.89 1.28 1.89 1.28.46.31.77.97.77 1.36v.84c-.43.24-.78.36-1.24.36-.67 0-1.31-.29-1.77-.79l-.07-.08-.09-.05a2.425 2.425 0 01-1.31-2.16c0-.38.09-.74.25-1.08l.15-.31-.14-.33c-.17-.34-.25-.7-.25-1.08 0-1.13.76-2.1 1.85-2.37l.39-.09.07-.43a2.41 2.41 0 012.39-2.05c.19 0 .39.02.58.07l.4.1.22-.38A2.41 2.41 0 019.17 1.3c.55 0 1.08.19 1.5.53l-.44.45-.01-.01-.31.31c-.41.35-.92.53-1.11.5 0 0-.84-.13-.84-.14-.83-.15-1.09 1.08-.18 1.29.01 0 .84.14.84.14.03 0 .06 0 .09.01-.14.46-.18.96-.12 1.4 0 0 .21 1.24.19 1.23.13.65 1.32.44 1.16-.22 0-.01-.19-1.23-.19-1.23-.07-.48.15-1.19.45-1.5l.48-.5c.07-.06.13-.12.19-.18l.93-.95c.5-.23 1.04-.34 1.59-.34 1.93 0 3.57 1.4 3.89 3.34l.05.31.26.15a2.445 2.445 0 01.87 3.4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iM3N3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.95 10.23c.16-.18.22-.22.46-.22h1.48c.25 0 .47.08.59.33.1.2.09.41-.05.66l-2.71 3.58L16.88 19c.13.21.16.46.03.69-.12.21-.34.31-.57.31H14.7c-.31 0-.56-.17-.7-.44l-1.9-2.67-1.93 2.68c-.15.27-.42.43-.73.43H7.98c-.25 0-.47-.08-.59-.33-.1-.2-.09-.41.05-.66l3.09-4.35L6.26 9H5v4.32c0 .41-.3.69-.7.69H2.7c-.41 0-.7-.28-.7-.69V.69c0-.41.3-.69.7-.69h4.42c.71 0 1.36.1 1.94.3.59.2 1.11.49 1.54.87.44.38.78.84 1.02 1.39.24.54.36 1.14.36 1.78 0 1.01-.28 1.88-.84 2.6-.43.54-1.35 1.29-2 1.59l3.09 3.94 1.72-2.24zM6.71 6.04c.71 0 1.45-.16 1.81-.46.33-.28.5-.69.5-1.25s-.17-.97-.5-1.25c-.35-.3-1.1-.46-1.81-.46h-1.7v3.42h1.7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"18yiu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 1h-8c0-.55-.45-1-1-1S9 .45 9 1H1c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 .55.45 1 1 1h4.59L4.3 18.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L9 16.41V19c0 .55.45 1 1 1s1-.45 1-1v-2.59l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L12.41 15H17c.55 0 1-.45 1-1V3h1c.55 0 1-.45 1-1s-.45-1-1-1zm-3 12H4V3h12v10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7OLNk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 16H6v-4H4v5c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-5h-2v4zm2-13c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v1h12V3zm3 2H1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h2v-3h14v3h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 4h-2V7h2v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4WLQU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v2h16V4zm-2-3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v1h12V1zm3 6H1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-5 7c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-2h1v2h6v-2h1v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdRuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 15c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm5-4h12c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1zM2 1C.9 1 0 1.9 0 3s.9 2 2 2 2-.9 2-2-.9-2-2-2zm17 8H7c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm0 7H7c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2SDg3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm5-1h11c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM3 15c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm16 1H8c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm-1-8H9c-1.1 0-2 .9-2 2s.9 2 2 2h9c1.1 0 2-.9 2-2s-.9-2-2-2zM3 7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i64HD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.01 10.11c.35-.64.72-1.68 1.09-3.11l.8-3.03h.96l.24-.77h-.99c.28-1.11.66-1.92 1.12-2.43.28-.32.56-.48.83-.48.05 0 .1.02.13.05.03.03.05.07.05.12 0 .04-.04.13-.11.25-.08.12-.11.24-.11.35 0 .15.06.28.18.39.12.11.27.16.45.16.2 0 .36-.07.49-.2s.2-.31.2-.54c0-.26-.1-.47-.3-.63-.2-.16-.52-.24-.96-.24-.68 0-1.3.19-1.86.58-.55.38-1.08 1.02-1.58 1.91-.17.3-.34.5-.49.59-.15.08-.4.13-.74.12l-.23.77h.95L5.74 9.21c-.23.86-.39 1.39-.47 1.59-.12.29-.3.54-.54.75-.1.08-.21.12-.35.12-.04 0-.07-.01-.1-.03l-.03-.04c0-.02.03-.07.1-.13.07-.07.1-.17.1-.31 0-.15-.05-.28-.16-.38-.11-.1-.27-.15-.47-.15-.25 0-.44.07-.59.2-.15.12-.23.28-.23.46 0 .19.09.36.27.5.19.14.47.21.86.21.61 0 1.16-.15 1.63-.46.48-.31.89-.79 1.25-1.43zm3.7 1.18c-.18-.18-.43-.29-.71-.29s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L9 14.41V19c0 .55.45 1 1 1s1-.45 1-1v-4.59l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3zm4.15-6.78c.17-.13.36-.2.55-.2.07 0 .2.03.39.08s.36.08.5.08c.2 0 .37-.07.5-.2.13-.14.2-.31.2-.52 0-.22-.07-.4-.2-.53s-.33-.2-.58-.2c-.22 0-.43.05-.63.15-.2.1-.45.32-.75.67-.23.25-.56.7-1.01 1.33a6.52 6.52 0 00-.91-2.15l-2.38.39-.05.25c.18-.03.33-.05.45-.05.24 0 .43.1.59.3.25.31.59 1.24 1.02 2.79-.34.44-.58.73-.7.87-.21.22-.38.36-.52.43-.1.05-.22.08-.35.08-.1 0-.26-.05-.49-.16a1.01 1.01 0 00-.42-.11c-.23 0-.42.07-.57.22-.17.14-.24.32-.24.55 0 .21.07.38.21.51.14.13.33.2.56.2.23 0 .44-.05.64-.14.2-.09.45-.29.75-.59s.72-.78 1.25-1.43c.2.62.38 1.07.53 1.35.15.28.32.49.52.61.19.12.44.19.73.19.28 0 .57-.1.86-.3.38-.25.77-.69 1.17-1.31l-.25-.14c-.27.37-.48.6-.61.69-.09.06-.19.09-.31.09-.14 0-.28-.09-.42-.26-.23-.29-.54-1.09-.93-2.4.37-.58.66-.96.9-1.14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2y3BV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 10h-2.38L14.9 6.55h-.01c-.17-.32-.5-.55-.89-.55-.43 0-.79.28-.93.66h-.01l-2.75 7.57L7.98 1.82h-.02A.978.978 0 007 1c-.44 0-.8.29-.94.69h-.01L3.28 10H1c-.55 0-1 .45-1 1s.45 1 1 1h3c.44 0 .8-.29.94-.69h.01l1.78-5.34 2.29 12.21h.02c.08.46.47.82.96.82.43 0 .79-.28.93-.66h.01l3.21-8.82.96 1.92h.01c.16.33.49.56.88.56h3c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8hxDg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 10a3 3 0 111.065-5.806A5.001 5.001 0 0114.63 3.11 3.5 3.5 0 1115.5 10H4zm0 2a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm9 1a1 1 0 10-2 0v6a1 1 0 102 0v-6zm3-1a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm-7 1a1 1 0 10-2 0v3a1 1 0 102 0v-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hf0nv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.47 5h2.12L15.3 6.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3a1.003 1.003 0 00-1.42 1.42L16.59 3H14c-.31 0-.57.15-.76.37l-.01-.01-2.93 3.52 1.3 1.56L14.47 5zm2.24 7.29a1.003 1.003 0 00-1.42 1.42l1.3 1.29h-2.12L4.77 3.36l-.01.01A.998.998 0 004 3H1c-.55 0-1 .45-1 1s.45 1 1 1h2.53l9.7 11.64.01-.01c.19.22.45.37.76.37h2.59l-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3zM3.53 15H1c-.55 0-1 .45-1 1s.45 1 1 1h3c.31 0 .57-.15.76-.37l.01.01 2.93-3.52-1.3-1.56L3.53 15z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iKLnk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0c-.442 0-.877.029-1.305.084a1 1 0 00.259 1.984 8.086 8.086 0 012.092 0 1 1 0 00.259-1.984A10.084 10.084 0 0010 0zM5.13 3.652a1 1 0 10-1.218-1.586 10.052 10.052 0 00-1.846 1.846A1 1 0 103.652 5.13 8.054 8.054 0 015.13 3.652zm10.958-1.586a1 1 0 00-1.218 1.586 8.054 8.054 0 011.478 1.478 1 1 0 101.585-1.218 10.053 10.053 0 00-1.845-1.846zM2.068 8.954a1 1 0 10-1.984-.259 10.085 10.085 0 000 2.61 1 1 0 101.984-.259 8.085 8.085 0 010-2.092zm17.848-.259a1 1 0 10-1.984.259 8.086 8.086 0 010 2.092 1 1 0 001.984.259 10.077 10.077 0 000-2.61zM3.652 14.87a1 1 0 00-1.586 1.218 10.053 10.053 0 001.846 1.845 1 1 0 001.218-1.585 8.054 8.054 0 01-1.478-1.478zm14.281 1.218a1 1 0 00-1.585-1.218 8.054 8.054 0 01-1.478 1.478 1 1 0 101.218 1.585 10.054 10.054 0 001.845-1.845zm-8.98 1.844a1 1 0 00-.258 1.984 10.078 10.078 0 002.61 0 1 1 0 10-.259-1.984 8.085 8.085 0 01-2.092 0zM10 7a3 3 0 110 6 3 3 0 010-6zm5 3a5 5 0 10-10 0 5 5 0 0010 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"24Yea":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 3a7 7 0 100 14 7 7 0 100-14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"askQP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 18V2h12v16H4zM2 1a1 1 0 011-1h14a1 1 0 011 1v18a1 1 0 01-1 1H3a1 1 0 01-1-1V1zm4.293 11.705a.999.999 0 111.412-1.412L10 13.587l2.295-2.294a.999.999 0 011.412 1.412l-2.962 2.963a1 1 0 01-1.49 0l-2.962-2.963zm0-3.998a.999.999 0 010-1.412l2.962-2.963A1.008 1.008 0 0110 4a.996.996 0 01.745.332l2.962 2.963a.999.999 0 01-1.412 1.412L10 6.413 7.705 8.707a.999.999 0 01-1.412 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cXT81":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 16H2V4h16v12zM1 18a1 1 0 01-1-1V3a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1H1zM7.295 6.293a.999.999 0 111.412 1.412L6.413 10l2.294 2.295a.999.999 0 11-1.412 1.412l-2.963-2.962A.992.992 0 014 10a.996.996 0 01.332-.745l2.963-2.962zm3.998 0a.999.999 0 011.412 0l2.963 2.962.04.038A.996.996 0 0116 10a.996.996 0 01-.332.745l-2.963 2.962a.999.999 0 01-1.412-1.412L13.587 10l-2.294-2.295a.999.999 0 010-1.412z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5KDm6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 4h18c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1zm1 2v8h16V6H2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5gcOt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.71 5.29l-4-4a1.003 1.003 0 00-1.42 1.42L16.59 5H6c-3.31 0-6 2.69-6 6s2.69 6 6 6h5v-2H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h10.59L14.3 9.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM15 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3LVfg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.636 3.636A9 9 0 0110 1c2.439 0 5.182.717 7 2.471V2a1 1 0 112 0v4a1 1 0 01-1 1h-4a1 1 0 110-2h1.7c-1.304-1.32-3.483-2-5.7-2a7 7 0 00-7 7 1 1 0 11-2 0 9 9 0 012.636-6.364zM16.364 16.364A9 9 0 0110 19c-2.439 0-5.182-.717-7-2.471V18a1 1 0 11-2 0v-4a1 1 0 011-1h4a1 1 0 110 2H4.3c1.304 1.32 3.483 2 5.7 2a7 7 0 007-7 1 1 0 112 0 9 9 0 01-2.636 6.364z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6wGfe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 17.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zM14 0a1 1 0 00-1 1v3.768L9.737 2.884a1 1 0 10-1 1.732L12 6.5 8.737 8.384a1 1 0 001 1.732L13 8.232V12a1 1 0 102 0V8.232l3.263 1.884a1 1 0 001-1.732L16 6.5l3.263-1.884a1 1 0 10-1-1.732L15 4.768V1a1 1 0 00-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dLZDv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 16H3.1L19.31 3.39l-.61-.79L2 15.59V3c0-.55-.45-1-1-1s-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm-9-9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-5 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm10-2c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm-5 4c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kgrDs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm5-9H5c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d4pSb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0H5c-.55 0-1 .45-1 1v4h2V2h5v16H6v-3H4v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18h-5V2h5v16zM6.29 13.71a1.003 1.003 0 001.42-1.42L5.41 10 7.7 7.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L4 8.59l-2.29-2.3A1.003 1.003 0 00.29 7.71L2.59 10 .3 12.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L4 11.41l2.29 2.3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2z9vC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 11h6c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-7 18H2V2h10v16zm6 0h-5V2h5v16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gED3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM7 18H2V2h5v16zm11 0H8V2h10v16zm-8-7h6c.55 0 1-.45 1-1s-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"atQBh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 14h6c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1zM19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2V8h16v10zm0-11H2V2h16v5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Wpka":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 8h6c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1zm12-8H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2v-5h16v5zm0-6H2V2h16v10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4lhab":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 6c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1v2.05C16.18 1.6 13.29 0 10 0 4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10c0-.55-.45-1-1-1s-1 .45-1 1c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8c2.53 0 4.77 1.17 6.24 3H15c-.55 0-1 .45-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3kbod":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6 6c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1s1 .45 1 1v2.05C3.82 1.6 6.71 0 10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10c0-.55.45-1 1-1s1 .45 1 1c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8C7.47 2 5.23 3.17 3.76 5H5c.55 0 1 .45 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"OH0F6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.7 4.7C7.9 4.2 7 4 6 4c-3.3 0-6 2.7-6 6s2.7 6 6 6c1 0 1.9-.2 2.7-.7C7.3 14 6.5 12.1 6.5 10s.9-4 2.2-5.3zM14 4c-1 0-1.9.2-2.7.7 1.4 1.4 2.2 3.2 2.2 5.3s-.9 4-2.2 5.3c.8.5 1.7.7 2.7.7 3.3 0 6-2.7 6-6s-2.7-6-6-6zm-4 1.5C8.8 6.7 8 8.2 8 10s.8 3.3 2 4.4c1.2-1.1 2-2.7 2-4.5s-.8-3.3-2-4.4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j11Ca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 4.2C7 5.75 8.34 7 10 7s3-1.46 3-2.8C13 1.45 10.94 0 10 0H6c0 2.74 3.76 1.96 1 4.2zm11.71 14.09L13 12.59V9.01c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v3.58l-5.71 5.7a1.003 1.003 0 001.42 1.42L7 15.42V19c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3.58l4.29 4.29a1.003 1.003 0 001.42-1.42zM10.21 8c.01 0 .01.01 0 0 .01.01.01 0 0 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ihj8H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.7 4.7C7.4 6 6.5 7.9 6.5 10s.8 4 2.2 5.3c-.8.5-1.7.7-2.7.7-3.3 0-6-2.7-6-6s2.7-6 6-6c1 0 1.9.2 2.7.7zm-3.34 9.25c-.55-1.2-.86-2.54-.86-3.95s.31-2.75.86-3.95a4.001 4.001 0 000 7.9zM14 4c3.3 0 6 2.7 6 6s-2.7 6-6 6c-1 0-1.9-.2-2.7-.7 1.3-1.3 2.2-3.2 2.2-5.3s-.8-3.9-2.2-5.3C12.1 4.2 13 4 14 4zm-4 1.5C8.8 6.7 8 8.2 8 10s.8 3.3 2 4.4c1.2-1.1 2-2.7 2-4.5s-.8-3.3-2-4.4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kL3Lg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fvN6k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7 7.5c0-3 1.857-6.25 3-7.5 1.143 1.25 3 4.5 3 7.5s-.714 6.25-1 7.5H8c-.286-1.25-1-4.5-1-7.5zm6.84 2.5c-.139 1.62-.47 3.405-.84 5.01l4 .99-1-4-2.16-2zm-4.832 6C9 16.139 9 16.284 9 16.429 9 17.143 9 17.5 10 20c1-2.5 1-2.857 1-3.571 0-.145 0-.29-.008-.429H9.008zM7 15.011c-.37-1.605-.701-3.39-.84-5.011L4 12l-1 4 4-.989zM10 5a1 1 0 100 2 1 1 0 000-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPl4P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 5c2.121-2.121 6.308-2.924 8-3-.076 1.692-.879 5.879-3 8-1.192 1.192-2.543 1.823-3.748 2.384-.442.207-.865.404-1.252.616-.203.111-.597.302-.986.49-.444.215-.88.426-1.014.51l-2-2c.158-.252 1-2 1-2s1.37-3.37 3-5zm5 1a1 1 0 11-2 0 1 1 0 012 0zM3 17s0-2 2-4l2 2c-2 2-4 2-4 2zm11-2l-4 4-1.298-4.233c1.033-.56 1.881-.962 2.643-1.322 1.275-.604 2.307-1.092 3.554-2.015L14 15zM1 10l4-4 3.557-.899c-.923 1.247-1.412 2.28-2.015 3.554-.36.762-.762 1.61-1.322 2.643L1 10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cWv1r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.293 9.59a.76.76 0 01-.038 1.035l-4.326 4.326a.76.76 0 101.076 1.076l4.326-4.326c.846-.846.896-2.2.114-3.106l-3.315-3.84h1.38a.76.76 0 100-1.521h-3.043a.76.76 0 00-.76.76v3.044a.76.76 0 001.521 0V6.04l3.065 3.55zM12.866 9.116a1.25 1.25 0 010 1.768l-5.303 5.303a1.25 1.25 0 01-1.768 0L.492 10.884a1.25 1.25 0 010-1.768l5.303-5.303a1.25 1.25 0 011.768 0l5.303 5.303z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jLY1i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.707 9.59a.76.76 0 00.038 1.035l4.326 4.326a.76.76 0 01-1.076 1.076L.669 11.701a2.283 2.283 0 01-.114-3.106l3.315-3.84H2.49a.76.76 0 110-1.521h3.043c.42 0 .76.34.76.76v3.044a.76.76 0 11-1.521 0V6.04L1.707 9.59z",
    "M19.116 9.116a1.25 1.25 0 010 1.768l-5.303 5.303a1.25 1.25 0 01-1.768 0l-5.303-5.303a1.25 1.25 0 010-1.768l5.303-5.303a1.25 1.25 0 011.768 0l5.303 5.303z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grbid":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.71 6.29A.997.997 0 008 6H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-8c0-.28-.11-.53-.29-.71l-4-4zM11 18H4V8h3v3c0 .55.45 1 1 1h3v6zm3-16h-1.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C9.11 2.47 9 2.72 9 3c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H14c1.1 0 2 .9 2 2v3c0 .55.45 1 1 1s1-.45 1-1V6c0-2.21-1.79-4-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7AVLR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 2h-1.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C9.11 2.47 9 2.72 9 3c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H14c1.1 0 2 .9 2 2v3c0 .55.45 1 1 1s1-.45 1-1V6c0-2.21-1.79-4-4-4zm-2 5H3c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 11H4V9h7v9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"QZ7et":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.028 6.016c.146.275.31.57.485.872.304.524.628 1.047.952 1.545l.118.178-.208-.006-.577-.005c-2.093.004-2.841.303-2.841.895 0 .069.271.248 1.245.567l1.008.313c2.671.831 3.99 1.827 3.99 4.167 0 2.76-1.928 4.059-4.832 4.376-.782.085-1.52.098-2.452.066l-1.15-.046H6.221l.535-.811a67.46 67.46 0 001.122-1.787h2.04l.686.03c1.028.046 1.77.043 2.523-.039 1.832-.2 2.673-.767 2.673-1.789 0-.69-.483-1.09-1.992-1.585l-.83-.257c-1.192-.364-2.037-.7-2.59-1.165.399-1 .612-1.844.612-2.538a6.018 6.018 0 00-.382-2.098c.745-.573 1.884-.822 3.41-.883zM5 4.2c2.648 0 4.791 2.151 4.8 4.797C9.8 11.652 5 18.6 5 18.6l-.5-.744C3.273 15.993.2 11.121.2 8.997A4.802 4.802 0 015 4.2zm0 2.4a2.4 2.4 0 10.002 4.802A2.4 2.4 0 005 6.6zM17 .333a2.671 2.671 0 012.667 2.665C19.667 4.473 17 8.333 17 8.333l-.391-.587c-.741-1.137-2.276-3.629-2.276-4.748A2.668 2.668 0 0117 .333z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HuEF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 18c.6 0 1 .4 1 1s-.4 1-1 1c-5 0-9-4-9-9 0-.6.4-1 1-1s1 .4 1 1c0 3.9 3.1 7 7 7zm0-4c.6 0 1 .4 1 1s-.4 1-1 1c-2.8 0-5-2.2-5-5 0-.6.4-1 1-1s1 .4 1 1c0 1.7 1.3 3 3 3zm5.7-3.7c.4-.4 1-.4 1.4 0l3.6 3.6c.4.4.4 1 0 1.4l-1.4 1.4c-.4.4-1 .4-1.4 0l-3.6-3.6c-.4-.4-.4-1 0-1.4l1.4-1.4zM4.7.3c.4-.4 1-.4 1.4 0l3.6 3.6c.4.4.4 1 0 1.4L8.3 6.7c-.4.4-1 .4-1.4 0L3.3 3.1c-.4-.4-.4-1 0-1.4L4.7.3zm11.1 1c.4-.4 1-.4 1.4 0l1.6 1.6c.4.4.4 1 0 1.4l-6.5 6.5c-.4.4-1 .4-1.4 0L9.3 9.2c-.4-.4-.4-1 0-1.4l6.5-6.5zM9 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"baSyi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 0H4c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V6l-6-6zm4 18H5V2h6v5h5v11zm-8.29-6.71a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29.32 0 .59-.16.77-.38l.01.01 4-5-.01-.01c.14-.18.23-.38.23-.62 0-.55-.45-1-1-1-.32 0-.59.16-.77.38l-.01-.01-3.3 4.13-2.21-2.21z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hxyeR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm5 2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1 10H2V3c0-.55-.45-1-1-1s-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM5 15c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfGO4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.56 17.44l-4.94-4.94A8.004 8.004 0 0016 8c0-4.42-3.58-8-8-8S0 3.58 0 8s3.58 8 8 8c1.67 0 3.21-.51 4.5-1.38l4.94 4.94a1.498 1.498 0 102.12-2.12zM8 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6BGli":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.9 6.9a3 3 0 100 6 3 3 0 100-6zM3 14c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM3 0C1.3 0 0 1.3 0 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM17 14c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM17 0c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM10 10L5 5",
    "M5.379 4.671l5.02 5.02-.707.708-5.02-5.02zM10 10l5-5",
    "M14.621 4.671l.707.708-5.02 5.02-.707-.707z",
    "M10 10l5 5M10.379 9.671l5.02 5.02-.707.708-5.02-5.02z",
    "M10 10l-5 5M9.621 9.671l.707.708-5.02 5.02-.707-.707z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hj1oy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 8H5c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm0 3H5c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm0-6H5c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm6.56 12.44l-3.23-3.23A8.939 8.939 0 0018 9a9 9 0 10-9 9c1.94 0 3.74-.62 5.21-1.67l3.23 3.23a1.498 1.498 0 102.12-2.12zM9 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lJ3ae":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.56 17.44l-3.23-3.23A8.939 8.939 0 0018 9a9 9 0 10-9 9c1.94 0 3.74-.62 5.21-1.67l3.23 3.23a1.498 1.498 0 102.12-2.12zM9 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm3.5-11h-7c-.28 0-.5.22-.5.5v2c0 .28.22.5.5.5s.5-.22.5-.5V7h2v6h-.5c-.28 0-.5.22-.5.5s.22.5.5.5h3c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H10V7h2v.5c0 .28.22.5.5.5s.5-.22.5-.5v-2c0-.28-.22-.5-.5-.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7eoQR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 5H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 8h-8V7h8v6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45YRW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.71 18.29l-4.25-4.25L20 12.91 9.93 9.33c.04-.1.07-.21.07-.33V3c0-.55-.45-1-1-1H4V1c0-.55-.45-1-1-1S2 .45 2 1v1H1c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 .55.45 1 1 1h6c.12 0 .23-.03.34-.07L12.91 20l1.14-4.54 4.25 4.25c.17.18.42.29.7.29a1.003 1.003 0 00.71-1.71zM8 8H4V4h4v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9RHqL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
    "M10 6a4 4 0 100 8 4 4 0 100-8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g7C1K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10.707 19.707a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 16.586V11H1a1 1 0 110-2h8V6H1a1 1 0 01-1-1V2a1 1 0 011-1h18a1 1 0 011 1v3a1 1 0 01-1 1h-8v3h8a1 1 0 110 2h-8v5.586l2.293-2.293a1 1 0 011.414 1.414l-4 4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"781MV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1.754.135L19.393 9.06c.57.288.775.943.458 1.462-.107.176-.266.32-.458.418l-17.64 8.925c-.57.288-1.288.1-1.604-.418C.05 19.287 0 19.183 0 19v-7l11-2L0 8V1.075C0 .481.529 0 1.18 0c.201 0 .399.047.574.135z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9acC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0h-5c-.6 0-1 .4-1 1s.4 1 1 1h2.6l-4.3 4.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3L18 3.4V6c0 .5.5 1 1 1s1-.5 1-1V1c0-.6-.5-1-1-1zm0 9c-1 0-1.9-.5-2.5-1.3l-1.4 1.4c-.5.6-1.3.9-2.1.9-1.7 0-3-1.3-3-3 0-.8.3-1.6.9-2.1l1.4-1.4C11.5 2.9 11 2 11 1c0-.3.1-.6.2-.9-.4-.1-.8-.1-1.2-.1C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10c0-.4 0-.8-.1-1.2-.3.1-.6.2-.9.2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1m5GI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 11H3c-.55 0-1 .45-1 1s.45 1 1 1h2.59L.3 18.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L7 14.41V17c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1zm10 2c-.53 0-1.01.21-1.37.55L11.9 10.6c.06-.19.1-.39.1-.6 0-.21-.04-.41-.1-.6l4.72-2.95c.37.34.85.55 1.38.55 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .21.04.41.1.6l-4.73 2.96c-.24-.23-.54-.4-.87-.48V3.93c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S8 .9 8 2c0 .93.64 1.71 1.5 1.93v4.14c-.33.09-.63.26-.87.48L7.6 7.91 5.42 6.55 3.9 5.6c.06-.19.1-.39.1-.6 0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.53 0 1.01-.21 1.37-.55L9 9.96V10h.06L12 11.84l.4.25 1.51.94 2.19 1.37c-.06.19-.1.39-.1.6 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2zm-7-2.96l-.06-.04H11v.04z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGwB7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 11H3c-.55 0-1 .45-1 1s.45 1 1 1h2.59L.3 18.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L7 14.41V17c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1zm11.54-6.82l.01-.02-6-4-.01.02C13.39.08 13.21 0 13 0s-.39.08-.54.18l-.01-.02L7 3.8 1.55.17l-.01.01A.969.969 0 001 0C.45 0 0 .45 0 1v9c0-.55.45-1 1-1h1V2.87l4 2.67V9h2V5.54l4-2.67v11.6l-1 .67v2.4l2-1.33 5.45 3.63.01-.02c.15.1.33.18.54.18.55 0 1-.45 1-1V5c0-.35-.19-.64-.46-.82zM18 17.13l-4-2.67V2.87l4 2.67v11.59z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ITi8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 18H2v-2h16zM16 16H4l2.122-1.768a1 1 0 01.64-.232h6.476a1 1 0 01.64.232L16 16zM10 11a1 1 0 100 2 1 1 0 100-2z",
    "M13.685 10.04c.4-.38.42-1.01.04-1.41-2.159-2.27-5.508-2.08-7.457.01A.996.996 0 107.728 10c1.19-1.28 3.208-1.39 4.538.01.39.39 1.02.41 1.42.03z",
    "M3.205 6.403c-.3.4-.3 1.1.2 1.4.4.3 1.1.3 1.399-.2 1.3-1.7 3.099-2.6 5.198-2.6 1.999 0 4.098 1 5.198 2.6.3.5.9.6 1.4.2.299-.2.399-.5.399-.8 0-.2-.1-.4-.2-.6-1.5-2.099-4.098-3.399-6.797-3.399-2.799-.09-5.098 1.2-6.797 3.4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6tAoY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.29 9.29c.3.62.8 1.12 1.42 1.42l-3 3c-.18.18-.43.29-.71.29s-.53-.11-.71-.3L7 10.41l-5 5V17h17c.55 0 1 .45 1 1s-.45 1-1 1H1a.998.998 0 01-1-1V4c0-.55.45-1 1-1s1 .45 1 1v8.59l4.29-4.3C6.47 8.11 6.72 8 7 8s.53.11.71.29l3.29 3.3 2.29-2.3zM12 5c0-.5.4-1 1-1h2V2c0-.6.4-1 1-1 .5 0 1 .4 1 1v2h2c.5 0 1 .4 1 1s-.5 1-1 1h-2v2c0 .6-.5 1-1 1-.6 0-1-.4-1-1V6h-2c-.6 0-1-.4-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3qlmR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.91 10.67c.52.45 1.13.8 1.8 1.03l-2.01 2.01c-.18.18-.43.29-.71.29-.28 0-.53-.11-.71-.3L7 10.41l-5 5V17h16.99c.55 0 1 .45 1 1s-.45 1-1 1H1a.998.998 0 01-1-1V4c0-.55.45-1 1-1s1 .45 1 1v8.59l4.29-4.3C6.47 8.11 6.72 8 7 8c.28 0 .53.11.71.29l3.29 3.3.91-.92zM18.5 4.6h1.04c.25 0 .45.2.46.44v.9c0 .25-.2.45-.45.45h-1.04c-.07.22-.16.42-.27.62l.73.73c.17.17.17.44 0 .61l-.61.61c-.17.17-.44.17-.61 0l-.73-.73c-.2.11-.4.2-.62.26v1.05c0 .25-.2.45-.45.45h-.9c-.25 0-.45-.2-.45-.45V8.51c-.21-.06-.4-.15-.58-.25l-.76.77c-.17.17-.46.17-.64 0l-.64-.64a.465.465 0 010-.64l.76-.77c-.1-.19-.19-.38-.25-.59h-1.04c-.25 0-.45-.2-.45-.45v-.9c0-.25.2-.45.45-.45h1.04c.07-.22.16-.42.27-.61l-.73-.73a.429.429 0 010-.61l.61-.61c.17-.17.44-.17.61 0l.73.73c.2-.11.4-.2.62-.26V1.45a.44.44 0 01.44-.45h.9c.25 0 .45.2.45.45V2.5c.21.06.4.15.58.25l.76-.77c.17-.17.46-.17.64 0l.64.64c.17.17.17.46 0 .64l-.76.77c.1.17.19.36.25.57zm-4.69.9c0 .93.75 1.69 1.69 1.69.93 0 1.69-.75 1.69-1.69s-.75-1.69-1.69-1.69-1.69.76-1.69 1.69z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6lRcU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.82 6.58c-.03.05-.07.09-.11.13 0 0 0-.01-.01-.01l-2 2c-.2.2-.4.3-.7.3-.6 0-1-.4-1-1 0-.3.1-.5.3-.7L16.6 6H11c-.6 0-1-.4-1-1s.4-1 1-1h5.6l-1.3-1.3c-.2-.2-.3-.4-.3-.7 0-.6.4-1 1-1 .3 0 .5.1.7.3l3 3c.2.2.3.4.3.7s-.1.5-.3.7l-.88.88zm-5.53 2.71c.3.62.8 1.12 1.42 1.42l-3 3c-.18.18-.43.29-.71.29s-.53-.11-.71-.3L7 10.41l-5 5V17h17c.55 0 1 .45 1 1s-.45 1-1 1H1a.998.998 0 01-1-1V4c0-.55.45-1 1-1s1 .45 1 1v8.59l4.29-4.3C6.47 8.11 6.72 8 7 8s.53.11.71.29l3.29 3.3 2.29-2.3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4qt46":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.14 10.45c.21.67.65 1.23 1.22 1.61l-1.65 1.65c-.18.18-.43.29-.71.29s-.53-.11-.71-.3L7 10.41l-5 5V17h17c.55 0 1 .45 1 1s-.45 1-1 1H1a.998.998 0 01-1-1V4c0-.55.45-1 1-1s1 .45 1 1v8.59l4.29-4.3C6.47 8.11 6.72 8 7 8s.53.11.71.29l3.29 3.3 1.14-1.14zM19.35 1a.642.642 0 01.46 1.1l-3.03 3.03v2.95c0 .18-.07.34-.19.46l-1.28 1.29c-.11.1-.27.17-.45.17-.35 0-.64-.29-.64-.64V5.13L11.19 2.1a.642.642 0 01.45-1.1h7.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Y0FD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.28 11.31l-.28.28-3.29-3.3C7.53 8.11 7.28 8 7 8s-.53.11-.71.29L2 12.59V4c0-.55-.45-1-1-1s-1 .45-1 1v14a.998.998 0 001 1h18c.55 0 1-.45 1-1s-.45-1-1-1H2v-1.59l5-5 3.29 3.29c.18.19.43.3.71.3s.53-.11.71-.29l2.09-2.09c-.17.02-.34.02-.51.02-.7 0-1.38-.12-2.01-.33zm-.93-6c0-1.62 1.31-2.93 2.93-2.93s2.93 1.31 2.93 2.93-1.31 2.93-2.93 2.93-2.93-1.31-2.93-2.93zm6.47 2.43c.11-.17.21-.33.29-.51.01-.03.03-.06.04-.09.08-.18.16-.35.21-.54.06-.2.1-.38.14-.58.01-.05.01-.09.02-.14.03-.2.05-.39.05-.6 0-2.37-1.93-4.3-4.3-4.3-2.37.01-4.3 1.93-4.3 4.31s1.93 4.3 4.3 4.3c.21 0 .4-.02.6-.05.04 0 .09-.01.14-.02.2-.03.38-.08.57-.14.2-.06.37-.14.55-.21.03-.01.06-.03.09-.04.18-.09.34-.19.51-.29l2.87 2.87c.14.14.33.22.56.22.43 0 .78-.35.78-.78a.938.938 0 00-.23-.56l-2.89-2.85z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3jy2g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.75 0C14.44 0 15 .56 15 1.25v12.5c0 .69-.56 1.25-1.25 1.25h-7.5C5.56 15 5 14.44 5 13.75V1.25C5 .56 5.56 0 6.25 0h7.5zM11.5 2a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM11 6.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5zm.5 3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z",
    "M4 10.726v3.024A2.25 2.25 0 006.25 16h7.5A2.25 2.25 0 0016 13.75v-3.024l3.607 2.618a.97.97 0 01.131 1.443l-4.5 4.875a1.068 1.068 0 01-.786.338H5.548c-.3 0-.586-.123-.785-.338L.262 14.787a.97.97 0 01.13-1.443L4 10.726z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"G9rfD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17.29 4.295a1.002 1.002 0 011.42 1.419l-3 2.997a1.015 1.015 0 01-1.42 0l-3-2.997a1.002 1.002 0 011.42-1.419L14 5.584V1a1 1 0 012 0v4.584l1.29-1.289z",
    "M13.267 0A1.99 1.99 0 0013 1v2.27a2.002 2.002 0 00-2.417 3.152l3.01 3.006.01.01c.359.34.85.563 1.397.563v3.749c0 .69-.56 1.25-1.25 1.25h-7.5C5.56 15 5 14.44 5 13.75V1.25C5 .56 5.56 0 6.25 0h7.017z",
    "M4 10.726L.393 13.344a.97.97 0 00-.131 1.443l4.5 4.875c.2.215.485.338.786.338h8.904c.3 0 .586-.123.785-.338l4.501-4.875a.97.97 0 00-.13-1.443L16 10.726v3.024A2.25 2.25 0 0113.75 16h-7.5A2.25 2.25 0 014 13.75v-3.024z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Wjan":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 1c0-.55-.45-1-1-1S2 .45 2 1v5h2V1zM2 19c0 .55.45 1 1 1s1-.45 1-1v-6H2v6zm9-18c0-.55-.45-1-1-1S9 .45 9 1v8h2V1zm7 0c0-.55-.45-1-1-1s-1 .45-1 1v3h2V1zM9 19c0 .55.45 1 1 1s1-.45 1-1v-3H9v3zm9-14h-2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-2 14c0 .55.45 1 1 1s1-.45 1-1v-8h-2v8zM4 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm7 3H9c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"frEIM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.88 11.12a.958.958 0 011.277.33l3.719 6.207c.081.136.124.29.124.447 0 .495-.419.896-.936.896H4.936a.969.969 0 01-.436-.103.878.878 0 01-.392-1.21l3.409-6.208a.915.915 0 01.362-.36zM15 5a4 4 0 110 8 4 4 0 010-8zM8 1a1 1 0 011 1v6a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5fj4G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 18H2V5h8.76l2-2H1c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1h15c.55 0 1-.45 1-1V7.24l-2 2V18zm4-18h-7c-.55 0-1 .45-1 1s.45 1 1 1h4.59l-7.3 7.29a1.003 1.003 0 001.42 1.42L18 3.41V8c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1fqhV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.917 17.209c1.01.454 2.543.928 2.873 1.643.31.722.186 1.148.186 1.148H6.026s-.13-.426.186-1.148 1.842-1.203 2.86-1.65c1.017-.447.914-.722.948-1.093 0-.048.007-.097.007-.145a3.067 3.067 0 01-.839-1.237l-.007-.007c0-.007-.006-.014-.006-.02a1.757 1.757 0 01-.11-.337c-.234-.042-.372-.296-.426-.537a1.045 1.045 0 01-.138-.598c.034-.35.179-.509.337-.57v-.056c0-.44.034-1.065.117-1.478a2.508 2.508 0 01.962-1.623c.426-.33 1.038-.501 1.58-.501.544 0 1.155.172 1.588.502a2.496 2.496 0 01.963 1.622c.075.413.117 1.045.117 1.478v.062c.15.062.288.22.323.564.02.268-.083.502-.138.598-.048.234-.185.488-.42.537a2.635 2.635 0 01-.116.364 3.094 3.094 0 01-.818 1.224c0 .055 0 .11.007.158.034.378-.103.653.914 1.1z",
    "M14.976 16.57c-.24-.099-.455-.186-.65-.273l-.007-.004a3.801 3.801 0 01-.194-.091c.224-.288.41-.609.554-.946l.001-.002.013-.033c.018-.043.036-.087.052-.13l.011-.027.016-.04c.105-.092.19-.19.256-.284.129-.184.213-.38.265-.563.105-.226.225-.592.192-1.026l-.001-.011-.002-.011a1.854 1.854 0 00-.325-.91 9.924 9.924 0 00-.12-1.246 3.09 3.09 0 00-.106-.475l-.001-.006a3.543 3.543 0 00-.763-1.353c.27-.092.56-.139.83-.139.495 0 1.05.156 1.444.456a2.269 2.269 0 01.875 1.475c.069.375.106.95.106 1.344v.056c.138.056.263.2.294.513.019.244-.075.456-.125.543-.044.213-.169.444-.381.488-.025.1-.056.206-.094.3a2.815 2.815 0 01-.756 1.144c0 .05 0 .1.006.144.004.043.006.086.007.127.01.283.018.518.824.872.192.087.404.173.623.263.83.34 1.752.717 1.99 1.231.28.657.168 1.044.168 1.044h-2.081a3.864 3.864 0 00-.188-.542l-.005-.013-.006-.012c-.183-.397-.491-.681-.76-.88a5.614 5.614 0 00-.896-.522 17.36 17.36 0 00-.916-.4l-.15-.061zM14 1c.55 0 1 .45 1 1 0 .28-.11.53-.29.7L10 7.41v.897a3.182 3.182 0 00-.69.4 3.508 3.508 0 00-1.343 2.259c-.07.37-.107.836-.122 1.237a1.836 1.836 0 00-.339.926c-.046.458.09.84.195 1.06.053.178.138.376.27.56.055.08.125.162.21.242v.143l.053.052L6.71 16.71A1.003 1.003 0 015 16V7.41L.29 2.71A1.003 1.003 0 011 1h13z",
    "M9.059 14.361c-.23-.044-.366-.296-.42-.535a1.045 1.045 0 01-.138-.598c.034-.35.179-.509.337-.57v-.056c0-.44.034-1.065.117-1.478A2.508 2.508 0 0110 9.441V13c0 .28-.11.53-.29.71l-.651.651z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ehGH6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 20c6-3.81 9-9.048 9-15.714-2 0-5-1.429-9-4.286-4 2.857-7 4.286-9 4.286C1 10.952 4 16.19 10 20zm0-17.348c2.577 1.734 4.776 2.88 6.667 3.419-.44 4.627-2.636 8.353-6.667 11.297V2.652z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"803hS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.84.804L6.5 2.5h-3a1 1 0 00-1 1v4.893l-1.58.451a.99.99 0 00-.691 1.192c.46 1.82 1.163 4.356 1.701 5.571-.218.012-.445.018-.68.018a.625.625 0 100 1.25c2.583 0 4.268-.68 5.202-1.146.687.466 1.88 1.146 3.548 1.146 1.65 0 2.837-.666 3.528-1.132l.005.003c.244.131.6.3 1.07.468.938.335 2.321.661 4.147.661a.625.625 0 100-1.25c-.323 0-.63-.011-.922-.031a.996.996 0 00.184-.334l1.67-5.168a1 1 0 00-.677-1.27l-1.505-.43V3.5a1 1 0 00-1-1h-3L13.16.804A1 1 0 0012.18 0H7.82a1 1 0 00-.98.804zM5 7.679l3.75-1.072V5H5v2.679zm6.25-1.072L15 7.68V5h-3.75v1.607zM6.205 16.95a.625.625 0 01.658.042c.569.407 1.597 1.134 3.137 1.134s2.568-.727 3.137-1.134a.625.625 0 01.724-.001l.007.005.045.029c.044.027.114.069.21.12.194.104.493.247.9.392.811.29 2.053.589 3.727.589a.625.625 0 110 1.25c-1.826 0-3.21-.326-4.148-.661a7.894 7.894 0 01-1.069-.468l-.005-.003c-.691.466-1.878 1.132-3.528 1.132-1.667 0-2.861-.68-3.548-1.146-.934.467-2.619 1.146-5.202 1.146a.625.625 0 110-1.25c2.66 0 4.23-.787 4.955-1.176z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9rDRU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17.94 3.63c-.01-.02-.01-.03-.02-.04l-.03-.09h-.01c-.18-.3-.49-.5-.86-.5h-14c-.42 0-.77.25-.92.61L0 8.5h.02a2.5 2.5 0 005 0 2.5 2.5 0 005 0 2.5 2.5 0 005 0 2.5 2.5 0 005 0l-2.08-4.87zM3.02 2h14c.55 0 1-.45 1-1s-.45-1-1-1h-14c-.55 0-1 .45-1 1s.44 1 1 1zm13 14h-12v-4h-2v7c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-7h-2v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"28k88":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 14H8.72l-.67-2H17c.44 0 .8-.29.94-.69h.01l2-6h-.01c.03-.1.06-.2.06-.31 0-.55-.45-1-1-1H5.39l-.44-1.32h-.01C4.8 2.29 4.44 2 4 2H1c-.55 0-1 .45-1 1s.45 1 1 1h2.28l3.33 10H5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2h9c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2zM6.05 6h11.56l-1.33 4H7.39L6.05 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1kLe2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M.833 13h8.334c.458 0 .833-.45.833-1s-.375-1-.833-1H.833C.375 11 0 11.45 0 12s.375 1 .833 1zM1 8h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm15 6c0-.28-.11-.53-.29-.71l-.3-.29H19c.55 0 1-.45 1-1s-.45-1-1-1h-3.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2c-.18.19-.29.44-.29.71 0 .28.11.53.29.71l2 2c.18.18.43.29.71.29.55.01 1-.44 1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4J46i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M7.15 10.33c.888.8 1.999 1.36 3.228 1.574l2.326 6.98a.846.846 0 01-.535 1.07.844.844 0 01-1.072-.535l-1.225-3.671H7.125L5.9 19.419a.85.85 0 01-1.072.536.85.85 0 01-.536-1.071l2.857-8.555zm1.353 1.305l-.808 2.413h1.607l-.8-2.413zM5 5.5c0 .76.13 1.49.37 2.17-.496 1.056-.313 2.356.704 3.29.385.353.404.94.038 1.311a.982.982 0 01-1.356.038c-2.183-2.01-2-5.125.01-6.94a.95.95 0 01.24-.156A6.421 6.421 0 005 5.5z",
    "M3.874 13.185c-1.346-.918-2.187-2.67-2.187-4.34 0-1.752.757-3.254 2.187-4.339.42-.25.42-.834.168-1.168-.252-.418-.84-.418-1.177-.167C1.014 4.59-.08 6.509.005 8.846c.084 2.253 1.177 4.423 2.86 5.675.168.083.336.166.504.166.253 0 .505-.083.673-.333.337-.418.253-.918-.168-1.169zM12.246 12.309a.98.98 0 01-1.354-.037.917.917 0 01-.206-.324 6.54 6.54 0 001.959-.049 5.125 5.125 0 01-.399.41zM14.631 11.476l1.228 1.229a6.6 6.6 0 01-1.723 1.816c-.169.083-.337.166-.505.166-.253 0-.505-.083-.673-.333-.337-.418-.253-.918.168-1.169.62-.422 1.133-1.022 1.505-1.709z",
    "M11.5 0C14.54 0 17 2.46 17 5.5c0 .26-.02.51-.06.75l-.03.17c-.04.25-.1.49-.17.73v.01c-.08.24-.17.47-.28.69-.01.04-.03.07-.05.11-.11.23-.24.44-.38.65l3.68 3.68A1.003 1.003 0 0119 14c-.28 0-.53-.11-.7-.29l-3.68-3.68c-.21.14-.42.27-.65.38-.04.01-.07.03-.11.05-.22.11-.45.2-.69.28h-.01c-.24.07-.48.13-.73.17l-.17.03c-.25.04-.5.06-.76.06C8.46 11 6 8.54 6 5.5S8.46 0 11.5 0zm0 1.5c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cBXx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.71 5.29l-5-5A.997.997 0 0011 0H4c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.28-.11-.53-.29-.71zM9 7h2v3H9V7zM6 7h2v3H6V7zm2 11H6v-3h2v3zm3 0H9v-3h2v3zm3 0h-2v-3h2v3zm0-4H6v-3h8v3zm0-4h-2V7h2v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LNTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 2c-.46 0-.85.32-.97.74L7.04 16.7c-.02.1-.04.2-.04.3 0 .55.45 1 1 1 .46 0 .85-.32.97-.74L12.96 3.3c.02-.1.04-.2.04-.3 0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kPLv0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.41 10l3.29-3.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L10 8.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42L8.59 10 5.3 13.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3.29-3.3 3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L11.41 10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3yKWy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 10a7 7 0 11-14 0 7 7 0 0114 0zm-6-5v2H9V5h2zm0 3v6h1v1H8v-1h1V9H8V8h3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dwfGj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 9H6c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Zz5l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 9h-3V6c0-.55-.45-1-1-1s-1 .45-1 1v3H6c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5LsAK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 5v10h10V5H5zM4 3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1H4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"44wrO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 5c-.28 0-.53.11-.71.29L8 11.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l7-7A1.003 1.003 0 0015 5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ftYuz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 11.776v2.81l2.31 2.242a.987.987 0 010 1.415c-.399.39-1.044.39-1.442 0L11 17.414V19a.99.99 0 01-.996 1A.996.996 0 019 19v-1.636l-.912.879c-.398.39-1.043.39-1.441 0a.987.987 0 010-1.415L9 14.536v-2.79l-2.548 1.435-.837 3.063c-.146.534-.705.85-1.248.707a.998.998 0 01-.721-1.224l.309-1.132-1.4.793a1.03 1.03 0 01-1.393-.366.99.99 0 01.373-1.366l1.445-.818-1.224-.322a.998.998 0 01-.72-1.225c.145-.533.704-.85 1.248-.707l3.193.84 2.462-1.395-2.532-1.434-3.123.82a1.022 1.022 0 01-1.249-.706.998.998 0 01.721-1.225L2.91 7.18l-1.4-.793a.99.99 0 01-.373-1.366 1.03 1.03 0 011.392-.366l1.445.818-.328-1.2a.998.998 0 01.72-1.225 1.022 1.022 0 011.25.707l.855 3.132L9 8.311V5.414L6.647 3.121a.987.987 0 010-1.414 1.033 1.033 0 011.441 0L9 2.586V1c0-.552.44-1 1.004-1A.99.99 0 0111 1l-.007 1.536.875-.829a1.033 1.033 0 011.441 0 .987.987 0 010 1.414L11 5.364v2.918l2.53-1.42.855-3.131c.146-.534.705-.85 1.249-.707a.998.998 0 01.72 1.224l-.327 1.2 1.4-.792a1.03 1.03 0 011.392.366.99.99 0 01-.373 1.366l-1.355.768 1.153.303a.998.998 0 01.721 1.225c-.146.533-.705.85-1.249.707l-3.123-.821-2.576 1.459 2.506 1.42 3.193-.84a1.022 1.022 0 011.249.707.998.998 0 01-.72 1.225l-1.224.322 1.4.793a.99.99 0 01.373 1.366 1.03 1.03 0 01-1.393.366l-1.356-.768.31 1.132a.998.998 0 01-.721 1.224 1.022 1.022 0 01-1.249-.707l-.837-3.063L11 11.776z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eeAzc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.5 19a9.5 9.5 0 100-19 9.5 9.5 0 000 19zm0-2c.879 0 1.722-.151 2.506-.429l.644-1.982-1.152-1.585H7.674l-1.152 1.585.665 2.048A7.497 7.497 0 009.5 17zm-6-2.999h2.213l1.219-1.677-1.038-3.247-2.337-.759L2 9.45v.05c0 1.689.558 3.247 1.5 4.501zM17 9.5a7.466 7.466 0 01-1.5 4.501h-2.04l-1.339-1.842.976-3.05 2.432-.79 1.47 1.068L17 9.5zM3.225 5.391l.642 1.976 2.296.746 2.833-2.09V4.136L6.764 2.515a7.525 7.525 0 00-3.54 2.876zM15.22 7.367l.613-1.887a7.526 7.526 0 00-3.602-2.967L9.996 4.137v1.879l2.867 2.117 2.357-.766z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jW7Bi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.5 5c.8 0 1.6-.4 2-1 2 1.2 3.3 3.3 3.5 5.7 0 .5.5.9 1 .9.6 0 1-.5 1-1v-.1c-.2-3.3-2.2-6.2-5.1-7.6C13.7.8 12.7 0 11.5 0 10.1 0 9 1.1 9 2.5S10.1 5 11.5 5zm5 7c-1.4 0-2.5 1.1-2.5 2.5 0 .4.1.7.2 1.1-1.1.9-2.6 1.4-4.2 1.4-1.9 0-3.6-.8-4.9-2-.2-.2-.5-.4-.8-.4-.5 0-1 .5-1 1 0 .3.1.5.3.7C5.3 18 7.5 19 10 19c2.2 0 4.2-.8 5.8-2.1.2.1.5.1.7.1 1.4 0 2.5-1.1 2.5-2.5S17.9 12 16.5 12zM5 10.5c0-1.1-.7-2.1-1.7-2.4.5-1.9 1.9-3.5 3.6-4.4.3-.2.6-.5.6-.9 0-.5-.4-1-1-1-.2 0-.4.1-.6.2-2.4 1.2-4.2 3.6-4.7 6.4C.5 8.9 0 9.6 0 10.5 0 11.9 1.1 13 2.5 13S5 11.9 5 10.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bGyTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 16h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm0-5h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zM7 15c-.28 0-.53.11-.71.29L5 16.59V11c0-.55-.45-1-1-1s-1 .45-1 1v5.59L1.71 15.3A.965.965 0 001 15a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 007 15zM19 1h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm0 5h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"91H1Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 15c-.28 0-.53.11-.71.29L6 16.59v-5.58c0-.55-.45-1-1-1s-1 .45-1 1v5.58L2.71 15.3c-.18-.18-.43-.3-.71-.3a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 008 15zm8.89-.79v-1.22H11.3v1.3h3.51L11 18.78V20h5.99v-1.3h-3.91l3.81-4.49zM14.97 0h-1.95L9.01 11.01h1.89l.98-2.92h4.17l.98 2.92h1.96L14.97 0zm-2.59 6.63l1.58-4.74H14l1.57 4.74h-3.19z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h6KZH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.01 15c-.28 0-.53.11-.71.29L6 16.59v-5.58c0-.55-.45-1-1-1s-1 .45-1 1v5.58L2.71 15.3c-.18-.18-.43-.3-.71-.3a1.003 1.003 0 00-.71 1.71l3 3a1.014 1.014 0 001.42 0l3-3c.18-.18.29-.43.29-.71.01-.55-.44-1-.99-1zm4.44-5.65l6.4-7.88V0H10.5v1.67h5.91L10 9.44v1.57h9V9.35h-6.55zm1.27 3.64L11 20h1.59l.56-1.56h2.68l.55 1.56h1.64l-2.68-7.01h-1.62zm-.16 4.3l.93-2.57h.02l.9 2.57h-1.85z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imvri":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 8h5c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm0 5h7c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-7c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm0-10h3c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm9 12h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zM7 14c-.28 0-.53.11-.71.29L5 15.59V10c0-.55-.45-1-1-1s-1 .45-1 1v5.59L1.71 14.3A.965.965 0 001 14a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 007 14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzKuJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 15h-3c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm-6-1c-.28 0-.53.11-.71.29L5 15.59V10c0-.55-.45-1-1-1s-1 .45-1 1v5.59L1.71 14.3A.965.965 0 001 14a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 007 14zM19 0h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-4 10h-5c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm2-5h-7c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"vXp1h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 14.99c-.28 0-.53.11-.71.29L7 16.58v-5.59c0-.55-.45-1-1-1s-1 .45-1 1v5.59l-1.29-1.29a.965.965 0 00-.71-.3 1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29.28 0 .53-.11.71-.29l3-3c.18-.18.29-.43.29-.71a.99.99 0 00-1-1zm8.88.23c-.08-.42-.22-.79-.42-1.12-.2-.33-.47-.6-.8-.8-.33-.2-.76-.3-1.28-.3a2.333 2.333 0 00-1.72.71c-.21.22-.37.48-.49.78-.11.3-.17.62-.17.97 0 .27.04.54.13.8.08.26.22.5.4.7.19.21.43.38.71.5a2.142 2.142 0 001.72.02c.25-.12.47-.31.66-.58l.02.02c-.01.19-.04.4-.08.63-.04.24-.11.46-.21.67-.1.21-.23.38-.39.53a.92.92 0 01-.62.22c-.24 0-.44-.08-.6-.25-.16-.17-.27-.36-.31-.59h-1.31c.04.29.12.56.24.79.12.23.28.43.48.59.19.16.42.28.67.36.25.08.52.12.82.12.49 0 .9-.1 1.23-.31.34-.21.61-.48.82-.82.21-.34.37-.71.47-1.13.1-.42.15-.83.15-1.25 0-.43-.04-.85-.12-1.26zm-1.42.63c-.05.15-.11.28-.2.4-.09.12-.2.21-.34.27s-.3.1-.49.1c-.17 0-.33-.04-.46-.11s-.24-.17-.33-.29c-.08-.12-.15-.25-.19-.4-.04-.15-.06-.31-.06-.47 0-.15.02-.3.07-.45.05-.15.11-.28.2-.39.09-.12.2-.21.33-.28.13-.07.27-.11.44-.11.17 0 .33.04.47.11.14.07.25.17.34.28a1.387 1.387 0 01.28.86c.01.17-.02.33-.06.48zM15.32 11H17V0h-1.25c-.05.34-.17.62-.34.85-.17.23-.39.42-.63.57-.25.15-.52.25-.83.31-.3.06-.62.09-.94.09v1.41h2.31V11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"30D9I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 15c-.28 0-.53.11-.71.29L7 16.59v-5.58c0-.55-.45-1-1-1s-1 .45-1 1v5.58L3.71 15.3c-.18-.18-.43-.3-.71-.3a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29.28 0 .53-.11.71-.29l3-3A1.003 1.003 0 009 15zm6.7-1.33a1.5 1.5 0 01-.44.43c-.17.11-.37.19-.58.23-.22.04-.44.06-.67.05v1.07h1.66V20H17v-6.99h-1.06c-.04.26-.12.48-.24.66zm3.15-10.3c-.11-.68-.29-1.26-.55-1.76-.26-.5-.62-.89-1.08-1.18C16.75.14 16.17 0 15.46 0c-.54 0-1.03.09-1.46.27-.43.18-.79.44-1.09.76-.3.33-.52.71-.67 1.15-.16.44-.24.92-.24 1.43 0 .54.08 1.04.23 1.47.15.44.37.81.65 1.12.28.31.61.55 1 .72.39.17.82.26 1.3.26.46 0 .88-.11 1.26-.33.38-.22.68-.53.9-.94l.03.03c-.03.35-.07.74-.12 1.16-.05.42-.15.81-.29 1.18-.14.37-.35.68-.61.92-.26.25-.62.37-1.06.37-.43 0-.77-.13-1.03-.4-.25-.27-.4-.62-.44-1.05h-1.64c.02.43.11.83.29 1.18.17.35.39.66.67.91a3.027 3.027 0 002.07.8c.71 0 1.3-.17 1.79-.5.48-.33.87-.76 1.17-1.29.3-.53.51-1.12.64-1.76.13-.64.19-1.28.19-1.92.01-.77-.05-1.49-.15-2.17zM17.1 4.44c-.08.27-.19.5-.34.71-.15.21-.34.37-.57.49-.23.12-.5.18-.8.18-.3 0-.56-.06-.78-.19-.22-.13-.4-.29-.55-.49-.14-.2-.25-.44-.32-.7-.07-.27-.11-.55-.11-.84 0-.28.04-.55.11-.82.07-.26.18-.49.32-.7.14-.2.33-.36.55-.48.22-.12.48-.17.78-.17.31 0 .57.06.8.18.23.12.42.28.57.48.15.2.26.43.34.69.08.26.11.53.11.82 0 .29-.04.57-.11.84z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"A8cLj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8.89.56l5 10c.06.13.11.28.11.44 0 .55-.45 1-1 1-.39 0-.72-.23-.89-.55L10.88 9H5.12l-1.23 2.44c-.17.33-.5.56-.89.56-.55 0-1-.45-1-1 0-.16.05-.31.12-.44l2.35-4.73.9-1.81L7.11.56C7.28.23 7.61 0 8 0s.72.23.89.56zM6.12 7L8 3.24 9.88 7H6.12zm11.17 4.29a1.003 1.003 0 011.42 1.42l-7 7c-.18.18-.43.29-.71.29-.28 0-.53-.11-.71-.29l-3-3a1.003 1.003 0 011.42-1.42l2.29 2.3 6.29-6.3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lnOO4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 13a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3a1.003 1.003 0 00-1.42 1.42L16.59 9H11V2h5v2c.77 0 1.47.3 2 .78V1c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v3.78C2.53 4.3 3.23 4 4 4V2h5v7H3.41L4.7 7.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L3.41 11H9v7H4v-2c-.77 0-1.47-.3-2-.78V19c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.78c-.53.48-1.23.78-2 .78v2h-5v-7h5.59l-1.29 1.29c-.19.18-.3.43-.3.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iOKMw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 .5a.5.5 0 01.5-.5c.433 0 .5.269.5.269.338-.453.819-.245 1.34-.02.548.236 1.14.492 1.66.02v2.494c-.52.414-1.124.2-1.682.002-.512-.182-.985-.35-1.318-.002V5.02c.329-.013.663-.02 1-.02 1.422 0 2.775.119 4 .333V1.5a.5.5 0 01.5-.5c.433 0 .5.269.5.269.338-.453.819-.245 1.34-.02.548.236 1.14.492 1.66.02v2.494c-.52.414-1.124.2-1.682.002-.512-.182-.985-.35-1.318-.002v1.772c2.989.692 5 1.984 5 3.465 0 .631-.365 1.228-1.016 1.759C18.704 8.662 14.788 7 10 7s-8.703 1.662-8.984 3.759C.366 10.228 0 9.63 0 9c0-.903.748-1.736 2.009-2.405A.502.502 0 012 6.5v-5a.5.5 0 01.5-.5c.433 0 .5.269.5.269.338-.453.819-.245 1.34-.02.548.236 1.14.492 1.66.02v2.494c-.52.414-1.124.2-1.682.002-.512-.182-.985-.35-1.318-.002v2.38c1.35-.53 3.075-.907 5-1.063V.5z",
    "M17.868 11.469A.973.973 0 0018 11c0-.227-.1-.518-.432-.868-.337-.354-.872-.719-1.61-1.047C14.484 8.43 12.378 8 10 8c-2.379 0-4.484.43-5.958 1.085-.738.328-1.273.693-1.61 1.047-.333.35-.432.641-.432.868 0 .134.035.291.132.469C3.962 12.401 6.807 13 10 13c3.193 0 6.037-.599 7.868-1.531z",
    "M10 14c2.856 0 5.488-.461 7.442-1.243C18.47 12.347 19.357 11.644 20 11v6c0 1.343-2.943 2.618-7 3v-1a3 3 0 00-6 0v1c-4.057-.382-7-1.657-7-3v-6c.72.71 1.626 1.384 2.558 1.757C4.512 13.539 7.144 14 10 14z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4BloY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2V2h16v16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dAiSt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v4h4V2zm3 14h2c.55 0 1-.45 1-1v-5h-4v5c0 .55.45 1 1 1zm3-10c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v3h4V6zm-6 1H8v5h4V7zm-9 9h2c.55 0 1-.45 1-1v-3H2v3c0 .55.45 1 1 1zm16 1H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM6 9c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v2h4V9zm3 7h2c.55 0 1-.45 1-1v-2H8v2c0 .55.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a0CNY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 7H5a3 3 0 000 6h10a3 3 0 100-6zM5 5a5 5 0 000 10h10a5 5 0 000-10H5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hIaL6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0l3.1 6.6 6.9 1-5 5.1 1.2 7.3-6.2-3.4L3.8 20 5 12.7 0 7.6l6.9-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6rPM5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M20 7.6l-6.9-1.1L10 0 6.9 6.6 0 7.6l5 5.1L3.8 20l6.2-3.4 6.2 3.4-1.2-7.2 5-5.2zM10 15l-4.5 2.4.9-5.2-3.6-3.6 5-.8L10 3.1l2.2 4.7 5 .8-3.6 3.7.9 5.2L10 15z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a9Zzr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 3c-.23 0-.42.09-.59.21l-.01-.01L8 8V4c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-4l6.4 4.8.01-.01c.17.12.36.21.59.21.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cwgAn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 16H2v-3h4c.55 0 1-.45 1-1V8h3v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V6h2c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1v4h-3V7c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v4H2V3c0-.55-.45-1-1-1s-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1kGEa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 3h-2c-.55 0-1 .45-1 1v4L5.6 3.2l-.01.01C5.42 3.09 5.23 3 5 3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1 .23 0 .42-.09.59-.21l.01.01L12 12v4c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g4HKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 3H4c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f4vSj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 6a6 6 0 106 6h-6V6zm-.998-1.938A1.015 1.015 0 019 4V2H7a1 1 0 110-2h6a1 1 0 010 2h-2v2c0 .02 0 .041-.002.062A8.001 8.001 0 0110 20a8 8 0 01-.998-15.938z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDvi2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 9h-4.46a4.7 4.7 0 00-.4-.14c-.19-.05-.51-.14-.96-.25-.45-.11-.9-.23-1.37-.35-.47-.12-.89-.23-1.27-.33s-.6-.16-.65-.17c-.53-.15-.95-.37-1.27-.66-.32-.28-.49-.68-.49-1.19 0-.36.09-.66.26-.9s.39-.43.65-.57c.26-.14.55-.24.87-.3s.63-.09.93-.09c.89 0 1.63.19 2.21.57.45.3.75.76.89 1.38h2.63c-.06-.52-.2-.98-.42-1.4-.3-.57-.71-1.05-1.23-1.43a5.33 5.33 0 00-1.79-.87c-.7-.2-1.42-.3-2.19-.3-.66 0-1.31.08-1.96.25s-1.22.43-1.73.77-.92.79-1.23 1.32c-.31.52-.46 1.15-.46 1.87 0 .37.05.74.15 1.1.1.36.28.7.53 1.02.18.24.41.47.69.67H2c-.55 0-1 .45-1 1s.45 1 1 1h10.14c.02.01.05.02.07.02.3.11.58.29.84.55.25.26.38.67.38 1.21 0 .27-.06.53-.17.79-.11.26-.29.49-.54.69-.25.2-.57.36-.97.49s-.88.19-1.44.19c-.52 0-1.01-.06-1.45-.17-.45-.11-.84-.29-1.19-.54s-.61-.56-.8-.95c-.05-.08-.09-.18-.12-.28H4.11c.09.43.22.82.4 1.18.33.65.77 1.18 1.32 1.59.55.41 1.2.72 1.94.92.74.2 1.53.3 2.37.3.73 0 1.44-.08 2.14-.25.7-.17 1.33-.43 1.88-.79.55-.36.99-.83 1.33-1.39.34-.56.51-1.25.51-2.05 0-.37-.06-.75-.18-1.12a3.12 3.12 0 00-.15-.39H18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bjAQj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 18H2V2h12.3l2-2H1C.4 0 0 .4 0 1v18c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V7.7l-2 2V18zm1.2-18l-7.6 7.6 2.8 2.8L20 4.8V0h-.8zM4 15.9c3.1.2 5.9.2 8.2-2 1.1-1.1 1.1-3 0-4.1-.6-.5-1.3-.8-2-.8s-1.4.3-1.9.8C7.2 11 6.6 14.3 4 15.9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6knHy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M.224 6.63a1 1 0 111.563-1.248L5 9.4l3.213-4.017A1 1 0 119.776 6.63L6.28 11l3.495 4.369a1 1 0 11-1.563 1.248L5 12.601l-3.213 4.016A1 1 0 11.224 15.37L3.72 11 .224 6.63zm15.8 11.33c.16-.19.34-.38.56-.55.21-.18.449-.36.709-.53.25-.18.5-.36.749-.56.25-.2.49-.41.73-.63.229-.22.439-.47.629-.74.18-.27.33-.56.44-.88.11-.32.159-.67.159-1.07 0-.32-.05-.65-.14-1-.09-.35-.25-.68-.47-.97-.22-.3-.509-.55-.869-.74-.36-.2-.809-.29-1.348-.29-.49 0-.93.1-1.299.29-.37.18-.69.44-.949.78-.26.33-.45.73-.58 1.2-.13.46-.2.96-.2 1.5h1.43c.01-.35.04-.67.09-.97.05-.3.14-.56.25-.78.109-.22.259-.39.449-.52s.43-.19.709-.19c.31 0 .56.06.75.18.189.12.339.26.449.43.11.17.18.36.22.56.04.2.06.39.06.57-.01.38-.1.72-.26 1.02-.15.3-.37.57-.63.83-.26.25-.54.49-.849.71-.31.22-.61.45-.889.68-.6.45-1.059.98-1.409 1.58-.35.61-.519 1.32-.529 2.13h5.984v-1.43h-4.276c.06-.21.17-.42.33-.61z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5yET9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.024 7.96c.16-.19.34-.38.56-.55.21-.18.449-.36.709-.53.25-.18.5-.36.749-.56.25-.2.49-.41.73-.63.229-.22.439-.47.629-.74.18-.27.33-.56.44-.88C19.95 3.75 20 3.4 20 3c0-.32-.05-.65-.14-1-.09-.35-.25-.68-.47-.97-.22-.3-.509-.55-.869-.74-.36-.2-.809-.29-1.348-.29-.49 0-.93.1-1.299.29-.37.18-.69.44-.949.78-.26.33-.45.73-.58 1.2-.13.46-.2.96-.2 1.5h1.43c.01-.35.04-.67.09-.97.05-.3.14-.56.25-.78.109-.22.259-.39.449-.52s.43-.19.709-.19c.31 0 .56.06.75.18.189.12.339.26.449.43.11.17.18.36.22.56.04.2.06.39.06.57-.01.38-.1.72-.26 1.02-.15.3-.37.57-.63.83-.26.25-.54.49-.849.71-.31.22-.61.45-.889.68-.6.45-1.059.98-1.409 1.58-.35.61-.519 1.32-.529 2.13h5.984V8.57h-4.276c.06-.21.17-.42.33-.61zM.224 6.63a1 1 0 111.563-1.248L5 9.4l3.213-4.017A1 1 0 119.776 6.63L6.28 11l3.495 4.369a1 1 0 11-1.563 1.248L5 12.601l-3.213 4.016A1 1 0 11.224 15.37L3.72 11 .224 6.63z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iVJMr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.02 10c-.01 0-.01 0 0 0H16h.02zM2 6h13.58l-2.29 2.29a1 1 0 00-.3.71 1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-4-4a1.003 1.003 0 00-1.42 1.42L15.58 4H2c-.55 0-1 .45-1 1s.45 1 1 1zm2 4h-.02H4zm14 4H4.42l2.29-2.29a1 1 0 00.3-.71 1.003 1.003 0 00-1.71-.71l-4 4c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L4.42 16H18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jAKij":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.71 5.3l-4-4A.997.997 0 005 1.01c-.28 0-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L4 4.42V18c0 .55.45 1 1 1s1-.45 1-1V4.42l2.29 2.29a1 1 0 00.71.3 1.003 1.003 0 00.71-1.71zM10 3.98c0 .01 0 .01 0 0V4v-.02zm0 12.04c0-.01 0-.01 0 0V16v.02zm9-3.03c-.28 0-.53.11-.71.29L16 15.58V2c0-.55-.45-1-1-1s-1 .45-1 1v13.58l-2.29-2.29a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29.28 0 .53-.11.71-.29l4-4c.18-.18.29-.43.29-.71 0-.56-.45-1.01-1-1.01z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3aRG7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12.293 2.293l1.414 1.414-7.127 7.129a3.5 3.5 0 11-1.415-1.415l7.128-7.128zM16.5 9a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm-13 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm13 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"148VM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 4.01a6 6 0 100 12 6 6 0 100-12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iqw7M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 8.01h-3v-3c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v3H5c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h3v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-3h3c.55 0 1-.45 1-1v-2c0-.56-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lacUK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 10.01c0-.21-.08-.39-.18-.54l.02-.01-4-6-.02.01c-.18-.28-.47-.46-.82-.46s-.64.18-.82.45l-.01-.01-4 6 .02.01c-.11.16-.19.34-.19.55s.08.39.18.54l-.02.01 4 6 .02-.01c.18.27.47.46.82.46s.64-.19.82-.46l.02.01 4-6-.02-.01c.1-.16.18-.34.18-.54z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1UOT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 5H4c-.5 0-1 .5-1 1v8c0 .5.5 1 1 1h12c.5 0 1-.5 1-1V6c0-.5-.5-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8vbS6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 4.01H5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-10c0-.56-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Ks1R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 5c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1 0 .16.05.31.11.44H4.1l5 10h.01c.17.33.5.56.89.56s.72-.23.89-.56h.01l5-10h-.01c.06-.13.11-.28.11-.44z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bkVmP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.89 14.56l-4.99-10h-.01c-.17-.33-.5-.56-.89-.56s-.72.23-.89.56H9.1l-5 10h.01c-.06.13-.11.28-.11.44 0 .55.45 1 1 1h10c.55 0 1-.45 1-1 0-.16-.05-.31-.11-.44z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bJLKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.146.854a.5.5 0 01.708-.708l4 4a.5.5 0 01-.708.708l-.646-.647L17.207 5.5l1.647 1.646a.5.5 0 01-.708.708l-.646-.647-1.146 1.146-7.5 7.5a.5.5 0 01-.708 0l-.646-.646-2.646 2.647a.5.5 0 01-.708 0l-.646-.647-2.646 2.647a.5.5 0 01-.708-.708L2.793 16.5l-.647-.646a.5.5 0 010-.708L4.793 12.5l-.647-.646a.5.5 0 010-.708l7.5-7.5L12.794 2.5l-.647-.646a.5.5 0 01.708-.708L14.5 2.793 15.793 1.5l-.647-.646zM12.707 4l.793-.793L16.793 6.5 16 7.293 12.707 4zm2.586 4l-.793.793-1.646-1.647a.5.5 0 00-.708.708L13.793 9.5 12.5 10.793l-1.646-1.647a.5.5 0 00-.708.708l1.647 1.646-1.293 1.293-1.646-1.647a.5.5 0 00-.708.708L9.793 13.5 8.5 14.793 5.207 11.5 12 4.707 15.293 8zM3.207 15.5L5.5 13.207 6.793 14.5 4.5 16.793 3.207 15.5zM16.5 2.207L17.793 3.5 16.5 4.793 15.207 3.5 16.5 2.207z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8xpZu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 1H1c-.6 0-1 .5-1 1v16c0 .5.4 1 1 1h8a4.976 4.976 0 01-.9-2H8v-1c-.364 0-.706-.098-1-.269V17H2v-3h4c0-.362.095-.704.264-1H2v-3h5v2.166l1-1V10h4v1.166l.129.128c.164-.433.475-.795.871-1.025V10h5v1.999c.628.836 1 1.875 1 3.001.364 0 .706.098 1 .269V2c0-.5-.5-1-1-1zM7 9H2V6h5v3zm5 0H8V6h4v3zm6 0h-5V6h5v3z",
    "M18 16.59V15c0-2.21-1.79-4-4-4-.55 0-1 .45-1 1s.45 1 1 1c1.1 0 2 .9 2 2v1.59l-.29-.3a1.003 1.003 0 00-1.42 1.42l2 2c.18.18.43.29.71.29.28 0 .53-.11.71-.29l2-2A1.003 1.003 0 0019 16c-.28 0-.53.11-.71.3l-.29.29zm-9-2.18V16c0 2.21 1.79 4 4 4 .55 0 1-.45 1-1s-.45-1-1-1c-1.1 0-2-.9-2-2v-1.59l.29.3a1.003 1.003 0 001.42-1.42l-2-2A.997.997 0 0010 11c-.28 0-.53.11-.71.29l-2 2A1.003 1.003 0 008 15c.28 0 .53-.11.71-.3l.29-.29z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfttO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 4a2 2 0 012-2h4.588a2 2 0 011.414.586l7.41 7.41a2 2 0 010 2.828l-4.588 4.588a2 2 0 01-2.829 0l-7.41-7.41A2 2 0 012 8.588V4zm3.489-.006a1.495 1.495 0 100 2.99 1.495 1.495 0 000-2.99z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9fxUi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0V6h-2a1 1 0 110-2h2V2a1 1 0 011-1z",
    "M10.81 3.393A2 2 0 0012 7h1v1a2 2 0 003.607 1.19l.804.805a2 2 0 010 2.829l-4.587 4.588a2 2 0 01-2.829 0l-7.41-7.41A2 2 0 012 8.588V4a2 2 0 012-2h4.588a2 2 0 011.414.586l.807.807zM3.993 5.489a1.495 1.495 0 102.99 0 1.495 1.495 0 00-2.99 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67HWU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.293 1.293c.39-.39 1.03-.39 1.42 0l2.98 2.966c.41.41.41 1.072 0 1.482l-2.98 2.966c-.39.39-1.03.39-1.42 0a1 1 0 010-1.413L16.592 5l-2.3-2.294a1 1 0 010-1.413z",
    "M11.713 1.293l2.98 2.966c.41.41.41 1.072 0 1.482l-2.98 2.966c-.39.39-1.03.39-1.42 0a1 1 0 010-1.413L12.593 5l-2.3-2.294a1 1 0 010-1.413c.39-.39 1.03-.39 1.42 0z",
    "M16.625 9.21l.786.785a2 2 0 010 2.829l-4.587 4.588a2 2 0 01-2.829 0l-7.41-7.41A2 2 0 012 8.588V4a2 2 0 012-2h4.588A2 2 0 019 2.043c.011.497.206.99.585 1.37h.001L11.176 5l-1.59 1.586-.001.002a2 2 0 000 2.825c.78.782 2.053.782 2.834.002l.001-.002.709-.705a2.007 2.007 0 003.29.707l.001-.002.205-.204zM3.994 5.488a1.495 1.495 0 102.99 0 1.495 1.495 0 00-2.99 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hCvxA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13.29 7.29a1.003 1.003 0 011.42 1.42l-.3.29H16c.55 0 1-.45 1-1s.45-1 1-1 1 .45 1 1c0 1.66-1.34 3-3 3h-1.59l.3.29a1.003 1.003 0 01-1.42 1.42l-2-2A.997.997 0 0111 10c0-.28.11-.53.29-.71l2-2zm3.42-.58a1.003 1.003 0 01-1.42-1.42l.3-.29H14c-.55 0-1 .45-1 1s-.45 1-1 1-1-.45-1-1c0-1.66 1.34-3 3-3h1.59l-.3-.29a1.003 1.003 0 011.42-1.42l2 2c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2 2z",
    "M10.893 3.477A3.985 3.985 0 0010 6c0 .854.539 1.585 1.294 1.871l-.711.712A1.997 1.997 0 0010 10c0 .548.217 1.052.583 1.417l2 2A2.003 2.003 0 0016 12c.728 0 1.41-.193 1.996-.532-.014.493-.209.98-.584 1.356l-4.588 4.588a2 2 0 01-2.829 0l-7.41-7.41A2 2 0 012 8.588V4a2 2 0 012-2h4.588a2 2 0 011.414.586l.892.891zm-6.9 2.012a1.495 1.495 0 102.99 0 1.495 1.495 0 00-2.99 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Qkvf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 2a1 1 0 011-1c1.66 0 3 1.34 3 3s-1.34 3-3 3h-1.59l.3.29a1.003 1.003 0 01-1.42 1.42l-2-2A.997.997 0 0111 6c0-.28.11-.53.29-.71l2-2a1.003 1.003 0 011.42 1.42l-.3.29H16c.55 0 1-.45 1-1s-.45-1-1-1a1 1 0 01-1-1z",
    "M15.932 8.516l1.48 1.48a2 2 0 010 2.828l-4.588 4.588a2 2 0 01-2.829 0l-7.41-7.41A2 2 0 012 8.588V4a2 2 0 012-2h4.588a2 2 0 011.414.586l1.289 1.289-.708.708A1.997 1.997 0 0010 6c0 .548.217 1.052.583 1.417l2 2a2.004 2.004 0 003.35-.9zM3.994 5.49a1.495 1.495 0 102.99 0 1.495 1.495 0 00-2.99 0z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"W3c9s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 3a2 2 0 012-2h4.588a2 2 0 011.414.586l7.41 7.41a2 2 0 010 2.828l-4.588 4.588a2 2 0 01-2.829 0l-7.41-7.41A2 2 0 013 7.588V3zm3.489-.006a1.495 1.495 0 100 2.99 1.495 1.495 0 000-2.99z",
    "M2 4.689l-.732 1.258c-.265.457-.337 1-.2 1.51l2.717 10.068a2.005 2.005 0 002.453 1.407l4.785-1.274a2.996 2.996 0 01-.735-.54L2.878 9.71A3 3 0 012 7.588v-2.9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3O2JC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 7c.28 0 .53-.11.71-.29l5-5A1.003 1.003 0 009.29.29l-5 5A1.003 1.003 0 005 7zm6 6a1.003 1.003 0 001.71.71l5-5a1.003 1.003 0 00-1.42-1.42l-5 5c-.18.18-.29.43-.29.71zm8 5h-1c0-.55-.45-1-1-1h-7c-.55 0-1 .45-1 1H8c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm-9-6l6-6-1.29-1.29a1.003 1.003 0 00-1.42-1.42L12 2 6 8l1.29 1.29-7 7a1.003 1.003 0 001.42 1.42l7-7L10 12z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ztf7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3.956 4.47A1 1 0 014.804 4h6.392a1 1 0 01.848.47L13 6h5a1 1 0 010 2h-5v1h4a3 3 0 110 6H3a3 3 0 010-6V6.287a1 1 0 01.152-.53l.804-1.287zM3 11h14a1 1 0 110 2H3a1 1 0 110-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dvOoU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 5a1 1 0 012 0v3a1 1 0 01-2 0V5zM12 9a1 1 0 000 2h3a1 1 0 000-2h-3zM4 10a1 1 0 011-1h3a1 1 0 010 2H5a1 1 0 01-1-1zM10 11a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1z",
    "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9QeWE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 9h-.33l.33 1v.5c0 .15-.03.3-.07.44h.01L17 17.23v.27c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5V17H6v.5c0 .83-.67 1.5-1.5 1.5S3 18.33 3 17.5v-.27l-1.93-6.28h.01c-.05-.15-.08-.3-.08-.45V10s.02-.06.05-.16c.06-.17.16-.47.28-.84H1c-.55 0-1-.45-1-1s.45-1 1-1h1l1-3h-.01v-.01c.25-.64 1-1.31 1.67-1.5 0 0 .78-.21 2.33-.36V1c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1.13c1.55.14 2.33.36 2.33.36.67.19 1.42.86 1.67 1.5V4H17l1 3h1c.55 0 1 .45 1 1s-.45 1-1 1zM3 11.5c0 .83.67 1.5 1.5 1.5S6 12.33 6 11.5 5.33 10 4.5 10 3 10.67 3 11.5zM16 7l-1-3H5L4 7v1h12V7zm-.5 3c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kTOJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17.691 15.328c-.456-1.056-2.68-1.752-4.154-2.408-1.48-.656-1.272-1.048-1.328-1.592-.008-.072-.008-.152-.016-.232.504-.448.92-1.064 1.192-1.776 0 0 .016-.04.016-.048.056-.152.104-.312.152-.48.337-.072.537-.44.609-.784.08-.136.232-.48.2-.864-.048-.496-.248-.728-.472-.824v-.088c0-.632-.056-1.544-.177-2.144a3.64 3.64 0 00-1.393-2.352C11.69 1.256 10.8 1 10.009 1c-.792 0-1.68.256-2.313.736a3.64 3.64 0 00-1.393 2.352c-.112.6-.176 1.512-.176 2.144v.08c-.232.088-.44.32-.488.832-.032.384.12.728.2.864.08.352.28.728.633.784.04.168.096.328.152.48 0 .008.008.024.008.032l.008.016c.272.728.696 1.352 1.216 1.8 0 .072-.008.144-.016.208-.056.544.104.936-1.376 1.592-1.481.656-3.698 1.352-4.154 2.408C1.853 16.384 2 19 2 19h16s.147-2.616-.309-3.672z",
    "M1.34 15.15c-.148.302-.34.693-.34 3.85H0v-4c0-1.3.851-2.103 1.905-2.57 1.149-.51 1.168-.837 1.192-1.236a3.63 3.63 0 01.012-.157c.007-.056.014-.119.014-.182-.455-.392-.826-.938-1.064-1.575l-.007-.014c0-.004-.002-.009-.004-.014l-.001-.005a3.684 3.684 0 01-.135-.43c-.308-.048-.484-.377-.554-.685a1.372 1.372 0 01-.175-.756c.042-.448.224-.651.428-.728v-.07c0-.553.056-1.351.154-1.876a3.186 3.186 0 011.218-2.058C3.536 2.224 4.313 2 5.007 2c.327 0 .673.05 1.005.147a4.527 4.527 0 00-.505 1.121 4.388 4.388 0 00-.139.612 14.146 14.146 0 00-.184 1.94c-.286.305-.45.729-.497 1.217v.009c-.045.541.12 1.007.254 1.277.064.227.167.479.33.707.102.141.238.287.41.406.01.027.018.053.026.079.017.056.034.11.064.17.264.688.647 1.311 1.128 1.818-.01.151-.03.186-.159.277-.13.092-.343.214-.686.366-.24.106-.538.228-.858.36-.545.223-1.157.474-1.664.721a7.408 7.408 0 00-1.222.725c-.358.271-.721.63-.924 1.098-.014.034-.03.066-.046.1zM13.946 12.146h.002c.282.126.59.253.924.39h.003l.27.112c.43.177.888.37 1.32.579.427.208.857.447 1.223.724.359.271.75.73.953 1.2C18.792 15.5 19 16 19 19h1v-4c0-1.274-.875-2.111-1.905-2.57-1.123-.498-1.136-.822-1.15-1.209a2.942 2.942 0 00-.012-.184 1.578 1.578 0 01-.007-.088v-.013a2.106 2.106 0 00-.007-.102 3.978 3.978 0 001.043-1.554s.014-.035.014-.042c.05-.133.091-.273.133-.42.294-.063.47-.385.532-.686.07-.119.204-.42.176-.756-.043-.434-.218-.637-.414-.721v-.077c0-.553-.049-1.351-.154-1.876a3.186 3.186 0 00-1.219-2.058C16.478 2.224 15.7 2 15.008 2c-.327 0-.672.05-1.004.146.219.35.39.727.506 1.122.056.187.106.392.138.606.112.574.17 1.346.186 1.97.273.301.433.713.48 1.19v.012c.045.537-.118 1-.251 1.271a2.226 2.226 0 01-.32.696c-.097.14-.228.285-.395.406l-.01.03a5.65 5.65 0 01-1.19 2.025v.04l.001.018c.002.051.003.103.01.153.033.039.195.198.788.461z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ix2fc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 0a2 2 0 00-2 2v10.535a4 4 0 104 0V2a2 2 0 00-2-2zM3 2.5a.5.5 0 01.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zM3.5 8a.5.5 0 000 1h4a.5.5 0 000-1h-4zM5 5.5a.5.5 0 01.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm.5 5.5a.5.5 0 000 1h2a.5.5 0 000-1h-2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eAL6X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 17c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1-.45 1-1-.45-1-1-1c-.77 0-1.47.3-2 .78-.53-.48-1.23-.78-2-.78-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1v12c0 .55-.45 1-1 1s-1 .45-1 1 .45 1 1 1c.77 0 1.47-.3 2-.78.53.48 1.23.78 2 .78.55 0 1-.45 1-1s-.45-1-1-1zm-4-4H2V7h10V5H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h11v-2zm7-8h-3v2h2v6h-2v2h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2lyIn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 1H1c-.6 0-1 .5-1 1v16c0 .5.4 1 1 1h18c.5 0 1-.5 1-1V2c0-.5-.5-1-1-1zM7 17H2v-3h5v3zm0-4H2v-3h5v3zm0-4H2V6h5v3zm11 8H8v-3h10v3zm0-4H8v-3h10v3zm0-4H8V6h10v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i8RZb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1a1 1 0 012 0v2h2a1 1 0 010 2h-2v2a1 1 0 01-2 0V5h-2a1 1 0 010-2h2V1z",
    "M19 7v11a1 1 0 01-1 1H1a1 1 0 01-1-1V2c0-.5.4-1 1-1h12a3 3 0 00-2.236 5H8v3h5.764a2.993 2.993 0 003.314.8l.09-.036A3 3 0 0019 7zm-3 3H8v3h9v-3h-1zM7 9V6H2v3h5zm-5 1v3h5v-3H2zm0 4v3h5v-3H2zm15 0H8v3h9v-3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gXuXJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5.3 13.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3l3-3c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-3-3C6.5 7.1 6.3 7 6 7c-.6 0-1 .4-1 1 0 .3.1.5.3.7L6.6 10H1c-.6 0-1 .4-1 1s.4 1 1 1h5.6l-1.3 1.3zM19 1H3c-.5 0-1 .5-1 1v6h1c0-1.7 1.3-3 3-3 .8 0 1.6.3 2.1.9l.1.1H9v.8l1 1V6h8v3h-6.8c.3.3.5.6.6 1H18v3h-6.8l-.1.1-.9.9H18v3h-8v-2.8l-1 1V17H4v-.8c-.6-.5-1-1.3-1-2.2H2v4c0 .5.5 1 1 1h16c.6 0 1-.5 1-1V2c0-.5-.5-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffILc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14.25 1H19c.5 0 1 .5 1 1v16c0 .5-.5 1-1 1h-7.221l.278-2H18v-3h-5.527l.14-1H18v-3h-4.971l.139-1H18V6h-4.416l.637-4.587c.02-.139.03-.277.03-.413zM8.221 1l-.694 5H2v3h5.11l-.139 1H2v3h4.555l-.14 1H2v3h3.999l-.22 1.587c-.02.139-.03.277-.03.413H1c-.6 0-1-.5-1-1V2c0-.5.4-1 1-1h7.221zM10.26.862a1 1 0 011.98.276l-2.5 18a1 1 0 01-1.98-.276l2.5-18z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Gzq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17.333 10l1.435-1.722a1 1 0 00.232-.64V4.85l1-.9V18c0 .5-.5 1-1 1H1c-.6 0-1-.5-1-1V2c0-.5.4-1 1-1h6.722L12 4.85V6H8v3h4v1H8v3h10v-3h-.667zM7 17v-3H2v3h5zm0-4v-3H2v3h5zm0-4V6H2v3h5zm11 8v-3H8v3h10z",
    "M19.35 0a.642.642 0 01.46 1.1l-3.03 3.03v2.95c0 .18-.07.34-.19.46l-1.28 1.29c-.11.1-.27.17-.45.17-.35 0-.64-.29-.64-.64V4.13L11.19 1.1a.642.642 0 01.45-1.1h7.71z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"RlB5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 1H1c-.6 0-1 .5-1 1v16c0 .5.4 1 1 1h18c.5 0 1-.5 1-1V2c0-.5-.5-1-1-1zm-1 16H2v-3h16v3zm0-4H2v-3h16v3zm0-4H2V6h16v3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"caSzB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 0a1 1 0 00-1 1v2h-2a1 1 0 000 2h2v2a1 1 0 002 0V5h2a1 1 0 000-2h-2V1a1 1 0 00-1-1z",
    "M17.168 9.764A3 3 0 0019 7v11a1 1 0 01-1 1H1a1 1 0 01-1-1V2c0-.5.4-1 1-1h12a3 3 0 00-2.236 5H2v3h11.764c.55.614 1.348 1 2.236 1H2v3h15v-3h-1a2.995 2.995 0 001.168-.236zM2 14v3h15v-3H2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lMWF1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 8a1 1 0 011-1h5a1 1 0 010 2H6.414l5.293 5.293a1 1 0 11-1.414 1.414L5 10.414V13a1 1 0 01-2 0V8z",
    "M20 18a1 1 0 01-1 1H1a1 1 0 01-1-1V2c0-.5.4-1 1-1h18a1 1 0 011 1v16zm-2-1V6H2v11h16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aGRFZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15 1a1 1 0 112 0v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0V5h-2a1 1 0 110-2h2V1z",
    "M1 1h12a3 3 0 00-2.236 5H2v11h15V9.83A3.002 3.002 0 0019 7v11a1 1 0 01-1 1H1a1 1 0 01-1-1V2c0-.5.4-1 1-1z",
    "M3 8a1 1 0 011-1h5a1 1 0 010 2H6.414l5.293 5.293a1 1 0 11-1.414 1.414L5 10.414V13a1 1 0 01-2 0V8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iIFB5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 0C3.58 0 0 3.58 0 8a8 8 0 005.856 7.71c.064-.057.129-.109.19-.156.278-.209.595-.383.896-.53.358-.174.81-.358 1.193-.515.206-.084.393-.16.534-.223a3.93 3.93 0 00.203-.095 4.1 4.1 0 01-.305-.45C8.382 13.911 8.19 14 8 14c-.67 0-1.36-1.1-1.73-3h1.252c.047-.296.153-.571.323-.797l.01-.203H6.12C6.05 9.39 6 8.73 6 8s.05-1.39.12-2h3.76l.037.344c.315-.145.65-.242.979-.295L10.89 6h2.76c.027.077.052.155.076.233l.118-.04A3.62 3.62 0 0114.998 6c.247 0 .51.028.772.086A8 8 0 008 0zm5.17 5h-2.44c-.21-1.11-.51-2.03-.91-2.69 1.43.46 2.61 1.43 3.35 2.69zM8 2c.67 0 1.36 1.1 1.73 3H6.27C6.64 3.1 7.33 2 8 2zm-1.82.31c-.4.66-.71 1.58-.91 2.69H2.83a6.025 6.025 0 013.35-2.69zM2 8c0-.7.13-1.37.35-2h2.76C5.04 6.62 5 7.28 5 8s.04 1.38.11 2H2.35C2.13 9.37 2 8.7 2 8zm.83 3h2.44c.21 1.11.51 2.03.91 2.69A6.025 6.025 0 012.83 11z",
    "M13.917 15.209c.21.094.444.19.685.288.912.374 1.927.789 2.188 1.355.31.722.186 1.148.186 1.148H6.026s-.13-.426.186-1.148c.256-.584 1.305-1.011 2.234-1.39.22-.088.432-.175.626-.26.909-.4.923-.662.94-.978.002-.037.004-.076.008-.115l.003-.072c.002-.025.004-.049.004-.073a3.067 3.067 0 01-.839-1.237l-.007-.007a.024.024 0 00-.003-.01 1.757 1.757 0 01-.113-.347c-.234-.042-.372-.296-.427-.537a1.045 1.045 0 01-.137-.598c.034-.35.179-.509.337-.57v-.056c0-.44.034-1.065.117-1.478a2.508 2.508 0 01.962-1.623c.426-.33 1.038-.501 1.58-.501.544 0 1.155.172 1.588.502a2.496 2.496 0 01.963 1.622c.075.413.117 1.045.117 1.478v.062c.15.062.288.22.323.564.02.268-.083.502-.138.598-.048.234-.185.488-.42.537a2.635 2.635 0 01-.116.364 3.094 3.094 0 01-.818 1.224c0 .055 0 .11.007.158.004.048.006.095.007.14.011.311.02.57.907.96z",
    "M14.976 14.57c-.24-.098-.455-.186-.65-.274l-.007-.003a3.801 3.801 0 01-.194-.091c.224-.288.41-.609.554-.946l.001-.002.013-.033c.018-.043.036-.087.052-.13l.011-.027.016-.04c.105-.092.19-.19.256-.284.129-.184.213-.38.265-.563.105-.226.225-.592.192-1.026l-.001-.011-.002-.011a1.855 1.855 0 00-.325-.91 9.924 9.924 0 00-.12-1.246 3.088 3.088 0 00-.106-.474l-.001-.007a3.543 3.543 0 00-.763-1.353c.27-.092.56-.139.83-.139.495 0 1.05.156 1.444.456a2.269 2.269 0 01.875 1.475c.069.375.106.95.106 1.344v.056c.138.056.263.2.294.513.019.244-.075.456-.125.543-.044.213-.169.444-.381.488-.025.1-.056.206-.094.3a2.815 2.815 0 01-.756 1.144c0 .05 0 .1.006.144.004.043.006.086.007.127.01.283.018.518.824.873.192.086.404.172.623.262.83.34 1.752.717 1.99 1.231.28.657.168 1.044.168 1.044h-2.081a3.864 3.864 0 00-.188-.542l-.005-.013-.006-.012c-.183-.397-.491-.681-.76-.88a5.614 5.614 0 00-.896-.522 17.36 17.36 0 00-.916-.4l-.15-.061z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cZkgh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18.55 6.56c-.31-.01-.65-.03-1.02-.06.03 0 .06-.01.09-.01.88-.12 1.68-.63 1.76-1.37.08-.75-.58-1.25-1.46-1.33-.32-.03-.65-.05-.99-.08.59-.19 1.05-.54 1.09-1.2.05-.75-.99-1.32-1.87-1.41-.34-.03-.64-.05-.91-.07h-.11c-.28-.02-.54-.02-.77-.02-3.92-.08-7.29.6-9.36 1.93v7.72c2.67 1.66 5.95 4.61 5.26 7.08-.21.76.39 1.35 1.23 1.26 1.01-.11 1.71-1.18 1.75-2.28.05-1.29-.19-2.59-.62-3.74-.05-.32.01-.65.47-.68.61-.04 1.39-.08 1.99-.1.32 0 .64-.01.94-.03h.01c.52-.03 1-.07 1.42-.12.88-.11 1.69-.6 1.79-1.35.1-.75-.55-1.25-1.44-1.35-.07-.01-.13-.02-.2-.02.21-.02.42-.04.61-.06.88-.11 1.69-.6 1.79-1.35.09-.75-.56-1.31-1.45-1.36zM3 3H0v8h3c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cpUy0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 9H0v8h3c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm16.99 3.09c-.1-.75-.91-1.24-1.79-1.35-.19-.02-.4-.05-.61-.06.07-.01.14-.01.2-.02.88-.1 1.53-.61 1.44-1.35-.1-.74-.91-1.24-1.79-1.35-.42-.05-.9-.09-1.42-.12h-.01l-.94-.03c-.6-.02-1.39-.05-1.99-.1-.45-.03-.51-.36-.47-.68.43-1.15.67-2.45.62-3.74-.04-1.11-.74-2.17-1.75-2.28-.84-.09-1.45.5-1.23 1.26.7 2.47-2.58 5.43-5.25 7.08v7.72c2.08 1.33 5.44 2.01 9.35 1.93.24 0 .49-.01.77-.02h.11c.27-.02.57-.04.91-.07.88-.08 1.92-.66 1.87-1.41-.04-.65-.5-1.01-1.09-1.2.34-.03.67-.05.99-.08.89-.08 1.55-.58 1.46-1.33-.08-.75-.88-1.25-1.76-1.37-.03 0-.06-.01-.09-.01.37-.02.71-.04 1.02-.06.91-.05 1.55-.61 1.45-1.36z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kA3r9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 4c-.28 0-.53.11-.71.29L7 13.59 3.71 10.3A.965.965 0 003 10a1.003 1.003 0 00-.71 1.71l4 4c.18.18.43.29.71.29s.53-.11.71-.29l10-10A1.003 1.003 0 0017 4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4EyuI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 20C4.48 20 0 15.52 0 10S4.48 0 10 0s10 4.48 10 10-4.48 10-10 10zm5-14c-.28 0-.53.11-.71.29L8 12.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29.28 0 .53-.11.71-.29l7-7A1.003 1.003 0 0015 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fmncb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 9.59V4c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L11 9.59zM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gi10s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 16H2V3c0-.55-.45-1-1-1s-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0-13.41l-7.07 7.07-4.3-3.44-.01.01A.987.987 0 007 6c-.24 0-.46.1-.63.24l-.01-.01L3 9.03V15h16V2.59z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"97bJU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 17H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM9 16h2c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1zm6 0h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1zM3 16h2c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"czCb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 5c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1s-1 .5-1 1v2c0 .6.4 1 1 1zm10 0c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1s-1 .5-1 1v2c0 .6.4 1 1 1zm-9 9H4v2h2v-2zM17 3v1c0 1.1-.9 2-2 2s-2-.9-2-2V3H7v1c0 1.1-.9 2-2 2s-2-.9-2-2V3H2c-.5 0-1 .5-1 1v14c0 .5.5 1 1 1h16c.5 0 1-.5 1-1V4c0-.5-.5-1-1-1h-1zM7 17H3v-4h4v4zm0-5H3V8h4v4zm5 5H8v-4h4v4zm0-5H8V8h4v4zm5 5h-4v-4h4v4zm0-5h-4V8h4v4zm-6 2H9v2h2v-2zm5-5h-2v2h2V9z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bsiGI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 16H2v-1.59l5-5 3.29 3.29c.18.19.43.3.71.3s.53-.11.71-.29l7-7a1.003 1.003 0 00-1.42-1.42L11 10.59l-3.29-3.3C7.53 7.11 7.28 7 7 7s-.53.11-.71.29L2 11.59V3c0-.55-.45-1-1-1s-1 .45-1 1v14a.998.998 0 001 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ap2DA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9.86 2S3.98 9.18 3.98 12.17C3.99 15.4 6.78 18 9.96 18c3.18-.01 6.04-2.63 6.03-5.86C15.99 9.05 9.86 2 9.86 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4rswT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M6.97 19c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2h-6v2zm-3-15l3 4v8h6V8l3-4h-12zm5 5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V9zm6-9h-10c-.55 0-1 .45-1 1v2h12V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfzWP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.5 11a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm11.499 1a4 4 0 110 8 4 4 0 010-8zm-11.5 1.571a1.928 1.928 0 100 3.857 1.928 1.928 0 000-3.857zM16 14.667a1.333 1.333 0 100 2.666 1.333 1.333 0 000-2.666zM5.999 0C7.46 0 8.527.668 9 2l.851 4.256c1.433.096 2.82.217 4.147.362V2h2L16 6.862c.962.13 1.886.275 2.767.435.779.141 1.232.614 1.232 1.284L20 13a4.995 4.995 0 00-4-1.997A5.001 5.001 0 0011.099 15h-1.12a5.499 5.499 0 00-5.478-4.994 5.482 5.482 0 00-3.377 1.157H.004v-1.18L0 7.327c-.002-.597.37-1.18.999-1.302V1a1 1 0 011-1h4zm1 2H3v4h.75c1.386.027 2.749.073 4.079.139L6.999 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7IIbi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 18h-2l2 2H4l.12-.12L6 18H4c-1.1 0-2-.9-2-2V2c0-1.1 3.58-2 8-2s8 .9 8 2v14c0 1.1-.9 2-2 2zM5.5 15c.83 0 1.5-.67 1.5-1.5S6.33 12 5.5 12 4 12.67 4 13.5 4.67 15 5.5 15zM9 3H4v6h5V3zm7 0h-5v6h5V3zm-1.5 9c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffKul":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.89 18.56l-4.99-10h-.01c-.17-.33-.5-.56-.89-.56s-.72.23-.89.56h-.01l-1.73 3.46-2.8-2.3 1.99-1.64C11.44 7.34 12 6.23 12 5V4h1c.55 0 1-.45 1-1s-.45-1-1-1H8V1c0-.55-.45-1-1-1S6 .45 6 1v1H1c-.55 0-1 .45-1 1s.45 1 1 1h9v1c0 .62-.28 1.18-.73 1.54L7 8.42 4.73 6.54C4.28 6.18 4 5.62 4 5H2c0 1.23.56 2.34 1.44 3.07l1.99 1.64-3.06 2.52.01.01c-.23.18-.38.45-.38.76 0 .55.45 1 1 1 .24 0 .45-.1.63-.24l.01.01L7 11l3.36 2.77.01-.01c.02.02.05.03.08.05.01 0 .01.01.02.02l-2.36 4.73h.01c-.07.13-.12.28-.12.44 0 .55.45 1 1 1 .39 0 .72-.23.89-.56h.01L11.12 17h5.76l1.22 2.45h.01c.17.32.5.55.89.55.55 0 1-.45 1-1 0-.16-.05-.31-.11-.44zM12.12 15L14 11.24 15.88 15h-3.76z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5eJLT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 1h-5c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1H3c-.55 0-1 .45-1 1v1h16V2c0-.55-.45-1-1-1zm.5 3h-15c-.28 0-.5.22-.5.5s.22.5.5.5H3v14c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V5h.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zM7 16c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8zm4 0c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8zm4 0c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9IVyN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 15.542V20H9v-4.458L2 17l4.5-5.625L4 12l3.655-5.483L6 7l4-7 4 7-1.655-.483L16 12l-2.5-.625L18 17l-7-1.458z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hiTKK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 10c-.55 0-1 .45-1 1v1.37l-6.25-7.03-.01.01A.971.971 0 0011 5c-.23 0-.42.09-.59.21l-.01-.01-3.43 2.58-5.42-3.61-.01.01A.969.969 0 001 4c-.55 0-1 .45-1 1 0 .35.19.64.46.82l-.01.01 6 4 .01-.02c.15.11.33.19.54.19.23 0 .42-.09.59-.21l.01.01 3.26-2.45L16.77 14H15c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kOi17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 4h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.77l-5.91 6.65L7.6 10.2l-.01.01C7.42 10.09 7.23 10 7 10c-.21 0-.39.08-.54.18l-.01-.02-6 4 .01.02c-.27.18-.46.47-.46.82 0 .55.45 1 1 1 .21 0 .39-.08.54-.18l.01.02 5.41-3.61 3.43 2.58.01-.01c.18.11.37.2.6.2.3 0 .56-.14.74-.34l.01.01L18 7.63V9c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Cfo7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 1a1 1 0 011-1h8a1 1 0 011 1v2h4a1 1 0 011 1v2a5 5 0 01-5 5h-.416A5.01 5.01 0 0111 13.9V18h3a1 1 0 110 2H6a1 1 0 110-2h3v-4.1A5.009 5.009 0 015.416 11H5a5 5 0 01-5-5V4a1 1 0 011-1h4V1zm0 4H2v1a3 3 0 003 3V5zm10 4V5h3v1a3 3 0 01-3 3z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"491hQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 0a1 1 0 011 1v11a1 1 0 011 1v3h.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H17v1a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1H6v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-1H1.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H2v-3a1 1 0 011-1V1a1 1 0 112 0v3a2 2 0 012-2h6a2 2 0 012 2V1a1 1 0 011-1zm-4 10H8a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1zm-7 4H4a1 1 0 000 2h1a1 1 0 000-2zm11 0h-1a1 1 0 000 2h1a1 1 0 000-2zm-4.5 0a.5.5 0 110 1h-3l-.09-.008A.5.5 0 018.5 14zm0-1.5a.5.5 0 110 1h-3l-.09-.008a.5.5 0 01.09-.992zm0-1.5a.5.5 0 110 1h-3l-.09-.008A.5.5 0 018.5 11zM14 5H6v3h8V5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCILT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm14.71 9.29l-3-3A1.003 1.003 0 0015 7v6a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM12 0H8c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gXPqm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16.434 0a1 1 0 01.857.486L20 5v14a1 1 0 01-1 1H1a1 1 0 01-1-1V5L2.709.486A1 1 0 013.566 0h12.868zM10 8c-.28 0-.53.11-.71.29l-3 3-.084.096A1.003 1.003 0 007.71 12.71L9 11.41v4.58l.007.116c.058.496.482.884.993.884.55 0 1-.45 1-1v-4.58l1.29 1.29.081.073c.171.139.389.227.629.227a1.003 1.003 0 00.71-1.71l-3-3-.096-.084A1.002 1.002 0 0010 8zm6-6H4L2 5.002h16L16 2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kxi0w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 17c3.3 0 6-2.7 6-6V3.5c0-.8-.7-1.5-1.5-1.5S13 2.7 13 3.5V11c0 1.7-1.3 3-3 3s-3-1.3-3-3V3.5C7 2.7 6.3 2 5.5 2S4 2.7 4 3.5V11c0 3.3 2.7 6 6 6zM16.5 19h-13c-.3 0-.5.2-.5.5s.2.5.5.5h13c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8bSBK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M5 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm9-9H3.41L5.7 2.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C.11 5.47 0 5.72 0 6c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L3.41 7H14c2.21 0 4 1.79 4 4s-1.79 4-4 4H9v2h5c3.31 0 6-2.69 6-6s-2.69-6-6-6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lgu6l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.5 6C2.01 6 0 8.01 0 10.5S2.01 15 4.5 15 9 12.99 9 10.5 6.99 6 4.5 6zm11 0C13.01 6 11 8.01 11 10.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5S17.99 6 15.5 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jwQPY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 11.988v-4H4v-1l1-3h6V2.003a35.867 35.867 0 00-1-.015c-3.593 0-5.332.488-5.332.488-.67.188-1.424.864-1.674 1.503l-.004.009H3l-1 3H1a1 1 0 100 2h.333l-.28.84-.053.16v7.5a1.5 1.5 0 103 0v-.5h12v.5a1.5 1.5 0 103 0v-4.5h-5a1 1 0 01-1-1zm-8.5 1a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM19.83 2.782a2.392 2.392 0 00-.592-.853c-.276-.264-.64-.485-1.09-.663C17.695 1.09 17.132 1 16.457 1c-.523 0-.996.084-1.418.253a3.157 3.157 0 00-1.084.703c-.299.3-.532.656-.698 1.065-.166.41-.254.861-.264 1.353h2.096c0-.246.028-.476.085-.69.057-.214.145-.4.264-.56.119-.16.27-.287.456-.383.185-.095.406-.143.663-.143.38 0 .677.1.89.3.215.2.321.51.321.93.01.245-.035.45-.135.614-.1.164-.23.314-.392.45a8.598 8.598 0 01-.527.41 3.53 3.53 0 00-.542.485c-.171.187-.32.412-.45.676-.127.265-.206.592-.234.984v.614h1.924v-.519c.038-.273.13-.5.278-.683.147-.182.316-.343.506-.484a13.5 13.5 0 01.606-.424c.214-.14.408-.312.584-.512s.323-.442.442-.724.178-.642.178-1.079c0-.264-.059-.548-.178-.854zm-4.54 6.099v2.103h2.237V8.881H15.29z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2GuND":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 0c2.21 0 4 1.79 4 4 0 1.11-.46 2.09-1.18 2.82l.01.01-3 3-.01-.01a4.05 4.05 0 01-2.064 1.107l-.932-.931L17.41 5.41c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2-.55 0-1.05.22-1.41.58L10 7.17l-.927-.926A4.05 4.05 0 0110.18 4.18l-.01-.01 3-3 .01.01C13.91.46 14.89 0 16 0zm-5.296 7.876l1.42 1.42L14.71 6.71a1.003 1.003 0 00-1.42-1.42l-2.586 2.586zM8.583 9.997L5.29 13.29a1.003 1.003 0 001.42 1.42l3.293-3.293.705.705L6.41 16.42l-1 1c-.36.36-.86.58-1.41.58-1.1 0-2-.9-2-2 0-.55.22-1.05.59-1.41l5.293-5.293.7.7zm-.934-.934L3.293 4.707a1 1 0 011.414-1.414l12 12a1 1 0 01-1.414 1.414l-4.356-4.356c.04.21.063.423.063.649 0 1.11-.46 2.09-1.18 2.82l.01.01-3 3-.01-.01C6.09 19.54 5.11 20 4 20c-2.21 0-4-1.79-4-4 0-1.11.46-2.09 1.18-2.82l-.01-.01 3-3 .01.01C4.91 9.46 5.89 9 7 9c.225 0 .438.023.649.063z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1iOaF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 1c-2.21 0-4 1.79-4 4v4H2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-2V5c0-1.1.9-2 2-2s2 .9 2 2v2c0 .55.45 1 1 1s1-.45 1-1V5c0-2.21-1.79-4-4-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d53bh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.77 1.16c-.81.81-.74 2.28.02 3.76L6.1 8.71c-2.17-1.46-4.12-2-4.94-1.18l4.95 4.95-2.12 3.54 3.54-2.12 4.95 4.95c.82-.82.27-2.77-1.19-4.94l3.8-5.69c1.47.76 2.94.84 3.76.02l-7.08-7.08z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5ydUQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.47 12.46c.16-.36.29-.74.38-1.14 0-.02.01-.04.01-.06.09-.4.14-.82.14-1.26 0-.44-.05-.86-.14-1.27 0-.02-.01-.04-.01-.06-.09-.4-.22-.78-.38-1.14-.01-.02-.02-.03-.02-.05a5.94 5.94 0 00-.61-1.03c0-.01-.01-.01-.01-.02a6.308 6.308 0 00-2.1-1.77c-.19-.1-.39-.18-.59-.26-.03-.01-.06-.02-.1-.03-.17-.07-.34-.12-.52-.17-.05-.01-.1-.03-.15-.04a4.34 4.34 0 00-.52-.09c-.05-.01-.11-.02-.17-.03C6.46 4.02 6.23 4 6 4c-3.31 0-6 2.69-6 6s2.69 6 6 6c.23 0 .46-.02.68-.04l.17-.03c.17-.02.34-.06.51-.09.05-.01.1-.03.15-.04.18-.05.36-.1.53-.17l.09-.03a5.973 5.973 0 002.68-2.04c0-.01.01-.01.01-.02.24-.32.44-.66.61-1.03.02-.01.03-.03.04-.05zM14 4c-.99 0-1.91.24-2.73.66a7.51 7.51 0 010 10.68c.82.42 1.74.66 2.73.66 3.31 0 6-2.69 6-6s-2.69-6-6-6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7iB73":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C6.71 0 3.82 1.6 2 4.05V2c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.76C5.22 3.17 7.47 2 10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8c0-.55-.45-1-1-1s-1 .45-1 1c0 5.52 4.48 10 10 10s10-4.48 10-10S15.52 0 10 0zm4 7c-.28 0-.53.11-.71.29L9 11.58 6.71 9.29a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29.28 0 .53-.11.71-.29l5-5A1.003 1.003 0 0014 7z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3OpfV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm4 10c-.28 0-.53-.11-.71-.29L11 7.41V15c0 .55-.45 1-1 1s-1-.45-1-1V7.41l-2.29 2.3a1.003 1.003 0 01-1.42-1.42l4-4c.18-.18.43-.29.71-.29s.53.11.71.29l4 4A1.003 1.003 0 0114 10z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jPU8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M10 0C4.48 0 0 4.48 0 10c0 .33.02.65.05.97.01.12.03.23.05.35.03.2.05.4.09.59.03.14.06.28.1.42l.12.48c.05.16.1.31.15.46.05.13.09.27.15.4.06.16.13.32.21.48.05.11.1.22.16.33.09.17.17.34.27.5.05.09.1.17.15.25.11.18.22.35.34.52.04.06.08.11.12.17 1.19 1.62 2.85 2.86 4.78 3.53l.09.03c.46.15.93.27 1.42.36.08.01.17.03.25.04.49.07.99.12 1.5.12s1.01-.05 1.5-.12c.08-.01.17-.02.25-.04.49-.09.96-.21 1.42-.36l.09-.03c1.93-.67 3.59-1.91 4.78-3.53.04-.05.08-.1.12-.16.12-.17.23-.35.34-.53.05-.08.1-.16.15-.25.1-.17.19-.34.27-.51.05-.11.1-.21.15-.32.07-.16.14-.32.21-.49.05-.13.1-.26.14-.39.05-.15.11-.31.15-.46.05-.16.08-.32.12-.48.03-.14.07-.28.1-.42.04-.19.06-.39.09-.59.02-.12.04-.23.05-.35.05-.32.07-.64.07-.97 0-5.52-4.48-10-10-10zm0 18a7.94 7.94 0 01-6.15-2.89c.84-.44 1.86-.82 2.67-1.19 1.45-.65 1.3-1.05 1.35-1.59.01-.07.01-.14.01-.21-.51-.45-.93-1.08-1.2-1.8l-.01-.01c0-.01-.01-.02-.01-.03a4.42 4.42 0 01-.15-.48c-.33-.07-.53-.44-.61-.79-.08-.14-.23-.48-.2-.87.05-.51.26-.74.49-.83v-.08c0-.63.06-1.55.17-2.15.02-.17.06-.33.11-.5.21-.73.66-1.4 1.26-1.86.62-.47 1.5-.72 2.28-.72.78 0 1.65.25 2.27.73.6.46 1.05 1.12 1.26 1.86.05.16.08.33.11.5.11.6.17 1.51.17 2.15v.09c.22.1.42.33.46.82.04.39-.12.73-.2.87-.07.34-.27.71-.6.78-.04.16-.09.33-.15.48 0 .01-.02.05-.02.05-.26.71-.67 1.33-1.17 1.78 0 .08.01.16.01.23.05.54-.15.94 1.31 1.59.81.36 1.84.74 2.68 1.19A7.958 7.958 0 0110 18z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cplpC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.93 3.79a9.1 9.1 0 012.2-2.27L7.29 1c-1.38.59-2.57 1.33-3.55 2.22C2.46 4.39 1.49 5.72.83 7.23.28 8.51 0 9.81 0 11.12c0 2.28.83 4.57 2.49 6.86l.16-.55c-.49-1.23-.73-2.38-.73-3.44 0-1.67.28-3.46.84-5.36.55-1.9 1.28-3.51 2.17-4.84zm9.38 8.39l-.33-.2c-.37.54-.65.87-.82 1a.74.74 0 01-.42.12c-.19 0-.38-.12-.57-.37-.31-.42-.73-1.59-1.26-3.5.47-.85.86-1.41 1.19-1.67.23-.19.48-.29.74-.29.1 0 .28.04.53.11.26.07.48.11.68.11.27 0 .5-.1.68-.29.18-.19.27-.44.27-.75 0-.33-.09-.58-.27-.77-.18-.19-.44-.29-.78-.29-.3 0-.59.07-.86.22s-.61.47-1.02.97c-.31.37-.77 1.02-1.37 1.94a9.683 9.683 0 00-1.24-3.14l-3.24.59-.06.36c.24-.05.44-.07.61-.07.32 0 .59.14.8.43.33.45.8 1.8 1.39 4.07-.47.64-.78 1.06-.96 1.26-.28.32-.52.53-.7.62-.14.08-.3.11-.48.11-.14 0-.36-.08-.67-.23-.21-.1-.4-.15-.57-.15-.31 0-.57.11-.78.32s-.31.48-.31.8c0 .31.09.55.28.75.19.19.44.29.76.29.31 0 .6-.07.87-.2s.61-.42 1.02-.86c.41-.44.98-1.13 1.7-2.08.28.9.52 1.56.72 1.97.2.41.44.71.7.89.26.18.59.27.99.27.38 0 .77-.14 1.17-.43.54-.36 1.07-1 1.61-1.91zM17.51 1l-.15.54c.49 1.24.73 2.39.73 3.45 0 1.43-.21 2.96-.63 4.6-.33 1.26-.75 2.45-1.27 3.55-.52 1.11-1.02 1.97-1.51 2.6-.49.62-1.09 1.2-1.8 1.72l-.17.53c1.38-.59 2.57-1.34 3.55-2.23 1.29-1.17 2.26-2.5 2.91-4 .55-1.28.83-2.59.83-3.91 0-2.27-.83-4.56-2.49-6.85z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i3bPx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11.286 1.7a.996.996 0 01-.29-.71c0-.55.45-1 1-.99.28 0 .531.11.711.29l3.003 3a1.013 1.013 0 010 1.419l-3.003 2.999a1.003 1.003 0 01-1.712-.71c0-.28.12-.53.3-.71l1.292-1.29H5.001C4.45 4.999 4 4.549 4 4c0-.55.45-1 1-1h7.587l-1.301-1.3zM5.553 10.105a1 1 0 011.341.448L10 16.763l3.106-6.21a1 1 0 011.789.894l-4 8a1 1 0 01-1.79 0l-4-8a1 1 0 01.448-1.341z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9y3Kx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M8 7H7c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zM3 9H2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1zm10-5h-1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm5-4h-1c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5UxLT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M3 0H2c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm5 4H7c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm5 3h-1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm5 2h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hQqKb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 2h18c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1s.45 1 1 1zm2 5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1H3zm16 11H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Vs4Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M0 0h20v1a1 1 0 01-1 1H1a1 1 0 01-1-1V0zm6.293 11.293a.999.999 0 000 1.412l2.962 2.963.038.04A.996.996 0 0010 16a.996.996 0 00.745-.332l2.962-2.963a.999.999 0 00-1.412-1.412L10 13.587l-2.295-2.294a.999.999 0 00-1.412 0zm0-3.998a.999.999 0 101.412 1.412L10 6.413l2.295 2.294a.999.999 0 101.412-1.412l-2.962-2.963A.996.996 0 0010 4a.996.996 0 00-.745.332L6.293 7.295zM20 19v1H0v-1a1 1 0 011-1h18a1 1 0 011 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1YfkS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19 2H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM7 14V6l6 4-6 4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ljCA0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.249 13.835l1.251 1.251.354-.354.087-.077a1 1 0 011.327 1.491l-2.122 2.122-.087.077a1 1 0 01-1.327-1.491l.354-.354-1.251-1.251A6.466 6.466 0 0111 16.424L10.999 18h.501a1 1 0 01.117 1.993L11.5 20h-3a1 1 0 01-.117-1.993L8.5 18h.499v-1.577a6.46 6.46 0 01-2.538-.97L5.414 16.5l.354.354a1 1 0 01-1.327 1.491l-.087-.077-2.122-2.122a1 1 0 011.327-1.491l.087.077.354.354.97-.97a6.472 6.472 0 01-1.384-3.057l-.025.002L2 11.06v.44a1 1 0 01-1.993.117L0 11.5v-3a1 1 0 011.993-.117L2 8.5v.56h1.567A6.471 6.471 0 014.97 5.883l-.971-.969-.353.354-.087.077a1 1 0 01-1.327-1.491l2.122-2.122.087-.077a1 1 0 011.327 1.491l-.354.353 1.047 1.048A6.46 6.46 0 019 3.577L9 2h-.5A1 1 0 018.383.007L8.5 0h3a1 1 0 01.117 1.993L11.5 2H11v1.577a6.466 6.466 0 012.838 1.176l.04-.046L15.086 3.5l-.353-.353a1 1 0 011.327-1.491l.087.077 2.122 2.122a1 1 0 01-1.327 1.491l-.087-.077-.354-.354-1.207 1.207-.046.041a6.467 6.467 0 011.16 2.733H18V8.5a1 1 0 011.993-.117L20 8.5v3a1 1 0 01-1.993.117L18 11.5v-.605h-1.561a6.466 6.466 0 01-1.19 2.94zM12.5 11a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM8 6a2 2 0 100 4 2 2 0 000-4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fa1hP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M15.92 3.93l-1.6 1.18A7.948 7.948 0 0116 10c0 1.84-.63 3.54-1.68 4.89l1.6 1.18A9.878 9.878 0 0018 10c0-2.29-.78-4.39-2.08-6.07zM11 3c-.28 0-.53.11-.71.29L7.59 6H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h4.59l2.71 2.71c.17.18.42.29.7.29.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8b3np":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M14 3c-.28 0-.53.11-.71.29L10.59 6H6c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h4.59l2.71 2.71c.17.18.42.29.7.29.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jW0i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M9 3.43c-.28 0-.53.11-.71.29l-2.7 2.71H1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h4.59l2.71 2.71a1.003 1.003 0 001.71-.71v-12c-.01-.55-.46-1-1.01-1zm8.31-1.56l-1.62 1.2C17.14 5.16 18 7.69 18 10.43s-.86 5.27-2.31 7.37l1.62 1.2C19 16.57 20 13.62 20 10.43c0-3.18-1-6.13-2.69-8.56zm-3.39 2.49l-1.6 1.18A7.948 7.948 0 0114 10.43c0 1.84-.63 3.54-1.68 4.89l1.6 1.18A9.94 9.94 0 0016 10.43c0-2.28-.78-4.38-2.08-6.07z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2e010":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M16 10h-2c-.23 0-.42-.09-.59-.21l-.01.01-1.69-1.27-.63 3.14 2.62 2.62c.19.18.3.43.3.71v4c0 .55-.45 1-1 1s-1-.45-1-1v-3.59L9.39 12.8l-2.45 6.55h-.01c-.14.38-.5.65-.93.65-.55 0-1-.45-1-1 0-.12.03-.24.07-.35h-.01L9.43 7h-2.9l-1.7 2.55-.01-.01c-.18.27-.47.46-.82.46-.55 0-1-.45-1-1 0-.21.08-.39.18-.54l-.01-.01 2-3 .02.01C5.36 5.19 5.65 5 6 5h4.18l.36-.96c-.33-.43-.54-.96-.54-1.54a2.5 2.5 0 015 0A2.5 2.5 0 0112.5 5c-.06 0-.12-.01-.18-.02l-.44 1.18L14.33 8H16c.55 0 1 .45 1 1s-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lCWts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.86 17.52l.01-.01-9-16-.01.01C10.69 1.21 10.37 1 10 1s-.69.21-.86.52l-.01-.01-9 16 .01.01c-.08.14-.14.3-.14.48 0 .55.45 1 1 1h18c.55 0 1-.45 1-1 0-.18-.06-.34-.14-.48zM11 17H9v-2h2v2zm0-3H9V6h2v8z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2EpkS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M13 7h2c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm-9 8h1c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm4-6h2c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm11-5h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0 12H2V3c0-.55-.45-1-1-1s-1 .45-1 1v14a.998.998 0 001 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gBSpY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4.948 2.682a1 1 0 00-1.897.001l-.005.016-.027.074a6.05 6.05 0 01-.6 1.172C1.958 4.635 1.468 5 .999 5a1 1 0 000 2c1.457 0 2.442-1.027 3-1.825C4.558 5.973 5.543 7 7 7s2.442-1.027 3-1.825C10.558 5.973 11.543 7 13 7s2.442-1.027 3-1.825C16.558 5.973 17.544 7 19 7a1 1 0 100-2c-.47 0-.958-.365-1.418-1.055a6.048 6.048 0 01-.628-1.246l-.006-.016a1 1 0 00-1.896 0l-.006.016a5.868 5.868 0 01-.147.364c-.11.246-.272.568-.481.882C13.958 4.635 13.469 5 13 5c-.47 0-.958-.365-1.418-1.055a6.048 6.048 0 01-.628-1.246l-.006-.016a1 1 0 00-1.897 0l-.005.016-.027.074a6.05 6.05 0 01-.6 1.172C7.958 4.635 7.468 5 6.999 5c-.47 0-.958-.365-1.418-1.055A6.05 6.05 0 014.954 2.7l-.006-.016v-.001zm0 6a1 1 0 00-1.897.001l-.005.016-.027.074a6.05 6.05 0 01-.6 1.172c-.46.69-.95 1.055-1.419 1.055a1 1 0 100 2c1.457 0 2.442-1.027 3-1.825C4.558 11.973 5.543 13 7 13s2.442-1.027 3-1.825c.558.798 1.543 1.825 3 1.825s2.442-1.027 3-1.825c.558.798 1.544 1.825 3 1.825a1 1 0 100-2c-.47 0-.958-.365-1.418-1.055a6.048 6.048 0 01-.628-1.246l-.006-.016a1 1 0 00-1.896 0l-.006.016a5.868 5.868 0 01-.147.364c-.11.246-.272.568-.481.882-.46.69-.949 1.055-1.418 1.055-.47 0-.958-.365-1.418-1.055a6.048 6.048 0 01-.628-1.246l-.006-.016a1 1 0 00-1.897 0l-.005.016-.027.074a6.05 6.05 0 01-.6 1.172c-.46.69-.95 1.055-1.419 1.055-.47 0-.958-.365-1.418-1.055A6.05 6.05 0 014.954 8.7l-.006-.016zm-1.896-6zm1.896 12l.006.017.027.074a6.053 6.053 0 00.6 1.172c.46.69.95 1.055 1.419 1.055.47 0 .958-.365 1.418-1.055a6.053 6.053 0 00.628-1.246l.005-.016a1 1 0 011.897 0l.006.016.027.074a6.051 6.051 0 00.6 1.172c.46.69.95 1.055 1.419 1.055.47 0 .958-.365 1.418-1.055a6.051 6.051 0 00.628-1.246l.006-.016a1 1 0 011.896 0l.006.016.027.074a6.051 6.051 0 00.6 1.172c.46.69.95 1.055 1.419 1.055a1 1 0 110 2c-1.456 0-2.442-1.027-3-1.825-.558.798-1.543 1.825-3 1.825s-2.442-1.027-3-1.825C9.442 17.973 8.457 19 7 19s-2.442-1.027-3-1.825C3.442 17.973 2.457 19 1 19a1 1 0 110-2c.47 0 .958-.365 1.418-1.055a6.053 6.053 0 00.628-1.246l.005-.016a1 1 0 011.897-.001z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jEDpf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M18 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm15-1h2V5h-2v10zM3 5H1v10h2V5zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm3 3h10V1H5v2zm13 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM5 19h10v-2H5v2z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kqW43":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 4h18c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1zm1 2v8h16V6H2zm4 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9CFWS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 0H3c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H4v-4h12v4zm0-5H4V2h12v11z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XHo2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M17 0H3c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H4V7h12v11zm0-12H4V2h12v4z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7I14p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M12 6a3 3 0 113 3H4a1 1 0 000 2h11a5 5 0 10-5-5 1 1 0 102 0zM1 12a1 1 0 100 2h10a2 2 0 110 4c-.934 0-1.803-.614-2.057-1.333a1 1 0 10-1.886.666C7.627 18.944 9.321 20 11 20a4 4 0 000-8H1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fOUn4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.8 4.44L16.13 8.1l-3.55-.71-.71-3.53L15.54.21c-2.01-.53-4.23-.03-5.8 1.53-1.86 1.85-2.23 4.6-1.14 6.83L.59 16.59C.22 16.95 0 17.45 0 18a2 2 0 002 2c.55 0 1.05-.22 1.41-.59l8.03-8.04c2.23 1.05 4.97.67 6.82-1.16 1.57-1.56 2.07-3.77 1.54-5.77z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8bRtf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M4 9C2.34 9 1 7.66 1 6s1.34-3 3-3h1.59l-.3-.29a1.003 1.003 0 011.42-1.42l2 2c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2 2a1.003 1.003 0 01-1.42-1.42l.3-.29H4c-.55 0-1 .45-1 1s.45 1 1 1a1 1 0 110 2zm9.5 7c-.821 0-1.6-.18-2.3-.503l-2.944 2.944a1.907 1.907 0 01-2.697-2.697L8.503 12.8a5.5 5.5 0 017.68-7.103l-3.744 3.742a1.5 1.5 0 102.122 2.122l3.742-3.743A5.5 5.5 0 0113.5 16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avynk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M2 1h4a1 1 0 01.775 1.632L4.08 6H6a1 1 0 010 2H2a1 1 0 01-.771-1.636L3.919 3H2a1 1 0 010-2zm11.5 15c-.821 0-1.6-.18-2.3-.503l-2.944 2.944a1.907 1.907 0 01-2.697-2.697L8.503 12.8a5.5 5.5 0 017.68-7.103l-3.744 3.742a1.5 1.5 0 102.122 2.122l3.742-3.743A5.5 5.5 0 0113.5 16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7G44s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 4.5C1 2.57 2.57 1 4.5 1S8 2.57 8 4.5 6.43 8 4.5 8 1 6.43 1 4.5zm3-2v2.21l1.56 1.56c.1.09.23.14.36.14.12 0 .25-.05.35-.14.19-.2.19-.51 0-.71L5 4.29V2.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5zM13.5 16c-.821 0-1.6-.18-2.3-.503l-2.944 2.944a1.907 1.907 0 01-2.697-2.697L8.503 12.8a5.5 5.5 0 017.68-7.103l-3.744 3.742a1.5 1.5 0 102.122 2.122l3.742-3.743A5.5 5.5 0 0113.5 16z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"601Ob":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M19.56 17.44l-4.94-4.94A8.004 8.004 0 0016 8c0-4.42-3.58-8-8-8S0 3.58 0 8s3.58 8 8 8c1.67 0 3.21-.51 4.5-1.38l4.94 4.94a1.498 1.498 0 102.12-2.12zM8 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm3-7H9V5c0-.55-.45-1-1-1s-1 .45-1 1v2H5c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V9h2c.55 0 1-.45 1-1s-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"keNMe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M11 7H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm8.56 10.44l-4.94-4.94A8.004 8.004 0 0016 8c0-4.42-3.58-8-8-8S0 3.58 0 8s3.58 8 8 8c1.67 0 3.21-.51 4.5-1.38l4.94 4.94a1.498 1.498 0 102.12-2.12zM8 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3InJX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "M1 7c.55 0 1-.45 1-1V2h4c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v5c0 .55.45 1 1 1zm5 1a1.003 1.003 0 00-1.71-.71l-2 2c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L4.41 10 5.7 8.71c.19-.18.3-.43.3-.71zm2-2c.28 0 .53-.11.71-.29L10 4.41l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-2-2C10.53 2.11 10.28 2 10 2s-.53.11-.71.29l-2 2A1.003 1.003 0 008 6zM6 18H2v-4c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm8-6a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l1.3 1.29-1.29 1.29c-.19.18-.3.43-.3.71zm5-12h-5c-.55 0-1 .45-1 1s.45 1 1 1h4v4c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm-7 14c-.28 0-.53.11-.71.29L10 15.59 8.71 14.3A.965.965 0 008 14a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 0012 14zm7-1c-.55 0-1 .45-1 1v4h-4c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1z"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kknia":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconSize", ()=>IconSize);
var IconSize;
(function(IconSize) {
    IconSize[IconSize["STANDARD"] = 16] = "STANDARD";
    IconSize[IconSize["LARGE"] = 20] = "LARGE";
})(IconSize || (IconSize = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"34sEn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icons", ()=>Icons);
var _tslib = require("tslib");
var _iconNames = require("./iconNames");
var _iconTypes = require("./iconTypes");
var _loaderUtils = require("./loaderUtils");
function getLoaderFn(options) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var _a, loader;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = options.loader, loader = _a === void 0 ? singleton.defaultLoader : _a;
                    if (!(typeof loader === "function")) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        loader
                    ];
                case 1:
                    if (!(loader === "all")) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        require(/* webpackChunkName: "blueprint-icons-all-paths-loader" */ "35c1840f37b9d719")
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _b.sent().allPathsLoader
                    ];
                case 3:
                    return [
                        4 /*yield*/ ,
                        require(/* webpackChunkName: "blueprint-icons-split-paths-by-size-loader" */ "bb012cdec7f90ee2")
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        _b.sent().splitPathsBySizeLoader
                    ];
            }
        });
    });
}
/**
 * Blueprint icons loader.
 */ var Icons = /** @class */ function() {
    function Icons() {
        /** @internal */ this.defaultLoader = "split-by-size";
        /** @internal */ this.loadedIconPaths16 = new Map();
        /** @internal */ this.loadedIconPaths20 = new Map();
    }
    /**
     * Set global icon loading options for all subsequent `Icons.load()` calls.
     */ Icons.setLoaderOptions = function(options) {
        if (options.loader !== undefined) singleton.defaultLoader = options.loader;
    };
    Icons.load = function(icons, size, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!Array.isArray(icons)) icons = [
                            icons
                        ];
                        return [
                            4 /*yield*/ ,
                            Promise.all(icons.map(function(icon) {
                                return _this.loadImpl(icon, size, options);
                            }))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Load all available icons for use in Blueprint components.
     */ Icons.loadAll = function(options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var allIcons;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                allIcons = Object.values((0, _iconNames.IconNames));
                (0, _loaderUtils.wrapWithTimer)("[Blueprint] loading all icons", function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4 /*yield*/ ,
                                        Promise.all([
                                            this.load(allIcons, (0, _iconTypes.IconSize).STANDARD, options),
                                            this.load(allIcons, (0, _iconTypes.IconSize).LARGE, options)
                                        ])
                                    ];
                                case 1:
                                    _a.sent();
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Get the icon SVG paths. Returns `undefined` if the icon has not been loaded yet.
     */ Icons.getPaths = function(icon, size) {
        if (!this.isValidIconName(icon)) // don't warn, since this.load() will have warned already
        return undefined;
        var loadedIcons = size < (0, _iconTypes.IconSize).LARGE ? singleton.loadedIconPaths16 : singleton.loadedIconPaths20;
        return loadedIcons.get(icon);
    };
    Icons.loadImpl = function(icon, size, options) {
        if (options === void 0) options = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var loadedIcons, loaderFn, supportedSize, paths, e_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.isValidIconName(icon)) {
                            console.error("[Blueprint] Unknown icon '".concat(icon, "'"));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        loadedIcons = size < (0, _iconTypes.IconSize).LARGE ? singleton.loadedIconPaths16 : singleton.loadedIconPaths20;
                        if (loadedIcons.has(icon)) // already loaded, no-op
                        return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            getLoaderFn(options)
                        ];
                    case 1:
                        loaderFn = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        supportedSize = size < (0, _iconTypes.IconSize).LARGE ? (0, _iconTypes.IconSize).STANDARD : (0, _iconTypes.IconSize).LARGE;
                        return [
                            4 /*yield*/ ,
                            loaderFn(icon, supportedSize)
                        ];
                    case 3:
                        paths = _a.sent();
                        loadedIcons.set(icon, paths);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_1 = _a.sent();
                        console.error("[Blueprint] Unable to load ".concat(size, "px icon '").concat(icon, "'"), e_1);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @returns true if the given string is a valid {@link IconName}
     */ Icons.isValidIconName = function(iconName) {
        return (0, _iconNames.IconNamesSet).has(iconName);
    };
    return Icons;
}();
var singleton = new Icons();

},{"tslib":"b4wpY","./iconNames":"anJGa","./iconTypes":"kknia","./loaderUtils":"d33r6","35c1840f37b9d719":"kYxK3","bb012cdec7f90ee2":"8w9yZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"anJGa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconNames", ()=>IconNames);
parcelHelpers.export(exports, "IconNamesSet", ()=>IconNamesSet);
var _tslib = require("tslib");
/* eslint-disable camelcase */ var _changeCase = require("change-case");
// The two icon sets are identical aside from SVG paths, so we only need to import info for the 16px set
var _blueprintIcons16 = require("./generated/16px/blueprint-icons-16");
var IconNamesNew = {};
var IconNamesLegacy = {};
for(var _i = 0, _a = Object.values((0, _blueprintIcons16.BlueprintIcons_16)); _i < _a.length; _i++){
    var name_1 = _a[_i];
    IconNamesNew[(0, _changeCase.pascalCase)(name_1)] = name_1;
    IconNamesLegacy[(0, _changeCase.snakeCase)(name_1).toUpperCase()] = name_1;
}
var IconNames = (0, _tslib.__assign)((0, _tslib.__assign)({}, IconNamesNew), IconNamesLegacy);
var IconNamesSet = new Set(Object.values(IconNames));

},{"tslib":"b4wpY","change-case":"itgXF","./generated/16px/blueprint-icons-16":"c4zZr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c4zZr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlueprintIcons_16", ()=>BlueprintIcons_16);
parcelHelpers.export(exports, "BLUEPRINT_ICONS_16_CODEPOINTS", ()=>BLUEPRINT_ICONS_16_CODEPOINTS);
var _a;
var BlueprintIcons_16;
(function(BlueprintIcons_16) {
    BlueprintIcons_16["AddClip"] = "add-clip";
    BlueprintIcons_16["AddColumnLeft"] = "add-column-left";
    BlueprintIcons_16["AddColumnRight"] = "add-column-right";
    BlueprintIcons_16["AddLocation"] = "add-location";
    BlueprintIcons_16["AddRowBottom"] = "add-row-bottom";
    BlueprintIcons_16["AddRowTop"] = "add-row-top";
    BlueprintIcons_16["AddToArtifact"] = "add-to-artifact";
    BlueprintIcons_16["AddToFolder"] = "add-to-folder";
    BlueprintIcons_16["Add"] = "add";
    BlueprintIcons_16["AimpointsTarget"] = "aimpoints-target";
    BlueprintIcons_16["Airplane"] = "airplane";
    BlueprintIcons_16["AlignCenter"] = "align-center";
    BlueprintIcons_16["AlignJustify"] = "align-justify";
    BlueprintIcons_16["AlignLeft"] = "align-left";
    BlueprintIcons_16["AlignRight"] = "align-right";
    BlueprintIcons_16["AlignmentBottom"] = "alignment-bottom";
    BlueprintIcons_16["AlignmentHorizontalCenter"] = "alignment-horizontal-center";
    BlueprintIcons_16["AlignmentLeft"] = "alignment-left";
    BlueprintIcons_16["AlignmentRight"] = "alignment-right";
    BlueprintIcons_16["AlignmentTop"] = "alignment-top";
    BlueprintIcons_16["AlignmentVerticalCenter"] = "alignment-vertical-center";
    BlueprintIcons_16["Ammunition"] = "ammunition";
    BlueprintIcons_16["Anchor"] = "anchor";
    BlueprintIcons_16["Annotation"] = "annotation";
    BlueprintIcons_16["Antenna"] = "antenna";
    BlueprintIcons_16["AppHeader"] = "app-header";
    BlueprintIcons_16["Application"] = "application";
    BlueprintIcons_16["Applications"] = "applications";
    BlueprintIcons_16["Archive"] = "archive";
    BlueprintIcons_16["AreaOfInterest"] = "area-of-interest";
    BlueprintIcons_16["ArrayBoolean"] = "array-boolean";
    BlueprintIcons_16["ArrayDate"] = "array-date";
    BlueprintIcons_16["ArrayFloatingPoint"] = "array-floating-point";
    BlueprintIcons_16["ArrayNumeric"] = "array-numeric";
    BlueprintIcons_16["ArrayString"] = "array-string";
    BlueprintIcons_16["ArrayTimestamp"] = "array-timestamp";
    BlueprintIcons_16["Array"] = "array";
    BlueprintIcons_16["ArrowBottomLeft"] = "arrow-bottom-left";
    BlueprintIcons_16["ArrowBottomRight"] = "arrow-bottom-right";
    BlueprintIcons_16["ArrowDown"] = "arrow-down";
    BlueprintIcons_16["ArrowLeft"] = "arrow-left";
    BlueprintIcons_16["ArrowRight"] = "arrow-right";
    BlueprintIcons_16["ArrowTopLeft"] = "arrow-top-left";
    BlueprintIcons_16["ArrowTopRight"] = "arrow-top-right";
    BlueprintIcons_16["ArrowUp"] = "arrow-up";
    BlueprintIcons_16["ArrowsArc"] = "arrows-arc";
    BlueprintIcons_16["ArrowsHorizontal"] = "arrows-horizontal";
    BlueprintIcons_16["ArrowsVertical"] = "arrows-vertical";
    BlueprintIcons_16["Asterisk"] = "asterisk";
    BlueprintIcons_16["At"] = "at";
    BlueprintIcons_16["AutomaticUpdates"] = "automatic-updates";
    BlueprintIcons_16["Axle"] = "axle";
    BlueprintIcons_16["Backlink"] = "backlink";
    BlueprintIcons_16["BackwardTen"] = "backward-ten";
    BlueprintIcons_16["Badge"] = "badge";
    BlueprintIcons_16["BanCircle"] = "ban-circle";
    BlueprintIcons_16["BankAccount"] = "bank-account";
    BlueprintIcons_16["Barcode"] = "barcode";
    BlueprintIcons_16["BinaryNumber"] = "binary-number";
    BlueprintIcons_16["Blank"] = "blank";
    BlueprintIcons_16["BlockPromote"] = "block-promote";
    BlueprintIcons_16["BlockedPerson"] = "blocked-person";
    BlueprintIcons_16["Bold"] = "bold";
    BlueprintIcons_16["Book"] = "book";
    BlueprintIcons_16["Bookmark"] = "bookmark";
    BlueprintIcons_16["Box"] = "box";
    BlueprintIcons_16["Briefcase"] = "briefcase";
    BlueprintIcons_16["BringData"] = "bring-data";
    BlueprintIcons_16["BringForward"] = "bring-forward";
    BlueprintIcons_16["BritishPound"] = "british-pound";
    BlueprintIcons_16["Bug"] = "bug";
    BlueprintIcons_16["Buggy"] = "buggy";
    BlueprintIcons_16["Build"] = "build";
    BlueprintIcons_16["Bullseye"] = "bullseye";
    BlueprintIcons_16["Calculator"] = "calculator";
    BlueprintIcons_16["Calendar"] = "calendar";
    BlueprintIcons_16["Camera"] = "camera";
    BlueprintIcons_16["CaretDown"] = "caret-down";
    BlueprintIcons_16["CaretLeft"] = "caret-left";
    BlueprintIcons_16["CaretRight"] = "caret-right";
    BlueprintIcons_16["CaretUp"] = "caret-up";
    BlueprintIcons_16["CargoShip"] = "cargo-ship";
    BlueprintIcons_16["CellTower"] = "cell-tower";
    BlueprintIcons_16["Changes"] = "changes";
    BlueprintIcons_16["Chart"] = "chart";
    BlueprintIcons_16["Chat"] = "chat";
    BlueprintIcons_16["ChevronBackward"] = "chevron-backward";
    BlueprintIcons_16["ChevronDown"] = "chevron-down";
    BlueprintIcons_16["ChevronForward"] = "chevron-forward";
    BlueprintIcons_16["ChevronLeft"] = "chevron-left";
    BlueprintIcons_16["ChevronRight"] = "chevron-right";
    BlueprintIcons_16["ChevronUp"] = "chevron-up";
    BlueprintIcons_16["CircleArrowDown"] = "circle-arrow-down";
    BlueprintIcons_16["CircleArrowLeft"] = "circle-arrow-left";
    BlueprintIcons_16["CircleArrowRight"] = "circle-arrow-right";
    BlueprintIcons_16["CircleArrowUp"] = "circle-arrow-up";
    BlueprintIcons_16["Circle"] = "circle";
    BlueprintIcons_16["Citation"] = "citation";
    BlueprintIcons_16["Clean"] = "clean";
    BlueprintIcons_16["Clip"] = "clip";
    BlueprintIcons_16["ClipboardFile"] = "clipboard-file";
    BlueprintIcons_16["Clipboard"] = "clipboard";
    BlueprintIcons_16["CloudDownload"] = "cloud-download";
    BlueprintIcons_16["CloudServer"] = "cloud-server";
    BlueprintIcons_16["CloudTick"] = "cloud-tick";
    BlueprintIcons_16["CloudUpload"] = "cloud-upload";
    BlueprintIcons_16["Cloud"] = "cloud";
    BlueprintIcons_16["CodeBlock"] = "code-block";
    BlueprintIcons_16["Code"] = "code";
    BlueprintIcons_16["Cog"] = "cog";
    BlueprintIcons_16["CollapseAll"] = "collapse-all";
    BlueprintIcons_16["ColorFill"] = "color-fill";
    BlueprintIcons_16["ColumnLayout"] = "column-layout";
    BlueprintIcons_16["Comment"] = "comment";
    BlueprintIcons_16["Comparison"] = "comparison";
    BlueprintIcons_16["Compass"] = "compass";
    BlueprintIcons_16["Compressed"] = "compressed";
    BlueprintIcons_16["Confirm"] = "confirm";
    BlueprintIcons_16["Console"] = "console";
    BlueprintIcons_16["Contrast"] = "contrast";
    BlueprintIcons_16["Control"] = "control";
    BlueprintIcons_16["CreditCard"] = "credit-card";
    BlueprintIcons_16["Crop"] = "crop";
    BlueprintIcons_16["CrossCircle"] = "cross-circle";
    BlueprintIcons_16["Cross"] = "cross";
    BlueprintIcons_16["Crown"] = "crown";
    BlueprintIcons_16["CssStyle"] = "css-style";
    BlueprintIcons_16["CubeAdd"] = "cube-add";
    BlueprintIcons_16["CubeEdit"] = "cube-edit";
    BlueprintIcons_16["CubeRemove"] = "cube-remove";
    BlueprintIcons_16["Cube"] = "cube";
    BlueprintIcons_16["Cubes"] = "cubes";
    BlueprintIcons_16["CurlyBraces"] = "curly-braces";
    BlueprintIcons_16["CurvedRangeChart"] = "curved-range-chart";
    BlueprintIcons_16["Cut"] = "cut";
    BlueprintIcons_16["Cycle"] = "cycle";
    BlueprintIcons_16["Dashboard"] = "dashboard";
    BlueprintIcons_16["DataConnection"] = "data-connection";
    BlueprintIcons_16["DataLineage"] = "data-lineage";
    BlueprintIcons_16["DataSearch"] = "data-search";
    BlueprintIcons_16["DataSync"] = "data-sync";
    BlueprintIcons_16["Database"] = "database";
    BlueprintIcons_16["Delete"] = "delete";
    BlueprintIcons_16["Delta"] = "delta";
    BlueprintIcons_16["DeriveColumn"] = "derive-column";
    BlueprintIcons_16["Desktop"] = "desktop";
    BlueprintIcons_16["Detection"] = "detection";
    BlueprintIcons_16["Diagnosis"] = "diagnosis";
    BlueprintIcons_16["DiagramTree"] = "diagram-tree";
    BlueprintIcons_16["DirectionLeft"] = "direction-left";
    BlueprintIcons_16["DirectionRight"] = "direction-right";
    BlueprintIcons_16["Disable"] = "disable";
    BlueprintIcons_16["Divide"] = "divide";
    BlueprintIcons_16["DocumentOpen"] = "document-open";
    BlueprintIcons_16["DocumentShare"] = "document-share";
    BlueprintIcons_16["Document"] = "document";
    BlueprintIcons_16["Dollar"] = "dollar";
    BlueprintIcons_16["Dot"] = "dot";
    BlueprintIcons_16["DoubleCaretHorizontal"] = "double-caret-horizontal";
    BlueprintIcons_16["DoubleCaretVertical"] = "double-caret-vertical";
    BlueprintIcons_16["DoubleChevronDown"] = "double-chevron-down";
    BlueprintIcons_16["DoubleChevronLeft"] = "double-chevron-left";
    BlueprintIcons_16["DoubleChevronRight"] = "double-chevron-right";
    BlueprintIcons_16["DoubleChevronUp"] = "double-chevron-up";
    BlueprintIcons_16["DoughnutChart"] = "doughnut-chart";
    BlueprintIcons_16["Download"] = "download";
    BlueprintIcons_16["DragHandleHorizontal"] = "drag-handle-horizontal";
    BlueprintIcons_16["DragHandleVertical"] = "drag-handle-vertical";
    BlueprintIcons_16["Draw"] = "draw";
    BlueprintIcons_16["DrawerLeftFilled"] = "drawer-left-filled";
    BlueprintIcons_16["DrawerLeft"] = "drawer-left";
    BlueprintIcons_16["DrawerRightFilled"] = "drawer-right-filled";
    BlueprintIcons_16["DrawerRight"] = "drawer-right";
    BlueprintIcons_16["DriveTime"] = "drive-time";
    BlueprintIcons_16["Duplicate"] = "duplicate";
    BlueprintIcons_16["Edit"] = "edit";
    BlueprintIcons_16["Eject"] = "eject";
    BlueprintIcons_16["Emoji"] = "emoji";
    BlueprintIcons_16["Endnote"] = "endnote";
    BlueprintIcons_16["Endorsed"] = "endorsed";
    BlueprintIcons_16["Envelope"] = "envelope";
    BlueprintIcons_16["Equals"] = "equals";
    BlueprintIcons_16["Eraser"] = "eraser";
    BlueprintIcons_16["Error"] = "error";
    BlueprintIcons_16["Euro"] = "euro";
    BlueprintIcons_16["Excavator"] = "excavator";
    BlueprintIcons_16["Exchange"] = "exchange";
    BlueprintIcons_16["ExcludeRow"] = "exclude-row";
    BlueprintIcons_16["ExpandAll"] = "expand-all";
    BlueprintIcons_16["Explain"] = "explain";
    BlueprintIcons_16["Export"] = "export";
    BlueprintIcons_16["EyeOff"] = "eye-off";
    BlueprintIcons_16["EyeOn"] = "eye-on";
    BlueprintIcons_16["EyeOpen"] = "eye-open";
    BlueprintIcons_16["FastBackward"] = "fast-backward";
    BlueprintIcons_16["FastForward"] = "fast-forward";
    BlueprintIcons_16["FeedSubscribed"] = "feed-subscribed";
    BlueprintIcons_16["Feed"] = "feed";
    BlueprintIcons_16["FighterJet"] = "fighter-jet";
    BlueprintIcons_16["Film"] = "film";
    BlueprintIcons_16["FilterKeep"] = "filter-keep";
    BlueprintIcons_16["FilterList"] = "filter-list";
    BlueprintIcons_16["FilterOpen"] = "filter-open";
    BlueprintIcons_16["FilterRemove"] = "filter-remove";
    BlueprintIcons_16["FilterSortAsc"] = "filter-sort-asc";
    BlueprintIcons_16["FilterSortDesc"] = "filter-sort-desc";
    BlueprintIcons_16["Filter"] = "filter";
    BlueprintIcons_16["Flag"] = "flag";
    BlueprintIcons_16["Flame"] = "flame";
    BlueprintIcons_16["Flash"] = "flash";
    BlueprintIcons_16["FloatingPoint"] = "floating-point";
    BlueprintIcons_16["FloppyDisk"] = "floppy-disk";
    BlueprintIcons_16["FlowBranch"] = "flow-branch";
    BlueprintIcons_16["FlowEnd"] = "flow-end";
    BlueprintIcons_16["FlowLinear"] = "flow-linear";
    BlueprintIcons_16["FlowReviewBranch"] = "flow-review-branch";
    BlueprintIcons_16["FlowReview"] = "flow-review";
    BlueprintIcons_16["Flows"] = "flows";
    BlueprintIcons_16["FolderClose"] = "folder-close";
    BlueprintIcons_16["FolderNew"] = "folder-new";
    BlueprintIcons_16["FolderOpen"] = "folder-open";
    BlueprintIcons_16["FolderSharedOpen"] = "folder-shared-open";
    BlueprintIcons_16["FolderShared"] = "folder-shared";
    BlueprintIcons_16["Follower"] = "follower";
    BlueprintIcons_16["Following"] = "following";
    BlueprintIcons_16["Font"] = "font";
    BlueprintIcons_16["Fork"] = "fork";
    BlueprintIcons_16["Form"] = "form";
    BlueprintIcons_16["ForwardTen"] = "forward-ten";
    BlueprintIcons_16["Fuel"] = "fuel";
    BlueprintIcons_16["FullCircle"] = "full-circle";
    BlueprintIcons_16["FullStackedChart"] = "full-stacked-chart";
    BlueprintIcons_16["Fullscreen"] = "fullscreen";
    BlueprintIcons_16["Function"] = "function";
    BlueprintIcons_16["GanttChart"] = "gantt-chart";
    BlueprintIcons_16["Generate"] = "generate";
    BlueprintIcons_16["Geofence"] = "geofence";
    BlueprintIcons_16["Geolocation"] = "geolocation";
    BlueprintIcons_16["Geosearch"] = "geosearch";
    BlueprintIcons_16["Geotime"] = "geotime";
    BlueprintIcons_16["GitBranch"] = "git-branch";
    BlueprintIcons_16["GitCommit"] = "git-commit";
    BlueprintIcons_16["GitMerge"] = "git-merge";
    BlueprintIcons_16["GitNewBranch"] = "git-new-branch";
    BlueprintIcons_16["GitPull"] = "git-pull";
    BlueprintIcons_16["GitPush"] = "git-push";
    BlueprintIcons_16["GitRepo"] = "git-repo";
    BlueprintIcons_16["Glass"] = "glass";
    BlueprintIcons_16["GlobeNetworkAdd"] = "globe-network-add";
    BlueprintIcons_16["GlobeNetwork"] = "globe-network";
    BlueprintIcons_16["Globe"] = "globe";
    BlueprintIcons_16["GraphRemove"] = "graph-remove";
    BlueprintIcons_16["Graph"] = "graph";
    BlueprintIcons_16["GreaterThanOrEqualTo"] = "greater-than-or-equal-to";
    BlueprintIcons_16["GreaterThan"] = "greater-than";
    BlueprintIcons_16["GridView"] = "grid-view";
    BlueprintIcons_16["Grid"] = "grid";
    BlueprintIcons_16["GroupItem"] = "group-item";
    BlueprintIcons_16["GroupObjects"] = "group-objects";
    BlueprintIcons_16["GroupedBarChart"] = "grouped-bar-chart";
    BlueprintIcons_16["HandDown"] = "hand-down";
    BlueprintIcons_16["HandLeft"] = "hand-left";
    BlueprintIcons_16["HandRight"] = "hand-right";
    BlueprintIcons_16["HandUp"] = "hand-up";
    BlueprintIcons_16["Hand"] = "hand";
    BlueprintIcons_16["Hat"] = "hat";
    BlueprintIcons_16["HeaderOne"] = "header-one";
    BlueprintIcons_16["HeaderThree"] = "header-three";
    BlueprintIcons_16["HeaderTwo"] = "header-two";
    BlueprintIcons_16["Header"] = "header";
    BlueprintIcons_16["Headset"] = "headset";
    BlueprintIcons_16["HeartBroken"] = "heart-broken";
    BlueprintIcons_16["Heart"] = "heart";
    BlueprintIcons_16["HeatGrid"] = "heat-grid";
    BlueprintIcons_16["Heatmap"] = "heatmap";
    BlueprintIcons_16["Helicopter"] = "helicopter";
    BlueprintIcons_16["Help"] = "help";
    BlueprintIcons_16["HelperManagement"] = "helper-management";
    BlueprintIcons_16["Hexagon"] = "hexagon";
    BlueprintIcons_16["HighPriority"] = "high-priority";
    BlueprintIcons_16["HighVoltagePole"] = "high-voltage-pole";
    BlueprintIcons_16["Highlight"] = "highlight";
    BlueprintIcons_16["History"] = "history";
    BlueprintIcons_16["Home"] = "home";
    BlueprintIcons_16["HorizontalBarChartAsc"] = "horizontal-bar-chart-asc";
    BlueprintIcons_16["HorizontalBarChartDesc"] = "horizontal-bar-chart-desc";
    BlueprintIcons_16["HorizontalBarChart"] = "horizontal-bar-chart";
    BlueprintIcons_16["HorizontalDistribution"] = "horizontal-distribution";
    BlueprintIcons_16["HorizontalInbetween"] = "horizontal-inbetween";
    BlueprintIcons_16["Hurricane"] = "hurricane";
    BlueprintIcons_16["IdNumber"] = "id-number";
    BlueprintIcons_16["ImageRotateLeft"] = "image-rotate-left";
    BlueprintIcons_16["ImageRotateRight"] = "image-rotate-right";
    BlueprintIcons_16["Import"] = "import";
    BlueprintIcons_16["InboxFiltered"] = "inbox-filtered";
    BlueprintIcons_16["InboxGeo"] = "inbox-geo";
    BlueprintIcons_16["InboxSearch"] = "inbox-search";
    BlueprintIcons_16["InboxUpdate"] = "inbox-update";
    BlueprintIcons_16["Inbox"] = "inbox";
    BlueprintIcons_16["InfoSign"] = "info-sign";
    BlueprintIcons_16["Inheritance"] = "inheritance";
    BlueprintIcons_16["InheritedGroup"] = "inherited-group";
    BlueprintIcons_16["InnerJoin"] = "inner-join";
    BlueprintIcons_16["Input"] = "input";
    BlueprintIcons_16["Insert"] = "insert";
    BlueprintIcons_16["Intelligence"] = "intelligence";
    BlueprintIcons_16["Intersection"] = "intersection";
    BlueprintIcons_16["IpAddress"] = "ip-address";
    BlueprintIcons_16["IssueClosed"] = "issue-closed";
    BlueprintIcons_16["IssueNew"] = "issue-new";
    BlueprintIcons_16["Issue"] = "issue";
    BlueprintIcons_16["Italic"] = "italic";
    BlueprintIcons_16["JoinTable"] = "join-table";
    BlueprintIcons_16["KeyBackspace"] = "key-backspace";
    BlueprintIcons_16["KeyCommand"] = "key-command";
    BlueprintIcons_16["KeyControl"] = "key-control";
    BlueprintIcons_16["KeyDelete"] = "key-delete";
    BlueprintIcons_16["KeyEnter"] = "key-enter";
    BlueprintIcons_16["KeyEscape"] = "key-escape";
    BlueprintIcons_16["KeyOption"] = "key-option";
    BlueprintIcons_16["KeyShift"] = "key-shift";
    BlueprintIcons_16["KeyTab"] = "key-tab";
    BlueprintIcons_16["Key"] = "key";
    BlueprintIcons_16["KnownVehicle"] = "known-vehicle";
    BlueprintIcons_16["LabTest"] = "lab-test";
    BlueprintIcons_16["Label"] = "label";
    BlueprintIcons_16["LayerOutline"] = "layer-outline";
    BlueprintIcons_16["Layer"] = "layer";
    BlueprintIcons_16["Layers"] = "layers";
    BlueprintIcons_16["LayoutAuto"] = "layout-auto";
    BlueprintIcons_16["LayoutBalloon"] = "layout-balloon";
    BlueprintIcons_16["LayoutBottomRowThreeTiles"] = "layout-bottom-row-three-tiles";
    BlueprintIcons_16["LayoutBottomRowTwoTiles"] = "layout-bottom-row-two-tiles";
    BlueprintIcons_16["LayoutCircle"] = "layout-circle";
    BlueprintIcons_16["LayoutGrid"] = "layout-grid";
    BlueprintIcons_16["LayoutGroupBy"] = "layout-group-by";
    BlueprintIcons_16["LayoutHierarchy"] = "layout-hierarchy";
    BlueprintIcons_16["LayoutLeftColumnThreeTiles"] = "layout-left-column-three-tiles";
    BlueprintIcons_16["LayoutLeftColumnTwoTiles"] = "layout-left-column-two-tiles";
    BlueprintIcons_16["LayoutLinear"] = "layout-linear";
    BlueprintIcons_16["LayoutRightColumnThreeTiles"] = "layout-right-column-three-tiles";
    BlueprintIcons_16["LayoutRightColumnTwoTiles"] = "layout-right-column-two-tiles";
    BlueprintIcons_16["LayoutSkewGrid"] = "layout-skew-grid";
    BlueprintIcons_16["LayoutSortedClusters"] = "layout-sorted-clusters";
    BlueprintIcons_16["LayoutThreeColumns"] = "layout-three-columns";
    BlueprintIcons_16["LayoutThreeRows"] = "layout-three-rows";
    BlueprintIcons_16["LayoutTopRowThreeTiles"] = "layout-top-row-three-tiles";
    BlueprintIcons_16["LayoutTopRowTwoTiles"] = "layout-top-row-two-tiles";
    BlueprintIcons_16["LayoutTwoColumns"] = "layout-two-columns";
    BlueprintIcons_16["LayoutTwoRows"] = "layout-two-rows";
    BlueprintIcons_16["Layout"] = "layout";
    BlueprintIcons_16["Learning"] = "learning";
    BlueprintIcons_16["LeftJoin"] = "left-join";
    BlueprintIcons_16["LengthenText"] = "lengthen-text";
    BlueprintIcons_16["LessThanOrEqualTo"] = "less-than-or-equal-to";
    BlueprintIcons_16["LessThan"] = "less-than";
    BlueprintIcons_16["Lifesaver"] = "lifesaver";
    BlueprintIcons_16["Lightbulb"] = "lightbulb";
    BlueprintIcons_16["Lightning"] = "lightning";
    BlueprintIcons_16["Link"] = "link";
    BlueprintIcons_16["LinkedSquares"] = "linked-squares";
    BlueprintIcons_16["ListColumns"] = "list-columns";
    BlueprintIcons_16["ListDetailView"] = "list-detail-view";
    BlueprintIcons_16["List"] = "list";
    BlueprintIcons_16["Locate"] = "locate";
    BlueprintIcons_16["Lock"] = "lock";
    BlueprintIcons_16["Locomotive"] = "locomotive";
    BlueprintIcons_16["LogIn"] = "log-in";
    BlueprintIcons_16["LogOut"] = "log-out";
    BlueprintIcons_16["LowVoltagePole"] = "low-voltage-pole";
    BlueprintIcons_16["Manual"] = "manual";
    BlueprintIcons_16["ManuallyEnteredData"] = "manually-entered-data";
    BlueprintIcons_16["ManyToMany"] = "many-to-many";
    BlueprintIcons_16["ManyToOne"] = "many-to-one";
    BlueprintIcons_16["MapCreate"] = "map-create";
    BlueprintIcons_16["MapMarker"] = "map-marker";
    BlueprintIcons_16["Map"] = "map";
    BlueprintIcons_16["Maximize"] = "maximize";
    BlueprintIcons_16["Media"] = "media";
    BlueprintIcons_16["MenuClosed"] = "menu-closed";
    BlueprintIcons_16["MenuOpen"] = "menu-open";
    BlueprintIcons_16["Menu"] = "menu";
    BlueprintIcons_16["MergeColumns"] = "merge-columns";
    BlueprintIcons_16["MergeLinks"] = "merge-links";
    BlueprintIcons_16["Microphone"] = "microphone";
    BlueprintIcons_16["Minimize"] = "minimize";
    BlueprintIcons_16["Minus"] = "minus";
    BlueprintIcons_16["MobilePhone"] = "mobile-phone";
    BlueprintIcons_16["MobileVideo"] = "mobile-video";
    BlueprintIcons_16["ModalFilled"] = "modal-filled";
    BlueprintIcons_16["Modal"] = "modal";
    BlueprintIcons_16["Model"] = "model";
    BlueprintIcons_16["Moon"] = "moon";
    BlueprintIcons_16["More"] = "more";
    BlueprintIcons_16["Mountain"] = "mountain";
    BlueprintIcons_16["Move"] = "move";
    BlueprintIcons_16["Mugshot"] = "mugshot";
    BlueprintIcons_16["MultiSelect"] = "multi-select";
    BlueprintIcons_16["Music"] = "music";
    BlueprintIcons_16["Nest"] = "nest";
    BlueprintIcons_16["NewDrawing"] = "new-drawing";
    BlueprintIcons_16["NewGridItem"] = "new-grid-item";
    BlueprintIcons_16["NewLayer"] = "new-layer";
    BlueprintIcons_16["NewLayers"] = "new-layers";
    BlueprintIcons_16["NewLink"] = "new-link";
    BlueprintIcons_16["NewObject"] = "new-object";
    BlueprintIcons_16["NewPerson"] = "new-person";
    BlueprintIcons_16["NewPrescription"] = "new-prescription";
    BlueprintIcons_16["NewShield"] = "new-shield";
    BlueprintIcons_16["NewTextBox"] = "new-text-box";
    BlueprintIcons_16["Ninja"] = "ninja";
    BlueprintIcons_16["NotEqualTo"] = "not-equal-to";
    BlueprintIcons_16["NotificationsSnooze"] = "notifications-snooze";
    BlueprintIcons_16["NotificationsUpdated"] = "notifications-updated";
    BlueprintIcons_16["Notifications"] = "notifications";
    BlueprintIcons_16["NumberedList"] = "numbered-list";
    BlueprintIcons_16["Numerical"] = "numerical";
    BlueprintIcons_16["ObjectView"] = "object-view";
    BlueprintIcons_16["Office"] = "office";
    BlueprintIcons_16["Offline"] = "offline";
    BlueprintIcons_16["OilField"] = "oil-field";
    BlueprintIcons_16["OneColumn"] = "one-column";
    BlueprintIcons_16["OneToMany"] = "one-to-many";
    BlueprintIcons_16["OneToOne"] = "one-to-one";
    BlueprintIcons_16["OpenApplication"] = "open-application";
    BlueprintIcons_16["Outdated"] = "outdated";
    BlueprintIcons_16["Output"] = "output";
    BlueprintIcons_16["Package"] = "package";
    BlueprintIcons_16["PageLayout"] = "page-layout";
    BlueprintIcons_16["PanelStats"] = "panel-stats";
    BlueprintIcons_16["PanelTable"] = "panel-table";
    BlueprintIcons_16["Panel"] = "panel";
    BlueprintIcons_16["Paperclip"] = "paperclip";
    BlueprintIcons_16["Paragraph"] = "paragraph";
    BlueprintIcons_16["PasteVariable"] = "paste-variable";
    BlueprintIcons_16["PathSearch"] = "path-search";
    BlueprintIcons_16["Path"] = "path";
    BlueprintIcons_16["Pause"] = "pause";
    BlueprintIcons_16["People"] = "people";
    BlueprintIcons_16["Percentage"] = "percentage";
    BlueprintIcons_16["Person"] = "person";
    BlueprintIcons_16["PhoneCall"] = "phone-call";
    BlueprintIcons_16["PhoneForward"] = "phone-forward";
    BlueprintIcons_16["Phone"] = "phone";
    BlueprintIcons_16["PieChart"] = "pie-chart";
    BlueprintIcons_16["Pill"] = "pill";
    BlueprintIcons_16["Pin"] = "pin";
    BlueprintIcons_16["PivotTable"] = "pivot-table";
    BlueprintIcons_16["Pivot"] = "pivot";
    BlueprintIcons_16["Play"] = "play";
    BlueprintIcons_16["Playbook"] = "playbook";
    BlueprintIcons_16["Plus"] = "plus";
    BlueprintIcons_16["PolygonFilter"] = "polygon-filter";
    BlueprintIcons_16["Power"] = "power";
    BlueprintIcons_16["PredictiveAnalysis"] = "predictive-analysis";
    BlueprintIcons_16["Prescription"] = "prescription";
    BlueprintIcons_16["Presentation"] = "presentation";
    BlueprintIcons_16["Print"] = "print";
    BlueprintIcons_16["Projects"] = "projects";
    BlueprintIcons_16["Properties"] = "properties";
    BlueprintIcons_16["Property"] = "property";
    BlueprintIcons_16["PublishFunction"] = "publish-function";
    BlueprintIcons_16["Pulse"] = "pulse";
    BlueprintIcons_16["Rain"] = "rain";
    BlueprintIcons_16["Random"] = "random";
    BlueprintIcons_16["RangeRing"] = "range-ring";
    BlueprintIcons_16["Record"] = "record";
    BlueprintIcons_16["RectHeight"] = "rect-height";
    BlueprintIcons_16["RectWidth"] = "rect-width";
    BlueprintIcons_16["Rectangle"] = "rectangle";
    BlueprintIcons_16["Redo"] = "redo";
    BlueprintIcons_16["Refresh"] = "refresh";
    BlueprintIcons_16["Regex"] = "regex";
    BlueprintIcons_16["RegressionChart"] = "regression-chart";
    BlueprintIcons_16["RemoveColumnLeft"] = "remove-column-left";
    BlueprintIcons_16["RemoveColumnRight"] = "remove-column-right";
    BlueprintIcons_16["RemoveColumn"] = "remove-column";
    BlueprintIcons_16["RemoveRowBottom"] = "remove-row-bottom";
    BlueprintIcons_16["RemoveRowTop"] = "remove-row-top";
    BlueprintIcons_16["Remove"] = "remove";
    BlueprintIcons_16["Repeat"] = "repeat";
    BlueprintIcons_16["Reset"] = "reset";
    BlueprintIcons_16["Resolve"] = "resolve";
    BlueprintIcons_16["Rig"] = "rig";
    BlueprintIcons_16["RightJoin"] = "right-join";
    BlueprintIcons_16["Ring"] = "ring";
    BlueprintIcons_16["RocketSlant"] = "rocket-slant";
    BlueprintIcons_16["Rocket"] = "rocket";
    BlueprintIcons_16["RotateCcw"] = "rotate-ccw";
    BlueprintIcons_16["RotateCw"] = "rotate-cw";
    BlueprintIcons_16["RotateDocument"] = "rotate-document";
    BlueprintIcons_16["RotatePage"] = "rotate-page";
    BlueprintIcons_16["Route"] = "route";
    BlueprintIcons_16["Satellite"] = "satellite";
    BlueprintIcons_16["Saved"] = "saved";
    BlueprintIcons_16["ScatterPlot"] = "scatter-plot";
    BlueprintIcons_16["SearchAround"] = "search-around";
    BlueprintIcons_16["SearchTemplate"] = "search-template";
    BlueprintIcons_16["SearchText"] = "search-text";
    BlueprintIcons_16["Search"] = "search";
    BlueprintIcons_16["SegmentedControl"] = "segmented-control";
    BlueprintIcons_16["Select"] = "select";
    BlueprintIcons_16["Selection"] = "selection";
    BlueprintIcons_16["SendBackward"] = "send-backward";
    BlueprintIcons_16["SendMessage"] = "send-message";
    BlueprintIcons_16["SendToGraph"] = "send-to-graph";
    BlueprintIcons_16["SendToMap"] = "send-to-map";
    BlueprintIcons_16["SendTo"] = "send-to";
    BlueprintIcons_16["Sensor"] = "sensor";
    BlueprintIcons_16["SeriesAdd"] = "series-add";
    BlueprintIcons_16["SeriesConfiguration"] = "series-configuration";
    BlueprintIcons_16["SeriesDerived"] = "series-derived";
    BlueprintIcons_16["SeriesFiltered"] = "series-filtered";
    BlueprintIcons_16["SeriesSearch"] = "series-search";
    BlueprintIcons_16["ServerInstall"] = "server-install";
    BlueprintIcons_16["Server"] = "server";
    BlueprintIcons_16["Settings"] = "settings";
    BlueprintIcons_16["Shapes"] = "shapes";
    BlueprintIcons_16["Share"] = "share";
    BlueprintIcons_16["SharedFilter"] = "shared-filter";
    BlueprintIcons_16["Shield"] = "shield";
    BlueprintIcons_16["Ship"] = "ship";
    BlueprintIcons_16["Shop"] = "shop";
    BlueprintIcons_16["ShoppingCart"] = "shopping-cart";
    BlueprintIcons_16["ShortenText"] = "shorten-text";
    BlueprintIcons_16["SignalSearch"] = "signal-search";
    BlueprintIcons_16["SimCard"] = "sim-card";
    BlueprintIcons_16["Slash"] = "slash";
    BlueprintIcons_16["SmallCross"] = "small-cross";
    BlueprintIcons_16["SmallInfoSign"] = "small-info-sign";
    BlueprintIcons_16["SmallMinus"] = "small-minus";
    BlueprintIcons_16["SmallPlus"] = "small-plus";
    BlueprintIcons_16["SmallSquare"] = "small-square";
    BlueprintIcons_16["SmallTick"] = "small-tick";
    BlueprintIcons_16["Snowflake"] = "snowflake";
    BlueprintIcons_16["SoccerBall"] = "soccer-ball";
    BlueprintIcons_16["SocialMedia"] = "social-media";
    BlueprintIcons_16["SortAlphabeticalDesc"] = "sort-alphabetical-desc";
    BlueprintIcons_16["SortAlphabetical"] = "sort-alphabetical";
    BlueprintIcons_16["SortAsc"] = "sort-asc";
    BlueprintIcons_16["SortDesc"] = "sort-desc";
    BlueprintIcons_16["SortNumericalDesc"] = "sort-numerical-desc";
    BlueprintIcons_16["SortNumerical"] = "sort-numerical";
    BlueprintIcons_16["Sort"] = "sort";
    BlueprintIcons_16["SpellCheck"] = "spell-check";
    BlueprintIcons_16["SplitColumns"] = "split-columns";
    BlueprintIcons_16["SportsStadium"] = "sports-stadium";
    BlueprintIcons_16["Square"] = "square";
    BlueprintIcons_16["StackedChart"] = "stacked-chart";
    BlueprintIcons_16["StadiumGeometry"] = "stadium-geometry";
    BlueprintIcons_16["StarEmpty"] = "star-empty";
    BlueprintIcons_16["Star"] = "star";
    BlueprintIcons_16["StepBackward"] = "step-backward";
    BlueprintIcons_16["StepChart"] = "step-chart";
    BlueprintIcons_16["StepForward"] = "step-forward";
    BlueprintIcons_16["Stop"] = "stop";
    BlueprintIcons_16["Stopwatch"] = "stopwatch";
    BlueprintIcons_16["Strikethrough"] = "strikethrough";
    BlueprintIcons_16["Style"] = "style";
    BlueprintIcons_16["Subscript"] = "subscript";
    BlueprintIcons_16["Superscript"] = "superscript";
    BlueprintIcons_16["SwapHorizontal"] = "swap-horizontal";
    BlueprintIcons_16["SwapVertical"] = "swap-vertical";
    BlueprintIcons_16["Switch"] = "switch";
    BlueprintIcons_16["SymbolCircle"] = "symbol-circle";
    BlueprintIcons_16["SymbolCross"] = "symbol-cross";
    BlueprintIcons_16["SymbolDiamond"] = "symbol-diamond";
    BlueprintIcons_16["SymbolRectangle"] = "symbol-rectangle";
    BlueprintIcons_16["SymbolSquare"] = "symbol-square";
    BlueprintIcons_16["SymbolTriangleDown"] = "symbol-triangle-down";
    BlueprintIcons_16["SymbolTriangleUp"] = "symbol-triangle-up";
    BlueprintIcons_16["Syringe"] = "syringe";
    BlueprintIcons_16["TableSync"] = "table-sync";
    BlueprintIcons_16["TagAdd"] = "tag-add";
    BlueprintIcons_16["TagPromote"] = "tag-promote";
    BlueprintIcons_16["TagRefresh"] = "tag-refresh";
    BlueprintIcons_16["TagUndo"] = "tag-undo";
    BlueprintIcons_16["Tag"] = "tag";
    BlueprintIcons_16["Tags"] = "tags";
    BlueprintIcons_16["TakeAction"] = "take-action";
    BlueprintIcons_16["Tank"] = "tank";
    BlueprintIcons_16["Target"] = "target";
    BlueprintIcons_16["Taxi"] = "taxi";
    BlueprintIcons_16["Team"] = "team";
    BlueprintIcons_16["Temperature"] = "temperature";
    BlueprintIcons_16["TextHighlight"] = "text-highlight";
    BlueprintIcons_16["ThAdd"] = "th-add";
    BlueprintIcons_16["ThDerived"] = "th-derived";
    BlueprintIcons_16["ThDisconnect"] = "th-disconnect";
    BlueprintIcons_16["ThFiltered"] = "th-filtered";
    BlueprintIcons_16["ThListAdd"] = "th-list-add";
    BlueprintIcons_16["ThList"] = "th-list";
    BlueprintIcons_16["ThVirtualAdd"] = "th-virtual-add";
    BlueprintIcons_16["ThVirtual"] = "th-virtual";
    BlueprintIcons_16["Th"] = "th";
    BlueprintIcons_16["ThirdParty"] = "third-party";
    BlueprintIcons_16["ThumbsDown"] = "thumbs-down";
    BlueprintIcons_16["ThumbsUp"] = "thumbs-up";
    BlueprintIcons_16["TickCircle"] = "tick-circle";
    BlueprintIcons_16["Tick"] = "tick";
    BlueprintIcons_16["Time"] = "time";
    BlueprintIcons_16["TimelineAreaChart"] = "timeline-area-chart";
    BlueprintIcons_16["TimelineBarChart"] = "timeline-bar-chart";
    BlueprintIcons_16["TimelineEvents"] = "timeline-events";
    BlueprintIcons_16["TimelineLineChart"] = "timeline-line-chart";
    BlueprintIcons_16["Tint"] = "tint";
    BlueprintIcons_16["Torch"] = "torch";
    BlueprintIcons_16["Tractor"] = "tractor";
    BlueprintIcons_16["Train"] = "train";
    BlueprintIcons_16["Translate"] = "translate";
    BlueprintIcons_16["Trash"] = "trash";
    BlueprintIcons_16["Tree"] = "tree";
    BlueprintIcons_16["TrendingDown"] = "trending-down";
    BlueprintIcons_16["TrendingUp"] = "trending-up";
    BlueprintIcons_16["Trophy"] = "trophy";
    BlueprintIcons_16["Truck"] = "truck";
    BlueprintIcons_16["TwoColumns"] = "two-columns";
    BlueprintIcons_16["Unarchive"] = "unarchive";
    BlueprintIcons_16["Underline"] = "underline";
    BlueprintIcons_16["Undo"] = "undo";
    BlueprintIcons_16["UngroupObjects"] = "ungroup-objects";
    BlueprintIcons_16["UnknownVehicle"] = "unknown-vehicle";
    BlueprintIcons_16["Unlink"] = "unlink";
    BlueprintIcons_16["Unlock"] = "unlock";
    BlueprintIcons_16["Unpin"] = "unpin";
    BlueprintIcons_16["Unresolve"] = "unresolve";
    BlueprintIcons_16["Updated"] = "updated";
    BlueprintIcons_16["Upload"] = "upload";
    BlueprintIcons_16["User"] = "user";
    BlueprintIcons_16["Variable"] = "variable";
    BlueprintIcons_16["Vector"] = "vector";
    BlueprintIcons_16["VerticalBarChartAsc"] = "vertical-bar-chart-asc";
    BlueprintIcons_16["VerticalBarChartDesc"] = "vertical-bar-chart-desc";
    BlueprintIcons_16["VerticalDistribution"] = "vertical-distribution";
    BlueprintIcons_16["VerticalInbetween"] = "vertical-inbetween";
    BlueprintIcons_16["Video"] = "video";
    BlueprintIcons_16["Virus"] = "virus";
    BlueprintIcons_16["VolumeDown"] = "volume-down";
    BlueprintIcons_16["VolumeOff"] = "volume-off";
    BlueprintIcons_16["VolumeUp"] = "volume-up";
    BlueprintIcons_16["Walk"] = "walk";
    BlueprintIcons_16["WarningSign"] = "warning-sign";
    BlueprintIcons_16["WaterfallChart"] = "waterfall-chart";
    BlueprintIcons_16["Waves"] = "waves";
    BlueprintIcons_16["WidgetButton"] = "widget-button";
    BlueprintIcons_16["WidgetFooter"] = "widget-footer";
    BlueprintIcons_16["WidgetHeader"] = "widget-header";
    BlueprintIcons_16["Widget"] = "widget";
    BlueprintIcons_16["Wind"] = "wind";
    BlueprintIcons_16["WrenchRedo"] = "wrench-redo";
    BlueprintIcons_16["WrenchSnooze"] = "wrench-snooze";
    BlueprintIcons_16["WrenchTime"] = "wrench-time";
    BlueprintIcons_16["Wrench"] = "wrench";
    BlueprintIcons_16["ZoomIn"] = "zoom-in";
    BlueprintIcons_16["ZoomOut"] = "zoom-out";
    BlueprintIcons_16["ZoomToFit"] = "zoom-to-fit";
})(BlueprintIcons_16 || (BlueprintIcons_16 = {}));
var BLUEPRINT_ICONS_16_CODEPOINTS = (_a = {}, _a[BlueprintIcons_16.AddClip] = "61697", _a[BlueprintIcons_16.AddColumnLeft] = "61698", _a[BlueprintIcons_16.AddColumnRight] = "61699", _a[BlueprintIcons_16.AddLocation] = "61700", _a[BlueprintIcons_16.AddRowBottom] = "61701", _a[BlueprintIcons_16.AddRowTop] = "61702", _a[BlueprintIcons_16.AddToArtifact] = "61703", _a[BlueprintIcons_16.AddToFolder] = "61704", _a[BlueprintIcons_16.Add] = "61705", _a[BlueprintIcons_16.AimpointsTarget] = "62261", _a[BlueprintIcons_16.Airplane] = "61706", _a[BlueprintIcons_16.AlignCenter] = "61707", _a[BlueprintIcons_16.AlignJustify] = "61708", _a[BlueprintIcons_16.AlignLeft] = "61709", _a[BlueprintIcons_16.AlignRight] = "61710", _a[BlueprintIcons_16.AlignmentBottom] = "61711", _a[BlueprintIcons_16.AlignmentHorizontalCenter] = "61712", _a[BlueprintIcons_16.AlignmentLeft] = "61713", _a[BlueprintIcons_16.AlignmentRight] = "61714", _a[BlueprintIcons_16.AlignmentTop] = "61715", _a[BlueprintIcons_16.AlignmentVerticalCenter] = "61716", _a[BlueprintIcons_16.Ammunition] = "62274", _a[BlueprintIcons_16.Anchor] = "62256", _a[BlueprintIcons_16.Annotation] = "61717", _a[BlueprintIcons_16.Antenna] = "61718", _a[BlueprintIcons_16.AppHeader] = "61719", _a[BlueprintIcons_16.Application] = "61720", _a[BlueprintIcons_16.Applications] = "61721", _a[BlueprintIcons_16.Archive] = "61722", _a[BlueprintIcons_16.AreaOfInterest] = "61723", _a[BlueprintIcons_16.ArrayBoolean] = "61724", _a[BlueprintIcons_16.ArrayDate] = "61725", _a[BlueprintIcons_16.ArrayFloatingPoint] = "62253", _a[BlueprintIcons_16.ArrayNumeric] = "61726", _a[BlueprintIcons_16.ArrayString] = "61727", _a[BlueprintIcons_16.ArrayTimestamp] = "61728", _a[BlueprintIcons_16.Array] = "61729", _a[BlueprintIcons_16.ArrowBottomLeft] = "61730", _a[BlueprintIcons_16.ArrowBottomRight] = "61731", _a[BlueprintIcons_16.ArrowDown] = "61732", _a[BlueprintIcons_16.ArrowLeft] = "61733", _a[BlueprintIcons_16.ArrowRight] = "61734", _a[BlueprintIcons_16.ArrowTopLeft] = "61735", _a[BlueprintIcons_16.ArrowTopRight] = "61736", _a[BlueprintIcons_16.ArrowUp] = "61737", _a[BlueprintIcons_16.ArrowsArc] = "62343", _a[BlueprintIcons_16.ArrowsHorizontal] = "61738", _a[BlueprintIcons_16.ArrowsVertical] = "61739", _a[BlueprintIcons_16.Asterisk] = "61740", _a[BlueprintIcons_16.At] = "62257", _a[BlueprintIcons_16.AutomaticUpdates] = "61741", _a[BlueprintIcons_16.Axle] = "62264", _a[BlueprintIcons_16.Backlink] = "61742", _a[BlueprintIcons_16.BackwardTen] = "62300", _a[BlueprintIcons_16.Badge] = "61743", _a[BlueprintIcons_16.BanCircle] = "61744", _a[BlueprintIcons_16.BankAccount] = "61745", _a[BlueprintIcons_16.Barcode] = "61746", _a[BlueprintIcons_16.BinaryNumber] = "62295", _a[BlueprintIcons_16.Blank] = "61747", _a[BlueprintIcons_16.BlockPromote] = "62322", _a[BlueprintIcons_16.BlockedPerson] = "61748", _a[BlueprintIcons_16.Bold] = "61749", _a[BlueprintIcons_16.Book] = "61750", _a[BlueprintIcons_16.Bookmark] = "61751", _a[BlueprintIcons_16.Box] = "61752", _a[BlueprintIcons_16.Briefcase] = "61753", _a[BlueprintIcons_16.BringData] = "61754", _a[BlueprintIcons_16.BringForward] = "62292", _a[BlueprintIcons_16.BritishPound] = "62342", _a[BlueprintIcons_16.Bug] = "62254", _a[BlueprintIcons_16.Buggy] = "61755", _a[BlueprintIcons_16.Build] = "61756", _a[BlueprintIcons_16.Bullseye] = "62297", _a[BlueprintIcons_16.Calculator] = "61757", _a[BlueprintIcons_16.Calendar] = "61758", _a[BlueprintIcons_16.Camera] = "61759", _a[BlueprintIcons_16.CaretDown] = "61760", _a[BlueprintIcons_16.CaretLeft] = "61761", _a[BlueprintIcons_16.CaretRight] = "61762", _a[BlueprintIcons_16.CaretUp] = "61763", _a[BlueprintIcons_16.CargoShip] = "61764", _a[BlueprintIcons_16.CellTower] = "61765", _a[BlueprintIcons_16.Changes] = "61766", _a[BlueprintIcons_16.Chart] = "61767", _a[BlueprintIcons_16.Chat] = "61768", _a[BlueprintIcons_16.ChevronBackward] = "61769", _a[BlueprintIcons_16.ChevronDown] = "61770", _a[BlueprintIcons_16.ChevronForward] = "61771", _a[BlueprintIcons_16.ChevronLeft] = "61772", _a[BlueprintIcons_16.ChevronRight] = "61773", _a[BlueprintIcons_16.ChevronUp] = "61774", _a[BlueprintIcons_16.CircleArrowDown] = "61775", _a[BlueprintIcons_16.CircleArrowLeft] = "61776", _a[BlueprintIcons_16.CircleArrowRight] = "61777", _a[BlueprintIcons_16.CircleArrowUp] = "61778", _a[BlueprintIcons_16.Circle] = "61779", _a[BlueprintIcons_16.Citation] = "61780", _a[BlueprintIcons_16.Clean] = "61781", _a[BlueprintIcons_16.Clip] = "61782", _a[BlueprintIcons_16.ClipboardFile] = "62299", _a[BlueprintIcons_16.Clipboard] = "61783", _a[BlueprintIcons_16.CloudDownload] = "61784", _a[BlueprintIcons_16.CloudServer] = "62298", _a[BlueprintIcons_16.CloudTick] = "62286", _a[BlueprintIcons_16.CloudUpload] = "61785", _a[BlueprintIcons_16.Cloud] = "61786", _a[BlueprintIcons_16.CodeBlock] = "61787", _a[BlueprintIcons_16.Code] = "61788", _a[BlueprintIcons_16.Cog] = "61789", _a[BlueprintIcons_16.CollapseAll] = "61790", _a[BlueprintIcons_16.ColorFill] = "62248", _a[BlueprintIcons_16.ColumnLayout] = "61791", _a[BlueprintIcons_16.Comment] = "61792", _a[BlueprintIcons_16.Comparison] = "61793", _a[BlueprintIcons_16.Compass] = "61794", _a[BlueprintIcons_16.Compressed] = "61795", _a[BlueprintIcons_16.Confirm] = "61796", _a[BlueprintIcons_16.Console] = "61797", _a[BlueprintIcons_16.Contrast] = "61798", _a[BlueprintIcons_16.Control] = "61799", _a[BlueprintIcons_16.CreditCard] = "61800", _a[BlueprintIcons_16.Crop] = "62291", _a[BlueprintIcons_16.CrossCircle] = "62262", _a[BlueprintIcons_16.Cross] = "61801", _a[BlueprintIcons_16.Crown] = "61802", _a[BlueprintIcons_16.CssStyle] = "62315", _a[BlueprintIcons_16.CubeAdd] = "61803", _a[BlueprintIcons_16.CubeEdit] = "62339", _a[BlueprintIcons_16.CubeRemove] = "61804", _a[BlueprintIcons_16.Cube] = "61805", _a[BlueprintIcons_16.Cubes] = "62323", _a[BlueprintIcons_16.CurlyBraces] = "62296", _a[BlueprintIcons_16.CurvedRangeChart] = "61806", _a[BlueprintIcons_16.Cut] = "61807", _a[BlueprintIcons_16.Cycle] = "61808", _a[BlueprintIcons_16.Dashboard] = "61809", _a[BlueprintIcons_16.DataConnection] = "61810", _a[BlueprintIcons_16.DataLineage] = "61811", _a[BlueprintIcons_16.DataSearch] = "62319", _a[BlueprintIcons_16.DataSync] = "62316", _a[BlueprintIcons_16.Database] = "61812", _a[BlueprintIcons_16.Delete] = "61813", _a[BlueprintIcons_16.Delta] = "61814", _a[BlueprintIcons_16.DeriveColumn] = "61815", _a[BlueprintIcons_16.Desktop] = "61816", _a[BlueprintIcons_16.Detection] = "62273", _a[BlueprintIcons_16.Diagnosis] = "61817", _a[BlueprintIcons_16.DiagramTree] = "61818", _a[BlueprintIcons_16.DirectionLeft] = "61819", _a[BlueprintIcons_16.DirectionRight] = "61820", _a[BlueprintIcons_16.Disable] = "61821", _a[BlueprintIcons_16.Divide] = "62247", _a[BlueprintIcons_16.DocumentOpen] = "61822", _a[BlueprintIcons_16.DocumentShare] = "61823", _a[BlueprintIcons_16.Document] = "61824", _a[BlueprintIcons_16.Dollar] = "61825", _a[BlueprintIcons_16.Dot] = "61826", _a[BlueprintIcons_16.DoubleCaretHorizontal] = "61827", _a[BlueprintIcons_16.DoubleCaretVertical] = "61828", _a[BlueprintIcons_16.DoubleChevronDown] = "61829", _a[BlueprintIcons_16.DoubleChevronLeft] = "61830", _a[BlueprintIcons_16.DoubleChevronRight] = "61831", _a[BlueprintIcons_16.DoubleChevronUp] = "61832", _a[BlueprintIcons_16.DoughnutChart] = "61833", _a[BlueprintIcons_16.Download] = "61834", _a[BlueprintIcons_16.DragHandleHorizontal] = "61835", _a[BlueprintIcons_16.DragHandleVertical] = "61836", _a[BlueprintIcons_16.Draw] = "61837", _a[BlueprintIcons_16.DrawerLeftFilled] = "61838", _a[BlueprintIcons_16.DrawerLeft] = "61839", _a[BlueprintIcons_16.DrawerRightFilled] = "61840", _a[BlueprintIcons_16.DrawerRight] = "61841", _a[BlueprintIcons_16.DriveTime] = "61842", _a[BlueprintIcons_16.Duplicate] = "61843", _a[BlueprintIcons_16.Edit] = "61844", _a[BlueprintIcons_16.Eject] = "61845", _a[BlueprintIcons_16.Emoji] = "61846", _a[BlueprintIcons_16.Endnote] = "62294", _a[BlueprintIcons_16.Endorsed] = "61847", _a[BlueprintIcons_16.Envelope] = "61848", _a[BlueprintIcons_16.Equals] = "61849", _a[BlueprintIcons_16.Eraser] = "61850", _a[BlueprintIcons_16.Error] = "61851", _a[BlueprintIcons_16.Euro] = "61852", _a[BlueprintIcons_16.Excavator] = "62317", _a[BlueprintIcons_16.Exchange] = "61853", _a[BlueprintIcons_16.ExcludeRow] = "61854", _a[BlueprintIcons_16.ExpandAll] = "61855", _a[BlueprintIcons_16.Explain] = "62285", _a[BlueprintIcons_16.Export] = "61856", _a[BlueprintIcons_16.EyeOff] = "61857", _a[BlueprintIcons_16.EyeOn] = "61858", _a[BlueprintIcons_16.EyeOpen] = "61859", _a[BlueprintIcons_16.FastBackward] = "61860", _a[BlueprintIcons_16.FastForward] = "61861", _a[BlueprintIcons_16.FeedSubscribed] = "61862", _a[BlueprintIcons_16.Feed] = "61863", _a[BlueprintIcons_16.FighterJet] = "62340", _a[BlueprintIcons_16.Film] = "61864", _a[BlueprintIcons_16.FilterKeep] = "61865", _a[BlueprintIcons_16.FilterList] = "61866", _a[BlueprintIcons_16.FilterOpen] = "61867", _a[BlueprintIcons_16.FilterRemove] = "61868", _a[BlueprintIcons_16.FilterSortAsc] = "62350", _a[BlueprintIcons_16.FilterSortDesc] = "62351", _a[BlueprintIcons_16.Filter] = "61869", _a[BlueprintIcons_16.Flag] = "61870", _a[BlueprintIcons_16.Flame] = "61871", _a[BlueprintIcons_16.Flash] = "61872", _a[BlueprintIcons_16.FloatingPoint] = "62252", _a[BlueprintIcons_16.FloppyDisk] = "61873", _a[BlueprintIcons_16.FlowBranch] = "61874", _a[BlueprintIcons_16.FlowEnd] = "61875", _a[BlueprintIcons_16.FlowLinear] = "61876", _a[BlueprintIcons_16.FlowReviewBranch] = "61877", _a[BlueprintIcons_16.FlowReview] = "61878", _a[BlueprintIcons_16.Flows] = "61879", _a[BlueprintIcons_16.FolderClose] = "61880", _a[BlueprintIcons_16.FolderNew] = "61881", _a[BlueprintIcons_16.FolderOpen] = "61882", _a[BlueprintIcons_16.FolderSharedOpen] = "61883", _a[BlueprintIcons_16.FolderShared] = "61884", _a[BlueprintIcons_16.Follower] = "61885", _a[BlueprintIcons_16.Following] = "61886", _a[BlueprintIcons_16.Font] = "61887", _a[BlueprintIcons_16.Fork] = "61888", _a[BlueprintIcons_16.Form] = "61889", _a[BlueprintIcons_16.ForwardTen] = "62301", _a[BlueprintIcons_16.Fuel] = "62243", _a[BlueprintIcons_16.FullCircle] = "61890", _a[BlueprintIcons_16.FullStackedChart] = "61891", _a[BlueprintIcons_16.Fullscreen] = "61892", _a[BlueprintIcons_16.Function] = "61893", _a[BlueprintIcons_16.GanttChart] = "61894", _a[BlueprintIcons_16.Generate] = "62284", _a[BlueprintIcons_16.Geofence] = "61895", _a[BlueprintIcons_16.Geolocation] = "61896", _a[BlueprintIcons_16.Geosearch] = "61897", _a[BlueprintIcons_16.Geotime] = "62276", _a[BlueprintIcons_16.GitBranch] = "61898", _a[BlueprintIcons_16.GitCommit] = "61899", _a[BlueprintIcons_16.GitMerge] = "61900", _a[BlueprintIcons_16.GitNewBranch] = "61901", _a[BlueprintIcons_16.GitPull] = "61902", _a[BlueprintIcons_16.GitPush] = "61903", _a[BlueprintIcons_16.GitRepo] = "61904", _a[BlueprintIcons_16.Glass] = "61905", _a[BlueprintIcons_16.GlobeNetworkAdd] = "62338", _a[BlueprintIcons_16.GlobeNetwork] = "61906", _a[BlueprintIcons_16.Globe] = "61907", _a[BlueprintIcons_16.GraphRemove] = "61908", _a[BlueprintIcons_16.Graph] = "61909", _a[BlueprintIcons_16.GreaterThanOrEqualTo] = "61910", _a[BlueprintIcons_16.GreaterThan] = "61911", _a[BlueprintIcons_16.GridView] = "61912", _a[BlueprintIcons_16.Grid] = "61913", _a[BlueprintIcons_16.GroupItem] = "62282", _a[BlueprintIcons_16.GroupObjects] = "61914", _a[BlueprintIcons_16.GroupedBarChart] = "61915", _a[BlueprintIcons_16.HandDown] = "61916", _a[BlueprintIcons_16.HandLeft] = "61917", _a[BlueprintIcons_16.HandRight] = "61918", _a[BlueprintIcons_16.HandUp] = "61919", _a[BlueprintIcons_16.Hand] = "61920", _a[BlueprintIcons_16.Hat] = "61921", _a[BlueprintIcons_16.HeaderOne] = "61922", _a[BlueprintIcons_16.HeaderThree] = "61923", _a[BlueprintIcons_16.HeaderTwo] = "61924", _a[BlueprintIcons_16.Header] = "61925", _a[BlueprintIcons_16.Headset] = "61926", _a[BlueprintIcons_16.HeartBroken] = "61927", _a[BlueprintIcons_16.Heart] = "61928", _a[BlueprintIcons_16.HeatGrid] = "61929", _a[BlueprintIcons_16.Heatmap] = "61930", _a[BlueprintIcons_16.Helicopter] = "61931", _a[BlueprintIcons_16.Help] = "61932", _a[BlueprintIcons_16.HelperManagement] = "61933", _a[BlueprintIcons_16.Hexagon] = "62324", _a[BlueprintIcons_16.HighPriority] = "61934", _a[BlueprintIcons_16.HighVoltagePole] = "62259", _a[BlueprintIcons_16.Highlight] = "61935", _a[BlueprintIcons_16.History] = "61936", _a[BlueprintIcons_16.Home] = "61937", _a[BlueprintIcons_16.HorizontalBarChartAsc] = "61938", _a[BlueprintIcons_16.HorizontalBarChartDesc] = "61939", _a[BlueprintIcons_16.HorizontalBarChart] = "61940", _a[BlueprintIcons_16.HorizontalDistribution] = "61941", _a[BlueprintIcons_16.HorizontalInbetween] = "62249", _a[BlueprintIcons_16.Hurricane] = "61942", _a[BlueprintIcons_16.IdNumber] = "61943", _a[BlueprintIcons_16.ImageRotateLeft] = "61944", _a[BlueprintIcons_16.ImageRotateRight] = "61945", _a[BlueprintIcons_16.Import] = "61946", _a[BlueprintIcons_16.InboxFiltered] = "61947", _a[BlueprintIcons_16.InboxGeo] = "61948", _a[BlueprintIcons_16.InboxSearch] = "61949", _a[BlueprintIcons_16.InboxUpdate] = "61950", _a[BlueprintIcons_16.Inbox] = "61951", _a[BlueprintIcons_16.InfoSign] = "61952", _a[BlueprintIcons_16.Inheritance] = "61953", _a[BlueprintIcons_16.InheritedGroup] = "61954", _a[BlueprintIcons_16.InnerJoin] = "61955", _a[BlueprintIcons_16.Input] = "62283", _a[BlueprintIcons_16.Insert] = "61956", _a[BlueprintIcons_16.Intelligence] = "62263", _a[BlueprintIcons_16.Intersection] = "61957", _a[BlueprintIcons_16.IpAddress] = "61958", _a[BlueprintIcons_16.IssueClosed] = "61959", _a[BlueprintIcons_16.IssueNew] = "61960", _a[BlueprintIcons_16.Issue] = "61961", _a[BlueprintIcons_16.Italic] = "61962", _a[BlueprintIcons_16.JoinTable] = "61963", _a[BlueprintIcons_16.KeyBackspace] = "61964", _a[BlueprintIcons_16.KeyCommand] = "61965", _a[BlueprintIcons_16.KeyControl] = "61966", _a[BlueprintIcons_16.KeyDelete] = "61967", _a[BlueprintIcons_16.KeyEnter] = "61968", _a[BlueprintIcons_16.KeyEscape] = "61969", _a[BlueprintIcons_16.KeyOption] = "61970", _a[BlueprintIcons_16.KeyShift] = "61971", _a[BlueprintIcons_16.KeyTab] = "61972", _a[BlueprintIcons_16.Key] = "61973", _a[BlueprintIcons_16.KnownVehicle] = "61974", _a[BlueprintIcons_16.LabTest] = "61975", _a[BlueprintIcons_16.Label] = "61976", _a[BlueprintIcons_16.LayerOutline] = "61977", _a[BlueprintIcons_16.Layer] = "61978", _a[BlueprintIcons_16.Layers] = "61979", _a[BlueprintIcons_16.LayoutAuto] = "61980", _a[BlueprintIcons_16.LayoutBalloon] = "61981", _a[BlueprintIcons_16.LayoutBottomRowThreeTiles] = "62308", _a[BlueprintIcons_16.LayoutBottomRowTwoTiles] = "62307", _a[BlueprintIcons_16.LayoutCircle] = "61982", _a[BlueprintIcons_16.LayoutGrid] = "61983", _a[BlueprintIcons_16.LayoutGroupBy] = "61984", _a[BlueprintIcons_16.LayoutHierarchy] = "61985", _a[BlueprintIcons_16.LayoutLeftColumnThreeTiles] = "62310", _a[BlueprintIcons_16.LayoutLeftColumnTwoTiles] = "62309", _a[BlueprintIcons_16.LayoutLinear] = "61986", _a[BlueprintIcons_16.LayoutRightColumnThreeTiles] = "62312", _a[BlueprintIcons_16.LayoutRightColumnTwoTiles] = "62311", _a[BlueprintIcons_16.LayoutSkewGrid] = "61987", _a[BlueprintIcons_16.LayoutSortedClusters] = "61988", _a[BlueprintIcons_16.LayoutThreeColumns] = "62305", _a[BlueprintIcons_16.LayoutThreeRows] = "62306", _a[BlueprintIcons_16.LayoutTopRowThreeTiles] = "62314", _a[BlueprintIcons_16.LayoutTopRowTwoTiles] = "62313", _a[BlueprintIcons_16.LayoutTwoColumns] = "62303", _a[BlueprintIcons_16.LayoutTwoRows] = "62304", _a[BlueprintIcons_16.Layout] = "61989", _a[BlueprintIcons_16.Learning] = "61990", _a[BlueprintIcons_16.LeftJoin] = "61991", _a[BlueprintIcons_16.LengthenText] = "62270", _a[BlueprintIcons_16.LessThanOrEqualTo] = "61992", _a[BlueprintIcons_16.LessThan] = "61993", _a[BlueprintIcons_16.Lifesaver] = "61994", _a[BlueprintIcons_16.Lightbulb] = "61995", _a[BlueprintIcons_16.Lightning] = "61996", _a[BlueprintIcons_16.Link] = "61997", _a[BlueprintIcons_16.LinkedSquares] = "62341", _a[BlueprintIcons_16.ListColumns] = "61998", _a[BlueprintIcons_16.ListDetailView] = "61999", _a[BlueprintIcons_16.List] = "62000", _a[BlueprintIcons_16.Locate] = "62001", _a[BlueprintIcons_16.Lock] = "62002", _a[BlueprintIcons_16.Locomotive] = "62267", _a[BlueprintIcons_16.LogIn] = "62003", _a[BlueprintIcons_16.LogOut] = "62004", _a[BlueprintIcons_16.LowVoltagePole] = "62258", _a[BlueprintIcons_16.Manual] = "62005", _a[BlueprintIcons_16.ManuallyEnteredData] = "62006", _a[BlueprintIcons_16.ManyToMany] = "62007", _a[BlueprintIcons_16.ManyToOne] = "62008", _a[BlueprintIcons_16.MapCreate] = "62009", _a[BlueprintIcons_16.MapMarker] = "62010", _a[BlueprintIcons_16.Map] = "62011", _a[BlueprintIcons_16.Maximize] = "62012", _a[BlueprintIcons_16.Media] = "62013", _a[BlueprintIcons_16.MenuClosed] = "62014", _a[BlueprintIcons_16.MenuOpen] = "62015", _a[BlueprintIcons_16.Menu] = "62016", _a[BlueprintIcons_16.MergeColumns] = "62017", _a[BlueprintIcons_16.MergeLinks] = "62018", _a[BlueprintIcons_16.Microphone] = "62275", _a[BlueprintIcons_16.Minimize] = "62019", _a[BlueprintIcons_16.Minus] = "62020", _a[BlueprintIcons_16.MobilePhone] = "62021", _a[BlueprintIcons_16.MobileVideo] = "62022", _a[BlueprintIcons_16.ModalFilled] = "62023", _a[BlueprintIcons_16.Modal] = "62024", _a[BlueprintIcons_16.Model] = "62269", _a[BlueprintIcons_16.Moon] = "62025", _a[BlueprintIcons_16.More] = "62026", _a[BlueprintIcons_16.Mountain] = "62027", _a[BlueprintIcons_16.Move] = "62028", _a[BlueprintIcons_16.Mugshot] = "62029", _a[BlueprintIcons_16.MultiSelect] = "62030", _a[BlueprintIcons_16.Music] = "62031", _a[BlueprintIcons_16.Nest] = "62032", _a[BlueprintIcons_16.NewDrawing] = "62033", _a[BlueprintIcons_16.NewGridItem] = "62034", _a[BlueprintIcons_16.NewLayer] = "62035", _a[BlueprintIcons_16.NewLayers] = "62036", _a[BlueprintIcons_16.NewLink] = "62037", _a[BlueprintIcons_16.NewObject] = "62038", _a[BlueprintIcons_16.NewPerson] = "62039", _a[BlueprintIcons_16.NewPrescription] = "62040", _a[BlueprintIcons_16.NewShield] = "62281", _a[BlueprintIcons_16.NewTextBox] = "62041", _a[BlueprintIcons_16.Ninja] = "62042", _a[BlueprintIcons_16.NotEqualTo] = "62043", _a[BlueprintIcons_16.NotificationsSnooze] = "62044", _a[BlueprintIcons_16.NotificationsUpdated] = "62045", _a[BlueprintIcons_16.Notifications] = "62046", _a[BlueprintIcons_16.NumberedList] = "62047", _a[BlueprintIcons_16.Numerical] = "62048", _a[BlueprintIcons_16.ObjectView] = "62352", _a[BlueprintIcons_16.Office] = "62049", _a[BlueprintIcons_16.Offline] = "62050", _a[BlueprintIcons_16.OilField] = "62051", _a[BlueprintIcons_16.OneColumn] = "62052", _a[BlueprintIcons_16.OneToMany] = "62053", _a[BlueprintIcons_16.OneToOne] = "62054", _a[BlueprintIcons_16.OpenApplication] = "62251", _a[BlueprintIcons_16.Outdated] = "62055", _a[BlueprintIcons_16.Output] = "62320", _a[BlueprintIcons_16.Package] = "62325", _a[BlueprintIcons_16.PageLayout] = "62056", _a[BlueprintIcons_16.PanelStats] = "62057", _a[BlueprintIcons_16.PanelTable] = "62058", _a[BlueprintIcons_16.Panel] = "62337", _a[BlueprintIcons_16.Paperclip] = "62059", _a[BlueprintIcons_16.Paragraph] = "62060", _a[BlueprintIcons_16.PasteVariable] = "62278", _a[BlueprintIcons_16.PathSearch] = "62061", _a[BlueprintIcons_16.Path] = "62062", _a[BlueprintIcons_16.Pause] = "62063", _a[BlueprintIcons_16.People] = "62064", _a[BlueprintIcons_16.Percentage] = "62065", _a[BlueprintIcons_16.Person] = "62066", _a[BlueprintIcons_16.PhoneCall] = "62279", _a[BlueprintIcons_16.PhoneForward] = "62280", _a[BlueprintIcons_16.Phone] = "62067", _a[BlueprintIcons_16.PieChart] = "62068", _a[BlueprintIcons_16.Pill] = "62326", _a[BlueprintIcons_16.Pin] = "62069", _a[BlueprintIcons_16.PivotTable] = "62070", _a[BlueprintIcons_16.Pivot] = "62071", _a[BlueprintIcons_16.Play] = "62072", _a[BlueprintIcons_16.Playbook] = "62244", _a[BlueprintIcons_16.Plus] = "62073", _a[BlueprintIcons_16.PolygonFilter] = "62074", _a[BlueprintIcons_16.Power] = "62075", _a[BlueprintIcons_16.PredictiveAnalysis] = "62076", _a[BlueprintIcons_16.Prescription] = "62077", _a[BlueprintIcons_16.Presentation] = "62078", _a[BlueprintIcons_16.Print] = "62079", _a[BlueprintIcons_16.Projects] = "62080", _a[BlueprintIcons_16.Properties] = "62081", _a[BlueprintIcons_16.Property] = "62082", _a[BlueprintIcons_16.PublishFunction] = "62083", _a[BlueprintIcons_16.Pulse] = "62084", _a[BlueprintIcons_16.Rain] = "62085", _a[BlueprintIcons_16.Random] = "62086", _a[BlueprintIcons_16.RangeRing] = "62321", _a[BlueprintIcons_16.Record] = "62087", _a[BlueprintIcons_16.RectHeight] = "62245", _a[BlueprintIcons_16.RectWidth] = "62246", _a[BlueprintIcons_16.Rectangle] = "62241", _a[BlueprintIcons_16.Redo] = "62088", _a[BlueprintIcons_16.Refresh] = "62089", _a[BlueprintIcons_16.Regex] = "62255", _a[BlueprintIcons_16.RegressionChart] = "62090", _a[BlueprintIcons_16.RemoveColumnLeft] = "62091", _a[BlueprintIcons_16.RemoveColumnRight] = "62092", _a[BlueprintIcons_16.RemoveColumn] = "62093", _a[BlueprintIcons_16.RemoveRowBottom] = "62094", _a[BlueprintIcons_16.RemoveRowTop] = "62095", _a[BlueprintIcons_16.Remove] = "62096", _a[BlueprintIcons_16.Repeat] = "62097", _a[BlueprintIcons_16.Reset] = "62098", _a[BlueprintIcons_16.Resolve] = "62099", _a[BlueprintIcons_16.Rig] = "62100", _a[BlueprintIcons_16.RightJoin] = "62101", _a[BlueprintIcons_16.Ring] = "62102", _a[BlueprintIcons_16.RocketSlant] = "62103", _a[BlueprintIcons_16.Rocket] = "62104", _a[BlueprintIcons_16.RotateCcw] = "62345", _a[BlueprintIcons_16.RotateCw] = "62344", _a[BlueprintIcons_16.RotateDocument] = "62105", _a[BlueprintIcons_16.RotatePage] = "62106", _a[BlueprintIcons_16.Route] = "62107", _a[BlueprintIcons_16.Satellite] = "62108", _a[BlueprintIcons_16.Saved] = "62109", _a[BlueprintIcons_16.ScatterPlot] = "62110", _a[BlueprintIcons_16.SearchAround] = "62111", _a[BlueprintIcons_16.SearchTemplate] = "62112", _a[BlueprintIcons_16.SearchText] = "62113", _a[BlueprintIcons_16.Search] = "62114", _a[BlueprintIcons_16.SegmentedControl] = "62115", _a[BlueprintIcons_16.Select] = "62116", _a[BlueprintIcons_16.Selection] = "62117", _a[BlueprintIcons_16.SendBackward] = "62293", _a[BlueprintIcons_16.SendMessage] = "62118", _a[BlueprintIcons_16.SendToGraph] = "62119", _a[BlueprintIcons_16.SendToMap] = "62120", _a[BlueprintIcons_16.SendTo] = "62121", _a[BlueprintIcons_16.Sensor] = "62268", _a[BlueprintIcons_16.SeriesAdd] = "62122", _a[BlueprintIcons_16.SeriesConfiguration] = "62123", _a[BlueprintIcons_16.SeriesDerived] = "62124", _a[BlueprintIcons_16.SeriesFiltered] = "62125", _a[BlueprintIcons_16.SeriesSearch] = "62126", _a[BlueprintIcons_16.ServerInstall] = "62327", _a[BlueprintIcons_16.Server] = "62328", _a[BlueprintIcons_16.Settings] = "62127", _a[BlueprintIcons_16.Shapes] = "62128", _a[BlueprintIcons_16.Share] = "62129", _a[BlueprintIcons_16.SharedFilter] = "62130", _a[BlueprintIcons_16.Shield] = "62131", _a[BlueprintIcons_16.Ship] = "62132", _a[BlueprintIcons_16.Shop] = "62133", _a[BlueprintIcons_16.ShoppingCart] = "62134", _a[BlueprintIcons_16.ShortenText] = "62271", _a[BlueprintIcons_16.SignalSearch] = "62135", _a[BlueprintIcons_16.SimCard] = "62136", _a[BlueprintIcons_16.Slash] = "62137", _a[BlueprintIcons_16.SmallCross] = "62138", _a[BlueprintIcons_16.SmallInfoSign] = "62260", _a[BlueprintIcons_16.SmallMinus] = "62139", _a[BlueprintIcons_16.SmallPlus] = "62140", _a[BlueprintIcons_16.SmallSquare] = "62141", _a[BlueprintIcons_16.SmallTick] = "62142", _a[BlueprintIcons_16.Snowflake] = "62143", _a[BlueprintIcons_16.SoccerBall] = "62288", _a[BlueprintIcons_16.SocialMedia] = "62144", _a[BlueprintIcons_16.SortAlphabeticalDesc] = "62145", _a[BlueprintIcons_16.SortAlphabetical] = "62146", _a[BlueprintIcons_16.SortAsc] = "62147", _a[BlueprintIcons_16.SortDesc] = "62148", _a[BlueprintIcons_16.SortNumericalDesc] = "62149", _a[BlueprintIcons_16.SortNumerical] = "62150", _a[BlueprintIcons_16.Sort] = "62151", _a[BlueprintIcons_16.SpellCheck] = "62272", _a[BlueprintIcons_16.SplitColumns] = "62152", _a[BlueprintIcons_16.SportsStadium] = "62289", _a[BlueprintIcons_16.Square] = "62153", _a[BlueprintIcons_16.StackedChart] = "62154", _a[BlueprintIcons_16.StadiumGeometry] = "62155", _a[BlueprintIcons_16.StarEmpty] = "62156", _a[BlueprintIcons_16.Star] = "62157", _a[BlueprintIcons_16.StepBackward] = "62158", _a[BlueprintIcons_16.StepChart] = "62159", _a[BlueprintIcons_16.StepForward] = "62160", _a[BlueprintIcons_16.Stop] = "62161", _a[BlueprintIcons_16.Stopwatch] = "62162", _a[BlueprintIcons_16.Strikethrough] = "62163", _a[BlueprintIcons_16.Style] = "62164", _a[BlueprintIcons_16.Subscript] = "62265", _a[BlueprintIcons_16.Superscript] = "62266", _a[BlueprintIcons_16.SwapHorizontal] = "62165", _a[BlueprintIcons_16.SwapVertical] = "62166", _a[BlueprintIcons_16.Switch] = "62167", _a[BlueprintIcons_16.SymbolCircle] = "62168", _a[BlueprintIcons_16.SymbolCross] = "62169", _a[BlueprintIcons_16.SymbolDiamond] = "62170", _a[BlueprintIcons_16.SymbolRectangle] = "62242", _a[BlueprintIcons_16.SymbolSquare] = "62171", _a[BlueprintIcons_16.SymbolTriangleDown] = "62172", _a[BlueprintIcons_16.SymbolTriangleUp] = "62173", _a[BlueprintIcons_16.Syringe] = "62174", _a[BlueprintIcons_16.TableSync] = "62318", _a[BlueprintIcons_16.TagAdd] = "62329", _a[BlueprintIcons_16.TagPromote] = "62330", _a[BlueprintIcons_16.TagRefresh] = "62331", _a[BlueprintIcons_16.TagUndo] = "62332", _a[BlueprintIcons_16.Tag] = "62175", _a[BlueprintIcons_16.Tags] = "62333", _a[BlueprintIcons_16.TakeAction] = "62176", _a[BlueprintIcons_16.Tank] = "62177", _a[BlueprintIcons_16.Target] = "62178", _a[BlueprintIcons_16.Taxi] = "62179", _a[BlueprintIcons_16.Team] = "62290", _a[BlueprintIcons_16.Temperature] = "62180", _a[BlueprintIcons_16.TextHighlight] = "62181", _a[BlueprintIcons_16.ThAdd] = "62346", _a[BlueprintIcons_16.ThDerived] = "62182", _a[BlueprintIcons_16.ThDisconnect] = "62183", _a[BlueprintIcons_16.ThFiltered] = "62184", _a[BlueprintIcons_16.ThListAdd] = "62347", _a[BlueprintIcons_16.ThList] = "62185", _a[BlueprintIcons_16.ThVirtualAdd] = "62349", _a[BlueprintIcons_16.ThVirtual] = "62348", _a[BlueprintIcons_16.Th] = "62186", _a[BlueprintIcons_16.ThirdParty] = "62187", _a[BlueprintIcons_16.ThumbsDown] = "62188", _a[BlueprintIcons_16.ThumbsUp] = "62189", _a[BlueprintIcons_16.TickCircle] = "62190", _a[BlueprintIcons_16.Tick] = "62191", _a[BlueprintIcons_16.Time] = "62192", _a[BlueprintIcons_16.TimelineAreaChart] = "62193", _a[BlueprintIcons_16.TimelineBarChart] = "62194", _a[BlueprintIcons_16.TimelineEvents] = "62195", _a[BlueprintIcons_16.TimelineLineChart] = "62196", _a[BlueprintIcons_16.Tint] = "62197", _a[BlueprintIcons_16.Torch] = "62198", _a[BlueprintIcons_16.Tractor] = "62199", _a[BlueprintIcons_16.Train] = "62200", _a[BlueprintIcons_16.Translate] = "62201", _a[BlueprintIcons_16.Trash] = "62202", _a[BlueprintIcons_16.Tree] = "62203", _a[BlueprintIcons_16.TrendingDown] = "62204", _a[BlueprintIcons_16.TrendingUp] = "62205", _a[BlueprintIcons_16.Trophy] = "62287", _a[BlueprintIcons_16.Truck] = "62206", _a[BlueprintIcons_16.TwoColumns] = "62207", _a[BlueprintIcons_16.Unarchive] = "62208", _a[BlueprintIcons_16.Underline] = "62209", _a[BlueprintIcons_16.Undo] = "62210", _a[BlueprintIcons_16.UngroupObjects] = "62211", _a[BlueprintIcons_16.UnknownVehicle] = "62212", _a[BlueprintIcons_16.Unlink] = "62277", _a[BlueprintIcons_16.Unlock] = "62213", _a[BlueprintIcons_16.Unpin] = "62214", _a[BlueprintIcons_16.Unresolve] = "62215", _a[BlueprintIcons_16.Updated] = "62216", _a[BlueprintIcons_16.Upload] = "62217", _a[BlueprintIcons_16.User] = "62218", _a[BlueprintIcons_16.Variable] = "62219", _a[BlueprintIcons_16.Vector] = "62302", _a[BlueprintIcons_16.VerticalBarChartAsc] = "62220", _a[BlueprintIcons_16.VerticalBarChartDesc] = "62221", _a[BlueprintIcons_16.VerticalDistribution] = "62222", _a[BlueprintIcons_16.VerticalInbetween] = "62250", _a[BlueprintIcons_16.Video] = "62223", _a[BlueprintIcons_16.Virus] = "62224", _a[BlueprintIcons_16.VolumeDown] = "62225", _a[BlueprintIcons_16.VolumeOff] = "62226", _a[BlueprintIcons_16.VolumeUp] = "62227", _a[BlueprintIcons_16.Walk] = "62228", _a[BlueprintIcons_16.WarningSign] = "62229", _a[BlueprintIcons_16.WaterfallChart] = "62230", _a[BlueprintIcons_16.Waves] = "62231", _a[BlueprintIcons_16.WidgetButton] = "62232", _a[BlueprintIcons_16.WidgetFooter] = "62233", _a[BlueprintIcons_16.WidgetHeader] = "62234", _a[BlueprintIcons_16.Widget] = "62235", _a[BlueprintIcons_16.Wind] = "62236", _a[BlueprintIcons_16.WrenchRedo] = "62334", _a[BlueprintIcons_16.WrenchSnooze] = "62335", _a[BlueprintIcons_16.WrenchTime] = "62336", _a[BlueprintIcons_16.Wrench] = "62237", _a[BlueprintIcons_16.ZoomIn] = "62238", _a[BlueprintIcons_16.ZoomOut] = "62239", _a[BlueprintIcons_16.ZoomToFit] = "62240", _a);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d33r6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wraps an async task with a performance timer. Only logs to console in development.
 */ parcelHelpers.export(exports, "wrapWithTimer", ()=>wrapWithTimer);
var _tslib = require("tslib");
/** Returns whether bundler-injected variable `NODE_ENV` equals `env`. */ function isNodeEnv(env) {
    return typeof NODE_ENV !== "undefined" && NODE_ENV === env;
}
function wrapWithTimer(taskDescription, task) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var shouldMeasure, start, time;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    shouldMeasure = isNodeEnv("development") && typeof performance !== "undefined";
                    /* eslint-disable no-console */ if (shouldMeasure) {
                        start = performance.now();
                        console.info("Started '".concat(taskDescription, "'..."));
                    }
                    return [
                        4 /*yield*/ ,
                        task()
                    ];
                case 1:
                    _a.sent();
                    if (shouldMeasure) {
                        time = Math.round(performance.now() - start);
                        console.info("Finished '".concat(taskDescription, "' in ").concat(time, "ms"));
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}

},{"tslib":"b4wpY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kYxK3":[function(require,module,exports,__globalThis) {
module.exports = require("80234502d93ae31f")(require("447492d45064c818").resolve("5rJ1p")).then(()=>module.bundle.root('5ZvQg'));

},{"80234502d93ae31f":"9wKyf","447492d45064c818":"gSiLw"}],"9wKyf":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"e8xyU"}],"e8xyU":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"8w9yZ":[function(require,module,exports,__globalThis) {
module.exports = require("180bd2a8da601958")(require("f48da70e6244e4fd").resolve("4RRE6")).then(()=>module.bundle.root('15doJ'));

},{"180bd2a8da601958":"9wKyf","f48da70e6244e4fd":"gSiLw"}],"1BB1X":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SVGIconContainer", ()=>SVGIconContainer);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _classes = require("./classes");
var _iconTypes = require("./iconTypes");
var _jsUtils = require("./jsUtils");
var SVGIconContainer = _react.forwardRef(function(props, ref) {
    var children = props.children, className = props.className, color = props.color, htmlTitle = props.htmlTitle, iconName = props.iconName, _a = props.size, size = _a === void 0 ? (0, _iconTypes.IconSize).STANDARD : _a, svgProps = props.svgProps, _b = props.tagName, tagName = _b === void 0 ? "span" : _b, title = props.title, htmlProps = (0, _tslib.__rest)(props, [
        "children",
        "className",
        "color",
        "htmlTitle",
        "iconName",
        "size",
        "svgProps",
        "tagName",
        "title"
    ]);
    var isLarge = size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var viewBox = "0 0 ".concat(pixelGridSize, " ").concat(pixelGridSize);
    var titleId = (0, _jsUtils.uniqueId)("iconTitle");
    var sharedSvgProps = (0, _tslib.__assign)({
        fill: color,
        height: size,
        role: "img",
        viewBox: viewBox,
        width: size
    }, svgProps);
    if (tagName === null) return _react.createElement("svg", (0, _tslib.__assign)({
        "aria-labelledby": title ? titleId : undefined,
        "data-icon": iconName,
        ref: ref
    }, sharedSvgProps, htmlProps, {
        className: (0, _classnamesDefault.default)(className, svgProps === null || svgProps === void 0 ? void 0 : svgProps.className)
    }), title && _react.createElement("title", {
        id: titleId
    }, title), children);
    else // N.B. styles for `Classes.ICON` are defined in @blueprintjs/core in `_icon.scss`
    return _react.createElement(tagName, (0, _tslib.__assign)((0, _tslib.__assign)({
        "aria-hidden": title ? undefined : true
    }, htmlProps), {
        className: (0, _classnamesDefault.default)(_classes.ICON, "".concat(_classes.ICON, "-").concat(iconName), className),
        ref: ref,
        title: htmlTitle
    }), _react.createElement("svg", (0, _tslib.__assign)({
        "data-icon": iconName
    }, sharedSvgProps, {
        className: svgProps === null || svgProps === void 0 ? void 0 : svgProps.className
    }), title && _react.createElement("title", null, title), children));
});
SVGIconContainer.displayName = "Blueprint5.SVGIconContainer";

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","./classes":"2mwF4","./iconTypes":"kknia","./jsUtils":"637Mh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2mwF4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ICON", ()=>ICON);
var NS = "bp5";
var ICON = "".concat(NS, "-icon");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"637Mh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Generate a unique ID within a given namespace, using a simple counter-based implementation to avoid collisions. */ parcelHelpers.export(exports, "uniqueId", ()=>uniqueId);
var uniqueCountForNamespace = new Map();
function uniqueId(namespace) {
    var _a;
    var curCount = (_a = uniqueCountForNamespace.get(namespace)) !== null && _a !== void 0 ? _a : 0;
    uniqueCountForNamespace.set(namespace, curCount + 1);
    return "".concat(namespace, "-").concat(curCount);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1lD7j":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The two icon sets are identical aside from SVG paths, so we only need to import info for the 16px set
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconCodepoints", ()=>IconCodepoints);
/**
 * Returns the hex code content string which represents the codepoint in the icon font
 * for a given icon. You can render this string to the DOM and if the icon font is loaded
 * as an active font family, this string will be replaced with the associated icon.
 */ parcelHelpers.export(exports, "getIconContentString", ()=>getIconContentString);
var _blueprintIcons16 = require("./generated/16px/blueprint-icons-16");
var IconCodepoints = (0, _blueprintIcons16.BLUEPRINT_ICONS_16_CODEPOINTS);
function getIconContentString(icon) {
    // parse base 10 number from string, then convert to hex code
    return String.fromCodePoint(parseInt(IconCodepoints[icon], 10));
}

},{"./generated/16px/blueprint-icons-16":"c4zZr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lVdW3":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddClip", ()=>AddClip);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AddClip = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "add-clip",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 400C311.046 400 320 391.0457 320 380V320H380C391.046 320 400 311.0456 400 300C400 288.9544 391.046 280 380 280H320V220C320 208.9542 311.046 200 300 200C288.954 200 280 208.9542 280 220V280H220C208.954 280 200 288.9544 200 300C200 311.0456 208.954 320 220 320H280V380C280 391.0457 288.954 400 300 400zM20 320C8.9543 320 0 311.0456 0 300V220C0 208.9544 8.9543 200 20 200C31.0456 200 40 208.9544 40 220V280H100C111.0456 280 120 288.9544 120 300C120 311.0456 111.0456 320 100 320H20zM0 20C0 8.954 8.9543 0 20 0H100C111.0456 0 120 8.954 120 20C120 31.046 111.0456 40 100 40H40V100C40 111.046 31.0456 120 20 120C8.9543 120 0 111.046 0 100V20zM300 0L220 0C208.954 0 200 8.954 200 20C200 31.046 208.954 40 220 40L280 40V100C280 111.046 288.954 120 300 120C311.046 120 320 111.046 320 100V20C320 8.954 311.046 0 300 0zM160 100C193.137 100 220 126.862 220 160C220 193.138 193.137 220 160 220C126.863 220 100 193.138 100 160C100 126.862 126.863 100 160 100z" : "M240 320C228.954 320 220 311.0457 220 300V260H180C168.9544 260 160 251.0456 160 240C160 228.9544 168.9542 220 180 220H220V180C220 168.9544 228.954 160 240 160C251.046 160 260 168.9544 260 180V220H300C311.046 220 320 228.9544 320 240C320 251.0456 311.046 260 300 260H260V300C260 311.0457 251.046 320 240 320zM0 240C0 251.0456 8.9543 260 20 260H90C101.0456 260 110 251.0456 110 240C110 228.9544 101.0456 220 90 220H40V180C40 168.9544 31.0456 160 20 160C8.9543 160 0 168.9544 0 180V240zM20 0C8.9543 0 0 8.954 0 20V80C0 91.046 8.9543 100 20 100C31.0456 100 40 91.046 40 80V40H90C101.0456 40 110 31.046 110 20C110 8.954 101.0456 0 90 0H20zM240 0C245.304 0 250.392 2.108 254.142 5.858C257.892 9.608 260 14.696 260 20V80C260 91.046 251.046 100 240 100C228.954 100 220 91.046 220 80V40L180 40C168.9544 40 160 31.046 160 20C160 8.954 168.9542 0 180 0L240 0zM130 80C157.6142 80 180 102.386 180 130C180 157.6142 157.6142 180 130 180C102.3858 180 80 157.6142 80 130C80 102.386 102.3858 80 130 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AddClip.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AddClip.displayName = "Blueprint5.Icon.AddClip";
exports.default = AddClip;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avrNy":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddColumnLeft", ()=>AddColumnLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AddColumnLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "add-column-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 180H120V140C120 129 129 120 140 120S160 129 160 140V180H200C211 180 220 189 220 200C220 211 211 220 200 220H160V260C160 271 151 280 140 280S120 271 120 260V220H80C69 220 60 211 60 200C60 189 69 180 80 180zM380 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM240 40H40V360H240V40zM360 40H260V360H360V40z" : "M300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM200 40H40V280H200V40zM280 40H220V280H280V40zM80 140H100V120C100 109 109 100 120 100S140 109 140 120V140H160C171 140 180 149 180 160C180 171 171 180 160 180H140V200C140 211 131 220 120 220S100 211 100 200V180H80C69 180 60 171 60 160C60 149 69 140 80 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AddColumnLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AddColumnLeft.displayName = "Blueprint5.Icon.AddColumnLeft";
exports.default = AddColumnLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lRtul":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddColumnRight", ()=>AddColumnRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AddColumnRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "add-column-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 180H240V140C240 129 249 120 260 120S280 129 280 140V180H320C331 180 340 189 340 200C340 211 331 220 320 220H280V260C280 271 271 280 260 280S240 271 240 260V220H200C189 220 180 211 180 200C180 189 189 180 200 180zM380 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM140 40H40V360H140V40zM360 40H160V360H360V40z" : "M160 140H180V120C180 109 189 100 200 100S220 109 220 120V140H240C251 140 260 149 260 160C260 171 251 180 240 180H220V200C220 211 211 220 200 220S180 211 180 200V180H160C149 180 140 171 140 160C140 149 149 140 160 140zM300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM100 40H40V280H100V40zM280 40H120V280H280V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AddColumnRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AddColumnRight.displayName = "Blueprint5.Icon.AddColumnRight";
exports.default = AddColumnRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jrt3n":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddLocation", ()=>AddLocation);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AddLocation = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "add-location",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C211.045694 400 220 391.045695 220 380C220 368.954305 211.045694 360 200 360C111.63444 360 40 288.36556 40 200C40 111.63444 111.63444 40 200 40C288.36556 40 360 111.63444 360 200C360 211.045695 368.954306 220 380 220C391.0456940000001 220 400 211.045695 400 200C400 89.54305 310.45695 0 200 0C89.54305 0 0 89.54305 0 200C0 310.45695 89.54305 400 200 400zM200 280C244.18278 280 280 244.18278 280 200C280 155.81722 244.18278 120 200 120C155.81722 120 120 155.81722 120 200C120 244.18278 155.81722 280 200 280zM320 400C332 400 340 392 340 380L340 380L340 340L380 340C392 340 400 332 400 320C400 308 392 300 380 300L380 300L340 300L340 260C340 248 332 240 320 240C308 240 300 248 300 260L300 260L300 300L260 300C248 300 240 308 240 320C240 330 248 340 260 340L260 340L300 340L300 380C300 392 308 400 320 400z" : "M160 320C171.045695 320 180 311.045695 180 300C180 288.954305 171.045695 280 160 280C93.72583 280 40 226.27417 40 160C40 93.72583 93.72583 40 160 40C226.2741700000001 40 280 93.72583 280 160C280 171.045695 288.9543060000001 180 300 180C311.045694 180 320 171.045695 320 160C320 71.63444 248.36556 0 160 0C71.63444 0 0 71.63444 0 160C0 248.36556 71.63444 320 160 320zM160 220C193.137085 220 220 193.137085 220 160C220 126.862915 193.137085 100 160 100C126.862915 100 100 126.862915 100 160C100 193.137085 126.862915 220 160 220zM260 320C271.045694 320 280 311.045695 280 300L280 280.02L300 280C311.045694 280 320 271.045695 320 260C320 248.954305 311.045694 240 300 240L280 240L280 220C280 208.954305 271.045694 200 260 200C248.954306 200 240 208.954305 240 220L240 240L220 240C208.954306 240 200 248.954305 200 260C200 271.045695 208.954306 280 220 280L240 280L240 300C240 311.045695 248.954306 320 260 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AddLocation.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AddLocation.displayName = "Blueprint5.Icon.AddLocation";
exports.default = AddLocation;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cWxpT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddRowBottom", ()=>AddRowBottom);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AddRowBottom = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "add-row-bottom",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM360 40H40V240H360V40zM360 260H40V360H360V260zM140 120H180V80C180 69 189 60 200 60S220 69 220 80V120H260C271 120 280 129 280 140C280 151 271 160 260 160H220V200C220 211 211 220 200 220S180 211 180 200V160H140C129 160 120 151 120 140C120 129 129 120 140 120z" : "M120 100H140V80C140 69 149 60 160 60S180 69 180 80V100H200C211 100 220 109 220 120C220 131 211 140 200 140H180V160C180 171 171 180 160 180S140 171 140 160V140H120C109 140 100 131 100 120C100 109 109 100 120 100zM300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM280 40H40V200H280V40zM280 220H40V280H280V220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AddRowBottom.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AddRowBottom.displayName = "Blueprint5.Icon.AddRowBottom";
exports.default = AddRowBottom;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5rL9V":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddRowTop", ()=>AddRowTop);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AddRowTop = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "add-row-top",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140 240H180V200C180 189 189 180 200 180S220 189 220 200V240H260C271 240 280 249 280 260C280 271 271 280 260 280H220V320C220 331 211 340 200 340S180 331 180 320V280H140C129 280 120 271 120 260C120 249 129 240 140 240zM380 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM360 40H40V140H360V40zM360 160H40V360H360V160z" : "M300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM280 40H40V100H280V40zM280 120H40V280H280V120zM120 180H140V160C140 149 149 140 160 140S180 149 180 160V180H200C211 180 220 189 220 200C220 211 211 220 200 220H180V240C180 251 171 260 160 260S140 251 140 240V220H120C109 220 100 211 100 200C100 189 109 180 120 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AddRowTop.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AddRowTop.displayName = "Blueprint5.Icon.AddRowTop";
exports.default = AddRowTop;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hCuzx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddToArtifact", ()=>AddToArtifact);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AddToArtifact = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "add-to-artifact",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260 160H20C9 160 0 151 0 140C0 129 9 120 20 120H260C271 120 280 129 280 140C280 151 271 160 260 160zM260 80H20C9 80 0 71 0 60C0 49 9 40 20 40H260C271 40 280 49 280 60C280 71 271 80 260 80zM20 280H200C211 280 220 289 220 300C220 311 211 320 200 320H20C9 320 0 311 0 300C0 289 9 280 20 280zM260 240H20C9 240 0 231 0 220C0 209 9 200 20 200H260C271 200 280 209 280 220C280 231 271 240 260 240zM380 320H340V360C340 371 331 380 320 380S300 371 300 360V320H260C249 320 240 311 240 300C240 289 249 280 260 280H300V240C300 229 309 220 320 220S340 229 340 240V280H380C391 280 400 289 400 300C400 311 391 320 380 320z" : "M280 239.8H260V259.8C260 270.8 251 279.8 240 279.8S220 270.8 220 259.8V239.8H200C189 239.8 180 230.8 180 219.8C180 208.8 189 199.8 200 199.8H220V179.8C220 168.8 229 159.8 240 159.8S260 168.8 260 179.8V199.8H280C291 199.8 300 208.8 300 219.8C300 231 291 239.8 280 239.8zM20 199.8H140C151 199.8 160 208.8 160 219.8C160 230.8 151 239.8 140 239.8H20C9 239.8 0 230.8 0 219.8C0 208.8 9 199.8 20 199.8zM180 79.8H20C9 79.8 0 70.8 0 59.8C0 48.8 9 39.8 20 39.8H180C191 39.8 200 48.8 200 59.8C200 71 191 79.8 180 79.8zM180 159.8H20C9 159.8 0 150.8 0 139.8C0 128.8 9 119.8 20 119.8H180C191 119.8 200 128.8 200 139.8C200 151 191 159.8 180 159.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AddToArtifact.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AddToArtifact.displayName = "Blueprint5.Icon.AddToArtifact";
exports.default = AddToArtifact;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hkcTz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddToFolder", ()=>AddToFolder);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AddToFolder = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "add-to-folder",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0.19990005 200L0.19990005 280L400 280L400 80C400 69 391.004498 60 380.009996 60L199.90005 60L199.90005 139.8C199.3073226 173.366448 172.6870804 200 139.730135 200L39.78011 200L0.19990005 200zM380.009996 340C391.004498 340 400 331 399.8001 320L399.8033680000001 300L0 300L0 360C0 371 8.99550224 380 19.990005 380L139.930035 380C145.5272364 380 150.5247376 377.8 154.1229386 374.2L188.305847 340L380.009996 340zM139.730135 160C150.7246376 160 159.72014 151 159.92004 139.8L159.92004 39.8C159.92004 28.8 150.9245378 19.8 139.930035 19.8C128.9355322 19.8 119.94003 28.8 119.94003 39.8L119.94003 91.6L34.1829086 5.8C30.5847076 2.2 25.5872064 0 19.990005 0C8.99550224 0 0 9 0 20C0 25.6 2.19890054 30.6 5.79710144 34.2L91.5542228 120L39.78011 120C28.7856072 120 19.79010494 129 19.79010494 140C19.79010494 151 28.7856072 160 39.78011 160L139.730135 160z" : "M0.199875078 180L0.199875078 220L320 220L320 80C320 69 311.005622 60 300.012492 60L180.0874454 60L180.0874454 119.8C179.494792 153.3664478 152.8778754 180 119.9250468 180L39.9750156 180L0.199875078 180zM300.012492 280L148.307308 280L114.1286696 314.2C110.5309182 317.8 105.5340412 320 99.937539 320L19.9875078 320C8.99437852 320 0 311 0 300L0 240L319.800124 240L319.800124 260C320 271 311.005622 280 300.012492 280zM119.9250468 140L39.9750156 140C28.9818864 140 19.9875078 131 19.9875078 120C19.9875078 109 28.9818864 100 39.9750156 100L71.755153 100L5.99625234 34.2C2.39850094 30.6 0.199875078 25.6 0.199875078 20C0.199875078 9 9.1942536 0 20.1873828 0C25.783885 0 30.780762 2.2 34.3785134 5.8L100.1374142 71.6L100.1374142 39.8C100.1374142 28.8 109.1317926 19.8 120.124922 19.8C131.1180512 19.8 140.1124298 28.8 140.1124298 39.8L140.1124298 119.8C139.9125546 131 130.9181762 140 119.9250468 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AddToFolder.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AddToFolder.displayName = "Blueprint5.Icon.AddToFolder";
exports.default = AddToFolder;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aSlbd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Add", ()=>Add);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Add = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "add",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 40C111.6 40 40 111.6 40 200S111.6 360 200 360S360 288.4 360 200S288.4 40 200 40zM300 220H220V300C220 311 211 320 200 320S180 311 180 300V220H100C89 220 80 211 80 200C80 189 89 180 100 180H180V100C180 89 189 80 200 80S220 89 220 100V180H300C311 180 320 189 320 200C320 211 311 220 300 220z" : "M219.8 180.2H179.8V220.2C179.8 231.2 170.8 240.2 159.8 240.2S139.8 231.2 139.8 220.2V180.2H99.8C88.8 180.2 79.8 171.2 79.8 160.2S88.8 140.2 99.8 140.2H139.8V100.2C139.8 89.2 148.8 80.2 159.8 80.2S179.8 89.2 179.8 100.2V140.2H219.8C230.8 140.2 239.8 149.2 239.8 160.2S230.8 180.2 219.8 180.2zM159.8 320.2C71.4 320.2 -0.2 248.6 -0.2 160.2S71.4 0.2 159.8 0.2S319.8 71.8 319.8 160.2S248.2 320.2 159.8 320.2zM159.8 40.2C93.6 40.2 39.8 94 39.8 160.2S93.6 280.2 159.8 280.2S279.8 226.4 279.8 160.2S226.2 40.2 159.8 40.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Add.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Add.displayName = "Blueprint5.Icon.Add";
exports.default = Add;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"78CnI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AimpointsTarget", ()=>AimpointsTarget);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AimpointsTarget = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "aimpoints-target",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M45.9164 156.742C32.4324 153.006 20.2204 146.21 10.07474 137.15C3.53794 156.914 0 178.044 0 200C0 310.457 89.543 400 200 400C221.956 400 243.086 396.46206 262.85 389.92526C253.79 379.7794 246.994 367.5674 243.258 354.0836C229.5 357.9386 214.99 360 200 360C111.6344 360 40 288.3656 40 200C40 185.01 42.0614 170.5 45.9164 156.742zM360 200C360 214.9902 357.938 229.499 354.084 243.2584C367.568 246.9938 379.7800000000001 253.789 389.9260000000001 262.8494C396.462 243.0852 400 221.9558 400 200C400 89.544 310.456 0 200 0C178.0442 0 156.9148 3.538 137.1506 10.074C146.211 20.22 153.0062 32.432 156.7416 45.916C170.501 42.062 185.0096 40 200 40C288.366 40 360 111.634 360 200zM380 330C380 302.3858 357.6140000000001 280 330 280C302.386 280 280 302.3858 280 330C280 357.6142 302.386 380 330 380C357.6140000000001 380 380 357.6142 380 330zM120 70C120 42.386 97.6142 20 70 20C42.3858 20 20 42.386 20 70C20 97.614 42.3858 120 70 120C97.6142 120 120 97.614 120 70zM200 320C188.955 320 180 311.0462 180 300V240C180 228.9538 188.955 220 200 220C211.044 220 220 228.9538 220 240V300C220 311.0462 211.044 320 200 320zM220 200C220 211.0462 228.956 220 240 220H300C311.044 220 320 211.0462 320 200C320 188.954 311.044 180 300 180H240C228.956 180 220 188.954 220 200zM80 200C80 211.0462 88.955 220 100 220H160C171.045 220 180 211.0462 180 200C180 188.954 171.045 180 160 180H100C88.955 180 80 188.954 80 200zM180 160C180 171.046 188.955 180 200 180C211.044 180 220 171.046 220 160V100C220 88.954 211.044 80 200 80C188.955 80 180 88.954 180 100V160z" : "M42.0176 137.971C28.082 134.77 15.53596 127.9292 5.43386 118.502C1.889708 131.737 0 145.6478 0 160C0 248.3656 71.6344 320 160 320C174.3522 320 188.263 318.110292 201.498 314.56614C192.0708 304.46404 185.23 291.918 182.029 277.9824C174.888 279.3074000000001 167.525 280 160 280C93.7258 280 40 226.2742 40 160C40 152.475 40.6926 145.112 42.0176 137.971zM280 160C280 167.525 279.308 174.888 277.9820000000001 182.029C291.918 185.23 304.464 192.0708 314.5660000000001 201.4972C318.11 188.263 320 174.3522 320 160C320 71.634 248.366 0 160 0C145.6478 0 131.737 1.89 118.5028 5.434C127.9292 15.536 134.77 28.082 137.971 42.018C145.112 40.692 152.475 40 160 40C226.274 40 280 93.726 280 160zM160 260C148.955 260 140 251.0462 140 240V200C140 188.9538 148.955 180 160 180C171.045 180 180 188.9538 180 200V240C180 251.0462 171.045 260 160 260zM180 160C180 171.0462 188.955 180 200 180H240C251.044 180 260 171.0462 260 160C260 148.9538 251.044 140 240 140H200C188.955 140 180 148.9538 180 160zM60 160C60 171.0462 68.955 180 80 180H120C131.045 180 140 171.0462 140 160C140 148.9538 131.045 140 120 140H80C68.955 140 60 148.9538 60 160zM140 120C140 131.0462 148.955 140 160 140C171.045 140 180 131.0462 180 120V80C180 68.954 171.045 60 160 60C148.955 60 140 68.954 140 80V120zM100 60C100 37.908 82.0914 20 60 20C37.9086 20 20 37.908 20 60C20 82.092 37.9086 100 60 100C82.0914 100 100 82.092 100 60zM260 220C282.092 220 300 237.9086 300 260C300 282.0914 282.092 300 260 300C237.908 300 220 282.0914 220 260C220 237.9086 237.908 220 260 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AimpointsTarget.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AimpointsTarget.displayName = "Blueprint5.Icon.AimpointsTarget";
exports.default = AimpointsTarget;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ntnQx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Airplane", ()=>Airplane);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Airplane = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "airplane",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 360C400 382 382 400 360 400C349 400 339 395.6 331.8 388.2L235 291.4L40 380L20 340L170.6 227.2L83.4 140H20L0 120L80 80L120 0L140 20V83.4L227.2 170.6L340 20L380 40L291.4 234.8L388.2 331.6C395.6 339 400 349 400 360z" : "M320 290C320 306.6 306.6 320 290 320C281.8 320 274.2000000000001 316.6 268.8 311.2L198.2 240.6L40 300L20 260L138.6 181L77.6 120H20L0 100L60 60L100 0L120 20V77.6L181 138.6L260 20L300 40L240.6 198.2L311.2 268.8C316.6 274.2 320 281.8 320 290z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Airplane.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Airplane.displayName = "Blueprint5.Icon.Airplane";
exports.default = Airplane;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Nnv6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlignCenter", ()=>AlignCenter);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AlignCenter = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "align-center",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100 300C89 300 80 291 80 280C80 269 89 260 100 260H300C311 260 320 269 320 280C320 291 311 300 300 300H100zM20 340H380C391 340 400 349 400 360C400 371 391 380 380 380H20C9 380 0 371 0 360C0 349 9 340 20 340zM260 100C271 100 280 109 280 120C280 131 271 140 260 140H140C129 140 120 131 120 120C120 109 129 100 140 100H260zM340 60H60C49 60 40 51 40 40C40 29 49 20 60 20H340C351 20 360 29 360 40C360 51 351 60 340 60zM380 220H20C9 220 0 211 0 200C0 189 9 180 20 180H380C391 180 400 189 400 200C400 211 391 220 380 220z" : "M80 240C69 240 60 231 60 220C60 209 69 200 80 200H240C251 200 260 209 260 220C260 231 251 240 240 240H80zM20 260H300C311 260 320 269 320 280C320 291 311 300 300 300H20C9 300 0 291 0 280C0 269 9 260 20 260zM280 60H40C29 60 20 51 20 40C20 29 29 20 40 20H280C291 20 300 29 300 40C300 51 291 60 280 60zM300 180H20C9 180 0 171 0 160C0 149 9 140 20 140H300C311 140 320 149 320 160C320 171 311 180 300 180zM200 80C211 80 220 89 220 100C220 111 211 120 200 120H120C109 120 100 111 100 100C100 89 109 80 120 80H200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AlignCenter.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AlignCenter.displayName = "Blueprint5.Icon.AlignCenter";
exports.default = AlignCenter;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"qcQpk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlignJustify", ()=>AlignJustify);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AlignJustify = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "align-justify",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 340H380C391 340 400 349 400 360C400 371 391 380 380 380H20C9 380 0 371 0 360C0 349 9 340 20 340zM380 60H20C9 60 0 51 0 40C0 29 9 20 20 20H380C391 20 400 29 400 40C400 51 391 60 380 60zM380 300H20C9 300 0 291 0 280C0 269 9 260 20 260H380C391 260 400 269 400 280C400 291 391 300 380 300zM380 220H20C9 220 0 211 0 200C0 189 9 180 20 180H380C391 180 400 189 400 200C400 211 391 220 380 220zM380 140H20C9 140 0 131 0 120C0 109 9 100 20 100H380C391 100 400 109 400 120C400 131 391 140 380 140z" : "M300 60.4H20C9 60.4 0 51.4 0 40.4C0 29.4 9 20.4 20 20.4H300C311 20.4 320 29.4 320 40.4C320 51.4 311 60.4 300 60.4zM20 260.4H300C311 260.4 320 269.4 320 280.4C320 291.4 311 300.4 300 300.4H20C9 300.4 0 291.4 0 280.4C0 269.2 9 260.4 20 260.4zM300 180.4H20C9 180.4 0 171.4 0 160.4C0 149.4 9 140.4 20 140.4H300C311 140.4 320 149.4 320 160.4C320 171.4 311 180.4 300 180.4zM300 240.4H20C9 240.4 0 231.4 0 220.4C0 209.4 9 200.4 20 200.4H300C311 200.4 320 209.4 320 220.4C320 231.4 311 240.4 300 240.4zM300 120.4H20C9 120.4 0 111.4 0 100.4C0 89.4 9 80.4 20 80.4H300C311 80.4 320 89.4 320 100.4C320 111.4 311 120.4 300 120.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AlignJustify.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AlignJustify.displayName = "Blueprint5.Icon.AlignJustify";
exports.default = AlignJustify;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cQZgT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlignLeft", ()=>AlignLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AlignLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "align-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 260H220C231 260 240 269 240 280C240 291 231 300 220 300H20C9 300 0 291 0 280C0 269 9 260 20 260zM20 340H380C391 340 400 349 400 360C400 371 391 380 380 380H20C9 380 0 371 0 360C0 349 9 340 20 340zM300 60H20C9 60 0 51 0 40C0 29 9 20 20 20H300C311 20 320 29 320 40C320 51 311 60 300 60zM380 220H20C9 220 0 211 0 200C0 189 9 180 20 180H380C391 180 400 189 400 200C400 211 391 220 380 220zM20 100H140C151 100 160 109 160 120C160 131 151 140 140 140H20C9 140 0 131 0 120C0 109 9 100 20 100z" : "M260 60H20C9 60 0 51 0 40C0 29 9 20 20 20H260C271 20 280 29 280 40C280 51 271 60 260 60zM20 260H300C311 260 320 269 320 280C320 291 311 300 300 300H20C9 300 0 291 0 280C0 269 9 260 20 260zM20 200H180C191 200 200 209 200 220C200 231 191 240 180 240H20C9 240 0 231 0 220C0 209 9 200 20 200zM300 180H20C9 180 0 171 0 160C0 149 9 140 20 140H300C311 140 320 149 320 160C320 171 311 180 300 180zM20 80H100C111 80 120 89 120 100C120 111 111 120 100 120H20C9 120 0 111 0 100C0 89 9 80 20 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AlignLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AlignLeft.displayName = "Blueprint5.Icon.AlignLeft";
exports.default = AlignLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9LoJ5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlignRight", ()=>AlignRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AlignRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "align-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 60H100C89 60 80 51 80 40C80 29 89 20 100 20H380C391 20 400 29 400 40C400 51 391 60 380 60zM20 340H380C391 340 400 349 400 360C400 371 391 380 380 380H20C9 380 0 371 0 360C0 349 9 340 20 340zM380 140H260C249 140 240 131 240 120C240 109 249 100 260 100H380C391 100 400 109 400 120C400 131 391 140 380 140zM380 220H20C9 220 0 211 0 200C0 189 9 180 20 180H380C391 180 400 189 400 200C400 211 391 220 380 220zM380 300H180C169 300 160 291 160 280C160 269 169 260 180 260H380C391 260 400 269 400 280C400 291 391 300 380 300z" : "M300 60.4H60C49 60.4 40 51.4 40 40.4C40 29.4 49 20.4 60 20.4H300C311 20.4 320 29.4 320 40.4C320 51.4 311 60.4 300 60.4zM20 260.4H300C311 260.4 320 269.4 320 280.4C320 291.4 311 300.4 300 300.4H20C9 300.4 0 291.4 0 280.4C0 269.2 9 260.4 20 260.4zM300 240.4H140C129 240.4 120 231.4 120 220.4C120 209.4 129 200.4 140 200.4H300C311 200.4 320 209.4 320 220.4C320 231.4 311 240.4 300 240.4zM300 120.4H220C209 120.4 200 111.4 200 100.4C200 89.4 209 80.4 220 80.4H300C311 80.4 320 89.4 320 100.4C320 111.4 311 120.4 300 120.4zM300 180.4H20C9 180.4 0 171.4 0 160.4C0 149.4 9 140.4 20 140.4H300C311 140.4 320 149.4 320 160.4C320 171.4 311 180.4 300 180.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AlignRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AlignRight.displayName = "Blueprint5.Icon.AlignRight";
exports.default = AlignRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6JHem":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlignmentBottom", ()=>AlignmentBottom);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AlignmentBottom = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "alignment-bottom",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 80H320C331 80 340 89 340 100V240C340 251 331 260 320 260H240C229 260 220 251 220 240V100C220 89 229 80 240 80zM380 40H20C9 40 0 31 0 20S9 0 20 0H380C391 0 400 9 400 20S391 40 380 40zM80 80H160C171 80 180 89 180 100V380C180 391 171 400 160 400H80C69 400 60 391 60 380V100C60 89 69 80 80 80z" : "M200 80H260C271 80 280 89 280 100V180C280 191 271 200 260 200H200C189 200 180 191 180 180V100C180 89 189 80 200 80zM300 40H20C9 40 0 31 0 20S9 0 20 0H300C311 0 320 9 320 20S311 40 300 40zM60 80H120C131 80 140 89 140 100V280C140 291 131 300 120 300H60C49 300 40 291 40 280V100C40 89 49 80 60 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AlignmentBottom.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AlignmentBottom.displayName = "Blueprint5.Icon.AlignmentBottom";
exports.default = AlignmentBottom;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jrPXA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlignmentHorizontalCenter", ()=>AlignmentHorizontalCenter);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AlignmentHorizontalCenter = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "alignment-horizontal-center",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 220H340V260C340 271 331 280 320 280H240C229 280 220 271 220 260V220H180V340C180 351 171 360 160 360H80C69 360 60 351 60 340V220H20C9 220 0 211 0 200C0 189 9 180 20 180H60V60C60 49 69 40 80 40H160C171 40 180 49 180 60V180H220V140C220 129 229 120 240 120H320C331 120 340 129 340 140V180H380C391 180 400 189 400 200C400 211 391 220 380 220z" : "M300 180H280V200C280 211 271 220 260 220H200C189 220 180 211 180 200V180H140V260C140 271 131 280 120 280H60C49 280 40 271 40 260V180H20C9 180 0 171 0 160C0 149 9 140 20 140H40V60C40 49 49 40 60 40H120C131 40 140 49 140 60V140H180V120C180 109 189 100 200 100H260C271 100 280 109 280 120V140H300C311 140 320 149 320 160C320 171 311 180 300 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AlignmentHorizontalCenter.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AlignmentHorizontalCenter.displayName = "Blueprint5.Icon.AlignmentHorizontalCenter";
exports.default = AlignmentHorizontalCenter;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kzSO6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlignmentLeft", ()=>AlignmentLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AlignmentLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "alignment-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 400C9 400 0 391 0 380V20C0 9 9 0 20 0S40 9 40 20V380C40 391 31 400 20 400zM240 180H100C89 180 80 171 80 160V80C80 69 89 60 100 60H240C251 60 260 69 260 80V160C260 171 251 180 240 180zM380 340H100C89 340 80 331 80 320V240C80 229 89 220 100 220H380C391 220 400 229 400 240V320C400 331 391 340 380 340z" : "M180 140H100C89 140 80 131 80 120V60C80 49 89 40 100 40H180C191 40 200 49 200 60V120C200 131 191 140 180 140zM20 320C9 320 0 311 0 300V20C0 9 9 0 20 0S40 9 40 20V300C40 311 31 320 20 320zM280 280H100C89 280 80 271 80 260V200C80 189 89 180 100 180H280C291 180 300 189 300 200V260C300 271 291 280 280 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AlignmentLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AlignmentLeft.displayName = "Blueprint5.Icon.AlignmentLeft";
exports.default = AlignmentLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jrNFy":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlignmentRight", ()=>AlignmentRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AlignmentRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "alignment-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400C369 400 360 391 360 380V20C360 9 369 0 380 0S400 9 400 20V380C400 391 391 400 380 400zM300 180H160C149 180 140 171 140 160V80C140 69 149 60 160 60H300C311 60 320 69 320 80V160C320 171 311 180 300 180zM300 340H20C9 340 0 331 0 320V240C0 229 9 220 20 220H300C311 220 320 229 320 240V320C320 331 311 340 300 340z" : "M220 140H140C129 140 120 131 120 120V60C120 49 129 40 140 40H220C231 40 240 49 240 60V120C240 131 231 140 220 140zM300 320C289 320 280 311 280 300V20C280 9 289 0 300 0S320 9 320 20V300C320 311 311 320 300 320zM220 280H40C29 280 20 271 20 260V200C20 189 29 180 40 180H220C231 180 240 189 240 200V260C240 271 231 280 220 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AlignmentRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AlignmentRight.displayName = "Blueprint5.Icon.AlignmentRight";
exports.default = AlignmentRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8nyQN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlignmentTop", ()=>AlignmentTop);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AlignmentTop = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "alignment-top",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 320H80C69 320 60 311 60 300V20C60 9 69 0 80 0H160C171 0 180 9 180 20V300C180 311 171 320 160 320zM380 400H20C9 400 0 391 0 380S9 360 20 360H380C391 360 400 369 400 380S391 400 380 400zM320 320H240C229 320 220 311 220 300V160C220 149 229 140 240 140H320C331 140 340 149 340 160V300C340 311 331 320 320 320z" : "M300 320H20C9 320 0 311 0 300S9 280 20 280H300C311 280 320 289 320 300S311 320 300 320zM120 240H60C49 240 40 231 40 220V40C40 29 49 20 60 20H120C131 20 140 29 140 40V220C140 231 131 240 120 240zM260 240H200C189 240 180 231 180 220V140C180 129 189 120 200 120H260C271 120 280 129 280 140V220C280 231 271 240 260 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AlignmentTop.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AlignmentTop.displayName = "Blueprint5.Icon.AlignmentTop";
exports.default = AlignmentTop;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hQAB1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlignmentVerticalCenter", ()=>AlignmentVerticalCenter);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AlignmentVerticalCenter = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "alignment-vertical-center",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 340H220V380C220 391 211 400 200 400S180 391 180 380V340H60C49 340 40 331 40 320V240C40 229 49 220 60 220H180V180H140C129 180 120 171 120 160V80C120 69 129 60 140 60H180V20C180 9 189 0 200 0S220 9 220 20V60H260C271 60 280 69 280 80V160C280 171 271 180 260 180H220V220H340C351 220 360 229 360 240V320C360 331 351 340 340 340z" : "M260 280H180V300C180 311 171 320 160 320S140 311 140 300V280H60C49 280 40 271 40 260V200C40 189 49 180 60 180H140V140H120C109 140 100 131 100 120V60C100 49 109 40 120 40H140V20C140 9 149 0 160 0S180 9 180 20V40H200C211 40 220 49 220 60V120C220 131 211 140 200 140H180V180H260C271 180 280 189 280 200V260C280 271 271 280 260 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AlignmentVerticalCenter.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AlignmentVerticalCenter.displayName = "Blueprint5.Icon.AlignmentVerticalCenter";
exports.default = AlignmentVerticalCenter;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ino6c":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ammunition", ()=>Ammunition);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Ammunition = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "ammunition",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 280V283.4314C120 319.6516 105.6116 354.3884 80 380C54.3884 354.3884 40 319.6516 40 283.4314V280H120zM120 40V20H40V40H120zM120 60V260H40V60H120zM160 20V40H240V20H160zM240 283.4314V280H160V283.4314C160 319.6516 174.3884 354.3884 200 380C225.612 354.3884 240 319.6516 240 283.4314zM240 260V60H160V260H240zM280 40V20H360V40H280zM360 280V283.4314C360 319.6516 345.612 354.3884 320 380C294.3880000000001 354.3884 280 319.6516 280 283.4314V280H360zM360 60V260H280V60H360z" : "M42.5196 297.9882C66.211 279.0332 80 250.3418 80 220V60H0V220C0 250.3418 13.78906 279.0332 37.4804 297.9882L40 300L42.5196 297.9882zM162.5196 297.9882C186.211 279.0332 200 250.3418 200 220V60H120V220C120 250.3418 133.789 279.0332 157.4804 297.9882L160 300L162.5196 297.9882zM320 220C320 250.3418 306.21 279.0332 282.52 297.9882L280 300L277.48 297.9882C253.79 279.0332 240 250.3418 240 220V60H320V220zM80 20V40H0V20H80zM200 40V20H120V40H200zM320 20V40H240V20H320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Ammunition.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Ammunition.displayName = "Blueprint5.Icon.Ammunition";
exports.default = Ammunition;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bn3rH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Anchor", ()=>Anchor);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Anchor = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "anchor",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 283.4142C243.304 291.6508 260 313.8756 260 340C260 373.137 233.138 400 200 400C166.863 400 140 373.137 140 340C140 313.8756 156.6962 291.6508 180 283.4142V260H120V220H180V41.66C126.0016 50.718 84.2316 95.84 80.3024 151.414L85.8578 145.858C93.6684 138.048 106.3316 138.048 114.1422 145.858C121.9526 153.668 121.9526 166.332 114.1422 174.142L74.1422 214.1422C66.3316 221.9526 53.6684 221.9526 45.8578 214.1422L5.85786 174.142C-1.952622 166.332 -1.952622 153.668 5.85786 145.858C13.66834 138.048 26.3316 138.048 34.1422 145.858L40.2006 151.916C44.4108 67.306 114.3452 0 200 0C285.654 0 355.59 67.306 359.8 151.916L365.858 145.858C373.668 138.048 386.332 138.048 394.142 145.858C401.952 153.668 401.952 166.332 394.142 174.142L354.142 214.1422C346.332 221.9526 333.668 221.9526 325.858 214.1422L285.858 174.142C278.048 166.332 278.048 153.668 285.858 145.858C293.668 138.048 306.332 138.048 314.142 145.858L319.698 151.414C315.768 95.84 273.998 50.718 220 41.66V220H280V260H220V283.4142zM220 340C220 328.9544 211.046 320 200 320C188.9544 320 180 328.9544 180 340C180 351.0456 188.9544 360 200 360C211.046 360 220 351.0456 220 340z" : "M200 280C200 265.1944 191.956 252.2674 180 245.3512V220H220V180H180V42.52C211.764 50.696 235.894 77.89 239.526 111.242L234.142 105.858C226.332 98.048 213.668 98.048 205.858 105.858C198.0474 113.668 198.0474 126.3316 205.858 134.1422L245.858 174.1422C253.668 181.9526 266.332 181.9526 274.142 174.1422L314.142 134.1422C321.952 126.3316 321.952 113.668 314.142 105.858C306.332 98.048 293.668 98.048 285.858 105.858L279.736 111.98C275.61 49.444 223.58 0 160 0C96.421 0 44.3904 49.444 40.2638 111.98L34.1422 105.858C26.3316 98.048 13.66834 98.048 5.85786 105.858C-1.952622 113.668 -1.952622 126.3316 5.85786 134.1422L45.8578 174.1422C53.6684 181.9526 66.3316 181.9526 74.1422 174.1422L114.1422 134.1422C121.9526 126.3316 121.9526 113.668 114.1422 105.858C106.3316 98.048 93.6684 98.048 85.8578 105.858L80.474 111.242C84.1054 77.89 108.235 50.696 140 42.52V180H100V220H140V245.3512C128.044 252.2674 120 265.1944 120 280C120 302.09138 137.9086 320 160 320C182.0914 320 200 302.09138 200 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Anchor.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Anchor.displayName = "Blueprint5.Icon.Anchor";
exports.default = Anchor;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k9UIt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Annotation", ()=>Annotation);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Annotation = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "annotation",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M188.2 131.8L341.2000000000001 284.8L284.6 341.4L131.6 188.4L188.2 131.8zM388.2 331.8C395.6 339 400 349 400 360C400 382 382 400 360 400C349 400 339 395.6 331.8 388.2L298.8 355.2L355.4 298.6L388.2 331.8zM360 40H40V360H218.6L258.6 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V258.6L360 218.6V40zM80 80L168.2 111.8L112 167.6L80 80z" : "M310.4 264.6C316.4 270.4 320 278.6 320 287.6C320 305.4 305.4 320 287.6 320C278.6 320 270.6 316.4 264.6 310.4L237.8 283.6L283.8 237.6L310.4 264.6zM148 102L272.2 226.2L226.2 272.2L102 148L148 102zM280 40H40V280H166.8L206.8 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V206.8L280 166.8V40zM60 60L131.6 85.8L85.8 131.2L60 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Annotation.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Annotation.displayName = "Blueprint5.Icon.Annotation";
exports.default = Annotation;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8l08a":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Antenna", ()=>Antenna);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Antenna = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "antenna",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40.2052 184.838C42.3518 162.214 49.2698 140.382 60.414 120.754L60.8138 120.054C61.4722 118.906 62.0266 117.718 62.4772 116.504C65.7438 107.694 63.551 97.476 55.8902 91.72C47.1726 85.17 34.702 86.882 29.043 96.204C28.2022 97.588 27.3788 98.982 26.5728 100.386C25.91 101.54 25.259 102.7 24.6198 103.866C11.58612 127.644 3.47452 153.916 0.894362 181.108C-2.58976 217.8274 4.14826 254.7952 20.3634 287.9242C36.5786 321.0534 61.6394 349.053 92.775 368.8276C123.9106 388.60236 159.9082 399.381796 196.7878 399.9741972C233.668 400.566598 269.992 390.9489 301.748 372.1844C333.502 353.42 359.45 326.2396 376.72 293.6484C393.99 261.0574000000001 401.9120000000001 224.325 399.61 187.512C397.904 160.252 390.64 133.732 378.3780000000001 109.548C377.776 108.362 377.1620000000001 107.182 376.538 106.008C375.776 104.578 374.998 103.158 374.202 101.748C368.846 92.25 356.436 90.138 347.514 96.404C339.672 101.91 337.1520000000001 112.054 340.134 120.964C340.546 122.192 341.062 123.398 341.682 124.564L342.0600000000001 125.278C352.568 145.254 358.78 167.296 360.2000000000001 189.978C362.048 219.5224 355.6900000000001 249.0024 341.83 275.1588C327.968 301.3152 307.144 323.1292 281.658 338.189C256.174 353.2486 227.02 360.9674 197.422 360.492C167.8238 360.0166 138.9334 351.3654 113.9452 335.495C88.9568 319.6244000000001 68.844 297.153 55.8302 270.5648C42.8166 243.9766 37.4088 214.3076 40.2052 184.838zM125.6476 169.408C125.9296 168.722 126.185 168.028 126.4138 167.324C126.8736 165.91 127.2248 164.464 127.464 163.008C128.8608 154.496 126.427 145.608 119.4274 140.434C110.6342 133.934 98.0672 135.74 93.0992 145.482C91.621 148.38 90.2624 151.336 89.0262 154.34C88.6412 155.276 88.268 156.216 87.9068 157.162C83.9462 167.526 81.4234 178.436 80.4522 189.594C78.533 211.6412 82.7482 233.7898 92.6314 253.5908C102.5148 273.392 117.6814 290.0744000000001 136.4544 301.7936000000001C155.2274 313.5130000000001 176.8756 319.8124000000001 199.0056 319.9958000000001C221.136 320.1792000000001 242.886 314.2394 261.85 302.833C280.814 291.4264 296.256 274.9978 306.466 255.363C316.676 235.7284 321.258 213.6528 319.704 191.576C318.918 180.404 316.576 169.454 312.788 159.026C312.442 158.074 312.084 157.128 311.716 156.186C310.5300000000001 153.162 309.2200000000001 150.184 307.79 147.262C302.9840000000001 137.438 290.448 135.424 281.548 141.778C274.464 146.836 271.884 155.682 273.14 164.214C273.354 165.676 273.682 167.126 274.118 168.548C274.334 169.256 274.578 169.954 274.85 170.644C277.812 178.196 279.626 186.188 280.202 194.356C281.242 209.1474 278.1720000000001 223.938 271.332 237.0932C264.492 250.2484 254.146 261.2558 241.44 268.898C228.734 276.5404 214.16 280.5202 199.3338 280.3972C184.5068 280.2744 170.0024 276.0536 157.4246 268.2018C144.8466 260.3498 134.685 249.1726 128.0632 235.9058C121.4412 222.6392 118.6172 207.7996 119.903 193.028C120.613 184.87 122.561 176.91 125.6476 169.408zM219.874 117.746C219.958 118.486 220 119.238 220 120V200.0002C220 211.0458 211.046 220.0002 200 220.0002C188.9542 220.0002 180 211.0458 180 200.0002V120C180 119.238 180.0426 118.486 180.1256 117.746L105.052 33.288C97.7136 25.032 98.4572 12.39 106.7128 5.052C114.9686 -2.286 127.61 -1.542 134.9484 6.712L199.9998 79.896L265.048 6.714C272.386 -1.542 285.026 -2.286 293.282 5.052C301.538 12.39 302.2820000000001 25.032 294.944 33.286L219.874 117.746z" : "M53.4522 104.846C53.6014 104.556 53.7448 104.266 53.8824 103.974C54.1106 103.488 54.3226 102.998 54.519 102.502C54.825 101.73 55.0922 100.944 55.3204 100.152C57.8608 91.326 55.5532 81.522 48.0828 75.91C39.2522 69.274 26.5818 70.998 21.0994 80.586C9.85026 100.262 2.87064 122.1734 0.71542 144.8874C-2.07188 174.263 3.31854 203.8374 16.2907 230.3406C29.2628 256.8438 49.3114 279.2434 74.22 295.0632C99.1284 310.88298 127.9264 319.506522 157.4302 319.98044334C186.934 320.454364 215.994 312.7602 241.398 297.7486C266.802 282.737 287.56 260.9928 301.376 234.9198C315.192 208.847 321.53 179.461 319.688 150.011C318.264 127.2394 311.99 105.116 301.38 85.088C296.208 75.328 283.6 73.2 274.56 79.548C266.914 84.918 264.2920000000001 94.642 266.548 103.544C266.75 104.344 266.992 105.138 267.274 105.92C267.454 106.422 267.65 106.918 267.862 107.41C267.99 107.708 268.124 108.002 268.264 108.296C274.86 122.1072 278.78 137.1112 279.744 152.51C281.126 174.5934 276.372 196.6286 266.012 216.1796C255.652 235.7306 240.086 252.0358 221.038 263.2924C201.988 274.549 180.1968 280.3186 158.073 279.9632000000001C135.9494 279.6078 114.3548 273.1414 95.677 261.2788C76.999 249.4162 61.9654 232.6194 52.2382 212.7458C42.5108 192.8722 38.4688 170.6956 40.5588 148.668C42.0164 133.308 46.4158 118.438 53.4522 104.846zM102.7346 142.0772C103.1602 140.7176 103.5062 139.325 103.7668 137.9164C104.0074 136.6174 104.1754 135.3048 104.2666 133.992C104.843 125.6908 102.3476 117.38 95.6686 112.442C86.7876 105.876 74.0522 107.704 69.3816 117.712C67.502 121.7406 65.893 125.8892 64.5656 130.1302L64.4998 130.3414C62.3884 137.1394 60.9996 144.1736 60.3768 151.3292C58.7774 169.702 62.29 188.1592 70.5262 204.6602C78.7622 221.1612 91.4012 235.0632 107.0454 244.8292C122.6896 254.5952 140.7296 259.8448 159.1712 259.9976000000001C177.6128 260.1504 195.7376 255.2006 211.542 245.6952C227.346 236.1898 240.212 222.4992 248.722 206.137C257.23 189.7748 261.048 171.3784 259.754 152.9816C259.25 145.8168 257.978 138.7604 255.978 131.9284L255.916 131.7162C254.6600000000001 127.4536 253.12 123.279 251.306 119.22C246.802 109.136 234.1 107.098 225.11 113.514C218.35 118.342 215.718 126.6096 216.156 134.9192C216.226 136.2334 216.372 137.5486 216.592 138.8514C216.828 140.2642 217.152 141.6624 217.554 143.0288C218.776 147.168 219.552 151.4452 219.856 155.789C220.634 166.828 218.342 177.8668 213.238 187.6848C208.132 197.503 200.41 205.718 190.9274 211.4218C181.4442 217.1254 170.5686 220.0956 159.5028 220.004C148.4368 219.9122 137.6118 216.7622 128.2246 210.902C118.8374 205.042 111.2534 196.7002 106.3114 186.7988C101.3692 176.8974 99.2614 165.8222 100.2212 154.7976C100.5988 150.4594 101.4456 146.1956 102.7346 142.0772zM159.9998 180.0022C171.0456 180.0022 179.9998 171.0478 179.9998 160.0022V88.286L234.142 34.144C241.952 26.334 241.952 13.67 234.142 5.86C226.332 -1.95 213.668 -1.95 205.858 5.86L159.9998 51.718L114.142 5.86C106.3316 -1.95 93.6682 -1.95 85.8578 5.86C78.0472 13.67 78.0472 26.334 85.8578 34.144L139.9998 88.286V160.0022C139.9998 171.0478 148.9542 180.0022 159.9998 180.0022z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Antenna.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Antenna.displayName = "Blueprint5.Icon.Antenna";
exports.default = Antenna;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5o4u3":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppHeader", ()=>AppHeader);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AppHeader = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "app-header",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400C391.0456940000001 400 400 391.045695 400 380L400 20C400 8.954306 391.0456940000001 0 380 0L20 0C8.954305 0 0 8.954306 0 20L0 380C0 391.045695 8.954305 400 20 400L380 400zM160 280C160 291.045695 151.045695 300 140 300C129.7432832 300 121.2898568 292.2791962 120.1345546 282.3324226L120 280L120 120C120 108.954306 128.954305 100 140 100C150.2567168 100 158.7101432 107.720804 159.8654454 117.667578L160 120L160 180L240 180L240 120C240 108.954306 248.954306 100 260 100C270.256716 100 278.710144 107.720804 279.865446 117.667578L280 120L280 280C280 291.045695 271.045694 300 260 300C249.743284 300 241.289856 292.2791962 240.134554 282.3324226L240 280L240 220L160 220L160 280z" : "M300 320C311.045694 320 320 311.045695 320 300L320 20C320 8.954306 311.045694 0 300 0L20 0C8.954305 0 0 8.954306 0 20L0 300C0 311.045695 8.954305 320 20 320L300 320zM120 240C120 251.045695 111.045695 260 100 260C89.7432832 260 81.2898568 252.2791962 80.1345546 242.3324226L80 240L80 80C80 68.954306 88.954305 60 100 60C110.2567168 60 118.7101432 67.720804 119.8654454 77.667578L120 80L120 140L200 140L200 80C200 68.954306 208.954306 60 220 60C230.256716 60 238.710144 67.720804 239.865446 77.667578L240 80L240 240C240 251.045695 231.045694 260 220 260C209.743284 260 201.289856 252.2791962 200.134554 242.3324226L200 240L200 180L120 180L120 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AppHeader.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AppHeader.displayName = "Blueprint5.Icon.AppHeader";
exports.default = AppHeader;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"44NV6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Application", ()=>Application);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Application = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "application",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M70 220H250C255.6 220 260 224.4 260 230C260 235.6 255.6 240 250 240H70C64.4 240 60 235.6 60 230C60 224.4 64.4 220 70 220zM70 180H170C175.6 180 180 184.4 180 190C180 195.6 175.6 200 170 200H70C64.4 200 60 195.6 60 190C60 184.4 64.4 180 70 180zM380 380H20C9 380 0 371 0 360V40C0 29 9 20 20 20H380C391 20 400 29 400 40V360C400 371 391 380 380 380zM360 60H40V280H360V60zM70 140H210C215.6 140 220 144.4 220 150C220 155.6 215.6 160 210 160H70C64.4 160 60 155.6 60 150C60 144.4 64.4 140 70 140z" : "M70 180H210C215.6 180 220 184.4 220 190C220 195.6 215.6 200 210 200H70C64.4 200 60 195.6 60 190C60 184.4 64.4 180 70 180zM300 300H20C9 300 0 291 0 280V40C0 29 9 20 20 20H300C311 20 320 29 320 40V280C320 291 311 300 300 300zM280 60H40V220H280V60zM70 140H150C155.6 140 160 144.4 160 150C160 155.6 155.6 160 150 160H70C64.4 160 60 155.6 60 150C60 144.4 64.4 140 70 140zM70 100H170C175.6 100 180 104.4 180 110C180 115.6 175.6 120 170 120H70C64.4 120 60 115.6 60 110C60 104.4 64.4 100 70 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Application.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Application.displayName = "Blueprint5.Icon.Application";
exports.default = Application;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7nZQH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Applications", ()=>Applications);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Applications = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "applications",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 300H20C9 300 0 291 0 280V20C0 9 9 0 20 0H300C311 0 320 9 320 20V280C320 291 311 300 300 300zM280 40H40V240H280V40zM70 200H210C215.6 200 220 204.4 220 210C220 215.6 215.6 220 210 220H70C64.4 220 60 215.6 60 210C60 204.4 64.4 200 70 200zM70 160H130C135.6 160 140 164.4 140 170C140 175.6 135.6 180 130 180H70C64.4 180 60 175.6 60 170C60 164.4 64.4 160 70 160zM70 120H170C175.6 120 180 124.4 180 130C180 135.6 175.6 140 170 140H70C64.4 140 60 135.6 60 130C60 124.4 64.4 120 70 120zM380 400H100C89 400 80 391 80 380V320H120V340H360V140H340V100H380C391 100 400 109 400 120V380C400 391 391 400 380 400z" : "M70 100H110C115.6 100 120 104.4 120 110C120 115.6 115.6 120 110 120H70C64.4 120 60 115.6 60 110C60 104.4 64.4 100 70 100zM70 140H170C175.6 140 180 144.4 180 150C180 155.6 175.6 160 170 160H70C64.4 160 60 155.6 60 150C60 144.4 64.4 140 70 140zM220 240H20C9 240 0 231 0 220V20C0 9 9 0 20 0H220C231 0 240 9 240 20V220C240 231 231 240 220 240zM200 40H40V180H200V40zM300 320H100C89 320 80 311 80 300V260H120V280H280V140H260V100H300C311 100 320 109 320 120V300C320 311 311 320 300 320zM70 60H130C135.6 60 140 64.4 140 70C140 75.6 135.6 80 130 80H70C64.4 80 60 75.6 60 70C60 64.4 64.4 60 70 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Applications.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Applications.displayName = "Blueprint5.Icon.Applications";
exports.default = Applications;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7CAX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Archive", ()=>Archive);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Archive = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "archive",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M328.676192 400C335.70145 400 342.211586 396.31402332 345.82605 390.2899151L400 300L400 20C400 8.954306 391.0456940000001 0 380 0L20 0C8.954305 0 0 8.954306 0 20L0 300L54.173949 390.2899151C57.788414 396.31402332 64.2985506 400 71.3238076 400L328.676192 400zM200 240C189 240 180 231 180 220L180 220L180 128.4L154.2 154.2L152.573761 155.66589C149.1591836 158.436734 144.8 160.2 140 160.2C129 160.2 120 151.2 120 140.2C120 134.6 122.2 129.6 125.8 126L125.8 126L185.8 66L187.712963 64.32037C191.0833334 61.727778 195.3333334 60.2000000000001 200 60.2000000000001C205.6 60.2000000000001 210.6 62.4 214.2 66L214.2 66L274.2000000000001 126L275.87963 127.912962C278.472222 131.283334 280 135.533334 280 140.2C280 151.2 271 160.2 260 160.2C254.4 160.2 249.4 158 245.8 154.4L245.8 154.4L220 128.4L220 220L219.864796 222.3239796C218.704082 232.239796 210.214286 240 200 240zM320 360L80 360L40 299.9675252L360 299.9675252L320 360z" : "M267.63932 320C275.214762 320 282.140024 315.71995248 285.527864 308.9442719L320 240L320 20C320 8.954306 311.045694 0 300 0L20 0C8.954305 0 0 8.954306 0 20L0 240L34.472136 308.9442719C37.8599762 315.71995248 44.7852386 320 52.3606798 320L267.63932 320zM160 200C149 200 140 191 140 180L140 180L140 128.2L134.2 134L132.573761 135.528863C129.1591836 138.3836734 124.8 140 120 140C109 140 100 131 100 120C100 114.4 102.2 109.4 105.8 105.8L105.8 105.8L145.8 65.8L147.712963 64.12037C151.0833334 61.527778 155.3333334 60 160 60C165.6 60 170.6 62.2 174.2 65.8L174.2 65.8L214.2 105.8L215.87963 107.712962C218.472222 111.083334 220 115.333334 220 120C220 131 211 140 200 140C194.4 140 189.4 137.8 185.8 134.2L185.8 134.2L180 128.2L180 180L179.864796 182.3239796C178.7040816 192.239796 170.2142858 200 160 200zM260 280L60 280L40 240L280 240L260 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Archive.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Archive.displayName = "Blueprint5.Icon.Archive";
exports.default = Archive;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hoKXF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AreaOfInterest", ()=>AreaOfInterest);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AreaOfInterest = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "area-of-interest",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100.0002 306.725C100.0002 358.175 144.8276 400 200 400C255.172 400 299.818 358.175 300 306.725C300 255.1 200 120 200 120C200 120 100.0002 255.1 100.0002 306.725zM160 300C160 277.92 177.9202 260 200 260C222.08 260 240 277.92 240 300C240 322.08 222.08 340 200 340C177.9202 340 160 322.08 160 300zM10.07784 157.366L96.1162 206.5278C102.5572 195.002 109.3598 183.616 116.0262 172.89L116.5104 172.112L50.6398 134.474L129.3676 39.996L270.632 40L349.36 134.472L283.49 172.112L283.974 172.89C290.64 183.616 297.442 195.002 303.884 206.5274L389.922 157.364C395.058 154.43 398.632 149.372 399.682 143.55C400.732 137.728 399.152 131.74 395.3640000000001 127.196L295.3640000000001 7.196C291.564 2.636 285.936 0 280 0L120.0006 -0.004C114.0646 -0.004 108.4354 2.6319999999999 104.6354 7.192L4.63548 127.198C0.848502 131.742 -0.732348 137.73 0.317864 143.552C1.368074 149.374 4.9416 154.432 10.07784 157.366z" : "M80.0006 246.7126C80.0006 287.1376 115.8626 320 160.0006 320C204.138 320 239.856 287.1376 240 246.7126C240 206.15 160.0006 100 160.0006 100C160.0006 100 80.0006 206.15 80.0006 246.7126zM120.0006 240C120.0006 217.92 137.9206 200 160.0006 200C182.0806 200 200 217.92 200 240C200 262.08 182.0806 280 160.0006 280C137.9206 280 120.0006 262.08 120.0006 240zM270.086 114.628L216.482 146.7902L216.902 147.4524C223.718 158.2264 230.652 169.7582 236.886 181.1958L310.29 137.1528C315.238 134.1834 318.664 129.221 319.684 123.5406C320.706 117.86 319.222 112.016 315.618 107.51L235.618 7.51C231.822 2.764 226.076 0.002 220 0.002H100.0002C93.9244 0.002 88.1782 2.764 84.3828 7.51L4.38276 107.51C0.777406 112.016 -0.705358 117.86 0.315498 123.5406C1.336354 129.221 4.7613 134.1834 9.71022 137.1528L83.116 181.1962C89.348 169.7586 96.2824 158.2266 103.0998 147.4524L103.519 146.7906L49.9134 114.628L109.6126 40.002H210.388L270.086 114.628z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AreaOfInterest.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AreaOfInterest.displayName = "Blueprint5.Icon.AreaOfInterest";
exports.default = AreaOfInterest;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lwVrh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrayBoolean", ()=>ArrayBoolean);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrayBoolean = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "array-boolean",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400C390.2567160000001 400 398.710144 392.2791962 399.865446 382.3324225L400 380L400 20C400 9.743284 392.279196 1.289856 382.332422 0.134554L380 0L300 0C288.9543060000001 0 280 8.954306 280 20C280 30.256716 287.720804 38.710144 297.667578 39.865446L300 40L360 40L360 360L300 360C289.743284 360 281.289856 367.7208038 280.1345540000001 377.6675774000001L280 380C280 390.25671678 287.720804 398.7101432140001 297.667578 399.8654453736L300 400L380 400zM100 400C111.045695 400 120 391.045695 120 380C120 369.7432832 112.2791962 361.2898568 102.3324226 360.1345546L100 360L40 360L40 40L100 40C110.2567168 40 118.7101432 32.279196 119.8654454 22.332422L120 20C120 9.743284 112.2791962 1.289856 102.3324226 0.134554L100 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 380C0 390.25671678 7.7208038 398.7101432140001 17.6675775 399.8654453734L20 400L100 400zM300 260C310.256716 260 318.710144 252.2791962 319.865446 242.3324226L320 240L320 160C320 149.743284 312.279196 141.289856 302.332422 140.134554L300 140L100 140C89.7432832 140 81.2898568 147.720804 80.1345546 157.667578L80 160L80 240C80 250.2567168 87.7208038 258.7101432 97.6675774 259.8654454L100 260L300 260zM300 240L200 240L200 160L300 160L300 240z" : "M300 320C310.256716 320 318.710144 312.2791962 319.865446 302.3324225L320 300L320 20C320 9.743284 312.279196 1.289856 302.332422 0.134554L300 0L240 0C228.954306 0 220 8.954306 220 20C220 30.256716 227.720804 38.710144 237.667578 39.865446L240 40L280 40L280 280L240 280C229.743284 280 221.289856 287.7208038 220.134554 297.6675774000001L220 300C220 310.25671678 227.720804 318.7101432140001 237.667578 319.8654453734L240 320L300 320zM80 320C91.045695 320 100 311.045695 100 300C100 289.7432832 92.2791962 281.2898568 82.3324226 280.1345546L80 280L40 280L40 40L80 40C90.2567168 40 98.7101432 32.279196 99.8654454 22.332422L100 20C100 9.743284 92.2791962 1.289856 82.3324226 0.134554L80 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 300C0 310.25671678 7.7208038 318.7101432140001 17.6675775 319.8654453734L20 320L80 320zM220 200C230.256716 200 238.710144 192.2791962 239.865446 182.3324226L240 180L240 140C240 129.7432832 232.279196 121.2898568 222.332422 120.1345546L220 120L100 120C89.7432832 120 81.2898568 127.7208038 80.1345546 137.6675774L80 140L80 180C80 190.2567168 87.7208038 198.7101432 97.6675774 199.8654454L100 200L220 200zM220 180L160 180L160 140L220 140L220 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrayBoolean.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrayBoolean.displayName = "Blueprint5.Icon.ArrayBoolean";
exports.default = ArrayBoolean;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aBFnS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrayDate", ()=>ArrayDate);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrayDate = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "array-date",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400C390.2567160000001 400 398.710144 392.2791962 399.865446 382.3324225L400 380L400 20C400 9.743284 392.279196 1.289856 382.332422 0.134554L380 0L300 0C288.9543060000001 0 280 8.954306 280 20C280 30.256716 287.720804 38.710144 297.667578 39.865446L300 40L360 40L360 360L300 360C289.743284 360 281.289856 367.7208038 280.1345540000001 377.6675774000001L280 380C280 390.25671678 287.720804 398.7101432140001 297.667578 399.8654453736L300 400L380 400zM100 400C111.045695 400 120 391.045695 120 380C120 369.7432832 112.2791962 361.2898568 102.3324226 360.1345546L100 360L40 360L40 40L100 40C110.2567168 40 118.7101432 32.279196 119.8654454 22.332422L120 20C120 9.743284 112.2791962 1.289856 102.3324226 0.134554L100 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 380C0 390.25671678 7.7208038 398.7101432140001 17.6675775 399.8654453734L20 400L100 400zM150 300C155.5228474 300 160 295.5228474 160 290L160 280L240 280L240 290C240 295.5228474 244.477152 300 250 300L270 300C275.522848 300 280 295.5228474 280 290L280 280L300 280C310.256716 280 318.710144 272.2791962 319.865446 262.3324226L320 260L320 120C320 109.743284 312.279196 101.289856 302.332422 100.134554L300 100L100 100C89.7432832 100 81.2898568 107.720804 80.1345546 117.667578L80 120L80 260C80 270.2567168 87.7208038 278.7101432 97.6675774 279.8654454L100 280L120 280L120 290C120 295.5228474 124.4771526 300 130 300L150 300zM300 220L100 220L100 120L300 120L300 220z" : "M300 320C310.256716 320 318.710144 312.2791962 319.865446 302.3324225L320 300L320 20C320 9.743284 312.279196 1.289856 302.332422 0.134554L300 0L240 0C228.954306 0 220 8.954306 220 20C220 30.256716 227.720804 38.710144 237.667578 39.865446L240 40L280 40L280 280L240 280C229.743284 280 221.289856 287.7208038 220.134554 297.6675774000001L220 300C220 310.25671678 227.720804 318.7101432140001 237.667578 319.8654453734L240 320L300 320zM80 320C91.045695 320 100 311.045695 100 300C100 289.7432832 92.2791962 281.2898568 82.3324226 280.1345546L80 280L40 280L40 40L80 40C90.2567168 40 98.7101432 32.279196 99.8654454 22.332422L100 20C100 9.743284 92.2791962 1.289856 82.3324226 0.134554L80 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 300C0 310.25671678 7.7208038 318.7101432140001 17.6675775 319.8654453734L20 320L80 320zM210 240C215.522848 240 220 235.5228474 220 230L220 220C230.256716 220 238.710144 212.2791962 239.865446 202.3324226L240 200L240 100C240 89.743284 232.279196 81.289856 222.332422 80.134554L220 80L100 80C89.7432832 80 81.2898568 87.720804 80.1345546 97.667578L80 100L80 200C80 210.2567168 87.7208038 218.7101432 97.6675774 219.8654454L100 220L100 230C100 235.5228474 104.4771526 240 110 240C115.5228474 240 120 235.5228474 120 230L120 220L200 220L200 230C200 235.5228474 204.477152 240 210 240zM220 180L100 180L100 100L220 100L220 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrayDate.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrayDate.displayName = "Blueprint5.Icon.ArrayDate";
exports.default = ArrayDate;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9QUKT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrayFloatingPoint", ()=>ArrayFloatingPoint);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrayFloatingPoint = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "array-floating-point",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M399.832 377.9156C398.388 390.349 387.82 400 375 400H300C290.586 400 280 392.8209 280 380C280 367.1792 290 360 300.458 360H360.458L360 40H300C290 40 280 32.8199999999999 280 20C280 6.192 290 0 300 0H375L377.9160000000001 0.168C390.35 1.612 400 12.1800000000001 400 25V375L399.832 377.9156zM120 380C120 393.80712 110 400 100 400H25L22.0844 399.8318068C9.651 398.38768 0 387.8209 0 375V25L0.1681932 22.0839999999999C1.61232 9.65 12.1791 0 25 0H100C110 0 120 7.1800000000001 120 20C120 32.8199999999999 110 40 100 40H40V360H100C110 360 120 367.1792 120 380zM108.678 253.508C104.2494 252.7264 99.6904 252.3358 95.0012 252.3358V234.7514H128.607V138.232H153.0296V275H134.8592C134.0776 270.8318000000001 132.3842 267.315 129.7792 264.4494C127.3044 261.5838 124.2434 259.2392 120.5962 257.4156C117.0794 255.592 113.1066 254.2896 108.678 253.508zM286.542 268.2716C280.6500000000001 272.6596 273.002 274.8536000000001 263.598 274.8536000000001C254.196 274.8536000000001 246.486 272.6596 240.468 268.2716C234.576 264.009 229.938 258.4928 226.552 251.7228C223.292 245.0782 221.036 237.744 219.782 229.7204C218.654 221.6966 218.09 213.9236 218.09 206.4014C218.09 198.88 218.654 191.106 219.782 183.082C221.036 175.058 223.292 167.662 226.552 160.892C229.938 154.248 234.576 148.732 240.468 144.344C246.486 140.08 254.196 137.9500000000001 263.598 137.9500000000001C273.002 137.9500000000001 280.6500000000001 140.08 286.542 144.344C292.56 148.732 297.198 154.248 300.458 160.892C303.842 167.662 306.1 175.058 307.228 183.082C308.482 191.106 309.108 198.88 309.108 206.4014C309.108 213.9236 308.482 221.6966 307.228 229.7204C306.1 237.744 303.842 245.0782 300.458 251.7228C297.198 258.4928 292.56 264.009 286.542 268.2716zM275.258 159.764C272.124 157.132 268.238 155.814 263.598 155.814C258.834 155.814 254.886 157.132 251.752 159.764C248.742 162.522 246.298 166.158 244.418 170.672C242.662 175.31 241.408 180.7 240.656 186.844C239.904 192.986 239.528 199.506 239.528 206.4014C239.528 213.2968 239.904 219.7534 240.656 225.7712C241.408 231.9142 242.662 237.3052 244.418 241.9438C246.298 246.5826 248.742 250.2182 251.752 252.851C254.886 255.6092 258.834 256.9882 263.598 256.9882C268.238 256.9882 272.124 255.6092 275.258 252.851C278.392 250.2182 280.838 246.5826 282.592 241.9438C284.474 237.3052 285.79 231.9142 286.542 225.7712C287.294 219.7534 287.67 213.2968 287.67 206.4014C287.67 199.506 287.294 192.986 286.542 186.844C285.79 180.7 284.474 175.31 282.592 170.672C280.838 166.158 278.392 162.522 275.258 159.764zM177.0618 163.868H204.22V137.49H177.0618V163.868z" : "M319.866 302.33242C318.71 312.2792 310.2560000000001 320 300 320H240L237.668 319.8654454C227.72 318.710144 220 310.25672 220 300L220.134 297.6676C221.29 287.7208 229.744 280 240 280H280V40H240L237.668 39.866C227.72 38.71 220 30.256 220 20C220 8.954 228.954 0 240 0H300L302.332 0.134C312.2800000000001 1.29 320 9.744 320 20V300L319.866 302.33242zM100 300C100 311.0457 91.0456 320 80 320H20L17.66758 319.8654454C7.7208 318.710144 0 310.25672 0 300V20L0.1345546 17.668C1.289856 7.72 9.74328 0 20 0H80L82.3324 0.134C92.2792 1.29 100 9.744 100 20L99.8654 22.332C98.7102 32.28 90.2568 40 80 40H40V280H80L82.3324 280.1346C92.2792 281.2898 100 289.7432 100 300zM86.9424 202.8064C83.3994 202.1812 79.7524 201.8686 76.001 201.8686V187.801H102.8856V110.586H122.4238V220H107.8872C107.262 216.6654 105.9074 213.852 103.8234 211.5596C101.8434 209.267 99.3948 207.3914 96.477 205.9326C93.6636 204.4736 90.4852 203.4316 86.9424 202.8064zM229.234 214.6172C224.52 218.1276 218.402 219.8828 210.88 219.8828C203.356 219.8828 197.1888 218.1276 192.3746 214.6172C187.6606 211.2072 183.9496 206.7942 181.2416 201.3782C178.634 196.0626 176.8286 190.1952 175.8256 183.7762C174.923 177.3572 174.4716 171.139 174.4716 165.1212C174.4716 159.1034 174.923 152.885 175.8256 146.4662C176.8286 140.0472 178.634 134.1296 181.2416 128.7138C183.9496 123.398 187.6606 118.986 192.3746 115.474C197.1888 112.064 203.356 110.36 210.88 110.36C218.402 110.36 224.52 112.064 229.234 115.474C234.048 118.986 237.758 123.398 240.366 128.7138C243.074 134.1296 244.88 140.0472 245.782 146.4662C246.786 152.885 247.286 159.1034 247.286 165.1212C247.286 171.139 246.786 177.3572 245.782 183.7762C244.88 190.1952 243.074 196.0626 240.366 201.3782C237.758 206.7942 234.048 211.2072 229.234 214.6172zM220.206 127.811C217.7 125.7048 214.59 124.6518 210.88 124.6518C207.068 124.6518 203.908 125.7048 201.402 127.811C198.994 130.0176 197.0384 132.9262 195.5338 136.5368C194.1298 140.2478 193.1268 144.5604 192.525 149.475C191.9232 154.3894 191.6224 159.6048 191.6224 165.1212C191.6224 170.6374 191.9232 175.8028 192.525 180.617C193.1268 185.5314 194.1298 189.8442 195.5338 193.5552C197.0384 197.266 198.994 200.1746 201.402 202.2808C203.908 204.4874 207.068 205.5906 210.88 205.5906C214.59 205.5906 217.7 204.4874 220.206 202.2808C222.714 200.1746 224.67 197.266 226.074 193.5552C227.578 189.8442 228.632 185.5314 229.234 180.617C229.836 175.8028 230.136 170.6374 230.136 165.1212C230.136 159.6048 229.836 154.3894 229.234 149.475C228.632 144.5604 227.578 140.2478 226.074 136.5368C224.67 132.9262 222.714 130.0176 220.206 127.811zM141.6494 131.0938H163.3758V109.992H141.6494V131.0938z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrayFloatingPoint.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrayFloatingPoint.displayName = "Blueprint5.Icon.ArrayFloatingPoint";
exports.default = ArrayFloatingPoint;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a1qX4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrayNumeric", ()=>ArrayNumeric);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrayNumeric = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "array-numeric",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400C390.2567160000001 400 398.710144 392.2791962 399.865446 382.3324225L400 380L400 20C400 9.743284 392.279196 1.289856 382.332422 0.134554L380 0L300 0C288.9543060000001 0 280 8.954306 280 20C280 30.256716 287.720804 38.710144 297.667578 39.865446L300 40L360 40L360 360L300 360C289.743284 360 281.289856 367.7208038 280.1345540000001 377.6675774000001L280 380C280 390.25671678 287.720804 398.7101432140001 297.667578 399.8654453736L300 400L380 400zM100 400C111.045695 400 120 391.045695 120 380C120 369.7432832 112.2791962 361.2898568 102.3324226 360.1345546L100 360L40 360L40 40L100 40C110.2567168 40 118.7101432 32.279196 119.8654454 22.332422L120 20C120 9.743284 112.2791962 1.289856 102.3324226 0.134554L100 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 380C0 390.25671678 7.7208038 398.7101432140001 17.6675775 399.8654453734L20 400L100 400zM279.9 278.2C286.3 278.2 291.9666660000001 277.2666666 296.9000000000001 275.4C301.833334 273.5333334 306 270.9333334 309.4000000000001 267.6C312.8 264.2666666 315.4 260.3 317.2 255.7C319 251.1 319.9 246.0666666 319.9 240.6C319.9 234.8666666 318.633334 229.5666666 316.1 224.7C313.566666 219.8333334 309.766666 215.7333334 304.7 212.4L304.7 212.4L304.7 212L306.722222 211.0111112C308.085186 210.225926 309.477778 209.1888888 310.9 207.9C313.033334 205.9666666 314.9666660000001 203.6 316.7000000000001 200.8C318.433334 198 319.866666 194.766666 321 191.1C322.1333340000001 187.433334 322.7000000000001 183.4 322.7000000000001 179C322.7000000000001 172.733334 321.633334 167.066666 319.5 162C317.366666 156.933334 314.4000000000001 152.6 310.6 149C306.8 145.4 302.3 142.633334 297.1 140.7C291.9000000000001 138.766666 286.233334 137.8 280.1 137.8C269.433334 137.8 260.3 140.333334 252.7 145.4C245.1 150.466666 240.233334 157.666666 238.1 167C237.833334 168.333334 238.366666 169.2 239.7 169.6L239.7 169.6L257.1 173.6L257.925 173.6625C258.675 173.5875 259.2000000000001 173.1 259.5 172.2C260.966666 168.2 263.366666 164.8 266.7000000000001 162C270.033334 159.2 274.5 157.8 280.1 157.8C286.5 157.8 291.433334 159.7 294.9 163.5C298.366666 167.3 300.1 172.133334 300.1 178C300.1 184.933334 298.1 190.366666 294.1 194.3C290.1 198.233334 284.7 200.2 277.9 200.2L277.9 200.2L272.1 200.2L271.225 200.325C270.475 200.575 270.1 201.2 270.1 202.2L270.1 202.2L270.1 218L270.225 218.875C270.475 219.625 271.1 220 272.1 220L272.1 220L277.5 220L280.4 220.15C285.066666 220.65 288.9 222.4 291.9000000000001 225.4C295.5 229 297.3 233.8 297.3 239.8C297.3 245.2666666 295.7 249.7 292.5 253.1C289.3 256.5 284.833334 258.2 279.1 258.2C274.033334 258.2 270.033334 256.9333334000001 267.1 254.4C264.166666 251.8666666 262.1 248.4666666 260.9 244.2C260.5 243 259.7 242.5333334 258.5 242.8L258.5 242.8L241.5 246.8L240.65 247.1C239.95 247.5 239.7 248.2 239.9 249.2C240.7 253.3333334 242.2 257.1666666 244.4 260.7C246.6 264.2333334 249.4 267.3 252.8 269.9C256.2 272.5 260.2 274.5333334 264.8 276C269.4000000000001 277.4666666 274.433334 278.2 279.9 278.2zM120.1 276L120.975 275.875C121.725 275.625 122.1 275 122.1 274L122.1 274L122.1 142L121.975 141.125C121.725 140.375 121.1 140 120.1 140L120.1 140L101.7 140L100.825 140.125C100.075 140.375 99.7 141 99.7 142L99.7 142L99.7 249.2L99.3 249.2L78.5 234.6L77.708 234.2C76.7693334 233.88 76.3 234.4133334 76.3 235.8L76.3 235.8L76.3 256.2L76.4555556 257.2222222000001C76.662963 257.874074 77.0777778 258.4666666 77.7 259L77.7 259L99.5 274.8L100.5222222 275.4666666C101.262963 275.8222222 102.1222222 276 103.1 276L103.1 276L120.1 276zM186.9 278.2C193.3 278.2 198.9666666 277.2 203.9 275.2C208.833334 273.2 213 270.5 216.4 267.1C219.8 263.7 222.4 259.7000000000001 224.2 255.1C226 250.5 226.9 245.5333334 226.9 240.2C226.9 234.0666666 225.766666 228.4333334 223.5 223.3C221.233334 218.1666666 218.1 213.2 214.1 208.4L214.1 208.4L174.5 160.4L174.5 160L224.9 160L225.775 159.875C226.525 159.625 226.9 159 226.9 158L226.9 158L226.9 142L226.775 141.125C226.525 140.375 225.9 140 224.9 140L224.9 140L148.5 140L147.625 140.125C146.875 140.375 146.5 141 146.5 142L146.5 142L146.5 157L146.6111112 158C146.7592592 158.622222 147.0555556 159.155556 147.5 159.6L147.5 159.6L195.5 219.4L197.9888888 222.7333334C199.5296296 224.9555556 200.833334 227.1777778 201.9 229.4C203.5 232.7333334 204.3 236.3333334 204.3 240.2C204.3 245.2666666 202.733334 249.5333334 199.6 253C196.4666666 256.4666666 192.0333334 258.2 186.3 258.2C180.8333334 258.2 176.5666666 256.6666666 173.5 253.6C170.4333334 250.5333334 168.5666666 246.4 167.9 241.2C167.6333334 239.8666666 166.9 239.3333334 165.7 239.6L165.7 239.6L148.1 243.2L147.25 243.5C146.55 243.9 146.3 244.6 146.5 245.6C146.9 249.6 148.0333334 253.5333334 149.9 257.4C151.7666666 261.2666666 154.3666666 264.7666666 157.7 267.9C161.0333334 271.0333334 165.1333334 273.5333334 170 275.4C174.8666666 277.2666666 180.5 278.2 186.9 278.2z" : "M300 320C310.256716 320 318.710144 312.2791962 319.865446 302.3324225L320 300L320 20C320 9.743284 312.279196 1.289856 302.332422 0.134554L300 0L240 0C228.954306 0 220 8.954306 220 20C220 30.256716 227.720804 38.710144 237.667578 39.865446L240 40L280 40L280 280L240 280C229.743284 280 221.289856 287.7208038 220.134554 297.6675774000001L220 300C220 310.25671678 227.720804 318.7101432140001 237.667578 319.8654453734L240 320L300 320zM80 320C91.045695 320 100 311.045695 100 300C100 289.7432832 92.2791962 281.2898568 82.3324226 280.1345546L80 280L40 280L40 40L80 40C90.2567168 40 98.7101432 32.279196 99.8654454 22.332422L100 20C100 9.743284 92.2791962 1.289856 82.3324226 0.134554L80 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 300C0 310.25671678 7.7208038 318.7101432140001 17.6675775 319.8654453734L20 320L80 320zM218.08 220C223.2 220 227.733334 219.2533334 231.68 217.76C235.626666 216.2666666 238.96 214.1866666 241.68 211.52C244.4 208.8533334 246.48 205.68 247.92 202C249.36 198.32 250.08 194.2933334 250.08 189.92C250.08 185.3333334 249.066666 181.0933334 247.04 177.2C245.013334 173.3066666 241.973334 170.0266666 237.92 167.36L237.92 167.36L237.92 167.04L239.537778 166.2488888C240.628148 165.6207408 241.742222 164.7911112 242.88 163.76C244.586666 162.2133334 246.133334 160.32 247.52 158.08C248.906666 155.84 250.053334 153.2533334 250.96 150.32C251.866666 147.3866666 252.32 144.16 252.32 140.64C252.32 135.6266666 251.466666 131.0933334 249.76 127.04C248.053334 122.9866666 245.68 119.52 242.64 116.64C239.6 113.76 236 111.546666 231.84 110C227.68 108.453334 223.146666 107.68 218.24 107.68C209.706666 107.68 202.4 109.706666 196.32 113.76C190.24 117.813334 186.3466666 123.5733334 184.64 131.04C184.4266666 132.1066666 184.8533334 132.8 185.92 133.12L185.92 133.12L199.84 136.32L200.5 136.37C201.1 136.31 201.52 135.92 201.76 135.2C202.933334 132 204.853334 129.28 207.52 127.04C210.186666 124.8 213.76 123.68 218.24 123.68C223.36 123.68 227.306666 125.2 230.08 128.24C232.853334 131.28 234.24 135.1466666 234.24 139.84C234.24 145.3866666 232.64 149.7333334 229.44 152.88C226.24 156.0266666 221.92 157.6 216.48 157.6L216.48 157.6L211.84 157.6L211.14 157.7C210.54 157.9 210.24 158.4 210.24 159.2L210.24 159.2L210.24 171.84L210.34 172.54C210.54 173.14 211.04 173.44 211.84 173.44L211.84 173.44L216.16 173.44L218.9248 173.6128C222.4576 174.0736 225.376 175.456 227.68 177.76C230.56 180.64 232 184.48 232 189.28C232 193.6533334 230.72 197.2 228.16 199.92C225.6 202.64 222.026666 204 217.44 204C213.386666 204 210.186666 202.9866666 207.84 200.96C205.493334 198.9333334 203.84 196.2133334 202.88 192.8C202.56 191.84 201.92 191.4666666 200.96 191.68L200.96 191.68L187.36 194.88L186.68 195.12C186.12 195.44 185.92 196 186.08 196.8C186.72 200.1066666 187.92 203.1733334 189.68 206C191.44 208.8266666 193.68 211.28 196.4 213.36C199.12 215.44 202.32 217.0666666 206 218.24C209.68 219.4133334 213.706666 220 218.08 220zM95.04 218.24L95.74 218.14C96.34 217.94 96.64 217.44 96.64 216.64L96.64 216.64L96.64 111.04L96.54 110.34C96.34 109.74 95.84 109.44 95.04 109.44L95.04 109.44L80.32 109.44L79.62 109.54C79.02 109.74 78.72 110.24 78.72 111.04L78.72 111.04L78.72 196.8L78.4 196.8L61.76 185.12L61.1264 184.8C60.3754666 184.544 60 184.9706666 60 186.08L60 186.08L60 202.4L60.1244444 203.2177778C60.2903704 203.7392592 60.6222222 204.2133334 61.12 204.64L61.12 204.64L78.56 217.28L79.3777778 217.8133334C79.9703704 218.0977778 80.6577778 218.24 81.44 218.24L81.44 218.24L95.04 218.24zM146.88 220C152 220 156.5333334 219.2 160.48 217.6C164.4266666 216 167.76 213.84 170.48 211.12C173.2 208.4 175.28 205.2 176.72 201.52C178.16 197.84 178.88 193.8666666 178.88 189.6C178.88 184.6933334 177.9733334 180.1866666 176.16 176.08C174.3466666 171.9733334 171.84 168 168.64 164.16L168.64 164.16L136.96 125.76L136.96 125.44L177.28 125.44L177.98 125.34C178.58 125.14 178.88 124.64 178.88 123.84L178.88 123.84L178.88 111.04L178.78 110.34C178.58 109.74 178.08 109.44 177.28 109.44L177.28 109.44L116.16 109.44L115.46 109.54C114.86 109.74 114.56 110.24 114.56 111.04L114.56 111.04L114.56 123.04L114.6488888 123.84C114.7674074 124.3377778 115.0044444 124.7644444 115.36 125.12L115.36 125.12L153.76 172.96L155.7511112 175.6266666C156.9837038 177.4044444 158.0266666 179.1822222 158.88 180.96C160.16 183.6266666 160.8 186.5066666 160.8 189.6C160.8 193.6533334 159.5466666 197.0666666 157.04 199.84C154.5333334 202.6133334 150.9866666 204 146.4 204C142.0266666 204 138.6133334 202.7733334 136.16 200.32C133.7066666 197.8666666 132.2133334 194.56 131.68 190.4C131.4666666 189.3333334 130.88 188.9066666 129.92 189.12L129.92 189.12L115.84 192L115.16 192.24C114.6 192.56 114.4 193.12 114.56 193.92C114.88 197.12 115.7866666 200.2666666 117.28 203.36C118.7733334 206.4533334 120.8533334 209.2533334 123.52 211.76C126.1866666 214.2666666 129.4666666 216.2666666 133.36 217.76C137.2533334 219.2533334 141.76 220 146.88 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrayNumeric.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrayNumeric.displayName = "Blueprint5.Icon.ArrayNumeric";
exports.default = ArrayNumeric;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ysNW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrayString", ()=>ArrayString);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrayString = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "array-string",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400C390.2567160000001 400 398.710144 392.2791962 399.865446 382.3324225L400 380L400 20C400 9.743284 392.279196 1.289856 382.332422 0.134554L380 0L300 0C288.9543060000001 0 280 8.954306 280 20C280 30.256716 287.720804 38.710144 297.667578 39.865446L300 40L360 40L360 360L300 360C289.743284 360 281.289856 367.7208038 280.1345540000001 377.6675774000001L280 380C280 390.25671678 287.720804 398.7101432140001 297.667578 399.8654453736L300 400L380 400zM100 400C111.045695 400 120 391.045695 120 380C120 369.7432832 112.2791962 361.2898568 102.3324226 360.1345546L100 360L40 360L40 40L100 40C110.2567168 40 118.7101432 32.279196 119.8654454 22.332422L120 20C120 9.743284 112.2791962 1.289856 102.3324226 0.134554L100 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 380C0 390.25671678 7.7208038 398.7101432140001 17.6675775 399.8654453734L20 400L100 400zM140.2325582 280C153.1007752 280 164.3023256 274.6899224 173.8372094 264.0697674C183.372093 253.4496124 188.1395348 239.1472868 188.1395348 221.1627906C188.1395348 200.2325582 181.7054264 181.472868 168.8372094 164.88372C155.9689922 148.294574 135.6589148 134.88372 107.9069768 124.651162L107.9069768 124.651162L107.9069768 136.27907L113.1036462 138.367786C126.6245574 144.270744 137.4504738 152.83807 145.5813954 164.069768C154.7286822 176.705426 159.3023256 189.844962 159.3023256 203.488372C159.3023256 206.4341086 158.8372094 208.6046512 157.9069768 210C157.4418604 210.9302326 156.8217054 211.3953488 156.0465116 211.3953488C155.2713178 211.3953488 154.0310078 210.7751938 152.3255814 209.5348838C147.364341 205.9689922 141.1627906 204.1860466 133.7209302 204.1860466C124.7286822 204.1860466 116.8604652 207.7906976 110.116279 215C103.372093 222.2093024 100 230.7751938 100 240.6976744C100 251.24031 103.875969 260.4263566 111.627907 268.255814C119.379845 276.0852714 128.9147286 280 140.2325582 280zM252.093024 280C264.96124 280 276.16279 274.6899224 285.697674 264.0697674C295.2325580000001 253.4496124 300 239.1472868 300 221.1627906C300 200.2325582 293.565892 181.472868 280.697674 164.88372C267.829458 148.294574 247.51938 134.88372 219.767442 124.651162L219.767442 124.651162L219.767442 136.27907L224.964112 138.367786C238.485022 144.270744 249.310938 152.83807 257.44186 164.069768C266.589148 176.705426 271.16279 189.844962 271.16279 203.488372C271.16279 206.4341086 270.697674 208.6046512 269.767442 210C269.302326 210.9302326 268.6821700000001 211.3953488 267.906976 211.3953488C267.1317820000001 211.3953488 265.891472 210.7751938 264.186046 209.5348838C259.224806 205.9689922 253.023256 204.1860466 245.581396 204.1860466C236.589148 204.1860466 228.72093 207.7906976 221.976744 215C215.232558 222.2093024 211.860466 230.7751938 211.860466 240.6976744C211.860466 251.24031 215.736434 260.4263566 223.488372 268.255814C231.24031 276.0852714 240.775194 280 252.093024 280z" : "M300 320C310.256716 320 318.710144 312.2791962 319.865446 302.3324225L320 300L320 20C320 9.743284 312.279196 1.289856 302.332422 0.134554L300 0L240 0C228.954306 0 220 8.954306 220 20C220 30.256716 227.720804 38.710144 237.667578 39.865446L240 40L280 40L280 280L240 280C229.743284 280 221.289856 287.7208038 220.134554 297.6675774000001L220 300C220 310.25671678 227.720804 318.7101432140001 237.667578 319.8654453734L240 320L300 320zM80 320C91.045695 320 100 311.045695 100 300C100 289.7432832 92.2791962 281.2898568 82.3324226 280.1345546L80 280L40 280L40 40L80 40C90.2567168 40 98.7101432 32.279196 99.8654454 22.332422L100 20C100 9.743284 92.2791962 1.289856 82.3324226 0.134554L80 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 300C0 310.25671678 7.7208038 318.7101432140001 17.6675775 319.8654453734L20 320L80 320zM112.1860466 220C122.4806202 220 131.4418604 215.751938 139.0697674 207.255814C146.6976744 198.75969 150.511628 187.3178294 150.511628 172.9302326C150.511628 156.1860466 145.364341 141.1782946 135.0697674 127.9069768C124.7751938 114.635658 108.5271318 103.906976 86.3255814 95.72093L86.3255814 95.72093L86.3255814 105.023256L90.988372 106.917152C101.5697674 111.631298 110.0620156 118.410852 116.4651162 127.255814C123.7829458 137.364341 127.4418604 147.875969 127.4418604 158.7906976C127.4418604 161.1472868 127.0697674 162.883721 126.3255814 164C125.9534884 164.744186 125.4573644 165.116279 124.8372094 165.116279C124.2170542 165.116279 123.2248062 164.620155 121.8604652 163.627907C117.8914728 160.7751938 112.9302326 159.3488372 106.9767442 159.3488372C99.7829458 159.3488372 93.488372 162.2325582 88.0930232 168C82.6976744 173.7674418 80 180.620155 80 188.5581396C80 196.992248 83.1007752 204.3410852 89.3023256 210.6046512C95.503876 216.868217 103.131783 220 112.1860466 220zM201.674418 220C211.968992 220 220.930232 215.751938 228.55814 207.255814C236.186046 198.75969 240 187.3178294 240 172.9302326C240 156.1860466 234.852714 141.1782946 224.55814 127.9069768C214.263566 114.635658 198.0155038 103.906976 175.8139534 95.72093L175.8139534 95.72093L175.8139534 105.023256L180.4767442 106.917152C191.0581396 111.631298 199.5503876 118.410852 205.953488 127.255814C213.271318 137.364341 216.930232 147.875969 216.930232 158.7906976C216.930232 161.1472868 216.55814 162.883721 215.813954 164C215.44186 164.744186 214.945736 165.116279 214.325582 165.116279C213.705426 165.116279 212.713178 164.620155 211.348838 163.627907C207.379844 160.7751938 202.418604 159.3488372 196.4651162 159.3488372C189.2713178 159.3488372 182.9767442 162.2325582 177.5813954 168C172.1860466 173.7674418 169.488372 180.620155 169.488372 188.5581396C169.488372 196.992248 172.5891472 204.3410852 178.7906976 210.6046512C184.992248 216.868217 192.620155 220 201.674418 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrayString.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrayString.displayName = "Blueprint5.Icon.ArrayString";
exports.default = ArrayString;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fwdY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrayTimestamp", ()=>ArrayTimestamp);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrayTimestamp = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "array-timestamp",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400C390.2567160000001 400 398.710144 392.2791962 399.865446 382.3324225L400 380L400 20C400 9.743284 392.279196 1.289856 382.332422 0.134554L380 0L300 0C288.9543060000001 0 280 8.954306 280 20C280 30.256716 287.720804 38.710144 297.667578 39.865446L300 40L360 40L360 360L300 360C289.743284 360 281.289856 367.7208038 280.1345540000001 377.6675774000001L280 380C280 390.25671678 287.720804 398.7101432140001 297.667578 399.8654453736L300 400L380 400zM100 400C111.045695 400 120 391.045695 120 380C120 369.7432832 112.2791962 361.2898568 102.3324226 360.1345546L100 360L40 360L40 40L100 40C110.2567168 40 118.7101432 32.279196 119.8654454 22.332422L120 20C120 9.743284 112.2791962 1.289856 102.3324226 0.134554L100 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 380C0 390.25671678 7.7208038 398.7101432140001 17.6675775 399.8654453734L20 400L100 400zM200 320C266.2741700000001 320 320 266.2741700000001 320 200C320 133.72583 266.2741700000001 80 200 80C133.72583 80 80 133.72583 80 200C80 266.2741700000001 133.72583 320 200 320zM200 300C144.771525 300 100 255.228475 100 200C100 144.771526 144.771525 100 200 100C255.228474 100 300 144.771526 300 200C300 255.228475 255.228474 300 200 300zM257.071068 257.0710678000001C260.542394 253.5997408 260.9280980000001 248.2112528 258.228176 244.31389L257.071068 242.9289322L207.071068 192.928932C203.59974 189.457606 198.2112528 189.071902 194.31389 191.771824L192.9289322 192.928932L162.9289322 222.9289322C159.0236892 226.8341752 159.0236892 233.1658248 162.9289322 237.0710678C166.4002592 240.5423948 171.7887472 240.9280978 175.68611 238.2281768L177.0710678 237.0710678L200 214.14L242.9289320000001 257.0710678000001C246.834176 260.9763108 253.165824 260.9763108 257.071068 257.0710678000001z" : "M300 320C310.256716 320 318.710144 312.2791962 319.865446 302.3324225L320 300L320 20C320 9.743284 312.279196 1.289856 302.332422 0.134554L300 0L240 0C228.954306 0 220 8.954306 220 20C220 30.256716 227.720804 38.710144 237.667578 39.865446L240 40L280 40L280 280L240 280C229.743284 280 221.289856 287.7208038 220.134554 297.6675774000001L220 300C220 310.25671678 227.720804 318.7101432140001 237.667578 319.8654453734L240 320L300 320zM80 320C91.045695 320 100 311.045695 100 300C100 289.7432832 92.2791962 281.2898568 82.3324226 280.1345546L80 280L40 280L40 40L80 40C90.2567168 40 98.7101432 32.279196 99.8654454 22.332422L100 20C100 9.743284 92.2791962 1.289856 82.3324226 0.134554L80 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 300C0 310.25671678 7.7208038 318.7101432140001 17.6675775 319.8654453734L20 320L80 320zM160 260C215.228474 260 260 215.228475 260 160C260 104.771526 215.228474 60 160 60C104.771525 60 60 104.771526 60 160C60 215.228475 104.771525 260 160 260zM160 240C115.81722 240 80 204.18278 80 160C80 115.81722 115.81722 80 160 80C204.18278 80 240 115.81722 240 160C240 204.18278 204.18278 240 160 240zM207.071068 207.0710678C210.542394 203.5997408 210.928098 198.2112528 208.228176 194.31389L207.071068 192.9289322L167.0710678 152.9289322C163.5997408 149.4576052 158.2112528 149.0719022 154.31389 151.7718232L152.9289322 152.9289322L132.9289322 172.9289322C129.0236892 176.8341752 129.0236892 183.1658248 132.9289322 187.0710678C136.4002592 190.5423948 141.7887472 190.9280978 145.68611 188.2281768L147.0710678 187.0710678L160 174.14L192.9289322 207.0710678C196.8341752 210.9763108 203.165824 210.9763108 207.071068 207.0710678z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrayTimestamp.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrayTimestamp.displayName = "Blueprint5.Icon.ArrayTimestamp";
exports.default = ArrayTimestamp;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cpEIL":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Array", ()=>Array);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Array = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "array",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400C390.2567160000001 400 398.710144 392.2791962 399.865446 382.3324225L400 380L400 20C400 9.743284 392.279196 1.289856 382.332422 0.134554L380 0L300 0C288.9543060000001 0 280 8.954306 280 20C280 30.256716 287.720804 38.710144 297.667578 39.865446L300 40L360 40L360 360L300 360C289.743284 360 281.289856 367.7208038 280.1345540000001 377.6675774000001L280 380C280 390.25671678 287.720804 398.7101432140001 297.667578 399.8654453736L300 400L380 400zM100 400C111.045695 400 120 391.045695 120 380C120 369.7432832 112.2791962 361.2898568 102.3324226 360.1345546L100 360L40 360L40 40L100 40C110.2567168 40 118.7101432 32.279196 119.8654454 22.332422L120 20C120 9.743284 112.2791962 1.289856 102.3324226 0.134554L100 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 380C0 390.25671678 7.7208038 398.7101432140001 17.6675775 399.8654453734L20 400L100 400zM200 220C211.045694 220 220 211.045695 220 200C220 188.954306 211.045694 180 200 180C188.954305 180 180 188.954306 180 200C180 211.045695 188.954305 220 200 220zM120 220C131.045695 220 140 211.045695 140 200C140 188.954306 131.045695 180 120 180C108.954305 180 100 188.954306 100 200C100 211.045695 108.954305 220 120 220zM280 220C291.045694 220 300 211.045695 300 200C300 188.954306 291.045694 180 280 180C268.9543060000001 180 260 188.954306 260 200C260 211.045695 268.9543060000001 220 280 220z" : "M300 320C310.256716 320 318.710144 312.2791962 319.865446 302.3324225L320 300L320 20C320 9.743284 312.279196 1.289856 302.332422 0.134554L300 0L240 0C228.954306 0 220 8.954306 220 20C220 30.256716 227.720804 38.710144 237.667578 39.865446L240 40L280 40L280 280L240 280C229.743284 280 221.289856 287.7208038 220.134554 297.6675774000001L220 300C220 310.25671678 227.720804 318.7101432140001 237.667578 319.8654453734L240 320L300 320zM80 320C91.045695 320 100 311.045695 100 300C100 289.7432832 92.2791962 281.2898568 82.3324226 280.1345546L80 280L40 280L40 40L80 40C90.2567168 40 98.7101432 32.279196 99.8654454 22.332422L100 20C100 9.743284 92.2791962 1.289856 82.3324226 0.134554L80 0L20 0C9.74328322 0 1.289856786 7.720804 0.1345546266 17.667578L0 20L0 300C0 310.25671678 7.7208038 318.7101432140001 17.6675775 319.8654453734L20 320L80 320zM160 180C171.045695 180 180 171.045695 180 160C180 148.954305 171.045695 140 160 140C148.954305 140 140 148.954305 140 160C140 171.045695 148.954305 180 160 180zM100 180C111.045695 180 120 171.045695 120 160C120 148.954305 111.045695 140 100 140C88.954305 140 80 148.954305 80 160C80 171.045695 88.954305 180 100 180zM220 180C231.045694 180 240 171.045695 240 160C240 148.954305 231.045694 140 220 140C208.954306 140 200 148.954305 200 160C200 171.045695 208.954306 180 220 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Array.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Array.displayName = "Blueprint5.Icon.Array";
exports.default = Array;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l0Fzm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowBottomLeft", ()=>ArrowBottomLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrowBottomLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "arrow-bottom-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 340C360 351 351 360 340 360C334.4 360 329.4 357.8 325.8 354.2L80 108.2V260C80 271 71 280 60 280S40 271 40 260V60C40 49 49 40 60 40H260C271 40 280 49 280 60C280 71 271 80 260 80H108.2L354.2000000000001 325.8C357.8 329.4 360 334.4 360 340z" : "M280 260C280 271 271 280 260 280C254.4 280 249.4 277.8 245.8 274.2L80 108.2V200C80 211 71 220 60 220S40 211 40 200V60C40 49 49 40 60 40H200C211 40 220 49 220 60C220 71 211 80 200 80H108.2L274 245.8C277.8 249.4 280 254.4 280 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrowBottomLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrowBottomLeft.displayName = "Blueprint5.Icon.ArrowBottomLeft";
exports.default = ArrowBottomLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4iZFn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowBottomRight", ()=>ArrowBottomRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrowBottomRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "arrow-bottom-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 280C329 280 320 271 320 260V108.2L74.2 354.2C70.6 357.8 65.6 360 60 360C49 360 40 351 40 340C40 334.4 42.2 329.4 45.8 325.8L291.8 80H140C129 80 120 71 120 60C120 49 129 40 140 40H340C351 40 360 49 360 60V260C360 271 351 280 340 280z" : "M260 220C249 220 240 211 240 200V108.2L74.2 274.2C70.6 277.8 65.6 280 60 280C49 280 40 271 40 260C40 254.4 42.2 249.4 45.8 245.8L211.8 80H120C109 80 100 71 100 60C100 49 109 40 120 40H260C271 40 280 49 280 60V200C280 211 271 220 260 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrowBottomRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrowBottomRight.displayName = "Blueprint5.Icon.ArrowBottomRight";
exports.default = ArrowBottomRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"igNtS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowDown", ()=>ArrowDown);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrowDown = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "arrow-down",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 180C314 180 310 178 306 174L220 88V360C220 370 212 380 200 380S180 370 180 360V88L94 174C90 178 86 180 80 180C70 180 60 172 60 160C60 154 62 150 66 146L186 26C190 22 194 20 200 20S210 22 214 26L334 146C338 150 340 154 340 160C340 172 330 180 320 180L320 180z" : "M260 160C254 160 250 158 246 154L180 88V280C180 290 172 300 160 300S140 290 140 280V88L74 154C70 158 66 160 60 160C50 160 40 150 40 140C40 134 42 130 46 126L146 26C150 22 154 20 160 20S170 22 174 26L274 126C278 130 280 134 280 140C280 152 272 160 260 160L260 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrowDown.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrowDown.displayName = "Blueprint5.Icon.ArrowDown";
exports.default = ArrowDown;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2PHVM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowLeft", ()=>ArrowLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrowLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "arrow-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 220H88.2L174 305.8C177.8 309.4 180 314.4 180 320C180 331 171 340 160 340C154.4 340 149.4 337.8 145.8 334.2L25.8 214.2C22.2 210.6 20 205.6 20 200C20 194.4 22.2 189.4 25.8 185.8L145.8 65.8C149.4 62.2 154.4 60 160 60C171 60 180 69 180 80C180 85.6 177.8 90.6 174.2 94.2000000000001L88.2 180H360C371 180 380 189 380 200C380 211 371 220 360 220z" : "M279.8 180.2H88.2L154 246C157.6 249.6 159.8 254.6 159.8 260.2C159.8 271.2 150.8 280.2 139.8 280.2C134.2 280.2 129.2 278 125.6 274.4L25.6 174.4C22 170.6 19.8 165.6 19.8 160.2S22 149.6 25.6 146L125.6 46C129.2 42.4 134.2 40.2 139.8 40.2C150.8 40.2 159.8 49.2 159.8 60.2000000000001C159.8 65.8 157.6 70.8 154 74.4L88.2 140.2H280C291 140.2 300 149.2 300 160.2S290.8 180.2 279.8 180.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrowLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrowLeft.displayName = "Blueprint5.Icon.ArrowLeft";
exports.default = ArrowLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3pmoU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowRight", ()=>ArrowRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrowRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "arrow-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M374.2000000000001 214.2L254.2 334.2000000000001C250.6 337.8 245.6 340 240 340C229 340 220 331 220 320C220 314.4 222.2 309.4 225.8 305.8L311.8 220H40C29 220 20 211 20 200C20 189 29 180 40 180H311.8L226 94.2000000000001C222.2 90.6 220 85.6 220 80C220 69 229 60 240 60C245.6 60 250.6 62.2 254.2 65.8L374.2000000000001 185.8C377.8 189.4 380 194.4 380 200C380 205.6 377.8 210.6 374.2000000000001 214.2z" : "M294 174.2L194 274.2C190.4 278 185.4 280.2 179.8 280.2C168.8 280.2 159.8 271.2 159.8 260.2C159.8 254.6 162 249.6 165.6 246L231.4 180.2H39.8C28.8 180.2 19.8 171.2 19.8 160.2S28.8 140.2 39.8 140.2H231.6L165.8 74.4C162.2 70.8 160 65.8 160 60.1999999999999C160 49.1999999999999 169 40.1999999999999 180 40.1999999999999C185.6 40.1999999999999 190.6 42.4 194.2 45.9999999999999L294.2000000000001 146C297.8 149.5999999999999 300 154.5999999999999 300 160.1999999999999S297.6 170.6 294 174.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrowRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrowRight.displayName = "Blueprint5.Icon.ArrowRight";
exports.default = ArrowRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dbrAS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowTopLeft", ()=>ArrowTopLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrowTopLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "arrow-top-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M354.2000000000001 74.2000000000001L108.2 320H260C271 320 280 329 280 340C280 351 271 360 260 360H60C49 360 40 351 40 340V140C40 129 49 120 60 120S80 129 80 140V291.8L325.8 46C329.4 42.2 334.4 40 340 40C351 40 360 49 360 60C360 65.6 357.8 70.6 354.2000000000001 74.2000000000001z" : "M274.2000000000001 74.2L108.2 240H200C211 240 220 249 220 260C220 271 211 280 200 280H60C49 280 40 271 40 260V120C40 109 49 100 60 100S80 109 80 120V211.8L245.8 46C249.4 42.2 254.4 40 260 40C271 40 280 49 280 60C280 65.6 277.8 70.6 274.2000000000001 74.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrowTopLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrowTopLeft.displayName = "Blueprint5.Icon.ArrowTopLeft";
exports.default = ArrowTopLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"PkYIo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowTopRight", ()=>ArrowTopRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrowTopRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "arrow-top-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 360H140C129 360 120 351 120 340C120 329 129 320 140 320H291.8L45.8 74.2000000000001C42.2 70.6 40 65.6 40 60C40 49 49 40 60 40C65.6 40 70.6 42.2 74.2 45.8L320 291.8V140C320 129 329 120 340 120S360 129 360 140V340C360 351 351 360 340 360z" : "M260 280H120C109 280 100 271 100 260C100 249 109 240 120 240H211.8L46 74.2C42.2 70.6 40 65.6 40 60C40 49 49 40 60 40C65.6 40 70.6 42.2 74.2 45.8L240 211.8V120C240 109 249 100 260 100S280 109 280 120V260C280 271 271 280 260 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrowTopRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrowTopRight.displayName = "Blueprint5.Icon.ArrowTopRight";
exports.default = ArrowTopRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bDXjO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowUp", ()=>ArrowUp);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrowUp = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "arrow-up",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M334 254L214 374C210 378 206 380 200 380S190 378 186 374L66 254C62 250 60 246 60 240C60 228 70 220 80 220C86 220 90 222 94 226L180 312V40C180 30 188 20 200 20S220 30 220 40V312L306 226C310 222 314 220 320 220C330 220 340 228 340 240C340 246 338 250 334 254L334 254z" : "M274 194L174 294C170 298 166 300 160 300S150 298 146 294L46 194C42 190 40 186 40 180C40 168 50 160 60 160C66 160 70 162 74 166L140 232V40C140 28 148 20 160 20S180 28 180 40V232L246 166C250 162 254 160 260 160C272 160 280 168 280 180C280 186 278 190 274 194L274 194z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrowUp.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrowUp.displayName = "Blueprint5.Icon.ArrowUp";
exports.default = ArrowUp;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2R75V":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowsArc", ()=>ArrowsArc);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrowsArc = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "arrows-arc",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M84.9112 396.33884C89.7926 401.220388 97.7072 401.220388 102.5888 396.33884L182.1382 316.7894C187.0198 311.9078 187.0198 303.9932 182.1382 299.1116C177.2568 294.23 169.3422 294.23 164.4606 299.1116L106.16 357.4124L106.1596 357.3444C105.9526 312.4674 105.7964 278.634 110.7604 249.478C116.5778 215.3104 129.4266 188.094 158.8156 158.862C188.375 129.46 214.218 116.696 247.468 110.876C276.19 105.846 310.146 105.982 357.2120000000001 106.172C357.274 106.172 357.338 106.172 357.4000000000001 106.172L299.112 164.46C294.23 169.342 294.23 177.256 299.112 182.138C303.9940000000001 187.02 311.908 187.02 316.79 182.138L396.3400000000001 102.588C401.2200000000001 97.708 401.2200000000001 89.792 396.3400000000001 84.912L316.79 5.362C311.908 0.48 303.9940000000001 0.48 299.112 5.362C294.23 10.244 294.23 18.158 299.112 23.04L357.236 81.164C310.574 80.96 274.098 80.832 243.158 86.25C204.532 93.012 174.1258 108.372 141.1854 141.138C108.0746 174.072 92.7982 206.0296 86.1152 245.282C80.7934 276.5394 80.9306 312.7658 81.1504 357.2226L23.0392 299.1116C18.15772 294.23 10.24316 294.23 5.3616 299.1116C0.480052 303.9932 0.480052 311.9078 5.3616 316.7894L84.9112 396.33884z" : "M67.9284 317.07106C71.8336 320.97631 78.1652 320.97631 82.0706 317.07106L145.7102 253.4314C149.6154 249.5262 149.6154 243.1946 145.7102 239.2894C141.805 235.384 135.4732 235.384 131.568 239.2894L84.9274 285.9298L84.9272 285.8754C84.7616 249.974 84.6366 222.9072 88.6078 199.5824C93.2618 172.2482 103.5408 150.4758 127.052 127.09C150.6994 103.568 171.3742 93.358 197.9744 88.7C220.952 84.678 248.116 84.786 285.768 84.938C285.82 84.938 285.87 84.938 285.92 84.938L239.29 131.5686C235.384 135.4738 235.384 141.8054 239.29 145.7106C243.194 149.616 249.526 149.616 253.432 145.7106L317.072 82.072C320.976 78.166 320.976 71.834 317.072 67.928L253.432 4.29C249.526 0.384 243.194 0.384 239.29 4.29C235.384 8.194 235.384 14.526 239.29 18.432L285.788 64.93C248.458 64.768 219.278 64.666 194.5254 69C163.6256 74.41 139.3002 86.698 112.9478 112.91C86.4592 139.2572 74.238 164.8236 68.8916 196.2256C64.6342 221.2316 64.744 250.2126 64.9198 285.7782L18.43092 239.2894C14.52568 235.384 8.19404 235.384 4.2888 239.2894C0.383554 243.1946 0.383554 249.5262 4.2888 253.4314L67.9284 317.07106z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrowsArc.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrowsArc.displayName = "Blueprint5.Icon.ArrowsArc";
exports.default = ArrowsArc;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dHpiH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowsHorizontal", ()=>ArrowsHorizontal);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrowsHorizontal = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "arrows-horizontal",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M394 214L294 314C290 318 286 320 280 320C268 320 260 312 260 300C260 294 262 290 266 286L332 220H68L134 286C138 290 140 294 140 300C140 312 132 320 120 320C114 320 110 318 106 314L6 214C2 210 0 206 0 200S2 190 6 186L106 86C110 82 114 80 120 80C132 80 140 88 140 100C140 106 138 110 134 114L68 180H332L266 114C262 110 260 106 260 100C260 88 268 80 280 80C286 80 290 82 294 86L394 186C398 190 400 194 400 200S398 210 394 214L394 214z" : "M314 174L234 254C230 258 226 260 220 260C208 260 200 250 200 240C200 234 202 230 206 226L252.0000000000001 180H68L114 226C118 230 120 234 120 240C120 250 112 260 100 260C94 260 90 258 86 254L6 174C2 170 0 166 0 160S2 150 6 146L86 66C90 62 94 60 100 60C112 60 120 68 120 80C120 86 118 90 114 94L68 140H252L206 94C202 90 200 86 200 80C200 68 208 60 220 60C226 60 230 62 234 66L314 146C318 150 320 154 320 160S318 170 314 174L314 174z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrowsHorizontal.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrowsHorizontal.displayName = "Blueprint5.Icon.ArrowsHorizontal";
exports.default = ArrowsHorizontal;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUs3O":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowsVertical", ()=>ArrowsVertical);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ArrowsVertical = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "arrows-vertical",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 140C294 140 290 138 286 134L220 68V332L286 266C290 262 294 260 300 260C312 260 320 268 320 280C320 286 318 290 314 294L214 394C210 398 206 400 200 400S190 398 186 394L86 294C82 290 80 286 80 280C80 268 88 260 100 260C106 260 110 262 114 266L180 332V68.0000000000001L114 134.0000000000001C110 138 106 140 100 140C88 140 80 132 80 120C80 114 82 110 86 106L186 6C190 2 194 0 200 0S210 2 214 6L314 106C318 110 320 114 320 120C320 130 312 140 300 140L300 140z" : "M240 120C234 120 230 118 226 114L180 68V252L226 206C230 202 234 200 240 200C252 200 260 208 260 220C260 226 258 230 254 234L174 314C170 318 166 320 160 320S150 318 146 314L66 234C62 230 60 226 60 220C60 208 70 200 80 200C86 200 90 202 94 206L140 252V68L94 114C90 118 86 120 80 120C70 120 60 112 60 100C60 94 62 90 66 86L146 6C150 2 154 0 160 0S170 2 174 6L254 86C258 90 260 94 260 100C260 112 252 120 240 120L240 120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ArrowsVertical.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ArrowsVertical.displayName = "Blueprint5.Icon.ArrowsVertical";
exports.default = ArrowsVertical;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aT6TH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Asterisk", ()=>Asterisk);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Asterisk = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "asterisk",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M370.4 116.6L370.6 117L237.8 200L370.6 283L370.4 283.4C376 286.8 380 292.8 380 300C380 311 371 320 360 320C356 320 352.6 318.6 349.6 316.6L349.4 317L220 236V380C220 391 211 400 200 400S180 391 180 380V236L50.6 317L50.4 316.6C47.4 318.6 44 320 40 320C29 320 20 311 20 300C20 292.8 24 286.8 29.6 283.4L29.4 283L162.2 200L29.4 117L29.6 116.6C24 113.2 20 107.2 20 100C20 89 29 80 40 80C44 80 47.4 81.4 50.4 83.4L50.6 83L180 164V20C180 9 189 0 200 0S220 9 220 20V164L349.4 83.2L349.6 83.6C352.6 81.4 356 80 360 80C371 80 380 89 380 100C380 107.2 376 113.2 370.4 116.6z" : "M290.8 96.4L291 96.8L196 160L291 223.4L290.8 223.8C296.2 227.2 300 233 300 240C300 251 291 260 280 260C275.8 260 272.2 258.4 269.2000000000001 256.4L269 256.8L180 197.4V300C180 311 171 320 160 320S140 311 140 300V197.4L51 256.6L50.8 256.4C47.8 258.4 44.2 260 40 260C29 260 20 251 20 240C20 233 23.8 227.2 29.2 223.6L29 223.4L124 160L29 96.6L29.2 96.2C23.8 92.8 20 87 20 80C20 69 29 60 40 60C44.2 60 47.8 61.6 50.8 63.6L51 63.2L140 122.6V20C140 9 149 0 160 0S180 9 180 20V122.6L269 63.4L269.2 63.8C272.2 61.6 275.8 60 280 60C291 60 300 69 300 80C300 87 296.2 92.8 290.8 96.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Asterisk.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Asterisk.displayName = "Blueprint5.Icon.Asterisk";
exports.default = Asterisk;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hzSQV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "At", ()=>At);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var At = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "at",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M245.96 263.64C235.54 266.4 224.4 267.78 212.52 267.78C191.38 267.78 174.9 260.88 163.08 247.06C151.3 233.24 145.4 214.46 145.4 190.72C145.4 152.84 160.5 133.88 190.72 133.88C222.58 133.88 240 157.72 243 205.36L245.96 263.64zM376.84 315.48C392.2800000000001 288.4 400 257.16 400 221.68C400 198.42 396.28 177.2 388.88 157.9C381.4 138.64 371 123.64 357.5 112.9C344.06 102.2 328.5 96.84 310.84 96.84C297.82 96.84 286.48 100.24 276.92 107.08C267.3400000000001 113.9 260.9 123.18 257.58 134.88H254.62C246.52 122.18 236.54 112.68 224.66 106.34C212.74 99.98 199.38 96.84 184.52 96.84C157.62 96.84 136.42 105.34 121.02 122.42C105.54 139.5 97.84 162.58 97.84 191.68C97.84 225.2 108.08 252.4 128.58 273.28C149 294.14 176.5 304.62 211.02 304.62C223.58 304.62 237.46 303.52 252.74 301.3400000000001C268.02 299.14 281.6 296.1 293.48 292.18L288.04 178.78V172.9C288.04 146.9 296.64 133.88 313.82 133.88C326.86 133.88 337.2 142.16 344.88 158.78C352.56 175.36 356.42 196.5 356.42 222.2C356.42 250 350.6 274.42 339.06 295.48C327.5200000000001 316.54 311.1 332.74 289.8 344.14C268.5 355.52 244.06 361.2 216.46 361.2C181.32 361.2 150.72 354.06 124.7 339.76C98.7 325.44 78.86 304.9600000000001 65.14 278.38C51.42 251.84 44.6 220.94 44.6 185.84C44.6 138.68 57.38 102.4 83 77.08C108.58 51.68 145.3 39.04 193.18 39.04C229.7 39.04 267.76 46.34 307.38 60.96V20.94C272.7 6.98 234.98 0 194.18 0C133.06 0 85.44 16.22 51.3 48.64C17.1 81.1 0 126.34 0 184.38C0 226.82 9.24 264.6 27.76 297.68C46.22 330.74 71.88 356.06 104.66 373.64C137.42 391.2 174.54 400 215.98 400C251.8 400 283.74 392.6600000000001 311.7000000000001 378.04C339.7 363.4 361.4 342.54 376.84 315.48V315.48z" : "M116.3196 152.5718C116.3196 122.286 128.3882 107.108 152.594 107.108C178.0568 107.108 192.0226 126.1718 194.3768 164.2974L196.7768 210.926C188.411 213.0974 179.5196 214.2174 170.034 214.2174C153.074 214.2174 139.9082 208.7088 130.4682 197.6688C121.0282 186.5832 116.3196 171.566 116.3196 152.5718M320 177.3486C320 158.7428 317.028 141.7372 311.086 126.3314C305.142 110.926 296.8 98.902 286.012 90.308C275.246 81.738 262.788 77.462 248.662 77.462C238.24 77.462 229.166 80.206 221.532 85.646C213.874 91.132 208.708 98.538 206.08 107.886H203.68C197.2114 97.76 189.2114 90.148 179.7258 85.074C170.1942 79.978 159.4972 77.462 147.6114 77.462C126.1028 77.462 109.1428 84.274 96.8 97.942C84.4342 111.588 78.2858 130.08 78.2858 153.3486C78.2858 180.16 86.4686 201.8972 102.8572 218.6286C119.2228 235.3142 141.2114 243.68 168.8228 243.68C178.8572 243.68 189.9886 242.8114 202.194 241.0742C214.4 239.3142 225.302 236.8686 234.788 233.7372L230.446 143.0172V138.3314C230.446 117.532 237.326 107.108 251.062 107.108C261.486 107.108 269.76 113.738 275.886 127.0172C282.034 140.2972 285.142 157.1886 285.142 177.76C285.142 200 280.502 219.5428 271.246 236.3886C262.012 253.2114 248.892 266.1942 231.84 275.3142000000001C214.812 284.4342000000001 195.2458 288.96 173.1658 288.96C145.0514 288.96 120.5942 283.2458000000001 99.7486 271.7942C78.9486 260.3658 63.0858 243.9772 52.1142 222.6972C41.1428 201.4628 35.68 176.7772 35.68 148.6858C35.68 110.948 45.92 81.92 66.3772 61.646C86.8572 41.348 116.2286 31.222 154.56 31.222C183.7486 31.222 214.194 37.052 245.898 48.778V16.778C218.172 5.578 187.9772 0 155.36 0C106.4458 0 68.3428 12.982 41.0286 38.902C13.69142 64.868 0 101.052 0 147.4972C0 181.4628 7.38286 211.68 22.1942 238.1486C36.9828 264.5942 57.5086 284.8458 83.7258 298.9028C109.9428 312.98286 139.6342 320 172.8 320C201.462 320 226.994 314.12572 249.348 302.44572C271.772 290.7200000000001 289.142 274.0114 301.486 252.3658C313.8520000000001 230.72 320 205.7142 320 177.3486",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
At.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
At.displayName = "Blueprint5.Icon.At";
exports.default = At;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1FYN6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutomaticUpdates", ()=>AutomaticUpdates);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var AutomaticUpdates = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "automatic-updates",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 40C111.6 40 40 111.6 40 200C40 250.4 63.6 295.2 100 324.4V300C100 289 109 280 120 280S140 289 140 300V380C140 391 131 400 120 400H40C29 400 20 391 20 380S29 360 40 360H81.2C32.2 323.6 0 265.8 0 200C0 89.6 89.6 0 200 0C211 0 220 9 220 20S211 40 200 40zM200 360C232.8 360 263 350.2 288.4 333.2L317 361.8C284.2000000000001 385.8 243.8 400 200 400C189 400 180 391 180 380C180 369 189 360 200 360zM400 200C400 222.6 396 244.2 389.2000000000001 264.4L356.8 232C358.8 221.6 360 211 360 200C360 149.6 336.4 104.8 300 75.6V100C300 111 291 120 280 120S260 111 260 100V20C260 9 269 0 280 0H360C371 0 380 9 380 20S371 40 360 40H318.8C367.8 76.4 400 134.2000000000001 400 200zM400 340C400 351 391 360 380 360C374.4 360 369.4 357.8 365.8 354.2L240 228.2L194.2 274.2C190.6 277.8 185.6 280 180 280C169 280 160 271 160 260C160 254.4 162.2 249.4 165.8 245.8L225.8 185.8C229.4 182.2 234.4 180 240 180S250.6 182.2 254.2 185.8L394.2000000000001 325.8C397.8 329.4 400 334.4 400 340z" : "M160 40C93.8 40 40 93.8 40 160C40 195.4 55.6 227.2 80 249.2V220C80 209 89 200 100 200S120 209 120 220V300C120 311 111 320 100 320H20C9 320 0 311 0 300S9 280 20 280H54.8C21.4 250.8 0 208 0 160C0 71.6 71.6 0 160 0C171 0 180 9 180 20S171 40 160 40zM160 280C181.6 280 201.6 273.8 219 263.8L248.4 293.2C223 310.2 192.8 320 160 320C149 320 140 311 140 300S149 280 160 280zM214.2 145.8L314.2000000000001 245.8C317.8 249.4 320 254.4 320 260C320 271 311 280 300 280C294.4000000000001 280 289.4000000000001 277.8 285.8 274.2L200 188.2L174.2 214.2C170.6 217.8 165.6 220 160 220C149 220 140 211 140 200C140 194.4 142.2 189.4 145.8 185.8L185.8 145.8C189.4 142.2 194.4 140 200 140S210.6 142.2 214.2 145.8zM320 160C320 171 318.8 181.6 316.8 192L279.4 154.6C277.8 121.4 263.2 91.8 240 71V100C240 111 231 120 220 120S200 111 200 100V20C200 9 209 0 220 0H300C311 0 320 9 320 20S311 40 300 40H265.2C298.6 69.2 320 112 320 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
AutomaticUpdates.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
AutomaticUpdates.displayName = "Blueprint5.Icon.AutomaticUpdates";
exports.default = AutomaticUpdates;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cva67":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Axle", ()=>Axle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Axle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "axle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 100H80V90C80 84.478 84.4772 80 90 80C95.5228 80 100 84.478 100 90V310C100 315.5228 95.5228 320 90 320C84.4772 320 80 315.5228 80 310V300H40V100zM360 300L320 300L320 310C320 315.5228 315.522 320 310 320C304.478 320 300 315.5228 300 310L300 90C300 84.478 304.478 80 310 80C315.522 80 320 84.478 320 90L320 100L360 100L360 300zM100 240L135.777 222.1114C138.5542 220.723 141.6164 220 144.7214 220H255.278C258.384 220 261.4460000000001 220.723 264.222 222.1114L300 240V160L264.222 177.888C261.4460000000001 179.278 258.384 180 255.278 180H144.7214C141.6164 180 138.5542 179.278 135.777 177.888L100 160V240zM0 220H40V180H0V220zM0 240H20V160H0V240zM380 240H400V160H380V240zM400 180L360 180L360 220L400 220L400 180zM160 220C160 231.0456 168.9544 240 180 240H220C231.046 240 240 231.0456 240 220V180C240 168.954 231.046 160 220 160H180C168.9544 160 160 168.954 160 180V220z" : "M20 60H40V50C40 44.478 44.4772 40 50 40C55.5228 40 60 44.478 60 50V270C60 275.5228 55.5228 280 50 280C44.4772 280 40 275.5228 40 270V260H20V60zM300 260L280 260L280 270C280 275.5228 275.522 280 270 280C264.478 280 260 275.5228 260 270L260 50C260 44.478 264.478 40 270 40C275.522 40 280 44.478 280 50L280 60L300 60L300 260zM60 200L95.777 182.1114C98.5542 180.723 101.6164 180 104.7214 180H215.278C218.384 180 221.446 180.723 224.222 182.1114L260 200V120L224.222 137.8886C221.446 139.277 218.384 140 215.278 140H104.7214C101.6164 140 98.5542 139.277 95.777 137.8886L60 120V200zM0 160C0 171.0456 8.9543 180 20 180H40V140H20C8.9543 140 0 148.9544 0 160V160zM320 160C320 148.9544 311.046 140 300 140L280 140L280 180L300 180C311.046 180 320 171.0456 320 160V160zM140 200H180A20 20 0 0 0 200 180V140A20 20 0 0 0 180 120H140A20 20 0 0 0 120 140V180A20 20 0 0 0 140 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Axle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Axle.displayName = "Blueprint5.Icon.Axle";
exports.default = Axle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kH3wq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Backlink", ()=>Backlink);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Backlink = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "backlink",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M367.7420080000001 4.194092L365.857862 5.8578640000001L279.999998 91.7000000000001L279.999998 40C279.999998 28.954306 271.0456920000001 20 259.999998 20C248.954302 20 239.999998 28.954306 239.999998 40L240.055756 141.50477L240.055756 141.50477L240.4048 144.014516L240.4048 144.014516L240.99476 146.24285L240.99476 146.24285L241.873464 148.46443L241.873464 148.46443L242.919906 150.414176L242.919906 150.414176L244.258552 152.340446L244.258552 152.340446L245.858216 154.142816L245.858216 154.142816C246.565744 154.850016 247.313486 155.49374 248.093866 156.073308L250.318756 157.506576L250.318756 157.506576L252.573278 158.57549L252.573278 158.57549L254.680138 159.283098L254.680138 159.283098L257.667576 159.865446L257.667576 159.865446L259.999998 160L359.999998 160C371.0456920000001 160 379.999998 151.045696 379.999998 140C379.999998 128.954306 371.0456920000001 120 359.999998 120L308.299998 120L394.142134 34.1421359999999C401.95262 26.33165 401.95262 13.66835 394.142134 5.8578640000001C386.932454 -1.351814 375.5878340000001 -1.906406 367.7420080000001 4.194092zM140.716662 217.284882L51.7157288 128.284272L49.3790738 125.739976C36.1380284 110.024228 36.9169134 86.514544 51.7157288 71.715728C66.514544 56.916914 90.0242272 56.138028 105.7399758 69.379074L108.2842712 71.715728L197.2902504 160.696548C204.054786 135.339858 198.1542358 107.307152 179.588597 86.618918L176.5685424 83.431458L136.5685424 43.431458C105.3265992 12.189514 54.6734008 12.189514 23.4314576 43.431458C-6.76908772 73.632002 -7.77577256 121.971288 20.411403 153.381082L23.4314576 156.568542L63.4314576 196.568542C84.369871 217.506956 114.0272526 224.4124026 140.716662 217.284882zM274.142136 294.1421356C281.351814 286.9324564 281.906406 275.5878352 275.805908 267.7420112L274.142136 265.8578644L134.1421356 125.857864C126.3316498 118.047378 113.6683502 118.047378 105.8578644 125.857864C98.6481852 133.067544 98.0935944 144.412164 104.1940922 152.257988L105.8578644 154.142136L245.857864 294.1421356C253.66835 301.9526214 266.33165 301.9526214 274.142136 294.1421356zM356.568542 376.5685424C386.769088 346.3679972 387.775772 298.0287126 359.588598 266.6189182L356.568542 263.4314576000001L316.5685420000001 223.4314576C295.635388 202.4983036 265.987646 195.591068 239.303452 202.7097496L328.284272 291.7157288L330.620926 294.2600242C343.861972 309.9757728 343.083086 333.485456 328.284272 348.2842712C313.485456 363.0830866 289.975772 363.8619716 274.2600240000001 350.6209262L271.715728 348.2842712L182.715118 259.283338C175.9420936 284.6453164 181.8408552 312.6873770000001 200.411402 333.3810818L203.431458 336.5685424L243.431458 376.5685424C274.6734 407.81048584 325.3266 407.81048584 356.568542 376.5685424z" : "M280 120C291.045696 120 300 111.045696 300 100C300 88.954306 291.045696 80 280 80L268.3 80L314.142136 34.142136C321.952622 26.33165 321.952622 13.66835 314.142136 5.857864C306.932456 -1.351814 295.5878360000001 -1.906406 287.742012 4.194092L285.857864 5.857864L240 51.7L240 40C240 28.954306 231.045696 20 220 20C208.954306 20 200 28.954306 200 40L200.055758 101.50477L200.305626 103.49415L200.548454 104.670282L201.197892 106.83333L201.873468 108.46443L202.91991 110.414176L204.258554 112.340446L205.858218 114.142816C206.565746 114.850016 207.313488 115.49374 208.093868 116.073308L210.318758 117.506576L213.166992 118.802282L214.68014 119.283098L216.506916 119.694566L218.814968 119.965078L280 120zM120.716662 197.284882L51.7157288 128.2842712L49.3790738 125.7399758C36.1380284 110.024228 36.9169134 86.514544 51.7157288 71.715728C66.514544 56.916914 90.0242272 56.138028 105.7399758 69.379074L108.2842712 71.715728L177.2902504 140.6965488C184.054787 115.339858 178.1542358 87.307152 159.588597 66.618918L156.5685424 63.431458L136.5685424 43.431458C105.3265992 12.189514 54.6734008 12.189514 23.4314576 43.431458C-6.76908772 73.632002 -7.77577256 121.9712874 20.411403 153.3810818L23.4314576 156.5685424L43.4314576 176.5685424C64.369871 197.506956 94.0272526 204.4124026 120.716662 197.284882zM214.142136 234.1421356C221.351814 226.9324564 221.906406 215.5878352 215.805908 207.7420112L214.142136 205.8578644L114.1421356 105.857864C106.3316498 98.047378 93.6683502 98.047378 85.8578644 105.857864C78.6481852 113.067544 78.0935944 124.4121648 84.1940922 132.2579888L85.8578644 134.1421356L185.8578644 234.1421356C193.6683502 241.9526214 206.33165 241.9526214 214.142136 234.1421356zM276.5685420000001 296.5685424C306.769088 266.3679972 307.775772 218.0287126 279.588598 186.6189182L276.5685420000001 183.4314576L256.5685420000001 163.4314576C235.635388 142.4983036 205.987646 135.5910676 179.3034512 142.7097496L248.284272 211.7157288L250.620926 214.2600242C263.8619720000001 229.9757728 263.083086 253.485456 248.284272 268.2842712C233.485456 283.0830866 209.975772 283.8619716 194.2600242 270.6209262L191.7157288 268.2842712L122.715118 199.283338C115.9420936 224.6453164 121.8408552 252.687377 140.411403 273.3810818L143.4314576 276.5685424L163.4314576 296.5685424C194.6734008 327.81048584 245.3266 327.81048584 276.5685420000001 296.5685424z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Backlink.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Backlink.displayName = "Blueprint5.Icon.Backlink";
exports.default = Backlink;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bO0a5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackwardTen", ()=>BackwardTen);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var BackwardTen = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "backward-ten",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M195.0718 0C170.7562 0 147.9806 4.62 126.7452 13.86C105.5096 23.1 87.0298 35.582 71.3058 51.306C55.5818 67.03 43.0998 85.51 33.8598 106.746C24.62 127.98 20 150.756 20 175.072C20 180.584 21.8642 185.204 25.5926 188.932C29.321 192.66 33.9408 194.524 39.4524 194.524C44.964 194.524 49.5838 192.66 53.3122 188.932C57.0406 185.204 58.9048 180.584 58.9048 175.072C58.9048 137.14 72.1162 104.962 98.5392 78.54C124.962 52.116 157.1396 38.904 195.0718 38.904C233.004 38.904 265.182 52.116 291.604 78.54C318.028 104.962 331.2380000000001 137.14 331.2380000000001 175.072C331.2380000000001 213.004 318.028 245.1814 291.604 271.6044C265.182 298.0272 233.004 311.2386 195.0718 311.2386H192.1538L208.688 294.704C212.578 290.8136 214.444 286.2746 214.28 281.0874C214.118 275.9 212.254 271.3612 208.688 267.4708C204.798 263.5802 200.178 261.554 194.8286 261.3918C189.4792 261.2298 184.8592 263.094 180.9688 266.9844L130.8788 317.0744C126.9882 320.9648 125.043 325.5038 125.043 330.6910000000001C125.043 335.8784 126.9882 340.4172 130.8788 344.3078L180.9688 394.3977C184.8592 398.288188 189.4792 400.1523772 194.8286 399.9902738C200.178 399.8281704 204.798 397.80188 208.688 393.9114C212.254 390.02092 214.118 385.48202 214.28 380.2947C214.444 375.1074 212.578 370.5684 208.688 366.678L192.1538 350.1434H195.0718C219.388 350.1434 242.162 345.5236 263.398 336.2836C284.634 327.0438 303.114 314.5618 318.838 298.8378C334.562 283.1136 347.044 264.634 356.284 243.3984C365.524 222.1628 370.144 199.388 370.144 175.072C370.144 150.756 365.524 127.98 356.284 106.746C347.044 85.51 334.562 67.03 318.838 51.306C303.114 35.582 284.634 23.1 263.398 13.86C242.162 4.62 219.388 0 195.0718 0zM230 210V150H250V210H230zM220 240C208.954 240 200 231.0456 200 220V140C200 128.954 208.954 120 220 120H260C271.046 120 280 128.954 280 140V220C280 231.0456 271.046 240 260 240H220zM180 220C180 231.0456 171.0456 240 160 240H135C126.7158 240 120 233.2842 120 225C120 216.7158 126.7158 210 135 210H150V135C150 126.716 156.7158 120 165 120C173.2842 120 180 126.716 180 135V220z" : "M160.0432 0C140.6104 0 122.3942 3.704 105.3944 11.114C88.3946 18.524 73.588 28.586 60.9744 41.3C48.3608 54.014 38.3784 68.94 31.0268 86.074C23.6756 103.21 20 121.486 20 140.9044C20 146.3756 21.8994 151.0254 25.698 154.854C29.4966 158.683 34.1098 160.5974 39.5378 160.5974C44.9658 160.5974 49.579 158.683 53.3776 154.854C57.1762 151.0254 59.0756 146.3756 59.0756 140.9044C59.0756 112.624 68.8676 88.634 88.4518 68.936C108.0358 49.236 131.8852 39.386 160 39.386C188.1148 39.386 211.964 49.256 231.548 68.996C251.132 88.736 260.9240000000001 112.776 260.9240000000001 141.1144C260.9240000000001 169.3942 251.084 193.3838 231.402 213.0832C211.72 232.7824 187.8504 242.6322 159.7918 242.6322H157.3716L167.196 232.7292C170.423 229.4768 172.0098 225.6238 171.9562 221.1702C171.9028 216.717 170.3162 212.864 167.196 209.6112C163.9692 206.3588 160.0506 204.7056 155.44 204.6516C150.8294 204.5978 146.9106 206.1972 143.6836 209.45L105.0898 248.351C101.1684 252.3546 99.2076 257.0256 99.2076 262.3634C99.2076 267.7016 101.1684 272.347 105.0898 276.2996L143.6836 315.2006600000001C146.9106 318.45333 150.8294 320.052678 155.44 319.998677194C160.0506 319.9449242 163.9692 318.221722 167.196 314.82908C170.3162 311.57666 171.8682 307.68872 171.8522 303.1653C171.8362 298.6418 170.2148 294.7538 166.9878 291.5012L157.58 282.0184H159.7918C179.2348 282.0184 197.4464 278.3136 214.426 270.9038C231.406 263.4940000000001 246.238 253.4322 258.922 240.7182C271.604 228.004 281.622 213.1102 288.9720000000001 196.0368C296.324 178.9632 300 160.6516 300 141.1018C300 121.5518 296.324 103.21 288.9720000000001 86.074C281.622 68.94 271.64 54.014 259.026 41.3C246.412 28.586 231.62 18.524 214.648 11.114C197.6774 3.704 179.4756 0 160.0432 0zM200 160H180V100H200V160zM180 180C168.9544 180 160 171.0456 160 160V100C160 88.954 168.9544 80 180 80H200C211.046 80 220 88.954 220 100V160C220 171.0456 211.046 180 200 180H180zM110 180C104.4772 180 100 175.5228 100 170C100 164.4772 104.4772 160 110 160H120V90C120 84.478 124.4772 80 130 80C135.5228 80 140 84.478 140 90V160C140 171.0456 131.0456 180 120 180H110z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
BackwardTen.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
BackwardTen.displayName = "Blueprint5.Icon.BackwardTen";
exports.default = BackwardTen;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1iSHO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Badge = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "badge",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M338.8 285.4C335 313.6 351.2000000000001 335.8 366.4 357.2L340.6 387C297.8 364.8 237.6 370.4 200 400C162.4 370.4 102.2 364.8 59.4 387L33.6 357.2C48.8 335.8 65 313.6 61.2 285.4C53.6 228.2 0 181.2 28 118.4C39.2 89.8 64.2 71 96 63.4C135 54.2 184 45.2 200 0C216 45.1999999999999 265 54.2 304 63.4C336 71 360.8 89.8000000000001 372 118.4C400 181.2 346.4 228.2 338.8 285.4z" : "M267.2 228.2C264.2 250.8 277.2 268.4 289.2 285.6L268.6 309.4C234.2 291.8 186.2 296.4 156 320C125.8 296.4 77.8 291.8 43.4 309.6L22.8 285.6C35 268.4 47.8 250.8 44.8 228.2C38.8 182.4 -4.2 144.8 18.4 94.6C27.4 71.8 47.2 56.6 72.8 50.6C104 43.4 143.2 36.2 156 0C168.8 36.2 208 43.2 239.2 50.8C264.8 56.8 284.6 72 293.6 94.8C316 144.8 273 182.4 267.2 228.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Badge.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Badge.displayName = "Blueprint5.Icon.Badge";
exports.default = Badge;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lmeQA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BanCircle", ()=>BanCircle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var BanCircle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "ban-circle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM300 180H100C89 180 80 189 80 200C80 211 89 220 100 220H300C311 220 320 211 320 200C320 189 311 180 300 180z" : "M160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM220 140H100C89 140 80 149 80 160C80 171 89 180 100 180H220C231 180 240 171 240 160C240 149 231 140 220 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
BanCircle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
BanCircle.displayName = "Blueprint5.Icon.BanCircle";
exports.default = BanCircle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9dCA8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BankAccount", ()=>BankAccount);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var BankAccount = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "bank-account",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M384 239.6L368.4 243.2C360.6 272 344 298.4 321.6 320L331.6 365.6C333.8 374 327.2 381.2 319.4 380C298.2 377.6 279.4 369.2 266 354.8C244.8 363.2 219.2 368 194.8 368C132.4 368 79 338 46.8 293.6C42.2 294.6 37.8 295.8 33.4 295.8C14.4 295.8 0 280.4 0 260C0 245.6 7.8 233.6 19 227.6C17.8 219.2 16.6 209.6 16.6 200C16.6 156.8 34.4 118.4 62.2 88.4L55.6 47.6C53.4 33.2 64.6 20 78 20H92.4C103.6 20 112.4 28.4 114.6 40.4L115.8 50C139.2 39.2 165.8 32 194.8 32C222.6 32 250.4 38.0000000000001 273.8 50L275.0000000000001 40.4C277.2000000000001 28.4 286.2000000000001 20 297.2000000000001 20H311.6C325.0000000000001 20 336 33.2 333.8 47.6L327.2000000000001 87.2C342.8000000000001 102.8 354.0000000000001 122 361.8000000000001 142.4L381.8000000000001 147.2C391.8000000000001 149.6 399.6000000000001 159.2 399.6000000000001 171.2V215.6C401.8 227.6 394 237.2 384 239.6zM300 200C288 200 280 214 280 230S288 260 300 260S320 246 320 230S312 200 300 200zM151 283.4C142 277.2 129.4 279.8 123.4 289C117.2 298 119.8 310.6 129 316.6C175.8 347.8 224.4 347.8 271.2 316.6C280.4000000000001 310.4 282.8 298 276.8 288.8C270.6 279.6 258.2 277.2 249 283.2C215.6 305.6 184.4 305.6 151 283.4z" : "M307.2 190.8L294.8 193.6C288.6 216 275.2 236.6 257.4000000000001 253.4L265.4000000000001 288.8C267.2000000000001 295.4 261.8 301 255.6 300C238.6 298.2 223.6 291.6 212.8 280.4C196 286.8 175.4 290.6 155.8 290.6C106 290.6 63.2 267.2 37.4 232.8C33.8 233.6 30.2 234.6 26.8 234.6C11.6 234.6 0 222.4 0 206.6C0 195.4 6.2 186 15.2 181.4C14.2 174.8 13.4 167.4 13.4 160C13.4 126.4 27.6 96.6 50 73.2L44.6 41.4C42.8 30.2 51.6 20 62.4 20H74C83 20 90 26.6 91.8 35.8L92.6 43.2C111.4 34.8 132.6 29.2 155.8 29.2C178 29.2 200.4 33.8 219 43.2L220 35.8C221.8 26.4 229 20 237.8 20H249.4C260 20 269 30.2 267.2000000000001 41.4L261.8 72.2C274.2000000000001 84.4 283.2000000000001 99.2 289.4000000000001 115.2L305.4000000000001 119C313.4000000000001 120.8 319.6000000000001 128.4 319.6000000000001 137.6V172C321.4 181.4 315.2 188.8 307.2 190.8zM240 160C228 160 220 174 220 190S228 220 240 220S260 206 260 190S252 160 240 160zM124.2 221.6C116 217.6 106 220.8 101.8 228.8C97.6 236.8 101 246.4 109.2 250.2C136.2 263.2 163.8 263.2 190.8 250.2C199 246.2 202.4 236.6 198.2 228.8C194 220.8 184 217.6 175.8 221.6C158.4 230.2 141.6 230.2 124.2 221.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
BankAccount.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
BankAccount.displayName = "Blueprint5.Icon.BankAccount";
exports.default = BankAccount;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iePn2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Barcode", ()=>Barcode);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Barcode = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "barcode",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 60.4H160V340.4H120V60.4zM180 60.4H200V340.4H180V60.4zM60 60.4H100V340.4H60V60.4zM0 60.4H40V340.4H0V60.4zM320 60.4H360V340.4H320V60.4zM240 60.4H260V340.4H240V60.4zM380 340.4V60.4H400V340.4H380zM280 60.4H300V340.4H280V60.4z" : "M0 40H40V280H0V40zM120 40H140V280H120V40zM160 40H180V280H160V40zM60 40H100V280H60V40zM300 280V40H320V280H300zM200 40H220V280H200V40zM240 40H280V280H240V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Barcode.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Barcode.displayName = "Blueprint5.Icon.Barcode";
exports.default = Barcode;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4HBib":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BinaryNumber", ()=>BinaryNumber);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var BinaryNumber = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "binary-number",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160.2258 290.3846C151.5984 296.7948 140.401 300 126.6336 300C112.8664 300 101.5772 296.7948 92.7662 290.3846C84.1386 284.1576 77.3468 276.0988 72.3906 266.2088C67.6178 256.5018 64.3138 245.7876 62.4782 234.066C60.826 222.3444 60 210.989 60 200C60 189.01 60.826 177.656 62.4782 165.934C64.3138 154.212 67.6178 143.406 72.3906 133.516C77.3468 123.81 84.1386 115.75 92.7662 109.34C101.5772 103.114 112.8664 100 126.6336 100C140.401 100 151.5984 103.114 160.2258 109.34C169.0368 115.75 175.8288 123.81 180.6014 133.516C185.5576 143.406 188.8618 154.212 190.5138 165.934C192.3494 177.656 193.2672 189.01 193.2672 200C193.2672 210.989 192.3494 222.3444 190.5138 234.066C188.8618 245.7876 185.5576 256.5018 180.6014 266.2088C175.8288 276.0988 169.0368 284.1576 160.2258 290.3846zM143.705 131.868C139.116 128.022 133.4254 126.098 126.6336 126.098C119.6582 126.098 113.876 128.022 109.2868 131.868C104.8814 135.898 101.3018 141.208 98.5484 147.802C95.9784 154.578 94.1428 162.454 93.0414 171.428C91.94 180.402 91.3894 189.926 91.3894 200C91.3894 210.0732 91.94 219.5056 93.0414 228.2966C94.1428 237.271 95.9784 245.1466 98.5484 251.923C101.3018 258.6996000000001 104.8814 264.011 109.2868 267.8572000000001C113.876 271.8864 119.6582 273.901 126.6336 273.901C133.4254 273.901 139.116 271.8864 143.705 267.8572000000001C148.2942 264.011 151.8736 258.6996000000001 154.4436 251.923C157.197 245.1466 159.1244 237.271 160.2258 228.2966C161.3272 219.5056 161.8778 210.0732 161.8778 200C161.8778 189.926 161.3272 180.402 160.2258 171.428C159.1244 162.454 157.197 154.578 154.4436 147.802C151.8736 141.208 148.2942 135.898 143.705 131.868zM260.046 268.5714C253.554 267.4286 246.872 266.8572000000001 240 266.8572000000001V241.1428H289.254V100H325.048V300H298.418C297.272 293.9048 294.79 288.762 290.972 284.5714000000001C287.344 280.381 282.858 276.9524 277.514 274.2858C272.358 271.6190000000001 266.536 269.7142 260.046 268.5714z" : "M140.08 232.3076C133.1866 237.4358 124.24 240 113.24 240C102.24 240 93.22 237.4358 86.18 232.3076C79.2866 227.326 73.86 220.8792 69.9 212.967C66.0866 205.2014 63.4466 196.63 61.98 187.2528C60.66 177.8754 60 168.7912 60 160C60 151.2088 60.66 142.1246 61.98 132.7472C63.4466 123.37 66.0866 114.726 69.9 106.814C73.86 99.048 79.2866 92.6 86.18 87.472C93.22 82.49 102.24 80 113.24 80C124.24 80 133.1866 82.49 140.08 87.472C147.12 92.6 152.5466 99.048 156.36 106.814C160.32 114.726 162.96 123.37 164.28 132.7472C165.7466 142.1246 166.48 151.2088 166.48 160C166.48 168.7912 165.7466 177.8754 164.28 187.2528C162.96 196.63 160.32 205.2014 156.36 212.967C152.5466 220.8792 147.12 227.326 140.08 232.3076zM126.88 105.494C123.2134 102.418 118.6666 100.88 113.24 100.88C107.6666 100.88 103.0466 102.418 99.38 105.494C95.86 108.718 93 112.968 90.8 118.242C88.7466 123.663 87.28 129.9634 86.4 137.1428C85.52 144.3224 85.08 151.9414 85.08 160C85.08 168.0586 85.52 175.6044 86.4 182.6374C87.28 189.8168 88.7466 196.1172 90.8 201.5384C93 206.9598 95.86 211.2088 99.38 214.2858C103.0466 217.5092 107.6666 219.1208 113.24 219.1208C118.6666 219.1208 123.2134 217.5092 126.88 214.2858C130.5466 211.2088 133.4066 206.9598 135.46 201.5384C137.66 196.1172 139.2 189.8168 140.08 182.6374C140.96 175.6044 141.4 168.0586 141.4 160C141.4 151.9414 140.96 144.3224 140.08 137.1428C139.2 129.9634 137.66 123.663 135.46 118.242C133.4066 112.968 130.5466 108.718 126.88 105.494zM216.016 214.8572C210.83 213.9428 205.492 213.4858 200 213.4858V192.9142H239.354V80H267.954V240H246.676C245.76 235.1238 243.778 231.0096 240.726 227.6572C237.8280000000001 224.3048 234.244 221.5618 229.972 219.4286C225.854 217.2952 221.202 215.7714 216.016 214.8572z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
BinaryNumber.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
BinaryNumber.displayName = "Blueprint5.Icon.BinaryNumber";
exports.default = BinaryNumber;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dhdhh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Blank", ()=>Blank);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Blank = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "blank",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "" : "",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Blank.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Blank.displayName = "Blueprint5.Icon.Blank";
exports.default = Blank;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2MPyT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockPromote", ()=>BlockPromote);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var BlockPromote = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "block-promote",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 220H340V320C340 331 331 340 320 340H80C69 340 60 331 60 320V220H40C29 220 20 211 20 200S29 180 40 180H60V80C60 69 69 60 80 60H320C331 60 340 69 340 80V180H360C371 180 380 189 380 200S371 220 360 220zM137 133C135.2 131 132.6 130 130 130C127.4 130 124.8 131 123 133C119 136.8 119 143.2 123 147L175.8 200L123 253C119 256.8 119 263.2 123 267C126.8 271 133.2 271 137 267L197 207C201 203.2000000000001 201 196.8000000000001 197 193.0000000000001L137 133.0000000000001zM277 193L217 133C215.2 131 212.6 130 210 130C207.4 130 204.8 131 203 133C199 136.8 199 143.2 203 147L255.8 200L203 253C199 256.8 199 263.2 203 267C206.8 271 213.2 271 217 267L277 207C281 203.2000000000001 281 196.8000000000001 277 193.0000000000001z" : "M60 280H260C271.046 280 280 271.0456 280 260V180H300C311.046 180 320 171.0456 320 160C320 148.9542 311.046 140 300 140H280V60C280 48.954 271.046 40 260 40H60C48.9544 40 40 48.954 40 60V140H20C8.9542 140 0 148.9542 0 160C0 171.0456 8.9542 180 20 180H40V260C40 271.0456 48.9544 280 60 280zM177.071 217.071C173.1658 220.9764 166.8342 220.9764 162.929 217.071C159.0236 213.1658 159.0236 206.8342 162.929 202.929L205.858 160L162.929 117.072C159.0236 113.166 159.0236 106.834 162.929 102.928C166.8342 99.024 173.1658 99.024 177.071 102.928L227.072 152.929C230.976 156.8342 230.976 163.1658 227.072 167.071L177.071 217.071zM92.929 217.071C89.0236 213.1658 89.0238 206.8342 92.929 202.929L135.858 160.0002L92.929 117.072C89.0236 113.166 89.0236 106.834 92.929 102.928C96.8342 99.024 103.1658 99.024 107.071 102.928L157.071 152.929A9.9582 9.9582 0 0 1 159.9542 159.0418A10.062 10.062 0 0 1 159.9324 161.1652A9.958 9.958 0 0 1 157.071 167.0714L107.071 217.071C103.1658 220.9764 96.8342 220.9762 92.929 217.071z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
BlockPromote.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
BlockPromote.displayName = "Blueprint5.Icon.BlockPromote";
exports.default = BlockPromote;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iLexl":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockedPerson", ()=>BlockedPerson);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var BlockedPerson = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "blocked-person",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M231 81.6C201.4 94.6 205.4 102.6 204.4 113.4C204.2 114.8 204.2 116.4 204.2 118C214.4 127 222.6 139.4 228 153.6C228 153.6 228.2 154.4 228.4 154.6C229.6 157.6 230.6 161 231.4 164.2C238.2 165.6 242.2 173 243.6 179.8C244.8 182 246.4 186.8 247 192.2C206.6 211.6 178.4 252.4 178.4 300C178.4 306 179.4 311.6 180.2 317.4C173.6 319 166.8 320 160.4 320C144.6 320 126.8 315 114.2 305.4C102 296 92.8 282.8 88.4 268.2C87.4 265 86.6 261.6 86.2 258.2C83.8 246.2 82.8 228 82.8 215.4C82.8 214.8 82.8 214.4 82.8 213.8C78 212 73.8 207.4 73 197.2C72.2 189.4 75.4 182.6 77 179.8C78.6 172.8 82.6 165.4 89.6 164.2C90.4 160.8 91.4 157.6 92.6 154.6C92.6 154.4 92.8 154.2 92.8 154L93 153.8C98.4 139.4 107 126.8 117.4 117.8C117.4 116.4 117.2 115 117.2 113.6C116.2 102.8 119.2 94.8 89.6 81.8C60 68.8 15.4 54.8 6.4 33.8C-3 12.4 0.8 0 0.8 0H319.8C319.8 0 323.4 12.4 314.4 33.4C305.2 54.6 260.6 68.4 231 81.6zM299.4000000000001 400C243.8 400 198.8 355.2 198.8 300S243.8 200 299.4000000000001 200S400 244.8 400 300S355 400 299.4000000000001 400zM238.8 300C238.8 333.2 265.8 360 299.2 360C308.6 360 317.2 357.8 325 354L244.8 274.2C241.2 282.2 238.8 290.8 238.8 300zM299.4000000000001 240C290 240 281.4 242.2 273.6 246L353.8 325.8C357.6 318 359.8 309.4 359.8 300C359.8 266.8 332.6 240 299.4000000000001 240z" : "M187.8 66.2C163.8 76.8 167 83.2 166.2 92C166 93.4 166 94.6 165.8 96C174 103.4 180.8 113.4 185.2 124.8C185.2 124.8 185.4 125.4 185.4 125.6C186.4 128.2 187.2 130.8 188 133.4C193.4 134.6 196.6 140.6 198 146C198.2 146.6 198.6 147.6 199 148.4C163.6 164 138.8 199.2 138.8 240C138.8 246.4 139.6 252.4 140.6 258.4C137.2 259 133.6 260 130.4 260C117.4 260 103 256 92.8 248.2C82.8 240.6 75.4 229.8 71.8 218C71 215.2 70.4 212.6 70 209.8C68.2 200.2 67.2 185.2 67.2 175C67.2 174.6 67.2 174.2 67.2 173.8C63.4 172.2 60 168.4 59.2 160.2C58.6 154 61.2 148.4 62.4 146.2C63.6 140.6 67 134.4 72.6 133.4C73.4 130.6 74.2 128 75.2 125.6C75.2 125.4 75.4 125.2 75.4 125.2L75.4 125C79.8 113.2 86.8 103 95.2 95.8C95.2 94.6 95 93.4 95 92.4C94.2 83.6 96.6 77.2 72.6 66.6C48.6 56 12.4 44.6 5 27.6C-2.4 10 0.6 0 0.6 0H259.8C259.8 0 262.8 10 255.4 27.2C248 44.2 211.8 55.6 187.8 66.2zM239.4 320C195 320 158.8 284.2 158.8 240C158.8 195.8 194.8 160 239.4 160S320 195.8 320 240C320 284.2 284 320 239.4 320zM199.2 240C199.2 262 217.2 280 239.4 280C246.8 280 253.8 277.8 259.8 274.4L204.8 219.8C201.4 225.8 199.2 232.6 199.2 240zM239.4 200C232.0000000000001 200 225 202.2 219 205.6L274 260.2C277.6 254.2 279.6 247.4 279.6 240C279.8 218 261.6 200 239.4 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
BlockedPerson.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
BlockedPerson.displayName = "Blueprint5.Icon.BlockedPerson";
exports.default = BlockedPerson;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kbdEx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bold", ()=>Bold);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Bold = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "bold",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M286 220C294 236 300 252 300 270C300 320 260 360 210 360H100C88 360 80 352 80 340V80C80 68 88 60 100 60H230C280 60 320 100 320 150C320 178 306 204 286 220zM140 300H210C226 300 240 286 240 270C240 254 226 240 210 240H140V300zM230 120H140V180H230C246 180 260 166 260 150C260 134 246 120 230 120z" : "M234 180C238 188 240 200 240 210C240 212 240 216 240 218C240 220 240 220 240 220C240 222 240 224 238 226C238 226 238 228 238 228C228 258 202 280 170 280H80C70 280 60 272 60 260V60C60 50 68 40 80 40H180C224 40 260 76 260 120C260 144 250 166 234 180zM120 220H160C172 220 180 212 180 200S172 180 160 180H120V220zM180 100H120V140H180C192 140 200 132 200 120S192 100 180 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Bold.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Bold.displayName = "Blueprint5.Icon.Bold";
exports.default = Bold;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4J3M0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Book", ()=>Book);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Book = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "book",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 380V20C60 9 69 0 80 0H120V400H80C69 400 60 391 60 380zM340 400H300V240L260 280L220 240V400H140V0H340C351 0 360 9 360 20V380C360 391 351 400 340 400z" : "M40 300V20C40 9 49 0 60 0H80V320H60C49 320 40 311 40 300zM260 320H240V180L200 220L160 180V320H100V0H260C271 0 280 9 280 20V300C280 311 271 320 260 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Book.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Book.displayName = "Blueprint5.Icon.Book";
exports.default = Book;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cdeZw":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bookmark", ()=>Bookmark);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Bookmark = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "bookmark",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 400C109 400 100 391 100 380V310C100 299 100 281 100 270V220C100 209 100 191 100 180V20C100 9 106.4 6.4 114.2 14.2L186 86C193.8 93.8 206.6 93.8 214.2 86L286 14.2C293.6 6.4 300 9 300 20V180C300 191 300 209 300 220V270C300 281 300 299 300 310V380C300 391 291 400 280 400H120z" : "M224 319.8H221C220.6 319.8 220.4 320 220 320H100C99.6 320 99.4 319.8 99 319.8H96C87.2 319.8 80 312.4 80 303.4V8.4C80 -0.6 85 -2.8 91.4 3.6L148.8 62.4C155 68.8 165.2 68.8 171.4 62.4L228.8 3.6C235.0000000000001 -2.8 240.2000000000001 -0.6 240.2000000000001 8.4V303.4C240 312.4 232.8 319.8 224 319.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Bookmark.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Bookmark.displayName = "Blueprint5.Icon.Bookmark";
exports.default = Bookmark;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aIz39":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Box", ()=>Box);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Box = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "box",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M397.8 268.8L397.8 268.8L338 388.8L337.8 388.8C334.4 395.4 327.8 400 320 400H80C72.2 400 65.6 395.4 62.2 388.8L62 388.8L2 268.8L2.2 268.8C1 266.2 0 263.2 0 260V20C0 9 9 0 20 0H380C391 0 400 9 400 20V260C400 263.2 399 266.2 397.8 268.8zM220 360H307.6L347.6 280H220V360zM92.4 360H180V280H52.4L92.4 360zM360 40H40V240H360V40zM160 160H240C251 160 260 169 260 180C260 191 251 200 240 200H160C149 200 140 191 140 180C140 169 149 160 160 160z" : "M120 120H200C211 120 220 129 220 140C220 151 211 160 200 160H120C109 160 100 151 100 140C100 129 109 120 120 120zM318.6 207.4L318.6 207.4L318.6 207.8C318.6 207.8 318.6 207.8 318.6 207.8L278.8 307.4L278.8 307.4C275.6 314.8 268.4 320 260 320H60C51.6 320 44.4 314.8 41.4 307.4L41.4 307.4L1.6 207.8C1.6 207.8 1.6 207.8 1.6 207.8L1.4 207.4L1.4 207.4C0.6 205.2 0 202.6 0 200V20C0 9 9 0 20 0H300C311 0 320 9 320 20V200C320 202.6 319.4000000000001 205.2 318.6 207.4zM180 280H246.4L270.4 220H180V280zM73.6 280H140V220H49.6L73.6 280zM280 40H40V180H280V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Box.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Box.displayName = "Blueprint5.Icon.Box";
exports.default = Box;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l2KA8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Briefcase", ()=>Briefcase);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Briefcase = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "briefcase",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 300H300V360C300 371 291 380 280 380H120C109 380 100 371 100 360V300H20C9 300 0 291 0 280V180H80V200H120V180H280V200H320V180H400V280C400 291 391 300 380 300zM260 300H140V340H260V300zM320 140H280V160H120V140H80V160H0V40C0 29 9 20 20 20H380C391 20 400 29 400 40V160H320V140z" : "M300 240.4H240V280.4C240 291.4 231 300.4 220 300.4H100C89 300.4 80 291.4 80 280.4V240.4H20C9 240.4 0 231.4 0 220.4V140.4H60V160.4H100V140.4H220V160.4H260V140.4H320V220.4C320 231.4 311 240.4 300 240.4zM200 240.4H120V260.4H200V240.4zM260 100.4H220V120.4H100V100.4H60V120.4H0V40.4C0 29.4 9 20.4 20 20.4H300C311 20.4 320 29.4 320 40.4V120.4H260V100.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Briefcase.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Briefcase.displayName = "Blueprint5.Icon.Briefcase";
exports.default = Briefcase;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9x5YN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BringData", ()=>BringData);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var BringData = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "bring-data",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 40C371.0456940000001 40 380 31.045694 380 20C380 8.954306 371.0456940000001 0 360 0L40 0C28.954305 0 20 8.954306 20 20C20 31.045694 28.954305 40 40 40L360 40zM199.9 339.9C210.9 339.9 219.9 330.908991 219.9 319.91998L219.9 319.91998L219.9 128.231668L245.7 154.005894C249.3 157.602298 254.3 159.8001 259.9 159.8001C270.9 159.8001 279.9 150.80909 279.9 139.82008C279.9 134.225674 277.7 129.23067 274.1 125.634266L274.1 125.634266L214.1 65.694206C210.5 62.097802 205.3 59.9 199.9 59.9C194.5 59.9 189.5 62.097802 185.7 65.694206L185.7 65.694206L125.7 125.634266C122.1 129.23067 119.9 134.225674 119.9 139.82008C119.9 150.80909 128.9 159.8001 139.9 159.8001C145.5 159.8001 150.5 157.602298 154.1 154.005894L154.1 154.005894L179.9 128.231668L179.9 319.7201798C179.9 330.7091908 188.9 339.9 199.9 339.9zM320 400C331.0456940000001 400 340 391.045695 340 380C340 368.954305 331.0456940000001 360 320 360C308.9543060000001 360 300 368.954305 300 380C300 391.045695 308.9543060000001 400 320 400zM260 400C271.045694 400 280 391.045695 280 380C280 368.954305 271.045694 360 260 360C248.954306 360 240 368.954305 240 380C240 391.045695 248.954306 400 260 400zM200 400C211.045694 400 220 391.045695 220 380C220 368.954305 211.045694 360 200 360C188.954305 360 180 368.954305 180 380C180 391.045695 188.954305 400 200 400zM140 400C151.045695 400 160 391.045695 160 380C160 368.954305 151.045695 360 140 360C128.954305 360 120 368.954305 120 380C120 391.045695 128.954305 400 140 400zM80 400C91.045695 400 100 391.045695 100 380C100 368.954305 91.045695 360 80 360C68.954305 360 60 368.954305 60 380C60 391.045695 68.954305 400 80 400z" : "M280 40C291.045694 40 300 31.045694 300 20C300 8.954306 291.045694 0 280 0L40 0C28.954305 0 20 8.954306 20 20C20 31.045694 28.954305 40 40 40L280 40zM159.9 259.9C170.9 259.9 179.9 250.908991 179.9 239.91998L179.9 239.91998L179.9 128.2316684L205.7 154.0058942C209.3 157.6022978 214.3 159.8001 219.9 159.8001C230.9 159.8001 239.9 150.809091 239.9 139.82008C239.9 134.2256744 237.7 129.2306694 234.1 125.6342658L234.1 125.6342658L174.1 65.694206C170.5 62.097802 165.3 59.9 159.9 59.9C154.5 59.9 149.5 62.097802 145.7 65.694206L145.7 65.694206L85.7 125.6342658C82.1 129.2306694 79.9 134.2256744 79.9 139.82008C79.9 150.809091 88.9 159.8001 99.9 159.8001C105.5 159.8001 110.5 157.6022978 114.1 154.0058942L114.1 154.0058942L139.9 128.2316684L139.9 239.7201798C139.9 250.7091908 148.9 259.9 159.9 259.9zM280 320C291.045694 320 300 311.045695 300 300C300 288.954305 291.045694 280 280 280C268.9543060000001 280 260 288.954305 260 300C260 311.045695 268.9543060000001 320 280 320zM220 320C231.045694 320 240 311.045695 240 300C240 288.954305 231.045694 280 220 280C208.954306 280 200 288.954305 200 300C200 311.045695 208.954306 320 220 320zM160 320C171.045695 320 180 311.045695 180 300C180 288.954305 171.045695 280 160 280C148.954305 280 140 288.954305 140 300C140 311.045695 148.954305 320 160 320zM100 320C111.045695 320 120 311.045695 120 300C120 288.954305 111.045695 280 100 280C88.954305 280 80 288.954305 80 300C80 311.045695 88.954305 320 100 320zM40 320C51.045695 320 60 311.045695 60 300C60 288.954305 51.045695 280 40 280C28.954305 280 20 288.954305 20 300C20 311.045695 28.954305 320 40 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
BringData.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
BringData.displayName = "Blueprint5.Icon.BringData";
exports.default = BringData;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iHBq0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BringForward", ()=>BringForward);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var BringForward = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "bring-forward",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M185.8578 394.14214C193.6684 401.952622 206.332 401.952622 214.142 394.14214L294.142 314.1422C301.952 306.3316 301.952 293.6684 294.142 285.8578C286.332 278.0474000000001 273.668 278.0474000000001 265.858 285.8578L220 331.7158V220H380C391.046 220 400 211.0458 400 200C400 188.954 391.046 180 380 180H220V120H380C391.046 120 400 111.046 400 100V40C400 28.954 391.046 20 380 20H20C8.95432 20 0 28.954 0 40V100C0 111.046 8.9543 120 20 120H180V180H20C8.95432 180 0 188.954 0 200C0 211.0458 8.9543 220 20 220H180V331.7158L134.1422 285.8578C126.3316 278.0474000000001 113.6684 278.0474000000001 105.8578 285.8578C98.0474 293.6684 98.0474 306.3316 105.8578 314.1422L185.8578 394.14214z" : "M173.9412 314.2C170.3436 317.8 165.3466 320 159.95 320C154.5534 320 149.3566 317.8 145.7588 314.2L85.7964 254.4C82.1986 250.6 80 245.6 80 240.2C80 229.2 88.9944 220.2 99.9876 220.2C105.584 220.2 110.5808 222.4 114.1786 226L139.9626 251.8C139.9626 227.8668 140 203.9338 140 180.0006H20C8.9543 180.0006 0 171.0462 0 160.0006C0 148.9548 8.9543 140.0006 20 140.0006H140V100H20C8.9543 100 0 91.046 0 80V40C0 28.954 8.9543 20 20 20H300C311.046 20 320 28.954 320 40V80C320 91.046 311.046 100 300 100H180V140.0006H300C311.046 140.0006 320 148.9548 320 160.0006C320 171.0462 311.046 180.0006 300 180.0006H180L180 251.7162H179.9376V251.8L205.722 226C209.32 222.4 214.316 220.2 219.712 220.2C230.706 220.2 239.7 229.2 239.7 240.2C239.7 245.8 237.502 250.8 233.904 254.4L173.9412 314.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
BringForward.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
BringForward.displayName = "Blueprint5.Icon.BringForward";
exports.default = BringForward;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1lPRd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BritishPound", ()=>BritishPound);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var BritishPound = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "british-pound",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M192.3988 296.5256C184.3582 286.0470000000001 180 273.208 180 260V220H260C271.046 220 280 211.0456 280 200V180C280 168.954 271.046 160 260 160H180V132.464C180 112.726 176.259 95.128 169.3148 80H340V50V20H60V80H70C84.3034 80 96.6852 84.332 105.0766 91.786C112.8312 98.674 120 110.684 120 132.464V159.996L80 160C68.9544 160 60 168.954 60 180V200C60 211.0456 68.9544 220 80 220H120V260C120 286.4162 128.7164 312.094 144.7976 333.0514C160.8788 354.0086 183.4258 369.074 208.942 375.911C234.458 382.74804 261.516 380.97452 285.922 370.8654C310.3280000000001 360.7564 326.7920000000001 342.877 340 320L291.962 290C285.358 301.4384 275.164 310.3782 262.96 315.4328C250.758 320.4872000000001 237.228 321.374 224.47 317.9554C211.712 314.537 200.44 307.0042 192.3988 296.5256z" : "M144.0062 291.4454C131.7016 285.2466 121.1742 275.957 113.4824 264.4456C104.692 251.2896 100 235.8224 100 220L100 180H80C68.9544 180 60 171.0456 60 160C60 148.9542 68.9544 140 80 140H100V110C100 87.338 95.4198 74.186 90.859 67.344C86.654 61.036 82.599 60 80 60H60V20H260V60H131.82C137.2244 73.684 140 90.436 140 110V140H200C211.046 140 220 148.9542 220 160C220 171.0456 211.046 180 200 180H140V220C140 228.8054 142.9056 237.3646 148.266 244.3504C149.2794 245.671 150.3696 246.9214 151.5292 248.0964C152.5116 249.0918 153.5446 250.0344 154.6242 250.9204C156.75 252.665 159.0556 254.1902 161.5068 255.4684C162.5436 256.0088 163.6064 256.5052 164.6926 256.9552C165.8348 257.4282 166.9946 257.8466 168.1686 258.2102C168.658 258.3618 169.151 258.504 169.6474 258.637C169.9188 258.7098 170.191 258.7796 170.4634 258.8466C176.122 260.2356 182.041 260.3776 187.8036 259.2314C190.2284 258.749 192.5914 258.0454 194.8652 257.1352C199.8678 255.1326 204.438 252.1302 208.284 248.2842C210.74 245.828 212.882 243.047 214.642 240L249.282 260C245.764 266.094 241.48 271.6562 236.568 276.5686C233.072 280.0648 229.276 283.2126 225.236 285.9824C221.676 288.423 217.926 290.5702 214.024 292.4038C213.056 292.8594 212.076 293.2954 211.09 293.712C210.932 293.7786 210.774 293.8446 210.614 293.9104C208.512 294.7818 206.368 295.5642000000001 204.192 296.2548C199.7402 297.6668 195.189 298.6818 190.591 299.2958C186.6196 299.8264 182.6258 300.05608 178.6428 299.9884C172.1472 299.8784 165.649 298.9766 159.2946 297.274C158.1764 296.9744 157.0668 296.6512 155.9664 296.3046",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
BritishPound.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
BritishPound.displayName = "Blueprint5.Icon.BritishPound";
exports.default = BritishPound;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7NICm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bug", ()=>Bug);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Bug = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "bug",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120.1256 314.5566C122.4704 357.2762 157.3348 400 200 400C242.666 400 277.53 357.2762 279.874 314.5566C289.688 305.7974 298.054 295.449 304.5660000000001 283.9156L340 299.6642V340C340 351.0456 348.954 360 360 360C371.046 360 380 351.0456 380 340V286.6666C380 278.7628 375.346 271.6004000000001 368.122 268.3904L318.1380000000001 246.1748C319.362 239.3012 320 232.2252 320 225V200H380C391.046 200 400 191.046 400 180C400 168.954 391.046 160 380 160H320V150C320 137.922 318.216 126.26 314.896 115.266L368.122 91.61C375.346 88.4 380 81.238 380 73.334V20C380 8.954 371.046 0 360 0C348.954 0 340 8.954 340 20V60.336L297.06 79.42C275.24 49.468 239.894 30 200 30C160.1062 30 124.7592 49.468 102.9404 79.42L60 60.336V20C60 8.954 51.0456 0 40 0C28.9544 0 20 8.954 20 20V73.334C20 81.238 24.6546 88.4 31.8772 91.61L85.1038 115.266C81.7844 126.26 80 137.922 80 150V160H20C8.9543 160 0 168.954 0 180C0 191.046 8.9543 200 20 200H80V225C80 232.2252 80.6386 239.3012 81.8622 246.1748L31.8772 268.3904C24.6546 271.6004000000001 20 278.7628 20 286.6666V340C20 351.0456 28.9544 360 40 360C51.0456 360 60 351.0456 60 340V299.6642L95.4342 283.9156C101.9464 295.449 110.3116 305.7974 120.1256 314.5566zM120 180V150C120 105.818 155.8172 70 200 70C244.182 70 280 105.818 280 150V180V225C280 269.1828 244.182 305 200 305C155.8172 305 120 269.1828 120 225V180z" : "M100 260.0074C100.004 293.141 126.8654 320 160 320C193.1346 320 219.996 293.141 220 260.0072C231.794 251.149 241.564 239.744 248.496 226.609L260 232.3606V260C260 271.0456 268.954 280 280 280C291.046 280 300 271.0456 300 260V220C300 212.4246 295.72 205.4992 288.944 202.1114L259.722 187.5008C259.906 185.0246 260 182.5232 260 180V160H300C311.046 160 320 151.0458 320 140C320 128.9542 311.046 120 300 120H260C260 109.996 258.5320000000001 100.336 255.798 91.222L287.428 78.57C295.02 75.532 300 68.178 300 60V20C300 8.954 291.046 0 280 0C268.954 0 260 8.954 260 20V46.46L236.668 55.792C218.324 33.912 190.7864 20 160 20C129.2136 20 101.6766 33.912 83.3328 55.792L60 46.46V20C60 8.954 51.0456 0 40 0C28.9544 0 20 8.954 20 20V60C20 68.178 24.979 75.532 32.5722 78.57L64.203 91.222C61.469 100.336 60 109.996 60 120H20C8.9543 120 0 128.9542 0 140C0 151.0458 8.9543 160 20 160H60V180C60 182.5232 60.0934 185.0246 60.277 187.5008L31.0558 202.1114C24.28 205.4992 20 212.4246 20 220V260C20 271.0456 28.9544 280 40 280C51.0456 280 60 271.0456 60 260V232.3606L71.5034 226.609C78.4358 239.7442 88.2068 251.149 100 260.0074zM100 140V120C100 86.862 126.863 60 160 60C193.137 60 220 86.862 220 120V140V180C220 213.137 193.137 240 160 240C126.863 240 100 213.137 100 180V140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Bug.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Bug.displayName = "Blueprint5.Icon.Bug";
exports.default = Bug;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lhhVJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Buggy", ()=>Buggy);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Buggy = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "buggy",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M316.712 379.7268000000001C325.372 381.17018 333.962 376.7962 337.8880000000001 368.9432L387.514 269.693L387.904 269.7768C390.858 270.4094 393.938 269.674 396.286 267.7754C398.636 265.8768 400 263.0186 400 259.9986V169.998C400 164.476 395.522 159.998 390 159.998H311.408C301.376 159.998 292.01 154.986 286.4460000000001 146.64L258.32 104.452C256.466 101.67 253.344 99.998 250 99.998H160C157.3478 99.998 154.8042 101.052 152.929 102.928L104.6446 151.212C99.0186 156.838 91.388 159.998 83.4314 159.998H10C4.47716 159.998 0 164.476 0 169.998V229.9986C0 235.5216 4.47716 239.9986 10 239.9986H26.4592L61.4304 327.4266C64.0256 333.9148 69.8192 338.578 76.712 339.7268000000001L316.712 379.7268000000001zM322.5 310.2778L347.12 261.0372L291.97 249.2194L322.5 310.2778zM290.002 334.7232L258.8060000000001 272.3344L253.756 285.0888L237.254 325.932L290.002 334.7232zM94.3896 302.1212L196.8346 319.1954L216.592 270.2976L234.574 224.8862L204.648 179.998H154.1422L97.071 237.0698C95.1958 238.9452 92.6522 239.9986 90 239.9986H69.5406L94.3896 302.1212zM60 19.998C93.137 19.998 120 46.862 120 79.998C120 113.136 93.137 139.998 60 139.998C26.863 139.998 0 113.136 0 79.998C0 46.862 26.863 19.998 60 19.998zM340 19.998C373.1380000000001 19.998 400 46.862 400 79.998C400 113.136 373.1380000000001 139.998 340 139.998C306.862 139.998 280 113.136 280 79.998C280 46.862 306.862 19.998 340 19.998z" : "M278.57 307.42704C275.23 315.7762 266.728 320.8699460000001 257.79 319.8769104L77.791 299.877C71.5872 299.1876 66.0612 295.6414 62.8498 290.2892L8.61942 199.9054C3.7502 199.2326 0.000610352 195.0542 0.000610352 190V130C0.000610352 124.477 4.47776 120 10.00062 120H65.9694C72.7816 120 79.3908 117.682 84.7102 113.426L123.7536 82.192C125.5268 80.772 127.7298 80 130.0006 80H200C203.148 80 206.112 81.482 208 84L226 108C231.666 115.554 240.558 120 250 120H310C315.524 120 320 124.477 320 130V210C320 213.0566 318.602 215.9456 316.206 217.8422C315.478 218.417 314.684 218.8816 313.848 219.2304L278.57 307.42704zM247.21 278.12L247.082 278.4408L183.7658 271.4058L206.188 209.7472L247.21 278.12zM256.54 254.796L223.57 199.847L273.774 211.7128L256.54 254.796zM192.0584 190.0774L163.311 269.133L92.0532 261.2154L55.3238 200H70.0006C72.7862 200 75.4456 198.838 77.3382 196.794L124.3692 146.0004H162.6482L191.6796 189.5474C191.8004 189.7286 191.9268 189.9054 192.0584 190.0774zM50 0C77.6142 0 100 22.386 100 50C100 77.614 77.6142 100 50 100C22.3858 100 0 77.614 0 50C0 22.386 22.3858 0 50 0zM270 0C297.614 0 320 22.386 320 50C320 77.614 297.614 100 270 100C242.386 100 220 77.614 220 50C220 22.386 242.386 0 270 0z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Buggy.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Buggy.displayName = "Blueprint5.Icon.Buggy";
exports.default = Buggy;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bbX2e":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Build", ()=>Build);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Build = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "build",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M388.6 66.6L186.2 243.8L215.6 275C223.8 283.8 212.6 291 218.6 307C240.2000000000001 362.2 302.4000000000001 366.8 302.4000000000001 366.8S311.4 376.2 319.8 385.2C239.6 420 185.2 386 160.8 364L76.6 275L59.4 256.6C49.8 246.4 49.8 230 59.4 219.8L42 201.4C32.4 211.6 16.8 211.6 7.2 201.4S-2.4 174.8 7.2 164.6L42 127.8C51.6 117.6 67.2 117.6 76.8 127.8C86.4 138 86.4 154.4 76.8 164.6L94.2 183C103.8 172.8 119.4 172.8 129 183L157.2 212.8L333.4000000000001 11.4C348.6000000000001 -3.8 373.4000000000001 -3.8 388.6 11.4C403.8 26.6 403.8 51.4 388.6 66.6z" : "M307.8 71.8L154 200L175.4 222C182.2 228.8 173 234.6 177.8 247.2C195.4 290.6 246 294.2 246 294.2S253.2 301.6 260.2 308.6C194.8 336.2 150.6 309.4 130.8 292L62.4 222L48.2 207.6C40.4 199.6 40.4 186.6 48.2 178.6L34.2 164.2C26.4 172.2 13.8 172.2 6 164.2S-1.8 143.2 6 135.2L34.2 106.2C42 98.2 54.6 98.2 62.4 106.2S70.2 127.2 62.4 135.2L76.6 149.6C84.4 141.6 97 141.6 104.8 149.6L120.8 166L248.6 12.6C265 -3.8 291.4 -3.8 307.8 12.6C324 29 324 55.6 307.8 71.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Build.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Build.displayName = "Blueprint5.Icon.Build";
exports.default = Build;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lC8Xa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bullseye", ()=>Bullseye);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Bullseye = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "bullseye",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M394.142 394.14214C401.952 386.33166 401.952 373.6684 394.142 365.8578L214.142 185.858C206.332 178.048 193.6684 178.048 185.8578 185.858C178.0474 193.668 178.0474 206.3316 185.8578 214.1422L365.858 394.14214C373.668 401.952622 386.332 401.952622 394.142 394.14214zM292.512 377.3636C264.848 391.8233 233.378 400 200 400C89.543 400 0 310.457 0 200C0 89.544 89.543 0 200 0C310.456 0 400 89.544 400 200C400 233.3778 391.824 264.8458 377.3640000000001 292.5104L347.3400000000001 262.485C355.49 243.288 360 222.1706 360 200C360 111.634 288.366 40 200 40C111.6344 40 40 111.634 40 200C40 288.3656 111.6344 360 200 360C222.172 360 243.29 355.4904 262.486 347.3384L292.512 377.3636zM231.084 315.9352C221.17 318.5864000000001 210.75 320 200 320C133.7258 320 80 266.2742 80 200C80 133.726 133.7258 80 200 80C266.274 80 320 133.726 320 200C320 210.7492 318.586 221.1682 315.936 231.0816L279.846 194.992C277.26 153.142 242.5 120 200 120C155.8172 120 120 155.818 120 200C120 242.5016 153.1434 277.2622 194.9946 279.846L231.084 315.9352z" : "M315.184 293.0154C322.374 284.629 321.402 272.003 313.016 264.8146L173.0156 144.8146C164.629 137.626 152.003 138.5974 144.8146 146.9838C137.6262 155.3704 138.5974 167.9964 146.984 175.1848L286.984 295.1848C295.37 302.37322 307.9960000000001 301.40198 315.184 293.0154zM160 40C226.274 40 280 93.726 280 160C280 175.2596 277.152 189.854 271.958 203.2804L303.6840000000001 230.4738C314.132 209.2112 320 185.2908 320 160C320 71.634 248.366 0 160 0C71.6344 0 0 71.634 0 160C0 248.3656 71.6344 320 160 320C194.0706 320 225.654 309.3509 251.602 291.1996L219.884 264.0126C202.26 274.1818 181.8098 280 160 280C93.7258 280 40 226.2742 40 160C40 93.726 93.7258 40 160 40zM186.5906 235.4748C178.2712 238.4056 169.3218 240 160 240C115.8172 240 80 204.1828 80 160C80 115.818 115.8172 80 160 80C204.182 80 240 115.818 240 160C240 165.0314 239.536 169.9544 238.648 174.7284L186.1714 129.7492C184.9726 128.7112 183.7114 127.7432 182.3944 126.8516C175.0432 121.8718 166.4856 119.638 158.0698 120.0458C153.045 120.2846 148.2628 121.4504 143.8908 123.3762C138.5648 125.7144 133.6678 129.2558 129.6292 133.9676C129.5558 134.0534 129.4826 134.1394 129.41 134.2256C128.8644 134.8724 128.339 135.5368 127.8346 136.2178C122.2274 143.7852 119.6672 152.7834 120.033 161.6412C120.2478 166.9626 121.5022 172.016 123.5984 176.6042C126.0684 182.0104 129.7072 186.7704 134.1916 190.5614L186.5906 235.4748z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Bullseye.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Bullseye.displayName = "Blueprint5.Icon.Bullseye";
exports.default = Bullseye;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3gppB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Calculator", ()=>Calculator);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Calculator = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "calculator",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 400H80C69 400 60 391 60 380V20C60 9 69 0 80 0H320C331 0 340 9 340 20V380C340 391 331 400 320 400zM140 40H100V80H140V40zM140 120H100V160H140V120zM140 200H100V240H140V200zM220 40H180V80H220V40zM220 120H180V160H220V120zM220 200H180V240H220V200zM300 40H260V160H300V40zM300 200H260V240H300V200zM300 280H100V360H300V280z" : "M260 320H60C49 320 40 311 40 300V20C40 9 49 0 60 0H260C271 0 280 9 280 20V300C280 311 271 320 260 320zM120 40H80V80H120V40zM120 100H80V140H120V100zM120 160H80V200H120V160zM180 40H140V80H180V40zM180 100H140V140H180V100zM180 160H140V200H180V160zM240 40H200V140H240V40zM240 160H200V200H240V160zM240 220H80V280H240V220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Calculator.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Calculator.displayName = "Blueprint5.Icon.Calculator";
exports.default = Calculator;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lxdmc":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Calendar", ()=>Calendar);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Calendar = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "calendar",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 300C312 300 320 308 320 320L320 360C320 370 312 380 300 380C288 380 280 370 280 360L280 320C280 308 288 300 300 300zM100 300C112 300 120 308 120 320L120 360C120 370 112 380 100 380C88 380 80 370 80 360L80 320C80 308 88 300 100 300zM360 340L340 340L340 320C340 298 322 280 300 280C278 280 260 298 260 320L260 340L140 340L140 320C140 298 122 280 100 280C78 280 60 298 60 320L60 340L40 340C30 340 20 330 20 320L20 40C20 30 30 20 40 20L360 20C370 20 380 30 380 40L380 320C380 330 370 340 360 340zM140 60L60 60L60 140L140 140L140 60zM140 160L60 160L60 240L140 240L140 160zM240 60L160 60L160 140L240 140L240 60zM240 160L160 160L160 240L240 240L240 160zM340 60L260 60L260 140L340 140L340 60zM340 160L260 160L260 240L340 240L340 160z" : "M220 260C232 260 240 270 240 280L240 300C240 312 232 320 220 320C208 320 200 312 200 300L200 280C200 270 208 260 220 260zM280 300L260 300L260 280C260 258 242 240 220 240C198 240 180 258 180 280L180 300L120 300L120 280C120 258 102 240 80 240C58 240 40 258 40 280L40 300L20 300C8 300 0 290 0 280L0 40C0 28 8 20 20 20L280 20C292 20 300 28 300 40L300 280C300 292 290 300 280 300zM100 60L40 60L40 120L100 120L100 60zM100 140L40 140L40 200L100 200L100 140zM180 60L120 60L120 120L180 120L180 60zM180 140L120 140L120 200L180 200L180 140zM260 60L200 60L200 120L260 120L260 60zM260 140L200 140L200 200L260 200L260 140zM80 260C92 260 100 270 100 280L100 300C100 312 92 320 80 320C68 320 60 312 60 300L60 280C60 270 68 260 80 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Calendar.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Calendar.displayName = "Blueprint5.Icon.Calendar";
exports.default = Calendar;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"vHSl7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Camera", ()=>Camera);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Camera = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "camera",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 240C166.8 240 140 213.2 140 180S166.8 120 200 120S260 146.8 260 180S233.2 240 200 240zM380 320H308.2L274 354.2C270.6 357.8 265.6 360 260 360H140C134.4 360 129.4 357.8 125.8 354.2L91.8 320H20C9 320 0 311 0 300V100C0 89 9 80 20 80H102.2C127.4 55.2 162 40 200 40S272.6 55.2 297.8 80H380C391 80 400 89 400 100V300C400 311 391 320 380 320zM80 240H40V280H80V240zM200 80C144.8 80 100 124.8 100 180S144.8 280 200 280S300 235.2 300 180S255.2 80 200 80z" : "M300 260H248.2L214 294.2C210.6 297.8 205.6 300 200 300H120C114.4 300 109.4 297.8 105.8 294.2L71.8 260H20C9 260 0 251 0 240V100C0 89 9 80 20 80H71.2C93.2 55.6 124.6 40 160 40S226.8 55.6 248.8 80H300C311 80 320 89 320 100V240C320 251 311 260 300 260zM60 200H20V220H60V200zM160 80C115.8 80 80 115.8 80 160C80 204.2 115.8 240 160 240S240 204.2 240 160C240 115.8 204.2 80 160 80zM160 200C138 200 120 182 120 160C120 138 138 120 160 120S200 138 200 160C200 182 182 200 160 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Camera.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Camera.displayName = "Blueprint5.Icon.Camera";
exports.default = Camera;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iALAN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CaretDown", ()=>CaretDown);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CaretDown = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "caret-down",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 260C320 271 311 280 300 280H100C89 280 80 271 80 260C80 255.2 82 250.8 84.8 247.4L84.6 247.2L184.6 127.2L184.8 127.4C188.6 123 193.8 120 200 120S211.4 123 215.2 127.4L215.4 127.2L315.4 247.2L315.2 247.4C318 250.8 320 255.2 320 260z" : "M240 190C240 195.6 235.6 200 230 200H90C84.4 200 80 195.6 80 190C80 187.4 81 185.2 82.6 183.4C82.6 183.4 82.6 183.4 82.6 183.4L152.6 103.4L152.6 103.4C154.4 101.4 157 100 160 100S165.6 101.4 167.4 103.4L167.4 103.4L237.4 183.4L237.4 183.4C239 185.2 240 187.4 240 190z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CaretDown.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CaretDown.displayName = "Blueprint5.Icon.CaretDown";
exports.default = CaretDown;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fosY9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CaretLeft", ()=>CaretLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CaretLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "caret-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260 320C255.2 320 250.8 318 247.4 315.2L247.2 315.4L127.2 215.4L127.4 215.2C123 211.4 120 206.2 120 200C120 193.8 123 188.6 127.4 184.8L127.2 184.6L247.2 84.6L247.4 84.8C250.8 82 255.2 80 260 80C271 80 280 89 280 100V300C280 311 271 320 260 320z" : "M190 240C187.4 240 185.2 239 183.4 237.4C183.4 237.4 183.4 237.4 183.4 237.4L103.4 167.4L103.4 167.4C101.4 165.6 100 163 100 160S101.4 154.4 103.4 152.6L103.4 152.6L183.4 82.6L183.4 82.6C185.2 81 187.4 80 190 80C195.6 80 200 84.4 200 90V230C200 235.6 195.6 240 190 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CaretLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CaretLeft.displayName = "Blueprint5.Icon.CaretLeft";
exports.default = CaretLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fBAUG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CaretRight", ()=>CaretRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CaretRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "caret-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 200C280 206.2 277 211.4 272.6 215.2L272.8 215.4L152.8 315.4L152.6 315.2C149.2 318 144.8 320 140 320C129 320 120 311 120 300V100C120 89 129 80 140 80C144.8 80 149.2 82 152.6 84.8L152.8 84.6L272.8 184.6L272.6 184.8C277 188.6 280 193.8 280 200z" : "M220 160C220 163 218.6 165.6 216.6 167.4L216.6 167.4L136.6 237.4L136.6 237.4C134.8 239 132.6 240 130 240C124.4 240 120 235.6 120 230V90C120 84.4 124.4 80 130 80C132.6 80 134.8 81 136.6 82.6C136.6 82.6 136.6 82.6 136.6 82.6L216.6 152.6L216.6 152.6C218.6 154.4 220 157 220 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CaretRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CaretRight.displayName = "Blueprint5.Icon.CaretRight";
exports.default = CaretRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"atJoJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CaretUp", ()=>CaretUp);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CaretUp = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "caret-up",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M315.2 152.6L315.4 152.8L215.4 272.8L215.2 272.6C211.4 277 206.2 280 200 280S188.6 277 184.8 272.6L184.6 272.8L84.6 152.8L84.8 152.6C82 149.2 80 144.8 80 140C80 129 89 120 100 120H300C311 120 320 129 320 140C320 144.8 318 149.2 315.2 152.6z" : "M237.4 136.6C237.4 136.6 237.6 136.6 237.4 136.6L167.4 216.6L167.4 216.6C165.6 218.6 163 220 160 220S154.4 218.6 152.6 216.6L152.6 216.6L82.6 136.6L82.6 136.6C81 134.8 80 132.6 80 130C80 124.4 84.4 120 90 120H230C235.6 120 240 124.4 240 130C240 132.6 239 134.8 237.4 136.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CaretUp.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CaretUp.displayName = "Blueprint5.Icon.CaretUp";
exports.default = CaretUp;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f732N":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CargoShip", ()=>CargoShip);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CargoShip = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cargo-ship",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M250 375H330C341.046 375 350 366.0456 350 355V300H250V375zM55.0002 300C52.2388 300 50.0002 297.7614 50.0002 295V175H17.66254C9.88958 175 5.08846 166.52 9.08762 159.856L42.5224 104.13C45.9314 98.448 50.1988 93.46 55.1028 89.292C45.9634 88.166 35.9438 87.5 25.0002 87.5C18.09666 87.5 12.50022 81.904 12.50022 75C12.50022 68.096 18.09666 62.5 25.0002 62.5C76.666 62.5 110.3582 76.086 129.0324 85.414C142.7808 76.096 166.6568 62.5 200 62.5C233.01 62.5 256.74 75.826 270.552 85.134L270.66 85.076C275.544 82.458 282.674 79.076 292.046 75.728C310.812 69.026 338.48 62.5 375 62.5C381.904 62.5 387.5 68.096 387.5 75C387.5 81.904 381.904 87.5 375 87.5C368.624 87.5 362.56 87.716 356.81 88.108C364.764 94.456 371.14 102.85 375.088 112.716L394.516 161.286C397.142 167.854 392.3040000000001 175 385.23 175H100.0002V295C100.0002 297.7614 97.7616 300 95.0002 300H55.0002zM124.0974 61.018C128.2904 63.264 133.395 62.936 137.2656 60.172C148.6396 52.048 169.194 37.5 200 37.5C230.806 37.5 251.36 52.048 262.734 60.172C267.064 63.264 272.874 63.276 277.216 60.208L277.366 60.106C277.532 59.994 278.266 59.526 278.266 59.526C279.132 58.984 280.532 58.148 282.466 57.112C286.33 55.042 292.326 52.174 300.454 49.272C316.69 43.474 341.52 37.5 375 37.5C381.904 37.5 387.5 31.904 387.5 25C387.5 18.096 381.904 12.5 375 12.5C338.48 12.5 310.812 19.026 292.046 25.728C282.674 29.076 275.544 32.458 270.66 35.076L270.552 35.134C256.74 25.826 233.01 12.5 200 12.5C166.6568 12.5 142.7808 26.096 129.0324 35.414C110.3582 26.086 76.666 12.5 25.0002 12.5C18.09666 12.5 12.50022 18.096 12.50022 25C12.50022 31.904 18.09666 37.5 25.0002 37.5C78.2168 37.5 109.5892 53.246 124.0974 61.018zM350 275H250V200H330C341.046 200 350 208.9542 350 220V275zM125.0002 355C125.0002 366.0456 133.9546 375 145.0002 375H225V300H125.0002V355zM225 275H125.0002V220C125.0002 208.9544 133.9546 200 145.0002 200H225V275z" : "M200 300H260C271.046 300 280 291.0456 280 280V240H200V300zM45 240C42.2386 240 40 237.7614 40 235V140H17.66224C9.8893 140 5.08816 131.5202 9.0873 124.855L30.5222 89.13C34.6614 82.232 40.0662 76.356 46.3398 71.726C38.4294 70.65 29.665 70 20 70C14.47716 70 10 65.522 10 60C10 54.478 14.47716 50 20 50C61.3326 50 88.2864 60.868 103.2258 68.332C114.2246 60.878 133.3252 50 160 50C186.4074 50 205.392 60.66 216.44 68.106L216.528 68.06C220.436 65.966 226.138 63.26 233.636 60.582C248.648 55.222 270.784 50 300 50C305.522 50 310 54.478 310 60C310 65.522 305.522 70 300 70C293.486 70 287.382 70.282 281.688 70.778C291.096 77.334 298.636 86.59 303.086 97.716L314.514 126.286C317.142 132.8548 312.304 140 305.23 140H80V235C80 237.7614 77.7614 240 75 240H45zM99.2778 48.814C102.6322 50.612 106.7158 50.35 109.8124 48.138C118.9116 41.638 135.355 30 160 30C184.645 30 201.088 41.638 210.188 48.138C213.652 50.612 218.3 50.62 221.772 48.166L221.892 48.084C222.026 47.996 222.612 47.62 222.612 47.62C223.306 47.188 224.426 46.518 225.972 45.69C229.064 44.034 233.862 41.74 240.364 39.418C253.352 34.778 273.216 30 300 30C305.522 30 310 25.522 310 20C310 14.478 305.522 10 300 10C270.784 10 248.648 15.222 233.636 20.582C226.138 23.26 220.436 25.966 216.528 28.06L216.44 28.106C205.392 20.66 186.4074 10 160 10C133.3252 10 114.2246 20.878 103.2258 28.332C88.2864 20.868 61.3326 10 20 10C14.47716 10 10 14.478 10 20C10 25.522 14.47716 30 20 30C62.5732 30 87.6712 42.596 99.2778 48.814zM280 220H200V160H260C271.046 160 280 168.9544 280 180V220zM100 280C100 291.0456 108.9544 300 120 300H180V240H100V280zM180 220H100V180C100 168.9544 108.9544 160 120 160H180V220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CargoShip.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CargoShip.displayName = "Blueprint5.Icon.CargoShip";
exports.default = CargoShip;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"klKQK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CellTower", ()=>CellTower);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CellTower = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cell-tower",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M230 233.6C236.2 240.6 240.2 249.8 240.2 260C240.2 282 222.2 300 200.2 300S160.2 282 160.2 260C160.2 249.8 164.2 240.6 170.4 233.6L101.2 26.2C97.8 15.8 103.4 4.4 113.8 0.9999999999999S135.6 3.1999999999999 139 13.5999999999999L167.8 100H232.4000000000001L261.2 13.6C264.6 3.2 276 -2.6 286.4 1S302.6 15.8 299 26.2L230 233.6zM219 140H181.2L200.2 196.8L219 140zM106.2 185.4C114.2 177.8 126.8 178.2 134.4 186.2C142 194.2 141.6 206.8 133.6 214.4C105.6 241 108 281.4 133.4 305.2C141.4 312.8 142 325.4 134.4 333.4C127.2 341.6 114.4 342 106.4 334.6C64.6 295.6 60.8 228.6 106.2 185.4zM92 156C60 178 40 220 40 260C40 302 58 338 92 364C102 370 102 384 96 392C90 402 76 402 68 396C24 362 -2 316 0 260C2 206 28 154 68 124C72 122 76 120 80 120C86 120 92 122 96 128C104 138 102 150 92 156zM265.4 186.2C273 178.2 285.6 177.8 293.6 185.4C339 228.6 335.2 295.6 293.4 334.6C285.4 342.2000000000001 272.6 341.6 265.2 333.6C257.6 325.6 258.2 312.8 266.2 305.4000000000001C291.8 281.6 294 241.2 266 214.6C258.2 206.8 257.8 194.2 265.4 186.2zM332 396C324.0000000000001 402 310.0000000000001 402 304 392C298 384 298 370 308 364C342 338 360 302 360 260C360 220 340 178 308 156C298 150 296 138 304 128C308 122 314 120 320 120C324 120 328 122 332 124C374.0000000000001 154 400 206 400 260C401.8 316 376 362 332 396z" : "M179.4 184.8C179.2 185.8 178.6 186.4 178.2 187.4C177.8 188.4 177.6 189.4 177.2 190.4C178.8 193.2 180 196.4 180 200C180 211 171 220 160 220S140 211 140 200C140 196.4 141.2 193.2 142.8 190.4C142.2 189.4 142.2 188.4 141.8 187.4C141.4 186.4 140.8 185.8 140.6 184.8L100.6 24.8C98 14 104.4 3.2 115.2 0.6C126 -1.9999999999999 136.8 4.4 139.4 15.2L150.6 60H169.4L180.6 15.2C183.2000000000001 4.4 194.2 -2 204.8000000000001 0.6C215.6 3.2 222 14.2 219.4 24.8L179.4 184.8zM74.4 286C82 294 81.8 306.6 74 314.4S53.4 321.8 45.6 314C-15.4 251.6 -15.4 148.4 45.6 86C53.4 78 66 78 73.8 85.6S81.8 106 74.2 113.8C28.6 160.8 28.6 239.2 74.4 286zM232 256C223.2 262.6 210.6 260.8 204 252C197.4 243.2 199.2 230.6 208 224C216.6 217.6 218.6 184.8 207.2 175.4C198.8 168.4 197.6 155.8 204.6 147.2C211.6 138.8 224.2 137.6 232.8 144.6C264.6 171.2 260.6 234.6 232 256zM274.4000000000001 314C266.6 322 254.0000000000001 322 246.2 314.4S238 294 245.6 286C291.4 239.2 291.4 160.8 245.6 114C237.8 106.2 238 93.4 246 85.8S266.6 78.2 274.2 86.2C335.2000000000001 148.4 335.2000000000001 251.6 274.4000000000001 314zM108 175.4C96.6 184.8 98.6 217.6 107.2 224C116 230.6 117.8 243.2 111.2 252S92 262.6 83.2 256C54.4 234.6 50.6 171.2 82.4 144.6C90.8 137.6 103.4 138.6 110.6 147.2C117.6 155.6 116.4 168.4 108 175.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CellTower.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CellTower.displayName = "Blueprint5.Icon.CellTower";
exports.default = CellTower;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dXj1L":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Changes", ()=>Changes);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Changes = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "changes",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 80H40C18 80 0 62 0 40C0 18 18 0 40 0H360C382 0 400 18 400 40C400 62 382 80 360 80zM60 300C65.6 300 70.6 302.2 74.2 305.8L100 331.8V140C100 129 109 120 120 120S140 129 140 140V331.8L165.8 306C169.4 302.2 174.4 300 180 300C191 300 200 309 200 320C200 325.6 197.8 330.6 194.2 334.2L134.2 394.2C130.6 397.8 125.6 400 120 400S109.4 397.8 105.8 394.2L45.8 334.2C42.2 330.6 40 325.6 40 320C40 309 49 300 60 300zM205.8 185.8L265.8 125.8C269.4000000000001 122.2 274.4000000000001 120 280 120S290.6 122.2 294.2000000000001 125.8L354.2000000000001 185.8C357.8 189.4 360 194.4 360 200C360 211 351 220 340 220C334.4 220 329.4 217.8 325.8 214.2L300 188.2V380C300 391 291 400 280 400S260 391 260 380V188.2L234.2 214C230.6 217.8 225.6 220 220 220C209 220 200 211 200 200C200 194.4 202.2 189.4 205.8 185.8z" : "M165.8 165.8L225.8 105.8C229.4 102.2 234.4 100 240 100S250.6 102.2 254.2 105.8L314.2000000000001 165.8C317.8 169.4 320 174.4 320 180C320 191 311 200 300 200C294.4000000000001 200 289.4000000000001 197.8 285.8 194.2L260 168.2V300C260 311 251 320 240 320S220 311 220 300V168.2L194.2 194.2C190.6 197.8 185.6 200 180 200C169 200 160 191 160 180C160 174.4 162.2 169.4 165.8 165.8zM290 60H30C13.4 60 0 46.6 0 30S13.4 0 30 0H290C306.6 0 320 13.4 320 30S306.6 60 290 60zM20 220C25.6 220 30.6 222.2 34.2 225.8L60 251.8V120C60 109 69 100 80 100S100 109 100 120V251.8L125.8 226C129.4 222.2 134.4 220 140 220C151 220 160 229 160 240C160 245.6 157.8 250.6 154.2 254.2L94.2 314.2C90.6 317.8 85.6 320 80 320S69.4 317.8 65.8 314.2L5.8 254.2C2.2 250.6 0 245.6 0 240C0 229 9 220 20 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Changes.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Changes.displayName = "Blueprint5.Icon.Changes";
exports.default = Changes;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dKm9r":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Chart", ()=>Chart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Chart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140 180V20C140 9 149 0 160 0H240C251 0 260 9 260 20V180L220 140L140 180zM0 20C0 9 9 0 20 0H100C111 0 120 9 120 20V180L0 120V20zM340 260L280 200V20C280 9 289 0 300 0H380C391 0 400 9 400 20V225.2C394.8 222.2 388.4000000000001 220 380 220C341.6 220 340 260 340 260zM380 380H300C289 380 280 371 280 360C280 349 289 340 300 340H331.8L216 224.4L149 257.8L149 257.6C146.2 259 143.2 260 140 260S133.8 259 131.2 257.8L131.2 258L11.2 198L11.2 197.8C4.6 194.4 0 187.8 0 180C0 169 9 160 20 160C23.2 160 26.2 161 28.8 162.2L28.8 162L140 217.6L211 182L211 182.2C213.8 181 216.8 180 220 180C225.6 180 230.6 182.2 234.2 185.8L360 311.8V280C360 269 369 260 380 260S400 269 400 280V360C400 371 391 380 380 380z" : "M0 20C0 9 9 0 20 0H60C71 0 80 9 80 20V132L0 100V20zM120 130V20C120 9 129 0 140 0H180C191 0 200 9 200 20V120L180 100L120 130zM260 180L240 160V20C240 9 249 0 260 0H300C311 0 320 9 320 20V162.4C314.8 161 308.4 160 300 160C260.8 160 260 180 260 180zM300 300H240C229 300 220 291 220 280C220 269 229 260 240 260H251.8L176 184.4L109 217.8L109 217.6C106.2 219 103.2 220 100 220S93.8 219 91.2 217.8L91.2 218L11.2 178L11.2 177.8C4.6 174.4 0 167.8 0 160C0 149 9 140 20 140C23.2 140 26.2 141 28.8 142.2L28.8 142L100 177.6L171 142L171 142.2C173.8 141 176.8 140 180 140C185.6 140 190.6 142.2 194.2 145.8L280 231.8V220C280 209 289 200 300 200S320 209 320 220V280C320 291 311 300 300 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Chart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Chart.displayName = "Blueprint5.Icon.Chart";
exports.default = Chart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aZEIT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Chat", ()=>Chat);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Chat = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "chat",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400H140C129 400 120 391 120 380V180C120 169 129 160 140 160H251.8L326 85.8C329.4 82.2 334.4 80 340 80C351 80 360 89 360 100V160H380C391 160 400 169 400 180V380C400 391 391 400 380 400zM140 140C118 140 100 158 100 180V320H20C9 320 0 311 0 300V100C0 89 9 80 20 80H40V20C40 9 49 0 60 0C65.6 0 70.6 2.2 74.2 5.8L148.2 80H260C271 80 280 89 280 100V103.4L243.4 140H140z" : "M120 120C98 120 80 138 80 160V260H20C9 260 0 251 0 240V80C0 69 9 60 20 60V20C20 9 29 0 40 0C45.6 0 50.6 2.2 54.2 5.8L108.2 60H200C211 60 220 69 220 80V103.4L203.4 120H120zM300 320H120C109 320 100 311 100 300V160C100 149 109 140 120 140H211.8L266 85.8C269.4000000000001 82.2 274.4000000000001 80 280 80C291 80 300 89 300 100V140C311 140 320 149 320 160V300C320 311 311 320 300 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Chat.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Chat.displayName = "Blueprint5.Icon.Chat";
exports.default = Chat;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Qq2s":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChevronBackward", ()=>ChevronBackward);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ChevronBackward = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "chevron-backward",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M168.2 200L274 305.8C277.8 309.4 280 314.4 280 320C280 331 271 340 260 340C254.4 340 249.4 337.8 245.8 334.2L140 228.2V320C140 331 131 340 120 340S100 331 100 320V80C100 69 109 60 120 60S140 69 140 80V171.8L245.8 66C249.4 62.2 254.4 60 260 60C271 60 280 69 280 80C280 85.6 277.8 90.6 274.2000000000001 94.2000000000001L168.2 200z" : "M148.2 160L214 225.8C217.8 229.4 220 234.4 220 240C220 251 211 260 200 260C194.4 260 189.4 257.8 185.8 254.2L120 188.2V240C120 251 111 260 100 260S80 251 80 240V80C80 69 89 60 100 60S120 69 120 80V131.8L185.8 66C189.4 62.2 194.4 60 200 60C211 60 220 69 220 80C220 85.6 217.8 90.6 214.2 94.2L148.2 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ChevronBackward.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ChevronBackward.displayName = "Blueprint5.Icon.ChevronBackward";
exports.default = ChevronBackward;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzkD8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChevronDown", ()=>ChevronDown);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ChevronDown = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "chevron-down",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 280C314.4000000000001 280 309.4000000000001 277.8 305.8 274.2L200 168.2L94.2 274.2C90.6 277.8 85.6 280 80 280C69 280 60 271 60 260C60 254.4 62.2 249.4 65.8 245.8L185.8 125.8C189.4 122.2 194.4 120 200 120S210.6 122.2 214.2 125.8L334.2000000000001 245.8C337.8 249.4 340 254.4 340 260C340 271 331 280 320 280z" : "M240 220C234.4 220 229.4 217.8 225.8 214.2L160 148.2L94.2 214.2C90.6 217.8 85.6 220 80 220C69 220 60 211 60 200C60 194.4 62.2 189.4 65.8 185.8L145.8 105.8C149.4 102.2 154.4 100 160 100S170.6 102.2 174.2 105.8L254.2 185.8C257.8 189.4 260 194.4 260 200C260 211 251 220 240 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ChevronDown.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ChevronDown.displayName = "Blueprint5.Icon.ChevronDown";
exports.default = ChevronDown;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fNeMM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChevronForward", ()=>ChevronForward);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ChevronForward = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "chevron-forward",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260 340C249 340 240 331 240 320V228.2L134.2 334.2C130.6 337.8 125.6 340 120 340C109 340 100 331 100 320C100 314.4 102.2 309.4 105.8 305.8L211.8 200L106 94.2000000000001C102.2 90.6 100 85.6 100 80C100 69 109 60 120 60C125.6 60 130.6 62.2 134.2 65.8L240 171.8V80C240 69 249 60 260 60S280 69 280 80V320C280 331 271 340 260 340z" : "M200 260C189 260 180 251 180 240V188.2L114.2 254.2C110.6 257.8 105.6 260 100 260C89 260 80 251 80 240C80 234.4 82.2 229.4 85.8 225.8L151.8 160L86 94.2C82.2 90.6 80 85.6 80 80C80 69 89 60 100 60C105.6 60 110.6 62.2 114.2 65.8L180 131.8V80C180 69 189 60 200 60S220 69 220 80V240C220 251 211 260 200 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ChevronForward.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ChevronForward.displayName = "Blueprint5.Icon.ChevronForward";
exports.default = ChevronForward;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cT523":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChevronLeft", ()=>ChevronLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ChevronLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "chevron-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M168.2 200L274 305.8C277.8 309.4 280 314.4 280 320C280 331 271 340 260 340C254.4 340 249.4 337.8 245.8 334.2L125.8 214.2C122.2 210.6 120 205.6 120 200C120 194.4 122.2 189.4 125.8 185.8L245.8 65.8C249.4 62.2 254.4 60 260 60C271 60 280 69 280 80C280 85.6 277.8 90.6 274.2000000000001 94.2000000000001L168.2 200z" : "M148.2 160L214 225.8C217.8 229.4 220 234.4 220 240C220 251 211 260 200 260C194.4 260 189.4 257.8 185.8 254.2L105.8 174.2C102.2 170.6 100 165.6 100 160C100 154.4 102.2 149.4 105.8 145.8L185.8 65.8C189.4 62.2 194.4 60 200 60C211 60 220 69 220 80C220 85.6 217.8 90.6 214.2 94.2L148.2 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ChevronLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ChevronLeft.displayName = "Blueprint5.Icon.ChevronLeft";
exports.default = ChevronLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hy2GQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChevronRight", ()=>ChevronRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ChevronRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "chevron-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M274.2000000000001 214.2L154.2 334.2000000000001C150.6 337.8 145.6 340 140 340C129 340 120 331 120 320C120 314.4 122.2 309.4 125.8 305.8L231.8 200L126 94.2000000000001C122.2 90.6 120 85.6 120 80C120 69 129 60 140 60C145.6 60 150.6 62.2 154.2 65.8L274.2000000000001 185.8C277.8 189.4 280 194.4 280 200C280 205.6 277.8 210.6 274.2000000000001 214.2z" : "M214.2 174.2L134.2 254.2C130.6 257.8 125.6 260 120 260C109 260 100 251 100 240C100 234.4 102.2 229.4 105.8 225.8L171.8 160L106 94.2C102.2 90.6 100 85.6 100 80C100 69 109 60 120 60C125.6 60 130.6 62.2 134.2 65.8L214.2 145.8C217.8 149.4 220 154.4 220 160C220 165.6 217.8 170.6 214.2 174.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ChevronRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ChevronRight.displayName = "Blueprint5.Icon.ChevronRight";
exports.default = ChevronRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PLt2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChevronUp", ()=>ChevronUp);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ChevronUp = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "chevron-up",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M334.2000000000001 154.2L214.2 274.2000000000001C210.6 277.8 205.6 280 200 280S189.4 277.8 185.8 274.2L65.8 154.2C62.2 150.6 60 145.6 60 140C60 129 69 120 80 120C85.6 120 90.6 122.2 94.2 125.8L200 231.8L305.8 126C309.4000000000001 122.2 314.4000000000001 120 320 120C331 120 340 129 340 140C340 145.6 337.8 150.6 334.2000000000001 154.2z" : "M254.2 134.2L174.2 214.2C170.6 217.8 165.6 220 160 220S149.4 217.8 145.8 214.2L65.8 134.2C62.2 130.6 60 125.6 60 120C60 109 69 100 80 100C85.6 100 90.6 102.2 94.2 105.8L160 171.8L225.8 106C229.4 102.2 234.4 100 240 100C251 100 260 109 260 120C260 125.6 257.8 130.6 254.2 134.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ChevronUp.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ChevronUp.displayName = "Blueprint5.Icon.ChevronUp";
exports.default = ChevronUp;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2xCFH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleArrowDown", ()=>CircleArrowDown);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CircleArrowDown = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "circle-arrow-down",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 200C274.4000000000001 200 269.4000000000001 197.8 265.8 194.2L220 148.2V300C220 311 211 320 200 320S180 311 180 300V148.2L134.2 194C130.6 197.8 125.6 200 120 200C109 200 100 191 100 180C100 174.4 102.2 169.4 105.8 165.8L185.8 85.8C189.4 82.2 194.4 80 200 80S210.6 82.2 214.2 85.8L294.2000000000001 165.8C297.8 169.4 300 174.4 300 180C300 191 291 200 280 200zM200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 40C111.6 40 40 111.6 40 200S111.6 360 200 360S360 288.4 360 200S288.4 40 200 40z" : "M220 180C214.4 180 209.4 177.8 205.8 174.2L180 148.2V220C180 231 171 240 160 240S140 231 140 220V148.2L114.2 174.2C110.6 177.8 105.6 180 100 180C89 180 80 171 80 160C80 154.4 82.2 149.4 85.8 145.8L145.8 85.8C149.4 82.2 154.4 80 160 80S170.6 82.2 174.2 85.8L234.2 145.8C237.8 149.4 240 154.4 240 160C240 171 231 180 220 180zM160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM160 40C93.8 40 40 93.8 40 160S93.8 280 160 280S280 226.2 280 160S226.2 40 160 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CircleArrowDown.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CircleArrowDown.displayName = "Blueprint5.Icon.CircleArrowDown";
exports.default = CircleArrowDown;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iQpBM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleArrowLeft", ()=>CircleArrowLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CircleArrowLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "circle-arrow-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 220H148.2L194 265.8C197.8 269.4 200 274.4 200 280C200 291 191 300 180 300C174.4 300 169.4 297.8 165.8 294.2L85.8 214.2C82.2 210.6 80 205.6 80 200C80 194.4 82.2 189.4 85.8 185.8L165.8 105.8C169.4 102.2 174.4 100 180 100C191 100 200 109 200 120C200 125.6 197.8 130.6 194.2 134.2000000000001L148.2 180H300C311 180 320 189 320 200C320 211 311 220 300 220zM200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 40C111.6 40 40 111.6 40 200S111.6 360 200 360S360 288.4 360 200S288.4 40 200 40z" : "M220 180H148.2L174 205.8C177.8 209.4 180 214.4 180 220C180 231 171 240 160 240C154.4 240 149.4 237.8 145.8 234.2L85.8 174.2C82.2 170.6 80 165.6 80 160C80 154.4 82.2 149.4 85.8 145.8L145.8 85.8C149.4 82.2 154.4 80 160 80C171 80 180 89 180 100C180 105.6 177.8 110.6 174.2 114.2L148.2 140H220C231 140 240 149 240 160C240 171 231 180 220 180zM160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM160 40C93.8 40 40 93.8 40 160S93.8 280 160 280S280 226.2 280 160S226.2 40 160 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CircleArrowLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CircleArrowLeft.displayName = "Blueprint5.Icon.CircleArrowLeft";
exports.default = CircleArrowLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eFs0K":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleArrowRight", ()=>CircleArrowRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CircleArrowRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "circle-arrow-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M314.2000000000001 214.2L234.2 294.2000000000001C230.6 297.8 225.6 300 220 300C209 300 200 291 200 280C200 274.4 202.2 269.4 205.8 265.8L251.8 220H100C89 220 80 211 80 200C80 189 89 180 100 180H251.8L206 134.2000000000001C202.2 130.6 200 125.6 200 120C200 109 209 100 220 100C225.6 100 230.6 102.2 234.2 105.8L314.2000000000001 185.8C317.8 189.4 320 194.4 320 200C320 205.6 317.8 210.6 314.2000000000001 214.2zM200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 40C111.6 40 40 111.6 40 200S111.6 360 200 360S360 288.4 360 200S288.4 40 200 40z" : "M174.2 234.2C170.6 237.8 165.6 240 160 240C149 240 140 231 140 220C140 214.4 142.2 209.4 145.8 205.8L171.8 180H100C89 180 80 171 80 160C80 149 89 140 100 140H171.8L146 114.2C142.2 110.6 140 105.6 140 100C140 89 149 80 160 80C165.6 80 170.6 82.2 174.2 85.8L234.2 145.8C237.8 149.4 240 154.4 240 160C240 165.6 237.8 170.6 234.2 174.2L174.2 234.2zM160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM160 40C93.8 40 40 93.8 40 160S93.8 280 160 280S280 226.2 280 160S226.2 40 160 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CircleArrowRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CircleArrowRight.displayName = "Blueprint5.Icon.CircleArrowRight";
exports.default = CircleArrowRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7rgpT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleArrowUp", ()=>CircleArrowUp);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CircleArrowUp = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "circle-arrow-up",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 40C111.6 40 40 111.6 40 200S111.6 360 200 360S360 288.4 360 200S288.4 40 200 40zM214.2 314.2C210.6 317.8 205.6 320 200 320S189.4 317.8 185.8 314.2L105.8 234.2C102.2 230.6 100 225.6 100 220C100 209 109 200 120 200C125.6 200 130.6 202.2 134.2 205.8L180 251.8V100C180 89 189 80 200 80S220 89 220 100V251.8L265.8 206C269.4000000000001 202.2 274.4000000000001 200 280 200C291 200 300 209 300 220C300 225.6 297.8 230.6 294.2000000000001 234.2L214.2 314.2z" : "M174.2 234.2C170.6 237.8 165.6 240 160 240S149.4 237.8 145.8 234.2L85.8 174.2C82.2 170.6 80 165.6 80 160C80 149 89 140 100 140C105.6 140 110.6 142.2 114.2 145.8L140 171.8V100C140 89 149 80 160 80S180 89 180 100V171.8L205.8 146C209.4 142.2 214.4 140 220 140C231 140 240 149 240 160C240 165.6 237.8 170.6 234.2 174.2L174.2 234.2zM160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM160 40C93.8 40 40 93.8 40 160S93.8 280 160 280S280 226.2 280 160S226.2 40 160 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CircleArrowUp.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CircleArrowUp.displayName = "Blueprint5.Icon.CircleArrowUp";
exports.default = CircleArrowUp;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"igHuU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Circle", ()=>Circle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Circle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "circle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C90 400 0 310 0 200S90 0 200 0S400 90 400 200S310 400 200 400L200 400zM200 40C112 40 40 112 40 200S112 360 200 360S360 288 360 200S288 40 200 40L200 40z" : "M160 320C72 320 0 248 0 160S72 0 160 0S320 72 320 160S248 320 160 320L160 320zM160 40C94 40 40 94 40 160S94 280 160 280S280 226 280 160S226 40 160 40L160 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Circle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Circle.displayName = "Blueprint5.Icon.Circle";
exports.default = Circle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4SJGP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Citation", ()=>Citation);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Citation = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "citation",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 380C35.8 380 0 344.2 0 300S35.8 220 80 220C82 220 84 220.2 86 220.4C76.4 173.6 50.6 140 20 140C9 140 0 131 0 120C0 109 9 100 20 100C97.4 100 160 189.6 160 300C160 344.2 124.2 380 80 380zM320 380C275.8 380 240 344.2 240 300S275.8 220 320 220C322 220 324 220.2 326 220.4C316.4 173.6 290.6 140 260 140C249 140 240 131 240 120C240 109 249 100 260 100C337.4000000000001 100 400 189.6 400 300C400 344.2 364.2000000000001 380 320 380z" : "M300.4 220C300.4 253.2 273.6 280 240.4 280S180.4 253.2 180.4 220S207.2 160 240.4 160C244.6 160 248.6 160.4 252.4 161.2C242 124.8 222.8 100 200.4 100C189.4 100 180.4 91 180.4 80C180.4 69 189.4 60 200.4 60C255.6 60 300.4 122.6 300.4 200C300.4 204 300 207.8 299.6 211.6C299.8 214.4 300.4 217.2 300.4 220zM80.4 280C47.2 280 20.4 253.2 20.4 220S47.2 160 80.4 160C84.6 160 88.6 160.4 92.4 161.2C82 124.8 62.8 100 40.4 100C29.4 100 20.4 91 20.4 80C20.4 69 29.4 60 40.4 60C95.6 60 140.4 122.6 140.4 200C140.4 204 140 207.8 139.6 211.6C139.8 214.4 140.4 217.2 140.4 220C140.4 253.2 113.4 280 80.4 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Citation.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Citation.displayName = "Blueprint5.Icon.Citation";
exports.default = Citation;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"euT4d":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Clean", ()=>Clean);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Clean = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "clean",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140 400L100 300L0 260.0385184L100 220L140 120L180 220L280 259.8943316L180 300zM300 200L270 130.07389L200 100.102912L270 70.137224L300 0L330 70.137224L400 100L330 130.07389z" : "M240 160L216 104.07387L160 80.08233L216 56.137188L240 0L264 56.137188L320 80L264 104.07387zM100 320L70 250L0 220.102913L70 190L100 120L130 190L200 220L130 250z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Clean.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Clean.displayName = "Blueprint5.Icon.Clean";
exports.default = Clean;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lackh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Clip", ()=>Clip);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Clip = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "clip",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 380C0 391.0457 8.9543 400 20 400H120C131.0456 400 140 391.0457 140 380C140 368.9544 131.0456 360 120 360H40V280C40 268.9544 31.0456 260 20 260C8.9543 260 0 268.9544 0 280V380zM20 0C8.9543 0 0 8.954 0 20V120C0 131.046 8.9543 140 20 140C31.0456 140 40 131.046 40 120V40H120C131.0456 40 140 31.046 140 20C140 8.954 131.0456 0 120 0H20zM380 0C391.046 0 400 8.954 400 20V120C400 131.046 391.046 140 380 140C368.954 140 360 131.046 360 120V40H280C268.954 40 260 31.046 260 20C260 8.954 268.954 0 280 0H380zM380 400C391.046 400 400 391.0457 400 380V280C400 268.9544 391.046 260 380 260C368.954 260 360 268.9544 360 280V360H280C268.954 360 260 368.9544 260 380C260 391.0457 268.954 400 280 400H380zM200 120C244.182 120 280 155.818 280 200C280 244.1828 244.182 280 200 280C155.8172 280 120 244.1828 120 200C120 155.818 155.8172 120 200 120z" : "M0 300C0 311.0457 8.9543 320 20 320H100C111.0456 320 120 311.0457 120 300C120 288.9544 111.0456 280 100 280H40V220C40 208.9544 31.0456 200 20 200C8.9543 200 0 208.9544 0 220V300zM20 0C8.9543 0 0 8.954 0 20V100C0 111.046 8.9543 120 20 120C31.0456 120 40 111.046 40 100V40H100C111.0456 40 120 31.046 120 20C120 8.954 111.0456 0 100 0H20zM300 0C311.046 0 320 8.954 320 20V100C320 111.046 311.046 120 300 120C288.954 120 280 111.046 280 100V40H220C208.954 40 200 31.046 200 20C200 8.954 208.954 0 220 0H300zM300 320C311.046 320 320 311.0457 320 300V220C320 208.9544 311.046 200 300 200C288.954 200 280 208.9544 280 220V280H220C208.954 280 200 288.9544 200 300C200 311.0457 208.954 320 220 320H300zM160 100C193.137 100 220 126.863 220 160C220 193.137 193.137 220 160 220C126.863 220 100 193.137 100 160C100 126.863 126.863 100 160 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Clip.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Clip.displayName = "Blueprint5.Icon.Clip";
exports.default = Clip;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dSKoh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClipboardFile", ()=>ClipboardFile);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ClipboardFile = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "clipboard-file",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140 220C140 231.0456 148.9544 240 160 240H291.716C297.0200000000001 240 302.108 237.8928 305.858 234.1422L334.142 205.8578C337.892 202.1072 340 197.02 340 191.716V20C340 8.954 331.046 0 320 0H160C148.9544 0 140 8.954 140 20V220zM190 180C184.4772 180 180 175.522 180 170C180 164.478 184.4772 160 190 160H290C295.522 160 300 164.478 300 170C300 175.522 295.522 180 290 180H190zM190 120C184.4772 120 180 115.522 180 110C180 104.478 184.4772 100 190 100H290C295.522 100 300 104.478 300 110C300 115.522 295.522 120 290 120H190zM190 60C184.4772 60 180 55.522 180 50C180 44.478 184.4772 40 190 40H290C295.522 40 300 44.478 300 50C300 55.522 295.522 60 290 60H190zM240 361.1428C240 371.8286 231 380.57142 220 380.57142H204.4C197.4 392.22858 184.8 400 170 400C155.2 400 142.4 392.22858 135.6 380.57142H120C109 380.57142 100 371.8286 100 361.1428V340H240V361.1428zM260 320H80.7844V360H60C48.9544 360 40 351.0456 40 340V60C40 48.954 48.9544 40 60 40H120V240C120 251.0456 128.9542 260 140 260H300V340C300 351.0456 291.046 360 280 360H260V320z" : "M231.716 200C237.02 200 242.108 197.8928 245.858 194.1422L274.142 165.8578C277.892 162.1072 280 157.02 280 151.7158V20C280 8.954 271.046 0 260 0H140C128.9544 0 120 8.954 120 20V180C120 191.0456 128.9544 200 140 200H231.716zM160 140C154.4772 140 150 135.5228 150 130C150 124.4772 154.4772 120 160 120H240C245.522 120 250 124.4772 250 130C250 135.5228 245.522 140 240 140H160zM160 100C154.4772 100 150 95.522 150 90C150 84.478 154.4772 80 160 80H240C245.522 80 250 84.478 250 90C250 95.522 245.522 100 240 100H160zM160 60C154.4772 60 150 55.522 150 50C150 44.478 154.4772 40 160 40H240C245.522 40 250 44.478 250 50C250 55.522 245.522 60 240 60H160zM161.8178 301.81818C171.8178 301.81818 179.9996 293.6364 179.9996 283.6364V270H99.9996V283.6364C99.9996 293.6364 108.1814 301.81818 118.1814 301.81818H114.1814C120.3632 312.72728 126.5464 320 140.001 320C153.4556 320 159.6358 312.72728 165.8178 301.81818H161.8178zM200 279.9956H221.818C231.818 279.9956 240 271.8138 240 261.8138V220H120C108.9544 220 100 211.0456 100 200V39.996H58.1818C48.1818 39.996 40 48.178 40 58.178V261.8138C40 271.8138 48.1818 279.9956 58.1818 279.9956H80V249.9956H200V279.9956z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ClipboardFile.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ClipboardFile.displayName = "Blueprint5.Icon.ClipboardFile";
exports.default = ClipboardFile;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2F14D":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Clipboard", ()=>Clipboard);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Clipboard = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "clipboard",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260 360C260 371 251 380 240 380H224.4C217.4 392 204.8 400 190 400S162.4 392 155.6 380H140C129 380 120 371 120 360V320H260V360zM320 360H280V320V300H260H120H100V320V360H60C49 360 40 351 40 340V20C40 9 49 0 60 0H320C331 0 340 9 340 20V340C340 351 331 360 320 360z" : "M220 280C220 291 211 300 200 300H204.4C197.6 312 184.8 320 170 320S142.4 312 135.6 300H140C129 300 120 291 120 280V260H220V280zM260 280H240V240H100V280H80C69 280 60 271 60 260V20C60 9 69 0 80 0H260C271 0 280 9 280 20V260C280 271 271 280 260 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Clipboard.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Clipboard.displayName = "Blueprint5.Icon.Clipboard";
exports.default = Clipboard;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2tkYT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloudDownload", ()=>CloudDownload);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CloudDownload = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cloud-download",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 320C297.6 320 295.2 319.4 292.8 319.2C276.6 366.2 232.4 400 180 400C113.8 400 60 346.2 60 280C60 279 60.2 278.2 60.2 277.2C25.6 268.4 0 237.4 0 200C0 155.8 35.8 120 80 120H95.6C106.6 132.2 122.4 140 140 140V180C140 213.2 166.8 240 200 240S260 213.2 260 180V140C277.6 140 293.2 132.4 304 120.4C357.4000000000001 122.6 400 166.2 400 220C400 275.2 355.2000000000001 320 300 320zM260 100C254.4 100 249.4 97.8 245.8 94.2000000000001L220 68.2V180C220 191 211 200 200 200S180 191 180 180V68.2L154.2 94C150.6 97.8 145.6 100 140 100C129 100 120 91 120 80C120 74.4 122.2 69.4 125.8 65.8L185.8 5.8C189.4 2.2 194.4 0 200 0S210.6 2.2 214.2 5.8L274.2000000000001 65.8C277.8 69.4 280 74.4 280 80C280 91 271 100 260 100z" : "M220 100C214.4 100 209.4 97.8 205.8 94.2L180 68.2V160C180 171 171 180 160 180S140 171 140 160V68.2L114.2 94C110.6 97.8 105.6 100 100 100C89 100 80 91 80 80C80 74.4 82.2 69.4 85.8 65.8L145.8 5.8C149.4 2.2 154.4 0 160 0S170.6 2.2 174.2 5.8L234.2 65.8C237.8 69.4 240 74.4 240 80C240 91 231 100 220 100zM240 240C239.4 240 238.6 240 238 239.8C228.8 285.6 188.4 320 140 320C84.8 320 40 275.2 40 220C40 217.8 40.2 215.6 40.4 213.4C16.6 202.2 0 178 0 150C0 121.8 16.8 97.8 40.6 86.6C44 116.6 69.2 140 100 140C101.2 140 102.6 139.6 103.8 139.6C101.4 146 100 152.8 100 160C100 193.2 126.8 220 160 220S220 193.2 220 160C220 152.8 218.6 146 216.2 139.6C217.4 139.6 218.8 140 220 140C249.6 140 274 118.6 279 90.6C303.4 104.2 320 130 320 160C320 204.2 284.2000000000001 240 240 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CloudDownload.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CloudDownload.displayName = "Blueprint5.Icon.CloudDownload";
exports.default = CloudDownload;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lBPG0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloudServer", ()=>CloudServer);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CloudServer = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cloud-server",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M180 100H400V20H180V100zM240 60C240 48.954 231.046 40 220 40C208.954 40 200 48.954 200 60C200 71.046 208.954 80 220 80C231.046 80 240 71.046 240 60zM280 80C268.954 80 260 71.046 260 60C260 48.954 268.954 40 280 40H360C371.046 40 380 48.954 380 60C380 71.046 371.046 80 360 80H280zM295.68 299.568C297.12 299.784 298.56 300 300 300C348.352 300 388.724 265.627 397.996 220H180C168.9542 220 160 211.0456 160 200V100H80C35.8 100 0 135.8 0 180C0 217.4 25.6 248.4 60.2 257.2000000000001C60.2 257.7 60.15 258.15 60.1 258.6C60.05 259.05 60 259.5 60 260C60 326.2 113.8 380 180 380C232.4 380 276.6 346.2 292.8 299.2C293.76 299.28 294.7200000000001 299.424 295.68 299.568zM180 200H400V120H180V200zM240 160C240 148.954 231.046 140 220 140C208.954 140 200 148.954 200 160C200 171.046 208.954 180 220 180C231.046 180 240 171.046 240 160zM280 180C268.954 180 260 171.046 260 160C260 148.954 268.954 140 280 140H360C371.046 140 380 148.954 380 160C380 171.046 371.046 180 360 180H280z" : "M240 240C239.4 240 238.6 240 238 239.8C228.8 285.6 188.4 320 140 320C84.8 320 40 275.2 40 220C40 217.8 40.2 215.6 40.4 213.4C16.6 202.2 0 178 0 150C0 111.4 31.4 80 70 80H120V140C120 151.0458 128.9544 160 140 160H300C308.7320000000001 160 316.156 154.4042 318.884 146.6028C319.618 150.9588 320 155.4346 320 160C320 204.2 284.2000000000001 240 240 240zM140 140H300V80H140V140zM200 110C200 115.522 204.478 120 210 120H270C275.522 120 280 115.522 280 110C280 104.478 275.522 100 270 100H210C204.478 100 200 104.478 200 110zM180 110C180 104.478 175.5228 100 170 100C164.4772 100 160 104.478 160 110C160 115.522 164.4772 120 170 120C175.5228 120 180 115.522 180 110zM140 0V60H300V0H140zM200 30C200 35.522 204.478 40 210 40H270C275.522 40 280 35.522 280 30C280 24.478 275.522 20 270 20H210C204.478 20 200 24.478 200 30zM170 20C175.5228 20 180 24.478 180 30C180 35.522 175.5228 40 170 40C164.4772 40 160 35.522 160 30C160 24.478 164.4772 20 170 20z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CloudServer.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CloudServer.displayName = "Blueprint5.Icon.CloudServer";
exports.default = CloudServer;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b1Po0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloudTick", ()=>CloudTick);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CloudTick = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cloud-tick",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M295.68 319.568C294.7200000000001 319.424 293.76 319.28 292.8 319.2C276.6 366.2 232.4 400 180 400C113.8 400 60 346.2 60 280C60 279.5 60.05 279.05 60.1 278.6C60.15 278.15 60.2 277.7 60.2 277.2C25.6 268.4 0 237.4 0 200C0 155.8 35.8 120 80 120H103.4166C106.3048 128.19 111.0238 135.876 117.5736 142.426C141.005 165.858 178.995 165.858 202.426 142.426L220 124.852L317.574 222.4264C340.1760000000001 245.0286 376.324 245.8284 399.886 224.8258C397.3640000000001 277.7876 353.582 320 300 320C298.56 320 297.12 319.784 295.68 319.568zM234.142 25.858C226.332 18.048 213.668 18.048 205.858 25.858L145.8578 85.858C138.0474 93.668 138.0474 106.332 145.8578 114.142C153.6684 121.952 166.3316 121.952 174.1422 114.142L220 68.284L345.854 194.14C352.412 200.696 362.392 201.7512 370.0460000000001 197.3C371.5100000000001 196.448 372.8880000000001 195.396 374.142 194.142C380.976 187.308 381.83 176.758 376.704 168.996C375.972 167.886 375.118 166.834 374.142 165.858L234.142 25.858z" : "M238 239.8C238.6 240 239.4 240 240 240C278.294 240 310.282 213.128 318.148 177.2026C297.476 183.7416 273.964 178.8164 257.574 162.4264L200 104.852L182.4264 122.4264C158.995 145.8578 121.005 145.8578 97.5736 122.4264C85.8578 110.71 80 95.356 80 80H70C31.4 80 0 111.4 0 150C0 178 16.6 202.2 40.4 213.4C40.2 215.6 40 217.8 40 220C40 275.2 84.8 320 140 320C188.4 320 228.8 285.6 238 239.8zM315.294 132.8896C321.932 125.0316 321.548 113.264 314.142 105.858L214.142 5.858C206.332 -1.952 193.6684 -1.952 185.8578 5.858L125.8578 65.858C118.6986 73.018 118.1018 84.254 124.067 92.092C124.6096 92.806 125.2066 93.49 125.8578 94.142C133.6684 101.952 146.3316 101.952 154.1422 94.142L200 48.284L285.852 134.1356C293.662 141.946 306.332 141.9526 314.142 134.1422C314.548 133.7372 314.93 133.3192 315.294 132.8896z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CloudTick.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CloudTick.displayName = "Blueprint5.Icon.CloudTick";
exports.default = CloudTick;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4jfc3":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloudUpload", ()=>CloudUpload);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CloudUpload = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cloud-upload",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M214.2 194.2C210.6 197.8 205.6 200 200 200S189.4 197.8 185.8 194.2L125.8 134.2000000000001C122.2 130.6 120 125.6 120 120C120 109 129 100 140 100C145.6 100 150.6 102.2 154.2 105.8L180 131.8V20C180 9 189 0 200 0S220 9 220 20V131.8L245.8 106C249.4 102.2 254.4 100 260 100C271 100 280 109 280 120C280 125.6 277.8 130.6 274.2000000000001 134.2000000000001L214.2 194.2zM300 320C297.6 320 295.2 319.4 292.8 319.2C276.6 366.2 232.4 400 180 400C113.8 400 60 346.2 60 280C60 279 60.2 278.2 60.2 277.2C25.6 268.4 0 237.4 0 200C0 155.8 35.8 120 80 120C80 136.6 86.8 151.6 97.6 162.4L157.6 222.4C168.4 233.2 183.4 240 200 240S231.6 233.2 242.4000000000001 222.4L302.4000000000001 162.4L302.2000000000001 162.2C312.6 151.8 319.2000000000001 137.6 319.6 121.8C365.6 131.2 400 171.6 400 220C400 275.2 355.2000000000001 320 300 320z" : "M174.2 174.2C170.6 177.8 165.6 180 160 180S149.4 177.8 145.8 174.2L85.8 114.2C82.2 110.6 80 105.6 80 100C80 89 89 80 100 80C105.6 80 110.6 82.2 114.2 85.8L140 111.8V20C140 9 149 0 160 0S180 9 180 20V111.8L205.8 86C209.4 82.2 214.4 80 220 80C231 80 240 89 240 100C240 105.6 237.8 110.6 234.2 114.2L174.2 174.2zM240 240C239.4 240 238.6 240 238 239.8C228.8 285.6 188.4 320 140 320C84.8 320 40 275.2 40 220C40 217.8 40.2 215.6 40.4 213.4C16.6 202.2 0 178 0 150C0 121.4 17.2 96.8 41.8 86C40.8 90.6 40 95.2 40 100C40 116.6 46.8 131.6 57.6 142.4L117.6 202.4C128.4 213.2 143.4 220 160 220S191.6 213.2 202.4 202.4L262.4000000000001 142.4C273.2 131.6 280 116.6 280 100C280 96.8 279.6 93.6 279 90.6C303.4 104.4 320 130 320 160C320 204.2 284.2000000000001 240 240 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CloudUpload.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CloudUpload.displayName = "Blueprint5.Icon.CloudUpload";
exports.default = CloudUpload;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3wjtR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cloud", ()=>Cloud);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Cloud = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cloud",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 260C297.6 260 295.2 259.4 292.8 259.2C276.6 306.2 232.4 340 180 340C113.8 340 60 286.2 60 220C60 219 60.2 218.2 60.2 217.2C25.6 208.4 0 177.4 0 140C0 95.8 35.8 60 80 60H300C355.2 60 400 104.8 400 160S355.2000000000001 260 300 260z" : "M240 200C239.4 200 238.6 200 238 199.8C228.8 245.6 188.4 280 140 280C84.8 280 40 235.2 40 180C40 177.8 40.2 175.6 40.4 173.4C16.6 162.2 0 138 0 110C0 71.4 31.4 40 70 40H240C284.2000000000001 40 320 75.8 320 120C320 164.2 284.2000000000001 200 240 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Cloud.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Cloud.displayName = "Blueprint5.Icon.Cloud";
exports.default = Cloud;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"01P5q":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeBlock", ()=>CodeBlock);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CodeBlock = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "code-block",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 300H340V340C340 351 331 360 320 360H240C229 360 220 351 220 340V300H180V340C180 351 171 360 160 360H80C69 360 60 351 60 340V300H20C9 300 0 291 0 280V40C0 29 9 20 20 20H380C391 20 400 29 400 40V280C400 291 391 300 380 300zM174.2 94.2000000000001C177.8 90.6 180 85.6 180 80C180 69 171 60 160 60C154.4 60 149.4 62.2 145.8 65.8L65.8 145.8C62.2 149.4 60 154.4 60 160S62.2 170.6 65.8 174.2L145.8 254.2C149.4 257.8 154.4 260 160 260C171 260 180 251 180 240C180 234.4 177.8 229.4 174.2 225.8L108.2 160L174.2 94.2000000000001zM334.2000000000001 145.8L254.2 65.8C250.6 62.2 245.6 60 240 60C229 60 220 69 220 80C220 85.6 222.2 90.6 225.8 94.2000000000001L291.8 160L226 225.8C222.2 229.4 220 234.4 220 240C220 251 229 260 240 260C245.6 260 250.6 257.8 254.2 254.2L334.2000000000001 174.2C337.8 170.6 340 165.6 340 160S337.8 149.4 334.2000000000001 145.8z" : "M300 260H260V280C260 291 251 300 240 300H200C189 300 180 291 180 280V260H140V280C140 291 131 300 120 300H80C69 300 60 291 60 280V260H20C9 260 0 251 0 240V40C0 29 9 20 20 20H300C311 20 320 29 320 40V240C320 251 311 260 300 260zM134.2 94.2C137.8 90.6 140 85.6 140 80C140 69 131 60 120 60C114.4 60 109.4 62.2 105.8 65.8L45.8 125.8C42.2 129.4 40 134.4 40 140S42.2 150.6 45.8 154.2L105.8 214.2C109.4 217.8 114.4 220 120 220C131 220 140 211 140 200C140 194.4 137.8 189.4 134.2 185.8L88.2 140L134.2 94.2zM274.2000000000001 125.8L214.2 65.8C210.6 62.2 205.6 60 200 60C189 60 180 69 180 80C180 85.6 182.2 90.6 185.8 94.2L231.8 140L185.8 185.8C182.2 189.4 180 194.4 180 200C180 211 189 220 200 220C205.6 220 210.6 217.8 214.2 214.2L274.2000000000001 154.2C277.8 150.6 280 145.6 280 140S277.8 129.4 274.2000000000001 125.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CodeBlock.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CodeBlock.displayName = "Blueprint5.Icon.CodeBlock";
exports.default = CodeBlock;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f05tp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Code", ()=>Code);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Code = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "code",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 280C120 291 111 300 100 300C94.4 300 89.4 297.8 85.8 294.2L5.8 214.2C2.2 210.6 0 205.6 0 200C0 194.4 2.2 189.4 5.8 185.8L85.8 105.8C89.4 102.2 94.4 100 100 100C111 100 120 109 120 120C120 125.6 117.8 130.6 114.2 134.2000000000001L48.2 200L114 265.8C117.8 269.4 120 274.4 120 280zM240 360C230.8 360 223.4 353.8 221 345.4L141 65.4C140.6 63.6 140 62 140 60C140 49 149 40 160 40C169.2 40 176.6 46.2 179 54.6L259 334.6C259.4000000000001 336.4 260 338 260 340C260 351 251 360 240 360zM394.2000000000001 214.2L314.2000000000001 294.2000000000001C310.6 297.8 305.6 300 300 300C289 300 280 291 280 280C280 274.4 282.2 269.4 285.8 265.8L351.8 200L286 134.2000000000001C282.2 130.6 280 125.6 280 120C280 109 289 100 300 100C305.6 100 310.6 102.2 314.2000000000001 105.8L394.2000000000001 185.8C397.8 189.4 400 194.4 400 200C400 205.6 397.8 210.6 394.2000000000001 214.2z" : "M314.2000000000001 174.2L254.2 234.2C250.6 237.8 245.6 240 240 240C229 240 220 231 220 220C220 214.4 222.2 209.4 225.8 205.8L271.8 160L226 114.2C222.2 110.6 220 105.6 220 100C220 89 229 80 240 80C245.6 80 250.6 82.2 254.2 85.8L314.2000000000001 145.8C317.8 149.4 320 154.4 320 160C320 165.6 317.8 170.6 314.2000000000001 174.2zM100 220C100 231 91 240 80 240C74.4 240 69.4 237.8 65.8 234.2L5.8 174.2C2.2 170.6 0 165.6 0 160C0 154.4 2.2 149.4 5.8 145.8L65.8 85.8C69.4 82.2 74.4 80 80 80C91 80 100 89 100 100C100 105.6 97.8 110.6 94.2 114.2L48.2 160L94 205.8C97.8 209.4 100 214.4 100 220zM180 280C170.4 280 162.6 273 160.8 263.8L120.8 63.8C120.6 62.6 120 61.4 120 60C120 49 129 40 140 40C149.6 40 157.4 47 159.2 56.2L199.2 256.2C199.4 257.4 200 258.6 200 260C200 271 191 280 180 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Code.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Code.displayName = "Blueprint5.Icon.Code";
exports.default = Code;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9eIfa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cog", ()=>Cog);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Cog = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cog",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 240H333.8C331 249.2 327.2000000000001 257.8 322.6 266L356.6 300C364.4000000000001 307.8 364.4000000000001 320.4 356.6 328.2L328.4000000000001 356.4C320.6 364.2 308.0000000000001 364.2 300.2000000000001 356.4L266.2000000000001 322.4C258.0000000000001 326.8 249.4000000000001 330.6 240.2000000000001 333.4V380C240.2000000000001 391 231.2000000000001 400 220.2000000000001 400H180C169 400 160 391 160 380V333.4C150.4 330.6 141.2 326.6 132.6 321.8L100 354.4C92.6 361.8 80.4 361.8 72.8 354.4L45.6 327.2C38.2 319.6 38.2 307.4 45.6 300L78 267.6C73.2 258.8 69.2 249.8 66.2 240H20C9 240 0 231 0 220V180C0 169 9 160 20 160H66.2C69 150.8 72.8 142.2 77.4 134L43.4 100C35.6 92.2 35.6 79.6 43.4 71.8L71.6 43.6C79.4 35.8 92 35.8 99.8 43.6L133.8 77.6C142 73.2 150.6 69.4 159.8 66.6V20C159.8 9 168.8 0 179.8 0H219.8C230.8 0 239.8 9 239.8 20V66.6C249.4 69.4 258.6 73.6 267.2 78.4L300 45.6C307.4 38.2 319.6 38.2 327.2 45.6L354.4 72.8C361.8 80.2 361.8 92.4 354.4 100L322 132.4C326.8 141 331 150.2000000000001 334 160H380C391 160 400 169 400 180V220C400 231 391 240 380 240zM200 120C155.8 120 120 155.8 120 200C120 244.2 155.8 280 200 280S280 244.2 280 200C280 155.8 244.2 120 200 120z" : "M303.8 192.2H266.8C264.6 199.6 261.4 206.4 257.8 213L285 240.2C291.2 246.4000000000001 291.2 256.6 285 262.8L262.4000000000001 285.4C256.2 291.6 246 291.6 239.8000000000001 285.4L212.6000000000001 258.2C206 261.6 199.2 264.8 191.8 267V304.2C191.8 313 184.6 320.2 175.8 320.2H143.8C135 320.2 127.8 313 127.8 304.2V267C120 264.6 112.8 261.4 105.8 257.6L79.8 283.6C73.8 289.6 64 289.6 58 283.6L36.4 261.8C30.4 255.8 30.4 246 36.4 240L62.4 214C58.4 207.2 55.2 200 52.8 192.2H15.8C7 192.2 -0.2 185 -0.2 176.2V144.2C-0.2 135.4 7 128.2 15.8 128.2H52.8C55 120.8 58.2 114 61.8 107.4L34.6 80.2000000000001C28.4 74 28.4 63.8 34.6 57.6L57.2 35.0000000000001C63.4 28.8000000000001 73.6 28.8000000000001 79.8 35.0000000000001L107 62.2000000000001C113.6 58.6000000000001 120.4 55.6000000000001 127.8 53.4000000000001V16.2000000000001C127.8 7.4000000000001 135 0.2 143.8 0.2H175.8C184.6 0.2 191.8000000000001 7.4 191.8000000000001 16.2000000000001V53.4000000000001C199.6000000000001 55.8000000000001 206.8000000000001 59.0000000000001 213.8 62.8000000000001L239.8000000000001 36.8000000000001C245.8000000000001 30.8000000000001 255.6 30.8000000000001 261.6 36.8000000000001L283.4000000000001 58.6000000000001C289.4000000000001 64.6000000000001 289.4000000000001 74.4 283.4000000000001 80.4000000000001L257.4000000000001 106.4000000000001C261.2 113.4000000000001 264.6 120.6000000000001 267 128.4000000000001H304C312.8 128.4000000000001 320 135.6000000000001 320 144.4000000000001V176.4000000000001C319.8 185 312.6 192.2 303.8 192.2zM159.8 100.2C126.6 100.2 99.8 127 99.8 160.2S126.6 220.2 159.8 220.2S219.8 193.4 219.8 160.2S193 100.2 159.8 100.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Cog.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Cog.displayName = "Blueprint5.Icon.Cog";
exports.default = Cog;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g9MuN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CollapseAll", ()=>CollapseAll);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CollapseAll = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "collapse-all",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M185.8 225.8C189.4 222.2 194.4 220 200 220S210.6 222.2 214.2 225.8L334.2000000000001 345.8C337.8 349.4 340 354.4 340 360C340 371 331 380 320 380C314.4000000000001 380 309.4000000000001 377.8 305.8 374.2L200 268.2L94.2 374.2C90.6 377.8 85.6 380 80 380C69 380 60 371 60 360C60 354.4 62.2 349.4 65.8 345.8L185.8 225.8zM214.2 174.2C210.6 177.8 205.6 180 200 180S189.4 177.8 185.8 174.2L65.8 54.2C62.2 50.6 60 45.6 60 40C60 29 69 20 80 20C85.6 20 90.6 22.2 94.2 25.8L200 131.8L305.8 26C309.4000000000001 22.2 314.4000000000001 20 320 20C331 20 340 29 340 40C340 45.6 337.8 50.6 334.2000000000001 54.2L214.2 174.2z" : "M145.8 185.8C149.4 182.2 154.4 180 160 180S170.6 182.2 174.2 185.8L254.2 265.8C257.8 269.4 260 274.4 260 280C260 291 251 300 240 300C234.4 300 229.4 297.8 225.8 294.2L160 228.2L94.2 294.2C90.6 297.8 85.6 300 80 300C69 300 60 291 60 280C60 274.4 62.2 269.4 65.8 265.8L145.8 185.8zM174.2 134.2C170.6 137.8 165.6 140 160 140S149.4 137.8 145.8 134.2L65.8 54.2C62.2 50.6 60 45.6 60 40C60 29 69 20 80 20C85.6 20 90.6 22.2 94.2 25.8L160 91.8L225.8 26C229.4 22.2 234.4 20 240 20C251 20 260 29 260 40C260 45.6 257.8 50.6 254.2 54.2L174.2 134.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CollapseAll.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CollapseAll.displayName = "Blueprint5.Icon.CollapseAll";
exports.default = CollapseAll;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6hKJM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorFill", ()=>ColorFill);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ColorFill = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "color-fill",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M43.7636 220L283.432 220L160 343.4314L68.2842 251.7158C56.2248 239.6562 48.103 230.3902 43.7636 220zM160 400L131.7158 371.7158L40 280C20 260 0 237.8048 0 200C0 160 20 140 40 120L60 100C80 80 100 60 140 60C180.1766 60 198.3614 78.268 217.352 97.344L217.352 97.344L220 100L311.716 191.716L340 220L311.716 248.2842L188.2842 371.7158L160 400zM370 130L340 180L310 130C303.646 119.41 300 110 300 100C300 80 310 60 340 60C370 60 380 80 380 100C380 110 376.354 119.41 370 130zM20 40C8.9543 40 0 31.046 0 20C0 8.954 8.9543 0 20 0H380C391.046 0 400 8.954 400 20C400 31.046 391.046 40 380 40H20z" : "M61.8638 180C62.2002 180.9846 62.5838 181.9852 63.0158 182.9932C65.1466 187.9652 67.5152 190.9466 68.2842 191.7158L140 263.4314L223.432 180L61.8638 180zM130 60C150 60 179.9998 80 189.9998 90L251.716 151.7158L280 180L251.716 208.2842L168.2842 291.7158L140 320L111.7158 291.7158L40 220C30 210 20 190 20 170C20 150 30 130 40 120L80 80C90 70 110 60 130 60zM270 140L292.5 106.666C297.266 99.606 300 93.334 300 86.666C300 73.334 292.5 60 270 60C247.5 60 240 73.334 240 86.666C240 93.334 242.734 99.606 247.5 106.666L270 140zM0 20C0 31.046 8.9543 40 20 40H300C311.046 40 320 31.046 320 20C320 8.954 311.046 0 300 0H20C8.9543 0 0 8.954 0 20z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ColorFill.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ColorFill.displayName = "Blueprint5.Icon.ColorFill";
exports.default = ColorFill;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jUIro":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColumnLayout", ()=>ColumnLayout);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ColumnLayout = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "column-layout",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 380H20C9 380 0 371 0 360V40C0 29 9 20 20 20H380C391 20 400 29 400 40V360C400 371 391 380 380 380zM100 60H40V340H100V60zM180 60H120V340H180V60zM360 60H200V340H360V60z" : "M300 300H20C9 300 0 291 0 280V40C0 29 9 20 20 20H300C311 20 320 29 320 40V280C320 291 311 300 300 300zM80 60H40V260H80V60zM140 60H100V260H140V60zM280 60H160V260H280V60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ColumnLayout.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ColumnLayout.displayName = "Blueprint5.Icon.ColumnLayout";
exports.default = ColumnLayout;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eOEIG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Comment", ()=>Comment);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Comment = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "comment",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 380H20C9 380 0 371 0 360V120C0 109 9 100 20 100H80V20C80 9 89 0 100 0C105.6 0 110.6 2.2 114.2 5.8L208.2 100H380C391 100 400 109 400 120V360C400 371 391 380 380 380zM80 200C58 200 40 218 40 240C40 262 58 280 80 280S120 262 120 240C120 218 102 200 80 200zM200 200C178 200 160 218 160 240C160 262 178 280 200 280S240 262 240 240C240 218 222 200 200 200zM320 200C298 200 280 218 280 240C280 262 298 280 320 280S360 262 360 240C360 218 342 200 320 200z" : "M280 300H20C9 300 0 291 0 280V100C0 89 9 80 20 80H60V20C60 9 69 0 80 0C85.6 0 90.6 2.2 94.2 5.8L168.2 80H280C291 80 300 89 300 100V280C300 291 291 300 280 300zM70 160C53.4 160 40 173.4 40 190S53.4 220 70 220S100 206.6 100 190S86.6 160 70 160zM150 160C133.4 160 120 173.4 120 190S133.4 220 150 220S180 206.6 180 190S166.6 160 150 160zM230 160C213.4 160 200 173.4 200 190S213.4 220 230 220S260 206.6 260 190S246.6 160 230 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Comment.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Comment.displayName = "Blueprint5.Icon.Comment";
exports.default = Comment;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lRl7q":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Comparison", ()=>Comparison);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Comparison = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "comparison",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 240H20C9 240 0 231 0 220V180C0 169 9 160 20 160H120C131 160 140 169 140 180V220C140 231 131 240 120 240zM380 360H280C269 360 260 351 260 340V300C260 289 269 280 280 280H380C391 280 400 289 400 300V340C400 351 391 360 380 360zM380 300H280V340H380V300zM120 120H20C9 120 0 111 0 100V60C0 49 9 40 20 40H120C131 40 140 49 140 60V100C140 111 131 120 120 120zM120 360H20C9 360 0 351 0 340V300C0 289 9 280 20 280H120C131 280 140 289 140 300V340C140 351 131 360 120 360zM200 400C189 400 180 391 180 380V20C180 9 189 0 200 0S220 9 220 20V380C220 391 211 400 200 400zM380 120H280C269 120 260 111 260 100V60C260 49 269 40 280 40H380C391 40 400 49 400 60V100C400 111 391 120 380 120zM380 60H280V100H380V60zM380 240H280C269 240 260 231 260 220V180C260 169 269 160 280 160H380C391 160 400 169 400 180V220C400 231 391 240 380 240zM380 180H280V220H380V180z" : "M159.8 320.2C148.8 320.2 139.8 311.2 139.8 300.2V20.2C139.8 9.2 148.8 0.2 159.8 0.2S179.8 9.2 179.8 20.2V300.2C179.8 311.2 170.8 320.2 159.8 320.2zM99.8 260.2H19.8C8.8 260.2 -0.2 251.2 -0.2 240.2V200.2C-0.2 189.2 8.8 180.2 19.8 180.2H99.8C110.8 180.2 119.8 189.2 119.8 200.2V240.2C119.8 251.2 110.8 260.2 99.8 260.2zM299.8 260.2H219.8C208.8 260.2 199.8 251.2 199.8 240.2V200.2C199.8 189.2 208.8 180.2 219.8 180.2H299.8C310.8 180.2 319.8 189.2 319.8 200.2V240.2C319.8 251.2 310.8 260.2 299.8 260.2zM299.8 200.2H219.8V240.2H299.8V200.2zM299.8 140.2H219.8C208.8 140.2 199.8 131.2 199.8 120.2V80.2C199.8 69.2 208.8 60.2 219.8 60.2H299.8C310.8 60.2 319.8 69.2 319.8 80.2V120.2C319.8 131.2 310.8 140.2 299.8 140.2zM299.8 80.2H219.8V120.2H299.8V80.2zM99.8 140.2H19.8C8.8 140.2 -0.2 131.2 -0.2 120.2V80.2C-0.2 69.2 8.8 60.2 19.8 60.2H99.8C110.8 60.2 119.8 69.2 119.8 80.2V120.2C119.8 131.2 110.8 140.2 99.8 140.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Comparison.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Comparison.displayName = "Blueprint5.Icon.Comparison";
exports.default = Comparison;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9vwe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Compass", ()=>Compass);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Compass = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "compass",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 200C300 197.2 299.4000000000001 194.4 298.2 192L298.2 192L218.4 12.4C218.4 12.4 218.4 12.4 218.4 12.4L218.2 11.9999999999999L218.2 11.9999999999999C215.2 5 208.2 0 200 0S184.8 5 181.8 12L181.8 12L181.6 12.4C181.6 12.4 181.6 12.4 181.6 12.4L101.8 192L101.8 192C100.6 194.4 100 197.2 100 200S100.6 205.6 101.8 208L101.8 208L181.6 387.6C181.6 387.6 181.6 387.6 181.6 387.6L181.8 388L181.8 388C184.8 395 191.8 400 200 400S215.2 395 218.2 388L218.2 388L218.4 387.6C218.4 387.6 218.4 387.6 218.4 387.6L298.2 208L298.2 208C299.4000000000001 205.6 300 202.8 300 200zM200 330.8L141.8 200H258L200 330.8z" : "M240 160C240 157.2 239.4 154.6 238.4 152.2L238.4 152.2L178.4 12.4C178.4 12.4 178.4 12.4 178.4 12.4L178.4 12.4L178.4 12.4C175.4 5 168.2 0 160 0S144.6 5 141.6 12.2L141.6 12.2L141.6 12.2C141.6 12.2 141.6 12.2 141.6 12.2L81.6 152L81.6 152C80.6 154.6 80 157.2 80 160S80.6 165.4 81.6 167.8L81.6 167.8L141.6 307.6C141.6 307.6 141.6 307.6 141.6 307.6L141.6 307.6L141.6 307.6C144.6 315 151.8 320 160 320S175.4 315 178.4 307.8L178.4 307.8L178.4 307.8C178.4 307.8 178.4 307.8 178.4 307.8L238.4 168L238.4 168C239.4 165.4 240 162.8 240 160zM160 249.2L121.8 160H198.2L160 249.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Compass.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Compass.displayName = "Blueprint5.Icon.Compass";
exports.default = Compass;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ltCe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Compressed", ()=>Compressed);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Compressed = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "compressed",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M397.8 268.8L397.8 268.8L338 388.8L337.8 388.8C334.4 395.4 327.8 400 320 400H80C72.2 400 65.6 395.4 62.2 388.8L62 388.8L2 268.8L2.2 268.8C1 266.2 0 263.2 0 260V20C0 9 9 0 20 0H380C391 0 400 9 400 20V260C400 263.2 399 266.2 397.8 268.8zM220 360H307.6L347.6 280H220V360zM92.4 360H180V280H52.4L92.4 360zM360 40H40V240H180V148.2L134.2 194C130.6 197.8 125.6 200 120 200C109 200 100 191 100 180C100 174.4 102.2 169.4 105.8 165.8L185.8 85.8C189.4 82.2 194.4 80 200 80S210.6 82.2 214.2 85.8L294.2000000000001 165.8C297.8 169.4 300 174.4 300 180C300 191 291 200 280 200C274.4000000000001 200 269.4000000000001 197.8 265.8 194.2L220 148.2V240H360V40z" : "M318.6 207.4L318.6 207.4L318.6 207.8C318.6 207.8 318.6 207.8 318.6 207.8L278.8 307.4L278.8 307.4C275.6 314.8 268.4 320 260 320H60C51.6 320 44.4 314.8 41.4 307.4L41.4 307.4L1.6 207.8C1.6 207.8 1.6 207.8 1.6 207.8L1.4 207.4L1.4 207.4C0.6 205.2 0 202.6 0 200V20C0 9 9 0 20 0H300C311 0 320 9 320 20V200C320 202.6 319.4000000000001 205.2 318.6 207.4zM180 280H246.4L270.4 220H180V280zM73.6 280H140V220H49.6L73.6 280zM280 40H40V180H140V128.2L114.2 154.2C110.6 157.8 105.6 160 100 160C89 160 80 151 80 140C80 134.4 82.2 129.4 85.8 125.8L145.8 65.8C149.4 62.2 154.4 60 160 60S170.6 62.2 174.2 65.8L234.2 125.8C237.8 129.4 240 134.4 240 140C240 151 231 160 220 160C214.4 160 209.4 157.8 205.8 154.2L180 128.2V180H280V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Compressed.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Compressed.displayName = "Blueprint5.Icon.Compressed";
exports.default = Compressed;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Sd58":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Confirm", ()=>Confirm);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Confirm = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "confirm",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M194.2 294.2C190.6 297.8 185.6 300 180 300C169 300 160 291 160 280C160 274.4 162.2 269.4 165.8 265.8L225.8 205.8C229.4 202.2 234.4 200 240 200S250.6 202.2 254.2 205.8L394.2000000000001 345.8C397.8 349.4 400 354.4 400 360C400 371 391 380 380 380C374.4 380 369.4 377.8 365.8 374.2L240 248.2L194.2 294.2zM352.8 247.8C357.4000000000001 232.8 360 216.6 360 200C360 111.6 288.4 40 200 40S40 111.6 40 200S111.6 360 200 360C227.6 360 253.4 353 276 340.8L305.2000000000001 370C274.6 388.8 238.6 400 200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 228 394.2000000000001 254.6 383.8 279L352.8 247.8z" : "M174 234.2C170.4 238 165.4 240.2 159.8 240.2C148.8 240.2 139.8 231.2 139.8 220.2C139.8 214.6 142 209.6 145.6 206L185.6 166C189.2 162.4 194.2 160.2 199.8000000000001 160.2S210.4 162.4 214.0000000000001 166L314.0000000000001 266C317.6 269.6 319.8000000000001 274.6 319.8000000000001 280.2C319.8000000000001 291.2 310.8000000000001 300.2 299.8000000000001 300.2C294.2000000000001 300.2 289.2000000000001 298 285.6 294.4L199.8 208.4L174 234.2zM278.4 174C279 169.4 279.8 165 279.8 160.2C279.8 94 226 40.2 159.8 40.2S39.8 94 39.8 160.2S93.6 280.2 159.8 280.2C176 280.2 191.6 276.8 205.8 271L235.8 301C213.2 313.2 187.4 320.2 159.8 320.2C71.4 320.2 -0.2 248.6 -0.2 160.2S71.4 0.2 159.8 0.2S319.8 71.8 319.8 160.2C319.8 176.8 317.2 193 312.6 208L278.4 174z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Confirm.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Confirm.displayName = "Blueprint5.Icon.Confirm";
exports.default = Confirm;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bn2my":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Console", ()=>Console);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Console = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "console",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 20H20C9 20 0 29 0 40V360C0 371 9 380 20 380H380C391 380 400 371 400 360V40C400 29 391 20 380 20zM360 280H40V60H360V280zM80 240C85.6 240 90.6 237.8 94.2 234.2L94.2 234.2L134.2 194.2L134.2 194.2C137.8 190.6 140 185.6 140 180S137.8 169.4 134.2 165.8L134.2 165.8L94.2 125.8L94.2 125.8C90.6 122.2 85.6 120 80 120C69 120 60 129 60 140C60 145.6 62.2 150.6 65.8 154.2L65.8 154.2L91.8 180L65.8 205.8L65.8 205.8C62.2 209.4 60 214.4 60 220C60 231 69 240 80 240zM180 160H240C251 160 260 151 260 140C260 129 251 120 240 120H180C169 120 160 129 160 140C160 151 169 160 180 160z" : "M300 20H20C9 20 0 29 0 40V280C0 291 9 300 20 300H300C311 300 320 291 320 280V40C320 29 311 20 300 20zM280 220H40V60H280V220zM80 200C85.6 200 90.6 197.8 94.2 194.2L94.2 194.2L134.2 154.2L134.2 154.2C137.8 150.6 140 145.6 140 140S137.8 129.4 134.2 125.8L134.2 125.8L94.2 85.8L94.2 85.8C90.6 82.2 85.6 80 80 80C69 80 60 89 60 100C60 105.6 62.2 110.6 65.8 114.2L65.8 114.2L91.8 140L65.8 165.8L65.8 165.8C62.2 169.4 60 174.4 60 180C60 191 69 200 80 200zM180 120H240C251 120 260 111 260 100S251 80 240 80H180C169 80 160 89 160 100S169 120 180 120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Console.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Console.displayName = "Blueprint5.Icon.Console";
exports.default = Console;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8jLQ3":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Contrast", ()=>Contrast);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Contrast = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "contrast",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 240H354.8C351 254.6 345.2 268.4 337.8 281.2000000000001L356.6 300C364.4 307.8 364.4 320.4 356.6 328.2L328.4 356.4C320.6 364.2 308 364.2 300.2 356.4L281.4 337.6C268.4 345.2 254.6 351 240 354.8V380C240 391 231 400 220 400H180C169 400 160 391 160 380V354.8C144.8 350.8 130.6 344.8 117.4 337L100 354.4C92.6 361.8 80.4 361.8 72.8 354.4L45.6 327.2C38.2 319.6 38.2 307.6 45.6 300L63 282.6C55.2 269.4 49.2 255.2 45.2 240H20C9 240 0 231 0 220V180C0 169 9 160 20 160H45.2C49 145.4 54.8 131.6 62.2 118.8L43.4 100C35.6 92.2 35.6 79.6 43.4 71.8L71.6 43.6C79.4 35.8 92 35.8 99.8 43.6L118.6 62.4C131.4 54.8000000000001 145.2 49.2 159.8 45.4V20C159.8 9 168.8 0 179.8 0H219.8C230.8 0 239.8 9 239.8 20V45.2C255 49.2 269.2000000000001 55.2 282.4000000000001 63.0000000000001L300 45.6C307.4 38.2 319.6 38.2 327.2 45.6L354.4 72.8C361.8 80.4 361.8 92.4 354.4 100L337 117.4C345 130.4 351 144.8 354.8 160H380C391 160 400 169 400 180V220C400 231 391 240 380 240zM200 100C144.8 100 100 144.8 100 200S144.8 300 200 300V100z" : "M304 192H275.2C272.6 201.4 268.8 210.4 264 218.8L285.2 240C291.4 246.2 291.4 256.4 285.2 262.6L262.6 285.2C256.4 291.4 246.2 291.4 240 285.2L218.8 264C210.4 268.8 201.6 272.4 192 275.2V304C192 312.8 184.8 320 176 320H144C135.2 320 128 312.8 128 304V275.2C118 272.4 108.8 268.4 100 263.4L80 283.4C74 289.4 64.2 289.4 58.2 283.4L36.6 261.8C30.6 255.8 30.6 246 36.6 240L56.6 220C51.6 211.2 47.6 202 44.8 192H16C7.2 192 0 184.8 0 176V144C0 135.2 7.2 128 16 128H44.8C47.4 118.6 51.2 109.6 56 101.2L34.8 80C28.6 73.8 28.6 63.6 34.8 57.4L57.4 34.8000000000001C63.6 28.6 73.8 28.6 80 34.8000000000001L101.2 56.0000000000001C109.6 51.2 118.4 47.6 128 44.8000000000001V16.0000000000001C128 7.2 135.2 1e-13 144 1e-13H176C184.8 1e-13 192 7.2 192 16.0000000000001V44.8000000000001C202 47.6 211.2000000000001 51.4 220 56.6L240.0000000000001 36.6C246.0000000000001 30.6 255.8000000000001 30.6 261.8 36.6L283.6 58.4C289.6 64.4 289.6 74.2 283.6 80.2000000000001L263.6 100.2000000000001C268.6 108.8 272.6 118.2000000000001 275.4000000000001 128.2000000000001H304.2000000000001C313 128.2000000000001 320.2000000000001 135.4 320.2000000000001 144.2000000000001V176C320 184.8 312.8 192 304 192zM160 80C115.8 80 80 115.8 80 160C80 204.2 115.8 240 160 240V80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Contrast.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Contrast.displayName = "Blueprint5.Icon.Contrast";
exports.default = Contrast;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4nx42":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Control", ()=>Control);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Control = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "control",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 200H200V60H340V200zM340 340H200V220H340V340zM180 340H60V60H180V340zM380 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM360 40H40V360H360V40z" : "M260 160H160V60H260V160zM260 260H160V180H260V260zM300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM280 40H40V280H280V40zM140 260H60V60H140V260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Control.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Control.displayName = "Blueprint5.Icon.Control";
exports.default = Control;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67HkW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreditCard", ()=>CreditCard);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CreditCard = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "credit-card",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 340H20C9 340 0 331 0 320V280H400V320C400 331 391 340 380 340zM0 80C0 69 9 60 20 60H380C391 60 400 69 400 80V240H0V80zM130 120H270C275.6 120 280 115.6 280 110C280 104.4 275.6 100 270 100H130C124.4 100 120 104.4 120 110C120 115.6 124.4 120 130 120zM50 120H90C95.6 120 100 115.6 100 110C100 104.4 95.6 100 90 100H50C44.4 100 40 104.4 40 110C40 115.6 44.4 120 50 120z" : "M299.8 261H19.8C8.8 261 -0.2 252 -0.2 241V221H319.8V241C319.8 252 310.8 261 299.8 261zM-0.2 61C-0.2 50 8.8 41 19.8 41H299.8C310.8 41 319.8 50 319.8 61V181H-0.2C-0.2 181 -0.2 61 -0.2 61zM109.8 101H209.8C215.4 101 219.8 96.6 219.8 91S215.4 81 209.8 81H109.8C104.2 81 99.8 85.4 99.8 91S104.4 101 109.8 101zM49.8 101H69.8C75.4 101 79.8 96.6 79.8 91S75.4 81 69.8 81H49.8C44.2 81 39.8 85.4 39.8 91S44.4 101 49.8 101z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CreditCard.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CreditCard.displayName = "Blueprint5.Icon.CreditCard";
exports.default = CreditCard;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5a0rO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Crop", ()=>Crop);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Crop = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "crop",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 20C280 8.954 288.954 0 300 0C311.046 0 320 8.954 320 20L320 80L380 80C391.046 80 400 88.954 400 100C400 111.046 391.046 120 380 120L120 120L120 380.00002C120 391.04574 111.0458 400.0000252612 100 400.0000262268C88.9544 400.0000271924 80 391.04576 80 380.00002L80 320L20 320C8.95434 320 0.0000271924 311.0458 0.0000262268 300C0.0000252612 288.9544 8.95434 280 20 280L80 280L80 100C80 88.954 88.9544 80 100 80L280 80L280 20zM300 320L160 320L160 280L280 280L280 160L320 160L320 300.0002C320 311.0458 311.046 320 300 320zM0 400H400V0H0V400z" : "M220 20C220 8.954 228.954 0 240 0C251.046 0 260 8.954 260 20V60H300C311.046 60 320 68.954 320 80C320 91.046 311.046 100 300 100H100.0002V300C100.0002 311.0457 91.0458 319.999999034354 80.0002 320C68.9544 320.000000965646 60.0002 311.04568 60.0002 300L60.0002 260L20.0002 260C8.95444 260 0.0001154066 251.0456 0.000152588 240C0.0001516224 228.9542 8.95444 220 20.0002 220L60.0002 220L60.0002 80C60.0002 68.954 68.9544 60 80.0002 60H220V20zM240 260.0002L120.0002 260.0002V220.0002L220 220.0002L220 120H260L260 240.0002C260 251.0458 251.046 260.0002 240 260.0002z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Crop.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Crop.displayName = "Blueprint5.Icon.Crop";
exports.default = Crop;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"crplJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CrossCircle", ()=>CrossCircle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CrossCircle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cross-circle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 0C310.456 0 400 89.544 400 200C400 310.457 310.456 400 200 400C89.543 400 0 310.457 0 200C0 89.544 89.543 0 200 0zM294 265.8L228.2 200L294.2000000000001 134.2000000000001C297.8 130.6 300 125.6 300 120C300 109 291 100 280 100C274.4000000000001 100 269.4000000000001 102.2 265.8 106L200 171.8L134.2 105.8C130.6 102.2 125.6 100 120 100C109 100 100 109 100 120C100 125.6 102.2 130.6 106 134.2000000000001L171.8 200L105.8 265.8C102.2 269.4 100 274.4 100 280C100 291 109 300 120 300C125.6 300 130.6 297.8 134.2 294.2L200 228.2L265.8 294.2C269.4000000000001 297.8 274.4000000000001 300 280 300C291 300 300 291 300 280C300 274.4 297.8 269.4 294 265.8z" : "M160 0C248.366 0 320 71.634 320 160C320 248.3656 248.366 320 160 320C71.6344 320 0 248.3656 0 160C0 71.634 71.6344 0 160 0zM234 205.8L188.2 160L234.2 114.2C237.8 110.6 240 105.6 240 100C240 89 231 80 220 80C214.4 80 209.4 82.2 205.8 86L160 131.8L114.2 85.8C110.6 82.2 105.6 80 100 80C89 80 80 89 80 100C80 105.6 82.2 110.6 86 114.2L131.8 160L85.8 205.8C82.2 209.4 80 214.4 80 220C80 231 89 240 100 240C105.6 240 110.6 237.8 114.2 234.2L160 188.2L205.8 234.2C209.4 237.8 214.4 240 220 240C231 240 240 231 240 220C240 214.4 237.8 209.4 234 205.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CrossCircle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CrossCircle.displayName = "Blueprint5.Icon.CrossCircle";
exports.default = CrossCircle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eW4sq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cross", ()=>Cross);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Cross = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cross",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M228.2 200L314 285.8C317.8 289.4 320 294.4 320 300C320 311 311 320 300 320C294.4000000000001 320 289.4000000000001 317.8 285.8 314.2L200 228.2L114.2 314.2C110.6 317.8 105.6 320 100 320C89 320 80 311 80 300C80 294.4 82.2 289.4 85.8 285.8L171.8 200L86 114.2000000000001C82.2 110.6 80 105.6 80 100C80 89 89 80 100 80C105.6 80 110.6 82.2 114.2 85.8L200 171.8L285.8 86C289.4000000000001 82.2 294.4000000000001 80 300 80C311 80 320 89 320 100C320 105.6 317.8 110.6 314.2000000000001 114.2000000000001L228.2 200z" : "M188.2 160L254 225.8C257.8 229.4 260 234.4 260 240C260 251 251 260 240 260C234.4 260 229.4 257.8 225.8 254.2L160 188.2L94.2 254.2C90.6 257.8 85.6 260 80 260C69 260 60 251 60 240C60 234.4 62.2 229.4 65.8 225.8L131.8 160L66 94.2C62.2 90.6 60 85.6 60 80C60 69 69 60 80 60C85.6 60 90.6 62.2 94.2 65.8L160 131.8L225.8 66C229.4 62.2 234.4 60 240 60C251 60 260 69 260 80C260 85.6 257.8 90.6 254.2 94.2L188.2 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Cross.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Cross.displayName = "Blueprint5.Icon.Cross";
exports.default = Cross;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8I3Ql":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Crown", ()=>Crown);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Crown = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "crown",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 240L120 200L200 300L280 200L360 240L340 100L60 100L40 240zM200 360C211.045694 360 220 351.045695 220 340C220 328.954305 211.045694 320 200 320C188.954305 320 180 328.954305 180 340C180 351.045695 188.954305 360 200 360zM20 300C31.045695 300 40 291.045695 40 280C40 268.954305 31.045695 260 20 260C8.954305 260 0 268.954305 0 280C0 291.045695 8.954305 300 20 300zM380 300C391.0456940000001 300 400 291.045695 400 280C400 268.954305 391.0456940000001 260 380 260C368.954306 260 360 268.954305 360 280C360 291.045695 368.954306 300 380 300zM60 80L340 80L340 40L60 40L60 80z" : "M40 200L100 160L160 240L220 160L280 200L260 80L60 80L40 200zM160 300C171.045695 300 180 291.045695 180 280C180 268.954305 171.045695 260 160 260C148.954305 260 140 268.954305 140 280C140 291.045695 148.954305 300 160 300zM20 260C31.045695 260 40 251.045695 40 240C40 228.954305 31.045695 220 20 220C8.954305 220 0 228.954305 0 240C0 251.045695 8.954305 260 20 260zM300 260C311.045694 260 320 251.045695 320 240C320 228.954305 311.045694 220 300 220C288.9543060000001 220 280 228.954305 280 240C280 251.045695 288.9543060000001 260 300 260zM60 60L260 60L260 20L60 20L60 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Crown.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Crown.displayName = "Blueprint5.Icon.Crown";
exports.default = Crown;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"XLvug":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CssStyle", ()=>CssStyle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CssStyle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "css-style",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 380C60 391.04568 68.9544 400 80 400C140 400 200 400.00029875 260 399.9999120832L380 280C380 193.334 380 106.666 380 20C380 8.954 371.046 0 360 0H285.846C293.858 8.784 300 20.846 300 35C300 36.72 299.914 38.386 299.75 40H340V260C293.334 260 286.666 260 240 260V360H100V125.59C99.7246 125.36 99.4516 125.128 99.181 124.894C95.9118 122.072 92.7888 118.74 90.0474 114.964C87.1244 119.38 83.5152 123.47 79.1184 127.06C73.1826 131.908 66.669 135.144 60 137.168V380zM40 120C29.6488 120 20.3564 116.842 13.19204 110.732C5.74774 104.384 0.771948 94.772 0 85V35C0 25.1659999999999 5.19282 16.338 12.2515 10.244C19.4114 4.062 29.206 0 40 0C60.3068 0 80 14.04 80 35C80 40.522 75.5228 45 70 45C64.4772 45 60 40.522 60 35C60 28.346 52.8302 20 40 20C34.2256 20 29.02 22.188 25.322 25.3820000000001C21.523 28.662 20 32.3340000000001 20 35V85C20.948 90.07 23.1992 92.982 26.1694 95.514C29.267 98.156 33.7826 100 40 100C46.6792 100 51.0066 98.374 53.8172 96.078C56.5796 93.822 59.012 89.996 60.1404 83.33C61.0622 77.886 66.224 74.218 71.6694 75.14C77.1148 76.062 80.7816 81.224 79.8596 86.67C78.133 96.868 73.8496 105.54 66.4678 111.568C59.1344 117.558 49.8894 120 40 120zM112.2516 109.756C119.4114 115.938 129.206 120 140 120C160.3068 120 180 105.96 180 85C180 79.478 175.5228 75 170 75C164.4772 75 160 79.478 160 85C160 91.654 152.8302 100 140 100C134.2256 100 129.02 97.812 125.3222 94.618C121.523 91.338 120 87.666 120 85C120 82.576 120.9782 80.424 124.9976 77.69C129.422 74.682 135.6646 72.29 143.4956 69.37L144.1004 69.144C151.1528 66.514 159.613 63.36 166.2476 58.848C173.4782 53.932 180 46.382 180 35C180 25.1659999999999 174.8072 16.338 167.7486 10.244C160.5886 4.062 150.794 0 140 0C119.6932 0 100 14.04 100 35C100 40.522 104.4772 45 110 45C115.5228 45 120 40.522 120 35C120 28.346 127.1698 20 140 20C145.7744 20 150.98 22.188 154.6778 25.3820000000001C158.477 28.662 160 32.3340000000001 160 35C160 37.424 159.0218 39.576 155.0024 42.31C149.248 46.222 142.3672 48.444 135.8996 50.856C128.8474 53.486 120.3872 56.64 113.7524 61.152C106.5218 66.068 100 73.6180000000001 100 85C100 94.834 105.1928 103.662 112.2516 109.756zM240 120C229.206 120 219.412 115.938 212.252 109.756C205.192 103.662 200 94.834 200 85C200 73.6180000000001 206.522 66.068 213.752 61.152C220.388 56.64 228.848 53.486 235.9 50.856C242.368 48.444 249.248 46.222 255.002 42.31C259.022 39.576 260 37.424 260 35C260 32.3340000000001 258.478 28.662 254.678 25.3820000000001C250.98 22.188 245.774 20 240 20C227.17 20 220 28.346 220 35C220 40.522 215.522 45 210 45C204.478 45 200 40.522 200 35C200 14.04 219.694 0 240 0C250.794 0 260.588 4.062 267.748 10.244C274.808 16.338 280 25.1659999999999 280 35C280 46.382 273.478 53.932 266.248 58.848C259.612 63.36 251.152 66.514 244.1 69.144L243.496 69.37C235.664 72.29 229.422 74.682 224.998 77.69C220.978 80.424 220 82.576 220 85C220 87.666 221.522 91.338 225.322 94.618C229.02 97.812 234.226 100 240 100C252.83 100 260 91.654 260 85C260 79.478 264.478 75 270 75C275.522 75 280 79.478 280 85C280 105.96 260.306 120 240 120z" : "M40 300C40 311.0457 48.9544 320 60 320H200C233.334 286.6668 266.666 253.3334 300 220V20C300 8.954 291.046 0 280 0H229.642C236.192 8.634 240 19.218 240 30C240 33.552 239.618 36.884 238.932 40H260V200C226.666 200 213.334 200 180 200V280H80V109.728C76.2614 106.846 72.9498 103.464 70.1502 99.724C68.5006 102.082 66.6038 104.352 64.4262 106.486C57.1778 113.588 48.6016 117.466 40 119.082V300zM149.82 0.236L149.9964 0H149.6418L149.82 0.236zM30 100C21.8796 100 14.66904 96.98 9.30174 91.488C4.06022 86.124 1.099978 78.962 0.0866068 71.314L0 70.66V70V30C0 14.814 13.10002 0 30 0C46.5686 0 60 13.432 60 30C60 35.522 55.5228 40 50 40C44.4772 40 40 35.522 40 30C40 24.478 35.5228 20 30 20C24.8086 20 20 25.186 20 30V69.286C20.631 73.296 22.0808 75.948 23.606 77.51C25.0798 79.018 27.0746 80 30 80C33.4608 80 35.2792 79.044 36.429 77.916C37.7366 76.636 39.3398 73.978 40.098 68.602C40.8696 63.134 45.9284 59.326 51.3972 60.098C56.8658 60.87 60.6736 65.928 59.902 71.398C58.7568 79.512 55.8828 86.854 50.4276 92.202C44.8148 97.702 37.5848 100 30 100zM80 70C80 85.186 93.1 100 110 100C126.5686 100 140 86.568 140 70C140 64.478 135.5228 60 130 60C124.4772 60 120 64.478 120 70C120 75.522 115.5228 80 110 80C104.8086 80 100 74.814 100 70C100 68.158 100.569 66.92 102.5718 65.286C105.0942 63.226 108.7642 61.51 114.0864 59.128L114.6112 58.892C119.23 56.826 125.2782 54.122 130.0718 50.212C135.569 45.726 140 39.204 140 30C140 14.814 126.9 0 110 0C93.4314 0 80 13.432 80 30C80 35.522 84.4772 40 90 40C95.5228 40 100 35.522 100 30C100 24.478 104.4772 20 110 20C115.1914 20 120 25.186 120 30C120 31.842 119.431 33.08 117.4282 34.716C114.9058 36.774 111.2358 38.49 105.9138 40.872L105.3888 41.108C100.77 43.174 94.722 45.878 89.9282 49.788C84.431 54.274 80 60.796 80 70zM190 100C173.1 100 160 85.186 160 70C160 60.796 164.431 54.274 169.9282 49.788C174.722 45.878 180.77 43.174 185.3888 41.108L185.9138 40.872C191.2358 38.49 194.9058 36.774 197.4282 34.716C199.431 33.08 200 31.842 200 30C200 25.186 195.1914 20 190 20C184.4772 20 180 24.478 180 30C180 35.522 175.5228 40 170 40C164.4772 40 160 35.522 160 30C160 13.432 173.4314 0 190 0C206.9 0 220 14.814 220 30C220 39.204 215.568 45.726 210.072 50.212C205.278 54.122 199.23 56.826 194.6112 58.892L194.0864 59.128C188.7642 61.51 185.0942 63.226 182.5718 65.286C180.569 66.92 180 68.158 180 70C180 74.814 184.8086 80 190 80C195.5228 80 200 75.522 200 70C200 64.478 204.478 60 210 60C215.522 60 220 64.478 220 70C220 86.568 206.568 100 190 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CssStyle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CssStyle.displayName = "Blueprint5.Icon.CssStyle";
exports.default = CssStyle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"BAbn6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CubeAdd", ()=>CubeAdd);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CubeAdd = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cube-add",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 340L380 340C391.0456940000001 340 400 331.045695 400 320C400 308.954305 391.0456940000001 300 380 300L340 300L340 260C340 248.954305 331.0456940000001 240 320 240C308.9543060000001 240 300 248.954305 300 260L300 300L260 300C248.954306 300 240 308.954305 240 320C240 331.045695 248.954306 340 260 340L300 340L300 380C300 391.045695 308.9543060000001 400 320 400C331.0456940000001 400 340 391.045695 340 380L340 340zM260.6251900000001 251.306629L200 215.6051288L39.0633182 310.3789524L187.2421416 390.78281158C195.147553 395.07239614 204.852446 395.07239614 212.757858 390.78281158L239.351824 376.3525618C216.38718 367.9356178 200 345.8815244 200 320C200 286.862915 226.862916 260 260 260C260 257.0475482 260.21325 254.1449036 260.6251900000001 251.306629zM266.999778 231.8502962C277.085288 212.9008086 297.03607 200 320 200C353.137084 200 380 226.862915 380 260L380 118.864096C380 110.101668 375.0555020000001 102.01105 367.043572 97.663668L212.757858 13.9461260000001C211.860026 13.45895 210.938982 13.027104 210 12.650586L210 198.28376L266.999778 231.8502962zM22.7192898 296.7935118L190 198.28376L190 12.650586C189.0610178 13.027104 188.1399744 13.45895 187.2421416 13.9461260000001L32.9564272 97.663668C24.9444988 102.01105 20 110.101668 20 118.864096L20 285.8648418C20 289.7257424 20.9599542 293.4562136 22.7192898 296.7935118z" : "M280 280L300 280C311.045694 280 320 271.045695 320 260C320 248.954305 311.045694 240 300 240L280 240L280 220C280 208.954305 271.045694 200 260 200C248.954306 200 240 208.954305 240 220L240 240L220 240C208.954306 240 200 248.954305 200 260C200 271.045695 208.954306 280 220 280L240 280L240 300C240 311.045695 248.954306 320 260 320C271.045694 320 280 311.045695 280 300L280 280zM182.7209844 307.01658036C168.8774658 296.0254388 160 279.049441 160 260C160 232.924642 177.9338258 210.0379536 202.570706 202.570706C202.923532 201.4066184 203.310782 200.2574954 203.731274 199.124522L160 171.7924764L36.125055 249.214317L150.0772212 314.3298407C156.2258746 317.84335692 163.7741254 317.84335692 169.9227788 314.3298407L182.7209844 307.01658036zM300 175.2778698L300 91.60645C300 84.429314 296.154278 77.802444 289.922778 74.241588L170 5.714286L170 154.4575236L213.7358 181.792399C224.740976 168.4817372 241.37998 160 260 160C275.367088 160 289.38487 165.7770714 300 175.2778698zM21.1240402 235.0049984L150 154.4575236L150 5.714286L30.0772212 74.241588C23.8457212 77.802444 20 84.429314 20 91.60645L20 228.3935492C20 230.680355 20.3904216 232.911297 21.1240402 235.0049984z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CubeAdd.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CubeAdd.displayName = "Blueprint5.Icon.CubeAdd";
exports.default = CubeAdd;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e1YqF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CubeEdit", ()=>CubeEdit);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CubeEdit = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cube-edit",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M276.18 356L212.76 390.4A27 27 0 0 1 187.24 390.4L39.06 310L159.34 239.16zM144.74 224.54L22.72 296.4A24 24 0 0 1 20 285.48V118.48C20 109.72 24.94 101.62 32.96 97.28L187.24 13.5599999999999Q188.6 12.8199999999999 190 12.2599999999999V123.1199999999999L126.64 101.0999999999999A20 20 0 0 0 101.16 126.4999999999999L128.06 204.3599999999999A20 20 0 0 0 133.14 212.9599999999999zM210 130.74V12.26Q211.4 12.8199999999999 212.76 13.56L367.04 97.28C375.04 101.62 380 109.72 380 118.48V285.48C380 289.3400000000001 379.04 293.0800000000001 377.2800000000001 296.4000000000001L374.2000000000001 294.6L362.6 283A20 20 0 0 0 361.24 281.4600000000001L212.9400000000001 133.16A20 20 0 0 0 210 130.74M161.34 212.9L212.84 161.4L347.02 295.58L295.5 347.08zM120 119.96L198.7 147.3L147.24 198.78zM364.42 400.08C354.62 400.08 345.04 396.86 338.62 390.26L309.62 361.18L361.0200000000001 309.7L390 338.8C396.4 345.4 399.98 354.64 399.98 364.44C399.98 384.04 383.98 400.1 364.4 400.1" : "M174.8 135.94L136 174.74L236.44 275.16L275.24 236.36zM100 99.84L121.86 160.5L160.7 121.68zM273.14 312C278.16 316.86 285.08 320 292.64 320C307.9 320 320.16 307.6 320 292.6600000000001C320 284.96 317 278.2 311.98 273.18L289.3400000000001 250.54L250.5 289.3400000000001zM169.92 314.32L219.2 286.2L126.02 193.02L36.12 249.22L150.08 314.32A20 20 0 0 0 169.92 314.32M21.12 235L111.52 178.52L107.66 174.66A20 20 0 0 1 102.54 165.86L81.18 106.6A20 20 0 0 1 106.78 81L150 96.54V5.7L30.08 74.22A20 20 0 0 0 20 91.6V228.4A20 20 0 0 0 21.12 235M170 5.72V103.96A20 20 0 0 1 176.28 109.12L289.38 222.22L290.3800000000001 223.3L299.5800000000001 232.5Q300.0000000000001 230.48 300.0000000000001 228.4V91.6A20 20 0 0 0 289.9200000000001 74.24z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CubeEdit.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CubeEdit.displayName = "Blueprint5.Icon.CubeEdit";
exports.default = CubeEdit;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRYMA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CubeRemove", ()=>CubeRemove);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CubeRemove = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cube-remove",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M239.351824 376.3525618C216.38718 367.9356178 200 345.8815244 200 320C200 286.862915 226.862916 260 260 260L275.387518 260L200 215.6051288L39.0633182 310.3789524L187.2421416 390.78281158C195.147553 395.07239614 204.852446 395.07239614 212.757858 390.78281158L239.351824 376.3525618zM380 260L380 118.864096C380 110.101668 375.0555020000001 102.01105 367.043572 97.663668L212.757858 13.9461260000001C211.860026 13.45895 210.938982 13.027104 210 12.650586L210 198.28376L314.8011620000001 260L380 260zM22.7192898 296.7935118L190 198.28376L190 12.650586C189.0610178 13.027104 188.1399744 13.45895 187.2421416 13.9461260000001L32.9564272 97.663668C24.9444988 102.01105 20 110.101668 20 118.864096L20 285.8648418C20 289.7257424 20.9599542 293.4562136 22.7192898 296.7935118zM260 340L380 340C391.0456940000001 340 400 331.045695 400 320C400 308.954305 391.0456940000001 300 380 300L260 300C248.954306 300 240 308.954305 240 320C240 331.045695 248.954306 340 260 340z" : "M207.290134 201.3488102L160 171.7924764L36.125055 249.214317L150.0772212 314.3298407C156.2258746 317.84335692 163.7741254 317.84335692 169.9227788 314.3298407L182.7209844 307.01658036C168.8774658 296.0254388 160 279.049441 160 260C160 231.2238434 180.257699 207.1791258 207.290134 201.3488102zM300 200L300 91.60645C300 84.429314 296.154278 77.802444 289.922778 74.241588L170 5.714286L170 154.4575236L242.867962 200L300 200zM21.1240402 235.0049984L150 154.4575236L150 5.714286L30.0772212 74.241588C23.8457212 77.802444 20 84.429314 20 91.60645L20 228.3935492C20 230.680355 20.3904216 232.911297 21.1240402 235.0049984zM220 280L300 280C311.045694 280 320 271.045695 320 260C320 248.954305 311.045694 240 300 240L220 240C208.954306 240 200 248.954305 200 260C200 271.045695 208.954306 280 220 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CubeRemove.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CubeRemove.displayName = "Blueprint5.Icon.CubeRemove";
exports.default = CubeRemove;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6hCrm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cube", ()=>Cube);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Cube = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cube",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M39.0633182 310.3789524L187.2421416 390.78281158C195.147553 395.07239614 204.852446 395.07239614 212.757858 390.78281158L360.936682 310.3789524L200 215.6051288L39.0633182 310.3789524zM22.7192898 296.7935118L190 198.28376L190 12.650586C189.0610178 13.027104 188.1399744 13.45895 187.2421416 13.9461260000001L32.9564272 97.663668C24.9444988 102.01105 20 110.101668 20 118.864096L20 285.8648418C20 289.7257424 20.9599542 293.4562136 22.7192898 296.7935118zM377.28071 296.7935118C379.040046 293.4562136 380 289.7257424 380 285.8648418L380 118.864096C380 110.101668 375.0555020000001 102.01105 367.043572 97.663668L212.757858 13.9461260000001C211.860026 13.45895 210.938982 13.027104 210 12.650586L210 198.28376L377.28071 296.7935118z" : "M283.874946 249.214317L160 171.7924764L36.125055 249.214317L150.0772212 314.3298407C156.2258746 317.84335692 163.7741254 317.84335692 169.9227788 314.3298407L283.874946 249.214317zM298.87596 235.0049984C299.609578 232.911297 300 230.680355 300 228.3935492L300 91.60645C300 84.429314 296.154278 77.802444 289.922778 74.241588L170 5.714286L170 154.4575236L298.87596 235.0049984zM21.1240402 235.0049984L150 154.4575236L150 5.714286L30.0772212 74.241588C23.8457212 77.802444 20 84.429314 20 91.60645L20 228.3935492C20 230.680355 20.3904216 232.911297 21.1240402 235.0049984z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Cube.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Cube.displayName = "Blueprint5.Icon.Cube";
exports.default = Cube;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d6QxW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cubes", ()=>Cubes);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Cubes = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cubes",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M194.1416 271.85L292.016 317.7044C299.356 321.1434 307.9100000000001 320.6966 314.858 316.5112000000001L388.094 272.396C395.478 267.948 400 259.9152000000001 400 251.2444V150.494C400 140.908 394.484 132.19 385.858 128.15L287.9840000000001 82.296C280.644 78.856 272.09 79.304 265.1420000000001 83.4879999999999L191.9054 127.604C184.5214 132.052 180 140.084 180 148.756V249.5052C180 259.0924 185.5168 267.8092 194.1416 271.85zM16.2484 358.0422L98.467 397.2152C107.216 401.3838 117.4896 400.8448 125.7512 395.7838L186.3898 358.6380000000001C194.8472 353.4572 200 344.2726 200 334.3788V296.6808L185.6566 289.9608C169.9454 282.6002 160 266.786 160 249.5052V218.258L136.1984 232.8384C122.1632 241.436 104.7216 242.3494 89.8644 235.2706000000001L34.1998 208.7492L13.6102 221.362C5.153 226.5428 0 235.7274 0 245.6212V332.3516C0 343.3192 6.32 353.3118 16.2484 358.0422zM160 194.804V148.756C160 133.122 168.151 118.564 181.5856 110.472L200 99.38V67.648C200 56.68 193.68 46.688 183.7516 41.958L101.533 2.784C92.784 -1.384 82.5104 -0.8440000000001 74.2488 4.216L13.6102 41.362C5.153 46.542 0 55.728 0 65.622V152.352C0 163.32 6.32 173.312 16.2484 178.042L98.467 217.2152C107.216 221.3838 117.4896 220.8448 125.7512 215.7838L160 194.804z" : "M79.5644 317.5294C86.901 321.2850000000001 95.6404 320.728 102.4654 316.0698L149.8218 283.7482C156.1806 279.4082 160 272.1018000000001 160 264.2776V250.9194L145.0206 244.8114C129.735 238.5784 120 223.6486 120 207.3616V188.3164L113.74 192.589C100.8862 201.362 84.3272 202.4354 70.4512 195.3326L20.0346 169.5248L10.1782 176.2518C3.8194 180.5918 0 187.8982 0 195.7224V262.339C0 271.2024 4.8914 279.3052 12.6352 283.269L79.5644 317.5294zM152.5722 226.2918L231.662 258.5418C236.966 260.7046000000001 242.924 260.452 248.034 257.8476L308.944 226.8004C315.7200000000001 223.3468 320 216.287 320 208.5646V112.638C320 104.302 315.02 96.804 307.428 93.708L228.338 61.458C223.034 59.296 217.076 59.548 211.966 62.152L151.0558 93.2C144.28 96.654 140 103.712 140 111.436V207.3616C140 215.6986 144.979 223.1956 152.5722 226.2918zM120 164.102V111.436C120 96.34 128.3676 82.316 141.9734 75.38L160 66.192V57.662C160 48.798 155.1086 40.694 147.365 36.73L80.4356 2.47C73.099 -1.284 64.3596 -0.728 57.5346 3.93L10.1782 36.252C3.8194 40.592 0 47.898 0 55.722V122.339C0 131.2024 4.8914 139.3052 12.6352 143.269L79.5644 177.5294C86.901 181.285 95.6404 180.728 102.4654 176.0698L120 164.102z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Cubes.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Cubes.displayName = "Blueprint5.Icon.Cubes";
exports.default = Cubes;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9vORm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CurlyBraces", ()=>CurlyBraces);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CurlyBraces = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "curly-braces",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 340C134.1502 340 113.941 332.6296 103.3648 313.8944C98.6776 305.5916 96.958 296.722 96.3022 288.9968C95.6502 281.3178 95.9622 273.3792 96.2706 266.5918C96.9598 251.4318 97.3804 241.4906 94.694 233.7298C93.5832 230.5204 92.0114 228.0852 89.6268 226.0212C87.1322 223.8624 82.827 221.3222 75.1492 219.4028C66.246 217.177 60 209.1774 60 200C60 190.822 66.246 182.822 75.1492 180.598C82.827 178.678 87.1322 176.138 89.6268 173.978C92.0114 171.914 93.5832 169.48 94.694 166.27C97.3804 158.51 96.9598 148.568 96.2706 133.408C95.9622 126.62 95.6502 118.682 96.3022 111.004C96.958 103.278 98.6776 94.408 103.3648 86.106C113.941 67.37 134.1502 60 160 60C171.0456 60 180 68.954 180 80C180 91.046 171.0456 100 160 100C141.3372 100 138.6864 104.872 138.2294 105.712L138.1978 105.77C137.416 107.154 136.5576 109.69 136.1588 114.388C135.756 119.13 135.9128 124.63 136.2294 131.592C136.2716 132.518 136.3188 133.482 136.3674 134.48C136.9682 146.746 137.8124 163.988 132.4934 179.354C129.97 186.644 126.0508 193.724 120.1924 200C126.0508 206.2764 129.97 213.3554 132.4934 220.6452C137.8124 236.0112000000001 136.9682 253.2542 136.3674 265.5208C136.3188 266.5168 136.2714 267.4814 136.2294 268.4082C135.9128 275.3708000000001 135.756 280.8698 136.1588 285.6126000000001C136.5576 290.3092000000001 137.416 292.846 138.1978 294.2306L138.2294 294.288C138.6864 295.1282 141.3372 300 160 300C171.0456 300 180 308.9544 180 320C180 331.0456000000001 171.0456 340 160 340zM240 340C265.85 340 286.058 332.6296 296.636 313.8944C301.322 305.5916 303.0420000000001 296.722 303.6980000000001 288.9968C304.35 281.3178 304.038 273.3792 303.73 266.5918C303.04 251.4318 302.62 241.4906 305.306 233.7298C306.416 230.5204 307.988 228.0852 310.374 226.0212C312.868 223.8624 317.1740000000001 221.3222 324.85 219.4028C333.754 217.177 340 209.1774 340 200C340 190.822 333.754 182.822 324.85 180.598C317.1740000000001 178.678 312.868 176.138 310.374 173.978C307.988 171.914 306.416 169.48 305.306 166.27C302.62 158.51 303.04 148.568 303.73 133.408C304.038 126.62 304.35 118.682 303.6980000000001 111.004C303.0420000000001 103.278 301.322 94.408 296.636 86.106C286.058 67.37 265.85 60 240 60C228.954 60 220 68.954 220 80C220 91.046 228.954 100 240 100C258.662 100 261.314 104.872 261.77 105.712L261.802 105.77C262.584 107.154 263.442 109.69 263.842 114.388C264.244 119.13 264.088 124.63 263.77 131.592C263.728 132.518 263.682 133.48 263.632 134.474C263.032 146.74 262.188 163.988 267.506 179.354C270.03 186.644 273.95 193.724 279.808 200C273.95 206.2764 270.03 213.3554 267.506 220.6452C262.188 236.0112000000001 263.032 253.2542 263.632 265.5208C263.682 266.5174 263.728 267.481 263.77 268.4082C264.088 275.3708000000001 264.244 280.8698 263.842 285.6126000000001C263.442 290.3092000000001 262.584 292.846 261.802 294.2306L261.77 294.288C261.314 295.1282 258.662 300 240 300C228.954 300 220 308.9544 220 320C220 331.0456000000001 228.954 340 240 340z" : "M72.3814 258.8836C82.055 275.0062 100.0022 280 120 280C131.0456 280 140 271.0456 140 260C140 248.9544 131.0456 240 120 240C111.1896 240 107.7076 238.7046 106.5844 238.0524C106.436 237.6204 106.1658 236.6122 106.0102 234.6712C105.7646 231.6068 105.8978 227.8258 106.2154 222.4244C106.2598 221.6696 106.3094 220.879 106.361 220.0554C106.9614 210.4744 107.8396 196.4576 104.126 182.9716C101.857 174.7312 98.0152 166.96 92.2094 160C98.0152 153.04 101.857 145.2688 104.126 137.0284C107.8396 123.5424 106.9614 109.526 106.361 99.944C106.3094 99.122 106.2598 98.33 106.2154 97.576C105.8978 92.174 105.7646 88.394 106.0102 85.328C106.1658 83.388 106.436 82.38 106.5844 81.948C107.7076 81.296 111.1896 80 120 80C131.0456 80 140 71.046 140 60C140 48.954 131.0456 40 120 40C100.0022 40 82.055 44.994 72.3814 61.116C68.0816 68.282 66.6404 75.866 66.1382 82.132C65.6416 88.326 65.9772 94.7 66.2846 99.924L66.3112 100.378C66.986 111.842 67.4414 119.582 65.5614 126.4092C64.1296 131.609 61.0864 137.096 51.0558 142.1114C44.28 145.4992 40 152.4246 40 160C40 167.5754 44.28 174.5008 51.0558 177.8886C61.0864 182.904 64.1296 188.391 65.5614 193.5908C67.4414 200.4184 66.986 208.1586 66.3112 219.6216L66.2846 220.0756C65.9772 225.2992 65.6416 231.6744 66.1382 237.8678C66.6404 244.1334 68.0816 251.7172 72.3814 258.8836zM106.133 82.312C106.133 82.312 106.281 82.244 106.4538 82.028C106.199 82.19 106.133 82.312 106.133 82.312zM106.133 237.688C106.133 237.688 106.1988 237.8098 106.4538 237.973C106.281 237.7562 106.133 237.688 106.133 237.688zM247.618 258.8836C237.946 275.0062 219.998 280 200 280C188.9544 280 180 271.0456 180 260C180 248.9544 188.9544 240 200 240C208.81 240 212.292 238.7046 213.416 238.0524C213.564 237.6204 213.834 236.6122 213.99 234.6712C214.236 231.6068 214.102 227.8258 213.784 222.4244C213.74 221.6696 213.69 220.879 213.638 220.0554C213.038 210.4744 212.16 196.4576 215.874 182.9716C218.144 174.7312 221.984 166.96 227.79 160C221.984 153.04 218.144 145.2688 215.874 137.0284C212.16 123.5424 213.038 109.526 213.638 99.944C213.69 99.122 213.74 98.33 213.784 97.576C214.102 92.174 214.236 88.394 213.99 85.328C213.834 83.388 213.564 82.38 213.416 81.948C212.292 81.296 208.81 80 200 80C188.9544 80 180 71.046 180 60C180 48.954 188.9544 40 200 40C219.998 40 237.946 44.994 247.618 61.116C251.918 68.282 253.36 75.866 253.862 82.132C254.358 88.326 254.022 94.7 253.716 99.924L253.688 100.378C253.014 111.842 252.558 119.582 254.438 126.4092C255.87 131.609 258.914 137.096 268.944 142.1114C275.72 145.4992 280 152.4246 280 160C280 167.5754 275.72 174.5008 268.944 177.8886C258.914 182.904 255.87 188.391 254.438 193.5908C252.558 200.4184 253.014 208.1586 253.688 219.6216L253.716 220.0756C254.022 225.2992 254.358 231.6744 253.862 237.8678C253.36 244.1334 251.918 251.7172 247.618 258.8836zM213.866 82.312C213.866 82.312 213.718 82.244 213.546 82.028C213.802 82.19 213.866 82.312 213.866 82.312zM213.866 237.688C213.866 237.688 213.802 237.8098 213.546 237.973C213.718 237.7562 213.866 237.688 213.866 237.688z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CurlyBraces.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CurlyBraces.displayName = "Blueprint5.Icon.CurlyBraces";
exports.default = CurlyBraces;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eUD0a":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CurvedRangeChart", ()=>CurvedRangeChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var CurvedRangeChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "curved-range-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 80H60.4L103.2 114.8C148.2 80.8 249.8 105.6 339.8000000000001 174.6L314.0000000000001 204.6C242.8000000000001 149.8 167.8000000000001 124 135.4000000000001 140.8L346.4000000000001 312.2000000000001L333.8000000000001 327.8L122 155.8C109.2 188.6 151.2 254 223.8 309.8L198 339.8C106 269 59.8 177.4 89.8 129.6L40 89.2000000000001V340C40 351 31 360 20 360S0 351 0 340V60C0 57.2 0.6 54.6 1.6 52.2C4.6 45 11.8 40 20 40H380C391 40 400 49 400 60S391 80 380 80z" : "M300 80H62.4L98.6 107.8C133.2 87.6 209.2 108.4 280.2 160L255.8 190C206 154 157.2 132.6 133 134.2L286 252L274 268L117.4 147.4C117.2 168.8 153.4 211.2 206.8 250L182.4 280C107.6 226 66.8 158 85 122.6L40 88V260C40 271 31 280 20 280S0 271 0 260V60C0 49 9 40 20 40H300C311 40 320 49 320 60S311 80 300 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
CurvedRangeChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
CurvedRangeChart.displayName = "Blueprint5.Icon.CurvedRangeChart";
exports.default = CurvedRangeChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Ja08":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cut", ()=>Cut);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Cut = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cut",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 360C320 360 334.4 385.6 320 400L214.2 275L239.8 244.2L320 360zM321.6 160C310.6 160 300.2 157.6 290.8 153.6L86.2 400C72.2 385.6 86.2 360 86.2 360L175.2 228.8L111.4 153.4C101.8 157.6 91.2 160 80 160C35.8 160 0 124.2000000000001 0 80C0 35.8 35.8 0 80 0S160 35.8 160 80C160 93 156.6 105.2 151 116L201.8 189.4L251.6 116C246.2 105.2000000000001 242.8 93 242.8 80C242.8 35.8 278 0 321.2000000000001 0C364.6000000000001 0 399.6000000000001 35.8 399.6000000000001 80C400 124.2000000000001 364.8 160 321.6 160zM80 40C58 40 40 58 40 80C40 102 58 120 80 120S120 102 120 80C120 58 102 40 80 40zM321.6 40C300 40 282.4 58 282.4 80C282.4 102 300 120 321.6 120C343.2 120 360.8 102 360.8 80C360.8 58 343.2 40 321.6 40z" : "M260 280C260 280 274.2000000000001 305.8 260 320L173.2 218.6L194.2 192.2L260 280zM261.4 120C253 120 245 118.2 237.8 114.8L66.2 320C52.4 305.8 66.2 280 66.2 280L139.8 179.6L84.4 114.8C76.8 118.2 68.6 120 60 120C26.8 120 0 93.2 0 60S26.8 0 60 0S120 26.8 120 60C120 69.2 117.8 77.8 114.2 85.4L162 149.2L208.6 85.4C205 77.6 202.8 69 202.8 60.0000000000001C202.8 26.8 229.0000000000001 1e-13 261.4 1e-13C293.8 1e-13 320 26.8 320 60.0000000000001S293.8 120 261.4 120zM60 40C49 40 40 49 40 60C40 71 49 80 60 80S80 71 80 60C80 49 71 40 60 40zM261.4 40C250.6 40 241.8 49 241.8 60C241.8 71 250.6 80 261.4 80S281 71 281 60C281 49 272.2 40 261.4 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Cut.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Cut.displayName = "Blueprint5.Icon.Cut";
exports.default = Cut;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8UtxA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cycle", ()=>Cycle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Cycle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "cycle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 200C364.18278 200 400 164.18278 400 120C400 75.81722 364.18278 40 320 40C275.81722 40 240 75.81722 240 120C240 164.18278 275.81722 200 320 200zM80 200C124.18278 200 160 164.18278 160 120C160 75.81722 124.18278 40 80 40C35.81722 40 0 75.81722 0 120C0 164.18278 35.81722 200 80 200zM225.975578 310.8636448L227.717926 309.0819614L266.32 264.44L307.2837120000001 250.2722938C316.977674 246.9215724 322.445012 236.8627728 320.287458 227.0843274L319.652662 224.8359206C316.30194 215.1419584 306.24314 209.6746208 296.464696 211.832174L294.216288 212.4669708L248.186224 228.3772788C245.690846 229.2398068 243.39937 230.5848596 241.438168 232.3268482L239.59174 234.1979788L211.86 266.26L174.04 226.62L214.96187 181.137364C217.716386 178.07692 219.445596 174.257058 219.945486 170.20942L220.096268 167.757756L220.096268 82.951372C220.096268 71.905678 211.141964 62.951372 200.096268 62.951372C189.839552 62.951372 181.3861256 70.672176 180.2308234 80.61895L180.0962688 82.951372L180.08 160.1L131.9170774 213.6129642C125.5061162 220.735953 125.1153508 231.2833646 130.65201 238.8193324L132.3088992 240.795097L198.1159522 309.8025254000001C205.680532 317.7349912 218.063208 318.0133324 225.975578 310.8636448zM320 160C297.90861 160 280 142.09139 280 120C280 97.90861 297.90861 80 320 80C342.09139 80 360 97.90861 360 120C360 142.09139 342.09139 160 320 160zM80 160C57.90861 160 40 142.09139 40 120C40 97.90861 57.90861 80 80 80C102.09139 80 120 97.90861 120 120C120 142.09139 102.09139 160 80 160zM270 360C286.5685420000001 360 300 346.5685424 300 330C300 313.4314576 286.5685420000001 300 270 300C253.431458 300 240 313.4314576 240 330C240 346.5685424 253.431458 360 270 360z" : "M260 140C293.137084 140 320 113.137084 320 80C320 46.862916 293.137084 20 260 20C226.862916 20 200 46.862916 200 80C200 113.137084 226.862916 140 260 140zM60 140C93.137085 140 120 113.137084 120 80C120 46.862916 93.137085 20 60 20C26.862915 20 0 46.862916 0 80C0 113.137084 26.862915 140 60 140zM183.3730088 245.4034204L185.128195 243.6100436L215.32 208.68L247.09883 197.6993958C256.792792 194.3486744 262.26013 184.2898748 260.102576 174.5114294L259.46778 172.2630226C256.117058 162.5690604 246.058258 157.1017228 236.279814 159.259276L234.031406 159.8940728L197.1880868 172.628979C194.6927092 173.4915072 192.4012326 174.8365598 190.4400318 176.5785486L188.5936032 178.4496792L169.42 200.62L140.82 170L174.6459846 133.61966C177.513628 130.535922 179.319932 126.6428462 179.8423766 122.5064836L180 120L180 60C180 48.954306 171.045695 40 160 40C149.7432832 40 141.2898568 47.720804 140.1345546 57.667578L140 60L139.98 112.16L98.8526818 156.3858336C92.299539 163.4327958 91.7631726 174.0248152 97.2372524 181.6518998L98.8791978 183.653612L155.3805314 244.1762008C162.9141772 252.2460234 175.4012012 252.595028 183.3730088 245.4034204zM260 110C243.431458 110 230 96.568542 230 80C230 63.431458 243.431458 50 260 50C276.5685420000001 50 290 63.431458 290 80C290 96.568542 276.5685420000001 110 260 110zM60 110C43.4314576 110 30 96.568542 30 80C30 63.431458 43.4314576 50 60 50C76.5685424 50 90 63.431458 90 80C90 96.568542 76.5685424 110 60 110zM220 300C236.568542 300 250 286.5685424 250 270C250 253.4314576 236.568542 240 220 240C203.431458 240 190 253.4314576 190 270C190 286.5685424 203.431458 300 220 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Cycle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Cycle.displayName = "Blueprint5.Icon.Cycle";
exports.default = Cycle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5snCX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dashboard", ()=>Dashboard);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Dashboard = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "dashboard",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 300C109 300 100 291 100 280C100 269 109 260 120 260S140 269 140 280C140 291 131 300 120 300zM80 220C69 220 60 211 60 200C60 189 69 180 80 180S100 189 100 200C100 211 91 220 80 220zM200 300C211 300 220 309 220 320C220 331 211 340 200 340S180 331 180 320C180 309 189 300 200 300zM200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 40C111.6 40 40 111.6 40 200S111.6 360 200 360S360 288.4 360 200S288.4 40 200 40zM320 220C309 220 300 211 300 200C300 189 309 180 320 180S340 189 340 200C340 211 331 220 320 220zM160 120C160 98 178 80 200 80S240 98 240 120C240 126.6 200 280 200 280S160 126.6 160 120zM280 300C269 300 260 291 260 280C260 269 269 260 280 260S300 269 300 280C300 291 291 300 280 300z" : "M100 240C89 240 80 231 80 220C80 209 89 200 100 200S120 209 120 220C120 231 111 240 100 240zM80 180C69 180 60 171 60 160C60 149 69 140 80 140S100 149 100 160C100 171 91 180 80 180zM160 220C171 220 180 229 180 240C180 251 171 260 160 260S140 251 140 240C140 229 149 220 160 220zM120 100C120 78 138 60 160 60S200 78 200 100C200 110.6 160 200 160 200S120 110.6 120 100zM160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM160 40C93.8 40 40 93.8 40 160S93.8 280 160 280S280 226.2 280 160S226.2 40 160 40zM240 220C240 231 231 240 220 240S200 231 200 220C200 209 209 200 220 200S240 209 240 220zM240 180C229 180 220 171 220 160C220 149 229 140 240 140S260 149 260 160C260 171 251 180 240 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Dashboard.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Dashboard.displayName = "Blueprint5.Icon.Dashboard";
exports.default = Dashboard;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6YxVb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataConnection", ()=>DataConnection);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DataConnection = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "data-connection",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 162C58.693773 148.515528 86.779336 137.660844 120.4573894 131.27809C120.1515374 127.568272 120 123.801834 120 120C120 69.065874 147.1989 24.4846 187.8643188 -0.011C108.0925026 0.376966 43.2336234 21.658914 40.1172306 48.014096L40 50L40 162zM260 240C326.3 240 380 186.3 380 120C380 53.7 326.3 0 260 0C193.7 0 140 53.7 140 120C140 186.3 193.7 240 260 240zM280 220L200 100L250 100L240 20L320 140L270 140L280 220zM339.990248 312L339.9994240000001 234.901628C317.322246 250.7219106 289.74232 260 259.99545 260C194.784215 260 139.9867956 215.4117094 124.4255082 155.058382C76.267117 162.889044 42.4828228 179.095604 40.1310854 197.900202L40 200L40 312C70.4990086 290 125.9972044 275 189.995124 275C253.993044 275 309.49124 290 339.990248 312zM189.995124 400C272.742434 400 339.990248 377.5 339.990248 350C339.990248 322.5 272.742434 300 189.995124 300C106.997822 300 40 322.5 40 350C40 377.5 106.997822 400 189.995124 400z" : "M20 129.6C37.7731818 116.78 66.1579598 106.931246 100.0528088 102.527208L100 100C100 58.41417 121.1536484 21.76904 153.2876162 0.237938C148.9339546 0.08301 144.4955694 0 140 0C75.6914286 0 23.0844082 16.986122 20.1307896 38.124408L20 40L20 129.6zM220 200C275.25 200 320 155.25 320 100C320 44.75 275.25 0 220 0C164.75 0 120 44.75 120 100C120 155.25 164.75 200 220 200zM240 180L160 80L210 80L200 20L280 120L230 120L240 180zM260 249.6L260.0137180000001 213.1669222C247.498684 217.592072 234.030544 220 220 220C161.2569858 220 112.3724554 177.7908122 102.0208966 122.0469242L97.0436104 122.6540408C53.684161 128.223347 22.389439 141.9598368 20.1307896 158.1244082L20 160L20 249.6C44.4 232 88.8 220 140 220C191.2 220 235.6 232 260 249.6zM140 320C206.2 320 260 302 260 280C260 258 206.2 240 140 240C73.6 240 20 258 20 280C20 302 73.6 320 140 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DataConnection.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DataConnection.displayName = "Blueprint5.Icon.DataConnection";
exports.default = DataConnection;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9dp69":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataLineage", ()=>DataLineage);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DataLineage = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "data-lineage",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M21.052632 400C9.425586 400 0 390.57441578 0 378.9473684L0 315.7894736C0 304.1624264 9.425586 294.7368422 21.052632 294.7368422L86.564802 294.7349946C93.76105 252.145896 122.419682 216.7835934 161.119494 199.989142C122.413254 183.210612 93.75153 147.841942 86.561218 105.243726L21.052632 105.263158C9.425586 105.263158 0 95.837572 0 84.210526L0 21.052632C0 9.425586 9.425586 0 21.052632 0L169.760088 0C181.387136 0 190.81272 9.425586 190.81272 21.052632L190.81272 84.210526C190.81272 95.837572 181.387136 105.263158 169.760088 105.263158L108.128402 105.267116C117.951928 153.312308 160.730214 189.473684 212.0141344 189.473684L212.0141344 147.368422C212.0141344 135.741374 221.4397186 126.31579 233.0667658 126.31579L378.9473684 126.31579C390.5744157800001 126.31579 400 135.741374 400 147.368422L400 252.631579C400 264.2586264000001 390.5744157800001 273.6842106000001 378.9473684 273.6842106000001L233.0667658 273.6842106000001C221.4397186 273.6842106000001 212.0141344 264.2586264000001 212.0141344 252.631579L212.0141344 210.5263158C160.737694 210.5263158 117.964404 246.6771452 108.132702 294.7118652000001L169.760088 294.7368422C181.387136 294.7368422 190.81272 304.1624264 190.81272 315.7894736L190.81272 378.9473684C190.81272 390.57441578 181.387136 400 169.760088 400L21.052632 400z" : "M21.333334 320C9.55126 320 0 310.4487413400001 0 298.6666666L0 256C0 244.2179254 9.55126 234.6666666 21.333334 234.6666666L66.136364 234.6536424C72.828874 201.705044 94.708948 174.272886 124.1505044 159.983244C94.70256 145.7182198 72.819382 118.282052 66.13201 85.324742L21.333334 85.333334C9.55126 85.333334 0 75.782074 0 64L0 21.333334C0 9.55126 9.55126 0 21.333334 0L128 0C139.7820746 0 149.3333334 9.55126 149.3333334 21.333334L149.3333334 64C149.3333334 75.782074 139.7820746 85.333334 128 85.333334L88.019566 85.325018C97.149476 120.8121102 128.532693 147.367252 166.4076728 149.2289L170.6666666 149.3333334L170.6666666 128C170.6666666 116.217926 180.2179254 106.666666 192 106.666666L298.6666666 106.666666C310.4487413400001 106.666666 320 116.217926 320 128L320 192C320 203.7820746 310.4487413400001 213.3333334 298.6666666 213.3333334L192 213.3333334C180.2179254 213.3333334 170.6666666 203.7820746 170.6666666 192L170.6666666 170.6666666C130.910608 170.6666666 97.504448 197.8538188 88.025888 234.6504248L128 234.6666666C139.7820746 234.6666666 149.3333334 244.2179254 149.3333334 256L149.3333334 298.6666666C149.3333334 310.4487413400001 139.7820746 320 128 320L21.333334 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DataLineage.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DataLineage.displayName = "Blueprint5.Icon.DataLineage";
exports.default = DataLineage;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gi27r":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataSearch", ()=>DataSearch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DataSearch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "data-search",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 210V318C70 295.4 130.4 280 200 280C269.8 280 330.2000000000001 295.4 360 318V210C360 208.933 359.892 207.8736 359.682 206.823C338.152 238.8776 301.56 260 260 260C201.718 260 153.1406 218.4538 142.2714 163.354C82.4208 170.592 40 188.756 40 210zM140.014 141.88C140.0248 142.584 140.0416 143.286 140.0646 143.984C96.7026 149.954 60.9434 162.222 40 178V70C40 42.4 111.6 20 200 20C213.934 20 227.452 20.556 240.338 21.602C190.6132 29.796 151.2164 68.552 142.028 117.934C140.6946 125.1 140 132.478 140 140V140.154L140.014 141.88zM360 350C360 322.4 288.4 300 200 300C111.8 300 40 322.4 40 350C40 377.6 111.6 400 200 400C288.4 400 360 377.6 360 350zM315.148 56.568L365.828 5.888C373.638 -1.924 386.302 -1.924 394.112 5.888C401.924 13.696 401.924 26.362 394.112 34.17L343.432 84.854C353.902 100.66 360 119.62 360 140C360 145.772 359.51 151.43 358.572 156.938C357.4600000000001 163.448 355.7200000000001 169.746 353.416 175.762C339.026 213.3252 302.628 240 260 240C205.298 240 160.8532 196.08 160.0122 141.572L160 140C160 133.71 160.5804 127.558 161.6906 121.592C170.3306 75.156 211.06 40 260 40C280.382 40 299.338 46.098 315.148 56.568zM260 80C293.1380000000001 80 320 106.866 320 140C320 173.134 293.1380000000001 200 260 200C226.862 200 200 173.134 200 140C200 106.866 226.862 80 260 80z" : "M140 240C206.2 240 260 258 260 280C260 302 206.2 320 140 320C73.6 320 20 302 20 280C20 258 73.6 240 140 240zM20 249.6V160C20 142.6562 53.4366 127.7986 100.0256 122.2862C101.2408 176.4588 145.5356 220 200 220C222.512 220 243.286 212.561 260 200.0072V249.6C235.6 232 191.2 220 140 220C88.8 220 44.4 232 20 249.6zM20 129.6C38.0352 116.592 66.997 106.642 101.5552 102.336C109.897 55.532 150.799 20 200 20C212.884 20 225.226 22.446 236.564 26.902L243.5900000000001 19.846C222.742 7.998 184.126 0 140 0C73.8 0 20 18 20 40V129.6zM240.688 51.106L285.8 5.798C289.4000000000001 2.198 294.4000000000001 -0.002 300 -0.002C311 -0.002 320 8.998 320 19.998C320 25.598 317.8 30.598 314.2000000000001 34.198L268.892 79.308C275.95 91.23 280 105.142 280 120C280 140.289 272.4480000000001 158.8138 260 172.9164C245.342 189.5248 223.894 200 200 200C156.003 200 120.3012 164.4832 120.002 120.5566C120.0006 120.3712 120 120.1856 120 120C120 113.266 120.832 106.726 122.3988 100.478C131.112 65.732 162.551 40 200 40C214.856 40 228.768 44.05 240.688 51.106zM164.8144 100.958C171.584 88.476 184.802 80 200 80C221.536 80 239.096 97.018 239.966 118.34C239.988 118.89 240 119.444 240 120C240 125.8008 238.766 131.3132 236.544 136.2886C230.306 150.2616 216.29 160 200 160C178.0942 160 160.3018 142.3918 160.0038 120.557C160.0014 120.3716 160 120.186 160 120C160 113.106 161.7438 106.62 164.8144 100.958z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DataSearch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DataSearch.displayName = "Blueprint5.Icon.DataSearch";
exports.default = DataSearch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lnajB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataSync", ()=>DataSync);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DataSync = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "data-sync",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 318V210C20 184.132 82.8988 162.83 163.576 160.26L171.6578 168.342C178.9658 175.65 189.0354 180 200 180C210.964 180 221.034 175.65 228.342 168.342L233.788 162.896C235.93 163.134 238.048 163.386 240.146 163.654C240.89 172.906 244.5 181.786 251.358 188.642C259.1140000000001 196.398 269.456 200 280 200C296.3040000000001 200 311.724 196.056 325.3520000000001 189.074C334.756 195.44 340 202.53 340 210V318C310.2 295.4 249.8 280 180 280C110.4 280 50 295.4 20 318zM20 178C44.7878 159.326 90.3298 145.568 144.6674 141.352L131.6578 128.342C124.35 121.034 120 110.964 120 100C120 77.954 137.9544 60 160 60C160.673 60 161.3426 60.016 162.0084 60.048C165.0256 45.268 171.3248 31.652 180.1058 20H180C91.6 20 20 42.4 20 70V178zM180 300C268.4 300 340 322.4 340 350C340 377.6 268.4 400 180 400C91.6 400 20 377.6 20 350C20 322.4 91.8 300 180 300zM280 180C324 180 360 144 360 100V88.2L365.8 94C369.4 97.8 374.4 100 380 100C391 100 400 91 400 80C400 74.4 397.8 69.4 394.2000000000001 65.8L354.2000000000001 25.8C350.6 22.2 345.6 20 340 20C334.4 20 329.4 22.2 325.8 25.8L285.8 65.8C282.2 69.4 280 74.4 280 80C280 91 289 100 300 100C305.6 100 310.6 97.8 314.2000000000001 94.2000000000001L320 88.2V100C320 122 302 140 280 140C268 140 260 148 260 160C260 172 268 180 280 180zM160 80C165.6 80 170.6 82.2 174.2 85.8L180 91.8V80C180 36 216 0 260 0C272 0 280 8 280 20C280 32 272 40 260 40C238 40 220 58 220 80V91.8L225.8 86C229.4 82.2 234.4 80 240 80C251 80 260 89 260 100C260 105.6 257.8 110.6 254.2 114.2000000000001L214.2 154.2C210.6 157.8 205.6 160 200 160C194.4 160 189.4 157.8 185.8 154.2L145.8 114.2000000000001C142.2 110.6 140 105.6 140 100C140 89 149 80 160 80z" : "M140 240C206.2 240 260 258 260 280C260 302 206.2 320 140 320C73.6 320 20 302 20 280C20 258 73.6 240 140 240zM20 249.6V160C20 149.0138 33.4162 139.0252 55.093 131.7774L91.6578 168.3422C98.9658 175.65 109.0354 180 120 180C130.9646 180 141.0342 175.65 148.3422 168.3422L160.1296 156.5546C160.043 157.6986 160 158.848 160 160C160 170.545 163.6022 180.8866 171.3578 188.6422C179.1134 196.3978 189.455 200 200 200C222.472 200 243.264 192.5074 260 179.8944V249.6C235.6 232 191.2 220 140 220C88.8 220 44.4 232 20 249.6zM20 129.6C26.5304 124.8894 34.4934 120.5802 43.6358 116.794C41.2866 111.662 40 105.964 40 100C40 77.954 57.9544 60 80 60C80.673 60 81.3426 60.016 82.0084 60.048C86.918 35.998 100.5174 15.03 119.3582 0.594C62.9698 3.872 20 20.338 20 40V129.6zM280 100C280 144 244 180 200 180C188 180 180 172 180 160C180 148 188 140 200 140C222 140 240 122 240 100V88.2L234.2 94.2C230.6 97.8 225.6 100 220 100C209 100 200 91 200 80C200 74.4 202.2 69.4 205.8 65.8L245.8 25.8C249.4 22.2 254.4 20 260 20C265.6 20 270.6 22.2 274.2000000000001 25.8L314.2000000000001 65.8C317.8 69.4 320 74.4 320 80C320 91 311 100 300 100C294.4000000000001 100 289.4000000000001 97.8 285.8 94L280 88.2V100zM94.2 85.8C90.6 82.2 85.6 80 80 80C69 80 60 89 60 100C60 105.6 62.2 110.6 65.8 114.2L105.8 154.2C109.4 157.8 114.4 160 120 160C125.6 160 130.6 157.8 134.2 154.2L174.2 114.2C177.8 110.6 180 105.6 180 100C180 89 171 80 160 80C154.4 80 149.4 82.2 145.8 86L140 91.8V80C140 58 158 40 180 40C192 40 200 32 200 20C200 8 192 0 180 0C136 0 100 36 100 80V91.8L94.2 85.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DataSync.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DataSync.displayName = "Blueprint5.Icon.DataSync";
exports.default = DataSync;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cocSf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Database", ()=>Database);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Database = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "database",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40.2 298V190C40.2 162.4 111.8 140 200.2 140S360.2 162.4 360.2 190V298C330.4 275.4 270 260 200.2 260C130.6 260 70.2 275.4 40.2 298zM200.2 280C288.6 280 360.2 302.4 360.2 330C360.2 357.6 288.6 380 200.2 380S40.2 357.6 40.2 330C40.2 302.4 112 280 200.2 280zM40.2 158V50C40.2 22.4 111.8 0 200.2 0S360.2 22.4 360.2 50V158C330.4 135.4 270 120 200.2 120C130.6 120 70.2 135.4 40.2 158z" : "M160 240C226.2 240 280 258 280 280C280 302 226.2 320 160 320C93.6 320 40 302 40 280C40 258 93.6 240 160 240zM40 249.6V160C40 138 93.8 120 160 120C226.2 120 280 138 280 160V249.6C255.6 232 211.2 220 160 220S64.4 232 40 249.6zM40 129.6V40C40 18 93.8 0 160 0C226.2 0 280 18 280 40V129.6C255.6 112 211.2 100 160 100S64.4 112 40 129.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Database.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Database.displayName = "Blueprint5.Icon.Database";
exports.default = Database;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Q541":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Delete", ()=>Delete);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Delete = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "delete",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 280C300 291 291 300 280 300C274.4000000000001 300 269.4000000000001 297.8 265.8 294.2L200 228.2L134.2 294.2C130.6 297.8 125.6 300 120 300C109 300 100 291 100 280C100 274.4 102.2 269.4 105.8 265.8L171.8 200L106 134.2000000000001C102.2 130.6 100 125.6 100 120C100 109 109 100 120 100C125.6 100 130.6 102.2 134.2 105.8L200 171.8L265.8 106C269.4000000000001 102.2 274.4000000000001 100 280 100C291 100 300 109 300 120C300 125.6 297.8 130.6 294.2000000000001 134.2000000000001L228.2 200L294 265.8C297.8 269.4 300 274.4 300 280zM200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 40C111.6 40 40 111.6 40 200S111.6 360 200 360S360 288.4 360 200S288.4 40 200 40z" : "M239.8 220.2C239.8 231.2 230.8 240.2 219.8 240.2C214.2 240.2 209.2 238 205.6 234.4L159.8 188.4L114 234.2C110.4 238 105.4 240.2 99.8 240.2C88.8 240.2 79.8 231.2 79.8 220.2C79.8 214.6 82 209.6 85.6 206L131.4 160.2L85.6 114.4C82 110.8 79.8 105.8 79.8 100.2C79.8 89.1999999999999 88.8 80.2 99.8 80.2C105.4 80.2 110.4 82.4 114 85.9999999999999L159.8 131.7999999999999L205.6 85.9999999999999C209.2 82.4 214.2 80.2 219.8000000000001 80.2C230.8000000000001 80.2 239.8000000000001 89.1999999999999 239.8000000000001 100.2C239.8000000000001 105.8 237.6000000000001 110.8 234.0000000000001 114.4L188.2 160.2L234 206C237.6 209.6 239.8 214.6 239.8 220.2zM159.8 320.2C71.4 320.2 -0.2 248.6 -0.2 160.2S71.4 0.2 159.8 0.2S319.8 71.8 319.8 160.2S248.2 320.2 159.8 320.2zM159.8 40.2C93.6 40.2 39.8 94 39.8 160.2S93.6 280.2 159.8 280.2S279.8 226.4 279.8 160.2S226.2 40.2 159.8 40.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Delete.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Delete.displayName = "Blueprint5.Icon.Delete";
exports.default = Delete;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Xoqo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Delta", ()=>Delta);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Delta = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "delta",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400L0 0H400L200 400zM180 280L300 40H60L180 280z" : "M160 320L0 0H320L160 320zM140 220L240 20H40L140 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Delta.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Delta.displayName = "Blueprint5.Icon.Delta";
exports.default = Delta;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Thvi":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeriveColumn", ()=>DeriveColumn);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DeriveColumn = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "derive-column",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M142 236H122.2C127.8 258.2000000000001 135.4 274.4 144.6 284.6C150.2 291 155.8 294.2000000000001 161.2 294.2000000000001C162.2 294.2000000000001 163.2 293.8 163.8 293.2000000000001C164.4 292.6 164.8000000000001 291.8 164.8000000000001 290.8C164.8000000000001 290 164.0000000000001 288.2000000000001 162.6000000000001 285.8C161 283.4 160.2 281 160.2 278.8C160.2 275.8 161.4 273.2 163.8 271C166.2 268.8 169.2 267.8 172.8 267.8C176.8 267.8 180 269.2000000000001 182.6 271.8C185.2 274.4 186.6 278 186.6 282.6C186.6 287.8 184.6 292 180.6 295.2000000000001C176.8 298.4 170.4 300 161.6 300C148 300 135.6 296.2 124.6 288.4C113.4 280.8 102.8 268 92.8 250.2C89.4 244.2 86 240.2 83 238.4C80 236.8 75 235.8 68.2 236L63.6 220.6H82.6L54.8 115.8C50.2 98.6 47 88 45.4 84C43 78.2 39.4 73.2 34.6 69C32.6 67.4 30.4 66.6 27.6 66.6C26.8 66.6 26.2 66.8 25.6 67.2L25 68C25 68.4 25.6 69.4 27 70.6C28.4 71.9999999999999 29 74 29 76.8C29 79.7999999999999 28 82.3999999999999 25.8 84.3999999999999C23.6 86.3999999999999 20.4 87.4 16.4 87.4C11.4 87.4 7.6 85.9999999999999 4.6 83.4C1.6 81 0 77.8 0 74.2000000000001C0 70.4 1.8 67 5.4 64.2000000000001C9.2 61.4 14.8 60 22.6 60C34.8 60 45.8 63 55.2 69.2000000000001C64.8 75.4 73 84.8 80.2 97.8C87.2 110.6 94.6 131.4 102 160L118 220.6H137.2L142 236zM380 400H200C189 400 180 391 180 380V320H220V360H360V40H220V80H180V20C180 9 189 0 200 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM204.2 130.2C207.2 124.6 210.6 120.4 214.6 118C218.4 115.6 223.4 114.2000000000001 229.2 114.2000000000001C234.8 114.2000000000001 240.6 116.2 246.4 120.2000000000001C254.0000000000001 125.2000000000001 261.8 134 269.8 146.4L264.8 149.2000000000001C259.4000000000001 141.8000000000001 255.2 137.2000000000001 252.6 135.4000000000001C250.8 134.2000000000001 248.8 133.6000000000001 246.4 133.6000000000001C243.6 133.6000000000001 240.8 135.4000000000001 238 138.8000000000001C233.4 144.6000000000001 227.2 160.6000000000001 219.4 186.8000000000001C226.4 198.6000000000001 232.2 206.2000000000001 236.8 209.8000000000001C240.2 212.4000000000001 243.8 213.8000000000001 247.8 213.8000000000001C249.2 213.8000000000001 251.8 213.2000000000001 255.6 212.2000000000001C259.4000000000001 211.2000000000001 262.8 210.6000000000001 265.6 210.6000000000001C269.6 210.6000000000001 273 212.0000000000001 275.6 214.6000000000001C278.6 217.4 280 220.8 280 225C280 229.4 278.6 233 276 235.6C273.4 238.2 269.4000000000001 239.6 264.4000000000001 239.6C260 239.6 255.8 238.6 251.8 236.6C247.8 234.6 242.8 230.2 236.8 223.2C232.2 218.2 225.6 209.2 216.6 196.6C213 212.2 207 226.6 198.4 239.6L150.6 231.8L149.6 226.8C153.2 227.4 156.2 227.8 158.6 227.8C163.4 227.8 167.2 225.8 170.4 221.8C175.4 215.6 182.2 197 190.8 165.8C184 157 179.2 151.2 176.8000000000001 148.4C172.6 144 169.2 141.2 166.4 139.8C164.4 138.8 162 138.2 159.4 138.2C157.4000000000001 138.2 154.2000000000001 139.2000000000001 149.6000000000001 141.4C146.6 142.8 143.8000000000001 143.6 141.2000000000001 143.6C136.6 143.6 132.8000000000001 142.2 129.8000000000001 139.2C126.8000000000001 136.4 125.2 132.6 125.2 128.2C125.2 124 126.6 120.6 129.4 118C132.2 115.4 136 114 140.6 114C145.2000000000001 114 149.4 115 153.4 116.8C157.4 118.6 162.4 122.6 168.4 128.6C174.4 134.6 182.8000000000001 144.2 193.4 157.2C197.6 145 201.2 136 204.2 130.2z" : "M121.6 186.6H104.8C109.6 205 116 218.6 124 227.2C128.8 232.6 133.6 235.2 138.2 235.2C139.2 235.2 139.8 235 140.4 234.4C141 233.8 141.2 233.2 141.2 232.4000000000001C141.2 231.6 140.6 230.2 139.2 228.2C138 226.2000000000001 137.2 224.2 137.2 222.4C137.2 219.8 138.2 217.6 140.2000000000001 215.8C142.2 214 144.8000000000001 213 148 213C151.4 213 154.2 214.2 156.4 216.4C158.8 218.6 160 221.6 160 225.4C160 229.8 158.2 233.2 154.8 236C151.4 238.6 146 240 138.6 240C126.8 240 116.2 236.8 106.8 230.4C97.2 224 88.2 213.4 79.6 198.6C76.6 193.4 73.8 190.2 71.2 188.8C68.6 187.4 64.2 186.6 58.4 186.8L54.6 173.8H70.8L47 86.4C43 72 40.4 63.2 39 59.8C37 55 33.8 50.8 29.8 47.4C28.2 46 26.2 45.4 23.8 45.4C23.2 45.4 22.6 45.6 22.2 46L21.6 46.8C21.6 47.2 22.2 48 23.4 49C24.6 50.2 25.2 51.8 25.2 54.2C25.2 56.8 24.2 58.8 22.4 60.6C20.6 62.2 17.8 63.2 14.4 63.2C10.2 63.2 6.8 62.2 4.2 60S0 55 0 52C0 48.8 1.6 46 4.6 43.6C7.8 41.2 12.6 40 19.4 40C30 40 39.2 42.6 47.4 47.8C55.6 53 62.6 60.8 68.8 71.6C74.8 82.4 81.2 99.6 87.6 123.4L101.2 174H117.6L121.6 186.6zM300 320H160C149 320 140 311 140 300V260H180V280H280V40H180V60H140V20C140 9 149 0 160 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM166 121.2C169.6 110.8 172.6 103.4 175.2000000000001 98.6C177.8000000000001 93.8 180.8 90.6 184 88.4C187.4 86.4 191.4 85.2 196.4 85.2C201.2 85.2 206.2 86.8 211.2 90.2C217.8 94.4 224.4 101.8 231.4 112L227.2 114.2C222.6 108 219 104.2 216.8 102.8C215.4 101.8 213.6 101.4 211.6 101.4C209.2 101.4 206.8 102.8 204.4 105.6C200.4 110.4 195.2 123.8 188.4 145.6C194.4 155.4 199.4 161.8 203.4 164.8C206.4 167 209.4 168 212.8 168C214 168 216.2 167.6 219.6 166.8C222.8 166 225.8 165.6 228.2 165.6C231.6 165.6 234.4 166.8 236.8 169C238.8 171.2 240 174 240 177.6C240 181.4 238.8 184.2 236.6 186.4C234.2 188.6 231 189.6 226.8 189.6C223 189.6 219.4 188.8 216 187C212.6 185.2 208.2 181.6 203 175.8C199 171.6 193.4 164.2 185.6 153.6C182.6 166.8 177.4 178.8 170 189.8L129 183.2L128.2 179C131.2 179.6 133.8 179.8 136 179.8C140 179.8 143.4 178.2 146 174.8C150.2 169.6 156 154.2 163.6 128.2C157.8 120.8 153.8 116 151.6 113.8C148 110.2 145 107.8 142.8 106.6C141 105.8 139 105.2 136.8 105.2C135 105.2 132.2 106 128.4 107.8C125.8 109 123.4 109.6 121.2 109.6C117.2 109.6 114 108.4 111.4 106C108.8 103.6 107.6 100.6 107.6 96.8C107.6 93.4 108.8 90.4 111.2 88.2C113.6 86 116.8 85 120.8 85C124.8 85 128.4 85.8 131.8 87.2C135.2 88.8 139.6 92 144.8 97C149.6 102.4 156.8 110.2 166 121.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DeriveColumn.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DeriveColumn.displayName = "Blueprint5.Icon.DeriveColumn";
exports.default = DeriveColumn;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b2ln4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Desktop", ()=>Desktop);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Desktop = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "desktop",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400H20C9 400 0 391 0 380V120C0 109 9 100 20 100H133.4L123.4 40H100C89 40 80 31 80 20C80 9 89 0 100 0H300C311 0 320 9 320 20C320 31 311 40 300 40H276.6L266.6 100H380C391 100 400 109 400 120V380C400 391 391 400 380 400zM360 140H40V360H360V140z" : "M300 320H20C9 320 0 311 0 300V100C0 89 9 80 20 80H115L105 40H80C69 40 60 31 60 20C60 9 69 0 80 0H240C251 0 260 9 260 20C260 31 251 40 240 40H215L205 80H300C311 80 320 89 320 100V300C320 311 311 320 300 320zM280 120H40V280H280V120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Desktop.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Desktop.displayName = "Blueprint5.Icon.Desktop";
exports.default = Desktop;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7bQ12":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Detection", ()=>Detection);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Detection = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "detection",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 400C8.9543 400 0 391.0457 0 380V280C0 268.9544 8.9543 260 20 260C31.0456 260 40 268.9544 40 280V360H120C131.0456 360 140 368.9544 140 380C140 391.0457 131.0456 400 120 400H20zM0 20C0 8.954 8.9543 0 20 0H120C131.0456 0 140 8.954 140 20C140 31.046 131.0456 40 120 40H40V120C40 131.046 31.0456 140 20 140C8.9543 140 0 131.046 0 120V20zM380 0C391.046 0 400 8.954 400 20V120C400 131.046 391.046 140 380 140C368.954 140 360 131.046 360 120V40H280C268.954 40 260 31.046 260 20C260 8.954 268.954 0 280 0H380zM400 380C400 391.0457 391.046 400 380 400H280C268.954 400 260 391.0457 260 380C260 368.9544 268.954 360 280 360H360V280C360 268.9544 368.954 260 380 260C391.046 260 400 268.9544 400 280V380zM100 280C100 291.0456 108.9544 300 120 300H280C291.046 300 300 291.0456 300 280V120C300 108.954 291.046 100 280 100H120C108.9544 100 100 108.954 100 120V280zM140 140V260H260V140H140z" : "M20 320C8.9543 320 0 311.0457 0 300V220C0 208.9544 8.9543 200 20 200C31.0456 200 40 208.9544 40 220V280H100C111.0456 280 120 288.9544 120 300C120 311.0457 111.0456 320 100 320H20zM0 20C0 8.954 8.9543 0 20 0H100C111.0456 0 120 8.954 120 20C120 31.046 111.0456 40 100 40H40V100C40 111.046 31.0456 120 20 120C8.9543 120 0 111.046 0 100V20zM300 0C311.046 0 320 8.954 320 20V100C320 111.046 311.046 120 300 120C288.954 120 280 111.046 280 100V40H220C208.954 40 200 31.046 200 20C200 8.954 208.954 0 220 0H300zM320 300C320 311.0457 311.046 320 300 320H220C208.954 320 200 311.0457 200 300C200 288.9544 208.954 280 220 280H280V220C280 208.9544 288.954 200 300 200C311.046 200 320 208.9544 320 220V300zM80 220C80 231.0456 88.9544 240 100 240H220C231.046 240 240 231.0456 240 220V100C240 88.954 231.046 80 220 80H100C88.9544 80 80 88.954 80 100V220zM120 120V200H200V120H120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Detection.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Detection.displayName = "Blueprint5.Icon.Detection";
exports.default = Detection;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5mffU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Diagnosis", ()=>Diagnosis);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Diagnosis = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "diagnosis",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 360C91.045695 360 100 351.045695 100 340C100 329.7432832 92.2791962 321.2898568 82.3324226 320.1345546L80 320L80 220C80 198.912764 96.3175558 181.636698 117.0147532 180.109714L120 180C141.087236 180 158.3633024 196.317556 159.8902852 217.0147532L160 220L160 320C148.954305 320 140 328.954305 140 340C140 350.2567168 147.7208038 358.7101432 157.6675774 359.8654454L160 360L180 360C190.2567168 360 198.7101432 352.2791962 199.8654454 342.3324226L200 340L200 220C200 182.728696 174.5120448 151.41042 140.0152268 142.52427L140 140C140 106.862916 166.862915 80 200 80C242.843908 80 277.821578 113.67937 279.9020940000001 156.007194L280 160L280.003496 224.1589092C262.342582 231.873677 250 249.4954564 250 270C250 297.6142374 272.385762 320 300 320C327.614238 320 350 297.6142374 350 270C350 249.503235 337.666782 231.8870474 320.0166000000001 224.1676936L320 160C320 93.72583 266.2741700000001 40 200 40C146.224906 40 102.3636378 82.446134 100.0923902 135.662208L100 140L100.0077968 142.518344C66.7386466 151.077634 41.8432012 180.4994 40.0979062 216.0071932L40 220L40 340C40 350.2567168 47.7208038 358.7101432 57.6675774 359.8654454L60 360L80 360z" : "M64 300C75.045695 300 84 291.045695 84 280C84 269.7432832 76.2791962 261.2898568 66.3324226 260.1345546L64 260L60 260L60 200C60 178.912764 76.3175558 161.6366976 97.0147532 160.1097148L100 160C121.087236 160 138.3633024 176.3175558 139.8902852 197.0147532L140 200L140 260L136 260C125.7432832 260 117.2898568 267.7208038 116.1345546 277.6675774000001L116 280C116 290.2567168 123.7208038 298.7101432 133.6675774 299.8654454L136 300L160 300C170.2567168 300 178.7101432 292.2791962 179.8654454 282.3324226L180 280L180 200C180 162.6707978 154.4327974 131.3131358 119.8543998 122.4830216C119.8526456 122.4406944 119.8591538 122.3865914 119.8654454 122.3324226L120 120C120 86.862916 146.862915 60 180 60C211.953618 60 238.073218 84.9784 239.898146 116.474544L240 120L239.9834 164.1676936C222.333218 171.8870474 210 189.503235 210 210C210 237.6142374 232.385762 260 260 260C287.614238 260 310 237.6142374 310 210C310 189.4954564 297.657418 171.873677 279.996504 164.1589092L280 120C280 64.771526 235.228474 20 180 20C124.771525 20 80 64.771526 80 120C80 120.844835 80.052383 121.6774354 80.154078 122.4947304C46.8077766 130.9960002 21.8456228 160.450132 20.0979062 196.0071932L20 200L20 280C20 290.2567168 27.7208038 298.7101432 37.6675774 299.8654454L40 300L64 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Diagnosis.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Diagnosis.displayName = "Blueprint5.Icon.Diagnosis";
exports.default = Diagnosis;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ihOt5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiagramTree", ()=>DiagramTree);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DiagramTree = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "diagram-tree",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 200L380 100L340 100L340 180L220 180L220 100L180 100L180 180L60 180L60 100L20 100L20 200C20 211.045695 28.954305 220 40 220L180 220L180 300L220 300L220 220L360 220C371.0456940000001 220 380 211.045695 380 200zM20 80L60 80C71.045695 80 80 71.045694 80 60L80 20C80 8.954306 71.045695 0 60 0L20 0C8.954305 0 0 8.954306 0 20L0 60C0 71.045694 8.954305 80 20 80zM340 80L380 80C391.0456940000001 80 400 71.045694 400 60L400 20C400 8.954306 391.0456940000001 0 380 0L340 0C328.954306 0 320 8.954306 320 20L320 60C320 71.045694 328.954306 80 340 80zM180 80L220 80C231.045694 80 240 71.045694 240 60L240 20C240 8.954306 231.045694 0 220 0L180 0C168.954305 0 160 8.954306 160 20L160 60C160 71.045694 168.954305 80 180 80zM180 400L220 400C231.045694 400 240 391.045695 240 380L240 340C240 328.954305 231.045694 320 220 320L180 320C168.954305 320 160 328.954305 160 340L160 380C160 391.045695 168.954305 400 180 400z" : "M300 160L300 100L260 100L260 140L180 140L180 100L140 100L140 140L60 140L60 100L20 100L20 160C20 171.045695 28.954305 180 40 180L140 180L140 220L180 220L180 180L280 180C291.045694 180 300 171.045695 300 160zM20 80L60 80C71.045695 80 80 71.045694 80 60L80 20C80 8.954306 71.045695 0 60 0L20 0C8.954305 0 0 8.954306 0 20L0 60C0 71.045694 8.954305 80 20 80zM260 80L300 80C311.045694 80 320 71.045694 320 60L320 20C320 8.954306 311.045694 0 300 0L260 0C248.954306 0 240 8.954306 240 20L240 60C240 71.045694 248.954306 80 260 80zM140 80L180 80C191.045695 80 200 71.045694 200 60L200 20C200 8.954306 191.045695 0 180 0L140 0C128.954305 0 120 8.954306 120 20L120 60C120 71.045694 128.954305 80 140 80zM140 320L180 320C191.045695 320 200 311.045695 200 300L200 260C200 248.954305 191.045695 240 180 240L140 240C128.954305 240 120 248.954305 120 260L120 300C120 311.045695 128.954305 320 140 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DiagramTree.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DiagramTree.displayName = "Blueprint5.Icon.DiagramTree";
exports.default = DiagramTree;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jYapn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectionLeft", ()=>DirectionLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DirectionLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "direction-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 339.6L0 199.6L400 59.6L300 199.6z" : "M320 280.2L0 160.2L320 40.2L240 160.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DirectionLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DirectionLeft.displayName = "Blueprint5.Icon.DirectionLeft";
exports.default = DirectionLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g3hkr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectionRight", ()=>DirectionRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DirectionRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "direction-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 199.6L0 339.6L100 199.6L0 59.6z" : "M320 160.2L0 280.2L80 160.2L0 40.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DirectionRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DirectionRight.displayName = "Blueprint5.Icon.DirectionRight";
exports.default = DirectionRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ydTO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Disable", ()=>Disable);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Disable = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "disable",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM40 200C40 288.4 111.6 360 200 360C237 360 271 347.4 298 326.2L73.8 102C52.6 129 40 163 40 200zM200 40C163 40 129 52.6 102 73.8L326.2 298C347.4000000000001 271 360 237 360 200C360 111.6 288.4 40 200 40z" : "M159.8 320.2C71.4 320.2 -0.2 248.6 -0.2 160.2S71.4 0.2 159.8 0.2S319.8 71.8 319.8 160.2S248.2 320.2 159.8 320.2zM39.8 160.2C39.8 226.4 93.6 280.2 159.8 280.2C185.8 280.2 209.6 271.8 229.2 257.8L62.2 90.8C48.2 110.4 39.8 134.2 39.8 160.2zM159.8 40.2C133.8 40.2 110 48.6 90.4 62.6L257.4 229.6C271.4 210 279.8 186.2 279.8 160.2C279.8 93.8 226.2 40.2 159.8 40.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Disable.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Disable.displayName = "Blueprint5.Icon.Disable";
exports.default = Disable;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8fP8n":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Divide", ()=>Divide);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Divide = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "divide",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M225 275C225 261.1928000000001 213.808 250 200 250C186.1928 250 175 261.1928000000001 175 275C175 288.8072 186.1928 300 200 300C213.808 300 225 288.8072 225 275zM120 220C109 220 100 211 100 200C100 189 109 180 120 180H280C291 180 300 189 300 200C300 211 291 220 280 220H120zM200 100C213.808 100 225 111.192 225 125C225 138.808 213.808 150 200 150C186.1928 150 175 138.808 175 125C175 111.192 186.1928 100 200 100z" : "M180 220C180 208.9544 171.0456 200 160 200C148.9544 200 140 208.9544 140 220C140 231.0456 148.9544 240 160 240C171.0456 240 180 231.0456 180 220zM100 180C89 180 80 171 80 160C80 149 89 140 100 140H220C231 140 240 149 240 160C240 171 231 180 220 180H100zM160 80C171.0456 80 180 88.954 180 100C180 111.046 171.0456 120 160 120C148.9544 120 140 111.046 140 100C140 88.954 148.9544 80 160 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Divide.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Divide.displayName = "Blueprint5.Icon.Divide";
exports.default = Divide;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7M4BR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocumentOpen", ()=>DocumentOpen);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DocumentOpen = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "document-open",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 100C160 89 169 80 180 80S200 89 200 100V200C200 211 191 220 180 220H80C69 220 60 211 60 200S69 180 80 180H131.8L26 74.2000000000001C22.2 70.6 20 65.6 20 60C20 49 29 40 40 40C45.6 40 50.6 42.2 54.2 45.8L160 151.8V100zM260 400H100C89 400 80 391 80 380V260H120V360H240V260H340V40H120V55.2L80.8 16C82.8 7 90.4 0 100 0H360C371 0 380 9 380 20V280L260 400z" : "M120 80C120 69 129 60 140 60S160 69 160 80V160C160 171 151 180 140 180H60C49 180 40 171 40 160C40 149 49 140 60 140H91.8L26 74.2C22.2 70.6 20 65.6 20 60C20 49 29 40 40 40C45.6 40 50.6 42.2 54.2 45.8L120 111.8V80zM200 320H80C69 320 60 311 60 300V220H100V280H180V200H260V40H104.8L68.8 4C72 1.6 75.8 0 80 0H280C291 0 300 9 300 20V220L200 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DocumentOpen.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DocumentOpen.displayName = "Blueprint5.Icon.DocumentOpen";
exports.default = DocumentOpen;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kKcxR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocumentShare", ()=>DocumentShare);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DocumentShare = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "document-share",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M281.8 198.2C275.6 192 268.4 186.8 260 183.8V40H40V360H160V260H183.6C186.6 268.4 191.4 276 197.6 282.2L197.6 282.4L246.6 331.4C238.2000000000001 337.2 231.0000000000001 344.4 226.4000000000001 353.6L180 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H280C291 0 300 9 300 20V215.2L282.4 197.6L281.8 198.2zM380 400H280C269 400 260 391 260 380C260 369 269 360 280 360H331.8L226 254.2C222.2 250.6 220 245.6 220 240C220 229 229 220 240 220C245.6 220 250.6 222.2 254.2 225.8L360 331.8V280C360 269 369 260 380 260S400 269 400 280V380C400 391 391 400 380 400z" : "M200 40H40V280H120V200H140C140 216.6 147.2 231 158.2 241.8L157.6 242.4L175.6 260.4C166 271 160 284.6 160 300L140 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H220C231 0 240 9 240 20V155.6C229.4 146 215.4 140 200 140V40zM300 320H220C209 320 200 311 200 300S209 280 220 280H251.8L185.8 214.2C182.2 210.6 180 205.6 180 200C180 189 189 180 200 180C205.6 180 210.6 182.2 214.2 185.8L280 251.8V220C280 209 289 200 300 200S320 209 320 220V300C320 311 311 320 300 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DocumentShare.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DocumentShare.displayName = "Blueprint5.Icon.DocumentShare";
exports.default = DocumentShare;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cOLqs":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Document", ()=>Document);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Document = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "document",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M239.6 400H79.6C68.6 400 59.6 391 59.6 380V20C59.6 9 68.6 0 79.6 0H339.6C350.6 0 359.6 9 359.6 20V280L239.6 400zM319.6 40H99.6V360H219.6V260H319.6V40z" : "M180 320H60C49 320 40 311 40 300V20C40 9 49 0 60 0H260C271 0 280 9 280 20V220L180 320zM240 40H80V280H160V200H240V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Document.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Document.displayName = "Blueprint5.Icon.Document";
exports.default = Document;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"XAoln":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dollar", ()=>Dollar);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Dollar = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "dollar",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M311.4 176.2C306 186.4 298.8 194.8 290 201.4C281.2 208 271 213.4 259.8 217.2C248.6 221.2 237 224.4 225.4 227.2C213.4 230 201.6 232.4 190.4 234.8C179 237.4 169 240.2 160.2 243.6C151.4 247 144.2 251.2 138.8 256.2C133.4 261.2 130.6 268 130.6 276.2C130.6 282.8 132.4 288.2 136.2 292.4C140 296.6 144.6 299.6 150 301.8C155.4 304 161.4 305.4 167.6 306.2C173.8 307 179.2 307.4 183.6 307.4C197.8 307.4 210.6 304.6 221.6 299.2C232.6000000000001 293.8 239.8000000000001 283 242.8000000000001 266.8H310.0000000000001C308.2000000000001 283.6 303.6 298 296.2000000000001 310C288.8000000000001 322 279.6 331.6 268.6000000000001 339C257.4000000000001 346.4 245.0000000000001 351.8 231.4000000000001 355.2C227.6000000000001 356.2 223.8000000000001 356.6 220.0000000000001 357.2V380C220.0000000000001 391 211.0000000000001 400 200.0000000000001 400H180.0000000000001C169.0000000000001 400 160.0000000000001 391 160.0000000000001 380V358C155.6000000000001 357.4 151.4000000000001 357 146.8000000000001 356C132.2 353.4 119 348.6 107.2 341.8C95.2 335 85.4 325.8 77.8 314.8C70 303.6 66.2 289.8 66.2 273.2C66.2 258 68.8 245 74.2 234.6C79.4 224.2 86.6 215.6 95.4 209C104.2 202.4 114.2 197 125.4 193.2C136.4 189.2 148 186 160.2 183.2C171.8 180.4 183.4 178 194.6 175.6C205.8 173.2 216 170.4 224.8 167C233.6 163.6 240.8 159.2 246.6 153.8C252.2 148.4 255.2 141.2 255.6 132.6C256 124 254 117 249.6 111.8C245.2 106.6 239.8 102.4 233 99.8C226.2 97 219 95.2 211.2 94.2000000000001C203.4 93.2 196.6 92.8 190.6 92.8C173.2 92.8 158.4 96.8 146 104.6C133.6 112.4 126.4 126.2 124.6 145.8H60C60.4 127.8 63.8 112.2000000000001 70.4 99C77 85.8 86 74.8000000000001 97.4 66C108.8 57.2 122.4 50.6 138 46.4C145 44.4 152.2 43.2 159.6 42.2V20C159.6 9 168.6 0 179.6 0H199.6C210.6 0 219.6 9 219.6 20V42.6C224.6 43.4 229.6 44 234.8 45.1999999999999C250.2 48.8 264.2000000000001 54.4 276.8 62.2C289.4000000000001 70 299.6 80.2 307.6 92.8C315.6 105.4 319.4 120.6 319.4 138.6C319.6 153.6 316.8 166 311.4 176.2z" : "M256.6 129.8C254.6 135.8 251.6 141.4 247.6 146.6C243.6 151.8 238.6 156.4 232.6 160.6C226.6 164.6 219.6 167.8 211.6 170.2C208.4 171 203 172.4 195.6 174.2C188.6 176 181 177.8 173.2 179.8C165.4 181.8 158.4 183.6 152 185.2C145.8 186.8 142.2 187.6 141.2 187.8C132.6 190.2 125.6 193.6 120.2 198.2C114.8 202.8 112.2 209.2 112.2 217.2C112.2 223 113.6 227.8 116.4 231.6C119.2 235.4 122.8 238.4 127.2 240.8C131.6 243 136.4 244.6 141.6 245.6C146.8 246.6 152 247.2 157 247.2C171.8 247.2 184 244.2 193.6 238C203.2 232 208.6 221.4 209.8 206.8H252.6C252.6 218.8 250 229.4 245 238.4C240 247.4 233.2 255.2 224.6 261.4C216 267.6 206 272.2 194.8 275.4C190 276.6 185 277.4 179.8 278.2V300C179.8 311 170.8 320 159.8 320C148.8 320 139.8 311 139.8 300V278.4C135.2 277.8 130.6 277 126.2 275.8C115.4 273.2 105.8 269 97.4 263.6C89 258 82.2 251 77 242.6C71.8 234 69.2 224 69.2 212.6C69.2 206.6 70 200.8 71.8 195C73.6 189.2 76.4 183.8 80.6 178.6C84.8 173.4 90.2 168.8 97.2 164.6C104.2 160.4 113 157 123.4 154.4C140.4 150.2 154.6 146.8 166.2 144C177.8 141.4 187.8 138.4 196.6 135.6C201.6 133.8 206.2 131 210.4 126.8C214.6 122.6 216.8 116.2 216.8 107.4C216.8 103.2 215.8 99 214 94.8C212.2 90.6 209.2 86.9999999999999 205 83.8C200.8 80.6 195.6 78 188.8 75.9999999999999C182.2 73.9999999999999 174.2 72.9999999999999 164.8 72.9999999999999C156.2 72.9999999999999 148 73.9999999999999 140.6 75.8C133.2 77.5999999999999 126.6 80.6 120.8 84.4C115 88.3999999999999 110.6 93.3999999999999 107.4 99.5999999999999C104.2 105.8 102.6 113.1999999999999 102.6 122H60C60.2 107.8 63 95.6 68.6 85.2C74 74.8 81.4 66.4 90.6 59.8C99.8 53.2 110.4 48.2 122.8 44.9999999999999C128.2 43.6 134 42.6 139.8 41.8V20C139.8 9 148.8 0 159.8 0C170.8 0 179.8 9 179.8 20V41C185.8 41.6 192 42.6 197.8 44C209.4 46.6 219.8 50.8 229.0000000000001 56.6C238.2000000000001 62.4 245.6 69.8 251.2 78.8C256.8 87.8 259.6 98.8 259.6 111.6C259.6 117.8 258.6 123.8 256.6 129.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Dollar.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Dollar.displayName = "Blueprint5.Icon.Dollar";
exports.default = Dollar;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45zBM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dot", ()=>Dot);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Dot = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "dot",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 200A80 80 0 0 1 280 200A80 80 0 0 1 120 200" : "M100 160A60 60 0 0 1 220 160A60 60 0 0 1 100 160",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Dot.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Dot.displayName = "Blueprint5.Icon.Dot";
exports.default = Dot;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hVoPF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoubleCaretHorizontal", ()=>DoubleCaretHorizontal);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DoubleCaretHorizontal = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "double-caret-horizontal",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 320C155.2 320 150.8 318 147.4 315.2L147.2 315.4L27.2 215.4L27.4 215.2C23 211.4 20 206.2 20 200C20 193.8 23 188.6 27.4 184.8L27.2 184.6L147.2 84.6L147.4 84.8C150.8 82 155.2 80 160 80C171 80 180 89 180 100V300C180 311 171 320 160 320zM380 200C380 206.2 377 211.4 372.6 215.2L372.8 215.4L252.8 315.4L252.6 315.2C249.2 318 244.8 320 240 320C229 320 220 311 220 300V100C220 89 229 80 240 80C244.8 80 249.2 82 252.6 84.8L252.8 84.6L372.8 184.6L372.6 184.8C377 188.6 380 193.8 380 200z" : "M274.2000000000001 174.2L214.2 234.2C210.6 237.8 205.6 240 200 240C189 240 180 231 180 220V100C180 89 189 80 200 80C205.6 80 210.6 82.2 214.2 85.8L274.2000000000001 145.8C277.8 149.4 280 154.4 280 160C280 165.6 277.8 170.6 274.2000000000001 174.2zM120 240C114.4 240 109.4 237.8 105.8 234.2L45.8 174.2C42.2 170.6 40 165.6 40 160C40 154.4 42.2 149.4 45.8 145.8L105.8 85.8C109.4 82.2 114.4 80 120 80C131 80 140 89 140 100V220C140 231 131 240 120 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DoubleCaretHorizontal.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DoubleCaretHorizontal.displayName = "Blueprint5.Icon.DoubleCaretHorizontal";
exports.default = DoubleCaretHorizontal;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"25ncP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoubleCaretVertical", ()=>DoubleCaretVertical);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DoubleCaretVertical = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "double-caret-vertical",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100 220H300C311 220 320 229 320 240C320 244.8 318 249.2 315.2 252.6L315.4 252.8L215.4 372.8L215.2 372.6C211.4 377 206.2 380 200 380S188.6 377 184.8 372.6L184.6 372.8L84.6 252.8L84.8 252.6C82 249.2 80 244.8 80 240C80 229 89 220 100 220zM300 180H100C89 180 80 171 80 160C80 155.2 82 150.8 84.8 147.4L84.6 147.2L184.6 27.2L184.8 27.4C188.6 23 193.8 20 200 20S211.4 23 215.2 27.4L215.4 27.2L315.4 147.2L315.2 147.4C318 150.8 320 155.2 320 160C320 171 311 180 300 180z" : "M100 180H220C231 180 240 189 240 200C240 205.6 237.8 210.6 234.2 214.2L174.2 274.2C170.6 277.8 165.6 280 160 280S149.4 277.8 145.8 274.2L85.8 214.2C82.2 210.6 80 205.6 80 200C80 189 89 180 100 180zM220 140H100C89 140 80 131 80 120C80 114.4 82.2 109.4 85.8 105.8L145.8 45.8C149.4 42.2 154.4 40 160 40S170.6 42.2 174.2 45.8L234.2 105.8C237.8 109.4 240 114.4 240 120C240 131 231 140 220 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DoubleCaretVertical.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DoubleCaretVertical.displayName = "Blueprint5.Icon.DoubleCaretVertical";
exports.default = DoubleCaretVertical;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iHyY5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoubleChevronDown", ()=>DoubleChevronDown);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DoubleChevronDown = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "double-chevron-down",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M185.8 185.8C189.4 182.2 194.4 180 200 180S210.6 182.2 214.2 185.8L334.2000000000001 305.8C337.8 309.4 340 314.4 340 320C340 331 331 340 320 340C314.4000000000001 340 309.4000000000001 337.8 305.8 334.2L200 228.2L94.2 334.2C90.6 337.8 85.6 340 80 340C69 340 60 331 60 320C60 314.4 62.2 309.4 65.8 305.8L185.8 185.8zM320 220C314.4000000000001 220 309.4000000000001 217.8 305.8 214.2L200 108.2L94.2 214.2C90.6 217.8 85.6 220 80 220C69 220 60 211 60 200C60 194.4 62.2 189.4 65.8 185.8L185.8 65.8C189.4 62.2 194.4 60 200 60S210.6 62.2 214.2 65.8L334.2000000000001 185.8C337.8 189.4 340 194.4 340 200C340 211 331 220 320 220z" : "M145.8 145.8C149.4 142.2 154.4 140 160 140S170.6 142.2 174.2 145.8L254.2 225.8C257.8 229.4 260 234.4 260 240C260 251 251 260 240 260C234.4 260 229.4 257.8 225.8 254.2L160 188.2L94.2 254.2C90.6 257.8 85.6 260 80 260C69 260 60 251 60 240C60 234.4 62.2 229.4 65.8 225.8L145.8 145.8zM240 160C234.4 160 229.4 157.8 225.8 154.2L160 88.2L94.2 154.2C90.6 157.8 85.6 160 80 160C69 160 60 151 60 140C60 134.4 62.2 129.4 65.8 125.8L145.8 45.8C149.4 42.2 154.4 40 160 40S170.6 42.2 174.2 45.8L254.2 125.8C257.8 129.4 260 134.4 260 140C260 151 251 160 240 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DoubleChevronDown.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DoubleChevronDown.displayName = "Blueprint5.Icon.DoubleChevronDown";
exports.default = DoubleChevronDown;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gkJmi":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoubleChevronLeft", ()=>DoubleChevronLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DoubleChevronLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "double-chevron-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M108.2 200L214 305.8C217.8 309.4 220 314.4 220 320C220 331 211 340 200 340C194.4 340 189.4 337.8 185.8 334.2L65.8 214.2C62.2 210.6 60 205.6 60 200C60 194.4 62.2 189.4 65.8 185.8L185.8 65.8C189.4 62.2 194.4 60 200 60C211 60 220 69 220 80C220 85.6 217.8 90.6 214.2 94.2000000000001L108.2 200zM228.2 200L334 305.8C337.8 309.4 340 314.4 340 320C340 331 331 340 320 340C314.4000000000001 340 309.4000000000001 337.8 305.8 334.2L185.8 214.2C182.2 210.6 180 205.6 180 200C180 194.4 182.2 189.4 185.8 185.8L305.8 65.8C309.4000000000001 62.2 314.4000000000001 60 320 60C331 60 340 69 340 80C340 85.6 337.8 90.6 334.2000000000001 94.2000000000001L228.2 200z" : "M88.2 160L154 225.8C157.8 229.4 160 234.4 160 240C160 251 151 260 140 260C134.4 260 129.4 257.8 125.8 254.2L45.8 174.2C42.2 170.6 40 165.6 40 160C40 154.4 42.2 149.4 45.8 145.8L125.8 65.8C129.4 62.2 134.4 60 140 60C151 60 160 69 160 80C160 85.6 157.8 90.6 154.2 94.2L88.2 160zM188.2 160L254 225.8C257.8 229.4 260 234.4 260 240C260 251 251 260 240 260C234.4 260 229.4 257.8 225.8 254.2L145.8 174.2C142.2 170.6 140 165.6 140 160C140 154.4 142.2 149.4 145.8 145.8L225.8 65.8C229.4 62.2 234.4 60 240 60C251 60 260 69 260 80C260 85.6 257.8 90.6 254.2 94.2L188.2 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DoubleChevronLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DoubleChevronLeft.displayName = "Blueprint5.Icon.DoubleChevronLeft";
exports.default = DoubleChevronLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6rJq5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoubleChevronRight", ()=>DoubleChevronRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DoubleChevronRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "double-chevron-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 200C220 205.6 217.8 210.6 214.2 214.2L94.2 334.2000000000001C90.6 337.8 85.6 340 80 340C69 340 60 331 60 320C60 314.4 62.2 309.4 65.8 305.8L171.8 200L66 94.2000000000001C62.2 90.6 60 85.6 60 80C60 69 69 60 80 60C85.6 60 90.6 62.2 94.2 65.8L214.2 185.8C217.8 189.4 220 194.4 220 200zM334.2000000000001 214.2L214.2 334.2000000000001C210.6 337.8 205.6 340 200 340C189 340 180 331 180 320C180 314.4 182.2 309.4 185.8 305.8L291.8 200L186 94.2000000000001C182.2 90.6 180 85.6 180 80C180 69 189 60 200 60C205.6 60 210.6 62.2 214.2 65.8L334.2000000000001 185.8C337.8 189.4 340 194.4 340 200C340 205.6 337.8 210.6 334.2000000000001 214.2z" : "M180 160C180 165.6 177.8 170.6 174.2 174.2L94.2 254.2C90.6 257.8 85.6 260 80 260C69 260 60 251 60 240C60 234.4 62.2 229.4 65.8 225.8L131.8 160L66 94.2C62.2 90.6 60 85.6 60 80C60 69 69 60 80 60C85.6 60 90.6 62.2 94.2 65.8L174.2 145.8C177.8 149.4 180 154.4 180 160zM274.2000000000001 174.2L194.2 254.2C190.6 257.8 185.6 260 180 260C169 260 160 251 160 240C160 234.4 162.2 229.4 165.8 225.8L231.8 160L166 94.2C162.2 90.6 160 85.6 160 80C160 69 169 60 180 60C185.6 60 190.6 62.2 194.2 65.8L274.2000000000001 145.8C277.8 149.4 280 154.4 280 160C280 165.6 277.8 170.6 274.2000000000001 174.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DoubleChevronRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DoubleChevronRight.displayName = "Blueprint5.Icon.DoubleChevronRight";
exports.default = DoubleChevronRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iwPyX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoubleChevronUp", ()=>DoubleChevronUp);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DoubleChevronUp = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "double-chevron-up",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 180C85.6 180 90.6 182.2 94.2 185.8L200 291.8L305.8 186C309.4000000000001 182.2 314.4000000000001 180 320 180C331 180 340 189 340 200C340 205.6 337.8 210.6 334.2000000000001 214.2L214.2 334.2000000000001C210.6 337.8 205.6 340 200 340C194.4 340 189.4 337.8 185.8 334.2L65.8 214.2C62.2 210.6 60 205.6 60 200C60 189 69 180 80 180zM214.2 214.2C210.6 217.8 205.6 220 200 220C194.4 220 189.4 217.8 185.8 214.2L65.8 94.2000000000001C62.2 90.6 60 85.6 60 80C60 69 69 60 80 60C85.6 60 90.6 62.2 94.2 65.8L200 171.8L305.8 66C309.4000000000001 62.2 314.4000000000001 60 320 60C331 60 340 69 340 80C340 85.6 337.8 90.6 334.2000000000001 94.2000000000001L214.2 214.2z" : "M80 160C85.6 160 90.6 162.2 94.2 165.8L160 231.8L225.8 166C229.4 162.2 234.4 160 240 160C251 160 260 169 260 180C260 185.6 257.8 190.6 254.2 194.2L174.2 274.2C170.6 277.8 165.6 280 160 280S149.4 277.8 145.8 274.2L65.8 194.2C62.2 190.6 60 185.6 60 180C60 169 69 160 80 160zM174.2 174.2C170.6 177.8 165.6 180 160 180S149.4 177.8 145.8 174.2L65.8 94.2C62.2 90.6 60 85.6 60 80C60 69 69 60 80 60C85.6 60 90.6 62.2 94.2 65.8L160 131.8L225.8 66C229.4 62.2 234.4 60 240 60C251 60 260 69 260 80C260 85.6 257.8 90.6 254.2 94.2L174.2 174.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DoubleChevronUp.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DoubleChevronUp.displayName = "Blueprint5.Icon.DoubleChevronUp";
exports.default = DoubleChevronUp;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"97Tac":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoughnutChart", ()=>DoughnutChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DoughnutChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "doughnut-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 200C320 133.8 266.2 80 200 80S80 133.8 80 200S133.8 320 200 320V400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200H320zM318.2 220H399C389.6 314.4 314.4000000000001 389.6 220 399V318C270.2 309.6 309.8 270.2 318.2 220z" : "M237.2 180H318.2C309 252.2 252.2 309.6 180 318.6V237.2C208 230 229.8 208 237.2 180zM240 160C240 115.8 204.2 80 160 80S80 115.8 80 160C80 204.2 115.8 240 160 240V320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160H240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DoughnutChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DoughnutChart.displayName = "Blueprint5.Icon.DoughnutChart";
exports.default = DoughnutChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bxNdW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Download", ()=>Download);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Download = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "download",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM294.2000000000001 165.8L214.2 85.8C210.6 82.2 205.6 80 200 80S189.4 82.2 185.8 85.8L105.8 165.8C102.2 169.4 100 174.4 100 180C100 191 109 200 120 200C125.6 200 130.6 197.8 134.2 194.2L180 148.2V300C180 311 189 320 200 320S220 311 220 300V148.2L265.8 194C269.4000000000001 197.8 274.4000000000001 200 280 200C291 200 300 191 300 180C300 174.4 297.8 169.4 294.2000000000001 165.8z" : "M159.8 320.2C71.4 320.2 -0.2 248.6 -0.2 160.2S71.4 0.2 159.8 0.2S319.8 71.8 319.8 160.2S248.2 320.2 159.8 320.2zM234 126L174 66C170.4 62.4 165.4 60.2000000000001 159.8 60.2000000000001S149.2 62.4 145.6 66L85.6 126C82 129.6 79.8 134.6 79.8 140.2C79.8 151.2 88.8 160.2 99.8 160.2C105.4 160.2 110.4 158 114 154.4L139.8 128.6V240.2C139.8 251.2 148.8 260.2 159.8 260.2S179.8 251.2 179.8 240.2V128.4L205.6 154.2C209.2 157.8 214.2 160 219.8000000000001 160C230.8000000000001 160 239.8000000000001 151 239.8000000000001 140C239.8 134.6 237.6 129.6 234 126z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Download.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Download.displayName = "Blueprint5.Icon.Download";
exports.default = Download;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lwSnz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragHandleHorizontal", ()=>DragHandleHorizontal);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DragHandleHorizontal = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "drag-handle-horizontal",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M150 180C133.4 180 120 166.6 120 150S133.4 120 150 120S180 133.4 180 150S166.6 180 150 180zM50 280C33.4 280 20 266.6 20 250S33.4 220 50 220S80 233.4 80 250S66.6 280 50 280zM50 180C33.4 180 20 166.6 20 150S33.4 120 50 120S80 133.4 80 150S66.6 180 50 180zM350 220C366.6 220 380 233.4 380 250S366.6 280 350 280S320 266.6 320 250S333.4000000000001 220 350 220zM250 180C233.4 180 220 166.6 220 150S233.4 120 250 120S280 133.4 280 150S266.6 180 250 180zM350 180C333.4000000000001 180 320 166.6 320 150S333.4000000000001 120 350 120S380 133.4 380 150S366.6 180 350 180zM150 280C133.4 280 120 266.6 120 250S133.4 220 150 220S180 233.4 180 250S166.6 280 150 280zM250 280C233.4 280 220 266.6 220 250S233.4 220 250 220S280 233.4 280 250S266.6 280 250 280z" : "M40 140C29 140 20 131 20 120C20 109 29 100 40 100S60 109 60 120C60 131 51 140 40 140zM40 220C29 220 20 211 20 200C20 189 29 180 40 180S60 189 60 200C60 211 51 220 40 220zM120 140C109 140 100 131 100 120C100 109 109 100 120 100S140 109 140 120C140 131 131 140 120 140zM280 180C291 180 300 189 300 200C300 211 291 220 280 220S260 211 260 200C260 189 269 180 280 180zM280 140C269 140 260 131 260 120C260 109 269 100 280 100S300 109 300 120C300 131 291 140 280 140zM200 220C189 220 180 211 180 200C180 189 189 180 200 180S220 189 220 200C220 211 211 220 200 220zM200 140C189 140 180 131 180 120C180 109 189 100 200 100S220 109 220 120C220 131 211 140 200 140zM120 220C109 220 100 211 100 200C100 189 109 180 120 180S140 189 140 200C140 211 131 220 120 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DragHandleHorizontal.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DragHandleHorizontal.displayName = "Blueprint5.Icon.DragHandleHorizontal";
exports.default = DragHandleHorizontal;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g8mmJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragHandleVertical", ()=>DragHandleVertical);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DragHandleVertical = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "drag-handle-vertical",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M150 280C133.4 280 120 266.6 120 250S133.4 220 150 220S180 233.4 180 250S166.6 280 150 280zM150 180C133.4 180 120 166.6 120 150S133.4 120 150 120S180 133.4 180 150S166.6 180 150 180zM150 80C133.4 80 120 66.6 120 50S133.4 20 150 20S180 33.4 180 50S166.6 80 150 80zM250 320C266.6 320 280 333.4 280 350S266.6 380 250 380S220 366.6 220 350S233.4 320 250 320zM150 380C133.4 380 120 366.6 120 350S133.4 320 150 320S180 333.4 180 350S166.6 380 150 380zM250 180C233.4 180 220 166.6 220 150S233.4 120 250 120S280 133.4 280 150S266.6 180 250 180zM250 80C233.4 80 220 66.6 220 50S233.4 20 250 20S280 33.4 280 50S266.6 80 250 80zM250 280C233.4 280 220 266.6 220 250S233.4 220 250 220S280 233.4 280 250S266.6 280 250 280z" : "M120 140C109 140 100 131 100 120C100 109 109 100 120 100S140 109 140 120C140 131 131 140 120 140zM200 260C211 260 220 269 220 280C220 291 211 300 200 300S180 291 180 280C180 269 189 260 200 260zM120 60C109 60 100 51 100 40C100 29 109 20 120 20S140 29 140 40C140 51 131 60 120 60zM120 220C109 220 100 211 100 200C100 189 109 180 120 180S140 189 140 200C140 211 131 220 120 220zM120 300C109 300 100 291 100 280C100 269 109 260 120 260S140 269 140 280C140 291 131 300 120 300zM200 140C189 140 180 131 180 120C180 109 189 100 200 100S220 109 220 120C220 131 211 140 200 140zM200 220C189 220 180 211 180 200C180 189 189 180 200 180S220 189 220 200C220 211 211 220 200 220zM200 60C189 60 180 51 180 40C180 29 189 20 200 20S220 29 220 40C220 51 211 60 200 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DragHandleVertical.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DragHandleVertical.displayName = "Blueprint5.Icon.DragHandleVertical";
exports.default = DragHandleVertical;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ccrQu":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Draw", ()=>Draw);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Draw = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "draw",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M354 146C354 148 354 150 352 152H352L312 292H312C310 298 306 304 300 306L300 306L36 400L24 390L154 260C160 264 166 266 174 266C196 266 214 248 214 226S196 186 174 186S134 204 134 226C134 234.0000000000001 136 240.0000000000001 140 246L10 376L0 364L94 100C96 94 102 90 108 88V88L248 48V48C250 48 252 45.9999999999999 254.0000000000001 45.9999999999999C260.0000000000001 45.9999999999999 264 48 268 51.9999999999999L348 132C352 136 354 142 354 146L354 146zM374 126C368 126 364 124 360 120L280 40C276 36 274 32 274 26C274 16 282 6 294 6C300 6 304 8.0000000000001 308 12L388 92C392 96 394 100.0000000000001 394 106C394 118 384 126 374 126L374 126z" : "M298 100C292 100 288 98 284 94L224 34C220 30 218 26 218 20C218 8 228 0 238 0C244.0000000000001 0 248 2 252 6L312 66C316 70 318 74 318 80C318 90 310 100 298 100L298 100zM278 120C278 122 278 122 278 124L278 124L258 224L258 224C256 230 252 236 246 238L246 238L26 318L20 312L136 196C140 198 144 200 148 200C164 200 178 186 178 170S166 140 148 140S118 154 118 170C118 174 120 178 122 182L6 298L0 292L80 72L80 72C82 66 88 60 94 60L94 60L194 40L194 40C196 40 196 40 198 40C204 40 208 42 212 46L272 106C276 110 278 114 278 120L278 120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Draw.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Draw.displayName = "Blueprint5.Icon.Draw";
exports.default = Draw;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b6YRC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DrawerLeftFilled", ()=>DrawerLeftFilled);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DrawerLeftFilled = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "drawer-left-filled",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 400L180 400C191.045695 400 200 391.045695 200 380L200 20C200 8.954306 191.045695 0 180 0L20 0C8.954305 0 0 8.954306 0 20L0 380C0 391.045695 8.954305 400 20 400zM200.000002 220L331.800002 220L286.000002 265.7999988000001C282.2000020000001 269.3999988 280.000002 274.3999988 280.000002 280C280.000002 290.999999 289.000002 300 300.000002 300C305.600002 300 310.600002 297.799999 314.200002 294.199999L394.200002 214.1999986C397.8000020000001 210.5999986 400.000002 205.5999986 400.000002 200C400.000002 194.399998 397.8000020000001 189.399998 394.200002 185.799998L314.200002 105.799998C310.600002 102.199998 305.600002 100 300.000002 100C289.000002 100 280.000002 108.999998 280.000002 120C280.000002 125.599998 282.2000020000001 130.599998 285.800002 134.199998L331.800002 180L200.000002 180L200.000002 220z" : "M20 320L140 320C151.045695 320 160 311.045695 160 300L160 20C160 8.954306 151.045695 0 140 0L20 0C8.954305 0 0 8.954306 0 20L0 300C0 311.045695 8.954305 320 20 320zM160.000001 180L251.800002 180L226.000002 205.7999988C222.200002 209.3999988 220 214.3999988 220 220C220 230.999999 229.000002 240 240 240C245.600002 240 250.600002 237.799999 254.200002 234.199999L314.200002 174.1999986C317.800002 170.5999986 320 165.5999986 320 160C320 154.3999984 317.800002 149.3999984 314.200002 145.7999984L254.200002 85.799998C250.600002 82.199998 245.600002 80 240 80C229.000002 80 220 88.999998 220 100C220 105.599998 222.200002 110.599998 225.800002 114.199998L251.800002 140L160.000001 140L160.000001 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DrawerLeftFilled.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DrawerLeftFilled.displayName = "Blueprint5.Icon.DrawerLeftFilled";
exports.default = DrawerLeftFilled;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dbxmT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DrawerLeft", ()=>DrawerLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DrawerLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "drawer-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M180 400C191.045695 400 200 391.045695 200 380L200 20C200 8.954306 191.045695 0 180 0L20 0C8.954305 0 0 8.954306 0 20L0 380C0 391.045695 8.954305 400 20 400L180 400zM159.9999998 360L39.9999998 360L39.9999998 40L159.9999998 40L159.9999998 360zM200.000002 220L331.800002 220L286.000002 265.7999988000001C282.2000020000001 269.3999988 280.000002 274.3999988 280.000002 280C280.000002 290.999999 289.000002 300 300.000002 300C305.600002 300 310.600002 297.799999 314.200002 294.199999L394.200002 214.1999986C397.8000020000001 210.5999986 400.000002 205.5999986 400.000002 200C400.000002 194.399998 397.8000020000001 189.399998 394.200002 185.799998L314.200002 105.799998C310.600002 102.199998 305.600002 100 300.000002 100C289.000002 100 280.000002 108.999998 280.000002 120C280.000002 125.599998 282.2000020000001 130.599998 285.800002 134.199998L331.800002 180L200.000002 180L200.000002 220z" : "M140 320C151.045695 320 160 311.045695 160 300L160 20C160 8.954306 151.045695 0 140 0L20 0C8.954305 0 0 8.954306 0 20L0 300C0 311.045695 8.954305 320 20 320L140 320zM120 280L40 280L40 40L120 40L120 280zM160.000001 180L251.800002 180L226.000002 205.7999988C222.200002 209.3999988 220 214.3999988 220 220C220 230.999999 229.000002 240 240 240C245.600002 240 250.600002 237.799999 254.200002 234.199999L314.200002 174.1999986C317.800002 170.5999986 320 165.5999986 320 160C320 154.3999984 317.800002 149.3999984 314.200002 145.7999984L254.200002 85.799998C250.600002 82.199998 245.600002 80 240 80C229.000002 80 220 88.999998 220 100C220 105.599998 222.200002 110.599998 225.800002 114.199998L251.800002 140L160.000001 140L160.000001 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DrawerLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DrawerLeft.displayName = "Blueprint5.Icon.DrawerLeft";
exports.default = DrawerLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7uJYX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DrawerRightFilled", ()=>DrawerRightFilled);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DrawerRightFilled = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "drawer-right-filled",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 400L380 400C391.0456940000001 400 400 391.045695 400 380L400 20C400 8.954306 391.0456940000001 0 380 0L220 0C208.954306 0 200 8.954306 200 20L200 380C200 391.045695 208.954306 400 220 400zM200 220L68.1999994 220L113.9999996 265.7999988000001C117.7999996 269.3999988 120 274.3999988 120 280C120 290.999999 110.9999996 300 100 300C94.3999994 300 89.3999994 297.799999 85.7999994 294.199999L5.79999902 214.1999986C2.19999902 210.5999986 1.7e-12 205.5999986 1.7e-12 200C1.7e-12 194.399998 2.19999902 189.399998 5.79999902 185.799998L85.7999994 105.799998C89.3999994 102.199998 94.3999994 100 100 100C110.9999996 100 120 108.999998 120 120C120 125.599998 117.7999996 130.599998 114.1999996 134.199998L68.1999994 180L200 180L200 220z" : "M180 320L300 320C311.045694 320 320 311.045695 320 300L320 20C320 8.954306 311.045694 0 300 0L180 0C168.954305 0 160 8.954306 160 20L160 300C160 311.045695 168.954305 320 180 320zM160.000001 180L68.2000004 180L94.0000006 205.7999988C97.8000006 209.3999988 100.000001 214.3999988 100.000001 220C100.000001 230.999999 91.0000006 240 80.000001 240C74.4000004 240 69.4000004 237.799999 65.8000004 234.199999L5.80000004 174.1999986C2.20000002 170.5999986 9.999991e-7 165.5999986 9.999991e-7 160C9.999991e-7 154.3999984 2.20000002 149.3999984 5.80000004 145.7999984L65.8000004 85.799998C69.4000004 82.199998 74.4000004 80 80.000001 80C91.0000006 80 100.000001 88.999998 100.000001 100C100.000001 105.599998 97.8000006 110.599998 94.2000006 114.199998L68.2000004 140L160.000001 140L160.000001 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DrawerRightFilled.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DrawerRightFilled.displayName = "Blueprint5.Icon.DrawerRightFilled";
exports.default = DrawerRightFilled;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lehsn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DrawerRight", ()=>DrawerRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DrawerRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "drawer-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400C391.0456940000001 400 400 391.045695 400 380L400 20C400 8.954306 391.0456940000001 0 380 0L220 0C208.954306 0 200 8.954306 200 20L200 380C200 391.045695 208.954306 400 220 400L380 400zM360 360L240 360L240 40L360 40L360 360zM200 220L68.1999994 220L113.9999996 265.7999988000001C117.7999996 269.3999988 120 274.3999988 120 280C120 290.999999 110.9999996 300 100 300C94.3999994 300 89.3999994 297.799999 85.7999994 294.199999L5.79999902 214.1999986C2.19999902 210.5999986 1.3e-12 205.5999986 1.3e-12 200C1.3e-12 194.399998 2.19999902 189.399998 5.79999902 185.799998L85.7999994 105.799998C89.3999994 102.199998 94.3999994 100 100 100C110.9999996 100 120 108.999998 120 120C120 125.599998 117.7999996 130.599998 114.1999996 134.199998L68.1999994 180L200 180L200 220z" : "M300 320C311.045694 320 320 311.045695 320 300L320 20C320 8.954306 311.045694 0 300 0L180 0C168.954305 0 160 8.954306 160 20L160 300C160 311.045695 168.954305 320 180 320L300 320zM280 280L200 280L200 40L280 40L280 280zM160.000001 180L68.2000004 180L94.0000006 205.7999988C97.8000006 209.3999988 100.000001 214.3999988 100.000001 220C100.000001 230.999999 91.0000006 240 80.000001 240C74.4000004 240 69.4000004 237.799999 65.8000004 234.199999L5.80000004 174.1999986C2.20000002 170.5999986 9.999997e-7 165.5999986 9.999997e-7 160C9.999997e-7 154.3999984 2.20000002 149.3999984 5.80000004 145.7999984L65.8000004 85.799998C69.4000004 82.199998 74.4000004 80 80.000001 80C91.0000006 80 100.000001 88.999998 100.000001 100C100.000001 105.599998 97.8000006 110.599998 94.2000006 114.199998L68.2000004 140L160.000001 140L160.000001 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DrawerRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DrawerRight.displayName = "Blueprint5.Icon.DrawerRight";
exports.default = DrawerRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9JKPn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DriveTime", ()=>DriveTime);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var DriveTime = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "drive-time",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400.2000000000001 246C400.2000000000001 258.6 390.2000000000001 268.8 378.2 268.8H351.8L332.8 320.2C328.0000000000001 333 313.8 346.4 301 350.2C301 350.2 268 360 200 360C132 360 99.2 350.2 99.2 350.2C86.6 346.4 72.2 333 67.4 320.2L48.4 268.8H22C10 268.8 0 258.6 0 246C0 233.4 10 223.2 22 223.2H31.4L24.6 205C19.8 192.2 16 170.6 16 157V49.2C16 33.2 28.6 20.2 44 20.2C59.4 20.2 72 33.2 72 49.2V65.8H328.0000000000001V49.2C328.0000000000001 33.2 340.6 20.2 356 20.2S384 33.2 384 49.2V157C384 170.6 380.2 192.4 375.4 205L368.6 223.2000000000001H378C390.2000000000001 223.2 400.2000000000001 233.4 400.2000000000001 246zM70.8 239.2L93.2 302.4000000000001C94.8 306.8 99.6 310.2 104 310.2H296C300.4000000000001 310.2 305.2000000000001 306.8 306.8 302.4L329.2000000000001 239.2C330.8 235 328.4000000000001 231.4 324 231.4H76C71.6 231.6 69.2 235 70.8 239.2zM90 140.4C73.4 140.4 60 153.8 60 170.4C60 187 73.4 200.4 90 200.4S120 186.8 120 170.4C120 153.8 106.6 140.4 90 140.4zM310 140.4C293.4 140.4 280 153.8 280 170.4C280 187 293.4 200.4 310 200.4S340 187 340 170.4C340 153.8 326.6 140.4 310 140.4z" : "M302.4 224.8H281.4L266.2 267.2C262.4 277.8 251 288.8 240.8 292C240.8 292 214.4 300 160 300C105.6 300 79.2 292 79.2 292C69.2 288.8 57.8 277.8 54 267.2L38.6 224.8H17.6C8 224.8 0 216.4 0 206C0 195.6 8 187.2 17.6 187.2H25.2L20 180C19.4 166.2 20 151.2 20 140V40C20 26.8 27.6 20 40 20C52.4 20 60 26.8 60 40V60H260V40C260 26.8 267.6 20 280 20C292.4 20 300 26.8 300 40V140C300 151.2 299.8 167.4 300 180L294.8 187.4H302.4000000000001C312 187.4 320 195.8 320 206C320 216.4 312 224.8 302.4 224.8zM100 120H60V160H100V120zM260 120H220V160H260V120zM260 200H60C56.4 200 58.8 216.4 60 220L74.6 252.6C75.8 256.2 76.4 260 80 260H240C243.6 260 244.2 256.2 245.4 252.6L260 220C261.2 216.4 263.6 200 260 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
DriveTime.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
DriveTime.displayName = "Blueprint5.Icon.DriveTime";
exports.default = DriveTime;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cF57l":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Duplicate", ()=>Duplicate);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Duplicate = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "duplicate",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM280 40H40V280H280V40zM380 400H100C89 400 80 391 80 380V340H120V360H360V120H340V80H380C391 80 400 89 400 100V380C400 391 391 400 380 400z" : "M300 320H100C89 320 80 311 80 300V260H120V280H280V140H260V100H300C311 100 320 109 320 120V300C320 311 311 320 300 320zM220 240H20C9 240 0 231 0 220V20C0 9 9 0 20 0H220C231 0 240 9 240 20V220C240 231 231 240 220 240zM200 40H40V200H200V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Duplicate.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Duplicate.displayName = "Blueprint5.Icon.Duplicate";
exports.default = Duplicate;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fKo1g":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Edit = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "edit",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M91.8 148.2L148.4 91.6L301.4 244.6L244.8 301.2000000000001L91.8 148.2zM40 40L128.2 71.8L72 127.6L40 40zM320 360C309 360 299 355.6 291.8 348.2L258.8 315.2L315.4 258.6L348.4 291.6C355.6 299 360 309 360 320C360 342 342 360 320 360z" : "M65 114.8L114.4 65.4L248.2 199.2L199 248.8L65 114.8zM19.8 20.2L97 48L47.8 96.8L19.8 20.2zM264.8 300.2C255.2 300.2 246.4 296.2 240 290L211.2 261.2L260.6 211.8L289.4000000000001 240.6C295.8 247 299.6 255.6 299.6 265.4C299.8 284.4 284.2000000000001 300.2 264.8 300.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Edit.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Edit.displayName = "Blueprint5.Icon.Edit";
exports.default = Edit;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iD3tq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Eject", ()=>Eject);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Eject = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "eject",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 160H320C331 160 340 169 340 180C340 185 338 189.4 335 192.8L335.2000000000001 193L215.2000000000001 333L215 332.8C211.4 337.2 206 340 200 340S188.6 337.2 185 332.8C185 332.8 184.8 333 184.8 333L64.8 193L65 192.8C62 189.4 60 185 60 180C60 169 69 160 80 160zM320 140H80C69 140 60 131 60 120V80C60 69 69 60 80 60H320C331 60 340 69 340 80V120C340 131 331 140 320 140z" : "M80 140H240C251 140 260 149 260 160C260 165.6 257.8 170.6 254.2 174.2L174.2 254.2C170.6 257.8 165.6 260 160 260S149.4 257.8 145.8 254.2L65.8 174.2C62.2 170.6 60 165.6 60 160C60 149 69 140 80 140zM240 120H80C69 120 60 111 60 100V80C60 69 69 60 80 60H240C251 60 260 69 260 80V100C260 111 251 120 240 120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Eject.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Eject.displayName = "Blueprint5.Icon.Eject";
exports.default = Eject;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jFkhK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Emoji", ()=>Emoji);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Emoji = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "emoji",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C310.45695 400 400 310.45695 400 200C400 89.54305 310.45695 0 200 0C89.54305 0 0 89.54305 0 200C0 310.45695 89.54305 400 200 400zM200 360C111.63444 360 40 288.36556 40 200C40 111.63444 111.63444 40 200 40C288.36556 40 360 111.63444 360 200C360 288.36556 288.36556 360 200 360zM120 200L120.2995578 195.695118C124.3722088 151.607298 158.4949642 120 200 120C242.843908 120 277.821578 153.67937 279.9020940000001 196.007194L280 200L320 200L319.7479840000001 195.2364C315.089908 128.952668 263.261708 80 200 80C135.2320612 80 82.4485648 131.311498 80.0827694 195.501234L80 200L120 200zM150 280C166.5685424 280 180 266.5685424 180 250C180 233.4314576 166.5685424 220 150 220C133.4314576 220 120 233.4314576 120 250C120 266.5685424 133.4314576 280 150 280zM250 280C266.5685420000001 280 280 266.5685424 280 250C280 233.4314576 266.5685420000001 220 250 220C233.431458 220 220 233.4314576 220 250C220 266.5685424 233.431458 280 250 280z" : "M160 320C248.36556 320 320 248.36556 320 160C320 71.63444 248.36556 0 160 0C71.63444 0 0 71.63444 0 160C0 248.36556 71.63444 320 160 320zM160 300C82.680135 300 20 237.319865 20 160C20 82.680136 82.680135 20 160 20C237.319864 20 300 82.680136 300 160C300 237.319865 237.319864 300 160 300zM80 160C84.5527456 114.761724 120 80 160 80C198.75 80 235.414496 114.765414 239.688518 155.991191L240 160L260 160C257.43309 102.2497 213.650518 60 160 60C106.224906 60 62.3636378 102.446134 60.0923902 155.6622076L60 160L80 160zM120 220C131.045695 220 140 211.045695 140 200C140 188.954305 131.045695 180 120 180C108.954305 180 100 188.954305 100 200C100 211.045695 108.954305 220 120 220zM200 220C211.045694 220 220 211.045695 220 200C220 188.954305 211.045694 180 200 180C188.954305 180 180 188.954305 180 200C180 211.045695 188.954305 220 200 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Emoji.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Emoji.displayName = "Blueprint5.Icon.Emoji";
exports.default = Emoji;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9gEbp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Endnote", ()=>Endnote);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Endnote = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "endnote",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M338.856 368.5714C332.75 367.4286 326.464 366.8572 320 366.8572V341.1428H366.3300000000001V200H400V400H374.95C373.872 393.90476 371.538 388.7619000000001 367.9460000000001 384.57142C364.534 380.38094 360.314 376.9524 355.286 374.2858C350.438 371.6190000000001 344.9600000000001 369.7142 338.856 368.5714zM256.666 0C248.506 0 240.226 1.932 231.826 5.794C230.618 6.4 229.5060000000001 6.944 228.464 7.454C222.454 10.39 218.722 12.2140000000001 212.386 18.588V4.346H170.985V260H212.386V194.094L211.306 164.402C218.746 170.92 226.786 176.23 235.426 180.334C244.306 184.438 253.306 186.49 262.426 186.49C273.466 186.49 283.306 184.318 291.9460000000001 179.972C300.586 175.868 307.906 169.832 313.906 161.866C319.906 154.142 324.466 144.726 327.584 133.622C330.706 122.516 332.266 110.084 332.266 96.324C332.266 81.114 330.106 67.474 325.784 55.404C321.706 43.574 316.1860000000001 33.556 309.226 25.348C302.266 17.14 294.226 10.864 285.106 6.518C275.986 2.172 266.5060000000001 0 256.666 0zM248.026 34.402C259.786 34.402 269.626 39.47 277.546 49.61C285.466 59.99 289.426 75.3199999999999 289.426 95.598C289.426 113.464 286.4260000000001 127.344 280.426 137.242C274.426 147.14 264.706 152.09 251.266 152.09C238.786 152.09 225.826 145.45 212.386 132.172V49.248C218.626 43.696 224.746 39.832 230.746 37.66C236.986 35.488 242.746 34.402 248.026 34.402zM52.2 0.004C36.6 0.004 24 4.712 14.4 14.126C4.8 23.782 0 36.456 0 52.148C0 61.564 1.920002 69.8919999999999 5.76 77.134C9.84 84.618 16.08 91.016 24.48 96.326C33.12 101.638 43.92 106.104 56.88 109.726C70.08 113.346 85.8 116.122 104.04 118.054C103.8 122.64 103.08 126.986 101.88 131.09C100.92 135.436 99.12 139.178 96.48 142.316C94.08 145.696 90.84 148.23 86.76 149.92C82.68 151.852 77.64 152.818 71.64 152.818C63 152.818 54.48 151.128 46.08 147.748C37.92 144.368 29.88 140.264 21.96 135.436L6.84 163.318C16.68 169.596 27.72 175.028 39.96 179.614C52.2 184.2 65.4 186.494 79.56 186.494C101.64 186.494 118.08 179.856 128.88 166.578C139.92 153.542 145.44 134.59 145.44 109.726V4.35H104.04V21.77C96.12 15.0119999999999 90.48 11.47 81.36 6.884C72.48 2.298 62.76 0.004 52.2 0.004zM65.52 32.594C72.72 32.594 79.2 34.2840000000001 84.96 37.664C90.96 41.044 97.32 45.872 104.04 52.148V91.982C92.04 90.534 81.96 88.602 73.8 86.188C65.64 83.774 59.04 80.998 54 77.86C48.96 74.962 45.36 71.582 43.2 67.72C41.04 63.8580000000001 39.96 59.754 39.96 55.408C39.96 47.442 42.36 41.648 47.16 38.026C51.96 34.404 58.08 32.594 65.52 32.594zM0 400H400V0H0V400z" : "M11.8812 12.116C19.802 4.038 30.198 0 43.0694 0C51.7822 0 59.802 1.968 67.1288 5.902C74.6534 9.838 79.307 12.5 85.8416 18.298V3.728H120V94.136C120 115.47 115.4456 131.7282 106.3366 142.9126C97.4258 154.3042 83.8614 160 65.6436 160C53.9604 160 43.0694 158.0324 32.9704 154.097C22.8712 150.1618 13.76238 145.5016 5.64358 140.1166L18.11882 116.194C24.6534 120.3366 31.2872 123.8576 38.0198 126.7572C44.9506 129.657 51.9802 131.1068 59.109 131.1068C64.0594 131.1068 68.2178 130.2784 71.5842 128.6214C74.9504 127.1716 77.6238 124.9968 79.604 122.0972C81.7822 119.404 83.2674 116.194 84.0594 112.466C85.0496 108.944 85.6436 105.216 85.8416 101.282C70.792 99.624 57.8218 97.242 46.9306 94.136C36.2376 91.03 27.3268 87.198 20.198 82.64C13.26734 78.084 8.11882 72.596 4.75248 66.174C1.584168 59.962 7.06172e-7 52.816 0 44.738C-0.000001176954 31.276 3.96042 20.402 11.8812 12.116zM70.099 32.31C65.3466 29.41 60 27.962 54.0594 27.962C47.9208 27.962 42.8714 29.514 38.911 32.622C34.9506 35.728 32.9704 40.7 32.9704 47.534C32.9704 51.262 33.8614 54.784 35.6436 58.098C37.4258 61.41 40.396 64.31 44.5544 66.796C48.7128 69.488 54.1584 71.87 60.891 73.942C67.6238 76.012 75.9406 77.67 85.8416 78.912V44.738C80.297 39.352 75.0496 35.21 70.099 32.31zM192.8126 4.902C200.104 1.634 207.292 0 214.376 0C222.916 0 231.146 1.838 239.062 5.516C246.98 9.192 253.9580000000001 14.504 260 21.448C266.042 28.394 270.834 36.872 274.376 46.88C278.124 57.094 280 68.636 280 81.504C280 93.148 278.646 103.668 275.938 113.064C273.23 122.4608 269.27 130.4274 264.062 136.964C258.854 143.705 252.5 148.8116 245 152.2842C237.5 155.9612 228.9580000000001 157.7996 219.376 157.7996C211.458 157.7996 203.646 156.0632 195.9376 152.5906C188.4376 149.118 182.3958 144.6242 175.9376 139.1088V220H140V3.678H175.9376V16.096C181.9464 10.204 185.25 8.592 191.3856 5.6L192.8126 4.902zM232.5 41.978C225.626 33.398 217.084 29.11 206.876 29.11C202.292 29.11 197.2916 30.028 191.875 31.866C188.2026 33.164 184.4784 36.78 180.7024 40.448C179.1232 41.982 177.5348 43.526 175.9376 44.91V110C187.6042 121.2348 198.8542 128.691 209.688 128.691C221.354 128.691 229.792 124.5034 235 116.128C240.2080000000001 107.754 242.812 96.008 242.812 80.892C242.812 63.732 239.376 50.762 232.5 41.978zM274.142 294.8572C269.562 293.9428 264.848 293.4858 260 293.4858V272.9142L294.748 272.9142V160H320L320 319.999998357508L301.212 320C300.404 315.1238 298.654 311.00952 295.96 307.6571400000001C293.4 304.30476 290.236 301.56192 286.464 299.4286C282.8280000000001 297.2952 278.7200000000001 295.7714 274.142 294.8572z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Endnote.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Endnote.displayName = "Blueprint5.Icon.Endnote";
exports.default = Endnote;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eBEbf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Endorsed", ()=>Endorsed);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Endorsed = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "endorsed",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M396.6 212.4L376.2 248V287.6C376.2 296.6 371.6 304.6 364 309.2L329.8 329.2L309.4 364.4C304.8 372 296.8 376.6 287.8 376.6H247.2L212.4 396.6C204.8 401.2 195 401.2 187.4 396.6L152.6 376.6H113C104.2 376.6 96 372 91.4 364.4L71.6 330L35.6 309.2C28 304.4 23.2 296.4 23.2 287.6V246.4L3.4 212C1.2 208.2 0 204 0 199.8S1.2 191.4 3.4 187.6L23.2 153.2V112C23.2 103 27.8 95 35.4 90.4L71 70L90.8 35.6C95.4 28.0000000000001 103.4 23.4 112.4 23.4H152.2L187 3.4C190.8 1.2 195.2 0 199.4 0C203.6 0 207.8 1.2 211.6 3.4L246.4 23.4H287C295.8 23.4 304 28.0000000000001 308.6 35.6L329 70.8000000000001L363.2 90.8000000000001C370.8 95.4000000000001 375.4 103.6000000000001 375.4 112.4V151.8000000000001L395.8 187.4000000000001C401.2 195 401.2 204.4 396.6 212.4zM295 226.6L194.8 126.4C191.2 122.8 186.2 120.6 180.6 120.6C175 120.6 170 122.8 166.4 126.4L106.2 186.6C102.6 190.2 100.4 195.2 100.4 200.8C100.4 211.8 109.4 220.8 120.4 220.8C126 220.8 131 218.6 134.6 215L180.6 169L266.8 255C270.4 258.6 275.4 260.8 281 260.8C292 260.8 301 251.8 301 240.8C301 235.2 298.6 230.2 295 226.6z" : "M317.2 170L301 198.4V230C301 237.2 297.2 243.6 291.2 247.4L263.8 263.4L247.6 291.6C243.8 297.8 237.4 301.4 230.4 301.4H197.8L170 317.2C164 321 156.2 321 150 317.2L122.2 301.2H90.4C83.2 301.2 76.8 297.4 73.2 291.4L57.2 264L28.4 247.4C22.4 243.6 18.6 237.2 18.6 230V197L2.6 169.6C1 166.6 0 163.2 0 159.8S1 153 2.8 150L18.8 122.6V89.6C18.8 82.4 22.6 76 28.6 72.2L57 56L73 28.6C76.8 22.4 83.2 18.8 90.2 18.8H122L149.8 2.8C152.8 1 156.2 0 159.4 0S166.2 1 169.2 2.8L197 18.8H229.6C236.8 18.8 243.2 22.6 246.8 28.6L263 56.8L290.4 72.8C296.4 76.6 300.2 83.0000000000001 300.2 90.2000000000001V121.4L316.4 149.8C321 156 321 163.6 317.2 170zM234.8 186.4L154.6 106.2C151 102.6 146 100.4 140.4 100.4S129.8 102.6 126.2 106.2L86.2 146.2C82.6 150 80.2 155 80.2 160.4C80.2 171.4 89.2 180.4 100.2 180.4C105.8 180.4 110.8 178.2 114.4 174.6L140.4 148.6L206.4 214.6C210 218.2 215 220.4 220.6 220.4C231.6 220.4 240.6 211.4 240.6 200.4C240.8 195 238.4 190 234.8 186.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Endorsed.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Endorsed.displayName = "Blueprint5.Icon.Endorsed";
exports.default = Endorsed;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9a51A":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Envelope", ()=>Envelope);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Envelope = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "envelope",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 319.8V81.6L125.4 207L0 319.8zM378.2 340.4H21.8L200 180.6L378.2 340.4zM274.6 207.2L400 81.6V319.8L274.6 207.2zM210 149.2L210 149.2C207.4 146.8000000000001 203.8 145.4 200 145.4S192.6 146.8000000000001 190 149.2L190 149.2L147.8 187L21.2 60.4000000000001H378.8L252.2 187.0000000000001L210 149.2z" : "M0 258.8V61.2L98.8 160L0 258.8zM298.8 280H21.2L160 141.2L298.8 280zM170.6 109.4C167.8 106.6 164.2 105 160 105S152.2 106.6 149.4 109.4L120 138.8L21.2 40H298.8L200 138.8L170.6 109.4zM221.2 160L320 61.2V258.8L221.2 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Envelope.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Envelope.displayName = "Blueprint5.Icon.Envelope";
exports.default = Envelope;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bT0FL":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Equals", ()=>Equals);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Equals = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "equals",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 260L320 260C331.0456940000001 260 340 251.045695 340 240C340 228.954305 331.0456940000001 220 320 220L80 220C68.954305 220 60 228.954305 60 240C60 251.045695 68.954305 260 80 260zM80 180L320 180C331.0456940000001 180 340 171.045694 340 160C340 148.954306 331.0456940000001 140 320 140L80 140C68.954305 140 60 148.954306 60 160C60 171.045694 68.954305 180 80 180z" : "M60 220L260 220C271.045694 220 280 211.045695 280 200C280 188.954305 271.045694 180 260 180L60 180C48.954305 180 40 188.954305 40 200C40 211.045695 48.954305 220 60 220zM60 140L260 140C271.045694 140 280 131.045695 280 120C280 108.954306 271.045694 100 260 100L60 100C48.954305 100 40 108.954306 40 120C40 131.045695 48.954305 140 60 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Equals.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Equals.displayName = "Blueprint5.Icon.Equals";
exports.default = Equals;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aPdCo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Eraser", ()=>Eraser);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Eraser = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "eraser",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M374.2000000000001 231.4C382 239.4 382 252.4 374.2000000000001 260.4L263.6 374.8C255.8 382.8 243.4 382.8 235.6 374.8L25.8 158C18 150 18 137 25.8 129L110.8 41.2H110.8L153.4 0.2H338.8C339.2 0.2 339.4 0 339.8 0C350.8 0 359.8 9 359.8 20C359.8 31 350.8 40 339.8 40H189.2L190.2000000000001 41L190.4 41H190.4L206.6 57.8L374.2000000000001 231.4zM150.4 41.2L51.4 143.6L140.6 235.8L239.6 133.4L150.4 41.2z" : "M161.2 41.8L313.8 190.6C322 198.6 322 211.6 313.8 219.6L217.2 314C209 322 195.6 322 187.4 314L6.2 137.4C-2 129.4 -2 116.4 6.2 108.4L117.8 -0.4H280.2V-0.1999999999999C291.2 -0.1999999999999 300.2 8.8 300.2 19.8000000000001C300.2 30.8000000000001 291.2 39.8000000000001 280.2 39.8000000000001H159.2L161.2 41.8L161.2 41.8zM117.8 40.6L33.4 123L117.8 205.2L202.2 123L117.8 40.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Eraser.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Eraser.displayName = "Blueprint5.Icon.Eraser";
exports.default = Eraser;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d8PhF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Error", ()=>Error);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Error = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "error",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM220 80H180V120H220V80zM220 140H180V320H220V140z" : "M159.8 320.2C71.4 320.2 -0.2 248.6 -0.2 160.2S71.4 0.2 159.8 0.2S319.8 71.8 319.8 160.2S248.2 320.2 159.8 320.2zM179.8 60.2H139.8V100.2H179.8V60.2zM179.8 120.2H139.8V260.2H179.8V120.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Error.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Error.displayName = "Blueprint5.Icon.Error";
exports.default = Error;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kkFWA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Euro", ()=>Euro);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Euro = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "euro",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M177.8 310.6C189 316.8 202.4 320 218.4 320C227.2 320 235.4 318.6 243.4 315.6C251.4 312.8 258.6 308.6 264.8 303.6C268.2 300.8 271.4 297.6 274.2000000000001 294.2000000000001L320.6 340.6C317.4000000000001 343.6 314.6 347 311.2 349.8C298.8 359.6 284.6 367.2000000000001 268.8 372.4000000000001C252.8 377.4 236 380 218.4 380C193.6 380 171.4 375.6 151.8 366.8C132 358 115.4 345.8 102 330.4C88.4 314.8 78 296.8 70.8 276C69 270.8 68.2 265.2 66.8 260H40C29 260 20 251 20 240S29 220 40 220H60.8C60.6 216 60 212.4 60 208.4C60 205.4 60.6 202.8 60.6 200H40C29 200 20 191 20 180S29 160 40 160H66.2C67.6 154 68.8 148 70.8 142.2C78 121.8 88.4 103.8 102 88.8C115.6 73.6 132.2 61.8 151.8 53C171.4 44.4 193.6 40 218.4 40C238.2 40 256.4 43 273 49.2C289.6 55.2 304 64 316.4 75.6C317 76.2000000000001 317.4000000000001 76.8 318 77.4L269.8 120.4C269.6 120.2000000000001 269.4000000000001 120.0000000000001 269.4000000000001 119.8000000000001C257.2000000000001 106.4 240.2000000000001 99.8000000000001 218.6 99.8000000000001C202.6 99.8000000000001 189.2 103.0000000000001 178 109.2000000000001C166.8 115.4000000000001 157.8 123.6000000000001 151 134.0000000000001C145.4 141.6 141.6 150.6 138.4 160H240C251 160 260 169 260 180S251 200 240 200H131.2C131.2 202.8 130.8 205.6 130.8 208.4C130.8 212.4 131.2 216.2 131.4 220H260C271 220 280 229 280 240S271 260 260 260H138.8C141.8 269.2 145.6 278 150.6 285.6C157.6 296 166.6 304.4 177.8 310.6zM360 172.4V172C360 172.2 360 172.4 360 172.4L360 172.4z" : "M130.4 256.4C140.6 261.8 152.8 264.4 167 264.4C176.6 264.4 185.2 263.2 192.4 260.8C199.8 258.4 206 255 211.6 250.6C215.2 247.8 217.6 244 220.4 240.4L251 271C248.6 273.2 246.3999999999999 275.4 243.8 277.4C233.8 284.6 222.2 290.2 209 294C195.8 298 181.8 300 167 300C147.2 300 129.4 296.4 113.8 289.4C98 282.4 84.8 273 73.8 261.2C62.8 249.6 54.6 235.8 48.6 220H40C29 220 20 211 20 200C20 189 29 180 40 180H40.8C40.6 176.6 40 173.4 40 170C40 166.6 40.6 163.4 40.8 160H40C29 160 20 151 20 140C20 129 29 120 40 120H48.6C48.6 119.8 48.6 119.6 48.8 119.6C54.6 103.8 63 90 73.8 78.2C84.6 66.4 98 57 113.8 50.2C129.4 43.4 147.2 40 167 40C183.2 40 197.8 42.4 211.2 47.2C224.6 52 236.2 59 246.2 67.8C246.4 68 246.6 68.2 246.8 68.4L215.8 95C215.6 94.8 215.4 94.4 215.2 94.2C209.4 88.2 202.5999999999999 83.6 194.8 80.4C186.8 77 177.8 75.4 167.4 75.4C153.2 75.4 141 78 130.8 83.4C120.6 88.8 112.2 95.8 105.8 104.8C102 109.6 99 114.6 96.6 120H180C191 120 200 129 200 140C200 151 191 160 180 160H87C86.8 163.4 86.4 166.6 86.4 170C86.4 173.4 86.8 176.8 87 180H200C211 180 220 189 220 200C220 211 211 220 200 220H96.6C99.2 225.4 102 230.4 105.4 235.2C111.8 244 120.2 251.2 130.4 256.4zM280 140.4V140.2C280 140.2 280 140.4 280 140.4L280 140.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Euro.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Euro.displayName = "Blueprint5.Icon.Euro";
exports.default = Euro;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4fczm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Excavator", ()=>Excavator);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Excavator = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "excavator",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M383.216 203.9222C381.346 213.2708 373.1380000000001 220 363.604 220H320V300C320 311.0456 311.046 320 300 320H230C223.704 320 217.776 317.036 214 312L195.2168 280L162.7512 224.688C160.9494 221.6184 159.9994 218.1234 159.9994 214.564V160C159.9994 148.954 168.9538 140 179.9994 140H375.6040000000001C388.2240000000001 140 397.69 151.546 395.216 163.922L383.216 203.9222zM200 220L235.2 280H280V220H200zM85 390.00004C73.895 395.55258 56.735 389.11658 53.1674 377.2244L0 200C0 161.206 19.04042 148.1 50.0212 141.766C56.263 140.492 62.6614 142.662 67.1664 147.166L120 200H40L80 340.113L180 300L187.433 311.1494C194.106 321.1588 190.534 334.733 179.7742 340.113L85 390.00004zM60 60C60 93.138 86.863 120 120 120H340C373.1380000000001 120 400 93.138 400 60C400 26.862 373.1380000000001 0 340 0H120C86.863 0 60 26.862 60 60zM100 60C100 71.046 108.9544 80 120 80H340C351.046 80 360 71.046 360 60C360 48.954 351.046 40 340 40H120C108.9544 40 100 48.954 100 60z" : "M284.386 200.0002C293.564 200.0002 301.562 193.7542 303.788 184.8508L313.788 144.8508C316.944 132.2278 307.398 120 294.386 120H160.0012C148.9556 120 140.0012 128.9544 140.0012 140V213.9446C140.0012 217.893 141.17 221.7532 143.3602 225.0386L174.064 271.094C177.7732 276.658 184.0178 280 190.705 280H240.002C251.046 280 260.002 271.0458 260.002 260V200.0002H284.386zM206.6 240.0002L180 200.0002L220.002 200.0002V240L206.6 240.0002zM34.443 297.7716C37.3824 309.52952 50.0208 315.99168 61.2736 311.49052L119.8186 288.0726C130.6826 283.727 135.5122 271.0242 130.2794 260.5588L120 240.0002L60 260L40 160.0002H100L55.2588 117.804C50.1742 113.008 42.9092 111.096 36.3044 113.38C15.6341 120.5336 0.910752 131.521 0.0413692 157.5296C-0.01326182 159.1638 0.201246 160.8024 0.59786 162.3888L5.00062 180L34.443 297.7716zM60 50C60 77.614 82.3858 100 110 100H270C297.614 100 320 77.614 320 50C320 22.386 297.614 0 270 0H110C82.3858 0 60 22.386 60 50zM100 50C100 55.522 104.4772 60 110 60H270C275.522 60 280 55.522 280 50C280 44.478 275.522 40 270 40H110C104.4772 40 100 44.478 100 50z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Excavator.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Excavator.displayName = "Blueprint5.Icon.Excavator";
exports.default = Excavator;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"exbzT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Exchange", ()=>Exchange);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Exchange = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "exchange",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M50 240C22.4 240 0 217.6 0 190S22.4 140 50 140S100 162.4 100 190S77.6 240 50 240zM257 177C255.2 178.8 252.6 180 250 180C244.4 180 240 175.6 240 170C240 167.2 241.2 164.8 243 163L266 140H110C104.4 140 100 135.6 100 130S104.4 120 110 120H265.8L242.8 97C241.2 95.2 240 92.8 240 90C240 84.4 244.4 80 250 80C252.8 80 255.2 81.2 257 83L297 123C298.8 124.8 300 127.2 300 130S298.8 135.2 297 137L257 177zM350 240C322.4000000000001 240 300 217.6 300 190S322.4000000000001 140 350 140S400 162.4 400 190S377.6 240 350 240zM143 203C144.8 201.2 147.2 200 150 200C155.6 200 160 204.4 160 210C160 212.8 158.8 215.2 157 217L134.2 240H290C295.6 240 300 244.4 300 250S295.6 260 290 260H134.2L157.2 283C158.8 284.8 160 287.2 160 290C160 295.6 155.6 300 150 300C147.2 300 144.8 298.8 143 297L103 257C101.2 255.2 100 252.8 100 250S101.2 244.8 103 243L143 203z" : "M39.8 200.2C17.8 200.2 -0.2 182.2 -0.2 160.2S17.8 120.2 39.8 120.2S79.8 138.2 79.8 160.2S62 200.2 39.8 200.2zM122.8 163C124.6 161.2 127.2 160 129.8 160C135.4 160 139.8 164.4 139.8 170C139.8 172.8 138.6 175.2 136.8 177L114 200.2H229.8C235.4 200.2 239.8 204.6 239.8 210.2S235.4 220.2 229.8 220.2H114L137 243.2C138.8 245 140 247.6 140 250.2C140 255.8 135.6 260.2 130 260.2C127.2 260.2 124.8 259 123 257.2L83 217.2C81 215.4 79.8 213 79.8 210.2S81 205 82.8 203.2L122.8 163zM279.8 200.2C257.8 200.2 239.8 182.2 239.8 160.2S257.8 120.2 279.8 120.2S319.8 138.2 319.8 160.2S302 200.2 279.8 200.2zM197 157.2C195 159 192.6 160.2 189.8 160.2C184.2 160.2 179.8 155.8 179.8 150.2C179.8 147.4 181 145 182.8 143.2L205.8 120.2H89.8C84.2 120.2 79.8 115.8 79.8 110.2S84.2 100.2 89.8 100.2H205.6L182.6 77.2C180.8 75.4 179.6 72.8 179.6 70.2C179.6 64.6 184 60.2 189.6 60.2C192.4 60.2 194.8 61.4 196.6 63.2L236.6 103.2C238.4 105 239.6 107.6 239.6 110.2S238.4 115.4 236.6 117.2L197 157.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Exchange.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Exchange.displayName = "Blueprint5.Icon.Exchange";
exports.default = Exchange;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8PsQh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExcludeRow", ()=>ExcludeRow);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ExcludeRow = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "exclude-row",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 340H380C391 340 400 349 400 360C400 371 391 380 380 380H20C9 380 0 371 0 360C0 349 9 340 20 340zM0 140C0 129 9 120 20 120C25.6 120 30.6 122.2 34.2 125.8L80 171.8L125.8 126C129.4 122.2 134.4 120 140 120C151 120 160 129 160 140C160 145.6 157.8 150.6 154.2 154.2L108.2 200L154 245.8C157.8 249.4 160 254.4 160 260C160 271 151 280 140 280C134.4 280 129.4 277.8 125.8 274.2L80 228.2L34.2 274.2C30.6 277.8 25.6 280 20 280C9 280 0 271 0 260C0 254.4 2.2 249.4 5.8 245.8L51.8 200L6 154.2C2.2 150.6 0 145.6 0 140zM360 240H220C198 240 180 222 180 200C180 178 198 160 220 160H360C382 160 400 178 400 200C400 222 382 240 360 240zM380 60H20C9 60 0 51 0 40C0 29 9 20 20 20H380C391 20 400 29 400 40C400 51 391 60 380 60z" : "M0 120C0 109 9 100 20 100C25.6 100 30.6 102.2 34.2 105.8L60 131.8L85.8 106C89.4 102.2 94.4 100 100 100C111 100 120 109 120 120C120 125.6 117.8 130.6 114.2 134.2L88.2 160L114 185.8C117.8 189.4 120 194.4 120 200C120 211 111 220 100 220C94.4 220 89.4 217.8 85.8 214.2L60 188.2L34.2 214.2C30.6 217.8 25.6 220 20 220C9 220 0 211 0 200C0 194.4 2.2 189.4 5.8 185.8L31.8 160L5.8 134.2C2.2 130.6 0 125.6 0 120zM20 260H300C311 260 320 269 320 280C320 291 311 300 300 300H20C9 300 0 291 0 280C0 269 9 260 20 260zM300 60H20C9 60 0 51 0 40C0 29 9 20 20 20H300C311 20 320 29 320 40C320 51 311 60 300 60zM280 200H180C158 200 140 182 140 160C140 138 158 120 180 120H280C302 120 320 138 320 160C320 182 302 200 280 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ExcludeRow.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ExcludeRow.displayName = "Blueprint5.Icon.ExcludeRow";
exports.default = ExcludeRow;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8FrLl":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExpandAll", ()=>ExpandAll);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ExpandAll = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "expand-all",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 220C85.6 220 90.6 222.2 94.2 225.8L200 331.8L305.8 226C309.4000000000001 222.2 314.4000000000001 220 320 220C331 220 340 229 340 240C340 245.6 337.8 250.6 334.2000000000001 254.2L214.2 374.2C210.6 377.8 205.6 380 200 380S189.4 377.8 185.8 374.2L65.8 254.2C62.2 250.6 60 245.6 60 240C60 229 69 220 80 220zM320 180C314.4000000000001 180 309.4000000000001 177.8 305.8 174.2L200 68.2L94.2 174C90.6 177.8 85.6 180 80 180C69 180 60 171 60 160C60 154.4 62.2 149.4 65.8 145.8L185.8 25.8C189.4 22.2 194.4 20 200 20S210.6 22.2 214.2 25.8L334.2000000000001 145.8C337.8 149.4 340 154.4 340 160C340 171 331 180 320 180z" : "M80 180C85.6 180 90.6 182.2 94.2 185.8L160 251.8L225.8 186C229.4 182.2 234.4 180 240 180C251 180 260 189 260 200C260 205.6 257.8 210.6 254.2 214.2L174.2 294.2C170.6 297.8 165.6 300 160 300S149.4 297.8 145.8 294.2L65.8 214.2C62.2 210.6 60 205.6 60 200C60 189 69 180 80 180zM240 140C234.4 140 229.4 137.8 225.8 134.2L160 68.2L94.2 134.2C90.6 137.8 85.6 140 80 140C69 140 60 131 60 120C60 114.4 62.2 109.4 65.8 105.8L145.8 25.8C149.4 22.2 154.4 20 160 20S170.6 22.2 174.2 25.8L254.2 105.8C257.8 109.4 260 114.4 260 120C260 131 251 140 240 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ExpandAll.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ExpandAll.displayName = "Blueprint5.Icon.ExpandAll";
exports.default = ExpandAll;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"abcgL":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Explain", ()=>Explain);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Explain = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "explain",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.543 400 0 310.457 0 200C0 89.544 89.543 0 200 0H400V200C400 310.457 310.456 400 200 400zM160 180C171.0456 180 180 171.046 180 160V72.582C180 65.628 185.6374 59.99 192.5912 59.99C197.164 59.99 201.378 62.47 203.598 66.466L278.4 201.1118C279.45 202.9996 280 205.1234 280 207.283C280 214.301 274.31 219.9902 267.292 219.9902H240C228.954 219.9902 220 228.9446 220 239.9902V327.4088C220 334.3628 214.362 340 207.408 340C202.836 340 198.6228 337.5208 196.402 333.5236L121.5992 198.878C120.5504 196.99 120 194.866 120 192.708C120 185.69 125.6892 180 132.7072 180H160z" : "M160 320C71.6344 320 0 248.3656 0 160C0 71.634 71.6344 0 160 0H320V160C320 248.3656 248.366 320 160 320zM120 140C131.0458 140 140 131.0456 140 120V70.186C140 64.556 144.5632 59.992 150.1924 59.992C153.7924 59.992 157.1254 61.892 158.9608 64.988L218.684 165.7722C219.546 167.2256 220 168.8842 220 170.5738C220 175.7758 215.784 179.9926 210.582 179.9926H200C188.9542 179.9926 180 188.947 180 199.9926V249.8076C180 255.4368 175.4368 260 169.8076 260C166.2076 260 162.8746 258.1008 161.0392 255.0038L101.3158 154.2206C100.4546 152.767 100 151.1084 100 149.4188C100 144.217 104.217 140 109.4188 140H120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Explain.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Explain.displayName = "Blueprint5.Icon.Explain";
exports.default = Explain;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ja1qA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Export", ()=>Export);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Export = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "export",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100 260C105.6 260 110.6 262.2000000000001 114.2 265.8L180 331.8V100C180 89 189 80 200 80S220 89 220 100V331.8L285.8 266C289.4000000000001 262.2000000000001 294.4000000000001 260 300 260C311 260 320 269 320 280C320 285.6 317.8 290.6 314.2000000000001 294.2L214.2 394.2C210.6 397.8 205.6 400 200 400S189.4 397.8 185.8 394.2L85.8 294.2C82.2 290.6 80 285.6 80 280C80 269 89 260 100 260zM380 120C369 120 360 111 360 100V40H40V100C40 111 31 120 20 120S0 111 0 100V20C0 9 9 0 20 0H380C391 0 400 9 400 20V100C400 111 391 120 380 120z" : "M80 200C85.6 200 90.6 202.2 94.2 205.8L140 251.8V100C140 89 149 80 160 80S180 89 180 100V251.8L225.8 206C229.4 202.2 234.4 200 240 200C251 200 260 209 260 220C260 225.6 257.8 230.6 254.2 234.2L174.2 314.2C170.6 317.8 165.6 320 160 320S149.4 317.8 145.8 314.2L65.8 234.2C62.2 230.6 60 225.6 60 220C60 209 69 200 80 200zM300 100C289 100 280 91 280 80V40H40V80C40 91 31 100 20 100S0 91 0 80V20C0 9 9 0 20 0H300C311 0 320 9 320 20V80C320 91 311 100 300 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Export.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Export.displayName = "Blueprint5.Icon.Export";
exports.default = Export;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lRxNZ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EyeOff", ()=>EyeOff);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var EyeOff = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "eye-off",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 200.8C400 201 400 201.2 400 201.4C400 201.4 400 201.6 400 201.6C400 201.8 400 201.8 400 202C400 202.2 400 202.2 400 202.4C400 202.4 400 202.4 400 202.4C399.6 205.6 398 208.6 395.8 211C384.8 224.7999999999999 372 237 358.8 248.4L280.2 196C278 154 243.6 120.6 201 120.6C191.5999999999999 120.6 182.8 122.6 174.4 125.4L129.5999999999999 95.6C140 91.3999999999999 150.5999999999999 87.8 161.5999999999999 85.4C185.7999999999999 79.9999999999999 210.1999999999999 79.8 234.4 84.3999999999999C256.5999999999999 88.6 277.8 97.1999999999999 297.8 107.9999999999999C328.9999999999999 124.8 357.5999999999999 148 382.4 173.9999999999999C387 178.7999999999999 391.6 183.7999999999999 395.8 188.9999999999999C398 191.3999999999999 399.4 194.3999999999999 400 197.5999999999999C400 197.5999999999999 400 197.5999999999999 400 197.5999999999999C400 197.7999999999999 400 197.7999999999999 400 197.9999999999999C400 198.1999999999999 400 198.1999999999999 400 198.3999999999999C400 198.3999999999999 400 198.5999999999999 400 198.5999999999999C400 198.7999999999999 400 198.9999999999999 400 199.1999999999999C400 199.3999999999999 400 199.7999999999999 400 199.9999999999999C400 200.2 400 200.6 400 200.8zM390.8 303.6C396.2 307.2 400 313 400 320C400 331 391 340 380 340C375.8 340 372.2 338.4 369.2000000000001 336.4L369 336.8L300 290.8C281 301.4 261 310 239.8 314.8C215.4 320 191 320.2 166.8 315.6C144.6 311.4 123.4 302.8 103.4 292C72.2 275.2 43.6 252 18.8 226C14.2 221.2 9.6 216.4 5.4 211C0 204.2 0 195.8 5.4 189C18.2 173.2 33.2 159 48.6 146C53.8 141.8 59 137.8 64.4 133.8L8.8 96.8L9 96.4C3.8 92.8 0 87 0 80C0 69 9 60 20 60C24.2 60 27.8 61.6 30.8 63.6L31 63.2L391 303.2L390.8 303.6zM217.4 235.6C212.4 238 206.8 239.6 200.8 239.6C178.8 239.6 161 221.8 161 199.8C161 199.2 161.4 198.6 161.4 198L125.8 174.2C123 182.2 121.4 190.8 121.4 199.8C121.4 243.6 157 279.2 201 279.2C221.2 279.2 239.2 271.6 253.2 259.2L217.4 235.6z" : "M320 160.6C320 160.8 320 160.8 320 161C320 161 320 161.2 320 161.2C320 161.4 320 161.4 320 161.6C320 161.8 320 161.8 320 162C320 162 320 162 320 162C319.6 164.8 318.4 167.2 316.6 169.2C306.8 181.8 295.2 193.2 283.6 203.6L220.4 158.4C219.6 126.2 193.2 100.4 160.8 100.4C154.6 100.4 148.8 101.6 143.2 103.4L101.8 74C110.6 70.2 119.8 66.8 129.2 64.6C148.6 60 168 59.8 187.6 63.6C205.2000000000001 67 222.4 74.4 238.2 83.2C263.2 97.2 286 116.6 305.8 138.2C309.4 142.2 313.2 146.4 316.4 150.6C318.2 152.6 319.4 155 319.8 157.8C319.8 157.8 319.8 157.8 319.8 157.8C319.8 158 319.8 158 319.8 158.2C319.8 158.4 319.8 158.4 319.8 158.6C319.8 158.6 319.8 158.8 319.8 158.8C319.8 159 319.8 159 319.8 159.1999999999999C319.8 159.4 319.8 159.5999999999999 319.8 159.7999999999999C320 160.2 320 160.4 320 160.6zM311.4 244C316.4 247.6 320 253.2 320 260C320 271 311 280 300 280C295.6 280 291.8 278.4 288.6 276L288.4 276.2L235 238C221.2 245.6 206.8 251.8 191.6 255.4C172.4 260 152.8 260.2 133.4 256.4C115.8 252.8 98.6 245.6 82.8 236.6C57.8 222.6 35 203.2 15.2 181.6C11.6 177.6 7.8 173.4 4.6 169.2C0 163.4 0 156.6 4.4 150.8C14.6 137.6 26.6 125.8 39 115C42.6 111.8 46.6 109.2 50.2 106.2L8.4 76.2L8.6 76C3.6 72.4 0 66.8 0 60C0 49 9 40 20 40C24.4 40 28.2 41.6 31.4 44L31.6 43.8L311.6 243.8L311.4 244zM103.2 144C101.8 149.2 101 154.4 101 160C101 192.8 127.8 219.6 160.8 219.6C173.2 219.6 184.6 215.4 194 209L103.2 144z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
EyeOff.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
EyeOff.displayName = "Blueprint5.Icon.EyeOff";
exports.default = EyeOff;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"30bc2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EyeOn", ()=>EyeOn);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var EyeOn = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "eye-on",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M266 225.8C269.6 222.2 274.6 220 280.2 220S290.8 222.2 294.4 225.8L394.2000000000001 325.8C397.6 329.4 400 334.4 400 340C400 351 391 360 380 360C374.4 360 369.4 357.8 365.8 354.2L280 268.4L234.2 314.2C230.8 317.8 225.8 320 220.2 320C209.2 320 200.2 311 200.2 300C200.2 294.4 202.4 289.4 206 285.8L266 225.8zM400 200.8C400 201 400 201.2 400 201.4C400 201.4 400 201.6 400 201.6C400 201.8 400 201.8 400 202C400 202.2 400 202.2 400 202.4C400 202.4 400 202.4 400 202.4C399.6 205.6 398 208.8 395.8 211.1999999999999C387 222.2 377 232.2 366.6 241.6L322.6 197.5999999999999C311.6 186.8 296.6 180 280.2 180C279.2 180 278.4 180.2 277.4 180.2C268.6 145.4 237.6 119.8 200.2 119.8C156 119.8 120.2 155.8 120.2 200C120.2 232.4000000000001 139.4 260.2 167 272.8C162.8 281 160.4 290.2 160.4 300C160.4 305.6 161.4 310.8 162.8 316C141.8 311.6 121.4 303.2 102.4 293C71 276 42.4 252.6 17.6 226.4C13 221.4 8.4 216.4 4.2 211.2C-1.4 204.2 -1.4 195.8 4.2 188.8C17 172.8 32.2 158.4 47.6 145.4C80.8 117.2000000000001 118.8 93.8 160.8 84.2000000000001C185 78.8 209.4 78.4 233.8 83.2C256 87.4 277.4 96.2 297.4 107C328.8 124 357.4 147.4 382.2 173.6C386.8 178.4 391.4 183.4 395.6 188.8C397.8 191.2 399.2000000000001 194.2 399.8000000000001 197.6C399.8000000000001 197.6 399.8000000000001 197.6 399.8000000000001 197.6C399.8000000000001 197.8 399.8000000000001 197.8 399.8000000000001 198C399.8000000000001 198.2 399.8000000000001 198.2 399.8000000000001 198.4C399.8000000000001 198.4 399.8000000000001 198.6 399.8000000000001 198.6C399.8000000000001 198.8 399.8000000000001 199 399.8000000000001 199.1999999999999C399.8000000000001 199.4 399.8000000000001 199.7999999999999 399.8000000000001 200C400 200.2 400 200.6 400 200.8zM200.2 159.8C220.8 159.8 237.6 175.6 239.8 195.8C239.2 196.4 238.6 197 238 197.6L237.8 197.4L195.8 239.6C175.8 237.4000000000001 160.4 220.6 160.4 200C160.2 177.8 178.2 159.8 200.2 159.8z" : "M205.8 186C209.4 182.4 214.4 180.2 220 180.2S230.6 182.4 234.2 186L314.2000000000001 266C317.6 269.6 320 274.6 320 280C320 291 311 300 300 300C294.4000000000001 300 289.4000000000001 297.8 285.8 294.2L220 228.4L194.2 254.2C190.6 257.8 185.6 260 180 260C169 260 160 251.2 160 240C160 234.6 162.4 229.6 166 226L205.8 186zM320 160.8C320 161 320 161 320 161.2C320 161.2 320 161.4 320 161.4C320 161.6 320 161.6 320 161.8C320 162 320 162 320 162.2C320 162.2 320 162.2 320 162.2C319.6 165 318.4 167.6 316.6 169.4C310.6 177.4 303.6 184.6 296.6 191.8L262.6 157.8C251.6 146.8 236.6 140.2 220 140.2C218.8 140.2 217.8 140.4 216.6 140.6C208.4 117 186.4 100 160.2 100C127 100 100.2 127 100.2 160.2C100.2 181.6 111.4 200.2 128 210.8C123.2 219.4 120.2 229.4 120.2 240C120.2 245.2 121 250 122.2 254.8C108.2 250.8 94.8 244.8 82 237.6C56.8 223.6 34 204 14 182.2C10.4 178 6.8 174 3.4 169.6C-1 163.8 -1 156.8 3.4 151C13.6 137.6 25.8 125.6 38 114.8C64.6 91.4 95 71.8 128.6 63.8C148 59.2000000000001 167.6 59 187 62.8C204.8 66.4 221.8 73.6 237.8 82.6C262.8 96.8 285.8 116.4 305.6 138.2C309.2000000000001 142.2 313 146.4 316.4 150.8C318.2 152.8 319.4000000000001 155.4 319.8 158.2C319.8 158.2 319.8 158.2 319.8 158.2C319.8 158.4 319.8 158.4 319.8 158.6C319.8 158.8 319.8 158.8 319.8 159C319.8 159 319.8 159.2 319.8 159.2C319.8 159.4 319.8 159.4 319.8 159.6C319.8 159.8 319.8 160 319.8 160.2C320 160.4 320 160.6 320 160.8zM160.2 140C169.8 140 177.6 147 179.4 156.2C178.8 156.8 178.4 157.4 178 158L177.6 157.8L156 179.4C147 177.4 140.2 169.8 140.2 160.2C140.2 149 149.2 140 160.2 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
EyeOn.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
EyeOn.displayName = "Blueprint5.Icon.EyeOn";
exports.default = EyeOn;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9nMLv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EyeOpen", ()=>EyeOpen);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var EyeOpen = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "eye-open",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200.1998 240.3130406C178.2217782 240.3130406 160.2397602 222.2624252 160.2397602 200.200562C160.2397602 178.1386996 178.2217782 160.0880842 200.1998 160.0880842C222.177822 160.0880842 240.15984 178.1386996 240.15984 200.200562C240.15984 222.2624252 222.177822 240.3130406 200.1998 240.3130406zM400 200.8022492C400 201.0028116 400 201.203374 400 201.4039364C400 201.4039364 400 201.6044988 400 201.6044988C400 201.8050612 400 201.8050612 400 202.0056236C400 202.206186 400 202.206186 400 202.4067484C400 202.4067484 400 202.4067484 400 202.4067484C399.6004 205.6157466 398.001998 208.8247448 395.804196 211.2314936C383.016984 227.276485 367.832168 241.516415 352.447552 254.5529704C319.28072 282.6317054 281.118882 306.29806786 239.16084 315.72450034C214.985014 321.139684948 190.4095904 321.340247342 166.033966 316.7273123C143.8561438 312.71606444 122.4775224 303.89131916 102.4975024 293.06095C71.1288712 276.0131466000001 42.5574426 252.747909 17.58241758 226.4742354C12.98701298 221.4601756 8.3916084 216.6466782 4.1958042 211.2314936C-1.398601398 204.2118098 -1.398601398 195.7881902 4.1958042 188.7685064C16.98301698 172.723515 32.1678322 158.483585 47.5524476 145.4470296C80.7192808 117.368294 118.8811188 93.902494 160.8391608 84.2755C185.014985 78.860316 209.59041 78.659752 233.966034 83.272688C256.143856 87.484498 277.522478 96.309244 297.502498 107.139612C328.871128 124.1874158 357.442558 147.4526534 382.417582 173.726327C387.0129880000001 178.5398244 391.608392 183.5538842 395.804196 188.7685064C398.001998 191.1752552 399.4006000000001 194.183691 400 197.5932516C400 197.5932516 400 197.5932516 400 197.5932516C400 197.793814 400 197.793814 400 197.9943764C400 198.1949388 400 198.1949388 400 198.3955012C400 198.3955012 400 198.5960636 400 198.5960636C400 198.796626 400 198.9971884 400 199.1977508C400 199.3983132 400 199.7994372 400 199.9999996C400 200.4011244 400 200.6016868 400 200.8022492zM200.1998 119.975606C156.043956 119.975606 120.2797202 155.876274 120.2797202 200.200562C120.2797202 244.5248508 156.043956 280.4255192 200.1998 280.4255192C244.355644 280.4255192 280.11988 244.5248508 280.11988 200.200562C280.11988 155.876274 244.355644 119.975606 200.1998 119.975606z" : "M160.049922 179.9463792C149.0670826 179.9463792 140.0811232 170.9230228 140.0811232 159.894476C140.0811232 148.8659294 149.0670826 139.842573 160.049922 139.842573C171.0327614 139.842573 180.0187208 148.8659294 180.0187208 159.894476C180.0187208 170.9230228 171.0327614 179.9463792 160.049922 179.9463792zM319.800312 160.4960332C319.800312 160.6965522 319.800312 160.6965522 319.800312 160.8970712C319.800312 160.8970712 319.800312 161.0975902 319.800312 161.0975902C319.800312 161.2981092 319.800312 161.2981092 319.800312 161.4986284C319.800312 161.6991474 319.800312 161.6991474 319.800312 161.8996664C319.800312 161.8996664 319.800312 161.8996664 319.800312 161.8996664C319.400936 164.7069328 318.202808 167.1131612 316.405616 169.1183514C306.221528 182.5531266 294.040562 194.3837494 281.659906 205.2117772C255.101404 228.6725038 224.74883 248.32336886 191.201248 256.1436110800001C171.6318252 260.956067826 152.2620904 261.156586858 132.6926678 257.34672526C114.9204368 253.7373827 97.9469578 246.51869758 81.7722308 237.4953412C56.8112324 223.25849 33.8471138 203.808144 13.87831514 181.9515694C10.28393136 177.7406698 6.68954758 173.7302892 3.2948518 169.3188706C-1.098283932 163.5038186 -1.098283932 156.4856526 3.2948518 150.6706006C13.47893916 137.2358256 25.6599064 125.4052026 38.0405616 114.5771758C64.599064 91.1164492 94.951638 71.465584 128.49922 63.6453418C147.8689548 59.033404 167.4383776 58.832886 187.0078004 62.8432658C204.780032 66.4526082 221.75351 73.6712934 237.928238 82.6946498C262.889236 96.931501 285.853354 116.381847 305.822152 138.2384206C309.416536 142.2488012 313.2106080000001 146.459701 316.605304 150.8711196C318.402496 152.87631 319.6006240000001 155.4830574 320 158.0898048C320 158.0898048 320 158.0898048 320 158.0898048C320 158.2903238 320 158.2903238 320 158.4908428C320 158.6913618 320 158.6913618 320 158.8918808C320 158.8918808 320 159.0924 320 159.0924C320 159.2929190000001 320 159.2929190000001 320 159.493438C320 159.693957 320 159.894476 320 160.094995C320 160.2955142 319.800312 160.2955142 319.800312 160.4960332zM160.049922 99.7387674C126.901716 99.7387674 100.1435258 126.6083168 100.1435258 159.894476C100.1435258 193.1806352 126.901716 220.0501854 160.049922 220.0501854C193.198128 220.0501854 219.956318 193.1806352 219.956318 159.894476C219.956318 126.6083168 193.198128 99.7387674 160.049922 99.7387674z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
EyeOpen.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
EyeOpen.displayName = "Blueprint5.Icon.EyeOpen";
exports.default = EyeOpen;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hpbb0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FastBackward", ()=>FastBackward);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FastBackward = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "fast-backward",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 340C355.4 340 351.6 338.2 348.2 335.8L348 336L220 240V320C220 331 211 340 200 340C195.4 340 191.6 338.2 188.2 335.8L188 336L28 216L28.2 215.8C23.4 212 20 206.6 20 200S23.4 188 28.2 184.2L28 184L188 64L188.2 64.2000000000001C191.6 61.8 195.4 60 200 60C211 60 220 69 220 80V160L348 64L348.2 64.2000000000001C351.6 61.8 355.4 60 360 60C371 60 380 69 380 80V320C380 331 371 340 360 340z" : "M280 260C275.2 260 271.2 258.2 267.6 255.4L267.4000000000001 255.6L180 185.6V240C180 251 171 260 160 260C155.2 260 151.2 258.2 147.6 255.4L147.6 255.6L47.6 175.6C47.6 175.6 47.8 175.4 47.8 175.4C43.2 171.8 40 166.4 40 160S43.2 148.2 47.6 144.6L47.6 144.4L147.6 64.4L147.8 64.6C151.2 61.8 155.2 60 160 60C171 60 180 69 180 80V134.4L267.6 64.4L267.8 64.6C271.2 61.8 275.2 60 280 60C291 60 300 69 300 80V240C300 251 291 260 280 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FastBackward.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FastBackward.displayName = "Blueprint5.Icon.FastBackward";
exports.default = FastBackward;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2OKbi":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FastForward", ()=>FastForward);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FastForward = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "fast-forward",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 200C380 206.6 376.6 212 371.8 215.8L372 216L212 336L211.8000000000001 335.8C208.4 338.2 204.6 340 200 340C189 340 180 331 180 320V240L52 336L51.8 335.8C48.4 338.2 44.6 340 40 340C29 340 20 331 20 320V80C20 69 29 60 40 60C44.6 60 48.4 61.8 51.8 64.2000000000001L52 64L180 160V80C180 69 189 60 200 60C204.6 60 208.4 61.8 211.8 64.2000000000001L212 64L372 184L371.8 184.2C376.6 188 380 193.4 380 200z" : "M300 160C300 166.4 296.8 171.8 292.4 175.4L292.6 175.6L192.6 255.6L192.4 255.4C188.8 258.2 184.8 260 180 260C169 260 160 251 160 240V185.6L72.4 255.6L72.4 255.4C68.8 258.2 64.8 260 60 260C49 260 40 251 40 240V80C40 69 49 60 60 60C64.8 60 68.8 61.8 72.4 64.6L72.6 64.4L160 134.4V80C160 69 169 60 180 60C184.8 60 188.8 61.8 192.4 64.6L192.6 64.4L292.6 144.4C292.6 144.4 292.4 144.6 292.4 144.6C296.8 148.2 300 153.6 300 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FastForward.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FastForward.displayName = "Blueprint5.Icon.FastForward";
exports.default = FastForward;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5UsHX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeedSubscribed", ()=>FeedSubscribed);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FeedSubscribed = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "feed-subscribed",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M50 100C22.4 100 0 77.6 0 50C0 22.4 22.4 0 50 0S100 22.4 100 50C100 77.6 77.6 100 50 100zM60 360C95.2 360 128.8 353.8 160.2 342.6C160.8 356.8 166.4 369.6 175.2 379.6C139.2 392.6 100.6 400 60 400C49 400 40 391 40 380S49 360 60 360zM266.4 266.6C270 263 275 260.8 280.4 260.8C285.8 260.8 290.8 263 294.4 266.6L394 366.2C397.8 369.6 400 374.6 400 380.2C400 391.2 391 400.2 380 400.2C374.6 400.2 369.6 398 366 394.4L280.6 309L235.0000000000001 354.6C231.4000000000001 358.2 226.4000000000001 360.4 221.0000000000001 360.4C210 360.4 201.2000000000001 351.4 201.2000000000001 340.4C201.2000000000001 334.8 203.4 330 207 326.4L266.4 266.6zM60 200C49 200 40 191 40 180S49 160 60 160C115.2 160 160 115.2 160 60C160 49 169 40 180 40S200 49 200 60C200 137.4 137.4 200 60 200zM338.8 253.8L322.4000000000001 237.4000000000001L322 237.8C318.0000000000001 233.8 313.6 230.4000000000001 308.6 227.6C341.2 179.8 360 122.2 360 60C360 49 369 40 380 40S400 49 400 60C400 132.2 377.2 198.8 338.8 253.8zM60 300C49 300 40 291 40 280S49 260 60 260C170.4 260 260 170.4 260 60C260 49 269 40 280 40S300 49 300 60C300 192.6 192.6 300 60 300z" : "M60 280C81.2 280 101.6 276.8 121.2 271C123.8 285.2 131.6 297.4 142.2 306.2C116.4 315 88.8 320 60 320C49 320 40 311 40 300S49 280 60 280zM40 80C18 80 0 62 0 40C0 18 18 0 40 0S80 18 80 40C80 62 62 80 40 80zM206.4 206.6C210 203 215 200.8 220.4 200.8C225.8 200.8 230.8 203 234.4 206.6L314 286.2C317.8 289.8 320 294.6 320 300.2C320 311.2 311 320 300 320C294.4000000000001 320 289.6 317.8 286 314.2L220.4 248.6L194.6 274.4C191 278 186 280.2 180.6 280.2C169.6 280.2 160.6 271.2 160.6 260.4C160.6 255 162.8 250 166.4 246.4L206.4 206.6zM281 196L262.4000000000001 177.4L262 177.8C258.6 174.4 255.0000000000001 171.2 250.8 168.8C269.4000000000001 136.8 280 99.6 280 60C280 49 289 40 300 40S320 49 320 60C320 110 305.4 156.4 281 196zM60 160C49 160 40 151 40 140S49 120 60 120C93.2 120 120 93.2 120 60C120 49 129 40 140 40S160 49 160 60C160 115.2 115.2 160 60 160zM178.2 178.2L177.6 177.6L137.6 217.6L138.2 218.2C136 220.4 133.6 222.2 131.6 224.8C109.6 234.4 85.6 240 60 240C49 240 40 231 40 220S49 200 60 200C137.4 200 200 137.4 200 60C200 49 209 40 220 40S240 49 240 60C240 97.4 228.6 132.2 209 161.2C196.8 163.4 186.4 169.6 178.2 178.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FeedSubscribed.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FeedSubscribed.displayName = "Blueprint5.Icon.FeedSubscribed";
exports.default = FeedSubscribed;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ltDlR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Feed", ()=>Feed);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Feed = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "feed",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M50 100C22.4 100 0 77.6 0 50C0 22.4 22.4 0 50 0S100 22.4 100 50C100 77.6 77.6 100 50 100zM60 200C49 200 40 191 40 180C40 169 49 160 60 160C115.2 160 160 115.2 160 60C160 49 169 40 180 40S200 49 200 60C200 137.4 137.4 200 60 200zM60 400C49 400 40 391 40 380C40 369 49 360 60 360C225.6 360 360 225.6 360 60C360 49 369 40 380 40S400 49 400 60C400 247.8 247.8 400 60 400zM60 300C49 300 40 291 40 280C40 269 49 260 60 260C170.4 260 260 170.4 260 60C260 49 269 40 280 40S300 49 300 60C300 192.6 192.6 300 60 300z" : "M39.8 80.2C17.8 80.2 -0.2 62.2 -0.2 40.2S17.8 0.2 39.8 0.2S79.8 18.2 79.8 40.2S62 80.2 39.8 80.2zM59.8 160.2C48.8 160.2 39.8 151.2 39.8 140.2S48.8 120.2 59.8 120.2C93 120.2 119.8 93.4 119.8 60.2C119.8 49.2 128.8 40.2 139.8 40.2S159.8 49.2 159.8 60.2C159.8 115.4 115 160.2 59.8 160.2zM59.8 240.2C48.8 240.2 39.8 231.2 39.8 220.2S48.8 200.2 59.8 200.2C137.2 200.2 199.8 137.6 199.8 60.2C199.8 49.2 208.8 40.2 219.8 40.2S239.8 49.2 239.8 60.2C239.8 159.6 159.2 240.2 59.8 240.2zM59.8 320.2C48.8 320.2 39.8 311.2 39.8 300.2S48.8 280.2 59.8 280.2C181.4 280.2 279.8 181.8 279.8 60.2C279.8 49.2 288.8 40.2 299.8 40.2S319.8 49.2 319.8 60.2C319.8 203.8 203.4 320.2 59.8 320.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Feed.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Feed.displayName = "Blueprint5.Icon.Feed";
exports.default = Feed;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPbhH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FighterJet", ()=>FighterJet);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FighterJet = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "fighter-jet",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M294.48 345.52A10 10 0 0 1 306.68 344.02L386.28 391.76C389.8400000000001 393.92 393.9 389.86 391.76 386.28L344.02 306.68A10 10 0 0 1 345.52 294.48L352.92 287.08A10 10 0 0 0 352.92 272.92L303.4 223.4A10 10 0 0 1 300.54 215.22L319.48 44.78A10 10 0 0 0 316.6 36.6L305.1 25.1A10 10 0 0 0 293.56 23.22L185.78 77.0999999999999A4 4 0 0 1 180 73.5399999999999V16.18A10 10 0 0 0 165.52 7.24L106.84 36.5799999999999A10 10 0 0 0 101.4999999999999 47.4999999999999L109.58 87.8999999999999A4 4 0 0 1 108.48 91.4999999999999L91.52 108.4999999999999A4 4 0 0 1 87.9 109.5799999999999L47.5 101.4999999999999A10 10 0 0 0 36.58 106.8199999999999L7.24 165.52A10 10 0 0 0 16.18 180H54.46A4 4 0 0 1 58.26 185.26L21.94 294.14A10 10 0 0 0 24.34 304.36L36.58 316.6A10 10 0 0 0 44.76 319.46L215.2 300.52A10 10 0 0 1 223.38 303.4L272.9 352.92A10 10 0 0 0 287.06 352.92z" : "M233.86 266.14A10 10 0 0 1 246.94 265.2L308.8 311.6C310.66 313 313 310.6600000000001 311.6 308.8L265.2 246.94A10 10 0 0 1 266.14 233.86L272.94 227.06A10 10 0 0 0 272.94 212.92L243.54 183.52A10 10 0 0 1 240.7 175.06L259.3 44.94A10 10 0 0 0 256.4600000000001 36.46L244.6600000000001 24.66A10 10 0 0 0 233.86 22.46L145.5 57.8A4 4 0 0 1 140.02 54.1V13.88A10 10 0 0 0 126.86 4.38L88.4 17.2A10 10 0 0 0 81.76 28.66L89.6 67.9A4 4 0 0 1 88.5 71.5L80 80L71.52 88.48A4 4 0 0 1 67.9 89.58L28.66 81.74A10 10 0 0 0 17.2 88.38L4.4 126.84A10 10 0 0 0 13.86 140H54.06A4 4 0 0 1 57.78 145.48L22.42 233.88A10 10 0 0 0 24.64 244.68L36.44 256.48A10 10 0 0 0 44.92 259.2800000000001L175.04 240.7A10 10 0 0 1 183.52 243.54L212.92 272.9400000000001A10 10 0 0 0 227.06 272.9400000000001z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FighterJet.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FighterJet.displayName = "Blueprint5.Icon.FighterJet";
exports.default = FighterJet;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aZXO6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Film", ()=>Film);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Film = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "film",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 360H280V300H120V360H20C9 360 0 351 0 340V60C0 49 9 40 20 40H120V100H280V40H380C391 40 400 49 400 60V340C400 351 391 360 380 360zM80 60H40V100H80V60zM80 120H40V160H80V120zM80 180H40V220H80V180zM80 240H40V280H80V240zM80 300H40V340H80V300zM280 140H120V260H280V140zM360 60H320V100H360V60zM360 120H320V160H360V120zM360 180H320V220H360V180zM360 240H320V280H360V240zM360 300H320V340H360V300z" : "M300 300H200V260H120V300H20C9 300 0 291 0 280V60C0 49 9 40 20 40H120V80H200V40H300C311 40 320 49 320 60V280C320 291 311 300 300 300zM80 60H40V100H80V60zM80 120H40V160H80V120zM80 180H40V220H80V180zM80 240H40V280H80V240zM200 120H120V220H200V120zM280 60H240V100H280V60zM280 120H240V160H280V120zM280 180H240V220H280V180zM280 240H240V280H280V240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Film.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Film.displayName = "Blueprint5.Icon.Film";
exports.default = Film;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iyHhU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterKeep", ()=>FilterKeep);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FilterKeep = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "filter-keep",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 360C300 371 291 380 280 380H20C9 380 0 371 0 360C0 354.4 2.2 349.4 5.8 345.8L100 251.8V80C100 69 109 60 120 60C125.6 60 130.6 62.2 134.2 65.8L194.2 125.8C197.8 129.4 200 134.4 200 140V251.8L294.2000000000001 346C297.8 349.4 300 354.4 300 360zM380 140C374.4 140 369.4 137.8 365.8 134.2000000000001L300 68.2L274.2000000000001 94C270.6 97.8 265.6 100 260 100C249 100 240 91 240 80C240 74.4 242.2 69.4 245.8 65.8L285.8 25.8C289.4000000000001 22.2 294.4000000000001 20 300 20S310.6 22.2 314.2000000000001 25.8L394.2000000000001 105.8C397.8 109.4 400 114.4 400 120C400 131 391 140 380 140z" : "M300 120C294.4000000000001 120 289.4000000000001 117.8 285.8 114.2L240 68.2L214.2 94C210.6 97.8 205.6 100 200 100C189 100 180 91 180 80C180 74.4 182.2 69.4 185.8 65.8L225.8 25.8C229.4 22.2 234.4 20 240 20S250.6 22.2 254.2 25.8L314.2000000000001 85.8C317.8 89.4 320 94.4 320 100C320 111 311 120 300 120zM240 280C240 291 231 300 220 300H20C9 300 0 291 0 280C0 274.4 2.2 269.4 5.8 265.8L80 191.8V80C80 69 89 60 100 60C105.6 60 110.6 62.2 114.2 65.8L154.2 105.8C157.8 109.4 160 114.4 160 120V191.8L234.2 266C237.8 269.4 240 274.4 240 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FilterKeep.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FilterKeep.displayName = "Blueprint5.Icon.FilterKeep";
exports.default = FilterKeep;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43Wvs":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterList", ()=>FilterList);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FilterList = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "filter-list",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 360C300 371 291 380 280 380H20C9 380 0 371 0 360C0 354.4 2.2 349.4 5.8 345.8L100 251.8V80C100 69 109 60 120 60C125.6 60 130.6 62.2 134.2 65.8L194.2 125.8C197.8 129.4 200 134.4 200 140V251.8L294.2000000000001 346C297.8 349.4 300 354.4 300 360zM220 200C220 189 229 180 240 180H380C391 180 400 189 400 200C400 211 391 220 380 220H240C229 220 220 211 220 200zM380 60H240C229 60 220 51 220 40C220 29 229 20 240 20H380C391 20 400 29 400 40C400 51 391 60 380 60zM380 140H240C229 140 220 131 220 120C220 109 229 100 240 100H380C391 100 400 109 400 120C400 131 391 140 380 140z" : "M180 160C180 149 189 140 200 140H300C311 140 320 149 320 160C320 171 311 180 300 180H200C189 180 180 171 180 160zM240 280C240 291 231 300 220 300H20C9 300 0 291 0 280C0 274.4 2.2 269.4 5.8 265.8L80 191.8V80C80 69 89 60 100 60C105.6 60 110.6 62.2 114.2 65.8L154.2 105.8C157.8 109.4 160 114.4 160 120V191.8L234.2 266C237.8 269.4 240 274.4 240 280zM300 120H200C189 120 180 111 180 100C180 89 189 80 200 80H300C311 80 320 89 320 100C320 111 311 120 300 120zM300 60H200C189 60 180 51 180 40C180 29 189 20 200 20H300C311 20 320 29 320 40C320 51 311 60 300 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FilterList.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FilterList.displayName = "Blueprint5.Icon.FilterList";
exports.default = FilterList;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ePWj4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterOpen", ()=>FilterOpen);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FilterOpen = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "filter-open",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 360C300 354.4 297.8 349.4 294.2000000000001 346L200 251.8L200 140C200 134.4 197.8 129.4 194.2 125.8L134.2 65.8C130.6 62.2 125.6 60 120 60C109 60 100 69 100 80L100 251.8L5.8 345.8C2.2 349.4 1e-13 354.4 1e-13 360C1e-13 371 9 380 20 380L280 380C291 380 300 371 300 360zM394.142136 134.142136C401.952622 126.33165 401.952622 113.66835 394.142136 105.857864L314.142136 25.8578640000001C301.542838 13.258568 280 22.181902 280 40L280 200C280 217.818097 301.542838 226.7414328 314.142136 214.1421356L394.142136 134.142136z" : "M314.142136 114.142136C321.952622 106.33165 321.952622 93.66835 314.142136 85.857864L254.142136 25.857864C241.542838 13.258568 220 22.181902 220 40L220 160C220 177.818097 241.542838 186.7414328 254.142136 174.1421356L314.142136 114.142136zM240 280C240 274.4 237.8 269.4 234.2 266L160 191.8L160 120C160 114.4 157.8 109.4 154.2 105.8L114.2 65.8C110.6 62.2 105.6 60 100 60C89 60 80 69 80 80L80 191.8L5.8 265.8C2.2 269.4 -1e-13 274.4 -1e-13 280C-1e-13 291 9 300 20 300L220 300C231 300 240 291 240 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FilterOpen.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FilterOpen.displayName = "Blueprint5.Icon.FilterOpen";
exports.default = FilterOpen;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kzANK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterRemove", ()=>FilterRemove);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FilterRemove = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "filter-remove",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 360C300 371 291 380 280 380H20C9 380 0 371 0 360C0 354.4 2.2 349.4 5.8 345.8L100 251.8V80C100 69 109 60 120 60C125.6 60 130.6 62.2 134.2 65.8L194.2 125.8C197.8 129.4 200 134.4 200 140V251.8L294.2000000000001 346C297.8 349.4 300 354.4 300 360zM358.2 90L394 125.8C397.8 129.4 400 134.4 400 140C400 151 391 160 380 160C374.4 160 369.4 157.8 365.8 154.2L330 118.4L294.2000000000001 154.2C290.6 157.8 285.6 160 280 160C269 160 260 151 260 140C260 134.4 262.2 129.4 265.8 125.8L301.6 90L265.8 54.2C262.2 50.6 260 45.6 260 40C260 29 269 20 280 20C285.6 20 290.6 22.2 294.2000000000001 25.8L330 61.6L365.8 25.8C369.4 22.2 374.4 20 380 20C391 20 400 29 400 40C400 45.6 397.8 50.6 394.2000000000001 54.2L358.2 90z" : "M240 280C240 291 231 300 220 300H20C9 300 0 291 0 280C0 274.4 2.2 269.4 5.8 265.8L80 191.8V80C80 69 89 60 100 60C105.6 60 110.6 62.2 114.2 65.8L154.2 105.8C157.8 109.4 160 114.4 160 120V191.8L234.2 266C237.8 269.4 240 274.4 240 280zM288.2 80L314 105.8C317.8 109.4 320 114.4 320 120C320 131 311 140 300 140C294.4000000000001 140 289.4000000000001 137.8 285.8 134.2L260 108.2L234.2 134C230.6 137.8 225.6 140 220 140C209 140 200 131 200 120C200 114.4 202.2 109.4 205.8 105.8L231.8 80L206 54.2C202.2 50.6 200 45.6 200 40C200 29 209 20 220 20C225.6 20 230.6 22.2 234.2 25.8L260 51.8L285.8 26C289.4000000000001 22.2 294.4000000000001 20 300 20C311 20 320 29 320 40C320 45.6 317.8 50.6 314.2000000000001 54.2L288.2 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FilterRemove.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FilterRemove.displayName = "Blueprint5.Icon.FilterRemove";
exports.default = FilterRemove;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7xkxo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSortAsc", ()=>FilterSortAsc);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FilterSortAsc = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "filter-sort-asc",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 360C400 371 391 380 380 380H120C109 380 100 371 100 360C100 354.4 102.2 349.4 105.8 345.8L200 251.8V80C200 69 209 60 220 60C225.6 60 230.6 62.2 234.2 65.8L294.2000000000001 125.8C297.8 129.4 300 134.4 300 140V251.8L394.2000000000001 346C397.8 349.4 400 354.4 400 360zM94.2 194.2C90.6 197.8 85.6 200 80 200C74.4 200 69.4 197.8 65.8 194.2L5.8 134.2000000000001C2.2 130.6 0 125.6 0 120C0 109 9 100 20 100C25.6 100 30.6 102.2 34.2 105.8L60 131.8V20C60 9 69 0 80 0C91 0 100 9 100 20V131.8L125.8 106C129.4 102.2 134.4 100 140 100C151 100 160 109 160 120C160 125.6 157.8 130.6 154.2 134.2000000000001L94.2 194.2z" : "M320 280C320 274.4 317.8 269.4 314.2000000000001 266L240 191.8V120C240 114.4 237.8 109.4 234.2 105.8L194.2 65.8C190.6 62.2 185.6 60 180 60C169 60 160 69 160 80V191.8L85.8 265.8C82.2 269.4 80 274.4 80 280C80 291 89 300 100 300H300C311 300 320 291 320 280zM100 79.898C94.4 79.898 89.4 82.094 85.8 85.69L80 91.484V19.972C80 8.986 71 -0.002 60 -0.002C49 -0.002 40 8.986 40 19.972V91.682L34.2 85.89C30.6 82.294 25.6 80.098 20 80.098C9 80.098 0 89.086 0 100.072C0 105.666 2.2 110.66 5.8 114.254L45.8 154.2048C49.4 157.8002 54.4 159.9976 60 159.9976C65.6 159.9976 70.6 157.8002 74.2 154.2048L114.2 114.254C117.8 110.66 120 105.666 120 100.072C120 88.886 111 79.898 100 79.898z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FilterSortAsc.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FilterSortAsc.displayName = "Blueprint5.Icon.FilterSortAsc";
exports.default = FilterSortAsc;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cpD5T":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSortDesc", ()=>FilterSortDesc);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FilterSortDesc = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "filter-sort-desc",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 360C400 371 391 380 380 380H120C109 380 100 371 100 360C100 354.4 102.2 349.4 105.8 345.8L200 251.8V80C200 69 209 60 220 60C225.6 60 230.6 62.2 234.2 65.8L294.2000000000001 125.8C297.8 129.4 300 134.4 300 140V251.8L394.2000000000001 346C397.8 349.4 400 354.4 400 360zM94.2 5.8C90.6 2.2 85.6 0 80 0C74.4 0 69.4 2.2 65.8 5.8L5.8 65.8C2.2 69.4 0 74.4 0 80C0 91 9 100 20 100C25.6 100 30.6 97.8 34.2 94.2000000000001L60 68.2V180C60 191 69 200 80 200C91 200 100 191 100 180V68.2L125.8 94C129.4 97.8 134.4 100 140 100C151 100 160 91 160 80C160 74.4 157.8 69.4 154.2 65.8L94.2 5.8z" : "M320 280C320 274.4 317.8 269.4 314.2000000000001 266L240 191.8V120C240 114.4 237.8 109.4 234.2 105.8L194.2 65.8C190.6 62.2 185.6 60 180 60C169 60 160 69 160 80V191.8L85.8 265.8C82.2 269.4 80 274.4 80 280C80 291 89 300 100 300H300C311 300 320 291 320 280zM100 80.098C94.4 80.098 89.4 77.9 85.8 74.304L80 68.512V140.0226C80 151.0088 71 159.9976 60 159.9976C49 159.9976 40 151.0088 40 140.0226V68.312L34.2 74.104C30.6 77.7 25.6 79.898 20 79.898C9 79.898 0 70.908 0 59.922C0 54.33 2.2 49.336 5.8 45.74L45.8 5.79C49.4 2.194 54.4 -0.002 60 -0.002C65.6 -0.002 70.6 2.194 74.2 5.79L114.2 45.74C117.8 49.336 120 54.33 120 59.922C120 71.108 111 80.098 100 80.098z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FilterSortDesc.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FilterSortDesc.displayName = "Blueprint5.Icon.FilterSortDesc";
exports.default = FilterSortDesc;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dmda5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Filter", ()=>Filter);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Filter = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "filter",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 380H40C29 380 20 371 20 360C20 354.4 22.2 349.4 25.8 345.8L140 231.8V40C140 29 149 20 160 20C165.6 20 170.6 22.2 174.2 25.8L254.2 105.8C257.8 109.4 260 114.4 260 120V231.8L374.2000000000001 346C377.8 349.4 380 354.4 380 360C380 371 371 380 360 380z" : "M279.8 300.2H39.8C28.8 300.2 19.8 291.2 19.8 280.2C19.8 274.6 22 269.6 25.6 266L119.8 171.8V40C119.8 29 128.8 20 139.8 20C145.4 20 150.4 22.2 154 25.8L194 65.8C197.6 69.4 199.8 74.4 199.8 80V171.8L294 266C297.6 269.6 299.8 274.6 299.8 280.2C299.8 291.2 290.8 300.2 279.8 300.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Filter.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Filter.displayName = "Blueprint5.Icon.Filter";
exports.default = Filter;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kd8iq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Flag", ()=>Flag);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Flag = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "flag",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 340C49 340 40 331 40 320V20C40 9 49 0 60 0S80 9 80 20V320C80 331 71 340 60 340zM60 400C49 400 40 391 40 380C40 369 49 360 60 360S80 369 80 380C80 391 71 400 60 400zM100 318.4V152.8C160.2 201 273.4 100 360 152.8V318.4C272.2 257.2000000000001 160.2 380 100 318.4z" : "M59.8 260.2C48.8 260.2 39.8 251.2 39.8 240.2V20.2C39.8 9.2 48.8 0.2 59.8 0.2S79.8 9.2 79.8 20.2V240.2C79.8 251.2 70.8 260.2 59.8 260.2zM59.8 320.2C48.8 320.2 39.8 311.2 39.8 300.2S48.8 280.2 59.8 280.2S79.8 289.2 79.8 300.2S70.8 320.2 59.8 320.2zM99.8 259.6V115C141.2 157.2 218.2 80 279.8 115V259.6C219.8 218.2 141 300.2 99.8 259.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Flag.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Flag.displayName = "Blueprint5.Icon.Flag";
exports.default = Flag;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9odL":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Flame", ()=>Flame);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Flame = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "flame",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M232.446022 400C232.446022 365.8119658 242.257866 338.4615384 261.8815560000001 317.948718C327.293852 270.08547 360 215.3846154 360 153.846154C360 85.470086 320.752622 34.188034 242.257866 0C300 60 291.31709 84.615384 232.446022 160C170 130 180 110 190 70C169.0485132 70 150 70 140 80C140 66.324786 163.9343176 30 179.0485132 0C100.5537578 20.51282 16.58544538 143.589744 46.0209786 153.846154C65.6446674 160.68376 88.5389712 157.264958 114.7038896 143.589744C81.9977416 266.6666666 121.2451192 352.1367522 232.446022 400z" : "M184.334517 320C184.334517 292.6495726 191.6934002 270.7692308 206.411166 254.3589744C255.470388 216.068376 280 172.3076924 280 123.076923C280 68.376068 250.564466 27.350428 191.6934002 0C235 48 228.487816 67.692308 184.334517 128C137.5 104 145 88 152.5 56C136.7863848 56 122.5 56 115 64C115 53.05983 132.9507382 24 144.2863848 0C85.4153184 16.410256 22.439084 114.871794 44.515734 123.076923C59.2335006 128.5470086 76.4042284 125.8119658 96.0279172 114.871794C71.4983062 213.3333334 100.9338394 281.7094018 184.334517 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Flame.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Flame.displayName = "Blueprint5.Icon.Flame";
exports.default = Flame;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Z4eM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Flash", ()=>Flash);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Flash = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "flash",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M99.2 272.6C102.8 269 107.8 266.8 113.4 266.8C124.4 266.8 133.4 275.8 133.4 286.8C133.4 292.4 131.2 297.4 127.6 301L87.6 341C83.8 344.4 78.8 346.6 73.4 346.6C62.4 346.6 53.4 337.6 53.4 326.6C53.4 321 55.6 316 59.2 312.4L99.2 272.6zM286.6 266.6C292.2 266.6 297.2 268.8 300.8 272.4L340.8 312.4C344.4 316 346.6 321 346.6 326.6C346.6 337.6 337.6 346.6 326.6 346.6C321 346.6 316 344.4 312.4 340.8L272.4 300.8C268.8 297.2 266.6 292.2 266.6 286.6C266.6 275.6 275.6 266.6 286.6 266.6zM200 300C211 300 220 309 220 320V380C220 391 211 400 200 400S180 391 180 380V320C180 309 189 300 200 300zM100 200C100 211 91 220 80 220H20C9 220 0 211 0 200C0 189 9 180 20 180H80C91 180 100 189 100 200zM380 220H320C309 220 300 211 300 200C300 189 309 180 320 180H380C391 180 400 189 400 200C400 211 391 220 380 220zM200 280C155.8 280 120 244.2 120 200C120 155.8 155.8 120 200 120S280 155.8 280 200C280 244.2 244.2 280 200 280zM200 160C178 160 160 178 160 200C160 222 178 240 200 240S240 222 240 200C240 178 222 160 200 160zM300.8 127.4C297.2 131 292.2 133.2 286.6 133.2C275.6 133.2 266.6 124.2 266.6 113.2C266.6 107.6 268.8 102.6 272.4 99L312.4 59C316 55.4 321 53.2 326.6 53.2C337.6 53.2 346.6 62.2 346.6 73.2C346.6 78.8 344.4 83.8 340.8 87.4L300.8 127.4zM200 100C189 100 180 91 180 80V20C180 9 189 0 200 0S220 9 220 20V80C220 91 211 100 200 100zM113.4 133.4C107.8 133.4 102.8 131.2 99.2 127.6L59.2 87.6C55.6 84 53.4 79 53.4 73.4C53.4 62.4 62.4 53.4 73.4 53.4C79 53.4 84 55.6 87.6 59.2000000000001L127.6 99.2000000000001C131.2 102.8 133.4 107.8 133.4 113.4C133.4 124.4 124.4 133.4 113.4 133.4z" : "M80 160C80 171 71 180 60 180H20C9 180 0 171 0 160C0 149 9 140 20 140H60C71 140 80 149 80 160zM160 240C171 240 180 249 180 260V300C180 311 171 320 160 320S140 311 140 300V260C140 249 149 240 160 240zM75.8 215.8C79.4 212.2 84.4 210 90 210C101 210 110 219 110 230C110 235.6 107.8 240.6 104.2 244.2L74.2 274.2C70.6 277.8 65.6 280 60 280C49 280 40 271 40 260C40 254.4 42.2 249.4 45.8 245.8L75.8 215.8zM90 110C84.4 110 79.4 107.8 75.8 104.2L45.8 74.2C42.2 70.6 40 65.6 40 60C40 49 49 40 60 40C65.6 40 70.6 42.2 74.2 45.8L104.2 75.8C107.8 79.4 110 84.4 110 90C110 101 101 110 90 110zM230 210C235.6 210 240.6 212.2 244.2 215.8L274.2000000000001 245.8C277.8 249.4 280 254.4 280 260C280 271 271 280 260 280C254.4 280 249.4 277.8 245.8 274.2L215.8 244.2C212.2 240.6 210 235.6 210 230C210 219 219 210 230 210zM244.2 104.2C240.6 107.8 235.6 110 230 110C219 110 210 101 210 90C210 84.4 212.2 79.4 215.8 75.8L245.8 45.8C249.4 42.2 254.4 40 260 40C271 40 280 49 280 60C280 65.6 277.8 70.6 274.2000000000001 74.2L244.2 104.2zM300 180H260C249 180 240 171 240 160C240 149 249 140 260 140H300C311 140 320 149 320 160C320 171 311 180 300 180zM160 220C126.8 220 100 193.2 100 160S126.8 100 160 100S220 126.8 220 160S193.2 220 160 220zM160 140C149 140 140 149 140 160C140 171 149 180 160 180S180 171 180 160C180 149 171 140 160 140zM160 80C149 80 140 71 140 60V20C140 9 149 0 160 0S180 9 180 20V60C180 71 171 80 160 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Flash.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Flash.displayName = "Blueprint5.Icon.Flash";
exports.default = Flash;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2y8Oj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FloatingPoint", ()=>FloatingPoint);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FloatingPoint = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "floating-point",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 267.0338C26.8572 267.0338 33.5238 267.6022000000001 40 268.7388C46.4762 269.8756 52.2858 271.7702000000001 57.4286 274.4228C62.762 277.0752 67.238 280.4854000000001 70.8572 284.6536C74.6666 288.8218 77.1428 293.9372 78.2858 300H104.8572V101.066H69.1428V241.4564H20V267.0338zM299.3 299.7498C313.05 299.7498 324.2340000000001 296.5586 332.85 290.176C341.65 283.976 348.4340000000001 275.9522 353.2 266.105C358.15 256.4402 361.4500000000001 245.7722 363.1 234.1014C364.9340000000001 222.4306 365.85 211.1246 365.85 200.1832C365.85 189.242 364.9340000000001 177.936 363.1 166.264C361.4500000000001 154.594 358.15 143.836 353.2 133.988C348.4340000000001 124.322 341.65 116.3 332.85 109.916C324.2340000000001 103.716 313.05 100.616 299.3 100.616C285.55 100.616 274.276 103.716 265.476 109.916C256.858 116.3 250.076 124.322 245.126 133.988C240.358 143.836 237.058 154.594 235.226 166.264C233.576 177.936 232.75 189.242 232.75 200.1832C232.75 211.1246 233.576 222.4306 235.226 234.1014C237.058 245.7722 240.358 256.4402 245.126 266.105C250.076 275.9522 256.858 283.976 265.476 290.176C274.276 296.5586 285.55 299.7498 299.3 299.7498zM299.3 126.602C306.084 126.602 311.766 128.518 316.35 132.346C320.9340000000001 136.358 324.5080000000001 141.646 327.076 148.212C329.826 154.958 331.75 162.8 332.85 171.736C333.9500000000001 180.672 334.5 190.154 334.5 200.1832C334.5 210.2128 333.9500000000001 219.6042 332.85 228.3572C331.75 237.2926 329.826 245.134 327.076 251.8812C324.5080000000001 258.6284 320.9340000000001 263.9168 316.35 267.7462000000001C311.766 271.7580000000001 306.084 273.764 299.3 273.764C292.334 273.764 286.558 271.7580000000001 281.976 267.7462000000001C277.576 263.9168 274 258.6284 271.25 251.8812C268.6840000000001 245.134 266.85 237.2926 265.75 228.3572C264.65 219.6042 264.1 210.2128 264.1 200.1832C264.1 190.154 264.65 180.672 265.75 171.736C266.85 162.8 268.6840000000001 154.958 271.25 148.212C274 141.646 277.576 136.358 281.976 132.346C286.558 128.518 292.334 126.602 299.3 126.602zM197.2142 138.366H157.5V100H197.2142V138.366z" : "M20 213.4858C25.4858 213.4858 30.819 213.9428 36 214.8572C41.181 215.7714 45.8286 217.2952 49.9428 219.4286C54.2096 221.5618 57.7904 224.3048 60.6858 227.6572C63.7334 231.0096 65.7142 235.1238 66.6286 240H87.8858V80H59.3142V192.9142H20V213.4858zM243.44 239.7998C254.44 239.7998 263.386 237.2332 270.28 232.0998C277.32 227.1132 282.746 220.6598 286.56 212.7398C290.52 204.9664 293.16 196.3864 294.48 186.9998C295.9460000000001 177.6132 296.68 168.5198 296.68 159.7198C296.68 150.9198 295.9460000000001 141.8264 294.48 132.4398C293.16 123.0532 290.52 114.4 286.56 106.48C282.746 98.706 277.32 92.254 270.28 87.12C263.386 82.134 254.44 79.64 243.44 79.64C232.44 79.64 223.42 82.134 216.38 87.12C209.486 92.254 204.06 98.706 200.1 106.48C196.2868 114.4 193.6468 123.0532 192.18 132.4398C190.86 141.8264 190.2 150.9198 190.2 159.7198C190.2 168.5198 190.86 177.6132 192.18 186.9998C193.6468 196.3864 196.2868 204.9664 200.1 212.7398C204.06 220.6598 209.486 227.1132 216.38 232.0998C223.42 237.2332 232.44 239.7998 243.44 239.7998zM243.44 100.54C248.866 100.54 253.414 102.08 257.08 105.16C260.746 108.386 263.606 112.64 265.66 117.92C267.86 123.3464 269.4000000000001 129.6532 270.28 136.8398C271.16 144.0264 271.6 151.6532 271.6 159.7198C271.6 167.7864 271.16 175.3398 270.28 182.3798C269.4000000000001 189.5664 267.86 195.8732 265.66 201.2998C263.606 206.7264 260.746 210.9798 257.08 214.0598C253.414 217.2864 248.866 218.8998 243.44 218.8998C237.866 218.8998 233.246 217.2864 229.58 214.0598C226.06 210.9798 223.2 206.7264 221 201.2998C218.946 195.8732 217.48 189.5664 216.6 182.3798C215.72 175.3398 215.28 167.7864 215.28 159.7198C215.28 151.6532 215.72 144.0264 216.6 136.8398C217.48 129.6532 218.946 123.3464 221 117.92C223.2 112.64 226.06 108.386 229.58 105.16C233.246 102.08 237.866 100.54 243.44 100.54zM161.7714 110H130V79.142H161.7714V110z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FloatingPoint.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FloatingPoint.displayName = "Blueprint5.Icon.FloatingPoint";
exports.default = FloatingPoint;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aMjy1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FloppyDisk", ()=>FloppyDisk);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FloppyDisk = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "floppy-disk",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 380H220V280H280V380zM394.2000000000001 334.2L334.2000000000001 394.2C330.6 397.8 325.6 400 320 400H300V260H100V400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V320C400 325.6 397.8 330.6 394.2000000000001 334.2zM340 20H60V180C60 191 69 200 80 200H320C331 200 340 191 340 180V20z" : "M314.2000000000001 274.2L274.2000000000001 314.2C270.6 317.8 265.6 320 260 320H240V200H80V320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V260C320 265.6 317.8 270.6 314.2000000000001 274.2zM280 20H40V140C40 151 49 160 60 160H260C271 160 280 151 280 140V20zM220 300H180V220H220V300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FloppyDisk.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FloppyDisk.displayName = "Blueprint5.Icon.FloppyDisk";
exports.default = FloppyDisk;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jn3Xv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlowBranch", ()=>FlowBranch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FlowBranch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "flow-branch",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M288.502886 240.9311088C295.635624 228.9652222000001 299.733384 214.9786258 299.733384 200.0345452C299.733384 184.7956844 295.472368 170.552454 288.07726 158.432246L360.015988 86.577562L360.025784 140.410902C360.026686 145.373462 361.957368 150.336374 365.817628 154.196844C373.40028 161.779914 386.764156 161.782346 394.34405 154.202036C398.202902 150.34297 400.131778 145.380762 399.9930100000001 140.280328L399.974632 39.302668C399.9737300000001 34.340108 398.31873 29.377248 394.4584700000001 25.516776C390.59821 21.656304 385.635632 20.049184 380.673344 20.04828L279.483806 20.029864C274.521518 20.02896 269.559584 21.957942 265.700728 25.817008C258.120836 33.397318 258.123238 46.586246 265.705888 54.169314C269.566148 58.0297860000001 274.528786 59.960574 279.491074 59.961476L333.538882 59.971314L260.866552 131.416644C248.865458 124.213502 234.818398 120.072152 219.80448 120.072152C182.5608214 120.072152 151.2666518 145.555622 142.3936886 180.0439464L19.98222556 180.0439464C8.9463471 180.0439464 0 188.9940424 0 200.0345452C0 211.075048 8.9463471 220.0251436 19.98222556 220.0251436L142.3936886 220.0251436C151.2666518 254.513468 182.5608214 279.996939 219.80448 279.996939C235.117206 279.996939 249.424206 275.6891058 261.580652 268.2187446000001L333.292998 340.0340168L279.424532 340.0438212C274.462242 340.0447244 269.499604 341.975512 265.639346 345.8359832C258.056692 353.4190518 258.054264 366.76342974 265.634156 374.34373874C269.49301 378.202805132 274.454948 380.1317864314 279.555102 379.99300929146L380.565298 379.9746248914001C385.527586 379.9737217314 390.4901720000001 378.318631932 394.350432 374.45816054C398.21069 370.59768934 399.805256 365.63483934 399.8061580000001 360.67227934L399.824548 259.6260248C399.825452 254.6634648 397.896576 249.7012562 394.037722 245.8421898C386.457828 238.2618808000001 373.22735 238.2642888000001 365.644698 245.8473574C361.784438 249.7078288 359.853758 254.67074 359.8528540000001 259.6332998000001L359.843044 313.535235L288.502886 240.9311088z" : "M212.851218 188.099858C217.254234 179.7452286 219.746888 170.2243 219.746888 160.1202742C219.746888 151.3453016 217.866858 143.0101172 214.488212 135.4967294L279.78232 66.25405L279.743242 101.256222C279.918398 106.21895 282.0221 111.115052 286.01542 114.8417C293.859442 122.1619034 306.479202 121.7336892 313.788028 113.890006C317.508884 109.896856 320.091364 104.701984 319.77359 99.606164L319.609014 18.986442C319.433858 14.023714 317.605666 9.118094 313.612344 5.391446C309.6190220000001 1.664796 304.591792 -0.093832 299.63268 0.07749L218.578588 0.045148C213.619474 0.21647 208.728476 2.31774 205.00762 6.310888C197.6987948 14.154572 198.1370232 27.4121 205.981046 34.732304C209.974366 38.458952 215.001598 40.21758 219.96071 40.04626L253.976806 40.059832L187.856118 107.057578C179.4894974 102.613368 169.946232 100.096006 159.8159188 100.096006C133.7215986 100.096006 111.5223872 116.798912 103.2951354 140.1121846L19.97698988 140.1121846C8.94400302 140.1121846 0 149.0701114 0 160.1202742C0 171.170437 8.94400302 180.1283638 19.97698988 180.1283638L103.2951354 180.1283638C111.5223872 203.441637 133.7215986 220.1445428 159.8159188 220.1445428C168.6205068 220.1445428 176.981644 218.2429472 184.512238 214.8274508L253.478608 280.1742186L218.574792 280.1350828C213.615818 280.3103712 208.723418 282.4156626 204.999584 286.4120044C197.6849148 294.2619612 198.1128938 306.6691248800001 205.950648 313.98347888C209.940778 317.70715 215.131724 320.291584222 220.223694 319.9735694902L300.710576 319.8088976582C305.66955 319.633609416 310.571462 317.8040327 314.295296 313.80769098C318.0191260000001 309.81134926 319.776426 304.7803162 319.605234 299.8174508L319.63748 218.8799938C319.466288 213.9171284 317.366606 209.0224306 313.3764760000001 205.2987596C305.538722 197.9844056 292.291214 198.4229654 284.976544 206.2729224C281.252714 210.269264 279.495414 215.3002972 279.666604 220.2631626L279.653114 254.1270406L212.851218 188.099858z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FlowBranch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FlowBranch.displayName = "Blueprint5.Icon.FlowBranch";
exports.default = FlowBranch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kILpt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlowEnd", ()=>FlowEnd);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FlowEnd = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "flow-end",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240.01461 201.629275C240.837688 245.0617898 276.333188 280.01717062 320 280.01717062C364.18278 280.01717062 400 244.2308438 400 200.086172C400 155.9415006 364.18278 120.1551738 320 120.1551738C276.351992 120.1551738 240.868264 155.0804534 240.015692 198.48696C239.64026 193.6795492 237.583316 189.4096012 234.416458 186.247797L153.6840024 105.7947984C150.1700738 102.286478 145.4337502 100.107571 139.9676386 100.107571C129.2306342 100.107571 120.0777876 109.3228848 120.0777876 120.0427526C120.0777876 125.50014 122.2299448 130.6082814 125.7438736 134.116602L173.3131412 180.1536974L19.5996137 180.1536974C8.8626091 180.1536974 0.0777871784 189.3663044 0.0777871784 200.086172C0.0777871784 210.80604 8.8626091 219.922752 19.5996137 219.922752C26.7576168 219.922752 77.9303866 219.922752 173.117923 219.922752L125.7438736 266.2568108C122.2299448 269.7651314 120.0777876 274.5217086 120.0777876 279.9790960000001C120.0777876 290.6989638400001 129.2306342 299.9075710394 139.9676386 299.9075710394C145.4337502 299.9075710394 150.1700738 297.8976514800001 153.6840024 294.19442438L234.22124 213.7296404C237.399318 210.5566364 239.619284 206.4270532 240.01461 201.629275z" : "M194.0493444 173.8034272C197.5606934 170.2831812 199.9015928 165.58952 199.9015928 160.113582C199.9015928 154.6376438 197.7557684 149.7484134 194.2444194 146.2281676C156.4721794 108.0385366 136.3961366 87.8529832 134.0162908 85.6715072C130.446522 82.3992934 125.628068 80 120.1659696 80C109.130218 80 100.21191 88.9472986 100.21191 99.7036056C100.21191 105.1795436 102.4678874 110.5284868 106.0545004 114.1175436C108.4455756 116.510248 118.5418916 125.1276682 136.3434486 139.9698042L19.59998306 139.9698042C8.87086102 139.9698042 0.092488421 149.357275 0.092488421 160.113582C0.092488421 170.8698888 8.87086102 180.0441336 19.59998306 180.0441336L136.3434486 180.0441336C118.4323106 195.0766028 108.3359944 203.770231 106.0545004 206.1250186C102.6322592 209.6572 100.21191 214.7518006 100.21191 220.22773862C100.21191 230.98404562 109.2747504 240 120.0038724 240C125.465971 240 130.4102778 237.83761662 133.9216268 234.1218015C136.2625262 231.64459142 156.3050986 211.5384666 194.0493444 173.8034272zM260 99.9615572C226.862916 99.9615572 200 126.892536 200 160.113582C200 193.3346278 226.862916 220.26560662 260 220.26560662C293.137084 220.26560662 320 193.3346278 320 160.113582C320 126.892536 293.137084 99.9615572 260 99.9615572z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FlowEnd.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FlowEnd.displayName = "Blueprint5.Icon.FlowEnd";
exports.default = FlowEnd;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ZO8P":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlowLinear", ()=>FlowLinear);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FlowLinear = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "flow-linear",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M102.5074162 180.0503182L19.51906448 180.0503182C8.78357902 180.0503182 0 189.2708780000001 0 200C0 210.729122 8.78357902 219.853704 19.51906448 219.853704L102.482844 219.853704C111.3127152 254.4324544 142.6705474 280 180 280C217.329452 280 248.687284 254.4324544 257.517156 219.853704L333.0496080000001 219.853704L285.868188 266.2001672C282.354756 269.7115162 280.158902 274.4841906 280.158902 279.946289C280.158902 290.6754111200001 289.3473360000001 299.9642944336 300.082822 299.9642944336C305.54816 299.9642944336 310.525416 297.66424868 314.0388480000001 293.9578247L394.14428 213.6552462C397.6577120000001 210.1438972 400 205.4620986 400 200C400 194.5379014 397.852902 189.6610278 394.33947 186.1496788L314.0388480000001 106.0021252C310.525416 102.4907762 305.54816 100.0542498 300.082822 100.0542498C289.3473360000001 100.0542498 280.158902 109.1247542 280.158902 119.8538762C280.158902 125.3159748 282.305998 130.1928484 285.81943 133.7041974L333.244798 180.0503182L257.492584 180.0503182C248.62924 145.5202454 217.294906 120 180 120C142.7050934 120 111.3707594 145.5202454 102.5074162 180.0503182z" : "M83.1826106 139.9698042L19.5529698 139.9698042C8.79883638 139.9698042 0 149.357275 0 160.113582C0 170.8698888 8.79883638 179.917692 19.5529698 179.917692L83.1427902 179.917692C91.3799616 203.2645242 113.6905716 220 139.9212536 220C166.1519354 220 188.4625456 203.2645242 196.6997168 179.917692L256.293692 179.917692C238.3408 195.0344554 228.220948 203.770231 225.934134 206.1250186C222.503916 209.6572002 220.077924 214.7518006 220.077924 220.2277387C220.077924 230.98404562 229.161892 240 239.916026 240C245.390856 240 250.34669 237.83761662 253.866224 234.1218015C256.21258 231.64459142 276.301876 211.5384666 314.1341080000001 173.8034272C317.653644 170.2831812 320 165.58952 320 160.113582C320 154.637644 317.849172 149.7484134 314.329638 146.2281676L253.961108 85.6715072C250.441574 82.1512614 245.553332 80 240.0785 80C229.017022 80 220.077924 88.9472988 220.077924 99.7036056C220.077924 105.1795438 222.4146 110.5972976 225.934134 114.1175436L256.293692 139.9698042L196.6598964 139.9698042C188.3908292 116.6817314 166.1097828 100 139.9212536 100C113.7327244 100 91.451678 116.6817314 83.1826106 139.9698042z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FlowLinear.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FlowLinear.displayName = "Blueprint5.Icon.FlowLinear";
exports.default = FlowLinear;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lRhQT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlowReviewBranch", ()=>FlowReviewBranch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FlowReviewBranch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "flow-review-branch",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260.797012 131.525098C248.802586 124.313996 234.765448 120.168416 219.762708 120.168416C182.5737802 120.168416 151.317997 145.640912 142.4007968 180.1354648L66.8385368 180.1354648L114.2878034 133.934052C117.795365 130.416868 119.9388748 125.531892 119.9388748 120.060716C119.9388748 109.313766 110.9032724 100.098944 100.1857228 100.098944C94.7295156 100.098944 89.8634064 102.159658 86.3558448 105.872242L5.84593616 186.3442214C2.33837446 189.861405 1.1e-12 194.550983 1.1e-12 200.0221574C1.1e-12 205.4933318 2.14350992 210.378309 5.65107162 213.8954926L86.3558448 294.7122578C89.8634064 298.2294412 94.7295156 300.4675066 100.1857228 300.4675066C110.9032724 300.4675066 119.9388748 291.0627746 119.9388748 280.3158248C119.9388748 274.8446504 117.795365 269.9596734 114.2878034 266.4424898L66.6436724 220.3260758L142.3644456 220.3260758C151.2327734 254.892267 182.523073 280.4342744 219.762708 280.4342744C235.187474 280.4342744 249.591548 276.0521832 261.804346 268.4617966L333.094664 339.8614728L282.335368 339.9118194C277.370004 339.9167442 272.402728 341.8541062 268.536952 345.7228108C260.94346 353.3220518 260.9301500000001 366.76292282 268.508602 374.3471153C272.366724 378.208158764 277.330172 380.1356707952 282.433598 379.99257780614L380.3638380000001 379.8954442182C385.329202 379.8905192484 390.296204 378.229219706 394.1619800000001 374.3605152C398.027758 370.49181068 399.5659940000001 365.52116614 399.570914 360.55204234L399.667976 262.547622C399.6728960000001 257.5784984 397.746842 252.61129 393.88872 248.7502464C386.3102700000001 241.166054 373.157372 241.1790998 365.5638820000001 248.7783408C361.6981040000001 252.6470454 359.7622100000001 257.6180844 359.757288 262.5872082L359.70698 313.3849532L288.618256 240.997573C295.644588 229.0698852 299.67642 215.1577492 299.67642 200.3013452C299.67642 185.030641 295.41658 170.757606 288.023464 158.611888L359.92979 86.72787L359.980098 137.525614C359.985018 142.494738 361.9209140000001 147.465778 365.78669 151.334482C373.38018 158.933724 386.772942 158.947006 394.351394 151.362814C398.209514 147.50177 400.13557 142.534562 399.992584 137.42727L399.895524 39.42285C399.890602 34.453726 398.230854 29.7799700000001 394.3650780000001 25.911266C390.499302 22.042562 385.532026 20.1052 380.566662 20.100276L279.478592 20.00001C274.5132280000001 19.995086 269.54978 21.922598 265.691658 25.78364C258.113208 33.367834 258.126314 46.601292 265.719802 54.200532C269.585578 58.069236 274.552854 60.006598 279.518218 60.011522L333.4353440000001 60.0650020000001L260.797012 131.525098z" : "M207.838848 107.0543138C199.4745472 102.6361524 189.9392114 100.1343842 179.8188874 100.1343842C153.6874726 100.1343842 131.456233 116.8139276 123.2139092 140.0958078L67.410214 140.0966668L94.174242 113.7490006C97.6251746 110.1795432 99.9162722 105.5363486 99.8209924 100.0791986C99.6338356 89.359794 89.345798 80.183236 80.0375544 80.18338C70.7293106 80.183522 67.4110798 83.91805 65.0819224 86.054052L5.6183411 146.3665006C2.16740852 149.9359584 -0.092379026 154.6543754 0.00290078472 160.1115262C0.0981805928 165.5686768 2.32958646 170.4036782 5.90302168 173.850557L66.0827968 234.4102578C69.656232 237.8571368 74.5716964 239.915893 80.0350936 239.820554C90.7667668 239.633281 100.00631 230.1191058 99.8191532 219.3997028C99.7238734 213.9425522 97.4924676 209.107551 93.9190322 205.660672L67.409598 180.0547356L123.2037772 180.0538768C131.4380022 203.350719 153.6767576 220.0439438 179.8188874 220.0439438C188.9340872 220.0439438 197.5747276 218.0144362 205.312608 214.3831314L253.633306 259.9165510000001L219.008086 259.848267C214.045492 260.019327 209.151274 262.4208344 205.427966 266.4125496C198.1143272 274.2534188 198.5530402 286.65628206 206.402884 293.97446812C210.399168 297.70008994 215.596224 300.287910822 220.691794 299.9742896574L300.93453 299.8771036538C305.897124 299.706043554 310.801224 297.8812686 314.524532 293.8895533C318.247838 289.897838 320.002252 284.8701694 319.826766 279.9090242L319.791134 199.0019896C319.615648 194.0408444 317.510264 189.1462224 313.51398 185.4206002C305.664136 178.1024146 292.406936 178.5296898 285.093298 186.3705592C281.36999 190.3622744 279.615576 195.3899432 279.791062 200.3510884L279.80597 234.202238L232.973788 187.964708C237.360058 179.6369824 239.842294 170.1526204 239.842294 160.0891638C239.842294 151.0606106 237.844342 142.4981708 234.265972 134.8189022L279.97017 86.42151L279.901868 121.0376834C280.072974 125.9989818 282.36483 130.8919696 286.357588 134.6143044C294.200506 141.9260332 306.60661 141.4874346 313.926708 133.6396412C317.653304 129.6444008 320.241802 124.4487026 319.928098 119.3544636L319.830886 39.132692C319.659782 34.171392 317.834632 29.035146 313.841874 25.31281C309.849116 21.590476 304.820134 19.836522 299.857692 20.01196L218.929516 20.047584C213.967074 20.223024 209.07107 22.561288 205.344474 26.556528C198.0243762 34.404322 198.451857 47.445122 206.294774 54.756852C210.287534 58.479188 215.316516 60.23314 220.278958 60.0577L254.138952 60.042796L207.838848 107.0543138z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FlowReviewBranch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FlowReviewBranch.displayName = "Blueprint5.Icon.FlowReviewBranch";
exports.default = FlowReviewBranch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"loYvu":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlowReview", ()=>FlowReview);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FlowReview = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "flow-review",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M122.6160306 219.9104624C131.4460818 254.4668618 162.8468374 280.02123468 200.229338 280.02123468C237.61184 280.02123468 269.012596 254.4668618 277.842646 219.9104624L333.207866 219.9104624L286.119952 266.2528354C282.604576 269.7604522000001 280.456292 274.6321424 280.456292 280.08843528C280.456292 290.80615356 289.702652 299.9784096724 300.444078 299.9784096724C305.91244 299.9784096724 310.794906 297.83486602 314.3102820000001 294.32724912L394.33634 213.4973702C397.851714 209.9897532 400 205.1180632 400 199.6617704C400 194.2054774 397.6564160000001 189.528655 394.1410400000001 186.0210378L314.3102820000001 106.0803334C310.794906 102.3778488 305.91244 100.2343052 300.444078 100.2343052C289.702652 100.2343052 280.456292 109.4578066 280.456292 120.1755248C280.456292 125.631818 282.604576 130.503508 286.119952 134.0111248L333.012568 179.8291684L277.720254 179.8291684C268.7256520000001 145.5127844 237.441112 120.1912958 200.229338 120.1912958C163.0175658 120.1912958 131.7330254 145.5127844 122.7384236 179.8291684L66.9874326 179.8291684L114.5008202 133.6656066C118.0161956 130.1579898 120.1644806 125.2862996 120.1644806 119.8300068C120.1644806 109.1122884 111.0268832 100.1784096 100.2854582 100.1784096C94.8170964 100.1784096 89.534503 102.3001336 86.0191274 106.002618L5.85895912 186.0210378C2.34358366 189.528655 9e-13 194.2054774 9e-13 199.6617704C9e-13 205.1180632 2.14828502 209.9897532 5.66366048 213.4973702L86.2479996 294.23145898C89.763375 297.73907588 94.8170964 299.9044396036 100.2854582 299.9044396036C111.0268832 299.9044396036 120.1644806 290.62896928 120.1644806 279.911251C120.1644806 274.4549580000001 118.0161956 269.583268 114.5008202 266.075651L66.792134 219.9104624L122.6160306 219.9104624z" : "M103.5004848 179.917692C111.7617436 203.2441608 133.981543 219.949325 160.0955048 219.949325C186.2094666 219.949325 208.429266 203.2441608 216.690524 179.917692L256.403918 179.917692C238.482088 195.0344554 228.379746 203.770231 226.09689 206.1250186C222.672606 209.6572002 220.250812 214.7518006 220.250812 220.2277387C220.250812 230.98404562 229.319062 240 240.054588 240C245.519948 240 250.467206 237.83761662 253.98065 234.1218015C256.322946 231.64459142 276.377482 211.5384666 314.144258 173.8034272C317.657704 170.2831812 320 165.58952 320 160.113582C320 154.637644 317.852894 149.7484134 314.33945 146.2281676L254.07537 85.6715072C250.561926 82.1512614 245.682142 80 240.216782 80C229.174444 80 220.250812 88.9472988 220.250812 99.7036056C220.250812 105.1795438 222.583444 110.5972976 226.09689 114.1175436L256.403918 139.9698042L216.7934 139.9698042C208.614978 116.4904038 186.318636 99.6452756 160.0955048 99.6452756C133.8723736 99.6452756 111.5760318 116.4904038 103.3976088 139.9698042L63.5960824 139.9698042L93.9031102 114.1175436C97.4165552 110.5972976 99.749188 105.1795438 99.749188 99.7036056C99.749188 88.9472988 90.8255566 80 79.7832178 80C74.317859 80 69.4380742 82.1512614 65.9246292 85.6715072L5.66055024 146.2281676C2.14710526 149.7484134 0 154.637644 0 160.113582C0 165.58952 2.34229666 170.2831812 5.85574162 173.8034272C43.622517 211.5384666 63.677053 231.64459142 66.0193498 234.1218015C69.5327948 237.83761662 74.4800528 240 79.9454116 240C90.680938 240 99.749188 230.98404562 99.749188 220.2277387C99.749188 214.7518006 97.3273942 209.6572002 93.9031102 206.1250186C91.6202542 203.770231 81.5179116 195.0344554 63.5960824 179.917692L103.5004848 179.917692z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FlowReview.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FlowReview.displayName = "Blueprint5.Icon.FlowReview";
exports.default = FlowReview;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2AxUR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Flows", ()=>Flows);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Flows = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "flows",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M350 241.4C325.8 241.4 305.6 224.2 301 201.4H255L174.8 281.4L159.8 266.4L225 201.4H99C94.4 224.2 74.2 241.4 50 241.4C22.4 241.4 0 219 0 191.4S22.4 141.4 50 141.4C74.2 141.4 94.4 158.6 99 181.4H225L159.8 116.4L174.8 101.4L255 181.4H301C305.6 158.6 325.8 141.4 350 141.4C377.6 141.4 400 163.8 400 191.4S377.6 241.4 350 241.4z" : "M270 200C245.8 200 225.6 182.8 221 160H195L114.8 240L99.8 225L165 160H99C94.4 182.8 74.2 200 50 200C22.4 200 0 177.6 0 150C0 122.4 22.4 100 50 100C74.2 100 94.4 117.2 99 140H165L99.8 75L114.8 60L195 140H221C225.6 117.2 245.8 100 270 100C297.6 100 320 122.4 320 150C320 177.6 297.6 200 270 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Flows.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Flows.displayName = "Blueprint5.Icon.Flows";
exports.default = Flows;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hKHPb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FolderClose", ()=>FolderClose);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FolderClose = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "folder-close",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 60C0 49 9 40 20 40H380C391 40 400 49 400 60V260H0V60zM380 320H188.2L154.2 354.2V354.2C150.6 357.8 145.6 360 140 360H20C9 360 0 351 0 340V280H400V300C400 311 391 320 380 320z" : "M-0.2 40C-0.2 29 8.8 20 19.8 20H299.8C310.8 20 319.8 29 319.8 40V180H-0.2C-0.2 180 -0.2 40 -0.2 40zM299.8 240H148.2L114 274C110.4 277.8 105.4 280 99.8 280H19.8C8.8 280 -0.2 271 -0.2 260V200H319.8V220C319.8 231 310.8 240 299.8 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FolderClose.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FolderClose.displayName = "Blueprint5.Icon.FolderClose";
exports.default = FolderClose;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4YfMg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FolderNew", ()=>FolderNew);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FolderNew = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "folder-new",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M259.870064 260C259.870064 226.90861 286.765228 200 319.84008 200C352.914932 200 379.810094 226.90861 379.810094 260L400 260L400 60C400 49 391.004498 40 380.009996 40L20.189905 40C9.1954023 40 0.19990005 49 0.19990005 60L0.19990005 260L259.870064 260zM215.20245 280L0 280L0 340C0 351 8.99550224 360 19.990005 360L99.950025 360C105.5472264 360 110.5447276 357.8 114.1429286 354.2L148.325837 320L199.90005 320C199.90005 304.6452944 205.690696 290.6217688000001 215.20245 280zM379.810094 340C390.804598 340 399.8001 331 399.8001 320C399.8001 309 390.804598 300 379.810094 300L339.8300840000001 300L339.8300840000001 260C339.8300840000001 249 330.834582 240 319.84008 240C308.845578 240 299.850074 249 299.850074 260L299.850074 300L259.870064 300C248.875562 300 239.88006 309 239.88006 320C239.88006 331 248.875562 340 259.870064 340L299.850074 340L299.850074 380C299.850074 391 308.845578 400 319.84008 400C330.834582 400 339.8300840000001 391 339.8300840000001 380L339.8300840000001 340L379.810094 340z" : "M203.29828 180C211.545356 156.715923 233.772272 140 259.837602 140C285.90293 140 308.129846 156.715923 316.376922 180L320 180L320 40C320 29 311.005622 20 300.012492 20L20.1873828 20C9.1942536 20 0.199875078 29 0.199875078 40L0.199875078 180L203.29828 180zM175.2005516 200L0 200L0 260C0 271 8.99437852 280 19.9875078 280L59.9625234 280C65.5590256 280 70.5559026 277.8 74.153654 274.2L108.3322924 240L159.9000624 240C159.9000624 224.6452944 165.6899868 210.6217688 175.2005516 200zM299.812618 260C310.805746 260 319.800124 251 319.800124 240C319.800124 229 310.805746 220 299.812618 220L279.82511 220L279.82511 200C279.82511 189 270.83073 180 259.837602 180C248.844472 180 239.850094 189 239.850094 200L239.850094 220L219.862586 220C208.869456 220 199.875078 229 199.875078 240C199.875078 251 208.869456 260 219.862586 260L239.850094 260L239.850094 280C239.850094 291 248.844472 300 259.837602 300C270.83073 300 279.82511 291 279.82511 280L279.82511 260L299.812618 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FolderNew.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FolderNew.displayName = "Blueprint5.Icon.FolderNew";
exports.default = FolderNew;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fgTru":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FolderOpen", ()=>FolderOpen);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FolderOpen = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "folder-open",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 220C400 231 391 240 380 240H100C91.4 240 84.2 234.6 81.4 227L81.2 227L21.2 67L21.4 67C20.6 64.8 20 62.4 20 60C20 49 29 40 40 40H320C328.6 40 335.8 45.4 338.6 53L338.8 53L398.8 213L398.6 213C399.4 215.2 400 217.6 400 220zM61.4 247.4C64.4 254.8 71.6 260 80 260H360V300C360 311 351 320 340 320H168.2L134.2 354.2C130.6 357.8 125.6 360 120 360H20C9 360 0 351 0 340V93.8L61.4 247.4L61.4 247.4z" : "M41.2 186.2C44 194.2 51.2 200 60 200H280V220C280 231 271 240 260 240H128.2L94.2 274.2C90.6 277.8 85.6 280 80 280H20C9 280 0 271 0 260V63.2L41 186.2L41.2 186.2zM320 160C320 171 311 180 300 180H80C71.2 180 63.8 174.2 61.2 166.2L61.2 166.2L21.2 46.2L21.2 46.2C20.4 44.4 20 42.2 20 40C20 29 29 20 40 20H260C268.8 20 276.2 25.8 278.8 33.8L278.8 33.8L318.8 153.8L318.8 153.8C319.6 155.6 320 157.8 320 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FolderOpen.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FolderOpen.displayName = "Blueprint5.Icon.FolderOpen";
exports.default = FolderOpen;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2EzSQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FolderSharedOpen", ()=>FolderSharedOpen);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FolderSharedOpen = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "folder-shared-open",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M61.4 247.4C64.4 254.8 71.6 260 80 260H235.2L246 270.8C230.2 281.6 220 299.6 220 320H168.2L134.2 354.2C130.6 357.8 125.6 360 120 360H20C9 360 0 351 0 340V93.8L61.4 247.4L61.4 247.4zM330.8 186L302.4 157.6C291.6 146.8 276.6 140 260 140C226.8 140 200 166.8 200 200C200 215.4 206 229.4 215.6 240H100C91.4 240 84.2 234.6 81.4 227L81.2 227L21.2 67L21.4 67C20.6 64.8 20 62.4 20 60C20 49 29 40 40 40H320C328.6 40 335.8 45.4 338.6 53L338.8 53L379.0000000000001 160.2C359 160.4 341.4 170.6 330.8 186zM380 340H280C269 340 260 331 260 320S269 300 280 300H331.8L246 214.2C242.2 210.6 240 205.6 240 200C240 189 249 180 260 180C265.6 180 270.6 182.2 274.2000000000001 185.8L360 271.8V220C360 209 369 200 380 200S400 209 400 220V320C400 331 391 340 380 340z" : "M260.4 115.6L242.4 97.6L242.2 97.8C231.4 86.8 216.6 80 200 80C166.8 80 140 106.8 140 140C140 155.4 146 169.4 155.6 180H80C71.2 180 63.8 174.2 61.2 166.2L61.2 166.2L21.2 46.2L21.2 46.2C20.4 44.4 20 42.2 20 40C20 29 29 20 40 20H260C268.8 20 276.2 25.8 278.8 33.8L278.8 33.8L301 100.2C300.8 100.2 300.4 100 300 100C284.6 100 271 106 260.4 115.6zM41.2 186.2C44 194.2 51.2 200 60 200H175.2L175.4 200.2C166 210.8 160 224.6 160 240H128.2L94.2 274.2C90.6 277.8 85.6 280 80 280H20C9 280 0 271 0 260V63.2L41 186.2L41.2 186.2zM300 260H220C209 260 200 251 200 240S209 220 220 220H251.8L185.8 154.2C182.2 150.6 180 145.6 180 140C180 129 189 120 200 120C205.6 120 210.6 122.2 214.2 125.8L280 191.8V160C280 149 289 140 300 140S320 149 320 160V240C320 251 311 260 300 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FolderSharedOpen.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FolderSharedOpen.displayName = "Blueprint5.Icon.FolderSharedOpen";
exports.default = FolderSharedOpen;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kc26Y":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FolderShared", ()=>FolderShared);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FolderShared = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "folder-shared",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 320H188.2L154.2 354.2C150.6 357.8 145.6 360 140 360H20C9 360 0 351 0 340V280H235.6C226 290.6 220 304.6 220 320zM380 340H280C269 340 260 331 260 320C260 309 269 300 280 300H331.8L246 214.2C242.2 210.6 240 205.6 240 200C240 189 249 180 260 180C265.6 180 270.6 182.2 274.2000000000001 185.8L360 271.8V220C360 209 369 200 380 200S400 209 400 220V320C400 331 391 340 380 340zM330.8 186L302.4 157.6C291.6 146.8 276.6 140 260 140C226.8 140 200 166.8 200 200C200 216.6 206.8 231.6 217.6 242.4L235.2 260H0V60C0 49 9 40 20 40H380C391 40 400 49 400 60V163.6C393.8 161.4 387 160 380 160C359.6 160 341.6 170.4 330.8 186z" : "M175.2 200.4C165.8 211 159.8 224.8 159.8 240.2H148.2L114 274.2C110.4 278 105.4 280.2 99.8 280.2H19.8C8.8 280.2 -0.2 271.2 -0.2 260.2V200.2H175L175.2 200.4zM299.8 260.2H219.8C208.8 260.2 199.8 251.2 199.8 240.2S208.8 220.2 219.8 220.2H251.6L185.6 154.2C182 150.6 179.8 145.6 179.8 140.2C179.8 129.2 188.8 120.2 199.8 120.2C205.4 120.2 210.4 122.4 214 126L279.8 191.8V160C279.8 149 288.8 140 299.8 140S319.8 149 319.8 160V240C319.8 251.2 310.8 260.2 299.8 260.2zM260.2 115.6L242.2 97.6L242 97.8C231.2 86.8 216.4 80 199.8 80C166.6 80 139.8 106.8 139.8 140C139.8 155.4 145.8 169.4 155.4 180H-0.2V40C-0.2 29 8.8 20 19.8 20H299.8C310.8 20 319.8 29 319.8 40V103.6C313.6 101.4 306.8 100 299.8 100C284.6 100.2 270.8 106.2 260.2 115.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FolderShared.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FolderShared.displayName = "Blueprint5.Icon.FolderShared";
exports.default = FolderShared;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9xURw":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Follower", ()=>Follower);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Follower = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "follower",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M230.8 81.6C201.2 94.6 205.2 102.6 204.2 113.4C204 114.8 204 116.4 204 118C214.2 127 222.4 139.4 227.8 153.6C227.8 153.6 228 154.4 228.2 154.6C229.4 157.6 230.4 161 231.2 164.2C238 165.6 242 173 243.4 179.8C245 182.6 248 189.4 247.4 197.2C246.3999999999999 207.2 242.4 211.8 238 213.6C238 214.2 238 214.8 238 215.4C238 228 236.8 246.4 234.6 258.4C234.2 261.8 233.3999999999999 265 232.4 268.4C228 283 218.8 296.4 206.6 305.6C193.8 315 176 320 160.2 320C144.2 320 126.4 315 113.8 305.4C101.6 296 92.6 282.8 88.2 268.2C87.2 264.8 86.4 261.6 86 258.2C83.6 246.2 82.4 228 82.4 215.4C82.4 214.8 82.4 214.4 82.4 213.8C77.8 212 73.6 207.4 72.6 197.2C71.8 189.4 75 182.6 76.6 179.8C78.2 172.8 82.2 165.4 89.2 164.2C90 160.8 91 157.6 92.2 154.6C92.2 154.4 92.4 154.2 92.4 154L92.6 153.8C98 139.4 106.6 126.8 117 117.8C117 116.4 116.8 115 116.8 113.6C115.8 102.8 118.8 94.8 89.2 81.8C59.6 68.8 15 54.8 6 33.8C-3.2 12.4 0.4 0 0.4 0H319.4C319.4 0 323 12.4 314 33.4C304.8 54.6 260.4 68.4 230.8 81.6zM393.8 334.2L333.8 394.2C330.4 397.8 325.4 400 319.8 400C308.8 400 299.8 391 299.8 380C299.8 374.4 302 369.4 305.6 365.8L331.6 340H260C249 340 240 331 240 320C240 309 249 300 260 300H331.6L305.8 274.2C302 270.6 299.8 265.6 299.8 260C299.8 249 308.8 240 319.8 240C325.4 240 330.4 242.2 334 245.8L394 305.8C397.6 309.4 399.8 314.4 399.8 320C399.8 325.6 397.6 330.6 393.8 334.2z" : "M187.4 66.2C163.4 76.8 166.6 83.2 165.8 92C165.6 93.2000000000001 165.6 94.4 165.6 95.8C173.8 103.2 180.6 113.2 185 124.6C185 124.6 185.2 125.2 185.2 125.4C186.2 128 187 130.6 187.6 133.2C193.2 134.4 196.4 140.4 197.6 145.8C198.8 148 201.4 153.6 200.8 159.8C200 167.8 196.8 171.6 193.2 173.2C193.2 173.6 193.2 174.2 193.2 174.6C193.2 185 192.2 199.8 190.4 209.4C190 212.6 189.4 215.2 188.6 218C185 230 177.6 240.6 167.8 248.2C157.4 256 143 260 130 260C117.2 260 102.8 256 92.6 248.2C82.6 240.6 75.2 229.8 71.6 218C70.8 215.4 70.2 212.6 69.8 210C68 200.2 67 185.2 67 175C67 174.6 67 174.2 67 173.8C63.2 172.4 59.8 168.6 59 160.2C58.4 154 61 148.4 62.2 146.2C63.4 140.6 66.8 134.4 72.4 133.4C73.2 130.6 74 128 75 125.6C75 125.4 75.2 125.2 75.2 125.2L75.2 125C79.6 113.2 86.6 103 95 95.8C95 94.6 94.8 93.4 94.8 92.4C94 83.6 96.4 77.2 72.4 66.6C48.4 56 12.2 44.6 4.8 27.6C-2.6 10 0.4 0 0.4 0H259.6C259.6 0 262.6 10 255.2 27.2C247.6 44.2 211.4 55.6 187.4 66.2zM314 274.2L274 314.2C270.4 317.8 265.4 320 259.8 320C248.8 320 239.8 311 239.8 300C239.8 294.4 242 289.4 245.6 285.8L251.6 280H199.8C188.8 280 179.8 271 179.8 260C179.8 249 188.8 240 199.8 240H251.4L245.6 234.2C242 230.6 239.8 225.6 239.8 220C239.8 209 248.8 200 259.8 200C265.4 200 270.4 202.2 274 205.8L314 245.8C317.6 249.4 319.8 254.4 319.8 260C319.8 265.6 317.6 270.6 314 274.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Follower.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Follower.displayName = "Blueprint5.Icon.Follower";
exports.default = Follower;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"81RzT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Following", ()=>Following);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Following = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "following",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M231 81.6C201.4 94.6 205.4 102.6 204.4 113.4C204.2 114.8 204.2 116.4 204.2 118C214.4 127 222.6 139.4 228 153.6C228 153.6 228.2 154.4 228.4 154.6C229.6 157.6 230.6 161 231.4 164.2C238.2 165.6 242.2 173 243.6 179.8C245.2 182.6 248.2 189.4 247.6 197.2C246.6 207.2 242.6 211.8 238.2 213.6C238.2 214.2 238.2 214.8 238.2 215.4C238.2 228 237 246.4 234.8 258.4C234.4 261.8 233.6 265 232.6 268.4C228.2 283 219 296.4 206.8 305.6C194 315 176.2 320 160.4 320C144.6 320 126.8 315 114.2 305.4C102 296 92.8 282.8 88.4 268.2C87.4 265 86.6 261.6 86.2 258.2C83.8 246.2 82.6 228 82.6 215.4C82.6 214.8 82.6 214.4 82.6 213.8C78 212 73.8 207.4 73 197.2C72.2 189.4 75.4 182.6 77 179.8C78.6 172.8 82.6 165.4 89.6 164.2C90.4 160.8 91.4 157.6 92.6 154.6C92.6 154.4 92.8 154.2 92.8 154L93 153.8C98.4 139.4 107 126.8 117.4 117.8C117.4 116.4 117.2 115 117.2 113.6C116.2 102.8 119.2 94.8 89.6 81.8C60 68.8 15.4 54.8 6.4 33.8C-3 12.4 0.8 0 0.8 0H319.8C319.8 0 323.4 12.4 314.4 33.4C305.2 54.6 260.6 68.4 231 81.6zM380 340H308.4L334.2000000000001 365.8C337.8 369.4 340 374.4 340 380C340 391 331 400 320 400C314.4000000000001 400 309.4000000000001 397.8 305.8 394.2L245.8 334.2C242.4 330.6 240.2 325.6 240.2 320C240.2 314.4 242.4 309.4 246 305.8L306 245.8C309.6 242.2 314.6 240 320 240C331 240 340 249 340 260C340 265.6 337.8 270.6 334.2000000000001 274.2L308.4 300H380C391 300 400 309 400 320C400 331 391 340 380 340z" : "M187.4 66.2C163.4 76.8 166.6 83.2 165.8 92C165.6 93.2000000000001 165.6 94.4 165.6 95.8C173.8 103.2 180.6 113.2 185 124.6C185 124.6 185.2 125.2 185.2 125.4C186.2 128 187 130.6 187.6 133.2C193.2 134.4 196.4 140.4 197.6 145.8C198.8 148 201.4 153.6 200.8 159.8C200 167.8 196.8 171.6 193.2 173.2C193.2 173.6 193.2 174.2 193.2 174.6C193.2 185 192.2 199.8 190.4 209.4C190 212.6 189.4 215.2 188.6 218C185 230 177.6 240.6 167.8 248.2C157.4 256 143 260 130 260C117.2 260 102.8 256 92.6 248.2C82.6 240.6 75.2 229.8 71.6 218C70.8 215.4 70.2 212.6 69.8 210C68 200.2 67 185.2 67 175C67 174.6 67 174.2 67 173.8C63.2 172.4 59.8 168.6 59 160.2C58.4 154 61 148.4 62.2 146.2C63.4 140.6 66.8 134.4 72.4 133.4C73.2 130.6 74 128 75 125.6C75 125.4 75.2 125.2 75.2 125.2L75.2 125C79.6 113.2 86.6 103 95 95.8C95 94.6 94.8 93.4 94.8 92.4C94 83.6 96.4 77.2 72.4 66.6C48.4 56 12.2 44.6 4.8 27.6C-2.6 10 0.4 0 0.4 0H259.6C259.6 0 262.6 10 255.2 27.2C247.6 44.2 211.4 55.6 187.4 66.2zM299.8 280H248.2L254 285.8C257.6 289.4 259.8 294.4 259.8 300C259.8 311 250.8 320 239.8 320C234.2 320 229.2 317.8 225.6 314.2L185.6 274.2C182.2 270.6 179.8 265.6 179.8 260C179.8 254.4 182 249.4 185.6 245.8L225.6 205.8C229.4 202.2 234.4 200 239.8 200C250.8 200 259.8 209 259.8 220C259.8 225.6 257.6 230.6 254.0000000000001 234.2L248.2 240H299.8C310.8 240 319.8 249 319.8 260C319.8 271 310.8 280 299.8 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Following.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Following.displayName = "Blueprint5.Icon.Following";
exports.default = Following;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k3B9B":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Font", ()=>Font);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Font = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "font",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M218.666 347.1796C215.696 354.9034 208.276 360 200 360C191.7244 360 184.3038 354.9034 181.333 347.1796L81.4964 87.604C80.532 85.26 80 82.692 80 80C80 68.954 88.9544 60 100 60C108.6804 60 116.0692 65.53 118.8356 73.26L144.5052 140H255.494L281.166 73.254C283.934 65.528 291.322 60 300 60C311.046 60 320 68.954 320 80C320 82.694 319.468 85.264 318.502 87.61L218.666 347.1796zM240.11 180L200 284.2864L159.8898 180H240.11z" : "M160 280C168.178 280 175.5322 275.021 178.5696 267.4278L258.4 67.85C259.43 65.44 260 62.786 260 60C260 48.954 251.046 40 240 40C231.414 40 224.094 45.41 221.258 53.006L202.46 100H117.5406L98.7426 53.004C95.9064 45.408 88.5848 40 80 40C68.9544 40 60 48.954 60 60C60 62.786 60.5698 65.44 61.599 67.85L141.4304 267.4278C144.4678 275.021 151.822 280 160 280zM133.5406 140H186.4594L160 206.1484L133.5406 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Font.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Font.displayName = "Blueprint5.Icon.Font";
exports.default = Font;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5X4lV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fork", ()=>Fork);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Fork = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "fork",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M334.2000000000001 174.2C330.6 177.8 325.6 180 320 180C309 180 300 171 300 160C300 154.4 302.2 149.4 305.8 145.8L331.8 120H288.4L128.4 280H331.8L306 254.2C302.2 250.6 300 245.6 300 240C300 229 309 220 320 220C325.6 220 330.6 222.2 334.2000000000001 225.8L394.2000000000001 285.8C397.8 289.4 400 294.4 400 300C400 305.6 397.8 310.6 394.2000000000001 314.2L334.2000000000001 374.2C330.6 377.8 325.6 380 320 380C309 380 300 371 300 360C300 354.4 302.2 349.4 305.8 345.8L331.8 320H20C9 320 0 311 0 300C0 289 9 280 20 280H71.8L266 85.8C269.4000000000001 82.2 274.4000000000001 80 280 80H331.8L306 54.2C302.2 50.6 300 45.6 300 40C300 29 309 20 320 20C325.6 20 330.6 22.2 334.2000000000001 25.8L394.2000000000001 85.8C397.8 89.4 400 94.4 400 100C400 105.6 397.8 110.6 394.2000000000001 114.2000000000001L334.2000000000001 174.2z" : "M274 134.2C270.4 137.8 265.4 140 259.8 140C248.8 140 239.8 131 239.8 120C239.8 114.4 242 109.4 245.6 105.8L251.4 100H228L128 200H251.4L245.6 194.2C242 190.6 239.8 185.6 239.8 180C239.8 169 248.8 160 259.8 160C265.4 160 270.4 162.2 274 165.8L314 205.8C317.6 209.4 319.8 214.4 319.8 220S317.6 230.6 314 234.2L274 274.2C270.4 277.8 265.4 280 259.8 280C248.8 280 239.8 271 239.8 260C239.8 254.4 242 249.4 245.6 245.8L251.4 240H19.8C8.8 240 -0.2 231 -0.2 220S8.8 200 19.8 200H71.6L205.8 65.8C209.4 62.2 214.4 60 220 60H251.8L246 54.2C242.4000000000001 50.6 240.2000000000001 45.6 240.2000000000001 40C240.2000000000001 29 249.2 20 260.2000000000001 20C265.8 20 270.8 22.2 274.4000000000001 25.8L314.4000000000001 65.8C318.0000000000001 69.4 320.2000000000001 74.4 320.2000000000001 80S318.0000000000001 90.6 314.4000000000001 94.2L274 134.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Fork.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Fork.displayName = "Blueprint5.Icon.Fork";
exports.default = Fork;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fYKU9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", ()=>Form);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Form = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "form",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 140V60H120V140H40zM20 180H140C151 180 160 171 160 160V40C160 29 151 20 140 20H20C9 20 0 29 0 40V160C0 171 9 180 20 180zM240 320H380L380 320C391 320 400 311 400 300L400 300C400 289 391 280 380 280H240C229 280 220 289 220 300S229 320 240 320zM160 380C171 380 180 371 180 360C180 354.4 177.8 349.4 174.2 345.8L74.2 225.8C70.6 222.2 65.6 220 60 220S49.4 222.2 45.8 225.8L5.8 265.8C2.2 269.4 0 274.4 0 280C0 291 9 300 20 300C25.6 300 30.6 297.8 34.2 294.2L60 268.2L145.8 374.2C149.4 377.8 154.4 380 160 380zM240 120H380L380 120C391 120 400 111 400 100L400 100C400 89 391 80 380 80H240C229 80 220 89 220 100S229 120 240 120z" : "M40 100V60H80V100H40zM20 140H100C111 140 120 131 120 120V40C120 29 111 20 100 20H20C9 20 0 29 0 40V120C0 131 9 140 20 140zM200 260H300L300 260C311 260 320 251 320 240L320 240C320 229 311 220 300 220H200C189 220 180 229 180 240S189 260 200 260zM120 300C131 300 140 291 140 280C140 274.4 137.8 269.4 134.2 265.8L74.2 185.8C70.6 182.2 65.6 180 60 180S49.4 182.2 45.8 185.8L5.8 225.8C2.2 229.4 0 234.4 0 240C0 251 9 260 20 260C25.6 260 30.6 257.8 34.2 254.2L60 228.2L105.8 294.2C109.4 297.8 114.4 300 120 300zM200 100H300C311 100 320 91 320 80L320 80C320 69 311 60 300 60H200C189 60 180 69 180 80S189 100 200 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Form.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Form.displayName = "Blueprint5.Icon.Form";
exports.default = Form;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ItpEY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ForwardTen", ()=>ForwardTen);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ForwardTen = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "forward-ten",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M195.0718 0C170.7562 0 147.9806 4.62 126.7452 13.86C105.5096 23.1 87.0298 35.582 71.3058 51.306C55.5818 67.03 43.0998 85.51 33.8598 106.746C24.62 127.98 20 150.756 20 175.072C20 199.388 24.62 222.1628 33.8598 243.3984C43.0998 264.634 55.5818 283.1136 71.3058 298.8378C87.0298 314.5618 105.5096 327.0438 126.7452 336.2836C147.9806 345.5236 170.7562 350.1434 195.0718 350.1434H197.9896L181.455 366.678C177.5646 370.5684 175.7004 375.1074 175.8624 380.2947C176.0246 385.48202 177.8888 390.02092 181.455 393.9114C185.3456 397.80188 189.9654 399.8281704 195.3148 399.9902738C200.664 400.1523772 205.284 398.288188 209.174 394.3977L259.264 344.3078C263.156 340.4172 265.1 335.8784 265.1 330.6910000000001C265.1 325.5038 263.156 320.9648 259.264 317.0744L209.174 266.9844C205.284 263.094 200.664 261.2298 195.3148 261.3918C189.9654 261.554 185.3456 263.5802 181.455 267.4708C177.8888 271.3612 176.0246 275.9 175.8624 281.0874C175.7004 286.2746 177.5646 290.8136 181.455 294.704L197.9896 311.2386H195.0718C157.1396 311.2386 124.962 298.0272 98.5392 271.6044C72.1162 245.1814 58.9048 213.004 58.9048 175.072C58.9048 137.14 72.1162 104.962 98.5392 78.54C124.962 52.116 157.1396 38.904 195.0718 38.904C233.004 38.904 265.182 52.116 291.604 78.54C318.028 104.962 331.2380000000001 137.14 331.2380000000001 175.072C331.2380000000001 180.584 333.1020000000001 185.204 336.832 188.932C340.56 192.66 345.18 194.524 350.6900000000001 194.524C356.202 194.524 360.822 192.66 364.55 188.932C368.2800000000001 185.204 370.144 180.584 370.144 175.072C370.144 150.756 365.524 127.98 356.284 106.746C347.044 85.51 334.562 67.03 318.838 51.306C303.114 35.582 284.634 23.1 263.398 13.86C242.162 4.62 219.388 0 195.0718 0zM230 210V150H250V210H230zM220 240C208.954 240 200 231.0456 200 220V140C200 128.954 208.954 120 220 120H260C271.046 120 280 128.954 280 140V220C280 231.0456 271.046 240 260 240H220zM180 220C180 231.0456 171.0456 240 160 240H135C126.7158 240 120 233.2842 120 225C120 216.7158 126.7158 210 135 210H150V135C150 126.716 156.7158 120 165 120C173.2842 120 180 126.716 180 135V220z" : "M160.0432 0C140.6104 0 122.3942 3.704 105.3944 11.114C88.3946 18.524 73.588 28.586 60.9744 41.3C48.3608 54.014 38.3784 68.924 31.0268 86.03C23.6756 103.136 20 121.4838 20 141.0708C20 160.658 23.6756 178.9842 31.0268 196.0494C38.3784 213.1144 48.3954 228.004 61.0784 240.7182C73.7614 253.4322 88.5932 263.4940000000001 105.5736 270.9038C122.5536 278.3136 140.7652 282.0184 160.2082 282.0184H162.42L153.0122 291.5012C149.7852 294.7538 148.1638 298.6418 148.1478 303.1653C148.1318 307.68872 149.6838 311.57666 152.804 314.82908C156.0308 318.221722 159.9494 319.9449242 164.56 319.998677194C169.1706 320.052678 173.0894 318.45333 176.3164 315.2006600000001L214.91 276.2996C218.832 272.296 220.792 267.6252 220.792 262.2872C220.792 256.949 218.832 252.3036 214.91 248.351L176.3164 209.45C173.0894 206.1972 169.1706 204.5978 164.56 204.6516C159.9494 204.7056 156.0308 206.3588 152.804 209.6112C149.6838 212.864 148.0972 216.717 148.0438 221.1702C147.9902 225.6238 149.577 229.4768 152.804 232.7292L162.6284 242.6322H160.2082C132.1496 242.6322 108.2796 232.7822 88.598 213.0824C68.9164 193.3828 59.0756 169.3926 59.0756 141.1122C59.0756 112.832 68.8676 88.808 88.4518 69.038C108.0358 49.27 131.8852 39.386 160 39.386C188.1148 39.386 211.964 49.236 231.548 68.936C251.132 88.634 260.9240000000001 112.624 260.9240000000001 140.9044C260.9240000000001 146.3756 262.824 151.0254 266.622 154.854C270.42 158.683 275.034 160.5974 280.462 160.5974C285.89 160.5974 290.504 158.683 294.302 154.854C298.1 151.0254 300 146.3756 300 140.9044C300 121.486 296.324 103.21 288.9720000000001 86.074C281.622 68.94 271.64 54.014 259.026 41.3C246.412 28.586 231.62 18.524 214.648 11.114C197.6774 3.704 179.4756 0 160.0432 0zM200 160H180V100H200V160zM180 180C168.9544 180 160 171.0456 160 160V100C160 88.954 168.9544 80 180 80H200C211.046 80 220 88.954 220 100V160C220 171.0456 211.046 180 200 180H180zM110 180C104.4772 180 100 175.5228 100 170C100 164.4772 104.4772 160 110 160H120V90C120 84.478 124.4772 80 130 80C135.5228 80 140 84.478 140 90V160C140 171.0456 131.0456 180 120 180H110z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ForwardTen.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ForwardTen.displayName = "Blueprint5.Icon.ForwardTen";
exports.default = ForwardTen;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ZTtC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fuel", ()=>Fuel);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Fuel = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "fuel",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M43.9274 360H0V320H40C46.347 320 52.3772 317.2266 56.508 312.4074L126.3636 230.909L88.906 205.9374C83.342 202.228 80 195.984 80 189.296V40C80 30 90 20 100 20H380C390 20 400 30 400 40V258C400 258.6742 399.972 259.3412 399.918 260H400V340C400 340 400 360 380 360H220C210 360 200 350 200 340V280L162.3922 254.9282L89.2674 339.2974C77.871 352.4462 61.3276 360 43.9274 360zM360 320V280H240V320H360z" : "M38.9756 300H0V260H40C46.2144 260 51.984 256.776 55.241 251.4834L94.536 187.6288L67.506 166.0048C62.7618 162.2094 60 156.4632 60 150.3874V42C60 29.85 68.9544 20 80 20H300C311.046 20 320 29.85 320 42V280C320 280 320 300 300 300H180C170 300 160 290 160 280V240L127.7608 214.2086L89.1018 272.9752C78.0048 289.844 59.1672 300 38.9756 300zM280 260V240H200V260H280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Fuel.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Fuel.displayName = "Blueprint5.Icon.Fuel";
exports.default = Fuel;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4TbkO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FullCircle", ()=>FullCircle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FullCircle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "full-circle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M-0.8 200A200 200 0 0 1 399.2000000000001 200A200 200 0 0 1 -0.8 200" : "M0 160A160 160 0 0 1 320 160A160 160 0 0 1 0 160",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FullCircle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FullCircle.displayName = "Blueprint5.Icon.FullCircle";
exports.default = FullCircle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"66tk9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FullStackedChart", ()=>FullStackedChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var FullStackedChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "full-stacked-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 80H340C351 80 360 89 360 100V200H280V100C280 89 289 80 300 80zM240 360C240 371 231 380 220 380H180C169 380 160 371 160 360V280H240V360zM360 280H280V220H360V280zM360 360C360 371 351 380 340 380H300C289 380 280 371 280 360V300H360V360zM240 260H160V160H240V260zM60 80H100C111 80 120 89 120 100V160H40V100C40 89 49 80 60 80zM180 80H220C231 80 240 89 240 100V140H160V100C160 89 169 80 180 80zM380 60H20C9 60 0 51 0 40C0 29 9 20 20 20H380C391 20 400 29 400 40C400 51 391 60 380 60zM120 360C120 371 111 380 100 380H60C49 380 40 371 40 360V300H120V360zM120 280H40V180H120V280z" : "M260 80H280C291 80 300 89 300 100V160H240V100C240 89 249 80 260 80zM200 280C200 291 191 300 180 300H160C149 300 140 291 140 280V220H200V280zM200 200H140V140H200V200zM300 280C300 291 291 300 280 300H260C249 300 240 291 240 280V240H300V280zM300 220H240V180H300V220zM100 220H40V160H100V220zM60 80H80C91 80 100 89 100 100V140H40V100C40 89 49 80 60 80zM300 60H40C29 60 20 51 20 40S29 20 40 20H300C311 20 320 29 320 40S311 60 300 60zM100 280C100 291 91 300 80 300H60C49 300 40 291 40 280V240H100V280zM160 80H180C191 80 200 89 200 100V120H140V100C140 89 149 80 160 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
FullStackedChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
FullStackedChart.displayName = "Blueprint5.Icon.FullStackedChart";
exports.default = FullStackedChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"12jUl":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fullscreen", ()=>Fullscreen);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Fullscreen = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "fullscreen",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M68.2 360H120C131 360 140 369 140 380S131 400 120 400H20C9 400 0 391 0 380V280C0 269 9 260 20 260S40 269 40 280V331.8L145.8 226C149.4 222.2 154.4 220 160 220C171 220 180 229 180 240C180 245.6 177.8 250.6 174.2 254.2L68.2 360zM160 180C154.4 180 149.4 177.8 145.8 174.2L40 68.2V120C40 131 31 140 20 140S0 131 0 120V20C0 9 9 0 20 0H120C131 0 140 9 140 20S131 40 120 40H68.2L174 145.8C177.8 149.4 180 154.4 180 160C180 171 171 180 160 180zM380 400H280C269 400 260 391 260 380S269 360 280 360H331.8L226 254.2C222.2 250.6 220 245.6 220 240C220 229 229 220 240 220C245.6 220 250.6 222.2 254.2 225.8L360 331.8V280C360 269 369 260 380 260S400 269 400 280V380C400 391 391 400 380 400zM380 140C369 140 360 131 360 120V68.2L254.2 174C250.6 177.8 245.6 180 240 180C229 180 220 171 220 160C220 154.4 222.2 149.4 225.8 145.8L331.8 40H280C269 40 260 31 260 20S269 0 280 0H380C391 0 400 9 400 20V120C400 131 391 140 380 140z" : "M68.2 280H100C111 280 120 289 120 300C120 311 111 320 100 320H20C9 320 0 311 0 300V220C0 209 9 200 20 200S40 209 40 220V251.8L105.8 186C109.4 182.2 114.4 180 120 180C131 180 140 189 140 200C140 205.6 137.8 210.6 134.2 214.2L68.2 280zM120 140C114.4 140 109.4 137.8 105.8 134.2L40 68.2V100C40 111 31 120 20 120S0 111 0 100V20C0 9 9 0 20 0H100C111 0 120 9 120 20C120 31 111 40 100 40H68.2L134 105.8C137.8 109.4 140 114.4 140 120C140 131 131 140 120 140zM300 120C289 120 280 111 280 100V68.2L214.2 134C210.6 137.8 205.6 140 200 140C189 140 180 131 180 120C180 114.4 182.2 109.4 185.8 105.8L251.8 40H220C209 40 200 31 200 20C200 9 209 0 220 0H300C311 0 320 9 320 20V100C320 111 311 120 300 120zM300 320H220C209 320 200 311 200 300C200 289 209 280 220 280H251.8L185.8 214.2C182.2 210.6 180 205.6 180 200C180 189 189 180 200 180C205.6 180 210.6 182.2 214.2 185.8L280 251.8V220C280 209 289 200 300 200S320 209 320 220V300C320 311 311 320 300 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Fullscreen.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Fullscreen.displayName = "Blueprint5.Icon.Fullscreen";
exports.default = Fullscreen;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iGbS5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Function", ()=>Function);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Function = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "function",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M202.8 283.6H174.6C182.6 316.8 193.4 341 206.6 356.4C214.6 366 222.6 370.8 230.2 370.8C231.8 370.8 233 370.4 234 369.4C235 368.4 235.4 367.4 235.4 365.8C235.4 364.4 234.4 362 232.2 358.4C230 354.8 229 351.2 229 348C229 343.4 230.6 339.4 234 336.2C237.4 333 241.6 331.2 246.8 331.2C252.4 331.2 257 333.2 260.8 337.2C264.6 341.2 266.4 346.6 266.4 353.4C266.4 361.2 263.6 367.4 258 372.2C252.4 377 243.2 379.4 230.8 379.4C211.4 379.4 193.6 373.6 177.8 362C162 350.8 147 331.6 132.6 305C127.8 295.8 123 290 118.6 287.4C114.2 284.8 107.2 283.6 97.4 283.6L91 260.6H118L78.2 103.6C71.6 77.8 67 61.8 64.8 55.8C61.4 46.9999999999999 56.2 39.6 49.4 33.4C46.6 30.9999999999999 43.4 29.5999999999999 39.4 29.5999999999999C38.4 29.5999999999999 37.4 29.9999999999999 36.6 30.6L35.8 32C35.8 32.6 36.8 34.0000000000001 38.8 36C40.8 38.0000000000001 41.8 41.2 41.8 45.4C41.8 50 40.2 53.8 37.2 56.8C34 59.8 29.6 61.4 23.8 61.4C16.8 61.4 11.2 59.4 6.8 55.6C2.6 51.6 0.4 47 0.4 41.6C0.4 35.8000000000001 3 30.8000000000001 8.2 26.6C13.2 22.2 21.2 20 32.2 20C49.8 20 65.4 24.6 78.8 33.8C92.4 43.0000000000001 104.2 57.2 114.4 76.6C124.6 95.8000000000001 135 127 145.6 169.8000000000001L168.4 260.6H196L202.8 283.6zM338.8 244.6C343.8 248.6 349.0000000000001 250.4 354.4000000000001 250.4C356.4000000000001 250.4 360.2000000000001 249.6 365.6 248.2C371 246.6 375.8000000000001 246 380 246C385.8 246 390.4 248 394.4 252C398 255.8 400 261 400 267.4C400 274 398 279.4 394.2000000000001 283.4C390.4 287.4 384.8000000000001 289.2 377.8 289.2C371.4 289.2 365.4 287.6 359.8000000000001 284.6C354.2000000000001 281.6 347 274.8 338.2000000000001 264.6C331.6000000000002 257 322.0000000000001 243.6 309.4000000000001 224.6C304.4000000000001 248 295.6000000000001 269.6 283.2000000000001 289L215.2000000000001 277.2000000000001L213.8000000000001 269.8C218.8000000000001 270.8 223.2000000000001 271.4000000000001 226.6000000000001 271.4000000000001C233.4000000000001 271.4000000000001 239.0000000000001 268.4 243.4000000000001 262.6C250.4000000000001 253.4 260.2000000000001 225.6 272.6 178.8C262.8000000000001 165.6 256.2000000000001 157 252.6000000000001 152.8C246.6 146.2 241.6 142 237.8000000000001 140C234.8000000000001 138.4 231.4000000000001 137.6 227.6000000000001 137.6C224.8000000000001 137.6 220 139.2000000000001 213.6000000000001 142.4C209.2000000000001 144.4 205.2000000000001 145.6 201.8000000000001 145.6C195.2000000000001 145.6 189.8000000000001 143.4 185.4000000000001 139.2000000000001C181.2000000000001 134.8 179.0000000000001 129.4 179.0000000000001 122.6C179.0000000000001 116.4 181.0000000000001 111.2 185.0000000000001 107.2000000000001C189.0000000000001 103.2000000000001 194.4000000000001 101.4 201.0000000000001 101.4C207.4000000000001 101.4 213.6000000000001 102.8000000000001 219.4000000000001 105.6000000000001C225.2000000000001 108.4000000000001 232.2000000000001 114.2000000000001 241.0000000000001 123.2000000000001C249.6000000000001 132.2000000000001 261.6000000000001 146.4000000000001 276.8000000000001 166.0000000000001C282.6 147.4000000000001 287.8000000000001 133.8000000000001 292.0000000000001 125.4000000000001C296.2000000000001 117.0000000000001 301.2000000000001 110.8000000000001 306.8000000000001 107.2000000000001C312.4000000000001 103.4000000000001 319.2000000000001 101.6000000000001 327.6 101.6000000000001C335.6 101.6000000000001 343.8 104.6000000000001 352.2000000000001 110.4000000000001C363.2000000000001 118.0000000000001 374.2000000000001 131.2000000000001 385.8000000000001 149.8000000000001L378.8 154.0000000000001C371 143.0000000000001 365.2000000000001 136.2000000000001 361.4 133.4000000000002C359 131.6000000000001 356 130.8000000000001 352.6 130.8000000000001C348.6 130.8000000000001 344.6 133.4000000000002 340.8 138.4000000000002C334.2000000000001 147.0000000000002 325.4 171.0000000000002 314.2 210.4000000000002C323.6 227.6 332 239.2 338.8 244.6z" : "M162.4 225.2H139.6C146.2 251 154.6 270 165.2 282C171.8 289.4 178 293.2 184.2 293.2C185.4 293.2 186.4 292.8 187.2 292.2C188 291.4 188.4 290.4 188.4 289.2C188.4 288.2 187.6 286.2 185.8 283.4C184 280.6 183.2 277.8 183.2 275.4C183.2 271.8 184.6 268.8 187.2 266.2C190 263.6 193.4 262.4 197.6 262.4C202 262.4 205.8 264 208.8 267C211.8000000000001 270.2 213.4 274.4 213.4 279.6C213.4 285.6 211.2000000000001 290.6 206.6 294.4C202 298.2 194.8 300 184.8 300C169.2 300 155 295.6 142.4 286.6C129.6 277.6 117.6 262.6 106.2 242C102.2 234.8 98.6 230.2 95 228.2C91.4 226.2 85.8 225.2 78 225.2L72.8 207.2H94.4L62.6 84.8C57.2 64.6 53.8 52.2 51.8 47.6C49 40.8 45 34.9999999999999 39.4 30.2C37.2 28.2 34.6 27.2 31.4 27.2C30.6 27.2 29.8 27.4 29.2 28L28.4 29C28.4 29.6 29.2 30.6 30.8 32.2C32.4 33.8 33.2 36.2 33.2 39.4C33.2 43 32 46 29.4 48.2C27 50.6 23.4 51.8 18.6 51.8C13 51.8 8.4 50.1999999999999 5 47.1999999999999C1.8 44.4 0 40.8 0 36.6C0 32.2 2 28.2 6.2 24.8C10.4 21.4 16.8 19.8 25.6 19.8C39.6 19.8 52 23.4 63 30.6C73.8 37.8 83.4 49 91.4 64C99.6 79 107.8 103.2 116.4 136.6L134.6 207.4H156.6L162.4 225.2zM271 194.8C275 197.8 279.2000000000001 199.4 283.4 199.4C285 199.4 288 198.8 292.4 197.6C296.8 196.4 300.6 195.8 303.8 195.8C308.4 195.8 312.2 197.4 315.2 200.4C318.4 203.6 320 207.6 320 212.6C320 217.8 318.4 222 315.4 225C312.4 228 308 229.6 302.2 229.6C297.2 229.6 292.2 228.4000000000001 287.8 226C283.2 223.6 277.6 218.4 270.6 210.4C265.4 204.4 257.8 194.2 247.6 179.4C243.6 197.6 236.6 214.4 226.6 229.6L172.2 220.4L171 214.6C175 215.4 178.4 215.8 181.2 215.8C186.6 215.8 191 213.6 194.6 209C200.2 201.8 208 180 218 143.8C210.2 133.4 204.8 126.8000000000001 202 123.6C197.2 118.4 193.2 115.2000000000001 190.2 113.6C187.8 112.4 185.2 111.8 182 111.8C179.8 111.8 176 113.0000000000001 170.8 115.4C167.2 117 164 117.8 161.2 117.8C155.8 117.8 151.6 116.2 148 112.8C144.6 109.4 142.8 105.2 142.8 100C142.8 95 144.4 91.2 147.6 88C150.8 85 155 83.4 160.4 83.4C165.6 83.4 170.4 84.4 175 86.6C179.6 88.8 185.4 93.4 192.2 100.4C199.2 107.4 208.6 118.4 220.8 133.8C225.4 119.2 229.6 108.8 233 102.2S240.4 90.8 244.8 88C249.2 85 254.8 83.6 261.4 83.6C267.8 83.6 274.4 85.8 281 90.4C289.8 96.4 298.6 106.6 307.8 121L302.6 124C296.4 115.4 291.8 110 288.8 108C286.8 106.6 284.4000000000001 106 281.8 106C278.6 106 275.4000000000001 108 272.2000000000001 112C266.8 118.8 259.8000000000001 137.4 251 168C259 181.6 265.6 190.6 271 194.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Function.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Function.displayName = "Blueprint5.Icon.Function";
exports.default = Function;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bDvkw":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GanttChart", ()=>GanttChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GanttChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "gantt-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 260H180C191 260 200 269 200 280V300C200 311 191 320 180 320H80C69 320 60 311 60 300V280C60 269 69 260 80 260zM140 220V200C140 189 149 180 160 180H280C291 180 300 189 300 200V220C300 231 291 240 280 240H160C149 240 140 231 140 220zM380 160H260C249 160 240 151 240 140V120C240 109 249 100 260 100H380C391 100 400 109 400 120V140C400 151 391 160 380 160zM380 80H40V340C40 351 31 360 20 360S0 351 0 340V60C0 49 9 40 20 40H380C391 40 400 49 400 60C400 71 391 80 380 80z" : "M200 120C200 109 209 100 220 100H300C311 100 320 109 320 120C320 131 311 140 300 140H220C209 140 200 131 200 120zM120 180C120 169 129 160 140 160H220C231 160 240 169 240 180C240 191 231 200 220 200H140C129 200 120 191 120 180zM300 80H40V260C40 271 31 280 20 280S0 271 0 260V60C0 49 9 40 20 40H300C311 40 320 49 320 60C320 71 311 80 300 80zM80 220H140C151 220 160 229 160 240C160 251 151 260 140 260H80C69 260 60 251 60 240C60 229 69 220 80 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GanttChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GanttChart.displayName = "Blueprint5.Icon.GanttChart";
exports.default = GanttChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ksGp8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Generate", ()=>Generate);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Generate = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "generate",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 140C160 151.046 151.0458 160 140 160H98.8376C88.4338 160 80 168.434 80 178.838C80 182.216 80.909 185.534 82.6318 188.442L202.19 390.19606C205.944 396.53112 212.738 400 220 400C231.046 400 240 391.0457 240 380V260C240 248.9544 248.954 240 260 240H301.162C311.5660000000001 240 320 231.5662 320 221.1624C320 217.783 319.09 214.466 317.368 211.5588L197.8098 9.804C194.0556 3.468 187.2614 0 180 0C168.9544 0 160 8.954 160 20V140z" : "M140 100C140 111.046 131.0456 120 120 120H96C87.1634 120 80 127.1634 80 136C80 138.6262 80.6464 141.212 81.8824 143.5294L171.7648 312.05884C174.3716 316.9468 179.4604 320 185 320C193.2842 320 200 313.28426 200 305V220C200 208.9542 208.954 200 220 200H244C252.836 200 260 192.8364 260 184C260 181.3736 259.3540000000001 178.7878 258.118 176.4704L168.2352 7.94C165.6284 3.054 160.5396 0 155 0C146.7158 0 140 6.716 140 15V100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Generate.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Generate.displayName = "Blueprint5.Icon.Generate";
exports.default = Generate;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2K1yx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Geofence", ()=>Geofence);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Geofence = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "geofence",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 180L161.5047708 179.944242L164.0145152 179.595198L166.2428504 179.005238L168.464431 178.126532L170.414175 177.08009L172.340447 175.741446L174.1428162 174.141782C174.8500166 173.434254 175.493741 172.686512 176.0733084 171.906132L177.5065766 169.681242L178.5754902 167.42672L179.2830972 165.31986L179.8618568 162.36191L180 159.979706L180 40C180 28.954306 171.045695 20 160 20C149.7432832 20 141.2898568 27.720804 140.1345546 37.667578L140 40L140 111.72L34.1421356 5.8578640000001C26.3316498 -1.952622 13.66835022 -1.952622 5.85786438 5.8578640000001C-1.351814856 13.067544 -1.906405566 24.412164 4.19409224 32.257988L5.85786438 34.1421359999999L111.68 140L40.0796508 140C29.0339558 140 20.0796508 148.954306 20.0796508 160C20.0796508 170.256716 27.8004546 178.710144 37.7472284 179.865446L40.0796508 180L160 180zM220.353532 399.99730602694C221.742358 399.9721704388 223.119904 399.8031605912001 224.467234 399.49494119C225.7284200000001 399.210404934 226.961728 398.800930584 228.1558340000001 398.26732539L230.54701 396.99909132L231.181828 396.58468328L233.172254 395.04964176L393.725474 254.5115684L394.957418 253.2394958L396.324354 251.5233122L397.20639 250.1629134L398.484412 247.6006474L399.285032 245.2595818L399.767848 243.0000786L399.982762 240.8332014L399.971428 238.8282252L399.835502 237.3833294L399.4621560000001 235.3299866L398.71651 232.8950534L397.9415800000001 231.1108168L396.9587580000001 229.3574988L297.019108 69.489968C295.8149440000001 67.54418 294.286408 65.820288 292.50898 64.393776L290.644976 63.065146L288.736888 62.004198L287.006182 61.265966L284.507568 60.5100240000001C283.083748 60.184628 281.616072 60.009688 280.140066 59.997958L220 59.997958L220 160C220 191.953618 195.0216008 218.0732176 163.5254558 219.8981462L160 220L60 220L60 280C60.0076872 285.4561596 62.228822 290.822099 66.4243496 294.689681L68.3752362 296.2746694L208.375236 396.27466942C209.097784 396.79077536 209.842968 397.2519392 210.605814 397.65898986C211.66371 398.225299292 212.768174 398.688943632 213.899952 399.050165764C215.053414 399.421521056 216.217094 399.679513636 217.388064 399.832696902L220.353532 399.99730602694z" : "M120 140C131 140 140 131 140 120L140 120L140 40C140 29 131 20 120 20C109 20 100 29 100 40L100 40L100 71.8L34.2 5.8C30.6 2.2 25.6 0 20 0C9 0 4.4e-12 9 4.4e-12 20C4.4e-12 25.6 2.2 30.6 6 34.2L6 34.2L71.8 100L40 100C29 100 20 109 20 120C20 131 29 140 40 140L40 140zM181.7513244 319.9238973876L183.7059536 319.65732403L185.6438468 319.188227496L186.7743274 318.823554982L188.7679404 317.980513L189.8682892 317.4009627600001L191.7648664 316.18039794L192.803688 315.3644256L312.803688 215.3644256L313.808364 214.4692662L315.326578 212.8568274L316.389862 211.4705122L317.569974 209.5660614L318.603692 207.3438056C319.71095 204.5336696 320.179526 201.4869304 319.944042 198.4432986L319.66598 196.3302288L318.910844 193.4738316L318.222312 191.7447336L317.364862 190.0772212L237.364862 50.077222L236.680414 48.964022L235.506858 47.367912L234.742414 46.478998L232.81395 44.637064L230.53434 42.995664L228.224526 41.76393L226.497718 41.079818L224.320188 40.468408L222.332422 40.134554L220.943752 40.019754L176.5935068 40.019754C178.3584452 45.02116 179.4796378 50.324626 179.8575174 55.83241L180 60L180 120C180 151.9536176 155.0216008 178.0732176 123.5254558 179.8981462L120 180L60 180C52.973628 180 46.2293474 178.7922228 39.9634404 176.5729504L40 220L40.0469564 221.3813346L40.2924582 223.4080052L40.5923554 224.8510144L41.0978674 226.5501266L41.9581402 228.6406776L43.0748944 230.6606106L43.9768114 231.9781248L45.5574476 233.8413760000001L47.2420406 235.4031072L48.905996 236.6410058L168.905996 316.64100588L170.3017282 317.49246314L172.7093812 318.627809038L174.922276 319.346295756L177.0760668 319.785307096L178.732873 319.963137805L179.3682024 319.9902335706001C180.2886398 320.01324136752 181.0221554 319.9884539969 181.7513244 319.9238973876z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Geofence.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Geofence.displayName = "Blueprint5.Icon.Geofence";
exports.default = Geofence;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"83Qux":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Geolocation", ()=>Geolocation);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Geolocation = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "geolocation",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 233.4L183.4 183.4L233.4 0L400 400z" : "M-0.2 186.8L146.6 146.8L186.6 0.2L319.8 320.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Geolocation.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Geolocation.displayName = "Blueprint5.Icon.Geolocation";
exports.default = Geolocation;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bEnfC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Geosearch", ()=>Geosearch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Geosearch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "geosearch",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 22.4C84.2 22.4 22.4 84.2000000000001 22.4 160C22.4 172.2 24 184.4 27 195.8C27.6 195.6 28.2 196 29 196H30.8V185C30.8 180.4 35 176.6 39.6 176.6C40.4 176.6 41.4 176.8 42 177L60 159.4C61.8 157.6 64.6 157.6 66.4 159.4C68.2 161.2 68.2 164 66.4 165.8L49.2 183.8C49.2 184.2 50.2 184.6 50.2 185.2000000000001V187.8000000000001C50.2 191.4 52.2 192.8000000000001 56 196.0000000000001H66.6C68.6 196.0000000000001 70.4 196.2000000000001 72 197.0000000000001C72.2 197.2000000000001 72.4 197.0000000000001 72.6 197.2000000000001C73 197.4000000000001 73.2 197.6000000000001 73.6 198.0000000000001C73.8 198.2000000000001 74 198.2000000000001 74 198.4L74.4 198.8L97 221.4C93.8 227.8 91 234.4 88.6 241.2H75.8V251.8C75.8 252 77 250.6 77 253.8H84.6C83.8 257 83 260.2 82.6 263.4H68.4C72.4 266.6 76.8 269.6 81.2 272.4C80.4 278.2 80 284 80 290C80 292.8 80.2 295.6 80.4 298.6C32.4 270.8 0 219.2 0 160C0 71.8 71.8 0 160 0C237.4000000000001 0 301.8 55.4 316.4 128.8L297 150.8C291.8 79.4 232.4 22.4 160 22.4zM117.6 95.8V102.8H120.6C126.4 102.8 130.4 107.4 130.4 113.4V127C130.4 127.1999999999999 130.6 127.1999999999999 130.4 127.4L94.2 164H78.8C73 164 69.4 159.1999999999999 69.4 153.4V113.4C69.4 107.6 73 102.8 78.8 102.8H85.4V62.4C85.4 56.8 91 52.1999999999999 96.6 52.1999999999999C102.2 52.1999999999999 107.8 56.8 107.8 62.4V86.8H107.6C113.4 86.8 117.6 90 117.6 95.8zM394.2000000000001 154.2L320.6 227.8C323.4000000000001 232.0000000000001 326 236.2 328.2 240.8C328.6 241.6 329 242.2 329.2000000000001 243.0000000000001C331.4 247.4000000000001 333.2 252.0000000000001 334.8000000000001 256.8000000000001C334.8000000000001 256.8000000000001 334.8000000000001 256.8000000000001 334.8000000000001 257C336.2000000000001 261.8000000000001 337.4000000000001 266.6 338.2000000000001 271.6C338.4000000000001 272.8 338.6000000000001 273.8000000000001 338.8000000000001 275C339.6 279.8 340 284.8 340 290C340 350.8 290.8 400 230 400C169.2 400 120 350.8 120 290C120 229.2 169.2 180 230 180C235.2 180 240.2 180.4 245.2 181.2C246.4 181.4 247.4 181.6 248.6 181.8C253.6 182.6 258.4 183.8 263.2 185.2C263.2 185.2 263.2 185.2 263.4 185.2C268.2 186.8 272.8 188.6 277.2 190.8C278 191.2 278.6 191.6 279.4 191.8C284 194 288.2 196.6 292.4 199.4L366 125.8C369.4 122.2 374.4 120 380 120C391 120 400 129 400 140C400 145.6 397.8 150.6 394.2000000000001 154.2zM230 210C185.8 210 150 245.8 150 290C150 334.2 185.8 370 230 370C274.2000000000001 370 310 334.2 310 290C310 245.8 274.2000000000001 210 230 210zM268.6 103.4V116.4C268.6 118.6 266 120.6 263.8 120.6C261.6 120.6 259 118.8 259 116.4V103.4C259 101.2 261.6 99.2 263.8 99.2C266 99.2000000000001 268.6 101.2 268.6 103.4zM220.4 90H237C242.8 90 246.2 94.2000000000001 246.2 100V137.2L250.8 141.6C244 140.6 237 140 230 140C222.8 140 216 140.6 209 141.6C209.6 140.6 210.2 139.6 210.6 138.4V100C210.8 94.2000000000001 214.6 90 220.4 90z" : "M176.4 72H189.6C194.2 72 196.8 75.4 196.8 80V109.6L200.6 113.2C195.2 112.6 189.6 112 184 112C178.4 112 172.8 112.6 167.2 113.4C167.6 112.6 168.2 111.8 168.6 110.8V80C168.6 75.4 171.6 72 176.4 72zM128 18C67.4 18 18 67.4 18 128C18 137.8 19.2 147.6 21.6 156.6C22.2 156.6 22.6 156.8 23.2 156.8H24.8V148C24.8 144.2 28.2 141.2 32 141.2C32.6 141.2 33.4 141.4 34 141.4L48.2 127.4C49.6 126 52 126 53.4 127.4C54.8 128.8 54.8 131.2 53.4 132.6L39.4 147C39.4 147.4 40 147.6 40 148V150.2C40 153.2 41.6 154.2 44.6 156.8H53C54.6 156.8 56 157 57.4 157.6C57.6 157.6 57.8 157.6 57.8 157.6C58.2 158 58.4 158 58.6 158.4C58.8 158.6 58.8 158.6 59 158.6L59.4 158.8L77.4 176.8C74.8 182 72.6 187.2 70.6 192.8H60.6V201.4C60.6 201.6 61.6 200.4 61.4 203H67.6C67 205.6 66.4 208.2 66 210.8H54.6C57.8 213.2 61.4 215.6 64.8 218C64.4 222.6 64 227.2 64 232C64 234.4 64.2 236.6 64.4 238.8C26 216.8 0 175.4 0 128C0 57.4 57.4 0 128 0C190 0 241.4 44.4 253.2 103L237.6 120.6C233.4 63.6 186 18 128 18zM94 76.6V82.2H96.4C101 82.2 104.2 86 104.2 90.6V101.4C104.2 101.4 104.4 101.6 104.2 101.6L75.4 131H63C58.4 131 55.4 127.2 55.4 122.6V90.6C55.4 86 58.2 82.2 63 82.2H68.2V50.0000000000001C68.2 45.4 72.6 41.8 77.2 41.8C81.8 41.8 86.2 45.4 86.2 50.0000000000001V69.4H86C90.8 69.4 94 72 94 76.6zM315.4 123.4L256.6 182.2C258.8 185.6 260.8 189 262.6 192.6C262.8 193.2 263.2 193.8 263.4 194.4C265 198 266.6 201.6 267.8 205.4C267.8 205.4 267.8 205.4 267.8 205.6C269 209.4 269.8 213.2 270.6 217.2C270.8 218.2 270.8 219 271 220C271.6 224 272 228 272 232.2C272 280.8 232.6 320.2 184 320.2C135.4 320 96 280.6 96 232S135.4 144 184 144C188.2 144 192.2 144.4 196.2 145C197 145 198 145.2 199 145.4C203 146 206.8 147 210.6 148.2C210.6 148.2 210.6 148.2 210.8 148.2C214.6 149.4 218.2 151 221.8 152.6C222.4 152.8 223 153.2 223.6 153.4C227.2 155.2 230.6 157.2 234 159.4L292.8 100.6C295.6 97.8 299.6 96 304.2 96C313 96 320.2 103.2 320.2 112C320 116.4 318.2 120.4 315.4 123.4zM184 168C148.6 168 120 196.6 120 232C120 267.4 148.6 296 184 296S248 267.4 248 232C248 196.6 219.4 168 184 168zM214.8 82.8V93.2C214.8 95 212.8 96.6 211 96.6C209.2 96.6 207.2 95.2 207.2 93.2V82.8C207.2 81 209.2 79.4 211 79.4C212.8 79.4 214.8 80.8 214.8 82.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Geosearch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Geosearch.displayName = "Blueprint5.Icon.Geosearch";
exports.default = Geosearch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6VfO2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Geotime", ()=>Geotime);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Geotime = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "geotime",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M311.094 260C263.594 260 225 222.6562 225 176.718C225 130.624 311.094 0 311.094 0C311.094 0 397.188 130.624 397.188 176.718C397.0320000000001 222.6562 358.594 260 311.094 260zM311.094 135C289.532 135 272.032 152.5 272.032 174.062C272.032 195.624 289.532 213.125 311.094 213.125C332.656 213.125 350.156 195.624 350.156 174.062C350.156 152.5 332.656 135 311.094 135zM0 250C0 332.875 67.125 400 150 400C222.914 400 283.636 348.0416 297.18 279.1122000000001C284.322 277.4600000000001 272.14 273.5506000000001 261.096 267.7906C252.552 321.4208 206.01 362.5 150 362.5C87.9374 362.5 37.5 312.0626 37.5 250C37.5 187.938 87.9374 137.5 150 137.5C171.4086 137.5 191.434 143.502 208.484 153.912C211.294 143.396 215.52 132.336 220.086 121.744C220.596 120.56 221.116 119.368 221.646 118.17C200.36 106.582 175.9528 100 150 100C67.125 100 0 167.126 0 250zM168.75 321.2516V257.6876L200.812 225.8126C204.188 222.4376 206.25 217.75 206.25 212.5C206.25 202.1876 197.8124 193.75 187.5 193.75C182.25 193.75 177.5626 195.812 174.1876 199.188L136.6874 236.6876C133.3126 240.0626 131.25 244.75 131.25 250V321.2516C131.25 331.5642000000001 139.6876 340.0016 150 340.0016C160.3124 340.0016 168.75 331.5642000000001 168.75 321.2516z" : "M248.876 200C210.876 200 180 170.125 180 133.375C180 96.5 248.876 0 248.876 0C248.876 0 317.75 96.5 317.75 133.375C317.626 170.125 286.876 200 248.876 200zM250 100C233.44 100 220 113.44 220 130C220 146.56 233.44 160 250 160C266.56 160 280 146.56 280 130C280 113.44 266.56 100 250 100zM0 200C0 266.3 53.7 320 120 320C179.7336 320 229.24 276.4102000000001 238.46 219.2886C228.116 218.004 218.318 215.0162 209.378 210.6262C204.108 255.2812 166.0552 290 120 290C70.35 290 30 249.65 30 200C30 150.35 70.35 110 120 110C134.9972 110 149.146 113.682 161.5904 120.1888C163.4652 111.698 166.899 101.938 171.3608 91.506C155.7928 84.128 138.3806 80 120 80C53.7 80 0 133.7 0 200zM135 244.9992V206.15L160.65 180.65C163.35 177.95 165 174.2 165 170C165 161.75 158.25 155 150 155C145.8 155 142.05 156.65 139.35 159.35L109.35 189.35C106.65 192.05 105 195.8 105 200V244.9992C105 253.2492 111.75 259.9992 120 259.9992C128.25 259.9992 135 253.2492 135 244.9992z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Geotime.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Geotime.displayName = "Blueprint5.Icon.Geotime";
exports.default = Geotime;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b44lo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GitBranch", ()=>GitBranch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GitBranch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "git-branch",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 360C266.8 360 240 333.2 240 300C240 274 256.8 252 280 243.6V220C280 198 262 180 240 180H160C145.4 180 131.8 175.8 120 169V283.6C143.2 292 160 314 160 340C160 373.2 133.2 400 100 400S40 373.2 40 340C40 314 56.8 292 80 283.6V116.2C56.8 108 40 86 40 60C40 26.8 66.8 0 100 0S160 26.8 160 60C160 85 144.6 106 123 115C129 129.6 143.2 140 160 140H240C284.2000000000001 140 320 175.8 320 220V243.6C343.2 252 360 274 360 300C360 333.2 333.2 360 300 360zM100 360C111 360 120 351 120 340C120 329 111 320 100 320S80 329 80 340C80 351 89 360 100 360zM100 40C89 40 80 49 80 60C80 71 89 80 100 80S120 71 120 60C120 49 111 40 100 40zM300 280C289 280 280 289 280 300C280 311 289 320 300 320S320 311 320 300C320 289 311 280 300 280z" : "M240 300C206.8 300 180 273.2 180 240C180 215 195.2 193.6 217 184.6C210.8 170.2 196.6 160 180 160H140C125.4 160 111.8 156 100 149V203.6C123.2 212 140 234 140 260C140 293.2 113.2 320 80 320S20 293.2 20 260C20 234 36.8 212 60 203.6V116.2C36.8 108.2 20 86 20 60C20 26.8 46.8 0 80 0S140 26.8 140 60C140 80.8 129.4 99 113.6 109.8C120.6 116 129.8 120 140 120H180C218.4 120 250.4 147 258.2 183C282.4 190.8 300 213.2 300 240C300 273.2 273.2 300 240 300zM80 280C91 280 100 271 100 260C100 249 91 240 80 240S60 249 60 260C60 271 69 280 80 280zM80 40C69 40 60 49 60 60C60 71 69 80 80 80S100 71 100 60C100 49 91 40 80 40zM240 220C229 220 220 229 220 240C220 251 229 260 240 260S260 251 260 240C260 229 251 220 240 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GitBranch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GitBranch.displayName = "Blueprint5.Icon.GitBranch";
exports.default = GitBranch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ZXXz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GitCommit", ()=>GitCommit);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GitCommit = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "git-commit",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 220H298C288.8 265.6 248.4 300 200 300S111.2 265.6 102 220H20C9 220 0 211 0 200C0 189 9 180 20 180H102C111.2 134.4 151.6 100 200 100S288.8 134.4 298 180H380C391 180 400 189 400 200C400 211 391 220 380 220zM200 140C166.8 140 140 166.8 140 200S166.8 260 200 260S260 233.2 260 200S233.2 140 200 140z" : "M300 180H237.2C228.2 214.4 197.2 240 160 240S91.8 214.4 82.8 180H20C9 180 0 171 0 160C0 149 9 140 20 140H82.8C91.8 105.6 122.8 80 160 80S228.2 105.6 237.2 140H300C311 140 320 149 320 160C320 171 311 180 300 180zM160 120C138 120 120 138 120 160C120 182 138 200 160 200S200 182 200 160C200 138 182 120 160 120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GitCommit.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GitCommit.displayName = "Blueprint5.Icon.GitCommit";
exports.default = GitCommit;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Gs4zn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GitMerge", ()=>GitMerge);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GitMerge = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "git-merge",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 240C274 240 252 223.2 243.6 200H220C170.2 200 129.2 236.6 121.6 284.2C144 292.8 160 314.6 160 340C160 373.2 133.2 400 100 400S40 373.2 40 340C40 314 56.8 292 80 283.8V116.4C56.8 108 40 86 40 60C40 26.8 66.8 0 100 0S160 26.8 160 60C160 86 143.2 108 120 116.4V202.8C145.4 176.6 180.6 160 220 160H243.6C251.8 136.8 273.8 120 300 120C333.2 120 360 146.8 360 180S333.2 240 300 240zM100 40C89 40 80 49 80 60C80 71 89 80 100 80S120 71 120 60C120 49 111 40 100 40zM100 320C89 320 80 329 80 340C80 351 89 360 100 360S120 351 120 340C120 329 111 320 100 320zM300 160C289 160 280 169 280 180C280 191 289 200 300 200S320 191 320 180C320 169 311 160 300 160z" : "M240 200C214 200 192 183.2 183.6 160H180C147.6 160 120 179.2 107.4 206.8C126.6 216.8 140 236.8 140 260C140 293.2 113.2 320 80 320S20 293.2 20 260C20 234 36.8 212 60 203.8V116.4C36.8 108 20 86 20 60C20 26.8 46.8 0 80 0S140 26.8 140 60C140 86 123.2 108 100 116.4V151.4C121.2 132 149 120 180 120H183.6C191.8 96.8 213.8 80 240 80C273.2 80 300 106.8 300 140S273.2 200 240 200zM80 40C69 40 60 49 60 60C60 71 69 80 80 80S100 71 100 60C100 49 91 40 80 40zM80 240C69 240 60 249 60 260C60 271 69 280 80 280S100 271 100 260C100 249 91 240 80 240zM240 120C229 120 220 129 220 140C220 151 229 160 240 160S260 151 260 140C260 129 251 120 240 120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GitMerge.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GitMerge.displayName = "Blueprint5.Icon.GitMerge";
exports.default = GitMerge;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ljK9i":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GitNewBranch", ()=>GitNewBranch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GitNewBranch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "git-new-branch",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 340H320V360C320 371 311 380 300 380S280 371 280 360V340H260C249 340 240 331 240 320C240 309 249 300 260 300H280V280C280 269 289 260 300 260S320 269 320 280V300H340C351 300 360 309 360 320C360 331 351 340 340 340zM280 242.8V220C280 198 262 180 240 180H160C145.4 180 131.8 175.8 120 169V283.6C143.2 292 160 314 160 340C160 373.2 133.2 400 100 400S40 373.2 40 340C40 314 56.8 292 80 283.6V116.2C56.8 108 40 86 40 60C40 26.8 66.8 0 100 0S160 26.8 160 60C160 85 144.6 106 123 115C129 129.6 143.2 140 160 140H240C284.2000000000001 140 320 175.8 320 220V242.8C313.6 241.2 307 240 300 240S286.4 241.2 280 242.8zM100 360C111 360 120 351 120 340C120 329 111 320 100 320S80 329 80 340C80 351 89 360 100 360zM100 40C89 40 80 49 80 60S89 80 100 80S120 71 120 60S111 40 100 40z" : "M280 280H260V300C260 311 251 320 240 320S220 311 220 300V280H200C189 280 180 271 180 260C180 249 189 240 200 240H220V220C220 209 229 200 240 200S260 209 260 220V240H280C291 240 300 249 300 260C300 271 291 280 280 280zM216.4 184C210.2 169.8 196.4 160 180 160H140C125.4 160 111.8 156 100 149V203.6C123.2 212 140 234 140 260C140 293.2 113.2 320 80 320S20 293.2 20 260C20 234 36.8 212 60 203.6V116.2C36.8 108.2 20 86 20 60C20 26.8 46.8 0 80 0S140 26.8 140 60C140 80.8 129.4 99 113.6 109.8C120.6 116 129.8 120 140 120H180C218 120 249.8 146.6 257.8 182.2C252 180.8 246.2 180 240 180C231.8 180 224 181.6 216.4 184zM80 280C91 280 100 271 100 260S91 240 80 240S60 249 60 260S69 280 80 280zM80 40C69 40 60 49 60 60S69 80 80 80S100 71 100 60S91 40 80 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GitNewBranch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GitNewBranch.displayName = "Blueprint5.Icon.GitNewBranch";
exports.default = GitNewBranch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3jRMp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GitPull", ()=>GitPull);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GitPull = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "git-pull",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 116.4V260C340 304.2 304.2000000000001 340 260 340H208.2L234 365.8C237.8 369.4 240 374.4 240 380C240 391 231 400 220 400C214.4 400 209.4 397.8 205.8 394.2L145.8 334.2C142.2 330.6 140 325.6 140 320C140 314.4 142.2 309.4 145.8 305.8L205.8 245.8C209.4 242.2 214.4 240 220 240C231 240 240 249 240 260C240 265.6 237.8 270.6 234.2 274.2L208.2 300H260C282 300 300 282 300 260V116.4C276.8 108.2 260 86.2 260 60C260 26.8 286.8 0 320 0S380 26.8 380 60C380 86 363.2 108 340 116.4zM320 40C309 40 300 49 300 60C300 71 309 80 320 80S340 71 340 60C340 49 331 40 320 40zM80 380C46.8 380 20 353.2 20 320C20 294 36.8 272 60 263.6V116.2C36.8 108 20 86 20 60C20 26.8 46.8 0 80 0S140 26.8 140 60C140 86 123.2 108 100 116.4V263.6C123.2 272 140 294 140 320C140 353.2 113.2 380 80 380zM80 40C69 40 60 49 60 60C60 71 69 80 80 80S100 71 100 60C100 49 91 40 80 40zM80 300C69 300 60 309 60 320C60 331 69 340 80 340S100 331 100 320C100 309 91 300 80 300z" : "M60 300C26.8 300 0 273.2 0 240C0 214 16.8 192 40 183.6V116.2C16.8 108 0 86 0 60C0 26.8 26.8 0 60 0S120 26.8 120 60C120 86 103.2 108 80 116.4V183.6C103.2 192 120 214 120 240C120 273.2 93.2 300 60 300zM60 40C49 40 40 49 40 60C40 71 49 80 60 80S80 71 80 60C80 49 71 40 60 40zM60 220C49 220 40 229 40 240C40 251 49 260 60 260S80 251 80 240C80 229 71 220 60 220zM280 116.4V200C280 233.2 253.2 260 220 260H188.2L214 285.8C217.8 289.4 220 294.4 220 300C220 311 211 320 200 320C194.4 320 189.4 317.8 185.8 314.2L125.8 254.2C122.2 250.6 120 245.6 120 240C120 234.4 122.2 229.4 125.8 225.8L185.8 165.8C189.4 162.2 194.4 160 200 160C211 160 220 169 220 180C220 185.6 217.8 190.6 214.2 194.2L188.2 220H220C231 220 240 211 240 200V116.4C216.8 108.2 200 86.2 200 60C200 26.8 226.8 0 260 0S320 26.8 320 60C320 86 303.2 108 280 116.4zM260 40C249 40 240 49 240 60C240 71 249 80 260 80S280 71 280 60C280 49 271 40 260 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GitPull.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GitPull.displayName = "Blueprint5.Icon.GitPull";
exports.default = GitPull;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"apd9W":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GitPush", ()=>GitPush);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GitPush = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "git-push",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 180C300 185.6 297.8 190.6 294.2000000000001 194.2L234.2 254.2C230.6 257.8 225.6 260 220 260S209.4 257.8 205.8 254.2L145.8 194.2C142.2 190.6 140 185.6 140 180C140 169 149 160 160 160C165.6 160 170.6 162.2 174.2 165.8L200 191.8V20C200 9 209 0 220 0S240 9 240 20V191.8L265.8 166C269.4000000000001 162.2 274.4000000000001 160 280 160C291 160 300 169 300 180zM380 400H20C9 400 0 391 0 380V60C0 49 9 40 20 40H160V80H40V120H160V140H80V360H360V140H280V120H360V80H280V40H380C391 40 400 49 400 60V380C400 391 391 400 380 400zM100 240H140V280H100V240zM140 340H100V300H140V340z" : "M80 200H100V220H80V200zM260 140C260 145.6 257.8 150.6 254.2 154.2L194.2 214.2C190.6 217.8 185.6 220 180 220S169.4 217.8 165.8 214.2L105.8 154.2C102.2 150.6 100 145.6 100 140C100 129 109 120 120 120C125.6 120 130.6 122.2 134.2 125.8L160 151.8V20C160 9 169 0 180 0S200 9 200 20V151.8L225.8 126C229.4 122.2 234.4 120 240 120C251 120 260 129 260 140zM100 260H80V240H100V260zM300 320H20C9 320 0 311 0 300V40C0 29 9 20 20 20H120V60H40V80H120V100H60V280H280V100H240V80H280V60H240V20H300C311 20 320 29 320 40V300C320 311 311 320 300 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GitPush.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GitPush.displayName = "Blueprint5.Icon.GitPush";
exports.default = GitPush;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5VtLd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GitRepo", ()=>GitRepo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GitRepo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "git-repo",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140 340H100V300H140V340zM140 220H100V180H140V220zM140 280H100V240H140V280zM380 400H20C9 400 0 391 0 380V60C0 49 9 40 20 40H100V0L140 20L180 0V40H380C391 40 400 49 400 60V380C400 391 391 400 380 400zM360 80H180V100H100V80H40V120H360V80zM360 140H80V360H360V140z" : "M100 140H80V120H100V140zM300 320H20C9 320 0 311 0 300V40C0 29 9 20 20 20H80V0L120 20L160 0V20H300C311 20 320 29 320 40V300C320 311 311 320 300 320zM80 60H40V80H80V60zM280 60H160V80H280V60zM280 100H60V280H280V100zM100 260H80V240H100V260zM100 180H80V160H100V180zM100 220H80V200H100V220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GitRepo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GitRepo.displayName = "Blueprint5.Icon.GitRepo";
exports.default = GitRepo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1s6TD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Glass", ()=>Glass);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Glass = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "glass",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 280V400H60V280C60 209.4 112.2 151.4 180 141.6V40H120C109 40 100 31 100 20C100 9 109 0 120 0H280C291 0 300 9 300 20C300 31 291 40 280 40H220V141.6C287.8 151.4 340 209.4 340 280z" : "M40 320V240C40 180.6 83.2 131.4 140 121.8V40H100C89 40 80 31 80 20C80 9 89 0 100 0H220C231 0 240 9 240 20C240 31 231 40 220 40H180V121.8C236.8 131.4 280 180.6 280 240V320H40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Glass.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Glass.displayName = "Blueprint5.Icon.Glass";
exports.default = Glass;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vYQY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobeNetworkAdd", ()=>GlobeNetworkAdd);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GlobeNetworkAdd = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "globe-network-add",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M255 260L254.96 260.2C256.64 260.0666 258.32 260 260 260C260 244.9 265.2 229.22 277.2 217.2C278.026 216.4 278.86 215.6266 279.7 214.88C280.464 196.564 279.83 178.218 277.8 160H354.4C357.8 172.8 360 186.2 360 200C360 204.9334 359.734 209.8134 359.2000000000001 214.64C365.802 220.1946 371.092 227.1434 374.688 234.9866C378.286 242.8296 380.1 251.3722 380 260C383.52 260 387.026 260.3266 390.52 260.98C396.68 241.76 400 221.26 400 200C400 89.6 310.4 0 200 0C89.6 0 0 89.6 0 200C0 310.4 89.6 400 200 400C221.2 400 241.68 396.7 260.86 390.56C260.286 387.02666 260 383.50666 260 380C239.02 380 222.4 370 212.04 355.92C208.516 358.4352 204.328 359.8544 200 360C178.6 360 155 319 145 260H255zM257.8 160C259.2000000000001 172.8 260 186.2 260 200C260 213.8 259.2000000000001 227.2 257.6 240H142.2C139.2928 213.4126 139.2928 186.588 142.2 160H257.8zM124.8 260C131 299.8 143.2 333.2 159.2 354.6C135.2562 348.1966 113.1276 336.3182 94.559 319.9014C75.9902 303.4846 61.4894 282.9784 52.2 260H124.8zM40 200C40 186.2 42.2 172.8 45.6 160H122.2C119.2928 186.588 119.2928 213.4126 122.2 240H45.6C42.2 227.2 40 213.8 40 200zM124.8 140H52.2C71 93.8 110.2 58.4 159.2 45.4C143.2 66.8 131 100.2 124.8 140zM200 40C221.4 40 245 81 255 140H145C155 81 178.6 40 200 40zM275.2 140C268.8 100.2 256.6 66.8 240.8 45.4C264.744 51.804 286.872 63.682 305.442 80.098C324.0100000000001 96.516 338.51 117.022 347.8 140H275.2zM260 300C248 300 240 308 240 320C240 330 248 340 260 340H300V380C300 392 308 400 320 400C330 400 340 392 340 380V340H380C390 340 400 332 400 320C400 308 390 300 380 300H340V260C340 248 330 240 320 240C308 240 300 248 300 260V300H260z" : "M133.8508 220C136.1872 214.2992 139.6282 208.9454 144.2868 204.2868C145.8516 202.722 147.495 201.2944 149.2036 200H122.4C121 187.8 120 174.6 120 160C120 145.4 121 132.2 122.4 120H197.6C198.6544 129.1876 199.4818 138.942 199.8262 149.4346C201.166 147.643 202.652 145.9222 204.286 144.2868C208.7 139.8726 213.74 136.5516 219.106 134.2278C218.76 129.36 218.322 124.6244 217.8 120H273C276.174 129.0898 278.4120000000001 138.596 279.412 148.4436C286.704 157.6728 290 168.9094 290 180V190H300C305.614 190 311.266 190.8448 316.674 192.6246C318.854 182.0924 320 171.1806 320 160C320 71.6 248.4 0 160 0C71.6 0 0 71.6 0 160C0 248.4 71.6 320 160 320C171.1806 320 182.0924 318.854606 192.6246 316.67478C190.8448 311.2653 190 305.61396 190 300V290H180C149.5156 290 130 264.5854 130 240C130 239.6772 130.0028 239.354 130.0084 239.031C128.2894 233.2356 126.7398 226.88 125.4 220H133.8508zM105.4 220C109.4 242.2 115.6 260.6 123.6 273.8C95 264.6 71.4 245.2 56.6 220H105.4zM47 200C42.6 187.4 40 174 40 160C40 146 42.6 132.6 47 120H102.2C100.8 132.4 100 145.6 100 160C100 174.4 100.8 187.6 102.2 200H47zM105.4 100H56.6C71.4 74.8 95 55.4 123.6 46.2C115.6 59.4 109.6 77.8 105.4 100zM125.4 100C132.8 62 146.6 40 160 40C173.4 40 187.2 62 194.6 100H125.4zM214.6 100C210.4 77.8 204.4 59.4 196.4 46.2C225 55.4 248.6 74.8 263.4 100H214.6zM180 220C168 220 160 228 160 240C160 250 168 260 180 260H220V300C220 312 228 320 240 320C252 320 260 312 260 300V260H300C312 260 320 252 320 240C320 228 312 220 300 220H260V180C260 168 252 160 240 160C228 160 220 168 220 180V220H180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GlobeNetworkAdd.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GlobeNetworkAdd.displayName = "Blueprint5.Icon.GlobeNetworkAdd";
exports.default = GlobeNetworkAdd;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8UB2d":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobeNetwork", ()=>GlobeNetwork);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GlobeNetwork = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "globe-network",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0C310.4 0 400 89.6 400 200C400 310.4 310.4 400 200 400zM347.8 260L275.2 260C269 299.8 256.8 333.2 240.8 354.6C289.8 341.6 329 306.2 347.8 260zM260 200C260 186.2 259.2000000000001 172.8 257.8 160L142.2 160C140.8 172.8 140 186.2 140 200C140 213.8 140.8 227.2 142.2 240L257.6 240C259.2000000000001 227.2 260 213.8 260 200zM200 360C221.4 360 245 319 255 260L145 260C155 319 178.6 360 200 360zM159.2 354.6C143.2 333.2 131 299.8 124.8 260L52.2 260C71 306.2 110.2 341.6 159.2 354.6zM40 200C40 213.8 42.2 227.2 45.6 240L122.2 240C120.8 227.2 120 213.8 120 200C120 186.2 120.8 172.8 122.2 160L45.6 160C42.2 172.8 40 186.2 40 200zM52.2 140L124.8 140C131 100.2 143.2 66.8 159.2 45.4C110.2 58.4 71 93.8 52.2 140zM200 40C178.6 40 155 81 145 140L255 140C245 81 221.4 40 200 40zM240.8 45.4C256.6 66.8 268.8 100.2 275.2 140L347.8 140C329 93.8 289.8 58.4 240.8 45.4zM277.8 160C279.2000000000001 172.8 280 186.2 280 200C280 213.8 279.2000000000001 227.2 277.8 240L354.4 240C357.8 227.2 360 213.8 360 200C360 186.2 357.8 172.8 354.4 160L277.8 160z" : "M160 320C71.6 320 0 248.4 0 160C0 71.6 71.6 0 160 0C248.4 0 320 71.6 320 160C320 248.4 248.4 320 160 320zM263.4 220L214.6 220C210.4 242.2 204.4 260.6 196.4 273.8C225 264.6 248.6 245.2 263.4 220zM200 160C200 145.4 199 132.2 197.6 120L122.4 120C121 132.2 120 145.4 120 160C120 174.6 121 187.8 122.4 200L197.6 200C199 187.8 200 174.6 200 160zM160 280C173.4 280 187.2 258 194.6 220L125.4 220C132.8 258 146.6 280 160 280zM123.6 273.8C115.6 260.6 109.4 242.2 105.4 220L56.6 220C71.4 245.2 95 264.6 123.6 273.8zM40 160C40 174 42.6 187.4 47 200L102.2 200C100.8 187.6 100 174.4 100 160C100 145.6 100.8 132.4 102.2 120L47 120C42.6 132.6 40 146 40 160zM56.6 100L105.4 100C109.6 77.8 115.6 59.4 123.6 46.2C95 55.4 71.4 74.8 56.6 100zM160 40C146.6 40 132.8 62 125.4 100L194.6 100C187.2 62 173.4 40 160 40zM196.4 46.2C204.4 59.4 210.4 77.8 214.6 100L263.4 100C248.6 74.8 225 55.4 196.4 46.2zM273 120L217.8 120C219.2 132.4 220 145.6 220 160C220 174.4 219.2 187.6 217.8 200L273 200C277.4 187.4 280 174 280 160C280 146 277.4 132.6 273 120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GlobeNetwork.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GlobeNetwork.displayName = "Blueprint5.Icon.GlobeNetwork";
exports.default = GlobeNetwork;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Vr10":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Globe", ()=>Globe);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Globe = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "globe",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M150.6 312.6C152.6 314.6 152.6 317.8 150.6 319.6L137 333.2C135 335.2 132 335.2 130 333.2C128 331.2 128 328 130 326.2L143.6 312.6C145.6 310.6 148.6 310.6 150.6 312.6zM214 311.4H220C221.8 311.4 223.2 311.6 223.2 313.4C223.2 315.2 221.8 315.4 220 315.4H214C212.2 315.4 210.8 315.2 210.8 313.4S212.2 311.4 214 311.4zM233.6 288.4C235.4 288.4 237.4 290 237.4 291.8V300.2C237.4 302 235.4 303.6 233.6 303.6C231.8 303.6 229.8 302 229.8 300.2V291.8C229.8 290 231.8 288.4 233.6 288.4zM103.6 204.6C96.6 204.6 92.4 199 92.4 192V144.6C92.4 137.6 96.6 132.2000000000001 103.6 132.2000000000001H111.4V84.2000000000001C111.4 77.4 118 72 124.8 72C131.6 72 138.2 77.4 138.2 84.2000000000001V113H137.8C144.8 113 149.8 116.8 149.8 123.8V132H153.4C160.4 132 165 137.6 165 144.4V160.6C165 160.8 165.2 160.8 165 161L122 204.6H103.6zM200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 40C111.6 40 40 111.6 40 200C40 214.8 42.2 229.2 46 242.8H46.6V229.8C46.6 224.2 51.6 219.8 57.2 219.8C58.2 219.8 59.2 220 60.2 220.2L81.2 199.2C83.2 197 86.8 197 88.8 199.2C90.8 201.2 91 204.6 88.8 206.8L68.4 228.2C68.4 228.8 69.4 229.2 69.4 229.8V233C69.4 237.4000000000001 71.8 239.0000000000001 76.2 242.8H88.8C91.2 242.8 93.4 243 95.2 244.2C95.4 244.4 95.6 244.2 95.8 244.4C96.2 244.8 96.6 245.0000000000001 97 245.2C97.2 245.4 97.4 245.4 97.6 245.6L98 246L141 289C145.8 293.8 145.8 301.6 141 306.2C136.4 311 128.6 310 123.8 305.4L115.6 296.2H100V309C100 309.2 101.4 307.6 101.4 311.4H118.8C122.2 311.4 124.8 313.8 124.8 317.2C124.8 320.6 122.2 323 118.8 323H97.6C125.4 346 161 360 200 360S274.6 346 302.4000000000001 322.8H270.8C270.8 322.8 270.6 323.6 270.6 323.6C269.4000000000001 323.6 268.2000000000001 323.6 267.2000000000001 322.8L253.0000000000001 308.8C251.2000000000001 307 251.2000000000001 304.2 253.0000000000001 302.6C254.8000000000001 300.8 257.6 300.8 259.4000000000001 302.6L270.6000000000001 314.6C270.6000000000001 314.6 270.8000000000001 315.2 270.8000000000001 315.2H277.6C277.6 311.4 275.6000000000001 312.6 275.6000000000001 312V310C275.6000000000001 304.2 271.6000000000001 300 265.8000000000001 300H255.6000000000001C250.6000000000001 300 245.2000000000001 294.4 245.2000000000001 289.2V284.6H242.8000000000001C239.6000000000001 284.6 237.4000000000001 283 237.4000000000001 279.8C237.4000000000001 278.2 237.4000000000001 273.2 237.4000000000001 273.2H231.0000000000001C226.4000000000001 273.2 222.8000000000001 270.2 222.8000000000001 265.6C222.8000000000001 261.2 226.4000000000001 258.6 231.0000000000001 258.6C233.0000000000001 258.6 234.8000000000001 257.8 236.2000000000001 261.8H236.2000000000001L237.4000000000001 261.6L250.6000000000001 273.4H255.2000000000001L265.8000000000001 263.4C266.6000000000001 262.6 268.0000000000001 262.8 269.0000000000001 263.6C269.8000000000001 264.4 269.8000000000001 266.8 269.0000000000001 267.6L260 277H266.4L268.8 273.8C273.8 268.8 281.8 269.2 286.6 274.2L289 277H300C300.4 277 302.2 275.6 302.2 275.6V269C302.2 269 301 269.2 300.8 269.2H291C287.8 269.2 285.4 266.6 285.4 263.4C285.4 260.2 288 257.6 291 257.6H300.8C301 257.6 302.2 257.8 302.2 257.8V253.8C298.4 248.2 295.6 242.4 289.8 242.4H264.2000000000001C264.2000000000001 242.4 264.2000000000001 242.6 264 242.6L252.4000000000001 254.2C247.4000000000001 259.2 239.6 259.2 234.6 254.2L223 242.6C223 242.6 223 242.4 222.8 242.4H216C209 242.4 202.6 236.8 202.6 229.8V204.7999999999999C202.6 197.8 209 192.5999999999999 216 192.5999999999999H240.4000000000001C249.6000000000001 188.8 256 183 259.8000000000001 173.8V128.2C259.8000000000001 121.2 264.4000000000001 116.2 271.4000000000001 116.2H291.0000000000001C298.0000000000001 116.2 301.8000000000001 121.2 301.8000000000001 128.2V172.2L326.0000000000001 195.6L326.8000000000001 196L327.2000000000001 196.2L328.0000000000001 196.2C330.0000000000001 198.4 332 201.4 332 204.6V230.2C332 235.2 327.6 239 323.6 242.8H335.2C335.6 235.2 341 231.4 347.8 231.4H356.3999999999999C359 221.2 360 210.8 360 200C360 111.6 288.4 40 200 40zM323.2 153C320.4 153 317.4000000000001 150.8 317.4000000000001 148V132.6C317.4000000000001 129.8 320.4 127.6 323.2 127.6C326 127.6 329 129.8 329 132.6V148C329 150.8 326 153 323.2 153zM210 330.4C210 337.2 204.4 341.8 197.6 341.8H182.8C176 341.8 171.4 336.8 171.4 330C171.4 329 168.8 328.8 172.6 328V315.2C172.6 311.2 174.4 308 178.4 308C182.4 308 184.2 311.2 184.2 315.2V319H197.8C204.4 319 210 323.6 210 330.4z" : "M89 163.4C83.8 163.4 80.8 159.2 80.8 154.2V119.2C80.8 114 84 110 89 110H94.8V74.6C94.8 69.6 99.6 65.6 104.6 65.6C109.6 65.6 114.4 69.6 114.4 74.6V96H114.2C119.4 96 123 98.8 123 104V110H125.8C131 110 134.4 114 134.4 119.2000000000001V131C134.4 131 134.6 131.2 134.4 131.2L102.8 163.2H89zM170.2 242H174.6C175.8 242 177 242.2 177 243.4C177 244.6 176 244.8 174.6 244.8H170.2C169 244.8 167.8 244.6 167.8 243.4C168 242.2 169 242 170.2 242zM123.6 243C125 244.4 125 246.8 123.6 248.2L113.6 258.2C112.2 259.6 109.8 259.6 108.4 258.2C107 256.8 107 254.4 108.4 253L118.4 243C119.8 241.6 122.2 241.6 123.6 243zM184.8 225.2C186.2 225.2 187.6 226.4 187.6 227.6V233.8C187.6 235.2 186.2 236.2 184.8 236.2C183.4 236.2 182 235 182 233.8V227.6C182 226.2 183.4 225.2 184.8 225.2zM160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM160 40C93.8 40 40 93.8 40 160C40 171 42 181.4 44.6 191.4C44.8 191.4 45 191.4 45.2 191.4H46.8V182C46.8 178 50.4 174.6 54.6 174.6C55.2 174.6 56.2 174.8 56.8 175L72.4 159.6C74 158 76.4 158 78 159.6C79.6 161.2 79.6 163.6 78 165.2L63 180.8C63 181.2 63.8 181.6 63.8 182V184.4C63.8 187.6 65.6 188.8 68.8 191.6H78C79.8 191.6 81.4 191.8 82.8 192.6C83 192.6 83.2 192.6 83.2 192.6C83.6 192.8 83.8 193 84.2 193.2C84.4 193.4 84.4 193.4 84.6 193.4L85 193.8L116.8 225.4C120.4 229 120.4 234.6 116.8 238.2C113.2 241.8 107.4 241.2 103.8 237.6L97.8 230.8H86.4V240.4C86.4 240.6 87.4 239.4 87.4 242.2H100.2C102.6 242.2 104.6 244 104.6 246.4S102.6 250.6 100.2 250.6H82C85.6 253.6 88.8 256.8 92.8 259.4C92.8 259.4 93 259.6 93 259.6C97.2 262.4 102 264.6 106.6 267C109.6 268.4 112.4 270 115.4 271.2C118.8 272.6 122.4 273.4 126 274.6C129.6 275.6 133 277 136.6 277.8C144.2 279.2 152 280 160 280C176.4 280 191.8 276.6 206 270.8C207 270.4 208 269.8 209.2 269.2C214.2 267 218.8 264.4 223.4 261.4C228.4000000000001 258.2 233.2000000000001 254.6 237.6000000000001 250.4H212.0000000000001C212.0000000000001 250.4 212.0000000000001 251 211.8000000000001 251C211.0000000000001 251 210.0000000000001 251 209.2000000000001 250.4L199 240.2C197.8 239 197.8 236.8 199 235.6C200.2 234.4 202.4 234.4 203.6 235.6L212 244.4C212 244.4 212.2 244.8 212.2 244.8H217.2C217.2 242 215.8 243 215.8 242.4V241C215.8 236.6 212.8 233.6 208.6 233.6H201C197.2 233.6 193.4 229.4 193.4 225.6V222.2H191.4C189 222.2 187.4 221 187.4 218.6C187.4 217.4 187.4 213.6 187.4 213.6H182.8C179.4 213.6 176.8 211.4 176.8 208C176.8 204.6 179.4 202.8 182.8 202.8C184.2 202.8 185.6 202.2 186.6 205H186.6L187.4 204.8L197.2 214H200.6L208.4 206.6C209 206 210 206.2 210.8 206.8C211.4 207.4 211.4 209.2 210.8 209.8L204.4 216.8H209L210.8 214.4C214.4 210.8 220.4 211 224 214.6L225.8 216.6H233.8C234.2 216.6 235.4 215.6 235.4 215.6V210.8C235.4 210.8 234.4 211 234.4 211H227.2C225 211 223 209 223 206.8C223 204.6 224.8 202.6 227.2 202.6H234.4C234.4 202.6 235.4 202.6 235.4 202.6V199.6C232.6 195.4 230.6 191.2 226.4 191.2H207.6C207.6 191.2 207.6 191.2 207.6 191.4L198.8 200.2C195.2 203.8 189.2 203.8 185.6 200.2L177.2 191.6C177.2 191.6 177.2 191.4 177.2 191.4H172C166.8 191.4 162.2 187.2 162.2 182.2V163.8C162.2 158.6 166.8 154.8 172 154.8H190C196.8 152 201.4 147.8 204.4 141V107.4C204.4 102.2 207.8 98.6 212.8 98.6H227.2C232.4000000000001 98.6 235.2000000000001 102.2 235.2000000000001 107.4V140L253.0000000000001 157.2L253.6 157.6L254.0000000000001 157.8L254.6 157.8C256 159.4 257.6 161.6 257.6 164V182.2C257.6 185.8 254.4 188.6 251.4 191.4H260C260.2 185.8 264.2000000000001 183 269.2000000000001 183H277.6C279.2000000000001 175.6 280 167.8 280 160C280 93.8 226.2 40 160 40zM250.8 125.4C248.8 125.4 246.6 123.8 246.6 121.8V110.4C246.6 108.4 248.8 106.8 250.8 106.8C252.8 106.8 255 108.4 255 110.4V121.8C255 123.8 252.8 125.4 250.8 125.4zM167.4 256.2C167.4 261.2 163.4 264.6 158.2 264.6H147.4C142.4 264.6 139 261 139 256C139 255.4 137 255.2 140 254.4V245C140 242 141.2 239.6 144.2 239.6C147.2 239.6 148.4 242 148.4 245V247.8H158.4C163.2 247.8 167.4 251 167.4 256.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Globe.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Globe.displayName = "Blueprint5.Icon.Globe";
exports.default = Globe;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hmowO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphRemove", ()=>GraphRemove);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GraphRemove = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "graph-remove",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M348.2 320L394 365.8C397.8 369.4 400 374.4 400 380C400 391 391 400 380 400C374.4 400 369.4 397.8 365.8 394.2L320 348.2L274.2000000000001 394C270.6 397.8 265.6 400 260 400C249 400 240 391 240 380C240 374.4 242.2 369.4 245.8 365.8L291.8 320L246 274.2C242.2 270.6 240 265.6 240 260C240 249 249 240 260 240C265.6 240 270.6 242.2 274.2000000000001 245.8L320 291.8L365.8 246C369.4 242.2 374.4 240 380 240C391 240 400 249 400 260C400 265.6 397.8 270.6 394.2000000000001 274.2L348.2 320zM380 200C363.4000000000001 200 349 207.2 338.2 218.2L337.6 217.6L320 235.2L302.4 217.6C291.6 206.8 276.6 200 260 200C226.8 200 200 226.8 200 260C200 276.6 206.8 291.6 217.6 302.4L235.2 320L217.6 337.6L218.2 338.2C207.2 349 200 363.4 200 380C200 387 201.4 393.6 203.6 399.8C202.4 399.8 201.2 400 200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 201.2 399.8 202.4 399.8 203.6C393.6 201.4 387 200 380 200z" : "M257.8 157.8L257.6 157.6L250 165.2L242.4 157.6L242 158C231.2 147 216.6 140 200 140C166.8 140 140 166.8 140 200C140 216.6 147 231.2 158 242L157.6 242.4L165.2 250L157.6 257.6L157.8 257.8C147 268.6 140 283.4 140 300C140 306.8 141.4 313 143.4 319.2C62.8 310.8 0 242.8 0 160C0 71.6 71.6 0 160 0C242.8 0 310.8 62.8 319.2000000000001 143.4C313 141.4 306.8 140 300 140C283.4 140 268.6 147 257.8 157.8zM278.2 250L314 285.8C317.8 289.4 320 294.4 320 300C320 311 311 320 300 320C294.4000000000001 320 289.4000000000001 317.8 285.8 314.2L250 278.2L214.2 314C210.6 317.8 205.6 320 200 320C189 320 180 311 180 300C180 294.4 182.2 289.4 185.8 285.8L221.6 250L185.8 214.2C182.2 210.6 180 205.6 180 200C180 189 189 180 200 180C205.6 180 210.6 182.2 214.2 185.8L250 221.6L285.8 185.8C289.4000000000001 182.2 294.4000000000001 180 300 180C311 180 320 189 320 200C320 205.6 317.8 210.6 314.2000000000001 214.2L278.2 250z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GraphRemove.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GraphRemove.displayName = "Blueprint5.Icon.GraphRemove";
exports.default = GraphRemove;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2FiUY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Graph", ()=>Graph);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Graph = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "graph",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M350 320C322.4000000000001 320 300 297.6 300 270C300 268.8 300.2 267.6 300.4 266.4L262.4 249.6C247.6 268 225.4 280 200 280C183.4 280 168.2 275 155.4 266.4L98.2 317.2C99.2 321.4 100 325.6 100 330C100 357.6 77.6 380 50 380S0 357.6 0 330C0 302.4 22.4 280 50 280C58.4 280 66.2 282.2 73.2 286L129 236.4C123.4 225.4 120 213.2 120 200C120 171.8 134.6 147.2 156.6 133L145.4 99.6C120 97.2 100 76 100 50C100 22.4 122.4 0 150 0S200 22.4 200 50C200 64.8 193.6 77.8 183.4 87L194.6 120.6C196.4 120.4 198.2 120 200 120C244.2 120 280 155.8 280 200C280 204.4 279.4000000000001 208.8 278.6 213L319 231C327.6 224.2 338.2 220 350 220C377.6 220 400 242.4 400 270C400 297.6 377.6 320 350 320z" : "M280 260C258.8 260 241.6 243.4 240.2 222.4L201.6 203C190.8 213.6 176.2 220 160 220C148.8 220 138.4 216.8 129.6 211.4L79.4 253.2C79.6 255.4 80 257.6 80 260C80 282 62 300 40 300S0 282 0 260C0 238 18 220 40 220C44.8 220 49.4 221 53.6 222.6L103.8 180.8C101.6 174.2 100 167.4 100 160C100 140.8 109.2 123.8 123.2 113L112 79.2C93.8 75.4 80 59.4 80 40C80 18 98 0 120 0S160 18 160 40C160 50.2 156 59.4 149.8 66.4L161 100.2C193.8 100.8 220 127.2 220 160C220 162.4 219.6 164.8 219.2 167.2L258 186.6C264.4000000000001 182.4 271.8 180 280 180C302 180 320 198 320 220C320 242 302 260 280 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Graph.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Graph.displayName = "Blueprint5.Icon.Graph";
exports.default = Graph;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b7NLT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GreaterThanOrEqualTo", ()=>GreaterThanOrEqualTo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GreaterThanOrEqualTo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "greater-than-or-equal-to",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M73.67545072 178.97366C63.19658438 175.4807044 57.53338464 164.154305 61.026340088 153.6754386C64.51929554 143.1965722 75.84569502 137.533372 86.3245614 141.026328L326.324562 221.026328C344.558488 227.1043034 344.558488 252.8956844 326.324562 258.97366L86.3245614 338.973659912C75.84569502 342.46661536 64.51929554 336.80341562 61.026340088 326.32454928C57.53338464 315.845683 63.19658438 304.5192834 73.67545072 301.0263280000001L256.7544528 239.999994L73.67545072 178.97366zM80.000006 99.999994L320.000006 99.999994C331.045702 99.999994 340.000006 91.045688 340.000006 79.999994L340.000006 79.999994C340.000006 68.954298 331.045702 59.999994 320.000006 59.999994L80.000006 59.999994C68.95431106 59.999994 60.00000604954 68.954298 60.00000604954 79.999994L60.00000604954 79.999994C60.00000604954 91.045688 68.95431106 99.999994 80.000006 99.999994z" : "M54.2530422 240.8434742C43.6731852 244.0174314 37.6695172 255.1671008 40.8434742 265.7469578C44.0174314 276.3268148 55.1671008 282.3304828000001 65.7469578 279.1565258L265.746958 219.1565258C284.751014 213.4553088 284.751014 186.5446912 265.746958 180.8434742L65.7469578 120.8434742C55.1671008 117.669518 44.0174314 123.6731852 40.8434742 134.2530422C37.6695172 144.8328992 43.6731852 155.9825686 54.2530422 159.1565258L190.3979566 200L54.2530422 240.8434742zM60 80L260 80C271.045694 80 280 71.045694 280 60C280 48.954306 271.045694 40 260 40L60 40C48.954305 40 40 48.954306 40 60C40 71.045694 48.954305 80 60 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GreaterThanOrEqualTo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GreaterThanOrEqualTo.displayName = "Blueprint5.Icon.GreaterThanOrEqualTo";
exports.default = GreaterThanOrEqualTo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hPYa5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GreaterThan", ()=>GreaterThan);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GreaterThan = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "greater-than",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M256.754446 200L73.6754446 138.973666C63.1965784 135.48071 57.5333786 124.154312 61.026334 113.675444C64.5192894 103.1965780000001 75.845689 97.533378 86.3245554 101.026334L326.3245560000001 181.026334C344.558482 187.10431 344.558482 212.8956906 326.3245560000001 218.973666L86.3245554 298.973666C75.845689 302.4666214 64.5192894 296.8034216 61.026334 286.3245554C57.5333786 275.845689 63.1965784 264.5192894 73.6754446 261.026334L256.754446 200z" : "M54.2530422 200.8434742C43.6731852 204.0174314 37.6695172 215.1671008 40.8434742 225.7469578C44.0174314 236.3268148 55.1671008 242.3304828 65.7469578 239.1565258L265.746958 179.1565258C284.751014 173.4553088 284.751014 146.5446912 265.746958 140.8434742L65.7469578 80.843474C55.1671008 77.669518 44.0174314 83.673186 40.8434742 94.253042C37.6695172 104.8329 43.6731852 115.982568 54.2530422 119.156526L190.3979566 160L54.2530422 200.8434742z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GreaterThan.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GreaterThan.displayName = "Blueprint5.Icon.GreaterThan";
exports.default = GreaterThan;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gB9IR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridView", ()=>GridView);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GridView = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "grid-view",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 20C0 9 9 0 20 0H180V180H0V20zM0 380V220H180V400H20C9 400 0 391 0 380zM380 400H220V220H400V380C400 391 391 400 380 400zM220 0H380C391 0 400 9 400 20V180H220V0z" : "M0 300V180H140V320H20C9 320 0 311 0 300zM0 20C0 9 9 0 20 0H140V140H0V20zM300 320H180V180H320V300C320 311 311 320 300 320zM180 0H300C311 0 320 9 320 20V140H180V0z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GridView.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GridView.displayName = "Blueprint5.Icon.GridView";
exports.default = GridView;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eDyA8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Grid", ()=>Grid);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Grid = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "grid",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 180C391 180 400 189 400 200C400 211 391 220 380 220H340V300H380C391 300 400 309 400 320C400 331 391 340 380 340H340V380C340 391 331 400 320 400S300 391 300 380V340H220V380C220 391 211 400 200 400S180 391 180 380V340H100V380C100 391 91 400 80 400S60 391 60 380V340H20C9 340 0 331 0 320C0 309 9 300 20 300H60V220H20C9 220 0 211 0 200C0 189 9 180 20 180H60V100H20C9 100 0 91 0 80C0 69 9 60 20 60H60V20C60 9 69 0 80 0S100 9 100 20V60H180V20C180 9 189 0 200 0S220 9 220 20V60H300V20C300 9 309 0 320 0S340 9 340 20V60H380C391 60 400 69 400 80C400 91 391 100 380 100H340V180H380zM180 100H100V180H180V100zM180 220H100V300H180V220zM300 100H220V180H300V100zM300 220H220V300H300V220z" : "M300 140C311 140 320 149 320 160C320 171 311 180 300 180H280V240H300C311 240 320 249 320 260C320 271 311 280 300 280H280V300C280 311 271 320 260 320S240 311 240 300V280H180V300C180 311 171 320 160 320S140 311 140 300V280H80V300C80 311 71 320 60 320S40 311 40 300V280H20C9 280 0 271 0 260C0 249 9 240 20 240H40V180H20C9 180 0 171 0 160C0 149 9 140 20 140H40V80H20C9 80 0 71 0 60C0 49 9 40 20 40H40V20C40 9 49 0 60 0S80 9 80 20V40H140V20C140 9 149 0 160 0S180 9 180 20V40H240V20C240 9 249 0 260 0S280 9 280 20V40H300C311 40 320 49 320 60C320 71 311 80 300 80H280V140H300zM140 80H80V140H140V80zM140 180H80V240H140V180zM240 80H180V140H240V80zM240 180H180V240H240V180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Grid.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Grid.displayName = "Blueprint5.Icon.Grid";
exports.default = Grid;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cec7v":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupItem", ()=>GroupItem);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GroupItem = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "group-item",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M315.144 385.9439C307.332 393.7543800000001 294.67 393.7543800000001 286.858 385.9439L216.148 315.2332C208.338 307.4228 208.338 294.7594000000001 216.148 286.949L286.858 216.2382C294.67 208.4278 307.332 208.4278 315.144 216.2382L385.854 286.949C393.664 294.7594000000001 393.664 307.4228 385.854 315.2332L315.144 385.9439zM19.99512 360.086C19.99512 371.1318 28.9494 380.08602 39.9952 380.08602H159.9952C171.0408 380.08602 179.9952 371.1318 179.9952 360.086V240.086C179.9952 229.0404 171.0408 220.086 159.9952 220.086H39.9952C28.9494 220.086 19.99512 229.0404 19.99512 240.086V360.086zM59.9952 260.086V340.086H139.9952V260.086H59.9952zM39.9952 180.086C28.9494 180.086 19.99512 171.132 19.99512 160.086V40.086C19.99512 29.04 28.9494 20.086 39.9952 20.086H159.9952C171.0408 20.086 179.9952 29.04 179.9952 40.086V160.086C179.9952 171.132 171.0408 180.086 159.9952 180.086H39.9952zM59.9952 140.086V60.086H139.9952V140.086H59.9952zM219.996 160.086C219.996 171.132 228.95 180.086 239.996 180.086H359.996C371.04 180.086 379.996 171.132 379.996 160.086V40.086C379.996 29.04 371.04 20.086 359.996 20.086H239.996C228.95 20.086 219.996 29.04 219.996 40.086V160.086zM259.996 60.086V140.086H339.996V60.086H259.996z" : "M172.0396 257.5728000000001C164.2292 249.7622 164.2292 237.0988 172.0396 229.2884L228.608 172.7198C236.418 164.9094 249.082 164.9094 256.892 172.7198L313.462 229.2884C321.2720000000001 237.0988 321.2720000000001 249.7622 313.462 257.5728000000001L256.892 314.14122C249.082 321.951706 236.418 321.951706 228.608 314.14122L172.0396 257.5728000000001zM0 299.903C0 310.94872 8.9543 319.903028 20 319.903028H120C131.0456 319.903028 140 310.94872 140 299.903V199.903C140 188.8574 131.0456 179.903 120 179.903H20C8.9543 179.903 0 188.8574 0 199.903V299.903zM40 219.903V279.903H100V219.903H40zM200 139.903C188.9544 139.903 180 130.9488 180 119.904V19.904C180 8.858 188.9542 -0.096 200 -0.096H300C311.046 -0.096 320 8.858 320 19.904V119.904C320 130.9488 311.046 139.903 300 139.903H200zM220 99.904V39.904H280V99.904H220zM0 119.904C0 130.9488 8.9543 139.903 20 139.903H120C131.0456 139.903 140 130.9488 140 119.904V19.904C140 8.858 131.0456 -0.096 120 -0.096H20C8.9543 -0.096 0 8.858 0 19.904V119.904zM40 39.904V99.904H100V39.904H40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GroupItem.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GroupItem.displayName = "Blueprint5.Icon.GroupItem";
exports.default = GroupItem;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dnxkb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupObjects", ()=>GroupObjects);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GroupObjects = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "group-objects",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 260C86.8 260 60 233.2 60 200S86.8 140 120 140S180 166.8 180 200S153.2 260 120 260zM280 320H120C53.8 320 0 266.2000000000001 0 200C0 133.8 53.8 80 120 80H280C346.2 80 400 133.8 400 200C400 266.2 346.2 320 280 320zM280 100H120C64.8 100 20 144.8 20 200S64.8 300 120 300H280C335.2 300 380 255.2 380 200S335.2000000000001 100 280 100zM280 260C246.8 260 220 233.2 220 200S246.8 140 280 140S340 166.8 340 200S313.2 260 280 260z" : "M100 200C78 200 60 182 60 160C60 138 78 120 100 120S140 138 140 160C140 182 122 200 100 200zM220 260H100C44.8 260 0 215.2 0 160S44.8 60 100 60H220C275.2 60 320 104.8 320 160S275.2 260 220 260zM220 80H100C55.8 80 20 115.8 20 160C20 204.2 55.8 240 100 240H220C264.2000000000001 240 300 204.2 300 160C300 115.8 264.2000000000001 80 220 80zM220 200C198 200 180 182 180 160C180 138 198 120 220 120S260 138 260 160C260 182 242 200 220 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GroupObjects.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GroupObjects.displayName = "Blueprint5.Icon.GroupObjects";
exports.default = GroupObjects;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a9ore":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupedBarChart", ()=>GroupedBarChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var GroupedBarChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "grouped-bar-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 80H260C271 80 280 89 280 100V300C280 311 271 320 260 320H240C229 320 220 311 220 300V100C220 89 229 80 240 80zM380 60H20C9 60 0 51 0 40C0 29 9 20 20 20H380C391 20 400 29 400 40C400 51 391 60 380 60zM320 80H340C351 80 360 89 360 100V240C360 251 351 260 340 260H320C309 260 300 251 300 240V100C300 89 309 80 320 80zM140 80H160C171 80 180 89 180 100V200C180 211 171 220 160 220H140C129 220 120 211 120 200V100C120 89 129 80 140 80zM60 80H80C91 80 100 89 100 100V360C100 371 91 380 80 380H60C49 380 40 371 40 360V100C40 89 49 80 60 80z" : "M200 80C211 80 220 89 220 100V260C220 271 211 280 200 280S180 271 180 260V100C180 89 189 80 200 80zM260 80C271 80 280 89 280 100V200C280 211 271 220 260 220S240 211 240 200V100C240 89 249 80 260 80zM300 60H20C9 60 0 51 0 40S9 20 20 20H300C311 20 320 29 320 40S311 60 300 60zM120 80C131 80 140 89 140 100V160C140 171 131 180 120 180S100 171 100 160V100C100 89 109 80 120 80zM60 80C71 80 80 89 80 100V280C80 291 71 300 60 300S40 291 40 280V100C40 89 49 80 60 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
GroupedBarChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
GroupedBarChart.displayName = "Blueprint5.Icon.GroupedBarChart";
exports.default = GroupedBarChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3sLYI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HandDown", ()=>HandDown);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HandDown = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "hand-down",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M353.6 203.2C318.2 220 285.4 270.2 269 302C248.2 351.4 244.2 400 157.4 400C109.8 400 79 384.8 61 347C46.2 316 40 290.4 40 204.2V184.4C40 168 53.8 154.8 70.8 154.8C78.4 154.8 85.4 157.6 90.8 162C94.6 150 106.4 141 120.2 141C129.6 141 138 145 143.6 151.4C148.8 142 159 135.6 170.8 135.6C183.8 135.6 194.8 143.4 199.4 154.1999999999999L200 138.8V30C200 20.4 204.6 11.8 211.8 6.4C216 2.6 221.8 0 228.8 0C229 0 229.2 0 229.4 0C229.6 0 229.8 0 230 0C246.6 0 260 13.4 260 30V194.8L260.2 208.2C277.2 188.6 298.6 173 325 170.4C360.8 166.6 366.8 197 353.6 203.2z" : "M294.4000000000001 162.6C263.6 176 234.6 216.2 220.4 241.6C202.2 281 198.6 320 122.8 320C81 320 54.2 307.8 38.4 277.6C25.4 252.8 20 215.8 20 163.4V147.6C20 134.6 32 124 47 124C53.8 124 59.8 126.2 64.6 129.8C68 120.2 78.2 113 90.4 113C98.6 113 106 116.2 111 121.4C115.6 114 124.4 108.8 134.8 108.8C146.2 108.8 155.8 115 159.8 123.6L160 111V30C160 13.4 173.4 0 190 0C206.6 0 220 13.4 220 30V162C231.6 153.8 251 137.8 269.4000000000001 136.2C300.8 133.4 305.8 157.6 294.4000000000001 162.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HandDown.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HandDown.displayName = "Blueprint5.Icon.HandDown";
exports.default = HandDown;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7B7yQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HandLeft", ()=>HandLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HandLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "hand-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M302 269.2C270.4 285.4 220.2 318.4 203.2 353.8C197 366.8 166.8 360.8 170.4 325.2C173 298.6 188.6 277.2 208.2 260.4L194.8 260H30C13.4 260 0 246.6 0 230C0 229.8 0 229.6 0 229.4C0 229.2 0 229.0000000000001 0 228.8C0 221.6 2.6 216 6.4 211.8C11.8 204.6 20.4 200 30 200H138.8L154.4 199.8C143.6 195.2 135.8 184.2 135.8 171.2C135.8 159.4 142.2 149.2 151.6 144C145.2 138.4 141.2 130.0000000000001 141.2 120.6C141.2 106.8 150 95.0000000000001 162.2 91.2C157.8000000000001 85.8 155 78.8 155 71.2000000000001C155 54.2 168.2 40.4000000000001 184.6 40.4000000000001H204.4C290.6 40.4000000000001 316.2 46.6 347.2 61.4000000000001C385 79.4 400.2 110.2000000000001 400.2 157.8000000000001C400 244.2 351.4 248.2 302 269.2z" : "M241.6 220.6C216.4 234.8 176.2 263.6 162.6 294.6C157.6 306 133.4 300.8 136.2 269.6C138 251 154 231.6 162.2 220H30C13.4 220 0 206.6 0 190S13.4 160 30 160H111L123.6 159.8C114.8 155.8 108.6 146 108.6 134.8C108.6 124.4 113.8 115.6 121.2 111C116 106 112.8 98.8 112.8 90.4C112.8 78.2000000000001 119.8 68.0000000000001 129.6 64.6C126 59.8 123.8 53.8 123.8 47C123.8 32 134.6 20 147.6 20H163.4C215.8 20 252.8 25.6 277.6 38.4C307.8 54.2 320 81.2 320 122.8C320 198.6 281 202.2 241.6 220.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HandLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HandLeft.displayName = "Blueprint5.Icon.HandLeft";
exports.default = HandLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f0e6d":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HandRight", ()=>HandRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HandRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "hand-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 230C400 246.6 386.6 260 370 260H205.2L191.8 260.2C211.4 277.2 227 298.6 229.6 325C233.2 360.8 203 366.6 196.6 353.6C179.8 318.4 129.6 285.4 98 269C48.6 248.2 0 244.2 0 157.4C0 109.8 15.2 79 53 60.9999999999999C84 46.2 109.6 40 195.8 40H215.6C232 40 245.2 53.8 245.2 70.8C245.2 78.4 242.4 85.4 238 90.8C250 94.6 259 106.4 259 120.2C259 129.6 255.0000000000001 138 248.6 143.6C258.0000000000001 148.8 264.4000000000001 159 264.4000000000001 170.8C264.4000000000001 183.8 256.6 194.8 245.8000000000001 199.4L261.2 200H370C379.6 200 388.2 204.6 393.6 211.8C397.4000000000001 216 400 221.6 400 228.8C400 229 400 229.2 400 229.4C400 229.6 400 229.8 400 230z" : "M290 220H157.8C166 231.6 182 251 183.8 269.4C186.8 300.6 162.4 305.8 157.4 294.4C144 263.6 103.8 234.6 78.4 220.4C39 202.2 0 198.6 0 122.8C0 81 12.2 54.2 42.4 38.4C67.2 25.4 104.2 20 156.6 20H172.4C185.4 20 196 32 196 47C196 53.8 193.8 59.8 190.2000000000001 64.6C199.8000000000001 68 207 78.2 207 90.4C207 98.6 203.8 106 198.6 111C206 115.6 211.2000000000001 124.4 211.2000000000001 134.8C211.2000000000001 146.2 205 155.8 196.4 159.8L209 160H290C306.6 160 320 173.4 320 190S306.6 220 290 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HandRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HandRight.displayName = "Blueprint5.Icon.HandRight";
exports.default = HandRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ik4B9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HandUp", ()=>HandUp);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HandUp = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "hand-up",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M329.2000000000001 245.2C321.6 245.2 314.6 242.4 309.2000000000001 238C305.4000000000001 250 293.6 259 279.8 259C270.4 259 262 255 256.4 248.6C251.2 258 241 264.4 229.2 264.4C216.2 264.4 205.2000000000001 256.6 200.6 245.8L200 261.2V370C200 379.6 195.4 388.2 188.2 393.6C184 397.4 178.4 400 171.2 400C171 400 170.8 400 170.6 400C170.4 400 170.2 400 170 400C153.4 400 140 386.6 140 370V205.2L139.8 191.8C123 211.4 101.4 227 75 229.6C39.2 233.2 33.4 203 46.4 196.6C81.8 179.8 114.6 129.6 131 97.8C152 48.4 156 -0.1999999999999 242.6 -0.1999999999999C290.2000000000001 -0.1999999999999 321 15.0000000000001 339.0000000000001 52.8C353.8 84 360 109.6 360 195.8V215.6C360 231.8 346.2 245.2 329.2000000000001 245.2z" : "M273 196.2C266.2 196.2 260.2 194 255.4 190.4C252 200 241.8 207.2 229.6 207.2C221.4 207.2 214 204 209 198.8C204.4 206.2 195.6 211.4 185.2000000000001 211.4C173.8 211.4 164.2 205.2 160.2000000000001 196.6L160 209V290C160 306.6 146.6 320 130 320S100 306.6 100 290V157.8C88.4 166 69 182 50.4 183.8C19.2 186.6 14 162.4 25.6 157.4C56.4 144 85.4 103.8 99.6 78.4C117.8 39 121.4 0 197.2 0C239 0 265.8 12.2 281.6 42.4C294.4000000000001 67.2 300 104.2 300 156.6V172.4C300 185.4 288 196.2 273 196.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HandUp.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HandUp.displayName = "Blueprint5.Icon.HandUp";
exports.default = HandUp;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fNIb6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hand", ()=>Hand);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Hand = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "hand",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 300C331.6 300 324.2000000000001 294.6 321.4 287.2H321.4L287.6 200H272.2000000000001L299 333.4C299.6 335.4 300 337.6 300 340C300 351 291 360 280 360C270.2 360 262.2 353 260.4 343.8L260.2 343.8L231.4 200H220V380C220 391 211 400 200 400S180 391 180 380V200H176L139.4 344.8L139.4 344.8C137.2 353.6 129.4 360 120 360C114 360 108.4 357.2 104.8 353L104.8 353C104.6 352.8 104.4 352.6 104.2 352.4C104.2 352.4 104.2 352.4 104.2 352.4C104 352 103.8 351.8 103.6 351.6C103.6 351.6 103.6 351.6 103.6 351.6C103.4 351.2 103.4 351 103.2 350.8C103.2 350.8 103.2 350.8 103.2 350.6C103 350.4 102.8 350.2 102.8 350C102.8 350 102.8 349.8 102.8 349.8C102.4 349.6 102.4 349.4 102.2 349.2C102.2 349.2 102.2 349 102 349C102 348.8 102 348.6 101.8 348.4C101.8 348.4 101.8 348.2 101.6 348.2C101.6 348 101.4 347.8 101.4 347.6C101.4 347.6 101.4 347.4000000000001 101.2 347.4000000000001C101.2 347.2000000000001 101 347 101 346.8C101 346.6 101 346.6 100.8 346.4000000000001C100.8 346.2000000000001 100.6 346 100.6 345.8C100.6 345.6 100.6 345.6 100.4 345.4000000000001C100.4 345.2000000000001 100.2 345 100.2 344.8C100.2 344.6 100.2 344.6 100.2 344.4000000000001C100.2 344.2000000000001 100.2 344 100 343.8C100 343.6 100 343.4000000000001 100 343.4000000000001C100 343.2000000000001 100 343 100 343C100 342.8 100 342.6 100 342.4000000000001C100 342.2000000000001 100 342.2000000000001 100 342C100 341.8 100 341.6 100 341.4000000000001C100 341.2000000000001 100 341.2000000000001 100 341C100 340.6 100 340.4 100 340C100 339 100 338.2 100.2 337.2H100.2L129.2 132.2L120 146V145.8L76.8 211L76.6 211C73.2 216.4 67 220 60 220C49 220 40 211 40 200C40 196 41.2 192.2 43.4 189L120 31.2V31.2C141.2 12 169.2 0 200 0C266.2 0 320 53.8 320 120V156.8L320.2000000000001 157.4V158.6L359.0000000000001 273.6C359.6 275.6 360 277.8 360 280C360 291 351 300 340 300z" : "M300 220C300 231 291 240 280 240C271.8 240 264.8 235.2 261.8 228.2L261.8 228C261.8 228 261.8 227.8 261.6 227.8L231.4 160H224.2L239.8 256.8H239.8C240 257.8 240 259 240 260C240 271 231 280 220 280C210 280 201.8 272.8 200.2 263.2H200.2V263.2C200.2 263.2 200.2 263 200.2 263L183.6 160H180V300C180 311 171 320 160 320S140 311 140 300V160H138.2L119.6 263.6L119.6 263.6C118 272.8 109.8 280 100 280C89 280 80 271 80 260C80 259 80 257.8 80.2 256.8L80.2 256.8L105.2 100H104.4L56.6 171.2C53 176.4 47 180 40 180C29 180 20 171 20 160C20 156.6 20.8 153.4 22.4 150.6L82.4 36.8H82.6V36.6C101 14.2 128.8 0 160 0C215.2 0 260 44.8 260 100V111.8L298.6 212.8H298.6C299.6 215 300 217.4 300 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Hand.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Hand.displayName = "Blueprint5.Icon.Hand";
exports.default = Hand;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4FUyo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hat", ()=>Hat);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Hat = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "hat",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M370 140C392.354862 140 399.310486 129.312478 399.9501620000001 112.675622L400 110L400 100C400 61.093998 286.201512 40 200 40C113.7984854 40 -0.0000018482524 61.093998 -0.0000018482524 100L-0.0000018482524 110C-0.0000018482524 128.15787 6.46856372 140 29.9999982 140C47.8956428 140 99.9990908 116 199.9999982 116L208.222814 116.054526C302.868972 117.314814 352.601456 140 370 140zM270 340C304.505576 340 329.089196 285.42924 343.750858 176.28772C314.658946 171.018284 267.661194 161.89494 215.915702 160.255912L207.24975 160.053984L199.9999982 160C142.0778164 160 88.2953406 170.48412 56.2292176 176.27092C70.9112756 285.42924 95.4948382 340 130 340C172 340 166.5721132 290 200 290C233.427884 290 230 340 270 340z" : "M300 120C309.909058 120 318.660478 112.429816 319.860124 102.364698L320 100L320 89.90589C320 60.67968 249.51787 40.914208 165.8574354 40.030874L160 40C73.7984854 40 -0.0000018609992 60 -0.0000018609992 89.90589L-0.0000018609992 100C-0.0000018609992 111.22038 9.32870562 120 19.99999814 120C37.895641 120 79.9992712 100 159.9999982 100L167.62416 100.061092C242.6919 101.26951 282.6816360000001 120 300 120zM219.999998 280C242.592376 280 260.399782 236.9321216 273.422218 150.796365C252.155506 145.472496 220.54205 137.7672422 175.6792504 136.2608346L167.6241582 136.0610922L159.9999982 136C106.715904 136 70.2435724 144.8723222 46.538305 150.7982326C59.5996604 236.9321216 77.4068928 280 99.9992712 280C139.9985444 280 126.5721132 240 159.9999982 240C193.4278832 240 180.000725 280 219.999998 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Hat.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Hat.displayName = "Blueprint5.Icon.Hat";
exports.default = Hat;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kBIrp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderOne", ()=>HeaderOne);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HeaderOne = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "header-one",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 180V80C40 68.954 31.0456 60 20 60C8.9543 60 0 68.954 0 80V180V220V340C0 351.0456 8.9543 360 20 360C31.0456 360 40 351.0456 40 340V220H180V340C180 351.0456 188.9542 360 200 360C211.046 360 220 351.0456 220 340V220V180V80C220 68.954 211.046 60 200 60C188.9542 60 180 68.954 180 80V180H40zM354.8 200C353.8 193.8 351.4 188.6 348 184.6C344.6 180.4 340.4 176.8 335.2000000000001 174.4C330.2000000000001 171.8 324.8 169.8 318.6 168.6C312.6 167.6 306.4 167 300 167V142.2H350V0H380V200H354.8z" : "M281.2 160C280.4 155.4 278.8 151.2 276.2 147.8C273.6 144.4 270.4 141.8 266.6 139.6C263 137.4 258.8 136 254.2 135C249.6 134.2 245 133.6 240 133.6V113H274.8V0H300V160H281.2zM140 280C128.8 280 120 271 120 260V180H40V260C40 271 31 280 20 280C8.8 280 0 271 0 260V60C0 49 9 40 20 40C31.2 40 40 49 40 60V140H120V60C120 49 129 40 140 40C151.2 40 160 49 160 60V260C160 270.8 151 280 140 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HeaderOne.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HeaderOne.displayName = "Blueprint5.Icon.HeaderOne";
exports.default = HeaderOne;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hy5f5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderThree", ()=>HeaderThree);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HeaderThree = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "header-three",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 180V80C40 68.954 31.0456 60 20 60C8.9543 60 0 68.954 0 80V180V220V340C0 351.0456 8.9543 360 20 360C31.0456 360 40 351.0456 40 340V220H180V340C180 351.0456 188.9542 360 200 360C211.046 360 220 351.0456 220 340V220V180V80C220 68.954 211.046 60 200 60C188.9542 60 180 68.954 180 80V180H40zM369.154 107.196C378.906 104.998 386.468 99.602 391.84 90.812C397.2140000000001 82.02 400 71.43 400 58.644C400 49.452 398.408 41.26 395.224 34.068C392.04 26.876 387.662 20.682 382.0900000000001 15.686C376.716 10.692 370.348 6.896 362.986 4.098C355.622 1.3 348.06 -0.098 339.9000000000001 -0.098C329.95 -0.098 321.394 1.5 314.03 4.698C306.666 7.894 300.498 12.49 295.522 18.284C290.548 24.078 286.766 31.27 284.18 39.462C281.592 47.854 280.2 57.046 280 67.036H307.6620000000001C307.264 55.446 309.85 45.6560000000001 315.224 37.864C320.796 30.072 328.756 26.276 339.702 26.276C349.054 26.276 356.8160000000001 29.272 362.986 35.266C369.154 41.26 372.338 49.652 372.338 60.642C372.338 68.0340000000001 370.9460000000001 74.028 368.358 78.424C365.772 82.82 362.388 86.216 358.208 88.414C354.03 90.612 349.254 92.01 344.0800000000001 92.61C338.906 93.21 333.5320000000001 93.408 327.96 93.21V116.586C332.338 116.386 336.916 116.586 341.492 117.584C346.07 118.584 350.05 120.182 353.632 122.38C357.2140000000001 124.578 360 127.774 362.19 131.77C364.3780000000001 135.766 365.374 140.762 365.374 146.556C365.374 154.748 362.986 161.34 358.01 166.336C353.0340000000001 171.33 346.6660000000001 173.728 338.906 173.728C334.13 173.728 329.95 172.53 326.368 170.332C322.786 168.134 319.8 165.138 317.412 161.34C315.024 157.544 313.432 153.348 312.238 148.754C311.2440000000001 144.158 310.646 139.362 310.846 134.368H283.1840000000001C283.384 143.7580000000001 284.976 152.35 287.762 160.342C290.548 168.334 294.328 175.326 299.104 181.122C303.88 187.116 309.652 191.71 316.418 194.908C323.184 198.304 330.9460000000001 199.902 339.502 199.902C346.07 199.902 352.636 198.904 359.004 196.706C365.374 194.508 371.144 191.31 376.318 187.116C381.492 182.92 385.6720000000001 177.724 388.656 171.132C391.642 164.738 393.234 157.146 393.234 148.754C393.234 139.164 391.442 130.572 387.462 123.3780000000001C383.482 116.186 377.512 110.792 369.154 107.594V107.196z" : "M20 280C8.8 280 0 271 0 260V60C0 49.2 9 40 20 40C31.2 40 40 49 40 60V140H120V60C120 49.2 129 40 140 40C151.2 40 160 49 160 60V260C160 270.8 151 280 140 280C128.8 280 120 271 120 260V180H40V260C40 270.8 31 280 20 280zM294.2000000000001 85.414C302.4 83.81 308.6 79.398 313.2 72.38C317.8 65.364 320 56.942 320 46.918C320 39.498 318.6 32.882 316 27.468C313.2 21.654 309.6 16.642 305 12.632C300.4 8.622 295 5.414 289 3.208C283 1.002 276.6 0 269.8 0C261.6 0 254.4 1.204 248.2 3.81C242 6.216 237 10.026 232.8 14.636C228.6 19.448 225.6 25.062 223.4 31.68C221.2 38.296 220.2 45.714 220 53.734H242.8C242.6 44.31 244.6 36.492 249.2 30.276C253.8 24.06 260.6 20.852 269.6 20.852C277.4 20.852 283.8 23.258 289 28.07C294.2000000000001 32.882 296.8 39.7 296.8 48.522C296.8 54.536 295.8 59.148 293.6 62.756C291.4 66.166 288.6 68.972 285 70.776C281.6 72.582 277.6 73.784 273.2 74.186C268.8 74.586 264.4000000000001 74.786 259.8 74.586V93.234C263.6 93.032 267.4 93.234 271.2 94.036C275 94.636 278.4 96.04 281.4 97.844C284.2000000000001 99.65 286.6 102.256 288.4 105.464C290.2 108.672 291.2 112.682 291.2 117.294C291.2 123.9098 289.2000000000001 129.1228 285 133.1328C281 137.1428 275.6 139.1478 269.2000000000001 139.1478C265 139.1478 261.6 138.3458 258.6 136.5414C255.6 134.7368 253.2 132.3308 251.2 129.3234C249.2 126.3158 247.8 122.9072 246.8 119.098C245.8 115.288 245.4 111.478 245.6 107.468H222.6C222.8 115.088 224.2 121.9048 226.4 128.3208C228.6 134.7368 231.8 140.3508 235.8 144.9624C239.6 149.574 244.6 153.3834 250.2 155.99C255.8 158.5964 262.2 160 269.4000000000001 160C275 160 280.4 159.198 285.8 157.3934C291.2 155.7894 296 153.183 300.2 149.7744C304.4000000000001 146.366 307.8 142.1554 310.4 136.9424C313 131.7294 314.2000000000001 125.7142 314.2000000000001 118.898C314.2000000000001 111.078 312.6 104.26 309.4000000000001 98.446C306.2 92.632 301 88.422 294.2000000000001 85.814V85.414z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HeaderThree.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HeaderThree.displayName = "Blueprint5.Icon.HeaderThree";
exports.default = HeaderThree;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aPvA2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderTwo", ()=>HeaderTwo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HeaderTwo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "header-two",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 180V80C40 68.954 31.0456 60 20 60C8.9543 60 0 68.954 0 80V180V220V340C0 351.0456 8.9543 360 20 360C31.0456 360 40 351.0456 40 340V220H180V340C180 351.0456 188.9542 360 200 360C211.046 360 220 351.0456 220 340V220V180V80C220 68.954 211.046 60 200 60C188.9542 60 180 68.954 180 80V180H40zM320.664 40.8C323.854 44.6 327.442 48.4 331.828 51.8C336.014 55.4 340.798 59 345.98 62.4L345.982 62.402C350.9640000000001 66 355.948 69.6 360.9300000000001 73.6C365.914 77.6 370.698 81.8 375.4820000000001 86.2C380.066 90.6 384.252 95.6 388.04 101C391.628 106.4 394.618 112.2 396.81 118.6C399.004 125 400 132 400 140C400 146.4 399.004 153 397.21 160C395.4160000000001 167 392.226 173.6 387.84 179.4C383.456 185.4 377.6740000000001 190.4 370.498 194.2C363.322 198.2 354.3520000000001 200 343.588 200C333.82 200 325.05 198 317.674 194.2C310.298 190.6 303.92 185.4 298.738 178.6C293.554 172 289.7680000000001 164 287.176 154.6C284.584 145.4 283.19 135.4 283.19 124.6H311.694C311.894 131.6 312.492 138 313.488 144C314.486 150 316.28 155.2 318.472 159.6C320.664 164 323.654 167.4 327.442 170C331.23 172.6 336.014 173.8 341.594 173.8C347.774 173.8 352.758 172.6 356.5440000000001 170.2C360.332 167.8 363.322 165 365.514 161.6C367.7080000000001 158.2 369.1020000000001 154.4 369.9000000000001 150.4C370.698 146.4 371.096 142.6 371.096 139C370.896 131.4 369.1020000000001 124.6 365.914 118.6C362.924 112.6 358.538 107.2 353.356 102C348.1720000000001 97 342.592 92.2 336.412 87.8C330.2320000000001 83.4 324.252 78.8 318.6720000000001 74.2000000000001C306.71 65.2000000000001 297.5420000000001 54.6 290.564 42.6C283.588 30.4 280.2 16.2 280 0H399.402V28.6H314.086C315.282 32.8 317.476 37 320.664 40.8z" : "M20 280C8.8 280 0 271 0 260V60C0 49.2 9 40 20 40C31.2 40 40 49 40 60V140H120V60C120 49.2 129 40 140 40C151.2 40 160 49 160 60V260C160 270.8 151 280 140 280C128.8 280 120 271 120 260V180H40V260C40 270.8 31 280 20 280zM263.082 41.118L263.4 41.4C267 44.2 270.6 47 274.8 49.8L287.4 58.8C291.6 62 295.6 65.4 299.6 69C303.6 72.6 307 76.6 310 80.8C313 85 315.6 89.8 317.4 94.8C319.2000000000001 99.8 320 105.6 320 111.8C320 116.8 319.2000000000001 122 317.6 127.6C316.2 133.4 313.6 138.6 309.8 143.4C306.2 148.2 301.2 152.2 295.2 155.4C289.4000000000001 158.4 282 160 273 160C265 160 257.8 158.4 251.6 155.4C245.4 152.2 240 148 235.8 143C231.4 137.6 228.2 131.2 226 123.8C223.8 116.4 222.8 108.4 222.8 99.8H246.6C246.8 105.2 247.2 110.4 248.2 115.2C249 120 250.4 124.2 252.4 127.6C254.2 131.2 256.8 134 260 136C263.2 138 267 139 271.8 139C277 139 281.2 138 284.4000000000001 136.2C287.4 134.4 290 132 291.8 129.2C293.6 126.4 294.8 123.4 295.4 120.2C296 117 296.4 114 296.4 111.2C296.2 105 294.8 99.6 292 94.8C289.2000000000001 90.2 285.6 85.8 281.4 81.8C277 77.6 272.2 74 267.2 70.4C262 66.8 257 63.2 252.2 59.6C242.2 52.4 234.4 44 228.8 34.2C223.2 24.4 220.2 13 220 0H319.8V22.8H248.8C249.8 26.2 251.6 29.4 254.2 32.6C256.718 35.506 259.8 38.224 263.082 41.118z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HeaderTwo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HeaderTwo.displayName = "Blueprint5.Icon.HeaderTwo";
exports.default = HeaderTwo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iYPYv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Header = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "header",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 180V80C120 68.954 111.0456 60 100 60C88.9544 60 80 68.954 80 80V180V220V340C80 351.0456 88.9544 360 100 360C111.0456 360 120 351.0456 120 340V220H280V340C280 351.0456 288.954 360 300 360C311.046 360 320 351.0456 320 340V220V180V80C320 68.954 311.046 60 300 60C288.954 60 280 68.954 280 80V180H120z" : "M240 280C229 280 220 271 220 260V180H100V260C100 271 91 280 80 280C69 280 60 271 60 260V60C60 49 69 40 80 40C91 40 100 49 100 60V140H220V60C220 49 229 40 240 40C251 40 260 49 260 60V260C260 271 251 280 240 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Header.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Header.displayName = "Blueprint5.Icon.Header";
exports.default = Header;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6AKc1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Headset", ()=>Headset);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Headset = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "headset",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M379.4 220H380C380 319.4 299.4 400 200 400S20 319.4 20 220H20.6C8.2 205.4 0 184 0 160C0 125.2 16.8 96 40 84.8V80C40 46.8 66.8 20 100 20H160C160 9 169 0 180 0H220C231 0 240 9 240 20V60C240 71 231 80 220 80H180C169 80 160 71 160 60H100C89 60 80 69 80 80C91 80 100 89 100 100V220C100 231 91 240 80 240H61.6C71.4 307.8 129.4 360 200 360S328.6 307.8 338.4000000000001 240H320C309 240 300 231 300 220V100C300 89 309 80 320 80H340C373.2 80 400 115.8 400 160C400 184 391.8 205.4 379.4 220z" : "M297 193.2C283.6 265.6 227.4 320 160 320S36.4 265.6 23 193.2C9.4 182 0 158 0 130C0 91.4 18 60 40 60C40 38 58 20 80 20H120C120 9 129 0 140 0H180C191 0 200 9 200 20V40C200 51 191 60 180 60H140C129 60 120 51 120 40H80C69 40 60 49 60 60C71 60 80 69 80 80V180C80 189 74 196.2 65.8 198.8C79.4 246 116.2 280 160 280S240.6 246 254.2 198.8C246 196.2 240 189 240 180V80C240 69 249 60 260 60H280C302 60 320 91.4 320 130C320 158 310.6 182 297 193.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Headset.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Headset.displayName = "Blueprint5.Icon.Headset";
exports.default = Headset;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fMebq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeartBroken", ()=>HeartBroken);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HeartBroken = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "heart-broken",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M162.2 251L162.2 251C161 253.8 160 256.8 160 260C160 261.4 160.6 262.6 160.8 263.8L160.4 263.8L177.6 350.2000000000001C158.8 368.6 133.4 380 105 380C47 380 0 333 0 275C0 273.2 0.2 271.6 0.2 270H0C0 268.8 0.2 267.6 0.4 266.4C0.6 265.2000000000001 0.6 264 0.8 262.8C2.6 242.2 8.8 220 21.4 196.6C49 145 96.6 104.6 175.6 40L160.4 116L160.8 116C160.6 117.4 160 118.6 160 120C160 124.2000000000001 161.6 127.8 163.6 130.8L163.2 131L196.8 181.4L162.2 251zM400 275C400 333 353 380 295 380C264.2000000000001 380 236.6 366.6 217.4 345.4L200.8 262.8L237.8 189L237.6 189C239 186.2 240 183.2 240 180C240 175.8 238.4 172.2 236.4 169.2L236.8 169L201.4 115.8L217.6 34.4C300.8 102.2 350.2000000000001 143.4 378.6 196.4C391.2 219.8 397.4000000000001 241.8 399.2000000000001 262.4C399.4000000000001 263.8 399.4000000000001 265.2 399.6 266.6C399.6 267.8 399.8000000000001 268.8 400 270H399.8C399.8 271.6 400 273.2 400 275z" : "M154.2 142.6L123.4 189L123.8 189.2C121.6 192.2 120 195.8 120 200C120 201.4 120.6 202.6 120.8 203.8L120.4 203.8L136 282.2C121.8 293.2 103.8 300 84 300C37.6 300 0 263.4 0 218.2C0 216.8 0.2 215.6 0.2 214.4H0C0 213.4 0.2 212.4 0.2 211.6C0.2 210.6 0.4 209.6 0.4 208.8C1.8 192.8 6.8 175.6 16.8 157.4C38.2 118.6 74.4 88 134 40.6L120.4 95.4L120.8 95.4C120.6 96.8 120 98.4 120 100C120 105.6 122.2 110.6 125.8 114.2L154.2 142.6zM320 218.2C320 263.4 282.4 300 236 300C212 300 190.6 290 175.2000000000001 274.4L161.2000000000001 204.2L196.6 151L196.4 150.8C198.4 147.8 200 144.2 200 140C200 134.4 197.8 129.4 194.2 125.8L162.2 93.8L177.2 33.6C241.8000000000001 84.8 280.4000000000001 116.6 302.8 157.2C312.8 175.4 317.8 192.6 319.2000000000001 208.4C319.4000000000001 209.4 319.4000000000001 210.6 319.6 211.6C319.6 212.4 319.8 213.4 319.8 214.2H319.6C319.8 215.6 320 217 320 218.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HeartBroken.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HeartBroken.displayName = "Blueprint5.Icon.HeartBroken";
exports.default = HeartBroken;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1E91Q":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heart", ()=>Heart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Heart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "heart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 275C400 333 353 380 295 380C274.6 380 256 373.8 240 363.6V364.4C238.2 363.2 236.6 362 234.8 360.6C234 360 233 359.4 232 358.6C218.4 348.4 207.2 335 200 319.4C192 336.6 179.2 350.8 164 361.4C163.2 361.8 162.6 362.4 162 363C158.2 365.4 154 367.6 150 369.6C147.4 370.4 145.4 371.6 143 372.6C142 373 141 373.6 140 374V373.6C129 377.4 117.4 380 105 380C47 380 0 333 0 275C0 273.2 0.2 271.6 0.2 270H0C0 268.8 0.2 267.6 0.4 266.4S0.6 264 0.8 262.8C2.6 242.2 8.8 220 21.4 196.6C44.6 153.4 82 117.8 140 69.4V69.1999999999999C158 54.1999999999999 177.8 38.1999999999999 200 19.9999999999999C214.2 31.5999999999999 227.6 42.4 240 52.5999999999999V52.5999999999999C309.6 109.7999999999999 352.8 148.1999999999999 378.6 196.1999999999999C391.2 219.5999999999999 397.4000000000001 241.5999999999999 399.2000000000001 262.2C399.4000000000001 263.5999999999999 399.4000000000001 264.9999999999999 399.6 266.3999999999999C399.6 267.5999999999999 399.8000000000001 268.5999999999999 400 269.7999999999999H399.8C399.8 271.6 400 273.2 400 275z" : "M320 218.1C320 263.202 282.392 299.766 236 299.766C202.352 299.766 173.41 280.486 160 252.712C146.59 280.488 117.648 299.766 84 299.766C37.608 299.766 0 263.204 0 218.1C0 216.786 0.14 215.508 0.202 214.21H0.072C0.102 213.284 0.294 212.3 0.35 211.364C0.43 210.41 0.514 209.46 0.628 208.514C2.02 192.524 7.048 175.256 17.104 157.07C41.464 112.908 84.65 79.64 159.996 20C235.34 79.64 278.526 112.932 302.886 157.07C312.904 175.186 317.926 192.392 319.344 208.328C319.478 209.414 319.574 210.506 319.664 211.604C319.712 212.46 319.892 213.364 319.918 214.212H319.8C319.86 215.51 320 216.788 320 218.1z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Heart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Heart.displayName = "Blueprint5.Icon.Heart";
exports.default = Heart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"51bLD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeatGrid", ()=>HeatGrid);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HeatGrid = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "heat-grid",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 160H400V240H280V160zM0 160H120V240H0V160zM20 220H100V180H20V220zM0 80C0 69 9 60 20 60H120V140H0V80zM380 340H280V260H400V320C400 331 391 340 380 340zM380 280H300V320H380V280zM0 320V260H120V340H20C9 340 0 331 0 320zM140 260H260V340H140V260zM280 60H380C391 60 400 69 400 80V140H280V60zM140 60H260V140H140V60zM160 120H240V80H160V120zM140 160H260V240H140V160z" : "M0 120H100V180H0V120zM20 160H80V140H20V160zM300 260H220V200H320V240C320 251 311 260 300 260zM300 220H240V240H300V220zM0 240V200H100V260H20C9 260 0 251 0 240zM0 60C0 49 9 40 20 40H100V100H0V60zM120 200H200V260H120V200zM120 40H200V100H120V40zM140 80H180V60H140V80zM220 40H300C311 40 320 49 320 60V100H220V40zM220 120H320V180H220V120zM120 120H200V180H120V120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HeatGrid.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HeatGrid.displayName = "Blueprint5.Icon.HeatGrid";
exports.default = HeatGrid;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gD5Is":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heatmap", ()=>Heatmap);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Heatmap = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "heatmap",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 280A120 120 0 0 1 240 280A120 120 0 0 1 0 280M120 150A90 90 0 0 1 300 150A90 90 0 0 1 120 150M260 190A70 70 0 0 1 400 190A70 70 0 0 1 260 190M320 40A40 40 0 0 1 400 40A40 40 0 0 1 320 40M0 70A50 50 0 0 1 100 70A50 50 0 0 1 0 70M280 350A50 50 0 0 1 380 350A50 50 0 0 1 280 350" : "M40 100C18 100 0 82 0 60C0 38 18 20 40 20S80 38 80 60C80 82 62 100 40 100zM260 240C282 240 300 258 300 280S282 320 260 320S220 302 220 280S238 240 260 240zM320 150C320 177.6 297.6 200 270 200C250.4 200 233.6 188.6 225.4 172.2C213.4 187.8 195.2 198.2 174.2 199.4C177.8 209.2 180 219.2 180 230C180 279.8 139.8 320 90 320S0 279.8 0 230S40.2 140 90 140C93.8 140 97.4 140.6 101.2 141.2C100.6 137.4 100 133.8 100 130C100 91.4 131.4 60 170 60C202.6 60 229.6 82.2 237.4000000000001 112.4C246.2 104.8 257.4000000000001 100 270 100C297.6 100 320 122.4 320 150zM290 60C273.4 60 260 46.6 260 30S273.4 0 290 0S320 13.4 320 30S306.6 60 290 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Heatmap.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Heatmap.displayName = "Blueprint5.Icon.Heatmap";
exports.default = Heatmap;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGuh2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Helicopter", ()=>Helicopter);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Helicopter = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "helicopter",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 340V300H140H120H20V330C20 335.5228 15.52284 340 10 340C4.47716 340 0 335.5228 0 330V230C0 224.4772 4.47716 220 10 220C15.52284 220 20 224.4772 20 230V260L120 220C120 189.194 136.4754 148.504 180 123.304V80H110C104.4772 80 100 75.524 100 70C100 64.478 104.4772 60 110 60H189.9288L190 60L190.0712 60H289.928L290 60L290.072 60H330C331.552 60 333.084 60.362 334.4720000000001 61.056L374.4720000000001 81.056C379.4120000000001 83.526 381.414 89.532 378.944 94.472C376.474 99.412 370.468 101.414 365.528 98.944L327.6400000000001 80H300V102C345.644 111.266 380 151.62 380 200C380 255.2284 335.228 300 280 300H260V340H390C395.522 340 400 344.4772 400 350C400 355.5228 395.522 360 390 360H260H200H70C64.4772 360 60 355.5228 60 350C60 344.4772 64.4772 340 70 340H200zM280 80V100C247.846 100 221.436 105.17 200 113.662V80H280zM280 200V220V280C324.182 280 360 244.1828 360 200H280z" : "M10 280C15.52284 280 20 275.5228 20 270V240H100H160V260H50C44.4772 260 40 264.4772 40 270C40 275.5228 44.4772 280 50 280H160H200H310C315.522 280 320 275.5228 320 270C320 264.4772 315.522 260 310 260H200V240H220C265.186 240 300 204.1828 300 160C300 122.604 275.06 91.2 240 82.436V60H247.64L285.528 78.944C290.468 81.414 296.474 79.412 298.944 74.472C301.414 69.532 299.412 63.526 294.472 61.056L252.36 40H230.072L230 40L229.928 40H150.0712L150 40L149.9288 40H90C84.4772 40 80 44.478 80 50C80 55.524 84.4772 60 90 60H140V106.112C114.9718 125.2792 100 152.6396 100 180L20 200L20 170C20 164.4772 15.52284 160 10 160C4.47714 160 0 164.4772 0 170V270C0 275.5228 4.47716 280 10 280zM160 93.686V60H220V80C197.6314 80 177.3052 85.106 160 93.686zM220 220V160H280C280 193.137 253.138 220 220 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Helicopter.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Helicopter.displayName = "Blueprint5.Icon.Helicopter";
exports.default = Helicopter;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kPbGp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Help", ()=>Help);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Help = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "help",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM148.2 307.6C161.2 318.4 178.4 324 199.4 324C210.2000000000001 324 220 322.4 229.0000000000001 319C237.8 315.6 245.6 311.2000000000001 251.8000000000001 305.4C258.2000000000001 299.6 263.0000000000001 292.8 266.6 285C270.0000000000001 277.2 271.8 268.6 271.8 259.6S270.2000000000001 242.2 267 235C263.8 227.6 259 220.4 252.8 212.8L228.6 181.2C225.8 177.8 223 174.6 222.2 171.6C221.2 168.6 220 164.6 220 159.6V151C220 148.6 220 140.2000000000001 220 140.2000000000001H180V180.2000000000001C180 180.2000000000001 181.2 191.8000000000001 184.8 196.4L209 229.2000000000001C214 235.2000000000001 217.2 240.4000000000001 219.2 244.6000000000001S222 253.4000000000001 222 258.0000000000001C222 265 219.8 270.6 215.6 275S205.6 281.6 198 281.6C190.6 281.6 184.6 279.4000000000001 180.2 275C175.8 270.4 172.8 264.2 171 256.2C170.4 253.8 168.8 252.8 166.4 253L127.4 258.8C125 259 124.2 260.4 124.6 263.2C127.2 281.8 135 296.6 148.2 307.6zM180 120H220.4L220 80H180V120z" : "M160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM180 60H140V100H180V60zM218.6 190.4C215.8 184 211.6 177.6 206.2 171L185 143.4C182.6 140.4 180.2 137.6 179.4 135C178.6 132.4 177.6 129 177.6 124.6V120H142.4V142.4C142.4 142.4 143.4 152.6 146.6 156.6L168 185.4C172.4 190.6 175 195.2 176.8 199C178.6 202.8 179.2 206.6 179.2 210.6C179.2 216.6 177.2 221.6 173.6 225.6C170 229.4 164.8 231.2 158.4 231.2C151.8 231.2 146.6 229.2 142.8 225.4C139 221.6 136.2 216.2 134.8 209.2C134.2 207 132.8 206.2 130.8 206.4L96.8 211.4C94.4 211.6 93.6 213 94 215.2C96.4 231.6 103.2 244.6 114.6 254C126 263.6 141 268.4 159.6 268.4C169 268.4 177.6 267 185.4 264C193.2 261 199.8 257.2 205.4 252.2C211 247.2 215.2 241.2 218.4 234.4C221.4 227.4 222.8 220 222.8 212S221.4 197 218.6 190.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Help.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Help.displayName = "Blueprint5.Icon.Help";
exports.default = Help;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7wHni":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HelperManagement", ()=>HelperManagement);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HelperManagement = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "helper-management",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 200H280V140H340V200L340 200zM340 120H280V60H340V120L340 120zM340 280H280V220H340V280L340 280zM380 400H20C8 400 0 392 0 380V20C0 10 8 0 20 0H380C390 0 400 10 400 20V380C400 392 390 400 380 400L380 400zM360 40H40V360H360V40L360 40zM180 120H120V60H180V120L180 120zM260 120H200V60H260V120L260 120z" : "M260 220H220V180H260V220L260 220zM260 100H220V60H260V100L260 100zM260 160H220V120H260V160L260 160zM300 320H20C8 320 0 312 0 300V20C0 8 8 0 20 0H300C312 0 320 8 320 20V300C320 312 312 320 300 320L300 320zM280 40H40V280H280V40L280 40zM140 100H100V60H140V100L140 100zM200 100H160V60H200V100L200 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HelperManagement.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HelperManagement.displayName = "Blueprint5.Icon.HelperManagement";
exports.default = HelperManagement;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fRNJP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hexagon", ()=>Hexagon);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Hexagon = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "hexagon",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M146.9992 300H253L308.4 200L253 100H146.9992L91.5992 200L146.9992 300zM169.9992 200C169.9992 183.4 183.3992 170 199.9992 170C216.6 170 230 183.4 230 200S216.6 230 199.9992 230C183.3992 230 169.9992 216.6 169.9992 200zM92.5988 369.8C96.1988 376 102.9988 380 110.3988 380H289.398C296.798 380 303.598 376.2 307.1980000000001 369.8L397.598 209.8C400.9980000000001 203.8 400.9980000000001 196.4 397.598 190.4L307.398 30.4C303.798 24.2 296.998 20.1999999999999 289.598 20.1999999999999H110.5988C103.1988 20.1999999999999 96.3988 24 92.7988 30.4L2.5988 190.4C-0.8012 196.4 -0.8012 203.8 2.5988 209.8L92.5988 369.8zM122.5988 60H277.798L356.798 200L277.798 340H122.5988L43.5988 200L122.5988 60z" : "M72.5834 30.078L2.6862 150.0772C-0.8954 156.2258 -0.8954 163.7742 2.6862 169.9228L72.5834 289.9228C76.213 296.1542 82.9682 300 90.284 300H229.716C237.032 300 243.786 296.1542 247.416 289.9228L317.314 169.9228C320.896 163.7742 320.896 156.2258 317.314 150.0772L247.416 30.078C243.786 23.846 237.032 20 229.716 20H90.284C82.968 20 76.2132 23.846 72.5834 30.078zM200.138 90H119.8612L79.0878 160L119.8612 230H200.138L240.912 160L200.138 90zM102.1148 60H217.886L276.132 160L217.886 260H102.1148L43.8672 160L102.1148 60zM160 140C171.2592 140 180.3868 148.9544 180.3868 160S171.2592 180 160 180C148.7408 180 139.6132 171.0456 139.6132 160S148.7408 140 160 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Hexagon.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Hexagon.displayName = "Blueprint5.Icon.Hexagon";
exports.default = Hexagon;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4nuKQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HighPriority", ()=>HighPriority);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HighPriority = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "high-priority",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 80L240 0L160 0L160 80L240 80zM260 400L240 120L160 120L140 400L260 400z" : "M180 40L180 0L140 0L140 40L180 40zM200 320L180 80L140 80L120 320L200 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HighPriority.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HighPriority.displayName = "Blueprint5.Icon.HighPriority";
exports.default = HighPriority;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e78ls":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HighVoltagePole", ()=>HighVoltagePole);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HighVoltagePole = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "high-voltage-pole",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140 400C128.9544 400 120 391.04568 120 380V320H80V360C91.0456 360 100 368.9544 100 380C100 391.0457 91.0456 400 80 400H20C8.9543 400 0 391.0457 0 380C0 368.9544 8.9543 360 20 360H40V320H20C8.9543 320 0 311.0456 0 300C0 288.9544 8.95432 280 20 280H40V240H20C8.9543 240 0 231.0458 0 220C0 208.9544 8.9543 200 20 200H80C91.0456 200 100 208.9544 100 220C100 231.0458 91.0456 240 80 240V280H120V20C120 8.954 128.9544 0 140 0C148.3996 0 155.5896 5.178 158.5526 12.516L199.9998 109.226L241.456 12.494C244.426 5.168 251.61 0 260 0C271.046 0 280 8.954 280 20V280H320V240C308.954 240 300 231.0458 300 220C300 208.9544 308.954 200 320 200H380C391.046 200 400 208.9544 400 220C400 231.0458 391.046 240 380 240H360V280H380C391.046 280 400 288.9544 400 300C400 311.0456 391.046 320 380 320H360V360H380C391.046 360 400 368.9544 400 380C400 391.0457 391.046 400 380 400H320C308.954 400 300 391.0457 300 380C300 368.9544 308.954 360 320 360V320H280V380C280 391.0457 271.046 400 260 400H140zM160 360V320H240V360H160zM240 117.436L221.76 159.998L240 202.5598V117.436zM170.3294 280L199.9998 210.7694L229.67 280H170.3294zM178.2404 159.998L160 202.5584V117.436L178.2404 159.998z" : "M120 320C108.9544 320 100 311.0457 100 300V240H60V260H70C75.5228 260 80 264.4772 80 270C80 275.5228 75.5228 280 70 280H30C24.4772 280 20 275.5228 20 270C20 264.4772 24.4772 260 30 260H40V240C28.9544 240 20 231.0456 20 220C20 208.9544 28.9544 200 40 200L40 180H30C24.4772 180 20 175.5228 20 170C20 164.4772 24.4772 160 30 160H70C75.5228 160 80 164.4772 80 170C80 175.5228 75.5228 180 70 180H60V200H100V20C100 8.954 108.9544 0 120 0C131.0456 0 140 8.954 140 20V200H180V20C180 8.954 188.9542 0 200 0C211.046 0 220 8.954 220 20V200H260V180H250C244.478 180 240 175.5228 240 170C240 164.4772 244.478 160 250 160H290C295.522 160 300 164.4772 300 170C300 175.5228 295.522 180 290 180H280L280 200C291.046 200 300 208.9544 300 220C300 231.0456 291.046 240 280 240L280 260H290C295.522 260 300 264.4772 300 270C300 275.5228 295.522 280 290 280H250C244.478 280 240 275.5228 240 270C240 264.4772 244.478 260 250 260H260V240H220V300C220 311.0457 211.046 320 200 320H120zM140 280V240H180V280H140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HighVoltagePole.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HighVoltagePole.displayName = "Blueprint5.Icon.HighVoltagePole";
exports.default = HighVoltagePole;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"braiq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Highlight", ()=>Highlight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Highlight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "highlight",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M224.4 118.2L285 178.8L299.2000000000001 164.6L400 265.4L285.8 379.6L185 278.8L199.2 264.6L138.8 203.8L224.4 118.2zM360.4 40H40.4C29.4 40 20.4 31 20.4 20C20.4 9 29.4 0 40.4 0H360.4C371.4 0 380.4 9 380.4 20C380.4 31 371.4 40 360.4 40zM60.4 60H141.2C146.8 60 151.8 62.2 155.4 66L195.8 106.4L127 175.4L46.2 94.6C42.6 91 40.2 85.8 40.2 80.4C40.4 69 49.4 60 60.4 60z" : "M182.4 98.6L222.4 139L236.6 124.8L316.6 205.6L203.4 320L123.4 239.2L137.6 225L97.6 184.6L182.4 98.6zM40 60.6H120C125.6 60.6 130.6 62.8 134.2 66.6L154.2 86.8L85.8 155.8L25.8 95.2C22.2 91.6 20 86.4 20 80.8C20 69.8 29 60.6 40 60.6zM300 40.4H20C9 40.4 0 31.4 0 20.2S9 0 20 0H300C311 0 320 9 320 20.2S311 40.4 300 40.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Highlight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Highlight.displayName = "Blueprint5.Icon.Highlight";
exports.default = Highlight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4E3ml":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "History", ()=>History);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var History = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "history",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C134.2 400 76.4 368 40 319V360C40 371 31 380 20 380S0 371 0 360V280C0 269 9 260 20 260H100C111 260 120 269 120 280S111 300 100 300H75.2C104.6 336.6 149.4 360 200 360C288.4 360 360 288.4 360 200S288.4 40 200 40S40 111.6 40 200C40 211 31 220 20 220S0 211 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 340C189 340 180 331 180 320V200C180 194.4 182.2 189.4 185.8 185.8L245.8 125.8C249.4 122.2 254.4 120 260 120C271 120 280 129 280 140C280 145.6 277.8 150.6 274.2000000000001 154.2L220 208.2V320C220 331 211 340 200 340z" : "M160 260C149 260 140 251 140 240V160C140 154.4 142.2 149.4 145.8 145.8L185.8 105.8C189.4 102.2 194.4 100 200 100C211 100 220 109 220 120C220 125.6 217.8 130.6 214.2 134.2L180 168.2V240C180 251 171 260 160 260zM160 320C112 320 69.2 298.6 40 265.2V300C40 311 31 320 20 320S0 311 0 300V220C0 209 9 200 20 200H100C111 200 120 209 120 220S111 240 100 240H70.8C92.8 264.4 124.6 280 160 280C226.2 280 280 226.2 280 160C280 107.8 246.6 63.8 200 47.4V47.6C187.4 43 174.2 40 160 40C93.8 40 40 93.8 40 160C40 171 31 180 20 180S0 171 0 160C0 71.6 71.6 0 160 0C166.8 0 173.4 0.6 180 1.4C180.4 1.4 180.8 1.6 181.2 1.6C259.6 12 320 78.8 320 160C320 248.4 248.4 320 160 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
History.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
History.displayName = "Blueprint5.Icon.History";
exports.default = History;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gIJo4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Home", ()=>Home);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Home = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "home",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 160V20C40 9 49 0 60 0H160V140H240V0H340C351 0 360 9 360 20V160L200 320L40 160zM394.2000000000001 214.2L340 268.2V340C340 351 331 360 320 360S300 351 300 340V308.2L214.2 394C210.6 397.8 205.6 400 200 400S189.4 397.8 185.8 394.2L5.8 214.2C2.2 210.6 0 205.6 0 200C0 189 9 180 20 180C25.6 180 30.6 182.2 34.2 185.8L200 351.8L365.8 186C369.4 182.2 374.4 180 380 180C391 180 400 189 400 200C400 205.6 397.8 210.6 394.2000000000001 214.2z" : "M40 120V100C40 100 40 91.4 40 80V60.2C40 40.2 40 20 40 20C40 9 49 0 60 0H120V100H200V0H260C271 0 280 9 280 20V120L160 240L40 120zM314.2000000000001 174.2L280 208.2V280C280 291 271 300 260 300S240 291 240 280V248.2L174.2 314.2C170.6 317.8 165.6 320 160 320S149.4 317.8 145.8 314.2L5.8 174.2C2.2 170.6 0 165.6 0 160C0 149 9 140 20 140C25.6 140 30.6 142.2 34.2 145.8L160 271.8L285.8 146C289.4000000000001 142.2 294.4000000000001 140 300 140C311 140 320 149 320 160C320 165.6 317.8 170.6 314.2000000000001 174.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Home.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Home.displayName = "Blueprint5.Icon.Home";
exports.default = Home;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7xOmG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorizontalBarChartAsc", ()=>HorizontalBarChartAsc);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HorizontalBarChartAsc = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "horizontal-bar-chart-asc",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 220H240C251 220 260 229 260 240V260C260 271 251 280 240 280H20C9 280 0 271 0 260V240C0 229 9 220 20 220zM20 320H200C211 320 220 329 220 340V360C220 371 211 380 200 380H20C9 380 0 371 0 360V340C0 329 9 320 20 320zM380 80H20C9 80 0 71 0 60V40C0 29 9 20 20 20H380C391 20 400 29 400 40V60C400 71 391 80 380 80zM20 120H300C311 120 320 129 320 140V160C320 171 311 180 300 180H20C9 180 0 171 0 160V140C0 129 9 120 20 120z" : "M20 260H120C131 260 140 269 140 280S131 300 120 300H20C9 300 0 291 0 280S9 260 20 260zM20 180H160C171 180 180 189 180 200S171 220 160 220H20C9 220 0 211 0 200S9 180 20 180zM300 60H20C9 60 0 51 0 40S9 20 20 20H300C311 20 320 29 320 40S311 60 300 60zM20 100H220C231 100 240 109 240 120S231 140 220 140H20C9 140 0 131 0 120S9 100 20 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HorizontalBarChartAsc.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HorizontalBarChartAsc.displayName = "Blueprint5.Icon.HorizontalBarChartAsc";
exports.default = HorizontalBarChartAsc;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c9VYZ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorizontalBarChartDesc", ()=>HorizontalBarChartDesc);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HorizontalBarChartDesc = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "horizontal-bar-chart-desc",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 80H20C9 80 0 71 0 60V40C0 29 9 20 20 20H200C211 20 220 29 220 40V60C220 71 211 80 200 80zM240 180H20C9 180 0 171 0 160V140C0 129 9 120 20 120H240C251 120 260 129 260 140V160C260 171 251 180 240 180zM300 280H20C9 280 0 271 0 260V240C0 229 9 220 20 220H300C311 220 320 229 320 240V260C320 271 311 280 300 280zM380 380H20C9 380 0 371 0 360V340C0 329 9 320 20 320H380C391 320 400 329 400 340V360C400 371 391 380 380 380z" : "M300 300H20C9 300 0 291 0 280C0 269 9 260 20 260H300C311 260 320 269 320 280C320 291 311 300 300 300zM160 140H20C9 140 0 131 0 120C0 109 9 100 20 100H160C171 100 180 109 180 120C180 131 171 140 160 140zM120 60H20C9 60 0 51 0 40C0 29 9 20 20 20H120C131 20 140 29 140 40C140 51 131 60 120 60zM220 220H20C9 220 0 211 0 200C0 189 9 180 20 180H220C231 180 240 189 240 200C240 211 231 220 220 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HorizontalBarChartDesc.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HorizontalBarChartDesc.displayName = "Blueprint5.Icon.HorizontalBarChartDesc";
exports.default = HorizontalBarChartDesc;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dCqQ2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorizontalBarChart", ()=>HorizontalBarChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HorizontalBarChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "horizontal-bar-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 380C9 380 0 371 0 360V40C0 29 9 20 20 20S40 29 40 40V360C40 371 31 380 20 380zM80 280H300C311 280 320 289 320 300V340C320 351 311 360 300 360H80C69 360 60 351 60 340V300C60 289 69 280 80 280zM240 120H80C69 120 60 111 60 100V60C60 49 69 40 80 40H240C251 40 260 49 260 60V100C260 111 251 120 240 120zM380 240H80C69 240 60 231 60 220V180C60 169 69 160 80 160H380C391 160 400 169 400 180V220C400 231 391 240 380 240z" : "M80 220H220C231 220 240 229 240 240V260C240 271 231 280 220 280H80C69 280 60 271 60 260V240C60 229 69 220 80 220zM20 300C9 300 0 291 0 280V20C0 9 9 0 20 0S40 9 40 20V280C40 291 31 300 20 300zM300 180H80C69 180 60 171 60 160V140C60 129 69 120 80 120H300C311 120 320 129 320 140V160C320 171 311 180 300 180zM180 80H80C69 80 60 71 60 60V40C60 29 69 20 80 20H180C191 20 200 29 200 40V60C200 71 191 80 180 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HorizontalBarChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HorizontalBarChart.displayName = "Blueprint5.Icon.HorizontalBarChart";
exports.default = HorizontalBarChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"76oQQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorizontalDistribution", ()=>HorizontalDistribution);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HorizontalDistribution = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "horizontal-distribution",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 360H160C149 360 140 351 140 340V60C140 49 149 40 160 40H240C251 40 260 49 260 60V340C260 351 251 360 240 360zM20 400C9 400 0 391 0 380V20C0 9 9 0 20 0S40 9 40 20V380C40 391 31 400 20 400zM380 400C369 400 360 391 360 380V20C360 9 369 0 380 0S400 9 400 20V380C400 391 391 400 380 400z" : "M40 320C29 320 20 311 20 300V20C20 9 29 0 40 0S60 9 60 20V300C60 311 51 320 40 320zM300 320C289 320 280 311 280 300V20C280 9 289 0 300 0S320 9 320 20V300C320 311 311 320 300 320zM200 280H140C129 280 120 271 120 260V80C120 69 129 60 140 60H200C211 60 220 69 220 80V260C220 271 211 280 200 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HorizontalDistribution.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HorizontalDistribution.displayName = "Blueprint5.Icon.HorizontalDistribution";
exports.default = HorizontalDistribution;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bi5DX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorizontalInbetween", ()=>HorizontalInbetween);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var HorizontalInbetween = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "horizontal-inbetween",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M225.852 125.852C233.654 118.05 246.3040000000001 118.05 254.106 125.852L313.354 185.1C313.624 185.342 313.888 185.592 314.148 185.852C318.054 189.758 320.006 194.88 320 200C320.006 205.12 318.054 210.2418 314.148 214.1482C313.888 214.4076 313.624 214.6582 313.354 214.9004L254.106 274.1482C246.3040000000001 281.9506 233.654 281.9506 225.852 274.1482C218.05 266.3458 218.05 253.6958 225.852 245.8934L271.7460000000001 200L225.852 154.106C218.05 146.304 218.05 133.654 225.852 125.852zM145.8934 125.852C153.6958 118.05 166.3458 118.05 174.1482 125.852C181.9506 133.654 181.9506 146.304 174.1482 154.106L128.2548 200L174.1482 245.8934C181.9506 253.6958 181.9506 266.3458 174.1482 274.1482C166.3458 281.9506 153.6958 281.9506 145.8934 274.1482L86.6456 214.9004C86.3758 214.6582 86.1112 214.4076 85.8518 214.1482C81.9454 210.2418 79.9948 205.12 80 200C79.9948 194.88 81.9454 189.758 85.8518 185.852C86.1112 185.592 86.3758 185.342 86.6456 185.1L145.8934 125.852zM0 0V400H20C31.0456 400 40 391.0457 40 380V20C40 8.954 31.0456 0 20 0H0zM400 0V400H380C368.954 400 360 391.0457 360 380V20C360 8.954 368.954 0 380 0H400z" : "M0 0V320H20C31.0456 320 40 311.0457 40 300V20C40 8.954 31.0456 0 20 0H0zM300 320H320V0H300C288.954 0 280 8.954 280 20V300C280 311.0457 288.954 320 300 320zM134.1416 185.8578C141.952 193.6684 141.952 206.3316 134.1416 214.1422C126.331 221.9526 113.6678 221.9526 105.8572 214.1422L65.8572 174.1422C58.0468 166.3316 58.0468 153.6684 65.8572 145.8578L105.8572 105.858C113.6678 98.048 126.331 98.048 134.1416 105.858C141.952 113.668 141.952 126.3316 134.1416 134.1422L108.2836 160L134.1416 185.8578zM214.142 214.1422C206.332 221.9526 193.6678 221.9526 185.8572 214.1422C178.0468 206.3316 178.0468 193.6684 185.8572 185.8578L211.716 160L185.8572 134.1422C178.0468 126.3316 178.0468 113.668 185.8572 105.858C193.6678 98.048 206.332 98.048 214.142 105.858L254.142 145.8578C261.952 153.6684 261.952 166.3316 254.142 174.1422L214.142 214.1422z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
HorizontalInbetween.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
HorizontalInbetween.displayName = "Blueprint5.Icon.HorizontalInbetween";
exports.default = HorizontalInbetween;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7sQ59":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hurricane", ()=>Hurricane);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Hurricane = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "hurricane",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M-0.000365426 120C32.9674 104.498 60.0002 100 80.0002 100C60.0002 120 40.0006 162.236 40.0006 200C40.0006 200.116 40.0002 200.2326 39.9998 200.3492C39.999 200.532 39.9984 200.7148 39.9994 200.8966C39.9994 296.6134 124.0262 380.00004 223.438 380C287.564 380 361.428 366.6552 400 280C367.034 295.502 340 300 320 300C340 280 360 237.7632 360 200L360 199.104C360 103.386 275.972 20 176.5616 20C112.436 20 38.571 33.3440000000001 -0.000365426 120zM199.9998 260C166.8628 260 139.9998 233.137 139.9998 200C139.9998 166.862 166.8626 140 199.9998 140C233.136 140 260 166.862 260 200C260 233.137 233.136 260 199.9998 260z" : "M70 80C52.8104 80 20 90 0 100C20 30 90.1246 20 140 20C217.32 20 280 82.68 280 160L279.886 160.085C279.962 161.83 280 163.5846 280 165.3482C280 193.492 270.312 219.3732 254.088 239.8378C272.004 238.511 301.49 229.2554 320 220C300 290 229.876 300 180 300C127.0704 300 81.0012 270.6272 57.2032 227.2926C46.2834 209.21 40 188.0128 40 165.3482C40 164.489 40.009 163.632 40.027 162.7772C40.009 161.8536 40 160.928 40 160L40.121 159.9092C41.5116 128.7372 54.7948 100.658 75.543 80.102C73.7118 80.034 71.864 80 70 80zM160 200C137.9086 200 120 182.0914 120 160C120 137.9086 137.9086 120 160 120C182.0914 120 200 137.9086 200 160C200 182.0914 182.0914 200 160 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Hurricane.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Hurricane.displayName = "Blueprint5.Icon.Hurricane";
exports.default = Hurricane;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1lOgy":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdNumber", ()=>IdNumber);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var IdNumber = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "id-number",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 300V100H360V300H40zM40 340H360C382 340 400 322 400 300V100C400 78 382 60 360 60H40C18 60 0 78 0 100V300C0 322 18 340 40 340zM177.6 152.4C174.2 160.2 157.4 165.6 146.4 170.4C135.2 175.2 136.8 178.2 136.4 182.4C136.4 183 136.4 183.6 136.4 184.2C140.2 187.6 143.4 192.2 145.4 197.6C145.4 197.6 145.4 198 145.6 198C146 199.2 146.4 200.4 146.8 201.6C149.4 202.2 150.8 205 151.4 207.4C152 208.4 153.2 211 153 214C152.2 217.6 150.8 219.4 149 220V220.6C149 225.4 148.6 232.2 147.8 236.8C147.6 238 147.4 239.2 147 240.6C145.4 246 142 251 137.4 254.6C132.6 258.2 126 260 120 260S107.4 258.2 102.6 254.6C98 251.2 94.6 246.2 93 240.6C92.6 239.4 92.4 238 92.2 236.8C91.4 232.4 91 225.4 91 220.6V220C89.2 219.4 87.6 217.6 87.2 213.8C87 211 88.2 208.4 88.8 207.4C89.4 204.6 90.8 202 93.4 201.4C93.8 200.2 94 199 94.6 197.8C94.6 197.8 94.6 197.6 94.6 197.6L94.6 197.6C96.8 192.2 100 187.4 104 184C104 183.4 104 183 104 182.4C103.6 178.4 104.8 175.4 93.8 170.4C82.6 165.6 66 160.2 62.6 152.4C58.8 144.6 60.2 140 60.2 140H179.8C179.6 140 181 144.6 177.6 152.4L177.6 152.4zM240 260H320C331 260 340 251 340 240L340 240C340 229 331 220 320 220H240C229 220 220 229 220 240L220 240C220 251 229 260 240 260zM240 180H320C331 180 340 171 340 160L340 160C340 149 331 140 320 140H240C229 140 220 149 220 160L220 160C220 171 229 180 240 180z" : "M40 220V80H280V220H40zM40 260H280C302 260 320 242 320 220V80C320 58 302 40 280 40H40C18 40 0 58 0 80V220C0 242 18 260 40 260zM158 110.4C155.2 117 141.2 121.4 132 125.4C122.8 129.4 124 132 123.6 135.4C123.6 135.8 123.6 136.4 123.6 136.8C126.8 139.6 129.4 143.4 131 148C131 148 131 148.2 131.2 148.4C131.6 149.4 131.8 150.4 132.2 151.4C134.2 151.6 135.4 154 136 156C136.6 156.8 137.4 159 137.2 161.4C136.8 164.6 135.6 166.2 134.2 166.6V167.2C134.2 171.2 133.8 176.8 133.2 180.6C133 181.6 132.8 182.6 132.6 183.8C131.2 188.4 128.4 192.6 124.6 195.4C120.6 198.4 115 200 110 200S99.4 198.4 95.6 195.4C91.8 192.6 89 188.4 87.6 183.8C87.2 182.8 87 181.8 87 180.6C86 177 85.8 171.2 85.8 167.2V166.6C84.4 166 83 164.6 82.8 161.4C82.4 159 83.4 157 84 156C84.4 154 85.8 151.6 88 151.2C88.2 150.2 88.6 149.2 89 148.2C89 148.2 89 148 89 148L89 148C90.6 143.4 93.4 139.6 96.6 136.8C96.6 136.4 96.6 136 96.6 135.4C96.2 132 97.2 129.6 88 125.4C78.8 121.4 64.8 117 62 110.4S60.2 100 60.2 100H160C159.8 100 161 103.8 158 110.4L158 110.4zM200 200H240C251 200 260 191 260 180L260 180C260 169 251 160 240 160H200C189 160 180 169 180 180L180 180C180 191 189 200 200 200zM200 140H240C251 140 260 131 260 120L260 120C260 109 251 100 240 100H200C189 100 180 109 180 120L180 120C180 131 189 140 200 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
IdNumber.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
IdNumber.displayName = "Blueprint5.Icon.IdNumber";
exports.default = IdNumber;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"di8PT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImageRotateLeft", ()=>ImageRotateLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ImageRotateLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "image-rotate-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M210 140C226.6 140 240 153.4 240 170S226.6 200 210 200S180 186.6 180 170S193.4 140 210 140zM280 260H20C9 260 0 251 0 240V20C0 9 9 0 20 0H280C291 0 300 9 300 20V240C300 251 291 260 280 260zM260 60L160 120L140 80L100 160L40 70V220H260V60zM320 360H288.2L294 365.8C297.8 369.4 300 374.4 300 380C300 391 291 400 280 400C274.4000000000001 400 269.4000000000001 397.8 265.8 394.2L225.8 354.2C222.2 350.6 220 345.6 220 340C220 334.4 222.2 329.4 225.8 325.8L265.8 285.8C269.4000000000001 282.2 274.4000000000001 280 280 280C291 280 300 289 300 300C300 305.6 297.8 310.6 294.2000000000001 314.2L288.2 320H320C342 320 360 302 360 280V220C360 209 369 200 380 200S400 209 400 220V280C400 324.2 364.2000000000001 360 320 360z" : "M260 280H228.2L234 285.8C237.8 289.4 240 294.4 240 300C240 311 231 320 220 320C214.4 320 209.4 317.8 205.8 314.2L165.8 274.2C162.2 270.6 160 265.6 160 260C160 254.4 162.2 249.4 165.8 245.8L205.8 205.8C209.4 202.2 214.4 200 220 200C231 200 240 209 240 220C240 225.6 237.8 230.6 234.2 234.2L228.2 240H260C271 240 280 231 280 220V160C280 149 289 140 300 140S320 149 320 160V220C320 253.2 293.2 280 260 280zM150 100C155.6 100 160 104.4 160 110C160 115.6 155.6 120 150 120S140 115.6 140 110C140 104.4 144.4 100 150 100zM200 180H20C9 180 0 171 0 160V20C0 9 9 0 20 0H200C211 0 220 9 220 20V160C220 171 211 180 200 180zM180 53.4L140 80L120 60L80 120L40 66.6V140H180V53.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ImageRotateLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ImageRotateLeft.displayName = "Blueprint5.Icon.ImageRotateLeft";
exports.default = ImageRotateLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3SZ3n":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImageRotateRight", ()=>ImageRotateRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ImageRotateRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "image-rotate-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M105.8 314.2C102.2 310.6 100 305.6 100 300C100 289 109 280 120 280C125.6 280 130.6 282.2 134.2 285.8L174.2 325.8C177.8 329.4 180 334.4 180 340C180 345.6 177.8 350.6 174.2 354.2L134.2 394.2C130.6 397.8 125.6 400 120 400C109 400 100 391 100 380C100 374.4 102.2 369.4 105.8 365.8L111.8 360H80C35.8 360 0 324.2 0 280V220C0 209 9 200 20 200S40 209 40 220V280C40 302 58 320 80 320H111.8L105.8 314.2zM310 140C326.6 140 340 153.4 340 170S326.6 200 310 200S280 186.6 280 170S293.4 140 310 140zM380 260H120C109 260 100 251 100 240V20C100 9 109 0 120 0H380C391 0 400 9 400 20V240C400 251 391 260 380 260zM360 60L260 120L240 80L200 160L140 70V220H360V60z" : "M114.2 205.8L154.2 245.8C157.8 249.4 160 254.4 160 260C160 265.6 157.8 270.6 154.2 274.2L114.2 314.2C110.6 317.8 105.6 320 100 320C89 320 80 311 80 300C80 294.4 82.2 289.4 85.8 285.8L91.8 280H60C26.8 280 0 253.2 0 220V160C0 149 9 140 20 140S40 149 40 160V220C40 231 49 240 60 240H91.8L85.8 234.2C82.2 230.6 80 225.6 80 220C80 209 89 200 100 200C105.6 200 110.6 202.2 114.2 205.8zM250 100C255.6 100 260 104.4 260 110C260 115.6 255.6 120 250 120S240 115.6 240 110C240 104.4 244.4 100 250 100zM300 180H120C109 180 100 171 100 160V20C100 9 109 0 120 0H300C311 0 320 9 320 20V160C320 171 311 180 300 180zM280 53.4L240 80L220 60L180 120L140 66.6V140H280V53.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ImageRotateRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ImageRotateRight.displayName = "Blueprint5.Icon.ImageRotateRight";
exports.default = ImageRotateRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1m1jq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Import", ()=>Import);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Import = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "import",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M185.8 85.8C189.4 82.2 194.4 80 200 80S210.6 82.2 214.2 85.8L314.2000000000001 185.8C317.8 189.4 320 194.4 320 200C320 211 311 220 300 220C294.4000000000001 220 289.4000000000001 217.8 285.8 214.2L220 148.2V380C220 391 211 400 200 400S180 391 180 380V148.2L114.2 214.2C110.6 217.8 105.6 220 100 220C89 220 80 211 80 200C80 194.4 82.2 189.4 85.8 185.8L185.8 85.8zM380 120C369 120 360 111 360 100V40H40V100C40 111 31 120 20 120S0 111 0 100V20C0 9 9 0 20 0H380C391 0 400 9 400 20V100C400 111 391 120 380 120z" : "M145.8 85.8C149.4 82.2 154.4 80 160 80S170.6 82.2 174.2 85.8L254.2 165.8C257.8 169.4 260 174.4 260 180C260 191 251 200 240 200C234.4 200 229.4 197.8 225.8 194.2L180 148.2V300C180 311 171 320 160 320S140 311 140 300V148.2L94.2 194.2C90.6 197.8 85.6 200 80 200C69 200 60 191 60 180C60 174.4 62.2 169.4 65.8 165.8L145.8 85.8zM300 100C289 100 280 91 280 80V40H40V80C40 91 31 100 20 100S0 91 0 80V20C0 9 9 0 20 0H300C311 0 320 9 320 20V80C320 91 311 100 300 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Import.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Import.displayName = "Blueprint5.Icon.Import";
exports.default = Import;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bRgL0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InboxFiltered", ()=>InboxFiltered);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var InboxFiltered = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "inbox-filtered",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M205.231458 340L244.4 300.8314576L244.4 299.8267822000001L93 299.8267822000001L39.6 179.906728L100 179.906728C111 179.906728 120 170.912724 120 159.920054L120 139.933378L280 139.933378L280 159.920054C280 170.912724 289 179.906728 300 179.906728L360.4 179.906728L347.697776 208.4320346L360.194112 221.0259976C367.270068 228.1016438 372.1609560000001 237.042888 374.332154 246.8147786L400 189.1006L400 59.986676C400 48.994004 391 40 380 40L20 40C9 40 0 48.994004 0 59.986676L0 189.1006L61.6 327.6082612L61.8 328.0079946C64.8 335.0033312 71.8 340 80 340L205.231458 340zM387 400C394.2000000000001 400 400 394.2 400 387.2C400 383.6 398.6 380.4 396.2 378L335.6 317.4L335.6 258.4C335.6 254.8 334.2000000000001 251.6 331.8 249.2L306.2 223.4C304 221.4 300.8 220 297.2 220C290.2 220 284.4000000000001 225.8 284.4000000000001 232.8L284.4000000000001 317.4L223.8 378C221.4 380.4 220 383.6 220 387.2C220 394.2 225.8 400 232.8 400L387 400z" : "M128.6391878 280C130.5165792 277.1908186 132.6815224 274.5499352 135.1157288 272.1157288L168.4024282 240L73.2 240L39 160L80 160C91 160 100 151 100 140L100 120L203.57666 120L231.148072 120C245.003886 120 258.403088 125.2345452 267.884272 134.7157288L269.935816 136.7672732L286.931742 159.5666864C294.958736 168.8815686 299.4000000000001 180.6911366 299.4000000000001 193.2L299.4000000000001 218.8336538L320 170.8L320 60C320 49 311 40 300 40L20 40C9 40 0 49 0 60L0 170.8L41.6 267.8C44.6 275 51.8 280 60 280L128.6391878 280zM309.6 320.0000000000002C315.8 320.0000000000002 320 314.8 320 308.6C320 305.4 318.8 302.6 316.6 300.4L259.4000000000001 245.8L259.4000000000001 193.2C259.4000000000001 190 258.2 187.2 256 185L239.6 163C237.6 161 234.6 159.6 231.4 159.6C225.2 159.6 220 164.8 220 171L220 245.8L163.4 300.4C161.2 302.6 160 305.4 160 308.6C160 314.8 165.2 320.0000000000002 171.4 320.0000000000002L309.6 320.0000000000002z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
InboxFiltered.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
InboxFiltered.displayName = "Blueprint5.Icon.InboxFiltered";
exports.default = InboxFiltered;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MM1s":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InboxGeo", ()=>InboxGeo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var InboxGeo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "inbox-geo",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M148.5352854 340C144.0486672 327.3061894 141.222194 313.8281574 140.316744 299.8267822000001L93 299.8267822000001L39.6 179.906728L100 179.906728C111 179.906728 120 170.912724 120 159.920054L120 139.933378L280 139.933378L280 140C283.307296 139.782174 286.637582 140 290 140C333.461084 140 372.6051 158.48356 400 188.01863L400 59.986676C400 48.994004 391 40 380 40L20 40C9 40 -5e-13 48.994004 -5e-13 59.986676L-5e-13 189.1006L61.6 327.6082612L61.8 328.0079946C64.8 335.0033312 71.8 340 80 340L148.5352854 340zM262.8300000000001 351.93C261.73 350.83 260.08 350.83 258.98 351.93L251.5 359.41C250.4 360.4 250.4 362.1600000000001 251.5 363.26C252.6 364.36 254.25 364.36 255.35 363.26L262.8300000000001 355.78C263.93 354.79 263.93 353.03 262.8300000000001 351.93zM297.7 351.27C296.71 351.27 295.94 351.38 295.94 352.37C295.94 353.36 296.71 353.4700000000001 297.7 353.4700000000001L301 353.4700000000001C301.99 353.4700000000001 302.76 353.36 302.76 352.37C302.76 351.38 301.99 351.27 301 351.27L297.7 351.27zM308.48 338.62C307.49 338.62 306.39 339.5 306.39 340.49L306.39 345.11C306.39 346.1 307.49 346.98 308.48 346.98C309.47 346.98 310.57 346.1 310.57 345.11L310.57 340.49C310.57 339.5 309.47 338.62 308.48 338.62zM236.98 292.53L247.1 292.53L270.75 268.55C270.86 268.44 270.75 268.44 270.75 268.3300000000001L270.75 259.42C270.75 255.68 268.22 252.6 264.37 252.6L262.39 252.6L262.39 248.09C262.39 244.24 259.64 242.15 255.79 242.15L256.01 242.15L256.01 226.31C256.01 222.57 252.38 219.6 248.64 219.6C244.9 219.6 241.27 222.57 241.27 226.31L241.27 252.71L236.98 252.71C233.13 252.71 230.82 255.68 230.82 259.53L230.82 285.6C230.82 289.45 233.13 292.53 236.98 292.53zM290 400C350.7200000000001 400 400 350.7200000000001 400 290C400 229.28 350.7200000000001 180 290 180C229.28 180 180 229.28 180 290C180 350.7200000000001 229.28 400 290 400zM290 202C338.62 202 378 241.38 378 290C378 295.94 377.45 301.66 376.02 307.27L371.29 307.27C367.55 307.27 364.58 309.36 364.36 313.54L357.98 313.54C360.18 311.45 362.6 309.36 362.6 306.61L362.6 292.53C362.6 290.77 361.5 289.12 360.4 287.91L359.9600000000001 287.91L359.74 287.8L359.3 287.58L345.99 274.7100000000001L345.99 250.51C345.99 246.66 343.9 243.91 340.05 243.91L329.27 243.91C325.42 243.91 322.89 246.66 322.89 250.51L322.89 275.59C320.8 280.65 317.2800000000001 283.8400000000001 312.2200000000001 285.93L298.8 285.93C294.95 285.93 291.43 288.79 291.43 292.64L291.43 306.39C291.43 310.24 294.95 313.32 298.8 313.32L302.65 313.43L309.03 319.81C311.7800000000001 322.56 316.07 322.56 318.82 319.81L325.2000000000001 313.43C325.31 313.43 325.31 313.32 325.31 313.32L339.39 313.32C342.5800000000001 313.32 344.12 316.51 346.2100000000001 319.5900000000001L346.2100000000001 321.79C346.2100000000001 321.79 345.55 321.68 345.44 321.68L340.05 321.68C338.4000000000001 321.68 336.9700000000001 323.11 336.9700000000001 324.87C336.9700000000001 326.63 338.29 328.06 340.05 328.06L345.44 328.06C345.55 328.06 346.2100000000001 327.95 346.2100000000001 327.95L346.2100000000001 331.58C346.2100000000001 331.58 345.22 332.35 345 332.35L338.9500000000001 332.35L337.63 330.81C334.99 328.06 330.59 327.8400000000001 327.84 330.5900000000001L326.52 332.35L323 332.35L327.9500000000001 327.18C328.39 326.74 328.39 325.42 327.9500000000001 324.98C327.4000000000001 324.54 326.63 324.43 326.19 324.87L320.36 330.37L317.8300000000001 330.37L310.57 323.88L309.91 323.99C309.14 321.79 308.1500000000001 322.23 307.05 322.23C304.5200000000001 322.23 302.54 323.66 302.54 326.08C302.54 328.61 304.5200000000001 330.26 307.05 330.26L310.57 330.26C310.57 330.26 310.57 333.01 310.57 333.89C310.57 335.65 311.7800000000001 336.53 313.54 336.53L314.86 336.53L314.86 339.06C314.86 341.92 317.8300000000001 345 320.58 345L326.19 345C329.38 345 331.5800000000001 347.31 331.5800000000001 350.5L331.5800000000001 351.6C331.5800000000001 351.93 332.68 351.27 332.68 353.36L328.94 353.36C328.94 353.36 328.8300000000001 353.03 328.8300000000001 353.03L322.67 346.43C321.68 345.44 320.1400000000001 345.44 319.15 346.43C318.16 347.31 318.16 348.85 319.15 349.8400000000001L326.96 357.54C327.51 357.98 328.17 357.98 328.8300000000001 357.98C328.8300000000001 357.98 328.94 357.54 328.94 357.54L346.32 357.54C331.0300000000001 370.3 311.45 378 290 378C268.55 378 248.97 370.3 233.68 357.65L245.34 357.65C247.21 357.65 248.64 356.33 248.64 354.46C248.64 352.5900000000001 247.21 351.27 245.34 351.27L235.77 351.27C235.77 349.18 235 350.06 235 349.95L235 342.9100000000001L243.58 342.9100000000001L248.09 347.9700000000001C250.73 350.5 255.02 351.05 257.55 348.4100000000001C260.19 345.88 260.19 341.59 257.55 338.95L233.9 315.3L233.68 315.08C233.57 314.9700000000001 233.46 314.9700000000001 233.35 314.86C233.13 314.75 232.91 314.64 232.69 314.42C232.58 314.31 232.47 314.42 232.36 314.31C231.37 313.65 230.16 313.54 228.84 313.54L221.91 313.54C219.49 311.45 218.17 310.57 218.17 308.15L218.17 306.39C218.17 306.06 217.62 305.8400000000001 217.62 305.51L228.84 293.74C230.05 292.53 229.94 290.6600000000001 228.84 289.56C227.74 288.35 225.76 288.35 224.66 289.56L213.11 301.11C212.56 301 212.01 300.89 211.46 300.89C208.38 300.89 205.63 303.31 205.63 306.39L205.63 313.54L205.3 313.54C203.21 306.06 202 298.14 202 290C202 241.38 241.38 202 290 202zM357.7600000000001 264.15C359.3 264.15 360.95 262.94 360.95 261.4L360.95 252.93C360.95 251.39 359.3 250.18 357.7600000000001 250.18C356.2200000000001 250.18 354.57 251.39 354.57 252.93L354.57 261.4C354.57 262.94 356.2200000000001 264.15 357.7600000000001 264.15zM295.5 361.7200000000001C295.5 357.98 292.42 355.45 288.79 355.45L281.31 355.45L281.31 353.36C281.31 351.16 280.32 349.4 278.12 349.4C275.92 349.4 274.93 351.16 274.93 353.36L274.93 360.4C272.84 360.8400000000001 274.27 360.95 274.27 361.5C274.27 365.24 276.8 367.99 280.54 367.99L288.68 367.99C292.42 367.99 295.5 365.46 295.5 361.7200000000001z" : "M126.8282284 280C122.4061688 267.488843 120 254.025417 120 240L73.2 240L39 160L80 160C91 160 100 151 100 140L100 120L220 120C220.086362 120.0037422 220.172828 120 220.2594 120C227.244444 120 233.272882 120 240 120C270.7341780000001 120 298.76974 131.5541428 320 150.5557398L320 60C320 49 311 40 300 40L20 40C9 40 -1.5e-12 49 -1.5e-12 60L-1.5e-12 170.8L41.6 267.8C44.6 275 51.8 280 60 280L126.8282284 280zM200.4 237.1C200.4 239.6 201.9 241.7 204.5 241.6L211.4 241.6L227.2 225.6C227.3 225.6 227.2 225.5 227.2 225.5L227.2 219.6C227.2 217 225.5 215 222.9 215L221.5 215L221.5 212C221.5 209.4 219.7 208 217.2 208L217.2 197.3C217.2 194.8 214.8 192.8 212.3 192.8C209.8 192.8 207.4 194.8 207.4 197.3L207.4 215L204.5 215C202 215 200.4 217 200.4 219.6L200.4 237.1zM245.1 281C244.5 281 244 281.1 243.9 281.7C243.9 282.3 244.5 282.4 245.1 282.4L247.3 282.4C248 282.4 248.5 282.3 248.5 281.7C248.5 281.1 247.9 281 247.3 281L245.1 281zM221.8 281.5C221.1 280.8 219.9 280.8 219.2 281.5L214.2 286.5C213.5 287.2 213.5 288.4 214.2 289.1C214.9 289.8 216.1 289.8 216.8 289.1L221.8 284.1C222.5 283.4 222.5 282.2 221.8 281.5zM252.4 272.6C251.7 272.6 251 273.1 251 273.8L251 276.9C251 277.5 251.7 278.1 252.4 278.1C253.1 278.1 253.8 277.6 253.8 276.9L253.8 273.8C253.8 273.2 253.1 272.6 252.4 272.6zM240 320C284.2000000000001 320 320 284.2 320 240C320 195.8 284.2000000000001 160 240 160C195.8 160 160 195.8 160 240C160 284.2 195.8 320 240 320zM240 180C273.1 180 300 206.9 300 240C300 243.9 299.6 247.8 298.8 251.5L294.6 251.5C292.1 251.5 290.1 252.9 290 255.7L285.7 255.7C287.2 254.3 288.8 252.9 288.8 251.1L288.8 242C288.8 240.8 288 239.7 287.3 238.9L287 238.9L286.8 238.8L286.5 238.6L277.6 230L277.6 213.7C277.6 211.1 276.2 209.3 273.6 209.3L266.4 209.3C263.9 209.3 262.2 211.1 262.2 213.7L262.2 230.5C260.7 233.9 258.4 236 255 237.4L246 237.4C243.4 237.4 241.1 239.3 241.1 241.9L241.1 251.1C241.1 253.6 243.4 255.7 246 255.7L248.6 255.8L252.8 260.1C254.6 261.9 257.6 261.9 259.4000000000001 260.1L263.8 255.6L273.2 255.6C275.3 255.6 276.3 257.7 277.7 259.8L277.7 261.3C277.7 261.3 277.2 261.3 277.2 261.3L273.6 261.3C272.4 261.3 271.5 262.3 271.5 263.4C271.5 264.5 272.5 265.5 273.6 265.5L277.2 265.5C277.2 265.5 277.7 265.4 277.7 265.4L277.7 267.8C277.7 267.8 277.1 268.3 276.9000000000001 268.3L272.9 268.3L272 267.3C270.2 265.5 267.2 265.4 265.4 267.2L264.5 268.4L262.2 268.4L265.4 264.9C265.7 264.6 265.7 263.7 265.4 263.4C265 263.1 264.5 263 264.2000000000001 263.3L260.3 267L258.6 267L253.7 262.4L253.3 262.5C252.8 261.1 252.1 261.4 251.4 261.4C249.7 261.4 248.4 262.3 248.4 264C248.4 265.7 249.7 266.8 251.4 266.8L253.7 266.8C253.7 266.8 253.7 268.7 253.7 269.3C253.7 270.5 254.5 271.1 255.7 271.1L256.7000000000001 271.1L256.7000000000001 272.8C256.7000000000001 274.7 258.6 276.8 260.5 276.8L264.3 276.8C266.4 276.8 267.9 278.3 267.9 280.5L267.9 281.2C267.9 281.5 268.6 281 268.6 282.4L266.1 282.4C266.1 282.4 266 282.2 266 282.2L261.8 277.8C261.2 277.2 260.1 277.2 259.5 277.8C258.9 278.4 258.9 279.5 259.5 280.1L264.6 285.2C265 285.5 265.5 285.5 265.9 285.5C266 285.5 266 285.2 266 285.2L278.8 285.2C276.6 287.3 274.2000000000001 289.1 271.7000000000001 290.7C269.4000000000001 292.2 267.1 293.5 264.6 294.6C264 294.9 263.5 295.2 263 295.4C255.9 298.3 248.2 300 240 300C236 300 232.1 299.6 228.3 298.9C226.5 298.5 224.8 297.8 223 297.3C221.2 296.7 219.4 296.3 217.7 295.6C216.2 295 214.8 294.2 213.3 293.5C211 292.3 208.6 291.2 206.5 289.8C206.5 289.8 206.4 289.7 206.4 289.7C204.4 288.4 202.8 286.8 201 285.3L210.1 285.3C211.3 285.3 212.3 284.4 212.3 283.2C212.3 282 211.3 281.1 210.1 281.1L203.7 281.1C203.7 279.7 203.2 280.3 203.2 280.2L203.2 275.4L208.9 275.4L211.9 278.8C213.7 280.6 216.6 280.9 218.4 279.1C220.2 277.3 220.2 274.5 218.4 272.7L202.5 256.9L202.3 256.7C202.2 256.7 202.2 256.7 202.1 256.6C201.9 256.5 201.8 256.4 201.6 256.3C201.6 256.3 201.5 256.3 201.4 256.3C200.7 255.9 199.9 255.8 199 255.8L194.4 255.8C192.8 254.4 191.9 253.8 191.9 252.2L191.9 251C191.9 250.8 191.5 250.6 191.5 250.4L199 242.6C199.8 241.8 199.8 240.6 199 239.8C198.2 239 197 239 196.2 239.8L188.4 247.5C188.1 247.4 187.6 247.3 187.3 247.3C185.2 247.3 183.4 249 183.4 251L183.4 255.7L182.6 255.7C182.5 255.7 182.4 255.7 182.3 255.7C181 250.7 180 245.5 180 240C180 206.9 206.9 180 240 180zM285.4 222.7C286.4 222.7 287.5 221.9 287.5 220.9L287.5 215.2C287.5 214.2 286.4 213.4 285.4 213.4C284.4000000000001 213.4 283.3 214.2 283.3 215.2L283.3 220.9C283.3 221.9 284.4000000000001 222.7 285.4 222.7zM243.7 288.1C243.7 285.5 241.6 283.9 239.2 283.9L234.2 283.9L234.2 282.5C234.2 281 233.6 279.8 232.1 279.8C230.6 279.8 230 281 230 282.5L230 287.2C228.5 287.6 229.5 287.7 229.5 288C229.5 290.5 231.2 292.3 233.7 292.3L239.1 292.3C241.7 292.3 243.7 290.6 243.7 288.1z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
InboxGeo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
InboxGeo.displayName = "Blueprint5.Icon.InboxGeo";
exports.default = InboxGeo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hjA0I":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InboxSearch", ()=>InboxSearch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var InboxSearch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "inbox-search",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M142.726983 340C140.9398976 331.5487208 140 322.7846278 140 313.8C140 309.0767130000001 140.2597198 304.4144916 140.7656286 299.8267822000001L93 299.8267822000001L39.6 179.906728L100 179.906728C111 179.906728 120 170.912724 120 159.920054L120 139.933378L280 139.933378L280 159.920054C280 170.912724 289 179.906728 300 179.906728L321.524728 179.906728L344.315728 157.115728C354.811476 146.619982 368.86143 141 383.8 141C389.4343340000001 141 394.873776 141.839462 400 143.400058L400 59.986676C400 48.994004 391 40 380 40L20 40C9 40 1.3e-12 48.994004 1.3e-12 59.986676L1.3e-12 189.1006L61.6 327.6082612L61.8 328.0079946C64.8 335.0033312 71.8 340 80 340L142.726983 340zM207.6 313.4C207.6 281 233.8 254.8 266.2 254.8C298.6 254.8 324.8 281 324.8 313.4C324.8 345.8 298.6 372 266.2 372C233.8 372 207.6 345.8 207.6 313.4zM337 264.8L394.8 207.8C397.4000000000001 204.8 399.2000000000001 200.8 399.4 196.6C399.4 188 392.4000000000001 181 383.8 181C379.2000000000001 181 375.4 182.6 372.6 185.4L315.2 242.8C311.8 240.8 308.6 238.8 305 237C304.4000000000001 236.8 303.8 236.4 303.2 236.2C299.6 234.8 296.2 233.2 292.2 232C288.4 230.8 284.8 229.8 280.8 229.2C279.8 229 278.8 228.8 278 228.8C274 228.2 270.2 227.8 266 227.8C218.6 227.8 180 266.2 180 313.8C180 361.4 218.6 399.8 266 399.9999999999996C313.4 399.9999999999996 352 361.4 352 314C352 309.8 351.6 306 351 302C350.8 301 350.8 300.2 350.6 299.2C349.8 295.2 349 291.6 347.8 287.6C346.8 283.8 345.2000000000001 280.4 343.6 276.8C343.4000000000001 276.2 343 275.6 342.8 275C341.2 271.4 339.2000000000001 268.2 337 264.8z" : "M112.7705878 280C110.4407516 271.1896348 109.2 261.9382674 109.2 252.4C109.2 248.2067406 109.4397712 244.0690258 109.9063422 240L73.2 240L39 160L80 160C91 160 100 151 100 140L100 120L220 120L220 140C220 141.7634362 220.2313 143.4754722 220.665062 145.1072678C223.073024 145.2326756 225.415952 145.4740282 228.475624 145.8623638C231.548026 146.0104214 233.500944 146.44418 237.301426 147.3943C239.047232 147.7258194 240.592146 148.0412844 242.102028 148.4L243.091106 148.4L245.531256 149.2133836L270.852806 123.7787926C279.358166 114.361742 293.189408 108.4 307.8 108.4C312.003008 108.4 316.087866 108.893288 320 109.825288L320 60C320 49 311 40 300 40L20 40C9 40 -5e-13 49 -5e-13 60L-5e-13 170.8L41.6 267.8C44.6 275 51.8 280 60 280L112.7705878 280zM316.4 169.4C318.4 167 319.8 164 320 160.6C320 153.8 314.6 148.4 307.8 148.4C304.2000000000001 148.4 301.2 149.8 299.2000000000001 152L254.4 197C251.8 195.4 249.2 193.8 246.4 192.4C246 192.2 245.4 192 245 191.8C242.2 190.6 239.6 189.4 236.6 188.4L236.4 188.4C233.6 187.4 230.6 186.8 227.6 186.2C226.8 186 226 185.8 225.4 185.8C222.4 185.4 219.4 185 216.2 185C179.2 185 149.2 215.2 149.2 252.4C149.2 289.6 179.2 319.8 216.2 320.0000000000004C253.2 320.0000000000004 283.2 289.8 283.2 252.6C283.2 249.4 282.8 246.4 282.4 243.2C282.2 242.4 282.2 241.8 282 241C281.6 238 281 235.2 280 232.2L280 232C279 229 277.8 226.4 276.6 223.6C276.4 223.2 276.2 222.6 276 222.2C274.6 219.4 273.2 216.8 271.4 214.2L316.4 169.4zM216.2 208.2C240.6 208.2 260.4 228 260.4 252.6C260.4 277.2 240.6 297 216.2 297C191.8 297 172 277.2 172 252.6C172 228.2 191.8 208.2 216.2 208.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
InboxSearch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
InboxSearch.displayName = "Blueprint5.Icon.InboxSearch";
exports.default = InboxSearch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4LDwr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InboxUpdate", ()=>InboxUpdate);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var InboxUpdate = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "inbox-update",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M201.659168 340C200.567976 333.4958306 200 326.8142442 200 320C200 313.1252492 200.578108 306.3855226 201.68836 299.8267822000001L93 299.8267822000001L39.6 179.906728L100 179.906728C111 179.906728 120 170.912724 120 159.920054L120 139.933378L280 139.933378L280 159.920054C280 170.912724 289 179.906728 300 179.906728L360.4 179.906728L349.7927440000001 203.727379C362.96233 207.0917858 375.2603220000001 212.6347388 386.2801580000001 219.9496794L400 189.1006L400 59.986676C400 48.994004 391 40 380 40L20 40C9 40 0 48.994004 0 59.986676L0 189.1006L61.6 327.6082612L61.8 328.0079946C64.8 335.0033312 71.8 340 80 340L201.659168 340zM320 240C275.81722 240 240 275.81722 240 320C240 364.18278 275.81722 400 320 400C364.18278 400 400 364.18278 400 320C400 275.81722 364.18278 240 320 240z" : "M162.0003624 280C160.6886052 273.5378012 160 266.8493168 160 260C160 253.1506832 160.688675 246.4621988 162.0005458 240L73.2 240L39 160L80 160C91 160 100 151 100 140L100 120L220 120L220 140C220 151 229 160 240 160L260 160L281 160C295.163558 160 308.041738 164.8244742 319.0994 172.8999574L320 170.8L320 60C320 49 311 40 300 40L20 40C9 40 0 49 0 60L0 170.8L41.6 267.8C44.6 275 51.8 280 60 280L162.0003624 280zM260 200C226.862916 200 200 226.862915 200 260C200 293.137085 226.862916 320 260 320C293.137084 320 320 293.137085 320 260C320 226.862915 293.137084 200 260 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
InboxUpdate.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
InboxUpdate.displayName = "Blueprint5.Icon.InboxUpdate";
exports.default = InboxUpdate;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lDykF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Inbox", ()=>Inbox);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Inbox = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "inbox",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M338.4000000000001 328.8L338.4000000000001 328.8L338.2 329.2L338.2 329.2C335 336.2 328.2 341.2 320 341.2H80C71.8 341.2 64.8 336.2 61.8 329.2L61.8 329.2L61.6 328.8L61.6 328.8L0 190.2V61C0 50 9 41 20 41H380C391 41 400 50 400 61V190.2000000000001L338.4000000000001 328.8zM300 181C289 181 280 172 280 161V141H120V161C120 172 111 181 100 181H39.6L93 301H307L360.4 181H300z" : "M278.2 268C278.2 268 278.2 268 278.2 268L278.2 268L278.2 268C275 275.2 268 280.2 259.8 280.2H59.8C51.6 280.2 44.4 275.2 41.4 268L41.4 268L41.4 268C41.4 268 41.4 268 41.4 268L-0.2 171V60.2000000000001C-0.2 49.2 8.8 40.2 19.8 40.2H299.8C310.8 40.2 319.8 49.2 319.8 60.2000000000001V171L278.2 268zM239.8 160.2C228.8 160.2 219.8 151.2 219.8 140.2V120.2H99.8V140.2C99.8 151.2 90.8 160.2 79.8 160.2H38.8L73 240.2H246.6L280.8 160.2H239.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Inbox.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Inbox.displayName = "Blueprint5.Icon.Inbox";
exports.default = Inbox;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cSMcB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InfoSign", ()=>InfoSign);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var InfoSign = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "info-sign",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM180 320H220V280H180V320zM260 80H140V100H180V240H160V260H220V100H260V80z" : "M160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM140 260H180V220H140V260zM200 60H120V80H140V180H120V200H180V80H200V60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
InfoSign.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
InfoSign.displayName = "Blueprint5.Icon.InfoSign";
exports.default = InfoSign;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cr2Za":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Inheritance", ()=>Inheritance);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Inheritance = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "inheritance",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 200C120 155.8 155.8 120 200 120L331.8 120L286 165.8C282.2 169.4 280 174.4 280 180C280 191 289 200 300 200C305.6 200 310.6 197.8 314.2000000000001 194.2L394.2000000000001 114.2000000000001C397.8 110.6 400 105.6 400 100C400 94.4 397.8 89.4 394.2000000000001 85.8L314.2000000000001 5.8C310.6 2.2 305.6 0 300 0C289 0 280 9 280 20C280 25.6 282.2 30.6 285.8 34.2L331.8 80L200 80C133.8 80 80 133.8 80 200L20 200C8.954305 200 0 208.954305 0 220L0 380C0 391.045695 8.954305 400 20 400L180 400C191.045695 400 200 391.045695 200 380L200 220C200 208.954305 191.045695 200 180 200L120 200zM40 360L40 240L160 240L160 360L40 360z" : "M100 160C100 126.8 126.8 100 160 100L251.8 100L226 125.8C222.2 129.4 220 134.4 220 140C220 151 229 160 240 160C245.6 160 250.6 157.8 254.2 154.2L314.2000000000001 94.2C317.8 90.6 320 85.6 320 80C320 74.4 317.8 69.4 314.2000000000001 65.8L254.2 5.8C250.6 2.2 245.6 0 240 0C229 0 220 9 220 20C220 25.6 222.2 30.6 225.8 34.2L251.8 60L160 60C104.8 60 60 104.8 60 160L20 160C8.954305 160 0 168.954305 0 180L0 300C0 311.045695 8.954305 320 20 320L140 320C151.045695 320 160 311.045695 160 300L160 180C160 168.954305 151.045695 160 140 160L100 160zM40 280L40 200L120 200L120 280L40 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Inheritance.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Inheritance.displayName = "Blueprint5.Icon.Inheritance";
exports.default = Inheritance;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtq8D":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InheritedGroup", ()=>InheritedGroup);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var InheritedGroup = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "inherited-group",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 220C31 220 40 211 40 200L40 200L40 120C40 98 58 80 80 80L80 80L131.8 80L125.8 85.8C122.2 89.4 120 94.4 120 100C120 111 129 120 140 120C145.6 120 150.6 117.8 154.2 114.2000000000001L154.2 114.2000000000001L194.2 74.2000000000001C197.8 70.6 200 65.6 200 60C200 54.4 197.8 49.4 194.2 45.8L194.2 45.8L154.2 5.8C150.6 2.2 145.6 0 140 0C129 0 120 9 120 20C120 25.6 122.2 30.6 126 34.2L126 34.2L131.8 40L80 40C35.8 40 -1.85e-11 75.8 -1.85e-11 120L-1.85e-11 120L-1.85e-11 200C-1.85e-11 211 9 220 20 220zM159.9204376 400C175.713683 400 193.5060736 395 206.100688 385.4C218.495386 376.2 227.491538 362.8 231.889658 348.2C232.88923 344.8 233.688888 341.6 234.088718 338.2C236.287776 326.2 237.487264 307.8 237.487264 295.2L237.487264 293.4C241.885382 291.6 245.883672 287 246.883246 277C247.482988 269.2 244.484272 262.4 242.884956 259.6C241.485554 252.8 237.487264 245.4 230.69017 244C229.890512 240.8 228.89094 237.4 227.691454 234.4C227.491538 234.2 227.291624 233.4 227.291624 233.4C221.893932 219.2 213.697438 206.8 203.501798 197.8C203.501798 196.2 203.501798 194.6 203.701714 193.2C204.701286 182.2 200.702996 174.2 230.290342 161.2C259.677774 148 304.258706 134.2000000000001 313.854604 113.4C322.850756 92.4 319.252294 80 319.252294 80L214.72721 79.985364C212.990072 83.023832 210.849022 85.835248 208.342136 88.342136L168.3421356 128.3421360000001C160.901996 135.782276 150.7794564 140 140 140C117.954305 140 100 122.045694 100 100L80 100C69.045695 100 60 109.045694 60 120L60.0089672 149.239616C70.221246 153.492204 80.4546202 157.491302 89.3506188 161.4C118.9379648 174.4 115.9392474 182.4 116.9388198 193.2L117.1387344 197.4L117.1387344 197.4C106.7431804 206.4 98.1468568 219 92.7491652 233.4L92.5492508 233.6L92.3493362 234.2L92.3493362 234.2C90.9499348 237.2 89.9503622 240.6 89.1507042 244C82.3536112 245.2 78.3553212 252.6 76.7560052 259.6C75.1566892 262.4 71.9580572 269.2 72.7577152 277C73.7572878 287.2 77.9554922 291.8 82.5535258 293.6L82.5535258 295.2C82.5535258 308 83.5530982 326.2 85.9520722 338.2C86.3519012 341.6 87.1515592 345 88.1511318 348.2C92.5492508 363 101.7453178 376.2 113.9401024 385.4C126.3348014 395 144.127192 400 159.9204376 400zM279.869138 340C291.664094 340 305.058364 336.2 314.454346 329C323.650414 322 330.447506 312 333.846054 301C334.645712 298.4 335.245454 296 335.44537 293.4C337.044686 284.4 338.044258 270.6 338.044258 261.2L338.044258 259.8C341.24289 258.4 344.2416080000001 255 345.041266 247.4C345.441094 241.6 343.242034 236.4 342.042548 234.4C341.042976 229.2 338.044258 223.8 332.84648 222.6C332.246738 220.2 331.4470800000001 217.6 330.647422 215.4C330.447506 215.2 330.447506 214.6 330.447506 214.6C326.4492160000001 204 320.251868 194.6 312.655116 187.8C312.655116 186.6 312.655116 185.4 312.85503 184.4C313.654688 176.2 310.655972 170.2 332.84648 160.6C354.837076 150.6 388.222798 140.4 395.41972 124.8C402.216812 109 399.41801 99.8 399.41801 99.8L338.644002 99.8L338.644002 100C337.4445140000001 106.6 335.245454 113.8 332.046822 121.2C323.0506700000001 140.6 304.658536 151.6 267.274524 167.2C263.8759780000001 168.6 252.081022 173.4 251.881108 173.6C249.881962 174.4 247.882818 175.2 246.283502 176C247.283074 178.8 247.08316 181.8 247.482988 185L247.682904 188.2L247.682904 188.2C242.68504 192.4 238.286922 197.8 234.68846 204C239.08658 210.8 242.884956 218.2 245.883672 226.4L246.44 227.96L246.402202 227.7C246.370964 227.525 246.33348 227.3 246.283502 227L247.482988 230C254.67991 235.2 259.477858 243.4 261.876832 252.6C265.475294 260 267.674354 269 266.874696 278.6C265.875122 288.6 262.67649 297 257.478714 303C257.078884 313.6 256.279226 325.2 255.07974 334.8C262.67649 338.2 271.672644 340 279.869138 340z" : "M20 180C30.2142858 180 38.7040816 172.239796 39.864796 162.3239796L40 160L40 100C40 89.785714 47.760204 81.295918 57.6760204 80.135204L60 80L91.8 80L85.8 85.8C82.2 89.4 80 94.4 80 100C80 111 89 120 100 120C104.6666666 120 108.9166666 118.472222 112.287037 115.87963L114.2 114.2L154.2 74.2C157.8 70.6 160 65.6 160 60C160 55.333334 158.4722222 51.083334 155.8796296 47.712962L154.2 45.8L114.2 5.8C110.6 2.2 105.6 0 100 0C89 0 80 9 80 20C80 24.8 81.6163266 29.159184 84.471137 32.57376L86 34.2L91.8 40L60 40C27.9857142 40 1.92244898 64.919898 0.1016217202 96.468276L0 100L0 160C0 171 9 180 20 180zM127.7513428 320C140.3398506 320 154.526899 315.8 164.5177782 308C174.1090222 300.4 181.5022728 289.8 184.8991718 277.6C185.698442 275 186.2978948 272.2 186.69753 269.6C188.4958882 260 189.4949762 245.2 189.4949762 235L189.4949762 233.6C193.0916926 232 196.288774 228.2 196.8882268 220.2C197.4876796 213.8 195.0898686 208.4 193.6911454 206C192.49224 200.4 189.4949762 194.4 184.0999014 193.4C183.5004486 190.8 182.7011784 188.2 181.7020904 185.6C181.7020904 185.4 181.5022728 184.8 181.5022728 184.8C177.106286 173.2 170.5123058 163.2 162.5196024 155.8L162.5196024 152.2C163.3188726 143.2 160.1217914 136.8 183.7002662 126.2C207.278742 115.6 242.646454 104.4 249.839886 87.2C257.233138 70 254.235874 60 254.235874 60L180 60L180 60C180 70.779456 175.7822752 80.901996 168.3421356 88.342136L128.3421356 128.3421356C120.901996 135.7822752 110.7794564 140 100 140C97.022899 140 94.0771294 140.3002186 91.162691 140.9006558C93.1347932 144.6913718 92.8089732 148.283041 93.1829008 152.4C93.1829008 153.4 93.3827184 154.6 93.3827184 155.8C85.1901974 162.8 78.3963996 173 74.0004128 184.8L74.0004128 185C74.0004128 185 73.8005952 185.2 73.8005952 185.4C73.0013248 187.8 72.002237 190.6 71.4027842 193.2C65.8078918 194.2 62.6108104 200.4 61.411905 206C60.2129994 208.4 57.6153708 213.8 58.2148236 220.2C59.014094 228.4 62.4109928 232.2 66.0077094 233.8L66.0077094 235C66.0077094 245.2 67.0067974 260.2 68.8051556 269.8C69.2047908 272.4 69.8042434 275.2 70.6035138 277.8C74.0004128 289.8 81.3936634 300.4 90.9849074 308C100.9757866 315.8 115.162835 320 127.7513428 320zM220.266884 279.2C230.057946 279.2 241.24773 276 249.040616 270C256.633684 264.2 262.4283940000001 256 265.026022 246.6C265.625476 244.6 266.02511 242.4 266.4247460000001 240.4C267.823468 233 268.62274 221.6 268.62274 213.8L268.62274 212.8C271.420186 211.6 274.017814 208.6 274.4174500000001 202.6C274.817084 197.6 273.018726 193.6 271.81982 191.8C270.820732 187.6 268.62274 183 264.2267520000001 182.2C263.827118 180.2 263.227664 178.2 262.4283940000001 176.2C262.4283940000001 176 262.2285760000001 175.6 262.2285760000001 175.6C258.831678 166.8 253.63642 159 247.242258 153.4L247.242258 150.6C247.84171 143.6 245.4439 138.8 263.827118 130.6C282.410152 122.4 310.184796 113.8 315.77969 100.6C321.5744000000001 87.4 319.1765880000001 79.8 319.1765880000001 79.8L273.218544 79.8L273.218544 79.6C272.2194560000001 84.4 270.421098 89.6 268.223104 94.8C261.029672 112 245.843534 121.4 214.472174 134.8C211.674728 136 202.682936 139.8 202.48312 139.8C198.2869498 141.6 195.289686 142.8 192.49224 144.2C192.891875 146.2 192.891875 148.2 193.0916926 150.4C193.0916926 151.2 193.2915102 152 193.2915102 153C191.8927872 154.2 190.6938816 155.4 189.4949762 156.8C193.890963 163.2 197.4876796 170.2 200.285126 177.8C200.68476 179 200.68476 179 200.884578 179.8C206.679288 184.4 210.475822 191.2 212.673816 199C215.870898 205.6 217.669256 213.6 216.869986 222.2C216.270532 230.2 213.672904 237.4 209.476734 242.8C209.0771 253.4 208.078012 265.4 206.47947 273.6C206.279654 274.8 206.079836 276 205.880018 277.4C210.475822 278.6 215.471262 279.2 220.266884 279.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
InheritedGroup.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
InheritedGroup.displayName = "Blueprint5.Icon.InheritedGroup";
exports.default = InheritedGroup;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6aYI4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InnerJoin", ()=>InnerJoin);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var InnerJoin = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "inner-join",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M174 306C148 280 130 242 130 200S146 120 174 94C158 84 140 80 120 80C54 80 0 134 0 200S54 320 120 320C140 320 158 316 174 306zM107.2 121C96.2 145 90 171.8 90 200S96.2 255 107.2 279C69 272.8 40 239.8 40 200S69 127.2 107.2 121zM280 320C346 320 400 266 400 200S346 80 280 80C260 80 242 84 226 94C252.0000000000001 120 270 158 270 200S254 278 226 306C242 316 260 320 280 320zM292 279C303 255 309.2 228.2 309.2 200S303 145 292 121C330 127.2000000000001 359.2000000000001 160.2000000000001 359.2000000000001 200S330 272.8 292 279zM200 290C176 266 160 236 160 200S176 134 200 112C224 134 240 166 240 202S224 268 200 290z" : "M132 254C106 232 90 198 90 160S106 88 132 66C122 62 112 60 100 60C44 60 0 104 0 160S44 260 100 260C112 260 122 258 132 254zM92.8 80.4C78.4 103.4 70 130.8 70 160S78.4 216.6 92.8 239.6C52 236 20 201.8 20 160S52 84 92.8 80.4zM160 240C136 222 120 192 120 160S136 98 160 80C184 98 200 126 200 160S184 222 160 240zM220 260C276 260 320 216 320 160S276 60 220 60C208 60 198 62 188 66C214 88 230 124 230 160S214 230 188 254.0000000000001C198 258 208 260 220 260zM227 239.6C241.6 216.6 249.8 189.2 249.8 160S241.4 103.4 227 80.4C267.8 84 299.8 118.4 299.8 160S267.8 236 227 239.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
InnerJoin.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
InnerJoin.displayName = "Blueprint5.Icon.InnerJoin";
exports.default = InnerJoin;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3LNmK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Input", ()=>Input);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Input = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "input",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 200C400 89.8 310.2 0 200 0C176.6 0 153.6 4 131.6 12C121.2 15.8 115.8 27.2 119.6 37.6C123.4 48 134.8 53.4 145.2 49.6C162.8 43.2 181.2 40 200 40C288.2 40 360 111.8 360 200C360 288.2 288.2 360 200 360C181.2 360 162.8 356.8 145.2 350.4C134.8 346.6 123.4 352 119.6 362.4C115.8 372.8 121.2 384.2 131.6 388C153.6 396 176.6 400 200 400C310.2 400 400 310.2 400 200zM314.2000000000001 214.2L234.2 294.2C230.6 297.8 225.6 300 220 300C209 300 200 291 200 280C200 274.4 202.2 269.4 205.8 265.8L251.8 220H20C8.9543 220 0 211.0456 0 200C0 188.954 8.9543 180 20 180H251.8L206 134.2000000000001C202.2 130.6 200 125.6 200 120C200 109 209 100 220 100C225.6 100 230.6 102.2 234.2 105.8L314.2000000000001 185.8C317.8 189.4 320 194.4 320 200C320 205.6 317.8 210.6 314.2000000000001 214.2z" : "M160 0C248.2 0 320 71.644 320 160.1C320 248.5554 248.2 320 160 320C141.2 320 122.8 316.798 105.2 310.394C94.8 306.59162 89.4 295.1844 93.2 284.778C97 274.3714 108.4 268.9682 118.8 272.7704C132 277.5734 145.8 279.975 159.8 279.975C226 279.975 279.8 226.1414 279.8 159.9C279.8 93.658 226 39.824 159.8 39.824C145.8 39.824 132 42.226 118.8 47.03C108.4 50.832 97 45.428 93.2 35.022C89.4 24.616 94.8 13.208 105.2 9.406C122.8 3.002 141.2 0 160 0zM234.2 174.1088C237.8 170.5066 240 165.5034 240 159.9C240 154.2964 237.8 149.2934 234.2 145.691L174.2 85.654C170.6 82.052 165.6 79.85 160 79.85C149 79.85 140 88.856 140 99.862C140 105.466 142.2 110.47 146 114.072L171.8 139.8874H20C9 139.8874 0 148.893 0 159.9C0 170.9068 9 179.9124 20 179.9124H171.8L145.8 205.7286C142.2 209.3308 140 214.334 140 219.9374C140 230.9444 149 239.95 160 239.95C165.6 239.95 170.6 237.7486 174.2 234.1464L234.2 174.1088z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Input.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Input.displayName = "Blueprint5.Icon.Input";
exports.default = Input;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"65daK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Insert", ()=>Insert);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Insert = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "insert",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400H20C8 400 0 392 0 380V20C0 10 8 0 20 0H380C390 0 400 10 400 20V380C400 392 390 400 380 400L380 400zM360 40H40V360H360V40L360 40zM100 180H180V100C180 88 188 80 200 80S220 88 220 100V180H300C312 180 320 188 320 200S312 220 300 220H220V300C220 312 212 320 200 320S180 312 180 300V220H100C88 220 80 212 80 200S88 180 100 180L100 180z" : "M100 140H140V100C140 88 148 80 160 80S180 88 180 100V140H220C232 140 240 148 240 160S232 180 220 180H180V220C180 232 172 240 160 240S140 232 140 220V180H100C88 180 80 172 80 160S88 140 100 140L100 140zM300 320H20C8 320 0 312 0 300V20C0 8 8 0 20 0H300C312 0 320 8 320 20V300C320 312 312 320 300 320L300 320zM280 40H40V280H280V40L280 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Insert.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Insert.displayName = "Blueprint5.Icon.Insert";
exports.default = Insert;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"60d2M":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Intelligence", ()=>Intelligence);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Intelligence = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "intelligence",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 220C189 220 180 211 180 200C180 189 189 180 200 180C211 180 220 189 220 200C220 211 210.8 220 200 220zM299.842 200.5V201.375C299.592 203.125 298.844 204.625 297.718 205.875C291.346 214.25 283.722 221.625 275.976 228.375C259.356 243 240.362 255.25 219.492 260.125C207.372 263 195.1256 263.125 183.1294 260.625C171.8828 258.375 161.2612 253.875 151.2642 248.25C135.6442 239.375 121.2736 227.25 108.7776 213.625C106.5282 211.125 104.279 208.5 102.1546 205.75C99.4054 202.125 99.4054 197.75 102.1546 194.126C108.5276 185.75 116.1502 178.376 123.8978 171.626C140.5176 157 159.5116 144.75 180.3802 139.876C192.5014 137 204.748 136.876 216.994 139.376C228.116 141.626 238.736 146.126 248.858 151.75C264.478 160.626 278.85 172.75 291.2200000000001 186.376C293.4700000000001 188.876 295.844 191.5 297.968 194.25C299.094 195.5 299.842 197.126 300.092 198.75V200C299.842 200.25 299.842 200.375 299.842 200.5zM200 160C177.8666 160 160 177.866 160 200C160 222.1334 177.8666 240 200 240C222.134 240 240 222.1334 240 200C240 177.866 222.134 160 200 160zM140 380C140 391.0457 131.0456 400 120 400H20C8.9543 400 0 391.0457 0 380V280C0 268.9544 8.9543 260 20 260C31.0456 260 40 268.9544 40 280V360H120C131.0456 360 140 368.9544 140 380zM260 380C260 391.0457 268.954 400 280 400H380C391.046 400 400 391.0457 400 380V280C400 268.9544 391.046 260 380 260C368.954 260 360 268.9544 360 280V360H280C268.954 360 260 368.9544 260 380zM260 20C260 8.954 268.954 0 280 0H380C391.046 0 400 8.954 400 20V120C400 131.046 391.046 140 380 140C368.954 140 360 131.046 360 120V40H280C268.954 40 260 31.046 260 20zM140 20C140 8.954 131.0456 0 120 0H20C8.9543 0 0 8.954 0 20V120C0 131.046 8.9543 140 20 140C31.0456 140 40 131.046 40 120V40H120C131.0456 40 140 31.046 140 20z" : "M160 180C149 180 140 171 140 160C140 149 149 140 160 140C171 140 180 149 180 160C180 171 170.8 180 160 180zM259.75 160.4808V161.3222C259.5 163.005 258.75 164.4472 257.626 165.6492C251.252 173.7024 243.63 180.7942 235.882 187.2848C219.262 201.3478 200.268 213.1272 179.4002 217.8148C167.279 220.5794 155.0328 220.6996 143.0366 218.2956C131.79 216.1322 121.1684 211.805 111.1716 206.3962C95.5514 197.8622 81.1808 186.203 68.6848 173.1016C66.4354 170.6976 64.1862 168.1734 62.0618 165.529C59.3128 162.0434 59.3128 157.8364 62.0618 154.3508C68.4348 146.2976 76.0574 139.2058 83.805 132.7152C100.4248 118.652 119.419 106.872 140.2874 102.186C152.4086 99.42 164.6548 99.3 176.901 101.704C188.0224 103.868 198.6442 108.194 208.766 113.604C224.386 122.1378 238.756 133.797 251.128 146.8984C253.378 149.3024 255.752 151.8266 257.8760000000001 154.471C259 155.6728 259.75 157.2354 260 158.798V160C259.75 160.2404 259.75 160.3606 259.75 160.4808zM160 120C137.8666 120 120 137.8666 120 160C120 182.1334 137.8666 200 160 200C182.1334 200 200 182.1334 200 160C200 137.8666 182.1334 120 160 120zM140 300C140 311.0457 131.0456 320 120 320H20C8.9543 320 0 311.0457 0 300V200C0 188.9544 8.9543 180 20 180C31.0456 180 40 188.9544 40 200V280H120C131.0456 280 140 288.9544 140 300zM180 300C180 311.0457 188.9542 320 200 320H300C311.046 320 320 311.0457 320 300V200C320 188.9544 311.046 180 300 180C288.954 180 280 188.9544 280 200V280H200C188.9542 280 180 288.9544 180 300zM180 20C180 8.954 188.9542 0 200 0H300C311.046 0 320 8.954 320 20V120C320 131.0456 311.046 140 300 140C288.954 140 280 131.0456 280 120V40H200C188.9542 40 180 31.046 180 20zM140 20C140 8.954 131.0456 0 120 0H20C8.9543 0 0 8.954 0 20V120C0 131.0456 8.9543 140 20 140C31.0456 140 40 131.0456 40 120V40H120C131.0456 40 140 31.046 140 20z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Intelligence.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Intelligence.displayName = "Blueprint5.Icon.Intelligence";
exports.default = Intelligence;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"66TBR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Intersection", ()=>Intersection);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Intersection = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "intersection",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260 320C233.8 320 209.8 311.4 190 297.2C170.2 311.4 146.2 320 120 320C53.8 320 0 266.2000000000001 0 200S53.8 80 120 80C146.2 80 170.2 88.6 190 102.8C209.8 88.6 233.8 80 260 80C326.2 80 380 133.8 380 200S326.2 320 260 320zM161.4 131.8C149.2 124.4 135.2 120 120 120C75.8 120 40 155.8 40 200C40 244.2 75.8 280 120 280C135.2 280 149.2 275.6 161.4 268.2C148 248.8 140 225.4 140 200C140 174.6 148 151.2 161.4 131.8zM260 120C244.8 120 230.8 124.4 218.6 131.8C232 151.2 240 174.6 240 200C240 225.4 232 248.8 218.6 268.2C230.8 275.6 244.8 280 260 280C304.2000000000001 280 340 244.2 340 200C340 155.8 304.2000000000001 120 260 120z" : "M200 260C181.6 260 164.8 254.8 150 246.2C135.2 254.8 118.4 260 100 260C44.8 260 0 215.2 0 160S44.8 60 100 60C118.4 60 135.2 65.2 150 73.8C164.8 65.2 181.6 60 200 60C255.2 60 300 104.8 300 160S255.2 260 200 260zM118 103C112.2 101.2 106.2 100 100 100C66.8 100 40 126.8 40 160S66.8 220 100 220C106.2 220 112.2 218.8 118 217C106.6 200.8 100 181.2 100 160C100 138.8 106.6 119.2 118 103zM200 100C193.8 100 187.8 101.2 182 103C193.4 119.2 200 138.8 200 160C200 181.2 193.4 200.8 182 217C187.8 218.8 193.8 220 200 220C233.2 220 260 193.2 260 160S233.2 100 200 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Intersection.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Intersection.displayName = "Blueprint5.Icon.Intersection";
exports.default = Intersection;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"42iaU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IpAddress", ()=>IpAddress);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var IpAddress = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "ip-address",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 326.8C120 286.2 200 180 200 180S280 286.2 280 326.8C279.8 367.2 244.2 400 200 400S120 367.2 120 326.8zM160 320C160 342 178 360 200 360S240 342 240 320S222 280 200 280S160 298 160 320zM280 130V140H200V120H260V80H220V60H270H280V130zM60 160H340C351 160 360 151 360 140V20C360 9 351 0 340 0H60C49 0 40 9 40 20V140L40 140C40 151 49 160 60 160L60 160zM140 140V20H160V140H140zM200 120V20H220V120H200z" : "M100 266.8C100 237.2 160 160 160 160S220 237.2 220 266.8C219.8 296 193.2 320 160 320S100 296 100 266.8zM140 260C140 271 149 280 160 280S180 271 180 260S171 240 160 240S140 249 140 260zM210 120H170H160V20H180V100H200V80H180V60H210H220V120H210zM40 140H280L280 140C291 140 300 131 300 120V20L300 20C300 9 291 0 280 0H40L40 0C29 0 20 9 20 20V120L20 120C20 131 29 140 40 140L40 140zM120 120V20H140V120H120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
IpAddress.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
IpAddress.displayName = "Blueprint5.Icon.IpAddress";
exports.default = IpAddress;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Rq1W":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IssueClosed", ()=>IssueClosed);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var IssueClosed = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "issue-closed",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M307.27922 282.0101012C302.160774 282.0101012 297.042328 283.9627228 293.137084 287.8679656L250.7106780000001 330.2943726C242.900192 338.1048584 242.900192 350.768158 250.7106780000001 358.5786438C258.521164 366.3891296 271.184464 366.3891296 278.99495 358.5786438L278.99495 358.5786438L307.27922 330.2943726L363.847764 386.86291502L363.847764 386.86291502C371.658248 394.67340084 384.321548 394.67340084 392.132034 386.86291502L392.132034 386.86291502L392.132034 386.86291502C399.9425200000001 379.0524292 399.9425200000001 366.3891296 392.132034 358.5786438L321.4213560000001 287.8679656C317.516114 283.9627228 312.397666 282.0101012 307.27922 282.0101012zM235.601426 396.84072574C230.880192 394.20219462 226.43975 390.87625772 222.426406 386.86291502C214.667826 379.1043336 209.478252 369.7495758 206.857684 359.8556876C204.583744 359.9515742 202.297526 360 200 360C111.63444 360 40 288.36556 40 200C40 111.63444 111.63444 40 200 40C288.36556 40 360 111.63444 360 200C360 220.7456014 356.0517200000001 240.569033 348.865602 258.759854C349.147896 259.031369 349.42792 259.3059872 349.7056280000001 259.5836944L379.144286 289.022353C392.492754 262.212331 400 231.9828712 400 200C400 89.54305 310.45695 0 200 0C89.54305 0 0 89.54305 0 200C0 310.45695 89.54305 400 200 400C212.150668 400 224.048262 398.916457076 235.601426 396.84072574zM220 80L180 80L180 120L220 120L220 80zM220 140L180 140L180 320L220 320L220 140z" : "M185.920271 317.9111775C178.6172174 314.9825308 171.773562 310.5603586 165.8578644 304.64466094C158.6293194 297.416116 153.6307622 288.8020344000001 150.8621926 279.6572852C88.8570008 274.9885608 40 223.1998624 40 160C40 93.72583 93.72583 40 160 40C226.2741700000001 40 280 93.72583 280 160C280 170.0364326 278.76788 179.7850882 276.446648 189.1029568C277.31587 189.8766984 278.165742 190.678368 278.99495 191.507576L308.114322 220.6269482C315.776066 201.9286014 320 181.4575772 320 160C320 71.63444 248.36556 0 160 0C71.63444 0 0 71.63444 0 160C0 248.36556 71.63444 320 160 320C168.8252026 320 177.4835236 319.285495176 185.920271 317.9111775zM236.568542 213.9339828C231.4500960000001 213.9339828 226.33165 215.8866042 222.426406 219.7918472L194.1421356 248.0761184C186.3316498 255.8866042 186.3316498 268.5499038 194.1421356 276.3603896C201.952622 284.1708756 214.615922 284.1708756 222.426406 276.3603896L236.568542 262.218254L271.923882 297.5735932C279.734368 305.38407896 292.397666 305.38407896 300.2081520000001 297.5735932C308.018638 289.7631072 308.018638 277.0998078 300.2081520000001 269.2893218L250.7106780000001 219.7918472C246.805436 215.8866042 241.686988 213.9339828 236.568542 213.9339828zM180 80L140 80L140 120L180 120L180 80zM180 140L140 140L140 240L180 240L180 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
IssueClosed.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
IssueClosed.displayName = "Blueprint5.Icon.IssueClosed";
exports.default = IssueClosed;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7PVu5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IssueNew", ()=>IssueNew);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var IssueNew = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "issue-new",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M263.331658 389.7651483800001C262.15757 386.3986238400001 261.275004 382.89542718 260.7142 379.2858008C245.915146 376.986566 232.905076 369.2788102 223.768152 358.246695C216.013146 359.401592 208.076456 360 200 360C111.63444 360 40 288.36556 40 200C40 111.63444 111.63444 40 200 40C288.36556 40 360 111.63444 360 200C360 208.0764558 359.401592 216.0131458 358.246694 223.768151C369.27881 232.9050762 376.986566 245.915146 379.2858 260.7141992C382.895428 261.275004 386.398624 262.157571 389.765148 263.3316578C396.4043000000001 243.4290932 400 222.134457 400 200C400 89.54305 310.45695 0 200 0C89.54305 0 0 89.54305 0 200C0 310.45695 89.54305 400 200 400C222.134456 400 243.429094 396.4042993 263.331658 389.7651483800001zM220 80L180 80L180 120L220 120L220 80zM220 140L180 140L180 320L220 320L220 140zM340 340L370 340C381.0456940000001 340 390 331.045695 390 320C390 308.954305 381.0456940000001 300 370 300L340 300L340 270C340 258.954305 331.0456940000001 250 320 250C308.9543060000001 250 300 258.954305 300 270L300 300L270 300C258.9543060000001 300 250 308.954305 250 320C250 331.045695 258.9543060000001 340 270 340L300 340L300 370C300 381.045695 308.9543060000001 390 320 390C331.0456940000001 390 340 381.045695 340 370L340 340z" : "M211.353824 311.58069588C211.16338 310.78072724 210.992216 309.97337186 210.84085 309.15914996C194.0910468 306.04531654 180.2470734 294.5528376 173.8379702 279.210753C169.2975554 279.7320842 164.6800652 280 160 280C93.72583 280 40 226.27417 40 160C40 93.72583 93.72583 40 160 40C226.2741700000001 40 280 93.72583 280 160C280 164.6485708 279.735678 169.2354058 279.221244 173.7462954C294.572066 180.1666064 306.059938 194.0399368 309.1644780000001 210.8418408C309.976894 210.9929628 310.782472 211.1637964 311.580696 211.3538244C317.039832 195.2347348 320 177.9630596 320 160C320 71.63444 248.36556 0 160 0C71.63444 0 0 71.63444 0 160C0 248.36556 71.63444 320 160 320C177.9630596 320 195.2347348 317.03983156 211.353824 311.58069588zM180 80L140 80L140 120L180 120L180 80zM180 140L140 140L140 240L180 240L180 140zM200 260C200 271 209 280 220 280L240 280L240 300C240 311 249 320 260 320C271 320 280 311 280 300L280 280L300 280C311 280 320 271 320 260C320 249 311 240 300 240L280 240L280 219.903193C280 208.903193 271 199.903193 260 199.903193C249 199.903193 240 208.903193 240 219.903193L240 240L220 240C209 240 200 249 200 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
IssueNew.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
IssueNew.displayName = "Blueprint5.Icon.IssueNew";
exports.default = IssueNew;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cU186":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Issue", ()=>Issue);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Issue = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "issue",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 0C89.54305 0 0 89.54305 0 200C0 310.45695 89.54305 400 200 400C310.45695 400 400 310.45695 400 200C400 89.54305 310.45695 0 200 0zM200 40C288.36556 40 360 111.63444 360 200C360 288.36556 288.36556 360 200 360C111.63444 360 40 288.36556 40 200C40 111.63444 111.63444 40 200 40zM220 80L180 80L180 120L220 120L220 80zM220 140L180 140L180 320L220 320L220 140z" : "M160 0C71.63444 0 0 71.63444 0 160C0 248.36556 71.63444 320 160 320C248.36556 320 320 248.36556 320 160C320 71.63444 248.36556 0 160 0zM160 40C226.2741700000001 40 280 93.72583 280 160C280 226.27417 226.2741700000001 280 160 280C93.72583 280 40 226.27417 40 160C40 93.72583 93.72583 40 160 40zM180 80L140 80L140 120L180 120L180 80zM180 140L140 140L140 240L180 240L180 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Issue.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Issue.displayName = "Blueprint5.Icon.Issue";
exports.default = Issue;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6B4Aw":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Italic", ()=>Italic);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Italic = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "italic",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M234 320H280C292 320 300 328 300 340C300 352 292 360 280 360H140C128 360 120 352 120 340C120 328 128 320 140 320H184L146 100H100C88 100 80 92 80 80C80 68 88 60 100 60H240C252 60 260 68 260 80C260 92 252 100 240 100H196L234 320z" : "M196 240H220C230 240 240 248 240 260C240 272 232 280 220 280H140C130 280 120 272 120 260C120 248 128 240 140 240H156L124 80H100C90 80 80 72 80 60C80 48 88 40 100 40H180C190 40 200 48 200 60C200 72 192 80 180 80H164L196 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Italic.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Italic.displayName = "Blueprint5.Icon.Italic";
exports.default = Italic;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixbXV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JoinTable", ()=>JoinTable);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var JoinTable = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "join-table",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 280H300V360C300 371 291 380 280 380H20C9 380 0 371 0 360V140C0 129 9 120 20 120H100V40C100 29 109 20 120 20H380C391 20 400 29 400 40V260C400 271 391 280 380 280zM120 160H40V220H120V160zM120 240H40V300H120V240zM260 60H140V120H260V60zM260 140H140V220H260V140zM260 240H140V300H260V240zM360 60H280V120H360V60zM360 140H280V200H360V140z" : "M300 220H240V280C240 291 231 300 220 300H20C9 300 0 291 0 280V120C0 109 9 100 20 100H80V40C80 29 89 20 100 20H300C311 20 320 29 320 40V200C320 211 311 220 300 220zM200 240V200H120V240H200zM200 120H120V180H200V120zM40 240H100V200H40V240zM40 140V180H100V140H40zM120 60V100H200V60H120zM280 60H220V100H280V60zM280 120H220V160H280V120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
JoinTable.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
JoinTable.displayName = "Blueprint5.Icon.JoinTable";
exports.default = JoinTable;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fuh4U":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyBackspace", ()=>KeyBackspace);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var KeyBackspace = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "key-backspace",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 340H140C134.4 340 129.4 337.8 125.8 334.2L5.8 214.2C2.2 210.6 0 205.6 0 200C0 194.4 2.2 189.4 5.8 185.8L125.8 65.8C129.4 62.2 134.4 60 140 60H380C391 60 400 69 400 80V320C400 331 391 340 380 340zM334.2000000000001 154.2C337.8 150.6 340 145.6 340 140C340 129 331 120 320 120C314.4000000000001 120 309.4000000000001 122.2 305.8 125.8L260 171.8L214.2 126C210.6 122.2 205.6 120 200 120C189 120 180 129 180 140C180 145.6 182.2 150.6 185.8 154.2L231.8 200L185.8 245.8C182.2 249.4 180 254.4 180 260C180 271 189 280 200 280C205.6 280 210.6 277.8 214.2 274.2L260 228.2L305.8 274C309.4000000000001 277.8 314.4000000000001 280 320 280C331 280 340 271 340 260C340 254.4 337.8 249.4 334.2000000000001 245.8L288.2 200L334.2000000000001 154.2z" : "M300 280H120C114.4 280 109.4 277.8 105.8 274.2L5.8 174.2C2.2 170.6 0 165.6 0 160C0 154.4 2.2 149.4 5.8 145.8L105.8 45.8C109.4 42.2 114.4 40 120 40H300C311 40 320 49 320 60V260C320 271 311 280 300 280zM254.2 134.2C257.8 130.6 260 125.6 260 120C260 109 251 100 240 100C234.4 100 229.4 102.2 225.8 105.8L200 131.8L174.2 106C170.6 102.2 165.6 100 160 100C149 100 140 109 140 120C140 125.6 142.2 130.6 145.8 134.2L171.8 160L145.8 185.8C142.2 189.4 140 194.4 140 200C140 211 149 220 160 220C165.6 220 170.6 217.8 174.2 214.2L200 188.2L225.8 214C229.4 217.8 234.4 220 240 220C251 220 260 211 260 200C260 194.4 257.8 189.4 254.2 185.8L228.2 160L254.2 134.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
KeyBackspace.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
KeyBackspace.displayName = "Blueprint5.Icon.KeyBackspace";
exports.default = KeyBackspace;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"coymA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyCommand", ()=>KeyCommand);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var KeyCommand = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "key-command",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M310 160H280V240H310C348.6 240 380 271.4 380 310S348.6 380 310 380S240 348.6 240 310V280H160V310C160 348.6 128.6 380 90 380S20 348.6 20 310S51.4 240 90 240H120V160H90C51.4 160 20 128.6 20 90S51.4 20 90 20S160 51.4 160 90V120H240V90C240 51.4 271.4 20 310 20S380 51.4 380 90S348.6 160 310 160zM310 340C326.6 340 340 326.6 340 310S326.6 280 310 280S280 293.4 280 310S293.4 340 310 340zM90 60C73.4 60 60 73.4 60 90S73.4 120 90 120S120 106.6 120 90S106.6 60 90 60zM90 280C73.4 280 60 293.4 60 310S73.4 340 90 340S120 326.6 120 310S106.6 280 90 280zM240 160H160V240H240V160zM310 60C293.4 60 280 73.4 280 90S293.4 120 310 120S340 106.6 340 90S326.6 60 310 60z" : "M240 140H220V180H240C273.2 180 300 206.8 300 240S273.2 300 240 300S180 273.2 180 240V220H140V240C140 273.2 113.2 300 80 300S20 273.2 20 240S46.8 180 80 180H100V140H80C46.8 140 20 113.2 20 80S46.8 20 80 20S140 46.8 140 80V100H180V80C180 46.8 206.8 20 240 20S300 46.8 300 80S273.2 140 240 140zM240 260C251 260 260 251 260 240C260 229 251 220 240 220S220 229 220 240C220 251 229 260 240 260zM80 60C69 60 60 69 60 80C60 91 69 100 80 100S100 91 100 80C100 69 91 60 80 60zM80 220C69 220 60 229 60 240C60 251 69 260 80 260S100 251 100 240C100 229 91 220 80 220zM180 140H140V180H180V140zM240 60C229 60 220 69 220 80C220 91 229 100 240 100S260 91 260 80C260 69 251 60 240 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
KeyCommand.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
KeyCommand.displayName = "Blueprint5.Icon.KeyCommand";
exports.default = KeyCommand;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8cmxX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyControl", ()=>KeyControl);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var KeyControl = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "key-control",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M334.2000000000001 254.2L214.2 374.2C210.6 377.8 205.6 380 200 380S189.4 377.8 185.8 374.2L65.8 254.2C62.2 250.6 60 245.6 60 240C60 229 69 220 80 220C85.6 220 90.6 222.2 94.2 225.8L200 331.8L305.8 226C309.4000000000001 222.2 314.4000000000001 220 320 220C331 220 340 229 340 240C340 245.6 337.8 250.6 334.2000000000001 254.2z" : "M254.2 214.2L174.2 294.2C170.6 297.8 165.6 300 160 300S149.4 297.8 145.8 294.2L65.8 214.2C62.2 210.6 60 205.6 60 200C60 189 69 180 80 180C85.6 180 90.6 182.2 94.2 185.8L160 251.8L225.8 186C229.4 182.2 234.4 180 240 180C251 180 260 189 260 200C260 205.6 257.8 210.6 254.2 214.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
KeyControl.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
KeyControl.displayName = "Blueprint5.Icon.KeyControl";
exports.default = KeyControl;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0ucP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyDelete", ()=>KeyDelete);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var KeyDelete = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "key-delete",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M394.2000000000001 214.2L274.2000000000001 334.2000000000001C270.6 337.8 265.6 340 260 340H20C9 340 0 331 0 320V80C0 69 9 60 20 60H260C265.6 60 270.6 62.2 274.2000000000001 65.8L394.2000000000001 185.8C397.8 189.4 400 194.4 400 200C400 205.6 397.8 210.6 394.2000000000001 214.2zM214.2 154.2C217.8 150.6 220 145.6 220 140C220 129 211 120 200 120C194.4 120 189.4 122.2 185.8 125.8L140 171.8L94.2 126C90.6 122.2 85.6 120 80 120C69 120 60 129 60 140C60 145.6 62.2 150.6 65.8 154.2L111.8 200L65.8 245.8C62.2 249.4 60 254.4 60 260C60 271 69 280 80 280C85.6 280 90.6 277.8 94.2 274.2L140 228.2L185.8 274C189.4 277.8 194.4 280 200 280C211 280 220 271 220 260C220 254.4 217.8 249.4 214.2 245.8L168.2 200L214.2 154.2z" : "M314.2000000000001 174.2L214.2 274.2C210.6 277.8 205.6 280 200 280H20C9 280 0 271 0 260V60C0 49 9 40 20 40H200C205.6 40 210.6 42.2 214.2 45.8L314.2000000000001 145.8C317.8 149.4 320 154.4 320 160C320 165.6 317.8 170.6 314.2000000000001 174.2zM174.2 134.2C177.8 130.6 180 125.6 180 120C180 109 171 100 160 100C154.4 100 149.4 102.2 145.8 105.8L120 131.8L94.2 106C90.6 102.2 85.6 100 80 100C69 100 60 109 60 120C60 125.6 62.2 130.6 65.8 134.2L91.8 160L65.8 185.8C62.2 189.4 60 194.4 60 200C60 211 69 220 80 220C85.6 220 90.6 217.8 94.2 214.2L120 188.2L145.8 214C149.4 217.8 154.4 220 160 220C171 220 180 211 180 200C180 194.4 177.8 189.4 174.2 185.8L148.2 160L174.2 134.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
KeyDelete.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
KeyDelete.displayName = "Blueprint5.Icon.KeyDelete";
exports.default = KeyDelete;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6TkdO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyEnter", ()=>KeyEnter);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var KeyEnter = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "key-enter",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 360C349 360 340 351 340 340V240C340 195.8 304.2000000000001 160 260 160H88.2L134 205.8C137.8 209.4 140 214.4 140 220C140 231 131 240 120 240C114.4 240 109.4 237.8 105.8 234.2L25.8 154.2C22.2 150.6 20 145.6 20 140C20 134.4 22.2 129.4 25.8 125.8L105.8 45.8C109.4 42.2 114.4 40 120 40C131 40 140 49 140 60C140 65.6 137.8 70.6 134.2 74.2000000000001L88.2 120H260C326.2 120 380 173.8 380 240V340C380 351 371 360 360 360z" : "M280 280C269 280 260 271 260 260V200C260 166.8 233.2 140 200 140H88.2L114 165.8C117.8 169.4 120 174.4 120 180C120 191 111 200 100 200C94.4 200 89.4 197.8 85.8 194.2L25.8 134.2C22.2 130.6 20 125.6 20 120C20 114.4 22.2 109.4 25.8 105.8L85.8 45.8C89.4 42.2 94.4 40 100 40C111 40 120 49 120 60C120 65.6 117.8 70.6 114.2 74.2L88.2 100H200C255.2 100 300 144.8 300 200V260C300 271 291 280 280 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
KeyEnter.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
KeyEnter.displayName = "Blueprint5.Icon.KeyEnter";
exports.default = KeyEnter;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lalRM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyEscape", ()=>KeyEscape);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var KeyEscape = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "key-escape",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 240C51 240 60 249 60 260V311.8L185.8 186C189.4 182.2 194.4 180 200 180C211 180 220 189 220 200C220 205.6 217.8 210.6 214.2 214.2L88.2 340H140C151 340 160 349 160 360C160 371 151 380 140 380H40C29 380 20 371 20 360V260C20 249 29 240 40 240zM220 378.8V338C287.8 328.2 340 270.4 340 200C340 122.6 277.4000000000001 60 200 60C129.6 60 71.8 112.2 62 180H21.2C31.2 90 107.4 20 200 20C299.4 20 380 100.6 380 200C380 292.6 310 368.8 220 378.8z" : "M40 180C51 180 60 189 60 200V231.8L145.8 146C149.4 142.2 154.4 140 160 140C171 140 180 149 180 160C180 165.6 177.8 170.6 174.2 174.2L88.2 260H120C131 260 140 269 140 280C140 291 131 300 120 300H40C29 300 20 291 20 280V200C20 189 29 180 40 180zM180 298V258C225.6 248.8 260 208.4 260 160C260 104.8 215.2 60 160 60C111.6 60 71.2 94.4 62 140H22C31.8 72.2 89.6 20 160 20C237.4000000000001 20 300 82.6 300 160C300 230.4 247.8 288.2 180 298z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
KeyEscape.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
KeyEscape.displayName = "Blueprint5.Icon.KeyEscape";
exports.default = KeyEscape;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8TaRn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyOption", ()=>KeyOption);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var KeyOption = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "key-option",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260 320H380C391 320 400 329 400 340C400 351 391 360 380 360H260C249 360 240 351 240 340C240 329 249 320 260 320zM380 80H291.6L137.4 350L137 349.8C133.6 355.8 127.4 360 120 360H20C9 360 0 351 0 340C0 329 9 320 20 320H108.4L262.6 50L262.8 50.2C266.4 44.2 272.6 40 280 40H380C391 40 400 49 400 60C400 71 391 80 380 80z" : "M220 240H300C311 240 320 249 320 260C320 271 311 280 300 280H220C209 280 200 271 200 260C200 249 209 240 220 240zM300 80H231.4L117.2 270.2L116.8 270.2C113.4 276 107.2 280 100 280H20C9 280 0 271 0 260C0 249 9 240 20 240H88.6L202.8 49.8L203 50C206.6 44 212.8 40 220 40H300C311 40 320 49 320 60C320 71 311 80 300 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
KeyOption.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
KeyOption.displayName = "Blueprint5.Icon.KeyOption";
exports.default = KeyOption;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6RgZP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyShift", ()=>KeyShift);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var KeyShift = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "key-shift",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M354.8 193L354.8 193L215 353.2L214.8 353C211.2 357.2 206 360 200 360S188.8 357.2 185.2 353L185 353.2L45 193.2L45.2 193C42 189.6 40 185 40 180C40 169 49 160 60 160H120V60C120 49 129 40 140 40H260C271 40 280 49 280 60V160H340C351 160 360 169 360 180C360 185 358 189.6 354.8 193z" : "M274.2000000000001 174.2L174.2 274.2C170.6 277.8 165.6 280 160 280S149.4 277.8 145.8 274.2L45.8 174.2C42.2 170.6 40 165.6 40 160C40 149 49 140 60 140H100V60C100 49 109 40 120 40H200C211 40 220 49 220 60V140H260C271 140 280 149 280 160C280 165.6 277.8 170.6 274.2000000000001 174.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
KeyShift.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
KeyShift.displayName = "Blueprint5.Icon.KeyShift";
exports.default = KeyShift;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jmomH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyTab", ()=>KeyTab);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var KeyTab = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "key-tab",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 140H88.2L134 185.8C137.8 189.4 140 194.4 140 200C140 211 131 220 120 220C114.4 220 109.4 217.8 105.8 214.2L40 148.2V200C40 211 31 220 20 220S0 211 0 200V40C0 29 9 20 20 20S40 29 40 40V91.8L105.8 26C109.4 22.2 114.4 20 120 20C131 20 140 29 140 40C140 45.6 137.8 50.6 134.2 54.2L88.2 100H380C391 100 400 109 400 120C400 131 391 140 380 140zM380 380C369 380 360 371 360 360V308.2L294.2000000000001 374C290.6 377.8 285.6 380 280 380C269 380 260 371 260 360C260 354.4 262.2 349.4 265.8 345.8L311.8 300H20C9 300 0 291 0 280C0 269 9 260 20 260H311.8L266 214.2C262.2 210.6 260 205.6 260 200C260 189 269 180 280 180C285.6 180 290.6 182.2 294.2000000000001 185.8L360 251.8V200C360 189 369 180 380 180S400 189 400 200V360C400 371 391 380 380 380z" : "M300 120H88.2L114 145.8C117.8 149.4 120 154.4 120 160C120 171 111 180 100 180C94.4 180 89.4 177.8 85.8 174.2L40 128.2V160C40 171 31 180 20 180S0 171 0 160V40C0 29 9 20 20 20S40 29 40 40V71.8L85.8 26C89.4 22.2 94.4 20 100 20C111 20 120 29 120 40C120 45.6 117.8 50.6 114.2 54.2L88.2 80H300C311 80 320 89 320 100C320 111 311 120 300 120zM300 300C289 300 280 291 280 280V248.2L234.2 294C230.6 297.8 225.6 300 220 300C209 300 200 291 200 280C200 274.4 202.2 269.4 205.8 265.8L231.8 240H20C9 240 0 231 0 220C0 209 9 200 20 200H231.8L206 174.2C202.2 170.6 200 165.6 200 160C200 149 209 140 220 140C225.6 140 230.6 142.2 234.2 145.8L280 191.8V160C280 149 289 140 300 140S320 149 320 160V280C320 291 311 300 300 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
KeyTab.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
KeyTab.displayName = "Blueprint5.Icon.KeyTab";
exports.default = KeyTab;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cnNbr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Key", ()=>Key);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Key = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "key",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 400C213.8 400 160 346.2 160 280C160 257.8 166.4 237.2 177 219.4L8.8 51.2C3.4 45.8 0 38.2 0 30C0 13.4 13.4 0 30 0C38.2 0 45.8 3.4 51.2 8.8L67 24.6L85.8 5.8C89.4 2.2 94.4 0 100 0S110.6 2.2 114.2 5.8L174.2 65.8C177.8 69.4 180 74.4 180 80C180 85.6 177.8 90.6 174.2 94.2000000000001L155.4 113L219.4 177C237.2 166.4 257.8 160 280 160C346.2 160 400 213.8 400 280S346.2 400 280 400zM280 220C246.8 220 220 246.8 220 280S246.8 340 280 340S340 313.2 340 280S313.2 220 280 220z" : "M220 320C164.8 320 120 275.2 120 220C120 199.6 126.2 180.8 136.6 165L5.8 34.2C2.2 30.6 0 25.6 0 20C0 9 9 0 20 0C25.6 0 30.6 2.2 34.2 5.8L60 31.8L85.8 6C89.4 2.2 94.4 0 100 0S110.6 2.2 114.2 5.8L154.2 45.8C157.8 49.4 160 54.4 160 60C160 65.6 157.8 70.6 154.2 74.2L128.2 100L164.8 136.6C180.8 126.2 199.6 120 220 120C275.2 120 320 164.8 320 220S275.2 320 220 320zM220 160C215.4 160 211 160.6 206.8 161.6C206.6 161.6 206.4 161.8 206.2 161.8C202 162.8 198 164.2 194.2 166C181.8 172 172 181.8 166 194.2C164.2 198 162.8 202 161.8 206C161.8 206.2 161.6 206.4 161.6 206.6C160.6 211 160 215.4 160 220C160 253.2 186.8 280 220 280S280 253.2 280 220S253.2 160 220 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Key.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Key.displayName = "Blueprint5.Icon.Key";
exports.default = Key;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5yPUD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KnownVehicle", ()=>KnownVehicle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var KnownVehicle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "known-vehicle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 320C374.4775400000001 320 369.4775400000001 317.76123 365.858154 314.141846L280 228.283692L234.141846 274.141846C230.52246 277.76123 225.52246 280 220 280C208.953858 280 200 271.044922 200 260C200 254.476318 202.23877 249.476318 205.858154 245.858154L265.858154 185.856934C269.47754 182.23877 274.47754 180 280 180S290.52246 182.23877 294.141846 185.856934L394.141846 285.858154C397.76123 289.476318 400 294.476318 400 300C400 311.044922 391.0461420000001 320 380 320zM339.030762 174.177246C339.265136 172.749024 340 171.506348 340 170.004882C340 153.436278 326.568604 140.003662 310 140.003662C305.509034 140.003662 301.343994 141.134034 297.519532 142.902832C291.94336 141.190186 286.137696 140 280 140C263.431396 140 248.431396 146.715088 237.573242 157.573242L177.573242 217.573242L177.72583 217.72583C171.54541 223.973388 166.679688 231.540528 163.671874 240.007324H80V260.0085440000001L100 320.009764H300L303.789062 308.641356L329.9499500000001 334.802244C323.2287580000001 341.927488 314.7729480000001 347.9663060000001 306.639404 350.24658C306.639404 350.24658 271.851806 359.998778 200 359.998778S93.360596 350.246582 93.360596 350.246582C79.94751 346.486816 64.880372 332.963868 59.874268 320.194092L59.802246 320.009766H60C60 320.009766 50 290.0073240000001 40 260.008546H20C8.953858 260.008546 0 251.053468 0 240.007326C0 228.962404 8.953858 220.006106 20 220.006106H26.66626C24.194336 212.587894 22.198486 206.604006 21.064454 203.201906C20.379638 201.143798 20 200.006104 20 200.006104V50.001222C20 33.432618 33.431396 20 50 20C66.567382 20 80 33.432618 80 50.00122V60.00122H320V50.00122C320 33.432618 333.432618 20 350 20C366.568604 20 380 33.432618 380 50.00122V200.006104L376.2146 211.362306L339.030762 174.177246zM90 140.003662C73.431396 140.003662 60 153.43628 60 170.004882S73.431396 200.006102 90 200.006102C106.567382 200.006102 120 186.573484 120 170.004882S106.567382 140.003662 90 140.003662z" : "M300 260.00122C294.47754 260.00122 289.47754 257.76245 285.858154 254.143066L240 208.284912L214.141846 234.143066C210.52246 237.762452 205.52246 240.00122 200 240.00122C188.953858 240.00122 180 231.047362 180 220.00122C180 214.47876 182.23877 209.47876 185.858154 205.858154L225.858154 165.858154C229.47754 162.23999 234.47754 160.00122 240 160.00122S250.52246 162.23999 254.141846 165.858154L314.141846 225.858154C317.76123 229.47876 320 234.47876 320 240.00122C320 251.047364 311.0461420000001 260.00122 300 260.00122zM282.426758 137.574462L282.27417 137.72705C276.027832 131.54663 268.461914 126.682128 259.996338 123.6730940000001V120.0048820000001H240.037842C240.024414 120.0048820000001 240.013428 120.0012200000001 240 120.0012200000001C239.987792 120.0012200000001 239.975586 120.0048820000001 239.963378 120.0048820000001H219.997558V123.675538C211.52954 126.685792 203.99292 131.573488 197.767334 137.767334L197.573242 137.574462L157.573242 177.574462L157.79419 177.79541C151.57959 183.995362 146.688232 191.520996 143.671876 200.007324H60.002442C56.481934 200.007324 58.790284 216.488036 60.002442 220.007324L74.584962 252.617188C75.803224 256.1413580000001 76.483156 260.008546 80.001222 260.008546H155.578614C166.560058 272.1960440000001 182.303466 280.00122 200 280.00122C215.358886 280.00122 229.21997 274.135742 239.746094 264.599608L256.625976 281.47949C251.851806 286.369626 246.136474 290.323484 240.737304 291.967772C240.737304 291.967772 214.399414 299.999998 160.00122 299.999998C105.600586 300 79.261474 291.967774 79.261474 291.967774C69.105224 288.8696300000001 57.700194 277.735596 53.90747 267.216798L38.64624 224.87793H17.598876C7.921142 224.87793 0 216.428222 0 206.101074C0 195.771484 7.921142 187.320556 17.598876 187.320556H25.10742L20.00366 180.006102C19.32495 166.30615 20.00366 151.275634 20.00366 140.004882V40.00244C20.00366 26.857908 27.685544 20.00122 40.00244 20.00122C52.326658 20.00122 60.00244 26.85791 60.00244 40.00244V60.00244H259.9963360000001V40.00244C259.9963360000001 26.857908 267.6757800000001 20.00122 279.9963360000001 20.00122C292.3156720000001 20.00122 299.995116 26.85791 299.995116 40.00244V140.004882C299.995116 144.420166 299.9633780000001 149.67041 299.9353020000001 155.084228L282.426758 137.574462zM100.00122 120.004882H60.00244V160.006102H100.00122V120.004882z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
KnownVehicle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
KnownVehicle.displayName = "Blueprint5.Icon.KnownVehicle";
exports.default = KnownVehicle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iQQKm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LabTest", ()=>LabTest);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LabTest = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "lab-test",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260 360C271.045694 360 280 351.045695 280 340C280 328.954305 271.045694 320 260 320L260 240L340 80L340 60C340 48.954306 331.0456940000001 40 320 40L80 40C68.954305 40 60 48.954306 60 60L60 80L140 240L140 320C128.954305 320 120 328.954305 120 340C120 351.045695 128.954305 360 140 360L260 360zM220 320L180 320L180 240L140 160L260 160L220 240L220 320z" : "M220 300C231.045694 300 240 291.045695 240 280C240 268.954305 231.045694 260 220 260L220 200L280 60L280 35C280 26.715728 273.284272 20 265 20L55 20C46.7157288 20 40 26.715728 40 35L40 60L100 200L100 260C88.954305 260 80 268.954305 80 280C80 291.045695 88.954305 300 100 300L220 300zM180 260L140 260L140 200L105.72 120L214.28 120L180 200L180 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LabTest.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LabTest.displayName = "Blueprint5.Icon.LabTest";
exports.default = LabTest;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"76nuU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Label = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "label",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 160H340V180H60V160zM280 340H20C9 340 0 331 0 320V80C0 69 9 60 20 60H380C391 60 400 69 400 80V220L280 340zM360 100H40V300H260V240H60V220H260V200H360V100zM280 220V300L360 220H280z" : "M220 280H20C9 280 0 271 0 260V60C0 49 9 40 20 40H300C311 40 320 49 320 60V180L220 280zM280 80H40V240H200V200H60V180H200V160H280V80zM220 180V240L280 180H220zM60 120H260V140H60V120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Label.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Label.displayName = "Blueprint5.Icon.Label";
exports.default = Label;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dhQhG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayerOutline", ()=>LayerOutline);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayerOutline = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layer-outline",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M190.2871414 317.4831456L10.28714138 217.4831456C-3.42904712 209.8630408 -3.42904712 190.13696 10.28714138 182.516854L190.2871414 82.516854C196.3275922 79.161048 203.672408 79.161048 209.712858 82.516854L389.712858 182.516854C403.429048 190.13696 403.429048 209.8630408 389.712858 217.4831456L209.712858 317.4831456C203.672408 320.8389514 196.3275922 320.8389514 190.2871414 317.4831456zM200 277.12L338.8 200.02L200 122.9L61.18 200.02L200 277.12z" : "M150.0772212 257.3648628000001L10.07722124 177.3648628C-3.35907374 169.68698 -3.35907374 150.31302 10.07722124 142.6351372L150.0772212 62.635138C156.2258746 59.12162 163.7741254 59.12162 169.9227788 62.635138L309.922778 142.6351372C323.359074 150.31302 323.359074 169.68698 309.922778 177.3648628L169.9227788 257.3648628000001C163.7741254 260.878379 156.2258746 260.878379 150.0772212 257.3648628000001zM160 216.96L259.6600000000001 160L160 103.06L60.32 160L160 216.96z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayerOutline.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayerOutline.displayName = "Blueprint5.Icon.LayerOutline";
exports.default = LayerOutline;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cHP6r":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layer", ()=>Layer);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Layer = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layer",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M390 218L210 318C206 320 204 320 200 320S194 320 190 318L10 218C4 214 0 208 0 200C0 192 4 186 10 182L190 82C194 80 196 80 200 80S206 80 210 82L390 182C396 186 400 192 400 200C400 208 396 214 390 218z" : "M320 160C320 167.4 315.8 173.6 309.8 177L310 177.2L170 257.2L169.8 257C166.8 258.8 163.6 260 160 260S153.2 258.8 150.2 257L150 257.4L10 177.4L10.2 177.2C4.2 173.6 0 167.4 0 160S4.2 146.4 10.2 143C10.2 143 10 142.8 10 142.8L150 62.8L150.2 63C153.2 61.2 156.4 60 160 60S166.8 61.2 169.8 63L170 62.8L310 142.8L309.8 143C315.8 146.4 320 152.6 320 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Layer.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Layer.displayName = "Blueprint5.Icon.Layer";
exports.default = Layer;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iCSVt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layers", ()=>Layers);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Layers = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layers",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M10 262L10 262L190 162L190 162C194 160 196 160 200 160S206 160 210 162L210 162L390 262L390 262C396 266 400 272 400 280C400 288 396 294 390 298L390 298L210 398L210 398C206 400 204 400 200 400S194 400 190 398L190 398L10 298L10 298C4 294 0 288 0 280C0 272 4 266 10 262zM380 220C376 220 374 220 370 218L370 218L200 122L30 218L30 218C26 220 24 220 20 220C8 220 0 212 0 200C0 192 4 186 10 182L10 182L190 82L190 82C194 80 196 80 200 80S206 80 210 82L210 82L390 182L390 182C396 186 400 192 400 200C400 212 392 220 380 220zM380 140C376 140 374 140 370 138L370 138L200 42L30 136L30 136C26 140 24 140 20 140C8 140 0 132 0 120C0 112 4 106 10 102L10 102L190 2L190 2C194 0 196 0 200 0S206 0 210 2L210 2L390 102L390 102C396 106 400 112 400 120.0000000000001C400 132 392 140 380 140z" : "M10.99952 222.2L150.9998 162.2C153.7998 160.8 156.7998 160 159.9998 160C163.1998 160 166.1998 160.8 168.9998 162.2L309 222.2C315.4 225.4 320 232.2 320 240C320 248.2 315 255.4 307.8 258.4L167.9998 318.4C165.3998 319.4 162.7998 320 159.9998 320C157.1998 320 154.5998 319.4 152.1998 318.4L12.39952 258.4C4.99952 255.4 -0.000487566 248.2 -0.000487566 240C-0.000487566 232.2 4.59952 225.4 10.99952 222.2zM300 100C296.8 100 293.8 99.2 291 97.8L159.9998 40L28.9998 98C26.1998 99.2 23.1998 100 19.99976 100C8.99976 100 -0.00024438 91 -0.00024438 80C-0.00024438 72.2 4.59976 65.4 10.99976 62.2L150.9998 2.2C153.7998 0.8 156.7998 0 159.9998 0C163.1998 0 166.1998 0.8 168.9998 2.2L309 62.2C315.4 65.4 320 72.2 320 80C320 91 311 100 300 100zM300 180.0002C296.8 180.0002 293.8 179.2002 291 177.8002L159.9998 120L28.9994 177.8C26.1994 179.2 23.1994 180 19.99938 180C8.99938 180 -0.000610352 171 -0.000610352 160C-0.000610352 152.2 4.5994 145.4 10.99938 142.2L150.9998 82.2C153.7998 80.8 156.7998 80 159.9998 80C163.1998 80 166.1998 80.8 168.9998 82.2L309 142.2002C315.4 145.4002 320 152.2002 320 160.0002C320 171.0002 311 180.0002 300 180.0002z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Layers.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Layers.displayName = "Blueprint5.Icon.Layers";
exports.default = Layers;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ZyBy":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutAuto", ()=>LayoutAuto);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutAuto = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-auto",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 140C349.4 140 339.8 135.8 332.6 129L238 188C239.2 191.8 240 195.8 240 200S239.2 208.2 238 212L332.4000000000001 271C339.8 264.2 349.4 260 360 260C382 260 400 278 400 300C400 322 382 340 360 340S320 322 320 300C320 295.8 320.8 291.8 322 288L227.4000000000001 228.8C222.6 233.4000000000001 216.6 236.8000000000001 210 238.4000000000001V321.4C227.2 325.8 240 341.4 240 360C240 382 222 400 200 400S160 382 160 360C160 341.4 172.8 325.8 190 321.4V238.6C183.4 236.8 177.4 233.4 172.6 229L78 288C79.2 291.8 80 295.8 80 300C80 322 62 340 40 340S0 322 0 300C0 278 18 260 40 260C50.6 260 60.2 264.2 67.4 271L162 212C160.8 208.2 160 204.2 160 200S160.8 191.8 162 188L67.6 129C60.2 135.8 50.6 140 40 140C18 140 0 122 0 100C0 78 18 60 40 60S80 78 80 100C80 104.2000000000001 79.2 108.2 78 112L172.6 171.2C177.4 166.6 183.4 163.2 190 161.6V78.8C172.8 74.2000000000001 160 58.6 160 40C160 18 178 0 200 0S240 18 240 40C240 58.6 227.2 74.2000000000001 210 78.6V161.4C216.6 163.2 222.6 166.6 227.4 171L322 111.8C320.8 108.2 320 104.2000000000001 320 100C320 78 338 60 360 60S400 78 400 100C400 122 382 140 360 140z" : "M280 130C268.8 130 258.8 125.4 251.6 118.2L179.8 160L251.6 201.8C258.8 194.6 268.8 190 280 190C302 190 320 208 320 230C320 252 302 270 280 270S240 252 240 230C240 226.2 240.6 222.6 241.6 219.2L170 177.4V241.4C187.2 245.8 200 261.4 200 280C200 302 182 320 160 320S120 302 120 280C120 261.4 132.8 245.8 150 241.4V177.4L78.4 219.2C79.4 222.6 80 226.2 80 230C80 252 62 270 40 270S0 252 0 230C0 208 18 190 40 190C51.2 190 61.2 194.6 68.4 201.8L140.2 160L68.4 118.2C61.2 125.4 51.2 130 40 130C18 130 0 112 0 90C0 68 18 50 40 50S80 68 80 90C80 93.8 79.4 97.4 78.4 100.8L150 142.6V78.6C132.8 74.2 120 58.6 120 40C120 18 138 0 160 0S200 18 200 40C200 58.6 187.2 74.2 170 78.6V142.6L241.6 100.8C240.6 97.4 240 93.8 240 90C240 68 258 50 280 50S320 68 320 90C320 112 302 130 280 130z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutAuto.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutAuto.displayName = "Blueprint5.Icon.LayoutAuto";
exports.default = LayoutAuto;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k3dQ9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutBalloon", ()=>LayoutBalloon);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutBalloon = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-balloon",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 80C357.2 80 354.4 79.6 351.6 79L317 148C330.8 157 339.8 172.4 339.8 190S330.6 223 317 232L351.6 301C354.4 300.4 357.2 300 360 300C382 300 400 318 400 340S382 380 360 380S320 362 320 340C320 328 325.4 317.4 333.8 310L298.4000000000001 239.2C295.6 239.6 292.8 240 290 240C265.8 240 245.6 222.8 241 200H159C154.4 222.8 134.2 240 110 240C107.2 240 104.4 239.6 101.6 239.2L66.2 310C74.6 317.4 80 328 80 340C80 362 62 380 40 380S0 362 0 340S18 300 40 300C42.8 300 45.6 300.4 48.4 301L82.8 232C69.2 223 60 207.6 60 190S69.2 157 82.8 148L48.2 79C45.6 79.6 42.8 80 40 80C18 80 0 62 0 40S18 0 40 0S80 18 80 40C80 52 74.6 62.6 66.2 70L101.6 140.8C104.4 140.4 107.2 140 110 140C134.2 140 154.4 157.2 159 180H241C245.6 157.2 265.8 140 290 140C292.8 140 295.6 140.4 298.4 140.8L333.8 70C325.4 62.6 320 52 320 40C320 18 338 0 360 0S400 18 400 40S382 80 360 80z" : "M280 100C276 100 272.4 99.2 268.8 98.2L248.4 132C255.6 139.2 260 149 260 160C260 171 255.6 180.8 248.4 188L268.6 221.8C272.4 220.8 276 220 280 220C302 220 320 238 320 260S302 300 280 300S240 282 240 260C240 249 244.4 239.2 251.6 232L231.4 198.2C227.6 199.2 224 200 220 200C201.4 200 185.8 187.2 181.4 170H138.6C134.2 187.2 118.6 200 100 200C96 200 92.4 199.2 88.8 198.2L68.4 232C75.6 239.2 80 249 80 260C80 282 62 300 40 300S0 282 0 260S18 220 40 220C44 220 47.6 220.8 51.2 221.8L71.6 188C64.4 180.8 60 171 60 160C60 149 64.4 139.2 71.6 132L51.4 98.2C47.6 99.2 44 100 40 100C18 100 0 82 0 60S18 20 40 20S80 38 80 60C80 71 75.6 80.8 68.4 88L88.6 121.8C92.4 120.8 96 120 100 120C118.6 120 134.2 132.8 138.6 150H181.4C185.8 132.8 201.4 120 220 120C224 120 227.6 120.8 231.2 121.8L251.4 88C244.4 80.8 240 71 240 60C240 38 258 20 280 20S320 38 320 60S302 100 280 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutBalloon.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutBalloon.displayName = "Blueprint5.Icon.LayoutBalloon";
exports.default = LayoutBalloon;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUsuP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutBottomRowThreeTiles", ()=>LayoutBottomRowThreeTiles);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutBottomRowThreeTiles = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-bottom-row-three-tiles",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 380C0 391.0457 8.9543 400 20 400H380C391.046 400 400 391.0457 400 380V240C400 228.9544 391.046 220 380 220H20C8.95432 220 0 228.9544 0 240V380zM0 160C0 171.046 8.9543 180 20 180H80C91.0456 180 100 171.046 100 160V20C100 8.954 91.0456 0 80 0H20C8.9543 0 0 8.954 0 20V160zM140 160C140 171.046 148.9544 180 160 180H240C251.046 180 260 171.046 260 160V20C260 8.954 251.046 0 240 0H160C148.9544 0 140 8.954 140 20V160zM300 160C300 171.046 308.954 180 320 180H380C391.046 180 400 171.046 400 160V20C400 8.954 391.046 0 380 0H320C308.954 0 300 8.954 300 20V160z" : "M140 140C128.9544 140 120 131.0456 120 120L120 20C120 8.954 128.9544 0 140 0H180C191.0456 0 200 8.954 200 20V120C200 131.0456 191.0456 140 180 140H140zM20 140C8.95432 140 0.00000485396 131.0456 0.00000437114 120L0 20C-4.82822e-7 8.954 8.9543 0 20 0H60C71.0456 0 80 8.954 80 20V120C80 131.0456 71.0456 140 60 140H20zM260 140C248.954 140 240 131.0456 240 120V20C240 8.954 248.954 0 260 0H300C311.046 0 320 8.954 320 20V120C320 131.0456 311.046 140 300 140H260zM20 320C8.95432 320.000000482822 0.00000485396 311.0457 0.00000437114 300L0 200C-4.82822e-7 188.9544 8.9543 180 20 180L300 180C311.046 180 320 188.9542 320 200V300C320 311.04568 311.046 319.99998727798 300 319.9999877608L20 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutBottomRowThreeTiles.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutBottomRowThreeTiles.displayName = "Blueprint5.Icon.LayoutBottomRowThreeTiles";
exports.default = LayoutBottomRowThreeTiles;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hDthG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutBottomRowTwoTiles", ()=>LayoutBottomRowTwoTiles);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutBottomRowTwoTiles = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-bottom-row-two-tiles",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 160C0 171.046 8.9543 180 20 180H160C171.0456 180 180 171.046 180 160V20C180 8.954 171.0456 0 160 0H20C8.9543 0 0 8.954 0 20V160zM220 160C220 171.046 228.954 180 240 180H380C391.046 180 400 171.046 400 160V20C400 8.954 391.046 0 380 0H240C228.954 0 220 8.954 220 20V160zM0 380C0 391.0457 8.9543 400 20 400H380C391.046 400 400 391.0457 400 380V240C400 228.9544 391.046 220 380 220H20C8.95432 220 0 228.9544 0 240V380z" : "M120 140C131.0456 140 140 131.0456 140 120V20C140 8.954 131.0456 0 120 0H20C8.9543 0 0 8.954 0 20V120C0 131.0456 8.9543 140 20 140H120zM300 140C311.046 140 320 131.0456 320 120V20C320 8.954 311.046 0 300 0H200C188.9544 0 180 8.954 180 20V120C180 131.0456 188.9544 140 200 140H300zM300 320C311.046 320 320 311.0457 320 300V200C320 188.9544 311.046 180 300 180H20C8.9543 180 0 188.9544 0 200V300C0 311.0457 8.9543 320 20 320H300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutBottomRowTwoTiles.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutBottomRowTwoTiles.displayName = "Blueprint5.Icon.LayoutBottomRowTwoTiles";
exports.default = LayoutBottomRowTwoTiles;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"flPeO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutCircle", ()=>LayoutCircle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutCircle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-circle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M366 240C362 258 354 274 344 290C348 296 350 304 350 310C350 332 332 350 310 350C302 350 296 348 290 344C274 354 258 360 240 366C238 386 220 400 200 400C180 400 164 384 160 366C142 360 126 354 110 344C104 348 96 350 90 350C68 350 50 332 50 310C50 302 52 296 56 290C46 274 40 258 34 240C16 236 0 220 0 200C0 180 16 164 34 160C38 142 46 126 56 110C52 104 50 96 50 90C50 68 68 50 90 50C98 50 104 52 110 56C126 46 142 40 160 34C162 14 180 0 200 0C220 0 236 16 240 34C258 38 274 46 290 56C296 52 304 50 310 50C332 50 350 68 350 90C350 98 348 104 344 110C354 126 360 142 366 160C386 162 400 180 400 200C400 220 384 236 366 240zM330 124C324 128 318 130 310 130C288 130 270 112 270 90C270 82 272 76 276 70C264 64 252.0000000000001 58 238 54C232 68 218 80 200 80C184 80 168 70 162 54C148 58 136 61.9999999999999 124 70C128 76 130 82 130 90C130 112 112 130 90 130C82 130 76 128 70 124C64 136 58 148 54 162C70 168 80 184 80 200S70 232 56 236C60 250.0000000000001 64 262 72 274C78 270 84 268 92 268C114 268 132 286 132 308C132 316 130 322 126 328C138 334 150 340 164 344C168 330 184 320 200 320C216 320 232 330 238 346C252 342 264 338 276 330C272 324 270 318 270 310C270 288 288 270 310 270C318 270 324 272 330 276C336 264 342 252 346 238C330 232 320 216 320 200S330 168 344 164C342 150 336 136 330 124z" : "M283.2 199.6C280.8 206.8 278 213.6 274.6 220.2C278 226 280 232.8 280 240C280 262 262 280 240 280C232.8 280 226 278 220.2 274.6C213.6 278 206.8 280.8 199.6 283.2C198 303.8 181 320 160 320C139 320 122 303.8 120.4 283.2C113.2 280.8 106.4 278 99.8 274.6C94 278 87.2 280 80 280C58 280 40 262 40 240C40 232.8 42 226 45.4 220.2C42 213.6 39.2 206.8 36.8 199.6C16.2 198 0 181 0 160C0 139 16.2 122 36.8 120.4C39.2 113.2 42 106.4 45.4 99.8C42 94 40 87.2 40 80C40 58 58 40 80 40C87.2 40 94 42 99.8 45.4C106.4 42 113.2 39 120.4 36.8C122 16.2 139 0 160 0C181 0 198 16.2 199.6 36.8C206.8 39.2 213.6 42 220.2 45.4C226 42 232.8 40 240 40C262 40 280 58 280 80C280 87.2 278 94 274.6 99.8C278 106.4 280.8 113.2 283.2 120.4C303.8 122 320 139 320 160C320 181 303.8 198 283.2 199.6zM263.4 123.8C262.4 120.6 261.2 117.6 260 114.6C254 118 247.2 120 240 120C218 120 200 102 200 80C200 72.8 202 66 205.4 60C202.4 58.6 199.4 57.6 196.2 56.6C190 70.4 176.2 80 160 80S130 70.4 123.8 56.6C120.6 57.8 117.4 58.8 114.6 60C118 66 120 72.8 120 80C120 102 102 120 80 120C72.8 120 66 118 60 114.6C58.6 117.6 57.6 120.6 56.6 123.8C70.4 130 80 143.8 80 160S70.4 190 56.6 196.2C57.8 199.4 58.8 202.6 60 205.4C66 202 72.8 200 80 200C102 200 120 218 120 240C120 247.2 118 254 114.6 260C117.6 261.4 120.6 262.4 123.8 263.4C130 249.6 143.8 240 160 240S190 249.6 196.2 263.4C199.4 262.2 202.6 261.2 205.4 260C202 254 200 247.2 200 240C200 218 218 200 240 200C247.2 200 254 202 260 205.4C261.4 202.4 262.4 199.4 263.4 196.2C249.6 190 240 176.2 240 160S249.6 130 263.4 123.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutCircle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutCircle.displayName = "Blueprint5.Icon.LayoutCircle";
exports.default = LayoutCircle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"02Upx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutGrid", ()=>LayoutGrid);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutGrid = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-grid",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 360A40 40 0 0 1 80 360A40 40 0 0 1 0 360M160 360A40 40 0 0 1 240 360A40 40 0 0 1 160 360M320 360A40 40 0 0 1 400 360A40 40 0 0 1 320 360M320 200A40 40 0 0 1 400 200A40 40 0 0 1 320 200M320 40A40 40 0 0 1 400 40A40 40 0 0 1 320 40M160 40A40 40 0 0 1 240 40A40 40 0 0 1 160 40M0 40A40 40 0 0 1 80 40A40 40 0 0 1 0 40M0 200A40 40 0 0 1 80 200A40 40 0 0 1 0 200M160 200A40 40 0 0 1 240 200A40 40 0 0 1 160 200" : "M40 80C18 80 0 62 0 40C0 18 18 0 40 0S80 18 80 40C80 62 62 80 40 80zM40 200C18 200 0 182 0 160C0 138 18 120 40 120S80 138 80 160C80 182 62 200 40 200zM40 320C18 320 0 302 0 280S18 240 40 240S80 258 80 280S62 320 40 320zM280 240C302 240 320 258 320 280S302 320 280 320S240 302 240 280S258 240 280 240zM280 200C258 200 240 182 240 160C240 138 258 120 280 120S320 138 320 160C320 182 302 200 280 200zM160 320C138 320 120 302 120 280S138 240 160 240S200 258 200 280S182 320 160 320zM280 80C258 80 240 62 240 40C240 18 258 0 280 0S320 18 320 40C320 62 302 80 280 80zM160 200C138 200 120 182 120 160C120 138 138 120 160 120S200 138 200 160C200 182 182 200 160 200zM160 80C138 80 120 62 120 40C120 18 138 0 160 0S200 18 200 40C200 62 182 80 160 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutGrid.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutGrid.displayName = "Blueprint5.Icon.LayoutGrid";
exports.default = LayoutGrid;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8wMrg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutGroupBy", ()=>LayoutGroupBy);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutGroupBy = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-group-by",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 320A40 40 0 0 1 80 320A40 40 0 0 1 0 320M320 360A40 40 0 0 1 400 360A40 40 0 0 1 320 360M320 200A40 40 0 0 1 400 200A40 40 0 0 1 320 200M320 40A40 40 0 0 1 400 40A40 40 0 0 1 320 40M0 80A40 40 0 0 1 80 80A40 40 0 0 1 0 80M0 200A40 40 0 0 1 80 200A40 40 0 0 1 0 200M220 120A40 40 0 0 1 300 120A40 40 0 0 1 220 120M220 280A40 40 0 0 1 300 280A40 40 0 0 1 220 280" : "M40 200C18 200 0 182 0 160C0 138 18 120 40 120S80 138 80 160C80 182 62 200 40 200zM40 100C18 100 0 82 0 60C0 38 18 20 40 20S80 38 80 60C80 82 62 100 40 100zM280 240C302 240 320 258 320 280S302 320 280 320S240 302 240 280S258 240 280 240zM40 300C18 300 0 282 0 260S18 220 40 220S80 238 80 260S62 300 40 300zM180 140C158 140 140 122 140 100C140 78 158 60 180 60S220 78 220 100C220 122 202 140 180 140zM180 260C158 260 140 242 140 220S158 180 180 180S220 198 220 220S202 260 180 260zM280 200C258 200 240 182 240 160C240 138 258 120 280 120S320 138 320 160C320 182 302 200 280 200zM280 80C258 80 240 62 240 40C240 18 258 0 280 0S320 18 320 40C320 62 302 80 280 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutGroupBy.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutGroupBy.displayName = "Blueprint5.Icon.LayoutGroupBy";
exports.default = LayoutGroupBy;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iJfOt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutHierarchy", ()=>LayoutHierarchy);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutHierarchy = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-hierarchy",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M370 78.6V161.4C387.2 165.8 400 181.4 400 200C400 222 382 240 360 240C341.4 240 325.8 227.2 321.4 210H238.6C235 224 224 235 210 238.6V321.4C227.2 325.8 240 341.4 240 360C240 382 222 400 200 400S160 382 160 360C160 341.4 172.8 325.8 190 321.4V238.6C176 235 165 224 161.4 210H78.6C74.2 227.2 58.6 240 40 240C18 240 0 222 0 200C0 181.4 12.8 165.8 30 161.4V78.6C12.8 74.2000000000001 0 58.6 0 40C0 18 18 0 40 0S80 18 80 40C80 58.6 67.2 74.2000000000001 50 78.6V161.4C64 165 75 176 78.6 190H161.4C165 176 176 165 190 161.4V78.6C172.8 74.2000000000001 160 58.6 160 40C160 18 178 0 200 0S240 18 240 40C240 58.6 227.2 74.2000000000001 210 78.6V161.4C224 165 235 176 238.6 190H321.4C325 176 336 165 350 161.4V78.6C332.8 74.2000000000001 320 58.6 320 40C320 18 338 0 360 0S400 18 400 40C400 58.6 387.2 74.2000000000001 370 78.6z" : "M290 78.6V121.4C307.2 125.8 320 141.4 320 160C320 182 302 200 280 200C261.4 200 245.8 187.2 241.4 170H198.6C195 184 184 195 170 198.6V241.4C187.2 245.8 200 261.4 200 280C200 302 182 320 160 320S120 302 120 280C120 261.4 132.8 245.8 150 241.4V198.6C136 195 125 184 121.4 170H78.6C74.2 187.2 58.6 200 40 200C18 200 0 182 0 160C0 141.4 12.8 125.8 30 121.4V78.6C12.8 74.2 0 58.6 0 40C0 18 18 0 40 0S80 18 80 40C80 58.6 67.2 74.2 50 78.6V121.4C64 125 75 136 78.6 150H121.4C125 136 136 125 150 121.4V78.6C132.8 74.2 120 58.6 120 40C120 18 138 0 160 0S200 18 200 40C200 58.6 187.2 74.2 170 78.6V121.4C184 125 195 136 198.6 150H241.4C245 136 256 125 270 121.4V78.6C252.8 74.2 240 58.6 240 40C240 18 258 0 280 0S320 18 320 40C320 58.6 307.2 74.2 290 78.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutHierarchy.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutHierarchy.displayName = "Blueprint5.Icon.LayoutHierarchy";
exports.default = LayoutHierarchy;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVUx0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutLeftColumnThreeTiles", ()=>LayoutLeftColumnThreeTiles);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutLeftColumnThreeTiles = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-left-column-three-tiles",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 380C220 391.04568 228.954 400 240 400H380C391.046 400 400 391.0457 400 380V20C400 8.954 391.046 0 380 0H240C228.954 0 220 8.954 220 20V380zM0 380C0 391.0457 8.9543 400 20 400H160C171.0456 400 180 391.0457 180 380V320C180 308.9544 171.0456 300 160 300H20C8.9543 300 0 308.9544 0 320V380zM0 240C0 251.0456 8.9543 260 20 260H160C171.0456 260 180 251.0456 180 240V160C180 148.954 171.0456 140 160 140H20C8.9543 140 0 148.954 0 160V240zM0 80C0 91.046 8.9543 100 20 100H160C171.0456 100 180 91.046 180 80V20C180 8.954 171.0456 0 160 0H20C8.9543 0 0 8.954 0 20V80z" : "M140 180C140 191.0456 131.0456 200 120 200H20C8.9543 200 0 191.0456 0 180V140C0 128.9544 8.9543 120 20 120H120C131.0456 120 140 128.9544 140 140V180zM140 300C140 311.0457 131.0456 320 120 320H20C8.9543 320 0 311.0457 0 300V260C0 248.9544 8.9543 240 20 240H120C131.0456 240 140 248.9544 140 260V300zM140 60C140 71.046 131.0456 80 120 80H20C8.9543 80 0 71.046 0 60V20C0 8.954 8.9543 0 20 0H120C131.0456 0 140 8.954 140 20V60zM320 300C320 311.0457 311.046 320 300 320H200C188.9544 320 180 311.0457 180 300V20C180 8.954 188.9544 0 200 0H300C311.046 0 320 8.954 320 20V300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutLeftColumnThreeTiles.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutLeftColumnThreeTiles.displayName = "Blueprint5.Icon.LayoutLeftColumnThreeTiles";
exports.default = LayoutLeftColumnThreeTiles;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dHrrU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutLeftColumnTwoTiles", ()=>LayoutLeftColumnTwoTiles);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutLeftColumnTwoTiles = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-left-column-two-tiles",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 380C0 391.0457 8.9543 400 20 400H160C171.0456 400 180 391.0457 180 380V240C180 228.9544 171.0456 220 160 220H20C8.9543 220 0 228.9544 0 240V380zM0 160C0 171.046 8.9543 180 20 180H160C171.0456 180 180 171.046 180 160V20C180 8.954 171.0456 0 160 0H20C8.9543 0 0 8.954 0 20V160zM220 380C220 391.04568 228.954 400 240 400H380C391.046 400 400 391.0457 400 380V20C400 8.954 391.046 0 380 0H240C228.954 0 220 8.954 220 20V380z" : "M140 300C140 311.0457 131.0456 320 120 320H20C8.9543 320 0 311.0457 0 300V200C0 188.9544 8.9543 180 20 180H120C131.0456 180 140 188.9544 140 200V300zM140 120C140 131.0456 131.0456 140 120 140H20C8.9543 140 0 131.0456 0 120V20C0 8.954 8.9543 0 20 0H120C131.0456 0 140 8.954 140 20V120zM320 300C320 311.0457 311.046 320 300 320H200C188.9544 320 180 311.0457 180 300V20C180 8.954 188.9544 0 200 0H300C311.046 0 320 8.954 320 20V300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutLeftColumnTwoTiles.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutLeftColumnTwoTiles.displayName = "Blueprint5.Icon.LayoutLeftColumnTwoTiles";
exports.default = LayoutLeftColumnTwoTiles;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4fWUo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutLinear", ()=>LayoutLinear);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutLinear = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-linear",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M330 260C305.8 260 285.6 242.8 281 220H239.0000000000001C234.4 242.8 214.2 260 190 260S145.6 242.8 141 220H99C94.4 242.8 74.2 260 50 260C22.4 260 0 237.6 0 210C0 182.4 22.4 160 50 160C74.2 160 94.4 177.2 99 200H141C145.6 177.2 165.8 160 190 160S234.4 177.2 239 200H281C285.6 177.2 305.8 160 330 160C357.6 160 380 182.4 380 210C380 237.6 357.6 260 330 260z" : "M280 200C261.4 200 245.8 187.2 241.4 170H198.6C194.2 187.2 178.6 200 160 200S125.8 187.2 121.4 170H78.6C74.2 187.2 58.6 200 40 200C18 200 0 182 0 160C0 138 18 120 40 120C58.6 120 74.2 132.8 78.6 150H121.2C125.8 132.8 141.4 120 160 120S194.2 132.8 198.6 150H241.2C245.6 132.8 261.2 120 279.8 120C301.8 120 319.8 138 319.8 160C320 182 302 200 280 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutLinear.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutLinear.displayName = "Blueprint5.Icon.LayoutLinear";
exports.default = LayoutLinear;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e21Uw":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutRightColumnThreeTiles", ()=>LayoutRightColumnThreeTiles);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutRightColumnThreeTiles = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-right-column-three-tiles",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 380C0 391.04568 8.9543 400 20 400H160C171.0456 400 180 391.0457 180 380V20C180 8.954 171.0456 0 160 0H20C8.9543 0 0 8.954 0 20V380zM220 380C220 391.0457 228.954 400 240 400H380C391.046 400 400 391.0457 400 380V320C400 308.9544 391.046 300 380 300H240C228.954 300 220 308.9544 220 320V380zM220 240C220 251.0456 228.954 260 240 260H380C391.046 260 400 251.0456 400 240V160C400 148.954 391.046 140 380 140H240C228.954 140 220 148.954 220 160V240zM220 80C220 91.046 228.954 100 240 100H380C391.046 100 400 91.046 400 80V20C400 8.954 391.046 0 380 0H240C228.954 0 220 8.954 220 20V80z" : "M180 180C180 191.0456 188.9544 200 200 200H300C311.046 200 320 191.0456 320 180V140C320 128.9544 311.046 120 300 120H200C188.9544 120 180 128.9544 180 140V180zM180 300C180 311.0457 188.9544 320 200 320H300C311.046 320 320 311.0457 320 300V260C320 248.9544 311.046 240 300 240H200C188.9544 240 180 248.9544 180 260V300zM180 60C180 71.046 188.9544 80 200 80H300C311.046 80 320 71.046 320 60V20C320 8.954 311.046 0 300 0H200C188.9544 0 180 8.954 180 20V60zM0 300C0 311.0457 8.9543 320 20 320H120C131.0456 320 140 311.0457 140 300V20C140 8.954 131.0456 0 120 0H20C8.9543 0 0 8.954 0 20V300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutRightColumnThreeTiles.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutRightColumnThreeTiles.displayName = "Blueprint5.Icon.LayoutRightColumnThreeTiles";
exports.default = LayoutRightColumnThreeTiles;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g0JmJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutRightColumnTwoTiles", ()=>LayoutRightColumnTwoTiles);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutRightColumnTwoTiles = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-right-column-two-tiles",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 380C220 391.0457 228.954 400 240 400H380C391.046 400 400 391.0457 400 380V240C400 228.9544 391.046 220 380 220H240C228.954 220 220 228.9544 220 240V380zM220 160C220 171.046 228.954 180 240 180H380C391.046 180 400 171.046 400 160V20C400 8.954 391.046 0 380 0H240C228.954 0 220 8.954 220 20V160zM0 380C0 391.04568 8.9543 400 20 400H160C171.0456 400 180 391.0457 180 380V20C180 8.954 171.0456 0 160 0H20C8.9543 0 0 8.954 0 20V380z" : "M180 300C180 311.0457 188.9544 320 200 320H300C311.046 320 320 311.0457 320 300V200C320 188.9544 311.046 180 300 180H200C188.9544 180 180 188.9544 180 200V300zM180 120C180 131.0456 188.9544 140 200 140H300C311.046 140 320 131.0456 320 120V20C320 8.954 311.046 0 300 0H200C188.9544 0 180 8.954 180 20V120zM0 300C0 311.0457 8.9543 320 20 320H120C131.0456 320 140 311.0457 140 300V20C140 8.954 131.0456 0 120 0H20C8.9543 0 0 8.954 0 20V300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutRightColumnTwoTiles.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutRightColumnTwoTiles.displayName = "Blueprint5.Icon.LayoutRightColumnTwoTiles";
exports.default = LayoutRightColumnTwoTiles;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bPzt5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutSkewGrid", ()=>LayoutSkewGrid);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutSkewGrid = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-skew-grid",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 360A40 40 0 0 1 80 360A40 40 0 0 1 0 360M320 360A40 40 0 0 1 400 360A40 40 0 0 1 320 360M320 200A40 40 0 0 1 400 200A40 40 0 0 1 320 200M320 40A40 40 0 0 1 400 40A40 40 0 0 1 320 40M0 40A40 40 0 0 1 80 40A40 40 0 0 1 0 40M0 200A40 40 0 0 1 80 200A40 40 0 0 1 0 200M160 120A40 40 0 0 1 240 120A40 40 0 0 1 160 120M160 280A40 40 0 0 1 240 280A40 40 0 0 1 160 280" : "M40 200C18 200 0 182 0 160C0 138 18 120 40 120S80 138 80 160C80 182 62 200 40 200zM280 240C302 240 320 258 320 280S302 320 280 320S240 302 240 280S258 240 280 240zM40 80C18 80 0 62 0 40C0 18 18 0 40 0S80 18 80 40C80 62 62 80 40 80zM40 320C18 320 0 302 0 280S18 240 40 240S80 258 80 280S62 320 40 320zM160 140C138 140 120 122 120 100C120 78 138 60 160 60S200 78 200 100C200 122 182 140 160 140zM280 200C258 200 240 182 240 160C240 138 258 120 280 120S320 138 320 160C320 182 302 200 280 200zM160 260C138 260 120 242 120 220S138 180 160 180S200 198 200 220S182 260 160 260zM280 80C258 80 240 62 240 40C240 18 258 0 280 0S320 18 320 40C320 62 302 80 280 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutSkewGrid.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutSkewGrid.displayName = "Blueprint5.Icon.LayoutSkewGrid";
exports.default = LayoutSkewGrid;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9HX57":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutSortedClusters", ()=>LayoutSortedClusters);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutSortedClusters = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-sorted-clusters",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 240C18 240 0 222 0 200S18 160 40 160S80 178 80 200S62 240 40 240zM40 80C18 80 0 62 0 40S18 0 40 0S80 18 80 40S62 80 40 80zM40 400C18 400 0 382 0 360S18 320 40 320S80 338 80 360S62 400 40 400zM360 240C338 240 320 222 320 200S338 160 360 160S400 178 400 200S382 240 360 240zM200 160C178 160 160 142 160 120S178 80 200 80S240 98 240 120S222 160 200 160zM200 320C178 320 160 302 160 280S178 240 200 240S240 258 240 280S222 320 200 320z" : "M40 200C18 200 0 182 0 160S18 120 40 120S80 138 80 160S62 200 40 200zM40 80C18 80 0 62 0 40S18 0 40 0S80 18 80 40S62 80 40 80zM40 320C18 320 0 302 0 280S18 240 40 240S80 258 80 280S62 320 40 320zM280 200C258 200 240 182 240 160S258 120 280 120S320 138 320 160S302 200 280 200zM160 140C138 140 120 122 120 100S138 60 160 60S200 78 200 100S182 140 160 140zM160 260C138 260 120 242 120 220S138 180 160 180S200 198 200 220S182 260 160 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutSortedClusters.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutSortedClusters.displayName = "Blueprint5.Icon.LayoutSortedClusters";
exports.default = LayoutSortedClusters;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l2XuI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutThreeColumns", ()=>LayoutThreeColumns);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutThreeColumns = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-three-columns",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 380C0 391.04568 8.9543 400 20 400H80C91.0456 400 100 391.0457 100 380V20C100 8.954 91.0456 0 80 0H20C8.9543 0 0 8.954 0 20V380zM140 380C140 391.04568 148.9544 400 160 400H240C251.046 400 260 391.0457 260 380V20C260 8.954 251.046 0 240 0H160C148.9544 0 140 8.954 140 20V380zM300 380C300 391.04568 308.954 400 320 400H380C391.046 400 400 391.0457 400 380V20C400 8.954 391.046 0 380 0H320C308.954 0 300 8.954 300 20V380z" : "M240 300C240 311.0457 248.954 320 260 320H300C311.046 320 320 311.0457 320 300V20C320 8.954 311.046 0 300 0H260C248.954 0 240 8.954 240 20V300zM120 300C120 311.0457 128.9544 320 140 320H180C191.0456 320 200 311.0457 200 300V20C200 8.954 191.0456 0 180 0H140C128.9544 0 120 8.954 120 20V300zM0 300C0 311.0457 8.9543 320 20 320H60C71.0456 320 80 311.0457 80 300V20C80 8.954 71.0456 0 60 0H20C8.9543 0 0 8.954 0 20V300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutThreeColumns.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutThreeColumns.displayName = "Blueprint5.Icon.LayoutThreeColumns";
exports.default = LayoutThreeColumns;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4DKme":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutThreeRows", ()=>LayoutThreeRows);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutThreeRows = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-three-rows",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 380C0 391.0457 8.9543 400 20 400H380C391.046 400 400 391.0457 400 380V320C400 308.9544 391.046 300 380 300H20C8.95432 300 0 308.9544 0 320V380zM0 240C0 251.0456 8.9543 260 20 260H380C391.046 260 400 251.0456 400 240V160C400 148.954 391.046 140 380 140H20C8.95432 140 0 148.954 0 160V240zM0 80C0 91.046 8.9543 100 20 100H380C391.046 100 400 91.046 400 80V20C400 8.954 391.046 0 380 0H20C8.95432 0 0 8.954 0 20V80z" : "M300 80C311.046 80 320 71.046 320 60V20C320 8.954 311.046 0 300 0H20C8.9543 0 0 8.954 0 20V60C0 71.046 8.9543 80 20 80H300zM300 200C311.046 200 320 191.0456 320 180V140C320 128.9544 311.046 120 300 120H20C8.9543 120 0 128.9544 0 140V180C0 191.0456 8.9543 200 20 200H300zM300 320C311.046 320 320 311.0457 320 300V260C320 248.9544 311.046 240 300 240H20C8.9543 240 0 248.9544 0 260V300C0 311.0457 8.9543 320 20 320H300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutThreeRows.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutThreeRows.displayName = "Blueprint5.Icon.LayoutThreeRows";
exports.default = LayoutThreeRows;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fsB6X":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutTopRowThreeTiles", ()=>LayoutTopRowThreeTiles);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutTopRowThreeTiles = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-top-row-three-tiles",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 160C0 171.046 8.9543 180 20 180H380C391.046 180 400 171.046 400 160V20C400 8.954 391.046 0 380 0H20C8.95432 0 0 8.954 0 20V160zM0 380C0 391.0457 8.9543 400 20 400H80C91.0456 400 100 391.0457 100 380V240C100 228.9544 91.0456 220 80 220H20C8.9543 220 0 228.9544 0 240V380zM140 380C140 391.0457 148.9544 400 160 400H240C251.046 400 260 391.0457 260 380V240C260 228.9544 251.046 220 240 220H160C148.9544 220 140 228.9544 140 240V380zM300 380C300 391.0457 308.954 400 320 400H380C391.046 400 400 391.0457 400 380V240C400 228.9544 391.046 220 380 220H320C308.954 220 300 228.9544 300 240V380z" : "M140 180C128.9544 180 120 188.9544 120 200L120 300C120 311.0457 128.9544 319.99999776872 140 319.999998251532L180 320C191.0456 320.000000482822 200 311.0457 200 300V200C200 188.9544 191.0456 180 180 180H140zM20 180C8.95432 180 0.00000485396 188.9544 0.00000437114 200L0 300C-4.82822e-7 311.0457 8.9543 319.99999776872 20 319.999998251532L60 320C71.0456 320.000000482822 80 311.0457 80 300V200C80 188.9544 71.0456 180 60 180H20zM260 180C248.954 180 240 188.9544 240 200V300C240 311.0457 248.954 319.99999776872 260 319.999998251532L300 320C311.046 320.000000482822 320 311.0457 320 300V200C320 188.9544 311.046 180 300 180H260zM20 0C8.95432 0 0.00000485396 8.954 0.00000437114 20L0 120C-4.82822e-7 131.0456 8.9543 140 20 140L300 140C311.046 140 320 131.0458 320 120V20C320 8.954 311.046 0 300 0L20 0z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutTopRowThreeTiles.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutTopRowThreeTiles.displayName = "Blueprint5.Icon.LayoutTopRowThreeTiles";
exports.default = LayoutTopRowThreeTiles;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3uTTs":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutTopRowTwoTiles", ()=>LayoutTopRowTwoTiles);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutTopRowTwoTiles = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-top-row-two-tiles",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 380C0 391.0457 8.9543 400 20 400H160C171.0456 400 180 391.0457 180 380V240C180 228.9544 171.0456 220 160 220H20C8.9543 220 0 228.9544 0 240V380zM220 380C220 391.0457 228.954 400 240 400H380C391.046 400 400 391.0457 400 380V240C400 228.9544 391.046 220 380 220H240C228.954 220 220 228.9544 220 240V380zM0 160C0 171.046 8.9543 180 20 180H380C391.046 180 400 171.046 400 160V20C400 8.954 391.046 0 380 0H20C8.95432 0 0 8.954 0 20V160z" : "M200 180C188.9544 180 180 188.9544 180 200V300C180 311.0457 188.9544 320.000000965646 200 320L300 319.99999125772C311.046 319.99999029208 320 311.04568 320 300V200C320 188.9542 311.046 180 300 180L200 180zM20 180C8.9543 180 -9.65646e-7 188.9544 0 200L0.00000874228 300C0.00000970792 311.0457 8.95432 320.000000965646 20 320L120 319.99999125772C131.0458 319.99999029208 140 311.04568 140 300L140 200C140 188.9542 131.0456 180 120 180L20 180zM20 0C8.9543 0 -9.65646e-7 8.954 0 20L0.00000874228 120C0.00000970792 131.0456 8.95432 140 20 140L300 140C311.046 140 320 131.0456 320 120V20C320 8.954 311.046 0 300 0L20 0z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutTopRowTwoTiles.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutTopRowTwoTiles.displayName = "Blueprint5.Icon.LayoutTopRowTwoTiles";
exports.default = LayoutTopRowTwoTiles;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"SifBi":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutTwoColumns", ()=>LayoutTwoColumns);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutTwoColumns = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-two-columns",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 380C0 391.04568 8.9543 400 20 400H160C171.0456 400 180 391.0457 180 380V20C180 8.954 171.0456 0 160 0H20C8.9543 0 0 8.954 0 20V380zM220 380C220 391.04568 228.954 400 240 400H380C391.046 400 400 391.0457 400 380V20C400 8.954 391.046 0 380 0H240C228.954 0 220 8.954 220 20V380z" : "M180 300C180 311.0457 188.9544 320 200 320H300C311.046 320 320 311.0457 320 300V20C320 8.954 311.046 0 300 0H200C188.9544 0 180 8.954 180 20V300zM0 300C0 311.0457 8.9543 320 20 320H120C131.0456 320 140 311.0457 140 300V20C140 8.954 131.0456 0 120 0H20C8.9543 0 0 8.954 0 20V300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutTwoColumns.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutTwoColumns.displayName = "Blueprint5.Icon.LayoutTwoColumns";
exports.default = LayoutTwoColumns;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"emC3J":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutTwoRows", ()=>LayoutTwoRows);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LayoutTwoRows = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout-two-rows",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 380C0 391.0457 8.9543 400 20 400H380C391.046 400 400 391.0457 400 380V240C400 228.9544 391.046 220 380 220H20C8.95432 220 0 228.9544 0 240V380zM0 160C0 171.046 8.9543 180 20 180H380C391.046 180 400 171.046 400 160V20C400 8.954 391.046 0 380 0H20C8.95432 0 0 8.954 0 20V160z" : "M0 120C0 131.0456 8.9543 140 20 140H300C311.046 140 320 131.0456 320 120V20C320 8.954 311.046 0 300 0H20C8.9543 0 0 8.954 0 20V120zM0 300C0 311.0457 8.9543 320 20 320H300C311.046 320 320 311.0457 320 300V200C320 188.9544 311.046 180 300 180H20C8.9543 180 0 188.9544 0 200V300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LayoutTwoRows.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LayoutTwoRows.displayName = "Blueprint5.Icon.LayoutTwoRows";
exports.default = LayoutTwoRows;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5gsV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layout", ()=>Layout);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Layout = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "layout",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 280C338 280 320 262 320 240C320 232.6 322.2 225.8 325.6 219.8L280.2000000000001 174.4C274.2000000000001 177.8 267.4 180 260 180C241.4 180 225.8 167.2 221.4 150H178.6C174.2 167.2 158.6 180 140 180C132.6 180 125.8 177.8 119.8 174.4L74.4 219.8C77.8 225.8 80 232.6 80 240C80 246.8 78.2 253.2 75.2 258.8L148.4 326.4C154.6 322.4 162 320 170 320C192 320 210 338 210 360C210 382 192 400 170 400S130 382 130 360C130 353.2 131.8 346.8 134.8 341.2L61.6 273.6C55.4 277.6 48 280 40 280C18 280 0 262 0 240C0 218 18 200 40 200C47.4 200 54.2 202.2 60.2 205.6L105.6 160.2C102.2 154.2 100 147.4 100 140S102.2 125.8 105.6 119.8L60.2 74.4C54.2 77.8 47.4 80 40 80C18 80 0 62 0 40C0 18 18 0 40 0S80 18 80 40C80 47.4 77.8 54.2 74.4 60.2000000000001L119.8 105.6C125.8 102.2 132.6 100 140 100C158.6 100 174.2 112.8 178.6 130H221.4C225.8 112.8 241.4 100 260 100C282 100 300 118 300 140C300 147.4 297.8 154.2 294.4000000000001 160.2L339.8000000000001 205.6C345.8 202.2 352.6 200 360 200C382 200 400 218 400 240C400 262 382 280 360 280z" : "M280 240C258 240 240 222 240 200C240 190.6 243.4 182 248.8 175.2L235.2 157C230.6 159 225.4 160 220 160C201.4 160 185.8 147.2 181.4 130H158.6C154.2 147.2 138.6 160 120 160C110.6 160 102 156.6 95.2 151.2L77 164.8C79 169.4 80 174.6 80 180C80 187.4 77.8 194.2 74.4 200.2L119.8 245.6C125.8 242.2 132.6 240 140 240C162 240 180 258 180 280C180 302 162 320 140 320S100 302 100 280C100 272.6 102.2 265.8 105.6 259.8L60.2 214.4C54.2 217.8 47.4 220 40 220C18 220 0 202 0 180C0 158 18 140 40 140C49.4 140 58 143.4 64.8 148.8L83 135.2C81 130.6 80 125.4 80 120C80 112.6 82.2 105.8 85.6 99.8L60.2 74.4C54.2 77.8 47.4 80 40 80C18 80 0 62 0 40C0 18 18 0 40 0S80 18 80 40C80 47.4 77.8 54.2 74.4 60.2L99.8 85.6C105.8 82.2 112.6 80 120 80C138.6 80 154.2 92.8 158.6 110H181.4C185.8 92.8 201.4 80 220 80C242 80 260 98 260 120C260 129.4 256.6 138 251.2 144.8L264.8 163C269.4000000000001 161 274.6 160 280 160C302 160 320 178 320 200C320 222 302 240 280 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Layout.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Layout.displayName = "Blueprint5.Icon.Layout";
exports.default = Layout;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"71rNn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Learning", ()=>Learning);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Learning = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "learning",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M211.025884 377.45145018C204.327718 380.849516608 195.6695552 380.849516608 188.975025 377.45145018L9.12816108 282.2228476C-3.04272036 276.0424908 -3.04272036 263.9560918 9.12816108 257.7785596L188.975025 162.542216C195.6695552 159.14415 204.327718 159.14415 211.025884 162.542216L390.8691120000001 257.7785596C403.04363 263.9560918 403.04363 276.0424908 390.8691120000001 282.2228476L211.025884 377.45145018zM360 269.9968334L360.32922 179.716092C360.369136 168.76966 369.254204 159.916934 380.20071 159.916934C391.135556 159.916934 400 168.781378 400 179.716224L400 269.9968334L400 269.9968334L360 269.9968334zM67.3226902 199.3374188L195.3493856 132.177958C198.2574554 130.65246 201.729166 130.651974 204.637664 132.176656L332.760378 199.3406872C335.206126 200.622788 338.2281420000001 199.6794664 339.510244 197.2337192C339.885692 196.5175094 340.081826 195.7209226 340.081826 194.9122704L340.081826 92.739564C340.081826 90.841804 339.00745 89.107626 337.308208 88.262598L204.493676 22.214346C201.689 20.819588 198.3928272 20.819588 195.5881508 22.214346L62.7736186 88.262598C61.074377 89.107626 60 90.841804 60 92.739564L60 194.909653C60 197.6710768 62.2385762 199.909653 65 199.909653C65.8091264 199.909653 66.606166 199.7132888 67.3226902 199.3374188z" : "M168.8207072 297.91480954C163.462174 300.69506349 156.5356442 300.69506349 151.18002 297.91480954L7.30252886 220C-2.43417628 214.943312 -2.43417628 205.0543768 7.30252886 200L151.18002 122.0788574C156.5356442 119.2986034 163.462174 119.2986034 168.8207072 122.0788574L312.69529 200C322.434904 205.0543768 322.434904 214.943312 312.69529 220L168.8207072 297.91480954zM280 209.9968334L280.32922 119.7160926C280.369136 108.7696596 289.254204 99.916934 300.20071 99.916934C311.135556 99.916934 320 108.781378 320 119.7162242L320 209.9968334L320 209.9968334L280 209.9968334zM67.4240658 139.0634448L155.160337 90.429972C158.1753504 88.758708 161.8385762 88.758178 164.8540724 90.428572L252.659026 139.0669492C255.074602 140.4050258 258.11754 139.531539 259.455616 137.115962C259.8663420000001 136.3744958 260.0818260000001 135.5407846 260.0818260000001 134.6931602L260.0818260000001 75.591454C260.0818260000001 73.733896 259.052044 72.029446 257.4077000000001 71.165358L164.6926586 22.44445C161.7803086 20.914036 158.3015184 20.914036 155.3891684 22.44445L62.6741274 71.165358C61.0297826 72.029446 60 73.733896 60 75.591454L60 134.6903562C60 137.4517798 62.2385762 139.6903562 65 139.6903562C65.848114 139.6903562 66.6822902 139.4746216 67.4240658 139.0634448z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Learning.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Learning.displayName = "Blueprint5.Icon.Learning";
exports.default = Learning;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bluGH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LeftJoin", ()=>LeftJoin);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LeftJoin = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "left-join",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M174 306C148 280 130 242 130 200S146 120 174 94C158 84 140 80 120 80C54 80 0 134 0 200S54 320 120 320C140 320 158 316 174 306zM280 320C346 320 400 266 400 200S346 80 280 80C260 80 242 84 226 94C252.0000000000001 120 270 158 270 200S254 278 226 306C242 316 260 320 280 320zM292 279C303 255 309.2 228.2 309.2 200S303 145 292 121C330 127.2000000000001 359.2000000000001 160.2000000000001 359.2000000000001 200S330 272.8 292 279zM200 290C176 266 160 236 160 200S176 134 200 112C224 134 240 166 240 202S224 268 200 290z" : "M132 254C122 258 112 260 100 260C44 260 0 216 0 160S44 60 100 60C112 60 122 62 132 66C106 88 90 122 90 160S106 232 132 254zM160 240C136 222 120 192 120 160S136 98 160 80C184 98 200 126 200 160S184 222 160 240zM220 260C276 260 320 216 320 160S276 60 220 60C208 60 198 62 188 66C214 88 230 124 230 160S214 230 188 254.0000000000001C198 258 208 260 220 260zM227 239.6C241.6 216.6 249.8 189.2 249.8 160S241.4 103.4 227 80.4C267.8 84 299.8 118.4 299.8 160S267.8 236 227 239.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LeftJoin.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LeftJoin.displayName = "Blueprint5.Icon.LeftJoin";
exports.default = LeftJoin;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fJseg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LengthenText", ()=>LengthenText);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LengthenText = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "lengthen-text",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M16.66666 80H183.3334C192.5 80 200 89 200 100C200 111 192.5 120 183.3334 120H16.66666C7.5 120 0 111 0 100C0 89 7.5 80 16.66666 80zM20 180H380C391 180 400 189 400 200C400 211 391 220 380 220H20C9 220 0 211 0 200C0 189 9 180 20 180zM320 139.996C320 134.396 322.2 129.396 325.8 125.796L331.8 119.996H260C249 119.996 240 110.996 240 99.996C240 88.996 249 79.996 260 79.996H331.8L326 74.196C322.2 70.596 320 65.596 320 59.996C320 48.996 329 39.996 340 39.996C345.6 39.996 350.6 42.196 354.2000000000001 45.796L394.2000000000001 85.796C397.8 89.596 400 94.596 400 99.996C400 105.596 397.8 110.596 394.2000000000001 114.196L354.2000000000001 154.196C350.6 157.796 345.6 159.996 340 159.996C329 160.196 320 151.196 320 139.996zM20 280H380C391 280 400 289 400 300C400 311 391 320 380 320H20C9 320 0 311 0 300C0 289 9 280 20 280z" : "M20 140H300C311 140 320 149 320 160C320 171 311 180 300 180H20C9 180 0 171 0 160C0 149 9 140 20 140zM100 80H20C9 80 0 71 0 60C0 49 9 40 20 40H100C111 40 120 49 120 60C120 71 111 80 100 80zM240 100C240 94.4 242.2 89.4 245.8 85.8L251.8 80H180C169 80 160 71 160 60C160 49 169 40 180 40H251.8L246 34.2C242.2 30.6 240 25.6 240 20C240 9 249 0 260 0C265.6 0 270.6 2.2 274.2000000000001 5.8L314.2000000000001 45.8C317.8 49.4 320 54.4 320 60C320 65.6 317.8 70.6 314.2000000000001 74.2L274.2000000000001 114.2C270.6 117.8 265.6 120 260 120C249 120 240 111 240 100zM20 240H300C311 240 320 249 320 260C320 271 311 280 300 280H20C9 280 0 271 0 260C0 249 9 240 20 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LengthenText.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LengthenText.displayName = "Blueprint5.Icon.LengthenText";
exports.default = LengthenText;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gJfXq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LessThanOrEqualTo", ()=>LessThanOrEqualTo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LessThanOrEqualTo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "less-than-or-equal-to",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M326.3191492 178.97366L143.240148 239.999994L326.3191492 301.0263280000001C336.7980156 304.5192834 342.4612154 315.845683 338.96826 326.3245492C335.4753044000001 336.8034156 324.148905 342.4666154 313.6700386 338.97366L73.670038 258.97366C55.436112 252.8956844 55.436112 227.1043034 73.670038 221.026328L313.6700386 141.026328C324.148905 137.533372 335.4753044000001 143.196572 338.96826 153.675438C342.4612154 164.154306 336.7980156 175.480704 326.3191492 178.97366zM319.994594 99.999994L79.994594 99.999994C68.948898 99.999994 59.994594 91.045688 59.994594 79.999994C59.994594 68.954298 68.948898 59.999994 79.994594 59.999994L319.994594 59.999994C331.0402890000001 59.999994 339.994594 68.954298 339.994594 79.999994C339.994594 91.045688 331.0402890000001 99.999994 319.994594 99.999994z" : "M265.741692 240.8434742C276.321549 244.0174314 282.325217 255.1671008 279.15126 265.7469578C275.9773028 276.3268148 264.8276334 282.3304828000001 254.2477764 279.1565258L54.247776 219.1565258C35.24372 213.4553088 35.24372 186.5446912 54.247776 180.8434742L254.2477764 120.8434742C264.8276334 117.669518 275.9773028 123.6731852 279.15126 134.2530422C282.325217 144.8328992 276.321549 155.9825686 265.741692 159.1565258L129.5967776 200L265.741692 240.8434742zM259.9947342000001 80L59.994734 80C48.94904 80 39.994734 71.045694 39.994734 60C39.994734 48.954306 48.94904 40 59.994734 40L259.9947342000001 40C271.0404292 40 279.9947342000001 48.954306 279.9947342000001 60C279.9947342000001 71.045694 271.0404292 80 259.9947342000001 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LessThanOrEqualTo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LessThanOrEqualTo.displayName = "Blueprint5.Icon.LessThanOrEqualTo";
exports.default = LessThanOrEqualTo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"qZ3ul":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LessThan", ()=>LessThan);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LessThan = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "less-than",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M143.245568 199.994574L326.3245694 138.96824C336.8034356 135.475284 342.4666354 124.148886 338.97368 113.670018C335.4807246000001 103.191152 324.154325 97.527952 313.6754586 101.020908L73.675458 181.020908C55.441532 187.098884 55.441532 212.8902646 73.675458 218.96824L313.6754586 298.9682400000001C324.154325 302.4611954 335.4807246000001 296.7979956 338.97368 286.3191294C342.4666354 275.840263 336.8034356 264.5138634 326.3245694 261.020908L143.245568 199.994574z" : "M265.7469720000001 200.8382084C276.3268290000001 204.0121656 282.3304970000001 215.161835 279.1565400000001 225.741692C275.9825828000001 236.321549 264.8329134 242.325217 254.2530564000001 239.15126L54.253056 179.15126C35.249 173.450043 35.249 146.5394254 54.253056 140.8382084L254.2530564000001 80.838208C264.8329134 77.664252 275.9825828000001 83.66792 279.1565400000001 94.247776C282.3304970000001 104.827634 276.3268290000001 115.977302 265.7469720000001 119.15126L129.6020576000001 159.9947342L265.7469720000001 200.8382084z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LessThan.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LessThan.displayName = "Blueprint5.Icon.LessThan";
exports.default = LessThan;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jFOAP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lifesaver", ()=>Lifesaver);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Lifesaver = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "lifesaver",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M162.851055 107.127638L140.561688 51.40422C158.9376584 44.047172 178.9961952 40 200 40C221.003804 40 241.062342 44.047172 259.438312 51.40422L237.148946 107.127638C225.663964 102.529484 213.127378 100 200 100C186.872622 100 174.3360364 102.529484 162.851055 107.127638zM107.1276374 162.851054C102.529483 174.336036 100 186.872622 100 200C100 213.127378 102.529483 225.6639636 107.1276374 237.148945L51.4042198 259.438312C44.0471728 241.0623416 40 221.0038048 40 200C40 178.996196 44.0471728 158.937658 51.4042198 140.561688L107.1276374 162.851054zM162.851055 292.8723626C174.3360364 297.470517 186.872622 300 200 300C213.127378 300 225.663964 297.470517 237.148946 292.8723626L259.438312 348.5957802C241.062342 355.9528272 221.003804 360 200 360C178.9961952 360 158.9376584 355.9528272 140.561688 348.5957802L162.851055 292.8723626zM292.872362 237.148945C297.470516 225.6639636 300 213.127378 300 200C300 186.872622 297.470516 174.336036 292.872362 162.851054L348.59578 140.561688C355.952828 158.937658 360 178.996196 360 200C360 221.0038048 355.952828 241.0623416 348.59578 259.438312L292.872362 237.148945zM200 140C233.137084 140 260 166.862916 260 200C260 233.137085 233.137084 260 200 260C166.862915 260 140 233.137085 140 200C140 166.862916 166.862915 140 200 140zM200 0C89.54305 0 0 89.54305 0 200C0 310.45695 89.54305 400 200 400C310.45695 400 400 310.45695 400 200C400 89.54305 310.45695 0 200 0z" : "M188.0974886 85.073364C179.3556866 81.793668 169.8873102 80 160 80C150.1126898 80 140.6443134 81.793668 131.9025114 85.073364L117.8537672 47.610046C130.9664702 42.690502 145.1690348 40 160 40C174.8309652 40 189.0335298 42.690502 202.146232 47.610046L188.0974886 85.073364zM234.926636 131.9025114L272.389954 117.853768C277.309498 130.9664702 280 145.1690348 280 160C280 174.8309652 277.309498 189.0335298 272.389954 202.1462328L234.926636 188.0974886C238.206332 179.3556866 240 169.8873102 240 160C240 150.1126898 238.206332 140.6443134 234.926636 131.9025114zM188.0974886 234.9266362L202.146232 272.3899542000001C189.0335298 277.3094976 174.8309652 280 160 280C145.1690348 280 130.9664702 277.3094976 117.8537672 272.3899542000001L131.9025114 234.9266362C140.6443134 238.2063318 150.1126898 240 160 240C169.8873102 240 179.3556866 238.2063318 188.0974886 234.9266362zM85.0733638 188.0974886L47.6100458 202.1462328C42.6905024 189.0335298 40 174.8309652 40 160C40 145.1690348 42.6905024 130.9664702 47.6100458 117.853768L85.0733638 131.9025114C81.7936682 140.6443134 80 150.1126898 80 160C80 169.8873102 81.7936682 179.3556866 85.0733638 188.0974886zM160 0C71.63444 0 0 71.63444 0 160C0 248.36556 71.63444 320 160 320C248.36556 320 320 248.36556 320 160C320 71.63444 248.36556 0 160 0zM160 120C182.09139 120 200 137.90861 200 160C200 182.09139 182.09139 200 160 200C137.90861 200 120 182.09139 120 160C120 137.90861 137.90861 120 160 120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Lifesaver.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Lifesaver.displayName = "Blueprint5.Icon.Lifesaver";
exports.default = Lifesaver;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7DdSe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lightbulb", ()=>Lightbulb);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Lightbulb = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "lightbulb",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M126.6 132.2C126.6 125.4 132 120 138.6 120H261.2C267.8 120 273.2 125.4 273.2 132.2C280.6 204.4 320 212 320 278.2C320 345.6 266.2 400 200 400S80 345.6 80 278.2C80 212 119.4 204.4 126.6 132.2L126.6 132.2zM260 100H140C129 100 120 91 120 80C120 69 129 60 140 60H260C271 60 280 69 280 80C280 91 271 100 260 100zM240 40H160C149 40 140 31 140 20C140 9 149 0 160 0H240C251 0 260 9 260 20C260 31 251 40 240 40z" : "M180.2 40H140.2C129.2 40 120.2 31 120.2 20C120.2 9 129.2 0 140.2 0H180.2C191.2 0 200.2 9 200.2 20C200.2 31 191.4 40 180.2 40zM200.2 100H120.2C109.2 100 100.2 91 100.2 80C100.2 69 109.2 60 120.2 60H200.2C211.2 60 220.2 69 220.2 80C220.2 91 211.4 100 200.2 100zM160.2 320C105.2 320 60.6 281 60.6 233C60.6 185.6 93.2 180.2 99.4 128.6H99.4C99.4 123.8 103.8 119.8 109.4 119.8H211.2C216.8 119.8 221.2 123.6 221.2 128.6C227.4 180.2 260 185.6 260 233C260 281 215.4 320 160.2 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Lightbulb.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Lightbulb.displayName = "Blueprint5.Icon.Lightbulb";
exports.default = Lightbulb;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8fgnQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lightning", ()=>Lightning);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Lightning = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "lightning",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M180 180H120C108.9544 180 100 188.954 100 200L118.199 381.99006C119.2214 392.2141 127.8248 400 138.0998 400H263.23C272.492 400 280 392.49166 280 383.22966C280 381.09616 279.592 378.9822 278.8 377.0014L224 240H283.56C292.64 240 300 232.64 300 223.5608C300 221.2142 299.498 218.8946 298.526 216.7584L203.242 7.132C201.268 2.788 196.937 0 192.166 0C185.447 0 180 5.446 180 12.166V180z" : "M140 140H100C88.9544 140 80 148.9542 80 160L97.81 302.4807C99.0612 312.48928 107.5692 320 117.6556 320H203.07C212.42 320 220 312.42018 220 303.07C220 301.03988 219.634 299.0264 218.922 297.1254L182.5 200H223.502C232.614 200 240 192.6132 240 183.5012C240 181.1928 239.516 178.91 238.578 176.8004L163.1996 7.198C161.2538 2.822 156.9126 0 152.1222 0C145.4272 0 140 5.428 140 12.122V140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Lightning.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Lightning.displayName = "Blueprint5.Icon.Lightning";
exports.default = Lightning;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9P7Qe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Link", ()=>Link);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Link = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "link",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M217 160.4L128.2 71.6L108.2 51.6C101 44.4 91 40 80 40C58 40 40 58 40 80C40 91 44.4 101 51.8 108.2L160.6 217C153.8 218.8 147.2 220 140 220C117.8 220 98.2 210.8 83.6 196.4L83.4 196.6L23.4 136.6L23.6 136.4C9.2 121.8 0 102.2 0 80C0 35.8 35.8 0 80 0C102.2 0 121.8 9.2 136.4 23.6L136.6 23.4L196.6 83.4L196.4 83.6C210.8 98.2 220 117.8 220 140C220 147.2 218.8 153.8 217 160.4zM400 320C400 364.2 364.2000000000001 400 320 400C297.8 400 278.2 390.8 263.6 376.4L263.4 376.6L203.4 316.6L203.6 316.4C189.2 301.8 180 282.2 180 260C180 252.8 181.2 246.2 183 239.6L271.8 328.4000000000001L291.8 348.4000000000001C299 355.6 309 360 320 360C342 360 360 342 360 320C360 309 355.6 299 348.2 291.8L239.4 183C246.2 181.2 252.8 180 260 180C282.2 180 301.8 189.2 316.4 203.6L316.6 203.4L376.6 263.4L376.3999999999999 263.6C390.8 278.2 400 297.8 400 320zM100 120C100 109 109 100 120 100C125.6 100 130.6 102.2 134.2 105.8L294.2000000000001 265.8C297.8 269.4 300 274.4 300 280C300 291 291 300 280 300C274.4000000000001 300 269.4000000000001 297.8 265.8 294.2L225.8 254.2L185.8 214.2L145.8 174.2L105.8 134.2000000000001C102.2 130.6 100 125.6 100 120z" : "M99.8 80.2C105.4 80.2 110.4 82.4 114 86L234 206C237.6 209.6 239.8 214.6 239.8 220.2C239.8 231.2 230.8 240.2 219.8 240.2C214.2 240.2 209.2 238 205.6 234.4L85.6 114.4C82 110.8 79.8 105.8 79.8 100.2C79.8 89.2 88.8 80.2 99.8 80.2zM176.8 120.6L128 71.8L108 51.8L107.8 52C100.6 44.8 90.8 40 79.8 40C57.8 40 39.8 58 39.8 80C39.8 91 44.6 100.8 51.8 108L51.6 108.2L71.6 128.2L120.4 177C113.8 179 107 180.2 99.8 180.2C77.8 180.2 58 171 43.6 156.4L43.2 156.8L23.2 136.8L23.6 136.4C9 122 -0.2 102.2 -0.2 80.2C-0.2 36 35.6 0.2 79.8 0.2C101.8 0.2 121.6 9.4 136 24L136.4 23.6L156.4 43.6L156 44C170.6 58.4 179.8 78.2 179.8 100.2C179.8 107.2 178.6 114 176.8 120.6zM319.8 240.2C319.8 284.4 284 320.2 239.8 320.2C217.8 320.2 198 311 183.6 296.4L183.2 296.8L163.2 276.8L163.6 276.4C149.2 262 139.8 242.2 139.8 220.2C139.8 213 141 206.4 142.8 199.8L191.6 248.6L211.6 268.6L211.8 268.4C219 275.6 228.8 280.4 239.8 280.4C261.8 280.4 279.8 262.4000000000001 279.8 240.4C279.8 229.4 275 219.6 267.8 212.4L268 212.2L248 192.2L199.4 143.2C206 141.4 212.8 140.2 219.8 140.2C241.8 140.2 261.6 149.4 276 164L276.4 163.6L296.4 183.6L296 184C310.6 198.4 319.8 218 319.8 240.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Link.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Link.displayName = "Blueprint5.Icon.Link";
exports.default = Link;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"RzNkA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkedSquares", ()=>LinkedSquares);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LinkedSquares = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "linked-squares",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M22 380C9.8496 380 0 370.1502 0 358V142C0 129.85 9.84974 120 22 120H60C71.0456 120 80 128.954 80 140C80 151.046 71.0456 160 60 160H40V340H260V160H180C168.9544 160 160 151.046 160 140C160 128.954 168.9544 120 180 120H278C290.15 120 300 129.85 300 142V358C300 370.1504 290.15 380 278 380H22zM122 20C109.8496 20 100 29.85 100 42V258C100 270.1502 109.8498 280 122 280H220C231.046 280 240 271.0458 240 260C240 248.9542 231.046 240 220 240H140V60H360V240H340C328.954 240 320 248.9542 320 260C320 271.0458 328.954 280 340 280H378C390.15 280 400 270.1502 400 258V42C400 29.85 390.15 20 378 20H122z" : "M40 260V140C51.0456 140 60 131.0456 60 120C60 108.954 51.0456 100 40 100H25C11.19288 100 0 111.192 0 125L0 275C0 288.807 11.19286 300 25 300H215C228.808 300 240 288.807 240 275V125C240 111.192 228.808 100 215 100H160C148.9544 100 140 108.954 140 120C140 131.0456 148.9544 140 160 140H200V260H40zM280 60V180C268.954 180 260 188.9544 260 200C260 211.0458 268.954 220 280 220H295C308.808 220 320 208.8072 320 195V45C320 31.192 308.808 20 295 20H105C91.1928 20 80 31.192 80 45V195C80 208.807 91.1928 220 105 220H160C171.0456 220 180 211.0458 180 200C180 188.9544 171.0456 180 160 180H120V60H280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LinkedSquares.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LinkedSquares.displayName = "Blueprint5.Icon.LinkedSquares";
exports.default = LinkedSquares;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3zprt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListColumns", ()=>ListColumns);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ListColumns = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "list-columns",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 340.5315614L0 359.269103C0 370.63122924 9.18978912 379.8006644518 20.5771366 380L159.4228634 380C170.8102108 380 180 370.63122924 180 359.4684386L180 340.5315614C180 329.1694352 170.6104328 320 159.4228634 320L20.5771366 320C9.18978912 320 0 329.1694352 0 340.5315614zM0 240.5315614L0 259.269103C0 270.6312292 9.18978912 279.8006644 20.5771366 280L159.4228634 280C170.8102108 280 180 270.6312292 180 259.4684386L180 240.5315614C180 229.1694352 170.6104328 220 159.4228634 220L20.5771366 220C9.18978912 220 0 229.1694352 0 240.5315614zM0 140.531562L0 159.269102C0 170.63123 9.18978912 179.800664 20.5771366 180L159.4228634 180C170.8102108 180 180 170.63123 180 159.468438L180 140.531562C180 129.169436 170.6104328 120 159.4228634 120L20.5771366 120C9.18978912 120 0 129.169436 0 140.531562zM0 40.531562L0 59.269102C0 70.6312300000001 9.18978912 79.800664 20.5771366 80L159.4228634 80C170.8102108 80 180 70.6312300000001 180 59.4684380000001L180 40.531562C180 29.169436 170.6104328 20 159.4228634 20L20.5771366 20C9.18978912 20 0 29.169436 0 40.531562zM220 340.5315614L220 359.269103C220 370.63122924 229.18979 379.8006644518 240.577136 380L379.422864 380C390.81021 380 400 370.63122924 400 359.4684386L400 340.5315614C400 329.1694352 390.610432 320 379.422864 320L240.577136 320C229.18979 320 220 329.1694352 220 340.5315614zM220 240.5315614L220 259.269103C220 270.6312292 229.18979 279.8006644 240.577136 280L379.422864 280C390.81021 280 400 270.6312292 400 259.4684386L400 240.5315614C400 229.1694352 390.610432 220 379.422864 220L240.577136 220C229.18979 220 220 229.1694352 220 240.5315614zM220 140.531562L220 159.269102C220 170.63123 229.18979 179.800664 240.577136 180L379.422864 180C390.81021 180 400 170.63123 400 159.468438L400 140.531562C400 129.169436 390.610432 120 379.422864 120L240.577136 120C229.18979 120 220 129.169436 220 140.531562zM220 40.531562L220 59.269102C220 70.6312300000001 229.18979 79.800664 240.577136 80L379.422864 80C390.81021 80 400 70.6312300000001 400 59.4684380000001L400 40.531562C400 29.169436 390.610432 20 379.422864 20L240.577136 20C229.18979 20 220 29.169436 220 40.531562z" : "M120 300C131 300 140 291 140 280C140 269 131 260 120 260L20 260C9 260 0 269 0 280C0 291 9 300 20 300L120 300zM120 220C131 220 140 211 140 200C140 189 131 180 120 180L20 180C9 180 0 189 0 200C0 211 9 220 20 220L120 220zM120 140C131 140 140 131 140 120C140 109 131 100 120 100L20 100C9 100 0 109 0 120C0 131 9 140 20 140L120 140zM120 60C131 60 140 51 140 40C140 29 131 20 120 20L20 20C9 20 0 29 0 40C0 51 9 60 20 60L120 60zM300 300C311 300 320 291 320 280C320 269 311 260 300 260L200 260C189 260 180 269 180 280C180 291 189 300 200 300L300 300zM300 220C311 220 320 211 320 200C320 189 311 180 300 180L200 180C189 180 180 189 180 200C180 211 189 220 200 220L300 220zM300 140C311 140 320 131 320 120C320 109 311 100 300 100L200 100C189 100 180 109 180 120C180 131 189 140 200 140L300 140zM300 60C311 60 320 51 320 40C320 29 311 20 300 20L200 20C189 20 180 29 180 40C180 51 189 60 200 60L300 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ListColumns.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ListColumns.displayName = "Blueprint5.Icon.ListColumns";
exports.default = ListColumns;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9X8TG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListDetailView", ()=>ListDetailView);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ListDetailView = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "list-detail-view",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 280H20C9 280 0 271 0 260V240C0 229 9 220 20 220H160C171 220 180 229 180 240V260C180 271 171 280 160 280zM160 180H20C9 180 0 171 0 160V140C0 129 9 120 20 120H160C171 120 180 129 180 140V160C180 171 171 180 160 180zM160 80H20C9 80 0 71 0 60V40C0 29 9 20 20 20H160C171 20 180 29 180 40V60C180 71 171 80 160 80zM160 380H20C9 380 0 371 0 360V340C0 329 9 320 20 320H160C171 320 180 329 180 340V360C180 371 171 380 160 380zM380 380H240C229 380 220 371 220 360V40C220 29 229 20 240 20H380C391 20 400 29 400 40V360C400 371 391 380 380 380z" : "M120 140H20C9 140 0 131 0 120S9 100 20 100H120C131 100 140 109 140 120S131 140 120 140zM120 60H20C9 60 0 51 0 40S9 20 20 20H120C131 20 140 29 140 40S131 60 120 60zM300 300H200C189 300 180 291 180 280V40C180 29 189 20 200 20H300C311 20 320 29 320 40V280C320 291 311 300 300 300zM120 220H20C9 220 0 211 0 200S9 180 20 180H120C131 180 140 189 140 200S131 220 120 220zM120 300H20C9 300 0 291 0 280S9 260 20 260H120C131 260 140 269 140 280S131 300 120 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ListDetailView.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ListDetailView.displayName = "Blueprint5.Icon.ListDetailView";
exports.default = ListDetailView;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f4Gf5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "List", ()=>List);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var List = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "list",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20.6 380C9.2 380 0 370.8 0 359.4V340.4C0 329.2 9.2 320 20.6 320H379.6C390.8 320 400 329.2 400 340.6V359.4C400 370.8 390.8 380 379.4 380H20.6zM0 40.6C0 29.2 9.2 20 20.6 20H379.6C390.8 20 400.2000000000001 29.2 400.2000000000001 40.6V59.6C400.2000000000001 70.8 391 80.2 379.6 80.2H20.6C9.2 80 0 70.8 0 59.4V40.6zM0 140.6C0 129.2000000000001 9.2 120 20.6 120H379.6C390.8 120 400.2000000000001 129.2000000000001 400.2000000000001 140.6V159.6C400.2000000000001 170.8 391 180.2 379.6 180.2H20.6C9.2 180 0 170.8 0 159.4V140.6zM0 240.6C0 229.2 9.2 220 20.6 220H379.6C390.8 220 400 229.2 400 240.6V259.4C400 270.8 390.8 280 379.4 280H20.6C9.2 280 0 270.8 0 259.4V240.6z" : "M20 260H300C311 260 320 269 320 280S311 300 300 300H20C9 300 0 291 0 280S9 260 20 260zM300 60H20C9 60 0 51 0 40S9 20 20 20H300C311 20 320 29 320 40S311 60 300 60zM300 140H20C9 140 0 131 0 120S9 100 20 100H300C311 100 320 109 320 120S311 140 300 140zM300 220H20C9 220 0 211 0 200S9 180 20 180H300C311 180 320 189 320 200S311 220 300 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
List.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
List.displayName = "Blueprint5.Icon.List";
exports.default = List;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dlH2T":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Locate", ()=>Locate);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Locate = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "locate",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 240C178 240 160 222 160 200C160 178 178 160 200 160S240 178 240 200C240 222 222 240 200 240zM380 220H358.6C349.6 292.2 292.2 349 220 358.2V380C220 391 211 400 200 400S180 391 180 380V358.2C107.8 349 50.4 292.2 41.4 220H20C9 220 0 211 0 200C0 189 9 180 20 180H41.4C50.4 107.8 107.8 51 180 41.8V20C180 9 189 0 200 0S220 9 220 20V41.8C292.2 51 349.6 107.6 358.6 180H380C391 180 400 189 400 200C400 211 391 220 380 220zM300 180H318C309.6 129.8 270.2 90.2 220 81.8V100C220 111 211 120 200 120S180 111 180 100V81.8C129.8 90.2 90.4 129.8 82 180H100C111 180 120 189 120 200C120 211 111 220 100 220H82C90.4 270.2 129.8 309.8 180 318.2V300C180 289 189 280 200 280S220 289 220 300V318.2C270.2 309.8 309.6 270.2 318 220H300C289 220 280 211 280 200C280 189 289 180 300 180z" : "M300 180H298.2C289.4000000000001 241 241.2 289.2 180 298V300C180 311 171 320 160 320S140 311 140 300V298.2C79 289.4 30.8 241.2 22 180H20C9 180 0 171 0 160C0 149 9 140 20 140H22C30.8 78.8 78.8 30.6 140 21.8V20C140 9 149 0 160 0S180 9 180 20V21.8C241 30.6 289.2000000000001 78.8 298 140H300C311 140 320 149 320 160C320 171 311 180 300 180zM179.6 62C178.6 72 170.4 80 160 80S141.4 72 140.4 62C101 70 69.8 101 62 140.4C72 141.4 80 149.6 80 160C80 170.4 72 178.6 62 179.6C69.8 219 101 250 140.4 258C141.4 248 149.6 240 160 240C170.4 240 178.6 248 179.6 258C219 250.2 250 219 258 179.6C248 178.6 240 170.4 240 160C240 149.6 248 141.4 258 140.4C250.2 101 219 70 179.6 62zM160 200C138 200 120 182 120 160C120 138 138 120 160 120S200 138 200 160C200 182 182 200 160 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Locate.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Locate.displayName = "Blueprint5.Icon.Locate";
exports.default = Locate;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ebYad":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lock", ()=>Lock);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Lock = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "lock",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M318.6 220H280V300.2C280 344.4 244.2 380.2 200 380.2S120 344.4 120 300.2V220H78.6C67.6 220 60 211.2 60 200.2V40.1999999999999C60 29.2 67.6 20 78.6 20H318.6C329.6 20 340 29.2 340 40.2V200.2000000000001C340 211.2 329.6 220 318.6 220zM160 220V300.2C160 322.2 178 340.2 200 340.2S240 322.2 240 300.2V220H160z" : "M279.2000000000001 180H240V241C240 284.6 204.2 320 160 320S80 284.6 80 241V180H39.2C28.2 180 20 173 20 162V23.8C20 13 28.2 0 39.2 0H279.2000000000001C290.2000000000001 0 300 13 300 23.8V162C300 173 290.2 180 279.2000000000001 180zM120 180V241C120 262.8 138 280.4 160 280.4S200 262.8 200 241V180H120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Lock.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Lock.displayName = "Blueprint5.Icon.Lock";
exports.default = Lock;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"13QY2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Locomotive", ()=>Locomotive);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Locomotive = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "locomotive",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M199.7658 360H39.974C28.9426 360 20 351.0456 20 340V80H54.8084C58.0338 80 61.0772 81.62 63.0336 84.186C109.5386 145.222 155.508 112.944 176.7218 84.362C178.7136 81.678 181.7976 80 185.1366 80H194.8814C197.9632 80 200.9 81.488 202.856 83.872C254.372 146.724 298.11 113.702 316.592 85.034C318.558 81.984 321.86 80 325.486 80H375.394C384.2920000000001 80 388.748 90.772 382.456 97.072L359.5580000000001 120C429.466 180 399.5060000000001 233.3334 339.584 260V300L362.482 322.929C368.774 329.2286000000001 364.3180000000001 340 355.42 340H283.798C274.9020000000001 340 270.446 329.2286000000001 276.736 322.929L299.636 300V260H219.74V340C219.74 351.0456 210.798 360 199.7658 360zM59.948 320H119.8698V220H59.948V320zM179.7918 320H139.8438V220H179.7918V320zM119.8698 20C141.9324 20 159.8178 37.908 159.8178 60C159.8178 82.092 141.9324 100 119.8698 100C97.8072 100 79.9218 82.092 79.9218 60C79.9218 37.908 97.8072 20 119.8698 20zM119.8698 40C130.9012 40 139.8438 48.954 139.8438 60C139.8438 71.046 130.9012 80 119.8698 80C108.8386 80 99.8958 71.046 99.8958 60C99.8958 48.954 108.8386 40 119.8698 40zM259.688 20C281.75 20 299.636 37.908 299.636 60C299.636 82.092 281.75 100 259.688 100C237.626 100 219.74 82.092 219.74 60C219.74 37.908 237.626 20 259.688 20zM259.688 40C270.72 40 279.6620000000001 48.954 279.6620000000001 60C279.6620000000001 71.046 270.72 80 259.688 80C248.656 80 239.714 71.046 239.714 60C239.714 48.954 248.656 40 259.688 40z" : "M0 280V40H34.116C37.7476 40 41.0936 42.024 42.9716 45.132C79.9116 106.266 119.0458 73.522 137.0038 45.052C138.9414 41.98 142.2524 40 145.884 40H154.116C157.7476 40 161.0936 42.024 162.9716 45.132C199.9116 106.266 239.046 73.522 257.004 45.052C258.942 41.98 262.252 40 265.884 40H285.514C290.86 40 293.538 46.462 289.758 50.242L260 80C348 128 296.666 180 260 200V240L282.928 262.929C289.228 269.2286000000001 284.766 280 275.858 280H204.142C195.233 280 190.7714 269.2286000000001 197.071 262.929L220 240V200H160V280C160 291.0456 151.0456 300 140 300H20C8.9543 300 0 291.0456 0 280zM20 180H80V280H20V180zM140 180H100V280H140V180zM90 0C106.5686 0 120 13.432 120 30C120 46.568 106.5686 60 90 60C73.4314 60 60 46.568 60 30C60 13.432 73.4314 0 90 0zM90 20C95.5228 20 100 24.478 100 30C100 35.522 95.5228 40 90 40C84.4772 40 80 35.522 80 30C80 24.478 84.4772 20 90 20zM210 0C226.568 0 240 13.432 240 30C240 46.568 226.568 60 210 60C193.4314 60 180 46.568 180 30C180 13.432 193.4314 0 210 0zM210 20C215.522 20 220 24.478 220 30C220 35.522 215.522 40 210 40C204.478 40 200 35.522 200 30C200 24.478 204.478 20 210 20z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Locomotive.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Locomotive.displayName = "Blueprint5.Icon.Locomotive";
exports.default = Locomotive;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cNJAD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogIn", ()=>LogIn);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LogIn = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "log-in",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400H220C209 400 200 391 200 380C200 369 209 360 220 360H360V40H220C209 40 200 31 200 20C200 9 209 0 220 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM300 200C300 205.6 297.8 210.6 294.2000000000001 214.2L194.2 314.2000000000001C190.6 317.8 185.6 320 180 320C169 320 160 311 160 300C160 294.4 162.2 289.4 165.8 285.8L231.8 220H20C9 220 0 211 0 200C0 189 9 180 20 180H231.8L166 114.2000000000001C162.2 110.6 160 105.6 160 100C160 89 169 80 180 80C185.6 80 190.6 82.2 194.2 85.8L294.2000000000001 185.8C297.8 189.4 300 194.4 300 200z" : "M220 160C220 165.6 217.8 170.6 214.2 174.2L154.2 234.2C150.6 237.8 145.6 240 140 240C129 240 120 231 120 220C120 214.4 122.2 209.4 125.8 205.8L151.8 180H20C9 180 0 171 0 160C0 149 9 140 20 140H151.8L126 114.2C122.2 110.6 120 105.6 120 100C120 89 129 80 140 80C145.6 80 150.6 82.2 154.2 85.8L214.2 145.8C217.8 149.4 220 154.4 220 160zM300 320H180C169 320 160 311 160 300C160 289 169 280 180 280H280V40H180C169 40 160 31 160 20C160 9 169 0 180 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LogIn.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LogIn.displayName = "Blueprint5.Icon.LogIn";
exports.default = LogIn;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cJDBJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogOut", ()=>LogOut);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LogOut = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "log-out",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M394.2000000000001 214.2L294.2000000000001 314.2000000000001C290.6 317.8 285.6 320 280 320C269 320 260 311 260 300C260 294.4 262.2 289.4 265.8 285.8L331.8 220H120C109 220 100 211 100 200S109 180 120 180H331.8L266 114.2000000000001C262.2 110.6 260 105.6 260 100C260 89 269 80 280 80C285.6 80 290.6 82.2 294.2000000000001 85.8L394.2000000000001 185.8C397.8 189.4 400 194.4 400 200C400 205.6 397.8 210.6 394.2000000000001 214.2zM180 40H40V360H180C191 360 200 369 200 380S191 400 180 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H180C191 0 200 9 200 20S191 40 180 40z" : "M140 40H40V280H140C151 280 160 289 160 300S151 320 140 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H140C151 0 160 9 160 20S151 40 140 40zM314.2000000000001 174.2L254.2 234.2C250.6 237.8 245.6 240 240 240C229 240 220 231 220 220C220 214.4 222.2 209.4 225.8 205.8L251.8 180H120C109 180 100 171 100 160S109 140 120 140H251.8L226 114.2C222.2 110.6 220 105.6 220 100C220 89 229 80 240 80C245.6 80 250.6 82.2 254.2 85.8L314.2000000000001 145.8C317.8 149.4 320 154.4 320 160C320 165.6 317.8 170.6 314.2000000000001 174.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LogOut.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LogOut.displayName = "Blueprint5.Icon.LogOut";
exports.default = LogOut;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"elgVU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LowVoltagePole", ()=>LowVoltagePole);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var LowVoltagePole = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "low-voltage-pole",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C188.9542 400 180 391.04568 180 380V340H100V360C100 371.0456 91.0456 380 80 380C68.9544 380 60 371.0456 60 360V340H40C28.9544 340 20 331.0456000000001 20 320C20 308.9544 28.9544 300 40 300H60V260H40C28.9544 260 20 251.0456 20 240C20 228.9544 28.9544 220 40 220H120C131.0456 220 140 228.9544 140 240C140 251.0456 131.0456 260 120 260H100V300H180V20C180 8.954 188.9542 0 200 0C211.046 0 220 8.954 220 20V300H300V260H280C268.954 260 260 251.0456 260 240C260 228.9544 268.954 220 280 220H360C371.046 220 380 228.9544 380 240C380 251.0456 371.046 260 360 260H340V300H360C371.046 300 380 308.9544 380 320C380 331.0456000000001 371.046 340 360 340H340V360C340 371.0456 331.046 380 320 380C308.954 380 300 371.0456 300 360V340H220V380C220 391.0457 211.046 400 200 400z" : "M160 320C148.9544 320 140 311.0457 140 300V280H60V290C60 295.5228 55.5228 300 50 300C44.4772 300 40 295.5228 40 290V280C28.9544 280 20 271.0456 20 260C20 248.9544 28.9544 240 40 240L40 220H30C24.4772 220 20 215.5228 20 210C20 204.4772 24.4772 200 30 200H70C75.5228 200 80 204.4772 80 210C80 215.5228 75.5228 220 70 220H60V240H140V20C140 8.954 148.9544 0 160 0C171.0456 0 180 8.954 180 20V240H260V220H250C244.478 220 240 215.5228 240 210C240 204.4772 244.478 200 250 200H290C295.522 200 300 204.4772 300 210C300 215.5228 295.522 220 290 220H280L280 240C291.046 240 300 248.9544 300 260C300 271.0456 291.046 280 280 280L280 290C280 295.5228 275.522 300 270 300C264.478 300 260 295.5228 260 290V280H180V300C180 311.0457 171.0456 320 160 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
LowVoltagePole.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
LowVoltagePole.displayName = "Blueprint5.Icon.LowVoltagePole";
exports.default = LowVoltagePole;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7YtNA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Manual", ()=>Manual);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Manual = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "manual",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 378C399.4 386.6 392.6 394.2 383.4000000000001 395.6C303 408.6 241.4 393.2 200 350C158.6 393.2 97 408.6 16.8 395.6C7.4 394 0.6 386.6 0 378H0V77.8C0 76.4 0 75 0.2 73.6C2 63.2 12.4 56 23.2 57.8C100.2 70.2000000000001 151.2 54.6 183.2 8.6C183.6 8.2 183.8 7.8 184.2 7.2C184.2 7.2 184.2 7.2 184.2 7.2C184.6 6.8 185 6.4 185.4 5.8C185.4 5.8 185.6 5.6 185.6 5.6C186 5.1999999999999 186.4 4.8 187 4.4C187 4.4 187 4.4 187 4.4C188.2000000000001 3.4 189.6000000000001 2.6 191.2000000000001 1.8C191.4 1.8 191.4 1.6 191.6 1.6C192.2 1.3999999999999 193.0000000000001 0.9999999999999 193.6 0.8C193.8 0.8 194 0.6 194.4 0.6C195 0.3999999999999 195.8 0.1999999999999 196.4 0.1999999999999C196.6 0.1999999999999 196.8 0.1999999999999 197.2 -1e-13C198.2 0 199 0 200 0H200C200 0 200 0 200 0C200.8 0 201.8 0 202.6 0.2C202.8 0.2 203.2 0.2 203.4 0.4000000000001C204 0.6000000000001 204.6 0.6000000000001 205.4 0.8000000000001C205.6 0.8000000000001 206 1.0000000000001 206.2 1.0000000000001C206.8 1.2000000000001 207.6 1.4000000000001 208.2 1.8000000000001C208.4 1.8000000000001 208.6 2.0000000000001 208.8 2.0000000000001C210.2 2.6000000000001 211.4 3.4000000000001 212.5999999999999 4.2000000000001C212.8 4.2000000000001 212.8 4.4000000000001 213 4.4000000000001C213.3999999999999 4.8000000000001 213.7999999999999 5.0000000000001 214.1999999999999 5.4000000000001C214.4 5.6000000000001 214.5999999999999 5.8000000000001 214.7999999999999 5.8000000000001C215.1999999999999 6.2000000000001 215.3999999999999 6.4000000000001 215.8 6.8000000000001C216 7.0000000000002 216.1999999999999 7.2000000000002 216.1999999999999 7.4000000000001C216.3999999999999 7.8000000000002 216.5999999999999 8.0000000000002 216.9999999999999 8.4000000000002C249.1999999999999 54.4000000000002 300 70.2000000000002 376.9999999999999 57.6000000000002C387.7999999999999 55.8000000000002 398.1999999999999 62.8000000000002 399.9999999999999 73.4000000000002C399.8 74.4 400 75.2000000000001 400 76H400L400 378L400 378zM180 67.4C144.4 93.6 97.6 104 40 98.4V360C105.2 367.4 150.2 352.2 180 313V67.4zM360 98.6C302.4000000000001 104.2 255.6 93.8 220 67.6V313.2C249.8 352.4 294.8 367.4 360 360.2V98.6z" : "M319.8 297.4C319.4000000000001 305.6 313.2 312.8 304.2000000000001 314.8C245.2 327.2 196.8 317.4 160 286C123.2 317.4 74.8 327.2 15.6 314.8C6.6 313 0.6 305.6 0.2 297.4H0V57.4H0C0 55.8 0 54 0.4 52.2C2.8 42 13.4 35.8 24.2 38.0000000000001C76.8 49.0000000000001 116 38.8 144.4 6.6C144.8 6.0000000000001 145.6 5.8000000000001 146 5.4C146.4 5.0000000000001 146.6 4.6 147 4.2C147.8 3.6 148.8 3.4 149.6 2.8C150.6 2.2 151.4 1.8 152.4 1.4C154.6 0.6 157 0 159.4 0C159.6 0 159.6 0 159.8 0C159.8 0 159.8 0 159.8 0S159.8 0 159.8 0C160 0 160 0 160.2 0C162.5999999999999 0 165 0.6 167.2 1.4C168.2 1.8 169 2.4 170 2.8C170.8 3.2 171.8 3.6 172.6 4.2C173 4.6 173.2 5 173.6 5.4C174.2 5.8 174.8 6 175.2 6.6C203.6 38.6 243 49.0000000000001 295.4 38.0000000000001C306.2 35.8000000000001 316.8 42.2 319.2 52.2C320 54 320 55.8 320 57.4H320L319.8 297.4L319.8 297.4zM140 60.2C112 76.8 78.6 83 40 78.8V280.8C82.2 286.4 115 276.8 140 251.6V60.2zM280 78.6C241.4 82.8 208 76.6 180 60V251.6C205 276.8 237.8 286.4 280 280.8V78.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Manual.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Manual.displayName = "Blueprint5.Icon.Manual";
exports.default = Manual;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3iQan":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManuallyEnteredData", ()=>ManuallyEnteredData);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ManuallyEnteredData = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "manually-entered-data",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 160H106.8L146.8 200H20C9 200 0 191 0 180C0 169 9 160 20 160zM355.4 238.8L388.4 271.8C395.6 279 400 289 400 300C400 322 382 340 360 340C349 340 339 335.6 331.8 328.2L298.8 295.2L355.4 238.8zM20 320H266.8L306.8 360H20C9 360 0 351 0 340C0 329 9 320 20 320zM0 100C0 89 9 80 20 80H26.8L66.8 120H20C9 120 0 111 0 100zM20 240H186.8L226.8 280H20C9 280 0 271 0 260C0 249 9 240 20 240zM380 200H373.2L333.2 160H380C391 160 400 169 400 180C400 191 391 200 380 200zM380 120H293.2L253.2 80H380C391 80 400 89 400 100C400 111 391 120 380 120zM80 20L168.2 51.8L112 107.6L80 20zM284.6 281.2L131.6 128.2L188.2 71.6L341.2000000000001 224.6L284.6 281.2z" : "M20 160H95.2L135.2 200H20C9 200 0 191 0 180C0 169 9 160 20 160zM309.8 240.2C316 246.6 320 255.4 320 265C320 284.4 304.4000000000001 300 285 300C275.4 300 266.6 296 260.2 289.8L231.4 261L280.8 211.6L309.8 240.2zM20 240H175.2L215.2 280H20C9 280 0 271 0 260C0 249 9 240 20 240zM20 120C9 120 0 111 0 100C0 90.4 7 82.8 16 80.8L55.2 120H20zM219 248.6L85.2 114.8L134.6 65.4L268.4 199.2L219 248.6zM304 199.2L264.8 160H300C311 160 320 169 320 180C320 189.6 313 197.2 304 199.2zM40 20L117.2 47.8L68 96.6L40 20zM300 120H224.8L184.8 80H300C311 80 320 89 320 100C320 111 311 120 300 120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ManuallyEnteredData.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ManuallyEnteredData.displayName = "Blueprint5.Icon.ManuallyEnteredData";
exports.default = ManuallyEnteredData;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kSM8a":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManyToMany", ()=>ManyToMany);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ManyToMany = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "many-to-many",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 280C351.046 280 360 288.9544 360 300C360 311.0456 351.046 320 340 320C328.954 320 320 311.0456 320 300C320 288.9544 328.954 280 340 280zM340 240C315.752 240 294.864 254.383 285.402 275.0826C281.388 273.729 277.248 272.0028 273.064 269.8016C255.388 260.4976 234.668 241.4436 220.968 200C234.668 158.556 255.388 139.502 273.064 130.198C277.248 127.998 281.388 126.272 285.402 124.918C294.864 145.618 315.752 160 340 160C373.1380000000001 160 400 133.138 400 100C400 66.862 373.1380000000001 40 340 40C312.318 40 289.016 58.746 282.092 84.234C273.436 86.4260000000001 264.028 89.752 254.436 94.802C234.77 105.152 215.484 122.088 200 148.9C184.5162 122.088 165.2294 105.152 145.565 94.802C135.9722 89.752 126.5642 86.4260000000001 117.9072 84.234C110.984 58.746 87.681 40 60 40C26.863 40 0 66.862 0 100C0 133.138 26.863 160 60 160C84.2472 160 105.135 145.618 114.5974 124.918C118.6128 126.272 122.7528 127.998 126.935 130.198C144.6126 139.502 165.3324 158.556 179.033 200C165.3322 241.4436 144.6126 260.4976 126.935 269.8016C122.7528 272.0028 118.6128 273.729 114.5974 275.0826C105.1352 254.383 84.2472 240 60 240C26.863 240 0 266.863 0 300C0 333.137 26.863 360 60 360C87.681 360 110.9838 341.2548 117.9072 315.766C126.5642 313.574 135.9722 310.2472 145.565 305.1984C165.2294 294.8486 184.5162 277.9120000000001 200 251.1006C215.484 277.9120000000001 234.77 294.8486 254.436 305.1984C264.028 310.2472 273.436 313.5738 282.092 315.766C289.016 341.2548 312.318 360 340 360C373.1380000000001 360 400 333.137 400 300C400 266.863 373.1380000000001 240 340 240zM80 300C80 311.0456 71.0456 320 60 320C48.9544 320 40 311.0456 40 300C40 288.9544 48.9544 280 60 280C71.0456 280 80 288.9544 80 300zM320 100C320 88.954 328.954 80 340 80C351.046 80 360 88.954 360 100C360 111.046 351.046 120 340 120C328.954 120 320 111.046 320 100zM60 120C71.0456 120 80 111.046 80 100C80 88.954 71.0456 80 60 80C48.9544 80 40 88.954 40 100C40 111.046 48.9544 120 60 120z" : "M60 260C48.9544 260 40 251.0456 40 240C40 228.9544 48.9544 220 60 220C71.0456 220 80 228.9544 80 240C80 251.0456 71.0456 260 60 260zM120 240C120 239.0612 119.9784 238.1274 119.9358 237.1992C125.0488 235.5792 130.7036 233.022 136.58 228.9856C144.7084 223.4022 152.5844 215.4734 160 204.4992C167.4156 215.4734 175.2916 223.4022 183.42 228.9856C189.2964 233.022 194.9512 235.5792 200.064 237.1992C200.022 238.1276 200 239.0612 200 240C200 273.137 226.862 300 260 300C293.1380000000001 300 320 273.137 320 240C320 206.863 293.1380000000001 180 260 180C242.328 180 226.442 187.6396 215.462 199.796C212.772 199.4506 209.716 198.52 206.068 196.0144C200.232 192.0064 191.0236 182.5694 181.5252 160C191.0236 137.4306 200.232 127.9936 206.068 123.9856C209.716 121.48 212.772 120.5494 215.462 120.204C226.442 132.3604 242.328 140 260 140C293.1380000000001 140 320 113.138 320 80C320 46.862 293.1380000000001 20 260 20C226.862 20 200 46.862 200 80C200 80.938 200.022 81.872 200.064 82.8C194.9512 84.42 189.2964 86.978 183.42 91.014C175.2916 96.598 167.4156 104.526 160 115.5C152.5844 104.526 144.7084 96.598 136.58 91.014C130.7036 86.978 125.0488 84.42 119.9358 82.8C119.9784 81.872 120 80.938 120 80C120 46.862 93.137 20 60 20C26.863 20 0 46.862 0 80C0 113.138 26.863 140 60 140C77.6714 140 93.5584 132.3604 104.5388 120.204C107.2284 120.5494 110.2848 121.48 113.9324 123.9856C119.7676 127.9936 128.9764 137.4306 138.4748 160C128.9764 182.5694 119.7676 192.0064 113.9324 196.0144C110.2848 198.52 107.2284 199.4506 104.5388 199.796C93.5584 187.6396 77.6714 180 60 180C26.863 180 0 206.863 0 240C0 273.137 26.863 300 60 300C93.137 300 120 273.137 120 240zM240 240C240 251.0456 248.954 260 260 260C271.046 260 280 251.0456 280 240C280 228.9544 271.046 220 260 220C248.954 220 240 228.9544 240 240zM60 100C48.9544 100 40 91.046 40 80C40 68.954 48.9544 60 60 60C71.0456 60 80 68.954 80 80C80 91.046 71.0456 100 60 100zM240 80C240 91.046 248.954 100 260 100C271.046 100 280 91.046 280 80C280 68.954 271.046 60 260 60C248.954 60 240 68.954 240 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ManyToMany.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ManyToMany.displayName = "Blueprint5.Icon.ManyToMany";
exports.default = ManyToMany;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c8vmd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManyToOne", ()=>ManyToOne);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ManyToOne = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "many-to-one",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 360C48.9544 360 40 351.0456 40 340C40 328.9544 48.9544 320 60 320C71.0456 320 80 328.9544 80 340C80 351.0456 71.0456 360 60 360zM60 280C85.9136 280 107.9904 296.428 116.3838 319.4374000000001C126.1326 318.666 138.1134 316.838 149.7374 312.508C168.6742 305.454 185.1998 292.492 190.375 266.145C196.8354 233.2560000000001 215.064 212.6364 235.654 200C215.064 187.364 196.8354 166.744 190.375 133.854C185.1998 107.508 168.6742 94.546 149.7374 87.492C138.1134 83.162 126.1326 81.334 116.3838 80.562C107.9904 103.572 85.9136 120 60 120C26.863 120 0 93.138 0 60C0 26.862 26.863 0 60 0C86.3026 0 108.6522 16.924 116.7524 40.478C129.4234 41.318 146.5832 43.632 163.7002 50.008C191.7426 60.454 221.05 82.492 229.624 126.146C234.8 152.492 251.326 165.454 270.262 172.508C275.072 174.3 279.944 175.664 284.692 176.7C293.788 155.136 315.126 140 340 140C373.1380000000001 140 400 166.862 400 200C400 233.137 373.1380000000001 260 340 260C315.126 260 293.788 244.8638 284.692 223.2996C279.944 224.337 275.072 225.7002 270.262 227.4918C251.326 234.546 234.8 247.5078 229.624 273.8548C221.05 317.5078 191.7426 339.546 163.7002 349.9918C146.5832 356.368 129.4236 358.6824000000001 116.7524 359.5222C108.6522 383.07528 86.3026 400 60 400C26.863 400 0 373.137 0 340C0 306.863 26.863 280 60 280zM320 200C320 188.954 328.954 180 340 180C351.046 180 360 188.954 360 200C360 211.0456 351.046 220 340 220C328.954 220 320 211.0456 320 200zM40 60C40 71.046 48.9544 80 60 80C71.0456 80 80 71.046 80 60C80 48.954 71.0456 40 60 40C48.9544 40 40 48.954 40 60z" : "M60 280C48.9544 280 40 271.0456 40 260C40 248.9544 48.9544 240 60 240C71.0456 240 80 248.9544 80 260C80 271.0456 71.0456 280 60 280zM60 320C87.7076 320 111.0286 301.21884 117.927 275.6926C121.2824 274.8254 124.7012 273.7838 128.1216 272.5324C149.6428 264.6588 172.8556 247.7026 179.6116 213.9222C182.8434 197.7636 192.9002 189.7192 205.48 185.0846C214.978 205.6944 235.818 220 260 220C293.1380000000001 220 320 193.137 320 160C320 126.863 293.1380000000001 100 260 100C235.818 100 214.978 114.306 205.48 134.9154C192.9002 130.2808 182.8434 122.2364 179.6116 106.078C172.8556 72.298 149.6428 55.342 128.1216 47.468C124.7012 46.216 121.2822 45.174 117.927 44.308C111.0286 18.782 87.7076 0 60 0C26.863 0 0 26.862 0 60C0 93.138 26.863 120 60 120C84.1818 120 105.0224 105.694 114.5206 85.084C127.0996 89.72 137.1566 97.764 140.3884 113.922C144.6924 135.4424 155.675 150.1344 168.6444 160C155.675 169.8656 144.6924 184.5576 140.3884 206.0776C137.1566 222.2364 127.0998 230.2806 114.5206 234.9152C105.0224 214.3054 84.1818 200 60 200C26.863 200 0 226.863 0 260C0 293.137 26.863 320 60 320zM80 60C80 71.046 71.0456 80 60 80C48.9544 80 40 71.046 40 60C40 48.954 48.9544 40 60 40C71.0456 40 80 48.954 80 60zM240 160C240 148.9544 248.954 140 260 140C271.046 140 280 148.9544 280 160C280 171.0456 271.046 180 260 180C248.954 180 240 171.0456 240 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ManyToOne.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ManyToOne.displayName = "Blueprint5.Icon.ManyToOne";
exports.default = ManyToOne;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8baFV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MapCreate", ()=>MapCreate);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var MapCreate = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "map-create",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 215.6V57.4L280 110.8V215.6C267.8 226.6 260 242.2 260 260C253 260 246.2 261.4 240 263.6V110.6L160 57.2V289.2L200.4 316.2000000000001C200.4 317.4 200 318.8 200 320C200 353.2 226.8 380 260 380C260 386.8 261.4 393.2 263.4 399.4C262.4 399.6 261.2 400 260 400C255.8 400 252.2 398.4 249.2 396.4L249.0000000000001 396.8L140 324L31 396.6L30.8 396.4C27.8 398.4 24.2 400 20 400C9 400 0 391 0 380V100C0 93 3.8 87.2 9.2 83.6L9 83.2L129 3.2L129.2 3.6C132.2 1.6 135.8 0 140 0S147.8 1.6 150.8 3.6L151 3.2L260 76L369 3.4L369.2000000000001 3.8C372.2 1.6 375.8 0 380 0C391 0 400 9 400 20V263.6C393.8 261.4 387 260 380 260C380 242.2 372.2 226.6 360 215.6zM120 57.4L40 110.8V342.6L120 289.2V57.4zM240 320C240 309 249 300 260 300H300V260C300 249 309 240 320 240S340 249 340 260V300H380C391 300 400 309 400 320S391 340 380 340H340V380C340 391 331 400 320 400S300 391 300 380V340H260C249 340 240 331 240 320z" : "M280 183.6V57.2L221.2 96.4C221.2 96.4 221.2 96.4 221.2 96.4L221.2 96.4L221.2 96.4C220.8 96.6 220.4 96.8 220.2 97V195.6C218.6 197 217.2 198.8 215.8 200.4C210.2 200.8 205 202 200 203.6V97.2C200 97.2 199.8 97.2 199.8 97L199.8 97L120 49.4V222.8C120 222.8 120.2 222.8 120.2 223L120.2 223L161.2 247.6C160.4 251.6 160 255.8 160 260C160 279.6 169.4 296.8 184 307.8L110.6 263.8L31.2 316.6C31.2 316.6 31.2 316.6 31.2 316.6L31.2 316.6L31.2 316.6C28 318.8 24.2 320 20 320C9 320 0 311 0 300V80C0 73 3.6 67 9 63.4L9 63.4L98.8 3.4C98.8 3.4 98.8 3.4 98.8 3.4L98.8 3.4L98.8 3.4C102 1.2 105.8 0 110 0C113.8 0 117.2 1.2 120.2 3L120.2 3L209.4 56.4L288.8 3.4C288.8 3.4 288.8 3.4 288.8 3.4L288.8 3.4L288.8 3.4C292 1.2 295.8 0 300 0C311 0 320 9 320 20V203.6C315 201.8 309.6 200.8 304 200.4C297.4 193.2 289.4000000000001 187 280 183.6zM100 50.8L40 90.8V262.8L98.8 223.6C98.8 223.6 98.8 223.6 98.8 223.6L98.8 223.6L98.8 223.6C99.2 223.2 99.6 223 100 222.8V50.8zM220 240H240V220C240 209 249 200 260 200S280 209 280 220V240H300C311 240 320 249 320 260S311 280 300 280H280V300C280 311 271 320 260 320S240 311 240 300V280H220C209 280 200 271 200 260S209 240 220 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
MapCreate.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
MapCreate.displayName = "Blueprint5.Icon.MapCreate";
exports.default = MapCreate;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bvRmB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MapMarker", ()=>MapMarker);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var MapMarker = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "map-marker",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C122.6 400 60 340.4 60 266.6C60 193 200 0 200 0C200 0 340 193 340 266.6C340 340.2 277.2 400 200 400zM200 200C166.8 200 140 226.8 140 260C140 293.2 166.8 320 200 320C233.2 320 260 293.2 260 260C260 226.8 233.2 200 200 200z" : "M159.9998 320C99.1998 320 49.7998 272.2 49.7998 213.4C49.7998 154.4 159.9998 0 159.9998 0C159.9998 0 270.2 154.4 270.2 213.4C270 272.2 220.8 320 159.9998 320zM159.9998 160C132.3998 160 109.9998 182.4 109.9998 210C109.9998 237.6 132.3998 260 159.9998 260C187.5998 260 210 237.6 210 210C210 182.4 187.5998 160 159.9998 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
MapMarker.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
MapMarker.displayName = "Blueprint5.Icon.MapMarker";
exports.default = MapMarker;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7UvNa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Map", ()=>Map);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Map = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "map",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M390.8 316.4L391 316.8L271 396.8L270.8 396.4C267.8 398.4 264.2000000000001 400 260 400S252.2 398.4 249.2 396.4L249.0000000000001 396.8L140 324L31 396.6L30.8 396.4C27.8 398.4 24.2 400 20 400C9 400 0 391 0 380V100C0 93 3.8 87.2 9.2 83.6L9 83.2L129 3.2L129.2 3.6C132.2 1.6 135.8 0 140 0S147.8 1.6 150.8 3.6L151 3.2L260 76L369 3.4L369.2000000000001 3.8C372.2 1.6 375.8 0 380 0C391 0 400 9 400 20V300C400 307 396.2 312.8 390.8 316.4zM120 57.4L40 110.8V342.6L120 289.2V57.4zM240 110.8L160 57.4V289.2L240 342.6V110.8zM360 57.4L280 110.8V342.6L360 289.2V57.4z" : "M311 256.6L311 256.6L221.2 316.6C221.2 316.6 221.2 316.6 221.2 316.6L221.2 316.6L221.2 316.6C218 318.8 214.2 320 210 320C206.2 320 202.8 318.8 199.8 317L199.8 317L110.6 263.6L31.2 316.6C31.2 316.6 31.2 316.6 31.2 316.6L31.2 316.6L31.2 316.6C28 318.8 24.2 320 20 320C9 320 0 311 0 300V80C0 73 3.6 67 9 63.4L9 63.4L98.8 3.4C98.8 3.4 98.8 3.4 98.8 3.4L98.8 3.4L98.8 3.4C102 1.2 105.8 0 110 0C113.8 0 117.2 1.2 120.2 3L120.2 3L209.4 56.4L288.8 3.4C288.8 3.4 288.8 3.4 288.8 3.4L288.8 3.4L288.8 3.4C292 1.2 295.8 0 300 0C311 0 320 9 320 20V240C320 247 316.4 253 311 256.6zM100 50.8L40 90.8V262.8L98.8 223.6C98.8 223.6 98.8 223.6 98.8 223.6L98.8 223.6L98.8 223.6C99.2 223.2 99.6 223 100 222.8V50.8zM200 97.2C200 97.2 199.8 97.2 199.8 97L199.8 97L120 49.4V222.8C120 222.8 120.2 222.8 120.2 223L120.2 223L200 270.6V97.2zM280 57.4L221.2 96.6C221.2 96.6 221.2 96.6 221.2 96.6L221.2 96.6L221.2 96.6C220.8 96.8 220.4 96.9999999999999 220.2 97.2V269.2L280.2 229.2V57.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Map.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Map.displayName = "Blueprint5.Icon.Map";
exports.default = Map;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gGiZ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Maximize", ()=>Maximize);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Maximize = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "maximize",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400H280C269 400 260 391 260 380S269 360 280 360H331.8L226 254.2C222.2 250.6 220 245.6 220 240C220 229 229 220 240 220C245.6 220 250.6 222.2 254.2 225.8L360 331.8V280C360 269 369 260 380 260S400 269 400 280V380C400 391 391 400 380 400zM160 180C154.4 180 149.4 177.8 145.8 174.2L40 68.2V120C40 131 31 140 20 140S0 131 0 120V20C0 9 9 0 20 0H120C131 0 140 9 140 20S131 40 120 40H68.2L174 145.8C177.8 149.4 180 154.4 180 160C180 171 171 180 160 180z" : "M119.8 140.2C114.2 140.2 109.2 138 105.6 134.4L39.8 68.6V100.4C39.8 111.4 30.8 120.4 19.8 120.4S-0.2 111.4 -0.2 100.4V20.4C-0.2 9.4 8.8 0.4 19.8 0.4H99.8C110.8 0.4 119.8 9.4 119.8 20.4S110.8 40.4 99.8 40.4H68.2L134 106C137.6 109.6 139.8 114.6 139.8 120.2000000000001C139.8 131.2 130.8 140.2 119.8 140.2zM299.8 320.2H219.8C208.8 320.2 199.8 311.2 199.8 300.2S208.8 280.2 219.8 280.2H251.6L185.6 214.2C182 210.6 179.8 205.6 179.8 200.2C179.8 189.2 188.8 180.2 199.8 180.2C205.4 180.2 210.4 182.4 214 186L279.8 251.8V220C279.8 209 288.8 200 299.8 200S319.8 209 319.8 220V300C319.8 311.2 310.8 320.2 299.8 320.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Maximize.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Maximize.displayName = "Blueprint5.Icon.Maximize";
exports.default = Maximize;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lYanV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Media", ()=>Media);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Media = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "media",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 220C322 220 340 238 340 260C340 282 322 300 300 300S260 282 260 260C260 238 278 220 300 220zM380 360H20C9 360 0 351 0 340V60C0 49 9 40 20 40H380C391 40 400 49 400 60V340C400 351 391 360 380 360zM360 100L240 200L200 160L120 260L40 100V320H360V100z" : "M239.8 180.2C250.8 180.2 259.8 189.2 259.8 200.2S250.8 220.2 239.8 220.2S219.8 211.2 219.8 200.2S228.8 180.2 239.8 180.2zM299.8 280.2H19.8C8.8 280.2 -0.2 271.2 -0.2 260.2V60.2C-0.2 49.2 8.8 40.2 19.8 40.2H299.8C310.8 40.2 319.8 49.2 319.8 60.2V260.2C319.8 271.2 310.8 280.2 299.8 280.2zM279.8 100.2L179.8 160.2L159.8 120.2L99.8 200.2L39.8 100.2V240.2H279.8V100.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Media.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Media.displayName = "Blueprint5.Icon.Media";
exports.default = Media;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kFU5r":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuClosed", ()=>MenuClosed);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var MenuClosed = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "menu-closed",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 280H380C391 280 400 289 400 300C400 311 391 320 380 320H160C149 320 140 311 140 300C140 289 149 280 160 280zM80 280C74.4 280 69.4 277.8 65.8 274.2L5.8 214.2C2.2 210.6 0 205.6 0 200C0 194.4 2.2 189.4 5.8 185.8L65.8 125.8C69.4 122.2 74.4 120 80 120C91 120 100 129 100 140V260C100 271 91 280 80 280zM380 120H160C149 120 140 111 140 100C140 89 149 80 160 80H380C391 80 400 89 400 100C400 111 391 120 380 120zM380 220H160C149 220 140 211 140 200C140 189 149 180 160 180H380C391 180 400 189 400 200C400 211 391 220 380 220z" : "M299.8 180.2H119.8C108.8 180.2 99.8 171.2 99.8 160.2S108.8 140.2 119.8 140.2H299.8C310.8 140.2 319.8 149.2 319.8 160.2S310.8 180.2 299.8 180.2zM59.8 220.2C54.2 220.2 49.2 218 45.6 214.4L5.6 174.4C2 170.6 -0.2 165.6 -0.2 160.2S2 149.6 5.6 146L45.6 106C49.2 102.4 54.2 100.2000000000001 59.8 100.2000000000001C70.8 100.2000000000001 79.8 109.2 79.8 120.2000000000001V200.2000000000001C79.8 211.2 70.8 220.2 59.8 220.2zM119.8 240.2H299.8C310.8 240.2 319.8 249.2 319.8 260.2S310.8 280.2 299.8 280.2H119.8C108.8 280.2 99.8 271.2 99.8 260.2S108.8 240.2 119.8 240.2zM299.8 80.2H119.8C108.8 80.2 99.8 71.2 99.8 60.2S108.8 40.2 119.8 40.2H299.8C310.8 40.2 319.8 49.2 319.8 60.2S310.8 80.2 299.8 80.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
MenuClosed.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
MenuClosed.displayName = "Blueprint5.Icon.MenuClosed";
exports.default = MenuClosed;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iPu4b":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuOpen", ()=>MenuOpen);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var MenuOpen = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "menu-open",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 220H20C9 220 0 211 0 200C0 189 9 180 20 180H240C251 180 260 189 260 200C260 211 251 220 240 220zM240 120H20C9 120 0 111 0 100C0 89 9 80 20 80H240C251 80 260 89 260 100C260 111 251 120 240 120zM240 320H20C9 320 0 311 0 300C0 289 9 280 20 280H240C251 280 260 289 260 300C260 311 251 320 240 320zM394.2000000000001 214.2L334.2000000000001 274.2000000000001C330.6 277.8 325.6 280 320 280C309 280 300 271 300 260V140C300 129 309 120 320 120C325.6 120 330.6 122.2 334.2000000000001 125.8L394.2000000000001 185.8C397.8 189.4 400 194.4 400 200C400 205.6 397.8 210.6 394.2000000000001 214.2z" : "M199.8 80.2H19.8C8.8 80.2 -0.2 71.2 -0.2 60.2S8.8 40.2 19.8 40.2H199.8C210.8 40.2 219.8 49.2 219.8 60.2S210.8 80.2 199.8 80.2zM199.8 180.2H19.8C8.8 180.2 -0.2 171.2 -0.2 160.2S8.8 140.2 19.8 140.2H199.8C210.8 140.2 219.8 149.2 219.8 160.2S210.8 180.2 199.8 180.2zM199.8 280.2H19.8C8.8 280.2 -0.2 271.2 -0.2 260.2S8.8 240.2 19.8 240.2H199.8C210.8 240.2 219.8 249.2 219.8 260.2S210.8 280.2 199.8 280.2zM314 174.2L274 214.2C270.4 217.8 265.4 220 259.8 220C248.8 220 239.8 211 239.8 200V120C239.8 109 248.8 100 259.8 100C265.4 100 270.4 102.2 274 105.8L314 145.8C317.6 149.4 319.8 154.4 319.8 160S317.6 170.6 314 174.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
MenuOpen.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
MenuOpen.displayName = "Blueprint5.Icon.MenuOpen";
exports.default = MenuOpen;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5R4i":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Menu", ()=>Menu);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Menu = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "menu",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 280H380C391 280 400 289 400 300C400 311 391 320 380 320H20C9 320 0 311 0 300C0 289 9 280 20 280zM380 220H20C9 220 0 211 0 200C0 189 9 180 20 180H380C391 180 400 189 400 200C400 211 391 220 380 220zM380 120H20C9 120 0 111 0 100C0 89 9 80 20 80H380C391 80 400 89 400 100C400 111 391 120 380 120z" : "M20 240H300C311 240 320 249 320 260C320 271 311 280 300 280H20C9 280 0 271 0 260C0 249 9 240 20 240zM300 80H20C9 80 0 71 0 60C0 49 9 40 20 40H300C311 40 320 49 320 60C320 71 311 80 300 80zM300 180H20C9 180 0 171 0 160C0 149 9 140 20 140H300C311 140 320 149 320 160C320 171 311 180 300 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Menu.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Menu.displayName = "Blueprint5.Icon.Menu";
exports.default = Menu;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3CqtS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MergeColumns", ()=>MergeColumns);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var MergeColumns = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "merge-columns",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M134.2 274.2C130.6 277.8 125.6 280 120 280C109 280 100 271 100 260C100 254.4 102.2 249.4 105.8 245.8L131.8 220H40V360H140V316.4C148.4 313.4 156 308.6 162.2 302.4L162.4 302.6L180 284.8V380C180 391 171 400 160 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H160C171 0 180 9 180 20V115.2L162.4 97.6L162.2 97.8C156 91.6 148.4 86.6 140 83.6V40H40V180H131.8L106 154.2C102.2 150.6 100 145.6 100 140C100 129 109 120 120 120C125.6 120 130.6 122.2 134.2 125.8L194.2 185.8C197.8 189.4 200 194.4 200 200C200 205.6 197.8 210.6 194.2 214.2L134.2 274.2zM380 400H240C229 400 220 391 220 380V284.8L237.6 302.4L237.8 302.2C244.0000000000001 308.4 251.6 313.2 260 316.2000000000001V360H360V220H268.2L294 245.8C297.8 249.4 300 254.4 300 260C300 271 291 280 280 280C274.4000000000001 280 269.4000000000001 277.8 265.8 274.2L205.8 214.2C202.2 210.6 200 205.6 200 200C200 194.4 202.2 189.4 205.8 185.8L265.8 125.8C269.4000000000001 122.2 274.4000000000001 120 280 120C291 120 300 129 300 140C300 145.6 297.8 150.6 294.2000000000001 154.2L268.2 180H360V40H260V83.6C251.6 86.6 244 91.4 237.8 97.6L237.6 97.4L220 115.2V20C220 9 229 0 240 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400z" : "M114.2 214.2C110.6 217.8 105.6 220 100 220C89 220 80 211 80 200C80 194.4 82.2 189.4 85.8 185.8L91.8 180H40V280H100V249.8C110.4 248.6 119.8 244 126.8 236.8L126.8 236.8L140 223.6V300C140 311 131 320 120 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H120C131 0 140 9 140 20V96.4L126.8 83.2L126.8 83.2C119.8 76.2 110.4 71.4 100 70.2V40H40V140H91.8L85.8 134.2C82.2 130.6 80 125.6 80 120C80 109 89 100 100 100C105.6 100 110.6 102.2 114.2 105.8L154.2 145.8C157.8 149.4 160 154.4 160 160C160 165.6 157.8 170.6 154.2 174.2L114.2 214.2zM300 320H200C189 320 180 311 180 300V223.6L193.2 236.8L193.2 236.8C200.2 243.8 209.6 248.6 220 249.8V280H280V180H228.2L234 185.8C237.8 189.4 240 194.4 240 200C240 211 231 220 220 220C214.4 220 209.4 217.8 205.8 214.2L165.8 174.2C162.2 170.6 160 165.6 160 160C160 154.4 162.2 149.4 165.8 145.8L205.8 105.8C209.4 102.2 214.4 100 220 100C231 100 240 109 240 120C240 125.6 237.8 130.6 234.2 134.2L228.2 140H280V40H220V70.2C209.6 71.4 200.2 76 193.2 83.2L193.2 83.2L180 96.4V20C180 9 189 0 200 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
MergeColumns.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
MergeColumns.displayName = "Blueprint5.Icon.MergeColumns";
exports.default = MergeColumns;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYSvh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MergeLinks", ()=>MergeLinks);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var MergeLinks = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "merge-links",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 140C178 140 160 122 160 100S178 60 200 60S240 78 240 100S222 140 200 140zM360 240C341.4 240 325.8 227.2 321.4 210H280V320C280 364.2 244.2 400 200 400S120 364.2 120 320V210H78.6C74.2 227.2 58.6 240 40 240C18 240 0 222 0 200S18 160 40 160C58.6 160 74.2 172.8 78.6 190H120V80C120 35.8 155.8 0 200 0S280 35.8 280 80V190H321.4C325.8 172.8 341.4 160 360 160C382 160 400 178 400 200S382 240 360 240zM260 80C260 46.8 233.2 20 200 20S140 46.8 140 80V320C140 353.2 166.8 380 200 380S260 353.2 260 320V80zM200 340C178 340 160 322 160 300S178 260 200 260S240 278 240 300S222 340 200 340z" : "M160 180C149 180 140 171 140 160C140 149 149 140 160 140S180 149 180 160C180 171 171 180 160 180zM160 100C149 100 140 91 140 80C140 69 149 60 160 60S180 69 180 80C180 91 171 100 160 100zM160 260C149 260 140 251 140 240C140 229 149 220 160 220S180 229 180 240C180 251 171 260 160 260zM280 200C261.4 200 245.8 187.2 241.4 170H220V260C220 293.2 193.2 320 160 320S100 293.2 100 260V170H78.6C74.2 187.2 58.6 200 40 200C18 200 0 182 0 160C0 138 18 120 40 120C58.6 120 74.2 132.8 78.6 150H100V60C100 26.8 126.8 0 160 0S220 26.8 220 60V150H241.4C245.8 132.8 261.4 120 280 120C302 120 320 138 320 160C320 182 302 200 280 200zM200 60C200 38 182 20 160 20S120 38 120 60V260C120 282 138 300 160 300S200 282 200 260V60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
MergeLinks.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
MergeLinks.displayName = "Blueprint5.Icon.MergeLinks";
exports.default = MergeLinks;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8e0kw":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Microphone", ()=>Microphone);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Microphone = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "microphone",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C155.8172 400 120 364.1828 120 320V220C120 175.818 155.8172 140 200 140C244.182 140 280 175.818 280 220V320C280 364.1828 244.182 400 200 400zM80 260C91.0456 260 100 251.0456 100 240V220C100 164.772 144.7716 120 200 120C255.228 120 300 164.772 300 220V240C300 251.0456 308.954 260 320 260C331.046 260 340 251.0456 340 240V220C340 149.47 287.846 91.122 220 81.418V40H240C251.046 40 260 31.046 260 20C260 8.954 251.046 0 240 0H160C148.9544 0 140 8.954 140 20C140 31.046 148.9544 40 160 40H180V81.418C112.1542 91.122 60 149.47 60 220V240C60 251.0456 68.9544 260 80 260z" : "M160 320C126.863 320 100 293.137 100 260V180C100 146.863 126.863 120 160 120C193.137 120 220 146.863 220 180V260C220 293.137 193.137 320 160 320zM60 220C71.0456 220 80 211.0456 80 200V160C80 126.863 106.863 100 140 100H180C213.138 100 240 126.863 240 160V200C240 211.0456 248.954 220 260 220C271.046 220 280 211.0456 280 200V160C280 104.772 235.228 60 180 60L180 40H200C211.046 40 220 31.046 220 20C220 8.954 211.046 0 200 0H120C108.9544 0 100 8.954 100 20C100 31.046 108.9544 40 120 40H140L140 60C84.7716 60 40 104.772 40 160V200C40 211.0456 48.9544 220 60 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Microphone.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Microphone.displayName = "Blueprint5.Icon.Microphone";
exports.default = Microphone;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9TXRM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Minimize", ()=>Minimize);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Minimize = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "minimize",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 180H60C49 180 40 171 40 160S49 140 60 140H111.8L6 34.2C2.2 30.6 0 25.6 0 20C0 9 9 0 20 0C25.6 0 30.6 2.2 34.2 5.8L140 111.8V60C140 49 149 40 160 40S180 49 180 60V160C180 171 171 180 160 180zM400 380C400 391 391 400 380 400C374.4 400 369.4 397.8 365.8 394.2L260 288.2V340C260 351 251 360 240 360S220 351 220 340V240C220 229 229 220 240 220H340C351 220 360 229 360 240S351 260 340 260H288.2L394 365.8C397.8 369.4 400 374.4 400 380z" : "M319.8 300.2C319.8 311.2 310.8 320.2 299.8 320.2C294.2000000000001 320.2 289.2000000000001 318 285.6 314.4L219.8000000000001 248.6V280.2C219.8000000000001 291.2 210.8000000000001 300.2 199.8000000000001 300.2S179.8000000000001 291.2 179.8000000000001 280.2V200.2C179.8000000000001 189.2 188.8 180.2 199.8000000000001 180.2H279.8000000000001C290.8000000000001 180.2 299.8000000000001 189.2 299.8000000000001 200.2S290.8000000000001 220.2 279.8000000000001 220.2H248.0000000000001L314 286C317.6 289.6 319.8 294.6 319.8 300.2zM119.8 140.2H39.8C28.8 140.2 19.8 131.2 19.8 120.2S28.8 100.2 39.8 100.2H71.6L5.8 34.4C2.2 30.8 0 25.8 0 20.1999999999999C0 9.1999999999999 9 0.1999999999999 20 0.1999999999999C25.6 0.1999999999999 30.6 2.4 34.2 5.9999999999999L100 71.7999999999999V39.9999999999999C100 28.9999999999999 109 19.9999999999999 120 19.9999999999999S140 28.9999999999999 140 39.9999999999999V120C139.8 131.2 130.8 140.2 119.8 140.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Minimize.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Minimize.displayName = "Blueprint5.Icon.Minimize";
exports.default = Minimize;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bhEiZ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Minus", ()=>Minus);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Minus = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "minus",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 220H80C69 220 60 211 60 200C60 189 69 180 80 180H320C331 180 340 189 340 200C340 211 331 220 320 220z" : "M260 180H60C49 180 40 171 40 160C40 149 49 140 60 140H260C271 140 280 149 280 160C280 171 271 180 260 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Minus.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Minus.displayName = "Blueprint5.Icon.Minus";
exports.default = Minus;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hrzDk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobilePhone", ()=>MobilePhone);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var MobilePhone = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "mobile-phone",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 400H100C89 400 80 391 80 380V20C80 9 89 0 100 0H300C311 0 320 9 320 20V380C320 391 311 400 300 400zM200 20C189 20 180 29 180 40C180 51 189 60 200 60S220 51 220 40C220 29 211 20 200 20zM280 80H120V340H280V80z" : "M240 320H80C69 320 60 311 60 300V20C60 9 69 0 80 0H240C251 0 260 9 260 20V300C260 311 251 320 240 320zM160 20C149 20 140 29 140 40C140 51 149 60 160 60S180 51 180 40C180 29 171 20 160 20zM220 80H100V260H220V80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
MobilePhone.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
MobilePhone.displayName = "Blueprint5.Icon.MobilePhone";
exports.default = MobilePhone;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eUh58":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileVideo", ()=>MobileVideo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var MobileVideo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "mobile-video",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 300C374.4 300 369.4 297.8 365.8 294.2L300 228.2C300 267.2000000000001 300 300 300 300C300 311 291 320 280 320H20C9 320 0 311 0 300V100C0 89 9 80 20 80H280C291 80 300 89 300 100C300 100 300 132.8 300 171.8L365.8 106C369.4 102.2 374.4 100 380 100C391 100 400 109 400 120V280C400 291 391 300 380 300z" : "M300 240C294.4000000000001 240 289.4000000000001 237.8 285.8 234.2L240 188.2V240C240 251 231 260 220 260H20C9 260 0 251 0 240V80C0 69 9 60 20 60H220C231 60 240 69 240 80V131.8L285.8 86C289.4000000000001 82.2 294.4000000000001 80 300 80C311 80 320 89 320 100V220C320 231 311 240 300 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
MobileVideo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
MobileVideo.displayName = "Blueprint5.Icon.MobileVideo";
exports.default = MobileVideo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1T4my":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalFilled", ()=>ModalFilled);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ModalFilled = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "modal-filled",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 300L400 40C400 28.954306 391.0456940000001 20 380 20L20 20C8.954305 20 0 28.954306 0 40L0 300L400 300zM340 380L380 380C391.0456940000001 380 400 371.045695 400 360L400 340L340 340L340 380zM300 340L0 340L0 360C0 371.045695 8.954305 380 20 380L300 380L300 340z" : "M300 300L20 300C9 300 0 291 0 280L0 40C0 29 9 20 20 20L300 20C311 20 320 29 320 40L320 280C320 291 311 300 300 300zM320 220L0 220L0 260L320 260L320 220zM260 260L220 260L220 300L260 300L260 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ModalFilled.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ModalFilled.displayName = "Blueprint5.Icon.ModalFilled";
exports.default = ModalFilled;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2jQ8B":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Modal", ()=>Modal);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Modal = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "modal",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M379.999998 380C391.0456940000001 380 399.999998 371.045695 399.999998 360L399.999998 40C399.999998 28.954306 391.0456940000001 20 379.999998 20L19.999999 20C8.954304 20 -0.0000010000002 28.954306 -0.0000010000002 40L-0.0000010000002 360C-0.0000010000002 371.045695 8.954304 380 19.999999 380L379.999998 380zM360 300L40 300L40 60L360 60L360 300zM300 360L260 360L260 320L300 320L300 360zM360 360L320 360L320 320L360 320L360 360z" : "M300 300C311.045694 300 320 291.045695 320 280L320 40C320 28.954306 311.045694 20 300 20L20 20C8.954305 20 0 28.954306 0 40L0 280C0 291.045695 8.954305 300 20 300L300 300zM280 220L40 220L40 60L280 60L280 220zM220 280L180 280L180 240L220 240L220 280zM280 280L240 280L240 240L280 240L280 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Modal.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Modal.displayName = "Blueprint5.Icon.Modal";
exports.default = Modal;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d7NcF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Model", ()=>Model);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Model = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "model",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M374.914 60H25.0778C11.04106 60 -0.505908 71.554 0.0170954 85.868C1.42532 124.406 5.58966 191.324 17.89646 249.7816C24.398 280.664 33.0818 308.7208 44.5554 328.9116C56.3076 349.5926 69.7564 360 84.9828 360C102.589 360 115.8062 352.8524 126.599 341.598C137.5488 330.1798 145.8238 314.7028 153.1484 298.5784C155.1972 294.068 157.3552 289.0396 159.488 284.07L159.54 283.9486C164.4384 272.5344 169.1844 261.5308 173.6624 253.465C180.4242 241.2862 189.3636 230 203.088 230C223.992 230 236.142 243.3302 246.026 254.899L246.086 254.9692C246.956 255.9874 247.894 257.0838 248.786 258.0934C254.4460000000001 264.5014 260.1 270.4220000000001 267.27 274.7928C274.276 279.064 282.98 282 294.95 282C307.492 282 319.714 274.8362 331.588 261.152C343.318 247.6326 353.8580000000001 228.6908 363.098 207.3918C380.158 168.066 392.264 121.968 399.3760000000001 90.448C402.9220000000001 74.736 390.8760000000001 60 374.914 60z" : "M294.892 40H25.0976C10.98738 40 -0.527098 51.634 0.01863206 65.914C1.160738 95.798 4.45338 146.82 13.99284 191.5926C19.0911 215.5208 25.9752 237.6668 35.2694 253.8274C44.7898 270.3814 56.4576 280 70.5792 280C85.6286 280 97.0114 273.8908 106.128 264.4976000000001C115.2246 255.1248 121.9342 242.6108 127.6782 230.1166C129.2942 226.6016 130.9908 222.6952 132.6428 218.8916L132.6948 218.772C136.5378 209.9236 140.132 201.7034 143.4766 195.7512C145.746 191.7122 148.493 187.5052 151.968 184.3768C155.1306 181.53 158.376 180 162.525 180C176.6608 180 184.938 188.7238 192.6248 197.6128L192.679 197.6754C193.3494 198.4508 194.1012 199.3202 194.822 200.1266C199.263 205.0946 204.046 210.0948 210.244 213.8288C216.4 217.5364 223.954 220 234.038 220C245.546 220 256.17 213.491 265.866 202.449C275.444 191.5418 283.876 176.4818 291.158 159.8994C304.362 129.8268 313.752 94.814 319.35 70.536C322.996 54.722 310.83 40 294.892 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Model.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Model.displayName = "Blueprint5.Icon.Model";
exports.default = Model;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cjrTe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Moon", ()=>Moon);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Moon = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "moon",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 117C348.8 48 279.4000000000001 0 198.8 0C89 0 0 89 0 198.8C0 279.4 48 348.8 117 380C105.6 355 99.4 327.4 99.4 298.2C99.4 188.4 188.4 99.4 298.2 99.4C327.4000000000001 99.4 355 105.6 380 117z" : "M300 92.4C275.4 37.8 220.6 0 157 0C70.2 0 0 70.2 0 157C0 220.6 37.8 275.4 92.4 300C83.4 280.2 78.4 258.4 78.4 235.4C78.4 148.8 148.6 78.4 235.4 78.4C258.4 78.4 280.2 83.4 300 92.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Moon.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Moon.displayName = "Blueprint5.Icon.Moon";
exports.default = Moon;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9kmD5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "More", ()=>More);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var More = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "more",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 190A50 50 0 0 1 120 190A50 50 0 0 1 20 190M300 190A50 50 0 0 1 400 190A50 50 0 0 1 300 190M160 190A50 50 0 0 1 260 190A50 50 0 0 1 160 190" : "M0 159.4A40 40 0 0 1 80 159.4A40 40 0 0 1 0 159.4M240 159.4A40 40 0 0 1 320 159.4A40 40 0 0 1 240 159.4M120 159.4A40 40 0 0 1 200 159.4A40 40 0 0 1 120 159.4",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
More.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
More.displayName = "Blueprint5.Icon.More";
exports.default = More;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9dmT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mountain", ()=>Mountain);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Mountain = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "mountain",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 80L80 80L220 300L240 300L280 260L300 260L400 80zM320 180L290 240L270 240L250 260L230 280L160 170L220 200L240 180L260 200L320 180zM161.0911966 240L55.7920514 80L0 80L140 240L161.0911966 240z" : "M320 60L60 60L180 240L200 240L240 200L260 200L320 60zM270 130L250 180L230 180L190 220L130 130L180 160L200 140L220 160L270 130zM118.7912744 180L36.367032 60L0 60L100 180L118.7912744 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Mountain.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Mountain.displayName = "Blueprint5.Icon.Mountain";
exports.default = Mountain;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4oBfy":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Move", ()=>Move);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Move = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "move",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M394.2000000000001 214.2L334.2000000000001 274.2000000000001C330.6 277.8 325.6 280 320 280C309 280 300 271 300 260C300 254.4 302.2 249.4 305.8 245.8L331.8 220H220V331.8L245.8 306C249.4 302.2 254.4 300 260 300C271 300 280 309 280 320C280 325.6 277.8 330.6 274.2000000000001 334.2L214.2 394.2C210.6 397.8 205.6 400 200 400S189.4 397.8 185.8 394.2L125.8 334.2C122.2 330.6 120 325.6 120 320C120 309 129 300 140 300C145.6 300 150.6 302.2 154.2 305.8L180 331.8V220H68.2L94 245.8C97.8 249.4 100 254.4 100 260C100 271 91 280 80 280C74.4 280 69.4 277.8 65.8 274.2L5.8 214.2C2.2 210.6 0 205.6 0 200C0 194.4 2.2 189.4 5.8 185.8L65.8 125.8C69.4 122.2 74.4 120 80 120C91 120 100 129 100 140C100 145.6 97.8 150.6 94.2 154.2L68.2 180H180V68.2L154.2 94C150.6 97.8 145.6 100 140 100C129 100 120 91 120 80C120 74.4 122.2 69.4 125.8 65.8L185.8 5.8C189.4 2.2 194.4 0 200 0S210.6 2.2 214.2 5.8L274.2000000000001 65.8C277.8 69.4 280 74.4 280 80C280 91 271 100 260 100C254.4 100 249.4 97.8 245.8 94.2000000000001L220 68.2V180H331.8L306 154.2C302.2 150.6 300 145.6 300 140C300 129 309 120 320 120C325.6 120 330.6 122.2 334.2000000000001 125.8L394.2000000000001 185.8C397.8 189.4 400 194.4 400 200C400 205.6 397.8 210.6 394.2000000000001 214.2z" : "M314.2000000000001 174.2L274.2000000000001 214.2C270.6 217.8 265.6 220 260 220C249 220 240 211 240 200C240 194.4 242.2 189.4 245.8 185.8L251.8 180H180V251.8L185.8 246C189.4 242.2 194.4 240 200 240C211 240 220 249 220 260C220 265.6 217.8 270.6 214.2 274.2L174.2 314.2C170.6 317.8 165.6 320 160 320S149.4 317.8 145.8 314.2L105.8 274.2C102.2 270.6 100 265.6 100 260C100 249 109 240 120 240C125.6 240 130.6 242.2 134.2 245.8L140 251.8V180H68.2L74 185.8C77.8 189.4 80 194.4 80 200C80 211 71 220 60 220C54.4 220 49.4 217.8 45.8 214.2L5.8 174.2C2.2 170.6 0 165.6 0 160C0 154.4 2.2 149.4 5.8 145.8L45.8 105.8C49.4 102.2 54.4 100 60 100C71 100 80 109 80 120C80 125.6 77.8 130.6 74.2 134.2L68.2 140H140V68.2L134.2 74C130.6 77.8 125.6 80 120 80C109 80 100 71 100 60C100 54.4 102.2 49.4 105.8 45.8L145.8 5.8C149.4 2.2 154.4 0 160 0S170.6 2.2 174.2 5.8L214.2 45.8C217.8 49.4 220 54.4 220 60C220 71 211 80 200 80C194.4 80 189.4 77.8 185.8 74.2L180 68.2V140H251.8L246 134.2C242.2 130.6 240 125.6 240 120C240 109 249 100 260 100C265.6 100 270.6 102.2 274.2000000000001 105.8L314.2000000000001 145.8C317.8 149.4 320 154.4 320 160C320 165.6 317.8 170.6 314.2000000000001 174.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Move.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Move.displayName = "Blueprint5.Icon.Move";
exports.default = Move;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"agAhm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mugshot", ()=>Mugshot);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Mugshot = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "mugshot",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM360 40H358.6C357.6 44 356.2 48.4 354.2000000000001 53.4C345 74.4 300.6 88.4 271 101.4C241.4 114.4 245.4000000000001 122.4 244.4 133.2000000000001C244.2 134.6 244.2 136.2000000000001 244.2 137.8000000000001C254.4 146.8000000000001 262.6 159.2000000000001 268 173.4C268 173.4 268.2 174.2 268.4 174.4C269.6 177.4000000000001 270.6 180.8000000000001 271.4 184.0000000000001C278.2 185.4000000000001 282.2 192.8000000000001 283.6 199.6000000000001C285.2 202.4000000000001 288.2 209.2000000000001 287.6 217C286.6 227.0000000000001 282.6 231.6 278.2 233.4000000000001C278.2 234.0000000000001 278.2 234.6000000000001 278.2 235.2000000000001C278.2 247.8000000000001 277 266.2000000000001 274.8 278.2000000000001C274.4 281.6 273.6 284.8000000000001 272.6 288.2000000000001C268.2 302.8000000000001 259.2 316 246.8 325.4000000000001C234 335 216.2 340 200.4 340S166.8 335 154.2 325.4C142 316 132.8 302.8 128.4 288.2C127.4 285 126.6 281.6 126.2 278.2C123.8 266.2 122.8 248 122.8 235.4C122.8 234.8 122.8 234.4 122.8 233.8C118 232 114 227.4 113 217.2C112.2 209.4 115.4 202.6 117 199.8C118.6 192.8 122.6 185.4 129.6 184.2C130.4 180.8 131.4 177.6 132.6 174.6C132.6 174.4 132.8 174.2 132.8 174L133 173.8C138.4 159.4 147 146.8000000000001 157.4 137.8C157.4 136.4 157.2 135 157.2 133.6C156.2 122.8 159.2 114.8 129.6 101.8C100 88.8 55.6 74.8 46.4 53.8C44 48.4 42.8 44 41.8 40H40V360H360V40z" : "M300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM280 40H277C276.4 41.8 276.2 43.2 275.4 45C268.6 60.8 235.2 71.2 213 81C190.8 90.8 193.8 96.8 193 105C192.8 106.2 192.8 107.4 192.8 108.6C200.4 115.4 206.6 124.6 210.6 135.2C210.6 135.2 210.8 135.8 210.8 136C211.6 138.4 212.4 140.8 213 143.2C218 144.2 221 149.8 222.2 155C223.4 157 225.8 162.2 225.2 168C224.4 175.4 221.4 179 218.2 180.4C218.2 180.8 218.2 181.2 218.2 181.6C218.2 191.2 217.4 204.8 215.6 213.8C215.2 216.2 214.6 218.8 214 221.2C210.8 232.2 203.8 242.2 194.8 249C185.2 256.2 172 260 160 260C148.2 260 134.8 256.2 125.4 249C116.4 242 109.4 232.2 106.2 221.2C105.4 218.6 105 216.2 104.6 213.6C102.8 204.6 102 191 102 181.4C102 181 102 180.6 102 180.2C98.4 179 95.4 175.4 94.6 167.8C94 162 96.4 157 97.6 154.8C98.8 149.6 101.8 144 107 143C107.6 140.6 108.4 138 109.2 135.8C109.2 135.6 109.4 135.4 109.4 135.4L109.4 135.2000000000001C113.6 124.4 120 115 127.8 108.2C127.8 107.2 127.6 106 127.6 105C126.8 96.8 129.2 91 107 81C84.8 71.2 51.6 60.8 44.6 45C43.8 43.2 43.6 41.8 43 40H40V280H280V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Mugshot.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Mugshot.displayName = "Blueprint5.Icon.Mugshot";
exports.default = Mugshot;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cnFCN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiSelect", ()=>MultiSelect);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var MultiSelect = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "multi-select",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 340H140C129 340 120 331 120 320V300H360V180H380C391 180 400 189 400 200V320C400 331 391 340 380 340zM260 220H20C9 220 0 211 0 200V80C0 69 9 60 20 60H260C271 60 280 69 280 80V200C280 211 271 220 260 220zM240 100H40V180H240V100zM320 280H80C69 280 60 271 60 260V240H300V120H320C331 120 340 129 340 140V260C340 271 331 280 320 280z" : "M240 240.4H80C69 240.4 60 231.4 60 220.4V200.4H220V100.4H240C251 100.4 260 109.4 260 120.4V220.4C260 231.4 251 240.4 240 240.4zM300 300.4H140C129 300.4 120 291.4 120 280.4V260.4H280V160.4H300C311 160.4 320 169.4 320 180.4V280.4C320 291.4 311 300.4 300 300.4zM180 180.4H20C9 180.4 0 171.4 0 160.4V60.4C0 49.4 9 40.4 20 40.4H180C191 40.4 200 49.4 200 60.4V160.4C200 171.4 191 180.4 180 180.4zM160 80.4H40V140.4H160V80.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
MultiSelect.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
MultiSelect.displayName = "Blueprint5.Icon.MultiSelect";
exports.default = MultiSelect;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kZgEx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Music", ()=>Music);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Music = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "music",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400C378.4000000000001 400 376.8 399.4 375.2000000000001 399L375.2000000000001 399.4L135.2000000000001 339.4L135.2000000000001 339C126.6 336.8 120 329.4 120 320V93C108.2 97.4 94.6 100 80 100C35.8 100 0 77.6 0 50C0 22.4 35.8 0 80 0C118.8 0 151 17.2 158.4 40H160V244.4L360 294.4V153C348.2 157.4 334.6 160 320 160C275.8 160 240 137.6 240 110C240 82.4 275.8 60 320 60C358.8 60 391 77.2 398.4000000000001 100H400V380C400 391 391 400 380 400z" : "M300 320C298.6 320 297.4 319.4 296.2 319.2L296.2 319.6L96.2 279.6L96.2 279.2C87 277.4 80 269.6 80 260V77.6C73.8 79 67 80 60 80C26.8 80 0 62 0 40C0 18 26.8 0 60 0S120 18 120 40V193.6L280 225.6V117.6C273.8 119 267 120 260 120C226.8 120 200 102 200 80S226.8 40 260 40S320 58 320 80V300C320 311 311 320 300 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Music.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Music.displayName = "Blueprint5.Icon.Music";
exports.default = Music;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Vxe8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Nest", ()=>Nest);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Nest = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "nest",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 360C51 360 60 351 60 340V240C60 195.8 95.8 160 140 160H311.8L266 205.8C262.2 209.4 260 214.4 260 220C260 231 269 240 280 240C285.6 240 290.6 237.8 294.2000000000001 234.2L374.2000000000001 154.2C377.8 150.6 380 145.6 380 140C380 134.4 377.8 129.4 374.2000000000001 125.8L294.2000000000001 45.8C290.6 42.2 285.6 40 280 40C269 40 260 49 260 60C260 65.6 262.2 70.6 265.8 74.2000000000001L311.8 120H140C73.8 120 20 173.8 20 240V340C20 351 29 360 40 360z" : "M40 280C51 280 60 271 60 260V200C60 166.8 86.8 140 120 140H231.8L206 165.8C202.2 169.4 200 174.4 200 180C200 191 209 200 220 200C225.6 200 230.6 197.8 234.2 194.2L294.2000000000001 134.2C297.8 130.6 300 125.6 300 120C300 114.4 297.8 109.4 294.2000000000001 105.8L234.2 45.8C230.6 42.2 225.6 40 220 40C209 40 200 49 200 60C200 65.6 202.2 70.6 205.8 74.2L231.8 100H120C64.8 100 20 144.8 20 200V260C20 271 29 280 40 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Nest.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Nest.displayName = "Blueprint5.Icon.Nest";
exports.default = Nest;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1uquM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewDrawing", ()=>NewDrawing);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NewDrawing = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "new-drawing",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M374 126C384 126 394 118 394 106C394 100.857142 392.530612 97.183674 389.5918360000001 93.720116L388 92L308 12C304 8 300 6 294 6C282 6 274 16 274 26C274 31.142858 275.469388 34.816326 278.408164 38.279884L280 40L360 120C364 124 368 126 374 126zM36 399.9999999999996L203.553904 340.3590886C201.25415 333.999921 200 327.1440432 200 320C200 286.90861 226.90861 260 260 260C260 226.90861 286.90861 200 320 200C326.101226 200 331.992272 200.914735 337.5432380000001 202.6143026L352 152L352.976 150.8C354 149.2 354 147.6 354 146C354 142.666666 352.6111120000001 137.944444 349.833334 134.148148L348 132L268 52C264 48 260 46 254 46C252.5 46 251 47.125 249.5 47.6875L248 48L108 88L105.7578126 88.84375C101.3046876 90.71875 97.1328126 93.71875 94.9296876 97.84375L94 100L5e-13 364L10 376L140 246C136 240 134 234 134 226C134 204 152 186 174 186C196 186 214 204 214 226C214 248 196 266 174 266C167.1428572 266 161.755102 264.5306122 156.5772594 261.5918368L154 260L24 390L36 399.9999999999996zM320 400C331 400 340 391 340 380L340 380L340 340L380 340C391 340 400 331 400 320C400 309 391 300 380 300L380 300L340 300L340 260C340 251.3571428 334.4438780000001 243.9489796 326.7270400000001 241.1709184L326.531714 241.1017516C325.49772 240.7416768 324.425804 240.4644652 323.324018 240.2781714C322.237842 240.094886 321.129464 240 320 240L320 240C309 240 300 249 300 260L300 300L260 300L260 300C249 300 240 309 240 320L240.135204 322.3239796000001C241.295918 332.239796 249.785714 340 260 340L260 340L300 340L300 380C300 391 309 400 320 400z" : "M298 100C310 100 318 90 318 80C318 74.857142 316.530612 71.183674 313.591836 67.720116L312 66L252 6C248 2 244 0 238 0C228 0 218 8 218 20C218 25.142858 219.469388 28.816326 222.408164 32.279884L224 34L284 94C288 98 292 100 298 100zM26 318L160.6746204 269.0098282C160.2303452 266.0704218 160 263.061674 160 260C160 232.965626 177.959485 210.0577954 202.577482 202.5774814C210.057796 177.959485 232.965626 160 260 160C263.61708 160 267.16029 160.3214974 270.6025620000001 160.937425L278 124L278 120C278 114.857142 276.530612 111.183674 273.591836 107.720116L272 106L212 46C208.571428 42.571428 205.142858 40.612244 200.45481 40.122448L198 40L194 40L94 60L92.005487 60.213992C87.377229 61.193416 83.0178326 65.399176 80.8093278 70.00823L80 72L9e-13 292L6 298L122 182C120 178 118 174 118 170C118 154 130 140 148 140C166 140 178 154 178 170C178 186 164 200 148 200C144.8 200 141.6 198.72 138.4 197.184L136 196L20 312L26 318zM260 319.9999999999997C271 319.9999999999997 280 311 280 300L280 300L280 280L300 280C311 280 320 271 320 260C320 249 311 240 300 240L300 240L280 240L280 220C280 209.940051 272.472536 201.5528718 262.7719640000001 200.1928194L262.7719640000001 200.1928194L262.527982 200.1601552C261.699628 200.0544842 260.855868 200 260 200L261.94 200.12L261.398576 200.048751C261.150742 200.0314208 260.901702 200.0186584 260.651538 200.0105484L260 200C249 200 240 209 240 220L240 220L240 240L220 240C218.363096 240 216.77048 240.1992984 215.245218 240.5748284C215.133862 240.6021722 215.011658 240.6334294 214.889902 240.665814C214.25691 240.8345072 213.645094 241.0302542 213.04662 241.253958C212.754276 241.3631826 212.46239 241.4802472 212.173942 241.6039172C211.81811 241.7564722 211.467298 241.9191832 211.122086 242.091595C210.701084 242.301973 210.29215 242.5245726 209.892036 242.7606956C209.64002 242.9092656 209.383998 243.0680862 209.131864 243.232429C208.780244 243.4617966 208.442016 243.6975704 208.111548 243.9432666C207.818012 244.161364 207.525858 244.3912286 207.24036 244.6288536C207.029426 244.8045202 206.826476 244.9804988 206.627134 245.1604102C206.241268 245.5084072 205.863772 245.8765464 205.501126 246.2588908C205.3312 246.4381832 205.169734 246.614705 205.011416 246.794063C204.729458 247.1134356 204.456314 247.4433096 204.193752 247.7817508C203.93144 248.1198898 203.680022 248.4660934 203.439644 248.8203202C203.25506 249.092405 203.078374 249.3669476 202.908318 249.6459228C202.66896 250.038371 202.440436 250.444006 202.225962 250.8579656C202.113278 251.0754444 202.004184 251.2958254 201.899084 251.5184228C201.703518 251.9326478 201.521946 252.3541164 201.354778 252.7826412C201.21176 253.149145 201.078654 253.5227456 200.956574 253.9011788C200.902164 254.0700216 200.851746 254.2337108 200.803398 254.3982632C200.284868 256.1492828 200 258.0429894 200 260C200 271 209 280 220 280L220 280L240 280L240 300C240 311 249 319.9999999999997 260 319.9999999999997z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NewDrawing.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NewDrawing.displayName = "Blueprint5.Icon.NewDrawing";
exports.default = NewDrawing;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dThdU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewGridItem", ()=>NewGridItem);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NewGridItem = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "new-grid-item",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 400H20C9 400 0 391 0 380V240C0 229 9 220 20 220H160C171 220 180 229 180 240V380C180 391 171 400 160 400zM160 180H20C9 180 0 171 0 160V20C0 9 9 0 20 0H160C171 0 180 9 180 20V160C180 171 171 180 160 180zM280 40H260V60C260 71 251 80 240 80S220 71 220 60V20C220 9 229 0 240 0H280C291 0 300 9 300 20C300 31 291 40 280 40zM380 180H340C329 180 320 171 320 160C320 149 329 140 340 140H360V120C360 109 369 100 380 100S400 109 400 120V160C400 171 391 180 380 180zM380 400H240C229 400 220 391 220 380V240C220 229 229 220 240 220H380C391 220 400 229 400 240V380C400 391 391 400 380 400zM280 180H240C229 180 220 171 220 160V120C220 109 229 100 240 100S260 109 260 120V140H280C291 140 300 149 300 160C300 171 291 180 280 180zM380 80C369 80 360 71 360 60V40H340C329 40 320 31 320 20C320 9 329 0 340 0H380C391 0 400 9 400 20V60C400 71 391 80 380 80z" : "M120 320H20C9 320 0 311 0 300V200C0 189 9 180 20 180H120C131 180 140 189 140 200V300C140 311 131 320 120 320zM220 40C220 51 211 60 200 60S180 51 180 40V20C180 9 189 0 200 0H220C231 0 240 9 240 20C240 31 231 40 220 40zM120 140H20C9 140 0 131 0 120V20C0 9 9 0 20 0H120C131 0 140 9 140 20V120C140 131 131 140 120 140zM300 60C289 60 280 51 280 40C269 40 260 31 260 20C260 9 269 0 280 0H300C311 0 320 9 320 20V40C320 51 311 60 300 60zM220 140H200C189 140 180 131 180 120V100C180 89 189 80 200 80S220 89 220 100C231 100 240 109 240 120C240 131 231 140 220 140zM300 320H200C189 320 180 311 180 300V200C180 189 189 180 200 180H300C311 180 320 189 320 200V300C320 311 311 320 300 320zM300 140H280C269 140 260 131 260 120C260 109 269 100 280 100C280 89 289 80 300 80S320 89 320 100V120C320 131 311 140 300 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NewGridItem.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NewGridItem.displayName = "Blueprint5.Icon.NewGridItem";
exports.default = NewGridItem;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4eGu8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewLayer", ()=>NewLayer);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NewLayer = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "new-layer",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M230.256694 346.746281C223.880356 339.660075 220 330.2831902 220 320C220 297.90861 237.90861 280 260 280L280 280L280 260C280 237.90861 297.90861 220 320 220C342.09139 220 360 237.90861 360 260L360 274.6666666L390 258C396 254 400 248 400 240C400 232 396 226 390 222L210 122C206 120 204 120 200 120C196 120 194 120 190 122L10 222C4 226 0 232 0 240C0 248 4 254 10 258L190 358C194 360 196 360 200 360C204 360 206 360 210 358L230.256694 346.746281zM340 340L380 340C391.0456940000001 340 400 331.045695 400 320C400 308.954305 391.0456940000001 300 380 300L340 300L340 260C340 248.954306 331.0456940000001 240 320 240C308.9543060000001 240 300 248.954306 300 260L300 300L260 300C248.954306 300 240 308.954305 240 320C240 331.045695 248.954306 340 260 340L300 340L300 380C300 391.045695 308.9543060000001 400 320 400C331.0456940000001 400 340 391.045695 340 380L340 340z" : "M279.632234 194.5530092L310 177.2L309.8 177C315.8 173.6 320 167.4 320 160C320 152.6 315.8 146.4 309.8 143L310 142.8L170 62.8L169.8 63C166.8 61.2 163.6 60 160 60C156.4 60 153.2 61.2 150.2 63L150 62.8L10 142.8L10.2 143C4.2 146.4 0 152.6 0 160C0 167.4 4.2 173.6 10.2 177.2L10 177.4L150 257.4L150.2 257C153.2 258.8 156.4 260 160 260C161.7252748 260 163.35868 259.7243914 164.9222298 259.2392158C161.7846776 253.5308462 160 246.97384 160 240C160 217.90861 177.90861 200 200 200C200 177.90861 217.90861 160 240 160C260.243792 160 276.975196 175.038328 279.632234 194.5530092zM280 260C291 260 300 251 300 240C300 229 291 220 280 220L260 220L260 200C260 189 251 180 240 180C229 180 220 189 220 200L220 220L200 220C189 220 180 229 180 240C180 251 189 260 200 260L220 260L220 280C220 291 229 300 240 300C251 300 260 291 260 280L260 260L280 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NewLayer.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NewLayer.displayName = "Blueprint5.Icon.NewLayer";
exports.default = NewLayer;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7o9kp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewLayers", ()=>NewLayers);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NewLayers = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "new-layers",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 340L380 340C391.0456940000001 340 400 331.045695 400 320C400 308.954305 391.0456940000001 300 380 300L340 300L340 260C340 248.954305 331.0456940000001 240 320 240C308.9543060000001 240 300 248.954305 300 260L300 300L260 300C248.954306 300 240 308.954305 240 320C240 331.045695 248.954306 340 260 340L300 340L300 380C300 391.045695 308.9543060000001 400 320 400C331.0456940000001 400 340 391.045695 340 380L340 340zM314.964942 220.3138562L210 162C206 160 204 160 200 160C196 160 194 160 190 162L10 262C4 266 0 272 0 280C0 288 4 294 10 298L190 398C194 400 196 400 200 400C204 400 206 400 210 398L278.4 360L260 360C237.90861 360 220 342.09139 220 320C220 297.90861 237.90861 280 260 280L280 280L280 260C280 239.6139944 295.25036 222.789901 314.964942 220.3138562zM356.36382 243.3132332C358.69828 248.3921346 360 254.0440508 360 260L360 280L380 280C387.052218 280 393.678182 281.8250188 399.431362 285.0285302C399.803178 283.4507648 400 281.774588 400 280C400 272 396 266 390 262L356.36382 243.3132332zM380 220C392 220 400 212 400 200C400 192 396 186 390 182L210 82C206 80 204 80 200 80C196 80 194 80 190 82L10 182C4 186 0 192 0 200C0 212 8 220 20 220C24 220 26 220 30 218L200 122L370 218C374 220 376 220 380 220zM380 140C392 140 400 132 400 120C400 112 396 106 390 102L210 2C206 0 204 0 200 0C196 0 194 0 190 2L10 102C4 106 0 112 0 120C0 132 8 140 20 140C24 140 26 140 30 136L200 42L370 138C374 140 376 140 380 140z" : "M260 260L300 260C311.045694 260 320 251.045695 320 240C320 228.954305 311.045694 220 300 220L260 220L260 180C260 168.954305 251.045694 160 240 160C228.954306 160 220 168.954305 220 180L220 220L180 220C168.954305 220 160 228.954305 160 240C160 251.045695 168.954305 260 180 260L220 260L220 300C220 311.045695 228.954306 320 240 320C251.045694 320 260 311.045695 260 300L260 260zM200 299.6660944L200 280L180 280C157.90861 280 140 262.09139 140 240C140 217.90861 157.90861 200 180 200L200 200L200 180C200 174.4268224 201.139782 169.1198548 203.198962 164.2994806L169 147.2C166.2 145.8 163.2 145 160 145C156.8 145 153.8 145.8 151 147.2L11 217.2C4.6 220.4 0 227.2 0 235C0 243.2 5 250.4 12.4 253.4L152.2 313.4C154.6 314.4 157.2 315 160 315C162.8 315 165.4 314.4 168 313.4L200 299.6660944zM218.201234 146.4561882C224.472028 142.3727058 231.958926 140 240 140C261.1712560000001 140 278.5009120000001 156.4478474 279.907786 177.2623608L291 182.8C293.8 184.2 296.8 185 300 185C311 185 320 176 320 165C320 157.2 315.4 150.4 309 147.2L169 77.2C166.2 75.8 163.2 75 160 75C156.8 75 153.8 75.8 151 77.2L11 147.2C4.6 150.4 0 157.2 0 165C0 176 9 185 20 185C23.2 185 26.2 184.2 29 182.8L160 117.4L218.201234 146.4561882zM300 115C311 115 320 106 320 95C320 87.2 315.4 80.4 309 77.2L169 7.2C166.2 5.8 163.2 5 160 5C156.8 5 153.8 5.8 151 7.2L11 77.2C4.6 80.4 0 87.2 0 95C0 106 9 115 20 115C23.2 115 26.2 114.2 29 113L160 47.4L291 112.8C293.8 114.2 296.8 115 300 115z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NewLayers.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NewLayers.displayName = "Blueprint5.Icon.NewLayers";
exports.default = NewLayers;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hhqxr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewLink", ()=>NewLink);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NewLink = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "new-link",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M290 160C265.8 160 245.6 142.8 241 120H99C94.4 142.8 74.2 160 50 160C22.4 160 0 137.6 0 110C0 82.4 22.4 60 50 60C74.2 60 94.4 77.2 99 100H241C245.6 77.2 265.8 60 290 60C317.6 60 340 82.4 340 110C340 137.6 317.6 160 290 160zM380 300H340V340C340 351 331 360 320 360S300 351 300 340V300H260C249 300 240 291 240 280S249 260 260 260H300V220C300 209 309 200 320 200S340 209 340 220V260H380C391 260 400 269 400 280S391 300 380 300z" : "M300 260H280V280C280 291 271 300 260 300S240 291 240 280V260H220C209 260 200 251 200 240C200 229 209 220 220 220H240V200C240 189 249 180 260 180S280 189 280 200V220H300C311 220 320 229 320 240C320 251 311 260 300 260zM230 140C205.8 140 185.6 122.8 181 100H99C94.4 122.8 74.2 140 50 140C22.4 140 0 117.6 0 90C0 62.4 22.4 40 50 40C74.2 40 94.4 57.2 99 80H181C185.6 57.2 205.8 40 230 40C257.6 40 280 62.4 280 90C280 117.6 257.6 140 230 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NewLink.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NewLink.displayName = "Blueprint5.Icon.NewLink";
exports.default = NewLink;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7kQvS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewObject", ()=>NewObject);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NewObject = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "new-object",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 320C240 308 248 300 260 300H300V260C300 248 308 240 320 240C330 240 340 248 340 260V300H380C390 300 400 308 400 320S390 340 380 340H340V380C340 392 330 400 320 400C308 400 300 392 300 380V340H260C248 340 240 330 240 320L240 320zM380 260C380 226 354 200 320 200S260 226 260 260C226 260 200 286 200 320S226 380 260 380C260 384 260 388 262 390C242 396 222 400 200 400C90 400 0 310 0 200S90 0 200 0S400 90 400 200C400 222 396 242 390 260H380L380 260z" : "M160 240C160 228 168 220 180 220H220V180C220 168 228 160 240 160S260 168 260 180V220H300C312 220 320 228 320 240S312 260 300 260H260V300C260 312 252 320 240 320S220 312 220 300V260H180C168 260 160 250 160 240L160 240zM290 190V180C290 152 268 130 240 130S190 152 190 180V190H180C152 190 130 212 130 240S152 290 180 290H190V300C190 306 192 312 192 316C182 318 172 320 160 320C72 320 0 248 0 160S72 0 160 0S320 72 320 160C320 172 318 186 316 198C308 192 300 190 290 190L290 190z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NewObject.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NewObject.displayName = "Blueprint5.Icon.NewObject";
exports.default = NewObject;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gjBJV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewPerson", ()=>NewPerson);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NewPerson = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "new-person",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M228.2 81.6C199 94.6 203 102.6 202 113.4C201.8 114.8 201.8 116.4 201.8 118C211.8 127 220 139.4 225.4 153.6C225.4 153.6 225.6 154.4 225.8 154.6C227 157.6 228 161 228.8 164.2C235.4 165.6 239.4 173 240.8 179.8C242.4 182.6 245.4 189.4 244.8 197.2C243.8 207.2 240 211.8 235.4 213.6C235.4 214.2 235.4 214.8 235.4 215.4C235.4 228 234.2 246.4 232 258.4C231.6 261.8 230.8 265 229.8 268.4C225.4 283 216.4 296.4 204.4 305.6C191.6 315 174 320 158.4 320C142.8 320 125.2 315 112.8 305.4C100.6 296 91.6 282.8 87.4 268.2C86.4 265 85.8 261.6 85.2 258.2C82.8 246.2 81.6 228 81.6 215.4C81.6 214.8 81.6 214.4 81.6 213.8C77 212 73 207.4 72 197.2C71.2 189.4 74.4 182.6 76 179.8C77.6 172.8 81.6 165.4 88.4 164.2C89.2 160.8 90.2 157.6 91.4 154.6C91.4 154.4 91.6 154.2 91.6 154L91.8 153.8C97.2 139.4 105.6 126.8 116 117.8C116 116.4 115.8 115 115.8 113.6C114.8 102.8 117.8 94.8 88.6 81.8C59.4 68.8 15.4 54.8 6.4 33.8C-2.8 12.4 0.8 0 0.8 0H315.8C315.8 0 319.4 12.4 310.4 33.4C301.4 54.6 257.4 68.4 228.2 81.6zM377.4000000000001 340H337.4000000000001V380C337.4000000000001 391 328.4000000000001 400 317.4000000000001 400C306.4 400 297.4000000000001 391 297.4000000000001 380V340H257.4000000000001C246.4 340 237.4000000000001 331 237.4000000000001 320C237.4000000000001 309 246.4 300 257.4000000000001 300H297.4000000000001V260C297.4000000000001 249 306.4 240 317.4000000000001 240C328.4000000000001 240 337.4000000000001 249 337.4000000000001 260V300H377.4000000000001C388.4000000000001 300 397.4000000000001 309 397.4000000000001 320C397.4000000000001 331 388.4000000000001 340 377.4000000000001 340z" : "M182.4 66.2C159 76.8 162.2 83.2 161.4 92C161.2 93.2000000000001 161.2 94.4 161.2 95.8C169.2 103.2 175.8 113.2 180 124.6C180 124.6 180.2 125.2 180.2 125.4C181.2 128.2 182 130.8 182.6 133.4C188 134.6 191.2 140.6 192.4 146C193.6 148.2 196.2 153.8 195.6 160C194.8 168.2 191.6 172 188 173.6C188 174 188 174.6 188 175C188 185.2 187 200 185.2 209.8C184.8 212.4 184.2 215.2 183.4 217.8C180 229.8 172.8 240.6 163.2 248.2C153.2 256 139.2 260 126.6 260C114.2 260 100 256 90.2 248.2C80.4 240.6 73.2 229.8 69.8 217.8C69 215.2 68.4 212.6 68 209.8C66.2 200 65.4 185.2 65.4 175C65.4 174.6 65.4 174.2 65.4 173.8C61.6 172.2 58.4 168.4 57.6 160.2C57 154 59.6 148.4 60.8 146.2C62 140.6 65.2 134.4 70.8 133.4C71.4 130.6 72.2 128 73 125.4C73 125.2 73.2 125 73.2 125L73.2 124.8C77.6 113 84.2 102.8 92.4 95.6C92.4 94.4 92.2 93.2000000000001 92.2 92.2C91.4 83.4 93.8 77 70.4 66.4C47 55.8 11.8 44.4 4.6 27.4C-2.4 10 0.6 0 0.6 0H252.6C252.6 0 255.6 10 248.2 27.2C241 44.2 205.8 55.6 182.4 66.2zM297.8 280H277.8V300C277.8 311 268.8 320 257.8 320S237.8 311 237.8 300V280H217.8C206.8 280 197.8 271 197.8 260S206.8 240 217.8 240H237.8V220C237.8 209 246.8 200 257.8 200S277.8 209 277.8 220V240H297.8C308.8 240 317.8 249 317.8 260S308.8 280 297.8 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NewPerson.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NewPerson.displayName = "Blueprint5.Icon.NewPerson";
exports.default = NewPerson;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9fO8X":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewPrescription", ()=>NewPrescription);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NewPrescription = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "new-prescription",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M239 195.4C242.2 199 243.4 199.8 248.2 199.8H277.8C282.8 199.8 287.2000000000001 198.2 289.6 193.2C291.6 189.2 291.4 185 288.6 180L234.4 108.4L297.6 20C300.2000000000001 15.8 300.8 10.8 298.2 6.2C295.8 2 291.4 0 286.8 0H254C247.8 0 242.8 3.4 240 8.8L202 62.2L163.4 8.6C160.4 3.2 155 0 148.8 0H119.6C114.6 0 110.2 1.6 107.8 6.6C105.8 10.6 106 14.8 108.8 19.8L170.6 106.8L85.2 220H60V133.6C60 125.4 54 119.8 46 119.8H14C5.8 119.8 0 125.4 0 133.6V386.2C0 394.4 6 400 14 400H102.4C116.6 400 129.6 398 141.2 394C153 390 163.4 384.2 172 376.6C180.8 369 187.6 359.8 192.4 348.8C197.4 338 199.8 326.2 199.8 313.4C199.8 293.2 194.2 275.8 183 261.4C174.4 250.6 156 235.6 143 229.6L204.8 150.8L239 195.4zM94.2 279.2C108.4 279.2 123.2 282.4 130.4 288.4C137 294 140.4 302.2 140.4 313.4S137 332.8 130.4 338.4C123.4 344.4 108.4 347.6 94.2 347.6H60.2V279.2H94.2zM380 340C391 340 400 331 400 320S391 300 380 300H340V260C340 249 331 240 320 240C309 240 300 249 300 260V300H260C249 300 240 309 240 320S249 340 260 340H300V380C300 391 309 400 320 400C331 400 340 391 340 380V340H380z" : "M196.4 86.8L246 144.2C248.4 148.2 248.6 151.6 246.8 154.8C244.6 158.6 240.8 160 236.4 160H210.6C205.2000000000001 160 200.8 157.4 198 153.2L168.8 122L139 160C138.8 160.4 138.2 161.2 137.4 162L116.4 189C127.8 193.8 137.2 200.4 144.8 209.2C154.6 220.6 159.6 234.6 159.6 250.8C159.6 261 157.6 270.6 153.2 279.2C149 287.8 143 295.2 135.4 301.4C127.8 307.4 118.8 312 108.4 315.2C98.2 318.4 86.8 320 74.4 320H12.2C5.2 320 0 315.4 0 308.8V111C0 104.4 5.2 100 12.2 100H28.2C35.4 100 40.4 104.6 40.4 111.2V180.2H66L140.6 85.4L86.4 15.8C84 11.8 83.8 8.4 85.6 5.2C87.8 1.4 91.6 0 96 0H121.4C126.8 0 131.6 2.4 134.2 6.8L168 49.8L201.2 7C203.6 2.8 208 0 213.6 0H242.2C246.2 0 250 1.6 252.2 5C254.6 8.6 254 12.6 251.8 16L196.4 86.8zM83.6 220H39.8V279.6H83.6C96 279.6 105.2 277 111.2 272.2C117 267.8 120 259.8 120 250.6C120 241.6 117 231.8 111.2 227.2C105 222.6 96 220 83.6 220zM300 280H280V300C280 311 271 320 260 320S240 311 240 300V280H220C209 280 200 271 200 260C200 249 209 240 220 240H240V220C240 209 249 200 260 200S280 209 280 220V240H300C311 240 320 249 320 260C320 271 311 280 300 280zM199.8 259.8C199.8 259.4 200 259 200 258.6V260V261C200 260.6 199.8 260.2 199.8 259.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NewPrescription.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NewPrescription.displayName = "Blueprint5.Icon.NewPrescription";
exports.default = NewPrescription;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9v66y":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewShield", ()=>NewShield);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NewShield = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "new-shield",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 320C240 308 248 300 260 300H300V260C300 248 308 240 320 240C330 240 340 248 340 260V300H380C390 300 400 308 400 320C400 332 390 340 380 340H340V380C340 392 330 400 320 400C308 400 300 392 300 380V340H260C248 340 240 330 240 320zM315.9120000000001 200.1278C294.9020000000001 142.752 256.444 93.86 200 52.646V346.9694C200 370 200 360 200 400C120 342.8572000000001 60 314.2858 20 314.2858C20 180.952 80 76.19 200 0C292.678 58.844 349.568 134.73 370.67 227.6586C359.3760000000001 210.1856 339.448 200 320 200C318.642 200 317.278 200.0422 315.9120000000001 200.1278z" : "M220 240H240V220C240 209 249 200 260 200C271 200 280 209 280 220V240H300C311 240 320 249 320 260C320 271 311 280 300 280H280V300C280 311 271 320 260 320C249 320 240 311 240 300V280H220C209 280 200 271 200 260C200 249 209 240 220 240zM160 300C97.7778 257.1428 51.1112 235.7142 20 235.7142C20 135.7142 66.6666 57.142 160 0C235.938 46.492 280.9840000000001 107.172 295.138 182.0352C284.002 171.4394 269.8160000000001 164.0194 254.032 161.2268C238.806 113.352 207.638 73.028 160 39.484V240C160 260.12 160 279.6796 160 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NewShield.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NewShield.displayName = "Blueprint5.Icon.NewShield";
exports.default = NewShield;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43QFo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewTextBox", ()=>NewTextBox);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NewTextBox = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "new-text-box",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 340H340V380C340 391 331 400 320 400S300 391 300 380V340H260C249 340 240 331 240 320S249 300 260 300H300V260C300 249 309 240 320 240S340 249 340 260V300H380C391 300 400 309 400 320S391 340 380 340zM100 250V230C100 224.4 104.4 220 110 220S120 224.4 120 230V240H160V100H150C144.4 100 140 95.6 140 90C140 84.4 144.4 80 150 80H190C195.6 80 200 84.4 200 90C200 95.6 195.6 100 190 100H180V240H220V230C220 224.4 224.4 220 230 220S240 224.4 240 230V250C240 255.6 235.6 260 230 260H110C104.4 260 100 255.6 100 250zM320 220C309 220 300 211 300 200V40H40V300H200C211 300 220 309 220 320C220 331 211 340 200 340H20C9 340 0 331 0 320V20C0 9 9 0 20 0H320C331 0 340 9 340 20V200C340 211 331 220 320 220z" : "M100 190C100 184.4 104.4 180 110 180H140V110C140 104.4 144.4 100 150 100S160 104.4 160 110V180H190C195.6 180 200 184.4 200 190C200 195.6 195.6 200 190 200H110C104.4 200 100 195.6 100 190zM300 280H280V300C280 311 271 320 260 320S240 311 240 300V280H220C209 280 200 271 200 260C200 249 209 240 220 240H240V220C240 209 249 200 260 200S280 209 280 220V240H300C311 240 320 249 320 260C320 271 311 280 300 280zM260 180C249 180 240 171 240 160V60H60V240H160C171 240 180 249 180 260C180 271 171 280 160 280H40C29 280 20 271 20 260V40C20 29 29 20 40 20H260C271 20 280 29 280 40V160C280 171 271 180 260 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NewTextBox.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NewTextBox.displayName = "Blueprint5.Icon.NewTextBox";
exports.default = NewTextBox;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c0U1i":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ninja", ()=>Ninja);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Ninja = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "ninja",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 280C400 280 340.4 231.4 277.6 236.2C270.4 293.8 241 400 120 400C120 400 168.2 340.2 163.2 277.6C105.4 270.2 0 240.6 0 120C0 120 59.6 168.6 122.2 163.8C129.4 106.2 158.8 0 280 0C280 0 231.6 59.8000000000001 236.8 122.6C294.6 129.8 400 159.6 400 280zM200 160C178 160 160 178 160 200C160 222 178 240 200 240S240 222 240 200C240 178 222 160 200 160z" : "M320 220C320 220 269.6 177.8 220.8 180.2C220.6 222.2 207.8 315.4 100 320C100 320 142.2 269.2 139.2 220.2C97.2 219.8 4.6 207 0 100C0 100 51.2 142.4 100.4 139C100.8 96.8 113.8 4.6 220 0C220 0 178.2 50.8 181.2 99.8C223.4 100.2 315.4 113.4 320 220zM160 130C143.4 130 130 143.4 130 160S143.4 190 160 190S190 176.6 190 160S176.6 130 160 130z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Ninja.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Ninja.displayName = "Blueprint5.Icon.Ninja";
exports.default = Ninja;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"22MW2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotEqualTo", ()=>NotEqualTo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NotEqualTo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "not-equal-to",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M189.734666 260L200.388386 323.9223228C202.554626 334.7535178 213.091128 341.7778526 223.922322 339.6116136C234.753518 337.4453746 241.777852 326.9088724 239.6116140000001 316.0776772L230.265334 260L320 260C331.0456940000001 260 340 251.045695 340 240C340 228.954305 331.0456940000001 220 320 220L223.598668 220L216.932 180L320 180C331.0456940000001 180 340 171.045694 340 160C340 148.954306 331.0456940000001 140 320 140L210.265334 140L199.6116136 76.0776780000001C197.4453746 65.246482 186.9088724 58.222148 176.0776772 60.388386C165.2464822 62.554626 158.2221474 73.091128 160.3883864 83.922322L169.734666 140L80 140C68.954305 140 60 148.954306 60 160C60 171.045694 68.954305 180 80 180L176.4013328 180L183.0679994 220L80 220C68.954305 220 60 228.954305 60 240C60 251.045695 68.954305 260 80 260L189.734666 260z" : "M151.603922 220L160.3883864 263.9223228C162.5546254 274.7535178 173.0911276 281.7778526 183.9223228 279.6116136C194.7535178 277.4453746 201.777852 266.9088724 199.6116136 256.0776772L192.396078 220L260 220C271.045694 220 280 211.045695 280 200C280 188.954305 271.045694 180 260 180L184.396078 180L176.396078 140L260 140C271.045694 140 280 131.045695 280 120C280 108.954306 271.045694 100 260 100L168.396078 100L159.6116136 56.077678C157.4453746 45.246482 146.9088724 38.222148 136.0776772 40.388386C125.2464822 42.554626 118.2221474 53.091128 120.3883864 63.922322L127.603922 100L60 100C48.954305 100 40 108.954306 40 120C40 131.045695 48.954305 140 60 140L135.603922 140L143.603922 180L60 180C48.954305 180 40 188.954305 40 200C40 211.045695 48.954305 220 60 220L151.603922 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NotEqualTo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NotEqualTo.displayName = "Blueprint5.Icon.NotEqualTo";
exports.default = NotEqualTo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gsxR7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationsSnooze", ()=>NotificationsSnooze);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NotificationsSnooze = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "notifications-snooze",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 40C200 18 182 0 160 0C138 0 120 18 120 40L120 40zM160 400C169.5137614 400 178.2794928 396.63386398 185.1650104 391.03377532C170.164773 382.4448333000001 161.7874748 368.7684848 160 350C157.3333334 322 168 302.6666666 192 292C170.6666666 268 160 250.6666666 160 240L160 216L160 216C160 185.072054 185.072054 160 216 160L280 160L280 120C280 109.785714 287.760204 101.295918 297.67602 100.135204L300 100C311 100 320 91 320 80C320 69 311 60 300 60L300 60L20 60C9 60 0 69 0 80C0 91 9 100 20 100C31 100 40 109 40 120L40 120L40 240C40 292.2 73.4 336.2 120 352.6L120 352.6L120 360C120 382 138 400 160 400zM360 215L360 222.8947368C360 231.179008 353.284272 237.8947368 345 237.8947368L288.75 237.8947368L288.75 237.8947368L356.6695680000001 321.993852C358.824558 324.6621946 360 327.9884778 360 331.4183510000001L360 345C360 353.2842712 353.284272 360 345 360L255 360C246.715728 360 240 353.2842712 240 345L240 341.3157894C240 333.0315182 246.715728 326.3157894 255 326.3157894L311.25 326.3157894L311.25 326.3157894L244.426808 243.3883944C241.562112 239.8333146 240 235.4051024 240 230.8394614L240 215C240 206.7157288 246.715728 200 255 200L345 200C353.284272 200 360 206.7157288 360 215z" : "M180 40C180 18 162 0 140 0C118 0 100 18 100 40L100 40zM140 320C148.0882352 320 155.0951558 315.13408304 158.2379656 308.18504478L158 308L158 308C144 296 140 280.8115966000001 140 270C140 254 145.3333334 241.3333334 156 232C145.3333334 220 140.1064538 207.5555556 140.3193612 194.6666666C140.3551372 192.5008794 140.3849016 190.1092056 140.4086542 187.491645C140.6877054 156.7633412 165.676778 132 196.4063488 132L240 132.02L240 120C240 109.785714 247.760204 101.295918 257.67602 100.135204L260 100C271 100 280 91 280 80C280 69 271 60 260 60L260 60L20 60C9 60 0 69 0 80C0 91 9 100 20 100C31 100 40 109 40 120L40 120L40 200C40 248.6 74.6 289 120.4 298L120.4 298L120 300C120 311 129 320 140 320zM280 185.9649122C280 192.9411406 274.34465 198.5964912 267.368422 198.5964912L232.5 198.5964912L232.5 198.5964912L276.6695680000001 253.2879696C278.824558 255.9563122 280 259.2825954 280 262.7124686L280 268.7058824C280 274.9434512000001 274.9434520000001 280 268.705882 280L211.2280702 280C205.0269782 280 200 274.9730218 200 268.7719298C200 262.5708378 205.0269782 257.5438596 211.2280702 257.5438596L247.5 257.5438596L247.5 257.5438596L204.426809 204.0901488C201.5621128 200.535069 200 196.1068568 200 191.5412158L200 185.9649122C200 178.9886838 205.6553506 173.3333334 212.631579 173.3333334L267.368422 173.3333334C274.34465 173.3333334 280 178.9886838 280 185.9649122z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NotificationsSnooze.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NotificationsSnooze.displayName = "Blueprint5.Icon.NotificationsSnooze";
exports.default = NotificationsSnooze;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"coeDk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationsUpdated", ()=>NotificationsUpdated);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NotificationsUpdated = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "notifications-updated",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 0C222 0 240 18 240 40L160 40C160 18 178 0 200 0zM240 356.6840968C233.599948 358.9820866 226.776472 360.2 219.8 360.2C186.6212272 360.2 160 333.2064478 160 300.2C160 284.0347284 166.3727932 269.0586642 177.5157288 257.9157288L236.915728 198.115728C248.040604 186.990854 263.218882 180.6 279.2000000000001 180.6C294.48142 180.6 309.028764 186.443486 320 196.681858L320 120C320 109 329 100 340 100C351 100 360 91 360 80C360 69 351 60 340 60L60 60C49 60 40 69 40 80C40 91 49 100 60 100C71 100 80 109 80 120L80 240C80 292.2 113.4 336.2 160 352.6L160 360C160 382 178 400 200 400C222 400 240 382 240 360L240 356.6840968zM265.2 226.4L205.8 286.2C202.2 289.8 200 294.6 200 300.2C200 311.2 208.8 320.2 219.8 320.2C225.2 320.2 230.2 318 233.8 314.4L279.4000000000001 268.8L364.8 354.2C368.4000000000001 357.8 373.4000000000001 360 378.8 360C389.8 360 398.8 351 398.8 340C398.8 334.4 396.6 329.4 392.8 326L293.2 226.4C289.6 222.8 284.6 220.6 279.2000000000001 220.6C273.8 220.6 268.8 222.8 265.2 226.4z" : "M160 0C182 0 200 18 200 40L120 40C120 18 138 0 160 0zM227.976586 273.345128L219.726904 265.095446C208.889204 274.7275318 194.788337 280.2 180 280.2C147.0015896 280.2 120 253.3846282 120 220.4C120 204.4188818 126.390854 189.2406036 137.5157288 178.1157288L177.5607218 138.2707836C188.6815092 127.1736428 203.840416 120.8 219.8 120.8C234.804476 120.8 249.10124 126.433603 260 136.3295492L260 120C260 109 269 100 280 100C291 100 300 91 300 80C300 69 291 60 280 60L40 60C29 60 20 69 20 80C20 91 29 100 40 100C51 100 60 109 60 120L60 200C60 248.6 94.6 289 140.4 298C140.4 298.8 140 299.2 140 300C140 311 149 320 160 320C171 320 180 311 180 300C180 299.2 179.6 298.8 179.6 298C198.0541022 294.373648 214.689874 285.6494756 227.976586 273.345128zM205.8 166.6L165.8 206.4C162.2 210 160 215 160 220.4C160 231.2 169 240.2 180 240.2C185.4 240.2 190.4 238 194 234.4L219.8 208.6L285.4 274.2C289 277.8 293.8 280 299.4000000000001 280C310.4 280 319.4000000000001 271.2 319.4000000000001 260.2C319.4000000000001 254.6 317.2 249.8 313.4 246.2L233.8 166.6C230.2 163 225.2 160.8 219.8 160.8C214.4 160.8 209.4 163 205.8 166.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NotificationsUpdated.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NotificationsUpdated.displayName = "Blueprint5.Icon.NotificationsUpdated";
exports.default = NotificationsUpdated;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"waksK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notifications", ()=>Notifications);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Notifications = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "notifications",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 0C222 0 240 18 240 40H160C160 18 178 0 200 0zM340 100C329 100 320 109 320 120V240C320 292.2 286.6 336.2 240 352.6V360C240 382 222 400 200 400S160 382 160 360V352.6C113.4 336.2 80 292.2 80 240V120C80 109 71 100 60 100S40 91 40 80C40 69 49 60 60 60H340C351 60 360 69 360 80C360 91 351 100 340 100z" : "M160 0C182 0 200 18 200 40H120C120 18 138 0 160 0zM280 100C269 100 260 109 260 120V200C260 248.6 225.4 289 179.6 298C179.6 298.8 180 299.2 180 300C180 311 171 320 160 320S140 311 140 300C140 299.2 140.4 298.8 140.4 298C94.6 289 60 248.6 60 200V120C60 109 51 100 40 100S20 91 20 80C20 69 29 60 40 60H280C291 60 300 69 300 80C300 91 291 100 280 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Notifications.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Notifications.displayName = "Blueprint5.Icon.Notifications";
exports.default = Notifications;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bgPrw":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberedList", ()=>NumberedList);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var NumberedList = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "numbered-list",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M34.8 219.8H60.2V380H41.2C40.4 375.2 38.8 371 36 367.6C33.4 364.2 30.2 361.6 26.6 359.4C22.8 357.2 18.6 355.8 14 354.8C9.4 354 4.8 353.4 -0.2 353.4V332.8H34.8V219.8zM43.4 61.2C47 64 50.8 66.8 55 69.8C59.2 72.6 63.4 75.6 67.6 78.8C71.8 81.9999999999999 75.8 85.4 79.8 88.8C83.8 92.4 87.2 96.4 90.2 100.6C93.2 104.8 95.8 109.5999999999999 97.6 114.5999999999999C99.4 119.5999999999999 100.4 125.3999999999999 100.4 131.5999999999999C100.4 136.5999999999999 99.6 142 98 147.5999999999999C96.4 153.1999999999999 93.8 158.4 90.2 163.1999999999999C86.4 168 81.6 171.9999999999999 75.6 175C69.6 178.4 62 180 53.2 180C45 180 37.8 178.4 31.6 175.4C25.2 172.2 20 168 15.6 162.6C11.2 157.2 8 150.8 5.8 143.4C3.6 136.0000000000001 2.6 128.0000000000001 2.6 119.2000000000001H26.4C26.6 124.8 27 129.8 28 134.6C29 139.4 30.4 143.6 32.2 147C34 150.6 36.6 153.2 39.8 155.4C43 157.4 46.8 158.4 51.6 158.4C56.8 158.4 61 157.4 64.2 155.6C67.4 153.8 70 151.4 71.8 148.6C73.6 145.8 74.8 142.8 75.4 139.6C76 136.4 76.4 133.4 76.4 130.6C76.2 124.4 74.8 119 72 114.4C69.2 109.6 65.6 105.4 61.4 101.2C57 97.2000000000001 52.4 93.4 47.2 89.8C42 86.2 37 82.6 32.4 79C22.4 71.8 14.6 63.4 9 53.6C3 44.2 0 32.8 -0.2 19.8H100V42.6H28.6C29.6 46 31.4 49.1999999999999 34 52.4C36.6 55.4 39.8 58.4 43.4 61.2zM360 319.6H160C149 319.6 140 310.6 140 299.6V279.6C140 268.6 149 259.6 160 259.6H360C371 259.6 380 268.6 380 279.6V299.6C380 310.8 371 319.6 360 319.6zM360 139.6H160C149 139.6 140 130.6 140 119.6V99.6C140 88.6 149 79.6 160 79.6H360C371 79.6 380 88.6 380 99.6V119.6C380 130.8 371 139.6 360 139.6z" : "M55.2 180H80.4V320H61.6C60.8 315.8 59.2 312.2 56.6 309.2C54 306.2 50.8 303.8 47 302C43.4 300.2 39.2 298.8 34.6 298C30 297.2 25.4 296.8 20.4 296.8V278.8H55.2V180zM43.4 36.6C47 39 50.8 41.6 55 44C59.2 46.4 63.4 49 67.6 51.8C71.8 54.6 75.8 57.4 79.8 60.6C83.8 63.8 87.2 67.2 90.2 70.8C93.2 74.6 95.8 78.6 97.6 83C99.4 87.4 100.4 92.4 100.4 97.8C100.4 102.2 99.6 106.8 98 111.8C96.4 117 93.8 121.6 90 125.6C86.4 129.8 81.4 133.4 75.6 136C69.6 138.8 62 140.2 53.2 140.2C45 140.2 37.8 138.8 31.6 136.2C25.2 133.4 20 129.8 15.6 125C11.2 120.4 8 114.8 5.8 108.2C3.6 101.8 2.6 94.8 2.6 87.2H26.4C26.6 92 27 96.6 28 100.6C29 104.8 30.2 108.4 32.2 111.4C34 114.4 36.6 116.8 39.8 118.6C43 120.4 46.8 121.2 51.6 121.2C56.8 121.2 61 120.4 64.2 118.8C67.4 117.2 70 115.2000000000001 71.8 112.8C73.6 110.4 74.8 107.8 75.4 105C76 102.2 76.4 99.6 76.4 97C76.2 91.6 74.8 87 72 82.8C69.2 78.6 65.6 74.8 61.4 71.4C57 67.8 52.4 64.6 47.2 61.6C42 58.6 37 55.4 32.4 52.2C22.4 46 14.6 38.6 9 30C3 21.8 0.2 11.8 0 0.4H100V20.4H28.6C29.6 23.4 31.4 26.2 34 29C36.8 31.6 39.8 34.2 43.4 36.6zM300.2 280.2H160.2C149.2 280.2 140.2 271.2 140.2 260.2V240.2C140.2 229.2 149.2 220.2 160.2 220.2H300.2C311.2 220.2 320.2 229.2 320.2 240.2V260.2C320.2000000000001 271.2 311.4 280.2 300.2 280.2zM300.2 100.2H160.2C149.2 100.2 140.2 91.2 140.2 80.2V60.2C140.2 49.2 149.2 40.2 160.2 40.2H300.2C311.2 40.2 320.2 49.2 320.2 60.2V80.2C320.2000000000001 91.2 311.4 100.2 300.2 100.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
NumberedList.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
NumberedList.displayName = "Blueprint5.Icon.NumberedList";
exports.default = NumberedList;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7pmf3":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Numerical", ()=>Numerical);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Numerical = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "numerical",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M47.8 285C44.4 280.8 40.2 277.2 35.2 274.6C30.2 272 24.8 270 18.6 268.8C12.6 267.8 6.4 267.2000000000001 0 267.2000000000001V242.4H49.8V100H79.6V300.4H54.6C53.6 294.2 51.2 289 47.8 285zM391.8 190.8C386.4 199.6 378.8 205 369 207.2V207.6C377.4000000000001 210.8 383.4 216.2 387.4000000000001 223.4C391.4 230.6 393.2 239.2 393.2 248.8C393.2 257.2000000000001 391.6 264.8 388.6 271.2000000000001C385.6 277.8 381.4 283 376.2 287.2000000000001C371 291.4000000000001 365.2 294.6 358.8 296.8000000000001C352.4 299.0000000000001 345.8 300 339.2 300C330.6 300 322.8 298.4000000000001 316 295C309.2 291.8000000000001 303.3999999999999 287.2000000000001 298.6 281.2000000000001C293.8 275.4000000000001 290 268.4000000000001 287.2 260.4000000000001C284.3999999999999 252.4000000000001 282.8 243.8000000000001 282.6 234.4000000000001H310.4C310.2 239.4000000000001 310.8 244.2000000000001 311.8 248.8000000000001C313 253.4000000000001 314.6 257.6 317 261.4000000000001C319.3999999999999 265.2000000000001 322.4 268.2000000000001 326 270.4000000000001C329.5999999999999 272.6 333.8 273.8000000000001 338.5999999999999 273.8000000000001C346.3999999999999 273.8000000000001 352.8 271.4000000000001 357.8 266.4000000000001C362.8 261.4000000000001 365.2 254.8000000000001 365.2 246.6C365.2 240.8000000000001 364.2 235.8000000000001 362 231.8000000000001C359.8 227.8000000000001 357 224.6000000000001 353.4 222.4C349.8 220.2000000000001 345.8 218.6 341.2 217.6C336.6 216.6 332 216.4 327.6 216.6V193.2C333.2 193.4 338.6 193.2 343.8 192.6C349 192 353.8 190.6 358 188.4C362.2 186.2 365.6 182.8 368.2 178.4C370.8 174 372.2 168 372.2 160.6C372.2 149.6 369 141.2 362.8 135.2C356.6 129.2 348.8 126.2 339.4 126.2C328.4 126.2 320.4 130 314.8 137.8C309.4 145.6 306.8 155.4 307.2 167H279.3999999999999C279.5999999999999 157 281 147.8 283.6 139.4C286.2 131.2000000000001 290 124.0000000000001 295 118.2000000000001C300 112.4 306.2 107.8000000000001 313.6 104.6C321 101.4 329.5999999999999 99.8000000000001 339.5999999999999 99.8000000000001C347.8 99.8000000000001 355.3999999999999 101.2000000000001 362.8 104.0000000000001C370.2 106.8000000000001 376.6 110.6000000000001 382 115.6000000000001C387.6 120.6000000000001 392 126.8000000000001 395.2 134.0000000000001C398.4 141.2000000000001 400 149.4 400 158.6000000000001C400 171.4 397.2 182 391.8 190.8zM171.6 151.8C175.8 155.4 180.6 159 185.6 162.4C190.6 166 195.6 169.6 200.6 173.6C205.6 177.6 210.4 181.8 215.2 186.2C219.8 190.6 224 195.6 227.8 201C231.4 206.4 234.4 212.2 236.6 218.6C238.8 225 239.8 232.0000000000001 239.8 240.0000000000001C239.8 246.4000000000001 238.8 253.0000000000001 237 260C235.2 267 232 273.6 227.6 279.4000000000001C223.2 285.4000000000001 217.4 290.4000000000001 210.2 294.2000000000001C203 298.2000000000001 194 300 183.2 300C173.4 300 164.6 298.0000000000001 157.2 294.2000000000001C149.8 290.6 143.4 285.4 138.2 278.6C133 272 129.2 264 126.6 254.6C124 245.4 122.6 235.4 122.6 224.6H151.2C151.4 231.6 152 238 153 244C154 250 155.8 255.2 158 259.6C160.2 264 163.2 267.4 167 270C170.8 272.6 175.6 273.8 181.2 273.8C187.4 273.8 192.4 272.6 196.2 270.2000000000001C200 267.8 203 265 205.2 261.6C207.4 258.2000000000001 208.8 254.4 209.6 250.4000000000001C210.4 246.4000000000001 210.8 242.6 210.8 239.0000000000001C210.6 231.4 208.8 224.6 205.6 218.6C202.6 212.6 198.2 207.2 193 202C187.8 197 182.2 192.2 176 187.8C169.8 183.4 163.8 178.8 158.2 174.2C146.2 165.2000000000001 137 154.6 130 142.6C123 130.4 119.6 116.2 119.4 100H239.6V128.6H153.8C155 132.8 157.2 137 160.4 140.8C163.6 144.6 167.2 148.4 171.6 151.8z" : "M55.8 227.8C53.2 224.4 50 221.8 46.2 219.6C42.6 217.4 38.4 216 33.8 215C29.2 214.2 24.6 213.6 19.6 213.6V193H54.4V80H79.6V240H60.8C60 235.4 58.4 231.2 55.8 227.8zM143.2 121.6C146.8 124.4 150.6 127.2 154.8 130C159 133 163.2 136 167.4 139C171.6 142.2 175.6 145.6 179.6 149.2C183.6 152.8 187 156.8 190 161C193 165.2 195.6 170 197.4 175C199.2 180 200 185.8 200 192C200 197 199.2 202.4 197.6 208C196.2 213.8 193.6 219 189.8 223.8C186.2 228.6 181.2 232.6 175.2 235.8C169.4 238.8 162 240.4 153 240.4C144.8 240.4 137.6 238.8 131.4 235.8C125.2 232.6 119.8 228.4 115.6 223C111.2 217.6 108 211.2 105.8 203.8C103.6 196.4 102.6 188.4 102.6 179.8H126.4C126.6 185.2 127 190.4 128 195.2C128.8 200 130.2 204.2 132.2 207.6C134 211.2 136.6 214 139.8 216C143 218 146.8 219 151.6 219C156.8 219 161 218 164.2 216.2C167.2 214.4 169.8 212 171.6 209.2C173.4 206.4 174.6 203.4 175.2 200.2C175.8 197 176.2 194 176.2 191.2C176 185 174.6 179.6 171.8 174.8C169 170.2 165.4 165.8 161.2 161.8C156.8 157.6 152 154 147 150.4C141.8 146.8 136.8 143.2 132 139.6C122 132.4 114.2 124 108.6 114.2C103 104.4 100 93 99.8 80H199.8V103H128.6C129.6 106.4 131.4 109.6 134 112.8C136.6 115.8 139.8 118.6 143.2 121.6zM313.2 152.8C308.6 159.8 302.4000000000001 164.2 294.2000000000001 165.8V166.2C301 168.8 306.2 173 309.4000000000001 178.8C312.6 184.6 314.2000000000001 191.4 314.2000000000001 199.2C314.2000000000001 206 313 212 310.4000000000001 217.2C307.8 222.4 304.4000000000001 226.6 300.2000000000001 230C296 233.4 291.2000000000001 236 285.8 237.6C280.4000000000001 239.4 275 240.2 269.4000000000001 240.2C262.2000000000001 240.2 255.8 238.8 250.2000000000001 236.2C244.6000000000001 233.6 239.6000000000001 229.8 235.8 225.2C231.8000000000001 220.6 228.6 215 226.4 208.6C224.2 202.2 222.8 195.4 222.6 187.8H245.6C245.4000000000001 191.8 245.8 195.6 246.8000000000001 199.4C247.8000000000001 203.2 249.2 206.6 251.2000000000001 209.6C253.2000000000001 212.6 255.6000000000001 215 258.6 216.8C261.6 218.6 265.0000000000001 219.4 269.2000000000001 219.4C275.6 219.4 281 217.4 285 213.4C289.2000000000001 209.4 291.2 204.2 291.2 197.6C291.2 193 290.2 189 288.4 185.8C286.6 182.6 284.2000000000001 180 281.4 178.2C278.4 176.4 275 175 271.2 174.4C267.4000000000001 173.6 263.6 173.4 259.8 173.6V155C264.4000000000001 155.2 268.8 155 273.2 154.6C277.6 154.2 281.6 153 285 151.2C288.6 149.4 291.4 146.6 293.6 143.2C295.8 139.6 296.8 135 296.8 129C296.8 120.2 294.2 113.4 289 108.6C283.8 103.8 277.4 101.4 269.6 101.4C260.6 101.4 253.8 104.6 249.2 110.8C244.6 117 242.6 124.8 242.8 134.2H220C220.2 126.2 221.2 118.8 223.4 112.2C225.6 105.6 228.6 100 232.8 95.2000000000001C237.0000000000001 90.6 242.0000000000001 86.8 248.2 84.4C254.4 81.8 261.6 80.6000000000001 269.8 80.6000000000001C276.6 80.6000000000001 283 81.6000000000001 289 83.8000000000001C295 86.0000000000001 300.4 89.2000000000001 305 93.2000000000001C309.6 97.2000000000001 313.2 102.2000000000001 316 108.0000000000001C318.6 113.4 320 120 320 127.4C320 137.4 317.8 145.8 313.2 152.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Numerical.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Numerical.displayName = "Blueprint5.Icon.Numerical";
exports.default = Numerical;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f20lr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectView", ()=>ObjectView);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ObjectView = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "object-view",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100 400H20C8.9543 400 0 391.0457 0 380V300H40L40 360H100V400zM360 100V40H300V0H380C391.046 0 400 8.954 400 20V100H360zM0 100H40L40 40H100V0H20C8.9543 0 0 8.954 0 20V100zM300 400H380C391.046 400 400 391.0457 400 380V300H360V360H300V400zM191.0156 357.4978L74.8266 294.9616L200 220L325.1720000000001 294.9616L210 357.4978C203.852 360.834 197.1642 360.834 191.0156 357.4978zM190 199.998L62.115 280.0756C60.7466 277.48 60 274.5786 60 271.5756V146.008C60 139.192 63.8458 132.9 70.0772 129.518L187.855 61.006C188.5534 60.626 189.2696 60.29 190 59.998V199.998zM337.884 280.077C339.252 277.4812 339.998 274.5798 339.998 271.5768V146.008C339.998 139.194 336.1520000000001 132.9 329.922 129.5200000000001L212.146 61.006C211.448 60.628 210.73 60.292 210 59.998L209.998 199.998L337.884 280.077z" : "M20 320C8.9543 320 0 311.0457 0 300V240H40V280L80 280V320H20zM0 20V80H40L40 40H80V0H20C8.9543 0 0 8.954 0 20zM300 0H240V40H280V80H320V20C320 8.954 311.046 0 300 0zM320 300V240H280V280H240V320H300C311.046 320 320 311.0457 320 300zM159.9988 180L249.998 230L167.8382 278.1374C163.4922 280.6208000000001 156.9712 280.6208000000001 152.625 278.1374L71.4002 232.111L159.9988 180zM259.094 220C259.6140000000001 218.52 259.89 216.9432 259.89 215.3268V118.64C259.89 113.566 257.17 108.882 252.766 106.366L167.9998 60V163.0658L259.094 220zM151.8894 165.144L60.7946 220.0062C60.276 218.5262 60 215.4506 60 213.8342V120.7182C60 115.646 62.7184 110.96 67.123 108.444L151.8894 60.006V165.144z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ObjectView.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ObjectView.displayName = "Blueprint5.Icon.ObjectView";
exports.default = ObjectView;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6GoMt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Office", ()=>Office);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Office = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "office",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 280H280V380C280 391 271 400 260 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H100V120H180V0H380C391 0 400 9 400 20V260C400 271 391 280 380 280zM120 160H40V240H120V160zM120 280H40V360H120V280zM240 160H160V240H240V160zM240 280H160V360H240V280zM360 60H280V120H360V60zM360 160H280V240H360V160z" : "M300 220H240V300C240 311 231 320 220 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H80V80H160V0H300C311 0 320 9 320 20V200C320 211 311 220 300 220zM100 120H40V180H100V120zM100 220H40V280H100V220zM200 120H140V180H200V120zM200 220H140V280H200V220zM280 40H240V80H280V40zM280 120H240V180H280V120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Office.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Office.displayName = "Blueprint5.Icon.Office";
exports.default = Office;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"331kf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Offline", ()=>Offline);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Offline = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "offline",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM140 40L180 180H100L260 360L220 220H300L140 40z" : "M160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM120 40L140 140H80L200 280L180 180H240L120 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Offline.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Offline.displayName = "Blueprint5.Icon.Offline";
exports.default = Offline;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4d8qI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OilField", ()=>OilField);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var OilField = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "oil-field",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 40.2H352.8L265.8 231.6L324.0000000000001 248.8000000000001L357.2000000000001 166.8000000000001C359.4000000000001 161.4000000000001 365.8000000000001 158.8000000000001 371.6 160.6000000000001C374.0000000000001 161.4 376 162.8000000000001 377.2000000000001 164.6000000000001C378.4000000000001 166.8000000000001 406.6 206.2000000000001 398.2000000000001 276.6C395.8 297.6 386 400 320.2000000000001 400C297.8 399.8 279.8 383.4 280 363.2C280 359.4 280.8 355.6 282 352L308.8 285.8L14.4 199.4L14.4 199C6.2 196.6 0 189.2 0 180.2C0 169.2 9 160.2 20 160.2C22 160.2 23.8 160.8 25.6 161.4L25.6 161L65.6 172.8L95 40.2H60C49 40.2 40 31.2 40 20.2C40 9.2 49 0.2 60 0.2H380C391 0.2 400 9.2 400 20.2C400 31.2 391 40.2 380 40.2zM104 184L183 207.2L126.4 82.8L104 184zM151 40.2L230 213.8L309 40.2H151z" : "M300 40H273L206.2 190.2L255.4 209.2L284.4 145C286.2 141 291.6 139 296.4 140.4C298.4 141 300 142 301.2 143.4C302.2 145 325.8 174.6 318.6 227.4C316.4 243.2 308.2 319.8 253.4 319.8C234.8 319.8 219.8 307.4 220 292.4C220 289.6 220.6 286.8 221.8 284L239.2 245.6L12.8 158.6L12.8 158.4C5.4 155.6 0 148.6 0 140C0 129 9 120 20 120C22.6 120 25 120.6 27.2 121.4L27.2 121.2L48 129.2L73.4 40H40C29 40 20 31 20 20C20 9 29 0 40 0H300C311 0 320 9 320 20C320 31 311 40 300 40zM85.4 143.8L142.8 166L104 78.4L85.4 143.8zM130.8 40L180 150.8L229.2 40H130.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
OilField.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
OilField.displayName = "Blueprint5.Icon.OilField";
exports.default = OilField;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"liko0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OneColumn", ()=>OneColumn);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var OneColumn = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "one-column",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M298.8 400H218.8C207.8 400 198.8 391 198.8 380V20C198.8 9 207.8 0 218.8 0H298.8C309.8 0 318.8 9 318.8 20V380C318.8 391 309.8 400 298.8 400zM138.8 280C133.2 280 128.2 277.8 124.6 274.2L64.6 214.2C61 210.6 58.8 205.6 58.8 200S61 189.4 64.6 185.8L124.6 125.8C128.2 122.2 133.2 120 138.8 120C149.8 120 158.8 129 158.8 140V260C158.8 271 149.8 280 138.8 280z" : "M239.8 320.2H179.8C168.8 320.2 159.8 311.2 159.8 300.2V20.2C159.8 9.2 168.8 0.2 179.8 0.2H239.8C250.8 0.2 259.8 9.2 259.8 20.2V300.2C259.8 311.2 250.8 320.2 239.8 320.2zM119.8 220.2C114.2 220.2 109.2 218 105.6 214.4L65.6 174.4C62 170.6 59.8 165.6 59.8 160.2S62 149.6 65.6 146L105.6 106C109.2 102.4 114.2 100.2000000000001 119.8 100.2000000000001C130.8 100.2000000000001 139.8 109.2 139.8 120.2000000000001V200.2000000000001C139.8 211.2 130.8 220.2 119.8 220.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
OneColumn.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
OneColumn.displayName = "Blueprint5.Icon.OneColumn";
exports.default = OneColumn;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g2FNs":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OneToMany", ()=>OneToMany);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var OneToMany = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "one-to-many",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 340C360 328.9544 351.046 320 340 320C328.954 320 320 328.9544 320 340C320 351.0456 328.954 360 340 360C351.046 360 360 351.0456 360 340zM283.616 319.4374000000001C273.868 318.666 261.886 316.838 250.262 312.508C231.326 305.454 214.8 292.492 209.624 266.145C203.164 233.2560000000001 184.9354 212.6364 164.3452 200C184.9354 187.364 203.164 166.744 209.624 133.854C214.8 107.508 231.326 94.546 250.262 87.492C261.886 83.162 273.868 81.334 283.616 80.562C292.01 103.572 314.086 120 340 120C373.1380000000001 120 400 93.138 400 60C400 26.862 373.1380000000001 0 340 0C313.6980000000001 0 291.348 16.924 283.248 40.478C270.576 41.318 253.416 43.632 236.3 50.008C208.258 60.454 178.9498 82.492 170.375 126.146C165.1998 152.492 148.6742 165.454 129.7374 172.508C124.9276 174.3 120.0566 175.664 115.3082 176.7C106.2128 155.136 84.874 140 60 140C26.863 140 0 166.862 0 200C0 233.137 26.863 260 60 260C84.874 260 106.2128 244.8638 115.3082 223.2996C120.0566 224.337 124.9276 225.7002 129.7372 227.4918C148.674 234.546 165.1998 247.5078 170.375 273.8548C178.9498 317.5078 208.258 339.546 236.3 349.9918C253.416 356.368 270.576 358.6824000000001 283.248 359.5222C291.348 383.07528 313.6980000000001 400 340 400C373.1380000000001 400 400 373.137 400 340C400 306.863 373.1380000000001 280 340 280C314.086 280 292.01 296.4278 283.616 319.4374000000001zM80 200.0198C79.9894 211.0564 71.0392 220 60 220C48.9544 220 40 211.0458 40 200C40 188.954 48.9544 180 60 180C71.0392 180 79.9894 188.944 80 199.98L80 200L80 200.0198zM340 40C351.046 40 360 48.954 360 60C360 71.046 351.046 80 340 80C328.954 80 320 71.046 320 60C320 48.954 328.954 40 340 40z" : "M280 260C280 248.9544 271.046 240 260 240C248.954 240 240 248.9544 240 260C240 271.0456 248.954 280 260 280C271.046 280 280 271.0456 280 260zM205.48 234.9152C214.978 214.3054 235.818 200 260 200C293.1380000000001 200 320 226.863 320 260C320 293.137 293.1380000000001 320 260 320C232.292 320 208.972 301.21884 202.072 275.6926C198.7178 274.8254 195.2988 273.7838 191.8784 272.5324C170.3572 264.6588 147.1444 247.7026 140.3884 213.9222C137.1566 197.7636 127.0998 189.7192 114.5206 185.0846C105.0224 205.6944 84.1818 220 60 220C26.863 220 0 193.137 0 160C0 126.863 26.863 100 60 100C84.1818 100 105.0224 114.306 114.5206 134.9154C127.0998 130.2808 137.1566 122.2364 140.3884 106.078C147.1444 72.298 170.3572 55.342 191.8784 47.468C195.2988 46.216 198.7178 45.174 202.074 44.308C208.972 18.782 232.292 0 260 0C293.1380000000001 0 320 26.862 320 60C320 93.138 293.1380000000001 120 260 120C235.818 120 214.978 105.694 205.48 85.084C192.9004 89.72 182.8434 97.764 179.6116 113.922C175.3076 135.4424 164.325 150.1344 151.3556 160C164.325 169.8656 175.3076 184.5576 179.6116 206.0776C182.8434 222.2364 192.9002 230.2806 205.48 234.9152zM260 40C248.954 40 240 48.954 240 60C240 71.046 248.954 80 260 80C271.046 80 280 71.046 280 60C280 48.954 271.046 40 260 40zM80 160C80 171.0456 71.0456 180 60 180C48.9544 180 40 171.0456 40 160C40 148.9542 48.9544 140 60 140C71.0456 140 80 148.9542 80 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
OneToMany.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
OneToMany.displayName = "Blueprint5.Icon.OneToMany";
exports.default = OneToMany;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"XhSNp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OneToOne", ()=>OneToOne);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var OneToOne = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "one-to-one",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 200C40 211.0456 48.9544 220 60 220C71.0456 220 80 211.0456 80 200C80 188.954 71.0456 180 60 180C48.9544 180 40 188.954 40 200zM116.5858 220C108.3492 243.3038 86.1244 260 60 260C26.863 260 0 233.137 0 200C0 166.862 26.863 140 60 140C86.1244 140 108.3492 156.696 116.5858 180H283.414C291.65 156.696 313.876 140 340 140C373.1380000000001 140 400 166.862 400 200C400 233.137 373.1380000000001 260 340 260C313.876 260 291.65 243.3038 283.414 220H116.5858zM340 220C328.954 220 320 211.0456 320 200C320 188.954 328.954 180 340 180C351.046 180 360 188.954 360 200C360 211.0456 351.046 220 340 220z" : "M40 160C40 171.0456 48.9544 180 60 180C71.0456 180 80 171.0456 80 160C80 148.9544 71.0456 140 60 140C48.9544 140 40 148.9544 40 160zM116.5858 180C108.3492 203.3038 86.1244 220 60 220C26.863 220 0 193.137 0 160C0 126.863 26.863 100 60 100C86.1244 100 108.3492 116.696 116.5858 140H203.414C211.65 116.696 233.876 100 260 100C293.1380000000001 100 320 126.863 320 160C320 193.137 293.1380000000001 220 260 220C233.876 220 211.65 203.3038 203.414 180H116.5858zM260 180C248.954 180 240 171.0456 240 160C240 148.9544 248.954 140 260 140C271.046 140 280 148.9544 280 160C280 171.0456 271.046 180 260 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
OneToOne.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
OneToOne.displayName = "Blueprint5.Icon.OneToOne";
exports.default = OneToOne;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dT3e8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenApplication", ()=>OpenApplication);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var OpenApplication = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "open-application",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 380H360C371 380 380 371 380 360V100C380 89 371 80 360 80H200V120H340V320H100V200H60V360C60 371 69 380 80 380zM130 280H270C275.6 280 280 284.4 280 290C280 295.6 275.6 300 270 300H130C124.4 300 120 295.6 120 290C120 284.4 124.4 280 130 280zM130 240H190C195.6 240 200 244.4 200 250C200 255.6 195.6 260 190 260H130C124.4 260 120 255.6 120 250C120 244.4 124.4 240 130 240zM230 200H130C124.4 200 120 204.4 120 210C120 215.6 124.4 220 130 220H230C235.6 220 240 215.6 240 210C240 204.4 235.6 200 230 200zM140 60C140 49 149 40 160 40C171 40 180 49 180 60V160C180 171 171 180 160 180H60C49 180 40 171 40 160C40 149 49 140 60 140H111.8L6 34.2C2.2 30.6 0 25.6 0 20C0 9 9 0 20 0C25.6 0 30.6 2.2 34.2 5.8L140 111.8V60z" : "M100 320H300C311 320 320 311 320 300V100C320 89 311 80 300 80H160V120H280V260H120V160H80V300C80 311 89 320 100 320zM150 220H250C255.6 220 260 224.4 260 230C260 235.6 255.6 240 250 240H150C144.4 240 140 235.6 140 230C140 224.4 144.4 220 150 220zM150 180H190C195.6 180 200 184.4 200 190C200 195.6 195.6 200 190 200H150C144.4 200 140 195.6 140 190C140 184.4 144.4 180 150 180zM220 150C220 144.4 216.7 140 212.5 140H167.5C163.3 140 160 144.4 160 150C160 155.6 163.3 160 167.5 160H212.5C216.7 160 220 155.6 220 150zM100 40C100 29 109 20 120 20C131 20 140 29 140 40V120C140 131 131 140 120 140H40C29 140 20 131 20 120C20 109 29 100 40 100H71.8L6 34.2C2.2 30.6 0 25.6 0 20C0 9 9 0 20 0C25.6 0 30.6 2.2 34.2 5.8L100 71.8V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
OpenApplication.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
OpenApplication.displayName = "Blueprint5.Icon.OpenApplication";
exports.default = OpenApplication;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"19uMc":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Outdated", ()=>Outdated);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Outdated = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "outdated",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C310.4 400 400 310.4 400 200C400 89.6 310.4 0 200 0C89.6 0 0 89.6 0 200C0 211 9 220 20 220C31 220 40 211 40 200C40 111.6 111.6 40 200 40C288.4 40 360 111.6 360 200C360 288.4 288.4 360 200 360C149.4 360 104.4 336.6 75.2 300L100 300C111 300 120 291 120 280C120 269 111 260 100 260L20 260C9 260 0 269 0 280L0 360C0 371 9 380 20 380C31 380 40 371 40 360L40 319C76.4 368 134.2 400 200 400zM220 80L180 80L180 120L220 120L220 80zM220 140L180 140L180 320L220 320L220 140z" : "M160 320C248.4 320 320 248.4 320 160C320 78.8 259.6 12 181.2 1.6C180.8 1.6 180.4 1.4 180 1.4C173.4 0.6 166.8 0 160 0C71.6 0 0 71.6 0 160C0 171 9 180 20 180C31 180 40 171 40 160C40 93.8 93.8 40 160 40C174.2 40 187.4 43 200 47.6L200 47.4C246.6 63.8 280 107.8 280 160C280 226.2 226.2 280 160 280C124.4 280 92.8 264.4 70.8 240L100 240C111 240 120 231 120 220C120 209 111 200 100 200L20 200C9 200 0 209 0 220L0 300C0 311 9 320 20 320C31 320 40 311 40 300L40 265.2C69.2 298.6 112 320 160 320zM180 80L140 80L140 120L180 120L180 80zM180 140L140 140L140 240L180 240L180 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Outdated.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Outdated.displayName = "Blueprint5.Icon.Outdated";
exports.default = Outdated;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"D1cpF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Output", ()=>Output);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Output = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "output",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 200C0 89.8 89.8 0 200 0C223.4 0 246.4 4 268.4 12C278.8 15.8 284.2000000000001 27.2 280.4 37.6C276.6 48 265.2 53.4 254.8 49.6C237.2 43.2 218.8 40 200 40C111.8 40 40 111.8 40 200C40 288.2 111.8 360 200 360C218.8 360 237.2 356.8 254.8 350.4C265.2 346.6 276.6 352 280.4 362.4C284.2000000000001 372.8 278.8 384.2 268.4 388C246.4 396 223.4 400 200 400C89.8 400 0 310.2 0 200zM394.2000000000001 214.2L314.2000000000001 294.2C310.6 297.8 305.6 300 300 300C289 300 280 291 280 280C280 274.4 282.2 269.4 285.8 265.8L331.8 220H100C88.9544 220 80 211.0456 80 200C80 188.954 88.9544 180 100 180H331.8L286 134.2000000000001C282.2 130.6 280 125.6 280 120C280 109 289 100 300 100C305.6 100 310.6 102.2 314.2000000000001 105.8L394.2000000000001 185.8C397.8 189.4 400 194.4 400 200C400 205.6 397.8 210.6 394.2000000000001 214.2z" : "M160 0C71.8 0 0 71.644 0 160.1C0 248.5554 71.8 320 160 320C178.8 320 197.2 316.798 214.8 310.394C225.2 306.59162 230.6 295.1844 226.8 284.778C223 274.3714 211.6 268.9682 201.2 272.7704C188 277.5734 174.2 279.975 160.2 279.975C94 279.975 40.2 226.1414 40.2 159.9C40.2 93.658 94 39.824 160.2 39.824C174.2 39.824 188 42.226 201.2 47.03C211.6 50.832 223 45.428 226.8 35.022C230.6 24.616 225.2 13.208 214.8 9.406C197.2 3.002 178.8 0 160 0zM314.2000000000001 174.1088C317.8 170.5066 320 165.5034 320 159.9C320 154.2964 317.8 149.2934 314.2000000000001 145.691L254.2 85.654C250.6 82.052 245.6 79.85 240 79.85C229 79.85 220 88.856 220 99.862C220 105.466 222.2 110.47 226 114.072L251.8 139.8874H100C89 139.8874 80 148.893 80 159.9C80 170.9068 89 179.9124 100 179.9124H251.8L225.8 205.7286C222.2 209.3308 220 214.334 220 219.9374C220 230.9444 229 239.95 240 239.95C245.6 239.95 250.6 237.7486 254.2 234.1464L314.2000000000001 174.1088z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Output.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Output.displayName = "Blueprint5.Icon.Output";
exports.default = Output;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lxKfz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Package", ()=>Package);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Package = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "package",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M236.978 393.8728L377.8880000000001 323.4172C391.44 316.6416000000001 400 302.791 400 287.6402V113.542C400 97.186 390.042 82.476 374.856 76.402L195.7668 4.766A40.0116 40.0116 0 0 0 163.0226 6.128L22.1114 76.584C8.56 83.36 0 97.21 0 112.362V286.4602C0 302.8164 9.958 317.5246 25.1444 323.5992L204.234 395.2348A40 40 0 0 0 236.978 393.8728zM200 206.4606V49.542L360 113.542V270.4606L300 246.4606V143.2820000000001L260 127.422V230.4606L200 206.4606z" : "M196 317L298 265C312 259 320 245 320 229V93C320 77 310 61 294 55L156 3C146 -1 134 -1 124 3L22 55C8 61 0 75 0 91V227C0 243 10 259 26 265L164 317C174 321 186 321 196 317zM240 196.14V122L200 106V181.14L160 166.14V45.782L280 91V211.14L240 196.14z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Package.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Package.displayName = "Blueprint5.Icon.Package";
exports.default = Package;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6AYGJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageLayout", ()=>PageLayout);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PageLayout = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "page-layout",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 380H20C9 380 0 371 0 360V40C0 29 9 20 20 20H380C391 20 400 29 400 40V360C400 371 391 380 380 380zM140 60H40V240H140V60zM360 60H160V240H360V60zM360 260H40V340H360V260z" : "M300 301H20C9 301 0 292 0 281V41C0 30 9 21 20 21H300C311 21 320 30 320 41V281C320 292 311 301 300 301zM120 61H40V181H120V61zM280 61H140V181H280V61zM280 201H40V261H280V201z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PageLayout.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PageLayout.displayName = "Blueprint5.Icon.PageLayout";
exports.default = PageLayout;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9dnZQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanelStats", ()=>PanelStats);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PanelStats = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "panel-stats",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 380L380 380C391.0456940000001 380 400 371.045695 400 360L400 60C400 48.954306 391.0456940000001 40 380 40L20 40C8.954305 40 0 48.954306 0 60L0 360L0 360C0 371.045695 8.954305 380 20 380L20 380zM40 340L40 80L360 80L360 340L40 340zM220 340L240 340L240 80L220 80L220 340zM260 200L339.04762 200L339.04762 180L260 180L260 200zM260 160L339.04762 160L339.04762 140L260 140L260 160zM260 120L339.04762 120L339.04762 100L260 100L260 120zM260 240L339.04762 240L339.04762 220L260 220L260 240zM260 280L339.04762 280L339.04762 260L260 260L260 280zM260 320L339.04762 320L339.04762 300L260 300L260 320z" : "M200 240H260V220H200V240zM200 200H260V180H200V200zM200 160H260V140H200V160zM200 120H260V100H200V120zM300 300H20C8 300 0 292 0 280V60C0 48 8 40 20 40H300C312 40 320 48 320 60V280C320 292 312 300 300 300zM160 80H40V260H160V80zM280 80H180V260H280V80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PanelStats.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PanelStats.displayName = "Blueprint5.Icon.PanelStats";
exports.default = PanelStats;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3AEnp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanelTable", ()=>PanelTable);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PanelTable = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "panel-table",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 380H20C8 380 0 372 0 360V60C0 48 8 40 20 40H380C392 40 400 48 400 60V360C400 372 392 380 380 380zM200 160H140V220H200V160zM200 240H140V300H200V240zM40 80V340H120V80H40zM140 80V140H200V80H140zM360 80H220V140H360V80zM360 160H220V220H360V160zM360 240H220V300H360V240z" : "M300 300H20C8 300 0 292 0 280V60C0 48 8 40 20 40H300C312 40 320 48 320 60V280C320 292 312 300 300 300zM160 140H120V180H160V140zM160 200H120V240H160V200zM40 80V260H100V80H40zM120 80V120H160V80H120zM280 80H180V120H280V80zM280 140H180V180H280V140zM280 200H180V240H280V200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PanelTable.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PanelTable.displayName = "Blueprint5.Icon.PanelTable";
exports.default = PanelTable;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ZgaK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Panel", ()=>Panel);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Panel = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "panel",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 60L340 60L340 340L220 340L220 60zM20 0L380 0C391 0 400 9 400 20L400 380C400 391 391 400.0000007868061 380 400.000001748456L20 400.0000332206C9.00004 400.0000341824 0.0000341822 391.00004 0.0000332206 380.00004L0.000001748438 20C7.86786e-7 9 9 0 20 0zM40 360L360 360L360 40L40 40L40 360z" : "M20 0L300 0C311 0 320 9 320 20L320 300C320 311 311 320.0000007868061 300 320.000001748456L20 320.0000262268C9.00002 320.0000271884 0.0000271884 311.00002 0.0000262268 300.00002L0.000001748456 20C7.86804e-7 9 9 0 20 0zM40 280L280 280L280 40L40 40L40 280zM180 60L260 60L260 260L180 260L180 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Panel.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Panel.displayName = "Blueprint5.Icon.Panel";
exports.default = Panel;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hbQxr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Paperclip", ()=>Paperclip);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Paperclip = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "paperclip",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M367 346.6C344.8 368.8 315.8 380 286.6 380C257.8 380 228.8 368.8 206.8 346.6L23.6 161.2C8 145.4 0 124.4 0 103.4C0 82.4 7.8 61.4 23.6 45.4C39.2 29.6 60 21.8 80.6 21.8C101.4 21.8 122 29.6 138 45.8L320.8 231.2C340 250.4 340 281.2 321.2 300.2C302.4 319.2 271.4 319.4 252.4 300.2L100.6 146.4L100.6 146.4C94.4 140 94.6 129.8 100.8 123.6C107 117.4 117 117.4 123.4 123.2L123.4 123.2L275.2 277C281.4 283.2 292 283.2 297.8 277.4C304 271.2000000000001 304 260.4 297.8 254.2L114.9999999999999 68.8C96.3999999999999 49.8000000000001 64.1999999999999 50.2 45.9999999999999 68.4C27.1999999999999 87.4 27.5999999999999 119.4 46.3999999999999 138.2000000000001L229.6 323.2000000000001C260.6 354.4000000000001 313.2 355.0000000000001 343.9999999999999 323.8000000000001C375.1999999999999 292.4000000000001 375 238.6 343.9999999999999 207.4L166.1999999999999 27L166.1999999999999 27C160.1999999999999 20.8000000000001 160.1999999999999 10.8000000000001 166.3999999999999 4.8000000000001C172.3999999999999 -1.2 182.1999999999999 -1.3999999999999 188.3999999999999 4.6L188.3999999999999 4.4L366.5999999999999 184.8C389 207 400 236.2 400 265.4C400 295 389 324.2 367 346.6z" : "M293.6 273.8C276 291.4 252.6 300.2 229.2 300.2C206.2 300.2 183 291.4 165.4 273.8L19 127.4C6.4 114.8 0 98.2 0 81.8S6.2 48.6 19 36C31.4 23.6 48 17.4 64.6 17.4S97.8 23.6 110.6 36.4L256.8 182.8C272 198.2 272 222.4 257 237.4000000000001C242 252.4000000000001 217.2 252.6 202 237.4000000000001L80.6 115.8L80.6 115.8C75.8 110.8 75.8 102.8 80.8 97.8C85.8 92.8 93.8 92.8 99 97.6L99 97.6L220.4 219.2C225.4 224.2 233.8 224.2 238.6 219.4C243.6 214.4 243.6 206 238.6 201L92.4 54.6C77.4 39.6 51.6 39.8 37.2 54.4C22.2 69.4 22.6 94.8 37.4 109.6L184 255.8C208.8 280.6 251 281 275.6 256.4C300.4000000000001 231.6 300.4000000000001 189.2 275.6 164.4L133.2 21.8L133.2 21.8C128.4 16.8 128.4 9 133.4 4.2C138.2 -0.6 146 -0.6 151 4L151 3.8L293.6 146.4C311.2 163.6 320 186.6 320 209.8C320 233 311.2 256.2 293.6 273.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Paperclip.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Paperclip.displayName = "Blueprint5.Icon.Paperclip";
exports.default = Paperclip;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8FVZb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Paragraph", ()=>Paragraph);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Paragraph = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "paragraph",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M330 380H140C84 380 40 336 40 280S84 180 140 180V50C140 34 154 20 170 20C186 20 200 34 200 50V320H240V50C240 34 254 20 270 20C286 20 300 34 300 50V320H330C346 320 360 334 360 350C360 366 346 380 330 380z" : "M260 300H120C76 300 40 264 40 220S76 140 120 140V40C120 28 128 20 140 20C152 20 160 30 160 40V260H200V40C200 28 208 20 220 20C232 20 240 30 240 40V260H260C270 260 280 268 280 280C280 292 272 300 260 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Paragraph.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Paragraph.displayName = "Blueprint5.Icon.Paragraph";
exports.default = Paragraph;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a6bAp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PasteVariable", ()=>PasteVariable);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PasteVariable = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "paste-variable",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 380C251 380 260 371 260 360V320H120V360C120 371 129 380 140 380H155.6C162.4 392 175.2 400 190 400C204.8 400 217.4 392 224.4 380H240zM280 360H320C331 360 340 351 340 340V20C340 9 331 0 320 0H60C49 0 40 9 40 20V340C40 351 49 360 60 360H100V300H280V360zM278.648 110.164L285.556 106.23C274.254 88.328 263.158 75.738 251.856 68.656C243.482 62.9500000000001 235.318 60.196 227.364 60.196C218.992 60.196 212.084 61.968 206.642 65.508C201.198 69.05 196.175 74.95 191.9886 83.016C187.802 91.082 182.7784 104.066 176.9172 121.77C161.8458 103.082 149.9144 89.508 141.332 80.852C132.7498 72.196 125.6328 66.492 119.981 63.934C114.3292 61.378 108.2588 60 101.7698 60C95.0714 60 89.8382 61.968 85.861 65.704C81.884 69.64 80 74.36 80 80.46C80 86.754 82.0932 92.066 86.489 96.196C90.8848 100.328 96.3274 102.492 102.8164 102.492C106.3748 102.492 110.352 101.508 114.7478 99.54C121.237 96.59 125.842 95.016 128.7726 95.016C132.5404 95.016 135.8896 95.606 138.8202 97.18C142.588 98.95 147.6118 103.082 153.4728 109.378C157.2408 113.312 163.7298 121.574 173.568 134.164C161.2178 178.82 151.3796 205.377 144.472 214.2296C140.0762 219.9344 134.4244 222.6886 127.726 222.6886C124.1674 222.6886 119.981 222.295 114.9572 221.3114L116.2132 228.3934L184.0342 240C196.3844 221.3114 204.966 200.6558 209.99 178.23C222.55 196.328 232.178 209.1148 238.668 216.3934C247.25 226.2296 254.368 232.5246 260.02 235.4754C265.67 238.4262 271.742 239.8032 278.02 239.8032C285.138 239.8032 290.58 237.836 294.348 234.0984C298.116 230.3606 300 225.4426000000001 300 218.9508C300 212.8524 298.116 207.9344 294.348 204.1968C290.58 200.459 285.766 198.492 280.114 198.492C275.928 198.492 271.322 199.278 265.88 200.6558C260.648 202.0328 256.88 202.8196 254.786 202.8196C249.344 202.8196 244.11 200.8524 239.296 197.114C232.388 192 224.224 180.984 214.386 164.262C225.48 126.688 234.272 103.672 240.762 95.41C244.738 90.492 248.716 88.132 252.692 88.132C256.042 88.132 258.9720000000001 88.918 261.484 90.492C265.0420000000001 93.05 270.904 99.54 278.648 110.164z" : "M179.9996 300C190.9996 300 199.9996 291 199.9996 280V260H99.9996V280C99.9996 291 108.9996 300 119.9996 300H115.5996C122.3996 312 135.1996 320 149.9996 320C164.7996 320 177.5996 312 184.3996 300H179.9996zM220 280H240C251 280 260 271 260 260V20C260 9 251 0 240 0H60C49 0 40 9 40 20V260C40 271 49 280 60 280H80V240H220V280zM206.318 93.476L210.822 90.902C203.48 78.884 196.472 70.644 189.7974 65.666C184.6246 61.888 179.4518 60 174.279 60C168.9392 60 164.6008 61.202 161.0966 63.606C157.5924 66.008 154.422 69.958 151.752 75.278C149.0822 80.772 145.745 89.356 142.0738 101.202C132.3958 88.67 124.8868 79.57 119.3802 73.906C113.8736 68.24 109.3682 64.464 105.6972 62.746C102.0262 61.03 98.1884 60.172 94.0166 60.172C89.6782 60.172 86.3408 61.374 83.838 63.948C81.335 66.524 80 69.786 80 73.734C80 77.854 81.335 81.46 84.0048 84.206C86.6746 86.952 90.1788 88.326 94.3504 88.326C96.5196 88.326 99.0226 87.64 101.8594 86.438C105.8642 84.378 108.8678 83.348 110.7032 83.348C113.2062 83.348 115.3754 83.862 117.211 84.892C119.714 86.094 122.7176 88.842 126.5554 92.962C128.8916 95.536 133.23 101.03 139.404 109.442C131.3946 139.3132 125.2204 157.1674 120.882 163.0042C118.0452 166.7812 114.5412 168.6696 110.2026 168.6696C108.0334 168.6696 105.1966 168.3262 102.0262 167.6394L102.8606 172.2746L146.0786 179.8284C153.9214 167.4678 159.4278 153.734 162.2646 138.97C170.441 150.9872 176.4482 159.5708 180.6198 164.3776C186.1264 170.9012 190.7986 175.1932 194.3028 177.0816C197.9738 178.97 201.812 180 205.816 180C210.488 180 213.826 178.7982 216.328 176.2232C218.832 173.8198 220 170.3862 220 166.0944C220 162.146 218.832 158.8842 216.328 156.309C213.992 153.734 210.99 152.5322 207.318 152.5322C204.816 152.5322 201.644 152.8756 198.3076 153.9056C194.8034 154.764 192.4672 155.279 191.1322 155.279C187.795 155.279 184.4576 154.0772 181.2872 151.5022C176.9488 148.0686 171.776 140.6866 165.435 129.5278C172.4434 104.292 178.1168 89.012 182.2884 83.348C184.7914 80.258 187.2944 78.54 189.7974 78.54C191.7998 78.54 193.8022 79.228 195.304 80.258C197.64 82.146 201.312 86.438 206.318 93.476z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PasteVariable.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PasteVariable.displayName = "Blueprint5.Icon.PasteVariable";
exports.default = PasteVariable;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fy2GF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PathSearch", ()=>PathSearch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PathSearch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "path-search",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 260C69 260 60 251 60 240C60 229 69 220 80 220S100 229 100 240C100 251 91 260 80 260zM380 26.2L280 76.2V148.8C273.6 146.6 266.8 144.4 260 143V76.6L140 25.1999999999999V170.2C132.8 175.6 126.2 181.6 120 188.2V26.2L20 76.2V200C31 200 40 209 40 220C40 231 31 240 20 240V373.8L88.6 339.6C90.8 345.8 93.4 352 96.4 358L14.4 399L14.4 399C13 399.6 11.6 400 10 400C4.4 400 0 395.6 0 390V70C0 66 2.4 62.8 5.6 61.2L5.6 61.2L125.6 1.2L125.6 1.2C127 0.4 128.4 0 130 0C131.4 0 132.8 0.2 134 0.8L134 0.8L269.8 59L385.6 1L385.6 1C387 0.4 388.4000000000001 0 390 0C395.6 0 400 4.4 400 10V94.2000000000001C393.8 91.6 387.2 90 380 90V26.2zM200 300C189 300 180 291 180 280C180 269 189 260 200 260S220 269 220 280C220 291 211 300 200 300zM260 320C249 320 240 311 240 300C240 289 249 280 260 280S280 289 280 300C280 311 271 320 260 320zM394.4 338.8L394.4 338.8L365.8 353.2C369.8 344.6 373 335.4 375.4 326L380 323.8V290C369 290 360 281 360 270C360 259 369 250 380 250V210.8L400 190.8V330C400 334 397.6 337.2 394.4 338.8zM320.6 227.6C323.4000000000001 231.8000000000001 326 236 328.2 240.6C328.6 241.4000000000001 329 242.0000000000001 329.2000000000001 242.8000000000001C331.4 247.2 333.2 251.8000000000001 334.8000000000001 256.6C334.8000000000001 256.6 334.8000000000001 256.6 334.8000000000001 256.8000000000001C336.2000000000001 261.6 337.4000000000001 266.4000000000001 338.2000000000001 271.4000000000001C338.4000000000001 272.6 338.6000000000001 273.6 338.8000000000001 274.8000000000001C339.6 279.8 340 284.8 340 290C340 350.8 290.8 400 230 400C169.2 400 120 350.8 120 290S169.2 180 230 180C235.2 180 240.2 180.4 245.2 181.2C246.4 181.4 247.4 181.6 248.6 181.8C253.6 182.6 258.4 183.8 263.2 185.2C263.2 185.2 263.2 185.2 263.4 185.2C268.2 186.8 272.8 188.6 277.2 190.8C278 191.2 278.6 191.4 279.4 191.8C284 194 288.2 196.6 292.4 199.4L296 195.8L296 195.8L366 125.8C369.4 122.2 374.4 120 380 120C391 120 400 129 400 140C400 145.6 397.8 150.6 394.2000000000001 154.2L320.6 227.6zM230 210C185.8 210 150 245.8 150 290C150 334.2 185.8 370 230 370C274.2000000000001 370 310 334.2 310 290C310 245.8 274.2000000000001 210 230 210z" : "M300 27.6L220 75.6V124.6C213.6 122.8 206.8 121.6 200 121V75.6L120 27.6V145.8C112.4 152 105.6 159 100 167V27.6L20 75.6V160C31 160 40 169 40 180C40 191 31 200 20 200V292.4L83 254.6C84.6 261.4 86.6 267.8 89.4 274L15.2 318.6L15.2 318.4C13.6 319.4 11.8 320 10 320C4.4 320 0 315.6 0 310V70C0 66.4 2 63.4 5 61.6L5 61.4L105 1.4L105 1.6C106.4 0.6 108.2 0 110 0S113.6 0.6 115 1.6L115 1.4L209.8 58.4L304.6 1.4L304.6 1.6C306.4 0.6 308.2 0 310 0C315.6 0 320 4.4 320 10V85.6C314 82.2 307.4 80 300 80V27.6zM40 220C40 209 49 200 60 200S80 209 80 220C80 231 71 240 60 240S40 231 40 220zM160 240C149 240 140 231 140 220C140 209 149 200 160 200S180 209 180 220C180 231 171 240 160 240zM315 258.4L315 258.4L291.2 272.8C294.8 264.2 297 254.8 298.4 245.2L300 244.4V176.6L320 156.6V250C320 253.6 318 256.6 315 258.4zM200 280C189 280 180 271 180 260C180 249 189 240 200 240S220 249 220 260C220 271 211 280 200 280zM266 182.2C274.8 196.2 280 212.4 280 230C280 279.8 239.8 320 190 320S100 279.8 100 230S140.2 140 190 140C207.6 140 223.8 145.2 237.8 154L286 105.8C289.4000000000001 102.2 294.4000000000001 100 300 100C311 100 320 109 320 120C320 125.6 317.8 130.6 314.2000000000001 134.2L266 182.2zM190 160C151.4 160 120 191.4 120 230S151.4 300 190 300S260 268.6 260 230S228.6 160 190 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PathSearch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PathSearch.displayName = "Blueprint5.Icon.PathSearch";
exports.default = PathSearch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bRXae":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Path", ()=>Path);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Path = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "path",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 400H40C18 400 0 382 0 360C0 338 18 320 40 320H180V240H80C58 240 40 222 40 200C40 178 58 160 80 160H180V80H120C98 80 80 62 80 40C80 18 98 0 120 0H280C302 0 320 18 320 40C320 62 302 80 280 80H220V160H320C342 160 360 178 360 200C360 222 342 240 320 240H220V320H360C382 320 400 338 400 360C400 382 382 400 360 400z" : "M290 320H30C13.4 320 0 306.6 0 290S13.4 260 30 260H140V200H70C53.4 200 40 186.6 40 170S53.4 140 70 140H140V80H110C93.4 80 80 66.6 80 50S93.4 20 110 20H210C226.6 20 240 33.4 240 50S226.6 80 210 80H180V140H250C266.6 140 280 153.4 280 170S266.6 200 250 200H180V260H290C306.6 260 320 273.4 320 290S306.6 320 290 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Path.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Path.displayName = "Blueprint5.Icon.Path";
exports.default = Path;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"glhIV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pause", ()=>Pause);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Pause = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "pause",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140 340H80C69 340 60 331 60 320V80C60 69 69 60 80 60H140C151 60 160 69 160 80V320C160 331 151 340 140 340zM320 340H260C249 340 240 331 240 320V80C240 69 249 60 260 60H320C331 60 340 69 340 80V320C340 331 331 340 320 340z" : "M120 260H80C69 260 60 251 60 240V80C60 69 69 60 80 60H120C131 60 140 69 140 80V240C140 251 131 260 120 260zM240 260H200C189 260 180 251 180 240V80C180 69 189 60 200 60H240C251 60 260 69 260 80V240C260 251 251 260 240 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Pause.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Pause.displayName = "Blueprint5.Icon.Pause";
exports.default = Pause;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gX8VC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "People", ()=>People);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var People = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "people",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M338.8 60C337.6 66.6 335.4 73.8 332.2000000000001 81.2C323.2000000000001 100.6 304.8000000000001 111.6 267.4000000000001 127.2C264.0000000000001 128.6 252.2000000000001 133.4 252.0000000000001 133.6C250.0000000000001 134.4 248.0000000000001 135.2 246.4000000000001 136C247.4000000000001 138.8 247.2000000000001 141.8 247.6000000000001 145C247.6000000000001 146 247.8000000000001 147.2 247.8000000000001 148.2C242.8000000000001 152.4 238.4000000000001 157.8 234.8000000000001 164C239.2000000000001 170.8 243.0000000000001 178.2 246.0000000000001 186.4L246.8000000000001 188.6C246.6000000000001 188.2 246.6000000000001 188.2 246.4000000000001 187C246.8000000000001 188 247.2000000000001 189 247.6000000000001 190C254.8000000000001 195.2 259.6000000000001 203.4 262.0000000000001 212.6C265.6000000000001 220 267.8000000000001 229 267.0000000000001 238.6C266.0000000000001 248.6 262.8000000000001 257 257.6000000000001 263C257.2000000000001 273.6 256.4000000000001 285.2 255.2000000000001 294.8C262.8 298.2 271.8 300 280 300C291.8 300 305.2 296.2 314.6 289C323.8 282 330.6 272 334 261C334.8 258.4 335.4 256 335.6 253.4C337.2 244.4 338.2 230.6 338.2 221.2C338.2 220.8 338.2 220.2 338.2 219.8C341.3999999999999 218.4 344.3999999999999 215 345.2 207.4C345.6 201.6 343.4 196.4 342.2 194.4C341.2 189.2 338.2 183.8 333 182.6C332.4 180.2000000000001 331.6 177.6 330.8 175.4C330.6 175.2000000000001 330.6 174.6000000000001 330.6 174.6000000000001C326.6 164.0000000000001 320.3999999999999 154.6000000000001 312.8 147.8000000000001C312.8 146.6 312.8 145.4000000000001 313 144.4C313.7999999999999 136.2000000000001 310.8 130.2000000000001 333 120.6000000000001C355 110.6000000000001 388.4 100.4000000000001 395.6 84.8000000000001C402.4 69.0000000000001 399.5999999999999 59.8000000000001 399.5999999999999 59.8000000000001H338.8zM230.4 121.2C259.8 108 304.4 94.2000000000001 314 73.4C323 52.4 319.4 40 319.4 40H0.8C0.8 40 -3 52.4 6.2 73.4C15.4 94.4 59.8 108.4 89.4 121.4C119 134.4 116 142.4 117 153.2000000000001C117 154.6000000000001 117.2 156.0000000000001 117.2 157.4000000000001C106.8 166.4 98.2 179.0000000000001 92.8 193.4000000000001L92.6 193.6000000000001C92.6 193.8000000000001 92.4 194.0000000000001 92.4 194.2000000000001C91 197.2 90 200.6 89.2 204C82.4 205.2 78.4 212.6 76.8 219.6C75.2 222.4 72 229.2 72.8 237C73.8 247.2 78 251.8 82.6 253.6C82.6 254.2 82.6 254.6 82.6 255.2C82.6 268 83.6 286.2 86 298.2C86.4 301.6 87.2 305 88.2 308.2C92.6 323 101.8 336.2 114 345.4C126.4 355 144.2 360 160 360S193.6 355 206.2 345.4C218.6 336.2 227.6 322.8 232.0000000000001 308.2C233.0000000000001 304.8 233.8 301.6 234.2 298.2C236.4 286.2000000000001 237.6 267.8 237.6 255.2C237.6 254.6 237.6 254 237.6 253.4C242.0000000000001 251.6 246 247 247.0000000000001 237C247.6 229.2 244.6000000000001 222.4 243.0000000000001 219.6C241.6 212.8 237.6000000000001 205.4 230.8000000000001 204C230.0000000000001 200.8 229.0000000000001 197.4 227.8000000000001 194.4C227.6000000000001 194.2 227.4000000000001 193.4 227.4000000000001 193.4C222.0000000000001 179.2 213.8000000000001 166.8 203.6000000000001 157.8C203.6000000000001 156.2 203.6000000000001 154.6 203.8000000000001 153.2C204.8 142.2 200.8 134.2000000000001 230.4 121.2z" : "M273.8 40.4C272.8 45.2 271 50.4 268.8 55.6C261.6 72.8 246.4 82.2 215 95.6C212.2 96.8 203.2 100.6 203 100.6C198.8 102.4 195.8 103.6 193 105C193.4 107 193.4 109 193.6 111.2C193.6 112 193.8 112.8 193.8 113.8C192.4 115 191.2 116.2 190 117.6C194.4 124 198 131 200.8 138.6C201.2 139.8000000000001 201.2 139.8000000000001 201.4 140.6C207.2 145.2000000000001 211 152 213.2 159.8000000000001C216.4 166.4 218.2 174.4 217.4 183.0000000000001C216.8 191.0000000000001 214.2 198.2000000000001 210 203.6000000000001C209.6 214.2000000000001 208.6 226.2000000000001 207 234.4000000000001C206.8 235.6 206.6 236.8000000000001 206.4 238.2000000000001C211 239.4 216 240 220.8 240C230.6 240 241.8 236.8 249.6 230.8C257.2 225 263 216.8 265.6 207.4C266.2 205.4 266.6 203.2 267 201.2C268.4 193.8 269.2 182.4 269.2 174.6C269.2 174.2 269.2 173.8 269.2 173.6C272 172.4 274.6 169.4 275 163.4C275.4 158.4 273.6 154.4 272.4 152.6C271.3999999999999 148.4 269.2 143.8 264.8 143C264.3999999999999 141 263.7999999999999 139 263 137C263 136.8 262.8 136.4 262.8 136.4C259.3999999999999 127.6 254.2 119.8 247.8 114.2C247.8 113.2 247.8 112.2 247.8 111.4C248.3999999999999 104.4 246 99.6 264.3999999999999 91.4C283 83.2 310.8 74.6 316.3999999999999 61.4C322.2 48.2 319.8 40.6 319.8 40.6H273.8zM250.4 48C257.8 30.8 254.8 20.8 254.8 20.8H1.2C1.2 20.8 -1.6 30.8 5.6 48S48.2 76.6 71.8 87.2C95.2 98 92.8 104.4 93.6 113.2C93.6 114.2 93.8 115.4 93.8 116.6C85.6 123.6 78.8 133.8 74.4 145.6V145.8C74.4 145.8 74.2 146 74.2 146.2C73.4 148.6 72.4 151.4 71.8 154C66.2 155 63 161.2 61.8 166.8C60.6 169.2 58 174.6 58.6 181C59.4 189.2 62.8 193 66.4 194.6C66.4 195 66.4 195.4 66.4 195.8C66.4 206 67.4 221 69.2 230.6C69.6 233.2 70.2 236 71 238.6C74.4 250.6 81.8 261.2 91.4 268.8C101.4 276.6 115.6 280.8 128.2 280.8S155 276.6 165 268.8C174.6 261.2 182 250.6 185.4 238.4C186.2 235.8 186.8 233 187.2 230.4C189 220.8 190 206 190 195.8C190 195.4 190 194.8 190 194.4C193.6 192.8 196.8 189 197.4 181C198 174.6 195.6 169.2 194.2 166.8C193 161.2 190 155.2 184.6 154.2C184 151.6 183.2 149 182.2 146.4C182.2 146.2 182 145.6 182 145.6C177.6 134 171 124 163 116.6C163 115.4 163 114 163 113C163.8 104 160.6 97.6 184.2 87C207.8 76.4 243.2 65.2 250.4 48z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
People.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
People.displayName = "Blueprint5.Icon.People";
exports.default = People;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jszDF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Percentage", ()=>Percentage);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Percentage = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "percentage",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 200C266.8 200 240 173.2 240 140V100C240 66.8 266.8 40 300 40S360 66.8 360 100V140C360 173.2 333.2 200 300 200zM320 100C320 89 311 80 300 80S280 89 280 100V140C280 151 289 160 300 160S320 151 320 140V100zM160 260V300C160 333.2 133.2 360 100 360S40 333.2 40 300V260C40 226.8 66.8 200 100 200S160 226.8 160 260zM80 260V300C80 311 89 320 100 320S120 311 120 300V260C120 249 111 240 100 240S80 249 80 260zM300 340C300 351 291 360 280 360C272.4 360 265.8 355.8 262.4 349.6L102.8 70.2000000000001C101 67.2 100 63.8 100 60C100 49 109 40 120 40C127.6 40 134.2 44.2 137.6 50.4L297.4000000000001 329.8C299 332.8 300 336.2 300 340z" : "M120 200V240C120 262 102 280 80 280H60C38 280 20 262 20 240V200C20 178 38 160 60 160H80C102 160 120 178 120 200zM70 200C64.4 200 60 204.4 60 210V230C60 235.6 64.4 240 70 240S80 235.6 80 230V210C80 204.4 75.6 200 70 200zM260 160H240C218 160 200 142 200 120V80C200 58 218 40 240 40H260C282 40 300 58 300 80V120C300 142 282 160 260 160zM260 90C260 84.4 255.6 80 250 80S240 84.4 240 90V110C240 115.6 244.4 120 250 120S260 115.6 260 110V90zM240 260C240 271 231 280 220 280C212.6 280 206.2 276 202.6 270L82.8 70.4C81 67.4 80 63.8 80 60C80 49 89 40 100 40C107.4 40 113.8 44 117.4 50L237.2 249.6C239 252.6 240 256.2 240 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Percentage.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Percentage.displayName = "Blueprint5.Icon.Percentage";
exports.default = Percentage;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gpbHe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Person", ()=>Person);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Person = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "person",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M392.2 41.8C380.8 68.2 325.2 85.6 288.4 102C251.4 118.4 256.6 128.2 255.2 141.8C255 143.6 255 145.6 254.8 147.6C267.4 158.8 277.8 174.2 284.6 192C284.6 192 285 193 285 193.2C286.4 197 287.6 201 288.8 205.2C297.2 207 302.2 216.2 304 224.8C306 228.2 309.8 236.8 309 246.4C307.8 258.8 302.8 264.6 297.2 267C297.2 267.8 297.2 268.4 297.2 269.2000000000001C297.2 285 295.8 307.8 292.8 322.8C292.2 327 291.2 331.2000000000001 290 335.2000000000001C284.5999999999999 353.6 273.2 370 258 381.6C242.2 393.6 220 400 200.2 400S158.2 393.6 142.4 381.6C127.2 370 115.8 353.6 110.4 335.2C109.2 331.2 108.2 327 107.6 322.8C104.8 307.8 103.2 285 103.2 269.2C103.2 268.6 103.2 268 103.2 267.2000000000001C97.4 265 92.2 259.2 91 246.4C90.2 236.8 94 228.2 96 224.8C98 216 103 206.6 111.8 205.2C112.8 201 114.2 197 115.6 193.2C115.6 193 115.8 192.6 115.8 192.4L116 192C122.8 173.8 133.4 158.2 146.4 147C146.4 145.2 146.2 143.4 146 141.8C144.6 128.2 148.6 118.4 111.6 102S19.2 68.2 7.8 41.8C-3.6 15.4 1 0 1 0H399C399 0 403.6 15.4 392.2 41.8z" : "M313.6 33.6C304.4 54.6 260 68.6 230.4 81.6C200.8 94.6 204.8 102.6 203.8 113.4C203.6 114.8 203.6 116.4 203.6 118C213.8 127 222 139.4 227.4 153.6C227.4 153.6 227.6 154.4 227.8 154.6C229 157.6 230 161 230.8 164.2C237.6 165.6 241.6 173 243 179.8C244.6 182.6 247.6 189.4 247 197.2C246 207.2 242 211.8000000000001 237.6 213.6C237.6 214.2000000000001 237.6 214.8 237.6 215.4C237.6 228.0000000000001 236.3999999999999 246.4000000000001 234.2 258.4000000000001C233.8 261.8 233 265 232 268.4000000000001C227.6 283 218.6 296.4000000000001 206.4 305.6C193.6 315 175.8 320.2 160 320.2C144.2 320.2 126.4 315.2 113.8 305.6C101.6 296.2 92.6 283 88.2 268.4C87.2 265 86.4 261.8 86 258.4C83.6 246.4 82.6 228.2 82.6 215.4C82.6 214.8 82.6 214.4 82.6 213.8C77.8 212 73.6 207.4 72.6 197.2C72 189.6 75.2 182.8 76.6 180C78.2 173 82.2 165.6 89.2 164.4C90 161 91 157.8 92.2 154.6C92.2 154.4 92.4 154.2 92.4 154L92.6 153.8C98 139.4 106.6 126.8000000000001 117 117.8C117 116.4 116.8 115 116.8 113.6C115.8 102.8 118.8 94.8 89.4 81.8C59.8 68.8 15.4 54.8 6.2 33.8C-3 12.8 0.8 0.4 0.8 0.4H319.2C319 0.2 322.8 12.6 313.6 33.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Person.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Person.displayName = "Blueprint5.Icon.Person";
exports.default = Person;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"71006":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhoneCall", ()=>PhoneCall);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PhoneCall = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "phone-call",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M396.898 89.798C395.3 91.398 312.784 139.798 309.988 141.198C307.19 142.598 304.592 143.198 301.996 143.198C298.2 143.198 293.604 140.598 287.81 135.198C282.216 129.798 264.4340000000001 105.398 259.24 99.998C254.044 94.598 249.65 91.998 246.252 91.998C244.654 91.998 242.456 92.398 239.86 93.398C237.262 94.398 210.888 107.998 155.9454 156.398C101.0018 204.7972 93.8092 236.3968 93.4096 245.1966C93.4096 248.5966 96.007 252.9966 101.4014 258.1964C106.9956 263.1964 112.7898 268.3964 119.1832 272.9962000000001C125.5766 277.7962 131.3706 282.9962000000001 136.7652 288.596C142.1596 294.1960000000001 144.7568 298.9958000000001 144.7568 302.7958C144.7568 305.3958 144.1576 308.1958 142.759 310.7958C141.3604 313.5956 91.4116 396.19456 89.6136 397.99452C85.8174 401.59448 71.2324 399.99450118 63.84 395.99456C4.10136 363.5950000000001 -0.893518 319.9956 0.1054556 302.7958C1.10443 284.996 12.29294 191.198 103.9988 104.198C217.882 -4 297 0.2 302.1960000000001 0.2C319.578 0.2 372.5220000000001 9.8 395.1 64C398.296 71.6 401.294 85.398 396.898 89.798zM220 360C208 360 200 368 200 380.00002C200 392.00002 208 400.00001678518 220 400.0000157361C320 400.00000699382 400 320 400 220C400 208 392 200 380 200C368 200 360 208 360 220C360 298 298 360 220 360zM220 280C208 280 200 288 200 300C200 312 208 320 220 320C276 320 320 276 320 220C320 208 312 200 300 200C288 200 280 208 280 220C280 254 254 280 220 280z" : "M318.32 71.802C317.118 73 250.864 111.792 248.662 112.792C246.46 113.792 244.258 114.392 242.256 114.392C239.254 114.392 235.45 112.192 230.846 107.992C226.242 103.594 212.03 84.198 207.828 80C203.624 75.6 200.22 73.6 197.4182 73.6C196.0172 73.6 194.4158 74 192.4142 74.8C190.4124 75.6 169.1946 86.398 125.1576 125.1888C81.1206 163.7798 75.3158 189.1738 75.1156 196.1722C75.1156 198.9714 77.3174 202.3706 81.521 206.5698C85.9246 210.7688 90.5286 214.7678 95.5328 218.567C100.537 222.366 105.341 226.565 109.5444 230.964C113.9482 235.563 115.9498 239.362 115.9498 242.3614C115.9498 244.5608 115.3494 246.5604 114.3486 248.7598C113.3476 250.7594 73.314 316.9439 71.9128 318.3435820000001C68.9104 321.342882 57.1004 319.9432084 51.0954 316.74396C3.25522 290.75 -0.547978 255.9582 0.0525274 242.1614C0.8532 227.9648000000001 9.86076 152.9822 83.3224 83.198C174.5992 -3.382 238.052 0.018 242.256 0.018C256.068 0.018 298.704 7.616 316.718 51.006C319.32 57.404 321.722 68.402 318.32 71.802zM260 180C260 168 252 160 240 160C228 160 220 168 220 180C220 202 202 220 180 220C168 220 160 228 160 240C160 252 168 260 180 260C224 260 260 224 260 180zM320 180C320 168 312 160 300 160C288 160 280 168 280 180C280 236 236 280 180 280C168 280 160 288 160 300.00002C160 312.00002 168 320.00001328826 180 320.00001223918C258 320.00000542022 320 258 320 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PhoneCall.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PhoneCall.displayName = "Blueprint5.Icon.PhoneCall";
exports.default = PhoneCall;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4oOYt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhoneForward", ()=>PhoneForward);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PhoneForward = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "phone-forward",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M396.898 89.798C395.3 91.398 312.784 139.798 309.988 141.198C307.19 142.598 304.592 143.198 301.996 143.198C298.2 143.198 293.604 140.598 287.81 135.198C282.216 129.798 264.4340000000001 105.398 259.24 99.998C254.044 94.598 249.65 91.998 246.252 91.998C244.654 91.998 242.456 92.398 239.86 93.398C237.262 94.398 210.888 107.998 155.9454 156.398C101.0018 204.7972 93.8092 236.3968 93.4096 245.1966C93.4096 248.5966 96.007 252.9966 101.4014 258.1964C106.9956 263.1964 112.7898 268.3964 119.1832 272.9962000000001C125.5766 277.7962 131.3706 282.9962000000001 136.7652 288.596C142.1596 294.1960000000001 144.7568 298.9958000000001 144.7568 302.7958C144.7568 305.3958 144.1576 308.1958 142.759 310.7958C141.3604 313.5956 91.4116 396.19456 89.6136 397.99452C85.8174 401.59448 71.2324 399.99450118 63.84 395.99456C4.10136 363.5950000000001 -0.893518 319.9956 0.1054556 302.7958C1.10443 284.996 12.29294 191.198 103.9988 104.198C217.882 -4 297 0.2 302.1960000000001 0.2C319.578 0.2 372.5220000000001 9.8 395.1 64C398.296 71.6 401.294 85.398 396.898 89.798zM220 260H331.6L305.8 234.2C302 230.4 299.8 225.4 299.8 220C299.8 209 308.8 200 319.8 200C325.4 200 330.4 202.2 334 205.8L394 265.8C397.6 269.4 399.8 274.4 399.8 280C399.8 285.6 397.6 290.6 394 294.2L334 354.2C330.4 357.8 325.4 360 319.8 360C308.8 360 299.8 351 299.8 340C299.8 334.4 302 329.4 305.6 325.8L331.6 300H220C209 300 200 291 200 280C200 269 209 260 220 260z" : "M318.32 71.802C317.118 73 250.864 111.792 248.662 112.792C246.46 113.792 244.258 114.392 242.256 114.392C239.254 114.392 235.45 112.192 230.846 107.992C226.242 103.594 212.03 84.198 207.828 80C203.624 75.6 200.22 73.6 197.4184 73.6C196.0172 73.6 194.4158 74 192.4142 74.8C190.4124 75.6 169.1946 86.398 125.1576 125.1888C81.1206 163.7798 75.3158 189.1738 75.1156 196.1722C75.1156 198.9714 77.3174 202.3708 81.521 206.5698C85.9246 210.7688 90.5286 214.7678 95.5328 218.567C100.537 222.366 105.341 226.565 109.5444 230.964C113.9482 235.563 115.9498 239.362 115.9498 242.3614C115.9498 244.5608 115.3494 246.5604 114.3486 248.7598C113.3476 250.7594 73.314 316.9439 71.9128 318.3435820000001C68.9104 321.342882 57.1004 319.9432084 51.0954 316.74396C3.25522 290.75 -0.547978 255.9582 0.0525274 242.1614C0.8532 227.9648000000001 9.86076 152.9822 83.3224 83.198C174.5992 -3.382 238.052 0.018 242.256 0.018C256.068 0.018 298.704 7.616 316.718 51.006C319.32 57.404 321.722 68.402 318.32 71.802zM314.2000000000001 234L274.2000000000001 274C270.6 277.8 265.6 280 260 280C249 280 240 271 240 260C240 254.4 242.2 249.4 245.8 245.8L251.6 240H180C169 240 160 231 160 220C160 209 169 200 180 200H251.8L246 194.2C242.4 190.6 240.2 185.6 240.2 180C240.2 169 249.2 160 260.2 160C265.8 160 270.8 162.2 274.4000000000001 165.8L314.4000000000001 205.8C318 209.4 320.2000000000001 214.4 320.2000000000001 220C320.2000000000001 225.6 317.8 230.4 314.2000000000001 234z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PhoneForward.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PhoneForward.displayName = "Blueprint5.Icon.PhoneForward";
exports.default = PhoneForward;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7zQpv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Phone", ()=>Phone);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Phone = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "phone",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M398.2 89.8C396.6 91.4 314 139.8 311.2 141.2C308.4 142.6 305.8 143.2 303.2 143.2C299.4000000000001 143.2 294.8 140.6 289 135.2C283.4 129.8 265.6 105.4 260.4 100C255.2 94.6 250.8 92 247.4 92C245.8 92 243.6 92.4 241 93.4C238.4 94.4 212 108 157 156.4C102 204.8 94.8 236.4 94.4 245.2C94.4 248.6 97 253 102.4 258.2000000000001C108 263.2 113.8 268.4 120.2 273C126.6 277.8 132.4 283 137.8 288.6C143.2 294.2000000000001 145.8 299 145.8 302.8C145.8 305.4 145.2 308.2 143.8 310.8C142.4 313.6 92.4 396.2 90.6 398C86.8 401.6 72.2 400 64.8 396C5 363.6 0 320 1 302.8C2 285 13.2 191.2 105 104.2000000000001C219 -4 298.2 0.2 303.4 0.2C320.8 0.2 373.8 9.8000000000001 396.4 64.0000000000001C399.6 71.6 402.6 85.4 398.2 89.8z" : "M318 71.8C316.8 73 250.6 111.8 248.4 112.8C246.2 113.8 244 114.4 242 114.4C239 114.4 235.2 112.2 230.6 108C226 103.6 211.8 84.2 207.6 80C203.4 75.6 200 73.6 197.2 73.6C195.8 73.6 194.2 74 192.2 74.8C190.2 75.6 169 86.4 125 125.2C81 163.8 75.2 189.2 75 196.2C75 199 77.2 202.4 81.4 206.6C85.8 210.8 90.4 214.8 95.4 218.6C100.4 222.4 105.2 226.6 109.4 231C113.8 235.6 115.8 239.4 115.8 242.4C115.8 244.6 115.2 246.6 114.2 248.8C113.2 250.8 73.2 317 71.8 318.4C68.8 321.4 57 320 51 316.8C3.2 290.8 -0.6 256 0 242.2C0.8 228 9.8 153 83.2 83.2C174.4 -3.4 237.8 0 242 0C255.8 0 298.4 7.6 316.4 51C319 57.4 321.4 68.4 318 71.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Phone.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Phone.displayName = "Blueprint5.Icon.Phone";
exports.default = Phone;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fxTxf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PieChart", ()=>PieChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PieChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "pie-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M180 380.4C90 370.4 20 294.2000000000001 20 201.6C20 102.2 100.6 20.8 200 20.8C292.6 20.8 368.8 100 378.8 180H180V380.4zM200 401.6V200H400C400 320 310.4 401.6 200 401.6z" : "M140 298.4C72.6 288.4 20.6 230.4 20.6 160C20.6 82.6 83.2 20 160.2 20C230.6 20 288.6 72.2 298.4 140H140V298.4zM160 320V160H320C320 248.4 248.4 320 160 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PieChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PieChart.displayName = "Blueprint5.Icon.PieChart";
exports.default = PieChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"axJ1i":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pill", ()=>Pill);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Pill = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "pill",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100 300H200C211.046 300 220 291.0456 220 280V120C220 108.954 211.046 100 200 100H100C44.7716 100 0 144.772 0 200C0 255.2284 44.7716 300 100 300zM240 285.4546000000001C240 293.4878 246.512 300 254.546 300H300C355.2280000000001 300 400 255.2284 400 200C400 144.772 355.2280000000001 100 300 100H254.546C246.512 100 240 106.512 240 114.546V285.4546000000001zM300 140C333.1380000000001 140 360 166.862 360 200C360 233.137 333.1380000000001 260 300 260H280V140H300z" : "M80 240H145.4546C153.4878 240 160 233.4878 160 225.4546V94.546C160 86.512 153.4878 80 145.4546 80H80C35.8172 80 0 115.818 0 160C0 204.1828 35.8172 240 80 240zM320 160C320 115.818 284.182 80 240 80H192.7272C185.6982 80 180 85.698 180 92.728V227.2728C180 234.3018 185.6982 240 192.7272 240H240C284.182 240 320 204.1828 320 160zM240 200H220V120H240C262.092 120 280 137.9086 280 160S262.092 200 240 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Pill.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Pill.displayName = "Blueprint5.Icon.Pill";
exports.default = Pill;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"nrrGD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pin", ()=>Pin);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Pin = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "pin",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M235.4 376.8C219.2 360.6 220.6 331.2000000000001 235.8 301.6L122 225.8C78.6 255 39.6 265.8 23.2 249.4L122.2 150.4L23.2 23.2L150.4 122.2L249.4 23.2C265.8 39.6 254.8 78.6 225.6 122L301.6 235.8000000000001C331 220.6000000000001 360.4000000000001 219.0000000000001 376.8000000000001 235.4000000000001L235.4 376.8z" : "M188.2 301.6C178 291.4 180 271.6 191.2 250.4L86.8 169.2C56 190.4 29 199 18.4 188.4L89.2 117.6L18.4 18.6L117.4 89.4L188.2 18.6C198.8 29.2 190.2 56.2 169 87L250.2 191.4C271.4 180.2 291 178.2 301.2 188.4L188.2 301.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Pin.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Pin.displayName = "Blueprint5.Icon.Pin";
exports.default = Pin;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7tE41":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PivotTable", ()=>PivotTable);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PivotTable = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "pivot-table",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 300H20C9 300 0 291 0 280V20C0 9 9 0 20 0H60C71 0 80 9 80 20V280C80 291 71 300 60 300zM60 400H20C9 400 0 391 0 380V340C0 329 9 320 20 320H60C71 320 80 329 80 340V380C80 391 71 400 60 400zM334.2000000000001 294.2C330.6 297.8 325.6 300 320 300S309.4000000000001 297.8 305.8 294.2L245.8 234.2C242.2 230.6 240 225.6 240 220C240 209 249 200 260 200C265.6 200 270.6 202.2 274.2000000000001 205.8L300 231.8V180C300 135.8 264.2000000000001 100 220 100H168.2L194 125.8C197.8 129.4 200 134.4 200 140C200 151 191 160 180 160C174.4 160 169.4 157.8 165.8 154.2L105.8 94.2000000000001C102.2 90.6 100 85.6 100 80C100 74.4 102.2 69.4 105.8 65.8L165.8 5.8C169.4 2.2 174.4 0 180 0C191 0 200 9 200 20C200 25.6 197.8 30.6 194.2 34.2L168.2 60H220C286.2 60 340 113.8 340 180V231.8L365.8 206C369.4 202.2 374.4 200 380 200C391 200 400 209 400 220C400 225.6 397.8 230.6 394.2000000000001 234.2L334.2000000000001 294.2zM380 400H120C109 400 100 391 100 380V340C100 329 109 320 120 320H380C391 320 400 329 400 340V380C400 391 391 400 380 400z" : "M40 240H20C9 240 0 231 0 220V20C0 9 9 0 20 0H40C51 0 60 9 60 20V220C60 231 51 240 40 240zM40 320H20C9 320 0 311 0 300V280C0 269 9 260 20 260H40C51 260 60 269 60 280V300C60 311 51 320 40 320zM274.2000000000001 234.2C270.6 237.8 265.6 240 260 240S249.4 237.8 245.8 234.2L205.8 194.2C202.2 190.6 200 185.6 200 180C200 169 209 160 220 160C225.6 160 230.6 162.2 234.2 165.8L240 171.8V140C240 106.8 213.2 80 180 80H148.2L154 85.8C157.8 89.4 160 94.4 160 100C160 111 151 120 140 120C134.4 120 129.4 117.8 125.8 114.2L85.8 74.2C82.2 70.6 80 65.6 80 60C80 54.4 82.2 49.4 85.8 45.8L125.8 5.8C129.4 2.2 134.4 0 140 0C151 0 160 9 160 20C160 25.6 157.8 30.6 154.2 34.2L148.2 40H180C235.2 40 280 84.8 280 140V171.8L285.8 166C289.4000000000001 162.2 294.4000000000001 160 300 160C311 160 320 169 320 180C320 185.6 317.8 190.6 314.2000000000001 194.2L274.2000000000001 234.2zM300 320H100C89 320 80 311 80 300V280C80 269 89 260 100 260H300C311 260 320 269 320 280V300C320 311 311 320 300 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PivotTable.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PivotTable.displayName = "Blueprint5.Icon.PivotTable";
exports.default = PivotTable;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGc7U":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pivot", ()=>Pivot);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Pivot = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "pivot",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M116.6 205L5.8 94.2000000000001C2.2 90.6 0 85.6 0 80C0 69 9 60 20 60C25.6 60 30.6 62.2 34.2 65.8L145 176.6C133.6 184 124 193.6 116.6 205zM380 180C369 180 360 171 360 160V128.2L283.4 204.8C276 193.6 266.4 184 255.2 176.6L331.8 100H300C289 100 280 91 280 80C280 69 289 60 300 60H380C391 60 400 69 400 80V160C400 171 391 180 380 180zM280 260C280 304.2 244.2 340 200 340S120 304.2 120 260C120 215.8 155.8 180 200 180S280 215.8 280 260zM200 220C178 220 160 238 160 260S178 300 200 300S240 282 240 260S222 220 200 220z" : "M91.4 179.6L6 94.2C2.2 90.6 0 85.6 0 80C0 69 9 60 20 60C25.6 60 30.6 62.2 34.2 65.8L119.6 151.2C108 158.2 98.2 168 91.4 179.6zM300 160C289 160 280 151 280 140V128.2L228.6 179.6C221.8 168 212 158.2 200.4 151.4L251.8 100H240C229 100 220 91 220 80C220 69 229 60 240 60H300C311 60 320 69 320 80V140C320 151 311 160 300 160zM220 220C220 253.2 193.2 280 160 280S100 253.2 100 220S126.8 160 160 160S220 186.8 220 220zM160 200C149 200 140 209 140 220C140 231 149 240 160 240S180 231 180 220C180 209 171 200 160 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Pivot.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Pivot.displayName = "Blueprint5.Icon.Pivot";
exports.default = Pivot;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kfLZj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Play", ()=>Play);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Play = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "play",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 200C320 207.2 316 213.4 310.2 216.8L310.4 217L110.4 337L110.2 336.8C107.2 338.6 103.8 340 100 340C89 340 80 331 80 320V80C80 69 89 60 100 60C103.8 60 107.2 61.4 110.2 63.2L110.4 63L310.4 183L310.2 183.2C316 186.6 320 192.8 320 200z" : "M240 160C240 167 236.2 172.8 230.8 176.4L231 176.8L111 256.8L110.8 256.4C107.8 258.4 104.2 260 100 260C89 260 80 251 80 240V80C80 69 89 60 100 60C104.2 60 107.8 61.6 110.8 63.6L111 63.2L231 143.2L230.8 143.6C236.2 147.2 240 153 240 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Play.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Play.displayName = "Blueprint5.Icon.Play";
exports.default = Play;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lc37U":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Playbook", ()=>Playbook);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Playbook = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "playbook",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M34.1422 394.14214C26.3316 401.952622 13.66834 401.952622 5.85786 394.14214C-1.952622 386.33166 -1.952622 373.6684 5.85786 365.8578L41.7158 330L5.85786 294.1422C-1.95262 286.3316 -1.95262 273.6684 5.85786 265.8578C13.66834 258.0474000000001 26.3316 258.0474000000001 34.1422 265.8578L70 301.7158L105.8578 265.8578C113.6684 258.0474000000001 126.3316 258.0474000000001 134.1422 265.8578C141.9526 273.6684 141.9526 286.3316 134.1422 294.1422L98.2842 330L134.1422 365.8578C141.9526 373.6684 141.9526 386.33166 134.1422 394.14214C126.3316 401.952622 113.6684 401.952622 105.8578 394.14214L70 358.2842L34.1422 394.14214zM320 0C364.182 0 400 35.818 400 80C400 124.182 364.182 160 320 160C275.818 160 240 124.182 240 80C240 35.818 275.818 0 320 0zM320 40C342.0920000000001 40 360 57.908 360 80C360 102.092 342.0920000000001 120 320 120C297.908 120 280 102.092 280 80C280 57.908 297.908 40 320 40zM365.8 286L320 331.8V240C320 206.863 293.1380000000001 180 260 180H80C68.9544 180 60 171.046 60 160V20C60 8.954 51.0456 0 40 0C28.9544 0 20 8.954 20 20V160C20 193.138 46.863 220 80 220H260C271.046 220 280 228.9544 280 240V331.8L234.2 285.8C230.6 282.2 225.6 280 220 280C209 280 200 289 200 300C200 305.6 202.2 310.6 205.8 314.2L285.8 394.2C289.4000000000001 397.8 294.4000000000001 399.999999701976 300 399.999999701976C305.6 399.999999701976 310.6 397.8 314.2000000000001 394.2L394.2000000000001 314.2C397.8 310.6 400 305.6 400 300C400 289 391 280 380 280C374.4 280 369.4 282.2 365.8 286z" : "M85.8578 314.14214C93.6684 321.952622 106.3316 321.952622 114.1422 314.14214C121.9526 306.33166 121.9526 293.6684 114.1422 285.8578L88.2842 260L114.1422 234.1422C121.9526 226.3316 121.9526 213.6684 114.1422 205.8578C106.3316 198.0474 93.6684 198.0474 85.8578 205.8578L60 231.7158L34.1422 205.8578C26.3316 198.0474 13.66836 198.0474 5.85786 205.8578C-1.952622 213.6684 -1.952622 226.3316 5.85786 234.1422L31.7158 260L5.85788 285.8578C-1.952614 293.6684 -1.952614 306.33166 5.85788 314.14214C13.66836 321.952622 26.3316 321.952622 34.1422 314.14214L60 288.2842L85.8578 314.14214zM285.8 225.8L260 251.8V200C260 166.863 233.138 140 200 140H80C68.9544 140 60 131.0456 60 120V20C60 8.954 51.0456 0 40 0C28.9544 0 20 8.954 20 20V120C20 153.137 46.863 180 80 180H200C211.046 180 220 188.9544 220 200V251.8L194.2 226C190.6 222.2 185.6 220 180 220C169 220 160 229 160 240C160 245.6 162.2 250.6 165.8 254.2L225.8 314.2C229.4 317.8 234.4 319.999999701976 240 319.999999701976C245.6 319.999999701976 250.6 317.8 254.2 314.2L314.2000000000001 254.2C317.8 250.6 320 245.6 320 240C320 229 311 220 300 220C294.4000000000001 220 289.4000000000001 222.2 285.8 225.8zM320 60C320 26.862 293.1380000000001 0 260 0C226.862 0 200 26.862 200 60C200 93.138 226.862 120 260 120C293.1380000000001 120 320 93.138 320 60zM280 60C280 48.954 271.046 40 260 40C248.954 40 240 48.954 240 60C240 71.046 248.954 80 260 80C271.046 80 280 71.046 280 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Playbook.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Playbook.displayName = "Blueprint5.Icon.Playbook";
exports.default = Playbook;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9nkvz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Plus", ()=>Plus);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Plus = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "plus",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 220H220V320C220 331 211 340 200 340S180 331 180 320V220H80C69 220 60 211 60 200C60 189 69 180 80 180H180V80C180 69 189 60 200 60S220 69 220 80V180H320C331 180 340 189 340 200C340 211 331 220 320 220z" : "M260 180H180V260C180 271 171 280 160 280S140 271 140 260V180H60C49 180 40 171 40 160C40 149 49 140 60 140H140V60C140 49 149 40 160 40S180 49 180 60V140H260C271 140 280 149 280 160C280 171 271 180 260 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Plus.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Plus.displayName = "Blueprint5.Icon.Plus";
exports.default = Plus;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"528Cr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PolygonFilter", ()=>PolygonFilter);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PolygonFilter = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "polygon-filter",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 260C354.6 260 349.6 259 345 257L219.4 354.6C219.6 356.4 220 358.2 220 360C220 382 202 400 180 400S140 382 140 360C140 358.8 140.2 357.6 140.4 356.2L56.6 296.2000000000001C51.4 298.6 45.8 300 40 300C18 300 0 282 0 260C0 245.2 8 232.4000000000001 20 225.6V74.6C8 67.6 0 54.8 0 40C0 18 18 0 40 0C54.8 0 67.6 8 74.4 20H225.4C232.4 8 245 0 259.8 0C281.8 0 299.8 18 299.8 40C299.8 47.4 297.6 54.4 294 60.4L360.6 180C382.4000000000001 180.4 400 198 400 220C400 242 382 260 360 260zM259.4000000000001 80C245 79.8 232.4000000000001 71.8 225.6 60H74.4C71 66 66 71 60 74.4V225.6C72 232.4 80 245.2 80 260C80 261.2 79.8 262.4 79.6 263.8L163.4 323.8C168.6 321.4 174.2 320 180 320C185.4 320 190.4 321 195 323L320.6 225.4C320.4 223.6 320 221.8 320 220C320 212.6 322.2 205.6 325.8 199.6L259.4000000000001 80z" : "M280 220C275.2 220 270.6 219 266.4 217.4L199.4 273.2C199.6 275.4 200 277.6 200 280C200 302 182 320 160 320S120 302 120 280C120 279.2 120.2 278.4 120.2 277.6L57.6 235.8C52.2 238.4 46.4 240 40 240C18 240 0 222 0 200C0 185.2 8 172.4 20 165.6V74.6C8 67.6 0 54.8 0 40C0 18 18 0 40 0C54.8 0 67.6 8 74.4 20H165.4C172.4 8 185 0 199.8 0C221.8 0 239.8 18 239.8 40C239.8 47.4 237.6 54 234.2 60L280 140C302.2 140.2 320 158 320 180C320 202 302 220 280 220zM199.8 80C185.2 80 172.4 71.8 165.6 60H74.6C71 66 66 71 60 74.4V165.6C72 172.4 80 185.2 80 200C80 200.8 79.8 201.6 79.8 202.4L142.4 244.2C147.8 241.6 153.6 240 160 240C164.8 240 169.4 241 173.6 242.6L240.6 186.8C240.4 184.6 240 182.4 240 180C240 172.6 242.2 166 245.6 160L199.8 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PolygonFilter.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PolygonFilter.displayName = "Blueprint5.Icon.PolygonFilter";
exports.default = PolygonFilter;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5nm8G":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Power", ()=>Power);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Power = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "power",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 200C211 200 220 209 220 220V380C220 391 211 400 200 400S180 391 180 380V220C180 209 189 200 200 200zM260 349V305.8C307.2 283.4 340 235.8 340 180C340 102.6 277.4000000000001 40 200 40S60 102.6 60 180C60 235.8 92.8 283.4 140 305.8V349C70.2 324.2 20 258.2 20 180C20 80.6 100.6 0 200 0S380 80.6 380 180C380 258.2 329.8 324.2 260 349z" : "M160 160C171 160 180 169 180 180V300C180 311 171 320 160 320S140 311 140 300V180C140 169 149 160 160 160zM220 266.4V219.6C244.2 201.4 260 172.6 260 140C260 84.8 215.2 40 160 40S60 84.8 60 140C60 172.6 75.8 201.2 100 219.6V266.4C52.8 243.8 20 195.8 20 140C20 62.6 82.6 0 160 0S300 62.6 300 140C300 195.8 267.2 243.8 220 266.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Power.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Power.displayName = "Blueprint5.Icon.Power";
exports.default = Power;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dv95q":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PredictiveAnalysis", ()=>PredictiveAnalysis);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PredictiveAnalysis = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "predictive-analysis",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 239.8C400 265 387.8 288.4 367.8 302.2C357.2 350 316 384.2 268 384.2C256.4 384.2 245.2 382.2 234.2 378.4C220.8 392.2 202.6 400 183.4 400C161 400 140 389 126.4 371C123.4 371.4 120.4 371.6 117.4 371.6C84.8 371.6 56.8 349.2 48.2 317.4C19.4 307 0 279 0 246.8C0 237.2 1.8 227.8 5.2 218.8C1.8 210 0 200.6 0 191C0 163.4 14.4 138.2 37.8 125.2000000000001C51.2 111.2000000000001 69.6 103.4 88.6 103.4C100.8 103.4 112.4 106.4 122.8 112.4C136.4 96 156.4 86.4 177.4 86.4C190.6 86.4 203 90 214 96.8C226.2 87 240.8 80.6 256.2 78.6C282.2 50 302.2 13 302.4 12.6C302.4 12.6 309.4 0.4 309 0.4C328.2 0.6 344.4 4.4 341.8 26.4C342 26 323.4 84.2000000000001 323.4 84.2000000000001C333.8 89.4 342.2 98 347.6 108.8C370 122 384.4 147 384.4 174C384.4 180 383.8 186 382.4 191.8000000000001C393.8 204.6 400 222 400 239.8zM369.2000000000001 214.2L365.6 218.2H365.6L350.2000000000001 235C343.6000000000001 242.4 336.8 258.4 335.6 269.6C335.6 269.6 333.0000000000001 294.6 333.0000000000001 294.8C331.8000000000001 309.6 309.6 309.4 310.4000000000001 292C310.4000000000001 291.6 313.0000000000001 266.8 313.0000000000001 266.8C313.8000000000001 259.6 316.0000000000001 251.4 319.0000000000001 243.4C317.4000000000001 243.6 316.0000000000001 243.8 314.6000000000001 243.8C314.6000000000001 243.8 263.2000000000001 246.2 263.2000000000001 246.4C248.6000000000001 247 245.4000000000001 222 262.2000000000001 221.4C262.0000000000001 221.4 313.6000000000001 218.8 313.6000000000001 218.8C324.2000000000001 218.2 339.4000000000001 211.4 345.8000000000001 204.4L358.0000000000001 191L358.4000000000001 189.8C360.4000000000001 184.4 361.2000000000001 178.8 361.2000000000001 173.2C361.2000000000001 154.6 351 137.8 334.4000000000001 129.6L330.4000000000001 127.6L328.6000000000001 123C324.8000000000001 113.4 316.6000000000001 106.6 306.6000000000001 104.4L293.2000000000001 101.6L310.6000000000001 46.6C301.0000000000001 61.8 286.8000000000001 82.4 270.2000000000001 99.9999999999999L267.2000000000001 103.2L263.0000000000001 103.6C252.8000000000001 104.3999999999999 243.2000000000001 107.8 234.6000000000001 113.2L268.6 142.8C277.4000000000001 150.6 289.4000000000001 153.8 293.4000000000001 152.6C293.4000000000001 152.6 309 148.2 309 148C324.6 144 329.6 166.4 314.8 172.2C314.8 172.2 299.2000000000001 176.8 299.2000000000001 176.8C285.4000000000001 180.8 265.8 172.4 254.4 162.4L216.2 129.2L216.2 129.2L208.4 122.8C199.6 115.6 189.8 111.8 178.4 111.8C162.4 111.8 147.6 120 139 133.2V170.8C139 180.8 143.2 190.4 145.8 192.2C145.8 192.2 158.8 200.8 158.6 200.8C176 214.6 162.8 232.2 145.8 223.6C145.8 223.8 132.8 215 132.8 215C126.6 211 122 203.8 118.8 195.6C116.2 198.2 113.2 200.6 110.2 202.6C110.2 202.6 72 227.8 72 228.2C55.8 239.4 42 215.6 59.8 206C59.8 206.4 97.6 180.4 97.6 180.4C106.8 174.2 113 161 113 153.2000000000001V136.4C104.4 131.6 97.4 129.2000000000001 88.2 129.2000000000001C74.8 129.2000000000001 62 135.0000000000001 52.8 145.0000000000001L51.4 146.6000000000001L49.6 147.6000000000001C33.4 156.0000000000001 23.4 172.6000000000001 23.4 190.8000000000001C23.4 198.4000000000001 25.2 205.6000000000001 28.4 212.4000000000001L31.4 218.6000000000001L28.6 225.2C25.2 232 23.6 239.2 23.6 246.8C23.6 269.4 38.8 288.8 60.6 294.2L68.4 296L69.8 304.6C73.6 328.4 93.6 345.6 117.6 345.6C121.4 345.6 125.4 345.2 129.2 344.2L137.2 342.2L141.6 349.8C150.2 364.8 166.2 374 183.4 374C194.4 374 205 370.2 213.4 363.4L204.6 354.4L204.4 354.6L198.2 348.4C190 341.4 179.8 337.8 176 338.4C176 338.4 159.2 341 159.2 341.2C142.6 344.2 137.4 319.6 155.6 315.4C155.8 315.4 172.4 312.6 172.4 312.6C173 312.6 173.6 312.6 174.2 312.4C171.4 303.2 170.6 293.2 171.8000000000001 284.4C171.8000000000001 284.4 176.0000000000001 259.6 175.6 259.8C178.2000000000001 246.8 202 251 198.8 264.2C198.8 264.4 195 288.8 195 288.8C193.6 298.4 198 312.6 204 318.8L213.6 328.8C215 330 216.2 331.2000000000001 217.4 332.4L236 351.4C246 356 256.8 358.2 267.8 358.2C306.4 358.2 339.2 330.2 345.6 291.4L346.6 285.2000000000001L351.8 282.2C367 273.6 376.4 257.2000000000001 376.4 239.8C376.4 230.6 373.8 221.8 369.2000000000001 214.2z" : "M320 191.8C320 212 310.2 230.6 294.2000000000001 241.6C285.6 280 252.8 307.2 214.2 307.2C205 307.2 195.8 305.6 187.2 302.4C176.6 313.8 162.2 320 146.8 320C128.8 320 112 311.2 101.2 296.8C98.8 297 96.4 297.2 94 297.2C67.8 297.2 45.6 279.4 38.6 253.8C15.6 245.6 0 223.2 0 197.4C0 189.8 1.4 182.2 4.2 175C1.4 168 0 160.4 0 152.8C0 130.6 11.6 110.6 30.2 100.2000000000001C41 89 55.6 82.8 70.8 82.8C80.6 82.8 89.8 85.2000000000001 98.2 90C109 77 125 69.2 141.8 69.2C152.2 69.2 162.4 72 171.2 77.6C181 69.8 192.6 64.6 205 63C225.8 40 241.8 10.4 241.8 10.2C241.8 10.2 247.4 0.4 247 0.4C262.4 0.4 275.2 3.6 273.4 21.2C273.4 20.8 258.8 67.4 258.8 67.4C267 71.6 273.8 78.4 278.2 87C296.2 97.4 307.6 117.6 307.6 139.2C307.6 144 307 148.8 306 153.4C315 163.8 320 177.6 320 191.8zM295.4 171.4L292.4 174.6H292.4L280.2 188C274.8 193.8 269.4 206.8 268.6 215.8C268.6 215.8 266.6 235.8 266.6 236C265.6 247.8 247.8 247.6 248.4 233.8C248.4 233.4 250.4 213.6 250.4 213.6C251 207.8 252.8 201.2 255.2 195C254 195.2 252.8 195.4 251.6 195.4C251.6 195.4 210.4 197.4 210.6 197.6C199 198 196.4 178.2 209.8000000000001 177.6C209.6000000000001 177.6 250.8000000000001 175.4 250.8000000000001 175.4C259.2000000000001 175 271.6 169.4 276.6 163.8L286.4000000000001 153L286.8 152C288.4000000000001 147.8 289.2000000000001 143.2 289.2000000000001 138.8C289.2000000000001 124 281 110.6 267.8 103.8L264.6 102.2L263.2 98.6C260.2 90.9999999999999 253.6 85.4 245.6 83.8L234.8 81.6L248.8 37.6C241.2 49.8 229.8 66.2 216.3999999999999 80.4L214 83L210.6 83.2C202.4 83.8 194.5999999999999 86.6 187.8 90.8L215 114.4C221.9999999999999 120.6 231.6 123.2 234.8 122.2C234.8 122.2 247.4 118.8 247.2 118.6C259.8 115.4 263.7999999999999 133.4 251.8 138.0000000000001L239.4 141.6C228.3999999999999 144.8000000000001 212.8 138.0000000000001 203.5999999999999 130L173 103.4L173 103.4L166.7999999999999 98.2000000000001C159.7999999999999 92.4000000000001 151.7999999999999 89.4 142.7999999999999 89.4C130 89.4 118.1999999999999 96.0000000000001 111.1999999999999 106.6V137C111.1999999999999 145 114.5999999999999 152.8 116.5999999999999 154C116.5999999999999 154 126.9999999999999 160.8 126.7999999999999 161C140.9999999999999 171.6 130.3999999999999 185.6 116.9999999999999 178.8C116.9999999999999 179 106.5999999999999 171.8 106.5999999999999 171.8C101.4 168.8 97.6 163 95 156.4C92.8 158.6 90.6 160.4 88.2 162C88.2 162 57.6 182.2 57.6 182.4C44.6 191.4 33.6 172.2 47.8 164.6C47.8 164.8 78 144.2 78 144.2C85.4 139.4 90.4 128.6 90.4 122.4V109C83.6 105.2000000000001 77.8 103.2000000000001 70.6 103.2000000000001C59.8 103.2000000000001 49.6 107.8 42.4 115.8000000000001L41.4 117.0000000000001L40 117.8000000000001C27 124.6000000000001 19 137.8000000000001 19 152.4000000000001C19 158.4000000000001 20.4 164.4 23 169.8000000000001L25.4 174.8000000000001L23 180C20.4 185.4 19 191.2 19 197.4C19 215.4 31.2 231 48.6 235.2L54.8 236.8L55.8 243.6C58.8 262.6 74.8 276.4 94 276.4C97.2 276.4 100.2 276 103.4 275.2L109.8 273.6L113.4 279.8C120.4 291.8 133.2 299.2 146.8 299.2C155.6 299.2 164 296.2 170.8 290.8L163.6 283.6L163.6 283.8L158.6 278.6C152 273.2 143.8 270.2 140.8 270.6C140.8 270.6 127.4 272.6 127.4 272.8C114 275.4 110 255.6 124.6 252.4C124.8 252.4 138 250.2 138 250.2C138.4 250.2 139 250.2 139.4 250C137.2 242.6 136.4 234.6 137.4 227.6C137.4 227.6 140.8 207.8 140.4 207.8C142.6 197.4 161.6 200.6 159 211.4C159 211.6 156 231.2 156 231.2C155 238.6 158.4 250 163.2 255L171 263C172 264 173 264.8 174 265.8L188.8 281C196.8 284.6 205.4 286.4 214.2 286.4C245.2 286.4 271.4 264 276.4 233L277.2 228L281.4 225.6C293.6 218.6 301 205.6 301 191.6C301 184.4 299 177.6 295.4 171.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PredictiveAnalysis.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PredictiveAnalysis.displayName = "Blueprint5.Icon.PredictiveAnalysis";
exports.default = PredictiveAnalysis;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lD0nF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Prescription", ()=>Prescription);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Prescription = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "prescription",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M279 195.4C282.2 199 283.4 199.8 288.2 199.8H317.8C322.8 199.8 327.2 198.2 329.6 193.2C331.6 189.2 331.4 185 328.6 180L274.4 108.4L337.6 20C340.2 15.8 340.8 10.8 338.2 6.2C335.8 2 331.4 0 326.8 0H294C287.8 0 282.8 3.4 280 8.8L242 62.2L203.4 8.6C200.4 3.2 195 0 188.8 0H159.6C154.6 0 150.2 1.6 147.8 6.6C145.8 10.6 146 14.8 148.8 19.8L210.6 106.8L125.2 220H100V133.6C100 125.4 94 119.8 86 119.8H54C45.8 119.8 40 125.4 40 133.6V386.2C40 394.4 46 400 54 400H142.4C156.6 400 169.6 398 181.2 394C193 390 203.4 384.2 212 376.6C220.8 369 227.6 359.8 232.4000000000001 348.8C237.2 338 239.6 326 239.6 313.2C239.6 293 234.0000000000001 275.6 222.8 261.2000000000001C214.2 250.4 195.8 235.4 182.8 229.4L244.6 150.6L279 195.4zM134.2 279.2C148.4 279.2 163.2 282.4 170.4 288.4C177 294 180.4 302.2 180.4 313.4S177 332.8 170.4 338.4C163.4 344.4 148.4 347.6 134.2 347.6H100.2V279.2H134.2z" : "M218.2 153.2C221 157.4 225.4 160 230.8 160H256.6C261.0000000000001 160 264.8000000000001 158.6 267 154.8C268.8 151.6 268.6 148.2 266.2000000000001 144.2L216.4 86.8L271.8 16C274.2000000000001 12.6 274.6 8.6 272.2000000000001 5C270.0000000000001 1.6 266.2 0 262.2000000000001 0H233.4000000000001C228.0000000000001 0 223.6 2.8 221.2000000000001 7L188.0000000000001 49.8L154.2000000000001 6.8C151.6 2.6 147 0 141.6 0H116C111.6 0 107.8 1.4 105.6 5.2C103.8 8.4 104 11.8 106.4 15.8L160.6 85.4L86 180.2H60.6V110.8C60.6 104.2 55.4 99.6 48.2 99.6H32.2C25.2 99.8 20 104.2 20 110.8V308.8C20 315.4 25.2 320 32.4 320H94.6C107 320 118.4 318.4 128.6 315.2C138.8 312 147.8 307.4 155.4 301.4C163 295.4 169 287.8 173.2 279.2C177.4 270.6 179.6 261 179.6 250.8C179.6 234.6 174.6 220.8 164.8 209.2C157.4 200.4 148 193.8 136.4 189L157.6 162C158.4 161.2 159 160.4 159.2 160L189 122L218.2 153.2zM103.6 220C116 220 125.2 222.6 131.4 227.4C137.2 232 140.2 241.6 140.2 250.6S137.2 268 131.4 272.6C125.2 277.6 116 280 103.6 280H59.8V220H103.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Prescription.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Prescription.displayName = "Blueprint5.Icon.Prescription";
exports.default = Prescription;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bscwS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Presentation", ()=>Presentation);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Presentation = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "presentation",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 380H220C220 391 211 400 200 400S180 391 180 380H20C9 380 0 371 0 360C0 349 9 340 20 340H40V120C40 109 49 100 60 100H151.8L86 34.2C82.2 30.6 80 25.6 80 20C80 9 89 0 100 0C105.6 0 110.6 2.2 114.2 5.8L180 71.8V20C180 9 189 0 200 0S220 9 220 20V71.8L285.8 6C289.4000000000001 2.2 294.4000000000001 0 300 0C311 0 320 9 320 20C320 25.6 317.8 30.6 314.2000000000001 34.2L248.2 100H340C351 100 360 109 360 120V340H380C391 340 400 349 400 360C400 371 391 380 380 380zM320 140H80V340H320V140z" : "M300 300H180C180 311 171 320 160 320S140 311 140 300H20C9 300 0 291 0 280C0 269 9 260 20 260V100C20 89 29 80 40 80H111.8L66 34.2C62.2 30.6 60 25.6 60 20C60 9 69 0 80 0C85.6 0 90.6 2.2 94.2 5.8L140 51.8V20C140 9 149 0 160 0S180 9 180 20V51.8L225.8 6C229.4 2.2 234.4 0 240 0C251 0 260 9 260 20C260 25.6 257.8 30.6 254.2 34.2L208.2 80H280C291 80 300 89 300 100V260C311 260 320 269 320 280C320 291 311 300 300 300zM260 120H60V260H260V120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Presentation.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Presentation.displayName = "Blueprint5.Icon.Presentation";
exports.default = Presentation;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ldWy6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Print", ()=>Print);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Print = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "print",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 80H120V160H80V60C80 49 89 40 100 40H300C311 40 320 49 320 60V160H280V80zM320 340C320 351 311 360 300 360H100C89 360 80 351 80 340V320H320V340zM380 300H20C9 300 0 291 0 280V140C0 129 9 120 20 120H60V180H340V120H380C391 120 400 129 400 140V280C400 291 391 300 380 300zM360 220H320V260H360V220z" : "M240 279.6C240 290.6 231 299.6 220 299.6H100C89 299.6 80 290.6 80 279.6V259.6H240V279.6zM300 239.6H20C9 239.6 0 230.6 0 219.6V99.6C0 88.6 9 79.6 20 79.6H40V139.6H280V79.6H300C311 79.6 320 88.6 320 99.6V219.6C320 230.8 311 239.6 300 239.6zM280 179.6H240V199.6H280V179.6zM220 59.6H100V119.6H60V39.6C60 28.6 69 19.6 80 19.6H240C251 19.6 260 28.6 260 39.6V119.6H220V59.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Print.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Print.displayName = "Blueprint5.Icon.Print";
exports.default = Print;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iu1OD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Projects", ()=>Projects);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Projects = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "projects",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 320C360 331 351 340 340 340H60C49 340 40 331 40 320V280H360V320zM320 380C320 391 311 400 300 400H100C89 400 80 391 80 380V360H320V380zM380 260H20C9 260 0 251 0 240V20C0 9 9 0 20 0H380C391 0 400 9 400 20V240C400 251 391 260 380 260zM280 120C280 109 271 100 260 100H140C129 100 120 109 120 120V160H140V120H260V160H280V120z" : "M280 260C280 271 271 280 260 280H60C49 280 40 271 40 260V240H280V260zM240 320H80C69 320 60 311 60 300H260C260 311 251 320 240 320zM300 220H20C9 220 0 211 0 200V20C0 9 9 0 20 0H300C311 0 320 9 320 20V200C320 211 311 220 300 220zM240 100C240 89 231 80 220 80H100C89 80 80 89 80 100V140H100V100H220V140H240V100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Projects.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Projects.displayName = "Blueprint5.Icon.Projects";
exports.default = Projects;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"13ovW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Properties", ()=>Properties);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Properties = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "properties",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 100C18 100 0 82 0 60C0 38 18 20 40 20S80 38 80 60C80 82 62 100 40 100zM40 240C18 240 0 222 0 200C0 178 18 160 40 160S80 178 80 200C80 222 62 240 40 240zM140 320H380C391 320 400 329 400 340C400 351 391 360 380 360H140C129 360 120 351 120 340C120 329 129 320 140 320zM40 380C18 380 0 362 0 340C0 318 18 300 40 300S80 318 80 340C80 362 62 380 40 380zM380 220H140C129 220 120 211 120 200C120 189 129 180 140 180H380C391 180 400 189 400 200C400 211 391 220 380 220zM380 80H140C129 80 120 71 120 60C120 49 129 40 140 40H380C391 40 400 49 400 60C400 71 391 80 380 80z" : "M40 200C18 200 0 182 0 160C0 138 18 120 40 120S80 138 80 160C80 182 62 200 40 200zM120 260H300C311 260 320 269 320 280C320 291 311 300 300 300H120C109 300 100 291 100 280C100 269 109 260 120 260zM40 80C18 80 0 62 0 40C0 18 18 0 40 0S80 18 80 40C80 62 62 80 40 80zM300 180H120C109 180 100 171 100 160C100 149 109 140 120 140H300C311 140 320 149 320 160C320 171 311 180 300 180zM300 60H120C109 60 100 51 100 40C100 29 109 20 120 20H300C311 20 320 29 320 40C320 51 311 60 300 60zM40 320C18 320 0 302 0 280C0 258 18 240 40 240S80 258 80 280C80 302 62 320 40 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Properties.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Properties.displayName = "Blueprint5.Icon.Properties";
exports.default = Properties;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fk1n7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Property", ()=>Property);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Property = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "property",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 300C82 300 100 318 100 340C100 362 82 380 60 380S20 362 20 340C20 318 38 300 60 300zM160 320H380C391 320 400 329 400 340C400 351 391 360 380 360H160C149 360 140 351 140 340C140 329 149 320 160 320zM60 100C38 100 20 82 20 60C20 38 38 20 60 20S100 38 100 60C100 82 82 100 60 100zM380 80H160C149 80 140 71 140 60C140 49 149 40 160 40H380C391 40 400 49 400 60C400 71 391 80 380 80zM360 240H180C158 240 140 222 140 200C140 178 158 160 180 160H360C382 160 400 178 400 200C400 222 382 240 360 240zM60 260C26.8 260 0 233.2 0 200S26.8 140 60 140S120 166.8 120 200S93.2 260 60 260z" : "M60 80C38 80 20 62 20 40C20 18 38 0 60 0S100 18 100 40C100 62 82 80 60 80zM50 210C22.4 210 0 187.6 0 160C0 132.4 22.4 110 50 110S100 132.4 100 160C100 187.6 77.6 210 50 210zM140 260H300C311 260 320 269 320 280C320 291 311 300 300 300H140C129 300 120 291 120 280C120 269 129 260 140 260zM300 60H140C129 60 120 51 120 40C120 29 129 20 140 20H300C311 20 320 29 320 40C320 51 311 60 300 60zM60 320C38 320 20 302 20 280S38 240 60 240S100 258 100 280S82 320 60 320zM300 200H140C129 200 120 191 120 180V140C120 129 129 120 140 120H300C311 120 320 129 320 140V180C320 191 311 200 300 200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Property.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Property.displayName = "Blueprint5.Icon.Property";
exports.default = Property;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h4ZJg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PublishFunction", ()=>PublishFunction);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var PublishFunction = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "publish-function",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140.2 197.8C147.2 210.6 154.6 231.4 162 260L178 320.6H197.2L202 336H182.2C187.8 358.2 195.4 374.4 204.6 384.6C210.2 391 215.8 394.2 221.2 394.2C222.2 394.2 223.2 393.8 223.8 393.2C224.4 392.6 224.8000000000001 391.8 224.8000000000001 390.8C224.8000000000001 390 224.0000000000001 388.2 222.6000000000001 385.8C221.0000000000001 383.4 220.4000000000001 381 220.4000000000001 378.8C220.4000000000001 375.8 221.6000000000001 373.2 224.0000000000001 371C226.4000000000001 368.8 229.4000000000001 367.8 233.0000000000001 367.8C237.0000000000001 367.8 240.2000000000001 369.2 242.8000000000001 371.8S246.8000000000001 378 246.8000000000001 382.6C246.8000000000001 387.8 244.8000000000001 392 240.8 395.2C236.8 398.4 230.4 400 221.6 400C208 400 195.6 396.2 184.4 388.4C173.4 380.8 162.8 368 152.8 350.2C149.4 344.2 146 340.2 143 338.4C140 336.8 135 335.8 128.2 336L123.6 320.6H142.6L114.8 215.8C110.2 198.6 107 188 105.4 184C103 178.2 99.4 173.2 94.6 169C92.6 167.4 90.4 166.6 87.6 166.6C86.8 166.6 86.2 166.8 85.6 167.2L85 168C85 168.4 85.6 169.4 87 170.6C88.4 172 89 174 89 176.8000000000001C89 179.8000000000001 88 182.4 85.8 184.4C83.6 186.4 80.4 187.4000000000001 76.4 187.4000000000001C71.4 187.4000000000001 67.6 186.0000000000001 64.6 183.4000000000001C61.6 181 60 177.8 60 174.2C60 170.4 61.8 167 65.4 164.2C69.2 161.4 74.8 160 82.6 160C94.8 160 105.8 163 115.2 169.2C124.8 175.4 133 185 140.2 197.8zM214.2 174.2C210.6 177.8 205.6 180 200 180S189.4 177.8 185.8 174.2L125.8 114.2000000000001C122.2 110.6 120 105.6 120 100C120 89 129 80 140 80C145.6 80 150.6 82.2 154.2 85.8L180 111.8V20C180 9 189 0 200 0C211 0 220 9 220 20V111.8L245.8 86C249.4 82.2 254.4 80 260 80C271 80 280 89 280 100C280 105.6 277.8 110.6 274.2000000000001 114.2000000000001L214.2 174.2zM297.2 309.8C300.6 312.4 304.4 313.8 308.2 313.8C309.6 313.8 312.2 313.2 316 312.2C319.8 311.2000000000001 323.2 310.6 326 310.6C330 310.6 333.4000000000001 312 336 314.6C338.6 317.4 340 320.8 340 325C340 329.4 338.6 333 336 335.6C333.4000000000001 338.2 329.4000000000001 339.6 324.4000000000001 339.6C320.0000000000001 339.6 315.8000000000001 338.6 311.8 336.6C307.8000000000001 334.6 302.8000000000001 330.2000000000001 296.8 323.2000000000001C292.2000000000001 318.2 285.6 309.2000000000001 276.6 296.6C273.0000000000001 312.2 267 326.6 258.4000000000001 339.6L210.8000000000001 331.8L209.8000000000001 326.8C213.4 327.4 216.4 327.8 218.8 327.8C223.6 327.8 227.4000000000001 325.8 230.6 321.8C235.6 315.6 242.4000000000001 297 251 266C244.2 257.2 239.4 251.4 237.0000000000001 248.6C232.8 244.2 229.4 241.4 226.6 240C224.6000000000001 239 222.2 238.4 219.6000000000001 238.4C217.6000000000001 238.4 214.4 239.4 209.8000000000001 241.6C206.8000000000001 243 204.0000000000001 243.8 201.4 243.8C196.8000000000001 243.8 193.0000000000001 242.4 190 239.4C186.6 236.6 185.2 233 185.2 228.4C185.2 224.2 186.6 220.8 189.4 218.2C192.2 215.6 196 214.2 200.6 214.2C205.2000000000001 214.2 209.4 215.2000000000001 213.4 217C217.4 218.8 222.4 222.8 228.4000000000001 228.8C234.4000000000001 234.8000000000001 242.8000000000001 244.4000000000001 253.4000000000001 257.4000000000001C257.4000000000001 245.0000000000001 261.0000000000001 236 264 230.4000000000001C267 224.8000000000001 270.4000000000001 220.6 274.4000000000001 218.2000000000001C278.2 215.8000000000001 283.2 214.4 289 214.4C294.6 214.4 300.4000000000001 216.4 306.2 220.4000000000001C313.8 225.4000000000001 321.6 234.2000000000001 329.6 246.6000000000001L324.6 249.4000000000001C319.2000000000001 242.0000000000001 315 237.4000000000001 312.4000000000001 235.6000000000001C310.6 234.4000000000001 308.6 233.8000000000001 306.2 233.8000000000001C303.4 233.8000000000001 300.6 235.6000000000001 297.8 239.0000000000001C293.2 244.8000000000001 287 260.8000000000001 279.2000000000001 287.0000000000001C286.6 298.6 292.4 306.2 297.2 309.8z" : "M243.2 244.8C246.2 247 249.2 248 252.6 248C253.8 248 256 247.6 259.4000000000001 246.8C262.6 246 265.6 245.6 268 245.6C271.4 245.6 274.4000000000001 246.8 276.6 249C278.8 251.2 280 254 280 257.6C280 261.4 278.8 264.2 276.6 266.4C274.4000000000001 268.6 271 269.6 266.8 269.6C263 269.6 259.4000000000001 268.8 256 267C252.6 265.2 248.2 261.6 243 256C239.0000000000001 251.8 233.4 244.4 225.6 233.8C222.6 246.8 217.4 258.8 210 269.6L169 263.2L168.2 259C171.2 259.6 173.8 259.8 176 259.8C180 259.8 183.4 258.2 186 254.8C190.2000000000001 249.6 196 234.2 203.6 208.2C197.8 201 193.8 196.2 191.6 194C188 190.2 185 187.8 182.6 186.8C180.8 186 178.8 185.4 176.6 185.4C174.8 185.4 172 186.2 168.2 188C165.4 189.2 163.2 189.8 161 189.8C157 189.8 153.8 188.6 151.2 186.2C148.6 183.8 147.4 180.8 147.4 177C147.4 173.4 148.6 170.6 151 168.4C153.4 166.2 156.6 165.2 160.6 165.2C164.6 165.2 168.2 166 171.6 167.6C175 169.2 179.4 172.4 184.6 177.4C189.8 182.4 197 190.4 206 201.2C209.6 190.8 212.6 183.4 215.2000000000001 178.6C217.8000000000001 173.8 220.8 170.6 224 168.4C227.4000000000001 166.4 231.4 165.2 236.4 165.2C241.2 165.2 246.2 166.8 251.2 170.2C257.8 174.4 264.4000000000001 181.8 271.4 192L267.2 194.2C262.6 188 259 184.2 256.8 182.8C255.4 181.8 253.6 181.4 251.6 181.4C249.2 181.4 246.8 182.8 244.4 185.6C240.4000000000001 190.4 235.2 203.8 228.4 225.6C234.2 235.4 239.2 241.8 243.2 244.8zM127.4 203.4L141 254H157.6L161.6 266.8H144.8C149.6 285 156 298.6 164 307C168.8 312.4 173.6 315 178.2 315C179.2 315 179.8 314.8 180.4 314.2C181 313.6 181.2 313 181.2 312.2C181.2 311.4 180.6 310 179.2 308C178 306 177.2 304 177.2 302.2C177.2 299.6 178.2 297.4 180.2 295.6C182.2 293.8 184.8 292.8 188 292.8C191.4 292.8 194.2 294 196.4 296.2C198.8 298.6 200 301.6 200 305.4C200 309.6 198.4 313.2 195 315.8C191.4 318.6 186 320 178.6 320C166.8 320 156.2 316.8 146.8 310.4C137.2 304 128.2 293.4 119.6 278.6C116.6 273.4 113.8 270.2 111.2 268.8C108.6 267.4 104.2 266.6 98.4 266.8L94.6 253.8H110.8L87 166.4C83 152 80.4 143.2 79 139.8C77 135 73.8 130.8 69.8 127.4C68 126 66 125.4 63.6 125.4C63 125.4 62.4 125.6 62 126L61.4 126.6C61.4 127 62 127.8 63.2 128.8C64.4 130 65 131.8 65 134C65 136.6 64 138.6 62.2 140.4C60.2 142.2 57.6 143 54 143C49.8 143 46.4 142 43.8 139.8C41.2 137.4 40 134.8 40 132C40 128.8 41.6 126 44.6 123.6C47.8 121.2 52.6 120 59.4 120C70 120 79.2 122.6 87.4 127.8C95.6 133 102.6 140.8 108.8 151.6C114.8 162.2 121 179.4 127.4 203.4zM174.2 134.2C170.6 137.8 165.6 140 160 140C154.4 140 149.4 137.8 145.8 134.2L105.8 94.2C102.2 90.6 100 85.6 100 80C100 69 109 60 120 60C125.6 60 130.6 62.2 134.2 65.8L140 71.8V20C140 9 149 0 160 0C171 0 180 9 180 20V71.8L185.8 66C189.4 62.2 194.4 60 200 60C211 60 220 69 220 80C220 85.6 217.8 90.6 214.2 94.2L174.2 134.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
PublishFunction.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
PublishFunction.displayName = "Blueprint5.Icon.PublishFunction";
exports.default = PublishFunction;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4xhNY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pulse", ()=>Pulse);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Pulse = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "pulse",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 200H332.4000000000001L298 269L297.8 269C294.4000000000001 275.4 287.8 280 280 280C271.4 280 264.2000000000001 274.4 261.4 266.8L261.2 266.8L206.2 115.4L159.6 363.6L159.2 363.6C157.6 372.8 149.8 380 140 380C131.2 380 124 374.2 121.2 366.2L121 366.2L65.6 200H20C9 200 0 191 0 180C0 169 9 160 20 160H80C88.8 160 96 165.8 98.8 173.8L99 173.8L134.6 280.6L180.4 36.4L180.8 36.4C182.4 27.2 190.2 20 200 20C208.6 20 215.8 25.6 218.6 33.2L218.8 33.2L283 209.6L302.2 171.2L302.4 171.2C305.6 164.6 312.2 160 320 160H380C391 160 400 169 400 180C400 191 391 200 380 200z" : "M300 160H270.8L236.8 211L236.4 210.8C232.8 216.2 227 220 220 220C211.4 220 204.2 214.6 201.4 207L201.2 207L167.4 116.8L139.8 283.2L139.4 283.2C137.8 292.6 130 300 120 300C111.8 300 104.6 295 101.6 287.8L101.6 287.8L101.6 287.8C101.6 287.8 101.6 287.8 101.6 287.8L46.8 160H20C9 160 0 151 0 140C0 129 9 120 20 120H60C68.2 120 75.4 125 78.4 132.2L78.4 132.2L78.4 132.2C78.4 132.2 78.4 132.2 78.4 132.2L111.4 209.4L140.2 36.8L140.6 36.8C142.2 27.4 150 20 160 20C168.6 20 175.8 25.4 178.6 33L178.8 33L225 156.4L243.4 128.8L243.8 129C247.2 123.8 253 120 260 120H300C311 120 320 129 320 140C320 151 311 160 300 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Pulse.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Pulse.displayName = "Blueprint5.Icon.Pulse";
exports.default = Pulse;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVAlw":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Rain", ()=>Rain);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Rain = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "rain",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 200C46.863 200 20 226.863 20 260C20 293.137 46.863 320 80 320C87.4978 320 94.6744 318.6246 101.2912 316.1126C108.9964 363.6802 150.2568 400 200 400C241.844 400 277.686 374.2984 292.6 337.8204C298.164 339.2434 303.9940000000001 340 310 340C348.66 340 380 308.66 380 270C380 231.34 348.66 200 310 200H200H80zM80 160C91.0456 160 100 151.046 100 140L100 40C100 28.954 91.0456 20 80 20C68.9544 20 60 28.954 60 40L60 140C60 151.046 68.9544 160 80 160zM260 140C260 151.046 251.046 160 240 160C228.954 160 220 151.046 220 140V20C220 8.954 228.954 0 240 0C251.046 0 260 8.954 260 20V140zM320 160C331.046 160 340 151.046 340 140V80C340 68.954 331.046 60 320 60C308.954 60 300 68.954 300 80V140C300 151.046 308.954 160 320 160zM180 140C180 151.046 171.0456 160 160 160C148.9544 160 140 151.046 140 140V80C140 68.954 148.9542 60 160 60C171.0456 60 180 68.954 180 80V140z" : "M70 160C42.3858 160 20 182.3858 20 210C20 237.6142 42.3858 260 70 260C74.1914 260 78.2624 259.4842 82.1528 258.5128C90.5058 293.7694 122.1896 320 160 320C189.967 320 216.086 303.5232 229.79 279.1348C233.108 279.7036 236.52 280 240 280C273.1380000000001 280 300 253.137 300 220C300 186.863 273.1380000000001 160 240 160H160H70zM60 120C60 131.0456 68.9544 140 80 140C91.0456 140 100 131.0456 100 120V40C100 28.954 91.0456 20 80 20C68.9544 20 60 28.954 60 40V120zM200 140C188.9542 140 180 131.0458 180 120V20C180 8.954 188.9542 0 200 0C211.046 0 220 8.954 220 20V120C220 131.0456 211.046 140 200 140zM240 120C240 131.0458 248.954 140 260 140C271.046 140 280 131.0458 280 120V80C280 68.954 271.046 60 260 60C248.954 60 240 68.954 240 80V120zM140 140C128.9544 140 120 131.0458 120 120V80C120 68.954 128.9544 60 140 60C151.0456 60 160 68.954 160 80V120C160 131.0458 151.0456 140 140 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Rain.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Rain.displayName = "Blueprint5.Icon.Rain";
exports.default = Rain;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5eX2a":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Random", ()=>Random);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Random = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "random",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M289.4000000000001 300H331.8L306 274.2C302.2 270.6 300 265.6 300 260C300 249 309 240 320 240C325.6 240 330.6 242.2 334.2000000000001 245.8L394.2000000000001 305.8C397.8 309.4 400 314.4 400 320C400 325.6 397.8 330.6 394.2000000000001 334.2L334.2000000000001 394.2C330.6 397.8 325.6 400 320 400C309 400 300 391 300 380C300 374.4 302.2 369.4 305.8 365.8L331.8 340H280C273.8 340 268.6 337 264.8 332.6L264.6 332.8L206 262.4L232.0000000000001 231.2L289.4000000000001 300zM334.2000000000001 154.2C330.6 157.8 325.6 160 320 160C309 160 300 151 300 140C300 134.4 302.2 129.4 305.8 125.8L331.8 100H289.4L95.4 332.8L95.2 332.6C91.4 337 86.2 340 80 340H20C9 340 0 331 0 320C0 309 9 300 20 300H70.6L264.6 67.2L264.8 67.4C268.6 63 273.8 60 280 60H331.8L306 34.2C302.2 30.6 300 25.6 300 20C300 9 309 0 320 0C325.6 0 330.6 2.2 334.2000000000001 5.8L394.2000000000001 65.8C397.8 69.4 400 74.4 400 80C400 85.6 397.8 90.6 394.2000000000001 94.2000000000001L334.2000000000001 154.2zM70.6 100H20C9 100 0 91 0 80C0 69 9 60 20 60H80C86.2 60 91.4 63 95.2 67.4L95.4 67.2L154 137.6L128 168.8L70.6 100z" : "M229.6 240H251.8L246 234.2C242.2 230.6 240 225.6 240 220C240 209 249 200 260 200C265.6 200 270.6 202.2 274.2000000000001 205.8L314.2000000000001 245.8C317.8 249.4 320 254.4 320 260C320 265.6 317.8 270.6 314.2000000000001 274.2L274.2000000000001 314.2C270.6 317.8 265.6 320 260 320C249 320 240 311 240 300C240 294.4 242.2 289.4 245.8 285.8L251.8 280H220C213.6 280 208.2 276.8 204.6 272.4L204.4 272.6L165.6 224L191.2 192L229.6 240zM274.2000000000001 114.2C270.6 117.8 265.6 120 260 120C249 120 240 111 240 100C240 94.4 242.2 89.4 245.8 85.8L251.8 80H229.6L75.6 272.4L75.4 272.4C71.8 276.8 66.4 280 60 280H20C9 280 0 271 0 260C0 249 9 240 20 240H50.4L204.4 47.6L204.6 47.8C208.2 43.2 213.6 40 220 40H251.8L246 34.2C242.2 30.6 240 25.6 240 20C240 9 249 0 260 0C265.6 0 270.6 2.2 274.2000000000001 5.8L314.2000000000001 45.8C317.8 49.4 320 54.4 320 60C320 65.6 317.8 70.6 314.2000000000001 74.2L274.2000000000001 114.2zM50.4 80H20C9 80 0 71 0 60C0 49 9 40 20 40H60C66.4 40 71.8 43.2 75.4 47.6L75.6 47.4L114.4 95.8L88.8 128L50.4 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Random.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Random.displayName = "Blueprint5.Icon.Random";
exports.default = Random;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e9N4r":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeRing", ()=>RangeRing);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RangeRing = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "range-ring",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C191.1646 400 182.4534 399.425848 173.9034 398.31058C162.9506 396.88186 155.2296 386.84458 156.6584 375.8916C158.087 364.9388 168.1244 357.2178 179.0772 358.6466C185.9162 359.5386 192.8992 360 200 360C207.1 360 214.084 359.5386 220.922 358.6466C231.876 357.2178 241.912 364.9388 243.342 375.8916C244.77 386.84458 237.05 396.88186 226.096 398.31058C217.546 399.425848 208.836 400 200 400zM102.6054 326.9536C111.3638 333.684 113.0076 346.24 106.2772 354.9984C99.5468 363.7568 86.9906 365.4008 78.2324 358.6702C64.3844 348.0288 51.9712 335.6156 41.3298 321.7676C34.5992 313.0094000000001 36.2432 300.4532000000001 45.0016 293.7228C53.76 286.9924 66.316 288.6362 73.0464 297.3946C81.5696 308.4858 91.5142 318.4304 102.6054 326.9536zM321.7680000000001 358.6702C313.01 365.4008 300.454 363.7568 293.722 354.9984C286.992 346.24 288.636 333.684 297.394 326.9536C308.486 318.4304 318.43 308.4858 326.954 297.3946C333.6840000000001 288.6362 346.24 286.9924 354.998 293.7228C363.756 300.4532000000001 365.4 313.0094000000001 358.67 321.7676C348.028 335.6156 335.616 348.0288 321.7680000000001 358.6702zM41.3534 220.9228C42.7822 231.8756 35.0612 241.913 24.1084 243.3416C13.15542 244.7704 3.11814 237.0494 1.68942 226.0966C0.574152 217.5466 0 208.8354 0 200C0 191.164 0.574152 182.454 1.68942 173.904C3.11814 162.95 13.15542 155.23 24.1084 156.658C35.0612 158.088 42.7822 168.124 41.3534 179.078C40.4614 185.916 40 192.9 40 200C40 207.1008 40.4614 214.0838 41.3534 220.9228zM398.3100000000001 226.0966C396.882 237.0494 386.844 244.7704 375.892 243.3416C364.938 241.913 357.218 231.8756 358.646 220.9228C359.538 214.0838 360 207.1008 360 200C360 192.9 359.538 185.916 358.646 179.078C357.218 168.124 364.938 158.088 375.892 156.658C386.844 155.23 396.882 162.95 398.3100000000001 173.904C399.426 182.454 400 191.164 400 200C400 208.8354 399.426 217.5466 398.3100000000001 226.0966zM73.0464 102.606C66.316 111.364 53.76 113.008 45.0016 106.278C36.2432 99.546 34.5992 86.99 41.3298 78.232C51.9712 64.384 64.3844 51.972 78.2324 41.33C86.9906 34.6 99.5468 36.244 106.2772 45.002C113.0076 53.76 111.3638 66.316 102.6054 73.046C91.5142 81.57 81.5696 91.514 73.0464 102.606zM358.67 78.232C365.4 86.99 363.756 99.546 354.998 106.278C346.24 113.008 333.6840000000001 111.364 326.954 102.606C318.43 91.514 308.486 81.57 297.394 73.046C288.636 66.316 286.992 53.76 293.722 45.002C300.454 36.244 313.01 34.6 321.7680000000001 41.33C335.616 51.972 348.028 64.384 358.67 78.232zM179.0772 41.354C168.1244 42.782 158.087 35.062 156.6584 24.108C155.2296 13.1560000000001 162.9506 3.118 173.9034 1.6899999999999C182.4534 0.574 191.1646 0 200 0C208.836 0 217.546 0.574 226.096 1.6899999999999C237.05 3.118 244.77 13.1560000000001 243.342 24.108C241.912 35.062 231.876 42.782 220.922 41.354C214.084 40.462 207.1 40 200 40C192.8992 40 185.9162 40.462 179.0772 41.354zM200 260C233.138 260 260 233.137 260 200C260 166.862 233.138 140 200 140C166.863 140 140 166.862 140 200C140 233.137 166.863 260 200 260zM300 200C300 255.2284 255.228 300 200 300C144.7716 300 100 255.2284 100 200C100 144.772 144.7716 100 200 100C255.228 100 300 144.772 300 200z" : "M160 320C152.9354 320 145.9678 319.540902 139.1278 318.64867C128.1748 317.21996 120.454 307.18268 121.8828 296.2298C123.3114 285.2768 133.3488 277.556 144.3016 278.9846C149.4306 279.6538 154.6698 280 160 280C165.3302 280 170.5694 279.6538 175.6984 278.9846C186.6512 277.556 196.6886 285.2768 198.1172 296.2298C199.546 307.18268 191.8252 317.21996 180.8722 318.6486740000001C174.0322 319.540902 167.0646 320 160 320zM86.9568 255.2176C95.7152 261.948 97.359 274.5042000000001 90.6286 283.2624C83.8982 292.0208 71.342 293.6648 62.5836 286.9344C51.5068 278.4222 41.5778 268.4932 33.0656 257.4164C26.3352 248.658 27.9792 236.1018 36.7376 229.3714C45.4958 222.641 58.052 224.2848 64.7824 233.0432C71.1762 241.3634 78.6366 248.8238 86.9568 255.2176zM257.416 286.9344C248.658 293.6648 236.102 292.0208 229.372 283.2624C222.64 274.5042000000001 224.284 261.948 233.044 255.2176C241.364 248.8238 248.824 241.3634 255.218 233.0432C261.948 224.2848 274.504 222.641 283.262 229.3714C292.0200000000001 236.1018 293.664 248.658 286.9340000000001 257.4164C278.422 268.4932 268.494 278.4222 257.416 286.9344zM318.648 180.8722C317.2200000000001 191.8252 307.182 199.546 296.23 198.1172C285.276 196.6886 277.5560000000001 186.6512 278.984 175.6984C279.654 170.5694 280 165.3302 280 160C280 154.6698 279.654 149.4306 278.984 144.3016C277.5560000000001 133.3488 285.276 123.3114 296.23 121.8828C307.182 120.454 317.2200000000001 128.1748 318.648 139.1278C319.54 145.9678 320 152.9354 320 160C320 167.0646 319.54 174.0322 318.648 180.8722zM41.0154 175.6984C42.444 186.6512 34.7232 196.6886 23.7702 198.1172C12.81732 199.546 2.78004 191.825 1.351326 180.8722C0.459098 174.0322 0 167.0646 0 160C0 152.9354 0.459098 145.9678 1.35133 139.1278C2.78004 128.1748 12.81732 120.454 23.7702 121.8828C34.7232 123.3114 42.444 133.3488 41.0154 144.3016C40.3462 149.4306 40 154.6698 40 160C40 165.3302 40.3462 170.5694 41.0154 175.6984zM64.7824 86.956C58.052 95.716 45.4958 97.36 36.7376 90.628C27.9792 83.898 26.3352 71.342 33.0656 62.584C41.5778 51.506 51.5068 41.578 62.5836 33.066C71.342 26.336 83.8982 27.98 90.6286 36.738C97.359 45.496 95.7152 58.052 86.9568 64.782C78.6366 71.176 71.1762 78.636 64.7824 86.956zM286.9340000000001 62.584C293.664 71.342 292.0200000000001 83.898 283.262 90.628C274.504 97.36 261.948 95.716 255.218 86.956C248.824 78.636 241.364 71.176 233.044 64.782C224.284 58.052 222.64 45.496 229.372 36.738C236.102 27.98 248.658 26.336 257.416 33.066C268.494 41.578 278.422 51.506 286.9340000000001 62.584zM180.8722 1.352C191.8252 2.78 199.546 12.818 198.1172 23.77C196.6886 34.724 186.6512 42.444 175.6984 41.016C170.5694 40.346 165.3302 40 160 40C154.6698 40 149.4306 40.346 144.3016 41.016C133.3488 42.444 123.3114 34.724 121.8828 23.77C120.454 12.818 128.175 2.78 139.1278 1.352C145.9678 0.46 152.9354 0 160 0C167.0646 0 174.0322 0.46 180.8722 1.352zM160 200C182.0914 200 200 182.0914 200 160C200 137.9086 182.0914 120 160 120C137.9086 120 120 137.9086 120 160C120 182.0914 137.9086 200 160 200zM240 160C240 204.1828 204.182 240 160 240C115.8172 240 80 204.1828 80 160C80 115.818 115.8172 80 160 80C204.182 80 240 115.818 240 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RangeRing.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RangeRing.displayName = "Blueprint5.Icon.RangeRing";
exports.default = RangeRing;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jazj9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Record", ()=>Record);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Record = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "record",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 200A140 140 0 0 1 340 200A140 140 0 0 1 60 200" : "M60 160A100 100 0 0 1 260 160A100 100 0 0 1 60 160",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Record.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Record.displayName = "Blueprint5.Icon.Record";
exports.default = Record;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fi8vo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RectHeight", ()=>RectHeight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RectHeight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "rect-height",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 40V360H320V40H80zM40 380C40 391.04568 48.9544 400 60 400H340C351.046 400 360 391.0457 360 380V20C360 8.954 351.046 0 340 0H60C48.9544 0 40 8.954 40 20V380zM125.8518 145.894C118.0494 153.696 118.0494 166.346 125.8518 174.148C133.6542 181.95 146.3042 181.95 154.1066 174.148L200 128.254L245.894 174.148C253.696 181.95 266.346 181.95 274.148 174.148C281.95 166.346 281.95 153.696 274.148 145.894L214.9 86.646C214.658 86.376 214.408 86.112 214.148 85.852C210.242 81.946 205.12 79.994 200 80C194.88 79.994 189.7582 81.946 185.8518 85.852C185.5924 86.112 185.3416 86.376 185.0996 86.646L125.8518 145.894zM125.8518 225.8518000000001C118.0494 233.6542 118.0494 246.3042 125.8518 254.1066L185.0996 313.3544C185.3416 313.6242 185.5924 313.8888 185.8518 314.1482C189.7582 318.0546 194.88 320.0052 200 320C205.12 320.0052 210.242 318.0546 214.148 314.1482C214.408 313.8888 214.658 313.6242 214.9 313.3544L274.148 254.1066C281.95 246.3042 281.95 233.6542 274.148 225.8518000000001C266.346 218.0494 253.696 218.0494 245.894 225.8518000000001L200 271.7452L154.1066 225.8518000000001C146.3042 218.0494 133.6542 218.0494 125.8518 225.8518000000001z" : "M60 20V300H260V20H60zM60 0C48.9544 0 40 8.954 40 20V300C40 311.0457 48.9544 320 60 320H260C271.046 320 280 311.0457 280 300V20C280 8.954 271.046 0 260 0H60zM174.1422 254.1422C166.3316 261.9526 153.6684 261.9526 145.8578 254.1422L105.8578 214.1422C98.0474 206.3316 98.0474 193.6684 105.8578 185.8578C113.6684 178.0474 126.3316 178.0474 134.1422 185.8578L160 211.7158L185.8578 185.8578C193.6684 178.0474 206.332 178.0474 214.142 185.8578C221.952 193.6684 221.952 206.3316 214.142 214.1422L174.1422 254.1422zM134.1422 134.1422C126.3316 141.9526 113.6684 141.9526 105.8578 134.1422C98.0474 126.3316 98.0474 113.668 105.8578 105.858L145.8578 65.858C149.6086 62.108 154.6956 60 160 60C165.3044 60 170.3914 62.108 174.1422 65.858L214.142 105.858C221.952 113.668 221.952 126.3316 214.142 134.1422C206.332 141.9526 193.6684 141.9526 185.8578 134.1422L160 108.284L134.1422 134.1422z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RectHeight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RectHeight.displayName = "Blueprint5.Icon.RectHeight";
exports.default = RectHeight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"73Dp4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RectWidth", ()=>RectWidth);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RectWidth = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "rect-width",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 80H40V320H360V80zM20 40C8.95432 40 0 48.954 0 60V340C0 351.0456 8.9543 360 20 360H380C391.046 360 400 351.0456 400 340V60C400 48.954 391.046 40 380 40H20zM145.8934 274.1482C153.6958 281.9506 166.3458 281.9506 174.1482 274.1482C181.9506 266.3458 181.9506 253.6958 174.1482 245.8934L128.2548 200L174.1482 154.106C181.9506 146.304 181.9506 133.654 174.1482 125.852C166.3458 118.05 153.6958 118.05 145.8934 125.852L86.6454 185.1C86.3758 185.342 86.1112 185.592 85.8518 185.852C81.9454 189.758 79.9948 194.88 80 200C79.9948 205.12 81.9454 210.2418 85.8518 214.1482C86.1112 214.4076 86.3758 214.6584 86.6456 214.9004L145.8934 274.1482zM225.852 274.1482C233.654 281.9506 246.3040000000001 281.9506 254.106 274.1482L313.354 214.9004C313.624 214.6584 313.888 214.4076 314.148 214.1482C318.054 210.2418 320.006 205.12 320 200C320.006 194.88 318.054 189.758 314.148 185.852C313.888 185.592 313.624 185.342 313.354 185.1L254.106 125.852C246.3040000000001 118.05 233.654 118.05 225.852 125.852C218.05 133.654 218.05 146.304 225.852 154.106L271.7460000000001 200L225.852 245.8934C218.05 253.6958 218.05 266.3458 225.852 274.1482z" : "M20 260H300V60H20V260zM0 260C0 271.0456 8.9543 280 20 280H300C311.046 280 320 271.0456 320 260V60C320 48.954 311.046 40 300 40H20C8.9543 40 0 48.954 0 60V260zM214.142 214.1422C206.332 221.9526 193.6684 221.9526 185.8578 214.1422C178.0474 206.3316 178.0474 193.6684 185.8578 185.8578L211.716 160L185.8578 134.1422C178.0474 126.3316 178.0474 113.668 185.8578 105.858C193.6684 98.048 206.332 98.048 214.142 105.858L254.142 145.8578C257.892 149.6086 260 154.6956 260 160C260 165.3044 257.892 170.3914 254.142 174.1422L214.142 214.1422zM134.1422 185.8578C141.9526 193.6684 141.9526 206.3316 134.1422 214.1422C126.3316 221.9526 113.6684 221.9526 105.8578 214.1422L65.8578 174.1422C62.1072 170.3914 60 165.3044 60 160C60 154.6956 62.1072 149.6086 65.8578 145.8578L105.8578 105.858C113.6684 98.048 126.3316 98.048 134.1422 105.858C141.9526 113.668 141.9526 126.3316 134.1422 134.1422L108.2842 160L134.1422 185.8578z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RectWidth.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RectWidth.displayName = "Blueprint5.Icon.RectWidth";
exports.default = RectWidth;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kWLaS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Rectangle", ()=>Rectangle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Rectangle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "rectangle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 320H380C391 320 400 311 400 300V100C400 89 391 80 380 80H20C9 80 0 89 0 100V300C0 311 9 320 20 320zM40 280V120H360V280H40z" : "M20 260H300C311 260 320 251 320 240V80C320 69 311 60 300 60H20C9 60 0 69 0 80V240C0 251 9 260 20 260zM40 220V100H280V220H40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Rectangle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Rectangle.displayName = "Blueprint5.Icon.Rectangle";
exports.default = Rectangle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eFEEr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Redo", ()=>Redo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Redo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "redo",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M394.2000000000001 294.2L314.2000000000001 374.2C310.6 377.8 305.6 380 300 380C289 380 280 371 280 360C280 354.4 282.2 349.4 285.8 345.8L331.8 300H120C53.8 300 0 246.2 0 180C0 113.8 53.8 60 120 60H220V100H120C75.8 100 40 135.8 40 180C40 224.2 75.8 260 120 260H331.8L286 214.2C282.2 210.6 280 205.6 280 200C280 189 289 180 300 180C305.6 180 310.6 182.2 314.2000000000001 185.8L394.2000000000001 265.8C397.8 269.4 400 274.4 400 280C400 285.6 397.8 290.6 394.2000000000001 294.2zM300 120C278 120 260 102 260 80S278 40 300 40S340 58 340 80S322 120 300 120z" : "M240 100C218 100 200 82 200 60S218 20 240 20S280 38 280 60S262 100 240 100zM314.2000000000001 234.2L254.2 294.2C250.6 297.8 245.6 300 240 300C229 300 220 291 220 280C220 274.4 222.2 269.4 225.8 265.8L251.8 240H100C44.8 240 0 195.2 0 140S44.8 40 100 40H180V80H100C66.8 80 40 106.8 40 140S66.8 200 100 200H251.8L226 174.2C222.2 170.6 220 165.6 220 160C220 149 229 140 240 140C245.6 140 250.6 142.2 254.2 145.8L314.2000000000001 205.8C317.8 209.4 320 214.4 320 220C320 225.6 317.8 230.6 314.2000000000001 234.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Redo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Redo.displayName = "Blueprint5.Icon.Redo";
exports.default = Redo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ydPz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Refresh", ()=>Refresh);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Refresh = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "refresh",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M72.7208 327.2792C106.4774 361.0358 152.261 380 200 380C248.774 380 303.64 365.6654 340 330.5748V360C340 371.0456 348.954 380 360 380C371.046 380 380 371.0456 380 360V280C380 268.9544 371.046 260 360 260H280C268.954 260 260 268.9544 260 280C260 291.0456 268.954 300 280 300H313.998C287.926 326.4008 244.348 340 200 340C162.8698 340 127.2602 325.25 101.005 298.995C74.75 272.7398 60 237.1304 60 200C60 188.954 51.0456 180 40 180C28.9544 180 20 188.954 20 200C20 247.739 38.9642 293.5228 72.7208 327.2792zM327.2800000000001 72.72C293.522 38.964 247.738 20 200 20C151.2264 20 96.3604 34.334 60 69.426V40C60 28.954 51.0456 20 40 20C28.9544 20 20 28.954 20 40V120C20 131.046 28.9544 140 40 140H120C131.0458 140 140 131.046 140 120C140 108.954 131.0458 100 120 100H86.0012C112.0736 73.6 155.6518 60 200 60C237.13 60 272.74 74.75 298.9940000000001 101.006C325.25 127.26 340 162.87 340 200C340 211.0456 348.954 220 360 220C371.046 220 380 211.0456 380 200C380 152.26 361.036 106.478 327.2800000000001 72.72z" : "M160 260C104.7716 260 60 215.2284 60 160C60 148.9544 51.0456 140 40 140C28.9544 140 20 148.9544 20 160C20 237.3198 82.6802 300 160 300C194.383 300 232.382 291.6802 260 268.6506V280C260 291.0456 268.954 300 280 300C291.046 300 300 291.0456 300 280V220C300 208.9544 291.046 200 280 200H220C208.954 200 200 208.9544 200 220C200 231.0456 208.954 240 220 240H231.716C214.034 253.3168 188.34 260 160 260zM160 60C215.228 60 260 104.772 260 160C260 171.0456 268.954 180 280 180C291.046 180 300 171.0456 300 160C300 82.68 237.32 20 160 20C125.617 20 87.6184 28.32 60 51.35V40C60 28.954 51.0456 20 40 20C28.9544 20 20 28.954 20 40V100C20 111.046 28.9542 120 40 120H100C111.0458 120 120 111.046 120 100C120 88.954 111.0458 80 100 80H88.284C105.9654 66.684 131.66 60 160 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Refresh.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Refresh.displayName = "Blueprint5.Icon.Refresh";
exports.default = Refresh;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fdQM0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Regex", ()=>Regex);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Regex = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "regex",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 50C0 77.614 22.3858 100 50 100C77.6142 100 100 77.614 100 50C100 22.386 77.6142 0 50 0C22.3858 0 0 22.386 0 50zM280 400C268.954 400 260 391.04568 260 380V304.6424L194.7374 342.3216C185.1716 347.8446 172.9398 344.567 167.417 335.0012C161.8942 325.4354 165.1716 313.2036 174.7374 307.6806000000001L240.002 270.0002L174.737 232.3194000000001C165.171 226.7964 161.8936 214.5646 167.4164 204.9988C172.9392 195.432 185.171 192.156 194.737 197.678L260 235.358V160C260 148.954 268.954 140 280 140C291.046 140 300 148.954 300 160V235.3604L365.264 197.68C374.828 192.158 387.0600000000001 195.436 392.584 205.0012C398.106 214.567 394.828 226.7988 385.264 232.3216L320.002 270.0002L385.2620000000001 307.6784C394.828 313.2012 398.106 325.433 392.584 334.9988C387.0600000000001 344.5646 374.828 347.8422 365.2620000000001 342.3194L300 304.64V380C300 391.04568 291.046 400 280 400z" : "M0 40C0.00000386258 62.092 17.9086 80 40 80C62.0914 80 80 62.092 80 40C80 17.908 62.0914 0 40 0C17.9086 0 -0.00000386258 17.908 0 40zM220 320C208.954 320.000001931292 200 311.0457 200 300L200 244.6422L152.0578 272.3216C142.4918 277.8446 130.26 274.567 124.7372 265.0012C119.2144 255.4354 122.4918 243.2036 132.0578 237.6806L180.002 210L132.0578 182.3194C122.4918 176.7964 119.2144 164.5646 124.7372 154.9988C130.26 145.433 142.4918 142.1554 152.0576 147.6784L200 175.3578L200 120C200 108.954 208.954 100 220 100C231.046 100 240 108.954 240 120L240 175.3602L287.942 147.6806C297.5080000000001 142.1578 309.74 145.4354 315.262 155.0012C320.786 164.567 317.5080000000001 176.7988 307.942 182.3216L260.002 210L307.942 237.6784C317.5080000000001 243.2012 320.786 255.433 315.262 264.9988C309.74 274.5646 297.5080000000001 277.8422 287.942 272.3194L240 244.6398L240 300C240 311.0457 231.046 319.999998068708 220 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Regex.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Regex.displayName = "Blueprint5.Icon.Regex";
exports.default = Regex;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Eu56":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RegressionChart", ()=>RegressionChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RegressionChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "regression-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 80H62L386.2 332.2L374 348L40 88.2V340C40 351 31 360 20 360S0 351 0 340V60C0 49 9 40 20 40H380C391 40 400 49 400 60C400 71 391 80 380 80zM200 260C222 260 240 278 240 300C240 322 222 340 200 340S160 322 160 300C160 278 178 260 200 260zM100 180C122 180 140 198 140 220C140 242 122 260 100 260S60 242 60 220C60 198 78 180 100 180zM300 220C300 198 318 180 340 180S380 198 380 220C380 242 362 260 340 260S300 242 300 220zM200 140C200 118 218 100 240 100S280 118 280 140S262 180 240 180S200 162 200 140z" : "M260 190C260 173.4 273.4 160 290 160S320 173.4 320 190S306.6 220 290 220S260 206.6 260 190zM170 220C186.6 220 200 233.4 200 250S186.6 280 170 280S140 266.6 140 250S153.4 220 170 220zM180 130C180 113.4 193.4 100 210 100S240 113.4 240 130S226.6 160 210 160S180 146.6 180 130zM90 160C106.6 160 120 173.4 120 190S106.6 220 90 220S60 206.6 60 190S73.4 160 90 160zM300 80H65.2L305.8 251.8L294.2 268L40 86.6V260C40 271 31 280 20 280S0 271 0 260V60C0 49 9 40 20 40H300C311 40 320 49 320 60C320 71 311 80 300 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RegressionChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RegressionChart.displayName = "Blueprint5.Icon.RegressionChart";
exports.default = RegressionChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jcMS0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveColumnLeft", ()=>RemoveColumnLeft);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RemoveColumnLeft = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "remove-column-left",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 180H200C211 180 220 189 220 200S211 220 200 220H80C69 220 60 211 60 200S69 180 80 180zM380 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM240 40H40V360H240V40zM360 40H260V360H360V40z" : "M80 140H160C171 140 180 149 180 160S171 180 160 180H80C69 180 60 171 60 160C60 149 69 140 80 140zM300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM200 40H40V280H200V40zM280 40H220V280H280V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RemoveColumnLeft.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RemoveColumnLeft.displayName = "Blueprint5.Icon.RemoveColumnLeft";
exports.default = RemoveColumnLeft;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6KYfF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveColumnRight", ()=>RemoveColumnRight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RemoveColumnRight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "remove-column-right",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM140 40H40V360H140V40zM360 40H160V360H360V40zM200 180H320C331 180 340 189 340 200S331 220 320 220H200C189 220 180 211 180 200S189 180 200 180z" : "M300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM100 40H40V280H100V40zM280 40H120V280H280V40zM160 140H240C251 140 260 149 260 160S251 180 240 180H160C149 180 140 171 140 160S149 140 160 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RemoveColumnRight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RemoveColumnRight.displayName = "Blueprint5.Icon.RemoveColumnRight";
exports.default = RemoveColumnRight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnpFL":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveColumn", ()=>RemoveColumn);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RemoveColumn = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "remove-column",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400H100C89 400 80 391 80 380V300H120V360H220V40H120V100H80V20C80 9 89 0 100 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM360 40H260V360H360V40zM125.8 125.8C129.4 122.2 134.4 120 140 120C151 120 160 129 160 140C160 145.6 157.8 150.6 154.2 154.2L108.2 200L154 245.8C157.8 249.4 160 254.4 160 260C160 271 151 280 140 280C134.4 280 129.4 277.8 125.8 274.2L80 228.2L34.2 274.2C30.6 277.8 25.6 280 20 280C9 280 0 271 0 260C0 254.4 2.2 249.4 5.8 245.8L51.8 200L6 154.2C2.2 150.6 0 145.6 0 140C0 129 9 120 20 120C25.6 120 30.6 122.2 34.2 125.8L80 171.8L125.8 125.8z" : "M280 320H80C69 320 60 311 60 300V240H100V280H160V40H100V80H60V20C60 9 69 0 80 0H280C291 0 300 9 300 20V300C300 311 291 320 280 320zM260 40H200V280H260V40zM85.8 105.8C89.4 102.2 94.4 100 100 100C111 100 120 109 120 120C120 125.6 117.8 130.6 114.2 134.2L88.2 160L114 185.8C117.8 189.4 120 194.4 120 200C120 211 111 220 100 220C94.4 220 89.4 217.8 85.8 214.2L60 188.2L34.2 214.2C30.6 217.8 25.6 220 20 220C9 220 0 211 0 200C0 194.4 2.2 189.4 5.8 185.8L31.8 160L5.8 134.2C2.2 130.6 0 125.6 0 120C0 109 9 100 20 100C25.6 100 30.6 102.2 34.2 105.8L60 131.8L85.8 105.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RemoveColumn.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RemoveColumn.displayName = "Blueprint5.Icon.RemoveColumn";
exports.default = RemoveColumn;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iIkEv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveRowBottom", ()=>RemoveRowBottom);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RemoveRowBottom = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "remove-row-bottom",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140 120H260C271 120 280 129 280 140C280 151 271 160 260 160H140C129 160 120 151 120 140C120 129 129 120 140 120zM380 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM360 40H40V240H360V40zM360 260H40V360H360V260z" : "M300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM280 40H40V200H280V40zM280 220H40V280H280V220zM120 100H200C211 100 220 109 220 120S211 140 200 140H120C109 140 100 131 100 120C100 109 109 100 120 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RemoveRowBottom.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RemoveRowBottom.displayName = "Blueprint5.Icon.RemoveRowBottom";
exports.default = RemoveRowBottom;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eZdDr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveRowTop", ()=>RemoveRowTop);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RemoveRowTop = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "remove-row-top",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140 240H260C271 240 280 249 280 260S271 280 260 280H140C129 280 120 271 120 260S129 240 140 240zM380 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM360 40H40V140H360V40zM360 160H40V360H360V160z" : "M300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM280 40H40V100H280V40zM280 120H40V280H280V120zM120 180H200C211 180 220 189 220 200S211 220 200 220H120C109 220 100 211 100 200S109 180 120 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RemoveRowTop.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RemoveRowTop.displayName = "Blueprint5.Icon.RemoveRowTop";
exports.default = RemoveRowTop;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8AMLh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Remove", ()=>Remove);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Remove = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "remove",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 40C111.6 40 40 111.6 40 200S111.6 360 200 360S360 288.4 360 200S288.4 40 200 40zM300 220H100C89 220 80 211 80 200C80 189 89 180 100 180H300C311 180 320 189 320 200C320 211 311 220 300 220z" : "M219.8 180.2H99.8C88.8 180.2 79.8 171.2 79.8 160.2S88.8 140.2 99.8 140.2H219.8C230.8 140.2 239.8 149.2 239.8 160.2S230.8 180.2 219.8 180.2zM159.8 320.2C71.4 320.2 -0.2 248.6 -0.2 160.2S71.4 0.2 159.8 0.2S319.8 71.8 319.8 160.2S248.2 320.2 159.8 320.2zM159.8 40.2C93.6 40.2 39.8 94 39.8 160.2S93.6 280.2 159.8 280.2S279.8 226.4 279.8 160.2S226.2 40.2 159.8 40.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Remove.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Remove.displayName = "Blueprint5.Icon.Remove";
exports.default = Remove;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ioWGH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Repeat", ()=>Repeat);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Repeat = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "repeat",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 280C280 269 289 260 300 260H380C391 260 400 269 400 280V360C400 371 391 380 380 380S360 371 360 360V319C323.6 368 265.8 400 200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 211 391 220 380 220S360 211 360 200C360 111.6 288.4 40 200 40S40 111.6 40 200S111.6 360 200 360C250.6 360 295.4 336.6 324.8000000000001 300H300C289 300 280 291 280 280z" : "M200 220C200 209 209 200 220 200H300C311 200 320 209 320 220V300C320 311 311 320 300 320S280 311 280 300V265.2C250.8 298.6 208 320 160 320C71.6 320 0 248.4 0 160C0 78.8 60.4 12 138.8 1.6C139.2 1.6 139.6 1.4 140 1.4C146.6 0.6 153.2 0 160 0C248.4 0 320 71.6 320 160C320 171 311 180 300 180S280 171 280 160C280 93.8 226.2 40 160 40C145.8 40 132.6 43 120 47.6V47.4C73.4 63.8 40 107.8 40 160C40 226.2 93.8 280 160 280C195.4 280 227.2 264.4 249.2 240H220C209 240 200 231 200 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Repeat.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Repeat.displayName = "Blueprint5.Icon.Repeat";
exports.default = Repeat;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fj7An":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reset", ()=>Reset);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Reset = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "reset",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M120 280C120 269 111 260 100 260L20 260C9 260 0 269 0 280L0 360C0 371 9 380 20 380C31 380 40 371 40 360L40 319C76.4 368 134.2 400 200 400C310.4 400 400 310.4 400 200C400 89.6 310.4 0 200 0C89.6 0 0 89.6 0 200C0 211 9 220 20 220C31 220 40 211 40 200C40 111.6 111.6 40 200 40C288.4 40 360 111.6 360 200C360 288.4 288.4 360 200 360C149.4 360 104.6 336.6 75.2 300L100 300C111 300 120 291 120 280z" : "M120 220C120 209 111 200 100 200L20 200C9 200 0 209 0 220L0 300C0 311 9 320 20 320C31 320 40 311 40 300L40 265.2C69.2 298.6 112 320 160 320C248.4 320 320 248.4 320 160C320 78.8 259.6 12 181.2 1.6C180.8 1.6 180.4 1.4 180 1.4C173.4 0.6 166.8 0 160 0C71.6 0 0 71.6 0 160C0 171 9 180 20 180C31 180 40 171 40 160C40 93.8 93.8 40 160 40C174.2 40 187.4 43 200 47.6L200 47.4C246.6 63.8 280 107.8 280 160C280 226.2 226.2 280 160 280C124.6 280 92.8 264.4 70.8 240L100 240C111 240 120 231 120 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Reset.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Reset.displayName = "Blueprint5.Icon.Reset";
exports.default = Reset;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"io9BC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Resolve", ()=>Resolve);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Resolve = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "resolve",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M174 306C158 316 140 320 120 320C54 320 0 266 0 200S54 80 120 80C140 80 158 84 174 94C146 120 130 158 130 200S148 280 174 306L174 306zM280 320C260 320 242 316 226 306C254.0000000000001 278 270 242 270 200S252 120 226 94C242 84 260 80 280 80C346 80 400 134 400 200S346 320 280 320L280 320zM200 290L200 290C176 266 160 236 160 200S176 134 200 112L200 112C224 134 240 166 240 202S224 268 200 290L200 290z" : "M132 254C122 258 112 260 100 260C44 260 0 216 0 160S44 60 100 60C112 60 122 62 132 66C106 88 90 122 90 160S106 232 132 254L132 254zM160 240C136 222 120 192 120 160S136 98 160 80C184 98 200 126 200 160S184 222 160 240L160 240zM220 260C208 260 198 258 188 254C214 230 230 196 230 160S214 88 188 66C198 62 208 60 220 60C276 60 320 104 320 160S276 260 220 260L220 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Resolve.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Resolve.displayName = "Blueprint5.Icon.Resolve";
exports.default = Resolve;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5X9Ab":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Rig", ()=>Rig);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Rig = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "rig",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140 316C140 285 166.8 260 200 260S260 289.2 260 316C260 371 218.8 400 200 400H120C120 345.2 195.2 360.8 140 316zM374.2000000000001 34.2L260 148.2V219.8C260 230.8 251 239.8 240 239.8H204.4H160C149 239.8 140 230.8 140 219.8V148.2L25.8 34.2C22.2 30.6 20 25.6 20 20C20 9 29 0 40 0C45.6 0 50.6 2.2 54.2 5.8L140 91.6V20C140 9 149 0 160 0H240C251 0 260 9 260 20V91.6L345.8 5.8C349.4 2.2 354.4 0 360 0C371 0 380 9 380 20C380 25.6 377.8 30.6 374.2000000000001 34.2zM204.2 240C204.4 240 204.4 239.8 204.2 240C204.4 239.8 204.4 240 204.2 240L204.2 240z" : "M114.2 260C114.2 238 133.4 220 157 220C180.8 220 200 240.8 200 260C200 299.2 170.6 320 157.2 320H100C100 280.8 153.6 292 114.2 260zM164.2 200C164.2 200 164.4 199.8 164.4 199.8S164.4 200 164.2 200L164.2 200zM294.2000000000001 34.2L200 128.2V180C200 191 191 200 180 200H164.4H140C129 200 120 191 120 180V128.4L25.8 34.4C22.2 30.6 20 25.6 20 20C20 9 29 0 40 0C45.6 0 50.6 2.2 54.2 5.8L120 71.6V20C120 9 129 0 140 0H180C191 0 200 9 200 20V71.6L265.8 5.8C269.4000000000001 2.2 274.4000000000001 0 280 0C291 0 300 9 300 20C300 25.6 297.8 30.6 294.2000000000001 34.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Rig.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Rig.displayName = "Blueprint5.Icon.Rig";
exports.default = Rig;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l2ZXW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RightJoin", ()=>RightJoin);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RightJoin = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "right-join",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M174 306C148 280 130 242 130 200S146 120 174 94C158 84 140 80 120 80C54 80 0 134 0 200S54 320 120 320C140 320 158 316 174 306zM107.2 121C96.2 145 90 171.8 90 200S96.2 255 107.2 279C69 272.8 40 239.8 40 200S69 127.2 107.2 121zM280 320C346 320 400 266 400 200S346 80 280 80C260 80 242 84 226 94C252.0000000000001 120 270 158 270 200S254 278 226 306C242 316 260 320 280 320zM200 290C176 266 160 236 160 200S176 134 200 112C224 134 240 166 240 202S224 268 200 290z" : "M132 254C106 232 90 198 90 160S106 88 132 66C122 62 112 60 100 60C44 60 0 104 0 160S44 260 100 260C112 260 122 258 132 254zM92.8 80.4C78.4 103.4 70 130.8 70 160S78.4 216.6 92.8 239.6C52 236 20 201.8 20 160S52 84 92.8 80.4zM160 240C136 222 120 192 120 160S136 98 160 80C184 98 200 126 200 160S184 222 160 240zM220 260C276 260 320 216 320 160S276 60 220 60C208 60 198 62 188 66C214 88 230 124 230 160S214 230 188 254.0000000000001C198 258 208 260 220 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RightJoin.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RightJoin.displayName = "Blueprint5.Icon.RightJoin";
exports.default = RightJoin;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"98eZm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ring", ()=>Ring);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Ring = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "ring",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 100C144.8 100 100 144.8 100 200S144.8 300 200 300S300 255.2 300 200S255.2 100 200 100z" : "M160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM160 80C115.8 80 80 115.8 80 160C80 204.2 115.8 240 160 240S240 204.2 240 160C240 115.8 204.2 80 160 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Ring.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Ring.displayName = "Blueprint5.Icon.Ring";
exports.default = Ring;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jDDfn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RocketSlant", ()=>RocketSlant);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RocketSlant = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "rocket-slant",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 300C242.426 342.4264 326.16 358.4848 360 360C358.484 326.1598 342.4260000000001 242.4264 300 200C276.1520000000001 176.152 249.13 163.548 225.04 152.31C216.198 148.184 207.75 144.244 200 140C195.9396 137.776 188.0536 133.96 180.2852 130.202L180.2842 130.202L180.284 130.202C171.406 125.906 162.6824 121.684 160 120L120 160C123.1584 165.03 140 200 140 200C140 200 167.3996 267.3996 200 300zM300 280C300 268.9544 291.046 260 280 260C268.954 260 260 268.9544 260 280C260 291.0456 268.954 300 280 300C291.046 300 300 291.0456 300 280zM60 60C60 60 60 100 100 140L140 100C100 60 60 60 60 60zM280 100L200 20L174.0488 104.664C194.696 115.86 211.664 123.892 226.906 131.108C252.392 143.17 273.044 152.946 297.98 171.404L280 100zM20 200L100 280L171.1356 297.9796C152.678 273.0436000000001 142.9024 252.3912 130.839 226.9058C123.625 211.6652 115.5928 194.696 104.3966 174.05L20 200z" : "M79.8404 120.0022C119.8402 220.0008 179.8404 299.9988 299.8400000000001 299.9992C299.8400000000001 180 219.84 120.0024 119.8402 80.002L79.8404 120.0022zM234.124 205.6954C226.314 197.885 213.65 197.885 205.84 205.6954C198.0298 213.5058 198.0298 226.1692 205.84 233.9796C213.65 241.7902 226.314 241.7902 234.124 233.9796C241.936 226.1692 241.936 213.5058 234.124 205.6954zM103.0196 210.0584L59.841 199.9962L-0.1590884 159.9962L64.8064 136.093C75.6488 162.1286 88.1222 187.217 103.0196 210.0584zM159.8406 -0.002L135.1286 64.634C161.1118 75.414 186.1668 87.806 209.004 102.6L199.8406 59.998L159.8406 -0.002zM61.217 98.794L61.2172 98.794L100.004 60.008L100.0038 60.008C80.1754 40.18 56.3058 36.914 39.9996 40.002C36.9124 56.308 41.3886 78.966 61.217 98.794z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RocketSlant.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RocketSlant.displayName = "Blueprint5.Icon.RocketSlant";
exports.default = RocketSlant;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4t9Rd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Rocket", ()=>Rocket);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Rocket = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "rocket",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M140 250C140 310 177.1428 375 200 400C222.858 375 260 310 260 250C260 190 245.714 125 240 100H160C154.2858 125 140 190 140 250zM276.802 200.0174C274.02 167.594 267.4 131.908 260 99.79L340 80L320 160L276.802 200.0174zM180.1668 80C180 77.222 180 74.326 180 71.428C180 57.142 180 50 200 0C220 50 220 57.142 220 71.428C220 74.326 220 77.222 219.834 80H180.1668zM140 99.774C132.599 131.89 125.98 167.576 123.1982 200L80 159.982L60 80L140 99.774zM200 300.0002C188.9544 300.0002 180 291.0458 180 280.0002C180 268.9544 188.9544 260.0002 200 260.0002C211.046 260.0002 220 268.9544 220 280.0002C220 291.0458 211.046 300.0002 200 300.0002z" : "M120.0002 80C87.9498 170.8134 88.296 230.6902 159.9998 320C231.704 230.3054 232.036 170.395 200 80H120.0002zM180 220C180 208.9544 171.0456 200 160 200C148.9542 200 140 208.9544 140 220C140 231.0456 148.9542 240 160 240C171.0456 240 180 231.0456 180 220zM40 59.552L100 79.552L98.9222 82.714C92.7074 100.916 81.5282 133.6578 80 160L60 140L40 59.552zM220 79.552L280 59.552L260 140L240 160C238.472 133.6578 227.292 100.916 221.078 82.714L220 79.552zM140 59.998V60H180V59.998C180 29.998 170 10 160 0C150 10 140 29.998 140 59.998z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Rocket.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Rocket.displayName = "Blueprint5.Icon.Rocket";
exports.default = Rocket;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"akpQC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RotateCcw", ()=>RotateCcw);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RotateCcw = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "rotate-ccw",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M365.866 208.203C371.076 202.1684 370.746 193.136 365.1080000000001 187.498L278.588 100.978C272.644 95.034 272.644 85.4 278.588 79.458C284.53 73.514 294.164 73.514 300.108 79.456L386.628 165.976C403.542 182.89 404.5320000000001 209.9892 388.902 228.093L322.592 304.8906H350.216C358.622 304.8906 365.434 311.7036 365.434 320.108C365.434 328.5122 358.622 335.3254 350.216 335.3254H289.348C280.944 335.3254 274.13 328.5122 274.13 320.108V259.2384C274.13 250.834 280.944 244.021 289.348 244.021C297.752 244.021 304.564 250.834 304.564 259.2384V279.1988L365.866 208.203zM257.322 217.6776C267.084 207.9144 267.084 192.086 257.322 182.322L151.2558 76.256C141.4928 66.494 125.6636 66.494 115.9006 76.256L9.83454 182.322C0.0714306 192.086 0.0714306 207.9144 9.83454 217.6776L115.9006 323.7436C125.6636 333.5066 141.4928 333.5066 151.2558 323.7436L257.322 217.6776z" : "M292.692 166.5626C296.862 161.7348 296.596 154.5084 292.086 149.9982L222.87 80.782C218.116 76.028 218.116 68.32 222.87 63.566C227.624 58.812 235.332 58.812 240.086 63.566L309.304 132.7816C322.834 146.312 323.626 167.9916 311.122 182.4746L258.074 243.9126H280.174C286.898 243.9126 292.348 249.3632 292.348 256.0866C292.348 262.81 286.898 268.2604 280.174 268.2604H231.478C224.756 268.2604 219.304 262.81 219.304 256.0866V207.391C219.304 200.6674 224.756 195.217 231.478 195.217C238.202 195.217 243.652 200.6674 243.652 207.391V223.3594L292.692 166.5626zM205.858 174.1422C213.668 166.3318 213.668 153.6684 205.858 145.858L121.0054 61.006C113.195 53.194 100.5316 53.194 92.7212 61.006L7.86836 145.858C0.0578768 153.6684 0.0578768 166.3318 7.86836 174.1422L92.7212 258.995C100.5316 266.8056000000001 113.195 266.8056000000001 121.0054 258.995L205.858 174.1422z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RotateCcw.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RotateCcw.displayName = "Blueprint5.Icon.RotateCcw";
exports.default = RotateCcw;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aq3PI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RotateCw", ()=>RotateCw);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RotateCw = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "rotate-cw",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M34.1344 208.203C28.9238 202.1684 29.2544 193.136 34.892 187.498L121.4124 100.978C127.3552 95.034 127.3552 85.4 121.4126 79.458C115.4698 73.514 105.8346 73.514 99.8918 79.456L13.37148 165.976C-3.5415 182.89 -4.53324 209.9892 11.09828 228.093L77.408 304.8906H49.7826C41.3782 304.8906 34.5652 311.7036 34.5652 320.108C34.5652 328.5122 41.3782 335.3254 49.7826 335.3254H110.6522C119.0566 335.3254 125.8696 328.5122 125.8696 320.108V259.2384C125.8696 250.834 119.0566 244.021 110.6522 244.021C102.2478 244.021 95.4348 250.834 95.4348 259.2384V279.1988L34.1344 208.203zM382.322 217.6776C392.086 207.9144 392.086 192.086 382.322 182.322L276.256 76.256C266.4940000000001 66.494 250.664 66.494 240.9 76.256L134.835 182.322C125.0718 192.086 125.0718 207.9144 134.835 217.6776L240.9 323.7436C250.664 333.5066 266.4940000000001 333.5066 276.256 323.7436L382.322 217.6776z" : "M27.3074 166.5626C23.139 161.7348 23.4036 154.5084 27.9136 149.9982L97.13 80.782C101.8842 76.028 101.8842 68.32 97.13 63.566C92.3758 58.812 84.6678 58.812 79.9136 63.566L10.69718 132.7816C-2.8332 146.312 -3.6266 167.9916 8.87862 182.4746L61.9264 243.9126H39.826C33.1026 243.9126 27.6522 249.3632 27.6522 256.0866C27.6522 262.81 33.1026 268.2604 39.826 268.2604H88.5218C95.2452 268.2604 100.6956 262.81 100.6956 256.0866V207.391C100.6956 200.6674 95.2452 195.217 88.5218 195.217C81.7982 195.217 76.3478 200.6674 76.3478 207.391V223.3594L27.3074 166.5626zM305.858 174.1422C313.668 166.3318 313.668 153.6684 305.858 145.858L221.006 61.006C213.194 53.194 200.532 53.194 192.7208 61.006L107.868 145.858C100.0574 153.6684 100.0574 166.3318 107.868 174.1422L192.7208 258.995C200.532 266.8056000000001 213.194 266.8056000000001 221.006 258.995L305.858 174.1422z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RotateCw.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RotateCw.displayName = "Blueprint5.Icon.RotateCw";
exports.default = RotateCw;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gjb1Y":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RotateDocument", ()=>RotateDocument);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RotateDocument = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "rotate-document",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M174.2 274.2C170.6 277.8 165.6 280 160 280H60C49 280 40 271 40 260V20C40 9 49 0 60 0H240C251 0 260 9 260 20V180C260 185.6 257.8 190.6 254.2 194.2L174.2 274.2zM220 40H80V240H140V180C140 169 149 160 160 160H220V40zM280 360H248.2L254 365.8C257.8 369.4 260 374.4 260 380C260 391 251 400 240 400C234.4 400 229.4 397.8 225.8 394.2L185.8 354.2C182.2 350.6 180 345.6 180 340C180 334.4 182.2 329.4 185.8 325.8L225.8 285.8C229.4 282.2 234.4 280 240 280C251 280 260 289 260 300C260 305.6 257.8 310.6 254.2 314.2L248.2 320H280C302 320 320 302 320 280V220C320 209 329 200 340 200S360 209 360 220V280C360 324.2 324.2000000000001 360 280 360z" : "M240 280H208.2L214 285.8C217.8 289.4 220 294.4 220 300C220 311 211 320 200 320C194.4 320 189.4 317.8 185.8 314.2L145.8 274.2C142.2 270.6 140 265.6 140 260C140 254.4 142.2 249.4 145.8 245.8L185.8 205.8C189.4 202.2 194.4 200 200 200C211 200 220 209 220 220C220 225.6 217.8 230.6 214.2 234.2L208.2 240H240C251 240 260 231 260 220V160C260 149 269 140 280 140S300 149 300 160V220C300 253.2 273.2 280 240 280zM114.2 214.2C110.6 217.8 105.6 220 100 220H20C9 220 0 211 0 200V20C0 9 9 0 20 0H160C171 0 180 9 180 20V140C180 145.6 177.8 150.6 174.2 154.2L114.2 214.2zM140 40H40V180H80V140C80 129 89 120 100 120H140V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RotateDocument.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RotateDocument.displayName = "Blueprint5.Icon.RotateDocument";
exports.default = RotateDocument;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gM2pU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RotatePage", ()=>RotatePage);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var RotatePage = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "rotate-page",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 360H248.2L254 365.8C257.8 369.4 260 374.4 260 380C260 391 251 400 240 400C234.4 400 229.4 397.8 225.8 394.2L185.8 354.2C182.2 350.6 180 345.6 180 340C180 334.4 182.2 329.4 185.8 325.8L225.8 285.8C229.4 282.2 234.4 280 240 280C251 280 260 289 260 300C260 305.6 257.8 310.6 254.2 314.2L248.2 320H280C302 320 320 302 320 280V220C320 209 329 200 340 200S360 209 360 220V280C360 324.2 324.2000000000001 360 280 360zM240 260H60C49 260 40 251 40 240V20C40 9 49 0 60 0H240C251 0 260 9 260 20V240C260 251 251 260 240 260zM220 40H80V220H220V40z" : "M160 200H40C29 200 20 191 20 180V20C20 9 29 0 40 0H160C171 0 180 9 180 20V180C180 191 171 200 160 200zM140 40H60V160H140V40zM240 280H208.2L214 285.8C217.8 289.4 220 294.4 220 300C220 311 211 320 200 320C194.4 320 189.4 317.8 185.8 314.2L145.8 274.2C142.2 270.6 140 265.6 140 260C140 254.4 142.2 249.4 145.8 245.8L185.8 205.8C189.4 202.2 194.4 200 200 200C211 200 220 209 220 220C220 225.6 217.8 230.6 214.2 234.2L208.2 240H240C251 240 260 231 260 220V160C260 149 269 140 280 140S300 149 300 160V220C300 253.2 273.2 280 240 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
RotatePage.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
RotatePage.displayName = "Blueprint5.Icon.RotatePage";
exports.default = RotatePage;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b6l5S":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Route = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "route",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280.55342 279.6899548C283.483428 274.1776762 286.760102 268.2857864 290.26609 262.2412462C296.344764 251.7612298 302.824644 241.306349 309.302882 231.3318858L311.6600000000001 227.7899548L307.5073280000001 227.8912026L295.9691900000001 228.0009226C254.108024 227.9100448 239.13746 221.9377054 239.13746 210.0993832C239.13746 208.726132 244.560846 205.1410794 264.036 198.756862L284.195582 192.504342C337.619642 175.877018 363.999834 155.960166 363.999834 109.156762C363.999834 53.95534 325.442724 27.986186 267.355856 21.641754C251.727588 19.934786 236.958826 19.680014 218.329216 20.32431L195.3264632 21.241948L124.42 21.24L135.1274054 37.469792C142.675676 49.091768 150.2245876 61.081596 157.5631282 73.196418L198.354868 73.193646L212.08168 72.60922C232.645962 71.686342 247.47887 71.73426 262.540848 73.379376C299.17062 77.380196 315.99984 88.715108 315.99984 109.156762C315.99984 122.960768 306.342754 130.978344 276.16348 140.860464L259.568354 146.004438C235.724294 153.288626 218.810956 160.006284 207.764242 169.292604C215.737496 189.294768 220 206.1702008 220 220.06C219.951432 234.8207776 217.252432 248.9567564 212.355102 262.0138912C227.254202 273.4803678 250.0428 278.4681244 280.55342 279.6899548zM100 316C152.9655172 316 195.8257714 272.98 196 220.06C196 166.96 100 28 100 28L90.016 42.87664C65.44 80.1496 4 177.58 4 220.06C4 272.98 47.0344828 316 100 316zM100 268C73.504 268 52 246.496 52 220C52 193.504 73.504 172 100 172C126.496 172 148 193.504 148 220C148 246.496 126.496 268 100 268zM340 393.33333334C369.425288 393.33333334 393.23654 369.4333334 393.3333340000001 340.0333334C393.3333340000001 310.5333334 340 233.3333334 340 233.3333334L332.1778940000001 245.0707108C317.3602860000001 267.8231074000001 286.666666 317.654023 286.666666 340.0333334C286.666666 369.4333334 310.574712 393.33333334 340 393.33333334z" : "M233.377944 218.6822578C234.029752 217.4418622 234.683576 216.183999 235.357652 214.9065578C237.61257 210.6332572 240.0700760000001 206.2143398 242.699566 201.6809346C247.22658 193.8760804 252.050288 186.089814 256.874874 178.656459L252.922894 178.7426396L243.307764 178.8270396C208.423398 178.7571336 195.947909 174.1630186 195.947909 165.0566016C195.947909 164.0002528 200.467406 161.2425154 216.696728 156.3315708L233.496408 151.5219312C278.016532 138.7316616 299.999992 123.4109802 299.999992 87.4083C299.999992 44.945596 267.869082 24.969292 219.463278 20.088952C206.4397 18.775896 194.132378 18.579918 178.607677 19.07553L159.4386836 19.781408L103.92 19.786396L109.2728378 27.891492C115.9969562 38.244534 122.721685 48.947864 129.2322248 59.75427L161.9623584 59.74432L173.4013874 59.29476C190.5383188 58.584852 202.899096 58.621712 215.450764 59.887188C245.975626 62.964748 259.999992 71.683926 259.999992 87.4083C259.999992 98.026784 251.952414 104.194162 226.802978 111.795804L212.973684 115.752714C192.1765186 121.6173764 177.7064846 127.0046306 168.546831 134.6797312C176.0013966 152.687586 180 167.7691864 180 180.05C179.9695808 189.295013 178.6915062 198.2459106 176.3257308 206.7420516C189.228452 214.6367422 208.289206 217.9813982 233.377944 218.6822578zM80 260C124.137931 260 159.8548094 224.15 160 180.05C160 135.8 80 20 80 20L71.68 32.3972C51.2 63.458 0 144.65 0 180.05C0 224.15 35.862069 260 80 260zM80 220C57.92 220 40 202.08 40 180C40 157.92 57.92 140 80 140C102.08 140 120 157.92 120 180C120 202.08 102.08 220 80 220zM280 300C302.068966 300 319.927404 282.075 320 260.025C320 237.9 280 180 280 180L274.13342 188.8030332C263.020214 205.8673306 240 243.2405172 240 260.025C240 282.075 257.931034 300 280 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Route.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Route.displayName = "Blueprint5.Icon.Route";
exports.default = Route;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jDvLc":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Satellite", ()=>Satellite);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Satellite = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "satellite",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M180 40C192 40 200 32 200 20S192 0 180 0C80 0 0 80 0 180C0 192 8 200 20 200S40 192 40 180C40 102 102 40 180 40zM180 120C192 120 200 112 200 100S192 80 180 80C124 80 80 124 80 180C80 192 88 200 100 200S120 192 120 180C120 146 146 120 180 120zM294 194C302 202 314 202 322 194L394 122C402 114 402 102 394 94L366 66C358.0000000000001 58.0000000000001 346 58.0000000000001 338.0000000000001 66L266.0000000000001 138C258.0000000000001 146 258.0000000000001 158 266.0000000000001 166L294 194zM94 394C102 402 114 402 122 394L194 322C202 314 202 302 194 294L166 266C158 258 146 258 138 266L66 338C58 346 58 358 66 366L94 394zM316 374C324 382 336 382 344 374L376 342C384 334 384 322 376 314L246 184C238 176 226 176 218 184L186 216C178 224 178 236 186 244.0000000000001L316 374zM180 160C168 160 160 168 160 180S168 200 180 200S200 192 200 180S192 160 180 160z" : "M60 140C60 152 68 160 80 160S100 152 100 140C100 118 118 100 140 100C152 100 160 92 160 80S152 60 140 60C96 60 60 96 60 140zM0 140C0 152 8 160 20 160S40 152 40 140C40 84 84 40 140 40C152 40 160 32 160 20S152 0 140 0C62 0 0 62 0 140zM140 120C128 120 120 128 120 140S128 160 140 160S160 152 160 140S152 120 140 120zM166 176C158 184 158 196 166 204L256 294C264 302 276 302 284 294L294 284C302 276 302 264 294 256L204 166C196 158 184 158 176 166L166 176zM104 314C112 322 124 322 132 314L174 272C182 264 182 252 174 244L156 226C148 218 136 218 128 226L86 268C78 276 78 288 86 296L104 314zM244 174C252 182 264 182 272 174L314 132C322 124 322 112 314 104L296 86C288 78 276 78 268 86L226 128C218 136 218 148 226 156L244 174z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Satellite.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Satellite.displayName = "Blueprint5.Icon.Satellite";
exports.default = Satellite;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"24WzM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Saved", ()=>Saved);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Saved = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "saved",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 400H80C69 400 60 391 60 380V20C60 9 69 0 80 0H340C351 0 360 9 360 20V280L240 400zM320 40H100V360H220V260H320V40zM154.2 174.2C150.6 177.8 145.6 180 140 180C129 180 120 171 120 160C120 154.4 122.2 149.4 125.8 145.8L185.8 85.8C189.4 82.2 194.4 80 200 80C206.4 80 211.8 83.2 215.4 87.6L215.6 87.4L295.6 187.4L295.4 187.6C298.2 191.2 300 195.2 300 200C300 211 291 220 280 220C273.6 220 268.2 216.8 264.6 212.4L264.4000000000001 212.6L198.4 130L154.2 174.2z" : "M134.2 134.2C130.6 137.8 125.6 140 120 140C109 140 100 131 100 120C100 114.4 102.2 109.4 105.8 105.8L145.8 65.8C149.4 62.2 154.4 60 160 60C167.8 60 174.4 64.6 177.8 71.2L178 71.2L218 151.2L217.8 151.2C219 153.8 220 156.8 220 160C220 171 211 180 200 180C192.2 180 185.6 175.4 182.2 168.8L182 168.8L154.4 113.6L134.2 134.2zM180 320H60C49 320 40 311 40 300V20C40 9 49 0 60 0H260C271 0 280 9 280 20V220L180 320zM240 40H80V280H160V200H240V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Saved.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Saved.displayName = "Blueprint5.Icon.Saved";
exports.default = Saved;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jaGex":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScatterPlot", ()=>ScatterPlot);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ScatterPlot = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "scatter-plot",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M180 220C202 220 220 238 220 260C220 282 202 300 180 300S140 282 140 260C140 238 158 220 180 220zM280 180C302 180 320 198 320 220C320 242 302 260 280 260S240 242 240 220C240 198 258 180 280 180zM360 280C382 280 400 298 400 320C400 342 382 360 360 360S320 342 320 320C320 298 338 280 360 280zM380 80H40V340C40 351 31 360 20 360S0 351 0 340V60C0 49 9 40 20 40H380C391 40 400 49 400 60S391 80 380 80zM100 100C122 100 140 118 140 140C140 162 122 180 100 180S60 162 60 140C60 118 78 100 100 100z" : "M300 80H40V260C40 271 31 280 20 280S0 271 0 260V60C0 49 9 40 20 40H300C311 40 320 49 320 60S311 80 300 80zM290 220C306.6 220 320 233.4 320 250S306.6 280 290 280S260 266.6 260 250S273.4 220 290 220zM230 140C246.6 140 260 153.4 260 170S246.6 200 230 200S200 186.6 200 170S213.4 140 230 140zM150 180C166.6 180 180 193.4 180 210S166.6 240 150 240S120 226.6 120 210S133.4 180 150 180zM90 100C106.6 100 120 113.4 120 130S106.6 160 90 160S60 146.6 60 130S73.4 100 90 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ScatterPlot.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ScatterPlot.displayName = "Blueprint5.Icon.ScatterPlot";
exports.default = ScatterPlot;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5R1as":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchAround", ()=>SearchAround);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SearchAround = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "search-around",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M138 202A60 60 0 0 1 258 202A60 60 0 0 1 138 202M60 120C26 120 0 94 0 60S26 0 60 0S120 26 120 60S94 120 60 120zM60 20C38 20 20 38 20 60C20 82 38 100 60 100S100 82 100 60C100 38 82 20 60 20zM60 400C26 400 0 374 0 340S26 280 60 280S120 306 120 340S94 400 60 400zM60 300C38 300 20 318 20 340C20 362 38 380 60 380S100 362 100 340C100 318 82 300 60 300zM340 120C306 120 280 94 280 60S306 0 340 0S400 26 400 60S374 120 340 120zM340 20C318 20 300 38 300 60C300 82 318 100 340 100S380 82 380 60C380 38 362 20 340 20zM340 400C306 400 280 374 280 340S306 280 340 280S400 306 400 340S374 400 340 400zM340 300C318 300 300 318 300 340C300 362 318 380 340 380S380 362 380 340C380 318 362 300 340 300zM200 200L220 180L120 280L100 300zM107.574 306.57L207.9822 206.1618L193.8402 192.0198L93.432 292.428L107.574 306.57zM200 200L220 180L320 280L300 300zM292.426 306.5700000000001L306.568 292.428L206.1598 192.0198000000001L192.0178 206.1618000000001L292.426 306.5700000000001zM200 200L220 180L320 80L300 100zM207.574 206.572L307.9822000000001 106.1638L293.8402 92.0218L193.432 192.43L207.5740000000001 206.572zM200 200L220 180L120 80L100 100zM192.4260000000001 206.57L206.5680000000001 192.428L106.1598000000001 92.0198L92.0178000000001 106.1618L192.4260000000001 206.57z" : "M270 100C259.8 100 250.4 97 242.4000000000001 91.6L194.4 139.8C197.8 145.8 200 152.6 200 160S197.8 174.2 194.4 180.2L242.6 228.4C250.4 223 259.8 220 270 220C297.6 220 320 242.4 320 270C320 297.6 297.6 320 270 320S220 297.6 220 270C220 259.8 223 250.4 228.4 242.4L180.2 194.4C174.2 197.8 167.4 200 160 200S145.8 197.8 139.8 194.4L91.6 242.4C97 250.4 100 259.8 100 270C100 297.6 77.6 320 50 320S0 297.6 0 270C0 242.4 22.4 220 50 220C60.2 220 69.6 223 77.6 228.4L125.8 180.2C122.2 174.2 120 167.4 120 160S122.2 145.8 125.6 139.8L77.4 91.6C69.6 97 60.2 100 50 100C22.4 100 0 77.6 0 50C0 22.4 22.4 0 50 0S100 22.4 100 50C100 60.2 97 69.6 91.6 77.6L139.8 125.8C145.8 122.2 152.6 120 160 120S174.2 122.2 180.2 125.6L228.4 77.4C223 69.6 220 60.2 220 50C220 22.4 242.4000000000001 0 270 0S320 22.4 320 50C320 77.6 297.6 100 270 100zM270 300C286.6 300 300 286.6 300 270S286.6 240 270 240S240 253.4 240 270S253.4 300 270 300zM50 240C33.4 240 20 253.4 20 270S33.4 300 50 300S80 286.6 80 270S66.6 240 50 240zM50 20C33.4 20 20 33.4 20 50S33.4 80 50 80S80 66.6 80 50S66.6 20 50 20zM270 20C253.4 20 240 33.4 240 50S253.4 80 270 80S300 66.6 300 50S286.6 20 270 20z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SearchAround.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SearchAround.displayName = "Blueprint5.Icon.SearchAround";
exports.default = SearchAround;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cdKfH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchTemplate", ()=>SearchTemplate);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SearchTemplate = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "search-template",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260 240H100C89 240 80 231 80 220C80 209 89 200 100 200H260C271 200 280 209 280 220C280 231 271 240 260 240zM260 180H100C89 180 80 171 80 160C80 149 89 140 100 140H260C271 140 280 149 280 160C280 171 271 180 260 180zM260 300H100C89 300 80 291 80 280C80 269 89 260 100 260H260C271 260 280 269 280 280C280 291 271 300 260 300zM391.2 51.2L326.6 115.8C347.6 145.2 360 181.2 360 220C360 319.4 279.4 400 180 400S0 319.4 0 220C0 120.6 80.6 40 180 40C218.8 40 254.8 52.4 284.2000000000001 73.4L348.8 8.8C354.2000000000001 3.4 361.8 0 370 0C386.6 0 400 13.4 400 30C400 38.2 396.6 45.8 391.2 51.2zM180 80C102.6 80 40 142.6 40 220C40 297.4 102.6 360 180 360S320 297.4 320 220C320 142.6 257.4 80 180 80z" : "M311 51.4L257.6 104.8C271.6 126.6 279.8 152.4 279.8 180.2C279.8 257.6 217.2 320.2 139.8 320.2S-0.2 257.6 -0.2 180.2S62.4 40.2 139.8 40.2C167.6 40.2 193.4 48.4 215.2 62.4L268.6 9C274 3.6 281.6 0.2 289.8 0.2C306.4 0.2 319.8 13.6 319.8 30.2C319.8 38.4 316.4 46 311 51.4zM139.8 80.2C84.6 80.2 39.8 125 39.8 180.2S84.6 280.2 139.8 280.2S239.8 235.4 239.8 180.2S195 80.2 139.8 80.2zM189.8 200.2H89.8C84.2 200.2 79.8 195.8 79.8 190.2S84.2 180.2 89.8 180.2H189.8C195.4 180.2 199.8 184.6 199.8 190.2S195.4 200.2 189.8 200.2zM189.8 240.2H89.8C84.2 240.2 79.8 235.8 79.8 230.2S84.2 220.2 89.8 220.2H189.8C195.4 220.2 199.8 224.6 199.8 230.2S195.4 240.2 189.8 240.2zM189.8 160.2H89.8C84.2 160.2 79.8 155.8 79.8 150.2S84.2 140.2 89.8 140.2H189.8C195.4 140.2 199.8 144.6 199.8 150.2S195.4 160.2 189.8 160.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SearchTemplate.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SearchTemplate.displayName = "Blueprint5.Icon.SearchTemplate";
exports.default = SearchTemplate;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVlB7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchText", ()=>SearchText);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SearchText = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "search-text",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M391.2 51.2L326.6 115.8C347.6 145.2 360 181.2 360 220C360 319.4 279.4 400 180 400S0 319.4 0 220C0 120.6 80.6 40 180 40C218.8 40 254.8 52.4 284.2000000000001 73.4L348.8 8.8C354.2000000000001 3.4 361.8 0 370 0C386.6 0 400 13.4 400 30C400 38.2 396.6 45.8 391.2 51.2zM180 80C102.6 80 40 142.6 40 220C40 297.4 102.6 360 180 360S320 297.4 320 220C320 142.6 257.4 80 180 80zM250 300H110C104.4 300 100 295.6 100 290V250C100 244.4 104.4 240 110 240S120 244.4 120 250V260H160V140H150C144.4 140 140 135.6 140 130C140 124.4 144.4 120 150 120H210C215.6 120 220 124.4 220 130C220 135.6 215.6 140 210 140H200V260H240V250C240 244.4 244.4 240 250 240S260 244.4 260 250V290C260 295.6 255.6 300 250 300z" : "M180 240H100C89 240 80 231 80 220C80 209 89 200 100 200H120V140C120 129 129 120 140 120S160 129 160 140V200H180C191 200 200 209 200 220C200 231 191 240 180 240zM311.2 51.2L257.8 104.6C271.8 126.4 280 152.2 280 180C280 257.4 217.4 320 140 320S0 257.4 0 180C0 102.6 62.6 40 140 40C167.8 40 193.6 48.2 215.4 62.2L268.8 8.8C274.2000000000001 3.4 281.8 0 290 0C306.6 0 320 13.4 320 30C320 38.2 316.6 45.8 311.2 51.2zM140 80C84.8 80 40 124.8 40 180S84.8 280 140 280S240 235.2 240 180S195.2 80 140 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SearchText.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SearchText.displayName = "Blueprint5.Icon.SearchText";
exports.default = SearchText;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9kMiy":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Search", ()=>Search);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Search = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "search",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M391.2 51.2L292.4 150C309.8 175.8 320 206.6 320 240C320 328.4 248.4 400 160 400S0 328.4 0 240S71.6 80 160 80C193.4 80 224.2 90.2 250 107.6L348.8 8.8C354.2000000000001 3.4 361.8 0 370 0C386.6 0 400 13.4 400 30C400 38.2 396.6 45.8 391.2 51.2zM160 120C93.8 120 40 173.8 40 240S93.8 360 160 360S280 306.2000000000001 280 240S226.2 120 160 120z" : "M311 51.4L257.6 105C271.6 126.8 279.8 152.6 279.8 180.2C279.8 257.6 217.2 320.2 139.8 320.2S-0.2 257.6 -0.2 180.2S62.4 40.2 139.8 40.2C167.6 40.2 193.4 48.6 215 62.4L268.6 9C274 3.6 281.6 0.2 289.8 0.2C306.4 0.2 319.8 13.6 319.8 30.2C319.8 38.4 316.4 46 311 51.4zM139.8 80.2C84.6 80.2 39.8 125 39.8 180.2S84.6 280.2 139.8 280.2S239.8 235.4 239.8 180.2S195 80.2 139.8 80.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Search.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Search.displayName = "Blueprint5.Icon.Search";
exports.default = Search;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eAdkM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SegmentedControl", ()=>SegmentedControl);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SegmentedControl = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "segmented-control",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 300H20C9 300 0 291 0 280V120C0 109 9 100 20 100H380C391 100 400 109 400 120V280C400 291 391 300 380 300zM360 140H200V260H360V140z" : "M300 240H20C9 240 0 231 0 220V100C0 89 9 80 20 80H300C311 80 320 89 320 100V220C320 231 311 240 300 240zM280 120H160V200H280V120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SegmentedControl.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SegmentedControl.displayName = "Blueprint5.Icon.SegmentedControl";
exports.default = SegmentedControl;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lanex":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Select = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "select",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M394.2000000000001 34.2L309.2000000000001 119.2000000000001L400 141.8L198.6 213.4C199.4 215.4 200 217.6 200 220V340C200 351 191 360 180 360H80V380C80 391 71 400 60 400S40 391 40 380V360H20C9 360 0 351 0 340C0 329 9 320 20 320H40V220C40 209 49 200 60 200H180C182.4 200 184.6 200.6 186.8 201.4L258.2 0L281 90.8L366 5.8C369.4 2.2 374.4 0 380 0C391 0 400 9 400 20C400 25.6 397.8 30.6 394.2000000000001 34.2zM160 240H80V320H160V240z" : "M320 20C320 25.6 317.6 30.4 313.8 33.8L314.2 34.2L251.8 96.6L320 113.4L159 170.6C159.6 172.4 160 174 160 176V280C160 291 151 300 140 300H60C60 311 51 320 40 320S20 311 20 300C9 300 0 291 0 280C0 269 9 260 20 260V180C20 169 29 160 40 160H144C146 160 147.6 160.4 149.4 161L206.6 0L223.6 68.2L286 5.8L286.4 6.2C289.6 2.4 294.4000000000001 0 300 0C300.8 0 301.4 0.4 302 0.4C302.6 0.4 303.2 0 304 0C312.8 0 320 7.2 320 16C320 16.8 319.6 17.4 319.6 18C319.6 18.6 320 19.2 320 20zM120 200H60V260H120V200z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Select.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Select.displayName = "Blueprint5.Icon.Select";
exports.default = Select;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1szIJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Selection", ()=>Selection);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Selection = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "selection",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 40C111.6 40 40 111.6 40 200S111.6 360 200 360S360 288.4 360 200S288.4 40 200 40zM120 200A80 80 0 0 1 280 200A80 80 0 0 1 120 200" : "M160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM160 40C93.8 40 40 93.8 40 160S93.8 280 160 280S280 226.2 280 160S226.2 40 160 40zM160 220C126.8 220 100 193.2 100 160S126.8 100 160 100S220 126.8 220 160S193.2 220 160 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Selection.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Selection.displayName = "Blueprint5.Icon.Selection";
exports.default = Selection;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fzKKf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SendBackward", ()=>SendBackward);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SendBackward = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "send-backward",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M214.142 5.858C206.332 -1.952 193.6684 -1.952 185.8578 5.858L105.8578 85.858C98.0474 93.668 98.0474 106.332 105.8578 114.142C113.6684 121.952 126.3316 121.952 134.1422 114.142L180 68.284L180 180L20 180C8.95432 180 -9.65646e-7 188.954 0 200C9.65646e-7 211.0458 8.95432 220 20 220L180 220V280L20 280C8.95432 280 0.00000602818 288.9544 0.00000699382 300L0.0000157361 360C0.00001670174 371.0456 8.95434 380 20 380L380 380C391.046 380 400 371.0456 400 360V300C400 288.9542 391.046 280 380 280L220 280V220L380 220C391.046 220 400 211.0456 400 200C400 188.954 391.046 180 380 180L220 180L220 68.284L265.858 114.142C273.668 121.952 286.332 121.952 294.142 114.142C301.952 106.332 301.952 93.668 294.142 85.858L214.142 5.858zM0 400H400V0H0V400z" : "M146.0588 5.8C149.6564 2.2 154.6534 0 160.05 0C165.4466 0 170.6434 2.2 174.2412 5.8L234.204 65.6C237.802 69.4 240 74.4 240 79.8C240 90.8 231.006 99.8 220.012 99.8C214.416 99.8 209.42 97.6 205.822 94L180.0374 68.2C180.0374 92.134 180 116.066 180 139.9994L300 139.9994C311.046 139.9994 320 148.9538 320 159.9994C320 171.0452 311.046 179.9994 300 179.9994L180 179.9994L180 219.9994L300 219.9994C311.046 219.9994 320 228.9538 320 239.9994L320 279.9994C320 291.0452 311.046 299.9994 300 299.9994L20 299.9994C8.95432 299.9994 0.000025444 291.0452 0.0000244784 279.9994L0.0000209814 239.9994C0.0000200158 228.9538 8.95432 219.9994 20 219.9994L140 219.9994L140 179.9994L20 179.9994C8.95432 179.9994 0.00001495324 171.0452 0.0000139876 159.9994C0.00001302194 148.9538 8.9543 139.9994 20 139.9994L140 139.9994L140 68.284L140.0624 68.284L140.0624 68.2L114.2786 94C110.6808 97.6 105.684 99.8 100.2874 99.8C89.2942 99.8 80.2998 90.8 80.2998 79.8C80.2998 74.2 82.4984 69.2 86.0962 65.6L146.0588 5.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SendBackward.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SendBackward.displayName = "Blueprint5.Icon.SendBackward";
exports.default = SendBackward;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hPpp4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SendMessage", ()=>SendMessage);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SendMessage = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "send-message",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M35.078 397.29388L387.8520000000001 218.7998C399.25 213.0322 403.358 199.94 397.024 189.558C394.884 186.048 391.706 183.154 387.8520000000001 181.204L35.078 2.71C23.6788 -3.058 9.30416 0.682 2.9713 11.064C1.022616 14.26 0 16.346 0 20V160L220 200L0 240V378.496C0 390.37232 10.57112 400 23.6112 400C27.6238 400 31.5702 399.068648 35.078 397.29388z" : "M307.9700000000001 139.808L30.5496 2.492C19.83024 -2.838 7.03736 0.874 2.11212 11.046C0.65286 14.06 0 16.634 0 19.982V120L160 160L0 200V299.9874C0 310.5661 8.14606 320 20.076 320C23.458 320 28.3928 319.208706 31.4142 317.6894L308.058 178.5794C318.752 173.2014 323.062 160.1724 317.684 149.478C315.578 145.2888 312.168 141.8956 307.9700000000001 139.808z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SendMessage.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SendMessage.displayName = "Blueprint5.Icon.SendMessage";
exports.default = SendMessage;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"etLwb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SendToGraph", ()=>SendToGraph);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SendToGraph = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "send-to-graph",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 180H60C49 180 40 171 40 160S49 140 60 140H111.8L6 34.2C2.2 30.6 0 25.6 0 20C0 9 9 0 20 0C25.6 0 30.6 2.2 34.2 5.8L140 111.8V60C140 49 149 40 160 40S180 49 180 60V160C180 171 171 180 160 180zM360 140C349.4 140 339.8 135.8 332.6 129L238 188C239.2 191.8 240 195.8 240 200C240 204.2 239.2 208.2 238 212L332.4000000000001 271C339.8 264.2 349.4 260 360 260C382 260 400 278 400 300S382 340 360 340S320 322 320 300C320 295.8 320.8 291.8 322 288L227.4000000000001 228.8C222.6 233.4000000000001 216.6 236.8000000000001 210 238.4000000000001V321.4C227.2 325.8 240 341.4 240 360C240 382 222 400 200 400S160 382 160 360C160 341.4 172.8 325.8 190 321.4V238.6C183.4 236.8 177.4 233.4 172.6 229L152 241.8L108.4 269L78 288C79.2 291.8 80 295.8 80 300C80 322 62 340 40 340S0 322 0 300S18 260 40 260C50.6 260 60.2 264.2 67.4 271L180 200.8V200H181.2L240 163.2L248 158.2L278.2 139.4L322 112C320.8 108.2 320 104.2000000000001 320 100C320 78 338 60 360 60S400 78 400 100S382 140 360 140zM220 199.2L218.8 200H220V199.2z" : "M120 140H40C29 140 20 131 20 120C20 109 29 100 40 100H71.8L6 34.2C2.2 30.6 0 25.6 0 20C0 9 9 0 20 0C25.6 0 30.6 2.2 34.2 5.8L100 71.8V40C100 29 109 20 120 20S140 29 140 40V120C140 131 131 140 120 140zM280 130C268.8 130 258.8 125.4 251.6 118.2L209 143L179.8 160L251.6 201.8C258.8 194.6 268.8 190 280 190C302 190 320 208 320 230S302 270 280 270S240 252 240 230C240 226.2 240.6 222.6 241.6 219.2L170 177.4V241.4C187.2 245.8 200 261.4 200 280C200 302 182 320 160 320S120 302 120 280C120 261.4 132.8 245.8 150 241.4V177.4L132.4 187.8L78.4 219.2C79.4 222.6 80 226.2 80 230C80 252 62 270 40 270S0 252 0 230S18 190 40 190C51.2 190 61.2 194.6 68.4 201.8L111 177L187.8 132.2L241.8 100.8C240.6 97.4 240 93.8 240 90C240 68 258 50 280 50S320 68 320 90S302 130 280 130z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SendToGraph.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SendToGraph.displayName = "Blueprint5.Icon.SendToGraph";
exports.default = SendToGraph;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7pmeH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SendToMap", ()=>SendToMap);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SendToMap = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "send-to-map",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 180H60C49 180 40 171 40 160S49 140 60 140H111.8L6 34.2C2.2 30.6 0 25.6 0 20C0 9 9 0 20 0C25.6 0 30.6 2.2 34.2 5.8L140 111.8V60C140 49 149 40 160 40S180 49 180 60V160C180 171 171 180 160 180zM390.8 316.4L391 316.8L271 396.8L270.8 396.4C267.8 398.4 264.2000000000001 400 260 400S252.2 398.4 249.2 396.4L249.0000000000001 396.8L140 324L31 396.6L30.8 396.4C27.8 398.4 24.2 400 20 400C9 400 0 391 0 380V200C0 211 9 220 20 220H40V342.6L120 289.2V220H160V289.2L240 342.6V110.6L220 97.2000000000001V49.2L260 75.8L369 3.2L369.2000000000001 3.6C372.2 1.6 375.8 0 380 0C391 0 400 9 400 20V300C400 307 396.2 312.8 390.8 316.4zM360 57.4L280 110.8V342.6L360 289.2V57.4z" : "M120 140H40C29 140 20 131 20 120C20 109 29 100 40 100H71.8L6 34.2C2.2 30.6 0 25.6 0 20C0 9 9 0 20 0C25.6 0 30.6 2.2 34.2 5.8L100 71.8V40C100 29 109 20 120 20S140 29 140 40V120C140 131 131 140 120 140zM311 256.6L311 256.6L221.2 316.6C221.2 316.6 221.2 316.6 221.2 316.6L221.2 316.6L221.2 316.6C218 318.8 214.2 320 210 320C206.2 320 202.8 318.8 199.8 317L199.8 317L110.6 263.6L31.2 316.6C31.2 316.6 31.2 316.6 31.2 316.6L31.2 316.6L31.2 316.6C28 318.8 24.2 320 20 320C9 320 0 311 0 300V180H40V262.6L98.8 223.4C98.8 223.4 98.8 223.4 98.8 223.4L98.8 223.4L98.8 223.4C99.2 223.2 99.6 223 100 222.8V180H120V222.8C120 222.8 120.2 222.8 120.2 223L120.2 223L200 270.6V97.2C200 97.2 199.8 97.2 199.8 97L199.8 97L180 85.4V38.8L209.4 56.4L288.8 3.4C288.8 3.4 288.8 3.4 288.8 3.4L288.8 3.4L288.8 3.4C292 1.2 295.8 0 300 0C311 0 320 9 320 20V240C320 247 316.4 253 311 256.6zM280 57.4L221.2 96.6C221.2 96.6 221.2 96.6 221.2 96.6L221.2 96.6L221.2 96.6C220.8 96.8 220.4 96.9999999999999 220.2 97.2V269.2L280.2 229.2V57.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SendToMap.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SendToMap.displayName = "Blueprint5.Icon.SendToMap";
exports.default = SendToMap;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9fomE":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SendTo", ()=>SendTo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SendTo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "send-to",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400H280C268 400 260 392 260 380S268 360 280 360H332L246 274C242 270 240 266 240 260C240 248 248 240 260 240C266 240 270 242 274 246L360 332V280C360 270 370 260 380 260S400 270 400 280V380C400 392 390 400 380 400L380 400zM380 220C360 220 342 230 330 246L302 218C292 206 276 200 260 200C226 200 200 226 200 260C200 276 206 292 218 302L246 330C230 342 220 360 220 380C220 386 222 392 224 398C216 400 208 400 200 400C90 400 0 310 0 200S90 0 200 0S400 90 400 200C400 208 400 216 398 224C392 222 386 220 380 220L380 220z" : "M300 170C284 170 270 178 260 190L236 166C228 156 214 152 200 152C172 150 150 172 150 200C150 214 156 226 164 236L190 260C178 270 170 284 170 300C170 306 172 314 174 320C170 320 164 320 160 320C72 320 0 248 0 160S72 0 160 0S320 72 320 160C320 164 320 170 320 174C314 172 308 170 300 170L300 170zM300 320H220C208 320 200 310 200 300S208 280 220 280H252L186 214C182 210 180 206 180 200C180 190 188 180 200 180C206 180 210 182 214 186L280 252V220C280 208 288 200 300 200C310 200 320 208 320 220V300C320 310 312 320 300 320L300 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SendTo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SendTo.displayName = "Blueprint5.Icon.SendTo";
exports.default = SendTo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3OllA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sensor", ()=>Sensor);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Sensor = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "sensor",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360.0000000000001 40.0000000000001L40.0000000000001 40.0000000000001L40.0000000000001 80.0000000000001L360.0000000000001 80.0000000000001L360.0000000000001 40.0000000000001zM320 80L80 80L122.4374 115.364C126.0316 118.36 130.5622 120 135.241 120L264.758 120C269.438 120 273.968 118.36 277.562 115.364L320 80zM180 160A20 20 0 0 1 220 160A20 20 0 0 1 180 160M273.702 199.202C281.698 206.7996 282.098 219.3962 274.502 227.394C231.32 272.7818 164.347 268.9828 125.3632 227.194C117.7662 219.1962 118.366 206.3996 126.3628 199.002C134.3594 191.404 147.1542 192.004 154.551 200.0014C178.3412 225.5944 218.724 227.7938 245.314 199.802C253.11 192.004 265.706 191.604 273.702 199.202zM64.093 271.9314C58.0956 263.9336 58.0956 249.9374 68.0914 243.939C76.0882 237.9406 90.0824 237.9406 96.0798 247.9378C122.0692 281.9288 158.0542 299.9238000000001 200.036 299.9238000000001C240.02 299.9238000000001 282.004 279.9292 303.9940000000001 247.9378C309.992 237.9406 321.986 235.941 331.982 243.939C337.98 247.9378 339.98 253.9362 339.98 259.9346000000001C339.98 263.9336 337.98 267.9324000000001 335.98 271.9314C305.994 313.9202 254.014 339.9132 200.036 339.9132C144.06 341.7126 98.079 315.9196 64.093 271.9314z" : "M300.0000000000001 20.0000000000001L20 20.0000000000001L20 60.0000000000001L300.0000000000001 60.0000000000001L300.0000000000001 20.0000000000001zM260 60L60 60L94.1422 94.142C97.8928 97.892 102.98 100 108.2842 100H211.716C217.02 100 222.108 97.892 225.858 94.142L260 60zM103.978 196.9246C97.379 188.1288 99.1788 175.5346 107.9772 168.9378C116.7758 162.3408 129.3736 164.14 135.9726 172.9358C142.3716 181.5318 175.166 183.5308 184.5644 172.1362C191.5632 163.7402 204.162 162.5408 212.76 169.5374C221.158 176.5342 222.358 189.1282 215.36 197.7242C188.7636 229.5094 125.3744 225.5112 103.978 196.9246zM46.05 234.4474C38.0512 226.6512 38.0512 214.057 45.65 206.2606C53.2488 198.4644 66.0466 198.0646 74.0452 205.661C120.8374 251.4396 199.2242 251.4396 246.016 205.661C253.814 197.8646 266.612 198.0646 274.212 206.0608C281.81 214.057 281.81 226.6512 273.812 234.2476C211.622 295.219 108.4394 295.219 46.05 234.4474zM140 140A20 20 0 0 1 180 140A20 20 0 0 1 140 140",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Sensor.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Sensor.displayName = "Blueprint5.Icon.Sensor";
exports.default = Sensor;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ydZf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeriesAdd", ()=>SeriesAdd);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SeriesAdd = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "series-add",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M265.8 214.2C271.8 201.8000000000001 281.8 191.8 294.2 185.8L234.2 125.8C230.6 122.2 225.6 120 220 120S209.4 122.2 205.8 126L140 191.8L40 91.8V60H380C391 60 400 51 400 40S391 20 380 20H20C11.8 20 4.6 25 1.6 32.2C0.6 34.6 0 37.2 0 40V320C0 331 9 340 20 340S40 331 40 320V148.2L125.8 234.2C129.4 237.8 134.4 240 140 240S150.6 237.8 154.2 234.2L220 168.2L265.8 214.2zM240 300C240 310 248 320 260 320H300V360C300 372 308 380 320 380C330 380 340 372 340 360V320H380C390 320 400 312 400 300S390 280 380 280H340V240C340 228 330 220 320 220C308 220 300 228 300 240V280H260C248 280 240 288 240 300z" : "M213.6 162C222.4 151.2 235 143.6 249.4 141L194.2 85.8C190.6 82.2 185.6 80 180 80S169.4 82.2 165.8 86L100 151.8L40 91.8V60H300C311 60 320 51 320 40S311 20 300 20H20C9 20 0 29 0 40V240C0 251 9 260 20 260S40 251 40 240V148.2L85.8 194.2C89.4 197.8 94.4 200 100 200S110.6 197.8 114.2 194.2L180 128.2L213.6 162zM300 260C311 260 320 251 320 240S311 220 300 220H280V200C280 189 271 180 260 180S240 189 240 200V220H220C209 220 200 229 200 240S209 260 220 260H240V280C240 291 249 300 260 300S280 291 280 280V260H300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SeriesAdd.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SeriesAdd.displayName = "Blueprint5.Icon.SeriesAdd";
exports.default = SeriesAdd;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"leJHU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeriesConfiguration", ()=>SeriesConfiguration);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SeriesConfiguration = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "series-configuration",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M238.2 186.6C248.6 177.6 260.8 170.6 274.2000000000001 166L234.0000000000001 125.8C230.4 122.2 225.4 120 219.8 120C214.2 120 209.2 122.2 205.6 126L140 191.8L40 91.8V60H379.8C390.8 60 399.8 51 399.8 40S390.8 20 379.8 20H20C11.8 20 4.6 25 1.6 32.2C0.6 34.6 0 37.2 0 40V320C0 331 9 340 20 340C31 340 40 331 40 320V148.2L125.8 234.2C129.4 237.8 134.4 240 140 240C145.6 240 150.6 237.8 154.2 234.2L220 168.2L238.2 186.6zM370 308H390.8C395.8 308 399.8 304 400 299.2V281.2C400 276.2 396 272.2 391 272.2H370.2000000000001C368.8 267.8 367 263.8 364.8000000000001 259.8L379.4000000000001 245.2C382.8000000000001 241.8 382.8000000000001 236.4 379.4000000000001 233L367.2000000000001 220.8C363.8 217.4 358.4000000000001 217.4 355.0000000000001 220.8L340.4000000000001 235.4000000000001C336.4000000000001 233.2000000000001 332.4000000000001 231.4000000000001 328.0000000000001 230.2000000000001V209.2C328.0000000000001 204.2 324.0000000000001 200.2000000000001 319.0000000000001 200.2000000000001H301.0000000000001C296.0000000000001 200.2000000000001 292.0000000000001 204.2 292.0000000000001 209.2V229.8C287.8000000000001 231 284.0000000000001 232.8 280.4000000000001 234.8L265.2000000000001 219.4C261.8000000000001 216 256.0000000000001 216 252.4000000000001 219.4L239.6000000000001 232.2C236.2000000000001 235.6 236.2000000000001 241.4000000000001 239.6000000000001 245.0000000000001L254.8000000000001 260.4000000000001C252.8000000000001 264.2000000000001 251.0000000000001 268 249.8000000000001 272.2000000000001H229.0000000000001C224.0000000000001 272.2000000000001 220.0000000000001 276.2000000000001 220.0000000000001 281.2000000000001V299.2000000000001C220.0000000000001 304.2000000000001 224.0000000000001 308.2000000000001 229.0000000000001 308.2000000000001H249.8000000000001C251.2000000000001 312.6 253.0000000000001 316.6 255.2000000000001 320.4000000000001L240.6 335C237.2 338.4000000000001 237.2 343.8 240.6 347.2000000000001L252.8 359.4000000000001C256.2 362.8 261.6 362.8 265 359.4000000000001L279.6 344.8C283.6 347 287.6 348.8 292 350.0000000000001V371C291.8 376 296 380 300.8 380H318.8C323.8 380 327.8 376 327.8 371V350C332 348.8 335.8 347 339.4 345L354.6 360.4C358.0000000000001 363.8 363.8 363.8 367.4000000000001 360.4L380.2000000000001 347.6C383.6000000000001 344.2 383.6000000000001 338.4 380.2000000000001 334.8L365 319.4C367 316 368.8 312.2 370 308zM276.2 290C276.2 271.4 291.2 256.2000000000001 310 256.2000000000001C328.6 256.2000000000001 343.8 271.2000000000001 343.8 290S328.8 323.8 310.0000000000001 323.8C291.2 323.8 276.2 308.6 276.2 290z" : "M198.8 127.2C211.8 122.6 225.6 120 240 120C242.8 120 245.8 120.2 248.6 120.2L194 65.8C190.4 62.2 185.4 60 179.8 60C174.2 60 169.2 62.2 165.6 66L100 131.8L40 71.8V40H299.8C310.8 40 319.8 31 319.8 20S310.8 0 299.8 0H20C9 0 0 9 0 20V220C0 231 9 240 20 240C31 240 40 231 40 220V128.2L85.8 174.2C89.4 177.8 94.4 180 100 180C105.6 180 110.6 177.8 114.2 174.2L180 108.2L198.8 127.2zM293.4 256H311.8C316.2 256 319.8 252.4 319.8 248V232C319.8 227.6 316.2 224 311.8 224H293.2C292 220 290.4 216.4 288.4 213L301.6 200C304.6 197 304.6 192 301.6 189L290.8 178C287.8 175 282.8 175 279.8 178L266.8 191C263.4 189 259.6 187.4 255.8 186.2V168C255.8 163.6 252.2 160 247.8 160H231.8C227.3999999999999 160 223.7999999999999 163.6 223.7999999999999 168V186.6C220.1999999999999 187.8 216.5999999999999 189.2 213.3999999999999 191L199.8 177.4C196.8 174.2 191.6 174.2 188.4 177.4L177.2 188.6C174.2 191.8 174.2 196.8 177.2 200L190.8 213.6C189.2 216.8 187.6 220.2 186.4 224H167.8C163.4 224 159.8 227.6 159.8 232V248C159.8 252.4 163.4 256 167.8 256H186.4C187.6 260 189.2 263.6 191.2 267L178.2 279.8C175.2 282.8 175.2 287.8 178.2 290.8L189 301.8C192 304.8 196.8 304.8 199.8 301.8L212.8 288.8C216.4 290.8 220 292.4 223.8 293.6V312C223.8 316.4 227.4 320 231.8 320H247.8C252.2 320 255.8 316.4 255.8 312V293.4C259.4000000000001 292.2 262.8 290.6 266.2 289L279.8 302.6C282.8 305.8 288 305.8 291.2 302.6L302.6 291.2C305.6 288 305.6 283 302.6 279.8L289 266.2C290.8 263 292.2 259.6 293.4 256zM209.8 240C209.8 223.4 223.2 210 239.8 210C256.4 210 269.8 223.4 269.8 240C269.8 256.6 256.4 270 239.8 270C223.4 270 209.8 256.6 209.8 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SeriesConfiguration.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SeriesConfiguration.displayName = "Blueprint5.Icon.SeriesConfiguration";
exports.default = SeriesConfiguration;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Rzza":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeriesDerived", ()=>SeriesDerived);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SeriesDerived = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "series-derived",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M376.4 268.4C375.8 267.4 375 266.6 374.2000000000001 265.8C374.2000000000001 265.8 374.2000000000001 266 374 266L334 226C330 222 326 220 320 220C308 220 300 228 300 240C300 246 302 250 306 254L332 280H220C208 280 200 288 200 300S208 320 220 320H332L306 346C302 350 300 354 300 360C300 372 308 380 320 380C326 380 330 378 334 374L394 314C398 310 400 306 400 300S398 290 394 286L376.4 268.4zM265.8 214.2C271.8 201.8000000000001 281.8 191.8 294.2 185.8L234.2 125.8C230.6 122.2 225.6 120 220 120S209.4 122.2 205.8 126L140 191.8L40 91.8V60H380C391 60 400 51 400 40S391 20 380 20H20C11.8 20 4.6 25 1.6 32.2C0.6 34.6 0 37.2 0 40V320C0 331 9 340 20 340S40 331 40 320V148.2L125.8 234.2C129.4 237.8 134.4 240 140 240S150.6 237.8 154.2 234.2L220 168.2L265.8 214.2z" : "M213.2 161.6C222 150.8 234.6 143.4 249.2 141L194.2 86C190.6 82.2 185.6 80 180 80S169.4 82.2 165.8 86L100 151.8L40 91.8V60H300C311 60 320 51 320 40S311 20 300 20H20C9 20 0 29 0 40V240C0 251 9 260 20 260S40 251 40 240V148.2L85.8 194.2C89.4 197.8 94.4 200 100 200S110.6 197.8 114.2 194.2L180 128.2L213.2 161.6zM246 214L252 220H160C148 220 140 228 140 240S148 260 160 260H252L246 266C242 270 240 274 240 280C240 292 250 300 260 300C266 300 270 298 274 294L314 254C318 250 320 246 320 240S318 230 314 226L274 186C270 182 266 180 260 180C248 180 240 188 240 200C240 206 242 210 246 214z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SeriesDerived.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SeriesDerived.displayName = "Blueprint5.Icon.SeriesDerived";
exports.default = SeriesDerived;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5mCuI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeriesFiltered", ()=>SeriesFiltered);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SeriesFiltered = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "series-filtered",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M242.8 191C247.0000000000001 177.6 255.8 166.4 267.2000000000001 158.8L234.2 125.8C230.6 122.2 225.6 120 220 120S209.4 122.2 205.8 126L140 191.8L40 91.8V60H380C391 60 400 51 400 40S391 20 380 20H20C11.8 20 4.6 25 1.6 32.2C0.6 34.6 0 37.2 0 40V320C0 331 9 340 20 340S40 331 40 320V148.2L125.8 234.2C129.4 237.8 134.4 240 140 240S150.6 237.8 154.2 234.2L220 168.2L242.8 191zM387 380C394.2000000000001 380 400 374.2 400 367.2C400 363.6 398.6 360.4 396.2 358L335.6 297.4V238.4C335.6 234.8 334.2 231.6 331.8 229.2L306.2 203.4C304 201.4 300.8 200 297.2 200C290.2 200 284.4 205.8 284.4 212.8V297.4L223.8 358C221.4 360.4 220 363.6 220 367.2C220 374.2 225.8 380 232.8 380H387z" : "M185.8 134C191.8 121.6 201.8 111.6 214.2 105.8L194.2 85.8C190.6 82.2 185.6 80 180 80S169.4 82.2 165.8 86L100 151.8L40 91.8V60H300C311 60 320 51 320 40S311 20 300 20H20C9 20 0 29 0 40V240C0 251 9 260 20 260S40 251 40 240V148.2L85.8 194.2C89.4 197.8 94.4 200 100 200S110.6 197.8 114.2 194.2L180 128.2L185.8 134zM309.6 300C315.8 300 320 294.8 320 288.6C320 285.4 318.8 282.6 316.6 280.4L259.4000000000001 225.8V173.2C259.4000000000001 170 258.2 167.2 256 165L239.6 143C237.6 141 234.6 139.6 231.4 139.6C225.2 139.6 220 144.8 220 151V225.8L163.4 280.4C161.2 282.6 160 285.4 160 288.6C160 294.8 165.2 300 171.4 300H309.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SeriesFiltered.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SeriesFiltered.displayName = "Blueprint5.Icon.SeriesFiltered";
exports.default = SeriesFiltered;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Jn4j":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeriesSearch", ()=>SeriesSearch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SeriesSearch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "series-search",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M225.6 173.8L220 168.2L154.2 234.2C150.6 237.8 145.6 240 140 240S129.4 237.8 125.8 234.2L40 148.2V320C40 331 31 340 20 340S0 331 0 320V40C0 37.2 0.6 34.6 1.6 32.2C4.6 25 11.8 20 20 20H380C391 20 400 29 400 40C400 51 391 60 380 60H40V91.8L140 191.8L205.8 126C209.4 122.2 214.4 120 220 120S230.6 122.2 234.2 125.8L276 167.6C272.6 167.2 269.2000000000001 167.2 265.8 167.2C251.8 167.2 238.2 169.6 225.6 173.8zM207 293.8C207 326.2000000000001 233.2 352.4000000000001 265.6 352.4000000000001S324.2000000000001 326.2000000000001 324.2000000000001 293.8S298 235.2 265.6 235.2S207 261.4 207 293.8zM336.4 245.2C338.6 248.6 340.6 251.8 342.2 255.4C342.4000000000001 256 342.8 256.6 343 257.2C344.5999999999999 260.8 346.2 264.2 347.2 268C348.4 272 349.2000000000001 275.6 350 279.6C350.2000000000001 280.6 350.2000000000001 281.4 350.4 282.4C351 286.4 351.4 290.2 351.4 294.4C351.4 341.8 312.8 380.4 265.4 380.4C218 380.2 179.4 341.8 179.4 294.2S218 208.2 265.4 208.2C269.6 208.2 273.4 208.6 277.4 209.2C278.2 209.2 279.2 209.4 280.2 209.6C284.2 210.2 287.8 211.2 291.6 212.4C295.6 213.6 299 215.2000000000001 302.6 216.6C303.2 216.8000000000001 303.8 217.2 304.4000000000001 217.4C308 219.2 311.2 221.2 314.6 223.2L372 165.8C374.8000000000001 163 378.6 161.4 383.2 161.4C391.8 161.4 398.8 168.4 398.8 177C398.6 181.2 396.8 185.2 394.2000000000001 188.2L336.4 245.2z" : "M192 141.2C198.2 140 204.4 139.4 211 139.4C215 139.4 219 139.6 223 140.2C224.8 140.4 226.2 140.6 228.4 141C230.4 141.2 232.8 141.8 236.2 142.6L240.8 144C241.6 144.2 242.4 144.4 243 144.8L247.4 140.4L193.4 85.9999999999999C189.8 82.2 184.8 80 179.2 80S168.6 82.2 165 86L99.6 151.8L39.8 91.8V60H298.6C309.6 60 318.6 51 318.6 40C318.6 29 309.6 20 298.6 20H20C9 20 0 29 0 40V240.2C0 251.2 9 260.2 20 260.2S40 251.2 40 240.2V148.4L85.6 194.4C89 198 94 200.2 99.6 200.2S110.2 198 113.6 194.4L179.2 128.4L192 141.2zM316.4 149.4C318.4 147 319.8 144 320 140.6C320 133.8 314.6 128.4 307.8 128.4C304.2000000000001 128.4 301.2 129.8 299.2000000000001 132L254.4 177C251.8 175.4 249.2 173.8 246.4 172.4C246 172.2 245.4 172 245 171.8C242.2 170.6 239.6 169.4 236.6 168.4H236.4C233.6 167.4 230.6 166.8 227.6 166.2C226.8000000000001 166 226 165.8 225.4000000000001 165.8C222.4 165.4 219.4 165 216.2 165C179.2 165 149.2 195.2 149.2 232.4S179.2 299.8 216.2 300C253.2 300 283.2 269.8 283.2 232.6C283.2 229.4 282.8 226.4 282.4000000000001 223.2C282.2000000000001 222.4 282.2000000000001 221.8 282 221C281.6 218 281 215.2 280 212.2V212C279 209 277.8 206.4 276.6 203.6C276.4 203.2 276.2 202.6 276 202.2C274.6 199.4 273.2 196.8 271.4 194.2L316.4 149.4zM216.2 188.2C240.6 188.2 260.4 208 260.4 232.6C260.4 257.2000000000001 240.6 277 216.2 277C191.8 277 172 257.2000000000001 172 232.6C172 208.2 191.8 188.2 216.2 188.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SeriesSearch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SeriesSearch.displayName = "Blueprint5.Icon.SeriesSearch";
exports.default = SeriesSearch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8wrbZ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerInstall", ()=>ServerInstall);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ServerInstall = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "server-install",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M345.8 314.0958C349.4 317.6922 354.4 319.89 360 319.89C371 319.89 380 310.899 380 299.9100000000001C380 294.3156 377.8 289.3206 374.2000000000001 285.7242L314.2000000000001 225.7842C310.6 222.1878000000001 305.4000000000001 219.99 300 219.99C294.6 219.99 289.6 222.1878000000001 285.8 225.7842L225.8 285.7242C222.2 289.3206 220 294.3156 220 299.9100000000001C220 310.8992 229 319.8902000000001 240 319.8902000000001C245.6 319.8902000000001 250.6 317.6922 254.2 314.0958000000001L280 288.3216V380.0082C280 391.0498 288.948 399.9944 299.99 400C311.04 400.0054 320 391.0576 320 380.008V288.3216L345.8 314.0958zM265.348 400C261.9460000000001 394.12 260 387.2928 260 380.008V334.6104000000001C254.08 337.9976 247.234 339.89 240 339.89C217.974 339.89 200 321.9636 200 299.91C200 288.9446 204.354 278.8778 211.664 271.575L271.856 211.444L272.052 211.2582C279.238 204.4584 289.05 199.99 300 199.99V125C300 111.192 288.808 100 275 100H125C111.1928 100 100 111.192 100 125V375C100 388.8072 111.1928 400 125 400H265.348zM80 185.482L7.8556 133.112C-1.48 125.974 -2.6736 112.828 5.2364 104.262L95.259 6.768C99.232 2.464 104.9478 0 110.9528 0H289.048C295.052 0 300.7680000000001 2.464 304.742 6.768L394.7640000000001 104.262C402.6740000000001 112.828 401.48 125.974 392.1440000000001 133.112L320 185.482V125C320 100.148 299.852 80 275 80H125C100.1472 80 80 100.148 80 125V185.482z" : "M285.8 234.0858C289.4 237.6822 294.4 239.88 300 239.88C311 239.88 320 230.889 320 219.9C320 214.3056 317.8 209.3106 314.2000000000001 205.7142L254.2 145.7742C250.6 142.1778000000001 245.4000000000001 139.9800000000001 240 139.9800000000001C234.6 139.9800000000001 229.6 142.1778000000001 225.8 145.7742L165.8 205.7142C162.2 209.3106 160 214.3056 160 219.9C160 230.889 169 239.88 180 239.88C185.6 239.88 190.6 237.6822 194.2 234.0858L220 208.3116V299.998C220 311.04 228.948 319.9844 239.99 319.99C251.04 319.9954 260 311.0476 260 299.998V208.3116L285.8 234.0858zM151.665 191.565L211.856 131.434L212.052 131.2482C219.238 124.4484 229.05 119.98 240 119.98V100C240 88.954 231.046 80 220 80H100C88.9544 80 80 88.954 80 100V300C80 311.0458 88.9544 320 100 320H205.354C201.948 314.1178 200 307.2868 200 299.998V254.6004C194.0796 257.9876 187.2338 259.88 180 259.88C157.9732 259.88 140 241.9536 140 219.9C140 208.9346 144.3548 198.8678 151.665 191.565zM260 125.2848C263.0420000000001 127.0178 265.854 129.1458 268.336 131.625L274.1260000000001 137.4096L311.074 112.83C321.242 106.066 323.028 91.874 314.8540000000001 82.808L246.14 6.62C242.338 2.406 236.924 0 231.242 0H88.7574C83.0758 0 77.661 2.406 73.8602 6.62L5.1462 82.808C-3.0286 91.874 -1.2418 106.066 8.9262 112.83L60 146.807V100C60 77.908 77.9086 60 100 60H220C242.092 60 260 77.908 260 100V125.2848z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ServerInstall.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ServerInstall.displayName = "Blueprint5.Icon.ServerInstall";
exports.default = ServerInstall;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dHgqo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Server", ()=>Server);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Server = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "server",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M275 400C288.808 400 300 388.8072 300 375V125C300 111.192 288.808 100 275 100H125C111.1928 100 100 111.192 100 125V375C100 388.8072 111.1928 400 125 400H275zM230 360C224.478 360 220 355.5228 220 350V330C220 324.4772000000001 224.478 320 230 320H250C255.522 320 260 324.4772000000001 260 330V350C260 355.5228 255.522 360 250 360H230zM220 270V250C220 244.4772 224.478 240 230 240H250C255.522 240 260 244.4772 260 250V270C260 275.5228 255.522 280 250 280H230C224.478 280 220 275.5228 220 270zM230 200C224.478 200 220 195.522 220 190V170C220 164.478 224.478 160 230 160H250C255.522 160 260 164.478 260 170V190C260 195.522 255.522 200 250 200H230zM80 185.482V125C80 100.148 100.1472 80 125 80H275C299.852 80 320 100.148 320 125V185.482L392.144 133.112C401.48 125.974 402.674 112.828 394.764 104.262L304.742 6.768C300.768 2.464 295.052 0 289.048 0H110.9528C104.9478 0 99.232 2.464 95.259 6.768L5.2364 104.262C-2.6736 112.828 -1.48 125.974 7.8556 133.112L80 185.482z" : "M220 320C231.046 320 240 311.0458 240 300V100C240 88.954 231.046 80 220 80H100C88.9544 80 80 88.954 80 100V300C80 311.0458 88.9544 320 100 320H220zM200 266.6666C200 274 194 280 186.6666 280H173.3334C166 280 160 274 160 266.6666V253.3334C160 246 166 240 173.3334 240H186.6666C194 240 200 246 200 253.3334V266.6666zM200 193.3334V206.6666C200 214 194 220 186.6666 220H173.3334C166 220 160 214 160 206.6666V193.3334C160 186 166 180 173.3334 180H186.6666C194 180 200 186 200 193.3334zM200 146.6666C200 154 194 160 186.6666 160H173.3334C166 160 160 154 160 146.6666V133.3334C160 126 166 120 173.3334 120H186.6666C194 120 200 126 200 133.3334V146.6666zM8.926 112.83L60 146.807V100C60 77.908 77.9086 60 100 60H220C242.092 60 260 77.908 260 100V146.807L311.074 112.83C321.242 106.066 323.028 91.874 314.854 82.808L246.14 6.62C242.338 2.406 236.924 0 231.242 0H88.7574C83.0758 0 77.661 2.406 73.8602 6.62L5.1462 82.808C-3.0286 91.874 -1.2418 106.066 8.9262 112.83z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Server.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Server.displayName = "Blueprint5.Icon.Server";
exports.default = Server;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dgWGZ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Settings", ()=>Settings);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Settings = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "settings",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 380C80 391 71 400 60 400S40 391 40 380V280H80V380zM40 20C40 9 49 0 60 0S80 9 80 20V140H40V20zM220 380C220 391 211 400 200 400S180 391 180 380V220H220V380zM360 380C360 391 351 400 340 400S320 391 320 380V320H360V380zM180 20C180 9 189 0 200 0S220 9 220 20V80H180V20zM360 300H320C309 300 300 291 300 280V220C300 209 309 200 320 200H360C371 200 380 209 380 220V280C380 291 371 300 360 300zM320 20C320 9 329 0 340 0S360 9 360 20V180H320V20zM80 260H40C29 260 20 251 20 240V180C20 169 29 160 40 160H80C91 160 100 169 100 180V240C100 251 91 260 80 260zM220 200H180C169 200 160 191 160 180V120C160 109 169 100 180 100H220C231 100 240 109 240 120V180C240 191 231 200 220 200z" : "M60 300C60 311 51 320 40 320S20 311 20 300V240H60V300zM60 220H20C9 220 0 211 0 200V160C0 149 9 140 20 140H60C71 140 80 149 80 160V200C80 211 71 220 60 220zM300 300C300 311 291 320 280 320S260 311 260 300V260H300V300zM180 300C180 311 171 320 160 320S140 311 140 300V180H180V300zM20 20C20 9 29 0 40 0S60 9 60 20V120H20V20zM300 240H260C249 240 240 231 240 220V180C240 169 249 160 260 160H300C311 160 320 169 320 180V220C320 231 311 240 300 240zM260 20C260 9 269 0 280 0S300 9 300 20V140H260V20zM180 160H140C129 160 120 151 120 140V100C120 89 129 80 140 80H180C191 80 200 89 200 100V140C200 151 191 160 180 160zM140 20C140 9 149 0 160 0S180 9 180 20V60H140V20z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Settings.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Settings.displayName = "Blueprint5.Icon.Settings";
exports.default = Settings;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6yEyz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Shapes", ()=>Shapes);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Shapes = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "shapes",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M157.5864028 177.61821C166.5515942 182.546628 177.9903592 179.580442 183.1355996 170.993044L183.1355996 170.993044L257.516596 46.851302C259.1437880000001 44.13552 260 41.05887 260 37.92761C260 28.026464 251.620418 20 241.28368 20L241.28368 20L98.7201054 20C95.6838246 20 92.693128 20.707562 90.0060144 22.061646C80.8579836 26.671498 77.343471 37.511958 82.1561306 46.274488L82.1561306 46.274488L150.3387098 170.41623C151.9922902 173.426946 154.506055 175.924856 157.5864028 177.61821zM300 300C344.18278 300 380 264.18278 380 220C380 175.81722 344.18278 140 300 140C255.81722 140 220 175.81722 220 220C220 264.18278 255.81722 300 300 300zM160 380C171.045695 380 180 371.045695 180 360L180 240C180 228.954305 171.045695 220 160 220L40 220C28.954305 220 20 228.954305 20 240L20 360C20 371.045695 28.954305 380 40 380L160 380z" : "M118.4121872 157.2293096C127.2091482 162.8527168 138.526284 159.6447622 143.6897176 150.0641428L143.6897176 150.0641428L197.4589014 50.296792C199.1227852 47.209498 200 43.694534 200 40.114714C200 29.005664 191.7309654 20 181.5305946 20L181.5305946 20L78.4729922 20C75.4185326 20 72.4117548 20.825028 69.7219222 22.4012C60.7392232 27.664826 57.3752944 39.86245 62.208377 49.645354L62.208377 49.645354L111.4967954 149.4127042C113.1006618 152.6591768 115.4929012 155.3631728 118.4121872 157.2293096zM240 240C273.137084 240 300 213.137085 300 180C300 146.862915 273.137084 120 240 120C206.862916 120 180 146.862915 180 180C180 213.137085 206.862916 240 240 240zM120 300C131.045695 300 140 291.045695 140 280L140 200C140 188.954305 131.045695 180 120 180L40 180C28.954305 180 20 188.954305 20 200L20 280C20 291.045695 28.954305 300 40 300L120 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Shapes.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Shapes.displayName = "Blueprint5.Icon.Shapes";
exports.default = Shapes;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4381R":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Share", ()=>Share);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Share = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "share",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 40H40V300H215.2L255.2 340H20C9 340 0 331 0 320V20C0 9 9 0 20 0H320C331 0 340 9 340 20V255.2L300 215.2V40zM380 400H240C229 400 220 391 220 380C220 369 229 360 240 360H331.8L185.8 214.2C182.2 210.6 180 205.6 180 200C180 189 189 180 200 180C205.6 180 210.6 182.2 214.2 185.8L360 331.8V240C360 229 369 220 380 220S400 229 400 240V380C400 391 391 400 380 400z" : "M219.8 40.2H39.8V220.2H135L175 260.2H19.8C8.8 260.2 -0.2 251.2 -0.2 240.2V20.2C-0.2 9.2 8.8 0.2 19.8 0.2H239.8C250.8 0.2 259.8 9.2 259.8 20.2V175.2L219.8 135.2V40.2zM299.8 320.2H199.8C188.8 320.2 179.8 311.2 179.8 300.2S188.8 280.2 199.8 280.2H251.6L145.8 174.4C142 170.6 139.8 165.6 139.8 160.2C139.8 149.2 148.8 140.2 159.8 140.2C165.4 140.2 170.4 142.4 174 146L279.8 251.8V200C279.8 189 288.8 180 299.8 180S319.8 189 319.8 200V300C319.8 311.2 310.8 320.2 299.8 320.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Share.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Share.displayName = "Blueprint5.Icon.Share";
exports.default = Share;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"642KR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SharedFilter", ()=>SharedFilter);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SharedFilter = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "shared-filter",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M278.34 55.826C298.548 46.75 329.202 37.262 335.8 22.962C341.986 8.524 339.512 0 339.512 0H120.5344C120.5344 0 117.9228 8.524 124.246 22.962C130.5692 37.4 161.0858 47.024 181.4302 55.962C201.774 64.9 199.7126 70.4 200.4 77.826C200.4 78.788 200.538 79.75 200.538 80.712C193.3892 86.9 187.4784 95.562 183.767 105.462L183.6294 105.6C183.6294 105.738 183.492 105.874 183.492 106.012C182.5298 108.074 181.8424 110.412 181.2926 112.75C176.619 113.574 173.8696 118.662 172.77 123.474C171.6704 125.4 169.471 130.076 170.0208 135.438C170.708 142.45 173.5948 145.612 176.7564 146.85V147.95C176.7564 156.75 177.4438 169.262 179.0932 177.512C179.3682 179.85 179.918 182.188 180.6054 184.388C183.6294 194.562 189.9528 203.6376 198.338 209.9626C206.86 216.5626 219.094 220 229.954 220C240.814 220 253.048 216.5626 261.708 209.9626C270.23 203.6376 276.416 194.424 279.44 184.388C280.128 182.05 280.678 179.85 280.952 177.512C282.464 169.262 283.29 156.612 283.29 147.95V146.712C286.314 145.474 289.062 142.312 289.75 135.438C290.1620000000001 130.076 288.1 125.4 287 123.474C286.038 118.8 283.29 113.712 278.616 112.75C278.066 110.55 277.378 108.212 276.554 106.15C276.416 106.012 276.278 105.462 276.278 105.462C272.568 95.7 266.932 87.174 259.92 80.988C259.92 79.888 259.92 78.788 260.058 77.826C260.746 70.2620000000001 257.9960000000001 64.762 278.34 55.826zM299.516 68.602C294.7080000000001 70.5700000000001 290.414 72.328 286.534 74.0699999999999L286.384 74.136C284.838 74.816 283.556 75.426 282.5 75.9640000000001C286.984 81.72 290.686 88.132 293.574 94.886L293.6 94.912L293.868 95.584C294.228 96.446 294.576 97.314 294.908 98.186L295.124 98.724C295.23 98.99 295.336 99.258 295.438 99.526C297.54 101.352 299.236 103.334 300.552 105.206C303.136 108.876 304.814 112.816 305.854 116.45C307.954 120.984 310.358 128.308 309.692 136.972L309.6740000000001 137.2L309.65 137.428C308.99 144.036 306.906 150.416 303.13 155.608C302.814 163.764 302.024 173.21 300.73 180.532C300.246 184.208 299.4000000000001 187.406 298.628 190.03L298.5900000000001 190.158C295.624 200.001 290.446 209.3686 283.332 217.2148C288.74 219.0578 294.538 220 299.958 220C309.83 220 320.952 216.875 328.826 210.875C336.574 205.125 342.1960000000001 196.75 344.946 187.624C345.5700000000001 185.5 346.07 183.5 346.32 181.374C347.696 173.874 348.444 162.374 348.444 154.5V153.374C351.194 152.25 353.694 149.376 354.3180000000001 143.126C354.694 138.25 352.818 134 351.8180000000001 132.25C350.944 128 348.444 123.374 344.1960000000001 122.5C343.696 120.5 343.072 118.374 342.322 116.5C342.1960000000001 116.374 342.072 115.874 342.072 115.874C338.698 107 333.574 99.25 327.2 93.624C327.2 92.624 327.2 91.626 327.326 90.75C327.406 89.872 327.4340000000001 89.024 327.462 88.196C327.654 82.546 327.814 77.836 343.946 70.75C347.778 69.03 352.022 67.292 356.396 65.502C372.99 58.712 391.434 51.164 396.182 40.874C401.806 27.75 399.556 20 399.556 20H357.934C357.05 23.374 355.83 26.998 354.184 30.84L354.076 31.092L353.9600000000001 31.342C350.3 39.272 344.14 44.968 338.764 48.94C333.202 53.05 326.856 56.486 320.838 59.38C314.756 62.302 308.348 64.978 302.512 67.374L299.516 68.602zM280 380C291 380 300 371 300 360C300 354.4 297.8 349.4 294.2000000000001 346L200 251.8V233.8698C195.1064 231.7736 190.4244 229.1146 186.1948 225.8544C174.487 216.9898 165.7198 204.3994 161.4738 190.218C160.5914 187.372 159.8004 184.142 159.3358 180.688C157.9256 173.272 157.1946 163.964 156.9064 155.95C153.0202 150.772 150.8016 144.316 150.1204 137.43C149.192 128.262 151.9118 120.616 154.0128 116.216C155.0818 112.654 156.7734 108.7 159.4054 105.008C160.5278 103.434 161.9296 101.77 163.6294 100.19V97.318L164.6732 96.274L134.2 65.8C130.6 62.2 125.6 60 120 60C109 60 100 69 100 80V251.8L5.8 345.8C2.2 349.4 0 354.4 0 360C0 371 9 380 20 380H280zM181.1722 112.772C176.5716 113.662 173.8602 118.704 172.77 123.474C171.6704 125.4 169.471 130.074 170.0208 135.438C170.708 142.45 173.5948 145.612 176.7564 146.85V147.95C176.7564 156.75 177.4438 169.262 179.0932 177.512C179.3682 179.85 179.918 182.188 180.6054 184.388C183.6294 194.562 189.9528 203.6376 198.338 209.9626C198.8776 210.3804 199.432 210.7856 200 211.178V140C200 134.4 197.8 129.4 194.2 125.8L181.1722 112.772z" : "M276.858 16.738C281.5060000000001 6.154 279.622 0 279.622 0H120.3366C120.3366 0 118.5778 6.154 123.1004 16.738C127.6226 27.322 149.8572 34.338 164.6804 40.862C179.3778 47.508 177.8702 51.446 178.3728 56.862C178.3728 57.478 178.4984 58.214 178.4984 58.954C173.348 63.262 169.077 69.538 166.3134 76.8V76.922C166.3134 76.922 166.1876 77.046 166.1876 77.168C165.6852 78.646 165.0572 80.368 164.6804 81.968C161.163 82.586 159.153 86.4 158.3994 89.846C157.6456 91.322 156.0126 94.646 156.3894 98.586C156.8918 103.632 159.0274 105.968 161.2886 106.954V107.692C161.2886 113.968 161.9166 123.2 163.0472 129.1078C163.2984 130.7078 163.6752 132.4308 164.1778 134.0308C166.3134 141.4154 170.9614 147.9386 176.991 152.6154C183.272 157.4154 192.191 160 200.104 160C208.02 160 216.938 157.4154 223.22 152.6154C229.248 147.9386 233.896 141.4154 236.032 133.9078C236.534 132.3078 236.912 130.5846 237.162 128.9846C238.294 123.0768 238.922 113.968 238.922 107.692V106.832C241.182 105.846 243.192 103.508 243.57 98.586C243.946 94.646 242.438 91.322 241.56 89.846C240.806 86.4 238.922 82.708 235.53 82.092C235.152 80.492 234.65 78.892 234.022 77.292C234.022 77.168 233.896 76.8 233.896 76.8C231.132 69.662 226.988 63.508 221.964 58.954V56.738C222.464 51.2 220.456 47.262 235.278 40.738C250.102 34.214 272.336 27.322 276.858 16.738zM297.05 20H319.67C319.67 20 321.318 25.384 317.252 34.646C314.0660000000001 42.1 300.842 47.462 289.038 52.246C286.176 53.406 283.398 54.532 280.868 55.646C269.558 60.624 269.448 63.882 269.314 67.848C269.294 68.43 269.274 69.026 269.218 69.646V71.584C273.614 75.568 277.242 80.954 279.6600000000001 87.2C279.6600000000001 87.2 279.7680000000001 87.522 279.7680000000001 87.632C280.318 89.032 280.7580000000001 90.432 281.088 91.832C284.056 92.368 285.704 95.6 286.366 98.616C287.134 99.906 288.452 102.816 288.122 106.262C287.794 110.568 286.034 112.616 284.056 113.478V114.232C284.056 119.722 283.506 127.6922 282.516 132.8616C282.298 134.2616 281.966 135.7694 281.528 137.1694C279.6600000000001 143.7384 275.592 149.4462 270.318 153.5384C264.82 157.7384 257.016 160 250.092 160C248.308 160 246.464 159.8498 244.618 159.555C249.342 153.8338 253.034 147.1016 255.198 139.6288C255.96 137.1466 256.502 134.6618 256.868 132.416C257.826 127.2778 258.434 120.8578 258.722 115.086C261.516 110.702 263.068 105.564 263.496 100.292C264.164 92.838 262.194 86.63 260.32 82.604C259.454 79.782 258.1 76.594 255.984 73.532C255.056 72.19 253.888 70.752 252.464 69.364C250.866 65.278 248.908 61.348 246.61 57.658C247.836 57.152 249.206 56.592 250.668 55.994C256.368 53.668 263.4460000000001 50.78 268.646 48.262C273.176 46.07 278.166 43.35 282.614 39.978C286.872 36.752 292.13 31.822 295.204 24.704C295.908 23.094 296.52 21.524 297.05 20zM242.788 37.594C243.392 37.348 244.002 37.102 244.616 36.852zM220 300C231 300 240 291 240 280C240 274.4 237.8 269.4 234.2 266L160 191.8V164.3188C153.1796 157.7344 147.8314 149.3474 145.0278 139.8016C144.2514 137.2868 143.7076 134.7822 143.343 132.5454C142.3954 127.4616 141.7906 121.076 141.4978 115.326C138.6844 111.03 137.0228 105.942 136.4876 100.566L136.4802 100.49C136.0642 96.142 136.5956 92.216 137.4096 89.01L114.2 65.8C110.6 62.2 105.6 60 100 60C89 60 80 69 80 80V191.8L5.8 265.8C2.2 269.4 0 274.4 0 280C0 291 9 300 20 300H220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SharedFilter.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SharedFilter.displayName = "Blueprint5.Icon.SharedFilter";
exports.default = SharedFilter;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i3xYB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Shield", ()=>Shield);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Shield = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "shield",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 0C320 76.190476 380 180.95238 380 314.2857142000001C340 314.2857142000001 280 342.8571428 200 400C120 342.8571428 60 314.2857142000001 20 314.2857142000001C20 180.95238 80 76.190476 200 0zM200 346.9693256C251.549258 312.278675 295.5223880000001 289.3705758 333.345966 278.5886604C324.5513360000001 186.047024 280.620436 111.514582 200 52.645212L200 346.9693256z" : "M160 0C253.333334 60.95238 300 144.7619048 300 251.4285714C268.888888 251.4285714 222.222222 274.2857142000001 160 320C97.7777778 274.2857142000001 51.1111112 251.4285714 20 251.4285714C20 144.7619048 66.6666666 60.95238 160 0zM160 277.5754604C200.093868 249.82294 234.295192 231.4964608 263.71353 222.8709284C256.873262 148.8376194 222.704784 89.211664 160 42.116168L160 277.5754604z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Shield.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Shield.displayName = "Blueprint5.Icon.Shield";
exports.default = Shield;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ibnHm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ship", ()=>Ship);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Ship = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "ship",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M136.7842 383.92232L129.9998 350H70C58.9542 350 50 341.0456 50 330V232.1428L18.4134 223.1182C8.1172 220.1764 1.955086 209.6542 4.57716 199.272C13.77092 162.87 27.8314 112.154 38.5992 87.852C34.2344 87.622 29.7024 87.5 25 87.5C18.09638 87.5 12.49994 81.904 12.49994 75C12.49994 68.096 18.09638 62.5 25 62.5C76.6658 62.5 110.358 76.086 129.0322 85.414C142.7806 76.096 166.6564 62.5 200 62.5C233.01 62.5 256.74 75.826 270.552 85.134L270.66 85.076C275.544 82.458 282.674 79.076 292.046 75.728C310.812 69.026 338.48 62.5 375 62.5C381.904 62.5 387.5 68.096 387.5 75C387.5 81.904 381.904 87.5 375 87.5C368.534 87.5 362.392 87.722 356.57 88.124C358.164 90.032 359.428 92.276 360.24 94.792L393.638 198.164C397.116 208.9294 390.978 220.4346 380.1 223.5428L350 232.1428V330C350 341.0456 341.046 350 330 350H270L263.216 383.92232C261.346 393.2708 253.138 400 243.604 400H156.3958C146.8622 400 138.654 393.2708 136.7842 383.92232zM100 246.4286L175 267.8572000000001V300H100V246.4286zM225 267.8572000000001L300 246.4286V300H225V267.8572000000001zM124.0972 61.018C128.2902 63.264 133.3946 62.936 137.2654 60.172C148.6394 52.048 169.1936 37.5 200 37.5C230.806 37.5 251.36 52.048 262.734 60.172C267.064 63.264 272.874 63.276 277.216 60.208L277.366 60.106C277.532 59.994 278.266 59.526 278.266 59.526C279.132 58.984 280.532 58.148 282.466 57.112C286.33 55.042 292.326 52.174 300.454 49.272C316.688 43.474 341.52 37.5 375 37.5C381.904 37.5 387.5 31.904 387.5 25C387.5 18.096 381.904 12.5 375 12.5C338.48 12.5 310.812 19.026 292.046 25.728C282.674 29.076 275.544 32.458 270.66 35.076L270.552 35.134C256.74 25.826 233.01 12.5 200 12.5C166.6564 12.5 142.7806 26.096 129.0322 35.414C110.358 26.086 76.6658 12.5 25 12.5C18.09638 12.5 12.49994 18.096 12.49994 25C12.49994 31.904 18.09638 37.5 25 37.5C78.2166 37.5 109.589 53.246 124.0972 61.018z" : "M108.7844 303.92232L104 280H60C48.9544 280 40 271.0456 40 260V185.7142L18.41346 179.5466C8.11726 176.605 1.955562 166.076 4.60586 155.7008C11.92338 127.0552 22.5362 89.23 30.775 70.518C30.81 70.438 30.8456 70.36 30.8816 70.282C27.3892 70.098 23.7628 70 20 70C14.47716 70 10 65.522 10 60C10 54.478 14.47716 50 20 50C61.3326 50 88.2864 60.868 103.2258 68.332C114.2246 60.878 133.3252 50 160 50C186.4074 50 205.392 60.66 216.44 68.106L216.528 68.06C220.436 65.966 226.138 63.26 233.636 60.582C248.648 55.222 270.784 50 300 50C305.522 50 310 54.478 310 60C310 65.522 305.522 70 300 70C294.108 70 288.55 70.232 283.326 70.642C286.098 72.97 288.272 76.082 289.472 79.792L313.6380000000001 154.5922C317.116 165.358 310.978 176.8632 300.1 179.9712L280 185.7142V260C280 271.0456 271.046 280 260 280H216L211.216 303.92232C209.346 313.2708 201.138 320 191.6038 320H128.396C118.8624 320 110.654 313.2708 108.7844 303.92232zM80 197.1428L140 214.2858V240H80V197.1428zM180 214.2858L240 197.1428V240H180V214.2858zM99.2778 48.814C102.6322 50.612 106.7158 50.35 109.8124 48.138C118.9116 41.638 135.355 30 160 30C184.645 30 201.088 41.638 210.188 48.138C213.652 50.612 218.3 50.62 221.772 48.166L221.892 48.084C222.026 47.996 222.612 47.62 222.612 47.62C223.306 47.188 224.426 46.518 225.972 45.69C229.064 44.034 233.862 41.74 240.364 39.418C253.352 34.778 273.216 30 300 30C305.522 30 310 25.522 310 20C310 14.478 305.522 10 300 10C270.784 10 248.648 15.222 233.636 20.582C226.138 23.26 220.436 25.966 216.528 28.06L216.44 28.106C205.392 20.66 186.4074 10 160 10C133.3252 10 114.2246 20.878 103.2258 28.332C88.2864 20.868 61.3326 10 20 10C14.47716 10 10 14.478 10 20C10 25.522 14.47716 30 20 30C62.5732 30 87.6712 42.596 99.2778 48.814z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Ship.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Ship.displayName = "Blueprint5.Icon.Ship";
exports.default = Ship;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vuIS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Shop", ()=>Shop);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Shop = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "shop",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M358.8 327.4C358.6 327.8 358.6 328 358.4000000000001 328.2L357.8 330L357.6 330C354 336 347.8 340 340.4 340H60.4C52 340 45 335 42 327.8L42 327.8L42 327.8C42 327.8 42 327.8 42 327.8L0 230H0.4C0.4 202.4 22.8 180 50.4 180S100.4 202.4 100.4 230C100.4 202.4 122.8 180 150.4 180S200.4 202.4 200.4 230C200.4 202.4 222.8 180 250.4 180S300.4 202.4 300.4 230C300.4 202.4 322.8 180 350.4 180S400.4 202.4 400.4 230H400.4L358.8 327.4zM60.4 360H340.4C351.4 360 360.4 369 360.4 380C360.4 391 351.4 400 340.4 400H60.4C49.4 400 40.4 391 40.4 380C40.4 369 49.2 360 60.4 360zM320.4 80H80.4V160H40.4V20C40.4 9 49.4 0 60.4 0H340.4C351.4 0 360.4 9 360.4 20V160H320.4V80z" : "M60 280H260C271 280 280 289 280 300C280 311 271 320 260 320H60C49 320 40 311 40 300C40 289 49 280 60 280zM240 60H80V120H40V20C40 9 49 0 60 0H260C271 0 280 9 280 20V120H240V60zM320 180L299.8 243.4C298 252.8 289.8 260 280 260H40C30.2 260 22 252.8 20.4 243.4L0.2 180H0C0 158 18 140 40 140S80 158 80 180C80 158 98 140 120 140S160 158 160 180C160 158 178 140 200 140S240 158 240 180C240 158 258 140 280 140S320 158 320 180L320 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Shop.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Shop.displayName = "Blueprint5.Icon.Shop";
exports.default = Shop;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XfUC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShoppingCart", ()=>ShoppingCart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ShoppingCart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "shopping-cart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 120H174.4L161 160H340C348.8 160 356 165.8 358.8 173.8L359.0000000000001 173.8L399.0000000000001 293.8L398.8 293.8C399.4 295.8 400 297.8 400 300C400 311 391 320 380 320H107.8L99 346.4L98.8 346.4C96 354.2 88.8 360 80 360H20C9 360 0 351 0 340C0 329 9 320 20 320H65.6L132.2 120H100C78 120 60 102 60 80C60 58 78 40 100 40S140 58 140 80H320C320 58 338 40 360 40S400 58 400 80C400 102 382 120 360 120zM121 280H352.2L325.6 200H147.8L121 280z" : "M280 120H154.4L147.8 140H260C267.8 140 274.4000000000001 144.6 277.8 151.2L278 151.2L318 231.2L317.8 231.2C319 233.8 320 236.8 320 240C320 251 311 260 300 260H107.8L99 286.4L98.8 286.4C96 294.2 88.8 300 80 300H20C9 300 0 291 0 280C0 269 9 260 20 260H65.6L112.2 120H80C58 120 40 102 40 80C40 58 58 40 80 40S120 58 120 80H240C240 58 258 40 280 40S320 58 320 80C320 102 302 120 280 120zM121 220H267.6L247.6 180H134.4L121 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ShoppingCart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ShoppingCart.displayName = "Blueprint5.Icon.ShoppingCart";
exports.default = ShoppingCart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7YB30":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShortenText", ()=>ShortenText);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ShortenText = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "shorten-text",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M16.66666 140H183.3334C192.5 140 200 149 200 160C200 171 192.5 180 183.3334 180H16.66666C7.5 180 0 171 0 160C0 149 7.5 140 16.66666 140zM20 240H380C391 240 400 249 400 260C400 271 391 280 380 280H20C9 280 0 271 0 260C0 249 9 240 20 240zM320 120C320 125.6 317.8 130.6 314.2000000000001 134.2000000000001L308.2 140H380C391 140 400 149 400 160C400 171 391 180 380 180H308.2L314 185.8C317.8 189.4 320 194.4 320 200C320 211 311 220 300 220C294.4000000000001 220 289.4000000000001 217.8 285.8 214.2L245.8 174.2C242.2 170.4 240 165.4 240 160C240 154.4 242.2 149.4 245.8 145.8L285.8 105.8C289.4000000000001 102.2 294.4000000000001 100 300 100C311 99.8 320 108.8 320 120z" : "M20 200H300C311 200 320 209 320 220C320 231 311 240 300 240H20C9 240 0 231 0 220C0 209 9 200 20 200zM100 140H20C9 140 0 131 0 120C0 109 9 100 20 100H100C111 100 120 109 120 120C120 131 111 140 100 140zM240 80C240 85.6 237.8 90.6 234.2 94.2L228.2 100H300C311 100 320 109 320 120C320 131 311 140 300 140H228.2L234 145.8C237.8 149.4 240 154.4 240 160C240 171 231 180 220 180C214.4 180 209.4 177.8 205.8 174.2L165.8 134.2C162.2 130.6 160 125.6 160 120C160 114.4 162.2 109.4 165.8 105.8L205.8 65.8C209.4 62.2 214.4 60 220 60C231 60 240 69 240 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ShortenText.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ShortenText.displayName = "Blueprint5.Icon.ShortenText";
exports.default = ShortenText;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ln5WD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignalSearch", ()=>SignalSearch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SignalSearch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "signal-search",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M142.9819366 193.417704C160.755405 177.394016 182.974199 166.206544 207.564874 161.928734L254.089464 22.324672C257.151544 13.486748 252.218194 3.968984 243.372186 0.909704C234.52618 -2.149578 224.829594 2.779264 221.93763 11.6171880000001L197.4409958 85.039936L142.4936824 85.039936L117.9970474 11.6171880000001C115.1050836 2.779264 105.4084988 -1.979618 96.5624918 0.909704C87.7164846 3.799024 82.95325 13.486748 85.845214 22.324672L142.9819366 193.417704zM170.0523968 167.300606L153.8914224 119.031948L186.0432558 119.031948L170.0523968 167.300606zM100 290C100 274.7877548 102.6128776 260.18578 107.4143232 246.6183848C97.4792222 225.4795872 101.1446342 199.481608 121.4798722 180.800994C129.1749846 173.732012 129.5597402 162.012386 122.2493834 154.571354C114.9390268 147.13032 102.819225 146.758268 95.1241126 153.82725C51.4543504 194.008828 55.1095288 256.3274774 95.3164904 292.6025126C96.7765886 293.9085092000001 98.4029134 294.9533066 100.1271272 295.7369046C100.041057 293.8042030000001 100 291.9068962 100 290zM77.4825744 136.293404C50.563598 154.653264 33.7392378 189.703902 33.7392378 223.0854636C33.7392378 258.1361028 48.881162 288.1795076 77.4825744 309.8775224C85.8947544 314.8847564 85.8947544 326.5683028 80.8474464 333.244615C75.8001384 341.5900054 64.0230862 341.5900054 57.2933422 336.5827712C20.2797496 308.2084442000001 -1.591918598 269.8196490000001 0.0905174224 223.0854636C1.772953444 178.020356 23.6446218 134.624326 57.2933422 109.588156C60.6582142 107.919078 64.0230862 106.25 67.3879582 106.25C72.4352664 106.25 77.4825744 107.919078 80.8474464 112.926312C87.5771906 121.271702 85.8947544 131.28617 77.4825744 136.293404zM244.926326 153.824078C237.243584 146.759514 225.143268 147.131332 217.844664 154.567716C215.96063 156.487316 214.58853 158.691836 213.718454 161.030986C219.057778 160.34294 224.48884 160 230 160C237.811054 160 245.46121 160.688892 252.8930220000001 162.009236C250.44238 159.186908 247.785984 156.457906 244.926326 153.824078zM292.629014 170.473868L317.183346 145.906512C308.030612 131.698138 296.377932 119.27024 282.711932 109.588156C279.34642 107.919078 275.980906 106.25 272.615394 106.25C267.5671260000001 106.25 262.5188560000001 107.919078 259.153344 112.926312C252.422318 121.271702 254.105076 131.28617 262.5188560000001 136.293404C274.91466 144.746248 285.170338 156.736976 292.629014 170.473868L292.629014 170.473868zM230 400C290.8 400 340 350.8 340 290C340 284.8 339.6 279.8 338.8 275L338.2 271.6C337.4000000000001 266.6 336.2 261.8 334.8 257L334.8 256.8C333.2 252 331.4 247.4 329.2000000000001 243C329 242.2 328.6 241.6 328.2 240.8C326 236.2 323.4000000000001 232 320.6 227.8L394.2000000000001 154.2C397.8 150.6 400 145.6 400 140C400 129 391 120 380 120C374.4 120 369.4 122.2 366 125.8L292.4 199.4C288.2 196.6 284 194 279.4000000000001 191.8C278.6 191.6 278 191.2 277.2 190.8C272.8 188.6 268.2 186.8 263.4 185.2L263.2 185.2C258.4 183.8 253.6 182.6 248.6 181.8L245.2 181.2C240.2 180.4 235.2 180 230 180C169.2 180 120 229.2 120 290C120 350.8 169.2 400 230 400zM230 370C185.8 370 150 334.2 150 290C150 245.8 185.8 210 230 210C274.2000000000001 210 310 245.8 310 290C310 334.2 274.2000000000001 370 230 370z" : "M109.4823658 160.5760082C116.4400596 153.3260918 124.4210696 147.0661448 133.1956504 142.0259124L133.334363 141.6429264L133.7091872 140.5181156C134.0090468 139.7682418 134.4588358 139.3183176 134.6087656 138.5684438L164.5947096 18.588632C166.543796 10.63997 161.746045 2.391358 153.64984 0.441686C145.703565 -1.507986 137.4574302 3.291206 135.508344 11.389844L127.1122796 44.98419L113.0188858 44.98419L104.6228216 11.389844C102.6737352 3.291206 94.5775302 -1.507986 86.4813254 0.441686C78.3851204 2.391358 73.5873694 10.489994 75.5364558 18.588632L105.5223998 138.5684438C105.6723296 139.3183176 106.1221188 139.7682418 106.4219782 140.5181156C106.7218376 141.2679894 106.7218376 142.0178634 107.1716268 142.7677372C105.972189 144.8673838 105.0726106 147.26698 105.0726106 149.9665258C105.0726106 154.0908318 106.75932 157.840201 109.4767962 160.5584936L109.4823658 160.5760082zM55.8956624 214.4556746C61.5929918 220.4546652 61.443062 229.9030754 55.595803 235.7520912C49.7485438 241.601107 40.1530418 241.3011574 34.3057826 235.4521416C-11.42278212 188.6600152 -11.42278212 111.273036 34.3057826 64.48091C40.1530418 58.48192 49.5986142 58.48192 55.4458732 64.18096C61.2931322 69.880002 61.443062 79.478386 55.7457326 85.327402C21.5617564 120.571472 21.5617564 179.3615796 55.8956624 214.4556746L55.8956624 214.4556746zM156.1642786 132.2405208C165.6247038 129.4799736 175.636411 128 186 128C186.5849678 128 187.1688144 128.0047152 187.7515042 128.0141096C185.0296064 120.3540608 180.7027146 113.496366 174.640001 108.423516C168.193023 103.1744 158.7474506 104.074248 153.4999104 110.373188C148.2523702 116.822102 149.1519484 126.270513 155.4489968 131.5196298L156.1642786 132.2405208zM230.8704 137.904922L238.44256 130.346824C234.61642 106.16943 223.69711 83.012586 205.675454 64.630884C199.9781238 58.631894 190.5325514 58.631894 184.5353626 64.330936C178.5381736 70.029976 178.388244 79.628362 184.235503 85.477378C196.566834 98.081736 204.469256 113.742768 207.94277 130.2648078C215.954558 131.9440888 223.635344 134.528078 230.8704 137.904922zM81.0838554 131.5196298C72.5378614 138.5684438 74.0371586 163.1643052 80.4841366 167.9634976C87.0810442 172.9126648 88.4304116 182.361075 83.482731 188.9599646C78.5350502 195.5588542 69.0894778 196.9086272 62.49257 191.95946C40.9026904 175.9121602 38.0540256 128.3701598 61.8928512 108.423516C68.1898994 103.1744 77.6354718 103.924274 83.0329418 110.373188C88.280482 116.672128 87.3809036 126.270513 81.0838554 131.5196298zM186.351472 320C234.041034 320 272.702944 281.338091 272.702944 233.648528C272.702944 229.5272078 272.310438 225.602141 271.721678 221.677074C271.5254240000001 220.6958074 271.5254240000001 219.910794 271.32917 218.9295272C270.5441580000001 215.0044604 269.759144 211.2756468 268.5816240000001 207.5468332L268.5816240000001 207.3505798C267.404104 203.6217662 265.834076 200.089206 264.26405 196.5566458L263.479036 194.7903658C261.712756 191.2578056 259.750224 187.9214986 257.5914360000001 184.5851918L315.28992 126.8867082C318.037466 123.9429082 319.803746 120.0178412 320 115.700268C320 107.06512 312.93488 100 304.299732 100C299.785906 100 295.860838 101.76628 293.113292 104.513826L235.414808 162.2123104C232.078502 160.0535236 228.742194 158.0909902 225.209634 156.32471L223.443354 155.5396966C219.910794 153.96967 216.378234 152.3996432 212.64942 151.2221232L212.453166 151.2221232C208.724354 150.044603 204.99554 149.0633364 201.070472 148.4745762C200.089206 148.278323 199.1079394 148.0820696 198.322926 148.0820696C194.397859 147.4933096 190.4727922 147.1008028 186.351472 147.1008028C138.661909 147.1008028 100 185.7627118 100 233.4522748C100 281.1418376000001 138.661909 319.8037466548 186.351472 320zM185.960025 298C150.5821362 298 122 269.4178638 122 234.039975C122 198.6620862 150.5821362 170.07995 185.960025 170.07995C221.337914 170.07995 249.92005 198.6620862 249.92005 234.039975C249.92005 269.4178638 221.337914 298 185.960025 298z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SignalSearch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SignalSearch.displayName = "Blueprint5.Icon.SignalSearch";
exports.default = SignalSearch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fFP0z":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimCard", ()=>SimCard);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SimCard = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "sim-card",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M334.2000000000001 294.2L234.2 394.2C230.6 397.8 225.6 400 220 400H80C69 400 60 391 60 380V20C60 9 69 0 80 0H320C331 0 340 9 340 20V280C340 285.6 337.8 290.6 334.2000000000001 294.2zM180 260H220V200H180V260zM120 260H160V200H120V260zM160 40H120V100H160V40zM220 40H180V100H220V40zM280 40H240V100H280V40zM280 120H120V180H280V120zM280 200H240V260H280V200z" : "M274.2000000000001 234.2L194.2 314.2C190.6 317.8 185.6 320 180 320H60C49 320 40 311 40 300V20C40 9 49 0 60 0H260C271 0 280 9 280 20V220C280 225.6 277.8 230.6 274.2000000000001 234.2zM140 200H180V160H140V200zM80 200H120V160H80V200zM120 40H80V80H120V40zM180 40H140V80H180V40zM240 40H200V80H240V40zM240 100H80V140H240V100zM240 160H200V200H240V160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SimCard.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SimCard.displayName = "Blueprint5.Icon.SimCard";
exports.default = SimCard;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"38K7d":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slash", ()=>Slash);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Slash = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "slash",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 360C230.8 360 223 353.6 220.6 345.2L140.8 66C140.4 64 140 62 140 60C140 49 149 40 160 40C169.2 40 177 46.4 179.4 54.8L259.2000000000001 334C259.6 336 260 338 260 340C260 351 251 360 240 360z" : "M200 280C190.8 280 183 273.8 180.8 265.4L121 66.2C120.4 64.2 120 62.2 120 60C120 49 129 40 140 40C149.2 40 157 46.2 159.2 54.6L219 253.8C219.6 255.8 220 257.8 220 260C220 271 211 280 200 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Slash.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Slash.displayName = "Blueprint5.Icon.Slash";
exports.default = Slash;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"75XfC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmallCross", ()=>SmallCross);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SmallCross = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "small-cross",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M228.2 200L294 265.8C297.8 269.4 300 274.4 300 280C300 291 291 300 280 300C274.4000000000001 300 269.4000000000001 297.8 265.8 294.2L200 228.2L134.2 294.2C130.6 297.8 125.6 300 120 300C109 300 100 291 100 280C100 274.4 102.2 269.4 105.8 265.8L171.8 200L106 134.2000000000001C102.2 130.6 100 125.6 100 120C100 109 109 100 120 100C125.6 100 130.6 102.2 134.2 105.8L200 171.8L265.8 106C269.4000000000001 102.2 274.4000000000001 100 280 100C291 100 300 109 300 120C300 125.6 297.8 130.6 294.2000000000001 134.2000000000001L228.2 200z" : "M188.2 160L234 205.8C237.8 209.4 240 214.4 240 220C240 231 231 240 220 240C214.4 240 209.4 237.8 205.8 234.2L160 188.2L114.2 234.2C110.6 237.8 105.6 240 100 240C89 240 80 231 80 220C80 214.4 82.2 209.4 85.8 205.8L131.8 160L86 114.2C82.2 110.6 80 105.6 80 100C80 89 89 80 100 80C105.6 80 110.6 82.2 114.2 85.8L160 131.8L205.8 86C209.4 82.2 214.4 80 220 80C231 80 240 89 240 100C240 105.6 237.8 110.6 234.2 114.2L188.2 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SmallCross.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SmallCross.displayName = "Blueprint5.Icon.SmallCross";
exports.default = SmallCross;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6RAbr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmallInfoSign", ()=>SmallInfoSign);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SmallInfoSign = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "small-info-sign",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 200C340 122.68 277.32 60 200 60C122.6802 60 60 122.68 60 200C60 277.3198 122.6802 340 200 340C277.32 340 340 277.3198 340 200zM220 300V260H180V300H220zM220 240V120H240V100H160V120H180V220H160V240H220z" : "M280 160C280 93.726 226.274 40 160 40C93.7258 40 40 93.726 40 160C40 226.2742 93.7258 280 160 280C226.274 280 280 226.2742 280 160zM180 240V200H140V240H180zM180 180V100H200V80H120V100H140V160H120V180H180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SmallInfoSign.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SmallInfoSign.displayName = "Blueprint5.Icon.SmallInfoSign";
exports.default = SmallInfoSign;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jM1iY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmallMinus", ()=>SmallMinus);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SmallMinus = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "small-minus",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 220H120C109 220 100 211 100 200C100 189 109 180 120 180H280C291 180 300 189 300 200C300 211 291 220 280 220z" : "M220 180H100C89 180 80 171 80 160C80 149 89 140 100 140H220C231 140 240 149 240 160C240 171 231 180 220 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SmallMinus.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SmallMinus.displayName = "Blueprint5.Icon.SmallMinus";
exports.default = SmallMinus;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hrUSA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmallPlus", ()=>SmallPlus);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SmallPlus = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "small-plus",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 220H220V280C220 291 211 300 200 300S180 291 180 280V220H120C109 220 100 211 100 200C100 189 109 180 120 180H180V120C180 109 189 100 200 100S220 109 220 120V180H280C291 180 300 189 300 200C300 211 291 220 280 220z" : "M220 180H180V220C180 231 171 240 160 240S140 231 140 220V180H100C89 180 80 171 80 160C80 149 89 140 100 140H140V100C140 89 149 80 160 80S180 89 180 100V140H220C231 140 240 149 240 160C240 171 231 180 220 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SmallPlus.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SmallPlus.displayName = "Blueprint5.Icon.SmallPlus";
exports.default = SmallPlus;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6II6L":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmallSquare", ()=>SmallSquare);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SmallSquare = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "small-square",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100 300V100H300V300H100zM80 340C68.9544 340 60 331.0456000000001 60 320V80C60 68.954 68.9544 60 80 60H320C331.046 60 340 68.954 340 80V320C340 331.0456000000001 331.046 340 320 340H80z" : "M100 220V100H220V220H100zM80 260C68.9544 260 60 251.0456 60 240V80C60 68.954 68.9544 60 80 60H240C251.046 60 260 68.954 260 80V240C260 251.0456 251.046 260 240 260H80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SmallSquare.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SmallSquare.displayName = "Blueprint5.Icon.SmallSquare";
exports.default = SmallSquare;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Ek4D":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmallTick", ()=>SmallTick);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SmallTick = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "small-tick",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 300C294.4000000000001 300 289.4000000000001 297.8 285.8 294.2L160 168.2L114.2 214.2C110.6 217.8 105.6 220 100 220C89 220 80 211 80 200C80 194.4 82.2 189.4 85.8 185.8L145.8 125.8C149.4 122.2 154.4 120 160 120S170.6 122.2 174.2 125.8L314.2000000000001 265.8C317.8 269.4 320 274.4 320 280C320 291 311 300 300 300z" : "M240 220C234.4 220 229.4 217.8 225.8 214.2L140 128.2L94.2 174.2C90.6 177.8 85.6 180 80 180C69 180 60 171 60 160C60 154.4 62.2 149.4 65.8 145.8L125.8 85.8C129.4 82.2 134.4 80 140 80S150.6 82.2 154.2 85.8L254.2 185.8C257.8 189.4 260 194.4 260 200C260 211 251 220 240 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SmallTick.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SmallTick.displayName = "Blueprint5.Icon.SmallTick";
exports.default = SmallTick;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ljODz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Snowflake", ()=>Snowflake);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Snowflake = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "snowflake",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 164.488584L220 108.284272L266.18543 63.431458C274.14763 55.6209719999999 274.14763 42.957672 266.18543 35.147186C258.223228 27.3367 245.313952 27.3367 237.35175 35.147186L220 51.715728L220 20C220 8.954306 211.3331338 0 200.0728804 0C188.8126288 0 180 8.954306 180 20L180 52.72078L161.7694388 35.147186C153.807238 27.3367 140.8979598 27.3367 132.935759 35.147186C124.9735584 42.957672 124.9735584 55.6209719999999 132.935759 63.431458L180 109.289322L180 165.06885L129.039978 136.386428L112.303811 75.116344C109.3894434 64.447022 98.2096804 58.115372 87.333112 60.97421C76.4565432 63.833046 70.0019044 74.799784 72.916272 85.469106L79.0985796 108.102156L51.0984266 92.244292C41.3467622 86.721444 28.87735692 89.998948 23.24723082 99.5648C17.61710454 109.130652 20.958271684 121.36246 30.70993622 126.885308L59.5973956 143.245698L35.12511644 149.67808C24.24854772 152.536916 17.79390864 163.503654 20.708276372 174.172978C23.6226443 184.8423 34.802407 191.173948 45.6789758 188.315112L109.538794 171.52997L158.7836134 199.419734L108.139201 228.1021566L45.6789758 211.6848874C34.802407 208.8260512 23.6226443 215.157701 20.708276372 225.827023C17.79390864 236.496345 24.24854772 247.4630842 35.12511644 250.3219204L58.1978024 256.3864278L30.1976495 272.2442922C20.445984966 277.7671398 17.10481804 289.9989478 22.73494412 299.5648004C28.3650702 309.1306528 40.8344754 312.4081558000001 50.58614 306.8853084L79.4735994 290.5249186L72.916272 314.5308934C70.0019044 325.2002154 76.4565432 336.1669546 87.333112 339.0257908C98.2096804 341.884627 109.3894434 335.5529772 112.303811 324.8836552L129.4149978 262.2406474L180 233.7706168L180 291.7157288L132.935759 337.5735932C124.9735584 345.384079 124.9735584 358.0473786 132.935759 365.8578644C140.8979598 373.6683502 153.807238 373.6683502 161.7694388 365.8578644L180 348.2842712L180 380C180 391.045695 188.8126288 400 200.0728804 400C211.3331338 400 220 391.045695 220 380L219.8542384 349.2893218L237.35175 365.8578644C245.313952 373.6683502 258.223228 373.6683502 266.18543 365.8578644C274.14763 358.0473786 274.14763 345.384079 266.18543 337.5735932L220 292.7207794000001L220 234.350883L270.593498 262.7431728L287.704684 325.3861804C290.619052 336.0555026 301.798816 342.3871524 312.675384 339.528316C323.551952 336.6694798 330.006592 325.7027408 327.092224 315.0334186L320.534896 291.027444L348.535048 306.8853084C358.286714 312.4081558000001 370.75612 309.1306528 376.386244 299.5648004C382.01637 289.9989478 378.675204 277.7671398 368.923538 272.2442922L341.810694 256.8889532L364.88338 250.8244458C375.759948 247.9656094 382.214588 236.9988704 379.300218 226.3295482C376.38585 215.6602262 365.206088 209.3285764 354.32952 212.1874126L291.869294 228.604682L240.337576 199.419734L290.469702 171.027444L354.32952 187.812588C365.206088 190.671424 376.38585 184.339774 379.300218 173.670452C382.214588 163.00113 375.759948 152.03439 364.88338 149.175554L340.4111000000001 142.743172L368.4112540000001 126.885308C378.162918 121.36246 381.504086 109.130652 375.873958 99.5648C370.243832 89.998948 357.774426 86.721444 348.022762 92.244292L320.909916 107.599632L327.092224 84.966582C330.006592 74.2972600000001 323.551952 63.33052 312.675384 60.471684C301.798816 57.612848 290.619052 63.944498 287.704684 74.61382L270.968518 135.883902L220 164.488584z" : "M267.27922 140L284.852814 122.4264068C292.6633 114.615922 292.6633 101.952622 284.852814 94.142136C277.042328 86.33165 264.379028 86.33165 256.5685420000001 94.142136L214.142136 136.5685424C213.079932 137.6307454 212.162186 138.782702 211.388896 140L180 140L180 107.928706C180.8493024 107.313404 181.6611476 106.623124 182.4264068 105.857864L224.852814 63.431458C232.6633 55.620972 232.6633 42.957672 224.852814 35.147186C217.042328 27.3367 204.379028 27.3367 196.5685424 35.147186L180 51.715728L180 20C180 8.954306 171.045695 0 160 0C148.954305 0 140 8.954306 140 20L140 52.72078L122.4264068 35.147186C114.615921 27.3367 101.9526214 27.3367 94.1421356 35.147186C86.3316498 42.957672 86.3316498 55.620972 94.1421356 63.431458L136.5685424 105.857864C137.6307454 106.920068 138.782702 107.837814 140 108.611104L140 140L107.6060532 140C106.8327632 138.782702 105.9150166 137.6307454 104.8528138 136.5685424L62.4264068 94.142136C54.615921 86.33165 41.9526214 86.33165 34.1421356 94.142136C26.3316498 101.952622 26.3316498 114.615922 34.1421356 122.4264068L51.7157288 140L20 140C8.954305 140 0 148.954305 0 160C0 171.045695 8.954305 180 20 180L50.7106782 180L34.1421356 196.5685424C26.3316498 204.3790284 26.3316498 217.042328 34.1421356 224.8528138C41.9526214 232.6632996 54.615921 232.6632996 62.4264068 224.8528138L104.8528138 182.4264068C105.618073 181.6611476 106.3083534 180.8493024 106.9236548 180L140 180L140 212.3939468C138.782702 213.1672368 137.6307454 214.0849834 136.5685424 215.1471862L94.1421356 257.5735932C86.3316498 265.384079 86.3316498 278.0473786 94.1421356 285.8578644C101.9526214 293.6683502 114.615921 293.6683502 122.4264068 285.8578644L140 268.2842712L140 300C140 311.045695 148.954305 320 160 320C171.045695 320 180 311.045695 180 300L180 269.2893218L196.5685424 285.8578644C204.379028 293.6683502 217.042328 293.6683502 224.852814 285.8578644C232.6633 278.0473786 232.6633 265.384079 224.852814 257.5735932L182.4264068 215.1471862C181.6611476 214.381927 180.8493024 213.6916466 180 213.0763452L180 180L212.071294 180C212.686596 180.8493024 213.376876 181.6611476 214.142136 182.4264068L256.5685420000001 224.8528138C264.379028 232.6632996 277.042328 232.6632996 284.852814 224.8528138C292.6633 217.042328 292.6633 204.3790284 284.852814 196.5685424L268.284272 180L300 180C311.045694 180 320 171.045695 320 160C320 148.954305 311.045694 140 300 140L267.27922 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Snowflake.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Snowflake.displayName = "Blueprint5.Icon.Snowflake";
exports.default = Snowflake;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hiKvq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SoccerBall", ()=>SoccerBall);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SoccerBall = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "soccer-ball",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M190 20C294.9340000000001 20 380 105.066 380 210C380 314.9342000000001 294.9340000000001 400 190 400C85.0658 400 0 314.9342000000001 0 210C0 105.066 85.0658 20 190 20zM190 60C207.576 60 224.446 63.024 240.12 68.578L253.002 108.224L229.966 139.928H153.4742L130.4388 108.224L143.7464 67.266C158.3152 62.55 173.8598 60 190 60zM70.0046 119.98H114.2584L138.6304 153.524L117.8702 218.456L71.1498 233.6362L40.0034 211.007L40 210C40 176.222 51.1646 145.052 70.0046 119.98zM340 210C340 176.222 328.836 145.052 309.996 119.98H269.182L242.42 156.812L261.93 217.8306L310.574 233.6362L339.984 212.2698C339.9940000000001 211.5146 340 210.758 340 210zM64.4906 292.1736L77.3302 252.6574L123.2688 237.731L179.9156 279.5562V317.2654L135.2702 349.7022C106.129 338.277 81.4322 317.9974 64.4906 292.1736zM304.394 252.6574L316.656 290.3974C299.672 317.1 274.474 338.0678 244.62 349.7452L199.9156 317.2654V279.6808L257.258 237.342L304.394 252.6574z" : "M300 170C300 87.158 232.842 20 150 20C67.1572 20 0 87.158 0 170C0 252.8428 67.1572 320 150 320C232.842 320 300 252.8428 300 170zM150 60C163.874 60 177.148 62.568 189.3726 67.256L196.2158 88.318L173.5898 119.46H126.7654L104.0528 88.198L110.8898 67.156C123.0418 62.532 136.2252 60 150 60zM259.978 167.7968C259.474 142.0952 250.154 118.554 234.918 100.074H212.396L189.3168 131.8392L189.281 131.8132L203.012 174.0734L236.406 184.9236L259.978 167.7968zM65.1814 99.954H87.8724L110.8118 131.5272L97.0742 173.8074L62.861 184.924L40.0126 168.3236C40.4004 142.3616 49.7824 118.58 65.1814 99.954zM160 220.735L197.6694 193.3666L230.226 203.9446L239.83 233.5032C225.888 253.189 205.638 268.0916 182.0234 275.266L160 259.265V220.735zM117.9766 275.2658L140 259.2648V220.735L102.1044 193.2022L69.0414 203.945L59.6692 232.7894C73.6248 252.8286 94.078 268.005 117.9766 275.2658z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SoccerBall.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SoccerBall.displayName = "Blueprint5.Icon.SoccerBall";
exports.default = SoccerBall;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"29yvH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SocialMedia", ()=>SocialMedia);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SocialMedia = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "social-media",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M230 300C246 300 262 308 270 320C310 296 336 254 340 206C340 196 350 188 360 188C372 188 380 198 380 208L380 210C376 276 336 334 278 362C274 384 254 400 230 400C202 400 180 378 180 350C180 322 202 300 230 300zM330 160C302 160 280 138 280 110C280 102 282 96 284 88C262 70 232 60 200 60C162 60 128 76 102 100C98 104 92 108 86 108C76 108 66 98 66 88C66 82 68 78 72 74C106 40 150 20 200 20C244 20 284 36 316 62C320 60 326 60 330 60C358 60 380 82 380 110C380 138 358 160 330 160zM100 190C100 212 86 232 66 238C76 276 104 308 138 326C144 330 150 336 150 344C150 354 142 364 130 364C126 364 122 362 118 360C70 336 34 288 24 232C10 222 0 208 0 190C0 162 22 140 50 140C78 140 100 162 100 190z" : "M190 240C198 240 206 242 212 246C240 230 258 200 260 168L260 168C260 158 270 150 280 150C292 150 300 158 300 170C300 172 300 172 300 174C296 222 270 262 230 284C228 304 212 320 190 320S150 302 150 280S168 240 190 240L190 240zM80 150C80 164 72 176 62 184C68 212 86 236 112 250C118 252 124 258 124 268S116 288 104 288C100 288 98 288 94 286C56 266 30 230 22 186C8 178 0 164 0 150C0 128 18 110 40 110S80 128 80 150L80 150zM256 126C234.0000000000001 126 216 108 216 86C216 84 216 82 216 80C200 68 180 62 160 62C136 62 114 70 96 84C92 88 88 90 82 90C70 90 62 82 62 70C62 64 64 58 68 54L68 54C92 32 124 20 160 20C190 20 220 30 242 46C246 44 252 44 256 44C278 44 296 62 296 84S278 126 256 126L256 126z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SocialMedia.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SocialMedia.displayName = "Blueprint5.Icon.SocialMedia";
exports.default = SocialMedia;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iXq1L":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortAlphabeticalDesc", ()=>SortAlphabeticalDesc);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SortAlphabeticalDesc = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "sort-alphabetical-desc",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160.2 100C154.6 100 149.6 97.8 146 94.2000000000001L120 68.2V179.8C120 190.8 111 199.8 100 199.8S80 190.8 80 179.8V68.2L54.2 94C50.6 97.6 45.6 100 40 100C29 100 20 91 20 80C20 74.4 22.2 69.4 25.8 65.8H25.8L85.8 5.8C89.6 2.2 94.6 0 100 0S110.6 2.2 114.2 5.8L174.2 65.8C177.8 69.4 180 74.4 180 80C180.2 91 171.2 100 160.2 100zM249 213L377 370.6V400H210V366.6H328.2000000000001L200 211.2V179.8H380V213H249zM274.4000000000001 140.2L220 0H251.8L263 31.2H316.6L327.6 0H360.4L306.8 140.2H274.4000000000001zM271.2 54.2L289.8 105.6H290.2L308.2 54.2H271.2z" : "M119.8 80.2C114.2 80.2 109.2 78 105.6 74.4V74.4L99.8 68.6V140.2C99.8 151.2 90.8 160.2 79.8 160.2C68.8 160.2 59.8 151.2 59.8 140.2V68.4L54 74.2C50.4 77.8 45.4 80 39.8 80C28.8 80 19.8 71 19.8 60C19.8 54.4 22 49.4 25.6 45.8L65.6 5.8C69.2 2.2 74.2 0 79.8 0C85.4 0 90.4 2.2 94 5.8L134 45.8C137.6 49.4 139.8 54.4 139.8 60C139.8 71.2 130.8 80.2 119.8 80.2zM254 120H226.4L180 0.2H207.2L216.8 26.8H262.8L272 0.2H300L254 120zM223.8 46.6L239.8 90.6H240.2L255.6 46.6H223.8zM299.8 190H208.4L297.4000000000001 292.4V320H166.8V290.4H248.8L159.8 188.2V160.4H299.8V190z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SortAlphabeticalDesc.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SortAlphabeticalDesc.displayName = "Blueprint5.Icon.SortAlphabeticalDesc";
exports.default = SortAlphabeticalDesc;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lFApM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortAlphabetical", ()=>SortAlphabetical);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SortAlphabetical = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "sort-alphabetical",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 100C154.4 100 149.4 97.8 145.8 94.2000000000001L120 68.2V179.8C120 190.8 111 199.8 100 199.8S80 190.8 80 179.8V68.2L54.2 94H54.2C50.6 97.6 45.6 100 40 100C29 100 20 91 20 80C20 74.4 22.2 69.4 25.8 65.8H25.8L85.8 5.8C89.4 2.2 94.4 0 100 0S110.6 2.2 114.2 5.8L174.2 65.8C177.8 69.4 180 74.4 180 80C180 91 171 100 160 100zM337.8 115.8V140.2H226V114.2H296.2L220 24.4V0H339.8000000000001V26H261.6L337.8 115.8zM299.4000000000001 400H260.4000000000001L180.2 179.8H218L237.6 238.2H321L340.6 179.8H379.8000000000001L299.4000000000001 400zM247.6 267.4L279.2000000000001 362.2H280L311.4 267.4H247.6z" : "M120 80C114.4 80 109.4 77.8 105.8 74.2L100 68.2V140C100 151 91 160 80 160C69 160 60 151 60 140V68.2L54.2 74H54.2C50.6 77.8 45.6 80 40 80C29 80 20 71 20 60C20 54.4 22.2 49.4 25.8 45.8L65.8 5.8C69.6 2.2 74.6 0 80 0C85.6 0 90.6 2.2 94.2 5.8L134.2 45.8C137.8 49.4 140 54.4 140 60C140.2 71 131.2 80 120 80zM278.6 99V119.8H185V97.6H243.8L180 20.8V0H280.4V22.2H215L278.6 99zM250.2 195.8L262.6 160.2H300L238.8 319.8H202L140 160.2H176.2L189 195.8H250.2zM219.8 280.6H220.2L240.8 222H198.4L219.8 280.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SortAlphabetical.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SortAlphabetical.displayName = "Blueprint5.Icon.SortAlphabetical";
exports.default = SortAlphabetical;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l0yH7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortAsc", ()=>SortAsc);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SortAsc = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "sort-asc",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 240H300C311 240 320 249 320 260V280C320 291 311 300 300 300H200C189 300 180 291 180 280V260C180 249 189 240 200 240zM200 140H340C351 140 360 149 360 160V180C360 191 351 200 340 200H200C189 200 180 191 180 180V160C180 149 189 140 200 140zM200 340H260C271 340 280 349 280 360V380C280 391 271 400 260 400H200C189 400 180 391 180 380V360C180 349 189 340 200 340zM380 100H200C189 100 180 91 180 80V60C180 49 189 40 200 40H380C391 40 400 49 400 60V80C400 91 391 100 380 100zM140 120C134.4 120 129.4 117.8 125.8 114.2000000000001L100 88.2V200C100 211 91 220 80 220S60 211 60 200V88.2L34.2 114C30.6 117.8 25.6 120 20 120C9 120 0 111 0 100C0 94.4 2.2 89.4 5.8 85.8L65.8 25.8C69.4 22.2 74.4 20 80 20S90.6 22.2 94.2 25.8L154.2 85.8C157.8 89.4 160 94.4 160 100C160 111 151 120 140 120z" : "M160 180H220C231 180 240 189 240 200C240 211 231 220 220 220H160C149 220 140 211 140 200C140 189 149 180 160 180zM160 260H180C191 260 200 269 200 280C200 291 191 300 180 300H160C149 300 140 291 140 280C140 269 149 260 160 260zM160 100H260C271 100 280 109 280 120C280 131 271 140 260 140H160C149 140 140 131 140 120C140 109 149 100 160 100zM100 80C94.4 80 89.4 77.8 85.8 74.2L80 68.2V140C80 151 71 160 60 160S40 151 40 140V68.2L34.2 74C30.6 77.8 25.6 80 20 80C9 80 0 71 0 60C0 54.4 2.2 49.4 5.8 45.8L45.8 5.8C49.4 2.2 54.4 0 60 0S70.6 2.2 74.2 5.8L114.2 45.8C117.8 49.4 120 54.4 120 60C120 71 111 80 100 80zM300 60H160C149 60 140 51 140 40C140 29 149 20 160 20H300C311 20 320 29 320 40C320 51 311 60 300 60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SortAsc.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SortAsc.displayName = "Blueprint5.Icon.SortAsc";
exports.default = SortAsc;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"71ihm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortDesc", ()=>SortDesc);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SortDesc = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "sort-desc",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260 100H200C189 100 180 91 180 80V60C180 49 189 40 200 40H260C271 40 280 49 280 60V80C280 91 271 100 260 100zM140 120C134.4 120 129.4 117.8 125.8 114.2000000000001L100 88.2V200C100 211 91 220 80 220S60 211 60 200V88.2L34.2 114C30.6 117.8 25.6 120 20 120C9 120 0 111 0 100C0 94.4 2.2 89.4 5.8 85.8L65.8 25.8C69.4 22.2 74.4 20 80 20S90.6 22.2 94.2 25.8L154.2 85.8C157.8 89.4 160 94.4 160 100C160 111 151 120 140 120zM380 400H200C189 400 180 391 180 380V360C180 349 189 340 200 340H380C391 340 400 349 400 360V380C400 391 391 400 380 400zM300 200H200C189 200 180 191 180 180V160C180 149 189 140 200 140H300C311 140 320 149 320 160V180C320 191 311 200 300 200zM340 300H200C189 300 180 291 180 280V260C180 249 189 240 200 240H340C351 240 360 249 360 260V280C360 291 351 300 340 300z" : "M100 80C94.4 80 89.4 77.8 85.8 74.2L80 68.2V140C80 151 71 160 60 160S40 151 40 140V68.2L34.2 74C30.6 77.8 25.6 80 20 80C9 80 0 71 0 60C0 54.4 2.2 49.4 5.8 45.8L45.8 5.8C49.4 2.2 54.4 0 60 0S70.6 2.2 74.2 5.8L114.2 45.8C117.8 49.4 120 54.4 120 60C120 71 111 80 100 80zM180 60H160C149 60 140 51 140 40C140 29 149 20 160 20H180C191 20 200 29 200 40C200 51 191 60 180 60zM260 220H160C149 220 140 211 140 200C140 189 149 180 160 180H260C271 180 280 189 280 200C280 211 271 220 260 220zM220 140H160C149 140 140 131 140 120C140 109 149 100 160 100H220C231 100 240 109 240 120C240 131 231 140 220 140zM300 300H160C149 300 140 291 140 280C140 269 149 260 160 260H300C311 260 320 269 320 280C320 291 311 300 300 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SortDesc.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SortDesc.displayName = "Blueprint5.Icon.SortDesc";
exports.default = SortDesc;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iS1vb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortNumericalDesc", ()=>SortNumericalDesc);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SortNumericalDesc = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "sort-numerical-desc",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M180 100C174.4 100 169.4 97.8 165.8 94.2000000000001L140 68.2V179.8C140 190.8 131 199.8 120 199.8C109 199.8 100 190.8 100 179.8V68.2L74.2 94H74.2C70.6 97.6 65.6 100 60 100C49 100 40 91 40 80C40 74.4 42.2 69.4 45.8 65.8L105.8 5.8C109.4 2.2 114.4 0 120 0C125.6 0 130.6 2.2 134.2 5.8V5.8L194.2 65.8V65.8C197.8 69.4 200 74.4 200 80C200 91 191 100 180 100zM314 126.6C311.6 123 308.6 120.2 305.2 118C301.8 115.8 297.8 114.2000000000001 293.6 113.4C289.2 112.6 284.8 112.2 280.2 112.4V91H313.4V0H340V139.8H318.8C318 134.6 316.4 130.2 314 126.6zM377 332.6C374.8000000000001 346.2 371.2000000000001 357.8 366 367.8C360.8 377.8 353.6 385.6 344.4 391.4C335 397.2 323.4000000000001 400 309.2000000000001 400C298.4 400 288.6 398.2 280 394.6C271.4 391 264.2000000000001 385.8 258.2 379.4C252.2 372.8 247.8 365.2 244.8 356.4C241.6 347.6 240 338 240 327.8C240 317 241.6 307 244.6 298.4C247.6 289.6 252 282.2 257.6 276C263.2 269.8 269.8 265 277.6 261.6C285.4000000000001 258.2 294 256.4 303.6 256.4C312.8000000000001 256.4 321.2000000000001 258.6 328.8 263C336.4 267.4 342.4000000000001 273.6 346.8 281.8L347.4000000000001 281.2C346.8 274.2 346 266.4 345 258C344 249.6 342 241.8 339.2000000000001 234.4C336.4 227 332.2 220.8 327 216C321.8 211 314.6 208.6 305.8 208.6C297.2000000000001 208.6 290.4000000000001 211.2 285.2000000000001 216.6C280.2000000000001 222 277.2000000000001 229 276.4000000000001 237.6H243.6C244.0000000000001 229.0000000000001 245.8 221 249.4 214C252.8 207 257.2000000000001 200.8 262.8 195.8C268.2 190.8 274.6 186.8000000000001 281.6 184C288.6 181.2 296.2 179.8 304.2000000000001 179.8C318.4000000000001 179.8 330.2000000000001 183.2 340 189.8C349.6 196.4 357.4000000000001 205 363.4000000000001 215.6C369.4000000000001 226.2 373.6000000000001 238.0000000000001 376.2000000000001 250.8C378.8 263.6 380.0000000000001 276.4000000000001 380.0000000000001 289.2000000000001C380.2000000000001 304.6 379 319 377 332.6zM342 311.2C340.4000000000001 305.8 338.2 301.2 335.2000000000001 297C332.2000000000001 292.8 328.4000000000001 289.6 323.8 287.2C319.2000000000001 284.8 313.8 283.6 307.8 283.6C301.8 283.6 296.6 284.8 292.2000000000001 287.4C287.8 290 284.2000000000001 293.2 281.2 297.2C278.4 301.2000000000001 276.2 306 274.8 311.2000000000001C273.4 316.6 272.6 322.2 272.6 328C272.6 333.6 273.4 339 274.8 344.4C276.2 349.6 278.4 354.2 281.2 358.4C284 362.4 287.8 365.6 292.2000000000001 368C296.6 370.4 301.8 371.4 307.8 371.4C314 371.4 319.2000000000001 370.2 323.8 367.8C328.4000000000001 365.4 332.2000000000001 362.2 335.2000000000001 358.2C338.2 354.2 340.4000000000001 349.6 342 344.4C343.6 339.2 344.2000000000001 333.8 344.2000000000001 328C344.2000000000001 322.2 343.4000000000001 316.6 342 311.2z" : "M120 80.2C114.4 80.2 109.4 78 105.8 74.4L100 68.4V140.2C100 151.2 91 160.2 80 160.2S60 151.2 60 140.2V68.4L54.2 74.2C50.4 78 45.6 80.2 40 80.2C29 80.2 20 71.2 20 60.2C20 54.6 22.2 49.6 25.8 46L65.8 6C69.4 2.4 74.4 0.2 80 0.2S90.6 2.4 94.2 6V6L134.2 46V46C137.6 49.6 140 54.6 140 60.2C140 71.2 131 80.2 120 80.2zM277.2 269.2C275.4 278.8 272 287.2 267.2 294.8C262.4 302.4 256 308.4 248 313C240 317.6 229.8 320 217.2 320C208.6 320 200.8 318.6 193.8 315.6C186.8 312.6 180.8 308.6 175.8 303.6C170.8 298.6 167 292.6 164.2 285.8C161.4 279 160.2000000000001 271.6 160.2000000000001 263.6C160.2000000000001 257.4 161.2000000000001 251.4 163.2000000000001 245.4C165.2000000000001 239.4 168.4 234 172.8000000000001 229.4C177.4000000000001 224.6 183.2000000000001 220.8 189.8000000000001 217.8C196.4 215 203.4 213.6 210.4 213.6C218.4 213.6 225.4000000000001 215 231.4000000000001 217.6C237.4000000000001 220.2 242.8000000000001 224.6 247.2000000000001 230.8L247.6000000000001 230.4C247.2000000000001 226.2 246.6 221.4 245.6000000000001 215.8C244.6000000000001 210.4 243.0000000000001 205.2 240.6000000000001 200.6C238.2000000000001 195.8 235.2000000000001 191.8 231.2000000000001 188.6C227.4000000000001 185.4 222.4000000000001 183.6 216.2000000000001 183.6C210.4000000000001 183.6 205.6000000000001 185.6 201.8000000000001 189.4C198 193 195.6 197.4 194.4 202.6H163C164 195.8 165.8 189.8 168.8 184.6C171.8 179.4 175.6 174.8 180.2 171.2C184.8 167.6 190.2 164.8 196.2 163C202.4 161 208.8 160 215.8 160C227.4 160 237.4 162.4 245.4 167.2C253.4 172 260 178.2 265.2 185.8C270.4 193.6 274 202.2 276.4 211.6C278.8 221.2 280 230.8 280 240.4C280 250 279 259.6 277.2 269.2zM243 254.8C242 251.4 240.2 248.4 238.2 245.6C236 243 233.4 240.8 230 239.4C226.8 237.8 222.8 237 218.4 237C214.2 237 210.6 237.8 207.4 239.6C204.2 241.2 201.6 243.4 199.6 246.2C197.2 249 195.8 252 194.8 255.4C193.8 258.8 193.2 262.4 193.2 266.2C193.2 269.8 193.8 273.2 194.8 276.6C196 279.8 197.6 282.8 199.8 285.4C202 288 204.6 290.2 207.8 291.8C211 293.4 214.4 294.2 218.2 294.2C222.4 294.2 226.2 293.4 229.4 291.8C232.6 290.2 235.4000000000001 288 237.6 285.4C239.8 282.6 241.6 279.6 242.8 276.2C244.0000000000001 272.8 244.6 269.2 244.6 265.8C244.6 261.8 244 258.2 243 254.8zM233.8 108.6C231.4 105.6 228.6 103 225 101.2C221.6 99.4 217.6 98 213.4 97.2C209 96.4 204.6 96.2 200 96.2V77.8H233V0.2H259.6V120H238.4C237.8 115.4 236.2 111.6 233.8 108.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SortNumericalDesc.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SortNumericalDesc.displayName = "Blueprint5.Icon.SortNumericalDesc";
exports.default = SortNumericalDesc;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gLEH2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortNumerical", ()=>SortNumerical);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SortNumerical = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "sort-numerical",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M180 100.2C174.4 100.2 169.4 98 165.8 94.4H165.8L140 68.4V180.2000000000001C140 191.2000000000001 131 200.2000000000001 120 200.2000000000001C109 200.2000000000001 100 191.2000000000001 100 180.2000000000001V68.4L74.2 94.2000000000001C70.6 98 65.6 100.2 60 100.2C49 100.2 40 91.2 40 80.2C40 74.6 42.2 69.6 45.8 66L105.8 6V6C109.4 2.4 114.4 0.2 120 0.2C125.6 0.2 130.6 2.4 134.2 6V6L194.2 66C197.8 69.6 200 74.6 200 80.2000000000001C200.2 91.2 191.2 100.2 180 100.2zM357.6 95.6C356 104 353.2 111.4 349.2 118C345.2 124.6 339.8 130 333.2 134C326.6 138 318 140 307.6 140C300.4 140 294 138.8 288.2 136.2C282.4 133.6 277.4 130.2 273.2 125.8C268.9999999999999 121.4 265.8 116.2 263.3999999999999 110.2000000000001C261.2 104.2000000000001 260 97.8000000000001 260 90.8C260 85.4 260.7999999999999 80 262.6 74.8000000000001C264.2 69.6 267 64.8000000000001 270.6 60.8000000000001C274.3999999999999 56.6 279.2 53.2 284.8 50.8000000000001C290.4 48.4 296 47 301.8 47C308.4 47 314.2 48.2 319.2 50.4000000000001C324.2 52.8000000000001 328.5999999999999 56.6 332.4 62L332.8 61.6C332.5999999999999 57.8 332 53.6000000000001 331.2 49.0000000000001C330.4 44.2000000000001 329 39.8000000000001 327 35.6C325 31.4 322.4 28.0000000000001 319.2 25C316 22.2 311.8 20.6 306.8 20.6C302 20.6 298 22.2 294.8 25.6C291.6 29.0000000000001 289.4 32.8 288.6 37.4H262.4C263.2 31.6 264.8 26.2 267.2 21.6C269.5999999999999 17 272.8 13.0000000000001 276.8 9.8000000000001C280.6 6.6 285.2 4.2 290.2 2.6C295.2 1.0000000000001 300.6 0.2 306.6 0.2C316.4 0.2 324.5999999999999 2.2 331.2 6.4C338 10.6 343.4 16 347.6 22.8C351.8 29.6 355 37 357 45.4C359 53.8 360 61.9999999999999 360 70.4C360 79 359.2000000000001 87.4 357.6 95.6zM329.2000000000001 83C328.2 80 327 77.4 325.2000000000001 75C323.4000000000001 72.6 321.2000000000001 70.8 318.4000000000001 69.6S312.4000000000001 67.6 308.6 67.6C305.2000000000001 67.6 302 68.4 299.4000000000001 69.8C296.8 71.2 294.6 73.2 292.8 75.6C291.2 78 289.8 80.6 289 83.6C288.2000000000001 86.6 287.8 89.8 287.8 93C287.8 96 288.2 99 289.2000000000001 101.9999999999999C290.2000000000001 104.9999999999999 291.4 107.6 293.2 109.8C295 112.1999999999999 297.2 114 299.8 115.4C302.4000000000001 116.8 305.2 117.6 308.6 117.6C312 117.6 315.2 116.8 318 115.4C320.8 114 323 111.9999999999999 324.8000000000001 109.8C326.6 107.4 328.0000000000001 104.8 329.0000000000001 101.8C330.0000000000001 98.8 330.4000000000001 95.8 330.4000000000001 92.6C330.6 89.2000000000001 330 86 329.2000000000001 83zM306.4 180H340V400H315C314 393.2 311.6 387.6 308.2 383C304.8 378.4 300.4 374.6 295.6 371.6C290.6 368.6 285.2 366.6 279 365.4C273 364.2 266.6 363.6 260.2 363.6V335.4H306.4V180z" : "M120 80.2C114.4 80.2 109.4 78 105.8 74.4L100 68.4V140.2C100 151.2 91 160.2 80 160.2C69 160.2 60 151.2 60 140.2V68.4L54.2 74.2C50.6 77.8 45.6 80.2 40 80.2C29 80.2 20 71.2 20 60.2C20 54.6 22.2 49.6 25.8 46L25.8 46L65.8 6L65.8 6C69.4 2.4 74.4 0.2 80 0.2C85.6 0.2 90.6 2.4 94.2 6L134.2 46C137.8 49.6 140 54.6 140 60.2C140 71.2 131 80.2 120 80.2zM278.2 81.8C277 89 274.8 95.4 271.6 101C268.4 106.6 264.2000000000001 111.2 258.8 114.8C253.4 118.2 246.6 120 238.2 120C232.6 120 227.4000000000001 118.8 222.6 116.6C218 114.4 214 111.4 210.6 107.6C207.2 103.8 204.6 99.4 202.8 94.2C201 89 200 83.6 200 77.6C200 73 200.6 68.4 202 63.8C203.4 59.2000000000001 205.4 55.2 208.4 51.8C211.6 48.2 215.2 45.2 219.8 43.2C224.2 41.0000000000001 228.8 40.0000000000001 233.4 40.0000000000001C238.6 40.0000000000001 243.4 41.0000000000001 247.4 43.0000000000001S255 48.2 258 53.0000000000001L258.4 52.6C258.2 49.4 257.8 45.8000000000001 257 41.8000000000001C256.4 37.8000000000001 255.2 33.8000000000001 253.6 30.4000000000001C252 26.8000000000001 250 23.8000000000001 247.4 21.4000000000001C244.8 19.0000000000001 241.6 17.6000000000001 237.4 17.6000000000001C233.6 17.6000000000001 230.4 19.0000000000001 227.8 21.8000000000001C225.2 24.6000000000001 223.5999999999999 28.0000000000001 222.8 31.8000000000001H202C202.6 26.8000000000001 204 22.2000000000001 205.8 18.2000000000001C207.8 14.2000000000001 210.2 10.8000000000001 213.4 8.2000000000001C216.6 5.4000000000001 220 3.4000000000001 224.2 2.0000000000001S232.6 1e-13 237.2 1e-13C245.0000000000001 1e-13 251.6 1.8000000000001 257 5.4000000000001C262.4000000000001 9.0000000000001 266.8 13.6000000000001 270.2000000000001 19.4000000000001C273.6 25.2 276 31.6000000000001 277.6 38.8000000000001C279.2000000000001 46.0000000000001 280 53.2000000000001 280 60.2000000000001C280 67.4 279.4000000000001 74.6 278.2 81.8zM255.4 71C254.6 68.4 253.6 66.2 252.2 64.2C250.8 62.2000000000001 249 60.6 246.8 59.4C244.6 58.2 242 57.6 239 57.6C236.2 57.6 233.8 58.2 231.6 59.4C229.4 60.6 227.8 62.4 226.4 64.4C225 66.4 224 68.8 223.4 71.4C222.8 74 222.4 76.6 222.4 79.4C222.4 82 222.8 84.6 223.4 87.2C224.2 89.8 225.2 92 226.6 94C228 96 229.8 97.6 231.8 98.8C233.8 100 236.2 100.6 238.8 100.6C241.6 100.6 244 100 246.2 98.8C248.4 97.6 250.2 96 251.8 94C253.2 92 254.4 89.6 255.2 87C256 84.4 256.4 81.8 256.4 79.2C256.4 76.2 256 73.6 255.4 71zM224.2 160.4H260V320H231.6C230.6 314 228.4 308.8 225.4 304.8C222.2 300.6 218.4 297.4 213.8 294.8C209.2 292.2 204 290.6 198.2 289.6C192.2 288.6 186.2 288.2 180 288.4V264H224.2V160.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SortNumerical.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SortNumerical.displayName = "Blueprint5.Icon.SortNumerical";
exports.default = SortNumerical;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"84vyj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sort", ()=>Sort);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Sort = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "sort",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 80H200C189 80 180 71 180 60V40C180 29 189 20 200 20H380C391 20 400 29 400 40V60C400 71 391 80 380 80zM380 180H200C189 180 180 171 180 160V140C180 129 189 120 200 120H380C391 120 400 129 400 140V160C400 171 391 180 380 180zM140 100C134.4 100 129.4 97.8 125.8 94.2000000000001L100 68.2V180C100 191 91 200 80 200S60 191 60 180V68.2L34.2 94C30.6 97.8 25.6 100 20 100C9 100 0 91 0 80C0 74.4 2.2 69.4 5.8 65.8L65.8 5.8C69.4 2.2 74.4 0 80 0S90.6 2.2 94.2 5.8L154.2 65.8C157.8 69.4 160 74.4 160 80C160 91 151 100 140 100zM380 380H200C189 380 180 371 180 360V340C180 329 189 320 200 320H380C391 320 400 329 400 340V360C400 371 391 380 380 380zM380 280H200C189 280 180 271 180 260V240C180 229 189 220 200 220H380C391 220 400 229 400 240V260C400 271 391 280 380 280z" : "M100 80C94.4 80 89.4 77.8 85.8 74.2L80 68.2V140C80 151 71 160 60 160S40 151 40 140V68.2L34.2 74C30.6 77.8 25.6 80 20 80C9 80 0 71 0 60C0 54.4 2.2 49.4 5.8 45.8L45.8 5.8C49.4 2.2 54.4 0 60 0S70.6 2.2 74.2 5.8L114.2 45.8C117.8 49.4 120 54.4 120 60C120 71 111 80 100 80zM160 260H300C311 260 320 269 320 280C320 291 311 300 300 300H160C149 300 140 291 140 280C140 269 149 260 160 260zM300 220H160C149 220 140 211 140 200C140 189 149 180 160 180H300C311 180 320 189 320 200C320 211 311 220 300 220zM300 60H160C149 60 140 51 140 40C140 29 149 20 160 20H300C311 20 320 29 320 40C320 51 311 60 300 60zM300 140H160C149 140 140 131 140 120C140 109 149 100 160 100H300C311 100 320 109 320 120C320 131 311 140 300 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Sort.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Sort.displayName = "Blueprint5.Icon.Sort";
exports.default = Sort;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dvhJp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpellCheck", ()=>SpellCheck);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SpellCheck = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "spell-check",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M177.8 388.8L277.8 188.8C279 186.2 280 183.2 280 180C280 169 271 160 260 160C252.2 160 245.6 164.6 242.2 171L217.6 220H102.4L77.8 171.2C74.4 164.6 67.8 160 60 160C49 160 40 169 40 180C40 183.2 41 186.2 42.4 188.8L89.4 283.4L107.4 319.6L142.2 388.8C145.6 395.4 152.2 400 160 400C167.8 400 174.4 395.4 177.8 388.8zM122.4024 259.9954L160.0024 335.1954L197.6024 259.9954H122.4024zM345.8 174.2C349.4 177.8 354.4 180 360 180C371 180 380 171 380 160C380 154.4 377.8 149.4 374.2000000000001 145.8L234.2 5.8C230.6 2.2 225.6 0 220 0C214.4 0 209.4 2.2 205.8 5.8L145.8 65.8C142.2 69.4 140 74.4 140 80C140 91 149 100 160 100C165.6 100 170.6 97.8 174.2 94.2000000000001L220 48.2L345.8 174.2z" : "M137.8 308.8L217.8 148.8C219 146.2 220 143.2 220 140C220 129 211 120 200 120C192.2 120 185.6 124.6 182.2 131H182L167.6 160H72.4L58 131.2H57.8C54.4 124.6 47.8 120 40 120C29 120 20 129 20 140C20 143.2 21 146.2 22.4 148.8L62 228.4L80 264.8L102.2 308.8C105.6 315.4 112.2 320 120 320C127.8 320 134.4 315.4 137.8 308.8zM280 140C274.4000000000001 140 269.4000000000001 137.8 265.8 134.2L180 48.2L134.2 94.2C130.6 97.8 125.6 100 120 100C109 100 100 91 100 80C100 74.4 102.2 69.4 105.8 65.8L165.8 5.8C169.4 2.2 174.4 0 180 0C185.6 0 190.6 2.2 194.2 5.8L294.2000000000001 105.8C297.8 109.4 300 114.4 300 120C300 131 291 140 280 140zM120.0024 255.1954L92.4024 199.9954H147.6024L120.0024 255.1954z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SpellCheck.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SpellCheck.displayName = "Blueprint5.Icon.SpellCheck";
exports.default = SpellCheck;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kvAkq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SplitColumns", ()=>SplitColumns);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SplitColumns = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "split-columns",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 140C300 129 309 120 320 120C325.6 120 330.6 122.2 334.2000000000001 125.8L394.2000000000001 185.8C397.8 189.4 400 194.4 400 200C400 205.6 397.8 210.6 394.2000000000001 214.2L334.2000000000001 274.2000000000001C330.6 277.8 325.6 280 320 280C309 280 300 271 300 260C300 254.4 302.2 249.4 305.8 245.8L331.8 220H220V360H320V320C335.4 320 349.4 314 360 304.4V380C360 391 351 400 340 400H60C49 400 40 391 40 380V304.4C50.6 314 64.6 320 80 320V360H180V220H68.2L94 245.8C97.8 249.4 100 254.4 100 260C100 271 91 280 80 280C74.4 280 69.4 277.8 65.8 274.2L5.8 214.2C2.2 210.6 0 205.6 0 200C0 194.4 2.2 189.4 5.8 185.8L65.8 125.8C69.4 122.2 74.4 120 80 120C91 120 100 129 100 140C100 145.6 97.8 150.6 94.2 154.2L68.2 180H180V40H80V80C64.6 80 50.6 86 40 95.6V20C40 9 49 0 60 0H340C351 0 360 9 360 20V95.6C349.4 86 335.4 80 320 80V40H220V180H331.8L306 154.2C302.2 150.6 300 145.6 300 140z" : "M240 120C240 109 249 100 260 100C265.6 100 270.6 102.2 274.2000000000001 105.8L314.2000000000001 145.8C317.8 149.4 320 154.4 320 160C320 165.6 317.8 170.6 314.2000000000001 174.2L274.2000000000001 214.2C270.6 217.8 265.6 220 260 220C249 220 240 211 240 200C240 194.4 242.2 189.4 245.8 185.8L251.8 180H180V280H240V245.8C246.2 248.4 252.8 250 260 250S273.8 248.4 280 245.8V300C280 311 271 320 260 320H60C49 320 40 311 40 300V245.8C46.2 248.4 52.8 250 60 250S73.8 248.4 80 245.8V280H140V180H68.2L74 185.8C77.8 189.4 80 194.4 80 200C80 211 71 220 60 220C54.4 220 49.4 217.8 45.8 214.2L5.8 174.2C2.2 170.6 0 165.6 0 160C0 154.4 2.2 149.4 5.8 145.8L45.8 105.8C49.4 102.2 54.4 100 60 100C71 100 80 109 80 120C80 125.6 77.8 130.6 74.2 134.2L68.2 140H140V40H80V74.2C73.8 71.6 67.2 70 60 70S46.2 71.6 40 74.2V20C40 9 49 0 60 0H260C271 0 280 9 280 20V74.2C273.8 71.6 267.2 70 260 70S246.2 71.6 240 74.2V40H180V140H251.8L246 134.2C242.2 130.6 240 125.6 240 120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SplitColumns.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SplitColumns.displayName = "Blueprint5.Icon.SplitColumns";
exports.default = SplitColumns;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2goj4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SportsStadium", ()=>SportsStadium);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SportsStadium = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "sports-stadium",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 390C160 395.52246 164.4772 400 170 400C178.6592 400 180 394.6289 180 394.6289C186.7698 403.67188 196.3778 399.526368 206.796 395.0293C217.756 390.29296 229.612 385.17578 240 394.6289V344.7412C229.59 336.455 217.514 340.7422000000001 206.368 344.7022C196.1184 348.3398000000001 186.6556 351.6992 180 344.7412V299.6044C186.578 299.8682 193.2502 300 200 300C228.444 300 255.502 297.627 280 293.3448V370C280 375.5224 284.478 380 290 380C298.66 380 300 374.629 300 374.629C306.77 383.67188 316.378 379.5264 326.796 375.0292C337.756 370.293 349.612 365.1758 360 374.629V324.7412C349.5900000000001 316.455 337.514 320.7422000000001 326.368 324.7022C316.118 328.3398 306.656 331.6992 300 324.7412V289.2968C359.7800000000001 275.4638 400 249.6142 400 220C400 207.378 392.692 195.44 379.678 184.824C374.066 226.7578 295.768 260 200 260C104.2324 260 25.933 226.7578 20.3218 184.824C7.30728 195.44 0 207.378 0 220C0 238.0566 14.95452 254.7168 40.1796 268.1054000000001C40.0618 268.7208 40 269.3506 40 270V370C40 375.5224 44.477 380 50 380C58.6592 380 60 374.629 60 374.629C66.7698 383.67188 76.3778 379.5264 86.7952 375.0292C97.7558 370.293 109.6118 365.1758 120 374.629V324.7412C109.5898 316.455 97.514 320.7422000000001 86.3688 324.7022C76.1186 328.3398 66.6558 331.6992 60 324.7412V277.1338C87.009 287.7246 121.4962 295.2734000000001 160 298.3984000000001V390zM357.36 170.62C359.304 174.18 360 177.314 360 180C360 184.536 358.014 190.366 351.366 197.354C344.622 204.4384 333.916 211.7334 319.156 218.291C289.688 231.3916 247.578 240 200 240C152.4228 240 110.3116 231.3916 80.8436 218.291C66.0842 211.7334 55.3784 204.4384 48.6332 197.354C41.986 190.366 40 184.536 40 180C40 177.314 40.695 174.18 42.6392 170.62C79.2556 151.972 136.1316 140 200 140C263.868 140 320.744 151.972 357.36 170.62zM200 120C257.122 120 309.756 129.228 348.85 144.864C369.374 153.074 387.13 167.112 400 180V60C400 33.134 341.142 7.646 260 0V20C260 53.134 233.138 80 200 80C166.8628 80 140 53.134 140 20V0C58.8578 7.646 0 33.134 0 60V180C14.39492 165.798 32.5152 152.318 51.1508 144.864C90.2436 129.228 142.8784 120 200 120z" : "M120 310C120 315.52284 124.4772 320 130 320C132.3996 320 134.6016 319.154856 136.325 317.746C143.089 322.21074 153.0342 319.1973 163.6486 315.98112C176.218 312.17258 189.7256 308.07974 199.9998 315.78408V263.402C189.787 257.0958 178.304 260.8446 167.643 264.3252C156.87 267.8424 146.936 271.0856 140 263.4022V239.5358C146.5518 239.8422 153.2268 240 160 240C181.218 240 201.472 238.4512 220 235.6386V310C220 315.52284 224.478 320 230 320C232.4 320 234.602 319.154856 236.324 317.746C243.09 322.21074 253.034 319.1973 263.648 315.98112C276.218 312.17258 289.726 308.07974 300 315.78408V263.402C289.786 257.0958 278.3040000000001 260.8446 267.644 264.3252C256.87 267.8424 246.936 271.0856 240 263.4022V231.973C287.824 221.5988 320 202.2084 320 180C320 168.9582 312.046 158.613 298.17 149.7262C287.326 178.238 229.592 200 160 200C90.4072 200 32.6742 178.238 21.83 149.7262C7.95378 158.613 0 168.9582 0 180C0 190.558 7.272 200.479 20.0402 209.0972C20.0136 209.3946 20 209.6958 20 210V310C20 315.52284 24.4772 320 30 320C32.3996 320 34.6016 319.154856 36.325 317.746C43.089 322.21074 53.0342 319.1973 63.6486 315.98112C76.218 312.17258 89.7256 308.07974 99.9998 315.78408V263.402C89.787 257.0958 78.304 260.8446 67.643 264.3252C56.87 267.8424 46.936 271.0856 40 263.4022V219.6874C60.8442 228.5434 88.551 235.0744000000001 120 238.1098V310zM279.992 140.309C279.904 141.9236 279.074 144.9388 274.764 149.306C270.076 154.0554 262.302 159.2498 251.116 164.0436C228.818 173.6004 196.6162 180 160 180C123.3838 180 91.183 173.6004 68.8834 164.0436C57.698 159.2498 49.924 154.0554 45.2368 149.306C40.9266 144.9388 40.0966 141.9236 40.0086 140.309C69.3262 127.8548 112.217 120 160 120C207.784 120 250.674 127.8548 279.992 140.309zM280.16 118.848C248.434 106.95 205.946 100 160 100C114.0538 100 71.5666 106.95 39.8404 118.848C24.3942 124.6396 10.50068 131.2118 0 140.309V60C0 32.042 50.991 6.66 120 0V20C120 42.092 137.9086 60 160 60C182.0914 60 200 42.092 200 20V0C269.01 6.66 320 32.042 320 60V140.309C309.5 131.2118 295.606 124.6396 280.16 118.848z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SportsStadium.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SportsStadium.displayName = "Blueprint5.Icon.SportsStadium";
exports.default = SportsStadium;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cEhLm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Square", ()=>Square);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Square = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "square",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H380C391 0 400 9 400 20V380C400 391 391 400 380 400zM360 40H40V360H360V40z" : "M300 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V300C320 311 311 320 300 320zM280 40H40V280H280V40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Square.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Square.displayName = "Blueprint5.Icon.Square";
exports.default = Square;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"77OSR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StackedChart", ()=>StackedChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var StackedChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "stacked-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 360C240 371 231 380 220 380H180C169 380 160 371 160 360V280H240V360zM300 80H340C351 80 360 89 360 100V200H280V100C280 89 289 80 300 80zM360 280C360 291 351 300 340 300H300C289 300 280 291 280 280V220H360V280zM240 260H160V160H240V260zM60 80H100C111 80 120 89 120 100V160H40V100C40 89 49 80 60 80zM380 60H20C9 60 0 51 0 40C0 29 9 20 20 20H380C391 20 400 29 400 40C400 51 391 60 380 60zM120 220C120 231 111 240 100 240H60C49 240 40 231 40 220V180H120V220zM180 80H220C231 80 240 89 240 100V140H160V100C160 89 169 80 180 80z" : "M200 280C200 291 191 300 180 300H160C149 300 140 291 140 280V220H200V280zM260 80H280C291 80 300 89 300 100V160H240V100C240 89 249 80 260 80zM300 220C300 231 291 240 280 240H260C249 240 240 231 240 220V180H300V220zM200 200H140V140H200V200zM100 180C100 191 91 200 80 200H60C49 200 40 191 40 180V160H100V180zM160 80H180C191 80 200 89 200 100V120H140V100C140 89 149 80 160 80zM300 60H40C29 60 20 51 20 40C20 29 29 20 40 20H300C311 20 320 29 320 40C320 51 311 60 300 60zM60 80H80C91 80 100 89 100 100V140H40V100C40 89 49 80 60 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
StackedChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
StackedChart.displayName = "Blueprint5.Icon.StackedChart";
exports.default = StackedChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"04HFj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StadiumGeometry", ()=>StadiumGeometry);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var StadiumGeometry = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "stadium-geometry",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 260H100C66.863 260 40 233.137 40 200C40 166.862 66.863 140 100 140H300C333.1380000000001 140 360 166.862 360 200C360 233.137 333.1380000000001 260 300 260zM100 300C44.7716 300 0 255.2284 0 200C0 144.772 44.7716 100 100 100H300C355.228 100 400 144.772 400 200C400 255.2284 355.228 300 300 300H100z" : "M240 200H80C57.9086 200 40 182.0914 40 160C40 137.9086 57.9086 120 80 120H240C262.092 120 280 137.9086 280 160C280 182.0914 262.092 200 240 200zM80 240C35.8172 240 0 204.1828 0 160C0 115.818 35.8172 80 80 80H240C284.182 80 320 115.818 320 160C320 204.1828 284.182 240 240 240H80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
StadiumGeometry.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
StadiumGeometry.displayName = "Blueprint5.Icon.StadiumGeometry";
exports.default = StadiumGeometry;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6odjA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StarEmpty", ()=>StarEmpty);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var StarEmpty = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "star-empty",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M400 248L262 270L200 400L138 268L0 248L100 146L76 0L200 68L324 0L300 144L400 248zM200 100L110 52L128 156L56 228L156 244L200 338L244 244L344 228L272 154L290 50L200 100z" : "M320 197.8L209.4 214.6L160 320L110.6 214.6L0 197.8L80 115.8L61.2 0L160 54.6L258.8 0L240 115.8L320 197.8L320 197.8zM98.2 56L110 128.4L60 179.6L129 190.2L160 256L191 190.2L260 179.6L210 128.4L221.8 56L160 90.2L98.2 56z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
StarEmpty.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
StarEmpty.displayName = "Blueprint5.Icon.StarEmpty";
exports.default = StarEmpty;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3aNRx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Star", ()=>Star);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Star = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "star",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400L262 268L400 248L300 146L324 0L200 68L76 0L100 146L0 248L138 268z" : "M160 320L210 214L320 198L240 116L258 0L160 54L62 0L80 116L0 198L110 214z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Star.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Star.displayName = "Blueprint5.Icon.Star";
exports.default = Star;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bW69N":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StepBackward", ()=>StepBackward);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var StepBackward = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "step-backward",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 340C295.4 340 291.6 338.2 288.2 335.8L288 336L160 240V320C160 331 151 340 140 340H100C89 340 80 331 80 320V80C80 69 89 60 100 60H140C151 60 160 69 160 80V160L288 64L288.2 64.2000000000001C291.6 61.8 295.4 60 300 60C311 60 320 69 320 80V320C320 331 311 340 300 340z" : "M240 260C235.2 260 231.2 258.2 227.6 255.4L227.4000000000001 255.6L140 185.6V240C140 251 131 260 120 260H100C89 260 80 251 80 240V80C80 69 89 60 100 60H120C131 60 140 69 140 80V134.4L227.6 64.4L227.8 64.6C231.2 61.8 235.2 60 240 60C251 60 260 69 260 80V240C260 251 251 260 240 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
StepBackward.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
StepBackward.displayName = "Blueprint5.Icon.StepBackward";
exports.default = StepBackward;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jIGS6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StepChart", ()=>StepChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var StepChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "step-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 80H40V140H120C131 140 140 149 140 160V240H200V200C200 189 209 180 220 180H320C331 180 340 189 340 200V280H380C391 280 400 289 400 300C400 311 391 320 380 320H320C309 320 300 311 300 300V220H240V260C240 271 231 280 220 280H120C109 280 100 271 100 260V180H40V340C40 351 31 360 20 360S0 351 0 340V60C0 49 9 40 20 40H380C391 40 400 49 400 60C400 71 391 80 380 80z" : "M300 80H40V120H100C111 120 120 129 120 140V180H160V160C160 149 169 140 180 140H260C271 140 280 149 280 160V220H300C311 220 320 229 320 240S311 260 300 260H260C249 260 240 251 240 240V180H200V200C200 211 191 220 180 220H100C89 220 80 211 80 200V160H40V260C40 271 31 280 20 280S0 271 0 260V60C0 49 9 40 20 40H300C311 40 320 49 320 60S311 80 300 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
StepChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
StepChart.displayName = "Blueprint5.Icon.StepChart";
exports.default = StepChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6anQs":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StepForward", ()=>StepForward);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var StepForward = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "step-forward",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 340H260C249 340 240 331 240 320V240L112 336L111.8 335.8C108.4 338.2 104.6 340 100 340C89 340 80 331 80 320V80C80 69 89 60 100 60C104.6 60 108.4 61.8 111.8 64.2000000000001L112 64L240 160V80C240 69 249 60 260 60H300C311 60 320 69 320 80V320C320 331 311 340 300 340z" : "M240 260H220C209 260 200 251 200 240V185.6L112.4 255.6L112.4 255.4C108.8 258.2 104.8 260 100 260C89 260 80 251 80 240V80C80 69 89 60 100 60C104.8 60 108.8 61.8 112.4 64.6L112.6 64.4L200 134.4V80C200 69 209 60 220 60H240C251 60 260 69 260 80V240C260 251 251 260 240 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
StepForward.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
StepForward.displayName = "Blueprint5.Icon.StepForward";
exports.default = StepForward;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iKpBm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Stop", ()=>Stop);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Stop = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "stop",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 340H80C69 340 60 331 60 320V80C60 69 69 60 80 60H320C331 60 340 69 340 80V320C340 331 331 340 320 340z" : "M240 260H80C69 260 60 251 60 240V80C60 69 69 60 80 60H240C251 60 260 69 260 80V240C260 251 251 260 240 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Stop.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Stop.displayName = "Blueprint5.Icon.Stop";
exports.default = Stop;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"klfGK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Stopwatch", ()=>Stopwatch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Stopwatch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "stopwatch",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 280C133.72583 280 80 226.2741700000001 80 160C80 93.72583 133.72583 40 200 40C266.2741700000001 40 320 93.72583 320 160L200 160L200 280zM180.0373994 318.7667840000001C180.012587 319.174675 180 319.5858676000001 180 320L180 360L140 360C128.954305 360 120 368.954305 120 380C120 391.045695 128.954305 400 140 400L260 400C271.045694 400 280 391.045695 280 380C280 368.954305 271.045694 360 260 360L220 360L220 320C220 319.5858676000001 219.987412 319.174675 219.9626 318.7667840000001C298.9069380000001 308.941431 360 241.6052402 360 160C360 71.63444 288.36556 0 200 0C111.63444 0 40 71.63444 40 160C40 241.6052402 101.0930626 308.941431 180.0373994 318.7667840000001z" : "M180 280L180 258.3408312000001C236.7542660000001 248.8192694 280 199.4599258 280 140C280 73.72583 226.2741700000001 20 160 20C93.72583 20 40 73.72583 40 140C40 199.4599258 83.2457332 248.8192694 140 258.3408312000001L140 280L120 280C108.954305 280 100 288.954305 100 300C100 311.045695 108.954305 320 120 320L200 320C211.045694 320 220 311.045695 220 300C220 288.954305 211.045694 280 200 280L180 280zM160 220C115.81722 220 80 184.18278 80 140C80 95.81722 115.81722 60 160 60C204.18278 60 240 95.81722 240 140L160 140L160 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Stopwatch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Stopwatch.displayName = "Blueprint5.Icon.Stopwatch";
exports.default = Stopwatch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5oKdq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Strikethrough", ()=>Strikethrough);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Strikethrough = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "strikethrough",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 220H270.8C268.2 221 265.6 222 262.8 222.8C259 223.8 252.6 225.6 243.6 227.8C234.6 230 225.6 232.4000000000001 216.2 234.8C206.8 237.2 198.4 239.4 190.8 241.4S178.8 244.6 177.8 244.8C167.2 247.8 158.8 252.2 152.4 258C146 263.6 142.6 271.6 142.6 281.8C142.6 289 144.4 295 147.8 299.8C151.2 304.6 155.6 308.4 160.8 311.2000000000001C166 314 171.8 316 178.2 317.2S190.8 319 196.8 319C214.6 319 229.4 315.2 241 307.6C250 301.6 256 292.4 258.8 280H311.4C310.2 290.4 307.4000000000001 299.6 303 308C297 319.4 288.8 329 278.4 336.6C268 344.4 256.2 350.2 242.6 354C228.6 358 214.2 360 198.8 360C185.6 360 172.6 358.4 159.6 355S135.2 346.4 125 339.6S106.6 323.8 100.4 313.2C94.2 302.8 91.2 290.2 91.2 275.8C91.2 268.4 92.2 261 94.2 253.8C96.2 246.6 99.8 239.8 104.8 233.4C108.4 228.6 113 224 118.6 220H40C29 220 20 211 20 200C20 189 29 180 40 180H242.8C243.2 179.8 243.8 179.6 244.2 179.6C250.2000000000001 177.4 255.8 173.8 261 168.6C266 163.4 268.6 155.2 268.6 144.4C268.6 139 267.4000000000001 133.8 265.2000000000001 128.6C263.0000000000001 123.4 259.4000000000001 118.8 254.4000000000001 114.8C249.4000000000001 110.8 243.0000000000001 107.6 235.0000000000001 105C227.0000000000001 102.4 217.4 101.2 206.2000000000001 101.2C195.8000000000001 101.2 186.0000000000001 102.4 177.2000000000001 104.6C168.2000000000001 106.8 160.4000000000001 110.4 153.4000000000001 115.4S141.2000000000001 126.6 137.4000000000001 134.4C136.4 136 135.6 138 135 140H82.2C84 131.4 86.6 123.6 90.2 116.4C96.8 103.4 105.6 92.8 116.6 84.6C127.6 76.4 140.6 70.2000000000001 155.4 66.2C170.2000000000001 62.2 186 60.1999999999999 202.8 60.1999999999999C217.4 60.1999999999999 231.6 61.8 245.6 65.1999999999999C259.6 68.6 272.2000000000001 73.8 283.2 80.9999999999999C294.2000000000001 88.1999999999999 303 97.6 309.8 108.8C316.6 120 320 133.8 320 149.8C320 157.2 318.8 164.8 316.4 172.2C315.6 174.8 314.6 177.4 313.4 180H360C371 180 380 189 380 200C380 211 371 220 360 220z" : "M280 180H173C165.4 181.8 158.4 183.6 152.2 185.2C146 186.8 142.4 187.8 141.4 188C132.8 190.2 125.6 193.8 120.4 198.4C115 203 112.4 209.4 112.4 217.4C112.4 223.2 113.8 228 116.6 231.8S123 238.6 127.4 241C131.8 243.2 136.6 244.8 141.8 245.8C147 246.8 152.2 247.2 157.2 247.2C172 247.2 184.4 244.2 194 238C200.4 234 205 228 207.6 220H252.0000000000001C250.8 226.6 248.6 232.8 245.6 238.4C240.6 247.4 233.8 255.2 225.2000000000001 261.4C216.6 267.6 206.6 272.2 195.4 275.4S171.8 280 159 280C148 280 137 278.6 126.4 276C115.6 273.4 106 269.2 97.4 263.6C89 258 82.2 251 77 242.6C71.8 234.2 69.2 224.2 69.2 212.6C69.2 206.6 70 200.8 71.8 195C73.4 189.8 76 184.8 79.6 180H40C29 180 20 171 20 160C20 149 29 140 40 140H182.6C187.6 138.6 192.4 137.2 196.8 135.6C201.8 133.8 206.4 131 210.8 126.8C215 122.6 217.2 116.2 217.2 107.4C217.2 103.2 216.2 98.8 214.4 94.8C212.6 90.6 209.6 86.9999999999999 205.4 83.8C201.2 80.6 195.8 78 189.2 75.9999999999999C182.6 73.9999999999999 174.6 72.9999999999999 165.2 72.9999999999999C156.4 72.9999999999999 148.4 73.9999999999999 141 75.8C133.6 77.5999999999999 127 80.6 121.2 84.4C115.4 88.3999999999999 111 93.3999999999999 107.8 99.5999999999999C107.6 99.6 107.6 99.8 107.4 100H62.8C64.2 94.6 66.2 89.6 68.6 85C74 74.6 81.4 66.2 90.6 59.4S110.6 47.8 123 44.6C135.2 41.6 148.4 40 162.4 40C174.6 40 186.4 41.4 198.2 44C209.8 46.6 220.4 50.8 229.4 56.6C238.6 62.4 246 69.8 251.6 78.8C257.2 87.8 260 98.8 260 111.6C260 117.6 259 123.6 257 129.6C256 133.4 254.4 136.8 252.6 140H280C291 140 300 149 300 160C300 171 291 180 280 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Strikethrough.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Strikethrough.displayName = "Blueprint5.Icon.Strikethrough";
exports.default = Strikethrough;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJ1BE":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Style", ()=>Style);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Style = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "style",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 40H40V360H286L326 400H60H20C8 400 0 392 0 380V20C0 8 8 0 20 0H380C392 0 400 8 400 20V120V246L360 206V40zM384 400L232 248L288 192L400 304V400H384zM80 82C142 78 198 78 244 122C266 144 266 182 244 204C232 214 218 220 204 220S176 214 166 204C144 180 132 114 80 82z" : "M280 40H40V280H215.2L255.2 320H20C9 320 0 311 0 300V20C0 9 9 0 20 0H300C311 0 320 9 320 20V195.2L280 155.2V40zM308 320L194 206L236 164L320 248V320H308zM80 81.6C126.6 78.6 168.4 78.6 203 111.6C219.4 128.2 219.4 156.6 203 173.2C194 180.8 183.4 185.2 173 185.2C162.4 185.2 152 180.8 144.4 173.2C128 155 119 105.6 80 81.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Style.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Style.displayName = "Blueprint5.Icon.Style";
exports.default = Style;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eBUFj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscript", ()=>Subscript);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Subscript = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "subscript",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M4.4819 267.382C1.67985 270.8238 0 275.2158 0 280C0 291.0456 8.9543 300 20 300C26.385 300 32.0714 297.0078 35.733 292.3494L100 212.0156L164.2676 292.3502C167.9294 297.0082 173.6152 300 180 300C191.0458 300 200 291.0456 200 280C200 275.2154 198.32 270.8234 195.5176 267.3814L125.6124 180L195.517 92.62C198.3198 89.178 200 84.784 200 80C200 68.954 191.0458 60 180 60C173.6146 60 167.928 62.992 164.2664 67.652L100 147.984L35.7334 67.652C32.0718 62.992 26.3854 60 20 60C8.9543 60 0 68.954 0 80C0 84.784 1.680234 89.178 4.48286 92.62L74.3876 180L4.4819 267.382zM320.48 40.8C323.6760000000001 44.6 327.2720000000001 48.4 331.668 51.8C335.864 55.4 340.6600000000001 59 345.854 62.4L345.856 62.4C350.85 66 355.8440000000001 69.6 360.8400000000001 73.6C365.834 77.6 370.63 81.8 375.424 86.2C380.0200000000001 90.6 384.216 95.6 388.012 101C391.608 106.4 394.606 112.2 396.804 118.6C399.002 125 400 132 400 140C400 146.4 399.002 153 397.202 160C395.404 167 392.208 173.6 387.812 179.4C383.416 185.4 377.622 190.4 370.43 194.2C363.236 198.2 354.246 200 343.456 200C333.666 200 324.876 198 317.4820000000001 194.2C310.0900000000001 190.6 303.696 185.4 298.502 178.6C293.306 172 289.51 164 286.914 154.6C284.316 145.4 282.918 135.4 282.918 124.6H311.488C311.688 131.6 312.288 138 313.286 144C314.286 150 316.084 155.2 318.282 159.6C320.48 164 323.476 167.4 327.2720000000001 170C331.07 172.6 335.864 173.8 341.4580000000001 173.8C347.652 173.8 352.648 172.6 356.444 170.2C360.24 167.8 363.236 165 365.434 161.6C367.632 158.2 369.032 154.4 369.83 150.4C370.63 146.4 371.0300000000001 142.6 371.0300000000001 139C370.83 131.4 369.032 124.6 365.834 118.6C362.838 112.6 358.442 107.2 353.246 102C348.052 97 342.4580000000001 92.2 336.264 87.8C330.07 83.4 324.076 78.8 318.482 74.2000000000001C306.4940000000001 65.2000000000001 297.302 54.6 290.31 42.6C283.3160000000001 30.4 279.92 16.2 279.7200000000001 0H399.4V28.6H313.886C315.086 32.8 317.2820000000001 37 320.48 40.8z" : "M123.9996 232C127.7768 237.0362 133.7046 240 139.9996 240C156.4806 240 165.8882 221.1848 155.9996 208L104.9996 140L155.9996 72C165.8882 58.816 156.4806 40 139.9996 40C133.7046 40 127.7768 42.964 123.9996 48L79.9996 106.666L35.9996 48C32.2226 42.964 26.2948 40 19.99964 40C3.51884 40 -5.88882 58.816 3.99964 72L54.9996 140L3.99964 208C-5.8888 221.1848 3.51884 240 19.99964 240C26.2948 240 32.2226 237.0362 35.9996 232L79.9996 173.3334L123.9996 232zM263.082 41.118L263.4 41.4C267 44.2 270.6 47 274.8 49.8L287.4 58.8C291.6 62 295.6 65.4 299.6 69C303.6 72.6 307 76.6 310 80.8C313 85 315.6 89.8 317.4 94.8C319.2000000000001 99.8 320 105.6 320 111.8C320 116.8 319.2000000000001 122 317.6 127.6C316.2 133.4 313.6 138.6 309.8 143.4C306.2 148.2 301.2 152.2 295.2 155.4C289.4000000000001 158.4 282 160 273 160C265 160 257.8 158.4 251.6 155.4C245.4 152.2 240 148 235.8 143C231.4 137.6 228.2 131.2 226 123.8C223.8 116.4 222.8 108.4 222.8 99.8H246.6C246.8 105.2 247.2 110.4 248.2 115.2C249 120 250.4 124.2 252.4 127.6C254.2 131.2 256.8 134 260 136C263.2 138 267 139 271.8 139C277 139 281.2 138 284.4000000000001 136.2C287.4 134.4 290 132 291.8 129.2C293.6 126.4 294.8 123.4 295.4 120.2C296 117 296.4 114 296.4 111.2C296.2 105 294.8 99.6 292 94.8C289.2000000000001 90.2 285.6 85.8 281.4 81.8C277 77.6 272.2 74 267.2 70.4C262 66.8 257 63.2 252.2 59.6C242.2 52.4 234.4 44 228.8 34.2C223.2 24.4 220.2 13 220 0H319.8V22.8H248.8C249.8 26.2 251.6 29.4 254.2 32.6C256.718 35.506 259.8 38.224 263.082 41.118z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Subscript.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Subscript.displayName = "Blueprint5.Icon.Subscript";
exports.default = Subscript;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cHZd6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Superscript", ()=>Superscript);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Superscript = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "superscript",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320.48 240.8C323.6760000000001 244.6 327.2720000000001 248.4 331.668 251.8C335.864 255.4 340.6600000000001 259 345.854 262.4C350.85 266 355.8440000000001 269.6 360.8400000000001 273.6C365.834 277.6 370.63 281.8 375.424 286.2C380.0200000000001 290.6 384.216 295.6 388.012 301C391.608 306.4 394.606 312.2 396.804 318.6C399.002 325 400 332 400 340C400 346.4 399.002 353 397.202 360C395.404 367 392.208 373.6 387.812 379.4C383.416 385.4 377.622 390.4 370.43 394.2C363.236 398.2 354.246 400 343.456 400C333.666 400 324.876 398 317.4820000000001 394.2C310.0900000000001 390.6 303.696 385.4 298.502 378.6C293.306 372 289.51 364 286.914 354.6C284.316 345.4 282.918 335.4 282.918 324.6H311.488C311.688 331.6 312.288 338 313.286 344C314.286 350 316.084 355.2 318.282 359.6C320.48 364 323.476 367.4 327.2720000000001 370C331.07 372.6 335.864 373.8 341.4580000000001 373.8C347.652 373.8 352.648 372.6 356.444 370.2C360.24 367.8 363.236 365 365.434 361.6C367.632 358.2 369.032 354.4 369.83 350.4C370.63 346.4 371.0300000000001 342.6 371.0300000000001 339C370.83 331.4 369.032 324.6 365.834 318.6C362.838 312.6 358.442 307.2 353.246 302C348.052 297 342.4580000000001 292.2 336.264 287.8C330.07 283.4 324.076 278.8 318.482 274.2C306.4940000000001 265.2 297.302 254.6 290.31 242.6C283.3160000000001 230.4 279.92 216.2 279.7200000000001 200H399.4V228.6H313.886C315.086 232.8 317.2820000000001 237 320.48 240.8zM4.4819 267.382C1.67985 270.8238 0 275.2158 0 280C0 291.0456 8.9543 300 20 300C26.385 300 32.0712 297.0078 35.733 292.3494L100 212.0156L164.2676 292.3502C167.9294 297.0082 173.6154 300 180 300C191.0458 300 200 291.0456 200 280C200 275.2154 198.32 270.8234 195.5176 267.3814L125.6124 180L195.517 92.62C198.3198 89.178 200 84.784 200 80C200 68.954 191.0458 60 180 60C173.6148 60 167.9284 62.992 164.2668 67.65L100 147.984L35.7332 67.65C32.0714 62.992 26.3852 60 20 60C8.9543 60 0 68.954 0 80C0 84.784 1.680234 89.178 4.48286 92.62L74.3876 180L4.4819 267.382z" : "M263.08 201.1188L263.4 201.4C267 204.2 270.6 207 274.8 209.8L287.4 218.8C291.6 222 295.6 225.4 299.6 229C303.6 232.6 307 236.6 310 240.8C313 245 315.6 249.8 317.4 254.8C319.2000000000001 259.8 320 265.6 320 271.8C320 276.8 319.2000000000001 282 317.6 287.6C316.2 293.4 313.6 298.6 309.8 303.4C306.2 308.2 301.2 312.2 295.2 315.4C289.4000000000001 318.4 282 320 273 320C265 320 257.8 318.4 251.6 315.4C245.4 312.2 240 308 235.8 303C231.4 297.6 228.2 291.2 226 283.8C223.8 276.4 222.8 268.4 222.8 259.8H246.6C246.8 265.2 247.2 270.4 248.2 275.2C249 280 250.4 284.2 252.4 287.6C254.2 291.2 256.8 294 260 296C263.2 298 267 299 271.8 299C277 299 281.2 298 284.4000000000001 296.2C287.4 294.4 290 292 291.8 289.2C293.6 286.4 294.8 283.4 295.4 280.2C296 277 296.4 274 296.4 271.2C296.2 265 294.8 259.6 292 254.8C289.2000000000001 250.2 285.6 245.8 281.4 241.8C277 237.6 272.2 234 267.2 230.4C262 226.8 257 223.2 252.2 219.6C242.2 212.4 234.4 204 228.8 194.2C223.2 184.4 220.2 173 220 160H319.8V182.8H248.8C249.8 186.2 251.6 189.4 254.2 192.6C256.718 195.506 259.8 198.2244 263.08 201.1188zM123.9996 232C127.7768 237.0362 133.7046 240 139.9996 240C156.4806 240 165.8882 221.1848 155.9996 208L104.9996 140L155.9996 72C165.8882 58.816 156.4806 40 139.9996 40C133.7046 40 127.7768 42.964 123.9996 48L79.9996 106.666L35.9996 48C32.2226 42.964 26.2948 40 19.99964 40C3.51884 40 -5.88882 58.816 3.99964 72L54.9996 140L3.99964 208C-5.88882 221.1848 3.51884 240 19.99964 240C26.2948 240 32.2226 237.0362 35.9996 232L79.9996 173.3334L123.9996 232z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Superscript.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Superscript.displayName = "Blueprint5.Icon.Superscript";
exports.default = Superscript;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ZEtW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwapHorizontal", ()=>SwapHorizontal);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SwapHorizontal = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "swap-horizontal",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320.4 200C320.2000000000001 200 320.2000000000001 200 320.4 200C320 200 320 200 320 200H320.4zM40 280H311.6L265.8 234.2C262 230.4 259.8 225.4 259.8 220C259.8 209 268.8 200 279.8 200C285.4 200 290.4 202.2 294 205.8L374 285.8C377.6 289.4 379.8 294.4 379.8 300C379.8 305.6 377.6 310.6 374 314.2L294 394.2C290.4 397.8 285.4 400 279.8 400C268.8 400 259.8 391 259.8 380C259.8 374.4 262 369.4 265.6 365.8L311.6 320H40C29 320 20 311 20 300C20 289 29 280 40 280zM80 200H79.6C79.8 200 79.8 200 80 200C80 200 80 200 80 200zM360 120H88.4L134.2 165.8C138 169.6 140.2 174.6 140.2 180C140.2 191 131.2 200 120.2 200C114.6 200 109.6 197.8 106 194.2L26 114.2000000000001C22.4 110.6 20.2 105.6 20.2 100C20.2 94.4 22.4 89.4 26 85.8L106 5.8C109.6 2.2 114.6 0 120.2 0C131.2 0 140.2 9 140.2 20C140.2 25.6 138 30.6 134.4 34.2L88.4 80H360C371 80 380 89 380 100C380 111 371 120 360 120z" : "M0 179.6L1 180H0V179.6zM40 220.2H231.4L205.6 194.4C202 190.6 199.8 185.6 199.8 180.2C199.8 169.2 208.8 160.2 219.8 160.2C225.4 160.2 230.4 162.4 234 166L293.8 226C297.4 229.6 299.6 234.6 299.6 240.2C299.6 245.8 297.4 250.8 293.8 254.4L234 314.4C230.2 317.8 225.2 320 219.8 320C208.8 320 199.8 311 199.8 300C199.8 294.4 202 289.4 205.6 285.8L231.4 260H40C29 260 20 251 20 240C20.2 229 29 220.2 40 220.2zM319.2000000000001 140H320V140.4L319.2000000000001 140zM280 99.8H88.6L114.4 125.6C118 129.4 120.2 134.4 120.2 139.8C120.2 150.8 111.2 159.8 100.2 159.8C94.6 159.8 89.6 157.6 86 154L26.2 94C22.6 90.4 20.4 85.4 20.4 80C20.4 74.4 22.6 69.4 26.2 65.8L86 5.8C89.8 2.2 94.8 0 100.2 0C111.2 0 120.2 9 120.2 20C120.2 25.6 118 30.6 114.4 34.2L88.6 60H280C291 60 300 69 300 80C300 91 291 99.8 280 99.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SwapHorizontal.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SwapHorizontal.displayName = "Blueprint5.Icon.SwapHorizontal";
exports.default = SwapHorizontal;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Cyjh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwapVertical", ()=>SwapVertical);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SwapVertical = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "swap-vertical",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M194.2 294L114.2 374C110.6 377.6 105.6 379.8 100 379.8C94.4 379.8 89.4 377.6 85.8 374L5.8 294C2.2 290.4 0 285.4 0 279.8C0 268.8 9 259.8 20 259.8C25.6 259.8 30.6 262 34.2 265.6L80 311.6V40C80 29 89 20 100 20C111 20 120 29 120 40V311.6L165.8 265.8C169.6 262 174.6 259.8 180 259.8C191 259.8 200 268.8 200 279.8C200 285.4 197.8 290.4 194.2 294zM200 320.4C200 320.2 200 320.2 200 320.4C200 320 200 320 200 320V320.4zM200 79.6C200 79.8 200 79.8 200 79.6C200 80 200 80 200 80V79.6zM380 140.2C374.4 140.2 369.4 138 365.8 134.4L320 88.4V360C320 371 311 380 300 380C289 380 280 371 280 360V88.4L234.2 134.2000000000001C230.6 137.8 225.6 140 220 140C209 140 200 131 200 120C200 114.4 202.2 109.4 205.8 105.8L285.8 25.8C289.4 22.2 294.4 20 300 20C305.6 20 310.6 22.2 314.2000000000001 25.8L394.2000000000001 105.8C397.8 109.4 400 114.4 400 120C400 131.2 391 140.2 380 140.2z" : "M180 320H179.6L180 319.2V320zM140 0H140.4L140 1V0zM94 293.8C90.4 297.4 85.4 299.6 80 299.6S69.4 297.4 65.8 293.8L5.8 234C2.2 230.2 0 225.2 0 219.8C0 208.8 9 199.8 20 199.8C25.6 199.8 30.6 202 34.2 205.6L60 231.4V40C60 29 69 20 80 20C91 20 100 29 100 40V231.4L125.8 205.6C129.4 202 134.4 199.8 139.8 199.8C150.8 199.8 159.8 208.8 159.8 219.8C159.8 225.4 157.6 230.4 154 234L94 293.8zM300 120.2C294.4000000000001 120.2 289.4000000000001 118 285.8 114.4L260 88.6V280C260 291 251 300 240 300C229 300 220 291 220 280V88.6L194.2 114.4C190.6 118 185.6 120.2 180.2 120.2C169.2 120.2 160.2 111.2 160.2 100.2C160.2 94.6 162.4 89.6 166 86L226 26.2C229.6 22.6 234.6 20.4 240.2 20.4C245.8 20.4 250.8 22.6 254.4 26.2L314.4 86C318 89.6 320.2 94.6 320.2 100.2000000000001C320 111.2 311 120.2 300 120.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SwapVertical.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SwapVertical.displayName = "Blueprint5.Icon.SwapVertical";
exports.default = SwapVertical;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4byok":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Switch", ()=>Switch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Switch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "switch",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M245.857864 354.1421356L274.142136 325.8578644L131.5976988 183.280746C136.956984 173.382396 140 162.046566 140 150C140 111.340068 108.6599324 80 70 80C31.3400676 80 1e-13 111.340068 1e-13 150C1e-13 188.659932 31.3400676 220 70 220C82.0547216 220 93.397746 216.952862 103.3008492 211.5868102L245.857864 354.1421356zM330 220C368.659932 220 400 188.659932 400 150C400 111.340068 368.659932 80 330 80C291.3400680000001 80 260 111.340068 260 150C260 188.659932 291.3400680000001 220 330 220zM70 180C53.4314576 180 40 166.568542 40 150C40 133.431458 53.4314576 120 70 120C86.5685424 120 100 133.431458 100 150C100 166.568542 86.5685424 180 70 180zM330 180C313.431458 180 300 166.568542 300 150C300 133.431458 313.431458 120 330 120C346.568542 120 360 133.431458 360 150C360 166.568542 346.568542 180 330 180z" : "M185.8578644 274.1421356L214.142136 245.8578644L114.1591502 145.8545756C117.9034096 138.0253498 120 129.2575174 120 120C120 86.862916 93.137085 60 60 60C26.862915 60 1e-13 86.862916 1e-13 120C1e-13 153.137085 26.862915 180 60 180C69.2575174 180 78.0253498 177.9034096 85.8545756 174.1591502L185.8578644 274.1421356zM260 180C293.137084 180 320 153.137085 320 120C320 86.862916 293.137084 60 260 60C226.862916 60 200 86.862916 200 120C200 153.137085 226.862916 180 260 180zM60 140C48.954305 140 40 131.045695 40 120C40 108.954306 48.954305 100 60 100C71.045695 100 80 108.954306 80 120C80 131.045695 71.045695 140 60 140zM260 140C248.954306 140 240 131.045695 240 120C240 108.954306 248.954306 100 260 100C271.045694 100 280 108.954306 280 120C280 131.045695 271.045694 140 260 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Switch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Switch.displayName = "Blueprint5.Icon.Switch";
exports.default = Switch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cCXMQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SymbolCircle", ()=>SymbolCircle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SymbolCircle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "symbol-circle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 199.8A120 120 0 0 1 320 199.8A120 120 0 0 1 80 199.8" : "M60 159.8A100 100 0 0 1 260 159.8A100 100 0 0 1 60 159.8",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SymbolCircle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SymbolCircle.displayName = "Blueprint5.Icon.SymbolCircle";
exports.default = SymbolCircle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cBgfQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SymbolCross", ()=>SymbolCross);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SymbolCross = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "symbol-cross",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 239.8H240V299.8C240 310.8 231 319.8 220 319.8H180C169 319.8 160 310.8 160 299.8V239.8H100C89 239.8 80 230.8 80 219.8V179.8C80 168.8 89 159.8 100 159.8H160V99.8C160 88.8 169 79.8000000000001 180 79.8000000000001H220C231 79.8000000000001 240 88.8 240 99.8000000000001V159.8000000000001H300C311 159.8000000000001 320 168.8 320 179.8000000000001V219.8000000000001C320 231 311 239.8 300 239.8z" : "M240 199.8H200V239.8C200 250.8 191 259.8 180 259.8H140C129 259.8 120 250.8 120 239.8V199.8H80C69 199.8 60 190.8 60 179.8V139.8C60 128.8 69 119.8 80 119.8H120V79.8C120 68.8 129 59.8 140 59.8H180C191 59.8 200 68.8 200 79.8V119.8H240C251 119.8 260 128.8 260 139.8V179.8C260 191 251 199.8 240 199.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SymbolCross.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SymbolCross.displayName = "Blueprint5.Icon.SymbolCross";
exports.default = SymbolCross;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHQCb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SymbolDiamond", ()=>SymbolDiamond);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SymbolDiamond = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "symbol-diamond",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 199.8C300 204 298.4 207.6 296.4 210.6L296.8 210.8L216.8 330.8L216.4 330.6C212.8 336.2 207 339.8 200 339.8S187.2 336.2 183.6 330.8L183.4 331L103.4 211L103.8 210.8C101.6 207.6 100 204 100 199.8S101.6 192 103.6 189L103.2 188.8L183.2 68.8L183.6 69C187.2 63.6 193 59.8 200 59.8S212.8 63.6 216.4 69L216.8 68.8L296.8 188.8L296.4 189C298.4 192.2 300 195.8 300 199.8z" : "M240 159.8C240 163.6 238.6 167 236.8 170L237 170.2L177 270.2L176.8 270C173.4 275.8 167.2 279.8 160 279.8S146.6 275.8 143.2 270L142.8 270.2L82.8 170.2L83.2 170C81.4 167 80 163.6 80 159.8S81.4 152.6 83.2 149.6L82.8 149.6L142.8 49.6L143 49.8C146.6 44 152.8 39.8 160 39.8S173.4 43.8 176.8 49.6L177 49.4L237 149.4L236.8 149.6C238.6 152.8 240 156 240 159.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SymbolDiamond.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SymbolDiamond.displayName = "Blueprint5.Icon.SymbolDiamond";
exports.default = SymbolDiamond;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5sSrd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SymbolRectangle", ()=>SymbolRectangle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SymbolRectangle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "symbol-rectangle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 300H80C70 300 60 290 60 280V120C60 110 70 100 80 100H320C330 100 340 110 340 120V280C340 290 330 300 320 300z" : "M260 240H60C50 240 40 230 40 220V100C40 90 50 80 60 80H260C270 80 280 90 280 100V220C280 230 270 240 260 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SymbolRectangle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SymbolRectangle.displayName = "Blueprint5.Icon.SymbolRectangle";
exports.default = SymbolRectangle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ictTK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SymbolSquare", ()=>SymbolSquare);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SymbolSquare = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "symbol-square",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 319.8H100C89 319.8 80 310.8 80 299.8V99.8C80 88.8 89 79.8000000000001 100 79.8000000000001H300C311 79.8000000000001 320 88.8 320 99.8000000000001V299.8000000000001C320 311 311 319.8 300 319.8z" : "M240 259.8H80C69 259.8 60 250.8 60 239.8V79.8C60 68.8 69 59.8 80 59.8H240C251 59.8 260 68.8 260 79.8V239.8C260 251 251 259.8 240 259.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SymbolSquare.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SymbolSquare.displayName = "Blueprint5.Icon.SymbolSquare";
exports.default = SymbolSquare;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aHnXd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SymbolTriangleDown", ()=>SymbolTriangleDown);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SymbolTriangleDown = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "symbol-triangle-down",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 300C320 311 311 320 300 320H100C89 320 80 311 80 300C80 296.8 81 293.8 82.2 291.2L82 291.2L182 91.2L182.2 91.2C185.6 84.6 192.2 80 200 80S214.4 84.6 217.8 91.2L218 91.2L318 291.2000000000001L317.8 291.2000000000001C319 293.8 320 296.8 320 300z" : "M260 239.8C260 250.8 251 259.8 240 259.8H80C69 259.8 60 250.8 60 239.8C60 236.6 61 233.6 62.2 231L62 231L142 71L142.2 71C145.4 64.4 152 59.8 160 59.8S174.4 64.4 177.8 71L178 71L258 231L257.8 231C259 233.8 260 236.6 260 239.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SymbolTriangleDown.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SymbolTriangleDown.displayName = "Blueprint5.Icon.SymbolTriangleDown";
exports.default = SymbolTriangleDown;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4o2EF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SymbolTriangleUp", ()=>SymbolTriangleUp);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var SymbolTriangleUp = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "symbol-triangle-up",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M317.8 108.8L317.8 108.8L218 308.8L217.8 308.8C214.4 315.4 207.8 320 200 320S185.6 315.4 182.2 308.8L182 308.8L82 108.8L82.2 108.8C81 106.2 80 103.2 80 100C80 89 89 80 100 80H300C311 80 320 89 320 100C320 103.2 319 106.2 317.8 108.8z" : "M257.8 88.8L257.8 88.8L178 248.8L177.8 248.8C174.4 255.2 167.8 259.8 160 259.8S145.6 255.2 142.2 248.8L142 248.8L62 88.8L62.2 88.8C61 86 60 83 60 79.8C60 68.8 69 59.8 80 59.8H240C251 59.8 260 68.8 260 79.8C260 83 259 86 257.8 88.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
SymbolTriangleUp.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
SymbolTriangleUp.displayName = "Blueprint5.Icon.SymbolTriangleUp";
exports.default = SymbolTriangleUp;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cK51V":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Syringe", ()=>Syringe);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Syringe = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "syringe",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M302.928 382.92894C299.024 386.83418 299.024 393.16582 302.928 397.07106C306.834 400.97631 313.166 400.97631 317.072 397.07106L397.072 317.0710000000001C400.976 313.1658 400.976 306.8342 397.072 302.929C393.166 299.0236 386.834 299.0236 382.928 302.929L370 315.8578L344.142 290L377.072 257.0710000000001C380.976 253.1658 380.976 246.8342 377.072 242.929C373.166 239.0236 366.834 239.0236 362.928 242.929L350 255.8578L327.078 232.9352L177.071 82.928C173.1658 79.024 166.8342 79.024 162.929 82.928L150 95.858L97.071 42.928C93.1658 39.024 86.8342 39.024 82.929 42.928L70 55.858L17.0711 2.928C13.16584 -0.976 6.8342 -0.976 2.92894 2.928C-0.976314 6.834 -0.976314 13.166 2.92894 17.072L55.8578 70L42.929 82.928C39.0236 86.834 39.0236 93.166 42.929 97.072L95.8578 150L82.929 162.928C79.0236 166.834 79.0236 173.166 82.929 177.072L232.9220000000001 327.064C232.924 327.0664 232.92 327.0616 232.9220000000001 327.064C232.924 327.0664 232.934 327.0758 232.936 327.0782L255.858 350L242.928 362.929C239.024 366.8342 239.024 373.1658 242.928 377.0710000000001C246.834 380.97632 253.166 380.97632 257.072 377.0710000000001L290 344.1422L315.858 370L302.928 382.92894zM254.142 320L270 335.8578L335.858 270L320 254.1422L254.142 320zM305.858 240L290 224.1422L257.072 257.0710000000001C253.166 260.9764 246.834 260.9764 242.928 257.0710000000001C239.024 253.1658 239.024 246.8342 242.928 242.929L275.858 210L250 184.142L217.072 217.071C213.166 220.9764 206.834 220.9764 202.928 217.071C199.0238 213.1658 199.0238 206.8342 202.928 202.929L235.858 170L210 144.142L177.071 177.072C173.1658 180.976 166.8342 180.976 162.929 177.072C159.0238 173.166 159.0238 166.834 162.929 162.928L195.8578 130L170 104.142L104.1422 170L240 305.8578L305.858 240zM64.1422 90L110 135.858L135.8578 110L90 64.142L64.1422 90zM330 355.8578L355.858 330L330 304.1422L304.142 330L330 355.8578z" : "M222.928 317.07106C219.024 313.16582 219.024 306.83418 222.928 302.92894L235.858 290L210 264.1422L177.071 297.0710000000001C173.1658 300.97632 166.8342 300.97632 162.929 297.0710000000001C159.0236 293.1658 159.0236 286.8342 162.929 282.929L175.8578 270L152.9356 247.0778L42.929 137.071C39.0236 133.1658 39.0236 126.8342 42.929 122.929L55.8578 110L22.929 77.072C19.02368 73.166 19.02368 66.834 22.929 62.928L35.8578 50L2.92892 17.072C-0.976306 13.166 -0.976306 6.834 2.92892 2.928C6.83418 -0.976 13.1658 -0.976 17.07106 2.928L50 35.858L62.929 22.928C66.8342 19.024 73.1658 19.024 77.071 22.928L110 55.858L122.929 42.928C126.8342 39.024 133.1658 39.024 137.071 42.928L247.064 152.9226L270 175.8578L282.928 162.929C286.834 159.0236 293.166 159.0236 297.072 162.929C300.976 166.8342 300.976 173.1658 297.072 177.071L264.142 210L290 235.8578L302.928 222.929C306.834 219.0236 313.166 219.0236 317.072 222.929C320.976 226.8342 320.976 233.1658 317.072 237.071L237.072 317.07106C233.166 320.97631 226.834 320.97631 222.928 317.07106zM225.858 160L210 144.1422L177.071 177.071C173.1658 180.9764 166.8342 180.9764 162.929 177.071C159.0236 173.1658 159.0236 166.8342 162.929 162.929L195.8578 130L170 104.142L137.071 137.071C133.1658 140.9764 126.8342 140.9764 122.929 137.071C119.0236 133.1658 119.0236 126.8342 122.929 122.929L155.8578 90L130 64.142L64.1422 130L160 225.8578L225.858 160zM174.1422 240L240 174.1422L255.858 190L190 255.8578L174.1422 240zM44.1422 70L70 44.142L95.8578 70L70 95.858L44.1422 70zM275.858 250L250 275.8578L224.142 250L250 224.1422L275.858 250z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Syringe.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Syringe.displayName = "Blueprint5.Icon.Syringe";
exports.default = Syringe;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPFpv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableSync", ()=>TableSync);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TableSync = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "table-sync",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 380H20C8 380 0 370 0 360V40C0 30 8 20 20 20H179.982C171.2512 31.628 164.9964 45.22 161.9986 60H160V80C152.721 80 145.888 81.958 140 85.374V60H40V120H120C120 127.236 121.894 134.0800000000001 125.2822 140H40V200H140V156.684L160 176.684V200H240V176.684L242.572 174.112C245.856 182.782 252.07 190.028 260 194.626V200H360V160.024C372.56 143.308 380 122.526 380 100C387.2800000000001 100 394.112 98.042 400 94.626V360C400 370 390 380 380 380zM140 220H40V280H140V220zM240 220H160V280H240V220zM360 220H260V280H360V220zM360 68.2V100C360 144.2 324.2000000000001 180 280 180C269 180 260 171 260 160C260 149 269 140 280 140C302 140 320 122 320 100V68.2L314.2000000000001 74.2000000000001C310.6 77.8 305.6 80 300 80C289 80 280 71 280 60C280 54.4 282.2 49.4 285.8 45.8L325.8 5.8C329.4 2.2 334.4 0 340 0C345.6 0 350.6 2.2 354.2000000000001 5.8L394.2000000000001 45.8C397.8 49.4 400 54.4 400 60C400 71 391 80 380 80C374.4 80 369.4 77.8 365.8 74L360 68.2zM180 111.8V80C180 35.8 215.8 0 260 0C271 0 280 9 280 20C280 31 271 40 260 40C238 40 220 58 220 80V111.8L225.8 105.8C229.4 102.2 234.4 100 240 100C251 100 260 109 260 120C260 125.6 257.8 130.6 254.2 134.2000000000001L214.2 174.2C210.6 177.8 205.6 180 200 180C194.4 180 189.4 177.8 185.8 174.2L145.8 134.2000000000001C142.2 130.6 140 125.6 140 120C140 109 149 100 160 100C165.6 100 170.6 102.2 174.2 106L180 111.8z" : "M300 320H20C8 320 0 310 0 300V60C0 48 8 40 20 40H102.511C100.8716 46.39 100 53.092 100 60C85.2334 60 72.3024 68.056 65.373 80H40V120H65.2822C67.0288 123.0512 69.1722 125.8564 71.6578 128.3422L83.3158 140H40V180H120C120 180 131.6006 180 140 180H200C200 180 211.486 180 220 180H280V152.9662C292.452 138.8664 300 120.3296 300 100C307.2800000000001 100 314.112 98.042 320 94.626V300C320 310 312 320 300 320zM120 200H40V240H120V200zM200 200H140V240H200V200zM280 200H220V240H280V200zM194.2 114.2L154.2 154.2C150.6 157.8 145.6 160 140 160C134.4 160 129.4 157.8 125.8 154.2L85.8 114.2C82.2 110.6 80 105.6 80 100C80 89 89 80 100 80C105.6 80 110.6 82.2 114.2 85.8L120 91.8V60C120 26.8 146.8 0 180 0C191 0 200 9 200 20C200 31 191 40 180 40C169 40 160 49 160 60V91.8L165.8 85.8C169.4 82.2 174.4 80 180 80C191 80 200 89 200 100C200 105.6 197.8 110.6 194.2 114.2zM205.8 45.8L245.8 5.8C249.4 2.2 254.4 0 260 0C265.6 0 270.6 2.2 274.2000000000001 5.8L314.2000000000001 45.8C317.8 49.4 320 54.4 320 60C320 71 311 80 300 80C294.4000000000001 80 289.4000000000001 77.8 285.8 74.2L280 68.2V100C280 133.2 253.2 160 220 160C209 160 200 151 200 140C200 129 209 120 220 120C231 120 240 111 240 100V68.2L234.2 74.2C230.6 77.8 225.6 80 220 80C209 80 200 71 200 60C200 54.4 202.2 49.4 205.8 45.8z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TableSync.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TableSync.displayName = "Blueprint5.Icon.TableSync";
exports.default = TableSync;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8qUMX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagAdd", ()=>TagAdd);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TagAdd = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tag-add",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 380C311.046 380 320 371.0456 320 360V320H360C371.046 320 380 311.0456 380 300S371.046 280 360 280H320V240C320 228.9544 311.046 220 300 220S280 228.9544 280 240V280H240C228.954 280 220 288.9544 220 300S228.954 320 240 320H280V360C280 371.0456 288.954 380 300 380zM216.182 332.1394C206.364 324.8506 200 313.1684 200 300C200 277.9086 217.908 260 240 260H260V240C260 217.9086 277.908 200 300 200C313.168 200 324.85 206.3634 332.14 216.1828L348.23 200.0918C363.852 184.47 363.852 159.144 348.23 143.524L256.476 51.7699999999999C240.856 36.148 215.53 36.148 199.9082 51.7699999999999L51.7158 199.9619999999999A39.9994 39.9994 0 0 0 40 228.2462V320C40 342.0914 57.9086 360 80 360H171.7538A39.9994 39.9994 0 0 0 200.038 348.2842L216.182 332.1394zM79.8702 290.2272C79.8702 273.7124 93.258 260.3246000000001 109.7728 260.3246000000001S139.6754 273.7124 139.6754 290.2272S126.2876 320.1298 109.7728 320.1298S79.8702 306.742 79.8702 290.2272z" : "M240 320C251.046 320 260 311.0458 260 300V260H300C311.046 260 320 251.0456 320 240S311.046 220 300 220H260V180C260 168.9544 251.046 160 240 160S220 168.9544 220 180V220H180C168.9544 220 160 228.9544 160 240S168.9542 260 180 260H220V300C220 311.0458 228.954 320 240 320zM155.8408 271.8828C146.2158 264.578 140 253.015 140 240C140 217.9086 157.9086 200 180 200H200V180C200 157.9086 217.908 140 240 140C253.012 140 264.574 146.2132 271.878 155.8348C283.73 140.161 282.512 117.752 268.222 103.4620000000001L176.5378 11.778C160.9168 -3.8439999999999 135.5902 -3.8439999999999 119.9692 11.778L11.7158 120.0308A40 40 0 0 0 0 148.315V240C0 262.0914 17.9086 280 40 280H131.685C140.4556 280 148.929 277.1196 155.8408 271.8828zM39.8516 210.2596C39.8516 193.7524 53.2334 180.3708 69.7404 180.3708C86.2476 180.3708 99.6292 193.7524 99.6292 210.2596C99.6292 226.7666 86.2476 240.1484 69.7404 240.1484C53.2334 240.1484 39.8516 226.7666 39.8516 210.2596z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TagAdd.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TagAdd.displayName = "Blueprint5.Icon.TagAdd";
exports.default = TagAdd;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iwNsx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagPromote", ()=>TagPromote);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TagPromote = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tag-promote",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M285.85 374.139C293.6500000000001 381.9536 306.45 381.9536 314.25 374.139L373.85 314.8278C382.05 306.6124 382.05 293.3876 373.85 285.1722L314.25 225.861C306.45 218.0464 293.65 218.0464 285.85 225.861C278.05 233.6756 278.05 246.2994 285.85 254.1140000000001L331.85 300L285.85 345.886C278.05 353.7006 278.05 366.3244 285.85 374.139zM234.25 374.139L293.85 314.8278C302.05 306.6124 302.05 293.3876 293.85 285.1722L234.25 225.861C226.45 218.0464 213.65 218.0464 205.85 225.861C198.05 233.6756 198.05 246.2994 205.85 254.1140000000001L251.85 300L205.85 345.886C198.05 353.7006 198.05 366.3244 205.85 374.139S226.45 381.9536 234.25 374.139zM332.508 215.8146L348.23 200.0918C363.852 184.47 363.852 159.144 348.23 143.524L256.476 51.77C240.856 36.148 215.53 36.148 199.9082 51.77L51.7158 199.962A39.9994 39.9994 0 0 0 40 228.2462V320C40 342.0914 57.9086 360 80 360H171.7538A39.988 39.988 0 0 0 180.0094 359.139C180.2252 349.2098 184.1204 339.3456 191.6946 331.7572L191.7254 331.7264L223.53 300L191.7254 268.2736L191.6946 268.2428C176.1018 252.6208 176.1018 227.3542 191.6946 211.7322C207.3 196.098 232.764 196.09 248.38 211.7064L248.406 211.7322L262.5780000000001 225.8366000000001C264.5200000000001 220.6966 267.5600000000001 215.8752 271.694 211.7322C287.2980000000001 196.1 312.7580000000001 196.09 328.374 211.7014L328.406 211.7322L332.5080000000001 215.8146zM79.8702 290.2272C79.8702 273.7124 93.258 260.3246000000001 109.7728 260.3246000000001S139.6754 273.7124 139.6754 290.2272S126.2876 320.1298 109.7728 320.1298S79.8702 306.742 79.8702 290.2272z" : "M225.8 314.2004C233.6 322.0016 246.4 322.0016 254.2 314.2004L313.8 254.9912C322 246.7898 322 233.5878 313.8 225.3864L254.2 166.1772C246.4 158.376 233.6 158.376 225.8 166.1772C218 173.9784 218 186.5804 225.8 194.3816L271.8 240.1888L225.8 285.9960000000001C218 293.7972000000001 218 306.3992 225.8 314.2004zM272.2 155.3756C283.6 139.7732 282.4 117.57 268.2 103.368L176.6 11.754C161 -3.85 135.6 -3.85 120 11.754L11.8 119.97C4.2 127.5712 0 137.7728 0 148.3744V239.9888C0 261.9922000000001 18 279.995 40 279.995H125.6C127.2 276.9944 129.2 274.194 131.8 271.5936L163.6 239.9888L131.8 208.3838C124.2 200.7826 120 190.581 120 179.9794S124.2 159.1762 131.8 151.575C139.4 144.1738 149.2 139.9732 160 139.9732C170.8 139.9732 180.8 144.1738 188.4 151.575L202.6 165.7772C204.6 160.5764 207.6 155.7756 211.8 151.575C219.4 144.1738 229.2 139.9732 240 139.9732C250.8 139.9732 260.8 144.1738 268.4 151.575L272.2 155.3756zM69.8 180.1794C86.4 180.1794 99.8 193.5814 99.8 210.184C99.8 226.7866 86.4 240.1888 69.8 240.1888S39.8 226.7866 39.8 210.184S53.2 180.1794 69.8 180.1794zM174.2 314.2004L233.8 254.9912C242.0000000000001 246.7898 242.0000000000001 233.5878 233.8 225.3864L174.2 166.1772C166.4 158.376 153.6 158.376 145.8 166.1772C138 173.9784 138 186.5804 145.8 194.3816L191.8 240.1888L145.8 285.996C138 293.7972 138 306.3992 145.8 314.2004C153.6 322.0016 166.4 322.0016 174.2 314.2004z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TagPromote.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TagPromote.displayName = "Blueprint5.Icon.TagPromote";
exports.default = TagPromote;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"39bkU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagRefresh", ()=>TagRefresh);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TagRefresh = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tag-refresh",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M265.8 254.2C269.4 257.8 274.4 260 280 260C291 260 300 251 300 240C300 234.4 297.8 229.4 294.2000000000001 225.8L288.2 220H320C331 220 340 229 340 240S349 260 360 260S380 251 380 240C380 206.8 353.2 180 320 180H288.2L294.2000000000001 174.2C297.8 170.6 300 165.6 300 160C300 149 291 140 280 140C274.4000000000001 140 269.4000000000001 142.2 265.8 145.8L225.8 185.8C222.2 189.4 220 194.4 220 200C220 205.6 222.2 210.6 225.8 214.2L265.8 254.2zM334.2000000000001 265.8C330.6 262.2000000000001 325.6 260 320 260C309 260 300 269 300 280C300 285.6 302.2 290.6 305.8 294.2L311.8 300H280C269 300 260 291 260 280S251 260 240 260S220 269 220 280C220 313.2 246.8 340 280 340H311.8L305.8 345.8C302.2 349.4 300 354.4 300 360C300 371 309 380 320 380C325.6 380 330.6 377.8 334.2000000000001 374.2L374.2000000000001 334.2C377.8 330.6 380 325.6 380 320C380 314.4 377.8 309.4 374.2000000000001 305.8L334.2000000000001 265.8zM217.87 330.4522C206.692 316.6962 200 299.1428 200 280C200 262.9184 210.78 248.293 225.888 242.5726L211.658 228.3422C204.35 221.0342 200 210.9646 200 200C200 189.036 204.35 178.966 211.658 171.658L251.658 131.658C258.966 124.35 269.036 120 280 120C302.046 120 320 137.954 320 160C334.552 160 348.184 163.868 359.93 170.632C359.6420000000001 160.79 355.7420000000001 151.034 348.23 143.524L256.476 51.77C240.856 36.148 215.53 36.148 199.9082 51.77L51.7158 199.962A39.9994 39.9994 0 0 0 40 228.2462V320C40 342.0914 57.9086 360 80 360H171.7538A39.9994 39.9994 0 0 0 200.038 348.2842L217.87 330.4522zM79.8702 290.2272C79.8702 273.7124 93.258 260.3246000000001 109.7728 260.3246000000001S139.6754 273.7124 139.6754 290.2272S126.2876 320.1298 109.7728 320.1298S79.8702 306.742 79.8702 290.2272z" : "M205.8 194.2C209.4 197.8 214.4 200 220 200C231 200 240 191 240 180C240 174.4 237.8 169.4 234.2 165.8L228.2 160H260C271 160 280 169 280 180S289 200 300 200S320 191 320 180C320 146.8 293.2 120 260 120H228.2L234.2 114.2C237.8 110.6 240 105.6 240 100C240 89 231 80 220 80C214.4 80 209.4 82.2 205.8 85.8L165.8 125.8C162.2 129.4 160 134.4 160 140C160 145.6 162.2 150.6 165.8 154.2L205.8 194.2zM274.2 205.8C270.6 202.2 265.6 200 260 200C249 200 240 209 240 220C240 225.6 242.2 230.6 245.8 234.2L251.8 240H220C209 240 200 231 200 220S191 200 180 200S160 209 160 220C160 253.2 186.8 280 220 280H251.8L245.8 285.8C242.2 289.4 240 294.4 240 300C240 311 249 320 260 320C265.6 320 270.6 317.8 274.2000000000001 314.2L314.2000000000001 274.2C317.8 270.6 320 265.6 320 260C320 254.4 317.8 249.4 314.2000000000001 245.8L274.2000000000001 205.8zM157.768 270.3262C146.6518 256.5892 140 239.0844 140 220C140 202.9184 150.779 188.293 165.8884 182.5726L151.6578 168.3422C144.35 161.0342 140 150.9646 140 140C140 129.0354 144.35 118.966 151.6578 111.658L191.6578 71.658C198.9658 64.35 209.036 60 220 60C221.722 60 223.418 60.11 225.082 60.322L176.5378 11.778C160.9168 -3.844 135.5902 -3.844 119.9692 11.778L11.7158 120.0308A40 40 0 0 0 0 148.315V240C0 262.0914 17.9086 280 40 280H131.685A40 40 0 0 0 157.768 270.3262zM39.8516 210.2596C39.8516 193.7524 53.2334 180.3708 69.7404 180.3708C86.2476 180.3708 99.6292 193.7524 99.6292 210.2596C99.6292 226.7666 86.2476 240.1484 69.7404 240.1484C53.2334 240.1484 39.8516 226.7666 39.8516 210.2596z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TagRefresh.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TagRefresh.displayName = "Blueprint5.Icon.TagRefresh";
exports.default = TagRefresh;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"62KLj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagUndo", ()=>TagUndo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TagUndo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tag-undo",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 360C300 371.0456 308.954 380 320 380C353.2 380 380 353.2 380 320S353.2 260 320 260H288.2L294.2000000000001 254.2C297.8 250.6 300 245.6 300 240C300 229 291 220 280 220C274.4000000000001 220 269.4000000000001 222.2 265.8 225.8L225.8 265.8C222.2 269.4 220 274.4 220 280C220 285.6 222.2 290.6 225.8 294.2L265.8 334.2C269.4 337.8 274.4 340 280 340C291 340 300 331 300 320C300 314.4 297.8 309.4 294.2000000000001 305.8L288.2 300H320C331 300 340 309 340 320S331 340 320 340C308.954 340 300 348.9544 300 360zM318.648 229.6748L348.23 200.0918C363.852 184.47 363.852 159.144 348.23 143.524L256.476 51.7699999999999C240.856 36.148 215.53 36.148 199.9082 51.7699999999999L51.7158 199.9619999999999A39.9994 39.9994 0 0 0 40 228.2462V320C40 342.0914 57.9086 360 80 360H171.7538A39.9994 39.9994 0 0 0 200.038 348.2842L225.82 322.5032L211.658 308.3422C204.35 301.0342 200 290.9646 200 280C200 269.0354 204.35 258.9658 211.658 251.6578L251.658 211.6578C258.966 204.35 269.036 200 280 200C298.478 200 314.0800000000001 212.6122 318.648 229.6748zM79.8702 290.2272C79.8702 273.7124 93.258 260.3246000000001 109.7728 260.3246000000001S139.6754 273.7124 139.6754 290.2272S126.2876 320.1298 109.7728 320.1298S79.8702 306.742 79.8702 290.2272z" : "M240 300C240 311.0458 248.954 320 260 320C293.2 320 320 293.2 320 260S293.2 200 260 200H228.2L234.2 194.2C237.8 190.6 240 185.6 240 180C240 169 231 160 220 160C214.4 160 209.4 162.2 205.8 165.8L165.8 205.8C162.2 209.4 160 214.4 160 220C160 225.6 162.2 230.6 165.8 234.2L205.8 274.2C209.4 277.8 214.4 280 220 280C231 280 240 271 240 260C240 254.4 237.8 249.4 234.2 245.8L228.2 240H260C271 240 280 249 280 260S271 280 260 280C248.954 280 240 288.9544 240 300zM258.632 169.6206L268.222 160.0308C283.844 144.4098 283.844 119.084 268.222 103.462L176.5378 11.778C160.9168 -3.844 135.5902 -3.844 119.9692 11.778L11.7158 120.0308A40 40 0 0 0 0 148.315V240C0 262.0914 17.9086 280 40 280H131.685A39.9994 39.9994 0 0 0 159.9692 268.2842L165.7846 262.469L151.6578 248.3422C144.35 241.0342 140 230.9646 140 220C140 209.0354 144.35 198.9658 151.6578 191.6578L191.6578 151.6578C198.9658 144.35 209.036 140 220 140C238.458 140 254.048 152.5856 258.632 169.6206zM39.8516 210.2596C39.8516 193.7524 53.2334 180.3708 69.7404 180.3708C86.2476 180.3708 99.6292 193.7524 99.6292 210.2596C99.6292 226.7666 86.2476 240.1484 69.7404 240.1484C53.2334 240.1484 39.8516 226.7666 39.8516 210.2596z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TagUndo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TagUndo.displayName = "Blueprint5.Icon.TagUndo";
exports.default = TagUndo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i4NrP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tag", ()=>Tag);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Tag = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tag",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 320C40 342.09139 57.90861 360 80 360L171.7537572 360C182.3624168 360 192.5365732 355.7857264 200.038028 348.2842712L348.23049 200.0918088C363.8514620000001 184.470838 363.8514620000001 159.144238 348.23049 143.523266L256.476734 51.76951C240.855762 36.148538 215.529162 36.148538 199.9081912 51.76951L51.7157288 199.961972C44.2142736 207.4634268 40 217.6375832 40 228.2462428L40 320zM109.772785 320.1298372C93.2580228 320.1298372 79.8701628 306.7419772 79.8701628 290.227215C79.8701628 273.7124528 93.2580228 260.324593 109.772785 260.324593C126.2875472 260.324593 139.675407 273.7124528 139.675407 290.227215C139.675407 306.7419772 126.2875472 320.1298372 109.772785 320.1298372z" : "M20 260C20 282.09139 37.90861 300 60 300L151.6850114 300C162.293671 300 172.4678274 295.7857264 179.9692826 288.2842712L288.222836 180.0307174C303.843808 164.4097456 303.843808 139.0831466 288.222836 123.4621748L196.5378252 31.777164C180.9168534 16.156192 155.5902544 16.156192 139.9692826 31.777164L31.7157288 140.0307174C24.2142736 147.5321726 20 157.706329 20 168.3149886L20 260zM89.740446 260.1483166C73.2333382 260.1483166 59.8516834 246.7666618 59.8516834 230.259554C59.8516834 213.7524462 73.2333382 200.3707914 89.740446 200.3707914C106.2475538 200.3707914 119.6292086 213.7524462 119.6292086 230.259554C119.6292086 246.7666618 106.2475538 260.1483166 89.740446 260.1483166z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Tag.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Tag.displayName = "Blueprint5.Icon.Tag";
exports.default = Tag;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i7JIe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tags", ()=>Tags);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Tags = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tags",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 340C60 362.0914 77.9086 380 100 380H191.7538A40.001 40.001 0 0 0 220.038 368.2842L368.23 220.0918C383.852 204.4708 383.852 179.144 368.23 163.524L276.476 71.77C260.856 56.148 235.53 56.148 219.908 71.77L71.7158 219.962A39.9994 39.9994 0 0 0 60 248.2462V340zM129.7728 340.1298C113.258 340.1298 99.8702 326.742 99.8702 310.2272S113.258 280.3246000000001 129.7728 280.3246000000001S159.6754 293.7124 159.6754 310.2272S146.2876 340.1298 129.7728 340.1298zM40 306.2284L25.3676 281.0578C20.0548 271.919 18.6152 261.0584 21.3652 250.8654L75.693 49.5C81.4198 28.2740000000001 103.3878 15.6780000000001 124.7602 21.366L220.456 46.832C215.168 49.588 210.206 53.188 205.766 57.628L57.5736 205.8198A60 60 0 0 0 40 248.2462V306.2284z" : "M80 320H171.685A40 40 0 0 0 199.9692 308.2842L308.2220000000001 200.0308C323.844 184.4098 323.844 159.0832 308.2220000000001 143.4622L216.5380000000001 51.778C200.916 36.156 175.5902000000001 36.156 159.9692 51.778L51.7158 160.0308A39.9994 39.9994 0 0 0 40 188.315V280C40 302.0914 57.9086 320 80 320zM79.8516 250.1484C79.8516 233.5798 93.2832 220.1484 109.8516 220.1484C126.4202 220.1484 139.8516 233.5798 139.8516 250.1484C139.8516 266.7168 126.4202 280.1484 109.8516 280.1484C93.2832 280.1484 79.8516 266.7168 79.8516 250.1484zM5.2524 216.4818L20 243.6222V188.3148C20 172.402 26.3214 157.1406 37.5736 145.8884L145.8272 37.634C152.0692 31.392 159.3444 26.814 167.1022 23.898L88.1842 1.43C67.2706 -4.5240000000001 45.774 8.662 40.1702 30.884L1.336 184.874C-1.3552 195.545 0.0536 206.9146 5.2524 216.4818z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Tags.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Tags.displayName = "Blueprint5.Icon.Tags";
exports.default = Tags;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hyoOG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TakeAction", ()=>TakeAction);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TakeAction = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "take-action",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100 260C105.6 260 110.6 262.2000000000001 114.2 265.8L214.2 365.8C217.8 369.4 220 374.4 220 380C220 391 211 400 200 400C194.4 400 189.4 397.8 185.8 394.2L85.8 294.2C82.2 290.6 80 285.6 80 280C80 269 89 260 100 260zM220 140C220 129 229 120 240 120C245.6 120 250.6 122.2 254.2 125.8L354.2000000000001 225.8C357.8 229.4 360 234.4 360 240C360 251 351 260 340 260C334.4 260 329.4 257.8 325.8 254.2L225.8 154.2C222.2 150.6 220 145.6 220 140zM380 40H360C360 51 351 60 340 60H200C189 60 180 51 180 40H160C149 40 140 31 140 20C140 9 149 0 160 0H380C391 0 400 9 400 20C400 31 391 40 380 40zM200 160L320 280L294.2000000000001 305.8C297.8 309.4 300 314.4 300 320C300 331 291 340 280 340C274.4000000000001 340 269.4000000000001 337.8 265.8 334.2L240 360L120 240L145.8 214.2L5.8 74.2000000000001C2.2 70.6 0 65.6 0 60C0 49 9 40 20 40C25.6 40 30.6 42.2 34.2 45.8L174.2 185.8L200 160z" : "M180 100C180 89 189 80 200 80C205.6 80 210.6 82.2 214.2 85.8L294.2000000000001 165.8C297.8 169.4 300 174.4 300 180C300 191 291 200 280 200C274.4000000000001 200 269.4000000000001 197.8 265.8 194.2L185.8 114.2C182.2 110.6 180 105.6 180 100zM80 200C85.6 200 90.6 202.2 94.2 205.8L174.2 285.8C177.8 289.4 180 294.4 180 300C180 311 171 320 160 320C154.4 320 149.4 317.8 145.8 314.2L65.8 234.2C62.2 230.6 60 225.6 60 220C60 209 69 200 80 200zM160 120L260 220L244.2 235.8L254.2 245.8C257.8 249.4 260 254.4 260 260C260 271 251 280 240 280C234.4 280 229.4 277.8 225.8 274.2L215.8 264.2L200 280L100 180L115.8 164.2L5.8 54.2C2.2 50.6 0 45.6 0 40C0 29 9 20 20 20C25.6 20 30.6 22.2 34.2 25.8L144.2 135.8L160 120zM300 40H140C129 40 120 31 120 20C120 9 129 0 140 0H300C311 0 320 9 320 20C320 31 311 40 300 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TakeAction.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TakeAction.displayName = "Blueprint5.Icon.TakeAction";
exports.default = TakeAction;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDK7N":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tank", ()=>Tank);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Tank = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tank",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M79.125 310.6C82.7798 316.4476 89.1892 320 96.085 320H160H223.916C230.81 320 237.2200000000001 316.4476 240.876 310.6L260 280.0002H360C371.046 280.0002 380 271.0456 380 260C380 248.9544 371.046 240.0002 360 240.0002H260V220.0004H340C373.1380000000001 220.0004 400 193.138 400 160C400 126.864 373.1380000000001 100 340 100H60C26.863 100 0 126.864 0 160C0 193.138 26.863 220.0004 60 220.0004L60 274.264C60 278.0124 61.0534 281.6854 63.04 284.8640000000001L79.125 310.6zM60 180H340C351.046 180 360 171.046 360 160C360 148.954 351.046 140 340 140H60C48.9544 140 40 148.954 40 160C40 171.046 48.9544 180 60 180z" : "M74 252C77.777 257.0362 83.7048 260 90 260H140H191.7158C197.02 260 202.108 257.8928 205.858 254.1422L220 240V239.9994H280C291.046 239.9994 300 231.045 300 219.9994C300 208.9536 291.046 199.9994 280 199.9994H220V180.0004H270C297.614 180.0004 320 157.6146 320 130.0004C320 102.386 297.614 80 270 80H50C22.3858 80 0 102.386 0 130.0004C0 157.6146 22.3858 180.0004 50 180.0004H60V226.6666C60 230.994 61.4036 235.2048 64 238.6666L74 252zM50 140.0004H270C275.522 140.0004 280 135.5232 280 130.0004C280 124.4774 275.522 120.0004 270 120.0004H50C44.4772 120.0004 40 124.4774 40 130.0004C40 135.5232 44.4772 140.0004 50 140.0004z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Tank.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Tank.displayName = "Blueprint5.Icon.Tank";
exports.default = Tank;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iZ66N":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Target", ()=>Target);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Target = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "target",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M180 300C180 311.0462 188.955 320 200 320C211.044 320 220 311.0462 220 300V240C220 228.9538 211.044 220 200 220C188.955 220 180 228.9538 180 240V300zM240 220C228.956 220 220 211.0462 220 200C220 188.954 228.956 180 240 180H300C311.044 180 320 188.954 320 200C320 211.0462 311.044 220 300 220H240zM80 200C80 211.0462 88.955 220 100 220H160C171.045 220 180 211.0462 180 200C180 188.954 171.045 180 160 180H100C88.955 180 80 188.954 80 200zM200 180C188.955 180 180 171.046 180 160V100C180 88.954 188.955 80 200 80C211.044 80 220 88.954 220 100V160C220 171.046 211.044 180 200 180zM200 0C310.456 0 400 89.544 400 200C400 310.4566 310.456 400 200 400C89.5434 400 0 310.4566 0 200C0 89.544 89.5434 0 200 0zM200 40C288.366 40 360 111.634 360 200C360 288.3654 288.366 360 200 360C111.6334 360 40 288.3654 40 200C40 111.634 111.6334 40 200 40z" : "M140 240C140 251.0462 148.955 260 160 260C171.045 260 180 251.0462 180 240V200C180 188.9538 171.045 180 160 180C148.955 180 140 188.9538 140 200V240zM200 180C188.955 180 180 171.0462 180 160C180 148.9538 188.955 140 200 140H240C251.044 140 260 148.9538 260 160C260 171.0462 251.044 180 240 180H200zM60 160C60 171.0462 68.955 180 80 180H120C131.045 180 140 171.0462 140 160C140 148.9538 131.045 140 120 140H80C68.955 140 60 148.9538 60 160zM160 140C148.955 140 140 131.0462 140 120V80C140 68.954 148.955 60 160 60C171.045 60 180 68.954 180 80V120C180 131.0462 171.045 140 160 140zM160 0C248.366 0 320 71.634 320 160C320 248.3654 248.366 320 160 320C71.6334 320 0 248.3654 0 160C0 71.634 71.6334 0 160 0zM160 40C226.274 40 280 93.726 280 160C280 226.2744 226.274 280 160 280C93.7256 280 40 226.2744 40 160C40 93.726 93.7256 40 160 40z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Target.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Target.displayName = "Blueprint5.Icon.Target";
exports.default = Target;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"49Rfr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Taxi", ()=>Taxi);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Taxi = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "taxi",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 220H373.4000000000001L380 200V190C380 187 379.4 184 378.6 181.2L378.8 181.2L340 55.4V50C340 33.4 326.6 20 310 20S280 33.4 280 50V60H120V50C120 33.4 106.6 20 90 20C73.4 20 60 33.4 60 50V55.4L21.4 181L21.6 181C20.6 184 20 187 20 190V200C20 200 20.4 201.2 21 203.2C22.2 206.6 24.2 212.6 26.6 220H20C9 220 0 229 0 240C0 251 9 260 20 260H40C50 290 60 320 60 320H59.8L59.8 320.2C64.8 333 79.8 346.4 93.2 350.2C93.2 350.2 108.8 354.4 139.8 357.4V360V380C139.8 391 148.8 400 159.8 400H239.8C250.8 400 259.8 391 259.8 380V360V357.4C290.8 354.6 306.4 350.2 306.4 350.2C319.8 346.4 334.8000000000001 333 339.8000000000001 320.2L339.8000000000001 320H340L360 260H380C391 260 400 251 400 240C400 229 391 220 380 220zM60 170C60 153.4 73.4 140 90 140C106.6 140 120 153.4 120 170C120 186.6 106.6 200 90 200C73.4 200 60 186.6 60 170zM320 260L300 320H260V320H140V320H100L80 260V240H320V260zM310 200C293.4 200 280 186.6 280 170C280 153.4 293.4 140 310 140S340 153.4 340 170C340 186.6 326.6 200 310 200z" : "M302.4 187.4H294.8L300 180C299.8 174 299.8 167.2 300 160.4C300 160.2 300 160.2 300 160C300 158.6 299.4000000000001 157.4 299.2000000000001 156.2L299.6 156.2L280 58V40C280 29 271 20 260 20S240 29 240 40V60H80V40C80 29 71 20 60 20S40 29 40 40V58L20.4 156L20.8 156C20.6 157.4 20 158.6 20 160H19.8C19.8 166.6 19.8 173.4 20 180L25.2 187.4H17.6C8 187.4 0 195.8 0 206.2C0 216.6 8 225 17.6 225H38.6L54 267.2C57.8 277.8 69.2 288.8 79.2 292C79.2 292 92.8 296 120.2 298.4C120.2 299 120 299.4 120 300C120 311 129 320 140 320H180C191 320 200 311 200 300C200 299.4 199.8 299 199.6 298.4C227.0000000000001 296 240.6 292 240.6 292C250.8 289 262.2000000000001 277.8 266 267.2L281.2 224.8H302.2000000000001C312 224.8 320 216.4 320 206.2C320 195.8 312 187.4 302.4 187.4zM220 120H260V160H260H220V120zM60 120H100V160H60H60V120zM260 220L245.4 252.6C244.2 256.2 243.6 260 240 260H80C76.4 260 75.8 256.2 74.6 252.6L60 220C58.8 216.4 56.4 200 60 200H260C263.6 200 261.2 216.4 260 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Taxi.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Taxi.displayName = "Blueprint5.Icon.Taxi";
exports.default = Taxi;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9HaFv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Team", ()=>Team);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Team = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "team",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M353.824 93.44C344.7 114.56 300.202 128.48 270.748 141.6C241.136 154.72 245.298 162.56 244.178 173.44C244.0180000000001 174.88 244.0180000000001 176.48 243.858 178.08C253.942 187.04 262.266 199.36 267.7080000000001 213.6C267.7080000000001 213.6 268.028 214.4 268.028 214.56C269.148 217.6 270.108 220.8 271.07 224.16C277.792 225.6 281.794 232.96 283.234 239.8400000000001C284.834 242.56 287.8760000000001 249.44 287.236 257.12C286.276 267.04 282.274 271.68 277.792 273.6V275.36C277.792 288 276.6720000000001 306.24 274.27 318.24C273.79 321.6 272.99 324.9600000000001 272.03 328.16C267.7080000000001 342.88 258.584 356 246.418 365.28C233.774 374.88 216.006 380 200.16 380C184.3132 380 166.546 374.88 153.9008 365.28C141.7358 356 132.612 342.88 128.2902 328.16C127.3298 324.9600000000001 126.5294 321.6 126.0492 318.24C123.8084 306.24 122.5278 288 122.5278 275.36V273.76C117.8858 272 113.7242 267.36 112.7638 257.12C112.1234 249.44 115.1648 242.56 116.7654 239.8400000000001C118.366 232.8 122.3678 225.28 129.4106 224.16C130.211 220.8 131.3314 217.6 132.4518 214.56C132.4518 214.4 132.612 214.08 132.612 213.92L132.772 213.6C138.2142 199.04 146.6978 186.56 157.102 177.6C157.102 176.16 156.942 174.72 156.782 173.44C155.6614 162.56 158.8628 154.72 129.2506 141.6C99.6384 128.48 55.3 114.56 46.1762 93.44C37.0526 72.32 40 20 40 20H360C360 20 362.9480000000001 72.32 353.824 93.44zM26.7982 97.016C23.8316 90.962 20 83.14 20 20H0V100C0 126.004 17.02856 142.068 38.093 151.4C61.0762 161.582 61.469 168.132 61.9486 176.126C62.0096 177.144 62.0722 178.184 62.183 179.26C62.323 180.38 62.463 181.64 62.463 182.9C53.3592 190.74 45.9362 201.66 41.1742 214.4L41.0342 214.68C41.0342 214.75 40.9992 214.855 40.9642 214.96L40.9324 215.0574C40.9108 215.1272 40.8942 215.1918 40.8942 215.24C39.9138 217.9 38.9334 220.7 38.233 223.64C32.0706 224.62 28.569 231.2 27.1684 237.36C25.768 239.74 23.1068 245.76 23.667 252.48C24.5074 261.44 28.1488 265.5 32.2106 267.04V268.44C32.2106 279.5 33.331 295.46 35.2918 305.9600000000001C35.712 308.9 36.4124 311.84 37.2526 314.64C41.0342 327.52 49.0174 339 59.6618 347.12C70.7264 355.52 86.2728 360 100.1386 360C106.6822 360 113.6002 359.0022 120.2446 357.0656C115.898 350.1154 112.472 342.5702 110.1372 334.6358C109.008 330.8664 108.0028 326.7252 107.3618 322.4066000000001C105.312 311.2484 104.0562 296.0982 103.6788 283.5994C97.9666 277.5042 94.665 269.0238 93.7498 259.265L93.7344 259.0794C92.8324 248.2604 96.1506 238.9312 98.82 233.5414C100.0924 229.0026 102.1628 223.968 105.4344 219.4086C107.4654 216.5778 110.178 213.6604 113.633 211.2768C113.8212 210.7378 113.9818 210.2166 114.1404 209.7018C114.4868 208.5778 114.8244 207.482 115.4218 206.2876C120.6914 192.538 128.3658 180.07 137.9796 169.942C137.7962 166.912 137.3852 166.228 134.8042 164.4C132.199 162.554 127.95 160.124 121.0736 157.078C116.2756 154.952 110.3234 152.51 103.919 149.884C93.0114 145.412 80.7792 140.396 70.6452 135.458C62.0968 131.292 53.5044 126.518 46.1934 120.968C39.036 115.536 31.7794 108.374 27.7282 98.996C27.4324 98.312 27.1204 97.674 26.7982 97.016zM278.924 157.078L278.956 157.062C284.592 154.552 290.774 152.022 297.446 149.29L297.496 149.268C299.264 148.544 301.068 147.806 302.906 147.05C311.504 143.51 320.668 139.654 329.2840000000001 135.462C337.838 131.3 346.444 126.526 353.766 120.98C360.932 115.552 368.7720000000001 106.382 372.8280000000001 96.99C375.848 90.002 379.998 80 379.998 20H400V100C400 125.484 382.4940000000001 142.228 361.904 151.4C339.4460000000001 161.35 339.19 167.83 338.882 175.58C338.834 176.768 338.784 177.994 338.654 179.26C338.592 179.824 338.558 180.418 338.526 181.026L338.512 181.288C338.478 181.954 338.442 182.638 338.374 183.32C347.198 191.16 354.482 201.94 359.242 214.4C359.242 214.4 359.524 215.1 359.524 215.24C360.504 217.9 361.344 220.7 362.1840000000001 223.64C368.0660000000001 224.9 371.568 231.34 372.8280000000001 237.36C374.23 239.74 376.89 245.76 376.3300000000001 252.48C375.49 261.16 371.988 265.2200000000001 368.0660000000001 266.9V268.44C368.0660000000001 279.5 367.086 295.46 364.9860000000001 305.9600000000001C364.5660000000001 308.9 363.8640000000001 311.84 363.024 314.64C359.242 327.52 351.26 339 340.616 347.12C329.55 355.52 314.004 360 300.138 360C293.606 360 286.7000000000001 359.0056 280.066 357.0754C284.43 350.0950000000001 287.86 342.5328 290.184 334.6326C291.3040000000001 330.8976 292.3 326.7974 292.942 322.5214C295.186 311.0456 296.344 295.5964 296.668 283.1190000000001C302.118 277.0942 305.318 268.8622000000001 306.242 259.3186L306.264 259.0796000000001C307.1600000000001 248.3384 303.894 239.0654 301.234 233.6584C300.002 229.0946 297.974 224.1912 294.854 219.7456C292.892 216.9496 290.278 214.047 286.94 211.6274L286.738 211.019C286.298 209.684 285.852 208.3344 285.336 207.0156C280.072 193.268 272.43 180.748 262.926 170.526C262.938 170.26 262.948 169.994 262.956 169.728L262.966 169.362C262.998 168.336 263.028 167.304 263.164 166.29C263.822 165.528 267.058 162.334 278.924 157.078z" : "M226.552 115.248C246.856 106.988 269.75 97.672 275.338 84.918C281.39 71.106 280.3 31.526 280.038 22.054C280.002 20.752 279.998 20 279.998 20H39.9998C39.9998 20 37.7318 69.308 44.6364 85.068C50.2248 97.822 73.1192 107.138 93.423 115.398C98.205 117.342 102.843 119.23 107.0776 121.0896C126.7824 129.8022 127.0942 135.5222 127.47 142.4188C127.515 143.2446 127.561 144.0874 127.6412 144.9542C127.6412 145.4796 127.6788 146.005 127.7162 146.5302C127.7538 147.0556 127.7914 147.5808 127.7914 148.1062C119.9862 154.8604 113.532 164.3162 109.4792 175.1228L109.3292 175.273C109.3292 175.348 109.2916 175.423 109.254 175.4982C109.2166 175.5732 109.179 175.6482 109.179 175.7232C108.2784 178.1248 107.528 180.5262 106.9276 183.0778C101.674 183.9784 98.672 189.5318 97.4714 194.785C96.4206 196.8864 94.019 201.9894 94.4694 207.693C95.2198 215.3478 98.3718 218.7998 101.9742 220.1506V221.3514C101.9742 230.9574 102.7248 244.6158 104.526 253.6214C104.8262 256.173 105.4266 258.5744000000001 106.177 261.126C109.4792 272.0828 116.2336 281.9888 125.3898 289.0432C134.846 296.2476 148.2048 300 160.0626 300C171.9204 300 185.2792 296.0976 194.8856 289.0432C204.042 282.139 210.796 272.0828 214.098 261.126C214.848 258.5744000000001 215.45 256.173 215.75 253.6214C217.4 244.6158 218.302 230.8072 218.302 221.3514V220.0006C221.604 218.6498 224.606 215.1976 225.356 207.693C225.806 201.8394 223.554 196.7362 222.354 194.635C221.302 189.5318 218.302 183.9784 213.198 182.9278C212.598 180.5262 211.846 177.9746 210.946 175.7232C210.796 175.5732 210.646 174.9728 210.646 174.9728C206.594 164.3162 200.44 155.0104 192.7842 148.2562C192.7842 147.0558 192.7842 145.8546 192.9342 144.8042C193.0304 143.7674 193.0648 142.765 193.0988 141.7846C193.3294 135.1018 193.5246 129.4474 212.898 120.9394C217.132 119.08 221.77 117.192 226.552 115.248zM89.9894 169.576C87.6606 171.5376 85.794 173.6986 84.353 175.7444C81.636 179.6016 79.875 183.7628 78.7884 187.6042C72.7022 200.6328 72.9624 217.3152 81.849 229.076C82.3078 241.635 83.1468 254.6436 86.7134 266.7696000000001C87.685 269.9928 88.8698 273.1514 90.2556 276.2188C83.7226 278.7188 76.576 280 69.942 280C59.0724 280 46.8268 276.4228 38.021 269.9562C29.628 263.6274 23.4364 254.4092 20.4094 244.3654C19.72136 242.0266 19.17102 239.8252 18.89584 237.4862C17.38234 229.2312 16.55678 216.5734 16.55678 207.9054V206.6672C13.5298 205.429 10.77798 202.2644 10.09002 195.3852C9.67724 190.0194 11.74112 185.3416 12.84184 183.4154C13.80498 178.7374 16.55678 173.6468 21.2348 172.6838C21.7852 170.4824 22.4732 168.1434 23.2988 166.0796C23.4364 165.942 23.574 165.3918 23.574 165.3918C27.2888 155.6232 32.93 147.093 39.9472 140.9016C39.9472 139.801 39.9472 138.7002 39.8096 137.7372C39.7216 136.7868 39.69 135.8678 39.6588 134.9692C39.4474 128.8432 39.2686 123.6602 21.51 115.862C5.62308 108.884 0 99.08 0 80C0 70 0 20 0 20H20C20 20 16.81796 67.114 20 80C23.182 92.886 31.435 103.69 42.1552 111.784C54.3492 120.9904 68.8236 126.857 82.9436 132.5802C84.3678 133.1574 85.8028 133.739 87.217 134.3166C104.367 141.321 101.2146 147.2082 95.6478 157.6046C93.8102 161.0364 91.7096 164.9594 89.9894 169.576zM230.01 169.576C232.338 171.5376 234.204 173.6986 235.646 175.7444C238.362 179.6016 240.124 183.7628 241.21 187.6042C247.296 200.6328 247.036 217.3152 238.15 229.076C237.69 241.635 236.852 254.6436 233.286 266.7696000000001C232.314 269.9928 231.128 273.1514 229.742 276.2188C236.276 278.7188 243.422 280 250.056 280C260.926 280 273.1720000000001 276.4228 281.978 269.9562C290.37 263.6274 296.562 254.4092 299.59 244.3654C300.278 242.0266 300.828 239.8252 301.102 237.4862C302.616 229.2312 303.442 216.5734 303.442 207.9054V206.6672C306.468 205.429 309.2200000000001 202.2644 309.908 195.3852C310.322 190.0194 308.2580000000001 185.3416 307.156 183.4154C306.194 178.7374 303.442 173.6468 298.764 172.6838C298.214 170.4824 297.526 168.1434 296.7000000000001 166.0796C296.562 165.942 296.424 165.3918 296.424 165.3918C292.7100000000001 155.6232 287.068 147.093 280.052 140.9016C280.052 139.801 280.052 138.7002 280.188 137.7372C280.276 136.787 280.308 135.8682 280.34 134.97C280.552 128.844 280.73 123.6602 298.488 115.862C314.376 108.884 320 99.08 320 80V20H300C300 20 303.182 67.114 300 80C296.818 92.886 288.564 103.69 277.844 111.784C265.6500000000001 120.9904 251.174 126.857 237.054 132.5802C235.626 133.1594 234.2 133.737 232.782 134.3166C215.632 141.321 218.784 147.2082 224.35 157.6046C226.188 161.0362 228.288 164.9596 230.01 169.576z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Team.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Team.displayName = "Blueprint5.Icon.Team";
exports.default = Team;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i8BQ2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Temperature", ()=>Temperature);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Temperature = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "temperature",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 400C197.9086 400 180 382.09138 180 360V149.298C156.088 135.466 140 109.612 140 80C140 35.818 175.8172 0 220 0C264.182 0 300 35.818 300 80C300 109.612 283.9120000000001 135.466 260 149.298V360C260 382.09138 242.092 400 220 400zM60 350C60 355.5228 64.4772 360 70 360L150 360C155.5228 360 160 355.5228 160 350C160 344.4772 155.5228 340 150 340L70 340C64.4772 340 60 344.4772 60 350zM70 240C64.4772 240 60 235.5228 60 230C60 224.4772 64.4772 220 70 220H150C155.5228 220 160 224.4772 160 230C160 235.5228 155.5228 240 150 240H70zM100 290C100 295.5228 104.4772 300 110 300H150C155.5228 300 160 295.5228 160 290C160 284.4772000000001 155.5228 280 150 280H110C104.4772 280 100 284.4772000000001 100 290zM110 180C104.4772 180 100 175.522 100 170C100 164.478 104.4772 160 110 160H150C155.5228 160 160 164.478 160 170C160 175.522 155.5228 180 150 180H110z" : "M170 320C153.4314 320 140 306.56854 140 290V133.2636C116.3506 122.029 100 97.924 100 70C100 31.34 131.34 0 170 0C208.66 0 240 31.34 240 70C240 97.924 223.65 122.029 200 133.2636V290C200 306.56854 186.5686 320 170 320zM40 210C40 215.5228 44.4772 220 50 220L110 220C115.5228 220 120 215.5228 120 210C120 204.4772 115.5228 200 110 200L50 200C44.4772 200 40 204.4772 40 210zM50 300C44.4772 300 40 295.5228 40 290C40 284.4772 44.4772 280 50 280L110 280C115.5228 280 120 284.4772 120 290C120 295.5228 115.5228 300 110 300L50 300zM80 250C80 255.5228 84.4772 260 90 260H110C115.5228 260 120 255.5228 120 250C120 244.4772 115.5228 240 110 240H90C84.4772 240 80 244.4772 80 250zM90 180C84.4772 180 80 175.5228 80 170C80 164.4772 84.4772 160 90 160H110C115.5228 160 120 164.4772 120 170C120 175.5228 115.5228 180 110 180L90 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Temperature.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Temperature.displayName = "Blueprint5.Icon.Temperature";
exports.default = Temperature;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bUDM2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextHighlight", ()=>TextHighlight);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TextHighlight = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "text-highlight",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 60C309 60 300 69 300 80V320C300 331 309 340 320 340S340 349 340 360C340 371 331 380 320 380C304.6 380 290.6 374 280 364.4C269.4000000000001 374 255.4 380 240 380C229 380 220 371 220 360C220 349 229 340 240 340S260 331 260 320V80C260 69 251 60 240 60S220 51 220 40C220 29 229 20 240 20C255.4 20 269.4000000000001 26 280 35.6C290.6 26 304.6 20 320 20C331 20 340 29 340 40C340 51 331 60 320 60zM240 140H40V260H240V300H20C9 300 0 291 0 280V120C0 109 9 100 20 100H240V140zM380 300H320V260H360V140H320V100H380C391 100 400 109 400 120V280C400 291 391 300 380 300z" : "M180 120H40V200H180V240H20C9 240 0 231 0 220V100C0 89 9 80 20 80H180V120zM260 60H240V260H260C271 260 280 269 280 280C280 291 271 300 260 300H240C232.6 300 226 297.8 220 294.4C214 297.8 207.4 300 200 300H180C169 300 160 291 160 280C160 269 169 260 180 260H200V60H180C169 60 160 51 160 40C160 29 169 20 180 20H200C207.4 20 214 22.2 220 25.6C226 22.2 232.6 20 240 20H260C271 20 280 29 280 40C280 51 271 60 260 60zM300 240H260V200H280V120H260V80H300C311 80 320 89 320 100V220C320 231 311 240 300 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TextHighlight.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TextHighlight.displayName = "Blueprint5.Icon.TextHighlight";
exports.default = TextHighlight;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7NzeN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThAdd", ()=>ThAdd);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ThAdd = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "th-add",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 380C300 391.04584 308.956 400 320 400S340 391.04584 340 380V340H380C391.044 340 400 331.0458 400 320S391.044 300 380 300H340V260C340 248.9542 331.044 240 320 240S300 248.9542 300 260V300H260C248.956 300 240 308.9542 240 320S248.956 340 260 340H300V380zM380 260V40C380 28.954 371.044 20 360 20H20C8.95508 20 0 28.954 0 40V360C0 370 7.99804 380 20 380H260C226.866 380 200 353.1372 200 320C200 304.6328 205.776 290.6152 215.278 280H160V220H275.278C286.264 207.725 302.232 200 320 200C327.012 200 333.746 201.203 340 203.4144C340.528 203.6004 341.05 203.794 341.568 203.9944C342.168 204.2254 342.764 204.4656 343.354 204.715C364.888 213.8236 380 235.147 380 260zM320 200H160V140H340V200H320zM140 220V280H40V220H140zM40 200V140H140V200H40zM40 120V60H140V120H40zM340 120H160V60H340V120z" : "M260 320C248.954 320 240 311.0457 240 300V280H220C208.954 280 200 271.0456 200 260S208.954 240 220 240H240V220C240 208.9544 248.954 200 260 200S280 208.9544 280 220V240H300C311.046 240 320 248.9544 320 260S311.046 280 300 280H280V300C280 311.0457 271.046 320 260 320zM175.2782 220H140V180H215.278C226.264 167.725 242.23 160 260 160C287.076 160 309.964 177.9342 317.43 202.5714C318.2960000000001 202.8336 319.1520000000001 203.1148 320 203.4146V40C320 28 312 20 300 20H20C8 20 0 28 0 40V280C0 290 8 300 20 300H175.2776C165.777 289.385 160 275.3674 160 260.0004C160 244.633 165.7772 230.6152 175.2782 220zM120 220H40V180H120V220zM120 160H40V120H120V160zM140 120H280V160H140V120zM120 100H40V60H120V100zM140 60H280V100H140V60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ThAdd.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ThAdd.displayName = "Blueprint5.Icon.ThAdd";
exports.default = ThAdd;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ccjg5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThDerived", ()=>ThDerived);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ThDerived = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "th-derived",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M106 134C102 130 100 126 100 120C100 108 108 100 120 100C126 100 130 102 134 106L194 166C198 170 200 174 200 180S198 190 194 194L134 254C130 258 126 260 120 260C108 260 100 252 100 240C100 234 102 230 106 226L132 200H20C8 200 0 192 0 180S8 160 20 160H132L106 134L106 134zM380 380H60C50 380 40 370 40 360V240H60C60 274 86 300 120 300C136 300 152 294 162 282L164 280H180V264L200 244V280H360V220H224C230 214 234 208 236 200H360V140H224L222 138L204 120H360V60H200V116L180 96V60H80V76C68 86 60 102 60 120H40V40C40 30 50 20 60 20H380C392 20 400 30 400 40V360C400 370 390 380 380 380L380 380z" : "M112 120L106 114C102 110 100 106 100 100C100 88 108 80 120 80C126 80 130 82 134 86L174 126C178 130 180 134 180 140S178 150 174 154L134 194C130 198 126 200 120 200C110 200 100 192 100 180C100 174 102 170 106 166L112 160H20C8 160 0 152 0 140S8 120 20 120H112L112 120zM300 300H40C30 300 20 290 20 280V180H60V220H280V180H176L188 168L188 168C190 166 192 162 194 160H280V120H194C192 118 190 114 188 112L188 112L176 100H280V60H60V100H20V40C20 30 30 20 40 20H300C312 20 320 30 320 40V280C320 290 312 300 300 300L300 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ThDerived.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ThDerived.displayName = "Blueprint5.Icon.ThDerived";
exports.default = ThDerived;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dbc01":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThDisconnect", ()=>ThDisconnect);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ThDisconnect = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "th-disconnect",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M285.0073 380L380 380C390 380 400 370 400 360L400 40C400 30 390 20 380 20L235.57594 20L241.131496 60L360 60L360 120L249.464828 120L252.242606 140L360 140L360 200L260.57594 200L263.353718 220L360 220L360 280L271.68705 280L284.429536 371.7458978C284.81482 374.519933 285.003874 377.2759744 285.0073 380zM164.4240606 380L150.5351716 280L40 280L40 220L142.2018382 220L139.4240606 200L40 200L40 140L131.0907272 140L128.3129494 120L40 120L40 60L119.979616 60L115.5704636 28.254102C115.185181 25.480066 114.9961266 22.724026 114.992699 20L20 20C8 20 0 30 0 40L0 360C0 370 8 380 20 380L164.4240606 380zM205.190154 382.75136742C206.709692 393.69204298 216.810692 401.329383734 227.751368 399.8098454636001C238.692042 398.290307194 246.329384 388.18930812 244.809846 377.2486326L194.8098454 17.248632C193.2903072 6.307958 183.1893082 -1.329384 172.2486326 0.190154C161.307957 1.709692 153.6706162 11.810692 155.1901546 22.751368L205.190154 382.75136742z" : "M240.007594 300L300 300C312 300 320 290 320 280L320 40C320 28 312 20 300 20L200.609152 20L206.323438 60L280 60L280 100L212.037724 100L214.894866 120L280 120L280 160L220.609152 160L223.466296 180L280 180L280 220L229.180582 220L239.39697 291.5147186C239.804364 294.3664762 240.00408 297.2000044 240.007594 300zM119.3908474 300L107.9622758 220L40 220L40 180L102.2479902 180L99.3908474 160L40 160L40 120L93.6765616 120L90.8194188 100L40 100L40 60L85.105133 60L80.6030304 28.485282C80.1956364 25.633524 79.9959206 22.799996 79.9924056 20L20 20C8 20 0 28 0 40L0 280C0 290 8 300 20 300L119.3908474 300zM160.2010102 302.82842712C161.7631072 313.7631073 171.893747 321.36108704 182.8284272 319.798989874C193.7631072 318.236892706 201.361088 308.10625304 199.7989898 297.1715728L159.7989898 17.171572C158.2368928 6.236892 148.106253 -1.361088 137.1715728 0.20101C126.2368928 1.763108 118.638913 11.893746 120.2010102 22.828428L160.2010102 302.82842712z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ThDisconnect.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ThDisconnect.displayName = "Blueprint5.Icon.ThDisconnect";
exports.default = ThDisconnect;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kK6dU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThFiltered", ()=>ThFiltered);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ThFiltered = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "th-filtered",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M346.66664 200L375.364396 234.4373624C378.359616 238.0316312 379.999934 242.5622404 379.9999600000001 247.2409266L380.000272 303.0002448L400 321L400 40C400 30 390 20 380 20L20 20C8 20 0 30 0 40L0 360C0 370 8 380 20 380L154.4444444 380L240 303L240 280L160 280L160 220L240 220L240 200L160 200L160 140L360 140L360 200L346.66664 200zM140 60L140 120L40 120L40 60L140 60zM140 140L140 200L40 200L40 140L140 140zM140 220L140 280L40 280L40 220L140 220zM360 60L360 120L160 120L160 60L360 60zM387 400C394.2000000000001 400 400 394.2 400 387.2C400 383.6 398.6 380.4 396.2 378L335.6 317.4L335.6 258.4C335.6 254.8 334.2000000000001 251.6 331.8 249.2L306.2 223.4C304 221.4 300.8 220 297.2 220C290.2 220 284.4000000000001 225.8 284.4000000000001 232.8L284.4000000000001 317.4L223.8 378C221.347826 380.43096952 219.978106 383.7471336 220 387.2C220 394.2 225.8 400 232.8 400L387 400z" : "M200 120L260 120L295.617406 164.5217584C298.454396 168.067996 300.0000100000001 172.4741722 300.00003 177.0155724L300.0002780000001 234.0002508L320 252L320 40C320 28 312 20 300 20L20 20C8 20 0 28 0 40L0 280C0 290 8 300 20 300L106.6666666 300L180 234L180 220L140 220L140 180L180 180L180 160L140 160L140 120L200 120zM120 60L120 100L40 100L40 60L120 60zM120 120L120 160L40 160L40 120L120 120zM120 180L120 220L40 220L40 180L120 180zM280 60L280 100L140 100L140 60L280 60zM309.6 320C315.8 320 320 314.8 320 308.6C320 305.4 318.8 302.6 316.6 300.4L259.4000000000001 245.8L259.4000000000001 193.2C259.4000000000001 190 258.2 187.2 256 185L239.6 163C237.6 161 234.6 159.6 231.4 159.6C225.2 159.6 220 164.8 220 171L220 245.8L163.4 300.4C161.2 302.6 160 305.4 160 308.6C160 314.8 165.2 320 171.4 320L309.6 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ThFiltered.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ThFiltered.displayName = "Blueprint5.Icon.ThFiltered";
exports.default = ThFiltered;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1MWM8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThListAdd", ()=>ThListAdd);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ThListAdd = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "th-list-add",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 400C308.956 400 300 391.04584 300 380V340H260C248.956 340 240 331.0458 240 320S248.956 300 260 300H300V260C300 248.9542 308.956 240 320 240S340 248.9542 340 260V300H380C391.044 300 400 308.9542 400 320S391.044 340 380 340H340V380C340 391.04584 331.044 400 320 400zM343.354 204.715C364.888 213.8236 380 235.147 380 260V40C380 28.954 371.044 20 360 20H20C8.95508 20 0 28.954 0 40V360C0 370 7.99804 380 20 380H260C226.866 380 200 353.1372 200 320C200 304.6328 205.776 290.6152 215.278 280H40V220H275.278C286.264 207.725 302.232 200 320 200H40V140H340V200H320C327.012 200 333.746 201.203 340 203.4144C340.528 203.6004 341.05 203.794 341.568 203.9944C342.168 204.2254 342.764 204.4656 343.354 204.715zM40 120V60H340V120H40z" : "M240 300C240 311.0457 248.954 320 260 320S280 311.0457 280 300V280H300C311.046 280 320 271.0456 320 260S311.046 240 300 240H280V220C280 208.9544 271.046 200 260 200S240 208.9544 240 220V240H220C208.954 240 200 248.9544 200 260S208.954 280 220 280H240V300zM160 260.0004C160 244.633 165.7772 230.6152 175.2782 220H40V180H215.278C226.264 167.725 242.23 160 260 160H40V120H280V160H260C287.076 160 309.964 177.9342 317.43 202.5714C318.2960000000001 202.8336 319.1520000000001 203.1148 320 203.4146V40C320 28 312 20 300 20H20C8 20 0 28 0 40V280C0 290 8 300 20 300H175.2776C165.777 289.385 160 275.3674 160 260.0004zM140 60H280V100H40V60H140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ThListAdd.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ThListAdd.displayName = "Blueprint5.Icon.ThListAdd";
exports.default = ThListAdd;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"wCc5D":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThList", ()=>ThList);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ThList = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "th-list",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 380H20C8 380 0 370 0 360V40C0 30 8 20 20 20H380C390 20 400 30 400 40V360C400 370 390 380 380 380L380 380zM360 60H40V120H360V60L360 60zM360 140H40V200H360V140L360 140zM360 220H40V280H360V220L360 220z" : "M300 300H20C8 300 0 290 0 280V40C0 28 8 20 20 20H300C312 20 320 28 320 40V280C320 290 312 300 300 300L300 300zM280 60H40V100H280V60L280 60zM280 120H40V160H280V120L280 120zM280 180H40V220H280V180L280 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ThList.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ThList.displayName = "Blueprint5.Icon.ThList";
exports.default = ThList;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fJvAh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThVirtualAdd", ()=>ThVirtualAdd);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ThVirtualAdd = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "th-virtual-add",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M300 380C300 391.0457 308.954 400 320 400S340 391.0457 340 380V340H380C391.046 340 400 331.0456000000001 400 320S391.046 300 380 300H340V260C340 248.9544 331.046 240 320 240S300 248.9544 300 260V300H260C248.954 300 240 308.9544 240 320S248.954 340 260 340H300V380zM20 380H260C226.866 380 200 353.137 200 320C200 304.6328 205.776 290.615 215.278 280H40V60H340V203.4144C363.3 211.6514 380 233.876 380 260V40C380 28.954 371.044 20 360 20H20C8.95508 20 0 28.954 0 40V360C0 370 7.99804 380 20 380zM60 240C60 251.0458 68.955 260 80 260H180C191.045 260 200 251.0458 200 240S191.045 220 180 220H128.2862L234.14 114.144C241.9540000000001 106.334 241.9540000000001 93.67 234.14 85.86C226.3280000000001 78.048 213.666 78.048 205.854 85.86L100 191.714V140C100 128.954 91.045 120 80 120S60 128.954 60 140V240z" : "M240 300C240 304.14218 241.26 307.99024 243.416 311.18226C247.01 316.50228 253.096 320 260 320C271.046 320 280 311.0457 280 300V280H300C303.676 280 307.122 279.0078 310.082 277.2766000000001C312.68 275.7572 314.904 273.6688000000001 316.584 271.1822C318.74 267.9902 320 264.1422 320 260C320 255.6076 318.584 251.5458 316.1840000000001 248.2464C314.4340000000001 245.8416 312.1620000000001 243.8416 309.5320000000001 242.4138C306.698 240.8744 303.452 240 300 240H280V220C280 215.8578 278.74 212.0098 276.584 208.8178C274.9340000000001 206.3744 272.7560000000001 204.3154 270.216 202.8032C267.226 201.0226 263.7320000000001 200 260 200C257.238 200 254.608 200.5596 252.216 201.5716C248.87 202.987 245.988 205.287 243.866 208.1786C241.436 211.49 240 215.5774 240 220V240H220C216.55 240 213.304 240.8736 210.47 242.4118C207.636 243.9514 205.214 246.1566 203.416 248.8178C201.26 252.0098 200 255.8578 200 260C200 264.543 201.514 268.7322 204.066 272.09C206.168 274.8556 208.974 277.0572 212.216 278.4284C214.608 279.4404 217.238 280 220 280H240V300zM280 163.4144C297.896 169.74 311.894 184.3154 317.432 202.5714C318.2960000000001 202.8336 319.1500000000001 203.1146 320 203.4146V40C320 28 312.002 20 300 20H20C8.95508 20 0 28.954 0 40V280C0 290 7.99804 300 20 300H175.2784C165.7764 289.385 160 275.3674 160 260.0004C160 244.6332 165.7764 230.6152 175.2784 220H40V60H280V163.4144zM147.212 85.59L100 132.7466V120C100 108.954 91.045 100 80 100S60 108.954 60 120V180C60 191.0458 68.955 200 80 200H140C151.045 200 160 191.0458 160 180S151.045 160 140 160H127.1044L174.4042 112.752C181.8702 105.292 181.8652 93.076 174.3848 85.608C166.9092 78.138 154.6778 78.1299999999999 147.212 85.59z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ThVirtualAdd.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ThVirtualAdd.displayName = "Blueprint5.Icon.ThVirtualAdd";
exports.default = ThVirtualAdd;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"js4SE":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThVirtual", ()=>ThVirtual);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ThVirtual = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "th-virtual",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 240C60 251.0458 68.955 260 80 260H180C191.045 260 200 251.0458 200 240S191.045 220 180 220H128.2862L234.14 114.144C241.9540000000001 106.334 241.9540000000001 93.67 234.14 85.86C226.3280000000001 78.048 213.666 78.048 205.854 85.86L100 191.714V140C100 128.954 91.045 120 80 120S60 128.954 60 140V240zM400 40C400 28.954 391.044 20 380 20H20C8.95508 20 0 28.954 0 40V360C0 370 7.99804 380 20 380H380C391.044 380 400 371.0456 400 360V40zM360 60V280H40V60H360z" : "M140 160C151.045 160 160 168.9542 160 180S151.045 200 140 200H80C68.955 200 60 191.0458 60 180V120C60 108.954 68.955 100 80 100S100 108.954 100 120V132.7466L147.212 85.59C154.6778 78.13 166.9092 78.138 174.3848 85.608C181.8652 93.076 181.8702 105.292 174.4042 112.752L127.1044 160H140zM20 300C7.99804 300 0 290 0 280V40C0 28.954 8.95508 20 20 20H300C312.002 20 320 28 320 40V280C320 291.0456 311.044 300 300 300H20zM280 60H40V220H280V60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ThVirtual.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ThVirtual.displayName = "Blueprint5.Icon.ThVirtual";
exports.default = ThVirtual;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cpHsU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Th", ()=>Th);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Th = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "th",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 380H20C8 380 0 370 0 360V40C0 30 8 20 20 20H380C390 20 400 30 400 40V360C400 370 390 380 380 380L380 380zM140 60H40V120H140V60L140 60zM140 140H40V200H140V140L140 140zM140 220H40V280H140V220L140 220zM360 60H160V120H360V60L360 60zM360 140H160V200H360V140L360 140zM360 220H160V280H360V220L360 220z" : "M300 300H20C8 300 0 290 0 280V40C0 28 8 20 20 20H300C312 20 320 28 320 40V280C320 290 312 300 300 300L300 300zM120 60H40V100H120V60L120 60zM120 120H40V160H120V120L120 120zM120 180H40V220H120V180L120 180zM280 60H140V100H280V60L280 60zM280 120H140V160H280V120L280 120zM280 180H140V220H280V180L280 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Th.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Th.displayName = "Blueprint5.Icon.Th";
exports.default = Th;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2cBy5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThirdParty", ()=>ThirdParty);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ThirdParty = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "third-party",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M177.7777777777778 400C79.5555555555556 400 0 320.4444444444445 0 222.2222222222222C0 140.5044444444445 55.0673333333333 71.7066666666667 130.1371111111111 50.8933333333334C131.5626666666667 52.1555555555556 132.9893333333333 53.3044444444445 134.3715555555556 54.3466666666667C140.5288888888889 58.9977777777778 147.5753333333333 62.8755555555555 154.2637777777778 66.1244444444445C162.2295555555556 69.9977777777778 172.2673333333334 74.1 180.7804444444445 77.5777777777778C185.3653333333333 79.4533333333334 189.5091111111111 81.1466666666667 192.6511111111111 82.5266666666666C194.4337777777778 83.3088888888889 195.9182222222222 84.0133333333333 197.1495555555555 84.64C194.6882222222222 87.7977777777778 192.4268888888889 91.1444444444445 190.3828888888889 94.6377777777778C186.2604444444444 90.8555555555556 182.0011111111111 88.8888888888889 177.7777777777778 88.8888888888889C162.8888888888889 88.8888888888889 147.5555555555556 113.3333333333333 139.3333333333333 155.5555555555556H167.1662222222222C168.2048888888889 162.1288888888889 170.564 168.2466666666667 174.3404444444445 173.2777777777778C174.3931111111111 174.7444444444445 174.4593333333333 176.2488888888889 174.5397777777778 177.7777777777778H136C134.4444444444444 191.3333333333333 133.3333333333333 206 133.3333333333333 222.2222222222222C133.3333333333333 238.4444444444445 134.4444444444444 253.1111111111111 136 266.6666666666667H219.5555555555556C219.8431111111111 264.1608888888889 220.1155555555556 261.6171111111111 220.3684444444444 259.0324444444444C227.3666666666667 262.2482222222223 234.8133333333333 264.398 242.1222222222222 265.5755555555555L242 266.6666666666667H303.3333333333333C303.9311111111111 264.9557777777778 304.4977777777778 263.2317777777778 305.0333333333333 261.4948888888889L307.6444444444445 262.3844444444445C315.9488888888889 265.2135555555556 324.8111111111112 266.6666666666667 333.2866666666667 266.6666666666667C338.7822222222223 266.6666666666667 344.6088888888889 266.0477777777778 350.44 264.7593333333334C331.3866666666667 342.4235555555556 261.3377777777778 400 177.7777777777778 400zM292.6666666666667 288.8888888888889H238.4444444444445C233.7777777777778 313.5555555555556 227.1111111111111 334 218.2222222222222 348.6666666666667C250 338.4444444444445 276.2222222222223 316.8888888888889 292.6666666666667 288.8888888888889zM177.7777777777778 355.5555555555556C192.6666666666667 355.5555555555556 208 331.1111111111111 216.2222222222222 288.8888888888889H139.3333333333333C147.5555555555556 331.1111111111111 162.8888888888889 355.5555555555556 177.7777777777778 355.5555555555556zM137.3333333333333 348.6666666666667C128.4444444444445 334 121.5555555555556 313.5555555555556 117.1111111111111 288.8888888888889H62.8888888888889C79.3333333333333 316.8888888888889 105.5555555555556 338.4444444444445 137.3333333333333 348.6666666666667zM44.4444444444444 222.2222222222222C44.4444444444444 237.7777777777778 47.3333333333333 252.6666666666667 52.2222222222222 266.6666666666667H113.5555555555556C112 252.8888888888889 111.1111111111111 238.2222222222223 111.1111111111111 222.2222222222222C111.1111111111111 206.2222222222222 112 191.5555555555556 113.5555555555556 177.7777777777778H52.2222222222222C47.3333333333333 191.7777777777778 44.4444444444444 206.6666666666667 44.4444444444444 222.2222222222222zM62.8888888888889 155.5555555555556H117.1111111111111C121.7777777777778 130.8888888888889 128.4444444444445 110.4444444444445 137.3333333333333 95.7777777777778C105.5555555555556 106 79.3333333333333 127.5555555555556 62.8888888888889 155.5555555555556zM309.2666666666667 62.0288888888889C313.9511111111111 59.9244444444445 319.1377777777778 57.8022222222223 324.4844444444445 55.6133333333333C344.7644444444445 47.3133333333333 367.3088888888889 38.0888888888888 373.1111111111111 25.5133333333333C379.9844444444444 9.4733333333334 377.2355555555556 0 377.2355555555556 0H133.9271111111111C133.9271111111111 0 131.0253333333333 9.4733333333334 138.0511111111111 25.5133333333333C143.7375555555556 38.4977777777777 167.0342222222222 47.9777777777778 187.6946666666667 56.3866666666667C192.56 58.3666666666667 197.2806666666667 60.2888888888889 201.5891111111111 62.18C221.79 71.0555555555555 222.1084444444445 76.88 222.4933333333333 83.9066666666667C222.5377777777778 84.7422222222222 222.5844444444444 85.5955555555556 222.6666666666667 86.4733333333334C222.6666666666667 87.0066666666667 222.7044444444444 87.54 222.7422222222223 88.0755555555556C222.78 88.6111111111111 222.82 89.1466666666667 222.82 89.68C214.8768888888889 96.5555555555556 208.3093333333333 106.18 204.1855555555556 117.18L204.0326666666667 117.3333333333333C204.0326666666667 117.4088888888889 203.9946666666667 117.4866666666667 203.9564444444444 117.5622222222223C203.9182222222222 117.6377777777778 203.88 117.7155555555556 203.88 117.7911111111111C202.8108888888889 120.0822222222223 202.0471111111111 122.68 201.4362222222222 125.2777777777778C196.2433333333333 126.1955555555556 193.1886666666667 131.8466666666667 191.9666666666667 137.1933333333333C190.7448888888889 139.3333333333333 188.3011111111111 144.5266666666667 188.912 150.4866666666667C189.6755555555555 158.2777777777778 192.8831111111111 161.7911111111111 196.396 163.1666666666667V164.3888888888889C196.396 174.1666666666667 197.1595555555556 188.0695555555556 198.9924444444445 197.236C199.298 199.8333333333334 199.9088888888889 202.4306666666667 200.6726666666667 204.8748888888889C204.0326666666667 216.1804444444445 211.0586666666667 226.264 220.3755555555555 233.2917777777778C229.8444444444445 240.6248888888889 243.4377777777778 244.4444444444445 255.5044444444445 244.4444444444445C267.5711111111111 244.4444444444445 281.1644444444445 240.6248888888889 290.7866666666667 233.2917777777778C300.2555555555556 226.264 307.1288888888889 216.0277777777778 310.4888888888889 204.8748888888889C311.2533333333334 202.2777777777778 311.8644444444444 199.8333333333334 312.1688888888889 197.236C313.8488888888889 188.0695555555556 314.7666666666667 174.0133333333334 314.7666666666667 164.3888888888889V163.0133333333333C318.1266666666667 161.6377777777778 321.18 158.1244444444445 321.9444444444445 150.4866666666667C322.4022222222223 144.5266666666667 320.1111111111111 139.3333333333333 318.8888888888889 137.1933333333333C317.82 132 314.7666666666667 126.3466666666667 309.5733333333333 125.2777777777778C308.9622222222222 122.8333333333333 308.1977777777778 120.2355555555556 307.2822222222223 117.9444444444445C307.1288888888889 117.7911111111111 306.9755555555556 117.18 306.9755555555556 117.18C302.8533333333333 106.3333333333334 296.5911111111111 96.86 288.8 89.9866666666667C288.8 88.7644444444445 288.8 87.5422222222222 288.9533333333333 86.4733333333334C289.0511111111112 85.3977777777778 289.0866666666667 84.3622222222223 289.12 83.3511111111111C289.3555555555556 76.4444444444445 289.5511111111111 70.6888888888889 309.2666666666667 62.0288888888889zM332.7955555555556 76.2244444444444C327.4533333333333 78.4111111111111 322.6822222222222 80.3644444444445 318.3711111111112 82.3L318.2044444444445 82.3733333333333C316.4866666666666 83.1288888888889 315.0622222222222 83.8066666666667 313.8888888888889 84.4044444444444C318.8711111111111 90.8 322.9844444444444 97.9244444444444 326.1933333333334 105.4288888888889L326.2222222222223 105.4577777777778L326.52 106.2044444444445C326.92 107.1622222222222 327.3066666666667 108.1266666666667 327.6755555555556 109.0955555555556L327.9155555555556 109.6933333333333C328.0333333333333 109.9888888888889 328.1511111111111 110.2866666666667 328.2644444444445 110.5844444444444C330.6 112.6133333333334 332.4844444444444 114.8155555555556 333.9466666666667 116.8955555555556C336.8177777777778 120.9733333333334 338.6822222222222 125.3511111111112 339.8377777777778 129.3888888888889C342.1711111111111 134.4266666666667 344.8422222222222 142.5644444444445 344.1022222222222 152.1911111111111L344.0822222222223 152.4444444444444L344.0555555555556 152.6977777777778C343.3222222222222 160.0377777777778 341.0066666666667 167.1288888888889 336.8111111111111 172.8977777777778C336.46 181.9602222222222 335.5822222222223 192.4551111111111 334.1444444444445 200.5904444444445C333.6066666666667 204.6744444444445 332.6666666666667 208.23 331.8088888888889 211.144L331.7666666666667 211.2855555555556C328.4711111111111 222.2233333333333 322.7177777777778 232.6317777777778 314.8133333333334 241.3497777777778C320.8222222222222 243.3975555555556 327.2644444444445 244.4444444444445 333.2866666666667 244.4444444444445C344.2555555555556 244.4444444444445 356.6133333333333 240.9722222222223 365.3622222222222 234.3055555555556C373.9711111111111 227.9166666666667 380.2177777777778 218.6111111111111 383.2733333333333 208.4722222222222C383.9666666666667 206.1111111111111 384.5222222222222 203.8888888888889 384.8 201.5277777777778C386.3288888888889 193.1944444444445 387.16 180.4166666666667 387.16 171.6666666666667V170.4155555555556C390.2155555555555 169.1666666666667 392.9933333333333 165.9733333333333 393.6866666666667 159.0266666666667C394.1044444444445 153.6111111111111 392.0199999999999 148.8888888888889 390.9088888888889 146.9444444444445C389.9377777777778 142.2222222222222 387.16 137.0822222222223 382.44 136.1111111111112C381.8844444444444 133.8888888888889 381.1911111111112 131.5266666666667 380.3577777777778 129.4444444444445C380.2177777777778 129.3066666666667 380.08 128.7488888888889 380.08 128.7488888888889C376.3311111111111 118.8888888888889 370.6377777777778 110.2777777777778 363.5555555555556 104.0266666666667C363.5555555555556 102.9155555555556 363.5555555555556 101.8066666666667 363.6955555555556 100.8333333333333C363.7844444444445 99.8577777777778 363.8155555555556 98.9155555555556 363.8466666666667 97.9955555555556C364.06 91.7177777777778 364.2377777777778 86.4844444444445 382.1622222222222 78.6111111111111C386.42 76.7 391.1355555555556 74.7688888888889 395.9955555555556 72.78C414.4333333333334 65.2355555555556 434.9266666666667 56.8488888888889 440.2022222222223 45.4155555555556C446.4511111111111 30.8333333333333 443.9511111111111 22.2222222222222 443.9511111111111 22.2222222222222H397.7044444444444C396.7222222222222 25.9711111111112 395.3666666666666 29.9977777777779 393.5377777777778 34.2666666666667L393.4177777777778 34.5466666666667L393.2888888888889 34.8244444444445C389.2222222222223 43.6355555555556 382.3777777777778 49.9644444444444 376.4044444444444 54.3777777777778C370.2244444444445 58.9444444444445 363.1733333333334 62.7622222222222 356.4866666666666 65.9777777777778C349.7288888888889 69.2244444444444 342.6088888888889 72.1977777777778 336.1244444444445 74.86L332.7955555555556 76.2244444444444z" : "M88.9636 140H100.4254C100.9148 140.8852 101.44 141.7528 102 142.6C102.2824 148.4234 102.8346 154.2296 103.6546 160H83.758C81.366 172.1778 80 185.664 80 200C80 214.336 81.366 227.8222 83.758 240H156.242C157.536 233.4126 158.5296 226.442 159.1694 219.1614C162.4732 219.6846 165.8254 219.967 169.2002 220C172.5634 219.9888 175.9148 219.7434 179.2306 219.2682C178.6542 226.4092 177.7628 233.3392 176.5856 240H211.68C214.634 233.2368 216.862 226.0828 218.266 218.6376L221.8 219.1998C225.126 219.5046 228.474 219.5046 231.8 219.1998C234.056 219.2024 236.302 219.0844 238.528 218.8486C229.486 276.1686 179.8616 320 120 320C53.7256 320 0 266.2744 0 200C0 135.9268 50.2162 83.582 113.4396 80.176C111.9174 83.03 110.5678 85.976 109.3998 89C107.6366 90.576 106.0294 92.316 104.6 94.2C102.2618 97.548 100.5038 101.268 99.3998 105.2C96.7226 110.962 95.4602 117.272 95.7062 123.6064L95.462 124.0918C93.0798 128.855 90.8948 134.1846 88.9636 140zM63.4144 160H28.321C22.9694 172.2486 20 185.7788 20 200C20 214.2212 22.9694 227.7514 28.321 240H63.4144C61.203 227.4878 60 214.0258 60 200C60 185.9742 61.203 172.5122 63.4144 160zM39.9926 140H68.0274C71.6052 127.6318 76.2542 116.658 81.7224 107.588C65.0628 114.494 50.6756 125.7764 39.9926 140zM88.9636 260H151.0364C149.1052 265.8154 146.9202 271.145 144.538 275.9082C134.743 295.498 124.9122 300 120 300C115.0878 300 105.257 295.498 95.462 275.9082C93.0798 271.145 90.8948 265.8154 88.9636 260zM171.9726 260H200.008C189.3244 274.2236000000001 174.9372 285.5054 158.2776 292.4122C163.7458 283.3422 168.3948 272.3682 171.9726 260zM81.7224 292.4122C76.2542 283.3422 71.6052 272.3682 68.0274 260H39.9926C50.6756 274.2236000000001 65.0628 285.5054 81.7224 292.4122zM269.528 0C269.528 0 271.882 7.692 266.072 20.922C261.524 31.57 242.632 39.23 225.77 46.066C221.682 47.722 217.714 49.332 214.098 50.922C197.9386 58.034 197.7822 62.688 197.5916 68.354C197.5636 69.186 197.535 70.038 197.455 70.922V73.692C203.736 79.384 208.916 87.078 212.37 96C212.37 96 212.528 96.46 212.528 96.616C213.312 98.614 213.94 100.616 214.412 102.614C218.652 103.386 221.008 108 221.95 112.308C223.048 114.152 224.932 118.308 224.462 123.2324C223.99 129.385 221.478 132.3076 218.652 133.54V134.615C218.652 142.46 217.868 153.846 216.452 161.2308C216.14 163.2308 215.668 165.3848 215.04 167.3848C212.37 176.7692 206.56 184.9232 199.025 190.7692C191.1726 196.7692 180.025 200 170.13 200C160.2388 200 149.09 196.7692 141.2388 190.7692C133.7018 184.9232 127.8918 176.7692 125.2224 167.5384C124.594 165.5386 124.123 163.3848 123.809 161.3848C122.3958 154 121.6108 142.46 121.6108 134.615V133.6926C118.7844 132.46 116.1148 129.54 115.4868 123.2324C115.0158 118.308 117.057 114.152 117.9994 112.308C118.9414 108 121.4538 103.232 125.8506 102.46C126.2436 100.792 126.8552 99.016 127.4118 97.4L127.7346 96.46C127.7346 96.308 127.8918 96.152 127.8918 96.152V96C131.3464 86.922 136.685 79.078 143.123 73.692C143.123 73.208 143.0802 72.726 143.0392 72.266C143.0018 71.846 142.966 71.444 142.966 71.078C142.8986 70.352 142.8602 69.646 142.8226 68.956C142.509 63.212 142.2514 58.494 125.8506 51.078C122.3318 49.528 118.4774 47.958 114.5056 46.338C97.5628 39.43 78.4546 31.64 73.8756 20.922C68.2224 7.692 70.4208 0 70.4208 0H269.528zM319.588 25H291.312C290.6500000000001 26.906 289.884 28.868 289.004 30.88C285.1620000000001 39.778 278.5900000000001 45.94 273.268 49.972C267.7080000000001 54.188 261.47 57.588 255.808 60.328C249.312 63.472 240.474 67.08 233.352 69.986L232.964 70.144C231.276 70.834 229.69 71.484 228.262 72.072C231.134 76.686 233.582 81.598 235.58 86.704C237.36 88.44 238.82 90.238 239.98 91.916C242.624 95.742 244.318 99.728 245.4 103.256C247.742 108.288 250.204 116.048 249.37 125.365C248.834 131.955 246.894 138.3774 243.402 143.8574C243.0420000000001 151.0722 242.282 159.0972 241.084 165.52C240.628 168.3272 239.95 171.4332 238.998 174.536C236.292 183.877 231.678 192.2922 225.772 199.4438C228.08 199.8122 230.384 200 232.614 200C241.27 200 251.024 197.173 257.898 191.923C264.49 186.8078 269.574 179.673 271.91 171.4618C272.458 169.7118 272.872 167.827 273.144 166.077C274.382 159.6152 275.07 149.6526 275.07 142.79V141.8474C277.5420000000001 140.77 279.742 138.21 280.152 132.8274C280.564 128.52 278.918 124.8826 277.958 123.27C277.13 119.5 275.07 115.46 271.36 114.79C270.948 113.04 270.398 111.29 269.71 109.54C269.71 109.402 269.574 109 269.574 109C266.552 101.192 262.018 94.46 256.522 89.48V87.058C256.592 86.292 256.616 85.556 256.642 84.838L256.642 84.81C256.81 79.852 256.948 75.78 271.084 69.558C274.248 68.164 277.72 66.758 281.298 65.308C296.052 59.328 312.582 52.626 316.564 43.308C321.648 31.73 319.588 25 319.588 25z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ThirdParty.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ThirdParty.displayName = "Blueprint5.Icon.ThirdParty";
exports.default = ThirdParty;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eq5yE":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThumbsDown", ()=>ThumbsDown);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ThumbsDown = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "thumbs-down",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M371 268.8C364.8000000000001 269 358.0000000000001 269.4 350.6 270C351.2000000000001 270 351.8 270.2 352.4000000000001 270.2C370 272.6 386 282.8 387.6 297.6C389.2000000000001 312.6 376.0000000000001 322.6 358.4000000000001 324.2C352 324.8 345.4000000000001 325.2 338.6000000000001 325.8C350.4000000000001 329.6 359.6000000000001 336.6 360.4000000000001 349.8C361.4000000000001 364.8 340.6000000000001 376.2 323.0000000000001 378C316.2000000000001 378.6 310.2000000000001 379 304.8000000000001 379.4L304.8000000000001 379.4C304.0000000000001 379.4 303.4000000000001 379.4 302.6 379.4C297.0000000000001 379.8 291.8000000000001 379.8 287.2000000000001 379.8C208.8 381.4 141.4 367.8 100 341.2V186.8C153.4 153.6 219 94.6 205.2 45.1999999999999C201 29.9999999999999 213 18.1999999999999 229.8 19.9999999999999C250 22.1999999999999 264 43.5999999999999 264.8 65.6C265.8 91.3999999999999 261 117.4 252.4000000000001 140.4C251.4 146.8 252.6 153.4 261.8 154C274 154.7999999999999 289.6 155.6 301.6 156C308.0000000000001 156 314.4000000000001 156.1999999999999 320.4000000000001 156.5999999999999C320.6000000000001 156.5999999999999 320.6000000000001 156.5999999999999 320.6000000000001 156.5999999999999H320.6000000000001C331.0000000000001 157.1999999999999 340.6000000000001 158 349.0000000000001 158.9999999999999C366.6 161.1999999999999 382.8000000000001 170.9999999999999 384.8000000000001 185.9999999999999C386.8000000000001 200.9999999999999 373.8 210.9999999999999 356 212.9999999999999C354.6 213.1999999999999 353.4000000000001 213.3999999999999 352 213.3999999999999C356.2000000000001 213.7999999999999 360.4000000000001 214.1999999999999 364.2000000000001 214.5999999999999C381.8 216.7999999999999 398.0000000000001 226.5999999999999 400 241.5999999999999C401.8 256.6 388.8 267.8 371 268.8zM60 340H0V180H60C71 180 80 189 80 200V320C80 331 71 340 60 340z" : "M40 280H0V140H40C51 140 60 149 60 160V260C60 271 51 280 40 280zM319.8 192.4C321.4 204 311 212.8 296.8 213.4C291.8 213.6 286.4 214 280.6 214.4C281 214.4 281.6 214.6 282 214.6C296 216.6 308.8 224.4 310.2 236C311.4 247.6 301 255.4 286.8 256.8C281.8 257.2 276.4 257.6 271 258C280.4000000000001 261 287.8 266.4 288.4 276.6C289.2 288.2 272.6 297.2 258.4 298.4C253 298.8 248.2 299.2 243.8 299.4L243.8 299.4C243.2 299.4 242.6 299.4 242 299.4C237.4 299.8 233.4 299.8 229.6 300C167 301 113.2 290.6 80 269.8V149.8C122.8 124 175.2 78 164.2 39.6C160.6 27.8 170.4 18.6 183.8 20C200 21.8 211.2 38.2 211.8 55.6C212.6 75.6 208.8 95.8 201.8 113.8C201 118.8 202 123.8 209.2 124.4C219 125 231.4 125.6 241 126C246.2 126 251.2 126.2 256 126.4C256 126.4 256.2 126.4 256.2 126.4H256.2C264.4 126.8 272.2 127.4 278.8 128.2C292.8 130 305.8 137.6 307.4 149.2C309 160.8 298.6 168.6 284.3999999999999 170.2C283.3999999999999 170.4 282.2 170.4 281.2 170.6C284.5999999999999 170.8 287.8 171.2 291 171.6C305.4 173.2 318.4 180.8 319.8 192.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ThumbsDown.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ThumbsDown.displayName = "Blueprint5.Icon.ThumbsDown";
exports.default = ThumbsDown;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kayj4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThumbsUp", ()=>ThumbsUp);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ThumbsUp = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "thumbs-up",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 220H0V60H60C71 60 80 69 80 80V200C80 211 71 220 60 220zM399.8 158.2C397.8 173.2 381.6 183 364 185.2C360.2 185.6 356 186.2 351.8 186.4C353.2 186.6 354.6 186.6 355.8 186.8C373.4 188.8 386.4 199 384.6 213.8C382.6 228.6 366.4 238.6 348.8 240.8C340.4 241.8 330.8000000000001 242.6 320.4000000000001 243.2H320.4000000000001C320.4000000000001 243.2 320.4000000000001 243.2 320.2000000000001 243.2C314.2000000000001 243.4 308.0000000000001 243.6 301.4000000000001 243.8C289.4000000000001 244.2 273.6 244.8 261.6 245.8C252.6000000000001 246.4 251.4000000000001 253 252.2 259.4C260.8 282.4 265.6 308.4 264.6 334.2C263.8 356.4 249.8 377.6 229.6 379.8C212.8 381.6 200.6 369.8 205 354.6C219 305.2 153.4 246 100 213V58.6C141.6 32 208.8 18.4 287 20C291.8 20 296.8 20.2 302.4 20.4C303.2 20.4 303.8 20.4 304.6 20.4L304.6 20.4C310 20.8 316 21.2 322.8 21.8C340.3999999999999 23.4 361.2 35 360.2 50C359.4 63 350.2 70.2000000000001 338.4 74C345.2 74.6 351.8 75 358.2 75.6C376 77.1999999999999 389.2 87.1999999999999 387.4 102.1999999999999C385.8 117.1999999999999 369.8 127.1999999999999 352.2 129.5999999999999C351.5999999999999 129.5999999999999 351 129.8 350.3999999999999 129.8C357.8 130.1999999999999 364.5999999999999 130.5999999999999 370.7999999999999 131C389 132 401.8 143.2 399.8 158.2z" : "M319.8 127.6C318.2 139.2 305.2 146.8 291.2 148.6C288.2 149 284.8 149.4 281.4 149.6000000000001C282.6 149.8000000000001 283.6 149.8000000000001 284.6 150C298.8 151.6 309.2000000000001 159.4 307.6 171C306 182.6 293 190.2000000000001 279 192C272.2000000000001 192.8 264.6 193.4 256.4 193.8H256.4C256.4 193.8 256.4 193.8 256.2 193.8C251.4 194 246.4 194.2 241.2 194.2C231.6 194.6 219 195 209.4 195.8C202.2 196.4 201.2 201.4 202 206.4C209 224.4 212.8 244.6 212 264.6C211.2 281.6 200 298.2 183.8 300C170.4 301.4 160.6 292.2 164 280.4C175.2 241.8 122.6 196 80 170.2V50.2C113.2 29.6 167 19 229.6 20.2C233.4 20.2 237.4000000000001 20.4 242 20.6C242.6 20.6 243.2 20.6 243.8 20.6L243.8 20.6C248.2 20.8 253 21.2 258.4 21.6C272.6 22.8 289.2000000000001 31.8 288.4 43.4C287.8 53.6 280.4 59.2000000000001 271 62C276.4 62.4 281.8 62.8 286.8 63.2C301 64.4 311.6 72.2 310.2 84C309 95.6 296.2 103.4 282 105.4C281.6 105.4 281 105.6 280.6 105.6C286.4 106 292 106.2 296.8 106.6C311 107.2 321.4 116 319.8 127.6zM40 180H0V40H40C51 40 60 49 60 60V160C60 171.2 51 180 40 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ThumbsUp.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ThumbsUp.displayName = "Blueprint5.Icon.ThumbsUp";
exports.default = ThumbsUp;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iFGi1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TickCircle", ()=>TickCircle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TickCircle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tick-circle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 0C89.6 0 0 89.6 0 200S89.6 400 200 400S400 310.4 400 200S310.4 0 200 0zM300 280C294.4000000000001 280 289.4000000000001 277.8 285.8 274.2L160 148.2L114.2 194.2C110.6 197.8 105.6 200 100 200C89 200 80 191 80 180C80 174.4 82.2 169.4 85.8 165.8L145.8 105.8C149.4 102.2 154.4 100 160 100C165.6 100 170.6 102.2 174.2 105.8L314.2000000000001 245.8C317.8 249.4 320 254.4 320 260C320 271 311 280 300 280z" : "M160 0C71.6 0 0 71.6 0 160S71.6 320 160 320S320 248.4 320 160S248.4 0 160 0zM240 220C234.4 220 229.4 217.8 225.8 214.2L140 128.2L94.2 174.2C90.6 177.8 85.6 180 80 180C69 180 60 171 60 160C60 154.4 62.2 149.4 65.8 145.8L125.8 85.8C129.4 82.2 134.4 80 140 80S150.6 82.2 154.2 85.8L254.2 185.8C257.8 189.4 260 194.4 260 200C260 211 251 220 240 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TickCircle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TickCircle.displayName = "Blueprint5.Icon.TickCircle";
exports.default = TickCircle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d6Bzh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tick", ()=>Tick);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Tick = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tick",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 320C334.4 320 329.4 317.8 325.8 314.2L140 128.2L74.2 194C70.6 197.8 65.6 200 60 200C49 200 40 191 40 180C40 174.4 42.2 169.4 45.8 165.8L125.8 85.8C129.4 82.2 134.4 80 140 80S150.6 82.2 154.2 85.8L354.2000000000001 285.8C357.8 289.4 360 294.4 360 300C360 311 351 320 340 320z" : "M280 260C274.4000000000001 260 269.4000000000001 257.8 265.8 254.2L120 108.2L54.2 174.2C50.6 177.8 45.6 180 40 180C29 180 20 171 20 160C20 154.4 22.2 149.4 25.8 145.8L105.8 65.8C109.4 62.2 114.4 60 120 60S130.6 62.2 134.2 65.8L294.2000000000001 225.8C297.8 229.4 300 234.4 300 240C300 251 291 260 280 260z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Tick.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Tick.displayName = "Blueprint5.Icon.Tick";
exports.default = Tick;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"RWj6W":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Time", ()=>Time);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Time = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "time",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 208.2V320C220 331 211 340 200 340S180 331 180 320V200C180 194.4 182.2 189.4 185.8 185.8L245.8 125.8C249.4 122.2 254.4 120 260 120C271 120 280 129 280 140C280 145.6 277.8 150.6 274.2000000000001 154.2L220 208.2zM200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM200 40C111.6 40 40 111.6 40 200S111.6 360 200 360S360 288.4 360 200S288.4 40 200 40z" : "M160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM160 40C93.8 40 40 93.8 40 160S93.8 280 160 280S280 226.2 280 160S226.2 40 160 40zM180 168.2V240C180 251 171 260 160 260S140 251 140 240V160C140 154.4 142.2 149.4 145.8 145.8L185.8 105.8C189.4 102.2 194.4 100 200 100C211 100 220 109 220 120C220 125.6 217.8 130.6 214.2 134.2L180 168.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Time.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Time.displayName = "Blueprint5.Icon.Time";
exports.default = Time;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9yku9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimelineAreaChart", ()=>TimelineAreaChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TimelineAreaChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "timeline-area-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 80H40V340C40 351 31 360 20 360S0 351 0 340V60C0 49 9 40 20 40H380C391 40 400 49 400 60C400 71 391 80 380 80zM380 348.2L238.6 206.8L152.6 275.6L152.4 275.4C148.8 278.2 144.8 280 140 280C135.2 280 130.8 278 127.4 275.2C127.4 275.2 127.2 275.4 127.2 275.4L60 219.4V100H380V348.2z" : "M300 268.2L198.2 166.4L132 216L131.8 215.8C128.4 218.2 124.6 220 120 220C115.2 220 111.2 218.2 107.6 215.4L107.6 215.6L60 177.6V100H300V268.2zM300 80H40V260C40 271 31 280 20 280S0 271 0 260V60C0 49 9 40 20 40H300C311 40 320 49 320 60C320 71 311 80 300 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TimelineAreaChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TimelineAreaChart.displayName = "Blueprint5.Icon.TimelineAreaChart";
exports.default = TimelineAreaChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c9Q3e":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimelineBarChart", ()=>TimelineBarChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TimelineBarChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "timeline-bar-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 60H20C9 60 0 51 0 40C0 29 9 20 20 20H380C391 20 400 29 400 40C400 51 391 60 380 60zM180 80H220C231 80 240 89 240 100V360C240 371 231 380 220 380H180C169 380 160 371 160 360V100C160 89 169 80 180 80zM300 80H340C351 80 360 89 360 100V280C360 291 351 300 340 300H300C289 300 280 291 280 280V100C280 89 289 80 300 80zM60 80H100C111 80 120 89 120 100V220C120 231 111 240 100 240H60C49 240 40 231 40 220V100C40 89 49 80 60 80z" : "M160 80H180C191 80 200 89 200 100V280C200 291 191 300 180 300H160C149 300 140 291 140 280V100C140 89 149 80 160 80zM260 80H280C291 80 300 89 300 100V220C300 231 291 240 280 240H260C249 240 240 231 240 220V100C240 89 249 80 260 80zM300 60H40C29 60 20 51 20 40S29 20 40 20H300C311 20 320 29 320 40S311 60 300 60zM60 80H80C91 80 100 89 100 100V180C100 191 91 200 80 200H60C49 200 40 191 40 180V100C40 89 49 80 60 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TimelineBarChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TimelineBarChart.displayName = "Blueprint5.Icon.TimelineBarChart";
exports.default = TimelineBarChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bAHAl":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimelineEvents", ()=>TimelineEvents);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TimelineEvents = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "timeline-events",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100 300C112 300 120 308 120 320V360C120 370 112 380 100 380S80 370 80 360V320C80 308 88 300 100 300L100 300zM300 300C312 300 320 308 320 320V360C320 370 312 380 300 380S280 370 280 360V320C280 308 288 300 300 300L300 300zM120 120H80V80H120V120L120 120zM340 340V320C340 298 322 280 300 280S260 298 260 320V340H140V320C140 298 122 280 100 280S60 298 60 320V340H40C30 340 20 330 20 320V40C20 30 30 20 40 20H360C370 20 380 30 380 40V320C380 330 370 340 360 340H340zM140 60H60V140H140V60L140 60zM140 160H60V240H140V160L140 160zM240 60H160V140H240V60L240 60zM240 160H160V240H240V160L240 160zM340 60H260V140H340V60L340 60zM340 160H260V240H340V160L340 160zM220 120H180V80H220V120L220 120zM320 220H280V180H320V220L320 220z" : "M160 100H140V80H160V100L160 100zM80 100H60V80H80V100L80 100zM220 260C232 260 240 270 240 280V300C240 310 232 320 220 320S200 310 200 300V280C200 270 210 260 220 260L220 260zM80 260C90 260 100 270 100 280V300C100 310 90 320 80 320S60 310 60 300V280C60 270 70 260 80 260L80 260zM280 300H260V280C260 258 242 240 220 240S180 258 180 280V300H120V280C120 258 102 240 80 240S40 258 40 280V300H20C10 300 0 290 0 280V40C0 30 10 20 20 20H280C292 20 300 30 300 40V280C300 290 292 300 280 300L280 300zM100 60H40V120H100V60L100 60zM100 140H40V200H100V140L100 140zM180 60H120V120H180V60L180 60zM180 140H120V200H180V140L180 140zM260 60H200V120H260V60L260 60zM260 140H200V200H260V140L260 140zM240 180H220V160H240V180L240 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TimelineEvents.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TimelineEvents.displayName = "Blueprint5.Icon.TimelineEvents";
exports.default = TimelineEvents;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2WcVU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimelineLineChart", ()=>TimelineLineChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TimelineLineChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "timeline-line-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 80H40V111.8L140 211.8L205.8 146C209.4 142.2 214.4 140 220 140S230.6 142.2 234.2 145.8L374.2000000000001 285.8C377.8 289.4 380 294.4 380 300C380 311 371 320 360 320C354.4 320 349.4 317.8 345.8 314.2L220 188.2L154.2 254.2C150.6 257.8 145.6 260 140 260S129.4 257.8 125.8 254.2L40 168.2V340C40 351 31 360 20 360S0 351 0 340V60C0 57.2 0.6 54.6 1.6 52.2C4.6 45 11.8 40 20 40H380C391 40 400 49 400 60C400 71 391 80 380 80z" : "M300 80H40V131.8L100 191.8L165.8 126C169.4 122.2 174.4 120 180 120S190.6 122.2 194.2 125.8L314.2000000000001 245.8C317.8 249.4 320 254.4 320 260C320 271 311 280 300 280C294.4000000000001 280 289.4000000000001 277.8 285.8 274.2L180 168.2L114.2 234.2C110.6 237.8 105.6 240 100 240S89.4 237.8 85.8 234.2L40 188.2V260C40 271 31 280 20 280S0 271 0 260V60C0 49 9 40 20 40H300C311 40 320 49 320 60C320 71 311 80 300 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TimelineLineChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TimelineLineChart.displayName = "Blueprint5.Icon.TimelineLineChart";
exports.default = TimelineLineChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ckuZs":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tint", ()=>Tint);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Tint = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tint",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M197.2 360C197.2 360 79.6 216.4 79.6 156.6C79.8 92 135.6 40 199.2 40C262.8 40.2 320 92.6 319.8000000000001 157.2C319.8 219 197.2 360 197.2 360z" : "M157.6 300C157.6 300 59.6 174.4 59.6 122C59.8 65.6 106.4 20 159.4 20C212.4 20.2 260 66 260 122.6C259.8 176.6 157.6 300 157.6 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Tint.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Tint.displayName = "Blueprint5.Icon.Tint";
exports.default = Tint;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HAJo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Torch", ()=>Torch);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Torch = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "torch",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M139.4 20C139.4 9 148.4 0 159.4 0H239.4C250.4 0 259.4 9 259.4 20V60H139.4V20zM79.4 320L139.4 240V80H259.4000000000001V240L319.4000000000001 320C319.4000000000001 320 118 320 84.2 320C81 320 79.4 320 79.4 320zM179.4 220C179.4 231 188.4 240 199.4 240S219.4 231 219.4 220V180C219.4 169 210.4 160 199.4 160S179.4 169 179.4 180V220zM299.4000000000001 400H99.4C88.4 400 79.4 391 79.4 380V340H319.4000000000001V380C319.4000000000001 391 310.4 400 299.4000000000001 400z" : "M100 20C100 9 109 0 120 0H200C211 0 220 9 220 20V40H100V20zM240 320H80C69 320 60 311 60 300V280H260V300C260 311 251 320 240 320zM100 180V60H220V180L260 260H60L100 180zM140 180C140 191 149 200 160 200S180 191 180 180V140C180 129 171 120 160 120S140 129 140 140V180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Torch.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Torch.displayName = "Blueprint5.Icon.Torch";
exports.default = Torch;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g11cF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tractor", ()=>Tractor);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Tractor = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tractor",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M89.9923902 180C139.6938028 180 179.9847584 139.705628 179.9847584 90C179.9847584 40.294372 139.6938028 0 89.9923902 0C40.2909776 0 0.0000220142266 40.294372 0.0000220142266 90C0.0000220142266 139.705628 40.2909776 180 89.9923902 180zM319.972886 160C364.15192 160 399.966102 124.18278 399.966102 80C399.966102 35.81722 364.15192 0 319.972886 0C275.793854 0 239.97967 35.81722 239.97967 80C239.97967 124.18278 275.793854 160 319.972886 160zM89.9923902 128.571428C68.6917848 128.571428 51.4242324 111.302412 51.4242324 90C51.4242324 68.697588 68.6917848 51.428572 89.9923902 51.428572C111.2929956 51.428572 128.560548 68.697588 128.560548 90C128.560548 111.302412 111.2929956 128.571428 89.9923902 128.571428zM319.972886 106.666666C305.246542 106.666666 293.308482 94.727594 293.308482 80C293.308482 65.272406 305.246542 53.333334 319.972886 53.333334C334.699232 53.333334 346.637292 65.272406 346.637292 80C346.637292 94.727594 334.699232 106.666666 319.972886 106.666666zM119.9898462 400C149.189379 400 170.53383 386.63504464 179.9996426 360L197.0258602 274.8708958C225.682238 272.9553418000001 253.411966 270.5493466000001 279.962644 267.6439022L279.976278 360L319.972886 360L319.98631 262.7596812C339.225722 260.1543906 357.706394 257.2569058000001 375.3169400000001 254.0632516C390.8958760000001 251.2380278 399.966102 241.77407 399.966102 228.38137L400 139.981502C381.75131 164.230056 352.707318 179.913486 319.9955320000001 179.913486C271.608528 179.913486 231.24669 145.598012 221.978074 100.005344L199.5882618 99.98923C194.5389238 155.993926 147.4113552 199.882832 90.019736 199.882832C64.5594906 199.882832 41.119225 191.245432 22.4764964 176.744608L0.0790105396 176.731484L0.063593751 200.3299208C0.0490912502 220.2934266 0.0276726488 243.575603 0.0001100302818 253.4857346C-0.0329517234 265.4202890000001 7.38706966 277.0766346 19.97884766 279.529156L19.99832606 380C19.99832606 391.045695 28.952631 400 39.998326 400L119.9898462 400zM139.9881502 360L59.9949342 360L59.98 280L74.9634974 280C102.6971944 279.4658782 129.9567796 278.542019 156.5565024 277.2217932L139.9881502 360z" : "M70 140C108.6599324 140 140 108.659932 140 70C140 31.340068 108.6599324 0 70 0C31.3400676 0 0 31.340068 0 70C0 108.659932 31.3400676 140 70 140zM260 120C293.137084 120 320 93.137084 320 60C320 26.862916 293.137084 0 260 0C226.862916 0 200 26.862916 200 60C200 93.137084 226.862916 120 260 120zM70 100C53.4314576 100 40 86.568542 40 70C40 53.431458 53.4314576 40 70 40C86.5685424 40 100 53.431458 100 70C100 86.568542 86.5685424 100 70 100zM260 80C248.954306 80 240 71.045694 240 60C240 48.954306 248.954306 40 260 40C271.045694 40 280 48.954306 280 60C280 71.045694 271.045694 80 260 80zM100 320.0000000000002C129.202009 320.0000000000002 150.54827 306.63504464 160.0148854 280L176.309483 214.8927204C191.2516718 213.7629924 205.842658 212.4640316 220.023336 210.9937846L220 280L260 280L260.0242 206.2371444C273.978006 204.3487456 287.41948 202.2704826 300.280828 200C312.743876 197.799831 320 190.4296874 320 180L319.996168 112.929272C305.3386280000001 129.5364984 283.892892 140.0109176 260.000668 140.0109176C222.732866 140.0109176 191.4175366 114.525934 182.5322214 80.033138L159.9781648 80.021836L159.4597272 80.050608C154.4702914 125.0274894 116.3315056 160.0054588 70.0229928 160.0054588C48.4690998 160.0054588 28.6850604 152.4279864 13.1895982 139.7917082L0.0928907468 139.7771786L0.0818882496 156.3500616C0.070283221 172.2728114 0.0526798512 191.5319618 0.0297708454 199.5502534C-1.6e-12 210.0116132 7.5242821 220.1984798 20 220.1984798L20 300C20 311.045695 28.954305 320.0000000000002 40 320.0000000000002L100 320.0000000000002zM120 280L60 280L60 220.1984798C85.8001104 219.7147856 111.0873338 218.8206704 135.6280022 217.508016L120 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Tractor.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Tractor.displayName = "Blueprint5.Icon.Tractor";
exports.default = Tractor;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1F9x":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Train", ()=>Train);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Train = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "train",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 40H280L320 0H80C80 0 81 1 82.4 2.4C91.2 11.2 120 40 120 40H80C58 40 40 58 40 80V360C40 382 111.6 400 200 400S360 382 360 360L360 360V80C360 58 342 40 320 40zM110 100C126.6 100 140 113.4 140 130C140 146.6 126.6 160 110 160C93.4 160 80 146.6 80 130C80 113.4 93.4 100 110 100zM180 340H80V220H180V340zM320 340H220V220H320V340zM290 160C273.4 160 260 146.6 260 130C260 113.4 273.4 100 290 100C306.6 100 320 113.4 320 130C320 146.6 306.6 160 290 160z" : "M260 40H240L260 0H60L80 40H60C38 40 20 58 20 80V280C20 302 82.6 320 160 320S300 302 300 280V80C300 58 282 40 260 40zM220 80H260V120H220V80zM180 180H260V260H180V180zM60 80H100V120H60V80zM60 180H140V260H60V180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Train.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Train.displayName = "Blueprint5.Icon.Train";
exports.default = Train;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k3DCJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Translate", ()=>Translate);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Translate = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "translate",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M397.8 28.8L397.8 28.8L298 228.8L297.8 228.8C294.4000000000001 235.4 287.8 240 280 240S265.6 235.4 262.2 228.8L262 228.8L227.4 159.6L171.4 205.6L211.2 238.4000000000001L211.2 238.4000000000001C228.8 253.2 240 275.4 240 300V320H260C271 320 280 329 280 340C280 351 271 360 260 360H160V380C160 391 151 400 140 400S120 391 120 380V360H20C9 360 0 351 0 340C0 329 9 320 20 320H200V300C200 287.6 194.4 276.4 185.4 269.2L185.4 269.2L140 231.6L94.6 269.2L94.6 269.2C85.6 276.4 80 287.6 80 300H40C40 275.4 51.2 253.2 68.8 238.6L68.8 238.6L108.6 205.8L47.4 155.4L47.6 155.2C43 151.6 40 146.2 40 140C40 129 49 120 60 120C64.8 120 69 122 72.6 124.8L72.8 124.6L140 180L207.2 124.6L207.4 124.8C207.8 124.4 208.4 124.2000000000001 209 123.8C209.2 123.8 209.2 123.6 209.4 123.4L162.2 28.8L162.4 28.8C161 26.2 160 23.2 160 20C160 9 169 0 180 0C187.8 0 194.4 4.6 197.8 11.2L198 11.2L222.4 60H337.6L362 11L362.2 11C365.6 4.6 372.2 0 380 0C391 0 400 9 400 20C400 23.2 399 26.2 397.8 28.8zM242.4 100L280 175.2L317.6 100H242.4z" : "M317.8 28.8L317.8 28.8L238 188.8L237.8 188.8C234.4 195.4 227.8 200 220 200S205.6 195.4 202.2 188.8L202 188.8L180 144.8L143.4 172.4L148 176L148 176C167.4 190.6 180 213.8 180 240V260H200C211 260 220 269 220 280C220 291 211 300 200 300H140C140 311 131 320 120 320H100C89 320 80 311 80 300H20C9 300 0 291 0 280C0 269 9 260 20 260H140V240C140 226.8 133.6 215 123.6 207.8L123.6 207.8L110 197.6L96.4 207.6L96.4 207.6C86.4 215 80 226.8 80 240H40C40 213.8 52.6 190.6 72 176L72 176L76.6 172.6L28 136L28.2 135.8C23.4 132 20 126.6 20 120C20 109 29 100 40 100C44.6 100 48.4 101.8 51.8 104.2L52 104L110 147.4L162 108.4L122.2 28.8L122.4 28.8C121 26.2 120 23.2 120 20C120 9 129 0 140 0C147.8 0 154.4 4.6 157.8 11.2L158 11.2L172.4 40H267.6L282 11L282.2 11C285.6 4.6 292.2 0 300 0C311 0 320 9 320 20C320 23.2 319 26.2 317.8 28.8zM192.4 80L220 135.2L247.6 80H192.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Translate.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Translate.displayName = "Blueprint5.Icon.Translate";
exports.default = Translate;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jbXNV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trash", ()=>Trash);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Trash = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "trash",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 380H240C240 391 231 400 220 400H180C169 400 160 391 160 380H60C49 380 40 371 40 360V340H360V360C360 371 351 380 340 380zM350 320H50C44.4 320 40 315.6 40 310C40 304.4 44.4 300 50 300H60V20C60 9 69 0 80 0H320C331 0 340 9 340 20V300H350C355.6 300 360 304.4 360 310C360 315.6 355.6 320 350 320zM140 80C140 69 131 60 120 60S100 69 100 80V240C100 251 109 260 120 260S140 251 140 240V80zM220 80C220 69 211 60 200 60S180 69 180 80V240C180 251 189 260 200 260S220 251 220 240V80zM300 80C300 69 291 60 280 60S260 69 260 80V240C260 251 269 260 280 260S300 251 300 240V80z" : "M289.8 240.2H29.8C24.2 240.2 19.8 235.8 19.8 230.2S24.2 220.2 29.8 220.2H39.8V20.2C39.8 9.2 48.8 0.2 59.8 0.2H259.8C270.8 0.2 279.8 9.2 279.8 20.2V220.2H289.8C295.4 220.2 299.8 224.6 299.8 230.2S295.4 240.2 289.8 240.2zM119.8 60.2C119.8 49.2 110.8 40.2 99.8 40.2S79.8 49.2 79.8 60.2V180.2C79.8 191.2 88.8 200.2 99.8 200.2S119.8 191.2 119.8 180.2V60.2zM179.8 60.2C179.8 49.2 170.8 40.2 159.8 40.2S139.8 49.2 139.8 60.2V180.2C139.8 191.2 148.8 200.2 159.8 200.2S179.8 191.2 179.8 180.2V60.2zM239.8 60.2C239.8 49.2 230.8 40.2 219.8 40.2S199.8 49.2 199.8 60.2V180.2C199.8 191.2 208.8 200.2 219.8 200.2S239.8 191.2 239.8 180.2V60.2zM279.8 300.2H199.8C199.8 311.2 190.8 320.2 179.8 320.2H139.8C128.8 320.2 119.8 311.2 119.8 300.2H39.8C28.8 300.2 19.8 291.2 19.8 280.2V260.2H299.8V280.2C299.8 291.2 290.8 300.2 279.8 300.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Trash.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Trash.displayName = "Blueprint5.Icon.Trash";
exports.default = Trash;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5XDof":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tree", ()=>Tree);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Tree = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "tree",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 89.166668L220 0L180 0L180 89.166668L40 60L130 172.5L80 160L153.1034482 269.6551724L120 260L200 400L280 260L246.896552 269.6551724L320 160L270 172.5L360 60L220 89.166668z" : "M180 82.857142L180 0L140 0L140 82.857142L20 60L97.6963352 148.7958116L60 140L121.3861386 225.940594L100 220L160 320L220 220L198.6138614 225.940594L260 140L222.303664 148.7958116L300 60L180 82.857142z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Tree.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Tree.displayName = "Blueprint5.Icon.Tree";
exports.default = Tree;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"erZ1h":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrendingDown", ()=>TrendingDown);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TrendingDown = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "trending-down",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 200C369 200 360 191 360 180V152.6L235 293.2L234.8 293C231.2 297.2 226 300 220 300C215.4 300 211.6 298.2 208.2 295.8L208 296L139.4 244.4L31 316.6L30.8 316.4C27.8 318.4 24.2 320 20 320C9 320 0 311 0 300C0 293 3.8 287.2 9.2 283.6L9 283.4L129 203.4L129.2 203.8C132.2 201.6 135.8 200 140 200C144.6 200 148.4 201.8 151.8 204.2L152 204L217.2 253L335.4 120H300C289 120 280 111 280 100C280 89 289 80 300 80H380C391 80 400 89 400 100V180C400 191 391 200 380 200z" : "M300 180C289 180 280 171 280 160V148.2L194.2 234.2C190.6 237.8 185.6 240 180 240C176.8 240 173.8 239 171.2 237.8L171.2 238L100 202.4L29 237.8L29 237.6C26.2 239 23.2 240 20 240C9 240 0 231 0 220C0 212.2 4.6 205.6 11.2 202.2L11.2 202L91.2 162L91.2 162.2C93.8 161 96.8 160 100 160S106.2 161 108.8 162.2L108.8 162L176 195.6L251.8 120H240C229 120 220 111 220 100S229 80 240 80H300C311 80 320 89 320 100V160C320 171 311 180 300 180z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TrendingDown.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TrendingDown.displayName = "Blueprint5.Icon.TrendingDown";
exports.default = TrendingDown;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5sz08":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrendingUp", ()=>TrendingUp);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TrendingUp = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "trending-up",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 320H300C289 320 280 311 280 300C280 289 289 280 300 280H335.4L217.2 147L152 196L151.8 195.8C148.4 198.2 144.6 200 140 200C135.8 200 132.2 198.4 129.2 196.4L129 196.8L9 116.8L9.2 116.4C3.8 112.8 0 107 0 100C0 89 9 80 20 80C24.2 80 27.8 81.6 30.8 83.6L31 83.2L139.2 155.4L207.8 103.8L208 104C211.6 101.8 215.4 100 220 100C226 100 231.2 102.8 234.8 106.8L235 106.6L360 247.4V220C360 209 369 200 380 200S400 209 400 220V300C400 311 391 320 380 320z" : "M300 240H240C229 240 220 231 220 220S229 200 240 200H251.8L176 124.4L109 157.8L109 157.6C106.2 159 103.2 160 100 160S93.8 159 91.2 157.8L91.2 158L11.2 118L11.2 117.8C4.6 114.4 0 107.8 0 100C0 89 9 80 20 80C23.2 80 26.2 81 28.8 82.2L28.8 82L100 117.6L171 82L171 82.2C173.8 81 176.8 80 180 80C185.6 80 190.6 82.2 194.2 85.8L280 171.8V160C280 149 289 140 300 140S320 149 320 160V220C320 231 311 240 300 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TrendingUp.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TrendingUp.displayName = "Blueprint5.Icon.TrendingUp";
exports.default = TrendingUp;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eRBiI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trophy", ()=>Trophy);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Trophy = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "trophy",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100 380C100 391.04568 108.9544 400 120 400H280C291.046 400 300 391.0457 300 380V340H380C391.046 340 400 331.0456000000001 400 320V280C400 224.7716 355.228 180 300 180H291.68C278.826 150.582 252.226 128.542 220 122V40H280C291.046 40 300 31.046 300 20C300 8.954 291.046 0 280 0H120C108.9544 0 100 8.954 100 20C100 31.046 108.9544 40 120 40H180V122C147.7734 128.542 121.1746 150.582 108.3208 180H100C44.7716 180 0 224.7716 0 280V320C0 331.0456000000001 8.9543 340 20 340H100V380zM100 300H40V280C40 246.863 66.863 220 100 220V300zM300 220V300H360V280C360 246.863 333.1380000000001 220 300 220z" : "M80 301.66666C80 311.79188 88.2082 320 98.3334 320H221.666C231.7920000000001 320 240 311.79188 240 301.66666V280H300C311.046 280 320 271.0456 320 260V240C320 187.9948 280.302 145.2616 229.556 140.4508C218.98 121.89 201.188 107.974 180 102.52V40H220C231.046 40 240 31.046 240 20C240 8.954 231.046 0 220 0H100C88.9544 0 80 8.954 80 20C80 31.046 88.9544 40 100 40H140V102.52C118.8114 107.974 101.0202 121.89 90.4438 140.4508C39.698 145.2616 0 187.9948 0 240V260C0 271.0456 8.9543 280 20 280H80V301.66666zM80 240H40C40 213.8756 56.6962 191.6508 80 183.4142V240zM240 183.4142V240H280C280 213.8756 263.3040000000001 191.6508 240 183.4142z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Trophy.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Trophy.displayName = "Blueprint5.Icon.Trophy";
exports.default = Trophy;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6eh5m":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Truck", ()=>Truck);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Truck = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "truck",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 400C331.0456940000001 400 340 391.045695 340 380L340 160C351.0456940000001 160 360 151.045694 360 140L360 80L370 80C375.522848 80 380 75.522848 380 70L380 50C380 44.477152 375.522848 40 370 40L340 40L340 20C340 8.954306 331.0456940000001 0 320 0L300 0C288.9543060000001 0 280 8.954306 280 20L280 40L120 40L120 20C120 8.954306 111.045695 0 100 0L80 0C68.954305 0 60 8.954306 60 20L60 40L30 40C24.4771526 40 20 44.477152 20 50L20 70C20 75.522848 24.4771526 80 30 80L40 80L40 140C40 151.045694 48.954305 160 60 160L60 380C60 391.045695 68.954305 400 80 400C91.045695 400 100 391.045695 100 380L100 320C100 342.09139 117.90861 360 140 360L260 360C282.09139 360 300 342.09139 300 320L300 380C300 391.045695 308.9543060000001 400 320 400zM240 200L160 200C148.954305 200 140 191.045694 140 180L140 180L140 100C140 88.954306 148.954305 80 160 80L160 80L240 80C251.045694 80 260 88.954306 260 100L260 100L260 180C260 191.045694 251.045694 200 240 200L240 200zM100 120L80 120C68.954305 120 60 111.045694 60 100C60 88.954306 68.954305 80 80 80L80 80L100 80C111.045695 80 120 88.954306 120 100C120 111.045694 111.045695 120 100 120L100 120zM320 120L300 120C288.9543060000001 120 280 111.045694 280 100C280 88.954306 288.9543060000001 80 300 80L300 80L320 80C331.0456940000001 80 340 88.954306 340 100C340 111.045694 331.0456940000001 120 320 120L320 120zM230 120C235.522848 120 240 115.522848 240 110C240 104.477152 235.522848 100 230 100L230 100L170 100L168.2024874 100.161114C163.5375032 101.007832 160 105.090802 160 110C160 115.522848 164.4771526 120 170 120L170 120zM230 150C235.522848 150 240 145.522848 240 140C240 134.477152 235.522848 130 230 130L230 130L170 130L168.2024874 130.161114C163.5375032 131.007832 160 135.090802 160 140C160 145.522848 164.4771526 150 170 150L170 150zM230 180C235.522848 180 240 175.522848 240 170C240 164.477152 235.522848 160 230 160L230 160L170 160L168.2024874 160.161114C163.5375032 161.007832 160 165.090802 160 170C160 175.522848 164.4771526 180 170 180L170 180zM280 300L120 300L120 240L280 240L280 300z" : "M250 320C255.522848 320 260 315.5228475 260 310L260 140C271.045694 140 280 131.045695 280 120L280 80L290 80C295.522848 80 300 75.522848 300 70L300 50C300 44.477152 295.522848 40 290 40L260 40L260 20C260 8.954306 251.045694 0 240 0C228.954306 0 220 8.954306 220 20L220 40L100 40L100 20C100 8.954306 91.045695 0 80 0C68.954305 0 60 8.954306 60 20L60 40L30 40C24.4771526 40 20 44.477152 20 50L20 70C20 75.522848 24.4771526 80 30 80L40 80L40 120C40 131.045695 48.954305 140 60 140L60 310C60 315.5228475 64.4771526 320 70 320C75.5228474 320 80 315.5228475 80 310L80 260C80 282.09139 97.90861 300 120 300L200 300C222.09139 300 240 282.09139 240 260L240 310C240 315.5228475 244.477152 320 250 320zM180 160L140 160C128.954305 160 120 151.045695 120 140L120 140L120 100C120 88.954306 128.954305 80 140 80L140 80L180 80C191.045695 80 200 88.954306 200 100L200 100L200 140C200 151.045695 191.045695 160 180 160L180 160zM250 100L230 100C224.477152 100 220 95.522848 220 90C220 84.477152 224.477152 80 230 80L230 80L250 80C255.522848 80 260 84.477152 260 90C260 95.522848 255.522848 100 250 100L250 100zM90 100L70 100C64.4771526 100 60 95.522848 60 90C60 84.477152 64.4771526 80 70 80L70 80L90 80C95.5228474 80 100 84.477152 100 90C100 95.522848 95.5228474 100 90 100L90 100zM180 140C185.5228474 140 190 135.5228474 190 130L190 130L190 110L189.8388866 108.202488C188.9921674 103.537504 184.9091978 100 180 100L180 100L140 100L138.2024874 100.161114C133.5375032 101.007832 130 105.090802 130 110L130 110L130 130L130.1611134 131.7975126C131.0078326 136.4624968 135.0908022 140 140 140L140 140zM220 240L100 240L100 200L220 200L220 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Truck.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Truck.displayName = "Blueprint5.Icon.Truck";
exports.default = Truck;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dSHoO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TwoColumns", ()=>TwoColumns);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var TwoColumns = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "two-columns",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100 400H20C9 400 0 391 0 380V20C0 9 9 0 20 0H100C111 0 120 9 120 20V380C120 391 111 400 100 400zM394.2000000000001 214.2L334.2000000000001 274.2000000000001C330.6 277.8 325.6 280 320 280C309 280 300 271 300 260V140C300 129 309 120 320 120C325.6 120 330.6 122.2 334.2000000000001 125.8L394.2000000000001 185.8C397.8 189.4 400 194.4 400 200C400 205.6 397.8 210.6 394.2000000000001 214.2zM240 400H160C149 400 140 391 140 380V20C140 9 149 0 160 0H240C251 0 260 9 260 20V380C260 391 251 400 240 400z" : "M79.8 320.2H19.8C8.8 320.2 -0.2 311.2 -0.2 300.2V20.2C-0.2 9.2 8.8 0.2 19.8 0.2H79.8C90.8 0.2 99.8 9.2 99.8 20.2V300.2C99.8 311.2 90.8 320.2 79.8 320.2zM314 174.2L274 214.2C270.4 217.8 265.4 220 259.8 220C248.8 220 239.8 211 239.8 200V120C239.8 109 248.8 100 259.8 100C265.4 100 270.4 102.2 274 105.8L314 145.8C317.6 149.4 319.8 154.4 319.8 160S317.6 170.6 314 174.2zM199.8 320.2H139.8C128.8 320.2 119.8 311.2 119.8 300.2V20.2C119.8 9.2 128.8 0.2 139.8 0.2H199.8C210.8 0.2 219.8 9.2 219.8 20.2V300.2C219.8 311.2 210.8 320.2 199.8 320.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
TwoColumns.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
TwoColumns.displayName = "Blueprint5.Icon.TwoColumns";
exports.default = TwoColumns;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fQXhB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Unarchive", ()=>Unarchive);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Unarchive = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "unarchive",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M328.676192 400C335.70145 400 342.211586 396.31402332 345.82605 390.2899151L400 300L400 20C400 8.954306 391.0456940000001 0 380 0L20 0C8.954305 0 0 8.954306 0 20L0 300L54.173949 390.2899151C57.788414 396.31402332 64.2985506 400 71.3238076 400L328.676192 400zM200 240C194.4 240 189.4 237.8 185.8 234.2L185.8 234.2L125.8 174.2L124.1203704 172.287038C121.5277778 168.916666 120 164.666666 120 160C120 149 129 140 140 140C145.6 140 150.6 142.2 154.2 145.8L154.2 145.8L180 171.8L180 80.2L180.135204 77.87602C181.2959184 67.960204 189.7857142 60.2000000000001 200 60.2000000000001C211 60.2000000000001 220 69.2000000000001 220 80.2L220 80.2L220 171.8L245.8 146L247.42624 144.53411C250.840816 141.763266 255.2 140 260 140C271 140 280 149 280 160C280 165.6 277.8 170.6 274.2000000000001 174.2L274.2000000000001 174.2L214.2 234.2L212.287038 235.8796296C208.916666 238.4722222 204.666666 240 200 240zM320 360L80 360L40 299.9675252L360 299.9675252L320 360z" : "M267.63932 320C275.214762 320 282.140024 315.71995248 285.527864 308.9442719L320 240L320 20C320 8.954306 311.045694 0 300 0L20 0C8.954305 0 0 8.954306 0 20L0 240L34.472136 308.9442719C37.8599762 315.71995248 44.7852386 320 52.3606798 320L267.63932 320zM160 200C154.4 200 149.4 197.8 145.8 194.2L145.8 194.2L105.8 154.2L104.1203704 152.287037C101.5277778 148.9166666 100 144.6666666 100 140C100 129 109 120 120 120C125.6 120 130.6 122.2 134.2 125.8L134.2 125.8L140 131.8L140 80L140.135204 77.67602C141.2959184 67.760204 149.7857142 60 160 60C171 60 180 69 180 80L180 80L180 131.8L185.8 126L187.426239 124.471137C190.8408164 121.6163266 195.2 120 200 120C211 120 220 129 220 140C220 145.6 217.8 150.6 214.2 154.2L214.2 154.2L174.2 194.2L172.287037 195.8796296C168.9166666 198.4722222 164.6666666 200 160 200zM260 280L60 280L40 240L280 240L260 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Unarchive.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Unarchive.displayName = "Blueprint5.Icon.Unarchive";
exports.default = Unarchive;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6NsLr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Underline", ()=>Underline);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Underline = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "underline",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 60C266 60 320 114 320 180V330C320 346 306 360 290 360C274 360 260 346 260 330V180C260 146 234 120 200 120S140 146 140 180V330C140 346 126 360 110 360C94 360 80 346 80 330V180C80 114 134 60 200 60zM330 20H70C64 20 60 16 60 10C60 4 64 0 70 0H330C336 0 340 4 340 10C340 16 336 20 330 20z" : "M160 40C216 40 260 84 260 140V260C260 272 252 280 240 280C228 280 220 272 220 260V140C220 106 194 80 160 80S100 106 100 140V260C100 272 92 280 80 280C68 280 60 272 60 260V140C60 84 104 40 160 40zM270 20H50C44 20 40 16 40 10C40 4 44 0 50 0H270C276 0 280 4 280 10C280 16 276 20 270 20z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Underline.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Underline.displayName = "Blueprint5.Icon.Underline";
exports.default = Underline;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"79IDH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Undo", ()=>Undo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Undo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "undo",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M100 120C78 120 60 102 60 80C60 58 78 40 100 40S140 58 140 80C140 102 122 120 100 120zM280 300H68.2L114 345.8C117.8 349.4 120 354.4 120 360C120 371 111 380 100 380C94.4 380 89.4 377.8 85.8 374.2L5.8 294.2C2.2 290.6 0 285.6 0 280C0 274.4 2.2 269.4 5.8 265.8L85.8 185.8C89.4 182.2 94.4 180 100 180C111 180 120 189 120 200C120 205.6 117.8 210.6 114.2 214.2L68.2 260H280C324.2000000000001 260 360 224.2 360 180C360 135.8 324.2000000000001 100 280 100H180V60H280C346.2 60 400 113.8 400 180S346.2 300 280 300z" : "M80 100C58 100 40 82 40 60S58 20 80 20S120 38 120 60S102 100 80 100zM220 240H68.2L94 265.8C97.8 269.4 100 274.4 100 280C100 291 91 300 80 300C74.4 300 69.4 297.8 65.8 294.2L5.8 234.2C2.2 230.6 0 225.6 0 220C0 214.4 2.2 209.4 5.8 205.8L65.8 145.8C69.4 142.2 74.4 140 80 140C91 140 100 149 100 160C100 165.6 97.8 170.6 94.2 174.2L68.2 200H220C253.2 200 280 173.2 280 140S253.2 80 220 80H140V40H220C275.2 40 320 84.8 320 140S275.2 240 220 240z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Undo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Undo.displayName = "Blueprint5.Icon.Undo";
exports.default = Undo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6mQWy":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UngroupObjects", ()=>UngroupObjects);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var UngroupObjects = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "ungroup-objects",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M90 280C40.2 280 0 239.8 0 190S40.2 100 90 100S180 140.2 180 190S139.8 280 90 280zM310 280C260.2 280 220 239.8 220 190S260.2 100 310 100S400 140.2 400 190S359.8 280 310 280z" : "M70 220C31.4 220 0 188.6 0 150S31.4 80 70 80S140 111.4 140 150S108.6 220 70 220zM250 220C211.4 220 180 188.6 180 150S211.4 80 250 80S320 111.4 320 150S288.6 220 250 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
UngroupObjects.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
UngroupObjects.displayName = "Blueprint5.Icon.UngroupObjects";
exports.default = UngroupObjects;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gBBTq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnknownVehicle", ()=>UnknownVehicle);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var UnknownVehicle = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "unknown-vehicle",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260 160.231934V240.239258H80V260.239258L100 320.2417H220V359.935302C213.673096 360.109862 207.087402 360.230712 200 360.230712C128.148194 360.230712 93.359376 350.478514 93.359376 350.478514C79.94751 346.71753 64.880372 333.1958 59.874268 320.424804L59.802246 320.2417H60C60 320.2417 50 290.238038 40 260.239258H20C8.953858 260.239258 0 251.2854 0 240.239258C0 229.194336 8.953858 220.238038 20 220.238038H26.66626C24.194336 212.819826 22.198486 206.835938 21.064454 203.433838C20.379638 201.375732 20 200.238038 20 200.238038V50.233156C20 33.6645520000001 33.431396 20.2319360000001 50 20.2319360000001C66.567382 20.2319360000001 80 33.6645540000001 80 50.233156V60.233156H320V50.233156C320 33.6645520000001 333.431396 20.2319360000001 350 20.2319360000001C366.567382 20.2319360000001 380 33.6645540000001 380 50.233156V140.2319360000001H280C268.953858 140.231934 260 149.185792 260 160.231934zM90 140.235596C73.431396 140.235596 60 153.668214 60 170.236816S73.431396 200.238036 90 200.238036C106.567382 200.238036 120 186.805418 120 170.236816S106.567382 140.235596 90 140.235596zM396.585694 344.351806C394.206544 350.450438 390.263672 356.140136 384.753418 361.42456C379.2395019999999 366.705322 371.968994 371.121826 362.944336 374.672852C353.9147940000001 378.225098 342.6538080000001 380 329.161376 380C318.706054 380 309.249266 378.314208 300.794676 374.94629C292.335204 371.574708 285.1147440000001 366.888428 279.128416 360.878908C273.140868 354.868166 268.481444 347.766116 265.15869 339.571534C261.831054 331.375734 260.0708 322.36084 259.884032 312.526856H301.79199C301.79199 317.443848 302.362058 322.041016 303.503416 326.322022C304.643552 330.5993660000001 306.398924 334.333496 308.776854 337.521974C311.151122 340.706788 314.194334 343.259278 317.90039 345.1709C321.606444 347.0837420000001 326.0253899999999 348.039552 331.157226 348.039552C338.756102 348.039552 344.698486 346.032716 348.974608 342.03003C353.250732 338.02124 355.389402 331.828614 355.389402 323.45337C355.57617 318.536378 354.676512 314.439698 352.680662 311.16089C350.686034 307.883302 348.070066 304.877932 344.8413060000001 302.145998C341.607664 299.415286 338.092038 296.683352 334.2932100000001 293.951418C330.4882780000001 291.219484 326.8798800000001 287.984622 323.45947 284.2541520000001C320.03784 280.5188000000001 317.044676 276.0119640000001 314.4787580000001 270.7324240000001C311.91284 265.4480000000001 310.345458 258.8916040000001 309.775388 251.063234V238.770754H348.2617160000001V249.151614C349.0197720000001 254.6154820000001 350.8728 259.1650420000001 353.8220180000001 262.810062C356.7663540000001 266.45142 360.1379360000001 269.6826200000001 363.9416460000001 272.5073280000001C367.7416940000001 275.3295940000001 371.782222 278.150638 376.0583460000001 280.9765660000001C380.33569 283.79761 384.228512 287.2119180000001 387.7478 291.219486C391.262204 295.2233920000001 394.20654 300.0512740000001 396.58569 305.6982460000001C398.9599580000001 311.3403360000001 400.148922 318.53638 400.148922 327.2790560000001C400.148926 332.558594 398.95996 338.248292 396.585694 344.351806zM305.7836920000001 222.380372V180.3125H350.543214V222.380372H305.7836920000001z" : "M210.148926 125V195C210.148926 196.774902 210.593262 198.425292 211.159668 200.006104H60.151368C56.63086 200.006104 58.93921 216.486816 60.151368 220.006104L74.735108 252.615968C75.95337 256.138918 76.633302 260.007326 80.151368 260.007326H170.148926V299.801026C166.82251 299.8693840000001 163.737792 299.99878 160.150146 299.99878C105.749512 299.99878 79.4104 291.966554 79.4104 291.966554C69.25537 288.86841 57.84912 277.734376 54.057616 267.215578L38.796386 224.876708H17.747802C8.070068 224.876708 0.148926 216.42578 0.148926 206.099852C0.148926 195.770262 8.070068 187.319334 17.747802 187.319334H25.256346L20.152586 180.00488C19.473876 166.304928 20.152586 151.274412 20.152586 140.00366V40.001218C20.152588 26.85669 27.834472 20 40.151368 20C52.475586 20 60.151368 26.85669 60.151368 40.00122V60.00122H260.145264V40.00122C260.145264 26.856688 267.825928 20 280.145264 20S300.144044 26.85669 300.144044 40.00122V110H225.148926C216.865234 110 210.148926 116.715088 210.148926 125zM100.150146 120.003662H60.151366V160.004882H100.150146V120.003662zM320.148926 206.102294V206.098632L320.150146 206.099852C320.150146 206.101074 320.148926 206.101074 320.148926 206.102294zM306.783448 303.474122C302.066652 308.24585 295.84961 312.23755 288.1311040000001 315.446778C280.4101560000001 318.656006 270.77881 320.26001 259.2407240000001 320.26001C250.299074 320.26001 242.2119160000001 318.736572 234.9816900000001 315.69336C227.7465820000001 312.646484 221.571046 308.411866 216.4514160000001 302.980958S207.3474120000001 291.131592 204.5043940000001 283.725586C201.8310540000001 276.768798 200.4492180000001 269.0979 200.1489260000001 260.83252V260H235.9179680000001C235.9704580000001 264.157714 236.3781740000001 268.105468 237.2973620000001 271.75293C238.2727040000001 275.617676 239.7729480000001 278.9929200000001 241.8078600000001 281.87378C243.8378900000001 284.752198 246.4404280000001 287.058106 249.6093740000001 288.786622C252.7795400000001 290.513916 256.5588360000001 291.378174 260.9472640000001 291.378174C267.4462880000001 291.378174 272.5280740000001 289.56543 276.1853020000001 285.947266C279.8425280000002 282.32544 281.6711420000001 276.728516 281.6711420000001 269.161378C281.8310540000001 264.7180180000001 281.0607900000001 261.014406 279.3542480000001 258.05298C277.6477060000001 255.090334 275.4113760000001 252.37427 272.6501460000001 249.906008C269.8840320000001 247.437746 266.8786620000001 244.969484 263.6291500000001 242.501222C260.3747560000001 240.03174 257.2900380000001 237.108156 254.3640140000001 233.736574C251.4379880000001 230.36255 248.8781740000001 226.289064 246.6833500000001 221.517336C244.4897460000001 216.741946 243.1481940000001 210.817874 242.6611340000001 203.743898V200H275.5749520000001V202.016602C276.2231460000001 206.953126 277.8076180000001 211.064454 280.3295900000001 214.359132C282.8479000000001 217.648926 285.7312020000001 220.568848 288.9843760000001 223.12256C292.2351080000001 225.671388 295.6896980000001 228.221436 299.3469240000001 230.775148C303.0041500000001 233.323976 306.3342280000001 236.409914 309.3432620000001 240.03174C312.3486340000001 243.649904 314.8669440000001 248.012698 316.9006360000002 253.115236C318.9318860000002 258.214112 319.9487320000001 264.71802 319.9487320000001 272.61719C319.9487320000001 277.387698 318.9318860000002 282.53052 316.9006360000002 288.045656C314.866944 293.557128 311.495362 298.69873 306.783448 303.474122zM240.148926 180V140H280.148926V180H240.148926z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
UnknownVehicle.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
UnknownVehicle.displayName = "Blueprint5.Icon.UnknownVehicle";
exports.default = UnknownVehicle;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0TLKI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Unlink", ()=>Unlink);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Unlink = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "unlink",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 400C364.2000000000001 400 400 364.2 400 320C400 297.8 390.8 278.2 376.4 263.6L376.6 263.4L316.6 203.4L316.4 203.6C305.212 192.566 291.0900000000001 184.586 275.112 181.458L256.484 200.0842L348.2 291.8C355.6 299 360 309 360 320C360 342 342 360 320 360C309 360 299 355.6 291.8 348.4L199.9842 256.5842L181.457 275.1114C184.5854 291.0902 192.5662 305.2128 203.6 316.4L203.4 316.6L263.4 376.6L263.6 376.4C278.2 390.8 297.8 400 320 400zM214.084 242.4842L242.484 214.0842L294.2000000000001 265.8C297.8 269.4 300 274.4 300 280C300 291 291 300 280 300C274.4000000000001 300 269.4000000000001 297.8 265.8 294.2L214.084 242.4842zM171.6578 200.0578L105.8 134.2000000000001C102.2 130.6 100 125.6 100 120C100 109 109 100 120 100C125.6 100 130.6 102.2 134.2 105.8L200.058 171.658L214.158 157.558L128.2 71.6L108.2 51.6C101 44.4 91 40 80 40C58 40 40 58 40 80C40 91 44.4 101 51.8 108.2L157.6578 214.0578L171.6578 200.0578zM152.9716 218.744L65.8578 305.8578C58.0474 313.6684 58.0474 326.3316 65.8578 334.1422C73.6684 341.9526 86.3316 341.9526 94.1422 334.1422L334.142 94.142C341.952 86.332 341.952 73.668 334.142 65.858C326.332 58.048 313.668 58.048 305.858 65.858L218.732 152.982C219.528 148.792 220 144.514 220 140C220 117.8 210.8 98.2 196.4 83.6L196.6 83.4L136.6 23.4L136.4 23.6C121.8 9.2 102.2 0 80 0C35.8 0 0 35.8 0 80C0 102.2 9.2 121.8 23.6 136.4L23.4 136.6L83.4 196.6L83.6 196.4C98.2 210.8 117.8 220 140 220C144.4928 220 148.7518 219.5328 152.9716 218.744z" : "M239.95 319.8999786C284.122 319.8999786 319.9 284.1224 319.9 239.95C319.9 217.7638 310.706 198.176 296.116 183.785L296.514 183.3852L276.528 163.3978L276.128 163.7976C265.124 152.6404 250.964 144.6386 235.078 141.4904L216.498 160.0714L248.146 191.98L268.132 211.9674L267.932 212.1674C275.128 219.3628 279.926 229.1566000000001 279.926 240.1498C279.926 262.136 261.936 280.1248 239.95 280.1248C228.9580000000001 280.1248 219.164 275.3278 211.968 268.1324L211.768 268.3322L160.002 216.5664L141.5118 235.0566C144.7036 250.9506 152.7886 265.1182 163.7978 276.1274L163.398 276.527L183.3856 296.5146L183.7852 296.1148C198.1764 310.70572 217.964 319.8999786 239.95 319.8999786zM45.8578 274.1422C53.6682 281.9526 66.3314 281.9526 74.142 274.1422L274.142 74.142C281.952 66.332 281.952 53.668 274.142 45.858C266.332 38.048 253.668 38.048 245.858 45.858L178.713 113.002C179.513 108.76 179.9876 104.438 179.9876 100.038C179.9876 78.052 170.7932 58.264 156.2024 43.872L156.6022 43.474L136.6146 23.486L136.2148 23.886C121.8238 9.294 102.0362 0.1 80.05 0.1C35.8776 0.1 0.0999376 35.878 0.0999376 80.05C0.0999376 102.036 9.29418 121.8242 23.885 136.2152L23.4854 136.615L43.4728 156.6024L43.8726 156.2028C58.2636 170.7936 78.0512 179.9878 100.0374 179.9878C104.502 179.9878 108.8128 179.5262 113.0174 178.6982L45.8578 245.858C38.0472 253.6684 38.0472 266.3318 45.8578 274.1422zM160.0488 131.6668L174.14 117.576L108.2324 51.668L108.0324 51.868C100.837 44.672 91.0432 39.876 80.05 39.876C58.0638 39.876 40.075 57.864 40.075 79.85C40.075 90.844 44.872 100.638 52.0674 107.832L51.8676 108.032L117.7752 173.9404L131.6666 160.049L85.8462 114.228C82.2486 110.63 80.0498 105.634 80.0498 100.038C80.0498 89.044 89.0442 80.05 100.0374 80.05C105.6338 80.05 110.6308 82.248 114.2286 85.846L160.0488 131.6668zM174.0932 202.4754L202.476 174.0932L234.154 205.7714C237.752 209.3692 239.95 214.366 239.95 219.9626C239.95 230.9556 230.956 239.95 219.962 239.95C214.366 239.95 209.37 237.7514 205.772 234.1536L174.0932 202.4754z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Unlink.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Unlink.displayName = "Blueprint5.Icon.Unlink";
exports.default = Unlink;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lWJlu":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Unlock", ()=>Unlock);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Unlock = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "unlock",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 380C235.8 380 200 344.2 200 300V220H40C29 220 20 211 20 200V40C20 29 29 20 40 20H280C291 20 300 29 300 40V200C300 211 291 220 280 220H240V300C240 322 258 340 280 340S320 322 320 300V260C320 249 329 240 340 240S360 249 360 260V300C360 344.2 324.2000000000001 380 280 380z" : "M239.8 320.2C195.6 320.2 159.8 284.4 159.8 240.2V180.2H19.8C8.8 180.2 -0.2 171.2 -0.2 160.2V20.2C-0.2 9.2 8.8 0.2 19.8 0.2H259.8C270.8 0.2 279.8 9.2 279.8 20.2V160.2C279.8 171.2 270.8 180.2 259.8 180.2H199.8V240.2C199.8 262.2 217.8 280.2 239.8 280.2S279.8 262.2 279.8 240.2V220.2C279.8 209.2 288.8 200.2 299.8 200.2S319.8 209.2 319.8 220.2V240.2C319.8 284.4 284 320.2 239.8 320.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Unlock.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Unlock.displayName = "Blueprint5.Icon.Unlock";
exports.default = Unlock;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3KD60":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Unpin", ()=>Unpin);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Unpin = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "unpin",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M235.4 376.8C219.2 360.6 220.6 331.2000000000001 235.8 301.6L122 225.8C78.6 255 39.6 265.8 23.2 249.4L122.2 150.4L79.8 79.6L150.6 122L249.6 23.0000000000001C266 39.4 255 78.4 225.8 121.8000000000001L301.8 235.6000000000001C331.2 220.4000000000001 360.6 218.8000000000001 377 235.2000000000001L235.4 376.8z" : "M187.8 300C177.8 290 179.8 270.4 190.8 249.4L87.6 169.2C57 190 30.4 198.6 20 188.2L90 118.2C89.6 117.8 62 62.2 62 62.2L118 90.2L188 20.2C198.6 30.8 190 57.4 169 87.8L249.4 191C270.2 180 289.6 178 299.6 188.2L187.8 300z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Unpin.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Unpin.displayName = "Blueprint5.Icon.Unpin";
exports.default = Unpin;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jVuzR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Unresolve", ()=>Unresolve);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Unresolve = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "unresolve",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M229.4 150.8C232.6 158 235.2 165.6 237.0000000000001 173.6C237.0000000000001 174 237.2 174.4 237.2 174.8C239 182.8 240 191.2 240 200C240 208.8 239 217.2 237.2 225.4C237.2 225.8 237 226.2 237 226.6C235.2 234.6 232.6 242.2 229.4 249.4C229.2 249.8 229 250 229 250.4C225.6 257.6 221.6 264.6 216.8 271C216.8 271.2 216.6 271.2 216.6 271.4C205.4 286 191.2 298.2 174.6 306.8C174.6 306.8 174.6 306.8 174.6 306.8C174.6 306.8 174.6 306.8 174.6 306.8C170.8 308.8 166.8 310.4 162.8 312C162.2 312.2 161.6 312.4 160.8 312.6C157.4 314 154 315 150.4 316C149.4 316.2 148.4 316.6 147.4 316.8C144 317.6 140.6 318.2 137 318.6C136 318.8 134.8 319 133.6 319.2C129.2 319.6 124.6 320 120 320C53.8 320 0 266.2000000000001 0 200S53.8 80 120 80C124.6 80 129.2 80.4 133.6 80.8C134.8 81 135.8 81.2 137 81.4C140.4 81.8 143.8 82.6 147.2 83.2C148.2 83.4 149.2 83.8 150.2 83.9999999999999C153.8 84.9999999999999 157.4 85.9999999999999 160.8 87.4C161.4 87.6 162 87.8 162.6 87.9999999999999C184.2 96.1999999999999 202.8 110.6 216.2 128.8C216.2 129 216.4 129 216.4 129.1999999999999C221.2 135.6 225.2 142.4 228.6 149.7999999999999C229 150 229.2 150.4 229.4 150.8zM280 320C260.2 320 241.8 315.2 225.4 306.8C252.8 279.6 270 241.8 270 200C270 158.2 252.8 120.4 225.4 93.2C241.8 84.8 260.2 80 280 80C346.2 80 400 133.8 400 200C400 266.2 346.2 320 280 320z" : "M220 260C209 260 198.6 258.2 188.6 254.8C214 231.2 230 197.4 230 160C230 122.6 214 88.8 188.6 65.2C198.6 61.8 209 60 220 60C275.2 60 320 104.8 320 160C320 215.2 275.2 260 220 260zM195.6 132.4C196.2 134.2 196.8 136 197.4 137.8C199 145 200 152.4 200 160S199 175 197.4 182.2C196.8 184 196.2 185.8 195.6 187.6C194 193 192.2 198.4 189.8 203.4C189 204.8 188.2 206.2 187.4 207.6C184.6 213 181.2 218 177.2 222.8C176.8 223.4 176.2 224.2 175.6 224.8C170.8 230.2 165.8 235.2 160 239.6L160 239.6L160 239.6C151.4 246 141.6 251.2 131 254.6C131 254.6 131.2 254.8 131.2 254.8C129.2 255.4 127.2 255.8 125.2 256.4C122.8 257 120.6 257.8 118 258.2C112.2 259.2 106.2 260 100 260C44.8 260 0 215.2 0 160C0 104.8 44.8 60 100 60C106.2 60 112.2 60.8 118 61.8C120.4 62.2 122.8 63 125.2 63.6C127.2 64.2 129.4 64.4 131.2 65.2C131.2 65.2 131 65.4 131 65.4C148.6 71.2 163.8 81.4 175.4 95.2C176 95.8 176.6 96.6 177.2 97.2C181 102 184.4 107 187.4 112.4C188.2 113.8 189 115.2 189.6 116.6C192.2 121.6 194.2 127 195.6 132.4z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Unresolve.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Unresolve.displayName = "Blueprint5.Icon.Unresolve";
exports.default = Unresolve;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ejK5Z":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Updated", ()=>Updated);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Updated = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "updated",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C134.2 400 76.4 368 40 319L40 360C40 371 31 380 20 380C9 380 0 371 0 360L0 280C0 269 9 260 20 260L100 260C111 260 120 269 120 280C120 291 111 300 100 300L75.2 300C104.4 336.6 149.4 360 200 360C288.4 360 360 288.4 360 200C360 111.6 288.4 40 200 40C111.6 40 40 111.6 40 200C40 211 31 220 20 220C9 220 0 211 0 200C0 89.6 89.6 0 200 0C310.4 0 400 89.6 400 200C400 310.4 310.4 400 200 400zM280 260C274.4000000000001 260 269.4000000000001 257.8 265.8 254.2L180 168.4L134.2 214.2C130.6 217.8 125.6 220 120 220C109 220 100 211 100 200C100 194.4 102.2 189.4 105.8 185.8L165.8 125.8C169.4 122.2 174.4 120 180 120C185.6 120 190.6 122.2 194.2 125.8L294.2000000000001 225.8C297.8 229.4 300 234.4 300 240C300 251 291 260 280 260z" : "M160 320C112 320 69.2 298.6 40 265.2L40 300C40 311 31 320 20 320C9 320 0 311 0 300L0 220C0 209 9 200 20 200L100 200C111 200 120 209 120 220C120 231 111 240 100 240L70.8 240C92.8 264.4 124.4 280 160 280C226.2 280 280 226.2 280 160C280 107.8 246.6 63.8 200 47.4C187.4 43 174.2 40 160 40C93.8 40 40 93.8 40 160C40 171 31 180 20 180C9 180 0 171 0 160C0 71.6 71.6 0 160 0C166.8 0 173.4 0.6 180 1.4C180.4 1.4 180.8 1.6 181.2 1.6C259.6 12 320 78.8 320 160C320 248.4 248.4 320 160 320zM220 220C214.4 220 209.4 217.8 205.8 214.2L140 148.4L114.2 174.2C110.6 177.8 105.6 180 100 180C89 180 80 171 80 160C80 154.4 82.2 149.4 85.8 145.8L125.8 105.8C129.4 102.2 134.4 100 140 100C145.6 100 150.6 102.2 154.2 105.8L234.2 185.8C237.8 189.4 240 194.4 240 200C240 211 231 220 220 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Updated.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Updated.displayName = "Blueprint5.Icon.Updated";
exports.default = Updated;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"xgr62":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Upload", ()=>Upload);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Upload = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "upload",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM280 200C274.4000000000001 200 269.4000000000001 202.2 265.8 205.8L220 251.8V100C220 89 211 80 200 80S180 89 180 100V251.8L134.2 205.8C130.6 202.2 125.6 200 120 200C109 200 100 209 100 220C100 225.6 102.2 230.6 105.8 234.2L185.8 314.2000000000001C189.4 317.8 194.4 320 200 320S210.6 317.8 214.2 314.2L294.2000000000001 234.2C297.8 230.6 300 225.6 300 220C300 209 291 200 280 200z" : "M160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM220 160C214.4 160 209.4 162.2 205.8 165.8L180 191.8V80C180 69 171 60 160 60S140 69 140 80V191.8L114.2 165.8C110.6 162.2 105.6 160 100 160C89 160 80 169 80 180C80 185.6 82.2 190.6 85.8 194.2L145.8 254.2C149.4 257.8 154.4 260 160 260S170.6 257.8 174.2 254.2L234.2 194.2C237.8 190.6 240 185.6 240 180C240 169 231 160 220 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Upload.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Upload.displayName = "Blueprint5.Icon.Upload";
exports.default = Upload;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cF9rS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "User", ()=>User);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var User = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "user",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 193.4 0.4 187 1 180.6C1.2 178.2 1.6 176 2 173.6C2.6 169.6 3 165.6 3.8 161.8C4.4 159 5 156.2 5.8 153.4C6.6 150.2 7.4 147 8.2 143.8C9.2 140.6 10.2 137.6 11.2 134.6C12.2 132 13 129.2 14.2 126.6C15.4 123.4 16.8 120.1999999999999 18.4 117C19.4 114.8 20.4 112.6 21.6 110.4C23.4 106.9999999999999 25 103.6 27 100.4C28 98.6 29 96.9999999999999 30 95.4C32.2 91.8 34.4 88.4 36.8 84.9999999999999C37.6 83.8 38.4 82.8 39.2 81.6C63 49.1999999999999 96.2 24.4 134.8 10.9999999999999C135.4 10.7999999999999 136 10.6 136.6 10.3999999999999C145.8 7.4 155.2 4.9999999999999 165 3.1999999999999C166.6 2.9999999999999 168.4 2.5999999999999 170 2.4C179.8 1 189.8 0 200 0S220.2 1 230 2.4C231.6 2.6 233.4 2.8 235 3.2C244.8 5 254.2 7.4 263.4 10.4C264 10.6 264.6 10.8 265.2 11C303.8 24.4 337 49.2 360.8 81.6C361.6 82.6 362.4 83.6 363.2 84.8C365.6 88.2 367.8 91.8 370 95.4C371 97 372 98.6 373 100.4C375 103.8 376.8 107.2 378.4 110.6C379.4 112.8 380.4 114.8 381.3999999999999 117C382.8 120.2 384.2 123.4 385.6 126.8C386.6 129.4 387.6 132 388.4 134.6C389.4 137.6 390.6 140.8 391.3999999999999 143.8C392.4 147 392.9999999999999 150.2000000000001 393.8 153.4C394.4 156.2000000000001 395.2 159 395.8 161.8000000000001C396.6 165.6 397 169.6000000000001 397.6 173.6C398 176 398.4 178.2000000000001 398.6 180.6C399.6 187 400 193.4 400 200C400 310.4 310.4 400 200 400zM200 40L200 40C150.4 40 106.2 62.4 77 97.8C93.8 106.6 114.2 114.2000000000001 130.4 121.6C159.4 134.6 156.4 142.6 157.4 153.4C157.6 154.8 157.6 156.2 157.6 157.6C147.4 166.6 139 179.2 133.6 193.6L133.4 193.8C133.4 194 133.2 194.2 133.2 194.4C132 197.6 131 200.8 130.2 204C123.6 205.4 119.6 212.8 118 219.8C116.4 222.6 113.4 229.4 114 237.2C115 247.4 119.2 252 123.8 253.8C123.8 254.4 123.8 254.8 123.8 255.4C123.8 268 125 286.4 127.2 298.4C127.6 301.8 128.4 305 129.4 308.4C133.6 323 142.6 336.4 154.6 345.6C167 355 184.6 360 200.2 360C215.8 360 233.2 355 245.6 345.4C257.6 336.2 266.6 323 270.8 308.2C271.8 305 272.4 301.6 273 298.2C275.2 286.2000000000001 276.4 268 276.4 255.2C276.4 254.6 276.4 254 276.4 253.4C280.8 251.4 284.8 246.8 285.6 237C286.4 229.2 283.2 222.4 281.6 219.6C280.2 212.8 276.2 205.4 269.6 204C268.8 200.8 267.8 197.4 266.6 194.4C266.6 194.2 266.2 193.4 266.2 193.4C261 179.2 252.8 166.8 242.8 157.8C242.8 156.2 243 154.6 243 153.2C244.0000000000001 142.4 240 134.4 269.2000000000001 121.4C285.4000000000001 114.2000000000001 306 106.6 322.8 97.6C293.6 62.4 249.4 40 200 40z" : "M159.8 320.2C71.4 320.2 -0.2 248.6 -0.2 160.2C-0.2 155 0 149.8 0.6 144.6C0.8 142.8 1.2 141 1.4 139C1.8 136 2.2 132.8 2.8 129.6C3.2 127.4 3.8 125.2 4.4 122.8C5 120.2 5.6 117.6 6.4 115.2C7.2 112.8 8 110.2 8.8 107.8C9.6 105.6 10.4 103.6 11.2 101.4C12.2 98.8 13.4 96.2 14.6 93.6C15.4 91.8 16.2 90.2 17.2 88.4C18.6 85.6 20 83 21.6 80.4C22.4 79 23.2 77.8 24 76.4C25.8 73.6 27.6 70.8 29.4 68C30 67.2 30.8 66.2 31.4 65.4C50.4 39.6 77 19.6 108 9C108.6 8.8 109 8.6 109.4 8.4C116.8 6 124.4 4 132.2 2.6C133.6 2.4 134.8 2.2 136.2 2C144 0.8 152 1e-13 160.2 1e-13S176.4 0.8 184.2 2C185.6 2.2 186.8 2.4 188.2 2.6C196 4 203.6 5.8 211 8.4C211.6 8.6 212 8.8 212.4 9C243.4 19.8 270 39.6 289 65.4C289.6 66.2 290.2 67 290.8 68C292.8 70.8 294.6 73.6 296.4 76.4C297.2 77.8 298 79 298.8 80.4C300.4 83 301.8 85.8 303.2 88.6C304 90.2 304.8 92 305.6 93.8C306.8 96.4 307.8 99 309 101.6C309.8 103.6 310.6 105.8 311.3999999999999 108C312.2 110.4 313 112.8 313.7999999999999 115.4C314.5999999999999 118 315.2 120.4 315.7999999999999 123C316.3999999999999 125.2 317 127.4 317.3999999999999 129.8C317.9999999999999 133 318.3999999999999 136 318.7999999999999 139.2C318.9999999999999 141 319.3999999999999 142.8 319.5999999999999 144.8C319.9999999999999 150 320.3999999999999 155 320.3999999999999 160.4C319.8 248.6 248.2 320.2 159.8 320.2zM159.8 32.2L159.8 32.2C120.2 32.2 84.8 50.2 61.4 78.4C74.8 85.6 91.2 91.6 104.2 97.4C127.4 107.8 125 114.2 125.8 122.8C126 124 126 125 126 126.2C117.8 133.4 111.2 143.4 106.8 155L106.8 155.2C106.8 155.4 106.6 155.6 106.6 155.6C105.6 158.2 104.8 160.8 104.2 163.4C98.6 164.4 95.4 170.4 94.2 176C93 178.2 90.6 183.6 91.2 189.8C92 198 95.2 201.6 98.8 203.2C98.8 203.6 98.8 204 98.8 204.4C98.8 214.6 99.8 229.2 101.6 238.8C102 241.4 102.6 244 103.4 246.6C106.8 258.4 114 269 123.6 276.4C133.4 284 147.4 288.2 160 288.2C172.4 288.2 186.4 284.2 196.4 276.4C206 269 213.2 258.4 216.6 246.6C217.4 244 218 241.4 218.4 238.6C220.2 229 221.2 214.4 221.2 204.2C221.2 203.8 221.2 203.2 221.2 202.8C224.8 201.2 227.8 197.6 228.6 189.6C229.2 183.4 226.6 178 225.4 175.8C224.2 170.4 221.2 164.4 215.8 163.4C215.2 160.8 214.4 158.2 213.4 155.8C213.4 155.6 213.2 155 213.2 155C209 143.6 202.4 133.8 194.4 126.6C194.4 125.4 194.6 124 194.6 122.8C195.4 114.2 192.2 107.8 215.6 97.4C228.6 91.6 245.0000000000001 85.4 258.4000000000001 78.4C234.8 50.2 199.4 32.2 159.8 32.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
User.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
User.displayName = "Blueprint5.Icon.User";
exports.default = User;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6sFQa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Variable", ()=>Variable);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Variable = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "variable",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M98.6 324.2C110.2 341.4 124.8 356.6 142.6 369.6L145.8 380C118.2 368.2 94.4 353.4 74.8 335.6C49.2 312.2 29.8 285.6 16.6 255.4C5.6 229.8 0 203.8 0 177.6C0 132 16.6 86.2 49.8 40.4L53 51.4C43.2 76 38.4 99 38.4 120.2C38.4 153.6 44 189.4 55.2 227.4000000000001C66.2 265.4 80.8 297.6 98.6 324.2zM286.2 156.4L279.6 160.4C272.2000000000001 149.6 266.6 143 263.2 140.4C260.8 138.8 258 138 254.8 138C251 138 247.2 140.4 243.4 145.4C237.2 153.8 228.8 177.2 218.2 215.4C227.6 232.4 235.4 243.6 242 248.8C246.6 252.6 251.6 254.6 256.8 254.6C258.8 254.6 262.4 253.8 267.4 252.4C272.6 251 277 250.2 281 250.2C286.4 250.2 291 252.2 294.6 256C298.2 259.8 300 264.8 300 271C300 277.6 298.2 282.6 294.6 286.4C291 290.2 285.8 292.2 279 292.2C273 292.2 267.2 290.8 261.8 287.8C256.4 284.8 249.6 278.4 241.4 268.4C235.2 261 226 248 214 229.6C209.2 252.4 201 273.4 189.2 292.4L124.4 280.6L123.2 273.4C128 274.4 132 274.8 135.4 274.8C141.8 274.8 147.2 272 151.4 266.2000000000001C158 257.2000000000001 167.4 230.2 179.2 184.8C169.8 172 163.6 163.6 160 159.6C154.4 153.2 149.6 149 146 147.2C143.2 145.6 140 145 136.4 145C133.6 145 129.2 146.6 123 149.6000000000001C118.8 151.6 115 152.6000000000001 111.6 152.6000000000001C105.4 152.6000000000001 100.2 150.4000000000001 96 146.2000000000001S89.8 136.6 89.8 130.2000000000001C89.8 124 91.6 119.2000000000001 95.4 115.2000000000001C99.2 111.4 104.2 109.4 110.6 109.4C116.8 109.4 122.6 110.8000000000001 128 113.4C133.4 116.0000000000001 140.2 121.8 148.4 130.6C156.6 139.4 168 153.2 182.4 172.2C188 154.2 192.8 141 196.8 132.8C200.8 124.6 205.6 118.6 210.8 115C216 111.4 222.6 109.6 230.6 109.6C238.2 109.6 246 112.4 254 118.2C264.8 125.4 275.4 138.2 286.2 156.4zM350.2000000000001 380L347.2000000000001 369.2C357 344.4 361.8000000000001 321.4 361.8000000000001 300.2C361.8000000000001 271.6 357.6 241 349.2000000000001 208.2C342.6000000000002 183 334.2000000000001 159.2 323.8000000000001 137.2C313.4000000000001 115 303.4000000000001 97.8 293.6000000000001 85.2C283.8000000000001 72.8 271.8000000000002 61.2 257.6000000000001 50.8L254.2000000000001 40.1999999999999C281.8000000000001 51.9999999999999 305.6000000000001 66.9999999999999 325.2000000000001 84.8C351.0000000000001 108.2 370.4000000000001 134.8 383.4000000000001 164.8C394.4 190.4 400 216.6 400 243C400 288.4 383.4000000000001 334.2 350.2000000000001 380z" : "M78.8 257C88.2 270.2 99.8 281.8 114 291.6L116.6 299.6C94.4 290.6 75.6 279.4 59.8 265.6C39.4 248 23.8 227.6 13.4 204.6C4.4 184.8 0 165 0 145C0 110 13.2 75 39.8 40L42.4 48.4C34.6 67.2 30.6 84.8 30.6 101C30.6 126.6 35 153.8 44 183C53 212 64.6 236.8 78.8 257zM229 128.8L223.6 131.8C217.6 123.6 213.2 118.6 210.4 116.4C208.6 115.2 206.2 114.4 203.8 114.4C200.8 114.4 197.8 116.4 194.8 120C189.8 126.6 183 144.4 174.6 173.8C182.2 186.8 188.4 195.4 193.6 199.4C197.4 202.4 201.4 203.8 205.4 203.8C207 203.8 209.8 203.2 214 202.2C218 201 221.8 200.6 224.8 200.6C229.2 200.6 232.8 202 235.6 205C238.6 208 240 211.8 240 216.4C240 221.4 238.6 225.4 235.6 228.2C232.6 231.2 228.6 232.6 223 232.6C218.1999999999999 232.6 213.5999999999999 231.4 209.1999999999999 229.2C205 227 199.4 222 192.8 214.4C187.8 208.8 180.6 198.8 170.8 184.8C167.4 202 160.8 218 151.4 232.4L99.6 223.6L98.6 218.2C102.4 219 105.8 219.4 108.4 219.4C113.6 219.4 117.8 217.2 121.2 212.8C126.4 206 133.8 185.2 143.4 150.4C136 140.6 130.8 134.2 128 131.2C123.4 126.4 119.8 123.2 116.8 121.8C114.6 120.6 112 120 109 120C106.8 120 103.2 121.2 98.4 123.6C95 125 92 125.8 89.4 125.8C84.4 125.8 80.2 124.2 77 121C73.8 117.8 72.2 113.6 72.2 108.8C72.2 104.2 73.8 100.4 76.8 97.4C79.8 94.4 83.8 93 89 93C94 93 98.6 94 103 96C107.4 98 112.8 102.4 119.4 109C126 115.6 135 126.2 146.6 140.8C151 127 155 117 158.2 110.6C161.4 104.4 165.2 99.8 169.4 97C173.6 94.2 178.8 92.8 185.2000000000001 92.8C191.4 92.8 197.6 95 203.8 99.4C211.8 105.2 220.2 114.8 229 128.8zM280.2 299.6L277.8 291.2C285.6 272.2 289.6 254.8 289.6 238.4C289.6 216.6 286.2 193.2 279.6 168.2C274.4000000000001 149 267.6 130.8 259.2000000000001 114C250.8 97 242.8 83.8 235 74.4C227.2 64.8 217.6 56 206.2 48L203.4 40C225.6 49 244.4 60.4 260.2 74C280.8 91.8 296.4 112.2 306.8 135C315.6 154.8 320 174.8 320 195C320 229.6 306.8 264.6 280.2 299.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Variable.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Variable.displayName = "Blueprint5.Icon.Variable";
exports.default = Variable;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gK7GF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Vector", ()=>Vector);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Vector = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "vector",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M225.716 366.0062C222.114 369.6052 219.912 374.6038 219.912 380.20228C219.912 391.1992 228.92 400.1966746 239.93 399.99673074C245.536 399.99673074 250.54 397.79734 254.144 394.19836L314.198 334.2152C317.802 330.6162 320.004 325.4176 320.004 320.0192C320.004 314.6206 317.802 309.6222 314.198 305.8232L254.144 245.84C250.54 242.241 245.536 240.0416 239.93 240.0416C228.92 240.0416 219.912 249.0392 219.912 260.036C219.912 265.6344000000001 222.314 270.6330000000001 225.918 274.232L251.742 300.0248000000001H100.0186C89.0084 300.0248000000001 80 309.0222 80 320.0192C80 331.016 89.0084 340.0136 100.0186 340.0136H251.742L225.716 366.0062zM111.056 197.89C120.9358 202.8288 132.9494 198.824 137.8894 188.944L200.002 64.722L262.1140000000001 188.944C267.0540000000001 198.824 279.068 202.8288 288.948 197.89C298.828 192.95 302.832 180.936 297.892 171.056L217.89 11.056C214.502 4.28 207.578 0 200.002 0C192.4264 0 185.501 4.28 182.113 11.056L102.1116 171.056C97.1718 180.936 101.1764 192.95 111.056 197.89z" : "M194.0574 314.2L234.008 274.2H234.208C237.802 270.6 240 265.6 240 260C240 254.4 237.802 249.4 234.208 245.8L194.2572 205.8C190.6616 202.2 185.668 200 180.075 200C169.0886 200 160.0998 209 160.0998 220C160.0998 225.6 162.2972 230.6 165.8926 234.2L171.6854 240H99.975C88.9888 240 80 249 80 260C80 271 88.9888 280 99.975 280H171.2858L165.4932 285.8C161.8976 289.4 159.7004 294.4 159.7004 300C159.7004 311 168.6892 320 179.8752 320C185.4682 320 190.462 317.8 194.0574 314.2zM191.4002 147.1998C195.4002 157.3998 207 162.5998 217.2 158.5998C227.4 154.5998 232.6 142.9998 228.6 132.7998L183.6002 16.8C179.6002 6.6 170.4002 0 160.0002 0C149.6002 0 140.4002 6.6 136.4002 16.8L91.4002 132.7998C87.4002 142.9998 92.4002 154.5998 102.8002 158.5998C113.0002 162.5998 124.6002 157.5998 128.6002 147.1998L160.0002 66.4L191.4002 147.1998z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Vector.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Vector.displayName = "Blueprint5.Icon.Vector";
exports.default = Vector;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3A4My":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerticalBarChartAsc", ()=>VerticalBarChartAsc);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var VerticalBarChartAsc = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "vertical-bar-chart-asc",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M160 260H140C129 260 120 251 120 240V20C120 9 129 0 140 0H160C171 0 180 9 180 20V240C180 251 171 260 160 260zM60 220H40C29 220 20 211 20 200V20C20 9 29 0 40 0H60C71 0 80 9 80 20V200C80 211 71 220 60 220zM260 320H240C229 320 220 311 220 300V20C220 9 229 0 240 0H260C271 0 280 9 280 20V300C280 311 271 320 260 320zM360 400H340C329 400 320 391 320 380V20C320 9 329 0 340 0H360C371 0 380 9 380 20V380C380 391 371 400 360 400z" : "M120 180C109 180 100 171 100 160V20C100 9 109 0 120 0S140 9 140 20V160C140 171 131 180 120 180zM40 140C29 140 20 131 20 120V20C20 9 29 0 40 0S60 9 60 20V120C60 131 51 140 40 140zM200 240C189 240 180 231 180 220V20C180 9 189 0 200 0S220 9 220 20V220C220 231 211 240 200 240zM280 320C269 320 260 311 260 300V20C260 9 269 0 280 0S300 9 300 20V300C300 311 291 320 280 320z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
VerticalBarChartAsc.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
VerticalBarChartAsc.displayName = "Blueprint5.Icon.VerticalBarChartAsc";
exports.default = VerticalBarChartAsc;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0crC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerticalBarChartDesc", ()=>VerticalBarChartDesc);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var VerticalBarChartDesc = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "vertical-bar-chart-desc",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M60 400H40C29 400 20 391 20 380V20C20 9 29 0 40 0H60C71 0 80 9 80 20V380C80 391 71 400 60 400zM160 320H140C129 320 120 311 120 300V20C120 9 129 0 140 0H160C171 0 180 9 180 20V300C180 311 171 320 160 320zM260 260H240C229 260 220 251 220 240V20C220 9 229 0 240 0H260C271 0 280 9 280 20V240C280 251 271 260 260 260zM360 220H340C329 220 320 211 320 200V20C320 9 329 0 340 0H360C371 0 380 9 380 20V200C380 211 371 220 360 220z" : "M120 240C109 240 100 231 100 220V20C100 9 109 0 120 0S140 9 140 20V220C140 231 131 240 120 240zM40 320C29 320 20 311 20 300V20C20 9 29 0 40 0S60 9 60 20V300C60 311 51 320 40 320zM200 180C189 180 180 171 180 160V20C180 9 189 0 200 0S220 9 220 20V160C220 171 211 180 200 180zM280 140C269 140 260 131 260 120V20C260 9 269 0 280 0S300 9 300 20V120C300 131 291 140 280 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
VerticalBarChartDesc.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
VerticalBarChartDesc.displayName = "Blueprint5.Icon.VerticalBarChartDesc";
exports.default = VerticalBarChartDesc;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dPnt9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerticalDistribution", ()=>VerticalDistribution);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var VerticalDistribution = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "vertical-distribution",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 360H380C391 360 400 369 400 380S391 400 380 400H20C9 400 0 391 0 380S9 360 20 360zM60 260C49 260 40 251 40 240V160C40 149 49 140 60 140H340C351 140 360 149 360 160V240C360 251 351 260 340 260H60zM380 40H20C9 40 0 31 0 20S9 0 20 0H380C391 0 400 9 400 20S391 40 380 40z" : "M20 280H300C311 280 320 289 320 300S311 320 300 320H20C9 320 0 311 0 300S9 280 20 280zM300 60H20C9 60 0 51 0 40S9 20 20 20H300C311 20 320 29 320 40S311 60 300 60zM60 220C49 220 40 211 40 200V140C40 129 49 120 60 120H240C251 120 260 129 260 140V200C260 211 251 220 240 220H60z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
VerticalDistribution.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
VerticalDistribution.displayName = "Blueprint5.Icon.VerticalDistribution";
exports.default = VerticalDistribution;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eYjL4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerticalInbetween", ()=>VerticalInbetween);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var VerticalInbetween = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "vertical-inbetween",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M0 400H400V380C400 368.9544 391.046 360 380 360H20C8.9543 360 0 368.9544 0 380V400zM125.8518 174.148C118.0494 166.346 118.0494 153.696 125.8518 145.894L185.0996 86.646C185.3416 86.376 185.5924 86.112 185.8518 85.852C189.7582 81.946 194.88 79.994 200 80C205.12 79.994 210.242 81.946 214.148 85.852C214.408 86.112 214.658 86.376 214.9 86.646L274.148 145.894C281.95 153.696 281.95 166.346 274.148 174.148C266.346 181.95 253.696 181.95 245.894 174.148L200 128.254L154.1066 174.148C146.3042 181.95 133.6542 181.95 125.8518 174.148zM125.8518 254.1066C118.0494 246.3042 118.0494 233.6542 125.8518 225.8518000000001C133.6542 218.0494 146.3042 218.0494 154.1066 225.8518000000001L200 271.7452L245.894 225.8518000000001C253.696 218.0494 266.346 218.0494 274.148 225.8518000000001C281.95 233.6542 281.95 246.3042 274.148 254.1066L214.9 313.3544C214.658 313.6242 214.408 313.8888 214.148 314.1482C210.242 318.0546 205.12 320.0052 200 320C194.88 320.0052 189.7582 318.0546 185.8518 314.1482C185.5924 313.8888 185.3416 313.6242 185.0996 313.3544L125.8518 254.1066zM400 20V0H0V20C0 31.046 8.9543 40 20 40H380C391.046 40 400 31.046 400 20z" : "M320 320H0V300C0 288.9544 8.9543 280 20 280H300C311.046 280 320 288.9544 320 300V320zM0 20V0H320V20C320 31.046 311.046 40 300 40H20C8.9543 40 0 31.046 0 20zM174.1422 254.1422C166.3316 261.9526 153.6684 261.9526 145.8578 254.1422L105.8578 214.1422C98.0474 206.3316 98.0474 193.6684 105.8578 185.8578C113.6684 178.0474 126.3316 178.0474 134.1422 185.8578L160 211.7158L185.8578 185.8578C193.6684 178.0474 206.332 178.0474 214.142 185.8578C221.952 193.6684 221.952 206.3316 214.142 214.1422L174.1422 254.1422zM134.1422 134.1422C126.3316 141.9526 113.6684 141.9526 105.8578 134.1422C98.0474 126.3316 98.0474 113.668 105.8578 105.858L145.8578 65.858C153.6684 58.048 166.3316 58.048 174.1422 65.858L214.142 105.858C221.952 113.668 221.952 126.3316 214.142 134.1422C206.332 141.9526 193.6684 141.9526 185.8578 134.1422L160 108.284L134.1422 134.1422z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
VerticalInbetween.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
VerticalInbetween.displayName = "Blueprint5.Icon.VerticalInbetween";
exports.default = VerticalInbetween;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"64ZxF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Video", ()=>Video);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Video = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "video",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M380 360H20C9 360 0 351 0 340V60C0 49 9 40 20 40H380C391 40 400 49 400 60V340C400 351 391 360 380 360zM140 120V280L260 200L140 120z" : "M300 280H20C9 280 0 271 0 260V60C0 49 9 40 20 40H300C311 40 320 49 320 60V260C320 271 311 280 300 280zM100 100V220L220 160L100 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Video.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Video.displayName = "Blueprint5.Icon.Video";
exports.default = Video;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"irhqb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Virus", ()=>Virus);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Virus = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "virus",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M304.9762820000001 123.303888L330 98.28L337.071068 105.35534L338.815484 106.909466C346.665838 113.125976 358.102746 112.607934 365.35534 105.35534C373.1658240000001 97.544854 373.1658240000001 84.8815539999999 365.35534 77.071068L365.35534 77.071068L322.9289320000001 34.64466L321.1845160000001 33.0905340000001C313.334162 26.874024 301.897254 27.392066 294.6446600000001 34.64466C286.834176 42.455146 286.834176 55.1184460000001 294.6446600000001 62.928932L294.6446600000001 62.928932L301.7200000000001 70L276.696112 95.023718C260.294058 83.0199060000001 240.973744 74.767236 219.998142 71.528676L219.98 40L230 40C241.045694 40 250 31.045694 250 20C250 9.743284 242.279196 1.289856 232.332422 0.134554L230 0L170 0C158.954305 0 150 8.954306 150 20C150 30.256716 157.7208038 38.710144 167.6675774 39.865446L170 40L179.98 40L179.9818216 71.5317720000001C161.4829752 74.390888 144.2720324 81.149992 129.2154538 90.942622L108.28 70L115.355339 62.928932C123.1658248 55.1184460000001 123.1658248 42.455146 115.355339 34.64466C108.102745 27.392066 96.6658372 26.874024 88.815484 33.0905340000001L87.0710678 34.64466L44.644661 77.071068C36.8341752 84.8815539999999 36.8341752 97.544854 44.644661 105.35534C51.897255 112.607934 63.3341628 113.125976 71.184516 106.909466L72.9289322 105.35534L80 98.28L99.390705 117.666652C85.2620986 134.911054 75.4796908 155.853652 71.7165052 178.821418L71.2132034 178.786796L40 178.8L40 170C40 158.954306 31.045695 150 20 150C9.74328322 150 1.289856786 157.720804 0.1345546266 167.667578L0 170L0 230C0 241.045695 8.954305 250 20 250C30.2567168 250 38.7101432 242.2791962 39.8654454 232.3324226L40 230L40 218.8L71.3485546 218.7940984C74.8098338 242.6968118 84.7746296 264.493974 99.390705 282.333348L79.98 301.7200000000001L72.9289322 294.644661L71.184516 293.0905336C63.3341628 286.8740246 51.897255 287.392067 44.644661 294.644661C36.8341752 302.4551468 36.8341752 315.1184464 44.644661 322.9289322L44.644661 322.9289322L87.0710678 365.355339L88.815484 366.9094664C96.6658372 373.1259754 108.102745 372.607933 115.355339 365.355339C123.1658248 357.5448532 123.1658248 344.8815536 115.355339 337.0710678L115.355339 337.0710678L108.28 330.02L129.2154538 309.057377C144.2774684 318.8535432 161.495403 325.6139918 180.0018584 328.4713234L180 360L170 360C158.954305 360 150 368.954305 150 380C150 390.25671678 157.7208038 398.71014322 167.6675774 399.86544538L170 400L230 400C241.045694 400 250 391.045695 250 380C250 369.7432832 242.279196 361.2898568 232.332422 360.1345546L230 360L220 360L220.018178 328.4682282C241.011694 325.2235442 260.346522 316.9560794 276.756266 304.9322316L277.573594 305.8578644L301.7000000000001 330.02L294.6446600000001 337.0710678C286.834176 344.8815536 286.834176 357.5448532 294.6446600000001 365.355339C301.897254 372.607933 313.334162 373.1259754 321.1845160000001 366.9094664L322.9289320000001 365.355339L365.35534 322.9289322C373.1658240000001 315.1184464 373.1658240000001 302.4551468 365.35534 294.644661C358.102746 287.392067 346.665838 286.8740246 338.815484 293.0905336L337.071068 294.644661L330 301.7200000000001L305.857864 277.5735932L304.932232 276.7562662000001C316.558258 260.8894562000001 324.6723560000001 242.2879178 328.1297180000001 222.096462L360 222.1L360 230C360 241.045695 368.954306 250 380 250C390.2567160000001 250 398.710144 242.2791962 399.865446 232.3324226L400 230L400 170C400 158.954306 391.0456940000001 150 380 150C369.743284 150 361.289856 157.720804 360.134554 167.667578L360 170L360 182.1L328.775936 182.086862C325.774142 160.306452 317.3768 140.248004 304.9762820000001 123.303888zM250 180C233.431458 180 220 166.568542 220 150C220 133.431458 233.431458 120 250 120C266.5685420000001 120 280 133.431458 280 150C280 166.568542 266.5685420000001 180 250 180zM160 280C137.90861 280 120 262.09139 120 240C120 217.90861 137.90861 200 160 200C182.09139 200 200 217.90861 200 240C200 262.09139 182.09139 280 160 280z" : "M238.350376 97.85497L253.1 83.12L254.142136 84.142136C261.952622 91.952622 274.615922 91.952622 282.4264060000001 84.142136C289.679 76.889542 290.197044 65.452634 283.980534 57.60228L282.4264060000001 55.857864L254.142136 27.573594C246.33165 19.763108 233.66835 19.763108 225.857864 27.573594C218.60527 34.826188 218.087228 46.263094 224.303738 54.113448L224.88 54.78L207.616212 72.042466C199.0906292 67.41735 189.817174 63.995628 180.023728 62.005182L180 40L182.3324226 39.865446C192.2791962 38.710144 200 30.256716 200 20C200 8.954306 191.045695 0 180 0L180 0L140 0L137.6675774 0.134554C127.7208038 1.289856 120 9.743284 120 20C120 31.045694 128.954305 40 140 40L140 40L139.9962406 62.001126C129.6855528 64.094498 119.9509784 67.774268 111.0583878 72.774562L94.1421356 55.857864L95.696263 54.113448C101.912772 46.263094 101.3947296 34.826188 94.1421356 27.573594C86.3316498 19.763108 73.6683502 19.763108 65.8578644 27.573594L65.8578644 27.573594L37.5735932 55.857864L36.0194658 57.60228C29.8029568 65.452634 30.3209992 76.889542 37.5735932 84.142136C45.384079 91.952622 58.0473786 91.952622 65.8578644 84.142136L65.8578644 84.142136L65.86 84.14L80.7415442 99.015694C73.6590046 108.206894 68.1394876 118.664566 64.5809152 129.990792L40 130C40 118.954306 31.045695 110 20 110C9.74328322 110 1.289856786 117.720804 0.1345546266 127.667578L0 130L0 170C0 181.045695 8.954305 190 20 190C30.2567168 190 38.7101432 182.2791962 39.8654454 172.3324226L40 170L60.4931566 169.9939968C62.2625104 187.8256658 68.7159708 204.279557 78.605736 218.1078688L68.36 228.36L65.8578644 225.8578644C58.0473786 218.0473786 45.384079 218.0473786 37.5735932 225.8578644C30.3209992 233.1104584 29.8029568 244.5473662 36.0194658 252.3977194L37.5735932 254.1421356L65.8578644 282.4264068C73.6683502 290.2368928 86.3316498 290.2368928 94.1421356 282.4264068C101.0955302 275.4730124 101.8585678 264.673423 96.4312482 256.8758966000001L107.8992848 245.3720464C117.6213712 251.3179166 128.437926 255.649733 139.976272 257.9948182L139.98 280L137.6675774 280.1345546C127.7208038 281.2898568 120 289.7432832 120 300C120 310.25671678 127.7208038 318.71014322 137.6675774 319.86544538L140 320L180 320C191.045695 320 200 311.045695 200 300C200 289.7432832 192.2791962 281.2898568 182.3324226 280.1345546L180 280L180.023728 257.9948182C192.7908976 255.3999834 204.674348 250.372714 215.169204 243.417887L225.86 254.14L225.857864 254.1421356L224.303738 255.8865518C218.087228 263.736905 218.60527 275.1738128 225.857864 282.4264068C233.66835 290.2368928 246.33165 290.2368928 254.142136 282.4264068L254.142136 282.4264068L282.4264060000001 254.1421356L283.980534 252.3977194C290.197044 244.5473662 289.679 233.1104584 282.4264060000001 225.8578644C274.615922 218.0473786 261.952622 218.0473786 254.142136 225.8578644L254.142136 225.8578644L243.431302 215.1489562C252.169396 201.9561992 257.862042 186.5704126 259.506844 169.9939968L280 170L280.1345540000001 172.3324226C281.289856 182.2791962 289.743284 190 300 190C311.045694 190 320 181.045695 320 170L320 170L320 130L319.865446 127.667578C318.710144 117.720804 310.256716 110 300 110C288.9543060000001 110 280 118.954306 280 130L280 130L255.419084 129.990792C251.70983 118.184972 245.870046 107.322818 238.350376 97.85497zM200 140C188.954305 140 180 131.045695 180 120C180 108.954306 188.954305 100 200 100C211.045694 100 220 108.954306 220 120C220 131.045695 211.045694 140 200 140zM130 220C113.4314576 220 100 206.5685424 100 190C100 173.4314576 113.4314576 160 130 160C146.5685424 160 160 173.4314576 160 190C160 206.5685424 146.5685424 220 130 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Virus.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Virus.displayName = "Blueprint5.Icon.Virus";
exports.default = Virus;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bSZXU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VolumeDown", ()=>VolumeDown);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var VolumeDown = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "volume-down",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M318.4 321.4L286.4 297.8C307.4 270.8 320 236.8 320 200C320 163.2 307.4 129.2000000000001 286.4 102.2L318.4 78.6C344.4 112.2 360 154.2 360 200C360 245.8 344.4 287.8 318.4 321.4zM220 340C214.4 340 209.4 337.8 205.8 334.2L151.8 280H60C49 280 40 271 40 260V140C40 129 49 120 60 120H151.8L206 65.8C209.4 62.2 214.4 60 220 60C231 60 240 69 240 80V320C240 331 231 340 220 340z" : "M180 280C174.4 280 169.4 277.8 165.8 274.2L111.8 220H60C49 220 40 211 40 200V120C40 109 49 100 60 100H111.8L166 45.8C169.4 42.2 174.4 40 180 40C191 40 200 49 200 60V260C200 271 191 280 180 280zM251.4 251.2L219.6 226.8C232.4 207.8 240 184.8 240 160S232.4 112.2 219.6 93.2L251.4 68.8C269.4000000000001 94.6 280 126 280 160C280 194 269.4000000000001 225.4 251.4 251.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
VolumeDown.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
VolumeDown.displayName = "Blueprint5.Icon.VolumeDown";
exports.default = VolumeDown;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jIVs3":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VolumeOff", ()=>VolumeOff);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var VolumeOff = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "volume-off",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M280 340C274.4000000000001 340 269.4000000000001 337.8 265.8 334.2L211.8 280H120C109 280 100 271 100 260V140C100 129 109 120 120 120H211.8L266 65.8C269.4000000000001 62.2 274.4000000000001 60 280 60C291 60 300 69 300 80V320C300 331 291 340 280 340z" : "M220 280C214.4 280 209.4 277.8 205.8 274.2L151.8 220H100C89 220 80 211 80 200V120C80 109 89 100 100 100H151.8L206 45.8C209.4 42.2 214.4 40 220 40C231 40 240 49 240 60V260C240 271 231 280 220 280z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
VolumeOff.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
VolumeOff.displayName = "Blueprint5.Icon.VolumeOff";
exports.default = VolumeOff;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lpdiO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VolumeUp", ()=>VolumeUp);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var VolumeUp = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "volume-up",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M180 331.4C174.4 331.4 169.4 329.2 165.8 325.6L111.8 271.4H20C9 271.4 0 262.4 0 251.4V131.4C0 120.4 9 111.4 20 111.4H111.8L166 57.2C169.6 53.6 174.6 51.4 180.2000000000001 51.4C191.2000000000001 51.4 200.2000000000001 60.4 200.2000000000001 71.4V311.4C200 322.4 191 331.4 180 331.4zM346.2 362.6L313.8 338.6C342.8 296.8 360 246.2 360 191.4C360 136.6 342.8 86 313.8 44L346.2 20C380 68.6 400 127.6 400 191.4C400 255 380 314 346.2 362.6zM278.4 312.8L246.4 289.2C267.4 262.2000000000001 280 228.2 280 191.4C280 154.6 267.4 120.6 246.4 93.6L278.4 70C304.2000000000001 103.6 320 145.6 320 191.4C320 237 304.4000000000001 279 278.4 312.8z" : "M140 282.8C134.4 282.8 129.4 280.6 125.8 277L71.8 222.8H20C9 222.8 0 213.8 0 202.8V122.8C0 111.8 9 102.8 20 102.8H71.8L126 48.6C129.6 45 134.6 42.8 140.2 42.8C151.2 42.8 160.2 51.8 160.2 62.8V262.8C160 273.8 151 282.8 140 282.8zM274.8 302.6L243.2 278.2C266.2 245.6 280 205.8 280 162.8C280 119.6 266.2 79.8 243 47.2L274.6 22.8C303 62.2 319.8 110.4 319.8 162.8C320 215 303 263.2 274.8 302.6zM179.6 229.6C192.4 210.4 200 187.4 200 162.8S192.4 115 179.6 96L211.4 71.6C229.4 97.4 240 128.8 240 162.8C240 196.8 229.4 228.2 211.4 254L179.6 229.6z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
VolumeUp.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
VolumeUp.displayName = "Blueprint5.Icon.VolumeUp";
exports.default = VolumeUp;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3tyX2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Walk", ()=>Walk);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Walk = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "walk",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M320 200H280C275.4 200 271.6 201.8 268.2 204.2L268 204L234.2 229.4L221.6 166.6L274 114.1999999999999L274 114.1999999999999C277.8 110.6 280 105.6 280 100V20C280 9 271 0 260 0C249 0 240 9 240 20V91.8L187.8 144L138.8 13L138.6 13C135.8 5.4 128.6 0 120 0C109 0 100 9 100 20C100 22.4 100.6 24.8 101.4 27L101.2 27L188.6 260H130.6L96.6 209L96.4 209.2C92.8 203.8 87 200 80 200C69 200 60 209 60 220C60 224.2 61.6 227.8 63.6 230.8L63.4 231L103.4 291L103.8 290.8C107.2 296.2 113 300 120 300H203.6L210.8 319.2C204.2 327.8 200 338.4 200 350C200 377.6 222.4 400 250 400S300 377.6 300 350S277.6 300 250 300C248.8 300 247.6 300.2 246.4 300.4L237.6 276.8L286.6 240H320C331 240 340 231 340 220C340 209 331 200 320 200z" : "M260 160H220C216.8 160 213.8 161 211.2 162.2L211.2 162L190.8 172.2L183.4 135L211 116.6L210.8 116.2C216.2 112.8 220 107 220 100V20C220 9 211 0 200 0S180 9 180 20V89.2L154.6 106.2L118.6 12.8L118.4 12.8C115.6 5.4 108.6 0 100 0C89 0 80 9 80 20C80 22.6 80.6 25 81.4 27.2L81.2 27.2L147.8 200H112.4L97.8 171L97.6 171C94.4 164.6 87.8 160 80 160C69 160 60 169 60 180C60 183.2 61 186.2 62.2 188.8L62 188.8L82 228.8L82.2 228.8C85.6 235.4 92.2 240 100 240H163.2L169 255C163.4 262 160 270.6 160 280C160 302 178 320 200 320S240 302 240 280C240 260 225.4 243.6 206.2 240.6L196.2 214.2L224.8 200H260C271 200 280 191 280 180S271 160 260 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Walk.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Walk.displayName = "Blueprint5.Icon.Walk";
exports.default = Walk;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2z9sB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WarningSign", ()=>WarningSign);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var WarningSign = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "warning-sign",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M397.2 49.6C397.2 49.6 397.4000000000001 49.8000000000001 397.4000000000001 49.8000000000001L217.4 369.8000000000001C217.4 369.8000000000001 217.2 369.6 217.2 369.6C213.8 375.8 207.4 380 200 380S186.2 375.8 182.8 369.6L182.6 369.8L2.6 49.8L2.8 49.5999999999999C1.2 46.8 0 43.6 0 40C0 29 9 20 20 20H380C391 20 400 29 400 40C400 43.6 398.8 46.8 397.2 49.6zM220 60H180V100H220V60zM220 120H180V280H220V120z" : "M316.8 50L317 50.2L177 290.2L176.8 290C173.4 296 167.2 300 159.8 300S146.4 296 142.8 290C142.8 290 142.6 290.2 142.6 290.2L2.6 50.2L2.8 50C1 47 -0.2 43.8 -0.2 40C-0.2 29 8.8 20 19.8 20H299.8C310.8 20 319.8 29 319.8 40C319.8 43.8 318.6 47 316.8 50zM179.8 60.2H139.8V100.2H179.8V60.2zM179.8 120.2H139.8V220.2H179.8V120.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
WarningSign.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
WarningSign.displayName = "Blueprint5.Icon.WarningSign";
exports.default = WarningSign;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kuC05":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WaterfallChart", ()=>WaterfallChart);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var WaterfallChart = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "waterfall-chart",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M260 260H300C311 260 320 269 320 280V300C320 311 311 320 300 320H260C249 320 240 311 240 300V280C240 269 249 260 260 260zM80 100H100C111 100 120 109 120 120V200C120 211 111 220 100 220H80C69 220 60 211 60 200V120C60 109 69 100 80 100zM160 220H200C211 220 220 229 220 240C220 251 211 260 200 260H160C149 260 140 251 140 240C140 229 149 220 160 220zM380 320H360C349 320 340 311 340 300V120C340 109 349 100 360 100H380C391 100 400 109 400 120V300C400 311 391 320 380 320zM380 80H40V340C40 351 31 360 20 360S0 351 0 340V60C0 57.2 0.6 54.6 1.6 52.2C4.6 45 11.8 40 20 40H380C391 40 400 49 400 60C400 71 391 80 380 80z" : "M160 180C171 180 180 189 180 200C180 211 171 220 160 220S140 211 140 200C140 189 149 180 160 180zM80 100H100C111 100 120 109 120 120V160C120 171 111 180 100 180H80C69 180 60 171 60 160V120C60 109 69 100 80 100zM220 220C231 220 240 229 240 240V260C240 271 231 280 220 280S200 271 200 260V240C200 229 209 220 220 220zM300 280H280C269 280 260 271 260 260V120C260 109 269 100 280 100H300C311 100 320 109 320 120V260C320 271 311 280 300 280zM300 80H40V260C40 271 31 280 20 280S0 271 0 260V60C0 49 9 40 20 40H300C311 40 320 49 320 60C320 71 311 80 300 80z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
WaterfallChart.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
WaterfallChart.displayName = "Blueprint5.Icon.WaterfallChart";
exports.default = WaterfallChart;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3YIpB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Waves", ()=>Waves);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Waves = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "waves",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M98.9598 346.3662C96.2254 354.5102 88.594 360 80 360C71.395 360 63.7552 354.496 61.0298 346.335L60.9214 346.0264C60.812 345.7188 60.629 345.2144 60.3728 344.5418C59.859 343.1932 59.0582 341.1878 57.9738 338.7478C55.7796 333.8110000000001 52.5506 327.3814 48.359 321.094C39.1644 307.302 29.3826 300 20 300C8.9543 300 0 291.0456 0 280C0 268.9544 8.9543 260 20 260C49.1304 260 68.8474 280.5468 80 296.502C91.1526 280.5468 110.8696 260 140 260C169.1304 260 188.8474 280.5470000000001 200 296.502C211.152 280.5470000000001 230.87 260 260 260C289.13 260 308.848 280.5470000000001 320 296.502C331.1520000000001 280.5470000000001 350.87 260 380 260C391.046 260 400 268.9544 400 280C400 291.0456 391.046 300 380 300C370.618 300 360.836 307.302 351.642 321.094C347.45 327.3814 344.22 333.8110000000001 342.026 338.7478C340.942 341.1878 340.1400000000001 343.1932 339.6280000000001 344.5418C339.37 345.2144 339.188 345.7188 339.0780000000001 346.0264L338.97 346.3352C336.246 354.4962 328.604 360 320 360C311.396 360 303.756 354.496 301.0300000000001 346.335L300.922 346.0264C300.812 345.7188 300.628 345.2144 300.372 344.5418C299.858 343.1932 299.058 341.1878 297.974 338.7478C295.78 333.8110000000001 292.55 327.3814 288.358 321.094C279.164 307.302 269.382 300 260 300C250.618 300 240.836 307.302 231.642 321.094C227.45 327.3814 224.22 333.8110000000001 222.026 338.7478C220.942 341.1878 220.142 343.1932 219.628 344.5418C219.372 345.2144 219.188 345.7188 219.078 346.0264L218.97 346.3352C216.246 354.4962 208.604 360 200 360C191.395 360 183.7552 354.496 181.0298 346.335L180.9214 346.0264C180.812 345.7188 180.629 345.2144 180.3728 344.5418C179.859 343.1932 179.0582 341.1878 177.9738 338.7478C175.7796 333.8110000000001 172.5506 327.3814 168.359 321.094C159.1644 307.302 149.3826 300 140 300C130.6174 300 120.8356 307.302 111.641 321.094C107.4494 327.3814 104.2204 333.8110000000001 102.0262 338.7478C100.9418 341.1878 100.141 343.1932 99.6272 344.5418C99.371 345.2144 99.188 345.7188 99.0786 346.0264L98.9666 346.3456L98.9598 346.3662zM98.9666 226.3456L98.9598 226.3662C96.2254 234.5102 88.594 240 80 240C71.395 240 63.7552 234.496 61.0298 226.335L60.9214 226.0264C60.812 225.7188 60.629 225.2144 60.3728 224.5418C59.859 223.1932 59.0582 221.1878 57.9738 218.7478C55.7796 213.811 52.5506 207.3814 48.359 201.094C39.1644 187.302 29.3826 180 20 180C8.9543 180 0 171.046 0 160C0 148.954 8.9543 140 20 140C49.1304 140 68.8474 160.546 80 176.502C91.1526 160.546 110.8696 140 140 140C169.1304 140 188.8474 160.546 200 176.502C211.152 160.546 230.87 140 260 140C289.13 140 308.848 160.546 320 176.502C331.1520000000001 160.546 350.87 140 380 140C391.046 140 400 148.954 400 160C400 171.046 391.046 180 380 180C370.618 180 360.836 187.302 351.642 201.094C347.45 207.3814 344.22 213.811 342.026 218.7478C340.942 221.1878 340.1400000000001 223.1932 339.6280000000001 224.5418C339.37 225.2144 339.188 225.7188 339.0780000000001 226.0264L338.97 226.3352C336.246 234.4962 328.604 240 320 240C311.396 240 303.756 234.496 301.0300000000001 226.335L300.922 226.0264C300.812 225.7188 300.628 225.2144 300.372 224.5418C299.858 223.1932 299.058 221.1878 297.974 218.7478C295.78 213.811 292.55 207.3814 288.358 201.094C279.164 187.302 269.382 180 260 180C250.618 180 240.836 187.302 231.642 201.094C227.45 207.3814 224.22 213.811 222.026 218.7478C220.942 221.1878 220.142 223.1932 219.628 224.5418C219.372 225.2144 219.188 225.7188 219.078 226.0264L218.97 226.3352C216.246 234.4962 208.604 240 200 240C191.395 240 183.7552 234.496 181.0298 226.335L180.9214 226.0264C180.812 225.7188 180.629 225.2144 180.3728 224.5418C179.859 223.1932 179.0582 221.1878 177.9738 218.7478C175.7796 213.811 172.5506 207.3814 168.359 201.094C159.1644 187.302 149.3826 180 140 180C130.6174 180 120.8356 187.302 111.641 201.094C107.4494 207.3814 104.2204 213.811 102.0262 218.7478C100.9418 221.1878 100.141 223.1932 99.6272 224.5418C99.371 225.2144 99.188 225.7188 99.0786 226.0264L98.9666 226.3456zM61.0378 346.3584C61.038 346.3594 61.0378 346.359 61.0376 346.3584L61.0378 346.3584zM98.9598 106.366L98.9666 106.346L99.0786 106.026C99.188 105.718 99.371 105.214 99.6272 104.542C100.141 103.194 100.9418 101.188 102.0262 98.748C104.2204 93.812 107.4494 87.382 111.641 81.094C120.8356 67.302 130.6174 60 140 60C149.3826 60 159.1644 67.302 168.359 81.094C172.5506 87.382 175.7796 93.812 177.9738 98.748C179.0582 101.188 179.859 103.194 180.3728 104.542C180.629 105.214 180.812 105.718 180.9214 106.026L181.0298 106.336C183.7552 114.496 191.395 120 200 120C208.604 120 216.246 114.496 218.97 106.336L219.078 106.026C219.188 105.718 219.372 105.214 219.628 104.542C220.142 103.194 220.942 101.188 222.026 98.748C224.22 93.812 227.45 87.382 231.642 81.094C240.836 67.302 250.618 60 260 60C269.382 60 279.164 67.302 288.358 81.094C292.55 87.382 295.78 93.812 297.974 98.748C299.058 101.188 299.858 103.194 300.372 104.542C300.628 105.214 300.812 105.718 300.922 106.026L301.0300000000001 106.336C303.756 114.496 311.396 120 320 120C328.604 120 336.246 114.496 338.97 106.336L339.0780000000001 106.026C339.188 105.718 339.37 105.214 339.6280000000001 104.542C340.1400000000001 103.194 340.942 101.188 342.026 98.748C344.22 93.812 347.45 87.382 351.642 81.094C360.836 67.302 370.618 60 380 60C391.046 60 400 51.046 400 40C400 28.954 391.046 20 380 20C350.87 20 331.1520000000001 40.546 320 56.502C308.848 40.546 289.13 20 260 20C230.87 20 211.152 40.546 200 56.502C188.8474 40.546 169.1304 20 140 20C110.8696 20 91.1526 40.546 80 56.502C68.8474 40.546 49.1304 20 20 20C8.9543 20 0 28.954 0 40C0 51.046 8.9543 60 20 60C29.3826 60 39.1644 67.302 48.359 81.094C52.5506 87.382 55.7796 93.812 57.9738 98.748C59.0582 101.188 59.859 103.194 60.3728 104.542C60.629 105.214 60.812 105.718 60.9214 106.026L61.0298 106.336C63.7552 114.496 71.395 120 80 120C88.594 120 96.2254 114.51 98.9598 106.366z" : "M60 300C67.5754 300 74.5008 295.7200000000001 77.8886 288.9442C79.9136 284.8942 85.7428 276.8086 93.4534 269.7988000000001C101.8352 262.179 107.8452 260 110 260C112.1548 260 118.1648 262.179 126.5466 269.7988000000001C134.2572 276.8086 140.0864 284.8942 142.1114 288.9442C145.4992 295.7200000000001 152.4246 300 160 300C167.5754 300 174.5006 295.7200000000001 177.8886 288.9442C179.9136 284.8942 185.7428 276.8086 193.4534 269.7988000000001C201.836 262.179 207.846 260 210 260C212.154 260 218.164 262.179 226.546 269.7988000000001C234.258 276.8086 240.086 284.8942 242.112 288.9442C245.5 295.7200000000001 252.424 300 260 300C267.576 300 274.5 295.7200000000001 277.888 288.9442C281.334 282.0542 285.4700000000001 273.9272 290.618 267.4940000000001C296.17 260.5524000000001 299.356 260 300 260C311.046 260 320 251.0456 320 240C320 228.9544 311.046 220 300 220C280.644 220 267.1620000000001 232.781 259.382 242.506C258.872 243.1434 258.372 243.7872 257.88 244.4356C256.44 242.988 254.962 241.5718 253.454 240.2012C243.502 231.1544 227.846 220 210 220C192.1548 220 176.4982 231.1544 166.5466 240.2012C164.289 242.2536 162.097 244.408 160 246.6172C157.903 244.408 155.711 242.2536 153.4534 240.2012C143.5018 231.1544 127.8452 220 110 220C92.1548 220 76.4982 231.1544 66.5466 240.2012C65.0388 241.5718 63.5604 242.988 62.12 244.4356C61.6282 243.7872 61.1272 243.1434 60.6174 242.506C52.8372 232.781 39.3564 220 20 220C8.9543 220 0 228.9544 0 240C0 251.0456 8.9543 260 20 260C20.6436 260 23.8294 260.5524000000001 29.3826 267.4940000000001C34.5292 273.9272 38.6664 282.0542 42.1114 288.9442C45.4992 295.7200000000001 52.4246 300 60 300zM60 200C67.5754 200 74.5008 195.72 77.8886 188.9442C79.9136 184.8942 85.7428 176.8086 93.4534 169.7988C101.8352 162.179 107.8452 160 110 160C112.1548 160 118.1648 162.179 126.5466 169.7988C134.2572 176.8086 140.0864 184.8942 142.1114 188.9442C145.4992 195.72 152.4246 200 160 200C167.5754 200 174.5006 195.72 177.8886 188.9442C179.9136 184.8942 185.7428 176.8086 193.4534 169.7988C201.836 162.179 207.846 160 210 160C212.154 160 218.164 162.179 226.546 169.7988C234.258 176.8086 240.086 184.8942 242.112 188.9442C245.5 195.72 252.424 200 260 200C267.576 200 274.5 195.72 277.888 188.9442C281.334 182.0542 285.4700000000001 173.9272 290.618 167.4938C296.17 160.5524 299.356 160 300 160C311.046 160 320 151.0456 320 140C320 128.9544 311.046 120 300 120C280.644 120 267.1620000000001 132.781 259.382 142.5062C258.872 143.1434 258.372 143.7872 257.88 144.4356C256.44 142.988 254.962 141.5718 253.454 140.2012C243.502 131.1544 227.846 120 210 120C192.1548 120 176.4982 131.1544 166.5466 140.2012C164.289 142.2536 162.097 144.408 160 146.6172C157.903 144.408 155.711 142.2536 153.4534 140.2012C143.5018 131.1544 127.8452 120 110 120C92.1548 120 76.4982 131.1544 66.5466 140.2012C65.0388 141.5718 63.5604 142.988 62.12 144.4356C61.6282 143.7872 61.1272 143.1434 60.6174 142.5062C52.8372 132.781 39.3564 120 20 120C8.9543 120 0 128.9544 0 140C0 151.0456 8.9543 160 20 160C20.6436 160 23.8294 160.5524 29.3826 167.4938C34.5292 173.9272 38.6664 182.0542 42.1114 188.9442C45.4992 195.72 52.4246 200 60 200zM77.8886 88.944C74.5008 95.72 67.5754 100 60 100C52.4246 100 45.4992 95.72 42.1114 88.944C38.6664 82.054 34.5292 73.928 29.3826 67.494C23.8294 60.552 20.6436 60 20 60C8.9543 60 0 51.046 0 40C0 28.954 8.9543 20 20 20C39.3564 20 52.8372 32.78 60.6174 42.506C61.1272 43.144 61.6282 43.788 62.12 44.436C63.5604 42.988 65.0388 41.572 66.5466 40.202C76.4982 31.154 92.1548 20 110 20C127.8452 20 143.5018 31.154 153.4534 40.202C155.711 42.254 157.903 44.408 160 46.618C162.097 44.408 164.289 42.254 166.5466 40.202C176.4982 31.154 192.1548 20 210 20C227.846 20 243.502 31.154 253.454 40.202C254.962 41.572 256.44 42.988 257.88 44.436C258.372 43.788 258.872 43.144 259.382 42.506C267.1620000000001 32.78 280.644 20 300 20C311.046 20 320 28.954 320 40C320 51.046 311.046 60 300 60C299.356 60 296.17 60.552 290.618 67.494C285.4700000000001 73.928 281.334 82.054 277.888 88.944C274.5 95.72 267.576 100 260 100C252.424 100 245.5 95.72 242.112 88.944C240.086 84.894 234.258 76.808 226.546 69.798C218.164 62.18 212.154 60 210 60C207.846 60 201.836 62.18 193.4534 69.798C185.7428 76.808 179.9136 84.894 177.8886 88.944C174.5006 95.72 167.5754 100 160 100C152.4246 100 145.4992 95.72 142.1114 88.944C140.0864 84.894 134.2572 76.808 126.5466 69.798C118.1648 62.18 112.1548 60 110 60C107.8452 60 101.8352 62.18 93.4534 69.798C85.7428 76.808 79.9136 84.894 77.8886 88.944z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Waves.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Waves.displayName = "Blueprint5.Icon.Waves";
exports.default = Waves;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ZaDY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WidgetButton", ()=>WidgetButton);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var WidgetButton = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "widget-button",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 320H380L380 320C391 320 400 311 400 300V100C400 89 391 80 380 80H20C9 80 0 89 0 100V300L0 300C0 311 9 320 20 320L20 320zM40 280V120H360V280H40zM120 180C109 180 100 189 100 200C100 211 109 220 120 220S140 211 140 200C140 189 131 180 120 180zM200 180C189 180 180 189 180 200C180 211 189 220 200 220C211 220 220 211 220 200C220 189 211 180 200 180zM280 180C269 180 260 189 260 200C260 211 269 220 280 220S300 211 300 200C300 189 291 180 280 180z" : "M20 260H300L300 260C311 260 320 251 320 240V80C320 69 311 60 300 60H20C9 60 0 69 0 80V240L0 240C0 251 9 260 20 260L20 260zM40 220V100H280V220H40zM100 140C89 140 80 149 80 160S89 180 100 180S120 171 120 160S111 140 100 140zM160 140C149 140 140 149 140 160S149 180 160 180S180 171 180 160S171 140 160 140zM220 140C209 140 200 149 200 160S209 180 220 180S240 171 240 160S231 140 220 140z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
WidgetButton.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
WidgetButton.displayName = "Blueprint5.Icon.WidgetButton";
exports.default = WidgetButton;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eE3HO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WidgetFooter", ()=>WidgetFooter);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var WidgetFooter = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "widget-footer",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 400H60C49 400 40 391 40 380V20C40 9 49 0 60 0H340C351 0 360 9 360 20V380C360 391 351 400 340 400zM320 40H80V120H320V40zM320 140H80V360H320V140z" : "M280 320H40C29 320 20 311 20 300V20C20 9 29 0 40 0H280C291 0 300 9 300 20V300C300 311 291 320 280 320zM260 40H60V100H260V40zM260 120H60V280H260V120z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
WidgetFooter.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
WidgetFooter.displayName = "Blueprint5.Icon.WidgetFooter";
exports.default = WidgetFooter;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9QbYx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WidgetHeader", ()=>WidgetHeader);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var WidgetHeader = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "widget-header",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M340 400H60C49 400 40 391 40 380V20C40 9 49 0 60 0H340C351 0 360 9 360 20V380C360 391 351 400 340 400zM320 40H80V260H320V40zM320 280H80V360H320V280z" : "M280 320H40C29 320 20 311 20 300V20C20 9 29 0 40 0H280C291 0 300 9 300 20V300C300 311 291 320 280 320zM260 40H60V200H260V40zM260 220H60V280H260V220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
WidgetHeader.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
WidgetHeader.displayName = "Blueprint5.Icon.WidgetHeader";
exports.default = WidgetHeader;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2niab":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Widget", ()=>Widget);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Widget = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "widget",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M360 320C382 320 400 338 400 360C400 382 382 400 360 400S320 382 320 360C320 338 338 320 360 320zM40 80C18 80 0 62 0 40C0 18 18 0 40 0S80 18 80 40C80 62 62 80 40 80zM340 100H380V300H340V100zM60 300H20V100H60V300zM40 400C18 400 0 382 0 360C0 338 18 320 40 320S80 338 80 360C80 382 62 400 40 400zM100 340H300V380H100V340zM360 80C338 80 320 62 320 40C320 18 338 0 360 0S400 18 400 40C400 62 382 80 360 80zM100 20H300V60H100V20z" : "M260 100H300V220H260V100zM60 220H20V100H60V220zM280 240C302 240 320 258 320 280C320 302 302 320 280 320S240 302 240 280C240 258 258 240 280 240zM40 80C18 80 0 62 0 40C0 18 18 0 40 0S80 18 80 40C80 62 62 80 40 80zM280 80C258 80 240 62 240 40C240 18 258 0 280 0S320 18 320 40C320 62 302 80 280 80zM100 260H220V300H100V260zM40 320C18 320 0 302 0 280C0 258 18 240 40 240S80 258 80 280C80 302 62 320 40 320zM100 20H220V60H100V20z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Widget.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Widget.displayName = "Blueprint5.Icon.Widget";
exports.default = Widget;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eIHiI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Wind", ()=>Wind);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Wind = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "wind",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M240 280C240 313.137 266.862 340 300 340C333.1380000000001 340 360 313.137 360 280C360 246.863 333.1380000000001 220 300 220H80C68.9544 220 60 211.0456 60 200C60 188.954 68.9544 180 80 180H300C355.228 180 400 224.7716 400 280C400 335.2284 355.228 380 300 380C244.772 380 200 335.2284 200 280C200 268.9544 208.954 260 220 260C231.046 260 240 268.9544 240 280zM20 160C8.9543 160 0 151.046 0 140C0 128.954 8.9543 120 20 120H220C242.092 120 260 102.092 260 80C260 57.908 242.092 40 220 40C201.326 40 183.9416 52.278 178.8568 66.6640000000001C175.1758 77.08 163.7494 82.538 153.335 78.856C142.9208 75.1760000000001 137.4622 63.75 141.1432 53.336C152.5318 21.114 186.4248 0 220 0C264.182 0 300 35.818 300 80C300 124.182 264.182 160 220 160H20z" : "M200 240C200 262.0914 217.908 280 240 280C262.092 280 280 262.0914 280 240C280 217.9086 262.092 200 240 200H80C68.9544 200 60 191.0456 60 180C60 168.9544 68.9544 160 80 160H240C284.182 160 320 195.8172 320 240C320 284.1828 284.182 320 240 320C195.8172 320 160 284.1828 160 240C160 228.9544 168.9544 220 180 220C191.0456 220 200 228.9544 200 240zM20 140C8.9543 140 0 131.0458 0 120C0 108.954 8.9543 100 20 100H170C186.5686 100 200 86.568 200 70C200 53.432 186.5686 40 170 40C155.0278 40 142.2828 50.764 139.6002 63.978C137.403 74.804 126.8462 81.798 116.0214 79.6C105.1964 77.402 98.2024 66.846 100.3998 56.022C106.9826 23.592 136.593 0 170 0C208.66 0 240 31.34 240 70C240 108.66 208.66 140 170 140H20z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Wind.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Wind.displayName = "Blueprint5.Icon.Wind";
exports.default = Wind;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e1pj5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WrenchRedo", ()=>WrenchRedo);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var WrenchRedo = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "wrench-redo",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M80 220C46.8 220 20 246.8 20 280S46.8 340 80 340H111.8L105.8 345.8C102.2 349.4 100 354.4 100 360C100 371 109 380 120 380C125.6 380 130.6 377.8 134.2 374.2L174.2 334.2C177.8 330.6 180 325.6 180 320C180 314.4 177.8 309.4 174.2 305.8L134.2 265.8C130.6 262.2000000000001 125.6 260 120 260C109 260 100 269 100 280C100 285.6 102.2 290.6 105.8 294.2L111.8 300H80C69 300 60 291 60 280S69 260 80 260C91.0456 260 100 251.0458 100 240C100 228.9544 91.0456 220 80 220zM270.002 80C253.58 80 237.998 83.598 224.002 90.052L165.124 31.174C150.226 16.276 126.0714 16.276 111.1734 31.174C96.2754 46.072 96.2756 70.226 111.1736 85.124L170.052 144.002C163.6008 157.998 160.0024 173.578 160.0024 190C160.0024 250.7514 209.252 300 270.002 300C289.476 300 307.7680000000001 294.9394 323.636 286.0616L248.788 211.2142C237.072 199.498 237.072 180.504 248.788 168.788C260.504 157.072 279.498 157.072 291.214 168.788L366.062 243.6358C374.942 227.7684000000001 380.002 209.4752 380.002 190C380.002 129.2480000000001 330.754 80.0000000000001 270.002 80.0000000000001z" : "M154.2 245.8L114.2 205.8C110.6 202.2 105.6 200 100 200C89 200 80 209 80 220C80 225.6 82.2 230.6 85.8 234.2L91.8 240H60C49 240 40 231 40 220S49 200 60 200C71.0456 200 80 191.0458 80 180C80 168.9544 71.0456 160 60 160C26.8 160 0 186.8 0 220S26.8 280 60 280H91.8L85.8 285.8C82.2 289.4 80 294.4 80 300C80 311 89 320 100 320C105.6 320 110.6 317.8 114.2 314.2L154.2 274.2C157.8 270.6 160 265.6 160 260C160 254.4 157.8 249.4 154.2 245.8zM191.6926 68.532L132.0992 8.938C120.1808 -2.98 100.8572 -2.98 88.9388 8.938C77.0204 20.858 77.0204 40.18 88.9388 52.1L148.5324 111.692C132.846 145.0576 138.7886 186.0678 166.3604 213.6396C194.0696 241.3488 235.3520000000001 247.2128 268.8060000000001 231.2314L208.786 171.2126C197.071 159.497 197.071 140.502 208.786 128.7862C220.5020000000001 117.07 239.4980000000001 117.07 251.214 128.7862L311.2320000000001 188.8048C327.2120000000001 155.351 321.348 114.0700000000001 293.64 86.36C266.068 58.788 225.058 52.8460000000001 191.6926 68.532z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
WrenchRedo.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
WrenchRedo.displayName = "Blueprint5.Icon.WrenchRedo";
exports.default = WrenchRedo;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dQ4vK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WrenchSnooze", ()=>WrenchSnooze);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var WrenchSnooze = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "wrench-snooze",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M40 380H120C131.0456 380 140 371.0456 140 360C140 355.2048 138.3124 350.8036 135.4986 347.3582L81.6138 280H120C131.0456 280 140 271.0456 140 260S131.0456 240 120 240H40C28.9544 240 20 248.9544 20 260C20 264.8344 21.7152 269.2680000000001 24.5702 272.7258L78.388 340H40C28.9544 340 20 348.9544 20 360S28.9544 380 40 380zM270.002 80C253.58 80 237.998 83.598 224.002 90.052L165.124 31.174C150.226 16.276 126.0714 16.276 111.1734 31.174C96.2754 46.072 96.2756 70.226 111.1736 85.124L170.052 144.002C163.6008 157.998 160.0024 173.578 160.0024 190C160.0024 250.7514 209.252 300 270.002 300C289.476 300 307.7680000000001 294.9394 323.636 286.0616L248.788 211.2142C237.072 199.498 237.072 180.504 248.788 168.788C260.504 157.072 279.498 157.072 291.214 168.788L366.062 243.6358C374.942 227.7684000000001 380.002 209.4752 380.002 190C380.002 129.2480000000001 330.754 80.0000000000001 270.002 80.0000000000001z" : "M20 320H100C111.0456 320 120 311.0458 120 300C120 295.2048 118.3124 290.8036 115.4986 287.3582L61.6138 220H100C111.0456 220 120 211.0456 120 200S111.0456 180 100 180H20C8.9542 180 0 188.9544 0 200C0 204.8344 1.7152 209.268 4.5702 212.7258L58.388 280H20C8.9542 280 0 288.9544 0 300C0 311.0458 8.9542 320 20 320zM191.6926 68.532L132.0992 8.938C120.1808 -2.98 100.8572 -2.98 88.9388 8.938C77.0204 20.858 77.0204 40.18 88.9388 52.1L148.5324 111.692C132.846 145.0576 138.7886 186.0678 166.3604 213.6396C194.0696 241.3488 235.3520000000001 247.2128 268.8060000000001 231.2314L208.786 171.2126C197.071 159.497 197.071 140.502 208.786 128.7862C220.5020000000001 117.07 239.4980000000001 117.07 251.214 128.7862L311.2320000000001 188.8048C327.2120000000001 155.351 321.348 114.0700000000001 293.64 86.36C266.068 58.788 225.058 52.8460000000001 191.6926 68.532z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
WrenchSnooze.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
WrenchSnooze.displayName = "Blueprint5.Icon.WrenchSnooze";
exports.default = WrenchSnooze;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5KTrQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WrenchTime", ()=>WrenchTime);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var WrenchTime = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "wrench-time",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 310C20 348.6 51.4 380 90 380S160 348.6 160 310S128.6 240 90 240S20 271.4 20 310zM80 350V305.8L111.2 274.6C113.2 272.8 115.8 271.8 118.4 271.8C120.8 271.8 123.4 272.8 125.4 274.6C129.2 278.6 129.2 284.8 125.4 288.8L100 314.2V350C100 355.6 95.6 360 90 360S80 355.6 80 350zM270.002 80C253.58 80 237.998 83.598 224.002 90.052L165.124 31.174C150.226 16.276 126.0714 16.276 111.1734 31.174C96.2754 46.072 96.2756 70.226 111.1736 85.124L170.052 144.002C163.6008 157.998 160.0024 173.578 160.0024 190C160.0024 250.7514 209.252 300 270.002 300C289.476 300 307.7680000000001 294.9394 323.636 286.0616L248.788 211.2142C237.072 199.498 237.072 180.504 248.788 168.788C260.504 157.072 279.498 157.072 291.214 168.788L366.062 243.6358C374.942 227.7684000000001 380.002 209.4752 380.002 190C380.002 129.2480000000001 330.754 80.0000000000001 270.002 80.0000000000001z" : "M0 250C0 288.6 31.4 320 70 320S140 288.6 140 250S108.6 180 70 180S0 211.4 0 250zM60 290V245.8L91.2 214.6C93.2 212.8 95.8 211.8 98.4 211.8C100.8 211.8 103.4 212.8 105.4 214.6C109.2 218.6 109.2 224.8 105.4 228.8L80 254.2V290C80 295.6 75.6 300 70 300S60 295.6 60 290zM191.6926 68.532L132.0992 8.938C120.1808 -2.98 100.8572 -2.98 88.9388 8.938C77.0204 20.858 77.0204 40.18 88.9388 52.1L148.5324 111.692C132.846 145.0576 138.7886 186.0678 166.3604 213.6396C194.0696 241.3488 235.3520000000001 247.2128 268.8060000000001 231.2314L208.786 171.2126C197.071 159.497 197.071 140.502 208.786 128.7862C220.5020000000001 117.07 239.4980000000001 117.07 251.214 128.7862L311.2320000000001 188.8048C327.2120000000001 155.351 321.348 114.0700000000001 293.64 86.36C266.068 58.788 225.058 52.8460000000001 191.6926 68.532z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
WrenchTime.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
WrenchTime.displayName = "Blueprint5.Icon.WrenchTime";
exports.default = WrenchTime;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9P6Fp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Wrench", ()=>Wrench);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var Wrench = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "wrench",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M396 311.2L322.6 238L251.6 252.2L237.4 322.8L310.8 395.8C270.6 406.4 226.2 396.4 194.8 365.2C157.6 328.2 150.2 273.2 172 228.6L11.8 68.2C4.4 61 0 51 0 40C0 18 17.8 0 40 0C51 0 61 4.4 68.2 11.8L228.8 172.6C273.4 151.6 328.2 159.2 365.2 195.8C396.6 227 406.6 271.2 396 311.2z" : "M316.6 246L255.4 185L198.6 199L184.6 255.6L245.8 316.6C212.4 325.4 175.4 317 149.2 290.8C120 261.8 112.6 219.4 126.8 183.6L11.6 68.4C4.4 61.2 0 51.2 0 40.2C0 18.2 18 0.2 40 0.2C51 0.2 61 4.6 68.2 12V12L183.6 127.4C219.4 113.6 261.8 120.8 290.6 149.8C317 175.8 325.4 212.8 316.6 246z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
Wrench.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
Wrench.displayName = "Blueprint5.Icon.Wrench";
exports.default = Wrench;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gfKRC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZoomIn", ()=>ZoomIn);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ZoomIn = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "zoom-in",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M391.2 51.2L292.4 150C309.8 175.8 320 206.6 320 240C320 328.4 248.4 400 160 400S0 328.4 0 240S71.6 80 160 80C193.4 80 224.2 90.2 250 107.6L348.8 8.8C354.2000000000001 3.4 361.8 0 370 0C386.6 0 400 13.4 400 30C400 38.2 396.6 45.8 391.2 51.2zM160 120C93.8 120 40 173.8 40 240S93.8 360 160 360S280 306.2000000000001 280 240S226.2 120 160 120zM220 260H180V300C180 311 171 320 160 320S140 311 140 300V260H100C89 260 80 251 80 240C80 229 89 220 100 220H140V180C140 169 149 160 160 160S180 169 180 180V220H220C231 220 240 229 240 240C240 251 231 260 220 260z" : "M159.8 200.2V240.2C159.8 251.2 150.8 260.2 139.8 260.2S119.8 251.2 119.8 240.2V200.2H79.8C68.8 200.2 59.8 191.2 59.8 180.2S68.8 160.2 79.8 160.2H119.8V120.2C119.8 109.2 128.8 100.2 139.8 100.2S159.8 109.2 159.8 120.2V160.2H199.8C210.8 160.2 219.8 169.2 219.8 180.2S210.8 200.2 199.8 200.2H159.8zM311 51.4L257.6 105C271.6 126.8 279.8 152.6 279.8 180.2C279.8 257.6 217.2 320.2 139.8 320.2S-0.2 257.6 -0.2 180.2S62.4 40.2 139.8 40.2C167.6 40.2 193.4 48.6 215 62.4L268.6 9C274 3.6 281.6 0.2 289.8 0.2C306.4 0.2 319.8 13.6 319.8 30.2C319.8 38.4 316.4 46 311 51.4zM139.8 80.2C84.6 80.2 39.8 125 39.8 180.2S84.6 280.2 139.8 280.2S239.8 235.4 239.8 180.2S195 80.2 139.8 80.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ZoomIn.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ZoomIn.displayName = "Blueprint5.Icon.ZoomIn";
exports.default = ZoomIn;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"20PvE":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZoomOut", ()=>ZoomOut);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ZoomOut = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "zoom-out",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M220 260H100C89 260 80 251 80 240C80 229 89 220 100 220H220C231 220 240 229 240 240C240 251 231 260 220 260zM391.2 51.2L292.4 150C309.8 175.8 320 206.6 320 240C320 328.4 248.4 400 160 400S0 328.4 0 240S71.6 80 160 80C193.4 80 224.2 90.2 250 107.6L348.8 8.8C354.2000000000001 3.4 361.8 0 370 0C386.6 0 400 13.4 400 30C400 38.2 396.6 45.8 391.2 51.2zM160 120C93.8 120 40 173.8 40 240S93.8 360 160 360S280 306.2000000000001 280 240S226.2 120 160 120z" : "M79.8 200.2C68.8 200.2 59.8 191.2 59.8 180.2S68.8 160.2 79.8 160.2H199.8C210.8 160.2 219.8 169.2 219.8 180.2S210.8 200.2 199.8 200.2H79.8zM311 51.4L257.6 105C271.6 126.8 279.8 152.6 279.8 180.2C279.8 257.6 217.2 320.2 139.8 320.2S-0.2 257.6 -0.2 180.2S62.4 40.2 139.8 40.2C167.6 40.2 193.4 48.6 215 62.4L268.6 9C274 3.6 281.6 0.2 289.8 0.2C306.4 0.2 319.8 13.6 319.8 30.2C319.8 38.4 316.4 46 311 51.4zM139.8 80.2C84.6 80.2 39.8 125 39.8 180.2S84.6 280.2 139.8 280.2S239.8 235.4 239.8 180.2S195 80.2 139.8 80.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ZoomOut.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ZoomOut.displayName = "Blueprint5.Icon.ZoomOut";
exports.default = ZoomOut;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LcUx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZoomToFit", ()=>ZoomToFit);
var _tslib = require("tslib");
var _react = require("react");
var _iconTypes = require("../../iconTypes");
var _svgIconContainer = require("../../svgIconContainer");
var ZoomToFit = _react.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, _iconTypes.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, _iconTypes.IconSize).LARGE : (0, _iconTypes.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return _react.createElement((0, _svgIconContainer.SVGIconContainer), (0, _tslib.__assign)({
        iconName: "zoom-to-fit",
        ref: ref
    }, props), _react.createElement("path", {
        d: isLarge ? "M20 260C31 260 40 269 40 280V360H120C131 360 140 369 140 380C140 391 131 400 120 400H20C9 400 0 391 0 380V280C0 269 9 260 20 260zM120 240C120 251 111 260 100 260C94.4 260 89.4 257.8 85.8 254.2L45.8 214.2C42.2 210.6 40 205.6 40 200C40 194.4 42.2 189.4 45.8 185.8L85.8 145.8C89.4 142.2 94.4 140 100 140C111 140 120 149 120 160C120 165.6 117.8 170.6 114.2 174.2L88.2 200L114 225.8C117.8 229.4 120 234.4 120 240zM160 280C165.6 280 170.6 282.2 174.2 285.8L200 311.8L225.8 286C229.4 282.2 234.4 280 240 280C251 280 260 289 260 300C260 305.6 257.8 310.6 254.2 314.2L214.2 354.2C210.6 357.8 205.6 360 200 360S189.4 357.8 185.8 354.2L145.8 314.2C142.2 310.6 140 305.6 140 300C140 289 149 280 160 280zM120 40H40V120C40 131 31 140 20 140S0 131 0 120V20C0 9 9 0 20 0H120C131 0 140 9 140 20C140 31 131 40 120 40zM280 160C280 149 289 140 300 140C305.6 140 310.6 142.2 314.2000000000001 145.8L354.2000000000001 185.8C357.8 189.4 360 194.4 360 200C360 205.6 357.8 210.6 354.2000000000001 214.2L314.2000000000001 254.2C310.6 257.8 305.6 260 300 260C289 260 280 251 280 240C280 234.4 282.2 229.4 285.8 225.8L311.8 200L286 174.2C282.2 170.6 280 165.6 280 160zM380 400H280C269 400 260 391 260 380C260 369 269 360 280 360H360V280C360 269 369 260 380 260S400 269 400 280V380C400 391 391 400 380 400zM240 120C234.4 120 229.4 117.8 225.8 114.2000000000001L200 88.2L174.2 114C170.6 117.8 165.6 120 160 120C149 120 140 111 140 100C140 94.4 142.2 89.4 145.8 85.8L185.8 45.8C189.4 42.2 194.4 40 200 40S210.6 42.2 214.2 45.8L254.2 85.8C257.8 89.4 260 94.4 260 100C260 111 251 120 240 120zM380 140C369 140 360 131 360 120V40H280C269 40 260 31 260 20C260 9 269 0 280 0H380C391 0 400 9 400 20V120C400 131 391 140 380 140z" : "M220 120C220 109 229 100 240 100C245.6 100 250.6 102.2 254.2 105.8L294.2000000000001 145.8C297.8 149.4 300 154.4 300 160C300 165.6 297.8 170.6 294.2000000000001 174.2L254.2 214.2C250.6 217.8 245.6 220 240 220C229 220 220 211 220 200C220 194.4 222.2 189.4 225.8 185.8L251.8 160L226 134.2C222.2 130.6 220 125.6 220 120zM20 220C31 220 40 229 40 240V280H80C91 280 100 289 100 300C100 311 91 320 80 320H20C9 320 0 311 0 300V240C0 229 9 220 20 220zM100 200C100 211 91 220 80 220C74.4 220 69.4 217.8 65.8 214.2L25.8 174.2C22.2 170.6 20 165.6 20 160C20 154.4 22.2 149.4 25.8 145.8L65.8 105.8C69.4 102.2 74.4 100 80 100C91 100 100 109 100 120C100 125.6 97.8 130.6 94.2 134.2L68.2 160L94 185.8C97.8 189.4 100 194.4 100 200zM120 220C125.6 220 130.6 222.2 134.2 225.8L160 251.8L185.8 226C189.4 222.2 194.4 220 200 220C211 220 220 229 220 240C220 245.6 217.8 250.6 214.2 254.2L174.2 294.2C170.6 297.8 165.6 300 160 300S149.4 297.8 145.8 294.2L105.8 254.2C102.2 250.6 100 245.6 100 240C100 229 109 220 120 220zM300 100C289 100 280 91 280 80V40H240C229 40 220 31 220 20C220 9 229 0 240 0H300C311 0 320 9 320 20V80C320 91 311 100 300 100zM300 320H240C229 320 220 311 220 300C220 289 229 280 240 280H280V240C280 229 289 220 300 220S320 229 320 240V300C320 311 311 320 300 320zM80 40H40V80C40 91 31 100 20 100S0 91 0 80V20C0 9 9 0 20 0H80C91 0 100 9 100 20C100 31 91 40 80 40zM200 100C194.4 100 189.4 97.8 185.8 94.2L160 68.2L134.2 94C130.6 97.8 125.6 100 120 100C109 100 100 91 100 80C100 74.4 102.2 69.4 105.8 65.8L145.8 25.8C149.4 22.2 154.4 20 160 20S170.6 22.2 174.2 25.8L214.2 65.8C217.8 69.4 220 74.4 220 80C220 91 211 100 200 100z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
ZoomToFit.defaultProps = {
    size: (0, _iconTypes.IconSize).STANDARD
};
ZoomToFit.displayName = "Blueprint5.Icon.ZoomToFit";
exports.default = ZoomToFit;

},{"tslib":"b4wpY","react":"9njXz","../../iconTypes":"kknia","../../svgIconContainer":"1BB1X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"19P1J":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpinnerSize", ()=>SpinnerSize);
parcelHelpers.export(exports, "Spinner", ()=>Spinner);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _props = require("../../common/props");
var _utils = require("../../common/utils");
var SpinnerSize;
(function(SpinnerSize) {
    SpinnerSize[SpinnerSize["SMALL"] = 20] = "SMALL";
    SpinnerSize[SpinnerSize["STANDARD"] = 50] = "STANDARD";
    SpinnerSize[SpinnerSize["LARGE"] = 100] = "LARGE";
})(SpinnerSize || (SpinnerSize = {}));
// see http://stackoverflow.com/a/18473154/3124288 for calculating arc path
var R = 45;
var SPINNER_TRACK = "M 50,50 m 0,-".concat(R, " a ").concat(R, ",").concat(R, " 0 1 1 0,").concat(R * 2, " a ").concat(R, ",").concat(R, " 0 1 1 0,-").concat(R * 2);
// unitless total length of SVG path, to which stroke-dash* properties are relative.
// https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/pathLength
// this value is the result of `<path d={SPINNER_TRACK} />.getTotalLength()` and works in all browsers:
var PATH_LENGTH = 280;
var MIN_SIZE = 10;
var STROKE_WIDTH = 4;
var MIN_STROKE_WIDTH = 16;
/**
 * Spinner component.
 *
 * @see https://blueprintjs.com/docs/#core/components/spinner
 */ var Spinner = /** @class */ function(_super) {
    (0, _tslib.__extends)(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.componentDidUpdate = function(prevProps) {
        if (prevProps.value !== this.props.value) // IE/Edge: re-render after changing value to force SVG update
        this.forceUpdate();
    };
    Spinner.prototype.render = function() {
        var _a;
        var _b = this.props, className = _b.className, intent = _b.intent, value = _b.value, _c = _b.tagName, tagName = _c === void 0 ? "div" : _c, htmlProps = (0, _tslib.__rest)(_b, [
            "className",
            "intent",
            "value",
            "tagName"
        ]);
        var size = this.getSize();
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).SPINNER, (0, _common.Classes).intentClass(intent), (_a = {}, _a[(0, _common.Classes).SPINNER_NO_SPIN] = value != null, _a), className);
        // keep spinner track width consistent at all sizes (down to about 10px).
        var strokeWidth = Math.min(MIN_STROKE_WIDTH, STROKE_WIDTH * SpinnerSize.LARGE / size);
        var strokeOffset = PATH_LENGTH - PATH_LENGTH * (value == null ? 0.25 : (0, _utils.clamp)(value, 0, 1));
        // multiple DOM elements around SVG are necessary to properly isolate animation:
        // - SVG elements in IE do not support anim/trans so they must be set on a parent HTML element.
        // - SPINNER_ANIMATION isolates svg from parent display and is always centered inside root element.
        return _react.createElement(tagName, (0, _tslib.__assign)({
            "aria-label": "loading",
            "aria-valuemax": 100,
            "aria-valuemin": 0,
            "aria-valuenow": value === undefined ? undefined : value * 100,
            className: classes,
            role: "progressbar"
        }, htmlProps), _react.createElement(tagName, {
            className: (0, _common.Classes).SPINNER_ANIMATION
        }, _react.createElement("svg", {
            width: size,
            height: size,
            strokeWidth: strokeWidth.toFixed(2),
            viewBox: this.getViewBox(strokeWidth)
        }, _react.createElement("path", {
            className: (0, _common.Classes).SPINNER_TRACK,
            d: SPINNER_TRACK
        }), _react.createElement("path", {
            className: (0, _common.Classes).SPINNER_HEAD,
            d: SPINNER_TRACK,
            pathLength: PATH_LENGTH,
            strokeDasharray: "".concat(PATH_LENGTH, " ").concat(PATH_LENGTH),
            strokeDashoffset: strokeOffset
        }))));
    };
    Spinner.prototype.validateProps = function(_a) {
        var _b = _a.className, className = _b === void 0 ? "" : _b, size = _a.size;
        if (size != null && (className.indexOf((0, _common.Classes).SMALL) >= 0 || className.indexOf((0, _common.Classes).LARGE) >= 0)) console.warn((0, _errors.SPINNER_WARN_CLASSES_SIZE));
    };
    /**
     * Resolve size to a pixel value.
     * Size can be set by className, props, default, or minimum constant.
     */ Spinner.prototype.getSize = function() {
        var _a = this.props, _b = _a.className, className = _b === void 0 ? "" : _b, size = _a.size;
        if (size == null) {
            // allow Classes constants to determine default size.
            if (className.indexOf((0, _common.Classes).SMALL) >= 0) return SpinnerSize.SMALL;
            else if (className.indexOf((0, _common.Classes).LARGE) >= 0) return SpinnerSize.LARGE;
            return SpinnerSize.STANDARD;
        }
        return Math.max(MIN_SIZE, size);
    };
    /** Compute viewbox such that stroked track sits exactly at edge of image frame. */ Spinner.prototype.getViewBox = function(strokeWidth) {
        var radius = R + strokeWidth / 2;
        var viewBoxX = (50 - radius).toFixed(2);
        var viewBoxWidth = (radius * 2).toFixed(2);
        return "".concat(viewBoxX, " ").concat(viewBoxX, " ").concat(viewBoxWidth, " ").concat(viewBoxWidth);
    };
    Spinner.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Spinner");
    return Spinner;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/errors":"lyD8m","../../common/props":"dBcIV","../../common/utils":"56UdR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cIHFN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>Text);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _useIsomorphicLayoutEffect = require("../../hooks/useIsomorphicLayoutEffect");
var Text = _react.forwardRef(function(_a, forwardedRef) {
    var _b;
    var children = _a.children, _c = _a.tagName, tagName = _c === void 0 ? "div" : _c, title = _a.title, className = _a.className, ellipsize = _a.ellipsize, htmlProps = (0, _tslib.__rest)(_a, [
        "children",
        "tagName",
        "title",
        "className",
        "ellipsize"
    ]);
    var contentMeasuringRef = _react.useRef();
    var textRef = _react.useMemo(function() {
        return (0, _common.mergeRefs)(contentMeasuringRef, forwardedRef);
    }, [
        forwardedRef
    ]);
    var _d = _react.useState(""), textContent = _d[0], setTextContent = _d[1];
    var _e = _react.useState(), isContentOverflowing = _e[0], setIsContentOverflowing = _e[1];
    // try to be conservative about running this effect, since querying scrollWidth causes the browser to reflow / recalculate styles,
    // which can be very expensive for long lists (for example, in long Menus)
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        var _a;
        if (((_a = contentMeasuringRef.current) === null || _a === void 0 ? void 0 : _a.textContent) != null) {
            setIsContentOverflowing(ellipsize && contentMeasuringRef.current.scrollWidth > contentMeasuringRef.current.clientWidth);
            setTextContent(contentMeasuringRef.current.textContent);
        }
    }, [
        contentMeasuringRef,
        children,
        ellipsize
    ]);
    return _react.createElement(tagName, (0, _tslib.__assign)((0, _tslib.__assign)({}, htmlProps), {
        className: (0, _classnamesDefault.default)((_b = {}, _b[(0, _common.Classes).TEXT_OVERFLOW_ELLIPSIS] = ellipsize, _b), className),
        ref: textRef,
        title: title !== null && title !== void 0 ? title : isContentOverflowing ? textContent : undefined
    }), children);
});
Text.defaultProps = {
    ellipsize: false
};
Text.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Text");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","../../hooks/useIsomorphicLayoutEffect":"7cQbp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7cQbp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react");
var _domUtils = require("../common/utils/domUtils");
var useIsomorphicLayoutEffect = (0, _domUtils.hasDOMEnvironment)() ? _react.useLayoutEffect : _react.useEffect;

},{"react":"9njXz","../common/utils/domUtils":"K845P","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6MadC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dialog", ()=>Dialog);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _utils = require("../../common/utils");
var _buttons = require("../button/buttons");
var _html = require("../html/html");
var _icon = require("../icon/icon");
var _overlay2 = require("../overlay2/overlay2");
/**
 * Dialog component.
 *
 * @see https://blueprintjs.com/docs/#core/components/dialog
 */ var Dialog = /** @class */ function(_super) {
    (0, _tslib.__extends)(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.childRef = _react.createRef();
        var id = (0, _utils.uniqueId)("bp-dialog");
        _this.titleId = "title-".concat(id);
        return _this;
    }
    Dialog.prototype.render = function() {
        var _a, _b;
        var _c = this.props, className = _c.className, children = _c.children, containerRef = _c.containerRef, style = _c.style, title = _c.title, _d = _c.role, role = _d === void 0 ? "dialog" : _d, overlayProps = (0, _tslib.__rest)(_c, [
            "className",
            "children",
            "containerRef",
            "style",
            "title",
            "role"
        ]);
        return _react.createElement((0, _overlay2.Overlay2), (0, _tslib.__assign)({}, overlayProps, {
            className: (0, _common.Classes).OVERLAY_SCROLL_CONTAINER,
            childRef: this.childRef,
            hasBackdrop: true
        }), _react.createElement("div", {
            className: (0, _common.Classes).DIALOG_CONTAINER,
            ref: (0, _common.mergeRefs)(containerRef, this.childRef)
        }, _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).DIALOG, className),
            role: role,
            "aria-modal": (_a = overlayProps.enforceFocus) !== null && _a !== void 0 ? _a : (_b = (0, _overlay2.Overlay2).defaultProps) === null || _b === void 0 ? void 0 : _b.enforceFocus,
            "aria-labelledby": this.props["aria-labelledby"] || (title ? this.titleId : undefined),
            "aria-describedby": this.props["aria-describedby"],
            style: style
        }, this.maybeRenderHeader(), children)));
    };
    Dialog.prototype.validateProps = function(props) {
        if (props.title == null) {
            if (props.icon != null) console.warn(_errors.DIALOG_WARN_NO_HEADER_ICON);
            if (props.isCloseButtonShown != null) console.warn(_errors.DIALOG_WARN_NO_HEADER_CLOSE_BUTTON);
        }
    };
    Dialog.prototype.maybeRenderCloseButton = function() {
        // show close button if prop is undefined or null
        // this gives us a behavior as if the default value were `true`
        if (this.props.isCloseButtonShown !== false) return _react.createElement((0, _buttons.Button), {
            "aria-label": "Close",
            className: (0, _common.Classes).DIALOG_CLOSE_BUTTON,
            icon: _react.createElement((0, _icons.SmallCross), {
                size: (0, _icons.IconSize).STANDARD
            }),
            minimal: true,
            onClick: this.props.onClose
        });
        else return undefined;
    };
    Dialog.prototype.maybeRenderHeader = function() {
        var _a = this.props, icon = _a.icon, title = _a.title;
        if (title == null) return undefined;
        return _react.createElement("div", {
            className: (0, _common.Classes).DIALOG_HEADER
        }, _react.createElement((0, _icon.Icon), {
            icon: icon,
            size: (0, _icons.IconSize).STANDARD,
            "aria-hidden": true,
            tabIndex: -1
        }), _react.createElement((0, _html.H6), {
            id: this.titleId
        }, title), this.maybeRenderCloseButton());
    };
    Dialog.defaultProps = {
        canOutsideClickClose: true,
        isOpen: false
    };
    Dialog.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Dialog");
    return Dialog;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../../common/errors":"lyD8m","../../common/utils":"56UdR","../button/buttons":"glm43","../html/html":"6epty","../icon/icon":"duMtK","../overlay2/overlay2":"3eEFv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6epty":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "H1", ()=>H1);
parcelHelpers.export(exports, "H2", ()=>H2);
parcelHelpers.export(exports, "H3", ()=>H3);
parcelHelpers.export(exports, "H4", ()=>H4);
parcelHelpers.export(exports, "H5", ()=>H5);
parcelHelpers.export(exports, "H6", ()=>H6);
parcelHelpers.export(exports, "Blockquote", ()=>Blockquote);
parcelHelpers.export(exports, "Code", ()=>Code);
parcelHelpers.export(exports, "Pre", ()=>Pre);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "OL", ()=>OL);
parcelHelpers.export(exports, "UL", ()=>UL);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _classes = require("../../common/classes");
function htmlElement(tagName, tagClassName) {
    /* eslint-disable-next-line react/display-name */ return _react.forwardRef(function(props, ref) {
        var className = props.className, children = props.children, htmlProps = (0, _tslib.__rest)(props, [
            "className",
            "children"
        ]);
        return _react.createElement(tagName, (0, _tslib.__assign)((0, _tslib.__assign)({}, htmlProps), {
            className: (0, _classnamesDefault.default)(tagClassName, className),
            ref: ref
        }), children);
    });
}
var H1 = htmlElement("h1", (0, _classes.HEADING));
var H2 = htmlElement("h2", (0, _classes.HEADING));
var H3 = htmlElement("h3", (0, _classes.HEADING));
var H4 = htmlElement("h4", (0, _classes.HEADING));
var H5 = htmlElement("h5", (0, _classes.HEADING));
var H6 = htmlElement("h6", (0, _classes.HEADING));
var Blockquote = htmlElement("blockquote", (0, _classes.BLOCKQUOTE));
var Code = htmlElement("code", (0, _classes.CODE));
var Pre = htmlElement("pre", (0, _classes.CODE_BLOCK));
var Label = htmlElement("label", (0, _classes.LABEL));
var OL = htmlElement("ol", (0, _classes.LIST));
var UL = htmlElement("ul", (0, _classes.LIST));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common/classes":"2PICA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3eEFv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Overlay2", ()=>Overlay2);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactTransitionGroup = require("react-transition-group");
var _reactUid = require("react-uid");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _props = require("../../common/props");
var _utils = require("../../common/utils");
var _domUtils = require("../../common/utils/domUtils");
var _useOverlayStack = require("../../hooks/overlays/useOverlayStack");
var _usePrevious = require("../../hooks/usePrevious");
var _overlayUtils = require("../overlay/overlayUtils");
var _portal = require("../portal/portal");
var Overlay2 = _react.forwardRef(function(props, forwardedRef) {
    var _a;
    var _b, _c;
    var autoFocus = props.autoFocus, backdropClassName = props.backdropClassName, backdropProps = props.backdropProps, canEscapeKeyClose = props.canEscapeKeyClose, canOutsideClickClose = props.canOutsideClickClose, childRef = props.childRef, childRefs = props.childRefs, children = props.children, className = props.className, enforceFocus = props.enforceFocus, hasBackdrop = props.hasBackdrop, isOpen = props.isOpen, lazy = props.lazy, onClose = props.onClose, onClosed = props.onClosed, onClosing = props.onClosing, onOpened = props.onOpened, onOpening = props.onOpening, portalClassName = props.portalClassName, portalContainer = props.portalContainer, shouldReturnFocusOnClose = props.shouldReturnFocusOnClose, transitionDuration = props.transitionDuration, transitionName = props.transitionName, usePortal = props.usePortal;
    useOverlay2Validation(props);
    var _d = (0, _useOverlayStack.useOverlayStack)(), closeOverlay = _d.closeOverlay, getLastOpened = _d.getLastOpened, getThisOverlayAndDescendants = _d.getThisOverlayAndDescendants, openOverlay = _d.openOverlay;
    var _e = _react.useState(false), isAutoFocusing = _e[0], setIsAutoFocusing = _e[1];
    var _f = _react.useState(false), hasEverOpened = _f[0], setHasEverOpened = _f[1];
    var lastActiveElementBeforeOpened = _react.useRef(null);
    /** Ref for container element, containing all children and the backdrop */ var containerElement = _react.useRef(null);
    /** Ref for backdrop element */ var backdropElement = _react.useRef(null);
    /* An empty, keyboard-focusable div at the beginning of the Overlay content */ var startFocusTrapElement = _react.useRef(null);
    /* An empty, keyboard-focusable div at the end of the Overlay content */ var endFocusTrapElement = _react.useRef(null);
    /**
     * Locally-generated DOM ref for a singleton child element.
     * This is only used iff the user does not specify the `childRef` or `childRefs` props.
     */ var localChildRef = _react.useRef(null);
    var bringFocusInsideOverlay = _react.useCallback(function() {
        // always delay focus manipulation to just before repaint to prevent scroll jumping
        return requestAnimationFrame(function() {
            var _a;
            // container element may be undefined between component mounting and Portal rendering
            // activeElement may be undefined in some rare cases in IE
            var container = (0, _utils.getRef)(containerElement);
            var activeElement = (0, _utils.getActiveElement)(container);
            if (container == null || activeElement == null) return;
            // Overlay2 is guaranteed to be mounted here
            var isFocusOutsideModal = !container.contains(activeElement);
            if (isFocusOutsideModal) {
                (_a = (0, _utils.getRef)(startFocusTrapElement)) === null || _a === void 0 || _a.focus({
                    preventScroll: true
                });
                setIsAutoFocusing(false);
            }
        });
    }, []);
    /** Unique ID for this overlay in the global stack */ var id = useOverlay2ID();
    // N.B. use `null` here and not simply `undefined` because `useImperativeHandle` will set `null` on unmount,
    // and we need the following code to be resilient to that value.
    var instance = _react.useRef(null);
    /**
     * When multiple `enforceFocus` Overlays are open, this event handler is only active for the most
     * recently opened one to avoid Overlays competing with each other for focus.
     */ var handleDocumentFocus = _react.useCallback(function(e) {
        // get the actual target even in the Shadow DOM
        // see https://github.com/palantir/blueprint/issues/4220
        var eventTarget = e.composed ? e.composedPath()[0] : e.target;
        var container = (0, _utils.getRef)(containerElement);
        if (container != null && eventTarget instanceof Node && !container.contains(eventTarget)) {
            // prevent default focus behavior (sometimes auto-scrolls the page)
            e.preventDefault();
            e.stopImmediatePropagation();
            bringFocusInsideOverlay();
        }
    }, [
        bringFocusInsideOverlay
    ]);
    // N.B. this listener is only kept attached when `isOpen={true}` and `canOutsideClickClose={true}`
    var handleDocumentMousedown = _react.useCallback(function(e) {
        // get the actual target even in the Shadow DOM
        // see https://github.com/palantir/blueprint/issues/4220
        var eventTarget = e.composed ? e.composedPath()[0] : e.target;
        var thisOverlayAndDescendants = getThisOverlayAndDescendants(id);
        var isClickInThisOverlayOrDescendant = thisOverlayAndDescendants.some(function(_a) {
            var containerRef = _a.containerElement;
            // `elem` is the container of backdrop & content, so clicking directly on that container
            // should not count as being "inside" the overlay.
            var elem = (0, _utils.getRef)(containerRef);
            return (elem === null || elem === void 0 ? void 0 : elem.contains(eventTarget)) && !elem.isSameNode(eventTarget);
        });
        if (!isClickInThisOverlayOrDescendant) // casting to any because this is a native event
        onClose === null || onClose === void 0 || onClose(e);
    }, [
        getThisOverlayAndDescendants,
        id,
        onClose
    ]);
    // send this instance's imperative handle to the the forwarded ref as well as our local ref
    var ref = _react.useMemo(function() {
        return (0, _common.mergeRefs)(forwardedRef, instance);
    }, [
        forwardedRef
    ]);
    _react.useImperativeHandle(ref, function() {
        return {
            bringFocusInsideOverlay: bringFocusInsideOverlay,
            containerElement: containerElement,
            handleDocumentFocus: handleDocumentFocus,
            handleDocumentMousedown: handleDocumentMousedown,
            id: id,
            props: {
                autoFocus: autoFocus,
                enforceFocus: enforceFocus,
                hasBackdrop: hasBackdrop,
                usePortal: usePortal
            }
        };
    }, [
        autoFocus,
        bringFocusInsideOverlay,
        enforceFocus,
        handleDocumentFocus,
        handleDocumentMousedown,
        hasBackdrop,
        id,
        usePortal
    ]);
    var handleContainerKeyDown = _react.useCallback(function(e) {
        if (e.key === "Escape" && canEscapeKeyClose) {
            onClose === null || onClose === void 0 || onClose(e);
            // prevent other overlays from closing
            e.stopPropagation();
            // prevent browser-specific escape key behavior (Safari exits fullscreen)
            e.preventDefault();
        }
    }, [
        canEscapeKeyClose,
        onClose
    ]);
    var overlayWillOpen = _react.useCallback(function() {
        if (instance.current == null) return;
        var lastOpenedOverlay = getLastOpened();
        if ((lastOpenedOverlay === null || lastOpenedOverlay === void 0 ? void 0 : lastOpenedOverlay.handleDocumentFocus) !== undefined) document.removeEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */ true);
        openOverlay(instance.current);
        if (autoFocus) {
            setIsAutoFocusing(true);
            bringFocusInsideOverlay();
        }
        (0, _utils.setRef)(lastActiveElementBeforeOpened, (0, _utils.getActiveElement)((0, _utils.getRef)(containerElement)));
    }, [
        autoFocus,
        bringFocusInsideOverlay,
        getLastOpened,
        openOverlay
    ]);
    var overlayWillClose = _react.useCallback(function() {
        var _a;
        document.removeEventListener("focus", handleDocumentFocus, /* useCapture */ true);
        document.removeEventListener("mousedown", handleDocumentMousedown);
        // N.B. `instance.current` may be null at this point if we are cleaning up an open overlay during the unmount phase
        // (this is common, for example, with context menu's singleton `showContextMenu` / `hideContextMenu` imperative APIs).
        closeOverlay(id);
        var lastOpenedOverlay = getLastOpened();
        if (lastOpenedOverlay !== undefined) // Only bring focus back to last overlay if it had autoFocus _and_ enforceFocus enabled.
        // If `autoFocus={false}`, it's likely that the overlay never received focus in the first place,
        // so it would be surprising for us to send it there. See https://github.com/palantir/blueprint/issues/4921
        {
            if (lastOpenedOverlay.props.autoFocus && lastOpenedOverlay.props.enforceFocus) {
                (_a = lastOpenedOverlay.bringFocusInsideOverlay) === null || _a === void 0 || _a.call(lastOpenedOverlay);
                if (lastOpenedOverlay.handleDocumentFocus !== undefined) document.addEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */ true);
            }
        }
    }, [
        closeOverlay,
        getLastOpened,
        handleDocumentFocus,
        handleDocumentMousedown,
        id
    ]);
    var prevIsOpen = (_b = (0, _usePrevious.usePrevious)(isOpen)) !== null && _b !== void 0 ? _b : false;
    _react.useEffect(function() {
        if (isOpen) setHasEverOpened(true);
        if (!prevIsOpen && isOpen) // just opened
        overlayWillOpen();
        if (prevIsOpen && !isOpen) // just closed
        overlayWillClose();
    }, [
        isOpen,
        overlayWillOpen,
        overlayWillClose,
        prevIsOpen
    ]);
    // Important: clean up old document-level event listeners if their memoized values change (this is rare, but
    // may happen, for example, if a user forgets to use `React.useCallback` in the `props.onClose` value).
    // Otherwise, we will lose the reference to those values and create a memory leak since we won't be able
    // to successfully detach them inside overlayWillClose.
    _react.useEffect(function() {
        if (!isOpen || !(canOutsideClickClose && !hasBackdrop)) return;
        document.addEventListener("mousedown", handleDocumentMousedown);
        return function() {
            document.removeEventListener("mousedown", handleDocumentMousedown);
        };
    }, [
        handleDocumentMousedown,
        isOpen,
        canOutsideClickClose,
        hasBackdrop
    ]);
    _react.useEffect(function() {
        if (!isOpen || !enforceFocus) return;
        // Focus events do not bubble, but setting useCapture allows us to listen in and execute
        // our handler before all others
        document.addEventListener("focus", handleDocumentFocus, /* useCapture */ true);
        return function() {
            document.removeEventListener("focus", handleDocumentFocus, /* useCapture */ true);
        };
    }, [
        handleDocumentFocus,
        enforceFocus,
        isOpen
    ]);
    var overlayWillCloseRef = _react.useRef(overlayWillClose);
    overlayWillCloseRef.current = overlayWillClose;
    _react.useEffect(function() {
        // run cleanup code once on unmount, ensuring we call the most recent overlayWillClose callback
        // by storing in a ref and keeping up to date
        return function() {
            overlayWillCloseRef.current();
        };
    }, []);
    var handleTransitionExited = _react.useCallback(function(node) {
        var lastActiveElement = (0, _utils.getRef)(lastActiveElementBeforeOpened);
        if (shouldReturnFocusOnClose && lastActiveElement instanceof HTMLElement) lastActiveElement.focus();
        onClosed === null || onClosed === void 0 || onClosed(node);
    }, [
        onClosed,
        shouldReturnFocusOnClose
    ]);
    // N.B. CSSTransition requires this callback to be defined, even if it's unused.
    var handleTransitionAddEnd = _react.useCallback(function() {
    // no-op
    }, []);
    /**
     * Gets the relevant DOM ref for a child element using the `childRef` or `childRefs` props (if possible).
     * This ref is necessary for `CSSTransition` to work in React 18 without relying on `ReactDOM.findDOMNode`.
     *
     * Returns `undefined` if the user did not specify either of those props. In those cases, we use the ref we
     * have locally generated and expect that the user _did not_ specify their own `ref` on the child element
     * (it will get clobbered / overriden).
     *
     * @see https://reactcommunity.org/react-transition-group/css-transition
     */ var getUserChildRef = _react.useCallback(function(child) {
        if (childRef != null) return childRef;
        else if (childRefs != null) {
            var key = child.key;
            if (key == null) {
                if (!(0, _utils.isNodeEnv)("production")) console.error((0, _errors.OVERLAY_CHILD_REQUIRES_KEY));
                return undefined;
            }
            return childRefs[key];
        }
        return undefined;
    }, [
        childRef,
        childRefs
    ]);
    var maybeRenderChild = _react.useCallback(function(child) {
        if (child == null || (0, _utils.isEmptyString)(child)) return null;
        // decorate the child with a few injected props
        var userChildRef = getUserChildRef(child);
        var childProps = (0, _utils.isReactElement)(child) ? child.props : {};
        // if the child is a string, number, or fragment, it will be wrapped in a <span> element
        var decoratedChild = (0, _utils.ensureElement)(child, "span", {
            className: (0, _classnamesDefault.default)(childProps.className, (0, _common.Classes).OVERLAY_CONTENT),
            // IMPORTANT: only inject our ref if the user didn't specify childRef or childRefs already. Otherwise,
            // we risk clobbering the user's ref (which we cannot inspect here while cloning/decorating the child).
            ref: userChildRef === undefined ? localChildRef : undefined,
            tabIndex: enforceFocus || autoFocus ? 0 : undefined
        });
        var resolvedChildRef = userChildRef !== null && userChildRef !== void 0 ? userChildRef : localChildRef;
        return _react.createElement((0, _reactTransitionGroup.CSSTransition), {
            addEndListener: handleTransitionAddEnd,
            classNames: transitionName,
            // HACKHACK: CSSTransition types are slightly incompatible with React types here.
            // React prefers `| null` but not `| undefined` for the ref value, while
            // CSSTransition _demands_ that `| undefined` be part of the element type.
            nodeRef: resolvedChildRef,
            onEntered: getLifecycleCallbackWithChildRef(onOpened, resolvedChildRef),
            onEntering: getLifecycleCallbackWithChildRef(onOpening, resolvedChildRef),
            onExited: getLifecycleCallbackWithChildRef(handleTransitionExited, resolvedChildRef),
            onExiting: getLifecycleCallbackWithChildRef(onClosing, resolvedChildRef),
            timeout: transitionDuration
        }, decoratedChild);
    }, [
        autoFocus,
        enforceFocus,
        getUserChildRef,
        handleTransitionAddEnd,
        handleTransitionExited,
        onClosing,
        onOpened,
        onOpening,
        transitionDuration,
        transitionName
    ]);
    var handleBackdropMouseDown = _react.useCallback(function(e) {
        var _a;
        if (canOutsideClickClose) onClose === null || onClose === void 0 || onClose(e);
        if (enforceFocus) bringFocusInsideOverlay();
        (_a = backdropProps === null || backdropProps === void 0 ? void 0 : backdropProps.onMouseDown) === null || _a === void 0 || _a.call(backdropProps, e);
    }, [
        backdropProps,
        bringFocusInsideOverlay,
        canOutsideClickClose,
        enforceFocus,
        onClose
    ]);
    var renderDummyElement = _react.useCallback(function(key, dummyElementProps) {
        return _react.createElement((0, _reactTransitionGroup.CSSTransition), {
            addEndListener: handleTransitionAddEnd,
            classNames: transitionName,
            key: key,
            nodeRef: dummyElementProps.ref,
            timeout: transitionDuration,
            unmountOnExit: true
        }, _react.createElement("div", (0, _tslib.__assign)({
            tabIndex: 0
        }, dummyElementProps)));
    }, [
        handleTransitionAddEnd,
        transitionDuration,
        transitionName
    ]);
    /**
     * Ensures repeatedly pressing shift+tab keeps focus inside the Overlay. Moves focus to
     * the `endFocusTrapElement` or the first keyboard-focusable element in the Overlay (excluding
     * the `startFocusTrapElement`), depending on whether the element losing focus is inside the
     * Overlay.
     */ var handleStartFocusTrapElementFocus = _react.useCallback(function(e) {
        if (!enforceFocus || isAutoFocusing) return;
        // e.relatedTarget will not be defined if this was a programmatic focus event, as is the
        // case when we call this.bringFocusInsideOverlay() after a user clicked on the backdrop.
        // Otherwise, we're handling a user interaction, and we should wrap around to the last
        // element in this transition group.
        var container = (0, _utils.getRef)(containerElement);
        var endFocusTrap = (0, _utils.getRef)(endFocusTrapElement);
        if (e.relatedTarget != null && (container === null || container === void 0 ? void 0 : container.contains(e.relatedTarget)) && e.relatedTarget !== endFocusTrap) endFocusTrap === null || endFocusTrap === void 0 || endFocusTrap.focus({
            preventScroll: true
        });
    }, [
        enforceFocus,
        isAutoFocusing
    ]);
    /**
     * Wrap around to the end of the dialog if `enforceFocus` is enabled.
     */ var handleStartFocusTrapElementKeyDown = _react.useCallback(function(e) {
        var _a;
        if (!enforceFocus) return;
        if (e.shiftKey && e.key === "Tab") {
            var lastFocusableElement = (0, _overlayUtils.getKeyboardFocusableElements)(containerElement).pop();
            if (lastFocusableElement != null) lastFocusableElement.focus();
            else (_a = (0, _utils.getRef)(endFocusTrapElement)) === null || _a === void 0 || _a.focus({
                preventScroll: true
            });
        }
    }, [
        enforceFocus
    ]);
    /**
     * Ensures repeatedly pressing tab keeps focus inside the Overlay. Moves focus to the
     * `startFocusTrapElement` or the last keyboard-focusable element in the Overlay (excluding the
     * `startFocusTrapElement`), depending on whether the element losing focus is inside the
     * Overlay.
     */ var handleEndFocusTrapElementFocus = _react.useCallback(function(e) {
        var _a;
        // No need for this.props.enforceFocus check here because this element is only rendered
        // when that prop is true.
        // During user interactions, e.relatedTarget will be defined, and we should wrap around to the
        // "start focus trap" element.
        // Otherwise, we're handling a programmatic focus event, which can only happen after a user
        // presses shift+tab from the first focusable element in the overlay.
        var startFocusTrap = (0, _utils.getRef)(startFocusTrapElement);
        if (e.relatedTarget != null && ((_a = (0, _utils.getRef)(containerElement)) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget)) && e.relatedTarget !== startFocusTrap) {
            var firstFocusableElement = (0, _overlayUtils.getKeyboardFocusableElements)(containerElement).shift();
            // ensure we don't re-focus an already active element by comparing against e.relatedTarget
            if (!isAutoFocusing && firstFocusableElement != null && firstFocusableElement !== e.relatedTarget) firstFocusableElement.focus();
            else startFocusTrap === null || startFocusTrap === void 0 || startFocusTrap.focus({
                preventScroll: true
            });
        } else {
            var lastFocusableElement = (0, _overlayUtils.getKeyboardFocusableElements)(containerElement).pop();
            if (lastFocusableElement != null) lastFocusableElement.focus();
            else // Keeps focus within Overlay even if there are no keyboard-focusable children
            startFocusTrap === null || startFocusTrap === void 0 || startFocusTrap.focus({
                preventScroll: true
            });
        }
    }, [
        isAutoFocusing
    ]);
    var maybeBackdrop = _react.useMemo(function() {
        return hasBackdrop && isOpen ? _react.createElement((0, _reactTransitionGroup.CSSTransition), {
            classNames: transitionName,
            key: "__backdrop",
            nodeRef: backdropElement,
            timeout: transitionDuration,
            addEndListener: handleTransitionAddEnd
        }, _react.createElement("div", (0, _tslib.__assign)({}, backdropProps, {
            className: (0, _classnamesDefault.default)((0, _common.Classes).OVERLAY_BACKDROP, backdropClassName, backdropProps === null || backdropProps === void 0 ? void 0 : backdropProps.className),
            onMouseDown: handleBackdropMouseDown,
            ref: backdropElement
        }))) : null;
    }, [
        backdropClassName,
        backdropProps,
        handleBackdropMouseDown,
        handleTransitionAddEnd,
        hasBackdrop,
        isOpen,
        transitionDuration,
        transitionName
    ]);
    // no reason to render anything at all if we're being truly lazy
    if (lazy && !hasEverOpened) return null;
    // TransitionGroup types require single array of children; does not support nested arrays.
    // So we must collapse backdrop and children into one array, and every item must be wrapped in a
    // Transition element (no ReactText allowed).
    var childrenWithTransitions = isOpen ? (_c = _react.Children.map(children, maybeRenderChild)) !== null && _c !== void 0 ? _c : [] : [];
    // const maybeBackdrop = maybeRenderBackdrop();
    if (maybeBackdrop !== null) childrenWithTransitions.unshift(maybeBackdrop);
    if (isOpen && (autoFocus || enforceFocus) && childrenWithTransitions.length > 0) {
        childrenWithTransitions.unshift(renderDummyElement("__start", {
            className: (0, _common.Classes).OVERLAY_START_FOCUS_TRAP,
            onFocus: handleStartFocusTrapElementFocus,
            onKeyDown: handleStartFocusTrapElementKeyDown,
            ref: startFocusTrapElement
        }));
        if (enforceFocus) childrenWithTransitions.push(renderDummyElement("__end", {
            className: (0, _common.Classes).OVERLAY_END_FOCUS_TRAP,
            onFocus: handleEndFocusTrapElementFocus,
            ref: endFocusTrapElement
        }));
    }
    var transitionGroup = _react.createElement("div", {
        "aria-live": "polite",
        className: (0, _classnamesDefault.default)((0, _common.Classes).OVERLAY, (_a = {}, _a[(0, _common.Classes).OVERLAY_OPEN] = isOpen, _a[(0, _common.Classes).OVERLAY_INLINE] = !usePortal, _a), className),
        onKeyDown: handleContainerKeyDown,
        ref: containerElement
    }, _react.createElement((0, _reactTransitionGroup.TransitionGroup), {
        appear: true,
        component: null
    }, childrenWithTransitions));
    if (usePortal) return _react.createElement((0, _portal.Portal), {
        className: portalClassName,
        container: portalContainer
    }, transitionGroup);
    else return transitionGroup;
});
Overlay2.defaultProps = {
    autoFocus: true,
    backdropProps: {},
    canEscapeKeyClose: true,
    canOutsideClickClose: true,
    enforceFocus: true,
    hasBackdrop: true,
    isOpen: false,
    lazy: (0, _domUtils.hasDOMEnvironment)(),
    shouldReturnFocusOnClose: true,
    transitionDuration: 300,
    transitionName: (0, _common.Classes).OVERLAY,
    usePortal: true
};
Overlay2.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Overlay2");
function useOverlay2Validation(_a) {
    var childRef = _a.childRef, childRefs = _a.childRefs, children = _a.children;
    var numChildren = _react.Children.count(children);
    _react.useEffect(function() {
        if ((0, _utils.isNodeEnv)("production")) return;
        if (childRef != null && childRefs != null) console.error((0, _errors.OVERLAY_CHILD_REF_AND_REFS_MUTEX));
        if (numChildren > 1 && childRefs == null) console.error((0, _errors.OVERLAY_WITH_MULTIPLE_CHILDREN_REQUIRES_CHILD_REFS));
    }, [
        childRef,
        childRefs,
        numChildren
    ]);
}
/**
 * Generates a unique ID for a given Overlay which persists across the component's lifecycle.
 */ function useOverlay2ID() {
    // TODO: migrate to React.useId() in React 18
    var id = (0, _reactUid.useUID)();
    return "".concat(Overlay2.displayName, "-").concat(id);
}
// N.B. the `onExiting` callback is not provided with the `node` argument as suggested in CSSTransition types since
// we are using the `nodeRef` prop, so we must inject it dynamically.
function getLifecycleCallbackWithChildRef(callback, childRef) {
    return function() {
        if ((childRef === null || childRef === void 0 ? void 0 : childRef.current) != null) callback === null || callback === void 0 || callback(childRef.current);
    };
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","react-transition-group":"hnCQJ","react-uid":"iXPEp","../../common":"3QDnh","../../common/errors":"lyD8m","../../common/props":"dBcIV","../../common/utils":"56UdR","../../common/utils/domUtils":"K845P","../../hooks/overlays/useOverlayStack":"dVB1g","../../hooks/usePrevious":"2FGmg","../overlay/overlayUtils":"hZFxO","../portal/portal":"kksjR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hnCQJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", ()=>(0, _csstransitionDefault.default));
parcelHelpers.export(exports, "ReplaceTransition", ()=>(0, _replaceTransitionDefault.default));
parcelHelpers.export(exports, "SwitchTransition", ()=>(0, _switchTransitionDefault.default));
parcelHelpers.export(exports, "TransitionGroup", ()=>(0, _transitionGroupDefault.default));
parcelHelpers.export(exports, "Transition", ()=>(0, _transitionDefault.default));
parcelHelpers.export(exports, "config", ()=>(0, _configDefault.default));
var _csstransition = require("./CSSTransition");
var _csstransitionDefault = parcelHelpers.interopDefault(_csstransition);
var _replaceTransition = require("./ReplaceTransition");
var _replaceTransitionDefault = parcelHelpers.interopDefault(_replaceTransition);
var _switchTransition = require("./SwitchTransition");
var _switchTransitionDefault = parcelHelpers.interopDefault(_switchTransition);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);

},{"./CSSTransition":"iyv3L","./ReplaceTransition":false,"./SwitchTransition":false,"./TransitionGroup":"4WN9V","./Transition":false,"./config":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iyv3L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _propTypes1 = require("./utils/PropTypes");
var _reflow = require("./utils/reflow");
var _addClass1 = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _addClassDefault.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _removeClassDefault.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, _reflow.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass1(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) removeClass(node, baseClassName);
        if (activeClassName) removeClass(node, activeClassName);
        if (doneClassName) removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionDefault.default), (0, _extendsDefault.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, _reactDefault.default).Component);
CSSTransition.defaultProps = {
    classNames: ''
};
CSSTransition.propTypes = {};
exports.default = CSSTransition;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","dom-helpers/addClass":"16v5y","dom-helpers/removeClass":"cUvLe","react":"9njXz","./Transition":"6LVcl","./utils/PropTypes":"8gMVu","./utils/reflow":"8V7Al","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cnxy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"9UMxe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9UMxe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16v5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

},{"./hasClass":"3I5QN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3I5QN":[function(require,module,exports,__globalThis) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cUvLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LVcl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","react-dom":"2ApDx","./config":"7vGu2","./utils/PropTypes":"8gMVu","./TransitionGroupContext":"162y0","./utils/reflow":"8V7Al","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vGu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gMVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"162y0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8V7Al":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4WN9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _childMapping = require("./utils/ChildMapping");
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, _assertThisInitializedDefault.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _childMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _childMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _childMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, _extendsDefault.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, _reactDefault.default).Component);
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
exports.default = TransitionGroup;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","./TransitionGroupContext":"162y0","./utils/ChildMapping":"kq3eN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJtsr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kq3eN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ parcelHelpers.export(exports, "getChildMapping", ()=>getChildMapping);
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ parcelHelpers.export(exports, "mergeChildMappings", ()=>mergeChildMappings);
parcelHelpers.export(exports, "getInitialChildMapping", ()=>getInitialChildMapping);
parcelHelpers.export(exports, "getNextChildMapping", ()=>getNextChildMapping);
var _react = require("react");
function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, _react.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, 'appear', props),
            enter: getProp(child, 'enter', props),
            exit: getProp(child, 'exit', props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iXPEp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateUID", ()=>(0, _uid.generateUID));
parcelHelpers.export(exports, "uid", ()=>(0, _uid.uid));
parcelHelpers.export(exports, "UID", ()=>(0, _uidcomponent.UID));
parcelHelpers.export(exports, "UIDConsumer", ()=>(0, _control.UIDConsumer));
parcelHelpers.export(exports, "UIDReset", ()=>(0, _control.UIDReset));
parcelHelpers.export(exports, "UIDFork", ()=>(0, _control.UIDFork));
parcelHelpers.export(exports, "useUID", ()=>(0, _hooks.useUID));
parcelHelpers.export(exports, "useUIDSeed", ()=>(0, _hooks.useUIDSeed));
var _control = require("./Control");
var _uidcomponent = require("./UIDComponent");
var _hooks = require("./hooks");
var _uid = require("./uid");

},{"./Control":false,"./UIDComponent":false,"./hooks":"74m4B","./uid":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"74m4B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUID", ()=>useUID);
parcelHelpers.export(exports, "useUIDSeed", ()=>useUIDSeed);
var _react = require("react");
var _context = require("./context");
var generateUID = function(context) {
    var quartz = context || (0, _context.counter);
    var prefix = (0, _context.getPrefix)(quartz);
    var id = (0, _context.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var useUIDState = function() {
    var context = (0, _react.useContext)((0, _context.source));
    var uid = (0, _react.useState)(function() {
        return generateUID(context);
    })[0];
    return uid;
};
var useUID = function() {
    var uid = useUIDState().uid;
    return uid;
};
var useUIDSeed = function() {
    var gen = useUIDState().gen;
    return gen;
};

},{"react":"9njXz","./context":"hTJVg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hTJVg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSource", ()=>createSource);
parcelHelpers.export(exports, "counter", ()=>counter);
parcelHelpers.export(exports, "source", ()=>source);
parcelHelpers.export(exports, "getId", ()=>getId);
parcelHelpers.export(exports, "getPrefix", ()=>getPrefix);
var _react = require("react");
var _uid = require("./uid");
var createSource = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, _uid.generateUID)()
    };
};
var counter = createSource();
var source = _react.createContext(createSource());
var getId = function(source) {
    return source.value++;
};
var getPrefix = function(source) {
    return source ? source.prefix : '';
};

},{"react":"9njXz","./uid":"gAviQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gAviQ":[function(require,module,exports,__globalThis) {
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateUID", ()=>generateUID);
parcelHelpers.export(exports, "uid", ()=>uid);
var generateUID = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var uid = generateUID();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dVB1g":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * React hook to interact with the global overlay stack.
 *
 * @see https://blueprintjs.com/docs/#core/hooks/use-overlay-stack
 */ parcelHelpers.export(exports, "useOverlayStack", ()=>useOverlayStack);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _common = require("../../common");
var _errors = require("../../common/errors");
var _utils = require("../../common/utils");
var _overlaysProvider = require("../../context/overlays/overlaysProvider");
var _useLegacyOverlayStack = require("./useLegacyOverlayStack");
function useOverlayStack() {
    // get the overlay stack from application-wide React context
    var _a = (0, _reactDefault.default).useContext((0, _overlaysProvider.OverlaysContext)), stack = _a.stack, hasProvider = _a.hasProvider;
    var legacyOverlayStack = (0, _useLegacyOverlayStack.useLegacyOverlayStack)();
    var getLastOpened = (0, _reactDefault.default).useCallback(function() {
        return stack.current[stack.current.length - 1];
    }, [
        stack
    ]);
    var getThisOverlayAndDescendants = (0, _reactDefault.default).useCallback(function(id) {
        var index = stack.current.findIndex(function(o) {
            return o.id === id;
        });
        if (index === -1) return [];
        return stack.current.slice(index);
    }, [
        stack
    ]);
    var resetStack = (0, _reactDefault.default).useCallback(function() {
        stack.current = [];
    }, [
        stack
    ]);
    var openOverlay = (0, _reactDefault.default).useCallback(function(overlay) {
        stack.current.push(overlay);
        if (overlay.props.usePortal && overlay.props.hasBackdrop) // add a class to the body to prevent scrolling of content below the overlay
        document.body.classList.add((0, _common.Classes).OVERLAY_OPEN);
    }, [
        stack
    ]);
    var closeOverlay = (0, _reactDefault.default).useCallback(function(id) {
        var otherOverlaysWithBackdrop = stack.current.filter(function(o) {
            return o.props.usePortal && o.props.hasBackdrop && o.id !== id;
        });
        var index = stack.current.findIndex(function(o) {
            return o.id === id;
        });
        if (index > -1) stack.current.splice(index, 1);
        if (otherOverlaysWithBackdrop.length === 0) // remove body class which prevents scrolling of content below overlay
        document.body.classList.remove((0, _common.Classes).OVERLAY_OPEN);
    }, [
        stack
    ]);
    if (!hasProvider) {
        if ((0, _utils.isNodeEnv)("development")) console.error((0, _errors.OVERLAY2_REQUIRES_OVERLAY_PROVDER));
        return legacyOverlayStack;
    }
    return {
        closeOverlay: closeOverlay,
        getLastOpened: getLastOpened,
        getThisOverlayAndDescendants: getThisOverlayAndDescendants,
        openOverlay: openOverlay,
        resetStack: resetStack
    };
}

},{"react":"9njXz","../../common":"3QDnh","../../common/errors":"lyD8m","../../common/utils":"56UdR","../../context/overlays/overlaysProvider":"2LpRL","./useLegacyOverlayStack":"jyJfk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2LpRL":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverlaysContext", ()=>OverlaysContext);
parcelHelpers.export(exports, "OverlaysProvider", ()=>OverlaysProvider);
var _react = require("react");
var OverlaysContext = _react.createContext({
    hasProvider: false,
    stack: {
        current: []
    }
});
var OverlaysProvider = function(_a) {
    var children = _a.children;
    var stack = _react.useRef([]);
    var contextValue = _react.useMemo(function() {
        return {
            hasProvider: true,
            stack: stack
        };
    }, [
        stack
    ]);
    return _react.createElement(OverlaysContext.Provider, {
        value: contextValue
    }, children);
};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyJfk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "modifyGlobalStack", ()=>modifyGlobalStack);
/**
 * Legacy implementation of a global overlay stack which maintains state in a global variable.
 * This is used for backwards-compatibility with overlay-based components in Blueprint v5.
 * It will be removed in Blueprint v6 once `<OverlaysProvider>` is required.
 *
 * @see https://github.com/palantir/blueprint/wiki/Overlay2-migration
 */ parcelHelpers.export(exports, "useLegacyOverlayStack", ()=>useLegacyOverlayStack);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// tslint:disable-next-line no-submodule-imports
var _shim = require("use-sync-external-store/shim");
var _common = require("../../common");
var globalStack = [];
var globalStackListeners = [];
var modifyGlobalStack = function(fn) {
    fn(globalStack);
    globalStackListeners.forEach(function(listener) {
        return listener();
    });
};
var legacyGlobalOverlayStackStore = {
    getSnapshot: function() {
        return globalStack;
    },
    subscribe: function(listener) {
        globalStackListeners.push(listener);
        return function() {
            var index = globalStackListeners.indexOf(listener);
            globalStackListeners.splice(index, 1);
        };
    }
};
function useLegacyOverlayStack() {
    var stack = (0, _shim.useSyncExternalStore)(legacyGlobalOverlayStackStore.subscribe, legacyGlobalOverlayStackStore.getSnapshot, // server snapshot is the same as client snapshot
    legacyGlobalOverlayStackStore.getSnapshot);
    var getLastOpened = (0, _reactDefault.default).useCallback(function() {
        return stack[stack.length - 1];
    }, [
        stack
    ]);
    var getThisOverlayAndDescendants = (0, _reactDefault.default).useCallback(function(id) {
        var stackIndex = stack.findIndex(function(o) {
            return o.id === id;
        });
        return stack.slice(stackIndex);
    }, [
        stack
    ]);
    var resetStack = (0, _reactDefault.default).useCallback(function() {
        modifyGlobalStack(function(s) {
            return s.splice(0, s.length);
        });
    }, []);
    var openOverlay = (0, _reactDefault.default).useCallback(function(overlay) {
        globalStack.push(overlay);
        if (overlay.props.usePortal && overlay.props.hasBackdrop) // add a class to the body to prevent scrolling of content below the overlay
        document.body.classList.add((0, _common.Classes).OVERLAY_OPEN);
    }, []);
    var closeOverlay = (0, _reactDefault.default).useCallback(function(id) {
        var otherOverlaysWithBackdrop = stack.filter(function(o) {
            return o.props.usePortal && o.props.hasBackdrop && o.id !== id;
        });
        var index = globalStack.findIndex(function(o) {
            return o.id === id;
        });
        if (index > -1) globalStack.splice(index, 1);
        if (otherOverlaysWithBackdrop.length === 0) // remove body class which prevents scrolling of content below overlay
        document.body.classList.remove((0, _common.Classes).OVERLAY_OPEN);
    }, [
        stack
    ]);
    return {
        closeOverlay: closeOverlay,
        getLastOpened: getLastOpened,
        getThisOverlayAndDescendants: getThisOverlayAndDescendants,
        openOverlay: openOverlay,
        resetStack: resetStack
    };
}

},{"react":"9njXz","use-sync-external-store/shim":"jHyRW","../../common":"3QDnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jHyRW":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("3e3e060a1c619377");

},{"3e3e060a1c619377":"7utQz"}],"7utQz":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("a18024ece7b3cd12");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"a18024ece7b3cd12":"9njXz"}],"2FGmg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** React hook which tracks the previous state of a given value. */ parcelHelpers.export(exports, "usePrevious", ()=>usePrevious);
var _react = require("react");
function usePrevious(value) {
    // create a new reference
    var ref = _react.useRef();
    // store current value in ref
    _react.useEffect(function() {
        ref.current = value;
    }, [
        value
    ]);
    // return previous value (happens before update in useEffect above)
    return ref.current;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZFxO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the keyboard-focusable elements inside a given container element, ignoring focus traps
 * rendered by Overlay/Overlay2.
 */ parcelHelpers.export(exports, "getKeyboardFocusableElements", ()=>getKeyboardFocusableElements);
var _classes = require("../../common/classes");
var _refs = require("../../common/refs");
function getKeyboardFocusableElements(container) {
    var containerElement = (0, _refs.getRef)(container);
    var focusableElements = containerElement != null ? Array.from(// Order may not be correct if children elements use tabindex values > 0.
    // Selectors derived from this SO question:
    // https://stackoverflow.com/questions/1599660/which-html-elements-can-receive-focus
    containerElement.querySelectorAll([
        'a[href]:not([tabindex="-1"])',
        'button:not([disabled]):not([tabindex="-1"])',
        'details:not([tabindex="-1"])',
        'input:not([disabled]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        '[tabindex]:not([tabindex="-1"])'
    ].join(","))) : [];
    return focusableElements.filter(function(el) {
        return !el.classList.contains((0, _classes.OVERLAY_START_FOCUS_TRAP)) && !el.classList.contains((0, _classes.OVERLAY_END_FOCUS_TRAP));
    });
}

},{"../../common/classes":"2PICA","../../common/refs":"krjx8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kksjR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Portal component.
 *
 * This component detaches its contents and re-attaches them to document.body.
 * Use it when you need to circumvent DOM z-stacking (for dialogs, popovers, etc.).
 * Any class names passed to this element will be propagated to the new container element on document.body.
 *
 * Portal supports both the newer React context API and the legacy context API.
 * Support for the legacy context API will be removed in Blueprint v6.0.
 *
 * @see https://blueprintjs.com/docs/#core/components/portal
 */ parcelHelpers.export(exports, "Portal", ()=>Portal);
var _react = require("react");
var _reactDom = require("react-dom");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _reactUtils = require("../../common/utils/reactUtils");
var _portalProvider = require("../../context/portal/portalProvider");
/** @deprecated will be removed in Blueprint v6.0 */ var PORTAL_LEGACY_CONTEXT_TYPES = {
    blueprintPortalClassName: function(obj, key) {
        if (obj[key] != null && typeof obj[key] !== "string") return new Error(_errors.PORTAL_CONTEXT_CLASS_NAME_STRING);
        return undefined;
    }
};
function Portal(// eslint-disable-next-line deprecation/deprecation
_a, legacyContext) {
    var _b;
    var className = _a.className, stopPropagationEvents = _a.stopPropagationEvents, container = _a.container, onChildrenMount = _a.onChildrenMount, children = _a.children;
    if (legacyContext === void 0) legacyContext = {};
    var context = _react.useContext((0, _portalProvider.PortalContext));
    var portalContainer = (_b = container !== null && container !== void 0 ? container : context.portalContainer) !== null && _b !== void 0 ? _b : typeof document !== "undefined" ? document.body : undefined;
    var _c = _react.useState(), portalElement = _c[0], setPortalElement = _c[1];
    var createPortalElement = _react.useCallback(function() {
        var newPortalElement = document.createElement("div");
        newPortalElement.classList.add((0, _common.Classes).PORTAL);
        maybeAddClass(newPortalElement.classList, className); // directly added to this portal element
        maybeAddClass(newPortalElement.classList, context.portalClassName); // added via PortalProvider context
        addStopPropagationListeners(newPortalElement, stopPropagationEvents);
        // TODO: remove legacy context support in Blueprint v6.0
        var blueprintPortalClassName = legacyContext.blueprintPortalClassName;
        if (blueprintPortalClassName != null && blueprintPortalClassName !== "") {
            console.error(_errors.PORTAL_LEGACY_CONTEXT_API);
            maybeAddClass(newPortalElement.classList, blueprintPortalClassName); // added via legacy context
        }
        return newPortalElement;
    }, [
        className,
        context.portalClassName,
        legacyContext.blueprintPortalClassName,
        stopPropagationEvents
    ]);
    // create the container element & attach it to the DOM
    _react.useEffect(function() {
        if (portalContainer == null) return;
        var newPortalElement = createPortalElement();
        portalContainer.appendChild(newPortalElement);
        setPortalElement(newPortalElement);
        return function() {
            removeStopPropagationListeners(newPortalElement, stopPropagationEvents);
            newPortalElement.remove();
            setPortalElement(undefined);
        };
    }, [
        portalContainer,
        createPortalElement,
        stopPropagationEvents
    ]);
    // wait until next successful render to invoke onChildrenMount callback
    _react.useEffect(function() {
        if (portalElement != null) onChildrenMount === null || onChildrenMount === void 0 || onChildrenMount();
    }, [
        portalElement,
        onChildrenMount
    ]);
    _react.useEffect(function() {
        if (portalElement != null) {
            maybeAddClass(portalElement.classList, className);
            return function() {
                return maybeRemoveClass(portalElement.classList, className);
            };
        }
        return undefined;
    }, [
        className,
        portalElement
    ]);
    _react.useEffect(function() {
        if (portalElement != null) {
            addStopPropagationListeners(portalElement, stopPropagationEvents);
            return function() {
                return removeStopPropagationListeners(portalElement, stopPropagationEvents);
            };
        }
        return undefined;
    }, [
        portalElement,
        stopPropagationEvents
    ]);
    // Only render `children` once this component has mounted in a browser environment, so they are
    // immediately attached to the DOM tree and can do DOM things like measuring or `autoFocus`.
    // See long comment on componentDidMount in https://reactjs.org/docs/portals.html#event-bubbling-through-portals
    if (typeof document === "undefined" || portalElement == null) return null;
    else return _reactDom.createPortal(children, portalElement);
}
Portal.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Portal");
// only use legacy context in React 16 or 17
if (!(0, _reactUtils.isReact18)()) // eslint-disable-next-line deprecation/deprecation
Portal.contextTypes = PORTAL_LEGACY_CONTEXT_TYPES;
function maybeRemoveClass(classList, className) {
    if (className != null && className !== "") classList.remove.apply(classList, className.split(" "));
}
function maybeAddClass(classList, className) {
    if (className != null && className !== "") classList.add.apply(classList, className.split(" "));
}
function addStopPropagationListeners(portalElement, eventNames) {
    eventNames === null || eventNames === void 0 || eventNames.forEach(function(event) {
        return portalElement.addEventListener(event, handleStopProgation);
    });
}
function removeStopPropagationListeners(portalElement, events) {
    events === null || events === void 0 || events.forEach(function(event) {
        return portalElement.removeEventListener(event, handleStopProgation);
    });
}
function handleStopProgation(e) {
    e.stopPropagation();
}

},{"react":"9njXz","react-dom":"2ApDx","../../common":"3QDnh","../../common/errors":"lyD8m","../../common/utils/reactUtils":"3wQbM","../../context/portal/portalProvider":"lOE9c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lOE9c":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortalContext", ()=>PortalContext);
parcelHelpers.export(exports, "PortalProvider", ()=>PortalProvider);
var _react = require("react");
var PortalContext = _react.createContext({});
var PortalProvider = function(_a) {
    var children = _a.children, portalClassName = _a.portalClassName, portalContainer = _a.portalContainer;
    var contextOptions = _react.useMemo(function() {
        return {
            portalClassName: portalClassName,
            portalContainer: portalContainer
        };
    }, [
        portalClassName,
        portalContainer
    ]);
    return _react.createElement(PortalContext.Provider, {
        value: contextOptions
    }, children);
};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fC1tD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Breadcrumb", ()=>Breadcrumb);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _icon = require("../icon/icon");
var Breadcrumb = function(props) {
    var _a;
    var classes = (0, _classnamesDefault.default)((0, _common.Classes).BREADCRUMB, (_a = {}, _a[(0, _common.Classes).BREADCRUMB_CURRENT] = props.current, _a[(0, _common.Classes).DISABLED] = props.disabled, _a), props.className);
    var icon = props.icon != null ? _react.createElement((0, _icon.Icon), {
        title: props.iconTitle,
        icon: props.icon
    }) : undefined;
    if (props.href == null && props.onClick == null) return _react.createElement("span", {
        className: classes
    }, icon, props.text, props.children);
    return _react.createElement("a", {
        className: classes,
        href: props.href,
        onClick: props.disabled ? undefined : props.onClick,
        onFocus: props.disabled ? undefined : props.onFocus,
        tabIndex: props.disabled ? undefined : 0,
        target: props.target
    }, icon, props.text, props.children);
};

},{"classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../icon/icon":"duMtK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"11MZa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Breadcrumbs", ()=>Breadcrumbs);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _menu = require("../menu/menu");
var _menuItem = require("../menu/menuItem");
var _overflowList = require("../overflow-list/overflowList");
var _popover = require("../popover/popover");
var _breadcrumb = require("./breadcrumb");
/**
 * Breadcrumbs component.
 *
 * @see https://blueprintjs.com/docs/#core/components/breadcrumbs
 */ var Breadcrumbs = /** @class */ function(_super) {
    (0, _tslib.__extends)(Breadcrumbs, _super);
    function Breadcrumbs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderOverflow = function(items) {
            var _a = _this.props, collapseFrom = _a.collapseFrom, overflowButtonProps = _a.overflowButtonProps, popoverProps = _a.popoverProps;
            var orderedItems = items;
            if (collapseFrom === (0, _common.Boundary).START) // If we're collapsing from the start, the menu should be read from the bottom to the
            // top, continuing with the breadcrumbs to the right. Since this means the first
            // breadcrumb in the props must be the last in the menu, we need to reverse the overlow
            // order.
            orderedItems = items.slice().reverse();
            return _react.createElement("li", null, _react.createElement((0, _popover.Popover), (0, _tslib.__assign)({
                placement: collapseFrom === (0, _common.Boundary).END ? "bottom-end" : "bottom-start",
                disabled: orderedItems.length === 0,
                content: _react.createElement((0, _menu.Menu), null, orderedItems.map(_this.renderOverflowBreadcrumb))
            }, popoverProps), _react.createElement("span", (0, _tslib.__assign)({
                "aria-label": "collapsed breadcrumbs",
                role: "button",
                tabIndex: 0
            }, overflowButtonProps, {
                className: (0, _classnamesDefault.default)((0, _common.Classes).BREADCRUMBS_COLLAPSED, overflowButtonProps === null || overflowButtonProps === void 0 ? void 0 : overflowButtonProps.className)
            }))));
        };
        _this.renderOverflowBreadcrumb = function(props, index) {
            var isClickable = props.href != null || props.onClick != null;
            var htmlProps = (0, _common.removeNonHTMLProps)(props);
            return _react.createElement((0, _menuItem.MenuItem), (0, _tslib.__assign)({
                disabled: !isClickable
            }, htmlProps, {
                text: props.text,
                key: index
            }));
        };
        _this.renderBreadcrumbWrapper = function(props, index) {
            var isCurrent = _this.props.items[_this.props.items.length - 1] === props;
            return _react.createElement("li", {
                key: index
            }, _this.renderBreadcrumb(props, isCurrent));
        };
        return _this;
    }
    Breadcrumbs.prototype.render = function() {
        var _a = this.props, className = _a.className, collapseFrom = _a.collapseFrom, items = _a.items, minVisibleItems = _a.minVisibleItems, _b = _a.overflowListProps, overflowListProps = _b === void 0 ? {} : _b;
        return _react.createElement((0, _overflowList.OverflowList), (0, _tslib.__assign)({
            collapseFrom: collapseFrom,
            minVisibleItems: minVisibleItems,
            tagName: "ol"
        }, overflowListProps, {
            className: (0, _classnamesDefault.default)((0, _common.Classes).BREADCRUMBS, overflowListProps.className, className),
            items: items,
            overflowRenderer: this.renderOverflow,
            visibleItemRenderer: this.renderBreadcrumbWrapper
        }));
    };
    Breadcrumbs.prototype.renderBreadcrumb = function(props, isCurrent) {
        if (isCurrent && this.props.currentBreadcrumbRenderer != null) return this.props.currentBreadcrumbRenderer(props);
        else if (this.props.breadcrumbRenderer != null) return this.props.breadcrumbRenderer(props);
        else // allow user to override 'current' prop
        return _react.createElement((0, _breadcrumb.Breadcrumb), (0, _tslib.__assign)({
            current: isCurrent
        }, props));
    };
    Breadcrumbs.defaultProps = {
        collapseFrom: (0, _common.Boundary).START
    };
    return Breadcrumbs;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../menu/menu":"dIGTR","../menu/menuItem":"cZFqh","../overflow-list/overflowList":"iHnqf","../popover/popover":"2UrEu","./breadcrumb":"fC1tD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dIGTR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Menu", ()=>Menu);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var Menu = function(_a) {
    var _b;
    var className = _a.className, children = _a.children, large = _a.large, small = _a.small, ulRef = _a.ulRef, htmlProps = (0, _tslib.__rest)(_a, [
        "className",
        "children",
        "large",
        "small",
        "ulRef"
    ]);
    var classes = (0, _classnamesDefault.default)(className, (0, _common.Classes).MENU, (_b = {}, _b[(0, _common.Classes).LARGE] = large, _b[(0, _common.Classes).SMALL] = small, _b));
    return _react.createElement("ul", (0, _tslib.__assign)({
        role: "menu"
    }, htmlProps, {
        className: classes,
        ref: ulRef
    }), children);
};
Menu.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Menu");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cZFqh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuItem", ()=>MenuItem);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _props = require("../../common/props");
var _utils = require("../../common/utils");
var _icon = require("../icon/icon");
var _popover = require("../popover/popover");
var _text = require("../text/text");
var _menu = require("./menu");
var MenuItem = _react.forwardRef(function(props, ref) {
    var _a, _b;
    var active = props.active, className = props.className, children = props.children, disabled = props.disabled, icon = props.icon, intent = props.intent, labelClassName = props.labelClassName, labelElement = props.labelElement, multiline = props.multiline, popoverProps = props.popoverProps, _c = props.roleStructure, roleStructure = _c === void 0 ? "menuitem" : _c, selected = props.selected, shouldDismissPopover = props.shouldDismissPopover, submenuProps = props.submenuProps, text = props.text, textClassName = props.textClassName, _d = props.tagName, tagName = _d === void 0 ? "a" : _d, htmlTitle = props.htmlTitle, htmlProps = (0, _tslib.__rest)(props, [
        "active",
        "className",
        "children",
        "disabled",
        "icon",
        "intent",
        "labelClassName",
        "labelElement",
        "multiline",
        "popoverProps",
        "roleStructure",
        "selected",
        "shouldDismissPopover",
        "submenuProps",
        "text",
        "textClassName",
        "tagName",
        "htmlTitle"
    ]);
    var _e = roleStructure === "listoption" // "listoption": parent has listbox role, or is a <select>
     ? [
        "option",
        undefined,
        Boolean(selected)
    ] : roleStructure === "menuitem" // "menuitem": parent has menu role
     ? [
        "none",
        "menuitem",
        undefined
    ] : roleStructure === "none" // "none": allows wrapping MenuItem in custom <li>
     ? [
        "none",
        undefined,
        undefined
    ] : [
        undefined,
        undefined,
        undefined
    ], liRole = _e[0], targetRole = _e[1], ariaSelected = _e[2];
    var isSelectable = roleStructure === "listoption";
    var isSelected = isSelectable && selected;
    var hasIcon = icon != null;
    var hasSubmenu = children != null;
    var intentClass = (0, _common.Classes).intentClass(intent);
    var anchorClasses = (0, _classnamesDefault.default)((0, _common.Classes).MENU_ITEM, intentClass, (_a = {}, _a[(0, _common.Classes).ACTIVE] = active, _a[(0, _common.Classes).DISABLED] = disabled, // prevent popover from closing when clicking on submenu trigger or disabled item
    _a[(0, _common.Classes).POPOVER_DISMISS] = shouldDismissPopover && !disabled && !hasSubmenu, _a[(0, _common.Classes).MENU_ITEM_IS_SELECTABLE] = isSelectable, _a[(0, _common.Classes).SELECTED] = isSelected, _a), className);
    var maybeLabel = props.label == null && labelElement == null ? null : _react.createElement("span", {
        className: (0, _classnamesDefault.default)((0, _common.Classes).MENU_ITEM_LABEL, labelClassName)
    }, props.label, labelElement);
    var target = _react.createElement(tagName, (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({
        // for menuitems, onClick when enter key pressed doesn't take effect like it does for a button-- fix this
        onKeyDown: (0, _utils.clickElementOnKeyPress)([
            "Enter",
            " "
        ]),
        // if hasSubmenu, must apply correct role and tabIndex to the outer popover target <span> instead of this target element
        role: hasSubmenu ? "none" : targetRole,
        tabIndex: hasSubmenu ? -1 : 0
    }, (0, _props.removeNonHTMLProps)(htmlProps)), disabled ? DISABLED_PROPS : {}), {
        className: anchorClasses
    }), isSelected ? _react.createElement((0, _icons.SmallTick), {
        className: (0, _common.Classes).MENU_ITEM_SELECTED_ICON
    }) : undefined, hasIcon ? // wrap icon in a <span> in case `icon` is a custom element rather than a built-in icon identifier,
    // so that we always render this class
    _react.createElement("span", {
        className: (0, _common.Classes).MENU_ITEM_ICON
    }, _react.createElement((0, _icon.Icon), {
        icon: icon,
        "aria-hidden": true,
        tabIndex: -1
    })) : undefined, _react.createElement((0, _text.Text), {
        className: (0, _classnamesDefault.default)((0, _common.Classes).FILL, textClassName),
        ellipsize: !multiline,
        title: htmlTitle
    }, text), maybeLabel, hasSubmenu ? _react.createElement((0, _icons.CaretRight), {
        className: (0, _common.Classes).MENU_SUBMENU_ICON,
        title: "Open sub menu"
    }) : undefined);
    var liClasses = (0, _classnamesDefault.default)((_b = {}, _b[(0, _common.Classes).MENU_SUBMENU] = hasSubmenu, _b));
    return _react.createElement("li", {
        className: liClasses,
        ref: ref,
        role: liRole,
        "aria-selected": ariaSelected
    }, children == null ? target : _react.createElement((0, _popover.Popover), (0, _tslib.__assign)({
        autoFocus: false,
        captureDismiss: false,
        disabled: disabled,
        enforceFocus: false,
        hoverCloseDelay: 0,
        interactionKind: "hover",
        modifiers: SUBMENU_POPOVER_MODIFIERS,
        targetProps: {
            role: targetRole,
            tabIndex: 0
        },
        placement: "right-start",
        usePortal: false
    }, popoverProps, {
        content: _react.createElement((0, _menu.Menu), (0, _tslib.__assign)({}, submenuProps), children),
        minimal: true,
        popoverClassName: (0, _classnamesDefault.default)((0, _common.Classes).MENU_SUBMENU, popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.popoverClassName)
    }), target));
});
MenuItem.defaultProps = {
    active: false,
    disabled: false,
    multiline: false,
    popoverProps: {},
    selected: undefined,
    shouldDismissPopover: true,
    text: ""
};
MenuItem.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".MenuItem");
var SUBMENU_POPOVER_MODIFIERS = {
    // 20px padding - scrollbar width + a bit
    flip: {
        options: {
            rootBoundary: "viewport",
            padding: 20
        },
        enabled: true
    },
    // shift popover up 5px so MenuItems align
    offset: {
        options: {
            offset: [
                -5,
                0
            ]
        },
        enabled: true
    },
    preventOverflow: {
        options: {
            rootBoundary: "viewport",
            padding: 20
        },
        enabled: true
    }
};
// props to ignore when disabled
var DISABLED_PROPS = {
    "aria-disabled": true,
    href: undefined,
    onClick: undefined,
    onMouseDown: undefined,
    onMouseEnter: undefined,
    onMouseLeave: undefined,
    tabIndex: -1
};

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../../common/props":"dBcIV","../../common/utils":"56UdR","../icon/icon":"duMtK","../popover/popover":"2UrEu","../text/text":"cIHFN","./menu":"dIGTR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2UrEu":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopoverInteractionKind", ()=>PopoverInteractionKind);
parcelHelpers.export(exports, "Popover", ()=>Popover);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactPopper = require("react-popper");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _overlay2 = require("../overlay2/overlay2");
var _resizeSensor = require("../resize-sensor/resizeSensor");
// eslint-disable-next-line import/no-cycle
var _tooltip = require("../tooltip/tooltip");
var _customModifiers = require("./customModifiers");
var _popoverArrow = require("./popoverArrow");
var _popoverPlacementUtils = require("./popoverPlacementUtils");
var _popperUtils = require("./popperUtils");
var PopoverInteractionKind = {
    CLICK: "click",
    CLICK_TARGET_ONLY: "click-target",
    HOVER: "hover",
    HOVER_TARGET_ONLY: "hover-target"
};
/**
 * Popover component, used to display a floating UI next to and tethered to a target element.
 *
 * @template T target element props interface. Consumers wishing to stay in sync with Blueprint's default target HTML
 * props interface should use the `DefaultPopoverTargetHTMLProps` type (although this is already the default type for
 * this type param).
 * @see https://blueprintjs.com/docs/#core/components/popover
 */ var Popover = /** @class */ function(_super) {
    (0, _tslib.__extends)(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasDarkParent: false,
            isClosingViaEscapeKeypress: false,
            isOpen: _this.getIsOpen(_this.props)
        };
        /**
         * DOM element that contains the popover.
         * When `usePortal={true}`, this element will be portaled outside the usual DOM flow,
         * so this reference can be very useful for testing.
         *
         * @public for testing
         */ _this.popoverElement = null;
        /** Popover ref handler */ _this.popoverRef = (0, _common.refHandler)(_this, "popoverElement", _this.props.popoverRef);
        /**
         * Target DOM element ref.
         *
         * N.B. this must be a ref object since we pass it to `<ResizeSensor>`, which needs to know about the target
         * DOM element in order to observe its dimensions.
         *
         * @public for testing
         */ _this.targetRef = _react.createRef();
        /**
         * Overlay2 transition container element ref.
         */ _this.transitionContainerElement = _react.createRef();
        // a flag that lets us detect mouse movement between the target and popover,
        // now that mouseleave is triggered when you cross the gap between the two.
        _this.isMouseInTargetOrPopover = false;
        // a flag that indicates whether the target previously lost focus to another
        // element on the same page.
        _this.lostFocusOnSamePage = true;
        _this.isControlled = function() {
            return _this.props.isOpen !== undefined;
        };
        // arrow is disabled if minimal, or if the arrow modifier was explicitly disabled
        _this.isArrowEnabled = function() {
            var _a, _b;
            return !_this.props.minimal && ((_b = (_a = _this.props.modifiers) === null || _a === void 0 ? void 0 : _a.arrow) === null || _b === void 0 ? void 0 : _b.enabled) !== false;
        };
        _this.isHoverInteractionKind = function() {
            return _this.props.interactionKind === PopoverInteractionKind.HOVER || _this.props.interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY;
        };
        /**
         * Instance method to instruct the `Popover` to recompute its position.
         *
         * This method should only be used if you are updating the target in a way
         * that does not cause it to re-render, such as changing its _position_
         * without changing its _size_ (since `Popover` already repositions when it
         * detects a resize).
         */ _this.reposition = function() {
            var _a;
            return (_a = _this.popperScheduleUpdate) === null || _a === void 0 ? void 0 : _a.call(_this);
        };
        _this.renderTarget = function(_a) {
            var _b, _c;
            var _d, _e;
            var popperChildRef = _a.ref;
            var _f = _this.props, children = _f.children, className = _f.className, disabled = _f.disabled, fill = _f.fill, openOnTargetFocus = _f.openOnTargetFocus, renderTarget = _f.renderTarget;
            var isOpen = _this.state.isOpen;
            var isControlled = _this.isControlled();
            var isHoverInteractionKind = _this.isHoverInteractionKind();
            var targetTagName = _this.props.targetTagName;
            if (fill) targetTagName = "div";
            // N.B. react-popper has a wide type for this ref, but we can narrow it based on the source,
            // see https://github.com/floating-ui/react-popper/blob/beac280d61082852c4efc302be902911ce2d424c/src/Reference.js#L17
            var ref = (0, _common.mergeRefs)(popperChildRef, _this.targetRef);
            var targetEventHandlers = isHoverInteractionKind ? {
                // HOVER handlers
                onBlur: _this.handleTargetBlur,
                onContextMenu: _this.handleTargetContextMenu,
                onFocus: _this.handleTargetFocus,
                onMouseEnter: _this.handleMouseEnter,
                onMouseLeave: _this.handleMouseLeave
            } : {
                // CLICK needs only one handler
                onClick: _this.handleTargetClick,
                // For keyboard accessibility, trigger the same behavior as a click event upon pressing ENTER/SPACE
                onKeyDown: _this.handleKeyDown
            };
            // Ensure target is focusable if relevant prop enabled
            var targetTabIndex = !_this.getIsContentEmpty() && !disabled && openOnTargetFocus && isHoverInteractionKind ? 0 : undefined;
            var ownTargetProps = (0, _tslib.__assign)({
                // N.B. this.props.className is passed along to renderTarget even though the user would have access to it.
                // If, instead, renderTarget is undefined and the target is provided as a child, this.props.className is
                // applied to the generated target wrapper element.
                className: (0, _classnamesDefault.default)(className, (0, _common.Classes).POPOVER_TARGET, (_b = {}, _b[(0, _common.Classes).POPOVER_OPEN] = isOpen, // this class is mainly useful for button targets
                _b[(0, _common.Classes).ACTIVE] = isOpen && !isControlled && !isHoverInteractionKind, _b)),
                ref: ref
            }, targetEventHandlers);
            var childTargetProps = {
                "aria-expanded": isHoverInteractionKind ? undefined : isOpen,
                "aria-haspopup": _this.props.interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY ? undefined : (_d = _this.props.popupKind) !== null && _d !== void 0 ? _d : "menu"
            };
            var targetModifierClasses = (_c = {}, // this class is mainly useful for Blueprint <Button> targets; we should only apply it for
            // uncontrolled popovers when they are opened by a user interaction
            _c[(0, _common.Classes).ACTIVE] = isOpen && !isControlled && !isHoverInteractionKind, // similarly, this class is mainly useful for targets like <Button>, <InputGroup>, etc.
            _c[(0, _common.Classes).FILL] = fill, _c);
            var target;
            if (renderTarget !== undefined) target = renderTarget((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, ownTargetProps), childTargetProps), {
                className: (0, _classnamesDefault.default)(ownTargetProps.className, targetModifierClasses),
                // if the consumer renders a tooltip target, it's their responsibility to disable that tooltip
                // when *this* popover is open
                isOpen: isOpen,
                tabIndex: targetTabIndex
            }));
            else {
                var childTarget = (0, _common.Utils).ensureElement(_react.Children.toArray(children)[0]);
                if (childTarget === undefined) return null;
                var clonedTarget = _react.cloneElement(childTarget, (0, _tslib.__assign)((0, _tslib.__assign)({}, childTargetProps), {
                    className: (0, _classnamesDefault.default)(childTarget.props.className, targetModifierClasses),
                    // force disable single Tooltip child when popover is open
                    disabled: isOpen && (0, _common.Utils).isElementOfType(childTarget, (0, _tooltip.Tooltip)) ? true : childTarget.props.disabled,
                    tabIndex: (_e = childTarget.props.tabIndex) !== null && _e !== void 0 ? _e : targetTabIndex
                }));
                var wrappedTarget = _react.createElement(targetTagName, (0, _tslib.__assign)((0, _tslib.__assign)({}, ownTargetProps), _this.props.targetProps), clonedTarget);
                target = wrappedTarget;
            }
            // No need to use the merged `ref` here, that only needs to be forwarded to the child node so that React can
            // notify both popper.js and our components about the mounted DOM element.
            return _react.createElement((0, _resizeSensor.ResizeSensor), {
                targetRef: _this.targetRef,
                onResize: _this.reposition
            }, target);
        };
        _this.renderPopover = function(popperProps) {
            var _a;
            var _b = _this.props, autoFocus = _b.autoFocus, enforceFocus = _b.enforceFocus, backdropProps = _b.backdropProps, canEscapeKeyClose = _b.canEscapeKeyClose, hasBackdrop = _b.hasBackdrop, interactionKind = _b.interactionKind, usePortal = _b.usePortal;
            var _c = _this.state, isClosingViaEscapeKeypress = _c.isClosingViaEscapeKeypress, isOpen = _c.isOpen;
            // compute an appropriate transform origin so the scale animation points towards target
            var transformOrigin = (0, _popperUtils.getTransformOrigin)(popperProps.placement, _this.isArrowEnabled() ? popperProps.arrowProps.style : undefined);
            // need to update our reference to this function on every render as it will change.
            _this.popperScheduleUpdate = popperProps.update;
            var popoverHandlers = {
                // always check popover clicks for dismiss class
                onClick: _this.handlePopoverClick,
                // treat ENTER/SPACE keys the same as a click for accessibility
                onKeyDown: function(event) {
                    return (0, _common.Utils).isKeyboardClick(event) && _this.handlePopoverClick(event);
                }
            };
            if (interactionKind === PopoverInteractionKind.HOVER || !usePortal && interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY) {
                popoverHandlers.onMouseEnter = _this.handleMouseEnter;
                popoverHandlers.onMouseLeave = _this.handleMouseLeave;
            }
            var basePlacement = (0, _popperUtils.getBasePlacement)(popperProps.placement);
            var popoverClasses = (0, _classnamesDefault.default)((0, _common.Classes).POPOVER, (_a = {}, _a[(0, _common.Classes).DARK] = _this.props.inheritDarkTheme && _this.state.hasDarkParent, _a[(0, _common.Classes).MINIMAL] = _this.props.minimal, _a[(0, _common.Classes).POPOVER_CAPTURING_DISMISS] = _this.props.captureDismiss, _a[(0, _common.Classes).POPOVER_MATCH_TARGET_WIDTH] = _this.props.matchTargetWidth, _a[(0, _common.Classes).POPOVER_REFERENCE_HIDDEN] = popperProps.isReferenceHidden === true, _a[(0, _common.Classes).POPOVER_POPPER_ESCAPED] = popperProps.hasPopperEscaped === true, _a), "".concat((0, _common.Classes).POPOVER_CONTENT_PLACEMENT, "-").concat(basePlacement), _this.props.popoverClassName);
            var defaultAutoFocus = _this.isHoverInteractionKind() ? false : undefined;
            // if hover interaction, it doesn't make sense to take over focus control
            var shouldReturnFocusOnClose = _this.isHoverInteractionKind() ? false : isClosingViaEscapeKeypress ? true : _this.props.shouldReturnFocusOnClose;
            return _react.createElement((0, _overlay2.Overlay2), {
                autoFocus: autoFocus !== null && autoFocus !== void 0 ? autoFocus : defaultAutoFocus,
                backdropClassName: (0, _common.Classes).POPOVER_BACKDROP,
                backdropProps: backdropProps,
                canEscapeKeyClose: canEscapeKeyClose,
                canOutsideClickClose: interactionKind === PopoverInteractionKind.CLICK,
                childRef: _this.transitionContainerElement,
                enforceFocus: enforceFocus,
                hasBackdrop: hasBackdrop,
                isOpen: isOpen,
                lazy: _this.props.lazy,
                onClose: _this.handleOverlayClose,
                onClosed: _this.props.onClosed,
                onClosing: _this.props.onClosing,
                onOpened: _this.props.onOpened,
                onOpening: _this.props.onOpening,
                transitionDuration: _this.props.transitionDuration,
                transitionName: (0, _common.Classes).POPOVER,
                usePortal: usePortal,
                portalClassName: _this.props.portalClassName,
                portalContainer: _this.props.portalContainer,
                // eslint-disable-next-line deprecation/deprecation
                portalStopPropagationEvents: _this.props.portalStopPropagationEvents,
                shouldReturnFocusOnClose: shouldReturnFocusOnClose
            }, _react.createElement("div", {
                className: (0, _common.Classes).POPOVER_TRANSITION_CONTAINER,
                // We need to attach a ref that notifies both react-popper and our Popover component about the DOM
                // element inside the Overlay2. We cannot re-use `PopperChildrenProps.ref` because Overlay2 only
                // accepts a ref object (not a callback) due to a CSSTransition API limitation.
                // N.B. react-popper has a wide type for this ref, but we can narrow it based on the source,
                // see https://github.com/floating-ui/react-popper/blob/beac280d61082852c4efc302be902911ce2d424c/src/Popper.js#L94
                ref: (0, _common.mergeRefs)(popperProps.ref, _this.transitionContainerElement),
                style: popperProps.style
            }, _react.createElement((0, _resizeSensor.ResizeSensor), {
                onResize: _this.reposition
            }, _react.createElement("div", (0, _tslib.__assign)({
                className: popoverClasses,
                style: {
                    transformOrigin: transformOrigin
                },
                ref: _this.popoverRef
            }, popoverHandlers), _this.isArrowEnabled() && _react.createElement((0, _popoverArrow.PopoverArrow), {
                arrowProps: popperProps.arrowProps,
                placement: popperProps.placement
            }), _react.createElement("div", {
                className: (0, _common.Classes).POPOVER_CONTENT
            }, _this.props.content)))));
        };
        _this.handleTargetFocus = function(e) {
            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
                if (e.relatedTarget == null && !_this.lostFocusOnSamePage) // ignore this focus event -- the target was already focused but the page itself
                // lost focus (e.g. due to switching tabs).
                return;
                _this.handleMouseEnter(e);
            }
        };
        _this.handleTargetBlur = function(e) {
            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
                if (e.relatedTarget != null) // if the next element to receive focus is within the popover, we'll want to leave the
                // popover open.
                {
                    if (e.relatedTarget !== _this.popoverElement && !_this.isElementInPopover(e.relatedTarget)) _this.handleMouseLeave(e);
                } else _this.handleMouseLeave(e);
            }
            _this.lostFocusOnSamePage = e.relatedTarget != null;
        };
        _this.handleTargetContextMenu = function(e) {
            // we assume that when someone prevents the default interaction on this event (a browser native context menu),
            // they are showing a custom context menu (as ContextMenu2 does); in this case, we should close this popover/tooltip
            if (e.defaultPrevented) _this.setOpenState(false, e);
        };
        _this.handleMouseEnter = function(e) {
            _this.isMouseInTargetOrPopover = true;
            // if we're entering the popover, and the mode is set to be HOVER_TARGET_ONLY, we want to manually
            // trigger the mouse leave event, as hovering over the popover shouldn't count.
            if (!_this.props.usePortal && _this.isElementInPopover(e.target) && _this.props.interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY && !_this.props.openOnTargetFocus) _this.handleMouseLeave(e);
            else if (!_this.props.disabled) // only begin opening popover when it is enabled
            _this.setOpenState(true, e, _this.props.hoverOpenDelay);
        };
        _this.handleMouseLeave = function(e) {
            _this.isMouseInTargetOrPopover = false;
            // Wait until the event queue is flushed, because we want to leave the
            // popover open if the mouse entered the popover immediately after
            // leaving the target (or vice versa). Make sure to persist the event since
            // we need to access `nativeEvent` in `this.setOpenState()`.
            e.persist();
            _this.setTimeout(function() {
                if (_this.isMouseInTargetOrPopover) return;
                // user-configurable closing delay is helpful when moving mouse from target to popover
                _this.setOpenState(false, e, _this.props.hoverCloseDelay);
            });
        };
        _this.handlePopoverClick = function(e) {
            var _a, _b, _c;
            var eventTarget = e.target;
            var eventPopover = eventTarget.closest(".".concat((0, _common.Classes).POPOVER));
            var eventPopoverV1 = eventTarget.closest(".".concat((0, _common.Classes).POPOVER));
            var isEventFromSelf = (eventPopover !== null && eventPopover !== void 0 ? eventPopover : eventPopoverV1) === _this.getPopoverElement();
            var isEventPopoverCapturing = (_b = (_a = eventPopover === null || eventPopover === void 0 ? void 0 : eventPopover.classList.contains((0, _common.Classes).POPOVER_CAPTURING_DISMISS)) !== null && _a !== void 0 ? _a : eventPopoverV1 === null || eventPopoverV1 === void 0 ? void 0 : eventPopoverV1.classList.contains((0, _common.Classes).POPOVER_CAPTURING_DISMISS)) !== null && _b !== void 0 ? _b : false;
            // an OVERRIDE inside a DISMISS does not dismiss, and a DISMISS inside an OVERRIDE will dismiss.
            var dismissElement = eventTarget.closest(".".concat((0, _common.Classes).POPOVER_DISMISS, ", .").concat((0, _common.Classes).POPOVER_DISMISS_OVERRIDE));
            var shouldDismiss = (_c = dismissElement === null || dismissElement === void 0 ? void 0 : dismissElement.classList.contains((0, _common.Classes).POPOVER_DISMISS)) !== null && _c !== void 0 ? _c : false;
            var isDisabled = eventTarget.closest(":disabled, .".concat((0, _common.Classes).DISABLED)) != null;
            if (shouldDismiss && !isDisabled && (!isEventPopoverCapturing || isEventFromSelf)) _this.setOpenState(false, e);
        };
        _this.handleOverlayClose = function(e) {
            var _a;
            if (_this.targetRef.current == null || e === undefined) return;
            var event = (_a = e.nativeEvent) !== null && _a !== void 0 ? _a : e;
            var eventTarget = event.composed ? event.composedPath()[0] : event.target;
            // if click was in target, target event listener will handle things, so don't close
            if (!(0, _common.Utils).elementIsOrContains(_this.targetRef.current, eventTarget) || e.nativeEvent instanceof KeyboardEvent) _this.setOpenState(false, e);
        };
        _this.handleKeyDown = function(e) {
            var isKeyboardClick = (0, _common.Utils).isKeyboardClick(e);
            // For keyboard accessibility, trigger the same behavior as a click event upon pressing ENTER/SPACE
            if (isKeyboardClick) _this.handleTargetClick(e);
        };
        _this.handleTargetClick = function(e) {
            // Target element(s) may fire simulated click event upon pressing ENTER/SPACE, which we should ignore
            // see: https://github.com/palantir/blueprint/issues/5775
            var shouldIgnoreClick = _this.state.isOpen && _this.isSimulatedButtonClick(e);
            if (!shouldIgnoreClick) // ensure click did not originate from within inline popover before closing
            {
                if (!_this.props.disabled && !_this.isElementInPopover(e.target)) {
                    if (_this.props.isOpen == null) _this.setState(function(prevState) {
                        return {
                            isOpen: !prevState.isOpen
                        };
                    });
                    else _this.setOpenState(!_this.props.isOpen, e);
                }
            }
        };
        _this.isSimulatedButtonClick = function(e) {
            return !e.isTrusted && e.target.matches(".".concat((0, _common.Classes).BUTTON));
        };
        return _this;
    }
    // popper innerRef gives us a handle on the transition container, since that's what we render as the overlay child,
    // so if we want to look at our actual popover element, we need to reach inside a bit
    Popover.prototype.getPopoverElement = function() {
        var _a;
        return (_a = this.popoverElement) === null || _a === void 0 ? void 0 : _a.querySelector(".".concat((0, _common.Classes).POPOVER));
    };
    Popover.prototype.getIsOpen = function(props) {
        var _a;
        // disabled popovers should never be allowed to open.
        if (props.disabled) return false;
        else return (_a = props.isOpen) !== null && _a !== void 0 ? _a : props.defaultIsOpen;
    };
    Popover.prototype.render = function() {
        var _a = this.props, disabled = _a.disabled, placement = _a.placement, _b = _a.position, position = _b === void 0 ? "auto" : _b, positioningStrategy = _a.positioningStrategy;
        var isOpen = this.state.isOpen;
        if (this.getIsContentEmpty()) {
            // need to do this check in render(), because `isOpen` is derived from
            // state, and state can't necessarily be accessed in validateProps.
            if (!disabled && isOpen !== false && !(0, _common.Utils).isNodeEnv("production")) console.warn(_errors.POPOVER_WARN_EMPTY_CONTENT);
            // just render the target without a content overlay if there is no content to display
            return this.renderTarget({
                ref: noop
            });
        }
        // Important: do not use <Reference innerRef> since it has a bug when used in React 18 strict mode
        // see https://github.com/floating-ui/react-popper/pull/459
        return _react.createElement((0, _reactPopper.Manager), null, _react.createElement((0, _reactPopper.Reference), null, this.renderTarget), _react.createElement((0, _reactPopper.Popper), {
            innerRef: this.popoverRef,
            placement: placement !== null && placement !== void 0 ? placement : (0, _popoverPlacementUtils.positionToPlacement)(position),
            strategy: positioningStrategy,
            modifiers: this.getPopperModifiers()
        }, this.renderPopover));
    };
    Popover.prototype.componentDidMount = function() {
        this.updateDarkParent();
    };
    Popover.prototype.componentDidUpdate = function(props, state) {
        _super.prototype.componentDidUpdate.call(this, props, state);
        this.updateDarkParent();
        var nextIsOpen = this.getIsOpen(this.props);
        if (this.props.isOpen != null && nextIsOpen !== this.state.isOpen) {
            this.setOpenState(nextIsOpen);
            // tricky: setOpenState calls setState only if this.props.isOpen is
            // not controlled, so we need to invoke setState manually here.
            this.setState({
                isOpen: nextIsOpen
            });
        } else if (this.props.disabled && this.state.isOpen && this.props.isOpen == null) // special case: close an uncontrolled popover when disabled is set to true
        this.setOpenState(false);
    };
    Popover.prototype.validateProps = function(props) {
        if (props.isOpen == null && props.onInteraction != null) console.warn(_errors.POPOVER_WARN_UNCONTROLLED_ONINTERACTION);
        if (props.hasBackdrop && !props.usePortal) console.warn(_errors.POPOVER_WARN_HAS_BACKDROP_INLINE);
        if (props.hasBackdrop && props.interactionKind !== PopoverInteractionKind.CLICK) console.warn(_errors.POPOVER_HAS_BACKDROP_INTERACTION);
        if (props.placement !== undefined && props.position !== undefined) console.warn(_errors.POPOVER_WARN_PLACEMENT_AND_POSITION_MUTEX);
        var childrenCount = _react.Children.count(props.children);
        var hasRenderTargetProp = props.renderTarget !== undefined;
        var hasTargetPropsProp = props.targetProps !== undefined;
        if (childrenCount === 0 && !hasRenderTargetProp) console.warn(_errors.POPOVER_REQUIRES_TARGET);
        if (childrenCount > 1) console.warn(_errors.POPOVER_WARN_TOO_MANY_CHILDREN);
        if (childrenCount > 0 && hasRenderTargetProp) console.warn(_errors.POPOVER_WARN_DOUBLE_TARGET);
        if (hasRenderTargetProp && hasTargetPropsProp) console.warn(_errors.POPOVER_WARN_TARGET_PROPS_WITH_RENDER_TARGET);
    };
    Popover.prototype.getPopperModifiers = function() {
        var _a, _b, _c, _d;
        var _e = this.props, matchTargetWidth = _e.matchTargetWidth, modifiers = _e.modifiers, modifiersCustom = _e.modifiersCustom;
        var popperModifiers = [
            (0, _tslib.__assign)({
                enabled: this.isArrowEnabled(),
                name: "arrow"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.arrow),
            (0, _tslib.__assign)((0, _tslib.__assign)({
                name: "computeStyles"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.computeStyles), {
                options: (0, _tslib.__assign)({
                    adaptive: true,
                    // We disable the built-in gpuAcceleration so that
                    // Popper.js will return us easy to interpolate values
                    // (top, left instead of transform: translate3d)
                    // We'll then use these values to generate the needed
                    // css transform values blended with the react-spring values
                    gpuAcceleration: false
                }, (_a = modifiers === null || modifiers === void 0 ? void 0 : modifiers.computeStyles) === null || _a === void 0 ? void 0 : _a.options)
            }),
            (0, _tslib.__assign)((0, _tslib.__assign)({
                enabled: this.isArrowEnabled(),
                name: "offset"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.offset), {
                options: (0, _tslib.__assign)({
                    offset: [
                        0,
                        (0, _popoverArrow.POPOVER_ARROW_SVG_SIZE) / 2
                    ]
                }, (_b = modifiers === null || modifiers === void 0 ? void 0 : modifiers.offset) === null || _b === void 0 ? void 0 : _b.options)
            }),
            (0, _tslib.__assign)((0, _tslib.__assign)({
                name: "flip"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.flip), {
                options: (0, _tslib.__assign)({
                    boundary: this.props.boundary,
                    rootBoundary: this.props.rootBoundary
                }, (_c = modifiers === null || modifiers === void 0 ? void 0 : modifiers.flip) === null || _c === void 0 ? void 0 : _c.options)
            }),
            (0, _tslib.__assign)((0, _tslib.__assign)({
                name: "preventOverflow"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.preventOverflow), {
                options: (0, _tslib.__assign)({
                    boundary: this.props.boundary,
                    rootBoundary: this.props.rootBoundary
                }, (_d = modifiers === null || modifiers === void 0 ? void 0 : modifiers.preventOverflow) === null || _d === void 0 ? void 0 : _d.options)
            })
        ];
        if (matchTargetWidth) popperModifiers.push((0, _customModifiers.matchReferenceWidthModifier));
        if (modifiersCustom !== undefined) popperModifiers.push.apply(popperModifiers, modifiersCustom);
        return popperModifiers;
    };
    // a wrapper around setState({ isOpen }) that will call props.onInteraction instead when in controlled mode.
    // starts a timeout to delay changing the state if a non-zero duration is provided.
    Popover.prototype.setOpenState = function(isOpen, e, timeout) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        // cancel any existing timeout because we have new state
        (_a = this.cancelOpenTimeout) === null || _a === void 0 || _a.call(this);
        if (timeout !== undefined && timeout > 0) {
            // Persist the react event since it will be used in a later macrotask.
            e === null || e === void 0 || e.persist();
            this.cancelOpenTimeout = this.setTimeout(function() {
                _this.setOpenState(isOpen, e);
            }, timeout);
        } else {
            if (this.props.isOpen == null) this.setState({
                isOpen: isOpen
            });
            else (_c = (_b = this.props).onInteraction) === null || _c === void 0 || _c.call(_b, isOpen, e);
            if (!isOpen) {
                // non-null assertion because the only time `e` is undefined is when in controlled mode
                // or the rare special case in uncontrolled mode when the `disabled` flag is toggled true
                (_e = (_d = this.props).onClose) === null || _e === void 0 || _e.call(_d, e);
                this.setState({
                    isClosingViaEscapeKeypress: isEscapeKeypressEvent(e === null || e === void 0 ? void 0 : e.nativeEvent)
                });
            }
        }
    };
    Popover.prototype.updateDarkParent = function() {
        var _a;
        if (this.props.usePortal && this.state.isOpen) {
            var hasDarkParent = ((_a = this.targetRef.current) === null || _a === void 0 ? void 0 : _a.closest(".".concat((0, _common.Classes).DARK))) != null;
            this.setState({
                hasDarkParent: hasDarkParent
            });
        }
    };
    Popover.prototype.isElementInPopover = function(element) {
        var _a, _b;
        return (_b = (_a = this.getPopoverElement()) === null || _a === void 0 ? void 0 : _a.contains(element)) !== null && _b !== void 0 ? _b : false;
    };
    Popover.prototype.getIsContentEmpty = function() {
        var content = this.props.content;
        return content == null || (0, _common.Utils).isEmptyString(content);
    };
    Popover.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Popover");
    Popover.defaultProps = {
        boundary: "clippingParents",
        captureDismiss: false,
        defaultIsOpen: false,
        disabled: false,
        fill: false,
        hasBackdrop: false,
        hoverCloseDelay: 300,
        hoverOpenDelay: 150,
        inheritDarkTheme: true,
        interactionKind: PopoverInteractionKind.CLICK,
        matchTargetWidth: false,
        minimal: false,
        openOnTargetFocus: true,
        // N.B. we don't set a default for `placement` or `position` here because that would trigger
        // a warning in validateProps if the other prop is specified by a user of this component
        positioningStrategy: "absolute",
        renderTarget: undefined,
        shouldReturnFocusOnClose: false,
        targetTagName: "span",
        transitionDuration: 300,
        usePortal: true
    };
    return Popover;
}((0, _common.AbstractPureComponent));
function isEscapeKeypressEvent(e) {
    return e instanceof KeyboardEvent && e.key === "Escape";
}
function noop() {
// no-op
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","react-popper":"kYGlh","../../common":"3QDnh","../../common/errors":"lyD8m","../overlay2/overlay2":"3eEFv","../resize-sensor/resizeSensor":"lnJHO","../tooltip/tooltip":"hMZHg","./customModifiers":"hTiJ3","./popoverArrow":"btwJ2","./popoverPlacementUtils":"gDgcW","./popperUtils":"7UxZg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kYGlh":[function(require,module,exports,__globalThis) {
// Public components
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>(0, _popper.Popper)) // Public types
;
parcelHelpers.export(exports, "Manager", ()=>(0, _manager.Manager));
parcelHelpers.export(exports, "Reference", ()=>(0, _reference.Reference));
parcelHelpers.export(exports, "usePopper", ()=>(0, _usePopper.usePopper));
var _popper = require("./Popper");
var _manager = require("./Manager");
var _reference = require("./Reference");
var _usePopper = require("./usePopper");

},{"./Popper":"fgopz","./Manager":"3WABl","./Reference":"7VRSI","./usePopper":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fgopz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>Popper);
var _react = require("react");
var _manager = require("./Manager");
var _utils = require("./utils");
var _usePopper = require("./usePopper");
var NOOP = function NOOP() {
    return void 0;
};
var NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var EMPTY_MODIFIERS = [];
function Popper(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = _react.useContext((0, _manager.ManagerReferenceNodeContext));
    var _React$useState = _react.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = _react.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    _react.useEffect(function() {
        (0, _utils.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = _react.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper1 = (0, _usePopper.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper1.state, styles = _usePopper1.styles, forceUpdate = _usePopper1.forceUpdate, update = _usePopper1.update;
    var childrenProps = _react.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || NOOP,
            update: update || NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, _utils.unwrapArray)(children)(childrenProps);
}

},{"react":"9njXz","./Manager":"3WABl","./utils":"2jZQR","./usePopper":"gD0zB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3WABl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManagerReferenceNodeContext", ()=>ManagerReferenceNodeContext);
parcelHelpers.export(exports, "ManagerReferenceNodeSetterContext", ()=>ManagerReferenceNodeSetterContext);
parcelHelpers.export(exports, "Manager", ()=>Manager);
var _react = require("react");
var ManagerReferenceNodeContext = _react.createContext();
var ManagerReferenceNodeSetterContext = _react.createContext();
function Manager(_ref) {
    var children = _ref.children;
    var _React$useState = _react.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = _react.useRef(false);
    _react.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = _react.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ _react.createElement(ManagerReferenceNodeContext.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ _react.createElement(ManagerReferenceNodeSetterContext.Provider, {
        value: handleSetReferenceNode
    }, children));
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2jZQR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrapArray", ()=>unwrapArray);
parcelHelpers.export(exports, "safeInvoke", ()=>safeInvoke);
parcelHelpers.export(exports, "setRef", ()=>setRef);
parcelHelpers.export(exports, "fromEntries", ()=>fromEntries);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react");
var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return safeInvoke(ref, node);
    else if (ref != null) ref.current = node;
};
var fromEntries = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? _react.useLayoutEffect : _react.useEffect;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gD0zB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePopper", ()=>usePopper);
var _react = require("react");
var _reactDom = require("react-dom");
var _core = require("@popperjs/core");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _utils = require("./utils");
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = _react.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || EMPTY_MODIFIERS
    };
    var _React$useState = _react.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = _react.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                _reactDom.flushSync(function() {
                    setState({
                        styles: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = _react.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, _reactFastCompareDefault.default)(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = _react.useRef();
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, _core.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

},{"react":"9njXz","react-dom":"2ApDx","@popperjs/core":"4kymL","react-fast-compare":"ga979","./utils":"2jZQR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kymL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":"gVkdf","./modifiers/index.js":false,"./createPopper.js":false,"./popper.js":"23oSG","./popper-lite.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVkdf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4uCU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"4mQXp","./dom-utils/getLayoutRect.js":"bweSm","./dom-utils/listScrollParents.js":"1qClO","./dom-utils/getOffsetParent.js":"bLvkb","./utils/orderModifiers.js":"4RWkj","./utils/debounce.js":"gcfKw","./utils/mergeByName.js":"kcmZR","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4mQXp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","./getNodeScroll.js":"8P5ka","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","./getWindowScrollBarX.js":"kaNJ3","./getDocumentElement.js":"gcVmr","./isScrollParent.js":"eD7m7","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XyXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"1bDAn","../utils/math.js":"8B7aS","./getWindow.js":"3ynkX","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1bDAn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ynkX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8B7aS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAhTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fpMW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8P5ka":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"btekq","./getWindow.js":"3ynkX","./instanceOf.js":"1bDAn","./getHTMLElementScroll.js":"hYXUH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btekq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYXUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyQUh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kaNJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"4XyXs","./getDocumentElement.js":"gcVmr","./getWindowScroll.js":"btekq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcVmr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eD7m7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"5uZSa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uZSa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bweSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1qClO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"1igW6","./getParentNode.js":"k0cfu","./getWindow.js":"3ynkX","./isScrollParent.js":"eD7m7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1igW6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"k0cfu","./isScrollParent.js":"eD7m7","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k0cfu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"jyQUh","./getDocumentElement.js":"gcVmr","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bLvkb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"3ynkX","./getNodeName.js":"jyQUh","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./isTableElement.js":"btBRX","./getParentNode.js":"k0cfu","../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btBRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"jyQUh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RWkj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcfKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kcmZR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6v2ts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"YPNSr","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getBoundingClientRect.js":"4XyXs","./computeOffsets.js":"gnv44","./rectToClientRect.js":"5PWlE","../enums.js":"gVkdf","../dom-utils/instanceOf.js":"1bDAn","./mergePaddingObject.js":"43lYJ","./expandToHashMap.js":"16QKI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"YPNSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"gVkdf","./getViewportRect.js":"2wQ5y","./getDocumentRect.js":"3LAyO","./listScrollParents.js":"1qClO","./getOffsetParent.js":"bLvkb","./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./getBoundingClientRect.js":"4XyXs","./getParentNode.js":"k0cfu","./contains.js":"eGlaM","./getNodeName.js":"jyQUh","../utils/rectToClientRect.js":"5PWlE","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2wQ5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"3ynkX","./getDocumentElement.js":"gcVmr","./getWindowScrollBarX.js":"kaNJ3","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3LAyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./getWindowScrollBarX.js":"kaNJ3","./getWindowScroll.js":"btekq","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGlaM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PWlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnv44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"5S4fc","./getVariation.js":"4BYPr","./getMainAxisFromPlacement.js":"avEhJ","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5S4fc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4BYPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avEhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43lYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"gtdyp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtdyp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16QKI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"23oSG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", ()=>createPopper) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"b4uCU","./modifiers/eventListeners.js":"5tT8s","./modifiers/popperOffsets.js":"hVDuj","./modifiers/computeStyles.js":"jvHvj","./modifiers/applyStyles.js":"ewuA1","./modifiers/offset.js":"2lcLd","./modifiers/flip.js":"8WVPr","./modifiers/preventOverflow.js":"jUko2","./modifiers/arrow.js":"5Trmz","./modifiers/hide.js":"6kFua","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tT8s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hVDuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"gnv44","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jvHvj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"gVkdf","../dom-utils/getOffsetParent.js":"bLvkb","../dom-utils/getWindow.js":"3ynkX","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getComputedStyle.js":"5uZSa","../utils/getBasePlacement.js":"5S4fc","../utils/getVariation.js":"4BYPr","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewuA1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect,
    requires: [
        'computeStyles'
    ]
};

},{"../dom-utils/getNodeName.js":"jyQUh","../dom-utils/instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2lcLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"5S4fc","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WVPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"htgah","../utils/getBasePlacement.js":"5S4fc","../utils/getOppositeVariationPlacement.js":"3n1hw","../utils/detectOverflow.js":"6v2ts","../utils/computeAutoPlacement.js":"clJeY","../enums.js":"gVkdf","../utils/getVariation.js":"4BYPr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htgah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3n1hw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"clJeY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"4BYPr","../enums.js":"gVkdf","./detectOverflow.js":"6v2ts","./getBasePlacement.js":"5S4fc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jUko2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"gVkdf","../utils/getBasePlacement.js":"5S4fc","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/getAltAxis.js":"l4M4a","../utils/within.js":"cdkh1","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/getOffsetParent.js":"bLvkb","../utils/detectOverflow.js":"6v2ts","../utils/getVariation.js":"4BYPr","../utils/getFreshSideObject.js":"gtdyp","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4M4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cdkh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Trmz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"5S4fc","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/contains.js":"eGlaM","../dom-utils/getOffsetParent.js":"bLvkb","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/within.js":"cdkh1","../utils/mergePaddingObject.js":"43lYJ","../utils/expandToHashMap.js":"16QKI","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kFua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"gVkdf","../utils/detectOverflow.js":"6v2ts","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ga979":[function(require,module,exports,__globalThis) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"7VRSI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reference", ()=>Reference);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _manager = require("./Manager");
var _utils = require("./utils");
function Reference(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = _react.useContext((0, _manager.ManagerReferenceNodeSetterContext));
    var refHandler = _react.useCallback(function(node) {
        (0, _utils.setRef)(innerRef, node);
        (0, _utils.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    _react.useEffect(function() {
        return function() {
            return (0, _utils.setRef)(innerRef, null);
        };
    }, []);
    _react.useEffect(function() {
        (0, _warningDefault.default)(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, _utils.unwrapArray)(children)({
        ref: refHandler
    });
}

},{"react":"9njXz","warning":"4kUCc","./Manager":"3WABl","./utils":"2jZQR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kUCc":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"lnJHO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeSensor", ()=>ResizeSensor);
var _tslib = require("tslib");
var _react = require("react");
var _common = require("../../common");
/**
 * Resize sensor component.
 *
 * It requires a single DOM element child and will error otherwise.
 *
 * @see https://blueprintjs.com/docs/#core/components/resize-sensor
 **/ var ResizeSensor = /** @class */ function(_super) {
    (0, _tslib.__extends)(ResizeSensor, _super);
    function ResizeSensor() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.targetRef = (_a = _this.props.targetRef) !== null && _a !== void 0 ? _a : _react.createRef();
        _this.prevElement = undefined;
        return _this;
    }
    ResizeSensor.prototype.render = function() {
        var onlyChild = _react.Children.only(this.props.children);
        // If we're provided a mutable ref to the child element already, we must re-use that one. This is necessary
        // in cases where the child node is not a native DOM element and does not use `React.forwardRef`, since
        // there's no way for us to know how to attach to the underlying DOM node.
        if (this.props.targetRef !== undefined) return onlyChild;
        return _react.cloneElement(onlyChild, {
            ref: this.targetRef
        });
    };
    ResizeSensor.prototype.componentDidMount = function() {
        var _this = this;
        // ResizeObserver is available in all modern browsers supported by Blueprint but not in server-side rendering
        // and some test environments like jsdom, so we to do a feature check here.
        this.observer = globalThis.ResizeObserver != null ? new ResizeObserver(function(entries) {
            var _a, _b;
            return (_b = (_a = _this.props).onResize) === null || _b === void 0 ? void 0 : _b.call(_a, entries);
        }) : undefined;
        this.observeElement();
    };
    ResizeSensor.prototype.componentDidUpdate = function(prevProps) {
        this.observeElement(this.props.observeParents !== prevProps.observeParents);
    };
    ResizeSensor.prototype.componentWillUnmount = function() {
        var _a;
        (_a = this.observer) === null || _a === void 0 || _a.disconnect();
        this.prevElement = undefined;
    };
    /**
     * Observe the DOM element, if defined and different from the currently
     * observed element. Pass `force` argument to skip element checks and always
     * re-observe.
     */ ResizeSensor.prototype.observeElement = function(force) {
        if (force === void 0) force = false;
        if (this.observer === undefined) return;
        if (!(this.targetRef.current instanceof Element)) {
            // stop everything if not defined
            this.observer.disconnect();
            return;
        }
        if (this.targetRef.current === this.prevElement && !force) // quit if given same element -- nothing to update (unless forced)
        return;
        else {
            // clear observer list if new element
            this.observer.disconnect();
            // remember element reference for next time
            this.prevElement = this.targetRef.current;
        }
        // observer callback is invoked immediately when observing new elements
        this.observer.observe(this.targetRef.current);
        if (this.props.observeParents) {
            var parent_1 = this.targetRef.current.parentElement;
            while(parent_1 != null){
                this.observer.observe(parent_1);
                parent_1 = parent_1.parentElement;
            }
        }
    };
    ResizeSensor.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".ResizeSensor");
    return ResizeSensor;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","react":"9njXz","../../common":"3QDnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hMZHg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _classes = require("../../common/classes");
// eslint-disable-next-line import/no-cycle
var _popover = require("../popover/popover");
var _popoverArrow = require("../popover/popoverArrow");
var _tooltipContext = require("../popover/tooltipContext");
/**
 * Tooltip component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tooltip
 */ var Tooltip = /** @class */ function(_super) {
    (0, _tslib.__extends)(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popoverRef = _react.createRef();
        // any descendant ContextMenus may update this ctxState
        _this.renderPopover = function(ctxState) {
            var _a;
            var _b;
            var _c = _this.props, children = _c.children, compact = _c.compact, disabled = _c.disabled, intent = _c.intent, popoverClassName = _c.popoverClassName, restProps = (0, _tslib.__rest)(_c, [
                "children",
                "compact",
                "disabled",
                "intent",
                "popoverClassName"
            ]);
            var popoverClasses = (0, _classnamesDefault.default)(_classes.TOOLTIP, _classes.intentClass(intent), popoverClassName, (_a = {}, _a[_classes.COMPACT] = compact, _a));
            return _react.createElement((0, _popover.Popover), (0, _tslib.__assign)({
                modifiers: {
                    arrow: {
                        enabled: !_this.props.minimal
                    },
                    offset: {
                        options: {
                            offset: [
                                0,
                                (0, _popoverArrow.TOOLTIP_ARROW_SVG_SIZE) / 2
                            ]
                        }
                    }
                }
            }, restProps, {
                autoFocus: false,
                canEscapeKeyClose: false,
                disabled: (_b = ctxState.forceDisabled) !== null && _b !== void 0 ? _b : disabled,
                enforceFocus: false,
                lazy: true,
                popoverClassName: popoverClasses,
                portalContainer: _this.props.portalContainer,
                ref: _this.popoverRef
            }), children);
        };
        return _this;
    }
    Tooltip.prototype.render = function() {
        var _this = this;
        // if we have an ancestor TooltipContext, we should take its state into account in this render path,
        // it was likely created by a parent ContextMenu
        return _react.createElement((0, _tooltipContext.TooltipContext).Consumer, null, function(_a) {
            var state = _a[0];
            return _react.createElement((0, _tooltipContext.TooltipProvider), (0, _tslib.__assign)({}, state), _this.renderPopover);
        });
    };
    Tooltip.prototype.reposition = function() {
        var _a;
        (_a = this.popoverRef.current) === null || _a === void 0 || _a.reposition();
    };
    Tooltip.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Tooltip");
    Tooltip.defaultProps = {
        compact: false,
        hoverCloseDelay: 0,
        hoverOpenDelay: 100,
        interactionKind: "hover-target",
        minimal: false,
        transitionDuration: 100
    };
    return Tooltip;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/classes":"2PICA","../popover/popover":"2UrEu","../popover/popoverArrow":"btwJ2","../popover/tooltipContext":"2ZDTk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btwJ2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "POPOVER_ARROW_SVG_SIZE", ()=>POPOVER_ARROW_SVG_SIZE);
parcelHelpers.export(exports, "TOOLTIP_ARROW_SVG_SIZE", ()=>TOOLTIP_ARROW_SVG_SIZE);
parcelHelpers.export(exports, "PopoverArrow", ()=>PopoverArrow);
var _tslib = require("tslib");
var _react = require("react");
var _common = require("../../common");
var _popperUtils = require("./popperUtils");
// these paths come from the Core Kit Sketch file
// https://github.com/palantir/blueprint/blob/develop/resources/sketch/Core%20Kit.sketch
var SVG_SHADOW_PATH = "M8.11 6.302c1.015-.936 1.887-2.922 1.887-4.297v26c0-1.378-.868-3.357-1.888-4.297L.925 17.09c-1.237-1.14-1.233-3.034 0-4.17L8.11 6.302z";
var SVG_ARROW_PATH = "M8.787 7.036c1.22-1.125 2.21-3.376 2.21-5.03V0v30-2.005c0-1.654-.983-3.9-2.21-5.03l-7.183-6.616c-.81-.746-.802-1.96 0-2.7l7.183-6.614z";
// additional space between arrow and edge of target
var ARROW_SPACING = 4;
var POPOVER_ARROW_SVG_SIZE = 30;
var TOOLTIP_ARROW_SVG_SIZE = 22;
/* istanbul ignore next */ /** Modifier helper function to compute arrow rotate() transform */ function getArrowAngle(placement) {
    if (placement == null) return 0;
    // can only be top/left/bottom/right - auto is resolved internally
    switch((0, _popperUtils.getBasePlacement)(placement)){
        case "top":
            return -90;
        case "left":
            return 180;
        case "bottom":
            return 90;
        default:
            return 0;
    }
}
/* istanbul ignore next */ /**
 * Popper's builtin "arrow" modifier options.padding doesn't seem to work for us, so we
 * need to compute our own offset in the direction of the popover relative to the reference.
 */ function getArrowReferenceOffsetStyle(placement) {
    var offset = POPOVER_ARROW_SVG_SIZE / 2 - ARROW_SPACING;
    switch((0, _popperUtils.getBasePlacement)(placement)){
        case "top":
            return {
                bottom: -offset
            };
        case "left":
            return {
                right: -offset
            };
        case "bottom":
            return {
                top: -offset
            };
        default:
            return {
                left: -offset
            };
    }
}
var PopoverArrow = function(_a) {
    var _b = _a.arrowProps, ref = _b.ref, style = _b.style, placement = _a.placement;
    return(// data attribute allows popper.js to position the arrow
    _react.createElement("div", {
        "aria-hidden": true,
        className: (0, _common.Classes).POPOVER_ARROW,
        "data-popper-arrow": true,
        ref: ref,
        style: (0, _tslib.__assign)((0, _tslib.__assign)({}, style), getArrowReferenceOffsetStyle(placement))
    }, _react.createElement("svg", {
        viewBox: "0 0 ".concat(POPOVER_ARROW_SVG_SIZE, " ").concat(POPOVER_ARROW_SVG_SIZE),
        style: {
            transform: "rotate(".concat(getArrowAngle(placement), "deg)")
        }
    }, _react.createElement("path", {
        className: (0, _common.Classes).POPOVER_ARROW + "-border",
        d: SVG_SHADOW_PATH
    }), _react.createElement("path", {
        className: (0, _common.Classes).POPOVER_ARROW + "-fill",
        d: SVG_ARROW_PATH
    }))));
};
PopoverArrow.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".PopoverArrow");

},{"tslib":"b4wpY","react":"9njXz","../../common":"3QDnh","./popperUtils":"7UxZg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7UxZg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopperPlacements", ()=>(0, _core.placements));
// Popper placement utils
// ======================
/** Converts a full placement to one of the four positions by stripping text after the `-`. */ parcelHelpers.export(exports, "getBasePlacement", ()=>getBasePlacement);
/** Returns true if position is left or right. */ parcelHelpers.export(exports, "isVerticalPlacement", ()=>isVerticalPlacement);
/** Returns the opposite position. */ parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
/** Returns the CSS alignment keyword corresponding to given placement. */ parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
// Popper modifiers
// ================
/** Modifier helper function to compute popper transform-origin based on arrow position */ parcelHelpers.export(exports, "getTransformOrigin", ()=>getTransformOrigin);
var _core = require("@popperjs/core");
function getBasePlacement(placement) {
    return placement.split("-")[0];
}
function isVerticalPlacement(side) {
    return [
        "left",
        "right"
    ].indexOf(side) !== -1;
}
function getOppositePlacement(side) {
    switch(side){
        case "top":
            return "bottom";
        case "left":
            return "right";
        case "bottom":
            return "top";
        default:
            return "left";
    }
}
function getAlignment(placement) {
    var align = placement.split("-")[1];
    switch(align){
        case "start":
            return "left";
        case "end":
            return "right";
        default:
            return "center";
    }
}
function getTransformOrigin(placement, arrowStyles) {
    var basePlacement = getBasePlacement(placement);
    if (arrowStyles === undefined) return isVerticalPlacement(basePlacement) ? "".concat(getOppositePlacement(basePlacement), " ").concat(getAlignment(basePlacement)) : "".concat(getAlignment(basePlacement), " ").concat(getOppositePlacement(basePlacement));
    else {
        // const arrowSizeShift = state.elements.arrow.clientHeight / 2;
        var arrowSizeShift = 15;
        // can use keyword for dimension without the arrow, to ease computation burden.
        // move origin by half arrow's height to keep it centered.
        return isVerticalPlacement(basePlacement) ? "".concat(getOppositePlacement(basePlacement), " ").concat(parseInt(arrowStyles.top, 10) + arrowSizeShift, "px") : "".concat(parseInt(arrowStyles.left, 10) + arrowSizeShift, "px ").concat(getOppositePlacement(basePlacement));
    }
}

},{"@popperjs/core":"4kymL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ZDTk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipContext", ()=>TooltipContext);
parcelHelpers.export(exports, "TooltipProvider", ()=>TooltipProvider);
var _react = require("react");
var noOpDispatch = function() {
    return null;
};
var TooltipContext = _react.createContext([
    {},
    noOpDispatch
]);
var tooltipContextReducer = function(state, action) {
    switch(action.type){
        case "FORCE_DISABLED_STATE":
            return {
                forceDisabled: true
            };
        case "RESET_DISABLED_STATE":
            return {};
        default:
            return state;
    }
};
var TooltipProvider = function(_a) {
    var children = _a.children, forceDisable = _a.forceDisable;
    var _b = _react.useReducer(tooltipContextReducer, {}), state = _b[0], dispatch = _b[1];
    var contextValue = _react.useMemo(function() {
        return [
            state,
            dispatch
        ];
    }, [
        state,
        dispatch
    ]);
    _react.useEffect(function() {
        if (forceDisable) dispatch({
            type: "FORCE_DISABLED_STATE"
        });
        else dispatch({
            type: "RESET_DISABLED_STATE"
        });
    }, [
        forceDisable
    ]);
    return _react.createElement(TooltipContext.Provider, {
        value: contextValue
    }, typeof children === "function" ? children(state) : children);
};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hTiJ3":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // tslint:disable object-literal-sort-keys
// adapted from https://popper.js.org/docs/v2/modifiers/community-modifiers/
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "matchReferenceWidthModifier", ()=>matchReferenceWidthModifier);
var matchReferenceWidthModifier = {
    enabled: true,
    name: "matchReferenceWidth",
    phase: "beforeWrite",
    requires: [
        "computeStyles"
    ],
    fn: function(_a) {
        var state = _a.state;
        state.styles.popper.width = "".concat(state.rects.reference.width, "px");
    },
    effect: function(_a) {
        var state = _a.state;
        var referenceWidth = state.elements.reference.getBoundingClientRect().width;
        state.elements.popper.style.width = "".concat(referenceWidth, "px");
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gDgcW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Convert a position to a placement.
 *
 * @param position the position to convert
 */ parcelHelpers.export(exports, "positionToPlacement", ()=>positionToPlacement);
var _popoverPosition = require("./popoverPosition");
function positionToPlacement(position) {
    /* istanbul ignore next */ switch(position){
        case (0, _popoverPosition.PopoverPosition).TOP_LEFT:
            return "top-start";
        case (0, _popoverPosition.PopoverPosition).TOP:
            return "top";
        case (0, _popoverPosition.PopoverPosition).TOP_RIGHT:
            return "top-end";
        case (0, _popoverPosition.PopoverPosition).RIGHT_TOP:
            return "right-start";
        case (0, _popoverPosition.PopoverPosition).RIGHT:
            return "right";
        case (0, _popoverPosition.PopoverPosition).RIGHT_BOTTOM:
            return "right-end";
        case (0, _popoverPosition.PopoverPosition).BOTTOM_RIGHT:
            return "bottom-end";
        case (0, _popoverPosition.PopoverPosition).BOTTOM:
            return "bottom";
        case (0, _popoverPosition.PopoverPosition).BOTTOM_LEFT:
            return "bottom-start";
        case (0, _popoverPosition.PopoverPosition).LEFT_BOTTOM:
            return "left-end";
        case (0, _popoverPosition.PopoverPosition).LEFT:
            return "left";
        case (0, _popoverPosition.PopoverPosition).LEFT_TOP:
            return "left-start";
        case "auto":
        case "auto-start":
        case "auto-end":
            // Return the string unchanged.
            return position;
        default:
            return assertNever(position);
    }
}
/* istanbul ignore next */ function assertNever(x) {
    throw new Error("Unexpected position: " + x);
}

},{"./popoverPosition":"bXDBV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bXDBV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopoverPosition", ()=>PopoverPosition);
var _tslib = require("tslib");
var _common = require("../../common");
var PopoverPosition = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _common.Position)), {
    AUTO: "auto",
    AUTO_END: "auto-end",
    AUTO_START: "auto-start"
});

},{"tslib":"b4wpY","../../common":"3QDnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iHnqf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverflowList", ()=>OverflowList);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _utils = require("../../common/utils");
var _resizeSensor = require("../resize-sensor/resizeSensor");
/**
 * Overflow list component.
 *
 * @see https://blueprintjs.com/docs/#core/components/overflow-list
 */ var OverflowList = /** @class */ function(_super) {
    (0, _tslib.__extends)(OverflowList, _super);
    function OverflowList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            chopSize: _this.defaultChopSize(),
            lastChopSize: null,
            lastOverflowCount: 0,
            overflow: [],
            repartitioning: false,
            visible: _this.props.items
        };
        _this.spacer = null;
        _this.resize = function() {
            _this.repartition();
        };
        return _this;
    }
    OverflowList.ofType = function() {
        return OverflowList;
    };
    OverflowList.prototype.componentDidMount = function() {
        this.repartition();
    };
    OverflowList.prototype.shouldComponentUpdate = function(nextProps, nextState) {
        // We want this component to always re-render, even when props haven't changed, so that
        // changes in the renderers' behavior can be reflected.
        // The following statement prevents re-rendering only in the case where the state changes
        // identity (i.e. setState was called), but the state is still the same when
        // shallow-compared to the previous state. Original context: https://github.com/palantir/blueprint/pull/3278.
        // We also ensure that we re-render if the props DO change (which isn't necessarily accounted for by other logic).
        return this.props !== nextProps || !(this.state !== nextState && (0, _utils.shallowCompareKeys)(this.state, nextState));
    };
    OverflowList.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b;
        if (prevProps.observeParents !== this.props.observeParents) console.warn((0, _errors.OVERFLOW_LIST_OBSERVE_PARENTS_CHANGED));
        if (prevProps.collapseFrom !== this.props.collapseFrom || prevProps.items !== this.props.items || prevProps.minVisibleItems !== this.props.minVisibleItems || prevProps.overflowRenderer !== this.props.overflowRenderer || prevProps.alwaysRenderOverflow !== this.props.alwaysRenderOverflow || prevProps.visibleItemRenderer !== this.props.visibleItemRenderer) // reset visible state if the above props change.
        this.setState({
            chopSize: this.defaultChopSize(),
            lastChopSize: null,
            lastOverflowCount: 0,
            overflow: [],
            repartitioning: true,
            visible: this.props.items
        });
        var _c = this.state, repartitioning = _c.repartitioning, overflow = _c.overflow, lastOverflowCount = _c.lastOverflowCount;
        if (// if a resize operation has just completed
        repartitioning === false && prevState.repartitioning === true) // only invoke the callback if the UI has actually changed
        {
            if (overflow.length !== lastOverflowCount) (_b = (_a = this.props).onOverflow) === null || _b === void 0 || _b.call(_a, overflow.slice());
        } else if (!(0, _utils.shallowCompareKeys)(prevState, this.state)) this.repartition();
    };
    OverflowList.prototype.render = function() {
        var _this = this;
        var _a = this.props, className = _a.className, collapseFrom = _a.collapseFrom, observeParents = _a.observeParents, style = _a.style, _b = _a.tagName, tagName = _b === void 0 ? "div" : _b, visibleItemRenderer = _a.visibleItemRenderer;
        var overflow = this.maybeRenderOverflow();
        var list = _react.createElement(tagName, {
            className: (0, _classnamesDefault.default)((0, _common.Classes).OVERFLOW_LIST, className),
            style: style
        }, collapseFrom === (0, _common.Boundary).START ? overflow : null, this.state.visible.map(visibleItemRenderer), collapseFrom === (0, _common.Boundary).END ? overflow : null, _react.createElement("div", {
            className: (0, _common.Classes).OVERFLOW_LIST_SPACER,
            ref: function(ref) {
                return _this.spacer = ref;
            }
        }));
        return _react.createElement((0, _resizeSensor.ResizeSensor), {
            onResize: this.resize,
            observeParents: observeParents
        }, list);
    };
    OverflowList.prototype.maybeRenderOverflow = function() {
        var overflow = this.state.overflow;
        if (overflow.length === 0 && !this.props.alwaysRenderOverflow) return null;
        return this.props.overflowRenderer(overflow.slice());
    };
    OverflowList.prototype.repartition = function() {
        var _this = this;
        var _a;
        if (this.spacer == null) return;
        // if lastChopSize was 1, then our binary search has exhausted.
        var partitionExhausted = this.state.lastChopSize === 1;
        var minVisible = (_a = this.props.minVisibleItems) !== null && _a !== void 0 ? _a : 0;
        // spacer has flex-shrink and width 1px so if it's much smaller then we know to shrink
        var shouldShrink = this.spacer.offsetWidth < 0.9 && this.state.visible.length > minVisible;
        // we only check partitionExhausted for shouldGrow to ensure shrinking is the final operation.
        var shouldGrow = (this.spacer.offsetWidth >= 1 || this.state.visible.length < minVisible) && this.state.overflow.length > 0 && !partitionExhausted;
        if (shouldShrink || shouldGrow) this.setState(function(state) {
            var visible;
            var overflow;
            if (_this.props.collapseFrom === (0, _common.Boundary).END) {
                var result = shiftElements(state.visible, state.overflow, _this.state.chopSize * (shouldShrink ? 1 : -1));
                visible = result[0];
                overflow = result[1];
            } else {
                var result = shiftElements(state.overflow, state.visible, _this.state.chopSize * (shouldShrink ? -1 : 1));
                overflow = result[0];
                visible = result[1];
            }
            return {
                chopSize: halve(state.chopSize),
                lastChopSize: state.chopSize,
                // if we're starting a new partition cycle, record the last overflow count so we can track whether the UI changes after the new overflow is calculated
                lastOverflowCount: _this.isFirstPartitionCycle(state.chopSize) ? state.overflow.length : state.lastOverflowCount,
                overflow: overflow,
                repartitioning: true,
                visible: visible
            };
        });
        else // repartition complete!
        this.setState({
            chopSize: this.defaultChopSize(),
            lastChopSize: null,
            repartitioning: false
        });
    };
    OverflowList.prototype.defaultChopSize = function() {
        return halve(this.props.items.length);
    };
    OverflowList.prototype.isFirstPartitionCycle = function(currentChopSize) {
        return currentChopSize === this.defaultChopSize();
    };
    OverflowList.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".OverflowList");
    OverflowList.defaultProps = {
        alwaysRenderOverflow: false,
        collapseFrom: (0, _common.Boundary).START,
        minVisibleItems: 0
    };
    return OverflowList;
}(_react.Component);
function halve(num) {
    return Math.ceil(num / 2);
}
function shiftElements(leftArray, rightArray, num) {
    // if num is positive then elements are shifted from left-to-right, if negative then right-to-left
    var allElements = leftArray.concat(rightArray);
    var newLeftLength = leftArray.length - num;
    if (newLeftLength <= 0) return [
        [],
        allElements
    ];
    else if (newLeftLength >= allElements.length) return [
        allElements,
        []
    ];
    var sliceIndex = allElements.length - newLeftLength;
    return [
        allElements.slice(0, -sliceIndex),
        allElements.slice(-sliceIndex)
    ];
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/errors":"lyD8m","../../common/utils":"56UdR","../resize-sensor/resizeSensor":"lnJHO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kDaEn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonGroup", ()=>ButtonGroup);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var ButtonGroup = _react.forwardRef(function(props, ref) {
    var _a;
    var alignText = props.alignText, className = props.className, fill = props.fill, minimal = props.minimal, outlined = props.outlined, large = props.large, vertical = props.vertical, htmlProps = (0, _tslib.__rest)(props, [
        "alignText",
        "className",
        "fill",
        "minimal",
        "outlined",
        "large",
        "vertical"
    ]);
    var buttonGroupClasses = (0, _classnamesDefault.default)((0, _common.Classes).BUTTON_GROUP, (_a = {}, _a[(0, _common.Classes).FILL] = fill, _a[(0, _common.Classes).LARGE] = large, _a[(0, _common.Classes).MINIMAL] = minimal, _a[(0, _common.Classes).OUTLINED] = outlined, _a[(0, _common.Classes).VERTICAL] = vertical, _a), (0, _common.Classes).alignmentClass(alignText), className);
    return _react.createElement("div", (0, _tslib.__assign)({}, htmlProps, {
        ref: ref,
        className: buttonGroupClasses
    }), props.children);
});
ButtonGroup.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".ButtonGroup");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7CqlL":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Callout", ()=>Callout);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _html = require("../html/html");
var _icon = require("../icon/icon");
var Callout = function(props) {
    var _a;
    var className = props.className, children = props.children, icon = props.icon, intent = props.intent, title = props.title, compact = props.compact, _b = props.minimal, minimal = _b === void 0 ? false : _b, htmlProps = (0, _tslib.__rest)(props, [
        "className",
        "children",
        "icon",
        "intent",
        "title",
        "compact",
        "minimal"
    ]);
    var iconElement = renderIcon(icon, intent);
    var classes = (0, _classnamesDefault.default)((0, _common.Classes).CALLOUT, (0, _common.Classes).intentClass(intent), className, (_a = {}, _a[(0, _common.Classes).CALLOUT_HAS_BODY_CONTENT] = !(0, _common.Utils).isReactNodeEmpty(children), _a[(0, _common.Classes).CALLOUT_ICON] = iconElement != null, _a[(0, _common.Classes).COMPACT] = compact, _a[(0, _common.Classes).MINIMAL] = minimal, _a));
    return _react.createElement("div", (0, _tslib.__assign)({
        className: classes
    }, htmlProps), iconElement, title && _react.createElement((0, _html.H5), null, title), children);
};
Callout.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Callout");
var renderIcon = function(icon, intent) {
    // 1. no icon
    if (icon === null || icon === false) return undefined;
    var iconProps = {
        "aria-hidden": true,
        tabIndex: -1
    };
    // 2. icon specified by name or as a custom SVG element
    if (icon !== undefined) return _react.createElement((0, _icon.Icon), (0, _tslib.__assign)({
        icon: icon
    }, iconProps));
    // 3. icon specified by intent prop
    switch(intent){
        case (0, _common.Intent).DANGER:
            return _react.createElement((0, _icons.Error), (0, _tslib.__assign)({}, iconProps));
        case (0, _common.Intent).PRIMARY:
            return _react.createElement((0, _icons.InfoSign), (0, _tslib.__assign)({}, iconProps));
        case (0, _common.Intent).WARNING:
            return _react.createElement((0, _icons.WarningSign), (0, _tslib.__assign)({}, iconProps));
        case (0, _common.Intent).SUCCESS:
            return _react.createElement((0, _icons.Tick), (0, _tslib.__assign)({}, iconProps));
        default:
            return undefined;
    }
};

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../html/html":"6epty","../icon/icon":"duMtK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3tOjJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Card", ()=>Card);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var Card = _react.forwardRef(function(props, ref) {
    var _a;
    var className = props.className, elevation = props.elevation, interactive = props.interactive, selected = props.selected, compact = props.compact, htmlProps = (0, _tslib.__rest)(props, [
        "className",
        "elevation",
        "interactive",
        "selected",
        "compact"
    ]);
    var classes = (0, _classnamesDefault.default)(className, (0, _common.Classes).CARD, (0, _common.Classes).elevationClass(elevation), (_a = {}, _a[(0, _common.Classes).INTERACTIVE] = interactive, _a[(0, _common.Classes).COMPACT] = compact, _a[(0, _common.Classes).SELECTED] = selected, _a));
    return _react.createElement("div", (0, _tslib.__assign)({
        className: classes,
        ref: ref
    }, htmlProps));
});
Card.defaultProps = {
    elevation: (0, _common.Elevation).ZERO,
    interactive: false
};
Card.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Card");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c1VFK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardList", ()=>CardList);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _card = require("../card/card");
var CardList = _react.forwardRef(function(props, ref) {
    var _a;
    var bordered = props.bordered, className = props.className, children = props.children, compact = props.compact, htmlProps = (0, _tslib.__rest)(props, [
        "bordered",
        "className",
        "children",
        "compact"
    ]);
    var classes = (0, _classnamesDefault.default)(className, (0, _common.Classes).CARD_LIST, (_a = {}, _a[(0, _common.Classes).CARD_LIST_BORDERED] = bordered, _a[(0, _common.Classes).COMPACT] = compact, _a));
    return _react.createElement((0, _card.Card), (0, _tslib.__assign)({
        role: "list",
        elevation: (0, _common.Elevation).ZERO,
        className: classes
    }, htmlProps, {
        ref: ref
    }), children);
});
CardList.defaultProps = {
    bordered: true,
    compact: false
};
CardList.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".CardList");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../card/card":"3tOjJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6TvyY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationStates", ()=>AnimationStates);
parcelHelpers.export(exports, "Collapse", ()=>Collapse);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var AnimationStates;
(function(AnimationStates) {
    /**
     * The body is re-rendered, height is set to the measured body height and
     * the body Y is set to 0.
     */ AnimationStates[AnimationStates["OPEN_START"] = 0] = "OPEN_START";
    /**
     * Animation begins, height is set to auto. This is all animated, and on
     * complete, the state changes to OPEN.
     */ AnimationStates[AnimationStates["OPENING"] = 1] = "OPENING";
    /**
     * The collapse height is set to auto, and the body Y is set to 0 (so the
     * element can be seen as normal).
     */ AnimationStates[AnimationStates["OPEN"] = 2] = "OPEN";
    /**
     * Height has been changed from auto to the measured height of the body to
     * prepare for the closing animation in CLOSING.
     */ AnimationStates[AnimationStates["CLOSING_START"] = 3] = "CLOSING_START";
    /**
     * Height is set to 0 and the body Y is at -height. Both of these properties
     * are transformed, and then after the animation is complete, the state
     * changes to CLOSED.
     */ AnimationStates[AnimationStates["CLOSING"] = 4] = "CLOSING";
    /**
     * The contents of the collapse is not rendered, the collapse height is 0,
     * and the body Y is at -height (so that the bottom of the body is at Y=0).
     */ AnimationStates[AnimationStates["CLOSED"] = 5] = "CLOSED";
})(AnimationStates || (AnimationStates = {}));
/**
 * Collapse component.
 *
 * @see https://blueprintjs.com/docs/#core/components/collapse
 */ var Collapse = /** @class */ function(_super) {
    (0, _tslib.__extends)(Collapse, _super);
    function Collapse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            animationState: _this.props.isOpen ? AnimationStates.OPEN : AnimationStates.CLOSED,
            height: undefined,
            heightWhenOpen: undefined
        };
        // The element containing the contents of the collapse.
        _this.contents = null;
        _this.contentsRefHandler = function(el) {
            _this.contents = el;
            if (_this.contents != null) {
                var height = _this.contents.clientHeight;
                _this.setState({
                    animationState: _this.props.isOpen ? AnimationStates.OPEN : AnimationStates.CLOSED,
                    height: height === 0 ? undefined : "".concat(height, "px"),
                    heightWhenOpen: height === 0 ? undefined : height
                });
            }
        };
        return _this;
    }
    Collapse.getDerivedStateFromProps = function(props, state) {
        var isOpen = props.isOpen;
        var animationState = state.animationState;
        if (isOpen) switch(animationState){
            case AnimationStates.OPEN:
                break;
            case AnimationStates.OPENING:
                break;
            default:
                return {
                    animationState: AnimationStates.OPEN_START
                };
        }
        else switch(animationState){
            case AnimationStates.CLOSED:
                break;
            case AnimationStates.CLOSING:
                break;
            default:
                // need to set an explicit height so that transition can work
                return {
                    animationState: AnimationStates.CLOSING_START,
                    height: "".concat(state.heightWhenOpen, "px")
                };
        }
        return null;
    };
    Collapse.prototype.render = function() {
        var isContentVisible = this.state.animationState !== AnimationStates.CLOSED;
        var shouldRenderChildren = isContentVisible || this.props.keepChildrenMounted;
        var displayWithTransform = isContentVisible && this.state.animationState !== AnimationStates.CLOSING;
        var isAutoHeight = this.state.height === "auto";
        var containerStyle = {
            height: isContentVisible ? this.state.height : undefined,
            overflowY: isAutoHeight ? "visible" : undefined,
            // transitions don't work with height: auto
            transition: isAutoHeight ? "none" : undefined
        };
        var contentsStyle = {
            // only use heightWhenOpen while closing
            transform: displayWithTransform ? "translateY(0)" : "translateY(-".concat(this.state.heightWhenOpen, "px)"),
            // transitions don't work with height: auto
            transition: isAutoHeight ? "none" : undefined
        };
        return _react.createElement(this.props.component, {
            className: (0, _classnamesDefault.default)((0, _common.Classes).COLLAPSE, this.props.className),
            style: containerStyle
        }, _react.createElement("div", {
            className: (0, _common.Classes).COLLAPSE_BODY,
            ref: this.contentsRefHandler,
            style: contentsStyle,
            "aria-hidden": !isContentVisible
        }, shouldRenderChildren ? this.props.children : null));
    };
    Collapse.prototype.componentDidMount = function() {
        this.forceUpdate();
        // HACKHACK: this should probably be done in getSnapshotBeforeUpdate
        /* eslint-disable react/no-did-mount-set-state */ if (this.props.isOpen) this.setState({
            animationState: AnimationStates.OPEN,
            height: "auto"
        });
        else this.setState({
            animationState: AnimationStates.CLOSED,
            height: "0px"
        });
    /* eslint-disable react/no-did-mount-set-state */ };
    Collapse.prototype.componentDidUpdate = function() {
        var _this = this;
        if (this.contents == null) return;
        var transitionDuration = this.props.transitionDuration;
        var animationState = this.state.animationState;
        if (animationState === AnimationStates.OPEN_START) {
            var clientHeight = this.contents.clientHeight;
            this.setState({
                animationState: AnimationStates.OPENING,
                height: "".concat(clientHeight, "px"),
                heightWhenOpen: clientHeight
            });
            this.setTimeout(function() {
                return _this.onDelayedStateChange();
            }, transitionDuration);
        } else if (animationState === AnimationStates.CLOSING_START) {
            var clientHeight_1 = this.contents.clientHeight;
            this.setTimeout(function() {
                return _this.setState({
                    animationState: AnimationStates.CLOSING,
                    height: "0px",
                    heightWhenOpen: clientHeight_1
                });
            });
            this.setTimeout(function() {
                return _this.onDelayedStateChange();
            }, transitionDuration);
        }
    };
    Collapse.prototype.onDelayedStateChange = function() {
        switch(this.state.animationState){
            case AnimationStates.OPENING:
                this.setState({
                    animationState: AnimationStates.OPEN,
                    height: "auto"
                });
                break;
            case AnimationStates.CLOSING:
                this.setState({
                    animationState: AnimationStates.CLOSED
                });
                break;
            default:
                break;
        }
    };
    Collapse.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Collapse");
    Collapse.defaultProps = {
        component: "div",
        isOpen: false,
        keepChildrenMounted: false,
        transitionDuration: 200
    };
    return Collapse;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"RjXVq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextMenu", ()=>ContextMenu);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _tooltipContext = require("../popover/tooltipContext");
var _contextMenuPopover = require("./contextMenuPopover");
var ContextMenu = _react.forwardRef(function(props, userRef) {
    var className = props.className, children = props.children, content = props.content, _a = props.disabled, disabled = _a === void 0 ? false : _a, onClose = props.onClose, onContextMenu = props.onContextMenu, popoverProps = props.popoverProps, _b = props.tagName, tagName = _b === void 0 ? "div" : _b, restProps = (0, _tslib.__rest)(props, [
        "className",
        "children",
        "content",
        "disabled",
        "onClose",
        "onContextMenu",
        "popoverProps",
        "tagName"
    ]);
    // ancestor TooltipContext state doesn't affect us since we don't care about parent ContextMenus, we only want to
    // force disable parent Tooltips in certain cases through dispatching actions
    // N.B. any calls to this dispatch function will be no-ops if there is no TooltipProvider ancestor of this component
    var _c = _react.useContext((0, _tooltipContext.TooltipContext)), tooltipCtxDispatch = _c[1];
    // click target offset relative to the viewport (e.clientX/clientY), since the target will be rendered in a Portal
    var _d = _react.useState(undefined), targetOffset = _d[0], setTargetOffset = _d[1];
    // hold a reference to the click mouse event to pass to content/child render functions
    var _e = _react.useState(), mouseEvent = _e[0], setMouseEvent = _e[1];
    var _f = _react.useState(false), isOpen = _f[0], setIsOpen = _f[1];
    // we need a ref on the child element (or the wrapper we generate) to check for dark theme
    var childRef = _react.useRef(null);
    // If disabled prop is changed, we don't want our old context menu to stick around.
    // If it has just been enabled (disabled = false), then the menu ought to be opened by
    // a new mouse event. Users should not be updating this prop in the onContextMenu callback
    // for this component (that will lead to unpredictable behavior).
    _react.useEffect(function() {
        setIsOpen(false);
        tooltipCtxDispatch({
            type: "RESET_DISABLED_STATE"
        });
    }, [
        disabled,
        tooltipCtxDispatch
    ]);
    var handlePopoverClose = _react.useCallback(function() {
        setIsOpen(false);
        setMouseEvent(undefined);
        tooltipCtxDispatch({
            type: "RESET_DISABLED_STATE"
        });
        onClose === null || onClose === void 0 || onClose();
    }, [
        onClose,
        tooltipCtxDispatch
    ]);
    // if the menu was just opened, we should check for dark theme (but don't do this on every render)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var isDarkTheme = _react.useMemo(function() {
        return (0, _common.Utils).isDarkTheme(childRef.current);
    }, [
        childRef,
        isOpen
    ]);
    var contentProps = _react.useMemo(function() {
        return {
            isOpen: isOpen,
            mouseEvent: mouseEvent,
            targetOffset: targetOffset
        };
    }, [
        isOpen,
        mouseEvent,
        targetOffset
    ]);
    // create a memoized function to render the menu so that we can call it if necessary in the "contextmenu" event
    // handler which runs before this render function has a chance to re-run and update the `menu` variable
    var renderMenu = _react.useCallback(function(menuContentProps) {
        return disabled ? undefined : (0, _common.Utils).isFunction(content) ? content(menuContentProps) : content;
    }, [
        disabled,
        content
    ]);
    var menuContent = _react.useMemo(function() {
        return renderMenu(contentProps);
    }, [
        contentProps,
        renderMenu
    ]);
    // only render the popover if there is content in the context menu;
    // this avoid doing unnecessary rendering & computation
    var maybePopover = menuContent === undefined ? undefined : _react.createElement((0, _contextMenuPopover.ContextMenuPopover), (0, _tslib.__assign)({}, popoverProps, {
        content: menuContent,
        isDarkTheme: isDarkTheme,
        isOpen: isOpen,
        targetOffset: targetOffset,
        onClose: handlePopoverClose
    }));
    var handleContextMenu = _react.useCallback(function(e) {
        // support nested menus (inner menu target would have called preventDefault())
        if (e.defaultPrevented) return;
        // If disabled, we should avoid the extra work in this event handler.
        // Otherwise: if using the child or content function APIs, we need to make sure contentProps gets updated,
        // so we handle the event regardless of whether the consumer returned an undefined menu.
        var shouldHandleEvent = !disabled && ((0, _common.Utils).isFunction(children) || (0, _common.Utils).isFunction(content) || content !== undefined);
        if (shouldHandleEvent) {
            setIsOpen(true);
            e.persist();
            setMouseEvent(e);
            var newTargetOffset = {
                left: e.clientX,
                top: e.clientY
            };
            setTargetOffset(newTargetOffset);
            tooltipCtxDispatch({
                type: "FORCE_DISABLED_STATE"
            });
            var newMenuContent = renderMenu({
                isOpen: true,
                mouseEvent: e,
                targetOffset: newTargetOffset
            });
            if (newMenuContent === undefined) ;
            else e.preventDefault();
        }
        onContextMenu === null || onContextMenu === void 0 || onContextMenu(e);
    }, [
        disabled,
        children,
        content,
        onContextMenu,
        tooltipCtxDispatch,
        renderMenu
    ]);
    var containerClassName = (0, _classnamesDefault.default)(className, (0, _common.Classes).CONTEXT_MENU);
    var child = (0, _common.Utils).isFunction(children) ? children({
        className: containerClassName,
        contentProps: contentProps,
        onContextMenu: handleContextMenu,
        popover: maybePopover,
        ref: childRef
    }) : _react.createElement(_react.Fragment, null, maybePopover, _react.createElement(tagName, (0, _tslib.__assign)({
        className: containerClassName,
        onContextMenu: handleContextMenu,
        ref: (0, _common.mergeRefs)(childRef, userRef)
    }, restProps), children));
    // force descendant Tooltips to be disabled when this context menu is open
    return _react.createElement((0, _tooltipContext.TooltipProvider), {
        forceDisable: isOpen
    }, child);
});
ContextMenu.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".ContextMenu");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../popover/tooltipContext":"2ZDTk","./contextMenuPopover":"cGifI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGifI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextMenuPopover", ()=>ContextMenuPopover);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _popover = require("../popover/popover");
var _portal = require("../portal/portal");
var ContextMenuPopover = _react.memo(function _ContextMenuPopover(props) {
    var _a;
    var content = props.content, popoverClassName = props.popoverClassName, onClose = props.onClose, _b = props.isDarkTheme, isDarkTheme = _b === void 0 ? false : _b, _c = props.rootBoundary, rootBoundary = _c === void 0 ? "viewport" : _c, targetOffset = props.targetOffset, _d = props.transitionDuration, transitionDuration = _d === void 0 ? 100 : _d, popoverProps = (0, _tslib.__rest)(props, [
        "content",
        "popoverClassName",
        "onClose",
        "isDarkTheme",
        "rootBoundary",
        "targetOffset",
        "transitionDuration"
    ]);
    var cancelContextMenu = _react.useCallback(function(e) {
        return e.preventDefault();
    }, []);
    // Popover should attach its ref to the virtual target we render inside a Portal, not the "inline" child target
    var renderTarget = _react.useCallback(function(_a) {
        var ref = _a.ref;
        return _react.createElement((0, _portal.Portal), null, _react.createElement("div", {
            className: (0, _common.Classes).CONTEXT_MENU_VIRTUAL_TARGET,
            style: targetOffset,
            ref: ref
        }));
    }, [
        targetOffset
    ]);
    var handleInteraction = _react.useCallback(function(nextOpenState) {
        if (!nextOpenState) onClose === null || onClose === void 0 || onClose();
    }, [
        onClose
    ]);
    return _react.createElement((0, _popover.Popover), (0, _tslib.__assign)({
        placement: "right-start",
        rootBoundary: rootBoundary,
        transitionDuration: transitionDuration
    }, popoverProps, {
        content: // this prevents right-clicking inside our context menu
        _react.createElement("div", {
            onContextMenu: cancelContextMenu
        }, content),
        enforceFocus: false,
        // Generate key based on offset so that a new Popover instance is created
        // when offset changes, to force recomputing position.
        key: getPopoverKey(targetOffset),
        hasBackdrop: true,
        backdropProps: {
            className: (0, _common.Classes).CONTEXT_MENU_BACKDROP
        },
        minimal: true,
        onInteraction: handleInteraction,
        popoverClassName: (0, _classnamesDefault.default)((0, _common.Classes).CONTEXT_MENU_POPOVER, popoverClassName, (_a = {}, _a[(0, _common.Classes).DARK] = isDarkTheme, _a)),
        positioningStrategy: "fixed",
        renderTarget: renderTarget
    }));
});
ContextMenuPopover.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".ContextMenuPopover");
function getPopoverKey(targetOffset) {
    return targetOffset === undefined ? "default" : "".concat(targetOffset.left, "x").concat(targetOffset.top);
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../popover/popover":"2UrEu","../portal/portal":"kksjR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"84kGc":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Show a context menu at a particular offset from the top-left corner of the document.
 * The menu will appear below-right of this point and will flip to below-left if there is not enough
 * room onscreen. Additional props like `onClose`, `isDarkTheme`, etc. can be forwarded to the `<ContextMenuPopover>`.
 *
 * Context menus created with this API will automatically close when a user clicks outside the popover.
 * You may force them to close by using `hideContextMenu()`.
 *
 * Note that this API relies on global state in the @blueprintjs/core package, and should be used with caution,
 * especially if your build system allows multiple copies of Blueprint libraries to be bundled into an application at
 * once.
 *
 * Alternative APIs to consider which do not have the limitations of global state:
 *  - `<ContextMenu>`
 *  - `<ContextMenuPopover>`
 *
 * @see https://blueprintjs.com/docs/#core/components/context-menu-popover.imperative-api
 */ parcelHelpers.export(exports, "showContextMenu", ()=>showContextMenu);
/**
 * Hide a context menu that was created using `showContextMenu()`.
 *
 * Note that this API relies on global state in the @blueprintjs/core package, and should be used with caution.
 *
 * @see https://blueprintjs.com/docs/#core/components/context-menu-popover.imperative-api
 */ parcelHelpers.export(exports, "hideContextMenu", ()=>hideContextMenu);
var _tslib = require("tslib");
var _react = require("react");
var _reactDom = require("react-dom");
var _common = require("../../common");
var _overlaysProvider = require("../../context/overlays/overlaysProvider");
var _contextMenuPopover = require("./contextMenuPopover");
/** DOM element which contains the context menu singleton instance for the imperative ContextMenu APIs. */ var contextMenuElement;
function showContextMenu(props, options) {
    if (options === void 0) options = {};
    var _a = options.container, container = _a === void 0 ? document.body : _a, _b = options.domRenderer, domRenderer = _b === void 0 ? _reactDom.render : _b, _c = options.domUnmounter, domUnmounter = _c === void 0 ? _reactDom.unmountComponentAtNode : _c;
    if (contextMenuElement === undefined) {
        contextMenuElement = document.createElement("div");
        contextMenuElement.classList.add((0, _common.Classes).CONTEXT_MENU);
        container.appendChild(contextMenuElement);
    } else // N.B. It's important to unmount previous instances of the ContextMenuPopover rendered by this function.
    // Otherwise, React will detect no change in props sent to the already-mounted component, and therefore
    // do nothing after the first call to this function, leading to bugs like https://github.com/palantir/blueprint/issues/5949
    domUnmounter(contextMenuElement);
    domRenderer(_react.createElement((0, _overlaysProvider.OverlaysProvider), null, _react.createElement(UncontrolledContextMenuPopover, (0, _tslib.__assign)({}, props))), contextMenuElement);
}
function hideContextMenu(options) {
    if (options === void 0) options = {};
    var _a = options.domUnmounter, domUnmounter = _a === void 0 ? _reactDom.unmountComponentAtNode : _a;
    if (contextMenuElement !== undefined) {
        domUnmounter(contextMenuElement);
        contextMenuElement = undefined;
    }
}
/**
 * A simple wrapper around `ContextMenuPopover` which is open by default and uncontrolled.
 * It closes when a user clicks outside the popover.
 */ function UncontrolledContextMenuPopover(_a) {
    var onClose = _a.onClose, props = (0, _tslib.__rest)(_a, [
        "onClose"
    ]);
    var _b = _react.useState(true), isOpen = _b[0], setIsOpen = _b[1];
    var handleClose = _react.useCallback(function() {
        setIsOpen(false);
        onClose === null || onClose === void 0 || onClose();
    }, [
        onClose
    ]);
    return _react.createElement((0, _contextMenuPopover.ContextMenuPopover), (0, _tslib.__assign)({
        isOpen: isOpen
    }, props, {
        onClose: handleClose
    }));
}

},{"tslib":"b4wpY","react":"9njXz","react-dom":"2ApDx","../../common":"3QDnh","../../context/overlays/overlaysProvider":"2LpRL","./contextMenuPopover":"cGifI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixDB1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DialogBody", ()=>DialogBody);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
/**
 * Dialog body component.
 *
 * @see https://blueprintjs.com/docs/#core/components/dialog.dialog-body-props
 */ var DialogBody = /** @class */ function(_super) {
    (0, _tslib.__extends)(DialogBody, _super);
    function DialogBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogBody.prototype.render = function() {
        var _a;
        return _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).DIALOG_BODY, this.props.className, (_a = {}, _a[(0, _common.Classes).DIALOG_BODY_SCROLL_CONTAINER] = this.props.useOverflowScrollContainer, _a))
        }, this.props.children);
    };
    DialogBody.defaultProps = {
        useOverflowScrollContainer: true
    };
    return DialogBody;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"P111Z":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DialogFooter", ()=>DialogFooter);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
/**
 * Dialog footer component.
 *
 * @see https://blueprintjs.com/docs/#core/components/dialog.dialog-footer-props
 */ var DialogFooter = /** @class */ function(_super) {
    (0, _tslib.__extends)(DialogFooter, _super);
    function DialogFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogFooter.prototype.render = function() {
        var _a;
        return _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).DIALOG_FOOTER, this.props.className, (_a = {}, _a[(0, _common.Classes).DIALOG_FOOTER_FIXED] = !this.props.minimal, _a))
        }, this.renderMainSection(), this.maybeRenderActionsSection());
    };
    /** Render the main footer section (left aligned). */ DialogFooter.prototype.renderMainSection = function() {
        return _react.createElement("div", {
            className: (0, _common.Classes).DIALOG_FOOTER_MAIN_SECTION
        }, this.props.children);
    };
    /** Optionally render the footer actions (right aligned). */ DialogFooter.prototype.maybeRenderActionsSection = function() {
        var actions = this.props.actions;
        if (actions == null) return undefined;
        return _react.createElement("div", {
            className: (0, _common.Classes).DIALOG_FOOTER_ACTIONS
        }, actions);
    };
    DialogFooter.defaultProps = {
        minimal: false
    };
    return DialogFooter;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6e1tf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DialogStep", ()=>DialogStep);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
/**
 * Dialog step component.
 *
 * @see https://blueprintjs.com/docs/#core/components/dialog.dialogstep
 */ var DialogStep = /** @class */ function(_super) {
    (0, _tslib.__extends)(DialogStep, _super);
    function DialogStep() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // this component is never rendered directly; see MultistepDialog#renderDialogStepPanel()
    /* istanbul ignore next */ DialogStep.prototype.render = function() {
        var className = this.props.className;
        return _react.createElement("div", {
            className: (0, _common.Classes).DIALOG_STEP_CONTAINER,
            role: "tab"
        }, _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).DIALOG_STEP, className)
        }));
    };
    DialogStep.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".DialogStep");
    return DialogStep;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cg8y":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultistepDialog", ()=>MultistepDialog);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _utils = require("../../common/utils");
var _dialog = require("./dialog");
var _dialogFooter = require("./dialogFooter");
var _dialogStep = require("./dialogStep");
var _dialogStepButton = require("./dialogStepButton");
var PADDING_BOTTOM = 0;
var MIN_WIDTH = 800;
/**
 * Multi-step dialog component.
 *
 * @see https://blueprintjs.com/docs/#core/components/dialog.multistep-dialog
 */ var MultistepDialog = /** @class */ function(_super) {
    (0, _tslib.__extends)(MultistepDialog, _super);
    function MultistepDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _this.getInitialIndexFromProps(_this.props);
        _this.renderDialogStep = function(step, index) {
            var _a;
            var stepNumber = index + 1;
            var hasBeenViewed = _this.state.lastViewedIndex >= index;
            var currentlySelected = _this.state.selectedIndex === index;
            var handleClickDialogStep = index > _this.state.lastViewedIndex ? undefined : _this.getDialogStepChangeHandler(index);
            return _react.createElement("div", {
                className: (0, _classnamesDefault.default)((0, _common.Classes).DIALOG_STEP_CONTAINER, (_a = {}, _a[(0, _common.Classes).ACTIVE] = currentlySelected, _a[(0, _common.Classes).DIALOG_STEP_VIEWED] = hasBeenViewed, _a)),
                key: index,
                "aria-disabled": !currentlySelected && !hasBeenViewed,
                "aria-selected": currentlySelected,
                role: "tab"
            }, _react.createElement("div", {
                className: (0, _common.Classes).DIALOG_STEP,
                onClick: handleClickDialogStep,
                tabIndex: handleClickDialogStep ? 0 : -1,
                // enable enter key to take effect on the div as if it were a button
                onKeyDown: (0, _utils.clickElementOnKeyPress)([
                    "Enter",
                    " "
                ])
            }, _react.createElement("div", {
                className: (0, _common.Classes).DIALOG_STEP_ICON
            }, stepNumber), _react.createElement("div", {
                className: (0, _common.Classes).DIALOG_STEP_TITLE
            }, step.props.title)));
        };
        return _this;
    }
    MultistepDialog.prototype.render = function() {
        var _a;
        var _b = this.props, className = _b.className, navigationPosition = _b.navigationPosition, showCloseButtonInFooter = _b.showCloseButtonInFooter, isCloseButtonShown = _b.isCloseButtonShown, otherProps = (0, _tslib.__rest)(_b, [
            "className",
            "navigationPosition",
            "showCloseButtonInFooter",
            "isCloseButtonShown"
        ]);
        return _react.createElement((0, _dialog.Dialog), (0, _tslib.__assign)({
            isCloseButtonShown: isCloseButtonShown
        }, otherProps, {
            className: (0, _classnamesDefault.default)((_a = {}, _a[(0, _common.Classes).MULTISTEP_DIALOG_NAV_RIGHT] = navigationPosition === "right", _a[(0, _common.Classes).MULTISTEP_DIALOG_NAV_TOP] = navigationPosition === "top", _a), className),
            style: this.getDialogStyle()
        }), _react.createElement("div", {
            className: (0, _common.Classes).MULTISTEP_DIALOG_PANELS
        }, this.renderLeftPanel(), this.maybeRenderRightPanel()));
    };
    MultistepDialog.prototype.componentDidUpdate = function(prevProps) {
        if ((prevProps.resetOnClose || prevProps.initialStepIndex !== this.props.initialStepIndex) && !prevProps.isOpen && this.props.isOpen) this.setState(this.getInitialIndexFromProps(this.props));
    };
    MultistepDialog.prototype.getDialogStyle = function() {
        return (0, _tslib.__assign)({
            minWidth: MIN_WIDTH,
            paddingBottom: PADDING_BOTTOM
        }, this.props.style);
    };
    MultistepDialog.prototype.renderLeftPanel = function() {
        return _react.createElement("div", {
            className: (0, _common.Classes).MULTISTEP_DIALOG_LEFT_PANEL,
            role: "tablist",
            "aria-label": "steps"
        }, this.getDialogStepChildren().filter(isDialogStepElement).map(this.renderDialogStep));
    };
    MultistepDialog.prototype.maybeRenderRightPanel = function() {
        var steps = this.getDialogStepChildren();
        if (steps.length <= this.state.selectedIndex) return null;
        var _a = steps[this.state.selectedIndex].props, className = _a.className, panel = _a.panel, panelClassName = _a.panelClassName;
        return _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).MULTISTEP_DIALOG_RIGHT_PANEL, className, panelClassName)
        }, panel, this.renderFooter());
    };
    MultistepDialog.prototype.renderFooter = function() {
        var _a = this.props, closeButtonProps = _a.closeButtonProps, showCloseButtonInFooter = _a.showCloseButtonInFooter, onClose = _a.onClose;
        var maybeCloseButton = !showCloseButtonInFooter ? undefined : _react.createElement((0, _dialogStepButton.DialogStepButton), (0, _tslib.__assign)({
            text: "Close",
            onClick: onClose
        }, closeButtonProps));
        return _react.createElement((0, _dialogFooter.DialogFooter), {
            actions: this.renderButtons()
        }, maybeCloseButton);
    };
    MultistepDialog.prototype.renderButtons = function() {
        var _a, _b;
        var selectedIndex = this.state.selectedIndex;
        var steps = this.getDialogStepChildren();
        var buttons = [];
        if (this.state.selectedIndex > 0) {
            var backButtonProps = (_a = steps[selectedIndex].props.backButtonProps) !== null && _a !== void 0 ? _a : this.props.backButtonProps;
            buttons.push(_react.createElement((0, _dialogStepButton.DialogStepButton), (0, _tslib.__assign)({
                key: "back",
                onClick: this.getDialogStepChangeHandler(selectedIndex - 1),
                text: "Back"
            }, backButtonProps)));
        }
        if (selectedIndex === this.getDialogStepChildren().length - 1) buttons.push(_react.createElement((0, _dialogStepButton.DialogStepButton), (0, _tslib.__assign)({
            intent: "primary",
            key: "final",
            text: "Submit"
        }, this.props.finalButtonProps)));
        else {
            var nextButtonProps = (_b = steps[selectedIndex].props.nextButtonProps) !== null && _b !== void 0 ? _b : this.props.nextButtonProps;
            buttons.push(_react.createElement((0, _dialogStepButton.DialogStepButton), (0, _tslib.__assign)({
                intent: "primary",
                key: "next",
                onClick: this.getDialogStepChangeHandler(selectedIndex + 1),
                text: "Next"
            }, nextButtonProps)));
        }
        return buttons;
    };
    MultistepDialog.prototype.getDialogStepChangeHandler = function(index) {
        var _this = this;
        return function(event) {
            if (_this.props.onChange !== undefined) {
                var steps = _this.getDialogStepChildren();
                var prevStepId = steps[_this.state.selectedIndex].props.id;
                var newStepId = steps[index].props.id;
                _this.props.onChange(newStepId, prevStepId, event);
            }
            _this.setState({
                lastViewedIndex: Math.max(_this.state.lastViewedIndex, index),
                selectedIndex: index
            });
        };
    };
    /** Filters children to only `<DialogStep>`s */ MultistepDialog.prototype.getDialogStepChildren = function(props) {
        if (props === void 0) props = this.props;
        return _react.Children.toArray(props.children).filter(isDialogStepElement);
    };
    MultistepDialog.prototype.getInitialIndexFromProps = function(props) {
        if (props.initialStepIndex !== undefined) {
            var boundedInitialIndex = Math.max(0, Math.min(props.initialStepIndex, this.getDialogStepChildren(props).length - 1));
            return {
                lastViewedIndex: boundedInitialIndex,
                selectedIndex: boundedInitialIndex
            };
        } else return {
            lastViewedIndex: 0,
            selectedIndex: 0
        };
    };
    MultistepDialog.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".MultistepDialog");
    MultistepDialog.defaultProps = {
        canOutsideClickClose: true,
        isOpen: false,
        navigationPosition: "left",
        resetOnClose: true,
        showCloseButtonInFooter: false
    };
    return MultistepDialog;
}((0, _common.AbstractPureComponent));
function isDialogStepElement(child) {
    return (0, _common.Utils).isElementOfType(child, (0, _dialogStep.DialogStep));
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","../../common/utils":"56UdR","./dialog":"6MadC","./dialogFooter":"P111Z","./dialogStep":"6e1tf","./dialogStepButton":"jIW8C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jIW8C":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DialogStepButton", ()=>DialogStepButton);
var _tslib = require("tslib");
var _react = require("react");
var _buttons = require("../button/buttons");
var _tooltip = require("../tooltip/tooltip");
function DialogStepButton(_a) {
    var tooltipContent = _a.tooltipContent, props = (0, _tslib.__rest)(_a, [
        "tooltipContent"
    ]);
    var button = _react.createElement((0, _buttons.AnchorButton), (0, _tslib.__assign)({}, props));
    if (tooltipContent !== undefined) return _react.createElement((0, _tooltip.Tooltip), {
        content: tooltipContent
    }, button);
    else return button;
}

},{"tslib":"b4wpY","react":"9njXz","../button/buttons":"glm43","../tooltip/tooltip":"hMZHg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7alHo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Divider", ()=>Divider);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _classes = require("../../common/classes");
var _props = require("../../common/props");
var Divider = function(_a) {
    var className = _a.className, _b = _a.tagName, tagName = _b === void 0 ? "div" : _b, htmlProps = (0, _tslib.__rest)(_a, [
        "className",
        "tagName"
    ]);
    var classes = (0, _classnamesDefault.default)((0, _classes.DIVIDER), className);
    return _react.createElement(tagName, (0, _tslib.__assign)((0, _tslib.__assign)({}, htmlProps), {
        className: classes
    }));
};
Divider.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Divider");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common/classes":"2PICA","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aaN6c":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DrawerSize", ()=>DrawerSize);
parcelHelpers.export(exports, "Drawer", ()=>Drawer);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _position = require("../../common/position");
var _props = require("../../common/props");
var _buttons = require("../button/buttons");
var _html = require("../html/html");
var _icon = require("../icon/icon");
var _overlay2 = require("../overlay2/overlay2");
var DrawerSize;
(function(DrawerSize) {
    DrawerSize["SMALL"] = "360px";
    DrawerSize["STANDARD"] = "50%";
    DrawerSize["LARGE"] = "90%";
})(DrawerSize || (DrawerSize = {}));
var Drawer = /** @class */ function(_super) {
    (0, _tslib.__extends)(Drawer, _super);
    function Drawer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Drawer.prototype.render = function() {
        var _a, _b, _c;
        var _d;
        var _e = this.props, hasBackdrop = _e.hasBackdrop, size = _e.size, style = _e.style, position = _e.position;
        var _f = this.props, className = _f.className, children = _f.children, overlayProps = (0, _tslib.__rest)(_f, [
            "className",
            "children"
        ]);
        var realPosition = (0, _position.getPositionIgnoreAngles)(position);
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).DRAWER, (_a = {}, _a[(_d = (0, _common.Classes).positionClass(realPosition)) !== null && _d !== void 0 ? _d : ""] = true, _a), className);
        var styleProp = size == null ? style : (0, _tslib.__assign)((0, _tslib.__assign)({}, style), (_b = {}, _b[(0, _position.isPositionHorizontal)(realPosition) ? "height" : "width"] = size, _b));
        return(// N.B. the `OVERLAY_CONTAINER` class is a bit of a misnomer since it is only being used by the Drawer
        // component, but we keep it for backwards compatibility.
        _react.createElement((0, _overlay2.Overlay2), (0, _tslib.__assign)({}, overlayProps, {
            className: (0, _classnamesDefault.default)((_c = {}, _c[(0, _common.Classes).OVERLAY_CONTAINER] = hasBackdrop, _c))
        }), _react.createElement("div", {
            className: classes,
            style: styleProp
        }, this.maybeRenderHeader(), children)));
    };
    Drawer.prototype.validateProps = function(props) {
        if (props.title == null) {
            if (props.icon != null) console.warn(_errors.DIALOG_WARN_NO_HEADER_ICON);
            if (props.isCloseButtonShown != null) console.warn(_errors.DIALOG_WARN_NO_HEADER_CLOSE_BUTTON);
        }
        if (props.position != null) {
            if (props.position !== (0, _position.getPositionIgnoreAngles)(props.position)) console.warn(_errors.DRAWER_ANGLE_POSITIONS_ARE_CASTED);
        }
    };
    Drawer.prototype.maybeRenderCloseButton = function() {
        // `isCloseButtonShown` can't be defaulted through default props because of props validation
        // so this check actually defaults it to true (fails only if directly set to false)
        if (this.props.isCloseButtonShown !== false) return _react.createElement((0, _buttons.Button), {
            "aria-label": "Close",
            className: (0, _common.Classes).DIALOG_CLOSE_BUTTON,
            icon: _react.createElement((0, _icons.SmallCross), {
                size: (0, _icons.IconSize).LARGE
            }),
            minimal: true,
            onClick: this.props.onClose
        });
        else return null;
    };
    Drawer.prototype.maybeRenderHeader = function() {
        var _a = this.props, icon = _a.icon, title = _a.title;
        if (title == null) return null;
        return _react.createElement("div", {
            className: (0, _common.Classes).DRAWER_HEADER
        }, _react.createElement((0, _icon.Icon), {
            icon: icon,
            size: (0, _icons.IconSize).LARGE
        }), _react.createElement((0, _html.H4), null, title), this.maybeRenderCloseButton());
    };
    Drawer.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Drawer");
    Drawer.defaultProps = {
        canOutsideClickClose: true,
        isOpen: false,
        position: "right",
        style: {}
    };
    return Drawer;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../../common/errors":"lyD8m","../../common/position":"1PCvS","../../common/props":"dBcIV","../button/buttons":"glm43","../html/html":"6epty","../icon/icon":"duMtK","../overlay2/overlay2":"3eEFv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1sFf4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditableText", ()=>EditableText);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _utils = require("../../common/utils");
var BUFFER_WIDTH_DEFAULT = 5;
/**
 * EditableText component.
 *
 * @see https://blueprintjs.com/docs/#core/components/editable-text
 */ var EditableText = /** @class */ function(_super) {
    (0, _tslib.__extends)(EditableText, _super);
    function EditableText(props) {
        var _this = _super.call(this, props) || this;
        _this.inputElement = null;
        _this.valueElement = null;
        _this.refHandlers = {
            content: function(spanElement) {
                _this.valueElement = spanElement;
            },
            input: function(input) {
                if (input != null) {
                    _this.inputElement = input;
                    // temporary fix for #3882
                    if (!_this.props.alwaysRenderInput) _this.inputElement.focus();
                    if (_this.state != null && _this.state.isEditing) {
                        var supportsSelection = inputSupportsSelection(input);
                        if (supportsSelection) {
                            var length_1 = input.value.length;
                            input.setSelectionRange(_this.props.selectAllOnFocus ? 0 : length_1, length_1);
                        }
                        if (!supportsSelection || !_this.props.selectAllOnFocus) input.scrollLeft = input.scrollWidth;
                    }
                }
            }
        };
        _this.cancelEditing = function() {
            var _a, _b, _c, _d;
            var _e = _this.state, lastValue = _e.lastValue, value = _e.value;
            _this.setState({
                isEditing: false,
                value: lastValue
            });
            if (value !== lastValue) (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, lastValue);
            (_d = (_c = _this.props).onCancel) === null || _d === void 0 || _d.call(_c, lastValue);
        };
        _this.toggleEditing = function() {
            var _a, _b;
            if (_this.state.isEditing) {
                var value = _this.state.value;
                _this.setState({
                    isEditing: false,
                    lastValue: value
                });
                (_b = (_a = _this.props).onConfirm) === null || _b === void 0 || _b.call(_a, value);
            } else if (!_this.props.disabled) _this.setState({
                isEditing: true
            });
        };
        _this.handleFocus = function() {
            var _a = _this.props, alwaysRenderInput = _a.alwaysRenderInput, disabled = _a.disabled, selectAllOnFocus = _a.selectAllOnFocus;
            if (!disabled) _this.setState({
                isEditing: true
            });
            if (alwaysRenderInput && selectAllOnFocus && _this.inputElement != null) {
                var length_2 = _this.inputElement.value.length;
                _this.inputElement.setSelectionRange(0, length_2);
            }
        };
        _this.handleTextChange = function(event) {
            var _a, _b;
            var value = event.target.value;
            // state value should be updated only when uncontrolled
            if (_this.props.value == null) _this.setState({
                value: value
            });
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, value);
        };
        _this.handleKeyEvent = function(event) {
            // During IME composition, Enter and Escape has special meanings that we will not override
            if (event.nativeEvent.isComposing) return;
            var altKey = event.altKey, ctrlKey = event.ctrlKey, metaKey = event.metaKey, shiftKey = event.shiftKey;
            if (event.key === "Escape") {
                _this.cancelEditing();
                return;
            }
            var hasModifierKey = altKey || ctrlKey || metaKey || shiftKey;
            if (event.key === "Enter") {
                // prevent browsers (Edge?) from full screening with alt + enter
                // shift + enter adds a newline by default
                if (altKey || shiftKey) event.preventDefault();
                if (_this.props.confirmOnEnterKey && _this.props.multiline) {
                    if (event.target != null && hasModifierKey) {
                        insertAtCaret(event.target, "\n");
                        _this.handleTextChange(event);
                    } else _this.toggleEditing();
                } else if (!_this.props.multiline || hasModifierKey) _this.toggleEditing();
            }
        };
        var value = props.value == null ? props.defaultValue : props.value;
        _this.state = {
            inputHeight: 0,
            inputWidth: 0,
            isEditing: props.isEditing === true && props.disabled === false,
            lastValue: value,
            value: value
        };
        return _this;
    }
    EditableText.prototype.render = function() {
        var _a;
        var _b;
        var _c = this.props, alwaysRenderInput = _c.alwaysRenderInput, disabled = _c.disabled, elementRef = _c.elementRef, multiline = _c.multiline, contentId = _c.contentId;
        var value = (_b = this.props.value) !== null && _b !== void 0 ? _b : this.state.value;
        var hasValue = value != null && value !== "";
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).EDITABLE_TEXT, (0, _common.Classes).intentClass(this.props.intent), (_a = {}, _a[(0, _common.Classes).DISABLED] = disabled, _a[(0, _common.Classes).EDITABLE_TEXT_EDITING] = this.state.isEditing, _a[(0, _common.Classes).EDITABLE_TEXT_PLACEHOLDER] = !hasValue, _a[(0, _common.Classes).MULTILINE] = multiline, _a), this.props.className);
        var contentStyle;
        if (multiline) // set height only in multiline mode when not editing
        // otherwise we're measuring this element to determine appropriate height of text
        contentStyle = {
            height: !this.state.isEditing ? this.state.inputHeight : undefined
        };
        else // minWidth only applies in single line mode (multiline == width 100%)
        contentStyle = {
            height: this.state.inputHeight,
            lineHeight: this.state.inputHeight != null ? "".concat(this.state.inputHeight, "px") : undefined,
            minWidth: this.props.minWidth
        };
        // If we are always rendering an input, then NEVER make the container div focusable.
        // Otherwise, make container div focusable when not editing, so it can still be tabbed
        // to focus (when the input is rendered, it is itself focusable so container div doesn't need to be)
        var tabIndex = alwaysRenderInput || this.state.isEditing || disabled ? undefined : 0;
        // we need the contents to be rendered while editing so that we can measure their height
        // and size the container element responsively
        var shouldHideContents = alwaysRenderInput && !this.state.isEditing;
        var spanProps = contentId != null ? {
            id: contentId
        } : {};
        return _react.createElement("div", {
            className: classes,
            onFocus: this.handleFocus,
            tabIndex: tabIndex,
            ref: elementRef
        }, alwaysRenderInput || this.state.isEditing ? this.renderInput(value) : undefined, shouldHideContents ? undefined : _react.createElement("span", (0, _tslib.__assign)({}, spanProps, {
            className: (0, _common.Classes).EDITABLE_TEXT_CONTENT,
            ref: this.refHandlers.content,
            style: contentStyle
        }), hasValue ? value : this.props.placeholder));
    };
    EditableText.prototype.componentDidMount = function() {
        this.updateInputDimensions();
    };
    EditableText.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b;
        var newState = {};
        // allow setting the value to undefined/null in controlled mode
        if (this.props.value !== prevProps.value && (prevProps.value != null || this.props.value != null)) newState.value = this.props.value;
        if (this.props.isEditing != null && this.props.isEditing !== prevProps.isEditing) newState.isEditing = this.props.isEditing;
        if (this.props.disabled || this.props.disabled == null && prevProps.disabled) newState.isEditing = false;
        this.setState(newState);
        if (this.state.isEditing && !prevState.isEditing) (_b = (_a = this.props).onEdit) === null || _b === void 0 || _b.call(_a, this.state.value);
        // updateInputDimensions is an expensive method. Call it only when the props
        // it depends on change
        if (this.state.value !== prevState.value || this.props.alwaysRenderInput !== prevProps.alwaysRenderInput || this.props.maxLines !== prevProps.maxLines || this.props.minLines !== prevProps.minLines || this.props.minWidth !== prevProps.minWidth || this.props.multiline !== prevProps.multiline || this.props.placeholder !== prevProps.placeholder) this.updateInputDimensions();
    };
    EditableText.prototype.renderInput = function(value) {
        var _a = this.props, disabled = _a.disabled, maxLength = _a.maxLength, multiline = _a.multiline, type = _a.type, placeholder = _a.placeholder;
        var props = {
            className: (0, _common.Classes).EDITABLE_TEXT_INPUT,
            disabled: disabled,
            maxLength: maxLength,
            onBlur: this.toggleEditing,
            onChange: this.handleTextChange,
            onKeyDown: this.handleKeyEvent,
            placeholder: placeholder,
            value: value
        };
        var _b = this.state, inputHeight = _b.inputHeight, inputWidth = _b.inputWidth;
        if (inputHeight !== 0 && inputWidth !== 0) props.style = {
            height: inputHeight,
            lineHeight: !multiline && inputHeight != null ? "".concat(inputHeight, "px") : undefined,
            width: multiline ? "100%" : inputWidth
        };
        return multiline ? _react.createElement("textarea", (0, _tslib.__assign)({
            ref: this.refHandlers.input
        }, props)) : _react.createElement("input", (0, _tslib.__assign)({
            ref: this.refHandlers.input,
            type: type
        }, props));
    };
    EditableText.prototype.updateInputDimensions = function() {
        if (this.valueElement != null) {
            var _a = this.props, maxLines = _a.maxLines, minLines = _a.minLines, minWidth = _a.minWidth, multiline = _a.multiline;
            var _b = this.valueElement, parentElement_1 = _b.parentElement, textContent = _b.textContent;
            var _c = this.valueElement, scrollHeight_1 = _c.scrollHeight, scrollWidth = _c.scrollWidth;
            var lineHeight = getLineHeight(this.valueElement);
            // add one line to computed <span> height if text ends in newline
            // because <span> collapses that trailing whitespace but <textarea> shows it
            if (multiline && this.state.isEditing && /\n$/.test(textContent !== null && textContent !== void 0 ? textContent : "")) scrollHeight_1 += lineHeight;
            if (lineHeight > 0) // line height could be 0 if the isNaN block from getLineHeight kicks in
            scrollHeight_1 = (0, _utils.clamp)(scrollHeight_1, minLines * lineHeight, maxLines * lineHeight);
            // Chrome's input caret height misaligns text so the line-height must be larger than font-size.
            // The computed scrollHeight must also account for a larger inherited line-height from the parent.
            scrollHeight_1 = Math.max(scrollHeight_1, getFontSize(this.valueElement) + 1, getLineHeight(parentElement_1));
            // Need to add a small buffer so text does not shift prior to resizing, causing an infinite loop.
            scrollWidth += BUFFER_WIDTH_DEFAULT;
            this.setState({
                inputHeight: scrollHeight_1,
                inputWidth: Math.max(scrollWidth, minWidth)
            });
            // synchronizes the ::before pseudo-element's height while editing for Chrome 53
            if (multiline && this.state.isEditing) this.setTimeout(function() {
                return parentElement_1.style.height = "".concat(scrollHeight_1, "px");
            });
        }
    };
    EditableText.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".EditableText");
    EditableText.defaultProps = {
        alwaysRenderInput: false,
        confirmOnEnterKey: false,
        defaultValue: "",
        disabled: false,
        maxLines: Infinity,
        minLines: 1,
        minWidth: 80,
        multiline: false,
        placeholder: "Click to Edit",
        type: "text"
    };
    return EditableText;
}((0, _common.AbstractPureComponent));
function getFontSize(element) {
    var fontSize = getComputedStyle(element).fontSize;
    return fontSize === "" ? 0 : parseInt(fontSize.slice(0, -2), 10);
}
function getLineHeight(element) {
    // getComputedStyle() => 18.0001px => 18
    var lineHeight = parseInt(getComputedStyle(element).lineHeight.slice(0, -2), 10);
    // this check will be true if line-height is a keyword like "normal"
    if (isNaN(lineHeight)) {
        // @see http://stackoverflow.com/a/18430767/6342931
        var line = document.createElement("span");
        line.innerHTML = "<br>";
        element.appendChild(line);
        var singleLineHeight = element.offsetHeight;
        line.innerHTML = "<br><br>";
        var doubleLineHeight = element.offsetHeight;
        element.removeChild(line);
        // this can return 0 in edge cases
        lineHeight = doubleLineHeight - singleLineHeight;
    }
    return lineHeight;
}
function insertAtCaret(el, text) {
    var selectionEnd = el.selectionEnd, selectionStart = el.selectionStart, value = el.value;
    if (selectionStart >= 0) {
        var before_1 = value.substring(0, selectionStart);
        var after_1 = value.substring(selectionEnd, value.length);
        var len = text.length;
        el.value = "".concat(before_1).concat(text).concat(after_1);
        el.selectionStart = selectionStart + len;
        el.selectionEnd = selectionStart + len;
    }
}
function inputSupportsSelection(input) {
    switch(input.type){
        // HTMLTextAreaElement
        case "textarea":
            return true;
        // HTMLInputElement
        // see https://html.spec.whatwg.org/multipage/input.html#do-not-apply
        case "text":
        case "search":
        case "tel":
        case "url":
        case "password":
            return true;
        default:
            return false;
    }
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","../../common/utils":"56UdR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5BVO1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlGroup", ()=>ControlGroup);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var ControlGroup = _react.forwardRef(function(props, ref) {
    var _a;
    var children = props.children, className = props.className, fill = props.fill, vertical = props.vertical, htmlProps = (0, _tslib.__rest)(props, [
        "children",
        "className",
        "fill",
        "vertical"
    ]);
    var rootClasses = (0, _classnamesDefault.default)((0, _common.Classes).CONTROL_GROUP, (_a = {}, _a[(0, _common.Classes).FILL] = fill, _a[(0, _common.Classes).VERTICAL] = vertical, _a), className);
    return _react.createElement("div", (0, _tslib.__assign)({
        role: "group"
    }, htmlProps, {
        ref: ref,
        className: rootClasses
    }), children);
});
ControlGroup.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".ControlGroup");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"33npD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "Radio", ()=>Radio);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
/**
 * Renders common control elements, with additional props to customize appearance.
 * This component is not exported and is only used within this module for `Checkbox`, `Radio`, and `Switch` below.
 */ var ControlInternal = _react.forwardRef(function(props, ref) {
    var _a;
    var alignIndicator = props.alignIndicator, children = props.children, className = props.className, indicatorChildren = props.indicatorChildren, inline = props.inline, inputRef = props.inputRef, label = props.label, labelElement = props.labelElement, large = props.large, style = props.style, type = props.type, typeClassName = props.typeClassName, _b = props.tagName, tagName = _b === void 0 ? "label" : _b, htmlProps = (0, _tslib.__rest)(props, [
        "alignIndicator",
        "children",
        "className",
        "indicatorChildren",
        "inline",
        "inputRef",
        "label",
        "labelElement",
        "large",
        "style",
        "type",
        "typeClassName",
        "tagName"
    ]);
    var classes = (0, _classnamesDefault.default)((0, _common.Classes).CONTROL, typeClassName, (_a = {}, _a[(0, _common.Classes).DISABLED] = htmlProps.disabled, _a[(0, _common.Classes).INLINE] = inline, _a[(0, _common.Classes).LARGE] = large, _a), (0, _common.Classes).alignmentClass(alignIndicator), className);
    return _react.createElement(tagName, {
        className: classes,
        style: style,
        ref: ref
    }, _react.createElement("input", (0, _tslib.__assign)({}, htmlProps, {
        ref: inputRef,
        type: type
    })), _react.createElement("span", {
        className: (0, _common.Classes).CONTROL_INDICATOR
    }, indicatorChildren), label, labelElement, children);
});
ControlInternal.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Control");
var Switch = _react.forwardRef(function(_a, ref) {
    var innerLabelChecked = _a.innerLabelChecked, innerLabel = _a.innerLabel, controlProps = (0, _tslib.__rest)(_a, [
        "innerLabelChecked",
        "innerLabel"
    ]);
    var switchLabels = innerLabel || innerLabelChecked ? [
        _react.createElement("div", {
            key: "checked",
            className: (0, _common.Classes).CONTROL_INDICATOR_CHILD
        }, _react.createElement("div", {
            className: (0, _common.Classes).SWITCH_INNER_TEXT
        }, innerLabelChecked ? innerLabelChecked : innerLabel)),
        _react.createElement("div", {
            key: "unchecked",
            className: (0, _common.Classes).CONTROL_INDICATOR_CHILD
        }, _react.createElement("div", {
            className: (0, _common.Classes).SWITCH_INNER_TEXT
        }, innerLabel))
    ] : null;
    return _react.createElement(ControlInternal, (0, _tslib.__assign)({}, controlProps, {
        indicatorChildren: switchLabels,
        ref: ref,
        type: "checkbox",
        typeClassName: (0, _common.Classes).SWITCH
    }));
});
Switch.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Switch");
var Radio = _react.forwardRef(function(props, ref) {
    return _react.createElement(ControlInternal, (0, _tslib.__assign)({}, props, {
        ref: ref,
        type: "radio",
        typeClassName: (0, _common.Classes).RADIO
    }));
});
Radio.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Radio");
var Checkbox = _react.forwardRef(function(props, ref) {
    var defaultIndeterminate = props.defaultIndeterminate, indeterminate = props.indeterminate, onChange = props.onChange, controlProps = (0, _tslib.__rest)(props, [
        "defaultIndeterminate",
        "indeterminate",
        "onChange"
    ]);
    var _a = _react.useState(indeterminate || defaultIndeterminate || false), isIndeterminate = _a[0], setIsIndeterminate = _a[1];
    var localInputRef = _react.useRef(null);
    var inputRef = (0, _common.mergeRefs)(props.inputRef, localInputRef);
    var handleChange = _react.useCallback(function(evt) {
        // update state immediately only if uncontrolled
        if (indeterminate === undefined) setIsIndeterminate(evt.target.indeterminate);
        // otherwise wait for props change. always invoke handler.
        onChange === null || onChange === void 0 || onChange(evt);
    }, [
        indeterminate,
        onChange
    ]);
    _react.useEffect(function() {
        if (indeterminate !== undefined) setIsIndeterminate(indeterminate);
    }, [
        indeterminate
    ]);
    _react.useEffect(function() {
        if (localInputRef.current != null) localInputRef.current.indeterminate = isIndeterminate;
    }, [
        localInputRef,
        isIndeterminate
    ]);
    return _react.createElement(ControlInternal, (0, _tslib.__assign)({}, controlProps, {
        inputRef: inputRef,
        onChange: handleChange,
        ref: ref,
        type: "checkbox",
        typeClassName: (0, _common.Classes).CHECKBOX
    }));
});
Checkbox.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Checkbox");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1aimB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EntityTitle", ()=>EntityTitle);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _html = require("../html/html");
var _icon = require("../icon/icon");
var _text = require("../text/text");
var EntityTitle = _react.forwardRef(function(props, ref) {
    var _a, _b, _c, _d;
    var className = props.className, _e = props.ellipsize, ellipsize = _e === void 0 ? false : _e, _f = props.fill, fill = _f === void 0 ? false : _f, _g = props.heading, heading = _g === void 0 ? (0, _text.Text) : _g, icon = props.icon, _h = props.loading, loading = _h === void 0 ? false : _h, subtitle = props.subtitle, tags = props.tags, title = props.title, titleURL = props.titleURL;
    var titleElement = _react.useMemo(function() {
        var _a;
        var maybeTitleWithURL = titleURL != null ? _react.createElement("a", {
            target: "_blank",
            href: titleURL,
            rel: "noreferrer"
        }, title) : title;
        return _react.createElement(heading, {
            className: (0, _classnamesDefault.default)((0, _common.Classes).ENTITY_TITLE_TITLE, (_a = {}, _a[(0, _common.Classes).SKELETON] = loading, _a[(0, _common.Classes).TEXT_OVERFLOW_ELLIPSIS] = heading !== (0, _text.Text) && ellipsize, _a)),
            ellipsize: heading === (0, _text.Text) ? ellipsize : undefined
        }, maybeTitleWithURL);
    }, [
        titleURL,
        title,
        heading,
        loading,
        ellipsize
    ]);
    var maybeSubtitle = _react.useMemo(function() {
        var _a;
        if (subtitle == null) return null;
        return _react.createElement((0, _text.Text), {
            className: (0, _classnamesDefault.default)((0, _common.Classes).TEXT_MUTED, (0, _common.Classes).ENTITY_TITLE_SUBTITLE, (_a = {}, _a[(0, _common.Classes).SKELETON] = loading, _a)),
            ellipsize: ellipsize
        }, subtitle);
    }, [
        ellipsize,
        loading,
        subtitle
    ]);
    return _react.createElement("div", {
        className: (0, _classnamesDefault.default)(className, (0, _common.Classes).ENTITY_TITLE, getClassNameFromHeading(heading), (_a = {}, _a[(0, _common.Classes).ENTITY_TITLE_ELLIPSIZE] = ellipsize, _a[(0, _common.Classes).FILL] = fill, _a)),
        ref: ref
    }, icon != null && _react.createElement("div", {
        className: (0, _classnamesDefault.default)((0, _common.Classes).ENTITY_TITLE_ICON_CONTAINER, (_b = {}, _b[(0, _common.Classes).ENTITY_TITLE_HAS_SUBTITLE] = maybeSubtitle != null, _b))
    }, _react.createElement((0, _icon.Icon), {
        "aria-hidden": true,
        className: (0, _classnamesDefault.default)((0, _common.Classes).TEXT_MUTED, (_c = {}, _c[(0, _common.Classes).SKELETON] = loading, _c)),
        icon: loading ? (0, _icons.IconNames).SQUARE : icon,
        tabIndex: -1
    })), _react.createElement("div", {
        className: (0, _common.Classes).ENTITY_TITLE_TEXT
    }, _react.createElement("div", {
        className: (0, _classnamesDefault.default)((0, _common.Classes).ENTITY_TITLE_TITLE_AND_TAGS, (_d = {}, _d[(0, _common.Classes).SKELETON] = loading, _d))
    }, titleElement, tags != null && _react.createElement("div", {
        className: (0, _common.Classes).ENTITY_TITLE_TAGS_CONTAINER
    }, tags)), maybeSubtitle));
});
EntityTitle.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".EntityTitle");
/**
 * Construct header class name from H{*}. Returns `undefined` if `heading` is not a Blueprint heading.
 */ function getClassNameFromHeading(heading) {
    var headerIndex = [
        (0, _html.H1),
        (0, _html.H2),
        (0, _html.H3),
        (0, _html.H4),
        (0, _html.H5),
        (0, _html.H6)
    ].findIndex(function(header) {
        return header === heading;
    });
    if (headerIndex < 0) return undefined;
    return [
        (0, _common.Classes).getClassNamespace(),
        "entity-title-heading",
        "h".concat(headerIndex + 1)
    ].join("-");
}

},{"classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../html/html":"6epty","../icon/icon":"duMtK","../text/text":"cIHFN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"562ZG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FileInput", ()=>FileInput);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var NS = (0, _common.Classes).getClassNamespace();
var FileInput = function(props) {
    var _a, _b, _c;
    var buttonText = props.buttonText, className = props.className, disabled = props.disabled, fill = props.fill, _d = props.hasSelection, hasSelection = _d === void 0 ? false : _d, _e = props.inputProps, inputProps = _e === void 0 ? {} : _e, large = props.large, onInputChange = props.onInputChange, small = props.small, _f = props.text, text = _f === void 0 ? "Choose file..." : _f, htmlProps = (0, _tslib.__rest)(props, [
        "buttonText",
        "className",
        "disabled",
        "fill",
        "hasSelection",
        "inputProps",
        "large",
        "onInputChange",
        "small",
        "text"
    ]);
    var rootClasses = (0, _classnamesDefault.default)(className, (0, _common.Classes).FILE_INPUT, (_a = {}, _a[(0, _common.Classes).FILE_INPUT_HAS_SELECTION] = hasSelection, _a[(0, _common.Classes).DISABLED] = disabled, _a[(0, _common.Classes).FILL] = fill, _a[(0, _common.Classes).LARGE] = large, _a[(0, _common.Classes).SMALL] = small, _a));
    var uploadProps = (_b = {}, _b["".concat(NS, "-button-text")] = buttonText, _b.className = (0, _classnamesDefault.default)((0, _common.Classes).FILE_UPLOAD_INPUT, (_c = {}, _c[(0, _common.Classes).FILE_UPLOAD_INPUT_CUSTOM_TEXT] = !!buttonText, _c)), _b);
    var handleInputChange = function(e) {
        var _a;
        onInputChange === null || onInputChange === void 0 || onInputChange(e);
        (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange) === null || _a === void 0 || _a.call(inputProps, e);
    };
    return _react.createElement("label", (0, _tslib.__assign)({}, htmlProps, {
        className: rootClasses
    }), _react.createElement("input", (0, _tslib.__assign)({}, inputProps, {
        onChange: handleInputChange,
        type: "file",
        disabled: disabled
    })), _react.createElement("span", (0, _tslib.__assign)({}, uploadProps), text));
};
FileInput.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".FileInput");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2vfIg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormGroup", ()=>FormGroup);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
/**
 * Form group component.
 *
 * @see https://blueprintjs.com/docs/#core/components/form-group
 */ var FormGroup = /** @class */ function(_super) {
    (0, _tslib.__extends)(FormGroup, _super);
    function FormGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroup.prototype.render = function() {
        var _a = this.props, children = _a.children, contentClassName = _a.contentClassName, helperText = _a.helperText, label = _a.label, labelFor = _a.labelFor, labelInfo = _a.labelInfo, style = _a.style, subLabel = _a.subLabel;
        return _react.createElement("div", {
            className: this.getClassName(),
            style: style
        }, label && _react.createElement("label", {
            className: (0, _common.Classes).LABEL,
            htmlFor: labelFor
        }, label, " ", _react.createElement("span", {
            className: (0, _common.Classes).TEXT_MUTED
        }, labelInfo)), subLabel && _react.createElement("div", {
            className: (0, _common.Classes).FORM_GROUP_SUB_LABEL
        }, subLabel), _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).FORM_CONTENT, contentClassName)
        }, children, helperText && _react.createElement("div", {
            className: (0, _common.Classes).FORM_HELPER_TEXT
        }, helperText)));
    };
    FormGroup.prototype.getClassName = function() {
        var _a;
        var _b = this.props, className = _b.className, disabled = _b.disabled, fill = _b.fill, inline = _b.inline, intent = _b.intent;
        return (0, _classnamesDefault.default)((0, _common.Classes).FORM_GROUP, (0, _common.Classes).intentClass(intent), (_a = {}, _a[(0, _common.Classes).DISABLED] = disabled, _a[(0, _common.Classes).FILL] = fill, _a[(0, _common.Classes).INLINE] = inline, _a), className);
    };
    FormGroup.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".FormGroup");
    return FormGroup;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a7nva":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputGroup", ()=>InputGroup);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _props = require("../../common/props");
var _icon = require("../icon/icon");
var _asyncControllableInput = require("./asyncControllableInput");
var NON_HTML_PROPS = [
    "onValueChange"
];
/**
 * Input group component.
 *
 * @see https://blueprintjs.com/docs/#core/components/input-group
 */ var InputGroup = /** @class */ function(_super) {
    (0, _tslib.__extends)(InputGroup, _super);
    function InputGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.leftElement = null;
        _this.rightElement = null;
        _this.refHandlers = {
            leftElement: function(ref) {
                return _this.leftElement = ref;
            },
            rightElement: function(ref) {
                return _this.rightElement = ref;
            }
        };
        _this.handleInputChange = function(event) {
            var _a, _b, _c, _d;
            var value = event.target.value;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, event);
            (_d = (_c = _this.props).onValueChange) === null || _d === void 0 || _d.call(_c, value, event.target);
        };
        return _this;
    }
    InputGroup.prototype.render = function() {
        var _a;
        var _b = this.props, _c = _b.asyncControl, asyncControl = _c === void 0 ? false : _c, className = _b.className, disabled = _b.disabled, fill = _b.fill, inputClassName = _b.inputClassName, inputRef = _b.inputRef, intent = _b.intent, large = _b.large, readOnly = _b.readOnly, round = _b.round, small = _b.small, _d = _b.tagName, tagName = _d === void 0 ? "div" : _d;
        var inputGroupClasses = (0, _classnamesDefault.default)((0, _common.Classes).INPUT_GROUP, (0, _common.Classes).intentClass(intent), (_a = {}, _a[(0, _common.Classes).DISABLED] = disabled, _a[(0, _common.Classes).READ_ONLY] = readOnly, _a[(0, _common.Classes).FILL] = fill, _a[(0, _common.Classes).LARGE] = large, _a[(0, _common.Classes).SMALL] = small, _a[(0, _common.Classes).ROUND] = round, _a), className);
        var style = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.props.style), {
            paddingLeft: this.state.leftElementWidth,
            paddingRight: this.state.rightElementWidth
        });
        var inputProps = (0, _tslib.__assign)((0, _tslib.__assign)({
            type: "text"
        }, (0, _props.removeNonHTMLProps)(this.props, NON_HTML_PROPS, true)), {
            "aria-disabled": disabled,
            className: (0, _classnamesDefault.default)((0, _common.Classes).INPUT, inputClassName),
            onChange: this.handleInputChange,
            style: style
        });
        var inputElement = asyncControl ? _react.createElement((0, _asyncControllableInput.AsyncControllableInput), (0, _tslib.__assign)({}, inputProps, {
            inputRef: inputRef
        })) : _react.createElement("input", (0, _tslib.__assign)({}, inputProps, {
            ref: inputRef
        }));
        return _react.createElement(tagName, {
            className: inputGroupClasses
        }, this.maybeRenderLeftElement(), inputElement, this.maybeRenderRightElement());
    };
    InputGroup.prototype.componentDidMount = function() {
        this.updateInputWidth();
    };
    InputGroup.prototype.componentDidUpdate = function(prevProps) {
        var _a = this.props, leftElement = _a.leftElement, rightElement = _a.rightElement;
        if (prevProps.leftElement !== leftElement || prevProps.rightElement !== rightElement) this.updateInputWidth();
    };
    InputGroup.prototype.validateProps = function(props) {
        if (props.leftElement != null && props.leftIcon != null) console.warn(_errors.INPUT_WARN_LEFT_ELEMENT_LEFT_ICON_MUTEX);
    };
    InputGroup.prototype.maybeRenderLeftElement = function() {
        var _a = this.props, leftElement = _a.leftElement, leftIcon = _a.leftIcon;
        if (leftElement != null) return _react.createElement("span", {
            className: (0, _common.Classes).INPUT_LEFT_CONTAINER,
            ref: this.refHandlers.leftElement
        }, leftElement);
        else if (leftIcon != null) return _react.createElement((0, _icon.Icon), {
            icon: leftIcon,
            "aria-hidden": true,
            tabIndex: -1
        });
        return undefined;
    };
    InputGroup.prototype.maybeRenderRightElement = function() {
        var rightElement = this.props.rightElement;
        if (rightElement == null) return undefined;
        return _react.createElement("span", {
            className: (0, _common.Classes).INPUT_ACTION,
            ref: this.refHandlers.rightElement
        }, rightElement);
    };
    InputGroup.prototype.updateInputWidth = function() {
        var _a = this.state, leftElementWidth = _a.leftElementWidth, rightElementWidth = _a.rightElementWidth;
        if (this.leftElement != null) {
            var clientWidth = this.leftElement.clientWidth;
            // small threshold to prevent infinite loops
            if (leftElementWidth === undefined || Math.abs(clientWidth - leftElementWidth) > 2) this.setState({
                leftElementWidth: clientWidth
            });
        } else this.setState({
            leftElementWidth: undefined
        });
        if (this.rightElement != null) {
            var clientWidth = this.rightElement.clientWidth;
            // small threshold to prevent infinite loops
            if (rightElementWidth === undefined || Math.abs(clientWidth - rightElementWidth) > 2) this.setState({
                rightElementWidth: clientWidth
            });
        } else this.setState({
            rightElementWidth: undefined
        });
    };
    InputGroup.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".InputGroup");
    return InputGroup;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/errors":"lyD8m","../../common/props":"dBcIV","../icon/icon":"duMtK","./asyncControllableInput":"dXctW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dXctW":[function(require,module,exports,__globalThis) {
/* !
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncControllableInput", ()=>AsyncControllableInput);
var _tslib = require("tslib");
var _react = require("react");
var _common = require("../../common");
/**
 * A stateful wrapper around the low-level <input> component which works around a
 * [React bug](https://github.com/facebook/react/issues/3926). This bug is reproduced when an input
 * receives CompositionEvents (for example, through IME composition) and has its value prop updated
 * asychronously. This might happen if a component chooses to do async validation of a value
 * returned by the input's `onChange` callback.
 *
 * Note: this component does not apply any Blueprint-specific styling.
 */ var AsyncControllableInput = /** @class */ function(_super) {
    (0, _tslib.__extends)(AsyncControllableInput, _super);
    function AsyncControllableInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasPendingUpdate: false,
            isComposing: false,
            nextValue: _this.props.value,
            value: _this.props.value
        };
        _this.cancelPendingCompositionEnd = null;
        _this.handleCompositionStart = function(e) {
            var _a, _b, _c;
            (_a = _this.cancelPendingCompositionEnd) === null || _a === void 0 || _a.call(_this);
            _this.setState({
                isComposing: true
            });
            (_c = (_b = _this.props).onCompositionStart) === null || _c === void 0 || _c.call(_b, e);
        };
        _this.handleCompositionEnd = function(e) {
            var _a, _b;
            // In some non-latin languages, a keystroke can end a composition event and immediately afterwards start another.
            // This can lead to unexpected characters showing up in the text input. In order to circumvent this problem, we
            // use a timeout which creates a delay which merges the two composition events, creating a more natural and predictable UX.
            // `this.state.nextValue` will become "locked" (it cannot be overwritten by the `value` prop) until a delay (10ms) has
            // passed without a new composition event starting.
            _this.cancelPendingCompositionEnd = _this.setTimeout(function() {
                return _this.setState({
                    isComposing: false
                });
            }, AsyncControllableInput.COMPOSITION_END_DELAY);
            (_b = (_a = _this.props).onCompositionEnd) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleChange = function(e) {
            var _a, _b;
            var value = e.target.value;
            _this.setState({
                nextValue: value
            });
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, e);
        };
        return _this;
    }
    AsyncControllableInput.getDerivedStateFromProps = function(nextProps, nextState) {
        if (nextState.isComposing || nextProps.value === undefined) // don't derive anything from props if:
        // - in uncontrolled mode, OR
        // - currently composing, since we'll do that after composition ends
        return null;
        var userTriggeredUpdate = nextState.nextValue !== nextState.value;
        if (userTriggeredUpdate) {
            if (nextProps.value === nextState.nextValue) {
                // parent has processed and accepted our update
                if (nextState.hasPendingUpdate) return {
                    value: nextProps.value,
                    hasPendingUpdate: false
                };
                else return {
                    value: nextState.nextValue
                };
            } else {
                if (nextProps.value === nextState.value) // we have sent the update to our parent, but it has not been processed yet. just wait.
                // DO NOT set nextValue here, since that will temporarily render a potentially stale controlled value,
                // causing the cursor to jump once the new value is accepted
                return {
                    hasPendingUpdate: true
                };
                // accept controlled update overriding user action
                return {
                    value: nextProps.value,
                    nextValue: nextProps.value,
                    hasPendingUpdate: false
                };
            }
        } else // accept controlled update, could be confirming or denying user action
        return {
            value: nextProps.value,
            nextValue: nextProps.value,
            hasPendingUpdate: false
        };
    };
    AsyncControllableInput.prototype.render = function() {
        var _a = this.state, isComposing = _a.isComposing, hasPendingUpdate = _a.hasPendingUpdate, value = _a.value, nextValue = _a.nextValue;
        var _b = this.props, inputRef = _b.inputRef, restProps = (0, _tslib.__rest)(_b, [
            "inputRef"
        ]);
        return _react.createElement("input", (0, _tslib.__assign)({}, restProps, {
            ref: inputRef,
            // render the pending value even if it is not confirmed by a parent's async controlled update
            // so that the cursor does not jump to the end of input as reported in
            // https://github.com/palantir/blueprint/issues/4298
            value: isComposing || hasPendingUpdate ? nextValue : value,
            onCompositionStart: this.handleCompositionStart,
            onCompositionEnd: this.handleCompositionEnd,
            onChange: this.handleChange
        }));
    };
    AsyncControllableInput.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".AsyncControllableInput");
    /**
     * The amount of time (in milliseconds) which the input will wait after a compositionEnd event before
     * unlocking its state value for external updates via props. See `handleCompositionEnd` for more details.
     */ AsyncControllableInput.COMPOSITION_END_DELAY = 10;
    return AsyncControllableInput;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","react":"9njXz","../../common":"3QDnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"js8Bo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumericInput", ()=>NumericInput);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _buttonGroup = require("../button/buttonGroup");
var _buttons = require("../button/buttons");
var _controlGroup = require("./controlGroup");
var _inputGroup = require("./inputGroup");
var _numericInputUtils = require("./numericInputUtils");
var IncrementDirection;
(function(IncrementDirection) {
    IncrementDirection[IncrementDirection["DOWN"] = -1] = "DOWN";
    IncrementDirection[IncrementDirection["UP"] = 1] = "UP";
})(IncrementDirection || (IncrementDirection = {}));
var NON_HTML_PROPS = [
    "allowNumericCharactersOnly",
    "buttonPosition",
    "clampValueOnBlur",
    "className",
    "defaultValue",
    "majorStepSize",
    "minorStepSize",
    "onButtonClick",
    "onValueChange",
    "selectAllOnFocus",
    "selectAllOnIncrement",
    "stepSize"
];
/**
 * Numeric input component.
 *
 * @see https://blueprintjs.com/docs/#core/components/numeric-input
 */ var NumericInput = /** @class */ function(_super) {
    (0, _tslib.__extends)(NumericInput, _super);
    function NumericInput() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.numericInputId = (0, _common.Utils).uniqueId("numericInput");
        _this.state = {
            currentImeInputInvalid: false,
            shouldSelectAfterUpdate: false,
            stepMaxPrecision: NumericInput.getStepMaxPrecision(_this.props),
            value: (0, _numericInputUtils.getValueOrEmptyValue)((_a = _this.props.value) !== null && _a !== void 0 ? _a : _this.props.defaultValue)
        };
        // updating these flags need not trigger re-renders, so don't include them in this.state.
        _this.didPasteEventJustOccur = false;
        _this.delta = 0;
        _this.inputElement = null;
        _this.inputRef = (0, _common.refHandler)(_this, "inputElement", _this.props.inputRef);
        _this.incrementButtonHandlers = _this.getButtonEventHandlers(IncrementDirection.UP);
        _this.decrementButtonHandlers = _this.getButtonEventHandlers(IncrementDirection.DOWN);
        _this.getCurrentValueAsNumber = function() {
            return Number((0, _numericInputUtils.parseStringToStringNumber)(_this.state.value, _this.props.locale));
        };
        _this.handleButtonClick = function(e, direction) {
            var _a, _b;
            var delta = _this.updateDelta(direction, e);
            var nextValue = _this.incrementValue(delta);
            (_b = (_a = _this.props).onButtonClick) === null || _b === void 0 || _b.call(_a, Number((0, _numericInputUtils.parseStringToStringNumber)(nextValue, _this.props.locale)), nextValue);
        };
        _this.stopContinuousChange = function() {
            _this.delta = 0;
            _this.clearTimeouts();
            clearInterval(_this.intervalId);
            document.removeEventListener("mouseup", _this.stopContinuousChange);
        };
        _this.handleContinuousChange = function() {
            var _a, _b, _c, _d;
            // If either min or max prop is set, when reaching the limit
            // the button will be disabled and stopContinuousChange will be never fired,
            // hence the need to check on each iteration to properly clear the timeout
            if (_this.props.min !== undefined || _this.props.max !== undefined) {
                var min = (_a = _this.props.min) !== null && _a !== void 0 ? _a : -Infinity;
                var max = (_b = _this.props.max) !== null && _b !== void 0 ? _b : Infinity;
                var valueAsNumber = _this.getCurrentValueAsNumber();
                if (valueAsNumber <= min || valueAsNumber >= max) {
                    _this.stopContinuousChange();
                    return;
                }
            }
            var nextValue = _this.incrementValue(_this.delta);
            (_d = (_c = _this.props).onButtonClick) === null || _d === void 0 || _d.call(_c, Number((0, _numericInputUtils.parseStringToStringNumber)(nextValue, _this.props.locale)), nextValue);
        };
        // Callbacks - Input
        // =================
        _this.handleInputFocus = function(e) {
            var _a, _b;
            // update this state flag to trigger update for input selection (see componentDidUpdate)
            _this.setState({
                shouldSelectAfterUpdate: _this.props.selectAllOnFocus
            });
            (_b = (_a = _this.props).onFocus) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleInputBlur = function(e) {
            var _a, _b;
            // always disable this flag on blur so it's ready for next time.
            _this.setState({
                shouldSelectAfterUpdate: false
            });
            if (_this.props.clampValueOnBlur) {
                var value = e.target.value;
                _this.handleNextValue(_this.roundAndClampValue(value));
            }
            (_b = (_a = _this.props).onBlur) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleInputKeyDown = function(e) {
            var _a, _b;
            if (_this.props.disabled || _this.props.readOnly) return;
            var direction = (0, _common.Utils).getArrowKeyDirection(e, [
                "ArrowDown"
            ], [
                "ArrowUp"
            ]);
            if (direction !== undefined) {
                // when the input field has focus, some key combinations will modify
                // the field's selection range. we'll actually want to select all
                // text in the field after we modify the value on the following
                // lines. preventing the default selection behavior lets us do that
                // without interference.
                e.preventDefault();
                var delta = _this.updateDelta(direction, e);
                _this.incrementValue(delta);
            }
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleCompositionEnd = function(e) {
            if (_this.props.allowNumericCharactersOnly) {
                _this.handleNextValue((0, _numericInputUtils.sanitizeNumericInput)(e.data, _this.props.locale));
                _this.setState({
                    currentImeInputInvalid: false
                });
            }
        };
        _this.handleCompositionUpdate = function(e) {
            if (_this.props.allowNumericCharactersOnly) {
                var data = e.data;
                var sanitizedValue = (0, _numericInputUtils.sanitizeNumericInput)(data, _this.props.locale);
                if (sanitizedValue.length === 0 && data.length > 0) _this.setState({
                    currentImeInputInvalid: true
                });
                else _this.setState({
                    currentImeInputInvalid: false
                });
            }
        };
        _this.handleInputKeyPress = function(e) {
            var _a, _b;
            // we prohibit keystrokes in onKeyPress instead of onKeyDown, because
            // e.key is not trustworthy in onKeyDown in all browsers.
            if (_this.props.allowNumericCharactersOnly && !(0, _numericInputUtils.isValidNumericKeyboardEvent)(e, _this.props.locale)) e.preventDefault();
            // eslint-disable-next-line deprecation/deprecation
            (_b = (_a = _this.props).onKeyPress) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleInputPaste = function(e) {
            var _a, _b;
            _this.didPasteEventJustOccur = true;
            (_b = (_a = _this.props).onPaste) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleInputChange = function(value) {
            var nextValue = value;
            if (_this.props.allowNumericCharactersOnly && _this.didPasteEventJustOccur) {
                _this.didPasteEventJustOccur = false;
                nextValue = (0, _numericInputUtils.sanitizeNumericInput)(value, _this.props.locale);
            }
            _this.handleNextValue(nextValue);
            _this.setState({
                shouldSelectAfterUpdate: false
            });
        };
        return _this;
    }
    NumericInput.getDerivedStateFromProps = function(props, state) {
        var _a, _b;
        var nextState = {
            prevMaxProp: props.max,
            prevMinProp: props.min
        };
        var didMinChange = props.min !== state.prevMinProp;
        var didMaxChange = props.max !== state.prevMaxProp;
        var didBoundsChange = didMinChange || didMaxChange;
        // in controlled mode, use props.value
        // in uncontrolled mode, if state.value has not been assigned yet (upon initial mount), use props.defaultValue
        var value = (_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : state.value;
        var stepMaxPrecision = NumericInput.getStepMaxPrecision(props);
        var sanitizedValue = value !== NumericInput.VALUE_EMPTY ? NumericInput.roundAndClampValue(value, stepMaxPrecision, props.min, props.max, 0, props.locale) : NumericInput.VALUE_EMPTY;
        // if a new min and max were provided that cause the existing value to fall
        // outside of the new bounds, then clamp the value to the new valid range.
        if (didBoundsChange && sanitizedValue !== state.value) return (0, _tslib.__assign)((0, _tslib.__assign)({}, nextState), {
            stepMaxPrecision: stepMaxPrecision,
            value: sanitizedValue
        });
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, nextState), {
            stepMaxPrecision: stepMaxPrecision,
            value: value
        });
    };
    // Value Helpers
    // =============
    NumericInput.getStepMaxPrecision = function(props) {
        if (props.minorStepSize != null) return (0, _common.Utils).countDecimalPlaces(props.minorStepSize);
        else return (0, _common.Utils).countDecimalPlaces(props.stepSize);
    };
    NumericInput.roundAndClampValue = function(value, stepMaxPrecision, min, max, delta, locale) {
        if (delta === void 0) delta = 0;
        if (!(0, _numericInputUtils.isValueNumeric)(value, locale)) return NumericInput.VALUE_EMPTY;
        var currentValue = (0, _numericInputUtils.parseStringToStringNumber)(value, locale);
        var nextValue = (0, _numericInputUtils.toMaxPrecision)(Number(currentValue) + delta, stepMaxPrecision);
        var clampedValue = (0, _numericInputUtils.clampValue)(nextValue, min, max);
        return (0, _numericInputUtils.toLocaleString)(clampedValue, locale);
    };
    NumericInput.prototype.render = function() {
        var _a;
        var _b = this.props, buttonPosition = _b.buttonPosition, className = _b.className, fill = _b.fill, large = _b.large, small = _b.small;
        var containerClasses = (0, _classnamesDefault.default)((0, _common.Classes).NUMERIC_INPUT, (_a = {}, _a[(0, _common.Classes).LARGE] = large, _a[(0, _common.Classes).SMALL] = small, _a), className);
        var buttons = this.renderButtons();
        return _react.createElement((0, _controlGroup.ControlGroup), {
            className: containerClasses,
            fill: fill
        }, buttonPosition === (0, _common.Position).LEFT && buttons, this.renderInput(), buttonPosition === (0, _common.Position).RIGHT && buttons);
    };
    NumericInput.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b, _c;
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        if (prevProps.inputRef !== this.props.inputRef) {
            (0, _common.setRef)(prevProps.inputRef, null);
            this.inputRef = (0, _common.refHandler)(this, "inputElement", this.props.inputRef);
            (0, _common.setRef)(this.props.inputRef, this.inputElement);
        }
        if (this.state.shouldSelectAfterUpdate) (_a = this.inputElement) === null || _a === void 0 || _a.setSelectionRange(0, this.state.value.length);
        var didMinChange = this.props.min !== prevProps.min;
        var didMaxChange = this.props.max !== prevProps.max;
        var didBoundsChange = didMinChange || didMaxChange;
        var didLocaleChange = this.props.locale !== prevProps.locale;
        var didValueChange = this.state.value !== prevState.value;
        if (didBoundsChange && didValueChange || didLocaleChange && prevState.value !== NumericInput.VALUE_EMPTY) {
            // we clamped the value due to a bounds change, so we should fire the change callback
            var valueToParse = didLocaleChange ? prevState.value : this.state.value;
            var valueAsString = (0, _numericInputUtils.parseStringToStringNumber)(valueToParse, prevProps.locale);
            var localizedValue = (0, _numericInputUtils.toLocaleString)(+valueAsString, this.props.locale);
            (_c = (_b = this.props).onValueChange) === null || _c === void 0 || _c.call(_b, +valueAsString, localizedValue, this.inputElement);
        }
    };
    NumericInput.prototype.validateProps = function(nextProps) {
        var majorStepSize = nextProps.majorStepSize, max = nextProps.max, min = nextProps.min, minorStepSize = nextProps.minorStepSize, stepSize = nextProps.stepSize, value = nextProps.value;
        if (min != null && max != null && min > max) console.error(_errors.NUMERIC_INPUT_MIN_MAX);
        if (stepSize <= 0) console.error(_errors.NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE);
        if (minorStepSize && minorStepSize <= 0) console.error(_errors.NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE);
        if (majorStepSize && majorStepSize <= 0) console.error(_errors.NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE);
        if (minorStepSize && minorStepSize > stepSize) console.error(_errors.NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND);
        if (majorStepSize && majorStepSize < stepSize) console.error(_errors.NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND);
        // controlled mode
        if (value != null) {
            var stepMaxPrecision = NumericInput.getStepMaxPrecision(nextProps);
            var sanitizedValue = NumericInput.roundAndClampValue(value.toString(), stepMaxPrecision, min, max, 0, this.props.locale);
            var valueDoesNotMatch = sanitizedValue !== value.toString();
            var localizedValue = (0, _numericInputUtils.toLocaleString)(Number((0, _numericInputUtils.parseStringToStringNumber)(value, this.props.locale)), this.props.locale);
            var isNotLocalized = sanitizedValue !== localizedValue;
            if (valueDoesNotMatch && isNotLocalized) console.warn(_errors.NUMERIC_INPUT_CONTROLLED_VALUE_INVALID);
        }
    };
    // Render Helpers
    // ==============
    NumericInput.prototype.renderButtons = function() {
        var _a = this.props, intent = _a.intent, max = _a.max, min = _a.min, locale = _a.locale;
        var value = (0, _numericInputUtils.parseStringToStringNumber)(this.state.value, locale);
        var disabled = this.props.disabled || this.props.readOnly;
        var isIncrementDisabled = max !== undefined && value !== "" && +value >= max;
        var isDecrementDisabled = min !== undefined && value !== "" && +value <= min;
        return _react.createElement((0, _buttonGroup.ButtonGroup), {
            className: (0, _common.Classes).FIXED,
            key: "button-group",
            vertical: true
        }, _react.createElement((0, _buttons.Button), (0, _tslib.__assign)({
            "aria-label": "increment",
            "aria-controls": this.numericInputId,
            disabled: disabled || isIncrementDisabled,
            icon: _react.createElement((0, _icons.ChevronUp), null),
            intent: intent
        }, this.incrementButtonHandlers)), _react.createElement((0, _buttons.Button), (0, _tslib.__assign)({
            "aria-label": "decrement",
            "aria-controls": this.numericInputId,
            disabled: disabled || isDecrementDisabled,
            icon: _react.createElement((0, _icons.ChevronDown), null),
            intent: intent
        }, this.decrementButtonHandlers)));
    };
    NumericInput.prototype.renderInput = function() {
        var inputGroupHtmlProps = (0, _common.removeNonHTMLProps)(this.props, NON_HTML_PROPS, true);
        var valueAsNumber = this.getCurrentValueAsNumber();
        return _react.createElement((0, _inputGroup.InputGroup), (0, _tslib.__assign)({
            asyncControl: this.props.asyncControl,
            autoComplete: "off",
            id: this.numericInputId,
            role: this.props.allowNumericCharactersOnly ? "spinbutton" : undefined
        }, inputGroupHtmlProps, {
            "aria-valuemax": this.props.max,
            "aria-valuemin": this.props.min,
            "aria-valuenow": valueAsNumber,
            intent: this.state.currentImeInputInvalid ? (0, _common.Intent).DANGER : this.props.intent,
            inputClassName: this.props.inputClassName,
            inputRef: this.inputRef,
            large: this.props.large,
            leftElement: this.props.leftElement,
            leftIcon: this.props.leftIcon,
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            onCompositionEnd: this.handleCompositionEnd,
            onCompositionUpdate: this.handleCompositionUpdate,
            onKeyDown: this.handleInputKeyDown,
            onKeyPress: this.handleInputKeyPress,
            onPaste: this.handleInputPaste,
            onValueChange: this.handleInputChange,
            rightElement: this.props.rightElement,
            small: this.props.small,
            value: this.state.value
        }));
    };
    // Callbacks - Buttons
    // ===================
    NumericInput.prototype.getButtonEventHandlers = function(direction) {
        var _this = this;
        return {
            // keydown is fired repeatedly when held so it's implicitly continuous
            onKeyDown: function(evt) {
                if (!_this.props.disabled && (0, _common.Utils).isKeyboardClick(evt)) _this.handleButtonClick(evt, direction);
            },
            onMouseDown: function(evt) {
                if (!_this.props.disabled) {
                    _this.handleButtonClick(evt, direction);
                    _this.startContinuousChange();
                }
            }
        };
    };
    NumericInput.prototype.startContinuousChange = function() {
        var _this = this;
        // The button's onMouseUp event handler doesn't fire if the user
        // releases outside of the button, so we need to watch all the way
        // from the top.
        document.addEventListener("mouseup", this.stopContinuousChange);
        // Initial delay is slightly longer to prevent the user from
        // accidentally triggering the continuous increment/decrement.
        this.setTimeout(function() {
            _this.intervalId = window.setInterval(_this.handleContinuousChange, NumericInput.CONTINUOUS_CHANGE_INTERVAL);
        }, NumericInput.CONTINUOUS_CHANGE_DELAY);
    };
    // Data logic
    // ==========
    NumericInput.prototype.handleNextValue = function(valueAsString) {
        var _a, _b;
        if (this.props.value == null) this.setState({
            value: valueAsString
        });
        (_b = (_a = this.props).onValueChange) === null || _b === void 0 || _b.call(_a, Number((0, _numericInputUtils.parseStringToStringNumber)(valueAsString, this.props.locale)), valueAsString, this.inputElement);
    };
    NumericInput.prototype.incrementValue = function(delta) {
        // pretend we're incrementing from 0 if currValue is empty
        var currValue = this.state.value === NumericInput.VALUE_EMPTY ? NumericInput.VALUE_ZERO : this.state.value;
        var nextValue = this.roundAndClampValue(currValue, delta);
        if (nextValue !== this.state.value) {
            this.handleNextValue(nextValue);
            this.setState({
                shouldSelectAfterUpdate: this.props.selectAllOnIncrement
            });
        }
        // return value used in continuous change updates
        return nextValue;
    };
    NumericInput.prototype.getIncrementDelta = function(direction, isShiftKeyPressed, isAltKeyPressed) {
        var _a = this.props, majorStepSize = _a.majorStepSize, minorStepSize = _a.minorStepSize, stepSize = _a.stepSize;
        if (isShiftKeyPressed && majorStepSize != null) return direction * majorStepSize;
        else if (isAltKeyPressed && minorStepSize != null) return direction * minorStepSize;
        else return direction * stepSize;
    };
    NumericInput.prototype.roundAndClampValue = function(value, delta) {
        if (delta === void 0) delta = 0;
        return NumericInput.roundAndClampValue(value, this.state.stepMaxPrecision, this.props.min, this.props.max, delta, this.props.locale);
    };
    NumericInput.prototype.updateDelta = function(direction, e) {
        this.delta = this.getIncrementDelta(direction, e.shiftKey, e.altKey);
        return this.delta;
    };
    NumericInput.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".NumericInput");
    NumericInput.VALUE_EMPTY = "";
    NumericInput.VALUE_ZERO = "0";
    NumericInput.defaultProps = {
        allowNumericCharactersOnly: true,
        buttonPosition: (0, _common.Position).RIGHT,
        clampValueOnBlur: false,
        defaultValue: NumericInput.VALUE_EMPTY,
        large: false,
        majorStepSize: 10,
        minorStepSize: 0.1,
        selectAllOnFocus: false,
        selectAllOnIncrement: false,
        small: false,
        stepSize: 1
    };
    NumericInput.CONTINUOUS_CHANGE_DELAY = 300;
    NumericInput.CONTINUOUS_CHANGE_INTERVAL = 100;
    return NumericInput;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../../common/errors":"lyD8m","../button/buttonGroup":"kDaEn","../button/buttons":"glm43","./controlGroup":"5BVO1","./inputGroup":"a7nva","./numericInputUtils":"fUvQP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fUvQP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toLocaleString", ()=>toLocaleString);
parcelHelpers.export(exports, "clampValue", ()=>clampValue);
parcelHelpers.export(exports, "getValueOrEmptyValue", ()=>getValueOrEmptyValue);
/** Transforms the localized number (ex. "10,99") to a javascript recognizable string number (ex. "10.99")  */ parcelHelpers.export(exports, "parseStringToStringNumber", ()=>parseStringToStringNumber);
/** Returns `true` if the string represents a valid numeric value, like "1e6". */ parcelHelpers.export(exports, "isValueNumeric", ()=>isValueNumeric);
parcelHelpers.export(exports, "isValidNumericKeyboardEvent", ()=>isValidNumericKeyboardEvent);
/**
 * Round the value to have _up to_ the specified maximum precision.
 *
 * This differs from `toFixed(5)` in that trailing zeroes are not added on
 * more precise values, resulting in shorter strings.
 */ parcelHelpers.export(exports, "toMaxPrecision", ()=>toMaxPrecision);
/**
 * Convert full-width (Japanese) numbers to ASCII, and strip all characters that are not valid floating-point numeric characters
 */ parcelHelpers.export(exports, "sanitizeNumericInput", ()=>sanitizeNumericInput);
var _utils = require("../../common/utils");
/** Returns the `decimal` number separator based on locale */ function getDecimalSeparator(locale) {
    var testNumber = 1.9;
    var testText = testNumber.toLocaleString(locale);
    var one = 1..toLocaleString(locale);
    var nine = 9..toLocaleString(locale);
    var pattern = "".concat(one, "(.+)").concat(nine);
    var result = new RegExp(pattern).exec(testText);
    return result && result[1] || ".";
}
function toLocaleString(num, locale) {
    if (locale === void 0) locale = "en-US";
    // HACKHACK: roundingPriority is not supported yet in TypeScript https://github.com/microsoft/TypeScript/issues/43336
    return sanitizeNumericInput(num.toLocaleString(locale, {
        roundingPriority: "morePrecision"
    }), locale);
}
function clampValue(value, min, max) {
    // defaultProps won't work if the user passes in null, so just default
    // to +/- infinity here instead, as a catch-all.
    var adjustedMin = min != null ? min : -Infinity;
    var adjustedMax = max != null ? max : Infinity;
    return (0, _utils.clamp)(value, adjustedMin, adjustedMax);
}
function getValueOrEmptyValue(value) {
    if (value === void 0) value = "";
    return value.toString();
}
/** Transform the localized character (ex. "") to a javascript recognizable string number (ex. "10.99")  */ function transformLocalizedNumberToStringNumber(character, locale) {
    var charactersMap = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].map(function(value) {
        return value.toLocaleString(locale);
    });
    var jsNumber = charactersMap.indexOf(character);
    if (jsNumber !== -1) return jsNumber;
    else return character;
}
function parseStringToStringNumber(value, locale) {
    var valueAsString = "" + value;
    if (parseFloat(valueAsString).toString() === value.toString()) return value.toString();
    if (locale !== undefined) {
        var decimalSeparator = getDecimalSeparator(locale);
        var sanitizedString = sanitizeNumericInput(valueAsString, locale);
        return sanitizedString.split("").map(function(character) {
            return transformLocalizedNumberToStringNumber(character, locale);
        }).join("").replace(decimalSeparator, ".");
    }
    return value.toString();
}
function isValueNumeric(value, locale) {
    // checking if a string is numeric in Typescript is a big pain, because
    // we can't simply toss a string parameter to isFinite. below is the
    // essential approach that jQuery uses, which involves subtracting a
    // parsed numeric value from the string representation of the value. we
    // need to cast the value to the `any` type to allow this operation
    // between dissimilar types.
    var stringToStringNumber = parseStringToStringNumber(value, locale);
    return value != null && stringToStringNumber - parseFloat(stringToStringNumber) + 1 >= 0;
}
function isValidNumericKeyboardEvent(e, locale) {
    // unit tests may not include e.key. don't bother disabling those events.
    if (e.key == null) return true;
    // allow modified key strokes that may involve letters and other
    // non-numeric/invalid characters (Cmd + A, Cmd + C, Cmd + V, Cmd + X).
    if (e.ctrlKey || e.altKey || e.metaKey) return true;
    // keys that print a single character when pressed have a `key` name of
    // length 1. every other key has a longer `key` name (e.g. "Backspace",
    // "ArrowUp", "Shift"). since none of those keys can print a character
    // to the field--and since they may have important native behaviors
    // beyond printing a character--we don't want to disable their effects.
    var isSingleCharKey = e.key.length === 1;
    if (!isSingleCharKey) return true;
    // now we can simply check that the single character that wants to be printed
    // is a floating-point number character that we're allowed to print.
    return isFloatingPointNumericCharacter(e.key, locale);
}
/**
 * A regex that matches a string of length 1 (i.e. a standalone character)
 * if and only if it is a floating-point number character as defined by W3C:
 * https://www.w3.org/TR/2012/WD-html-markup-20120329/datatypes.html#common.data.float
 *
 * Floating-point number characters are the only characters that can be
 * printed within a default input[type="number"]. This component should
 * behave the same way when this.props.allowNumericCharactersOnly = true.
 * See here for the input[type="number"].value spec:
 * https://www.w3.org/TR/2012/WD-html-markup-20120329/input.number.html#input.number.attrs.value
 */ function isFloatingPointNumericCharacter(character, locale) {
    if (locale !== undefined) {
        var decimalSeparator = getDecimalSeparator(locale).replace(".", "\\.");
        var numbers = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].map(function(value) {
            return value.toLocaleString(locale);
        }).join("");
        var localeFloatingPointNumericCharacterRegex = new RegExp("^[Ee" + numbers + "\\+\\-" + decimalSeparator + "]$");
        return localeFloatingPointNumericCharacterRegex.test(character);
    } else {
        var floatingPointNumericCharacterRegex = /^[Ee0-9\+\-\.]$/;
        return floatingPointNumericCharacterRegex.test(character);
    }
}
function toMaxPrecision(value, maxPrecision) {
    // round the value to have the specified maximum precision (toFixed is the wrong choice,
    // because it would show trailing zeros in the decimal part out to the specified precision)
    // source: http://stackoverflow.com/a/18358056/5199574
    var scaleFactor = Math.pow(10, maxPrecision);
    return Math.round(value * scaleFactor) / scaleFactor;
}
/**
 * Convert Japanese full-width numbers, e.g. '５', to ASCII, e.g. '5'
 * This should be called before performing any other numeric string input validation.
 */ function convertFullWidthNumbersToAscii(value) {
    return value.replace(/[\uFF10-\uFF19]/g, function(m) {
        return String.fromCharCode(m.charCodeAt(0) - 0xfee0);
    });
}
function sanitizeNumericInput(value, locale) {
    var valueChars = convertFullWidthNumbersToAscii(value).split("");
    var sanitizedValueChars = valueChars.filter(function(valueChar) {
        return isFloatingPointNumericCharacter(valueChar, locale);
    });
    return sanitizedValueChars.join("");
}

},{"../../common/utils":"56UdR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ZFes":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroup", ()=>RadioGroup);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _utils = require("../../common/utils");
var _radioCard = require("../control-card/radioCard");
var _controls = require("./controls");
var counter = 0;
function nextName() {
    return "".concat(RadioGroup.displayName, "-").concat(counter++);
}
/**
 * Radio group component.
 *
 * @see https://blueprintjs.com/docs/#core/components/radio.radiogroup
 */ var RadioGroup = /** @class */ function(_super) {
    (0, _tslib.__extends)(RadioGroup, _super);
    function RadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // a unique name for this group, which can be overridden by `name` prop.
        _this.autoGroupName = nextName();
        return _this;
    }
    RadioGroup.prototype.render = function() {
        var _a = this.props, disabled = _a.disabled, label = _a.label, options = _a.options, className = _a.className, children = _a.children, name = _a.name, onChange = _a.onChange, htmlProps = (0, _tslib.__rest)(_a, [
            "disabled",
            "label",
            "options",
            "className",
            "children",
            "name",
            "onChange"
        ]);
        var labelId = (0, _utils.uniqueId)("label");
        return _react.createElement("div", (0, _tslib.__assign)({
            role: "radiogroup",
            "aria-labelledby": label ? labelId : undefined
        }, (0, _common.removeNonHTMLProps)(htmlProps), {
            className: (0, _classnamesDefault.default)((0, _common.Classes).RADIO_GROUP, className)
        }), label && _react.createElement("label", {
            className: (0, _common.Classes).LABEL,
            id: labelId
        }, label), Array.isArray(options) ? this.renderOptions() : this.renderChildren());
    };
    RadioGroup.prototype.validateProps = function() {
        if (this.props.children != null && this.props.options != null) console.warn(_errors.RADIOGROUP_WARN_CHILDREN_OPTIONS_MUTEX);
    };
    RadioGroup.prototype.renderChildren = function() {
        var _this = this;
        return _react.Children.map(this.props.children, function(child) {
            if ((0, _utils.isElementOfType)(child, (0, _controls.Radio)) || (0, _utils.isElementOfType)(child, (0, _radioCard.RadioCard))) return _react.cloneElement(// Need this cast here to suppress a TS error caused by differing `ref` types for the Radio and
            // RadioCard components. We aren't injecting a ref, so we don't need to be strict about that
            // incompatibility.
            child, _this.getRadioProps(child.props));
            else return child;
        });
    };
    RadioGroup.prototype.renderOptions = function() {
        var _this = this;
        var _a;
        return (_a = this.props.options) === null || _a === void 0 ? void 0 : _a.map(function(option) {
            return _react.createElement((0, _controls.Radio), (0, _tslib.__assign)({}, _this.getRadioProps(option), {
                key: option.value,
                labelElement: option.label || option.value
            }));
        });
    };
    RadioGroup.prototype.getRadioProps = function(optionProps) {
        var name = this.props.name;
        var className = optionProps.className, disabled = optionProps.disabled, value = optionProps.value;
        return {
            checked: value === this.props.selectedValue,
            className: className,
            disabled: disabled || this.props.disabled,
            inline: this.props.inline,
            name: name == null ? this.autoGroupName : name,
            onChange: this.props.onChange,
            value: value
        };
    };
    RadioGroup.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".RadioGroup");
    return RadioGroup;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/errors":"lyD8m","../../common/utils":"56UdR","../control-card/radioCard":"fCpjP","./controls":"33npD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fCpjP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioCard", ()=>RadioCard);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _controlCard = require("./controlCard");
var RadioCard = _react.forwardRef(function(props, ref) {
    var className = (0, _classnamesDefault.default)(props.className, (0, _common.Classes).RADIO_CONTROL_CARD);
    return _react.createElement((0, _controlCard.ControlCard), (0, _tslib.__assign)({}, props, {
        className: className,
        controlKind: "radio",
        ref: ref
    }));
});
RadioCard.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".RadioCard");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","./controlCard":"eNg31","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNg31":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlCard", ()=>ControlCard);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _card = require("../card/card");
var _controls = require("../forms/controls");
var _useCheckedControl = require("./useCheckedControl");
var ControlCard = _react.forwardRef(function(props, ref) {
    var _a;
    var alignIndicator = props.alignIndicator, _checked = props.checked, children = props.children, className = props.className, controlKind = props.controlKind, _defaultChecked = props.defaultChecked, disabled = props.disabled, inputProps = props.inputProps, inputRef = props.inputRef, label = props.label, _onChange = props.onChange, showAsSelectedWhenChecked = props.showAsSelectedWhenChecked, value = props.value, cardProps = (0, _tslib.__rest)(props, [
        "alignIndicator",
        "checked",
        "children",
        "className",
        "controlKind",
        "defaultChecked",
        "disabled",
        "inputProps",
        "inputRef",
        "label",
        "onChange",
        "showAsSelectedWhenChecked",
        "value"
    ]);
    var _b = (0, _useCheckedControl.useCheckedControl)(props), checked = _b.checked, onChange = _b.onChange;
    // use a container element to achieve a good flex layout
    var labelElement = _react.createElement("div", {
        className: (0, _common.Classes).CONTROL_CARD_LABEL
    }, children !== null && children !== void 0 ? children : label);
    var controlProps = (0, _tslib.__assign)({
        alignIndicator: alignIndicator,
        checked: checked,
        disabled: disabled,
        inline: true,
        inputRef: inputRef,
        labelElement: labelElement,
        onChange: onChange,
        value: value
    }, inputProps);
    var classes = (0, _classnamesDefault.default)((0, _common.Classes).CONTROL_CARD, className, (_a = {}, _a[(0, _common.Classes).SELECTED] = showAsSelectedWhenChecked && checked, _a));
    return _react.createElement((0, _card.Card), (0, _tslib.__assign)({
        interactive: !disabled,
        className: classes,
        ref: ref
    }, cardProps), controlKind === "switch" ? _react.createElement((0, _controls.Switch), (0, _tslib.__assign)({}, controlProps)) : controlKind === "checkbox" ? _react.createElement((0, _controls.Checkbox), (0, _tslib.__assign)({}, controlProps)) : controlKind === "radio" ? _react.createElement((0, _controls.Radio), (0, _tslib.__assign)({}, controlProps)) : labelElement);
});
ControlCard.defaultProps = {
    alignIndicator: "right",
    showAsSelectedWhenChecked: true
};
ControlCard.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".ControlCard");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","../card/card":"3tOjJ","../forms/controls":"33npD","./useCheckedControl":"fOtOR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fOtOR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Keep track of a control's checked state in both controlled and uncontrolled modes
 */ parcelHelpers.export(exports, "useCheckedControl", ()=>useCheckedControl);
var _react = require("react");
function useCheckedControl(props) {
    var _a;
    var _b = _react.useState(function() {
        var _a;
        return (_a = props.defaultChecked) !== null && _a !== void 0 ? _a : false;
    }), checkedStateForUncontrolledMode = _b[0], setChecked = _b[1];
    // If the checked prop is passed, this input is in "controlled mode" and
    // should always reflect the value of the controlled prop. Any internal
    // state tracked for "uncontrolled mode" should be ignored.
    var checked = (_a = props.checked) !== null && _a !== void 0 ? _a : checkedStateForUncontrolledMode;
    var onChange = _react.useCallback(function(e) {
        var _a;
        setChecked(function(c) {
            return !c;
        });
        (_a = props.onChange) === null || _a === void 0 || _a.call(props, e);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.onChange
    ]);
    return {
        checked: checked,
        onChange: onChange
    };
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ipx5z":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextArea", ()=>TextArea);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _asyncControllableTextArea = require("./asyncControllableTextArea");
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */ /**
 * Text area component.
 *
 * @see https://blueprintjs.com/docs/#core/components/text-area
 */ var TextArea = /** @class */ function(_super) {
    (0, _tslib.__extends)(TextArea, _super);
    function TextArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        // used to measure and set the height of the component on first mount
        _this.textareaElement = null;
        _this.handleRef = (0, _common.refHandler)(_this, "textareaElement", _this.props.inputRef);
        _this.maybeSyncHeightToScrollHeight = function() {
            // eslint-disable-next-line deprecation/deprecation
            var _a = _this.props, autoResize = _a.autoResize, growVertically = _a.growVertically;
            if (_this.textareaElement != null) {
                var scrollHeight = _this.textareaElement.scrollHeight;
                if (autoResize) {
                    // set height to 0 to force scrollHeight to be the minimum height to fit
                    // the content of the textarea
                    _this.textareaElement.style.height = "0px";
                    _this.textareaElement.style.height = scrollHeight.toString() + "px";
                    _this.setState({
                        height: scrollHeight
                    });
                } else if (growVertically && scrollHeight > 0) // N.B. this code path will be deleted in Blueprint v6.0 when `growVertically` is removed
                _this.setState({
                    height: scrollHeight
                });
            }
            if (_this.props.autoResize && _this.textareaElement != null) {
                // set height to 0 to force scrollHeight to be the minimum height to fit
                // the content of the textarea
                _this.textareaElement.style.height = "0px";
                var scrollHeight = _this.textareaElement.scrollHeight;
                _this.textareaElement.style.height = scrollHeight.toString() + "px";
                _this.setState({
                    height: scrollHeight
                });
            }
        };
        _this.handleChange = function(e) {
            var _a, _b;
            _this.maybeSyncHeightToScrollHeight();
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, e);
        };
        return _this;
    }
    TextArea.prototype.componentDidMount = function() {
        this.maybeSyncHeightToScrollHeight();
    };
    TextArea.prototype.componentDidUpdate = function(prevProps) {
        if (prevProps.inputRef !== this.props.inputRef) {
            (0, _common.setRef)(prevProps.inputRef, null);
            this.handleRef = (0, _common.refHandler)(this, "textareaElement", this.props.inputRef);
            (0, _common.setRef)(this.props.inputRef, this.textareaElement);
        }
        if (prevProps.value !== this.props.value || prevProps.style !== this.props.style) this.maybeSyncHeightToScrollHeight();
    };
    TextArea.prototype.render = function() {
        var _a;
        var _b = this.props, asyncControl = _b.asyncControl, autoResize = _b.autoResize, className = _b.className, fill = _b.fill, // eslint-disable-next-line deprecation/deprecation
        growVertically = _b.growVertically, inputRef = _b.inputRef, intent = _b.intent, large = _b.large, small = _b.small, htmlProps = (0, _tslib.__rest)(_b, [
            "asyncControl",
            "autoResize",
            "className",
            "fill",
            "growVertically",
            "inputRef",
            "intent",
            "large",
            "small"
        ]);
        var rootClasses = (0, _classnamesDefault.default)((0, _common.Classes).INPUT, (0, _common.Classes).TEXT_AREA, (0, _common.Classes).intentClass(intent), (_a = {}, _a[(0, _common.Classes).FILL] = fill, _a[(0, _common.Classes).LARGE] = large, _a[(0, _common.Classes).SMALL] = small, _a[(0, _common.Classes).TEXT_AREA_AUTO_RESIZE] = autoResize, _a), className);
        // add explicit height style while preserving user-supplied styles if they exist
        var _c = htmlProps.style, style = _c === void 0 ? {} : _c;
        if ((autoResize || growVertically) && this.state.height != null) // this style object becomes non-extensible when mounted (at least in the enzyme renderer),
        // so we make a new one to add a property
        style = (0, _tslib.__assign)((0, _tslib.__assign)({}, style), {
            height: "".concat(this.state.height, "px")
        });
        var TextAreaComponent = asyncControl ? (0, _asyncControllableTextArea.AsyncControllableTextArea) : "textarea";
        return _react.createElement(TextAreaComponent, (0, _tslib.__assign)({}, htmlProps, {
            className: rootClasses,
            onChange: this.handleChange,
            style: style,
            ref: this.handleRef
        }));
    };
    TextArea.defaultProps = {
        autoResize: false,
        fill: false,
        large: false,
        small: false
    };
    TextArea.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".TextArea");
    return TextArea;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","./asyncControllableTextArea":"gtCiP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtCiP":[function(require,module,exports,__globalThis) {
/* !
 * (c) Copyright 2023 Palantir Technologies Inc. All rights reserved.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncControllableTextArea", ()=>AsyncControllableTextArea);
var _tslib = require("tslib");
var _react = require("react");
var _common = require("../../common");
var _useAsyncControllableValue = require("../../hooks/useAsyncControllableValue");
var AsyncControllableTextArea = _react.forwardRef(function _AsyncControllableTextArea(props, ref) {
    var parentValue = props.value, parentOnChange = props.onChange, parentOnCompositionStart = props.onCompositionStart, parentOnCompositionEnd = props.onCompositionEnd, restProps = (0, _tslib.__rest)(props, [
        "value",
        "onChange",
        "onCompositionStart",
        "onCompositionEnd"
    ]);
    var _a = (0, _useAsyncControllableValue.useAsyncControllableValue)({
        onChange: parentOnChange,
        onCompositionEnd: parentOnCompositionEnd,
        onCompositionStart: parentOnCompositionStart,
        value: parentValue
    }), value = _a.value, onChange = _a.onChange, onCompositionStart = _a.onCompositionStart, onCompositionEnd = _a.onCompositionEnd;
    return _react.createElement("textarea", (0, _tslib.__assign)({}, restProps, {
        value: value,
        onChange: onChange,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        ref: ref
    }));
});
AsyncControllableTextArea.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".AsyncControllableTextArea");

},{"tslib":"b4wpY","react":"9njXz","../../common":"3QDnh","../../hooks/useAsyncControllableValue":"egU2V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"egU2V":[function(require,module,exports,__globalThis) {
/* !
 * (c) Copyright 2023 Palantir Technologies Inc. All rights reserved.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ASYNC_CONTROLLABLE_VALUE_COMPOSITION_END_DELAY", ()=>ASYNC_CONTROLLABLE_VALUE_COMPOSITION_END_DELAY);
/**
 * A hook to workaround the following [React bug](https://github.com/facebook/react/issues/3926).
 * This bug is reproduced when an input receives CompositionEvents
 * (for example, through IME composition) and has its value prop updated asychronously.
 * This might happen if a component chooses to do async validation of a value
 * returned by the input's `onChange` callback.
 */ parcelHelpers.export(exports, "useAsyncControllableValue", ()=>useAsyncControllableValue);
var _react = require("react");
var ASYNC_CONTROLLABLE_VALUE_COMPOSITION_END_DELAY = 10;
function useAsyncControllableValue(props) {
    var onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, propValue = props.value, onChange = props.onChange;
    // The source of truth for the input value. This is not updated during IME composition.
    // It may be updated by a parent component.
    var _a = _react.useState(propValue), value = _a[0], setValue = _a[1];
    // The latest input value, which updates during IME composition.
    var _b = _react.useState(propValue), nextValue = _b[0], setNextValue = _b[1];
    // Whether we are in the middle of a composition event.
    var _c = _react.useState(false), isComposing = _c[0], setIsComposing = _c[1];
    // Whether there is a pending update we are expecting from a parent component.
    var _d = _react.useState(false), hasPendingUpdate = _d[0], setHasPendingUpdate = _d[1];
    var cancelPendingCompositionEnd = _react.useRef();
    var handleCompositionStart = _react.useCallback(function(event) {
        var _a;
        (_a = cancelPendingCompositionEnd.current) === null || _a === void 0 || _a.call(cancelPendingCompositionEnd);
        setIsComposing(true);
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(event);
    }, [
        onCompositionStart
    ]);
    // creates a timeout which will set `isComposing` to false after a delay
    // returns a function which will cancel the timeout if called before it fires
    var createOnCancelPendingCompositionEnd = _react.useCallback(function() {
        var timeoutId = window.setTimeout(function() {
            return setIsComposing(false);
        }, ASYNC_CONTROLLABLE_VALUE_COMPOSITION_END_DELAY);
        return function() {
            return window.clearTimeout(timeoutId);
        };
    }, []);
    var handleCompositionEnd = _react.useCallback(function(event) {
        // In some non-latin languages, a keystroke can end a composition event and immediately afterwards start another.
        // This can lead to unexpected characters showing up in the text input. In order to circumvent this problem, we
        // use a timeout which creates a delay which merges the two composition events, creating a more natural and predictable UX.
        // `this.state.nextValue` will become "locked" (it cannot be overwritten by the `value` prop) until a delay (10ms) has
        // passed without a new composition event starting.
        cancelPendingCompositionEnd.current = createOnCancelPendingCompositionEnd();
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(event);
    }, [
        createOnCancelPendingCompositionEnd,
        onCompositionEnd
    ]);
    var handleChange = _react.useCallback(function(event) {
        var targetValue = event.target.value;
        setNextValue(targetValue);
        onChange === null || onChange === void 0 || onChange(event);
    }, [
        onChange
    ]);
    // don't derive anything from props if:
    // - in uncontrolled mode, OR
    // - currently composing, since we'll do that after composition ends
    var shouldDeriveFromProps = !(isComposing || propValue === undefined);
    if (shouldDeriveFromProps) {
        var userTriggeredUpdate = nextValue !== value;
        if (userTriggeredUpdate && propValue === nextValue) {
            // parent has processed and accepted our update
            setValue(propValue);
            setHasPendingUpdate(false);
        } else if (userTriggeredUpdate && propValue === value) // we have sent the update to our parent, but it has not been processed yet. just wait.
        // DO NOT set nextValue here, since that will temporarily render a potentially stale controlled value,
        // causing the cursor to jump once the new value is accepted
        {
            if (!hasPendingUpdate) // make sure to setState only when necessary to avoid infinite loops
            setHasPendingUpdate(true);
        } else if (userTriggeredUpdate && propValue !== value) {
            // accept controlled update overriding user action
            setValue(propValue);
            setNextValue(propValue);
            setHasPendingUpdate(false);
        } else if (!userTriggeredUpdate) // accept controlled update, could be confirming or denying user action
        {
            if (value !== propValue || hasPendingUpdate) {
                // make sure to setState only when necessary to avoid infinite loops
                setValue(propValue);
                setNextValue(propValue);
                setHasPendingUpdate(false);
            }
        }
    }
    return {
        onChange: handleChange,
        onCompositionEnd: handleCompositionEnd,
        onCompositionStart: handleCompositionStart,
        // render the pending value even if it is not confirmed by a parent's async controlled update
        // so that the cursor does not jump to the end of input as reported in
        // https://github.com/palantir/blueprint/issues/4298
        value: isComposing || hasPendingUpdate ? nextValue : value
    };
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iGR3j":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLSelect", ()=>HTMLSelect);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _classes = require("../../common/classes");
var _props = require("../../common/props");
var HTMLSelect = _react.forwardRef(function(props, ref) {
    var _a;
    var className = props.className, children = props.children, disabled = props.disabled, fill = props.fill, _b = props.iconName, iconName = _b === void 0 ? "double-caret-vertical" : _b, iconProps = props.iconProps, large = props.large, minimal = props.minimal, _c = props.options, options = _c === void 0 ? [] : _c, value = props.value, htmlProps = (0, _tslib.__rest)(props, [
        "className",
        "children",
        "disabled",
        "fill",
        "iconName",
        "iconProps",
        "large",
        "minimal",
        "options",
        "value"
    ]);
    var classes = (0, _classnamesDefault.default)((0, _classes.HTML_SELECT), (_a = {}, _a[0, _classes.DISABLED] = disabled, _a[0, _classes.FILL] = fill, _a[0, _classes.LARGE] = large, _a[0, _classes.MINIMAL] = minimal, _a), className);
    var iconTitle = "Open dropdown";
    var rightIcon = iconName === "double-caret-vertical" ? _react.createElement((0, _icons.DoubleCaretVertical), (0, _tslib.__assign)({
        title: iconTitle
    }, iconProps)) : _react.createElement((0, _icons.CaretDown), (0, _tslib.__assign)({
        title: iconTitle
    }, iconProps));
    var optionChildren = options.map(function(option) {
        var optionProps = typeof option === "object" ? option : {
            value: option
        };
        return _react.createElement("option", (0, _tslib.__assign)({}, optionProps, {
            key: optionProps.value,
            children: optionProps.label || optionProps.value
        }));
    });
    return _react.createElement("div", {
        className: classes
    }, _react.createElement("select", (0, _tslib.__assign)({
        disabled: disabled,
        ref: ref,
        value: value
    }, htmlProps, {
        multiple: false
    }), optionChildren, children), rightIcon);
});
HTMLSelect.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".HTMLSelect");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common/classes":"2PICA","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4eVsz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLTable", ()=>HTMLTable);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var HTMLTable = _react.forwardRef(function(props, ref) {
    var _a;
    var bordered = props.bordered, className = props.className, compact = props.compact, interactive = props.interactive, striped = props.striped, htmlProps = (0, _tslib.__rest)(props, [
        "bordered",
        "className",
        "compact",
        "interactive",
        "striped"
    ]);
    var classes = (0, _classnamesDefault.default)((0, _common.Classes).HTML_TABLE, (_a = {}, _a[(0, _common.Classes).COMPACT] = compact, _a[(0, _common.Classes).HTML_TABLE_BORDERED] = bordered, _a[(0, _common.Classes).HTML_TABLE_STRIPED] = striped, _a[(0, _common.Classes).INTERACTIVE] = interactive, _a), className);
    // eslint-disable-next-line @blueprintjs/html-components
    return _react.createElement("table", (0, _tslib.__assign)({}, htmlProps, {
        ref: ref,
        className: classes
    }));
});
HTMLTable.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".HTMLTable");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bcidX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hotkey", ()=>(0, _hotkey.Hotkey));
parcelHelpers.export(exports, "Hotkeys", ()=>(0, _hotkeys.Hotkeys));
parcelHelpers.export(exports, "KeyComboTag", ()=>(0, _keyComboTag.KeyComboTag));
parcelHelpers.export(exports, "comboMatches", ()=>(0, _hotkeyParser.comboMatches));
parcelHelpers.export(exports, "getKeyCombo", ()=>(0, _hotkeyParser.getKeyCombo));
parcelHelpers.export(exports, "getKeyComboString", ()=>(0, _hotkeyParser.getKeyComboString));
parcelHelpers.export(exports, "parseKeyCombo", ()=>(0, _hotkeyParser.parseKeyCombo));
// N.B. "V1" variants of these APIs are exported from src/legacy/
parcelHelpers.export(exports, "HotkeysDialog2", ()=>(0, _hotkeysDialog2.HotkeysDialog2));
parcelHelpers.export(exports, "HotkeysTarget2", ()=>(0, _hotkeysTarget2.HotkeysTarget2));
var _hotkey = require("./hotkey");
var _hotkeys = require("./hotkeys");
var _keyComboTag = require("./keyComboTag");
var _hotkeyParser = require("./hotkeyParser");
var _hotkeysDialog2 = require("./hotkeysDialog2");
var _hotkeysTarget2 = require("./hotkeysTarget2");

},{"./hotkey":"3H0bD","./hotkeys":"5jpij","./keyComboTag":"knUq4","./hotkeyParser":"h9nCe","./hotkeysDialog2":"8MVjY","./hotkeysTarget2":"dMJK2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3H0bD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hotkey", ()=>Hotkey);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _keyComboTag = require("./keyComboTag");
/**
 * Hotkey component used to display a hotkey in the HotkeysDialog.
 * Should not be used by consumers directly.
 */ var Hotkey = /** @class */ function(_super) {
    (0, _tslib.__extends)(Hotkey, _super);
    function Hotkey() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hotkey.prototype.render = function() {
        var _a = this.props, label = _a.label, className = _a.className, spreadableProps = (0, _tslib.__rest)(_a, [
            "label",
            "className"
        ]);
        var rootClasses = (0, _classnamesDefault.default)((0, _common.Classes).HOTKEY, className);
        return _react.createElement("div", {
            className: rootClasses
        }, _react.createElement("div", {
            className: (0, _common.Classes).HOTKEY_LABEL
        }, label), _react.createElement((0, _keyComboTag.KeyComboTag), (0, _tslib.__assign)({}, spreadableProps)));
    };
    Hotkey.prototype.validateProps = function(props) {
        if (props.global !== true && props.group == null) console.error("non-global Hotkeys must define a group");
    };
    Hotkey.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Hotkey");
    Hotkey.defaultProps = {
        allowInInput: false,
        disabled: false,
        global: false,
        preventDefault: false,
        stopPropagation: false
    };
    return Hotkey;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","./keyComboTag":"knUq4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"knUq4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DISPLAY_ALIASES", ()=>DISPLAY_ALIASES);
parcelHelpers.export(exports, "KeyComboTagInternal", ()=>KeyComboTagInternal);
parcelHelpers.export(exports, "KeyComboTag", ()=>KeyComboTag);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _icon = require("../icon/icon");
var _hotkeyParser = require("./hotkeyParser");
var KEY_ICONS = {
    alt: {
        icon: _react.createElement((0, _icons.KeyOption), null),
        iconTitle: "Alt/Option key",
        isMacOnly: true
    },
    arrowdown: {
        icon: _react.createElement((0, _icons.ArrowDown), null),
        iconTitle: "Down key"
    },
    arrowleft: {
        icon: _react.createElement((0, _icons.ArrowLeft), null),
        iconTitle: "Left key"
    },
    arrowright: {
        icon: _react.createElement((0, _icons.ArrowRight), null),
        iconTitle: "Right key"
    },
    arrowup: {
        icon: _react.createElement((0, _icons.ArrowUp), null),
        iconTitle: "Up key"
    },
    cmd: {
        icon: _react.createElement((0, _icons.KeyCommand), null),
        iconTitle: "Command key",
        isMacOnly: true
    },
    ctrl: {
        icon: _react.createElement((0, _icons.KeyControl), null),
        iconTitle: "Control key",
        isMacOnly: true
    },
    delete: {
        icon: _react.createElement((0, _icons.KeyDelete), null),
        iconTitle: "Delete key"
    },
    enter: {
        icon: _react.createElement((0, _icons.KeyEnter), null),
        iconTitle: "Enter key"
    },
    meta: {
        icon: _react.createElement((0, _icons.KeyCommand), null),
        iconTitle: "Command key",
        isMacOnly: true
    },
    shift: {
        icon: _react.createElement((0, _icons.KeyShift), null),
        iconTitle: "Shift key",
        isMacOnly: true
    }
};
var DISPLAY_ALIASES = {
    ArrowDown: "down",
    ArrowLeft: "left",
    ArrowRight: "right",
    ArrowUp: "up"
};
var KeyComboTagInternal = /** @class */ function(_super) {
    (0, _tslib.__extends)(KeyComboTagInternal, _super);
    function KeyComboTagInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderKey = function(key, index) {
            var _a;
            var _b;
            var keyString = (_b = DISPLAY_ALIASES[key]) !== null && _b !== void 0 ? _b : key;
            var icon = _this.getKeyIcon(key);
            var reactKey = "key-".concat(index);
            return _react.createElement("kbd", {
                className: (0, _classnamesDefault.default)((0, _common.Classes).KEY, (_a = {}, _a[(0, _common.Classes).MODIFIER_KEY] = icon != null, _a)),
                key: reactKey
            }, icon != null && _react.createElement((0, _icon.Icon), {
                icon: icon.icon,
                title: icon.iconTitle
            }), keyString);
        };
        _this.renderMinimalKey = function(key, index, isLastKey) {
            var icon = _this.getKeyIcon(key);
            if (icon == null) return isLastKey ? key : _react.createElement(_react.Fragment, {
                key: "key-".concat(index)
            }, key, "\u00A0+\u00A0");
            return _react.createElement((0, _icon.Icon), {
                icon: icon.icon,
                title: icon.iconTitle,
                key: "key-".concat(index)
            });
        };
        return _this;
    }
    KeyComboTagInternal.prototype.render = function() {
        var _a;
        var _this = this;
        var _b = this.props, className = _b.className, combo = _b.combo, minimal = _b.minimal, platformOverride = _b.platformOverride;
        var normalizedKeys = (0, _hotkeyParser.normalizeKeyCombo)(combo, platformOverride);
        var keys = normalizedKeys.map(function(key) {
            return key.length === 1 ? key.toUpperCase() : key;
        }).map(function(key, index) {
            return minimal ? _this.renderMinimalKey(key, index, index === normalizedKeys.length - 1) : _this.renderKey(key, index);
        });
        return _react.createElement("span", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).KEY_COMBO, className, (_a = {}, _a[(0, _common.Classes).MINIMAL] = minimal, _a))
        }, keys);
    };
    KeyComboTagInternal.prototype.getKeyIcon = function(key) {
        var platformOverride = this.props.platformOverride;
        var icon = KEY_ICONS[key];
        if ((icon === null || icon === void 0 ? void 0 : icon.isMacOnly) && !(0, _hotkeyParser.isMac)(platformOverride)) return undefined;
        return icon;
    };
    KeyComboTagInternal.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".KeyComboTag");
    return KeyComboTagInternal;
}((0, _common.AbstractPureComponent));
var KeyComboTag = KeyComboTagInternal;

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../icon/icon":"duMtK","./hotkeyParser":"h9nCe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h9nCe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Named modifier keys
 *
 * @see https://www.w3.org/TR/uievents-key/#keys-modifier
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MODIFIER_BIT_MASKS", ()=>MODIFIER_BIT_MASKS);
parcelHelpers.export(exports, "CONFIG_ALIASES", ()=>CONFIG_ALIASES);
parcelHelpers.export(exports, "SHIFT_KEYS", ()=>SHIFT_KEYS);
parcelHelpers.export(exports, "comboMatches", ()=>comboMatches);
parcelHelpers.export(exports, "parseKeyCombo", ()=>parseKeyCombo);
parcelHelpers.export(exports, "getKeyComboString", ()=>getKeyComboString);
parcelHelpers.export(exports, "getKeyCombo", ()=>getKeyCombo);
parcelHelpers.export(exports, "normalizeKeyCombo", ()=>normalizeKeyCombo);
parcelHelpers.export(exports, "isMac", ()=>isMac);
var MODIFIER_KEYS = new Set([
    "Shift",
    "Control",
    "Alt",
    "Meta"
]);
var MODIFIER_BIT_MASKS = {
    alt: 1,
    ctrl: 2,
    meta: 4,
    shift: 8
};
var CONFIG_ALIASES = {
    cmd: "meta",
    command: "meta",
    del: "delete",
    esc: "escape",
    escape: "escape",
    minus: "-",
    mod: isMac(undefined) ? "meta" : "ctrl",
    option: "alt",
    plus: "+",
    return: "enter",
    win: "meta",
    // need these aliases for backwards-compatibility (but they're also convenient)
    up: "ArrowUp",
    left: "ArrowLeft",
    down: "ArrowDown",
    right: "ArrowRight"
};
var SHIFT_KEYS = {
    "~": "`",
    _: "-",
    "+": "=",
    "{": "[",
    "}": "]",
    "|": "\\",
    ":": ";",
    '"': "'",
    "<": ",",
    ">": ".",
    "?": "/"
};
function comboMatches(a, b) {
    return a.modifiers === b.modifiers && a.key === b.key;
}
var parseKeyCombo = function(combo) {
    var pieces = combo.replace(/\s/g, "").toLowerCase().split("+");
    var modifiers = 0;
    var key;
    for(var _i = 0, pieces_1 = pieces; _i < pieces_1.length; _i++){
        var piece = pieces_1[_i];
        if (piece === "") throw new Error("Failed to parse key combo \"".concat(combo, "\".\n                Valid key combos look like \"cmd + plus\", \"shift+p\", or \"!\""));
        if (CONFIG_ALIASES[piece] !== undefined) piece = CONFIG_ALIASES[piece];
        if (MODIFIER_BIT_MASKS[piece] !== undefined) modifiers += MODIFIER_BIT_MASKS[piece];
        else if (SHIFT_KEYS[piece] !== undefined) {
            modifiers += MODIFIER_BIT_MASKS.shift;
            key = SHIFT_KEYS[piece];
        } else key = piece.toLowerCase();
    }
    return {
        modifiers: modifiers,
        key: key
    };
};
var getKeyComboString = function(e) {
    var comboParts = [];
    // modifiers first
    if (e.ctrlKey) comboParts.push("ctrl");
    if (e.altKey) comboParts.push("alt");
    if (e.shiftKey) comboParts.push("shift");
    if (e.metaKey) comboParts.push("meta");
    var key = maybeGetKeyFromEventCode(e);
    if (key !== undefined) comboParts.push(key);
    else {
        if (e.code === "Space") comboParts.push("space");
        else if (MODIFIER_KEYS.has(e.key)) ;
        else if (e.shiftKey && SHIFT_KEYS[e.key] !== undefined) comboParts.push(SHIFT_KEYS[e.key]);
        else if (e.key !== undefined) comboParts.push(e.key.toLowerCase());
    }
    return comboParts.join(" + ");
};
var KEY_CODE_PREFIX = "Key";
var DIGIT_CODE_PREFIX = "Digit";
function maybeGetKeyFromEventCode(e) {
    if (e.code == null) return undefined;
    if (e.code.startsWith(KEY_CODE_PREFIX)) // Code looks like "KeyA", etc.
    return e.code.substring(KEY_CODE_PREFIX.length).toLowerCase();
    else if (e.code.startsWith(DIGIT_CODE_PREFIX)) // Code looks like "Digit1", etc.
    return e.code.substring(DIGIT_CODE_PREFIX.length).toLowerCase();
    else if (e.code === "Space") return "space";
    return undefined;
}
var getKeyCombo = function(e) {
    var _a, _b;
    var key;
    if (MODIFIER_KEYS.has(e.key)) ;
    else key = (_a = maybeGetKeyFromEventCode(e)) !== null && _a !== void 0 ? _a : (_b = e.key) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    var modifiers = 0;
    if (e.altKey) modifiers += MODIFIER_BIT_MASKS.alt;
    if (e.ctrlKey) modifiers += MODIFIER_BIT_MASKS.ctrl;
    if (e.metaKey) modifiers += MODIFIER_BIT_MASKS.meta;
    if (e.shiftKey) {
        modifiers += MODIFIER_BIT_MASKS.shift;
        if (SHIFT_KEYS[e.key] !== undefined) key = SHIFT_KEYS[e.key];
    }
    return {
        modifiers: modifiers,
        key: key
    };
};
var normalizeKeyCombo = function(combo, platformOverride) {
    var keys = combo.replace(/\s/g, "").split("+");
    return keys.map(function(key) {
        var keyName = CONFIG_ALIASES[key] != null ? CONFIG_ALIASES[key] : key;
        return keyName === "meta" ? isMac(platformOverride) ? "cmd" : "ctrl" : keyName;
    });
};
function isMac(platformOverride) {
    // HACKHACK: see https://github.com/palantir/blueprint/issues/5174
    // eslint-disable-next-line deprecation/deprecation
    var platform = platformOverride !== null && platformOverride !== void 0 ? platformOverride : typeof navigator !== "undefined" ? navigator.platform : undefined;
    return platform === undefined ? false : /Mac|iPod|iPhone|iPad/.test(platform);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jpij":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hotkeys", ()=>Hotkeys);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _utils = require("../../common/utils");
var _html = require("../html/html");
var _hotkey = require("./hotkey");
/**
 * Hotkeys component used to display a list of hotkeys in the HotkeysDialog.
 * Should not be used by consumers directly.
 */ var Hotkeys = /** @class */ function(_super) {
    (0, _tslib.__extends)(Hotkeys, _super);
    function Hotkeys() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hotkeys.prototype.render = function() {
        if (!(0, _utils.isReactChildrenElementOrElements)(this.props.children)) return null;
        var hotkeys = _react.Children.map(this.props.children, function(child) {
            return child.props;
        });
        // sort by group label alphabetically, prioritize globals
        hotkeys.sort(function(a, b) {
            if (a.global === b.global && a.group && b.group) return a.group.localeCompare(b.group);
            return a.global ? -1 : 1;
        });
        var lastGroup;
        var elems = [];
        for(var _i = 0, hotkeys_1 = hotkeys; _i < hotkeys_1.length; _i++){
            var hotkey = hotkeys_1[_i];
            var groupLabel = hotkey.group;
            if (groupLabel !== lastGroup) {
                elems.push(_react.createElement((0, _html.H4), {
                    key: "group-".concat(elems.length)
                }, groupLabel));
                lastGroup = groupLabel;
            }
            elems.push(_react.createElement((0, _hotkey.Hotkey), (0, _tslib.__assign)({
                key: elems.length
            }, hotkey)));
        }
        var rootClasses = (0, _classnamesDefault.default)((0, _common.Classes).HOTKEY_COLUMN, this.props.className);
        return _react.createElement("div", {
            className: rootClasses
        }, elems);
    };
    Hotkeys.prototype.validateProps = function(props) {
        if (!(0, _utils.isReactChildrenElementOrElements)(props.children)) return;
        _react.Children.forEach(props.children, function(child) {
            if (!(0, _utils.isElementOfType)(child, (0, _hotkey.Hotkey))) throw new Error((0, _errors.HOTKEYS_HOTKEY_CHILDREN));
        });
    };
    Hotkeys.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Hotkeys");
    Hotkeys.defaultProps = {
        tabIndex: 0
    };
    return Hotkeys;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/errors":"lyD8m","../../common/utils":"56UdR","../html/html":"6epty","./hotkey":"3H0bD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MVjY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HotkeysDialog2", ()=>HotkeysDialog2);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _dialog = require("../dialog/dialog");
var _dialogBody = require("../dialog/dialogBody");
var _hotkey = require("./hotkey");
var _hotkeys = require("./hotkeys");
var HotkeysDialog2 = function(_a) {
    var _b = _a.globalGroupName, globalGroupName = _b === void 0 ? "Global" : _b, hotkeys = _a.hotkeys, props = (0, _tslib.__rest)(_a, [
        "globalGroupName",
        "hotkeys"
    ]);
    return _react.createElement((0, _dialog.Dialog), (0, _tslib.__assign)({}, props, {
        className: (0, _classnamesDefault.default)((0, _common.Classes).HOTKEY_DIALOG, props.className)
    }), _react.createElement((0, _dialogBody.DialogBody), null, _react.createElement((0, _hotkeys.Hotkeys), null, hotkeys.map(function(hotkey, index) {
        return _react.createElement((0, _hotkey.Hotkey), (0, _tslib.__assign)({
            key: index
        }, hotkey, {
            group: hotkey.global === true && hotkey.group == null ? globalGroupName : hotkey.group
        }));
    }))));
};

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../dialog/dialog":"6MadC","../dialog/dialogBody":"ixDB1","./hotkey":"3H0bD","./hotkeys":"5jpij","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dMJK2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HotkeysTarget2", ()=>HotkeysTarget2);
var _react = require("react");
var _errors = require("../../common/errors");
var _utils = require("../../common/utils");
var _hooks = require("../../hooks");
var HotkeysTarget2 = function(_a) {
    var children = _a.children, hotkeys = _a.hotkeys, options = _a.options;
    var _b = (0, _hooks.useHotkeys)(hotkeys, options), handleKeyDown = _b.handleKeyDown, handleKeyUp = _b.handleKeyUp;
    // run props validation
    _react.useEffect(function() {
        if (!(0, _utils.isNodeEnv)("production")) {
            if (typeof children !== "function" && hotkeys.some(function(h) {
                return !h.global;
            })) console.error(_errors.HOTKEYS_TARGET_CHILDREN_LOCAL_HOTKEYS);
        }
    }, [
        hotkeys,
        children
    ]);
    if ((0, _utils.isFunction)(children)) return children({
        handleKeyDown: handleKeyDown,
        handleKeyUp: handleKeyUp
    });
    else return children;
};

},{"react":"9njXz","../../common/errors":"lyD8m","../../common/utils":"56UdR","../../hooks":"fCH16","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fCH16":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHotkeys", ()=>(0, _useHotkeys.useHotkeys));
parcelHelpers.export(exports, "useOverlayStack", ()=>(0, _useOverlayStack.useOverlayStack));
parcelHelpers.export(exports, "useAsyncControllableValue", ()=>(0, _useAsyncControllableValue.useAsyncControllableValue));
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>(0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect));
parcelHelpers.export(exports, "usePrevious", ()=>(0, _usePrevious.usePrevious));
var _useHotkeys = require("./hotkeys/useHotkeys");
var _useOverlayStack = require("./overlays/useOverlayStack");
var _useAsyncControllableValue = require("./useAsyncControllableValue");
var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");
var _usePrevious = require("./usePrevious");

},{"./hotkeys/useHotkeys":"3gjpY","./overlays/useOverlayStack":"dVB1g","./useAsyncControllableValue":"egU2V","./useIsomorphicLayoutEffect":"7cQbp","./usePrevious":"2FGmg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3gjpY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * React hook to register global and local hotkeys for a component.
 *
 * @see https://blueprintjs.com/docs/#core/hooks/use-hotkeys
 * @param keys list of hotkeys to configure
 * @param options hook options
 */ parcelHelpers.export(exports, "useHotkeys", ()=>useHotkeys);
var _tslib = require("tslib");
var _react = require("react");
var _errors = require("../../common/errors");
var _domUtils = require("../../common/utils/domUtils");
var _hotkeyParser = require("../../components/hotkeys/hotkeyParser");
var _context = require("../../context");
function useHotkeys(keys, options) {
    if (options === void 0) options = {};
    var _a = options.document, document = _a === void 0 ? getDefaultDocument() : _a, _b = options.showDialogKeyCombo, showDialogKeyCombo = _b === void 0 ? "?" : _b;
    var localKeys = _react.useMemo(function() {
        return keys.filter(function(k) {
            return !k.global;
        }).map(function(k) {
            return {
                combo: (0, _hotkeyParser.parseKeyCombo)(k.combo),
                config: k
            };
        });
    }, [
        keys
    ]);
    var globalKeys = _react.useMemo(function() {
        return keys.filter(function(k) {
            return k.global;
        }).map(function(k) {
            return {
                combo: (0, _hotkeyParser.parseKeyCombo)(k.combo),
                config: k
            };
        });
    }, [
        keys
    ]);
    // register keys with global context
    var _c = _react.useContext((0, _context.HotkeysContext)), state = _c[0], dispatch = _c[1];
    _react.useEffect(function() {
        if (!state.hasProvider) console.warn((0, _errors.HOTKEYS_PROVIDER_NOT_FOUND));
    }, [
        state.hasProvider
    ]);
    // we can still bind the hotkeys if there is no HotkeysProvider, they just won't show up in the dialog
    _react.useEffect(function() {
        var payload = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], globalKeys.map(function(k) {
            return k.config;
        }), true), localKeys.map(function(k) {
            return k.config;
        }), true);
        dispatch({
            type: "ADD_HOTKEYS",
            payload: payload
        });
        return function() {
            return dispatch({
                type: "REMOVE_HOTKEYS",
                payload: payload
            });
        };
    }, [
        dispatch,
        globalKeys,
        localKeys
    ]);
    var invokeNamedCallbackIfComboRecognized = _react.useCallback(function(global, combo, callbackName, e) {
        var _a, _b;
        var isTextInput = (0, _domUtils.elementIsTextInput)(e.target);
        for(var _i = 0, _c = global ? globalKeys : localKeys; _i < _c.length; _i++){
            var key = _c[_i];
            var _d = key.config, _e = _d.allowInInput, allowInInput = _e === void 0 ? false : _e, _f = _d.disabled, disabled = _f === void 0 ? false : _f, _g = _d.preventDefault, preventDefault = _g === void 0 ? false : _g, _h = _d.stopPropagation, stopPropagation = _h === void 0 ? false : _h;
            var shouldIgnore = isTextInput && !allowInInput || disabled;
            if (!shouldIgnore && (0, _hotkeyParser.comboMatches)(key.combo, combo)) {
                if (preventDefault) e.preventDefault();
                if (stopPropagation) {
                    // set a flag just for unit testing. not meant to be referenced in feature work.
                    e.isPropagationStopped = true;
                    e.stopPropagation();
                }
                (_b = (_a = key.config)[callbackName]) === null || _b === void 0 || _b.call(_a, e);
            }
        }
    }, [
        globalKeys,
        localKeys
    ]);
    var handleGlobalKeyDown = _react.useCallback(function(e) {
        // special case for global keydown: if '?' is pressed, open the hotkeys dialog
        var combo = (0, _hotkeyParser.getKeyCombo)(e);
        var isTextInput = (0, _domUtils.elementIsTextInput)(e.target);
        if (!isTextInput && (0, _hotkeyParser.comboMatches)((0, _hotkeyParser.parseKeyCombo)(showDialogKeyCombo), combo)) dispatch({
            type: "OPEN_DIALOG"
        });
        else invokeNamedCallbackIfComboRecognized(true, (0, _hotkeyParser.getKeyCombo)(e), "onKeyDown", e);
    }, [
        dispatch,
        invokeNamedCallbackIfComboRecognized,
        showDialogKeyCombo
    ]);
    var handleGlobalKeyUp = _react.useCallback(function(e) {
        return invokeNamedCallbackIfComboRecognized(true, (0, _hotkeyParser.getKeyCombo)(e), "onKeyUp", e);
    }, [
        invokeNamedCallbackIfComboRecognized
    ]);
    var handleLocalKeyDown = _react.useCallback(function(e) {
        return invokeNamedCallbackIfComboRecognized(false, (0, _hotkeyParser.getKeyCombo)(e.nativeEvent), "onKeyDown", e.nativeEvent);
    }, [
        invokeNamedCallbackIfComboRecognized
    ]);
    var handleLocalKeyUp = _react.useCallback(function(e) {
        return invokeNamedCallbackIfComboRecognized(false, (0, _hotkeyParser.getKeyCombo)(e.nativeEvent), "onKeyUp", e.nativeEvent);
    }, [
        invokeNamedCallbackIfComboRecognized
    ]);
    _react.useEffect(function() {
        // document is guaranteed to be defined inside effects
        document.addEventListener("keydown", handleGlobalKeyDown);
        document.addEventListener("keyup", handleGlobalKeyUp);
        return function() {
            document.removeEventListener("keydown", handleGlobalKeyDown);
            document.removeEventListener("keyup", handleGlobalKeyUp);
        };
    }, [
        document,
        handleGlobalKeyDown,
        handleGlobalKeyUp
    ]);
    return {
        handleKeyDown: handleLocalKeyDown,
        handleKeyUp: handleLocalKeyUp
    };
}
function getDefaultDocument() {
    if (typeof window === "undefined") return undefined;
    return window.document;
}

},{"tslib":"b4wpY","react":"9njXz","../../common/errors":"lyD8m","../../common/utils/domUtils":"K845P","../../components/hotkeys/hotkeyParser":"h9nCe","../../context":"TFWBE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"TFWBE":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlueprintProvider", ()=>(0, _blueprintProvider.BlueprintProvider));
parcelHelpers.export(exports, "HotkeysContext", ()=>(0, _hotkeysProvider.HotkeysContext));
parcelHelpers.export(exports, "HotkeysProvider", ()=>(0, _hotkeysProvider.HotkeysProvider));
parcelHelpers.export(exports, "OverlaysContext", ()=>(0, _overlaysProvider.OverlaysContext));
parcelHelpers.export(exports, "OverlaysProvider", ()=>(0, _overlaysProvider.OverlaysProvider));
parcelHelpers.export(exports, "PortalContext", ()=>(0, _portalProvider.PortalContext));
parcelHelpers.export(exports, "PortalProvider", ()=>(0, _portalProvider.PortalProvider));
var _blueprintProvider = require("./blueprintProvider");
var _hotkeysProvider = require("./hotkeys/hotkeysProvider");
var _overlaysProvider = require("./overlays/overlaysProvider");
var _portalProvider = require("./portal/portalProvider");

},{"./blueprintProvider":"9ClSK","./hotkeys/hotkeysProvider":"fx2g1","./overlays/overlaysProvider":"2LpRL","./portal/portalProvider":"lOE9c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ClSK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlueprintProvider", ()=>BlueprintProvider);
var _tslib = require("tslib");
var _react = require("react");
var _hotkeysProvider = require("./hotkeys/hotkeysProvider");
var _overlaysProvider = require("./overlays/overlaysProvider");
var _portalProvider = require("./portal/portalProvider");
var BlueprintProvider = function(_a) {
    var children = _a.children, hotkeysProviderValue = _a.hotkeysProviderValue, props = (0, _tslib.__rest)(_a, [
        "children",
        "hotkeysProviderValue"
    ]);
    return _react.createElement((0, _portalProvider.PortalProvider), (0, _tslib.__assign)({}, props), _react.createElement((0, _overlaysProvider.OverlaysProvider), null, _react.createElement((0, _hotkeysProvider.HotkeysProvider), (0, _tslib.__assign)({
        value: hotkeysProviderValue
    }, props), children)));
};

},{"tslib":"b4wpY","react":"9njXz","./hotkeys/hotkeysProvider":"fx2g1","./overlays/overlaysProvider":"2LpRL","./portal/portalProvider":"lOE9c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fx2g1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HotkeysContext", ()=>HotkeysContext);
parcelHelpers.export(exports, "HotkeysProvider", ()=>HotkeysProvider);
var _tslib = require("tslib");
var _react = require("react");
var _utils = require("../../common/utils");
var _hotkeysDialog2 = require("../../components/hotkeys/hotkeysDialog2");
var initialHotkeysState = {
    hasProvider: false,
    hotkeys: [],
    isDialogOpen: false
};
var noOpDispatch = function() {
    return null;
};
var HotkeysContext = _react.createContext([
    initialHotkeysState,
    noOpDispatch
]);
var hotkeysReducer = function(state, action) {
    switch(action.type){
        case "ADD_HOTKEYS":
            // only pick up unique hotkeys which haven't been registered already
            var newUniqueHotkeys = [];
            for(var _i = 0, _a = action.payload; _i < _a.length; _i++){
                var a = _a[_i];
                var isUnique = true;
                for(var _b = 0, _c = state.hotkeys; _b < _c.length; _b++){
                    var b = _c[_b];
                    isUnique && (isUnique = !(0, _utils.shallowCompareKeys)(a, b, {
                        exclude: [
                            "onKeyDown",
                            "onKeyUp"
                        ]
                    }));
                }
                if (isUnique) newUniqueHotkeys.push(a);
            }
            return (0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
                hotkeys: (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], state.hotkeys, true), newUniqueHotkeys, true)
            });
        case "REMOVE_HOTKEYS":
            return (0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
                hotkeys: state.hotkeys.filter(function(key) {
                    return action.payload.indexOf(key) === -1;
                })
            });
        case "OPEN_DIALOG":
            return (0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
                isDialogOpen: true
            });
        case "CLOSE_DIALOG":
            return (0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
                isDialogOpen: false
            });
        default:
            return state;
    }
};
var HotkeysProvider = function(_a) {
    var _b;
    var children = _a.children, dialogProps = _a.dialogProps, renderDialog = _a.renderDialog, value = _a.value;
    var hasExistingContext = value != null;
    var fallbackReducer = _react.useReducer(hotkeysReducer, (0, _tslib.__assign)((0, _tslib.__assign)({}, initialHotkeysState), {
        hasProvider: true
    }));
    var _c = value !== null && value !== void 0 ? value : fallbackReducer, state = _c[0], dispatch = _c[1];
    // The `useState` array isn't stable between renders -- so memo it outselves
    var contextValue = _react.useMemo(function() {
        return [
            state,
            dispatch
        ];
    }, [
        state,
        dispatch
    ]);
    var handleDialogClose = _react.useCallback(function() {
        return dispatch({
            type: "CLOSE_DIALOG"
        });
    }, [
        dispatch
    ]);
    var dialog = (_b = renderDialog === null || renderDialog === void 0 ? void 0 : renderDialog(state, {
        handleDialogClose: handleDialogClose
    })) !== null && _b !== void 0 ? _b : _react.createElement((0, _hotkeysDialog2.HotkeysDialog2), (0, _tslib.__assign)({}, dialogProps, {
        isOpen: state.isDialogOpen,
        hotkeys: state.hotkeys,
        onClose: handleDialogClose
    }));
    // if we are working with an existing context, we don't need to generate our own dialog
    return _react.createElement(HotkeysContext.Provider, {
        value: contextValue
    }, children, hasExistingContext ? undefined : dialog);
};

},{"tslib":"b4wpY","react":"9njXz","../../common/utils":"56UdR","../../components/hotkeys/hotkeysDialog2":"8MVjY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iROtW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuDivider", ()=>MenuDivider);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _html = require("../html/html");
var MenuDivider = function(_a) {
    var className = _a.className, title = _a.title, titleId = _a.titleId;
    var dividerClasses = (0, _classnamesDefault.default)(title ? (0, _common.Classes).MENU_HEADER : (0, _common.Classes).MENU_DIVIDER, className);
    return _react.createElement("li", {
        className: dividerClasses,
        role: "separator"
    }, title && _react.createElement((0, _html.H6), {
        id: titleId
    }, title));
};
MenuDivider.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".MenuDivider");

},{"classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../html/html":"6epty","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"auMQg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Navbar", ()=>Navbar);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _navbarDivider = require("./navbarDivider");
var _navbarGroup = require("./navbarGroup");
var _navbarHeading = require("./navbarHeading");
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */ /**
 * Navbar component.
 *
 * @see https://blueprintjs.com/docs/#core/components/navbar
 */ var Navbar = /** @class */ function(_super) {
    (0, _tslib.__extends)(Navbar, _super);
    function Navbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Navbar.prototype.render = function() {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, fixedToTop = _b.fixedToTop, htmlProps = (0, _tslib.__rest)(_b, [
            "children",
            "className",
            "fixedToTop"
        ]);
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).NAVBAR, (_a = {}, _a[(0, _common.Classes).FIXED_TOP] = fixedToTop, _a), className);
        return _react.createElement("div", (0, _tslib.__assign)({
            className: classes
        }, htmlProps), children);
    };
    Navbar.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Navbar");
    Navbar.Divider = (0, _navbarDivider.NavbarDivider);
    Navbar.Group = (0, _navbarGroup.NavbarGroup);
    Navbar.Heading = (0, _navbarHeading.NavbarHeading);
    return Navbar;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","./navbarDivider":"kr60P","./navbarGroup":"hHUaR","./navbarHeading":"bUl3D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kr60P":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavbarDivider", ()=>NavbarDivider);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */ var NavbarDivider = /** @class */ function(_super) {
    (0, _tslib.__extends)(NavbarDivider, _super);
    function NavbarDivider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavbarDivider.prototype.render = function() {
        var _a = this.props, className = _a.className, htmlProps = (0, _tslib.__rest)(_a, [
            "className"
        ]);
        return _react.createElement("div", (0, _tslib.__assign)({
            className: (0, _classnamesDefault.default)((0, _common.Classes).NAVBAR_DIVIDER, className)
        }, htmlProps));
    };
    NavbarDivider.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".NavbarDivider");
    return NavbarDivider;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hHUaR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavbarGroup", ()=>NavbarGroup);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var NavbarGroup = function(_a) {
    var _b = _a.align, align = _b === void 0 ? (0, _common.Alignment).LEFT : _b, children = _a.children, className = _a.className, htmlProps = (0, _tslib.__rest)(_a, [
        "align",
        "children",
        "className"
    ]);
    var classes = (0, _classnamesDefault.default)((0, _common.Classes).NAVBAR_GROUP, (0, _common.Classes).alignmentClass(align), className);
    return _react.createElement("div", (0, _tslib.__assign)({
        className: classes
    }, htmlProps), children);
};
NavbarGroup.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".NavbarGroup");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bUl3D":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavbarHeading", ()=>NavbarHeading);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */ var NavbarHeading = /** @class */ function(_super) {
    (0, _tslib.__extends)(NavbarHeading, _super);
    function NavbarHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavbarHeading.prototype.render = function() {
        var _a = this.props, children = _a.children, className = _a.className, htmlProps = (0, _tslib.__rest)(_a, [
            "children",
            "className"
        ]);
        return _react.createElement("div", (0, _tslib.__assign)({
            className: (0, _classnamesDefault.default)((0, _common.Classes).NAVBAR_HEADING, className)
        }, htmlProps), children);
    };
    NavbarHeading.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".NavbarHeading");
    return NavbarHeading;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"48IBA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonIdealStateIconSize", ()=>NonIdealStateIconSize);
parcelHelpers.export(exports, "NonIdealState", ()=>NonIdealState);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _utils = require("../../common/utils");
var _html = require("../html/html");
var _icon = require("../icon/icon");
var NonIdealStateIconSize;
(function(NonIdealStateIconSize) {
    NonIdealStateIconSize[NonIdealStateIconSize["STANDARD"] = 48] = "STANDARD";
    NonIdealStateIconSize[NonIdealStateIconSize["SMALL"] = 32] = "SMALL";
    NonIdealStateIconSize[NonIdealStateIconSize["EXTRA_SMALL"] = 20] = "EXTRA_SMALL";
})(NonIdealStateIconSize || (NonIdealStateIconSize = {}));
/**
 * Non-ideal state component.
 *
 * @see https://blueprintjs.com/docs/#core/components/non-ideal-state
 */ var NonIdealState = /** @class */ function(_super) {
    (0, _tslib.__extends)(NonIdealState, _super);
    function NonIdealState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NonIdealState.prototype.render = function() {
        var _a = this.props, action = _a.action, children = _a.children, className = _a.className, layout = _a.layout;
        return _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).NON_IDEAL_STATE, "".concat((0, _common.Classes).NON_IDEAL_STATE, "-").concat(layout), className)
        }, this.maybeRenderVisual(), this.maybeRenderText(), action, children);
    };
    NonIdealState.prototype.maybeRenderVisual = function() {
        var _a;
        var _b = this.props, icon = _b.icon, iconMuted = _b.iconMuted, iconSize = _b.iconSize;
        if (icon == null) return undefined;
        else return _react.createElement("div", {
            className: (0, _common.Classes).NON_IDEAL_STATE_VISUAL,
            style: {
                fontSize: "".concat(iconSize, "px"),
                lineHeight: "".concat(iconSize, "px")
            }
        }, _react.createElement((0, _icon.Icon), {
            className: (0, _classnamesDefault.default)((_a = {}, _a[(0, _common.Classes).ICON_MUTED] = iconMuted, _a)),
            icon: icon,
            size: iconSize,
            "aria-hidden": true,
            tabIndex: -1
        }));
    };
    NonIdealState.prototype.maybeRenderText = function() {
        var _a = this.props, description = _a.description, title = _a.title;
        if (title == null && description == null) return undefined;
        else return _react.createElement("div", {
            className: (0, _common.Classes).NON_IDEAL_STATE_TEXT
        }, title && _react.createElement((0, _html.H4), null, title), description && (0, _utils.ensureElement)(description, "div"));
    };
    NonIdealState.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".NonIdealState");
    NonIdealState.defaultProps = {
        iconMuted: true,
        iconSize: NonIdealStateIconSize.STANDARD,
        layout: "vertical"
    };
    return NonIdealState;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../../common/utils":"56UdR","../html/html":"6epty","../icon/icon":"duMtK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gfqUm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Overlay", ()=>Overlay);
var _tslib = require("tslib");
/**
 * @fileoverview This component is DEPRECATED, and the code is frozen.
 * All changes & bugfixes should be made to Overlay2 instead.
 */ /* eslint-disable deprecation/deprecation, @blueprintjs/no-deprecated-components */ var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactTransitionGroup = require("react-transition-group");
var _common = require("../../common");
var _props = require("../../common/props");
var _utils = require("../../common/utils");
var _portal = require("../portal/portal");
var _overlayUtils = require("./overlayUtils");
/**
 * Overlay component.
 *
 * @deprecated use `Overlay2` instead
 * @see https://blueprintjs.com/docs/#core/components/overlay
 */ var Overlay = /** @class */ function(_super) {
    (0, _tslib.__extends)(Overlay, _super);
    function Overlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isAutoFocusing = false;
        _this.state = {
            hasEverOpened: _this.props.isOpen
        };
        /** Ref for container element, containing all children and the backdrop */ _this.containerElement = _react.createRef();
        // An empty, keyboard-focusable div at the beginning of the Overlay content
        _this.startFocusTrapElement = _react.createRef();
        // An empty, keyboard-focusable div at the end of the Overlay content
        _this.endFocusTrapElement = _react.createRef();
        _this.maybeRenderChild = function(child) {
            if ((0, _utils.isFunction)(child)) child = child();
            if (child == null) return null;
            // decorate the child with a few injected props
            var tabIndex = _this.props.enforceFocus || _this.props.autoFocus ? 0 : undefined;
            var decoratedChild = typeof child === "object" ? _react.cloneElement(child, {
                className: (0, _classnamesDefault.default)(child.props.className, (0, _common.Classes).OVERLAY_CONTENT),
                tabIndex: tabIndex
            }) : _react.createElement("span", {
                className: (0, _common.Classes).OVERLAY_CONTENT,
                tabIndex: tabIndex
            }, child);
            var _a = _this.props, onOpening = _a.onOpening, onOpened = _a.onOpened, onClosing = _a.onClosing, transitionDuration = _a.transitionDuration, transitionName = _a.transitionName;
            return _react.createElement((0, _reactTransitionGroup.CSSTransition), {
                classNames: transitionName,
                onEntering: onOpening,
                onEntered: onOpened,
                onExiting: onClosing,
                onExited: _this.handleTransitionExited,
                timeout: transitionDuration,
                addEndListener: _this.handleTransitionAddEnd
            }, decoratedChild);
        };
        /**
         * Ensures repeatedly pressing shift+tab keeps focus inside the Overlay. Moves focus to
         * the `endFocusTrapElement` or the first keyboard-focusable element in the Overlay (excluding
         * the `startFocusTrapElement`), depending on whether the element losing focus is inside the
         * Overlay.
         */ _this.handleStartFocusTrapElementFocus = function(e) {
            var _a, _b;
            if (!_this.props.enforceFocus || _this.isAutoFocusing) return;
            // e.relatedTarget will not be defined if this was a programmatic focus event, as is the
            // case when we call this.bringFocusInsideOverlay() after a user clicked on the backdrop.
            // Otherwise, we're handling a user interaction, and we should wrap around to the last
            // element in this transition group.
            if (e.relatedTarget != null && ((_a = _this.containerElement.current) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget)) && e.relatedTarget !== _this.endFocusTrapElement.current) (_b = _this.endFocusTrapElement.current) === null || _b === void 0 || _b.focus({
                preventScroll: true
            });
        };
        /**
         * Wrap around to the end of the dialog if `enforceFocus` is enabled.
         */ _this.handleStartFocusTrapElementKeyDown = function(e) {
            var _a;
            if (!_this.props.enforceFocus) return;
            if (e.shiftKey && e.key === "Tab") {
                var lastFocusableElement = (0, _overlayUtils.getKeyboardFocusableElements)(_this.containerElement).pop();
                if (lastFocusableElement != null) lastFocusableElement.focus();
                else (_a = _this.endFocusTrapElement.current) === null || _a === void 0 || _a.focus({
                    preventScroll: true
                });
            }
        };
        /**
         * Ensures repeatedly pressing tab keeps focus inside the Overlay. Moves focus to the
         * `startFocusTrapElement` or the last keyboard-focusable element in the Overlay (excluding the
         * `startFocusTrapElement`), depending on whether the element losing focus is inside the
         * Overlay.
         */ _this.handleEndFocusTrapElementFocus = function(e) {
            var _a, _b, _c;
            // No need for this.props.enforceFocus check here because this element is only rendered
            // when that prop is true.
            // During user interactions, e.relatedTarget will be defined, and we should wrap around to the
            // "start focus trap" element.
            // Otherwise, we're handling a programmatic focus event, which can only happen after a user
            // presses shift+tab from the first focusable element in the overlay.
            if (e.relatedTarget != null && ((_a = _this.containerElement.current) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget)) && e.relatedTarget !== _this.startFocusTrapElement.current) {
                var firstFocusableElement = (0, _overlayUtils.getKeyboardFocusableElements)(_this.containerElement).shift();
                // ensure we don't re-focus an already active element by comparing against e.relatedTarget
                if (!_this.isAutoFocusing && firstFocusableElement != null && firstFocusableElement !== e.relatedTarget) firstFocusableElement.focus();
                else (_b = _this.startFocusTrapElement.current) === null || _b === void 0 || _b.focus({
                    preventScroll: true
                });
            } else {
                var lastFocusableElement = (0, _overlayUtils.getKeyboardFocusableElements)(_this.containerElement).pop();
                if (lastFocusableElement != null) lastFocusableElement.focus();
                else // Keeps focus within Overlay even if there are no keyboard-focusable children
                (_c = _this.startFocusTrapElement.current) === null || _c === void 0 || _c.focus({
                    preventScroll: true
                });
            }
        };
        _this.handleTransitionExited = function(node) {
            var _a, _b;
            if (_this.props.shouldReturnFocusOnClose && _this.lastActiveElementBeforeOpened instanceof HTMLElement) _this.lastActiveElementBeforeOpened.focus();
            (_b = (_a = _this.props).onClosed) === null || _b === void 0 || _b.call(_a, node);
        };
        _this.handleBackdropMouseDown = function(e) {
            var _a;
            var _b = _this.props, backdropProps = _b.backdropProps, canOutsideClickClose = _b.canOutsideClickClose, enforceFocus = _b.enforceFocus, onClose = _b.onClose;
            if (canOutsideClickClose) onClose === null || onClose === void 0 || onClose(e);
            if (enforceFocus) _this.bringFocusInsideOverlay();
            (_a = backdropProps === null || backdropProps === void 0 ? void 0 : backdropProps.onMouseDown) === null || _a === void 0 || _a.call(backdropProps, e);
        };
        _this.handleDocumentClick = function(e) {
            var _a = _this.props, canOutsideClickClose = _a.canOutsideClickClose, isOpen = _a.isOpen, onClose = _a.onClose;
            // get the actual target even in the Shadow DOM
            // see https://github.com/palantir/blueprint/issues/4220
            var eventTarget = e.composed ? e.composedPath()[0] : e.target;
            var stackIndex = Overlay.openStack.indexOf(_this);
            var isClickInThisOverlayOrDescendant = Overlay.openStack.slice(stackIndex).some(function(_a) {
                var _b;
                var elem = _a.containerElement;
                // `elem` is the container of backdrop & content, so clicking directly on that container
                // should not count as being "inside" the overlay.
                return ((_b = elem.current) === null || _b === void 0 ? void 0 : _b.contains(eventTarget)) && !elem.current.isSameNode(eventTarget);
            });
            if (isOpen && !isClickInThisOverlayOrDescendant && canOutsideClickClose) // casting to any because this is a native event
            onClose === null || onClose === void 0 || onClose(e);
        };
        /**
         * When multiple Overlays are open, this event handler is only active for the most recently
         * opened one to avoid Overlays competing with each other for focus.
         */ _this.handleDocumentFocus = function(e) {
            // get the actual target even in the Shadow DOM
            // see https://github.com/palantir/blueprint/issues/4220
            var eventTarget = e.composed ? e.composedPath()[0] : e.target;
            if (_this.props.enforceFocus && _this.containerElement.current != null && eventTarget instanceof Node && !_this.containerElement.current.contains(eventTarget)) {
                // prevent default focus behavior (sometimes auto-scrolls the page)
                e.preventDefault();
                e.stopImmediatePropagation();
                _this.bringFocusInsideOverlay();
            }
        };
        _this.handleKeyDown = function(e) {
            var _a = _this.props, canEscapeKeyClose = _a.canEscapeKeyClose, onClose = _a.onClose;
            if (e.key === "Escape" && canEscapeKeyClose) {
                onClose === null || onClose === void 0 || onClose(e);
                // prevent other overlays from closing
                e.stopPropagation();
                // prevent browser-specific escape key behavior (Safari exits fullscreen)
                e.preventDefault();
            }
        };
        _this.handleTransitionAddEnd = function() {
        // no-op
        };
        return _this;
    }
    Overlay.getDerivedStateFromProps = function(_a) {
        var hasEverOpened = _a.isOpen;
        if (hasEverOpened) return {
            hasEverOpened: hasEverOpened
        };
        return null;
    };
    Overlay.prototype.render = function() {
        var _a;
        var _b;
        // oh snap! no reason to render anything at all if we're being truly lazy
        if (this.props.lazy && !this.state.hasEverOpened) return null;
        var _c = this.props, autoFocus = _c.autoFocus, children = _c.children, className = _c.className, enforceFocus = _c.enforceFocus, usePortal = _c.usePortal, isOpen = _c.isOpen;
        // TransitionGroup types require single array of children; does not support nested arrays.
        // So we must collapse backdrop and children into one array, and every item must be wrapped in a
        // Transition element (no ReactText allowed).
        var childrenWithTransitions = isOpen ? (_b = _react.Children.map(children, this.maybeRenderChild)) !== null && _b !== void 0 ? _b : [] : [];
        var maybeBackdrop = this.maybeRenderBackdrop();
        if (maybeBackdrop !== null) childrenWithTransitions.unshift(maybeBackdrop);
        if (isOpen && (autoFocus || enforceFocus) && childrenWithTransitions.length > 0) {
            childrenWithTransitions.unshift(this.renderDummyElement("__start", {
                className: (0, _common.Classes).OVERLAY_START_FOCUS_TRAP,
                onFocus: this.handleStartFocusTrapElementFocus,
                onKeyDown: this.handleStartFocusTrapElementKeyDown,
                ref: this.startFocusTrapElement
            }));
            if (enforceFocus) childrenWithTransitions.push(this.renderDummyElement("__end", {
                className: (0, _common.Classes).OVERLAY_END_FOCUS_TRAP,
                onFocus: this.handleEndFocusTrapElementFocus,
                ref: this.endFocusTrapElement
            }));
        }
        var containerClasses = (0, _classnamesDefault.default)((0, _common.Classes).OVERLAY, (_a = {}, _a[(0, _common.Classes).OVERLAY_OPEN] = isOpen, _a[(0, _common.Classes).OVERLAY_INLINE] = !usePortal, _a), className);
        var transitionGroup = _react.createElement("div", {
            "aria-live": "polite",
            className: containerClasses,
            onKeyDown: this.handleKeyDown,
            ref: this.containerElement
        }, _react.createElement((0, _reactTransitionGroup.TransitionGroup), {
            appear: true,
            component: null
        }, childrenWithTransitions));
        if (usePortal) return _react.createElement((0, _portal.Portal), {
            className: this.props.portalClassName,
            container: this.props.portalContainer,
            // eslint-disable-next-line deprecation/deprecation
            stopPropagationEvents: this.props.portalStopPropagationEvents
        }, transitionGroup);
        else return transitionGroup;
    };
    Overlay.prototype.componentDidMount = function() {
        if (this.props.isOpen) this.overlayWillOpen();
    };
    Overlay.prototype.componentDidUpdate = function(prevProps) {
        if (prevProps.isOpen && !this.props.isOpen) this.overlayWillClose();
        else if (!prevProps.isOpen && this.props.isOpen) this.overlayWillOpen();
    };
    Overlay.prototype.componentWillUnmount = function() {
        this.overlayWillClose();
    };
    /**
     * @public for testing
     * @internal
     */ Overlay.prototype.bringFocusInsideOverlay = function() {
        var _this = this;
        // always delay focus manipulation to just before repaint to prevent scroll jumping
        return this.requestAnimationFrame(function() {
            var _a;
            // container element may be undefined between component mounting and Portal rendering
            // activeElement may be undefined in some rare cases in IE
            var activeElement = (0, _utils.getActiveElement)(_this.containerElement.current);
            if (_this.containerElement.current == null || activeElement == null || !_this.props.isOpen) return;
            var container = _this.containerElement.current;
            var isFocusOutsideModal = !container.contains(activeElement);
            if (isFocusOutsideModal) {
                (_a = _this.startFocusTrapElement.current) === null || _a === void 0 || _a.focus({
                    preventScroll: true
                });
                _this.isAutoFocusing = false;
            }
        });
    };
    Overlay.prototype.maybeRenderBackdrop = function() {
        var _a = this.props, backdropClassName = _a.backdropClassName, backdropProps = _a.backdropProps, hasBackdrop = _a.hasBackdrop, isOpen = _a.isOpen, transitionDuration = _a.transitionDuration, transitionName = _a.transitionName;
        if (hasBackdrop && isOpen) return _react.createElement((0, _reactTransitionGroup.CSSTransition), {
            classNames: transitionName,
            key: "__backdrop",
            timeout: transitionDuration,
            addEndListener: this.handleTransitionAddEnd
        }, _react.createElement("div", (0, _tslib.__assign)({}, backdropProps, {
            className: (0, _classnamesDefault.default)((0, _common.Classes).OVERLAY_BACKDROP, backdropClassName, backdropProps === null || backdropProps === void 0 ? void 0 : backdropProps.className),
            onMouseDown: this.handleBackdropMouseDown
        })));
        else return null;
    };
    Overlay.prototype.renderDummyElement = function(key, props) {
        var _a = this.props, transitionDuration = _a.transitionDuration, transitionName = _a.transitionName;
        return _react.createElement((0, _reactTransitionGroup.CSSTransition), {
            classNames: transitionName,
            key: key,
            addEndListener: this.handleTransitionAddEnd,
            timeout: transitionDuration,
            unmountOnExit: true
        }, _react.createElement("div", (0, _tslib.__assign)({
            tabIndex: 0
        }, props)));
    };
    Overlay.prototype.overlayWillClose = function() {
        document.removeEventListener("focus", this.handleDocumentFocus, /* useCapture */ true);
        document.removeEventListener("mousedown", this.handleDocumentClick);
        var openStack = Overlay.openStack;
        var stackIndex = openStack.indexOf(this);
        if (stackIndex !== -1) {
            openStack.splice(stackIndex, 1);
            if (openStack.length > 0) {
                var lastOpenedOverlay = Overlay.getLastOpened();
                // Only bring focus back to last overlay if it had autoFocus _and_ enforceFocus enabled.
                // If `autoFocus={false}`, it's likely that the overlay never received focus in the first place,
                // so it would be surprising for us to send it there. See https://github.com/palantir/blueprint/issues/4921
                if (lastOpenedOverlay.props.autoFocus && lastOpenedOverlay.props.enforceFocus) {
                    lastOpenedOverlay.bringFocusInsideOverlay();
                    document.addEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */ true);
                }
            }
            if (openStack.filter(function(o) {
                return o.props.usePortal && o.props.hasBackdrop;
            }).length === 0) document.body.classList.remove((0, _common.Classes).OVERLAY_OPEN);
        }
    };
    Overlay.prototype.overlayWillOpen = function() {
        var getLastOpened = Overlay.getLastOpened, openStack = Overlay.openStack;
        if (openStack.length > 0) document.removeEventListener("focus", getLastOpened().handleDocumentFocus, /* useCapture */ true);
        openStack.push(this);
        if (this.props.autoFocus) {
            this.isAutoFocusing = true;
            this.bringFocusInsideOverlay();
        }
        if (this.props.enforceFocus) // Focus events do not bubble, but setting useCapture allows us to listen in and execute
        // our handler before all others
        document.addEventListener("focus", this.handleDocumentFocus, /* useCapture */ true);
        if (this.props.canOutsideClickClose && !this.props.hasBackdrop) document.addEventListener("mousedown", this.handleDocumentClick);
        if (this.props.hasBackdrop && this.props.usePortal) // add a class to the body to prevent scrolling of content below the overlay
        document.body.classList.add((0, _common.Classes).OVERLAY_OPEN);
        this.lastActiveElementBeforeOpened = (0, _utils.getActiveElement)(this.containerElement.current);
    };
    Overlay.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Overlay");
    Overlay.defaultProps = {
        autoFocus: true,
        backdropProps: {},
        canEscapeKeyClose: true,
        canOutsideClickClose: true,
        enforceFocus: true,
        hasBackdrop: true,
        isOpen: false,
        lazy: true,
        shouldReturnFocusOnClose: true,
        transitionDuration: 300,
        transitionName: (0, _common.Classes).OVERLAY,
        usePortal: true
    };
    Overlay.openStack = [];
    Overlay.getLastOpened = function() {
        return Overlay.openStack[Overlay.openStack.length - 1];
    };
    return Overlay;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","react-transition-group":"hnCQJ","../../common":"3QDnh","../../common/props":"dBcIV","../../common/utils":"56UdR","../portal/portal":"kksjR","./overlayUtils":"hZFxO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"if8KV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanelStack", ()=>PanelStack);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactTransitionGroup = require("react-transition-group");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _panelView = require("./panelView");
/**
 * Panel stack component.
 *
 * @see https://blueprintjs.com/docs/#core/components/panel-stack
 * @deprecated use `PanelStack2<T>`
 */ var PanelStack = /** @class */ function(_super) {
    (0, _tslib.__extends)(PanelStack, _super);
    function PanelStack() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            direction: "push",
            stack: _this.props.stack != null ? _this.props.stack.slice().reverse() : _this.props.initialPanel !== undefined ? [
                _this.props.initialPanel
            ] : []
        };
        _this.renderPanel = function(panel, index) {
            var _a = _this.props, renderActivePanelOnly = _a.renderActivePanelOnly, _b = _a.showPanelHeader, showPanelHeader = _b === void 0 ? true : _b;
            var stack = _this.state.stack;
            // With renderActivePanelOnly={false} we would keep all the CSSTransitions rendered,
            // therefore they would not trigger the "enter" transition event as they were entered.
            // To force the enter event, we want to change the key, but stack.length is not enough
            // and a single panel should not rerender as long as it's hidden.
            // This key contains two parts: first one, stack.length - index is constant (and unique) for each panel,
            // second one, active changes only when the panel becomes or stops being active.
            var layer = stack.length - index;
            var key = renderActivePanelOnly ? stack.length : layer;
            return _react.createElement((0, _reactTransitionGroup.CSSTransition), {
                classNames: (0, _common.Classes).PANEL_STACK,
                key: key,
                timeout: 400
            }, _react.createElement((0, _panelView.PanelView), {
                onClose: _this.handlePanelClose,
                onOpen: _this.handlePanelOpen,
                panel: panel,
                previousPanel: stack[index + 1],
                showHeader: showPanelHeader
            }));
        };
        _this.handlePanelClose = function(panel) {
            var _a, _b;
            var stack = _this.state.stack;
            // only remove this panel if it is at the top and not the only one.
            if (stack[0] !== panel || stack.length <= 1) return;
            (_b = (_a = _this.props).onClose) === null || _b === void 0 || _b.call(_a, panel);
            if (_this.props.stack == null) _this.setState(function(state) {
                return {
                    direction: "pop",
                    stack: state.stack.slice(1)
                };
            });
        };
        _this.handlePanelOpen = function(panel) {
            var _a, _b;
            (_b = (_a = _this.props).onOpen) === null || _b === void 0 || _b.call(_a, panel);
            if (_this.props.stack == null) _this.setState(function(state) {
                return {
                    direction: "push",
                    stack: (0, _tslib.__spreadArray)([
                        panel
                    ], state.stack, true)
                };
            });
        };
        return _this;
    }
    PanelStack.prototype.componentDidUpdate = function(prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        // Always update local stack if stack prop changes
        if (this.props.stack !== prevProps.stack && prevProps.stack != null) this.setState({
            stack: this.props.stack.slice().reverse()
        });
        // Only update animation direction if stack length changes
        var stackLength = this.props.stack != null ? this.props.stack.length : 0;
        var prevStackLength = prevProps.stack != null ? prevProps.stack.length : 0;
        if (stackLength !== prevStackLength && prevProps.stack != null) this.setState({
            direction: prevProps.stack.length - this.props.stack.length < 0 ? "push" : "pop"
        });
    };
    PanelStack.prototype.render = function() {
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).PANEL_STACK, "".concat((0, _common.Classes).PANEL_STACK, "-").concat(this.state.direction), this.props.className);
        return _react.createElement((0, _reactTransitionGroup.TransitionGroup), {
            className: classes,
            component: "div"
        }, this.renderPanels());
    };
    PanelStack.prototype.validateProps = function(props) {
        if (props.initialPanel == null && props.stack == null || props.initialPanel != null && props.stack != null) console.error(_errors.PANEL_STACK_INITIAL_PANEL_STACK_MUTEX);
        if (props.stack != null && props.stack.length === 0) console.error(_errors.PANEL_STACK_REQUIRES_PANEL);
    };
    PanelStack.prototype.renderPanels = function() {
        var _a = this.props.renderActivePanelOnly, renderActivePanelOnly = _a === void 0 ? true : _a;
        var stack = this.state.stack;
        if (stack.length === 0) return null;
        var panelsToRender = renderActivePanelOnly ? [
            stack[0]
        ] : stack;
        var panelViews = panelsToRender.map(this.renderPanel).reverse();
        return panelViews;
    };
    return PanelStack;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","react-transition-group":"hnCQJ","../../common":"3QDnh","../../common/errors":"lyD8m","./panelView":"7V0lj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7V0lj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanelView", ()=>PanelView);
var _tslib = require("tslib");
/**
 * @fileoverview This component is DEPRECATED, and the code is frozen.
 * All changes & bugfixes should be made to PanelStack2 instead.
 */ /* eslint-disable deprecation/deprecation */ var _react = require("react");
var _common = require("../../common");
var _buttons = require("../button/buttons");
var _text = require("../text/text");
var PanelView = /** @class */ function(_super) {
    (0, _tslib.__extends)(PanelView, _super);
    function PanelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClose = function() {
            return _this.props.onClose(_this.props.panel);
        };
        return _this;
    }
    PanelView.prototype.render = function() {
        var _a = this.props, panel = _a.panel, onOpen = _a.onOpen;
        // two <span> tags in header ensure title is centered as long as
        // possible, due to `flex: 1` magic.
        return _react.createElement("div", {
            className: (0, _common.Classes).PANEL_STACK_VIEW
        }, this.maybeRenderHeader(), _react.createElement(panel.component, (0, _tslib.__assign)({
            openPanel: onOpen,
            closePanel: this.handleClose
        }, panel.props)));
    };
    PanelView.prototype.maybeRenderHeader = function() {
        if (!this.props.showHeader) return null;
        return _react.createElement("div", {
            className: (0, _common.Classes).PANEL_STACK_HEADER
        }, _react.createElement("span", null, this.maybeRenderBack()), _react.createElement((0, _text.Text), {
            className: (0, _common.Classes).HEADING,
            ellipsize: true,
            title: this.props.panel.htmlTitle
        }, this.props.panel.title), _react.createElement("span", null));
    };
    PanelView.prototype.maybeRenderBack = function() {
        if (this.props.previousPanel === undefined) return null;
        return _react.createElement((0, _buttons.Button), {
            "aria-label": "Back",
            className: (0, _common.Classes).PANEL_STACK_HEADER_BACK,
            icon: "chevron-left",
            minimal: true,
            onClick: this.handleClose,
            small: true,
            text: this.props.previousPanel.title,
            title: this.props.previousPanel.htmlTitle
        });
    };
    return PanelView;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","react":"9njXz","../../common":"3QDnh","../button/buttons":"glm43","../text/text":"cIHFN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"au9wW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanelStack2", ()=>PanelStack2);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactTransitionGroup = require("react-transition-group");
var _common = require("../../common");
var _hooks = require("../../hooks");
var _panelView2 = require("./panelView2");
var PanelStack2 = function(props) {
    var _a;
    var initialPanel = props.initialPanel, onClose = props.onClose, onOpen = props.onOpen, _b = props.renderActivePanelOnly, renderActivePanelOnly = _b === void 0 ? true : _b, _c = props.showPanelHeader, showPanelHeader = _c === void 0 ? true : _c, propsStack = props.stack;
    var isControlled = propsStack != null;
    var _d = _react.useState(initialPanel !== undefined ? [
        initialPanel
    ] : []), localStack = _d[0], setLocalStack = _d[1];
    var stack = _react.useMemo(function() {
        return isControlled ? propsStack.slice().reverse() : localStack;
    }, [
        localStack,
        isControlled,
        propsStack
    ]);
    var prevStackLength = (_a = (0, _hooks.usePrevious)(stack.length)) !== null && _a !== void 0 ? _a : stack.length;
    var direction = stack.length - prevStackLength < 0 ? "pop" : "push";
    var handlePanelOpen = _react.useCallback(function(panel) {
        onOpen === null || onOpen === void 0 || onOpen(panel);
        if (!isControlled) setLocalStack(function(prevStack) {
            return (0, _tslib.__spreadArray)([
                panel
            ], prevStack, true);
        });
    }, [
        onOpen,
        isControlled
    ]);
    var handlePanelClose = _react.useCallback(function(panel) {
        onClose === null || onClose === void 0 || onClose(panel);
        if (!isControlled) setLocalStack(function(prevStack) {
            return prevStack.slice(1);
        });
    }, [
        onClose,
        isControlled
    ]);
    // early return, after all hooks are called
    if (stack.length === 0) return null;
    var panelsToRender = renderActivePanelOnly ? [
        stack[0]
    ] : stack;
    var panels = panelsToRender.map(function(panel, index) {
        // With renderActivePanelOnly={false} we would keep all the CSSTransitions rendered,
        // therefore they would not trigger the "enter" transition event as they were entered.
        // To force the enter event, we want to change the key, but stack.length is not enough
        // and a single panel should not rerender as long as it's hidden.
        // This key contains two parts: first one, stack.length - index is constant (and unique) for each panel,
        // second one, active changes only when the panel becomes or stops being active.
        var layer = stack.length - index;
        var key = renderActivePanelOnly ? stack.length : layer;
        return _react.createElement((0, _reactTransitionGroup.CSSTransition), {
            classNames: (0, _common.Classes).PANEL_STACK2,
            key: key,
            timeout: 400
        }, _react.createElement((0, _panelView2.PanelView2), {
            onClose: handlePanelClose,
            onOpen: handlePanelOpen,
            panel: panel,
            previousPanel: stack[index + 1],
            showHeader: showPanelHeader
        }));
    }).reverse();
    var classes = (0, _classnamesDefault.default)((0, _common.Classes).PANEL_STACK2, "".concat((0, _common.Classes).PANEL_STACK2, "-").concat(direction), props.className);
    return _react.createElement((0, _reactTransitionGroup.TransitionGroup), {
        className: classes,
        component: "div"
    }, panels);
};
PanelStack2.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".PanelStack2");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","react-transition-group":"hnCQJ","../../common":"3QDnh","../../hooks":"fCH16","./panelView2":"8euIv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8euIv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanelView2", ()=>PanelView2);
var _tslib = require("tslib");
var _react = require("react");
var _common = require("../../common");
var _buttons = require("../button/buttons");
var _text = require("../text/text");
var PanelView2 = function(_a) {
    var panel = _a.panel, onClose = _a.onClose, onOpen = _a.onOpen, previousPanel = _a.previousPanel, showHeader = _a.showHeader;
    var hasPreviousPanel = previousPanel !== undefined;
    var handleClose = _react.useCallback(function() {
        // only remove this panel if it is not the only one.
        if (hasPreviousPanel) onClose(panel);
    }, [
        onClose,
        panel,
        hasPreviousPanel
    ]);
    var maybeBackButton = previousPanel === undefined ? null : _react.createElement((0, _buttons.Button), {
        "aria-label": "Back",
        className: (0, _common.Classes).PANEL_STACK2_HEADER_BACK,
        icon: "chevron-left",
        minimal: true,
        onClick: handleClose,
        small: true,
        text: previousPanel.title,
        title: previousPanel.htmlTitle
    });
    // `panel.renderPanel` is simply a function that returns a React.JSX.Element. It may be an FC which
    // uses hooks. In order to avoid React errors due to inconsistent hook calls, we must encapsulate
    // those hooks with their own lifecycle through a very simple wrapper component.
    var PanelWrapper = _react.useMemo(function() {
        return function() {
            // N.B. A type cast is required because of error TS2345, where technically `panel.props` could be
            // instantiated with a type unrelated to our generic constraint `T` here. We know
            // we're sending the right values here though, and it makes the consumer API for this
            // component type safe, so it's ok to do this...
            return panel.renderPanel((0, _tslib.__assign)({
                closePanel: handleClose,
                openPanel: onOpen
            }, panel.props));
        };
    }, [
        panel,
        handleClose,
        onOpen
    ]);
    return _react.createElement("div", {
        className: (0, _common.Classes).PANEL_STACK2_VIEW
    }, showHeader && _react.createElement("div", {
        className: (0, _common.Classes).PANEL_STACK2_HEADER
    }, _react.createElement("span", null, maybeBackButton), _react.createElement((0, _text.Text), {
        className: (0, _common.Classes).HEADING,
        ellipsize: true,
        title: panel.htmlTitle
    }, panel.title), _react.createElement("span", null)), _react.createElement(PanelWrapper, null));
};
PanelView2.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".PanelView2");

},{"tslib":"b4wpY","react":"9njXz","../../common":"3QDnh","../button/buttons":"glm43","../text/text":"cIHFN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4x8hV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Specifies the popup kind for [aria-haspopup](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-haspopup).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopupKind", ()=>PopupKind);
var PopupKind;
(function(PopupKind) {
    /** The popup is a menu. */ PopupKind["MENU"] = "menu";
    /** The popup is a listbox. */ PopupKind["LISTBOX"] = "listbox";
    /** The popup is a tree. */ PopupKind["TREE"] = "tree";
    /** The popup is a grid. */ PopupKind["GRID"] = "grid";
    /** The popup is a dialog. */ PopupKind["DIALOG"] = "dialog";
})(PopupKind || (PopupKind = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3yhOK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBar", ()=>ProgressBar);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _utils = require("../../common/utils");
/**
 * Progress bar component.
 *
 * @see https://blueprintjs.com/docs/#core/components/progress-bar
 */ var ProgressBar = /** @class */ function(_super) {
    (0, _tslib.__extends)(ProgressBar, _super);
    function ProgressBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProgressBar.prototype.render = function() {
        var _a;
        var _b = this.props, _c = _b.animate, animate = _c === void 0 ? true : _c, className = _b.className, intent = _b.intent, _d = _b.stripes, stripes = _d === void 0 ? true : _d, value = _b.value;
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).PROGRESS_BAR, (0, _common.Classes).intentClass(intent), (_a = {}, _a[(0, _common.Classes).PROGRESS_NO_ANIMATION] = !animate, _a[(0, _common.Classes).PROGRESS_NO_STRIPES] = !stripes, _a), className);
        var percent = value == null ? undefined : 100 * (0, _utils.clamp)(value, 0, 1);
        // don't set width if value is null (rely on default CSS value)
        var width = percent == null ? undefined : percent + "%";
        return _react.createElement("div", {
            "aria-valuemax": 100,
            "aria-valuemin": 0,
            "aria-valuenow": percent == null ? undefined : Math.round(percent),
            className: classes,
            role: "progressbar"
        }, _react.createElement("div", {
            className: (0, _common.Classes).PROGRESS_METER,
            style: {
                width: width
            }
        }));
    };
    ProgressBar.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".ProgressBar");
    return ProgressBar;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","../../common/utils":"56UdR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7HHpG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HandleType", ()=>HandleType);
parcelHelpers.export(exports, "HandleInteractionKind", ()=>HandleInteractionKind);
var HandleType = {
    /** A full handle appears as a small square. */ FULL: "full",
    /** A start handle appears as the left or top half of a square. */ START: "start",
    /** An end handle appears as the right or bottom half of a square. */ END: "end"
};
var HandleInteractionKind = {
    /** Locked handles prevent other handles from being dragged past then. */ LOCK: "lock",
    /** Push handles move overlapping handles with them as they are dragged. */ PUSH: "push",
    /**
     * Handles marked "none" are not interactive and do not appear in the UI.
     * They serve only to break the track into subsections that can be colored separately.
     */ NONE: "none"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"363Ok":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiSlider", ()=>MultiSlider);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _handle = require("./handle");
var _handleProps = require("./handleProps");
var _sliderUtils = require("./sliderUtils");
/**
 * SFC used to pass slider handle props to a `MultiSlider`.
 * This element is not rendered directly.
 */ var MultiSliderHandle = function() {
    return null;
};
MultiSliderHandle.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".MultiSliderHandle");
/**
 * Multi slider component.
 *
 * @see https://blueprintjs.com/docs/#core/components/sliders.multi-slider
 */ var MultiSlider = /** @class */ function(_super) {
    (0, _tslib.__extends)(MultiSlider, _super);
    function MultiSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            labelPrecision: getLabelPrecision(_this.props),
            tickSize: 0,
            tickSizeRatio: 0
        };
        _this.handleElements = [];
        _this.trackElement = null;
        _this.addHandleRef = function(ref) {
            if (ref != null) _this.handleElements.push(ref);
        };
        _this.maybeHandleTrackClick = function(event) {
            if (_this.canHandleTrackEvent(event)) {
                var foundHandle = _this.nearestHandleForValue(_this.handleElements, function(handle) {
                    return handle.mouseEventClientOffset(event);
                });
                if (foundHandle) foundHandle.beginHandleMovement(event);
            }
        };
        _this.maybeHandleTrackTouch = function(event) {
            if (_this.canHandleTrackEvent(event)) {
                var foundHandle = _this.nearestHandleForValue(_this.handleElements, function(handle) {
                    return handle.touchEventClientOffset(event);
                });
                if (foundHandle) foundHandle.beginHandleTouchMovement(event);
            }
        };
        _this.canHandleTrackEvent = function(event) {
            var target = event.target;
            // ensure event does not come from inside the handle
            return !_this.props.disabled && target.closest(".".concat((0, _common.Classes).SLIDER_HANDLE)) == null;
        };
        _this.getHandlerForIndex = function(index, callback) {
            return function(newValue) {
                callback === null || callback === void 0 || callback(_this.getNewHandleValues(newValue, index));
            };
        };
        _this.handleChange = function(newValues) {
            var _a, _b;
            var handleProps = getSortedInteractiveHandleProps(_this.props);
            var oldValues = handleProps.map(function(handle) {
                return handle.value;
            });
            if (!(0, _common.Utils).arraysEqual(newValues, oldValues)) {
                (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, newValues);
                handleProps.forEach(function(handle, index) {
                    var _a;
                    if (oldValues[index] !== newValues[index]) (_a = handle.onChange) === null || _a === void 0 || _a.call(handle, newValues[index]);
                });
            }
        };
        _this.handleRelease = function(newValues) {
            var _a, _b;
            var handleProps = getSortedInteractiveHandleProps(_this.props);
            (_b = (_a = _this.props).onRelease) === null || _b === void 0 || _b.call(_a, newValues);
            handleProps.forEach(function(handle, index) {
                var _a;
                (_a = handle.onRelease) === null || _a === void 0 || _a.call(handle, newValues[index]);
            });
        };
        return _this;
    }
    MultiSlider.getDerivedStateFromProps = function(props) {
        return {
            labelPrecision: MultiSlider.getLabelPrecision(props)
        };
    };
    MultiSlider.getLabelPrecision = function(_a) {
        var labelPrecision = _a.labelPrecision, stepSize = _a.stepSize;
        // infer default label precision from stepSize because that's how much the handle moves.
        return labelPrecision == null ? (0, _common.Utils).countDecimalPlaces(stepSize) : labelPrecision;
    };
    MultiSlider.prototype.getSnapshotBeforeUpdate = function(prevProps) {
        var prevHandleProps = getSortedInteractiveHandleProps(prevProps);
        var newHandleProps = getSortedInteractiveHandleProps(this.props);
        if (newHandleProps.length !== prevHandleProps.length) // clear refs
        this.handleElements = [];
        return null;
    };
    MultiSlider.prototype.render = function() {
        var _a;
        var _this = this;
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).SLIDER, (_a = {}, _a[(0, _common.Classes).DISABLED] = this.props.disabled, _a["".concat((0, _common.Classes).SLIDER, "-unlabeled")] = this.props.labelRenderer === false, _a[(0, _common.Classes).VERTICAL] = this.props.vertical, _a), this.props.className);
        return _react.createElement("div", {
            className: classes,
            onMouseDown: this.maybeHandleTrackClick,
            onTouchStart: this.maybeHandleTrackTouch
        }, _react.createElement("div", {
            className: (0, _common.Classes).SLIDER_TRACK,
            ref: function(ref) {
                return _this.trackElement = ref;
            }
        }, this.renderTracks()), _react.createElement("div", {
            className: (0, _common.Classes).SLIDER_AXIS
        }, this.renderLabels()), this.renderHandles());
    };
    MultiSlider.prototype.componentDidMount = function() {
        this.updateTickSize();
    };
    MultiSlider.prototype.componentDidUpdate = function(prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.updateTickSize();
    };
    MultiSlider.prototype.validateProps = function(props) {
        if (props.stepSize <= 0) throw new Error(_errors.SLIDER_ZERO_STEP);
        if (props.labelStepSize !== undefined && props.labelValues !== undefined) throw new Error(_errors.MULTISLIDER_WARN_LABEL_STEP_SIZE_LABEL_VALUES_MUTEX);
        if (props.labelStepSize !== undefined && props.labelStepSize <= 0) throw new Error(_errors.SLIDER_ZERO_LABEL_STEP);
        if (props.min !== undefined && !isFinite(props.min)) throw new Error(_errors.SLIDER_MIN);
        if (props.max !== undefined && !isFinite(props.max)) throw new Error(_errors.SLIDER_MAX);
        var anyInvalidChildren = false;
        _react.Children.forEach(props.children, function(child) {
            // allow boolean coercion to omit nulls and false values
            if (child && !(0, _common.Utils).isElementOfType(child, MultiSlider.Handle)) anyInvalidChildren = true;
        });
        if (anyInvalidChildren) throw new Error(_errors.MULTISLIDER_INVALID_CHILD);
    };
    MultiSlider.prototype.formatLabel = function(value, isHandleTooltip) {
        if (isHandleTooltip === void 0) isHandleTooltip = false;
        var labelRenderer = this.props.labelRenderer;
        if (labelRenderer === false) return undefined;
        else if ((0, _common.Utils).isFunction(labelRenderer)) return labelRenderer(value, {
            isHandleTooltip: isHandleTooltip
        });
        else return value.toFixed(this.state.labelPrecision);
    };
    MultiSlider.prototype.renderLabels = function() {
        var _this = this;
        if (this.props.labelRenderer === false) return null;
        var values = this.getLabelValues();
        var _a = this.props, max = _a.max, min = _a.min;
        var labels = values.map(function(step, i) {
            var offsetPercentage = (0, _sliderUtils.formatPercentage)((step - min) / (max - min));
            var style = _this.props.vertical ? {
                bottom: offsetPercentage
            } : {
                left: offsetPercentage
            };
            return _react.createElement("div", {
                className: (0, _common.Classes).SLIDER_LABEL,
                key: i,
                style: style
            }, _this.formatLabel(step));
        });
        return labels;
    };
    MultiSlider.prototype.renderTracks = function() {
        var trackStops = getSortedHandleProps(this.props);
        trackStops.push({
            value: this.props.max
        });
        // render from current to previous, then increment previous
        var previous = {
            value: this.props.min
        };
        var handles = [];
        for(var index = 0; index < trackStops.length; index++){
            var current = trackStops[index];
            handles.push(this.renderTrackFill(index, previous, current));
            previous = current;
        }
        return handles;
    };
    MultiSlider.prototype.renderTrackFill = function(index, start, end) {
        // ensure startRatio <= endRatio
        var _a = [
            this.getOffsetRatio(start.value),
            this.getOffsetRatio(end.value)
        ].sort(function(left, right) {
            return left - right;
        }), startRatio = _a[0], endRatio = _a[1];
        var startOffset = (0, _sliderUtils.formatPercentage)(startRatio);
        var endOffset = (0, _sliderUtils.formatPercentage)(1 - endRatio);
        var orientationStyle = this.props.vertical ? {
            bottom: startOffset,
            top: endOffset,
            left: 0
        } : {
            left: startOffset,
            right: endOffset,
            top: 0
        };
        var style = (0, _tslib.__assign)((0, _tslib.__assign)({}, orientationStyle), start.trackStyleAfter || end.trackStyleBefore || {});
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).SLIDER_PROGRESS, (0, _common.Classes).intentClass(this.getTrackIntent(start, end)));
        return _react.createElement("div", {
            key: "track-".concat(index),
            className: classes,
            style: style
        });
    };
    MultiSlider.prototype.renderHandles = function() {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, max = _a.max, min = _a.min, stepSize = _a.stepSize, vertical = _a.vertical;
        var handleProps = getSortedInteractiveHandleProps(this.props);
        if (handleProps.length === 0) return null;
        return handleProps.map(function(_a, index) {
            var _b;
            var value = _a.value, type = _a.type, className = _a.className, htmlProps = _a.htmlProps;
            return _react.createElement((0, _handle.Handle), {
                htmlProps: htmlProps,
                className: (0, _classnamesDefault.default)((_b = {}, _b[(0, _common.Classes).START] = type === (0, _handleProps.HandleType).START, _b[(0, _common.Classes).END] = type === (0, _handleProps.HandleType).END, _b), className),
                disabled: disabled,
                key: "".concat(index, "-").concat(handleProps.length),
                label: _this.formatLabel(value, true),
                max: max,
                min: min,
                onChange: _this.getHandlerForIndex(index, _this.handleChange),
                onRelease: _this.getHandlerForIndex(index, _this.handleRelease),
                ref: _this.addHandleRef,
                stepSize: stepSize,
                tickSize: _this.state.tickSize,
                tickSizeRatio: _this.state.tickSizeRatio,
                value: value,
                vertical: vertical
            });
        });
    };
    MultiSlider.prototype.nearestHandleForValue = function(handles, getOffset) {
        return (0, _sliderUtils.argMin)(handles, function(handle) {
            var offset = getOffset(handle);
            var offsetValue = handle.clientToValue(offset);
            var handleValue = handle.props.value;
            return Math.abs(offsetValue - handleValue);
        });
    };
    MultiSlider.prototype.getNewHandleValues = function(newValue, oldIndex) {
        var handleProps = getSortedInteractiveHandleProps(this.props);
        var oldValues = handleProps.map(function(handle) {
            return handle.value;
        });
        var newValues = oldValues.slice();
        newValues[oldIndex] = newValue;
        newValues.sort(function(left, right) {
            return left - right;
        });
        var newIndex = newValues.indexOf(newValue);
        var lockIndex = this.findFirstLockedHandleIndex(oldIndex, newIndex);
        if (lockIndex === -1) (0, _sliderUtils.fillValues)(newValues, oldIndex, newIndex, newValue);
        else {
            // If pushing past a locked handle, discard the new value and only make the updates to clamp values against the lock.
            var lockValue = oldValues[lockIndex];
            (0, _sliderUtils.fillValues)(oldValues, oldIndex, lockIndex, lockValue);
            return oldValues;
        }
        return newValues;
    };
    MultiSlider.prototype.findFirstLockedHandleIndex = function(startIndex, endIndex) {
        var inc = startIndex < endIndex ? 1 : -1;
        var handleProps = getSortedInteractiveHandleProps(this.props);
        for(var index = startIndex + inc; index !== endIndex + inc; index += inc){
            if (handleProps[index].interactionKind !== (0, _handleProps.HandleInteractionKind).PUSH) return index;
        }
        return -1;
    };
    MultiSlider.prototype.getLabelValues = function() {
        var _a = this.props, labelStepSize = _a.labelStepSize, labelValues = _a.labelValues, min = _a.min, max = _a.max;
        var values = [];
        if (labelValues !== undefined) values = labelValues.slice();
        else for(var i = min; i < max || (0, _common.Utils).approxEqual(i, max); i += labelStepSize !== null && labelStepSize !== void 0 ? labelStepSize : 1)values.push(i);
        return values;
    };
    MultiSlider.prototype.getOffsetRatio = function(value) {
        return (0, _common.Utils).clamp((value - this.props.min) * this.state.tickSizeRatio, 0, 1);
    };
    MultiSlider.prototype.getTrackIntent = function(start, end) {
        if (!this.props.showTrackFill) return (0, _common.Intent).NONE;
        if (start.intentAfter !== undefined) return start.intentAfter;
        else if (end !== undefined && end.intentBefore !== undefined) return end.intentBefore;
        return this.props.defaultTrackIntent;
    };
    MultiSlider.prototype.updateTickSize = function() {
        if (this.trackElement != null) {
            var trackSize = this.props.vertical ? this.trackElement.clientHeight : this.trackElement.clientWidth;
            var tickSizeRatio = 1 / (this.props.max - this.props.min);
            var tickSize = trackSize * tickSizeRatio;
            this.setState({
                tickSize: tickSize,
                tickSizeRatio: tickSizeRatio
            });
        }
    };
    MultiSlider.defaultSliderProps = {
        disabled: false,
        max: 10,
        min: 0,
        showTrackFill: true,
        stepSize: 1,
        vertical: false
    };
    MultiSlider.defaultProps = (0, _tslib.__assign)((0, _tslib.__assign)({}, MultiSlider.defaultSliderProps), {
        defaultTrackIntent: (0, _common.Intent).NONE
    });
    MultiSlider.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".MultiSlider");
    MultiSlider.Handle = MultiSliderHandle;
    return MultiSlider;
}((0, _common.AbstractPureComponent));
function getLabelPrecision(_a) {
    var labelPrecision = _a.labelPrecision, _b = _a.stepSize, stepSize = _b === void 0 ? MultiSlider.defaultSliderProps.stepSize : _b;
    // infer default label precision from stepSize because that's how much the handle moves.
    return labelPrecision == null ? (0, _common.Utils).countDecimalPlaces(stepSize) : labelPrecision;
}
function getSortedInteractiveHandleProps(props) {
    return getSortedHandleProps(props, function(childProps) {
        return childProps.interactionKind !== (0, _handleProps.HandleInteractionKind).NONE;
    });
}
function getSortedHandleProps(_a, predicate) {
    var children = _a.children;
    if (predicate === void 0) predicate = function() {
        return true;
    };
    var maybeHandles = _react.Children.map(children, function(child) {
        return (0, _common.Utils).isElementOfType(child, MultiSlider.Handle) && predicate(child.props) ? child.props : null;
    });
    var handles = maybeHandles != null ? maybeHandles : [];
    handles = handles.filter(function(handle) {
        return handle !== null;
    });
    handles.sort(function(left, right) {
        return left.value - right.value;
    });
    return handles;
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/errors":"lyD8m","./handle":"WymdN","./handleProps":"7HHpG","./sliderUtils":"ix8ok","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"WymdN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Handle", ()=>Handle);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _sliderUtils = require("./sliderUtils");
// props that require number values, for validation
var NUMBER_PROPS = [
    "max",
    "min",
    "stepSize",
    "tickSize",
    "value"
];
/** Internal component for a Handle with click/drag/keyboard logic to determine a new value. */ var Handle = /** @class */ function(_super) {
    (0, _tslib.__extends)(Handle, _super);
    function Handle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isMoving: false
        };
        _this.handleElement = null;
        _this.refHandlers = {
            handle: function(el) {
                return _this.handleElement = el;
            }
        };
        _this.beginHandleMovement = function(event) {
            document.addEventListener("mousemove", _this.handleHandleMovement);
            document.addEventListener("mouseup", _this.endHandleMovement);
            _this.setState({
                isMoving: true
            });
            _this.changeValue(_this.clientToValue(_this.mouseEventClientOffset(event)));
        };
        _this.beginHandleTouchMovement = function(event) {
            document.addEventListener("touchmove", _this.handleHandleTouchMovement);
            document.addEventListener("touchend", _this.endHandleTouchMovement);
            document.addEventListener("touchcancel", _this.endHandleTouchMovement);
            _this.setState({
                isMoving: true
            });
            _this.changeValue(_this.clientToValue(_this.touchEventClientOffset(event)));
        };
        _this.getStyleProperties = function() {
            if (_this.handleElement == null) return {};
            // The handle midpoint of RangeSlider is actually shifted by a margin to
            // be on the edge of the visible handle element. Because the midpoint
            // calculation does not take this margin into account, we instead
            // measure the long side (which is equal to the short side plus the
            // margin).
            var _a = _this.props, _b = _a.min, min = _b === void 0 ? 0 : _b, tickSizeRatio = _a.tickSizeRatio, value = _a.value, vertical = _a.vertical;
            var handleMidpoint = _this.getHandleMidpointAndOffset(_this.handleElement, true).handleMidpoint;
            var offsetRatio = (value - min) * tickSizeRatio;
            var offsetCalc = "calc(".concat((0, _sliderUtils.formatPercentage)(offsetRatio), " - ").concat(handleMidpoint, "px)");
            return vertical ? {
                bottom: offsetCalc
            } : {
                left: offsetCalc
            };
        };
        _this.endHandleMovement = function(event) {
            _this.handleMoveEndedAt(_this.mouseEventClientOffset(event));
        };
        _this.endHandleTouchMovement = function(event) {
            _this.handleMoveEndedAt(_this.touchEventClientOffset(event));
        };
        _this.handleMoveEndedAt = function(clientPixel) {
            var _a, _b;
            _this.removeDocumentEventListeners();
            _this.setState({
                isMoving: false
            });
            // always invoke onRelease; changeValue may call onChange if value is different
            var finalValue = _this.changeValue(_this.clientToValue(clientPixel));
            (_b = (_a = _this.props).onRelease) === null || _b === void 0 || _b.call(_a, finalValue);
        };
        _this.handleHandleMovement = function(event) {
            _this.handleMovedTo(_this.mouseEventClientOffset(event));
        };
        _this.handleHandleTouchMovement = function(event) {
            _this.handleMovedTo(_this.touchEventClientOffset(event));
        };
        _this.handleMovedTo = function(clientPixel) {
            if (_this.state.isMoving && !_this.props.disabled) _this.changeValue(_this.clientToValue(clientPixel));
        };
        _this.handleKeyDown = function(event) {
            var _a = _this.props, stepSize = _a.stepSize, value = _a.value;
            var direction = (0, _common.Utils).getArrowKeyDirection(event, [
                "ArrowLeft",
                "ArrowDown"
            ], [
                "ArrowRight",
                "ArrowUp"
            ]);
            if (direction !== undefined) {
                _this.changeValue(value + stepSize * direction);
                // this key event has been handled! prevent browser scroll on up/down
                event.preventDefault();
            }
        };
        _this.handleKeyUp = function(event) {
            var _a, _b;
            if ((0, _common.Utils).isArrowKey(event)) (_b = (_a = _this.props).onRelease) === null || _b === void 0 || _b.call(_a, _this.props.value);
        };
        return _this;
    }
    Handle.prototype.componentDidMount = function() {
        // The first time this component renders, it has no ref to the handle and thus incorrectly centers the handle.
        // Therefore, on the first mount, force a re-render to center the handle with the ref'd component.
        this.forceUpdate();
    };
    Handle.prototype.render = function() {
        var _a;
        var _b = this.props, className = _b.className, disabled = _b.disabled, label = _b.label, min = _b.min, max = _b.max, value = _b.value, vertical = _b.vertical, htmlProps = _b.htmlProps;
        var isMoving = this.state.isMoving;
        return _react.createElement("span", (0, _tslib.__assign)({
            role: "slider",
            tabIndex: 0
        }, htmlProps, {
            className: (0, _classnamesDefault.default)((0, _common.Classes).SLIDER_HANDLE, (_a = {}, _a[(0, _common.Classes).ACTIVE] = isMoving, _a), className),
            onKeyDown: disabled ? undefined : this.handleKeyDown,
            onKeyUp: disabled ? undefined : this.handleKeyUp,
            onMouseDown: disabled ? undefined : this.beginHandleMovement,
            onTouchStart: disabled ? undefined : this.beginHandleTouchMovement,
            ref: this.refHandlers.handle,
            style: this.getStyleProperties(),
            "aria-valuemin": min,
            "aria-valuemax": max,
            "aria-valuenow": value,
            "aria-disabled": disabled,
            "aria-orientation": vertical ? "vertical" : "horizontal"
        }), label == null ? null : _react.createElement("span", {
            className: (0, _common.Classes).SLIDER_LABEL
        }, label));
    };
    Handle.prototype.componentWillUnmount = function() {
        this.removeDocumentEventListeners();
    };
    /** Convert client pixel to value between min and max. */ Handle.prototype.clientToValue = function(clientPixel) {
        var _a = this.props, stepSize = _a.stepSize, tickSize = _a.tickSize, value = _a.value, vertical = _a.vertical;
        if (this.handleElement == null) return value;
        // #1769: this logic doesn't work perfectly when the tick size is
        // smaller than the handle size; it may be off by a tick or two.
        var clientPixelNormalized = vertical ? window.innerHeight - clientPixel : clientPixel;
        var handleCenterPixel = this.getHandleElementCenterPixel(this.handleElement);
        var pixelDelta = clientPixelNormalized - handleCenterPixel;
        if (isNaN(pixelDelta)) return value;
        // convert pixels to range value in increments of `stepSize`
        return value + Math.round(pixelDelta / (tickSize * stepSize)) * stepSize;
    };
    Handle.prototype.mouseEventClientOffset = function(event) {
        return this.props.vertical ? event.clientY : event.clientX;
    };
    Handle.prototype.touchEventClientOffset = function(event) {
        var touch = event.changedTouches[0];
        return this.props.vertical ? touch.clientY : touch.clientX;
    };
    Handle.prototype.validateProps = function(props) {
        for(var _i = 0, NUMBER_PROPS_1 = NUMBER_PROPS; _i < NUMBER_PROPS_1.length; _i++){
            var prop = NUMBER_PROPS_1[_i];
            if (typeof props[prop] !== "number") throw new Error("[Blueprint] <Handle> requires number value for ".concat(prop, " prop"));
        }
    };
    /** Clamp value and invoke callback if it differs from current value */ Handle.prototype.changeValue = function(newValue, callback) {
        if (callback === void 0) callback = this.props.onChange;
        newValue = this.clamp(newValue);
        if (!isNaN(newValue) && this.props.value !== newValue) callback === null || callback === void 0 || callback(newValue);
        return newValue;
    };
    /** Clamp value between min and max props */ Handle.prototype.clamp = function(value) {
        return (0, _common.Utils).clamp(value, this.props.min, this.props.max);
    };
    Handle.prototype.getHandleElementCenterPixel = function(handleElement) {
        var _a = this.getHandleMidpointAndOffset(handleElement), handleMidpoint = _a.handleMidpoint, handleOffset = _a.handleOffset;
        return handleOffset + handleMidpoint;
    };
    Handle.prototype.getHandleMidpointAndOffset = function(handleElement, useOppositeDimension) {
        if (useOppositeDimension === void 0) useOppositeDimension = false;
        if (handleElement == null) return {
            handleMidpoint: 0,
            handleOffset: 0
        };
        var vertical = this.props.vertical;
        // N.B. element.clientHeight does not include border size.
        // Also, element.getBoundingClientRect() is useful to get the top & left position on the page, but
        // it fails to accurately measure element width & height inside absolutely-positioned and CSS-transformed
        // containers like Popovers, so we use element.offsetWidth & offsetHeight instead (see https://github.com/palantir/blueprint/issues/4417).
        var handleRect = handleElement.getBoundingClientRect();
        handleRect.width = handleElement.offsetWidth;
        handleRect.height = handleElement.offsetHeight;
        var sizeKey = vertical ? useOppositeDimension ? "width" : "height" : useOppositeDimension ? "height" : "width";
        // "bottom" value seems to be consistently incorrect, so explicitly
        // calculate it using the window offset instead.
        var handleOffset = vertical ? window.innerHeight - (handleRect.top + handleRect[sizeKey]) : handleRect.left;
        return {
            handleMidpoint: handleRect[sizeKey] / 2,
            handleOffset: handleOffset
        };
    };
    Handle.prototype.removeDocumentEventListeners = function() {
        document.removeEventListener("mousemove", this.handleHandleMovement);
        document.removeEventListener("mouseup", this.endHandleMovement);
        document.removeEventListener("touchmove", this.handleHandleTouchMovement);
        document.removeEventListener("touchend", this.endHandleTouchMovement);
        document.removeEventListener("touchcancel", this.endHandleTouchMovement);
    };
    Handle.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".SliderHandle");
    return Handle;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","./sliderUtils":"ix8ok","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ix8ok":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Helper function for formatting ratios as CSS percentage values. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatPercentage", ()=>formatPercentage);
/**
 * Mutates the values array by filling all the values between start and end index (inclusive) with the fill value.
 */ parcelHelpers.export(exports, "fillValues", ()=>fillValues);
/**
 * Returns the minimum element of an array as determined by comparing the results of calling the arg function on each
 * element of the array. The function will only be called once per element.
 */ parcelHelpers.export(exports, "argMin", ()=>argMin);
function formatPercentage(ratio) {
    return "".concat((ratio * 100).toFixed(2), "%");
}
function fillValues(values, startIndex, endIndex, fillValue) {
    var inc = startIndex < endIndex ? 1 : -1;
    for(var index = startIndex; index !== endIndex + inc; index += inc)values[index] = fillValue;
}
function argMin(values, argFn) {
    if (values.length === 0) return undefined;
    var minValue = values[0];
    var minArg = argFn(minValue);
    for(var index = 1; index < values.length; index++){
        var value = values[index];
        var arg = argFn(value);
        if (arg < minArg) {
            minValue = value;
            minArg = arg;
        }
    }
    return minValue;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c4Wuy":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeSlider", ()=>RangeSlider);
var _tslib = require("tslib");
var _react = require("react");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _multiSlider = require("./multiSlider");
var RangeIndex;
(function(RangeIndex) {
    RangeIndex[RangeIndex["START"] = 0] = "START";
    RangeIndex[RangeIndex["END"] = 1] = "END";
})(RangeIndex || (RangeIndex = {}));
/**
 * Range slider component.
 *
 * @see https://blueprintjs.com/docs/#core/components/sliders.range-slider
 */ var RangeSlider = /** @class */ function(_super) {
    (0, _tslib.__extends)(RangeSlider, _super);
    function RangeSlider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RangeSlider.prototype.render = function() {
        var _a = this.props, value = _a.value, handleHtmlProps = _a.handleHtmlProps, props = (0, _tslib.__rest)(_a, [
            "value",
            "handleHtmlProps"
        ]);
        return _react.createElement((0, _multiSlider.MultiSlider), (0, _tslib.__assign)({}, props), _react.createElement((0, _multiSlider.MultiSlider).Handle, {
            value: value[RangeIndex.START],
            type: "start",
            intentAfter: props.intent,
            htmlProps: handleHtmlProps === null || handleHtmlProps === void 0 ? void 0 : handleHtmlProps.start
        }), _react.createElement((0, _multiSlider.MultiSlider).Handle, {
            value: value[RangeIndex.END],
            type: "end",
            htmlProps: handleHtmlProps === null || handleHtmlProps === void 0 ? void 0 : handleHtmlProps.end
        }));
    };
    RangeSlider.prototype.validateProps = function(props) {
        var value = props.value;
        if (value == null || value[RangeIndex.START] == null || value[RangeIndex.END] == null) throw new Error(_errors.RANGESLIDER_NULL_VALUE);
    };
    RangeSlider.defaultProps = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _multiSlider.MultiSlider).defaultSliderProps), {
        intent: (0, _common.Intent).PRIMARY,
        value: [
            0,
            10
        ]
    });
    RangeSlider.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".RangeSlider");
    return RangeSlider;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","react":"9njXz","../../common":"3QDnh","../../common/errors":"lyD8m","./multiSlider":"363Ok","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"capO4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", ()=>Section);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _props = require("../../common/props");
var _utils = require("../../common/utils");
var _card = require("../card/card");
var _collapse = require("../collapse/collapse");
var _html = require("../html/html");
var _icon = require("../icon/icon");
var Section = _react.forwardRef(function(props, ref) {
    var _a, _b;
    var _c;
    var children = props.children, className = props.className, collapseProps = props.collapseProps, collapsible = props.collapsible, compact = props.compact, elevation = props.elevation, icon = props.icon, rightElement = props.rightElement, subtitle = props.subtitle, title = props.title, _d = props.titleRenderer, titleRenderer = _d === void 0 ? (0, _html.H6) : _d, htmlProps = (0, _tslib.__rest)(props, [
        "children",
        "className",
        "collapseProps",
        "collapsible",
        "compact",
        "elevation",
        "icon",
        "rightElement",
        "subtitle",
        "title",
        "titleRenderer"
    ]);
    // Determine whether to use controlled or uncontrolled state.
    var isControlled = (collapseProps === null || collapseProps === void 0 ? void 0 : collapseProps.isOpen) != null;
    // The initial useState value is negated in order to conform to the `isCollapsed` expectation.
    var _e = _react.useState(!((_c = collapseProps === null || collapseProps === void 0 ? void 0 : collapseProps.defaultIsOpen) !== null && _c !== void 0 ? _c : true)), isCollapsedUncontrolled = _e[0], setIsCollapsed = _e[1];
    var isCollapsed = isControlled ? !(collapseProps === null || collapseProps === void 0 ? void 0 : collapseProps.isOpen) : isCollapsedUncontrolled;
    var toggleIsCollapsed = _react.useCallback(function() {
        var _a;
        if (isControlled) (_a = collapseProps === null || collapseProps === void 0 ? void 0 : collapseProps.onToggle) === null || _a === void 0 || _a.call(collapseProps);
        else setIsCollapsed(!isCollapsed);
    }, [
        collapseProps,
        isCollapsed,
        isControlled
    ]);
    var isHeaderRightContainerVisible = rightElement != null || collapsible;
    var sectionId = (0, _utils.uniqueId)("section");
    var sectionTitleId = title ? (0, _utils.uniqueId)("section-title") : undefined;
    return _react.createElement((0, _card.Card), (0, _tslib.__assign)({
        className: (0, _classnamesDefault.default)(className, (0, _common.Classes).SECTION, (_a = {}, _a[(0, _common.Classes).COMPACT] = compact, _a[(0, _common.Classes).SECTION_COLLAPSED] = collapsible && isCollapsed || (0, _common.Utils).isReactNodeEmpty(children), _a)),
        elevation: elevation,
        ref: ref,
        "aria-labelledby": sectionTitleId
    }, htmlProps, {
        id: sectionId
    }), title && _react.createElement("div", {
        role: collapsible ? "button" : undefined,
        "aria-pressed": collapsible ? isCollapsed : undefined,
        "aria-expanded": collapsible ? isCollapsed : undefined,
        "aria-controls": collapsible ? sectionId : undefined,
        className: (0, _classnamesDefault.default)((0, _common.Classes).SECTION_HEADER, (_b = {}, _b[(0, _common.Classes).INTERACTIVE] = collapsible, _b)),
        onClick: collapsible ? toggleIsCollapsed : undefined
    }, _react.createElement("div", {
        className: (0, _common.Classes).SECTION_HEADER_LEFT
    }, icon && _react.createElement((0, _icon.Icon), {
        icon: icon,
        "aria-hidden": true,
        tabIndex: -1,
        className: (0, _common.Classes).TEXT_MUTED
    }), _react.createElement("div", null, _react.createElement(titleRenderer, {
        className: (0, _common.Classes).SECTION_HEADER_TITLE,
        id: sectionTitleId
    }, title), subtitle && _react.createElement("div", {
        className: (0, _classnamesDefault.default)((0, _common.Classes).TEXT_MUTED, (0, _common.Classes).SECTION_HEADER_SUB_TITLE)
    }, subtitle))), isHeaderRightContainerVisible && _react.createElement("div", {
        className: (0, _common.Classes).SECTION_HEADER_RIGHT
    }, rightElement, collapsible && (isCollapsed ? _react.createElement((0, _icons.ChevronDown), {
        className: (0, _common.Classes).TEXT_MUTED
    }) : _react.createElement((0, _icons.ChevronUp), {
        className: (0, _common.Classes).TEXT_MUTED
    })))), collapsible ? _react.createElement((0, _collapse.Collapse), (0, _tslib.__assign)({}, collapseProps, {
        isOpen: !isCollapsed
    }), children) : children);
});
Section.defaultProps = {
    compact: false,
    elevation: (0, _common.Elevation).ZERO
};
Section.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Section");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../../common/props":"dBcIV","../../common/utils":"56UdR","../card/card":"3tOjJ","../collapse/collapse":"6TvyY","../html/html":"6epty","../icon/icon":"duMtK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6Ou6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionCard", ()=>SectionCard);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var SectionCard = _react.forwardRef(function(props, ref) {
    var _a;
    var className = props.className, children = props.children, padded = props.padded, htmlProps = (0, _tslib.__rest)(props, [
        "className",
        "children",
        "padded"
    ]);
    var classes = (0, _classnamesDefault.default)((0, _common.Classes).SECTION_CARD, (_a = {}, _a[(0, _common.Classes).PADDED] = padded, _a), className);
    return _react.createElement("div", (0, _tslib.__assign)({
        className: classes,
        ref: ref
    }, htmlProps), children);
});
SectionCard.defaultProps = {
    padded: true
};
SectionCard.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".SectionCard");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6qurk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SegmentedControl", ()=>SegmentedControl);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _buttons = require("../button/buttons");
var SegmentedControl = _react.forwardRef(function(props, ref) {
    var _a;
    var className = props.className, defaultValue = props.defaultValue, fill = props.fill, inline = props.inline, intent = props.intent, large = props.large, onValueChange = props.onValueChange, options = props.options, _b = props.role, role = _b === void 0 ? "radiogroup" : _b, small = props.small, controlledValue = props.value, htmlProps = (0, _tslib.__rest)(props, [
        "className",
        "defaultValue",
        "fill",
        "inline",
        "intent",
        "large",
        "onValueChange",
        "options",
        "role",
        "small",
        "value"
    ]);
    var _c = _react.useState(defaultValue), localValue = _c[0], setLocalValue = _c[1];
    var selectedValue = controlledValue !== null && controlledValue !== void 0 ? controlledValue : localValue;
    var outerRef = _react.useRef(null);
    var handleOptionClick = _react.useCallback(function(newSelectedValue, targetElement) {
        setLocalValue(newSelectedValue);
        onValueChange === null || onValueChange === void 0 || onValueChange(newSelectedValue, targetElement);
    }, [
        onValueChange
    ]);
    var handleKeyDown = _react.useCallback(function(e) {
        var _a;
        if (role === "radiogroup") {
            // in a `radiogroup`, arrow keys select next item, not tab key.
            var direction = (0, _common.Utils).getArrowKeyDirection(e, [
                "ArrowLeft",
                "ArrowUp"
            ], [
                "ArrowRight",
                "ArrowDown"
            ]);
            var outerElement = outerRef.current;
            if (direction === undefined || !outerElement) return;
            var focusedElement = (_a = (0, _common.Utils).getActiveElement(outerElement)) === null || _a === void 0 ? void 0 : _a.closest("button");
            if (!focusedElement) return;
            // must rely on DOM state because we have no way of mapping `focusedElement` to a React.JSX.Element
            var enabledOptionElements = Array.from(outerElement.querySelectorAll("button:not(:disabled)"));
            var focusedIndex = enabledOptionElements.indexOf(focusedElement);
            if (focusedIndex < 0) return;
            e.preventDefault();
            // auto-wrapping at 0 and `length`
            var newIndex = (focusedIndex + direction + enabledOptionElements.length) % enabledOptionElements.length;
            var newOption = enabledOptionElements[newIndex];
            newOption.click();
            newOption.focus();
        }
    }, [
        outerRef,
        role
    ]);
    var classes = (0, _classnamesDefault.default)((0, _common.Classes).SEGMENTED_CONTROL, className, (_a = {}, _a[(0, _common.Classes).FILL] = fill, _a[(0, _common.Classes).INLINE] = inline, _a));
    var isAnySelected = options.some(function(option) {
        return selectedValue === option.value;
    });
    return _react.createElement("div", (0, _tslib.__assign)({}, (0, _props.removeNonHTMLProps)(htmlProps), {
        role: role,
        onKeyDown: handleKeyDown,
        className: classes,
        ref: (0, _common.mergeRefs)(ref, outerRef)
    }), options.map(function(option, index) {
        var isSelected = selectedValue === option.value;
        return _react.createElement(SegmentedControlOption, (0, _tslib.__assign)({}, option, {
            intent: intent,
            isSelected: isSelected,
            key: option.value,
            large: large,
            onClick: handleOptionClick,
            small: small
        }, role === "radiogroup" ? {
            "aria-checked": isSelected,
            role: "radio",
            // "roving tabIndex" on a radiogroup: https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_roving_tabindex
            // `!isAnySelected` accounts for case where no value is currently selected
            // (passed value/defaultValue is not one of the values of the passed options.)
            // In this case, set first item to be tabbable even though it's unselected.
            tabIndex: isSelected || index === 0 && !isAnySelected ? 0 : -1
        } : {
            "aria-pressed": isSelected
        }));
    }));
});
SegmentedControl.defaultProps = {
    defaultValue: undefined,
    intent: (0, _common.Intent).NONE
};
SegmentedControl.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".SegmentedControl");
function SegmentedControlOption(_a) {
    var isSelected = _a.isSelected, label = _a.label, onClick = _a.onClick, value = _a.value, buttonProps = (0, _tslib.__rest)(_a, [
        "isSelected",
        "label",
        "onClick",
        "value"
    ]);
    var handleClick = _react.useCallback(function(event) {
        return onClick === null || onClick === void 0 ? void 0 : onClick(value, event.currentTarget);
    }, [
        onClick,
        value
    ]);
    return _react.createElement((0, _buttons.Button), (0, _tslib.__assign)({}, buttonProps, {
        onClick: handleClick,
        minimal: !isSelected,
        text: label
    }));
}
SegmentedControlOption.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".SegmentedControlOption");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","../button/buttons":"glm43","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5whZv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slider", ()=>Slider);
var _tslib = require("tslib");
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _multiSlider = require("./multiSlider");
/**
 * Slider component.
 *
 * @see https://blueprintjs.com/docs/#core/components/sliders.slider
 */ var Slider = /** @class */ function(_super) {
    (0, _tslib.__extends)(Slider, _super);
    function Slider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Slider.prototype.render = function() {
        var _a = this.props, initialValue = _a.initialValue, intent = _a.intent, value = _a.value, onChange = _a.onChange, onRelease = _a.onRelease, handleHtmlProps = _a.handleHtmlProps, props = (0, _tslib.__rest)(_a, [
            "initialValue",
            "intent",
            "value",
            "onChange",
            "onRelease",
            "handleHtmlProps"
        ]);
        return _react.createElement((0, _multiSlider.MultiSlider), (0, _tslib.__assign)({}, props), _react.createElement((0, _multiSlider.MultiSlider).Handle, {
            value: value,
            intentAfter: value < initialValue ? intent : undefined,
            intentBefore: value > initialValue ? intent : undefined,
            onChange: onChange,
            onRelease: onRelease,
            htmlProps: handleHtmlProps
        }), _react.createElement((0, _multiSlider.MultiSlider).Handle, {
            value: initialValue,
            interactionKind: "none"
        }));
    };
    Slider.defaultProps = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _multiSlider.MultiSlider).defaultSliderProps), {
        initialValue: 0,
        intent: (0, _common.Intent).PRIMARY,
        value: 0
    });
    Slider.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Slider");
    return Slider;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","./multiSlider":"363Ok","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l7snT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxCard", ()=>CheckboxCard);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _controlCard = require("./controlCard");
var CheckboxCard = _react.forwardRef(function(props, ref) {
    var className = (0, _classnamesDefault.default)(props.className, (0, _common.Classes).CHECKBOX_CONTROL_CARD);
    return _react.createElement((0, _controlCard.ControlCard), (0, _tslib.__assign)({}, props, {
        className: className,
        controlKind: "checkbox",
        ref: ref
    }));
});
CheckboxCard.defaultProps = {
    alignIndicator: "left"
};
CheckboxCard.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".CheckboxCard");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","./controlCard":"eNg31","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2hI3z":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchCard", ()=>SwitchCard);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _controlCard = require("./controlCard");
var SwitchCard = _react.forwardRef(function(props, ref) {
    var className = (0, _classnamesDefault.default)(props.className, (0, _common.Classes).SWITCH_CONTROL_CARD);
    return _react.createElement((0, _controlCard.ControlCard), (0, _tslib.__assign)({}, props, {
        className: className,
        controlKind: "switch",
        ref: ref
    }));
});
SwitchCard.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".SwitchCard");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","./controlCard":"eNg31","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jvFX9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tab", ()=>Tab);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _utils = require("../../common/utils");
/**
 * Tab component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tabs.tab
 */ var Tab = /** @class */ function(_super) {
    (0, _tslib.__extends)(Tab, _super);
    function Tab() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // this component is never rendered directly; see Tabs#renderTabPanel()
    /* istanbul ignore next */ Tab.prototype.render = function() {
        var _a = this.props, className = _a.className, panel = _a.panel;
        return _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).TAB_PANEL, className),
            role: "tablist"
        }, (0, _utils.isFunction)(panel) ? panel({
            tabTitleId: "",
            tabPanelId: ""
        }) : panel);
    };
    Tab.defaultProps = {
        disabled: false
    };
    Tab.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Tab");
    return Tab;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","../../common/utils":"56UdR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gYC2T":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabPanel", ()=>TabPanel);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _tab = require("./tab");
var _tabTitle = require("./tabTitle");
/**
 * Wraps the passed `panel`.
 */ var TabPanel = /** @class */ function(_super) {
    (0, _tslib.__extends)(TabPanel, _super);
    function TabPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabPanel.prototype.render = function() {
        var _a = this.props, className = _a.className, id = _a.id, parentId = _a.parentId, selectedTabId = _a.selectedTabId, panel = _a.panel, renderActiveTabPanelOnly = _a.renderActiveTabPanelOnly;
        var isSelected = id === selectedTabId;
        if (panel === undefined || renderActiveTabPanelOnly && !isSelected) return undefined;
        var _b = (0, _tabTitle.generateTabIds)(parentId, id), tabTitleId = _b.tabTitleId, tabPanelId = _b.tabPanelId;
        return _react.createElement("div", {
            "aria-labelledby": tabTitleId,
            "aria-hidden": !isSelected,
            className: (0, _classnamesDefault.default)((0, _common.Classes).TAB_PANEL, className),
            id: tabPanelId,
            role: "tabpanel"
        }, (0, _common.Utils).isFunction(panel) ? panel({
            tabTitleId: tabTitleId,
            tabPanelId: tabPanelId
        }) : panel);
    };
    return TabPanel;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","./tab":"jvFX9","./tabTitle":"73515","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"73515":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabTitle", ()=>TabTitle);
parcelHelpers.export(exports, "generateTabIds", ()=>generateTabIds);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _props = require("../../common/props");
var _icon = require("../icon/icon");
var _tag = require("../tag/tag");
var TabTitle = /** @class */ function(_super) {
    (0, _tslib.__extends)(TabTitle, _super);
    function TabTitle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function(e) {
            return _this.props.onClick(_this.props.id, e);
        };
        return _this;
    }
    TabTitle.prototype.render = function() {
        var _a = this.props, className = _a.className, children = _a.children, disabled = _a.disabled, id = _a.id, parentId = _a.parentId, selected = _a.selected, title = _a.title, icon = _a.icon, tagContent = _a.tagContent, tagProps = _a.tagProps, htmlProps = (0, _tslib.__rest)(_a, [
            "className",
            "children",
            "disabled",
            "id",
            "parentId",
            "selected",
            "title",
            "icon",
            "tagContent",
            "tagProps"
        ]);
        var intent = selected ? (0, _common.Intent).PRIMARY : (0, _common.Intent).NONE;
        var _b = generateTabIds(parentId, id), tabPanelId = _b.tabPanelId, tabTitleId = _b.tabTitleId;
        return _react.createElement("div", (0, _tslib.__assign)({}, (0, _props.removeNonHTMLProps)(htmlProps), {
            "aria-controls": tabPanelId,
            "aria-disabled": disabled,
            "aria-expanded": selected,
            "aria-selected": selected,
            className: (0, _classnamesDefault.default)((0, _common.Classes).TAB, className),
            "data-tab-id": id,
            id: tabTitleId,
            onClick: disabled ? undefined : this.handleClick,
            role: "tab",
            tabIndex: disabled ? undefined : selected ? 0 : -1
        }), icon != null && _react.createElement((0, _icon.Icon), {
            icon: icon,
            intent: intent,
            className: (0, _common.Classes).TAB_ICON
        }), title, children, tagContent != null && _react.createElement((0, _tag.Tag), (0, _tslib.__assign)({
            minimal: true,
            intent: intent
        }, tagProps, {
            className: (0, _classnamesDefault.default)((0, _common.Classes).TAB_TAG, tagProps === null || tagProps === void 0 ? void 0 : tagProps.className)
        }), tagContent));
    };
    TabTitle.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".TabTitle");
    return TabTitle;
}((0, _common.AbstractPureComponent));
function generateTabIds(parentId, tabId) {
    return {
        tabPanelId: "".concat((0, _common.Classes).TAB_PANEL, "_").concat(parentId, "_").concat(tabId),
        tabTitleId: "".concat((0, _common.Classes).TAB, "-title_").concat(parentId, "_").concat(tabId)
    };
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/props":"dBcIV","../icon/icon":"duMtK","../tag/tag":"dE1bU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dE1bU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tag", ()=>Tag);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _useInteractiveAttributes = require("../../accessibility/useInteractiveAttributes");
var _common = require("../../common");
var _utils = require("../../common/utils");
var _icon = require("../icon/icon");
var _text = require("../text/text");
var _tagRemoveButton = require("./tagRemoveButton");
var Tag = _react.forwardRef(function(props, ref) {
    var _a;
    var children = props.children, className = props.className, fill = props.fill, icon = props.icon, intent = props.intent, interactive = props.interactive, large = props.large, minimal = props.minimal, multiline = props.multiline, onRemove = props.onRemove, rightIcon = props.rightIcon, round = props.round, _b = props.tabIndex, tabIndex = _b === void 0 ? 0 : _b, htmlTitle = props.htmlTitle, htmlProps = (0, _tslib.__rest)(props, [
        "children",
        "className",
        "fill",
        "icon",
        "intent",
        "interactive",
        "large",
        "minimal",
        "multiline",
        "onRemove",
        "rightIcon",
        "round",
        "tabIndex",
        "htmlTitle"
    ]);
    var isRemovable = (0, _common.Utils).isFunction(onRemove);
    var isInteractive = interactive !== null && interactive !== void 0 ? interactive : htmlProps.onClick != null;
    var _c = (0, _useInteractiveAttributes.useInteractiveAttributes)(isInteractive, props, ref, {
        defaultTabIndex: 0,
        disabledTabIndex: undefined
    }), active = _c[0], interactiveProps = _c[1];
    var tagClasses = (0, _classnamesDefault.default)((0, _common.Classes).TAG, (0, _common.Classes).intentClass(intent), (_a = {}, _a[(0, _common.Classes).ACTIVE] = active, _a[(0, _common.Classes).FILL] = fill, _a[(0, _common.Classes).INTERACTIVE] = isInteractive, _a[(0, _common.Classes).LARGE] = large, _a[(0, _common.Classes).MINIMAL] = minimal, _a[(0, _common.Classes).ROUND] = round, _a), className);
    return _react.createElement("span", (0, _tslib.__assign)({}, (0, _common.removeNonHTMLProps)(htmlProps), interactiveProps, {
        className: tagClasses
    }), _react.createElement((0, _icon.Icon), {
        icon: icon
    }), !(0, _utils.isReactNodeEmpty)(children) && _react.createElement((0, _text.Text), {
        className: (0, _common.Classes).FILL,
        ellipsize: !multiline,
        tagName: "span",
        title: htmlTitle
    }, children), _react.createElement((0, _icon.Icon), {
        icon: rightIcon
    }), isRemovable && _react.createElement((0, _tagRemoveButton.TagRemoveButton), (0, _tslib.__assign)({}, props)));
});
Tag.defaultProps = {
    active: false,
    fill: false,
    large: false,
    minimal: false,
    round: false
};
Tag.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Tag");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../accessibility/useInteractiveAttributes":"18Zcf","../../common":"3QDnh","../../common/utils":"56UdR","../icon/icon":"duMtK","../text/text":"cIHFN","./tagRemoveButton":"cMcvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cMcvP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagRemoveButton", ()=>TagRemoveButton);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var TagRemoveButton = function(props) {
    var className = props.className, large = props.large, onRemove = props.onRemove, tabIndex = props.tabIndex;
    var isLarge = large || (className === null || className === void 0 ? void 0 : className.includes((0, _common.Classes).LARGE));
    var handleRemoveClick = _react.useCallback(function(e) {
        onRemove === null || onRemove === void 0 || onRemove(e, props);
    }, [
        onRemove,
        props
    ]);
    return _react.createElement("button", {
        "aria-label": "Remove tag",
        type: "button",
        className: (0, _common.Classes).TAG_REMOVE,
        onClick: handleRemoveClick,
        tabIndex: tabIndex
    }, _react.createElement((0, _icons.SmallCross), {
        size: isLarge ? (0, _icons.IconSize).LARGE : (0, _icons.IconSize).STANDARD
    }));
};
TagRemoveButton.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".TagRemoveButton");

},{"react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gmXlb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabsExpander", ()=>TabsExpander);
parcelHelpers.export(exports, "Expander", ()=>Expander);
parcelHelpers.export(exports, "Tabs", ()=>Tabs);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _tab = require("./tab");
var _tabPanel = require("./tabPanel");
var _tabTitle = require("./tabTitle");
var TabsExpander = function() {
    return _react.createElement("div", {
        className: (0, _common.Classes).FLEX_EXPANDER
    });
};
var Expander = TabsExpander;
var TAB_SELECTOR = ".".concat((0, _common.Classes).TAB);
/**
 * Tabs component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tabs
 */ var Tabs = /** @class */ function(_super) {
    (0, _tslib.__extends)(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.tablistElement = null;
        _this.refHandlers = {
            tablist: function(tabElement) {
                return _this.tablistElement = tabElement;
            }
        };
        _this.handleKeyDown = function(e) {
            var _a;
            var direction = (0, _common.Utils).getArrowKeyDirection(e, [
                "ArrowLeft",
                "ArrowUp"
            ], [
                "ArrowRight",
                "ArrowDown"
            ]);
            if (direction === undefined) return;
            var focusedElement = (_a = (0, _common.Utils).getActiveElement(_this.tablistElement)) === null || _a === void 0 ? void 0 : _a.closest(TAB_SELECTOR);
            // rest of this is potentially expensive and futile, so bail if no tab is focused
            if (!focusedElement) return;
            // must rely on DOM state because we have no way of mapping `focusedElement` to a React.JSX.Element
            var enabledTabElements = _this.getTabElements('[aria-disabled="false"]');
            var focusedIndex = enabledTabElements.indexOf(focusedElement);
            if (focusedIndex < 0) return;
            e.preventDefault();
            var length = enabledTabElements.length;
            // auto-wrapping at 0 and `length`
            var nextFocusedIndex = (focusedIndex + direction + length) % length;
            enabledTabElements[nextFocusedIndex].focus();
        };
        _this.handleKeyPress = function(e) {
            var targetTabElement = e.target.closest(TAB_SELECTOR);
            if (targetTabElement != null && (0, _common.Utils).isKeyboardClick(e)) {
                e.preventDefault();
                targetTabElement.click();
            }
        };
        _this.handleTabClick = function(newTabId, event) {
            var _a, _b;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, newTabId, _this.state.selectedTabId, event);
            if (_this.props.selectedTabId === undefined) _this.setState({
                selectedTabId: newTabId
            });
        };
        _this.renderTabPanel = function(tab) {
            var _a = tab.props, className = _a.className, panel = _a.panel, id = _a.id, panelClassName = _a.panelClassName;
            if (panel === undefined) return undefined;
            return _react.createElement((0, _tabPanel.TabPanel), (0, _tslib.__assign)({}, tab.props, {
                key: id,
                className: (0, _classnamesDefault.default)(className, panelClassName),
                parentId: _this.props.id,
                selectedTabId: _this.state.selectedTabId
            }));
        };
        _this.renderTabTitle = function(child) {
            if (isTabElement(child)) {
                var id = child.props.id;
                return _react.createElement((0, _tabTitle.TabTitle), (0, _tslib.__assign)({}, child.props, {
                    parentId: _this.props.id,
                    onClick: _this.handleTabClick,
                    selected: id === _this.state.selectedTabId
                }));
            }
            return child;
        };
        var selectedTabId = _this.getInitialSelectedTabId();
        _this.state = {
            selectedTabId: selectedTabId
        };
        return _this;
    }
    Tabs.getDerivedStateFromProps = function(_a) {
        var selectedTabId = _a.selectedTabId;
        if (selectedTabId !== undefined) // keep state in sync with controlled prop, so state is canonical source of truth
        return {
            selectedTabId: selectedTabId
        };
        return null;
    };
    Tabs.prototype.render = function() {
        var _a, _b;
        var _c = this.state, indicatorWrapperStyle = _c.indicatorWrapperStyle, selectedTabId = _c.selectedTabId;
        var tabTitles = _react.Children.map(this.props.children, this.renderTabTitle);
        var tabPanels = this.getTabChildren().filter(this.props.renderActiveTabPanelOnly ? function(tab) {
            return tab.props.id === selectedTabId;
        } : function() {
            return true;
        }).map(this.renderTabPanel);
        var tabIndicator = this.props.animate ? _react.createElement("div", {
            className: (0, _common.Classes).TAB_INDICATOR_WRAPPER,
            style: indicatorWrapperStyle
        }, _react.createElement("div", {
            className: (0, _common.Classes).TAB_INDICATOR
        })) : null;
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).TABS, this.props.className, (_a = {}, _a[(0, _common.Classes).VERTICAL] = this.props.vertical, _a[(0, _common.Classes).FILL] = this.props.fill, _a));
        var tabListClasses = (0, _classnamesDefault.default)((0, _common.Classes).TAB_LIST, (_b = {}, _b[(0, _common.Classes).LARGE] = this.props.large, _b));
        return _react.createElement("div", {
            className: classes
        }, _react.createElement("div", {
            className: tabListClasses,
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress,
            ref: this.refHandlers.tablist,
            role: "tablist"
        }, tabIndicator, tabTitles), tabPanels);
    };
    Tabs.prototype.componentDidMount = function() {
        this.moveSelectionIndicator(false);
    };
    Tabs.prototype.componentDidUpdate = function(prevProps, prevState) {
        if (this.state.selectedTabId !== prevState.selectedTabId) this.moveSelectionIndicator();
        else if (prevState.selectedTabId != null) {
            // comparing React nodes is difficult to do with simple logic, so
            // shallowly compare just their props as a workaround.
            var didChildrenChange = !(0, _common.Utils).arraysEqual(this.getTabChildrenProps(prevProps), this.getTabChildrenProps(), (0, _common.Utils).shallowCompareKeys);
            if (didChildrenChange) this.moveSelectionIndicator();
        }
    };
    Tabs.prototype.getInitialSelectedTabId = function() {
        // NOTE: providing an unknown ID will hide the selection
        var _a = this.props, defaultSelectedTabId = _a.defaultSelectedTabId, selectedTabId = _a.selectedTabId;
        if (selectedTabId !== undefined) return selectedTabId;
        else if (defaultSelectedTabId !== undefined) return defaultSelectedTabId;
        else {
            // select first tab in absence of user input
            var tabs = this.getTabChildren();
            return tabs.length === 0 ? undefined : tabs[0].props.id;
        }
    };
    Tabs.prototype.getTabChildrenProps = function(props) {
        if (props === void 0) props = this.props;
        return this.getTabChildren(props).map(function(child) {
            return child.props;
        });
    };
    /** Filters children to only `<Tab>`s */ Tabs.prototype.getTabChildren = function(props) {
        if (props === void 0) props = this.props;
        return _react.Children.toArray(props.children).filter(isTabElement);
    };
    /** Queries root HTML element for all tabs with optional filter selector */ Tabs.prototype.getTabElements = function(subselector) {
        if (subselector === void 0) subselector = "";
        if (this.tablistElement == null) return [];
        return Array.from(this.tablistElement.querySelectorAll(TAB_SELECTOR + subselector));
    };
    /**
     * Calculate the new height, width, and position of the tab indicator.
     * Store the CSS values so the transition animation can start.
     */ Tabs.prototype.moveSelectionIndicator = function(animate) {
        if (animate === void 0) animate = true;
        if (this.tablistElement == null || !this.props.animate) return;
        var tabIdSelector = "".concat(TAB_SELECTOR, "[data-tab-id=\"").concat(this.state.selectedTabId, "\"]");
        var selectedTabElement = this.tablistElement.querySelector(tabIdSelector);
        var indicatorWrapperStyle = {
            display: "none"
        };
        if (selectedTabElement != null) {
            var clientHeight = selectedTabElement.clientHeight, clientWidth = selectedTabElement.clientWidth, offsetLeft = selectedTabElement.offsetLeft, offsetTop = selectedTabElement.offsetTop;
            indicatorWrapperStyle = {
                height: clientHeight,
                transform: "translateX(".concat(Math.floor(offsetLeft), "px) translateY(").concat(Math.floor(offsetTop), "px)"),
                width: clientWidth
            };
            if (!animate) indicatorWrapperStyle.transition = "none";
        }
        this.setState({
            indicatorWrapperStyle: indicatorWrapperStyle
        });
    };
    /**
     * Insert a `TabsExpander` between any two children to right-align all subsequent children.
     *
     * @deprecated use `TabsExpander`
     */ Tabs.Expander = TabsExpander;
    Tabs.Tab = (0, _tab.Tab);
    Tabs.defaultProps = {
        animate: true,
        fill: false,
        large: false,
        renderActiveTabPanelOnly: false,
        vertical: false
    };
    Tabs.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Tabs");
    return Tabs;
}((0, _common.AbstractPureComponent));
function isTabElement(child) {
    return (0, _common.Utils).isElementOfType(child, (0, _tab.Tab));
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","./tab":"jvFX9","./tabPanel":"gYC2T","./tabTitle":"73515","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bYLhJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompoundTag", ()=>CompoundTag);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _utils = require("../../common/utils");
var _icon = require("../icon/icon");
var _text = require("../text/text");
var _tagRemoveButton = require("./tagRemoveButton");
var CompoundTag = _react.forwardRef(function(props, ref) {
    var _a;
    var active = props.active, children = props.children, className = props.className, fill = props.fill, icon = props.icon, intent = props.intent, interactive = props.interactive, leftContent = props.leftContent, large = props.large, minimal = props.minimal, onRemove = props.onRemove, rightIcon = props.rightIcon, round = props.round, _b = props.tabIndex, tabIndex = _b === void 0 ? 0 : _b, htmlProps = (0, _tslib.__rest)(props, [
        "active",
        "children",
        "className",
        "fill",
        "icon",
        "intent",
        "interactive",
        "leftContent",
        "large",
        "minimal",
        "onRemove",
        "rightIcon",
        "round",
        "tabIndex"
    ]);
    var isRemovable = (0, _common.Utils).isFunction(onRemove);
    var tagClasses = (0, _classnamesDefault.default)((0, _common.Classes).TAG, (0, _common.Classes).COMPOUND_TAG, (0, _common.Classes).intentClass(intent), (_a = {}, _a[(0, _common.Classes).ACTIVE] = active, _a[(0, _common.Classes).FILL] = fill, _a[(0, _common.Classes).INTERACTIVE] = interactive, _a[(0, _common.Classes).LARGE] = large, _a[(0, _common.Classes).MINIMAL] = minimal, _a[(0, _common.Classes).ROUND] = round, _a), className);
    return _react.createElement("span", (0, _tslib.__assign)({}, htmlProps, {
        className: tagClasses,
        tabIndex: interactive ? tabIndex : undefined,
        ref: ref
    }), _react.createElement("span", {
        className: (0, _common.Classes).COMPOUND_TAG_LEFT
    }, _react.createElement((0, _icon.Icon), {
        icon: icon
    }), _react.createElement((0, _text.Text), {
        className: (0, _classnamesDefault.default)((0, _common.Classes).COMPOUND_TAG_LEFT_CONTENT, (0, _common.Classes).FILL),
        tagName: "span"
    }, leftContent)), _react.createElement("span", {
        className: (0, _common.Classes).COMPOUND_TAG_RIGHT
    }, !(0, _utils.isReactNodeEmpty)(children) && _react.createElement((0, _text.Text), {
        className: (0, _classnamesDefault.default)((0, _common.Classes).COMPOUND_TAG_RIGHT_CONTENT, (0, _common.Classes).FILL),
        tagName: "span"
    }, children), _react.createElement((0, _icon.Icon), {
        icon: rightIcon
    }), isRemovable && _react.createElement((0, _tagRemoveButton.TagRemoveButton), (0, _tslib.__assign)({}, props))));
});
CompoundTag.defaultProps = {
    active: false,
    fill: false,
    interactive: false,
    large: false,
    minimal: false,
    round: false
};
CompoundTag.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".CompoundTag");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","../../common/utils":"56UdR","../icon/icon":"duMtK","../text/text":"cIHFN","./tagRemoveButton":"cMcvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6UZ43":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagInput", ()=>TagInput);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _props = require("../../common/props");
var _utils = require("../../common/utils");
var _icon = require("../icon/icon");
var _tag = require("../tag/tag");
var _resizableInput = require("./resizableInput");
/** special value for absence of active tag */ var NONE = -1;
/**
 * Tag input component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tag-input
 */ var TagInput = /** @class */ function(_super) {
    (0, _tslib.__extends)(TagInput, _super);
    function TagInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeIndex: NONE,
            inputValue: _this.props.inputValue || "",
            isInputFocused: false
        };
        _this.inputElement = null;
        _this.handleRef = (0, _common.refHandler)(_this, "inputElement", _this.props.inputRef);
        _this.addTags = function(value, method) {
            if (method === void 0) method = "default";
            var _a = _this.props, inputValue = _a.inputValue, onAdd = _a.onAdd, onChange = _a.onChange, values = _a.values;
            var newValues = _this.getValues(value);
            var shouldClearInput = (onAdd === null || onAdd === void 0 ? void 0 : onAdd(newValues, method)) !== false && inputValue === undefined;
            // avoid a potentially expensive computation if this prop is omitted
            if ((0, _common.Utils).isFunction(onChange)) shouldClearInput = onChange((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], values, true), newValues, true)) !== false && shouldClearInput;
            // only explicit return false cancels text clearing
            if (shouldClearInput) _this.setState({
                inputValue: ""
            });
        };
        _this.maybeRenderTag = function(tag, index) {
            if (!tag) return null;
            var _a = _this.props, large = _a.large, tagProps = _a.tagProps;
            var props = (0, _common.Utils).isFunction(tagProps) ? tagProps(tag, index) : tagProps;
            return _react.createElement((0, _tag.Tag), (0, _tslib.__assign)({
                active: index === _this.state.activeIndex,
                "data-tag-index": index,
                key: tag + "__" + index,
                large: large,
                onRemove: _this.props.disabled ? undefined : _this.handleRemoveTag
            }, props), tag);
        };
        _this.handleContainerClick = function() {
            var _a;
            (_a = _this.inputElement) === null || _a === void 0 || _a.focus();
        };
        _this.handleContainerBlur = function(_a) {
            var currentTarget = _a.currentTarget;
            _this.requestAnimationFrame(function() {
                // we only care if the blur event is leaving the container.
                // defer this check using rAF so activeElement will have updated.
                var isFocusInsideContainer = currentTarget.contains((0, _utils.getActiveElement)(_this.inputElement));
                if (!isFocusInsideContainer) {
                    if (_this.props.addOnBlur && _this.state.inputValue !== undefined && _this.state.inputValue.length > 0) _this.addTags(_this.state.inputValue, "blur");
                    _this.setState({
                        activeIndex: NONE,
                        isInputFocused: false
                    });
                }
            });
        };
        _this.handleInputFocus = function(event) {
            var _a, _b;
            _this.setState({
                isInputFocused: true
            });
            (_b = (_a = _this.props.inputProps) === null || _a === void 0 ? void 0 : _a.onFocus) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.handleInputChange = function(event) {
            var _a, _b, _c, _d;
            _this.setState({
                activeIndex: NONE,
                inputValue: event.currentTarget.value
            });
            (_b = (_a = _this.props).onInputChange) === null || _b === void 0 || _b.call(_a, event);
            (_d = (_c = _this.props.inputProps) === null || _c === void 0 ? void 0 : _c.onChange) === null || _d === void 0 || _d.call(_c, event);
        };
        _this.handleInputKeyDown = function(event) {
            var _a = event.currentTarget, selectionEnd = _a.selectionEnd, value = _a.value;
            var activeIndex = _this.state.activeIndex;
            var activeIndexToEmit = activeIndex;
            // do not add a new tag if the user is composing (e.g. for Japanese or Chinese)
            if (event.key === "Enter" && !event.nativeEvent.isComposing && value.length > 0) _this.addTags(value, "default");
            else if (selectionEnd === 0 && _this.props.values.length > 0) {
                // cursor at beginning of input allows interaction with tags.
                // use selectionEnd to verify cursor position and no text selection.
                var direction = (0, _common.Utils).getArrowKeyDirection(event, [
                    "ArrowLeft"
                ], [
                    "ArrowRight"
                ]);
                if (direction !== undefined) {
                    var nextActiveIndex = _this.getNextActiveIndex(direction);
                    if (nextActiveIndex !== activeIndex) {
                        event.stopPropagation();
                        activeIndexToEmit = nextActiveIndex;
                        _this.setState({
                            activeIndex: nextActiveIndex
                        });
                    }
                } else if (event.key === "Backspace") _this.handleBackspaceToRemove(event);
                else if (event.key === "Delete") _this.handleDeleteToRemove(event);
            }
            _this.invokeKeyPressCallback("onKeyDown", event, activeIndexToEmit);
        };
        _this.handleInputKeyUp = function(event) {
            _this.invokeKeyPressCallback("onKeyUp", event, _this.state.activeIndex);
        };
        _this.handleInputPaste = function(event) {
            var separator = _this.props.separator;
            var value = event.clipboardData.getData("text");
            if (!_this.props.addOnPaste || value.length === 0) return;
            // special case as a UX nicety: if the user pasted only one value with no delimiters in it, leave that value in
            // the input field so that the user can refine it before converting it to a tag manually.
            if (separator === false || value.split(separator).length === 1) return;
            event.preventDefault();
            _this.addTags(value, "paste");
        };
        _this.handleRemoveTag = function(event) {
            // using data attribute to simplify callback logic -- one handler for all children
            var index = +event.currentTarget.parentElement.getAttribute("data-tag-index");
            _this.removeIndexFromValues(index);
        };
        return _this;
    }
    TagInput.getDerivedStateFromProps = function(props, state) {
        if (props.inputValue !== state.prevInputValueProp) return {
            inputValue: props.inputValue,
            prevInputValueProp: props.inputValue
        };
        return null;
    };
    TagInput.prototype.render = function() {
        var _a;
        var _b = this.props, autoResize = _b.autoResize, className = _b.className, disabled = _b.disabled, fill = _b.fill, inputProps = _b.inputProps, intent = _b.intent, large = _b.large, leftIcon = _b.leftIcon, placeholder = _b.placeholder, values = _b.values;
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).INPUT, (0, _common.Classes).TAG_INPUT, (_a = {}, _a[(0, _common.Classes).ACTIVE] = this.state.isInputFocused, _a[(0, _common.Classes).DISABLED] = disabled, _a[(0, _common.Classes).FILL] = fill, _a[(0, _common.Classes).LARGE] = large, _a), (0, _common.Classes).intentClass(intent), className);
        var isLarge = classes.indexOf((0, _common.Classes).LARGE) > NONE;
        // use placeholder prop only if it's defined and values list is empty or contains only falsy values
        var isSomeValueDefined = values.some(function(val) {
            return !!val;
        });
        var resolvedPlaceholder = placeholder == null || isSomeValueDefined ? inputProps === null || inputProps === void 0 ? void 0 : inputProps.placeholder : placeholder;
        // final props that may be sent to <input> or <ResizableInput>
        var resolvedInputProps = (0, _tslib.__assign)((0, _tslib.__assign)({
            value: this.state.inputValue
        }, inputProps), {
            className: (0, _classnamesDefault.default)((0, _common.Classes).INPUT_GHOST, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className),
            disabled: disabled,
            onChange: this.handleInputChange,
            onFocus: this.handleInputFocus,
            onKeyDown: this.handleInputKeyDown,
            onKeyUp: this.handleInputKeyUp,
            onPaste: this.handleInputPaste,
            placeholder: resolvedPlaceholder,
            ref: this.handleRef
        });
        return _react.createElement("div", {
            className: classes,
            onBlur: this.handleContainerBlur,
            onClick: this.handleContainerClick
        }, _react.createElement((0, _icon.Icon), {
            className: (0, _common.Classes).TAG_INPUT_ICON,
            icon: leftIcon,
            size: isLarge ? (0, _icons.IconSize).LARGE : (0, _icons.IconSize).STANDARD
        }), _react.createElement("div", {
            className: (0, _common.Classes).TAG_INPUT_VALUES
        }, values.map(this.maybeRenderTag), this.props.children, autoResize ? _react.createElement((0, _resizableInput.ResizableInput), (0, _tslib.__assign)({}, resolvedInputProps)) : _react.createElement("input", (0, _tslib.__assign)({}, resolvedInputProps))), this.props.rightElement);
    };
    TagInput.prototype.componentDidUpdate = function(prevProps) {
        if (prevProps.inputRef !== this.props.inputRef) {
            (0, _common.setRef)(prevProps.inputRef, null);
            this.handleRef = (0, _common.refHandler)(this, "inputElement", this.props.inputRef);
            (0, _common.setRef)(this.props.inputRef, this.inputElement);
        }
    };
    TagInput.prototype.getNextActiveIndex = function(direction) {
        var activeIndex = this.state.activeIndex;
        if (activeIndex === NONE) // nothing active & moving left: select last defined value. otherwise select nothing.
        return direction < 0 ? this.findNextIndex(this.props.values.length, -1) : NONE;
        else // otherwise, move in direction and clamp to bounds.
        // note that upper bound allows going one beyond last item
        // so focus can move off the right end, into the text input.
        return this.findNextIndex(activeIndex, direction);
    };
    TagInput.prototype.findNextIndex = function(startIndex, direction) {
        var values = this.props.values;
        var index = startIndex + direction;
        while(index > 0 && index < values.length && !values[index])index += direction;
        return (0, _common.Utils).clamp(index, 0, values.length);
    };
    /**
     * Splits inputValue on separator prop,
     * trims whitespace from each new value,
     * and ignores empty values.
     */ TagInput.prototype.getValues = function(inputValue) {
        var separator = this.props.separator;
        // NOTE: split() typings define two overrides for string and RegExp.
        // this does not play well with our union prop type, so we'll just declare it as a valid type.
        return (separator === false ? [
            inputValue
        ] : inputValue.split(separator)).map(function(val) {
            return val.trim();
        }).filter(function(val) {
            return val.length > 0;
        });
    };
    TagInput.prototype.handleBackspaceToRemove = function(event) {
        var previousActiveIndex = this.state.activeIndex;
        // always move leftward one item (this will focus last item if nothing is focused)
        this.setState({
            activeIndex: this.getNextActiveIndex(-1)
        });
        // delete item if there was a previous valid selection (ignore first backspace to focus last item)
        if (this.isValidIndex(previousActiveIndex)) {
            event.stopPropagation();
            this.removeIndexFromValues(previousActiveIndex);
        }
    };
    TagInput.prototype.handleDeleteToRemove = function(event) {
        var activeIndex = this.state.activeIndex;
        if (this.isValidIndex(activeIndex)) {
            event.stopPropagation();
            this.removeIndexFromValues(activeIndex);
        }
    };
    /** Remove the item at the given index by invoking `onRemove` and `onChange` accordingly. */ TagInput.prototype.removeIndexFromValues = function(index) {
        var _a = this.props, onChange = _a.onChange, onRemove = _a.onRemove, values = _a.values;
        onRemove === null || onRemove === void 0 || onRemove(values[index], index);
        onChange === null || onChange === void 0 || onChange(values.filter(function(_, i) {
            return i !== index;
        }));
    };
    TagInput.prototype.invokeKeyPressCallback = function(propCallbackName, event, activeIndex) {
        var _a, _b, _c, _d;
        (_b = (_a = this.props)[propCallbackName]) === null || _b === void 0 || _b.call(_a, event, activeIndex === NONE ? undefined : activeIndex);
        (_d = (_c = this.props.inputProps)[propCallbackName]) === null || _d === void 0 || _d.call(_c, event);
    };
    /** Returns whether the given index represents a valid item in `this.props.values`. */ TagInput.prototype.isValidIndex = function(index) {
        return index !== NONE && index < this.props.values.length;
    };
    TagInput.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".TagInput");
    TagInput.defaultProps = {
        addOnBlur: false,
        addOnPaste: true,
        autoResize: false,
        inputProps: {},
        separator: /[,\n\r]/,
        tagProps: {}
    };
    return TagInput;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../../common/props":"dBcIV","../../common/utils":"56UdR","../icon/icon":"duMtK","../tag/tag":"dE1bU","./resizableInput":"2pEQq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2pEQq":[function(require,module,exports,__globalThis) {
/* !
 * (c) Copyright 2022 Palantir Technologies Inc. All rights reserved.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizableInput", ()=>ResizableInput);
var _tslib = require("tslib");
var _react = require("react");
var _common = require("../../common");
var ResizableInput = _react.forwardRef(function ResizableInput(props, ref) {
    var _a = _react.useState(""), content = _a[0], setContent = _a[1];
    var _b = _react.useState(0), width = _b[0], setWidth = _b[1];
    var span = _react.useRef(null);
    _react.useEffect(function() {
        if (span.current != null) setWidth(span.current.offsetWidth);
    }, [
        content
    ]);
    var onChange = props.onChange, style = props.style, otherProps = (0, _tslib.__rest)(props, [
        "onChange",
        "style"
    ]);
    var handleInputChange = function(evt) {
        var _a, _b;
        onChange === null || onChange === void 0 || onChange(evt);
        setContent((_b = (_a = evt === null || evt === void 0 ? void 0 : evt.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "");
    };
    return _react.createElement(_react.Fragment, null, _react.createElement("span", {
        ref: span,
        className: (0, _common.Classes).RESIZABLE_INPUT_SPAN,
        "aria-hidden": true
    }, content.replace(/ /g, "\u00a0")), _react.createElement("input", (0, _tslib.__assign)({}, otherProps, {
        type: "text",
        style: (0, _tslib.__assign)((0, _tslib.__assign)({}, style), {
            width: width
        }),
        onChange: handleInputChange,
        ref: ref
    })));
});
ResizableInput.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".ResizableInput");

},{"tslib":"b4wpY","react":"9njXz","../../common":"3QDnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cTaXD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OVERLAY_TOASTER_DELAY_MS", ()=>OVERLAY_TOASTER_DELAY_MS);
parcelHelpers.export(exports, "OverlayToaster", ()=>OverlayToaster);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDom = require("react-dom");
var _common = require("../../common");
var _errors = require("../../common/errors");
var _props = require("../../common/props");
var _utils = require("../../common/utils");
var _overlay2 = require("../overlay2/overlay2");
var _toast = require("./toast");
var _toast2 = require("./toast2");
var OVERLAY_TOASTER_DELAY_MS = 50;
/**
 * OverlayToaster component.
 *
 * @see https://blueprintjs.com/docs/#core/components/toast
 */ var OverlayToaster = /** @class */ function(_super) {
    (0, _tslib.__extends)(OverlayToaster, _super);
    function OverlayToaster() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            toastRefs: {},
            toasts: []
        };
        // Queue of toasts to be displayed. If toasts are shown too quickly back to back, it can result in cut off toasts.
        // The queue ensures that toasts are only displayed in QUEUE_TIMEOUT_MS increments.
        _this.queue = {
            cancel: undefined,
            isRunning: false,
            toasts: []
        };
        // auto-incrementing identifier for un-keyed toasts
        _this.toastId = 0;
        _this.toastRefs = {};
        /** Compute a new collection of toast refs (usually after updating toasts) */ _this.getToastRefs = function(toasts) {
            return toasts.reduce(function(refs, toast) {
                refs[toast.key] = _react.createRef();
                return refs;
            }, {});
        };
        _this.handleQueueTimeout = function() {
            var nextToast = _this.queue.toasts.shift();
            if (nextToast != null) {
                _this.immediatelyShowToast(nextToast);
                _this.startQueueTimeout();
            } else _this.queue.isRunning = false;
        };
        _this.renderToast = function(toast) {
            return _react.createElement((0, _toast2.Toast2), (0, _tslib.__assign)({}, toast, {
                onDismiss: _this.getDismissHandler(toast)
            }));
        };
        _this.getDismissHandler = function(toast) {
            return function(timeoutExpired) {
                _this.dismiss(toast.key, timeoutExpired);
            };
        };
        _this.handleClose = function(e) {
            // NOTE that `e` isn't always a KeyboardEvent but that's the only type we care about
            if (e.key === "Escape") _this.clear();
        };
        return _this;
    }
    /**
     * Create a new `Toaster` instance that can be shared around your application.
     * The `Toaster` will be rendered into a new element appended to the given container.
     */ OverlayToaster.create = function(props, container) {
        if (container === void 0) container = document.body;
        if (props != null && props.usePortal != null && !(0, _utils.isNodeEnv)("production")) console.warn((0, _errors.TOASTER_WARN_INLINE));
        var containerElement = document.createElement("div");
        container.appendChild(containerElement);
        var toaster = _reactDom.render(_react.createElement(OverlayToaster, (0, _tslib.__assign)({}, props, {
            usePortal: false
        })), containerElement);
        if (toaster == null) throw new Error((0, _errors.TOASTER_CREATE_NULL));
        return toaster;
    };
    /**
     * Similar to {@link OverlayToaster.create}, but returns a Promise to a
     * Toaster instance after it's rendered and mounted to the DOM.
     *
     * This API will replace the synchronous {@link OverlayToaster.create} in a
     * future major version of Blueprint to reflect React 18+'s new asynchronous
     * rendering API.
     */ OverlayToaster.createAsync = function(props, options) {
        var _a, _b;
        if (props != null && props.usePortal != null && !(0, _utils.isNodeEnv)("production")) console.warn((0, _errors.TOASTER_WARN_INLINE));
        var container = (_a = options === null || options === void 0 ? void 0 : options.container) !== null && _a !== void 0 ? _a : document.body;
        var domRenderer = (_b = options === null || options === void 0 ? void 0 : options.domRenderer) !== null && _b !== void 0 ? _b : _reactDom.render;
        var toasterComponentRoot = document.createElement("div");
        container.appendChild(toasterComponentRoot);
        return new Promise(function(resolve, reject) {
            try {
                domRenderer(_react.createElement(OverlayToaster, (0, _tslib.__assign)({}, props, {
                    ref: handleRef,
                    usePortal: false
                })), toasterComponentRoot);
            } catch (error) {
                // Note that we're catching errors from the domRenderer function
                // call, but not errors when rendering <OverlayToaster>, which
                // happens in a separate scheduled tick. Wrapping the
                // OverlayToaster in an error boundary would be necessary to
                // capture rendering errors, but that's still a bit unreliable
                // and would only catch errors rendering the initial mount.
                reject(error);
            }
            // We can get a rough guarantee that the OverlayToaster has been
            // mounted to the DOM by waiting until the ref callback here has
            // been fired.
            //
            // This is the approach suggested under "What about the render
            // callback?" at https://github.com/reactwg/react-18/discussions/5.
            function handleRef(ref) {
                if (ref == null) {
                    reject(new Error((0, _errors.TOASTER_CREATE_ASYNC_NULL)));
                    return;
                }
                resolve(ref);
            }
        });
    };
    OverlayToaster.prototype.show = function(props, key) {
        var options = this.createToastOptions(props, key);
        var wasExistingToastUpdated = this.maybeUpdateExistingToast(options, key);
        if (wasExistingToastUpdated) return options.key;
        if (this.queue.isRunning) // If a toast has been shown recently, push to the queued toasts to prevent toasts from being shown too
        // quickly for the animations to keep up
        this.queue.toasts.push(options);
        else {
            // If we have not recently shown a toast, we can immediately show the given toast
            this.immediatelyShowToast(options);
            this.startQueueTimeout();
        }
        return options.key;
    };
    OverlayToaster.prototype.maybeUpdateExistingToast = function(options, key) {
        if (key == null) return false;
        var isExistingQueuedToast = this.queue.toasts.some(function(toast) {
            return toast.key === key;
        });
        if (isExistingQueuedToast) {
            this.queue.toasts = this.queue.toasts.map(function(t) {
                return t.key === key ? options : t;
            });
            return true;
        }
        var isExistingShownToast = this.state.toasts.some(function(toast) {
            return toast.key === key;
        });
        if (isExistingShownToast) {
            this.updateToastsInState(function(toasts) {
                return toasts.map(function(t) {
                    return t.key === key ? options : t;
                });
            });
            return true;
        }
        return false;
    };
    OverlayToaster.prototype.immediatelyShowToast = function(options) {
        if (this.props.maxToasts) // check if active number of toasts are at the maxToasts limit
        this.dismissIfAtLimit();
        this.updateToastsInState(function(toasts) {
            return (0, _tslib.__spreadArray)([
                options
            ], toasts, true);
        });
    };
    OverlayToaster.prototype.startQueueTimeout = function() {
        this.queue.isRunning = true;
        this.queue.cancel = this.setTimeout(this.handleQueueTimeout, OVERLAY_TOASTER_DELAY_MS);
    };
    OverlayToaster.prototype.updateToastsInState = function(getNewToasts) {
        var _this = this;
        this.setState(function(prevState) {
            var toasts = getNewToasts(prevState.toasts);
            return {
                toasts: toasts,
                toastRefs: _this.getToastRefs(toasts)
            };
        });
    };
    OverlayToaster.prototype.dismiss = function(key, timeoutExpired) {
        var _this = this;
        if (timeoutExpired === void 0) timeoutExpired = false;
        this.setState(function(prevState) {
            var toasts = prevState.toasts.filter(function(t) {
                var _a;
                var matchesKey = t.key === key;
                if (matchesKey) (_a = t.onDismiss) === null || _a === void 0 || _a.call(t, timeoutExpired);
                return !matchesKey;
            });
            return {
                toasts: toasts,
                toastRefs: _this.getToastRefs(toasts)
            };
        });
    };
    OverlayToaster.prototype.clear = function() {
        var _a, _b;
        (_b = (_a = this.queue).cancel) === null || _b === void 0 || _b.call(_a);
        this.queue = {
            cancel: undefined,
            isRunning: false,
            toasts: []
        };
        this.state.toasts.forEach(function(t) {
            var _a;
            return (_a = t.onDismiss) === null || _a === void 0 ? void 0 : _a.call(t, false);
        });
        this.setState({
            toasts: [],
            toastRefs: {}
        });
    };
    OverlayToaster.prototype.getToasts = function() {
        return this.state.toasts;
    };
    OverlayToaster.prototype.render = function() {
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).TOAST_CONTAINER, this.getPositionClasses(), this.props.className);
        return _react.createElement((0, _overlay2.Overlay2), {
            autoFocus: this.props.autoFocus,
            canEscapeKeyClose: this.props.canEscapeKeyClear,
            canOutsideClickClose: false,
            className: classes,
            childRefs: this.toastRefs,
            enforceFocus: false,
            hasBackdrop: false,
            isOpen: this.state.toasts.length > 0 || this.props.children != null,
            onClose: this.handleClose,
            shouldReturnFocusOnClose: false,
            // $pt-transition-duration * 3 + $pt-transition-duration / 2
            transitionDuration: 350,
            transitionName: (0, _common.Classes).TOAST,
            usePortal: this.props.usePortal
        }, this.state.toasts.map(this.renderToast, this), this.renderChildren());
    };
    OverlayToaster.prototype.validateProps = function(_a) {
        var maxToasts = _a.maxToasts;
        // maximum number of toasts should not be a number less than 1
        if (maxToasts !== undefined && maxToasts < 1) throw new Error((0, _errors.TOASTER_MAX_TOASTS_INVALID));
    };
    /**
     * If provided `Toast` children, automaticaly upgrade them to `Toast2` elements so that `Overlay2` can inject
     * refs into them for use by `CSSTransition`. This is a bit hacky but ensures backwards compatibility for
     * `OverlayToaster`. It should be an uncommon code path in most applications, since we expect most usage to
     * occur via the imperative toaster APIs.
     *
     * We can remove this indirection once `Toast2` fully replaces `Toast` in a future major version.
     *
     * TODO(@adidahiya): Blueprint v6.0
     */ OverlayToaster.prototype.renderChildren = function() {
        return _react.Children.map(this.props.children, function(child) {
            // eslint-disable-next-line deprecation/deprecation
            if ((0, _utils.isElementOfType)(child, (0, _toast.Toast))) return _react.createElement((0, _toast2.Toast2), (0, _tslib.__assign)({}, child.props));
            else return child;
        });
    };
    OverlayToaster.prototype.dismissIfAtLimit = function() {
        if (this.state.toasts.length === this.props.maxToasts) // dismiss the oldest toast to stay within the maxToasts limit
        this.dismiss(this.state.toasts[this.state.toasts.length - 1].key);
    };
    OverlayToaster.prototype.createToastOptions = function(props, key) {
        if (key === void 0) key = "toast-".concat(this.toastId++);
        // clone the object before adding the key prop to avoid leaking the mutation
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, props), {
            key: key
        });
    };
    OverlayToaster.prototype.getPositionClasses = function() {
        var positions = this.props.position.split("-");
        // NOTE that there is no -center class because that's the default style
        return (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], positions.map(function(p) {
            return "".concat((0, _common.Classes).TOAST_CONTAINER, "-").concat(p.toLowerCase());
        }), true), [
            "".concat((0, _common.Classes).TOAST_CONTAINER, "-").concat(this.props.usePortal ? "in-portal" : "inline")
        ], false);
    };
    OverlayToaster.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".OverlayToaster");
    OverlayToaster.defaultProps = {
        autoFocus: false,
        canEscapeKeyClear: true,
        position: (0, _common.Position).TOP,
        usePortal: true
    };
    return OverlayToaster;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","react-dom":"2ApDx","../../common":"3QDnh","../../common/errors":"lyD8m","../../common/props":"dBcIV","../../common/utils":"56UdR","../overlay2/overlay2":"3eEFv","./toast":"2jDnj","./toast2":"bQZYd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2jDnj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toast", ()=>Toast);
var _tslib = require("tslib");
/**
 * @fileoverview This component is DEPRECATED, and the code is frozen.
 * All changes & bugfixes should be made to Toast2 instead.
 */ /* eslint-disable deprecation/deprecation, @blueprintjs/no-deprecated-components */ var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _props = require("../../common/props");
var _buttonGroup = require("../button/buttonGroup");
var _buttons = require("../button/buttons");
var _icon = require("../icon/icon");
/**
 * Toast component.
 *
 * @deprecated use `Toast2` instead, which forwards DOM refs and is thus compatible with `Overlay2`.
 * @see https://blueprintjs.com/docs/#core/components/toast
 */ var Toast = /** @class */ function(_super) {
    (0, _tslib.__extends)(Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleActionClick = function(e) {
            var _a, _b;
            (_b = (_a = _this.props.action) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, e);
            _this.triggerDismiss(false);
        };
        _this.handleCloseClick = function() {
            return _this.triggerDismiss(false);
        };
        _this.startTimeout = function() {
            _this.clearTimeouts();
            if (_this.props.timeout > 0) _this.setTimeout(function() {
                return _this.triggerDismiss(true);
            }, _this.props.timeout);
        };
        return _this;
    }
    Toast.prototype.render = function() {
        var _a = this.props, className = _a.className, icon = _a.icon, intent = _a.intent, message = _a.message, isCloseButtonShown = _a.isCloseButtonShown;
        return _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).TOAST, (0, _common.Classes).intentClass(intent), className),
            onBlur: this.startTimeout,
            onFocus: this.clearTimeouts,
            onMouseEnter: this.clearTimeouts,
            onMouseLeave: this.startTimeout,
            tabIndex: 0
        }, _react.createElement((0, _icon.Icon), {
            icon: icon
        }), _react.createElement("span", {
            className: (0, _common.Classes).TOAST_MESSAGE,
            role: "alert"
        }, message), _react.createElement((0, _buttonGroup.ButtonGroup), {
            minimal: true
        }, this.maybeRenderActionButton(), isCloseButtonShown && _react.createElement((0, _buttons.Button), {
            "aria-label": "Close",
            icon: _react.createElement((0, _icons.Cross), null),
            onClick: this.handleCloseClick
        })));
    };
    Toast.prototype.componentDidMount = function() {
        this.startTimeout();
    };
    Toast.prototype.componentDidUpdate = function(prevProps) {
        if (prevProps.timeout !== this.props.timeout) {
            if (this.props.timeout > 0) this.startTimeout();
            else this.clearTimeouts();
        }
    };
    Toast.prototype.componentWillUnmount = function() {
        this.clearTimeouts();
    };
    Toast.prototype.maybeRenderActionButton = function() {
        var action = this.props.action;
        if (action == null) return undefined;
        else return _react.createElement((0, _buttons.AnchorButton), (0, _tslib.__assign)({}, action, {
            intent: undefined,
            onClick: this.handleActionClick
        }));
    };
    Toast.prototype.triggerDismiss = function(didTimeoutExpire) {
        var _a, _b;
        this.clearTimeouts();
        (_b = (_a = this.props).onDismiss) === null || _b === void 0 || _b.call(_a, didTimeoutExpire);
    };
    Toast.defaultProps = {
        className: "",
        isCloseButtonShown: true,
        message: "",
        timeout: 5000
    };
    Toast.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Toast");
    return Toast;
}((0, _common.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../../common/props":"dBcIV","../button/buttonGroup":"kDaEn","../button/buttons":"glm43","../icon/icon":"duMtK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQZYd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toast2", ()=>Toast2);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _props = require("../../common/props");
var _useTimeout = require("../../hooks/useTimeout");
var _buttonGroup = require("../button/buttonGroup");
var _buttons = require("../button/buttons");
var _icon = require("../icon/icon");
var Toast2 = _react.forwardRef(function(props, ref) {
    var action = props.action, className = props.className, icon = props.icon, intent = props.intent, isCloseButtonShown = props.isCloseButtonShown, message = props.message, onDismiss = props.onDismiss, timeout = props.timeout;
    var _a = _react.useState(false), isTimeoutStarted = _a[0], setIsTimeoutStarted = _a[1];
    var startTimeout = _react.useCallback(function() {
        return setIsTimeoutStarted(true);
    }, []);
    var clearTimeout = _react.useCallback(function() {
        return setIsTimeoutStarted(false);
    }, []);
    // Per docs: "Providing a value less than or equal to 0 will disable the timeout (this is discouraged)."
    var isTimeoutEnabled = timeout != null && timeout > 0;
    // timeout is triggered & cancelled by updating `isTimeoutStarted` state
    (0, _useTimeout.useTimeout)(function() {
        triggerDismiss(true);
    }, isTimeoutStarted && isTimeoutEnabled ? timeout : null);
    // start timeout on mount or change, cancel on unmount
    _react.useEffect(function() {
        if (isTimeoutEnabled) startTimeout();
        else clearTimeout();
        return clearTimeout;
    }, [
        clearTimeout,
        startTimeout,
        isTimeoutEnabled,
        timeout
    ]);
    var triggerDismiss = _react.useCallback(function(didTimeoutExpire) {
        clearTimeout();
        onDismiss === null || onDismiss === void 0 || onDismiss(didTimeoutExpire);
    }, [
        clearTimeout,
        onDismiss
    ]);
    var handleCloseClick = _react.useCallback(function() {
        return triggerDismiss(false);
    }, [
        triggerDismiss
    ]);
    var handleActionClick = _react.useCallback(function(e) {
        var _a;
        (_a = action === null || action === void 0 ? void 0 : action.onClick) === null || _a === void 0 || _a.call(action, e);
        triggerDismiss(false);
    }, [
        action,
        triggerDismiss
    ]);
    return _react.createElement("div", {
        className: (0, _classnamesDefault.default)((0, _common.Classes).TOAST, (0, _common.Classes).intentClass(intent), className),
        // Pause timeouts if users are hovering over or click on the toast. The toast may have
        // actions the user wants to click. It'd be a poor experience to "pull the toast" out
        // from under them.
        onBlur: startTimeout,
        onFocus: clearTimeout,
        onMouseEnter: clearTimeout,
        onMouseLeave: startTimeout,
        ref: ref,
        tabIndex: 0
    }, _react.createElement((0, _icon.Icon), {
        icon: icon
    }), _react.createElement("span", {
        className: (0, _common.Classes).TOAST_MESSAGE,
        role: "alert"
    }, message), _react.createElement((0, _buttonGroup.ButtonGroup), {
        minimal: true
    }, action && _react.createElement((0, _buttons.AnchorButton), (0, _tslib.__assign)({}, action, {
        intent: undefined,
        onClick: handleActionClick
    })), isCloseButtonShown && _react.createElement((0, _buttons.Button), {
        "aria-label": "Close",
        icon: _react.createElement((0, _icons.Cross), null),
        onClick: handleCloseClick
    })));
});
Toast2.defaultProps = {
    className: "",
    isCloseButtonShown: true,
    message: "",
    timeout: 5000
};
Toast2.displayName = "".concat((0, _props.DISPLAYNAME_PREFIX), ".Toast2");

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../../common/props":"dBcIV","../../hooks/useTimeout":"byWjr","../button/buttonGroup":"kDaEn","../button/buttons":"glm43","../icon/icon":"duMtK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byWjr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * React hook wrapper for setTimeout(), adapted from usehooks-ts.
 * The provided callback is invoked after the specified delay in milliseconds.
 * If the delay is null or the component is unmounted, any pending timeout is cleared.
 *
 * @see https://usehooks-ts.com/react-hook/use-timeout
 */ parcelHelpers.export(exports, "useTimeout", ()=>useTimeout);
var _react = require("react");
var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");
function useTimeout(callback, delay) {
    var savedCallback = _react.useRef(callback);
    // remember the latest callback if it changes
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // set up the timeout
    _react.useEffect(function() {
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) return;
        var id = setTimeout(function() {
            return savedCallback.current();
        }, delay);
        return function() {
            return clearTimeout(id);
        };
    }, [
        delay
    ]);
}

},{"react":"9njXz","./useIsomorphicLayoutEffect":"7cQbp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aQgrO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toaster", ()=>Toaster);
var _overlayToaster = require("./overlayToaster");
var Toaster = {
    // eslint-disable-next-line deprecation/deprecation
    create: deprecatedToasterCreate
};
/** @deprecated use OverlayToaster.create() instead */ function deprecatedToasterCreate(props, container) {
    if (container === void 0) container = document.body;
    return (0, _overlayToaster.OverlayToaster).create(props, container);
}

},{"./overlayToaster":"cTaXD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5bB9L":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tree", ()=>Tree);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _common = require("../../common");
var _treeNode = require("./treeNode");
/**
 * Tree component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tree
 */ // eslint-disable-next-line @typescript-eslint/ban-types
var Tree = /** @class */ function(_super) {
    (0, _tslib.__extends)(Tree, _super);
    function Tree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.nodeRefs = {};
        _this.handleContentRef = function(node, element) {
            if (element != null) _this.nodeRefs[node.id] = element;
            else // don't want our object to get bloated with old keys
            delete _this.nodeRefs[node.id];
        };
        _this.handleNodeCollapse = function(node, path, e) {
            var _a, _b;
            (_b = (_a = _this.props).onNodeCollapse) === null || _b === void 0 || _b.call(_a, node, path, e);
        };
        _this.handleNodeClick = function(node, path, e) {
            var _a, _b;
            (_b = (_a = _this.props).onNodeClick) === null || _b === void 0 || _b.call(_a, node, path, e);
        };
        _this.handleNodeContextMenu = function(node, path, e) {
            var _a, _b;
            (_b = (_a = _this.props).onNodeContextMenu) === null || _b === void 0 || _b.call(_a, node, path, e);
        };
        _this.handleNodeDoubleClick = function(node, path, e) {
            var _a, _b;
            (_b = (_a = _this.props).onNodeDoubleClick) === null || _b === void 0 || _b.call(_a, node, path, e);
        };
        _this.handleNodeExpand = function(node, path, e) {
            var _a, _b;
            (_b = (_a = _this.props).onNodeExpand) === null || _b === void 0 || _b.call(_a, node, path, e);
        };
        _this.handleNodeMouseEnter = function(node, path, e) {
            var _a, _b;
            (_b = (_a = _this.props).onNodeMouseEnter) === null || _b === void 0 || _b.call(_a, node, path, e);
        };
        _this.handleNodeMouseLeave = function(node, path, e) {
            var _a, _b;
            (_b = (_a = _this.props).onNodeMouseLeave) === null || _b === void 0 || _b.call(_a, node, path, e);
        };
        return _this;
    }
    Tree.ofType = function() {
        return Tree;
    };
    Tree.nodeFromPath = function(path, treeNodes) {
        if (path.length === 1) return treeNodes[path[0]];
        else return Tree.nodeFromPath(path.slice(1), treeNodes[path[0]].childNodes);
    };
    Tree.prototype.render = function() {
        var _a;
        return _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).TREE, this.props.className, (_a = {}, _a[(0, _common.Classes).COMPACT] = this.props.compact, _a))
        }, this.renderNodes(this.props.contents, [], (0, _common.Classes).TREE_ROOT));
    };
    /**
     * Returns the underlying HTML element of the `Tree` node with an id of `nodeId`.
     * This element does not contain the children of the node, only its label and controls.
     * If the node is not currently mounted, `undefined` is returned.
     */ Tree.prototype.getNodeContentElement = function(nodeId) {
        return this.nodeRefs[nodeId];
    };
    Tree.prototype.renderNodes = function(treeNodes, currentPath, className) {
        var _this = this;
        if (treeNodes == null) return null;
        var nodeItems = treeNodes.map(function(node, i) {
            var elementPath = currentPath.concat(i);
            return _react.createElement((0, _treeNode.TreeNode), (0, _tslib.__assign)({}, node, {
                key: node.id,
                contentRef: _this.handleContentRef,
                depth: elementPath.length - 1,
                onClick: _this.handleNodeClick,
                onContextMenu: _this.handleNodeContextMenu,
                onCollapse: _this.handleNodeCollapse,
                onDoubleClick: _this.handleNodeDoubleClick,
                onExpand: _this.handleNodeExpand,
                onMouseEnter: _this.handleNodeMouseEnter,
                onMouseLeave: _this.handleNodeMouseLeave,
                path: elementPath
            }), _this.renderNodes(node.childNodes, elementPath));
        });
        return _react.createElement("ul", {
            className: (0, _classnamesDefault.default)((0, _common.Classes).TREE_NODE_LIST, className)
        }, nodeItems);
    };
    Tree.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".Tree");
    return Tree;
}(_react.Component);

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","../../common":"3QDnh","./treeNode":"glI0J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"glI0J":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TreeNode", ()=>TreeNode);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _collapse = require("../collapse/collapse");
var _icon = require("../icon/icon");
/**
 * Tree node component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tree.tree-node
 */ // eslint-disable-next-line @typescript-eslint/ban-types
var TreeNode = /** @class */ function(_super) {
    (0, _tslib.__extends)(TreeNode, _super);
    function TreeNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCaretClick = function(e) {
            var _a;
            e.stopPropagation();
            var _b = _this.props, isExpanded = _b.isExpanded, onCollapse = _b.onCollapse, onExpand = _b.onExpand;
            (_a = isExpanded ? onCollapse : onExpand) === null || _a === void 0 || _a(_this.props, _this.props.path, e);
        };
        _this.handleClick = function(e) {
            var _a, _b;
            (_b = (_a = _this.props).onClick) === null || _b === void 0 || _b.call(_a, _this.props, _this.props.path, e);
        };
        _this.handleContentRef = function(element) {
            var _a, _b;
            (_b = (_a = _this.props).contentRef) === null || _b === void 0 || _b.call(_a, _this.props, element);
        };
        _this.handleContextMenu = function(e) {
            var _a, _b;
            (_b = (_a = _this.props).onContextMenu) === null || _b === void 0 || _b.call(_a, _this.props, _this.props.path, e);
        };
        _this.handleDoubleClick = function(e) {
            var _a, _b;
            (_b = (_a = _this.props).onDoubleClick) === null || _b === void 0 || _b.call(_a, _this.props, _this.props.path, e);
        };
        _this.handleMouseEnter = function(e) {
            var _a, _b;
            (_b = (_a = _this.props).onMouseEnter) === null || _b === void 0 || _b.call(_a, _this.props, _this.props.path, e);
        };
        _this.handleMouseLeave = function(e) {
            var _a, _b;
            (_b = (_a = _this.props).onMouseLeave) === null || _b === void 0 || _b.call(_a, _this.props, _this.props.path, e);
        };
        return _this;
    }
    /** @deprecated no longer necessary now that the TypeScript parser supports type arguments on JSX element tags */ TreeNode.ofType = function() {
        return TreeNode;
    };
    TreeNode.prototype.render = function() {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, disabled = _b.disabled, icon = _b.icon, isExpanded = _b.isExpanded, isSelected = _b.isSelected, label = _b.label;
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).TREE_NODE, (_a = {}, _a[(0, _common.Classes).DISABLED] = disabled, _a[(0, _common.Classes).TREE_NODE_SELECTED] = isSelected, _a[(0, _common.Classes).TREE_NODE_EXPANDED] = isExpanded, _a), className);
        var contentClasses = (0, _classnamesDefault.default)((0, _common.Classes).TREE_NODE_CONTENT, "".concat((0, _common.Classes).TREE_NODE_CONTENT, "-").concat(this.props.depth));
        var eventHandlers = disabled === true ? {} : {
            onClick: this.handleClick,
            onContextMenu: this.handleContextMenu,
            onDoubleClick: this.handleDoubleClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        };
        return _react.createElement("li", {
            className: classes
        }, _react.createElement("div", (0, _tslib.__assign)({
            className: contentClasses,
            ref: this.handleContentRef
        }, eventHandlers), this.maybeRenderCaret(), _react.createElement((0, _icon.Icon), {
            className: (0, _common.Classes).TREE_NODE_ICON,
            icon: icon,
            "aria-hidden": true,
            tabIndex: -1
        }), _react.createElement("span", {
            className: (0, _common.Classes).TREE_NODE_LABEL
        }, label), this.maybeRenderSecondaryLabel()), _react.createElement((0, _collapse.Collapse), {
            isOpen: isExpanded
        }, children));
    };
    TreeNode.prototype.maybeRenderCaret = function() {
        var _a = this.props, children = _a.children, isExpanded = _a.isExpanded, disabled = _a.disabled, _b = _a.hasCaret, hasCaret = _b === void 0 ? _react.Children.count(children) > 0 : _b;
        if (hasCaret) {
            var caretClasses = (0, _classnamesDefault.default)((0, _common.Classes).TREE_NODE_CARET, isExpanded ? (0, _common.Classes).TREE_NODE_CARET_OPEN : (0, _common.Classes).TREE_NODE_CARET_CLOSED);
            return _react.createElement((0, _icons.ChevronRight), {
                title: isExpanded ? "Collapse group" : "Expand group",
                className: caretClasses,
                onClick: disabled === true ? undefined : this.handleCaretClick
            });
        }
        return _react.createElement("span", {
            className: (0, _common.Classes).TREE_NODE_CARET_NONE
        });
    };
    TreeNode.prototype.maybeRenderSecondaryLabel = function() {
        if (this.props.secondaryLabel != null) return _react.createElement("span", {
            className: (0, _common.Classes).TREE_NODE_SECONDARY_LABEL
        }, this.props.secondaryLabel);
        else return undefined;
    };
    TreeNode.displayName = "".concat((0, _common.DISPLAYNAME_PREFIX), ".TreeNode");
    return TreeNode;
}(_react.Component);

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/icons":"bO9O5","../../common":"3QDnh","../collapse/collapse":"6TvyY","../icon/icon":"duMtK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5T3u5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** @fileoverview type aliases for backwards-compatibility with @blueprintjs/core v4.x */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractComponent2", ()=>(0, _abstractComponent.AbstractComponent));
parcelHelpers.export(exports, "AbstractPureComponent2", ()=>(0, _abstractPureComponent.AbstractPureComponent));
var _abstractComponent = require("./common/abstractComponent");
var _abstractPureComponent = require("./common/abstractPureComponent");

},{"./common/abstractComponent":"hwWE1","./common/abstractPureComponent":"bXQVd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9IlGS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @deprecated use `useHotkeys` hook or `<HotkeysTarget2>` component */ parcelHelpers.export(exports, "HotkeysTargetLegacy", ()=>HotkeysTargetLegacy);
var _tslib = require("tslib");
/**
 * @fileoverview This component is DEPRECATED, and the code is frozen.
 * All changes & bugfixes should be made to HotkeysTarget2 instead.
 */ /* eslint-disable deprecation/deprecation */ var _react = require("react");
var _utils = require("../common/utils");
var _hotkeysEvents = require("./hotkeysEvents");
var _legacyCommon = require("./legacyCommon");
var HOTKEYS_WARN_DECORATOR_NO_METHOD = "[Blueprint] @HotkeysTargetLegacy-decorated class should implement renderHotkeys.";
var HOTKEYS_WARN_DECORATOR_NEEDS_REACT_ELEMENT = "[Blueprint] \"@HotkeysTargetLegacy-decorated components must return a single React.JSX.Element or an empty render.";
function HotkeysTargetLegacy(WrappedComponent) {
    var _a;
    if (!(0, _utils.isFunction)(WrappedComponent.prototype.renderHotkeys)) console.warn(HOTKEYS_WARN_DECORATOR_NO_METHOD);
    return _a = /** @class */ function(_super) {
        (0, _tslib.__extends)(HotkeysTargetClass, _super);
        function HotkeysTargetClass() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /** @internal */ _this.globalHotkeysEvents = new (0, _hotkeysEvents.HotkeysEvents)((0, _hotkeysEvents.HotkeyScope).GLOBAL);
            /** @internal */ _this.localHotkeysEvents = new (0, _hotkeysEvents.HotkeysEvents)((0, _hotkeysEvents.HotkeyScope).LOCAL);
            return _this;
        }
        HotkeysTargetClass.prototype.componentDidMount = function() {
            if (_super.prototype.componentDidMount != null) _super.prototype.componentDidMount.call(this);
            // attach global key event listeners
            document.addEventListener("keydown", this.globalHotkeysEvents.handleKeyDown);
            document.addEventListener("keyup", this.globalHotkeysEvents.handleKeyUp);
        };
        HotkeysTargetClass.prototype.componentWillUnmount = function() {
            var _b;
            (_b = _super.prototype.componentWillUnmount) === null || _b === void 0 || _b.call(this);
            document.removeEventListener("keydown", this.globalHotkeysEvents.handleKeyDown);
            document.removeEventListener("keyup", this.globalHotkeysEvents.handleKeyUp);
            this.globalHotkeysEvents.clear();
            this.localHotkeysEvents.clear();
        };
        HotkeysTargetClass.prototype.render = function() {
            var _this = this;
            var element = _super.prototype.render.call(this);
            if (element == null) // always return `element` in case caller is distinguishing between `null` and `undefined`
            return element;
            if (!_react.isValidElement(element)) {
                console.warn(HOTKEYS_WARN_DECORATOR_NEEDS_REACT_ELEMENT);
                return element;
            }
            if ((0, _utils.isFunction)(this.renderHotkeys)) {
                var hotkeys = this.renderHotkeys();
                if (this.localHotkeysEvents) this.localHotkeysEvents.setHotkeys(hotkeys.props);
                if (this.globalHotkeysEvents) this.globalHotkeysEvents.setHotkeys(hotkeys.props);
                if (this.localHotkeysEvents.count() > 0) {
                    var tabIndex = hotkeys.props.tabIndex === undefined ? 0 : hotkeys.props.tabIndex;
                    var _b = element.props, existingKeyDown_1 = _b.onKeyDown, existingKeyUp_1 = _b.onKeyUp;
                    var handleKeyDownWrapper = function(e) {
                        _this.localHotkeysEvents.handleKeyDown(e.nativeEvent);
                        existingKeyDown_1 === null || existingKeyDown_1 === void 0 || existingKeyDown_1(e);
                    };
                    var handleKeyUpWrapper = function(e) {
                        _this.localHotkeysEvents.handleKeyUp(e.nativeEvent);
                        existingKeyUp_1 === null || existingKeyUp_1 === void 0 || existingKeyUp_1(e);
                    };
                    return _react.cloneElement(element, {
                        onKeyDown: handleKeyDownWrapper,
                        onKeyUp: handleKeyUpWrapper,
                        tabIndex: tabIndex
                    });
                }
            }
            return element;
        };
        return HotkeysTargetClass;
    }(WrappedComponent), _a.displayName = "HotkeysTarget(".concat((0, _legacyCommon.getDisplayName)(WrappedComponent), ")"), _a;
}

},{"tslib":"b4wpY","react":"9njXz","../common/utils":"56UdR","./hotkeysEvents":"5Rhum","./legacyCommon":"dhq18","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Rhum":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview This component is DEPRECATED, and the code is frozen.
 * All changes & bugfixes should be made to HotkeysDialog2 instead.
 */ /* eslint-disable deprecation/deprecation */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HotkeyScope", ()=>HotkeyScope);
parcelHelpers.export(exports, "HotkeysEvents", ()=>HotkeysEvents);
var _react = require("react");
var _utils = require("../common/utils");
var _hotkeys = require("../components/hotkeys");
var _hotkeyParser = require("../components/hotkeys/hotkeyParser");
var _hotkeysDialogLegacy = require("./hotkeysDialogLegacy");
var SHOW_DIALOG_KEY = "?";
var HotkeyScope;
(function(HotkeyScope) {
    HotkeyScope["LOCAL"] = "local";
    HotkeyScope["GLOBAL"] = "global";
})(HotkeyScope || (HotkeyScope = {}));
var HotkeysEvents = /** @class */ function() {
    function HotkeysEvents(scope) {
        var _this = this;
        this.scope = scope;
        this.actions = [];
        this.handleKeyDown = function(e) {
            var combo = (0, _hotkeyParser.getKeyCombo)(e);
            var isTextInput = _this.isTextInput(e);
            if (!isTextInput && (0, _hotkeyParser.comboMatches)((0, _hotkeyParser.parseKeyCombo)(SHOW_DIALOG_KEY), combo)) {
                if ((0, _hotkeysDialogLegacy.isHotkeysDialogShowing)()) (0, _hotkeysDialogLegacy.hideHotkeysDialogAfterDelay)();
                else (0, _hotkeysDialogLegacy.showHotkeysDialog)(_this.actions.map(function(action) {
                    return action.props;
                }));
                return;
            } else if ((0, _hotkeysDialogLegacy.isHotkeysDialogShowing)()) return;
            _this.invokeNamedCallbackIfComboRecognized(combo, "onKeyDown", e);
        };
        this.handleKeyUp = function(e) {
            if ((0, _hotkeysDialogLegacy.isHotkeysDialogShowing)()) return;
            _this.invokeNamedCallbackIfComboRecognized((0, _hotkeyParser.getKeyCombo)(e), "onKeyUp", e);
        };
    }
    HotkeysEvents.prototype.count = function() {
        return this.actions.length;
    };
    HotkeysEvents.prototype.clear = function() {
        this.actions = [];
    };
    HotkeysEvents.prototype.setHotkeys = function(props) {
        var _this = this;
        var actions = [];
        (0, _react.Children).forEach(props.children, function(child) {
            if ((0, _utils.isElementOfType)(child, (0, _hotkeys.Hotkey)) && _this.isScope(child.props)) actions.push({
                combo: (0, _hotkeyParser.parseKeyCombo)(child.props.combo),
                props: child.props
            });
        });
        this.actions = actions;
    };
    HotkeysEvents.prototype.invokeNamedCallbackIfComboRecognized = function(combo, callbackName, e) {
        var _a, _b;
        var isTextInput = this.isTextInput(e);
        for(var _i = 0, _c = this.actions; _i < _c.length; _i++){
            var action = _c[_i];
            var shouldIgnore = isTextInput && !action.props.allowInInput || action.props.disabled;
            if (!shouldIgnore && (0, _hotkeyParser.comboMatches)(action.combo, combo)) {
                if (action.props.preventDefault) e.preventDefault();
                if (action.props.stopPropagation) {
                    // set a flag just for unit testing. not meant to be referenced in feature work.
                    e.isPropagationStopped = true;
                    e.stopPropagation();
                }
                (_b = (_a = action.props)[callbackName]) === null || _b === void 0 || _b.call(_a, e);
            }
        }
    };
    HotkeysEvents.prototype.isScope = function(props) {
        return (props.global ? HotkeyScope.GLOBAL : HotkeyScope.LOCAL) === this.scope;
    };
    HotkeysEvents.prototype.isTextInput = function(e) {
        var elem = e.target;
        // we check these cases for unit testing, but this should not happen
        // during normal operation
        if (elem == null || elem.closest == null) return false;
        var editable = elem.closest("input, textarea, [contenteditable=true]");
        if (editable == null) return false;
        // don't let checkboxes, switches, and radio buttons prevent hotkey behavior
        if (editable.tagName.toLowerCase() === "input") {
            var inputType = editable.type;
            if (inputType === "checkbox" || inputType === "radio") return false;
        }
        // don't let read-only fields prevent hotkey behavior
        if (editable.readOnly) return false;
        return true;
    };
    return HotkeysEvents;
}();

},{"react":"9njXz","../common/utils":"56UdR","../components/hotkeys":"bcidX","../components/hotkeys/hotkeyParser":"h9nCe","./hotkeysDialogLegacy":"gsHhS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gsHhS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @deprecated use HotkeysProvider */ parcelHelpers.export(exports, "isHotkeysDialogShowing", ()=>isHotkeysDialogShowing);
/** @deprecated use HotkeysProvider */ parcelHelpers.export(exports, "setHotkeysDialogProps", ()=>setHotkeysDialogProps);
/** @deprecated use HotkeysProvider */ parcelHelpers.export(exports, "showHotkeysDialog", ()=>showHotkeysDialog);
/** @deprecated use HotkeysProvider */ parcelHelpers.export(exports, "hideHotkeysDialog", ()=>hideHotkeysDialog);
/**
 * Use this function instead of `hideHotkeysDialog` if you need to ensure that all hotkey listeners
 * have time to execute with the dialog in a consistent open state. This can avoid flickering the
 * dialog between open and closed states as successive listeners fire.
 *
 * @deprecated use HotkeysProvider
 */ parcelHelpers.export(exports, "hideHotkeysDialogAfterDelay", ()=>hideHotkeysDialogAfterDelay);
var _tslib = require("tslib");
/**
 * @fileoverview This component is DEPRECATED, and the code is frozen.
 * All changes & bugfixes should be made to HotkeysDialog2 instead.
 */ /* eslint-disable deprecation/deprecation */ var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDom = require("react-dom");
var _common = require("../common");
var _components = require("../components");
/**
 * The delay before showing or hiding the dialog. Should be long enough to
 * allow all registered hotkey listeners to execute first.
 */ var DELAY_IN_MS = 10;
/** @deprecated use HotkeysDialog2 */ var HotkeysDialogLegacy = /** @class */ function() {
    function HotkeysDialogLegacy() {
        var _this = this;
        this.componentProps = {
            globalHotkeysGroup: "Global hotkeys"
        };
        this.container = null;
        this.hotkeysQueue = [];
        this.isDialogShowing = false;
        this.show = function() {
            _this.isDialogShowing = true;
            _this.render();
        };
        this.hide = function() {
            _this.isDialogShowing = false;
            _this.render();
        };
    }
    HotkeysDialogLegacy.prototype.render = function() {
        if (this.container == null) this.container = this.getContainer();
        _reactDom.render(this.renderComponent(), this.container);
    };
    HotkeysDialogLegacy.prototype.unmount = function() {
        if (this.container != null) {
            _reactDom.unmountComponentAtNode(this.container);
            this.container.remove();
            this.container = null;
        }
    };
    /**
     * Because hotkeys can be registered globally and locally and because
     * event ordering cannot be guaranteed, we use this debouncing method to
     * allow all hotkey listeners to fire and add their hotkeys to the dialog.
     *
     * 10msec after the last listener adds their hotkeys, we render the dialog
     * and clear the queue.
     */ HotkeysDialogLegacy.prototype.enqueueHotkeysForDisplay = function(hotkeys) {
        this.hotkeysQueue.push(hotkeys);
        // reset timeout for debounce
        window.clearTimeout(this.showTimeoutToken);
        this.showTimeoutToken = window.setTimeout(this.show, DELAY_IN_MS);
    };
    HotkeysDialogLegacy.prototype.hideAfterDelay = function() {
        window.clearTimeout(this.hideTimeoutToken);
        this.hideTimeoutToken = window.setTimeout(this.hide, DELAY_IN_MS);
    };
    HotkeysDialogLegacy.prototype.isShowing = function() {
        return this.isDialogShowing;
    };
    HotkeysDialogLegacy.prototype.getContainer = function() {
        if (this.container == null) {
            this.container = document.createElement("div");
            this.container.classList.add((0, _common.Classes).PORTAL);
            document.body.appendChild(this.container);
        }
        return this.container;
    };
    HotkeysDialogLegacy.prototype.renderComponent = function() {
        return _react.createElement((0, _components.Dialog), (0, _tslib.__assign)({}, this.componentProps, {
            className: (0, _classnamesDefault.default)((0, _common.Classes).HOTKEY_DIALOG, this.componentProps.className),
            isOpen: this.isDialogShowing,
            onClose: this.hide
        }), _react.createElement((0, _components.DialogBody), null, this.renderHotkeys()));
    };
    HotkeysDialogLegacy.prototype.renderHotkeys = function() {
        var _this = this;
        var hotkeys = this.emptyHotkeyQueue();
        var elements = hotkeys.map(function(hotkey, index) {
            var group = hotkey.global === true && hotkey.group == null ? _this.componentProps.globalHotkeysGroup : hotkey.group;
            return _react.createElement((0, _components.Hotkey), (0, _tslib.__assign)({
                key: index
            }, hotkey, {
                group: group
            }));
        });
        return _react.createElement((0, _components.Hotkeys), null, elements);
    };
    HotkeysDialogLegacy.prototype.emptyHotkeyQueue = function() {
        // flatten then empty the hotkeys queue
        var hotkeys = this.hotkeysQueue.reduce(function(arr, queued) {
            return arr.concat(queued);
        }, []);
        this.hotkeysQueue.length = 0;
        return hotkeys;
    };
    return HotkeysDialogLegacy;
}();
// singleton instance
var HOTKEYS_DIALOG = new HotkeysDialogLegacy();
function isHotkeysDialogShowing() {
    return HOTKEYS_DIALOG.isShowing();
}
function setHotkeysDialogProps(props) {
    for(var key in props)if (props.hasOwnProperty(key)) HOTKEYS_DIALOG.componentProps[key] = props[key];
}
function showHotkeysDialog(hotkeys) {
    HOTKEYS_DIALOG.enqueueHotkeysForDisplay(hotkeys);
}
function hideHotkeysDialog() {
    HOTKEYS_DIALOG.hide();
}
function hideHotkeysDialogAfterDelay() {
    HOTKEYS_DIALOG.hideAfterDelay();
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","react-dom":"2ApDx","../common":"3QDnh","../components":"6Av90","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dhq18":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDisplayName", ()=>getDisplayName);
function getDisplayName(ComponentClass) {
    return ComponentClass.displayName || ComponentClass.name || "Unknown";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lpIlT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTEXTMENU_WARN_DECORATOR_NO_METHOD", ()=>CONTEXTMENU_WARN_DECORATOR_NO_METHOD);
parcelHelpers.export(exports, "CONTEXTMENU_WARN_DECORATOR_NEEDS_REACT_ELEMENT", ()=>CONTEXTMENU_WARN_DECORATOR_NEEDS_REACT_ELEMENT);
/**
 * ContextMenuTarget decorator.
 *
 * @see https://blueprintjs.com/docs/#core/components/context-menu.decorator-usage
 * @deprecated use ContextMenu2
 */ parcelHelpers.export(exports, "ContextMenuTargetLegacy", ()=>ContextMenuTargetLegacy);
var _tslib = require("tslib");
/**
 * @fileoverview This component is DEPRECATED, and the code is frozen.
 * All changes & bugfixes should be made to ContextMenu2 instead.
 */ /* eslint-disable deprecation/deprecation */ var _react = require("react");
var _reactDom = require("react-dom");
var _utils = require("../common/utils");
var _contextMenuLegacy = require("./contextMenuLegacy");
var _legacyCommon = require("./legacyCommon");
var CONTEXTMENU_WARN_DECORATOR_NO_METHOD = "[Blueprint] @ContextMenuTarget-decorated class should implement renderContextMenu.";
var CONTEXTMENU_WARN_DECORATOR_NEEDS_REACT_ELEMENT = "[Blueprint] \"@ContextMenuTarget-decorated components must return a single React.JSX.Element or an empty render.";
function ContextMenuTargetLegacy(WrappedComponent) {
    var _a;
    if (!(0, _utils.isFunction)(WrappedComponent.prototype.renderContextMenu)) console.warn(CONTEXTMENU_WARN_DECORATOR_NO_METHOD);
    return _a = /** @class */ function(_super) {
        (0, _tslib.__extends)(ContextMenuTargetClass, _super);
        function ContextMenuTargetClass() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ContextMenuTargetClass.prototype.render = function() {
            var _this = this;
            var element = _super.prototype.render.call(this);
            if (element == null) // always return `element` in case caller is distinguishing between `null` and `undefined`
            return element;
            if (!_react.isValidElement(element)) {
                console.warn(CONTEXTMENU_WARN_DECORATOR_NEEDS_REACT_ELEMENT);
                return element;
            }
            var oldOnContextMenu = element.props.onContextMenu;
            var onContextMenu = function(e) {
                // support nested menus (inner menu target would have called preventDefault())
                if (e.defaultPrevented) return;
                if ((0, _utils.isFunction)(_this.renderContextMenu)) {
                    var menu = _this.renderContextMenu(e);
                    if (menu != null) {
                        // HACKHACK: see https://github.com/palantir/blueprint/issues/3979
                        /* eslint-disable-next-line react/no-find-dom-node */ var darkTheme = (0, _utils.isDarkTheme)(_reactDom.findDOMNode(_this));
                        e.preventDefault();
                        (0, _contextMenuLegacy.show)(menu, {
                            left: e.clientX,
                            top: e.clientY
                        }, _this.onContextMenuClose, darkTheme);
                    }
                }
                oldOnContextMenu === null || oldOnContextMenu === void 0 || oldOnContextMenu(e);
            };
            return _react.cloneElement(element, {
                onContextMenu: onContextMenu
            });
        };
        return ContextMenuTargetClass;
    }(WrappedComponent), _a.displayName = "ContextMenuTarget(".concat((0, _legacyCommon.getDisplayName)(WrappedComponent), ")"), _a;
}

},{"tslib":"b4wpY","react":"9njXz","react-dom":"2ApDx","../common/utils":"56UdR","./contextMenuLegacy":"braDG","./legacyCommon":"dhq18","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"braDG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Show the given menu element at the given offset from the top-left corner of the viewport.
 * The menu will appear below-right of this point and will flip to below-left if there is not enough
 * room onscreen. The optional callback will be invoked when this menu closes.
 *
 * @deprecated use ContextMenu2
 */ parcelHelpers.export(exports, "show", ()=>show);
/** Hide the open context menu. */ parcelHelpers.export(exports, "hide", ()=>hide);
/** Return whether a context menu is currently open. */ parcelHelpers.export(exports, "isOpen", ()=>isOpen);
var _tslib = require("tslib");
/**
 * @fileoverview This component is DEPRECATED, and the code is frozen.
 * All changes & bugfixes should be made to ContextMenu2 instead.
 */ /* eslint-disable deprecation/deprecation */ var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDom = require("react-dom");
var _common = require("../common");
var _popover = require("../components/popover/popover");
var TRANSITION_DURATION = 100;
/* istanbul ignore next */ /** @deprecated use ContextMenu */ var ContextMenuLegacy = /** @class */ function(_super) {
    (0, _tslib.__extends)(ContextMenuLegacy, _super);
    function ContextMenuLegacy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isDarkTheme: false,
            isOpen: false
        };
        _this.cancelContextMenu = function(e) {
            return e.preventDefault();
        };
        _this.handleBackdropContextMenu = function(e) {
            // React function to remove from the event pool, useful when using a event within a callback
            e.persist();
            e.preventDefault();
            // wait for backdrop to disappear so we can find the "real" element at event coordinates.
            // timeout duration is equivalent to transition duration so we know it's animated out.
            _this.setTimeout(function() {
                // retrigger context menu event at the element beneath the backdrop.
                // if it has a `contextmenu` event handler then it'll be invoked.
                // if it doesn't, no native menu will show (at least on OSX) :(
                var newTarget = document.elementFromPoint(e.clientX, e.clientY);
                var view = e.view, newEventInit = (0, _tslib.__rest)(e, [
                    "view"
                ]);
                newTarget === null || newTarget === void 0 || newTarget.dispatchEvent(new MouseEvent("contextmenu", newEventInit));
            }, TRANSITION_DURATION);
        };
        _this.handlePopoverInteraction = function(nextOpenState) {
            if (!nextOpenState) // delay the actual hiding till the event queue clears
            // to avoid flicker of opening twice
            _this.requestAnimationFrame(function() {
                return _this.hide();
            });
        };
        return _this;
    }
    ContextMenuLegacy.prototype.render = function() {
        var _a;
        // prevent right-clicking in a context menu
        var content = _react.createElement("div", {
            onContextMenu: this.cancelContextMenu
        }, this.state.menu);
        var popoverClassName = (0, _classnamesDefault.default)((_a = {}, _a[(0, _common.Classes).DARK] = this.state.isDarkTheme, _a));
        // HACKHACK: workaround until we have access to Popper#scheduleUpdate().
        // https://github.com/palantir/blueprint/issues/692
        // Generate key based on offset so a new Popover instance is created
        // when offset changes, to force recomputing position.
        var key = this.state.offset === undefined ? "" : "".concat(this.state.offset.left, "x").concat(this.state.offset.top);
        // wrap the popover in a positioned div to make sure it is properly
        // offset on the screen.
        return _react.createElement("div", {
            className: (0, _common.Classes).CONTEXT_MENU,
            style: this.state.offset
        }, _react.createElement((0, _popover.Popover), (0, _tslib.__assign)({}, this.props, {
            backdropProps: {
                onContextMenu: this.handleBackdropContextMenu
            },
            content: content,
            enforceFocus: false,
            key: key,
            hasBackdrop: true,
            isOpen: this.state.isOpen,
            minimal: true,
            rootBoundary: "viewport",
            onInteraction: this.handlePopoverInteraction,
            placement: "right-start",
            popoverClassName: popoverClassName,
            transitionDuration: TRANSITION_DURATION
        }), _react.createElement("div", null)));
    };
    ContextMenuLegacy.prototype.show = function(menu, offset, onClose, isDarkTheme) {
        if (isDarkTheme === void 0) isDarkTheme = false;
        this.setState({
            isOpen: true,
            menu: menu,
            offset: offset,
            onClose: onClose,
            isDarkTheme: isDarkTheme
        });
    };
    ContextMenuLegacy.prototype.hide = function() {
        var _a, _b;
        (_b = (_a = this.state).onClose) === null || _b === void 0 || _b.call(_a);
        this.setState({
            isOpen: false,
            onClose: undefined
        });
    };
    return ContextMenuLegacy;
}((0, _common.AbstractPureComponent));
var contextMenuElement;
var contextMenu;
function show(menu, offset, onClose, isDarkTheme) {
    if (contextMenuElement === undefined) {
        contextMenuElement = document.createElement("div");
        contextMenuElement.classList.add((0, _common.Classes).CONTEXT_MENU);
        document.body.appendChild(contextMenuElement);
        contextMenu = _reactDom.render(_react.createElement(ContextMenuLegacy, {
            onClosed: remove
        }), contextMenuElement);
    }
    contextMenu.show(menu, offset, onClose, isDarkTheme);
}
function hide() {
    contextMenu === null || contextMenu === void 0 || contextMenu.hide();
}
function isOpen() {
    return contextMenu != null && contextMenu.state.isOpen;
}
function remove() {
    if (contextMenuElement != null) {
        _reactDom.unmountComponentAtNode(contextMenuElement);
        contextMenuElement.remove();
        contextMenuElement = undefined;
        contextMenu = undefined;
    }
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","react-dom":"2ApDx","../common":"3QDnh","../components/popover/popover":"2UrEu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"knnT1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActiveLink", ()=>m);
parcelHelpers.export(exports, "Link", ()=>p);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "navigate", ()=>navigate);
parcelHelpers.export(exports, "useBasePath", ()=>useBasePath);
parcelHelpers.export(exports, "useFullPath", ()=>useFullPath);
parcelHelpers.export(exports, "useHash", ()=>useHash);
parcelHelpers.export(exports, "useLocationChange", ()=>useLocationChange);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigationPrompt", ()=>useNavigationPrompt);
parcelHelpers.export(exports, "usePath", ()=>usePath);
parcelHelpers.export(exports, "usePathParams", ()=>usePathParams);
parcelHelpers.export(exports, "useQueryParams", ()=>useQueryParams);
parcelHelpers.export(exports, "useRedirect", ()=>useRedirect);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const c = (0, _react.createContext)(""), l = (0, _react.createContext)(null);
function RouterProvider({ basePath: e = "", path: n, children: r }) {
    return (0, _reactDefault.default).createElement(c.Provider, {
        value: e
    }, (0, _reactDefault.default).createElement(l.Provider, {
        value: null != n ? n : null
    }, r));
}
let h = !0;
try {
    h = void 0 === window;
} catch (t) {}
const d = new Set;
let g = !1, f = !1, P = [
    0,
    0
];
function shouldCancelNavigation() {
    return P = [
        window.scrollX,
        window.scrollY
    ], g ? f : Array.from(d).some((t)=>{
        const e = t();
        return !!e && (f = !window.confirm(e), g = !0, setTimeout(()=>{
            g = !1, f = !1;
        }, 0), f);
    });
}
function usePath(t) {
    const e = (0, _react.useContext)(l), n = useBasePath();
    t = t || n;
    const [r, i] = (0, _react.useState)(getFormattedPath(t));
    return useLocationChange((t)=>i(t), {
        basePath: t,
        inheritBasePath: !t
    }), e || r;
}
function useBasePath() {
    return (0, _react.useContext)(c);
}
function useFullPath() {
    const [t, e] = (0, _react.useState)(getCurrentPath());
    return useLocationChange(e, {
        inheritBasePath: !1
    }), t || "/";
}
function useHash({ stripHash: t = !0 } = {}) {
    const [e, n] = (0, _react.useState)(window.location.hash), a = (0, _react.useCallback)(()=>{
        window.location.hash !== e && n(window.location.hash);
    }, [
        n,
        e
    ]);
    return (0, _react.useLayoutEffect)(()=>(window.addEventListener("hashchange", a, !1), ()=>window.removeEventListener("hashchange", a)), [
        a
    ]), useLocationChange(a), t ? e.substring(1) : e;
}
function getCurrentPath() {
    return h ? "/" : window.location.pathname || "/";
}
function getCurrentHash() {
    if (h) {
        const t = "/", e = t.indexOf("#");
        return t.substring(e);
    }
    return window.location.hash;
}
function useLocationChange(t, { inheritBasePath: e = !0, basePath: a = "", isActive: o, onInitial: s = !1 } = {}) {
    if (h) return;
    const u = useBasePath();
    e && u && (a = u);
    const c = (0, _react.useRef)(t);
    (0, _react.useLayoutEffect)(()=>{
        c.current = t;
    });
    const l = (0, _react.useCallback)(()=>{
        (void 0 === o || isPredicateActive(o)) && (shouldCancelNavigation() || c.current(getFormattedPath(a)));
    }, [
        o,
        a
    ]);
    (0, _react.useLayoutEffect)(()=>(window.addEventListener("popstate", l), ()=>window.removeEventListener("popstate", l)), [
        l
    ]), function useMountedLayout(t, e, { onInitial: a = !1 } = {}) {
        const o = (0, _react.useRef)(a);
        (0, _react.useLayoutEffect)(()=>{
            o.current ? t() : o.current = !0;
        }, e);
    }(()=>{
        (void 0 === o || isPredicateActive(o)) && c.current(getFormattedPath(a));
    }, [
        a,
        o
    ], {
        onInitial: s
    });
}
function getFormattedPath(t) {
    const e = getCurrentPath(), n = t && !function isPathInBase(t, e) {
        return !!(t && e && e.toLowerCase().startsWith(t.toLowerCase()));
    }(t, e);
    return null === e || n ? null : decodeURIComponent(t ? e.replace(function basePathMatcher(t) {
        return new RegExp("^" + t, "i");
    }(t), "") || "/" : e);
}
function isPredicateActive(t) {
    return function isFunction(t) {
        return t && "function" == typeof t;
    }(t) ? t() : t;
}
const v = [
    null,
    null
];
function useRoutes(e, { basePath: n = "", routeProps: a = {}, overridePathParams: i = !0, matchTrailingSlash: s = !0 } = {}) {
    const u = usePath(n) && getFormattedPath(n);
    !function useRedirectDetection(t, e) {
        const [, n] = (0, _react.useState)(!1);
        (0, _react.useLayoutEffect)(()=>{
            e !== getFormattedPath(t) && n((t)=>!t);
        }, [
            t,
            e
        ]);
    }(n, u);
    const c = function useMatchRoute(t, e, { routeProps: n, overridePathParams: r, matchTrailingSlash: a }) {
        e = trailingMatch(e, a);
        const o = useMatchers(Object.keys(t));
        if (null === e) return null;
        const [i, s] = getMatchParams(e, o);
        return i ? t[i.path](r ? {
            ...s,
            ...n
        } : {
            ...n,
            ...s
        }) : null;
    }(e, u, {
        routeProps: a,
        overridePathParams: i,
        matchTrailingSlash: s
    });
    return c && null !== u ? (0, _reactDefault.default).createElement(RouterProvider, {
        basePath: n,
        path: u
    }, c) : null;
}
function usePathParams(t, e = {}) {
    const n = !Array.isArray(t), [r, a] = usePathOptions(t, e);
    if (null === r) return n ? null : v;
    const [o, i] = getMatchParams(r, a);
    return o ? n ? i : [
        o.path,
        i
    ] : n ? null : v;
}
function useMatch(t, e = {}) {
    var n;
    const [r, a] = usePathOptions(t, e), o = a.find(({ regex: t })=>null == r ? void 0 : r.match(t));
    return null !== (n = null == o ? void 0 : o.path) && void 0 !== n ? n : null;
}
function usePathOptions(t, { basePath: e, matchTrailingSlash: n = !0 }) {
    const r = useMatchers(Array.isArray(t) ? t : [
        t
    ]);
    return [
        trailingMatch(usePath(e), n),
        r
    ];
}
function useMatchers(t) {
    var e;
    return (0, _react.useMemo)(()=>t.map(createRouteMatcher), [
        (e = t, [
            ...e
        ].sort().join(":"))
    ]);
}
function getMatchParams(t, e) {
    let n = null;
    const r = e.find(({ regex: e })=>(n = t.match(e), !!n));
    if (!r || null === n) return v;
    const a = r.props.reduce((t, e, r)=>(t[e] = n[r + 1], t), {});
    return [
        r,
        a
    ];
}
function createRouteMatcher(t) {
    var e, n;
    return {
        path: t,
        regex: new RegExp(`${"*" === t.substr(0, 1) ? "" : "^"}${(n = t, n.replace(/[-\\^$+?.()|[\]{}]/g, "\\$&")).replace(/:[a-zA-Z]+/g, "([^/]+)").replace(/\*/g, "")}${"*" === t.substr(-1) ? "" : "$"}`, "i"),
        props: (null !== (e = t.match(/:[a-zA-Z]+/g)) && void 0 !== e ? e : []).map((t)=>t.substr(1))
    };
}
function trailingMatch(t, e) {
    return null === t || e && t && "/" === t[t.length - 1] && t.length > 1 && (t = t.substring(0, t.length - 1)), t;
}
let w = "";
function navigate(t, e, n, r = null) {
    if ("string" != typeof t) throw new Error('"url" must be a string, was provided a(n) ' + typeof t);
    if (Array.isArray(e)) throw new Error('"replaceOrQuery" must be boolean, object, or URLSearchParams');
    if (shouldCancelNavigation()) return;
    if (null !== e && "object" == typeof e ? t += "?" + new URLSearchParams(e).toString() : void 0 === n && void 0 !== e ? n = null != e ? e : void 0 : void 0 === n && void 0 === e && (n = !1), w = t, function isAbsolute(t) {
        return /^(?:[a-z]+:)?\/\//i.test(t);
    }(t) && !function isCurrentOrigin(t) {
        return window.location.origin === new URL(t).origin;
    }(t)) return void window.location.assign(t);
    n ? window.history.replaceState(r, "", t) : window.history.pushState(r, "", t);
    const a = new PopStateEvent("popstate");
    a.__tag = "raviger:navigation", dispatchEvent(a);
}
function useNavigationPrompt(t = !0, e = "Are you sure you want to leave this page?") {
    h || ((0, _react.useLayoutEffect)(()=>{
        const onPopStateNavigation = ()=>{
            shouldCancelNavigation() && function undoNavigation(t) {
                window.history.pushState(null, null, t), setTimeout(()=>{
                    window.scrollTo(...P);
                }, 0);
            }(w);
        };
        return window.addEventListener("popstate", onPopStateNavigation), ()=>window.removeEventListener("popstate", onPopStateNavigation);
    }, []), (0, _react.useLayoutEffect)(()=>{
        const handler = (n)=>{
            if (t) return n ? function cancelNavigation(t, e) {
                return t.preventDefault(), t.returnValue = e, e;
            }(n, e) : e;
        };
        return function addInterceptor(t) {
            window.addEventListener("beforeunload", t), d.add(t);
        }(handler), ()=>(function removeInterceptor(t) {
                window.removeEventListener("beforeunload", t), d.delete(t);
            })(handler);
    }, [
        t,
        e
    ]));
}
function useNavigate(t = "") {
    const e = useBasePath();
    return (0, _react.useCallback)((n, r, a)=>{
        const o = t || e;
        navigate(n.startsWith("/") ? o + n : n, r, a);
    }, [
        e,
        t
    ]);
}
function useQueryParams(t = parseQuery, e = serializeQuery) {
    const [n, r] = (0, _react.useState)(getQueryString()), a = (0, _react.useCallback)((r, { replace: a = !0 } = {})=>{
        let o = getCurrentPath();
        r = a ? r : {
            ...t(n),
            ...r
        };
        const i = e(r).toString();
        i && (o += "?" + i), a || (o += getCurrentHash()), navigate(o);
    }, [
        n,
        t,
        e
    ]);
    return useLocationChange((0, _react.useCallback)(()=>r(getQueryString()), [])), [
        t(n),
        a
    ];
}
function parseQuery(t) {
    const e = new URLSearchParams(t);
    return Object.fromEntries(e.entries());
}
function serializeQuery(t) {
    return new URLSearchParams(Object.entries(t).filter(([, t])=>null !== t)).toString();
}
function getQueryString() {
    if (h) {
        const t = "/", e = t.indexOf("?");
        return -1 === e ? "" : t.substring(e + 1);
    }
    return window.location.search;
}
function Redirect({ to: t, query: e, replace: n = !0, merge: r = !0 }) {
    return useRedirect(usePath(), t, {
        query: e,
        replace: n,
        merge: r
    }), null;
}
function useRedirect(t, e, { query: n, replace: a = !0, merge: o = !0 } = {}) {
    const i = usePath(), [s] = useQueryParams(), u = getCurrentHash();
    let c = e;
    const l = new URLSearchParams({
        ...o ? s : {},
        ...n
    }).toString();
    l && (c += "?" + l), o && u && u.length && (c += u), (0, _react.useLayoutEffect)(()=>{
        i === t && navigate(c, void 0, a);
    }, [
        t,
        c,
        a,
        i
    ]);
}
const p = (0, _react.forwardRef)(function Link({ href: e, basePath: n, ...r }, a) {
    e = getLinkHref(e, n = useLinkBasePath(n));
    const { onClick: o, target: s } = r, u = (0, _react.useCallback)((t)=>{
        try {
            o && o(t);
        } catch (e) {
            throw t.preventDefault(), e;
        }
        (function shouldTrap(t, e) {
            return !t.defaultPrevented && 0 === t.button && !(e || "_self" === e) && !(t.metaKey || t.altKey || t.ctrlKey || t.shiftKey);
        })(t, s) && (t.preventDefault(), navigate(t.currentTarget.href));
    }, [
        o,
        s
    ]);
    return (0, _reactDefault.default).createElement("a", {
        ...r,
        href: e,
        onClick: u,
        ref: a
    });
});
const m = (0, _react.forwardRef)(function ActiveLink({ basePath: e, className: n, exactActiveClass: r, activeClass: a, ...o }, i) {
    e = useLinkBasePath(e);
    const s = useFullPath();
    let { href: u } = o;
    return u = function absolutePathName(t) {
        return t.startsWith("/") ? t : new URL(t, document.baseURI).pathname;
    }(getLinkHref(u, e)), r && s === u && (n += ` ${r}`), a && s.startsWith(u) && (n += ` ${a}`), (0, _reactDefault.default).createElement(p, {
        ...o,
        basePath: e,
        className: n,
        ref: i
    });
});
function useLinkBasePath(t) {
    const e = useBasePath();
    return "/" === t ? "" : t || e;
}
function getLinkHref(t, e = "") {
    return t.startsWith("/") ? e + t : t;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4AVaN":[function(require,module,exports,__globalThis) {
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});

},{}],"1e4qG":[function(require,module,exports,__globalThis) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

},{}],"8RKt0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("./TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _users = require("../api/Users");
var _userSlice = require("../slices/UserSlice");
class Login extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.username_input_ref = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        this.password_input_ref = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        this.login = this.login.bind(this);
        this.state = {
            username: '',
            password: '',
            failed_login: false
        };
    }
    componentDidMount() {
        if (this.username_input_ref.current !== null) this.username_input_ref.current.focus();
    }
    async login(e) {
        e.preventDefault();
        const response = await (0, _users.login)(this.props.api_url, this.state.username, this.state.password);
        if (response.error_code === 20002 || response.error_code === 20003) {
            this.setState({
                failed_login: true,
                reason: response.error_code
            });
            if (this.password_input_ref.current !== null) {
                this.password_input_ref.current.focus();
                this.password_input_ref.current.select();
            }
        } else this.props.setUser(response);
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col flex-grow justify-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Card), {
                    className: "w-64 p-8 pl-16 pr-16 mx-auto box-content",
                    elevation: (0, _core.Elevation).TWO,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                className: "bp5-heading text-center mb-6",
                                style: {
                                    color: '#394b59'
                                },
                                children: this.props.title || 'Prijava v aplikacijo AssistPRO'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                className: "flex flex-col items-center",
                                onSubmit: this.login,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex flex-1 flex-col mb-2 w-64",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "form--username",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: "Uporabni\u0161ko ime",
                                                    tooltip: "Uporabni\u0161ko ime"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                    id: "form--username",
                                                    inputRef: this.username_input_ref,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            username: event.target.value,
                                                            failed_login: false
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex flex-1 flex-col mb-2 w-64",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "form--password",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: "Geslo",
                                                    tooltip: "Geslo"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                    id: "form--password",
                                                    type: "password",
                                                    inputRef: this.password_input_ref,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            password: event.target.value,
                                                            failed_login: false
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex flex-row justify-end w-64",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            icon: "log-in",
                                            type: "submit",
                                            onClick: this.login,
                                            intent: "primary",
                                            children: "Prijava"
                                        })
                                    }),
                                    !this.state.failed_login ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-red-700 pt-4",
                                        children: (()=>{
                                            if (this.state.reason == 20002) return "Napa\u010Dno uporabni\u0161ko ime ali geslo";
                                            else if (this.state.reason == 20003) return 'Uporabnik neaktiven';
                                            return 'Neznana napaka';
                                        })()
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    }
}
Login.propTypes = {
    setUser: (0, _propTypesDefault.default).func
};
function mapStateToProps(state) {
    return {
        api_url: state.ConstantsSlice.api_url
    };
}
function mapDispatchToProps(dispatch) {
    return {
        setUser: (data)=>{
            dispatch((0, _userSlice.setUser)(data));
        }
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Login);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./TextWithTooltip":"6kuHH","../api/Users":"keHdn","../slices/UserSlice":"ikKoo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kuHH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@blueprintjs/core");
function TextWithTooltip(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: 'text-with-tooltip ' + (props.cls || ''),
        style: props.inline === true ? {
            display: 'inline'
        } : {},
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: 'mr-1 ' + (props.className || ''),
                children: props.label
            }),
            props.tooltip === undefined || props.tooltip === null || props.tooltip.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                content: props.tooltip,
                position: (0, _core.Position).RIGHT,
                openOnTargetFocus: false,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                    icon: "info-sign",
                    iconSize: 12
                })
            })
        ]
    });
}
exports.default = TextWithTooltip;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"keHdn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "login", ()=>login);
parcelHelpers.export(exports, "loadUserInfo", ()=>loadUserInfo);
parcelHelpers.export(exports, "loadUsers", ()=>loadUsers);
parcelHelpers.export(exports, "loadUserWorkTypes", ()=>loadUserWorkTypes);
parcelHelpers.export(exports, "loadUserDailyLogbookActivities", ()=>loadUserDailyLogbookActivities);
parcelHelpers.export(exports, "saveUser", ()=>saveUser);
parcelHelpers.export(exports, "saveUserWorkTypes", ()=>saveUserWorkTypes);
parcelHelpers.export(exports, "saveUserDailyLogbookActivities", ()=>saveUserDailyLogbookActivities);
parcelHelpers.export(exports, "addUserNotificationToken", ()=>addUserNotificationToken);
parcelHelpers.export(exports, "setSubscribedToNotifications", ()=>setSubscribedToNotifications);
var _userSlice = require("../slices/UserSlice");
async function login(api_url, username, password) {
    const form_data = new FormData();
    form_data.set('username', username);
    form_data.set('password', password);
    const response = await fetch(api_url + 'Users/v1/login', {
        method: 'post',
        body: form_data
    });
    const data = await response.json();
    return data;
}
async function loadUserInfo(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Users/v1/user', {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    let user = await response.json();
    if (user.error_code !== undefined) {
        if (user.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else {
        console.log({
            user
        });
        dispatch((0, _userSlice.setUser)({
            user_info: user,
            token
        }));
    }
}
async function loadUsers(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Users/v1/users', {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _userSlice.addUsers)(items));
}
async function loadUserWorkTypes(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Users/v1/user-work-types', {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _userSlice.addUserWorkTypes)(items));
}
async function loadUserDailyLogbookActivities(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Users/v1/user-daily-logbook-activities', {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _userSlice.addUserDailyLogbookActivities)(items));
}
async function saveUser(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Users/v1/save-user', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function saveUserWorkTypes(api_url, id_user, items, token) {
    const form_data = new FormData();
    form_data.set('id_user', JSON.stringify(id_user));
    form_data.set('items', JSON.stringify(items));
    let response = await fetch(api_url + 'Users/v1/save-user-work-types', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    let retval = await response.json();
    if (retval.error_code !== undefined) retval.error_code;
    else return true;
    return null;
}
async function saveUserDailyLogbookActivities(api_url, id_user, items, token) {
    const form_data = new FormData();
    form_data.set('id_user', JSON.stringify(id_user));
    form_data.set('items', JSON.stringify(items));
    let response = await fetch(api_url + 'Users/v1/save-user-daily-logbook-activities', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    let retval = await response.json();
    if (retval.error_code !== undefined) retval.error_code;
    else return true;
    return null;
}
async function addUserNotificationToken(api_url, notification_token, notification_auth, notification_p256dh, notification_encodings, token) {
    const form_data = new FormData();
    form_data.set('token', notification_token);
    form_data.set('auth', notification_auth);
    form_data.set('p256dh', notification_p256dh);
    form_data.set('encodings', notification_encodings);
    let response = await fetch(api_url + 'Users/v1/add-user-notification-token', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    let retval = await response.json();
    if (retval.error_code !== undefined) retval.error_code;
    else return true;
    return null;
}
async function setSubscribedToNotifications(api_url, value, token) {
    const form_data = new FormData();
    form_data.set('value', value ? 'true' : 'false');
    let response = await fetch(api_url + 'Users/v1/set-subscribed-to-notifications', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    let retval = await response.json();
    if (retval.error_code !== undefined) retval.error_code;
    else return true;
    return null;
}

},{"../slices/UserSlice":"ikKoo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdIxi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _settingsSlice = require("../slices/SettingsSlice");
var _localStorageHelper = require("../helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
class CashRegisterSelector extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.setCurrentIdCashRegister = this.setCurrentIdCashRegister.bind(this);
        this.state = {};
    }
    setCurrentIdCashRegister(id_cash_register) {
        this.props.dispatch((0, _settingsSlice.setCurrentIdCashRegister)({
            current_id_cash_register: id_cash_register
        }));
        (0, _localStorageHelperDefault.default).SetValue(this.props.client + '__current_id_cash_register', id_cash_register);
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col flex-grow justify-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Card), {
                    className: "p-8 pl-16 pr-16 mx-auto box-content",
                    style: {
                        width: '20rem'
                    },
                    elevation: (0, _core.Elevation).TWO,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                className: "bp5-heading text-center mb-6",
                                style: {
                                    color: '#394b59'
                                },
                                children: "Izberi blagajno"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-col items-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-1 flex-col mb-2",
                                    style: {
                                        width: '20rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                            vertical: true,
                                            children: [
                                                Object.values(this.props.cash_registers).filter((x)=>this.props.user.id_cash_registers.indexOf(x.id_cash_register) != -1).map((cash_register)=>{
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                                        onClick: ()=>{
                                                            this.setCurrentIdCashRegister(cash_register.id_cash_register);
                                                        },
                                                        children: [
                                                            cash_register.internal_code,
                                                            " \u2022 ",
                                                            cash_register.title
                                                        ]
                                                    }, 'cash-register-' + cash_register.id_cash_register);
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    onClick: ()=>{
                                                        this.setCurrentIdCashRegister(0);
                                                    },
                                                    children: "Nadaljuj brez izbora blagajne"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "p-2 text-gray-600 text-center",
                                            children: "\u010De nadaljuje\u0161 brez izbora blagajne, nekatere funkcije ne bodo na voljo"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        });
    }
}
CashRegisterSelector.propTypes = {};
function mapStateToProps(state) {
    return {
        cash_registers: state.CashRegisterSlice.cash_registers,
        client: state.ConstantsSlice.client,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(CashRegisterSelector);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","../slices/SettingsSlice":"ajHkF","../helpers/LocalStorageHelper":"9I9tm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9I9tm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _localStorage = require("local-storage");
var _localStorageDefault = parcelHelpers.interopDefault(_localStorage);
const LocalStorageHelper = {
    GetValue: (key)=>{
        let val = (0, _localStorageDefault.default).get(key);
        if (key.indexOf('__save_path') != -1 && (val === null || val.trim().length == 0)) val = 'C:\\AssistPRO\\pdf\\';
        else if (key.indexOf('__pos_printer_name') != -1 && (val === null || val.trim().length == 0)) val = 'HTML';
        else if (key.indexOf('__pos_printer_width') != -1 && (val === null || val.trim().length == 0)) val = '48';
        return val;
    },
    SetValue: (key, value)=>{
        (0, _localStorageDefault.default).set(key, value);
    }
};
exports.default = LocalStorageHelper;

},{"local-storage":"a2jL0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a2jL0":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var stub = require("54e68d2178721090");
var parse = require("8f5fcbf7c65f46ed");
var tracking = require("3bb955dbdb6c454a");
var ls = 'localStorage' in global && global.localStorage ? global.localStorage : stub;
function accessor(key, value) {
    if (arguments.length === 1) return get(key);
    return set(key, value);
}
function get(key) {
    const raw = ls.getItem(key);
    const parsed = parse(raw);
    return parsed;
}
function set(key, value) {
    try {
        ls.setItem(key, JSON.stringify(value));
        return true;
    } catch (e) {
        return false;
    }
}
function remove(key) {
    return ls.removeItem(key);
}
function clear() {
    return ls.clear();
}
function backend(store) {
    store && (ls = store);
    return ls;
}
accessor.set = set;
accessor.get = get;
accessor.remove = remove;
accessor.clear = clear;
accessor.backend = backend;
accessor.on = tracking.on;
accessor.off = tracking.off;
module.exports = accessor;

},{"54e68d2178721090":"eEmgu","8f5fcbf7c65f46ed":"5LFmk","3bb955dbdb6c454a":"2G5jM"}],"eEmgu":[function(require,module,exports,__globalThis) {
'use strict';
var ms = {};
function getItem(key) {
    return key in ms ? ms[key] : null;
}
function setItem(key, value) {
    ms[key] = value;
    return true;
}
function removeItem(key) {
    var found = key in ms;
    if (found) return delete ms[key];
    return false;
}
function clear() {
    ms = {};
    return true;
}
module.exports = {
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear
};

},{}],"5LFmk":[function(require,module,exports,__globalThis) {
'use strict';
function parse(rawValue) {
    const parsed = parseValue(rawValue);
    if (parsed === undefined) return null;
    return parsed;
}
function parseValue(rawValue) {
    try {
        return JSON.parse(rawValue);
    } catch (err) {
        return rawValue;
    }
}
module.exports = parse;

},{}],"2G5jM":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var parse = require("55a2063860cf18e6");
var listeners = {};
var listening = false;
function listen() {
    if (global.addEventListener) global.addEventListener('storage', change, false);
    else if (global.attachEvent) global.attachEvent('onstorage', change);
    else global.onstorage = change;
}
function change(e) {
    if (!e) e = global.event;
    var all = listeners[e.key];
    if (all) all.forEach(fire);
    function fire(listener) {
        listener(parse(e.newValue), parse(e.oldValue), e.url || e.uri);
    }
}
function on(key, fn) {
    if (listeners[key]) listeners[key].push(fn);
    else listeners[key] = [
        fn
    ];
    if (listening === false) listen();
}
function off(key, fn) {
    var ns = listeners[key];
    if (ns.length > 1) ns.splice(ns.indexOf(fn), 1);
    else listeners[key] = [];
}
module.exports = {
    on: on,
    off: off
};

},{"55a2063860cf18e6":"5LFmk"}],"8MvmD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _raviger = require("raviger");
var _timelineWithFilter = require("./TimelineWithFilter");
var _timelineWithFilterDefault = parcelHelpers.interopDefault(_timelineWithFilter);
var _timelineActivitiesWithFilter = require("./TimelineActivitiesWithFilter");
var _timelineActivitiesWithFilterDefault = parcelHelpers.interopDefault(_timelineActivitiesWithFilter);
const routes = {
    '/reservations/activities/:idAccommodation/:idAccommodationItem': ({ idAccommodation, idAccommodationItem })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timelineActivitiesWithFilterDefault.default), {
            idAccommodation: idAccommodation,
            idAccommodationItem: idAccommodationItem
        }),
    '/reservations/accommodation/:idAccommodation': ({ idAccommodation })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timelineWithFilterDefault.default), {
            idAccommodation: idAccommodation,
            idAccommodationItem: -1
        }),
    '/reservations/accommodation/:idAccommodation/:idAccommodationItem': ({ idAccommodation, idAccommodationItem })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timelineWithFilterDefault.default), {
            idAccommodation: idAccommodation,
            idAccommodationItem: idAccommodationItem
        })
};
function Reservations(props) {
    if (props.user === null || props.user === undefined || (props.user.access_roles ?? []).indexOf('reservations') === -1) return null;
    const { accommodations, accommodation_items, accommodation_item_places } = props;
    const [accommodation_is_open, setAccommodationIsOpen] = (0, _react.useState)([
        1
    ]);
    const toggleAccommodationItemOpenState = (item_id)=>{
        const new_accommodation_is_open = [
            ...accommodation_is_open
        ];
        if (isAccommodationItemOpen(item_id)) new_accommodation_is_open.splice(new_accommodation_is_open.indexOf(item_id), 1);
        else new_accommodation_is_open.push(item_id);
        setAccommodationIsOpen(new_accommodation_is_open);
    };
    const isAccommodationItemOpen = (item_id)=>{
        return accommodation_is_open.indexOf(item_id) != -1;
    };
    const route = (0, _raviger.useRoutes)(routes);
    let selected_id_accommodation = -1;
    let selected_id_accommodation_item = -1;
    if (route !== null && route.props !== undefined && route.props.children !== undefined && route.props.children.props !== undefined) {
        selected_id_accommodation = route.props.children.props.idAccommodation;
        selected_id_accommodation_item = route.props.children.props.idAccommodationItem;
    }
    const items = [];
    items.push({
        id_accommodation: 0,
        type: 'all',
        title: 'VSE KAPACITETE',
        items: []
    });
    const sorted_accommodations = Object.values(accommodations).sort((a, b)=>{
        if (a.ord < b.ord) return -1;
        if (a.ord > b.ord) return 1;
        return 0;
    });
    for(let i = 0; i < sorted_accommodations.length; i++){
        if ([
            'socaland'
        ].indexOf(props.client) > -1 && [
            'admin',
            'tanja',
            'gregor'
        ].indexOf(props.user.username) == -1 && [
            'd0be0242-7515-4eec-a40e-f687eafb9dac',
            'd2866441-8726-45ad-a7a7-e26b56b2c809'
        ].indexOf(sorted_accommodations[i].id_accommodation) > -1) continue;
        items.push(sorted_accommodations[i]);
    }
    const accommodation_item_places_values = Object.values(accommodation_item_places);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-row flex-grow",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "accommodation-nav flex flex-col",
                children: items.map((item, idx)=>{
                    const subitems = Object.values(accommodation_items).filter((subitem)=>subitem.id_accommodation == item.id_accommodation);
                    const only_default_subitem = subitems.length == 1 && subitems[0].title == 'default';
                    let cls = '';
                    if (selected_id_accommodation == item.id_accommodation || selected_id_accommodation === undefined && item.type == 'activities') cls = 'item-active';
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: 'item flex flex-row items-center ' + cls,
                                style: {
                                    minHeight: '49px'
                                },
                                onClick: ()=>{
                                    (0, _raviger.navigate)(item.type == 'activities' ? '/reservations/activities/' + item.id_accommodation + '/' + subitems[0].id_accommodation_item : '/reservations/accommodation/' + item.id_accommodation + (!only_default_subitem ? '' : '/' + subitems[0].id_accommodation_item));
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "flex-grow",
                                        children: item.title
                                    }),
                                    subitems.length == 0 || only_default_subitem ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                        icon: idx == 0 ? 'none' : isAccommodationItemOpen(idx) ? 'chevron-up' : 'chevron-down',
                                        className: 'mr-2 item-open ' + (subitems.length > 0 ? 'active' : ''),
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            toggleAccommodationItemOpenState(idx);
                                        }
                                    })
                                ]
                            }),
                            only_default_subitem ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Collapse), {
                                isOpen: isAccommodationItemOpen(idx),
                                children: subitems.filter((subitem)=>{
                                    return accommodation_item_places_values.filter((x)=>x.id_accommodation_item == subitem.id_accommodation_item && x.hidden === false).length > 0;
                                }).map((subitem, subidx)=>{
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: 'subitem ' + (selected_id_accommodation_item == subitem.id_accommodation_item ? 'item-active' : ''),
                                        onClick: ()=>{
                                            (0, _raviger.navigate)(item.id_accommodation_item == -1 ? '/reservations/activities' : '/reservations/accommodation/' + item.id_accommodation + '/' + subitem.id_accommodation_item);
                                        },
                                        children: subitem.title
                                    }, 'accommodation-item-' + subitem.id_accommodation_item);
                                })
                            })
                        ]
                    }, 'accommodation-' + item.id_accommodation);
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex-1 flex flex-col relative",
                children: route
            })
        ]
    });
}
function mapStateToProps(state) {
    return {
        client: state.ConstantsSlice.client,
        user: state.UserSlice.user,
        accommodations: state.CodeTablesSlice.accommodations,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Reservations);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","raviger":"knnT1","./TimelineWithFilter":"bQzKT","./TimelineActivitiesWithFilter":"kZgvH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQzKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _raviger = require("raviger");
var _reservationSlice = require("../../slices/ReservationSlice");
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _select = require("@blueprintjs/select");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reservation = require("./Reservation");
var _reservationDefault = parcelHelpers.interopDefault(_reservation);
var _timeline = require("./Timeline");
var _timelineDefault = parcelHelpers.interopDefault(_timeline);
var _datePickerDialog = require("../DatePickerDialog");
var _datePickerDialogDefault = parcelHelpers.interopDefault(_datePickerDialog);
var _appSlice = require("../../slices/AppSlice");
var _utils = require("../../utils");
function TimelineWithFilter(props) {
    if (props.user === null || props.user === undefined || (props.user.access_roles ?? []).indexOf('reservations') === -1) return null;
    const { idAccommodation, idAccommodationItem } = props;
    const id_accommodation = idAccommodation;
    const id_accommodation_item = idAccommodationItem;
    const [reservation_dialog_open, setReservationDialogOpen] = (0, _react.useState)(false);
    const [current_reservation, setCurrentReservation] = (0, _react.useState)(null);
    let [{ currentDate, scaleDays }, setQuery] = (0, _raviger.useQueryParams)();
    currentDate = currentDate || (0, _momentDefault.default)().format('YYYY-MM-DD');
    scaleDays = parseInt(scaleDays, 10) || 30;
    const openReservationDialog = (reservation)=>{
        setReservationDialogOpen(true);
        setCurrentReservation(reservation);
    };
    const closeReservationDialog = ()=>{
        setReservationDialogOpen(false);
    };
    const delReservation = (id_reservation)=>{
        props.dispatch((0, _reservationSlice.deleteReservation)(id_reservation));
    //const new_reservations = reservations;
    //let idx = -1;
    //for (let i=0; i<reservations.length; i++) {
    //	if (reservations[i][9] == id_reservation) {
    //		idx = i;
    //		break;
    //	}
    //}
    //
    //if (idx != -1) {
    //	new_reservations.splice(idx, 1);
    //}
    //
    //setReservations(new_reservations);
    };
    const accommodation_item_places = {};
    for(let id_accommodation_item_place in props.accommodation_item_places){
        const disallowed = [
            'socaland'
        ].indexOf(props.client) > -1 && [
            'admin',
            'tanja',
            'gregor'
        ].indexOf(props.user.username) == -1 && [
            'd0be0242-7515-4eec-a40e-f687eafb9dac',
            'd2866441-8726-45ad-a7a7-e26b56b2c809'
        ].indexOf(props.accommodation_items[props.accommodation_item_places[id_accommodation_item_place].id_accommodation_item].id_accommodation) > -1;
        if (disallowed) continue;
        if (id_accommodation == 0 || /* 0 is All accommodations */ id_accommodation_item == -1 && /* -1 is main accommodation item */ props.accommodation_items[props.accommodation_item_places[id_accommodation_item_place].id_accommodation_item].id_accommodation == id_accommodation || props.accommodation_item_places[id_accommodation_item_place].id_accommodation_item == id_accommodation_item) accommodation_item_places[id_accommodation_item_place] = props.accommodation_item_places[id_accommodation_item_place];
    }
    const reservations = {};
    for(let id_reservation in props.reservations)if (id_accommodation == 0 || /* 0 is All accommodations */ id_accommodation_item == -1 && /* -1 is main accommodation item */ props.accommodation_items[props.accommodation_item_places[props.reservations[id_reservation].id_accommodation_item_place].id_accommodation_item].id_accommodation == id_accommodation || props.accommodation_item_places[props.reservations[id_reservation].id_accommodation_item_place].id_accommodation_item == id_accommodation_item) reservations[id_reservation] = props.reservations[id_reservation];
    const reservation_requests = props.reservation_requests;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !reservation_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reservationDefault.default), {
                closeReservation: closeReservationDialog,
                deleteReservation: delReservation,
                reservation: current_reservation
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimelineWithFilterComponent, {
                ...props,
                openReservationDialog: (reservation)=>openReservationDialog(reservation),
                setCurrentDate: (newDate)=>setQuery({
                        currentDate: (0, _momentDefault.default)(newDate).format('YYYY-MM-DD'),
                        scaleDays
                    }),
                currentDate: new Date(currentDate),
                setScaleDays: (newScaleDays)=>setQuery({
                        currentDate,
                        scaleDays: newScaleDays
                    }),
                scaleDays: scaleDays,
                rooms: accommodation_item_places,
                items: reservations,
                items_requests: reservation_requests,
                deleteReservation: delReservation,
                user: props.user
            })
        ]
    });
}
function mapStateToProps(state) {
    return {
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodations: state.CodeTablesSlice.accommodations,
        reservations: state.ReservationSlice.reservations,
        reservation_customers_by_id_reservations: state.ReservationSlice.reservation_customers_by_id_reservations,
        reservation_requests: state.ReservationSlice.reservation_requests,
        customers: state.CodeTablesSlice.customers,
        client: state.ConstantsSlice.client,
        user: state.UserSlice.user,
        token: state.UserSlice.token,
        api_url: state.ReservationSlice.api_url
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(TimelineWithFilter);
class TimelineWithFilterComponent extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.openFilterDatePickerDialog = this.openFilterDatePickerDialog.bind(this);
        this.closeFilterDatePickerDialog = this.closeFilterDatePickerDialog.bind(this);
        this.offsetCurrentDate = this.offsetCurrentDate.bind(this);
        this.filterRooms = this.filterRooms.bind(this);
        this.printAvailableAccommodations = this.printAvailableAccommodations.bind(this);
        this.hideAvailableAccommodationsDialog = this.hideAvailableAccommodationsDialog.bind(this);
        this.state = {
            filter_date_picker_dialog_open: false,
            filter_date_picker_dialog_state_name: null,
            filter_from: null,
            filter_to: null,
            filter_from_temp: null,
            filter_to_temp: null,
            deleting_reservations: false,
            duplicating_reservations: false,
            rooms: null,
            items: null,
            reservation_search_query: '',
            show_hidden_rooms: false,
            select_available_rooms_dialog_open: false,
            select_available_rooms_dialog_items: {}
        };
        const filtered = this.filterRooms(null, null, this.state.show_hidden_rooms, true);
        this.state.rooms = filtered.rooms;
        this.state.items = filtered.items;
    }
    openFilterDatePickerDialog(state_name) {
        this.setState({
            filter_date_picker_dialog_open: true,
            filter_date_picker_dialog_state_name: state_name
        });
    }
    closeFilterDatePickerDialog(newValue) {
        this.setState({
            filter_date_picker_dialog_open: false
        });
        if (newValue instanceof Date) this.props.setCurrentDate(newValue);
    }
    offsetCurrentDate(offset_days) {
        this.props.setCurrentDate((0, _momentDefault.default)(this.props.currentDate).add(offset_days, 'days').toDate());
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterRooms(filter_from, filter_to, show_hidden_rooms, return_only) {
        return_only = return_only === undefined ? false : return_only;
        const found_id_accommodation_item_places = [];
        if (filter_from !== null && filter_to !== null) {
            for(let id_reservation in this.props.items){
                const reservation = this.props.items[id_reservation];
                if (reservation.status == 'reversed' || reservation.status == 'no-show' || reservation.deleted === true) continue;
                if (reservation.check_in >= this.toIsoString(filter_to) || reservation.check_out <= this.toIsoString(filter_from)) continue;
                if (found_id_accommodation_item_places.indexOf(reservation.id_accommodation_item_place) == -1) found_id_accommodation_item_places.push(reservation.id_accommodation_item_place);
            }
            for(let id_reservation_request in this.props.items_requests){
                const reservation = this.props.items_requests[id_reservation_request];
                if (reservation.status != 'new' && reservation.status != 'confirmed') continue;
                if (reservation.id_accommodation_item_place === null) continue;
                if (reservation.check_in >= this.toIsoString(filter_to) || reservation.check_out <= this.toIsoString(filter_from)) continue;
                if (found_id_accommodation_item_places.indexOf(reservation.id_accommodation_item_place) == -1) found_id_accommodation_item_places.push(reservation.id_accommodation_item_place);
            }
        }
        const rooms = [];
        for(let id_accommodation_item_place in this.props.rooms){
            if (found_id_accommodation_item_places.indexOf(id_accommodation_item_place) != -1) continue;
            if (show_hidden_rooms === false && (this.props.rooms[id_accommodation_item_place] === undefined || this.props.rooms[id_accommodation_item_place].hidden)) continue;
            rooms.push(this.props.rooms[id_accommodation_item_place]);
        }
        rooms.sort((a, b)=>{
            const accommodation_item_a = this.props.accommodation_items[a.id_accommodation_item];
            const accommodation_item_b = this.props.accommodation_items[b.id_accommodation_item];
            const accommodation_a = this.props.accommodations[accommodation_item_a.id_accommodation];
            const accommodation_b = this.props.accommodations[accommodation_item_b.id_accommodation];
            if (accommodation_a.ord < accommodation_b.ord) return -1;
            if (accommodation_a.ord > accommodation_b.ord) return 1;
            if (accommodation_item_a.ord < accommodation_item_b.ord) return -1;
            if (accommodation_item_a.ord > accommodation_item_b.ord) return 1;
            if (a.ord < b.ord) return -1;
            if (a.ord > b.ord) return 1;
            return 0;
        });
        const items = {};
        for(let id_reservation in this.props.items){
            if (found_id_accommodation_item_places.indexOf(this.props.items[id_reservation].id_accommodation_item_place) != -1) continue;
            if (show_hidden_rooms === false && (this.props.rooms[this.props.items[id_reservation].id_accommodation_item_place] === undefined || this.props.rooms[this.props.items[id_reservation].id_accommodation_item_place].hidden)) continue;
            items[id_reservation] = this.props.items[id_reservation];
        }
        if (!return_only) this.setState({
            rooms,
            items
        });
        return {
            rooms,
            items
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.filter_from != this.state.filter_from || prevState.filter_to != this.state.filter_to || prevProps.rooms != this.props.rooms || prevProps.items != this.props.items || prevState.show_hidden_rooms != this.state.show_hidden_rooms) this.filterRooms(this.state.filter_from, this.state.filter_to, this.state.show_hidden_rooms);
    }
    getGroupedForAvailableAccommodations(rooms) {
        const grouped = {};
        for(let i = 0; i < rooms.length; i++){
            const id_accommodation_item_place = rooms[i];
            const accommodation_item_place = this.props.accommodation_item_places[id_accommodation_item_place];
            const accommodation_item = this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
            const accommodation = this.props.accommodations[accommodation_item.id_accommodation];
            if (grouped[accommodation.id_accommodation] === undefined) grouped[accommodation.id_accommodation] = {
                accommodation,
                accommodation_items: []
            };
            if (grouped[accommodation.id_accommodation].accommodation_items[accommodation_item.id_accommodation_item] === undefined) grouped[accommodation.id_accommodation].accommodation_items[accommodation_item.id_accommodation_item] = {
                accommodation_item: this.props.accommodation_items[accommodation_item.id_accommodation_item],
                accommodation_item_places: []
            };
            grouped[accommodation.id_accommodation].accommodation_items[accommodation_item.id_accommodation_item].accommodation_item_places.push(accommodation_item_place);
        }
        return grouped;
    }
    printAvailableAccommodations(language, rooms) {
        if (language === undefined || rooms === undefined) {
            const select_available_rooms_dialog_items = {};
            for(let i = 0; i < this.state.rooms.length; i++)select_available_rooms_dialog_items[this.state.rooms[i].id_accommodation_item_place] = false;
            this.setState({
                select_available_rooms_dialog_open: true,
                select_available_rooms_dialog_items
            });
            return;
        }
        const grouped = this.getGroupedForAvailableAccommodations(rooms);
        this.props.dispatch((0, _appSlice.enqueueAvailableAccommodationsPosPrinterQueue)({
            type: 'available_invoices',
            grouped,
            from: (0, _momentDefault.default)(this.state.filter_from).format('YYYY-MM-DD'),
            to: (0, _momentDefault.default)(this.state.filter_to).format('YYYY-MM-DD'),
            language
        }));
    }
    hideAvailableAccommodationsDialog() {
        this.setState({
            select_available_rooms_dialog_open: false,
            select_available_rooms_dialog_items: {}
        });
    }
    render() {
        const year_ago_iso = (0, _momentDefault.default)().subtract(12, 'month').format('YYYY-MM-DD');
        const reservations_for_search = Object.values(this.props.reservations).filter((x)=>x.check_in >= year_ago_iso);
        const grouped_available_accommodations = this.state.select_available_rooms_dialog_open ? this.getGroupedForAvailableAccommodations(Object.keys(this.state.select_available_rooms_dialog_items)) : {};
        const short_week_days = [
            'ned',
            'pon',
            'tor',
            'sre',
            "\u010Det",
            'pet',
            'sob'
        ];
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.filter_date_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDialogDefault.default), {
                    closeDatePickerDialog: this.closeFilterDatePickerDialog,
                    value: this.props.currentDate
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: this.state.select_available_rooms_dialog_open,
                    onClose: this.hideAvailableAccommodationsDialog,
                    className: "dialog--available-accommodations",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                fixedToTop: false,
                                className: "bp5-dark",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: "Izbor prostih mest"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        align: (0, _core.Alignment).RIGHT,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: this.hideAvailableAccommodationsDialog
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_BODY,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col text-base",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                            className: "mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    onClick: ()=>{
                                                        const select_available_rooms_dialog_items = {
                                                            ...this.state.select_available_rooms_dialog_items
                                                        };
                                                        for(let id in select_available_rooms_dialog_items)select_available_rooms_dialog_items[id] = false;
                                                        this.setState({
                                                            select_available_rooms_dialog_items
                                                        });
                                                    },
                                                    children: "Izberi nobenega"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    onClick: ()=>{
                                                        const select_available_rooms_dialog_items = {
                                                            ...this.state.select_available_rooms_dialog_items
                                                        };
                                                        for(let id in select_available_rooms_dialog_items)select_available_rooms_dialog_items[id] = true;
                                                        this.setState({
                                                            select_available_rooms_dialog_items
                                                        });
                                                    },
                                                    children: "Izberi vse"
                                                })
                                            ]
                                        }),
                                        Object.keys(grouped_available_accommodations).map((id_accommodation)=>{
                                            const item = grouped_available_accommodations[id_accommodation];
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "pt-1 pb-2",
                                                        children: item.accommodation.title
                                                    }),
                                                    Object.keys(item.accommodation_items).map((id_accommodation_item)=>{
                                                        const subitem = item.accommodation_items[id_accommodation_item];
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            children: [
                                                                subitem.accommodation_item.title == 'default' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "pt-1 pb-2",
                                                                    children: subitem.accommodation_item.title
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "flex flex-row flex-wrap",
                                                                    children: subitem.accommodation_item_places.map((aip)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                                            className: "mr-3",
                                                                            style: {
                                                                                minWidth: 100
                                                                            },
                                                                            checked: this.state.select_available_rooms_dialog_items[aip.id_accommodation_item_place],
                                                                            onChange: (event)=>{
                                                                                const select_available_rooms_dialog_items = {
                                                                                    ...this.state.select_available_rooms_dialog_items
                                                                                };
                                                                                select_available_rooms_dialog_items[aip.id_accommodation_item_place] = event.target.checked;
                                                                                this.setState({
                                                                                    select_available_rooms_dialog_items
                                                                                });
                                                                            },
                                                                            label: aip.title
                                                                        }, aip.id_accommodation_item_place))
                                                                })
                                                            ]
                                                        }, id_accommodation_item);
                                                    })
                                                ]
                                            }, id_accommodation);
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>{
                                                this.printAvailableAccommodations('sl', Object.keys(this.state.select_available_rooms_dialog_items).filter((id_accommodation_item_place)=>this.state.select_available_rooms_dialog_items[id_accommodation_item_place]));
                                                this.hideAvailableAccommodationsDialog();
                                            },
                                            children: "Natisni SL"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>{
                                                this.printAvailableAccommodations('en', Object.keys(this.state.select_available_rooms_dialog_items).filter((id_accommodation_item_place)=>this.state.select_available_rooms_dialog_items[id_accommodation_item_place]));
                                                this.hideAvailableAccommodationsDialog();
                                            },
                                            children: "Natisni EN"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>{
                                                this.printAvailableAccommodations('de', Object.keys(this.state.select_available_rooms_dialog_items).filter((id_accommodation_item_place)=>this.state.select_available_rooms_dialog_items[id_accommodation_item_place]));
                                                this.hideAvailableAccommodationsDialog();
                                            },
                                            children: "Natisni DE"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "pt-4 pb-4 pr-2 flex flex-row justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                            className: "items-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    active: this.props.scaleDays == 15,
                                    onClick: ()=>this.props.setScaleDays(15),
                                    children: "15 dni"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    active: this.props.scaleDays == 30,
                                    onClick: ()=>this.props.setScaleDays(30),
                                    children: "30 dni"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    className: "mb-0 ml-5",
                                    checked: !this.state.show_hidden_rooms,
                                    onChange: (event)=>this.setState({
                                            show_hidden_rooms: !event.target.checked
                                        }),
                                    children: "Prika\u017Ei samo aktivne enote"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        this.offsetCurrentDate(-30);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 20 18",
                                            width: "20",
                                            height: "18",
                                            className: "inline-block mr-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                fillRule: "evenodd",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m14.589 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    })
                                                ]
                                            })
                                        }),
                                        "30 dni"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        this.offsetCurrentDate(-15);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            viewBox: "0 0 14 18",
                                            width: "14",
                                            height: "18",
                                            className: "inline-block mr-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                    fillRule: "evenodd"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                    fillRule: "evenodd"
                                                })
                                            ]
                                        }),
                                        "15 dni"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        this.offsetCurrentDate(-1);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 9 18",
                                            width: "9",
                                            height: "18",
                                            className: "inline-block mr-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fill: "#92a8b8",
                                                d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                fillRule: "evenodd"
                                            })
                                        }),
                                        "1 dan"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    className: "w-32",
                                    onClick: ()=>{
                                        this.openFilterDatePickerDialog('current_date');
                                    },
                                    intent: (0, _core.Intent).PRIMARY,
                                    children: short_week_days[this.props.currentDate.getDay()] + ', ' + this.props.currentDate.toLocaleString('sl-SI', {
                                        year: 'numeric',
                                        month: 'numeric',
                                        day: 'numeric'
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    className: "w-24",
                                    onClick: ()=>{
                                        this.props.setCurrentDate(new Date());
                                    },
                                    intent: (0, _core.Intent).PRIMARY,
                                    disabled: (0, _momentDefault.default)(this.props.currentDate).format('YYYY-MM-DD') == (0, _momentDefault.default)().format('YYYY-MM-DD'),
                                    children: "Danes"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        this.offsetCurrentDate(1);
                                    },
                                    children: [
                                        "1 dan",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 9 18",
                                            width: "9",
                                            height: "18",
                                            className: "inline-block ml-1",
                                            transform: "scale(-1,1)",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fill: "#92a8b8",
                                                d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                fillRule: "evenodd"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        this.offsetCurrentDate(15);
                                    },
                                    children: [
                                        "15 dni",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            viewBox: "0 0 14 18",
                                            width: "14",
                                            height: "18",
                                            className: "inline-block ml-1",
                                            transform: "scale(-1,1)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                    fillRule: "evenodd"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                    fillRule: "evenodd"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        this.offsetCurrentDate(30);
                                    },
                                    children: [
                                        "30 dni",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 20 18",
                                            width: "20",
                                            height: "18",
                                            className: "inline-block ml-1",
                                            transform: "scale(-1,1)",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                fillRule: "evenodd",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m14.589 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Suggest), {
                            itemListPredicate: (query, items)=>{
                                if (query.length < 3) return [];
                                return items.filter((item)=>item.search_value.indexOf(query.toLowerCase()) > -1).slice(0, 25);
                            },
                            itemRenderer: (item, { handleClick, modifiers })=>{
                                const reservation = this.props.reservations[item.id_reservation];
                                const accommodation_item_place = this.props.accommodation_item_places[reservation.id_accommodation_item_place];
                                const accommodation_item = accommodation_item_place === undefined ? undefined : this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
                                const accommodation = accommodation_item === undefined ? undefined : this.props.accommodations[accommodation_item.id_accommodation];
                                let accommodation_title = '';
                                if (accommodation !== undefined) {
                                    accommodation_title = accommodation.title + " \u2022 ";
                                    if (accommodation_item !== undefined && accommodation_item.title != 'default') accommodation_title += accommodation_item.title + " \u2022 ";
                                    if (accommodation_item_place !== undefined) accommodation_title += accommodation_item_place.title;
                                }
                                let customer = this.props.customers[reservation.id_customer];
                                let customer_name = '';
                                if (customer !== undefined) customer_name = customer.type == 'natural' ? customer.name + ' ' + customer.surname : customer.company_name;
                                const statuses = {
                                    'new': 'Nova',
                                    'waiting-for-confirmation': 'V potrjevanju',
                                    'offer-sent': 'Izdana ponudba',
                                    'confirmed': 'Potrjena',
                                    'advance-invoice-sent': 'Izdan avans',
                                    'closed': "Pla\u010Dana",
                                    'reversed': 'Stornirana',
                                    'no-show': 'Neprihod',
                                    'not-for-rent': 'Ni za oddajo'
                                };
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                    active: modifiers.active,
                                    onClick: handleClick,
                                    text: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: reservation.internal_code
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: customer_name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: item.check_in_out_range
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: accommodation_title
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: statuses[reservation.status]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    className: "items-stretch border-b border-gray-400"
                                }, item.id_reservation);
                            },
                            noResults: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "p-2",
                                children: "Ni rezultatov"
                            }),
                            items: reservations_for_search.map((reservation)=>{
                                let customer_name = '';
                                let search_value = reservation.internal_code;
                                let customer = this.props.customers[reservation.id_customer];
                                if (customer !== undefined) {
                                    customer_name = customer.type == 'natural' ? customer.name + ' ' + customer.surname : customer.company_name;
                                    search_value += ' ' + customer_name;
                                }
                                const reservation_customers = this.props.reservation_customers_by_id_reservations[reservation.id_reservation];
                                for(let id_reservation_customer in reservation_customers){
                                    const reservation_customer = reservation_customers[id_reservation_customer];
                                    let customer = reservation_customer === undefined ? undefined : this.props.customers[reservation_customer.id_customer];
                                    if (customer !== undefined) search_value += ' ' + customer.name + ' ' + customer.surname + ' ' + customer.company_name;
                                }
                                return {
                                    id_reservation: reservation.id_reservation,
                                    search_value: search_value.toLowerCase(),
                                    check_in: reservation.check_in,
                                    check_in_out_range: (0, _momentDefault.default)(reservation.check_in).format('DD. MM. YYYY') + " \uD83E\uDC52 " + (0, _momentDefault.default)(reservation.check_out).format('DD. MM. YYYY')
                                };
                            }).sort((a, b)=>{
                                if (a.check_in > b.check_in) return -1;
                                if (a.check_in < b.check_in) return 1;
                                return 0;
                            }),
                            onItemSelect: (item)=>{
                                this.props.openReservationDialog(this.props.reservations[item.id_reservation]);
                            },
                            openOnKeyDown: true,
                            popoverProps: {
                                targetProps: {
                                    style: {
                                        display: 'block'
                                    }
                                },
                                minimal: true
                            },
                            selectedItem: null,
                            inputProps: {
                                leftIcon: 'search',
                                placeholder: "I\u0161\u010Di (vsaj 3 znaki)",
                                rightElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "cross",
                                    minimal: true,
                                    onClick: ()=>{
                                        this.setState({
                                            reservation_search_query: ''
                                        });
                                    }
                                })
                            },
                            inputValueRenderer: (item)=>item.search_value,
                            resetOnSelect: true,
                            query: this.state.reservation_search_query,
                            onQueryChange: (query)=>{
                                this.setState({
                                    reservation_search_query: query
                                });
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "pt-0 pb-4 pr-2 flex flex-row justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-row items-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "mr-2",
                                    children: "Filtriranje nezasedenih:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateRangeInput3), {
                                    dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                    dateFnsFormat: 'dd. MM. yyyy',
                                    locale: "sl",
                                    allowSingleDayRange: true,
                                    contiguousCalendarMonths: false,
                                    shortcuts: false,
                                    startInputProps: {
                                        placeholder: 'Od',
                                        className: 'w-24'
                                    },
                                    endInputProps: {
                                        placeholder: 'Do',
                                        className: 'w-24'
                                    },
                                    selectAllOnFocus: true,
                                    minDate: new Date('1900-01-01'),
                                    maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                    onChange: (selectedRange)=>{
                                        this.setState({
                                            filter_from_temp: selectedRange[0] === null ? null : (0, _momentDefault.default)(selectedRange[0]).toDate(),
                                            filter_to_temp: selectedRange[1] === null ? null : (0, _momentDefault.default)(selectedRange[1]).toDate()
                                        });
                                    },
                                    value: [
                                        this.state.filter_from_temp,
                                        this.state.filter_to_temp
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "cross",
                                    disabled: this.state.filter_from_temp === null && this.state.filter_to_temp === null && this.state.filter_from === null && this.state.filter_to === null,
                                    onClick: ()=>{
                                        this.setState({
                                            filter_from: null,
                                            filter_to: null,
                                            filter_from_temp: null,
                                            filter_to_temp: null
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    disabled: this.state.filter_from_temp === null && this.state.filter_to_temp === null || (0, _momentDefault.default)(this.state.filter_from_temp).format('YYYY-MM-DD') == (0, _momentDefault.default)(this.state.filter_from).format('YYYY-MM-DD') && (0, _momentDefault.default)(this.state.filter_to_temp).format('YYYY-MM-DD') == (0, _momentDefault.default)(this.state.filter_to).format('YYYY-MM-DD'),
                                    onClick: ()=>{
                                        this.setState({
                                            filter_from: this.state.filter_from_temp,
                                            filter_to: this.state.filter_to_temp
                                        });
                                    },
                                    children: "Prika\u017Ei"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    disabled: this.state.filter_from === null || this.state.filter_to === null,
                                    icon: "print",
                                    onClick: this.printAvailableAccommodations
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                icon: "th",
                                onClick: ()=>(0, _raviger.navigate)('/reservation-list'),
                                children: "Seznam rezervacij"
                            })
                        }),
                        null
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-1",
                    style: {
                        position: 'relative'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timelineDefault.default), {
                        openReservation: (reservation)=>{
                            this.props.openReservationDialog(reservation);
                        },
                        currentDate: this.props.currentDate,
                        scaleDays: this.props.scaleDays,
                        setDateFilter: (filter_from, filter_to)=>{
                            this.setState({
                                filter_from: filter_from.toDate(),
                                filter_to: filter_to.toDate(),
                                filter_from_temp: filter_from.toDate(),
                                filter_to_temp: filter_to.toDate()
                            });
                        },
                        filterFrom: this.state.filter_from,
                        filterTo: this.state.filter_to,
                        rooms: this.state.rooms,
                        items: this.state.items,
                        deletingReservations: this.state.deleting_reservations,
                        deleteReservation: this.props.deleteReservation
                    })
                })
            ]
        });
    }
}
TimelineWithFilterComponent.propTypes = {};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","raviger":"knnT1","../../slices/ReservationSlice":"kTPna","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","@blueprintjs/select":"3IMc6","moment":"1e4qG","./Reservation":"a8Yu8","./Timeline":"3S3qx","../DatePickerDialog":"acPCW","../../slices/AppSlice":"aByTQ","../../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2mpOL":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker3", ()=>(0, _datePicker3.DatePicker3));
parcelHelpers.export(exports, "DateInput3", ()=>(0, _dateInput3.DateInput3));
parcelHelpers.export(exports, "DateRangeInput3", ()=>(0, _dateRangeInput3.DateRangeInput3));
parcelHelpers.export(exports, "DateRangePicker3", ()=>(0, _dateRangePicker3.DateRangePicker3));
parcelHelpers.export(exports, "Datetime2Classes", ()=>(0, _classes.Classes));
parcelHelpers.export(exports, "ReactDayPickerClasses", ()=>(0, _classes.ReactDayPickerClasses));
/* eslint-disable deprecation/deprecation */ parcelHelpers.export(exports, "Classes", ()=>(0, _datetime.Classes));
parcelHelpers.export(exports, "DateInput2", ()=>(0, _datetime.DateInput));
parcelHelpers.export(exports, "DateRangeInput2", ()=>(0, _datetime.DateRangeInput));
parcelHelpers.export(exports, "TimezoneSelect", ()=>(0, _datetime.TimezoneSelect));
parcelHelpers.export(exports, "TimePicker", ()=>(0, _datetime.TimePicker));
parcelHelpers.export(exports, "MonthAndYear", ()=>(0, _datetime.MonthAndYear));
parcelHelpers.export(exports, "Months", ()=>(0, _datetime.Months));
parcelHelpers.export(exports, "getTimezoneMetadata", ()=>(0, _datetime.getTimezoneMetadata));
parcelHelpers.export(exports, "TimePrecision", ()=>(0, _datetime.TimePrecision));
parcelHelpers.export(exports, "TimeUnit", ()=>(0, _datetime.TimeUnit));
parcelHelpers.export(exports, "TimezoneDisplayFormat", ()=>(0, _datetime.TimezoneDisplayFormat));
parcelHelpers.export(exports, "DateInput2MigrationUtils", ()=>_dateInput2MigrationUtils);
var _datePicker3 = require("./components/date-picker3/datePicker3");
var _dateInput3 = require("./components/date-input3/dateInput3");
var _dateRangeInput3 = require("./components/date-range-input3/dateRangeInput3");
var _dateRangePicker3 = require("./components/date-range-picker3/dateRangePicker3");
var _dateInput2MigrationUtils = require("./dateInput2MigrationUtils");
var _classes = require("./classes");
var _datetime = require("@blueprintjs/datetime");

},{"./components/date-picker3/datePicker3":"jnV80","./components/date-input3/dateInput3":"cfYu9","./components/date-range-input3/dateRangeInput3":"bEuJ0","./components/date-range-picker3/dateRangePicker3":"6kmWl","./dateInput2MigrationUtils":false,"./classes":false,"@blueprintjs/datetime":"g4aa7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jnV80":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker3", ()=>DatePicker3);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dateFns = require("date-fns");
var _react = require("react");
var _reactDayPicker = require("react-day-picker");
var _core = require("@blueprintjs/core");
var _datetime = require("@blueprintjs/datetime");
var _classes = require("../../classes");
var _dateFnsLocalizedComponent = require("../dateFnsLocalizedComponent");
var _datePicker3Dropdown = require("../react-day-picker/datePicker3Dropdown");
var _datePickerNavIcons = require("../react-day-picker/datePickerNavIcons");
var _datePicker3Context = require("./datePicker3Context");
/**
 * Date picker (v3) component.
 *
 * @see https://blueprintjs.com/docs/#datetime2/date-picker3
 */ var DatePicker3 = /** @class */ function(_super) {
    (0, _tslib.__extends)(DatePicker3, _super);
    function DatePicker3(props) {
        var _this = _super.call(this, props) || this;
        _this.ignoreNextMonthChange = false;
        /**
         * Custom formatter to render weekday names in the calendar header. The default formatter generally works fine,
         * but it was returning CAPITALIZED strings for some reason, while we prefer Title Case.
         */ _this.renderWeekdayName = function(date) {
            return (0, _dateFns.format)(date, "EEEEEE", {
                locale: _this.state.locale
            });
        };
        _this.handleDaySelect = function(day, selectedDay, activeModifiers, e) {
            var _a, _b;
            if (activeModifiers.disabled) return;
            else if (day === undefined) {
                _this.handleClearClick();
                return;
            }
            _this.updateDay(day);
            (_b = (_a = _this.props.dayPickerProps) === null || _a === void 0 ? void 0 : _a.onSelect) === null || _b === void 0 || _b.call(_a, day, selectedDay, activeModifiers, e);
            // allow toggling selected date by clicking it again (if prop enabled)
            var newValue = _this.props.canClearSelection && activeModifiers.selected ? null : (0, _datetime.DateUtils).getDateTime(day, _this.state.value);
            _this.updateValue(newValue, true);
        };
        _this.handleShortcutClick = function(shortcut, selectedShortcutIndex) {
            var _a = _this.props, onShortcutChange = _a.onShortcutChange, currentShortcutIndex = _a.selectedShortcutIndex;
            var dateRange = shortcut.dateRange, includeTime = shortcut.includeTime;
            var newDate = dateRange[0];
            var newValue = includeTime ? newDate : (0, _datetime.DateUtils).getDateTime(newDate, _this.state.value);
            if (newDate == null) return;
            _this.updateDay(newDate);
            _this.updateValue(newValue, true);
            if (currentShortcutIndex === undefined) _this.setState({
                selectedShortcutIndex: selectedShortcutIndex
            });
            var datePickerShortcut = (0, _tslib.__assign)((0, _tslib.__assign)({}, shortcut), {
                date: newDate
            });
            onShortcutChange === null || onShortcutChange === void 0 || onShortcutChange(datePickerShortcut, selectedShortcutIndex);
        };
        _this.updateDay = function(day) {
            if (_this.props.value === undefined) // set now if uncontrolled, otherwise they'll be updated in `componentDidUpdate`
            _this.setState({
                displayMonth: day.getMonth(),
                displayYear: day.getFullYear(),
                selectedDay: day.getDate()
            });
            if (_this.state.value != null && _this.state.value.getMonth() !== day.getMonth()) _this.ignoreNextMonthChange = true;
        };
        _this.handleClearClick = function() {
            return _this.updateValue(null, true);
        };
        _this.handleMonthChange = function(newDate) {
            var _a, _b;
            var date = _this.computeValidDateInSpecifiedMonthYear(newDate.getFullYear(), newDate.getMonth());
            _this.setState({
                displayMonth: date.getMonth(),
                displayYear: date.getFullYear()
            });
            if (_this.state.value !== null) {
                // if handleDayClick just got run (so this flag is set), then the
                // user selected a date in a new month, so don't invoke onChange a
                // second time
                _this.updateValue(date, false, _this.ignoreNextMonthChange);
                _this.ignoreNextMonthChange = false;
            }
            (_b = (_a = _this.props.dayPickerProps) === null || _a === void 0 ? void 0 : _a.onMonthChange) === null || _b === void 0 || _b.call(_a, date);
        };
        _this.handleTodayClick = function() {
            var timezone = _this.props.timezone;
            var today = new Date();
            var value = timezone != null ? (0, _datetime.TimezoneUtils).convertLocalDateToTimezoneTime(today, timezone) : today;
            var displayMonth = value.getMonth();
            var displayYear = value.getFullYear();
            var selectedDay = value.getDate();
            _this.setState({
                displayMonth: displayMonth,
                displayYear: displayYear,
                selectedDay: selectedDay
            });
            _this.updateValue(value, true);
        };
        _this.handleTimeChange = function(time) {
            var _a, _b;
            (_b = (_a = _this.props.timePickerProps) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 || _b.call(_a, time);
            var value = _this.state.value;
            var newValue = (0, _datetime.DateUtils).getDateTime(value != null ? value : new Date(), time);
            _this.updateValue(newValue, true);
        };
        var value = getInitialValue(props);
        var initialMonth = getInitialMonth(props, value);
        _this.state = {
            displayMonth: initialMonth.getMonth(),
            displayYear: initialMonth.getFullYear(),
            locale: undefined,
            selectedDay: value == null ? null : value.getDate(),
            selectedShortcutIndex: _this.props.selectedShortcutIndex !== undefined ? _this.props.selectedShortcutIndex : -1,
            value: value
        };
        return _this;
    }
    DatePicker3.prototype.render = function() {
        var _a;
        var _b;
        var _c = this.props, className = _c.className, dayPickerProps = _c.dayPickerProps, footerElement = _c.footerElement, maxDate = _c.maxDate, minDate = _c.minDate, showActionsBar = _c.showActionsBar;
        var _d = this.state, displayMonth = _d.displayMonth, displayYear = _d.displayYear, locale = _d.locale;
        return _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _classes.Classes).DATEPICKER, className, (_a = {}, _a[(0, _classes.Classes).DATEPICKER3_HIGHLIGHT_CURRENT_DAY] = this.props.highlightCurrentDay, _a[(0, _classes.Classes).DATEPICKER3_REVERSE_MONTH_AND_YEAR] = this.props.reverseMonthAndYearMenus, _a))
        }, this.maybeRenderShortcuts(), _react.createElement("div", {
            className: (0, _classes.Classes).DATEPICKER_CONTENT
        }, _react.createElement((0, _datePicker3Context.DatePicker3Provider), (0, _tslib.__assign)({}, this.props, this.state), _react.createElement((0, _reactDayPicker.DayPicker), (0, _tslib.__assign)({
            locale: locale,
            showOutsideDays: true
        }, dayPickerProps, {
            captionLayout: "dropdown-buttons",
            classNames: (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _classes.dayPickerClassNameOverrides)), dayPickerProps === null || dayPickerProps === void 0 ? void 0 : dayPickerProps.classNames),
            components: (0, _tslib.__assign)({
                Dropdown: (0, _datePicker3Dropdown.DatePicker3Dropdown),
                IconLeft: (0, _datePickerNavIcons.IconLeft),
                IconRight: (0, _datePickerNavIcons.IconRight)
            }, dayPickerProps === null || dayPickerProps === void 0 ? void 0 : dayPickerProps.components),
            formatters: (0, _tslib.__assign)({
                formatWeekdayName: this.renderWeekdayName
            }, dayPickerProps === null || dayPickerProps === void 0 ? void 0 : dayPickerProps.formatters),
            fromDate: minDate,
            mode: "single",
            month: new Date(displayYear, displayMonth),
            onMonthChange: this.handleMonthChange,
            onSelect: this.handleDaySelect,
            required: !this.props.canClearSelection,
            selected: (_b = this.state.value) !== null && _b !== void 0 ? _b : undefined,
            toDate: maxDate
        })), this.maybeRenderTimePicker(), showActionsBar && this.renderOptionsBar(), footerElement)));
    };
    DatePicker3.prototype.componentDidMount = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.componentDidMount.call(this)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DatePicker3.prototype.componentDidUpdate = function(prevProps) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                _super.prototype.componentDidUpdate.call(this, prevProps);
                if (this.props.value !== prevProps.value) {
                    if (this.props.value == null) // clear the value
                    this.setState({
                        value: null
                    });
                    else this.setState({
                        displayMonth: this.props.value.getMonth(),
                        displayYear: this.props.value.getFullYear(),
                        selectedDay: this.props.value.getDate(),
                        value: this.props.value
                    });
                }
                if (this.props.selectedShortcutIndex !== prevProps.selectedShortcutIndex) this.setState({
                    selectedShortcutIndex: this.props.selectedShortcutIndex
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    DatePicker3.prototype.validateProps = function(props) {
        var defaultValue = props.defaultValue, initialMonth = props.initialMonth, maxDate = props.maxDate, minDate = props.minDate, value = props.value;
        if (defaultValue != null && !(0, _datetime.DateUtils).isDayInRange(defaultValue, [
            minDate,
            maxDate
        ])) console.error((0, _datetime.Errors).DATEPICKER_DEFAULT_VALUE_INVALID);
        if (initialMonth != null && !(0, _datetime.DateUtils).isMonthInRange(initialMonth, [
            minDate,
            maxDate
        ])) console.error((0, _datetime.Errors).DATEPICKER_INITIAL_MONTH_INVALID);
        if (maxDate != null && minDate != null && maxDate < minDate && !(0, _datetime.DateUtils).isSameDay(maxDate, minDate)) console.error((0, _datetime.Errors).DATEPICKER_MAX_DATE_INVALID);
        if (value != null && !(0, _datetime.DateUtils).isDayInRange(value, [
            minDate,
            maxDate
        ])) console.error((0, _datetime.Errors).DATEPICKER_VALUE_INVALID);
    };
    DatePicker3.prototype.renderOptionsBar = function() {
        var _a = this.props, clearButtonText = _a.clearButtonText, todayButtonText = _a.todayButtonText, minDate = _a.minDate, maxDate = _a.maxDate, canClearSelection = _a.canClearSelection;
        var todayEnabled = isTodayEnabled(minDate, maxDate);
        return [
            _react.createElement((0, _core.Divider), {
                key: "div"
            }),
            _react.createElement("div", {
                className: (0, _classes.Classes).DATEPICKER_FOOTER,
                key: "footer"
            }, _react.createElement((0, _core.Button), {
                minimal: true,
                disabled: !todayEnabled,
                onClick: this.handleTodayClick,
                text: todayButtonText
            }), _react.createElement((0, _core.Button), {
                disabled: !canClearSelection,
                minimal: true,
                onClick: this.handleClearClick,
                text: clearButtonText
            }))
        ];
    };
    DatePicker3.prototype.maybeRenderTimePicker = function() {
        var _a = this.props, timePrecision = _a.timePrecision, timePickerProps = _a.timePickerProps, minDate = _a.minDate, maxDate = _a.maxDate;
        if (timePrecision == null && timePickerProps === undefined) return null;
        var applyMin = this.state.value != null && (0, _datetime.DateUtils).isSameDay(this.state.value, minDate);
        var applyMax = this.state.value != null && (0, _datetime.DateUtils).isSameDay(this.state.value, maxDate);
        return _react.createElement("div", {
            className: (0, _classes.Classes).DATEPICKER_TIMEPICKER_WRAPPER
        }, _react.createElement((0, _datetime.TimePicker), (0, _tslib.__assign)({
            precision: timePrecision,
            minTime: applyMin ? minDate : undefined,
            maxTime: applyMax ? maxDate : undefined
        }, timePickerProps, {
            onChange: this.handleTimeChange,
            value: this.state.value
        })));
    };
    DatePicker3.prototype.maybeRenderShortcuts = function() {
        var shortcuts = this.props.shortcuts;
        if (shortcuts == null || shortcuts === false) return null;
        var selectedShortcutIndex = this.state.selectedShortcutIndex;
        var _a = this.props, maxDate = _a.maxDate, minDate = _a.minDate, timePrecision = _a.timePrecision;
        // Reuse the existing date range shortcuts and only care about start date
        var dateRangeShortcuts = shortcuts === true ? true : shortcuts.map(function(shortcut) {
            return (0, _tslib.__assign)((0, _tslib.__assign)({}, shortcut), {
                dateRange: [
                    shortcut.date,
                    null
                ]
            });
        });
        return [
            _react.createElement((0, _datetime.DatePickerShortcutMenu), {
                key: "shortcuts",
                allowSingleDayRange: true,
                maxDate: maxDate,
                minDate: minDate,
                selectedShortcutIndex: selectedShortcutIndex,
                shortcuts: dateRangeShortcuts,
                timePrecision: timePrecision,
                onShortcutClick: this.handleShortcutClick,
                useSingleDateShortcuts: true
            }),
            _react.createElement((0, _core.Divider), {
                key: "div"
            })
        ];
    };
    DatePicker3.prototype.computeValidDateInSpecifiedMonthYear = function(displayYear, displayMonth) {
        var _a = this.props, minDate = _a.minDate, maxDate = _a.maxDate;
        var selectedDay = this.state.selectedDay;
        // month is 0-based, date is 1-based. date 0 is last day of previous month.
        var maxDaysInMonth = new Date(displayYear, displayMonth + 1, 0).getDate();
        var displayDate = selectedDay == null ? 1 : Math.min(selectedDay, maxDaysInMonth);
        // 12:00 matches the underlying react-day-picker timestamp behavior
        var value = (0, _datetime.DateUtils).getDateTime(new Date(displayYear, displayMonth, displayDate, 12), this.state.value);
        // clamp between min and max dates
        if (value < minDate) return minDate;
        else if (value > maxDate) return maxDate;
        return value;
    };
    /**
     * Update `value` by invoking `onChange` (always) and setting state (if uncontrolled).
     */ DatePicker3.prototype.updateValue = function(value, isUserChange, skipOnChange) {
        var _a, _b;
        if (skipOnChange === void 0) skipOnChange = false;
        if (!skipOnChange) (_b = (_a = this.props).onChange) === null || _b === void 0 || _b.call(_a, value, isUserChange);
        if (this.props.value === undefined) this.setState({
            value: value
        });
    };
    DatePicker3.defaultProps = {
        canClearSelection: true,
        clearButtonText: "Clear",
        dayPickerProps: {},
        highlightCurrentDay: false,
        locale: "en-US",
        maxDate: (0, _datetime.DatePickerUtils).getDefaultMaxDate(),
        minDate: (0, _datetime.DatePickerUtils).getDefaultMinDate(),
        reverseMonthAndYearMenus: false,
        shortcuts: false,
        showActionsBar: false,
        todayButtonText: "Today"
    };
    DatePicker3.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".DatePicker3");
    return DatePicker3;
}((0, _dateFnsLocalizedComponent.DateFnsLocalizedComponent));
function getInitialValue(props) {
    // !== because `null` is a valid value (no date)
    if (props.value !== undefined) return props.value;
    if (props.defaultValue !== undefined) return props.defaultValue;
    return null;
}
function getInitialMonth(props, value) {
    var _a, _b;
    var rangeFromProps = [
        (_a = props.minDate) !== null && _a !== void 0 ? _a : null,
        (_b = props.maxDate) !== null && _b !== void 0 ? _b : null
    ];
    var today = new Date();
    // != because we must have a real `Date` to begin the calendar on.
    if (props.initialMonth != null) return props.initialMonth;
    else if (value != null) return value;
    else if ((0, _datetime.DateUtils).isDayInRange(today, rangeFromProps)) return today;
    else return (0, _datetime.DateUtils).getDateBetween(rangeFromProps);
}
function isTodayEnabled(minDate, maxDate) {
    var today = new Date();
    return (0, _datetime.DateUtils).isDayInRange(today, [
        minDate,
        maxDate
    ]);
}

},{"tslib":"b4wpY","classnames":"5Een2","date-fns":"btU8f","react":"9njXz","react-day-picker":"58IhA","@blueprintjs/core":"6Mq52","@blueprintjs/datetime":"g4aa7","../../classes":"dstkC","../dateFnsLocalizedComponent":"fhuxV","../react-day-picker/datePicker3Dropdown":"bUQ9c","../react-day-picker/datePickerNavIcons":"62ZgP","./datePicker3Context":"8j1DF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btU8f":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "addBusinessDays", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "addDays", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "addHours", ()=>(0, _indexJsDefault3.default));
parcelHelpers.export(exports, "addISOWeekYears", ()=>(0, _indexJsDefault4.default));
parcelHelpers.export(exports, "addMilliseconds", ()=>(0, _indexJsDefault5.default));
parcelHelpers.export(exports, "addMinutes", ()=>(0, _indexJsDefault6.default));
parcelHelpers.export(exports, "addMonths", ()=>(0, _indexJsDefault7.default));
parcelHelpers.export(exports, "addQuarters", ()=>(0, _indexJsDefault8.default));
parcelHelpers.export(exports, "addSeconds", ()=>(0, _indexJsDefault9.default));
parcelHelpers.export(exports, "addWeeks", ()=>(0, _indexJsDefault10.default));
parcelHelpers.export(exports, "addYears", ()=>(0, _indexJsDefault11.default));
parcelHelpers.export(exports, "areIntervalsOverlapping", ()=>(0, _indexJsDefault12.default));
parcelHelpers.export(exports, "clamp", ()=>(0, _indexJsDefault13.default));
parcelHelpers.export(exports, "closestIndexTo", ()=>(0, _indexJsDefault14.default));
parcelHelpers.export(exports, "closestTo", ()=>(0, _indexJsDefault15.default));
parcelHelpers.export(exports, "compareAsc", ()=>(0, _indexJsDefault16.default));
parcelHelpers.export(exports, "compareDesc", ()=>(0, _indexJsDefault17.default));
parcelHelpers.export(exports, "daysToWeeks", ()=>(0, _indexJsDefault18.default));
parcelHelpers.export(exports, "differenceInBusinessDays", ()=>(0, _indexJsDefault19.default));
parcelHelpers.export(exports, "differenceInCalendarDays", ()=>(0, _indexJsDefault20.default));
parcelHelpers.export(exports, "differenceInCalendarISOWeekYears", ()=>(0, _indexJsDefault21.default));
parcelHelpers.export(exports, "differenceInCalendarISOWeeks", ()=>(0, _indexJsDefault22.default));
parcelHelpers.export(exports, "differenceInCalendarMonths", ()=>(0, _indexJsDefault23.default));
parcelHelpers.export(exports, "differenceInCalendarQuarters", ()=>(0, _indexJsDefault24.default));
parcelHelpers.export(exports, "differenceInCalendarWeeks", ()=>(0, _indexJsDefault25.default));
parcelHelpers.export(exports, "differenceInCalendarYears", ()=>(0, _indexJsDefault26.default));
parcelHelpers.export(exports, "differenceInDays", ()=>(0, _indexJsDefault27.default));
parcelHelpers.export(exports, "differenceInHours", ()=>(0, _indexJsDefault28.default));
parcelHelpers.export(exports, "differenceInISOWeekYears", ()=>(0, _indexJsDefault29.default));
parcelHelpers.export(exports, "differenceInMilliseconds", ()=>(0, _indexJsDefault30.default));
parcelHelpers.export(exports, "differenceInMinutes", ()=>(0, _indexJsDefault31.default));
parcelHelpers.export(exports, "differenceInMonths", ()=>(0, _indexJsDefault32.default));
parcelHelpers.export(exports, "differenceInQuarters", ()=>(0, _indexJsDefault33.default));
parcelHelpers.export(exports, "differenceInSeconds", ()=>(0, _indexJsDefault34.default));
parcelHelpers.export(exports, "differenceInWeeks", ()=>(0, _indexJsDefault35.default));
parcelHelpers.export(exports, "differenceInYears", ()=>(0, _indexJsDefault36.default));
parcelHelpers.export(exports, "eachDayOfInterval", ()=>(0, _indexJsDefault37.default));
parcelHelpers.export(exports, "eachHourOfInterval", ()=>(0, _indexJsDefault38.default));
parcelHelpers.export(exports, "eachMinuteOfInterval", ()=>(0, _indexJsDefault39.default));
parcelHelpers.export(exports, "eachMonthOfInterval", ()=>(0, _indexJsDefault40.default));
parcelHelpers.export(exports, "eachQuarterOfInterval", ()=>(0, _indexJsDefault41.default));
parcelHelpers.export(exports, "eachWeekOfInterval", ()=>(0, _indexJsDefault42.default));
parcelHelpers.export(exports, "eachWeekendOfInterval", ()=>(0, _indexJsDefault43.default));
parcelHelpers.export(exports, "eachWeekendOfMonth", ()=>(0, _indexJsDefault44.default));
parcelHelpers.export(exports, "eachWeekendOfYear", ()=>(0, _indexJsDefault45.default));
parcelHelpers.export(exports, "eachYearOfInterval", ()=>(0, _indexJsDefault46.default));
parcelHelpers.export(exports, "endOfDay", ()=>(0, _indexJsDefault47.default));
parcelHelpers.export(exports, "endOfDecade", ()=>(0, _indexJsDefault48.default));
parcelHelpers.export(exports, "endOfHour", ()=>(0, _indexJsDefault49.default));
parcelHelpers.export(exports, "endOfISOWeek", ()=>(0, _indexJsDefault50.default));
parcelHelpers.export(exports, "endOfISOWeekYear", ()=>(0, _indexJsDefault51.default));
parcelHelpers.export(exports, "endOfMinute", ()=>(0, _indexJsDefault52.default));
parcelHelpers.export(exports, "endOfMonth", ()=>(0, _indexJsDefault53.default));
parcelHelpers.export(exports, "endOfQuarter", ()=>(0, _indexJsDefault54.default));
parcelHelpers.export(exports, "endOfSecond", ()=>(0, _indexJsDefault55.default));
parcelHelpers.export(exports, "endOfToday", ()=>(0, _indexJsDefault56.default));
parcelHelpers.export(exports, "endOfTomorrow", ()=>(0, _indexJsDefault57.default));
parcelHelpers.export(exports, "endOfWeek", ()=>(0, _indexJsDefault58.default));
parcelHelpers.export(exports, "endOfYear", ()=>(0, _indexJsDefault59.default));
parcelHelpers.export(exports, "endOfYesterday", ()=>(0, _indexJsDefault60.default));
parcelHelpers.export(exports, "format", ()=>(0, _indexJsDefault61.default));
parcelHelpers.export(exports, "formatDistance", ()=>(0, _indexJsDefault62.default));
parcelHelpers.export(exports, "formatDistanceStrict", ()=>(0, _indexJsDefault63.default));
parcelHelpers.export(exports, "formatDistanceToNow", ()=>(0, _indexJsDefault64.default));
parcelHelpers.export(exports, "formatDistanceToNowStrict", ()=>(0, _indexJsDefault65.default));
parcelHelpers.export(exports, "formatDuration", ()=>(0, _indexJsDefault66.default));
parcelHelpers.export(exports, "formatISO", ()=>(0, _indexJsDefault67.default));
parcelHelpers.export(exports, "formatISO9075", ()=>(0, _indexJsDefault68.default));
parcelHelpers.export(exports, "formatISODuration", ()=>(0, _indexJsDefault69.default));
parcelHelpers.export(exports, "formatRFC3339", ()=>(0, _indexJsDefault70.default));
parcelHelpers.export(exports, "formatRFC7231", ()=>(0, _indexJsDefault71.default));
parcelHelpers.export(exports, "formatRelative", ()=>(0, _indexJsDefault72.default));
parcelHelpers.export(exports, "fromUnixTime", ()=>(0, _indexJsDefault73.default));
parcelHelpers.export(exports, "getDate", ()=>(0, _indexJsDefault74.default));
parcelHelpers.export(exports, "getDay", ()=>(0, _indexJsDefault75.default));
parcelHelpers.export(exports, "getDayOfYear", ()=>(0, _indexJsDefault76.default));
parcelHelpers.export(exports, "getDaysInMonth", ()=>(0, _indexJsDefault77.default));
parcelHelpers.export(exports, "getDaysInYear", ()=>(0, _indexJsDefault78.default));
parcelHelpers.export(exports, "getDecade", ()=>(0, _indexJsDefault79.default));
parcelHelpers.export(exports, "getDefaultOptions", ()=>(0, _indexJsDefault80.default));
parcelHelpers.export(exports, "getHours", ()=>(0, _indexJsDefault81.default));
parcelHelpers.export(exports, "getISODay", ()=>(0, _indexJsDefault82.default));
parcelHelpers.export(exports, "getISOWeek", ()=>(0, _indexJsDefault83.default));
parcelHelpers.export(exports, "getISOWeekYear", ()=>(0, _indexJsDefault84.default));
parcelHelpers.export(exports, "getISOWeeksInYear", ()=>(0, _indexJsDefault85.default));
parcelHelpers.export(exports, "getMilliseconds", ()=>(0, _indexJsDefault86.default));
parcelHelpers.export(exports, "getMinutes", ()=>(0, _indexJsDefault87.default));
parcelHelpers.export(exports, "getMonth", ()=>(0, _indexJsDefault88.default));
parcelHelpers.export(exports, "getOverlappingDaysInIntervals", ()=>(0, _indexJsDefault89.default));
parcelHelpers.export(exports, "getQuarter", ()=>(0, _indexJsDefault90.default));
parcelHelpers.export(exports, "getSeconds", ()=>(0, _indexJsDefault91.default));
parcelHelpers.export(exports, "getTime", ()=>(0, _indexJsDefault92.default));
parcelHelpers.export(exports, "getUnixTime", ()=>(0, _indexJsDefault93.default));
parcelHelpers.export(exports, "getWeek", ()=>(0, _indexJsDefault94.default));
parcelHelpers.export(exports, "getWeekOfMonth", ()=>(0, _indexJsDefault95.default));
parcelHelpers.export(exports, "getWeekYear", ()=>(0, _indexJsDefault96.default));
parcelHelpers.export(exports, "getWeeksInMonth", ()=>(0, _indexJsDefault97.default));
parcelHelpers.export(exports, "getYear", ()=>(0, _indexJsDefault98.default));
parcelHelpers.export(exports, "hoursToMilliseconds", ()=>(0, _indexJsDefault99.default));
parcelHelpers.export(exports, "hoursToMinutes", ()=>(0, _indexJsDefault100.default));
parcelHelpers.export(exports, "hoursToSeconds", ()=>(0, _indexJsDefault101.default));
parcelHelpers.export(exports, "intervalToDuration", ()=>(0, _indexJsDefault102.default));
parcelHelpers.export(exports, "intlFormat", ()=>(0, _indexJsDefault103.default));
parcelHelpers.export(exports, "intlFormatDistance", ()=>(0, _indexJsDefault104.default));
parcelHelpers.export(exports, "isAfter", ()=>(0, _indexJsDefault105.default));
parcelHelpers.export(exports, "isBefore", ()=>(0, _indexJsDefault106.default));
parcelHelpers.export(exports, "isDate", ()=>(0, _indexJsDefault107.default));
parcelHelpers.export(exports, "isEqual", ()=>(0, _indexJsDefault108.default));
parcelHelpers.export(exports, "isExists", ()=>(0, _indexJsDefault109.default));
parcelHelpers.export(exports, "isFirstDayOfMonth", ()=>(0, _indexJsDefault110.default));
parcelHelpers.export(exports, "isFriday", ()=>(0, _indexJsDefault111.default));
parcelHelpers.export(exports, "isFuture", ()=>(0, _indexJsDefault112.default));
parcelHelpers.export(exports, "isLastDayOfMonth", ()=>(0, _indexJsDefault113.default));
parcelHelpers.export(exports, "isLeapYear", ()=>(0, _indexJsDefault114.default));
parcelHelpers.export(exports, "isMatch", ()=>(0, _indexJsDefault115.default));
parcelHelpers.export(exports, "isMonday", ()=>(0, _indexJsDefault116.default));
parcelHelpers.export(exports, "isPast", ()=>(0, _indexJsDefault117.default));
parcelHelpers.export(exports, "isSameDay", ()=>(0, _indexJsDefault118.default));
parcelHelpers.export(exports, "isSameHour", ()=>(0, _indexJsDefault119.default));
parcelHelpers.export(exports, "isSameISOWeek", ()=>(0, _indexJsDefault120.default));
parcelHelpers.export(exports, "isSameISOWeekYear", ()=>(0, _indexJsDefault121.default));
parcelHelpers.export(exports, "isSameMinute", ()=>(0, _indexJsDefault122.default));
parcelHelpers.export(exports, "isSameMonth", ()=>(0, _indexJsDefault123.default));
parcelHelpers.export(exports, "isSameQuarter", ()=>(0, _indexJsDefault124.default));
parcelHelpers.export(exports, "isSameSecond", ()=>(0, _indexJsDefault125.default));
parcelHelpers.export(exports, "isSameWeek", ()=>(0, _indexJsDefault126.default));
parcelHelpers.export(exports, "isSameYear", ()=>(0, _indexJsDefault127.default));
parcelHelpers.export(exports, "isSaturday", ()=>(0, _indexJsDefault128.default));
parcelHelpers.export(exports, "isSunday", ()=>(0, _indexJsDefault129.default));
parcelHelpers.export(exports, "isThisHour", ()=>(0, _indexJsDefault130.default));
parcelHelpers.export(exports, "isThisISOWeek", ()=>(0, _indexJsDefault131.default));
parcelHelpers.export(exports, "isThisMinute", ()=>(0, _indexJsDefault132.default));
parcelHelpers.export(exports, "isThisMonth", ()=>(0, _indexJsDefault133.default));
parcelHelpers.export(exports, "isThisQuarter", ()=>(0, _indexJsDefault134.default));
parcelHelpers.export(exports, "isThisSecond", ()=>(0, _indexJsDefault135.default));
parcelHelpers.export(exports, "isThisWeek", ()=>(0, _indexJsDefault136.default));
parcelHelpers.export(exports, "isThisYear", ()=>(0, _indexJsDefault137.default));
parcelHelpers.export(exports, "isThursday", ()=>(0, _indexJsDefault138.default));
parcelHelpers.export(exports, "isToday", ()=>(0, _indexJsDefault139.default));
parcelHelpers.export(exports, "isTomorrow", ()=>(0, _indexJsDefault140.default));
parcelHelpers.export(exports, "isTuesday", ()=>(0, _indexJsDefault141.default));
parcelHelpers.export(exports, "isValid", ()=>(0, _indexJsDefault142.default));
parcelHelpers.export(exports, "isWednesday", ()=>(0, _indexJsDefault143.default));
parcelHelpers.export(exports, "isWeekend", ()=>(0, _indexJsDefault144.default));
parcelHelpers.export(exports, "isWithinInterval", ()=>(0, _indexJsDefault145.default));
parcelHelpers.export(exports, "isYesterday", ()=>(0, _indexJsDefault146.default));
parcelHelpers.export(exports, "lastDayOfDecade", ()=>(0, _indexJsDefault147.default));
parcelHelpers.export(exports, "lastDayOfISOWeek", ()=>(0, _indexJsDefault148.default));
parcelHelpers.export(exports, "lastDayOfISOWeekYear", ()=>(0, _indexJsDefault149.default));
parcelHelpers.export(exports, "lastDayOfMonth", ()=>(0, _indexJsDefault150.default));
parcelHelpers.export(exports, "lastDayOfQuarter", ()=>(0, _indexJsDefault151.default));
parcelHelpers.export(exports, "lastDayOfWeek", ()=>(0, _indexJsDefault152.default));
parcelHelpers.export(exports, "lastDayOfYear", ()=>(0, _indexJsDefault153.default));
parcelHelpers.export(exports, "lightFormat", ()=>(0, _indexJsDefault154.default));
parcelHelpers.export(exports, "max", ()=>(0, _indexJsDefault155.default));
parcelHelpers.export(exports, "milliseconds", ()=>(0, _indexJsDefault156.default));
parcelHelpers.export(exports, "millisecondsToHours", ()=>(0, _indexJsDefault157.default));
parcelHelpers.export(exports, "millisecondsToMinutes", ()=>(0, _indexJsDefault158.default));
parcelHelpers.export(exports, "millisecondsToSeconds", ()=>(0, _indexJsDefault159.default));
parcelHelpers.export(exports, "min", ()=>(0, _indexJsDefault160.default));
parcelHelpers.export(exports, "minutesToHours", ()=>(0, _indexJsDefault161.default));
parcelHelpers.export(exports, "minutesToMilliseconds", ()=>(0, _indexJsDefault162.default));
parcelHelpers.export(exports, "minutesToSeconds", ()=>(0, _indexJsDefault163.default));
parcelHelpers.export(exports, "monthsToQuarters", ()=>(0, _indexJsDefault164.default));
parcelHelpers.export(exports, "monthsToYears", ()=>(0, _indexJsDefault165.default));
parcelHelpers.export(exports, "nextDay", ()=>(0, _indexJsDefault166.default));
parcelHelpers.export(exports, "nextFriday", ()=>(0, _indexJsDefault167.default));
parcelHelpers.export(exports, "nextMonday", ()=>(0, _indexJsDefault168.default));
parcelHelpers.export(exports, "nextSaturday", ()=>(0, _indexJsDefault169.default));
parcelHelpers.export(exports, "nextSunday", ()=>(0, _indexJsDefault170.default));
parcelHelpers.export(exports, "nextThursday", ()=>(0, _indexJsDefault171.default));
parcelHelpers.export(exports, "nextTuesday", ()=>(0, _indexJsDefault172.default));
parcelHelpers.export(exports, "nextWednesday", ()=>(0, _indexJsDefault173.default));
parcelHelpers.export(exports, "parse", ()=>(0, _indexJsDefault174.default));
parcelHelpers.export(exports, "parseISO", ()=>(0, _indexJsDefault175.default));
parcelHelpers.export(exports, "parseJSON", ()=>(0, _indexJsDefault176.default));
parcelHelpers.export(exports, "previousDay", ()=>(0, _indexJsDefault177.default));
parcelHelpers.export(exports, "previousFriday", ()=>(0, _indexJsDefault178.default));
parcelHelpers.export(exports, "previousMonday", ()=>(0, _indexJsDefault179.default));
parcelHelpers.export(exports, "previousSaturday", ()=>(0, _indexJsDefault180.default));
parcelHelpers.export(exports, "previousSunday", ()=>(0, _indexJsDefault181.default));
parcelHelpers.export(exports, "previousThursday", ()=>(0, _indexJsDefault182.default));
parcelHelpers.export(exports, "previousTuesday", ()=>(0, _indexJsDefault183.default));
parcelHelpers.export(exports, "previousWednesday", ()=>(0, _indexJsDefault184.default));
parcelHelpers.export(exports, "quartersToMonths", ()=>(0, _indexJsDefault185.default));
parcelHelpers.export(exports, "quartersToYears", ()=>(0, _indexJsDefault186.default));
parcelHelpers.export(exports, "roundToNearestMinutes", ()=>(0, _indexJsDefault187.default));
parcelHelpers.export(exports, "secondsToHours", ()=>(0, _indexJsDefault188.default));
parcelHelpers.export(exports, "secondsToMilliseconds", ()=>(0, _indexJsDefault189.default));
parcelHelpers.export(exports, "secondsToMinutes", ()=>(0, _indexJsDefault190.default));
parcelHelpers.export(exports, "set", ()=>(0, _indexJsDefault191.default));
parcelHelpers.export(exports, "setDate", ()=>(0, _indexJsDefault192.default));
parcelHelpers.export(exports, "setDay", ()=>(0, _indexJsDefault193.default));
parcelHelpers.export(exports, "setDayOfYear", ()=>(0, _indexJsDefault194.default));
parcelHelpers.export(exports, "setDefaultOptions", ()=>(0, _indexJsDefault195.default));
parcelHelpers.export(exports, "setHours", ()=>(0, _indexJsDefault196.default));
parcelHelpers.export(exports, "setISODay", ()=>(0, _indexJsDefault197.default));
parcelHelpers.export(exports, "setISOWeek", ()=>(0, _indexJsDefault198.default));
parcelHelpers.export(exports, "setISOWeekYear", ()=>(0, _indexJsDefault199.default));
parcelHelpers.export(exports, "setMilliseconds", ()=>(0, _indexJsDefault200.default));
parcelHelpers.export(exports, "setMinutes", ()=>(0, _indexJsDefault201.default));
parcelHelpers.export(exports, "setMonth", ()=>(0, _indexJsDefault202.default));
parcelHelpers.export(exports, "setQuarter", ()=>(0, _indexJsDefault203.default));
parcelHelpers.export(exports, "setSeconds", ()=>(0, _indexJsDefault204.default));
parcelHelpers.export(exports, "setWeek", ()=>(0, _indexJsDefault205.default));
parcelHelpers.export(exports, "setWeekYear", ()=>(0, _indexJsDefault206.default));
parcelHelpers.export(exports, "setYear", ()=>(0, _indexJsDefault207.default));
parcelHelpers.export(exports, "startOfDay", ()=>(0, _indexJsDefault208.default));
parcelHelpers.export(exports, "startOfDecade", ()=>(0, _indexJsDefault209.default));
parcelHelpers.export(exports, "startOfHour", ()=>(0, _indexJsDefault210.default));
parcelHelpers.export(exports, "startOfISOWeek", ()=>(0, _indexJsDefault211.default));
parcelHelpers.export(exports, "startOfISOWeekYear", ()=>(0, _indexJsDefault212.default));
parcelHelpers.export(exports, "startOfMinute", ()=>(0, _indexJsDefault213.default));
parcelHelpers.export(exports, "startOfMonth", ()=>(0, _indexJsDefault214.default));
parcelHelpers.export(exports, "startOfQuarter", ()=>(0, _indexJsDefault215.default));
parcelHelpers.export(exports, "startOfSecond", ()=>(0, _indexJsDefault216.default));
parcelHelpers.export(exports, "startOfToday", ()=>(0, _indexJsDefault217.default));
parcelHelpers.export(exports, "startOfTomorrow", ()=>(0, _indexJsDefault218.default));
parcelHelpers.export(exports, "startOfWeek", ()=>(0, _indexJsDefault219.default));
parcelHelpers.export(exports, "startOfWeekYear", ()=>(0, _indexJsDefault220.default));
parcelHelpers.export(exports, "startOfYear", ()=>(0, _indexJsDefault221.default));
parcelHelpers.export(exports, "startOfYesterday", ()=>(0, _indexJsDefault222.default));
parcelHelpers.export(exports, "sub", ()=>(0, _indexJsDefault223.default));
parcelHelpers.export(exports, "subBusinessDays", ()=>(0, _indexJsDefault224.default));
parcelHelpers.export(exports, "subDays", ()=>(0, _indexJsDefault225.default));
parcelHelpers.export(exports, "subHours", ()=>(0, _indexJsDefault226.default));
parcelHelpers.export(exports, "subISOWeekYears", ()=>(0, _indexJsDefault227.default));
parcelHelpers.export(exports, "subMilliseconds", ()=>(0, _indexJsDefault228.default));
parcelHelpers.export(exports, "subMinutes", ()=>(0, _indexJsDefault229.default));
parcelHelpers.export(exports, "subMonths", ()=>(0, _indexJsDefault230.default));
parcelHelpers.export(exports, "subQuarters", ()=>(0, _indexJsDefault231.default));
parcelHelpers.export(exports, "subSeconds", ()=>(0, _indexJsDefault232.default));
parcelHelpers.export(exports, "subWeeks", ()=>(0, _indexJsDefault233.default));
parcelHelpers.export(exports, "subYears", ()=>(0, _indexJsDefault234.default));
parcelHelpers.export(exports, "toDate", ()=>(0, _indexJsDefault235.default));
parcelHelpers.export(exports, "weeksToDays", ()=>(0, _indexJsDefault236.default));
parcelHelpers.export(exports, "yearsToMonths", ()=>(0, _indexJsDefault237.default));
parcelHelpers.export(exports, "yearsToQuarters", ()=>(0, _indexJsDefault238.default));
var _indexJs = require("./add/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./addBusinessDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./addDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./addHours/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./addISOWeekYears/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./addMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./addMinutes/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./addMonths/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./addQuarters/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./addSeconds/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./addWeeks/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./addYears/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./areIntervalsOverlapping/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./clamp/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./closestIndexTo/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./closestTo/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./compareAsc/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./compareDesc/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./daysToWeeks/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./differenceInBusinessDays/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./differenceInCalendarDays/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./differenceInCalendarISOWeekYears/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./differenceInCalendarISOWeeks/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./differenceInCalendarMonths/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./differenceInCalendarQuarters/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./differenceInCalendarWeeks/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./differenceInCalendarYears/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./differenceInDays/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./differenceInHours/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./differenceInISOWeekYears/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./differenceInMilliseconds/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./differenceInMinutes/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./differenceInMonths/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./differenceInQuarters/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./differenceInSeconds/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./differenceInWeeks/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./differenceInYears/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./eachDayOfInterval/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./eachHourOfInterval/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./eachMinuteOfInterval/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./eachMonthOfInterval/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./eachQuarterOfInterval/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./eachWeekOfInterval/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./eachWeekendOfInterval/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./eachWeekendOfMonth/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./eachWeekendOfYear/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./eachYearOfInterval/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./endOfDay/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./endOfDecade/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./endOfHour/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./endOfISOWeek/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./endOfISOWeekYear/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./endOfMinute/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./endOfMonth/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./endOfQuarter/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./endOfSecond/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./endOfToday/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./endOfTomorrow/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./endOfWeek/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./endOfYear/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./endOfYesterday/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./format/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./formatDistance/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./formatDistanceStrict/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./formatDistanceToNow/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./formatDistanceToNowStrict/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./formatDuration/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./formatISO/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./formatISO9075/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./formatISODuration/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./formatRFC3339/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./formatRFC7231/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./formatRelative/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./fromUnixTime/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./getDate/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./getDay/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./getDayOfYear/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./getDaysInMonth/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./getDaysInYear/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./getDecade/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./getDefaultOptions/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./getHours/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./getISODay/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./getISOWeek/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./getISOWeekYear/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./getISOWeeksInYear/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./getMilliseconds/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./getMinutes/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./getMonth/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./getOverlappingDaysInIntervals/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./getQuarter/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./getSeconds/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./getTime/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);
var _indexJs93 = require("./getUnixTime/index.js");
var _indexJsDefault93 = parcelHelpers.interopDefault(_indexJs93);
var _indexJs94 = require("./getWeek/index.js");
var _indexJsDefault94 = parcelHelpers.interopDefault(_indexJs94);
var _indexJs95 = require("./getWeekOfMonth/index.js");
var _indexJsDefault95 = parcelHelpers.interopDefault(_indexJs95);
var _indexJs96 = require("./getWeekYear/index.js");
var _indexJsDefault96 = parcelHelpers.interopDefault(_indexJs96);
var _indexJs97 = require("./getWeeksInMonth/index.js");
var _indexJsDefault97 = parcelHelpers.interopDefault(_indexJs97);
var _indexJs98 = require("./getYear/index.js");
var _indexJsDefault98 = parcelHelpers.interopDefault(_indexJs98);
var _indexJs99 = require("./hoursToMilliseconds/index.js");
var _indexJsDefault99 = parcelHelpers.interopDefault(_indexJs99);
var _indexJs100 = require("./hoursToMinutes/index.js");
var _indexJsDefault100 = parcelHelpers.interopDefault(_indexJs100);
var _indexJs101 = require("./hoursToSeconds/index.js");
var _indexJsDefault101 = parcelHelpers.interopDefault(_indexJs101);
var _indexJs102 = require("./intervalToDuration/index.js");
var _indexJsDefault102 = parcelHelpers.interopDefault(_indexJs102);
var _indexJs103 = require("./intlFormat/index.js");
var _indexJsDefault103 = parcelHelpers.interopDefault(_indexJs103);
var _indexJs104 = require("./intlFormatDistance/index.js");
var _indexJsDefault104 = parcelHelpers.interopDefault(_indexJs104);
var _indexJs105 = require("./isAfter/index.js");
var _indexJsDefault105 = parcelHelpers.interopDefault(_indexJs105);
var _indexJs106 = require("./isBefore/index.js");
var _indexJsDefault106 = parcelHelpers.interopDefault(_indexJs106);
var _indexJs107 = require("./isDate/index.js");
var _indexJsDefault107 = parcelHelpers.interopDefault(_indexJs107);
var _indexJs108 = require("./isEqual/index.js");
var _indexJsDefault108 = parcelHelpers.interopDefault(_indexJs108);
var _indexJs109 = require("./isExists/index.js");
var _indexJsDefault109 = parcelHelpers.interopDefault(_indexJs109);
var _indexJs110 = require("./isFirstDayOfMonth/index.js");
var _indexJsDefault110 = parcelHelpers.interopDefault(_indexJs110);
var _indexJs111 = require("./isFriday/index.js");
var _indexJsDefault111 = parcelHelpers.interopDefault(_indexJs111);
var _indexJs112 = require("./isFuture/index.js");
var _indexJsDefault112 = parcelHelpers.interopDefault(_indexJs112);
var _indexJs113 = require("./isLastDayOfMonth/index.js");
var _indexJsDefault113 = parcelHelpers.interopDefault(_indexJs113);
var _indexJs114 = require("./isLeapYear/index.js");
var _indexJsDefault114 = parcelHelpers.interopDefault(_indexJs114);
var _indexJs115 = require("./isMatch/index.js");
var _indexJsDefault115 = parcelHelpers.interopDefault(_indexJs115);
var _indexJs116 = require("./isMonday/index.js");
var _indexJsDefault116 = parcelHelpers.interopDefault(_indexJs116);
var _indexJs117 = require("./isPast/index.js");
var _indexJsDefault117 = parcelHelpers.interopDefault(_indexJs117);
var _indexJs118 = require("./isSameDay/index.js");
var _indexJsDefault118 = parcelHelpers.interopDefault(_indexJs118);
var _indexJs119 = require("./isSameHour/index.js");
var _indexJsDefault119 = parcelHelpers.interopDefault(_indexJs119);
var _indexJs120 = require("./isSameISOWeek/index.js");
var _indexJsDefault120 = parcelHelpers.interopDefault(_indexJs120);
var _indexJs121 = require("./isSameISOWeekYear/index.js");
var _indexJsDefault121 = parcelHelpers.interopDefault(_indexJs121);
var _indexJs122 = require("./isSameMinute/index.js");
var _indexJsDefault122 = parcelHelpers.interopDefault(_indexJs122);
var _indexJs123 = require("./isSameMonth/index.js");
var _indexJsDefault123 = parcelHelpers.interopDefault(_indexJs123);
var _indexJs124 = require("./isSameQuarter/index.js");
var _indexJsDefault124 = parcelHelpers.interopDefault(_indexJs124);
var _indexJs125 = require("./isSameSecond/index.js");
var _indexJsDefault125 = parcelHelpers.interopDefault(_indexJs125);
var _indexJs126 = require("./isSameWeek/index.js");
var _indexJsDefault126 = parcelHelpers.interopDefault(_indexJs126);
var _indexJs127 = require("./isSameYear/index.js");
var _indexJsDefault127 = parcelHelpers.interopDefault(_indexJs127);
var _indexJs128 = require("./isSaturday/index.js");
var _indexJsDefault128 = parcelHelpers.interopDefault(_indexJs128);
var _indexJs129 = require("./isSunday/index.js");
var _indexJsDefault129 = parcelHelpers.interopDefault(_indexJs129);
var _indexJs130 = require("./isThisHour/index.js");
var _indexJsDefault130 = parcelHelpers.interopDefault(_indexJs130);
var _indexJs131 = require("./isThisISOWeek/index.js");
var _indexJsDefault131 = parcelHelpers.interopDefault(_indexJs131);
var _indexJs132 = require("./isThisMinute/index.js");
var _indexJsDefault132 = parcelHelpers.interopDefault(_indexJs132);
var _indexJs133 = require("./isThisMonth/index.js");
var _indexJsDefault133 = parcelHelpers.interopDefault(_indexJs133);
var _indexJs134 = require("./isThisQuarter/index.js");
var _indexJsDefault134 = parcelHelpers.interopDefault(_indexJs134);
var _indexJs135 = require("./isThisSecond/index.js");
var _indexJsDefault135 = parcelHelpers.interopDefault(_indexJs135);
var _indexJs136 = require("./isThisWeek/index.js");
var _indexJsDefault136 = parcelHelpers.interopDefault(_indexJs136);
var _indexJs137 = require("./isThisYear/index.js");
var _indexJsDefault137 = parcelHelpers.interopDefault(_indexJs137);
var _indexJs138 = require("./isThursday/index.js");
var _indexJsDefault138 = parcelHelpers.interopDefault(_indexJs138);
var _indexJs139 = require("./isToday/index.js");
var _indexJsDefault139 = parcelHelpers.interopDefault(_indexJs139);
var _indexJs140 = require("./isTomorrow/index.js");
var _indexJsDefault140 = parcelHelpers.interopDefault(_indexJs140);
var _indexJs141 = require("./isTuesday/index.js");
var _indexJsDefault141 = parcelHelpers.interopDefault(_indexJs141);
var _indexJs142 = require("./isValid/index.js");
var _indexJsDefault142 = parcelHelpers.interopDefault(_indexJs142);
var _indexJs143 = require("./isWednesday/index.js");
var _indexJsDefault143 = parcelHelpers.interopDefault(_indexJs143);
var _indexJs144 = require("./isWeekend/index.js");
var _indexJsDefault144 = parcelHelpers.interopDefault(_indexJs144);
var _indexJs145 = require("./isWithinInterval/index.js");
var _indexJsDefault145 = parcelHelpers.interopDefault(_indexJs145);
var _indexJs146 = require("./isYesterday/index.js");
var _indexJsDefault146 = parcelHelpers.interopDefault(_indexJs146);
var _indexJs147 = require("./lastDayOfDecade/index.js");
var _indexJsDefault147 = parcelHelpers.interopDefault(_indexJs147);
var _indexJs148 = require("./lastDayOfISOWeek/index.js");
var _indexJsDefault148 = parcelHelpers.interopDefault(_indexJs148);
var _indexJs149 = require("./lastDayOfISOWeekYear/index.js");
var _indexJsDefault149 = parcelHelpers.interopDefault(_indexJs149);
var _indexJs150 = require("./lastDayOfMonth/index.js");
var _indexJsDefault150 = parcelHelpers.interopDefault(_indexJs150);
var _indexJs151 = require("./lastDayOfQuarter/index.js");
var _indexJsDefault151 = parcelHelpers.interopDefault(_indexJs151);
var _indexJs152 = require("./lastDayOfWeek/index.js");
var _indexJsDefault152 = parcelHelpers.interopDefault(_indexJs152);
var _indexJs153 = require("./lastDayOfYear/index.js");
var _indexJsDefault153 = parcelHelpers.interopDefault(_indexJs153);
var _indexJs154 = require("./lightFormat/index.js");
var _indexJsDefault154 = parcelHelpers.interopDefault(_indexJs154);
var _indexJs155 = require("./max/index.js");
var _indexJsDefault155 = parcelHelpers.interopDefault(_indexJs155);
var _indexJs156 = require("./milliseconds/index.js");
var _indexJsDefault156 = parcelHelpers.interopDefault(_indexJs156);
var _indexJs157 = require("./millisecondsToHours/index.js");
var _indexJsDefault157 = parcelHelpers.interopDefault(_indexJs157);
var _indexJs158 = require("./millisecondsToMinutes/index.js");
var _indexJsDefault158 = parcelHelpers.interopDefault(_indexJs158);
var _indexJs159 = require("./millisecondsToSeconds/index.js");
var _indexJsDefault159 = parcelHelpers.interopDefault(_indexJs159);
var _indexJs160 = require("./min/index.js");
var _indexJsDefault160 = parcelHelpers.interopDefault(_indexJs160);
var _indexJs161 = require("./minutesToHours/index.js");
var _indexJsDefault161 = parcelHelpers.interopDefault(_indexJs161);
var _indexJs162 = require("./minutesToMilliseconds/index.js");
var _indexJsDefault162 = parcelHelpers.interopDefault(_indexJs162);
var _indexJs163 = require("./minutesToSeconds/index.js");
var _indexJsDefault163 = parcelHelpers.interopDefault(_indexJs163);
var _indexJs164 = require("./monthsToQuarters/index.js");
var _indexJsDefault164 = parcelHelpers.interopDefault(_indexJs164);
var _indexJs165 = require("./monthsToYears/index.js");
var _indexJsDefault165 = parcelHelpers.interopDefault(_indexJs165);
var _indexJs166 = require("./nextDay/index.js");
var _indexJsDefault166 = parcelHelpers.interopDefault(_indexJs166);
var _indexJs167 = require("./nextFriday/index.js");
var _indexJsDefault167 = parcelHelpers.interopDefault(_indexJs167);
var _indexJs168 = require("./nextMonday/index.js");
var _indexJsDefault168 = parcelHelpers.interopDefault(_indexJs168);
var _indexJs169 = require("./nextSaturday/index.js");
var _indexJsDefault169 = parcelHelpers.interopDefault(_indexJs169);
var _indexJs170 = require("./nextSunday/index.js");
var _indexJsDefault170 = parcelHelpers.interopDefault(_indexJs170);
var _indexJs171 = require("./nextThursday/index.js");
var _indexJsDefault171 = parcelHelpers.interopDefault(_indexJs171);
var _indexJs172 = require("./nextTuesday/index.js");
var _indexJsDefault172 = parcelHelpers.interopDefault(_indexJs172);
var _indexJs173 = require("./nextWednesday/index.js");
var _indexJsDefault173 = parcelHelpers.interopDefault(_indexJs173);
var _indexJs174 = require("./parse/index.js");
var _indexJsDefault174 = parcelHelpers.interopDefault(_indexJs174);
var _indexJs175 = require("./parseISO/index.js");
var _indexJsDefault175 = parcelHelpers.interopDefault(_indexJs175);
var _indexJs176 = require("./parseJSON/index.js");
var _indexJsDefault176 = parcelHelpers.interopDefault(_indexJs176);
var _indexJs177 = require("./previousDay/index.js");
var _indexJsDefault177 = parcelHelpers.interopDefault(_indexJs177);
var _indexJs178 = require("./previousFriday/index.js");
var _indexJsDefault178 = parcelHelpers.interopDefault(_indexJs178);
var _indexJs179 = require("./previousMonday/index.js");
var _indexJsDefault179 = parcelHelpers.interopDefault(_indexJs179);
var _indexJs180 = require("./previousSaturday/index.js");
var _indexJsDefault180 = parcelHelpers.interopDefault(_indexJs180);
var _indexJs181 = require("./previousSunday/index.js");
var _indexJsDefault181 = parcelHelpers.interopDefault(_indexJs181);
var _indexJs182 = require("./previousThursday/index.js");
var _indexJsDefault182 = parcelHelpers.interopDefault(_indexJs182);
var _indexJs183 = require("./previousTuesday/index.js");
var _indexJsDefault183 = parcelHelpers.interopDefault(_indexJs183);
var _indexJs184 = require("./previousWednesday/index.js");
var _indexJsDefault184 = parcelHelpers.interopDefault(_indexJs184);
var _indexJs185 = require("./quartersToMonths/index.js");
var _indexJsDefault185 = parcelHelpers.interopDefault(_indexJs185);
var _indexJs186 = require("./quartersToYears/index.js");
var _indexJsDefault186 = parcelHelpers.interopDefault(_indexJs186);
var _indexJs187 = require("./roundToNearestMinutes/index.js");
var _indexJsDefault187 = parcelHelpers.interopDefault(_indexJs187);
var _indexJs188 = require("./secondsToHours/index.js");
var _indexJsDefault188 = parcelHelpers.interopDefault(_indexJs188);
var _indexJs189 = require("./secondsToMilliseconds/index.js");
var _indexJsDefault189 = parcelHelpers.interopDefault(_indexJs189);
var _indexJs190 = require("./secondsToMinutes/index.js");
var _indexJsDefault190 = parcelHelpers.interopDefault(_indexJs190);
var _indexJs191 = require("./set/index.js");
var _indexJsDefault191 = parcelHelpers.interopDefault(_indexJs191);
var _indexJs192 = require("./setDate/index.js");
var _indexJsDefault192 = parcelHelpers.interopDefault(_indexJs192);
var _indexJs193 = require("./setDay/index.js");
var _indexJsDefault193 = parcelHelpers.interopDefault(_indexJs193);
var _indexJs194 = require("./setDayOfYear/index.js");
var _indexJsDefault194 = parcelHelpers.interopDefault(_indexJs194);
var _indexJs195 = require("./setDefaultOptions/index.js");
var _indexJsDefault195 = parcelHelpers.interopDefault(_indexJs195);
var _indexJs196 = require("./setHours/index.js");
var _indexJsDefault196 = parcelHelpers.interopDefault(_indexJs196);
var _indexJs197 = require("./setISODay/index.js");
var _indexJsDefault197 = parcelHelpers.interopDefault(_indexJs197);
var _indexJs198 = require("./setISOWeek/index.js");
var _indexJsDefault198 = parcelHelpers.interopDefault(_indexJs198);
var _indexJs199 = require("./setISOWeekYear/index.js");
var _indexJsDefault199 = parcelHelpers.interopDefault(_indexJs199);
var _indexJs200 = require("./setMilliseconds/index.js");
var _indexJsDefault200 = parcelHelpers.interopDefault(_indexJs200);
var _indexJs201 = require("./setMinutes/index.js");
var _indexJsDefault201 = parcelHelpers.interopDefault(_indexJs201);
var _indexJs202 = require("./setMonth/index.js");
var _indexJsDefault202 = parcelHelpers.interopDefault(_indexJs202);
var _indexJs203 = require("./setQuarter/index.js");
var _indexJsDefault203 = parcelHelpers.interopDefault(_indexJs203);
var _indexJs204 = require("./setSeconds/index.js");
var _indexJsDefault204 = parcelHelpers.interopDefault(_indexJs204);
var _indexJs205 = require("./setWeek/index.js");
var _indexJsDefault205 = parcelHelpers.interopDefault(_indexJs205);
var _indexJs206 = require("./setWeekYear/index.js");
var _indexJsDefault206 = parcelHelpers.interopDefault(_indexJs206);
var _indexJs207 = require("./setYear/index.js");
var _indexJsDefault207 = parcelHelpers.interopDefault(_indexJs207);
var _indexJs208 = require("./startOfDay/index.js");
var _indexJsDefault208 = parcelHelpers.interopDefault(_indexJs208);
var _indexJs209 = require("./startOfDecade/index.js");
var _indexJsDefault209 = parcelHelpers.interopDefault(_indexJs209);
var _indexJs210 = require("./startOfHour/index.js");
var _indexJsDefault210 = parcelHelpers.interopDefault(_indexJs210);
var _indexJs211 = require("./startOfISOWeek/index.js");
var _indexJsDefault211 = parcelHelpers.interopDefault(_indexJs211);
var _indexJs212 = require("./startOfISOWeekYear/index.js");
var _indexJsDefault212 = parcelHelpers.interopDefault(_indexJs212);
var _indexJs213 = require("./startOfMinute/index.js");
var _indexJsDefault213 = parcelHelpers.interopDefault(_indexJs213);
var _indexJs214 = require("./startOfMonth/index.js");
var _indexJsDefault214 = parcelHelpers.interopDefault(_indexJs214);
var _indexJs215 = require("./startOfQuarter/index.js");
var _indexJsDefault215 = parcelHelpers.interopDefault(_indexJs215);
var _indexJs216 = require("./startOfSecond/index.js");
var _indexJsDefault216 = parcelHelpers.interopDefault(_indexJs216);
var _indexJs217 = require("./startOfToday/index.js");
var _indexJsDefault217 = parcelHelpers.interopDefault(_indexJs217);
var _indexJs218 = require("./startOfTomorrow/index.js");
var _indexJsDefault218 = parcelHelpers.interopDefault(_indexJs218);
var _indexJs219 = require("./startOfWeek/index.js");
var _indexJsDefault219 = parcelHelpers.interopDefault(_indexJs219);
var _indexJs220 = require("./startOfWeekYear/index.js");
var _indexJsDefault220 = parcelHelpers.interopDefault(_indexJs220);
var _indexJs221 = require("./startOfYear/index.js");
var _indexJsDefault221 = parcelHelpers.interopDefault(_indexJs221);
var _indexJs222 = require("./startOfYesterday/index.js");
var _indexJsDefault222 = parcelHelpers.interopDefault(_indexJs222);
var _indexJs223 = require("./sub/index.js");
var _indexJsDefault223 = parcelHelpers.interopDefault(_indexJs223);
var _indexJs224 = require("./subBusinessDays/index.js");
var _indexJsDefault224 = parcelHelpers.interopDefault(_indexJs224);
var _indexJs225 = require("./subDays/index.js");
var _indexJsDefault225 = parcelHelpers.interopDefault(_indexJs225);
var _indexJs226 = require("./subHours/index.js");
var _indexJsDefault226 = parcelHelpers.interopDefault(_indexJs226);
var _indexJs227 = require("./subISOWeekYears/index.js");
var _indexJsDefault227 = parcelHelpers.interopDefault(_indexJs227);
var _indexJs228 = require("./subMilliseconds/index.js");
var _indexJsDefault228 = parcelHelpers.interopDefault(_indexJs228);
var _indexJs229 = require("./subMinutes/index.js");
var _indexJsDefault229 = parcelHelpers.interopDefault(_indexJs229);
var _indexJs230 = require("./subMonths/index.js");
var _indexJsDefault230 = parcelHelpers.interopDefault(_indexJs230);
var _indexJs231 = require("./subQuarters/index.js");
var _indexJsDefault231 = parcelHelpers.interopDefault(_indexJs231);
var _indexJs232 = require("./subSeconds/index.js");
var _indexJsDefault232 = parcelHelpers.interopDefault(_indexJs232);
var _indexJs233 = require("./subWeeks/index.js");
var _indexJsDefault233 = parcelHelpers.interopDefault(_indexJs233);
var _indexJs234 = require("./subYears/index.js");
var _indexJsDefault234 = parcelHelpers.interopDefault(_indexJs234);
var _indexJs235 = require("./toDate/index.js");
var _indexJsDefault235 = parcelHelpers.interopDefault(_indexJs235);
var _indexJs236 = require("./weeksToDays/index.js");
var _indexJsDefault236 = parcelHelpers.interopDefault(_indexJs236);
var _indexJs237 = require("./yearsToMonths/index.js");
var _indexJsDefault237 = parcelHelpers.interopDefault(_indexJs237);
var _indexJs238 = require("./yearsToQuarters/index.js");
var _indexJsDefault238 = parcelHelpers.interopDefault(_indexJs238);
var _indexJs239 = require("./constants/index.js");
parcelHelpers.exportAll(_indexJs239, exports);

},{"./add/index.js":false,"./addBusinessDays/index.js":false,"./addDays/index.js":"fK40q","./addHours/index.js":false,"./addISOWeekYears/index.js":false,"./addMilliseconds/index.js":false,"./addMinutes/index.js":false,"./addMonths/index.js":"luR8G","./addQuarters/index.js":false,"./addSeconds/index.js":false,"./addWeeks/index.js":"6qgbJ","./addYears/index.js":"dwe65","./areIntervalsOverlapping/index.js":false,"./clamp/index.js":false,"./closestIndexTo/index.js":false,"./closestTo/index.js":false,"./compareAsc/index.js":false,"./compareDesc/index.js":false,"./daysToWeeks/index.js":false,"./differenceInBusinessDays/index.js":false,"./differenceInCalendarDays/index.js":"9Dyug","./differenceInCalendarISOWeekYears/index.js":false,"./differenceInCalendarISOWeeks/index.js":false,"./differenceInCalendarMonths/index.js":"iE73E","./differenceInCalendarQuarters/index.js":false,"./differenceInCalendarWeeks/index.js":false,"./differenceInCalendarYears/index.js":false,"./differenceInDays/index.js":false,"./differenceInHours/index.js":false,"./differenceInISOWeekYears/index.js":false,"./differenceInMilliseconds/index.js":false,"./differenceInMinutes/index.js":false,"./differenceInMonths/index.js":false,"./differenceInQuarters/index.js":false,"./differenceInSeconds/index.js":false,"./differenceInWeeks/index.js":false,"./differenceInYears/index.js":false,"./eachDayOfInterval/index.js":false,"./eachHourOfInterval/index.js":false,"./eachMinuteOfInterval/index.js":false,"./eachMonthOfInterval/index.js":false,"./eachQuarterOfInterval/index.js":false,"./eachWeekOfInterval/index.js":false,"./eachWeekendOfInterval/index.js":false,"./eachWeekendOfMonth/index.js":false,"./eachWeekendOfYear/index.js":false,"./eachYearOfInterval/index.js":false,"./endOfDay/index.js":false,"./endOfDecade/index.js":false,"./endOfHour/index.js":false,"./endOfISOWeek/index.js":"86gAK","./endOfISOWeekYear/index.js":false,"./endOfMinute/index.js":false,"./endOfMonth/index.js":"9a5Tk","./endOfQuarter/index.js":false,"./endOfSecond/index.js":false,"./endOfToday/index.js":false,"./endOfTomorrow/index.js":false,"./endOfWeek/index.js":"7V8st","./endOfYear/index.js":false,"./endOfYesterday/index.js":false,"./format/index.js":"520Dk","./formatDistance/index.js":false,"./formatDistanceStrict/index.js":false,"./formatDistanceToNow/index.js":false,"./formatDistanceToNowStrict/index.js":false,"./formatDuration/index.js":false,"./formatISO/index.js":false,"./formatISO9075/index.js":false,"./formatISODuration/index.js":false,"./formatRFC3339/index.js":false,"./formatRFC7231/index.js":false,"./formatRelative/index.js":false,"./fromUnixTime/index.js":false,"./getDate/index.js":false,"./getDay/index.js":false,"./getDayOfYear/index.js":false,"./getDaysInMonth/index.js":false,"./getDaysInYear/index.js":false,"./getDecade/index.js":false,"./getDefaultOptions/index.js":false,"./getHours/index.js":false,"./getISODay/index.js":false,"./getISOWeek/index.js":"3RwbN","./getISOWeekYear/index.js":false,"./getISOWeeksInYear/index.js":false,"./getMilliseconds/index.js":false,"./getMinutes/index.js":false,"./getMonth/index.js":false,"./getOverlappingDaysInIntervals/index.js":false,"./getQuarter/index.js":false,"./getSeconds/index.js":false,"./getTime/index.js":false,"./getUnixTime/index.js":"8mNns","./getWeek/index.js":"5dAG2","./getWeekOfMonth/index.js":false,"./getWeekYear/index.js":false,"./getWeeksInMonth/index.js":"dEfOk","./getYear/index.js":false,"./hoursToMilliseconds/index.js":false,"./hoursToMinutes/index.js":false,"./hoursToSeconds/index.js":false,"./intervalToDuration/index.js":false,"./intlFormat/index.js":false,"./intlFormatDistance/index.js":false,"./isAfter/index.js":"1N23w","./isBefore/index.js":"joMzA","./isDate/index.js":"gmfSU","./isEqual/index.js":false,"./isExists/index.js":false,"./isFirstDayOfMonth/index.js":false,"./isFriday/index.js":false,"./isFuture/index.js":false,"./isLastDayOfMonth/index.js":false,"./isLeapYear/index.js":false,"./isMatch/index.js":false,"./isMonday/index.js":false,"./isPast/index.js":false,"./isSameDay/index.js":"i4e28","./isSameHour/index.js":false,"./isSameISOWeek/index.js":false,"./isSameISOWeekYear/index.js":false,"./isSameMinute/index.js":false,"./isSameMonth/index.js":"2bGq4","./isSameQuarter/index.js":false,"./isSameSecond/index.js":false,"./isSameWeek/index.js":false,"./isSameYear/index.js":"jauD1","./isSaturday/index.js":false,"./isSunday/index.js":false,"./isThisHour/index.js":false,"./isThisISOWeek/index.js":false,"./isThisMinute/index.js":false,"./isThisMonth/index.js":false,"./isThisQuarter/index.js":false,"./isThisSecond/index.js":false,"./isThisWeek/index.js":false,"./isThisYear/index.js":false,"./isThursday/index.js":false,"./isToday/index.js":false,"./isTomorrow/index.js":false,"./isTuesday/index.js":false,"./isValid/index.js":"l72u5","./isWednesday/index.js":false,"./isWeekend/index.js":false,"./isWithinInterval/index.js":false,"./isYesterday/index.js":false,"./lastDayOfDecade/index.js":false,"./lastDayOfISOWeek/index.js":false,"./lastDayOfISOWeekYear/index.js":false,"./lastDayOfMonth/index.js":false,"./lastDayOfQuarter/index.js":false,"./lastDayOfWeek/index.js":false,"./lastDayOfYear/index.js":false,"./lightFormat/index.js":false,"./max/index.js":"jGJ2T","./milliseconds/index.js":false,"./millisecondsToHours/index.js":false,"./millisecondsToMinutes/index.js":false,"./millisecondsToSeconds/index.js":false,"./min/index.js":"7SRyU","./minutesToHours/index.js":false,"./minutesToMilliseconds/index.js":false,"./minutesToSeconds/index.js":false,"./monthsToQuarters/index.js":false,"./monthsToYears/index.js":false,"./nextDay/index.js":false,"./nextFriday/index.js":false,"./nextMonday/index.js":false,"./nextSaturday/index.js":false,"./nextSunday/index.js":false,"./nextThursday/index.js":false,"./nextTuesday/index.js":false,"./nextWednesday/index.js":false,"./parse/index.js":"72XNY","./parseISO/index.js":false,"./parseJSON/index.js":false,"./previousDay/index.js":false,"./previousFriday/index.js":false,"./previousMonday/index.js":false,"./previousSaturday/index.js":false,"./previousSunday/index.js":false,"./previousThursday/index.js":false,"./previousTuesday/index.js":false,"./previousWednesday/index.js":false,"./quartersToMonths/index.js":false,"./quartersToYears/index.js":false,"./roundToNearestMinutes/index.js":false,"./secondsToHours/index.js":false,"./secondsToMilliseconds/index.js":false,"./secondsToMinutes/index.js":false,"./set/index.js":false,"./setDate/index.js":false,"./setDay/index.js":false,"./setDayOfYear/index.js":false,"./setDefaultOptions/index.js":false,"./setHours/index.js":false,"./setISODay/index.js":false,"./setISOWeek/index.js":false,"./setISOWeekYear/index.js":false,"./setMilliseconds/index.js":false,"./setMinutes/index.js":false,"./setMonth/index.js":"5lQsS","./setQuarter/index.js":false,"./setSeconds/index.js":false,"./setWeek/index.js":false,"./setWeekYear/index.js":false,"./setYear/index.js":"8eGGa","./startOfDay/index.js":"7nCna","./startOfDecade/index.js":false,"./startOfHour/index.js":false,"./startOfISOWeek/index.js":"6qre3","./startOfISOWeekYear/index.js":false,"./startOfMinute/index.js":false,"./startOfMonth/index.js":"blk2u","./startOfQuarter/index.js":false,"./startOfSecond/index.js":false,"./startOfToday/index.js":false,"./startOfTomorrow/index.js":false,"./startOfWeek/index.js":"3si6M","./startOfWeekYear/index.js":false,"./startOfYear/index.js":"45KIf","./startOfYesterday/index.js":false,"./sub/index.js":false,"./subBusinessDays/index.js":false,"./subDays/index.js":"0Vpj8","./subHours/index.js":false,"./subISOWeekYears/index.js":false,"./subMilliseconds/index.js":false,"./subMinutes/index.js":false,"./subMonths/index.js":false,"./subQuarters/index.js":false,"./subSeconds/index.js":false,"./subWeeks/index.js":false,"./subYears/index.js":false,"./toDate/index.js":"9koxn","./weeksToDays/index.js":false,"./yearsToMonths/index.js":false,"./yearsToQuarters/index.js":false,"./constants/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fK40q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addDays);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gKtzz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toInteger);
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9koxn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeofDefault.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9bkfg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requiredArgs);
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ueVg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMilliseconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var timestamp = (0, _indexJsDefault1.default)(dirtyDate).getTime();
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"luR8G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6qgbJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addWeeks);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    var days = amount * 7;
    return (0, _indexJsDefault1.default)(dirtyDate, days);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addDays/index.js":"fK40q","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dwe65":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addYears);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 12);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addMonths/index.js":"luR8G","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Dyug":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarDays);
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfDayLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfDayRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _indexJsDefault.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _indexJsDefault.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../startOfDay/index.js":"7nCna","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dIoK7":[function(require,module,exports,__globalThis) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTimezoneOffsetInMilliseconds);
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7nCna":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iE73E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarMonths);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"75PnZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarWeeks);
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_WEEK = 604800000;
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfWeekLeft = (0, _indexJsDefault.default)(dirtyDateLeft, options);
    var startOfWeekRight = (0, _indexJsDefault.default)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, _indexJsDefault1.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, _indexJsDefault1.default)(startOfWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

},{"../startOfWeek/index.js":"3si6M","../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3si6M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfWeek);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/defaultOptions/index.js");
function startOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","../_lib/defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cViP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"86gAK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfISOWeek);
var _indexJs = require("../endOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

},{"../endOfWeek/index.js":"7V8st","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7V8st":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfWeek);
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
function endOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../_lib/defaultOptions/index.js":"1cViP","../toDate/index.js":"9koxn","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9a5Tk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"520Dk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _indexJs = require("../isValid/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/format/formatters/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/defaultOptions/index.js");
var _indexJs10 = require("../_lib/defaultLocale/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs10);
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _indexJs9.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault8.default);
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, _indexJsDefault2.default)(dirtyDate);
    if (!(0, _indexJsDefault.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault5.default)(originalDate);
    var utcDate = (0, _indexJsDefault1.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault3.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"../isValid/index.js":"l72u5","../subMilliseconds/index.js":"8J3yE","../toDate/index.js":"9koxn","../_lib/format/formatters/index.js":"l17xy","../_lib/format/longFormatters/index.js":"l4aYZ","../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../_lib/protectedTokens/index.js":"5gdbP","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","../_lib/defaultOptions/index.js":"1cViP","../_lib/defaultLocale/index.js":"5kaPu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l72u5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isValid);
var _indexJs = require("../isDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isValid(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    if (!(0, _indexJsDefault.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    return !isNaN(Number(date));
}

},{"../isDate/index.js":"gmfSU","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gmfSU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function isDate(value) {
    (0, _indexJsDefault.default)(1, arguments);
    return value instanceof Date || (0, _typeofDefault.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8J3yE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMilliseconds);
var _indexJs = require("../addMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMilliseconds/index.js":"2ueVg","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l17xy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/getUTCDayOfYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/getUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../../../_lib/getUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../../../_lib/getUTCWeek/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../../addLeadingZeros/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../lightFormatters/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, _indexJsDefault6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _indexJsDefault4.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, _indexJsDefault5.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, _indexJsDefault5.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _indexJsDefault2.default)(date);
        // Padding
        return (0, _indexJsDefault5.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _indexJsDefault5.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, _indexJsDefault6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, _indexJsDefault5.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _indexJsDefault3.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, _indexJsDefault5.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _indexJsDefault1.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, _indexJsDefault5.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, _indexJsDefault6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _indexJsDefault.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, _indexJsDefault5.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, _indexJsDefault5.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, _indexJsDefault5.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, _indexJsDefault5.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, _indexJsDefault6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, _indexJsDefault6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, _indexJsDefault6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, _indexJsDefault6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _indexJsDefault6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, _indexJsDefault5.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, _indexJsDefault5.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, _indexJsDefault5.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _indexJsDefault5.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
exports.default = formatters;

},{"../../../_lib/getUTCDayOfYear/index.js":"aCfY8","../../../_lib/getUTCISOWeek/index.js":"hMWge","../../../_lib/getUTCISOWeekYear/index.js":"brbzX","../../../_lib/getUTCWeek/index.js":"8MUbv","../../../_lib/getUTCWeekYear/index.js":"18XUY","../../addLeadingZeros/index.js":"9Bsa8","../lightFormatters/index.js":"6EcHD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCfY8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCDayOfYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hMWge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"9koxn","../startOfUTCISOWeek/index.js":"aTskV","../startOfUTCISOWeekYear/index.js":"37Lio","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aTskV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"37Lio":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeekYear);
var _indexJs = require("../getUTCISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getUTCISOWeekYear/index.js":"brbzX","../startOfUTCISOWeek/index.js":"aTskV","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"brbzX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../startOfUTCISOWeek/index.js":"aTskV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MUbv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date, options).getTime() - (0, _indexJsDefault2.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"9koxn","../startOfUTCWeek/index.js":"20vji","../startOfUTCWeekYear/index.js":"3h6rf","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"20vji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3h6rf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeekYear);
var _indexJs = require("../getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault2.default)(firstWeek, options);
    return date;
}

},{"../getUTCWeekYear/index.js":"18XUY","../requiredArgs/index.js":"9bkfg","../startOfUTCWeek/index.js":"20vji","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"18XUY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../startOfUTCWeek/index.js":"20vji","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Bsa8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6EcHD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../addLeadingZeros/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _indexJsDefault.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, _indexJsDefault.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _indexJsDefault.default)(fractionalSeconds, token.length);
    }
};
exports.default = formatters;

},{"../../addLeadingZeros/index.js":"9Bsa8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4aYZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
exports.default = longFormatters;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5gdbP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "throwProtectedError", ()=>throwProtectedError);
var protectedDayOfYearTokens = [
    'D',
    'DD'
];
var protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5kaPu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../locale/en-US/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default);

},{"../../locale/en-US/index.js":"4vfjK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vfjK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: 'en-US',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"33ZTo","./_lib/formatLong/index.js":"3snKV","./_lib/formatRelative/index.js":"aDrXK","./_lib/localize/index.js":"cGr1B","./_lib/match/index.js":"gyWiy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"33ZTo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3snKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"begpu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDrXK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGr1B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"apnSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gyWiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8m1gR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchFn);
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imsfL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"an1FA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatISO);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/addLeadingZeros/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function formatISO(date, options) {
    var _options$format, _options$representati;
    (0, _indexJsDefault2.default)(1, arguments);
    var originalDate = (0, _indexJsDefault.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, _indexJsDefault1.default)(originalDate.getDate(), 2);
        var month = (0, _indexJsDefault1.default)(originalDate.getMonth() + 1, 2);
        var year = (0, _indexJsDefault1.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, _indexJsDefault1.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, _indexJsDefault1.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, _indexJsDefault1.default)(originalDate.getHours(), 2);
        var minute = (0, _indexJsDefault1.default)(originalDate.getMinutes(), 2);
        var second = (0, _indexJsDefault1.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

},{"../toDate/index.js":"9koxn","../_lib/addLeadingZeros/index.js":"9Bsa8","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gvmhi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDaysInMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDaysInMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3RwbN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getISOWeek);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../toDate/index.js":"9koxn","../startOfISOWeek/index.js":"6qre3","../startOfISOWeekYear/index.js":"cU0Cy","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6qre3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfISOWeek);
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

},{"../startOfWeek/index.js":"3si6M","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cU0Cy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfISOWeekYear);
var _indexJs = require("../getISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getISOWeekYear/index.js":"fSHi1","../startOfISOWeek/index.js":"6qre3","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fSHi1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getISOWeekYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../toDate/index.js":"9koxn","../startOfISOWeek/index.js":"6qre3","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3O7In":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTime);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getTime(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8mNns":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUnixTime);
var _indexJs = require("../getTime/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getUnixTime(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return Math.floor((0, _indexJsDefault.default)(dirtyDate) / 1000);
}

},{"../getTime/index.js":"3O7In","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5dAG2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWeek);
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfWeekYear/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault2.default)(dirtyDate);
    var diff = (0, _indexJsDefault.default)(date, options).getTime() - (0, _indexJsDefault1.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../startOfWeek/index.js":"3si6M","../startOfWeekYear/index.js":"emV8F","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"emV8F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfWeekYear);
var _indexJs = require("../getWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/defaultOptions/index.js");
function startOfWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault3.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(firstWeek, options);
    return date;
}

},{"../getWeekYear/index.js":"lePuC","../startOfWeek/index.js":"3si6M","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","../_lib/defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lePuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWeekYear);
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/defaultOptions/index.js");
function getWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../startOfWeek/index.js":"3si6M","../toDate/index.js":"9koxn","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","../_lib/defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dEfOk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWeeksInMonth);
var _indexJs = require("../differenceInCalendarWeeks/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../lastDayOfMonth/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function getWeeksInMonth(date, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    return (0, _indexJsDefault.default)((0, _indexJsDefault1.default)(date), (0, _indexJsDefault2.default)(date), options) + 1;
}

},{"../differenceInCalendarWeeks/index.js":"75PnZ","../lastDayOfMonth/index.js":"g9iwb","../startOfMonth/index.js":"blk2u","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g9iwb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lastDayOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function lastDayOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"blk2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1N23w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAfter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isAfter(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"joMzA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isBefore);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isBefore(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i4e28":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameDay);
var _indexJs = require("../startOfDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameDay(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfDay = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

},{"../startOfDay/index.js":"7nCna","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2bGq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jauD1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameYear(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGJ2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function max(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7SRyU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function min(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"72XNY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parse);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _createForOfIteratorHelper = require("@babel/runtime/helpers/esm/createForOfIteratorHelper");
var _createForOfIteratorHelperDefault = parcelHelpers.interopDefault(_createForOfIteratorHelper);
var _indexJs = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/assign/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _setterJs = require("./_lib/Setter.js");
var _indexJs9 = require("./_lib/parsers/index.js");
var _indexJs10 = require("../_lib/defaultOptions/index.js"); // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, _indexJs10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, _indexJsDefault2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterJs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _indexJsDefault4.default)) {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, _createForOfIteratorHelperDefault.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, _indexJs9.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, _typeofDefault.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _indexJsDefault2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, _indexJsDefault1.default)(date, (0, _indexJsDefault5.default)(date));
    var flags = {};
    var _iterator2 = (0, _createForOfIteratorHelperDefault.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, _indexJsDefault3.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","@babel/runtime/helpers/esm/createForOfIteratorHelper":"aDWbJ","../_lib/defaultLocale/index.js":"5kaPu","../subMilliseconds/index.js":"8J3yE","../toDate/index.js":"9koxn","../_lib/assign/index.js":"ebaSr","../_lib/format/longFormatters/index.js":"l4aYZ","../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../_lib/protectedTokens/index.js":"5gdbP","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","./_lib/Setter.js":"8MMcx","./_lib/parsers/index.js":"7IUvF","../_lib/defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDWbJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createForOfIteratorHelper);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, _unsupportedIterableToArrayJsDefault.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

},{"./unsupportedIterableToArray.js":"K5PcV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"K5PcV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"enjjy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"enjjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ebaSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>assign);
function assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MMcx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", ()=>Setter);
parcelHelpers.export(exports, "ValueSetter", ()=>ValueSetter);
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", ()=>DateToSystemTimezoneSetter);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        (0, _classCallCheckDefault.default)(this, Setter);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", 0);
    }
    (0, _createClassDefault.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
    (0, _inheritsDefault.default)(ValueSetter, _Setter);
    var _super = (0, _createSuperDefault.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, _classCallCheckDefault.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClassDefault.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
    (0, _inheritsDefault.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, _createSuperDefault.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, _classCallCheckDefault.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, _createClassDefault.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/defineProperty":"5zOJa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6oM96":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inherits);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, _setPrototypeOfJsDefault.default)(t, e);
}

},{"./setPrototypeOf.js":"9UMxe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Qcqa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(t) {
    var r = (0, _isNativeReflectConstructJsDefault.default)();
    return function() {
        var e, o = (0, _getPrototypeOfJsDefault.default)(t);
        if (r) {
            var s = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, e);
    };
}

},{"./getPrototypeOf.js":"kxTHC","./isNativeReflectConstruct.js":"3xdRH","./possibleConstructorReturn.js":"gHSsV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kxTHC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xdRH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHSsV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_possibleConstructorReturn);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == (0, _typeofJsDefault.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(t);
}

},{"./typeof.js":"la19k","./assertThisInitialized.js":"jJtsr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chhAr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3gRhs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, _toPropertyKeyJsDefault.default)(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

},{"./toPropertyKey.js":"61Sn9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7IUvF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", ()=>parsers);
var _eraParserJs = require("./EraParser.js");
var _yearParserJs = require("./YearParser.js");
var _localWeekYearParserJs = require("./LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./ISOWeekYearParser.js");
var _extendedYearParserJs = require("./ExtendedYearParser.js");
var _quarterParserJs = require("./QuarterParser.js");
var _standAloneQuarterParserJs = require("./StandAloneQuarterParser.js");
var _monthParserJs = require("./MonthParser.js");
var _standAloneMonthParserJs = require("./StandAloneMonthParser.js");
var _localWeekParserJs = require("./LocalWeekParser.js");
var _isoweekParserJs = require("./ISOWeekParser.js");
var _dateParserJs = require("./DateParser.js");
var _dayOfYearParserJs = require("./DayOfYearParser.js");
var _dayParserJs = require("./DayParser.js");
var _localDayParserJs = require("./LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./StandAloneLocalDayParser.js");
var _isodayParserJs = require("./ISODayParser.js");
var _ampmparserJs = require("./AMPMParser.js");
var _ampmmidnightParserJs = require("./AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./DayPeriodParser.js");
var _hour1To12ParserJs = require("./Hour1to12Parser.js");
var _hour0To23ParserJs = require("./Hour0to23Parser.js");
var _hour0To11ParserJs = require("./Hour0To11Parser.js");
var _hour1To24ParserJs = require("./Hour1To24Parser.js");
var _minuteParserJs = require("./MinuteParser.js");
var _secondParserJs = require("./SecondParser.js");
var _fractionOfSecondParserJs = require("./FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./TimestampMillisecondsParser.js");
var parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./EraParser.js":"kab4g","./YearParser.js":"99jVP","./LocalWeekYearParser.js":"2ttXC","./ISOWeekYearParser.js":"i0O3C","./ExtendedYearParser.js":"gotWm","./QuarterParser.js":"akkU8","./StandAloneQuarterParser.js":"2H4wl","./MonthParser.js":"7TuPi","./StandAloneMonthParser.js":"99rFP","./LocalWeekParser.js":"25yMP","./ISOWeekParser.js":"lKKiL","./DateParser.js":"aFDfi","./DayOfYearParser.js":"hA8D5","./DayParser.js":"jai6O","./LocalDayParser.js":"gPIfk","./StandAloneLocalDayParser.js":"c3sA0","./ISODayParser.js":"jXlK8","./AMPMParser.js":"6p81p","./AMPMMidnightParser.js":"JSP3I","./DayPeriodParser.js":"3rj7q","./Hour1to12Parser.js":"i0gZf","./Hour0to23Parser.js":"aPngu","./Hour0To11Parser.js":"gMmlD","./Hour1To24Parser.js":"aJEhQ","./MinuteParser.js":"269sd","./SecondParser.js":"e4ZOc","./FractionOfSecondParser.js":"izdK9","./ISOTimezoneWithZParser.js":"1udJV","./ISOTimezoneParser.js":"9DGq4","./TimestampSecondsParser.js":"hZAUb","./TimestampMillisecondsParser.js":"1WTFB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kab4g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", ()=>EraParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var EraParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(EraParser, _Parser);
    var _super = (0, _createSuperDefault.default)(EraParser);
    function EraParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 140);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dCP1D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _setterJs = require("./Setter.js");
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        (0, _classCallCheckDefault.default)(this, Parser);
        (0, _definePropertyDefault.default)(this, "incompatibleTokens", void 0);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", void 0);
    }
    (0, _createClassDefault.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/defineProperty":"5zOJa","./Setter.js":"8MMcx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99jVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", ()=>YearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var YearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(YearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(YearParser);
    function YearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cJqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", ()=>mapValue);
parcelHelpers.export(exports, "parseNumericPattern", ()=>parseNumericPattern);
parcelHelpers.export(exports, "parseTimezonePattern", ()=>parseTimezonePattern);
parcelHelpers.export(exports, "parseAnyDigitsSigned", ()=>parseAnyDigitsSigned);
parcelHelpers.export(exports, "parseNDigits", ()=>parseNDigits);
parcelHelpers.export(exports, "parseNDigitsSigned", ()=>parseNDigitsSigned);
parcelHelpers.export(exports, "dayPeriodEnumToHours", ()=>dayPeriodEnumToHours);
parcelHelpers.export(exports, "normalizeTwoDigitYear", ()=>normalizeTwoDigitYear);
parcelHelpers.export(exports, "isLeapYearIndex", ()=>isLeapYearIndex);
var _indexJs = require("../../constants/index.js");
var _constantsJs = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * (0, _indexJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants/index.js":"49NaD","./constants.js":"1mpGj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"49NaD":[function(require,module,exports,__globalThis) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1mpGj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", ()=>numericPatterns);
parcelHelpers.export(exports, "timezonePatterns", ()=>timezonePatterns);
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ttXC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", ()=>LocalWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _indexJsDefault.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, _indexJsDefault1.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault1.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/getUTCWeekYear/index.js":"18XUY","../../../_lib/startOfUTCWeek/index.js":"20vji","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0O3C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", ()=>ISOWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week-numbering year
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/startOfUTCISOWeek/index.js":"aTskV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gotWm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", ()=>ExtendedYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ExtendedYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"akkU8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", ()=>QuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var QuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(QuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2H4wl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", ()=>StandAloneQuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7TuPi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", ()=>MonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var MonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        return _this;
    }
    (0, _createClassDefault.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../utils.js":"1cJqi","../Parser.js":"dCP1D","../constants.js":"1mpGj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99rFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", ()=>StandAloneMonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneMonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"25yMP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", ()=>LocalWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js"); // Local week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","../../../_lib/setUTCWeek/index.js":"lcKkD","../../../_lib/startOfUTCWeek/index.js":"20vji","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcKkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault.default)(dirtyWeek);
    var diff = (0, _indexJsDefault2.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"gKtzz","../../toDate/index.js":"9koxn","../getUTCWeek/index.js":"8MUbv","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lKKiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", ()=>ISOWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","../../../_lib/setUTCISOWeek/index.js":"kNScb","../../../_lib/startOfUTCISOWeek/index.js":"aTskV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kNScb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISOWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"gKtzz","../../toDate/index.js":"9koxn","../getUTCISOWeek/index.js":"hMWge","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aFDfi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", ()=>DateParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DateParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DateParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DateParser);
    function DateParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subPriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../utils.js":"1cJqi","../Parser.js":"dCP1D","../constants.js":"1mpGj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hA8D5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", ()=>DayOfYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayOfYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subpriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jai6O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", ()=>DayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var DayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayParser);
    function DayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../../../_lib/setUTCDay/index.js":"jcEwJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jcEwJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCDay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(2, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPIfk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", ()=>LocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/setUTCDay/index.js":"jcEwJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c3sA0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", ()=>StandAloneLocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Stand-alone local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/setUTCDay/index.js":"jcEwJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jXlK8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", ()=>ISODayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISODay/index.js"); // ISO day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISODayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISODayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _indexJsDefault.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/setUTCISODay/index.js":"b0WCQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b0WCQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISODay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setUTCISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault1.default)(2, arguments);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6p81p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", ()=>AMPMParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"JSP3I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", ()=>AMPMMidnightParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMMidnightParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3rj7q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", ()=>DayPeriodParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js"); // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayPeriodParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0gZf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", ()=>Hour1to12Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1to12Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aPngu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", ()=>Hour0to23Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0to23Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gMmlD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", ()=>Hour0To11Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0To11Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJEhQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", ()=>Hour1To24Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1To24Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"269sd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", ()=>MinuteParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var MinuteParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MinuteParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 60);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e4ZOc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", ()=>SecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var SecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(SecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 50);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"izdK9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", ()=>FractionOfSecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(FractionOfSecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 30);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1udJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", ()=>ISOTimezoneWithZParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9DGq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", ()=>ISOTimezoneParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZAUb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", ()=>TimestampSecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampSecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 40);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, _createClassDefault.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1WTFB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", ()=>TimestampMillisecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 20);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, _createClassDefault.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5lQsS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setMonth);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getDaysInMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setMonth(dirtyDate, dirtyMonth) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var month = (0, _indexJsDefault.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _indexJsDefault2.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../getDaysInMonth/index.js":"gvmhi","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8eGGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setYear);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setYear(dirtyDate, dirtyYear) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = (0, _indexJsDefault.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45KIf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var cleanDate = (0, _indexJsDefault.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0Vpj8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subDays);
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addDays/index.js":"fK40q","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"58IhA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
parcelHelpers.export(exports, "Caption", ()=>Caption);
parcelHelpers.export(exports, "CaptionDropdowns", ()=>CaptionDropdowns);
parcelHelpers.export(exports, "CaptionLabel", ()=>CaptionLabel);
parcelHelpers.export(exports, "CaptionNavigation", ()=>CaptionNavigation);
parcelHelpers.export(exports, "Day", ()=>Day);
parcelHelpers.export(exports, "DayContent", ()=>DayContent);
parcelHelpers.export(exports, "DayPicker", ()=>DayPicker);
parcelHelpers.export(exports, "DayPickerContext", ()=>DayPickerContext);
parcelHelpers.export(exports, "DayPickerProvider", ()=>DayPickerProvider);
parcelHelpers.export(exports, "Dropdown", ()=>Dropdown);
parcelHelpers.export(exports, "FocusContext", ()=>FocusContext);
parcelHelpers.export(exports, "FocusProvider", ()=>FocusProvider);
parcelHelpers.export(exports, "Footer", ()=>Footer);
parcelHelpers.export(exports, "Head", ()=>Head);
parcelHelpers.export(exports, "HeadRow", ()=>HeadRow);
parcelHelpers.export(exports, "IconDropdown", ()=>IconDropdown);
parcelHelpers.export(exports, "IconLeft", ()=>IconLeft);
parcelHelpers.export(exports, "IconRight", ()=>IconRight);
parcelHelpers.export(exports, "InternalModifier", ()=>InternalModifier);
parcelHelpers.export(exports, "Months", ()=>Months);
parcelHelpers.export(exports, "NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "NavigationProvider", ()=>NavigationProvider);
parcelHelpers.export(exports, "RootProvider", ()=>RootProvider);
parcelHelpers.export(exports, "Row", ()=>Row);
parcelHelpers.export(exports, "SelectMultipleContext", ()=>SelectMultipleContext);
parcelHelpers.export(exports, "SelectMultipleProvider", ()=>SelectMultipleProvider);
parcelHelpers.export(exports, "SelectMultipleProviderInternal", ()=>SelectMultipleProviderInternal);
parcelHelpers.export(exports, "SelectRangeContext", ()=>SelectRangeContext);
parcelHelpers.export(exports, "SelectRangeProvider", ()=>SelectRangeProvider);
parcelHelpers.export(exports, "SelectRangeProviderInternal", ()=>SelectRangeProviderInternal);
parcelHelpers.export(exports, "SelectSingleContext", ()=>SelectSingleContext);
parcelHelpers.export(exports, "SelectSingleProvider", ()=>SelectSingleProvider);
parcelHelpers.export(exports, "SelectSingleProviderInternal", ()=>SelectSingleProviderInternal);
parcelHelpers.export(exports, "WeekNumber", ()=>WeekNumber);
parcelHelpers.export(exports, "addToRange", ()=>addToRange);
parcelHelpers.export(exports, "isDateAfterType", ()=>isDateAfterType);
parcelHelpers.export(exports, "isDateBeforeType", ()=>isDateBeforeType);
parcelHelpers.export(exports, "isDateInterval", ()=>isDateInterval);
parcelHelpers.export(exports, "isDateRange", ()=>isDateRange);
parcelHelpers.export(exports, "isDayOfWeekType", ()=>isDayOfWeekType);
parcelHelpers.export(exports, "isDayPickerDefault", ()=>isDayPickerDefault);
parcelHelpers.export(exports, "isDayPickerMultiple", ()=>isDayPickerMultiple);
parcelHelpers.export(exports, "isDayPickerRange", ()=>isDayPickerRange);
parcelHelpers.export(exports, "isDayPickerSingle", ()=>isDayPickerSingle);
parcelHelpers.export(exports, "isMatch", ()=>isMatch);
parcelHelpers.export(exports, "useActiveModifiers", ()=>useActiveModifiers);
parcelHelpers.export(exports, "useDayPicker", ()=>useDayPicker);
parcelHelpers.export(exports, "useDayRender", ()=>useDayRender);
parcelHelpers.export(exports, "useFocusContext", ()=>useFocusContext);
parcelHelpers.export(exports, "useInput", ()=>useInput);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useSelectMultiple", ()=>useSelectMultiple);
parcelHelpers.export(exports, "useSelectRange", ()=>useSelectRange);
parcelHelpers.export(exports, "useSelectSingle", ()=>useSelectSingle);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dateFns = require("date-fns");
var _locale = require("date-fns/locale");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
/** Returns true when the props are of type {@link DayPickerMultipleProps}. */ function isDayPickerMultiple(props) {
    return props.mode === 'multiple';
}
/** Returns true when the props are of type {@link DayPickerRangeProps}. */ function isDayPickerRange(props) {
    return props.mode === 'range';
}
/** Returns true when the props are of type {@link DayPickerSingleProps}. */ function isDayPickerSingle(props) {
    return props.mode === 'single';
}
/**
 * The name of the default CSS classes.
 */ var defaultClassNames = {
    root: 'rdp',
    multiple_months: 'rdp-multiple_months',
    with_weeknumber: 'rdp-with_weeknumber',
    vhidden: 'rdp-vhidden',
    button_reset: 'rdp-button_reset',
    button: 'rdp-button',
    caption: 'rdp-caption',
    caption_start: 'rdp-caption_start',
    caption_end: 'rdp-caption_end',
    caption_between: 'rdp-caption_between',
    caption_label: 'rdp-caption_label',
    caption_dropdowns: 'rdp-caption_dropdowns',
    dropdown: 'rdp-dropdown',
    dropdown_month: 'rdp-dropdown_month',
    dropdown_year: 'rdp-dropdown_year',
    dropdown_icon: 'rdp-dropdown_icon',
    months: 'rdp-months',
    month: 'rdp-month',
    table: 'rdp-table',
    tbody: 'rdp-tbody',
    tfoot: 'rdp-tfoot',
    head: 'rdp-head',
    head_row: 'rdp-head_row',
    head_cell: 'rdp-head_cell',
    nav: 'rdp-nav',
    nav_button: 'rdp-nav_button',
    nav_button_previous: 'rdp-nav_button_previous',
    nav_button_next: 'rdp-nav_button_next',
    nav_icon: 'rdp-nav_icon',
    row: 'rdp-row',
    weeknumber: 'rdp-weeknumber',
    cell: 'rdp-cell',
    day: 'rdp-day',
    day_today: 'rdp-day_today',
    day_outside: 'rdp-day_outside',
    day_selected: 'rdp-day_selected',
    day_disabled: 'rdp-day_disabled',
    day_hidden: 'rdp-day_hidden',
    day_range_start: 'rdp-day_range_start',
    day_range_end: 'rdp-day_range_end',
    day_range_middle: 'rdp-day_range_middle'
};
/**
 * The default formatter for the caption.
 */ function formatCaption(month, options) {
    return (0, _dateFns.format)(month, 'LLLL y', options);
}
/**
 * The default formatter for the Day button.
 */ function formatDay(day, options) {
    return (0, _dateFns.format)(day, 'd', options);
}
/**
 * The default formatter for the Month caption.
 */ function formatMonthCaption(month, options) {
    return (0, _dateFns.format)(month, 'LLLL', options);
}
/**
 * The default formatter for the week number.
 */ function formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}
/**
 * The default formatter for the name of the weekday.
 */ function formatWeekdayName(weekday, options) {
    return (0, _dateFns.format)(weekday, 'cccccc', options);
}
/**
 * The default formatter for the Year caption.
 */ function formatYearCaption(year, options) {
    return (0, _dateFns.format)(year, 'yyyy', options);
}
var formatters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    formatCaption: formatCaption,
    formatDay: formatDay,
    formatMonthCaption: formatMonthCaption,
    formatWeekNumber: formatWeekNumber,
    formatWeekdayName: formatWeekdayName,
    formatYearCaption: formatYearCaption
});
/**
 * The default ARIA label for the day button.
 */ var labelDay = function(day, activeModifiers, options) {
    return (0, _dateFns.format)(day, 'do MMMM (EEEE)', options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var labelMonthDropdown = function() {
    return 'Month: ';
};
/**
 * The default ARIA label for next month button in navigation
 */ var labelNext = function() {
    return 'Go to next month';
};
/**
 * The default ARIA label for previous month button in navigation
 */ var labelPrevious = function() {
    return 'Go to previous month';
};
/**
 * The default ARIA label for the Weekday element.
 */ var labelWeekday = function(day, options) {
    return (0, _dateFns.format)(day, 'cccc', options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var labelWeekNumber = function(n) {
    return "Week n. ".concat(n);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var labelYearDropdown = function() {
    return 'Year: ';
};
var labels = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    labelDay: labelDay,
    labelMonthDropdown: labelMonthDropdown,
    labelNext: labelNext,
    labelPrevious: labelPrevious,
    labelWeekNumber: labelWeekNumber,
    labelWeekday: labelWeekday,
    labelYearDropdown: labelYearDropdown
});
/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */ function getDefaultContextValues() {
    var captionLayout = 'buttons';
    var classNames = defaultClassNames;
    var locale = (0, _locale.enUS);
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: formatters,
        labels: labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: 'default'
    };
}
/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */ function parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) fromDate = (0, _dateFns.startOfMonth)(fromMonth);
    else if (fromYear) fromDate = new Date(fromYear, 0, 1);
    if (toMonth) toDate = (0, _dateFns.endOfMonth)(toMonth);
    else if (toYear) toDate = new Date(toYear, 11, 31);
    return {
        fromDate: fromDate ? (0, _dateFns.startOfDay)(fromDate) : undefined,
        toDate: toDate ? (0, _dateFns.startOfDay)(toDate) : undefined
    };
}
/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */ var DayPickerContext = (0, _react.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */ function DayPickerProvider(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = getDefaultContextValues();
    var _b = parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== 'buttons' && (!fromDate || !toDate)) // When no from/to dates are set, the caption is always buttons
    captionLayout = 'buttons';
    var onSelect;
    if (isDayPickerSingle(initialProps) || isDayPickerMultiple(initialProps) || isDayPickerRange(initialProps)) onSelect = initialProps.onSelect;
    var value = __assign(__assign(__assign({}, defaultContextValues), initialProps), {
        captionLayout: captionLayout,
        classNames: __assign(__assign({}, defaultContextValues.classNames), initialProps.classNames),
        components: __assign({}, initialProps.components),
        formatters: __assign(__assign({}, defaultContextValues.formatters), initialProps.formatters),
        fromDate: fromDate,
        labels: __assign(__assign({}, defaultContextValues.labels), initialProps.labels),
        mode: initialProps.mode || defaultContextValues.mode,
        modifiers: __assign(__assign({}, defaultContextValues.modifiers), initialProps.modifiers),
        modifiersClassNames: __assign(__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames),
        onSelect: onSelect,
        styles: __assign(__assign({}, defaultContextValues.styles), initialProps.styles),
        toDate: toDate
    });
    return (0, _jsxRuntime.jsx)(DayPickerContext.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */ function useDayPicker() {
    var context = (0, _react.useContext)(DayPickerContext);
    if (!context) throw new Error("useDayPicker must be used within a DayPickerProvider.");
    return context;
}
/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */ function CaptionLabel(props) {
    var _a = useDayPicker(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (0, _jsxRuntime.jsx)("div", {
        className: classNames.caption_label,
        style: styles.caption_label,
        "aria-live": "polite",
        role: "presentation",
        id: props.id,
        children: formatCaption(props.displayMonth, {
            locale: locale
        })
    });
}
/**
 * Render the icon in the styled drop-down.
 */ function IconDropdown(props) {
    return (0, _jsxRuntime.jsx)("svg", __assign({
        width: "8px",
        height: "8px",
        viewBox: "0 0 120 120",
        "data-testid": "iconDropdown"
    }, props, {
        children: (0, _jsxRuntime.jsx)("path", {
            d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */ function Dropdown(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = useDayPicker();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : IconDropdown;
    return (0, _jsxRuntime.jsxs)("div", {
        className: className,
        style: style,
        children: [
            (0, _jsxRuntime.jsx)("span", {
                className: dayPicker.classNames.vhidden,
                children: props['aria-label']
            }),
            (0, _jsxRuntime.jsx)("select", {
                name: props.name,
                "aria-label": props['aria-label'],
                className: dayPicker.classNames.dropdown,
                style: dayPicker.styles.dropdown,
                value: value,
                onChange: onChange,
                children: children
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: dayPicker.classNames.caption_label,
                style: dayPicker.styles.caption_label,
                "aria-hidden": "true",
                children: [
                    caption,
                    (0, _jsxRuntime.jsx)(IconDropdownComponent, {
                        className: dayPicker.classNames.dropdown_icon,
                        style: dayPicker.styles.dropdown_icon
                    })
                ]
            })
        ]
    });
}
/** Render the dropdown to navigate between months. */ function MonthsDropdown(props) {
    var _a;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    if (!toDate) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    var dropdownMonths = [];
    if ((0, _dateFns.isSameYear)(fromDate, toDate)) {
        // only display the months included in the range
        var date = (0, _dateFns.startOfMonth)(fromDate);
        for(var month = fromDate.getMonth(); month <= toDate.getMonth(); month++)dropdownMonths.push((0, _dateFns.setMonth)(date, month));
    } else {
        // display all the 12 months
        var date = (0, _dateFns.startOfMonth)(new Date()); // Any date should be OK, as we just need the year
        for(var month = 0; month <= 11; month++)dropdownMonths.push((0, _dateFns.setMonth)(date, month));
    }
    var handleChange = function(e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = (0, _dateFns.setMonth)((0, _dateFns.startOfMonth)(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (0, _jsxRuntime.jsx)(DropdownComponent, {
        name: "months",
        "aria-label": labelMonthDropdown(),
        className: classNames.dropdown_month,
        style: styles.dropdown_month,
        onChange: handleChange,
        value: props.displayMonth.getMonth(),
        caption: formatMonthCaption(props.displayMonth, {
            locale: locale
        }),
        children: dropdownMonths.map(function(m) {
            return (0, _jsxRuntime.jsx)("option", {
                value: m.getMonth(),
                children: formatMonthCaption(m, {
                    locale: locale
                })
            }, m.getMonth());
        })
    });
}
/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */ function YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    if (!toDate) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for(var year = fromYear; year <= toYear; year++)years.push((0, _dateFns.setYear)((0, _dateFns.startOfYear)(new Date()), year));
    var handleChange = function(e) {
        var newMonth = (0, _dateFns.setYear)((0, _dateFns.startOfMonth)(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (0, _jsxRuntime.jsx)(DropdownComponent, {
        name: "years",
        "aria-label": labelYearDropdown(),
        className: classNames.dropdown_year,
        style: styles.dropdown_year,
        onChange: handleChange,
        value: displayMonth.getFullYear(),
        caption: formatYearCaption(displayMonth, {
            locale: locale
        }),
        children: years.map(function(year) {
            return (0, _jsxRuntime.jsx)("option", {
                value: year.getFullYear(),
                children: formatYearCaption(year, {
                    locale: locale
                })
            }, year.getFullYear());
        })
    });
}
/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */ function useControlledValue(defaultValue, controlledValue) {
    var _a = (0, _react.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}
/** Return the initial month according to the given options. */ function getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && (0, _dateFns.differenceInCalendarMonths)(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = (0, _dateFns.addMonths)(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && (0, _dateFns.differenceInCalendarMonths)(initialMonth, fromDate) < 0) initialMonth = fromDate;
    return (0, _dateFns.startOfMonth)(initialMonth);
}
/** Controls the navigation state. */ function useNavigationState() {
    var context = useDayPicker();
    var initialMonth = getInitialMonth(context);
    var _a = useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function(date) {
        var _a;
        if (context.disableNavigation) return;
        var month = (0, _dateFns.startOfMonth)(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 || _a.call(context, month);
    };
    return [
        month,
        goToMonth
    ];
}
/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */ function getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = (0, _dateFns.startOfMonth)(month);
    var end = (0, _dateFns.startOfMonth)((0, _dateFns.addMonths)(start, numberOfMonths));
    var monthsDiff = (0, _dateFns.differenceInCalendarMonths)(end, start);
    var months = [];
    for(var i = 0; i < monthsDiff; i++){
        var nextMonth = (0, _dateFns.addMonths)(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths) months = months.reverse();
    return months;
}
/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */ function getNextMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, _dateFns.startOfMonth)(startingMonth);
    if (!toDate) return (0, _dateFns.addMonths)(month, offset);
    var monthsDiff = (0, _dateFns.differenceInCalendarMonths)(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    // Jump forward as the number of months when paged navigation
    return (0, _dateFns.addMonths)(month, offset);
}
/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */ function getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, _dateFns.startOfMonth)(startingMonth);
    if (!fromDate) return (0, _dateFns.addMonths)(month, -offset);
    var monthsDiff = (0, _dateFns.differenceInCalendarMonths)(month, fromDate);
    if (monthsDiff <= 0) return undefined;
    // Jump back as the number of months when paged navigation
    return (0, _dateFns.addMonths)(month, -offset);
}
/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */ var NavigationContext = (0, _react.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */ function NavigationProvider(props) {
    var dayPicker = useDayPicker();
    var _a = useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = getNextMonth(currentMonth, dayPicker);
    var previousMonth = getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function(date) {
        return displayMonths.some(function(displayMonth) {
            return (0, _dateFns.isSameMonth)(date, displayMonth);
        });
    };
    var goToDate = function(date, refDate) {
        if (isDateDisplayed(date)) return;
        if (refDate && (0, _dateFns.isBefore)(date, refDate)) goToMonth((0, _dateFns.addMonths)(date, 1 + dayPicker.numberOfMonths * -1));
        else goToMonth(date);
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (0, _jsxRuntime.jsx)(NavigationContext.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function useNavigation() {
    var context = (0, _react.useContext)(NavigationContext);
    if (!context) throw new Error('useNavigation must be used within a NavigationProvider');
    return context;
}
/**
 * Render a caption with the dropdowns to navigate between months and years.
 */ function CaptionDropdowns(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = useNavigation().goToMonth;
    var handleMonthChange = function(newMonth) {
        goToMonth((0, _dateFns.addMonths)(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var captionLabel = (0, _jsxRuntime.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    return (0, _jsxRuntime.jsxs)("div", {
        className: classNames.caption_dropdowns,
        style: styles.caption_dropdowns,
        children: [
            (0, _jsxRuntime.jsx)("div", {
                className: classNames.vhidden,
                children: captionLabel
            }),
            (0, _jsxRuntime.jsx)(MonthsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            }),
            (0, _jsxRuntime.jsx)(YearsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            })
        ]
    });
}
/**
 * Render the "previous month" button in the navigation.
 */ function IconLeft(props) {
    return (0, _jsxRuntime.jsx)("svg", __assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, _jsxRuntime.jsx)("path", {
            d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render the "next month" button in the navigation.
 */ function IconRight(props) {
    return (0, _jsxRuntime.jsx)("svg", __assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, _jsxRuntime.jsx)("path", {
            d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z",
            fill: "currentColor"
        })
    }));
}
/** Render a button HTML element applying the reset class name. */ var Button = (0, _react.forwardRef)(function(props, ref) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [
        classNames.button_reset,
        classNames.button
    ];
    if (props.className) classNamesArr.push(props.className);
    var className = classNamesArr.join(' ');
    var style = __assign(__assign({}, styles.button_reset), styles.button);
    if (props.style) Object.assign(style, props.style);
    return (0, _jsxRuntime.jsx)("button", __assign({}, props, {
        ref: ref,
        type: "button",
        className: className,
        style: style
    }));
});
/** A component rendering the navigation buttons or the drop-downs. */ function Navigation(props) {
    var _a, _b;
    var _c = useDayPicker(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    var previousLabel = labelPrevious(props.previousMonth, {
        locale: locale
    });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(' ');
    var nextLabel = labelNext(props.nextMonth, {
        locale: locale
    });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(' ');
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : IconRight;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : IconLeft;
    return (0, _jsxRuntime.jsxs)("div", {
        className: classNames.nav,
        style: styles.nav,
        children: [
            !props.hidePrevious && (0, _jsxRuntime.jsx)(Button, {
                name: "previous-month",
                "aria-label": previousLabel,
                className: previousClassName,
                style: styles.nav_button_previous,
                disabled: !props.previousMonth,
                onClick: props.onPreviousClick,
                children: dir === 'rtl' ? (0, _jsxRuntime.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, _jsxRuntime.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            }),
            !props.hideNext && (0, _jsxRuntime.jsx)(Button, {
                name: "next-month",
                "aria-label": nextLabel,
                className: nextClassName,
                style: styles.nav_button_next,
                disabled: !props.nextMonth,
                onClick: props.onNextClick,
                children: dir === 'rtl' ? (0, _jsxRuntime.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, _jsxRuntime.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            })
        ]
    });
}
/**
 * Render a caption with a button-based navigation.
 */ function CaptionNavigation(props) {
    var numberOfMonths = useDayPicker().numberOfMonths;
    var _a = useNavigation(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function(month) {
        return (0, _dateFns.isSameMonth)(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function() {
        if (!previousMonth) return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function() {
        if (!nextMonth) return;
        goToMonth(nextMonth);
    };
    return (0, _jsxRuntime.jsx)(Navigation, {
        displayMonth: props.displayMonth,
        hideNext: hideNext,
        hidePrevious: hidePrevious,
        nextMonth: nextMonth,
        previousMonth: previousMonth,
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick
    });
}
/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */ function Caption(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var caption;
    if (disableNavigation) caption = (0, _jsxRuntime.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    else if (captionLayout === 'dropdown') caption = (0, _jsxRuntime.jsx)(CaptionDropdowns, {
        displayMonth: props.displayMonth,
        id: props.id
    });
    else if (captionLayout === 'dropdown-buttons') caption = (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)(CaptionDropdowns, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            }),
            (0, _jsxRuntime.jsx)(CaptionNavigation, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            })
        ]
    });
    else caption = (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)(CaptionLabelComponent, {
                id: props.id,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, _jsxRuntime.jsx)(CaptionNavigation, {
                displayMonth: props.displayMonth,
                id: props.id
            })
        ]
    });
    return (0, _jsxRuntime.jsx)("div", {
        className: classNames.caption,
        style: styles.caption,
        children: caption
    });
}
/** Render the Footer component (empty as default).*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function Footer(props) {
    var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return (0, _jsxRuntime.jsx)("tfoot", {
        className: tfoot,
        style: styles.tfoot,
        children: (0, _jsxRuntime.jsx)("tr", {
            children: (0, _jsxRuntime.jsx)("td", {
                colSpan: 8,
                children: footer
            })
        })
    });
}
/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */ function getWeekdays(locale, /** The index of the first day of the week (0 - Sunday). */ weekStartsOn, /** Use ISOWeek instead of locale/ */ ISOWeek) {
    var start = ISOWeek ? (0, _dateFns.startOfISOWeek)(new Date()) : (0, _dateFns.startOfWeek)(new Date(), {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    var days = [];
    for(var i = 0; i < 7; i++){
        var day = (0, _dateFns.addDays)(start, i);
        days.push(day);
    }
    return days;
}
/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */ function HeadRow() {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = getWeekdays(locale, weekStartsOn, ISOWeek);
    return (0, _jsxRuntime.jsxs)("tr", {
        style: styles.head_row,
        className: classNames.head_row,
        children: [
            showWeekNumber && (0, _jsxRuntime.jsx)("td", {
                style: styles.head_cell,
                className: classNames.head_cell
            }),
            weekdays.map(function(weekday, i) {
                return (0, _jsxRuntime.jsx)("th", {
                    scope: "col",
                    className: classNames.head_cell,
                    style: styles.head_cell,
                    "aria-label": labelWeekday(weekday, {
                        locale: locale
                    }),
                    children: formatWeekdayName(weekday, {
                        locale: locale
                    })
                }, i);
            })
        ]
    });
}
/** Render the table head. */ function Head() {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
    return (0, _jsxRuntime.jsx)("thead", {
        style: styles.head,
        className: classNames.head,
        children: (0, _jsxRuntime.jsx)(HeadRowComponent, {})
    });
}
/** Render the content of the day cell. */ function DayContent(props) {
    var _a = useDayPicker(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: formatDay(props.date, {
            locale: locale
        })
    });
}
/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */ var SelectMultipleContext = (0, _react.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */ function SelectMultipleProvider(props) {
    if (!isDayPickerMultiple(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (0, _jsxRuntime.jsx)(SelectMultipleContext.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, _jsxRuntime.jsx)(SelectMultipleProviderInternal, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function SelectMultipleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) return;
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) return;
        var selectedDays = selected ? __spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function(selectedDay) {
                return (0, _dateFns.isSameDay)(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        } else selectedDays.push(day);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) modifiers.disabled.push(function(day) {
        var isMaxSelected = max && selected.length > max - 1;
        var isSelected = selected.some(function(selectedDay) {
            return (0, _dateFns.isSameDay)(selectedDay, day);
        });
        return Boolean(isMaxSelected && !isSelected);
    });
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (0, _jsxRuntime.jsx)(SelectMultipleContext.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function useSelectMultiple() {
    var context = (0, _react.useContext)(SelectMultipleContext);
    if (!context) throw new Error('useSelectMultiple must be used within a SelectMultipleProvider');
    return context;
}
/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */ function addToRange(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (from && to) {
        if ((0, _dateFns.isSameDay)(to, day) && (0, _dateFns.isSameDay)(from, day)) return undefined;
        if ((0, _dateFns.isSameDay)(to, day)) return {
            from: to,
            to: undefined
        };
        if ((0, _dateFns.isSameDay)(from, day)) return undefined;
        if ((0, _dateFns.isAfter)(from, day)) return {
            from: day,
            to: to
        };
        return {
            from: from,
            to: day
        };
    }
    if (to) {
        if ((0, _dateFns.isAfter)(day, to)) return {
            from: to,
            to: day
        };
        return {
            from: day,
            to: to
        };
    }
    if (from) {
        if ((0, _dateFns.isBefore)(day, from)) return {
            from: day,
            to: from
        };
        return {
            from: from,
            to: day
        };
    }
    return {
        from: day,
        to: undefined
    };
}
/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */ var SelectRangeContext = (0, _react.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */ function SelectRangeProvider(props) {
    if (!isDayPickerRange(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (0, _jsxRuntime.jsx)(SelectRangeContext.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, _jsxRuntime.jsx)(SelectRangeProviderInternal, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function SelectRangeProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var newRange = addToRange(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [
            selectedFrom
        ];
        if (!selectedTo) modifiers.range_end = [
            selectedFrom
        ];
        else {
            modifiers.range_end = [
                selectedTo
            ];
            if (!(0, _dateFns.isSameDay)(selectedFrom, selectedTo)) modifiers.range_middle = [
                {
                    after: selectedFrom,
                    before: selectedTo
                }
            ];
        }
    } else if (selectedTo) {
        modifiers.range_start = [
            selectedTo
        ];
        modifiers.range_end = [
            selectedTo
        ];
    }
    if (min) {
        if (selectedFrom && !selectedTo) modifiers.disabled.push({
            after: (0, _dateFns.subDays)(selectedFrom, min - 1),
            before: (0, _dateFns.addDays)(selectedFrom, min - 1)
        });
        if (selectedFrom && selectedTo) modifiers.disabled.push({
            after: selectedFrom,
            before: (0, _dateFns.addDays)(selectedFrom, min - 1)
        });
        if (!selectedFrom && selectedTo) modifiers.disabled.push({
            after: (0, _dateFns.subDays)(selectedTo, min - 1),
            before: (0, _dateFns.addDays)(selectedTo, min - 1)
        });
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: (0, _dateFns.addDays)(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, _dateFns.addDays)(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = (0, _dateFns.differenceInCalendarDays)(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: (0, _dateFns.subDays)(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: (0, _dateFns.addDays)(selectedTo, offset)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                before: (0, _dateFns.addDays)(selectedTo, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, _dateFns.addDays)(selectedTo, max - 1)
            });
        }
    }
    return (0, _jsxRuntime.jsx)(SelectRangeContext.Provider, {
        value: {
            selected: selected,
            onDayClick: onDayClick,
            modifiers: modifiers
        },
        children: children
    });
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function useSelectRange() {
    var context = (0, _react.useContext)(SelectRangeContext);
    if (!context) throw new Error('useSelectRange must be used within a SelectRangeProvider');
    return context;
}
/** Normalize to array a matcher input. */ function matcherToArray(matcher) {
    if (Array.isArray(matcher)) return __spreadArray([], matcher, true);
    else if (matcher !== undefined) return [
        matcher
    ];
    else return [];
}
/** Create CustomModifiers from dayModifiers */ function getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function(_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = matcherToArray(matcher);
    });
    return customModifiers;
}
/** The name of the modifiers that are used internally by DayPicker. */ var InternalModifier;
(function(InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */ InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */ InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */ InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */ InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */ InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */ InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */ InternalModifier["RangeMiddle"] = "range_middle";
})(InternalModifier || (InternalModifier = {}));
var Selected = InternalModifier.Selected, Disabled = InternalModifier.Disabled, Hidden = InternalModifier.Hidden, Today = InternalModifier.Today, RangeEnd = InternalModifier.RangeEnd, RangeMiddle = InternalModifier.RangeMiddle, RangeStart = InternalModifier.RangeStart, Outside = InternalModifier.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */ function getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {}, _a[Selected] = matcherToArray(dayPicker.selected), _a[Disabled] = matcherToArray(dayPicker.disabled), _a[Hidden] = matcherToArray(dayPicker.hidden), _a[Today] = [
        dayPicker.today
    ], _a[RangeEnd] = [], _a[RangeMiddle] = [], _a[RangeStart] = [], _a[Outside] = [], _a);
    if (dayPicker.fromDate) internalModifiers[Disabled].push({
        before: dayPicker.fromDate
    });
    if (dayPicker.toDate) internalModifiers[Disabled].push({
        after: dayPicker.toDate
    });
    if (isDayPickerMultiple(dayPicker)) internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectMultiple.modifiers[Disabled]);
    else if (isDayPickerRange(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectRange.modifiers[Disabled]);
        internalModifiers[RangeStart] = selectRange.modifiers[RangeStart];
        internalModifiers[RangeMiddle] = selectRange.modifiers[RangeMiddle];
        internalModifiers[RangeEnd] = selectRange.modifiers[RangeEnd];
    }
    return internalModifiers;
}
/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */ var ModifiersContext = (0, _react.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */ function ModifiersProvider(props) {
    var dayPicker = useDayPicker();
    var selectMultiple = useSelectMultiple();
    var selectRange = useSelectRange();
    var internalModifiers = getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = getCustomModifiers(dayPicker.modifiers);
    var modifiers = __assign(__assign({}, internalModifiers), customModifiers);
    return (0, _jsxRuntime.jsx)(ModifiersContext.Provider, {
        value: modifiers,
        children: props.children
    });
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */ function useModifiers() {
    var context = (0, _react.useContext)(ModifiersContext);
    if (!context) throw new Error('useModifiers must be used within a ModifiersProvider');
    return context;
}
/** Returns true if `matcher` is of type {@link DateInterval}. */ function isDateInterval(matcher) {
    return Boolean(matcher && typeof matcher === 'object' && 'before' in matcher && 'after' in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */ function isDateRange(value) {
    return Boolean(value && typeof value === 'object' && 'from' in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */ function isDateAfterType(value) {
    return Boolean(value && typeof value === 'object' && 'after' in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */ function isDateBeforeType(value) {
    return Boolean(value && typeof value === 'object' && 'before' in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */ function isDayOfWeekType(value) {
    return Boolean(value && typeof value === 'object' && 'dayOfWeek' in value);
}
/** Return `true` whether `date` is inside `range`. */ function isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (from && to) {
        var isRangeInverted = (0, _dateFns.differenceInCalendarDays)(to, from) < 0;
        if (isRangeInverted) _a = [
            to,
            from
        ], from = _a[0], to = _a[1];
        var isInRange = (0, _dateFns.differenceInCalendarDays)(date, from) >= 0 && (0, _dateFns.differenceInCalendarDays)(to, date) >= 0;
        return isInRange;
    }
    if (to) return (0, _dateFns.isSameDay)(to, date);
    if (from) return (0, _dateFns.isSameDay)(from, date);
    return false;
}
/** Returns true if `value` is a Date type. */ function isDateType(value) {
    return (0, _dateFns.isDate)(value);
}
/** Returns true if `value` is an array of valid dates. */ function isArrayOfDates(value) {
    return Array.isArray(value) && value.every((0, _dateFns.isDate));
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */ function isMatch(day, matchers) {
    return matchers.some(function(matcher) {
        if (typeof matcher === 'boolean') return matcher;
        if (isDateType(matcher)) return (0, _dateFns.isSameDay)(day, matcher);
        if (isArrayOfDates(matcher)) return matcher.includes(day);
        if (isDateRange(matcher)) return isDateInRange(day, matcher);
        if (isDayOfWeekType(matcher)) return matcher.dayOfWeek.includes(day.getDay());
        if (isDateInterval(matcher)) {
            var diffBefore = (0, _dateFns.differenceInCalendarDays)(matcher.before, day);
            var diffAfter = (0, _dateFns.differenceInCalendarDays)(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = (0, _dateFns.isAfter)(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if (isDateAfterType(matcher)) return (0, _dateFns.differenceInCalendarDays)(day, matcher.after) > 0;
        if (isDateBeforeType(matcher)) return (0, _dateFns.differenceInCalendarDays)(matcher.before, day) > 0;
        if (typeof matcher === 'function') return matcher(day);
        return false;
    });
}
/** Return the active modifiers for the given day. */ function getActiveModifiers(day, /** The modifiers to match for the given date. */ modifiers, /** The month where the day is displayed, to add the "outside" modifiers.  */ displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function(result, key) {
        var modifier = modifiers[key];
        if (isMatch(day, modifier)) result.push(key);
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function(modifier) {
        return activeModifiers[modifier] = true;
    });
    if (displayMonth && !(0, _dateFns.isSameMonth)(day, displayMonth)) activeModifiers.outside = true;
    return activeModifiers;
}
/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */ function getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = (0, _dateFns.startOfMonth)(displayMonths[0]);
    var lastDayInMonth = (0, _dateFns.endOfMonth)(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while(date <= lastDayInMonth){
        var activeModifiers = getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = (0, _dateFns.addDays)(date, 1);
            continue;
        }
        if (activeModifiers.selected) return date;
        if (activeModifiers.today && !today) today = date;
        if (!firstFocusableDay) firstFocusableDay = date;
        date = (0, _dateFns.addDays)(date, 1);
    }
    if (today) return today;
    else return firstFocusableDay;
}
var MAX_RETRY = 365;
/** Return the next date to be focused. */ function getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? {
        count: 0,
        lastFocused: focusedDay
    } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: (0, _dateFns.addDays),
        week: (0, _dateFns.addWeeks),
        month: (0, _dateFns.addMonths),
        year: (0, _dateFns.addYears),
        startOfWeek: function(date) {
            return context.ISOWeek ? (0, _dateFns.startOfISOWeek)(date) : (0, _dateFns.startOfWeek)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        },
        endOfWeek: function(date) {
            return context.ISOWeek ? (0, _dateFns.endOfISOWeek)(date) : (0, _dateFns.endOfWeek)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === 'after' ? 1 : -1);
    if (direction === 'before' && fromDate) newFocusedDay = (0, _dateFns.max)([
        fromDate,
        newFocusedDay
    ]);
    else if (direction === 'after' && toDate) newFocusedDay = (0, _dateFns.min)([
        toDate,
        newFocusedDay
    ]);
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) return newFocusedDay;
    else {
        if (retry.count > MAX_RETRY) return retry.lastFocused;
        return getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: __assign(__assign({}, retry), {
                count: retry.count + 1
            })
        });
    }
}
/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */ var FocusContext = (0, _react.createContext)(undefined);
/** The provider for the {@link FocusContext}. */ function FocusProvider(props) {
    var navigation = useNavigation();
    var modifiers = useModifiers();
    var _a = (0, _react.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0, _react.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : lastFocused && navigation.isDateDisplayed(lastFocused)) ? lastFocused : initialFocusTarget;
    var blur = function() {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function(date) {
        setFocusedDay(date);
    };
    var context = useDayPicker();
    var moveFocus = function(moveBy, direction) {
        if (!focusedDay) return;
        var nextFocused = getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if ((0, _dateFns.isSameDay)(focusedDay, nextFocused)) return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function() {
            return moveFocus('day', 'after');
        },
        focusDayBefore: function() {
            return moveFocus('day', 'before');
        },
        focusWeekAfter: function() {
            return moveFocus('week', 'after');
        },
        focusWeekBefore: function() {
            return moveFocus('week', 'before');
        },
        focusMonthBefore: function() {
            return moveFocus('month', 'before');
        },
        focusMonthAfter: function() {
            return moveFocus('month', 'after');
        },
        focusYearBefore: function() {
            return moveFocus('year', 'before');
        },
        focusYearAfter: function() {
            return moveFocus('year', 'after');
        },
        focusStartOfWeek: function() {
            return moveFocus('startOfWeek', 'before');
        },
        focusEndOfWeek: function() {
            return moveFocus('endOfWeek', 'after');
        }
    };
    return (0, _jsxRuntime.jsx)(FocusContext.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function useFocusContext() {
    var context = (0, _react.useContext)(FocusContext);
    if (!context) throw new Error('useFocusContext must be used within a FocusProvider');
    return context;
}
/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */ function useActiveModifiers(day, /**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */ displayMonth) {
    var modifiers = useModifiers();
    var activeModifiers = getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}
/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */ var SelectSingleContext = (0, _react.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */ function SelectSingleProvider(props) {
    if (!isDayPickerSingle(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (0, _jsxRuntime.jsx)(SelectSingleContext.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, _jsxRuntime.jsx)(SelectSingleProviderInternal, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function SelectSingleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 || _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (0, _jsxRuntime.jsx)(SelectSingleContext.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function useSelectSingle() {
    var context = (0, _react.useContext)(SelectSingleContext);
    if (!context) throw new Error('useSelectSingle must be used within a SelectSingleProvider');
    return context;
}
/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */ function useDayEventHandlers(date, activeModifiers) {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var _a = useFocusContext(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function(e) {
        var _a, _b, _c, _d;
        if (isDayPickerSingle(dayPicker)) (_a = single.onDayClick) === null || _a === void 0 || _a.call(single, date, activeModifiers, e);
        else if (isDayPickerMultiple(dayPicker)) (_b = multiple.onDayClick) === null || _b === void 0 || _b.call(multiple, date, activeModifiers, e);
        else if (isDayPickerRange(dayPicker)) (_c = range.onDayClick) === null || _c === void 0 || _c.call(range, date, activeModifiers, e);
        else (_d = dayPicker.onDayClick) === null || _d === void 0 || _d.call(dayPicker, date, activeModifiers, e);
    };
    var onFocus = function(e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function(e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function(e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function(e) {
        var _a;
        switch(e.key){
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayAfter() : focusDayBefore();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayBefore() : focusDayAfter();
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case 'PageUp':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case 'PageDown':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case 'Home':
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case 'End':
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}
/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */ function useSelectedDays() {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var selectedDays = isDayPickerSingle(dayPicker) ? single.selected : isDayPickerMultiple(dayPicker) ? multiple.selected : isDayPickerRange(dayPicker) ? range.selected : undefined;
    return selectedDays;
}
function isInternalModifier(modifier) {
    return Object.values(InternalModifier).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */ function getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [
        dayPicker.classNames.day
    ];
    Object.keys(activeModifiers).forEach(function(modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) classNames.push(customClassName);
        else if (isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) classNames.push(internalClassName);
        }
    });
    return classNames;
}
/** Return the style for the Day element, according to the given active modifiers. */ function getDayStyle(dayPicker, activeModifiers) {
    var style = __assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function(modifier) {
        var _a;
        style = __assign(__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}
/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */ function useDayRender(/** The date to render. */ day, /** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */ displayMonth, /** A ref to the button element that will be target of focus when rendered (if required). */ buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var activeModifiers = useActiveModifiers(day, displayMonth);
    var eventHandlers = useDayEventHandlers(day, activeModifiers);
    var selectedDays = useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== 'default');
    // Focus the button if the day is focused according to the focus context
    (0, _react.useEffect)(function() {
        var _a;
        if (activeModifiers.outside) return;
        if (!focusContext.focusedDay) return;
        if (!isButton) return;
        if ((0, _dateFns.isSameDay)(focusContext.focusedDay, day)) (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = getDayClassNames(dayPicker, activeModifiers).join(' ');
    var style = getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean(activeModifiers.outside && !dayPicker.showOutsideDays || activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : DayContent;
    var children = (0, _jsxRuntime.jsx)(DayContentComponent, {
        date: day,
        displayMonth: displayMonth,
        activeModifiers: activeModifiers
    });
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: 'gridcell'
    };
    var isFocusTarget = focusContext.focusTarget && (0, _dateFns.isSameDay)(focusContext.focusTarget, day) && !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && (0, _dateFns.isSameDay)(focusContext.focusedDay, day);
    var buttonProps = __assign(__assign(__assign({}, divProps), (_a = {
        disabled: activeModifiers.disabled,
        role: 'gridcell'
    }, _a['aria-selected'] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}
/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */ function Day(props) {
    var buttonRef = (0, _react.useRef)(null);
    var dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) return (0, _jsxRuntime.jsx)("div", {
        role: "gridcell"
    });
    if (!dayRender.isButton) return (0, _jsxRuntime.jsx)("div", __assign({}, dayRender.divProps));
    return (0, _jsxRuntime.jsx)(Button, __assign({
        name: "day",
        ref: buttonRef
    }, dayRender.buttonProps));
}
/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */ function WeekNumber(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = useDayPicker(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), {
        locale: locale
    });
    if (!onWeekNumberClick) return (0, _jsxRuntime.jsx)("span", {
        className: classNames.weeknumber,
        style: styles.weeknumber,
        children: content
    });
    var label = labelWeekNumber(Number(weekNumber), {
        locale: locale
    });
    var handleClick = function(e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (0, _jsxRuntime.jsx)(Button, {
        name: "week-number",
        "aria-label": label,
        className: classNames.weeknumber,
        style: styles.weeknumber,
        onClick: handleClick,
        children: content
    });
}
/** Render a row in the calendar, with the days and the week number. */ function Row(props) {
    var _a, _b;
    var _c = useDayPicker(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : Day;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : WeekNumber;
    var weekNumberCell;
    if (showWeekNumber) weekNumberCell = (0, _jsxRuntime.jsx)("td", {
        className: classNames.cell,
        style: styles.cell,
        children: (0, _jsxRuntime.jsx)(WeeknumberComponent, {
            number: props.weekNumber,
            dates: props.dates
        })
    });
    return (0, _jsxRuntime.jsxs)("tr", {
        className: classNames.row,
        style: styles.row,
        children: [
            weekNumberCell,
            props.dates.map(function(date) {
                return (0, _jsxRuntime.jsx)("td", {
                    className: classNames.cell,
                    style: styles.cell,
                    role: "presentation",
                    children: (0, _jsxRuntime.jsx)(DayComponent, {
                        displayMonth: props.displayMonth,
                        date: date
                    })
                }, (0, _dateFns.getUnixTime)(date));
            })
        ]
    });
}
/** Return the weeks between two dates.  */ function daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, _dateFns.endOfISOWeek)(toDate) : (0, _dateFns.endOfWeek)(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, _dateFns.startOfISOWeek)(fromDate) : (0, _dateFns.startOfWeek)(fromDate, options);
    var nOfDays = (0, _dateFns.differenceInCalendarDays)(toWeek, fromWeek);
    var days = [];
    for(var i = 0; i <= nOfDays; i++)days.push((0, _dateFns.addDays)(fromWeek, i));
    var weeksInMonth = days.reduce(function(result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, _dateFns.getISOWeek)(date) : (0, _dateFns.getWeek)(date, options);
        var existingWeek = result.find(function(value) {
            return value.weekNumber === weekNumber;
        });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [
                date
            ]
        });
        return result;
    }, []);
    return weeksInMonth;
}
/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */ function getMonthWeeks(month, options) {
    var weeksInMonth = daysToMonthWeeks((0, _dateFns.startOfMonth)(month), (0, _dateFns.endOfMonth)(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = (0, _dateFns.getWeeksInMonth)(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = (0, _dateFns.addWeeks)(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = daysToMonthWeeks((0, _dateFns.addWeeks)(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}
/** Render the table with the calendar. */ function Table(props) {
    var _a, _b, _c;
    var _d = useDayPicker(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : Head;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : Row;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : Footer;
    return (0, _jsxRuntime.jsxs)("table", {
        id: props.id,
        className: classNames.table,
        style: styles.table,
        role: "grid",
        "aria-labelledby": props['aria-labelledby'],
        children: [
            !hideHead && (0, _jsxRuntime.jsx)(HeadComponent, {}),
            (0, _jsxRuntime.jsx)("tbody", {
                className: classNames.tbody,
                style: styles.tbody,
                children: weeks.map(function(week) {
                    return (0, _jsxRuntime.jsx)(RowComponent, {
                        displayMonth: props.displayMonth,
                        dates: week.dates,
                        weekNumber: week.weekNumber
                    }, week.weekNumber);
                })
            }),
            (0, _jsxRuntime.jsx)(FooterComponent, {
                displayMonth: props.displayMonth
            })
        ]
    });
}
/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ /* eslint-disable prefer-const */ /* eslint-disable @typescript-eslint/ban-ts-comment */ /*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */ function canUseDOM() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */ var useIsomorphicLayoutEffect = canUseDOM() ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
var serverHandoffComplete = false;
var id = 0;
function genId() {
    return "react-day-picker-".concat(++id);
}
function useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : serverHandoffComplete ? genId() : null;
    var _b = (0, _react.useState)(initialId), id = _b[0], setId = _b[1];
    useIsomorphicLayoutEffect(function() {
        if (id === null) // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
        // rendering flicker, though it'll make the first render slower (unlikely
        // to matter, but you're welcome to measure your app and let us know if
        // it's a problem).
        setId(genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, _react.useEffect)(function() {
        if (serverHandoffComplete === false) // Flag all future uses of `useId` to skip the update dance. This is in
        // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
        // accidentally bail out of the patch-up dance prematurely.
        serverHandoffComplete = true;
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}
/** Render a month. */ function Month(props) {
    var _a;
    var _b;
    var dayPicker = useDayPicker();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = useNavigation().displayMonths;
    var captionId = useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex) : undefined;
    var className = [
        classNames.month
    ];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === 'rtl') _a = [
        isStart,
        isEnd
    ], isEnd = _a[0], isStart = _a[1];
    if (isStart) {
        className.push(classNames.caption_start);
        style = __assign(__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = __assign(__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = __assign(__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : Caption;
    return (0, _jsxRuntime.jsxs)("div", {
        className: className.join(' '),
        style: style,
        children: [
            (0, _jsxRuntime.jsx)(CaptionComponent, {
                id: captionId,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, _jsxRuntime.jsx)(Table, {
                id: tableId,
                "aria-labelledby": captionId,
                displayMonth: props.displayMonth
            })
        ]
    }, props.displayIndex);
}
/**
 * Render the wrapper for the month grids.
 */ function Months(props) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    return (0, _jsxRuntime.jsx)("div", {
        className: classNames.months,
        style: styles.months,
        children: props.children
    });
}
/** Render the container with the months according to the number of months to display. */ function Root(_a) {
    var _b, _c;
    var initialProps = _a.initialProps;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var navigation = useNavigation();
    var _d = (0, _react.useState)(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
    // Focus the focus target when initialFocus is passed in
    (0, _react.useEffect)(function() {
        if (!dayPicker.initialFocus) return;
        if (!focusContext.focusTarget) return;
        if (hasInitialFocus) return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [
        dayPicker.classNames.root,
        dayPicker.className
    ];
    if (dayPicker.numberOfMonths > 1) classNames.push(dayPicker.classNames.multiple_months);
    if (dayPicker.showWeekNumber) classNames.push(dayPicker.classNames.with_weeknumber);
    var style = __assign(__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps).filter(function(key) {
        return key.startsWith('data-');
    }).reduce(function(attrs, key) {
        var _a;
        return __assign(__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : Months;
    return (0, _jsxRuntime.jsx)("div", __assign({
        className: classNames.join(' '),
        style: style,
        dir: dayPicker.dir,
        id: dayPicker.id,
        nonce: initialProps.nonce,
        title: initialProps.title,
        lang: initialProps.lang
    }, dataAttributes, {
        children: (0, _jsxRuntime.jsx)(MonthsComponent, {
            children: navigation.displayMonths.map(function(month, i) {
                return (0, _jsxRuntime.jsx)(Month, {
                    displayIndex: i,
                    displayMonth: month
                }, i);
            })
        })
    }));
}
/** Provide the value for all the context providers. */ function RootProvider(props) {
    var children = props.children, initialProps = __rest(props, [
        "children"
    ]);
    return (0, _jsxRuntime.jsx)(DayPickerProvider, {
        initialProps: initialProps,
        children: (0, _jsxRuntime.jsx)(NavigationProvider, {
            children: (0, _jsxRuntime.jsx)(SelectSingleProvider, {
                initialProps: initialProps,
                children: (0, _jsxRuntime.jsx)(SelectMultipleProvider, {
                    initialProps: initialProps,
                    children: (0, _jsxRuntime.jsx)(SelectRangeProvider, {
                        initialProps: initialProps,
                        children: (0, _jsxRuntime.jsx)(ModifiersProvider, {
                            children: (0, _jsxRuntime.jsx)(FocusProvider, {
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
}
/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */ function DayPicker(props) {
    return (0, _jsxRuntime.jsx)(RootProvider, __assign({}, props, {
        children: (0, _jsxRuntime.jsx)(Root, {
            initialProps: props
        })
    }));
}
/** @private */ function isValidDate(day) {
    return !isNaN(day.getTime());
}
/** Return props and setters for binding an input field to DayPicker. */ function useInput(options) {
    if (options === void 0) options = {};
    var _a = options.locale, locale = _a === void 0 ? (0, _locale.enUS) : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? 'PP' : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function(value) {
        return (0, _dateFns.parse)(value, format$1, today, {
            locale: locale
        });
    };
    // Initialize states
    var _e = (0, _react.useState)(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = (0, _react.useState)(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected ? (0, _dateFns.format)(defaultSelected, format$1, {
        locale: locale
    }) : '';
    var _g = (0, _react.useState)(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function() {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : '');
    };
    var setSelected = function(date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? (0, _dateFns.format)(date, format$1, {
            locale: locale
        }) : '');
    };
    var handleDayClick = function(day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue('');
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? (0, _dateFns.format)(day, format$1, {
            locale: locale
        }) : '');
    };
    var handleMonthChange = function(month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function(e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && (0, _dateFns.differenceInCalendarDays)(fromDate, day) > 0;
        var isAfter = toDate && (0, _dateFns.differenceInCalendarDays)(day, toDate) > 0;
        if (!isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function(e) {
        var day = parseValue(e.target.value);
        if (!isValidDate(day)) reset();
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function(e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if (isValidDate(day)) setMonth(day);
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: (0, _dateFns.format)(new Date(), format$1, {
            locale: locale
        })
    };
    return {
        dayPickerProps: dayPickerProps,
        inputProps: inputProps,
        reset: reset,
        setSelected: setSelected
    };
}
/** Returns true when the props are of type {@link DayPickerDefaultProps}. */ function isDayPickerDefault(props) {
    return props.mode === undefined || props.mode === 'default';
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","date-fns":"btU8f","date-fns/locale":"dElgW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dElgW":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "af", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "ar", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "arDZ", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "arEG", ()=>(0, _indexJsDefault3.default));
parcelHelpers.export(exports, "arMA", ()=>(0, _indexJsDefault4.default));
parcelHelpers.export(exports, "arSA", ()=>(0, _indexJsDefault5.default));
parcelHelpers.export(exports, "arTN", ()=>(0, _indexJsDefault6.default));
parcelHelpers.export(exports, "az", ()=>(0, _indexJsDefault7.default));
parcelHelpers.export(exports, "be", ()=>(0, _indexJsDefault8.default));
parcelHelpers.export(exports, "beTarask", ()=>(0, _indexJsDefault9.default));
parcelHelpers.export(exports, "bg", ()=>(0, _indexJsDefault10.default));
parcelHelpers.export(exports, "bn", ()=>(0, _indexJsDefault11.default));
parcelHelpers.export(exports, "bs", ()=>(0, _indexJsDefault12.default));
parcelHelpers.export(exports, "ca", ()=>(0, _indexJsDefault13.default));
parcelHelpers.export(exports, "cs", ()=>(0, _indexJsDefault14.default));
parcelHelpers.export(exports, "cy", ()=>(0, _indexJsDefault15.default));
parcelHelpers.export(exports, "da", ()=>(0, _indexJsDefault16.default));
parcelHelpers.export(exports, "de", ()=>(0, _indexJsDefault17.default));
parcelHelpers.export(exports, "deAT", ()=>(0, _indexJsDefault18.default));
parcelHelpers.export(exports, "el", ()=>(0, _indexJsDefault19.default));
parcelHelpers.export(exports, "enAU", ()=>(0, _indexJsDefault20.default));
parcelHelpers.export(exports, "enCA", ()=>(0, _indexJsDefault21.default));
parcelHelpers.export(exports, "enGB", ()=>(0, _indexJsDefault22.default));
parcelHelpers.export(exports, "enIE", ()=>(0, _indexJsDefault23.default));
parcelHelpers.export(exports, "enIN", ()=>(0, _indexJsDefault24.default));
parcelHelpers.export(exports, "enNZ", ()=>(0, _indexJsDefault25.default));
parcelHelpers.export(exports, "enUS", ()=>(0, _indexJsDefault26.default));
parcelHelpers.export(exports, "enZA", ()=>(0, _indexJsDefault27.default));
parcelHelpers.export(exports, "eo", ()=>(0, _indexJsDefault28.default));
parcelHelpers.export(exports, "es", ()=>(0, _indexJsDefault29.default));
parcelHelpers.export(exports, "et", ()=>(0, _indexJsDefault30.default));
parcelHelpers.export(exports, "eu", ()=>(0, _indexJsDefault31.default));
parcelHelpers.export(exports, "faIR", ()=>(0, _indexJsDefault32.default));
parcelHelpers.export(exports, "fi", ()=>(0, _indexJsDefault33.default));
parcelHelpers.export(exports, "fr", ()=>(0, _indexJsDefault34.default));
parcelHelpers.export(exports, "frCA", ()=>(0, _indexJsDefault35.default));
parcelHelpers.export(exports, "frCH", ()=>(0, _indexJsDefault36.default));
parcelHelpers.export(exports, "fy", ()=>(0, _indexJsDefault37.default));
parcelHelpers.export(exports, "gd", ()=>(0, _indexJsDefault38.default));
parcelHelpers.export(exports, "gl", ()=>(0, _indexJsDefault39.default));
parcelHelpers.export(exports, "gu", ()=>(0, _indexJsDefault40.default));
parcelHelpers.export(exports, "he", ()=>(0, _indexJsDefault41.default));
parcelHelpers.export(exports, "hi", ()=>(0, _indexJsDefault42.default));
parcelHelpers.export(exports, "hr", ()=>(0, _indexJsDefault43.default));
parcelHelpers.export(exports, "ht", ()=>(0, _indexJsDefault44.default));
parcelHelpers.export(exports, "hu", ()=>(0, _indexJsDefault45.default));
parcelHelpers.export(exports, "hy", ()=>(0, _indexJsDefault46.default));
parcelHelpers.export(exports, "id", ()=>(0, _indexJsDefault47.default));
parcelHelpers.export(exports, "is", ()=>(0, _indexJsDefault48.default));
parcelHelpers.export(exports, "it", ()=>(0, _indexJsDefault49.default));
parcelHelpers.export(exports, "itCH", ()=>(0, _indexJsDefault50.default));
parcelHelpers.export(exports, "ja", ()=>(0, _indexJsDefault51.default));
parcelHelpers.export(exports, "jaHira", ()=>(0, _indexJsDefault52.default));
parcelHelpers.export(exports, "ka", ()=>(0, _indexJsDefault53.default));
parcelHelpers.export(exports, "kk", ()=>(0, _indexJsDefault54.default));
parcelHelpers.export(exports, "km", ()=>(0, _indexJsDefault55.default));
parcelHelpers.export(exports, "kn", ()=>(0, _indexJsDefault56.default));
parcelHelpers.export(exports, "ko", ()=>(0, _indexJsDefault57.default));
parcelHelpers.export(exports, "lb", ()=>(0, _indexJsDefault58.default));
parcelHelpers.export(exports, "lt", ()=>(0, _indexJsDefault59.default));
parcelHelpers.export(exports, "lv", ()=>(0, _indexJsDefault60.default));
parcelHelpers.export(exports, "mk", ()=>(0, _indexJsDefault61.default));
parcelHelpers.export(exports, "mn", ()=>(0, _indexJsDefault62.default));
parcelHelpers.export(exports, "ms", ()=>(0, _indexJsDefault63.default));
parcelHelpers.export(exports, "mt", ()=>(0, _indexJsDefault64.default));
parcelHelpers.export(exports, "nb", ()=>(0, _indexJsDefault65.default));
parcelHelpers.export(exports, "nl", ()=>(0, _indexJsDefault66.default));
parcelHelpers.export(exports, "nlBE", ()=>(0, _indexJsDefault67.default));
parcelHelpers.export(exports, "nn", ()=>(0, _indexJsDefault68.default));
parcelHelpers.export(exports, "oc", ()=>(0, _indexJsDefault69.default));
parcelHelpers.export(exports, "pl", ()=>(0, _indexJsDefault70.default));
parcelHelpers.export(exports, "pt", ()=>(0, _indexJsDefault71.default));
parcelHelpers.export(exports, "ptBR", ()=>(0, _indexJsDefault72.default));
parcelHelpers.export(exports, "ro", ()=>(0, _indexJsDefault73.default));
parcelHelpers.export(exports, "ru", ()=>(0, _indexJsDefault74.default));
parcelHelpers.export(exports, "sk", ()=>(0, _indexJsDefault75.default));
parcelHelpers.export(exports, "sl", ()=>(0, _indexJsDefault76.default));
parcelHelpers.export(exports, "sq", ()=>(0, _indexJsDefault77.default));
parcelHelpers.export(exports, "sr", ()=>(0, _indexJsDefault78.default));
parcelHelpers.export(exports, "srLatn", ()=>(0, _indexJsDefault79.default));
parcelHelpers.export(exports, "sv", ()=>(0, _indexJsDefault80.default));
parcelHelpers.export(exports, "ta", ()=>(0, _indexJsDefault81.default));
parcelHelpers.export(exports, "te", ()=>(0, _indexJsDefault82.default));
parcelHelpers.export(exports, "th", ()=>(0, _indexJsDefault83.default));
parcelHelpers.export(exports, "tr", ()=>(0, _indexJsDefault84.default));
parcelHelpers.export(exports, "ug", ()=>(0, _indexJsDefault85.default));
parcelHelpers.export(exports, "uk", ()=>(0, _indexJsDefault86.default));
parcelHelpers.export(exports, "uz", ()=>(0, _indexJsDefault87.default));
parcelHelpers.export(exports, "uzCyrl", ()=>(0, _indexJsDefault88.default));
parcelHelpers.export(exports, "vi", ()=>(0, _indexJsDefault89.default));
parcelHelpers.export(exports, "zhCN", ()=>(0, _indexJsDefault90.default));
parcelHelpers.export(exports, "zhHK", ()=>(0, _indexJsDefault91.default));
parcelHelpers.export(exports, "zhTW", ()=>(0, _indexJsDefault92.default));
var _indexJs = require("./af/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./ar/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./ar-DZ/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./ar-EG/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./ar-MA/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./ar-SA/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./ar-TN/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./az/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./be/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./be-tarask/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./bg/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./bn/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./bs/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./ca/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./cs/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./cy/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./da/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./de/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./de-AT/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./el/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./en-AU/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./en-CA/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./en-GB/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./en-IE/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./en-IN/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./en-NZ/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./en-US/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./en-ZA/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./eo/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./es/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./et/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./eu/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./fa-IR/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./fi/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./fr/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./fr-CA/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./fr-CH/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./fy/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./gd/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./gl/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./gu/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./he/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./hi/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./hr/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./ht/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./hu/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./hy/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./id/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./is/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./it/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./it-CH/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./ja/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./ja-Hira/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./ka/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./kk/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./km/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./kn/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./ko/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./lb/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./lt/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./lv/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./mk/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./mn/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./ms/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./mt/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./nb/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./nl/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./nl-BE/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./nn/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./oc/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./pl/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./pt/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./pt-BR/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./ro/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./ru/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./sk/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./sl/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./sq/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./sr/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./sr-Latn/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./sv/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./ta/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./te/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./th/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./tr/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./ug/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./uk/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./uz/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./uz-Cyrl/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./vi/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./zh-CN/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./zh-HK/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./zh-TW/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);

},{"./af/index.js":"cIjNY","./ar/index.js":"2yk8H","./ar-DZ/index.js":"btBPS","./ar-EG/index.js":"8X1HB","./ar-MA/index.js":"14nLK","./ar-SA/index.js":"glfFa","./ar-TN/index.js":"dLWPQ","./az/index.js":"l9iX3","./be/index.js":"uj0DW","./be-tarask/index.js":"71wnK","./bg/index.js":"cOZjH","./bn/index.js":"cSkVW","./bs/index.js":"dAlw7","./ca/index.js":"hXrDz","./cs/index.js":"6Za3G","./cy/index.js":"96HkC","./da/index.js":"Wae2W","./de/index.js":"ehZzJ","./de-AT/index.js":"c4wJ8","./el/index.js":"klEaZ","./en-AU/index.js":"blhs2","./en-CA/index.js":"kO2gy","./en-GB/index.js":"5FcFP","./en-IE/index.js":"7ZdBv","./en-IN/index.js":"H6lja","./en-NZ/index.js":"lStYJ","./en-US/index.js":"4vfjK","./en-ZA/index.js":"judpw","./eo/index.js":"gLhnW","./es/index.js":"jCVgz","./et/index.js":"899KZ","./eu/index.js":"3BKqi","./fa-IR/index.js":"4FsED","./fi/index.js":"dGMC6","./fr/index.js":"dEe2x","./fr-CA/index.js":"k4r7J","./fr-CH/index.js":"5JnNz","./fy/index.js":"6HEQq","./gd/index.js":"5gutn","./gl/index.js":"aMwzg","./gu/index.js":"f1ngJ","./he/index.js":"37xwP","./hi/index.js":"70r0G","./hr/index.js":"2nDgv","./ht/index.js":"8WCNE","./hu/index.js":"dFFH1","./hy/index.js":"d3FLD","./id/index.js":"d9iVd","./is/index.js":"7wBfn","./it/index.js":"ecW7F","./it-CH/index.js":"bboAp","./ja/index.js":"9Wocf","./ja-Hira/index.js":"8uqib","./ka/index.js":"1RFqe","./kk/index.js":"kbVuS","./km/index.js":"ief84","./kn/index.js":"6Knme","./ko/index.js":"f4lPo","./lb/index.js":"8f9Yz","./lt/index.js":"9UDJn","./lv/index.js":"gkd7T","./mk/index.js":"2Cvw1","./mn/index.js":"13QbE","./ms/index.js":"gca2E","./mt/index.js":"44qfW","./nb/index.js":"aJ75U","./nl/index.js":"HBIPT","./nl-BE/index.js":"ljPLv","./nn/index.js":"4H3VI","./oc/index.js":"bhYtb","./pl/index.js":"7hSVu","./pt/index.js":"8YsAV","./pt-BR/index.js":"cErTo","./ro/index.js":"loZ7k","./ru/index.js":"an5Rd","./sk/index.js":"ayYqD","./sl/index.js":"lEaez","./sq/index.js":"3XCK6","./sr/index.js":"c4a5E","./sr-Latn/index.js":"4qSpB","./sv/index.js":"8S82i","./ta/index.js":"l6qRR","./te/index.js":"gvwZ5","./th/index.js":"81s8f","./tr/index.js":"3zlpo","./ug/index.js":"crzEv","./uk/index.js":"8oawC","./uz/index.js":"2yIqt","./uz-Cyrl/index.js":"5OQW0","./vi/index.js":"2GiK8","./zh-CN/index.js":"5iego","./zh-HK/index.js":"gI19e","./zh-TW/index.js":"8NIxK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cIjNY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
 */ var locale = {
    code: 'af',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"6vydd","./_lib/formatLong/index.js":"8gXfD","./_lib/formatRelative/index.js":"htx4M","./_lib/localize/index.js":"1c3aP","./_lib/match/index.js":"9Qbjt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6vydd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: 'minder as {{count}} sekondes'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekondes'
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: 'minder as {{count}} minute'
    },
    xMinutes: {
        one: "'n minuut",
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} ure'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} ure'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dae'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weke'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weke'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maande'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maande'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer as 1 jaar',
        other: 'meer as {{count}} jaar'
    },
    almostXYears: {
        one: 'byna 1 jaar',
        other: 'byna {{count}} jaar'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oor ' + result;
        else return result + ' gelede';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gXfD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htx4M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1c3aP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'vC',
        'nC'
    ],
    abbreviated: [
        'vC',
        'nC'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ste kwartaal',
        '2de kwartaal',
        '3de kwartaal',
        '4de kwartaal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mrt',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januarie',
        'Februarie',
        'Maart',
        'April',
        'Mei',
        'Junie',
        'Julie',
        'Augustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'W',
        'D',
        'V',
        'S'
    ],
    short: [
        'So',
        'Ma',
        'Di',
        'Wo',
        'Do',
        'Vr',
        'Sa'
    ],
    abbreviated: [
        'Son',
        'Maa',
        'Din',
        'Woe',
        'Don',
        'Vry',
        'Sat'
    ],
    wide: [
        'Sondag',
        'Maandag',
        'Dinsdag',
        'Woensdag',
        'Donderdag',
        'Vrydag',
        'Saterdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + 'ste';
        default:
            return number + 'de';
    }
    return number + 'ste';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Qbjt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2yk8H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var locale = {
    code: 'ar',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"2AIJD","./_lib/formatLong/index.js":"9jwxH","./_lib/formatRelative/index.js":"18x2p","./_lib/localize/index.js":"jNJhE","./_lib/match/index.js":"6XpBA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2AIJD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
    },
    aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9jwxH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"18x2p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var formatRelative = function formatRelative(token) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jNJhE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6XpBA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btBPS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var locale = {
    code: 'ar-DZ',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"6NsRW","./_lib/formatLong/index.js":"7n5XH","./_lib/formatRelative/index.js":"c6g5Q","./_lib/localize/index.js":"f4Uu3","./_lib/match/index.js":"6g5lI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6NsRW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7n5XH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6g5Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f4Uu3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6g5lI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8X1HB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13]{@link https://github.com/AbdAllahAbdElFattah13}
 */ var locale = {
    code: 'ar-EG',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"ljaCa","./_lib/formatLong/index.js":"gXZHU","./_lib/formatRelative/index.js":"lv46r","./_lib/localize/index.js":"imzkO","./_lib/match/index.js":"b3lRq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ljaCa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
        else return "\u0645\u0646\u0630 ".concat(result);
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gXZHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'dd/MMM/y',
    short: 'd/MM/y'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lv46r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imzkO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645",
        "\u0628.\u0645"
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b3lRq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)/;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
var parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
var matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
var matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
var parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"14nLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
 */ var locale = {
    code: 'ar-MA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"bytSg","./_lib/formatLong/index.js":"feJ6d","./_lib/formatRelative/index.js":"1W0vF","./_lib/localize/index.js":"grmLh","./_lib/match/index.js":"heyJX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bytSg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"feJ6d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1W0vF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grmLh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u063A",
        "\u0634",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0646\u0640",
        "\u062F\u062C\u0646\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648\u0632",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0646\u0628\u0631",
        "\u062F\u062C\u0646\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"heyJX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"glfFa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
 */ var locale = {
    code: 'ar-SA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"LZG5G","./_lib/formatLong/index.js":"3NSWp","./_lib/formatRelative/index.js":"2KUah","./_lib/localize/index.js":"aAPMX","./_lib/match/index.js":"iKCSn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"LZG5G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3NSWp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2KUah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAPMX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iKCSn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dLWPQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var locale = {
    code: 'ar-TN',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"0484J","./_lib/formatLong/index.js":"4eJuS","./_lib/formatRelative/index.js":"4DTHi","./_lib/localize/index.js":"i3kQl","./_lib/match/index.js":"k6VAU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0484J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A " + result;
        else return "\u0639\u0646\u062F\u0648 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4eJuS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u0645\u0639' {{time}}",
    long: "{{date}} '\u0645\u0639' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4DTHi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
    yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
    tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
    nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
    other: 'P'
};
var formatRelative = function formatRelative(token) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i3kQl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u062F",
        "\u0646",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u062C",
        "\u062C",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u0641",
        "\u062C"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k6VAU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l9iX3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ var locale = {
    code: 'az',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"45fXe","./_lib/formatLong/index.js":"8Vp64","./_lib/formatRelative/index.js":"hoioy","./_lib/localize/index.js":"j2nT3","./_lib/match/index.js":"3QqlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45fXe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
    },
    xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
    },
    halfAMinute: "yar\u0131m d\u0259qiq\u0259",
    lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
    },
    xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
    },
    aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
    },
    xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
    },
    aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
    },
    xYears: {
        one: '1 il',
        other: '{{count}} il'
    },
    overXYears: {
        one: "1 ild\u0259n \xe7ox",
        other: "{{count}} ild\u0259n \xe7ox"
    },
    almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \u0259vv\u0259l";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Vp64":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} {{time}} - 'd\u0259'",
    long: "{{date}} {{time}} - 'd\u0259'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hoioy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'d\u0259'",
    yesterday: "'d\xfcn\u0259n' p -'d\u0259'",
    today: "'bug\xfcn' p -'d\u0259'",
    tomorrow: "'sabah' p -'d\u0259'",
    nextWeek: "eeee p -'d\u0259'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j2nT3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "e.\u0259",
        'b.e'
    ],
    abbreviated: [
        "e.\u0259",
        'b.e'
    ],
    wide: [
        "eram\u0131zdan \u0259vv\u0259l",
        'bizim era'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ci kvartal',
        '2ci kvartal',
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
var monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        "\u0130",
        "\u0130",
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avq',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avqust',
        'Sentyabr',
        'Oktyabr',
        'Noyabr',
        'Dekabr'
    ]
};
var dayValues = {
    narrow: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    short: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    abbreviated: [
        'Baz',
        'Baz.e',
        "\xc7\u0259r.a",
        "\xc7\u0259r",
        "C\xfcm.a",
        "C\xfcm",
        "\u015E\u0259"
    ],
    wide: [
        'Bazar',
        "Bazar ert\u0259si",
        "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
        "\xc7\u0259r\u015F\u0259nb\u0259",
        "C\xfcm\u0259 ax\u015Fam\u0131",
        "C\xfcm\u0259",
        "\u015E\u0259nb\u0259"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-nc\u0131",
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
};
var getSuffix = function getSuffix(number) {
    if (number === 0) // special case for zero
    return number + "-\u0131nc\u0131";
    var a = number % 10;
    var b = number % 100 - a;
    var c = number >= 100 ? 100 : null;
    if (suffixes[a]) return suffixes[a];
    else if (suffixes[b]) return suffixes[b];
    else if (c !== null) return suffixes[c];
    return '';
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var suffix = getSuffix(number);
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QqlZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
var parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
var parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
var matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
var parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'narrow'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"uj0DW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
 */ var locale = {
    code: 'be',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iv3kj","./_lib/formatLong/index.js":"gODRu","./_lib/formatRelative/index.js":"hpMdL","./_lib/localize/index.js":"1V5QN","./_lib/match/index.js":"eNgqU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iv3kj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return declension(scheme.regular, count);
    };
}
var halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: halfAMinute,
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gODRu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hpMdL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../index.js");
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: nextWeekFormat,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../index.js":"btU8f","../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eMkKu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameUTCWeek);
var _indexJs = require("../requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
    (0, _indexJsDefault.default)(2, arguments);
    var dateLeftStartOfWeek = (0, _indexJsDefault1.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, _indexJsDefault1.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

},{"../requiredArgs/index.js":"9bkfg","../startOfUTCWeek/index.js":"20vji","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1V5QN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u043D\u0435\u0436\u043D\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNgqU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
var parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"71wnK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears]{@link https://github.com/nopears}
 */ var locale = {
    code: 'be-tarask',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"3mZ97","./_lib/formatLong/index.js":"9n9px","./_lib/formatRelative/index.js":"7vRKo","./_lib/localize/index.js":"gyTmO","./_lib/match/index.js":"eVxuq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3mZ97":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return declension(scheme.regular, count);
    };
}
var halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: halfAMinute,
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9n9px":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vRKo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../index.js");
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: nextWeekFormat,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../index.js":"btU8f","../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gyTmO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u0442\u0440\u0430\u045E\u043D\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446\u044C",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eVxuq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
var parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cOZjH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
 */ var locale = {
    code: 'bg',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"lvLgv","./_lib/formatLong/index.js":"coSKc","./_lib/formatRelative/index.js":"2fV1K","./_lib/localize/index.js":"2nicx","./_lib/match/index.js":"3ZrYL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvLgv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0441\u043B\u0435\u0434 " + result;
        else return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"coSKc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2fV1K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
// Adapted from the `ru` translation
var weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u044F",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u044F\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
    "\u043F\u0435\u0442\u044A\u043A",
    "\u0441\u044A\u0431\u043E\u0442\u0430"
];
function lastWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
    }
}
function thisWeek(day) {
    var weekday = weekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function nextWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
    }
}
var lastWeekFormatToken = function lastWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault1.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormatToken = function nextWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault1.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormatToken,
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0434\u043D\u0435\u0441 \u0432' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
    nextWeek: nextWeekFormatToken,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../toDate/index.js":"9koxn","../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2nicx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."
    ],
    wide: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"
    ]
};
var monthValues = {
    abbreviated: [
        "\u044F\u043D\u0443",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u044F",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u044A\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u044F\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
        "\u043F\u0435\u0442\u044A\u043A",
        "\u0441\u044A\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
    }
};
function isFeminine(unit) {
    return unit === 'year' || unit === 'week' || unit === 'minute' || unit === 'second';
}
function isNeuter(unit) {
    return unit === 'quarter';
}
function numberWithSuffix(number, unit, masculine, feminine, neuter) {
    var suffix = isNeuter(unit) ? neuter : isFeminine(unit) ? feminine : masculine;
    return number + '-' + suffix;
}
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
    else if (number % 1000 === 0) return numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
    else if (number % 100 === 0) return numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
        case 2:
            return numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
        case 7:
        case 8:
            return numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
    return numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ZrYL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
var parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
var matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cSkVW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
 */ var locale = {
    code: 'bn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"bdg71","./_lib/formatLong/index.js":"7496N","./_lib/formatRelative/index.js":"9ZlcO","./_lib/localize/index.js":"9VBVg","./_lib/match/index.js":"jjxkH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdg71":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../localize/index.js");
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
    lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
    },
    aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
    },
    xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
    },
    aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    },
    xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
    },
    overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
    },
    almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, _indexJs.numberToLocale)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        else return result + " \u0986\u0997\u09C7";
    }
    return result;
};
exports.default = formatDistance;

},{"../localize/index.js":"9VBVg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9VBVg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// function localeToNumber(locale: string): number {
//   const enNumber = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
//     return numberValues.number[match as keyof typeof numberValues.number]
//   })
//   return Number(enNumber)
// }
parcelHelpers.export(exports, "numberToLocale", ()=>numberToLocale);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var numberValues = {
    locale: {
        '1': "\u09E7",
        '2': "\u09E8",
        '3': "\u09E9",
        '4': "\u09EA",
        '5': "\u09EB",
        '6': "\u09EC",
        '7': "\u09ED",
        '8': "\u09EE",
        '9': "\u09EF",
        '0': "\u09E6"
    },
    number: {
        "\u09E7": '1',
        "\u09E8": '2',
        "\u09E9": '3',
        "\u09EA": '4',
        "\u09EB": '5',
        "\u09EC": '6',
        "\u09ED": '7',
        "\u09EE": '8',
        "\u09EF": '9',
        "\u09E6": '0'
    }
};
var eraValues = {
    narrow: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    abbreviated: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    wide: [
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"
    ]
};
var quarterValues = {
    narrow: [
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA"
    ],
    abbreviated: [
        "\u09E7\u09A4\u09CD\u09B0\u09C8",
        "\u09E8\u09A4\u09CD\u09B0\u09C8",
        "\u09E9\u09A4\u09CD\u09B0\u09C8",
        "\u09EA\u09A4\u09CD\u09B0\u09C8"
    ],
    wide: [
        "\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"
    ]
};
var monthValues = {
    narrow: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    abbreviated: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    wide: [
        "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
        "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
    ]
};
var dayValues = {
    narrow: [
        "\u09B0",
        "\u09B8\u09CB",
        "\u09AE",
        "\u09AC\u09C1",
        "\u09AC\u09C3",
        "\u09B6\u09C1",
        "\u09B6"
    ],
    short: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    abbreviated: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    wide: [
        "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
        "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
        "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
        "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
        "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
        "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
        "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
function dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "\u09B6\u09C7";
    else switch(number){
        case 1:
            return localeNumber + "\u09B2\u09BE";
        case 2:
        case 3:
            return localeNumber + "\u09B0\u09BE";
        case 4:
            return localeNumber + "\u09A0\u09BE";
        default:
            return localeNumber + "\u0987";
    }
}
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var localeNumber = numberToLocale(number);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'date') return dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
    var rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "\u09DF";
        case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";
        default:
            return localeNumber + "\u09AE";
    }
};
function numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return numberValues.locale[match];
    });
}
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7496N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ZlcO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
    yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
    tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jjxkH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
var parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
var parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
var parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
var matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
var parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dAlw7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
 */ var locale = {
    code: 'bs',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"hwfOn","./_lib/formatLong/index.js":"5hDqE","./_lib/formatRelative/index.js":"8AxgY","./_lib/localize/index.js":"93f6z","./_lib/match/index.js":"3TpqU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hwfOn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 sedmicu',
            withPrepositionAgo: 'oko 1 sedmicu',
            withPrepositionIn: 'oko 1 sedmicu'
        },
        dual: 'oko {{count}} sedmice',
        other: 'oko {{count}} sedmice'
    },
    xWeeks: {
        one: {
            standalone: '1 sedmicu',
            withPrepositionAgo: '1 sedmicu',
            withPrepositionIn: '1 sedmicu'
        },
        dual: '{{count}} sedmice',
        other: '{{count}} sedmice'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5hDqE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8AxgY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedjelje u' p";
            case 3:
                return "'pro\u0161le srijede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'sljede\u0107e nedjelje u' p";
            case 3:
                return "'sljede\u0107u srijedu u' p";
            case 6:
                return "'sljede\u0107u subotu u' p";
            default:
                return "'sljede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"93f6z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Prije Hrista',
        'Poslije Hrista'
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number) + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3TpqU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hXrDz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
 */ var locale = {
    code: 'ca',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale; // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')

},{"./_lib/formatDistance/index.js":"bggDb","./_lib/formatLong/index.js":"i3sRo","./_lib/formatRelative/index.js":"2tRnn","./_lib/localize/index.js":"459Kf","./_lib/match/index.js":"f18We","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bggDb":[function(require,module,exports,__globalThis) {
/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: 'menys de {{count}} segons'
    },
    xSeconds: {
        one: '1 segon',
        other: '{{count}} segons'
    },
    halfAMinute: 'mig minut',
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: 'menys de {{count}} minuts'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minuts'
    },
    aboutXHours: {
        one: 'aproximadament una hora',
        other: 'aproximadament {{count}} hores'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} hores'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dies'
    },
    aboutXWeeks: {
        one: 'aproximadament una setmana',
        other: 'aproximadament {{count}} setmanes'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanes'
    },
    aboutXMonths: {
        one: 'aproximadament un mes',
        other: 'aproximadament {{count}} mesos'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} mesos'
    },
    aboutXYears: {
        one: 'aproximadament un any',
        other: 'aproximadament {{count}} anys'
    },
    xYears: {
        one: '1 any',
        other: '{{count}} anys'
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'fa ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i3sRo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2tRnn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"459Kf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ var eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a. de C.',
        'd. de C.'
    ],
    wide: [
        'abans de Crist',
        "despr\xe9s de Crist"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        '1r trimestre',
        '2n trimestre',
        '3r trimestre',
        '4t trimestre'
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ var monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MG',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DS'
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'maig',
        'juny',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'des.'
    ],
    wide: [
        'gener',
        'febrer',
        "mar\xe7",
        'abril',
        'maig',
        'juny',
        'juliol',
        'agost',
        'setembre',
        'octubre',
        'novembre',
        'desembre'
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ var dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'diumenge',
        'dilluns',
        'dimarts',
        'dimecres',
        'dijous',
        'divendres',
        'dissabte'
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'r';
        case 2:
            return number + 'n';
        case 3:
            return number + 'r';
        case 4:
            return number + 't';
    }
    return number + "\xe8";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f18We":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
var parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
var matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
var parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Za3G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var locale = {
    code: 'cs',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dfWpq","./_lib/formatLong/index.js":"lR4B0","./_lib/formatRelative/index.js":"hYpDB","./_lib/localize/index.js":"ldoDh","./_lib/match/index.js":"lIax9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dfWpq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E sekundou",
            future: "za m\xe9n\u011B ne\u017E sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "p\u0159ed sekundou",
            future: 'za sekundu'
        },
        few: {
            regular: '{{count}} sekundy',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekundy'
        },
        many: {
            regular: '{{count}} sekund',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekund'
        }
    },
    halfAMinute: {
        type: 'other',
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E minutou",
            future: "za m\xe9n\u011B ne\u017E minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "p\u0159ed minutou",
            future: 'za minutu'
        },
        few: {
            regular: '{{count}} minuty',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minuty'
        },
        many: {
            regular: '{{count}} minut',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minut'
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: 'hodina',
            past: "p\u0159ed hodinou",
            future: 'za hodinu'
        },
        few: {
            regular: '{{count}} hodiny',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodiny'
        },
        many: {
            regular: '{{count}} hodin',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodin'
        }
    },
    xDays: {
        one: {
            regular: 'den',
            past: "p\u0159ed dnem",
            future: 'za den'
        },
        few: {
            regular: '{{count}} dny',
            past: "p\u0159ed {{count}} dny",
            future: 'za {{count}} dny'
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "p\u0159ed t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "m\u011Bs\xedc",
            past: "p\u0159ed m\u011Bs\xedcem",
            future: "za m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: 'rok',
            past: "p\u0159ed rokem",
            future: 'za rok'
        },
        few: {
            regular: '{{count}} roky',
            past: "p\u0159ed {{count}} roky",
            future: 'za {{count}} roky'
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E rok",
            past: "p\u0159ed v\xedce ne\u017E rokem",
            future: "za v\xedce ne\u017E rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: 'skoro rok',
            past: "skoro p\u0159ed rokem",
            future: 'skoro za rok'
        },
        few: {
            regular: 'skoro {{count}} roky',
            past: "skoro p\u0159ed {{count}} roky",
            future: 'skoro za {{count}} roky'
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var pluralResult;
    var tokenValue = formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === 'other') pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var comparison = options === null || options === void 0 ? void 0 : options.comparison;
    var timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace('{{count}}', String(count));
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lR4B0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy',
    long: 'd. MMMM yyyy',
    medium: 'd. M. yyyy',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYpDB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    'sobotu'
];
var formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        return "'v " + accusativeWeekdays[day] + " o' p";
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ldoDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    abbreviated: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
var monthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'leden',
        "\xfanor",
        "b\u0159ezen",
        'duben',
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        'srpen',
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        'listopad',
        'prosinec'
    ]
};
var formattingMonthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'ledna',
        "\xfanora",
        "b\u0159ezna",
        'dubna',
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        'srpna',
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        'listopadu',
        'prosince'
    ]
};
var dayValues = {
    narrow: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    short: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    abbreviated: [
        'ned',
        'pon',
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        'sob'
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        'sobota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lIax9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"96HkC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
 */ var locale = {
    code: 'cy',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iFcgo","./_lib/formatLong/index.js":"gsVG2","./_lib/formatRelative/index.js":"9mGzL","./_lib/localize/index.js":"hLiTR","./_lib/match/index.js":"633ho","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iFcgo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'llai na eiliad',
        other: 'llai na {{count}} eiliad'
    },
    xSeconds: {
        one: '1 eiliad',
        other: '{{count}} eiliad'
    },
    halfAMinute: 'hanner munud',
    lessThanXMinutes: {
        one: 'llai na munud',
        two: 'llai na 2 funud',
        other: 'llai na {{count}} munud'
    },
    xMinutes: {
        one: '1 munud',
        two: '2 funud',
        other: '{{count}} munud'
    },
    aboutXHours: {
        one: 'tua 1 awr',
        other: 'tua {{count}} awr'
    },
    xHours: {
        one: '1 awr',
        other: '{{count}} awr'
    },
    xDays: {
        one: '1 diwrnod',
        two: '2 ddiwrnod',
        other: '{{count}} diwrnod'
    },
    aboutXWeeks: {
        one: 'tua 1 wythnos',
        two: 'tua pythefnos',
        other: 'tua {{count}} wythnos'
    },
    xWeeks: {
        one: '1 wythnos',
        two: 'pythefnos',
        other: '{{count}} wythnos'
    },
    aboutXMonths: {
        one: 'tua 1 mis',
        two: 'tua 2 fis',
        other: 'tua {{count}} mis'
    },
    xMonths: {
        one: '1 mis',
        two: '2 fis',
        other: '{{count}} mis'
    },
    aboutXYears: {
        one: 'tua 1 flwyddyn',
        two: 'tua 2 flynedd',
        other: 'tua {{count}} mlynedd'
    },
    xYears: {
        one: '1 flwyddyn',
        two: '2 flynedd',
        other: '{{count}} mlynedd'
    },
    overXYears: {
        one: 'dros 1 flwyddyn',
        two: 'dros 2 flynedd',
        other: 'dros {{count}} mlynedd'
    },
    almostXYears: {
        one: 'bron 1 flwyddyn',
        two: 'bron 2 flynedd',
        other: 'bron {{count}} mlynedd'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'mewn ' + result;
        else return result + " yn \xf4l";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gsVG2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9mGzL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hLiTR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'C',
        'O'
    ],
    abbreviated: [
        'CC',
        'OC'
    ],
    wide: [
        'Cyn Crist',
        "Ar \xf4l Crist"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Ch1',
        'Ch2',
        'Ch3',
        'Ch4'
    ],
    wide: [
        'Chwarter 1af',
        '2ail chwarter',
        '3ydd chwarter',
        '4ydd chwarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'I',
        'Ch',
        'Ma',
        'E',
        'Mi',
        'Me',
        'G',
        'A',
        'Md',
        'H',
        'T',
        'Rh'
    ],
    abbreviated: [
        'Ion',
        'Chwe',
        'Maw',
        'Ebr',
        'Mai',
        'Meh',
        'Gor',
        'Aws',
        'Med',
        'Hyd',
        'Tach',
        'Rhag'
    ],
    wide: [
        'Ionawr',
        'Chwefror',
        'Mawrth',
        'Ebrill',
        'Mai',
        'Mehefin',
        'Gorffennaf',
        'Awst',
        'Medi',
        'Hydref',
        'Tachwedd',
        'Rhagfyr'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'Ll',
        'M',
        'M',
        'I',
        'G',
        'S'
    ],
    short: [
        'Su',
        'Ll',
        'Ma',
        'Me',
        'Ia',
        'Gw',
        'Sa'
    ],
    abbreviated: [
        'Sul',
        'Llun',
        'Maw',
        'Mer',
        'Iau',
        'Gwe',
        'Sad'
    ],
    wide: [
        'dydd Sul',
        'dydd Llun',
        'dydd Mawrth',
        'dydd Mercher',
        'dydd Iau',
        'dydd Gwener',
        'dydd Sadwrn'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + 'fed';
        case 1:
            return number + 'af';
        case 2:
            return number + 'ail';
        case 3:
        case 4:
            return number + 'ydd';
        case 5:
        case 6:
            return number + 'ed';
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + 'fed';
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + 'eg';
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + 'fed';
    return number + 'ain';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"633ho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
var parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
var parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
var matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Wae2W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var locale = {
    code: 'da',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dUhVJ","./_lib/formatLong/index.js":"gU9Yh","./_lib/formatRelative/index.js":"VCckR","./_lib/localize/index.js":"jHbaC","./_lib/match/index.js":"3MeMB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dUhVJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: 'mindre end {{count}} sekunder'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: 'mindre end {{count}} minutter'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'cirka 1 time',
        other: 'cirka {{count}} timer'
    },
    xHours: {
        one: '1 time',
        other: '{{count}} timer'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dage'
    },
    aboutXWeeks: {
        one: 'cirka 1 uge',
        other: 'cirka {{count}} uger'
    },
    xWeeks: {
        one: '1 uge',
        other: '{{count}} uger'
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gU9Yh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"VCckR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jHbaC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'fvt',
        'vt'
    ],
    abbreviated: [
        'f.v.t.',
        'v.t.'
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        'vesterlandsk tidsregning'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. kvt.',
        '2. kvt.',
        '3. kvt.',
        '4. kvt.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marts',
        'april',
        'maj',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        'man.',
        'tir.',
        'ons.',
        'tor.',
        'fre.',
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3MeMB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ehZzJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var locale = {
    code: 'de',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iOOTW","./_lib/formatLong/index.js":"bPJ9N","./_lib/formatRelative/index.js":"8hrIF","./_lib/localize/index.js":"fjTDU","./_lib/match/index.js":"bymdU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iOOTW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'halbe Minute',
        withPreposition: 'halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: '1 Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: '1 Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: '1 Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: '1 Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: '1 Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: '1 Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bPJ9N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8hrIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fjTDU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var formattingMonthValues = {
    narrow: monthValues.narrow,
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: monthValues.wide
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        formattingValues: formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bymdU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c4wJ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../de/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../de/_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../de/_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../de/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
// difference to 'de' locale
var _indexJs4 = require("./_lib/localize/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
 */ var locale = {
    code: 'de-AT',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault4.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../de/_lib/formatDistance/index.js":"iOOTW","../de/_lib/formatLong/index.js":"bPJ9N","../de/_lib/formatRelative/index.js":"8hrIF","../de/_lib/match/index.js":"bymdU","./_lib/localize/index.js":"aJO0s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJO0s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        "J\xe4n",
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        "J\xe4nner",
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
var formattingMonthValues = {
    narrow: monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: monthValues.wide
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        formattingValues: formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"klEaZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
 */ var locale = {
    code: 'el',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"0RHg5","./_lib/formatLong/index.js":"4LED9","./_lib/formatRelative/index.js":"huVlG","./_lib/localize/index.js":"6q3gl","./_lib/match/index.js":"cBwKT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0RHg5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4LED9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'd/M/yy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: '{{date}} - {{time}}',
    long: '{{date}} - {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"huVlG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 6:
                //Σάββατο
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6q3gl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
var monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
var dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        'T',
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'year' || unit === 'month') suffix = "\u03BF\u03C2";
    else if (unit === 'week' || unit === 'dayOfYear' || unit === 'day' || unit === 'hour' || unit === 'date') suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cBwKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
var matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"blhs2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../en-US/_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var locale = {
    code: 'en-AU',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","./_lib/formatLong/index.js":"9Hjjj","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Hjjj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kO2gy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/match/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/formatDistance/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
 */ var locale = {
    code: 'en-CA',
    formatDistance: (0, _indexJsDefault3.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault.default),
    localize: (0, _indexJsDefault1.default),
    match: (0, _indexJsDefault2.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","./_lib/formatDistance/index.js":"cMaLF","./_lib/formatLong/index.js":"j9tex","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cMaLF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: 'a second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: 'a minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about an hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: 'an hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: 'a day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about a week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: 'a week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about a month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: 'a month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about a year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: 'a year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over a year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost a year',
        other: 'almost {{count}} years'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j9tex":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, yyyy',
    long: 'MMMM do, yyyy',
    medium: 'MMM d, yyyy',
    short: 'yyyy-MM-dd'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5FcFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var locale = {
    code: 'en-GB',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","./_lib/formatLong/index.js":"fp4Wt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fp4Wt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ZdBv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../en-GB/_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75]{@link https://github.com/tan75}
 */ var locale = {
    code: 'en-IE',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","../en-GB/_lib/formatLong/index.js":"fp4Wt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"H6lja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
 */ var locale = {
    code: 'en-IN',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1,
        // Monday is the first day of the week.
        firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","./_lib/formatLong/index.js":"lcbuk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcbuk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM, yyyy',
    medium: 'd MMM, yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lStYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
 */ var locale = {
    code: 'en-NZ',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","./_lib/formatLong/index.js":"i73Ox","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i73Ox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"judpw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
 */ var locale = {
    code: 'en-ZA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 0,
        // Sunday is the first day of the week.
        firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","./_lib/formatLong/index.js":"evQmH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"evQmH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gLhnW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ var locale = {
    code: 'eo',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"9JUwe","./_lib/formatLong/index.js":"fz9GN","./_lib/formatRelative/index.js":"8H6PU","./_lib/localize/index.js":"6kt5V","./_lib/match/index.js":"hReyj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9JUwe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'malpli ol sekundo',
        other: 'malpli ol {{count}} sekundoj'
    },
    xSeconds: {
        one: '1 sekundo',
        other: '{{count}} sekundoj'
    },
    halfAMinute: 'duonminuto',
    lessThanXMinutes: {
        one: 'malpli ol minuto',
        other: 'malpli ol {{count}} minutoj'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutoj'
    },
    aboutXHours: {
        one: 'proksimume 1 horo',
        other: 'proksimume {{count}} horoj'
    },
    xHours: {
        one: '1 horo',
        other: '{{count}} horoj'
    },
    xDays: {
        one: '1 tago',
        other: '{{count}} tagoj'
    },
    aboutXMonths: {
        one: 'proksimume 1 monato',
        other: 'proksimume {{count}} monatoj'
    },
    xWeeks: {
        one: '1 semajno',
        other: '{{count}} semajnoj'
    },
    aboutXWeeks: {
        one: 'proksimume 1 semajno',
        other: 'proksimume {{count}} semajnoj'
    },
    xMonths: {
        one: '1 monato',
        other: '{{count}} monatoj'
    },
    aboutXYears: {
        one: 'proksimume 1 jaro',
        other: 'proksimume {{count}} jaroj'
    },
    xYears: {
        one: '1 jaro',
        other: '{{count}} jaroj'
    },
    overXYears: {
        one: 'pli ol 1 jaro',
        other: 'pli ol {{count}} jaroj'
    },
    almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) return 'post ' + result;
        else return "anta\u016D " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fz9GN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: 'y-MMMM-dd',
    medium: 'y-MMM-dd',
    short: 'yyyy-MM-dd'
};
var timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8H6PU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hiera\u016D je' p",
    today: "'hodia\u016D je' p",
    tomorrow: "'morga\u016D je' p",
    nextWeek: "eeee 'je' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kt5V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'aK',
        'pK'
    ],
    abbreviated: [
        'a.K.E.',
        'p.K.E.'
    ],
    wide: [
        "anta\u016D Komuna Erao",
        'Komuna Erao'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1-a kvaronjaro',
        '2-a kvaronjaro',
        '3-a kvaronjaro',
        '4-a kvaronjaro'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        "a\u016Dg",
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januaro',
        'februaro',
        'marto',
        'aprilo',
        'majo',
        'junio',
        'julio',
        "a\u016Dgusto",
        'septembro',
        'oktobro',
        'novembro',
        'decembro'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        "\u0134",
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        "\u0135a",
        've',
        'sa'
    ],
    abbreviated: [
        'dim',
        'lun',
        'mar',
        'mer',
        "\u0135a\u016D",
        'ven',
        'sab'
    ],
    wide: [
        "diman\u0109o",
        'lundo',
        'mardo',
        'merkredo',
        "\u0135a\u016Ddo",
        'vendredo',
        'sabato'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    abbreviated: {
        am: 'a.t.m.',
        pm: 'p.t.m.',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    wide: {
        am: "anta\u016Dtagmeze",
        pm: 'posttagmeze',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '-a';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hReyj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
var parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jCVgz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var locale = {
    code: 'es',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"doI49","./_lib/formatLong/index.js":"gHxyu","./_lib/formatRelative/index.js":"01w35","./_lib/localize/index.js":"btkQs","./_lib/match/index.js":"bryYA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"doI49":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de un segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos de un minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'alrededor de 1 semana',
        other: 'alrededor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hace ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHxyu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"01w35":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    else return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btkQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        "despu\xe9s de cristo"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
    ],
    wide: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]
};
var dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'mi',
        'ju',
        'vi',
        "s\xe1"
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        "mi\xe9",
        'jue',
        'vie',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'lunes',
        'martes',
        "mi\xe9rcoles",
        'jueves',
        'viernes',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bryYA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"899KZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var locale = {
    code: 'et',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"bkk7A","./_lib/formatLong/index.js":"7Zqv7","./_lib/formatRelative/index.js":"jmUt7","./_lib/localize/index.js":"8GZTM","./_lib/match/index.js":"abvhK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bkk7A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: '{{count}} sekundit'
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: '{{count}} sekundi'
        }
    },
    halfAMinute: {
        standalone: 'pool minutit',
        withPreposition: 'poole minuti'
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: '{{count}} minutit'
        },
        withPreposition: {
            one: "\xfche minuti",
            other: '{{count}} minuti'
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: 'umbes {{count}} tundi'
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: 'umbes {{count}} tunni'
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: '{{count}} tundi'
        },
        withPreposition: {
            one: "\xfche tunni",
            other: '{{count}} tunni'
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: 'umbes {{count}} kuud'
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: 'umbes {{count}} kuu'
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: '{{count}} kuud'
        },
        withPreposition: {
            one: "\xfche kuu",
            other: '{{count}} kuu'
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: 'umbes {{count}} aastat'
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: 'umbes {{count}} aasta'
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: '{{count}} aastat'
        },
        withPreposition: {
            one: "\xfche aasta",
            other: '{{count}} aasta'
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: 'rohkem kui {{count}} aastat'
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: 'rohkem kui {{count}} aasta'
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: 'peaaegu {{count}} aastat'
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: 'peaaegu {{count}} aasta'
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + ' eest';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Zqv7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: '{{date}}. {{time}}',
    short: '{{date}}. {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jmUt7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8GZTM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'e.m.a',
        'm.a.j'
    ],
    abbreviated: [
        'e.m.a',
        'm.a.j'
    ],
    wide: [
        'enne meie ajaarvamist',
        "meie ajaarvamise j\xe4rgi"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'V',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jaan',
        'veebr',
        "m\xe4rts",
        'apr',
        'mai',
        'juuni',
        'juuli',
        'aug',
        'sept',
        'okt',
        'nov',
        'dets'
    ],
    wide: [
        'jaanuar',
        'veebruar',
        "m\xe4rts",
        'aprill',
        'mai',
        'juuni',
        'juuli',
        'august',
        'september',
        'oktoober',
        'november',
        'detsember'
    ]
};
var dayValues = {
    narrow: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    short: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    abbreviated: [
        "p\xfchap.",
        'esmasp.',
        'teisip.',
        'kolmap.',
        'neljap.',
        'reede.',
        'laup.'
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        'reede',
        "laup\xe4ev"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: monthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: dayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"abvhK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^\d+\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3BKqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
 */ var locale = {
    code: 'eu',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"4cTry","./_lib/formatLong/index.js":"cBDKZ","./_lib/formatRelative/index.js":"h6q8y","./_lib/localize/index.js":"cWW1n","./_lib/match/index.js":"6hN9E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4cTry":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'segundo bat baino gutxiago',
        other: '{{count}} segundo baino gutxiago'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundo'
    },
    halfAMinute: 'minutu erdi',
    lessThanXMinutes: {
        one: 'minutu bat baino gutxiago',
        other: '{{count}} minutu baino gutxiago'
    },
    xMinutes: {
        one: '1 minutu',
        other: '{{count}} minutu'
    },
    aboutXHours: {
        one: '1 ordu gutxi gorabehera',
        other: '{{count}} ordu gutxi gorabehera'
    },
    xHours: {
        one: '1 ordu',
        other: '{{count}} ordu'
    },
    xDays: {
        one: '1 egun',
        other: '{{count}} egun'
    },
    aboutXWeeks: {
        one: 'aste 1 inguru',
        other: '{{count}} aste inguru'
    },
    xWeeks: {
        one: '1 aste',
        other: '{{count}} astean'
    },
    aboutXMonths: {
        one: '1 hilabete gutxi gorabehera',
        other: '{{count}} hilabete gutxi gorabehera'
    },
    xMonths: {
        one: '1 hilabete',
        other: '{{count}} hilabete'
    },
    aboutXYears: {
        one: '1 urte gutxi gorabehera',
        other: '{{count}} urte gutxi gorabehera'
    },
    xYears: {
        one: '1 urte',
        other: '{{count}} urte'
    },
    overXYears: {
        one: '1 urte baino gehiago',
        other: '{{count}} urte baino gehiago'
    },
    almostXYears: {
        one: 'ia 1 urte',
        other: 'ia {{count}} urte'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'duela ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cBDKZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: 'y MMM d',
    short: 'yy/MM/dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h6q8y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cWW1n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'k.a.',
        'k.o.'
    ],
    abbreviated: [
        'k.a.',
        'k.o.'
    ],
    wide: [
        'kristo aurretik',
        'kristo ondoren'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1H',
        '2H',
        '3H',
        '4H'
    ],
    wide: [
        '1. hiruhilekoa',
        '2. hiruhilekoa',
        '3. hiruhilekoa',
        '4. hiruhilekoa'
    ]
};
var monthValues = {
    narrow: [
        'u',
        'o',
        'm',
        'a',
        'm',
        'e',
        'u',
        'a',
        'i',
        'u',
        'a',
        'a'
    ],
    abbreviated: [
        'urt',
        'ots',
        'mar',
        'api',
        'mai',
        'eka',
        'uzt',
        'abu',
        'ira',
        'urr',
        'aza',
        'abe'
    ],
    wide: [
        'urtarrila',
        'otsaila',
        'martxoa',
        'apirila',
        'maiatza',
        'ekaina',
        'uztaila',
        'abuztua',
        'iraila',
        'urria',
        'azaroa',
        'abendua'
    ]
};
var dayValues = {
    narrow: [
        'i',
        'a',
        'a',
        'a',
        'o',
        'o',
        'l'
    ],
    short: [
        'ig',
        'al',
        'as',
        'az',
        'og',
        'or',
        'lr'
    ],
    abbreviated: [
        'iga',
        'ast',
        'ast',
        'ast',
        'ost',
        'ost',
        'lar'
    ],
    wide: [
        'igandea',
        'astelehena',
        'asteartea',
        'asteazkena',
        'osteguna',
        'ostirala',
        'larunbata'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6hN9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
var parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
var parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
var matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
var parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4FsED":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
 */ var locale = {
    code: 'fa-IR',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"3eRMy","./_lib/formatLong/index.js":"64nmC","./_lib/formatRelative/index.js":"9Fqwn","./_lib/localize/index.js":"9pCXK","./_lib/match/index.js":"8dNiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3eRMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"64nmC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'yyyy/MM/dd'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Fqwn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9pCXK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "\u0698",
        "\u0641",
        "\u0645",
        "\u0622",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0622",
        "\u0633",
        "\u0627",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u0698\u0627\u0646\u0640",
        "\u0641\u0648\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0640",
        "\u0622\u06AF\u0648",
        "\u0633\u067E\u062A\u0640",
        "\u0627\u06A9\u062A\u0640",
        "\u0646\u0648\u0627\u0645\u0640",
        "\u062F\u0633\u0627\u0645\u0640"
    ],
    wide: [
        "\u0698\u0627\u0646\u0648\u06CC\u0647",
        "\u0641\u0648\u0631\u06CC\u0647",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631\u06CC\u0644",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u06CC",
        "\u0622\u06AF\u0648\u0633\u062A",
        "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0628\u0631",
        "\u0646\u0648\u0627\u0645\u0628\u0631",
        "\u062F\u0633\u0627\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8dNiY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
var parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
var matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGMC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var locale = {
    code: 'fi',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"21OHu","./_lib/formatLong/index.js":"dE4i6","./_lib/formatRelative/index.js":"7H9ZJ","./_lib/localize/index.js":"8k0RQ","./_lib/match/index.js":"hkhEW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21OHu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function futureSeconds(text) {
    return text.replace(/sekuntia?/, 'sekunnin');
}
function futureMinutes(text) {
    return text.replace(/minuuttia?/, 'minuutin');
}
function futureHours(text) {
    return text.replace(/tuntia?/, 'tunnin');
}
function futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, 'viikon');
}
function futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
}
function futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, 'vuoden');
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'alle sekunti',
        other: 'alle {{count}} sekuntia',
        futureTense: futureSeconds
    },
    xSeconds: {
        one: 'sekunti',
        other: '{{count}} sekuntia',
        futureTense: futureSeconds
    },
    halfAMinute: {
        one: 'puoli minuuttia',
        other: 'puoli minuuttia',
        futureTense: function futureTense(_text) {
            return 'puolen minuutin';
        }
    },
    lessThanXMinutes: {
        one: 'alle minuutti',
        other: 'alle {{count}} minuuttia',
        futureTense: futureMinutes
    },
    xMinutes: {
        one: 'minuutti',
        other: '{{count}} minuuttia',
        futureTense: futureMinutes
    },
    aboutXHours: {
        one: 'noin tunti',
        other: 'noin {{count}} tuntia',
        futureTense: futureHours
    },
    xHours: {
        one: 'tunti',
        other: '{{count}} tuntia',
        futureTense: futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: futureDays
    },
    aboutXWeeks: {
        one: 'noin viikko',
        other: 'noin {{count}} viikkoa',
        futureTense: futureWeeks
    },
    xWeeks: {
        one: 'viikko',
        other: '{{count}} viikkoa',
        futureTense: futureWeeks
    },
    aboutXMonths: {
        one: 'noin kuukausi',
        other: 'noin {{count}} kuukautta',
        futureTense: futureMonths
    },
    xMonths: {
        one: 'kuukausi',
        other: '{{count}} kuukautta',
        futureTense: futureMonths
    },
    aboutXYears: {
        one: 'noin vuosi',
        other: 'noin {{count}} vuotta',
        futureTense: futureYears
    },
    xYears: {
        one: 'vuosi',
        other: '{{count}} vuotta',
        futureTense: futureYears
    },
    overXYears: {
        one: 'yli vuosi',
        other: 'yli {{count}} vuotta',
        futureTense: futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: futureYears
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var tokenValue = formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + ' kuluttua';
        else return result + ' sitten';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dE4i6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'eeee d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'd.M.y'
};
var timeFormats = {
    full: 'HH.mm.ss zzzz',
    long: 'HH.mm.ss z',
    medium: 'HH.mm.ss',
    short: 'HH.mm'
};
var dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7H9ZJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8k0RQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'eaa.',
        'jaa.'
    ],
    abbreviated: [
        'eaa.',
        'jaa.'
    ],
    wide: [
        'ennen ajanlaskun alkua',
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartaali',
        '2. kvartaali',
        '3. kvartaali',
        '4. kvartaali'
    ]
};
var monthValues = {
    narrow: [
        'T',
        'H',
        'M',
        'H',
        'T',
        'K',
        'H',
        'E',
        'S',
        'L',
        'M',
        'J'
    ],
    abbreviated: [
        'tammi',
        'helmi',
        'maalis',
        'huhti',
        'touko',
        "kes\xe4",
        "hein\xe4",
        'elo',
        'syys',
        'loka',
        'marras',
        'joulu'
    ],
    wide: [
        'tammikuu',
        'helmikuu',
        'maaliskuu',
        'huhtikuu',
        'toukokuu',
        "kes\xe4kuu",
        "hein\xe4kuu",
        'elokuu',
        'syyskuu',
        'lokakuu',
        'marraskuu',
        'joulukuu'
    ]
};
var formattingMonthValues = {
    narrow: monthValues.narrow,
    abbreviated: monthValues.abbreviated,
    wide: [
        'tammikuuta',
        'helmikuuta',
        'maaliskuuta',
        'huhtikuuta',
        'toukokuuta',
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        'elokuuta',
        'syyskuuta',
        'lokakuuta',
        'marraskuuta',
        'joulukuuta'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'K',
        'T',
        'P',
        'L'
    ],
    short: [
        'su',
        'ma',
        'ti',
        'ke',
        'to',
        'pe',
        'la'
    ],
    abbreviated: [
        'sunn.',
        'maan.',
        'tiis.',
        'kesk.',
        'torst.',
        'perj.',
        'la'
    ],
    wide: [
        'sunnuntai',
        'maanantai',
        'tiistai',
        'keskiviikko',
        'torstai',
        'perjantai',
        'lauantai'
    ]
};
var formattingDayValues = {
    narrow: dayValues.narrow,
    short: dayValues.short,
    abbreviated: dayValues.abbreviated,
    wide: [
        'sunnuntaina',
        'maanantaina',
        'tiistaina',
        'keskiviikkona',
        'torstaina',
        'perjantaina',
        'lauantaina'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hkhEW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dEe2x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var locale = {
    code: 'fr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"cTXSJ","./_lib/formatLong/index.js":"99R8e","./_lib/formatRelative/index.js":"7SGGp","./_lib/localize/index.js":"6FysQ","./_lib/match/index.js":"flrvi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cTXSJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99R8e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7SGGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6FysQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"flrvi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k4r7J":[function(require,module,exports,__globalThis) {
// Same as fr
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../fr/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../fr/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../fr/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../fr/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
// Unique for fr-CA
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
 */ var locale = {
    code: 'fr-CA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"../fr/_lib/formatDistance/index.js":"cTXSJ","../fr/_lib/formatRelative/index.js":"7SGGp","../fr/_lib/localize/index.js":"6FysQ","../fr/_lib/match/index.js":"flrvi","./_lib/formatLong/index.js":"01EwZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"01EwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5JnNz":[function(require,module,exports,__globalThis) {
// Same as fr
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../fr/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../fr/_lib/localize/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../fr/_lib/match/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
// Unique for fr-CH
var _indexJs3 = require("./_lib/formatLong/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatRelative/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var locale = {
    code: 'fr-CH',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault3.default),
    formatRelative: (0, _indexJsDefault4.default),
    localize: (0, _indexJsDefault1.default),
    match: (0, _indexJsDefault2.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../fr/_lib/formatDistance/index.js":"cTXSJ","../fr/_lib/localize/index.js":"6FysQ","../fr/_lib/match/index.js":"flrvi","./_lib/formatLong/index.js":"lcig0","./_lib/formatRelative/index.js":"imUEr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcig0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imUEr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HEQq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02]{@link https://github.com/damon02}
 */ var locale = {
    code: 'fy',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dRMIG","./_lib/formatLong/index.js":"c6f0S","./_lib/formatRelative/index.js":"8BiZC","./_lib/localize/index.js":"dYv8A","./_lib/match/index.js":"3H7ux","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dRMIG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder as 1 sekonde',
        other: 'minder as {{count}} sekonden'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekonden'
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: 'minder as {{count}} minuten'
    },
    xMinutes: {
        one: "1 min\xfat",
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'sawat 1 oere',
        other: 'sawat {{count}} oere'
    },
    xHours: {
        one: '1 oere',
        other: '{{count}} oere'
    },
    xDays: {
        one: '1 dei',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'sawat 1 wike',
        other: 'sawat {{count}} wiken'
    },
    xWeeks: {
        one: '1 wike',
        other: '{{count}} wiken'
    },
    aboutXMonths: {
        one: 'sawat 1 moanne',
        other: 'sawat {{count}} moannen'
    },
    xMonths: {
        one: '1 moanne',
        other: '{{count}} moannen'
    },
    aboutXYears: {
        one: 'sawat 1 jier',
        other: 'sawat {{count}} jier'
    },
    xYears: {
        one: '1 jier',
        other: '{{count}} jier'
    },
    overXYears: {
        one: 'mear as 1 jier',
        other: 'mear as {{count}}s jier'
    },
    almostXYears: {
        one: 'hast 1 jier',
        other: 'hast {{count}} jier'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oer ' + result;
        else return result + ' lyn';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6f0S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8BiZC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYv8A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.K.',
        'n.K.'
    ],
    abbreviated: [
        'f.Kr.',
        'n.Kr.'
    ],
    wide: [
        'foar Kristus',
        'nei Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e fearnsjier',
        '2e fearnsjier',
        '3e fearnsjier',
        '4e fearnsjier'
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mai.',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'jannewaris',
        'febrewaris',
        'maart',
        'april',
        'maaie',
        'juny',
        'july',
        'augustus',
        'septimber',
        'oktober',
        'novimber',
        'desimber'
    ]
};
var dayValues = {
    narrow: [
        's',
        'm',
        't',
        'w',
        't',
        'f',
        's'
    ],
    short: [
        'si',
        'mo',
        'ti',
        'wo',
        'to',
        'fr',
        'so'
    ],
    abbreviated: [
        'snein',
        'moa',
        'tii',
        'woa',
        'ton',
        'fre',
        'sneon'
    ],
    wide: [
        'snein',
        'moandei',
        'tiisdei',
        'woansdei',
        'tongersdei',
        'freed',
        'sneon'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3H7ux":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
var parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5gutn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
 */ var locale = {
    code: 'gd',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"eXerc","./_lib/formatLong/index.js":"6Ta5U","./_lib/formatRelative/index.js":"iVZdl","./_lib/localize/index.js":"5cbvE","./_lib/match/index.js":"cDyJ7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eXerc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'nas lugha na diog',
        other: 'nas lugha na {{count}} diogan'
    },
    xSeconds: {
        one: '1 diog',
        two: '2 dhiog',
        twenty: '20 diog',
        other: '{{count}} diogan'
    },
    halfAMinute: 'leth mhionaid',
    lessThanXMinutes: {
        one: 'nas lugha na mionaid',
        other: 'nas lugha na {{count}} mionaidean'
    },
    xMinutes: {
        one: '1 mionaid',
        two: '2 mhionaid',
        twenty: '20 mionaid',
        other: '{{count}} mionaidean'
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: 'mu 1 seachdain',
        other: 'mu {{count}} seachdainean'
    },
    xWeeks: {
        one: '1 seachdain',
        other: '{{count}} seachdainean'
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: 'mu bhliadhna',
        other: 'mu {{count}} bliadhnaichean'
    },
    xYears: {
        one: '1 bhliadhna',
        other: '{{count}} bliadhna'
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'ann an ' + result;
        else return 'o chionn ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Ta5U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iVZdl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    //FIX
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5cbvE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'R',
        'A'
    ],
    abbreviated: [
        'RC',
        'AD'
    ],
    wide: [
        "ro Chr\xecosta",
        'anno domini'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'C1',
        'C2',
        'C3',
        'C4'
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        'an treas cairteal',
        'an ceathramh cairteal'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'F',
        'G',
        'M',
        'G',
        'C',
        "\xd2",
        'I',
        'L',
        'S',
        'D',
        'S',
        'D'
    ],
    abbreviated: [
        'Faoi',
        'Gear',
        "M\xe0rt",
        'Gibl',
        "C\xe8it",
        "\xd2gmh",
        'Iuch',
        "L\xf9n",
        'Sult',
        "D\xe0mh",
        'Samh',
        "D\xf9bh"
    ],
    wide: [
        'Am Faoilleach',
        'An Gearran',
        "Am M\xe0rt",
        'An Giblean',
        "An C\xe8itean",
        "An t-\xd2gmhios",
        'An t-Iuchar',
        "An L\xf9nastal",
        'An t-Sultain',
        "An D\xe0mhair",
        'An t-Samhain',
        "An D\xf9bhlachd"
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'C',
        'A',
        'H',
        'S'
    ],
    short: [
        "D\xf2",
        'Lu',
        "M\xe0",
        'Ci',
        'Ar',
        'Ha',
        'Sa'
    ],
    abbreviated: [
        'Did',
        'Dil',
        'Dim',
        'Dic',
        'Dia',
        'Dih',
        'Dis'
    ],
    wide: [
        "Did\xf2mhnaich",
        'Diluain',
        "Dim\xe0irt",
        'Diciadain',
        'Diardaoin',
        'Dihaoine',
        'Disathairne'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'd';
        case 2:
            return number + 'na';
    }
    if (rem100 === 12) return number + 'na';
    return number + 'mh';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cDyJ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
var parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aMwzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
 */ var locale = {
    code: 'gl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"9ZzMd","./_lib/formatLong/index.js":"3B7OT","./_lib/formatRelative/index.js":"b2RzQ","./_lib/localize/index.js":"1JP4N","./_lib/match/index.js":"3ME5v","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ZzMd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos dun segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos dun minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'arredor dunha hora',
        other: 'arredor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'arredor dunha semana',
        other: 'arredor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'arredor de 1 mes',
        other: 'arredor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'arredor dun ano',
        other: 'arredor de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: 'case un ano',
        other: 'case {{count}} anos'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hai ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3B7OT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b2RzQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1JP4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'despois de cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'xan',
        'feb',
        'mar',
        'abr',
        'mai',
        'xun',
        'xul',
        'ago',
        'set',
        'out',
        'nov',
        'dec'
    ],
    wide: [
        'xaneiro',
        'febreiro',
        'marzo',
        'abril',
        'maio',
        "xu\xf1o",
        'xullo',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'decembro'
    ]
};
var dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'me',
        'xo',
        've',
        'sa'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'xov',
        'ven',
        'sab'
    ],
    wide: [
        'domingo',
        'luns',
        'martes',
        "m\xe9rcores",
        'xoves',
        'venres',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ME5v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1ngJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
 */ var locale = {
    code: 'gu',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"2Hd39","./_lib/formatLong/index.js":"5j9G4","./_lib/formatRelative/index.js":"iX48t","./_lib/localize/index.js":"3bK47","./_lib/match/index.js":"j8DGL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Hd39":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        // CLDR #1461
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
    lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        // CLDR #1448
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
    },
    aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
    },
    almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0AAE\u0ABE\u0A82";
        else return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5j9G4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); //Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM, y',
    // CLDR #1825
    long: 'd MMMM, y',
    // CLDR #1826
    medium: 'd MMM, y',
    // CLDR #1827
    short: 'd/M/yy' // CLDR #1828
};
var timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR #1829
    long: 'hh:mm:ss a z',
    // CLDR #1830
    medium: 'hh:mm:ss a',
    // CLDR #1831
    short: 'hh:mm a' // CLDR #1832
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR #1833
    long: '{{date}} {{time}}',
    // CLDR #1834
    medium: '{{date}} {{time}}',
    // CLDR #1835
    short: '{{date}} {{time}}' // CLDR #1836
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iX48t":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
    // CLDR #1384
    yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1409
    today: "'\u0A86\u0A9C\u0AC7' p",
    // CLDR #1410
    tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1411
    nextWeek: 'eeee p',
    // CLDR #1386
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3bK47":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // https://www.unicode.org/cldr/charts/32/summary/gu.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// #1621 - #1630
var eraValues = {
    narrow: [
        "\u0A88\u0AB8\u0AAA\u0AC2",
        "\u0A88\u0AB8"
    ],
    abbreviated: [
        "\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88.\u0AB8."
    ],
    wide: [
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
var monthValues = {
    narrow: [
        "\u0A9C\u0ABE",
        "\u0AAB\u0AC7",
        "\u0AAE\u0ABE",
        "\u0A8F",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2",
        "\u0A9C\u0AC1",
        "\u0A93",
        "\u0AB8",
        "\u0A93",
        "\u0AA8",
        "\u0AA1\u0ABF"
    ],
    abbreviated: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
        "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
        "\u0AA8\u0AB5\u0AC7",
        "\u0AA1\u0ABF\u0AB8\u0AC7"
    ],
    wide: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
        "\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
        "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
var dayValues = {
    narrow: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    short: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    abbreviated: [
        "\u0AB0\u0AB5\u0ABF",
        "\u0AB8\u0ACB\u0AAE",
        "\u0AAE\u0A82\u0A97\u0AB3",
        "\u0AAC\u0AC1\u0AA7",
        "\u0A97\u0AC1\u0AB0\u0AC1",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0",
        "\u0AB6\u0AA8\u0ABF"
    ],
    wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0" /* Sunday */ ,
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0" /* Monday */ ,
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0" /* Tuesday */ ,
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0" /* Wednesday */ ,
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0" /* Thursday */ ,
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0" /* Friday */ ,
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j8DGL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
var parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
var parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
var parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"37xwP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
 */ var locale = {
    code: 'he',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"jZWJP","./_lib/formatLong/index.js":"cs94C","./_lib/formatRelative/index.js":"lap2H","./_lib/localize/index.js":"4uJ3c","./_lib/match/index.js":"baLP1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jZWJP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
    lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
    },
    aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    // Return word instead of `in one day` or `one day ago`
    if (token === 'xDays' && options !== null && options !== void 0 && options.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
    }
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u05D1\u05E2\u05D5\u05D3 " + result;
        else return "\u05DC\u05E4\u05E0\u05D9 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cs94C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d \u05D1MMMM y",
    long: "d \u05D1MMMM y",
    medium: "d \u05D1MMM y",
    short: 'd.M.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lap2H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
    today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
    tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4uJ3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    abbreviated: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    wide: [
        "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u05E8\u05D1\u05E2\u05D5\u05DF 1",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 2",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 3",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 4"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "\u05D9\u05E0\u05D5\u05F3",
        "\u05E4\u05D1\u05E8\u05F3",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05F3",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05F3",
        "\u05E1\u05E4\u05D8\u05F3",
        "\u05D0\u05D5\u05E7\u05F3",
        "\u05E0\u05D5\u05D1\u05F3",
        "\u05D3\u05E6\u05DE\u05F3"
    ],
    wide: [
        "\u05D9\u05E0\u05D5\u05D0\u05E8",
        "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05D9\u05DC",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
        "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
        "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
        "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
        "\u05D3\u05E6\u05DE\u05D1\u05E8"
    ]
};
var dayValues = {
    narrow: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    short: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    abbreviated: [
        "\u05D9\u05D5\u05DD \u05D0\u05F3",
        "\u05D9\u05D5\u05DD \u05D1\u05F3",
        "\u05D9\u05D5\u05DD \u05D2\u05F3",
        "\u05D9\u05D5\u05DD \u05D3\u05F3",
        "\u05D9\u05D5\u05DD \u05D4\u05F3",
        "\u05D9\u05D5\u05DD \u05D5\u05F3",
        "\u05E9\u05D1\u05EA"
    ],
    wide: [
        "\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var isFemale = [
        'year',
        'hour',
        'minute',
        'second'
    ].indexOf(unit) >= 0;
    var male = [
        "\u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05E9\u05E0\u05D9",
        "\u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05E9\u05D9\u05E9\u05D9",
        "\u05E9\u05D1\u05D9\u05E2\u05D9",
        "\u05E9\u05DE\u05D9\u05E0\u05D9",
        "\u05EA\u05E9\u05D9\u05E2\u05D9",
        "\u05E2\u05E9\u05D9\u05E8\u05D9"
    ];
    var female = [
        "\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
        "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
        "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
        "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"
    ];
    var index = number - 1;
    return isFemale ? female[index] : male[index];
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"baLP1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
var parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
var matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
var parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
var parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
var matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
var parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
var ordinalName = [
    "\u05E8\u05D0",
    "\u05E9\u05E0",
    "\u05E9\u05DC",
    "\u05E8\u05D1",
    "\u05D7",
    "\u05E9\u05D9",
    "\u05E9\u05D1",
    "\u05E9\u05DE",
    "\u05EA",
    "\u05E2"
];
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            var number = parseInt(value, 10);
            return isNaN(number) ? ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"70r0G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
 */ var locale = {
    code: 'hi',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"b68YW","./_lib/formatLong/index.js":"2WNaU","./_lib/formatRelative/index.js":"a0GID","./_lib/localize/index.js":"6t52l","./_lib/match/index.js":"5Ecph","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b68YW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../localize/index.js"); // Source: https://www.unicode.org/cldr/charts/32/summary/hi.html
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        // CLDR #1310
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
    },
    xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
    },
    halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
    lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
    },
    xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        // CLDR #1307
        other: "{{count}} \u092E\u093F\u0928\u091F"
    },
    aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
    },
    xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        // CLDR #1304
        other: "{{count}} \u0918\u0902\u091F\u0947" // CLDR #4467
    },
    xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        // CLDR #1286
        other: "{{count}} \u0926\u093F\u0928"
    },
    aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937" // CLDR #4823
    },
    xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
    },
    overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
    },
    almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, _indexJs.numberToLocale)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u092E\u0947 ";
        else return result + " \u092A\u0939\u0932\u0947";
    }
    return result;
};
exports.default = formatDistance;

},{"../localize/index.js":"6t52l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6t52l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localeToNumber", ()=>localeToNumber);
parcelHelpers.export(exports, "numberToLocale", ()=>numberToLocale);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var numberValues = {
    locale: {
        '1': "\u0967",
        '2': "\u0968",
        '3': "\u0969",
        '4': "\u096A",
        '5': "\u096B",
        '6': "\u096C",
        '7': "\u096D",
        '8': "\u096E",
        '9': "\u096F",
        '0': "\u0966"
    },
    number: {
        "\u0967": '1',
        "\u0968": '2',
        "\u0969": '3',
        "\u096A": '4',
        "\u096B": '5',
        "\u096C": '6',
        "\u096D": '7',
        "\u096E": '8',
        "\u096F": '9',
        "\u0966": '0'
    }
};
// CLDR #1585 - #1592
var eraValues = {
    narrow: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    abbreviated: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    wide: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u0935\u0940 \u0938\u0928"
    ]
};
// CLDR #1593 - #1616
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0924\u093F1",
        "\u0924\u093F2",
        "\u0924\u093F3",
        "\u0924\u093F4"
    ],
    wide: [
        "\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
var monthValues = {
    narrow: [
        "\u091C",
        "\u092B\u093C",
        "\u092E\u093E",
        "\u0905",
        "\u092E\u0908",
        "\u091C\u0942",
        "\u091C\u0941",
        "\u0905\u0917",
        "\u0938\u093F",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928",
        "\u0926\u093F"
    ],
    abbreviated: [
        "\u091C\u0928",
        "\u092B\u093C\u0930",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932",
        "\u0905\u0917",
        "\u0938\u093F\u0924",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928\u0935",
        "\u0926\u093F\u0938"
    ],
    wide: [
        "\u091C\u0928\u0935\u0930\u0940",
        "\u092B\u093C\u0930\u0935\u0930\u0940",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932\u093E\u0908",
        "\u0905\u0917\u0938\u094D\u0924",
        "\u0938\u093F\u0924\u0902\u092C\u0930",
        "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
        "\u0928\u0935\u0902\u092C\u0930",
        "\u0926\u093F\u0938\u0902\u092C\u0930"
    ]
};
// CLDR #1689 - #1744
var dayValues = {
    narrow: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    short: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    abbreviated: [
        "\u0930\u0935\u093F",
        "\u0938\u094B\u092E",
        "\u092E\u0902\u0917\u0932",
        "\u092C\u0941\u0927",
        "\u0917\u0941\u0930\u0941",
        "\u0936\u0941\u0915\u094D\u0930",
        "\u0936\u0928\u093F"
    ],
    wide: [
        "\u0930\u0935\u093F\u0935\u093E\u0930",
        "\u0938\u094B\u092E\u0935\u093E\u0930",
        "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
        "\u092C\u0941\u0927\u0935\u093E\u0930",
        "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
        "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
        "\u0936\u0928\u093F\u0935\u093E\u0930"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return numberToLocale(number);
};
function localeToNumber(locale) {
    var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return numberValues.number[match];
    });
    return Number(enNumber);
}
function numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return numberValues.locale[match];
    });
}
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2WNaU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    // CLDR #1787
    long: 'do MMMM, y',
    // CLDR #1788
    medium: 'd MMM, y',
    // CLDR #1789
    short: 'dd/MM/yyyy' // CLDR #1790
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    // CLDR #1791
    long: 'h:mm:ss a z',
    // CLDR #1792
    medium: 'h:mm:ss a',
    // CLDR #1793
    short: 'h:mm a' // CLDR #1794
};
var dateTimeFormats = {
    full: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1795
    long: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1796
    medium: '{{date}}, {{time}}',
    // CLDR #1797
    short: '{{date}}, {{time}}' // CLDR #1798
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a0GID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
    yesterday: "'\u0915\u0932' p",
    today: "'\u0906\u091C' p",
    tomorrow: "'\u0915\u0932' p",
    nextWeek: "eeee '\u0915\u094B' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Ecph":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../localize/index.js");
var matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
var matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: (0, _indexJs2.localeToNumber)
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","../localize/index.js":"6t52l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2nDgv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
 * @author Manico [@manico]{@link https://github.com/manico}
 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
 */ var locale = {
    code: 'hr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"booBl","./_lib/formatLong/index.js":"8qOg7","./_lib/formatRelative/index.js":"4Tkwc","./_lib/localize/index.js":"hWRkV","./_lib/match/index.js":"54PL8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"booBl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 tjedan',
            withPrepositionAgo: 'oko 1 tjedan',
            withPrepositionIn: 'oko 1 tjedan'
        },
        dual: 'oko {{count}} tjedna',
        other: 'oko {{count}} tjedana'
    },
    xWeeks: {
        one: {
            standalone: '1 tjedan',
            withPrepositionAgo: '1 tjedan',
            withPrepositionIn: '1 tjedan'
        },
        dual: '{{count}} tjedna',
        other: '{{count}} tjedana'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8qOg7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM y.',
    long: 'd. MMMM y.',
    medium: 'd. MMM y.',
    short: 'dd. MM. y.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Tkwc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hWRkV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Kr.',
        'po. Kr.'
    ],
    wide: [
        'Prije Krista',
        'Poslije Krista'
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        'travanj',
        'svibanj',
        'lipanj',
        'srpanj',
        'kolovoz',
        'rujan',
        'listopad',
        'studeni',
        'prosinac'
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        'travnja',
        'svibnja',
        'lipnja',
        'srpnja',
        'kolovoza',
        'rujna',
        'listopada',
        'studenog',
        'prosinca'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"54PL8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
var parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WCNE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
 */ var locale = {
    code: 'ht',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"duLk8","./_lib/formatLong/index.js":"e4m07","./_lib/formatRelative/index.js":"lss5l","./_lib/localize/index.js":"6trvU","./_lib/match/index.js":"1PUJF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"duLk8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mwens pase yon segond',
        other: 'mwens pase {{count}} segond'
    },
    xSeconds: {
        one: '1 segond',
        other: '{{count}} segond'
    },
    halfAMinute: '30 segond',
    lessThanXMinutes: {
        one: 'mwens pase yon minit',
        other: 'mwens pase {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: '1 jou',
        other: '{{count}} jou'
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: 'anviwon 1 mwa',
        other: 'anviwon {{count}} mwa'
    },
    xMonths: {
        one: '1 mwa',
        other: '{{count}} mwa'
    },
    aboutXYears: {
        one: 'anviwon 1 an',
        other: 'anviwon {{count}} an'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} an'
    },
    overXYears: {
        one: 'plis pase 1 an',
        other: 'plis pase {{count}} an'
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'nan ' + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e4m07":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lss5l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6trvU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'av. J.-K',
        'ap. J.-K'
    ],
    abbreviated: [
        'av. J.-K',
        'ap. J.-K'
    ],
    wide: [
        'anvan Jezi Kris',
        'apre Jezi Kris'
    ]
};
var quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1ye trim.',
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'fevr.',
        'mas',
        'avr.',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'sept.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'janvye',
        'fevrye',
        'mas',
        'avril',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'septanm',
        "okt\xf2b",
        'novanm',
        'desanm'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'le',
        'ma',
        "m\xe8",
        'je',
        'va',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'len.',
        'mad.',
        "m\xe8k.",
        'jed.',
        'van.',
        'sam.'
    ],
    wide: [
        'dimanch',
        'lendi',
        'madi',
        "m\xe8kredi",
        'jedi',
        'vandredi',
        'samdi'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'swa',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'maten',
        afternoon: "apr\xe8midi",
        evening: 'swa',
        night: 'maten'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'nan maten',
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: 'nan maten'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number === 0) return String(number);
    var suffix = number === 1 ? 'ye' : "y\xe8m";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1PUJF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
var parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dFFH1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var locale = {
    code: 'hu',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"eULYe","./_lib/formatLong/index.js":"eTFjR","./_lib/formatRelative/index.js":"iFs6h","./_lib/localize/index.js":"cl0PN","./_lib/match/index.js":"g2GCh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eULYe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: 'majdnem',
    lessthan: 'kevesebb mint'
};
var withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: ' perc',
    xhours: " \xf3ra",
    xdays: ' nap',
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var withSuffixes = {
    xseconds: {
        '-1': " m\xe1sodperccel ezel\u0151tt",
        '1': " m\xe1sodperc m\xfalva",
        '0': " m\xe1sodperce"
    },
    halfaminute: {
        '-1': "f\xe9l perccel ezel\u0151tt",
        '1': "f\xe9l perc m\xfalva",
        '0': "f\xe9l perce"
    },
    xminutes: {
        '-1': " perccel ezel\u0151tt",
        '1': " perc m\xfalva",
        '0': ' perce'
    },
    xhours: {
        '-1': " \xf3r\xe1val ezel\u0151tt",
        '1': " \xf3ra m\xfalva",
        '0': " \xf3r\xe1ja"
    },
    xdays: {
        '-1': " nappal ezel\u0151tt",
        '1': " nap m\xfalva",
        '0': ' napja'
    },
    xweeks: {
        '-1': " h\xe9ttel ezel\u0151tt",
        '1': " h\xe9t m\xfalva",
        '0': ' hete'
    },
    xmonths: {
        '-1': " h\xf3nappal ezel\u0151tt",
        '1': " h\xf3nap m\xfalva",
        '0': " h\xf3napja"
    },
    xyears: {
        '-1': " \xe9vvel ezel\u0151tt",
        '1': " \xe9v m\xfalva",
        '0': " \xe9ve"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];
    var result = key === 'halfaminute' ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = translations[adv] + ' ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eTFjR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'y. MMMM d., EEEE',
    long: 'y. MMMM d.',
    medium: 'y. MMM d.',
    short: 'y. MM. dd.'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iFs6h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    'kedden',
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    'szombaton'
];
function week(isFuture) {
    return function(date) {
        var weekday = accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? '' : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var formatRelativeLocale = {
    lastWeek: week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: week(true),
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cl0PN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'ie.',
        'isz.'
    ],
    abbreviated: [
        'i. e.',
        'i. sz.'
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var formattingQuarterValues = {
    narrow: [
        'I.',
        'II.',
        'III.',
        'IV.'
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        "\xc1",
        'M',
        'J',
        'J',
        'A',
        'Sz',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'febr.',
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        'aug.',
        'szept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        'augusztus',
        'szeptember',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'V',
        'H',
        'K',
        'Sz',
        'Cs',
        'P',
        'Sz'
    ],
    short: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    abbreviated: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        'kedd',
        'szerda',
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        'szombat'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    abbreviated: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    wide: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: "d\xe9lut\xe1n",
        evening: 'este',
        night: "\xe9jjel"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide'
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g2GCh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d3FLD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
 */ var locale = {
    code: 'hy',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"eeJFg","./_lib/formatLong/index.js":"k6yqJ","./_lib/formatRelative/index.js":"2ZD5R","./_lib/localize/index.js":"a3CYb","./_lib/match/index.js":"ko4sf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eeJFg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
    lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
    },
    xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
    },
    aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
    },
    xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
    },
    xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
    },
    aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
    },
    xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
    },
    aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
    },
    xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
    },
    overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
    },
    almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u0570\u0565\u057F\u0578";
        else return result + " \u0561\u057C\u0561\u057B";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k6yqJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'd MMMM, y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u056A\u2024'{{time}}",
    long: "{{date}} '\u056A\u2024'{{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ZD5R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
    today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
    tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
    nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a3CYb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0554",
        "\u0544"
    ],
    abbreviated: [
        "\u0554\u0531",
        "\u0544\u0539"
    ],
    wide: [
        "\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B",
        "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u05541",
        "\u05542",
        "\u05543",
        "\u05544"
    ],
    wide: [
        "1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564",
        "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"
    ]
};
var monthValues = {
    narrow: [
        "\u0540",
        "\u0553",
        "\u0544",
        "\u0531",
        "\u0544",
        "\u0540",
        "\u0540",
        "\u0555",
        "\u054D",
        "\u0540",
        "\u0546",
        "\u0534"
    ],
    abbreviated: [
        "\u0570\u0578\u0582\u0576",
        "\u0583\u0565\u057F",
        "\u0574\u0561\u0580",
        "\u0561\u057A\u0580",
        "\u0574\u0561\u0575",
        "\u0570\u0578\u0582\u0576",
        "\u0570\u0578\u0582\u056C",
        "\u0585\u0563\u057D",
        "\u057D\u0565\u057A",
        "\u0570\u0578\u056F",
        "\u0576\u0578\u0575",
        "\u0564\u0565\u056F"
    ],
    wide: [
        "\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
        "\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
        "\u0574\u0561\u0580\u057F",
        "\u0561\u057A\u0580\u056B\u056C",
        "\u0574\u0561\u0575\u056B\u057D",
        "\u0570\u0578\u0582\u0576\u056B\u057D",
        "\u0570\u0578\u0582\u056C\u056B\u057D",
        "\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
        "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
        "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
    ]
};
var dayValues = {
    narrow: [
        "\u053F",
        "\u0535",
        "\u0535",
        "\u0549",
        "\u0540",
        "\u0548",
        "\u0547"
    ],
    short: [
        "\u056F\u0580",
        "\u0565\u0580",
        "\u0565\u0584",
        "\u0579\u0584",
        "\u0570\u0563",
        "\u0578\u0582\u0580",
        "\u0577\u0562"
    ],
    abbreviated: [
        "\u056F\u056B\u0580",
        "\u0565\u0580\u056F",
        "\u0565\u0580\u0584",
        "\u0579\u0578\u0580",
        "\u0570\u0576\u0563",
        "\u0578\u0582\u0580\u0562",
        "\u0577\u0561\u0562"
    ],
    wide: [
        "\u056F\u056B\u0580\u0561\u056F\u056B",
        "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        "\u0578\u0582\u0580\u0562\u0561\u0569",
        "\u0577\u0561\u0562\u0561\u0569"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "\u058A\u056B\u0576";
    }
    return number + "\u058A\u0580\u0564";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ko4sf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
var parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
var parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
var matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
var parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9iVd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
 */ var locale = {
    code: 'id',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"7LdoC","./_lib/formatLong/index.js":"iWFyG","./_lib/formatRelative/index.js":"4U3VD","./_lib/localize/index.js":"4LmT6","./_lib/match/index.js":"evGhN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7LdoC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 detik',
        other: 'kurang dari {{count}} detik'
    },
    xSeconds: {
        one: '1 detik',
        other: '{{count}} detik'
    },
    halfAMinute: 'setengah menit',
    lessThanXMinutes: {
        one: 'kurang dari 1 menit',
        other: 'kurang dari {{count}} menit'
    },
    xMinutes: {
        one: '1 menit',
        other: '{{count}} menit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam waktu ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWFyG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4U3VD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4LmT6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // All data for localization are taken from this page
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// https://www.unicode.org/cldr/charts/32/summary/id.html
var eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masehi',
        'Masehi'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        'Kuartal ke-1',
        'Kuartal ke-2',
        'Kuartal ke-3',
        'Kuartal ke-4'
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Agt',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var dayValues = {
    narrow: [
        'M',
        'S',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    wide: [
        'Minggu',
        'Senin',
        'Selasa',
        'Rabu',
        'Kamis',
        'Jumat',
        'Sabtu'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + number;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"evGhN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
var parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
var parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7wBfn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var locale = {
    code: 'is',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"kIgeK","./_lib/formatLong/index.js":"dMlTI","./_lib/formatRelative/index.js":"6BOAd","./_lib/localize/index.js":"irRx7","./_lib/match/index.js":"2Fff8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kIgeK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: '1 klukkustund',
        other: '{{count}} klukkustundir'
    },
    xDays: {
        one: '1 dagur',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'um viku',
        other: 'um {{count}} vikur'
    },
    xWeeks: {
        one: '1 viku',
        other: '{{count}} vikur'
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dMlTI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'd.MM.y'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6BOAd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"irRx7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        'fyrir Krist',
        'eftir Krist'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1F',
        '2F',
        '3F',
        '4F'
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        "\xc1",
        'S',
        "\xd3",
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'sept.',
        'okt.',
        "n\xf3v.",
        'des.'
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'september',
        "okt\xf3ber",
        "n\xf3vember",
        'desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        "\xde",
        'M',
        'F',
        'F',
        'L'
    ],
    short: [
        'Su',
        "M\xe1",
        "\xder",
        'Mi',
        'Fi',
        "F\xf6",
        'La'
    ],
    abbreviated: [
        'sun.',
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        'fim.',
        "f\xf6s.",
        'lau.'
    ],
    wide: [
        'sunnudagur',
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        'fimmtudagur',
        "f\xf6studagur",
        'laugardagur'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Fff8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+(\.)?/i;
var matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
var parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecW7F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var locale = {
    code: 'it',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"ib50W","./_lib/formatLong/index.js":"kqnWs","./_lib/formatRelative/index.js":"gJUE9","./_lib/localize/index.js":"cRHTX","./_lib/match/index.js":"7P22f","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ib50W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'meno di un secondo',
        other: 'meno di {{count}} secondi'
    },
    xSeconds: {
        one: 'un secondo',
        other: '{{count}} secondi'
    },
    halfAMinute: 'alcuni secondi',
    lessThanXMinutes: {
        one: 'meno di un minuto',
        other: 'meno di {{count}} minuti'
    },
    xMinutes: {
        one: 'un minuto',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "circa un'ora",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "un'ora",
        other: '{{count}} ore'
    },
    xDays: {
        one: 'un giorno',
        other: '{{count}} giorni'
    },
    aboutXWeeks: {
        one: 'circa una settimana',
        other: 'circa {{count}} settimane'
    },
    xWeeks: {
        one: 'una settimana',
        other: '{{count}} settimane'
    },
    aboutXMonths: {
        one: 'circa un mese',
        other: 'circa {{count}} mesi'
    },
    xMonths: {
        one: 'un mese',
        other: '{{count}} mesi'
    },
    aboutXYears: {
        one: 'circa un anno',
        other: 'circa {{count}} anni'
    },
    xYears: {
        one: 'un anno',
        other: '{{count}} anni'
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: 'quasi un anno',
        other: 'quasi {{count}} anni'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'tra ' + result;
        else return result + ' fa';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kqnWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gJUE9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var weekdays = [
    'domenica',
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    'sabato'
];
function _lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + weekdays[day] + " scorso alle' p";
    }
}
function thisWeek(day) {
    return "'" + weekdays[day] + " alle' p";
}
function _nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + weekdays[day] + " prossimo alle' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cRHTX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'avanti Cristo',
        'dopo Cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'G',
        'F',
        'M',
        'A',
        'M',
        'G',
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'gen',
        'feb',
        'mar',
        'apr',
        'mag',
        'giu',
        'lug',
        'ago',
        'set',
        'ott',
        'nov',
        'dic'
    ],
    wide: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'G',
        'V',
        'S'
    ],
    short: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    wide: [
        'domenica',
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        'sabato'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7P22f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bboAp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../it/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../it/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../it/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../it/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66]{@link https://github.com/maic66}
 */ var locale = {
    code: 'it-CH',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../it/_lib/formatDistance/index.js":"ib50W","../it/_lib/formatRelative/index.js":"gJUE9","../it/_lib/localize/index.js":"cRHTX","../it/_lib/match/index.js":"7P22f","./_lib/formatLong/index.js":"lAKy4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lAKy4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Wocf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var locale = {
    code: 'ja',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"lCFcq","./_lib/formatLong/index.js":"drGSS","./_lib/formatRelative/index.js":"6nbYm","./_lib/localize/index.js":"juDbG","./_lib/match/index.js":"gEeRn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lCFcq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"drGSS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6nbYm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"juDbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u5E74");
        case 'quarter':
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case 'month':
            return "".concat(number, "\u6708");
        case 'week':
            return "\u7B2C".concat(number, "\u9031");
        case 'date':
            return "".concat(number, "\u65E5");
        case 'hour':
            return "".concat(number, "\u6642");
        case 'minute':
            return "".concat(number, "\u5206");
        case 'second':
            return "".concat(number, "\u79D2");
        default:
            return "".concat(number);
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gEeRn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8uqib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
 */ var locale = {
    code: 'ja-Hira',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5p79r","./_lib/formatLong/index.js":"870Fj","./_lib/formatRelative/index.js":"ewFhG","./_lib/localize/index.js":"6PGkb","./_lib/match/index.js":"aeyFH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5p79r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
    },
    xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
    },
    halfAMinute: "30\u3073\u3087\u3046",
    lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
    },
    xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
    },
    aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
    },
    xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
    },
    xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
    },
    aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
    },
    xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
    },
    aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
    },
    xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
    },
    overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
    },
    almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u3042\u3068";
        else return result + "\u307E\u3048";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"870Fj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
    long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var timeFormats = {
    full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewFhG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
    yesterday: "\u304D\u306E\u3046\u306Ep",
    today: "\u304D\u3087\u3046\u306Ep",
    tomorrow: "\u3042\u3057\u305F\u306Ep",
    nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6PGkb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ],
    wide: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u3060\u30441\u3057\u306F\u3093\u304D",
        "\u3060\u30442\u3057\u306F\u3093\u304D",
        "\u3060\u30443\u3057\u306F\u3093\u304D",
        "\u3060\u30444\u3057\u306F\u3093\u304D"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ],
    wide: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ]
};
var dayValues = {
    narrow: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    short: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    abbreviated: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    wide: [
        "\u306B\u3061\u3088\u3046\u3073",
        "\u3052\u3064\u3088\u3046\u3073",
        "\u304B\u3088\u3046\u3073",
        "\u3059\u3044\u3088\u3046\u3073",
        "\u3082\u304F\u3088\u3046\u3073",
        "\u304D\u3093\u3088\u3046\u3073",
        "\u3069\u3088\u3046\u3073"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u306D\u3093");
        case 'quarter':
            return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");
        case 'month':
            return "".concat(number, "\u304C\u3064");
        case 'week':
            return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");
        case 'date':
            return "".concat(number, "\u306B\u3061");
        case 'hour':
            return "".concat(number, "\u3058");
        case 'minute':
            return "".concat(number, "\u3075\u3093");
        case 'second':
            return "".concat(number, "\u3073\u3087\u3046");
        default:
            return "".concat(number);
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aeyFH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
var parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
var parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
var parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
var matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1RFqe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
 */ var locale = {
    code: 'ka',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"4Vwie","./_lib/formatLong/index.js":"310xS","./_lib/formatRelative/index.js":"4GZFL","./_lib/localize/index.js":"32Enk","./_lib/match/index.js":"iN08a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Vwie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
    },
    halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (options !== null && options !== void 0 && options.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace('{{count}}', String(count));
    else if (options !== null && options !== void 0 && options.addSuffix) result = tokenValue.past.replace('{{count}}', String(count));
    else result = tokenValue.present.replace('{{count}}', String(count));
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"310xS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do, MMMM, y',
    medium: 'd, MMM, y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} {{time}}'-\u10D6\u10D4'",
    long: "{{date}} {{time}}'-\u10D6\u10D4'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4GZFL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
    yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
    today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
    tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
    nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"32Enk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u10E9.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9.\u10EC"
    ],
    abbreviated: [
        "\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9\u10D5.\u10EC"
    ],
    wide: [
        "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4",
        "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u10DA\u10D8 \u10D9\u10D5",
        "2-\u10D4 \u10D9\u10D5",
        "3-\u10D4 \u10D9\u10D5",
        "4-\u10D4 \u10D9\u10D5"
    ],
    wide: [
        "1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "\u10D8\u10D0",
        "\u10D7\u10D4",
        "\u10DB\u10D0",
        "\u10D0\u10DE",
        "\u10DB\u10E1",
        "\u10D5\u10DC",
        "\u10D5\u10DA",
        "\u10D0\u10D2",
        "\u10E1\u10D4",
        "\u10DD\u10E5",
        "\u10DC\u10DD",
        "\u10D3\u10D4"
    ],
    abbreviated: [
        "\u10D8\u10D0\u10DC",
        "\u10D7\u10D4\u10D1",
        "\u10DB\u10D0\u10E0",
        "\u10D0\u10DE\u10E0",
        "\u10DB\u10D0\u10D8",
        "\u10D8\u10D5\u10DC",
        "\u10D8\u10D5\u10DA",
        "\u10D0\u10D2\u10D5",
        "\u10E1\u10D4\u10E5",
        "\u10DD\u10E5\u10E2",
        "\u10DC\u10DD\u10D4",
        "\u10D3\u10D4\u10D9"
    ],
    wide: [
        "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        "\u10DB\u10D0\u10E0\u10E2\u10D8",
        "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        "\u10DB\u10D0\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
        "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
        "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
    ]
};
var dayValues = {
    narrow: [
        "\u10D9\u10D5",
        "\u10DD\u10E0",
        "\u10E1\u10D0",
        "\u10DD\u10D7",
        "\u10EE\u10E3",
        "\u10DE\u10D0",
        "\u10E8\u10D0"
    ],
    short: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    abbreviated: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    wide: [
        "\u10D9\u10D5\u10D8\u10E0\u10D0",
        "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    if (number === 1) return number + "-\u10DA\u10D8";
    return number + "-\u10D4";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iN08a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
var parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
var parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
var parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kbVuS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
 */ var locale = {
    code: 'kk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"8SDGK","./_lib/formatLong/index.js":"e4XdT","./_lib/formatRelative/index.js":"dGQH5","./_lib/localize/index.js":"gDsWu","./_lib/match/index.js":"1HJfn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8SDGK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    halfAMinute: function halfAMinute(options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            else return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXWeeks: {
        type: 'weeks',
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
    },
    xWeeks: {
        type: 'weeks',
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    }
};
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
var formatDistance = function formatDistance(token, count, options) {
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'function') return tokenValue(options);
    if (tokenValue.type === 'weeks') return count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return declension(tokenValue.future, count);
            else return declension(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
        } else {
            if (tokenValue.past) return declension(tokenValue.past, count);
            else return declension(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
        }
    } else return declension(tokenValue.regular, count);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e4XdT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do MMMM y '\u0436.'",
    long: "do MMMM y '\u0436.'",
    medium: "d MMM y '\u0436.'",
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGQH5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var accusativeWeekdays = [
    "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0436\u04B1\u043C\u0430\u0434\u0430",
    "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"
];
function _lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function _nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gDsWu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    abbreviated: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    wide: [
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D",
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0448\u0456 \u0442\u043E\u049B.",
        "2-\u0448\u0456 \u0442\u043E\u049B.",
        "3-\u0448\u0456 \u0442\u043E\u049B.",
        "4-\u0448\u0456 \u0442\u043E\u049B."
    ],
    wide: [
        "1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var monthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var dayValues = {
    narrow: [
        "\u0416",
        "\u0414",
        "\u0421",
        "\u0421",
        "\u0411",
        "\u0416",
        "\u0421"
    ],
    short: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    wide: [
        "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
        "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
        "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0436\u04B1\u043C\u0430",
        "\u0441\u0435\u043D\u0431\u0456"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
    }
};
var suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var mod10 = number % 10;
    var b = number >= 100 ? 100 : null;
    var suffix = suffixes[number] || suffixes[mod10] || b && suffixes[b] || '';
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1HJfn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
var parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
var parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
var parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ief84":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay]{@link https://github.com/seanghay}
 */ var locale = {
    code: 'km',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"32NG8","./_lib/formatLong/index.js":"bq6GN","./_lib/formatRelative/index.js":"76KBe","./_lib/localize/index.js":"czT0c","./_lib/match/index.js":"g5FXH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"32NG8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
    lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
    xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
    aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
    xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
    xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
    aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
    xMonths: "{{count}} \u1781\u17C2",
    aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
var formatDistance = function formatDistance(token, count, options) {
    var tokenValue = formatDistanceLocale[token];
    var result = tokenValue;
    if (typeof count === 'number') result = result.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        else return result + "\u1798\u17BB\u1793";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bq6GN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a',
    long: 'h:mm:ss a',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"76KBe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
    yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
    today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
    tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
    nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"czT0c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u1798.\u1782\u179F",
        "\u1782\u179F"
    ],
    abbreviated: [
        "\u1798\u17BB\u1793\u1782.\u179F",
        "\u1782.\u179F"
    ],
    wide: [
        "\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787",
        "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"
    ]
};
var monthValues = {
    narrow: [
        "\u1798.\u1780",
        "\u1780.\u1798",
        "\u1798\u17B7",
        "\u1798.\u179F",
        "\u17A7.\u179F",
        "\u1798.\u1790",
        "\u1780.\u178A",
        "\u179F\u17B8",
        "\u1780\u1789",
        "\u178F\u17BB",
        "\u179C\u17B7",
        "\u1792"
    ],
    abbreviated: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ],
    wide: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ]
};
var dayValues = {
    narrow: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    short: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    abbreviated: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    wide: [
        "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
        "\u1785\u1793\u17D2\u1791",
        "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
        "\u1796\u17BB\u1792",
        "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
        "\u179F\u17BB\u1780\u17D2\u179A",
        "\u179F\u17C5\u179A\u17CD"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _) {
    var number = Number(dirtyNumber);
    return number.toString();
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g5FXH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
var parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
var parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Knme":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
 */ var locale = {
    code: 'kn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"ePgnL","./_lib/formatLong/index.js":"i5TBj","./_lib/formatRelative/index.js":"iM2Zu","./_lib/localize/index.js":"1uKP3","./_lib/match/index.js":"29Mpy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ePgnL":[function(require,module,exports,__globalThis) {
// note: no implementation for weeks
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    halfAMinute: {
        other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xHours: {
        one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xDays: {
        one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
    },
    almostXYears: {
        one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
    }
};
function getResultByTense(parentToken, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = getResultByTense(tokenValue.one, options);
    else result = getResultByTense(tokenValue.other, options);
    return result.replace('{{count}}', String(count));
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5TBj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM d, y',
    // CLDR 1816
    long: 'MMMM d, y',
    // CLDR 1817
    medium: 'MMM d, y',
    // CLDR 1818
    short: 'd/M/yy' // CLDR 1819
};
var timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR 1820
    long: 'hh:mm:ss a z',
    // CLDR 1821
    medium: 'hh:mm:ss a',
    // CLDR 1822
    short: 'hh:mm a' // CLDR 1823
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR 1824
    long: '{{date}} {{time}}',
    // CLDR 1825
    medium: '{{date}} {{time}}',
    // CLDR 1826
    short: '{{date}} {{time}}' // CLDR 1827
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iM2Zu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
    tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1uKP3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    abbreviated: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    // CLDR #1618, #1620
    wide: [
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5",
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"
    ] // CLDR #1614, #1616
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0CA4\u0CCD\u0CB0\u0CC8 1",
        "\u0CA4\u0CCD\u0CB0\u0CC8 2",
        "\u0CA4\u0CCD\u0CB0\u0CC8 3",
        "\u0CA4\u0CCD\u0CB0\u0CC8 4"
    ],
    // CLDR #1630 - #1638
    wide: [
        "1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"
    ] // CLDR #1622 - #1629
};
// CLDR #1646 - #1717
var monthValues = {
    narrow: [
        "\u0C9C",
        "\u0CAB\u0CC6",
        "\u0CAE\u0CBE",
        "\u0C8F",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2",
        "\u0C9C\u0CC1",
        "\u0C86",
        "\u0CB8\u0CC6",
        "\u0C85",
        "\u0CA8",
        "\u0CA1\u0CBF"
    ],
    abbreviated: [
        "\u0C9C\u0CA8",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
        "\u0CA8\u0CB5\u0CC6\u0C82",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"
    ],
    wide: [
        "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
        "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
    ]
};
// CLDR #1718 - #1773
var dayValues = {
    narrow: [
        "\u0CAD\u0CBE",
        "\u0CB8\u0CCB",
        "\u0CAE\u0C82",
        "\u0CAC\u0CC1",
        "\u0C97\u0CC1",
        "\u0CB6\u0CC1",
        "\u0CB6"
    ],
    short: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    abbreviated: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    wide: [
        "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
        "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
        "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
        "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
    ]
};
// CLDR #1774 - #1815
var dayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0CA8\u0CC7";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"29Mpy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
var parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
var parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f4lPo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var locale = {
    code: 'ko',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"g0ZBk","./_lib/formatLong/index.js":"jXXkK","./_lib/formatRelative/index.js":"iUrUH","./_lib/localize/index.js":"bpbmF","./_lib/match/index.js":"lyIE8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g0ZBk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jXXkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: 'y.MM.dd',
    short: 'y.MM.dd'
};
var timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: 'a H:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iUrUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bpbmF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'BC',
        'AD'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
var dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'minute':
        case 'second':
            return String(number);
        case 'date':
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lyIE8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8f9Yz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
 */ var locale = {
    code: 'lb',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"1Kfru","./_lib/formatLong/index.js":"6gcGS","./_lib/formatRelative/index.js":"5bwtX","./_lib/localize/index.js":"flNMH","./_lib/match/index.js":"38WqL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Kfru":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: 'eng Sekonn',
            other: '{{count}} Sekonnen'
        },
        withPreposition: {
            one: 'enger Sekonn',
            other: '{{count}} Sekonnen'
        }
    },
    halfAMinute: {
        standalone: 'eng hallef Minutt',
        withPreposition: 'enger hallwer Minutt'
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: 'eng Minutt',
            other: '{{count}} Minutten'
        },
        withPreposition: {
            one: 'enger Minutt',
            other: '{{count}} Minutten'
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: 'eng Stonn',
            other: '{{count}} Stonnen'
        },
        withPreposition: {
            one: 'enger Stonn',
            other: '{{count}} Stonnen'
        }
    },
    xDays: {
        standalone: {
            one: 'een Dag',
            other: '{{count}} Deeg'
        },
        withPreposition: {
            one: 'engem Dag',
            other: '{{count}} Deeg'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: 'eng Woch',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: 'enger Woch',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: 'ee Mount',
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: 'engem Mount',
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: 'ee Joer',
            other: '{{count}} Joer'
        },
        withPreposition: {
            one: 'engem Joer',
            other: '{{count}} Joer'
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: 'bal ee Joer',
            other: 'bal {{count}} Joer'
        },
        withPreposition: {
            one: 'bal engem Joer',
            other: 'bal {{count}} Joer'
        }
    }
};
var EXCEPTION_CONSONANTS = [
    'd',
    'h',
    'n',
    't',
    'z'
];
var VOWELS = [
    'a,',
    'e',
    'i',
    'o',
    'u'
];
var DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
var FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function isFinalNNeeded(nextWords) {
    var firstLetter = nextWords.charAt(0).toLowerCase();
    if (VOWELS.indexOf(firstLetter) != -1 || EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    var firstWord = nextWords.split(' ')[0];
    var number = parseInt(firstWord);
    if (!isNaN(number) && DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'a' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
        else return 'viru' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6gcGS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM y',
    // Méindeg, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan 2018
    short: 'dd.MM.yy' // 07.01.18
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5bwtX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        var result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += 'n';
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"flNMH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'viru Christus',
        'no Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4e",
        'Abr',
        'Mee',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4erz",
        "Abr\xebll",
        'Mee',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        "M\xe9",
        "D\xeb",
        "M\xeb",
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonndeg',
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        'Donneschdeg',
        'Freideg',
        'Samschdeg'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: 'nom.',
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"38WqL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
var parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
var parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /owes/i,
        night: /nuets/i // will never be matched. Night is matched by `pm`
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9UDJn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 */ var locale = {
    code: 'lt',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"DEB3D","./_lib/formatLong/index.js":"bWaNu","./_lib/formatRelative/index.js":"41leS","./_lib/localize/index.js":"lNozF","./_lib/match/index.js":"7OaHx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"DEB3D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var translations = {
    xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
    xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
    xhours_one: "valanda_valandos_valand\u0105",
    xhours_other: "valandos_valand\u0173_valandas",
    xdays_one: "diena_dienos_dien\u0105",
    xdays_other: "dienos_dien\u0173_dienas",
    xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
    xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
    xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    xyears_one: "metai_met\u0173_metus",
    xyears_other: "metai_met\u0173_metus",
    about: 'apie',
    over: 'daugiau nei',
    almost: 'beveik',
    lessthan: "ma\u017Eiau nei"
};
var translateSeconds = function translateSeconds(_number, addSuffix, _key, isFuture) {
    if (!addSuffix) return "kelios sekund\u0117s";
    else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : 'kelias sekundes';
};
var translateSingular = function translateSingular(_number, addSuffix, key, isFuture) {
    return !addSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
};
var translate = function translate(number, addSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) return result + translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    else {
        if (isFuture) return result + forms(key)[1];
        else return result + (special(number) ? forms(key)[1] : forms(key)[2]);
    }
};
function special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function forms(key) {
    return translations[key].split('_');
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: translateSeconds,
        other: translate
    },
    xSeconds: {
        one: translateSeconds,
        other: translate
    },
    halfAMinute: "pus\u0117 minut\u0117s",
    lessThanXMinutes: {
        one: translateSingular,
        other: translate
    },
    xMinutes: {
        one: translateSingular,
        other: translate
    },
    aboutXHours: {
        one: translateSingular,
        other: translate
    },
    xHours: {
        one: translateSingular,
        other: translate
    },
    xDays: {
        one: translateSingular,
        other: translate
    },
    aboutXWeeks: {
        one: translateSingular,
        other: translate
    },
    xWeeks: {
        one: translateSingular,
        other: translate
    },
    aboutXMonths: {
        one: translateSingular,
        other: translate
    },
    xMonths: {
        one: translateSingular,
        other: translate
    },
    aboutXYears: {
        one: translateSingular,
        other: translate
    },
    xYears: {
        one: translateSingular,
        other: translate
    },
    overXYears: {
        one: translateSingular,
        other: translate
    },
    almostXYears: {
        one: translateSingular,
        other: translate
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var isFuture = (options === null || options === void 0 ? void 0 : options.comparison) !== undefined && options.comparison > 0;
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_one', isFuture);
    else result = tokenValue.other(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_other', isFuture);
    if (adverb) {
        var _key2 = adverb[0].toLowerCase();
        result = translations[_key2] + ' ' + result;
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'po ' + result;
        else return "prie\u0161 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bWaNu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: 'y-MM-dd',
    short: 'y-MM-dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"41leS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'Pra\u0117jus\u012F' eeee p",
    yesterday: "'Vakar' p",
    today: "'\u0160iandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: 'eeee p',
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lNozF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr. Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pr. Kr.',
        'po Kr.'
    ],
    wide: [
        "prie\u0161 Krist\u0173",
        'po Kristaus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I ketv.',
        'II ketv.',
        'III ketv.',
        'IV ketv.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I k.',
        'II k.',
        'III k.',
        'IV k.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var monthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausis',
        'vasaris',
        'kovas',
        'balandis',
        "gegu\u017E\u0117",
        "bir\u017Eelis",
        'liepa',
        "rugpj\u016Btis",
        "rugs\u0117jis",
        'spalis',
        'lapkritis',
        'gruodis'
    ]
};
var formattingMonthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausio',
        'vasario',
        'kovo',
        "baland\u017Eio",
        "gegu\u017E\u0117s",
        "bir\u017Eelio",
        'liepos',
        "rugpj\u016B\u010Dio",
        "rugs\u0117jo",
        'spalio',
        "lapkri\u010Dio",
        "gruod\u017Eio"
    ]
};
var dayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        'sekmadienis',
        'pirmadienis',
        'antradienis',
        "tre\u010Diadienis",
        'ketvirtadienis',
        'penktadienis',
        "\u0161e\u0161tadienis"
    ]
};
var formattingDayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        "sekmadien\u012F",
        "pirmadien\u012F",
        "antradien\u012F",
        "tre\u010Diadien\u012F",
        "ketvirtadien\u012F",
        "penktadien\u012F",
        "\u0161e\u0161tadien\u012F"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '-oji';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7OaHx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
var parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
var parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
var parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
var matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gkd7T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
 */ var locale = {
    code: 'lv',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"3EFss","./_lib/formatLong/index.js":"kBB1x","./_lib/formatRelative/index.js":"gHewj","./_lib/localize/index.js":"fSInJ","./_lib/match/index.js":"dV25J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3EFss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function buildLocalizeTokenFn(schema) {
    return function(count, options) {
        if (count === 1) {
            if (options !== null && options !== void 0 && options.addSuffix) return schema.one[0].replace('{{time}}', schema.one[2]);
            else return schema.one[0].replace('{{time}}', schema.one[1]);
        } else {
            var rem = count % 10 === 1 && count % 100 !== 11;
            if (options !== null && options !== void 0 && options.addSuffix) return schema.other[0].replace('{{time}}', rem ? schema.other[3] : schema.other[4]).replace('{{count}}', String(count));
            else return schema.other[0].replace('{{time}}', rem ? schema.other[1] : schema.other[2]).replace('{{count}}', String(count));
        }
    };
}
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            'sekundi',
            'sekundi'
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    xSeconds: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'sekunde',
            'sekundes'
        ],
        other: [
            '{{count}} {{time}}',
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            '{{count}} {{time}}',
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'stunda',
            'stundas'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xHours: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'stunda',
            'stundas'
        ],
        other: [
            '{{count}} {{time}}',
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xDays: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'diena',
            'dienas'
        ],
        other: [
            '{{count}} {{time}}',
            'diena',
            'dienas',
            'dienas',
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            '{{count}} {{time}}',
            // TODO
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            '{{count}} {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    xYears: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'gads',
            'gada'
        ],
        other: [
            '{{count}} {{time}}',
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    overXYears: buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            'gadu',
            'gadu'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    almostXYears: buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    })
};
var formatDistance = function formatDistance(token, count, options) {
    var result = formatDistanceLocale[token](count, options);
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return 'pirms ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kBB1x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: 'dd.MM.y.',
    short: 'dd.MM.y.'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHewj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = weekdays[date.getUTCDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = weekdays[date.getUTCDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fSInJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        'pirmais ceturksnis',
        'otrais ceturksnis',
        "tre\u0161ais ceturksnis",
        'ceturtais ceturksnis'
    ]
};
var formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        'marts',
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        'marts',
        "apr\u012Blis",
        'maijs',
        "j\u016Bnijs",
        "j\u016Blijs",
        'augusts',
        'septembris',
        'oktobris',
        'novembris',
        'decembris'
    ]
};
var formattingMonthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        "mart\u0101",
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
var dayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdiena",
        'pirmdiena',
        'otrdiena',
        "tre\u0161diena",
        'ceturtdiena',
        'piektdiena',
        'sestdiena'
    ]
};
var formattingDayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: 'diena',
        evening: 'vakars',
        night: 'nakts'
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: 'vakars',
        night: 'nakts'
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusnakts',
        noon: 'pusdienlaiks',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: 'vakars',
        night: 'nakts'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dV25J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
var parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
var parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'wide',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Cvw1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
 */ var locale = {
    code: 'mk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dLl6D","./_lib/formatLong/index.js":"byLCp","./_lib/formatRelative/index.js":"cNaT9","./_lib/localize/index.js":"28RGv","./_lib/match/index.js":"dLsSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dLl6D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435\u0434 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byLCp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cNaT9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u0430",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
    "\u043F\u0435\u0442\u043E\u043A",
    "\u0441\u0430\u0431\u043E\u0442\u0430"
];
function _lastWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
    }
}
function thisWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
    }
}
function _nextWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
    today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"28RGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u0438 \u043A\u0432.",
        "2-\u0440\u0438 \u043A\u0432.",
        "3-\u0442\u0438 \u043A\u0432.",
        "4-\u0442\u0438 \u043A\u0432."
    ],
    wide: [
        "1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F\u0442",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435\u043C",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D\u0438",
        "\u0458\u0443\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435",
        "\u043F\u043E",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0435",
        "\u043F\u0435",
        "\u0441\u0430"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0430\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
        "\u043F\u0435\u0442\u043E\u043A",
        "\u0441\u0430\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-\u0432\u0438";
        case 2:
            return number + "-\u0440\u0438";
        case 7:
        case 8:
            return number + "-\u043C\u0438";
    }
    return number + "-\u0442\u0438";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dLsSs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
var parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
var matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"13QbE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
 */ var locale = {
    code: 'mn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"Fs4xQ","./_lib/formatLong/index.js":"cm3BB","./_lib/formatRelative/index.js":"K0YsV","./_lib/localize/index.js":"3C52m","./_lib/match/index.js":"2C2T3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Fs4xQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
    },
    halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
    lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
    },
    aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
    },
    xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
    },
    xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
    },
    aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
    },
    xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
    },
    aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
    },
    xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
    },
    almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        /**
     * Append genitive case
     */ var words = result.split(' ');
        var lastword = words.pop();
        result = words.join(' ');
        switch(lastword){
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
                result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
                break;
            case "\u043C\u0438\u043D\u0443\u0442":
                result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
                break;
            case "\u0446\u0430\u0433":
                result += " \u0446\u0430\u0433\u0438\u0439\u043D";
                break;
            case "\u04E9\u0434\u04E9\u0440":
                result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
                break;
            case "\u0441\u0430\u0440":
                result += " \u0441\u0430\u0440\u044B\u043D";
                break;
            case "\u0436\u0438\u043B":
                result += " \u0436\u0438\u043B\u0438\u0439\u043D";
                break;
            case "\u0445\u043E\u043D\u043E\u0433":
                result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
                break;
            case "\u0433\u0430\u0440\u0430\u043D":
                result += " \u0433\u0430\u0440\u0430\u043D\u044B";
                break;
            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
                result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
                break;
            default:
                result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) return result + " \u0434\u0430\u0440\u0430\u0430";
        else return result + " \u04E9\u043C\u043D\u04E9";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cm3BB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
    long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
    medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
    short: 'y.MM.dd'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"K0YsV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
    nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3C52m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    abbreviated: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    wide: [
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445",
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"
    ]
};
var quarterValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV'
    ],
    abbreviated: [
        "I \u0443\u043B\u0438\u0440\u0430\u043B",
        "II \u0443\u043B\u0438\u0440\u0430\u043B",
        "III \u0443\u043B\u0438\u0440\u0430\u043B",
        "IV \u0443\u043B\u0438\u0440\u0430\u043B"
    ],
    wide: [
        "1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var formattingMonthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432\u0430\u0430",
        "\u041C\u044F\u0433\u043C\u0430\u0440",
        "\u041B\u0445\u0430\u0433\u0432\u0430",
        "\u041F\u04AF\u0440\u044D\u0432",
        "\u0411\u0430\u0430\u0441\u0430\u043D",
        "\u0411\u044F\u043C\u0431\u0430"
    ]
};
var formattingDayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u043D\u044F\u043C",
        "\u0434\u0430\u0432\u0430\u0430",
        "\u043C\u044F\u0433\u043C\u0430\u0440",
        "\u043B\u0445\u0430\u0433\u0432\u0430",
        "\u043F\u04AF\u0440\u044D\u0432",
        "\u0431\u0430\u0430\u0441\u0430\u043D",
        "\u0431\u044F\u043C\u0431\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2C2T3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /\d+/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
var parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
var parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
var parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gca2E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
 */ var locale = {
    code: 'ms',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"ed58Q","./_lib/formatLong/index.js":"dJgop","./_lib/formatRelative/index.js":"1pko9","./_lib/localize/index.js":"5Bi5I","./_lib/match/index.js":"lzkyS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ed58Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 saat',
        other: 'kurang dari {{count}} saat'
    },
    xSeconds: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    halfAMinute: 'setengah minit',
    lessThanXMinutes: {
        one: 'kurang dari 1 minit',
        other: 'kurang dari {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam masa ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dJgop":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1pko9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Bi5I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Most data for localization are taken from this page
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// https://www.unicode.org/cldr/charts/32/summary/ms.html
var eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masihi',
        'Masihi'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'S1',
        'S2',
        'S3',
        'S4'
    ],
    wide: [
        'Suku pertama',
        'Suku kedua',
        'Suku ketiga',
        'Suku keempat'
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mac',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Ogo',
        'Sep',
        'Okt',
        'Nov',
        'Dis'
    ],
    wide: [
        'Januari',
        'Februari',
        'Mac',
        'April',
        'Mei',
        'Jun',
        'Julai',
        'Ogos',
        'September',
        'Oktober',
        'November',
        'Disember'
    ]
};
var dayValues = {
    narrow: [
        'A',
        'I',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    wide: [
        'Ahad',
        'Isnin',
        'Selasa',
        'Rabu',
        'Khamis',
        'Jumaat',
        'Sabtu'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tgh malam',
        noon: 'tgh hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + Number(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lzkyS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var parseOrdinalNumberPattern = /petama|\d+/i;
var matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
var parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
var parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
var parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"44qfW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ var locale = {
    code: 'mt',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"RXZAd","./_lib/formatLong/index.js":"4pxTo","./_lib/formatRelative/index.js":"jye5W","./_lib/localize/index.js":"7SjDn","./_lib/match/index.js":"2MHg1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"RXZAd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'inqas minn sekonda',
        other: 'inqas minn {{count}} sekondi'
    },
    xSeconds: {
        one: 'sekonda',
        other: '{{count}} sekondi'
    },
    halfAMinute: 'nofs minuta',
    lessThanXMinutes: {
        one: 'inqas minn minuta',
        other: 'inqas minn {{count}} minuti'
    },
    xMinutes: {
        one: 'minuta',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
    },
    xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
    },
    xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
    },
    aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
    },
    xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
    },
    aboutXMonths: {
        one: 'madwar xahar',
        other: 'madwar {{count}} xhur'
    },
    xMonths: {
        one: 'xahar',
        other: '{{count}} xhur'
    },
    aboutXYears: {
        one: 'madwar sena',
        two: 'madwar sentejn',
        other: 'madwar {{count}} snin'
    },
    xYears: {
        one: 'sena',
        two: 'sentejn',
        other: '{{count}} snin'
    },
    overXYears: {
        one: 'aktar minn sena',
        two: 'aktar minn sentejn',
        other: 'aktar minn {{count}} snin'
    },
    almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + ' ilu';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4pxTo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jye5W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
    yesterday: "'Il-biera\u0127 fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'G\u0127ada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7SjDn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'Q',
        'W'
    ],
    abbreviated: [
        'QK',
        'WK'
    ],
    wide: [
        'qabel Kristu',
        'wara Kristu'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kwart',
        '2. kwart',
        '3. kwart',
        '4. kwart'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        "\u0120",
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Fra',
        'Mar',
        'Apr',
        'Mej',
        "\u0120un",
        'Lul',
        'Aww',
        'Set',
        'Ott',
        'Nov',
        "Di\u010B"
    ],
    wide: [
        'Jannar',
        'Frar',
        'Marzu',
        'April',
        'Mejju',
        "\u0120unju",
        'Lulju',
        'Awwissu',
        'Settembru',
        'Ottubru',
        'Novembru',
        "Di\u010Bembru"
    ]
};
var dayValues = {
    narrow: [
        "\u0126",
        'T',
        'T',
        'E',
        "\u0126",
        "\u0120",
        'S'
    ],
    short: [
        "\u0126a",
        'Tn',
        'Tl',
        'Er',
        "\u0126a",
        "\u0120i",
        'Si'
    ],
    abbreviated: [
        "\u0126ad",
        'Tne',
        'Tli',
        'Erb',
        "\u0126am",
        "\u0120im",
        'Sib'
    ],
    wide: [
        "Il-\u0126add",
        'It-Tnejn',
        'It-Tlieta',
        "L-Erbg\u0127a",
        "Il-\u0126amis",
        "Il-\u0120img\u0127a",
        'Is-Sibt'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2MHg1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
var parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
var parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJ75U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var locale = {
    code: 'nb',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5tnXr","./_lib/formatLong/index.js":"9tGny","./_lib/formatRelative/index.js":"URaCv","./_lib/localize/index.js":"gaXfU","./_lib/match/index.js":"317Ts","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tnXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn ett sekund',
        other: 'mindre enn {{count}} sekunder'
    },
    xSeconds: {
        one: 'ett sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'et halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn ett minutt',
        other: 'mindre enn {{count}} minutter'
    },
    xMinutes: {
        one: 'ett minutt',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'omtrent en time',
        other: 'omtrent {{count}} timer'
    },
    xHours: {
        one: 'en time',
        other: '{{count}} timer'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dager'
    },
    aboutXWeeks: {
        one: 'omtrent en uke',
        other: 'omtrent {{count}} uker'
    },
    xWeeks: {
        one: 'en uke',
        other: '{{count}} uker'
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9tGny":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"URaCv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gaXfU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        'man',
        'tir',
        'ons',
        'tor',
        'fre',
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"317Ts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"HBIPT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var locale = {
    code: 'nl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"fhcrH","./_lib/formatLong/index.js":"cO4Hc","./_lib/formatRelative/index.js":"cnGUn","./_lib/localize/index.js":"kkYia","./_lib/match/index.js":"ccGjm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fhcrH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cO4Hc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cnGUn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kkYia":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ccGjm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ljPLv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var locale = {
    code: 'nl-BE',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"jAIEw","./_lib/formatLong/index.js":"a2v36","./_lib/formatRelative/index.js":"aCt4o","./_lib/localize/index.js":"haD49","./_lib/match/index.js":"3jaJp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jAIEw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a2v36":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCt4o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"haD49":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3jaJp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4H3VI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
 */ var locale = {
    code: 'nn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dbFFu","./_lib/formatLong/index.js":"d8Slz","./_lib/formatRelative/index.js":"crlnq","./_lib/localize/index.js":"h7ZQf","./_lib/match/index.js":"jCFFf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dbFFu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn eitt sekund',
        other: 'mindre enn {{count}} sekund'
    },
    xSeconds: {
        one: 'eitt sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'eit halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn eitt minutt',
        other: 'mindre enn {{count}} minutt'
    },
    xMinutes: {
        one: 'eitt minutt',
        other: '{{count}} minutt'
    },
    aboutXHours: {
        one: 'omtrent ein time',
        other: 'omtrent {{count}} timar'
    },
    xHours: {
        one: 'ein time',
        other: '{{count}} timar'
    },
    xDays: {
        one: 'ein dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'omtrent ei veke',
        other: 'omtrent {{count}} veker'
    },
    xWeeks: {
        one: 'ei veke',
        other: '{{count}} veker'
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var wordMapping = [
    'null',
    'ein',
    'to',
    'tre',
    'fire',
    'fem',
    'seks',
    'sju',
    "\xe5tte",
    'ni',
    'ti',
    'elleve',
    'tolv'
];
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sidan';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d8Slz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"crlnq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h7ZQf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        'su',
        "m\xe5",
        'ty',
        'on',
        'to',
        'fr',
        'lau'
    ],
    abbreviated: [
        'sun',
        "m\xe5n",
        'tys',
        'ons',
        'tor',
        'fre',
        'laur'
    ],
    wide: [
        'sundag',
        "m\xe5ndag",
        'tysdag',
        'onsdag',
        'torsdag',
        'fredag',
        'laurdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jCFFf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
var parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bhYtb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ var locale = {
    code: 'oc',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"vj3mx","./_lib/formatLong/index.js":"aMNsP","./_lib/formatRelative/index.js":"2LjJv","./_lib/localize/index.js":"8IiUD","./_lib/match/index.js":"f7Jdl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"vj3mx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: 'mens de {{count}} segondas'
    },
    xSeconds: {
        one: '1 segonda',
        other: '{{count}} segondas'
    },
    halfAMinute: '30 segondas',
    lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: 'mens de {{count}} minutas'
    },
    xMinutes: {
        one: '1 minuta',
        other: '{{count}} minutas'
    },
    aboutXHours: {
        one: 'environ 1 ora',
        other: 'environ {{count}} oras'
    },
    xHours: {
        one: '1 ora',
        other: '{{count}} oras'
    },
    xDays: {
        one: '1 jorn',
        other: '{{count}} jorns'
    },
    aboutXWeeks: {
        one: 'environ 1 setmana',
        other: 'environ {{count}} setmanas'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanas'
    },
    aboutXMonths: {
        one: 'environ 1 mes',
        other: 'environ {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "mai d\u2019un an",
        other: 'mai de {{count}} ans'
    },
    almostXYears: {
        one: 'gaireben un an',
        other: 'gaireben {{count}} ans'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d\u2019aqu\xed " + result;
        else return 'fa ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aMNsP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2LjJv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8IiUD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    abbreviated: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
var quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        "1\xe8r trim.",
        '2nd trim.',
        '3en trim.',
        '4en trim.'
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
var monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MA',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DC'
    ],
    abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'mai',
        'junh',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'dec.'
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        'abril',
        'mai',
        'junh',
        'julhet',
        'agost',
        'setembre',
        "oct\xf2bre",
        'novembre',
        'decembre'
    ]
};
var dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'dimenge',
        'diluns',
        'dimars',
        "dim\xe8cres",
        "dij\xf2us",
        'divendres',
        'dissabte'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = 'nd';
            break;
        default:
            ordinal = 'en';
    }
    // feminine for year, week, hour, minute, second
    if (unit === 'year' || unit === 'week' || unit === 'hour' || unit === 'minute' || unit === 'second') ordinal += 'a';
    return number + ordinal;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f7Jdl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
var parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
var parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
var parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
var matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7hSVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var locale = {
    code: 'pl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"hUcoR","./_lib/formatLong/index.js":"hOw09","./_lib/formatRelative/index.js":"9vZl4","./_lib/localize/index.js":"lTzCJ","./_lib/match/index.js":"dvJum","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hUcoR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: '{{count}} sekundy',
        other: '{{count}} sekund'
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: '{{count}} minuty',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: 'godzina',
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: '{{count}} godziny',
        other: '{{count}} godzin'
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: '{{count}} dni',
        other: '{{count}} dni'
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: '{{count}} tygodnie',
        other: '{{count}} tygodni'
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: 'rok',
        twoFour: '{{count}} lata',
        other: '{{count}} lat'
    },
    overXYears: {
        one: 'ponad rok',
        twoFour: 'ponad {{count}} lata',
        other: 'ponad {{count}} lat'
    },
    almostXYears: {
        one: 'prawie rok',
        twoFour: 'prawie {{count}} lata',
        other: 'prawie {{count}} lat'
    }
};
function declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function declension(scheme, count, time) {
    var group = declensionGroup(scheme, count);
    var finalText = typeof group === 'string' ? group : group[time];
    return finalText.replace('{{count}}', String(count));
}
var formatDistance = function formatDistance(token, count, options) {
    var scheme = formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return declension(scheme, count, 'regular');
    if (options.comparison && options.comparison > 0) return 'za ' + declension(scheme, count, 'future');
    else return declension(scheme, count, 'past') + ' temu';
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hOw09":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9vZl4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var adjectivesLastWeek = {
    masculine: 'ostatni',
    feminine: 'ostatnia'
};
var adjectivesThisWeek = {
    masculine: 'ten',
    feminine: 'ta'
};
var adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
var dayGrammaticalGender = {
    0: 'feminine',
    1: 'masculine',
    2: 'masculine',
    3: 'feminine',
    4: 'masculine',
    5: 'masculine',
    6: 'feminine'
};
function dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjectives;
    if ((0, _indexJsDefault.default)(date, baseDate, options)) adjectives = adjectivesThisWeek;
    else if (token === 'lastWeek') adjectives = adjectivesLastWeek;
    else if (token === 'nextWeek') adjectives = adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
    var day = date.getUTCDay();
    var grammaticalGender = dayGrammaticalGender[day];
    var adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
}
var formatRelativeLocale = {
    lastWeek: dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: dayAndTimeWithAdjective,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(token, date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lTzCJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'p.n.e.',
        'n.e.'
    ],
    abbreviated: [
        'p.n.e.',
        'n.e.'
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        'naszej ery'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I kw.',
        'II kw.',
        'III kw.',
        'IV kw.'
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
var monthValues = {
    narrow: [
        'S',
        'L',
        'M',
        'K',
        'M',
        'C',
        'L',
        'S',
        'W',
        'P',
        'L',
        'G'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        "stycze\u0144",
        'luty',
        'marzec',
        "kwiecie\u0144",
        'maj',
        'czerwiec',
        'lipiec',
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        'listopad',
        "grudzie\u0144"
    ]
};
var monthFormattingValues = {
    narrow: [
        's',
        'l',
        'm',
        'k',
        'm',
        'c',
        'l',
        's',
        'w',
        'p',
        'l',
        'g'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        'stycznia',
        'lutego',
        'marca',
        'kwietnia',
        'maja',
        'czerwca',
        'lipca',
        'sierpnia',
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        'listopada',
        'grudnia'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'W',
        "\u015A",
        'C',
        'P',
        'S'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var dayFormattingValues = {
    narrow: [
        'n',
        'p',
        'w',
        "\u015B",
        'c',
        'p',
        's'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: 'rano',
        afternoon: "popo\u0142.",
        evening: 'wiecz.',
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    }
};
var dayPeriodFormattingValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: 'rano',
        afternoon: "po po\u0142.",
        evening: 'wiecz.',
        night: 'w nocy'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: monthFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: dayFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: dayPeriodFormattingValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dvJum":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8YsAV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var locale = {
    code: 'pt',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dFzs2","./_lib/formatLong/index.js":"fOfNz","./_lib/formatRelative/index.js":"iZFLh","./_lib/localize/index.js":"5NkCh","./_lib/match/index.js":"dO1Fr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dFzs2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'aproximadamente 1 hora',
        other: 'aproximadamente {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'aproximadamente 1 semana',
        other: 'aproximadamente {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: 'aproximadamente {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'aproximadamente 1 ano',
        other: 'aproximadamente {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'daqui a ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fOfNz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iZFLh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5NkCh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'antes de Cristo',
        'depois de Cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var dayValues = {
    narrow: [
        'd',
        's',
        't',
        'q',
        'q',
        's',
        's'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    abbreviated: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dO1Fr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cErTo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var locale = {
    code: 'pt-BR',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"4gW7c","./_lib/formatLong/index.js":"7efy4","./_lib/formatRelative/index.js":"cVfsX","./_lib/localize/index.js":"dn48C","./_lib/match/index.js":"byl7t","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4gW7c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'cerca de 1 hora',
        other: 'cerca de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'cerca de 1 semana',
        other: 'cerca de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: 'cerca de {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'cerca de 1 ano',
        other: 'cerca de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'em ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7efy4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVfsX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dn48C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'depois de cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'S',
        'T',
        'Q',
        'Q',
        'S',
        'S'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        'sab'
    ],
    abbreviated: [
        'domingo',
        'segunda',
        "ter\xe7a",
        'quarta',
        'quinta',
        'sexta',
        "s\xe1bado"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') return number + "\xaa";
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byl7t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"loZ7k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var locale = {
    code: 'ro',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"fGGr6","./_lib/formatLong/index.js":"93o5F","./_lib/formatRelative/index.js":"2QMps","./_lib/localize/index.js":"auw7y","./_lib/match/index.js":"7hapv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fGGr6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: '{{count}} secunde'
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "1 or\u0103",
        other: '{{count}} ore'
    },
    xDays: {
        one: '1 zi',
        other: '{{count}} zile'
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: 'circa {{count}} luni'
    },
    xMonths: {
        one: "1 lun\u0103",
        other: '{{count}} luni'
    },
    aboutXYears: {
        one: 'circa 1 an',
        other: 'circa {{count}} ani'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ani'
    },
    overXYears: {
        one: 'peste 1 an',
        other: 'peste {{count}} ani'
    },
    almostXYears: {
        one: 'aproape 1 an',
        other: 'aproape {{count}} ani'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"93o5F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2QMps":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"auw7y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\xce",
        'D'
    ],
    abbreviated: [
        "\xce.d.C.",
        'D.C.'
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        'primul trimestru',
        'al doilea trimestru',
        'al treilea trimestru',
        'al patrulea trimestru'
    ]
};
var monthValues = {
    narrow: [
        'I',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'ian',
        'feb',
        'mar',
        'apr',
        'mai',
        'iun',
        'iul',
        'aug',
        'sep',
        'oct',
        'noi',
        'dec'
    ],
    wide: [
        'ianuarie',
        'februarie',
        'martie',
        'aprilie',
        'mai',
        'iunie',
        'iulie',
        'august',
        'septembrie',
        'octombrie',
        'noiembrie',
        'decembrie'
    ]
};
var dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'du',
        'lu',
        'ma',
        'mi',
        'jo',
        'vi',
        "s\xe2"
    ],
    abbreviated: [
        'dum',
        'lun',
        'mar',
        'mie',
        'joi',
        'vin',
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        'luni',
        "mar\u021Bi",
        'miercuri',
        'joi',
        'vineri',
        "s\xe2mb\u0103t\u0103"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'ami',
        morning: 'dim',
        afternoon: 'da',
        evening: 's',
        night: 'n'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7hapv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"an5Rd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: 'ru',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"gys48","./_lib/formatLong/index.js":"lKJSK","./_lib/formatRelative/index.js":"iyWFf","./_lib/localize/index.js":"g5tB7","./_lib/match/index.js":"llGGc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gys48":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return declension(scheme.regular, count);
    };
}
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lKJSK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iyWFf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function _lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function _nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g5tB7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'date') suffix = "-\u0435";
    else if (unit === 'week' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"llGGc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ayYqD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var locale = {
    code: 'sk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dFoB2","./_lib/formatLong/index.js":"jtiHB","./_lib/formatRelative/index.js":"9pvcY","./_lib/localize/index.js":"lfDXA","./_lib/match/index.js":"bo592","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dFoB2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function declension(scheme, count, time) {
    var group = declensionGroup(scheme, count);
    var finalText = group[time];
    return finalText.replace('{{count}}', String(count));
}
function extractPreposition(token) {
    var result = [
        'lessThan',
        'about',
        'over',
        'almost'
    ].filter(function(preposition) {
        return !!token.match(new RegExp('^' + preposition));
    });
    return result[0];
}
function prefixPreposition(preposition) {
    var translation = '';
    if (preposition === 'almost') translation = 'takmer';
    if (preposition === 'about') translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + ' ' : '';
}
function suffixPreposition(preposition) {
    var translation = '';
    if (preposition === 'lessThan') translation = "menej ne\u017E";
    if (preposition === 'over') translation = "viac ne\u017E";
    return translation.length > 0 ? translation + ' ' : '';
}
function lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var formatDistanceLocale = {
    xSeconds: {
        one: {
            present: 'sekunda',
            past: 'sekundou',
            future: 'sekundu'
        },
        twoFour: {
            present: '{{count}} sekundy',
            past: '{{count}} sekundami',
            future: '{{count}} sekundy'
        },
        other: {
            present: "{{count}} sek\xfand",
            past: '{{count}} sekundami',
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: 'hodina',
            past: 'hodinou',
            future: 'hodinu'
        },
        twoFour: {
            present: '{{count}} hodiny',
            past: '{{count}} hodinami',
            future: '{{count}} hodiny'
        },
        other: {
            present: "{{count}} hod\xedn",
            past: '{{count}} hodinami',
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: '{{count}} dni',
            past: "{{count}} d\u0148ami",
            future: '{{count}} dni'
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: 'mesiac',
            past: 'mesiacom',
            future: 'mesiac'
        },
        twoFour: {
            present: '{{count}} mesiace',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiace'
        },
        other: {
            present: '{{count}} mesiacov',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiacov'
        }
    },
    xYears: {
        one: {
            present: 'rok',
            past: 'rokom',
            future: 'rok'
        },
        twoFour: {
            present: '{{count}} roky',
            past: '{{count}} rokmi',
            future: '{{count}} roky'
        },
        other: {
            present: '{{count}} rokov',
            past: '{{count}} rokmi',
            future: '{{count}} rokov'
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var preposition = extractPreposition(token) || '';
    var key = lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = formatDistanceLocale[key];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return prefixPreposition(preposition) + suffixPreposition(preposition) + declension(scheme, count, 'present');
    if (options.comparison && options.comparison > 0) return prefixPreposition(preposition) + 'o ' + suffixPreposition(preposition) + declension(scheme, count, 'future');
    else return prefixPreposition(preposition) + 'pred ' + suffixPreposition(preposition) + declension(scheme, count, 'past');
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jtiHB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1986
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. M. y',
    short: 'd. M. y'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var dateTimeFormats = {
    full: '{{date}}, {{time}}',
    long: '{{date}}, {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9pvcY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var accusativeWeekdays = [
    "nede\u013Eu",
    'pondelok',
    'utorok',
    'stredu',
    "\u0161tvrtok",
    'piatok',
    'sobotu'
];
function _lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function _nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lfDXA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // https://www.unicode.org/cldr/charts/32/summary/sk.html#1772
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pred Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pred Kr.',
        'po Kr.'
    ],
    wide: [
        'pred Kristom',
        'po Kristovi'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        'marec',
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'august',
        'september',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var formattingMonthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        'marca',
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        'augusta',
        'septembra',
        "okt\xf3bra",
        'novembra',
        'decembra'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var dayValues = {
    narrow: [
        'n',
        'p',
        'u',
        's',
        "\u0161",
        'p',
        's'
    ],
    short: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    abbreviated: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    wide: [
        "nede\u013Ea",
        'pondelok',
        'utorok',
        'streda',
        "\u0161tvrtok",
        'piatok',
        'sobota'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'polnoc',
        noon: 'poludnie',
        morning: "r\xe1no",
        afternoon: 'popoludnie',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'nap.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'v n.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'napol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'v noci'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o polnoci',
        noon: 'napoludnie',
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: 'v noci'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bo592":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lEaez":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
 */ var locale = {
    code: 'sl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5ZD1d","./_lib/formatLong/index.js":"beCb6","./_lib/formatRelative/index.js":"8GTPk","./_lib/localize/index.js":"anNxz","./_lib/match/index.js":"eeV7e","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5ZD1d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isPluralType(val) {
    return val.one !== undefined;
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: 'manj kot {{count}} sekunda',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        },
        past: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundama',
            few: 'manj kot {{count}} sekundami',
            other: 'manj kot {{count}} sekundami'
        },
        future: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        }
    },
    xSeconds: {
        present: {
            one: '{{count}} sekunda',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        },
        past: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundama',
            few: '{{count}} sekundami',
            other: '{{count}} sekundami'
        },
        future: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        }
    },
    halfAMinute: 'pol minute',
    lessThanXMinutes: {
        present: {
            one: 'manj kot {{count}} minuta',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        },
        past: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minutama',
            few: 'manj kot {{count}} minutami',
            other: 'manj kot {{count}} minutami'
        },
        future: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        }
    },
    xMinutes: {
        present: {
            one: '{{count}} minuta',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        },
        past: {
            one: '{{count}} minuto',
            two: '{{count}} minutama',
            few: '{{count}} minutami',
            other: '{{count}} minutami'
        },
        future: {
            one: '{{count}} minuto',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        }
    },
    aboutXHours: {
        present: {
            one: "pribli\u017Eno {{count}} ura",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        },
        past: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} urama",
            few: "pribli\u017Eno {{count}} urami",
            other: "pribli\u017Eno {{count}} urami"
        },
        future: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: '{{count}} ura',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        },
        past: {
            one: '{{count}} uro',
            two: '{{count}} urama',
            few: '{{count}} urami',
            other: '{{count}} urami'
        },
        future: {
            one: '{{count}} uro',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        }
    },
    xDays: {
        present: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        },
        past: {
            one: '{{count}} dnem',
            two: '{{count}} dnevoma',
            few: '{{count}} dnevi',
            other: '{{count}} dnevi'
        },
        future: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: '{{count}} teden',
        two: '{{count}} tedna',
        few: '{{count}} tedne',
        other: '{{count}} tednov'
    },
    aboutXMonths: {
        present: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
            one: "pribli\u017Eno {{count}} mesecem",
            two: "pribli\u017Eno {{count}} mesecema",
            few: "pribli\u017Eno {{count}} meseci",
            other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} meseci',
            other: '{{count}} mesecev'
        },
        past: {
            one: '{{count}} mesecem',
            two: '{{count}} mesecema',
            few: '{{count}} meseci',
            other: '{{count}} meseci'
        },
        future: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} mesece',
            other: '{{count}} mesecev'
        }
    },
    aboutXYears: {
        present: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        },
        past: {
            one: "pribli\u017Eno {{count}} letom",
            two: "pribli\u017Eno {{count}} letoma",
            few: "pribli\u017Eno {{count}} leti",
            other: "pribli\u017Eno {{count}} leti"
        },
        future: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        },
        past: {
            one: '{{count}} letom',
            two: '{{count}} letoma',
            few: '{{count}} leti',
            other: '{{count}} leti'
        },
        future: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        }
    },
    overXYears: {
        present: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        },
        past: {
            one: "ve\u010D kot {{count}} letom",
            two: "ve\u010D kot {{count}} letoma",
            few: "ve\u010D kot {{count}} leti",
            other: "ve\u010D kot {{count}} leti"
        },
        future: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        },
        past: {
            one: 'skoraj {{count}} letom',
            two: 'skoraj {{count}} letoma',
            few: 'skoraj {{count}} leti',
            other: 'skoraj {{count}} leti'
        },
        future: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        }
    }
};
function getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return 'one';
        case 2:
            return 'two';
        case 3:
        case 4:
            return 'few';
        default:
            return 'other';
    }
}
var formatDistance = function formatDistance(token, count, options) {
    var result = '';
    var tense = 'present';
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = 'future';
            result = "\u010Dez ";
        } else {
            tense = 'past';
            result = 'pred ';
        }
    }
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result += tokenValue;
    else {
        var form = getFormFromCount(count);
        if (isPluralType(tokenValue)) result += tokenValue[form].replace('{{count}}', String(count));
        else result += tokenValue[tense][form].replace('{{count}}', String(count));
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"beCb6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd. MMMM y',
    long: 'dd. MMMM y',
    medium: 'd. MMM y',
    short: 'd. MM. yy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8GTPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'prej\u0161njo nedeljo ob' p";
            case 3:
                return "'prej\u0161njo sredo ob' p";
            case 6:
                return "'prej\u0161njo soboto ob' p";
            default:
                return "'prej\u0161nji' EEEE 'ob' p";
        }
    },
    yesterday: "'v\u010Deraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"anNxz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    abbreviated: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    wide: [
        "pred na\u0161im \u0161tetjem",
        "po na\u0161em \u0161tetju"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Det.",
        "2. \u010Det.",
        "3. \u010Det.",
        "4. \u010Det."
    ],
    wide: [
        "1. \u010Detrtletje",
        "2. \u010Detrtletje",
        "3. \u010Detrtletje",
        "4. \u010Detrtletje"
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'avg.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marec',
        'april',
        'maj',
        'junij',
        'julij',
        'avgust',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'n',
        'p',
        't',
        's',
        "\u010D",
        'p',
        's'
    ],
    short: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    abbreviated: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    wide: [
        'nedelja',
        'ponedeljek',
        'torek',
        'sreda',
        "\u010Detrtek",
        'petek',
        'sobota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'j',
        afternoon: 'p',
        evening: 'v',
        night: 'n'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'poln.',
        noon: 'pold.',
        morning: 'jut.',
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: "no\u010D"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "polno\u010D",
        noon: 'poldne',
        morning: 'jutro',
        afternoon: 'popoldne',
        evening: "ve\u010Der",
        night: "no\u010D"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'zj',
        afternoon: 'p',
        evening: 'zv',
        night: 'po'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'opoln.',
        noon: 'opold.',
        morning: 'zjut.',
        afternoon: 'pop.',
        evening: "zve\u010D.",
        night: "pono\u010Di"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "opolno\u010Di",
        noon: 'opoldne',
        morning: 'zjutraj',
        afternoon: 'popoldan',
        evening: "zve\u010Der",
        night: "pono\u010Di"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eeV7e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3XCK6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
 */ var locale = {
    code: 'sq',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"cAZO1","./_lib/formatLong/index.js":"f0UCY","./_lib/formatRelative/index.js":"hQkJP","./_lib/localize/index.js":"4yHeP","./_lib/match/index.js":"jtrmP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cAZO1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: '{{count}} sekonda'
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: 'rreth 1 muaj',
        other: 'rreth {{count}} muaj'
    },
    xMonths: {
        one: '1 muaj',
        other: '{{count}} muaj'
    },
    aboutXYears: {
        one: 'rreth 1 vit',
        other: 'rreth {{count}} vite'
    },
    xYears: {
        one: '1 vit',
        other: '{{count}} vite'
    },
    overXYears: {
        one: 'mbi 1 vit',
        other: 'mbi {{count}} vite'
    },
    almostXYears: {
        one: 'pothuajse 1 vit',
        other: 'pothuajse {{count}} vite'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f0UCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hQkJP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4yHeP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'P',
        'M'
    ],
    abbreviated: [
        'PK',
        'MK'
    ],
    wide: [
        'Para Krishtit',
        'Mbas Krishtit'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '4-mujori I',
        '4-mujori II',
        '4-mujori III',
        '4-mujori IV'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'S',
        'M',
        'P',
        'M',
        'Q',
        'K',
        'G',
        'S',
        'T',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Shk',
        'Mar',
        'Pri',
        'Maj',
        'Qer',
        'Kor',
        'Gus',
        'Sht',
        'Tet',
        "N\xebn",
        'Dhj'
    ],
    wide: [
        'Janar',
        'Shkurt',
        'Mars',
        'Prill',
        'Maj',
        'Qershor',
        'Korrik',
        'Gusht',
        'Shtator',
        'Tetor',
        "N\xebntor",
        'Dhjetor'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'H',
        'M',
        'M',
        'E',
        'P',
        'S'
    ],
    short: [
        'Di',
        "H\xeb",
        'Ma',
        "M\xeb",
        'En',
        'Pr',
        'Sh'
    ],
    abbreviated: [
        'Die',
        "H\xebn",
        'Mar',
        "M\xebr",
        'Enj',
        'Pre',
        'Sht'
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        'Enjte',
        'Premte',
        "Shtun\xeb"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "m\xebngjes",
        afternoon: 'dite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'hour') return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + 't';
    return number + "-t\xeb";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jtrmP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c4a5E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var locale = {
    code: 'sr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dGC8E","./_lib/formatLong/index.js":"lzxOZ","./_lib/formatRelative/index.js":"lQCtP","./_lib/localize/index.js":"i6tTO","./_lib/match/index.js":"ag5kV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGC8E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
    lessThanXMinutes: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    xMinutes: {
        one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    aboutXHours: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
    },
    xHours: {
        one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
    },
    xDays: {
        one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
    },
    aboutXWeeks: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    xWeeks: {
        one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    aboutXMonths: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xMonths: {
        one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    xYears: {
        one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    overXYears: {
        one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    almostXYears: {
        one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lzxOZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u0443' {{time}}",
    long: "{{date}} '\u0443' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lQCtP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
            case 6:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
            default:
                return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
    },
    yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
    today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
    tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
            case 6:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
            default:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i6tTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u0410\u0414"
    ],
    abbreviated: [
        "\u043F\u0440. \u0425\u0440.",
        "\u043F\u043E. \u0425\u0440."
    ],
    wide: [
        "\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430",
        "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. \u043A\u0432.",
        "2. \u043A\u0432.",
        "3. \u043A\u0432.",
        "4. \u043A\u0432."
    ],
    wide: [
        "1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0423",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u0459\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
        "\u0443\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
        "\u043F\u0435\u0442\u0430\u043A",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ag5kV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
var parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
var parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
var parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4qSpB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var locale = {
    code: 'sr-Latn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"byZA8","./_lib/formatLong/index.js":"fP4dO","./_lib/formatRelative/index.js":"5xpjE","./_lib/localize/index.js":"2HutN","./_lib/match/index.js":"aOq2K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byZA8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 nedelju',
            withPrepositionAgo: 'oko 1 nedelju',
            withPrepositionIn: 'oko 1 nedelju'
        },
        dual: 'oko {{count}} nedelje',
        other: 'oko {{count}} nedelje'
    },
    xWeeks: {
        one: {
            standalone: '1 nedelju',
            withPrepositionAgo: '1 nedelju',
            withPrepositionIn: '1 nedelju'
        },
        dual: '{{count}} nedelje',
        other: '{{count}} nedelje'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mesec',
            withPrepositionAgo: 'oko 1 mesec',
            withPrepositionIn: 'oko 1 mesec'
        },
        dual: 'oko {{count}} meseca',
        other: 'oko {{count}} meseci'
    },
    xMonths: {
        one: {
            standalone: '1 mesec',
            withPrepositionAgo: '1 mesec',
            withPrepositionIn: '1 mesec'
        },
        dual: '{{count}} meseca',
        other: '{{count}} meseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'pre ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fP4dO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5xpjE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedelje u' p";
            case 3:
                return "'pro\u0161le srede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'slede\u0107e nedelje u' p";
            case 3:
                return "'slede\u0107u sredu u' p";
            case 6:
                return "'slede\u0107u subotu u' p";
            default:
                return "'slede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2HutN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Pre Hrista',
        'Posle Hrista'
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedelja',
        'ponedeljak',
        'utorak',
        'sreda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aOq2K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8S82i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var locale = {
    code: 'sv',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"4rBGt","./_lib/formatLong/index.js":"9HbmU","./_lib/formatRelative/index.js":"kZoIX","./_lib/localize/index.js":"dL8J3","./_lib/match/index.js":"dPvqq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4rBGt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: 'en sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'en halv minut',
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: 'en minut',
        other: '{{count}} minuter'
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: 'en timme',
        other: '{{count}} timmar'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: 'en vecka',
        other: '{{count}} vecka'
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var wordMapping = [
    'noll',
    'en',
    "tv\xe5",
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    "\xe5tta",
    'nio',
    'tio',
    'elva',
    'tolv'
];
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sedan';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9HbmU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'y-MM-dd'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kZoIX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dL8J3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf6re Kristus",
        'efter Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1:a kvartalet',
        '2:a kvartalet',
        '3:e kvartalet',
        '4:e kvartalet'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'maj',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'mars',
        'april',
        'maj',
        'juni',
        'juli',
        'augusti',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf6",
        "m\xe5",
        'ti',
        'on',
        'to',
        'fr',
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        'tis',
        'ons',
        'tors',
        'fre',
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        'tisdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var dayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morg.',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    abbreviated: {
        am: 'f.m.',
        pm: 'e.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: 'eftermiddag',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'eftermiddag',
        evening: "kv\xe4ll",
        night: 'natt'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ':a';
    }
    return number + ':e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dPvqq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l6qRR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
 */ var locale = {
    code: 'ta',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"hAwVK","./_lib/formatLong/index.js":"aaIrr","./_lib/formatRelative/index.js":"70qKo","./_lib/localize/index.js":"dWsVi","./_lib/match/index.js":"2c9Oc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAwVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isPluralType(val) {
    return val.one !== undefined;
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
    },
    lessThanXMinutes: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
    },
    xHours: {
        one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xDays: {
        one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXWeeks: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xWeeks: {
        one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXMonths: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    almostXYears: {
        one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var tense = options !== null && options !== void 0 && options.addSuffix ? options.comparison && options.comparison > 0 ? 'in' : 'ago' : 'default';
    var tokenValue = formatDistanceLocale[token];
    if (!isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace('{{count}}', String(count));
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aaIrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// CLDR #1846 - #1849
var dateFormats = {
    full: 'EEEE, d MMMM, y',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'd/M/yy'
};
// CLDR #1850 - #1853
var timeFormats = {
    full: 'a h:mm:ss zzzz',
    long: 'a h:mm:ss z',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"70qKo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dWsVi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    abbreviated: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    // CLDR #1624, #1626
    wide: [
        "\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD",
        "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"
    ] // CLDR #1620, #1622
};
var quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "\u0B95\u0BBE\u0BB2\u0BBE.1",
        "\u0B95\u0BBE\u0BB2\u0BBE.2",
        "\u0B95\u0BBE\u0BB2\u0BBE.3",
        "\u0B95\u0BBE\u0BB2\u0BBE.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"
    ]
};
var monthValues = {
    // CLDR #700 - #711
    narrow: [
        "\u0B9C",
        "\u0BAA\u0BBF",
        "\u0BAE\u0BBE",
        "\u0B8F",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2",
        "\u0B9C\u0BC2",
        "\u0B86",
        "\u0B9A\u0BC6",
        "\u0B85",
        "\u0BA8",
        "\u0B9F\u0BBF"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "\u0B9C\u0BA9.",
        "\u0BAA\u0BBF\u0BAA\u0BCD.",
        "\u0BAE\u0BBE\u0BB0\u0BCD.",
        "\u0B8F\u0BAA\u0BCD.",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95.",
        "\u0B9A\u0BC6\u0BAA\u0BCD.",
        "\u0B85\u0B95\u0BCD.",
        "\u0BA8\u0BB5.",
        "\u0B9F\u0BBF\u0B9A."
    ],
    // CLDR #1652 - #1663
    wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        // January
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        // February
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        // March
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        // April
        "\u0BAE\u0BC7",
        // May
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        // June
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        // July
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        // August
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // September
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        // October
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // November
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD" // December
    ]
};
var dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1752 - #1758
    short: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "\u0B9E\u0BBE\u0BAF\u0BBF.",
        "\u0BA4\u0BBF\u0B99\u0BCD.",
        "\u0B9A\u0BC6\u0BB5\u0BCD.",
        "\u0BAA\u0BC1\u0BA4.",
        "\u0BB5\u0BBF\u0BAF\u0BBE.",
        "\u0BB5\u0BC6\u0BB3\u0BCD.",
        "\u0B9A\u0BA9\u0BBF"
    ],
    // CLDR #1724 - #1730
    wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        // Sunday
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        // Monday
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        // Tuesday
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        // Wednesday
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        // Thursday
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        // Friday
        "\u0B9A\u0BA9\u0BBF" // Saturday
    ]
};
// CLDR #1780 - #1845
var dayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
// CLDR #1780 - #1845
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2c9Oc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
var parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
var parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
var parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gvwZ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
 */ var locale = {
    code: 'te',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"enIuw","./_lib/formatLong/index.js":"j1mKE","./_lib/formatRelative/index.js":"f37Nj","./_lib/localize/index.js":"4DeQF","./_lib/match/index.js":"aRIEI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"enIuw":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    xSeconds: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            // CLDR #1314
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
    },
    lessThanXMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    xMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    aboutXHours: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xHours: {
        standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            // CLDR #1308
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xDays: {
        standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            // CLDR #1292
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    xWeeks: {
        standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    xMonths: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            // CLDR #1281
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    aboutXYears: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    xYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            // CLDR #1275
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    overXYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    almostXYears: {
        standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0C32\u0C4B";
        else return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j1mKE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// CLDR #1807 - #1811
var dateFormats = {
    full: 'd, MMMM y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd-MM-yy'
};
// CLDR #1807 - #1811
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
// CLDR #1815 - #1818
var dateTimeFormats = {
    full: "{{date}} {{time}}'\u0C15\u0C3F'",
    long: "{{date}} {{time}}'\u0C15\u0C3F'",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f37Nj":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0C17\u0C24' eeee p",
    // CLDR #1384
    yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
    // CLDR #1393
    today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
    // CLDR #1394
    tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
    // CLDR #1395
    nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
    // CLDR #1386
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4DeQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
var eraValues = {
    narrow: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    abbreviated: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    wide: [
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02",
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"
    ]
};
// CLDR #1613 - #1628
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0C24\u0C4D\u0C30\u0C481",
        "\u0C24\u0C4D\u0C30\u0C482",
        "\u0C24\u0C4D\u0C30\u0C483",
        "\u0C24\u0C4D\u0C30\u0C484"
    ],
    wide: [
        "1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"
    ]
};
// CLDR #1637 - #1708
var monthValues = {
    narrow: [
        "\u0C1C",
        "\u0C2B\u0C3F",
        "\u0C2E\u0C3E",
        "\u0C0F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42",
        "\u0C1C\u0C41",
        "\u0C06",
        "\u0C38\u0C46",
        "\u0C05",
        "\u0C28",
        "\u0C21\u0C3F"
    ],
    abbreviated: [
        "\u0C1C\u0C28",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
        "\u0C28\u0C35\u0C02",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02"
    ],
    wide: [
        "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
        "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
    ]
};
// CLDR #1709 - #1764
var dayValues = {
    narrow: [
        "\u0C06",
        "\u0C38\u0C4B",
        "\u0C2E",
        "\u0C2C\u0C41",
        "\u0C17\u0C41",
        "\u0C36\u0C41",
        "\u0C36"
    ],
    short: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    abbreviated: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    wide: [
        "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
        "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
        "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
    ]
};
// CLDR #1767 - #1806
var dayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0C35";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRIEI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
var parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
var parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
var parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"81s8f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
 * @author [@hawkup]{@link https://github.com/hawkup}
 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
 */ var locale = {
    code: 'th',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"3pAeA","./_lib/formatLong/index.js":"jawL3","./_lib/formatRelative/index.js":"loAw0","./_lib/localize/index.js":"ePmxs","./_lib/match/index.js":"drGtC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3pAeA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
    },
    aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
    },
    xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
    },
    overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
    },
    almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === 'halfAMinute') return "\u0E43\u0E19" + result;
            else return "\u0E43\u0E19 " + result;
        } else return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jawL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: "H:mm:ss \u0E19. zzzz",
    long: "H:mm:ss \u0E19. z",
    medium: "H:mm:ss \u0E19.",
    short: "H:mm \u0E19."
};
var dateTimeFormats = {
    full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'medium'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"loAw0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
    yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ePmxs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'B',
        "\u0E04\u0E28"
    ],
    abbreviated: [
        'BC',
        "\u0E04.\u0E28."
    ],
    wide: [
        "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25",
        "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"
    ]
};
var dayValues = {
    narrow: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    short: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    abbreviated: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    wide: [
        "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
        "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
        "\u0E1E\u0E38\u0E18",
        "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
        "\u0E28\u0E38\u0E01\u0E23\u0E4C",
        "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
    ]
};
var monthValues = {
    narrow: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    abbreviated: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    wide: [
        "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
        "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
        "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
        "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
        "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
        "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
        "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
        "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
        "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
        "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
        "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
        "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"drGtC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^\d+/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
var parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
var matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3zlpo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var locale = {
    code: 'tr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"cFEnt","./_lib/formatLong/index.js":"hLwA7","./_lib/formatRelative/index.js":"h4UuC","./_lib/localize/index.js":"4SHUj","./_lib/match/index.js":"5wFxm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cFEnt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'bir saniyeden az',
        other: '{{count}} saniyeden az'
    },
    xSeconds: {
        one: '1 saniye',
        other: '{{count}} saniye'
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: 'bir dakikadan az',
        other: '{{count}} dakikadan az'
    },
    xMinutes: {
        one: '1 dakika',
        other: '{{count}} dakika'
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \xf6nce";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hLwA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'd MMMM y EEEE',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h4UuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4SHUj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "M\xd6",
        'MS'
    ],
    abbreviated: [
        "M\xd6",
        'MS'
    ],
    wide: [
        "Milattan \xd6nce",
        'Milattan Sonra'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var monthValues = {
    narrow: [
        'O',
        "\u015E",
        'M',
        'N',
        'M',
        'H',
        'T',
        'A',
        'E',
        'E',
        'K',
        'A'
    ],
    abbreviated: [
        'Oca',
        "\u015Eub",
        'Mar',
        'Nis',
        'May',
        'Haz',
        'Tem',
        "A\u011Fu",
        'Eyl',
        'Eki',
        'Kas',
        'Ara'
    ],
    wide: [
        'Ocak',
        "\u015Eubat",
        'Mart',
        'Nisan',
        "May\u0131s",
        'Haziran',
        'Temmuz',
        "A\u011Fustos",
        "Eyl\xfcl",
        'Ekim',
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
var dayValues = {
    narrow: [
        'P',
        'P',
        'S',
        "\xc7",
        'P',
        'C',
        'C'
    ],
    short: [
        'Pz',
        'Pt',
        'Sa',
        "\xc7a",
        'Pe',
        'Cu',
        'Ct'
    ],
    abbreviated: [
        'Paz',
        'Pzt',
        'Sal',
        "\xc7ar",
        'Per',
        'Cum',
        'Cts'
    ],
    wide: [
        'Pazar',
        'Pazartesi',
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        'Cuma',
        'Cumartesi'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5wFxm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"crzEv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
 */ var locale = {
    code: 'ug',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5DXCS","./_lib/formatLong/index.js":"dfZKH","./_lib/formatRelative/index.js":"cw1yj","./_lib/localize/index.js":"h3gpF","./_lib/match/index.js":"jTOVE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5DXCS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
    },
    halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
    lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
    },
    aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
    },
    xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
    },
    aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
    },
    aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
    },
    aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
    },
    overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
    },
    almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " \u0628\u0648\u0644\u062F\u0649";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dfZKH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u062F\u06D5' {{time}}",
    long: "{{date}} '\u062F\u06D5' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cw1yj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
    yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
    nextWeek: "eeee '\u062F\u06D5' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h3gpF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0628",
        "\u0643"
    ],
    abbreviated: [
        "\u0628",
        "\u0643"
    ],
    wide: [
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646",
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1',
        '2',
        '3',
        '4'
    ],
    wide: [
        "\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0627",
        "\u0645",
        "\u0649",
        "\u0649",
        "\u0627",
        "\u0633",
        "\u06C6",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ],
    wide: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ],
    wide: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jTOVE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
var parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
var matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
var parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8oawC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
 */ var locale = {
    code: 'uk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"aXZMq","./_lib/formatLong/index.js":"awXqT","./_lib/formatRelative/index.js":"aCoJC","./_lib/localize/index.js":"3nFiB","./_lib/match/index.js":"8xZNz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aXZMq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u0437\u0430 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return declension(scheme.regular, count);
    };
}
var halfAtMinute = function halfAtMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: halfAtMinute,
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"awXqT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCoJC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../index.js");
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
var lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: nextWeekFormat,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../index.js":"btU8f","../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3nFiB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    if (unit === 'date') {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === 'minute' || unit === 'second' || unit === 'hour') suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8xZNz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
var parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2yIqt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
 */ var locale = {
    code: 'uz',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"7Cx0u","./_lib/formatLong/index.js":"luPuP","./_lib/formatRelative/index.js":"ilQlU","./_lib/localize/index.js":"8nbTU","./_lib/match/index.js":"cjIph","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Cx0u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'sekunddan kam',
        other: '{{count}} sekunddan kam'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'yarim minut',
    lessThanXMinutes: {
        one: 'bir minutdan kam',
        other: '{{count}} minutdan kam'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: 'tahminan 1 soat',
        other: 'tahminan {{count}} soat'
    },
    xHours: {
        one: '1 soat',
        other: '{{count}} soat'
    },
    xDays: {
        one: '1 kun',
        other: '{{count}} kun'
    },
    aboutXWeeks: {
        one: 'tahminan 1 hafta',
        other: 'tahminan {{count}} hafta'
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: 'tahminan 1 oy',
        other: 'tahminan {{count}} oy'
    },
    xMonths: {
        one: '1 oy',
        other: '{{count}} oy'
    },
    aboutXYears: {
        one: 'tahminan 1 yil',
        other: 'tahminan {{count}} yil'
    },
    xYears: {
        one: '1 yil',
        other: '{{count}} yil'
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: 'deyarli 1 yil',
        other: 'deyarli {{count}} yil'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' dan keyin';
        else return result + ' oldin';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"luPuP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss zzzz',
    long: 'h:mm:ss z',
    medium: 'h:mm:ss',
    short: 'h:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ilQlU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8nbTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'M.A',
        'M.'
    ],
    abbreviated: [
        'M.A',
        'M.'
    ],
    wide: [
        'Miloddan Avvalgi',
        'Milodiy'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'CH.1',
        'CH.2',
        'CH.3',
        'CH.4'
    ],
    wide: [
        '1-chi chorak',
        '2-chi chorak',
        '3-chi chorak',
        '4-chi chorak'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        'Iyun',
        'Iyul',
        'Avg',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        'Iyun',
        'Iyul',
        'Avgust',
        'Sentabr',
        'Oktabr',
        'Noyabr',
        'Dekabr'
    ]
};
var dayValues = {
    narrow: [
        'Y',
        'D',
        'S',
        'CH',
        'P',
        'J',
        'SH'
    ],
    short: [
        'Ya',
        'Du',
        'Se',
        'Cho',
        'Pa',
        'Ju',
        'Sha'
    ],
    abbreviated: [
        'Yak',
        'Dush',
        'Sesh',
        'Chor',
        'Pay',
        'Jum',
        'Shan'
    ],
    wide: [
        'Yakshanba',
        'Dushanba',
        'Seshanba',
        'Chorshanba',
        'Payshanba',
        'Juma',
        'Shanba'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cjIph":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
var parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
var parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5OQW0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28]{@link https://github.com/kamronbek28}
 */ var locale = {
    code: 'uz-Cyrl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"k9kQZ","./_lib/formatLong/index.js":"h9bvt","./_lib/formatRelative/index.js":"iAqDL","./_lib/localize/index.js":"8hFSh","./_lib/match/index.js":"35Ay1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k9kQZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
    },
    halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
    lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
    },
    aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
    },
    xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
    },
    xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
    },
    aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
    },
    xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
    },
    aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
    },
    xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
    },
    almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        else return result + " \u043E\u043B\u0434\u0438\u043D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h9bvt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iAqDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
    yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
    today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
    tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
    nextWeek: "eeee p '\u0434\u0430'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8hFSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u041C.\u0410",
        "\u041C"
    ],
    abbreviated: [
        "\u041C.\u0410",
        "\u041C"
    ],
    wide: [
        "\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438",
        "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0447\u043E\u0440.",
        "2-\u0447\u043E\u0440.",
        "3-\u0447\u043E\u0440.",
        "4-\u0447\u043E\u0440."
    ],
    wide: [
        "1-\u0447\u043E\u0440\u0430\u043A",
        "2-\u0447\u043E\u0440\u0430\u043A",
        "3-\u0447\u043E\u0440\u0430\u043A",
        "4-\u0447\u043E\u0440\u0430\u043A"
    ]
};
var monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043D",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u044F",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440",
        "\u0444\u0435\u0432\u0440\u0430\u043B",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
        "\u043E\u043A\u0442\u0430\u0431\u0440",
        "\u043D\u043E\u044F\u0431\u0440",
        "\u0434\u0435\u043A\u0430\u0431\u0440"
    ]
};
var dayValues = {
    narrow: [
        "\u042F",
        "\u0414",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0416",
        "\u0428"
    ],
    short: [
        "\u044F\u043A",
        "\u0434\u0443",
        "\u0441\u0435",
        "\u0447\u043E",
        "\u043F\u0430",
        "\u0436\u0443",
        "\u0448\u0430"
    ],
    abbreviated: [
        "\u044F\u043A\u0448",
        "\u0434\u0443\u0448",
        "\u0441\u0435\u0448",
        "\u0447\u043E\u0440",
        "\u043F\u0430\u0439",
        "\u0436\u0443\u043C",
        "\u0448\u0430\u043D"
    ],
    wide: [
        "\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
        "\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
        "\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
        "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
        "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
        "\u0436\u0443\u043C\u0430",
        "\u0448\u0430\u043D\u0431\u0430"
    ]
};
var dayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var formattingDayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'any'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"35Ay1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
var parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
var parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
var parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2GiK8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
 */ var locale = {
    code: 'vi',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"guYlS","./_lib/formatLong/index.js":"3XLYh","./_lib/formatRelative/index.js":"8tTWc","./_lib/localize/index.js":"04kSe","./_lib/match/index.js":"34goi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"guYlS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xe2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "n\u1EEDa ph\xfat",
    lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xfat",
        other: "d\u01B0\u1EDBi {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
    },
    xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
    },
    xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
    },
    aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xe1ng",
        other: "kho\u1EA3ng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
    },
    xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
    },
    overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
    },
    almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " n\u1EEFa";
        else return result + " tr\u01B0\u1EDBc";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3XLYh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'n\u0103m' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'n\u0103m' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'n\u0103m' y",
    // 25/08/2017
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: '{{date}} {{time}}',
    // ngày 25 tháng 08 năm 2017 23:25
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8tTWc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 't\u1EDBi v\xe0o l\xfac' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"04kSe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Vietnamese locale reference: http://www.localeplanet.com/icu/vi-VN/index.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
var eraValues = {
    narrow: [
        'TCN',
        'SCN'
    ],
    abbreviated: [
        "tr\u01B0\u1EDBc CN",
        'sau CN'
    ],
    wide: [
        "tr\u01B0\u1EDBc C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
var formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'Thg 1',
        'Thg 2',
        'Thg 3',
        'Thg 4',
        'Thg 5',
        'Thg 6',
        'Thg 7',
        'Thg 8',
        'Thg 9',
        'Thg 10',
        'Thg 11',
        'Thg 12'
    ],
    wide: [
        "Th\xe1ng M\u1ED9t",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng T\u01B0",
        "Th\xe1ng N\u0103m",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng B\u1EA3y",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng M\u01B0\u1EDDi",
        "Th\xe1ng M\u01B0\u1EDDi M\u1ED9t",
        "Th\xe1ng M\u01B0\u1EDDi Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
var formattingMonthValues = {
    narrow: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'thg 1',
        'thg 2',
        'thg 3',
        'thg 4',
        'thg 5',
        'thg 6',
        'thg 7',
        'thg 8',
        'thg 9',
        'thg 10',
        'thg 11',
        'thg 12'
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
var dayValues = {
    narrow: [
        'CN',
        'T2',
        'T3',
        'T4',
        'T5',
        'T6',
        'T7'
    ],
    short: [
        'CN',
        'Th 2',
        'Th 3',
        'Th 4',
        'Th 5',
        'Th 6',
        'Th 7'
    ],
    abbreviated: [
        'CN',
        "Th\u1EE9 2",
        "Th\u1EE9 3",
        "Th\u1EE9 4",
        "Th\u1EE9 5",
        "Th\u1EE9 6",
        "Th\u1EE9 7"
    ],
    wide: [
        "Ch\u1EE7 Nh\u1EADt",
        "Th\u1EE9 Hai",
        "Th\u1EE9 Ba",
        "Th\u1EE9 T\u01B0",
        "Th\u1EE9 N\u0103m",
        "Th\u1EE9 S\xe1u",
        "Th\u1EE9 B\u1EA3y"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
var dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xe0o bu\u1ED5i s\xe1ng",
        afternoon: "v\xe0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xe0o bu\u1ED5i t\u1ED1i",
        night: "v\xe0o ban \u0111\xeam"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'quarter') // many news outlets use "quý I"...
    switch(number){
        case 1:
            return 'I';
        case 2:
            return 'II';
        case 3:
            return 'III';
        case 4:
            return 'IV';
    }
    else if (unit === 'day') // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "th\u1EE9 2";
        // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "th\u1EE9 3";
        // meaning 3rd day
        case 3:
            return "th\u1EE9 4";
        // meaning 4th day and so on
        case 4:
            return "th\u1EE9 5";
        case 5:
            return "th\u1EE9 6";
        case 6:
            return "th\u1EE9 7";
        case 7:
            return "ch\u1EE7 nh\u1EADt";
    }
    else if (unit === 'week') {
        if (number === 1) return "th\u1EE9 nh\u1EA5t";
        else return "th\u1EE9 " + number;
    } else if (unit === 'dayOfYear') {
        if (number === 1) return "\u0111\u1EA7u ti\xean";
        else return "th\u1EE9 " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"34goi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
var parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
var parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
var matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
var matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5iego":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var locale = {
    code: 'zh-CN',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"falKS","./_lib/formatLong/index.js":"5FYcD","./_lib/formatRelative/index.js":"50hYR","./_lib/localize/index.js":"3cu3e","./_lib/match/index.js":"fph5p","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"falKS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5FYcD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"50hYR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function checkWeek(date, baseDate, options) {
    var baseFormat = 'eeee p';
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
var formatRelativeLocale = {
    lastWeek: checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: 'PP p'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3cu3e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number.toString() + "\u65E5";
        case 'hour':
            return number.toString() + "\u65F6";
        case 'minute':
            return number.toString() + "\u5206";
        case 'second':
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fph5p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gI19e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo]{@link https://github.com/gaplo}
 */ var locale = {
    code: 'zh-HK',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5VIel","./_lib/formatLong/index.js":"jYWrr","./_lib/formatRelative/index.js":"9CXVw","./_lib/localize/index.js":"7RpD0","./_lib/match/index.js":"fg6gs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5VIel":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jYWrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9CXVw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7RpD0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fg6gs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8NIxK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var locale = {
    code: 'zh-TW',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"llg2u","./_lib/formatLong/index.js":"4d4yw","./_lib/formatRelative/index.js":"hemIl","./_lib/localize/index.js":"lq0d1","./_lib/match/index.js":"knt6a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"llg2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4d4yw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hemIl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lq0d1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
var monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"knt6a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g4aa7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangeSelectionStrategy", ()=>(0, _dateRangeSelectionStrategy.DateRangeSelectionStrategy));
parcelHelpers.export(exports, "MonthAndYear", ()=>(0, _monthAndYear.MonthAndYear));
parcelHelpers.export(exports, "TimePrecision", ()=>(0, _timePrecision.TimePrecision));
parcelHelpers.export(exports, "DatePickerUtils", ()=>(0, _datePickerUtils.DatePickerUtils));
parcelHelpers.export(exports, "TimePicker", ()=>(0, _timePicker.TimePicker));
parcelHelpers.export(exports, "DatePickerShortcutMenu", ()=>(0, _shortcuts.DatePickerShortcutMenu));
parcelHelpers.export(exports, "TimezoneSelect", ()=>(0, _timezoneSelect.TimezoneSelect));
/* eslint-disable deprecation/deprecation */ parcelHelpers.export(exports, "DateInput", ()=>(0, _dateInput.DateInput));
parcelHelpers.export(exports, "DatePicker", ()=>(0, _datePicker.DatePicker));
parcelHelpers.export(exports, "DateRangeInput", ()=>(0, _dateRangeInput.DateRangeInput));
parcelHelpers.export(exports, "DateRangePicker", ()=>(0, _dateRangePicker.DateRangePicker));
var _common = require("./common");
parcelHelpers.exportAll(_common, exports);
var _dateRangeSelectionStrategy = require("./common/dateRangeSelectionStrategy");
var _monthAndYear = require("./common/monthAndYear");
var _timePrecision = require("./common/timePrecision");
var _datePickerUtils = require("./components/date-picker/datePickerUtils");
var _timePicker = require("./components/time-picker/timePicker");
var _shortcuts = require("./components/shortcuts/shortcuts");
var _timezoneSelect = require("./components/timezone-select/timezoneSelect");
var _dateInput = require("./components/date-input/dateInput");
var _datePicker = require("./components/date-picker/datePicker");
var _dateRangeInput = require("./components/date-range-input/dateRangeInput");
var _dateRangePicker = require("./components/date-range-picker/dateRangePicker");

},{"./common":"1Uxts","./common/dateRangeSelectionStrategy":"avGhV","./common/monthAndYear":"g91nA","./common/timePrecision":"MzfIf","./components/date-picker/datePickerUtils":"fx3O4","./components/time-picker/timePicker":"9s164","./components/shortcuts/shortcuts":"d7O46","./components/timezone-select/timezoneSelect":"RF4or","./components/date-input/dateInput":false,"./components/date-picker/datePicker":false,"./components/date-range-input/dateRangeInput":false,"./components/date-range-picker/dateRangePicker":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Uxts":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Months", ()=>(0, _months.Months));
parcelHelpers.export(exports, "TimeUnit", ()=>(0, _timeUnit.TimeUnit));
parcelHelpers.export(exports, "TimePrecision", ()=>(0, _timePrecision.TimePrecision));
parcelHelpers.export(exports, "TimezoneDisplayFormat", ()=>(0, _timezoneDisplayFormat.TimezoneDisplayFormat));
parcelHelpers.export(exports, "getTimezoneMetadata", ()=>(0, _timezoneMetadata.getTimezoneMetadata));
parcelHelpers.export(exports, "Classes", ()=>_classes);
parcelHelpers.export(exports, "DateUtils", ()=>_dateUtils);
parcelHelpers.export(exports, "Errors", ()=>_errors);
parcelHelpers.export(exports, "TimezoneNameUtils", ()=>_timezoneNameUtils);
parcelHelpers.export(exports, "TimezoneUtils", ()=>_timezoneUtils);
var _classes = require("./classes");
var _dateUtils = require("./dateUtils");
var _errors = require("./errors");
var _timezoneNameUtils = require("./timezoneNameUtils");
var _timezoneUtils = require("./timezoneUtils");
var _months = require("./months");
var _timeUnit = require("./timeUnit");
var _timePrecision = require("./timePrecision");
var _timezoneDisplayFormat = require("./timezoneDisplayFormat");
var _timezoneMetadata = require("./timezoneMetadata");

},{"./classes":"9Dstt","./dateUtils":"rPoyc","./errors":"9rXdI","./timezoneNameUtils":"hh6oW","./timezoneUtils":"kD0r0","./months":"aeoGe","./timeUnit":false,"./timePrecision":"MzfIf","./timezoneDisplayFormat":false,"./timezoneMetadata":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Dstt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATE_INPUT", ()=>DATE_INPUT);
parcelHelpers.export(exports, "DATE_INPUT_POPOVER", ()=>DATE_INPUT_POPOVER);
parcelHelpers.export(exports, "DATE_INPUT_TIMEZONE_SELECT", ()=>DATE_INPUT_TIMEZONE_SELECT);
parcelHelpers.export(exports, "DATEPICKER", ()=>DATEPICKER);
parcelHelpers.export(exports, "DATEPICKER_CAPTION", ()=>DATEPICKER_CAPTION);
parcelHelpers.export(exports, "DATEPICKER_CAPTION_CARET", ()=>DATEPICKER_CAPTION_CARET);
parcelHelpers.export(exports, "DATEPICKER_CAPTION_MEASURE", ()=>DATEPICKER_CAPTION_MEASURE);
parcelHelpers.export(exports, "DATEPICKER_CAPTION_SELECT", ()=>DATEPICKER_CAPTION_SELECT);
parcelHelpers.export(exports, "DATEPICKER_CONTENT", ()=>DATEPICKER_CONTENT);
parcelHelpers.export(exports, "DATEPICKER_DAY", ()=>DATEPICKER_DAY);
parcelHelpers.export(exports, "DATEPICKER_DAY_DISABLED", ()=>DATEPICKER_DAY_DISABLED);
parcelHelpers.export(exports, "DATEPICKER_DAY_OUTSIDE", ()=>DATEPICKER_DAY_OUTSIDE);
parcelHelpers.export(exports, "DATEPICKER_DAY_SELECTED", ()=>DATEPICKER_DAY_SELECTED);
parcelHelpers.export(exports, "DATEPICKER_DAY_IS_TODAY", ()=>DATEPICKER_DAY_IS_TODAY);
parcelHelpers.export(exports, "DATEPICKER_DAY_WRAPPER", ()=>DATEPICKER_DAY_WRAPPER);
parcelHelpers.export(exports, "DATEPICKER_FOOTER", ()=>DATEPICKER_FOOTER);
parcelHelpers.export(exports, "DATEPICKER_MONTH_SELECT", ()=>DATEPICKER_MONTH_SELECT);
parcelHelpers.export(exports, "DATEPICKER_YEAR_SELECT", ()=>DATEPICKER_YEAR_SELECT);
parcelHelpers.export(exports, "DATEPICKER_NAVBAR", ()=>DATEPICKER_NAVBAR);
parcelHelpers.export(exports, "DATEPICKER_NAVBUTTON", ()=>DATEPICKER_NAVBUTTON);
parcelHelpers.export(exports, "DATEPICKER_TIMEPICKER_WRAPPER", ()=>DATEPICKER_TIMEPICKER_WRAPPER);
parcelHelpers.export(exports, "DATERANGEPICKER", ()=>DATERANGEPICKER);
parcelHelpers.export(exports, "DATERANGEPICKER_CALENDARS", ()=>DATERANGEPICKER_CALENDARS);
parcelHelpers.export(exports, "DATERANGEPICKER_CONTIGUOUS", ()=>DATERANGEPICKER_CONTIGUOUS);
parcelHelpers.export(exports, "DATERANGEPICKER_SINGLE_MONTH", ()=>DATERANGEPICKER_SINGLE_MONTH);
parcelHelpers.export(exports, "DATERANGEPICKER_DAY_SELECTED_RANGE", ()=>DATERANGEPICKER_DAY_SELECTED_RANGE);
parcelHelpers.export(exports, "DATERANGEPICKER_DAY_HOVERED_RANGE", ()=>DATERANGEPICKER_DAY_HOVERED_RANGE);
parcelHelpers.export(exports, "DATERANGEPICKER_SHORTCUTS", ()=>DATERANGEPICKER_SHORTCUTS);
parcelHelpers.export(exports, "DATERANGEPICKER_TIMEPICKERS", ()=>DATERANGEPICKER_TIMEPICKERS);
parcelHelpers.export(exports, "DATE_RANGE_INPUT", ()=>DATE_RANGE_INPUT);
parcelHelpers.export(exports, "DATE_RANGE_INPUT_POPOVER", ()=>DATE_RANGE_INPUT_POPOVER);
parcelHelpers.export(exports, "TIMEPICKER", ()=>TIMEPICKER);
parcelHelpers.export(exports, "TIMEPICKER_ARROW_BUTTON", ()=>TIMEPICKER_ARROW_BUTTON);
parcelHelpers.export(exports, "TIMEPICKER_ARROW_ROW", ()=>TIMEPICKER_ARROW_ROW);
parcelHelpers.export(exports, "TIMEPICKER_DIVIDER_TEXT", ()=>TIMEPICKER_DIVIDER_TEXT);
parcelHelpers.export(exports, "TIMEPICKER_HOUR", ()=>TIMEPICKER_HOUR);
parcelHelpers.export(exports, "TIMEPICKER_INPUT", ()=>TIMEPICKER_INPUT);
parcelHelpers.export(exports, "TIMEPICKER_INPUT_ROW", ()=>TIMEPICKER_INPUT_ROW);
parcelHelpers.export(exports, "TIMEPICKER_MILLISECOND", ()=>TIMEPICKER_MILLISECOND);
parcelHelpers.export(exports, "TIMEPICKER_MINUTE", ()=>TIMEPICKER_MINUTE);
parcelHelpers.export(exports, "TIMEPICKER_SECOND", ()=>TIMEPICKER_SECOND);
parcelHelpers.export(exports, "TIMEPICKER_AMPM_SELECT", ()=>TIMEPICKER_AMPM_SELECT);
parcelHelpers.export(exports, "TIMEZONE_SELECT", ()=>TIMEZONE_SELECT);
parcelHelpers.export(exports, "TIMEZONE_SELECT_POPOVER", ()=>TIMEZONE_SELECT_POPOVER);
var _core = require("@blueprintjs/core");
var NS = (0, _core.Classes).getClassNamespace();
var DATE_INPUT = "".concat(NS, "-date-input");
var DATE_INPUT_POPOVER = "".concat(NS, "-date-input-popover");
var DATE_INPUT_TIMEZONE_SELECT = "".concat(NS, "-date-input-timezone-select");
var DATEPICKER = "".concat(NS, "-datepicker");
var DATEPICKER_CAPTION = "".concat(DATEPICKER, "-caption");
var DATEPICKER_CAPTION_CARET = "".concat(DATEPICKER_CAPTION, "-caret");
var DATEPICKER_CAPTION_MEASURE = "".concat(DATEPICKER_CAPTION, "-measure");
var DATEPICKER_CAPTION_SELECT = "".concat(DATEPICKER_CAPTION, "-select");
var DATEPICKER_CONTENT = "".concat(DATEPICKER, "-content");
var DATEPICKER_DAY = "DayPicker-Day";
var DATEPICKER_DAY_DISABLED = "".concat(DATEPICKER_DAY, "--disabled");
var DATEPICKER_DAY_OUTSIDE = "".concat(DATEPICKER_DAY, "--outside");
var DATEPICKER_DAY_SELECTED = "".concat(DATEPICKER_DAY, "--selected");
var DATEPICKER_DAY_IS_TODAY = "".concat(DATEPICKER_DAY, "--isToday");
var DATEPICKER_DAY_WRAPPER = "".concat(DATEPICKER, "-day-wrapper");
var DATEPICKER_FOOTER = "".concat(DATEPICKER, "-footer");
var DATEPICKER_MONTH_SELECT = "".concat(DATEPICKER, "-month-select");
var DATEPICKER_YEAR_SELECT = "".concat(DATEPICKER, "-year-select");
var DATEPICKER_NAVBAR = "".concat(DATEPICKER, "-navbar");
var DATEPICKER_NAVBUTTON = "DayPicker-NavButton";
var DATEPICKER_TIMEPICKER_WRAPPER = "".concat(DATEPICKER, "-timepicker-wrapper");
var DATERANGEPICKER = "".concat(NS, "-daterangepicker");
var DATERANGEPICKER_CALENDARS = "".concat(DATERANGEPICKER, "-calendars");
var DATERANGEPICKER_CONTIGUOUS = "".concat(DATERANGEPICKER, "-contiguous");
var DATERANGEPICKER_SINGLE_MONTH = "".concat(DATERANGEPICKER, "-single-month");
var DATERANGEPICKER_DAY_SELECTED_RANGE = "".concat(DATEPICKER_DAY, "--selected-range");
var DATERANGEPICKER_DAY_HOVERED_RANGE = "".concat(DATEPICKER_DAY, "--hovered-range");
var DATERANGEPICKER_SHORTCUTS = "".concat(DATERANGEPICKER, "-shortcuts");
var DATERANGEPICKER_TIMEPICKERS = "".concat(DATERANGEPICKER, "-timepickers");
var DATE_RANGE_INPUT = "".concat(NS, "-date-range-input");
var DATE_RANGE_INPUT_POPOVER = "".concat(NS, "-date-range-input-popover");
var TIMEPICKER = "".concat(NS, "-timepicker");
var TIMEPICKER_ARROW_BUTTON = "".concat(TIMEPICKER, "-arrow-button");
var TIMEPICKER_ARROW_ROW = "".concat(TIMEPICKER, "-arrow-row");
var TIMEPICKER_DIVIDER_TEXT = "".concat(TIMEPICKER, "-divider-text");
var TIMEPICKER_HOUR = "".concat(TIMEPICKER, "-hour");
var TIMEPICKER_INPUT = "".concat(TIMEPICKER, "-input");
var TIMEPICKER_INPUT_ROW = "".concat(TIMEPICKER, "-input-row");
var TIMEPICKER_MILLISECOND = "".concat(TIMEPICKER, "-millisecond");
var TIMEPICKER_MINUTE = "".concat(TIMEPICKER, "-minute");
var TIMEPICKER_SECOND = "".concat(TIMEPICKER, "-second");
var TIMEPICKER_AMPM_SELECT = "".concat(TIMEPICKER, "-ampm-select");
var TIMEZONE_SELECT = "".concat(NS, "-timezone-select");
var TIMEZONE_SELECT_POPOVER = "".concat(TIMEZONE_SELECT, "-popover");

},{"@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"rPoyc":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSameDay", ()=>(0, _dateFns.isSameDay));
parcelHelpers.export(exports, "clone", ()=>clone);
parcelHelpers.export(exports, "isDateValid", ()=>isDateValid);
parcelHelpers.export(exports, "isEqual", ()=>isEqual);
parcelHelpers.export(exports, "areRangesEqual", ()=>areRangesEqual);
parcelHelpers.export(exports, "isSameMonth", ()=>isSameMonth);
parcelHelpers.export(exports, "isSameTime", ()=>isSameTime);
parcelHelpers.export(exports, "isDayInRange", ()=>isDayInRange);
parcelHelpers.export(exports, "isDayRangeInRange", ()=>isDayRangeInRange);
parcelHelpers.export(exports, "isMonthInRange", ()=>isMonthInRange);
parcelHelpers.export(exports, "isTimeEqualOrGreaterThan", ()=>isTimeEqualOrGreaterThan);
parcelHelpers.export(exports, "isTimeEqualOrSmallerThan", ()=>isTimeEqualOrSmallerThan);
parcelHelpers.export(exports, "isTimeInRange", ()=>isTimeInRange);
parcelHelpers.export(exports, "getTimeInRange", ()=>getTimeInRange);
/**
 * Returns true if the time part of `date` is later than or equal to the time
 * part of `dateToCompare`. The day, month, and year parts will not be compared.
 */ parcelHelpers.export(exports, "isTimeSameOrAfter", ()=>isTimeSameOrAfter);
/**
 * @returns a Date at the exact time-wise midpoint between startDate and endDate
 */ parcelHelpers.export(exports, "getDateBetween", ()=>getDateBetween);
parcelHelpers.export(exports, "getDateTime", ()=>getDateTime);
parcelHelpers.export(exports, "getDateOnlyWithTime", ()=>getDateOnlyWithTime);
parcelHelpers.export(exports, "getDatePreviousMonth", ()=>getDatePreviousMonth);
parcelHelpers.export(exports, "getDateNextMonth", ()=>getDateNextMonth);
parcelHelpers.export(exports, "convert24HourMeridiem", ()=>convert24HourMeridiem);
parcelHelpers.export(exports, "getIsPmFrom24Hour", ()=>getIsPmFrom24Hour);
parcelHelpers.export(exports, "get12HourFrom24Hour", ()=>get12HourFrom24Hour);
parcelHelpers.export(exports, "get24HourFrom12Hour", ()=>get24HourFrom12Hour);
parcelHelpers.export(exports, "isToday", ()=>isToday);
parcelHelpers.export(exports, "hasMonthChanged", ()=>hasMonthChanged);
parcelHelpers.export(exports, "hasTimeChanged", ()=>hasTimeChanged);
var _dateFns = require("date-fns");
var _dateRange = require("./dateRange");
var _months = require("./months");
function clone(d) {
    return new Date(d.getTime());
}
function isDateValid(date) {
    return date instanceof Date && !isNaN(date.valueOf());
}
function isEqual(date1, date2) {
    if (date1 == null && date2 == null) return true;
    else if (date1 == null || date2 == null) return false;
    else return date1.getTime() === date2.getTime();
}
function areRangesEqual(dateRange1, dateRange2) {
    if (dateRange1 == null && dateRange2 == null) return true;
    else if (dateRange1 == null || dateRange2 == null) return false;
    else {
        var start1 = dateRange1[0], end1 = dateRange1[1];
        var start2 = dateRange2[0], end2 = dateRange2[1];
        var areStartsEqual = start1 == null && start2 == null || (0, _dateFns.isSameDay)(start1, start2);
        var areEndsEqual = end1 == null && end2 == null || (0, _dateFns.isSameDay)(end1, end2);
        return areStartsEqual && areEndsEqual;
    }
}
function isSameMonth(date1, date2) {
    return date1 != null && date2 != null && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
}
function isSameTime(d1, d2) {
    // N.B. do not use date-fns helper fns here, since we don't want to return false when the month/day/year is different
    return d1 != null && d2 != null && d1.getHours() === d2.getHours() && d1.getMinutes() === d2.getMinutes() && d1.getSeconds() === d2.getSeconds() && d1.getMilliseconds() === d2.getMilliseconds();
}
function isDayInRange(date, dateRange, exclusive) {
    if (exclusive === void 0) exclusive = false;
    if (date == null || !(0, _dateRange.isNonNullRange)(dateRange)) return false;
    var day = clone(date);
    var start = clone(dateRange[0]);
    var end = clone(dateRange[1]);
    day.setHours(0, 0, 0, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    return start <= day && day <= end && (!exclusive || !(0, _dateFns.isSameDay)(start, day) && !(0, _dateFns.isSameDay)(day, end));
}
function isDayRangeInRange(innerRange, outerRange) {
    return (innerRange[0] == null || isDayInRange(innerRange[0], outerRange)) && (innerRange[1] == null || isDayInRange(innerRange[1], outerRange));
}
function isMonthInRange(date, dateRange) {
    if (date == null) return false;
    var day = clone(date);
    var start = clone(dateRange[0]);
    var end = clone(dateRange[1]);
    day.setDate(1);
    start.setDate(1);
    end.setDate(1);
    day.setHours(0, 0, 0, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    return start <= day && day <= end;
}
var isTimeEqualOrGreaterThan = function(time, timeToCompare) {
    return time.getTime() >= timeToCompare.getTime();
};
var isTimeEqualOrSmallerThan = function(time, timeToCompare) {
    return time.getTime() <= timeToCompare.getTime();
};
function isTimeInRange(date, minDate, maxDate) {
    var time = getDateOnlyWithTime(date);
    var minTime = getDateOnlyWithTime(minDate);
    var maxTime = getDateOnlyWithTime(maxDate);
    var isTimeGreaterThanMinTime = isTimeEqualOrGreaterThan(time, minTime);
    var isTimeSmallerThanMaxTime = isTimeEqualOrSmallerThan(time, maxTime);
    if (isTimeEqualOrSmallerThan(maxTime, minTime)) return isTimeGreaterThanMinTime || isTimeSmallerThanMaxTime;
    return isTimeGreaterThanMinTime && isTimeSmallerThanMaxTime;
}
function getTimeInRange(time, minTime, maxTime) {
    if (isSameTime(minTime, maxTime)) return maxTime;
    else if (isTimeInRange(time, minTime, maxTime)) return time;
    else if (isTimeSameOrAfter(time, maxTime)) return maxTime;
    return minTime;
}
function isTimeSameOrAfter(date, dateToCompare) {
    var time = getDateOnlyWithTime(date);
    var timeToCompare = getDateOnlyWithTime(dateToCompare);
    return isTimeEqualOrGreaterThan(time, timeToCompare);
}
function getDateBetween(dateRange) {
    var start = dateRange[0].getTime();
    var end = dateRange[1].getTime();
    var middle = start + (end - start) * 0.5;
    return new Date(middle);
}
function getDateTime(date, time) {
    if (date == null) return null;
    else if (time == null) // cannot use default argument because `null` is a common value in this package.
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
    else return new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
}
function getDateOnlyWithTime(date) {
    return new Date(0, 0, 0, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function getDatePreviousMonth(date) {
    if (date.getMonth() === (0, _months.Months).JANUARY) return new Date(date.getFullYear() - 1, (0, _months.Months).DECEMBER);
    else return new Date(date.getFullYear(), date.getMonth() - 1);
}
function getDateNextMonth(date) {
    if (date.getMonth() === (0, _months.Months).DECEMBER) return new Date(date.getFullYear() + 1, (0, _months.Months).JANUARY);
    else return new Date(date.getFullYear(), date.getMonth() + 1);
}
function convert24HourMeridiem(hour, toPm) {
    if (hour < 0 || hour > 23) throw new Error("hour must be between [0,23] inclusive: got ".concat(hour));
    return toPm ? hour % 12 + 12 : hour % 12;
}
function getIsPmFrom24Hour(hour) {
    if (hour < 0 || hour > 23) throw new Error("hour must be between [0,23] inclusive: got ".concat(hour));
    return hour >= 12;
}
function get12HourFrom24Hour(hour) {
    if (hour < 0 || hour > 23) throw new Error("hour must be between [0,23] inclusive: got ".concat(hour));
    var newHour = hour % 12;
    return newHour === 0 ? 12 : newHour;
}
function get24HourFrom12Hour(hour, isPm) {
    if (hour < 1 || hour > 12) throw new Error("hour must be between [1,12] inclusive: got ".concat(hour));
    var newHour = hour === 12 ? 0 : hour;
    return isPm ? newHour + 12 : newHour;
}
function isToday(date) {
    return (0, _dateFns.isSameDay)(date, new Date());
}
function hasMonthChanged(prevDate, nextDate) {
    return prevDate == null !== (nextDate == null) || (nextDate === null || nextDate === void 0 ? void 0 : nextDate.getMonth()) !== (prevDate === null || prevDate === void 0 ? void 0 : prevDate.getMonth());
}
function hasTimeChanged(prevDate, nextDate) {
    return prevDate == null !== (nextDate == null) || (nextDate === null || nextDate === void 0 ? void 0 : nextDate.getHours()) !== (prevDate === null || prevDate === void 0 ? void 0 : prevDate.getHours()) || (nextDate === null || nextDate === void 0 ? void 0 : nextDate.getMinutes()) !== (prevDate === null || prevDate === void 0 ? void 0 : prevDate.getMinutes()) || (nextDate === null || nextDate === void 0 ? void 0 : nextDate.getSeconds()) !== (prevDate === null || prevDate === void 0 ? void 0 : prevDate.getSeconds()) || (nextDate === null || nextDate === void 0 ? void 0 : nextDate.getMilliseconds()) !== (prevDate === null || prevDate === void 0 ? void 0 : prevDate.getMilliseconds());
}

},{"date-fns":"btU8f","./dateRange":"5DqwI","./months":"aeoGe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5DqwI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* istanbul ignore next */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNonNullRange", ()=>isNonNullRange);
function isNonNullRange(range) {
    return range[0] != null && range[1] != null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aeoGe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Enumeration of calendar months.
 *
 * Note that the enum values are numbers (with January as `0`) so they can be
 * easily compared to `date.getMonth()`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Months", ()=>Months);
var Months;
(function(Months) {
    Months[Months["JANUARY"] = 0] = "JANUARY";
    Months[Months["FEBRUARY"] = 1] = "FEBRUARY";
    Months[Months["MARCH"] = 2] = "MARCH";
    Months[Months["APRIL"] = 3] = "APRIL";
    Months[Months["MAY"] = 4] = "MAY";
    Months[Months["JUNE"] = 5] = "JUNE";
    Months[Months["JULY"] = 6] = "JULY";
    Months[Months["AUGUST"] = 7] = "AUGUST";
    Months[Months["SEPTEMBER"] = 8] = "SEPTEMBER";
    Months[Months["OCTOBER"] = 9] = "OCTOBER";
    Months[Months["NOVEMBER"] = 10] = "NOVEMBER";
    Months[Months["DECEMBER"] = 11] = "DECEMBER";
})(Months || (Months = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9rXdI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATEPICKER_DEFAULT_VALUE_INVALID", ()=>DATEPICKER_DEFAULT_VALUE_INVALID);
parcelHelpers.export(exports, "DATEPICKER_INITIAL_MONTH_INVALID", ()=>DATEPICKER_INITIAL_MONTH_INVALID);
parcelHelpers.export(exports, "DATEPICKER_MAX_DATE_INVALID", ()=>DATEPICKER_MAX_DATE_INVALID);
parcelHelpers.export(exports, "DATEPICKER_VALUE_INVALID", ()=>DATEPICKER_VALUE_INVALID);
parcelHelpers.export(exports, "DATERANGEPICKER_DEFAULT_VALUE_INVALID", ()=>DATERANGEPICKER_DEFAULT_VALUE_INVALID);
parcelHelpers.export(exports, "DATERANGEPICKER_INITIAL_MONTH_INVALID", ()=>DATERANGEPICKER_INITIAL_MONTH_INVALID);
parcelHelpers.export(exports, "DATERANGEPICKER_MAX_DATE_INVALID", ()=>DATERANGEPICKER_MAX_DATE_INVALID);
parcelHelpers.export(exports, "DATERANGEPICKER_VALUE_INVALID", ()=>DATERANGEPICKER_VALUE_INVALID);
parcelHelpers.export(exports, "DATERANGEPICKER_PREFERRED_BOUNDARY_TO_MODIFY_INVALID", ()=>DATERANGEPICKER_PREFERRED_BOUNDARY_TO_MODIFY_INVALID);
parcelHelpers.export(exports, "DATERANGEINPUT_NULL_VALUE", ()=>DATERANGEINPUT_NULL_VALUE);
parcelHelpers.export(exports, "DATEINPUT_INVALID_DEFAULT_TIMEZONE", ()=>DATEINPUT_INVALID_DEFAULT_TIMEZONE);
parcelHelpers.export(exports, "DATEINPUT_INVALID_TIMEZONE", ()=>DATEINPUT_INVALID_TIMEZONE);
var ns = "[Blueprint]";
var DATEPICKER_DEFAULT_VALUE_INVALID = ns + " <DatePicker> defaultValue must be within minDate and maxDate bounds.";
var DATEPICKER_INITIAL_MONTH_INVALID = ns + " <DatePicker> initialMonth must be within minDate and maxDate bounds.";
var DATEPICKER_MAX_DATE_INVALID = ns + " <DatePicker> maxDate must be later than minDate.";
var DATEPICKER_VALUE_INVALID = ns + " <DatePicker> value prop must be within minDate and maxDate bounds.";
var DATERANGEPICKER_DEFAULT_VALUE_INVALID = DATEPICKER_DEFAULT_VALUE_INVALID.replace("DatePicker", "DateRangePicker");
var DATERANGEPICKER_INITIAL_MONTH_INVALID = DATEPICKER_INITIAL_MONTH_INVALID.replace("DatePicker", "DateRangePicker");
var DATERANGEPICKER_MAX_DATE_INVALID = DATEPICKER_MAX_DATE_INVALID.replace("DatePicker", "DateRangePicker");
var DATERANGEPICKER_VALUE_INVALID = DATEPICKER_VALUE_INVALID.replace("DatePicker", "DateRangePicker");
var DATERANGEPICKER_PREFERRED_BOUNDARY_TO_MODIFY_INVALID = "<DateRangePicker> preferredBoundaryToModify must be a valid Boundary if defined.";
var DATERANGEINPUT_NULL_VALUE = ns + " <DateRangeInput> value cannot be null. Pass undefined to clear the value and operate in" + " uncontrolled mode, or pass [null, null] to clear the value and continue operating in controlled mode.";
var DATEINPUT_INVALID_DEFAULT_TIMEZONE = "".concat(ns, " <DateInput> was provided an invalid defaultTimezone, defaulting to Etc/UTC instead");
var DATEINPUT_INVALID_TIMEZONE = "".concat(ns, " <DateInput> was provided an invalid timezone, defaulting to Etc/UTC instead");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hh6oW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidTimezone", ()=>isValidTimezone);
parcelHelpers.export(exports, "getTimezoneShortName", ()=>getTimezoneShortName);
/**
 * Augments a simple {@link Timezone} metadata object with long and short names formatted by `date-fns-tz`.
 */ parcelHelpers.export(exports, "getTimezoneNames", ()=>getTimezoneNames);
parcelHelpers.export(exports, "mapTimezonesWithNames", ()=>mapTimezonesWithNames);
parcelHelpers.export(exports, "getInitialTimezoneItems", ()=>getInitialTimezoneItems);
var _tslib = require("tslib");
var _dateFnsTz = require("date-fns-tz");
var _getTimezone = require("./getTimezone");
var _timezoneItems = require("./timezoneItems");
var CURRENT_DATE = Date.now();
var LONG_NAME_FORMAT_STR = "zzzz";
var SHORT_NAME_FORMAT_STR = "zzz";
function isValidTimezone(timeZone) {
    if (timeZone === undefined) return false;
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch (e) {
        return false;
    }
}
function getTimezoneShortName(tzIanaCode, date) {
    return (0, _dateFnsTz.formatInTimeZone)(date !== null && date !== void 0 ? date : CURRENT_DATE, tzIanaCode, SHORT_NAME_FORMAT_STR);
}
function getTimezoneNames(tz, date) {
    if (date === void 0) date = CURRENT_DATE;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, tz), {
        longName: (0, _dateFnsTz.formatInTimeZone)(date, tz.ianaCode, LONG_NAME_FORMAT_STR),
        shortName: (0, _dateFnsTz.formatInTimeZone)(date, tz.ianaCode, SHORT_NAME_FORMAT_STR)
    });
}
var mapTimezonesWithNames = function(date, timezones) {
    return timezones.map(function(tz) {
        return getTimezoneNames(tz, date);
    });
};
function getInitialTimezoneItems(date, showLocalTimezone) {
    var systemTimezone = (0, _getTimezone.getCurrentTimezone)();
    var localTimezone = showLocalTimezone ? (0, _timezoneItems.TIMEZONE_ITEMS).find(function(timezone) {
        return timezone.ianaCode === systemTimezone;
    }) : undefined;
    var localTimezoneItem = localTimezone !== undefined ? (0, _tslib.__assign)((0, _tslib.__assign)({}, localTimezone), {
        longName: "Current timezone",
        shortName: (0, _dateFnsTz.formatInTimeZone)(date !== null && date !== void 0 ? date : CURRENT_DATE, localTimezone.ianaCode, SHORT_NAME_FORMAT_STR)
    }) : undefined;
    var minimalTimezoneItemsWithNames = mapTimezonesWithNames(date, (0, _timezoneItems.MINIMAL_TIMEZONE_ITEMS)).filter(function(tz) {
        return tz.ianaCode !== (localTimezoneItem === null || localTimezoneItem === void 0 ? void 0 : localTimezoneItem.ianaCode);
    });
    return localTimezoneItem === undefined ? minimalTimezoneItemsWithNames : (0, _tslib.__spreadArray)([
        localTimezoneItem
    ], minimalTimezoneItemsWithNames, true);
}

},{"tslib":"b4wpY","date-fns-tz":"4WMBd","./getTimezone":"2rMgD","./timezoneItems":"jepBL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4WMBd":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "formatInTimeZone", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "getTimezoneOffset", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "toDate", ()=>(0, _indexJsDefault3.default));
parcelHelpers.export(exports, "utcToZonedTime", ()=>(0, _indexJsDefault4.default));
parcelHelpers.export(exports, "zonedTimeToUtc", ()=>(0, _indexJsDefault5.default));
var _indexJs = require("./format/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./formatInTimeZone/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./getTimezoneOffset/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./toDate/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./utcToZonedTime/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./zonedTimeToUtc/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);

},{"./format/index.js":false,"./formatInTimeZone/index.js":"h2Mst","./getTimezoneOffset/index.js":"brR0k","./toDate/index.js":false,"./utcToZonedTime/index.js":"egkRD","./zonedTimeToUtc/index.js":"hvE7E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cEzmy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _indexJs = require("date-fns/format/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./formatters/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match(tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, _indexJsDefault2.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, _indexJsDefault1.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, _indexJsDefault.default)(dirtyDate, formatStr, options);
}

},{"date-fns/format/index.js":"cnVe2","./formatters/index.js":"irkMu","../toDate/index.js":"c5C6z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cnVe2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f86d579e42626f4f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = format;
var _index = _interopRequireDefault(require("1fe30f48a2b12a18"));
var _index2 = _interopRequireDefault(require("91da7a7bb9731bc8"));
var _index3 = _interopRequireDefault(require("cbcdcb8bbba7cdd6"));
var _index4 = _interopRequireDefault(require("4bf37781a1e85da9"));
var _index5 = _interopRequireDefault(require("c7c9036672c9968"));
var _index6 = _interopRequireDefault(require("9b7316e82f4ca54d"));
var _index7 = require("a5dc5e69d88524a");
var _index8 = _interopRequireDefault(require("80674666a5ea4684"));
var _index9 = _interopRequireDefault(require("a70699f62d7110c2"));
var _index10 = require("87602e21a4fc6ea7");
var _index11 = _interopRequireDefault(require("6ecf1bdd9838a1b6"));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _index10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
    var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, _index3.default)(dirtyDate);
    if (!(0, _index.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _index6.default)(originalDate);
    var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = _index5.default[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = _index4.default[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}
module.exports = exports.default;

},{"f86d579e42626f4f":"kZ6eK","1fe30f48a2b12a18":"sVYaY","91da7a7bb9731bc8":"4cGN8","cbcdcb8bbba7cdd6":"gXAVm","4bf37781a1e85da9":"7pEDK","c7c9036672c9968":"8DtMz","9b7316e82f4ca54d":"dOJRl","a5dc5e69d88524a":"kbVzs","80674666a5ea4684":"l4B11","a70699f62d7110c2":"a596E","87602e21a4fc6ea7":"aHkDq","6ecf1bdd9838a1b6":"eyN48"}],"kZ6eK":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"sVYaY":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3339310cd01d224c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isValid;
var _index = _interopRequireDefault(require("17f7a33424d53065"));
var _index2 = _interopRequireDefault(require("988a1b9d58fb9dc3"));
var _index3 = _interopRequireDefault(require("e664e6a1553fb1e0"));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function isValid(dirtyDate) {
    (0, _index3.default)(1, arguments);
    if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, _index2.default)(dirtyDate);
    return !isNaN(Number(date));
}
module.exports = exports.default;

},{"3339310cd01d224c":"kZ6eK","17f7a33424d53065":"5t5IA","988a1b9d58fb9dc3":"gXAVm","e664e6a1553fb1e0":"a596E"}],"5t5IA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("338466e455b14575").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isDate;
var _typeof2 = _interopRequireDefault(require("b8bbff02b11f8d53"));
var _index = _interopRequireDefault(require("711bcf4ba0de247c"));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function isDate(value) {
    (0, _index.default)(1, arguments);
    return value instanceof Date || (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
module.exports = exports.default;

},{"338466e455b14575":"kZ6eK","b8bbff02b11f8d53":"979to","711bcf4ba0de247c":"a596E"}],"979to":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"a596E":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = requiredArgs;
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = exports.default;

},{}],"gXAVm":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2b2ebc7d56df52bd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toDate;
var _typeof2 = _interopRequireDefault(require("a126697796216d4d"));
var _index = _interopRequireDefault(require("5c5ecf72f02d842c"));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function toDate(argument) {
    (0, _index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeof2.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = exports.default;

},{"2b2ebc7d56df52bd":"kZ6eK","a126697796216d4d":"979to","5c5ecf72f02d842c":"a596E"}],"4cGN8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("982587670168e5f3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subMilliseconds;
var _index = _interopRequireDefault(require("c5d9824c393085d7"));
var _index2 = _interopRequireDefault(require("d8f669c4845e1248"));
var _index3 = _interopRequireDefault(require("4c81ec5fa767dd0e"));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _index2.default)(2, arguments);
    var amount = (0, _index3.default)(dirtyAmount);
    return (0, _index.default)(dirtyDate, -amount);
}
module.exports = exports.default;

},{"982587670168e5f3":"kZ6eK","c5d9824c393085d7":"5xM9i","d8f669c4845e1248":"a596E","4c81ec5fa767dd0e":"l4B11"}],"5xM9i":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("95756b80fa126250").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addMilliseconds;
var _index = _interopRequireDefault(require("e0d1cd2fc430dc41"));
var _index2 = _interopRequireDefault(require("2c24b24f968ff7de"));
var _index3 = _interopRequireDefault(require("169293c116ef1f15"));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var timestamp = (0, _index2.default)(dirtyDate).getTime();
    var amount = (0, _index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = exports.default;

},{"95756b80fa126250":"kZ6eK","e0d1cd2fc430dc41":"l4B11","2c24b24f968ff7de":"gXAVm","169293c116ef1f15":"a596E"}],"l4B11":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toInteger;
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = exports.default;

},{}],"7pEDK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c3cabd8a75691399").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("e18d65780c808351"));
var _index2 = _interopRequireDefault(require("7a7545910d16b33f"));
var _index3 = _interopRequireDefault(require("c03a85779c66753e"));
var _index4 = _interopRequireDefault(require("17e4cc5d10f8dd59"));
var _index5 = _interopRequireDefault(require("792bde6e71038421"));
var _index6 = _interopRequireDefault(require("3d2219d4eacb96a7"));
var _index7 = _interopRequireDefault(require("aa768d00659e9a8b"));
var dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return _index7.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _index5.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, _index6.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, _index6.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _index3.default)(date);
        // Padding
        return (0, _index6.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _index6.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, _index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, _index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return _index7.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, _index6.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _index4.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, _index6.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _index2.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, _index6.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return _index7.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _index.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, _index6.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, _index6.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, _index6.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, _index6.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return _index7.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return _index7.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _index6.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _index6.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return _index7.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return _index7.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return _index7.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _index6.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _index6.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var _default = formatters;
exports.default = _default;
module.exports = exports.default;

},{"c3cabd8a75691399":"kZ6eK","e18d65780c808351":"dwGun","7a7545910d16b33f":"huaw6","c03a85779c66753e":"5PlmB","17e4cc5d10f8dd59":"23xgT","792bde6e71038421":"XQNJE","3d2219d4eacb96a7":"7RWFH","aa768d00659e9a8b":"4fRLQ"}],"dwGun":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("63ab70f76e61c379").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCDayOfYear;
var _index = _interopRequireDefault(require("4b7483fab6f6f147"));
var _index2 = _interopRequireDefault(require("467f90d9b0286522"));
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
module.exports = exports.default;

},{"63ab70f76e61c379":"kZ6eK","4b7483fab6f6f147":"gXAVm","467f90d9b0286522":"a596E"}],"huaw6":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("fb68fbc215d258f4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCISOWeek;
var _index = _interopRequireDefault(require("3e4a03f3d08187e5"));
var _index2 = _interopRequireDefault(require("12a52f6fe6354603"));
var _index3 = _interopRequireDefault(require("33a067968a51f03b"));
var _index4 = _interopRequireDefault(require("8c2e14ddd62ad78a"));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

},{"fb68fbc215d258f4":"kZ6eK","3e4a03f3d08187e5":"gXAVm","12a52f6fe6354603":"d0ebO","33a067968a51f03b":"gvLHz","8c2e14ddd62ad78a":"a596E"}],"d0ebO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2393c04e863e086f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCISOWeek;
var _index = _interopRequireDefault(require("88bd8243a6fb9a75"));
var _index2 = _interopRequireDefault(require("7185b2bd8b0e0ab0"));
function startOfUTCISOWeek(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;

},{"2393c04e863e086f":"kZ6eK","88bd8243a6fb9a75":"gXAVm","7185b2bd8b0e0ab0":"a596E"}],"gvLHz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b5d4742ad8f9124e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCISOWeekYear;
var _index = _interopRequireDefault(require("4df9ac36cfb76094"));
var _index2 = _interopRequireDefault(require("3e25d8f8bf5f9829"));
var _index3 = _interopRequireDefault(require("25e58783c3feea35"));
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _index3.default)(1, arguments);
    var year = (0, _index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _index2.default)(fourthOfJanuary);
    return date;
}
module.exports = exports.default;

},{"b5d4742ad8f9124e":"kZ6eK","4df9ac36cfb76094":"5PlmB","3e25d8f8bf5f9829":"d0ebO","25e58783c3feea35":"a596E"}],"5PlmB":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2d47386185bb2409").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCISOWeekYear;
var _index = _interopRequireDefault(require("c140cac95f358d97"));
var _index2 = _interopRequireDefault(require("81cc93a9fe9fbf4b"));
var _index3 = _interopRequireDefault(require("23fc4aa122fcad18"));
function getUTCISOWeekYear(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = exports.default;

},{"2d47386185bb2409":"kZ6eK","c140cac95f358d97":"gXAVm","81cc93a9fe9fbf4b":"a596E","23fc4aa122fcad18":"d0ebO"}],"23xgT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2b29c1a3ff28030a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCWeek;
var _index = _interopRequireDefault(require("9c098228a4cb1ff0"));
var _index2 = _interopRequireDefault(require("fecdbb0ae8f01baa"));
var _index3 = _interopRequireDefault(require("b3e36117033835d5"));
var _index4 = _interopRequireDefault(require("bae4d6de1972a08d"));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

},{"2b29c1a3ff28030a":"kZ6eK","9c098228a4cb1ff0":"gXAVm","fecdbb0ae8f01baa":"6k1iV","b3e36117033835d5":"e4nsr","bae4d6de1972a08d":"a596E"}],"6k1iV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b9ccd1e3e5453533").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCWeek;
var _index = _interopRequireDefault(require("3cf930c1f8a75177"));
var _index2 = _interopRequireDefault(require("16657271cd31aa61"));
var _index3 = _interopRequireDefault(require("59c0acd5397c2e99"));
var _index4 = require("50cd3ec2eee20af4");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var defaultOptions = (0, _index4.getDefaultOptions)();
    var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;

},{"b9ccd1e3e5453533":"kZ6eK","3cf930c1f8a75177":"gXAVm","16657271cd31aa61":"a596E","59c0acd5397c2e99":"l4B11","50cd3ec2eee20af4":"aHkDq"}],"aHkDq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{}],"e4nsr":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("29e744893ccacc45").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCWeekYear;
var _index = _interopRequireDefault(require("1e46324a3287aee4"));
var _index2 = _interopRequireDefault(require("d22b2df3e54bba59"));
var _index3 = _interopRequireDefault(require("cd0cf10ea1b96f85"));
var _index4 = _interopRequireDefault(require("1020ce8d2bc92a46"));
var _index5 = require("972a0ccb92d8bbe4");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var defaultOptions = (0, _index5.getDefaultOptions)();
    var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _index3.default)(firstWeek, options);
    return date;
}
module.exports = exports.default;

},{"29e744893ccacc45":"kZ6eK","1e46324a3287aee4":"XQNJE","d22b2df3e54bba59":"a596E","cd0cf10ea1b96f85":"6k1iV","1020ce8d2bc92a46":"l4B11","972a0ccb92d8bbe4":"aHkDq"}],"XQNJE":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("92759581cef1be85").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCWeekYear;
var _index = _interopRequireDefault(require("38626c34abbfd5cc"));
var _index2 = _interopRequireDefault(require("dc8dd1ae5924c300"));
var _index3 = _interopRequireDefault(require("391cd5e455c9f364"));
var _index4 = _interopRequireDefault(require("fa6c59702933a671"));
var _index5 = require("11ea2a2b415afa1");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _index5.getDefaultOptions)();
    var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = exports.default;

},{"92759581cef1be85":"kZ6eK","38626c34abbfd5cc":"gXAVm","dc8dd1ae5924c300":"a596E","391cd5e455c9f364":"6k1iV","fa6c59702933a671":"l4B11","11ea2a2b415afa1":"aHkDq"}],"7RWFH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = exports.default;

},{}],"4fRLQ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("31b536496484381f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("70c9714f0a3fc09e"));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _index.default)(fractionalSeconds, token.length);
    }
};
var _default = formatters;
exports.default = _default;
module.exports = exports.default;

},{"31b536496484381f":"kZ6eK","70c9714f0a3fc09e":"7RWFH"}],"8DtMz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
var _default = longFormatters;
exports.default = _default;
module.exports = exports.default;

},{}],"dOJRl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = exports.default;

},{}],"kbVzs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = [
    'D',
    'DD'
];
var protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{}],"eyN48":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ff544fa389713d11").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("f3c5cb0655b45cc9"));
var _default = _index.default;
exports.default = _default;
module.exports = exports.default;

},{"ff544fa389713d11":"kZ6eK","f3c5cb0655b45cc9":"gqqxX"}],"gqqxX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("8f4b9a4f1b239517").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("a646f952b19f4966"));
var _index2 = _interopRequireDefault(require("33fc832b764d1ce6"));
var _index3 = _interopRequireDefault(require("335053a879a54f9"));
var _index4 = _interopRequireDefault(require("c96792daf63a81fa"));
var _index5 = _interopRequireDefault(require("f1f6ef78114f9d94"));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: 'en-US',
    formatDistance: _index.default,
    formatLong: _index2.default,
    formatRelative: _index3.default,
    localize: _index4.default,
    match: _index5.default,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var _default = locale;
exports.default = _default;
module.exports = exports.default;

},{"8f4b9a4f1b239517":"kZ6eK","a646f952b19f4966":"aWINV","33fc832b764d1ce6":"cJRzD","335053a879a54f9":"c7VYp","c96792daf63a81fa":"3boa5","f1f6ef78114f9d94":"g0X76"}],"aWINV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var _default = formatDistance;
exports.default = _default;
module.exports = exports.default;

},{}],"cJRzD":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("22d6b94e52f0d51c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("9a7f687abdf37369"));
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _index.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _index.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _index.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
var _default = formatLong;
exports.default = _default;
module.exports = exports.default;

},{"22d6b94e52f0d51c":"kZ6eK","9a7f687abdf37369":"apzff"}],"apzff":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildFormatLongFn;
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = exports.default;

},{}],"c7VYp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
var _default = formatRelative;
exports.default = _default;
module.exports = exports.default;

},{}],"3boa5":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("eb01f1742f0dce6a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("df0d0075432877a6"));
var eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _index.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _index.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _index.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _index.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _index.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var _default = localize;
exports.default = _default;
module.exports = exports.default;

},{"eb01f1742f0dce6a":"kZ6eK","df0d0075432877a6":"iLfR5"}],"iLfR5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildLocalizeFn;
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = exports.default;

},{}],"g0X76":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("54673652a9d9ab5e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("1158505ef900e368"));
var _index2 = _interopRequireDefault(require("49922fc0dddfaa90"));
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _index2.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _index.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _index.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _index.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _index.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _index.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var _default = match;
exports.default = _default;
module.exports = exports.default;

},{"54673652a9d9ab5e":"kZ6eK","1158505ef900e368":"3XA0v","49922fc0dddfaa90":"jol1B"}],"3XA0v":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildMatchFn;
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = exports.default;

},{}],"jol1B":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildMatchPatternFn;
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = exports.default;

},{}],"irkMu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../_lib/tzIntlTimeZoneName/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../_lib/tzParseTimezone/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_MINUTE = 60000;
var formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, _indexJsDefault.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, _indexJsDefault.default)('long', date, options);
        }
    }
};
function getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, _indexJsDefault1.default)(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimeter);
}
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
exports.default = formatters;

},{"../../_lib/tzIntlTimeZoneName/index.js":"gV60S","../../_lib/tzParseTimezone/index.js":"846od","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gV60S":[function(require,module,exports,__globalThis) {
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tzIntlTimeZoneName);
function tzIntlTimeZoneName(length, date, options) {
    var dtf = getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
}
function partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"846od":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tzParseTimezone);
var _indexJs = require("../tzTokenizeDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../newDateUTC/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function tzParseTimezone(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!validateTimezone(hours)) return NaN;
        return -(hours * MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if (isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : toUtcDate(date);
        var offset = calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function toUtcDate(date) {
    return (0, _indexJsDefault1.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function calcOffset(date, timezoneString) {
    var tokens = (0, _indexJsDefault.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, _indexJsDefault1.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var validIANATimezoneCache = {};
function isValidTimezoneIANAString(timeZoneString) {
    if (validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

},{"../tzTokenizeDate/index.js":"9OXaO","../newDateUTC/index.js":"b4kv3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9OXaO":[function(require,module,exports,__globalThis) {
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tzTokenizeDate);
function tzTokenizeDate(date, timeZone) {
    var dtf = getDateTimeFormat(timeZone);
    return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}
var typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var dtfCache = {};
function getDateTimeFormat(timeZone) {
    if (!dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return dtfCache[timeZone];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4kv3":[function(require,module,exports,__globalThis) {
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newDateUTC);
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c5C6z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _indexJs = require("date-fns/_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/tzPattern/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, _indexJsDefault3.default)
};
function toDate(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _indexJsDefault.default)(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, _indexJsDefault2.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, _indexJsDefault1.default)(new Date(timestamp + time));
            offset = (0, _indexJsDefault1.default)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function splitDateString(dateString) {
    var dateStrings = {};
    var parts = patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var patternYYY = patterns.YYY[additionalDigits];
    var patternYYYYY = patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!validateWeekDate(year, week)) return new Date(NaN);
        return dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!validateTime(hours)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!validateTime(hours, minutes)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = isLeapYearIndex(year);
        if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

},{"date-fns/_lib/toInteger/index.js":"l4B11","date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js":"dOJRl","../_lib/tzParseTimezone/index.js":"846od","../_lib/tzPattern/index.js":"elKoB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"elKoB":[function(require,module,exports,__globalThis) {
/** Regex to identify the presence of a time zone specifier in a date string */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
exports.default = tzPattern;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h2Mst":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatInTimeZone);
var _indexJs = require("date-fns/_lib/cloneObject/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../format/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../utcToZonedTime/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function formatInTimeZone(date, timeZone, formatStr, options) {
    var extendedOptions = (0, _indexJsDefault.default)(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, _indexJsDefault1.default)((0, _indexJsDefault2.default)(date, timeZone), formatStr, extendedOptions);
}

},{"date-fns/_lib/cloneObject/index.js":"eILCV","../format/index.js":"cEzmy","../utcToZonedTime/index.js":"egkRD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eILCV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("aa400e08011d267a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cloneObject;
var _index = _interopRequireDefault(require("cf6d30b3072c195"));
function cloneObject(object) {
    return (0, _index.default)({}, object);
}
module.exports = exports.default;

},{"aa400e08011d267a":"kZ6eK","cf6d30b3072c195":"iYkFo"}],"iYkFo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = assign;
function assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}
module.exports = exports.default;

},{}],"egkRD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>utcToZonedTime);
var _indexJs = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function utcToZonedTime(dirtyDate, timeZone, options) {
    var date = (0, _indexJsDefault1.default)(dirtyDate, options);
    var offsetMilliseconds = (0, _indexJsDefault.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

},{"../_lib/tzParseTimezone/index.js":"846od","../toDate/index.js":"c5C6z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"brR0k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTimezoneOffset);
var _indexJs = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function getTimezoneOffset(timeZone, date) {
    return -(0, _indexJsDefault.default)(timeZone, date);
}

},{"../_lib/tzParseTimezone/index.js":"846od","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hvE7E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>zonedTimeToUtc);
var _indexJs = require("date-fns/_lib/cloneObject/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/tzPattern/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/newDateUTC/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function zonedTimeToUtc(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, _indexJsDefault2.default))) {
        var extendedOptions = (0, _indexJsDefault.default)(options);
        extendedOptions.timeZone = timeZone;
        return (0, _indexJsDefault1.default)(date, extendedOptions);
    }
    var d = (0, _indexJsDefault1.default)(date, options);
    var utc = (0, _indexJsDefault4.default)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
    var offsetMilliseconds = (0, _indexJsDefault3.default)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}

},{"date-fns/_lib/cloneObject/index.js":"eILCV","../toDate/index.js":"c5C6z","../_lib/tzPattern/index.js":"elKoB","../_lib/tzParseTimezone/index.js":"846od","../_lib/newDateUTC/index.js":"b4kv3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2rMgD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the users current time zone, for example "Europe/Oslo".
 * This is currently backed by the browser or computer's locale setting.
 */ parcelHelpers.export(exports, "getCurrentTimezone", ()=>getCurrentTimezone);
var _timezoneItems = require("./timezoneItems");
/**
 * Keep the returned timezone constant for a page load.
 */ var memoizedTimezone = null;
function getCurrentTimezone() {
    var _a;
    if (memoizedTimezone === null) // Unsupported in IE, which newer Blueprint components do not support.
    // In the unlikely case that the browser API returns undefined, we default to UTC.
    // @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions
    memoizedTimezone = (_a = Intl.DateTimeFormat().resolvedOptions().timeZone) !== null && _a !== void 0 ? _a : (0, _timezoneItems.UTC_TIME).ianaCode;
    return memoizedTimezone;
}

},{"./timezoneItems":"jepBL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jepBL":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UTC_TIME", ()=>UTC_TIME);
parcelHelpers.export(exports, "TIMEZONE_ITEMS", ()=>TIMEZONE_ITEMS);
parcelHelpers.export(exports, "MINIMAL_TIMEZONE_ITEMS", ()=>MINIMAL_TIMEZONE_ITEMS);
var _timezoneOffsetUtils = require("./timezoneOffsetUtils");
var utcWithoutOffset = {
    label: "UTC",
    ianaCode: "Etc/UTC"
};
var UTC_TIME = (0, _timezoneOffsetUtils.lookupTimezoneOffset)(utcWithoutOffset);
var timezonesWithoutOffset = [
    utcWithoutOffset,
    {
        label: "Niue",
        ianaCode: "Pacific/Niue"
    },
    {
        label: "Pago Pago",
        ianaCode: "Pacific/Pago_Pago"
    },
    {
        label: "Hawaii Time",
        ianaCode: "Pacific/Honolulu"
    },
    {
        label: "Rarotonga",
        ianaCode: "Pacific/Rarotonga"
    },
    {
        label: "Tahiti",
        ianaCode: "Pacific/Tahiti"
    },
    {
        label: "Marquesas",
        ianaCode: "Pacific/Marquesas"
    },
    {
        label: "Alaska",
        ianaCode: "America/Anchorage"
    },
    {
        label: "Gambier",
        ianaCode: "Pacific/Gambier"
    },
    {
        label: "Los Angeles",
        ianaCode: "America/Los_Angeles"
    },
    {
        label: "Tijuana",
        ianaCode: "America/Tijuana"
    },
    {
        label: "Vancouver",
        ianaCode: "America/Vancouver"
    },
    {
        label: "Whitehorse",
        ianaCode: "America/Whitehorse"
    },
    {
        label: "Pitcairn",
        ianaCode: "Pacific/Pitcairn"
    },
    {
        label: "Denver",
        ianaCode: "America/Denver"
    },
    {
        label: "Arizona",
        ianaCode: "America/Phoenix"
    },
    {
        label: "Chihuahua, Mazatlan",
        ianaCode: "America/Mazatlan"
    },
    {
        label: "Dawson Creek",
        ianaCode: "America/Dawson_Creek"
    },
    {
        label: "Edmonton",
        ianaCode: "America/Edmonton"
    },
    {
        label: "Hermosillo",
        ianaCode: "America/Hermosillo"
    },
    {
        label: "Yellowknife",
        ianaCode: "America/Yellowknife"
    },
    {
        label: "Belize",
        ianaCode: "America/Belize"
    },
    {
        label: "Chicago",
        ianaCode: "America/Chicago"
    },
    {
        label: "Mexico City",
        ianaCode: "America/Mexico_City"
    },
    {
        label: "Regina",
        ianaCode: "America/Regina"
    },
    {
        label: "Tegucigalpa",
        ianaCode: "America/Tegucigalpa"
    },
    {
        label: "Winnipeg",
        ianaCode: "America/Winnipeg"
    },
    {
        label: "Costa Rica",
        ianaCode: "America/Costa_Rica"
    },
    {
        label: "El Salvador",
        ianaCode: "America/El_Salvador"
    },
    {
        label: "Galapagos",
        ianaCode: "Pacific/Galapagos"
    },
    {
        label: "Guatemala",
        ianaCode: "America/Guatemala"
    },
    {
        label: "Managua",
        ianaCode: "America/Managua"
    },
    {
        label: "America Cancun",
        ianaCode: "America/Cancun"
    },
    {
        label: "Bogota",
        ianaCode: "America/Bogota"
    },
    {
        label: "Easter Island",
        ianaCode: "Pacific/Easter"
    },
    {
        label: "New York",
        ianaCode: "America/New_York"
    },
    {
        label: "Iqaluit",
        ianaCode: "America/Iqaluit"
    },
    {
        label: "Toronto",
        ianaCode: "America/Toronto"
    },
    {
        label: "Guayaquil",
        ianaCode: "America/Guayaquil"
    },
    {
        label: "Havana",
        ianaCode: "America/Havana"
    },
    {
        label: "Jamaica",
        ianaCode: "America/Jamaica"
    },
    {
        label: "Lima",
        ianaCode: "America/Lima"
    },
    {
        label: "Nassau",
        ianaCode: "America/Nassau"
    },
    {
        label: "Panama",
        ianaCode: "America/Panama"
    },
    {
        label: "Port-au-Prince",
        ianaCode: "America/Port-au-Prince"
    },
    {
        label: "Rio Branco",
        ianaCode: "America/Rio_Branco"
    },
    {
        label: "Halifax",
        ianaCode: "America/Halifax"
    },
    {
        label: "Barbados",
        ianaCode: "America/Barbados"
    },
    {
        label: "Bermuda",
        ianaCode: "Atlantic/Bermuda"
    },
    {
        label: "Boa Vista",
        ianaCode: "America/Boa_Vista"
    },
    {
        label: "Caracas",
        ianaCode: "America/Caracas"
    },
    {
        label: "Curacao",
        ianaCode: "America/Curacao"
    },
    {
        label: "Grand Turk",
        ianaCode: "America/Grand_Turk"
    },
    {
        label: "Guyana",
        ianaCode: "America/Guyana"
    },
    {
        label: "La Paz",
        ianaCode: "America/La_Paz"
    },
    {
        label: "Manaus",
        ianaCode: "America/Manaus"
    },
    {
        label: "Martinique",
        ianaCode: "America/Martinique"
    },
    {
        label: "Port of Spain",
        ianaCode: "America/Port_of_Spain"
    },
    {
        label: "Porto Velho",
        ianaCode: "America/Porto_Velho"
    },
    {
        label: "Puerto Rico",
        ianaCode: "America/Puerto_Rico"
    },
    {
        label: "Santo Domingo",
        ianaCode: "America/Santo_Domingo"
    },
    {
        label: "Thule",
        ianaCode: "America/Thule"
    },
    {
        label: "St. Johns",
        ianaCode: "America/St_Johns"
    },
    {
        label: "Araguaina",
        ianaCode: "America/Araguaina"
    },
    {
        label: "Asuncion",
        ianaCode: "America/Asuncion"
    },
    {
        label: "Belem",
        ianaCode: "America/Belem"
    },
    {
        label: "Buenos Aires",
        ianaCode: "America/Argentina/Buenos_Aires"
    },
    {
        label: "Campo Grande",
        ianaCode: "America/Campo_Grande"
    },
    {
        label: "Cayenne",
        ianaCode: "America/Cayenne"
    },
    {
        label: "Cuiaba",
        ianaCode: "America/Cuiaba"
    },
    {
        label: "Fortaleza",
        ianaCode: "America/Fortaleza"
    },
    {
        label: "Godthab",
        ianaCode: "America/Godthab"
    },
    {
        label: "Maceio",
        ianaCode: "America/Maceio"
    },
    {
        label: "Miquelon",
        ianaCode: "America/Miquelon"
    },
    {
        label: "Montevideo",
        ianaCode: "America/Montevideo"
    },
    {
        label: "Palmer",
        ianaCode: "Antarctica/Palmer"
    },
    {
        label: "Paramaribo",
        ianaCode: "America/Paramaribo"
    },
    {
        label: "Punta Arenas",
        ianaCode: "America/Punta_Arenas"
    },
    {
        label: "Recife",
        ianaCode: "America/Recife"
    },
    {
        label: "Rothera",
        ianaCode: "Antarctica/Rothera"
    },
    {
        label: "Salvador",
        ianaCode: "America/Bahia"
    },
    {
        label: "Santiago",
        ianaCode: "America/Santiago"
    },
    {
        label: "Stanley",
        ianaCode: "Atlantic/Stanley"
    },
    {
        label: "Noronha",
        ianaCode: "America/Noronha"
    },
    {
        label: "Sao Paulo",
        ianaCode: "America/Sao_Paulo"
    },
    {
        label: "South Georgia",
        ianaCode: "Atlantic/South_Georgia"
    },
    {
        label: "Azores",
        ianaCode: "Atlantic/Azores"
    },
    {
        label: "Cape Verde",
        ianaCode: "Atlantic/Cape_Verde"
    },
    {
        label: "Scoresbysund",
        ianaCode: "America/Scoresbysund"
    },
    {
        label: "Abidjan",
        ianaCode: "Africa/Abidjan"
    },
    {
        label: "Accra",
        ianaCode: "Africa/Accra"
    },
    {
        label: "Bissau",
        ianaCode: "Africa/Bissau"
    },
    {
        label: "Canary Islands",
        ianaCode: "Atlantic/Canary"
    },
    {
        label: "Casablanca",
        ianaCode: "Africa/Casablanca"
    },
    {
        label: "Danmarkshavn",
        ianaCode: "America/Danmarkshavn"
    },
    {
        label: "Dublin",
        ianaCode: "Europe/Dublin"
    },
    {
        label: "El Aaiun",
        ianaCode: "Africa/El_Aaiun"
    },
    {
        label: "Faeroe",
        ianaCode: "Atlantic/Faroe"
    },
    {
        label: "GMT (no daylight saving)",
        ianaCode: "Etc/GMT"
    },
    {
        label: "Lisbon",
        ianaCode: "Europe/Lisbon"
    },
    {
        label: "London",
        ianaCode: "Europe/London"
    },
    {
        label: "Monrovia",
        ianaCode: "Africa/Monrovia"
    },
    {
        label: "Reykjavik",
        ianaCode: "Atlantic/Reykjavik"
    },
    {
        label: "Algiers",
        ianaCode: "Africa/Algiers"
    },
    {
        label: "Amsterdam",
        ianaCode: "Europe/Amsterdam"
    },
    {
        label: "Andorra",
        ianaCode: "Europe/Andorra"
    },
    {
        label: "Berlin",
        ianaCode: "Europe/Berlin"
    },
    {
        label: "Brussels",
        ianaCode: "Europe/Brussels"
    },
    {
        label: "Budapest",
        ianaCode: "Europe/Budapest"
    },
    {
        label: "Belgrade",
        ianaCode: "Europe/Belgrade"
    },
    {
        label: "Prague",
        ianaCode: "Europe/Prague"
    },
    {
        label: "Ceuta",
        ianaCode: "Africa/Ceuta"
    },
    {
        label: "Copenhagen",
        ianaCode: "Europe/Copenhagen"
    },
    {
        label: "Gibraltar",
        ianaCode: "Europe/Gibraltar"
    },
    {
        label: "Lagos",
        ianaCode: "Africa/Lagos"
    },
    {
        label: "Luxembourg",
        ianaCode: "Europe/Luxembourg"
    },
    {
        label: "Madrid",
        ianaCode: "Europe/Madrid"
    },
    {
        label: "Malta",
        ianaCode: "Europe/Malta"
    },
    {
        label: "Monaco",
        ianaCode: "Europe/Monaco"
    },
    {
        label: "Ndjamena",
        ianaCode: "Africa/Ndjamena"
    },
    {
        label: "Oslo",
        ianaCode: "Europe/Oslo"
    },
    {
        label: "Paris",
        ianaCode: "Europe/Paris"
    },
    {
        label: "Rome",
        ianaCode: "Europe/Rome"
    },
    {
        label: "Stockholm",
        ianaCode: "Europe/Stockholm"
    },
    {
        label: "Tirane",
        ianaCode: "Europe/Tirane"
    },
    {
        label: "Tunis",
        ianaCode: "Africa/Tunis"
    },
    {
        label: "Vienna",
        ianaCode: "Europe/Vienna"
    },
    {
        label: "Warsaw",
        ianaCode: "Europe/Warsaw"
    },
    {
        label: "Zurich",
        ianaCode: "Europe/Zurich"
    },
    {
        label: "Amman",
        ianaCode: "Asia/Amman"
    },
    {
        label: "Athens",
        ianaCode: "Europe/Athens"
    },
    {
        label: "Beirut",
        ianaCode: "Asia/Beirut"
    },
    {
        label: "Bucharest",
        ianaCode: "Europe/Bucharest"
    },
    {
        label: "Cairo",
        ianaCode: "Africa/Cairo"
    },
    {
        label: "Chisinau",
        ianaCode: "Europe/Chisinau"
    },
    {
        label: "Damascus",
        ianaCode: "Asia/Damascus"
    },
    {
        label: "Gaza",
        ianaCode: "Asia/Gaza"
    },
    {
        label: "Helsinki",
        ianaCode: "Europe/Helsinki"
    },
    {
        label: "Jerusalem",
        ianaCode: "Asia/Jerusalem"
    },
    {
        label: "Johannesburg",
        ianaCode: "Africa/Johannesburg"
    },
    {
        label: "Khartoum",
        ianaCode: "Africa/Khartoum"
    },
    {
        label: "Kyiv",
        ianaCode: "Europe/Kiev"
    },
    {
        label: "Maputo",
        ianaCode: "Africa/Maputo"
    },
    {
        label: "Kaliningrad",
        ianaCode: "Europe/Kaliningrad"
    },
    {
        label: "Nicosia",
        ianaCode: "Asia/Nicosia"
    },
    {
        label: "Riga",
        ianaCode: "Europe/Riga"
    },
    {
        label: "Sofia",
        ianaCode: "Europe/Sofia"
    },
    {
        label: "Tallinn",
        ianaCode: "Europe/Tallinn"
    },
    {
        label: "Tripoli",
        ianaCode: "Africa/Tripoli"
    },
    {
        label: "Vilnius",
        ianaCode: "Europe/Vilnius"
    },
    {
        label: "Windhoek",
        ianaCode: "Africa/Windhoek"
    },
    {
        label: "Baghdad",
        ianaCode: "Asia/Baghdad"
    },
    {
        label: "Istanbul",
        ianaCode: "Europe/Istanbul"
    },
    {
        label: "Minsk",
        ianaCode: "Europe/Minsk"
    },
    {
        label: "Moscow",
        ianaCode: "Europe/Moscow"
    },
    {
        label: "Nairobi",
        ianaCode: "Africa/Nairobi"
    },
    {
        label: "Qatar",
        ianaCode: "Asia/Qatar"
    },
    {
        label: "Riyadh",
        ianaCode: "Asia/Riyadh"
    },
    {
        label: "Syowa",
        ianaCode: "Antarctica/Syowa"
    },
    {
        label: "Tehran",
        ianaCode: "Asia/Tehran"
    },
    {
        label: "Baku",
        ianaCode: "Asia/Baku"
    },
    {
        label: "Dubai",
        ianaCode: "Asia/Dubai"
    },
    {
        label: "Mahe",
        ianaCode: "Indian/Mahe"
    },
    {
        label: "Mauritius",
        ianaCode: "Indian/Mauritius"
    },
    {
        label: "Samara",
        ianaCode: "Europe/Samara"
    },
    {
        label: "Reunion",
        ianaCode: "Indian/Reunion"
    },
    {
        label: "Tbilisi",
        ianaCode: "Asia/Tbilisi"
    },
    {
        label: "Yerevan",
        ianaCode: "Asia/Yerevan"
    },
    {
        label: "Kabul",
        ianaCode: "Asia/Kabul"
    },
    {
        label: "Aqtau",
        ianaCode: "Asia/Aqtau"
    },
    {
        label: "Aqtobe",
        ianaCode: "Asia/Aqtobe"
    },
    {
        label: "Ashgabat",
        ianaCode: "Asia/Ashgabat"
    },
    {
        label: "Dushanbe",
        ianaCode: "Asia/Dushanbe"
    },
    {
        label: "Karachi",
        ianaCode: "Asia/Karachi"
    },
    {
        label: "Kerguelen",
        ianaCode: "Indian/Kerguelen"
    },
    {
        label: "Maldives",
        ianaCode: "Indian/Maldives"
    },
    {
        label: "Mawson",
        ianaCode: "Antarctica/Mawson"
    },
    {
        label: "Yekaterinburg",
        ianaCode: "Asia/Yekaterinburg"
    },
    {
        label: "Tashkent",
        ianaCode: "Asia/Tashkent"
    },
    {
        label: "Colombo",
        ianaCode: "Asia/Colombo"
    },
    {
        label: "India - Kolkata",
        ianaCode: "Asia/Kolkata"
    },
    {
        label: "Kathmandu",
        ianaCode: "Asia/Kathmandu"
    },
    {
        label: "Almaty",
        ianaCode: "Asia/Almaty"
    },
    {
        label: "Bishkek",
        ianaCode: "Asia/Bishkek"
    },
    {
        label: "Chagos",
        ianaCode: "Indian/Chagos"
    },
    {
        label: "Dhaka",
        ianaCode: "Asia/Dhaka"
    },
    {
        label: "Omsk",
        ianaCode: "Asia/Omsk"
    },
    {
        label: "Thimphu",
        ianaCode: "Asia/Thimphu"
    },
    {
        label: "Vostok",
        ianaCode: "Antarctica/Vostok"
    },
    {
        label: "Cocos",
        ianaCode: "Indian/Cocos"
    },
    {
        label: "Rangoon",
        ianaCode: "Asia/Yangon"
    },
    {
        label: "Bangkok",
        ianaCode: "Asia/Bangkok"
    },
    {
        label: "Christmas",
        ianaCode: "Indian/Christmas"
    },
    {
        label: "Davis",
        ianaCode: "Antarctica/Davis"
    },
    {
        label: "Hanoi",
        ianaCode: "Asia/Saigon"
    },
    {
        label: "Hovd",
        ianaCode: "Asia/Hovd"
    },
    {
        label: "Jakarta",
        ianaCode: "Asia/Jakarta"
    },
    {
        label: "Moscow+04 - Krasnoyarsk",
        ianaCode: "Asia/Krasnoyarsk"
    },
    {
        label: "Brunei",
        ianaCode: "Asia/Brunei"
    },
    {
        label: "China - Beijing",
        ianaCode: "Asia/Shanghai"
    },
    {
        label: "Choibalsan",
        ianaCode: "Asia/Choibalsan"
    },
    {
        label: "Hong Kong",
        ianaCode: "Asia/Hong_Kong"
    },
    {
        label: "Kuala Lumpur",
        ianaCode: "Asia/Kuala_Lumpur"
    },
    {
        label: "Macau",
        ianaCode: "Asia/Macau"
    },
    {
        label: "Makassar",
        ianaCode: "Asia/Makassar"
    },
    {
        label: "Manila",
        ianaCode: "Asia/Manila"
    },
    {
        label: "Moscow+05 - Irkutsk",
        ianaCode: "Asia/Irkutsk"
    },
    {
        label: "Singapore",
        ianaCode: "Asia/Singapore"
    },
    {
        label: "Taipei",
        ianaCode: "Asia/Taipei"
    },
    {
        label: "Ulaanbaatar",
        ianaCode: "Asia/Ulaanbaatar"
    },
    {
        label: "Perth",
        ianaCode: "Australia/Perth"
    },
    {
        label: "Pyongyang",
        ianaCode: "Asia/Pyongyang"
    },
    {
        label: "Dili",
        ianaCode: "Asia/Dili"
    },
    {
        label: "Jayapura",
        ianaCode: "Asia/Jayapura"
    },
    {
        label: "Moscow+06 - Yakutsk",
        ianaCode: "Asia/Yakutsk"
    },
    {
        label: "Palau",
        ianaCode: "Pacific/Palau"
    },
    {
        label: "Seoul",
        ianaCode: "Asia/Seoul"
    },
    {
        label: "Tokyo",
        ianaCode: "Asia/Tokyo"
    },
    {
        label: "Darwin",
        ianaCode: "Australia/Darwin"
    },
    {
        label: "Dumont D'Urville",
        ianaCode: "Antarctica/DumontDUrville"
    },
    {
        label: "Brisbane",
        ianaCode: "Australia/Brisbane"
    },
    {
        label: "Guam",
        ianaCode: "Pacific/Guam"
    },
    {
        label: "Moscow+07 - Vladivostok",
        ianaCode: "Asia/Vladivostok"
    },
    {
        label: "Port Moresby",
        ianaCode: "Pacific/Port_Moresby"
    },
    {
        label: "Truk",
        ianaCode: "Pacific/Chuuk"
    },
    {
        label: "Adelaide",
        ianaCode: "Australia/Adelaide"
    },
    {
        label: "Casey",
        ianaCode: "Antarctica/Casey"
    },
    {
        label: "Hobart",
        ianaCode: "Australia/Hobart"
    },
    {
        label: "Melbourne, Sydney",
        ianaCode: "Australia/Sydney"
    },
    {
        label: "Efate",
        ianaCode: "Pacific/Efate"
    },
    {
        label: "Guadalcanal",
        ianaCode: "Pacific/Guadalcanal"
    },
    {
        label: "Kosrae",
        ianaCode: "Pacific/Kosrae"
    },
    {
        label: "Moscow+08 - Magadan",
        ianaCode: "Asia/Magadan"
    },
    {
        label: "Norfolk",
        ianaCode: "Pacific/Norfolk"
    },
    {
        label: "Noumea",
        ianaCode: "Pacific/Noumea"
    },
    {
        label: "Ponape",
        ianaCode: "Pacific/Pohnpei"
    },
    {
        label: "Funafuti",
        ianaCode: "Pacific/Funafuti"
    },
    {
        label: "Kwajalein",
        ianaCode: "Pacific/Kwajalein"
    },
    {
        label: "Majuro",
        ianaCode: "Pacific/Majuro"
    },
    {
        label: "Moscow+09 - Petropavlovsk-Kamchatskiy",
        ianaCode: "Asia/Kamchatka"
    },
    {
        label: "Nauru",
        ianaCode: "Pacific/Nauru"
    },
    {
        label: "Tarawa",
        ianaCode: "Pacific/Tarawa"
    },
    {
        label: "Wake",
        ianaCode: "Pacific/Wake"
    },
    {
        label: "Wallis",
        ianaCode: "Pacific/Wallis"
    },
    {
        label: "Auckland",
        ianaCode: "Pacific/Auckland"
    },
    {
        label: "Enderbury",
        ianaCode: "Pacific/Enderbury"
    },
    {
        label: "Fakaofo",
        ianaCode: "Pacific/Fakaofo"
    },
    {
        label: "Fiji",
        ianaCode: "Pacific/Fiji"
    },
    {
        label: "Tongatapu",
        ianaCode: "Pacific/Tongatapu"
    },
    {
        label: "Apia",
        ianaCode: "Pacific/Apia"
    },
    {
        label: "Kiritimati",
        ianaCode: "Pacific/Kiritimati"
    }
];
var minimalTimezonesWithoutOffset = [
    utcWithoutOffset,
    {
        label: "Pago Pago",
        ianaCode: "Pacific/Pago_Pago"
    },
    {
        label: "Hawaii Time",
        ianaCode: "Pacific/Honolulu"
    },
    {
        label: "Marquesas",
        ianaCode: "Pacific/Marquesas"
    },
    {
        label: "Alaska",
        ianaCode: "America/Anchorage"
    },
    {
        label: "Los Angeles",
        ianaCode: "America/Los_Angeles"
    },
    {
        label: "Denver",
        ianaCode: "America/Denver"
    },
    {
        label: "Mexico City",
        ianaCode: "America/Mexico_City"
    },
    {
        label: "New York",
        ianaCode: "America/New_York"
    },
    {
        label: "Puerto Rico",
        ianaCode: "America/Puerto_Rico"
    },
    {
        label: "St. Johns",
        ianaCode: "America/St_Johns"
    },
    {
        label: "Buenos Aires",
        ianaCode: "America/Argentina/Buenos_Aires"
    },
    {
        label: "Sao Paulo",
        ianaCode: "America/Sao_Paulo"
    },
    {
        label: "Cape Verde",
        ianaCode: "Atlantic/Cape_Verde"
    },
    {
        label: "Paris",
        ianaCode: "Europe/Paris"
    },
    {
        label: "Cairo",
        ianaCode: "Africa/Cairo"
    },
    {
        label: "Moscow",
        ianaCode: "Europe/Moscow"
    },
    {
        label: "Tehran",
        ianaCode: "Asia/Tehran"
    },
    {
        label: "Dubai",
        ianaCode: "Asia/Dubai"
    },
    {
        label: "Karachi",
        ianaCode: "Asia/Karachi"
    },
    {
        label: "India - Kolkata",
        ianaCode: "Asia/Kolkata"
    },
    {
        label: "Kathmandu",
        ianaCode: "Asia/Kathmandu"
    },
    {
        label: "Dhaka",
        ianaCode: "Asia/Dhaka"
    },
    {
        label: "Rangoon",
        ianaCode: "Asia/Yangon"
    },
    {
        label: "Jakarta",
        ianaCode: "Asia/Jakarta"
    },
    {
        label: "Manila",
        ianaCode: "Asia/Manila"
    },
    {
        label: "Tokyo",
        ianaCode: "Asia/Tokyo"
    },
    {
        label: "Brisbane",
        ianaCode: "Australia/Brisbane"
    },
    {
        label: "Adelaide",
        ianaCode: "Australia/Adelaide"
    },
    {
        label: "Melbourne, Sydney",
        ianaCode: "Australia/Sydney"
    },
    {
        label: "Nauru",
        ianaCode: "Pacific/Nauru"
    },
    {
        label: "Auckland",
        ianaCode: "Pacific/Auckland"
    },
    {
        label: "Kiritimati",
        ianaCode: "Pacific/Kiritimati"
    }
];
var TIMEZONE_ITEMS = timezonesWithoutOffset.map(function(tz) {
    return (0, _timezoneOffsetUtils.lookupTimezoneOffset)(tz);
});
var MINIMAL_TIMEZONE_ITEMS = minimalTimezonesWithoutOffset.map(function(tz) {
    return (0, _timezoneOffsetUtils.lookupTimezoneOffset)(tz);
});

},{"./timezoneOffsetUtils":"61Hq9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"61Hq9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Augment hard-coded timezone information stored in this package with its current offset relative to UTC,
 * adjusted for daylight saving using the current date.
 *
 * @see https://github.com/marnusw/date-fns-tz#gettimezoneoffset
 */ parcelHelpers.export(exports, "lookupTimezoneOffset", ()=>lookupTimezoneOffset);
var _tslib = require("tslib");
var _dateFnsTz = require("date-fns-tz");
function lookupTimezoneOffset(tz, date) {
    var offsetInMs = (0, _dateFnsTz.getTimezoneOffset)(tz.ianaCode, date);
    if (isNaN(offsetInMs)) throw new Error("Unable to lookup offset for invalid timezone '".concat(tz.ianaCode, "'"));
    var isPositiveOffset = offsetInMs >= 0;
    var offsetInMinutes = Math.abs(offsetInMs) / 1000 / 60;
    var offsetHours = Math.trunc(offsetInMinutes / 60).toString().padStart(2, "0");
    var offsetMinutes = (offsetInMinutes % 60).toString().padEnd(2, "0");
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, tz), {
        offset: "".concat(isPositiveOffset ? "+" : "-").concat(offsetHours, ":").concat(offsetMinutes)
    });
}

},{"tslib":"b4wpY","date-fns-tz":"4WMBd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kD0r0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCurrentTimezone", ()=>(0, _getTimezone.getCurrentTimezone));
parcelHelpers.export(exports, "UTC_TIME", ()=>(0, _timezoneItems.UTC_TIME));
parcelHelpers.export(exports, "getIsoEquivalentWithUpdatedTimezone", ()=>getIsoEquivalentWithUpdatedTimezone);
parcelHelpers.export(exports, "getDateObjectFromIsoString", ()=>getDateObjectFromIsoString);
/**
 * Converts a date in local timezone to represent better the passed through timezone
 * representation for the user, meaning if 8 AM local time is currently the date, and local time is Oslo
 * and the user has a default of UTC in selection, the new date should represent 7 AM.
 *
 * @param date the current existing date object
 * @param newTimezone the new timezone that we need to update the date to represent
 * @returns The date converted to match the new timezone
 */ parcelHelpers.export(exports, "convertLocalDateToTimezoneTime", ()=>convertLocalDateToTimezoneTime);
/**
 * Converts a date to match a new timezone selection. The date is the internal local time
 * representation for the user, meaning if 8 AM local time is currently selected, and local time is Oslo
 * and the user switches timezone to UTC, the new date should represent 9 AM in Oslo time.
 *
 * @param date the current existing date object
 * @param newTimezone the new timezone that the date should be converted to represent
 * @returns The date converted to match the new timezone
 */ parcelHelpers.export(exports, "convertDateToLocalEquivalentOfTimezoneTime", ()=>convertDateToLocalEquivalentOfTimezoneTime);
var _dateFnsTz = require("date-fns-tz");
var _getTimezone = require("./getTimezone");
var _timePrecision = require("./timePrecision");
var _timezoneItems = require("./timezoneItems");
var _a;
var NO_TIME_PRECISION = "date";
var TIME_FORMAT_TO_ISO_FORMAT = (_a = {}, _a[(0, _timePrecision.TimePrecision).MILLISECOND] = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx", _a[(0, _timePrecision.TimePrecision).SECOND] = "yyyy-MM-dd'T'HH:mm:ssxxx", _a[(0, _timePrecision.TimePrecision).MINUTE] = "yyyy-MM-dd'T'HH:mmxxx", _a[NO_TIME_PRECISION] = "yyyy-MM-dd", _a);
/**
 * @see https://github.com/marnusw/date-fns-tz#formatintimezone
 * @returns a string of tokens which tell date-fns-tz's formatInTimeZone how to render a datetime
 */ function getFormatStr(timePrecision) {
    return TIME_FORMAT_TO_ISO_FORMAT[timePrecision !== null && timePrecision !== void 0 ? timePrecision : NO_TIME_PRECISION];
}
function getIsoEquivalentWithUpdatedTimezone(date, timezone, timePrecision) {
    var convertedDate = convertDateToLocalEquivalentOfTimezoneTime(date, timezone);
    return (0, _dateFnsTz.formatInTimeZone)(convertedDate, timezone, getFormatStr(timePrecision));
}
function getDateObjectFromIsoString(value, timezone) {
    if (value === undefined) return undefined;
    // This function previously used lodash.isEmpty to check for empty values, which returns true for e.g. numbers and Dates.
    // Be extra defensive and avoid breakage in case a consumer is incorrectly passing in such a value.
    if (value === null || value === "" || typeof value !== "string") return null;
    var date = new Date(value);
    // If the value is just a date format then we convert it to midnight in local time to avoid weird things happening
    if (value.length === 10) // If it's just a date, we know it's interpreted as midnight UTC so we convert it to local time of that UTC time
    return convertLocalDateToTimezoneTime(date, (0, _timezoneItems.UTC_TIME).ianaCode);
    return convertLocalDateToTimezoneTime(date, timezone);
}
function convertLocalDateToTimezoneTime(date, newTimezone) {
    var nowUtc = (0, _dateFnsTz.zonedTimeToUtc)(date, (0, _getTimezone.getCurrentTimezone)());
    return (0, _dateFnsTz.utcToZonedTime)(nowUtc, newTimezone);
}
function convertDateToLocalEquivalentOfTimezoneTime(date, newTimezone) {
    var nowUtc = (0, _dateFnsTz.zonedTimeToUtc)(date, newTimezone);
    return (0, _dateFnsTz.utcToZonedTime)(nowUtc, (0, _getTimezone.getCurrentTimezone)());
}

},{"date-fns-tz":"4WMBd","./getTimezone":"2rMgD","./timePrecision":"MzfIf","./timezoneItems":"jepBL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"MzfIf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimePrecision", ()=>TimePrecision);
var TimePrecision = {
    MILLISECOND: "millisecond",
    MINUTE: "minute",
    SECOND: "second"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6raXC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeUnit", ()=>TimeUnit);
/** Gets a descriptive label representing the plural of the given time unit. */ parcelHelpers.export(exports, "getTimeUnitPrintStr", ()=>getTimeUnitPrintStr);
/** Returns the given time unit component of the date. */ parcelHelpers.export(exports, "getTimeUnit", ()=>getTimeUnit);
/** Sets the given time unit to the given time in date object. Modifies given `date` object and returns it. */ parcelHelpers.export(exports, "setTimeUnit", ()=>setTimeUnit);
/** Returns true if `time` is a valid value */ parcelHelpers.export(exports, "isTimeUnitValid", ()=>isTimeUnitValid);
/** If unit of time is greater than max, returns min. If less than min, returns max. Otherwise, returns time. */ parcelHelpers.export(exports, "wrapTimeAtUnit", ()=>wrapTimeAtUnit);
parcelHelpers.export(exports, "getTimeUnitClassName", ()=>getTimeUnitClassName);
parcelHelpers.export(exports, "getTimeUnitMax", ()=>getTimeUnitMax);
parcelHelpers.export(exports, "getTimeUnitMin", ()=>getTimeUnitMin);
parcelHelpers.export(exports, "getDefaultMinTime", ()=>getDefaultMinTime);
parcelHelpers.export(exports, "getDefaultMaxTime", ()=>getDefaultMaxTime);
var _classes = require("./classes");
var _dateUtils = require("./dateUtils");
var _a;
var TimeUnit;
(function(TimeUnit) {
    // NOTE: string enum so we can use it in Record<> type at the end of this file, which requires string keys
    TimeUnit["HOUR_24"] = "hour24";
    TimeUnit["HOUR_12"] = "hour12";
    TimeUnit["MINUTE"] = "minute";
    TimeUnit["SECOND"] = "second";
    TimeUnit["MS"] = "ms";
})(TimeUnit || (TimeUnit = {}));
function getTimeUnitPrintStr(unit) {
    var _a;
    var timeUnitToPrintstr = (_a = {}, _a[TimeUnit.HOUR_24] = "hours (24hr clock)", _a[TimeUnit.HOUR_12] = "hours (12hr clock)", _a[TimeUnit.MINUTE] = "minutes", _a[TimeUnit.SECOND] = "seconds", _a[TimeUnit.MS] = "milliseconds", _a);
    return timeUnitToPrintstr[unit];
}
function getTimeUnit(unit, date) {
    switch(unit){
        case TimeUnit.HOUR_24:
            return date.getHours();
        case TimeUnit.HOUR_12:
            return (0, _dateUtils.get12HourFrom24Hour)(date.getHours());
        case TimeUnit.MINUTE:
            return date.getMinutes();
        case TimeUnit.SECOND:
            return date.getSeconds();
        case TimeUnit.MS:
            return date.getMilliseconds();
        default:
            throw Error("Invalid TimeUnit");
    }
}
function setTimeUnit(unit, time, date, isPm) {
    switch(unit){
        case TimeUnit.HOUR_24:
            date.setHours(time);
            break;
        case TimeUnit.HOUR_12:
            date.setHours((0, _dateUtils.get24HourFrom12Hour)(time, isPm));
            break;
        case TimeUnit.MINUTE:
            date.setMinutes(time);
            break;
        case TimeUnit.SECOND:
            date.setSeconds(time);
            break;
        case TimeUnit.MS:
            date.setMilliseconds(time);
            break;
        default:
            throw Error("Invalid TimeUnit");
    }
    return date;
}
function isTimeUnitValid(unit, time) {
    return time != null && !isNaN(time) && getTimeUnitMin(unit) <= time && time <= getTimeUnitMax(unit);
}
function wrapTimeAtUnit(unit, time) {
    var max = getTimeUnitMax(unit);
    var min = getTimeUnitMin(unit);
    if (time > max) return min;
    else if (time < min) return max;
    return time;
}
function getTimeUnitClassName(unit) {
    return TimeUnitMetadataStore[unit].className;
}
function getTimeUnitMax(unit) {
    return TimeUnitMetadataStore[unit].max;
}
function getTimeUnitMin(unit) {
    return TimeUnitMetadataStore[unit].min;
}
function getDefaultMinTime() {
    return new Date(0, 0, 0, DEFAULT_MIN_HOUR, DEFAULT_MIN_MINUTE, DEFAULT_MIN_SECOND, DEFAULT_MIN_MILLISECOND);
}
function getDefaultMaxTime() {
    return new Date(0, 0, 0, DEFAULT_MAX_HOUR, DEFAULT_MAX_MINUTE, DEFAULT_MAX_SECOND, DEFAULT_MAX_MILLISECOND);
}
var DEFAULT_MIN_HOUR = 0;
var MERIDIEM_MIN_HOUR = 1;
var DEFAULT_MIN_MINUTE = 0;
var DEFAULT_MIN_SECOND = 0;
var DEFAULT_MIN_MILLISECOND = 0;
var DEFAULT_MAX_HOUR = 23;
var MERIDIEM_MAX_HOUR = 12;
var DEFAULT_MAX_MINUTE = 59;
var DEFAULT_MAX_SECOND = 59;
var DEFAULT_MAX_MILLISECOND = 999;
/**
 * A datastore (internal to this file) mapping TimeUnits to useful information about them.
 * Use the `get*` methods above to access these fields.
 */ var TimeUnitMetadataStore = (_a = {}, _a[TimeUnit.HOUR_24] = {
    className: _classes.TIMEPICKER_HOUR,
    max: DEFAULT_MAX_HOUR,
    min: DEFAULT_MIN_HOUR
}, _a[TimeUnit.HOUR_12] = {
    className: _classes.TIMEPICKER_HOUR,
    max: MERIDIEM_MAX_HOUR,
    min: MERIDIEM_MIN_HOUR
}, _a[TimeUnit.MINUTE] = {
    className: _classes.TIMEPICKER_MINUTE,
    max: DEFAULT_MAX_MINUTE,
    min: DEFAULT_MIN_MINUTE
}, _a[TimeUnit.SECOND] = {
    className: _classes.TIMEPICKER_SECOND,
    max: DEFAULT_MAX_SECOND,
    min: DEFAULT_MIN_SECOND
}, _a[TimeUnit.MS] = {
    className: _classes.TIMEPICKER_MILLISECOND,
    max: DEFAULT_MAX_MILLISECOND,
    min: DEFAULT_MIN_MILLISECOND
}, _a);

},{"./classes":"9Dstt","./dateUtils":"rPoyc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lqJbn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimezoneDisplayFormat", ()=>TimezoneDisplayFormat);
/**
 * Formats a timezone according to the specified display format to show in the default `<Button>` rendered as the
 * `<TimezoneSelect>` target element.
 */ parcelHelpers.export(exports, "formatTimezone", ()=>formatTimezone);
var TimezoneDisplayFormat = {
    /**
     * Short name format: "HST", "EDT", etc.
     * Falls back to "GMT+/-offset" if there is no commonly used abbreviation.
     */ ABBREVIATION: "abbreviation",
    /**
     * IANA timezone code: "Pacific/Honolulu", "America/New_York", etc.
     */ CODE: "code",
    /**
     * Composite format: "Hawaii Time (HST) -10:00", "New York (EDT) -5:00", etc.
     * Omits abbreviation if there is no short name (it is redundant with offset).
     */ COMPOSITE: "composite",
    /**
     * Long name format: "Hawaii-Aleutian Standard Time", "Eastern Daylight Time", "Coordinated Universal Time", etc.
     */ LONG_NAME: "long-name",
    /**
     * Offset format: "-10:00", "-5:00", etc.
     */ OFFSET: "offset"
};
function formatTimezone(timezone, displayFormat) {
    if (timezone === undefined) return undefined;
    switch(displayFormat){
        case TimezoneDisplayFormat.ABBREVIATION:
            return timezone.shortName;
        case TimezoneDisplayFormat.OFFSET:
            return timezone.offset;
        case TimezoneDisplayFormat.CODE:
            return timezone.ianaCode;
        case TimezoneDisplayFormat.LONG_NAME:
            return timezone.longName;
        case TimezoneDisplayFormat.COMPOSITE:
            var shortName = timezone.shortName;
            // if the short name is just an offset (contains + or -) or equal to the label, omit it
            return /[-\+]/.test(shortName) || shortName === timezone.label ? "".concat(timezone.label, " ").concat(timezone.offset) : "".concat(timezone.label, " (").concat(timezone.shortName, ") ").concat(timezone.offset);
        default:
            return undefined;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avGhV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangeSelectionStrategy", ()=>DateRangeSelectionStrategy);
var _core = require("@blueprintjs/core");
var _dateUtils = require("./dateUtils");
/* eslint-disable-next-line @typescript-eslint/no-extraneous-class */ var DateRangeSelectionStrategy = /** @class */ function() {
    function DateRangeSelectionStrategy() {}
    /**
     * Returns the new date-range and the boundary that would be affected if `day` were clicked. The
     * affected boundary may be different from the provided `boundary` in some cases. For example,
     * clicking a particular boundary's selected date will always deselect it regardless of which
     * `boundary` you provide to this function (because it's simply a more intuitive interaction).
     */ DateRangeSelectionStrategy.getNextState = function(currentRange, day, allowSingleDayRange, boundary) {
        if (boundary != null) return this.getNextStateForBoundary(currentRange, day, allowSingleDayRange, boundary);
        else return this.getDefaultNextState(currentRange, day, allowSingleDayRange);
    };
    DateRangeSelectionStrategy.getNextStateForBoundary = function(currentRange, day, allowSingleDayRange, boundary) {
        var boundaryDate = this.getBoundaryDate(boundary, currentRange);
        var otherBoundary = this.getOtherBoundary(boundary);
        var otherBoundaryDate = this.getBoundaryDate(otherBoundary, currentRange);
        var nextBoundary;
        var nextDateRange;
        if (boundaryDate == null && otherBoundaryDate == null) {
            nextBoundary = boundary;
            nextDateRange = this.createRangeForBoundary(boundary, day, null);
        } else if (boundaryDate != null && otherBoundaryDate == null) {
            var nextBoundaryDate = (0, _dateUtils.isSameDay)(boundaryDate, day) ? null : day;
            nextBoundary = boundary;
            nextDateRange = this.createRangeForBoundary(boundary, nextBoundaryDate, null);
        } else if (boundaryDate == null && otherBoundaryDate != null) {
            if ((0, _dateUtils.isSameDay)(day, otherBoundaryDate)) {
                var nextDate = void 0;
                if (allowSingleDayRange) {
                    nextBoundary = boundary;
                    nextDate = otherBoundaryDate;
                } else {
                    nextBoundary = otherBoundary;
                    nextDate = null;
                }
                nextDateRange = this.createRangeForBoundary(boundary, nextDate, nextDate);
            } else if (this.isOverlappingOtherBoundary(boundary, day, otherBoundaryDate)) {
                nextBoundary = otherBoundary;
                nextDateRange = this.createRangeForBoundary(boundary, otherBoundaryDate, day);
            } else {
                nextBoundary = boundary;
                nextDateRange = this.createRangeForBoundary(boundary, day, otherBoundaryDate);
            }
        } else {
            // both boundaryDate and otherBoundaryDate are already defined
            if ((0, _dateUtils.isSameDay)(boundaryDate, day)) {
                var isSingleDayRangeSelected = (0, _dateUtils.isSameDay)(boundaryDate, otherBoundaryDate);
                var nextOtherBoundaryDate = isSingleDayRangeSelected ? null : otherBoundaryDate;
                nextBoundary = boundary;
                nextDateRange = this.createRangeForBoundary(boundary, null, nextOtherBoundaryDate);
            } else if ((0, _dateUtils.isSameDay)(day, otherBoundaryDate)) {
                var _a = allowSingleDayRange ? [
                    otherBoundaryDate,
                    otherBoundaryDate
                ] : [
                    boundaryDate,
                    null
                ], nextBoundaryDate = _a[0], nextOtherBoundaryDate = _a[1];
                nextBoundary = allowSingleDayRange ? boundary : otherBoundary;
                nextDateRange = this.createRangeForBoundary(boundary, nextBoundaryDate, nextOtherBoundaryDate);
            } else if (this.isOverlappingOtherBoundary(boundary, day, otherBoundaryDate)) {
                nextBoundary = boundary;
                nextDateRange = this.createRangeForBoundary(boundary, day, null);
            } else {
                // extend the date range with an earlier boundaryDate date
                nextBoundary = boundary;
                nextDateRange = this.createRangeForBoundary(boundary, day, otherBoundaryDate);
            }
        }
        return {
            dateRange: nextDateRange,
            boundary: nextBoundary
        };
    };
    DateRangeSelectionStrategy.getDefaultNextState = function(selectedRange, day, allowSingleDayRange) {
        var start = selectedRange[0], end = selectedRange[1];
        var nextDateRange;
        var nextBoundary = (0, _core.Boundary).START;
        if (start == null && end == null) nextDateRange = [
            day,
            null
        ];
        else if (start != null && end == null) {
            nextDateRange = this.createRange(day, start, allowSingleDayRange);
            nextBoundary = (0, _core.Boundary).END;
        } else if (start == null && end != null) nextDateRange = this.createRange(day, end, allowSingleDayRange);
        else {
            var isStart = (0, _dateUtils.isSameDay)(start, day);
            var isEnd = (0, _dateUtils.isSameDay)(end, day);
            if (isStart && isEnd) nextDateRange = [
                null,
                null
            ];
            else if (isStart) nextDateRange = [
                null,
                end
            ];
            else if (isEnd) {
                nextDateRange = [
                    start,
                    null
                ];
                nextBoundary = (0, _core.Boundary).END;
            } else nextDateRange = [
                day,
                null
            ];
        }
        return {
            dateRange: nextDateRange,
            boundary: nextBoundary
        };
    };
    DateRangeSelectionStrategy.getOtherBoundary = function(boundary) {
        return boundary === (0, _core.Boundary).START ? (0, _core.Boundary).END : (0, _core.Boundary).START;
    };
    DateRangeSelectionStrategy.getBoundaryDate = function(boundary, dateRange) {
        return boundary === (0, _core.Boundary).START ? dateRange[0] : dateRange[1];
    };
    DateRangeSelectionStrategy.isOverlappingOtherBoundary = function(boundary, boundaryDate, otherBoundaryDate) {
        return boundary === (0, _core.Boundary).START ? boundaryDate > otherBoundaryDate : boundaryDate < otherBoundaryDate;
    };
    DateRangeSelectionStrategy.createRangeForBoundary = function(boundary, boundaryDate, otherBoundaryDate) {
        return boundary === (0, _core.Boundary).START ? [
            boundaryDate,
            otherBoundaryDate
        ] : [
            otherBoundaryDate,
            boundaryDate
        ];
    };
    DateRangeSelectionStrategy.createRange = function(a, b, allowSingleDayRange) {
        // clicking the same date again will clear it
        if (!allowSingleDayRange && (0, _dateUtils.isSameDay)(a, b)) return [
            null,
            null
        ];
        return a < b ? [
            a,
            b
        ] : [
            b,
            a
        ];
    };
    return DateRangeSelectionStrategy;
}();

},{"@blueprintjs/core":"6Mq52","./dateUtils":"rPoyc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g91nA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthAndYear", ()=>MonthAndYear);
var _dateUtils = require("./dateUtils");
var MonthAndYear = /** @class */ function() {
    function MonthAndYear(month, year) {
        if (month !== null && year !== null) this.date = new Date(year, month);
        else this.date = new Date();
    }
    MonthAndYear.fromDate = function(date) {
        return date == null ? undefined : new MonthAndYear(date.getMonth(), date.getFullYear());
    };
    MonthAndYear.prototype.clone = function() {
        return new MonthAndYear(this.getMonth(), this.getYear());
    };
    MonthAndYear.prototype.getFullDate = function() {
        return this.date;
    };
    MonthAndYear.prototype.getMonth = function() {
        return this.date.getMonth();
    };
    MonthAndYear.prototype.getYear = function() {
        return this.date.getFullYear();
    };
    MonthAndYear.prototype.getPreviousMonth = function() {
        var previousMonthDate = (0, _dateUtils.getDatePreviousMonth)(this.date);
        return new MonthAndYear(previousMonthDate.getMonth(), previousMonthDate.getFullYear());
    };
    MonthAndYear.prototype.getNextMonth = function() {
        var nextMonthDate = (0, _dateUtils.getDateNextMonth)(this.date);
        return new MonthAndYear(nextMonthDate.getMonth(), nextMonthDate.getFullYear());
    };
    MonthAndYear.prototype.isBefore = function(monthAndYear) {
        return compareMonthAndYear(this, monthAndYear) < 0;
    };
    MonthAndYear.prototype.isAfter = function(monthAndYear) {
        return compareMonthAndYear(this, monthAndYear) > 0;
    };
    MonthAndYear.prototype.isSame = function(monthAndYear) {
        return compareMonthAndYear(this, monthAndYear) === 0;
    };
    MonthAndYear.prototype.isSameMonth = function(monthAndYear) {
        return this.getMonth() === monthAndYear.getMonth();
    };
    return MonthAndYear;
}();
// returns negative if left < right
// returns positive if left > right
// returns 0 if left === right
function compareMonthAndYear(firstMonthAndYear, secondMonthAndYear) {
    var firstMonth = firstMonthAndYear.getMonth();
    var firstYear = firstMonthAndYear.getYear();
    var secondMonth = secondMonthAndYear.getMonth();
    var secondYear = secondMonthAndYear.getYear();
    if (firstYear === secondYear) return firstMonth - secondMonth;
    else return firstYear - secondYear;
}

},{"./dateUtils":"rPoyc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fx3O4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerUtils", ()=>DatePickerUtils);
var _dateFormatProps = require("../../common/dateFormatProps");
var _utils = require("../../common/utils");
var _datePickerCore = require("./datePickerCore");
var DatePickerUtils = {
    getDefaultMaxDate: (0, _datePickerCore.getDefaultMaxDate),
    getDefaultMinDate: (0, _datePickerCore.getDefaultMinDate),
    getFormattedDateString: (0, _dateFormatProps.getFormattedDateString),
    measureTextWidth: (0, _utils.measureTextWidth)
};

},{"../../common/dateFormatProps":"bTgsF","../../common/utils":"ol9Ov","./datePickerCore":"k3Hon","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bTgsF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormattedDateString", ()=>getFormattedDateString);
var _dateUtils = require("./dateUtils");
function getFormattedDateString(date, props, ignoreRange) {
    if (ignoreRange === void 0) ignoreRange = false;
    if (date == null) return "";
    else if (!(0, _dateUtils.isDateValid)(date)) return props.invalidDateMessage;
    else if (ignoreRange || (0, _dateUtils.isDayInRange)(date, [
        props.minDate,
        props.maxDate
    ])) return props.formatDate(date, props.locale);
    else return props.outOfRangeMessage;
}

},{"./dateUtils":"rPoyc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ol9Ov":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Measure width in pixels of a string displayed with styles provided by `className`.
 * Should only be used if measuring can't be done with existing DOM elements.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "measureTextWidth", ()=>measureTextWidth);
parcelHelpers.export(exports, "padWithZeroes", ()=>padWithZeroes);
function measureTextWidth(text, className, containerElement) {
    if (className === void 0) className = "";
    if (containerElement === void 0) containerElement = document.body;
    if (containerElement == null) return 0;
    var span = document.createElement("span");
    span.classList.add(className);
    span.textContent = text;
    containerElement.appendChild(span);
    var spanWidth = span.offsetWidth;
    span.remove();
    return spanWidth;
}
function padWithZeroes(str, minLength) {
    if (str.length < minLength) return "".concat(stringRepeat("0", minLength - str.length)).concat(str);
    else return str;
}
function stringRepeat(str, numTimes) {
    return new Array(numTimes + 1).join(str);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k3Hon":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DISABLED_MODIFIER", ()=>DISABLED_MODIFIER);
parcelHelpers.export(exports, "HOVERED_RANGE_MODIFIER", ()=>HOVERED_RANGE_MODIFIER);
parcelHelpers.export(exports, "OUTSIDE_MODIFIER", ()=>OUTSIDE_MODIFIER);
parcelHelpers.export(exports, "SELECTED_MODIFIER", ()=>SELECTED_MODIFIER);
parcelHelpers.export(exports, "SELECTED_RANGE_MODIFIER", ()=>SELECTED_RANGE_MODIFIER);
parcelHelpers.export(exports, "DISALLOWED_MODIFIERS", ()=>DISALLOWED_MODIFIERS);
parcelHelpers.export(exports, "getDefaultMaxDate", ()=>getDefaultMaxDate);
parcelHelpers.export(exports, "getDefaultMinDate", ()=>getDefaultMinDate);
parcelHelpers.export(exports, "combineModifiers", ()=>combineModifiers);
var _common = require("../../common");
var DISABLED_MODIFIER = "disabled";
var HOVERED_RANGE_MODIFIER = "hovered-range";
var OUTSIDE_MODIFIER = "outside";
var SELECTED_MODIFIER = "selected";
var SELECTED_RANGE_MODIFIER = "selected-range";
var DISALLOWED_MODIFIERS = [
    DISABLED_MODIFIER,
    HOVERED_RANGE_MODIFIER,
    OUTSIDE_MODIFIER,
    SELECTED_MODIFIER,
    SELECTED_RANGE_MODIFIER
];
function getDefaultMaxDate() {
    var date = new Date();
    date.setMonth(date.getMonth() + 6);
    return date;
}
function getDefaultMinDate() {
    var date = new Date();
    date.setFullYear(date.getFullYear() - 20);
    date.setMonth((0, _common.Months).JANUARY, 1);
    return date;
}
function combineModifiers(baseModifiers, userModifiers) {
    var modifiers = baseModifiers;
    if (userModifiers != null) {
        modifiers = {};
        for(var _i = 0, _a = Object.keys(userModifiers); _i < _a.length; _i++){
            var key = _a[_i];
            if (DISALLOWED_MODIFIERS.indexOf(key) === -1) modifiers[key] = userModifiers[key];
        }
        for(var _b = 0, _c = Object.keys(baseModifiers); _b < _c.length; _b++){
            var key = _c[_b];
            modifiers[key] = baseModifiers[key];
        }
    }
    return modifiers;
}

},{"../../common":"1Uxts","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9s164":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimePicker", ()=>TimePicker);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _core = require("@blueprintjs/core");
var _common = require("../../common");
var _timeUnit = require("../../common/timeUnit");
var _utils = require("../../common/utils");
/**
 * Time picker component.
 *
 * @see https://blueprintjs.com/docs/#datetime/timepicker
 */ var TimePicker = /** @class */ function(_super) {
    (0, _tslib.__extends)(TimePicker, _super);
    function TimePicker(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.timeInputIds = (_a = {}, _a[(0, _timeUnit.TimeUnit).HOUR_24] = (0, _core.Utils).uniqueId((0, _timeUnit.TimeUnit).HOUR_24 + "-input"), _a[(0, _timeUnit.TimeUnit).HOUR_12] = (0, _core.Utils).uniqueId((0, _timeUnit.TimeUnit).HOUR_12 + "-input"), _a[(0, _timeUnit.TimeUnit).MINUTE] = (0, _core.Utils).uniqueId((0, _timeUnit.TimeUnit).MINUTE + "-input"), _a[(0, _timeUnit.TimeUnit).SECOND] = (0, _core.Utils).uniqueId((0, _timeUnit.TimeUnit).SECOND + "-input"), _a[(0, _timeUnit.TimeUnit).MS] = (0, _core.Utils).uniqueId((0, _timeUnit.TimeUnit).MS + "-input"), _a);
        // begin method definitions: event handlers
        _this.getInputChangeHandler = function(unit) {
            return function(e) {
                var text = getStringValueFromInputEvent(e);
                switch(unit){
                    case (0, _timeUnit.TimeUnit).HOUR_12:
                    case (0, _timeUnit.TimeUnit).HOUR_24:
                        _this.setState({
                            hourText: text
                        });
                        break;
                    case (0, _timeUnit.TimeUnit).MINUTE:
                        _this.setState({
                            minuteText: text
                        });
                        break;
                    case (0, _timeUnit.TimeUnit).SECOND:
                        _this.setState({
                            secondText: text
                        });
                        break;
                    case (0, _timeUnit.TimeUnit).MS:
                        _this.setState({
                            millisecondText: text
                        });
                        break;
                }
            };
        };
        _this.getInputBlurHandler = function(unit) {
            return function(e) {
                var _a, _b;
                var text = getStringValueFromInputEvent(e);
                _this.updateTime(parseInt(text, 10), unit);
                (_b = (_a = _this.props).onBlur) === null || _b === void 0 || _b.call(_a, e, unit);
            };
        };
        _this.getInputFocusHandler = function(unit) {
            return function(e) {
                var _a, _b;
                if (_this.props.selectAllOnFocus) e.currentTarget.select();
                (_b = (_a = _this.props).onFocus) === null || _b === void 0 || _b.call(_a, e, unit);
            };
        };
        _this.getInputKeyDownHandler = function(unit) {
            return function(e) {
                var _a, _b;
                handleKeyEvent(e, {
                    ArrowDown: function() {
                        return _this.decrementTime(unit);
                    },
                    ArrowUp: function() {
                        return _this.incrementTime(unit);
                    },
                    Enter: function() {
                        e.currentTarget.blur();
                    }
                });
                (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, e, unit);
            };
        };
        _this.getInputKeyUpHandler = function(unit) {
            return function(e) {
                var _a, _b;
                (_b = (_a = _this.props).onKeyUp) === null || _b === void 0 || _b.call(_a, e, unit);
            };
        };
        _this.handleAmPmChange = function(e) {
            var isNextPm = e.currentTarget.value === "pm";
            if (isNextPm !== _this.state.isPm) {
                var hour_1 = (0, _common.DateUtils).convert24HourMeridiem(_this.state.value.getHours(), isNextPm);
                _this.setState({
                    isPm: isNextPm
                }, function() {
                    return _this.updateTime(hour_1, (0, _timeUnit.TimeUnit).HOUR_24);
                });
            }
        };
        _this.incrementTime = function(unit) {
            return _this.shiftTime(unit, 1);
        };
        _this.decrementTime = function(unit) {
            return _this.shiftTime(unit, -1);
        };
        _this.state = _this.getFullStateFromValue(_this.getInitialValue(), props.useAmPm);
        return _this;
    }
    TimePicker.prototype.render = function() {
        var _a;
        var shouldRenderMilliseconds = this.props.precision === (0, _common.TimePrecision).MILLISECOND;
        var shouldRenderSeconds = shouldRenderMilliseconds || this.props.precision === (0, _common.TimePrecision).SECOND;
        var hourUnit = this.props.useAmPm ? (0, _timeUnit.TimeUnit).HOUR_12 : (0, _timeUnit.TimeUnit).HOUR_24;
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).TIMEPICKER, this.props.className, (_a = {}, _a[(0, _core.Classes).DISABLED] = this.props.disabled, _a));
        return _react.createElement("div", {
            className: classes
        }, _react.createElement("div", {
            className: (0, _common.Classes).TIMEPICKER_ARROW_ROW
        }, this.maybeRenderArrowButton(true, hourUnit), this.maybeRenderArrowButton(true, (0, _timeUnit.TimeUnit).MINUTE), shouldRenderSeconds && this.maybeRenderArrowButton(true, (0, _timeUnit.TimeUnit).SECOND), shouldRenderMilliseconds && this.maybeRenderArrowButton(true, (0, _timeUnit.TimeUnit).MS)), _react.createElement("div", {
            className: (0, _common.Classes).TIMEPICKER_INPUT_ROW
        }, this.renderInput((0, _common.Classes).TIMEPICKER_HOUR, hourUnit, this.state.hourText), this.renderDivider(), this.renderInput((0, _common.Classes).TIMEPICKER_MINUTE, (0, _timeUnit.TimeUnit).MINUTE, this.state.minuteText), shouldRenderSeconds && this.renderDivider(), shouldRenderSeconds && this.renderInput((0, _common.Classes).TIMEPICKER_SECOND, (0, _timeUnit.TimeUnit).SECOND, this.state.secondText), shouldRenderMilliseconds && this.renderDivider("."), shouldRenderMilliseconds && this.renderInput((0, _common.Classes).TIMEPICKER_MILLISECOND, (0, _timeUnit.TimeUnit).MS, this.state.millisecondText)), this.maybeRenderAmPm(), _react.createElement("div", {
            className: (0, _common.Classes).TIMEPICKER_ARROW_ROW
        }, this.maybeRenderArrowButton(false, hourUnit), this.maybeRenderArrowButton(false, (0, _timeUnit.TimeUnit).MINUTE), shouldRenderSeconds && this.maybeRenderArrowButton(false, (0, _timeUnit.TimeUnit).SECOND), shouldRenderMilliseconds && this.maybeRenderArrowButton(false, (0, _timeUnit.TimeUnit).MS)));
    };
    TimePicker.prototype.componentDidUpdate = function(prevProps) {
        var didMinTimeChange = prevProps.minTime !== this.props.minTime;
        var didMaxTimeChange = prevProps.maxTime !== this.props.maxTime;
        var didBoundsChange = didMinTimeChange || didMaxTimeChange;
        var didPropValueChange = prevProps.value !== this.props.value;
        var shouldStateUpdate = didBoundsChange || didPropValueChange;
        var value = this.state.value;
        if (this.props.value == null) value = this.getInitialValue();
        if (didBoundsChange) value = (0, _common.DateUtils).getTimeInRange(this.state.value, this.props.minTime, this.props.maxTime);
        if (this.props.value != null && !(0, _common.DateUtils).isSameTime(this.props.value, prevProps.value)) value = this.props.value;
        if (shouldStateUpdate) this.setState(this.getFullStateFromValue(value, this.props.useAmPm));
    };
    // begin method definitions: rendering
    TimePicker.prototype.maybeRenderArrowButton = function(isDirectionUp, timeUnit) {
        var _this = this;
        if (!this.props.showArrowButtons) return null;
        var classes = (0, _classnamesDefault.default)((0, _common.Classes).TIMEPICKER_ARROW_BUTTON, (0, _timeUnit.getTimeUnitClassName)(timeUnit));
        var onClick = function() {
            return (isDirectionUp ? _this.incrementTime : _this.decrementTime)(timeUnit);
        };
        var label = "".concat(isDirectionUp ? "Increase" : "Decrease", " ").concat((0, _timeUnit.getTimeUnitPrintStr)(timeUnit));
        // set tabIndex=-1 to ensure a valid FocusEvent relatedTarget when focused
        return _react.createElement("span", {
            "aria-controls": this.timeInputIds[timeUnit],
            "aria-label": label,
            tabIndex: -1,
            className: classes,
            onClick: onClick
        }, _react.createElement((0, _core.Icon), {
            icon: isDirectionUp ? "chevron-up" : "chevron-down",
            title: label
        }));
    };
    TimePicker.prototype.renderDivider = function(text) {
        if (text === void 0) text = ":";
        return _react.createElement("span", {
            className: (0, _common.Classes).TIMEPICKER_DIVIDER_TEXT
        }, text);
    };
    TimePicker.prototype.renderInput = function(className, unit, value) {
        var _a;
        var valueNumber = parseInt(value, 10);
        var isValid = (0, _timeUnit.isTimeUnitValid)(unit, valueNumber);
        var isHour = unit === (0, _timeUnit.TimeUnit).HOUR_12 || unit === (0, _timeUnit.TimeUnit).HOUR_24;
        return _react.createElement("input", {
            "aria-label": (0, _timeUnit.getTimeUnitPrintStr)(unit),
            className: (0, _classnamesDefault.default)((0, _common.Classes).TIMEPICKER_INPUT, (_a = {}, _a[(0, _core.Classes).intentClass((0, _core.Intent).DANGER)] = !isValid, _a), className),
            id: this.timeInputIds[unit],
            min: 0,
            max: (0, _timeUnit.getTimeUnitMax)(unit),
            onBlur: this.getInputBlurHandler(unit),
            onChange: this.getInputChangeHandler(unit),
            onFocus: this.getInputFocusHandler(unit),
            onKeyDown: this.getInputKeyDownHandler(unit),
            onKeyUp: this.getInputKeyUpHandler(unit),
            role: this.props.showArrowButtons ? "spinbutton" : undefined,
            type: "number",
            value: value,
            disabled: this.props.disabled,
            autoFocus: isHour && this.props.autoFocus
        });
    };
    TimePicker.prototype.maybeRenderAmPm = function() {
        if (!this.props.useAmPm) return null;
        return _react.createElement((0, _core.HTMLSelect), {
            className: (0, _common.Classes).TIMEPICKER_AMPM_SELECT,
            disabled: this.props.disabled,
            onChange: this.handleAmPmChange,
            value: this.state.isPm ? "pm" : "am"
        }, _react.createElement("option", {
            value: "am"
        }, "AM"), _react.createElement("option", {
            value: "pm"
        }, "PM"));
    };
    // begin method definitions: state modification
    /**
     * Generates a full TimePickerState object with all text fields set to formatted strings based on value
     */ TimePicker.prototype.getFullStateFromValue = function(value, useAmPm) {
        var timeInRange = (0, _common.DateUtils).getTimeInRange(value, this.props.minTime, this.props.maxTime);
        var hourUnit = useAmPm ? (0, _timeUnit.TimeUnit).HOUR_12 : (0, _timeUnit.TimeUnit).HOUR_24;
        /* tslint:disable:object-literal-sort-keys */ return {
            hourText: formatTime(timeInRange.getHours(), hourUnit),
            minuteText: formatTime(timeInRange.getMinutes(), (0, _timeUnit.TimeUnit).MINUTE),
            secondText: formatTime(timeInRange.getSeconds(), (0, _timeUnit.TimeUnit).SECOND),
            millisecondText: formatTime(timeInRange.getMilliseconds(), (0, _timeUnit.TimeUnit).MS),
            value: timeInRange,
            isPm: (0, _common.DateUtils).getIsPmFrom24Hour(timeInRange.getHours())
        };
    /* tslint:enable:object-literal-sort-keys */ };
    TimePicker.prototype.shiftTime = function(unit, amount) {
        if (this.props.disabled) return;
        var newTime = (0, _timeUnit.getTimeUnit)(unit, this.state.value) + amount;
        this.updateTime((0, _timeUnit.wrapTimeAtUnit)(unit, newTime), unit);
    };
    TimePicker.prototype.updateTime = function(time, unit) {
        var newValue = (0, _common.DateUtils).clone(this.state.value);
        if ((0, _timeUnit.isTimeUnitValid)(unit, time)) {
            (0, _timeUnit.setTimeUnit)(unit, time, newValue, this.state.isPm);
            if ((0, _common.DateUtils).isTimeInRange(newValue, this.props.minTime, this.props.maxTime)) this.updateState({
                value: newValue
            });
            else this.updateState(this.getFullStateFromValue(this.state.value, this.props.useAmPm));
        } else this.updateState(this.getFullStateFromValue(this.state.value, this.props.useAmPm));
    };
    TimePicker.prototype.updateState = function(state) {
        var _a, _b;
        var newState = state;
        var hasNewValue = newState.value != null && !(0, _common.DateUtils).isSameTime(newState.value, this.state.value);
        if (this.props.value == null) {
            // component is uncontrolled
            if (hasNewValue) newState = this.getFullStateFromValue(newState.value, this.props.useAmPm);
            this.setState(newState);
        } else // component is controlled, and there's a new value
        // so set inputs' text based off of _old_ value and later fire onChange with new value
        if (hasNewValue) this.setState(this.getFullStateFromValue(this.state.value, this.props.useAmPm));
        else // no new value, this means only text has changed (from user typing)
        // we want inputs to change, so update state with new text for the inputs
        // but don't change actual value
        this.setState((0, _tslib.__assign)((0, _tslib.__assign)({}, newState), {
            value: (0, _common.DateUtils).clone(this.state.value)
        }));
        if (hasNewValue) (_b = (_a = this.props).onChange) === null || _b === void 0 || _b.call(_a, newState.value);
    };
    TimePicker.prototype.getInitialValue = function() {
        var value = this.props.minTime;
        if (this.props.value != null) value = this.props.value;
        else if (this.props.defaultValue != null) value = this.props.defaultValue;
        return value;
    };
    TimePicker.defaultProps = {
        autoFocus: false,
        disabled: false,
        maxTime: (0, _timeUnit.getDefaultMaxTime)(),
        minTime: (0, _timeUnit.getDefaultMinTime)(),
        precision: (0, _common.TimePrecision).MINUTE,
        selectAllOnFocus: false,
        showArrowButtons: false,
        useAmPm: false
    };
    TimePicker.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".TimePicker");
    return TimePicker;
}(_react.Component);
function formatTime(time, unit) {
    switch(unit){
        case (0, _timeUnit.TimeUnit).HOUR_24:
            return time.toString();
        case (0, _timeUnit.TimeUnit).HOUR_12:
            return (0, _common.DateUtils).get12HourFrom24Hour(time).toString();
        case (0, _timeUnit.TimeUnit).MINUTE:
        case (0, _timeUnit.TimeUnit).SECOND:
            return _utils.padWithZeroes(time.toString(), 2);
        case (0, _timeUnit.TimeUnit).MS:
            return _utils.padWithZeroes(time.toString(), 3);
        default:
            throw Error("Invalid TimeUnit");
    }
}
function getStringValueFromInputEvent(e) {
    return e.target.value;
}
function handleKeyEvent(e, actions, preventDefault) {
    if (preventDefault === void 0) preventDefault = true;
    for(var _i = 0, _a = Object.keys(actions); _i < _a.length; _i++){
        var key = _a[_i];
        if (e.key === key) {
            if (preventDefault) e.preventDefault();
            actions[key]();
        }
    }
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/core":"6Mq52","../../common":"1Uxts","../../common/timeUnit":"6raXC","../../common/utils":"ol9Ov","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d7O46":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerShortcutMenu", ()=>DatePickerShortcutMenu);
var _tslib = require("tslib");
var _react = require("react");
var _core = require("@blueprintjs/core");
var _common = require("../../common");
var _dateUtils = require("../../common/dateUtils");
/**
 * Menu of {@link DateRangeShortcut} items, typically displayed in the UI to the left of a day picker calendar.
 *
 * This component may be used for single date pickers as well as range pickers by toggling the
 * `useSingleDateShortcuts` option.
 */ var DatePickerShortcutMenu = /** @class */ function(_super) {
    (0, _tslib.__extends)(DatePickerShortcutMenu, _super);
    function DatePickerShortcutMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getShorcutClickHandler = function(shortcut, index) {
            return function() {
                var onShortcutClick = _this.props.onShortcutClick;
                onShortcutClick(shortcut, index);
            };
        };
        _this.isShortcutInRange = function(shortcutDateRange) {
            var _a = _this.props, minDate = _a.minDate, maxDate = _a.maxDate;
            return (0, _dateUtils.isDayRangeInRange)(shortcutDateRange, [
                minDate,
                maxDate
            ]);
        };
        return _this;
    }
    DatePickerShortcutMenu.prototype.render = function() {
        var _this = this;
        var shortcuts = this.props.shortcuts === true ? createDefaultShortcuts(this.props.allowSingleDayRange, this.props.timePrecision !== undefined, this.props.useSingleDateShortcuts === true) : this.props.shortcuts;
        var shortcutElements = shortcuts.map(function(shortcut, index) {
            return _react.createElement((0, _core.MenuItem), {
                active: _this.props.selectedShortcutIndex === index,
                disabled: !_this.isShortcutInRange(shortcut.dateRange),
                key: index,
                onClick: _this.getShorcutClickHandler(shortcut, index),
                shouldDismissPopover: false,
                text: shortcut.label
            });
        });
        return _react.createElement((0, _core.Menu), {
            "aria-label": "Date picker shortcuts",
            className: (0, _common.Classes).DATERANGEPICKER_SHORTCUTS,
            tabIndex: 0
        }, shortcutElements);
    };
    DatePickerShortcutMenu.defaultProps = {
        selectedShortcutIndex: -1
    };
    return DatePickerShortcutMenu;
}(_react.PureComponent);
function createShortcut(label, dateRange) {
    return {
        dateRange: dateRange,
        label: label
    };
}
function createDefaultShortcuts(allowSingleDayRange, hasTimePrecision, useSingleDateShortcuts) {
    var today = new Date();
    var makeDate = function(action) {
        var returnVal = (0, _dateUtils.clone)(today);
        action(returnVal);
        returnVal.setDate(returnVal.getDate() + 1);
        return returnVal;
    };
    var tomorrow = makeDate(function() {
        return null;
    });
    var yesterday = makeDate(function(d) {
        return d.setDate(d.getDate() - 2);
    });
    var oneWeekAgo = makeDate(function(d) {
        return d.setDate(d.getDate() - 7);
    });
    var oneMonthAgo = makeDate(function(d) {
        return d.setMonth(d.getMonth() - 1);
    });
    var threeMonthsAgo = makeDate(function(d) {
        return d.setMonth(d.getMonth() - 3);
    });
    var sixMonthsAgo = makeDate(function(d) {
        return d.setMonth(d.getMonth() - 6);
    });
    var oneYearAgo = makeDate(function(d) {
        return d.setFullYear(d.getFullYear() - 1);
    });
    var twoYearsAgo = makeDate(function(d) {
        return d.setFullYear(d.getFullYear() - 2);
    });
    var singleDayShortcuts = allowSingleDayRange || useSingleDateShortcuts ? [
        createShortcut("Today", [
            today,
            hasTimePrecision ? tomorrow : today
        ]),
        createShortcut("Yesterday", [
            yesterday,
            hasTimePrecision ? today : yesterday
        ])
    ] : [];
    return (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], singleDayShortcuts, true), [
        createShortcut(useSingleDateShortcuts ? "1 week ago" : "Past week", [
            oneWeekAgo,
            today
        ]),
        createShortcut(useSingleDateShortcuts ? "1 month ago" : "Past month", [
            oneMonthAgo,
            today
        ]),
        createShortcut(useSingleDateShortcuts ? "3 months ago" : "Past 3 months", [
            threeMonthsAgo,
            today
        ])
    ], false), useSingleDateShortcuts ? [] : [
        createShortcut("Past 6 months", [
            sixMonthsAgo,
            today
        ])
    ], true), [
        createShortcut(useSingleDateShortcuts ? "1 year ago" : "Past year", [
            oneYearAgo,
            today
        ])
    ], false), useSingleDateShortcuts ? [] : [
        createShortcut("Past 2 years", [
            twoYearsAgo,
            today
        ])
    ], true);
}

},{"tslib":"b4wpY","react":"9njXz","@blueprintjs/core":"6Mq52","../../common":"1Uxts","../../common/dateUtils":"rPoyc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"RF4or":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimezoneSelect", ()=>TimezoneSelect);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _core = require("@blueprintjs/core");
var _select = require("@blueprintjs/select");
var _common = require("../../common");
var _timezoneDisplayFormat = require("../../common/timezoneDisplayFormat");
var _timezoneItems = require("../../common/timezoneItems");
var _timezoneNameUtils = require("../../common/timezoneNameUtils");
/**
 * Timezone select component.
 *
 * @see https://blueprintjs.com/docs/#datetime/timezone-select
 */ var TimezoneSelect = /** @class */ function(_super) {
    (0, _tslib.__extends)(TimezoneSelect, _super);
    function TimezoneSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.filterItems = function(query, items) {
            // using list predicate so only one RegExp instance is needed
            // escape bad regex characters, let spaces act as any separator
            var expr = new RegExp(query.replace(/([[()+*?])/g, "\\$1").replace(" ", "[ _/\\(\\)]+"), "i");
            return items.filter(function(item) {
                return expr.test(item.ianaCode) || expr.test(item.label) || expr.test(item.longName) || expr.test(item.shortName);
            });
        };
        _this.renderItem = function(item, _a) {
            var handleClick = _a.handleClick, modifiers = _a.modifiers;
            if (!modifiers.matchesPredicate) return null;
            return _react.createElement((0, _core.MenuItem), {
                key: item.ianaCode,
                selected: modifiers.active,
                text: "".concat(item.label, ", ").concat(item.longName),
                onClick: handleClick,
                label: item.shortName
            });
        };
        _this.handleItemSelect = function(timezone) {
            var _a, _b;
            return (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, timezone.ianaCode);
        };
        _this.handleQueryChange = function(query) {
            return _this.setState({
                query: query
            });
        };
        var showLocalTimezone = props.showLocalTimezone, _a = props.inputProps, inputProps = _a === void 0 ? {} : _a, date = props.date;
        _this.state = {
            query: inputProps.value || ""
        };
        _this.timezoneItems = (0, _timezoneNameUtils.mapTimezonesWithNames)(date, (0, _timezoneItems.TIMEZONE_ITEMS));
        _this.initialTimezoneItems = (0, _timezoneNameUtils.getInitialTimezoneItems)(date, showLocalTimezone);
        return _this;
    }
    TimezoneSelect.prototype.render = function() {
        var _a = this.props, children = _a.children, className = _a.className, disabled = _a.disabled, fill = _a.fill, inputProps = _a.inputProps, popoverProps = _a.popoverProps;
        var query = this.state.query;
        return _react.createElement((0, _select.Select), {
            className: (0, _classnamesDefault.default)((0, _common.Classes).TIMEZONE_SELECT, className),
            disabled: disabled,
            fill: fill,
            inputProps: (0, _tslib.__assign)({
                placeholder: "Search for timezones..."
            }, inputProps),
            itemListPredicate: this.filterItems,
            itemRenderer: this.renderItem,
            items: query ? this.timezoneItems : this.initialTimezoneItems,
            noResults: _react.createElement((0, _core.MenuItem), {
                disabled: true,
                roleStructure: "listoption",
                text: "No matching timezones."
            }),
            onItemSelect: this.handleItemSelect,
            onQueryChange: this.handleQueryChange,
            popoverProps: (0, _tslib.__assign)((0, _tslib.__assign)({}, popoverProps), {
                popoverClassName: (0, _classnamesDefault.default)((0, _common.Classes).TIMEZONE_SELECT_POPOVER, popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.popoverClassName)
            }),
            resetOnClose: true,
            resetOnSelect: true
        }, children !== null && children !== void 0 ? children : this.renderButton());
    };
    TimezoneSelect.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a;
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        var nextDate = this.props.date;
        if (this.props.showLocalTimezone !== prevProps.showLocalTimezone) this.initialTimezoneItems = (0, _timezoneNameUtils.getInitialTimezoneItems)(nextDate, this.props.showLocalTimezone);
        if (nextDate != null && nextDate.getTime() !== ((_a = prevProps.date) === null || _a === void 0 ? void 0 : _a.getTime())) {
            this.initialTimezoneItems = (0, _timezoneNameUtils.mapTimezonesWithNames)(nextDate, this.initialTimezoneItems);
            this.timezoneItems = (0, _timezoneNameUtils.mapTimezonesWithNames)(nextDate, this.timezoneItems);
        }
    };
    TimezoneSelect.prototype.renderButton = function() {
        var _a = this.props, _b = _a.buttonProps, buttonProps = _b === void 0 ? {} : _b, disabled = _a.disabled, fill = _a.fill, placeholder = _a.placeholder, value = _a.value, valueDisplayFormat = _a.valueDisplayFormat;
        var selectedTimezone = this.timezoneItems.find(function(tz) {
            return tz.ianaCode === value;
        });
        var buttonContent = selectedTimezone !== undefined ? (0, _timezoneDisplayFormat.formatTimezone)(selectedTimezone, valueDisplayFormat !== null && valueDisplayFormat !== void 0 ? valueDisplayFormat : (0, _timezoneDisplayFormat.TimezoneDisplayFormat).COMPOSITE) : _react.createElement("span", {
            className: (0, _core.Classes).TEXT_MUTED
        }, placeholder);
        return _react.createElement((0, _core.Button), (0, _tslib.__assign)({
            rightIcon: "caret-down",
            disabled: disabled,
            text: buttonContent,
            fill: fill
        }, buttonProps));
    };
    TimezoneSelect.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".TimezoneSelect");
    TimezoneSelect.defaultProps = {
        date: new Date(),
        disabled: false,
        fill: false,
        inputProps: {},
        placeholder: "Select timezone...",
        popoverProps: {},
        showLocalTimezone: false
    };
    return TimezoneSelect;
}((0, _core.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/core":"6Mq52","@blueprintjs/select":"3IMc6","../../common":"1Uxts","../../common/timezoneDisplayFormat":"lqJbn","../../common/timezoneItems":"jepBL","../../common/timezoneNameUtils":"hh6oW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3IMc6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _common = require("./common");
parcelHelpers.exportAll(_common, exports);
var _components = require("./components");
parcelHelpers.exportAll(_components, exports);
var _deprecatedAliases = require("./components/deprecatedAliases");
parcelHelpers.exportAll(_deprecatedAliases, exports);

},{"./common":false,"./components":"04uSf","./components/deprecatedAliases":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"QOOYl":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Classes", ()=>_classes);
var _classes = require("./classes");
var _itemListRenderer = require("./itemListRenderer");
parcelHelpers.exportAll(_itemListRenderer, exports);
var _itemRenderer = require("./itemRenderer");
parcelHelpers.exportAll(_itemRenderer, exports);
var _listItemsProps = require("./listItemsProps");
parcelHelpers.exportAll(_listItemsProps, exports);
var _listItemsUtils = require("./listItemsUtils");
parcelHelpers.exportAll(_listItemsUtils, exports);
var _predicate = require("./predicate");
parcelHelpers.exportAll(_predicate, exports);

},{"./classes":"kBbXO","./itemListRenderer":"hr3gA","./itemRenderer":false,"./listItemsProps":"cqrxn","./listItemsUtils":"eCJ1h","./predicate":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kBbXO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MULTISELECT", ()=>MULTISELECT);
parcelHelpers.export(exports, "MULTISELECT_POPOVER", ()=>MULTISELECT_POPOVER);
parcelHelpers.export(exports, "MULTISELECT_POPOVER_DEFAULT_WIDTH", ()=>MULTISELECT_POPOVER_DEFAULT_WIDTH);
parcelHelpers.export(exports, "MULTISELECT_POPOVER_TAG_INPUT_MARGIN", ()=>MULTISELECT_POPOVER_TAG_INPUT_MARGIN);
parcelHelpers.export(exports, "MULTISELECT_TAG_INPUT_INPUT", ()=>MULTISELECT_TAG_INPUT_INPUT);
parcelHelpers.export(exports, "OMNIBAR", ()=>OMNIBAR);
parcelHelpers.export(exports, "OMNIBAR_OVERLAY", ()=>OMNIBAR_OVERLAY);
parcelHelpers.export(exports, "SELECT_POPOVER", ()=>SELECT_POPOVER);
parcelHelpers.export(exports, "SUGGEST_POPOVER", ()=>SUGGEST_POPOVER);
var _core = require("@blueprintjs/core");
var NS = (0, _core.Classes).getClassNamespace();
var MULTISELECT = "".concat(NS, "-multi-select");
var MULTISELECT_POPOVER = "".concat(MULTISELECT, "-popover");
var MULTISELECT_POPOVER_DEFAULT_WIDTH = "".concat(MULTISELECT, "-popover-default-width");
var MULTISELECT_POPOVER_TAG_INPUT_MARGIN = "".concat(MULTISELECT, "-popover-tag-input-margin");
var MULTISELECT_TAG_INPUT_INPUT = "".concat(MULTISELECT, "-tag-input-input");
var OMNIBAR = "".concat(NS, "-omnibar");
var OMNIBAR_OVERLAY = "".concat(OMNIBAR, "-overlay");
var SELECT_POPOVER = "".concat(NS, "-select-popover");
var SUGGEST_POPOVER = "".concat(NS, "-suggest-popover");

},{"@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hr3gA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ItemListRenderer` helper method for rendering each item in `filteredItems`,
 * with optional support for `noResults` (when filtered items is empty)
 * and `initialContent` (when query is empty).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderFilteredItems", ()=>renderFilteredItems);
function renderFilteredItems(props, noResults, initialContent) {
    if (props.query.length === 0 && initialContent !== undefined) return initialContent;
    var items = props.filteredItems.map(props.renderItem).filter(function(item) {
        return item != null;
    });
    return items.length > 0 ? items : noResults;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cqrxn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Utility function for executing the {@link ListItemsProps#itemsEqual} prop to test
 * for equality between two items.
 *
 * @return `true` if the two items are equivalent according to `itemsEqualProp`.
 */ parcelHelpers.export(exports, "executeItemsEqual", ()=>executeItemsEqual);
var _core = require("@blueprintjs/core");
function executeItemsEqual(itemsEqualProp, itemA, itemB) {
    // Use strict equality if:
    // A) Default equality check is necessary because itemsEqualProp is undefined.
    // OR
    // B) Either item is null/undefined. Note that null represents "no item", while
    //    undefined represents an uncontrolled prop. This strict equality check ensures
    //    nothing will ever be considered equivalent to an uncontrolled prop.
    if (itemsEqualProp === undefined || itemA == null || itemB == null) return itemA === itemB;
    if ((0, _core.Utils).isFunction(itemsEqualProp)) // itemsEqualProp is an equality comparator function, so use it
    return itemsEqualProp(itemA, itemB);
    else // itemsEqualProp is a property name, so strictly compare the values of the property.
    return itemA[itemsEqualProp] === itemB[itemsEqualProp];
}

},{"@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eCJ1h":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns an instance of a "Create Item" object. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCreateNewItem", ()=>getCreateNewItem);
/**
 * Type guard returning `true` if the provided item (e.g. the current
 * `activeItem`) is a "Create Item" option.
 */ parcelHelpers.export(exports, "isCreateNewItem", ()=>isCreateNewItem);
/**
 * Returns the type of the the current active item. This will be a no-op unless
 * the `activeItem` is `undefined` or a "Create Item" option, in which case
 * `null` will be returned instead.
 */ parcelHelpers.export(exports, "getActiveItem", ()=>getActiveItem);
function getCreateNewItem() {
    return {
        __blueprintCreateNewItemBrand: "blueprint-create-new-item"
    };
}
function isCreateNewItem(item) {
    if (item == null) return false;
    // see if the provided item exactly matches the `CreateNewItem` object,
    // with no superfluous keys.
    var keys = Object.keys(item);
    if (keys.length !== 1 || keys[0] !== "__blueprintCreateNewItemBrand") return false;
    return item.__blueprintCreateNewItemBrand === "blueprint-create-new-item";
}
function getActiveItem(activeItem) {
    return activeItem == null || isCreateNewItem(activeItem) ? null : activeItem;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"04uSf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiSelect", ()=>(0, _multiSelect.MultiSelect));
parcelHelpers.export(exports, "Omnibar", ()=>(0, _omnibar.Omnibar));
parcelHelpers.export(exports, "QueryList", ()=>(0, _queryList.QueryList));
parcelHelpers.export(exports, "Select", ()=>(0, _select.Select));
parcelHelpers.export(exports, "Suggest", ()=>(0, _suggest.Suggest));
var _multiSelect = require("./multi-select/multiSelect");
var _omnibar = require("./omnibar/omnibar");
var _queryList = require("./query-list/queryList");
var _select = require("./select/select");
var _suggest = require("./suggest/suggest");

},{"./multi-select/multiSelect":"g58Lb","./omnibar/omnibar":false,"./query-list/queryList":false,"./select/select":"h0H1O","./suggest/suggest":"aMlQj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g58Lb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiSelect", ()=>MultiSelect);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _queryList = require("../query-list/queryList");
/**
 * Multi select component.
 *
 * @see https://blueprintjs.com/docs/#select/multi-select
 */ var MultiSelect = /** @class */ function(_super) {
    (0, _tslib.__extends)(MultiSelect, _super);
    function MultiSelect() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.listboxId = (0, _core.Utils).uniqueId("listbox");
        _this.state = {
            isOpen: _this.props.popoverProps && _this.props.popoverProps.isOpen || false
        };
        _this.input = null;
        _this.queryList = null;
        _this.refHandlers = {
            input: (0, _core.refHandler)(_this, "input", (_a = _this.props.tagInputProps) === null || _a === void 0 ? void 0 : _a.inputRef),
            popover: _react.createRef(),
            queryList: function(ref) {
                return _this.queryList = ref;
            }
        };
        _this.renderQueryList = function(listProps) {
            var _a;
            var _b = _this.props, disabled = _b.disabled, _c = _b.popoverContentProps, popoverContentProps = _c === void 0 ? {} : _c, _d = _b.popoverProps, popoverProps = _d === void 0 ? {} : _d;
            var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
            // N.B. no need to set `popoverProps.fill` since that is unused with the `renderTarget` API
            return _react.createElement((0, _core.Popover), (0, _tslib.__assign)({
                autoFocus: false,
                canEscapeKeyClose: true,
                disabled: disabled,
                enforceFocus: false,
                isOpen: _this.state.isOpen,
                placement: popoverProps.position || popoverProps.placement ? undefined : "bottom-start"
            }, popoverProps, {
                className: (0, _classnamesDefault.default)(listProps.className, popoverProps.className),
                content: _react.createElement("div", (0, _tslib.__assign)({
                    // In the case where customTarget is supplied and the TagInput is rendered within the Popover,
                    // without matchTargetWidth there is no width defined in any of TagInput's
                    // grandparents when it's rendered through usePortal, so it will never flex-wrap
                    // and infinitely grow horizontally. To address this, if there is no width guidance
                    // from matchTargetWidth, explicitly set a default width to so Tags will flex-wrap.
                    className: _this.props.customTarget != null && !((_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.matchTargetWidth) ? (0, _common.Classes).MULTISELECT_POPOVER_DEFAULT_WIDTH : undefined
                }, popoverContentProps, {
                    onKeyDown: handleKeyDown,
                    onKeyUp: handleKeyUp
                }), _this.props.customTarget != null && _this.getTagInput(listProps, (0, _classnamesDefault.default)((0, _core.Classes).FILL, (0, _common.Classes).MULTISELECT_POPOVER_TAG_INPUT_MARGIN)), listProps.itemList),
                interactionKind: "click",
                onInteraction: _this.handlePopoverInteraction,
                onOpened: _this.handlePopoverOpened,
                popoverClassName: (0, _classnamesDefault.default)((0, _common.Classes).MULTISELECT_POPOVER, popoverProps.popoverClassName),
                popupKind: (0, _core.PopupKind).LISTBOX,
                ref: (0, _core.mergeRefs)(_this.refHandlers.popover, _this.props.popoverRef),
                renderTarget: _this.getPopoverTargetRenderer(listProps, _this.state.isOpen)
            }));
        };
        // We use the renderTarget API to flatten the rendered DOM and make it easier to implement features like
        // the "fill" prop. Note that we must take `isOpen` as an argument to force this render function to be called
        // again after that state changes.
        _this.getPopoverTargetRenderer = function(listProps, isOpen) {
            // N.B. pull out `isOpen` so that it's not forwarded to the DOM, but remember not to use it directly
            // since it may be stale (`renderTarget` is not re-invoked on this.state changes).
            // eslint-disable-next-line react/display-name
            return function(_a) {
                var _b;
                var _isOpen = _a.isOpen, ref = _a.ref, targetProps = (0, _tslib.__rest)(_a, [
                    "isOpen",
                    "ref"
                ]);
                var _c = _this.props, disabled = _c.disabled, fill = _c.fill, selectedItems = _c.selectedItems, _d = _c.popoverProps, popoverProps = _d === void 0 ? {} : _d, _e = _c.popoverTargetProps, popoverTargetProps = _e === void 0 ? {} : _e;
                var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
                var _f = popoverProps.targetTagName, targetTagName = _f === void 0 ? "div" : _f;
                return _react.createElement(targetTagName, (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({
                    "aria-autocomplete": "list",
                    "aria-controls": _this.listboxId
                }, popoverTargetProps), targetProps), {
                    "aria-disabled": disabled,
                    "aria-expanded": isOpen,
                    // Note that we must set FILL here in addition to TagInput to get the wrapper element to full width
                    className: (0, _classnamesDefault.default)(targetProps.className, popoverTargetProps.className, (_b = {}, _b[(0, _core.Classes).FILL] = fill, _b)),
                    // Normally, Popover would also need to attach its own `onKeyDown` handler via `targetProps`,
                    // but in our case we fully manage that interaction and listen for key events to open/close
                    // the popover, so we elide it from the DOM.
                    onKeyDown: _this.getTagInputKeyDownHandler(handleKeyDown),
                    onKeyUp: _this.getTagInputKeyUpHandler(handleKeyUp),
                    ref: ref,
                    role: "combobox"
                }), _this.props.customTarget != null ? _this.props.customTarget(selectedItems, isOpen) : _this.getTagInput(listProps));
            };
        };
        _this.getTagInput = function(listProps, className) {
            var _a;
            var _b = _this.props, disabled = _b.disabled, fill = _b.fill, onClear = _b.onClear, placeholder = _b.placeholder, selectedItems = _b.selectedItems, _c = _b.tagInputProps, tagInputProps = _c === void 0 ? {} : _c;
            var maybeClearButton = onClear !== undefined && selectedItems.length > 0 ? // use both aria-label and title a11y attributes here, for screen readers
            // and mouseover interactions respectively
            _react.createElement((0, _core.Button), {
                "aria-label": "Clear selected items",
                disabled: disabled,
                icon: _react.createElement((0, _icons.Cross), null),
                minimal: true,
                onClick: _this.handleClearButtonClick,
                title: "Clear selected items"
            }) : undefined;
            // add our own inputProps.className so that we can reference it in event handlers
            var inputProps = (0, _tslib.__assign)((0, _tslib.__assign)({}, tagInputProps.inputProps), {
                className: (0, _classnamesDefault.default)((_a = tagInputProps.inputProps) === null || _a === void 0 ? void 0 : _a.className, (0, _common.Classes).MULTISELECT_TAG_INPUT_INPUT)
            });
            return _react.createElement((0, _core.TagInput), (0, _tslib.__assign)({
                placeholder: placeholder,
                rightElement: maybeClearButton
            }, tagInputProps, {
                className: (0, _classnamesDefault.default)(className, (0, _common.Classes).MULTISELECT, tagInputProps.className),
                disabled: disabled,
                fill: fill,
                inputRef: _this.refHandlers.input,
                inputProps: inputProps,
                inputValue: listProps.query,
                onAdd: _this.getTagInputAddHandler(listProps),
                onInputChange: listProps.handleQueryChange,
                onRemove: _this.handleTagRemove,
                values: selectedItems.map(_this.props.tagRenderer)
            }));
        };
        _this.handleItemSelect = function(item, evt) {
            var _a, _b, _c;
            if (_this.input != null) _this.input.focus();
            (_b = (_a = _this.props).onItemSelect) === null || _b === void 0 || _b.call(_a, item, evt);
            (_c = _this.refHandlers.popover.current) === null || _c === void 0 || _c.reposition(); // reposition when size of input changes
        };
        _this.handleQueryChange = function(query, evt) {
            var _a, _b;
            _this.setState({
                isOpen: query.length > 0 || _this.props.customTarget == null && !_this.props.openOnKeyDown
            });
            (_b = (_a = _this.props).onQueryChange) === null || _b === void 0 || _b.call(_a, query, evt);
        };
        // Popover interaction kind is CLICK, so this only handles click events.
        // Note that we defer to the next animation frame in order to get the latest activeElement
        _this.handlePopoverInteraction = function(nextOpenState, evt) {
            var _a, _b;
            if (_this.props.customTarget != null) {
                _this.setState({
                    isOpen: nextOpenState
                });
                (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onInteraction) === null || _b === void 0 || _b.call(_a, nextOpenState, evt);
                return;
            }
            _this.requestAnimationFrame(function() {
                var _a, _b;
                var isInputFocused = _this.input === (0, _core.Utils).getActiveElement(_this.input);
                if (_this.input != null && !isInputFocused) // input is no longer focused, we should close the popover
                _this.setState({
                    isOpen: false
                });
                else if (!_this.props.openOnKeyDown) // we should open immediately on click focus events
                _this.setState({
                    isOpen: true
                });
                (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onInteraction) === null || _b === void 0 || _b.call(_a, nextOpenState, evt);
            });
        };
        _this.handlePopoverOpened = function(node) {
            var _a, _b, _c, _d;
            if (_this.queryList != null) // scroll active item into view after popover transition completes and all dimensions are stable.
            _this.queryList.scrollActiveItemIntoView();
            var hasCustomTarget = _this.props.customTarget != null;
            if (hasCustomTarget && _this.input != null) {
                var shouldAutofocus = ((_b = (_a = _this.props.tagInputProps) === null || _a === void 0 ? void 0 : _a.inputProps) === null || _b === void 0 ? void 0 : _b.autoFocus) !== false;
                if (shouldAutofocus) _this.input.focus();
            }
            (_d = (_c = _this.props.popoverProps) === null || _c === void 0 ? void 0 : _c.onOpened) === null || _d === void 0 || _d.call(_c, node);
        };
        _this.handleTagRemove = function(tag, index) {
            var _a, _b;
            var _c = _this.props, selectedItems = _c.selectedItems, onRemove = _c.onRemove, tagInputProps = _c.tagInputProps;
            onRemove === null || onRemove === void 0 || onRemove(selectedItems[index], index);
            (_a = tagInputProps === null || tagInputProps === void 0 ? void 0 : tagInputProps.onRemove) === null || _a === void 0 || _a.call(tagInputProps, tag, index);
            (_b = _this.refHandlers.popover.current) === null || _b === void 0 || _b.reposition(); // reposition when size of input changes
        };
        _this.getTagInputAddHandler = function(listProps) {
            return function(values, method) {
                if (method === "paste") listProps.handlePaste(values);
            };
        };
        _this.getTagInputKeyDownHandler = function(handleQueryListKeyDown) {
            return function(e) {
                var _a, _b, _c;
                if (e.key === "Escape" || e.key === "Tab") {
                    // By default the escape key will not trigger a blur on the
                    // input element. It must be done explicitly.
                    if (e.key === "Escape") (_a = _this.input) === null || _a === void 0 || _a.blur();
                    _this.setState({
                        isOpen: false
                    });
                } else if (!(e.key === "Backspace" || e.key === "ArrowLeft" || e.key === "ArrowRight")) {
                    // Custom target might not be an input, so certain keystrokes might have other effects (space pushing the scrollview down)
                    if (_this.props.customTarget != null) {
                        if (e.key === " ") {
                            e.preventDefault();
                            _this.setState({
                                isOpen: true
                            });
                        } else if (e.key === "Enter") _this.setState({
                            isOpen: true
                        });
                    } else _this.setState({
                        isOpen: true
                    });
                }
                var isTargetingTagRemoveButton = e.target.closest(".".concat((0, _core.Classes).TAG_REMOVE)) != null;
                if (_this.state.isOpen && !isTargetingTagRemoveButton) handleQueryListKeyDown === null || handleQueryListKeyDown === void 0 || handleQueryListKeyDown(e);
                (_c = (_b = _this.props.popoverTargetProps) === null || _b === void 0 ? void 0 : _b.onKeyDown) === null || _c === void 0 || _c.call(_b, e);
            };
        };
        _this.getTagInputKeyUpHandler = function(handleQueryListKeyUp) {
            return function(e) {
                var _a, _b;
                var isTargetingInput = e.target.classList.contains((0, _common.Classes).MULTISELECT_TAG_INPUT_INPUT);
                // only handle events when the focus is on the actual <input> inside the TagInput, as that's
                // what QueryList is designed to do
                if (_this.state.isOpen && isTargetingInput) handleQueryListKeyUp === null || handleQueryListKeyUp === void 0 || handleQueryListKeyUp(e);
                (_b = (_a = _this.props.popoverTargetProps) === null || _a === void 0 ? void 0 : _a.onKeyDown) === null || _b === void 0 || _b.call(_a, e);
            };
        };
        _this.handleClearButtonClick = function() {
            var _a, _b, _c;
            (_b = (_a = _this.props).onClear) === null || _b === void 0 || _b.call(_a);
            (_c = _this.refHandlers.popover.current) === null || _c === void 0 || _c.reposition(); // reposition when size of input changes
        };
        return _this;
    }
    /** @deprecated no longer necessary now that the TypeScript parser supports type arguments on JSX element tags */ MultiSelect.ofType = function() {
        return MultiSelect;
    };
    MultiSelect.prototype.componentDidUpdate = function(prevProps) {
        var _a, _b, _c, _d, _e;
        if (((_a = prevProps.tagInputProps) === null || _a === void 0 ? void 0 : _a.inputRef) !== ((_b = this.props.tagInputProps) === null || _b === void 0 ? void 0 : _b.inputRef)) {
            (0, _core.setRef)((_c = prevProps.tagInputProps) === null || _c === void 0 ? void 0 : _c.inputRef, null);
            this.refHandlers.input = (0, _core.refHandler)(this, "input", (_d = this.props.tagInputProps) === null || _d === void 0 ? void 0 : _d.inputRef);
            (0, _core.setRef)((_e = this.props.tagInputProps) === null || _e === void 0 ? void 0 : _e.inputRef, this.input);
        }
        if (prevProps.onClear === undefined && this.props.onClear !== undefined || prevProps.onClear !== undefined && this.props.onClear === undefined) this.forceUpdate();
    };
    MultiSelect.prototype.render = function() {
        // omit props specific to this component, spread the rest.
        var _a = this.props, menuProps = _a.menuProps, openOnKeyDown = _a.openOnKeyDown, popoverProps = _a.popoverProps, tagInputProps = _a.tagInputProps, customTarget = _a.customTarget, restProps = (0, _tslib.__rest)(_a, [
            "menuProps",
            "openOnKeyDown",
            "popoverProps",
            "tagInputProps",
            "customTarget"
        ]);
        return _react.createElement((0, _queryList.QueryList), (0, _tslib.__assign)({}, restProps, {
            menuProps: (0, _tslib.__assign)((0, _tslib.__assign)({
                "aria-label": "selectable options"
            }, menuProps), {
                "aria-multiselectable": true,
                id: this.listboxId
            }),
            onItemSelect: this.handleItemSelect,
            onQueryChange: this.handleQueryChange,
            ref: this.refHandlers.queryList,
            renderer: this.renderQueryList
        }));
    };
    MultiSelect.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".MultiSelect");
    MultiSelect.defaultProps = {
        disabled: false,
        fill: false,
        placeholder: "Search..."
    };
    return MultiSelect;
}((0, _core.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/core":"6Mq52","@blueprintjs/icons":"bO9O5","../../common":"QOOYl","../query-list/queryList":"92Cu9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"92Cu9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryList", ()=>QueryList);
/**
 * Get the next enabled item, moving in the given direction from the start
 * index. A `null` return value means no suitable item was found.
 *
 * @param items the list of items
 * @param itemDisabled callback to determine if a given item is disabled
 * @param direction amount to move in each iteration, typically +/-1
 * @param startIndex which index to begin moving from
 */ parcelHelpers.export(exports, "getFirstEnabledItem", ()=>getFirstEnabledItem);
var _tslib = require("tslib");
var _react = require("react");
var _core = require("@blueprintjs/core");
var _common = require("../../common");
/**
 * Query list component.
 *
 * @see https://blueprintjs.com/docs/#select/query-list
 */ var QueryList = /** @class */ function(_super) {
    (0, _tslib.__extends)(QueryList, _super);
    function QueryList(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.itemRefs = new Map();
        _this.refHandlers = {
            itemsParent: function(ref) {
                return _this.itemsParentRef = ref;
            }
        };
        /**
         * Flag indicating that we should check whether selected item is in viewport
         * after rendering, typically because of keyboard change. Set to `true` when
         * manipulating state in a way that may cause active item to scroll away.
         */ _this.shouldCheckActiveItemInViewport = false;
        /**
         * The item that we expect to be the next selected active item (based on click
         * or key interactions). When scrollToActiveItem = false, used to detect if
         * an unexpected external change to the active item has been made.
         */ _this.expectedNextActiveItem = null;
        /**
         * Flag which is set to true while in between an ENTER "keydown" event and its
         * corresponding "keyup" event.
         *
         * When entering text via an IME (https://en.wikipedia.org/wiki/Input_method),
         * the ENTER key is pressed to confirm the character(s) to be input from a list
         * of options. The operating system intercepts the ENTER "keydown" event and
         * prevents it from propagating to the application, but "keyup" is still
         * fired, triggering a spurious event which this component does not expect.
         *
         * To work around this quirk, we keep track of "real" key presses by setting
         * this flag in handleKeyDown.
         */ _this.isEnterKeyPressed = false;
        /** default `itemListRenderer` implementation */ _this.renderItemList = function(listProps) {
            var _a = _this.props, initialContent = _a.initialContent, noResults = _a.noResults;
            // omit noResults if createNewItemFromQuery and createNewItemRenderer are both supplied, and query is not empty
            var createItemView = listProps.renderCreateItem();
            var maybeNoResults = createItemView != null ? null : noResults;
            var menuContent = (0, _common.renderFilteredItems)(listProps, maybeNoResults, initialContent);
            if (menuContent == null && createItemView == null) return null;
            var createFirst = _this.isCreateItemFirst();
            return _react.createElement((0, _core.Menu), (0, _tslib.__assign)({
                role: "listbox"
            }, listProps.menuProps, {
                ulRef: listProps.itemsParentRef
            }), createFirst && createItemView, menuContent, !createFirst && createItemView);
        };
        /** wrapper around `itemRenderer` to inject props */ _this.renderItem = function(item, index) {
            if (_this.props.disabled !== true) {
                var _a = _this.state, activeItem = _a.activeItem, query = _a.query, filteredItems = _a.filteredItems;
                var modifiers = {
                    active: (0, _common.executeItemsEqual)(_this.props.itemsEqual, (0, _common.getActiveItem)(activeItem), item),
                    disabled: isItemDisabled(item, index, _this.props.itemDisabled),
                    matchesPredicate: filteredItems.indexOf(item) >= 0
                };
                return _this.props.itemRenderer(item, {
                    handleClick: function(e) {
                        return _this.handleItemSelect(item, e);
                    },
                    handleFocus: function() {
                        return _this.setActiveItem(item);
                    },
                    index: index,
                    modifiers: modifiers,
                    query: query,
                    ref: function(node) {
                        if (node) _this.itemRefs.set(index, node);
                        else _this.itemRefs.delete(index);
                    }
                });
            }
            return null;
        };
        _this.renderCreateItemMenuItem = function() {
            if (_this.isCreateItemRendered(_this.state.createNewItem)) {
                var _a = _this.state, activeItem = _a.activeItem, query = _a.query;
                var trimmedQuery_1 = query.trim();
                var handleClick = function(evt) {
                    _this.handleItemCreate(trimmedQuery_1, evt);
                };
                var isActive = (0, _common.isCreateNewItem)(activeItem);
                return _this.props.createNewItemRenderer(trimmedQuery_1, isActive, handleClick);
            }
            return null;
        };
        _this.handleItemCreate = function(query, evt) {
            var _a, _b, _c, _d;
            // we keep a cached createNewItem in state, but might as well recompute
            // the result just to be sure it's perfectly in sync with the query.
            var value = (_b = (_a = _this.props).createNewItemFromQuery) === null || _b === void 0 ? void 0 : _b.call(_a, query);
            if (value != null) {
                var newItems = Array.isArray(value) ? value : [
                    value
                ];
                for(var _i = 0, newItems_1 = newItems; _i < newItems_1.length; _i++){
                    var item = newItems_1[_i];
                    (_d = (_c = _this.props).onItemSelect) === null || _d === void 0 || _d.call(_c, item, evt);
                }
                _this.maybeResetQuery();
            }
        };
        _this.handleItemSelect = function(item, event) {
            var _a, _b;
            _this.setActiveItem(item);
            (_b = (_a = _this.props).onItemSelect) === null || _b === void 0 || _b.call(_a, item, event);
            _this.maybeResetQuery();
        };
        _this.handlePaste = function(queries) {
            var _a = _this.props, createNewItemFromQuery = _a.createNewItemFromQuery, onItemsPaste = _a.onItemsPaste;
            var nextActiveItem;
            var nextQueries = [];
            // Find an exising item that exactly matches each pasted value, or
            // create a new item if possible. Ignore unmatched values if creating
            // items is disabled.
            var pastedItemsToEmit = [];
            for(var _i = 0, queries_1 = queries; _i < queries_1.length; _i++){
                var query = queries_1[_i];
                var equalItem = getMatchingItem(query, _this.props);
                if (equalItem !== undefined) {
                    nextActiveItem = equalItem;
                    pastedItemsToEmit.push(equalItem);
                } else if (_this.canCreateItems()) {
                    var value = createNewItemFromQuery === null || createNewItemFromQuery === void 0 ? void 0 : createNewItemFromQuery(query);
                    if (value !== undefined) {
                        var newItems = Array.isArray(value) ? value : [
                            value
                        ];
                        pastedItemsToEmit.push.apply(pastedItemsToEmit, newItems);
                    }
                } else nextQueries.push(query);
            }
            // UX nicety: combine all unmatched queries into a single
            // comma-separated query in the input, so we don't lose any information.
            // And don't reset the active item; we'll do that ourselves below.
            _this.setQuery(nextQueries.join(", "), false);
            // UX nicety: update the active item if we matched with at least one
            // existing item.
            if (nextActiveItem !== undefined) _this.setActiveItem(nextActiveItem);
            onItemsPaste === null || onItemsPaste === void 0 || onItemsPaste(pastedItemsToEmit);
        };
        _this.handleKeyDown = function(event) {
            var _a, _b;
            if (!event.nativeEvent.isComposing) {
                var key = event.key;
                var direction = (0, _core.Utils).getArrowKeyDirection(event, [
                    "ArrowUp"
                ], [
                    "ArrowDown"
                ]);
                if (direction !== undefined) {
                    event.preventDefault();
                    var nextActiveItem = _this.getNextActiveItem(direction);
                    if (nextActiveItem != null) _this.setActiveItem(nextActiveItem);
                } else if (key === "Enter") _this.isEnterKeyPressed = true;
            }
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.handleKeyUp = function(event) {
            var onKeyUp = _this.props.onKeyUp;
            var activeItem = _this.state.activeItem;
            if (event.key === "Enter" && _this.isEnterKeyPressed) {
                // We handle ENTER in keyup here to play nice with the Button component's keyboard
                // clicking. Button is commonly used as the only child of Select. If we were to
                // instead process ENTER on keydown, then Button would click itself on keyup and
                // the Select popover would re-open.
                event.preventDefault();
                if (activeItem == null || (0, _common.isCreateNewItem)(activeItem)) _this.handleItemCreate(_this.state.query, event);
                else _this.handleItemSelect(activeItem, event);
                _this.isEnterKeyPressed = false;
            }
            onKeyUp === null || onKeyUp === void 0 || onKeyUp(event);
        };
        _this.handleInputQueryChange = function(event) {
            var _a, _b;
            var query = event == null ? "" : event.target.value;
            _this.setQuery(query);
            (_b = (_a = _this.props).onQueryChange) === null || _b === void 0 || _b.call(_a, query, event);
        };
        var _c = props.query, query = _c === void 0 ? "" : _c;
        var createNewItem = (_a = props.createNewItemFromQuery) === null || _a === void 0 ? void 0 : _a.call(props, query);
        var filteredItems = getFilteredItems(query, props);
        _this.state = {
            activeItem: props.activeItem !== undefined ? props.activeItem : (_b = props.initialActiveItem) !== null && _b !== void 0 ? _b : getFirstEnabledItem(filteredItems, props.itemDisabled),
            createNewItem: createNewItem,
            filteredItems: filteredItems,
            query: query
        };
        return _this;
    }
    /** @deprecated no longer necessary now that the TypeScript parser supports type arguments on JSX element tags */ QueryList.ofType = function() {
        return QueryList;
    };
    QueryList.prototype.render = function() {
        var _a = this.props, className = _a.className, items = _a.items, renderer = _a.renderer, _b = _a.itemListRenderer, itemListRenderer = _b === void 0 ? this.renderItemList : _b, menuProps = _a.menuProps;
        var _c = this.state, createNewItem = _c.createNewItem, spreadableState = (0, _tslib.__rest)(_c, [
            "createNewItem"
        ]);
        return renderer((0, _tslib.__assign)((0, _tslib.__assign)({}, spreadableState), {
            className: className,
            handleItemSelect: this.handleItemSelect,
            handleKeyDown: this.handleKeyDown,
            handleKeyUp: this.handleKeyUp,
            handlePaste: this.handlePaste,
            handleQueryChange: this.handleInputQueryChange,
            itemList: itemListRenderer((0, _tslib.__assign)((0, _tslib.__assign)({}, spreadableState), {
                items: items,
                itemsParentRef: this.refHandlers.itemsParent,
                menuProps: menuProps,
                renderCreateItem: this.renderCreateItemMenuItem,
                renderItem: this.renderItem
            }))
        }));
    };
    QueryList.prototype.componentDidUpdate = function(prevProps) {
        var _this = this;
        if (this.props.activeItem !== undefined && this.props.activeItem !== this.state.activeItem) {
            this.shouldCheckActiveItemInViewport = true;
            this.setState({
                activeItem: this.props.activeItem
            });
        }
        if (this.props.query != null && this.props.query !== prevProps.query) // new query
        this.setQuery(this.props.query, this.props.resetOnQuery, this.props);
        else if (// same query (or uncontrolled query), but items in the list changed
        !(0, _core.Utils).shallowCompareKeys(this.props, prevProps, {
            include: [
                "items",
                "itemListPredicate",
                "itemPredicate"
            ]
        })) this.setQuery(this.state.query);
        if (this.shouldCheckActiveItemInViewport) {
            // update scroll position immediately before repaint so DOM is accurate
            // (latest filteredItems) and to avoid flicker.
            this.requestAnimationFrame(function() {
                return _this.scrollActiveItemIntoView();
            });
            // reset the flag
            this.shouldCheckActiveItemInViewport = false;
        }
    };
    QueryList.prototype.scrollActiveItemIntoView = function() {
        var scrollToActiveItem = this.props.scrollToActiveItem !== false;
        var externalChangeToActiveItem = !(0, _common.executeItemsEqual)(this.props.itemsEqual, (0, _common.getActiveItem)(this.expectedNextActiveItem), (0, _common.getActiveItem)(this.props.activeItem));
        this.expectedNextActiveItem = null;
        if (!scrollToActiveItem && externalChangeToActiveItem) return;
        var activeElement = this.getActiveElement();
        if (this.itemsParentRef != null && activeElement != null) {
            var activeTop = activeElement.offsetTop, activeHeight = activeElement.offsetHeight;
            var _a = this.itemsParentRef, parentOffsetTop = _a.offsetTop, parentScrollTop = _a.scrollTop, parentHeight = _a.clientHeight;
            // compute padding on parent element to ensure we always leave space
            var _b = this.getItemsParentPadding(), paddingTop = _b.paddingTop, paddingBottom = _b.paddingBottom;
            // compute the two edges of the active item for comparison, including parent padding
            var activeBottomEdge = activeTop + activeHeight + paddingBottom - parentOffsetTop;
            var activeTopEdge = activeTop - paddingTop - parentOffsetTop;
            if (activeBottomEdge >= parentScrollTop + parentHeight) // offscreen bottom: align bottom of item with bottom of viewport
            this.itemsParentRef.scrollTop = activeBottomEdge + activeHeight - parentHeight;
            else if (activeTopEdge <= parentScrollTop) // offscreen top: align top of item with top of viewport
            this.itemsParentRef.scrollTop = activeTopEdge - activeHeight;
        }
    };
    QueryList.prototype.setQuery = function(query, resetActiveItem, props) {
        var _a;
        if (resetActiveItem === void 0) resetActiveItem = this.props.resetOnQuery;
        if (props === void 0) props = this.props;
        var createNewItemFromQuery = props.createNewItemFromQuery;
        this.shouldCheckActiveItemInViewport = true;
        var hasQueryChanged = query !== this.state.query;
        if (hasQueryChanged) (_a = props.onQueryChange) === null || _a === void 0 || _a.call(props, query);
        // Leading and trailing whitespace can be confusing to display, so we remove it when passing it
        // to functions dealing with data, like createNewItemFromQuery. But we need the unaltered user-typed
        // query to remain in state to be able to render controlled text inputs properly.
        var trimmedQuery = query.trim();
        var filteredItems = getFilteredItems(trimmedQuery, props);
        var createNewItem = createNewItemFromQuery != null && trimmedQuery !== "" ? createNewItemFromQuery(trimmedQuery) : undefined;
        this.setState({
            createNewItem: createNewItem,
            filteredItems: filteredItems,
            query: query
        });
        // always reset active item if it's now filtered or disabled
        var activeIndex = this.getActiveIndex(filteredItems);
        var shouldUpdateActiveItem = resetActiveItem || activeIndex < 0 || isItemDisabled((0, _common.getActiveItem)(this.state.activeItem), activeIndex, props.itemDisabled);
        if (shouldUpdateActiveItem) {
            // if the `createNewItem` is first, that should be the first active item.
            if (this.isCreateItemRendered(createNewItem) && this.isCreateItemFirst()) this.setActiveItem((0, _common.getCreateNewItem)());
            else this.setActiveItem(getFirstEnabledItem(filteredItems, props.itemDisabled));
        }
    };
    QueryList.prototype.setActiveItem = function(activeItem) {
        var _a, _b, _c, _d;
        this.expectedNextActiveItem = activeItem;
        if (this.props.activeItem === undefined) {
            // indicate that the active item may need to be scrolled into view after update.
            this.shouldCheckActiveItemInViewport = true;
            this.setState({
                activeItem: activeItem
            });
        }
        if ((0, _common.isCreateNewItem)(activeItem)) (_b = (_a = this.props).onActiveItemChange) === null || _b === void 0 || _b.call(_a, null, true);
        else (_d = (_c = this.props).onActiveItemChange) === null || _d === void 0 || _d.call(_c, activeItem, false);
    };
    QueryList.prototype.getActiveElement = function() {
        var _a;
        var activeItem = this.state.activeItem;
        if (this.itemsParentRef != null) {
            if ((0, _common.isCreateNewItem)(activeItem)) {
                var index = this.isCreateItemFirst() ? 0 : this.state.filteredItems.length;
                return this.itemsParentRef.children.item(index);
            } else {
                var activeIndex = this.getActiveIndex();
                return (_a = this.itemRefs.get(activeIndex)) !== null && _a !== void 0 ? _a : this.itemsParentRef.children.item(activeIndex);
            }
        }
        return undefined;
    };
    QueryList.prototype.getActiveIndex = function(items) {
        if (items === void 0) items = this.state.filteredItems;
        var activeItem = this.state.activeItem;
        if (activeItem == null || (0, _common.isCreateNewItem)(activeItem)) return -1;
        // NOTE: this operation is O(n) so it should be avoided in render(). safe for events though.
        for(var i = 0; i < items.length; ++i){
            if ((0, _common.executeItemsEqual)(this.props.itemsEqual, items[i], activeItem)) return i;
        }
        return -1;
    };
    QueryList.prototype.getItemsParentPadding = function() {
        // assert ref exists because it was checked before calling
        var _a = getComputedStyle(this.itemsParentRef), paddingTop = _a.paddingTop, paddingBottom = _a.paddingBottom;
        return {
            paddingBottom: pxToNumber(paddingBottom),
            paddingTop: pxToNumber(paddingTop)
        };
    };
    /**
     * Get the next enabled item, moving in the given direction from the start
     * index. A `null` return value means no suitable item was found.
     *
     * @param direction amount to move in each iteration, typically +/-1
     * @param startIndex item to start iteration
     */ QueryList.prototype.getNextActiveItem = function(direction, startIndex) {
        if (startIndex === void 0) startIndex = this.getActiveIndex();
        if (this.isCreateItemRendered(this.state.createNewItem)) {
            var reachedCreate = startIndex === 0 && direction === -1 || startIndex === this.state.filteredItems.length - 1 && direction === 1;
            if (reachedCreate) return (0, _common.getCreateNewItem)();
        }
        return getFirstEnabledItem(this.state.filteredItems, this.props.itemDisabled, direction, startIndex);
    };
    /**
     * @param createNewItem Checks if this item would match the current query. Cannot check this.state.createNewItem
     *  every time since state may not have been updated yet.
     */ QueryList.prototype.isCreateItemRendered = function(createNewItem) {
        return this.canCreateItems() && this.state.query !== "" && // this check is unfortunately O(N) on the number of items, but
        // alas, hiding the "Create Item" option when it exactly matches an
        // existing item is much clearer.
        !this.wouldCreatedItemMatchSomeExistingItem(createNewItem);
    };
    QueryList.prototype.isCreateItemFirst = function() {
        return this.props.createNewItemPosition === "first";
    };
    QueryList.prototype.canCreateItems = function() {
        return this.props.createNewItemFromQuery != null && this.props.createNewItemRenderer != null;
    };
    QueryList.prototype.wouldCreatedItemMatchSomeExistingItem = function(createNewItem) {
        var _this = this;
        // search only the filtered items, not the full items list, because we
        // only need to check items that match the current query.
        return this.state.filteredItems.some(function(item) {
            var newItems = Array.isArray(createNewItem) ? createNewItem : [
                createNewItem
            ];
            return newItems.some(function(newItem) {
                return (0, _common.executeItemsEqual)(_this.props.itemsEqual, item, newItem);
            });
        });
    };
    QueryList.prototype.maybeResetQuery = function() {
        if (this.props.resetOnSelect) this.setQuery("", true);
    };
    QueryList.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".QueryList");
    QueryList.defaultProps = {
        disabled: false,
        resetOnQuery: true
    };
    return QueryList;
}((0, _core.AbstractComponent));
function pxToNumber(value) {
    return value == null ? 0 : parseInt(value.slice(0, -2), 10);
}
function getMatchingItem(query, _a) {
    var items = _a.items, itemPredicate = _a.itemPredicate;
    if ((0, _core.Utils).isFunction(itemPredicate)) // .find() doesn't exist in ES5. Alternative: use a for loop instead of
    // .filter() so that we can return as soon as we find the first match.
    for(var i = 0; i < items.length; i++){
        var item = items[i];
        if (itemPredicate(query, item, i, true)) return item;
    }
    return undefined;
}
function getFilteredItems(query, _a) {
    var items = _a.items, itemPredicate = _a.itemPredicate, itemListPredicate = _a.itemListPredicate;
    if ((0, _core.Utils).isFunction(itemListPredicate)) // note that implementations can reorder the items here
    return itemListPredicate(query, items);
    else if ((0, _core.Utils).isFunction(itemPredicate)) return items.filter(function(item, index) {
        return itemPredicate(query, item, index);
    });
    return items;
}
/** Wrap number around min/max values: if it exceeds one bound, return the other. */ function wrapNumber(value, min, max) {
    if (value < min) return max;
    else if (value > max) return min;
    return value;
}
function isItemDisabled(item, index, itemDisabled) {
    if (itemDisabled == null || item == null) return false;
    else if ((0, _core.Utils).isFunction(itemDisabled)) return itemDisabled(item, index);
    return !!item[itemDisabled];
}
function getFirstEnabledItem(items, itemDisabled, direction, startIndex) {
    if (direction === void 0) direction = 1;
    if (startIndex === void 0) startIndex = items.length - 1;
    if (items.length === 0) return null;
    // remember where we started to prevent an infinite loop
    var index = startIndex;
    var maxIndex = items.length - 1;
    do {
        // find first non-disabled item
        index = wrapNumber(index + direction, 0, maxIndex);
        if (!isItemDisabled(items[index], index, itemDisabled)) return items[index];
    }while (index !== startIndex && startIndex !== -1);
    return null;
}

},{"tslib":"b4wpY","react":"9njXz","@blueprintjs/core":"6Mq52","../../common":"QOOYl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h0H1O":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _common = require("../../common");
var _queryList = require("../query-list/queryList");
/**
 * Select component.
 *
 * @see https://blueprintjs.com/docs/#select/select
 */ var Select = /** @class */ function(_super) {
    (0, _tslib.__extends)(Select, _super);
    function Select() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false
        };
        _this.inputElement = null;
        _this.queryList = null;
        _this.handleInputRef = (0, _core.refHandler)(_this, "inputElement", (_a = _this.props.inputProps) === null || _a === void 0 ? void 0 : _a.inputRef);
        _this.handleQueryListRef = function(ref) {
            return _this.queryList = ref;
        };
        _this.listboxId = (0, _core.Utils).uniqueId("listbox");
        _this.renderQueryList = function(listProps) {
            // not using defaultProps cuz they're hard to type with generics (can't use <T> on static members)
            var _a = _this.props, _b = _a.filterable, filterable = _b === void 0 ? true : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.inputProps, inputProps = _d === void 0 ? {} : _d, _e = _a.placeholder, placeholder = _e === void 0 ? "Filter..." : _e, _f = _a.popoverContentProps, popoverContentProps = _f === void 0 ? {} : _f, _g = _a.popoverProps, popoverProps = _g === void 0 ? {} : _g, popoverRef = _a.popoverRef;
            var input = _react.createElement((0, _core.InputGroup), (0, _tslib.__assign)({
                "aria-autocomplete": "list",
                leftIcon: _react.createElement((0, _icons.Search), null),
                placeholder: placeholder,
                rightElement: _this.maybeRenderClearButton(listProps.query)
            }, inputProps, {
                inputRef: _this.handleInputRef,
                onChange: listProps.handleQueryChange,
                value: listProps.query
            }));
            var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
            // N.B. no need to set `fill` since that is unused with the `renderTarget` API
            return _react.createElement((0, _core.Popover), (0, _tslib.__assign)({
                autoFocus: false,
                enforceFocus: false,
                isOpen: _this.state.isOpen,
                disabled: disabled,
                placement: popoverProps.position || popoverProps.placement ? undefined : "bottom-start"
            }, popoverProps, {
                className: (0, _classnamesDefault.default)(listProps.className, popoverProps.className),
                content: _react.createElement("div", (0, _tslib.__assign)({}, popoverContentProps, {
                    onKeyDown: handleKeyDown,
                    onKeyUp: handleKeyUp
                }), filterable ? input : undefined, listProps.itemList),
                onClosing: _this.handlePopoverClosing,
                onInteraction: _this.handlePopoverInteraction,
                onOpened: _this.handlePopoverOpened,
                onOpening: _this.handlePopoverOpening,
                popoverClassName: (0, _classnamesDefault.default)((0, _common.Classes).SELECT_POPOVER, popoverProps.popoverClassName),
                popupKind: (0, _core.PopupKind).LISTBOX,
                ref: popoverRef,
                renderTarget: _this.getPopoverTargetRenderer(listProps, _this.state.isOpen)
            }));
        };
        // We use the renderTarget API to flatten the rendered DOM and make it easier to implement features like
        // the "fill" prop. Note that we must take `isOpen` as an argument to force this render function to be called
        // again after that state changes.
        _this.getPopoverTargetRenderer = function(listProps, isOpen) {
            // N.B. pull out `isOpen` so that it's not forwarded to the DOM, but remember not to use it directly
            // since it may be stale (`renderTarget` is not re-invoked on this.state changes).
            // eslint-disable-next-line react/display-name
            return function(_a) {
                var _b;
                var _isOpen = _a.isOpen, ref = _a.ref, targetProps = (0, _tslib.__rest)(_a, [
                    "isOpen",
                    "ref"
                ]);
                var _c = _this.props, disabled = _c.disabled, _d = _c.popoverProps, popoverProps = _d === void 0 ? {} : _d, popoverTargetProps = _c.popoverTargetProps;
                var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
                var _e = popoverProps.targetTagName, targetTagName = _e === void 0 ? "div" : _e;
                return _react.createElement(targetTagName, (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({
                    "aria-controls": _this.listboxId
                }, popoverTargetProps), targetProps), {
                    "aria-disabled": disabled,
                    "aria-expanded": isOpen,
                    // Note that we must set FILL here in addition to children to get the wrapper element to full width
                    className: (0, _classnamesDefault.default)(targetProps.className, popoverTargetProps === null || popoverTargetProps === void 0 ? void 0 : popoverTargetProps.className, (_b = {}, _b[(0, _core.Classes).FILL] = _this.props.fill, _b)),
                    // Normally, Popover would also need to attach its own `onKeyDown` handler via `targetProps`,
                    // but in our case we fully manage that interaction and listen for key events to open/close
                    // the popover, so we elide it from the DOM.
                    onKeyDown: _this.withPopoverTargetPropsHandler("keydown", isOpen ? handleKeyDown : _this.handleTargetKeyDown),
                    onKeyUp: _this.withPopoverTargetPropsHandler("keyup", isOpen ? handleKeyUp : undefined),
                    ref: ref,
                    role: "combobox"
                }), _this.props.children);
            };
        };
        _this.withPopoverTargetPropsHandler = function(eventType, handler) {
            switch(eventType){
                case "keydown":
                    return function(event) {
                        var _a, _b;
                        handler === null || handler === void 0 || handler(event);
                        (_b = (_a = _this.props.popoverTargetProps) === null || _a === void 0 ? void 0 : _a.onKeyDown) === null || _b === void 0 || _b.call(_a, event);
                    };
                case "keyup":
                    return function(event) {
                        var _a, _b;
                        handler === null || handler === void 0 || handler(event);
                        (_b = (_a = _this.props.popoverTargetProps) === null || _a === void 0 ? void 0 : _a.onKeyUp) === null || _b === void 0 || _b.call(_a, event);
                    };
            }
        };
        /**
         * Target wrapper element "keydown" handler while the popover is closed.
         */ _this.handleTargetKeyDown = function(event) {
            // open popover when arrow key pressed on target while closed
            if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                event.preventDefault();
                _this.setState({
                    isOpen: true
                });
            } else if ((0, _core.Utils).isKeyboardClick(event)) _this.setState({
                isOpen: true
            });
        };
        _this.handleItemSelect = function(item, event) {
            var _a, _b;
            var target = event === null || event === void 0 ? void 0 : event.target;
            var menuItem = target === null || target === void 0 ? void 0 : target.closest(".".concat((0, _core.Classes).MENU_ITEM));
            var menuItemDismiss = menuItem === null || menuItem === void 0 ? void 0 : menuItem.matches(".".concat((0, _core.Classes).POPOVER_DISMISS));
            var shouldDismiss = menuItemDismiss !== null && menuItemDismiss !== void 0 ? menuItemDismiss : true;
            _this.setState({
                isOpen: !shouldDismiss
            });
            (_b = (_a = _this.props).onItemSelect) === null || _b === void 0 || _b.call(_a, item, event);
        };
        _this.handlePopoverInteraction = function(isOpen, event) {
            var _a, _b;
            _this.setState({
                isOpen: isOpen
            });
            (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onInteraction) === null || _b === void 0 || _b.call(_a, isOpen, event);
        };
        _this.handlePopoverOpening = function(node) {
            var _a, _b, _c;
            // save currently focused element before popover steals focus, so we can restore it when closing.
            _this.previousFocusedElement = (_a = (0, _core.Utils).getActiveElement(_this.inputElement)) !== null && _a !== void 0 ? _a : undefined;
            if (_this.props.resetOnClose) _this.resetQuery();
            (_c = (_b = _this.props.popoverProps) === null || _b === void 0 ? void 0 : _b.onOpening) === null || _c === void 0 || _c.call(_b, node);
        };
        _this.handlePopoverOpened = function(node) {
            var _a, _b;
            // scroll active item into view after popover transition completes and all dimensions are stable.
            if (_this.queryList != null) _this.queryList.scrollActiveItemIntoView();
            _this.requestAnimationFrame(function() {
                var _a;
                var _b = _this.props.inputProps, inputProps = _b === void 0 ? {} : _b;
                // autofocus is enabled by default
                if (inputProps.autoFocus !== false) (_a = _this.inputElement) === null || _a === void 0 || _a.focus();
            });
            (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onOpened) === null || _b === void 0 || _b.call(_a, node);
        };
        _this.handlePopoverClosing = function(node) {
            var _a, _b;
            // restore focus to saved element.
            // timeout allows popover to begin closing and remove focus handlers beforehand.
            /* istanbul ignore next */ _this.requestAnimationFrame(function() {
                if (_this.previousFocusedElement !== undefined) {
                    _this.previousFocusedElement.focus();
                    _this.previousFocusedElement = undefined;
                }
            });
            (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onClosing) === null || _b === void 0 || _b.call(_a, node);
        };
        _this.resetQuery = function() {
            return _this.queryList && _this.queryList.setQuery("", true);
        };
        return _this;
    }
    /** @deprecated no longer necessary now that the TypeScript parser supports type arguments on JSX element tags */ Select.ofType = function() {
        return Select;
    };
    Select.prototype.render = function() {
        // omit props specific to this component, spread the rest.
        var _a = this.props, filterable = _a.filterable, inputProps = _a.inputProps, menuProps = _a.menuProps, popoverProps = _a.popoverProps, restProps = (0, _tslib.__rest)(_a, [
            "filterable",
            "inputProps",
            "menuProps",
            "popoverProps"
        ]);
        return _react.createElement((0, _queryList.QueryList), (0, _tslib.__assign)({}, restProps, {
            menuProps: (0, _tslib.__assign)((0, _tslib.__assign)({
                "aria-label": "selectable options"
            }, menuProps), {
                id: this.listboxId
            }),
            onItemSelect: this.handleItemSelect,
            ref: this.handleQueryListRef,
            renderer: this.renderQueryList
        }));
    };
    Select.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b, _c, _d, _e;
        if (((_a = prevProps.inputProps) === null || _a === void 0 ? void 0 : _a.inputRef) !== ((_b = this.props.inputProps) === null || _b === void 0 ? void 0 : _b.inputRef)) {
            (0, _core.setRef)((_c = prevProps.inputProps) === null || _c === void 0 ? void 0 : _c.inputRef, null);
            this.handleInputRef = (0, _core.refHandler)(this, "inputElement", (_d = this.props.inputProps) === null || _d === void 0 ? void 0 : _d.inputRef);
            (0, _core.setRef)((_e = this.props.inputProps) === null || _e === void 0 ? void 0 : _e.inputRef, this.inputElement);
        }
        if (this.state.isOpen && !prevState.isOpen && this.queryList != null) this.queryList.scrollActiveItemIntoView();
    };
    Select.prototype.maybeRenderClearButton = function(query) {
        return query.length > 0 ? _react.createElement((0, _core.Button), {
            "aria-label": "Clear filter query",
            icon: _react.createElement((0, _icons.Cross), null),
            minimal: true,
            onClick: this.resetQuery,
            title: "Clear filter query"
        }) : undefined;
    };
    Select.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".Select");
    return Select;
}((0, _core.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/core":"6Mq52","@blueprintjs/icons":"bO9O5","../../common":"QOOYl","../query-list/queryList":"92Cu9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aMlQj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Suggest", ()=>Suggest);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _core = require("@blueprintjs/core");
var _common = require("../../common");
var _queryList = require("../query-list/queryList");
/**
 * Suggest component.
 *
 * @see https://blueprintjs.com/docs/#select/suggest
 */ var Suggest = /** @class */ function(_super) {
    (0, _tslib.__extends)(Suggest, _super);
    function Suggest() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: _this.props.popoverProps != null && _this.props.popoverProps.isOpen || false,
            selectedItem: _this.getInitialSelectedItem()
        };
        _this.inputElement = null;
        _this.queryList = null;
        _this.handleInputRef = (0, _core.refHandler)(_this, "inputElement", (_a = _this.props.inputProps) === null || _a === void 0 ? void 0 : _a.inputRef);
        _this.handleQueryListRef = function(ref) {
            return _this.queryList = ref;
        };
        _this.listboxId = (0, _core.Utils).uniqueId("listbox");
        _this.renderQueryList = function(listProps) {
            var _a = _this.props, _b = _a.popoverContentProps, popoverContentProps = _b === void 0 ? {} : _b, _c = _a.popoverProps, popoverProps = _c === void 0 ? {} : _c, popoverRef = _a.popoverRef;
            var isOpen = _this.state.isOpen;
            var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
            // N.B. no need to set `popoverProps.fill` since that is unused with the `renderTarget` API
            return _react.createElement((0, _core.Popover), (0, _tslib.__assign)({
                autoFocus: false,
                enforceFocus: false,
                isOpen: isOpen,
                placement: popoverProps.position || popoverProps.placement ? undefined : "bottom-start"
            }, popoverProps, {
                className: (0, _classnamesDefault.default)(listProps.className, popoverProps.className),
                content: _react.createElement("div", (0, _tslib.__assign)({}, popoverContentProps, {
                    onKeyDown: handleKeyDown,
                    onKeyUp: handleKeyUp
                }), listProps.itemList),
                interactionKind: "click",
                onInteraction: _this.handlePopoverInteraction,
                onOpened: _this.handlePopoverOpened,
                onOpening: _this.handlePopoverOpening,
                popoverClassName: (0, _classnamesDefault.default)((0, _common.Classes).SUGGEST_POPOVER, popoverProps.popoverClassName),
                popupKind: (0, _core.PopupKind).LISTBOX,
                ref: popoverRef,
                renderTarget: _this.getPopoverTargetRenderer(listProps, isOpen)
            }));
        };
        // We use the renderTarget API to flatten the rendered DOM and make it easier to implement features like
        // the "fill" prop. Note that we must take `isOpen` as an argument to force this render function to be called
        // again after that state changes.
        _this.getPopoverTargetRenderer = function(listProps, isOpen) {
            // eslint-disable-next-line react/display-name
            return function(_a) {
                var // pull out `isOpen` so that it's not forwarded to the DOM
                _isOpen = _a.isOpen, ref = _a.ref, targetProps = (0, _tslib.__rest)(_a, [
                    "isOpen",
                    "ref"
                ]);
                var _b = _this.props, disabled = _b.disabled, fill = _b.fill, _c = _b.inputProps, inputProps = _c === void 0 ? {} : _c, inputValueRenderer = _b.inputValueRenderer, _d = _b.popoverProps, popoverProps = _d === void 0 ? {} : _d, resetOnClose = _b.resetOnClose;
                var selectedItem = _this.state.selectedItem;
                var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
                var selectedItemText = selectedItem == null ? "" : inputValueRenderer(selectedItem);
                var _e = inputProps.autoComplete, autoComplete = _e === void 0 ? "off" : _e, _f = inputProps.placeholder, placeholder = _f === void 0 ? "Search..." : _f;
                // placeholder shows selected item while open.
                var inputPlaceholder = isOpen && selectedItemText ? selectedItemText : placeholder;
                // value shows query when open, and query remains when closed if nothing is selected.
                // if resetOnClose is enabled, then hide query when not open. (see handlePopoverOpening)
                var inputValue = isOpen ? listProps.query : selectedItemText === "" ? resetOnClose ? "" : listProps.query : selectedItemText;
                return _react.createElement((0, _core.InputGroup), (0, _tslib.__assign)({
                    "aria-controls": _this.listboxId,
                    autoComplete: autoComplete,
                    disabled: disabled,
                    tagName: popoverProps.targetTagName
                }, targetProps, inputProps, {
                    "aria-autocomplete": "list",
                    "aria-expanded": isOpen,
                    className: (0, _classnamesDefault.default)(targetProps.className, inputProps.className),
                    fill: fill,
                    inputRef: (0, _core.mergeRefs)(_this.handleInputRef, ref),
                    onChange: listProps.handleQueryChange,
                    onFocus: _this.handleInputFocus,
                    onKeyDown: _this.getTargetKeyDownHandler(handleKeyDown),
                    onKeyUp: _this.getTargetKeyUpHandler(handleKeyUp),
                    placeholder: inputPlaceholder,
                    role: "combobox",
                    value: inputValue
                }));
            };
        };
        _this.selectText = function() {
            // wait until the input is properly focused to select the text inside of it
            _this.requestAnimationFrame(function() {
                var _a;
                (_a = _this.inputElement) === null || _a === void 0 || _a.setSelectionRange(0, _this.inputElement.value.length);
            });
        };
        _this.handleInputFocus = function(event) {
            var _a, _b;
            _this.selectText();
            // TODO can we leverage Popover.openOnTargetFocus for this?
            if (!_this.props.openOnKeyDown) _this.setState({
                isOpen: true
            });
            (_b = (_a = _this.props.inputProps) === null || _a === void 0 ? void 0 : _a.onFocus) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.handleItemSelect = function(item, event) {
            var _a, _b, _c, _d;
            var nextOpenState;
            if (!_this.props.closeOnSelect) {
                (_a = _this.inputElement) === null || _a === void 0 || _a.focus();
                _this.selectText();
                nextOpenState = true;
            } else {
                (_b = _this.inputElement) === null || _b === void 0 || _b.blur();
                nextOpenState = false;
            }
            // the internal state should only change when uncontrolled.
            if (_this.props.selectedItem === undefined) _this.setState({
                isOpen: nextOpenState,
                selectedItem: item
            });
            else // otherwise just set the next open state.
            _this.setState({
                isOpen: nextOpenState
            });
            (_d = (_c = _this.props).onItemSelect) === null || _d === void 0 || _d.call(_c, item, event);
        };
        // Popover interaction kind is CLICK, so this only handles click events.
        // Note that we defer to the next animation frame in order to get the latest activeElement
        _this.handlePopoverInteraction = function(nextOpenState, event) {
            return _this.requestAnimationFrame(function() {
                var _a, _b;
                var isInputFocused = _this.inputElement === (0, _core.Utils).getActiveElement(_this.inputElement);
                if (_this.inputElement != null && !isInputFocused) // the input is no longer focused, we should close the popover
                _this.setState({
                    isOpen: false
                });
                (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onInteraction) === null || _b === void 0 || _b.call(_a, nextOpenState, event);
            });
        };
        _this.handlePopoverOpening = function(node) {
            var _a, _b;
            // reset query before opening instead of when closing to prevent flash of unfiltered items.
            // this is a limitation of the interactions between QueryList state and Popover transitions.
            if (_this.props.resetOnClose && _this.queryList) _this.queryList.setQuery("", true);
            (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onOpening) === null || _b === void 0 || _b.call(_a, node);
        };
        _this.handlePopoverOpened = function(node) {
            var _a, _b;
            // scroll active item into view after popover transition completes and all dimensions are stable.
            if (_this.queryList != null) _this.queryList.scrollActiveItemIntoView();
            (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onOpened) === null || _b === void 0 || _b.call(_a, node);
        };
        _this.getTargetKeyDownHandler = function(handleQueryListKeyDown) {
            return function(e) {
                var _a, _b, _c;
                if (e.key === "Escape" || e.key === "Tab") {
                    // By default the escape key will not trigger a blur on the
                    // input element. It must be done explicitly.
                    if (e.key === "Escape") (_a = _this.inputElement) === null || _a === void 0 || _a.blur();
                    _this.setState({
                        isOpen: false
                    });
                } else if (_this.props.openOnKeyDown && e.key !== "Backspace" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") _this.setState({
                    isOpen: true
                });
                if (_this.state.isOpen) handleQueryListKeyDown === null || handleQueryListKeyDown === void 0 || handleQueryListKeyDown(e);
                (_c = (_b = _this.props.inputProps) === null || _b === void 0 ? void 0 : _b.onKeyDown) === null || _c === void 0 || _c.call(_b, e);
            };
        };
        _this.getTargetKeyUpHandler = function(handleQueryListKeyUp) {
            return function(evt) {
                var _a, _b;
                if (_this.state.isOpen) handleQueryListKeyUp === null || handleQueryListKeyUp === void 0 || handleQueryListKeyUp(evt);
                (_b = (_a = _this.props.inputProps) === null || _a === void 0 ? void 0 : _a.onKeyUp) === null || _b === void 0 || _b.call(_a, evt);
            };
        };
        return _this;
    }
    /** @deprecated no longer necessary now that the TypeScript parser supports type arguments on JSX element tags */ Suggest.ofType = function() {
        return Suggest;
    };
    Suggest.prototype.render = function() {
        var _a;
        // omit props specific to this component, spread the rest.
        var _b = this.props, disabled = _b.disabled, inputProps = _b.inputProps, menuProps = _b.menuProps, popoverProps = _b.popoverProps, restProps = (0, _tslib.__rest)(_b, [
            "disabled",
            "inputProps",
            "menuProps",
            "popoverProps"
        ]);
        return _react.createElement((0, _queryList.QueryList), (0, _tslib.__assign)({}, restProps, {
            menuProps: (0, _tslib.__assign)((0, _tslib.__assign)({
                "aria-label": "selectable options"
            }, menuProps), {
                id: this.listboxId
            }),
            initialActiveItem: (_a = this.props.selectedItem) !== null && _a !== void 0 ? _a : undefined,
            onItemSelect: this.handleItemSelect,
            ref: this.handleQueryListRef,
            renderer: this.renderQueryList
        }));
    };
    Suggest.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        if (((_a = prevProps.inputProps) === null || _a === void 0 ? void 0 : _a.inputRef) !== ((_b = this.props.inputProps) === null || _b === void 0 ? void 0 : _b.inputRef)) {
            (0, _core.setRef)((_c = prevProps.inputProps) === null || _c === void 0 ? void 0 : _c.inputRef, null);
            this.handleInputRef = (0, _core.refHandler)(this, "inputElement", (_d = this.props.inputProps) === null || _d === void 0 ? void 0 : _d.inputRef);
            (0, _core.setRef)((_e = this.props.inputProps) === null || _e === void 0 ? void 0 : _e.inputRef, this.inputElement);
        }
        // If the selected item prop changes, update the underlying state.
        if (this.props.selectedItem !== undefined && this.props.selectedItem !== this.state.selectedItem) this.setState({
            selectedItem: this.props.selectedItem
        });
        if (this.state.isOpen === false && prevState.isOpen === true) {
            // just closed, likely by keyboard interaction
            // wait until the transition ends so there isn't a flash of content in the popover
            var timeout = (_g = (_f = this.props.popoverProps) === null || _f === void 0 ? void 0 : _f.transitionDuration) !== null && _g !== void 0 ? _g : (0, _core.Popover).defaultProps.transitionDuration;
            setTimeout(function() {
                return _this.maybeResetActiveItemToSelectedItem();
            }, timeout);
        }
        if (this.state.isOpen && !prevState.isOpen && this.queryList != null) this.queryList.scrollActiveItemIntoView();
    };
    Suggest.prototype.getInitialSelectedItem = function() {
        // controlled > uncontrolled > default
        if (this.props.selectedItem !== undefined) return this.props.selectedItem;
        else if (this.props.defaultSelectedItem !== undefined) return this.props.defaultSelectedItem;
        else return null;
    };
    Suggest.prototype.maybeResetActiveItemToSelectedItem = function() {
        var _a;
        var shouldResetActiveItemToSelectedItem = this.props.activeItem === undefined && this.state.selectedItem !== null && !this.props.resetOnSelect;
        if (this.queryList !== null && shouldResetActiveItemToSelectedItem) this.queryList.setActiveItem((_a = this.props.selectedItem) !== null && _a !== void 0 ? _a : this.state.selectedItem);
    };
    Suggest.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".Suggest");
    Suggest.defaultProps = {
        closeOnSelect: true,
        fill: false,
        openOnKeyDown: false,
        resetOnClose: false
    };
    return Suggest;
}((0, _core.AbstractPureComponent));

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/core":"6Mq52","../../common":"QOOYl","../query-list/queryList":"92Cu9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dstkC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactDayPickerClasses", ()=>ReactDayPickerClasses);
parcelHelpers.export(exports, "DatePicker3CaptionClasses", ()=>DatePicker3CaptionClasses);
parcelHelpers.export(exports, "DatePicker3Classes", ()=>DatePicker3Classes);
parcelHelpers.export(exports, "DateRangePicker3Classes", ()=>DateRangePicker3Classes);
parcelHelpers.export(exports, "Classes", ()=>Classes);
parcelHelpers.export(exports, "dayPickerClassNameOverrides", ()=>dayPickerClassNameOverrides);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _core = require("@blueprintjs/core");
var _datetime = require("@blueprintjs/datetime");
var RDP = "rdp";
var RDP_DAY = "".concat(RDP, "-day");
var ReactDayPickerClasses = {
    RDP: RDP,
    RDP_CAPTION: "".concat(RDP, "-caption"),
    RDP_CAPTION_DROPDOWNS: "".concat(RDP, "-caption_dropdowns"),
    RDP_CAPTION_LABEL: "".concat(RDP, "-caption_label"),
    RDP_DAY: RDP_DAY,
    RDP_DAY_DISABLED: "".concat(RDP_DAY, "_disabled"),
    RDP_DAY_HOVERED_RANGE: "".concat(RDP_DAY, "_hovered"),
    RDP_DAY_HOVERED_RANGE_END: "".concat(RDP_DAY, "_hovered_end"),
    RDP_DAY_HOVERED_RANGE_START: "".concat(RDP_DAY, "_hovered_start"),
    RDP_DAY_OUTSIDE: "".concat(RDP_DAY, "_outside"),
    RDP_DAY_RANGE_END: "".concat(RDP_DAY, "_range_end"),
    RDP_DAY_RANGE_MIDDLE: "".concat(RDP_DAY, "_range_middle"),
    RDP_DAY_RANGE_START: "".concat(RDP_DAY, "_range_start"),
    RDP_DAY_SELECTED: "".concat(RDP_DAY, "_selected"),
    RDP_DAY_TODAY: "".concat(RDP_DAY, "_today"),
    RDP_MONTH: "".concat(RDP, "-month"),
    RDP_NAV: "".concat(RDP, "-nav"),
    RDP_TABLE: "".concat(RDP, "-table"),
    RDP_VHIDDEN: "".concat(RDP, "-vhidden")
};
var DatePicker3CaptionClasses = {
    DATEPICKER3_CAPTION: (0, _datetime.Classes).DATEPICKER_CAPTION,
    DATEPICKER3_DROPDOWN_MONTH: (0, _datetime.Classes).DATEPICKER_MONTH_SELECT,
    DATEPICKER3_DROPDOWN_YEAR: (0, _datetime.Classes).DATEPICKER_YEAR_SELECT,
    DATEPICKER3_NAV_BUTTON: "".concat((0, _datetime.Classes).DATEPICKER, "-nav-button"),
    DATEPICKER3_NAV_BUTTON_NEXT: "".concat((0, _datetime.Classes).DATEPICKER, "-nav-button-next"),
    DATEPICKER3_NAV_BUTTON_PREVIOUS: "".concat((0, _datetime.Classes).DATEPICKER, "-nav-button-previous")
};
var DatePicker3Classes = {
    DATEPICKER3_DAY: RDP_DAY,
    DATEPICKER3_DAY_DISABLED: ReactDayPickerClasses.RDP_DAY_DISABLED,
    DATEPICKER3_DAY_IS_TODAY: ReactDayPickerClasses.RDP_DAY_TODAY,
    DATEPICKER3_DAY_OUTSIDE: ReactDayPickerClasses.RDP_DAY_OUTSIDE,
    DATEPICKER3_DAY_SELECTED: ReactDayPickerClasses.RDP_DAY_SELECTED,
    DATEPICKER3_HIGHLIGHT_CURRENT_DAY: "".concat((0, _datetime.Classes).DATEPICKER, "-highlight-current-day"),
    DATEPICKER3_REVERSE_MONTH_AND_YEAR: "".concat((0, _datetime.Classes).DATEPICKER, "-reverse-month-and-year")
};
var DateRangePicker3Classes = {
    DATERANGEPICKER3_HOVERED_RANGE: ReactDayPickerClasses.RDP_DAY_HOVERED_RANGE,
    DATERANGEPICKER3_HOVERED_RANGE_END: ReactDayPickerClasses.RDP_DAY_HOVERED_RANGE_END,
    DATERANGEPICKER3_HOVERED_RANGE_START: ReactDayPickerClasses.RDP_DAY_HOVERED_RANGE_START,
    DATERANGEPICKER3_REVERSE_MONTH_AND_YEAR: "".concat((0, _datetime.Classes).DATERANGEPICKER, "-reverse-month-and-year"),
    DATERANGEPICKER3_SELECTED_RANGE_END: ReactDayPickerClasses.RDP_DAY_RANGE_END,
    DATERANGEPICKER3_SELECTED_RANGE_MIDDLE: ReactDayPickerClasses.RDP_DAY_RANGE_MIDDLE,
    DATERANGEPICKER3_SELECTED_RANGE_START: ReactDayPickerClasses.RDP_DAY_RANGE_START,
    DATERANGEPICKER3_TIMEPICKERS_STACKED: "".concat((0, _datetime.Classes).DATERANGEPICKER_TIMEPICKERS, "-stacked")
};
var Classes = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _datetime.Classes)), DatePicker3CaptionClasses), DatePicker3Classes), DateRangePicker3Classes);
var dayPickerClassNameOverrides = {
    /* eslint-disable camelcase */ button: (0, _classnamesDefault.default)((0, _core.Classes).BUTTON, (0, _core.Classes).MINIMAL),
    // no need for button "reset" styles since the core Button styles handle that for us
    button_reset: undefined,
    dropdown_month: DatePicker3CaptionClasses.DATEPICKER3_DROPDOWN_MONTH,
    dropdown_year: DatePicker3CaptionClasses.DATEPICKER3_DROPDOWN_YEAR,
    nav_button: DatePicker3CaptionClasses.DATEPICKER3_NAV_BUTTON,
    nav_button_next: DatePicker3CaptionClasses.DATEPICKER3_NAV_BUTTON_NEXT,
    nav_button_previous: DatePicker3CaptionClasses.DATEPICKER3_NAV_BUTTON_PREVIOUS
};

},{"tslib":"b4wpY","classnames":"5Een2","@blueprintjs/core":"6Mq52","@blueprintjs/datetime":"g4aa7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fhuxV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateFnsLocalizedComponent", ()=>DateFnsLocalizedComponent);
var _tslib = require("tslib");
var _core = require("@blueprintjs/core");
var _dateFnsLocaleUtils = require("../common/dateFnsLocaleUtils");
/**
 * Abstract component which accepts a date-fns locale prop and loads the corresponding `Locale` object as necessary.
 *
 * Currently used by DatePicker3, DateRangePicker3, and DateRangeInput3, but we would ideally migrate to the
 * `useDateFnsLocale()` hook once those components are refactored into functional components.
 */ var DateFnsLocalizedComponent = /** @class */ function(_super) {
    (0, _tslib.__extends)(DateFnsLocalizedComponent, _super);
    function DateFnsLocalizedComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Keeping track of `isMounted` state is generally considered an anti-pattern, but since there is no way to
        // cancel/abort dyanmic ES module `import()` calls to load the date-fns locale, this is the best way to avoid
        // setting state on an unmounted component, which creates noise in the console (especially while running tests).
        // N.B. this cannot be named `isMounted` because that conflicts with a React internal property.
        _this.isComponentMounted = false;
        return _this;
    }
    // HACKHACK: type fix for setState which does not accept partial state objects in our version of
    // @types/react (v16.14.x)
    DateFnsLocalizedComponent.prototype.setState = function(nextStateOrAction, callback) {
        if (typeof nextStateOrAction === "function") _super.prototype.setState.call(this, nextStateOrAction, callback);
        else _super.prototype.setState.call(this, nextStateOrAction);
    };
    DateFnsLocalizedComponent.prototype.componentDidMount = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.isComponentMounted = true;
                        return [
                            4 /*yield*/ ,
                            this.loadLocale(this.props.locale)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DateFnsLocalizedComponent.prototype.componentDidUpdate = function(prevProps) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.props.locale !== prevProps.locale)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.loadLocale(this.props.locale)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DateFnsLocalizedComponent.prototype.componentWillUnmount = function() {
        this.isComponentMounted = false;
    };
    DateFnsLocalizedComponent.prototype.loadLocale = function(localeOrCode) {
        var _a, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var loader, locale;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (localeOrCode === undefined) return [
                            2 /*return*/ 
                        ];
                        else if (((_a = this.state.locale) === null || _a === void 0 ? void 0 : _a.code) === localeOrCode) return [
                            2 /*return*/ 
                        ];
                        if (!(typeof localeOrCode === "string")) return [
                            3 /*break*/ ,
                            2
                        ];
                        loader = (_b = this.props.dateFnsLocaleLoader) !== null && _b !== void 0 ? _b : (0, _dateFnsLocaleUtils.loadDateFnsLocale);
                        return [
                            4 /*yield*/ ,
                            loader(localeOrCode)
                        ];
                    case 1:
                        locale = _c.sent();
                        if (this.isComponentMounted) this.setState({
                            locale: locale
                        });
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        this.setState({
                            locale: localeOrCode
                        });
                        _c.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return DateFnsLocalizedComponent;
}((0, _core.AbstractPureComponent));

},{"tslib":"b4wpY","@blueprintjs/core":"6Mq52","../common/dateFnsLocaleUtils":"dsU4P","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dsU4P":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Lazy-loads a date-fns locale for use in a datetime class component.
 */ parcelHelpers.export(exports, "loadDateFnsLocale", ()=>loadDateFnsLocale);
/**
 * Lazy-loads a date-fns locale for use in a datetime function component.
 */ parcelHelpers.export(exports, "useDateFnsLocale", ()=>useDateFnsLocale);
var _tslib = require("tslib");
var _react = require("react");
var _core = require("@blueprintjs/core");
function loadDateFnsLocale(localeCode) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var localeModule, _a;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        require(/* webpackChunkName: "date-fns-locale-[request]" */ "date-fns/locale/".concat(localeCode, "/index.js"))
                    ];
                case 1:
                    localeModule = _b.sent();
                    return [
                        2 /*return*/ ,
                        localeModule.default
                    ];
                case 2:
                    _a = _b.sent();
                    if (!(0, _core.Utils).isNodeEnv("production")) console.error("[Blueprint] Could not load \"".concat(localeCode, "\" date-fns locale, please check that this locale code is supported: https://github.com/date-fns/date-fns/tree/main/src/locale"));
                    return [
                        2 /*return*/ ,
                        undefined
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function useDateFnsLocale(localeOrCode, dateFnsLocaleLoader) {
    if (dateFnsLocaleLoader === void 0) dateFnsLocaleLoader = loadDateFnsLocale;
    // make sure to set the locale correctly on first render if it is available
    var _a = _react.useState(typeof localeOrCode === "object" ? localeOrCode : undefined), locale = _a[0], setLocale = _a[1];
    _react.useEffect(function() {
        setLocale(function(prevLocale) {
            if (typeof localeOrCode === "string") {
                dateFnsLocaleLoader(localeOrCode).then(setLocale);
                // keep the current locale for now, it will be updated async
                return prevLocale;
            } else return localeOrCode;
        });
    }, [
        dateFnsLocaleLoader,
        localeOrCode
    ]);
    return locale;
}

},{"tslib":"b4wpY","react":"9njXz","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bUQ9c":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Custom react-day-picker dropdown component which implements Blueprint's datepicker design
 * for month and year dropdowns.
 *
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "DatePicker3Dropdown", ()=>DatePicker3Dropdown);
var _tslib = require("tslib");
var _react = require("react");
var _core = require("@blueprintjs/core");
var _useMonthSelectRightOffset = require("../../common/useMonthSelectRightOffset");
function DatePicker3Dropdown(_a) {
    var caption = _a.caption, children = _a.children, props = (0, _tslib.__rest)(_a, [
        "caption",
        "children"
    ]);
    var containerElement = _react.useRef(null);
    var selectElement = _react.useRef(null);
    // Use a custom hook to adjust the position of the position of the HTMLSelect icon to appear right next to
    // the month name. N.B. we expect props.caption to be a simple string representing the month name.
    var displayedMonthText = typeof caption === "string" ? caption : "";
    var monthSelectRightOffset = (0, _useMonthSelectRightOffset.useMonthSelectRightOffset)(selectElement, containerElement, displayedMonthText);
    var iconProps = _react.useMemo(function() {
        return props.name === "months" ? {
            style: {
                right: monthSelectRightOffset
            }
        } : {};
    }, [
        props.name,
        monthSelectRightOffset
    ]);
    return _react.createElement("div", {
        ref: containerElement
    }, _react.createElement((0, _core.HTMLSelect), (0, _tslib.__assign)({
        iconProps: iconProps,
        minimal: true,
        ref: selectElement
    }, props), children));
}

},{"tslib":"b4wpY","react":"9njXz","@blueprintjs/core":"6Mq52","../../common/useMonthSelectRightOffset":"2n9XY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2n9XY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMonthSelectRightOffset", ()=>useMonthSelectRightOffset);
var _react = require("react");
var _datetime = require("@blueprintjs/datetime");
var _icons = require("@blueprintjs/icons");
function useMonthSelectRightOffset(monthSelectElement, containerElement, displayedMonthText) {
    var _a = _react.useState(0), monthRightOffset = _a[0], setMonthRightOffset = _a[1];
    _react.useLayoutEffect(function() {
        var _a, _b;
        if (containerElement.current == null) return;
        // measure width of text as rendered inside our container element.
        var monthTextWidth = (0, _datetime.DatePickerUtils).measureTextWidth(displayedMonthText, (0, _datetime.Classes).DATEPICKER_CAPTION_MEASURE, containerElement.current);
        var monthSelectWidth = (_b = (_a = monthSelectElement.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
        var rightOffset = Math.max(2, monthSelectWidth - monthTextWidth - (0, _icons.IconSize).STANDARD - 2);
        setMonthRightOffset(rightOffset);
    }, [
        containerElement,
        displayedMonthText,
        monthSelectElement
    ]);
    return monthRightOffset;
}

},{"react":"9njXz","@blueprintjs/datetime":"g4aa7","@blueprintjs/icons":"bO9O5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"62ZgP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconLeft", ()=>IconLeft);
parcelHelpers.export(exports, "IconRight", ()=>IconRight);
var _tslib = require("tslib");
var _react = require("react");
var _icons = require("@blueprintjs/icons");
function IconLeft(_a) {
    var children = _a.children, props = (0, _tslib.__rest)(_a, [
        "children"
    ]);
    return _react.createElement((0, _icons.ChevronLeft), (0, _tslib.__assign)({}, props));
}
function IconRight(_a) {
    var children = _a.children, props = (0, _tslib.__rest)(_a, [
        "children"
    ]);
    return _react.createElement((0, _icons.ChevronRight), (0, _tslib.__assign)({}, props));
}

},{"tslib":"b4wpY","react":"9njXz","@blueprintjs/icons":"bO9O5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8j1DF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker3Context", ()=>DatePicker3Context);
parcelHelpers.export(exports, "DatePicker3Provider", ()=>DatePicker3Provider);
var _react = require("react");
var DatePicker3Context = _react.createContext({
    locale: undefined
});
var DatePicker3Provider = function(props) {
    return _react.createElement(DatePicker3Context.Provider, {
        value: props
    }, props.children);
};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cfYu9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateInput3", ()=>DateInput3);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _core = require("@blueprintjs/core");
var _datetime = require("@blueprintjs/datetime");
var _classes = require("../../classes");
var _dateFnsFormatUtils = require("../../common/dateFnsFormatUtils");
var _dateFnsLocaleUtils = require("../../common/dateFnsLocaleUtils");
var _datePicker3 = require("../date-picker3/datePicker3");
var _useDateFormatter = require("./useDateFormatter");
var _useDateParser = require("./useDateParser");
var timezoneSelectButtonProps = {
    fill: false,
    minimal: true,
    outlined: true
};
var defaultProps = {
    closeOnSelection: true,
    disabled: false,
    invalidDateMessage: "Invalid date",
    locale: "en-US",
    maxDate: (0, _datetime.DatePickerUtils).getDefaultMaxDate(),
    minDate: (0, _datetime.DatePickerUtils).getDefaultMinDate(),
    outOfRangeMessage: "Out of range",
    reverseMonthAndYearMenus: false
};
var DateInput3 = _react.memo(function _DateInput(props) {
    var _a = props, closeOnSelection = _a.closeOnSelection, dateFnsFormat = _a.dateFnsFormat, dateFnsLocaleLoader = _a.dateFnsLocaleLoader, defaultTimezone = _a.defaultTimezone, defaultValue = _a.defaultValue, disabled = _a.disabled, disableTimezoneSelect = _a.disableTimezoneSelect, fill = _a.fill, _b = _a.inputProps, inputProps = _b === void 0 ? {} : _b, invalidDateMessage = _a.invalidDateMessage, localeOrCode = _a.locale, maxDate = _a.maxDate, minDate = _a.minDate, onChange = _a.onChange, onError = _a.onError, onTimezoneChange = _a.onTimezoneChange, outOfRangeMessage = _a.outOfRangeMessage, _c = _a.popoverProps, popoverProps = _c === void 0 ? {} : _c, popoverRef = _a.popoverRef, rightElement = _a.rightElement, showTimezoneSelect = _a.showTimezoneSelect, timePrecision = _a.timePrecision, controlledTimezone = _a.timezone, value = _a.value, datePickerProps = (0, _tslib.__rest)(_a, [
        "closeOnSelection",
        "dateFnsFormat",
        "dateFnsLocaleLoader",
        "defaultTimezone",
        "defaultValue",
        "disabled",
        "disableTimezoneSelect",
        "fill",
        "inputProps",
        "invalidDateMessage",
        "locale",
        "maxDate",
        "minDate",
        "onChange",
        "onError",
        "onTimezoneChange",
        "outOfRangeMessage",
        "popoverProps",
        "popoverRef",
        "rightElement",
        "showTimezoneSelect",
        "timePrecision",
        "timezone",
        "value"
    ]);
    var locale = (0, _dateFnsLocaleUtils.useDateFnsLocale)(localeOrCode, dateFnsLocaleLoader);
    var placeholder = getPlaceholder(props);
    var formatDateString = (0, _useDateFormatter.useDateFormatter)(props, locale);
    var parseDateString = (0, _useDateParser.useDateParser)(props, locale);
    // Refs
    // ------------------------------------------------------------------------
    var inputRef = _react.useRef(null);
    var popoverContentRef = _react.useRef(null);
    var popoverId = (0, _core.Utils).uniqueId("date-picker");
    // State
    // ------------------------------------------------------------------------
    var _d = _react.useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = _react.useState(getInitialTimezoneValue(props)), timezoneValue = _e[0], setTimezoneValue = _e[1];
    var valueFromProps = _react.useMemo(function() {
        return (0, _datetime.TimezoneUtils).getDateObjectFromIsoString(value, timezoneValue);
    }, [
        timezoneValue,
        value
    ]);
    var isControlled = valueFromProps !== undefined;
    var defaultValueFromProps = _react.useMemo(function() {
        return (0, _datetime.TimezoneUtils).getDateObjectFromIsoString(defaultValue, timezoneValue);
    }, [
        defaultValue,
        timezoneValue
    ]);
    var _f = _react.useState(isControlled ? valueFromProps : defaultValueFromProps), valueAsDate = _f[0], setValue = _f[1];
    var _g = _react.useState(undefined), selectedShortcutIndex = _g[0], setSelectedShortcutIndex = _g[1];
    var _h = _react.useState(false), isInputFocused = _h[0], setIsInputFocused = _h[1];
    // rendered as the text input's value
    var formattedDateString = _react.useMemo(function() {
        return valueAsDate === null ? undefined : formatDateString(valueAsDate);
    }, [
        valueAsDate,
        formatDateString
    ]);
    var _j = _react.useState(formattedDateString !== null && formattedDateString !== void 0 ? formattedDateString : undefined), inputValue = _j[0], setInputValue = _j[1];
    var isErrorState = valueAsDate != null && (!(0, _datetime.DateUtils).isDateValid(valueAsDate) || !(0, _datetime.DateUtils).isDayInRange(valueAsDate, [
        minDate,
        maxDate
    ]));
    // Effects
    // ------------------------------------------------------------------------
    _react.useEffect(function() {
        if (isControlled) setValue(valueFromProps);
    }, [
        isControlled,
        valueFromProps
    ]);
    _react.useEffect(function() {
        // uncontrolled mode, updating initial timezone value
        if (defaultTimezone !== undefined && (0, _datetime.TimezoneNameUtils).isValidTimezone(defaultTimezone)) setTimezoneValue(defaultTimezone);
    }, [
        defaultTimezone
    ]);
    _react.useEffect(function() {
        // controlled mode, updating timezone value
        if (controlledTimezone !== undefined && (0, _datetime.TimezoneNameUtils).isValidTimezone(controlledTimezone)) setTimezoneValue(controlledTimezone);
    }, [
        controlledTimezone
    ]);
    _react.useEffect(function() {
        if (isControlled && !isInputFocused) setInputValue(formattedDateString);
    }, [
        isControlled,
        isInputFocused,
        formattedDateString
    ]);
    // Popover contents (date picker)
    // ------------------------------------------------------------------------
    var handlePopoverClose = _react.useCallback(function(e) {
        var _a;
        (_a = popoverProps.onClose) === null || _a === void 0 || _a.call(popoverProps, e);
        setIsOpen(false);
    }, [
        popoverProps
    ]);
    var handleDateChange = _react.useCallback(function(newDate, isUserChange, didSubmitWithEnter) {
        if (didSubmitWithEnter === void 0) didSubmitWithEnter = false;
        var prevDate = valueAsDate;
        if (newDate === null) {
            if (!isControlled && !didSubmitWithEnter) // user clicked on current day in the calendar, so we should clear the input when uncontrolled
            setInputValue("");
            onChange === null || onChange === void 0 || onChange(null, isUserChange);
            return;
        }
        // this change handler was triggered by a change in month, day, or (if
        // enabled) time. for UX purposes, we want to close the popover only if
        // the user explicitly clicked a day within the current month.
        var newIsOpen = !isUserChange || !closeOnSelection || prevDate != null && ((0, _datetime.DateUtils).hasMonthChanged(prevDate, newDate) || timePrecision !== undefined && (0, _datetime.DateUtils).hasTimeChanged(prevDate, newDate));
        // if selecting a date via click or Tab, the input will already be
        // blurred by now, so sync isInputFocused to false. if selecting via
        // Enter, setting isInputFocused to false won't do anything by itself,
        // plus we want the field to retain focus anyway.
        // (note: spelling out the ternary explicitly reads more clearly.)
        var newIsInputFocused = didSubmitWithEnter ? true : false;
        if (isControlled) {
            setIsInputFocused(newIsInputFocused);
            setIsOpen(newIsOpen);
        } else {
            var newFormattedDateString = formatDateString(newDate);
            setIsInputFocused(newIsInputFocused);
            setIsOpen(newIsOpen);
            setValue(newDate);
            setInputValue(newFormattedDateString);
        }
        var newIsoDateString = (0, _datetime.TimezoneUtils).getIsoEquivalentWithUpdatedTimezone(newDate, timezoneValue, timePrecision);
        onChange === null || onChange === void 0 || onChange(newIsoDateString, isUserChange);
    }, [
        closeOnSelection,
        isControlled,
        formatDateString,
        onChange,
        timezoneValue,
        timePrecision,
        valueAsDate
    ]);
    var dayPickerProps = (0, _tslib.__assign)((0, _tslib.__assign)({}, props.dayPickerProps), {
        onDayKeyDown: function(day, modifiers, e) {
            var _a, _b;
            (_b = (_a = props.dayPickerProps) === null || _a === void 0 ? void 0 : _a.onDayKeyDown) === null || _b === void 0 || _b.call(_a, day, modifiers, e);
        },
        onMonthChange: function(month) {
            var _a, _b;
            (_b = (_a = props.dayPickerProps) === null || _a === void 0 ? void 0 : _a.onMonthChange) === null || _b === void 0 || _b.call(_a, month);
        }
    });
    var handleShortcutChange = _react.useCallback(function(_, index) {
        setSelectedShortcutIndex(index);
    }, []);
    var handleStartFocusBoundaryFocusIn = _react.useCallback(function(e) {
        var _a, _b, _c;
        if ((_a = popoverContentRef.current) === null || _a === void 0 ? void 0 : _a.contains(getRelatedTargetWithFallback(e))) // Not closing Popover to allow user to freely switch between manually entering a date
        // string in the input and selecting one via the Popover
        (_b = inputRef.current) === null || _b === void 0 || _b.focus();
        else (_c = getKeyboardFocusableElements(popoverContentRef).shift()) === null || _c === void 0 || _c.focus();
    }, []);
    var handleEndFocusBoundaryFocusIn = _react.useCallback(function(e) {
        var _a, _b, _c;
        if ((_a = popoverContentRef.current) === null || _a === void 0 ? void 0 : _a.contains(getRelatedTargetWithFallback(e))) {
            (_b = inputRef.current) === null || _b === void 0 || _b.focus();
            handlePopoverClose(e);
        } else (_c = getKeyboardFocusableElements(popoverContentRef).pop()) === null || _c === void 0 || _c.focus();
    }, [
        handlePopoverClose
    ]);
    // React's onFocus prop listens to the focusin browser event under the hood, so it's safe to
    // provide it the focusIn event handlers instead of using a ref and manually adding the
    // event listeners ourselves.
    var popoverContent = _react.createElement("div", {
        ref: popoverContentRef,
        role: "dialog",
        "aria-label": "date picker",
        id: popoverId
    }, _react.createElement("div", {
        onFocus: handleStartFocusBoundaryFocusIn,
        tabIndex: 0
    }), _react.createElement((0, _datePicker3.DatePicker3), (0, _tslib.__assign)({}, datePickerProps, {
        dateFnsLocaleLoader: dateFnsLocaleLoader,
        dayPickerProps: dayPickerProps,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        onChange: handleDateChange,
        onShortcutChange: handleShortcutChange,
        selectedShortcutIndex: selectedShortcutIndex,
        timePrecision: timePrecision,
        timezone: timezoneValue,
        // the rest of this component handles invalid dates gracefully (to show error messages),
        // but DatePicker does not, so we must take care to filter those out
        value: isErrorState ? null : valueAsDate
    })), _react.createElement("div", {
        onFocus: handleEndFocusBoundaryFocusIn,
        tabIndex: 0
    }));
    // Timezone select
    // ------------------------------------------------------------------------
    // we need a date which is guaranteed to be non-null here; if necessary,
    // we use today's date and shift it to the desired/current timezone
    var tzSelectDate = _react.useMemo(function() {
        return valueAsDate != null && (0, _datetime.DateUtils).isDateValid(valueAsDate) ? valueAsDate : (0, _datetime.TimezoneUtils).convertLocalDateToTimezoneTime(new Date(), timezoneValue);
    }, [
        timezoneValue,
        valueAsDate
    ]);
    var isTimezoneSelectHidden = timePrecision === undefined || showTimezoneSelect === false;
    var isTimezoneSelectDisabled = disabled || disableTimezoneSelect;
    var handleTimezoneChange = _react.useCallback(function(newTimezone) {
        if (controlledTimezone === undefined) // uncontrolled timezone
        setTimezoneValue(newTimezone);
        onTimezoneChange === null || onTimezoneChange === void 0 || onTimezoneChange(newTimezone);
        if (valueAsDate != null) {
            var newDateString = (0, _datetime.TimezoneUtils).getIsoEquivalentWithUpdatedTimezone(valueAsDate, newTimezone, timePrecision);
            onChange === null || onChange === void 0 || onChange(newDateString, true);
        }
    }, [
        onChange,
        onTimezoneChange,
        valueAsDate,
        timePrecision,
        controlledTimezone
    ]);
    var maybeTimezonePicker = _react.useMemo(function() {
        return isTimezoneSelectHidden ? undefined : _react.createElement((0, _datetime.TimezoneSelect), {
            buttonProps: timezoneSelectButtonProps,
            className: (0, _classes.Classes).DATE_INPUT_TIMEZONE_SELECT,
            date: tzSelectDate,
            disabled: isTimezoneSelectDisabled,
            onChange: handleTimezoneChange,
            value: timezoneValue
        }, _react.createElement((0, _core.Tag), {
            interactive: !isTimezoneSelectDisabled,
            minimal: true,
            rightIcon: isTimezoneSelectDisabled ? undefined : "caret-down"
        }, (0, _datetime.TimezoneNameUtils).getTimezoneShortName(timezoneValue, tzSelectDate)));
    }, [
        handleTimezoneChange,
        isTimezoneSelectDisabled,
        isTimezoneSelectHidden,
        timezoneValue,
        tzSelectDate
    ]);
    // Text input
    // ------------------------------------------------------------------------
    var handleInputFocus = _react.useCallback(function(e) {
        var _a;
        setIsInputFocused(true);
        setIsOpen(true);
        setInputValue(formattedDateString);
        (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocus) === null || _a === void 0 || _a.call(inputProps, e);
    }, [
        formattedDateString,
        inputProps
    ]);
    var handleInputBlur = _react.useCallback(function(e) {
        var _a;
        if (inputValue == null || valueAsDate == null) return;
        var date = parseDateString(inputValue);
        if (inputValue.length > 0 && inputValue !== formattedDateString && (!(0, _datetime.DateUtils).isDateValid(date) || !(0, _datetime.DateUtils).isDayInRange(date, [
            minDate,
            maxDate
        ]))) {
            if (isControlled) setIsInputFocused(false);
            else {
                setIsInputFocused(false);
                setValue(date);
                setInputValue(undefined);
            }
            if (date === null) onChange === null || onChange === void 0 || onChange(null, true);
            else onError === null || onError === void 0 || onError(date);
        } else if (inputValue.length === 0) {
            setIsInputFocused(false);
            setValue(null);
            setInputValue(undefined);
        } else setIsInputFocused(false);
        (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onBlur) === null || _a === void 0 || _a.call(inputProps, e);
    }, [
        formattedDateString,
        inputProps,
        inputValue,
        isControlled,
        maxDate,
        minDate,
        onChange,
        onError,
        parseDateString,
        valueAsDate
    ]);
    var handleInputChange = _react.useCallback(function(e) {
        var _a;
        var valueString = e.target.value;
        var inputValueAsDate = parseDateString(valueString);
        if ((0, _datetime.DateUtils).isDateValid(inputValueAsDate) && (0, _datetime.DateUtils).isDayInRange(inputValueAsDate, [
            minDate,
            maxDate
        ])) {
            if (isControlled) setInputValue(valueString);
            else {
                setValue(inputValueAsDate);
                setInputValue(valueString);
            }
            var newIsoDateString = (0, _datetime.TimezoneUtils).getIsoEquivalentWithUpdatedTimezone(inputValueAsDate, timezoneValue, timePrecision);
            onChange === null || onChange === void 0 || onChange(newIsoDateString, true);
        } else {
            if (valueString.length === 0) onChange === null || onChange === void 0 || onChange(null, true);
            setValue(inputValueAsDate);
            setInputValue(valueString);
        }
        (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange) === null || _a === void 0 || _a.call(inputProps, e);
    }, [
        isControlled,
        minDate,
        maxDate,
        timezoneValue,
        timePrecision,
        parseDateString,
        onChange,
        inputProps
    ]);
    var handleInputClick = _react.useCallback(function(e) {
        var _a;
        // stop propagation to the Popover's internal handleTargetClick handler;
        // otherwise, the popover will flicker closed as soon as it opens.
        e.stopPropagation();
        (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onClick) === null || _a === void 0 || _a.call(inputProps, e);
    }, [
        inputProps
    ]);
    var handleInputKeyDown = _react.useCallback(function(e) {
        var _a, _b, _c;
        if (e.key === "Tab" && e.shiftKey) // close popover on SHIFT+TAB key press
        handlePopoverClose(e);
        else if (e.key === "Tab" && isOpen) {
            (_a = getKeyboardFocusableElements(popoverContentRef).shift()) === null || _a === void 0 || _a.focus();
            // necessary to prevent focusing the second focusable element
            e.preventDefault();
        } else if (e.key === "Escape") {
            setIsOpen(false);
            (_b = inputRef.current) === null || _b === void 0 || _b.blur();
        } else if (e.key === "Enter" && inputValue != null) {
            var nextDate = parseDateString(inputValue);
            if ((0, _datetime.DateUtils).isDateValid(nextDate)) handleDateChange(nextDate, true, true);
        }
        (_c = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onKeyDown) === null || _c === void 0 || _c.call(inputProps, e);
    }, [
        handleDateChange,
        handlePopoverClose,
        inputProps,
        inputValue,
        isOpen,
        parseDateString
    ]);
    // Main render
    // ------------------------------------------------------------------------
    var shouldShowErrorStyling = !isInputFocused || inputValue === outOfRangeMessage || inputValue === invalidDateMessage;
    // We use the renderTarget API to flatten the rendered DOM and make it easier to implement features like the "fill" prop.
    var renderTarget = _react.useCallback(function(_a) {
        var _b;
        var targetIsOpen = _a.isOpen, ref = _a.ref, targetProps = (0, _tslib.__rest)(_a, [
            "isOpen",
            "ref"
        ]);
        return _react.createElement((0, _core.InputGroup), (0, _tslib.__assign)({
            autoComplete: "off",
            className: (0, _classnamesDefault.default)(targetProps.className, inputProps.className),
            intent: shouldShowErrorStyling && isErrorState ? (0, _core.Intent).DANGER : (0, _core.Intent).NONE,
            placeholder: placeholder,
            rightElement: _react.createElement(_react.Fragment, null, rightElement, maybeTimezonePicker),
            tagName: popoverProps.targetTagName,
            type: "text",
            role: "combobox"
        }, targetProps, inputProps, {
            "aria-controls": popoverId,
            "aria-expanded": targetIsOpen,
            disabled: disabled,
            fill: fill,
            inputRef: (0, _core.mergeRefs)(ref, inputRef, inputProps === null || inputProps === void 0 ? void 0 : inputProps.inputRef),
            onBlur: handleInputBlur,
            onChange: handleInputChange,
            onClick: handleInputClick,
            onFocus: handleInputFocus,
            onKeyDown: handleInputKeyDown,
            value: (_b = isInputFocused ? inputValue : formattedDateString) !== null && _b !== void 0 ? _b : ""
        }));
    }, [
        disabled,
        fill,
        formattedDateString,
        handleInputBlur,
        handleInputChange,
        handleInputClick,
        handleInputFocus,
        handleInputKeyDown,
        inputProps,
        inputValue,
        isErrorState,
        isInputFocused,
        maybeTimezonePicker,
        placeholder,
        popoverId,
        popoverProps.targetTagName,
        rightElement,
        shouldShowErrorStyling
    ]);
    // N.B. no need to set `fill` since that is unused with the `renderTarget` API
    return _react.createElement((0, _core.Popover), (0, _tslib.__assign)({
        isOpen: isOpen && !disabled
    }, popoverProps, {
        autoFocus: false,
        className: (0, _classnamesDefault.default)((0, _classes.Classes).DATE_INPUT, popoverProps.className, props.className),
        content: popoverContent,
        enforceFocus: false,
        onClose: handlePopoverClose,
        popoverClassName: (0, _classnamesDefault.default)((0, _classes.Classes).DATE_INPUT_POPOVER, popoverProps.popoverClassName),
        ref: popoverRef,
        renderTarget: renderTarget
    }));
});
DateInput3.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".DateInput3");
DateInput3.defaultProps = defaultProps;
/** Gets the input `placeholder` value from props, using default values if undefined */ function getPlaceholder(props) {
    var _a;
    if (props.placeholder !== undefined || props.formatDate !== undefined && props.parseDate !== undefined) return props.placeholder;
    else return (_a = props.dateFnsFormat) !== null && _a !== void 0 ? _a : (0, _dateFnsFormatUtils.getDefaultDateFnsFormat)(props);
}
function getInitialTimezoneValue(_a) {
    var defaultTimezone = _a.defaultTimezone, timezone = _a.timezone;
    if (timezone !== undefined) {
        // controlled mode
        if ((0, _datetime.TimezoneNameUtils).isValidTimezone(timezone)) return timezone;
        else {
            console.error((0, _datetime.Errors).DATEINPUT_INVALID_TIMEZONE);
            return (0, _datetime.TimezoneUtils).UTC_TIME.ianaCode;
        }
    } else if (defaultTimezone !== undefined) {
        // uncontrolled mode with initial value
        if ((0, _datetime.TimezoneNameUtils).isValidTimezone(defaultTimezone)) return defaultTimezone;
        else {
            console.error((0, _datetime.Errors).DATEINPUT_INVALID_DEFAULT_TIMEZONE);
            return (0, _datetime.TimezoneUtils).UTC_TIME.ianaCode;
        }
    } else // uncontrolled mode
    return (0, _datetime.TimezoneUtils).getCurrentTimezone();
}
function getRelatedTargetWithFallback(e) {
    var _a;
    return (_a = e.relatedTarget) !== null && _a !== void 0 ? _a : (0, _core.Utils).getActiveElement(e.currentTarget);
}
function getKeyboardFocusableElements(popoverContentRef) {
    if (popoverContentRef.current === null) return [];
    var elements = Array.from(popoverContentRef.current.querySelectorAll("button:not([disabled]),input,[tabindex]:not([tabindex='-1'])"));
    // Remove focus boundary div elements
    elements.pop();
    elements.shift();
    return elements;
}

},{"tslib":"b4wpY","classnames":"5Een2","react":"9njXz","@blueprintjs/core":"6Mq52","@blueprintjs/datetime":"g4aa7","../../classes":"dstkC","../../common/dateFnsFormatUtils":"l6BVI","../../common/dateFnsLocaleUtils":"dsU4P","../date-picker3/datePicker3":"jnV80","./useDateFormatter":"buugQ","./useDateParser":"GsgaE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l6BVI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultDateFnsFormats", ()=>DefaultDateFnsFormats);
parcelHelpers.export(exports, "getDefaultDateFnsFormat", ()=>getDefaultDateFnsFormat);
parcelHelpers.export(exports, "getDateFnsFormatter", ()=>getDateFnsFormatter);
parcelHelpers.export(exports, "getDateFnsParser", ()=>getDateFnsParser);
var _dateFns = require("date-fns");
var _datetime = require("@blueprintjs/datetime");
var DefaultDateFnsFormats = {
    DATE_ONLY: "yyyy-MM-dd",
    DATE_TIME_MILLISECONDS: "yyyy-MM-dd HH:mm:ss.SSS",
    DATE_TIME_MINUTES: "yyyy-MM-dd HH:mm",
    DATE_TIME_SECONDS: "yyyy-MM-dd HH:mm:ss"
};
function getDefaultDateFnsFormat(props) {
    var _a, _b, _c;
    var hasTimePickerProps = props.timePickerProps !== undefined && Object.keys(props.timePickerProps).length > 0;
    var precision = (_c = (_a = props.timePrecision) !== null && _a !== void 0 ? _a : (_b = props.timePickerProps) === null || _b === void 0 ? void 0 : _b.precision) !== null && _c !== void 0 ? _c : // if timePickerProps is non-empty but has no precision defined, use the default value of "minute"
    hasTimePickerProps ? (0, _datetime.TimePrecision).MINUTE : undefined;
    switch(precision){
        case (0, _datetime.TimePrecision).MILLISECOND:
            return DefaultDateFnsFormats.DATE_TIME_MILLISECONDS;
        case (0, _datetime.TimePrecision).MINUTE:
            return DefaultDateFnsFormats.DATE_TIME_MINUTES;
        case (0, _datetime.TimePrecision).SECOND:
            return DefaultDateFnsFormats.DATE_TIME_SECONDS;
        default:
            return DefaultDateFnsFormats.DATE_ONLY;
    }
}
function getDateFnsFormatter(formatStr, locale) {
    return function(date) {
        return (0, _dateFns.format)(date, formatStr, {
            locale: locale
        });
    };
}
function getDateFnsParser(formatStr, locale) {
    return function(str) {
        return (0, _dateFns.parse)(str, formatStr, new Date(), {
            locale: locale
        });
    };
}

},{"date-fns":"btU8f","@blueprintjs/datetime":"g4aa7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"buugQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a date string parser function based on a given locale.
 *
 * Prefer using user-provided `props.formatDate` and `props.dateFnsFormat` if available, otherwise fall back to
 * default formats inferred from time picker props.
 */ parcelHelpers.export(exports, "useDateFormatter", ()=>useDateFormatter);
var _react = require("react");
var _datetime = require("@blueprintjs/datetime");
var _dateFnsFormatUtils = require("../../common/dateFnsFormatUtils");
var _dateFnsLocaleProps = require("../../common/dateFnsLocaleProps");
function useDateFormatter(props, locale) {
    var _a = props, dateFnsFormat = _a.dateFnsFormat, localeFromProps = _a.locale, formatDate = _a.formatDate, invalidDateMessage = _a.invalidDateMessage, maxDate = _a.maxDate, minDate = _a.minDate, outOfRangeMessage = _a.outOfRangeMessage, timePickerProps = _a.timePickerProps, timePrecision = _a.timePrecision;
    return _react.useCallback(function(date) {
        var _a;
        if (date === undefined) return "";
        if (!(0, _datetime.DateUtils).isDateValid(date)) return invalidDateMessage;
        else if ((0, _datetime.DateUtils).isDayInRange(date, [
            minDate,
            maxDate
        ])) {
            if (formatDate !== undefined) // user-provided date formatter
            return formatDate(date, (_a = locale === null || locale === void 0 ? void 0 : locale.code) !== null && _a !== void 0 ? _a : (0, _dateFnsLocaleProps.getLocaleCodeFromProps)(localeFromProps));
            else {
                // use user-provided date-fns format or one of the default formats inferred from time picker props
                var format = dateFnsFormat !== null && dateFnsFormat !== void 0 ? dateFnsFormat : (0, _dateFnsFormatUtils.getDefaultDateFnsFormat)({
                    timePickerProps: timePickerProps,
                    timePrecision: timePrecision
                });
                return (0, _dateFnsFormatUtils.getDateFnsFormatter)(format, locale)(date);
            }
        } else return outOfRangeMessage;
    }, [
        dateFnsFormat,
        formatDate,
        invalidDateMessage,
        locale,
        localeFromProps,
        maxDate,
        minDate,
        outOfRangeMessage,
        timePickerProps,
        timePrecision
    ]);
}

},{"react":"9njXz","@blueprintjs/datetime":"g4aa7","../../common/dateFnsFormatUtils":"l6BVI","../../common/dateFnsLocaleProps":"8n0NB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8n0NB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLocaleCodeFromProps", ()=>getLocaleCodeFromProps);
function getLocaleCodeFromProps(localeOrCode) {
    return typeof localeOrCode === "string" ? localeOrCode : localeOrCode === null || localeOrCode === void 0 ? void 0 : localeOrCode.code;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"GsgaE":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a date string parser function based on a given locale.
 *
 * Prefer using user-provided `props.parseDate` and `props.dateFnsFormat` if available, otherwise fall back to
 * default formats inferred from time picker props.
 */ parcelHelpers.export(exports, "useDateParser", ()=>useDateParser);
var _react = require("react");
var _dateFnsFormatUtils = require("../../common/dateFnsFormatUtils");
var _dateFnsLocaleProps = require("../../common/dateFnsLocaleProps");
var INVALID_DATE = new Date(undefined);
function useDateParser(props, locale) {
    var _a = props, dateFnsFormat = _a.dateFnsFormat, invalidDateMessage = _a.invalidDateMessage, localeFromProps = _a.locale, outOfRangeMessage = _a.outOfRangeMessage, parseDate = _a.parseDate, timePickerProps = _a.timePickerProps, timePrecision = _a.timePrecision;
    return _react.useCallback(function(dateString) {
        var _a;
        if (dateString === outOfRangeMessage || dateString === invalidDateMessage) return null;
        var newDate = null;
        if (parseDate !== undefined) // user-provided date parser
        newDate = parseDate(dateString, (_a = locale === null || locale === void 0 ? void 0 : locale.code) !== null && _a !== void 0 ? _a : (0, _dateFnsLocaleProps.getLocaleCodeFromProps)(localeFromProps));
        else {
            // use user-provided date-fns format or one of the default formats inferred from time picker props
            var format = dateFnsFormat !== null && dateFnsFormat !== void 0 ? dateFnsFormat : (0, _dateFnsFormatUtils.getDefaultDateFnsFormat)({
                timePickerProps: timePickerProps,
                timePrecision: timePrecision
            });
            newDate = (0, _dateFnsFormatUtils.getDateFnsParser)(format, locale)(dateString);
        }
        return newDate === false ? INVALID_DATE : newDate;
    }, [
        dateFnsFormat,
        invalidDateMessage,
        locale,
        localeFromProps,
        outOfRangeMessage,
        parseDate,
        timePickerProps,
        timePrecision
    ]);
}

},{"react":"9njXz","../../common/dateFnsFormatUtils":"l6BVI","../../common/dateFnsLocaleProps":"8n0NB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bEuJ0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangeInput3", ()=>DateRangeInput3);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dateFns = require("date-fns");
var _react = require("react");
var _core = require("@blueprintjs/core");
var _datetime = require("@blueprintjs/datetime");
var _classes = require("../../classes");
var _dateFnsFormatUtils = require("../../common/dateFnsFormatUtils");
var _dateFnsLocaleProps = require("../../common/dateFnsLocaleProps");
var _dateRangePicker3 = require("../date-range-picker3/dateRangePicker3");
var _dateFnsLocalizedComponent = require("../dateFnsLocalizedComponent");
var _dateRangeInputUilts = require("./dateRangeInputUilts");
/**
 * Date range input (v3) component.
 *
 * @see https://blueprintjs.com/docs/#datetime2/date-range-input3
 */ var DateRangeInput3 = /** @class */ function(_super) {
    (0, _tslib.__extends)(DateRangeInput3, _super);
    function DateRangeInput3(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.startInputElement = null;
        _this.endInputElement = null;
        _this.handleStartInputRef = (0, _core.refHandler)(_this, "startInputElement", (_a = _this.props.startInputProps) === null || _a === void 0 ? void 0 : _a.inputRef);
        _this.handleEndInputRef = (0, _core.refHandler)(_this, "endInputElement", (_b = _this.props.endInputProps) === null || _b === void 0 ? void 0 : _b.inputRef);
        // We use the renderTarget API to flatten the rendered DOM.
        _this.renderTarget = // N.B. pull out `isOpen` so that it's not forwarded to the DOM.
        function(_a) {
            var _b;
            var isOpen = _a.isOpen, targetProps = (0, _tslib.__rest)(_a, [
                "isOpen"
            ]);
            var _c = _this.props, fill = _c.fill, _d = _c.popoverProps, popoverProps = _d === void 0 ? {} : _d;
            var _f = popoverProps.targetTagName, targetTagName = _f === void 0 ? "div" : _f;
            return _react.createElement(targetTagName, (0, _tslib.__assign)((0, _tslib.__assign)({}, targetProps), {
                className: (0, _classnamesDefault.default)((0, _core.Classes).CONTROL_GROUP, targetProps.className, (_b = {}, _b[(0, _core.Classes).FILL] = fill, _b))
            }), _this.renderInputGroup((0, _core.Boundary).START), _this.renderInputGroup((0, _core.Boundary).END));
        };
        _this.renderInputGroup = function(boundary) {
            var _a;
            var inputProps = _this.getInputProps(boundary);
            var handleInputEvent = boundary === (0, _core.Boundary).START ? _this.handleStartInputEvent : _this.handleEndInputEvent;
            return _react.createElement((0, _core.InputGroup), (0, _tslib.__assign)({
                autoComplete: "off",
                disabled: (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled) !== null && _a !== void 0 ? _a : _this.props.disabled,
                fill: _this.props.fill
            }, inputProps, {
                intent: _this.isInputInErrorState(boundary) ? (0, _core.Intent).DANGER : inputProps === null || inputProps === void 0 ? void 0 : inputProps.intent,
                inputRef: _this.getInputRef(boundary),
                onBlur: handleInputEvent,
                onChange: handleInputEvent,
                onClick: handleInputEvent,
                onFocus: handleInputEvent,
                onKeyDown: handleInputEvent,
                onMouseDown: handleInputEvent,
                placeholder: _this.getInputPlaceholderString(boundary),
                value: _this.getInputDisplayString(boundary)
            }));
        };
        // Callbacks - DateRangePicker3
        // ===========================
        _this.handleDateRangePickerChange = function(selectedRange, didSubmitWithEnter) {
            var _a, _b;
            if (didSubmitWithEnter === void 0) didSubmitWithEnter = false;
            // ignore mouse events in the date-range picker if the popover is animating closed.
            if (!_this.state.isOpen) return;
            var selectedStart = selectedRange[0], selectedEnd = selectedRange[1];
            var isOpen = true;
            var isStartInputFocused;
            var isEndInputFocused;
            var startHoverString;
            var endHoverString;
            var boundaryToModify;
            if (selectedStart == null) {
                // focus the start field by default or if only an end date is specified
                if (_this.props.timePrecision == null) {
                    isStartInputFocused = true;
                    isEndInputFocused = false;
                } else {
                    isStartInputFocused = false;
                    isEndInputFocused = false;
                    boundaryToModify = (0, _core.Boundary).START;
                }
                // for clarity, hide the hover string until the mouse moves over a different date
                startHoverString = null;
            } else if (selectedEnd == null) {
                // focus the end field if a start date is specified
                if (_this.props.timePrecision == null) {
                    isStartInputFocused = false;
                    isEndInputFocused = true;
                } else {
                    isStartInputFocused = false;
                    isEndInputFocused = false;
                    boundaryToModify = (0, _core.Boundary).END;
                }
                endHoverString = null;
            } else if (_this.props.closeOnSelection) {
                isOpen = _this.getIsOpenValueWhenDateChanges(selectedStart, selectedEnd);
                isStartInputFocused = false;
                if (_this.props.timePrecision == null && didSubmitWithEnter) // if we submit via click or Tab, the focus will have moved already.
                // it we submit with Enter, the focus won't have moved, and setting
                // the flag to false won't have an effect anyway, so leave it true.
                isEndInputFocused = true;
                else {
                    isEndInputFocused = false;
                    boundaryToModify = (0, _core.Boundary).END;
                }
            } else if (_this.state.lastFocusedField === (0, _core.Boundary).START) {
                // keep the start field focused
                if (_this.props.timePrecision == null) {
                    isStartInputFocused = true;
                    isEndInputFocused = false;
                } else {
                    isStartInputFocused = false;
                    isEndInputFocused = false;
                    boundaryToModify = (0, _core.Boundary).START;
                }
            } else if (_this.props.timePrecision == null) {
                // keep the end field focused
                isStartInputFocused = false;
                isEndInputFocused = true;
            } else {
                isStartInputFocused = false;
                isEndInputFocused = false;
                boundaryToModify = (0, _core.Boundary).END;
            }
            var baseStateChange = {
                boundaryToModify: boundaryToModify,
                endHoverString: endHoverString,
                endInputString: _this.formatDate(selectedEnd),
                isEndInputFocused: isEndInputFocused,
                isOpen: isOpen,
                isStartInputFocused: isStartInputFocused,
                startHoverString: startHoverString,
                startInputString: _this.formatDate(selectedStart),
                wasLastFocusChangeDueToHover: false
            };
            if (_this.isControlled()) _this.setState(baseStateChange);
            else _this.setState((0, _tslib.__assign)((0, _tslib.__assign)({}, baseStateChange), {
                selectedEnd: selectedEnd,
                selectedStart: selectedStart
            }));
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, selectedRange);
        };
        _this.handleShortcutChange = function(_, selectedShortcutIndex) {
            _this.setState({
                selectedShortcutIndex: selectedShortcutIndex
            });
        };
        _this.handleDateRangePickerHoverChange = function(hoveredRange, _hoveredDay, hoveredBoundary) {
            // ignore mouse events in the date-range picker if the popover is animating closed.
            if (!_this.state.isOpen) return;
            if (hoveredRange == null) {
                // undo whatever focus changes we made while hovering over various calendar dates
                var isEndInputFocused = _this.state.boundaryToModify === (0, _core.Boundary).END;
                _this.setState({
                    endHoverString: null,
                    isEndInputFocused: isEndInputFocused,
                    isStartInputFocused: !isEndInputFocused,
                    lastFocusedField: _this.state.boundaryToModify,
                    startHoverString: null
                });
            } else {
                var hoveredStart = hoveredRange[0], hoveredEnd = hoveredRange[1];
                var isStartInputFocused = hoveredBoundary != null ? hoveredBoundary === (0, _core.Boundary).START : _this.state.isStartInputFocused;
                var isEndInputFocused = hoveredBoundary != null ? hoveredBoundary === (0, _core.Boundary).END : _this.state.isEndInputFocused;
                _this.setState({
                    endHoverString: _this.formatDate(hoveredEnd),
                    isEndInputFocused: isEndInputFocused,
                    isStartInputFocused: isStartInputFocused,
                    lastFocusedField: isStartInputFocused ? (0, _core.Boundary).START : (0, _core.Boundary).END,
                    shouldSelectAfterUpdate: _this.props.selectAllOnFocus,
                    startHoverString: _this.formatDate(hoveredStart),
                    wasLastFocusChangeDueToHover: true
                });
            }
        };
        // Callbacks - Input
        // =================
        // instantiate these two functions once so we don't have to for each callback on each render.
        _this.handleStartInputEvent = function(e) {
            _this.handleInputEvent(e, (0, _core.Boundary).START);
        };
        _this.handleEndInputEvent = function(e) {
            _this.handleInputEvent(e, (0, _core.Boundary).END);
        };
        _this.handleInputEvent = function(e, boundary) {
            var _a, _b, _c, _d, _f, _g;
            var inputProps = _this.getInputProps(boundary);
            switch(e.type){
                case "blur":
                    _this.handleInputBlur(e, boundary);
                    (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onBlur) === null || _a === void 0 || _a.call(inputProps, e);
                    break;
                case "change":
                    _this.handleInputChange(e, boundary);
                    (_b = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange) === null || _b === void 0 || _b.call(inputProps, e);
                    break;
                case "click":
                    e;
                    _this.handleInputClick(e);
                    (_c = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onClick) === null || _c === void 0 || _c.call(inputProps, e);
                    break;
                case "focus":
                    _this.handleInputFocus(e, boundary);
                    (_d = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocus) === null || _d === void 0 || _d.call(inputProps, e);
                    break;
                case "keydown":
                    e;
                    _this.handleInputKeyDown(e, boundary);
                    (_f = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onKeyDown) === null || _f === void 0 || _f.call(inputProps, e);
                    break;
                case "mousedown":
                    e;
                    _this.handleInputMouseDown();
                    (_g = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onMouseDown) === null || _g === void 0 || _g.call(inputProps, e);
                    break;
                default:
                    break;
            }
        };
        // add a keydown listener to persistently change focus when tabbing:
        // - if focused in start field, Tab moves focus to end field
        // - if focused in end field, Shift+Tab moves focus to start field
        _this.handleInputKeyDown = function(e, boundary) {
            var _a, _b;
            var isArrowKeyPresssed = e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "ArrowLeft" || e.key === "ArrowRight";
            var isTabPressed = e.key === "Tab";
            var isEnterPressed = e.key === "Enter";
            var isEscapeKeyPressed = e.key === "Escape";
            var isShiftPressed = e.shiftKey;
            var _c = _this.state, selectedStart = _c.selectedStart, selectedEnd = _c.selectedEnd;
            if (isArrowKeyPresssed) {
                _this.handleInputArrowKeyDown(e, boundary);
                return;
            }
            if (isEscapeKeyPressed) {
                (_a = _this.startInputElement) === null || _a === void 0 || _a.blur();
                (_b = _this.endInputElement) === null || _b === void 0 || _b.blur();
                _this.setState({
                    isOpen: false,
                    isStartInputFocused: false,
                    isEndInputFocused: false
                });
                return;
            }
            // order of JS events is our enemy here. when tabbing between fields,
            // this handler will fire in the middle of a focus exchange when no
            // field is currently focused. we work around this by referring to the
            // most recently focused field, rather than the currently focused field.
            var wasStartFieldFocused = _this.state.lastFocusedField === (0, _core.Boundary).START;
            var wasEndFieldFocused = _this.state.lastFocusedField === (0, _core.Boundary).END;
            // move focus to the other field
            if (isTabPressed) {
                var isEndInputFocused = void 0;
                var isStartInputFocused = void 0;
                var isOpen = true;
                if (wasStartFieldFocused && !isShiftPressed) {
                    isStartInputFocused = false;
                    isEndInputFocused = true;
                    // prevent the default focus-change behavior to avoid race conditions;
                    // we'll handle the focus change ourselves in componentDidUpdate.
                    e.preventDefault();
                } else if (wasEndFieldFocused && isShiftPressed) {
                    isStartInputFocused = true;
                    isEndInputFocused = false;
                    e.preventDefault();
                } else {
                    // don't prevent default here, otherwise Tab won't do anything.
                    isStartInputFocused = false;
                    isEndInputFocused = false;
                    isOpen = false;
                }
                _this.setState({
                    isEndInputFocused: isEndInputFocused,
                    isOpen: isOpen,
                    isStartInputFocused: isStartInputFocused,
                    wasLastFocusChangeDueToHover: false
                });
            } else if (wasStartFieldFocused && isEnterPressed) {
                var nextStartDate = _this.parseDate(_this.state.startInputString);
                _this.handleDateRangePickerChange([
                    nextStartDate,
                    selectedEnd
                ], true);
            } else if (wasEndFieldFocused && isEnterPressed) {
                var nextEndDate = _this.parseDate(_this.state.endInputString);
                _this.handleDateRangePickerChange([
                    selectedStart,
                    nextEndDate
                ], true);
            } else // let the default keystroke happen without side effects
            return;
        };
        _this.handleInputArrowKeyDown = function(e, boundary) {
            var _a;
            var _b, _c, _d;
            var _f = _this.props, minDate = _f.minDate, maxDate = _f.maxDate;
            var isOpen = _this.state.isOpen;
            var inputElement = boundary === (0, _core.Boundary).START ? _this.startInputElement : _this.endInputElement;
            if (!isOpen || !(0, _dateRangeInputUilts.isEntireInputSelected)(inputElement)) return;
            var shiftedDate = (_b = _this.getNextDateForArrowKeyNavigation(e.key, boundary)) !== null && _b !== void 0 ? _b : _this.getDefaultDateForArrowKeyNavigation(e.key, boundary);
            if (shiftedDate == null) return;
            // We've commited to moving the selection, prevent the default arrow key interactions
            e.preventDefault();
            var clampedDate = (0, _dateRangeInputUilts.clampDate)(shiftedDate, minDate, maxDate);
            var keys = _this.getStateKeysAndValuesForBoundary(boundary).keys;
            var nextState = (_a = {}, _a[keys.inputString] = _this.formatDate(clampedDate), _a.shouldSelectAfterUpdate = true, _a);
            if (!_this.isControlled()) nextState[keys.selectedValue] = clampedDate;
            (_d = (_c = _this.props).onChange) === null || _d === void 0 || _d.call(_c, _this.getDateRangeForCallback(clampedDate, boundary));
            _this.setState(nextState);
        };
        _this.handleInputMouseDown = function() {
            // clicking in the field constitutes an explicit focus change. we update
            // the flag on "mousedown" instead of on "click", because it needs to be
            // set before onFocus is called ("click" triggers after "focus").
            _this.setState({
                wasLastFocusChangeDueToHover: false
            });
        };
        _this.handleInputClick = function(e) {
            // unless we stop propagation on this event, a click within an input
            // will close the popover almost as soon as it opens.
            e.stopPropagation();
        };
        _this.handleInputFocus = function(_e, boundary) {
            var _a;
            var _b = _this.getStateKeysAndValuesForBoundary(boundary), keys = _b.keys, values = _b.values;
            var isValueControlled = _this.isControlled();
            // We may be reacting to a programmatic focus triggered by componentDidUpdate() at a point when
            // values.selectedValue may not have been updated yet in controlled mode, so we must use values.controlledValue
            // in that case.
            var inputString = formatDateString(isValueControlled ? values.controlledValue : values.selectedValue, _this.props, _this.state.locale, true);
            // change the boundary only if the user explicitly focused in the field.
            // focus changes from hovering don't count; they're just temporary.
            var boundaryToModify = _this.state.wasLastFocusChangeDueToHover ? _this.state.boundaryToModify : boundary;
            _this.setState((_a = {}, _a[keys.inputString] = inputString, _a[keys.isInputFocused] = true, _a.boundaryToModify = boundaryToModify, _a.isOpen = true, _a.lastFocusedField = boundary, _a.shouldSelectAfterUpdate = _this.props.selectAllOnFocus, _a.wasLastFocusChangeDueToHover = false, _a));
        };
        _this.handleInputBlur = function(_e, boundary) {
            var _a, _b, _c, _d;
            var _f, _g;
            var _h = _this.getStateKeysAndValuesForBoundary(boundary), keys = _h.keys, values = _h.values;
            var maybeNextDate = _this.parseDate(values.inputString);
            var isValueControlled = _this.isControlled();
            var nextState = (_a = {}, _a[keys.isInputFocused] = false, _a.shouldSelectAfterUpdate = false, _a);
            if (_this.isInputEmpty(values.inputString)) {
                if (isValueControlled) nextState = (0, _tslib.__assign)((0, _tslib.__assign)({}, nextState), (_b = {}, _b[keys.inputString] = formatDateString(values.controlledValue, _this.props, _this.state.locale), _b));
                else nextState = (0, _tslib.__assign)((0, _tslib.__assign)({}, nextState), (_c = {}, _c[keys.inputString] = null, _c[keys.selectedValue] = null, _c));
            } else if (!_this.isNextDateRangeValid(maybeNextDate, boundary)) {
                if (!isValueControlled) nextState = (0, _tslib.__assign)((0, _tslib.__assign)({}, nextState), (_d = {}, _d[keys.inputString] = null, _d[keys.selectedValue] = maybeNextDate, _d));
                (_g = (_f = _this.props).onError) === null || _g === void 0 || _g.call(_f, _this.getDateRangeForCallback(maybeNextDate, boundary));
            }
            _this.setState(nextState);
        };
        _this.handleInputChange = function(e, boundary) {
            var _a, _b, _c, _d, _f;
            var _g, _h, _j, _k;
            var inputString = e.target.value;
            var keys = _this.getStateKeysAndValuesForBoundary(boundary).keys;
            var maybeNextDate = _this.parseDate(inputString);
            var isValueControlled = _this.isControlled();
            var nextState = {
                shouldSelectAfterUpdate: false
            };
            if (inputString.length === 0) {
                // this case will be relevant when we start showing the hovered range in the input
                // fields. goal is to show an empty field for clarity until the mouse moves over a
                // different date.
                var baseState = (0, _tslib.__assign)((0, _tslib.__assign)({}, nextState), (_a = {}, _a[keys.inputString] = "", _a));
                if (isValueControlled) nextState = baseState;
                else nextState = (0, _tslib.__assign)((0, _tslib.__assign)({}, baseState), (_b = {}, _b[keys.selectedValue] = null, _b));
                (_h = (_g = _this.props).onChange) === null || _h === void 0 || _h.call(_g, _this.getDateRangeForCallback(null, boundary));
            } else if (_this.isDateValidAndInRange(maybeNextDate)) {
                // note that error cases that depend on both fields (e.g. overlapping dates) should fall
                // through into this block so that the UI can update immediately, possibly with an error
                // message on the other field.
                // also, clear the hover string to ensure the most recent keystroke appears.
                var baseState = (0, _tslib.__assign)((0, _tslib.__assign)({}, nextState), (_c = {}, _c[keys.hoverString] = null, _c[keys.inputString] = inputString, _c));
                if (isValueControlled) nextState = baseState;
                else nextState = (0, _tslib.__assign)((0, _tslib.__assign)({}, baseState), (_d = {}, _d[keys.selectedValue] = maybeNextDate, _d));
                if (_this.isNextDateRangeValid(maybeNextDate, boundary)) (_k = (_j = _this.props).onChange) === null || _k === void 0 || _k.call(_j, _this.getDateRangeForCallback(maybeNextDate, boundary));
            } else // again, clear the hover string to ensure the most recent keystroke appears
            nextState = (0, _tslib.__assign)((0, _tslib.__assign)({}, nextState), (_f = {}, _f[keys.inputString] = inputString, _f[keys.hoverString] = null, _f));
            _this.setState(nextState);
        };
        // Callbacks - Popover
        // ===================
        _this.handlePopoverClose = function(event) {
            var _a, _b;
            _this.setState({
                isOpen: false
            });
            (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onClose) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.getIsOpenValueWhenDateChanges = function(nextSelectedStart, nextSelectedEnd) {
            if (_this.props.closeOnSelection) {
                // trivial case when TimePicker is not shown
                if (_this.props.timePrecision == null) return false;
                var fallbackDate = (0, _dateRangeInputUilts.getTodayAtMidnight)();
                var _a = _this.getSelectedRange([
                    fallbackDate,
                    fallbackDate
                ]), selectedStart = _a[0], selectedEnd = _a[1];
                // case to check if the user has changed TimePicker values
                if ((0, _datetime.DateUtils).isSameTime(selectedStart, nextSelectedStart) && (0, _datetime.DateUtils).isSameTime(selectedEnd, nextSelectedEnd)) return false;
                return true;
            }
            return true;
        };
        _this.getInitialRange = function(props) {
            if (props === void 0) props = _this.props;
            var defaultValue = props.defaultValue, value = props.value;
            if (value != null) return value;
            else if (defaultValue != null) return defaultValue;
            else return [
                null,
                null
            ];
        };
        _this.getSelectedRange = function(fallbackRange) {
            var _a;
            var selectedStart;
            var selectedEnd;
            if (_this.isControlled()) _a = _this.props.value, selectedStart = _a[0], selectedEnd = _a[1];
            else {
                selectedStart = _this.state.selectedStart;
                selectedEnd = _this.state.selectedEnd;
            }
            // this helper function checks if the provided boundary date *would* overlap the selected
            // other boundary date. providing the already-selected start date simply tells us if we're
            // currently in an overlapping state.
            var doBoundaryDatesOverlap = _this.doBoundaryDatesOverlap(selectedStart, (0, _core.Boundary).START);
            var dateRange = [
                selectedStart,
                doBoundaryDatesOverlap ? undefined : selectedEnd
            ];
            return dateRange.map(function(selectedBound, index) {
                var fallbackDate = fallbackRange != null ? fallbackRange[index] : undefined;
                return _this.isDateValidAndInRange(selectedBound !== null && selectedBound !== void 0 ? selectedBound : null) ? selectedBound : fallbackDate;
            });
        };
        _this.getInputDisplayString = function(boundary) {
            var values = _this.getStateKeysAndValuesForBoundary(boundary).values;
            var isInputFocused = values.isInputFocused, inputString = values.inputString, selectedValue = values.selectedValue, hoverString = values.hoverString;
            if (hoverString != null) return hoverString;
            else if (isInputFocused) return inputString == null ? "" : inputString;
            else if (selectedValue == null) return "";
            else if (_this.doesEndBoundaryOverlapStartBoundary(selectedValue, boundary)) return _this.props.overlappingDatesMessage;
            else return formatDateString(selectedValue, _this.props, _this.state.locale);
        };
        _this.getInputPlaceholderString = function(boundary) {
            var isStartBoundary = boundary === (0, _core.Boundary).START;
            var isEndBoundary = boundary === (0, _core.Boundary).END;
            var inputProps = _this.getInputProps(boundary);
            var isInputFocused = _this.getStateKeysAndValuesForBoundary(boundary).values.isInputFocused;
            // use the custom placeholder text for the input, if providied
            if ((inputProps === null || inputProps === void 0 ? void 0 : inputProps.placeholder) != null) return inputProps.placeholder;
            else if (isStartBoundary) return isInputFocused ? _this.state.formattedMinDateString : "Start date";
            else if (isEndBoundary) return isInputFocused ? _this.state.formattedMaxDateString : "End date";
            else return "";
        };
        _this.getInputProps = function(boundary) {
            return boundary === (0, _core.Boundary).START ? _this.props.startInputProps : _this.props.endInputProps;
        };
        _this.getInputRef = function(boundary) {
            return boundary === (0, _core.Boundary).START ? _this.handleStartInputRef : _this.handleEndInputRef;
        };
        _this.getStateKeysAndValuesForBoundary = function(boundary) {
            var controlledRange = _this.props.value;
            if (boundary === (0, _core.Boundary).START) return {
                keys: {
                    hoverString: "startHoverString",
                    inputString: "startInputString",
                    isInputFocused: "isStartInputFocused",
                    selectedValue: "selectedStart"
                },
                values: {
                    controlledValue: controlledRange != null ? controlledRange[0] : undefined,
                    hoverString: _this.state.startHoverString,
                    inputString: _this.state.startInputString,
                    isInputFocused: _this.state.isStartInputFocused,
                    selectedValue: _this.state.selectedStart
                }
            };
            else return {
                keys: {
                    hoverString: "endHoverString",
                    inputString: "endInputString",
                    isInputFocused: "isEndInputFocused",
                    selectedValue: "selectedEnd"
                },
                values: {
                    controlledValue: controlledRange != null ? controlledRange[1] : undefined,
                    hoverString: _this.state.endHoverString,
                    inputString: _this.state.endInputString,
                    isInputFocused: _this.state.isEndInputFocused,
                    selectedValue: _this.state.selectedEnd
                }
            };
        };
        _this.getDateRangeForCallback = function(currDate, currBoundary) {
            var otherBoundary = _this.getOtherBoundary(currBoundary);
            var otherDate = _this.getStateKeysAndValuesForBoundary(otherBoundary).values.selectedValue;
            return currBoundary === (0, _core.Boundary).START ? [
                currDate,
                otherDate
            ] : [
                otherDate,
                currDate
            ];
        };
        _this.getOtherBoundary = function(boundary) {
            return boundary === (0, _core.Boundary).START ? (0, _core.Boundary).END : (0, _core.Boundary).START;
        };
        _this.doBoundaryDatesOverlap = function(date, boundary) {
            var allowSingleDayRange = _this.props.allowSingleDayRange;
            var otherBoundary = _this.getOtherBoundary(boundary);
            var otherBoundaryDate = _this.getStateKeysAndValuesForBoundary(otherBoundary).values.selectedValue;
            if (date == null || otherBoundaryDate == null) return false;
            if (boundary === (0, _core.Boundary).START) {
                var isAfter = date > otherBoundaryDate;
                return isAfter || !allowSingleDayRange && (0, _dateFns.isSameDay)(date, otherBoundaryDate);
            } else {
                var isBefore = date < otherBoundaryDate;
                return isBefore || !allowSingleDayRange && (0, _dateFns.isSameDay)(date, otherBoundaryDate);
            }
        };
        /**
         * Returns true if the provided boundary is an END boundary overlapping the
         * selected start date. (If the boundaries overlap, we consider the END
         * boundary to be erroneous.)
         */ _this.doesEndBoundaryOverlapStartBoundary = function(boundaryDate, boundary) {
            return boundary === (0, _core.Boundary).START ? false : _this.doBoundaryDatesOverlap(boundaryDate, boundary);
        };
        _this.isControlled = function() {
            return _this.props.value !== undefined;
        };
        _this.isInputEmpty = function(inputString) {
            return inputString == null || inputString.length === 0;
        };
        _this.isInputInErrorState = function(boundary) {
            var values = _this.getStateKeysAndValuesForBoundary(boundary).values;
            var isInputFocused = values.isInputFocused, hoverString = values.hoverString, inputString = values.inputString, selectedValue = values.selectedValue;
            if (hoverString != null || _this.isInputEmpty(inputString)) // don't show an error state while we're hovering over a valid date.
            return false;
            var boundaryValue = isInputFocused ? _this.parseDate(inputString) : selectedValue;
            return boundaryValue != null && (!_this.isDateValidAndInRange(boundaryValue) || _this.doesEndBoundaryOverlapStartBoundary(boundaryValue, boundary));
        };
        _this.isDateValidAndInRange = function(date) {
            // min/max dates defined in defaultProps
            return (0, _dateFns.isValid)(date) && (0, _datetime.DateUtils).isDayInRange(date, [
                _this.props.minDate,
                _this.props.maxDate
            ]);
        };
        // this is a slightly kludgy function, but it saves us a good amount of repeated code between
        // the constructor and componentDidUpdate.
        _this.formatMinMaxDateString = function(props, propName) {
            var _a, _b;
            var date = props[propName];
            // N.B. default values are applied only if a prop is strictly `undefined`
            // See: https://facebook.github.io/react/docs/react-component.html#defaultprops
            var defaultDate = DateRangeInput3.defaultProps[propName];
            // N.B. this.state will be undefined in the constructor, so we need a fallback in that case
            var maybeLocale = ((_b = (_a = _this.state) === null || _a === void 0 ? void 0 : _a.locale) !== null && _b !== void 0 ? _b : typeof props.locale === "string") ? undefined : props.locale;
            return formatDateString(date !== null && date !== void 0 ? date : defaultDate, _this.props, maybeLocale);
        };
        _this.parseDate = function(dateString) {
            var _a;
            if (dateString === undefined || dateString === _this.props.outOfRangeMessage || dateString === _this.props.invalidDateMessage) return null;
            // HACKHACK: this code below is largely copied from the `useDateParser()` hook, which is the preferred
            // implementation that we can migrate to once DateRangeInput3 is a function component.
            var _b = _this.props, dateFnsFormat = _b.dateFnsFormat, localeFromProps = _b.locale, parseDate = _b.parseDate, timePickerProps = _b.timePickerProps, timePrecision = _b.timePrecision;
            var locale = _this.state.locale;
            var newDate = null;
            if (parseDate !== undefined) // user-provided date parser
            newDate = parseDate(dateString, (_a = locale === null || locale === void 0 ? void 0 : locale.code) !== null && _a !== void 0 ? _a : (0, _dateFnsLocaleProps.getLocaleCodeFromProps)(localeFromProps));
            else {
                // use user-provided date-fns format or one of the default formats inferred from time picker props
                var format = dateFnsFormat !== null && dateFnsFormat !== void 0 ? dateFnsFormat : (0, _dateFnsFormatUtils.getDefaultDateFnsFormat)({
                    timePickerProps: timePickerProps,
                    timePrecision: timePrecision
                });
                newDate = (0, _dateFnsFormatUtils.getDateFnsParser)(format, locale)(dateString);
            }
            return newDate === false ? (0, _dateRangeInputUilts.getTodayAtMidnight)() : newDate;
        };
        // called on date hover & selection
        _this.formatDate = function(date) {
            var _a;
            if (!_this.isDateValidAndInRange(date)) return "";
            // HACKHACK: the code below is largely copied from the `useDateFormatter()` hook, which is the preferred
            // implementation that we can migrate to once DateRangeInput3 is a function component.
            var _b = _this.props, dateFnsFormat = _b.dateFnsFormat, formatDate = _b.formatDate, localeFromProps = _b.locale, timePickerProps = _b.timePickerProps, timePrecision = _b.timePrecision;
            var locale = _this.state.locale;
            if (formatDate !== undefined) // user-provided date formatter
            return formatDate(date, (_a = locale === null || locale === void 0 ? void 0 : locale.code) !== null && _a !== void 0 ? _a : (0, _dateFnsLocaleProps.getLocaleCodeFromProps)(localeFromProps));
            else {
                // use user-provided date-fns format or one of the default formats inferred from time picker props
                var format = dateFnsFormat !== null && dateFnsFormat !== void 0 ? dateFnsFormat : (0, _dateFnsFormatUtils.getDefaultDateFnsFormat)({
                    timePickerProps: timePickerProps,
                    timePrecision: timePrecision
                });
                return (0, _dateFnsFormatUtils.getDateFnsFormatter)(format, locale)(date);
            }
        };
        var _c = _this.getInitialRange(), selectedStart = _c[0], selectedEnd = _c[1];
        _this.state = {
            formattedMaxDateString: _this.formatMinMaxDateString(props, "maxDate"),
            formattedMinDateString: _this.formatMinMaxDateString(props, "minDate"),
            isEndInputFocused: false,
            isOpen: false,
            isStartInputFocused: false,
            locale: undefined,
            selectedEnd: selectedEnd,
            selectedShortcutIndex: -1,
            selectedStart: selectedStart
        };
        return _this;
    }
    DateRangeInput3.prototype.componentDidMount = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.componentDidMount.call(this)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DateRangeInput3.prototype.componentDidUpdate = function(prevProps) {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _r, isStartInputFocused, isEndInputFocused, shouldSelectAfterUpdate, shouldFocusStartInput, shouldFocusEndInput, nextState, _s, selectedStart, selectedEnd, formattedMinDateString, formattedMaxDateString;
            return (0, _tslib.__generator)(this, function(_t) {
                _super.prototype.componentDidUpdate.call(this, prevProps);
                _r = this.state, isStartInputFocused = _r.isStartInputFocused, isEndInputFocused = _r.isEndInputFocused, shouldSelectAfterUpdate = _r.shouldSelectAfterUpdate;
                if (((_a = prevProps.startInputProps) === null || _a === void 0 ? void 0 : _a.inputRef) !== ((_b = this.props.startInputProps) === null || _b === void 0 ? void 0 : _b.inputRef)) {
                    (0, _core.setRef)((_c = prevProps.startInputProps) === null || _c === void 0 ? void 0 : _c.inputRef, null);
                    this.handleStartInputRef = (0, _core.refHandler)(this, "startInputElement", (_d = this.props.startInputProps) === null || _d === void 0 ? void 0 : _d.inputRef);
                    (0, _core.setRef)((_f = this.props.startInputProps) === null || _f === void 0 ? void 0 : _f.inputRef, this.startInputElement);
                }
                if (((_g = prevProps.endInputProps) === null || _g === void 0 ? void 0 : _g.inputRef) !== ((_h = this.props.endInputProps) === null || _h === void 0 ? void 0 : _h.inputRef)) {
                    (0, _core.setRef)((_j = prevProps.endInputProps) === null || _j === void 0 ? void 0 : _j.inputRef, null);
                    this.handleEndInputRef = (0, _core.refHandler)(this, "endInputElement", (_k = this.props.endInputProps) === null || _k === void 0 ? void 0 : _k.inputRef);
                    (0, _core.setRef)((_l = this.props.endInputProps) === null || _l === void 0 ? void 0 : _l.inputRef, this.endInputElement);
                }
                shouldFocusStartInput = this.shouldFocusInputRef(isStartInputFocused, this.startInputElement);
                shouldFocusEndInput = this.shouldFocusInputRef(isEndInputFocused, this.endInputElement);
                if (shouldFocusStartInput) (_m = this.startInputElement) === null || _m === void 0 || _m.focus();
                else if (shouldFocusEndInput) (_o = this.endInputElement) === null || _o === void 0 || _o.focus();
                if (isStartInputFocused && shouldSelectAfterUpdate) (_p = this.startInputElement) === null || _p === void 0 || _p.select();
                else if (isEndInputFocused && shouldSelectAfterUpdate) (_q = this.endInputElement) === null || _q === void 0 || _q.select();
                nextState = {};
                if (this.props.value !== prevProps.value) {
                    _s = this.getInitialRange(this.props), selectedStart = _s[0], selectedEnd = _s[1];
                    nextState = (0, _tslib.__assign)((0, _tslib.__assign)({}, nextState), {
                        selectedEnd: selectedEnd,
                        selectedStart: selectedStart
                    });
                }
                // cache the formatted date strings to avoid computing on each render.
                if (this.props.minDate !== prevProps.minDate) {
                    formattedMinDateString = this.formatMinMaxDateString(this.props, "minDate");
                    nextState = (0, _tslib.__assign)((0, _tslib.__assign)({}, nextState), {
                        formattedMinDateString: formattedMinDateString
                    });
                }
                if (this.props.maxDate !== prevProps.maxDate) {
                    formattedMaxDateString = this.formatMinMaxDateString(this.props, "maxDate");
                    nextState = (0, _tslib.__assign)((0, _tslib.__assign)({}, nextState), {
                        formattedMaxDateString: formattedMaxDateString
                    });
                }
                this.setState(nextState);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    DateRangeInput3.prototype.render = function() {
        var _a = this.state, locale = _a.locale, selectedShortcutIndex = _a.selectedShortcutIndex;
        var _b = this.props, _c = _b.popoverProps, popoverProps = _c === void 0 ? {} : _c, popoverRef = _b.popoverRef;
        var popoverContent = _react.createElement((0, _dateRangePicker3.DateRangePicker3), (0, _tslib.__assign)({}, this.props, {
            boundaryToModify: this.state.boundaryToModify,
            locale: locale !== null && locale !== void 0 ? locale : this.props.locale,
            onChange: this.handleDateRangePickerChange,
            onHoverChange: this.handleDateRangePickerHoverChange,
            onShortcutChange: this.handleShortcutChange,
            selectedShortcutIndex: selectedShortcutIndex,
            value: this.getSelectedRange()
        }));
        // allow custom props for the popover and each input group, but pass them in an order that
        // guarantees only some props are overridable.
        return _react.createElement((0, _core.Popover), (0, _tslib.__assign)({
            isOpen: this.state.isOpen,
            placement: "bottom-start"
        }, popoverProps, {
            autoFocus: false,
            className: (0, _classnamesDefault.default)((0, _classes.Classes).DATE_RANGE_INPUT, popoverProps.className, this.props.className),
            content: popoverContent,
            enforceFocus: false,
            onClose: this.handlePopoverClose,
            popoverClassName: (0, _classnamesDefault.default)((0, _classes.Classes).DATE_RANGE_INPUT_POPOVER, popoverProps.popoverClassName),
            ref: popoverRef,
            renderTarget: this.renderTarget
        }));
    };
    DateRangeInput3.prototype.validateProps = function(props) {
        if (props.value === null) // throw a blocking error here because we don't handle a null value gracefully across this component
        // (it's not allowed by TS under strict null checks anyway)
        throw new Error((0, _datetime.Errors).DATERANGEINPUT_NULL_VALUE);
    };
    DateRangeInput3.prototype.getNextDateForArrowKeyNavigation = function(arrowKey, boundary) {
        var allowSingleDayRange = this.props.allowSingleDayRange;
        var _a = this.getSelectedRange(), selectedStart = _a[0], selectedEnd = _a[1];
        var initialDate = boundary === (0, _core.Boundary).START ? selectedStart : selectedEnd;
        if (initialDate == null) return undefined;
        var relativeDate = (0, _dateRangeInputUilts.shiftDateByArrowKey)(initialDate, arrowKey);
        // Ensure that we don't move onto a single day range selection if that is disallowed
        var adjustedStart = selectedStart == null || allowSingleDayRange ? selectedStart : (0, _dateRangeInputUilts.shiftDateByDays)(selectedStart, 1);
        var adjustedEnd = selectedEnd == null || allowSingleDayRange ? selectedEnd : (0, _dateRangeInputUilts.shiftDateByDays)(selectedEnd, -1);
        return boundary === (0, _core.Boundary).START ? (0, _dateRangeInputUilts.clampDate)(relativeDate, undefined, adjustedEnd) : (0, _dateRangeInputUilts.clampDate)(relativeDate, adjustedStart, undefined);
    };
    DateRangeInput3.prototype.getDefaultDateForArrowKeyNavigation = function(arrowKey, boundary) {
        var _a = this.getSelectedRange(), selectedStart = _a[0], selectedEnd = _a[1];
        var otherBoundary = boundary === (0, _core.Boundary).START ? selectedEnd : selectedStart;
        if (otherBoundary == null) return (0, _dateRangeInputUilts.getTodayAtMidnight)();
        var isForwardArrowKey = arrowKey === "ArrowRight" || arrowKey === "ArrowDown";
        // If the arrow key direction is in the same direction as the boundary, then moving that way will not create an
        // overlapping date range
        if (isForwardArrowKey === (boundary === (0, _core.Boundary).END)) return (0, _dateRangeInputUilts.shiftDateByArrowKey)(otherBoundary, arrowKey);
        return undefined;
    };
    // Helpers
    // =======
    DateRangeInput3.prototype.shouldFocusInputRef = function(isFocused, inputRef) {
        return isFocused && inputRef != null && (0, _core.Utils).getActiveElement(this.startInputElement) !== inputRef;
    };
    DateRangeInput3.prototype.isNextDateRangeValid = function(nextDate, boundary) {
        return this.isDateValidAndInRange(nextDate) && !this.doBoundaryDatesOverlap(nextDate, boundary);
    };
    DateRangeInput3.defaultProps = {
        allowSingleDayRange: false,
        closeOnSelection: true,
        contiguousCalendarMonths: true,
        dayPickerProps: {},
        disabled: false,
        endInputProps: {},
        invalidDateMessage: "Invalid date",
        locale: "en-US",
        maxDate: (0, _datetime.DatePickerUtils).getDefaultMaxDate(),
        minDate: (0, _datetime.DatePickerUtils).getDefaultMinDate(),
        outOfRangeMessage: "Out of range",
        overlappingDatesMessage: "Overlapping dates",
        popoverProps: {},
        selectAllOnFocus: false,
        shortcuts: true,
        singleMonthOnly: false,
        startInputProps: {}
    };
    DateRangeInput3.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".DateRangeInput3");
    return DateRangeInput3;
}((0, _dateFnsLocalizedComponent.DateFnsLocalizedComponent));
// called on initial construction, input focus & blur, and the standard input render path
function formatDateString(date, props, locale, ignoreRange) {
    var _a;
    if (ignoreRange === void 0) ignoreRange = false;
    var _b = props, invalidDateMessage = _b.invalidDateMessage, maxDate = _b.maxDate, minDate = _b.minDate, outOfRangeMessage = _b.outOfRangeMessage;
    if (date == null) return "";
    else if (!(0, _datetime.DateUtils).isDateValid(date)) return invalidDateMessage;
    else if (ignoreRange || (0, _datetime.DateUtils).isDayInRange(date, [
        minDate,
        maxDate
    ])) {
        // HACKHACK: the code below is largely copied from the `useDateFormatter()` hook, which is the preferred
        // implementation that we can migrate to once DateRangeInput3 is a function component.
        var dateFnsFormat = props.dateFnsFormat, formatDate = props.formatDate, localeFromProps = props.locale, timePickerProps = props.timePickerProps, timePrecision = props.timePrecision;
        if (formatDate !== undefined) // user-provided date formatter
        return formatDate(date, (_a = locale === null || locale === void 0 ? void 0 : locale.code) !== null && _a !== void 0 ? _a : (0, _dateFnsLocaleProps.getLocaleCodeFromProps)(localeFromProps));
        else {
            // use user-provided date-fns format or one of the default formats inferred from time picker props
            var format = dateFnsFormat !== null && dateFnsFormat !== void 0 ? dateFnsFormat : (0, _dateFnsFormatUtils.getDefaultDateFnsFormat)({
                timePickerProps: timePickerProps,
                timePrecision: timePrecision
            });
            return (0, _dateFnsFormatUtils.getDateFnsFormatter)(format, locale)(date);
        }
    } else return outOfRangeMessage;
}

},{"tslib":"b4wpY","classnames":"5Een2","date-fns":"btU8f","react":"9njXz","@blueprintjs/core":"6Mq52","@blueprintjs/datetime":"g4aa7","../../classes":"dstkC","../../common/dateFnsFormatUtils":"l6BVI","../../common/dateFnsLocaleProps":"8n0NB","../date-range-picker3/dateRangePicker3":"6kmWl","../dateFnsLocalizedComponent":"fhuxV","./dateRangeInputUilts":"le6CO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kmWl":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangePicker3", ()=>DateRangePicker3);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dateFns = require("date-fns");
var _react = require("react");
var _core = require("@blueprintjs/core");
var _datetime = require("@blueprintjs/datetime");
var _classes = require("../../classes");
var _dayPickerModifiers = require("../../common/dayPickerModifiers");
var _datePicker3Context = require("../date-picker3/datePicker3Context");
var _dateFnsLocalizedComponent = require("../dateFnsLocalizedComponent");
var _contiguousDayRangePicker = require("./contiguousDayRangePicker");
var _nonContiguousDayRangePicker = require("./nonContiguousDayRangePicker");
var NULL_RANGE = [
    null,
    null
];
/**
 * Date range picker (v3) component.
 *
 * @see https://blueprintjs.com/docs/#datetime2/date-range-picker3
 */ var DateRangePicker3 = /** @class */ function(_super) {
    (0, _tslib.__extends)(DateRangePicker3, _super);
    function DateRangePicker3(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        // these will get merged with the user's own
        _this.modifiers = (_a = {}, _a[0, _dayPickerModifiers.HOVERED_RANGE_MODIFIER] = function(day) {
            var _a = _this.state, hoverValue = _a.hoverValue, _b = _a.value, selectedStart = _b[0], selectedEnd = _b[1];
            if (selectedStart == null && selectedEnd == null) return false;
            if (hoverValue == null || hoverValue[0] == null || hoverValue[1] == null) return false;
            return (0, _datetime.DateUtils).isDayInRange(day, hoverValue, true);
        }, _a["".concat((0, _dayPickerModifiers.HOVERED_RANGE_MODIFIER), "-start")] = function(day) {
            var hoverValue = _this.state.hoverValue;
            if (hoverValue == null || hoverValue[0] == null) return false;
            return (0, _datetime.DateUtils).isSameDay(hoverValue[0], day);
        }, _a["".concat((0, _dayPickerModifiers.HOVERED_RANGE_MODIFIER), "-end")] = function(day) {
            var hoverValue = _this.state.hoverValue;
            if (hoverValue == null || hoverValue[1] == null) return false;
            return (0, _datetime.DateUtils).isSameDay(hoverValue[1], day);
        }, _a);
        _this.modifiersClassNames = (_b = {}, _b[0, _dayPickerModifiers.HOVERED_RANGE_MODIFIER] = (0, _classes.Classes).DATERANGEPICKER3_HOVERED_RANGE, _b["".concat((0, _dayPickerModifiers.HOVERED_RANGE_MODIFIER), "-start")] = (0, _classes.Classes).DATERANGEPICKER3_HOVERED_RANGE_START, _b["".concat((0, _dayPickerModifiers.HOVERED_RANGE_MODIFIER), "-end")] = (0, _classes.Classes).DATERANGEPICKER3_HOVERED_RANGE_END, _b);
        _this.initialMonthAndYear = (0, _datetime.MonthAndYear).fromDate(new Date());
        _this.handleTimeChange = function(newTime, dateIndex) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props.timePickerProps) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 || _b.call(_a, newTime);
            var _e = _this.state, value = _e.value, time = _e.time;
            var newValue = (0, _datetime.DateUtils).getDateTime(value[dateIndex] != null ? (0, _datetime.DateUtils).clone(value[dateIndex]) : _this.getDefaultDate(dateIndex), newTime);
            var newDateRange = [
                value[0],
                value[1]
            ];
            newDateRange[dateIndex] = newValue;
            var newTimeRange = [
                time[0],
                time[1]
            ];
            newTimeRange[dateIndex] = newTime;
            (_d = (_c = _this.props).onChange) === null || _d === void 0 || _d.call(_c, newDateRange);
            _this.setState({
                value: newDateRange,
                time: newTimeRange
            });
        };
        // When a user sets the time value before choosing a date, we need to pick a date for them
        // The default depends on the value of the other date since there's an invariant
        // that the left/0 date is always less than the right/1 date
        _this.getDefaultDate = function(dateIndex) {
            var value = _this.state.value;
            var otherIndex = dateIndex === 0 ? 1 : 0;
            var otherDate = value[otherIndex];
            if (otherDate == null) return new Date();
            var allowSingleDayRange = _this.props.allowSingleDayRange;
            if (!allowSingleDayRange) {
                var dateDiff = dateIndex === 0 ? -1 : 1;
                return (0, _dateFns.addDays)(otherDate, dateDiff);
            }
            return otherDate;
        };
        _this.handleTimeChangeLeftCalendar = function(time) {
            _this.handleTimeChange(time, 0);
        };
        _this.handleTimeChangeRightCalendar = function(time) {
            _this.handleTimeChange(time, 1);
        };
        /**
         * Custom formatter to render weekday names in the calendar header. The default formatter generally works fine,
         * but it was returning CAPITALIZED strings for some reason, while we prefer Title Case.
         */ _this.formatWeekdayName = function(date) {
            return (0, _dateFns.format)(date, "EEEEEE", {
                locale: _this.state.locale
            });
        };
        _this.handleDayMouseEnter = function(day, activeModifiers, e) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props.dayPickerProps) === null || _a === void 0 ? void 0 : _a.onDayMouseEnter) === null || _b === void 0 || _b.call(_a, day, activeModifiers, e);
            if (activeModifiers.disabled) return;
            var _e = (0, _datetime.DateRangeSelectionStrategy).getNextState(_this.state.value, day, _this.props.allowSingleDayRange, _this.props.boundaryToModify), dateRange = _e.dateRange, boundary = _e.boundary;
            _this.setState({
                hoverValue: dateRange
            });
            (_d = (_c = _this.props).onHoverChange) === null || _d === void 0 || _d.call(_c, dateRange, day, boundary);
        };
        _this.handleDayMouseLeave = function(day, activeModifiers, e) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props.dayPickerProps) === null || _a === void 0 ? void 0 : _a.onDayMouseLeave) === null || _b === void 0 || _b.call(_a, day, activeModifiers, e);
            if (activeModifiers.disabled) return;
            _this.setState({
                hoverValue: undefined
            });
            (_d = (_c = _this.props).onHoverChange) === null || _d === void 0 || _d.call(_c, undefined, day, undefined);
        };
        _this.handleDayRangeSelect = function(nextValue, selectedDay, boundary) {
            var _a, _b;
            // update the hovered date range after click to show the newly selected
            // state, at leasts until the mouse moves again
            _this.setState({
                hoverValue: nextValue
            });
            (_b = (_a = _this.props).onHoverChange) === null || _b === void 0 || _b.call(_a, nextValue, selectedDay, boundary);
            _this.updateSelectedRange(nextValue);
        };
        _this.handleShortcutClick = function(shortcut, selectedShortcutIndex) {
            var _a, _b;
            var dateRange = shortcut.dateRange, includeTime = shortcut.includeTime;
            if (includeTime) _this.updateSelectedRange(dateRange, [
                dateRange[0],
                dateRange[1]
            ]);
            else _this.updateSelectedRange(dateRange);
            if (_this.props.selectedShortcutIndex === undefined) // uncontrolled shorcut selection
            _this.setState({
                selectedShortcutIndex: selectedShortcutIndex
            });
            (_b = (_a = _this.props).onShortcutChange) === null || _b === void 0 || _b.call(_a, shortcut, selectedShortcutIndex);
        };
        _this.updateSelectedRange = function(selectedRange, selectedTimeRange) {
            var _a, _b;
            if (selectedTimeRange === void 0) selectedTimeRange = _this.state.time;
            selectedRange[0] = (0, _datetime.DateUtils).getDateTime(selectedRange[0], selectedTimeRange[0]);
            selectedRange[1] = (0, _datetime.DateUtils).getDateTime(selectedRange[1], selectedTimeRange[1]);
            if (_this.props.value == null) // uncontrolled range selection
            _this.setState({
                time: selectedTimeRange,
                value: selectedRange
            });
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, selectedRange);
        };
        var value = getInitialValue(props);
        var time = value;
        _this.initialMonthAndYear = (0, _datetime.MonthAndYear).fromDate(getInitialMonth(props, value));
        _this.state = {
            hoverValue: NULL_RANGE,
            locale: undefined,
            selectedShortcutIndex: _this.props.selectedShortcutIndex !== undefined ? _this.props.selectedShortcutIndex : -1,
            time: time,
            value: value
        };
        return _this;
    }
    DateRangePicker3.prototype.render = function() {
        var _a;
        var _b = this.props, className = _b.className, contiguousCalendarMonths = _b.contiguousCalendarMonths, footerElement = _b.footerElement;
        var isSingleMonthOnly = getIsSingleMonthOnly(this.props);
        var classes = (0, _classnamesDefault.default)((0, _classes.Classes).DATEPICKER, (0, _classes.Classes).DATERANGEPICKER, className, (_a = {}, _a[(0, _classes.Classes).DATEPICKER3_HIGHLIGHT_CURRENT_DAY] = this.props.highlightCurrentDay, _a[(0, _classes.Classes).DATERANGEPICKER_CONTIGUOUS] = contiguousCalendarMonths, _a[(0, _classes.Classes).DATERANGEPICKER_SINGLE_MONTH] = isSingleMonthOnly, _a[(0, _classes.Classes).DATERANGEPICKER3_REVERSE_MONTH_AND_YEAR] = this.props.reverseMonthAndYearMenus, _a));
        // use the left DayPicker when we only need one
        return _react.createElement("div", {
            className: classes
        }, this.maybeRenderShortcuts(), _react.createElement("div", {
            className: (0, _classes.Classes).DATEPICKER_CONTENT
        }, _react.createElement((0, _datePicker3Context.DatePicker3Provider), (0, _tslib.__assign)({}, this.props, this.state), contiguousCalendarMonths || isSingleMonthOnly ? this.renderContiguousDayRangePicker(isSingleMonthOnly) : this.renderNonContiguousDayRangePicker(), this.maybeRenderTimePickers(isSingleMonthOnly), footerElement)));
    };
    DateRangePicker3.prototype.componentDidMount = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.componentDidMount.call(this)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DateRangePicker3.prototype.componentDidUpdate = function(prevProps) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var isControlled;
            return (0, _tslib.__generator)(this, function(_b) {
                _super.prototype.componentDidUpdate.call(this, prevProps);
                isControlled = prevProps.value !== undefined && this.props.value !== undefined;
                if (prevProps.contiguousCalendarMonths !== this.props.contiguousCalendarMonths) this.initialMonthAndYear = (0, _datetime.MonthAndYear).fromDate(getInitialMonth(this.props, getInitialValue(this.props)));
                if (isControlled && (!(0, _datetime.DateUtils).areRangesEqual(prevProps.value, this.props.value) || prevProps.contiguousCalendarMonths !== this.props.contiguousCalendarMonths)) this.setState({
                    value: (_a = this.props.value) !== null && _a !== void 0 ? _a : NULL_RANGE
                });
                if (this.props.selectedShortcutIndex !== prevProps.selectedShortcutIndex) this.setState({
                    selectedShortcutIndex: this.props.selectedShortcutIndex
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    DateRangePicker3.prototype.validateProps = function(props) {
        var defaultValue = props.defaultValue, initialMonth = props.initialMonth, maxDate = props.maxDate, minDate = props.minDate, boundaryToModify = props.boundaryToModify, value = props.value;
        var dateRange = [
            minDate,
            maxDate
        ];
        if (defaultValue != null && !(0, _datetime.DateUtils).isDayRangeInRange(defaultValue, dateRange)) console.error((0, _datetime.Errors).DATERANGEPICKER_DEFAULT_VALUE_INVALID);
        if (initialMonth != null && !(0, _datetime.DateUtils).isMonthInRange(initialMonth, dateRange)) console.error((0, _datetime.Errors).DATERANGEPICKER_INITIAL_MONTH_INVALID);
        if (maxDate != null && minDate != null && maxDate < minDate && !(0, _datetime.DateUtils).isSameDay(maxDate, minDate)) console.error((0, _datetime.Errors).DATERANGEPICKER_MAX_DATE_INVALID);
        if (value != null && !(0, _datetime.DateUtils).isDayRangeInRange(value, dateRange)) console.error((0, _datetime.Errors).DATERANGEPICKER_VALUE_INVALID);
        if (boundaryToModify != null && boundaryToModify !== (0, _core.Boundary).START && boundaryToModify !== (0, _core.Boundary).END) console.error((0, _datetime.Errors).DATERANGEPICKER_PREFERRED_BOUNDARY_TO_MODIFY_INVALID);
    };
    DateRangePicker3.prototype.maybeRenderShortcuts = function() {
        var shortcuts = this.props.shortcuts;
        if (shortcuts == null || shortcuts === false) return null;
        var selectedShortcutIndex = this.state.selectedShortcutIndex;
        var _a = this.props, allowSingleDayRange = _a.allowSingleDayRange, maxDate = _a.maxDate, minDate = _a.minDate, timePrecision = _a.timePrecision;
        return [
            _react.createElement((0, _datetime.DatePickerShortcutMenu), {
                key: "shortcuts",
                allowSingleDayRange: allowSingleDayRange,
                maxDate: maxDate,
                minDate: minDate,
                selectedShortcutIndex: selectedShortcutIndex,
                shortcuts: shortcuts,
                timePrecision: timePrecision,
                onShortcutClick: this.handleShortcutClick
            }),
            _react.createElement((0, _core.Divider), {
                key: "div"
            })
        ];
    };
    DateRangePicker3.prototype.maybeRenderTimePickers = function(isShowingOneMonth) {
        var _a;
        // timePrecision may be set as a root prop or as a property inside timePickerProps, so we need to check both
        var _b = this.props, timePickerProps = _b.timePickerProps, _c = _b.timePrecision, timePrecision = _c === void 0 ? timePickerProps === null || timePickerProps === void 0 ? void 0 : timePickerProps.precision : _c;
        if (timePrecision == null && timePickerProps === DateRangePicker3.defaultProps.timePickerProps) return null;
        var isLongTimePicker = (timePickerProps === null || timePickerProps === void 0 ? void 0 : timePickerProps.useAmPm) || timePrecision === (0, _datetime.TimePrecision).SECOND || timePrecision === (0, _datetime.TimePrecision).MILLISECOND;
        return _react.createElement("div", {
            className: (0, _classnamesDefault.default)((0, _classes.Classes).DATERANGEPICKER_TIMEPICKERS, (_a = {}, _a[(0, _classes.Classes).DATERANGEPICKER3_TIMEPICKERS_STACKED] = isShowingOneMonth && isLongTimePicker, _a))
        }, _react.createElement((0, _datetime.TimePicker), (0, _tslib.__assign)({
            precision: timePrecision
        }, timePickerProps, {
            onChange: this.handleTimeChangeLeftCalendar,
            value: this.state.time[0]
        })), _react.createElement((0, _datetime.TimePicker), (0, _tslib.__assign)({
            precision: timePrecision
        }, timePickerProps, {
            onChange: this.handleTimeChangeRightCalendar,
            value: this.state.time[1]
        })));
    };
    /**
     * Render a standard day range picker where props.contiguousCalendarMonths is expected to be `true`.
     */ DateRangePicker3.prototype.renderContiguousDayRangePicker = function(singleMonthOnly) {
        var _a = this.props, dayPickerProps = _a.dayPickerProps, props = (0, _tslib.__rest)(_a, [
            "dayPickerProps"
        ]);
        return _react.createElement((0, _contiguousDayRangePicker.ContiguousDayRangePicker), (0, _tslib.__assign)({}, props, {
            contiguousCalendarMonths: true,
            dayPickerEventHandlers: {
                onDayMouseEnter: this.handleDayMouseEnter,
                onDayMouseLeave: this.handleDayMouseLeave
            },
            dayPickerProps: this.resolvedDayPickerProps,
            initialMonthAndYear: this.initialMonthAndYear,
            locale: this.state.locale,
            onRangeSelect: this.handleDayRangeSelect,
            singleMonthOnly: singleMonthOnly,
            value: this.state.value
        }));
    };
    /**
     * react-day-picker doesn't have built-in support for non-contiguous calendar months in its range picker,
     * so we have to implement this ourselves.
     */ DateRangePicker3.prototype.renderNonContiguousDayRangePicker = function() {
        var _a = this.props, dayPickerProps = _a.dayPickerProps, props = (0, _tslib.__rest)(_a, [
            "dayPickerProps"
        ]);
        return _react.createElement((0, _nonContiguousDayRangePicker.NonContiguousDayRangePicker), (0, _tslib.__assign)({}, props, {
            dayPickerProps: this.resolvedDayPickerProps,
            dayPickerEventHandlers: {
                onDayMouseEnter: this.handleDayMouseEnter,
                onDayMouseLeave: this.handleDayMouseLeave
            },
            initialMonthAndYear: this.initialMonthAndYear,
            locale: this.state.locale,
            onRangeSelect: this.handleDayRangeSelect,
            value: this.state.value
        }));
    };
    Object.defineProperty(DateRangePicker3.prototype, "resolvedDayPickerProps", {
        get: function() {
            var _a = this.props.dayPickerProps, dayPickerProps = _a === void 0 ? {} : _a;
            return (0, _tslib.__assign)((0, _tslib.__assign)({}, dayPickerProps), {
                classNames: (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _classes.dayPickerClassNameOverrides)), dayPickerProps.classNames),
                formatters: (0, _tslib.__assign)({
                    formatWeekdayName: this.formatWeekdayName
                }, dayPickerProps.formatters),
                modifiers: (0, _dayPickerModifiers.combineModifiers)(this.modifiers, dayPickerProps.modifiers),
                modifiersClassNames: (0, _tslib.__assign)((0, _tslib.__assign)({}, this.modifiersClassNames), dayPickerProps.modifiersClassNames)
            });
        },
        enumerable: false,
        configurable: true
    });
    DateRangePicker3.defaultProps = {
        allowSingleDayRange: false,
        contiguousCalendarMonths: true,
        dayPickerProps: {},
        locale: "en-US",
        maxDate: (0, _datetime.DatePickerUtils).getDefaultMaxDate(),
        minDate: (0, _datetime.DatePickerUtils).getDefaultMinDate(),
        reverseMonthAndYearMenus: false,
        shortcuts: true,
        singleMonthOnly: false,
        timePickerProps: {}
    };
    DateRangePicker3.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".DateRangePicker3");
    return DateRangePicker3;
}((0, _dateFnsLocalizedComponent.DateFnsLocalizedComponent));
function getIsSingleMonthOnly(props) {
    return props.singleMonthOnly || (0, _datetime.DateUtils).isSameMonth(props.minDate, props.maxDate);
}
function getInitialValue(props) {
    if (props.value != null) return props.value;
    if (props.defaultValue != null) return props.defaultValue;
    return NULL_RANGE;
}
function getInitialMonth(props, value) {
    var today = new Date();
    var isSingleMonthOnly = getIsSingleMonthOnly(props);
    if (props.initialMonth != null) {
        if (!isSingleMonthOnly && (0, _datetime.DateUtils).isSameMonth(props.initialMonth, props.maxDate)) // special case: if initial month is same as maxDate month, display it on the right calendar
        return (0, _datetime.DateUtils).getDatePreviousMonth(props.initialMonth);
        return props.initialMonth;
    } else if (value[0] != null) {
        if (!isSingleMonthOnly && (0, _datetime.DateUtils).isSameMonth(value[0], props.maxDate)) // special case: if start of range is selected and that date is in the maxDate month, display it on the right calendar
        return (0, _datetime.DateUtils).getDatePreviousMonth(value[0]);
        return (0, _datetime.DateUtils).clone(value[0]);
    } else if (value[1] != null) {
        var month = (0, _datetime.DateUtils).clone(value[1]);
        if (!(0, _datetime.DateUtils).isSameMonth(month, props.minDate)) month.setMonth(month.getMonth() - 1);
        return month;
    } else if ((0, _datetime.DateUtils).isDayInRange(today, [
        props.minDate,
        props.maxDate
    ])) {
        if (!isSingleMonthOnly && (0, _datetime.DateUtils).isSameMonth(today, props.maxDate)) // special case: if today is in the maxDate month, display it on the right calendar
        today.setMonth(today.getMonth() - 1);
        return today;
    } else {
        var betweenDate = (0, _datetime.DateUtils).getDateBetween([
            props.minDate,
            props.maxDate
        ]);
        if (!isSingleMonthOnly && (0, _datetime.DateUtils).isSameMonth(betweenDate, props.maxDate)) // special case: if betweenDate is in the maxDate month, display it on the right calendar
        betweenDate.setMonth(betweenDate.getMonth() - 1);
        return betweenDate;
    }
}

},{"tslib":"b4wpY","classnames":"5Een2","date-fns":"btU8f","react":"9njXz","@blueprintjs/core":"6Mq52","@blueprintjs/datetime":"g4aa7","../../classes":"dstkC","../../common/dayPickerModifiers":"c1otP","../date-picker3/datePicker3Context":"8j1DF","../dateFnsLocalizedComponent":"fhuxV","./contiguousDayRangePicker":"iuI3Z","./nonContiguousDayRangePicker":"en8wi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c1otP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DISABLED_MODIFIER", ()=>DISABLED_MODIFIER);
parcelHelpers.export(exports, "HOVERED_RANGE_MODIFIER", ()=>HOVERED_RANGE_MODIFIER);
parcelHelpers.export(exports, "OUTSIDE_MODIFIER", ()=>OUTSIDE_MODIFIER);
parcelHelpers.export(exports, "SELECTED_MODIFIER", ()=>SELECTED_MODIFIER);
parcelHelpers.export(exports, "SELECTED_RANGE_MODIFIER", ()=>SELECTED_RANGE_MODIFIER);
parcelHelpers.export(exports, "DISALLOWED_MODIFIERS", ()=>DISALLOWED_MODIFIERS);
parcelHelpers.export(exports, "combineModifiers", ()=>combineModifiers);
var DISABLED_MODIFIER = "disabled";
var HOVERED_RANGE_MODIFIER = "hovered-range";
var OUTSIDE_MODIFIER = "outside";
var SELECTED_MODIFIER = "selected";
var SELECTED_RANGE_MODIFIER = "selected-range";
var DISALLOWED_MODIFIERS = [
    DISABLED_MODIFIER,
    HOVERED_RANGE_MODIFIER,
    OUTSIDE_MODIFIER,
    SELECTED_MODIFIER,
    SELECTED_RANGE_MODIFIER
];
function combineModifiers(baseModifiers, userModifiers) {
    var modifiers = baseModifiers;
    if (userModifiers !== undefined) {
        modifiers = {};
        for(var _i = 0, _a = Object.keys(userModifiers); _i < _a.length; _i++){
            var key = _a[_i];
            if (DISALLOWED_MODIFIERS.indexOf(key) === -1) modifiers[key] = userModifiers[key];
        }
        for(var _b = 0, _c = Object.keys(baseModifiers); _b < _c.length; _b++){
            var key = _c[_b];
            modifiers[key] = baseModifiers[key];
        }
    }
    return modifiers;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iuI3Z":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContiguousDayRangePicker", ()=>ContiguousDayRangePicker);
var _tslib = require("tslib");
var _react = require("react");
var _reactDayPicker = require("react-day-picker");
var _core = require("@blueprintjs/core");
var _datetime = require("@blueprintjs/datetime");
var _reactDayPickerUtils = require("../../common/reactDayPickerUtils");
var _datePicker3Dropdown = require("../react-day-picker/datePicker3Dropdown");
var _datePickerNavIcons = require("../react-day-picker/datePickerNavIcons");
var ContiguousDayRangePicker = function(_a) {
    var allowSingleDayRange = _a.allowSingleDayRange, boundaryToModify = _a.boundaryToModify, dayPickerEventHandlers = _a.dayPickerEventHandlers, dayPickerProps = _a.dayPickerProps, initialMonthAndYear = _a.initialMonthAndYear, locale = _a.locale, maxDate = _a.maxDate, minDate = _a.minDate, onRangeSelect = _a.onRangeSelect, _b = _a.singleMonthOnly, singleMonthOnly = _b === void 0 ? false : _b, value = _a.value;
    var _c = useContiguousCalendarViews(initialMonthAndYear, singleMonthOnly, value, dayPickerProps === null || dayPickerProps === void 0 ? void 0 : dayPickerProps.onMonthChange), displayMonth = _c.displayMonth, handleMonthChange = _c.handleMonthChange;
    var handleRangeSelect = _react.useCallback(function(range, selectedDay, activeModifiers, e) {
        var _a;
        (_a = dayPickerProps === null || dayPickerProps === void 0 ? void 0 : dayPickerProps.onSelect) === null || _a === void 0 || _a.call(dayPickerProps, range, selectedDay, activeModifiers, e);
        if (activeModifiers.disabled) return;
        var _b = (0, _datetime.DateRangeSelectionStrategy).getNextState(value, selectedDay, allowSingleDayRange, boundaryToModify), nextValue = _b.dateRange, boundary = _b.boundary;
        onRangeSelect(nextValue, selectedDay, boundary);
    }, [
        allowSingleDayRange,
        boundaryToModify,
        dayPickerProps,
        onRangeSelect,
        value
    ]);
    return _react.createElement((0, _reactDayPicker.DayPicker), (0, _tslib.__assign)({
        showOutsideDays: true
    }, dayPickerEventHandlers, dayPickerProps, {
        captionLayout: "dropdown-buttons",
        components: (0, _tslib.__assign)({
            Dropdown: (0, _datePicker3Dropdown.DatePicker3Dropdown),
            IconLeft: (0, _datePickerNavIcons.IconLeft),
            IconRight: (0, _datePickerNavIcons.IconRight)
        }, dayPickerProps === null || dayPickerProps === void 0 ? void 0 : dayPickerProps.components),
        fromDate: minDate,
        locale: locale,
        mode: "range",
        month: displayMonth.getFullDate(),
        numberOfMonths: singleMonthOnly ? 1 : 2,
        onMonthChange: handleMonthChange,
        onSelect: handleRangeSelect,
        selected: (0, _reactDayPickerUtils.dateRangeToDayPickerRange)(value),
        toDate: maxDate
    }));
};
ContiguousDayRangePicker.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".ContiguousDayRangePicker");
/**
 * State management and navigation event handlers for a single calendar or two contiguous calendar views.
 *
 * @param initialMonthAndYear initial month and year to display in the left calendar
 * @param singleMonthOnly whether we are only displaying a single month instead of two
 * @param selectedRange currently selected date range
 * @param userOnMonthChange custom `dayPickerProps.onMonthChange` handler supplied by users of `DateRangePicker3`
 */ function useContiguousCalendarViews(initialMonthAndYear, singleMonthOnly, selectedRange, userOnMonthChange) {
    var _a = _react.useState(initialMonthAndYear), displayMonth = _a[0], setDisplayMonth = _a[1];
    var prevSelectedRange = _react.useRef(selectedRange);
    var isInitialRender = _react.useRef(true);
    // use an effect to react to external value updates (such as shortcut item selections)
    _react.useEffect(function() {
        // upon first render, we shouldn't update the display month; instead just use the initially computed value.
        // this is important in cases where the user sets `initialMonth` and a controlled `value`.
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        if (selectedRange == null) return;
        setDisplayMonth(function(prevDisplayMonth) {
            var _a, _b;
            var newDisplayMonth = prevDisplayMonth.clone();
            if (selectedRange[0] == null || selectedRange[1] == null) {
                // special case: if only one boundary of the range is selected and it is already displayed in one of the
                // months, don't update the display month. this prevents the picker from shifting around when a user is in
                // the middle of a selection.
                if (isDateDisplayed(selectedRange[0], prevDisplayMonth, singleMonthOnly) || isDateDisplayed(selectedRange[1], prevDisplayMonth, singleMonthOnly)) return newDisplayMonth;
            }
            var nextRangeStart = (0, _datetime.MonthAndYear).fromDate(selectedRange[0]);
            var nextRangeEnd = (0, _datetime.MonthAndYear).fromDate(selectedRange[1]);
            var hasSelectionEndChanged = ((_a = prevSelectedRange.current[0]) === null || _a === void 0 ? void 0 : _a.valueOf()) === ((_b = selectedRange[0]) === null || _b === void 0 ? void 0 : _b.valueOf());
            if (nextRangeStart == null && nextRangeEnd != null) // Only end date selected.
            // If the newly selected end date isn't in either of the displayed months, then
            //   - set the right DayPicker to the month of the selected end date
            //   - ensure the left DayPicker is before the right, changing if needed
            {
                if (!nextRangeEnd.isSame(newDisplayMonth.getNextMonth())) newDisplayMonth = nextRangeEnd.getPreviousMonth();
            } else if (nextRangeStart != null && nextRangeEnd == null) // Only start date selected.
            // If the newly selected start date isn't in either of the displayed months, then
            //   - set the left DayPicker to the month of the selected start date
            //   - ensure the right DayPicker is before the left, changing if needed
            {
                if (!nextRangeStart.isSame(newDisplayMonth)) newDisplayMonth = nextRangeStart;
            } else if (nextRangeStart != null && nextRangeEnd != null) {
                if (nextRangeStart.isSame(nextRangeEnd)) {
                    // Both start and end date months are identical
                    if (newDisplayMonth.isSame(nextRangeStart) || !singleMonthOnly && newDisplayMonth.getNextMonth().isSame(nextRangeEnd)) ;
                    else newDisplayMonth = nextRangeStart;
                } else if (hasSelectionEndChanged) // If the selection end has changed, adjust the view to show the new end date
                newDisplayMonth = singleMonthOnly ? nextRangeEnd : nextRangeEnd.getPreviousMonth();
                else // Otherwise, the selection start must have changed, show that
                newDisplayMonth = nextRangeStart;
            }
            return newDisplayMonth;
        });
    }, [
        setDisplayMonth,
        selectedRange,
        singleMonthOnly
    ]);
    _react.useEffect(function() {
        prevSelectedRange.current = selectedRange;
    }, [
        selectedRange
    ]);
    var handleMonthChange = _react.useCallback(function(newMonth) {
        setDisplayMonth((0, _datetime.MonthAndYear).fromDate(newMonth));
        userOnMonthChange === null || userOnMonthChange === void 0 || userOnMonthChange(newMonth);
    }, [
        userOnMonthChange,
        setDisplayMonth
    ]);
    return {
        displayMonth: displayMonth,
        handleMonthChange: handleMonthChange
    };
}
/**
 * Determines whether a given date is displayed in a contiguous single- or double-calendar view.
 */ function isDateDisplayed(date, displayMonth, singleMonthOnly) {
    if (date == null) return false;
    var month = (0, _datetime.MonthAndYear).fromDate(date);
    return singleMonthOnly ? displayMonth.isSameMonth(month) : displayMonth.isSameMonth(month) || displayMonth.getNextMonth().isSameMonth(month);
}

},{"tslib":"b4wpY","react":"9njXz","react-day-picker":"58IhA","@blueprintjs/core":"6Mq52","@blueprintjs/datetime":"g4aa7","../../common/reactDayPickerUtils":"8zA0F","../react-day-picker/datePicker3Dropdown":"bUQ9c","../react-day-picker/datePickerNavIcons":"62ZgP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8zA0F":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts a Blueprint `DateRange` to a react-day-picker `DateRange`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateRangeToDayPickerRange", ()=>dateRangeToDayPickerRange);
function dateRangeToDayPickerRange(range) {
    var _a, _b;
    return {
        from: (_a = range[0]) !== null && _a !== void 0 ? _a : undefined,
        to: (_b = range[1]) !== null && _b !== void 0 ? _b : undefined
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"en8wi":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonContiguousDayRangePicker", ()=>NonContiguousDayRangePicker);
var _tslib = require("tslib");
var _react = require("react");
var _reactDayPicker = require("react-day-picker");
var _core = require("@blueprintjs/core");
var _datetime = require("@blueprintjs/datetime");
var _classes = require("../../classes");
var _reactDayPickerUtils = require("../../common/reactDayPickerUtils");
var _datePicker3Caption = require("../react-day-picker/datePicker3Caption");
var NonContiguousDayRangePicker = function(_a) {
    var allowSingleDayRange = _a.allowSingleDayRange, boundaryToModify = _a.boundaryToModify, dayPickerEventHandlers = _a.dayPickerEventHandlers, dayPickerProps = _a.dayPickerProps, initialMonthAndYear = _a.initialMonthAndYear, locale = _a.locale, maxDate = _a.maxDate, minDate = _a.minDate, onRangeSelect = _a.onRangeSelect, value = _a.value;
    var _b = useNonContiguousCalendarViews(initialMonthAndYear, value, dayPickerProps === null || dayPickerProps === void 0 ? void 0 : dayPickerProps.onMonthChange), displayMonths = _b.displayMonths, handleLeftMonthChange = _b.handleLeftMonthChange, handleRightMonthChange = _b.handleRightMonthChange;
    var handleDaySelect = _react.useCallback(function(range, selectedDay, activeModifiers, e) {
        var _a;
        (_a = dayPickerProps === null || dayPickerProps === void 0 ? void 0 : dayPickerProps.onSelect) === null || _a === void 0 || _a.call(dayPickerProps, range, selectedDay, activeModifiers, e);
        if (activeModifiers.disabled) return;
        var _b = (0, _datetime.DateRangeSelectionStrategy).getNextState(value, selectedDay, allowSingleDayRange, boundaryToModify), nextValue = _b.dateRange, boundary = _b.boundary;
        onRangeSelect(nextValue, selectedDay, boundary);
    }, [
        allowSingleDayRange,
        boundaryToModify,
        dayPickerProps,
        onRangeSelect,
        value
    ]);
    // props applied to both the left and right calendars
    var commonDayPickerProps = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({
        locale: locale,
        mode: "range",
        showOutsideDays: true
    }, dayPickerProps), dayPickerEventHandlers), {
        components: (0, _tslib.__assign)({
            Caption: (0, _datePicker3Caption.DatePicker3Caption)
        }, dayPickerProps === null || dayPickerProps === void 0 ? void 0 : dayPickerProps.components),
        onSelect: handleDaySelect,
        selected: (0, _reactDayPickerUtils.dateRangeToDayPickerRange)(value)
    });
    return _react.createElement("div", {
        className: (0, _classes.Classes).DATERANGEPICKER_CALENDARS
    }, _react.createElement((0, _reactDayPicker.DayPicker), (0, _tslib.__assign)({
        key: "left"
    }, commonDayPickerProps, {
        fromDate: minDate,
        month: displayMonths.left.getFullDate(),
        numberOfMonths: 1,
        onMonthChange: handleLeftMonthChange,
        toMonth: (0, _datetime.DateUtils).getDatePreviousMonth(maxDate)
    })), _react.createElement((0, _reactDayPicker.DayPicker), (0, _tslib.__assign)({
        key: "right"
    }, commonDayPickerProps, {
        fromMonth: (0, _datetime.DateUtils).getDateNextMonth(minDate),
        month: displayMonths.right.getFullDate(),
        numberOfMonths: 1,
        onMonthChange: handleRightMonthChange,
        toDate: maxDate
    })));
};
NonContiguousDayRangePicker.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".NonContiguousDayRangePicker");
/**
 * State management and navigation event handlers for two (left and right) non-contiguous calendar views.
 *
 * @param initialMonthAndYear initial month and year to display in the left calendar
 * @param selectedRange currently selected date range
 * @param userOnMonthChange custom `dayPickerProps.onMonthChange` handler supplied by users of `DateRangePicker3`
 */ function useNonContiguousCalendarViews(initialMonthAndYear, selectedRange, userOnMonthChange) {
    // show the selected end date's encompassing month in the right view if
    // the calendars don't have to be contiguous.
    // if left view and right view months are the same, show next month in the right view.
    var _a = _react.useState({
        left: initialMonthAndYear,
        right: getInitialRightView(selectedRange[1], initialMonthAndYear)
    }), views = _a[0], setViews = _a[1];
    _react.useEffect(function() {
        if (selectedRange == null) return;
        setViews(function(_a) {
            var left = _a.left, right = _a.right;
            var newLeftView = left.clone();
            var newRightView = right.clone();
            var nextValueStartView = (0, _datetime.MonthAndYear).fromDate(selectedRange[0]);
            var nextValueEndView = (0, _datetime.MonthAndYear).fromDate(selectedRange[1]);
            if (nextValueStartView == null && nextValueEndView != null) // Only end date selected.
            // If the newly selected end date isn't in either of the displayed months, then
            //   - set the right DayPicker to the month of the selected end date
            //   - ensure the left DayPicker is before the right, changing if needed
            {
                if (!nextValueEndView.isSame(newLeftView) && !nextValueEndView.isSame(newRightView)) {
                    newRightView = nextValueEndView;
                    if (!newLeftView.isBefore(newRightView)) newLeftView = newRightView.getPreviousMonth();
                }
            } else if (nextValueStartView != null && nextValueEndView == null) // Only start date selected.
            // If the newly selected start date isn't in either of the displayed months, then
            //   - set the left DayPicker to the month of the selected start date
            //   - ensure the right DayPicker is before the left, changing if needed
            {
                if (!nextValueStartView.isSame(newLeftView) && !nextValueStartView.isSame(newRightView)) {
                    newLeftView = nextValueStartView;
                    if (!newRightView.isAfter(newLeftView)) newRightView = newLeftView.getNextMonth();
                }
            } else if (nextValueStartView != null && nextValueEndView != null) {
                // Both start and end date months are identical
                // If the selected month isn't in either of the displayed months, then
                //   - set the left DayPicker to be the selected month
                //   - set the right DayPicker to +1
                if (nextValueStartView.isSame(nextValueEndView)) {
                    if (newLeftView.isSame(nextValueStartView) || newRightView.isSame(nextValueStartView)) ;
                    else {
                        newLeftView = nextValueStartView;
                        newRightView = nextValueStartView.getNextMonth();
                    }
                } else {
                    // Different start and end date months, adjust display months.
                    if (!newLeftView.isSame(nextValueStartView)) {
                        newLeftView = nextValueStartView;
                        newRightView = nextValueStartView.getNextMonth();
                    }
                    if (!newRightView.isSame(nextValueEndView)) newRightView = nextValueEndView;
                }
            }
            return {
                left: newLeftView,
                right: newRightView
            };
        });
    }, [
        setViews,
        selectedRange
    ]);
    var updateLeftView = _react.useCallback(function(newLeftView) {
        setViews(function(_a) {
            var right = _a.right;
            var newRightView = right.clone();
            if (!newLeftView.isBefore(newRightView)) newRightView = newLeftView.getNextMonth();
            return {
                left: newLeftView,
                right: newRightView
            };
        });
    }, [
        setViews
    ]);
    var updateRightView = _react.useCallback(function(newRightView) {
        setViews(function(_a) {
            var left = _a.left;
            var newLeftView = left.clone();
            if (!newRightView.isAfter(newLeftView)) newLeftView = newRightView.getPreviousMonth();
            return {
                left: newLeftView,
                right: newRightView
            };
        });
    }, [
        setViews
    ]);
    var handleLeftMonthChange = _react.useCallback(function(newDate) {
        var newLeftView = (0, _datetime.MonthAndYear).fromDate(newDate);
        updateLeftView(newLeftView);
        userOnMonthChange === null || userOnMonthChange === void 0 || userOnMonthChange(newDate);
    }, [
        userOnMonthChange,
        updateLeftView
    ]);
    var handleRightMonthChange = _react.useCallback(function(newDate) {
        var newRightView = (0, _datetime.MonthAndYear).fromDate(newDate);
        updateRightView(newRightView);
        userOnMonthChange === null || userOnMonthChange === void 0 || userOnMonthChange(newDate);
    }, [
        userOnMonthChange,
        updateRightView
    ]);
    return {
        displayMonths: views,
        handleLeftMonthChange: handleLeftMonthChange,
        handleRightMonthChange: handleRightMonthChange
    };
}
function getInitialRightView(selectedRangeEnd, leftView) {
    var rightView = (0, _datetime.MonthAndYear).fromDate(selectedRangeEnd);
    if (rightView === undefined || rightView.isSameMonth(leftView)) return leftView.getNextMonth();
    return rightView;
}

},{"tslib":"b4wpY","react":"9njXz","react-day-picker":"58IhA","@blueprintjs/core":"6Mq52","@blueprintjs/datetime":"g4aa7","../../classes":"dstkC","../../common/reactDayPickerUtils":"8zA0F","../react-day-picker/datePicker3Caption":"anq8H","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"anq8H":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker3Caption", ()=>DatePicker3Caption);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDayPicker = require("react-day-picker");
var _reactInnertext = require("react-innertext");
var _reactInnertextDefault = parcelHelpers.interopDefault(_reactInnertext);
var _core = require("@blueprintjs/core");
var _datetime = require("@blueprintjs/datetime");
var _icons = require("@blueprintjs/icons");
var _classes = require("../../classes");
var _useMonthSelectRightOffset = require("../../common/useMonthSelectRightOffset");
var _datePicker3Context = require("../date-picker3/datePicker3Context");
var DatePicker3Caption = function(props) {
    var _a = (0, _reactDayPicker.useDayPicker)(), rdpClassNames = _a.classNames, formatters = _a.formatters, fromDate = _a.fromDate, toDate = _a.toDate, labels = _a.labels;
    var _b = _react.useContext((0, _datePicker3Context.DatePicker3Context)), locale = _b.locale, reverseMonthAndYearMenus = _b.reverseMonthAndYearMenus;
    // non-null assertion because we define these values in defaultProps
    var minYear = fromDate.getFullYear();
    var maxYear = toDate.getFullYear();
    var displayMonth = props.displayMonth.getMonth();
    var displayYear = props.displayMonth.getFullYear();
    var containerElement = _react.useRef(null);
    var monthSelectElement = _react.useRef(null);
    var _c = (0, _reactDayPicker.useNavigation)(), currentMonth = _c.currentMonth, goToMonth = _c.goToMonth, nextMonth = _c.nextMonth, previousMonth = _c.previousMonth;
    var handlePreviousClick = _react.useCallback(function() {
        return previousMonth && goToMonth(previousMonth);
    }, [
        previousMonth,
        goToMonth
    ]);
    var handleNextClick = _react.useCallback(function() {
        return nextMonth && goToMonth(nextMonth);
    }, [
        nextMonth,
        goToMonth
    ]);
    var prevButton = _react.createElement((0, _core.Button), {
        "aria-label": labels.labelPrevious(previousMonth, {
            locale: locale
        }),
        className: (0, _classnamesDefault.default)((0, _classes.DatePicker3CaptionClasses).DATEPICKER3_NAV_BUTTON, (0, _classes.DatePicker3CaptionClasses).DATEPICKER3_NAV_BUTTON_PREVIOUS),
        disabled: !previousMonth,
        icon: _react.createElement((0, _icons.ChevronLeft), null),
        minimal: true,
        onClick: handlePreviousClick
    });
    var nextButton = _react.createElement((0, _core.Button), {
        "aria-label": labels.labelNext(nextMonth, {
            locale: locale
        }),
        className: (0, _classnamesDefault.default)((0, _classes.DatePicker3CaptionClasses).DATEPICKER3_NAV_BUTTON, (0, _classes.DatePicker3CaptionClasses).DATEPICKER3_NAV_BUTTON_NEXT),
        disabled: !nextMonth,
        icon: _react.createElement((0, _icons.ChevronRight), null),
        minimal: true,
        onClick: handleNextClick
    });
    // build the list of available years, relying on react-day-picker's default date-fns formatter or a
    // user-provided formatter to localize the year "names"
    var formatYearCaption = formatters.formatYearCaption;
    var allYearOptions = _react.useMemo(function() {
        var years = [];
        for(var year = minYear; year <= maxYear; year++){
            var yearDate = new Date(year, 0);
            var yearCaption = formatYearCaption(yearDate, {
                locale: locale
            });
            years.push({
                label: (0, _reactInnertextDefault.default)(yearCaption),
                value: year
            });
        }
        return years;
    }, [
        formatYearCaption,
        maxYear,
        minYear,
        locale
    ]);
    // allow out-of-bounds years but disable the option.
    // this handles the Dec 2016 case in https://github.com/palantir/blueprint/issues/391
    if (displayYear > maxYear) {
        var displayYearDate = new Date(displayYear, 0);
        var displayYearCaption = formatYearCaption(displayYearDate, {
            locale: locale
        });
        allYearOptions.push({
            label: (0, _reactInnertextDefault.default)(displayYearCaption),
            value: displayYear,
            disabled: true
        });
    }
    var handleMonthSelectChange = _react.useCallback(function(e) {
        var newMonth = parseInt(e.target.value, 10);
        // ignore change events with invalid values to prevent crash on iOS Safari (#4178)
        if (isNaN(newMonth)) return;
        var newDate = (0, _datetime.DateUtils).clone(currentMonth);
        newDate.setMonth(newMonth);
        goToMonth(newDate);
    }, [
        currentMonth,
        goToMonth
    ]);
    var startMonth = displayYear === minYear ? fromDate.getMonth() : 0;
    var endMonth = displayYear === maxYear ? toDate.getMonth() + 1 : 12;
    // build the list of available months, relying on react-day-picker's default date-fns formatter or a
    // user-provided formatter to localize the month names
    var formatMonthCaption = formatters.formatMonthCaption;
    var allMonths = _react.useMemo(function() {
        var months = [];
        for(var i = (0, _datetime.Months).JANUARY; i <= (0, _datetime.Months).DECEMBER; i++){
            var monthDate = new Date(displayYear, i);
            var formattedMonth = formatMonthCaption(monthDate, {
                locale: locale
            });
            months.push((0, _reactInnertextDefault.default)(formattedMonth));
        }
        return months;
    }, [
        displayYear,
        formatMonthCaption,
        locale
    ]);
    var allMonthOptions = allMonths.map(function(month, i) {
        return {
            label: month,
            value: i
        };
    });
    var availableMonthOptions = allMonthOptions.slice(startMonth, endMonth);
    var displayedMonthText = allMonths[displayMonth];
    var monthSelectRightOffset = (0, _useMonthSelectRightOffset.useMonthSelectRightOffset)(monthSelectElement, containerElement, displayedMonthText);
    var monthSelect = _react.createElement((0, _core.HTMLSelect), {
        "aria-label": labels.labelMonthDropdown(),
        iconProps: {
            style: {
                right: monthSelectRightOffset
            }
        },
        className: (0, _classnamesDefault.default)((0, _classes.DatePicker3CaptionClasses).DATEPICKER3_DROPDOWN_MONTH, rdpClassNames.dropdown_month),
        key: "month",
        minimal: true,
        onChange: handleMonthSelectChange,
        ref: monthSelectElement,
        value: displayMonth,
        options: availableMonthOptions
    });
    var handleYearSelectChange = _react.useCallback(function(e) {
        var newYear = parseInt(e.target.value, 10);
        // ignore change events with invalid values to prevent crash on iOS Safari (#4178)
        if (isNaN(newYear)) return;
        var newDate = (0, _datetime.DateUtils).clone(currentMonth);
        newDate.setFullYear(newYear);
        goToMonth(newDate);
    }, [
        currentMonth,
        goToMonth
    ]);
    var yearSelect = _react.createElement((0, _core.HTMLSelect), {
        "aria-label": labels.labelYearDropdown(),
        className: (0, _classnamesDefault.default)((0, _classes.DatePicker3CaptionClasses).DATEPICKER3_DROPDOWN_YEAR, rdpClassNames.dropdown_year),
        key: "year",
        minimal: true,
        onChange: handleYearSelectChange,
        value: displayYear,
        options: allYearOptions
    });
    var orderedSelects = reverseMonthAndYearMenus ? [
        yearSelect,
        monthSelect
    ] : [
        monthSelect,
        yearSelect
    ];
    var hiddenCaptionLabel = _react.createElement("div", {
        className: (0, _classes.ReactDayPickerClasses).RDP_VHIDDEN
    }, _react.createElement((0, _reactDayPicker.CaptionLabel), {
        displayMonth: props.displayMonth,
        id: props.id
    }));
    return _react.createElement("div", {
        className: (0, _classnamesDefault.default)((0, _classes.DatePicker3CaptionClasses).DATEPICKER3_CAPTION, rdpClassNames.caption),
        ref: containerElement
    }, hiddenCaptionLabel, prevButton, orderedSelects, nextButton);
};
DatePicker3Caption.displayName = "".concat((0, _core.DISPLAYNAME_PREFIX), ".DatePicker3Caption");

},{"classnames":"5Een2","react":"9njXz","react-day-picker":"58IhA","react-innertext":"7jHuF","@blueprintjs/core":"6Mq52","@blueprintjs/datetime":"g4aa7","@blueprintjs/icons":"bO9O5","../../classes":"dstkC","../../common/useMonthSelectRightOffset":"2n9XY","../date-picker3/datePicker3Context":"8j1DF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7jHuF":[function(require,module,exports,__globalThis) {
"use strict";
var hasProps = function(jsx) {
    return Object.prototype.hasOwnProperty.call(jsx, 'props');
};
var reduceJsxToString = function(previous, current) {
    return previous + innerText(current);
};
var innerText = function(jsx) {
    if (jsx === null || typeof jsx === 'boolean' || typeof jsx === 'undefined') return '';
    if (typeof jsx === 'number') return jsx.toString();
    if (typeof jsx === 'string') return jsx;
    if (Array.isArray(jsx)) return jsx.reduce(reduceJsxToString, '');
    if (hasProps(jsx) && Object.prototype.hasOwnProperty.call(jsx.props, 'children')) return innerText(jsx.props.children);
    return '';
};
innerText.default = innerText;
module.exports = innerText;

},{}],"le6CO":[function(require,module,exports,__globalThis) {
/* !
 * (c) Copyright 2024 Palantir Technologies Inc. All rights reserved.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTodayAtMidnight", ()=>getTodayAtMidnight);
parcelHelpers.export(exports, "shiftDateByDays", ()=>shiftDateByDays);
parcelHelpers.export(exports, "shiftDateByWeeks", ()=>shiftDateByWeeks);
parcelHelpers.export(exports, "shiftDateByArrowKey", ()=>shiftDateByArrowKey);
parcelHelpers.export(exports, "clampDate", ()=>clampDate);
parcelHelpers.export(exports, "isEntireInputSelected", ()=>isEntireInputSelected);
var DAY_IN_MILLIS = 86400000;
var WEEK_IN_MILLIS = 7 * DAY_IN_MILLIS;
function getTodayAtMidnight() {
    return new Date(new Date().setHours(0, 0, 0, 0));
}
function shiftDateByDays(date, days) {
    return new Date(date.valueOf() + days * DAY_IN_MILLIS);
}
function shiftDateByWeeks(date, weeks) {
    return new Date(date.valueOf() + weeks * WEEK_IN_MILLIS);
}
function shiftDateByArrowKey(date, key) {
    switch(key){
        case "ArrowUp":
            return shiftDateByWeeks(date, -1);
        case "ArrowDown":
            return shiftDateByWeeks(date, 1);
        case "ArrowLeft":
            return shiftDateByDays(date, -1);
        case "ArrowRight":
            return shiftDateByDays(date, 1);
        default:
            return date;
    }
}
function clampDate(date, minDate, maxDate) {
    var result = date;
    if (minDate != null && date < minDate) result = minDate;
    if (maxDate != null && date > maxDate) result = maxDate;
    return result;
}
function isEntireInputSelected(element) {
    if (element == null) return false;
    return element.selectionStart === 0 && element.selectionEnd === element.value.length;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a8Yu8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _editReservationCustomerDialog = require("./EditReservationCustomerDialog");
var _editReservationCustomerDialogDefault = parcelHelpers.interopDefault(_editReservationCustomerDialog);
var _selectCustomerDialog = require("./SelectCustomerDialog");
var _selectCustomerDialogDefault = parcelHelpers.interopDefault(_selectCustomerDialog);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _dateTimePickerDialog = require("../DateTimePickerDialog");
var _dateTimePickerDialogDefault = parcelHelpers.interopDefault(_dateTimePickerDialog);
var _invoiceDialog = require("./InvoiceDialog");
var _invoiceDialogDefault = parcelHelpers.interopDefault(_invoiceDialog);
var _customerSelect = require("../CustomerSelect");
var _customerSelectDefault = parcelHelpers.interopDefault(_customerSelect);
var _editInvoiceDialog = require("../business/EditInvoiceDialog");
var _editInvoiceDialogDefault = parcelHelpers.interopDefault(_editInvoiceDialog);
var _waitFiscalVerificationDialog = require("../business/WaitFiscalVerificationDialog");
var _waitFiscalVerificationDialogDefault = parcelHelpers.interopDefault(_waitFiscalVerificationDialog);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _codeTables = require("../../api/CodeTables");
var _appToaster = require("../AppToaster");
var _businessSlice = require("../../slices/BusinessSlice");
var _business = require("../../api/Business");
var _documentSlice = require("../../slices/DocumentSlice");
var _documents = require("../../api/Documents");
var _documents1 = require("../Documents");
var _documentsDefault = parcelHelpers.interopDefault(_documents1);
var _reservations = require("../../api/Reservations");
var _guests = require("../../api/Guests");
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _invoiceCreator = require("../../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _documentsHelper = require("../../helpers/DocumentsHelper");
var _documentsHelperDefault = parcelHelpers.interopDefault(_documentsHelper);
var _reservationHelper = require("../../helpers/ReservationHelper");
var _reservationHelperDefault = parcelHelpers.interopDefault(_reservationHelper);
var _documentListDialog = require("../DocumentListDialog");
var _documentListDialogDefault = parcelHelpers.interopDefault(_documentListDialog);
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _addEditItemWithCountDialog = require("./AddEditItemWithCountDialog");
var _addEditItemWithCountDialogDefault = parcelHelpers.interopDefault(_addEditItemWithCountDialog);
var _numbers = require("../../numbers");
var _peopleCountInput = require("./PeopleCountInput");
var _peopleCountInputDefault = parcelHelpers.interopDefault(_peopleCountInput);
var _reservationSlice = require("../../slices/ReservationSlice");
var _guestSlice = require("../../slices/GuestSlice");
var _appSlice = require("../../slices/AppSlice");
var _utils = require("../../utils");
function ReservationGuests(props) {
    const { main_table_items, main_table_items_sort_ids, main_table_items_sort_field, main_table_items_sort_direction, main_table_items_checked, customers, countries, guest_book_items, guest_book_items_state, openDateTimePickerDialog, openInvoiceDialog, onCheckedItem, setMainTableItemsSort, editItem, deleteItem, documents, invoices, openEditInvoiceDialog, openDocumentListDialog, getAge, display_copy_guest_to_reservation_customer, copyGuestToReservationCustomer } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "reservation-guests-table mt-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "reservation-guests-table-header-col col-1",
                style: {
                    gridColumn: '1'
                },
                children: "\xa0"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "reservation-guests-table-header-col col-2",
                style: {
                    gridColumn: '2'
                },
                children: "Urejanje"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "reservation-guests-table-header-col col-3",
                style: {
                    gridColumn: '3'
                },
                onClick: ()=>{
                    setMainTableItemsSort('surname');
                },
                children: [
                    "Priimek",
                    main_table_items_sort_field != 'surname' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                        icon: 'caret-' + (main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                        color: "#888888"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "reservation-guests-table-header-col col-4",
                style: {
                    gridColumn: '4'
                },
                onClick: ()=>{
                    setMainTableItemsSort('name');
                },
                children: [
                    "Ime",
                    main_table_items_sort_field != 'name' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                        icon: 'caret-' + (main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                        color: "#888888"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "reservation-guests-table-header-col col-5",
                style: {
                    gridColumn: '5'
                },
                children: "Datum rojstva"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "reservation-guests-table-header-col col-6",
                style: {
                    gridColumn: '6'
                },
                children: "Dr\u017Eava"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "reservation-guests-table-header-col col-7",
                style: {
                    gridColumn: '7'
                },
                onClick: ()=>{
                    setMainTableItemsSort('check_in');
                },
                children: [
                    "Prijava",
                    main_table_items_sort_field != 'check_in' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                        icon: 'caret-' + (main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                        color: "#888888"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "reservation-guests-table-header-col col-8",
                style: {
                    gridColumn: '8'
                },
                onClick: ()=>{
                    setMainTableItemsSort('check_out');
                },
                children: [
                    "Odjava",
                    main_table_items_sort_field != 'check_out' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                        icon: 'caret-' + (main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                        color: "#888888"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "reservation-guests-table-header-col col-9",
                style: {
                    gridColumn: '9'
                },
                children: "\u0160tevilka ra\u010Duna"
            }),
            main_table_items_sort_ids.map((id, idx)=>{
                const item = main_table_items[id];
                if (item === undefined) return null;
                const birth_date = customers[item.id_customer] === undefined ? new Date() : new Date(customers[item.id_customer].birth_date);
                let etourism_status_color = '#cccccc';
                let etourism_status_title = 'NEPOSLAN';
                const guest_book_item = item.id_guest_book === null || item.id_guest_book === undefined ? null : guest_book_items_state[item.id_guest_book] || guest_book_items[item.id_guest_book] || null;
                if (guest_book_item !== undefined && guest_book_item !== null) {
                    if (guest_book_item.zst !== null) switch(guest_book_item.etourism_status){
                        case 'waiting':
                            etourism_status_color = 'orange';
                            etourism_status_title = "\u010CAKA NA PO\u0160ILJANJE";
                            break;
                        case 'success':
                            etourism_status_color = 'green';
                            etourism_status_title = "POSLANO USPE\u0160NO";
                            break;
                        case 'failure':
                            etourism_status_color = 'red';
                            etourism_status_title = "NAPAKA PRI PO\u0160ILJANJU";
                            break;
                    }
                }
                const etourism_tooltip_content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                "Stanje: ",
                                etourism_status_title
                            ]
                        }),
                        guest_book_item === null || guest_book_item.log === null || guest_book_item.log.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mt-6 mb-1",
                                    children: "Dnevnik dogodkov:"
                                }),
                                [
                                    ...guest_book_item.log
                                ].sort((log_item_a, log_item_b)=>log_item_a.created.localeCompare(log_item_b.created) * -1).map((guest_book_log)=>{
                                    let status_title = 'neznano';
                                    switch(guest_book_log.status){
                                        case 'success':
                                            status_title = "POSLANO USPE\u0160NO";
                                            break;
                                        case 'failure':
                                            status_title = "NAPAKA PRI PO\u0160ILJANJU";
                                            break;
                                    }
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            maxWidth: 480,
                                            marginBottom: '1rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex flex-row justify-between mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "mr-12",
                                                        children: status_title
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: new Date(guest_book_log.created).toLocaleString('sl-SI')
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: JSON.parse(guest_book_log.message).map((message_item)=>message_item.error_message).join(', ')
                                            })
                                        ]
                                    }, 'guest-book-log-' + guest_book_log.id_guest_book_log);
                                })
                            ]
                        })
                    ]
                });
                const reservation_customer_documents = Object.values(documents[item.id_reservation_customer] || {}).filter((document1)=>document1.document_type == 'invoice' || document1.document_type == 'cash-invoice');
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "reservation-guests-table-col col-1",
                            style: {
                                gridColumn: '1',
                                gridRow: idx + 2
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: main_table_items_checked.indexOf(item.id_reservation_customer) != -1,
                                onChange: (event)=>{
                                    onCheckedItem(item.id_reservation_customer, event.target.checked);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "reservation-guests-table-col col-2 flex flex-row items-center",
                            style: {
                                gridColumn: '2',
                                gridRow: idx + 2
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "edit",
                                    intent: "primary",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>{
                                        editItem(item.id_reservation_customer);
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "trash",
                                    intent: "danger",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>{
                                        deleteItem(item.id_reservation_customer);
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                    content: etourism_tooltip_content,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                        icon: item.checked_out === false ? 'upload' : 'tick',
                                        className: "ml-1",
                                        color: etourism_status_color
                                    })
                                }),
                                !display_copy_guest_to_reservation_customer ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                    content: "Prepi\u0161i v nosilca",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "follower",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>{
                                            copyGuestToReservationCustomer(item.id_customer);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "reservation-guests-table-col col-3",
                            style: {
                                gridColumn: '3',
                                gridRow: idx + 2
                            },
                            children: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].surname
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "reservation-guests-table-col col-4",
                            style: {
                                gridColumn: '4',
                                gridRow: idx + 2
                            },
                            children: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "reservation-guests-table-col col-5",
                            style: {
                                gridColumn: '5',
                                gridRow: idx + 2
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "mr-2",
                                    children: (0, _momentDefault.default)(birth_date).format('DD.MM.YYYY')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: '(' + getAge(birth_date) + ' let)'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "reservation-guests-table-col col-6",
                            style: {
                                gridColumn: '6',
                                gridRow: idx + 2
                            },
                            children: customers[item.id_customer] === undefined ? '' : countries[customers[item.id_customer].id_country].official_name_local
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "reservation-guests-table-col col-7",
                            style: {
                                gridColumn: '7',
                                gridRow: idx + 2
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                small: true,
                                className: 'cell-button',
                                onClick: ()=>{
                                    openDateTimePickerDialog([
                                        id,
                                        'check_in'
                                    ]);
                                },
                                children: [
                                    item.check_in === null ? '' : new Date(item.check_in).toLocaleString('sl-SI', {
                                        year: 'numeric',
                                        month: 'numeric',
                                        day: 'numeric'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "mr-2"
                                    }),
                                    item.check_in === null ? '' : new Date(item.check_in).toLocaleString('sl-SI', {
                                        hour: 'numeric',
                                        minute: 'numeric'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "reservation-guests-table-col col-8",
                            style: {
                                gridColumn: '8',
                                gridRow: idx + 2
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                small: true,
                                className: 'cell-button',
                                onClick: ()=>{
                                    openDateTimePickerDialog([
                                        id,
                                        'check_out'
                                    ]);
                                },
                                children: [
                                    item.check_out === null ? '' : new Date(item.check_out).toLocaleString('sl-SI', {
                                        year: 'numeric',
                                        month: 'numeric',
                                        day: 'numeric'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "mr-2"
                                    }),
                                    item.check_out === null ? '' : new Date(item.check_out).toLocaleString('sl-SI', {
                                        hour: 'numeric',
                                        minute: 'numeric'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "reservation-guests-table-col col-9",
                            style: {
                                gridColumn: '9',
                                gridRow: idx + 2
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: item.invoice_paid ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                item.invoice_paid_on.toLocaleString('sl-SI', {
                                                    year: 'numeric',
                                                    month: 'numeric',
                                                    day: 'numeric'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "ml-2 font-bold",
                                                    children: "#12345"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            icon: "euro",
                                            intent: "success",
                                            minimal: true,
                                            small: true,
                                            onClick: ()=>openInvoiceDialog([
                                                    item.id_reservation_customer
                                                ])
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                reservation_customer_documents.length == 0 ? null : invoices[reservation_customer_documents[0].id_document] === undefined ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "[manjka]"
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    small: true,
                                                    className: "cell-button",
                                                    onClick: ()=>{
                                                        openEditInvoiceDialog(invoices[reservation_customer_documents[0].id_document].invoice_type, invoices[reservation_customer_documents[0].id_document], [], []);
                                                    },
                                                    children: invoices[reservation_customer_documents[0].id_document].invoice_number_internal
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    small: true,
                                                    className: "cell-button ml-1",
                                                    onClick: ()=>openDocumentListDialog(item.id_reservation_customer, 'reservation-customer'),
                                                    icon: "multi-select"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }, 'reservation-guests-' + item.id_reservation_customer);
            })
        ]
    });
}
class Reservation extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.loading = 0;
        this.phone_input_ref = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        this.openEditReservationCustomerDialog = this.openEditReservationCustomerDialog.bind(this);
        this.closeEditReservationCustomerDialog = this.closeEditReservationCustomerDialog.bind(this);
        this.openSelectCustomerDialog = this.openSelectCustomerDialog.bind(this);
        this.closeSelectCustomerDialog = this.closeSelectCustomerDialog.bind(this);
        this.openInvoiceDialog = this.openInvoiceDialog.bind(this);
        this.closeInvoiceDialog = this.closeInvoiceDialog.bind(this);
        this.openDateTimePickerDialog = this.openDateTimePickerDialog.bind(this);
        this.closeDateTimePickerDialog = this.closeDateTimePickerDialog.bind(this);
        this.getDateFromStateByName = this.getDateFromStateByName.bind(this);
        this.setMainTableItemChecked = this.setMainTableItemChecked.bind(this);
        this.setMainTableItemsChecked = this.setMainTableItemsChecked.bind(this);
        this.setMainTableItemsSort = this.setMainTableItemsSort.bind(this);
        this.openEditInvoiceDialog = this.openEditInvoiceDialog.bind(this);
        this.closeEditInvoiceDialog = this.closeEditInvoiceDialog.bind(this);
        this.deleteMainTableItem = this.deleteMainTableItem.bind(this);
        this.calculateReservationPrice = this.calculateReservationPrice.bind(this);
        this.validate = this.validate.bind(this);
        this.addAndSaveDocumentAssociation = this.addAndSaveDocumentAssociation.bind(this);
        this.openOfferDialog = this.openOfferDialog.bind(this);
        this.increaseLoading = this.increaseLoading.bind(this);
        this.decreaseLoading = this.decreaseLoading.bind(this);
        this.saveReservation = this.saveReservation.bind(this);
        this.openDocumentListDialog = this.openDocumentListDialog.bind(this);
        this.closeDocumentListDialog = this.closeDocumentListDialog.bind(this);
        this.copyGuestToReservationCustomer = this.copyGuestToReservationCustomer.bind(this);
        this.startDateRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        this.addPersonRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        let reservation_customers = {};
        if (this.props.reservation !== null) reservation_customers = this.props.reservation_customers_by_id_reservations[this.props.reservation.id_reservation] || {};
        const reservation_items = {};
        if (this.props.reservation !== null) {
            for(let key in this.props.accommodation_item_place_items)if (this.props.accommodation_item_place_items[key].id_accommodation_item_place == this.props.reservation.id_accommodation_item_place) reservation_items[key] = this.props.accommodation_item_place_items[key];
        }
        const id_customer = this.props.reservation === null ? null : this.props.reservation.id_customer;
        const customer = id_customer === null || id_customer == -1 ? null : this.props.customers[id_customer];
        const open_id_reservation_customer = this.props.open_id_reservation_customer !== undefined && this.props.open_id_reservation_customer !== null ? this.props.open_id_reservation_customer : null;
        const reservation_customers_ids = Object.keys(reservation_customers);
        this.state = {
            reservation: this.props.reservation,
            check_in: this.props.reservation === null || this.props.reservation.check_in === null ? null : new Date(this.props.reservation.check_in),
            check_out: this.props.reservation === null || this.props.reservation.check_out === null ? null : new Date(this.props.reservation.check_out),
            id_customer,
            phone: customer === null ? '' : customer.phone,
            email: customer === null ? '' : customer.email,
            note: this.props.reservation.note || '',
            id_channel: this.props.reservation.id_channel || -1,
            id_market_segmentation: this.props.reservation.id_market_segmentation || -1,
            id_accommodation_item_place: this.props.reservation.id_accommodation_item_place || -1,
            guest_adult_count: this.props.reservation.guest_adult_count || 0,
            guest_child_1_count: this.props.reservation.guest_child_1_count || 0,
            guest_child_2_count: this.props.reservation.guest_child_2_count || 0,
            custom_status: this.props.reservation.custom_status || '',
            internal_code: this.props.reservation.internal_code || '',
            status: this.props.reservation.status || '',
            status_2: this.props.reservation.status_2 || null,
            deleted: this.props.reservation.deleted,
            guests_checked_in: this.props.reservation.guests_checked_in ?? false,
            main_table_items_changed: false,
            main_table_items: reservation_customers,
            main_table_items_sort_ids: Object.values(reservation_customers).sort((a, b)=>a.ord - b.ord).map((item)=>item.id_reservation_customer),
            main_table_items_sort_field: '',
            main_table_items_sort_direction: 'ASC',
            main_table_items_checked: [],
            reservation_items: Object.values(reservation_items).map((reservation_item)=>{
                let selected = false;
                for(let key in this.props.reservation.items)if (this.props.reservation.items[key].id_item == reservation_item.id_item) {
                    selected = true;
                    break;
                }
                // preselect items on new reservations
                if (this.props.reservation.id_reservation == -1) selected = reservation_item.mandatory || reservation_item.preselected;
                return {
                    item: this.props.items[reservation_item.id_item],
                    age_from: reservation_item.age_from,
                    age_until: reservation_item.age_until,
                    calculation_type: reservation_item.calculation_type,
                    mandatory: reservation_item.mandatory,
                    preselected: reservation_item.preselected,
                    enable_short_term_surcharge: reservation_item.enable_short_term_surcharge,
                    selected
                };
            }),
            edit_reservation_customer_dialog_open: open_id_reservation_customer !== null,
            edit_reservation_customer_dialog_item: open_id_reservation_customer === null ? null : reservation_customers[open_id_reservation_customer],
            select_customer_dialog_open: false,
            select_customer_dialog_name: '',
            select_customer_dialog_surname: '',
            select_customer_dialog_email: '',
            select_customer_dialog_id_country: '',
            select_customer_dialog_phone: '',
            select_customer_dialog_post_office: '',
            select_customer_dialog_address: '',
            select_customer_dialog_item: null,
            invoice_dialog_open: false,
            invoice_dialog_preselect: null,
            invoice_dialog_calculated_state: null,
            invoice_dialog_advance_invoices: [],
            invoice_dialog_id_customer: null,
            invoice_dialog_id_reservation_customers: null,
            date_picker_dialog_open: false,
            date_picker_dialog_state_name: null,
            delete_requested: false,
            status_change_requested: false,
            status_change_requested_value: '',
            create_invoice_dialog_open: false,
            create_invoice_dialog_item: null,
            create_invoice_dialog_type: '',
            create_invoice_dialog_selected_advance_invoices_amounts: {},
            create_invoice_dialog_id_reservation_customers: [],
            copy_customer_to_guest: false,
            validation_failed_fields: [],
            close_dialog_save_item: false,
            close_dialog_confirm_open: false,
            additional_info_tab_id: 'comment',
            delete_confirm_dialog_open: false,
            delete_confirm_dialog_id_reservation_customer: null,
            guest_book_items: {},
            loading: 0,
            error_message: null,
            document_list_dialog_open: false,
            document_list_dialog_id_document: null,
            document_list_dialog_document_type: null,
            wait_fiscal_verification_dialog_open: false,
            wait_fiscal_verification_dialog_id_invoice: null,
            add_edit_item_with_count_dialog_visible: false,
            add_edit_item_with_count_dialog_id_reservation_customer: null,
            add_edit_item_with_count_dialog_quantity: 0,
            add_edit_item_with_count_dialog_id_item: null,
            customer_items: Object.values(props.reservation_customer_items)// only select items for customers on this reservation
            .filter((x)=>reservation_customers_ids.indexOf(x.id_reservation_customer) != -1)// make copies to allow changing them
            .map((x)=>{
                return {
                    ...x
                };
            }),
            customer_items_customers_selected: [],
            delete_request__id_reservation_customer: null,
            delete_request__id_item: null
        };
        if (props.initial_customer_query !== null && props.initial_customer_query !== undefined) this.state = {
            ...this.state,
            ...this.openSelectCustomerDialog(props.initial_customer_query, null, true)
        };
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    getMaxDate() {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 10);
        return date;
    }
    openEditReservationCustomerDialog(item) {
        this.setState({
            edit_reservation_customer_dialog_open: true,
            edit_reservation_customer_dialog_item: item
        });
    }
    openSelectCustomerDialog(query, item, only_return) {
        item = item || null;
        const new_state = {
            select_customer_dialog_open: true,
            select_customer_dialog_name: query.name,
            select_customer_dialog_surname: query.surname,
            select_customer_dialog_email: query.email,
            select_customer_dialog_id_country: query.id_country,
            select_customer_dialog_phone: query.phone,
            select_customer_dialog_post_office: query.post_office,
            select_customer_dialog_address: query.address,
            select_customer_dialog_item: item
        };
        if (only_return) return new_state;
        this.setState(new_state);
    }
    openReservationDialog() {
        this.setState({
            reservation_dialog_open: true
        });
    }
    openInvoiceDialog(id_reservation_customers, additional_items_id_reservation_customers) {
        const specific_customers = id_reservation_customers !== undefined;
        if (id_reservation_customers === undefined) {
            id_reservation_customers = Object.keys(this.state.main_table_items);
            if (id_reservation_customers.length == 0) {
                (0, _appToaster.AppToaster).show({
                    message: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: "Na rezervaciji mora biti vsaj ena oseba"
                    }),
                    intent: 'danger',
                    icon: 'issue'
                });
                return;
            }
        }
        if (additional_items_id_reservation_customers === undefined) additional_items_id_reservation_customers = this.state.customer_items.map((item)=>item.id_reservation_customer);
        if (id_reservation_customers.length == 0) {
            (0, _appToaster.AppToaster).show({
                message: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: "Izbrana mora biti vsaj ena oseba"
                }),
                intent: 'danger',
                icon: 'issue'
            });
            return;
        }
        const invoice_dialog_id_customer = specific_customers && id_reservation_customers.length == 1 ? this.state.main_table_items[id_reservation_customers[0]].id_customer : this.state.id_customer;
        const advance_invoices = {};
        if (this.state.reservation !== null && this.state.reservation !== undefined) {
            const documents = Object.values((0, _documentsHelperDefault.default).GetDocuments(this.props.document_associations, this.state.reservation.id_reservation, 1));
            for(let i = 0; i < documents.length; i++){
                if (documents[i].document_type == 'prepayment-invoice') {
                    const invoice = this.props.invoices[documents[i].id_document];
                    if (invoice !== undefined && parseFloat(invoice.used_advance_payment_amount) < parseFloat(invoice.advance_payment_amount)) {
                        if (advance_invoices[invoice.id_invoice] === undefined) advance_invoices[invoice.id_invoice] = invoice;
                    }
                } else if (documents[i].document_type == 'offer') {
                    const subdocuments = Object.values((0, _documentsHelperDefault.default).GetDocuments(this.props.document_associations, documents[i].id_document, 1));
                    for(let i = 0; i < subdocuments.length; i++)if (subdocuments[i].document_type == 'prepayment-invoice') {
                        const invoice = this.props.invoices[subdocuments[i].id_document];
                        if (invoice !== undefined && parseFloat(invoice.used_advance_payment_amount) < parseFloat(invoice.advance_payment_amount)) {
                            if (advance_invoices[invoice.id_invoice] === undefined) advance_invoices[invoice.id_invoice] = invoice;
                        }
                    }
                }
            }
        }
        this.setState({
            invoice_dialog_open: true,
            invoice_dialog_preselect: true,
            invoice_dialog_calculated_state: this.calculateReservationPrice(id_reservation_customers, additional_items_id_reservation_customers),
            invoice_dialog_advance_invoices: Object.values(advance_invoices),
            invoice_dialog_id_customer,
            invoice_dialog_id_reservation_customers: id_reservation_customers
        });
    }
    openDateTimePickerDialog(state_name) {
        this.setState({
            date_picker_dialog_open: true,
            date_picker_dialog_state_name: state_name
        });
    }
    async closeEditReservationCustomerDialog(item, reopen) {
        this.setState({
            edit_reservation_customer_dialog_open: false,
            edit_reservation_customer_dialog_item: null
        });
        if (reopen) setTimeout(()=>{
            if (!this._ismounted) return;
            this.openEditReservationCustomerDialog(null);
        }, 1000);
        if (item !== undefined) {
            let id_customer = item.id_customer;
            let new_customer;
            let changed_for_etourism = false;
            if (id_customer == -1) {
                id_customer = (0, _uuidDefault.default).v4();
                new_customer = {
                    id_customer: id_customer,
                    type: 'natural',
                    name: item.name,
                    surname: item.surname,
                    company_name: '',
                    company_long_name: '',
                    address: '',
                    id_country: item.id_country,
                    post_code: '',
                    post_office: '',
                    tax_number: '',
                    vat_registered: false,
                    vat_prefix: '',
                    phone: '',
                    email: '',
                    sex: item.sex,
                    birth_date: item.birthdate === null ? null : this.toIsoString(item.birthdate),
                    supplier: false,
                    due_day_count: 0,
                    display_company_long_name_on_invoices: false,
                    identification_number: item.identification_number,
                    id_identification_type: item.id_identification_type,
                    delivery_addresses: []
                };
            } else {
                const existing_customer = this.props.customers[id_customer];
                new_customer = {
                    ...existing_customer
                };
                new_customer.name = item.name;
                new_customer.surname = item.surname;
                new_customer.id_country = item.id_country;
                new_customer.sex = item.sex;
                new_customer.birth_date = item.birthdate === null ? null : this.toIsoString(item.birthdate);
                new_customer.identification_number = item.identification_number;
                new_customer.id_identification_type = item.id_identification_type;
                changed_for_etourism = existing_customer.name != new_customer.name || existing_customer.surname != new_customer.surname || existing_customer.id_country != new_customer.id_country || existing_customer.sex != new_customer.sex || existing_customer.birth_date != new_customer.birth_date || existing_customer.identification_number != new_customer.identification_number || existing_customer.id_identification_type != new_customer.id_identification_type;
            }
            this.props.dispatch((0, _codeTablesSlice.addCustomer)({
                item: new_customer,
                token: this.props.token
            }));
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            this.increaseLoading();
            const new_item = await (0, _codeTables.saveCodeTableItem)(this.props.api_url, 'customers', new_customer, token);
            if (new_item !== null) {
                this.decreaseLoading();
                dispatch((0, _codeTablesSlice.addCustomer)({
                    item: new_item,
                    token
                }));
            }
            const main_table_items = {
                ...this.state.main_table_items
            };
            const main_table_items_sort_ids = this.state.main_table_items_sort_ids;
            let guest_book_items = this.state.guest_book_items;
            if (item.id_reservation_customer != -1) {
                const existing_reservation_customer = this.state.main_table_items[item.id_reservation_customer];
                const reservation_customer = {
                    ...existing_reservation_customer
                };
                reservation_customer.check_in = this.toIsoStringWithTime(item.check_in);
                reservation_customer.check_out = this.toIsoStringWithTime(item.check_out);
                reservation_customer.id_customer = id_customer;
                reservation_customer.identification_number = item.identification_number;
                reservation_customer.id_group = item.id_group;
                reservation_customer.pay_tourist_tax = item.tourist_tax_checked;
                reservation_customer.add_to_guest_book = item.e_tourist_checked;
                reservation_customer.agree_to_further_processing = item.agree_further_processing;
                reservation_customer.id_tourist_tax = item.id_tourist_tax;
                reservation_customer.id_identification_type = item.id_identification_type;
                main_table_items[item.id_reservation_customer] = reservation_customer;
                if (reservation_customer.id_guest_book !== null) {
                    changed_for_etourism = changed_for_etourism || reservation_customer.check_in != existing_reservation_customer.check_in || reservation_customer.check_out != existing_reservation_customer.check_out || reservation_customer.identification_number != existing_reservation_customer.identification_number || reservation_customer.id_tourist_tax != existing_reservation_customer.id_tourist_tax || reservation_customer.id_identification_type != existing_reservation_customer.id_identification_type;
                    if (changed_for_etourism) {
                        guest_book_items = {
                            ...this.state.guest_book_items
                        };
                        const guest_book_item = {
                            ...guest_book_items[reservation_customer.id_guest_book] || this.props.guest_book_items[reservation_customer.id_guest_book]
                        };
                        guest_book_item.etourism_status = 'waiting';
                        guest_book_items[reservation_customer.id_guest_book] = guest_book_item;
                    }
                }
            } else {
                let max_ord = 0;
                for(let id_reservation_customer in main_table_items)max_ord = Math.max(max_ord, main_table_items[id_reservation_customer].ord);
                const reservation_customer = {
                    id_reservation_customer: (0, _uuidDefault.default).v4(),
                    id_reservation: -1,
                    id_customer: id_customer,
                    check_in: this.toIsoStringWithTime(item.check_in),
                    check_out: this.toIsoStringWithTime(item.check_out),
                    invoice_paid: false,
                    invoice_paid_on: null,
                    identification_number: item.identification_number,
                    id_group: item.id_group,
                    pay_tourist_tax: item.tourist_tax_checked,
                    add_to_guest_book: item.e_tourist_checked,
                    agree_to_further_processing: item.agree_further_processing,
                    id_tourist_tax: item.id_tourist_tax,
                    id_identification_type: item.id_identification_type,
                    checked_out: false,
                    ord: max_ord + 1
                };
                main_table_items[reservation_customer.id_reservation_customer] = reservation_customer;
                main_table_items_sort_ids.push(reservation_customer.id_reservation_customer);
            }
            this.setState({
                main_table_items_changed: true,
                main_table_items,
                main_table_items_sort_ids,
                guest_book_items
            });
        }
    }
    closeSelectCustomerDialog(id_customer, new_customer) {
        const state = {
            select_customer_dialog_open: false
        };
        if (id_customer !== undefined) {
            state.id_customer = id_customer;
            state.phone = new_customer.phone;
            state.email = new_customer.email;
        }
        this.setState(state);
    }
    closeReservationDialog() {
        this.setState({
            reservation_dialog_open: false
        });
    }
    openOfferDialog() {
        const accommodation_item_place = this.props.accommodation_item_places[this.state.reservation.id_accommodation_item_place];
        const accommodation_item = this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
        let reservation_title = '';
        if (accommodation_item.title != 'default') reservation_title += accommodation_item.title + " \u2192 ";
        reservation_title += accommodation_item_place.title;
        const calculated_state = this.calculateReservationPrice(undefined, undefined, false);
        const items = calculated_state.items;
        const new_item = (0, _invoiceCreatorDefault.default).CreateInvoiceFromInitialData({
            id_invoice: (0, _uuidDefault.default).v4(),
            reverse_invoice: false,
            id_customer: this.state.id_customer,
            invoice_date: (0, _momentDefault.default)().toISOString(true),
            invoice_type: 'offer',
            reservation: reservation_title,
            service_date_end: this.state.check_out === null ? null : (0, _momentDefault.default)(this.state.check_out).toISOString(true),
            service_date_start: this.state.check_in === null ? null : (0, _momentDefault.default)(this.state.check_in).toISOString(true),
            items: items.map((item_item, idx)=>{
                const item = this.props.items[item_item.id_item];
                const measuring_unit = this.props.measuring_units[item.id_measuring_unit];
                const item_price_list = item.price_lists[item.id_item_price_list];
                const tax_rate = item_price_list === undefined ? null : this.props.tax_rates[item_price_list.id_tax_rate];
                return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                    id_invoice_item: (0, _uuidDefault.default).v4(),
                    description: item_item.id_tourist_tax === undefined ? item.description : this.props.tourist_taxes[item_item.id_tourist_tax].title,
                    id_item: item_item.id_item,
                    id_item_price_list: item_item.id_item_price_list,
                    id_tax_rate: item_price_list === undefined ? null : item_price_list.id_tax_rate,
                    item_measuring_unit_code: measuring_unit.title,
                    item_measuring_unit_decimal_digit_count: measuring_unit.decimal_digit_count,
                    price: item_item.single_price,
                    quantity: item_item.quantity,
                    tax_rate,
                    item_type: item.type,
                    item_ean: item.ean,
                    item_title: item.title,
                    ord: idx,
                    id_warehouse: item.item_type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === null ? null : this.props.cash_registers[this.props.current_id_cash_register], this.props.warehouses)
                });
            })
        });
        this.openEditInvoiceDialog('offer', new_item, {}, []);
    }
    closeInvoiceDialog(type, items, id_customer, selected_advance_invoices_amounts) {
        const id_reservation_customers = this.state.invoice_dialog_id_reservation_customers === null || this.state.invoice_dialog_id_reservation_customers === undefined || this.state.invoice_dialog_id_reservation_customers.length === 0 ? Object.keys(this.state.main_table_items) : this.state.invoice_dialog_id_reservation_customers;
        this.setState({
            invoice_dialog_open: false,
            invoice_dialog_preselect: null,
            invoice_dialog_calculated_state: null,
            invoice_dialog_id_customer: null,
            invoice_dialog_id_reservation_customers: null
        });
        if (type !== undefined) {
            const accommodation_item_place = this.props.accommodation_item_places[this.state.reservation.id_accommodation_item_place];
            const accommodation_item = this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
            if (this.state.id_customer === null || this.state.id_customer == -1) return;
            let reservation_title = '';
            if (accommodation_item.title != 'default') reservation_title += accommodation_item.title + " \u2192 ";
            reservation_title += accommodation_item_place.title;
            const advance_payment_amount = Object.values(selected_advance_invoices_amounts).reduce((curr_value, item_val)=>curr_value + item_val, 0);
            const new_item = (0, _invoiceCreatorDefault.default).CreateInvoiceFromInitialData({
                id_invoice: (0, _uuidDefault.default).v4(),
                reverse_invoice: false,
                id_customer: id_customer,
                invoice_date: (0, _momentDefault.default)().toISOString(true),
                invoice_type: type,
                reservation: reservation_title,
                service_date_end: this.state.check_out === null ? null : (0, _momentDefault.default)(this.state.check_out).toISOString(true),
                service_date_start: this.state.check_in === null ? null : (0, _momentDefault.default)(this.state.check_in).toISOString(true),
                advance_payment_amount,
                items: items.map((item_item, idx)=>{
                    const item = this.props.items[item_item.id_item];
                    const measuring_unit = this.props.measuring_units[item.id_measuring_unit];
                    const item_price_list = item.price_lists[item.id_item_price_list];
                    const tax_rate = item_price_list === undefined ? null : this.props.tax_rates[item_price_list.id_tax_rate];
                    return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                        id_invoice_item: (0, _uuidDefault.default).v4(),
                        description: item_item.id_tourist_tax === undefined ? item.description : this.props.tourist_taxes[item_item.id_tourist_tax].title,
                        id_item: item_item.id_item,
                        id_item_price_list: item_item.id_item_price_list,
                        id_tax_rate: item_price_list === undefined ? null : item_price_list.id_tax_rate,
                        item_measuring_unit_code: measuring_unit.title,
                        item_measuring_unit_decimal_digit_count: measuring_unit.decimal_digit_count,
                        price: item_item.single_price,
                        quantity: item_item.quantity,
                        tax_rate,
                        item_type: item.type,
                        item_ean: item.ean,
                        item_title: item.title,
                        ord: idx,
                        id_warehouse: item.item_type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === null ? null : this.props.cash_registers[this.props.current_id_cash_register], this.props.warehouses)
                    });
                })
            });
            this.openEditInvoiceDialog(type, new_item, selected_advance_invoices_amounts, id_reservation_customers);
        }
    }
    closeDateTimePickerDialog(newValue) {
        this.setState({
            date_picker_dialog_open: false
        });
        if (newValue instanceof Date) {
            const obj = {
                main_table_items_changed: true
            };
            if (Array.isArray(this.state.date_picker_dialog_state_name)) {
                if (this.state.date_picker_dialog_state_name.length == 2) {
                    const main_table_items = {
                        ...this.state.main_table_items
                    };
                    const guest_book_items = {
                        ...this.state.guest_book_items
                    };
                    const id_reservation_customer = this.state.date_picker_dialog_state_name[0];
                    const property_name = this.state.date_picker_dialog_state_name[1];
                    const reservation_customer = {
                        ...this.state.main_table_items[id_reservation_customer]
                    };
                    reservation_customer[property_name] = this.toIsoStringWithTime(newValue);
                    main_table_items[reservation_customer.id_reservation_customer] = reservation_customer;
                    if (reservation_customer.id_guest_book !== null) {
                        const guest_book_item = {
                            ...guest_book_items[reservation_customer.id_guest_book] || this.props.guest_book_items[reservation_customer.id_guest_book]
                        };
                        guest_book_item.etourism_status = 'waiting';
                        guest_book_items[reservation_customer.id_guest_book] = guest_book_item;
                    }
                    obj.main_table_items = main_table_items;
                    obj.guest_book_items = guest_book_items;
                }
            } else obj[this.state.date_picker_dialog_state_name] = newValue;
            this.setState(obj);
        }
    }
    getDateFromStateByName(name) {
        if (Array.isArray(name)) {
            if (name.length == 2) return this.state.main_table_items[name[0]][name[1]] === null ? null : new Date(this.state.main_table_items[name[0]][name[1]]);
        } else return this.state[name];
        return null;
    }
    setMainTableItemChecked(id, checked) {
        const main_table_items_checked = [
            ...this.state.main_table_items_checked
        ];
        if (checked) main_table_items_checked.push(id);
        else main_table_items_checked.splice(main_table_items_checked.indexOf(id), 1);
        // select/unselect customer items/services
        let ids = [
            ...this.state.customer_items_customers_selected
        ];
        if (checked) ids.push(id);
        else {
            const idx = ids.indexOf(id);
            if (idx != -1) ids.splice(idx, 1);
        }
        this.setState({
            main_table_items_checked,
            customer_items_customers_selected: ids
        });
    }
    setMainTableItemsChecked(checked) {
        const main_table_items_checked = checked ? [
            ...Object.keys(this.state.main_table_items)
        ] : [];
        this.setState({
            main_table_items_checked,
            customer_items_customers_selected: main_table_items_checked
        });
    }
    setMainTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.main_table_items_sort_field == field) direction = this.state.main_table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        const ids = this.state.main_table_items_sort_ids;
        ids.sort((a_key, b_key)=>{
            const a = this.state.main_table_items[a_key][field];
            const b = this.state.main_table_items[b_key][field];
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        this.setState({
            main_table_items_sort_ids: ids,
            main_table_items_sort_field: field,
            main_table_items_sort_direction: direction
        });
    }
    componentDidMount() {
        this._ismounted = true;
        setTimeout(()=>{
            if (!this._ismounted) return;
            {
                const id_customer_input = document.querySelector('.main-person-input > input');
                if (id_customer_input !== null) id_customer_input.focus();
            //if (this.addPersonRef.current !== null) {
            //	this.addPersonRef.current.focus();
            //}
            }
        }, 1000);
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    openEditInvoiceDialog(type, item, selected_advance_invoices_amounts, id_reservation_customers) {
        this.setState({
            create_invoice_dialog_open: true,
            create_invoice_dialog_type: type,
            create_invoice_dialog_item: item,
            create_invoice_dialog_selected_advance_invoices_amounts: selected_advance_invoices_amounts,
            create_invoice_dialog_id_reservation_customers: id_reservation_customers
        });
    }
    async closeEditInvoiceDialog(item, open_create_invoice_type, finish_invoice) {
        this.setState({
            create_invoice_dialog_open: false,
            create_invoice_dialog_item: null
        });
        if (item !== undefined) {
            this.setState({
                additional_info_tab_id: 'offers'
            });
            this.props.dispatch((0, _businessSlice.addInvoice)({
                item,
                token: this.props.token
            }));
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            const self = this;
            self.increaseLoading();
            const new_items = await (0, _business.saveInvoice)(this.props.api_url, item, token, dispatch);
            if (new_items !== null) {
                self.decreaseLoading();
                if (new_items.invoices !== undefined) dispatch((0, _businessSlice.addInvoices)(new_items.invoices));
                if (new_items.document_associations !== undefined) dispatch((0, _documentSlice.addDocumentAssociations)(new_items.document_associations));
                if (new_items.advance_invoice_consumptions !== undefined) dispatch((0, _businessSlice.addAdvanceInvoiceConsumptions)(new_items.advance_invoice_consumptions));
                for(let i = 0; i < new_items.invoices.length; i++)self.addAndSaveDocumentAssociation(new_items.invoices[i].id_invoice, new_items.invoices[i].invoice_type, self.state.reservation.id_reservation, 'reservation');
                for(let i = 0; i < new_items.invoices.length; i++)for(let j = 0; j < this.state.create_invoice_dialog_id_reservation_customers.length; j++)self.addAndSaveDocumentAssociation(new_items.invoices[i].id_invoice, new_items.invoices[i].invoice_type, this.state.create_invoice_dialog_id_reservation_customers[j], 'reservation-customer');
                if (finish_invoice && this.props.document_types[item.invoice_type].fiscal_verification_enabled) this.setState({
                    wait_fiscal_verification_dialog_open: true,
                    wait_fiscal_verification_dialog_id_invoice: item.id_invoice
                });
            }
        }
    }
    async addAndSaveDocumentAssociation(source_id_document, source_type, target_id_document, target_type) {
        const item = {
            id_document_association: (0, _uuidDefault.default).v4(),
            source_id_document,
            source_type,
            target_id_document,
            target_type
        };
        this.props.dispatch((0, _documentSlice.addDocumentAssociation)({
            item,
            token: this.props.token
        }));
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        this.increaseLoading();
        const new_item = await (0, _documents.saveDocumentAssociation)(this.props.api_url, item, token);
        if (new_item !== null) {
            this.decreaseLoading();
            dispatch((0, _documentSlice.addDocumentAssociation)({
                item: new_item,
                token
            }));
        }
    }
    deleteMainTableItem(id_reservation_customer, force) {
        if (force !== true) {
            this.setState({
                delete_confirm_dialog_open: true,
                delete_confirm_dialog_id_reservation_customer: id_reservation_customer
            });
            return;
        }
        const main_table_items = {
            ...this.state.main_table_items
        };
        delete main_table_items[id_reservation_customer];
        const main_table_items_sort_ids = this.state.main_table_items_sort_ids.filter((id)=>id != id_reservation_customer);
        const main_table_items_checked = this.state.main_table_items_checked.filter((id)=>id != id_reservation_customer);
        this.setState({
            main_table_items_changed: true,
            main_table_items,
            main_table_items_sort_ids,
            main_table_items_checked
        });
    }
    toIsoString(date) {
        if (date === null) return null;
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    toIsoStringWithTime(date) {
        if (date === null) return null;
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + 'T' + (hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute) + ':' + (second < 10 ? '0' + second : second);
    }
    async closeDialog(save, confirm) {
        if (confirm) {
            this.setState({
                close_dialog_save_item: save,
                close_dialog_confirm_open: true
            });
            return;
        }
        if (!save) {
            this.props.closeReservation();
            return;
        }
        if (await this.saveReservation()) this.props.closeReservation();
    }
    async saveReservation(state) {
        state = state || this.state;
        this.increaseLoading();
        const item = state.reservation === null ? {
            id_reservation: (0, _uuidDefault.default).v4()
        } : {
            ...state.reservation
        };
        const customers = Object.values(state.main_table_items);
        item.check_in = this.toIsoString(state.check_in);
        item.check_out = this.toIsoString(state.check_out);
        item.id_customer = state.id_customer;
        item.phone = state.phone;
        item.email = state.email;
        item.note = state.note;
        item.id_channel = state.id_channel == -1 ? null : state.id_channel;
        item.id_market_segmentation = state.id_market_segmentation;
        item.id_accommodation_item_place = state.id_accommodation_item_place;
        item.guest_adult_count = state.guest_adult_count;
        item.guest_child_1_count = state.guest_child_1_count;
        item.guest_child_2_count = state.guest_child_2_count;
        item.custom_status = state.custom_status;
        item.internal_code = state.internal_code;
        item.status = state.status;
        item.status_2 = state.status_2 == '' ? null : state.status_2;
        item.deleted = state.status != 'reversed' && state.status != 'no-show' && state.deleted;
        item.guests_checked_in = state.guests_checked_in;
        item.username = this.props.user.username;
        // when at least one guest is added, overwrite guest counts from added guests
        if (customers.length > 0) {
            let guest_adult_count = 0;
            let guest_child_1_count = 0;
            let guest_child_2_count = 0;
            for(let id_item in state.main_table_items){
                const item = state.main_table_items[id_item];
                const customer = this.props.customers[item.id_customer];
                if (customer === undefined) continue;
                console.log({
                    item,
                    customer
                });
                const birth_date = new Date(customer.birth_date);
                const check_in = new Date(item.check_in);
                const age = this.getAge(birth_date, check_in);
                if (age < this.props.general_settings.reservation_child_age_limit_1) guest_child_1_count++;
                else if (age < this.props.general_settings.reservation_child_age_limit_2) guest_child_2_count++;
                else guest_adult_count++;
            }
            item.guest_adult_count = guest_adult_count;
            item.guest_child_1_count = guest_child_1_count;
            item.guest_child_2_count = guest_child_2_count;
        }
        if (item.status != 'reversed' && item.status != 'no-show' && (0, _reservationHelperDefault.default).FindOverlappingReservation(item, this.props.reservations) !== null) {
            this.setState({
                error_message: 'V izbranem obdobju (' + (0, _momentDefault.default)(item.check_in).format('DD.MM.YYYY') + ' - ' + (0, _momentDefault.default)(item.check_out).format('DD.MM.YYYY') + ") \u017Ee obstaja rezervacija."
            });
            this.decreaseLoading();
            return;
        }
        if (item.id_reservation === undefined || item.id_reservation == -1) item.id_reservation = (0, _uuidDefault.default).v4();
        item.items = {};
        for(let key in state.reservation_items){
            const reservation_item = state.reservation_items[key];
            if (!reservation_item.selected) continue;
            //NOTE this code relies on only one id_item being used for each accommodation item's item set
            let new_reservation_item = null;
            for(let existing_key in state.reservation.items){
                const existing_reservation_item = state.reservation.items[existing_key];
                if (existing_reservation_item.id_item == reservation_item.item.id_item) {
                    new_reservation_item = existing_reservation_item;
                    break;
                }
            }
            if (new_reservation_item === null) new_reservation_item = {
                id_reservation_item: (0, _uuidDefault.default).v4(),
                id_reservation: item.id_reservation,
                id_item: reservation_item.item.id_item,
                calculation_type: reservation_item.calculation_type,
                mandatory: reservation_item.mandatory,
                enable_short_term_surcharge: reservation_item.enable_short_term_surcharge,
                age_from: reservation_item.age_from,
                age_until: reservation_item.age_until
            };
            item.items[new_reservation_item.id_reservation_item] = new_reservation_item;
        }
        if (item.id_market_segmentation == -1) item.id_market_segmentation = null;
        if (!this.validate(item)) {
            this.decreaseLoading();
            return false;
        }
        let new_item;
        // if user changed customer's email or phone, update customer with it
        const customer = this.props.customers[item.id_customer];
        if (customer.email != item.email || customer.phone != item.phone) {
            const new_customer = {
                ...customer
            };
            new_customer.email = item.email;
            new_customer.phone = item.phone;
            this.props.dispatch((0, _codeTablesSlice.addCustomer)({
                item: new_customer,
                token: this.props.token
            }));
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            new_item = await (0, _codeTables.saveCodeTableItem)(this.props.api_url, 'customers', new_customer, token);
            if (new_item !== null) dispatch((0, _codeTablesSlice.addCustomer)({
                item: new_item,
                token
            }));
        }
        const [dispatch, token] = [
            this.props.dispatch,
            this.props.token
        ];
        dispatch((0, _reservationSlice.addReservation)({
            item,
            token
        }));
        new_item = await (0, _reservations.saveReservation)(this.props.api_url, item, token);
        if (new_item !== null) {
            dispatch((0, _reservationSlice.addReservation)({
                item: new_item,
                token
            }));
            if (this.props.savedReservationCallback !== undefined) this.props.savedReservationCallback(new_item);
            if (this._ismounted) this.setState({
                reservation: new_item,
                internal_code: new_item.internal_code,
                main_table_items_changed: false
            });
        }
        const current_customers = this.props.reservation_customers_by_id_reservations[item.id_reservation];
        const old_customer_ids = current_customers === undefined || current_customers === null ? [] : Object.keys(current_customers);
        const new_customer_ids = customers.map((customer)=>customer.id_reservation_customer);
        let missing_customer_ids = [];
        for(let i = 0; i < old_customer_ids.length; i++)if (new_customer_ids.indexOf(old_customer_ids[i]) == -1) missing_customer_ids.push(old_customer_ids[i]);
        const main_table_items = {
            ...state.main_table_items
        };
        const items = [];
        for(let i = 0; i < customers.length; i++){
            const customer = {
                ...customers[i]
            };
            customer.id_reservation = item.id_reservation;
            if (customer.id_group == '') customer.id_group = null;
            items.push(customer);
        }
        const new_items = await (0, _reservations.batchSaveReservationCustomer)(this.props.api_url, customers.map((x)=>{
            return {
                ...x,
                id_reservation: item.id_reservation,
                id_group: x.id_group == '' ? null : x.id_group
            };
        }), token);
        for(let i = 0; i < new_items.reservation_customers.length; i++){
            if (this._ismounted) {
                if (main_table_items[new_items.reservation_customers[i].id_reservation_customer] !== undefined) main_table_items[new_items.reservation_customers[i].id_reservation_customer] = new_items.reservation_customers[i];
            }
        }
        dispatch((0, _reservationSlice.batchAddReservationCustomers)({
            items: new_items.reservation_customers,
            token
        }));
        dispatch((0, _guestSlice.batchAddGuestBookItems)({
            items: new_items.guest_book_items,
            token
        }));
        this.setState({
            main_table_items
        });
        for(let i = 0; i < missing_customer_ids.length; i++){
            await (0, _reservations.deleteReservationCustomer)(this.props.api_url, missing_customer_ids[i], token);
            dispatch((0, _reservationSlice.removeReservationCustomer)({
                item: current_customers[missing_customer_ids[i]]
            }));
        }
        // save items/services for customers
        let reservation_customers = {};
        if (this.props.reservation !== null) reservation_customers = this.props.reservation_customers_by_id_reservations[this.props.reservation.id_reservation] || {};
        const reservation_customers_ids = Object.keys(reservation_customers);
        const current_reservation_customer_item_ids = Object.values(this.props.reservation_customer_items).filter((x)=>reservation_customers_ids.indexOf(x.id_reservation_customer) != -1).map((x)=>x.id_reservation_customer_item);
        const processed_reservation_customer_item_ids = this.state.customer_items.map((item)=>item.id_reservation_customer_item);
        await (0, _reservations.saveReservationCustomerItems)(this.props.api_url, this.state.customer_items, token);
        for(let i = 0; i < current_reservation_customer_item_ids.length; i++)if (processed_reservation_customer_item_ids.indexOf(current_reservation_customer_item_ids[i]) == -1) {
            await (0, _reservations.deleteReservationCustomerItem)(this.props.api_url, current_reservation_customer_item_ids[i], token);
            dispatch((0, _reservationSlice.removeReservationCustomerItem)({
                item: {
                    id_reservation_customer_item: current_reservation_customer_item_ids[i]
                }
            }));
        }
        dispatch((0, _reservationSlice.addReservationCustomerItems)(this.state.customer_items));
        this.setState({
            guest_book_items: {}
        });
        this.decreaseLoading();
        return true;
    }
    validate(item) {
        // validate missing/empty fields
        const validation_failed_fields = [];
        const validation_failed_field_titles = [];
        const accommodation_item_place = this.props.accommodation_item_places[item.id_accommodation_item_place];
        const accommodation_item = this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
        const accommodation = this.props.accommodations[accommodation_item.id_accommodation];
        if (item.id_customer == -1 || item.id_customer === null) {
            validation_failed_fields.push('id_customer');
            validation_failed_field_titles.push('nosilec');
        }
        if (accommodation.required_id_channel && item.id_channel === null) {
            validation_failed_fields.push('id_channel');
            validation_failed_field_titles.push('prodajni kanal');
        }
        if (item.check_in === null || item.check_out === null) {
            validation_failed_fields.push('check_in_out');
            validation_failed_field_titles.push('Obdobje');
        }
        this.setState({
            validation_failed_fields
        });
        if (validation_failed_fields.length > 0) {
            (0, _appToaster.AppToaster).show({
                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Za shranjevanje rezervacije, izpolnite vsaj polja:",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: "\u2022 " + title
                            }, title))
                    ]
                }),
                intent: 'danger',
                icon: 'issue'
            });
            return false;
        }
        return true;
    }
    diffByIgnoringTimes(check_out, check_in) {
        return Math.ceil(check_out.clone().set('hour', 12).set('minute', 0).set('second', 0).diff(check_in.clone().set('hour', 12).set('minute', 0).set('second', 0), 'days', true));
    }
    calculateReservationPrice(id_reservation_customers, additional_items_id_reservation_customers, include_tourist_tax_in_items) {
        //TODO cache this somehow
        id_reservation_customers = id_reservation_customers || Object.keys(this.state.main_table_items);
        additional_items_id_reservation_customers = additional_items_id_reservation_customers || this.state.customer_items.map((item)=>item.id_reservation_customer);
        include_tourist_tax_in_items = include_tourist_tax_in_items === undefined ? true : false;
        let accommodation_items_price = 0;
        let additional_customer_items_price = 0;
        let tourist_taxes_by_ids = {};
        let total_tourist_tax = 0;
        const reservation_check_in = (0, _momentDefault.default)(this.state.check_in);
        const reservation_check_out = (0, _momentDefault.default)(this.state.check_out);
        const reservation_diff_days = this.diffByIgnoringTimes(reservation_check_out, reservation_check_in);
        const reservation_daily_items = {};
        // sum up prices from items
        for(let i = 0; i < this.state.reservation_items.length; i++){
            const reservation_item = this.state.reservation_items[i];
            if (!reservation_item.selected) continue;
            if (reservation_item.calculation_type == 'reservation') {
                const id_item_price_list = (0, _priceHelperDefault.default).FindBestPriceListMatch(reservation_check_in, reservation_item.item.price_lists);
                const price = id_item_price_list === null ? 0 : parseFloat(reservation_item.item.price_lists[id_item_price_list].price);
                const item = {
                    type: 'reservation-item',
                    id_item: reservation_item.item.id_item,
                    quantity: 1,
                    id_item_price_list,
                    description: '',
                    price,
                    single_price: price
                };
                const key = item.id_item + '--' + (item.id_item_price_list === null ? 'null' : item.id_item_price_list);
                if (reservation_daily_items[key] !== undefined) {
                    reservation_daily_items[key].quantity += item.quantity;
                    reservation_daily_items[key].price += item.price;
                } else reservation_daily_items[key] = item;
                accommodation_items_price += price;
            } else if (reservation_item.calculation_type == 'reservation_day') {
                let date = (0, _momentDefault.default)(reservation_check_in);
                for(let i = 0; i < reservation_diff_days; i++){
                    const id_item_price_list = (0, _priceHelperDefault.default).FindBestPriceListMatch(date, reservation_item.item.price_lists);
                    const price = id_item_price_list === null ? 0 : parseFloat(reservation_item.item.price_lists[id_item_price_list].price);
                    const item = {
                        type: 'reservation-item',
                        id_item: reservation_item.item.id_item,
                        quantity: 1,
                        id_item_price_list,
                        description: '',
                        price,
                        single_price: price
                    };
                    const key = item.id_item + '--' + (item.id_item_price_list === null ? 'null' : item.id_item_price_list);
                    if (reservation_daily_items[key] !== undefined) {
                        reservation_daily_items[key].quantity += item.quantity;
                        reservation_daily_items[key].price += item.price;
                    } else reservation_daily_items[key] = item;
                    accommodation_items_price += price;
                    date.add(1, 'day');
                }
            } else if (reservation_item.calculation_type == 'person_day' || reservation_item.calculation_type == 'person') {
                // if there are no checked-in guests, use guest count from guest_adult_count, guest_child_1_count and
                //   guest_child_2_count fields
                if (id_reservation_customers.length == 0) {
                    const counts_with_ages = [
                        {
                            age: this.props.general_settings.reservation_child_age_limit_1 - 0.01,
                            count: this.state.guest_child_1_count
                        },
                        {
                            age: this.props.general_settings.reservation_child_age_limit_2 - 0.01,
                            count: this.state.guest_child_2_count
                        },
                        {
                            age: 100,
                            count: this.state.guest_adult_count
                        }
                    ];
                    for(let j = 0; j < counts_with_ages.length; j++){
                        const age = counts_with_ages[j].age;
                        const count = counts_with_ages[j].count;
                        if (count == 0) continue;
                        if (reservation_item.age_from === null && reservation_item.age_until === null || reservation_item.age_from === null && reservation_item.age_until !== null && age < reservation_item.age_until || reservation_item.age_until === null && reservation_item.age_from !== null && age >= reservation_item.age_from || reservation_item.age_from !== null && reservation_item.age_until !== null && age >= reservation_item.age_from && age < reservation_item.age_until) {
                            let diff_days = reservation_diff_days;
                            if (reservation_item.calculation_type == 'person') diff_days = 1;
                            let date = (0, _momentDefault.default)(reservation_check_in);
                            for(let i = 0; i < diff_days; i++){
                                const id_item_price_list = (0, _priceHelperDefault.default).FindBestPriceListMatch(date, reservation_item.item.price_lists);
                                const price = id_item_price_list === null ? 0 : parseFloat(reservation_item.item.price_lists[id_item_price_list].price);
                                const item = {
                                    type: 'reservation-item',
                                    id_item: reservation_item.item.id_item,
                                    quantity: count,
                                    id_item_price_list,
                                    description: '',
                                    price: price * count,
                                    single_price: price
                                };
                                const key = item.id_item + '--' + (item.id_item_price_list === null ? 'null' : item.id_item_price_list);
                                if (reservation_daily_items[key] !== undefined) {
                                    reservation_daily_items[key].quantity += item.quantity;
                                    reservation_daily_items[key].price += item.price;
                                } else reservation_daily_items[key] = item;
                                accommodation_items_price += price * count;
                                date.add(1, 'day');
                            }
                        }
                    }
                } else for(let idx in id_reservation_customers){
                    const reservation_customer = this.state.main_table_items[id_reservation_customers[idx]];
                    const customer = this.props.customers[reservation_customer.id_customer];
                    if (customer === undefined) continue;
                    const check_in = (0, _momentDefault.default)(reservation_customer.check_in !== null ? reservation_customer.check_in : this.state.check_in);
                    const check_out = (0, _momentDefault.default)(reservation_customer.check_out !== null ? reservation_customer.check_out : this.state.check_out);
                    let diff_days = this.diffByIgnoringTimes(check_out, check_in);
                    if (reservation_item.calculation_type == 'person') diff_days = 1;
                    const curr_date = check_in;
                    for(let x = 0; x < diff_days; x++){
                        const age = curr_date.diff(customer.birth_date, 'years');
                        if (reservation_item.age_from === null && reservation_item.age_until === null || reservation_item.age_from === null && reservation_item.age_until !== null && age < reservation_item.age_until || reservation_item.age_until === null && reservation_item.age_from !== null && age >= reservation_item.age_from || reservation_item.age_from !== null && reservation_item.age_until !== null && age >= reservation_item.age_from && age < reservation_item.age_until) {
                            //accommodation_items_price += price;
                            ////item.price     += price;
                            //item.quantity  += 1;
                            const id_item_price_list = (0, _priceHelperDefault.default).FindBestPriceListMatch(curr_date, reservation_item.item.price_lists);
                            const price = id_item_price_list === null ? 0 : parseFloat(reservation_item.item.price_lists[id_item_price_list].price);
                            const item = {
                                type: 'reservation-item',
                                id_item: reservation_item.item.id_item,
                                quantity: 1,
                                id_item_price_list,
                                description: '',
                                price,
                                single_price: price
                            };
                            const key = item.id_item + '--' + (item.id_item_price_list === null ? 'null' : item.id_item_price_list);
                            if (reservation_daily_items[key] !== undefined) {
                                reservation_daily_items[key].quantity += item.quantity;
                                reservation_daily_items[key].price += item.price;
                            } else reservation_daily_items[key] = item;
                            accommodation_items_price += price;
                        }
                        curr_date.add(1, 'days');
                    }
                }
            }
        }
        const items = Object.values(reservation_daily_items).filter((x)=>x.quantity != 0);
        // sum up tourist taxes
        const accommodation_item_place = this.props.accommodation_item_places[this.state.reservation.id_accommodation_item_place];
        const accommodation_item = this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
        const accommodation = this.props.accommodations[accommodation_item.id_accommodation];
        const tourist_tax_item = accommodation.tourist_tax_id_item === null ? null : this.props.items[accommodation.tourist_tax_id_item];
        if (tourist_tax_item !== null && tourist_tax_item !== undefined) {
            const id_item_price_list = (0, _priceHelperDefault.default).FindBestPriceListMatch(reservation_check_in, tourist_tax_item.price_lists);
            const price = id_item_price_list === null ? 0 : parseFloat(tourist_tax_item.price_lists[id_item_price_list].price);
            if (price > 0) {
                // if there are no checked-in guests, use guest count from guest_adult_count, guest_child_1_count and
                //   guest_child_2_count fields
                if (id_reservation_customers.length == 0) {
                    const tourist_taxes = Object.values(this.props.tourist_taxes);
                    const tourist_tax_adults = tourist_taxes.find((tourist_tax)=>tourist_tax.internal_code == '0');
                    const tourist_tax_children_0_7 = tourist_taxes.find((tourist_tax)=>tourist_tax.internal_code == '1');
                    const tourist_tax_children_7_18 = tourist_taxes.find((tourist_tax)=>tourist_tax.internal_code == '11');
                    const taxes_with_counts = [
                        [
                            tourist_tax_adults,
                            this.state.guest_adult_count
                        ],
                        [
                            tourist_tax_children_0_7,
                            this.state.guest_child_1_count
                        ],
                        [
                            tourist_tax_children_7_18,
                            this.state.guest_child_2_count
                        ]
                    ];
                    for(let i = 0; i < taxes_with_counts.length; i++){
                        const tourist_tax = taxes_with_counts[i][0];
                        const count = taxes_with_counts[i][1];
                        if (tourist_tax === undefined) continue;
                        if (count == 0) continue;
                        if (tourist_taxes_by_ids[tourist_tax.id_tourist_tax] === undefined) tourist_taxes_by_ids[tourist_tax.id_tourist_tax] = {
                            price: 0,
                            price_with_discount: 0,
                            quantity: 0
                        };
                        const price_with_discount = price * (1 - tourist_tax.discount / 100);
                        const c = count * reservation_diff_days;
                        total_tourist_tax += price_with_discount * c;
                        tourist_taxes_by_ids[tourist_tax.id_tourist_tax].price += price * c;
                        tourist_taxes_by_ids[tourist_tax.id_tourist_tax].price_with_discount = price_with_discount;
                        tourist_taxes_by_ids[tourist_tax.id_tourist_tax].quantity += c;
                    }
                } else for(let idx in id_reservation_customers){
                    const reservation_customer = this.state.main_table_items[id_reservation_customers[idx]];
                    const tourist_tax = this.props.tourist_taxes[reservation_customer.id_tourist_tax];
                    const check_in = (0, _momentDefault.default)(reservation_customer.check_in !== null ? reservation_customer.check_in : this.state.check_in);
                    const check_out = (0, _momentDefault.default)(reservation_customer.check_out !== null ? reservation_customer.check_out : this.state.check_out);
                    const diff_days = this.diffByIgnoringTimes(check_out, check_in);
                    const curr_date = check_in;
                    for(let x = 0; x < diff_days; x++){
                        if (tourist_taxes_by_ids[tourist_tax.id_tourist_tax] === undefined) tourist_taxes_by_ids[tourist_tax.id_tourist_tax] = {
                            price: 0,
                            quantity: 0
                        };
                        const price_with_discount = price * (1 - tourist_tax.discount / 100);
                        total_tourist_tax += price_with_discount;
                        tourist_taxes_by_ids[tourist_tax.id_tourist_tax].price += price;
                        tourist_taxes_by_ids[tourist_tax.id_tourist_tax].price_with_discount = price_with_discount;
                        tourist_taxes_by_ids[tourist_tax.id_tourist_tax].quantity += 1;
                        curr_date.add(1, 'days');
                    }
                }
            }
            if (include_tourist_tax_in_items) for(let id_tourist_tax in tourist_taxes_by_ids)items.push({
                type: 'tourist-tax',
                id_item: accommodation.tourist_tax_id_item,
                quantity: tourist_taxes_by_ids[id_tourist_tax].quantity,
                price: tourist_taxes_by_ids[id_tourist_tax].price_with_discount * tourist_taxes_by_ids[id_tourist_tax].quantity,
                single_price: tourist_taxes_by_ids[id_tourist_tax].price_with_discount,
                id_item_price_list,
                id_tourist_tax,
                description: ''
            });
        }
        for(let i = 0; i < this.state.customer_items.length; i++){
            const item = this.state.customer_items[i];
            if (additional_items_id_reservation_customers.indexOf(item.id_reservation_customer) == -1) continue;
            const quantity = parseFloat(item.quantity);
            const price = parseFloat(this.props.items[item.id_item].price_lists[item.id_item_price_list].price);
            const total_price = parseFloat(this.props.items[item.id_item].price_lists[item.id_item_price_list].price) * quantity;
            items.push({
                type: 'customer-item',
                id_item: item.id_item,
                quantity: quantity,
                price: total_price,
                single_price: price,
                id_item_price_list: item.id_item_price_list,
                description: ''
            });
            additional_customer_items_price += total_price;
        }
        return {
            accommodation_items_price,
            additional_customer_items_price,
            tourist_taxes: tourist_taxes_by_ids,
            total_tourist_tax,
            total: accommodation_items_price + total_tourist_tax + additional_customer_items_price,
            items
        };
    }
    /*openAddEditItemDialog(item, type) {
		this.setState({ add_edit_item_dialog_open: true, add_edit_item_dialog_item: item, add_edit_item_dialog_type: type });
	}
	closeAddEditItemDialog(item) {
		this.setState({ add_edit_item_dialog_open: false });
		
		if (item !== undefined) {
			this.props.dispatch(addInvoice({
				item,
				token: this.props.token,
			}));
			
			const dispatch = this.props.dispatch;
			const token    = this.props.token;
			
			const new_items = await saveInvoice(this.props.api_url, item, token, dispatch);
			if (new_items !== null) {
				if (new_items.invoices !== undefined) {
					dispatch(addInvoices(new_items.invoices));
				}
				if (new_items.document_associations !== undefined) {
					dispatch(addDocumentAssociations(new_items.document_associations));
				}
			}
		}
	}*/ increaseLoading() {
        if (!this._ismounted) return;
        this.loading++;
        this.setState({
            loading: this.loading
        });
    }
    decreaseLoading() {
        if (!this._ismounted) return;
        this.loading--;
        this.setState({
            loading: this.loading
        });
    }
    openDocumentListDialog(id_document, document_type) {
        this.setState({
            document_list_dialog_open: true,
            document_list_dialog_id_document: id_document,
            document_list_dialog_document_type: document_type
        });
    }
    closeDocumentListDialog() {
        this.setState({
            document_list_dialog_open: false,
            document_list_dialog_id_document: null,
            document_list_dialog_document_type: null
        });
    }
    // from https://stackoverflow.com/questions/4060004/calculate-age-given-the-birth-date-in-the-format-yyyymmdd/7091965#7091965
    getAge(birthdate, today) {
        today = today || new Date();
        let age = today.getFullYear() - birthdate.getFullYear();
        const m = today.getMonth() - birthdate.getMonth();
        if (m < 0 || m === 0 && today.getDate() < birthdate.getDate()) age--;
        return age;
    }
    copyGuestToReservationCustomer(id_customer) {
        this.setState({
            id_customer
        });
    }
    render() {
        const any_checked_items = this.state.main_table_items_checked.length;
        const calculated_reservation_price = this.calculateReservationPrice();
        const reservation_items_without_person_day = this.state.reservation_items.filter((item)=>{
            return item.calculation_type != 'person_day' || item.age_from === null && item.age_until === null;
        });
        const accommodation_item_place = this.props.accommodation_item_places[this.state.reservation.id_accommodation_item_place];
        const accommodation_item = this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
        const accommodation = this.props.accommodations[accommodation_item.id_accommodation];
        const customer_documents = {};
        let can_log_out_customers = true;
        for(let id_reservation_customer in this.state.main_table_items){
            if (this.props.reservation_customers[id_reservation_customer] === undefined) continue;
            const documents = (0, _documentsHelperDefault.default).GetDocumentsForReservationAndCustomer(this.props.document_associations, this.state.reservation.id_reservation, id_reservation_customer);
            customer_documents[id_reservation_customer] = documents.customer_documents;
            if (this.state.main_table_items_checked.indexOf(id_reservation_customer) != -1) {
                const id_guest_book = this.props.reservation_customers[id_reservation_customer].id_guest_book;
                if (id_guest_book !== undefined) {
                    const guest_book_item = this.props.guest_book_items[id_guest_book];
                    if (guest_book_item === undefined || guest_book_item === null || guest_book_item.zst === null) can_log_out_customers = false;
                }
            }
        }
        const consider_deleted = this.state.deleted || this.state.status == 'reversed' || this.state.status == 'no-show';
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: !this.state.edit_reservation_customer_dialog_open && !this.state.invoice_dialog_open && !this.state.select_customer_dialog_open && !this.state.date_picker_dialog_open,
            onClose: ()=>{
                this.closeDialog(false, true);
            },
            className: "main-dialog",
            children: [
                !this.state.edit_reservation_customer_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editReservationCustomerDialogDefault.default), {
                    closeEditReservationCustomerDialog: this.closeEditReservationCustomerDialog,
                    item: this.state.edit_reservation_customer_dialog_item,
                    id_accommodation_item_place: this.state.reservation.id_accommodation_item_place,
                    default_check_out: new Date((0, _momentDefault.default)(this.state.check_out).format('YYYY-MM-DD') + 'T' + accommodation.default_check_out_time)
                }),
                !this.state.select_customer_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectCustomerDialogDefault.default), {
                    closeSelectCustomerDialog: this.closeSelectCustomerDialog,
                    name: this.state.select_customer_dialog_name,
                    surname: this.state.select_customer_dialog_surname,
                    email: this.state.select_customer_dialog_email,
                    id_country: this.state.select_customer_dialog_id_country,
                    phone: this.state.select_customer_dialog_phone,
                    post_office: this.state.select_customer_dialog_post_office,
                    address: this.state.select_customer_dialog_address,
                    item: this.state.select_customer_dialog_item
                }),
                !this.state.invoice_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _invoiceDialogDefault.default), {
                    closeInvoiceDialog: this.closeInvoiceDialog,
                    preselect: this.state.invoice_dialog_preselect,
                    calculatedState: this.state.invoice_dialog_calculated_state,
                    idCustomer: this.state.invoice_dialog_id_customer,
                    guestIdCustomers: [
                        ...new Set([
                            ...this.state.id_customer === null || this.state.id_customer === undefined || this.state.id_customer == -1 ? [] : [
                                this.state.id_customer
                            ],
                            ...Object.values(this.state.main_table_items).map((guest)=>guest.id_customer)
                        ])
                    ],
                    advance_invoices: this.state.invoice_dialog_advance_invoices
                }),
                !this.state.date_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePickerDialogDefault.default), {
                    closeDateTimePickerDialog: this.closeDateTimePickerDialog,
                    value: this.getDateFromStateByName(this.state.date_picker_dialog_state_name)
                }),
                !this.state.create_invoice_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editInvoiceDialogDefault.default), {
                    closeEditInvoiceDialog: this.closeEditInvoiceDialog,
                    item: this.state.create_invoice_dialog_item,
                    type: this.state.create_invoice_dialog_type,
                    selected_advance_invoices_amounts: this.state.create_invoice_dialog_selected_advance_invoices_amounts
                }),
                !this.state.delete_requested ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Da",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: async ()=>{
                        this.setState({
                            deleted: true,
                            delete_requested: false
                        });
                        const state = {
                            ...this.state
                        };
                        state.deleted = true;
                        if (await this.saveReservation(state)) this.closeDialog(false, false);
                    },
                    onCancel: ()=>{
                        this.setState({
                            delete_requested: false
                        });
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Brisanje rezervacije?"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    "Rezervacija:",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: " "
                                    }),
                                    this.props.accommodation_item_places[this.state.reservation.id_accommodation_item_place].title,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: ", "
                                    }),
                                    (0, _momentDefault.default)(this.state.check_in).format('DD.MM.YYYY') + ' - ' + (0, _momentDefault.default)(this.state.check_out).format('DD.MM.YYYY')
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mb-3",
                                children: [
                                    "Nosilec: ",
                                    this.state.id_customer === null || this.state.id_customer === undefined || this.state.id_customer == -1 || this.props.customers[this.state.id_customer] === undefined ? '' : this.props.customers[this.state.id_customer].type == 'natural' ? this.props.customers[this.state.id_customer].surname + ' ' + this.props.customers[this.state.id_customer].name : this.props.customers[this.state.id_customer].company_name
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mt-4 mb-4",
                                children: "Izbrisana rezervacija se bo evidentirala v seznamu rezervacij."
                            })
                        ]
                    })
                }),
                !this.state.status_change_requested ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Da",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "help",
                    intent: (0, _core.Intent).PRIMARY,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.setState({
                            status_change_requested: false,
                            status: this.state.status_change_requested_value
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            status_change_requested: false
                        });
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: this.state.status_change_requested_value == 'reversed' ? 'Storniranje rezervacije?' : this.state.status_change_requested_value == 'no-show' ? 'Neprihod?' : null
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    "Rezervacija:",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: " "
                                    }),
                                    this.props.accommodation_item_places[this.state.reservation.id_accommodation_item_place].title,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: ", "
                                    }),
                                    (0, _momentDefault.default)(this.state.check_in).format('DD.MM.YYYY') + ' - ' + (0, _momentDefault.default)(this.state.check_out).format('DD.MM.YYYY')
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mb-3",
                                children: [
                                    "Nosilec: ",
                                    this.state.id_customer === null || this.state.id_customer === undefined || this.state.id_customer == -1 || this.props.customers[this.state.id_customer] === undefined ? '' : this.props.customers[this.state.id_customer].type == 'natural' ? this.props.customers[this.state.id_customer].surname + ' ' + this.props.customers[this.state.id_customer].name : this.props.customers[this.state.id_customer].company_name
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mt-4 mb-4",
                                children: this.state.status_change_requested_value == 'reversed' ? 'Stornirana rezervacija se bo evidentirala v seznamu rezervacij.' : this.state.status_change_requested_value == 'no-show' ? 'Neprihod se bo evidentiral v seznamu rezervacij.' : null
                            })
                        ]
                    })
                }),
                !this.state.copy_customer_to_guest ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Ne",
                    confirmButtonText: "Da",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "duplicate",
                    intent: (0, _core.Intent).PRIMARY,
                    isOpen: true,
                    onConfirm: ()=>{
                        const reservation_customer = {
                            id_reservation_customer: -1,
                            id_reservation: -1,
                            id_customer: this.state.id_customer,
                            check_in: this.toIsoStringWithTime(new Date()),
                            check_out: null,
                            invoice_paid: false,
                            invoice_paid_on: null,
                            identification_number: '',
                            id_group: null,
                            pay_tourist_tax: true,
                            add_to_guest_book: true,
                            agree_to_further_processing: false,
                            id_tourist_tax: null,
                            id_identification_type: null,
                            checked_out: false
                        };
                        this.openEditReservationCustomerDialog(reservation_customer);
                        this.setState({
                            copy_customer_to_guest: false
                        });
                    },
                    onCancel: ()=>{
                        this.openEditReservationCustomerDialog(null);
                        this.setState({
                            copy_customer_to_guest: false
                        });
                    },
                    children: "Prepi\u0161em nosilca v goste?"
                }),
                !this.state.close_dialog_confirm_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Zapri",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "help",
                    intent: (0, _core.Intent).PRIMARY,
                    isOpen: true,
                    onConfirm: async ()=>{
                        await this.closeDialog(this.state.close_dialog_save_item, false);
                        this.setState({
                            close_dialog_save_item: false,
                            close_dialog_confirm_open: false
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            close_dialog_save_item: false,
                            close_dialog_confirm_open: false
                        });
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Shranjevanje rezervacije?"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    "Rezervacija:",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: " "
                                    }),
                                    this.props.accommodation_item_places[this.state.reservation.id_accommodation_item_place].title,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: ", "
                                    }),
                                    (0, _momentDefault.default)(this.state.check_in).format('DD.MM.YYYY') + ' - ' + (0, _momentDefault.default)(this.state.check_out).format('DD.MM.YYYY')
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mb-3",
                                children: [
                                    "Nosilec: ",
                                    this.state.id_customer === null || this.state.id_customer === undefined || this.state.id_customer == -1 || this.props.customers[this.state.id_customer] === undefined ? '' : this.props.customers[this.state.id_customer].type == 'natural' ? this.props.customers[this.state.id_customer].surname + ' ' + this.props.customers[this.state.id_customer].name : this.props.customers[this.state.id_customer].company_name
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mt-4 mb-4",
                                children: "\u017Delite zapreti rezervacijo brez shranjevanja?"
                            })
                        ]
                    })
                }),
                !this.state.delete_confirm_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Da",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.deleteMainTableItem(this.state.delete_confirm_dialog_id_reservation_customer, true);
                        this.setState({
                            delete_confirm_dialog_open: false
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            delete_confirm_dialog_open: false
                        });
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: this.state.main_table_items[this.state.delete_confirm_dialog_id_reservation_customer].id_guest_book !== null && this.props.guest_book_items[this.state.main_table_items[this.state.delete_confirm_dialog_id_reservation_customer].id_guest_book] !== undefined && this.props.guest_book_items[this.state.main_table_items[this.state.delete_confirm_dialog_id_reservation_customer].id_guest_book].zst !== null ? 'Storniranje gosta?' : 'Brisanje gosta?'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    "Rezervacija:",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: " "
                                    }),
                                    this.props.accommodation_item_places[this.state.reservation.id_accommodation_item_place].title,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: ", "
                                    }),
                                    (0, _momentDefault.default)(this.state.check_in).format('DD.MM.YYYY') + ' - ' + (0, _momentDefault.default)(this.state.check_out).format('DD.MM.YYYY')
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mb-3",
                                children: [
                                    "Gost: ",
                                    this.props.customers[this.state.main_table_items[this.state.delete_confirm_dialog_id_reservation_customer].id_customer].type == 'natural' ? this.props.customers[this.state.main_table_items[this.state.delete_confirm_dialog_id_reservation_customer].id_customer].surname + ' ' + this.props.customers[this.state.main_table_items[this.state.delete_confirm_dialog_id_reservation_customer].id_customer].name : this.props.customers[this.state.main_table_items[this.state.delete_confirm_dialog_id_reservation_customer].id_customer].company_name
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mt-4 mb-4",
                                children: this.state.main_table_items[this.state.delete_confirm_dialog_id_reservation_customer].id_guest_book !== null && this.props.guest_book_items[this.state.main_table_items[this.state.delete_confirm_dialog_id_reservation_customer].id_guest_book] !== undefined && this.props.guest_book_items[this.state.main_table_items[this.state.delete_confirm_dialog_id_reservation_customer].id_guest_book].zst !== null ? "Gost bo evidentiran kot storniran v knjigi gostov in kot tak tudi poslan na e-Turizem. Ne bo upo\u0161tevan pri obra\u010Dunu turisti\u010Dne takse." : "Gost bo izbrisan in ne bo evidentiran v knjigi gostov ter pri obra\u010Dunu turisti\u010Dne takse."
                            })
                        ]
                    })
                }),
                !this.state.error_message ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    confirmButtonText: "Nadaljuj",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "error",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.setState({
                            error_message: null
                        });
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Napaka"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: this.state.error_message
                            })
                        ]
                    })
                }),
                this.state.delete_request__id_reservation_customer === null || this.state.delete_request__id_item === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Odstrani",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        const existing_idx = this.state.customer_items.findIndex((x)=>x.id_reservation_customer == this.state.delete_request__id_reservation_customer && x.id_item == this.state.delete_request__id_item);
                        if (existing_idx != -1) {
                            const customer_items = this.state.customer_items.map((x)=>{
                                return {
                                    ...x
                                };
                            });
                            customer_items.splice(existing_idx, 1);
                            this.setState({
                                customer_items
                            });
                        }
                        this.setState({
                            delete_request__id_reservation_customer: null,
                            delete_request__id_item: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            delete_request__id_reservation_customer: null,
                            delete_request__id_item: null
                        });
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: "Res \u017Eelite odstraniti postavko?"
                        })
                    })
                }),
                !this.state.document_list_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentListDialogDefault.default), {
                    id_document: this.state.document_list_dialog_id_document,
                    closeDialog: this.closeDocumentListDialog,
                    deep: false,
                    document_type: this.state.document_list_dialog_document_type
                }),
                !this.state.wait_fiscal_verification_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _waitFiscalVerificationDialogDefault.default), {
                    closeWaitFiscalVerificationDialog: (print)=>{
                        this.setState({
                            wait_fiscal_verification_dialog_open: false
                        });
                        if (print) {
                            const invoice = this.props.invoices[this.state.wait_fiscal_verification_dialog_id_invoice];
                            if (this.props.general_settings.auto_print_type == 'a4') this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                                type: 'invoice',
                                lang: 'sl',
                                invoice
                            }));
                            else if (this.props.general_settings.auto_print_type == 'pos') this.props.dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                                type: 'invoice',
                                invoice
                            }));
                        }
                    },
                    id_invoice: this.state.wait_fiscal_verification_dialog_id_invoice
                }),
                !this.state.add_edit_item_with_count_dialog_visible ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditItemWithCountDialogDefault.default), {
                    date: this.state.check_in,
                    id_item: this.state.add_edit_item_with_count_dialog_id_item,
                    quantity: this.state.add_edit_item_with_count_dialog_quantity,
                    closeDialog: (id_item, quantity)=>{
                        if (id_item === undefined || quantity === undefined) {
                            this.setState({
                                add_edit_item_with_count_dialog_visible: false,
                                add_edit_item_with_count_dialog_id_reservation_customer: null,
                                add_edit_item_with_count_dialog_quantity: 0,
                                add_edit_item_with_count_dialog_id_item: null
                            });
                            return;
                        }
                        // if new item, add it
                        if (this.state.add_edit_item_with_count_dialog_id_item === null) {
                            if (id_item !== null && quantity > 0) {
                                const existing_idx = id_item === null ? -1 : this.state.customer_items.findIndex((item)=>item.id_reservation_customer == this.state.add_edit_item_with_count_dialog_id_reservation_customer && item.id_item == id_item);
                                const customer_items = this.state.customer_items.map((x)=>{
                                    return {
                                        ...x
                                    };
                                });
                                if (existing_idx != -1) {
                                    customer_items[existing_idx].id_item = id_item;
                                    customer_items[existing_idx].quantity += quantity;
                                } else customer_items.push({
                                    id_reservation_customer_item: (0, _uuidDefault.default).v4(),
                                    id_reservation_customer: this.state.add_edit_item_with_count_dialog_id_reservation_customer,
                                    id_item,
                                    id_item_price_list: (0, _priceHelperDefault.default).FindBestPriceListMatch(this.state.check_in ?? new Date(), this.props.items[id_item].price_lists),
                                    quantity
                                });
                                this.setState({
                                    customer_items
                                });
                            }
                        } else {
                            const existing_idx = this.state.customer_items.findIndex((item)=>item.id_reservation_customer == this.state.add_edit_item_with_count_dialog_id_reservation_customer && item.id_item == this.state.add_edit_item_with_count_dialog_id_item);
                            const new_existing_idx = id_item === null ? -1 : this.state.customer_items.findIndex((item)=>item.id_reservation_customer == this.state.add_edit_item_with_count_dialog_id_reservation_customer && item.id_item == id_item);
                            const customer_items = this.state.customer_items.map((x)=>{
                                return {
                                    ...x
                                };
                            });
                            // delete item if nothing was selected or if quantity is set to 0
                            if (existing_idx != -1 && new_existing_idx == existing_idx && quantity <= 0) customer_items.splice(existing_idx, 1);
                            else if (existing_idx != -1 && id_item === null) customer_items.splice(existing_idx, 1);
                            else if (existing_idx != -1 && new_existing_idx != -1 && new_existing_idx != existing_idx && quantity > 0) {
                                customer_items[existing_idx].quantity = 0;
                                customer_items[new_existing_idx].quantity += quantity;
                            } else if (existing_idx != -1 && quantity > 0) {
                                customer_items[existing_idx].id_item = id_item;
                                customer_items[existing_idx].quantity = quantity;
                            } else if (existing_idx == -1 && quantity > 0) customer_items.push({
                                id_reservation_customer_item: (0, _uuidDefault.default).v4(),
                                id_reservation_customer: this.state.add_edit_item_with_count_dialog_id_reservation_customer,
                                id_item,
                                id_item_price_list: (0, _priceHelperDefault.default).FindBestPriceListMatch(this.state.check_in ?? new Date(), this.props.items[id_item].price_lists),
                                quantity
                            });
                            this.setState({
                                customer_items
                            });
                        }
                        this.setState({
                            add_edit_item_with_count_dialog_visible: false,
                            add_edit_item_with_count_dialog_id_reservation_customer: null,
                            add_edit_item_with_count_dialog_quantity: 0,
                            add_edit_item_with_count_dialog_id_item: null
                        });
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                            fixedToTop: false,
                            className: "bp5-dark",
                            style: consider_deleted ? {
                                backgroundColor: '#e53e3e'
                            } : {},
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Group, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Heading, {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Rezervacija \u2022 "
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-bold uppercase",
                                                    children: this.props.accommodation_item_places[this.state.reservation.id_accommodation_item_place].title
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: " \u2022 "
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: this.state.reservation.internal_code == '' ? 'NOVA REZERVACIJA' : this.state.reservation.internal_code
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Divider, {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                            className: "mr-6",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    minimal: false,
                                                    icon: "floppy-disk",
                                                    text: "Shrani",
                                                    intent: "success",
                                                    onClick: ()=>{
                                                        this.saveReservation();
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    minimal: false,
                                                    icon: "floppy-disk",
                                                    text: "Shrani in zapri",
                                                    intent: "success",
                                                    onClick: ()=>{
                                                        this.closeDialog(true, false);
                                                    }
                                                })
                                            ]
                                        }),
                                        this.state.reservation.id_reservation < 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: false,
                                            icon: "trash",
                                            text: "Izbri\u0161i",
                                            intent: "danger",
                                            className: "mr-6",
                                            disabled: Object.keys(this.state.main_table_items).length > 0 || consider_deleted,
                                            onClick: ()=>{
                                                this.setState({
                                                    delete_requested: true
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                            style: {
                                                backgroundColor: '#2c85c1'
                                            },
                                            options: [
                                                {
                                                    label: 'Nova',
                                                    value: 'new',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: 'V potrjevanju',
                                                    value: 'waiting-for-confirmation',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: 'Izdana ponudba',
                                                    value: 'offer-sent',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: 'Potrjena',
                                                    value: 'confirmed',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: 'Izdan avans',
                                                    value: 'advance-invoice-sent',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: "Pla\u010Dana",
                                                    value: 'closed',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: 'Stornirana',
                                                    value: 'reversed',
                                                    disabled: Object.keys(this.state.main_table_items).length > 0
                                                },
                                                {
                                                    label: 'Neprihod',
                                                    value: 'no-show',
                                                    disabled: Object.keys(this.state.main_table_items).length > 0
                                                },
                                                {
                                                    label: 'Ni za oddajo',
                                                    value: 'not-for-rent',
                                                    disabled: consider_deleted
                                                }
                                            ],
                                            value: this.state.status,
                                            onChange: (e)=>{
                                                const val = e.currentTarget.value;
                                                if (val == 'reversed' || val == 'no-show') {
                                                    this.setState({
                                                        status_change_requested: true,
                                                        status_change_requested_value: val
                                                    });
                                                    return;
                                                }
                                                this.setState({
                                                    status: val
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                            style: {
                                                backgroundColor: '#2c85c1'
                                            },
                                            className: "mr-6",
                                            options: [
                                                {
                                                    label: 'Izberi status po meri',
                                                    value: ''
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_1,
                                                    value: 'custom-status-1'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_2,
                                                    value: 'custom-status-2'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_3,
                                                    value: 'custom-status-3'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_4,
                                                    value: 'custom-status-4'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_5,
                                                    value: 'custom-status-5'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_6,
                                                    value: 'custom-status-6'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_7,
                                                    value: 'custom-status-7'
                                                }
                                            ],
                                            value: this.state.status_2 ?? '',
                                            onChange: (e)=>{
                                                this.setState({
                                                    status_2: e.currentTarget.value
                                                });
                                            }
                                        }),
                                        this.state.reservation.id_reservation == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "document",
                                            text: "Ponudba",
                                            onClick: this.openOfferDialog
                                        }),
                                        [
                                            'test',
                                            'lodgge'
                                        ].indexOf(this.props.client) === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "projects",
                                            text: "Priprava ra\u010Duna",
                                            onClick: ()=>this.openInvoiceDialog()
                                        }),
                                        [
                                            'test',
                                            'lodgge'
                                        ].indexOf(this.props.client) === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Group, {
                                            className: "ml-12",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    minimal: true,
                                                    icon: "projects",
                                                    text: "Depozit",
                                                    className: "mr-2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    minimal: true,
                                                    icon: "projects",
                                                    text: "Potrditev rezervacije"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Group, {
                                    align: (0, _core.Alignment).RIGHT,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "help"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: ()=>{
                                                this.closeDialog(false, true);
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col flex-grow main-content",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "h-1",
                                    children: this.state.loading == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ProgressBar), {
                                        animate: true,
                                        intent: "warning",
                                        className: "h-1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-row -mx-2 px-4 pt-4 pb-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-none px-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                        className: this.state.validation_failed_fields.indexOf('check_in_out') == -1 ? '' : 'validation-failed',
                                                        labelFor: "from-until-input",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                label: "Obdobje",
                                                                tooltip: "Obdobje rezervacije"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateRangeInput3), {
                                                                id: "from-until-input",
                                                                dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                                dateFnsFormat: 'dd. MM. yyyy',
                                                                locale: "sl",
                                                                allowSingleDayRange: false,
                                                                contiguousCalendarMonths: false,
                                                                shortcuts: false,
                                                                startInputProps: {
                                                                    placeholder: 'Od',
                                                                    className: 'from-until',
                                                                    inputRef: (ref)=>{
                                                                        this.startDateRef.current = ref;
                                                                    }
                                                                },
                                                                endInputProps: {
                                                                    placeholder: 'Do',
                                                                    className: 'from-until'
                                                                },
                                                                minDate: new Date('1900-01-01'),
                                                                maxDate: this.getMaxDate(),
                                                                selectAllOnFocus: true,
                                                                onChange: (selectedRange)=>{
                                                                    this.setState({
                                                                        check_in: selectedRange[0] === null ? null : (0, _momentDefault.default)(selectedRange[0]).toDate(),
                                                                        check_out: selectedRange[1] === null ? null : (0, _momentDefault.default)(selectedRange[1]).toDate()
                                                                    });
                                                                },
                                                                value: [
                                                                    this.state.check_in,
                                                                    this.state.check_out
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                                            className: 'flex ' + (this.state.validation_failed_fields.indexOf('id_customer') == -1 ? '' : 'validation-failed'),
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerSelectDefault.default), {
                                                                itemSelected: (item)=>{
                                                                    this.setState({
                                                                        id_customer: item.id_customer,
                                                                        phone: item.phone,
                                                                        email: item.email
                                                                    });
                                                                    if (this.phone_input_ref.current !== null) this.phone_input_ref.current.focus();
                                                                },
                                                                addPersonClick: (query)=>{
                                                                    this.openSelectCustomerDialog({
                                                                        name: '',
                                                                        surname: query,
                                                                        email: '',
                                                                        id_country: '',
                                                                        phone: '',
                                                                        post_office: '',
                                                                        address: ''
                                                                    });
                                                                },
                                                                fieldTitle: "Nosilec"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "flex flex-row justify-between items-start",
                                                            children: this.state.id_customer == null || this.state.id_customer == -1 ? null : (()=>{
                                                                const customer = this.props.customers[this.state.id_customer];
                                                                if (customer === undefined) return null;
                                                                const customer_data_line_1 = customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name;
                                                                const customer_data_line_2 = customer.address;
                                                                const customer_data_line_3_arr = [];
                                                                if (customer.post_code.length > 0 || customer.post_office.length > 0) customer_data_line_3_arr.push((customer.post_code + ' ' + customer.post_office).trim());
                                                                if (customer.id_country !== null) customer_data_line_3_arr.push(this.props.countries[customer.id_country].iso_3166_1_a2);
                                                                const customer_data_line_3 = customer_data_line_3_arr.join(', ');
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "leading-relaxed",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "font-medium",
                                                                                    children: customer_data_line_1
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    children: customer_data_line_2
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    children: customer_data_line_3
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                            icon: "edit",
                                                                            minimal: true,
                                                                            onClick: ()=>{
                                                                                this.openSelectCustomerDialog({
                                                                                    name: '',
                                                                                    surname: '',
                                                                                    email: '',
                                                                                    id_country: '',
                                                                                    phone: '',
                                                                                    post_office: '',
                                                                                    address: ''
                                                                                }, customer);
                                                                            }
                                                                        })
                                                                    ]
                                                                });
                                                            })()
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-none px-2 w-1/3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "w-1/2 flex flex-col mr-4",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                labelFor: "phone-input",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                        label: "Telefon",
                                                                        tooltip: "Vpi\u0161ite telefon"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                                        id: "phone-input",
                                                                        value: this.state.phone,
                                                                        onChange: (event)=>{
                                                                            this.setState({
                                                                                phone: event.target.value
                                                                            });
                                                                        },
                                                                        inputRef: this.phone_input_ref,
                                                                        disabled: this.state.id_customer === null || this.state.id_customer == -1
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "w-1/2 flex flex-col mr-4",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                labelFor: "channel-input",
                                                                className: this.state.validation_failed_fields.indexOf('id_channel') == -1 ? '' : 'validation-failed',
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                        label: "Prodajni kanal",
                                                                        tooltip: "Prodajni kanal"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                                        id: "channel-input",
                                                                        fill: true,
                                                                        options: [
                                                                            {
                                                                                label: 'Izberi prodajni kanal',
                                                                                value: -1
                                                                            }
                                                                        ].concat(Object.values(this.props.channels).sort((a, b)=>a.ord - b.ord).map((item)=>{
                                                                            return {
                                                                                label: item.title,
                                                                                value: item.id_channel
                                                                            };
                                                                        })),
                                                                        value: this.state.id_channel,
                                                                        onChange: (e)=>{
                                                                            this.setState({
                                                                                id_channel: e.currentTarget.value
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "w-1/2 flex flex-col mr-4",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                labelFor: "email-input",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                        label: "E-po\u0161ta",
                                                                        tooltip: "Vpi\u0161ite e-po\u0161tni naslov"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                                        id: "email-input",
                                                                        value: this.state.email,
                                                                        onChange: (event)=>{
                                                                            this.setState({
                                                                                email: event.target.value
                                                                            });
                                                                        },
                                                                        disabled: this.state.id_customer === null || this.state.id_customer == -1
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "w-1/2 flex flex-col mr-4",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                labelFor: "market-segmentation",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                        label: "Tr\u017Eni segment",
                                                                        tooltip: "Tr\u017Eni segment"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                                        id: "market-segmentation",
                                                                        fill: true,
                                                                        options: [
                                                                            {
                                                                                label: "Izberi tr\u017Eni segment",
                                                                                value: -1
                                                                            }
                                                                        ].concat(Object.values(this.props.market_segmentation).sort((a, b)=>a.ord - b.ord).map((item)=>{
                                                                            return {
                                                                                label: item.title,
                                                                                value: item.id_market_segmentation
                                                                            };
                                                                        })),
                                                                        value: this.state.id_market_segmentation,
                                                                        onChange: (e)=>{
                                                                            this.setState({
                                                                                id_market_segmentation: e.currentTarget.value
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex flex-col flex-grow mr-4",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "flex flex-row content-start justify-between pt-3",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _peopleCountInputDefault.default), {
                                                                adult_title: 'Odrasli',
                                                                child_1_title: '0-' + this.props.general_settings.reservation_child_age_limit_1 + ' let',
                                                                child_2_title: this.props.general_settings.reservation_child_age_limit_1 + '-' + this.props.general_settings.reservation_child_age_limit_2 + ' let',
                                                                adult_count: this.state.guest_adult_count,
                                                                child_1_count: this.state.guest_child_1_count,
                                                                child_2_count: this.state.guest_child_2_count,
                                                                onChangeAdultCount: (val)=>{
                                                                    this.setState({
                                                                        guest_adult_count: val
                                                                    });
                                                                },
                                                                onChangeChild1Count: (val)=>{
                                                                    this.setState({
                                                                        guest_child_1_count: val
                                                                    });
                                                                },
                                                                onChangeChild2Count: (val)=>{
                                                                    this.setState({
                                                                        guest_child_2_count: val
                                                                    });
                                                                },
                                                                disabled: Object.keys(this.state.main_table_items).length > 0
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex flex-col flex-1 px-2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Tabs), {
                                                className: "flex flex-col flex-grow reservation-additional-info-tabs",
                                                id: "reservation-additional-info-tabs",
                                                vertical: false,
                                                onChange: (new_tab_id)=>{
                                                    this.setState({
                                                        additional_info_tab_id: new_tab_id
                                                    });
                                                },
                                                selectedTabId: this.state.additional_info_tab_id,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                        id: "comment",
                                                        title: "Opomba",
                                                        panelClassName: "flex-grow",
                                                        panel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                            className: "table-full-h",
                                                            fill: true,
                                                            onChange: (e)=>{
                                                                this.setState({
                                                                    note: e.target.value
                                                                });
                                                            },
                                                            value: this.state.note
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                        id: "offers",
                                                        title: "Dokumenti",
                                                        panelClassName: "flex-grow h-40",
                                                        panel: this.state.reservation === null || this.state.reservation.id_reservation === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentsDefault.default), {
                                                            id_document: this.state.reservation.id_reservation,
                                                            document_type: "reservation",
                                                            deep: true
                                                        })
                                                    }),
                                                    false,
                                                    false,
                                                    false,
                                                    false
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-col mt-2 pt-2 pb-2 px-4 reservation-services",
                                    children: reservation_items_without_person_day.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                    className: "bp5-heading",
                                                    children: "Storitve na rezervaciji"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "flex flex-row flex-wrap",
                                                children: reservation_items_without_person_day.map((item, idx)=>{
                                                    const id_item_price_list = this.state.check_in === null ? null : (0, _priceHelperDefault.default).FindBestPriceListMatch((0, _momentDefault.default)(this.state.check_in), item.item.price_lists);
                                                    const price = id_item_price_list === null ? 0 : parseFloat(item.item.price_lists[id_item_price_list].price);
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                        className: "w-1/4",
                                                        label: item.item.internal_code + " \u2022 " + item.item.title + " \u2022 " + price.toLocaleString(undefined, {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }) + " \u20AC",
                                                        checked: item.selected,
                                                        disabled: item.mandatory,
                                                        onChange: (event)=>{
                                                            if (item.mandatory) return;
                                                            const reservation_items = this.state.reservation_items;
                                                            reservation_items[idx].selected = event.target.checked;
                                                            this.setState({
                                                                reservation_items
                                                            });
                                                        }
                                                    }, 'reservation-item-' + idx);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-grow flex-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "w-full flex flex-col px-4 pb-4 pt-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                            className: "bp5-heading",
                                                            children: "Osebe na rezervaciji"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex flex-row",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                    icon: "plus",
                                                                    intent: "primary",
                                                                    className: "mr-4",
                                                                    onClick: ()=>{
                                                                        if (this.state.main_table_items_sort_ids.length == 0 && this.state.id_customer !== null && this.props.customers[this.state.id_customer] !== undefined && this.props.customers[this.state.id_customer] !== undefined && this.props.customers[this.state.id_customer].type == 'natural') this.setState({
                                                                            copy_customer_to_guest: true
                                                                        });
                                                                        else this.openEditReservationCustomerDialog(null);
                                                                    },
                                                                    elementRef: (ref)=>{
                                                                        this.addPersonRef.current = ref;
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                                                    className: "mr-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                            icon: "tick",
                                                                            onClick: ()=>{
                                                                                this.setMainTableItemsChecked(true);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                            icon: "square",
                                                                            onClick: ()=>{
                                                                                this.setMainTableItemsChecked(false);
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                    disabled: !any_checked_items || this.state.main_table_items_changed === true,
                                                                    className: "mr-2",
                                                                    onClick: ()=>{
                                                                        this.openInvoiceDialog(this.state.main_table_items_checked, this.state.customer_items_customers_selected);
                                                                    },
                                                                    children: "Izdelaj ra\u010Dun"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                                                    className: "mr-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                            disabled: !any_checked_items || !can_log_out_customers,
                                                                            onClick: ()=>{
                                                                                const state = {
                                                                                    main_table_items: {
                                                                                        ...this.state.main_table_items
                                                                                    },
                                                                                    guest_book_items: {
                                                                                        ...this.state.guest_book_items
                                                                                    },
                                                                                    main_table_items_changed: true
                                                                                };
                                                                                for(let i = 0; i < this.state.main_table_items_checked.length; i++){
                                                                                    const id_reservation_customer = this.state.main_table_items_checked[i];
                                                                                    const reservation_customer = {
                                                                                        ...this.state.main_table_items[id_reservation_customer]
                                                                                    };
                                                                                    reservation_customer.check_out = this.toIsoStringWithTime(new Date());
                                                                                    reservation_customer.checked_out = true;
                                                                                    state.main_table_items[reservation_customer.id_reservation_customer] = reservation_customer;
                                                                                    if (reservation_customer.id_guest_book !== null) {
                                                                                        const guest_book_item = {
                                                                                            ...state.guest_book_items[reservation_customer.id_guest_book] || this.props.guest_book_items[reservation_customer.id_guest_book]
                                                                                        };
                                                                                        guest_book_item.etourism_status = 'waiting';
                                                                                        state.guest_book_items[reservation_customer.id_guest_book] = guest_book_item;
                                                                                    }
                                                                                }
                                                                                this.setState(state);
                                                                            },
                                                                            children: "Odjavi s trenutnim datumom/\u010Dasom"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                            disabled: !any_checked_items || !can_log_out_customers,
                                                                            onClick: ()=>{
                                                                                const main_table_items = {
                                                                                    ...this.state.main_table_items
                                                                                };
                                                                                for(let i = 0; i < this.state.main_table_items_checked.length; i++){
                                                                                    const id_reservation_customer = this.state.main_table_items_checked[i];
                                                                                    const reservation_customer = {
                                                                                        ...this.state.main_table_items[id_reservation_customer]
                                                                                    };
                                                                                    reservation_customer.checked_out = true;
                                                                                    main_table_items[reservation_customer.id_reservation_customer] = reservation_customer;
                                                                                }
                                                                                this.setState({
                                                                                    main_table_items,
                                                                                    main_table_items_changed: true
                                                                                });
                                                                                this.setMainTableItemsChecked(false);
                                                                            },
                                                                            children: "Ozna\u010Di kot odjavljen"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                    disabled: !any_checked_items || this.state.main_table_items_changed === true,
                                                                    onClick: async ()=>{
                                                                        const dispatch = this.props.dispatch;
                                                                        const token = this.props.token;
                                                                        const id_guest_books = [];
                                                                        for(let i = 0; i < this.state.main_table_items_checked.length; i++){
                                                                            const customer = this.props.reservation_customers[this.state.main_table_items_checked[i]];
                                                                            if (customer === undefined) continue;
                                                                            if (customer.id_guest_book === null) continue;
                                                                            id_guest_books.push(customer.id_guest_book);
                                                                        }
                                                                        this.increaseLoading();
                                                                        await (0, _reservations.sendReservationCustomersToETourism)(this.props.api_url, id_guest_books, 'normal', token);
                                                                        await (0, _guests.loadGuestBookItems)(this.props.api_url, dispatch, token);
                                                                        this.decreaseLoading();
                                                                        this.setMainTableItemsChecked(false);
                                                                    },
                                                                    children: "Po\u0161lji na e-Turizem"
                                                                }),
                                                                !any_checked_items || this.state.main_table_items_changed === false ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "pt-1 ml-2",
                                                                    style: {
                                                                        color: '#db3737'
                                                                    },
                                                                    children: "Spremenili ste podatke o gostih. Pred po\u0161iljanjem shranite rezervacijo."
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "flex-1"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                                    checked: this.state.guests_checked_in,
                                                                    className: "mt-1 mb-0",
                                                                    onChange: (event)=>this.setState({
                                                                            guests_checked_in: event.target.checked
                                                                        }),
                                                                    children: "Gosti prijavljeni"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex-grow overflow-y-auto",
                                                    style: {
                                                        flexBasis: '0'
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReservationGuests, {
                                                        main_table_items: this.state.main_table_items,
                                                        main_table_items_sort_ids: this.state.main_table_items_sort_ids,
                                                        main_table_items_sort_field: this.state.main_table_items_sort_field,
                                                        main_table_items_sort_direction: this.state.main_table_items_sort_direction,
                                                        main_table_items_checked: this.state.main_table_items_checked,
                                                        customers: this.props.customers,
                                                        countries: this.props.countries,
                                                        guest_book_items: this.props.guest_book_items,
                                                        guest_book_items_state: this.state.guest_book_items,
                                                        openDateTimePickerDialog: this.openDateTimePickerDialog,
                                                        openInvoiceDialog: this.openInvoiceDialog,
                                                        onCheckedItem: this.setMainTableItemChecked,
                                                        setMainTableItemsSort: this.setMainTableItemsSort,
                                                        editItem: (id_reservation_customer)=>{
                                                            this.openEditReservationCustomerDialog(this.state.main_table_items[id_reservation_customer]);
                                                        },
                                                        deleteItem: this.deleteMainTableItem,
                                                        documents: customer_documents,
                                                        invoices: this.props.invoices,
                                                        openEditInvoiceDialog: this.openEditInvoiceDialog,
                                                        openDocumentListDialog: this.openDocumentListDialog,
                                                        getAge: this.getAge,
                                                        display_copy_guest_to_reservation_customer: this.state.id_customer === null || this.state.id_customer == -1,
                                                        copyGuestToReservationCustomer: this.copyGuestToReservationCustomer
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-col",
                                            style: {
                                                width: '35%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "px-4 pb-4 pt-2 flex flex-col flex-grow",
                                                    style: {
                                                        backgroundColor: 'rgb(195, 210, 218)'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                            className: "bp5-heading",
                                                            children: "Dodatne storitve/artikli gosta"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "flex-grow relative",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "overflow-y-auto absolute inset-0 pr-2",
                                                                children: this.state.main_table_items_sort_ids.map((id_reservation_customer)=>{
                                                                    const user = this.state.main_table_items[id_reservation_customer];
                                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "pl-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "flex flex-row items-center",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                                                        checked: this.state.customer_items_customers_selected.indexOf(user.id_reservation_customer) != -1,
                                                                                        onChange: (event)=>{
                                                                                            let ids = [
                                                                                                ...this.state.customer_items_customers_selected
                                                                                            ];
                                                                                            if (event.target.checked === false) ids.splice(ids.indexOf(user.id_reservation_customer), 1);
                                                                                            else ids.push(user.id_reservation_customer);
                                                                                            this.setState({
                                                                                                customer_items_customers_selected: ids
                                                                                            });
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                                                                        className: "bp5-heading mt-2 flex-grow",
                                                                                        children: this.props.customers[user.id_customer] === undefined ? '' : this.props.customers[user.id_customer].surname + ' ' + this.props.customers[user.id_customer].name
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                                        icon: "plus",
                                                                                        minimal: false,
                                                                                        small: true,
                                                                                        onClick: ()=>{
                                                                                            this.setState({
                                                                                                add_edit_item_with_count_dialog_visible: true,
                                                                                                add_edit_item_with_count_dialog_id_reservation_customer: user.id_reservation_customer,
                                                                                                add_edit_item_with_count_dialog_quantity: 0,
                                                                                                add_edit_item_with_count_dialog_id_item: null
                                                                                            });
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            this.state.customer_items.filter((item)=>item.id_reservation_customer == user.id_reservation_customer).map((item)=>{
                                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "flex flex-row",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                                                                            className: "flex-grow",
                                                                                            alignText: "left",
                                                                                            small: true,
                                                                                            minimal: true,
                                                                                            fill: true,
                                                                                            onClick: ()=>{
                                                                                                this.setState({
                                                                                                    add_edit_item_with_count_dialog_visible: true,
                                                                                                    add_edit_item_with_count_dialog_id_reservation_customer: item.id_reservation_customer,
                                                                                                    add_edit_item_with_count_dialog_quantity: item.quantity,
                                                                                                    add_edit_item_with_count_dialog_id_item: item.id_item
                                                                                                });
                                                                                            },
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                                                                    icon: "edit"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                                    className: "ml-2",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                                            className: "mr-4 font-bold",
                                                                                                            children: (0, _numbers.toLocal)(parseFloat(item.quantity, 0)) + 'x'
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                                            children: this.props.items[item.id_item].internal_code + " \u2022 " + this.props.items[item.id_item].title
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "w-20 text-right mr-2",
                                                                                            children: (0, _numbers.toLocal)(parseFloat(item.quantity) * parseFloat(this.props.items[item.id_item].price_lists[item.id_item_price_list].price), 2) + " \u20AC"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                                            icon: "trash",
                                                                                            intent: "danger",
                                                                                            minimal: true,
                                                                                            small: true,
                                                                                            onClick: ()=>{
                                                                                                this.setState({
                                                                                                    delete_request__id_reservation_customer: item.id_reservation_customer,
                                                                                                    delete_request__id_item: item.id_item
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                }, 'services-user-' + item.id_reservation_customer + '-' + item.id_item_price_list);
                                                                            })
                                                                        ]
                                                                    }, 'services-user-' + user.id_customer);
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "px-4 pb-4 pt-4 flex flex-col",
                                                    style: {
                                                        backgroundColor: 'rgb(170, 191, 203)',
                                                        borderRadius: '0px 0px 6px 0px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex flex-row font-bold",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                                    className: "bp5-heading",
                                                                    children: "Informativni izra\u010Dun"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex flex-row",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "flex-grow",
                                                                    children: "Storitve na rezervaciji"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    children: parseFloat(calculated_reservation_price.accommodation_items_price).toLocaleString(undefined, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) + " \u20AC"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex flex-row",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "flex-grow",
                                                                    children: "Dodatne storitve/artikli gosta"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    children: parseFloat(calculated_reservation_price.additional_customer_items_price).toLocaleString(undefined, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) + " \u20AC"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex flex-row",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "flex-grow",
                                                                    children: "Turisti\u010Dna taksa"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    children: parseFloat(calculated_reservation_price.total_tourist_tax).toLocaleString(undefined, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) + " \u20AC"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex flex-row font-bold mt-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "flex-grow",
                                                                    children: "Skupaj za pla\u010Dilo"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    children: parseFloat(calculated_reservation_price.total).toLocaleString(undefined, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) + " \u20AC"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
Reservation.propTypes = {
    closeReservation: (0, _propTypesDefault.default).func,
    deleteReservation: (0, _propTypesDefault.default).func,
    reservation: (0, _propTypesDefault.default).object
};
function mapStateToProps(state) {
    return {
        channels: state.CodeTablesSlice.channels,
        customers: state.CodeTablesSlice.customers,
        countries: state.CodeTablesSlice.countries,
        accommodations: state.CodeTablesSlice.accommodations,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
        accommodation_item_place_items: state.CodeTablesSlice.accommodation_item_place_items,
        market_segmentation: state.CodeTablesSlice.market_segmentation,
        measuring_units: state.CodeTablesSlice.measuring_units,
        items: state.CodeTablesSlice.items,
        tax_rates: state.CodeTablesSlice.tax_rates,
        tourist_taxes: state.CodeTablesSlice.tourist_taxes,
        reservations: state.ReservationSlice.reservations,
        reservation_customers: state.ReservationSlice.reservation_customers,
        reservation_customers_by_id_reservations: state.ReservationSlice.reservation_customers_by_id_reservations,
        reservation_customer_items: state.ReservationSlice.reservation_customer_items,
        api_url: state.CodeTablesSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        client: state.ConstantsSlice.client,
        invoices: state.BusinessSlice.invoices,
        guest_book_items: state.GuestSlice.guest_book_items,
        document_associations: state.DocumentSlice.document_associations_id_documents,
        document_types: state.DocumentSlice.document_types,
        general_settings: state.SettingsSlice.general,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        cash_registers: state.CashRegisterSlice.cash_registers,
        warehouses: state.CodeTablesSlice.warehouses
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Reservation);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","moment":"1e4qG","uuid":"b52pV","./EditReservationCustomerDialog":"3aYKZ","./SelectCustomerDialog":"ewc5P","../TextWithTooltip":"6kuHH","../DateTimePickerDialog":"5awK0","./InvoiceDialog":"fVAf4","../CustomerSelect":"8sizu","../business/EditInvoiceDialog":"kxL93","../business/WaitFiscalVerificationDialog":"bvSNl","../../slices/CodeTablesSlice":"hfPGz","../../api/CodeTables":"4GMYC","../AppToaster":"izixN","../../slices/BusinessSlice":"47JXm","../../api/Business":"fC7Hd","../../slices/DocumentSlice":"6gdAm","../../api/Documents":"hSEi5","../Documents":"jYQ4x","../../api/Reservations":"8B3n3","../../api/Guests":"8327Q","../../helpers/PriceHelper":"91cdD","../../helpers/InvoiceCreator":"d7VsE","../../helpers/DocumentsHelper":"ep63y","../../helpers/ReservationHelper":"ibz2t","../DocumentListDialog":"3h6Eg","../../helpers/Invoice":"jffQW","./AddEditItemWithCountDialog":"c7MaT","../../numbers":"jOh9w","./PeopleCountInput":"g0Iaj","../../slices/ReservationSlice":"kTPna","../../slices/GuestSlice":"bE5rS","../../slices/AppSlice":"aByTQ","../../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3aYKZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _select = require("@blueprintjs/select");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _parse = require("date-fns/parse");
var _parseDefault = parcelHelpers.interopDefault(_parse);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _dateTimePickerDialog = require("../DateTimePickerDialog");
var _dateTimePickerDialogDefault = parcelHelpers.interopDefault(_dateTimePickerDialog);
var _customerSelect = require("../CustomerSelect");
var _customerSelectDefault = parcelHelpers.interopDefault(_customerSelect);
var _simpleSuggest = require("../SimpleSuggest");
var _simpleSuggestDefault = parcelHelpers.interopDefault(_simpleSuggest);
var _appToaster = require("../AppToaster");
var _utils = require("../../utils");
class EditReservationCustomerDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.openDateTimePickerDialog = this.openDateTimePickerDialog.bind(this);
        this.closeDateTimePickerDialog = this.closeDateTimePickerDialog.bind(this);
        this.closeWithItem = this.closeWithItem.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.getTouristTaxForBirthDate = this.getTouristTaxForBirthDate.bind(this);
        this.findSimilarCustomers = this.findSimilarCustomers.bind(this);
        let customer = props.item === null ? null : props.customers[props.item.id_customer];
        if (customer === undefined) customer = null;
        const accommodation_item_place = props.accommodation_item_places[props.id_accommodation_item_place];
        const accommodation_item = props.accommodation_items[accommodation_item_place.id_accommodation_item];
        const accommodation = props.accommodations[accommodation_item.id_accommodation];
        let default_check_out_time = accommodation.default_check_out_time;
        let check_in = null;
        let check_out = null;
        if (props.item !== null) {
            check_in = new Date(props.item.check_in);
            check_out = props.item.check_out === null ? null : new Date(props.item.check_out);
        } else check_in = (0, _momentDefault.default)().toDate();
        if (check_out === null) check_out = props.default_check_out;
        const birthdate = customer === null || customer.birth_date === null ? null : new Date(customer.birth_date);
        let id_tourist_tax = props.item === null ? null : props.item.id_tourist_tax;
        if (props.item !== null && id_tourist_tax === null && birthdate !== null) id_tourist_tax = this.getTouristTaxForBirthDate(birthdate);
        this.state = {
            id_customer: props.item === null ? -1 : props.item.id_customer,
            id_country: customer === null ? -1 : customer.id_country,
            surname: customer === null ? '' : customer.surname,
            name: customer === null ? '' : customer.name,
            identification_number: customer === null ? '' : customer.identification_number,
            id_identification_type: customer === null ? '' : customer.id_identification_type,
            sex: customer === null ? null : customer.sex,
            delivery_addresses: customer === null ? [] : customer.delivery_addresses,
            birthdate,
            check_in,
            check_out,
            default_check_out_time: default_check_out_time,
            id_group: props.item === null ? '' : props.item.id_group,
            tourist_tax_checked: props.item === null ? true : props.item.pay_tourist_tax,
            e_tourist_checked: props.item === null ? true : props.item.add_to_guest_book,
            agree_further_processing: props.item === null ? false : props.item.agree_to_further_processing,
            date_picker_dialog_open: false,
            date_picker_dialog_state_name: null,
            id_tourist_tax,
            validation_failed_fields: [],
            close_dialog_confirm_open: false,
            accommodation_item_place,
            accommodation_item,
            accommodation,
            similar_customers: []
        };
        this.state.similar_customers = this.findSimilarCustomers(true);
    }
    componentDidMount() {
        const change_case = (val)=>{
            if (val === null) return val;
            if (this.props.general_settings.scanner_change_case == 'uppercase') return val.toUpperCase();
            if (this.props.general_settings.scanner_change_case == 'lowercase') return val.toLowerCase();
            if (this.props.general_settings.scanner_change_case == 'title-case') // from https://stackoverflow.com/a/37931321
            return val.replace(/\S+/g, (str)=>str.charAt(0).toUpperCase() + str.substr(1).toLowerCase());
            return val;
        };
        this._scanner_ws = new WebSocket('ws://127.0.0.1:9998/Scanner');
        this._scanner_ws.onmessage = (event)=>{
            const document_data = JSON.parse(event.data);
            console.log(document_data);
            const new_state = {};
            if (document_data.person_name !== null && document_data.person_name.length > 0) new_state.name = change_case(document_data.person_name);
            if (document_data.person_surname !== null && document_data.person_surname.length > 0) new_state.surname = change_case(document_data.person_surname);
            if (document_data.person_nationality !== null) for(let id_country in this.props.countries){
                const country = this.props.countries[id_country];
                if (document_data.person_nationality == country.iso_3166_1_a3 || document_data.person_nationality == country.iso_3166_1_a2) {
                    new_state.id_country = id_country;
                    break;
                }
            }
            if (document_data.person_birth_date !== null) {
                new_state.birthdate = new Date(document_data.person_birth_date);
                new_state.id_tourist_tax = this.getTouristTaxForBirthDate(new_state.birthdate);
                const input = document.querySelector('.check-in-button button');
                if (input !== null) input.focus();
            }
            if (document_data.document_type !== null) for(let id_identification_type in this.props.identification_types){
                const identification_type = this.props.identification_types[id_identification_type];
                if (identification_type.ocr_internal_code !== null && identification_type.ocr_internal_code.indexOf(';' + document_data.document_type + ';') > -1) {
                    new_state.id_identification_type = id_identification_type;
                    break;
                }
            }
            if (document_data.document_number !== null) new_state.identification_number = document_data.document_number;
            if (document_data.person_sex !== null) new_state.sex = document_data.person_sex == 'F' ? 'female' : 'male';
            this.setState(new_state);
        };
        this._scanner_ws.onopen = (event)=>{
            if (this._scanner_ws.readyState == WebSocket.OPEN) this._scanner_ws.send('START');
        };
    }
    componentWillUnmount() {
        try {
            if (this._scanner_ws.readyState == WebSocket.OPEN) this._scanner_ws.send('STOP');
        } catch (err) {}
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.name != this.state.name || prevState.surname != this.state.surname || prevState.id_country != this.state.id_country) this.findSimilarCustomers(false);
    }
    findSimilarCustomers(only_return) {
        if (this.state.name.length >= 2 && this.state.surname.length >= 2) {
            const name = this.state.name.toLowerCase();
            const surname = this.state.surname.toLowerCase();
            const found_customers = [];
            for(let id_customer in this.props.customers){
                // skip customer we're currently editing
                if (this.props.item !== null && this.props.item.id_customer === id_customer) continue;
                const customer = this.props.customers[id_customer];
                if (customer.name.toLowerCase().indexOf(name) != -1 && customer.surname.toLowerCase().indexOf(surname) != -1) {
                    if (this.state.id_country === null || this.state.id_country == '' || this.state.id_country == -1 || customer.id_country === null || customer.id_country == this.state.id_country) found_customers.push(customer);
                }
            }
            if (!only_return) this.setState({
                similar_customers: found_customers
            });
            return found_customers;
        } else {
            if (!only_return) this.setState({
                similar_customers: []
            });
            return [];
        }
    }
    openDateTimePickerDialog(state_name) {
        let value = this.state[state_name];
        if (state_name == 'check_out' && value === undefined) {
            value = (0, _momentDefault.default)();
            const default_check_out_time_arr = this.state.default_check_out_time.split(':');
            if (default_check_out_time_arr.length == 3) {
                value.hour(parseInt(default_check_out_time_arr[0], 10));
                value.minute(parseInt(default_check_out_time_arr[1], 10));
            }
            value = value.toDate();
        }
        this.setState({
            date_picker_dialog_open: true,
            date_picker_dialog_state_name: state_name,
            date_picker_dialog_value: value
        });
    }
    closeDateTimePickerDialog(newValue) {
        this.setState({
            date_picker_dialog_open: false
        });
        if (newValue !== false) {
            const obj = {};
            obj[this.state.date_picker_dialog_state_name] = newValue;
            this.setState(obj);
        }
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    // from https://stackoverflow.com/questions/4060004/calculate-age-given-the-birth-date-in-the-format-yyyymmdd/7091965#7091965
    getAge(birthdate) {
        if (birthdate === null) return 0;
        const today = new Date();
        let age = today.getFullYear() - birthdate.getFullYear();
        const m = today.getMonth() - birthdate.getMonth();
        if (m < 0 || m === 0 && today.getDate() < birthdate.getDate()) age--;
        return age;
    }
    getTouristTaxForBirthDate(birthdate) {
        const age_in_years = this.getAge(birthdate);
        let id_tourist_tax = 'f9a563f7-c2b8-457a-9efa-c23adc860902'; // full tax
        if (age_in_years < 7) id_tourist_tax = 'a3ada055-a624-4eb5-baad-49a2c84e6f6e';
        else if (age_in_years < 18) id_tourist_tax = '5a8d808e-eb7e-4adf-abef-ed4afb76779b';
        return id_tourist_tax;
    }
    closeWithItem(reopen) {
        const new_item = {
            id_reservation_customer: this.props.item === null ? -1 : this.props.item.id_reservation_customer,
            id_customer: this.state.id_customer,
            id_country: this.state.id_country,
            surname: this.state.surname,
            name: this.state.name,
            identification_number: this.state.identification_number,
            sex: this.state.sex,
            birthdate: this.state.birthdate,
            check_in: this.state.check_in,
            check_out: this.state.check_out,
            id_group: this.state.id_group,
            tourist_tax_checked: this.state.tourist_tax_checked,
            e_tourist_checked: this.state.e_tourist_checked,
            agree_further_processing: this.state.agree_further_processing,
            id_tourist_tax: this.state.id_tourist_tax,
            id_identification_type: this.state.id_identification_type,
            delivery_addresses: this.state.delivery_addresses
        };
        // validate missing/empty fields
        const validation_failed_fields = [];
        const validation_failed_field_titles = [];
        if (new_item.name.length == 0 && new_item.surname.length == 0) {
            validation_failed_fields.push('name');
            validation_failed_fields.push('surname');
            validation_failed_field_titles.push('ime in priimek');
        }
        if (new_item.birthdate === null) {
            validation_failed_fields.push('birthdate');
            validation_failed_field_titles.push('datum rojstva');
        }
        if (new_item.sex === null) {
            validation_failed_fields.push('sex');
            validation_failed_field_titles.push('spol');
        }
        if (new_item.id_country === null || new_item.id_country == -1) {
            validation_failed_fields.push('id_country');
            validation_failed_field_titles.push("dr\u017Eava");
        }
        if (new_item.id_tourist_tax === null) {
            validation_failed_fields.push('id_tourist_tax');
            validation_failed_field_titles.push("turisti\u010Dna taksa");
        }
        if (new_item.id_identification_type === null || new_item.id_identification_type == '') {
            validation_failed_fields.push('id_identification_type');
            validation_failed_field_titles.push('vrsta osebnega dokumenta');
        }
        if (new_item.identification_number === null || new_item.identification_number.length == 0) {
            validation_failed_fields.push('identification_number');
            validation_failed_field_titles.push("\u0161tevilka osebnega dokumenta");
        }
        if (new_item.check_in === null) {
            validation_failed_fields.push('check_in');
            validation_failed_field_titles.push('prijava');
        }
        if (new_item.check_out === null) {
            validation_failed_fields.push('check_out');
            validation_failed_field_titles.push('odjava');
        }
        this.setState({
            validation_failed_fields
        });
        if (validation_failed_fields.length > 0) {
            (0, _appToaster.AppToaster).show({
                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Za prijavo gosta, je potrebno izpolniti polja:",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: "\u2022 " + title
                            }, title))
                    ]
                }),
                intent: 'danger',
                icon: 'issue'
            });
            return false;
        }
        if (new_item.check_out !== null && new_item.check_out < new_item.check_in) {
            validation_failed_fields.push('check_in');
            validation_failed_fields.push('check_out');
            this.setState({
                validation_failed_fields
            });
            (0, _appToaster.AppToaster).show({
                message: 'Odjava ne sme biti pred prijavo',
                intent: 'danger',
                icon: 'issue'
            });
            return false;
        }
        this.props.closeEditReservationCustomerDialog(new_item, reopen);
    }
    closeDialog(confirm) {
        if (confirm) {
            this.setState({
                close_dialog_confirm_open: true
            });
            return;
        }
        this.props.closeEditReservationCustomerDialog();
    }
    render() {
        const groups = [];
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: !this.state.date_picker_dialog_open,
            onClose: ()=>this.closeDialog(true),
            className: "select-person-dialog",
            children: [
                !this.state.date_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePickerDialogDefault.default), {
                    closeDateTimePickerDialog: this.closeDateTimePickerDialog,
                    value: this.state.date_picker_dialog_value
                }),
                !this.state.close_dialog_confirm_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Zapri",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "help",
                    intent: (0, _core.Intent).PRIMARY,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.closeDialog(false);
                        this.setState({
                            close_dialog_confirm_open: false
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            close_dialog_confirm_open: false
                        });
                    },
                    children: "Res \u017Eelite zapreti brez shranjevanja?"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                            fixedToTop: false,
                            className: "bp5-dark",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                        children: "Vpis gosta"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                    align: (0, _core.Alignment).RIGHT,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        minimal: true,
                                        icon: "cross",
                                        onClick: ()=>this.closeDialog(true)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_BODY,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-grow flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-1 pr-2 flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerSelectDefault.default), {
                                                filter_type: "natural",
                                                itemSelected: (item)=>{
                                                    const id_tourist_tax = item.birth_date === null ? null : this.getTouristTaxForBirthDate(new Date(item.birth_date));
                                                    this.setState({
                                                        id_customer: item.id_customer,
                                                        name: item.name,
                                                        surname: item.surname,
                                                        id_country: item.id_country,
                                                        sex: item.sex,
                                                        birthdate: item.birth_date === null ? null : new Date(item.birth_date),
                                                        identification_number: item.identification_number,
                                                        id_identification_type: item.id_identification_type,
                                                        id_tourist_tax
                                                    });
                                                },
                                                fieldTitle: "Oseba",
                                                focus: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-row justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-person--surname",
                                                    className: 'flex-1 mr-1 ' + (this.state.validation_failed_fields.indexOf('surname') == -1 ? '' : 'validation-failed'),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Priimek",
                                                            tooltip: "Priimek"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                            id: "select-person--surname",
                                                            value: this.state.surname,
                                                            onChange: (event)=>this.setState({
                                                                    surname: event.target.value
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-person--name",
                                                    className: 'flex-1 mr-1 ' + (this.state.validation_failed_fields.indexOf('name') == -1 ? '' : 'validation-failed'),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Ime",
                                                            tooltip: "Ime"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                            id: "select-person--name",
                                                            value: this.state.name,
                                                            onChange: (event)=>this.setState({
                                                                    name: event.target.value
                                                                })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-row justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-person--sex",
                                                    className: this.state.validation_failed_fields.indexOf('sex') == -1 ? '' : 'validation-failed',
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Spol",
                                                            tooltip: "Spol"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.RadioGroup), {
                                                            id: "select-person--sex",
                                                            inline: true,
                                                            onChange: (event)=>{
                                                                this.setState({
                                                                    sex: event.target.value
                                                                });
                                                            },
                                                            selectedValue: this.state.sex,
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                                    label: "Mo\u0161ki",
                                                                    value: "male"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                                    label: "\u017Denski",
                                                                    value: "female"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                            labelFor: "select-person--birthdate",
                                                            className: this.state.validation_failed_fields.indexOf('birthdate') == -1 ? '' : 'validation-failed',
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                    label: "Datum rojstva",
                                                                    tooltip: "Datum rojstva"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                                    id: "select-person--birthdate",
                                                                    formatDate: (date)=>(0, _formatDefault.default)(date, 'dd. MM. yyyy'),
                                                                    parseDate: (str)=>(0, _parseDefault.default)(str.replaceAll(' ', ''), 'dd.MM.yyyy', new Date()),
                                                                    locale: "sl",
                                                                    inputProps: {
                                                                        placeholder: '01. 01. ' + new Date().getFullYear()
                                                                    },
                                                                    popoverProps: {
                                                                        position: 'right'
                                                                    },
                                                                    selectAllOnFocus: true,
                                                                    minDate: new Date('1900-01-01'),
                                                                    maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                                    onChange: (selectedDate, isUserChange)=>{
                                                                        let date = (0, _momentDefault.default)(selectedDate).toDate();
                                                                        if (isNaN(date)) date = null;
                                                                        const id_tourist_tax = date === null ? null : this.getTouristTaxForBirthDate(date);
                                                                        if (isUserChange) this.setState({
                                                                            birthdate: date,
                                                                            id_tourist_tax
                                                                        });
                                                                    },
                                                                    value: this.state.birthdate === null ? new Date() : (0, _formatISODefault.default)(this.state.birthdate)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "pt-5 ml-2 bp5-text-large font-bold select-person--age",
                                                            children: this.state.birthdate === null ? '' : this.getAge(this.state.birthdate) + ' let'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "select-person--identification-type",
                                            className: this.state.validation_failed_fields.indexOf('id_identification_type') == -1 ? '' : 'validation-failed',
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: "Vrsta osebnega dokumenta",
                                                    tooltip: "Vrsta osebnega dokumenta"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleSuggestDefault.default), {
                                                    matchKeyName: "title",
                                                    valueKeyName: "id_identification_type",
                                                    items: Object.values(this.props.identification_types).sort((a, b)=>a.ord - b.ord),
                                                    onItemSelect: (item)=>{
                                                        this.setState({
                                                            id_identification_type: item.id_identification_type
                                                        });
                                                    },
                                                    selectedItem: this.props.identification_types[this.state.id_identification_type],
                                                    placeholder: "I\u0161\u010Di"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "select-person--identification-number",
                                            className: this.state.validation_failed_fields.indexOf('identification_number') == -1 ? '' : 'validation-failed',
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: "\u0160tevilka osebnega dokumenta",
                                                    tooltip: "\u0160tevilka osebnega dokumenta"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                    id: "select-person--identification-number",
                                                    value: this.state.identification_number,
                                                    onChange: (event)=>this.setState({
                                                            identification_number: event.target.value
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "select-person--country",
                                            className: this.state.validation_failed_fields.indexOf('id_country') == -1 ? '' : 'validation-failed',
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: "Dr\u017Eava",
                                                    tooltip: "Dr\u017Eava"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleSuggestDefault.default), {
                                                    matchKeyName: "official_name_local",
                                                    valueKeyName: "id_country",
                                                    items: Object.values(this.props.countries),
                                                    onItemSelect: (item)=>{
                                                        this.setState({
                                                            id_country: item.id_country
                                                        });
                                                    },
                                                    selectedItem: this.props.countries[this.state.id_country],
                                                    placeholder: "I\u0161\u010Di"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "select-person--tourist-tax",
                                            className: this.state.validation_failed_fields.indexOf('id_tourist_tax') == -1 ? '' : 'validation-failed',
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: "Turisti\u010Dna taksa",
                                                    tooltip: "Turisti\u010Dna taksa"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleSuggestDefault.default), {
                                                    matchKeyName: "title",
                                                    valueKeyName: "id_tourist_tax",
                                                    items: Object.values(this.props.tourist_taxes).filter((x)=>x.id_accommodations === null || x.id_accommodations.indexOf(this.state.accommodation.id_accommodation) != -1).sort((a, b)=>a.ord - b.ord),
                                                    onItemSelect: (item)=>{
                                                        this.setState({
                                                            id_tourist_tax: item.id_tourist_tax
                                                        });
                                                    },
                                                    selectedItem: this.props.tourist_taxes[this.state.id_tourist_tax],
                                                    placeholder: "I\u0161\u010Di",
                                                    className: "tourist-tax-suggest"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-row",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-person--check-in-time",
                                                    className: 'check-in-button mr-4 ' + (this.state.validation_failed_fields.indexOf('check_in') == -1 ? '' : 'validation-failed'),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Prijava",
                                                            tooltip: "Prijava"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            id: "select-person--check-in-time",
                                                            onClick: ()=>{
                                                                this.openDateTimePickerDialog('check_in');
                                                            },
                                                            children: this.state.check_in === null || this.state.check_in === false ? "izberi datum in \u010Das" : this.getMomentFormatter('DD. MM. YYYY HH:mm').formatDate(this.state.check_in, 'sl')
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-person--check-out-time",
                                                    className: this.state.validation_failed_fields.indexOf('check_out') == -1 ? '' : 'validation-failed',
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Odjava",
                                                            tooltip: "Odjava"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            id: "select-person--check-out-time",
                                                            onClick: ()=>{
                                                                this.openDateTimePickerDialog('check_out');
                                                            },
                                                            children: this.state.check_out === null || this.state.check_out === false ? "izberi datum in \u010Das" : this.getMomentFormatter('DD. MM. YYYY HH:mm').formatDate(this.state.check_out, 'sl')
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex-grow"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "select-person--group",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: "Skupina",
                                                    tooltip: "Izberi skupino oz. vnesi novo"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Suggest), {
                                                    id: "select-person--group",
                                                    itemPredicate: (query, item, idx, exactMatch)=>{
                                                        return item.title.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                                    },
                                                    itemRenderer: (item, { handleClick, modifiers })=>{
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                            active: modifiers.active,
                                                            onClick: handleClick,
                                                            text: item.title
                                                        }, item.id_group);
                                                    },
                                                    items: groups,
                                                    onItemSelect: (item)=>{
                                                        this.setState({
                                                            group: item
                                                        });
                                                    },
                                                    openOnKeyDown: true,
                                                    popoverProps: {
                                                        targetProps: {
                                                            style: {
                                                                display: 'block'
                                                            }
                                                        },
                                                        minimal: true
                                                    },
                                                    fill: true,
                                                    createNewItemRenderer: (query, active, handleClick)=>{
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                            active: active,
                                                            onClick: handleClick,
                                                            text: 'Ustvari novo: ' + query
                                                        });
                                                    },
                                                    createNewItemFromQuery: (query)=>{
                                                        return {
                                                            id_group: Math.floor(Math.random() * Math.floor(999)) * -1,
                                                            title: query
                                                        };
                                                    },
                                                    selectedItem: this.state.id_group === null ? null : groups[this.state.id_group],
                                                    inputProps: {
                                                        placeholder: "I\u0161\u010Di"
                                                    },
                                                    inputValueRenderer: (item)=>item.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    checked: this.state.tourist_tax_checked,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            tourist_tax_checked: event.target.checked
                                                        });
                                                    },
                                                    children: "Obra\u010Dunaj turisti\u010Dno takso"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    className: "mb-5",
                                                    checked: this.state.e_tourist_checked,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            e_tourist_checked: event.target.checked
                                                        });
                                                    },
                                                    children: "Upo\u0161tevaj za e-Turizem in knjigo gostov"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    checked: this.state.agree_further_processing,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            agree_further_processing: event.target.checked
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Soglasje za nadaljnjo obdelavo",
                                                        tooltip: "Gost s tem sogla\u0161a za nadaljnjo obdelavo njegovih podatkov za potrebe tr\u017Eenja/obve\u0161\u010Danja",
                                                        inline: true
                                                    })
                                                })
                                            ]
                                        }),
                                        this.state.similar_customers.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "text-orange-600 flex flex-row",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                    icon: "warning-sign",
                                                    className: "mr-2",
                                                    size: 32
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            children: "Najdene obstoje\u010De stranke s podobnimi podatki:"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            children: this.state.similar_customers.map((customer)=>{
                                                                let value = customer.name + ' ' + customer.surname;
                                                                let additional_data = [];
                                                                if (customer.id_country !== null) additional_data.push(this.props.countries[customer.id_country].official_name_local);
                                                                if (customer.birth_date !== null) additional_data.push('RD ' + (0, _momentDefault.default)(customer.birth_date).format('DD.MM.YYYY'));
                                                                if (additional_data.length > 0) value += ' (' + additional_data.join(', ') + ')';
                                                                return value;
                                                            }).join(', ')
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        minimal: true,
                                        onClick: ()=>this.closeDialog(false),
                                        children: "Prekli\u010Di"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: (0, _core.Intent).PRIMARY,
                                        onClick: ()=>this.closeWithItem(true),
                                        children: "Shrani in dodaj novega"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: (0, _core.Intent).PRIMARY,
                                        onClick: ()=>this.closeWithItem(false),
                                        children: "Shrani in zapri"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
}
EditReservationCustomerDialog.propTypes = {
    closeEditReservationCustomerDialog: (0, _propTypesDefault.default).func,
    checkOut: (0, _propTypesDefault.default).any
};
function mapStateToProps(state) {
    return {
        countries: state.CodeTablesSlice.countries,
        customers: state.CodeTablesSlice.customers,
        identification_types: state.CodeTablesSlice.identification_types,
        tourist_taxes: state.CodeTablesSlice.tourist_taxes,
        accommodations: state.CodeTablesSlice.accommodations,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
        items: state.CodeTablesSlice.items,
        general_settings: state.SettingsSlice.general
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(EditReservationCustomerDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","@blueprintjs/select":"3IMc6","moment":"1e4qG","date-fns/formatISO":"an1FA","date-fns/format":"520Dk","date-fns/parse":"72XNY","../TextWithTooltip":"6kuHH","../DateTimePickerDialog":"5awK0","../CustomerSelect":"8sizu","../SimpleSuggest":"82Xt0","../AppToaster":"izixN","../../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5awK0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _utils = require("../utils");
class DateTimePickerDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            selectedDate: this.props.value
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: false,
            className: "date-picker-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                children: "Izbira datuma in \u010Dasa"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-grow flex-col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "self-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DatePicker3), {
                                    dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                    dateFnsFormat: 'dd. MM. yyyy',
                                    locale: "sl",
                                    timePickerProps: {
                                        showArrowButtons: true
                                    },
                                    timePrecision: (0, _datetime2.TimePrecision).MINUTE,
                                    onChange: (selectedDate, isUserChange)=>{
                                        this.setState({
                                            selectedDate
                                        });
                                    },
                                    value: this.state.selectedDate,
                                    maxDate: (0, _momentDefault.default)().add('10', 'years').toDate()
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>{
                                        this.props.closeDateTimePickerDialog(false);
                                    },
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDateTimePickerDialog(this.state.selectedDate);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
DateTimePickerDialog.propTypes = {
    closeDateTimePickerDialog: (0, _propTypesDefault.default).func,
    value: (0, _propTypesDefault.default).object
};
exports.default = DateTimePickerDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","moment":"1e4qG","../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kh8Vf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadDateFnsLocale", ()=>loadDateFnsLocale);
var _locale = require("date-fns/locale");
async function loadDateFnsLocale(localeCode) {
    return _locale[localeCode];
}

},{"date-fns/locale":"dElgW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8sizu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _select = require("@blueprintjs/select");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
class CustomerSelect extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            query: ''
        };
        this.itemRenderer = this.itemRenderer.bind(this);
        this.filterItems = this.filterItems.bind(this);
        this.search_field_id = Math.floor(Math.random() * Math.floor(99999999));
        this.has_focused = false;
    }
    componentDidMount() {
        if (this.props.focus === true && !this.has_focused) {
            const main_person_input = document.querySelector('.main-person-input-' + this.search_field_id + ' input');
            if (main_person_input !== null) {
                main_person_input.focus();
                this.has_focused = true;
            }
        }
    //if (this.state.names.length == 0)
    //{
    //	Promise.all([
    //		fetch('names.txt')
    //			.then(function(response) {
    //				return response.text();
    //			})
    //			.then(function(text) {
    //				return text.split('\n');
    //			}),
    //		fetch('surnames.txt')
    //			.then(function(response) {
    //				return response.text();
    //			})
    //			.then(function(text) {
    //				return text.split('\n');
    //			}),
    //	]).then(values => {
    //		let names = [];
    //		/*for (let i=0; i<values[1].length; i++)
    //		{
    //			names.push(values[0][i % values[0].length] + ' ' + values[1][i]);
    //		}*/
    //		names = values[1];
    //		
    //		console.log('Name count: ' + names.length);
    //		
    //		this.setState({
    //			names: names.map(x => { return { name: x }; }),
    //		});
    //	});
    //}
    }
    itemRenderer(item, props) {
        /*const text = <div className='flex flex-row'>
			<div className='w-1/4 mr-2'>
				{this.highlightText(item.surname + ' ' + item.name, props.query)}
			</div>
			<div className='w-1/4 mr-2'>
				{ item.email }
			</div>
			<div className='w-1/4 mr-2'>
				{ this.props.countries[item.id_country].official_name_local }
			</div>
			<div className='w-1/4'>
				{ item.phone }
			</div>
		</div>;*/ const label_arr = [];
        /*const birth_date = (item.birth_date === null ? null : new Date(item.birth_date));
		if (birth_date !== null) {
			label_arr.push(birth_date.getDate() + '.' + (birth_date.getMonth()+1) + '.' + birth_date.getFullYear());
		}
		if (item.identification_number !== null && item.identification_number.length > 0) {
			label_arr.push(
				(item.id_identification_type === null ?
					'' : this.props.identification_types[item.id_identification_type].internal_code + ' '
				) +
				item.identification_number
			);
		}*/ if (item.tax_number !== null && item.tax_number.length > 0) label_arr.push((item.vat_prefix === null ? '' : item.vat_prefix) + item.tax_number);
        if (item.phone !== null && item.phone.length > 0) label_arr.push(item.phone);
        if (item.email !== null && item.email.length > 0) label_arr.push(item.email);
        if (item.id_country !== null) label_arr.push(this.props.countries[item.id_country].common_name_international);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
            active: props.modifiers.active,
            disabled: props.modifiers.disabled,
            text: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: this.highlightText(item.type == 'company' ? item.company_name : item.surname + ' ' + item.name, props.query)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: item.birth_date === null ? '' : (0, _momentDefault.default)(item.birth_date).format('DD.MM.YYYY')
                        })
                    ]
                })
            }),
            className: "items-stretch",
            label: label_arr.join(', '),
            onClick: props.handleClick
        }, 'item-' + item.id_customer);
    // return <div>
    // 	{this.highlightText(item.name, props.query)}
    // </div>;
    }
    filterItems(query, items) {
        let filtered_items = [
            ...items
        ];
        if (this.props.itemFilter !== undefined && this.props.itemFilter !== null) filtered_items = filtered_items.filter(this.props.itemFilter);
        if (query.length > 0) {
            const normalized_query = query.toLowerCase();
            filtered_items = filtered_items.filter((item)=>{
                if (this.props.filter_type == 'natural' && item.type == 'company') return false;
                if (this.props.filter_type == 'company' && item.type == 'natural') return false;
                const normalized_name = item.type == 'company' ? item.company_name.toLowerCase() : item.surname.toLowerCase() + ' ' + item.name.toLowerCase();
                if (`${normalized_name}`.indexOf(normalized_query) > -1) return true;
                return false;
            });
        }
        // limit results to 50 items
        if (filtered_items.length >= 50) filtered_items = filtered_items.slice(0, 51);
        return filtered_items;
    }
    highlightText(text, query) {
        let lastIndex = 0;
        const words = query.split(/\s+/).filter((word)=>word.length > 0).map(this.escapeRegExpChars);
        if (words.length === 0) return [
            text
        ];
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens = [];
        while(true){
            const match = regexp.exec(text);
            if (!match) break;
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) tokens.push(before);
            lastIndex = regexp.lastIndex;
            tokens.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                children: match[0]
            }, lastIndex));
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) tokens.push(rest);
        return tokens;
    }
    escapeRegExpChars(text) {
        return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    }
    render() {
        const form_group_cls = this.props.formGroupCls === undefined ? '' : this.props.formGroupCls;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
            labelFor: "main-person-input",
            className: 'flex-grow ' + form_group_cls,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: this.props.titleClassName || '',
                    children: this.props.fieldTitle
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Suggest), {
                    id: "main-person-input",
                    inputValueRenderer: (item)=>item.type == 'natural' ? item.surname + ' ' + item.name : item.company_name,
                    itemListPredicate: this.filterItems,
                    itemRenderer: this.itemRenderer,
                    items: Object.values(this.props.customers),
                    onItemSelect: (item)=>{
                        this.props.itemSelected(item);
                        this.setState({
                            query: ''
                        });
                    },
                    selectedItem: null,
                    openOnKeyDown: true,
                    inputProps: {
                        rightElement: this.props.addPersonClick === undefined ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            icon: 'plus',
                            minimal: true,
                            disabled: this.state.query.length < 3,
                            onClick: ()=>{
                                this.props.addPersonClick(this.state.query);
                                this.setState({
                                    query: ''
                                });
                            }
                        }),
                        className: 'main-person-input main-person-input-' + this.search_field_id,
                        placeholder: "I\u0161\u010Di"
                    },
                    popoverProps: {
                        targetProps: {
                            style: {
                                display: 'block'
                            }
                        },
                        minimal: true
                    },
                    query: this.state.query,
                    onQueryChange: (query)=>{
                        this.setState({
                            query
                        });
                        if (this.props.queryChanged !== undefined) this.props.queryChanged(query);
                    }
                })
            ]
        });
    }
}
CustomerSelect.propTypes = {
    itemSelected: (0, _propTypesDefault.default).func,
    addPersonClick: (0, _propTypesDefault.default).func,
    queryChanged: (0, _propTypesDefault.default).func,
    fieldTitle: (0, _propTypesDefault.default).string
};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        countries: state.CodeTablesSlice.countries,
        identification_types: state.CodeTablesSlice.identification_types
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(CustomerSelect);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@blueprintjs/select":"3IMc6","moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"82Xt0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@blueprintjs/core");
var _select = require("@blueprintjs/select");
function SimpleSuggest(props) {
    const { matchKeyName, valueKeyName, items, onItemSelect, selectedItem, placeholder, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Suggest), {
        itemPredicate: (query, item, idx, exactMatch)=>{
            return items[idx][matchKeyName].toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
        itemRenderer: (item, { handleClick, modifiers })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                active: modifiers.active,
                onClick: handleClick,
                text: item[matchKeyName]
            }, item[valueKeyName]);
        },
        items: items,
        onItemSelect: (item)=>{
            onItemSelect(item);
        },
        openOnKeyDown: false,
        resetOnClose: true,
        popoverProps: {
            targetProps: {
                style: {
                    display: 'block'
                }
            },
            minimal: true
        },
        fill: true,
        selectedItem: selectedItem,
        inputProps: {
            placeholder: placeholder,
            className: className
        },
        inputValueRenderer: (item)=>item[matchKeyName]
    });
}
exports.default = SimpleSuggest;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@blueprintjs/core":"6Mq52","@blueprintjs/select":"3IMc6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"izixN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppToaster", ()=>AppToaster);
var _core = require("@blueprintjs/core");
const AppToaster = (0, _core.Toaster).create({
    //className: 'recipe-toaster',
    position: (0, _core.Position).TOP
});

},{"@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewc5P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _parse = require("date-fns/parse");
var _parseDefault = parcelHelpers.interopDefault(_parse);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _customerSelect = require("../CustomerSelect");
var _customerSelectDefault = parcelHelpers.interopDefault(_customerSelect);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _codeTables = require("../../api/CodeTables");
var _simpleSuggest = require("../SimpleSuggest");
var _simpleSuggestDefault = parcelHelpers.interopDefault(_simpleSuggest);
var _appToaster = require("../AppToaster");
var _utils = require("../../utils");
class SelectCustomerDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.closeDialog = this.closeDialog.bind(this);
        this.findSimilarCustomers = this.findSimilarCustomers.bind(this);
        this.state = {
            id_customer: props.item === null ? -1 : props.item.id_customer,
            customer_type: props.item === null ? 'natural' : props.item.type,
            vat_registered: props.item === null ? false : props.item.vat_registered,
            vat_prefix: props.item === null ? '' : props.item.vat_prefix,
            tax_number: props.item === null ? '' : props.item.tax_number,
            name: props.item === null ? this.props.name ?? '' : props.item.name,
            surname: props.item === null ? this.props.surname : props.item.surname,
            company_name: props.item === null ? '' : props.item.company_name,
            company_long_name: props.item === null ? '' : props.item.company_long_name,
            id_country: props.item === null || props.item.id_country === null ? this.props.id_country ?? null : props.item.id_country,
            phone: props.item === null ? this.props.phone ?? '' : props.item.phone,
            email: props.item === null ? this.props.email ?? '' : props.item.email,
            address: props.item === null ? this.props.address ?? '' : props.item.address,
            post_code: props.item === null ? this.props.post_code ?? '' : props.item.post_code,
            post_office: props.item === null ? this.props.post_office ?? '' : props.item.post_office,
            supplier: props.item === null ? false : props.item.supplier,
            due_day_count: props.item === null ? 8 : props.item.due_day_count,
            display_company_long_name_on_invoices: props.item === null ? false : props.item.display_company_long_name_on_invoices,
            note: props.item === null ? '' : props.item.note || '',
            birth_date: props.item === null ? null : props.item.birth_date === null ? null : new Date(props.item.birth_date),
            validation_failed_fields: [],
            close_dialog_save_id_item: false,
            close_dialog_save_item: false,
            close_dialog_confirm_open: false,
            similar_customers: []
        };
        this.state.similar_customers = this.findSimilarCustomers(true);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.customer_type != this.state.customer_type) {
            if (this.state.customer_type == 'company') this.setState({
                company_name: this.state.company_name.length > 0 ? this.state.company_name : (this.state.surname + ' ' + this.state.name).trim(),
                name: '',
                surname: ''
            });
            else this.setState({
                company_name: '',
                name: this.state.name.length > 0 ? this.state.name : '',
                surname: this.state.surname.length > 0 ? this.state.surname : this.state.company_name
            });
        }
        if (prevState.name != this.state.name || prevState.surname != this.state.surname || prevState.id_country != this.state.id_country) this.findSimilarCustomers(false);
    }
    findSimilarCustomers(only_return) {
        if (this.state.name.length >= 2 && this.state.surname.length >= 2) {
            const name = this.state.name.toLowerCase();
            const surname = this.state.surname.toLowerCase();
            const found_customers = [];
            for(let id_customer in this.props.customers){
                // skip customer we're currently editing
                if (this.props.item !== null && this.props.item.id_customer === id_customer) continue;
                const customer = this.props.customers[id_customer];
                if (customer.name.toLowerCase().indexOf(name) != -1 && customer.surname.toLowerCase().indexOf(surname) != -1) {
                    if (this.state.id_country === null || this.state.id_country == '' || customer.id_country === null || customer.id_country == this.state.id_country) found_customers.push(customer);
                }
            }
            if (!only_return) this.setState({
                similar_customers: found_customers
            });
            return found_customers;
        } else {
            if (!only_return) this.setState({
                similar_customers: []
            });
            return [];
        }
    }
    closeDialog(confirm, id_item, new_item) {
        if (confirm) {
            this.setState({
                close_dialog_save_id_item: id_item,
                close_dialog_save_item: new_item,
                close_dialog_confirm_open: true
            });
            return;
        }
        this.props.closeSelectCustomerDialog(id_item, new_item);
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.closeDialog(true),
            className: "select-customer-dialog",
            children: [
                !this.state.close_dialog_confirm_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Zapri",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "help",
                    intent: (0, _core.Intent).PRIMARY,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.closeDialog(false, this.state.close_dialog_save_id_item, this.state.close_dialog_save_item);
                        this.setState({
                            close_dialog_save_id_item: false,
                            close_dialog_save_item: false,
                            close_dialog_confirm_open: false
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            close_dialog_save_id_item: false,
                            close_dialog_save_item: false,
                            close_dialog_confirm_open: false
                        });
                    },
                    children: "Res \u017Eelite zapreti brez shranjevanja?"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                            fixedToTop: false,
                            className: "bp5-dark",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                        children: "Vpis stranke"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                    align: (0, _core.Alignment).RIGHT,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        minimal: true,
                                        icon: "cross",
                                        onClick: ()=>this.closeDialog(true)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_BODY,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-grow flex-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-1 pr-2 flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerSelectDefault.default), {
                                                        itemSelected: (item)=>{
                                                            this.setState({
                                                                id_customer: item.id_customer,
                                                                customer_type: item.type,
                                                                vat_registered: item.vat_registered,
                                                                vat_prefix: item.vat_prefix,
                                                                tax_number: item.tax_number,
                                                                name: item.name,
                                                                surname: item.surname,
                                                                company_name: item.company_name,
                                                                company_long_name: item.company_long_name,
                                                                id_country: item.id_country,
                                                                phone: item.phone,
                                                                email: item.email,
                                                                address: item.address,
                                                                post_code: item.post_code,
                                                                post_office: item.post_office,
                                                                supplier: item.supplier,
                                                                due_day_count: item.due_day_count,
                                                                display_company_long_name_on_invoices: item.display_company_long_name_on_invoices,
                                                                note: item.note || '',
                                                                birth_date: item.birth_date === null ? null : new Date(item.birth_date)
                                                            });
                                                        },
                                                        fieldTitle: "Oseba"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-row justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            children: "Tip stranke"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.RadioGroup), {
                                                            onChange: (event)=>{
                                                                this.setState({
                                                                    customer_type: event.target.value
                                                                });
                                                            },
                                                            selectedValue: this.state.customer_type,
                                                            inline: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                                    label: "Fizi\u010Dna",
                                                                    value: "natural"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                                    label: "Pravna",
                                                                    value: "company"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                this.state.customer_type == 'natural' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-row justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                            labelFor: "select-customer--surname",
                                                            className: 'flex-1 mr-1 ' + (this.state.validation_failed_fields.indexOf('surname') == -1 ? '' : 'validation-failed'),
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                    label: "Priimek",
                                                                    tooltip: "Priimek"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                                    id: "select-customer--surname",
                                                                    value: this.state.surname,
                                                                    onChange: (event)=>{
                                                                        this.setState({
                                                                            surname: event.target.value
                                                                        });
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                            labelFor: "select-customer--name",
                                                            className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('name') == -1 ? '' : 'validation-failed'),
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                    label: "Ime",
                                                                    tooltip: "Ime"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                                    id: "select-customer--name",
                                                                    value: this.state.name,
                                                                    onChange: (event)=>{
                                                                        this.setState({
                                                                            name: event.target.value
                                                                        });
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "flex flex-row justify-between",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                labelFor: "select-customer--company-name",
                                                                className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('company_name') == -1 ? '' : 'validation-failed'),
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                        label: "Naziv",
                                                                        tooltip: "Naziv"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                                        id: "select-customer--company-name",
                                                                        value: this.state.company_name,
                                                                        onChange: (event)=>{
                                                                            this.setState({
                                                                                company_name: event.target.value
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "flex flex-row justify-between",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                labelFor: "select-customer--company-long-name",
                                                                className: "flex-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                        label: "Dalj\u0161i naziv",
                                                                        tooltip: "Dalj\u0161i naziv"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                                        id: "select-customer--company-long-name",
                                                                        value: this.state.company_long_name,
                                                                        onChange: (event)=>{
                                                                            this.setState({
                                                                                company_long_name: event.target.value
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    checked: this.state.vat_registered,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            vat_registered: event.target.checked
                                                        });
                                                    },
                                                    children: "Zavezanec za DDV"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-row justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                            labelFor: "select-customer--tax-number",
                                                            className: "flex-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                    label: this.state.vat_registered ? 'ID za DDV' : "Dav\u010Dna \u0161tevilka",
                                                                    tooltip: this.state.vat_registered ? 'ID za DDV' : "Dav\u010Dna \u0161tevilka"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex flex-row",
                                                                    children: [
                                                                        !this.state.vat_registered ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                                            id: "select-customer--tax-number-prefix",
                                                                            options: [
                                                                                {
                                                                                    label: 'SI',
                                                                                    value: 'SI'
                                                                                },
                                                                                {
                                                                                    label: 'AT',
                                                                                    value: 'AT'
                                                                                },
                                                                                {
                                                                                    label: 'BE',
                                                                                    value: 'BE'
                                                                                },
                                                                                {
                                                                                    label: 'BG',
                                                                                    value: 'BG'
                                                                                },
                                                                                {
                                                                                    label: 'CY',
                                                                                    value: 'CY'
                                                                                },
                                                                                {
                                                                                    label: 'CZ',
                                                                                    value: 'CZ'
                                                                                },
                                                                                {
                                                                                    label: 'DE',
                                                                                    value: 'DE'
                                                                                },
                                                                                {
                                                                                    label: 'DK',
                                                                                    value: 'DK'
                                                                                },
                                                                                {
                                                                                    label: 'EE',
                                                                                    value: 'EE'
                                                                                },
                                                                                {
                                                                                    label: 'EL',
                                                                                    value: 'EL'
                                                                                },
                                                                                {
                                                                                    label: 'ES',
                                                                                    value: 'ES'
                                                                                },
                                                                                {
                                                                                    label: 'FI',
                                                                                    value: 'FI'
                                                                                },
                                                                                {
                                                                                    label: 'FR',
                                                                                    value: 'FR'
                                                                                },
                                                                                {
                                                                                    label: 'GB',
                                                                                    value: 'GB'
                                                                                },
                                                                                {
                                                                                    label: 'HR',
                                                                                    value: 'HR'
                                                                                },
                                                                                {
                                                                                    label: 'HU',
                                                                                    value: 'HU'
                                                                                },
                                                                                {
                                                                                    label: 'IE',
                                                                                    value: 'IE'
                                                                                },
                                                                                {
                                                                                    label: 'IT',
                                                                                    value: 'IT'
                                                                                },
                                                                                {
                                                                                    label: 'LT',
                                                                                    value: 'LT'
                                                                                },
                                                                                {
                                                                                    label: 'LU',
                                                                                    value: 'LU'
                                                                                },
                                                                                {
                                                                                    label: 'LV',
                                                                                    value: 'LV'
                                                                                },
                                                                                {
                                                                                    label: 'MT',
                                                                                    value: 'MT'
                                                                                },
                                                                                {
                                                                                    label: 'NL',
                                                                                    value: 'NL'
                                                                                },
                                                                                {
                                                                                    label: 'PL',
                                                                                    value: 'PL'
                                                                                },
                                                                                {
                                                                                    label: 'PT',
                                                                                    value: 'PT'
                                                                                },
                                                                                {
                                                                                    label: 'RO',
                                                                                    value: 'RO'
                                                                                },
                                                                                {
                                                                                    label: 'SE',
                                                                                    value: 'SE'
                                                                                },
                                                                                {
                                                                                    label: 'SK',
                                                                                    value: 'SK'
                                                                                }
                                                                            ],
                                                                            value: this.state.vat_prefix || '',
                                                                            onChange: (e)=>{
                                                                                this.setState({
                                                                                    vat_prefix: e.currentTarget.value
                                                                                });
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                                            id: "select-customer--tax-number",
                                                                            className: "flex-1",
                                                                            value: this.state.tax_number,
                                                                            onChange: (event)=>{
                                                                                this.setState({
                                                                                    tax_number: event.target.value
                                                                                });
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        [
                                                            'test',
                                                            'lodgge',
                                                            'ank'
                                                        ].indexOf(this.props.client) === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                            labelFor: "select-customer--birth-date",
                                                            className: "ml-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                    label: "Datum rojstva",
                                                                    tooltip: "Datum rojstva"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                                    formatDate: (date)=>(0, _formatDefault.default)(date, 'dd. MM. yyyy'),
                                                                    parseDate: (str)=>(0, _parseDefault.default)(str.replaceAll(' ', ''), 'dd.MM.yyyy', new Date()),
                                                                    locale: "sl",
                                                                    inputProps: {
                                                                        placeholder: '01. 01. ' + new Date().getFullYear(),
                                                                        className: 'w-24'
                                                                    },
                                                                    selectAllOnFocus: true,
                                                                    minDate: new Date('1900-01-01'),
                                                                    maxDate: (0, _momentDefault.default)().toDate(),
                                                                    onChange: (selectedDate, isUserChange)=>{
                                                                        if (isUserChange) this.setState({
                                                                            birth_date: selectedDate === null ? null : new Date(selectedDate)
                                                                        });
                                                                    },
                                                                    value: this.state.birth_date === null ? null : (0, _formatISODefault.default)(this.state.birth_date)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-customer--phone",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Telefon",
                                                            tooltip: "Telefon"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                            id: "select-customer--phone",
                                                            value: this.state.phone,
                                                            onChange: (event)=>{
                                                                this.setState({
                                                                    phone: event.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-customer--email",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "E-po\u0161ta",
                                                            tooltip: "E-po\u0161ta"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                            id: "select-customer--email",
                                                            value: this.state.email,
                                                            onChange: (event)=>{
                                                                this.setState({
                                                                    email: event.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-customer--address",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Naslov",
                                                            tooltip: "Naslov"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                            id: "select-customer--address",
                                                            value: this.state.address,
                                                            onChange: (event)=>{
                                                                this.setState({
                                                                    address: event.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-customer--post-code",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Po\u0161tna \u0161tevilka",
                                                            tooltip: "Po\u0161tna \u0161tevilka"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                            id: "select-customer--post-code",
                                                            value: this.state.post_code,
                                                            onChange: (event)=>{
                                                                this.setState({
                                                                    post_code: event.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-customer--post-office",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Po\u0161ta",
                                                            tooltip: "Po\u0161ta"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                            id: "select-customer--post-office",
                                                            value: this.state.post_office,
                                                            onChange: (event)=>{
                                                                this.setState({
                                                                    post_office: event.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-customer--country",
                                                    className: this.state.validation_failed_fields.indexOf('id_country') == -1 ? '' : 'validation-failed',
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Dr\u017Eava",
                                                            tooltip: "Dr\u017Eava"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleSuggestDefault.default), {
                                                            matchKeyName: "official_name_local",
                                                            valueKeyName: "id_country",
                                                            items: Object.values(this.props.countries),
                                                            onItemSelect: (item)=>{
                                                                this.setState({
                                                                    id_country: item.id_country
                                                                });
                                                            },
                                                            selectedItem: this.props.countries[this.state.id_country],
                                                            placeholder: "I\u0161\u010Di"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-1 pl-2 flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    id: "select-customer--display-company-long-name-on-invoices",
                                                    checked: this.state.display_company_long_name_on_invoices,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            display_company_long_name_on_invoices: event.target.checked
                                                        });
                                                    },
                                                    children: "Na ra\u010Dunu izpi\u0161i dalj\u0161i naziv"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    id: "select-customer--supplier",
                                                    checked: this.state.supplier,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            supplier: event.target.checked
                                                        });
                                                    },
                                                    children: "Dobavitelj"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    checked: true,
                                                    children: "Stranka aktivna"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                                    labelFor: "select-customer--due-day-count",
                                                    className: "mt-4 mb-4",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-row items-center justify-between",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                label: "\u0160tevilo dni za valuto",
                                                                tooltip: "\u0160tevilo dni za valuto"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ControlGroup), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                        icon: "minus",
                                                                        tabIndex: "-1",
                                                                        minimal: false,
                                                                        small: true,
                                                                        onClick: ()=>{
                                                                            this.setState({
                                                                                due_day_count: this.state.due_day_count - 1
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "w-8",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                                                            id: "select-customer--due-day-count",
                                                                            className: "centered-numeric-input",
                                                                            fill: true,
                                                                            buttonPosition: "none",
                                                                            value: this.state.due_day_count,
                                                                            min: 0,
                                                                            onValueChange: (val)=>{
                                                                                this.setState({
                                                                                    due_day_count: val
                                                                                });
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                        icon: "plus",
                                                                        tabIndex: "-1",
                                                                        minimal: false,
                                                                        small: true,
                                                                        onClick: ()=>{
                                                                            this.setState({
                                                                                due_day_count: this.state.due_day_count + 1
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                null,
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    labelFor: "select-customer--note",
                                                    className: "flex-1 flex-col select-customer-dialog--note",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Opomba",
                                                            tooltip: "Opomba"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                            id: "select-customer--note",
                                                            className: "",
                                                            growVertically: true,
                                                            fill: true,
                                                            onChange: (e)=>{
                                                                this.setState({
                                                                    note: e.target.value
                                                                });
                                                            },
                                                            value: this.state.note
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                this.state.similar_customers.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-orange-600 flex flex-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                            icon: "warning-sign",
                                            className: "mr-2",
                                            size: 32
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: "Najdene obstoje\u010De stranke s podobnimi podatki:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: this.state.similar_customers.map((customer)=>{
                                                        let value = customer.name + ' ' + customer.surname;
                                                        let additional_data = [];
                                                        if (customer.id_country !== null) additional_data.push(this.props.countries[customer.id_country].official_name_local);
                                                        if (customer.birth_date !== null) additional_data.push('RD ' + (0, _momentDefault.default)(customer.birth_date).format('DD.MM.YYYY'));
                                                        if (additional_data.length > 0) value += ' (' + additional_data.join(', ') + ')';
                                                        return value;
                                                    }).join(', ')
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        minimal: true,
                                        onClick: ()=>this.closeDialog(),
                                        children: "Prekli\u010Di"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: (0, _core.Intent).PRIMARY,
                                        onClick: async ()=>{
                                            const new_customer = this.state.id_customer != -1 ? {
                                                ...this.props.customers[this.state.id_customer]
                                            } : {
                                                id_customer: (0, _uuidDefault.default).v4()
                                            };
                                            let vat_prefix = '';
                                            if (this.state.vat_registered) vat_prefix = this.state.vat_prefix.length == 0 ? 'SI' : this.state.vat_prefix;
                                            new_customer.type = this.state.customer_type;
                                            new_customer.vat_registered = this.state.vat_registered;
                                            new_customer.vat_prefix = vat_prefix;
                                            new_customer.tax_number = this.state.tax_number;
                                            new_customer.name = this.state.name.trim();
                                            new_customer.surname = this.state.surname.trim();
                                            new_customer.company_name = (this.state.company_name ?? '').trim();
                                            new_customer.company_long_name = (this.state.company_long_name ?? '').trim();
                                            new_customer.id_country = this.state.id_country;
                                            new_customer.phone = this.state.phone;
                                            new_customer.email = this.state.email;
                                            new_customer.address = this.state.address;
                                            new_customer.post_code = this.state.post_code;
                                            new_customer.post_office = this.state.post_office;
                                            new_customer.supplier = this.state.supplier;
                                            new_customer.due_day_count = this.state.due_day_count;
                                            new_customer.display_company_long_name_on_invoices = this.state.display_company_long_name_on_invoices;
                                            new_customer.note = this.state.note;
                                            new_customer.birth_date = this.state.birth_date === null ? null : (0, _momentDefault.default)(this.state.birth_date).format('YYYY-MM-DD');
                                            // validate missing/empty fields
                                            const validation_failed_fields = [];
                                            const validation_failed_field_titles = [];
                                            if (new_customer.type == 'natural' && new_customer.name.length == 0 && new_customer.surname.length == 0) {
                                                validation_failed_fields.push('name');
                                                validation_failed_fields.push('surname');
                                                validation_failed_field_titles.push('ime in priimek');
                                            }
                                            if (new_customer.type == 'company' && new_customer.company_name.length == 0) {
                                                validation_failed_fields.push('company_name');
                                                validation_failed_field_titles.push('naziv');
                                            }
                                            if (new_customer.id_country === null) {
                                                validation_failed_fields.push('id_country');
                                                validation_failed_field_titles.push("dr\u017Eava");
                                            }
                                            this.setState({
                                                validation_failed_fields
                                            });
                                            if (validation_failed_fields.length > 0) {
                                                (0, _appToaster.AppToaster).show({
                                                    message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        children: [
                                                            "Za shranjevanje, izpolnite vsaj polja:",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                            validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    children: "\u2022 " + title
                                                                }, title))
                                                        ]
                                                    }),
                                                    intent: 'danger',
                                                    icon: 'issue'
                                                });
                                                return false;
                                            }
                                            // add to store
                                            this.props.dispatch((0, _codeTablesSlice.addCustomer)({
                                                item: new_customer,
                                                token: this.props.token
                                            }));
                                            const dispatch = this.props.dispatch;
                                            const token = this.props.token;
                                            const new_item = await (0, _codeTables.saveCodeTableItem)(this.props.api_url, 'customers', new_customer, token);
                                            if (new_item !== null) dispatch((0, _codeTablesSlice.addCustomer)({
                                                item: new_item,
                                                token
                                            }));
                                            this.closeDialog(false, new_customer.id_customer, new_customer);
                                        },
                                        children: "Shrani in zapri"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
}
SelectCustomerDialog.propTypes = {
    closeSelectCustomerDialog: (0, _propTypesDefault.default).func,
    surname: (0, _propTypesDefault.default).string
};
function mapStateToProps(state) {
    return {
        countries: state.CodeTablesSlice.countries,
        customers: state.CodeTablesSlice.customers,
        api_url: state.CodeTablesSlice.api_url,
        token: state.UserSlice.token,
        client: state.ConstantsSlice.client
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(SelectCustomerDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","uuid":"b52pV","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","moment":"1e4qG","date-fns/formatISO":"an1FA","date-fns/format":"520Dk","date-fns/parse":"72XNY","../TextWithTooltip":"6kuHH","../CustomerSelect":"8sizu","../../slices/CodeTablesSlice":"hfPGz","../../api/CodeTables":"4GMYC","../SimpleSuggest":"82Xt0","../AppToaster":"izixN","../../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fVAf4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
class InvoiceDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.closeWithType = this.closeWithType.bind(this);
        this.formatNumber = this.formatNumber.bind(this);
        let id_customer = props.idCustomer;
        if ((id_customer === null || id_customer === undefined || id_customer == -1) && props.guestIdCustomers.length > 0) id_customer = props.guestIdCustomers[0];
        console.log({
            calculatedState: props.calculatedState
        });
        this.state = {
            id_customer,
            selected_id_customer: id_customer,
            items: [
                /*{
					'id_user': 1,
					'user': 'Bože Jože',
					'sum': 20,
					'items': [
						{ 'title': 'kava', 'count': 4, 'sum': 4, 'checked': false },
						{ 'title': 'masaža', 'count': 1, 'sum': 16, 'checked': false },
					],
				},
				{
					'id_user': 2,
					'user': 'Bože Matjaž',
					'sum': 10,
					'items': [
						{ 'title': 'hamburger', 'count': 1, 'sum': 10, 'checked': false },
					],
				},*/ {
                    'id_user': -1,
                    'user': 'Storitve na rezervaciji',
                    'sum': 0,
                    'items': props.calculatedState.items.filter((item)=>item.type == 'reservation-item').map((item)=>{
                        let price = item.price !== undefined ? item.price : 0;
                        if (item.price === undefined && item.id_item_price_list !== undefined) price = props.items[item.id_item].price_lists[item.id_item_price_list].price * item.quantity;
                        return {
                            title: props.items[item.id_item].title,
                            count: item.quantity,
                            sum: price,
                            checked: false,
                            item
                        };
                    })
                },
                {
                    'id_user': -3,
                    'user': 'Dodatne storitve/artikli gosta',
                    'sum': 0,
                    'items': props.calculatedState.items.filter((item)=>item.type == 'customer-item').map((item)=>{
                        let price = item.price !== undefined ? item.price : 0;
                        if (item.price === undefined && item.id_item_price_list !== undefined) price = props.items[item.id_item].price_lists[item.id_item_price_list].price * item.quantity;
                        return {
                            title: props.items[item.id_item].title,
                            count: item.quantity,
                            sum: price,
                            checked: false,
                            item
                        };
                    })
                },
                {
                    'id_user': -2,
                    'user': "Turisti\u010Dna taksa",
                    'sum': 0,
                    'items': props.calculatedState.items.filter((item)=>item.type == 'tourist-tax' && item.id_tourist_tax !== undefined).map((item)=>{
                        let price = item.price !== undefined ? item.price : 0;
                        if (item.price === undefined && item.id_item_price_list !== undefined) price = props.items[item.id_item].price_lists[item.id_item_price_list].price * item.quantity;
                        return {
                            title: props.items[item.id_item].title,
                            subtitle: props.tourist_taxes[item.id_tourist_tax].title,
                            count: item.quantity,
                            sum: price,
                            checked: false,
                            item
                        };
                    })
                }
            ],
            selected_advance_invoices: []
        };
        for(let i = 0; i < this.state.items.length; i++){
            let sum = 0;
            for(let j = 0; j < this.state.items[i].items.length; j++)sum += this.state.items[i].items[j].sum;
            this.state.items[i].sum = sum;
        }
        //if (this.props.preselect) {
        //	for (let i=0; i<this.state.items[0].items.length; i++) {
        //		this.state.items[0].items[i].checked = true;
        //	}
        //}
        this.selectNone = this.selectNone.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.calculateTotalAmounts = this.calculateTotalAmounts.bind(this);
        this.calculateAdvanceInvoicesSelectedAmounts = this.calculateAdvanceInvoicesSelectedAmounts.bind(this);
        this.getAdvanceInvoicesForAmount = this.getAdvanceInvoicesForAmount.bind(this);
        if (this.props.preselect) this.setCheckedToAll(true, true);
        const total_amounts = this.calculateTotalAmounts();
        this.state.selected_advance_invoices = this.getAdvanceInvoicesForAmount(total_amounts.total);
    }
    selectNone() {
        this.setCheckedToAll(false);
    }
    selectAll() {
        this.setCheckedToAll(true);
    }
    setCheckedToAll(value, set_state_directly) {
        set_state_directly = set_state_directly === undefined ? false : set_state_directly;
        let items = this.state.items;
        for(let i = 0; i < items.length; i++)for(let j = 0; j < items[i].items.length; j++)items[i].items[j].checked = value;
        if (set_state_directly) this.state.items = items;
        else this.setState({
            items
        });
    }
    closeWithType(type) {
        const selected_items = [];
        for(let i = 0; i < this.state.items.length; i++){
            for(let j = 0; j < this.state.items[i].items.length; j++)if (this.state.items[i].items[j].checked) selected_items.push(this.state.items[i].items[j].item);
        }
        if (selected_items.length == 0) //TODO validation error ..
        return;
        this.props.closeInvoiceDialog(type, selected_items, this.state.selected_id_customer, this.calculateAdvanceInvoicesSelectedAmounts());
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    calculateTotalAmounts() {
        return {
            without_tourist_tax: this.state.items.filter((item)=>isNaN(item.id_user) || item.id_user == -1).reduce((curr_value, item)=>curr_value + item.items.reduce((curr_subvalue, subitem)=>curr_subvalue + (subitem.checked ? subitem.sum : 0), 0), 0),
            customer_services: this.state.items.filter((item)=>item.id_user == -3).reduce((curr_value, item)=>curr_value + item.items.reduce((curr_subvalue, subitem)=>curr_subvalue + (subitem.checked ? subitem.sum : 0), 0), 0),
            tourist_tax: this.state.items.filter((item)=>item.id_user == -2).reduce((curr_value, item)=>curr_value + item.items.reduce((curr_subvalue, subitem)=>curr_subvalue + (subitem.checked ? subitem.sum : 0), 0), 0),
            total: this.state.items.reduce((curr_value, item)=>curr_value + item.items.reduce((curr_subvalue, subitem)=>curr_subvalue + (subitem.checked ? subitem.sum : 0), 0), 0)
        };
    }
    calculateAdvanceInvoicesSelectedAmounts() {
        const amounts = {};
        const total_amounts = this.calculateTotalAmounts();
        let remaining_amount = total_amounts.total;
        const sorted_advance_invoices = this.props.advance_invoices.sort((a, b)=>{
            if (a.invoice_date < b.invoice_date) return -1;
            else if (a.invoice_date > b.invoice_date) return 1;
            return 0;
        });
        for(let i = 0; i < sorted_advance_invoices.length; i++){
            const invoice = sorted_advance_invoices[i];
            if (this.state.selected_advance_invoices.indexOf(invoice.id_invoice) == -1) continue;
            const amount = Math.min(invoice.advance_payment_amount - invoice.used_advance_payment_amount, remaining_amount);
            if (amount > 0) {
                remaining_amount -= amount;
                amounts[invoice.id_invoice] = amount;
            }
        }
        return amounts;
    }
    getAdvanceInvoicesForAmount(target_amount) {
        const ids = [];
        if (target_amount <= 0) return ids;
        let remaining_amount = target_amount;
        const sorted_advance_invoices = this.props.advance_invoices.sort((a, b)=>{
            if (a.invoice_date < b.invoice_date) return -1;
            else if (a.invoice_date > b.invoice_date) return 1;
            return 0;
        });
        for(let i = 0; i < sorted_advance_invoices.length; i++){
            const invoice = sorted_advance_invoices[i];
            const amount = Math.min(invoice.advance_payment_amount - invoice.used_advance_payment_amount, remaining_amount);
            if (amount > 0) {
                remaining_amount -= amount;
                ids.push(invoice.id_invoice);
                if (remaining_amount <= 0) break;
            }
        }
        return ids;
    }
    render() {
        const selected_advance_invoices_amounts = this.calculateAdvanceInvoicesSelectedAmounts();
        const advance_payment_amount = Object.values(selected_advance_invoices_amounts).reduce((curr_value, item_val)=>curr_value + item_val, 0);
        const total_amounts = this.calculateTotalAmounts();
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeInvoiceDialog(),
            className: "invoice-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Priprava ra\u010Duna"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeInvoiceDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-grow flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                    className: "bp5-heading",
                                    children: "Nosilec ra\u010Duna"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                        options: [
                                            this.state.id_customer,
                                            ...this.props.guestIdCustomers.filter((id)=>id != this.state.id_customer)
                                        ].map((id)=>{
                                            const customer = this.props.customers[id];
                                            if (customer === undefined) return null;
                                            return {
                                                label: customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name,
                                                value: id
                                            };
                                        }),
                                        value: this.state.selected_id_customer,
                                        onChange: (e)=>{
                                            this.setState({
                                                selected_id_customer: e.currentTarget.value
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                    className: "bp5-heading",
                                    children: "Nepla\u010Dane obveznosti"
                                }),
                                this.state.items.map((item, item_idx)=>{
                                    const count_checked = item.items.reduce((curr_value, item_val)=>curr_value + (item_val.checked ? 1 : 0), 0);
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Checkbox), {
                                                className: "flex flex-row",
                                                checked: count_checked == item.items.length,
                                                indeterminate: count_checked > 0 && count_checked != item.items.length,
                                                onChange: (event)=>{
                                                    var items = this.state.items;
                                                    for(let i = 0; i < items[item_idx].items.length; i++)items[item_idx].items[i].checked = event.target.checked;
                                                    this.setState({
                                                        items
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex-grow flex-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: item.user == this.state.invoice_holder ? 'font-bold' : '',
                                                                children: item.user
                                                            }),
                                                            item.id_user == -1 || item.id_user == -2 || item.id_user == -3 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                className: "ml-2",
                                                                icon: "follower",
                                                                disabled: item.user == this.state.invoice_holder,
                                                                minimal: true,
                                                                small: true,
                                                                onClick: ()=>{
                                                                    this.setState({
                                                                        invoice_holder: item.user
                                                                    });
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "font-bold",
                                                        children: [
                                                            this.formatNumber(item.sum),
                                                            " EUR"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            item.items.map((subitem, subitem_idx)=>{
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Checkbox), {
                                                    className: "ml-8 flex flex-row",
                                                    checked: subitem.checked,
                                                    onChange: (event)=>{
                                                        var items = this.state.items;
                                                        items[item_idx].items[subitem_idx].checked = event.target.checked;
                                                        this.setState({
                                                            items
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-grow flex flex-col",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    children: [
                                                                        subitem.count,
                                                                        "x ",
                                                                        subitem.title
                                                                    ]
                                                                }),
                                                                subitem.subtitle === undefined || subitem.subtitle.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-gray-500",
                                                                    children: subitem.subtitle
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            children: [
                                                                this.formatNumber(subitem.sum),
                                                                " EUR"
                                                            ]
                                                        })
                                                    ]
                                                }, 'invoice-item-' + item.user + '-subitem-' + subitem_idx);
                                            })
                                        ]
                                    }, 'invoice-item-' + item.user);
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex justify-between",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    onClick: this.selectNone,
                                                    children: "Izberi nobenega"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    onClick: this.selectAll,
                                                    children: "Izberi vse"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Divider), {
                                    className: "mt-2 mb-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-row justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex flex-row flex-1 justify-start",
                                            children: this.props.advance_invoices.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mb-4 mr-4 flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "font-bold mb-2",
                                                        children: "Avansi"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex flex-col",
                                                        children: this.props.advance_invoices.sort((a, b)=>{
                                                            if (a.invoice_date < b.invoice_date) return -1;
                                                            else if (a.invoice_date > b.invoice_date) return 1;
                                                            return 0;
                                                        }).map((item)=>{
                                                            const advance_invoice_consumption_ids = this.props.id_advance_invoice_consumption_by_id_advance_invoices[item.id_invoice] || [];
                                                            let tooltip_content = null;
                                                            if (advance_invoice_consumption_ids.length > 0) tooltip_content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "font-bold",
                                                                        children: "\u017De uporabljeno"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "grid grid-cols-2 col-gap-4 row-gap-1",
                                                                        children: advance_invoice_consumption_ids.map((id_consumer_invoice)=>{
                                                                            const advance_invoice_consumption = this.props.advance_invoice_consumptions[id_consumer_invoice];
                                                                            if (advance_invoice_consumption === undefined) return null;
                                                                            const invoice = this.props.invoices[advance_invoice_consumption.consumer_id_invoice];
                                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        children: invoice.invoice_number_internal
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "text-right",
                                                                                        children: this.formatNumber(advance_invoice_consumption.amount) + ' EUR'
                                                                                    })
                                                                                ]
                                                                            }, id_consumer_invoice);
                                                                        })
                                                                    })
                                                                ]
                                                            });
                                                            const used_amount = selected_advance_invoices_amounts[item.id_invoice] || 0;
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Checkbox), {
                                                                        checked: this.state.selected_advance_invoices.indexOf(item.id_invoice) != -1,
                                                                        onChange: (event)=>{
                                                                            const selected_advance_invoices = [
                                                                                ...this.state.selected_advance_invoices
                                                                            ];
                                                                            const idx = selected_advance_invoices.indexOf(item.id_invoice);
                                                                            if (event.target.checked) {
                                                                                if (idx == -1) selected_advance_invoices.push(item.id_invoice);
                                                                            } else if (idx != -1) selected_advance_invoices.splice(idx, 1);
                                                                            this.setState({
                                                                                selected_advance_invoices
                                                                            });
                                                                        },
                                                                        className: "flex flex-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "flex-1 mr-4 leading-3",
                                                                                children: item.invoice_number
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "w-20 text-right leading-3",
                                                                                children: [
                                                                                    this.formatNumber(parseFloat(item.advance_payment_amount)),
                                                                                    " EUR"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "text-right leading-3",
                                                                                style: {
                                                                                    width: '9rem'
                                                                                },
                                                                                children: [
                                                                                    "(ostane \u0161e ",
                                                                                    this.formatNumber(parseFloat(item.advance_payment_amount) - parseFloat(item.used_advance_payment_amount) - used_amount),
                                                                                    " EUR)"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "w-6 ml-2",
                                                                                style: {
                                                                                    marginTop: -2
                                                                                },
                                                                                children: tooltip_content === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                                                                    content: tooltip_content,
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                                                        icon: "info-sign",
                                                                                        color: "#cccccc"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }, 'prepayment--' + item.id_invoice);
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "text-right",
                                            style: {
                                                width: 300
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-row mt-1 mb-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "inline-block mr-2",
                                                            style: {
                                                                width: 200
                                                            },
                                                            children: "Storitve na rezervaciji:"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-1 inline-block",
                                                            children: [
                                                                this.formatNumber(total_amounts.without_tourist_tax),
                                                                " EUR"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-row mt-1 mb-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "inline-block mr-2",
                                                            style: {
                                                                width: 200
                                                            },
                                                            children: "Dodatne storitve/artikli gosta:"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-1 inline-block",
                                                            children: [
                                                                this.formatNumber(total_amounts.customer_services),
                                                                " EUR"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-row mt-1 mb-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "inline-block mr-2",
                                                            style: {
                                                                width: 200
                                                            },
                                                            children: "Turisti\u010Dna taksa:"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-1 inline-block",
                                                            children: [
                                                                this.formatNumber(total_amounts.tourist_tax),
                                                                " EUR"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                this.props.advance_invoices.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-row mt-1 mb-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "inline-block mr-2",
                                                            style: {
                                                                width: 200
                                                            },
                                                            children: "Znesek avansov:"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-1 inline-block",
                                                            children: [
                                                                this.formatNumber(-advance_payment_amount),
                                                                " EUR"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-row mt-3 mb-1 font-bold",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "inline-block mr-2",
                                                            style: {
                                                                width: 200
                                                            },
                                                            children: "Skupaj za pla\u010Dilo:"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-1 inline-block",
                                                            children: [
                                                                this.formatNumber(total_amounts.total - advance_payment_amount),
                                                                " EUR"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeInvoiceDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    onClick: ()=>this.closeWithType('invoice'),
                                    children: "Pripravi fakturo"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    disabled: this.props.current_id_cash_register == 0,
                                    onClick: ()=>this.closeWithType('cash-invoice'),
                                    children: "Pripravi ra\u010Dun"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
InvoiceDialog.propTypes = {
    closeInvoiceDialog: (0, _propTypesDefault.default).func,
    preselect: (0, _propTypesDefault.default).bool
};
function mapStateToProps(state) {
    return {
        items: state.CodeTablesSlice.items,
        customers: state.CodeTablesSlice.customers,
        tourist_taxes: state.CodeTablesSlice.tourist_taxes,
        invoices: state.BusinessSlice.invoices,
        advance_invoice_consumptions: state.BusinessSlice.advance_invoice_consumptions,
        id_advance_invoice_consumption_by_id_advance_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_advance_invoices,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(InvoiceDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kxL93":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _select = require("@blueprintjs/select");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _customerSelect = require("../CustomerSelect");
var _customerSelectDefault = parcelHelpers.interopDefault(_customerSelect);
var _selectCustomerDialog = require("../reservations/SelectCustomerDialog");
var _selectCustomerDialogDefault = parcelHelpers.interopDefault(_selectCustomerDialog);
var _selectPriceListDialog = require("./SelectPriceListDialog");
var _selectPriceListDialogDefault = parcelHelpers.interopDefault(_selectPriceListDialog);
var _numbers = require("../../numbers");
var _documents = require("../Documents");
var _documentsDefault = parcelHelpers.interopDefault(_documents);
var _invoiceCreator = require("../../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _splitPaymentDialog = require("./SplitPaymentDialog");
var _splitPaymentDialogDefault = parcelHelpers.interopDefault(_splitPaymentDialog);
var _prepaymentDocumentSearchDialog = require("../PrepaymentDocumentSearchDialog");
var _prepaymentDocumentSearchDialogDefault = parcelHelpers.interopDefault(_prepaymentDocumentSearchDialog);
var _customerInfo = require("./CustomerInfo");
var _customerInfoDefault = parcelHelpers.interopDefault(_customerInfo);
var _appToaster = require("../AppToaster");
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _utils = require("../../utils");
var _business = require("../../api/Business");
class InvoiceItemViewModel {
    constructor(single_price_with_vat, price_without_vat, price_with_vat, invoice_item){
        this.single_price_with_vat = single_price_with_vat;
        this.price_without_vat = price_without_vat;
        this.price_with_vat = price_with_vat;
        this.invoice_item = invoice_item;
        if (this.invoice_item.approved_percent === undefined) this.invoice_item.approved_percent = 100;
        this.quantity_formatted = this.formatNumber(this.invoice_item.quantity, this.invoice_item.item_measuring_unit_decimal_digit_count);
        this.discount_formatted = this.formatNumber(this.invoice_item.discount);
        this.single_price_with_vat_formatted = this.formatNumber(this.single_price_with_vat);
        this.price_without_vat_formatted = this.formatNumber(this.price_without_vat);
        this.price_with_vat_formatted = this.formatNumber(this.price_with_vat);
        this.approved_percent_formatted = this.formatNumber(this.invoice_item.approved_percent);
        this.price = this.price.bind(this);
    //this.priceWithoutVat = this.priceWithoutVat.bind(this);
    }
    static FromInvoiceItem(items, invoice_item, tax_rates) {
        const item = items[invoice_item.id_item];
        const price_list_items = item === undefined ? {} : item.price_lists;
        const price_list = invoice_item.id_item_price_list === null ? undefined : price_list_items[invoice_item.id_item_price_list];
        const price = invoice_item.price !== undefined ? invoice_item.price : price_list === undefined ? 0 : price_list.price;
        if (invoice_item.approved_percent === undefined) invoice_item.approved_percent = 100;
        const quantity = invoice_item.quantity;
        const vat = price_list === undefined ? 0 : tax_rates[price_list.id_tax_rate].value;
        const discount = invoice_item.discount;
        const approved_percent = invoice_item.approved_percent;
        return new InvoiceItemViewModel(Math.properRound(price * (approved_percent / 100), 2), Math.properRound(price * quantity * (1 - discount / 100) / (1 + vat / 100) * (approved_percent / 100), 2), Math.properRound(price * quantity * (1 - discount / 100) * (approved_percent / 100), 2), invoice_item);
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    price(priceList) {
        if (this.invoice_item.id_item_price_list === null) return 0;
        return priceList[this.invoice_item.id_item_price_list].price;
    }
}
class ItemsList extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.setMainTableItemsSort = this.setMainTableItemsSort.bind(this);
        this.formatNumber = this.formatNumber.bind(this);
        this.addEmptyItemIfNeeded = this.addEmptyItemIfNeeded.bind(this);
        this.changeInvoiceItemValue = this.changeInvoiceItemValue.bind(this);
        this.openSelectPriceListDialog = this.openSelectPriceListDialog.bind(this);
        this.closeSelectPriceListDialog = this.closeSelectPriceListDialog.bind(this);
        this.findBestPriceListMatch = this.findBestPriceListMatch.bind(this);
        this.state = {
            main_table_items_sort_field: '',
            main_table_items_sort_direction: 'ASC',
            select_price_list_dialog_open: false,
            select_price_list_dialog_item: null,
            select_price_list_dialog_idx: -1
        };
        this.main_table_refs = [];
    }
    setMainTableItemsSort(field) {}
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    addEmptyItemIfNeeded(invoice_items) {
        if (this.props.read_only) return;
        if (invoice_items.length == 0 || invoice_items[invoice_items.length - 1].invoice_item.id_item != -1) {
            const item = InvoiceItemViewModel.FromInvoiceItem(this.props.items, this.getEmptyInvoiceItem(), this.props.tax_rates);
            item.quantity = 1;
            invoice_items.push(item);
            this.props.setInvoiceItems(invoice_items);
        }
    }
    getEmptyInvoiceItem() {
        return {
            id_invoice_item: -1,
            id_invoice: -1,
            id_item: -1,
            id_item_price_list: null,
            quantity: 1,
            discount: 0,
            approved_percent: 100,
            item_measuring_unit_decimal_digit_count: 0,
            description: ''
        };
    }
    openSelectPriceListDialog(item, idx) {
        this.setState({
            select_price_list_dialog_open: true,
            select_price_list_dialog_item: item,
            select_price_list_dialog_idx: idx
        });
    }
    closeSelectPriceListDialog(id_item_price_list) {
        const invoice_items = this.props.invoice_items;
        if (id_item_price_list != -1) {
            this.state.select_price_list_dialog_item.id_item_price_list = id_item_price_list;
            if (this.state.select_price_list_dialog_idx != -1) this.changeInvoiceItemValue(this.state.select_price_list_dialog_item, this.state.select_price_list_dialog_idx, [
                'invoice_item',
                'id_item_price_list'
            ], id_item_price_list);
        }
        this.setState({
            select_price_list_dialog_open: false,
            select_price_list_dialog_item: null,
            select_price_list_dialog_idx: -1
        });
        this.props.setInvoiceItems(invoice_items);
    }
    changeInvoiceItemValue(item, idx, field_name, val, invoice_items, formatted_field_name, formatted_field_value) {
        invoice_items = [
            ...invoice_items || this.props.invoice_items
        ];
        if (Array.isArray(field_name)) invoice_items[idx][field_name[0]][field_name[1]] = val;
        else if (field_name != 'refresh') invoice_items[idx][field_name] = val;
        if (field_name == 'refresh') {
            // round quantity to item_measuring_unit_decimal_digit_count
            const quantity = parseFloat(invoice_items[idx].invoice_item.quantity);
            const decimal_digit_count = parseFloat(invoice_items[idx].invoice_item.item_measuring_unit_decimal_digit_count);
            let decimal_factor = 10 * decimal_digit_count;
            if (decimal_factor == 0) decimal_factor = 1;
            invoice_items[idx].invoice_item.quantity = Math.properRound(quantity, decimal_digit_count);
            invoice_items[idx].invoice_item.approved_percent = Math.properRound(invoice_items[idx].invoice_item.approved_percent, 2);
        }
        if (this.props.invoice_type == 'credit-note') invoice_items[idx].invoice_item.quantity = Math.abs(invoice_items[idx].invoice_item.quantity) * -1;
        let vat = 0;
        if (item.invoice_item !== undefined && item.invoice_item.id_item_price_list !== null && item.invoice_item.id_item != -1) vat = this.props.tax_rates[this.props.items[item.invoice_item.id_item].price_lists[item.invoice_item.id_item_price_list].id_tax_rate].value;
        invoice_items[idx].quantity_formatted = invoice_items[idx].invoice_item.quantity;
        invoice_items[idx].discount_formatted = invoice_items[idx].invoice_item.discount;
        invoice_items[idx].single_price_with_vat_formatted = invoice_items[idx].single_price_with_vat;
        invoice_items[idx].price_with_vat_formatted = invoice_items[idx].price_with_vat;
        invoice_items[idx].price_without_vat_formatted = invoice_items[idx].price_without_vat;
        invoice_items[idx].approved_percent_formatted = invoice_items[idx].invoice_item.approved_percent;
        // set new price
        if (Array.isArray(field_name) && field_name.length == 2 && field_name[0] == 'invoice_item' && field_name[1] == 'id_item_price_list') invoice_items[idx].single_price_with_vat = this.props.items[item.invoice_item.id_item].price_lists[item.invoice_item.id_item_price_list].price;
        const price = invoice_items[idx].single_price_with_vat;
        // calculate discount, if needed
        if (field_name == 'price_without_vat') invoice_items[idx].invoice_item.discount = Math.properRound((1 - val * (1 + vat / 100) / (price * invoice_items[idx].invoice_item.quantity / (invoice_items[idx].invoice_item.approved_percent / 100))) * 100, 6);
        else if (field_name == 'price_with_vat') invoice_items[idx].invoice_item.discount = Math.properRound((1 - val / (price * invoice_items[idx].invoice_item.quantity / (invoice_items[idx].invoice_item.approved_percent / 100))) * 100, 6);
        // format discount
        if (formatted_field_name == 'discount_formatted') invoice_items[idx].discount_formatted = formatted_field_value;
        else if (!Array.isArray(field_name) || field_name[1] != 'discount') invoice_items[idx].discount_formatted = this.formatNumber(invoice_items[idx].invoice_item.discount);
        // format quantity
        if (formatted_field_name == 'quantity_formatted') invoice_items[idx].quantity_formatted = formatted_field_value;
        else if (!Array.isArray(field_name) || field_name[1] != 'quantity') invoice_items[idx].quantity_formatted = this.formatNumber(invoice_items[idx].invoice_item.quantity, invoice_items[idx].invoice_item.item_measuring_unit_decimal_digit_count);
        // calculate and format price with VAT
        if (formatted_field_name == 'price_with_vat_formatted') invoice_items[idx].price_with_vat_formatted = formatted_field_value;
        else if (field_name != 'price_with_vat') {
            invoice_items[idx].price_with_vat = Math.properRound(price * invoice_items[idx].invoice_item.quantity * (1 - invoice_items[idx].invoice_item.discount / 100) * (invoice_items[idx].invoice_item.approved_percent / 100), 2);
            invoice_items[idx].price_with_vat_formatted = this.formatNumber(invoice_items[idx].price_with_vat);
        }
        // calculate and format price without VAT
        if (formatted_field_name == 'price_without_vat_formatted') invoice_items[idx].price_without_vat_formatted = formatted_field_value;
        else if (field_name != 'price_without_vat') {
            invoice_items[idx].single_price_with_vat = price;
            invoice_items[idx].price_without_vat = Math.properRound(invoice_items[idx].single_price_with_vat / (1 + vat / 100) * (1 - invoice_items[idx].invoice_item.discount / 100) * (invoice_items[idx].invoice_item.approved_percent / 100) * invoice_items[idx].invoice_item.quantity, 2);
            invoice_items[idx].price_without_vat_formatted = this.formatNumber(invoice_items[idx].price_without_vat);
        }
        // format single price with VAT
        if (formatted_field_name == 'single_price_with_vat_formatted') invoice_items[idx].single_price_with_vat_formatted = formatted_field_value;
        else if (!Array.isArray(field_name) || field_name[1] != 'single_price_with_vat') invoice_items[idx].single_price_with_vat_formatted = this.formatNumber(invoice_items[idx].single_price_with_vat);
        // format approved percent
        if (formatted_field_name == 'approved_percent_formatted') invoice_items[idx].approved_percent_formatted = formatted_field_value;
        else if (!Array.isArray(field_name) || field_name[1] != 'approved_percent') invoice_items[idx].approved_percent_formatted = this.formatNumber(invoice_items[idx].invoice_item.approved_percent);
        this.props.setInvoiceItems(invoice_items);
    }
    findBestPriceListMatch(item) {
        if (item === undefined || item === null || this.props.invoice_date === null) return null;
        return (0, _priceHelperDefault.default).FindBestPriceListMatch(this.props.invoice_date, item.price_lists);
    }
    render() {
        let column_idx = 1;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: 'items-table ' + (this.props.read_only ? 'read-only' : '') + ' ' + (this.props.invoice_type == 'credit-note' ? 'credit-note' : ''),
            children: [
                !this.state.select_price_list_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectPriceListDialogDefault.default), {
                    closeSelectPriceListDialog: this.closeSelectPriceListDialog,
                    priceListItems: this.props.items[this.state.select_price_list_dialog_item.invoice_item.id_item].price_lists,
                    item: this.state.select_price_list_dialog_item.invoice_item
                }),
                this.props.read_only ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-1",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-2",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Storitev/blago"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-3",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Opis"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-4",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Koli\u010Dina"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-5",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Cena z DDV"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-6",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Popust (%)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-7",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Znesek brez DDV"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-8",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "DDV (%)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-9",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Znesek z DDV"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-10",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Cenik"
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-1",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col col-2",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('title');
                            },
                            children: [
                                "Storitev/blago",
                                this.state.main_table_items_sort_field != 'title' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-3",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Opis"
                        }),
                        this.props.invoice_type != 'credit-note' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col col-4 text-center",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Priznan popust (%)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col col-4 text-center",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('count');
                            },
                            children: [
                                "Koli\u010Dina",
                                this.state.main_table_items_sort_field != 'count' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col col-5",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('single_price_with_vat');
                            },
                            children: [
                                "Cena z DDV",
                                this.state.main_table_items_sort_field != 'single_price_with_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col col-6",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('discount');
                            },
                            children: [
                                "Popust (%)",
                                this.state.main_table_items_sort_field != 'discount' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col col-7",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('price_without_vat');
                            },
                            children: [
                                "Znesek brez DDV",
                                this.state.main_table_items_sort_field != 'price_without_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col col-8",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('vat');
                            },
                            children: [
                                "DDV (%)",
                                this.state.main_table_items_sort_field != 'vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col col-9",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('price_with_vat');
                            },
                            children: [
                                "Znesek z DDV",
                                this.state.main_table_items_sort_field != 'price_with_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col col-10",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('price_list');
                            },
                            children: [
                                "Cenik",
                                this.state.main_table_items_sort_field != 'price_list' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        })
                    ]
                }),
                this.props.invoice_items.map((item, idx)=>{
                    const self = this;
                    let vat = 0;
                    if (item.invoice_item.id_item_price_list !== null && item.invoice_item.id_item != -1) vat = self.props.tax_rates[self.props.items[item.invoice_item.id_item].price_lists[item.invoice_item.id_item_price_list].id_tax_rate].value;
                    if (idx >= self.main_table_refs.length) self.main_table_refs.push(/*#__PURE__*/ (0, _reactDefault.default).createRef());
                    column_idx = 1;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                        children: this.props.read_only ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-1 text-center",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        disabled: this.props.read_only,
                                        onClick: ()=>{}
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-2",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: this.props.items[item.invoice_item.id_item].internal_code + " \u2022 " + this.props.items[item.invoice_item.id_item].title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-3 description",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: item.invoice_item.description || ''
                                }),
                                self.props.invoice_type != 'credit-note' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-4",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: item.approved_percent_formatted
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-4",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: item.quantity_formatted
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-5",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: item.single_price_with_vat_formatted
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-6",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: item.discount_formatted
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-7",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: item.price_without_vat_formatted
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-8",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: this.formatNumber(vat)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-9",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: item.price_with_vat_formatted
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-10",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: this.props.items[item.invoice_item.id_item].price_lists[item.invoice_item.id_item_price_list].price
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-1 text-center",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: item.invoice_item.id_item == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>{
                                            const invoice_items = [
                                                ...this.props.invoice_items
                                            ];
                                            invoice_items.splice(idx, 1);
                                            this.props.setInvoiceItems(invoice_items);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-2 tight service-suggest",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Suggest), {
                                        itemListPredicate: (query, items)=>{
                                            const trimmed_query = query.trim().toLowerCase();
                                            if (trimmed_query.length < 2) return [];
                                            const found_items = [];
                                            const found_ids = []; // to prevent duplicate items
                                            const ITEM_LIMIT = 20;
                                            // find exact matches
                                            for(let i = 0; i < items.length; i++){
                                                const item = items[i];
                                                if (found_ids.indexOf(item.id_item) == -1 && Object.keys(item.price_lists).length > 0 && item.internal_code.toLowerCase() == trimmed_query) {
                                                    found_items.push(item);
                                                    found_ids.push(item.id_item);
                                                }
                                                if (found_items.length >= ITEM_LIMIT) break;
                                            }
                                            // find matches that start with query
                                            if (found_items.length < ITEM_LIMIT) for(let i = 0; i < items.length; i++){
                                                const item = items[i];
                                                if (found_ids.indexOf(item.id_item) == -1 && Object.keys(item.price_lists).length > 0 && item.internal_code.toLowerCase().indexOf(trimmed_query) == 0) {
                                                    found_items.push(item);
                                                    found_ids.push(item.id_item);
                                                }
                                                if (found_items.length >= ITEM_LIMIT) break;
                                            }
                                            // find inexact matches
                                            if (found_items.length < ITEM_LIMIT) for(let i = 0; i < items.length; i++){
                                                const item = items[i];
                                                if (found_ids.indexOf(item.id_item) == -1 && Object.keys(item.price_lists).length > 0 && (item.title.toLowerCase().indexOf(trimmed_query) > -1 || item.internal_code.toLowerCase().indexOf(trimmed_query) > -1 || item.ean !== null && item.ean.length > 0 && item.ean.toLowerCase() == trimmed_query)) {
                                                    found_items.push(item);
                                                    found_ids.push(item.id_item);
                                                }
                                                if (found_items.length >= ITEM_LIMIT) break;
                                            }
                                            return found_items;
                                        },
                                        itemRenderer: (item, { handleClick, modifiers })=>{
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                active: modifiers.active,
                                                onClick: handleClick,
                                                text: item.internal_code + " \u2022 " + item.title,
                                                label: item.ean
                                            }, item.id_item);
                                        },
                                        items: Object.values(this.props.items),
                                        onItemSelect: (item)=>{
                                            const item_item = self.props.items[item.id_item];
                                            const invoice_items = [
                                                ...this.props.invoice_items
                                            ];
                                            invoice_items[idx].invoice_item.id_item = item.id_item;
                                            //TODO change findBestPriceListMatch to base search on proper dates!
                                            invoice_items[idx].invoice_item.id_item_price_list = self.findBestPriceListMatch(item_item);
                                            invoice_items[idx].invoice_item.item_measuring_unit_decimal_digit_count = self.props.measuring_units[item_item.id_measuring_unit].decimal_digit_count;
                                            invoice_items[idx].invoice_item.description = item.description;
                                            if (invoice_items[idx].invoice_item.id_item_price_list !== null) {
                                                const price_list = item_item.price_lists[invoice_items[idx].invoice_item.id_item_price_list];
                                                const price = price_list.price;
                                                const quantity = invoice_items[idx].invoice_item.quantity;
                                                const vat = self.props.tax_rates[price_list.id_tax_rate].value;
                                                const discount = invoice_items[idx].invoice_item.discount;
                                                const approved_percent = invoice_items[idx].invoice_item.approved_percent;
                                                if (invoice_items[idx].invoice_item.approved_percent === undefined) invoice_items[idx].invoice_item.approved_percent = 100;
                                                invoice_items[idx].single_price_with_vat = Math.properRound(price * (approved_percent / 100), 2);
                                                invoice_items[idx].price_without_vat = Math.properRound(price * quantity * (1 - discount / 100) / (1 + vat / 100) * (approved_percent / 100), 2);
                                                invoice_items[idx].price_with_vat = Math.properRound(price * quantity * (1 - discount / 100) * (approved_percent / 100), 2);
                                                invoice_items[idx].discount_formatted = this.formatNumber(invoice_items[idx].invoice_item.discount);
                                                invoice_items[idx].single_price_with_vat_formatted = this.formatNumber(invoice_items[idx].single_price_with_vat);
                                                invoice_items[idx].price_without_vat_formatted = this.formatNumber(invoice_items[idx].price_without_vat);
                                                invoice_items[idx].price_with_vat_formatted = this.formatNumber(invoice_items[idx].price_with_vat);
                                                invoice_items[idx].approved_percent_formatted = this.formatNumber(invoice_items[idx].invoice_item.approved_percent);
                                            }
                                            this.props.setInvoiceItems(invoice_items);
                                            this.addEmptyItemIfNeeded(invoice_items);
                                            // refresh values
                                            self.changeInvoiceItemValue(invoice_items[idx], idx, 'refresh', null, invoice_items);
                                            if (idx < self.main_table_refs.length && self.main_table_refs[idx] !== undefined && self.main_table_refs[idx].current !== null) {
                                                self.main_table_refs[idx].current.focus();
                                                setTimeout(()=>{
                                                    self.main_table_refs[idx].current.select();
                                                }, 200);
                                            }
                                        },
                                        openOnKeyDown: true,
                                        popoverProps: {
                                            targetProps: {
                                                style: {
                                                    display: 'block'
                                                }
                                            },
                                            minimal: true
                                        },
                                        fill: true,
                                        selectedItem: item.invoice_item.id_item == -1 ? null : this.props.items[item.invoice_item.id_item],
                                        inputProps: {
                                            placeholder: "I\u0161\u010Di"
                                        },
                                        inputValueRenderer: (item)=>item.internal_code + " \u2022 " + item.title,
                                        resetOnSelect: true
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-3 description tight",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: item.invoice_item.description || ''
                                }),
                                self.props.invoice_type != 'credit-note' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-4 tight",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        className: "text-center",
                                        value: item.approved_percent_formatted,
                                        ref: self.main_table_refs[idx],
                                        onChange: (event)=>{
                                            let val = (0, _numbers.parseFloatLocal)(event.target.value);
                                            if (Object.is(val, NaN)) val = item.invoice_item.approved_percent;
                                            self.changeInvoiceItemValue(item, idx, [
                                                'invoice_item',
                                                'approved_percent'
                                            ], val, this.props.invoice_items, 'approved_percent_formatted', event.target.value);
                                        },
                                        onBlur: (event)=>self.changeInvoiceItemValue(item, idx, 'refresh', null)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-4 tight",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        className: "text-center",
                                        value: item.quantity_formatted,
                                        ref: self.main_table_refs[idx],
                                        onChange: (event)=>{
                                            let val = (0, _numbers.parseFloatLocal)(event.target.value);
                                            if (Object.is(val, NaN)) val = item.invoice_item.quantity;
                                            self.changeInvoiceItemValue(item, idx, [
                                                'invoice_item',
                                                'quantity'
                                            ], val, this.props.invoice_items, 'quantity_formatted', event.target.value);
                                        },
                                        onBlur: (event)=>self.changeInvoiceItemValue(item, idx, 'refresh', null)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-5 text-right",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: this.props.items[item.invoice_item.id_item] === undefined || this.props.items[item.invoice_item.id_item].allow_changing_price !== true ? item.single_price_with_vat_formatted : /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        className: "text-right",
                                        value: item.single_price_with_vat_formatted,
                                        onChange: (event)=>{
                                            let val = (0, _numbers.parseFloatLocal)(event.target.value);
                                            if (Object.is(val, NaN)) val = item.single_price_with_vat;
                                            self.changeInvoiceItemValue(item, idx, 'single_price_with_vat', val, this.props.invoice_items, 'single_price_with_vat_formatted', event.target.value);
                                        },
                                        onBlur: (event)=>self.changeInvoiceItemValue(item, idx, 'refresh', null)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-6 tight text-right",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        className: "text-right",
                                        value: item.discount_formatted,
                                        onChange: (event)=>{
                                            let val = (0, _numbers.parseFloatLocal)(event.target.value);
                                            if (Object.is(val, NaN)) val = item.invoice_item.discount;
                                            self.changeInvoiceItemValue(item, idx, [
                                                'invoice_item',
                                                'discount'
                                            ], val, this.props.invoice_items, 'discount_formatted', event.target.value);
                                        },
                                        onBlur: (event)=>self.changeInvoiceItemValue(item, idx, 'refresh', null)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-7 tight text-right",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        className: "text-right",
                                        value: item.price_without_vat_formatted,
                                        onChange: (event)=>{
                                            let val = (0, _numbers.parseFloatLocal)(event.target.value);
                                            if (Object.is(val, NaN)) val = item.price_without_vat;
                                            self.changeInvoiceItemValue(item, idx, 'price_without_vat', val, this.props.invoice_items, 'price_without_vat_formatted', event.target.value);
                                        },
                                        onBlur: (event)=>self.changeInvoiceItemValue(item, idx, 'refresh', null)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-8 text-right",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: this.formatNumber(vat)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-9 tight text-right",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        className: "text-right",
                                        value: item.price_with_vat_formatted,
                                        onChange: (event)=>{
                                            let val = (0, _numbers.parseFloatLocal)(event.target.value);
                                            if (Object.is(val, NaN)) val = item.price_with_vat;
                                            self.changeInvoiceItemValue(item, idx, 'price_with_vat', val, this.props.invoice_items, 'price_with_vat_formatted', event.target.value);
                                        },
                                        onBlur: (event)=>self.changeInvoiceItemValue(item, idx, 'refresh', null)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-table-col col-10",
                                    style: {
                                        gridColumn: column_idx++
                                    },
                                    children: item.invoice_item.id_item == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        className: "cell-button",
                                        small: true,
                                        onClick: ()=>{
                                            this.openSelectPriceListDialog(item, idx);
                                        },
                                        children: item.invoice_item.id_item_price_list === null ? 'Izberi' : this.formatNumber(this.props.items[item.invoice_item.id_item].price_lists[item.invoice_item.id_item_price_list].price)
                                    })
                                })
                            ]
                        })
                    }, 'invoice-item-' + idx);
                })
            ]
        });
    }
}
function AdvanceInvoiceList(props) {
    const { prepayments, customers, invoices, openDocumentSearchDialog, removePrepayment } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: 'advance-invoice-list ' + (openDocumentSearchDialog === null && removePrepayment === null ? 'without-add-and-remove' : ''),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "advance-invoice-list-table",
                children: [
                    openDocumentSearchDialog === null && removePrepayment === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "advance-invoice-list-table-header-col col-1",
                        children: openDocumentSearchDialog === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            small: true,
                            minimal: true,
                            intent: "primary",
                            className: "add-document-button",
                            onClick: openDocumentSearchDialog,
                            icon: "add"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "advance-invoice-list-table-header-col col-2",
                        children: "Datum"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "advance-invoice-list-table-header-col col-3",
                        children: "\u0160t. dokumenta"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "advance-invoice-list-table-header-col col-4",
                        children: "Stranka"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "advance-invoice-list-table-header-col col-5 text-right",
                        children: "Znesek"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "advance-invoice-list-table",
                children: prepayments.map((item)=>{
                    const invoice = invoices[item.advance_id_invoice];
                    const document_date = invoice.invoice_date;
                    const document_document_number = invoice.invoice_number_internal;
                    let document_amount = item.new_amount;
                    switch(invoice.invoice_type){
                        case 'prepayment-invoice':
                        case 'cash-prepayment-invoice':
                            document_amount = invoice.advance_payment_amount;
                            break;
                    }
                    const document_customer = invoice.id_customer === null ? null : customers[invoice.id_customer];
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            openDocumentSearchDialog === null && removePrepayment === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "advance-invoice-list-table-col col-1",
                                children: removePrepayment === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    small: true,
                                    minimal: true,
                                    className: "cell-button",
                                    onClick: ()=>removePrepayment(invoice.id_invoice),
                                    icon: "remove"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "advance-invoice-list-table-col col-2",
                                children: document_date === null ? null : (0, _momentDefault.default)(document_date).format('DD.MM.YYYY')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "advance-invoice-list-table-col col-3",
                                children: document_document_number
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "advance-invoice-list-table-col col-4",
                                children: document_customer === null ? null : document_customer.type == 'natural' ? document_customer.surname + ' ' + document_customer.name : document_customer.company_name
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "advance-invoice-list-table-col col-5 text-right",
                                children: document_amount === null ? null : parseFloat(document_amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }) + ' EUR'
                            })
                        ]
                    }, 'prepayment-' + item.id_advance_invoice_consumption);
                })
            })
        ]
    });
}
class EditInvoiceDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.openSelectCustomerDialog = this.openSelectCustomerDialog.bind(this);
        this.closeSelectCustomerDialog = this.closeSelectCustomerDialog.bind(this);
        this.calculateInvoiceSum = this.calculateInvoiceSum.bind(this);
        this.calculateRemainingAmount = this.calculateRemainingAmount.bind(this);
        this.getItemFromState = this.getItemFromState.bind(this);
        this.changeAdvancePaymentValue = this.changeAdvancePaymentValue.bind(this);
        this.closeAndSaveAsDraft = this.closeAndSaveAsDraft.bind(this);
        this.closeAndSave = this.closeAndSave.bind(this);
        this.closeWithoutSave = this.closeWithoutSave.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.convertInvoiceItems = this.convertInvoiceItems.bind(this);
        this.closeAndCreateNewInvoice = this.closeAndCreateNewInvoice.bind(this);
        this.openSplitPaymentDialog = this.openSplitPaymentDialog.bind(this);
        this.closeSplitPaymentDialog = this.closeSplitPaymentDialog.bind(this);
        this.hasChanged = this.hasChanged.bind(this);
        this.isDraft = this.isDraft.bind(this);
        this.canBeSavedAsFinal = this.canBeSavedAsFinal.bind(this);
        this.toLocalStringWithTime = this.toLocalStringWithTime.bind(this);
        this.openDocumentSearchDialog = this.openDocumentSearchDialog.bind(this);
        this.closeDocumentSearchDialog = this.closeDocumentSearchDialog.bind(this);
        this.removePrepayment = this.removePrepayment.bind(this);
        this.updateAdvancePaymentAmountFromPrepayments = this.updateAdvancePaymentAmountFromPrepayments.bind(this);
        this.calculateAdvancePaymentsFromPrepayments = this.calculateAdvancePaymentsFromPrepayments.bind(this);
        this.loadUserHistory = this.loadUserHistory.bind(this);
        this.texts = {
            title: '',
            invoice_number_title: '',
            invoice_date_title: '',
            payment_date_title: '',
            credit_note_type_title: ''
        };
        let first_payment = null;
        let split_payment_types = [];
        if (props.item !== null && props.item.payments !== undefined && props.item.payments !== null) {
            if (props.item.payments.length == 1) first_payment = props.item.payments[0];
            split_payment_types = props.item.payments;
        }
        const invoice_number_internal = props.item === null ? '' : props.item.invoice_number_internal || '';
        let draft = props.item === null ? true : props.item.draft;
        if (draft === undefined) draft = true;
        const invoice_type = props.item === null ? props.type : props.item.invoice_type || props.type;
        let read_only = false;
        if (!draft && (invoice_type == 'cash-invoice' || invoice_type == 'cash-prepayment-invoice')) read_only = true;
        const prepayments = [];
        if (props.selected_advance_invoices_amounts !== undefined && props.selected_advance_invoices_amounts !== null && Object.keys(props.selected_advance_invoices_amounts).length > 0) for(let id_invoice in props.selected_advance_invoices_amounts)prepayments.push({
            id_advance_invoice_consumption: (0, _uuidDefault.default).v4(),
            created: null,
            updated: null,
            advance_id_invoice: id_invoice,
            consumer_id_invoice: null,
            amount: props.selected_advance_invoices_amounts[id_invoice],
            new_amount: props.selected_advance_invoices_amounts[id_invoice],
            enabled: true
        });
        else if (props.item !== null) {
            const id_advance_invoice_consumptions = props.id_advance_invoice_consumption_by_id_consumer_invoices[props.item.id_invoice] || [];
            for(let i = 0; i < id_advance_invoice_consumptions.length; i++)prepayments.push({
                ...props.advance_invoice_consumptions[id_advance_invoice_consumptions[i]],
                new_amount: props.advance_invoice_consumptions[id_advance_invoice_consumptions[i]].amount
            });
        }
        this.state = {
            invoice_number: props.item === null || props.item.invoice_number === null ? '' : props.item.invoice_number,
            invoice_number_internal,
            id_customer: props.item === null ? null : props.item.id_customer || null,
            invoice_date: props.item === null ? new Date() : props.item.invoice_date === null ? null : new Date(props.item.invoice_date),
            payment_date: props.item === null ? null : props.item.payment_date === null ? null : new Date(props.item.payment_date),
            paid: props.item === null ? false : props.item.paid,
            service_date_start: props.item === null ? new Date() : props.item.service_date_start === null ? null : new Date(props.item.service_date_start),
            service_date_end: props.item === null ? new Date() : props.item.service_date_end === null ? null : new Date(props.item.service_date_end),
            reference: props.item === null ? '' : props.item.reference || '',
            reservation: props.item === null ? '' : props.item.reservation || '',
            id_payment_type: first_payment === null ? split_payment_types.length > 0 ? -2 : null : first_payment.id_payment_type,
            split_payment_types,
            invoice_type,
            vat_type: '',
            note: props.item === null ? '' : props.item.note || '',
            credit_note_type: props.item === null ? null : props.item.credit_note_type,
            documents: [],
            invoice_items: this.convertInvoiceItems(props.item, read_only),
            select_customer_dialog_open: false,
            select_customer_dialog_surname: '',
            split_payment_data: [
                {
                    title: 'Gotovina',
                    value: 0
                },
                {
                    title: 'Maestro',
                    value: 0
                },
                {
                    title: 'MasterCard',
                    value: 0
                },
                {
                    title: 'Visa',
                    value: 0
                }
            ],
            advance_payment_value: props.item === null ? 0 : props.item.advance_payment_amount === undefined ? 0 : props.item.advance_payment_amount,
            advance_payment_value_formatted: props.item === null ? 0 : this.formatNumber(props.item.advance_payment_amount || 0),
            advance_payment_percent: props.item !== null ? null : props.type == 'prepayment-invoice' || props.type == 'cash-prepayment-invoice' ? 100 : 0,
            advance_payment_percent_formatted: props.item !== null ? 0 : this.formatNumber(props.type == 'prepayment-invoice' || props.type == 'cash-prepayment-invoice' ? 100 : 0),
            close_dialog_save_item: false,
            close_dialog_save_as_draft: false,
            close_dialog_confirm_open: false,
            payment_date_changed: false,
            payment_date_changed_ignore_requested: false,
            payment_date_changed_ignore: false,
            draft,
            reversed: props.item === null ? false : props.item.reversed,
            reverse_invoice: props.item === null ? false : props.item.reverse_invoice === undefined ? false : props.item.reverse_invoice,
            reverse_invoice_reference: props.item === null ? null : props.item.reverse_invoice_reference,
            original_id_invoice: props.item === null ? '' : props.item.original_id_invoice === undefined ? '' : props.item.original_id_invoice,
            original_invoice_type: props.item === null ? '' : props.item.original_invoice_type === undefined ? '' : props.item.original_invoice_type,
            read_only,
            split_payment_dialog_open: false,
            prepayments,
            document_search_dialog_open: false,
            user_history: null
        };
        if (this.state.invoice_type == 'credit-note' && props.item === null) this.state.payment_date = this.state.payment_date === null ? this.state.invoice_date : props.item.payment_date;
        if (this.state.reversed === undefined) this.state.reversed = false;
        if (props.item === null || props.item.id_invoice === null || props.item.id_invoice === undefined || this.state.payment_date === null) {
            if (this.state.payment_date === null) {
                if (this.state.invoice_type == 'invoice' || this.state.invoice_type == 'offer') {
                    const due_day_count = this.state.id_customer !== null ? props.customers[this.state.id_customer].due_day_count : props.settings.due_day_count;
                    this.state.payment_date = (0, _momentDefault.default)(this.state.invoice_date).add(due_day_count, 'days').toDate();
                } else if (this.state.invoice_type == 'prepayment-invoice' || this.state.invoice_type == 'cash-prepayment-invoice') this.state.payment_date = new Date();
            }
        }
        if (this.state.id_payment_type === null) {
            const payment_types = Object.values(props.payment_types);
            if (payment_types.length > 0) this.state.id_payment_type = payment_types[0].id_payment_type;
        }
        this.texts.service_date_title = 'Datum storitve';
        this.texts.payment_date_title = 'Datum valute';
        if (this.state.invoice_type == 'cash-invoice') {
            this.texts.title = "Vnos blagajni\u0161kega ra\u010Duna";
            this.texts.invoice_number_title = "Blagajni\u0161ki ra\u010Dun \u0161t.:";
            this.texts.invoice_date_title = "Datum ra\u010Duna";
        } else if (this.state.invoice_type == 'invoice') {
            this.texts.title = "Vnos ra\u010Duna";
            this.texts.invoice_number_title = "Ra\u010Dun \u0161t.:";
            this.texts.invoice_date_title = 'Datum fakture';
        } else if (this.state.invoice_type == 'prepayment-invoice') {
            this.texts.title = "Vnos avansnega ra\u010Duna";
            this.texts.invoice_number_title = "Avans \u0161t.:";
            this.texts.invoice_date_title = 'Datum avansa';
        } else if (this.state.invoice_type == 'credit-note') {
            this.texts.title = 'Vnos dobropisa';
            this.texts.invoice_number_title = "Dobropis \u0161t.:";
            this.texts.invoice_date_title = 'Datum dobropisa';
            this.texts.payment_date_title = 'Datum DDV';
            this.texts.credit_note_type_title = 'Vrsta dobropisa';
        } else if (this.state.invoice_type == 'cash-prepayment-invoice') {
            this.texts.title = "Vnos ra\u010Duna za predpla\u010Dilo";
            this.texts.invoice_number_title = "Ra\u010Dun za predpla\u010Dilo \u0161t.:";
            this.texts.invoice_date_title = "Datum ra\u010Duna";
        } else if (this.state.invoice_type == 'offer') {
            this.texts.title = 'Vnos ponudbe';
            this.texts.invoice_number_title = "Ponudba \u0161t.:";
            this.texts.invoice_date_title = 'Datum ponudbe';
            this.texts.payment_date_title = 'Datum veljavnosti';
            this.texts.service_date_title = 'Datum storitve/termin';
        }
        if (props.item !== null && props.item.id_invoice_fiscal_verification !== null && props.item.id_invoice_fiscal_verification !== undefined && props.invoice_fiscal_verifications[props.item.id_invoice_fiscal_verification] === undefined) (0, _business.loadInvoiceFiscalVerification)(props.api_url, props.item.id_invoice_fiscal_verification, props.dispatch, props.token);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.invoice_items != prevState.invoice_items) // if an item was deleted, focus new/empty item
        {
            if (this.state.invoice_items.length < prevState.invoice_items.length) {
                const service_suggest_inputs = document.querySelectorAll('.service-suggest input');
                if (service_suggest_inputs.length > 0) service_suggest_inputs[service_suggest_inputs.length - 1].focus();
            }
        }
        this.updateAdvancePaymentAmountFromPrepayments();
    }
    componentDidMount() {
        if (this.state.invoice_type == 'cash-invoice') setTimeout(()=>{
            const service_suggest_inputs = document.querySelectorAll('.service-suggest input');
            if (service_suggest_inputs.length > 0) service_suggest_inputs[0].focus();
        }, 1000);
        this.updateAdvancePaymentAmountFromPrepayments();
    }
    hasChanged() {
        if (this.props.item === null || this.props.item === undefined) return true;
        if (this.props.item.id_customer != this.state.id_customer) return true;
        let first_payment = null;
        let split_payment_types = [];
        if (this.props.item !== null && this.props.item.payments !== undefined && this.props.item.payments !== null) {
            if (this.props.item.payments.length == 1) first_payment = this.props.item.payments[0];
            split_payment_types = this.props.item.payments;
        }
        if (this.state.id_payment_type == -2) {
            if (first_payment !== null) return true;
            if (split_payment_types.length != this.state.split_payment_types.length) return true;
            let found_diff = false;
            for(let i = 0; i < split_payment_types.length; i++){
                let found = false;
                for(let j = 0; j < this.state.split_payment_types.length; j++)if (this.state.split_payment_types[j].id_payment_type == split_payment_types[i].id_payment_type && this.state.split_payment_types[j].amount == split_payment_types[i].amount) {
                    found = true;
                    break;
                }
                if (!found) {
                    found_diff = true;
                    break;
                }
            }
            if (found_diff) return true;
        } else if (first_payment === null || first_payment !== null && this.state.id_payment_type != first_payment.id_payment_type) return true;
        return false;
    }
    isDraft() {
        return this.state.invoice_number.length == 0;
    }
    isCashAndCanBeSaved() {
        // must have cash register selected to be able to save cash invoice and cash prepayment invoice
        if ([
            'cash-invoice',
            'cash-prepayment-invoice'
        ].indexOf(this.state.invoice_type) != -1) {
            if (this.props.current_id_cash_register === null || this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === 0) return false;
        }
        return true;
    }
    canBeSavedAsFinal() {
        return this.state.invoice_number.length == 0 || [
            'cash-invoice',
            'cash-prepayment-invoice'
        ].indexOf(this.state.invoice_type) == -1;
    }
    getEmptyInvoiceItem() {
        return {
            id_invoice_item: -1,
            id_invoice: -1,
            id_item: -1,
            id_item_price_list: null,
            quantity: 1,
            discount: 0,
            approved_percent: 100,
            item_measuring_unit_decimal_digit_count: 0,
            description: ''
        };
    }
    convertInvoiceItems(item, read_only) {
        const items = [];
        if (item !== null) for(let i = 0; i < item.items.length; i++)items.push(InvoiceItemViewModel.FromInvoiceItem(this.props.items, {
            ...item.items[i]
        }, this.props.tax_rates));
        if (!read_only) {
            const empty_invoice_item_view = InvoiceItemViewModel.FromInvoiceItem(this.props.items, this.getEmptyInvoiceItem(), this.props.tax_rates);
            empty_invoice_item_view.invoice_item.quantity = 1;
            items.push(empty_invoice_item_view);
        }
        return items;
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    getMaxDate() {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 10);
        return date;
    }
    openSelectCustomerDialog(query, item) {
        item = item || null;
        this.setState({
            select_customer_dialog_open: true,
            select_customer_dialog_surname: query,
            select_customer_dialog_item: item
        });
    }
    closeSelectCustomerDialog(id_customer, new_customer) {
        const state = {
            select_customer_dialog_open: false
        };
        if (id_customer !== undefined) state.id_customer = id_customer;
        this.setState(state);
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    calculateInvoiceSum(round) {
        round = round === undefined ? true : false;
        const sum = this.state.invoice_items.reduce((acc, item)=>acc + parseFloat(item.single_price_with_vat) * parseFloat(item.invoice_item.quantity) * (1 - parseFloat(item.invoice_item.discount) / 100), 0);
        if (round) return Math.properRound(sum, 2);
        return sum;
    }
    calculateRemainingAmount() {
        const total_sum = this.calculateInvoiceSum(false);
        const advance_sum = this.state.advance_payment_value !== null ? this.state.advance_payment_value : total_sum * (this.state.advance_payment_percent / 100);
        return total_sum - advance_sum;
    }
    calculateRemainingAmountForPayment() {
        const total_sum = this.calculateInvoiceSum();
        const advance_sum = this.state.advance_payment_value !== null ? this.state.advance_payment_value : total_sum * (this.state.advance_payment_percent / 100);
        if (this.state.invoice_type == 'prepayment-invoice' || this.state.invoice_type == 'cash-prepayment-invoice') return advance_sum;
        return total_sum - advance_sum;
    }
    getItemFromState(save_as_draft) {
        const invoice_amount = this.calculateInvoiceSum();
        const advance_payment_amount = this.state.advance_payment_value !== null ? this.state.advance_payment_value : invoice_amount * (this.state.advance_payment_percent / 100);
        const selected_advance_invoices_amounts = {};
        for(let i = 0; i < this.state.prepayments.length; i++){
            const prepayment = this.state.prepayments[i];
            if (this.state.reverse_invoice === true && prepayment.new_amount < 0 || this.state.reverse_invoice === false && prepayment.new_amount > 0) selected_advance_invoices_amounts[prepayment.advance_id_invoice] = prepayment.new_amount;
        }
        if ([
            'prepayment-invoice',
            'cash-prepayment-invoice'
        ].indexOf(this.state.invoice_type) != -1 && this.state.original_id_invoice != '' && [
            'prepayment-invoice',
            'cash-prepayment-invoice'
        ].indexOf(this.state.original_invoice_type) != -1) selected_advance_invoices_amounts[this.state.original_id_invoice] = -advance_payment_amount;
        let original_id_invoice = this.state.original_id_invoice;
        let original_invoice_type = this.state.original_invoice_type;
        // add references to prepayment invoices
        if (Array.isArray(original_id_invoice) && Array.isArray(original_invoice_type)) {
            for(let id_invoice in selected_advance_invoices_amounts)if (original_id_invoice.indexOf(id_invoice) == -1) {
                original_id_invoice.push(id_invoice);
                original_invoice_type.push(this.props.invoices[id_invoice].invoice_type);
            }
        }
        let id_cash_register = this.props.item === null || this.props.item.id_cash_register === null || this.props.item.id_cash_register === undefined ? this.props.current_id_cash_register : this.props.item.id_cash_register;
        // override id cash register with currently selected one for draft
        if (this.props.item !== null && this.props.item.draft) id_cash_register = this.props.current_id_cash_register;
        const item = (0, _invoiceCreatorDefault.default).CreateInvoiceFromInitialData({
            id_invoice: this.props.item === null ? (0, _uuidDefault.default).v4() : this.props.item.id_invoice,
            invoice_number: this.props.item === null ? null : this.props.item.invoice_number,
            invoice_number_internal: this.props.item === null ? null : this.props.item.invoice_number_internal,
            invoice_type: this.props.item === null ? this.props.type : this.props.item.invoice_type,
            id_customer: this.state.id_customer,
            invoice_date: this.state.invoice_date === null ? null : this.toIsoString(this.state.invoice_date),
            payment_date: this.state.payment_date === null ? null : this.toIsoString(this.state.payment_date),
            service_date_start: this.state.service_date_start === null ? null : this.toIsoString(this.state.service_date_start),
            service_date_end: this.state.service_date_end === null ? null : this.toIsoString(this.state.service_date_end),
            reference: this.state.reference,
            reservation: this.state.reservation,
            paid: this.state.paid,
            items: this.state.invoice_items.filter((item)=>item.invoice_item.id_item != -1).map((item, item_idx)=>{
                const item_item = this.props.items[item.invoice_item.id_item];
                const item_price_list = item_item.price_lists[item.invoice_item.id_item_price_list];
                const tax_rate = this.props.tax_rates[item_price_list.id_tax_rate];
                const measuring_unit = this.props.measuring_units[item_item.id_measuring_unit];
                const id_invoice_item = item.invoice_item.id_invoice_item == -1 ? (0, _uuidDefault.default).v4() : item.invoice_item.id_invoice_item;
                return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                    id_invoice_item: id_invoice_item,
                    id_item: item.invoice_item.id_item,
                    id_item_price_list: item.invoice_item.id_item_price_list,
                    quantity: item.invoice_item.quantity,
                    discount: item.invoice_item.discount,
                    item_type: item_item.type,
                    item_measuring_unit_code: measuring_unit.title,
                    item_measuring_unit_decimal_digit_count: measuring_unit.decimal_digit_count,
                    item_ean: item_item.ean,
                    item_title: item_item.title,
                    price: item.single_price_with_vat,
                    id_tax_rate: item_price_list.id_tax_rate,
                    tax_rate: tax_rate.value,
                    description: item.invoice_item.description,
                    approved_percent: item.invoice_item.approved_percent,
                    ord: item_idx,
                    taxable: tax_rate.taxable,
                    item_internal_code: item_item.internal_code,
                    id_warehouse: item_item.type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(id_cash_register === undefined || id_cash_register === null ? null : this.props.cash_registers[id_cash_register], this.props.warehouses)
                });
            }),
            eor: this.props.item === null ? '' : this.props.item.eor,
            zoi: this.props.item === null ? '' : this.props.item.zoi,
            //documents:      [],
            note: this.state.note,
            invoice_amount,
            advance_payment_amount,
            username: this.props.user.username,
            draft: save_as_draft,
            reversed: this.state.reversed,
            reverse_invoice: this.state.reverse_invoice,
            reverse_invoice_reference: this.state.reverse_invoice_reference,
            original_id_invoice,
            original_invoice_type,
            id_cash_register,
            selected_advance_invoices_amounts,
            credit_note_type: this.state.credit_note_type == '' ? null : this.state.credit_note_type
        });
        if (item.id_invoice === null || item.id_invoice === undefined) item.id_invoice = (0, _uuidDefault.default).v4();
        if (this.state.id_payment_type == -2) for(let i = 0; i < this.state.split_payment_types.length; i++)item.payments.push({
            id_invoice_payment: this.state.split_payment_types[i].id_invoice_payment,
            id_payment_type: this.state.split_payment_types[i].id_payment_type,
            amount: this.state.split_payment_types[i].amount,
            //TODO should we overwrite payment date on existing payment with new one?
            payment_date: this.toIsoString(new Date())
        });
        else {
            let existing_id_invoice_payment = null;
            for(let i = 0; i < this.state.split_payment_types.length; i++)if (this.state.split_payment_types[i].id_payment_type == this.state.id_payment_type) {
                existing_id_invoice_payment = this.state.split_payment_types[i].id_invoice_payment;
                break;
            }
            item.payments.push({
                id_invoice_payment: existing_id_invoice_payment === null ? (0, _uuidDefault.default).v4() : existing_id_invoice_payment,
                id_payment_type: this.state.id_payment_type,
                amount: this.calculateRemainingAmountForPayment(),
                //TODO should we overwrite payment date on existing payment with new one?
                payment_date: this.toIsoString(new Date())
            });
        }
        const customer = item.id_customer === null ? null : this.props.customers[item.id_customer];
        item.customer_id_country = customer === null ? null : customer.id_country;
        item.customer_type = customer === null ? null : customer.type;
        item.customer_address = customer === null ? null : customer.address;
        item.customer_birth_date = customer === null ? null : customer.birth_date;
        item.customer_company_long_name = customer === null ? null : customer.company_long_name;
        item.customer_company_name = customer === null ? null : customer.company_name;
        item.customer_email = customer === null ? null : customer.email;
        item.customer_name = customer === null ? null : customer.name;
        item.customer_surname = customer === null ? null : customer.surname;
        item.customer_phone = customer === null ? null : customer.phone;
        item.customer_post_code = customer === null ? null : customer.post_code;
        item.customer_post_office = customer === null ? null : customer.post_office;
        item.customer_sex = customer === null ? null : customer.sex;
        item.customer_tax_number = customer === null ? null : customer.tax_number;
        item.customer_vat_prefix = customer === null ? null : customer.vat_prefix;
        item.customer_vat_registered = customer === null ? null : customer.vat_registered;
        item.customer_display_company_long_name_on_invoices = customer === null ? null : customer.display_company_long_name_on_invoices;
        item.customer_identification_number = customer === null ? null : customer.identification_number;
        item.customer_internal_code = customer === null ? null : customer.internal_code;
        return item;
    }
    changeAdvancePaymentValue(field_name, value, formatted_value) {
        if (field_name == 'refresh') {
            const should_cap_at_max = (this.state.invoice_type == 'prepayment-invoice' || this.state.invoice_type == 'cash-prepayment-invoice') && this.props.item !== null && this.props.item !== undefined && this.props.item.max_advance_payment_amount !== null && this.props.item.max_advance_payment_amount !== undefined;
            if (this.state.advance_payment_value !== null) {
                let val = Math.properRound(this.state.advance_payment_value, 2);
                if (should_cap_at_max && val < -this.props.item.max_advance_payment_amount) val = -this.props.item.max_advance_payment_amount;
                this.setState({
                    advance_payment_value: val,
                    advance_payment_value_formatted: this.formatNumber(val)
                });
            } else {
                let val = Math.properRound(this.state.advance_payment_percent, 2);
                const sum = this.calculateInvoiceSum(false);
                const max_percent = this.props.item === null || this.props.item.undefined ? 0 : -this.props.item.max_advance_payment_amount / sum * 100;
                if (should_cap_at_max && val > max_percent) val = Math.properRound(max_percent, 2);
                this.setState({
                    advance_payment_percent: val,
                    advance_payment_percent_formatted: this.formatNumber(val)
                });
            }
        } else if (field_name == 'advance_payment_value') this.setState({
            advance_payment_value: value,
            advance_payment_value_formatted: formatted_value,
            advance_payment_percent: null,
            advance_payment_percent_formatted: 0
        });
        else if (field_name == 'advance_payment_percent') this.setState({
            advance_payment_value: null,
            advance_payment_value_formatted: 0,
            advance_payment_percent: value,
            advance_payment_percent_formatted: formatted_value
        });
    }
    recalculateTable(invoice_items) {
        invoice_items = invoice_items || this.state.invoice_items;
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    closeAndSaveAsDraft() {
        this.closeDialog(true, true);
    }
    closeAndSave() {
        this.closeDialog(true, false);
    }
    closeWithoutSave(confirm) {
        this.closeDialog(false, false, confirm);
    }
    closeAndCreateNewInvoice(invoice_type) {
        this.closeDialog(true, false, false, true, invoice_type);
    }
    closeDialog(save, save_as_draft, confirm, payment_date_ignore_changed, open_create_invoice_type) {
        if (confirm) {
            this.setState({
                close_dialog_save_item: save,
                close_dialog_save_as_draft: save_as_draft,
                close_dialog_confirm_open: true
            });
            return;
        }
        if (!save) {
            this.props.closeEditInvoiceDialog(undefined, open_create_invoice_type, !save_as_draft);
            return;
        }
        if ([
            'invoice',
            'prepayment-invoice',
            'credit-note',
            'offer'
        ].indexOf(this.state.invoice_type) != -1) {
            if (!save_as_draft && (this.state.id_customer === null || this.state.id_customer === -1)) {
                (0, _appToaster.AppToaster).show({
                    message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            "Napake na dokumentu:",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            "Stranka ni izbrana"
                        ]
                    }),
                    intent: 'danger',
                    icon: 'issue'
                });
                return;
            }
        }
        if (this.state.invoice_type == 'prepayment-invoice') //TODO only do this on new invoices?
        {
            if (!this.state.payment_date_changed && !this.state.payment_date_changed_ignore && !payment_date_ignore_changed) {
                this.setState({
                    close_dialog_save_item: save,
                    close_dialog_save_as_draft: save_as_draft,
                    payment_date_changed_ignore_requested: true
                });
                return;
            }
        }
        const item = this.getItemFromState(save_as_draft);
        //TODO validation
        if (item.items.length == 0) {
            (0, _appToaster.AppToaster).show({
                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Napake na dokumentu:",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "Dokument ne sme biti prazen"
                    ]
                }),
                intent: 'danger',
                icon: 'issue'
            });
            return;
        }
        if ((this.state.invoice_type == 'prepayment-invoice' || this.state.invoice_type == 'cash-prepayment-invoice') && item.advance_payment_amount == 0) {
            (0, _appToaster.AppToaster).show({
                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Napake na dokumentu:",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "Znesek predpla\u010Dila ne sme biti prazen"
                    ]
                }),
                intent: 'danger',
                icon: 'issue'
            });
            return;
        }
        if (this.state.invoice_type == 'credit-note' && (item.credit_note_type === null || item.credit_note_type == '')) {
            (0, _appToaster.AppToaster).show({
                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Napake na dokumentu:",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "Vrsta dobropisa ne sme biti prazna"
                    ]
                }),
                intent: 'danger',
                icon: 'issue'
            });
            return;
        }
        this.props.closeEditInvoiceDialog(item, open_create_invoice_type, !save_as_draft);
    }
    openSplitPaymentDialog() {
        this.setState({
            split_payment_dialog_open: true
        });
    }
    closeSplitPaymentDialog(payments) {
        this.setState({
            split_payment_dialog_open: false
        });
        if (payments !== undefined) {
            for(let i = 0; i < payments.length; i++){
                if (payments[i].id_invoice_payment === null) payments[i].id_invoice_payment = (0, _uuidDefault.default).v4();
                if (payments[i].payment_date === null) payments[i].payment_date = this.toIsoString(new Date()); // today
            }
            this.setState({
                split_payment_types: payments
            });
        }
    }
    toLocalStringWithTime(date) {
        if (date === null) return '';
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear() + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');
    }
    updateAdvancePaymentAmountFromPrepayments() {
        // only update if this is a draft
        if (!this.canBeSavedAsFinal()) return;
        // try to match advance payment amount to invoice sum, if possible (e.g. there are enough prepayments)
        const invoice_sum = this.calculateInvoiceSum(false);
        if (this.state.invoice_type != 'prepayment-invoice' && // manual advance payment amount
        this.state.invoice_type != 'cash-prepayment-invoice' && // manual advance payment amount
        this.state.advance_payment_value !== null && this.state.advance_payment_value != invoice_sum) {
            const { advance_amount, prepayments } = this.calculateAdvancePaymentsFromPrepayments(invoice_sum);
            console.log({
                advance_amount,
                prepayments
            });
            if (this.state.advance_payment_value != advance_amount) this.setState({
                advance_payment_value: advance_amount,
                prepayments
            });
        }
    }
    calculateAdvancePaymentsFromPrepayments(invoice_amount) {
        let advance_amount_reduced = 0;
        let advance_amount = 0;
        const prepayments = [];
        const prepayment_invoices_sorted_by_date = this.state.prepayments.map((x)=>{
            return {
                ...this.props.invoices[x.advance_id_invoice],
                advance_payment_amount: x.amount,
                amount: x.amount
            };
        }).sort((a, b)=>{
            if (a.created < b.created) return -1;
            else if (a.created > b.created) return 1;
            return 0;
        });
        /*
		for reverse invoices, we start with amount that wasn't paid from advance payments
		since we want to return (i.e. reverse) the least possible amount of advance payments
		*/ console.log({
            reverse_invoice: this.state.reverse_invoice,
            reverse_invoice_reference: this.state.reverse_invoice_reference
        });
        if (this.state.reverse_invoice === true && (this.state.reverse_invoice_reference ?? '') != '') {
            const reversed_invoice = this.props.invoices[this.state.reverse_invoice_reference];
            if (reversed_invoice !== undefined) {
                console.log({
                    a: reversed_invoice.invoice_amount - reversed_invoice.advance_payment_amount,
                    r_invoice_amount: reversed_invoice.invoice_amount,
                    advance_payment_amount: reversed_invoice.advance_payment_amount,
                    invoice_amount
                });
                advance_amount_reduced = Math.max(invoice_amount, -1 * (reversed_invoice.invoice_amount - reversed_invoice.advance_payment_amount));
            }
        }
        console.log({
            advance_amount_reduced,
            invoice_amount
        });
        for(let i = 0; i < prepayment_invoices_sorted_by_date.length; i++){
            const invoice = prepayment_invoices_sorted_by_date[i];
            let amount = 0;
            // for reverse_invoice, min and max are exchanged, since we're dealing with negative numbers
            if (this.state.reverse_invoice === true) {
                amount = Math.min(0, parseFloat(invoice.advance_payment_amount));
                // clamp to invoice amount
                amount = Math.max(advance_amount + amount + advance_amount_reduced, invoice_amount) - advance_amount - advance_amount_reduced;
            } else {
                amount = Math.max(0, parseFloat(invoice.advance_payment_amount));
                // clamp to invoice amount
                amount = Math.min(advance_amount + amount, invoice_amount) - advance_amount;
            }
            console.log({
                amount,
                invoice_amount
            });
            prepayments.push({
                id_advance_invoice_consumption: (0, _uuidDefault.default).v4(),
                created: null,
                updated: null,
                advance_id_invoice: invoice.id_invoice,
                consumer_id_invoice: null,
                amount: invoice.amount,
                new_amount: amount,
                enabled: true
            });
            advance_amount += amount;
        }
        return {
            advance_amount,
            prepayments
        };
    }
    openDocumentSearchDialog() {
        this.setState({
            document_search_dialog_open: true
        });
    }
    closeDocumentSearchDialog(id_document, document_type) {
        this.setState({
            document_search_dialog_open: false
        });
        if (id_document !== undefined && document_type !== undefined) {
            const prepayments = this.state.prepayments;
            let found = false;
            for(let i = 0; i < prepayments.length; i++)if (prepayments[i].advance_id_invoice == id_document) {
                found = true;
                break;
            }
            if (!found) {
                const item = this.props.invoices[id_document];
                prepayments.push({
                    id_advance_invoice_consumption: (0, _uuidDefault.default).v4(),
                    created: null,
                    updated: null,
                    advance_id_invoice: id_document,
                    consumer_id_invoice: null,
                    amount: Math.max(0, parseFloat(item.advance_payment_amount) - parseFloat(item.used_advance_payment_amount)),
                    new_amount: Math.max(0, parseFloat(item.advance_payment_amount) - parseFloat(item.used_advance_payment_amount)),
                    enabled: true
                });
                this.setState({
                    prepayments
                });
                this.updateAdvancePaymentAmountFromPrepayments();
            }
        }
    }
    removePrepayment(id_invoice) {
        const prepayments = this.state.prepayments;
        let found_idx = -1;
        for(let i = 0; i < prepayments.length; i++)if (prepayments[i].advance_id_invoice == id_invoice) {
            found_idx = i;
            break;
        }
        if (found_idx > -1) {
            prepayments.splice(found_idx, 1);
            this.setState({
                prepayments
            });
            this.updateAdvancePaymentAmountFromPrepayments();
        }
    }
    async loadUserHistory() {
        const user_history = await (0, _business.loadInvoiceUserHistory)(this.props.api_url, this.props.item.id_invoice, this.props.token);
        this.setState({
            user_history
        });
    }
    render() {
        const customer = this.state.id_customer === null ? null : this.props.customers[this.state.id_customer] || null;
        const invoice_fiscal_verification = this.props.item === null || this.props.item.id_invoice_fiscal_verification === null || this.props.item.id_invoice_fiscal_verification === undefined ? null : this.props.invoice_fiscal_verifications[this.props.item.id_invoice_fiscal_verification];
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: !this.state.select_customer_dialog_open,
            onClose: ()=>this.closeWithoutSave(true),
            className: "edit-invoice-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    !this.state.select_customer_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectCustomerDialogDefault.default), {
                        closeSelectCustomerDialog: this.closeSelectCustomerDialog,
                        surname: this.state.select_customer_dialog_surname,
                        item: null
                    }),
                    !this.state.close_dialog_confirm_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                        cancelButtonText: "Prekli\u010Di",
                        confirmButtonText: "Zapri",
                        canEscapeKeyCancel: true,
                        canOutsideClickCancel: true,
                        icon: "help",
                        intent: (0, _core.Intent).PRIMARY,
                        isOpen: true,
                        onConfirm: ()=>{
                            this.closeDialog(this.state.close_dialog_save_item, this.state.close_dialog_save_as_draft, false);
                            this.setState({
                                close_dialog_save_item: false,
                                close_dialog_save_as_draft: false,
                                close_dialog_confirm_open: false
                            });
                        },
                        onCancel: ()=>{
                            this.setState({
                                close_dialog_save_item: false,
                                close_dialog_save_as_draft: false,
                                close_dialog_confirm_open: false
                            });
                        },
                        children: "Res \u017Eelite zapreti brez shranjevanja?"
                    }),
                    !this.state.payment_date_changed_ignore_requested ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                        cancelButtonText: "Prekli\u010Di",
                        confirmButtonText: "Da",
                        canEscapeKeyCancel: true,
                        canOutsideClickCancel: true,
                        icon: "help",
                        intent: (0, _core.Intent).PRIMARY,
                        isOpen: true,
                        onConfirm: ()=>{
                            this.closeDialog(this.state.close_dialog_save_item, this.state.close_dialog_save_as_draft, false, true);
                            this.setState({
                                payment_date_changed_ignore_requested: false,
                                payment_date_changed_ignore: true
                            });
                        },
                        onCancel: ()=>{
                            this.setState({
                                payment_date_changed_ignore_requested: false,
                                payment_date_changed_ignore: false
                            });
                        },
                        children: "Datum pla\u010Dila ni bil spremenjen. Vseeno nadaljujem?"
                    }),
                    !this.state.split_payment_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _splitPaymentDialogDefault.default), {
                        payments: this.state.split_payment_types,
                        total_value: this.calculateRemainingAmountForPayment(),
                        closeDialog: this.closeSplitPaymentDialog
                    }),
                    !this.state.select_customer_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectCustomerDialogDefault.default), {
                        closeSelectCustomerDialog: this.closeSelectCustomerDialog,
                        surname: this.state.select_customer_dialog_surname,
                        item: this.state.select_customer_dialog_item
                    }),
                    !this.state.document_search_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prepaymentDocumentSearchDialogDefault.default), {
                        closeDialog: this.closeDocumentSearchDialog
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: this.texts.title
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: [
                                    [
                                        'offer',
                                        'prepayment-invoice'
                                    ].indexOf(this.state.invoice_type) == -1 || this.props.item === null || this.props.item.invoice_number == '' ? null : this.state.draft ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "success",
                                        icon: "inheritance",
                                        className: "w-32 mr-2",
                                        disabled: true,
                                        text: "Izdelaj ..."
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Popover), {
                                        content: this.state.invoice_type == 'offer' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Menu), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                    onClick: ()=>this.closeAndCreateNewInvoice('prepayment-invoice'),
                                                    text: "Avansni ra\u010Dun"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                    onClick: ()=>this.closeAndCreateNewInvoice('cash-invoice'),
                                                    text: "Blagajni\u0161ki ra\u010Dun",
                                                    disabled: this.props.current_id_cash_register == 0
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                    onClick: ()=>this.closeAndCreateNewInvoice('cash-prepayment-invoice'),
                                                    text: "Ra\u010Dun za predpla\u010Dilo",
                                                    disabled: true
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                    onClick: ()=>this.closeAndCreateNewInvoice('invoice'),
                                                    text: "Fakturo"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Menu), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                    onClick: ()=>this.closeAndCreateNewInvoice('cash-invoice'),
                                                    text: "Blagajni\u0161ki ra\u010Dun",
                                                    disabled: this.props.current_id_cash_register == 0
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                    onClick: ()=>this.closeAndCreateNewInvoice('invoice'),
                                                    text: "Fakturo"
                                                })
                                            ]
                                        }),
                                        position: (0, _core.Position).BOTTOM,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "inheritance",
                                            className: "w-32 mr-2",
                                            text: "Izdelaj ..."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        icon: "floppy-disk",
                                        onClick: ()=>this.closeAndSaveAsDraft(),
                                        className: "w-48",
                                        disabled: !this.isDraft(),
                                        children: "Shrani kot osnutek"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "success",
                                        icon: "tick",
                                        onClick: ()=>this.closeAndSave(),
                                        className: "w-48 ml-2",
                                        disabled: !this.isCashAndCanBeSaved() || !this.canBeSavedAsFinal() && !this.hasChanged(),
                                        children: "Zapri in zaklju\u010Di"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "danger",
                                        icon: "cross",
                                        onClick: ()=>this.closeWithoutSave(true),
                                        className: "w-48 ml-10",
                                        children: "Zapri brez shranjevanja"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-grow flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "invoice-header",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "invoice-number",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                                className: "bp5-heading",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "font-thin",
                                                        children: [
                                                            this.texts.invoice_number_title,
                                                            " "
                                                        ]
                                                    }),
                                                    this.state.draft ? 'osnutek' : this.state.invoice_number_internal
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "customer",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerSelectDefault.default), {
                                                    itemSelected: (item)=>{
                                                        this.setState({
                                                            id_customer: item.id_customer
                                                        });
                                                    },
                                                    addPersonClick: (query)=>{
                                                        this.openSelectCustomerDialog(query);
                                                    },
                                                    fieldTitle: "Stranka",
                                                    formGroupCls: "mb-0",
                                                    focus: this.state.invoice_type != 'cash-invoice'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerInfoDefault.default), {
                                                    customer: customer,
                                                    countries: this.props.countries,
                                                    editClick: ()=>{
                                                        this.openSelectCustomerDialog('', customer);
                                                    },
                                                    clearClick: ()=>{
                                                        this.setState({
                                                            id_customer: null
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "vat-type",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "edit-invoice--vat-type",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Vrsta obra\u010Duna DDV",
                                                        tooltip: "Vrsta obra\u010Duna DDV"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                        id: "edit-invoice--vat-type",
                                                        fill: true,
                                                        options: [
                                                            {
                                                                title: "DDV obra\u010Dun",
                                                                value: 'ddv'
                                                            },
                                                            {
                                                                title: 'Ni DDV-ja',
                                                                value: 'no-ddv'
                                                            }
                                                        ].map((item)=>{
                                                            return {
                                                                label: item.title,
                                                                value: item.value
                                                            };
                                                        }),
                                                        value: this.state.vat_type,
                                                        onChange: (e)=>{
                                                            this.setState({
                                                                vat_type: e.currentTarget.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: 'invoice-date ' + (this.state.invoice_type == 'cash-invoice' ? 'wide' : ''),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "edit-invoice--invoice-date",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: this.texts.invoice_date_title,
                                                        tooltip: this.texts.invoice_date_title
                                                    }),
                                                    this.state.invoice_type == 'cash-invoice' || this.state.invoice_type == 'cash-prepayment-invoice' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "leading-loose",
                                                        children: this.props.item === null || this.props.item.issued === null ? "ni datuma ra\u010Duna" : (0, _momentDefault.default)(this.props.item.issued).format('DD. MM. YYYY HH:mm:ss')
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                        id: "edit-invoice--invoice-date",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: 'dd. MM. yyyy',
                                                        locale: "sl",
                                                        inputProps: {
                                                            placeholder: '01. 01. ' + new Date().getFullYear()
                                                        },
                                                        selectAllOnFocus: true,
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                        disabled: this.state.read_only,
                                                        onChange: (selectedDate, isUserChange, a, b)=>{
                                                            if (isUserChange) this.setState({
                                                                invoice_date: selectedDate === null ? null : new Date(selectedDate)
                                                            });
                                                        },
                                                        value: this.state.invoice_date === null ? null : (0, _formatISODefault.default)(this.state.invoice_date)
                                                    })
                                                ]
                                            })
                                        }),
                                        this.state.invoice_type != 'invoice' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "payment-date-paid flex flex-row",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "edit-invoice--paid",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Pla\u010Dana",
                                                        tooltip: "Pla\u010Dana"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                        id: "edit-invoice--paid",
                                                        checked: this.state.paid,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                paid: event.target.checked
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        this.state.invoice_type != 'credit-note' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "credit-note-type",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "edit-invoice--credit-note-type",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: this.texts.credit_note_type_title,
                                                        tooltip: this.texts.credit_note_type_title
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                        id: "edit-invoice--credit-note-type",
                                                        fill: true,
                                                        options: [
                                                            {
                                                                title: '-- izberi --',
                                                                value: ''
                                                            },
                                                            {
                                                                title: "Finan\u010Dni",
                                                                value: 'financial'
                                                            },
                                                            {
                                                                title: 'Blagovni',
                                                                value: 'material'
                                                            }
                                                        ].map((item)=>{
                                                            return {
                                                                label: item.title,
                                                                value: item.value
                                                            };
                                                        }),
                                                        value: this.state.credit_note_type || '',
                                                        onChange: (e)=>{
                                                            this.setState({
                                                                credit_note_type: e.currentTarget.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        this.state.invoice_type != 'invoice' && this.state.invoice_type != 'credit-note' && this.state.invoice_type != 'offer' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "payment-date flex flex-row",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "edit-invoice--payment-date",
                                                className: "ml-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: this.texts.payment_date_title,
                                                        tooltip: this.texts.payment_date_title
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                        id: "edit-invoice--payment-date",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: 'dd. MM. yyyy',
                                                        locale: "sl",
                                                        inputProps: {
                                                            placeholder: '01. 01. ' + new Date().getFullYear()
                                                        },
                                                        selectAllOnFocus: true,
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                        onChange: (selectedDate, isUserChange)=>{
                                                            if (isUserChange) this.setState({
                                                                payment_date: selectedDate === null ? null : new Date(selectedDate),
                                                                payment_date_changed: true
                                                            });
                                                        },
                                                        value: this.state.payment_date === null ? null : (0, _formatISODefault.default)(this.state.payment_date)
                                                    })
                                                ]
                                            })
                                        }),
                                        this.state.invoice_type != 'prepayment-invoice' && this.state.invoice_type != 'cash-prepayment-invoice' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "payment-date flex flex-row",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "edit-invoice--payment-date",
                                                className: "ml-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Datum pla\u010Dila",
                                                        tooltip: "Datum pla\u010Dila"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                        id: "edit-invoice--payment-date",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: 'dd. MM. yyyy',
                                                        locale: "sl",
                                                        inputProps: {
                                                            placeholder: '01. 01. ' + new Date().getFullYear()
                                                        },
                                                        selectAllOnFocus: true,
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                        onChange: (selectedDate, isUserChange)=>{
                                                            if (isUserChange) this.setState({
                                                                payment_date: selectedDate === null ? null : new Date(selectedDate),
                                                                payment_date_changed: true
                                                            });
                                                        },
                                                        value: this.state.payment_date === null ? null : (0, _formatISODefault.default)(this.state.payment_date)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "service-date",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "edit-invoice--service-date",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: this.texts.service_date_title,
                                                        tooltip: this.texts.service_date_title
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateRangeInput3), {
                                                        id: "edit-invoice--service-date",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: 'dd. MM. yyyy',
                                                        locale: "sl",
                                                        allowSingleDayRange: true,
                                                        contiguousCalendarMonths: false,
                                                        shortcuts: false,
                                                        startInputProps: {
                                                            placeholder: 'Od',
                                                            className: 'from-until'
                                                        },
                                                        endInputProps: {
                                                            placeholder: 'Do',
                                                            className: 'from-until'
                                                        },
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: this.getMaxDate(),
                                                        selectAllOnFocus: true,
                                                        disabled: this.state.read_only,
                                                        onChange: (selectedRange)=>{
                                                            console.log({
                                                                selectedRange
                                                            });
                                                            this.setState({
                                                                service_date_start: selectedRange[0],
                                                                service_date_end: selectedRange[1]
                                                            });
                                                        },
                                                        value: [
                                                            this.state.service_date_start,
                                                            this.state.service_date_end
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "reference",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "edit-invoice--reference",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Referenca",
                                                        tooltip: "Referenca"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                        id: "edit-invoice--reference",
                                                        value: this.state.reference,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                reference: event.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "reservation",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "edit-invoice--reservation",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Rezervacija",
                                                        tooltip: "Rezervacija"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                        id: "edit-invoice--reservation",
                                                        value: this.state.reservation,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                reservation: event.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        this.state.invoice_type != 'cash-invoice' && this.state.invoice_type != 'cash-prepayment-invoice' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "payment-type",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "edit-invoice--payment-type",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Na\u010Din pla\u010Dila",
                                                        tooltip: "Na\u010Din pla\u010Dila"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                        id: "edit-invoice--payment-type",
                                                        fill: true,
                                                        options: Object.values(this.props.payment_types).filter((x)=>x.visible || x.id_payment_type == this.state.id_payment_type).concat([
                                                            {
                                                                id_payment_type: -2,
                                                                type: 'split-payment',
                                                                title: "Deljeno pla\u010Dilo",
                                                                visible: true,
                                                                ord: 99999
                                                            }
                                                        ]).sort((a, b)=>a.ord - b.ord).map((payment_type)=>{
                                                            return {
                                                                label: payment_type.title,
                                                                value: payment_type.id_payment_type
                                                            };
                                                        }),
                                                        value: this.state.id_payment_type || '',
                                                        onChange: (e)=>{
                                                            this.setState({
                                                                id_payment_type: e.currentTarget.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "split-payment-form",
                                            children: this.state.id_payment_type != -2 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "split-payment-title flex flex-row items-center justify-between pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "font-bold",
                                                                children: "Deljeno pla\u010Dilo"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                className: "ml-2",
                                                                onClick: this.openSplitPaymentDialog,
                                                                children: "Uredi"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "split-payment-form-table",
                                                            children: this.state.split_payment_types.map((invoice_payment, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "col-1 pl-2",
                                                                            style: {
                                                                                gridRow: idx
                                                                            },
                                                                            children: this.props.payment_types[invoice_payment.id_payment_type].title
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "col-2",
                                                                            style: {
                                                                                gridRow: idx
                                                                            },
                                                                            children: [
                                                                                this.formatNumber(invoice_payment.amount),
                                                                                " EUR"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }, invoice_payment.id_invoice_payment))
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "documents flex flex-row",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Tabs), {
                                                className: "flex flex-col flex-1",
                                                vertical: false,
                                                onChange: (newTabId)=>{
                                                    if (newTabId == 'user-history' && this.state.user_history === null) this.loadUserHistory();
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                        id: "comment",
                                                        title: "Opomba",
                                                        panelClassName: "flex-grow",
                                                        panel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                            className: "table-full-h",
                                                            fill: true,
                                                            onChange: (e)=>{
                                                                this.setState({
                                                                    note: e.target.value
                                                                });
                                                            },
                                                            value: this.state.note
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                        id: "documents",
                                                        title: "Dokumenti",
                                                        panelClassName: "flex-grow h-full",
                                                        panel: this.props.item === null || this.props.item.id_invoice === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentsDefault.default), {
                                                            id_document: this.props.item.id_invoice,
                                                            deep: true,
                                                            document_type: this.state.invoice_type
                                                        })
                                                    }),
                                                    [
                                                        'invoice',
                                                        'cash-invoice'
                                                    ].indexOf(this.state.invoice_type) === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                        id: "prepayments",
                                                        title: "Predpla\u010Dila",
                                                        panelClassName: "flex-grow h-full",
                                                        panel: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdvanceInvoiceList, {
                                                            prepayments: this.state.prepayments,
                                                            customers: this.props.customers,
                                                            invoices: this.props.invoices,
                                                            openDocumentSearchDialog: this.canBeSavedAsFinal() ? this.openDocumentSearchDialog : null,
                                                            removePrepayment: this.canBeSavedAsFinal() ? this.removePrepayment : null
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                        id: "user-history",
                                                        title: "Spremembe",
                                                        panelClassName: "flex-grow h-full",
                                                        panel: this.state.user_history === null ? 'nalagam' : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "user-history-list overflow-y-auto h-full",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "user-history-list-table",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "user-history-list-table-header-col col-1",
                                                                            children: "Datum in \u010Das"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "user-history-list-table-header-col col-2",
                                                                            children: "Uporabnik"
                                                                        })
                                                                    ]
                                                                }),
                                                                this.state.user_history.map((x)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "user-history-list-table",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "user-history-list-table-col col-1",
                                                                                children: (0, _momentDefault.default)(x.created).format('DD. MM. YYYY HH:mm:ss')
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "user-history-list-table-col col-2",
                                                                                children: this.props.users_by_username[x.username].name
                                                                            })
                                                                        ]
                                                                    }, x))
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-list-wrapper flex-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "items-list-scroll-container",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "items-list",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ItemsList, {
                                                read_only: this.state.read_only,
                                                invoice_type: this.state.invoice_type,
                                                invoice_items: this.state.invoice_items,
                                                items: this.props.items,
                                                tax_rates: this.props.tax_rates,
                                                invoice_date: this.state.invoice_date,
                                                measuring_units: this.props.measuring_units,
                                                setInvoiceItems: (invoice_items)=>{
                                                    this.setState({
                                                        invoice_items
                                                    });
                                                }
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "items-summary font-semibold text-base",
                                    children: [
                                        this.state.invoice_type != 'prepayment-invoice' && this.state.invoice_type != 'cash-prepayment-invoice' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-4 pt-1",
                                                    children: "Predpla\u010Dilo:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "col-5 flex flex-row items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "w-16",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                                intent: this.state.advance_payment_percent !== null ? 'success' : null,
                                                                value: (()=>{
                                                                    if (this.state.advance_payment_percent !== null) return this.state.advance_payment_percent_formatted;
                                                                    let val = 0;
                                                                    const sum = this.calculateInvoiceSum(false);
                                                                    if (sum != 0) val = this.state.advance_payment_value / sum * 100;
                                                                    val = this.formatNumber(val);
                                                                    return val;
                                                                })(),
                                                                onChange: (event)=>{
                                                                    let val = (0, _numbers.parseFloatLocal)(event.target.value);
                                                                    if (Object.is(val, NaN)) val = this.state.advance_payment_percent;
                                                                    let source_val = event.target.value;
                                                                    if (val < 0) {
                                                                        val = 0;
                                                                        source_val = 0;
                                                                    } else if (val > 100) {
                                                                        val = 100;
                                                                        source_val = 100;
                                                                    }
                                                                    this.changeAdvancePaymentValue('advance_payment_percent', val, source_val);
                                                                },
                                                                onBlur: (event)=>this.changeAdvancePaymentValue('refresh')
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "pl-1 pr-3 text-right",
                                                            children: "%"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "flex-1",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                                className: "text-right",
                                                                intent: this.state.advance_payment_value !== null ? 'success' : null,
                                                                value: (()=>{
                                                                    if (this.state.advance_payment_value !== null) return this.state.advance_payment_value_formatted;
                                                                    const sum = this.calculateInvoiceSum(false);
                                                                    let val = sum * (this.state.advance_payment_percent / 100);
                                                                    val = this.formatNumber(val);
                                                                    return val;
                                                                })(),
                                                                onChange: (event)=>{
                                                                    let val = (0, _numbers.parseFloatLocal)(event.target.value);
                                                                    if (Object.is(val, NaN)) val = this.state.advance_payment_value;
                                                                    this.changeAdvancePaymentValue('advance_payment_value', val, event.target.value);
                                                                },
                                                                onBlur: (event)=>this.changeAdvancePaymentValue('refresh')
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-1 pb-1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-2 pb-1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-3 pb-1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-4 pb-1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-5 pb-1"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-1 font-normal",
                                            children: invoice_fiscal_verification === undefined || invoice_fiscal_verification === null ? null : 'EOR:'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-2 font-normal select-text",
                                            children: invoice_fiscal_verification === undefined || invoice_fiscal_verification === null ? null : invoice_fiscal_verification.eor
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-4",
                                            children: this.state.invoice_type == 'credit-note' || this.state.reverse_invoice ? "Skupaj za vra\u010Dilo:" : "Znesek za pla\u010Dilo:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-5 text-right select-text",
                                            children: this.formatNumber(this.calculateInvoiceSum(false))
                                        }),
                                        this.state.invoice_type == 'offer' || this.state.invoice_type == 'credit-note' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-1 font-normal",
                                                    children: invoice_fiscal_verification === undefined || invoice_fiscal_verification === null ? null : 'ZOI:'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-2 font-normal select-text",
                                                    children: invoice_fiscal_verification === undefined || invoice_fiscal_verification === null ? null : invoice_fiscal_verification.signed_zoi
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-4",
                                                    children: this.state.reverse_invoice ? 'Storniran avans:' : "Pla\u010Dano z avansom:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-5 text-right select-text",
                                                    children: this.formatNumber(this.state.advance_payment_value !== null ? this.state.advance_payment_value * -1 : this.calculateInvoiceSum(false) * (this.state.advance_payment_percent / 100) * -1)
                                                })
                                            ]
                                        }),
                                        this.state.invoice_type == 'offer' || this.state.invoice_type == 'credit-note' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-1 font-normal",
                                                    children: invoice_fiscal_verification === undefined || invoice_fiscal_verification === null ? null : 'Stanje:'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-2 font-normal select-text",
                                                    children: invoice_fiscal_verification === undefined || invoice_fiscal_verification === null ? null : invoice_fiscal_verification.status === null ? "po\u0161iljanje v teku" : (()=>{
                                                        let verified = JSON.parse(invoice_fiscal_verification.response)?.InvoiceResponse?.Header?.DateTime;
                                                        let verified_date = verified === undefined ? 'neznano' : this.toLocalStringWithTime(new Date(verified));
                                                        return invoice_fiscal_verification.status === true ? 'poslano in potrjeno (' + verified_date + ')' : 'poslano in nepotrjeno (' + verified_date + ')';
                                                    })()
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-4",
                                                    children: this.state.reverse_invoice ? "Ostane za vra\u010Dilo:" : "Ostane za pla\u010Dilo:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col-5 text-right select-text",
                                                    children: this.formatNumber(this.calculateRemainingAmount())
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
EditInvoiceDialog.propTypes = {
    closeEditInvoiceDialog: (0, _propTypesDefault.default).func
};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        payment_types: state.CodeTablesSlice.payment_types,
        items: state.CodeTablesSlice.items,
        countries: state.CodeTablesSlice.countries,
        tax_rates: state.CodeTablesSlice.tax_rates,
        measuring_units: state.CodeTablesSlice.measuring_units,
        api_url: state.CodeTablesSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        users_by_username: state.UserSlice.users_by_username,
        settings: state.SettingsSlice,
        document_types: state.DocumentSlice.document_types,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        invoice_fiscal_verifications: state.BusinessSlice.invoice_fiscal_verifications,
        invoices: state.BusinessSlice.invoices,
        advance_invoice_consumptions: state.BusinessSlice.advance_invoice_consumptions,
        id_advance_invoice_consumption_by_id_consumer_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_consumer_invoices,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        cash_registers: state.CashRegisterSlice.cash_registers,
        warehouses: state.CodeTablesSlice.warehouses
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(EditInvoiceDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","uuid":"b52pV","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","@blueprintjs/select":"3IMc6","moment":"1e4qG","date-fns/formatISO":"an1FA","../TextWithTooltip":"6kuHH","../CustomerSelect":"8sizu","../reservations/SelectCustomerDialog":"ewc5P","./SelectPriceListDialog":"kwhOs","../../numbers":"jOh9w","../Documents":"jYQ4x","../../helpers/InvoiceCreator":"d7VsE","../../helpers/PriceHelper":"91cdD","./SplitPaymentDialog":"iymP9","../PrepaymentDocumentSearchDialog":"ct2Zf","./CustomerInfo":"aE2R5","../AppToaster":"izixN","../../helpers/Invoice":"jffQW","../../utils":"kh8Vf","../../api/Business":"fC7Hd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kwhOs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
class SelectPriceListDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_item_price_list: this.props.item.id_item_price_list
        };
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    render() {
        const self = this;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>{
                this.props.closeSelectPriceListDialog(-1);
            },
            className: "select-price-list-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Izberite cenik"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>{
                                        this.props.closeSelectPriceListDialog(-1);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.RadioGroup), {
                                    label: "",
                                    onChange: (event)=>{
                                        this.setState({
                                            id_item_price_list: event.target.value
                                        });
                                    },
                                    selectedValue: this.state.id_item_price_list,
                                    children: Object.values(this.props.priceListItems).sort((a, b)=>{
                                        if (a.valid_from === null && b.valid_from === null) return 0;
                                        if (a.valid_from === null) return 1;
                                        if (b.valid_from === null) return -1;
                                        if (a.valid_from < b.valid_from) return 1;
                                        else if (a.valid_from > b.valid_from) return -1;
                                        return 0;
                                    }).map(function(item) {
                                        let title = '';
                                        if (item.valid_from !== null && item.valid_until !== null) title = (0, _momentDefault.default)(item.valid_from).format('DD. MM. YYYY') + " \u2022 " + (0, _momentDefault.default)(item.valid_until).format('DD. MM. YYYY');
                                        else if (item.valid_from !== null) title = (0, _momentDefault.default)(item.valid_from).format('DD. MM. YYYY');
                                        else if (item.valid_until !== null) title = (0, _momentDefault.default)(item.valid_until).format('DD. MM. YYYY');
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                            value: item.id_item_price_list,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "inline-flex flex-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "w-48",
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "w-20 text-right",
                                                        children: self.formatNumber(self.props.priceListItems[item.id_item_price_list].price) + ' EUR'
                                                    })
                                                ]
                                            })
                                        }, item.id_item_price_list);
                                    })
                                }),
                                null,
                                null
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>{
                                        this.props.closeSelectPriceListDialog(-1);
                                    },
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeSelectPriceListDialog(this.state.id_item_price_list);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
SelectPriceListDialog.propTypes = {
    closeSelectPriceListDialog: (0, _propTypesDefault.default).func,
    priceListItems: (0, _propTypesDefault.default).object,
    item: (0, _propTypesDefault.default).object
};
exports.default = SelectPriceListDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jOh9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseFloatLocal", ()=>parseFloatLocal);
parcelHelpers.export(exports, "toLocal", ()=>toLocal);
const parseDecimalNumber = require("b868ed212b634f0");
function parseFloatLocal(val) {
    /*let language;
	if (window.navigator.languages) {
		language = window.navigator.languages[0];
	}
	else {
		language = window.navigator.userLanguage || window.navigator.language;
	}*/ return parseDecimalNumber(val, 10000.0.toLocaleString(undefined, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    }).replace(/[0-1]/g, ''));
}
function toLocal(val, decimals) {
    return val.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
}

},{"b868ed212b634f0":"cfa0n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cfa0n":[function(require,module,exports,__globalThis) {
(function() {
    var options, parseDecimalNumber, patterns;
    patterns = [];
    options = {};
    module.exports = parseDecimalNumber = function(value, inOptions, enforceGroupSize) {
        var decimal, fractionPart, groupMinSize, integerPart, number, pattern, patternIndex, result, thousands;
        if (enforceGroupSize == null) enforceGroupSize = true;
        if (typeof inOptions === 'string') {
            if (inOptions.length !== 2) throw {
                name: 'ArgumentException',
                message: 'The format for string options is \'<thousands><decimal>\' (exactly two characters)'
            };
            thousands = inOptions[0], decimal = inOptions[1];
        } else if (Array.isArray(inOptions)) {
            if (inOptions.length !== 2) throw {
                name: 'ArgumentException',
                message: 'The format for array options is [\'<thousands>\',\'[<decimal>\'] (exactly two elements)'
            };
            thousands = inOptions[0], decimal = inOptions[1];
        } else {
            thousands = (inOptions != null ? inOptions.thousands : void 0) || (inOptions != null ? inOptions.group : void 0) || options.thousands;
            decimal = (inOptions != null ? inOptions.decimal : void 0) || options.decimal;
        }
        patternIndex = "" + thousands + decimal + enforceGroupSize;
        pattern = patterns[patternIndex];
        if (pattern == null) {
            groupMinSize = enforceGroupSize ? 3 : 1;
            pattern = patterns[patternIndex] = new RegExp("^\\s*([+\-]?(?:(?:\\d{1,3}(?:\\" + thousands + "\\d{" + groupMinSize + ",3})+)|\\d*))(?:\\" + decimal + "(\\d*))?\\s*$");
        }
        result = value.match(pattern);
        if (!(result != null && result.length === 3)) return 0 / 0;
        integerPart = result[1].replace(new RegExp("\\" + thousands, 'g'), '');
        fractionPart = result[2];
        number = parseFloat(integerPart + "." + fractionPart);
        return number;
    };
    module.exports.setOptions = function(newOptions) {
        var key, value;
        for(key in newOptions){
            value = newOptions[key];
            options[key] = value;
        }
    };
    module.exports.factoryReset = function() {
        options = {
            thousands: ',',
            decimal: '.'
        };
    };
    module.exports.withOptions = function(options, enforceGroupSize) {
        if (enforceGroupSize == null) enforceGroupSize = true;
        return function(value) {
            return parseDecimalNumber(value, options, enforceGroupSize);
        };
    };
    module.exports.factoryReset();
}).call(this);

},{}],"jYQ4x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _businessSlice = require("../slices/BusinessSlice");
var _business = require("../api/Business");
var _documents = require("../api/Documents");
var _documentSlice = require("../slices/DocumentSlice");
var _editInvoiceDialog = require("./business/EditInvoiceDialog");
var _editInvoiceDialogDefault = parcelHelpers.interopDefault(_editInvoiceDialog);
var _waitFiscalVerificationDialog = require("./business/WaitFiscalVerificationDialog");
var _waitFiscalVerificationDialogDefault = parcelHelpers.interopDefault(_waitFiscalVerificationDialog);
var _reservation = require("./reservations/Reservation");
var _reservationDefault = parcelHelpers.interopDefault(_reservation);
var _invoiceCreator = require("../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _documentsHelper = require("../helpers/DocumentsHelper");
var _documentsHelperDefault = parcelHelpers.interopDefault(_documentsHelper);
var _documentSearchDialog = require("./DocumentSearchDialog");
var _documentSearchDialogDefault = parcelHelpers.interopDefault(_documentSearchDialog);
var _invoice = require("../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _appSlice = require("../slices/AppSlice");
class Documents extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.openEditInvoiceDialog = this.openEditInvoiceDialog.bind(this);
        this.closeEditInvoiceDialog = this.closeEditInvoiceDialog.bind(this);
        this.createInvoiceFromOriginal = this.createInvoiceFromOriginal.bind(this);
        this.openReservationDialog = this.openReservationDialog.bind(this);
        this.closeReservationDialog = this.closeReservationDialog.bind(this);
        this.openDocumentSearchDialog = this.openDocumentSearchDialog.bind(this);
        this.closeDocumentSearchDialog = this.closeDocumentSearchDialog.bind(this);
        this.addAndSaveDocumentAssociation = this.addAndSaveDocumentAssociation.bind(this);
        this.deleteAndSaveDocumentAssociation = this.deleteAndSaveDocumentAssociation.bind(this);
        this.state = {
            invoice_dialog_open: false,
            invoice_dialog_item: null,
            invoice_dialog_type: '',
            invoice_dialog_advance_invoices_amounts: {},
            reservation_dialog_open: false,
            reservation_dialog_item: null,
            document_search_dialog_open: false,
            wait_fiscal_verification_dialog_open: false,
            wait_fiscal_verification_dialog_id_invoice: null,
            confirm_remove_dialog_open: false,
            confirm_remove_dialog_id: -1
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    openEditInvoiceDialog(type, item, advance_invoices_amounts) {
        advance_invoices_amounts = advance_invoices_amounts || {};
        this.setState({
            invoice_dialog_open: true,
            invoice_dialog_type: type,
            invoice_dialog_item: item,
            invoice_dialog_advance_invoices_amounts: advance_invoices_amounts
        });
    }
    async closeEditInvoiceDialog(item, open_create_invoice_type, finish_invoice) {
        this.setState({
            invoice_dialog_open: false,
            invoice_dialog_item: null
        });
        if (item !== undefined) {
            this.props.dispatch((0, _businessSlice.addInvoice)({
                item,
                token: this.props.token
            }));
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            const new_items = await (0, _business.saveInvoice)(this.props.api_url, item, token, dispatch);
            if (new_items !== null) {
                if (new_items.invoices !== undefined) dispatch((0, _businessSlice.addInvoices)(new_items.invoices));
                if (new_items.document_associations !== undefined) dispatch((0, _documentSlice.addDocumentAssociations)(new_items.document_associations));
                if (new_items.advance_invoice_consumptions !== undefined) dispatch((0, _businessSlice.addAdvanceInvoiceConsumptions)(new_items.advance_invoice_consumptions));
                if (finish_invoice && this.props.document_types[item.invoice_type].fiscal_verification_enabled) this.setState({
                    wait_fiscal_verification_dialog_open: true,
                    wait_fiscal_verification_dialog_id_invoice: item.id_invoice
                });
            }
            if (open_create_invoice_type !== undefined) setTimeout(()=>{
                if (!this._ismounted) return;
                this.createInvoiceFromOriginal(item.id_invoice, open_create_invoice_type, [
                    item.id_invoice
                ]);
            }, 1000);
        }
    }
    createInvoiceFromOriginal(ids, invoice_type, advance_id_invoices) {
        ids = ids === null ? [] : Array.isArray(ids) ? ids : [
            ids
        ];
        advance_id_invoices = advance_id_invoices || [];
        let first_item = ids.length == 0 ? null : this.props.invoices[ids[0]];
        const amount_factor = invoice_type == 'credit-note' ? -1 : 1;
        const original_id_invoices = [];
        const original_invoice_types = [];
        const selected_advance_invoices_amounts = {};
        let advance_payment_amount = 0;
        let invoice_amount = 0;
        let items = [];
        let payments = [];
        for(let i = 0; i < advance_id_invoices.length; i++){
            const item = this.props.invoices[advance_id_invoices[i]];
            const advance_amount = Math.max(0, parseFloat(item.advance_payment_amount) - parseFloat(item.used_advance_payment_amount));
            advance_payment_amount += advance_amount;
            if (advance_amount > 0) selected_advance_invoices_amounts[item.id_invoice] = advance_amount;
        }
        for(let i = 0; i < ids.length; i++){
            const item = this.props.invoices[ids[i]];
            if (original_id_invoices.indexOf(ids[i]) == -1) {
                original_id_invoices.push(ids[i]);
                original_invoice_types.push(item.invoice_type);
            }
            invoice_amount += item.invoice_amount * amount_factor;
            items = [
                ...items,
                ...item.items.map((item_item)=>{
                    return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                        id_invoice_item: (0, _uuidDefault.default).v4(),
                        description: item_item.description,
                        discount: item_item.discount,
                        id_item: item_item.id_item,
                        id_item_price_list: item_item.id_item_price_list,
                        id_tax_rate: item_item.id_tax_rate,
                        item_measuring_unit_code: item_item.item_measuring_unit_code,
                        item_measuring_unit_decimal_digit_count: item_item.item_measuring_unit_decimal_digit_count,
                        price: item_item.price,
                        quantity: item_item.quantity * amount_factor,
                        tax_rate: item_item.tax_rate,
                        approved_percent: item_item.approved_percent,
                        item_type: item_item.item_type,
                        item_ean: item_item.item_ean,
                        item_title: item_item.item_title,
                        ord: item_item.ord,
                        taxable: item_item.taxable,
                        item_internal_code: item_item.item_internal_code,
                        id_warehouse: item_item.item_type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === null ? null : this.props.cash_registers[this.props.current_id_cash_register], this.props.warehouses)
                    });
                })
            ];
            payments = [
                ...payments
            ];
        }
        // create new document
        let payment_date = null;
        let invoice_date = null;
        let service_date_end = null;
        let service_date_start = null;
        if (first_item !== null) {
            payment_date = first_item.payment_date;
            invoice_date = first_item.invoice_date;
            service_date_end = first_item.service_date_end;
            service_date_start = first_item.service_date_start;
            if (invoice_type == 'credit-note' || invoice_type == 'prepayment-invoice' || invoice_type == 'cash-prepayment-invoice') {
                payment_date = new Date();
                invoice_date = new Date();
            } else if (invoice_type == 'invoice') {
                payment_date = null;
                invoice_date = new Date();
                service_date_end = new Date();
                service_date_start = new Date();
            }
        }
        const new_item = (0, _invoiceCreatorDefault.default).CreateInvoiceFromInitialData({
            id_invoice: (0, _uuidDefault.default).v4(),
            id_customer: first_item === null ? null : first_item.id_customer,
            invoice_date,
            invoice_type,
            note: '',
            payment_date,
            reference: first_item === null ? null : first_item.invoice_number_internal,
            reservation: first_item === null ? null : first_item.reservation,
            service_date_end,
            service_date_start,
            invoice_amount,
            id_cash_register: this.props.current_id_cash_register,
            advance_payment_amount,
            items,
            payments,
            original_id_invoice: original_id_invoices,
            original_invoice_type: original_invoice_types
        });
        this.openEditInvoiceDialog(new_item.invoice_type, new_item, selected_advance_invoices_amounts);
    }
    openReservationDialog(item) {
        this.setState({
            reservation_dialog_open: true,
            reservation_dialog_item: item
        });
    }
    closeReservationDialog() {
        this.setState({
            reservation_dialog_open: false,
            reservation_dialog_item: null
        });
    }
    openDocumentSearchDialog() {
        this.setState({
            document_search_dialog_open: true
        });
    }
    closeDocumentSearchDialog(id_document, document_type) {
        this.setState({
            document_search_dialog_open: false
        });
        if (id_document !== undefined && document_type !== undefined) {
            this.addAndSaveDocumentAssociation(this.props.id_document, this.props.document_type, id_document, document_type);
            if (this.props.document_type == 'reservation-customer' && document_type != 'reservation') this.addAndSaveDocumentAssociation(this.props.reservation_customers[this.props.id_document].id_reservation, 'reservation', id_document, document_type);
        }
    }
    async addAndSaveDocumentAssociation(source_id_document, source_type, target_id_document, target_type) {
        const item = {
            id_document_association: (0, _uuidDefault.default).v4(),
            source_id_document,
            source_type,
            target_id_document,
            target_type
        };
        this.props.dispatch((0, _documentSlice.addDocumentAssociation)({
            item,
            token: this.props.token
        }));
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        const new_item = await (0, _documents.saveDocumentAssociation)(this.props.api_url, item, token);
        if (new_item !== null) dispatch((0, _documentSlice.addDocumentAssociation)({
            item: new_item,
            token
        }));
    }
    async deleteAndSaveDocumentAssociation(id_document_association) {
        await (0, _documents.deleteDocumentAssociation)(this.props.api_url, id_document_association, this.props.token);
        this.props.dispatch((0, _documentSlice.deleteDocumentAssociation)({
            id_document_association
        }));
    }
    render() {
        let documents = Object.values((0, _documentsHelperDefault.default).GetDocuments(this.props.document_associations, this.props.id_document, this.props.deep ? 3 : 1));
        // remove duplicates
        const document_ids = [];
        documents = documents.filter((document)=>{
            if (document_ids.indexOf(document.id_document) > -1) return false;
            if (document.document_type != 'reservation' && this.props.document_types !== undefined && this.props.document_types[document.document_type] === undefined) return false;
            document_ids.push(document.id_document);
            return true;
        });
        const find_idx_by_id_document = (documents, id_document)=>{
            for(let i = 0; i < documents.length; i++){
                if (documents[i].id_document == id_document) return i;
            }
            return -1;
        };
        (this.props.id_advance_invoice_consumption_by_id_advance_invoices[this.props.id_document] || []).forEach((id)=>{
            const advance_invoice_consumption = this.props.advance_invoice_consumptions[id];
            if (advance_invoice_consumption !== undefined) {
                const id_document = advance_invoice_consumption.consumer_id_invoice;
                const from_id_document = advance_invoice_consumption.advance_id_invoice;
                const idx = find_idx_by_id_document(documents, id_document);
                if (idx > -1) documents.splice(idx, 1);
                documents.push({
                    created: advance_invoice_consumption.created,
                    document_type: 'advance-invoice-consumption',
                    id_document,
                    from_id_document
                });
            }
        });
        (this.props.id_advance_invoice_consumption_by_id_consumer_invoices[this.props.id_document] || []).forEach((id)=>{
            const advance_invoice_consumption = this.props.advance_invoice_consumptions[id];
            if (advance_invoice_consumption !== undefined) {
                const id_document = advance_invoice_consumption.advance_id_invoice;
                const from_id_document = advance_invoice_consumption.consumer_id_invoice;
                const idx = find_idx_by_id_document(documents, id_document);
                if (idx > -1) documents.splice(idx, 1);
                documents.push({
                    created: advance_invoice_consumption.created,
                    document_type: 'advance-invoice-consumption',
                    id_document,
                    from_id_document
                });
            }
        });
        documents.sort((a, b)=>{
            if (a.created < b.created) return 1;
            if (a.created > b.created) return -1;
            return 0;
        });
        const hide_customer = this.props.hide_customer !== undefined && this.props.hide_customer === true;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "documents-list overflow-y-auto h-full",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Nadaljuj",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "warning-sign",
                    intent: (0, _core.Intent).WARNING,
                    isOpen: this.state.confirm_remove_dialog_open,
                    onConfirm: ()=>{
                        this.deleteAndSaveDocumentAssociation(this.state.confirm_remove_dialog_id);
                        this.setState({
                            confirm_remove_dialog_open: false,
                            confirm_remove_dialog_id: -1
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            confirm_remove_dialog_open: false,
                            confirm_remove_dialog_id: -1
                        });
                    },
                    children: "Res \u017Eelite odstraniti povezavo na ta dokument?"
                }),
                !this.state.invoice_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editInvoiceDialogDefault.default), {
                    closeEditInvoiceDialog: this.closeEditInvoiceDialog,
                    item: this.state.invoice_dialog_item,
                    type: this.state.invoice_dialog_type,
                    selected_advance_invoices_amounts: this.state.invoice_dialog_advance_invoices_amounts
                }),
                !this.state.reservation_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reservationDefault.default), {
                    closeReservation: this.closeReservationDialog,
                    deleteReservation: null,
                    reservation: this.state.reservation_dialog_item
                }),
                !this.state.document_search_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentSearchDialogDefault.default), {
                    closeDialog: this.closeDocumentSearchDialog
                }),
                !this.state.wait_fiscal_verification_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _waitFiscalVerificationDialogDefault.default), {
                    closeWaitFiscalVerificationDialog: (print)=>{
                        this.setState({
                            wait_fiscal_verification_dialog_open: false
                        });
                        if (print) {
                            const invoice = this.props.invoices[this.state.wait_fiscal_verification_dialog_id_invoice];
                            if (this.props.general_settings.auto_print_type == 'a4') this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                                type: 'invoice',
                                lang: 'sl',
                                invoice
                            }));
                            else if (this.props.general_settings.auto_print_type == 'pos') this.props.dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                                type: 'invoice',
                                invoice
                            }));
                        }
                    },
                    id_invoice: this.state.wait_fiscal_verification_dialog_id_invoice
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: 'documents-table floating-header ' + (hide_customer ? 'hide-customer' : ''),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "documents-table-header-col col-1",
                            children: "Datum"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "documents-table-header-col col-2",
                            children: "\u0160t. dokumenta"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "documents-table-header-col col-3",
                            children: "Tip"
                        }),
                        hide_customer ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "documents-table-header-col col-4",
                            children: "Stranka"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "documents-table-header-col col-5",
                            children: "Znesek"
                        }),
                        this.props.document_type === undefined || this.props.document_type === null || this.props.document_type.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            small: true,
                            minimal: true,
                            intent: "primary",
                            className: "add-document-button",
                            onClick: this.openDocumentSearchDialog,
                            icon: "add"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: 'documents-table ' + (hide_customer ? 'hide-customer' : ''),
                    children: documents.map((item)=>{
                        let id_document = item.id_document;
                        let document_type = item.document_type;
                        const is_direct = item.from_document == this.props.id_document;
                        if (document_type == 'advance-invoice-consumption') {
                            const invoice = this.props.invoices[id_document];
                            if (invoice !== undefined) document_type = invoice.invoice_type;
                        }
                        let document_date = null;
                        let document_document_number = null;
                        let document_click_handler = null;
                        let document_type_title = document_type;
                        let document_customer = null;
                        let document_amount = null;
                        if (document_type == 'cash-invoice' || document_type == 'invoice' || document_type == 'offer' || document_type == 'prepayment-invoice' || document_type == 'credit-note') {
                            const invoice_item = this.props.invoices[id_document];
                            if (invoice_item !== undefined) {
                                document_date = invoice_item.invoice_date;
                                document_document_number = invoice_item.invoice_number_internal;
                                document_amount = invoice_item.invoice_amount;
                                document_type_title = "ra\u010Dun";
                                switch(document_type){
                                    case 'cash-invoice':
                                        document_type_title = "blagajni\u0161ki ra\u010Dun";
                                        break;
                                    case 'offer':
                                        document_type_title = 'ponudba';
                                        break;
                                    case 'credit-note':
                                        document_type_title = 'dobropis';
                                        break;
                                    case 'prepayment-invoice':
                                        document_type_title = "avansni ra\u010Dun";
                                        document_amount = invoice_item.advance_payment_amount;
                                        break;
                                }
                                document_customer = invoice_item.id_customer === null ? null : this.props.customers[invoice_item.id_customer];
                                const self = this;
                                document_click_handler = ()=>{
                                    self.openEditInvoiceDialog(invoice_item.invoice_type, invoice_item);
                                };
                            }
                        } else if (document_type == 'reservation') {
                            const reservation_item = this.props.reservations[id_document];
                            if (reservation_item !== undefined) {
                                document_date = reservation_item.check_in;
                                document_document_number = reservation_item.internal_code;
                                document_type_title = 'rezervacija';
                                document_amount = null;
                                document_customer = reservation_item.id_customer === null ? null : this.props.customers[reservation_item.id_customer];
                                const self = this;
                                document_click_handler = ()=>{
                                    self.openReservationDialog(reservation_item);
                                };
                            }
                        } else if (document_type == 'activity-reservation') {
                            const reservation_item = this.props.activity_reservations[id_document];
                            if (reservation_item !== undefined) {
                                document_date = reservation_item.reservation_date;
                                document_document_number = reservation_item.internal_code;
                                document_type_title = 'rezervacija akt.';
                                document_amount = null;
                                document_customer = reservation_item.id_customer === null ? null : this.props.customers[reservation_item.id_customer];
                            /*document_click_handler = () => {
								self.openReservationDialog(reservation_item);
							};*/ }
                        } else if (document_type == 'delivery-note') {
                            const delivery_note_item = this.props.delivery_notes[id_document];
                            if (delivery_note_item !== undefined) {
                                document_date = delivery_note_item.document_date;
                                document_document_number = delivery_note_item.document_number;
                                document_type_title = 'dobavnica';
                                document_amount = null;
                                document_customer = delivery_note_item.id_customer === null ? null : this.props.customers[delivery_note_item.id_customer];
                                const self = this;
                            //document_click_handler = () => {
                            //	self.openReservationDialog(delivery_noteitem);
                            //};
                            }
                        } else return null;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "documents-table-col col-1",
                                    children: [
                                        !is_direct ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            small: true,
                                            minimal: true,
                                            className: "cell-button",
                                            onClick: ()=>{
                                                this.setState({
                                                    confirm_remove_dialog_open: true,
                                                    confirm_remove_dialog_id: item.id_document_association
                                                });
                                            },
                                            icon: "remove"
                                        }),
                                        document_date === null ? null : (0, _momentDefault.default)(document_date).format('DD.MM.YYYY')
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "documents-table-col col-2",
                                    children: document_click_handler === null ? document_document_number : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        small: true,
                                        className: 'cell-button',
                                        onClick: document_click_handler,
                                        children: document_document_number
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "documents-table-col col-3",
                                    children: document_type_title
                                }),
                                hide_customer ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "documents-table-col col-4",
                                    children: document_customer === null ? null : document_customer.type == 'natural' ? document_customer.surname + ' ' + document_customer.name : document_customer.company_name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "documents-table-col col-5 text-right",
                                    children: document_amount === null ? null : parseFloat(document_amount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }) + ' EUR'
                                })
                            ]
                        }, 'documents-' + (item.id_document_association || item.id_document));
                    })
                })
            ]
        });
    }
}
function mapStateToProps(state) {
    return {
        document_associations: state.DocumentSlice.document_associations_id_documents,
        invoices: state.BusinessSlice.invoices,
        advance_invoice_consumptions: state.BusinessSlice.advance_invoice_consumptions,
        id_advance_invoice_consumption_by_id_advance_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_advance_invoices,
        id_advance_invoice_consumption_by_id_consumer_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_consumer_invoices,
        customers: state.CodeTablesSlice.customers,
        reservations: state.ReservationSlice.reservations,
        reservation_customers_by_id_reservations: state.ReservationSlice.reservation_customers_by_id_reservations,
        reservation_customers: state.ReservationSlice.reservation_customers,
        activity_reservations: state.ReservationSlice.activity_reservations,
        api_url: state.CodeTablesSlice.api_url,
        token: state.UserSlice.token,
        document_types: state.DocumentSlice.document_types,
        general_settings: state.SettingsSlice.general,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        cash_registers: state.CashRegisterSlice.cash_registers,
        warehouses: state.CodeTablesSlice.warehouses,
        delivery_notes: state.WarehouseSlice.delivery_notes
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Documents);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","uuid":"b52pV","@blueprintjs/core":"6Mq52","moment":"1e4qG","../slices/BusinessSlice":"47JXm","../api/Business":"fC7Hd","../api/Documents":"hSEi5","../slices/DocumentSlice":"6gdAm","./business/EditInvoiceDialog":"kxL93","./business/WaitFiscalVerificationDialog":"bvSNl","./reservations/Reservation":"a8Yu8","../helpers/InvoiceCreator":"d7VsE","../helpers/DocumentsHelper":"ep63y","./DocumentSearchDialog":"5UvH1","../helpers/Invoice":"jffQW","../slices/AppSlice":"aByTQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fC7Hd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadInvoices", ()=>loadInvoices);
parcelHelpers.export(exports, "loadInvoice", ()=>loadInvoice);
parcelHelpers.export(exports, "loadInvoiceFiscalVerifications", ()=>loadInvoiceFiscalVerifications);
parcelHelpers.export(exports, "loadLatestInvoiceFiscalVerifications", ()=>loadLatestInvoiceFiscalVerifications);
parcelHelpers.export(exports, "loadInvoiceFiscalVerificationsByIds", ()=>loadInvoiceFiscalVerificationsByIds);
parcelHelpers.export(exports, "loadInvoiceFiscalVerification", ()=>loadInvoiceFiscalVerification);
parcelHelpers.export(exports, "saveInvoice", ()=>saveInvoice);
parcelHelpers.export(exports, "deleteInvoice", ()=>deleteInvoice);
parcelHelpers.export(exports, "loadAdvanceInvoiceConsumptions", ()=>loadAdvanceInvoiceConsumptions);
parcelHelpers.export(exports, "loadAdvanceInvoiceConsumption", ()=>loadAdvanceInvoiceConsumption);
parcelHelpers.export(exports, "fiscallyVerifyInvoices", ()=>fiscallyVerifyInvoices);
parcelHelpers.export(exports, "increaseInvoicePrintCount", ()=>increaseInvoicePrintCount);
parcelHelpers.export(exports, "loadInvoiceUserHistory", ()=>loadInvoiceUserHistory);
parcelHelpers.export(exports, "setAsPaid", ()=>setAsPaid);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _businessSlice = require("../slices/BusinessSlice");
var _userSlice = require("../slices/UserSlice");
var _appSlice = require("../slices/AppSlice");
var _errorReportingHelper = require("../helpers/ErrorReportingHelper");
var _errorReportingHelperDefault = parcelHelpers.interopDefault(_errorReportingHelper);
async function loadInvoices(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Invoices/v2/invoices', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _businessSlice.addInvoices)(items));
}
async function loadInvoice(api_url, id_invoice, dispatch, token) {
    let response = await fetch(api_url + 'Invoices/v1/invoice?id_invoice=' + id_invoice, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let item = await response.json();
    if (item.error_code !== undefined) {
        if (item.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _businessSlice.addInvoice)({
        item
    }));
    return item;
}
async function loadInvoiceFiscalVerifications(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Invoices/v2/invoice-fiscal-verifications', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _businessSlice.addInvoiceFiscalVerifications)(items));
}
async function loadLatestInvoiceFiscalVerifications(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Invoices/v2/latest-invoice-fiscal-verifications', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _businessSlice.addInvoiceFiscalVerifications)(items));
}
async function loadInvoiceFiscalVerificationsByIds(api_url, ids, dispatch, token) {
    const form_data = new FormData();
    form_data.set('ids', ids.join(','));
    let response = await fetch(api_url + 'Invoices/v2/invoice-fiscal-verifications-by-ids', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _businessSlice.addInvoiceFiscalVerifications)(items));
}
async function loadInvoiceFiscalVerification(api_url, id_invoice_fiscal_verification, dispatch, token) {
    let response = await fetch(api_url + 'Invoices/v1/invoice-fiscal-verification?id_invoice_fiscal_verification=' + id_invoice_fiscal_verification, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let item = await response.json();
    if (item.error_code !== undefined) {
        if (item.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _businessSlice.addInvoiceFiscalVerification)({
        item
    }));
    return item;
}
async function saveInvoice(api_url, item, token, dispatch) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let text_response = 'n/a';
    try {
        let response = await fetch(api_url + 'Invoices/v1/save-invoice', {
            method: 'post',
            body: form_data,
            headers: {
                'Authorization': 'Bearer ' + token,
                'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
            }
        });
        text_response = await response.text();
        let new_item = JSON.parse(text_response);
        if (new_item.error_code !== undefined) new_item.error_code;
        else //delete new_item.items;
        //delete new_item.payments;
        //dispatch(addInvoice(new_item));
        return new_item;
    } catch (e) {
        (0, _errorReportingHelperDefault.default).ReportError(e.message, {
            context: {
                method: 'api.Business.saveInvoice',
                item,
                server_response: text_response
            }
        });
        dispatch((0, _appSlice.setCriticalError)(JSON.stringify(e)));
    }
    return null;
}
async function deleteInvoice(api_url, id, token) {
    const form_data = new FormData();
    form_data.set('id_invoice', id);
    let response = await fetch(api_url + 'Invoices/v1/delete-invoice', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let data = await response.json();
    if (data.error_code !== undefined) data.error_code;
    else return {
        id_invoice_items: data.id_invoice_items,
        id_invoice_payments: data.id_invoice_payments,
        id_cash_register_document_invoices: data.id_cash_register_document_invoices,
        id_advance_invoice_consumptions: data.id_advance_invoice_consumptions,
        id_document_associations: data.id_document_associations,
        id_invoices: data.id_invoices
    };
    return null;
}
async function loadAdvanceInvoiceConsumptions(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Invoices/v1/advance-invoice-consumptions', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _businessSlice.addAdvanceInvoiceConsumptions)(items));
}
async function loadAdvanceInvoiceConsumption(api_url, id_advance_invoice_consumption, dispatch, token) {
    let response = await fetch(api_url + 'Invoices/v1/advance-invoice-consumption?id_advance_invoice_consumption=' + id_advance_invoice_consumption, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let item = await response.json();
    if (item.error_code !== undefined) {
        if (item.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _businessSlice.addAdvanceInvoiceConsumption)({
        item
    }));
}
async function fiscallyVerifyInvoices(api_url, id_invoices, token) {
    const form_data = new FormData();
    form_data.set('id_invoices', id_invoices.join(','));
    await fetch(api_url + 'Invoices/v1/fiscally-verify-invoices', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
}
async function increaseInvoicePrintCount(api_url, id_invoice, token) {
    const form_data = new FormData();
    form_data.set('id_invoice', id_invoice);
    await fetch(api_url + 'Invoices/v1/increase-invoice-print-count', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
}
async function loadInvoiceUserHistory(api_url, id_invoice, token) {
    let response = await fetch(api_url + 'Invoices/v2/invoice-user-history?id_invoice=' + id_invoice, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    return items;
}
async function setAsPaid(api_url, id_invoices, token, paid) {
    const form_data = new FormData();
    form_data.set('id_invoices', id_invoices.join(','));
    form_data.set('paid', paid ? 'true' : 'false');
    await fetch(api_url + 'Invoices/v2/set-as-paid', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
}

},{"js-cookie":"2d7Fe","../slices/BusinessSlice":"47JXm","../slices/UserSlice":"ikKoo","../slices/AppSlice":"aByTQ","../helpers/ErrorReportingHelper":"8d1th","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8d1th":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@honeybadger-io/react");
const ErrorReportingHelper = {
    ReportError: (message, context)=>{
        console.log('Error: ' + message, context);
        (0, _react.Honeybadger).notify('Error: ' + message, {
            name: 'Error',
            ...context || {}
        });
    },
    ReportWarning: (message, context)=>{
        console.log('Warning: ' + message, context);
        (0, _react.Honeybadger).notify('Warning: ' + message, context || {});
    },
    ReportInfo: (message, context)=>{
        console.log([
            'Info',
            message
        ], context);
        (0, _react.Honeybadger).notify(message, {
            name: 'Info',
            ...context || {}
        });
    },
    ReportPosPrintInfo: (message, context)=>{
        console.log([
            'ReportPosPrintInfo',
            message
        ], context);
        (0, _react.Honeybadger).notify(message, {
            name: 'ReportPosPrintInfo',
            ...context || {}
        });
    },
    ReportA4PrintInfo: (message, context)=>{
        console.log([
            'ReportA4PrintInfo',
            message
        ], context);
        (0, _react.Honeybadger).notify(message, {
            name: 'ReportA4PrintInfo',
            ...context || {}
        });
    }
};
exports.default = ErrorReportingHelper;

},{"@honeybadger-io/react":"jFoJ4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jFoJ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Honeybadger", ()=>(0, _jsDefault.default));
parcelHelpers.export(exports, "HoneybadgerErrorBoundary", ()=>HoneybadgerErrorBoundary);
var _js = require("@honeybadger-io/js");
var _jsDefault = parcelHelpers.interopDefault(_js);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
class DefaultErrorComponent extends (0, _react.Component) {
    render() {
        return (0, _jsxRuntime.jsxs)("div", {
            className: 'error',
            children: [
                (0, _jsxRuntime.jsx)("div", {
                    children: "An Error Occurred"
                }),
                (0, _jsxRuntime.jsx)("div", {
                    children: JSON.stringify(this.props.error, null, 2)
                }),
                (0, _jsxRuntime.jsx)("div", {
                    children: this.props.info ? JSON.stringify(this.props.info, null, 2) : ''
                })
            ]
        });
    }
}
DefaultErrorComponent.propTypes = {
    error: (0, _propTypesDefault.default).object,
    info: (0, _propTypesDefault.default).object
};
class HoneybadgerErrorBoundary extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            error: null,
            info: null,
            errorOccurred: false
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error,
            errorOccurred: true,
            info: null
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            errorOccurred: true,
            error: error,
            info: errorInfo
        });
        this.props.honeybadger.notify(error, {
            context: errorInfo
        });
    }
    getErrorComponent() {
        return this.props.ErrorComponent ? (0, _reactDefault.default).createElement(this.props.ErrorComponent, this.state) : (0, _jsxRuntime.jsx)(DefaultErrorComponent, {
            ...this.state
        });
    }
    render() {
        return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: this.state.errorOccurred ? this.getErrorComponent() : this.props.children
        });
    }
}
HoneybadgerErrorBoundary.propTypes = {
    honeybadger: (0, _propTypesDefault.default).object.isRequired,
    children: (0, _propTypesDefault.default).element,
    ErrorComponent: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).element,
        (0, _propTypesDefault.default).func
    ])
};

},{"@honeybadger-io/js":"8DzM6","react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8DzM6":[function(require,module,exports,__globalThis) {
var global = arguments[3];
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    function getAugmentedNamespace(n) {
        var f = n.default;
        if (typeof f == "function") {
            var a = function() {
                return f.apply(this, arguments);
            };
            a.prototype = f.prototype;
        } else a = {};
        Object.defineProperty(a, '__esModule', {
            value: true
        });
        Object.keys(n).forEach(function(k) {
            var d = Object.getOwnPropertyDescriptor(n, k);
            Object.defineProperty(a, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return n[k];
                }
            });
        });
        return a;
    }
    var browser$1 = {};
    var src = {};
    var client = {};
    var util$1 = {};
    var UNKNOWN_FUNCTION = '<unknown>';
    /**
	 * This parses the different stack traces and puts them into one format
	 * This borrows heavily from TraceKit (https://github.com/csnover/TraceKit)
	 */ function parse(stackString) {
        var lines = stackString.split('\n');
        return lines.reduce(function(stack, line) {
            var parseResult = parseChrome(line) || parseWinjs(line) || parseGecko(line) || parseNode(line) || parseJSC(line);
            if (parseResult) stack.push(parseResult);
            return stack;
        }, []);
    }
    var chromeRe = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/|[a-z]:\\|\\\\).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var chromeEvalRe = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    function parseChrome(line) {
        var parts = chromeRe.exec(line);
        if (!parts) return null;
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        var submatch = chromeEvalRe.exec(parts[2]);
        if (isEval && submatch != null) {
            // throw out eval line/column and use top-most line/column number
            parts[2] = submatch[1]; // url
            parts[3] = submatch[2]; // line
            parts[4] = submatch[3]; // column
        }
        return {
            file: !isNative ? parts[2] : null,
            methodName: parts[1] || UNKNOWN_FUNCTION,
            arguments: isNative ? [
                parts[2]
            ] : [],
            lineNumber: parts[3] ? +parts[3] : null,
            column: parts[4] ? +parts[4] : null
        };
    }
    var winjsRe = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    function parseWinjs(line) {
        var parts = winjsRe.exec(line);
        if (!parts) return null;
        return {
            file: parts[2],
            methodName: parts[1] || UNKNOWN_FUNCTION,
            arguments: [],
            lineNumber: +parts[3],
            column: parts[4] ? +parts[4] : null
        };
    }
    var geckoRe = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
    var geckoEvalRe = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    function parseGecko(line) {
        var parts = geckoRe.exec(line);
        if (!parts) return null;
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        var submatch = geckoEvalRe.exec(parts[3]);
        if (isEval && submatch != null) {
            // throw out eval line/column and use top-most line number
            parts[3] = submatch[1];
            parts[4] = submatch[2];
            parts[5] = null; // no column when eval
        }
        return {
            file: parts[3],
            methodName: parts[1] || UNKNOWN_FUNCTION,
            arguments: parts[2] ? parts[2].split(',') : [],
            lineNumber: parts[4] ? +parts[4] : null,
            column: parts[5] ? +parts[5] : null
        };
    }
    var javaScriptCoreRe = /^\s*(?:([^@]*)(?:\((.*?)\))?@)?(\S.*?):(\d+)(?::(\d+))?\s*$/i;
    function parseJSC(line) {
        var parts = javaScriptCoreRe.exec(line);
        if (!parts) return null;
        return {
            file: parts[3],
            methodName: parts[1] || UNKNOWN_FUNCTION,
            arguments: [],
            lineNumber: +parts[4],
            column: parts[5] ? +parts[5] : null
        };
    }
    var nodeRe = /^\s*at (?:((?:\[object object\])?[^\\/]+(?: \[as \S+\])?) )?\(?(.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    function parseNode(line) {
        var parts = nodeRe.exec(line);
        if (!parts) return null;
        return {
            file: parts[2],
            methodName: parts[1] || UNKNOWN_FUNCTION,
            arguments: [],
            lineNumber: +parts[3],
            column: parts[4] ? +parts[4] : null
        };
    }
    var stackTraceParser_esm = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        parse: parse
    });
    var require$$0 = /*@__PURE__*/ getAugmentedNamespace(stackTraceParser_esm);
    (function(exports) {
        var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
            if (k2 === undefined) k2 = k;
            var desc = Object.getOwnPropertyDescriptor(m, k);
            if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                enumerable: true,
                get: function() {
                    return m[k];
                }
            };
            Object.defineProperty(o, k2, desc);
        } : function(o, m, k, k2) {
            if (k2 === undefined) k2 = k;
            o[k2] = m[k];
        });
        var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
            Object.defineProperty(o, "default", {
                enumerable: true,
                value: v
            });
        } : function(o, v) {
            o["default"] = v;
        });
        var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(mod) {
            if (mod && mod.__esModule) return mod;
            var result = {};
            if (mod != null) {
                for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
            }
            __setModuleDefault(result, mod);
            return result;
        };
        var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P ? value : new P(function(resolve) {
                    resolve(value);
                });
            }
            return new (P || (P = Promise))(function(resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        };
        var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
            var _ = {
                label: 0,
                sent: function() {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: []
            }, f, y, t, g;
            return g = {
                next: verb(0),
                "throw": verb(1),
                "return": verb(2)
            }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                return this;
            }), g;
            function verb(n) {
                return function(v) {
                    return step([
                        n,
                        v
                    ]);
                };
            }
            function step(op) {
                if (f) throw new TypeError("Generator is already executing.");
                while(_)try {
                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                    if (y = 0, t) op = [
                        op[0] & 2,
                        t.value
                    ];
                    switch(op[0]){
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return {
                                value: op[1],
                                done: false
                            };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [
                                0
                            ];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [
                        6,
                        e
                    ];
                    y = 0;
                } finally{
                    f = t = 0;
                }
                if (op[0] & 5) throw op[1];
                return {
                    value: op[0] ? op[1] : void 0,
                    done: true
                };
            }
        };
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.isBrowserConfig = exports.clone = exports.formatCGIData = exports.filterUrl = exports.filter = exports.generateStackTrace = exports.endpoint = exports.instrument = exports.isErrorObject = exports.makeNotice = exports.logger = exports.sanitize = exports.shallowClone = exports.runAfterNotifyHandlers = exports.runBeforeNotifyHandlers = exports.getSourceForBacktrace = exports.getCauses = exports.calculateBacktraceShift = exports.DEFAULT_BACKTRACE_SHIFT = exports.makeBacktrace = exports.objectIsExtensible = exports.objectIsEmpty = exports.mergeNotice = exports.merge = void 0;
        var stackTraceParser = __importStar(require$$0);
        function merge(obj1, obj2) {
            var result = {};
            for(var k in obj1)result[k] = obj1[k];
            for(var k in obj2)result[k] = obj2[k];
            return result;
        }
        exports.merge = merge;
        function mergeNotice(notice1, notice2) {
            var result = merge(notice1, notice2);
            if (notice1.context && notice2.context) result.context = merge(notice1.context, notice2.context);
            return result;
        }
        exports.mergeNotice = mergeNotice;
        function objectIsEmpty(obj) {
            for(var k in obj){
                if (Object.prototype.hasOwnProperty.call(obj, k)) return false;
            }
            return true;
        }
        exports.objectIsEmpty = objectIsEmpty;
        function objectIsExtensible(obj) {
            if (typeof Object.isExtensible !== 'function') return true;
            return Object.isExtensible(obj);
        }
        exports.objectIsExtensible = objectIsExtensible;
        function makeBacktrace(stack, filterHbSourceCode, logger) {
            if (filterHbSourceCode === void 0) filterHbSourceCode = false;
            if (logger === void 0) logger = console;
            try {
                var backtrace = stackTraceParser.parse(stack).map(function(line) {
                    return {
                        file: line.file,
                        method: line.methodName,
                        number: line.lineNumber,
                        column: line.column
                    };
                });
                if (filterHbSourceCode) backtrace.splice(0, calculateBacktraceShift(backtrace));
                return backtrace;
            } catch (err) {
                logger.debug(err);
                return [];
            }
        }
        exports.makeBacktrace = makeBacktrace;
        function isFrameFromHbSourceCode(frame) {
            var hasHbFile = false;
            var hasHbMethod = false;
            if (frame.file) hasHbFile = frame.file.toLowerCase().indexOf('@honeybadger-io') > -1;
            if (frame.method) hasHbMethod = frame.method.toLowerCase().indexOf('@honeybadger-io') > -1;
            return hasHbFile || hasHbMethod;
        }
        exports.DEFAULT_BACKTRACE_SHIFT = 3;
        /**
		 * If {@link generateStackTrace} is used, we want to exclude frames that come from
		 * Honeybadger's source code.
		 *
		 * Logic:
		 * - For each frame, increment the shift if source code is from Honeybadger
		 * - If a frame from an <anonymous> file is encountered increment the shift ONLY if between Honeybadger source code
		 *   (i.e. previous and next frames are from Honeybadger)
		 * - Exit when frame encountered is not from Honeybadger source code
		 *
		 * Note: this will not always work, especially in browser versions where code
		 *       is minified, uglified and bundled.
		 *       For those cases we default to 3:
		 *       - generateStackTrace
		 *       - makeNotice
		 *       - notify
		 */ function calculateBacktraceShift(backtrace) {
            var shift = 0;
            for(var i = 0; i < backtrace.length; i++){
                var frame = backtrace[i];
                if (isFrameFromHbSourceCode(frame)) {
                    shift++;
                    continue;
                }
                if (!frame.file || frame.file === '<anonymous>') {
                    var nextFrame = backtrace[i + 1];
                    if (nextFrame && isFrameFromHbSourceCode(nextFrame)) {
                        shift++;
                        continue;
                    }
                }
                break;
            }
            return shift || exports.DEFAULT_BACKTRACE_SHIFT;
        }
        exports.calculateBacktraceShift = calculateBacktraceShift;
        function getCauses(notice, logger) {
            if (notice.cause) {
                var causes = [];
                var cause = notice;
                while(causes.length < 3 && (cause = cause.cause))causes.push({
                    class: cause.name,
                    message: cause.message,
                    backtrace: typeof cause.stack == 'string' ? makeBacktrace(cause.stack, false, logger) : null
                });
                return causes;
            }
            return [];
        }
        exports.getCauses = getCauses;
        function getSourceForBacktrace(backtrace, getSourceFileHandler) {
            return __awaiter(this, void 0, void 0, function() {
                var result, index, trace, fileContent;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            result = [];
                            if (!getSourceFileHandler || !backtrace || !backtrace.length) return [
                                2 /*return*/ ,
                                result
                            ];
                            index = 0;
                            _a.label = 1;
                        case 1:
                            if (!backtrace.length) return [
                                3 /*break*/ ,
                                3
                            ];
                            trace = backtrace.splice(0)[index];
                            return [
                                4 /*yield*/ ,
                                getSourceFileHandler(trace.file)
                            ];
                        case 2:
                            fileContent = _a.sent();
                            result[index] = getSourceCodeSnippet(fileContent, trace.number);
                            index++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                result
                            ];
                    }
                });
            });
        }
        exports.getSourceForBacktrace = getSourceForBacktrace;
        function runBeforeNotifyHandlers(notice, handlers) {
            var result = true;
            for(var i = 0, len = handlers.length; i < len; i++){
                var handler = handlers[i];
                if (handler(notice) === false) result = false;
            }
            return result;
        }
        exports.runBeforeNotifyHandlers = runBeforeNotifyHandlers;
        function runAfterNotifyHandlers(notice, handlers, error) {
            if (notice && notice.afterNotify) notice.afterNotify(error, notice);
            for(var i = 0, len = handlers.length; i < len; i++)handlers[i](error, notice);
            return true;
        }
        exports.runAfterNotifyHandlers = runAfterNotifyHandlers;
        // Returns a new object with properties from other object.
        function shallowClone(obj) {
            if (typeof obj !== 'object' || obj === null) return {};
            var result = {};
            for(var k in obj)result[k] = obj[k];
            return result;
        }
        exports.shallowClone = shallowClone;
        function sanitize(obj, maxDepth) {
            if (maxDepth === void 0) maxDepth = 8;
            var seenObjects = [];
            function seen(obj) {
                if (!obj || typeof obj !== 'object') return false;
                for(var i = 0; i < seenObjects.length; i++){
                    var value = seenObjects[i];
                    if (value === obj) return true;
                }
                seenObjects.push(obj);
                return false;
            }
            function canSerialize(obj) {
                var typeOfObj = typeof obj;
                // Functions are TMI
                if (/function/.test(typeOfObj)) // Let special toJSON method pass as it's used by JSON.stringify (#722)
                return obj.name === 'toJSON';
                // Symbols can't convert to strings.
                if (/symbol/.test(typeOfObj)) return false;
                if (obj === null) return false;
                // No prototype, likely created with `Object.create(null)`.
                if (typeof obj === 'object' && typeof obj.hasOwnProperty === 'undefined') return false;
                return true;
            }
            function serialize(obj, depth) {
                if (depth === void 0) depth = 0;
                if (depth >= maxDepth) return '[DEPTH]';
                // Inspect invalid types
                if (!canSerialize(obj)) return Object.prototype.toString.call(obj);
                // Halt circular references
                if (seen(obj)) return '[RECURSION]';
                // Serialize inside arrays
                if (Array.isArray(obj)) return obj.map(function(o) {
                    return safeSerialize(o, depth + 1);
                });
                // Serialize inside objects
                if (typeof obj === 'object') {
                    var ret = {};
                    for(var k in obj){
                        var v = obj[k];
                        if (Object.prototype.hasOwnProperty.call(obj, k) && k != null && v != null) ret[k] = safeSerialize(v, depth + 1);
                    }
                    return ret;
                }
                // Return everything else untouched
                return obj;
            }
            function safeSerialize(obj, depth) {
                if (depth === void 0) depth = 0;
                try {
                    return serialize(obj, depth);
                } catch (e) {
                    return "[ERROR] ".concat(e);
                }
            }
            return safeSerialize(obj);
        }
        exports.sanitize = sanitize;
        function logger(client) {
            var log = function(method) {
                return function() {
                    var _a;
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    if (method === 'debug') {
                        if (!client.config.debug) return;
                        // Log at default level so that you don't need to also enable verbose
                        // logging in Chrome.
                        method = 'log';
                    }
                    args.unshift('[Honeybadger]');
                    (_a = client.config.logger)[method].apply(_a, args);
                };
            };
            return {
                log: log('log'),
                info: log('info'),
                debug: log('debug'),
                warn: log('warn'),
                error: log('error')
            };
        }
        exports.logger = logger;
        /**
		 * Converts any object into a notice object (which at minimum has the same
		 * properties as Error, but supports additional Honeybadger properties.)
		 */ function makeNotice(thing) {
            var notice;
            if (!thing) notice = {};
            else if (isErrorObject(thing)) {
                var e = thing;
                notice = merge(thing, {
                    name: e.name,
                    message: e.message,
                    stack: e.stack,
                    cause: e.cause
                });
            } else if (typeof thing === 'object') notice = shallowClone(thing);
            else {
                var m = String(thing);
                notice = {
                    message: m
                };
            }
            return notice;
        }
        exports.makeNotice = makeNotice;
        function isErrorObject(thing) {
            return thing instanceof Error || Object.prototype.toString.call(thing) === '[object Error]'; // Important for cross-realm objects
        }
        exports.isErrorObject = isErrorObject;
        /**
		 * Instrument an existing function inside an object (usually global).
		 * @param {!Object} object
		 * @param {!String} name
		 * @param {!Function} replacement
		 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function instrument(object, name, replacement) {
            if (!object || !name || !replacement || !(name in object)) return;
            try {
                var original = object[name];
                while(original && original.__hb_original)original = original.__hb_original;
                object[name] = replacement(original);
                object[name].__hb_original = original;
            } catch (_e) {
            // Ignores errors where "original" is a restricted object (see #1001)
            // Uncaught Error: Permission denied to access property "__hb_original"
            // Also ignores:
            //   Error: TypeError: Cannot set property onunhandledrejection of [object Object] which has only a getter
            //   User-Agent: Mozilla/5.0 (Linux; Android 10; SAMSUNG SM-G960F) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/12.1 Chrome/79.0.3945.136 Mobile Safari/537.36
            }
        }
        exports.instrument = instrument;
        function endpoint(base, path) {
            var endpoint = base.trim().replace(/\/$/, '');
            path = path.trim().replace(/(^\/|\/$)/g, '');
            return "".concat(endpoint, "/").concat(path);
        }
        exports.endpoint = endpoint;
        function generateStackTrace() {
            try {
                throw new Error('');
            } catch (e) {
                if (e.stack) return e.stack;
            }
            var maxStackSize = 10;
            var stack = [];
            var curr = arguments.callee;
            while(curr && stack.length < maxStackSize){
                if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(RegExp.$1 || '<anonymous>');
                else stack.push('<anonymous>');
                try {
                    curr = curr.caller;
                } catch (e) {
                    break;
                }
            }
            return stack.join('\n');
        }
        exports.generateStackTrace = generateStackTrace;
        function filter(obj, filters) {
            if (!is('Object', obj)) return;
            if (!is('Array', filters)) filters = [];
            var seen = [];
            function filter(obj) {
                var k, newObj;
                if (is('Object', obj) || is('Array', obj)) {
                    if (seen.indexOf(obj) !== -1) return '[CIRCULAR DATA STRUCTURE]';
                    seen.push(obj);
                }
                if (is('Object', obj)) {
                    newObj = {};
                    for(k in obj)if (filterMatch(k, filters)) newObj[k] = '[FILTERED]';
                    else newObj[k] = filter(obj[k]);
                    return newObj;
                }
                if (is('Array', obj)) return obj.map(function(v) {
                    return filter(v);
                });
                if (is('Function', obj)) return '[FUNC]';
                return obj;
            }
            return filter(obj);
        }
        exports.filter = filter;
        function filterMatch(key, filters) {
            for(var i = 0; i < filters.length; i++){
                if (key.toLowerCase().indexOf(filters[i].toLowerCase()) !== -1) return true;
            }
            return false;
        }
        function is(type, obj) {
            var klass = Object.prototype.toString.call(obj).slice(8, -1);
            return obj !== undefined && obj !== null && klass === type;
        }
        function filterUrl(url, filters) {
            if (!filters) return url;
            if (typeof url !== 'string') return url;
            var query = url.split(/\?/, 2)[1];
            if (!query) return url;
            var result = url;
            query.split(/[&]\s?/).forEach(function(pair) {
                var _a = pair.split('=', 2), key = _a[0], value = _a[1];
                if (filterMatch(key, filters)) result = result.replace("".concat(key, "=").concat(value), "".concat(key, "=[FILTERED]"));
            });
            return result;
        }
        exports.filterUrl = filterUrl;
        function formatCGIData(vars, prefix) {
            if (prefix === void 0) prefix = '';
            var formattedVars = {};
            Object.keys(vars).forEach(function(key) {
                var formattedKey = prefix + key.replace(/\W/g, '_').toUpperCase();
                formattedVars[formattedKey] = vars[key];
            });
            return formattedVars;
        }
        exports.formatCGIData = formatCGIData;
        function clone(obj) {
            return JSON.parse(JSON.stringify(obj));
        }
        exports.clone = clone;
        function getSourceCodeSnippet(fileData, lineNumber, sourceRadius) {
            if (sourceRadius === void 0) sourceRadius = 2;
            if (!fileData) return null;
            var lines = fileData.split('\n');
            // add one empty line because array index starts from 0, but error line number is counted from 1
            lines.unshift('');
            var start = lineNumber - sourceRadius;
            var end = lineNumber + sourceRadius;
            var result = {};
            for(var i = start; i <= end; i++){
                var line = lines[i];
                if (typeof line === 'string') result[i] = line;
            }
            return result;
        }
        function isBrowserConfig(config) {
            return config.async !== undefined;
        }
        exports.isBrowserConfig = isBrowserConfig;
    })(util$1);
    var store = {};
    Object.defineProperty(store, "__esModule", {
        value: true
    });
    store.GlobalStore = void 0;
    var util_1$7 = util$1;
    var GlobalStore = /** @class */ function() {
        function GlobalStore(contents, breadcrumbsLimit) {
            this.contents = contents;
            this.breadcrumbsLimit = breadcrumbsLimit;
        }
        GlobalStore.create = function(contents, breadcrumbsLimit) {
            return new GlobalStore(contents, breadcrumbsLimit);
        };
        GlobalStore.prototype.available = function() {
            return true;
        };
        GlobalStore.prototype.getContents = function(key) {
            var value = key ? this.contents[key] : this.contents;
            return JSON.parse(JSON.stringify(value));
        };
        GlobalStore.prototype.setContext = function(context) {
            this.contents.context = (0, util_1$7.merge)(this.contents.context, context || {});
        };
        GlobalStore.prototype.addBreadcrumb = function(breadcrumb) {
            if (this.contents.breadcrumbs.length == this.breadcrumbsLimit) this.contents.breadcrumbs.shift();
            this.contents.breadcrumbs.push(breadcrumb);
        };
        GlobalStore.prototype.clear = function() {
            this.contents.context = {};
            this.contents.breadcrumbs = [];
        };
        GlobalStore.prototype.run = function(callback) {
            return callback();
        };
        return GlobalStore;
    }();
    store.GlobalStore = GlobalStore;
    var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
        __assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    Object.defineProperty(client, "__esModule", {
        value: true
    });
    client.Client = void 0;
    var util_1$6 = util$1;
    var store_1 = store;
    var notifier = {
        name: 'honeybadger-js',
        url: 'https://github.com/honeybadger-io/honeybadger-js',
        version: '4.9.3'
    };
    // Split at commas and spaces
    var TAG_SEPARATOR = /,|\s+/;
    // Checks for non-blank characters
    var NOT_BLANK = /\S/;
    var Client = /** @class */ function() {
        function Client(opts, transport) {
            if (opts === void 0) opts = {};
            this.__pluginsExecuted = false;
            this.__store = null;
            this.__beforeNotifyHandlers = [];
            this.__afterNotifyHandlers = [];
            this.config = __assign({
                apiKey: null,
                endpoint: 'https://api.honeybadger.io',
                environment: null,
                hostname: null,
                projectRoot: null,
                component: null,
                action: null,
                revision: null,
                reportData: null,
                breadcrumbsEnabled: true,
                maxBreadcrumbs: 40,
                maxObjectDepth: 8,
                logger: console,
                developmentEnvironments: [
                    'dev',
                    'development',
                    'test'
                ],
                debug: false,
                tags: null,
                enableUncaught: true,
                enableUnhandledRejection: true,
                afterUncaught: function() {
                    return true;
                },
                filters: [
                    'creditcard',
                    'password'
                ],
                __plugins: []
            }, opts);
            this.__initStore();
            this.__transport = transport;
            this.logger = (0, util_1$6.logger)(this);
        }
        Client.prototype.getVersion = function() {
            return notifier.version;
        };
        Client.prototype.configure = function(opts) {
            var _this = this;
            if (opts === void 0) opts = {};
            for(var k in opts)this.config[k] = opts[k];
            if (!this.__pluginsExecuted) {
                this.__pluginsExecuted = true;
                this.config.__plugins.forEach(function(plugin) {
                    return plugin.load(_this);
                });
            }
            return this;
        };
        Client.prototype.__initStore = function() {
            this.__store = new store_1.GlobalStore({
                context: {},
                breadcrumbs: []
            }, this.config.maxBreadcrumbs);
        };
        Client.prototype.beforeNotify = function(handler) {
            this.__beforeNotifyHandlers.push(handler);
            return this;
        };
        Client.prototype.afterNotify = function(handler) {
            this.__afterNotifyHandlers.push(handler);
            return this;
        };
        Client.prototype.setContext = function(context) {
            if (typeof context === 'object' && context != null) this.__store.setContext(context);
            return this;
        };
        Client.prototype.resetContext = function(context) {
            this.logger.warn('Deprecation warning: `Honeybadger.resetContext()` has been deprecated; please use `Honeybadger.clear()` instead.');
            this.__store.clear();
            if (typeof context === 'object' && context !== null) this.__store.setContext(context);
            return this;
        };
        Client.prototype.clear = function() {
            this.__store.clear();
            return this;
        };
        Client.prototype.notify = function(noticeable, name, extra) {
            var _this = this;
            if (name === void 0) name = undefined;
            if (extra === void 0) extra = undefined;
            var preConditionError = null;
            var notice = this.makeNotice(noticeable, name, extra);
            if (!notice) {
                this.logger.debug('failed to build error report');
                preConditionError = new Error('failed to build error report');
            }
            if (!preConditionError && this.config.reportData === false) {
                this.logger.debug('skipping error report: honeybadger.js is disabled', notice);
                preConditionError = new Error('honeybadger.js is disabled');
            }
            if (!preConditionError && this.__developmentMode()) {
                this.logger.log('honeybadger.js is in development mode; the following error report will be sent in production.', notice);
                preConditionError = new Error('honeybadger.js is in development mode');
            }
            if (!preConditionError && !this.config.apiKey) {
                this.logger.warn('could not send error report: no API key has been configured', notice);
                preConditionError = new Error('missing API key');
            }
            // we need to have the source file data before the beforeNotifyHandlers,
            // in case they modify them
            var sourceCodeData = notice && notice.backtrace ? notice.backtrace.map(function(trace) {
                return (0, util_1$6.shallowClone)(trace);
            }) : null;
            var beforeNotifyResult = (0, util_1$6.runBeforeNotifyHandlers)(notice, this.__beforeNotifyHandlers);
            if (!preConditionError && !beforeNotifyResult) {
                this.logger.debug('skipping error report: beforeNotify handlers returned false', notice);
                preConditionError = new Error('beforeNotify handlers returned false');
            }
            if (preConditionError) {
                (0, util_1$6.runAfterNotifyHandlers)(notice, this.__afterNotifyHandlers, preConditionError);
                return false;
            }
            this.addBreadcrumb('Honeybadger Notice', {
                category: 'notice',
                metadata: {
                    message: notice.message,
                    name: notice.name,
                    stack: notice.stack
                }
            });
            var breadcrumbs = this.__store.getContents('breadcrumbs');
            notice.__breadcrumbs = this.config.breadcrumbsEnabled ? breadcrumbs : [];
            (0, util_1$6.getSourceForBacktrace)(sourceCodeData, this.__getSourceFileHandler).then(function(sourcePerTrace) {
                sourcePerTrace.forEach(function(source, index) {
                    notice.backtrace[index].source = source;
                });
                var payload = _this.__buildPayload(notice);
                _this.__transport.send({
                    headers: {
                        'X-API-Key': _this.config.apiKey,
                        'Content-Type': 'application/json',
                        'Accept': 'text/json, application/json'
                    },
                    method: 'POST',
                    endpoint: (0, util_1$6.endpoint)(_this.config.endpoint, '/v1/notices/js'),
                    maxObjectDepth: _this.config.maxObjectDepth,
                    logger: _this.logger
                }, payload).then(function(res) {
                    if (res.statusCode !== 201) {
                        (0, util_1$6.runAfterNotifyHandlers)(notice, _this.__afterNotifyHandlers, new Error("Bad HTTP response: ".concat(res.statusCode)));
                        _this.logger.warn("Error report failed: unknown response from server. code=".concat(res.statusCode));
                        return;
                    }
                    var uuid = JSON.parse(res.body).id;
                    (0, util_1$6.runAfterNotifyHandlers)((0, util_1$6.merge)(notice, {
                        id: uuid
                    }), _this.__afterNotifyHandlers);
                    _this.logger.info("Error report sent \u26A1 https://app.honeybadger.io/notice/".concat(uuid));
                }).catch(function(err) {
                    _this.logger.error('Error report failed: an unknown error occurred.', "message=".concat(err.message));
                    (0, util_1$6.runAfterNotifyHandlers)(notice, _this.__afterNotifyHandlers, err);
                });
            });
            return true;
        };
        /**
	     * An async version of {@link notify} that resolves only after the notice has been reported to Honeybadger.
	     * Implemented using the {@link afterNotify} hook.
	     * Rejects if for any reason the report failed to be reported.
	     * Useful in serverless environments (AWS Lambda).
	     */ Client.prototype.notifyAsync = function(noticeable, name, extra) {
            var _this = this;
            if (name === void 0) name = undefined;
            if (extra === void 0) extra = undefined;
            return new Promise(function(resolve, reject) {
                var applyAfterNotify = function(partialNotice) {
                    var originalAfterNotify = partialNotice.afterNotify;
                    partialNotice.afterNotify = function(err) {
                        originalAfterNotify === null || originalAfterNotify === void 0 || originalAfterNotify.call(_this, err);
                        if (err) return reject(err);
                        resolve();
                    };
                };
                // We have to respect any afterNotify hooks that come from the arguments
                var objectToOverride;
                if (noticeable.afterNotify) objectToOverride = noticeable;
                else if (name && name.afterNotify) objectToOverride = name;
                else if (extra && extra.afterNotify) objectToOverride = extra;
                else if (name && typeof name === 'object') objectToOverride = name;
                else if (extra) objectToOverride = extra;
                else objectToOverride = name = {};
                applyAfterNotify(objectToOverride);
                _this.notify(noticeable, name, extra);
            });
        };
        Client.prototype.makeNotice = function(noticeable, name, extra) {
            if (name === void 0) name = undefined;
            if (extra === void 0) extra = undefined;
            var notice = (0, util_1$6.makeNotice)(noticeable);
            if (name && !(typeof name === 'object')) {
                var n = String(name);
                name = {
                    name: n
                };
            }
            if (name) notice = (0, util_1$6.mergeNotice)(notice, name);
            if (typeof extra === 'object' && extra !== null) notice = (0, util_1$6.mergeNotice)(notice, extra);
            if ((0, util_1$6.objectIsEmpty)(notice)) return null;
            var context = this.__store.getContents('context');
            var noticeTags = this.__constructTags(notice.tags);
            var contextTags = this.__constructTags(context['tags']);
            var configTags = this.__constructTags(this.config.tags);
            // Turning into a Set will remove duplicates
            var tags = noticeTags.concat(contextTags).concat(configTags);
            var uniqueTags = tags.filter(function(item, index) {
                return tags.indexOf(item) === index;
            });
            notice = (0, util_1$6.merge)(notice, {
                name: notice.name || 'Error',
                context: (0, util_1$6.merge)(context, notice.context),
                projectRoot: notice.projectRoot || this.config.projectRoot,
                environment: notice.environment || this.config.environment,
                component: notice.component || this.config.component,
                action: notice.action || this.config.action,
                revision: notice.revision || this.config.revision,
                tags: uniqueTags
            });
            if (typeof notice.stack !== 'string' || !notice.stack.trim()) {
                notice.stack = (0, util_1$6.generateStackTrace)();
                notice.backtrace = (0, util_1$6.makeBacktrace)(notice.stack, true, this.logger);
            } else notice.backtrace = (0, util_1$6.makeBacktrace)(notice.stack, false, this.logger);
            return notice;
        };
        Client.prototype.addBreadcrumb = function(message, opts) {
            if (!this.config.breadcrumbsEnabled) return;
            opts = opts || {};
            var metadata = (0, util_1$6.shallowClone)(opts.metadata);
            var category = opts.category || 'custom';
            var timestamp = new Date().toISOString();
            this.__store.addBreadcrumb({
                category: category,
                message: message,
                metadata: metadata,
                timestamp: timestamp
            });
            return this;
        };
        Client.prototype.__getBreadcrumbs = function() {
            return this.__store.getContents('breadcrumbs').slice();
        };
        Client.prototype.__getContext = function() {
            return this.__store.getContents('context');
        };
        Client.prototype.__developmentMode = function() {
            if (this.config.reportData === true) return false;
            return this.config.environment && this.config.developmentEnvironments.includes(this.config.environment);
        };
        Client.prototype.__buildPayload = function(notice) {
            var headers = (0, util_1$6.filter)(notice.headers, this.config.filters) || {};
            var cgiData = (0, util_1$6.filter)(__assign(__assign({}, notice.cgiData), (0, util_1$6.formatCGIData)(headers, 'HTTP_')), this.config.filters);
            return {
                notifier: notifier,
                breadcrumbs: {
                    enabled: !!this.config.breadcrumbsEnabled,
                    trail: notice.__breadcrumbs || []
                },
                error: {
                    class: notice.name,
                    message: notice.message,
                    backtrace: notice.backtrace,
                    fingerprint: notice.fingerprint,
                    tags: notice.tags,
                    causes: (0, util_1$6.getCauses)(notice, this.logger)
                },
                request: {
                    url: (0, util_1$6.filterUrl)(notice.url, this.config.filters),
                    component: notice.component,
                    action: notice.action,
                    context: notice.context,
                    cgi_data: cgiData,
                    params: (0, util_1$6.filter)(notice.params, this.config.filters) || {},
                    session: (0, util_1$6.filter)(notice.session, this.config.filters) || {}
                },
                server: {
                    project_root: notice.projectRoot,
                    environment_name: notice.environment,
                    revision: notice.revision,
                    hostname: this.config.hostname,
                    time: new Date().toUTCString()
                },
                details: notice.details || {}
            };
        };
        Client.prototype.__constructTags = function(tags) {
            if (!tags) return [];
            return tags.toString().split(TAG_SEPARATOR).filter(function(tag) {
                return NOT_BLANK.test(tag);
            });
        };
        return Client;
    }();
    client.Client = Client;
    var types = {};
    Object.defineProperty(types, "__esModule", {
        value: true
    });
    (function(exports) {
        var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
            if (k2 === undefined) k2 = k;
            var desc = Object.getOwnPropertyDescriptor(m, k);
            if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                enumerable: true,
                get: function() {
                    return m[k];
                }
            };
            Object.defineProperty(o, k2, desc);
        } : function(o, m, k, k2) {
            if (k2 === undefined) k2 = k;
            o[k2] = m[k];
        });
        var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
            Object.defineProperty(o, "default", {
                enumerable: true,
                value: v
            });
        } : function(o, v) {
            o["default"] = v;
        });
        var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m, exports) {
            for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
        };
        var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(mod) {
            if (mod && mod.__esModule) return mod;
            var result = {};
            if (mod != null) {
                for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
            }
            __setModuleDefault(result, mod);
            return result;
        };
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.Util = exports.Types = exports.Client = void 0;
        var client_1 = client;
        Object.defineProperty(exports, "Client", {
            enumerable: true,
            get: function() {
                return client_1.Client;
            }
        });
        __exportStar(store, exports);
        exports.Types = __importStar(types);
        exports.Util = __importStar(util$1);
    })(src);
    var util = {};
    Object.defineProperty(util, "__esModule", {
        value: true
    });
    util.globalThisOrWindow = util.preferCatch = util.encodeCookie = util.decodeCookie = util.localURLPathname = util.parseURL = util.nativeFetch = util.stringTextOfElement = util.stringSelectorOfElement = util.stringNameOfElement = void 0;
    /**
	 * Converts an HTMLElement into a human-readable string.
	 * @param {!HTMLElement} element
	 * @return {string}
	 */ function stringNameOfElement(element) {
        if (!element || !element.tagName) return '';
        var name = element.tagName.toLowerCase();
        // Ignore the root <html> element in selectors and events.
        if (name === 'html') return '';
        if (element.id) name += "#".concat(element.id);
        var stringClassNames = element.getAttribute('class');
        if (stringClassNames) stringClassNames.split(/\s+/).forEach(function(className) {
            name += ".".concat(className);
        });
        [
            'alt',
            'name',
            'title',
            'type'
        ].forEach(function(attrName) {
            var attr = element.getAttribute(attrName);
            if (attr) name += "[".concat(attrName, "=\"").concat(attr, "\"]");
        });
        var siblings = getSiblings(element);
        if (siblings.length > 1) name += ":nth-child(".concat(Array.prototype.indexOf.call(siblings, element) + 1, ")");
        return name;
    }
    util.stringNameOfElement = stringNameOfElement;
    function stringSelectorOfElement(element) {
        var name = stringNameOfElement(element);
        if (element.parentNode && element.parentNode.tagName) {
            var parentName = stringSelectorOfElement(element.parentNode);
            if (parentName.length > 0) return "".concat(parentName, " > ").concat(name);
        }
        return name;
    }
    util.stringSelectorOfElement = stringSelectorOfElement;
    function stringTextOfElement(element) {
        var text = element.textContent || element.innerText || '';
        if (!text && (element.type === 'submit' || element.type === 'button')) text = element.value;
        return truncate(text.trim(), 300);
    }
    util.stringTextOfElement = stringTextOfElement;
    function nativeFetch() {
        var global = globalThisOrWindow();
        if (!global.fetch) return false;
        if (isNative(global.fetch)) return true;
        // If fetch isn't native, it may be wrapped by someone else. Try to get
        // a pristine function from an iframe.
        try {
            var sandbox = document.createElement('iframe');
            sandbox.style.display = 'none';
            document.head.appendChild(sandbox);
            var result = sandbox.contentWindow.fetch && isNative(sandbox.contentWindow.fetch);
            document.head.removeChild(sandbox);
            return result;
        } catch (err) {
            if (console && console.warn) console.warn('failed to detect native fetch via iframe: ' + err);
        }
        return false;
    }
    util.nativeFetch = nativeFetch;
    function isNative(func) {
        return func.toString().indexOf('native') !== -1;
    }
    function parseURL(url) {
        // Regexp: https://tools.ietf.org/html/rfc3986#appendix-B
        var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/) || {};
        return {
            protocol: match[2],
            host: match[4],
            pathname: match[5]
        };
    }
    util.parseURL = parseURL;
    function localURLPathname(url) {
        var parsed = parseURL(url);
        var parsedDocURL = parseURL(document.URL);
        // URL must be relative
        if (!parsed.host || !parsed.protocol) return parsed.pathname;
        // Same domain
        if (parsed.protocol === parsedDocURL.protocol && parsed.host === parsedDocURL.host) return parsed.pathname;
        // x-domain
        return "".concat(parsed.protocol, "://").concat(parsed.host).concat(parsed.pathname);
    }
    util.localURLPathname = localURLPathname;
    function decodeCookie(string) {
        var result = {};
        string.split(/[;,]\s?/).forEach(function(pair) {
            var _a = pair.split('=', 2), key = _a[0], value = _a[1];
            result[key] = value;
        });
        return result;
    }
    util.decodeCookie = decodeCookie;
    function encodeCookie(object) {
        if (typeof object !== 'object') return undefined;
        var cookies = [];
        for(var k in object)cookies.push(k + '=' + object[k]);
        return cookies.join(';');
    }
    util.encodeCookie = encodeCookie;
    // Helpers
    function getSiblings(element) {
        try {
            var nodes = element.parentNode.childNodes;
            var siblings_1 = [];
            Array.prototype.forEach.call(nodes, function(node) {
                if (node.tagName && node.tagName === element.tagName) siblings_1.push(node);
            });
            return siblings_1;
        } catch (e) {
            return [];
        }
    }
    function truncate(string, length) {
        if (string.length > length) string = string.substr(0, length) + '...';
        return string;
    }
    // Used to decide which error handling method to use when wrapping async
    // handlers: try/catch, or `window.onerror`. When available, `window.onerror`
    // will provide more information in modern browsers.
    util.preferCatch = function() {
        var preferCatch = true;
        // In case we're in an environment without access to "window", lets make sure theres a window.
        if (typeof window === 'undefined') return preferCatch;
        // IE < 10
        if (!window.atob) preferCatch = false;
        // Modern browsers support the full ErrorEvent API
        // See https://developer.mozilla.org/en-US/docs/Web/API/ErrorEvent
        if (window.ErrorEvent) try {
            if (new window.ErrorEvent('').colno === 0) preferCatch = false;
        // eslint-disable-next-line no-empty
        } catch (_e) {}
        return preferCatch;
    }();
    /** globalThis has fairly good support. But just in case, lets check its defined.
	 * @see {https://caniuse.com/?search=globalThis}
	 */ function globalThisOrWindow() {
        if (typeof globalThis !== 'undefined') return globalThis;
        if (typeof self !== 'undefined') return self;
        return window;
    }
    util.globalThisOrWindow = globalThisOrWindow;
    var onerror = {};
    Object.defineProperty(onerror, "__esModule", {
        value: true
    });
    onerror.onError = onerror.ignoreNextOnError = void 0;
    /* eslint-disable prefer-rest-params */ var core_1$5 = src;
    var util_1$5 = util;
    var instrument$4 = core_1$5.Util.instrument, makeNotice = core_1$5.Util.makeNotice;
    var ignoreOnError = 0;
    var currentTimeout;
    function ignoreNextOnError() {
        ignoreOnError += 1;
        clearTimeout(currentTimeout);
        currentTimeout = setTimeout(function() {
            ignoreOnError = 0;
        });
    }
    onerror.ignoreNextOnError = ignoreNextOnError;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onError(_window) {
        if (_window === void 0) _window = (0, util_1$5.globalThisOrWindow)();
        return {
            load: function(client) {
                instrument$4(_window, 'onerror', function(original) {
                    var onerror = function(msg, url, line, col, err) {
                        client.logger.debug('window.onerror callback invoked', arguments);
                        if (ignoreOnError > 0) {
                            client.logger.debug('Ignoring window.onerror (error likely reported earlier)', arguments);
                            ignoreOnError -= 1;
                            return;
                        }
                        // See https://developer.mozilla.org/en/docs/Web/API/GlobalEventHandlers/onerror#Notes
                        if (line === 0 && /Script error\.?/.test(msg)) {
                            if (client.config.enableUncaught) // Log only if the user wants to report uncaught errors
                            client.logger.warn('Ignoring cross-domain script error: enable CORS to track these types of errors', arguments);
                            return;
                        }
                        var notice = makeNotice(err);
                        if (!notice.name) notice.name = 'window.onerror';
                        if (!notice.message) notice.message = msg;
                        if (!notice.stack) // Simulate v8 stack
                        notice.stack = [
                            notice.message,
                            '\n    at ? (',
                            url || 'unknown',
                            ':',
                            line || 0,
                            ':',
                            col || 0,
                            ')'
                        ].join('');
                        client.addBreadcrumb(notice.name === 'window.onerror' || !notice.name ? 'window.onerror' : "window.onerror: ".concat(notice.name), {
                            category: 'error',
                            metadata: {
                                name: notice.name,
                                message: notice.message,
                                stack: notice.stack
                            }
                        });
                        if (client.config.enableUncaught) client.notify(notice);
                    };
                    return function(msg, url, line, col, err) {
                        onerror(msg, url, line, col, err);
                        if (typeof original === 'function') return original.apply(_window, arguments);
                        return false;
                    };
                });
            }
        };
    }
    onerror.onError = onError;
    var onunhandledrejection = {};
    Object.defineProperty(onunhandledrejection, "__esModule", {
        value: true
    });
    /* eslint-disable prefer-rest-params */ var core_1$4 = src;
    var util_1$4 = util;
    var instrument$3 = core_1$4.Util.instrument;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function default_1$3(_window) {
        if (_window === void 0) _window = (0, util_1$4.globalThisOrWindow)();
        return {
            load: function(client) {
                if (!client.config.enableUnhandledRejection) return;
                instrument$3(_window, 'onunhandledrejection', function(original) {
                    // See https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event
                    function onunhandledrejection(promiseRejectionEvent) {
                        var _a;
                        client.logger.debug('window.onunhandledrejection callback invoked', arguments);
                        if (!client.config.enableUnhandledRejection) return;
                        var reason = promiseRejectionEvent.reason;
                        if (reason instanceof Error) {
                            // simulate v8 stack
                            // const fileName = reason.fileName || 'unknown'
                            // const lineNumber = reason.lineNumber || 0
                            var fileName = 'unknown';
                            var lineNumber = 0;
                            var stackFallback = "".concat(reason.message, "\n    at ? (").concat(fileName, ":").concat(lineNumber, ")");
                            var stack = reason.stack || stackFallback;
                            var err = {
                                name: reason.name,
                                message: "UnhandledPromiseRejectionWarning: ".concat(reason),
                                stack: stack
                            };
                            client.addBreadcrumb("window.onunhandledrejection: ".concat(err.name), {
                                category: 'error',
                                metadata: err
                            });
                            client.notify(err);
                            return;
                        }
                        var message = typeof reason === 'string' ? reason : (_a = JSON.stringify(reason)) !== null && _a !== void 0 ? _a : 'Unspecified reason';
                        client.notify({
                            name: 'window.onunhandledrejection',
                            message: "UnhandledPromiseRejectionWarning: ".concat(message)
                        });
                    }
                    return function(promiseRejectionEvent) {
                        onunhandledrejection(promiseRejectionEvent);
                        if (typeof original === 'function') original.apply(this, arguments);
                    };
                });
            }
        };
    }
    onunhandledrejection.default = default_1$3;
    var breadcrumbs = {};
    Object.defineProperty(breadcrumbs, "__esModule", {
        value: true
    });
    /* eslint-disable prefer-rest-params */ var core_1$3 = src;
    var util_1$3 = util;
    var sanitize$1 = core_1$3.Util.sanitize, instrument$2 = core_1$3.Util.instrument;
    function default_1$2(_window) {
        if (_window === void 0) _window = (0, util_1$3.globalThisOrWindow)();
        return {
            load: function(client) {
                function breadcrumbsEnabled(type) {
                    if (client.config.breadcrumbsEnabled === true) return true;
                    if (type) return client.config.breadcrumbsEnabled[type] === true;
                    return client.config.breadcrumbsEnabled !== false;
                }
                // Breadcrumbs: instrument console
                (function() {
                    if (!breadcrumbsEnabled('console')) return;
                    function inspectArray(obj) {
                        if (!Array.isArray(obj)) return '';
                        return obj.map(function(value) {
                            try {
                                return String(value);
                            } catch (e) {
                                return '[unknown]';
                            }
                        }).join(' ');
                    }
                    [
                        'debug',
                        'info',
                        'warn',
                        'error',
                        'log'
                    ].forEach(function(level) {
                        instrument$2(_window.console, level, function(original) {
                            return function() {
                                var args = Array.prototype.slice.call(arguments);
                                var message = inspectArray(args);
                                var opts = {
                                    category: 'log',
                                    metadata: {
                                        level: level,
                                        arguments: sanitize$1(args, 3)
                                    }
                                };
                                client.addBreadcrumb(message, opts);
                                if (typeof original === 'function') Function.prototype.apply.call(original, _window.console, arguments);
                            };
                        });
                    });
                })();
                // Breadcrumbs: instrument click events
                (function() {
                    if (!breadcrumbsEnabled('dom')) return;
                    _window.addEventListener('click', function(event) {
                        var message, selector, text;
                        try {
                            message = (0, util_1$3.stringNameOfElement)(event.target);
                            selector = (0, util_1$3.stringSelectorOfElement)(event.target);
                            text = (0, util_1$3.stringTextOfElement)(event.target);
                        } catch (e) {
                            message = 'UI Click';
                            selector = '[unknown]';
                            text = '[unknown]';
                        }
                        // There's nothing to display
                        if (message.length === 0) return;
                        client.addBreadcrumb(message, {
                            category: 'ui.click',
                            metadata: {
                                selector: selector,
                                text: text,
                                event: event
                            }
                        });
                    }, _window.location ? true : false); // In CloudFlare workers useCapture must be false. window.locaiton is a hacky way to detect it.
                })();
                // Breadcrumbs: instrument XMLHttpRequest
                (function() {
                    if (!breadcrumbsEnabled('network')) return;
                    // Some environments may not support XMLHttpRequest.
                    if (typeof XMLHttpRequest === 'undefined') return;
                    // -- On xhr.open: capture initial metadata
                    instrument$2(XMLHttpRequest.prototype, 'open', function(original) {
                        return function() {
                            // eslint-disable-next-line @typescript-eslint/no-this-alias
                            var xhr = this;
                            var url = arguments[1];
                            var method = typeof arguments[0] === 'string' ? arguments[0].toUpperCase() : arguments[0];
                            var message = "".concat(method, " ").concat((0, util_1$3.localURLPathname)(url));
                            this.__hb_xhr = {
                                type: 'xhr',
                                method: method,
                                url: url,
                                message: message
                            };
                            if (typeof original === 'function') original.apply(xhr, arguments);
                        };
                    });
                    // -- On xhr.send: set up xhr.onreadystatechange to report breadcrumb
                    instrument$2(XMLHttpRequest.prototype, 'send', function(original) {
                        return function() {
                            // eslint-disable-next-line @typescript-eslint/no-this-alias
                            var xhr = this;
                            function onreadystatechangeHandler() {
                                if (xhr.readyState === 4) {
                                    var message = void 0;
                                    if (xhr.__hb_xhr) {
                                        xhr.__hb_xhr.status_code = xhr.status;
                                        message = xhr.__hb_xhr.message;
                                        delete xhr.__hb_xhr.message;
                                    }
                                    client.addBreadcrumb(message || 'XMLHttpRequest', {
                                        category: 'request',
                                        metadata: xhr.__hb_xhr
                                    });
                                }
                            }
                            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') instrument$2(xhr, 'onreadystatechange', function(original) {
                                return function() {
                                    onreadystatechangeHandler();
                                    if (typeof original === 'function') // eslint-disable-next-line prefer-rest-params
                                    original.apply(this, arguments);
                                };
                            });
                            else xhr.onreadystatechange = onreadystatechangeHandler;
                            if (typeof original === 'function') // eslint-disable-next-line prefer-rest-params
                            original.apply(xhr, arguments);
                        };
                    });
                })();
                // Breadcrumbs: instrument fetch
                (function() {
                    if (!breadcrumbsEnabled('network')) return;
                    if (!(0, util_1$3.nativeFetch)()) // Polyfills use XHR.
                    return;
                    instrument$2(_window, 'fetch', function(original) {
                        return function() {
                            // eslint-disable-next-line prefer-rest-params
                            var input = arguments[0];
                            var method = 'GET';
                            var url;
                            if (typeof input === 'string') url = input;
                            else if ('Request' in _window && input instanceof Request) {
                                url = input.url;
                                if (input.method) method = input.method;
                            } else url = String(input);
                            if (arguments[1] && arguments[1].method) method = arguments[1].method;
                            if (typeof method === 'string') method = method.toUpperCase();
                            // localURLPathname cant be constructed for CF workers due to reliance on "document".
                            var message = "".concat(method, " ").concat(typeof document === 'undefined' ? url : (0, util_1$3.localURLPathname)(url));
                            var metadata = {
                                type: 'fetch',
                                method: method,
                                url: url
                            };
                            return original.apply(this, arguments).then(function(response) {
                                metadata['status_code'] = response.status;
                                client.addBreadcrumb(message, {
                                    category: 'request',
                                    metadata: metadata
                                });
                                return response;
                            }).catch(function(error) {
                                client.addBreadcrumb('fetch error', {
                                    category: 'error',
                                    metadata: metadata
                                });
                                throw error;
                            });
                        };
                    });
                })();
                // Breadcrumbs: instrument navigation
                (function() {
                    if (!breadcrumbsEnabled('navigation')) return;
                    if (_window.location == null) // Most likely in a CF worker, we should be listening to fetch requests instead.
                    return;
                    // The last known href of the current page
                    var lastHref = _window.location.href;
                    function recordUrlChange(from, to) {
                        lastHref = to;
                        client.addBreadcrumb('Page changed', {
                            category: 'navigation',
                            metadata: {
                                from: from,
                                to: to
                            }
                        });
                    }
                    if (typeof addEventListener === 'function') addEventListener('popstate', function(_event) {
                        recordUrlChange(lastHref, _window.location.href);
                    });
                    // https://developer.mozilla.org/en-US/docs/Web/API/History/pushState
                    // https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState
                    function historyWrapper(original) {
                        return function() {
                            var url = arguments.length > 2 ? arguments[2] : undefined;
                            if (url) recordUrlChange(lastHref, String(url));
                            return original.apply(this, arguments);
                        };
                    }
                    instrument$2(_window.history, 'pushState', historyWrapper);
                    instrument$2(_window.history, 'replaceState', historyWrapper);
                })();
            }
        };
    }
    breadcrumbs.default = default_1$2;
    var timers = {};
    Object.defineProperty(timers, "__esModule", {
        value: true
    });
    /* eslint-disable prefer-rest-params */ var core_1$2 = src;
    var util_1$2 = util;
    var instrument$1 = core_1$2.Util.instrument;
    function default_1$1(_window) {
        if (_window === void 0) _window = (0, util_1$2.globalThisOrWindow)();
        return {
            load: function(client) {
                // Wrap timers
                (function() {
                    function instrumentTimer(wrapOpts) {
                        return function(original) {
                            // See https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout
                            return function(func, delay) {
                                if (typeof func === 'function') {
                                    var args_1 = Array.prototype.slice.call(arguments, 2);
                                    func = client.__wrap(func, wrapOpts);
                                    return original(function() {
                                        func.apply(void 0, args_1);
                                    }, delay);
                                } else return original(func, delay);
                            };
                        };
                    }
                    instrument$1(_window, 'setTimeout', instrumentTimer({
                        component: 'setTimeout'
                    }));
                    instrument$1(_window, 'setInterval', instrumentTimer({
                        component: 'setInterval'
                    }));
                })();
            }
        };
    }
    timers.default = default_1$1;
    var event_listeners = {};
    Object.defineProperty(event_listeners, "__esModule", {
        value: true
    });
    var core_1$1 = src;
    var util_1$1 = util;
    var instrument = core_1$1.Util.instrument;
    function default_1(_window) {
        if (_window === void 0) _window = (0, util_1$1.globalThisOrWindow)();
        return {
            load: function(client) {
                // Wrap event listeners
                // Event targets borrowed from bugsnag-js:
                // See https://github.com/bugsnag/bugsnag-js/blob/d55af916a4d3c7757f979d887f9533fe1a04cc93/src/bugsnag.js#L542
                var targets = [
                    'EventTarget',
                    'Window',
                    'Node',
                    'ApplicationCache',
                    'AudioTrackList',
                    'ChannelMergerNode',
                    'CryptoOperation',
                    'EventSource',
                    'FileReader',
                    'HTMLUnknownElement',
                    'IDBDatabase',
                    'IDBRequest',
                    'IDBTransaction',
                    'KeyOperation',
                    'MediaController',
                    'MessagePort',
                    'ModalWindow',
                    'Notification',
                    'SVGElementInstance',
                    'Screen',
                    'TextTrack',
                    'TextTrackCue',
                    'TextTrackList',
                    'WebSocket',
                    'WebSocketWorker',
                    'Worker',
                    'XMLHttpRequest',
                    'XMLHttpRequestEventTarget',
                    'XMLHttpRequestUpload'
                ];
                targets.forEach(function(prop) {
                    var prototype = _window[prop] && _window[prop].prototype;
                    if (prototype && Object.prototype.hasOwnProperty.call(prototype, 'addEventListener')) {
                        instrument(prototype, 'addEventListener', function(original) {
                            var wrapOpts = {
                                component: "".concat(prop, ".prototype.addEventListener")
                            };
                            // See https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
                            return function(type, listener, useCapture, wantsUntrusted) {
                                try {
                                    if (listener && listener.handleEvent != null) listener.handleEvent = client.__wrap(listener.handleEvent, wrapOpts);
                                } catch (e) {
                                    // Ignore 'Permission denied to access property "handleEvent"' errors.
                                    client.logger.error(e);
                                }
                                return original.call(this, type, client.__wrap(listener, wrapOpts), useCapture, wantsUntrusted);
                            };
                        });
                        instrument(prototype, 'removeEventListener', function(original) {
                            return function(type, listener, useCapture, wantsUntrusted) {
                                original.call(this, type, listener, useCapture, wantsUntrusted);
                                return original.call(this, type, client.__wrap(listener), useCapture, wantsUntrusted);
                            };
                        });
                    }
                });
            }
        };
    }
    event_listeners.default = default_1;
    var transport = {};
    var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    Object.defineProperty(transport, "__esModule", {
        value: true
    });
    transport.BrowserTransport = void 0;
    var core_1 = src;
    var util_1 = util;
    var sanitize = core_1.Util.sanitize;
    /**
	 * Helper function to get typesafe Object.entries()
	 * https://twitter.com/mattpocockuk/status/1502264005251018754?lang=en
	 */ function objectEntries(obj) {
        return Object.entries(obj);
    }
    var BrowserTransport = /** @class */ function() {
        function BrowserTransport() {}
        BrowserTransport.prototype.send = function(options, payload) {
            return __awaiter(this, void 0, void 0, function() {
                var headerArray, headers, requestInit, response, body;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            headerArray = options.headers ? objectEntries(options.headers) : [];
                            headers = {};
                            headerArray.forEach(function(_a) {
                                var key = _a[0], value = _a[1];
                                if (key != null && value != null) headers[String(key)] = String(value);
                            });
                            requestInit = {
                                method: options.method,
                                headers: headers
                            };
                            // GET methods cannot have a body.
                            if (options.method === 'POST') requestInit.body = payload ? JSON.stringify(sanitize(payload, options.maxObjectDepth)) : undefined;
                            return [
                                4 /*yield*/ ,
                                (0, util_1.globalThisOrWindow)().fetch(options.endpoint, requestInit)
                            ];
                        case 1:
                            response = _a.sent();
                            return [
                                4 /*yield*/ ,
                                response.text()
                            ];
                        case 2:
                            body = _a.sent();
                            return [
                                2 /*return*/ ,
                                Promise.resolve({
                                    statusCode: response.status,
                                    body: body
                                })
                            ];
                    }
                });
            });
        };
        return BrowserTransport;
    }();
    transport.BrowserTransport = BrowserTransport;
    (function(exports) {
        var __extends = commonjsGlobal && commonjsGlobal.__extends || function() {
            var extendStatics = function(d, b) {
                extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
                return extendStatics(d, b);
            };
            return function(d, b) {
                if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                extendStatics(d, b);
                function __() {
                    this.constructor = d;
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
        }();
        var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
            __assign = Object.assign || function(t) {
                for(var s, i = 1, n = arguments.length; i < n; i++){
                    s = arguments[i];
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
            return __assign.apply(this, arguments);
        };
        var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P ? value : new P(function(resolve) {
                    resolve(value);
                });
            }
            return new (P || (P = Promise))(function(resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        };
        var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
            var _ = {
                label: 0,
                sent: function() {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: []
            }, f, y, t, g;
            return g = {
                next: verb(0),
                "throw": verb(1),
                "return": verb(2)
            }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                return this;
            }), g;
            function verb(n) {
                return function(v) {
                    return step([
                        n,
                        v
                    ]);
                };
            }
            function step(op) {
                if (f) throw new TypeError("Generator is already executing.");
                while(_)try {
                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                    if (y = 0, t) op = [
                        op[0] & 2,
                        t.value
                    ];
                    switch(op[0]){
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return {
                                value: op[1],
                                done: false
                            };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [
                                0
                            ];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [
                        6,
                        e
                    ];
                    y = 0;
                } finally{
                    f = t = 0;
                }
                if (op[0] & 5) throw op[1];
                return {
                    value: op[0] ? op[1] : void 0,
                    done: true
                };
            }
        };
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.Types = exports.getUserFeedbackScriptUrl = void 0;
        var core_1 = src;
        var util_1 = util;
        var onerror_1 = onerror;
        var onunhandledrejection_1 = __importDefault(onunhandledrejection);
        var breadcrumbs_1 = __importDefault(breadcrumbs);
        var timers_1 = __importDefault(timers);
        var event_listeners_1 = __importDefault(event_listeners);
        var transport_1 = transport;
        var merge = core_1.Util.merge, filter = core_1.Util.filter, objectIsExtensible = core_1.Util.objectIsExtensible;
        var getProjectRoot = function() {
            var global = (0, util_1.globalThisOrWindow)();
            var projectRoot = '';
            // Cloudflare workers do not have access to location API.
            if (global.location != null) projectRoot = global.location.protocol + '//' + global.location.host;
            return projectRoot;
        };
        var getUserFeedbackScriptUrl = function(version) {
            var majorMinorVersion = version.split('.').slice(0, 2).join('.');
            return "https://js.honeybadger.io/v".concat(majorMinorVersion, "/honeybadger-feedback-form.js");
        };
        exports.getUserFeedbackScriptUrl = getUserFeedbackScriptUrl;
        var Honeybadger = /** @class */ function(_super) {
            __extends(Honeybadger, _super);
            function Honeybadger(opts) {
                if (opts === void 0) opts = {};
                var _this = _super.call(this, __assign({
                    userFeedbackEndpoint: 'https://api.honeybadger.io/v2/feedback',
                    async: true,
                    maxErrors: null,
                    projectRoot: getProjectRoot()
                }, opts), new transport_1.BrowserTransport()) || this;
                /** @internal */ _this.__errorsSent = 0;
                /** @internal */ _this.__lastWrapErr = undefined;
                /** @internal */ _this.__lastNoticeId = undefined;
                /** @internal */ _this.__beforeNotifyHandlers = [
                    function(notice) {
                        if (_this.__exceedsMaxErrors()) {
                            _this.logger.debug('Dropping notice: max errors exceeded', notice);
                            return false;
                        }
                        if (notice && !notice.url && typeof document !== 'undefined') notice.url = document.URL;
                        _this.__incrementErrorsCount();
                        return true;
                    }
                ];
                _this.__afterNotifyHandlers = [
                    function(_error, notice) {
                        if (notice) _this.__lastNoticeId = notice.id;
                        return true;
                    }
                ];
                return _this;
            }
            Honeybadger.prototype.configure = function(opts) {
                if (opts === void 0) opts = {};
                return _super.prototype.configure.call(this, opts);
            };
            Honeybadger.prototype.resetMaxErrors = function() {
                return this.__errorsSent = 0;
            };
            Honeybadger.prototype.factory = function(opts) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return new Honeybadger(opts);
            };
            Honeybadger.prototype.checkIn = function(_id) {
                throw new Error('Honeybadger.checkIn() is not supported on the browser');
            };
            Honeybadger.prototype.showUserFeedbackForm = function(options) {
                if (options === void 0) options = {};
                return __awaiter(this, void 0, void 0, function() {
                    var global, script;
                    return __generator(this, function(_a) {
                        if (!this.config || !this.config.apiKey) {
                            this.logger.debug('Client not initialized');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (!this.__lastNoticeId) {
                            this.logger.debug("Can't show user feedback form without a notice already reported");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        global = (0, util_1.globalThisOrWindow)();
                        if (typeof global.document === 'undefined') {
                            this.logger.debug('global.document is undefined. Cannot attach script');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (this.isUserFeedbackScriptUrlAlreadyVisible()) {
                            this.logger.debug('User feedback form is already visible');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        global['honeybadgerUserFeedbackOptions'] = __assign(__assign({}, options), {
                            apiKey: this.config.apiKey,
                            endpoint: this.config.userFeedbackEndpoint,
                            noticeId: this.__lastNoticeId
                        });
                        script = global.document.createElement('script');
                        script.setAttribute('src', this.getUserFeedbackSubmitUrl());
                        script.setAttribute('async', 'true');
                        if (options.onLoad) script.onload = options.onLoad;
                        (global.document.head || global.document.body).appendChild(script);
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            };
            Honeybadger.prototype.isUserFeedbackScriptUrlAlreadyVisible = function() {
                var global = (0, util_1.globalThisOrWindow)();
                var feedbackScriptUrl = this.getUserFeedbackSubmitUrl();
                for(var i = 0; i < global.document.scripts.length; i++){
                    var script = global.document.scripts[i];
                    if (script.src === feedbackScriptUrl) return true;
                }
                return false;
            };
            Honeybadger.prototype.getUserFeedbackSubmitUrl = function() {
                return (0, exports.getUserFeedbackScriptUrl)(this.getVersion());
            };
            /** @internal */ Honeybadger.prototype.__buildPayload = function(notice) {
                var cgiData = {
                    HTTP_USER_AGENT: undefined,
                    HTTP_REFERER: undefined,
                    HTTP_COOKIE: undefined
                };
                cgiData.HTTP_USER_AGENT = navigator.userAgent;
                if (typeof document !== 'undefined' && document.referrer.match(/\S/)) cgiData.HTTP_REFERER = document.referrer;
                var cookiesObject;
                if (typeof notice.cookies === 'string') cookiesObject = (0, util_1.decodeCookie)(notice.cookies);
                else cookiesObject = notice.cookies;
                if (cookiesObject) cgiData.HTTP_COOKIE = (0, util_1.encodeCookie)(filter(cookiesObject, this.config.filters));
                var payload = _super.prototype.__buildPayload.call(this, notice);
                payload.request.cgi_data = merge(cgiData, payload.request.cgi_data);
                return payload;
            };
            /**
		     * wrap always returns the same function so that callbacks can be removed via
		     * removeEventListener.
		     * @internal
		     */ Honeybadger.prototype.__wrap = function(f, opts) {
                if (opts === void 0) opts = {};
                var func = f;
                if (!opts) opts = {};
                try {
                    if (typeof func !== 'function') return func;
                    if (!objectIsExtensible(func)) return func;
                    if (!func.___hb) {
                        // eslint-disable-next-line @typescript-eslint/no-this-alias
                        var client_1 = this;
                        func.___hb = function() {
                            if (util_1.preferCatch) try {
                                // eslint-disable-next-line prefer-rest-params
                                return func.apply(this, arguments);
                            } catch (err) {
                                if (client_1.__lastWrapErr === err) throw err;
                                client_1.__lastWrapErr = err;
                                (0, onerror_1.ignoreNextOnError)();
                                client_1.addBreadcrumb(opts.component ? "".concat(opts.component, ": ").concat(err.name) : err.name, {
                                    category: 'error',
                                    metadata: {
                                        message: err.message,
                                        name: err.name,
                                        stack: err.stack
                                    }
                                });
                                if (client_1.config.enableUncaught) client_1.notify(err);
                                throw err;
                            }
                            else // eslint-disable-next-line prefer-rest-params
                            return func.apply(this, arguments);
                        };
                    }
                    func.___hb.___hb = func.___hb;
                    return func.___hb;
                } catch (_e) {
                    return func;
                }
            };
            /** @internal */ Honeybadger.prototype.__incrementErrorsCount = function() {
                return this.__errorsSent++;
            };
            /** @internal */ Honeybadger.prototype.__exceedsMaxErrors = function() {
                return this.config.maxErrors && this.__errorsSent >= this.config.maxErrors;
            };
            return Honeybadger;
        }(core_1.Client);
        var core_2 = src;
        Object.defineProperty(exports, "Types", {
            enumerable: true,
            get: function() {
                return core_2.Types;
            }
        });
        exports.default = new Honeybadger({
            __plugins: [
                (0, onerror_1.onError)(),
                (0, onunhandledrejection_1.default)(),
                (0, timers_1.default)(),
                (0, event_listeners_1.default)(),
                (0, breadcrumbs_1.default)()
            ]
        });
    })(browser$1);
    var browser = /*@__PURE__*/ getDefaultExportFromCjs(browser$1);
    return browser;
});

},{}],"hSEi5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadDocumentAssociations", ()=>loadDocumentAssociations);
parcelHelpers.export(exports, "saveDocumentAssociation", ()=>saveDocumentAssociation);
parcelHelpers.export(exports, "deleteDocumentAssociation", ()=>deleteDocumentAssociation);
parcelHelpers.export(exports, "loadDocumentTypes", ()=>loadDocumentTypes);
parcelHelpers.export(exports, "saveDocumentType", ()=>saveDocumentType);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _documentSlice = require("../slices/DocumentSlice");
var _userSlice = require("../slices/UserSlice");
async function loadDocumentAssociations(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Documents/v1/document-associations', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _documentSlice.addDocumentAssociations)(items));
}
async function saveDocumentAssociation(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Documents/v1/save-document-association', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else //delete new_item.items;
    //delete new_item.payments;
    //dispatch(addDocumentAssociation(new_item));
    return new_item;
    return null;
}
async function deleteDocumentAssociation(api_url, id, token) {
    const form_data = new FormData();
    form_data.set('id', id);
    let response = await fetch(api_url + 'Documents/v1/delete-document-association', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let response_json = await response.json();
    if (response_json.error_code !== undefined) response_json.error_code;
    return null;
}
async function loadDocumentTypes(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Documents/v1/document-types', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _documentSlice.addDocumentTypes)(items));
}
async function saveDocumentType(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Documents/v1/save-document-type', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else //delete new_item.items;
    //delete new_item.payments;
    //dispatch(addDocumentAssociation(new_item));
    return new_item;
    return null;
}

},{"js-cookie":"2d7Fe","../slices/DocumentSlice":"6gdAm","../slices/UserSlice":"ikKoo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bvSNl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
class WaitFiscalVerificationDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.state = {
            show_print_without_eor_button: false
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState) {
        const invoice = this.props.invoices[this.props.id_invoice];
        const fiscal_verification = invoice.id_invoice_fiscal_verification === undefined || invoice.id_invoice_fiscal_verification === null ? null : this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification];
        if (fiscal_verification !== null && fiscal_verification !== undefined) {
            if (fiscal_verification.status === true && fiscal_verification.signed_zoi !== null && fiscal_verification.eor !== null) this.props.closeWaitFiscalVerificationDialog(true);
            else if (fiscal_verification.signed_zoi !== null) {
                if (!this.state.show_print_without_eor_button) setTimeout(()=>{
                    if (!this._ismounted) return;
                    this.setState({
                        show_print_without_eor_button: true
                    });
                }, 4000);
            }
        }
    }
    render() {
        const invoice = this.props.invoices[this.props.id_invoice];
        const fiscal_verification = invoice.id_invoice_fiscal_verification === undefined || invoice.id_invoice_fiscal_verification === null ? null : this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification];
        const getStatus = (status)=>{
            if (status === null) return "v po\u0161iljanju";
            else if (status) return 'potrjeno';
            return 'napaka pri potrjevanju';
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: false,
            onClose: ()=>this.props.closeWaitFiscalVerificationDialog(false),
            className: "wait-fiscal-confirmation-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "\u010Cakanje na potrditev"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeWaitFiscalVerificationDialog(false)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "wait-fiscal-confirmation-dialog-body-wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "h-1",
                                children: fiscal_verification !== undefined && fiscal_verification !== null && fiscal_verification.status !== null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ProgressBar), {
                                    animate: true,
                                    intent: "warning",
                                    className: "h-1"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_BODY,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "wait-fiscal-confirmation-dialog-body",
                                    children: [
                                        fiscal_verification === undefined || fiscal_verification === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: "Stanje:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: getStatus(fiscal_verification.status)
                                                })
                                            ]
                                        }),
                                        fiscal_verification === undefined || fiscal_verification === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: "ZOI:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: fiscal_verification.signed_zoi
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: "EOR:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: fiscal_verification.eor
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: fiscal_verification === undefined || fiscal_verification === null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).DANGER,
                                            onClick: ()=>this.props.closeWaitFiscalVerificationDialog(false),
                                            children: "Zapri brez \u010Dakanja"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                fiscal_verification.eor !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    intent: (0, _core.Intent).PRIMARY,
                                                    onClick: ()=>this.props.closeWaitFiscalVerificationDialog(true),
                                                    children: "Natisni"
                                                }) : !this.state.show_print_without_eor_button ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    intent: (0, _core.Intent).WARNING,
                                                    onClick: ()=>this.props.closeWaitFiscalVerificationDialog(true),
                                                    children: "Natisni brez EOR"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    intent: (0, _core.Intent).WARNING,
                                                    onClick: ()=>this.props.closeWaitFiscalVerificationDialog(false),
                                                    children: "Zapri brez tiskanja"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
}
function mapStateToProps(state) {
    return {
        invoices: state.BusinessSlice.invoices,
        invoice_fiscal_verifications: state.BusinessSlice.invoice_fiscal_verifications,
        invoice_fiscal_verifications_by_id_invoice: state.BusinessSlice.invoice_fiscal_verifications_by_id_invoice
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(WaitFiscalVerificationDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d7VsE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const InvoiceCreator = {
    CreateInvoiceFromInitialData: (initialData)=>{
        return Object.assign({
            id_invoice: null,
            reverse_invoice: false,
            draft: true,
            invoice_number: '',
            invoice_number_internal: '',
            id_customer: null,
            invoice_date: null,
            invoice_type: null,
            note: '',
            payment_date: null,
            reference: '',
            reservation: '',
            service_date_end: null,
            service_date_start: null,
            invoice_amount: 0,
            id_cash_register: null,
            advance_payment_amount: 0,
            credit_note_type: null,
            paid: false,
            items: [],
            payments: []
        }, initialData);
    },
    CreateInvoiceItemFromInitialData: (initialData)=>{
        return Object.assign({
            id_invoice_item: null,
            description: '',
            discount: 0,
            id_item: null,
            id_item_price_list: null,
            id_tax_rate: null,
            item_measuring_unit_code: '',
            item_measuring_unit_decimal_digit_count: 0,
            price: 0,
            quantity: 0,
            tax_rate: 0,
            approved_percent: 100,
            item_type: null,
            item_ean: '',
            item_title: '',
            ord: 0,
            taxable: 'taxable',
            item_internal_code: ''
        }, initialData);
    },
    CreateInvoicePaymentFromInitialData: (initialData)=>{
        return Object.assign({
            id_invoice_payment: null,
            id_payment_type: null,
            amount: 0,
            payment_date: null
        }, initialData);
    },
    Duplicate: (item)=>InvoiceCreator.deepCopy(item),
    /**
	 * Deep copy an object (make copies of all its object properties, sub-properties, etc.)
	 * An improved version of http://keithdevens.com/weblog/archive/2007/Jun/07/javascript.clone
	 * that doesn't break if the constructor has required parameters
	 * 
	 * It also borrows some code from http://stackoverflow.com/a/11621004/560114
	 */ deepCopy: (src, /* INTERNAL */ _visited, _copiesVisited)=>{
        if (src === null || typeof src !== 'object') return src;
        //Honor native/custom clone methods
        if (typeof src.clone == 'function') return src.clone(true);
        //Special cases:
        //Date
        if (src instanceof Date) return new Date(src.getTime());
        //RegExp
        if (src instanceof RegExp) return new RegExp(src);
        //DOM Element
        if (src.nodeType && typeof src.cloneNode == 'function') return src.cloneNode(true);
        // Initialize the visited objects arrays if needed.
        // This is used to detect cyclic references.
        if (_visited === undefined) {
            _visited = [];
            _copiesVisited = [];
        }
        // Check if this object has already been visited
        var i, len = _visited.length;
        for(i = 0; i < len; i++){
            // If so, get the copy we already made
            if (src === _visited[i]) return _copiesVisited[i];
        }
        //Array
        if (Object.prototype.toString.call(src) == '[object Array]') {
            //[].slice() by itself would soft clone
            var ret = src.slice();
            //add it to the visited array
            _visited.push(src);
            _copiesVisited.push(ret);
            var i = ret.length;
            while(i--)ret[i] = InvoiceCreator.deepCopy(ret[i], _visited, _copiesVisited);
            return ret;
        }
        //If we've reached here, we have a regular object
        //make sure the returned object has the same prototype as the original
        var proto = Object.getPrototypeOf ? Object.getPrototypeOf(src) : src.__proto__;
        if (!proto) proto = src.constructor.prototype; //this line would probably only be reached by very old browsers 
        var dest = Object.create(proto);
        //add this object to the visited array
        _visited.push(src);
        _copiesVisited.push(dest);
        for(var key in src)//Note: this does NOT preserve ES5 property attributes like 'writable', 'enumerable', etc.
        //For an example of how this could be modified to do so, see the singleMixin() function
        dest[key] = InvoiceCreator.deepCopy(src[key], _visited, _copiesVisited);
        return dest;
    }
};
exports.default = InvoiceCreator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ep63y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const DocumentsHelper = {
    GetDocuments: (document_associations, id_document, max_depth, depth)=>{
        depth = depth || 1;
        let items = {};
        if (depth > max_depth) return items;
        let documents = Object.values(document_associations[id_document] || {});
        for(let i = 0; i < documents.length; i++){
            let item = documents[i];
            let curr_id_document = item.source_id_document;
            let curr_from_id_document = item.target_id_document;
            let document_type = item.source_type;
            if (item.source_id_document == id_document) {
                curr_id_document = item.target_id_document;
                curr_from_id_document = item.source_id_document;
                document_type = item.target_type;
            }
            if (items[item.id_document_association] === undefined) items[item.id_document_association] = {
                id_document_association: item.id_document_association,
                created: item.created,
                id_document: curr_id_document,
                from_document: curr_from_id_document,
                document_type
            };
            const subitems = DocumentsHelper.GetDocuments(document_associations, curr_id_document, max_depth, depth + 1);
            for(let id_document_association in subitems)if (items[id_document_association] === undefined) items[id_document_association] = subitems[id_document_association];
        }
        return items;
    },
    GetDocumentsForReservationAndCustomer: (document_associations, id_reservation, id_reservation_customer)=>{
        let items = {
            reservation_documents: {},
            customer_documents: {}
        };
        const reservation_documents = DocumentsHelper.GetDocuments(document_associations, id_reservation, 1);
        const customer_documents = DocumentsHelper.GetDocuments(document_associations, id_reservation_customer, 1);
        const reservation_documents_by_id_document = {};
        for(let id_document_association in reservation_documents){
            const doc = reservation_documents[id_document_association];
            const id_document = doc.source_type == 'reservation' ? doc.target_id_document : doc.source_id_document;
            reservation_documents_by_id_document[id_document] = doc;
        }
        for(let id_document_association in customer_documents){
            const doc = customer_documents[id_document_association];
            const id_document = doc.source_type == 'reservation' ? doc.target_id_document : doc.source_id_document;
            if (reservation_documents_by_id_document[id_document] !== undefined) {
                items.reservation_documents[id_document_association] = reservation_documents[id_document_association];
                items.customer_documents[id_document_association] = doc;
            }
        }
        return items;
    }
};
exports.default = DocumentsHelper;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5UvH1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _textWithTooltip = require("./TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _resultComponents = require("./code_tables/ResultComponents");
var _utils = require("../utils");
function Results(props) {
    const uppercase_search_value = props.search_value.toUpperCase();
    const start_date_iso = props.start_date === null ? null : (0, _momentDefault.default)(props.start_date).format('YYYY-MM-DD');
    const end_date_iso = props.end_date === null ? null : (0, _momentDefault.default)(props.end_date).format('YYYY-MM-DD');
    // find invoices
    const selected_invoice_types = Array.isArray(props.enabled_invoices_types) ? props.enabled_invoices_types : [];
    const found_invoices = props.enabled_invoices_types === false || Array.isArray(props.enabled_invoices_types) && props.enabled_invoices_types.length == 0 ? [] : Object.values(props.invoices).filter((item)=>{
        if (selected_invoice_types.length > 0 && selected_invoice_types.indexOf(item.invoice_type) == -1) return false;
        const issued_iso = item.issued === null ? null : (0, _momentDefault.default)(item.issued).format('YYYY-MM-DD');
        if (start_date_iso !== null && end_date_iso !== null && (issued_iso === null || issued_iso < start_date_iso || issued_iso > end_date_iso)) return false;
        const customer = item.id_customer === null ? null : props.customers[item.id_customer];
        return item.invoice_number_internal.toUpperCase().indexOf(uppercase_search_value) != -1 || customer !== null && (customer.internal_code.toString().indexOf(props.search_value) != -1 || (customer.surname + ' ' + customer.name + ' ' + customer.company_name).toUpperCase().indexOf(uppercase_search_value) != -1);
    });
    // find reservations
    const found_reservations = !props.reservations_enabled ? [] : Object.values(props.reservations).filter((item)=>{
        const check_in_iso = item.check_in === null ? null : (0, _momentDefault.default)(item.check_in).format('YYYY-MM-DD');
        const check_out_iso = item.check_out === null ? null : (0, _momentDefault.default)(item.check_out).format('YYYY-MM-DD');
        if (start_date_iso !== null && end_date_iso !== null && (check_in_iso === null || check_out_iso === null || check_out_iso < start_date_iso || check_in_iso > end_date_iso)) return false;
        const customer = item.id_customer === null ? null : props.customers[item.id_customer];
        return item.internal_code.toUpperCase().indexOf(uppercase_search_value) != -1 || customer !== null && (customer.internal_code.toString().indexOf(props.search_value) != -1 || (customer.surname + ' ' + customer.name + ' ' + customer.company_name).toUpperCase().indexOf(uppercase_search_value) != -1);
    });
    // find delivery notes
    const found_delivery_notes = !props.delivery_notes_enabled ? [] : Object.values(props.delivery_notes).filter((item)=>{
        const document_date_iso = item.document_date === null ? null : (0, _momentDefault.default)(item.document_date).format('YYYY-MM-DD');
        if (start_date_iso !== null && end_date_iso !== null && (document_date_iso === null || document_date_iso < start_date_iso || document_date_iso > end_date_iso)) return false;
        return item.document_number.toUpperCase().indexOf(uppercase_search_value) != -1;
    });
    if (found_invoices.length + found_reservations.length == 0 + found_delivery_notes.length) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: "Ni rezultatov"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            found_invoices.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvoiceResults, {
                invoices: found_invoices,
                customers: props.customers,
                selectItem: props.selectItem
            }),
            found_reservations.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReservationResults, {
                reservations: found_reservations,
                customers: props.customers,
                accommodation_item_place_titles: props.accommodation_item_place_titles,
                countries: props.countries,
                selectItem: props.selectItem
            }),
            found_delivery_notes.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeliveryNoteResults, {
                items: found_delivery_notes,
                customers: props.customers,
                selectItem: props.selectItem
            })
        ]
    });
}
function InvoiceResults(props) {
    const toLocalStringWithTime = (date)=>{
        if (date === null) return '';
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear() + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');
    };
    const invoice_types = {
        'cash-invoice': {
            title: "Blagajni\u0161ki ra\u010Dun"
        },
        'cash-prepayment-invoice': {
            title: "Ra\u010Dun za predpla\u010Dilo"
        },
        'invoice': {
            title: 'Faktura'
        },
        'prepayment-invoice': {
            title: "Avansni ra\u010Dun"
        },
        'credit-note': {
            title: 'Dobropis'
        },
        'offer': {
            title: 'Ponudba'
        },
        'cash-register-invoice-income': {
            title: 'cash-register-invoice-income'
        },
        'cash-register-invoice-outlay': {
            title: 'cash-register-invoice-outlay'
        },
        'cash-register-journal': {
            title: 'cash-register-journal'
        },
        'gift-voucher': {
            title: 'gift-voucher'
        },
        'stock-acquisition': {
            title: 'stock-acquisition'
        },
        'stock-delivery-document': {
            title: 'stock-delivery-document'
        },
        'warehouse-transfer-order': {
            title: 'warehouse-transfer-order'
        },
        'delivery-report': {
            title: 'delivery-report'
        },
        'sales-invoice-book': {
            title: 'sales-invoice-book'
        },
        'proforma-invoice-book': {
            title: 'proforma-invoice-book'
        },
        'guest-book': {
            title: 'guest-book'
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-thin text-lg mt-5 mb-5",
                children: "RA\u010CUNI"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "document-search-invoices-list",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "results",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 1,
                                title: "\u0160t. ra\u010Duna"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 2,
                                title: "\u0160ifra"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 3,
                                title: "Naziv stranke"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 4,
                                title: "Datum ra\u010Duna"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 5,
                                title: "Vrsta dokumenta"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 6,
                                title: "Znesek"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 7,
                                title: ""
                            }),
                            Object.values(props.invoices).map((item)=>{
                                const issued = item.issued === null ? null : new Date(item.issued);
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 1,
                                            child: item.draft ? 'osnutek' : item.invoice_number_internal
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 2,
                                            child: props.customers[item.id_customer] === undefined ? '' : props.customers[item.id_customer].internal_code
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 3,
                                            child: props.customers[item.id_customer] === undefined ? '' : props.customers[item.id_customer].type == 'natural' ? props.customers[item.id_customer].surname + ' ' + props.customers[item.id_customer].name : props.customers[item.id_customer].company_name
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 4,
                                            child: toLocalStringWithTime(issued)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 5,
                                            child: invoice_types[item.invoice_type] === undefined ? item.invoice_type : invoice_types[item.invoice_type].title
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 6,
                                            cls: "text-right font-bold col-invoice-amount",
                                            child: (item.reversed ? '[S] ' : '') + (item.invoice_type == 'prepayment-invoice' ? parseFloat(item.advance_payment_amount) : parseFloat(item.invoice_amount) - parseFloat(item.advance_payment_amount)).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            }) + ' EUR'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 7,
                                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                className: 'cell-button',
                                                onClick: ()=>{
                                                    props.selectItem(item.id_invoice, item.invoice_type);
                                                },
                                                icon: "tick",
                                                small: true,
                                                children: "Izberi"
                                            })
                                        })
                                    ]
                                }, 'result-' + item.id_invoice);
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function ReservationResults(props) {
    const toLocalString = (date)=>{
        if (date === null || date === undefined) return '';
        if (!(date instanceof Date)) return date;
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
    };
    const statuses = {
        'new': {
            title: 'Nova',
            key: 'new'
        },
        'waiting-for-confirmation': {
            title: 'V potrjevanju',
            key: 'waiting-for-confirmation'
        },
        'offer-sent': {
            title: 'Izdana ponudba',
            key: 'offer-sent'
        },
        'confirmed': {
            title: 'Potrjena',
            key: 'confirmed'
        },
        'advance-invoice-sent': {
            title: 'Izdan avans',
            key: 'advance-invoice-sent'
        },
        'closed': {
            title: "Pla\u010Dana",
            key: 'closed'
        },
        'reversed': {
            title: 'Stornirana',
            key: 'reversed'
        },
        'no-show': {
            title: 'Neprihod',
            key: 'no-show'
        },
        'not-for-rent': {
            title: 'Ni za oddajo',
            key: 'not-for-rent'
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-thin text-lg mt-5 mb-5",
                children: "REZERVACIJE"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "document-search-reservations-list",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "results",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 1,
                                title: "Objekt"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 2,
                                title: "Status"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 3,
                                title: "\u0160ifra"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 4,
                                title: "Nosilec"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 5,
                                title: "Dr\u017Eava"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 6,
                                title: "Prihod"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 7,
                                title: "Odhod"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 8,
                                title: ""
                            }),
                            Object.values(props.reservations).map((item)=>{
                                const customer = item.id_customer === null || props.customers[item.id_customer] === undefined ? null : props.customers[item.id_customer];
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 1,
                                            child: props.accommodation_item_place_titles[item.id_accommodation_item_place]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 2,
                                            child: statuses[item.status].title
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 3,
                                            child: item.internal_code
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 4,
                                            child: customer === null ? null : customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 5,
                                            child: customer === null ? null : customer.id_country === null || props.countries[customer.id_country] === undefined ? null : props.countries[customer.id_country].iso_3166_1_a2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 6,
                                            child: toLocalString(new Date(item.check_in))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 7,
                                            child: toLocalString(new Date(item.check_out))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 8,
                                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                className: 'cell-button',
                                                onClick: ()=>{
                                                    props.selectItem(item.id_reservation, 'reservation');
                                                },
                                                icon: "tick",
                                                small: true,
                                                children: "Izberi"
                                            })
                                        })
                                    ]
                                }, 'result-' + item.id_reservation);
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function DeliveryNoteResults(props) {
    const toLocalString = (date)=>{
        if (date === null || date === undefined) return '';
        if (!(date instanceof Date)) return date;
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
    };
    const types = {
        'delivery': 'Dobavnica',
        'return': "Vra\u010Dilo v zalogo"
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-thin text-lg mt-5 mb-5",
                children: "DOBAVNICE"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "document-search-delivery-note-list",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "results",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 1,
                                title: "\u0160t. dobavnice"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 2,
                                title: "\u0160ifra"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 3,
                                title: "Naziv stranke"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 4,
                                title: "Datum dobavnice"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 5,
                                title: "Vrsta dobavnice"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 6,
                                title: ""
                            }),
                            Object.values(props.items).map((item)=>{
                                const customer = item.id_customer === null || props.customers[item.id_customer] === undefined ? null : props.customers[item.id_customer];
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 1,
                                            child: item.document_number
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 2,
                                            child: customer === null ? null : customer.internal_code
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 3,
                                            child: customer === null ? null : customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 4,
                                            child: toLocalString(new Date(item.document_date))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 5,
                                            child: types[item.type]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 6,
                                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                className: 'cell-button',
                                                onClick: ()=>{
                                                    props.selectItem(item.id_delivery_note, 'delivery-note');
                                                },
                                                icon: "tick",
                                                small: true,
                                                children: "Izberi"
                                            })
                                        })
                                    ]
                                }, 'result-' + item.id_delivery_note);
                            })
                        ]
                    })
                })
            })
        ]
    });
}
class DocumentSearchDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.toggleEnabledType = this.toggleEnabledType.bind(this);
        this.toggleEnabledInvoiceType = this.toggleEnabledInvoiceType.bind(this);
        this.generateAccommodationItemPlaceTitles = this.generateAccommodationItemPlaceTitles.bind(this);
        this.state = {
            search_value: '',
            search_value_applied: '',
            enabled_type_all: true,
            enabled_types: [],
            enabled_invoice_types: [],
            start_date: (0, _momentDefault.default)().subtract(3, 'month').toDate(),
            end_date: (0, _momentDefault.default)().toDate()
        };
        this._search_timeout = null;
    }
    toLocalString(date) {
        if (date === null || date === undefined) return '';
        if (!(date instanceof Date)) return date;
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
    }
    toggleEnabledType(type, checked) {
        const enabled_types = this.state.enabled_types;
        if (checked && enabled_types.indexOf(type) == -1) enabled_types.push(type);
        else if (!checked && enabled_types.indexOf(type) != -1) enabled_types.splice(enabled_types.indexOf(type), 1);
        this.setState({
            enabled_type_all: false,
            enabled_types
        });
    }
    toggleEnabledInvoiceType(type, checked) {
        const enabled_invoice_types = this.state.enabled_invoice_types;
        if (checked && enabled_invoice_types.indexOf(type) == -1) enabled_invoice_types.push(type);
        else if (!checked && enabled_invoice_types.indexOf(type) != -1) enabled_invoice_types.splice(enabled_invoice_types.indexOf(type), 1);
        this.setState({
            enabled_type_all: false,
            enabled_invoice_types
        });
    }
    generateAccommodationItemPlaceTitles(accommodations, accommodation_items, accommodation_item_places) {
        const accommodation_item_place_titles = {};
        if (accommodations !== null && accommodation_items !== null && accommodation_item_places !== null) {
            for(let id_accommodation in accommodations)for(let id_accommodation_item in accommodation_items){
                if (accommodation_items[id_accommodation_item].id_accommodation != id_accommodation) continue;
                for(let id_accommodation_item_place in accommodation_item_places){
                    if (accommodation_item_places[id_accommodation_item_place].id_accommodation_item != id_accommodation_item) continue;
                    let title = accommodations[id_accommodation].title + " \u2022 ";
                    if (accommodation_items[id_accommodation_item].title != 'default') title += accommodation_items[id_accommodation_item].title + " \u2022 ";
                    title += accommodation_item_places[id_accommodation_item_place].title;
                    accommodation_item_place_titles[id_accommodation_item_place] = title;
                }
            }
        }
        return accommodation_item_place_titles;
    }
    render() {
        //TODO cache this?
        const accommodation_item_place_titles = this.generateAccommodationItemPlaceTitles(this.props.accommodations, this.props.accommodation_items, this.props.accommodation_item_places);
        const limit_document_types = this.props.limit_document_types || [];
        let enabled_invoice_types = this.state.enabled_invoice_types;
        let enabled_types = this.state.enabled_types;
        let enabled_type_all = this.state.enabled_type_all;
        if (limit_document_types.length > 0) {
            enabled_invoice_types = enabled_type_all ? limit_document_types : enabled_invoice_types.filter((x)=>limit_document_types.indexOf(x) > -1);
            enabled_types = enabled_type_all ? limit_document_types.filter((x)=>x == 'enabled_types') : enabled_types.filter((x)=>limit_document_types.indexOf(x) > -1);
            enabled_type_all = false;
        }
        const short_year = false;
        const formatDatePattern = short_year === true ? 'dd. MM. yy' : 'dd. MM. yyyy';
        let placeholderFrom = '01. 01. ' + new Date().getFullYear();
        let placeholderUntil = '31. 12. ' + new Date().getFullYear();
        if (short_year) {
            placeholderFrom = placeholderFrom.substring(0, placeholderFrom.length - 2);
            placeholderUntil = placeholderUntil.substring(0, placeholderUntil.length - 2);
        }
        console.log({
            enabled_types
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>{
                this.props.closeDialog();
            },
            className: "document-search-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col h-full",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Iskanje dokumenta"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>{
                                        this.props.closeDialog();
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-row h-full box-border",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "bg-gray-300 p-4 box-border left-side",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "search-input",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: "Iskalni niz",
                                                    tooltip: "\u0160t. ra\u010Duna, \u0161t. rezervacije, itd"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                    id: "search-input",
                                                    value: this.state.search_value,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            search_value: event.target.value
                                                        });
                                                        if (this._search_timeout !== null) clearTimeout(this._search_timeout);
                                                        this._search_timeout = setTimeout(()=>{
                                                            this.setState({
                                                                search_value_applied: this.state.search_value
                                                            });
                                                        }, 500);
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex flex-row filter-date-range",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                        className: "flex-1",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: formatDatePattern,
                                                        locale: "sl",
                                                        inputProps: {
                                                            placeholder: placeholderFrom
                                                        },
                                                        popoverProps: {
                                                            position: 'left'
                                                        },
                                                        selectAllOnFocus: true,
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                        onChange: (selectedDate, isUserChange)=>{
                                                            if (isUserChange) this.setState({
                                                                start_date: selectedDate === null ? null : new Date(selectedDate)
                                                            });
                                                        },
                                                        value: this.state.start_date === null ? null : (0, _formatISODefault.default)(this.state.start_date)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                        className: "flex-1",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: formatDatePattern,
                                                        locale: "sl",
                                                        inputProps: {
                                                            placeholder: placeholderUntil
                                                        },
                                                        popoverProps: {
                                                            position: 'right'
                                                        },
                                                        selectAllOnFocus: true,
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                        onChange: (selectedDate, isUserChange)=>{
                                                            if (isUserChange) this.setState({
                                                                end_date: selectedDate
                                                            });
                                                        },
                                                        value: this.state.end_date === null ? null : (0, _formatISODefault.default)(this.state.end_date)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: this.state.enabled_type_all,
                                            label: "Vse",
                                            onChange: (event)=>{
                                                if (!event.target.checked) return; // can't unselect all
                                                this.setState({
                                                    enabled_type_all: true,
                                                    enabled_types: [],
                                                    enabled_invoice_types: []
                                                });
                                            }
                                        }),
                                        limit_document_types.length > 0 && limit_document_types.indexOf('reservations') == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: enabled_types.indexOf('reservations') != -1,
                                            label: "Rezervacija",
                                            className: "mt-6 mb-6",
                                            onChange: (event)=>this.toggleEnabledType('reservations', event.target.checked)
                                        }),
                                        limit_document_types.length > 0 && limit_document_types.indexOf('delivery_notes') == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: enabled_types.indexOf('delivery_notes') != -1,
                                            label: "Dobavnica",
                                            className: "mt-6 mb-6",
                                            onChange: (event)=>this.toggleEnabledType('delivery_notes', event.target.checked)
                                        }),
                                        [
                                            {
                                                key: 'cash-invoice',
                                                title: "Blagajni\u0161ki ra\u010Dun"
                                            },
                                            {
                                                key: 'cash-prepayment-invoice',
                                                title: "Ra\u010Dun za predpla\u010Dilo"
                                            },
                                            {
                                                key: 'invoice',
                                                title: 'Faktura'
                                            },
                                            {
                                                key: 'prepayment-invoice',
                                                title: "Avansni ra\u010Dun"
                                            },
                                            {
                                                key: 'credit-note',
                                                title: 'Dobropis'
                                            },
                                            {
                                                key: 'offer',
                                                title: 'Ponudba'
                                            }
                                        ].map((invoice_type)=>limit_document_types.length > 0 && limit_document_types.indexOf(invoice_type.key) == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                checked: enabled_invoice_types.indexOf(invoice_type.key) != -1,
                                                label: invoice_type.title,
                                                onChange: (event)=>this.toggleEnabledInvoiceType(invoice_type.key, event.target.checked)
                                            }, 'filter-invoice-type--' + invoice_type.key))
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex-1 p-4 box-border overflow-y-auto",
                                    children: this.state.search_value_applied.length < 3 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "Vnesi iskalni niz"
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                        search_value: this.state.search_value_applied,
                                        start_date: this.state.start_date,
                                        end_date: this.state.end_date,
                                        enabled_invoices_types: enabled_type_all || enabled_invoice_types,
                                        reservations_enabled: enabled_type_all || enabled_types.indexOf('reservations') != -1,
                                        delivery_notes_enabled: enabled_type_all || enabled_types.indexOf('delivery_notes') != -1,
                                        invoices: this.props.invoices,
                                        customers: this.props.customers,
                                        reservations: this.props.reservations,
                                        delivery_notes: this.props.delivery_notes,
                                        accommodation_item_place_titles: accommodation_item_place_titles,
                                        countries: this.props.countries,
                                        selectItem: this.props.closeDialog
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
DocumentSearchDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func
};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        invoices: state.BusinessSlice.invoices,
        reservations: state.ReservationSlice.reservations,
        accommodations: state.CodeTablesSlice.accommodations,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
        countries: state.CodeTablesSlice.countries,
        delivery_notes: state.WarehouseSlice.delivery_notes
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(DocumentSearchDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","moment":"1e4qG","date-fns/formatISO":"an1FA","./TextWithTooltip":"6kuHH","./code_tables/ResultComponents":"1eVlZ","../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1eVlZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResultHeader", ()=>ResultHeader);
parcelHelpers.export(exports, "ResultHeaderWithSort", ()=>ResultHeaderWithSort);
parcelHelpers.export(exports, "Result", ()=>Result);
parcelHelpers.export(exports, "MultiSelectFilter", ()=>MultiSelectFilter);
parcelHelpers.export(exports, "DateRangeFilter", ()=>DateRangeFilter);
parcelHelpers.export(exports, "DateFilter", ()=>DateFilter);
parcelHelpers.export(exports, "TextFilter", ()=>TextFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _utils = require("../../utils");
function ResultHeader(props) {
    const { cls, title, columnIdx, columnSpan, rowIdx } = props;
    let style = {};
    let css = 'results-table-header-col ' + (cls || '');
    if (columnIdx !== undefined) {
        style.gridColumn = columnIdx + ' / ' + (columnIdx + (columnSpan || 1));
        css += ' col-' + columnIdx;
    }
    style.gridRow = rowIdx || 1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: css,
        style: style,
        children: title
    });
}
function ResultHeaderWithSort(props) {
    const { cls, title, columnIdx, columnSpan, rowIdx, fieldName, setTableItemsSort, tableItemsSortField, tableItemsSortDirection } = props;
    let style = {};
    let css = 'results-table-header-col sortable ' + (cls || '');
    if (columnIdx !== undefined) {
        style.gridColumn = columnIdx + ' / ' + (columnIdx + (columnSpan || 1));
        css += ' col-' + columnIdx;
    }
    if (rowIdx !== undefined) style.gridRow = rowIdx;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: css,
        style: style,
        onClick: ()=>{
            setTableItemsSort(fieldName);
        },
        children: [
            title,
            tableItemsSortField != fieldName ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                icon: 'caret-' + (tableItemsSortDirection == 'ASC' ? 'up' : 'down'),
                color: "#888888"
            })
        ]
    });
}
function Result(props) {
    const { columnIdx, rowIdx, child, cls, span } = props;
    let style = {};
    let css = 'results-table-col ' + (cls || '');
    if (columnIdx !== undefined) {
        style.gridColumn = columnIdx + ' / ' + (columnIdx + (span === undefined ? 1 : span));
        css += ' col-' + columnIdx;
    }
    if (rowIdx !== undefined) style.gridRow = rowIdx;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: css,
        style: style,
        children: child === undefined ? null : child
    });
}
class MultiSelectFilter extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            popover_open: false
        };
    }
    render() {
        let display_items = Object.values(this.props.items);
        if (this.props.displayFilter !== null && this.props.displayFilter !== undefined) display_items = display_items.filter(this.props.displayFilter);
        if (this.props.displaySort !== null && this.props.displaySort !== undefined) display_items = display_items.sort(this.props.displaySort);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Popover), {
                    onClose: (e)=>{
                        if (e !== undefined && e.currentTarget !== undefined && e.currentTarget.className !== undefined && e.currentTarget.className.indexOf('bp5-popover') != -1) return;
                        this.setState({
                            popover_open: false
                        });
                    },
                    isOpen: this.state.popover_open,
                    position: "bottom",
                    minimal: true,
                    className: 'multiselect-button-wrapper ' + (this.props.full_width ?? false ? 'w-full' : ''),
                    popoverClassName: "limit-height",
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Menu), {
                        children: display_items.map((x)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                className: "bp5-menu-item-horizontal",
                                icon: this.props.filtered_keys.indexOf(x[this.props.value_field]) != -1 ? 'tick' : 'square',
                                text: x[this.props.title_field],
                                onClick: ()=>{
                                    const new_keys = [
                                        ...this.props.filtered_keys
                                    ];
                                    const idx = new_keys.indexOf(x[this.props.value_field]);
                                    if (idx == -1) new_keys.push(x[this.props.value_field]);
                                    else new_keys.splice(idx, 1);
                                    this.props.onFilterChange(new_keys);
                                }
                            }, x[this.props.value_field]))
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                        fill: true,
                        small: this.props.small ?? true ? true : this.props.small,
                        onClick: ()=>this.setState({
                                popover_open: true
                            }),
                        disabled: this.props.disabled || false,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "multiselect-button",
                            children: this.props.filtered_keys.length == 0 ? this.props.empty_title : this.props.filtered_keys.map((x)=>this.props.items[x] === undefined ? '' : this.props.items[x][this.props.title_field]).join(', ')
                        })
                    })
                }),
                this.props.hide_close_button ?? false ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                    icon: "cross",
                    small: this.props.small ?? true ? true : this.props.small,
                    disabled: this.props.disabled || false,
                    onClick: ()=>{
                        this.props.onFilterChange([]);
                    }
                })
            ]
        });
    }
}
function DateRangeFilter(props) {
    const { filter_values, short_year, original_start_date, original_end_date, min_date, onFilterChange, hideReset } = props;
    const disableFrom = props.disabled || false || props.disable_from || false;
    const disableUntil = props.disabled || false || props.disable_until || false;
    const formatDatePattern = short_year === true ? 'dd. MM. yy' : 'dd. MM. yyyy';
    const parseDatePatterns = [
        'DD.MM.YYYY',
        'DD.M.YYYY',
        'D.MM.YYYY',
        'D.M.YYYY',
        'DD. MM. YYYY',
        'D. MM. YYYY',
        'DD. M. YYYY',
        'D. M. YYYY',
        'DD. MM. YY',
        'D. MM. YY',
        'DD. M. YY',
        'D. M. YY'
    ];
    let placeholderFrom = '01. 01. ' + new Date().getFullYear();
    let placeholderUntil = '31. 12. ' + new Date().getFullYear();
    if (short_year) {
        placeholderFrom = placeholderFrom.substring(0, placeholderFrom.length - 2);
        placeholderUntil = placeholderUntil.substring(0, placeholderUntil.length - 2);
    }
    console.log({
        filter_values
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-row filter-date-range",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                className: "flex-1",
                dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                dateFnsFormat: formatDatePattern,
                locale: "sl",
                inputProps: {
                    placeholder: placeholderFrom
                },
                popoverProps: {
                    position: 'left'
                },
                selectAllOnFocus: true,
                minDate: new Date(min_date || '1900-01-01'),
                maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                onChange: (selectedDate, isUserChange)=>{
                    if (isUserChange) onFilterChange([
                        (0, _momentDefault.default)(selectedDate).toDate(),
                        filter_values[1]
                    ]);
                },
                parseDate: (str, localeCode)=>{
                    const d = (0, _momentDefault.default)(str, parseDatePatterns, true);
                    if (d.isValid()) return d.toDate();
                    return null;
                },
                value: filter_values[0] === null || isNaN(filter_values[0]) ? null : (0, _formatISODefault.default)(filter_values[0]),
                disabled: disableFrom
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                className: "flex-1",
                dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                dateFnsFormat: formatDatePattern,
                locale: "sl",
                inputProps: {
                    placeholder: placeholderUntil
                },
                popoverProps: {
                    position: 'right'
                },
                selectAllOnFocus: true,
                minDate: new Date('1900-01-01'),
                maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                onChange: (selectedDate, isUserChange)=>{
                    console.log({
                        selectedDate
                    });
                    if (isUserChange) onFilterChange([
                        filter_values[0],
                        (0, _momentDefault.default)(selectedDate).toDate()
                    ]);
                },
                parseDate: (str, localeCode)=>{
                    const d = (0, _momentDefault.default)(str, parseDatePatterns, true);
                    if (d.isValid()) return d.toDate();
                    return null;
                },
                value: filter_values[1] === null || isNaN(filter_values[1]) ? null : (0, _formatISODefault.default)(filter_values[1]),
                disabled: disableUntil
            }),
            hideReset || false ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                icon: "cross",
                small: true,
                disabled: props.disabled || false,
                onClick: ()=>{
                    onFilterChange([
                        original_start_date === undefined ? null : original_start_date,
                        original_end_date === undefined ? null : original_end_date
                    ]);
                }
            })
        ]
    });
}
function DateFilter(props) {
    const { filter_value, short_year, original_date, onFilterChange } = props;
    const formatDatePattern = short_year === true ? 'dd. MM. yy' : 'dd. MM. yyyy';
    const parseDatePatterns = [
        'DD.MM.YYYY',
        'DD.M.YYYY',
        'D.MM.YYYY',
        'D.M.YYYY',
        'DD. MM. YYYY',
        'D. MM. YYYY',
        'DD. M. YYYY',
        'D. M. YYYY',
        'DD. MM. YY',
        'D. MM. YY',
        'DD. M. YY',
        'D. M. YY'
    ];
    let placeholderFrom = '01. 01. ' + new Date().getFullYear();
    if (short_year) placeholderFrom = placeholderFrom.substring(0, placeholderFrom.length - 2);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-row filter-date-range",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                className: "flex-1",
                dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                dateFnsFormat: formatDatePattern,
                locale: "sl",
                inputProps: {
                    placeholder: placeholderFrom
                },
                popoverProps: {
                    position: 'left'
                },
                selectAllOnFocus: true,
                minDate: new Date('1900-01-01'),
                maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                onChange: (selectedDate, isUserChange)=>{
                    if (isUserChange) onFilterChange((0, _momentDefault.default)(selectedDate).toDate());
                },
                parseDate: (str, localeCode)=>{
                    const d = (0, _momentDefault.default)(str, parseDatePatterns, true);
                    if (d.isValid()) return d.toDate();
                    return null;
                },
                value: filter_value === null || isNaN(filter_value) ? null : (0, _formatISODefault.default)(filter_value),
                disabled: props.disabled || false
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                icon: "cross",
                small: true,
                disabled: props.disabled || false,
                onClick: ()=>{
                    onFilterChange(original_date === undefined ? null : original_date);
                }
            })
        ]
    });
}
function TextFilter(props) {
    const { value, onChange } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
        value: value,
        onChange: onChange,
        fill: true,
        rightElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
            icon: "cross",
            minimal: true,
            onClick: ()=>{
                onChange('');
            }
        }),
        disabled: props.disabled || false
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","moment":"1e4qG","date-fns/formatISO":"an1FA","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","../../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jffQW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const Invoice = {
    groupInvoiceItemsByTaxes: (invoice, id_advance_invoice_consumption_by_id_consumer_invoices, advance_invoice_consumptions)=>{
        let amount_factor = 1;
        // with prepayment invoices, we need to calculate amounts from advance_payment_amount
        if (invoice.invoice_type == 'cash-prepayment-invoice' || invoice.invoice_type == 'prepayment-invoice') amount_factor = invoice.invoice_amount == 0 ? 0 : invoice.advance_payment_amount / invoice.invoice_amount;
        // taxes
        let invoice_items_by_tax_rate = {};
        for(let i = 0; i < invoice.items.length; i++){
            const invoice_item = invoice.items[i];
            const item_price = invoice_item.price * amount_factor; // calculate using reduced price
            const partial_price = invoice_item.quantity * item_price;
            const partial_price_discounted = partial_price * (1 - invoice_item.discount / 100);
            const full_price = invoice_item.quantity * invoice_item.price;
            const full_price_discounted = full_price * (1 - invoice_item.discount / 100);
            let key = invoice_item.tax_rate;
            if (invoice_item.taxable == 'nontaxable') key = -2;
            else if (invoice_item.taxable == 'tax-exempt') key = -1;
            if (invoice_items_by_tax_rate[key] === undefined) invoice_items_by_tax_rate[key] = {
                tax_rate: invoice_item.tax_rate,
                partial_price: 0,
                partial_price_discounted_without_tax: 0,
                partial_price_tax_amount: 0,
                partial_price_discounted: 0,
                partial_price_without_tax: 0,
                full_price: 0,
                full_price_discounted_without_tax: 0,
                full_price_tax_amount: 0,
                full_price_discounted: 0,
                full_price_without_tax: 0
            };
            invoice_items_by_tax_rate[key].partial_price += partial_price;
            invoice_items_by_tax_rate[key].partial_price_discounted += partial_price_discounted;
            invoice_items_by_tax_rate[key].full_price += full_price;
            invoice_items_by_tax_rate[key].full_price_discounted += full_price_discounted;
        }
        // remove already paid taxes via advance invoices
        if (invoice.invoice_type != 'cash-prepayment-invoice' && invoice.invoice_type != 'prepayment-invoice') {
            const id_advance_invoice_consumptions = id_advance_invoice_consumption_by_id_consumer_invoices[invoice.id_invoice] || [];
            for(let i = 0; i < id_advance_invoice_consumptions.length; i++){
                const advance_invoice_consumption = advance_invoice_consumptions[id_advance_invoice_consumptions[i]];
                for(let j = 0; j < advance_invoice_consumption.taxes.length; j++){
                    const tax = advance_invoice_consumption.taxes[j];
                    const price = parseFloat(tax.amount);
                    const total_amount = parseFloat(tax.amount);
                    let key = tax.tax_rate;
                    if (tax.taxable == 'nontaxable') key = -2;
                    else if (tax.taxable == 'tax-exempt') key = -1;
                    if (invoice_items_by_tax_rate[key] === undefined) invoice_items_by_tax_rate[key] = {
                        tax_rate: tax.tax_rate,
                        partial_price: 0,
                        partial_price_discounted_without_tax: 0,
                        partial_price_tax_amount: 0,
                        partial_price_discounted: 0,
                        partial_price_without_tax: 0,
                        full_price: 0,
                        full_price_discounted_without_tax: 0,
                        full_price_tax_amount: 0,
                        full_price_discounted: 0,
                        full_price_without_tax: 0
                    };
                    invoice_items_by_tax_rate[key].partial_price -= price;
                    invoice_items_by_tax_rate[key].partial_price_discounted -= total_amount;
                }
            }
        }
        let invoice_items_taxes_sums = [
            0,
            0,
            0,
            0,
            0
        ];
        for(let key in invoice_items_by_tax_rate){
            invoice_items_by_tax_rate[key].partial_price_discounted_without_tax = invoice_items_by_tax_rate[key].partial_price_discounted / (1 + invoice_items_by_tax_rate[key].tax_rate / 100);
            invoice_items_by_tax_rate[key].partial_price_tax_amount = invoice_items_by_tax_rate[key].partial_price_discounted - invoice_items_by_tax_rate[key].partial_price_discounted_without_tax;
            invoice_items_by_tax_rate[key].partial_price_without_tax = invoice_items_by_tax_rate[key].partial_price / (1 + invoice_items_by_tax_rate[key].tax_rate / 100);
            invoice_items_by_tax_rate[key].full_price_discounted_without_tax = invoice_items_by_tax_rate[key].full_price_discounted / (1 + invoice_items_by_tax_rate[key].tax_rate / 100);
            invoice_items_by_tax_rate[key].full_price_tax_amount = invoice_items_by_tax_rate[key].full_price_discounted - invoice_items_by_tax_rate[key].full_price_discounted_without_tax;
            invoice_items_by_tax_rate[key].full_price_without_tax = invoice_items_by_tax_rate[key].full_price / (1 + invoice_items_by_tax_rate[key].tax_rate / 100);
            invoice_items_taxes_sums[0] += invoice_items_by_tax_rate[key].full_price_discounted_without_tax;
            invoice_items_taxes_sums[1] += invoice_items_by_tax_rate[key].full_price_tax_amount;
            invoice_items_taxes_sums[2] += invoice_items_by_tax_rate[key].full_price_discounted;
            invoice_items_taxes_sums[3] += invoice_items_by_tax_rate[key].full_price_without_tax;
            invoice_items_taxes_sums[4] += invoice_items_by_tax_rate[key].full_price_without_tax - invoice_items_by_tax_rate[key].full_price_discounted_without_tax;
            invoice_items_by_tax_rate[key].partial_price = Math.properRound(invoice_items_by_tax_rate[key].partial_price, 2);
            invoice_items_by_tax_rate[key].partial_price_discounted_without_tax = Math.properRound(invoice_items_by_tax_rate[key].partial_price_discounted_without_tax, 2);
            invoice_items_by_tax_rate[key].partial_price_tax_amount = Math.properRound(invoice_items_by_tax_rate[key].partial_price_tax_amount, 2);
            invoice_items_by_tax_rate[key].partial_price_discounted = Math.properRound(invoice_items_by_tax_rate[key].partial_price_discounted, 2);
            invoice_items_by_tax_rate[key].partial_price_without_tax = Math.properRound(invoice_items_by_tax_rate[key].partial_price_without_tax, 2);
            invoice_items_by_tax_rate[key].full_price = Math.properRound(invoice_items_by_tax_rate[key].full_price, 2);
            invoice_items_by_tax_rate[key].full_price_discounted_without_tax = Math.properRound(invoice_items_by_tax_rate[key].full_price_discounted_without_tax, 2);
            invoice_items_by_tax_rate[key].full_price_tax_amount = Math.properRound(invoice_items_by_tax_rate[key].full_price_tax_amount, 2);
            invoice_items_by_tax_rate[key].full_price_discounted = Math.properRound(invoice_items_by_tax_rate[key].full_price_discounted, 2);
            invoice_items_by_tax_rate[key].full_price_without_tax = Math.properRound(invoice_items_by_tax_rate[key].full_price_without_tax, 2);
        }
        invoice_items_taxes_sums[0] = Math.properRound(invoice_items_taxes_sums[0], 2);
        invoice_items_taxes_sums[1] = Math.properRound(invoice_items_taxes_sums[1], 2);
        invoice_items_taxes_sums[2] = Math.properRound(invoice_items_taxes_sums[2], 2);
        invoice_items_taxes_sums[3] = Math.properRound(invoice_items_taxes_sums[3], 2);
        invoice_items_taxes_sums[4] = Math.properRound(invoice_items_taxes_sums[4], 2);
        return {
            invoice_items_by_tax_rate,
            invoice_items_taxes_sums
        };
    },
    findCurrentIdWarehouse: (cash_register, warehouses)=>{
        if (cash_register !== null && cash_register !== undefined) return cash_register.id_warehouse;
        for(let id_warehouse in warehouses){
            const warehouse = warehouses[id_warehouse];
            if (warehouse.default_warehouse) return warehouse.id_warehouse;
        }
        return null;
    }
};
exports.default = Invoice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"91cdD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const PriceHelper = {
    FindBestPriceListMatch: (date, price_lists)=>{
        // find active (i.e. valid_until is null or larger than date) price list
        //   with most current valid_from (but not larger than date)
        let target_date = (0, _momentDefault.default)(date).format('YYYY-MM-DD');
        let curr_valid_from = null;
        let curr_id_item_price_list = null;
        for(let id_item_price_list in price_lists){
            const valid_from = price_lists[id_item_price_list].valid_from;
            const valid_until = price_lists[id_item_price_list].valid_until;
            if (valid_from <= target_date && (valid_until === null || valid_until >= target_date) && (curr_valid_from === null || valid_from >= curr_valid_from)) {
                curr_valid_from = valid_from;
                curr_id_item_price_list = id_item_price_list;
            }
        }
        return curr_id_item_price_list;
    },
    // when changing this function, change it in Reservations.php as well
    FindBestUserWorkTypeMatch: (date, id_user, id_work_type, user_work_types)=>{
        // find active (i.e. valid_until is null or larger than date) item
        //   with most current valid_from (but not larger than date)
        let target_date = (0, _momentDefault.default)(date).format('YYYY-MM-DD');
        let curr_valid_from = null;
        let curr_id_user_work_type = null;
        for(let id_user_work_type in user_work_types){
            const item = user_work_types[id_user_work_type];
            const valid_from = item.valid_from;
            const valid_until = item.valid_until;
            if (item.id_user != id_user || item.id_work_type != id_work_type) continue;
            if (valid_from <= target_date && (valid_until === null || valid_until >= target_date) && (curr_valid_from === null || valid_from >= curr_valid_from)) {
                curr_valid_from = valid_from;
                curr_id_user_work_type = id_user_work_type;
            }
        }
        return curr_id_user_work_type;
    },
    // when changing this function, change it in Reservations.php as well
    FindBestUserDailyLogbookActivityMatch: (date, id_user, id_daily_logbook_activity, user_daily_logbook_activities)=>{
        // find active (i.e. valid_until is null or larger than date) item
        //   with most current valid_from (but not larger than date)
        let target_date = (0, _momentDefault.default)(date).format('YYYY-MM-DD');
        let curr_valid_from = null;
        let curr_id_user_daily_logbook_activity = null;
        for(let id_user_daily_logbook_activity in user_daily_logbook_activities){
            const item = user_daily_logbook_activities[id_user_daily_logbook_activity];
            const valid_from = item.valid_from;
            const valid_until = item.valid_until;
            if (item.id_user != id_user || item.id_daily_logbook_activity != id_daily_logbook_activity) continue;
            if (valid_from <= target_date && (valid_until === null || valid_until >= target_date) && (curr_valid_from === null || valid_from >= curr_valid_from)) {
                curr_valid_from = valid_from;
                curr_id_user_daily_logbook_activity = id_user_daily_logbook_activity;
            }
        }
        return curr_id_user_daily_logbook_activity;
    }
};
exports.default = PriceHelper;

},{"moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iymP9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _numbers = require("../../numbers");
class SplitPaymentDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.changeValue = this.changeValue.bind(this);
        this.preparePayments = this.preparePayments.bind(this);
        this.reformat = this.reformat.bind(this);
        const payments = {};
        for(let i = 0; i < this.props.payments.length; i++)payments[this.props.payments[i].id_payment_type] = this.props.payments[i];
        const values = {};
        for(const id_payment_type in props.payment_types){
            let value = 0;
            if (payments[id_payment_type] !== undefined) value = parseFloat(payments[id_payment_type].amount);
            values[id_payment_type] = {
                value,
                formatted: this.formatNumber(value)
            };
        }
        this.state = {
            payments,
            values,
            values_as_percents: false
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.values_as_percents != prevState.values_as_percents) {
            const values = this.state.values;
            if (this.state.values_as_percents) for(const id_payment_type in values){
                values[id_payment_type].value = this.props.total_value == 0 ? 0 : values[id_payment_type].value / this.props.total_value * 100;
                values[id_payment_type].formatted = this.formatNumber(values[id_payment_type].value);
            }
            else for(const id_payment_type in values){
                values[id_payment_type].value = values[id_payment_type].value / 100 * this.props.total_value;
                values[id_payment_type].formatted = this.formatNumber(values[id_payment_type].value);
            }
            this.setState({
                values
            });
        }
    }
    reformat() {
        const values = this.state.values;
        for(const id_payment_type in values)values[id_payment_type].formatted = this.formatNumber(values[id_payment_type].value);
        this.setState({
            values
        });
    }
    changeValue(val, field_id_payment_type, type) {
        const values = this.state.values;
        if (type == 'formatted') {
            let parsed_val = (0, _numbers.parseFloatLocal)(val);
            if (!Object.is(parsed_val, NaN)) values[field_id_payment_type].value = parsed_val;
            values[field_id_payment_type].formatted = val;
        } else if (type == 'value') {
            values[field_id_payment_type].value = val;
            values[field_id_payment_type].formatted = this.formatNumber(val);
        }
        for(const id_payment_type in values)if (id_payment_type != field_id_payment_type) values[id_payment_type].formatted = this.formatNumber(values[id_payment_type].value);
        this.setState({
            values
        });
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    preparePayments() {
        const payments = [];
        for(const id_payment_type in this.state.values){
            let value = this.state.values[id_payment_type].value;
            if (value == 0) continue;
            if (this.state.values_as_percents) value = value / 100 * this.props.total_value;
            const id_invoice_payment = this.state.payments[id_payment_type] === undefined ? null : this.state.payments[id_payment_type].id_invoice_payment;
            payments.push({
                id_invoice_payment,
                id_payment_type,
                amount: value,
                payment_date: null
            });
        }
        return payments;
    }
    render() {
        const number_of_columns = 3;
        const sum = Math.properRound(Object.values(this.state.values).map((x)=>x.value).reduce((acc, curr)=>acc + curr), 2);
        let total_value = 0;
        if (this.state.values_as_percents) total_value = 100;
        else total_value = this.props.total_value;
        total_value = Math.properRound(total_value, 2);
        const valid = sum == total_value;
        const payment_types = Object.values(this.props.payment_types).filter((x)=>x.visible).sort((a, b)=>{
            return a.ord - b.ord;
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>{
                this.props.closeDialog();
            },
            className: "select-price-list-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Deljeno pla\u010Dilo"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>{
                                        this.props.closeDialog();
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: 'grid grid-cols-' + number_of_columns + ' gap-2',
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                        label: "Vnos v procentih",
                                        checked: this.state.values_as_percents,
                                        onChange: (event)=>{
                                            this.setState({
                                                values_as_percents: event.target.checked
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'col-span-' + (number_of_columns - 1) + ' ' + 'text-right ' + (valid ? 'text-green-600' : 'text-red-600'),
                                    children: this.formatNumber(sum) + ' / ' + this.formatNumber(total_value) + ' ' + (this.state.values_as_percents ? '%' : 'EUR') + ' (' + this.formatNumber(Math.properRound(total_value - sum, 2)) + ')'
                                }),
                                payment_types.map((payment_type)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        labelFor: 'split-payment-dialog--' + payment_type.id_payment_type,
                                        className: 'flex-1 ' /*+
									(this.state.validation_failed_fields.indexOf('internal_code') == -1 ?
										'' : 'validation-failed')*/ ,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: this.state.values[payment_type.id_payment_type].value != 0 ? 'font-bold' : '',
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: payment_type.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                id: 'split-payment-dialog--' + payment_type.id_payment_type,
                                                value: this.state.values[payment_type.id_payment_type].formatted,
                                                onChange: (event)=>{
                                                    this.changeValue(event.target.value, payment_type.id_payment_type, 'formatted');
                                                },
                                                onBlur: this.reformat,
                                                rightElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tag), {
                                                    minimal: true,
                                                    children: this.state.values_as_percents ? "\uFF05" : 'EUR'
                                                })
                                            })
                                        ]
                                    }, 'key-split-payment-dialog--' + payment_type.id_payment_type))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>{
                                        this.props.closeDialog();
                                    },
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.preparePayments());
                                    },
                                    disabled: !valid,
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
function mapStateToProps(state) {
    return {
        payment_types: state.CodeTablesSlice.payment_types
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(SplitPaymentDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../../numbers":"jOh9w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ct2Zf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _textWithTooltip = require("./TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _resultComponents = require("./code_tables/ResultComponents");
var _dateRangePickerDialog = require("./DateRangePickerDialog");
var _dateRangePickerDialogDefault = parcelHelpers.interopDefault(_dateRangePickerDialog);
function Results(props) {
    const uppercase_search_value = props.search_value.toUpperCase();
    const start_date_iso = props.start_date === null ? null : (0, _momentDefault.default)(props.start_date).format('YYYY-MM-DD');
    const end_date_iso = props.end_date === null ? null : (0, _momentDefault.default)(props.end_date).format('YYYY-MM-DD');
    // find invoices
    let selected_invoice_types = Array.isArray(props.enabled_invoices_types) ? props.enabled_invoices_types : [];
    if (selected_invoice_types.length == 0) selected_invoice_types = [
        'cash-prepayment-invoice',
        'prepayment-invoice'
    ];
    const found_invoices = props.enabled_invoices_types === false || Array.isArray(props.enabled_invoices_types) && props.enabled_invoices_types.length == 0 ? [] : Object.values(props.invoices).filter((item)=>{
        if (selected_invoice_types.length > 0 && selected_invoice_types.indexOf(item.invoice_type) == -1) return false;
        const remaining_advance_payment_amount = parseFloat(item.advance_payment_amount) - parseFloat(item.used_advance_payment_amount);
        if (remaining_advance_payment_amount <= 0) return false;
        const issued_iso = item.issued === null ? null : (0, _momentDefault.default)(item.issued).format('YYYY-MM-DD');
        if (start_date_iso !== null && end_date_iso !== null && (issued_iso === null || issued_iso < start_date_iso || issued_iso > end_date_iso)) return false;
        if (uppercase_search_value.length == 0) return true;
        const customer = item.id_customer === null ? null : props.customers[item.id_customer];
        return item.invoice_number_internal.toUpperCase().indexOf(uppercase_search_value) != -1 || customer !== null && (customer.internal_code.toString().indexOf(props.search_value) != -1 || (customer.surname + ' ' + customer.name + ' ' + customer.company_name).toUpperCase().indexOf(uppercase_search_value) != -1);
    });
    if (found_invoices.length == 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: "Ni rezultatov"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: found_invoices.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvoiceResults, {
            invoices: found_invoices,
            customers: props.customers,
            selectItem: props.selectItem
        })
    });
}
function InvoiceResults(props) {
    const toLocalStringWithTime = (date)=>{
        if (date === null) return '';
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear() + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');
    };
    const invoice_types = {
        'cash-prepayment-invoice': {
            title: "Ra\u010Dun za predpla\u010Dilo"
        },
        'prepayment-invoice': {
            title: "Avansni ra\u010Dun"
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "document-search-prepayment-invoices-list",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: "\u0160t. ra\u010Duna"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 2,
                            title: "\u0160ifra"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 3,
                            title: "Naziv stranke"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 4,
                            title: "Datum ra\u010Duna"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 5,
                            title: "Vrsta dokumenta"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 6,
                            title: "Znesek ponudbe"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 7,
                            title: "Neporabljen znesek"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 8,
                            title: ""
                        }),
                        Object.values(props.invoices).map((item)=>{
                            const issued = item.issued === null ? null : new Date(item.issued);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        child: item.draft ? 'osnutek' : item.invoice_number_internal
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        child: props.customers[item.id_customer] === undefined ? '' : props.customers[item.id_customer].internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        child: props.customers[item.id_customer] === undefined ? '' : props.customers[item.id_customer].type == 'natural' ? props.customers[item.id_customer].surname + ' ' + props.customers[item.id_customer].name : props.customers[item.id_customer].company_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        child: toLocalStringWithTime(issued)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        child: invoice_types[item.invoice_type] === undefined ? item.invoice_type : invoice_types[item.invoice_type].title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        cls: "text-right font-bold col-invoice-amount",
                                        child: (item.reversed ? '[S] ' : '') + parseFloat(item.invoice_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) + ' EUR'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        cls: "text-right font-bold col-invoice-amount",
                                        child: (parseFloat(item.advance_payment_amount) - parseFloat(item.used_advance_payment_amount)).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) + ' EUR'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            className: 'cell-button',
                                            onClick: ()=>{
                                                props.selectItem(item.id_invoice, item.invoice_type);
                                            },
                                            icon: "tick",
                                            small: true,
                                            children: "Izberi"
                                        })
                                    })
                                ]
                            }, 'result-' + item.id_invoice);
                        })
                    ]
                })
            })
        })
    });
}
class PrepaymentDocumentSearchDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.openDateRangePickerDialog = this.openDateRangePickerDialog.bind(this);
        this.closeDateRangePickerDialog = this.closeDateRangePickerDialog.bind(this);
        this.toggleEnabledType = this.toggleEnabledType.bind(this);
        this.toggleEnabledInvoiceType = this.toggleEnabledInvoiceType.bind(this);
        this.state = {
            search_value: '',
            search_value_applied: '',
            enabled_type_all: true,
            enabled_types: [],
            enabled_invoice_types: [],
            date_range_picker_dialog_open: false,
            start_date: null,
            end_date: null
        };
        this._search_timeout = null;
    }
    openDateRangePickerDialog() {
        this.setState({
            date_range_picker_dialog_open: true
        });
    }
    closeDateRangePickerDialog(start_date, end_date) {
        this.setState({
            date_range_picker_dialog_open: false
        });
        if (end_date === null) end_date = start_date;
        if (start_date !== undefined && end_date !== undefined) this.setState({
            start_date,
            end_date
        });
    }
    toLocalString(date) {
        if (date === null || date === undefined) return '';
        if (!(date instanceof Date)) return date;
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
    }
    toggleEnabledType(type, checked) {
        const enabled_types = this.state.enabled_types;
        if (checked && enabled_types.indexOf(type) == -1) enabled_types.push(type);
        else if (!checked && enabled_types.indexOf(type) != -1) enabled_types.splice(enabled_types.indexOf(type), 1);
        this.setState({
            enabled_type_all: false,
            enabled_types
        });
    }
    toggleEnabledInvoiceType(type, checked) {
        const enabled_invoice_types = this.state.enabled_invoice_types;
        if (checked && enabled_invoice_types.indexOf(type) == -1) enabled_invoice_types.push(type);
        else if (!checked && enabled_invoice_types.indexOf(type) != -1) enabled_invoice_types.splice(enabled_invoice_types.indexOf(type), 1);
        this.setState({
            enabled_type_all: false,
            enabled_invoice_types
        });
    }
    render() {
        let enabled_invoice_types = this.state.enabled_invoice_types;
        let enabled_type_all = this.state.enabled_type_all;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>{
                this.props.closeDialog();
            },
            className: "prepayment-document-search-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col h-full",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Iskanje dokumenta"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>{
                                        this.props.closeDialog();
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: [
                            !this.state.date_range_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePickerDialogDefault.default), {
                                startValue: this.state.start_date,
                                endValue: this.state.end_date,
                                closeDialog: this.closeDateRangePickerDialog
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-row h-full box-border",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "bg-gray-300 p-4 box-border left-side",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "search-input",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Iskalni niz",
                                                        tooltip: "\u0160t. ra\u010Duna, \u0161t. rezervacije, itd"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                        id: "search-input",
                                                        value: this.state.search_value,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                search_value: event.target.value
                                                            });
                                                            if (this._search_timeout !== null) clearTimeout(this._search_timeout);
                                                            this._search_timeout = setTimeout(()=>{
                                                                this.setState({
                                                                    search_value_applied: this.state.search_value
                                                                });
                                                            }, 500);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    fill: true,
                                                    onClick: this.openDateRangePickerDialog,
                                                    children: this.state.start_date === null || this.state.end_date === null ? 'Izberi obdobje' : this.toLocalString(this.state.start_date) + " \u2194 " + this.toLocalString(this.state.end_date)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                checked: this.state.enabled_type_all,
                                                label: "Vse",
                                                onChange: (event)=>{
                                                    if (!event.target.checked) return; // can't unselect all
                                                    this.setState({
                                                        enabled_type_all: true,
                                                        enabled_types: [],
                                                        enabled_invoice_types: []
                                                    });
                                                }
                                            }),
                                            [
                                                {
                                                    key: 'cash-prepayment-invoice',
                                                    title: "Ra\u010Dun za predpla\u010Dilo"
                                                },
                                                {
                                                    key: 'prepayment-invoice',
                                                    title: "Avansni ra\u010Dun"
                                                }
                                            ].map((invoice_type)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    checked: enabled_invoice_types.indexOf(invoice_type.key) != -1,
                                                    label: invoice_type.title,
                                                    onChange: (event)=>this.toggleEnabledInvoiceType(invoice_type.key, event.target.checked)
                                                }, 'filter-invoice-type--' + invoice_type.key))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex-1 p-4 box-border overflow-y-auto",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                            search_value: this.state.search_value_applied,
                                            start_date: this.state.start_date,
                                            end_date: this.state.end_date,
                                            enabled_invoices_types: enabled_type_all || enabled_invoice_types,
                                            invoices: this.props.invoices,
                                            customers: this.props.customers,
                                            countries: this.props.countries,
                                            selectItem: this.props.closeDialog
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
PrepaymentDocumentSearchDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func
};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        invoices: state.BusinessSlice.invoices,
        countries: state.CodeTablesSlice.countries
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(PrepaymentDocumentSearchDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","moment":"1e4qG","./TextWithTooltip":"6kuHH","./code_tables/ResultComponents":"1eVlZ","./DateRangePickerDialog":"eJXAI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eJXAI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _utils = require("../utils");
class DateRangePickerDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            selectedDateStart: this.props.startValue,
            selectedDateEnd: this.props.endValue
        };
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: false,
            className: "date-range-picker-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                children: "Izbira datuma"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-grow flex-col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "self-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateRangePicker3), {
                                    dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                    dateFnsFormat: 'dd. MM. yyyy',
                                    locale: "sl",
                                    minDate: new Date('1900-01-01'),
                                    maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                    clearButtonText: "Po\u010Disti",
                                    allowSingleDayRange: true,
                                    shortcuts: false,
                                    reverseMonthAndYearMenus: true,
                                    onChange: (selectedDates)=>{
                                        //handleFilterChange('invoice_date_from', selectedDate)
                                        this.setState({
                                            selectedDateStart: selectedDates[0],
                                            selectedDateEnd: selectedDates[1]
                                        });
                                    //this.props.closeDialog(this.state.selectedDateStart, this.state.selectedDateEnd)
                                    },
                                    value: [
                                        this.state.selectedDateStart,
                                        this.state.selectedDateEnd
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>{
                                        this.props.closeDialog();
                                    },
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).DANGER,
                                    onClick: ()=>{
                                        this.props.closeDialog(null, null);
                                    },
                                    children: "Po\u010Disti"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.state.selectedDateStart, this.state.selectedDateEnd);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
DateRangePickerDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    startValue: (0, _propTypesDefault.default).object,
    endValue: (0, _propTypesDefault.default).object
};
exports.default = DateRangePickerDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","moment":"1e4qG","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aE2R5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@blueprintjs/core");
exports.default = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    const { customer, countries, editClick, clearClick } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "customer-info",
        style: {
            position: 'relative'
        },
        children: customer === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "customer-info-inner",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: (()=>{
                                const arr = [];
                                if (customer.address.length > 0) arr.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: customer.address
                                }, "address"));
                                if (customer.post_office.length > 0) arr.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: (customer.post_code + ' ' + customer.post_office).trim()
                                }, "post-office"));
                                if (customer.id_country !== null) arr.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: countries[customer.id_country].iso_3166_1_a2
                                }, "country"));
                                return arr;
                            })()
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pt-2",
                            children: customer.vat_registered ? 'ID za DDV: ' + customer.vat_prefix + customer.tax_number : "Dav\u010Dna \u0161t.: " + customer.tax_number
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "opacity-50 text-right pr-2",
                    style: {
                        position: 'absolute',
                        right: 0,
                        bottom: 0
                    },
                    children: customer.internal_code
                }),
                editClick === undefined || editClick === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        position: 'absolute',
                        right: 0,
                        top: 11
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                        icon: "edit",
                        minimal: true,
                        onClick: editClick
                    })
                }),
                clearClick === undefined || clearClick === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        position: 'absolute',
                        right: 0,
                        top: editClick === undefined || editClick === null ? 11 : 32
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                        icon: "cross",
                        minimal: true,
                        onClick: clearClick
                    })
                })
            ]
        })
    });
});

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8B3n3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadReservations", ()=>loadReservations);
parcelHelpers.export(exports, "saveActivityReservation", ()=>saveActivityReservation);
parcelHelpers.export(exports, "saveReservation", ()=>saveReservation);
parcelHelpers.export(exports, "saveReservationCustomer", ()=>saveReservationCustomer);
parcelHelpers.export(exports, "batchSaveReservationCustomer", ()=>batchSaveReservationCustomer);
parcelHelpers.export(exports, "deleteReservationCustomer", ()=>deleteReservationCustomer);
parcelHelpers.export(exports, "sendReservationCustomersToETourism", ()=>sendReservationCustomersToETourism);
parcelHelpers.export(exports, "loadActivityDailyLogbooks", ()=>loadActivityDailyLogbooks);
parcelHelpers.export(exports, "saveActivityDailyLogbook", ()=>saveActivityDailyLogbook);
parcelHelpers.export(exports, "deleteActivityDailyLogbook", ()=>deleteActivityDailyLogbook);
parcelHelpers.export(exports, "saveReservationCustomerItem", ()=>saveReservationCustomerItem);
parcelHelpers.export(exports, "saveReservationCustomerItems", ()=>saveReservationCustomerItems);
parcelHelpers.export(exports, "deleteReservationCustomerItem", ()=>deleteReservationCustomerItem);
parcelHelpers.export(exports, "loadReservationRequests", ()=>loadReservationRequests);
parcelHelpers.export(exports, "loadReservationRequestAccommodations", ()=>loadReservationRequestAccommodations);
parcelHelpers.export(exports, "changeReservationRequestStatus", ()=>changeReservationRequestStatus);
parcelHelpers.export(exports, "confirmReservationRequest", ()=>confirmReservationRequest);
parcelHelpers.export(exports, "cancelReservationRequest", ()=>cancelReservationRequest);
parcelHelpers.export(exports, "askCancelReservationRequest", ()=>askCancelReservationRequest);
parcelHelpers.export(exports, "saveReservationRequest", ()=>saveReservationRequest);
parcelHelpers.export(exports, "loadPublicAccommodations", ()=>loadPublicAccommodations);
parcelHelpers.export(exports, "loadPublicAccommodationSettings", ()=>loadPublicAccommodationSettings);
parcelHelpers.export(exports, "loadWorkerStats", ()=>loadWorkerStats);
parcelHelpers.export(exports, "saveWorkerStats", ()=>saveWorkerStats);
parcelHelpers.export(exports, "setWorkerStatsNotificationSent", ()=>setWorkerStatsNotificationSent);
parcelHelpers.export(exports, "loadActivityDailyNotes", ()=>loadActivityDailyNotes);
parcelHelpers.export(exports, "saveActivityDailyNote", ()=>saveActivityDailyNote);
parcelHelpers.export(exports, "loadWorkerNotes", ()=>loadWorkerNotes);
parcelHelpers.export(exports, "saveWorkerNote", ()=>saveWorkerNote);
parcelHelpers.export(exports, "sendDailyWorkerStatsNotification", ()=>sendDailyWorkerStatsNotification);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _reservationSlice = require("../slices/ReservationSlice");
var _userSlice = require("../slices/UserSlice");
async function loadReservations(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Reservations/v1/reservations', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else {
        dispatch((0, _reservationSlice.addReservations)(items.reservations));
        dispatch((0, _reservationSlice.addReservationCustomers)(items.reservation_customers));
        dispatch((0, _reservationSlice.addActivityReservations)(items.activity_reservations));
        dispatch((0, _reservationSlice.addActivityReservations)(items.activity_reservations));
        dispatch((0, _reservationSlice.addReservationCustomerItems)(items.reservation_customer_items));
    }
}
async function saveActivityReservation(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Reservations/v1/save-activity-reservation', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function saveReservation(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Reservations/v1/save-reservation', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function saveReservationCustomer(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Reservations/v1/save-reservation-customer', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function batchSaveReservationCustomer(api_url, items, token) {
    const form_data = new FormData();
    form_data.set('items', JSON.stringify(items));
    let response = await fetch(api_url + 'Reservations/v1/batch-save-reservation-customer', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_items = await response.json();
    if (new_items.error_code !== undefined) new_items.error_code;
    else return new_items;
    return null;
}
async function deleteReservationCustomer(api_url, id_reservation_customer, token) {
    const form_data = new FormData();
    form_data.set('id_reservation_customer', id_reservation_customer);
    let response = await fetch(api_url + 'Reservations/v1/delete-reservation-customer', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let result = await response.json();
    if (result.error_code !== undefined) result.error_code;
    else return result;
    return null;
}
async function sendReservationCustomersToETourism(api_url, id_guest_books, status, token) {
    const form_data = new FormData();
    form_data.append('status', status);
    for(let i = 0; i < id_guest_books.length; i++)form_data.append('id_guest_book[]', id_guest_books[i]);
    await fetch(api_url + 'Reservations/v1/send-reservation-customers-to-e-tourism', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
//TODO check for invalid token
}
async function loadActivityDailyLogbooks(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Reservations/v1/activity-daily-logbooks', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _reservationSlice.addActivityDailyLogbooks)(items));
}
async function saveActivityDailyLogbook(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Reservations/v1/save-activity-daily-logbook', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function deleteActivityDailyLogbook(api_url, id_activity_daily_logbook, token) {
    const form_data = new FormData();
    form_data.set('id_activity_daily_logbook', id_activity_daily_logbook);
    let response = await fetch(api_url + 'Reservations/v1/delete-activity-daily-logbook', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let result = await response.json();
    if (result.error_code !== undefined) result.error_code;
    else return result;
    return null;
}
async function saveReservationCustomerItem(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Reservations/v1/save-reservation-customer-item', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function saveReservationCustomerItems(api_url, items, token) {
    const form_data = new FormData();
    form_data.set('items', JSON.stringify(items));
    let response = await fetch(api_url + 'Reservations/v1/save-reservation-customer-items', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_items = await response.json();
    if (new_items.error_code !== undefined) new_items.error_code;
    else return new_items;
    return null;
}
async function deleteReservationCustomerItem(api_url, id_reservation_customer_item, token) {
    const form_data = new FormData();
    form_data.set('id_reservation_customer_item', id_reservation_customer_item);
    let response = await fetch(api_url + 'Reservations/v1/delete-reservation-customer-item', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let result = await response.json();
    if (result.error_code !== undefined) result.error_code;
    else return result;
    return null;
}
async function loadReservationRequests(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Reservations/v1/reservation-requests', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _reservationSlice.addReservationRequests)(items));
}
async function loadReservationRequestAccommodations(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Reservations/v1/reservation-request-accommodations', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _reservationSlice.addReservationRequestAccommodations)(items));
}
async function changeReservationRequestStatus(api_url, dispatch, token, id_reservation_requests, status) {
    const form_data = new FormData();
    form_data.set('id_reservation_requests', id_reservation_requests);
    form_data.set('status', status);
    let response = await fetch(api_url + 'Reservations/v1/change-reservation-request-status', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let result = await response.json();
    if (result.error_code !== undefined) result.error_code;
    else return result;
    return null;
}
async function confirmReservationRequest(api_url, dispatch, token, id_reservation_requests, prepayment, text) {
    const form_data = new FormData();
    form_data.set('id_reservation_requests', id_reservation_requests);
    form_data.set('prepayment', prepayment ? 'true' : 'false');
    form_data.set('text', text);
    let response = await fetch(api_url + 'Reservations/v1/confirm-reservation-request', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let result = await response.json();
    if (result.error_code !== undefined) result.error_code;
    else return result;
    return null;
}
async function cancelReservationRequest(api_url, dispatch, token, id_reservation_requests, text) {
    const form_data = new FormData();
    form_data.set('id_reservation_requests', id_reservation_requests);
    form_data.set('text', text);
    let response = await fetch(api_url + 'Reservations/v1/cancel-reservation-request', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let result = await response.json();
    if (result.error_code !== undefined) result.error_code;
    else return result;
    return null;
}
async function askCancelReservationRequest(api_url, dispatch, token, id_reservation_requests, text) {
    const form_data = new FormData();
    form_data.set('id_reservation_requests', id_reservation_requests);
    form_data.set('text', text);
    let response = await fetch(api_url + 'Reservations/v1/ask-cancel-reservation-request', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let result = await response.json();
    if (result.error_code !== undefined) result.error_code;
    else return result;
    return null;
}
async function saveReservationRequest(api_url, token, item) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Reservations/v1/save-reservation-request', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function loadPublicAccommodations(api_url, dispatch, token) {
    let response = await fetch(api_url + 'PublicReservations/v2/accommodations', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _reservationSlice.addPublicAccommodations)(items));
}
async function loadPublicAccommodationSettings(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Reservations/v1/public-accommodation-settings', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _reservationSlice.addPublicAccommodationSettings)(items));
}
async function loadWorkerStats(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Reservations/v1/worker-stats', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _reservationSlice.addWorkerStats)(items));
}
async function saveWorkerStats(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Reservations/v1/save-worker-stats', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function setWorkerStatsNotificationSent(api_url, id_worker_stats, notification_sent, token) {
    const form_data = new FormData();
    form_data.set('id_worker_stats', id_worker_stats);
    form_data.set('notification_sent', notification_sent ? 'true' : 'false');
    let response = await fetch(api_url + 'Reservations/v1/set-worker-stats-notification-sent', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
}
async function loadActivityDailyNotes(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Reservations/v1/activity-daily-notes', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _reservationSlice.addActivityDailyNotes)(items));
}
async function saveActivityDailyNote(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Reservations/v1/save-activity-daily-note', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function loadWorkerNotes(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Reservations/v1/worker-notes', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _reservationSlice.addWorkerNotes)(items));
}
async function saveWorkerNote(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Reservations/v1/save-worker-note', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function sendDailyWorkerStatsNotification(api_url, date, id_users, token) {
    const form_data = new FormData();
    form_data.set('date', date);
    form_data.set('id_users', id_users);
    let response = await fetch(api_url + 'Reservations/v1/send-daily-worker-stats-notification', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}

},{"js-cookie":"2d7Fe","../slices/ReservationSlice":"kTPna","../slices/UserSlice":"ikKoo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8327Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadGuestBookItems", ()=>loadGuestBookItems);
parcelHelpers.export(exports, "loadMonthlyGuestBookReports", ()=>loadMonthlyGuestBookReports);
parcelHelpers.export(exports, "saveMonthlyGuestBookReport", ()=>saveMonthlyGuestBookReport);
parcelHelpers.export(exports, "sendReservationCustomersToETourism", ()=>sendReservationCustomersToETourism);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _guestSlice = require("../slices/GuestSlice");
var _userSlice = require("../slices/UserSlice");
async function loadGuestBookItems(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Guests/v1/guests', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _guestSlice.addGuestBookItems)(items));
}
async function loadMonthlyGuestBookReports(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Guests/v1/monthly-guest-book-reports', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _guestSlice.addMonthlyGuestBookReports)(items));
}
async function saveMonthlyGuestBookReport(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Guests/v1/save-monthly-guest-book-report', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function sendReservationCustomersToETourism(api_url, token) {
    let response = await fetch(api_url + 'Guests/v1/send-reservation-customers-to-e-tourism', {
        method: 'post',
        body: new FormData(),
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
}

},{"js-cookie":"2d7Fe","../slices/GuestSlice":"bE5rS","../slices/UserSlice":"ikKoo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ibz2t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const ReservationHelper = {
    FindOverlappingReservation: (reservation, reservations)=>{
        let found_overlapping_reservation = null;
        for(let id_reservation in reservations){
            const existing_reservation = reservations[id_reservation];
            if (existing_reservation.id_reservation == reservation.id_reservation || existing_reservation.id_accommodation_item_place != reservation.id_accommodation_item_place || existing_reservation.status == 'reversed' || existing_reservation.status == 'no-show' || existing_reservation.deleted) continue;
            // check overlap
            if (reservation.check_in < existing_reservation.check_out && reservation.check_out > existing_reservation.check_in) {
                found_overlapping_reservation = existing_reservation;
                break;
            }
        }
        return found_overlapping_reservation;
    }
};
exports.default = ReservationHelper;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3h6Eg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@blueprintjs/core");
var _documents = require("./Documents");
var _documentsDefault = parcelHelpers.interopDefault(_documents);
function DocumentListDialog(props) {
    const { id_document, closeDialog, deep } = props;
    //const [ accommodation_is_open, setAccommodationIsOpen ] = useState([ 1 ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
        isOpen: true,
        usePortal: true,
        canOutsideClickClose: true,
        canEscapeKeyClose: true,
        onClose: closeDialog,
        className: "document-list-dialog",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col flex-grow",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                    fixedToTop: false,
                    className: "bp5-dark",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                children: "Dokumenti"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                            align: (0, _core.Alignment).RIGHT,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                minimal: true,
                                icon: "cross",
                                onClick: closeDialog
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _core.Classes).DIALOG_BODY,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentsDefault.default), {
                        id_document: id_document,
                        deep: deep,
                        hide_customer: true,
                        document_types: [
                            'invoice',
                            'cash-invoice'
                        ],
                        document_type: props.document_type
                    })
                })
            ]
        })
    });
}
exports.default = DocumentListDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@blueprintjs/core":"6Mq52","./Documents":"jYQ4x","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7MaT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _customerSelect = require("../CustomerSelect");
var _customerSelectDefault = parcelHelpers.interopDefault(_customerSelect);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _codeTables = require("../../api/CodeTables");
var _simpleSuggest = require("../SimpleSuggest");
var _simpleSuggestDefault = parcelHelpers.interopDefault(_simpleSuggest);
var _appToaster = require("../AppToaster");
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _numbers = require("../../numbers");
class AddEditItemWithCountDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.closeDialog = this.closeDialog.bind(this);
        this.state = {
            id_item: props.id_item,
            quantity: props.quantity
        };
    }
    closeDialog(id_item, quantity) {
        this.props.closeDialog(id_item, quantity);
    }
    render() {
        const item = this.state.id_item === null ? null : this.props.items[this.state.id_item];
        const id_item_price_list = item === null || this.state.date === null ? null : (0, _priceHelperDefault.default).FindBestPriceListMatch((0, _momentDefault.default)(this.props.date), item.price_lists);
        const price = id_item_price_list === null ? 0 : parseFloat(item.price_lists[id_item_price_list].price);
        console.log({
            id_item: this.state.id_item,
            item
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.closeDialog(),
            className: "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Artikli/storitve"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-grow flex-row",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-1 pr-2 flex-col",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                label: "Artikel/storitev",
                                                tooltip: "Artikel/storitev"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleSuggestDefault.default), {
                                                matchKeyName: "title_with_code",
                                                valueKeyName: "id_item",
                                                items: Object.values(this.props.items).map((item)=>{
                                                    return {
                                                        ...item,
                                                        title_with_code: item.internal_code + " \u2022 " + item.title
                                                    };
                                                }),
                                                onItemSelect: (item)=>{
                                                    this.setState({
                                                        id_item: item.id_item
                                                    });
                                                },
                                                selectedItem: this.state.id_item === null ? null : (()=>{
                                                    return {
                                                        ...this.props.items[this.state.id_item],
                                                        title_with_code: this.props.items[this.state.id_item].internal_code + " \u2022 " + this.props.items[this.state.id_item].title
                                                    };
                                                })(),
                                                placeholder: "I\u0161\u010Di"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-row justify-between items-end",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                                className: "mb-0",
                                                label: "\u0160tevilo",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ControlGroup), {
                                                    className: "mb-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            icon: "minus",
                                                            tabIndex: "-1",
                                                            minimal: false,
                                                            small: true,
                                                            onClick: ()=>{
                                                                this.setState({
                                                                    quantity: Math.max(0, parseFloat(this.state.quantity) - 1)
                                                                });
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "w-12",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                                                className: "centered-numeric-input",
                                                                fill: true,
                                                                buttonPosition: "none",
                                                                value: (0, _numbers.toLocal)(parseFloat(this.state.quantity), 0),
                                                                min: 0,
                                                                onValueChange: (val)=>{
                                                                    this.setState({
                                                                        quantity: val
                                                                    });
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            icon: "plus",
                                                            tabIndex: "-1",
                                                            minimal: false,
                                                            small: true,
                                                            onClick: ()=>{
                                                                this.setState({
                                                                    quantity: parseFloat(this.state.quantity) + 1
                                                                });
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: this.state.id_item === null ? '' : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: parseFloat(this.state.quantity) + 'x ' + (0, _numbers.toLocal)(parseFloat(price), 2) + " \u20AC = "
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "font-bold",
                                                            children: (0, _numbers.toLocal)(this.state.quantity * price, 2) + " \u20AC"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.closeDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: async ()=>{
                                        this.closeDialog(this.state.id_item, this.state.quantity);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditItemWithCountDialog.propTypes = {
    closeAddEditItemWithCountDialog: (0, _propTypesDefault.default).func,
    surname: (0, _propTypesDefault.default).string
};
function mapStateToProps(state) {
    return {
        items: state.CodeTablesSlice.items,
        api_url: state.CodeTablesSlice.api_url,
        token: state.UserSlice.token,
        client: state.ConstantsSlice.client
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddEditItemWithCountDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","uuid":"b52pV","@blueprintjs/core":"6Mq52","moment":"1e4qG","../TextWithTooltip":"6kuHH","../CustomerSelect":"8sizu","../../slices/CodeTablesSlice":"hfPGz","../../api/CodeTables":"4GMYC","../SimpleSuggest":"82Xt0","../AppToaster":"izixN","../../helpers/PriceHelper":"91cdD","../../numbers":"jOh9w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g0Iaj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PeopleCountInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@blueprintjs/core");
function PeopleCountInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                className: "mb-0",
                labelFor: "adults",
                label: props.adult_title,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ControlGroup), {
                    className: "mb-0",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            icon: "minus",
                            tabIndex: "-1",
                            minimal: false,
                            small: true,
                            onClick: ()=>{
                                props.onChangeAdultCount(Math.max(0, props.adult_count - 1));
                            },
                            disabled: props.disabled
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-12",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                id: "adults",
                                className: "centered-numeric-input",
                                fill: true,
                                disabled: props.disabled,
                                buttonPosition: "none",
                                value: props.adult_count,
                                min: 0,
                                onValueChange: (val)=>{
                                    props.onChangeAdultCount(val);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            icon: "plus",
                            tabIndex: "-1",
                            minimal: false,
                            small: true,
                            onClick: ()=>{
                                props.onChangeAdultCount(props.adult_count + 1);
                            },
                            disabled: props.disabled
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                className: "mb-0",
                labelFor: "children-2",
                label: props.child_2_title,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ControlGroup), {
                    className: "mb-0",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            icon: "minus",
                            tabIndex: "-1",
                            minimal: false,
                            small: true,
                            onClick: ()=>{
                                props.onChangeChild2Count(Math.max(0, props.child_2_count - 1));
                            },
                            disabled: props.disabled
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-12",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                id: "children-2",
                                className: "centered-numeric-input",
                                fill: true,
                                disabled: props.disabled,
                                buttonPosition: "none",
                                value: props.child_2_count,
                                min: 0,
                                onValueChange: (val)=>{
                                    props.onChangeChild2Count(val);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            icon: "plus",
                            tabIndex: "-1",
                            minimal: false,
                            small: true,
                            onClick: ()=>{
                                props.onChangeChild2Count(props.child_2_count + 1);
                            },
                            disabled: props.disabled
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                className: "mb-0",
                labelFor: "children-1",
                label: props.child_1_title,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ControlGroup), {
                    className: "mb-0",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            icon: "minus",
                            tabIndex: "-1",
                            minimal: false,
                            small: true,
                            onClick: ()=>{
                                props.onChangeChild1Count(Math.max(0, props.child_1_count - 1));
                            },
                            disabled: props.disabled
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-12",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                id: "children-1",
                                className: "centered-numeric-input",
                                fill: true,
                                disabled: props.disabled,
                                buttonPosition: "none",
                                value: props.child_1_count,
                                min: 0,
                                onValueChange: (val)=>{
                                    props.onChangeChild1Count(val);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            icon: "plus",
                            tabIndex: "-1",
                            minimal: false,
                            small: true,
                            onClick: ()=>{
                                props.onChangeChild1Count(props.child_1_count + 1);
                            },
                            disabled: props.disabled
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3S3qx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reservationSlice = require("../../slices/ReservationSlice");
var _guestSlice = require("../../slices/GuestSlice");
var _reservations = require("../../api/Reservations");
var _codeTables = require("../../api/CodeTables");
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _app = require("../../App");
const STATUSES = {
    NEW: 'new',
    WAITING_FOR_CONFIRMATION: 'waiting-for-confirmation',
    OFFER_SENT: 'offer-sent',
    CONFIRMED: 'confirmed',
    ADVANCE_INVOICE_SENT: 'advance-invoice-sent',
    CLOSED: 'closed',
    NOT_FOR_RENT: 'not-for-rent',
    NO_SHOW: 'no-show',
    REVERSED: 'reversed',
    DRAGGING: 'dragging'
};
const OFFSET_DAYS = 2;
const HOVER_STATE = {
    NONE: 0,
    ITEM_START: 1,
    ITEM_MIDDLE: 2,
    ITEM_END: 3,
    ITEM_OUTSIDE_START: 4,
    ITEM_OUTSIDE_END: 5
};
const ReservationBar = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    let { left_offset, top_offset, column_width, row_height, vertical_idx, idx_start, idx_end, status, channel, guest_count, title, status_2, is_mouse_over, dragging, guests_checked_in } = props;
    const margin_left = 2;
    const margin_top = 2;
    const margin_bottom = 0;
    let cls = 'reservation-bar status-' + status;
    if (status_2 !== null) cls += ' ' + status_2;
    if (is_mouse_over) cls += ' hover';
    if (dragging) cls += ' dragging';
    let add_border = false;
    if (guests_checked_in && [
        'new',
        'waiting-for-confirmation',
        'offer-sent',
        'confirmed',
        'advance-invoice-sent'
    ].indexOf(status) != -1) {
        cls += ' guests-checked-in';
        add_border = true;
    }
    const hide_channel = channel === undefined || channel.length == 0;
    const hide_guest_count = guest_count === undefined || guest_count.length == 0;
    let title_pos_x = 8;
    if (!hide_channel) title_pos_x += 28;
    if (!hide_guest_count) title_pos_x += 28;
    const width = column_width * Math.max(1, Math.abs(idx_end - idx_start)) - margin_left;
    const height = row_height - (margin_top + margin_bottom);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: cls,
        x: margin_left + Math.min(idx_start, idx_end) * column_width + left_offset + column_width / 2,
        y: vertical_idx * row_height + top_offset + margin_top,
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: add_border ? '2' : '0',
                y: add_border ? '2' : '0',
                width: width - (add_border ? 4 : 0),
                height: height - (add_border ? 4 : 0),
                className: 'reservation-bar-background',
                opacity: "1",
                rx: "12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: "0",
                y: "0",
                width: "100%",
                height: "100%",
                className: "reservation-bar-background-pattern",
                fill: 'url(#' + (status == STATUSES.OFFER_SENT ? 'pattern-polka-dots' : 'pattern-diagonal-stripes') + ')',
                opacity: "1",
                rx: "12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        x: "0",
                        y: "0",
                        width: "100%",
                        height: "100%",
                        opacity: "0.0"
                    }),
                    hide_channel ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                x: "8",
                                y: (row_height - 24) / 2,
                                width: "24",
                                height: "24",
                                fill: "#000000",
                                opacity: "0.2",
                                rx: "8"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                textAnchor: "middle",
                                x: "20",
                                y: row_height / 2 + 5,
                                children: channel
                            })
                        ]
                    }),
                    hide_guest_count ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                x: "36",
                                y: (row_height - 24) / 2,
                                width: "24",
                                height: "24",
                                fill: "#000000",
                                opacity: "0.2",
                                rx: "8"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                textAnchor: "middle",
                                x: "48",
                                y: row_height / 2 + 5,
                                children: guest_count
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        textAnchor: "left",
                        x: title_pos_x,
                        y: row_height / 2 + 5,
                        children: title
                    })
                ]
            }),
            status_2 === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        x: "0",
                        y: "0",
                        width: "40",
                        height: "40",
                        clipPath: "url(#reservation-bar-corner-triangle-clip)",
                        className: "custom-status-indicator",
                        rx: "12"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: 'reservation-bar-corner-triangle-clip--' + vertical_idx + '-' + idx_start + '-' + idx_end,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: 'M ' + width + ',' + (height - 20) + ' L ' + width + ',' + height + ' L ' + (width - 20) + ',' + height + ' L ' + width + ',' + (height - 20) + ' z',
                            fill: "#000000"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        x: width - 40,
                        y: height - 40,
                        width: "40",
                        height: "40",
                        clipPath: "url(#reservation-bar-corner-triangle-clip--" + vertical_idx + '-' + idx_start + '-' + idx_end + ')',
                        className: "custom-status-indicator",
                        rx: "12"
                    })
                ]
            })
        ]
    });
});
const ReservationRequestBar = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    let { left_offset, top_offset, column_width, row_height, vertical_idx, idx_start, idx_end, status, guest_count, title, is_mouse_over, dragging } = props;
    const margin_left = 2;
    const margin_top = 2;
    const margin_bottom = 0;
    let cls = 'reservation-request-bar status-' + status;
    if (is_mouse_over) cls += ' hover';
    if (dragging) cls += ' dragging';
    const hide_guest_count = guest_count === undefined || guest_count.length == 0;
    let title_pos_x = 8;
    if (!hide_guest_count) title_pos_x += 28;
    const width = column_width * Math.max(1, Math.abs(idx_end - idx_start)) - margin_left;
    const height = row_height - (margin_top + margin_bottom);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: cls,
        x: margin_left + Math.min(idx_start, idx_end) * column_width + left_offset + column_width / 2,
        y: vertical_idx * row_height + top_offset + margin_top,
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: "2",
                y: "2",
                width: width - 4,
                height: height - 4,
                className: "reservation-bar-background",
                opacity: "1",
                rx: "12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: "0",
                y: "0",
                width: "100%",
                height: "100%",
                className: "reservation-bar-background-pattern",
                fill: 'url(#' + (status == STATUSES.OFFER_SENT ? 'pattern-polka-dots' : 'pattern-diagonal-stripes') + ')',
                opacity: "1",
                rx: "12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        x: "0",
                        y: "0",
                        width: "100%",
                        height: "100%",
                        opacity: "0.0"
                    }),
                    hide_guest_count ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                x: "8",
                                y: (row_height - 24) / 2,
                                width: "24",
                                height: "24",
                                fill: "#000000",
                                opacity: "0.2",
                                rx: "8"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                textAnchor: "middle",
                                x: "20",
                                y: row_height / 2 + 5,
                                children: guest_count
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        textAnchor: "left",
                        x: title_pos_x,
                        y: row_height / 2 + 5,
                        children: title
                    })
                ]
            })
        ]
    });
});
const ConfirmReservationMoveDialog = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    let { idReservation, type, onCancel, onConfirm, items, dates, horizontalIdx, verticalIdx, offset, convertIdxToDate, convertIdxToIdAccommodationItemPlace, customers, rooms, accommodationItemPlaces, reservationCustomersByIdReservations } = props;
    const new_id_accommodation_item_place = convertIdxToIdAccommodationItemPlace(verticalIdx);
    const reservation = items[idReservation];
    let new_check_in = reservation.check_in;
    let new_check_out = reservation.check_out;
    if (type == 'move') {
        new_check_in = convertIdxToDate(dates, horizontalIdx - offset);
        new_check_out = convertIdxToDate(dates, horizontalIdx - offset + (reservation.idx_end - reservation.idx_start));
    } else if (type == 'start') new_check_in = convertIdxToDate(dates, horizontalIdx);
    else if (type == 'end') new_check_out = convertIdxToDate(dates, horizontalIdx);
    const range_source = (0, _momentDefault.default)(reservation.check_in).format('DD.MM.YYYY') + ' - ' + (0, _momentDefault.default)(reservation.check_out).format('DD.MM.YYYY');
    const range_target = (0, _momentDefault.default)(new_check_in).format('DD.MM.YYYY') + ' - ' + (0, _momentDefault.default)(new_check_out).format('DD.MM.YYYY');
    const room_title_source = accommodationItemPlaces[reservation.id_accommodation_item_place].title;
    const room_title_target = rooms[verticalIdx].title;
    const customer_name = reservation.id_customer === null || reservation.id_customer === undefined || customers[reservation.id_customer] === undefined ? '' : customers[reservation.id_customer].type == 'natural' ? customers[reservation.id_customer].surname + ' ' + customers[reservation.id_customer].name : customers[reservation.id_customer].company_name;
    const reservation_customers = reservationCustomersByIdReservations[reservation.id_reservation] || {};
    const id_reservation_customers = Object.keys(reservation_customers);
    const has_customers = id_reservation_customers.length > 0;
    let buttons = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                onClick: onCancel,
                children: "Prekli\u010Di"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                intent: "primary",
                onClick: ()=>{
                    onConfirm(idReservation, new_id_accommodation_item_place, new_check_in, new_check_out, false);
                },
                children: "Da"
            })
        ]
    });
    let additional_description = null;
    if (has_customers && range_source != range_target) {
        // if a reservation with customers is moved horizontally, customers must be sent to e-tourism
        buttons = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                    onClick: onCancel,
                    children: "Prekli\u010Di"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                    intent: "primary",
                    onClick: ()=>{
                        onConfirm(idReservation, new_id_accommodation_item_place, new_check_in, new_check_out, false);
                    },
                    children: "Spremeni obdobje rezervacije"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                    intent: "primary",
                    onClick: ()=>{
                        onConfirm(idReservation, new_id_accommodation_item_place, new_check_in, new_check_out, true);
                    },
                    children: "Spremeni obdobje in datum odjave gostov"
                })
            ]
        });
        additional_description = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "mt-4",
            children: "Ali \u017Eelite samo spremeniti obdobje rezervacije (kasneje lahko poljubno spremenite podatke o odhodih gostov) ali \u017Eelite tudi poslati spremembe datuma odhoda gostov na e-Turizem?"
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Dialog), {
        canEscapeKeyCancel: true,
        canOutsideClickCancel: true,
        isOpen: true,
        style: {
            minWidth: 580
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _core.Classes).DIALOG_BODY,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: "Sprememba rezervacije?"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                "Rezervacija: ",
                                room_title_source,
                                ", ",
                                range_source
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-3",
                            children: [
                                "Nosilec: ",
                                customer_name
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: "Sprememba:"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                "Rezervacija: ",
                                room_title_target,
                                ", ",
                                range_target
                            ]
                        }),
                        additional_description
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _core.Classes).DIALOG_FOOTER,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                    children: buttons
                })
            })
        ]
    });
});
const HeaderColumn = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    let { idx, column_width, header_height, is_first_day_of_month, is_current_date, is_today, is_hovered, day_title, day_date } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        x: idx * column_width,
        y: "0",
        width: column_width,
        children: [
            is_current_date ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: "0",
                y: "0",
                width: column_width,
                height: header_height,
                fill: "#000000",
                opacity: "0.8"
            }) : is_today ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: "0",
                y: "0",
                width: column_width,
                height: header_height,
                fill: "#000000",
                opacity: "0.5"
            }) : is_first_day_of_month ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: "0",
                y: "0",
                width: column_width,
                height: header_height,
                fill: "#e06e00",
                opacity: "0.7"
            }) : null,
            !is_hovered ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: "0",
                y: "0",
                width: column_width,
                height: header_height,
                fill: "#000000",
                opacity: "0.3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: 'M ' + (column_width - 1) + ',0 L ' + (column_width - 1) + ',' + header_height,
                stroke: "#bbbbbb",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                textAnchor: "middle",
                x: "50%",
                y: "18",
                fill: "#ffffff",
                children: day_title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                textAnchor: "middle",
                x: "50%",
                y: "36",
                fill: "#ffffff",
                children: day_date
            })
        ]
    }, 'timeline-col-' + idx);
});
class HeaderColumns extends (0, _react.PureComponent) {
    constructor(props){
        super(props);
        this.translatePositionToIndex = this.translatePositionToIndex.bind(this);
        this.translateDateToIdx = this.translateDateToIdx.bind(this);
        this.setCursor = this.setCursor.bind(this);
        let filter_index_start = this.props.filterFrom === null ? -1 : this.translateDateToIdx(this.props.filterFrom);
        let filter_index_end = this.props.filterTo === null ? -1 : this.translateDateToIdx(this.props.filterTo);
        this.state = {
            drag_hor_index_start: -1,
            drag_hor_index_end: -1,
            filter_index_start: filter_index_start,
            filter_index_end: filter_index_end
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.filterFrom != prevProps.filterFrom || this.props.filterTo != prevProps.filterTo) {
            let filter_index_start = this.props.filterFrom === null ? -1 : this.translateDateToIdx(this.props.filterFrom);
            let filter_index_end = this.props.filterTo === null ? -1 : this.translateDateToIdx(this.props.filterTo);
            this.setState({
                filter_index_start,
                filter_index_end
            });
        }
    }
    translatePositionToIndex(x) {
        const timeline_pos = this.props.timelineRef.current.getBoundingClientRect();
        const relative_x = x - timeline_pos.left - this.props.left_side_width;
        const hor_index = Math.floor(relative_x / this.props.column_width);
        return hor_index;
    }
    translateDateToIdx(date) {
        for(let i = 0; i < this.props.dates.length; i++){
            const d = this.props.dates[i][6].toDate();
            if (d.getYear() == date.getYear() && d.getMonth() == date.getMonth() && d.getDate() == date.getDate()) return i;
        }
        return -1;
    }
    setCursor(cursor) {
        this.props.timelineRef.current.style.cursor = cursor;
    }
    render() {
        const { timeline_width, header_height, left_side_width, column_width, dates, active_horizontal_idx } = this.props;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: {
                position: 'sticky',
                top: 0,
                width: timeline_width,
                height: header_height,
                zIndex: 16
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    width: timeline_width,
                    height: header_height,
                    style: {
                        backgroundColor: 'rgba(97, 127, 151, 0.8)'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                        x: left_side_width,
                        children: dates.map((item, idx)=>{
                            const is_first_day_of_month = item[2] === true;
                            const is_current_date = item[4] === true;
                            const is_today = item[5] === true;
                            const is_hovered = active_horizontal_idx == idx;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(HeaderColumn, {
                                idx,
                                column_width,
                                header_height,
                                is_first_day_of_month,
                                is_current_date,
                                is_today,
                                is_hovered,
                                day_title: item[0],
                                day_date: item[1]
                            }, 'header-column-' + item[1]);
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    style: {
                        position: 'absolute',
                        left: '0px',
                        top: '0px',
                        width: timeline_width,
                        height: header_height
                    },
                    onMouseDown: (e)=>{
                        const hor_index = this.translatePositionToIndex(e.pageX);
                        this.setState({
                            drag_hor_index_start: hor_index,
                            drag_hor_index_end: hor_index
                        });
                    },
                    onMouseMove: (e)=>{
                        const hor_index = this.translatePositionToIndex(e.pageX);
                        this.setState({
                            drag_hor_index_end: hor_index
                        });
                    },
                    onMouseUp: (e)=>{
                        const start_index = Math.min(this.state.drag_hor_index_start, this.state.drag_hor_index_end);
                        const end_index = Math.max(this.state.drag_hor_index_start, this.state.drag_hor_index_end);
                        if (end_index - start_index > 0 && dates[start_index] !== undefined && dates[end_index] !== undefined) this.props.setDateFilter(dates[start_index][6], dates[end_index][6]);
                        this.setState({
                            drag_hor_index_start: -1,
                            drag_hor_index_end: -1
                        });
                    },
                    children: [
                        this.state.filter_index_start == -1 || this.state.filter_index_end == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            x: Math.min(this.state.filter_index_start, this.state.filter_index_end) * column_width + left_side_width,
                            y: "0",
                            height: header_height,
                            width: Math.max(this.state.filter_index_start, this.state.filter_index_end) * column_width + left_side_width - (Math.min(this.state.filter_index_start, this.state.filter_index_end) * column_width + left_side_width) + column_width,
                            fill: "#00ff00",
                            opacity: "0.5",
                            rx: "10"
                        }),
                        this.state.drag_hor_index_start == -1 || this.state.drag_hor_index_end == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            x: Math.min(this.state.drag_hor_index_start, this.state.drag_hor_index_end) * column_width + left_side_width,
                            y: "0",
                            height: header_height,
                            width: Math.max(this.state.drag_hor_index_start, this.state.drag_hor_index_end) * column_width + left_side_width - (Math.min(this.state.drag_hor_index_start, this.state.drag_hor_index_end) * column_width + left_side_width) + column_width,
                            fill: "#ff0000",
                            opacity: "0.5",
                            rx: "10"
                        })
                    ]
                })
            ]
        });
    }
}
const LeftSideRow = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    let { idx, left_side_width, row_height, timeline_width, is_hovered, is_last, title, dirty_state, toggleDirty } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        x: "0",
        y: idx * row_height,
        width: left_side_width,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: 0,
                y: 0,
                width: left_side_width,
                height: row_height,
                className: 'room-dirty-background ' + dirty_state
            }),
            !is_hovered ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: 0,
                y: 0,
                width: left_side_width,
                height: row_height,
                className: "room-hover-background"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: 'M 0,1 L ' + timeline_width + ',1',
                stroke: "rgba(0, 0, 0, 0.5)",
                strokeWidth: 0.5
            }),
            !is_last ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: 'M 0,' + (row_height + 1) + ' L ' + timeline_width + ',' + (row_height + 1),
                stroke: "rgba(0, 0, 0, 0.5)",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("foreignObject", {
                x: "12",
                y: "10",
                width: left_side_width - 24 - 24,
                height: row_height - 14,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    xmlns: "http://www.w3.org/1999/xhtml",
                    style: {
                        position: 'relative',
                        height: '100%'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            position: 'absolute',
                            bottom: '0'
                        },
                        children: title
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                className: 'room-dirty-indicator ' + dirty_state,
                onClick: toggleDirty,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        x: left_side_width - 28 - 4,
                        y: (row_height - 24) / 2 + 2,
                        width: 24,
                        height: 24,
                        rx: "8",
                        className: "room-dirty-indicator--background"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                        x: left_side_width - 26 - 4,
                        y: (row_height - 20) / 2 + 2,
                        width: 20,
                        height: 20,
                        viewBox: "0 0 24 24",
                        className: "room-dirty-indicator--icon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M19.36,2.72L20.78,4.14L15.06,9.85C16.13,11.39 16.28,13.24 15.38,14.44L9.06,8.12C10.26,7.22 12.11,7.37 13.65,8.44L19.36,2.72M5.93,17.57C3.92,15.56 2.69,13.16 2.35,10.92L7.23,8.83L14.67,16.27L12.58,21.15C10.34,20.81 7.94,19.58 5.93,17.57Z"
                        })
                    })
                ]
            })
        ]
    }, 'timeline-left-col-' + idx);
});
class LeftSide extends (0, _react.PureComponent) {
    constructor(props){
        super(props);
        this.toggleRoomDirty = this.toggleRoomDirty.bind(this);
    }
    toggleRoomDirty(id_accommodation_item_place) {
        switch(this.props.accommodation_item_places[id_accommodation_item_place].state){
            case 'dirty':
                this.props.setDirtyState(id_accommodation_item_place, 'waiting');
                break;
            case 'waiting':
                this.props.setDirtyState(id_accommodation_item_place, 'clean');
                break;
            case 'clean':
                this.props.setDirtyState(id_accommodation_item_place, 'dirty');
                break;
        }
    }
    render() {
        const { left_side_width, timeline_width, timeline_height, row_height, rows, active_vertical_idx, accommodation_item_places } = this.props;
        let c = -1; // -1, so that first increment puts it at 0
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                position: 'sticky',
                left: 0,
                width: left_side_width,
                height: timeline_height,
                backgroundColor: '#f6f6f6',
                borderRight: '2px solid #bbbbbb'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                x: "0",
                y: "0",
                width: left_side_width,
                height: timeline_height,
                children: rows.map((item, idx)=>{
                    if (item === undefined) return null;
                    c++;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeftSideRow, {
                        idx: c,
                        left_side_width,
                        row_height,
                        timeline_width,
                        is_hovered: active_vertical_idx == idx,
                        is_last: idx == rows.length - 1,
                        title: item.title,
                        dirty_state: accommodation_item_places[item.id_accommodation_item_place].state,
                        toggleDirty: ()=>{
                            this.toggleRoomDirty(item.id_accommodation_item_place);
                        }
                    }, 'left-side-row-' + item.id_accommodation_item_place);
                })
            })
        });
    }
}
const HorizontalLines = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    const { header_height, timeline_width, row_height, rows } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        x: "0",
        y: header_height,
        width: timeline_width,
        children: [
            rows.map((item, idx)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    x: "0",
                    y: idx * row_height,
                    width: timeline_width,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: 'M 0,1 L ' + timeline_width + ',1',
                        stroke: "#bbbbbb",
                        strokeWidth: 0.5
                    })
                }, 'timeline-hor-line-' + idx);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                x: "0",
                y: rows.length * row_height,
                width: timeline_width,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: 'M 0,1 L ' + timeline_width + ',1',
                    stroke: "#bbbbbb",
                    strokeWidth: 0.5
                })
            }, 'timeline-hor-line-' + rows.length)
        ]
    });
});
const VerticalLines = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    const { left_side_width, timeline_width, timeline_height, column_width, header_height, dates } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        x: left_side_width,
        y: "0",
        width: timeline_width,
        children: [
            null,
            dates.map((item, idx)=>{
                const is_weekend = item[3] == 0 || item[3] == 6;
                const weekend_opacity = item[3] == 0 ? 0.15 : 0.1;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    x: idx * column_width,
                    y: "0",
                    width: column_width,
                    children: [
                        !is_weekend ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            x: "0",
                            y: "0",
                            width: column_width,
                            height: timeline_height,
                            fill: "#b71c1c",
                            opacity: weekend_opacity
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: 'M 1,0 L 1,' + timeline_height,
                            stroke: "#bbbbbb",
                            strokeWidth: 0.5
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: 'M ' + column_width / 2 + ',' + header_height + ' L ' + column_width / 2 + ',' + timeline_height,
                            stroke: "#e6e6e6",
                            strokeWidth: 0.5
                        }),
                        idx < dates.length - 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: 'M ' + (column_width - 1) + ',0 L ' + (column_width - 1) + ',' + timeline_height,
                            stroke: "#bbbbbb",
                            strokeWidth: 0.5
                        })
                    ]
                }, 'timeline-col-lines-' + idx);
            })
        ]
    });
});
const NewReservationIndicator = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    const { column_width, left_side_width, row_height, header_height, new_rect_position } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
        x: new_rect_position.hor_index * column_width + left_side_width + column_width / 2,
        y: new_rect_position.ver_index * row_height + header_height,
        width: column_width / 2,
        height: row_height,
        fill: "#617f97",
        opacity: "0.2"
    });
});
const TimelineTooltip = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    const { tooltip_open, tooltip_hidden, animation_ended, reservation, accommodation_item_place, channels, customers, general_settings } = props;
    if (reservation === null || accommodation_item_place === null) return null;
    let status_titles = [];
    switch(reservation.status){
        case STATUSES.NEW:
            status_titles.push('novo');
            break;
        case STATUSES.WAITING_FOR_CONFIRMATION:
            status_titles.push('v potrjevanju');
            break;
        case STATUSES.OFFER_SENT:
            status_titles.push('izdana ponudba');
            break;
        case STATUSES.CONFIRMED:
            status_titles.push('potrjena');
            break;
        case STATUSES.ADVANCE_INVOICE_SENT:
            status_titles.push('izdan avans');
            break;
        case STATUSES.CLOSED:
            status_titles.push("pla\u010Dana");
            break;
        case STATUSES.REVERSED:
            status_titles.push('stornirana');
            break;
        case STATUSES.NOT_FOR_RENT:
            status_titles.push('ni za oddajo');
            break;
        case STATUSES.NO_SHOW:
            status_titles.push('neprihod');
            break;
        case STATUSES.DRAGGING:
            status_titles.push('');
            break;
    }
    switch(reservation.status_2){
        case 'custom-status-1':
            status_titles.push(general_settings.title_custom_status_1);
            break;
        case 'custom-status-2':
            status_titles.push(general_settings.title_custom_status_2);
            break;
        case 'custom-status-3':
            status_titles.push(general_settings.title_custom_status_3);
            break;
        case 'custom-status-4':
            status_titles.push(general_settings.title_custom_status_4);
            break;
        case 'custom-status-5':
            status_titles.push(general_settings.title_custom_status_5);
            break;
        case 'custom-status-6':
            status_titles.push(general_settings.title_custom_status_6);
            break;
        case 'custom-status-7':
            status_titles.push(general_settings.title_custom_status_7);
            break;
    }
    const height = reservation.note.length == 0 ? 160 : 230;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: "480",
        height: height + 10,
        style: {
            filter: 'url(#timeline-tooltip-shadow)'
        },
        className: "timeline-tooltip " + (tooltip_open ? 'timeline-tooltip-visible' : 'timeline-tooltip-hidden') + ' ' + (tooltip_hidden ? 'timeline-tooltip-gone' : ''),
        onAnimationEnd: animation_ended,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: "8",
                y: "10",
                width: 464,
                height: height - 10,
                fill: "rgba(71, 94, 111, 0.8)",
                rx: "20"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                x: 230,
                y: "0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M 11,0 L 21,10 L 0,10 Z",
                    fill: "rgba(71, 94, 111, 0.8)"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("foreignObject", {
                x: "8",
                y: "24",
                width: 464,
                height: height,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    xmlns: "http://www.w3.org/1999/xhtml",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "timeline-tooltip-contents",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "timeline-tooltip-name",
                                children: accommodation_item_place.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-title",
                                                children: "\u0161ifra rezervacije"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-value",
                                                children: reservation.internal_code
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-title",
                                                children: "\u0161tevilo no\u010Ditev"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-value",
                                                children: reservation.idx_end - reservation.idx_start
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-title",
                                                children: "prodajni kanal"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-value",
                                                children: reservation.id_channel === null ? '' : channels[reservation.id_channel].title
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-title",
                                                children: "nosilec"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-value",
                                                children: customers[reservation.id_customer] === undefined ? '' : customers[reservation.id_customer].type == 'natural' ? customers[reservation.id_customer].surname + ' ' + customers[reservation.id_customer].name : customers[reservation.id_customer].company_name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-title",
                                                children: "odrasli/otroci"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-value",
                                                children: parseInt(reservation.guest_adult_count, 10).toString() + '/' + (parseInt(reservation.guest_child_1_count, 10) + parseInt(reservation.guest_child_2_count, 10)).toString()
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-title",
                                                children: "status"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "timeline-tooltip-value",
                                                children: status_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: title
                                                    }, 'status-title-' + title))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "timeline-tooltip-note mt-4",
                                children: reservation.note
                            })
                        ]
                    })
                })
            })
        ]
    });
});
class Timeline extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.setSizes = this.setSizes.bind(this);
        this.setCompact = this.setCompact.bind(this);
        this.findAllowedDragEndIndex = this.findAllowedDragEndIndex.bind(this);
        this.getItemHoverState = this.getItemHoverState.bind(this);
        this.generateReservationTable = this.generateReservationTable.bind(this);
        this.generateIdAccommodationItemPlaceIdxs = this.generateIdAccommodationItemPlaceIdxs.bind(this);
        this.convertIdAccommodationItemPlaceToIdx = this.convertIdAccommodationItemPlaceToIdx.bind(this);
        this.convertIdxToIdAccommodationItemPlace = this.convertIdxToIdAccommodationItemPlace.bind(this);
        this.fixDraggingReservationHorVerIdxs = this.fixDraggingReservationHorVerIdxs.bind(this);
        this.setDirtyState = this.setDirtyState.bind(this);
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
        this.changeCaseIfNeeded = this.changeCaseIfNeeded.bind(this);
        const id_accommodation_item_places_to_idxs = this.generateIdAccommodationItemPlaceIdxs(props.rooms, props.accommodation_item_places);
        const dates = this.generateDates();
        const reservation_table = this.generateReservationTable(dates, props.rooms, Object.values(props.items), id_accommodation_item_places_to_idxs, Object.values(props.reservation_requests));
        this.state = {
            new_rect_position: {
                hor_index: 0,
                ver_index: 0
            },
            new_rect_visible: false,
            new_dragging: false,
            new_drag_hor_index_start: -1,
            new_drag_hor_index_end: -1,
            new_drag_ver_index: -1,
            dates: dates,
            reservation_table: reservation_table,
            tooltip_open: true,
            tooltip_horizontal_idx: -1,
            tooltip_vertical_idx: -1,
            tooltip_hidden: true,
            tooltip_id_reservation: -1,
            compact: false,
            current_hor_idx: -1,
            current_ver_idx: -1,
            current_fractional_hor_idx: 0,
            current_id_reservation: -2,
            dragging_id_reservation: -1,
            dragging_id_reservation_offset: 0,
            dragging_id_reservation_hor_index: -1,
            dragging_id_reservation_ver_index: -1,
            dragging_id_reservation_valid: true,
            request_move_id_reservation: -1,
            request_move_id_reservation_offset: 0,
            request_move_id_reservation_ver_index: -1,
            request_move_id_reservation_hor_index: -1,
            mouse_down_hor_idx: -1,
            mouse_down_ver_idx: -1,
            dragging_id_reservation_start: -1,
            dragging_id_reservation_end: -1,
            request_move_id_reservation_start: -1,
            request_move_id_reservation_end: -1,
            id_accommodation_item_places_to_idxs,
            tiktok: 0
        };
        this.timelineRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        this.timelineContainerRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        this.forceRerenderWithoutThrottling = ()=>{
            this.setState({
                tiktok: this.state.tiktok == 0 ? 1 : 0
            });
        };
        this.forceRerender = (0, _app.throttle)(this.forceRerenderWithoutThrottling, 200);
        this.forceRerender = this.forceRerender.bind(this);
        this.setSizes(this.state.compact);
        this.tooltip_id_reservation = -1;
    }
    componentDidMount() {
        this.forceRerender();
    }
    setSizes(compact) {
        this.timeline_width = 3600;
        this.left_side_width = 150;
        this.header_height = 46;
        this.column_width = 40 * (30 / this.props.scaleDays);
        this.row_height = compact ? 36 : 48;
        this.timeline_height = this.row_height * this.props.rooms.length + 300;
    }
    setCompact(enabled) {
        this.setSizes(enabled);
        this.setState({
            compact: enabled
        });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        let id_accommodation_item_places_to_idxs = this.state.id_accommodation_item_places_to_idxs;
        if (prevProps.rooms != this.props.rooms) {
            id_accommodation_item_places_to_idxs = this.generateIdAccommodationItemPlaceIdxs(this.props.rooms, this.props.accommodation_item_places);
            this.setSizes(this.state.compact);
            this.setState({
                id_accommodation_item_places_to_idxs
            });
        }
        if (prevProps.currentDate != this.props.currentDate) {
            const dates = this.generateDates();
            const reservation_table = this.generateReservationTable(dates, this.props.rooms, Object.values(this.props.items), id_accommodation_item_places_to_idxs, Object.values(this.props.reservation_requests));
            this.setState({
                dates,
                reservation_table
            });
        }
        if (prevProps.scaleDays != this.props.scaleDays) {
            this.setSizes();
            const dates = this.generateDates();
            const reservation_table = this.generateReservationTable(dates, this.props.rooms, Object.values(this.props.items), id_accommodation_item_places_to_idxs, Object.values(this.props.reservation_requests));
            this.setState({
                dates,
                reservation_table
            });
        }
        if (prevProps.items != this.props.items || prevProps.rooms != this.props.rooms) {
            const dates = this.generateDates();
            const reservation_table = this.generateReservationTable(dates, this.props.rooms, Object.values(this.props.items), id_accommodation_item_places_to_idxs, Object.values(this.props.reservation_requests));
            this.setState({
                dates,
                reservation_table,
                current_id_reservation: -1
            });
        }
    }
    generateDates() {
        const weekdays = {
            0: 'ned',
            1: 'pon',
            2: 'tor',
            3: 'sre',
            4: "\u010Det",
            5: 'pet',
            6: 'sob'
        };
        const dates = [];
        const curr_date = (0, _momentDefault.default)(this.props.currentDate).subtract(OFFSET_DAYS, 'days');
        const today = new Date();
        for(let i = 0; i < 120; i++){
            dates.push([
                weekdays[curr_date.day()],
                curr_date.date() + '.' + (curr_date.month() + 1) + '.',
                curr_date.date() == 1,
                curr_date.day(),
                curr_date.year() == this.props.currentDate.getFullYear() && curr_date.month() == this.props.currentDate.getMonth() && curr_date.date() == this.props.currentDate.getDate(),
                curr_date.year() == today.getFullYear() && curr_date.month() == today.getMonth() && curr_date.date() == today.getDate(),
                curr_date.clone()
            ]);
            curr_date.add(1, 'days');
        }
        return dates;
    }
    convertCheckInOutToIdxs(dates, check_in, check_out) {
        const a = dates[0][6].startOf('day');
        let b = (0, _momentDefault.default)(check_in).startOf('day');
        const idx_start = b.diff(a, 'days'); // + OFFSET_DAYS;
        b = (0, _momentDefault.default)(check_out).startOf('day');
        const idx_end = b.diff(a, 'days'); // + OFFSET_DAYS;
        return {
            idx_start,
            idx_end
        };
    }
    generateReservationTable(dates, rooms, items, id_accommodation_item_places_to_idxs, reservation_requests) {
        id_accommodation_item_places_to_idxs = id_accommodation_item_places_to_idxs || this.state.id_accommodation_item_places_to_idxs;
        const table = [];
        for(let y = 0; y < rooms.length; y++){
            const row = [];
            for(let x = 0; x < dates.length; x++)row.push(-1);
            table.push(row);
        }
        const table_requests = [];
        for(let y = 0; y < rooms.length; y++){
            const row = [];
            for(let x = 0; x < dates.length; x++)row.push(-1);
            table_requests.push(row);
        }
        // filter reservations by dates
        const from_iso = dates[0][6].format('YYYY-MM-DD');
        const until_iso = dates[dates.length - 1][6].format('YYYY-MM-DD');
        const filtered_items = items.filter((item)=>from_iso <= item.check_out && until_iso >= item.check_in);
        // sort by check in ASC to improve hover detection
        const sorted_items = filtered_items.sort((a, b)=>{
            if (a.check_in < b.check_in) return -1;
            if (a.check_in > b.check_in) return 1;
            return 0;
        });
        const new_items = {};
        for(let i = 0; i < sorted_items.length; i++){
            const item = {
                ...sorted_items[i]
            };
            const id_reservation = item.id_reservation;
            if (item.status == 'reversed' || item.status == 'no-show' || item.deleted) continue;
            new_items[id_reservation] = item;
            const { idx_start, idx_end } = this.convertCheckInOutToIdxs(dates, item.check_in, item.check_out);
            new_items[id_reservation].idx_start = idx_start;
            new_items[id_reservation].idx_end = idx_end;
            for(let idx = idx_start; idx <= idx_end; idx++){
                const vertical_idx = this.convertIdAccommodationItemPlaceToIdx(item.id_accommodation_item_place, id_accommodation_item_places_to_idxs);
                if (table[vertical_idx] === undefined) continue;
                table[vertical_idx][idx] = id_reservation;
            }
        }
        const new_items_reservation_requests = {};
        for(let i = 0; i < reservation_requests.length; i++){
            const item = {
                ...reservation_requests[i]
            };
            const id_reservation_request = item.id_reservation_request;
            if (item.status != 'new' && item.status != 'confirmed') continue;
            if (item.id_accommodation_item_place === null) continue;
            new_items_reservation_requests[id_reservation_request] = item;
            const { idx_start, idx_end } = this.convertCheckInOutToIdxs(dates, item.check_in, item.check_out);
            new_items_reservation_requests[id_reservation_request].idx_start = idx_start;
            new_items_reservation_requests[id_reservation_request].idx_end = idx_end;
            for(let idx = idx_start; idx <= idx_end; idx++){
                const vertical_idx = this.convertIdAccommodationItemPlaceToIdx(item.id_accommodation_item_place, id_accommodation_item_places_to_idxs);
                if (table_requests[vertical_idx] === undefined) continue;
                table_requests[vertical_idx][idx] = id_reservation_request;
            }
        }
        return {
            items: new_items,
            reservation_request_items: new_items_reservation_requests,
            table,
            table_requests
        };
    }
    generateIdAccommodationItemPlaceIdxs(rooms, accommodation_item_places) {
        const id_accommodation_item_places_to_idxs = {};
        for(let i = 0; i < rooms.length; i++)id_accommodation_item_places_to_idxs[rooms[i].id_accommodation_item_place] = i;
        return id_accommodation_item_places_to_idxs;
    }
    convertIdAccommodationItemPlaceToIdx(id_accommodation_item_place, id_accommodation_item_places_to_idxs) {
        id_accommodation_item_places_to_idxs = id_accommodation_item_places_to_idxs || this.state.id_accommodation_item_places_to_idxs;
        if (id_accommodation_item_places_to_idxs === undefined) return -1;
        return id_accommodation_item_places_to_idxs[id_accommodation_item_place];
    }
    convertIdxToIdAccommodationItemPlace(idx) {
        return this.props.rooms[idx].id_accommodation_item_place;
    }
    convertIdxToDate(dates, idx) {
        return dates[0][6]//.subtract(OFFSET_DAYS, 'days')
        .clone().add(idx, 'days').toDate();
    }
    translatePositionToIndexes(x, y, reservation_table) {
        const timeline_pos = this.timelineRef.current.getBoundingClientRect();
        let relative_x = x - timeline_pos.left;
        let relative_y = y - timeline_pos.top;
        relative_x -= this.left_side_width;
        relative_y -= this.header_height;
        let hor_index = Math.floor(relative_x / this.column_width);
        let ver_index = Math.floor(relative_y / this.row_height);
        const fractional_hor_index = Math.round(relative_x * 2.0 / this.column_width) / 2.0 - hor_index;
        if (ver_index < 0) ver_index = 0;
        else if (ver_index >= reservation_table.table.length) ver_index = reservation_table.table.length - 1;
        const horizontal_length = reservation_table.table.length == 0 ? 1 : reservation_table.table[0].length;
        if (hor_index < 0) hor_index = 0;
        else if (hor_index >= horizontal_length) hor_index = horizontal_length - 1;
        return [
            hor_index,
            ver_index,
            fractional_hor_index
        ];
    }
    findAllowedDragEndIndex(ver_index, start_index, target_end_index) {
        if (start_index <= target_end_index) for(let hor_index = start_index + 1; hor_index <= target_end_index; hor_index++){
            if (this.state.reservation_table.table[ver_index][hor_index] != -1 && this.state.reservation_table.table[ver_index][hor_index] != -2 || this.state.reservation_table.table_requests[ver_index][hor_index] != -1 && this.state.reservation_table.table_requests[ver_index][hor_index] != -2) return hor_index;
        }
        else for(let hor_index = start_index; hor_index >= target_end_index; hor_index--){
            if (this.state.reservation_table.table[ver_index][hor_index] != -1 && this.state.reservation_table.table[ver_index][hor_index] != -2 || this.state.reservation_table.table_requests[ver_index][hor_index] != -1 && this.state.reservation_table.table_requests[ver_index][hor_index] != -2) return hor_index;
        }
        return target_end_index;
    }
    getItemHoverState(id_reservation, current_hor_idx, current_fractional_hor_idx, items) {
        if (items[id_reservation] === undefined) return [
            HOVER_STATE.NONE,
            -1
        ];
        if (id_reservation != -1 && id_reservation != -2) {
            if (current_hor_idx == items[id_reservation].idx_start && current_fractional_hor_idx == 0.5) return [
                HOVER_STATE.ITEM_START,
                id_reservation
            ];
            else if (current_hor_idx == items[id_reservation].idx_end && current_fractional_hor_idx == 0.5) return [
                HOVER_STATE.ITEM_END,
                id_reservation
            ];
            else if (current_hor_idx == items[id_reservation].idx_start && current_fractional_hor_idx == 1 || current_hor_idx == items[id_reservation].idx_end && current_fractional_hor_idx == 0 || current_hor_idx > items[id_reservation].idx_start && current_hor_idx < items[id_reservation].idx_end) return [
                HOVER_STATE.ITEM_MIDDLE,
                id_reservation
            ];
            else if (current_hor_idx == items[id_reservation].idx_start) return [
                HOVER_STATE.ITEM_OUTSIDE_START,
                id_reservation
            ];
            else return [
                HOVER_STATE.ITEM_OUTSIDE_END,
                id_reservation
            ];
        }
        return [
            HOVER_STATE.NONE,
            -1
        ];
    }
    numberOfNights(count) {
        if (count == 2) return count + " no\u010Ditvi";
        else if (count == 3 || count == 4) return count + " no\u010Ditve";
        return count + " no\u010Ditev";
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    fixDraggingReservationHorVerIdxs(dragging_id_reservation, current_hor_idx, current_ver_idx, hor_index, ver_index, reservation_new_idx_start, reservation_new_idx_end, change_type) {
        const retval = {
            new_hor_index: hor_index,
            new_ver_index: ver_index,
            valid: true
        };
        const reservation_customers = this.props.reservation_customers_by_id_reservations[dragging_id_reservation] || {};
        const id_reservation_customers = Object.keys(reservation_customers);
        if (id_reservation_customers.length > 0) {
            // only allow vertical movement for reservations with customers
            if (change_type == 'move' && retval.new_hor_index != current_hor_idx) {
                retval.new_hor_index = current_hor_idx;
                retval.valid = false;
            }
            // only allow movement in the same idRNO
            const old_id_rno = this.props.accommodations[this.props.accommodation_items[this.props.accommodation_item_places[this.state.reservation_table.items[dragging_id_reservation].id_accommodation_item_place].id_accommodation_item].id_accommodation].etourism_id_rno;
            const new_id_rno = this.props.accommodations[this.props.accommodation_items[this.props.rooms[ver_index].id_accommodation_item].id_accommodation].etourism_id_rno;
            if (old_id_rno != new_id_rno) {
                retval.new_ver_index = current_ver_idx;
                retval.valid = false;
            }
        }
        const idx_start = reservation_new_idx_start;
        const idx_end = reservation_new_idx_end;
        let all_empty = true;
        for(let i = idx_start; i <= idx_end; i++){
            if ((this.state.reservation_table.table[ver_index][i] == -1 || this.state.reservation_table.table[ver_index][i] == dragging_id_reservation) && (this.state.reservation_table.table_requests[ver_index][i] == -1 || this.state.reservation_table.table_requests[ver_index][i] == dragging_id_reservation)) continue;
            const current_item_hover_state = this.getItemHoverState(this.state.reservation_table.table[ver_index][i], i, i == idx_start ? 1 : i == idx_end ? 0 : 0.5, this.state.reservation_table.items);
            const current_item_hover_state_requests = this.getItemHoverState(this.state.reservation_table.table_requests[ver_index][i], i, i == idx_start ? 1 : i == idx_end ? 0 : 0.5, this.state.reservation_table.reservation_request_items);
            if (current_item_hover_state[0] != HOVER_STATE.ITEM_OUTSIDE_START && current_item_hover_state[0] != HOVER_STATE.ITEM_OUTSIDE_END && current_item_hover_state[0] != HOVER_STATE.NONE) {
                all_empty = false;
                break;
            }
            if (current_item_hover_state_requests[0] != HOVER_STATE.ITEM_OUTSIDE_START && current_item_hover_state_requests[0] != HOVER_STATE.ITEM_OUTSIDE_END && current_item_hover_state_requests[0] != HOVER_STATE.NONE) {
                all_empty = false;
                break;
            }
        }
        if (!all_empty) {
            retval.new_hor_index = current_hor_idx;
            retval.new_ver_index = current_ver_idx;
            retval.valid = false;
        }
        return retval;
    }
    async setDirtyState(id_accommodation_item_place, state) {
        const item = {
            ...this.props.accommodation_item_places[id_accommodation_item_place],
            state
        };
        this.props.dispatch((0, _codeTablesSlice.addAccommodationItemPlace)({
            item,
            token: this.props.token
        }));
        const new_items = await (0, _codeTables.saveAccommodationItemPlace)(this.props.api_url, item, this.props.token);
        if (new_items !== null) this.props.dispatch((0, _codeTablesSlice.addAccommodationItemPlace)({
            item,
            token: this.props.token
        }));
    }
    showTooltip(item, id_reservation) {
        this.tooltip_id_reservation = id_reservation;
        setTimeout(()=>{
            if (this.tooltip_id_reservation != id_reservation) return;
            this.setState({
                tooltip_open: true,
                tooltip_hidden: false,
                tooltip_horizontal_idx: (item.idx_start + item.idx_end) / 2,
                tooltip_vertical_idx: this.convertIdAccommodationItemPlaceToIdx(item.id_accommodation_item_place) + 1,
                tooltip_id_reservation: id_reservation,
                new_rect_visible: false
            });
        }, 500);
    }
    hideTooltip() {
        this.tooltip_id_reservation = -1;
        this.setState({
            tooltip_open: false,
            tooltip_id_reservation: -1
        });
    }
    changeCaseIfNeeded(value) {
        if (this.props.general_settings.scanner_change_case == 'uppercase') return value.toUpperCase();
        if (this.props.general_settings.scanner_change_case == 'lowercase') return value.toLowerCase();
        if (this.props.general_settings.scanner_change_case == 'title-case') // from https://stackoverflow.com/a/37931321
        return value.replace(/\S+/g, (str)=>str.charAt(0).toUpperCase() + str.substr(1).toLowerCase());
        return value;
    }
    render() {
        const rows = this.props.rooms;
        const new_rect_visible = this.state.new_rect_visible && this.state.new_rect_position.hor_index >= 0 && this.state.new_rect_position.hor_index <= (this.timeline_width - this.left_side_width) / this.column_width && this.state.new_rect_position.ver_index >= 0 && this.state.new_rect_position.ver_index <= (this.timeline_height - this.header_height) / this.row_height;
        const new_drag_hor_index_start = Math.max(0, this.state.new_drag_hor_index_start);
        const new_drag_hor_index_end = Math.max(0, this.state.new_drag_hor_index_end);
        const drag_rect_visible = this.state.new_dragging;
        const item_hover_state = this.getItemHoverState(this.state.current_id_reservation, this.state.current_hor_idx, this.state.current_fractional_hor_idx, this.state.reservation_table.items);
        let cursor = 'default';
        if (item_hover_state[0] == HOVER_STATE.ITEM_START || item_hover_state[0] == HOVER_STATE.ITEM_END) cursor = 'ew-resize';
        else if (item_hover_state[0] == HOVER_STATE.ITEM_MIDDLE) cursor = 'grab';
        const timelineRect = this.timelineRef.current === null ? {
            x: 0,
            y: 0
        } : this.timelineRef.current.getBoundingClientRect();
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                position: 'absolute'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Overlay2), {
                    isOpen: true,
                    hasBackdrop: false,
                    enforceFocus: false,
                    autoFocus: false,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            left: Math.max(250 /* left navigation width */  + this.left_side_width, Math.min(timelineRect.x + this.state.tooltip_horizontal_idx * this.column_width + this.left_side_width + this.column_width / 2 - 240, window.innerWidth - 480 /* tooltip width */ )),
                            top: timelineRect.y + this.state.tooltip_vertical_idx * this.row_height + this.header_height,
                            pointerEvents: 'none'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimelineTooltip, {
                            tooltip_open: this.state.tooltip_open,
                            tooltip_hidden: this.state.tooltip_hidden,
                            animation_ended: ()=>{
                                if (!this.state.tooltip_open) this.setState({
                                    tooltip_hidden: true
                                });
                            },
                            reservation: this.state.tooltip_id_reservation == -1 ? null : this.state.reservation_table.items[this.state.tooltip_id_reservation],
                            accommodation_item_place: this.state.tooltip_id_reservation == -1 ? null : this.state.reservation_table.items[this.state.tooltip_id_reservation] === undefined ? null : this.props.accommodation_item_places[this.state.reservation_table.items[this.state.tooltip_id_reservation].id_accommodation_item_place],
                            channels: this.props.channels,
                            customers: this.props.customers,
                            general_settings: this.props.general_settings
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        position: 'absolute'
                    },
                    className: "timeline overflow-auto",
                    ref: this.timelineContainerRef,
                    onScroll: ()=>{
                        if (this.scroll_end_timer !== undefined && this.scroll_end_timer !== null) clearTimeout(this.scroll_end_timer);
                        this.scroll_end_timer = setTimeout(()=>{
                            this.forceRerenderWithoutThrottling();
                            this.scroll_end_timer = null;
                        }, 200);
                        this.forceRerender();
                    },
                    onMouseLeave: ()=>{
                        this.hideTooltip();
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                position: 'absolute',
                                left: 0,
                                top: 0,
                                width: this.timeline_width,
                                height: this.timeline_height + this.header_height
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                viewBox: '0 0 ' + this.timeline_width + ' ' + (this.timeline_height + this.header_height),
                                style: {
                                    backgroundColor: '#ffffff'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pattern", {
                                                id: "pattern-diagonal-stripes",
                                                viewBox: "0,0,40,40",
                                                width: "18",
                                                height: "18",
                                                patternUnits: "userSpaceOnUse",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                    stroke: "none",
                                                    strokeWidth: "1",
                                                    fill: "none",
                                                    fillRule: "evenodd",
                                                    opacity: "0.1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                        fill: "#000000",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                                                                points: "0 40 40 0 20 0 0 20"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                                                                points: "40 40 40 20 20 40"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pattern", {
                                                id: "pattern-polka-dots",
                                                viewBox: "0,0,20,20",
                                                width: "18",
                                                height: "18",
                                                patternUnits: "userSpaceOnUse",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                    stroke: "none",
                                                    strokeWidth: "1",
                                                    fill: "none",
                                                    fillRule: "evenodd",
                                                    opacity: "0.1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                        fill: "#000000",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                cx: "3",
                                                                cy: "3",
                                                                r: "3"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                cx: "13",
                                                                cy: "13",
                                                                r: "3"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pattern", {
                                                id: "pattern-hideout",
                                                viewBox: "0,0,40,40",
                                                width: "36",
                                                height: "36",
                                                patternUnits: "userSpaceOnUse",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                    stroke: "none",
                                                    strokeWidth: "1",
                                                    fill: "none",
                                                    fillRule: "evenodd",
                                                    opacity: "0.2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                        fill: "#000000",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 1.4l2.83 2.83 1.41-1.41L1.41 0H0v1.41zM38.59 40l-2.83-2.83 1.41-1.41L40 38.59V40h-1.41zM40 1.41l-2.83 2.83-1.41-1.41L38.59 0H40v1.41zM20 18.6l2.83-2.83 1.41 1.41L21.41 20l2.83 2.83-1.41 1.41L20 21.41l-2.83 2.83-1.41-1.41L18.59 20l-2.83-2.83 1.41-1.41L20 18.59z"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                                id: "fadeGrad",
                                                y2: "0",
                                                x2: "1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                        offset: "0",
                                                        stopColor: "white",
                                                        stopOpacity: "1"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                        offset: "0.8",
                                                        stopColor: "white",
                                                        stopOpacity: "1"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                        offset: "1",
                                                        stopColor: "white",
                                                        stopOpacity: "0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                                                id: "fade",
                                                maskContentUnits: "objectBoundingBox",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: "1",
                                                    height: "1",
                                                    fill: "url(#fadeGrad)"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                id: "reservation-bar-corner-triangle-clip",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M 0,0 L 20,0 L 0,20 L 0,0 z",
                                                    fill: "#000000"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("filter", {
                                                id: "timeline-tooltip-shadow",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("feDropShadow", {
                                                    dx: "0",
                                                    dy: "3",
                                                    stdDeviation: "5",
                                                    floodOpacity: "0.6"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("filter", {
                                                id: "reservation-bar-dragging",
                                                x: "-5%",
                                                y: "-5%",
                                                width: "110%",
                                                height: "110%",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                                    in: "SourceGraphic",
                                                    stdDeviation: "1"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(HorizontalLines, {
                                        header_height: this.header_height,
                                        timeline_width: this.timeline_width,
                                        row_height: this.row_height,
                                        rows: rows
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(VerticalLines, {
                                        left_side_width: this.left_side_width,
                                        timeline_width: this.timeline_width,
                                        timeline_height: this.timeline_height + this.header_height,
                                        column_width: this.column_width,
                                        header_height: this.header_height,
                                        dates: this.state.dates
                                    }),
                                    !new_rect_visible || drag_rect_visible ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(NewReservationIndicator, {
                                        column_width: this.column_width,
                                        left_side_width: this.left_side_width,
                                        row_height: this.row_height,
                                        header_height: this.header_height,
                                        new_rect_position: this.state.new_rect_position
                                    }),
                                    !drag_rect_visible ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReservationBar, {
                                        left_offset: this.left_side_width,
                                        top_offset: this.header_height,
                                        column_width: this.column_width,
                                        row_height: this.row_height,
                                        vertical_idx: this.state.new_drag_ver_index,
                                        idx_start: new_drag_hor_index_start,
                                        idx_end: new_drag_hor_index_end,
                                        status: STATUSES.DRAGGING,
                                        channel: '',
                                        title: this.numberOfNights(Math.abs(new_drag_hor_index_end - new_drag_hor_index_start)),
                                        on_click: null,
                                        dragging: false,
                                        guests_checked_in: false
                                    }),
                                    Object.values(this.state.reservation_table.items).map((item, idx)=>{
                                        if (item.id_reservation == this.state.dragging_id_reservation || item.id_reservation == this.state.dragging_id_reservation_start || item.id_reservation == this.state.dragging_id_reservation_end || item.id_reservation == this.state.request_move_id_reservation || item.id_reservation == this.state.request_move_id_reservation_start || item.id_reservation == this.state.request_move_id_reservation_end) return;
                                        if (this.timelineContainerRef.current === null) return null;
                                        const idx_start = item.idx_start;
                                        const idx_end = item.idx_end;
                                        if (idx_start === undefined || idx_end === undefined) return null;
                                        const container = this.timelineContainerRef.current;
                                        // hide reservations not currently visible
                                        const first_hor_visible_idx = Math.round((container.scrollLeft - this.left_side_width) / this.column_width) - 1;
                                        const last_hor_visible_idx = Math.round((container.scrollLeft - this.left_side_width + container.clientWidth) / this.column_width) + 1;
                                        if (idx_start > last_hor_visible_idx || idx_end < first_hor_visible_idx) return null;
                                        const vertical_idx = this.convertIdAccommodationItemPlaceToIdx(item.id_accommodation_item_place);
                                        if (vertical_idx === undefined) return null;
                                        // hide reservations not currently visible
                                        const first_vert_visible_idx = Math.round(container.scrollTop / this.row_height) - 1;
                                        const last_vert_visible_idx = Math.round((container.scrollTop + container.clientHeight) / this.row_height) + 1;
                                        if (vertical_idx < first_vert_visible_idx || vertical_idx > last_vert_visible_idx) return null;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReservationBar, {
                                            left_offset: this.left_side_width,
                                            top_offset: this.header_height,
                                            column_width: this.column_width,
                                            row_height: this.row_height,
                                            vertical_idx: vertical_idx,
                                            idx_start: idx_start,
                                            idx_end: idx_end,
                                            status: this.props.deletingReservations ? 'deleting' : item.status,
                                            channel: item.id_channel === null ? '' : this.props.channels[item.id_channel].internal_code.toUpperCase(),
                                            guest_count: item.guest_adult_count + item.guest_child_1_count + item.guest_child_2_count,
                                            title: this.props.customers[item.id_customer] === undefined ? '' : this.props.customers[item.id_customer].type == 'natural' ? this.props.customers[item.id_customer].surname : this.props.customers[item.id_customer].company_name,
                                            status_2: item.status_2,
                                            is_mouse_over: item_hover_state[1] == idx && item_hover_state[0] == HOVER_STATE.ITEM_MIDDLE && !this.state.new_dragging,
                                            dragging: false,
                                            guests_checked_in: item.guests_checked_in
                                        }, 'reservation-bar-' + idx);
                                    }),
                                    Object.values(this.state.reservation_table.reservation_request_items).map((item, idx)=>{
                                        /*if (item.id_reservation == this.state.dragging_id_reservation ||
								item.id_reservation == this.state.dragging_id_reservation_start ||
								item.id_reservation == this.state.dragging_id_reservation_end ||
								item.id_reservation == this.state.request_move_id_reservation ||
								item.id_reservation == this.state.request_move_id_reservation_start ||
								item.id_reservation == this.state.request_move_id_reservation_end) {
								return;
							}*/ if (this.timelineContainerRef.current === null) return null;
                                        const idx_start = item.idx_start;
                                        const idx_end = item.idx_end;
                                        if (idx_start === undefined || idx_end === undefined) return null;
                                        const container = this.timelineContainerRef.current;
                                        // hide reservations not currently visible
                                        const first_hor_visible_idx = Math.round((container.scrollLeft - this.left_side_width) / this.column_width) - 1;
                                        const last_hor_visible_idx = Math.round((container.scrollLeft - this.left_side_width + container.clientWidth) / this.column_width) + 1;
                                        if (idx_start > last_hor_visible_idx || idx_end < first_hor_visible_idx) return null;
                                        const vertical_idx = this.convertIdAccommodationItemPlaceToIdx(item.id_accommodation_item_place);
                                        if (vertical_idx === undefined) return null;
                                        // hide reservations not currently visible
                                        const first_vert_visible_idx = Math.round(container.scrollTop / this.row_height) - 1;
                                        const last_vert_visible_idx = Math.round((container.scrollTop + container.clientHeight) / this.row_height) + 1;
                                        if (vertical_idx < first_vert_visible_idx || vertical_idx > last_vert_visible_idx) return null;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReservationRequestBar, {
                                            left_offset: this.left_side_width,
                                            top_offset: this.header_height,
                                            column_width: this.column_width,
                                            row_height: this.row_height,
                                            vertical_idx: vertical_idx,
                                            idx_start: idx_start,
                                            idx_end: idx_end,
                                            status: item.status,
                                            guest_count: item.guest_adult_count + item.guest_child_1_count + item.guest_child_2_count,
                                            title: this.changeCaseIfNeeded(item.customer_surname),
                                            is_mouse_over: item_hover_state[1] == idx && item_hover_state[0] == HOVER_STATE.ITEM_MIDDLE && !this.state.new_dragging,
                                            dragging: false
                                        }, 'reservation-request-bar-' + idx);
                                    }),
                                    this.state.dragging_id_reservation == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReservationBar, {
                                        left_offset: this.left_side_width,
                                        top_offset: this.header_height,
                                        column_width: this.column_width,
                                        row_height: this.row_height,
                                        vertical_idx: this.state.current_ver_idx,
                                        idx_start: this.state.current_hor_idx - this.state.dragging_id_reservation_offset,
                                        idx_end: this.state.current_hor_idx - this.state.dragging_id_reservation_offset + (this.state.reservation_table.items[this.state.dragging_id_reservation].idx_end - this.state.reservation_table.items[this.state.dragging_id_reservation].idx_start),
                                        status: this.state.dragging_id_reservation_valid ? this.state.reservation_table.items[this.state.dragging_id_reservation].status : 'invalid',
                                        channel: '',
                                        title: this.state.dragging_id_reservation_valid ? this.numberOfNights(this.state.current_hor_idx - this.state.dragging_id_reservation_offset + (this.state.reservation_table.items[this.state.dragging_id_reservation].idx_end - this.state.reservation_table.items[this.state.dragging_id_reservation].idx_start) - (this.state.current_hor_idx - this.state.dragging_id_reservation_offset)) : 'neveljavno',
                                        status_2: this.state.reservation_table.items[this.state.dragging_id_reservation].status_2,
                                        on_click: null,
                                        dragging: true,
                                        guests_checked_in: this.state.reservation_table.items[this.state.dragging_id_reservation].guests_checked_in
                                    }),
                                    this.state.request_move_id_reservation == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReservationBar, {
                                        left_offset: this.left_side_width,
                                        top_offset: this.header_height,
                                        column_width: this.column_width,
                                        row_height: this.row_height,
                                        vertical_idx: this.state.current_ver_idx,
                                        idx_start: this.state.current_hor_idx - this.state.request_move_id_reservation_offset,
                                        idx_end: this.state.current_hor_idx - this.state.request_move_id_reservation_offset + (this.state.reservation_table.items[this.state.request_move_id_reservation].idx_end - this.state.reservation_table.items[this.state.request_move_id_reservation].idx_start),
                                        status: this.state.reservation_table.items[this.state.request_move_id_reservation].status,
                                        channel: '',
                                        title: this.numberOfNights(this.state.current_hor_idx - this.state.request_move_id_reservation_offset + (this.state.reservation_table.items[this.state.request_move_id_reservation].idx_end - this.state.reservation_table.items[this.state.request_move_id_reservation].idx_start) - (this.state.current_hor_idx - this.state.request_move_id_reservation_offset)),
                                        status_2: this.state.reservation_table.items[this.state.request_move_id_reservation].status_2,
                                        on_click: null,
                                        dragging: true,
                                        guests_checked_in: this.state.reservation_table.items[this.state.request_move_id_reservation].guests_checked_in
                                    }),
                                    this.state.dragging_id_reservation_start == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReservationBar, {
                                        left_offset: this.left_side_width,
                                        top_offset: this.header_height,
                                        column_width: this.column_width,
                                        row_height: this.row_height,
                                        vertical_idx: this.convertIdAccommodationItemPlaceToIdx(this.state.reservation_table.items[this.state.dragging_id_reservation_start].id_accommodation_item_place),
                                        idx_start: this.state.current_hor_idx,
                                        idx_end: this.state.reservation_table.items[this.state.dragging_id_reservation_start].idx_end,
                                        status: this.state.dragging_id_reservation_valid ? this.state.reservation_table.items[this.state.dragging_id_reservation_start].status : 'invalid',
                                        channel: '',
                                        title: this.state.dragging_id_reservation_valid ? this.numberOfNights(Math.max(1, Math.abs(this.state.reservation_table.items[this.state.dragging_id_reservation_start].idx_end - this.state.current_hor_idx))) : 'neveljavno',
                                        status_2: this.state.reservation_table.items[this.state.dragging_id_reservation_start].status_2,
                                        on_click: null,
                                        dragging: true,
                                        guests_checked_in: this.state.reservation_table.items[this.state.dragging_id_reservation_start].guests_checked_in
                                    }),
                                    this.state.request_move_id_reservation_start == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReservationBar, {
                                        left_offset: this.left_side_width,
                                        top_offset: this.header_height,
                                        column_width: this.column_width,
                                        row_height: this.row_height,
                                        vertical_idx: this.convertIdAccommodationItemPlaceToIdx(this.state.reservation_table.items[this.state.request_move_id_reservation_start].id_accommodation_item_place),
                                        idx_start: this.state.current_hor_idx,
                                        idx_end: this.state.reservation_table.items[this.state.request_move_id_reservation_start].idx_end,
                                        status: this.state.reservation_table.items[this.state.request_move_id_reservation_start].status,
                                        channel: '',
                                        title: this.numberOfNights(Math.max(1, Math.abs(this.state.reservation_table.items[this.state.request_move_id_reservation_start].idx_end - this.state.current_hor_idx))),
                                        status_2: this.state.reservation_table.items[this.state.request_move_id_reservation_start].status_2,
                                        on_click: null,
                                        dragging: true,
                                        guests_checked_in: this.state.reservation_table.items[this.state.request_move_id_reservation_start].guests_checked_in
                                    }),
                                    this.state.dragging_id_reservation_end == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReservationBar, {
                                        left_offset: this.left_side_width,
                                        top_offset: this.header_height,
                                        column_width: this.column_width,
                                        row_height: this.row_height,
                                        vertical_idx: this.convertIdAccommodationItemPlaceToIdx(this.state.reservation_table.items[this.state.dragging_id_reservation_end].id_accommodation_item_place),
                                        idx_start: this.state.reservation_table.items[this.state.dragging_id_reservation_end].idx_start,
                                        idx_end: this.state.current_hor_idx,
                                        status: this.state.dragging_id_reservation_valid ? this.state.reservation_table.items[this.state.dragging_id_reservation_end].status : 'invalid',
                                        channel: '',
                                        title: this.state.dragging_id_reservation_valid ? this.numberOfNights(Math.max(1, Math.abs(this.state.current_hor_idx - this.state.reservation_table.items[this.state.dragging_id_reservation_end].idx_start))) : 'neveljavno',
                                        status_2: this.state.reservation_table.items[this.state.dragging_id_reservation_end].status_2,
                                        on_click: null,
                                        dragging: true,
                                        guests_checked_in: this.state.reservation_table.items[this.state.dragging_id_reservation_end].guests_checked_in
                                    }),
                                    this.state.request_move_id_reservation_end == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReservationBar, {
                                        left_offset: this.left_side_width,
                                        top_offset: this.header_height,
                                        column_width: this.column_width,
                                        row_height: this.row_height,
                                        vertical_idx: this.convertIdAccommodationItemPlaceToIdx(this.state.reservation_table.items[this.state.request_move_id_reservation_end].id_accommodation_item_place),
                                        idx_start: this.state.reservation_table.items[this.state.request_move_id_reservation_end].idx_start,
                                        idx_end: this.state.current_hor_idx,
                                        status: this.state.reservation_table.items[this.state.request_move_id_reservation_end].status,
                                        channel: '',
                                        title: this.numberOfNights(Math.max(1, Math.abs(this.state.current_hor_idx - this.state.reservation_table.items[this.state.request_move_id_reservation_end].idx_start))),
                                        status_2: this.state.reservation_table.items[this.state.request_move_id_reservation_end].status_2,
                                        on_click: null,
                                        dragging: true,
                                        guests_checked_in: this.state.reservation_table.items[this.state.request_move_id_reservation_end].guests_checked_in
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        ref: this.timelineRef,
                                        x: "0",
                                        y: "0",
                                        width: this.timeline_width,
                                        height: this.timeline_height + this.header_height,
                                        fill: "#ffffff",
                                        opacity: "0",
                                        style: {
                                            cursor
                                        },
                                        onMouseMove: (e)=>{
                                            const indexes = this.translatePositionToIndexes(e.pageX, e.pageY, this.state.reservation_table);
                                            let hor_index = indexes[0];
                                            let ver_index = indexes[1];
                                            const fractional_hor_index = indexes[2];
                                            if (this.state.reservation_table.table[ver_index] === undefined || this.state.reservation_table.table[ver_index][hor_index] === undefined) return;
                                            const current_item_hover_state = this.getItemHoverState(this.state.reservation_table.table[ver_index][hor_index], hor_index, fractional_hor_index, this.state.reservation_table.items);
                                            const current_item_hover_state_requests = this.getItemHoverState(this.state.reservation_table.table_requests[ver_index][hor_index], hor_index, fractional_hor_index, this.state.reservation_table.reservation_request_items);
                                            if (this.state.dragging_id_reservation != -1) {
                                                const { new_hor_index, new_ver_index, valid } = this.fixDraggingReservationHorVerIdxs(this.state.dragging_id_reservation, this.state.current_hor_idx, this.state.current_ver_idx, hor_index, ver_index, hor_index - this.state.dragging_id_reservation_offset, hor_index - this.state.dragging_id_reservation_offset + (this.state.reservation_table.items[this.state.dragging_id_reservation].idx_end - this.state.reservation_table.items[this.state.dragging_id_reservation].idx_start), 'move');
                                                hor_index = new_hor_index;
                                                ver_index = new_ver_index;
                                                this.setState({
                                                    dragging_id_reservation_valid: valid
                                                });
                                            } else if (this.state.dragging_id_reservation_start != -1) {
                                                const { new_hor_index, new_ver_index, valid } = this.fixDraggingReservationHorVerIdxs(this.state.dragging_id_reservation_start, this.state.current_hor_idx, this.state.current_ver_idx, hor_index, ver_index, this.state.current_hor_idx, this.state.reservation_table.items[this.state.dragging_id_reservation_start].idx_end, 'start');
                                                this.setState({
                                                    dragging_id_reservation_valid: valid
                                                });
                                            } else if (this.state.dragging_id_reservation_end != -1) {
                                                const { new_hor_index, new_ver_index, valid } = this.fixDraggingReservationHorVerIdxs(this.state.dragging_id_reservation_end, this.state.current_hor_idx, this.state.current_ver_idx, hor_index, ver_index, this.state.reservation_table.items[this.state.dragging_id_reservation_end].idx_start, this.state.current_hor_idx, 'end');
                                                this.setState({
                                                    dragging_id_reservation_valid: valid
                                                });
                                            }
                                            if (this.state.current_hor_idx != hor_index || this.state.current_ver_idx != ver_index || this.state.current_fractional_hor_idx != fractional_hor_index) {
                                                this.setState({
                                                    current_hor_idx: hor_index,
                                                    current_ver_idx: ver_index,
                                                    current_fractional_hor_idx: fractional_hor_index
                                                });
                                                if (this.state.dragging_id_reservation != -1 && this.state.dragging_id_reservation != -2 || this.state.dragging_id_reservation_start != -1 && this.state.dragging_id_reservation_start != -2 || this.state.dragging_id_reservation_end != -1 && this.state.dragging_id_reservation_end != -2) this.hideTooltip();
                                            }
                                            const id_reservation = this.state.reservation_table.table[ver_index][hor_index];
                                            if (this.state.current_id_reservation != id_reservation) this.setState({
                                                current_id_reservation: id_reservation
                                            });
                                            if (!this.state.new_dragging && this.state.dragging_id_reservation == -1 && this.state.dragging_id_reservation_start == -1 && this.state.dragging_id_reservation_end == -1) {
                                                if (current_item_hover_state[0] == HOVER_STATE.NONE || current_item_hover_state[0] == HOVER_STATE.ITEM_OUTSIDE_END) {
                                                    this.hideTooltip();
                                                    this.setState({
                                                        new_rect_visible: true
                                                    });
                                                } else if (current_item_hover_state[0] == HOVER_STATE.ITEM_MIDDLE) {
                                                    const item = this.state.reservation_table.items[id_reservation];
                                                    this.showTooltip(item, id_reservation);
                                                }
                                            }
                                            //hor_index = Math.max(0, hor_index);
                                            //ver_index = Math.max(0, ver_index);
                                            //var x = hor_index * this.column_width;
                                            //var y = ver_index * this.row_height;
                                            if (this.state.new_rect_position.hor_index != hor_index || this.state.new_rect_position.ver_index != ver_index) {
                                                let new_rect_visible = current_item_hover_state[0] == HOVER_STATE.NONE;
                                                //if ( id_reservation > -1) {
                                                //	const item = this.state.reservation_table.items[id_reservation];
                                                //	new_rect_visible = (hor_index == item.idx_end);
                                                //}
                                                this.setState({
                                                    new_rect_position: {
                                                        hor_index,
                                                        ver_index
                                                    },
                                                    new_rect_visible
                                                });
                                            }
                                            if (this.state.new_drag_hor_index_end != hor_index) {
                                                const allowed_drag_end_index = this.findAllowedDragEndIndex(ver_index, this.state.new_drag_hor_index_start, hor_index);
                                                this.setState({
                                                    new_drag_hor_index_end: allowed_drag_end_index
                                                });
                                            }
                                        },
                                        onClick: (e)=>{
                                        //if (new_rect_visible) {
                                        //	if (this.props.openReservation !== undefined) {
                                        //		this.props.openReservation();
                                        //	}
                                        //}
                                        },
                                        onMouseDown: (e)=>{
                                            const indexes = this.translatePositionToIndexes(e.pageX, e.pageY, this.state.reservation_table);
                                            const hor_index = indexes[0];
                                            const ver_index = indexes[1];
                                            const fractional_hor_index = indexes[2];
                                            const current_item_hover_state = this.getItemHoverState(this.state.reservation_table.table[ver_index][hor_index], hor_index, fractional_hor_index, this.state.reservation_table.items);
                                            const current_item_hover_state_requests = this.getItemHoverState(this.state.reservation_table.table_requests[ver_index][hor_index], hor_index, fractional_hor_index, this.state.reservation_table.reservation_request_items);
                                            this.setState({
                                                mouse_down_hor_idx: hor_index,
                                                mouse_down_ver_idx: ver_index
                                            });
                                            if (current_item_hover_state_requests[0] == HOVER_STATE.ITEM_START || current_item_hover_state_requests[0] == HOVER_STATE.ITEM_MIDDLE || current_item_hover_state_requests[0] == HOVER_STATE.ITEM_END) return;
                                            let allowed_to_drag = true;
                                            if (current_item_hover_state[1] != -1 && current_item_hover_state[1] != -2) allowed_to_drag = current_item_hover_state[0] == HOVER_STATE.NONE || current_item_hover_state[0] == HOVER_STATE.ITEM_OUTSIDE_END;
                                            if (allowed_to_drag) this.setState({
                                                new_dragging: true,
                                                new_drag_hor_index_start: hor_index,
                                                new_drag_hor_index_end: hor_index,
                                                new_drag_ver_index: ver_index
                                            });
                                            if (current_item_hover_state[1] != -1 && current_item_hover_state[1] != -2) {
                                                const item = this.state.reservation_table.items[current_item_hover_state[1]];
                                                if (current_item_hover_state[0] == HOVER_STATE.ITEM_MIDDLE) this.setState({
                                                    dragging_id_reservation: current_item_hover_state[1],
                                                    dragging_id_reservation_offset: hor_index - item.idx_start,
                                                    dragging_id_reservation_hor_index: hor_index,
                                                    dragging_id_reservation_ver_index: ver_index,
                                                    dragging_id_reservation_valid: true
                                                });
                                                else if (current_item_hover_state[0] == HOVER_STATE.ITEM_START) {
                                                    const id_reservation = current_item_hover_state[1];
                                                    const reservation_customers = this.props.reservation_customers_by_id_reservations[id_reservation] || {};
                                                    const id_reservation_customers = Object.keys(reservation_customers);
                                                    if (id_reservation_customers.length == 0) this.setState({
                                                        dragging_id_reservation_start: current_item_hover_state[1],
                                                        dragging_id_reservation_offset: 0,
                                                        dragging_id_reservation_hor_index: hor_index,
                                                        dragging_id_reservation_ver_index: ver_index
                                                    });
                                                } else if (current_item_hover_state[0] == HOVER_STATE.ITEM_END) this.setState({
                                                    dragging_id_reservation_end: current_item_hover_state[1],
                                                    dragging_id_reservation_offset: item.idx_end - item.idx_start,
                                                    dragging_id_reservation_hor_index: hor_index,
                                                    dragging_id_reservation_ver_index: ver_index
                                                });
                                            }
                                        },
                                        onMouseUp: (e)=>{
                                            const indexes = this.translatePositionToIndexes(e.pageX, e.pageY, this.state.reservation_table);
                                            const hor_index = indexes[0];
                                            const ver_index = indexes[1];
                                            const fractional_hor_index = indexes[2];
                                            const current_item_hover_state = this.getItemHoverState(this.state.reservation_table.table[ver_index][hor_index], hor_index, fractional_hor_index, this.state.reservation_table.items);
                                            // check if we should interpret this as a click
                                            if (hor_index == this.state.mouse_down_hor_idx && ver_index == this.state.mouse_down_ver_idx) {
                                                this.setState({
                                                    new_dragging: false,
                                                    dragging_id_reservation: -1,
                                                    dragging_id_reservation_start: -1,
                                                    dragging_id_reservation_end: -1
                                                });
                                                if (current_item_hover_state[1] != -1 && current_item_hover_state[1] != -2 && current_item_hover_state[0] == HOVER_STATE.ITEM_MIDDLE) {
                                                    const item = this.state.reservation_table.items[this.state.current_id_reservation];
                                                    if (item !== undefined) {
                                                        if (this.props.deletingReservations) this.props.deleteReservation(item.id_reservation);
                                                        else if (this.props.openReservation !== undefined) this.props.openReservation(item);
                                                    }
                                                }
                                                return;
                                            }
                                            if (this.state.new_dragging) {
                                                this.setState({
                                                    new_dragging: false
                                                });
                                                const start_date = this.convertIdxToDate(this.state.dates, Math.min(this.state.new_drag_hor_index_start, this.state.new_drag_hor_index_end));
                                                const end_date = this.convertIdxToDate(this.state.dates, Math.max(this.state.new_drag_hor_index_start, this.state.new_drag_hor_index_end));
                                                if (this.props.openReservation !== undefined) {
                                                    const id_accommodation_item_place = this.convertIdxToIdAccommodationItemPlace(ver_index);
                                                    const accommodation_item_place = this.props.accommodation_item_places[id_accommodation_item_place];
                                                    const accommodation_item = this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
                                                    const accommodation = this.props.accommodations[accommodation_item.id_accommodation];
                                                    this.props.openReservation({
                                                        id_reservation: -1,
                                                        id_accommodation_item_place,
                                                        internal_code: '',
                                                        id_customer: -1,
                                                        check_in: start_date,
                                                        check_out: end_date,
                                                        guest_adult_count: 0,
                                                        guest_child_1_count: 0,
                                                        guest_child_2_count: 0,
                                                        status: 'new',
                                                        status_2: null,
                                                        id_channel: accommodation.default_id_channel ?? -1,
                                                        custom_status: '',
                                                        deleted: false,
                                                        items: {}
                                                    });
                                                }
                                            }
                                            if (this.state.dragging_id_reservation != -1) {
                                                const { new_hor_index, new_ver_index, valid } = this.fixDraggingReservationHorVerIdxs(this.state.dragging_id_reservation, this.state.current_hor_idx, this.state.current_ver_idx, hor_index, ver_index, hor_index - this.state.dragging_id_reservation_offset, hor_index - this.state.dragging_id_reservation_offset + (this.state.reservation_table.items[this.state.dragging_id_reservation].idx_end - this.state.reservation_table.items[this.state.dragging_id_reservation].idx_start), 'move');
                                                if (new_hor_index == this.state.dragging_id_reservation_hor_index && new_ver_index == this.state.dragging_id_reservation_ver_index || !valid) this.setState({
                                                    dragging_id_reservation: -1
                                                });
                                                else this.setState({
                                                    dragging_id_reservation: -1,
                                                    request_move_id_reservation: this.state.dragging_id_reservation,
                                                    request_move_id_reservation_start: -1,
                                                    request_move_id_reservation_end: -1,
                                                    request_move_id_reservation_offset: this.state.dragging_id_reservation_offset,
                                                    request_move_id_reservation_ver_index: new_ver_index,
                                                    request_move_id_reservation_hor_index: new_hor_index
                                                });
                                            } else if (this.state.dragging_id_reservation_start != -1) {
                                                const { new_hor_index, new_ver_index, valid } = this.fixDraggingReservationHorVerIdxs(this.state.dragging_id_reservation_start, this.state.current_hor_idx, this.state.current_ver_idx, hor_index, ver_index, this.state.current_hor_idx, this.state.reservation_table.items[this.state.dragging_id_reservation_start].idx_end, 'start');
                                                if (new_hor_index == this.state.dragging_id_reservation_hor_index && new_ver_index == this.state.dragging_id_reservation_ver_index || !valid) this.setState({
                                                    dragging_id_reservation_start: -1
                                                });
                                                else this.setState({
                                                    dragging_id_reservation_start: -1,
                                                    request_move_id_reservation: -1,
                                                    request_move_id_reservation_start: this.state.dragging_id_reservation_start,
                                                    request_move_id_reservation_end: -1,
                                                    request_move_id_reservation_offset: 0,
                                                    request_move_id_reservation_ver_index: new_ver_index,
                                                    request_move_id_reservation_hor_index: new_hor_index
                                                });
                                            } else if (this.state.dragging_id_reservation_end != -1) {
                                                const { new_hor_index, new_ver_index, valid } = this.fixDraggingReservationHorVerIdxs(this.state.dragging_id_reservation_end, this.state.current_hor_idx, this.state.current_ver_idx, hor_index, ver_index, this.state.reservation_table.items[this.state.dragging_id_reservation_end].idx_start, this.state.current_hor_idx, 'end');
                                                if (new_hor_index == this.state.dragging_id_reservation_hor_index && new_ver_index == this.state.dragging_id_reservation_ver_index || !valid) this.setState({
                                                    dragging_id_reservation_end: -1
                                                });
                                                else this.setState({
                                                    dragging_id_reservation_end: -1,
                                                    request_move_id_reservation: -1,
                                                    request_move_id_reservation_start: -1,
                                                    request_move_id_reservation_end: this.state.dragging_id_reservation_end,
                                                    request_move_id_reservation_offset: 0,
                                                    request_move_id_reservation_ver_index: new_ver_index,
                                                    request_move_id_reservation_hor_index: new_hor_index
                                                });
                                            }
                                        },
                                        onMouseEnter: ()=>{
                                            this.setState({
                                                new_rect_visible: true
                                            });
                                        },
                                        onMouseLeave: ()=>{
                                            this.setState({
                                                new_rect_visible: false,
                                                new_dragging: false
                                            });
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(HeaderColumns, {
                            timeline_width: this.timeline_width,
                            header_height: this.header_height,
                            left_side_width: this.left_side_width,
                            column_width: this.column_width,
                            dates: this.state.dates,
                            timelineRef: this.timelineRef,
                            setDateFilter: this.props.setDateFilter,
                            filterFrom: this.props.filterFrom,
                            filterTo: this.props.filterTo,
                            active_horizontal_idx: this.state.current_hor_idx
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeftSide, {
                            left_side_width: this.left_side_width,
                            timeline_width: this.timeline_width,
                            timeline_height: this.timeline_height,
                            row_height: this.row_height,
                            rows: rows,
                            accommodation_item_places: this.props.accommodation_item_places,
                            setDirtyState: this.setDirtyState,
                            active_vertical_idx: this.state.current_ver_idx
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        position: 'absolute',
                        left: '0px',
                        top: '0px',
                        width: this.left_side_width,
                        height: this.header_height,
                        backgroundColor: '#617f97',
                        zIndex: 18
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                        icon: this.state.compact ? 'minimize' : 'maximize',
                        minimal: true,
                        onClick: ()=>{
                            this.setCompact(!this.state.compact);
                        },
                        intent: (0, _core.Intent).SUCCESS,
                        style: {
                            position: 'absolute',
                            left: '8px',
                            top: '10px',
                            color: '#ffffff'
                        }
                    })
                }),
                this.state.request_move_id_reservation == -1 && this.state.request_move_id_reservation_start == -1 && this.state.request_move_id_reservation_end == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfirmReservationMoveDialog, {
                    idReservation: this.state.request_move_id_reservation != -1 ? this.state.request_move_id_reservation : this.state.request_move_id_reservation_start != -1 ? this.state.request_move_id_reservation_start : this.state.request_move_id_reservation_end,
                    type: this.state.request_move_id_reservation != -1 ? 'move' : this.state.request_move_id_reservation_start != -1 ? 'start' : 'end',
                    dates: this.state.dates,
                    items: this.state.reservation_table.items,
                    horizontalIdx: this.state.request_move_id_reservation_hor_index,
                    verticalIdx: this.state.request_move_id_reservation_ver_index,
                    offset: this.state.request_move_id_reservation_offset,
                    convertIdxToDate: this.convertIdxToDate,
                    convertIdxToIdAccommodationItemPlace: this.convertIdxToIdAccommodationItemPlace,
                    customers: this.props.customers,
                    rooms: this.props.rooms,
                    accommodationItemPlaces: this.props.accommodation_item_places,
                    reservationCustomersByIdReservations: this.props.reservation_customers_by_id_reservations,
                    onCancel: ()=>{
                        this.setState({
                            request_move_id_reservation: -1,
                            request_move_id_reservation_start: -1,
                            request_move_id_reservation_end: -1,
                            request_move_id_reservation_offset: 0,
                            request_move_id_reservation_ver_index: -1,
                            request_move_id_reservation_hor_index: -1
                        });
                    },
                    onConfirm: async (id_reservation, new_id_accommodation_item_place, new_check_in, new_check_out, change_customers_if_needed)=>{
                        // save item
                        const new_reservation = {
                            ...this.state.reservation_table.items[id_reservation]
                        };
                        const old_check_in = new_reservation.check_in;
                        const old_check_out = new_reservation.check_out;
                        new_reservation.id_accommodation_item_place = new_id_accommodation_item_place;
                        delete new_reservation.idx_start;
                        delete new_reservation.idx_end;
                        new_reservation.check_in = new_check_in instanceof Date ? this.toIsoString(new_check_in) : new_check_in;
                        new_reservation.check_out = new_check_out instanceof Date ? this.toIsoString(new_check_out) : new_check_out;
                        const { idx_start, idx_end } = this.convertCheckInOutToIdxs(this.state.dates, new_reservation.check_in, new_reservation.check_out);
                        new_reservation.idx_start = idx_start;
                        new_reservation.idx_end = idx_end;
                        this.state.reservation_table.items[id_reservation] = new_reservation;
                        let new_item;
                        const [dispatch, token] = [
                            this.props.dispatch,
                            this.props.token
                        ];
                        dispatch((0, _reservationSlice.addReservation)({
                            item: new_reservation,
                            token
                        }));
                        new_item = await (0, _reservations.saveReservation)(this.props.api_url, new_reservation, token);
                        if (new_item !== null) dispatch((0, _reservationSlice.addReservation)({
                            item: new_item,
                            token
                        }));
                        const accommodation_item_place = this.props.accommodation_item_places[new_reservation.id_accommodation_item_place];
                        const accommodation_item = this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
                        const accommodation = this.props.accommodations[accommodation_item.id_accommodation];
                        // change customers' check out timestamps, if needed
                        if (change_customers_if_needed) {
                            const new_check_out_with_time = (0, _momentDefault.default)(new_check_out);
                            const default_check_out_time_arr = accommodation.default_check_out_time.split(':');
                            if (default_check_out_time_arr.length == 3) {
                                new_check_out_with_time.hour(parseInt(default_check_out_time_arr[0], 10));
                                new_check_out_with_time.minute(parseInt(default_check_out_time_arr[1], 10));
                            }
                            const reservation_customers = this.props.reservation_customers_by_id_reservations[id_reservation] || {};
                            const yesterday = this.toIsoString((0, _momentDefault.default)().subtract(1, 'days').toDate());
                            for(let id_reservation_customer in reservation_customers){
                                let reservation_customer = reservation_customers[id_reservation_customer];
                                if (reservation_customer !== undefined && reservation_customer.check_out >= yesterday && reservation_customer.check_out.indexOf(old_check_out) === 0 && reservation_customer.checked_out === false) {
                                    reservation_customer = {
                                        ...reservation_customer
                                    };
                                    reservation_customer.check_out = new_check_out_with_time.toISOString(true);
                                    new_item = await (0, _reservations.saveReservationCustomer)(this.props.api_url, reservation_customer, token);
                                    dispatch((0, _reservationSlice.addReservationCustomer)({
                                        item: new_item.reservation_customer,
                                        token
                                    }));
                                    dispatch((0, _guestSlice.addGuestBookItem)({
                                        item: new_item.guest_book_item,
                                        token
                                    }));
                                }
                            }
                        }
                        // reset state
                        this.setState({
                            reservation_table: this.generateReservationTable(this.state.dates, this.props.rooms, Object.values(this.state.reservation_table.items), this.state.id_accommodation_item_places_to_idxs, Object.values(this.props.reservation_requests)),
                            request_move_id_reservation: -1,
                            request_move_id_reservation_start: -1,
                            request_move_id_reservation_end: -1,
                            request_move_id_reservation_offset: 0,
                            request_move_id_reservation_ver_index: -1,
                            request_move_id_reservation_hor_index: -1
                        });
                    }
                })
            ]
        });
    }
}
Timeline.propTypes = {
    openReservation: (0, _propTypesDefault.default).func,
    openExistingReservation: (0, _propTypesDefault.default).func,
    currentDate: (0, _propTypesDefault.default).object,
    scaleDays: (0, _propTypesDefault.default).number,
    setDateFilter: (0, _propTypesDefault.default).func,
    filterFrom: (0, _propTypesDefault.default).object,
    filterTo: (0, _propTypesDefault.default).object,
    rooms: (0, _propTypesDefault.default).array,
    items: (0, _propTypesDefault.default).object,
    deletingReservations: (0, _propTypesDefault.default).bool,
    deleteReservation: (0, _propTypesDefault.default).func
};
function mapStateToProps(state) {
    return {
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodations: state.CodeTablesSlice.accommodations,
        channels: state.CodeTablesSlice.channels,
        customers: state.CodeTablesSlice.customers,
        user: state.UserSlice.user,
        token: state.UserSlice.token,
        api_url: state.ReservationSlice.api_url,
        reservation_customers_by_id_reservations: state.ReservationSlice.reservation_customers_by_id_reservations,
        reservation_requests: state.ReservationSlice.reservation_requests,
        reservation_request_accommodations: state.ReservationSlice.reservation_request_accommodations,
        general_settings: state.SettingsSlice.general
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Timeline);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","react-redux":"5DyKE","moment":"1e4qG","../../slices/ReservationSlice":"kTPna","../../slices/GuestSlice":"bE5rS","../../api/Reservations":"8B3n3","../../api/CodeTables":"4GMYC","../../slices/CodeTablesSlice":"hfPGz","../../App":"4sGPJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"acPCW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _utils = require("../utils");
class DatePickerDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            selectedDate: this.props.value
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: false,
            className: "date-picker-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                children: "Izbira datuma"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-grow flex-col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "self-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DatePicker3), {
                                    dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                    dateFnsFormat: 'dd. MM. yyyy',
                                    locale: "sl",
                                    todayButtonText: "Danes",
                                    clearButtonText: "Po\u010Disti",
                                    showActionsBar: true,
                                    canClearSelection: false,
                                    minDate: (0, _momentDefault.default)(this.props.min_date || '1900-01-01').toDate(),
                                    maxDate: (0, _momentDefault.default)().add(5, 'year').toDate(),
                                    onChange: (selectedDate, isUserChange)=>{
                                        this.setState({
                                            selectedDate
                                        });
                                        if (isUserChange) this.props.closeDatePickerDialog(selectedDate);
                                    },
                                    value: this.state.selectedDate
                                })
                            })
                        })
                    })
                ]
            })
        });
    }
}
DatePickerDialog.propTypes = {
    closeDatePickerDialog: (0, _propTypesDefault.default).func,
    value: (0, _propTypesDefault.default).object
};
exports.default = DatePickerDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","moment":"1e4qG","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kZgvH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _select = require("@blueprintjs/select");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _raviger = require("raviger");
var _reservation = require("./Reservation");
var _reservationDefault = parcelHelpers.interopDefault(_reservation);
var _timelineActivities = require("./TimelineActivities");
var _timelineActivitiesDefault = parcelHelpers.interopDefault(_timelineActivities);
var _datePickerDialog = require("../DatePickerDialog");
var _datePickerDialogDefault = parcelHelpers.interopDefault(_datePickerDialog);
var _editActivityItemDialog = require("./EditActivityItemDialog");
var _editActivityItemDialogDefault = parcelHelpers.interopDefault(_editActivityItemDialog);
var _reservationSlice = require("../../slices/ReservationSlice");
var _reservations = require("../../api/Reservations");
function TimelineActivitiesWithFilter(props) {
    if (props.user === null || props.user === undefined || (props.user.access_roles ?? []).indexOf('reservations') === -1) return null;
    const sortAndExtractIdActivities = (activities)=>{
        return Object.values(activities).sort((a, b)=>{
            if (a.ord < b.ord) return -1;
            else if (a.ord > b.ord) return 1;
            return 0;
        }).map((item)=>item.id_activity);
    };
    const all_activities_ids = props.activities === undefined || props.activities === null ? [] : sortAndExtractIdActivities(props.activities);
    const [reservation_dialog_open, setReservationDialogOpen] = (0, _react.useState)(false);
    const [current_reservation, setCurrentReservation] = (0, _react.useState)(null);
    const [filter_date_picker_dialog_open, setFilterDatePickerDialogOpen] = (0, _react.useState)(false);
    const [all_activities, setAllActivities] = (0, _react.useState)(all_activities_ids);
    const [selected_activities, setSelectedActivities] = (0, _react.useState)(all_activities_ids);
    const [reservation_search_query, setReservationSearchQuery] = (0, _react.useState)('');
    const [edit_activity_item_dialog_open, setEditActivityItemDialogOpen] = (0, _react.useState)(false);
    const [edit_activity_item_dialog_item, setEditActivityItemDialogItem] = (0, _react.useState)(null);
    const [edit_activity_item_dialog_reservation_date, setEditActivityItemDialogReservationDate] = (0, _react.useState)(null);
    const [edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity, setEditActivityItemDialogIdAccommodationItemScheduleTimeSlotActivity] = (0, _react.useState)(-1);
    let [{ current_date, scale_days }, setQuery] = (0, _raviger.useQueryParams)();
    current_date = current_date === undefined ? new Date() : new Date(current_date);
    scale_days = scale_days === undefined ? 1 : parseInt(scale_days, 10) || 1;
    const setCurrentDate = (value)=>{
        setQuery({
            current_date: (0, _momentDefault.default)(value).format('YYYY-MM-DD'),
            scale_days
        });
    };
    const setScaleDays = (value)=>{
        setQuery({
            current_date: (0, _momentDefault.default)(current_date).format('YYYY-MM-DD'),
            scale_days: value
        });
    };
    const openReservationDialog = (reservation)=>{
        setReservationDialogOpen(true);
        setCurrentReservation(reservation);
    };
    const openFilterDatePickerDialog = ()=>{
        setFilterDatePickerDialogOpen(true);
    };
    const closeFilterDatePickerDialog = (newValue)=>{
        setFilterDatePickerDialogOpen(false);
        if (newValue instanceof Date) setCurrentDate(newValue);
    };
    const offsetCurrentDate = (offset_days)=>{
        setCurrentDate((0, _momentDefault.default)(current_date).add(offset_days, 'days').toDate());
    };
    const isActivitySelected = (activity)=>{
        return selected_activities.indexOf(activity) != -1;
    };
    const toggleActivity = (activity)=>{
        const selected_activities_arr = Array.from(selected_activities);
        if (isActivitySelected(activity)) selected_activities_arr.splice(selected_activities_arr.indexOf(activity), 1);
        else selected_activities_arr.push(activity);
        setSelectedActivities(selected_activities_arr);
    };
    const openEditActivityItemDialog = (item, id_accommodation_item_schedule_time_slot_activity, reservation_date)=>{
        setEditActivityItemDialogOpen(true);
        setEditActivityItemDialogItem(item);
        setEditActivityItemDialogReservationDate(reservation_date);
        setEditActivityItemDialogIdAccommodationItemScheduleTimeSlotActivity(id_accommodation_item_schedule_time_slot_activity);
    };
    const closeEditActivityItemDialog = async (original_item, item)=>{
        setEditActivityItemDialogOpen(false);
        if (item !== undefined) {
            let new_item = {};
            if (original_item !== null) {
                new_item = {
                    ...original_item
                };
                new_item.guest_count = item.guest_count;
                new_item.guest_child_count = item.guest_child_count;
                new_item.note = item.note;
                new_item.id_channel = item.id_channel == -1 ? null : item.id_channel;
                new_item.id_customer = item.id_customer;
                new_item.phone = '';
                new_item.email = '';
                new_item.reservation_date = item.reservation_date;
                new_item.status = item.status;
                new_item.status_2 = item.status_2 == '' ? null : item.status_2;
                new_item.deleted = item.deleted;
            } else new_item = {
                id_activity_reservation: -1,
                guest_count: item.guest_count,
                guest_child_count: item.guest_child_count,
                note: item.note,
                id_channel: item.id_channel == -1 ? null : item.id_channel,
                id_customer: item.id_customer,
                phone: '',
                email: '',
                status: item.status,
                status_2: item.status_2 == '' ? null : item.status_2,
                reservation_date: item.reservation_date,
                id_accommodation_item_schedule_time_slot_activity: edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity,
                deleted: false,
                username: props.user.username
            };
            const dispatch = props.dispatch;
            const token = props.token;
            dispatch((0, _reservationSlice.addActivityReservation)({
                item: new_item,
                token
            }));
            new_item = await (0, _reservations.saveActivityReservation)(props.api_url, new_item, token);
            if (new_item !== null) dispatch((0, _reservationSlice.addActivityReservation)({
                item: new_item,
                token
            }));
        }
    };
    (0, _react.useEffect)(()=>{
        const all_activities = sortAndExtractIdActivities(props.activities);
        setAllActivities(all_activities);
        setSelectedActivities(all_activities);
    }, [
        props.activities
    ]);
    const weekdays = {
        'sunday': 'nedelja',
        'monday': 'ponedeljek',
        'tuesday': 'torek',
        'wednesday': 'sreda',
        'thursday': "\u010Detrtek",
        'friday': 'petek',
        'saturday': 'sobota'
    };
    const [reservation_in_clipboard, setReservationInClipboard] = (0, _react.useState)(null);
    const cutReservation = (reservation)=>{
        setReservationInClipboard(reservation);
    };
    const pasteReservation = async (id_accommodation_item_schedule_time_slot_activity, reservation_date)=>{
        if (reservation_in_clipboard === null) return;
        let new_item = {
            ...reservation_in_clipboard,
            id_accommodation_item_schedule_time_slot_activity,
            reservation_date
        };
        const dispatch = props.dispatch;
        const token = props.token;
        dispatch((0, _reservationSlice.addActivityReservation)({
            item: new_item,
            token
        }));
        new_item = await (0, _reservations.saveActivityReservation)(props.api_url, new_item, token);
        if (new_item !== null) dispatch((0, _reservationSlice.addActivityReservation)({
            item: new_item,
            token
        }));
        setReservationInClipboard(null);
    };
    const customer = reservation_in_clipboard === null ? null : props.customers[reservation_in_clipboard.id_customer];
    const short_week_days = [
        'ned',
        'pon',
        'tor',
        'sre',
        "\u010Det",
        'pet',
        'sob'
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !reservation_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reservationDefault.default), {
                closeReservation: ()=>{
                    setReservationDialogOpen(false);
                },
                reservation: current_reservation
            }),
            !filter_date_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDialogDefault.default), {
                closeDatePickerDialog: closeFilterDatePickerDialog,
                value: current_date
            }),
            !edit_activity_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editActivityItemDialogDefault.default), {
                closeEditActivityItemDialog: closeEditActivityItemDialog,
                item: edit_activity_item_dialog_item,
                reservation_date: edit_activity_item_dialog_reservation_date,
                time_slot: props.accommodation_item_schedule_time_slots[props.accommodation_item_schedule_time_slot_activities[edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity].id_accommodation_item_schedule_time_slot],
                activity: props.activities[props.accommodation_item_schedule_time_slot_activities[edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity].id_activity],
                accommodation_item_schedule_time_slot_activity: props.accommodation_item_schedule_time_slot_activities[edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity],
                setCurrentDate: setCurrentDate
            }),
            reservation_in_clipboard === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Card), {
                interactive: false,
                elevation: (0, _core.Elevation).FOUR,
                className: "activity-reservation-clipboard-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "ODLO\u017DI\u0160\u010CE"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            "Rezervacija",
                            ' ',
                            reservation_in_clipboard.internal_code,
                            ', ',
                            props.activities[props.accommodation_item_schedule_time_slot_activities[reservation_in_clipboard.id_accommodation_item_schedule_time_slot_activity].id_activity].title,
                            ', ',
                            (0, _momentDefault.default)(reservation_in_clipboard.reservation_date).format('DD.MM.YYYY'),
                            " ob ",
                            (()=>{
                                const time_slot = props.accommodation_item_schedule_time_slots[props.accommodation_item_schedule_time_slot_activities[reservation_in_clipboard.id_accommodation_item_schedule_time_slot_activity].id_accommodation_item_schedule_time_slot];
                                const starts_at_arr = time_slot.starts_at.split(':');
                                const time_label = starts_at_arr.length != 3 ? '00:00' : starts_at_arr[0] + ':' + starts_at_arr[1];
                                return time_label;
                            })(),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            customer === undefined ? '' : customer.type == 'company' ? customer.company_name : customer.surname + ' ' + customer.name
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                        icon: "delete",
                        className: "mt-2",
                        onClick: ()=>{
                            setReservationInClipboard(null);
                        },
                        children: "Po\u010Disti"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pt-4 pb-2 flex flex-row justify-between",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                active: scale_days == 1,
                                onClick: ()=>{
                                    setScaleDays(1);
                                },
                                children: "1 dan"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                active: scale_days == 2,
                                onClick: ()=>{
                                    setScaleDays(2);
                                },
                                children: "2 dni"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                active: scale_days == 3,
                                onClick: ()=>{
                                    setScaleDays(3);
                                },
                                children: "3 dni"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                onClick: ()=>{
                                    offsetCurrentDate(-30);
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        viewBox: "0 0 20 18",
                                        width: "20",
                                        height: "18",
                                        className: "inline-block mr-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            fillRule: "evenodd",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m14.589 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                })
                                            ]
                                        })
                                    }),
                                    "30 dni"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                onClick: ()=>{
                                    offsetCurrentDate(-15);
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        viewBox: "0 0 14 18",
                                        width: "14",
                                        height: "18",
                                        className: "inline-block mr-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fill: "#92a8b8",
                                                d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                fillRule: "evenodd"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fill: "#92a8b8",
                                                d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                fillRule: "evenodd"
                                            })
                                        ]
                                    }),
                                    "15 dni"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                onClick: ()=>{
                                    offsetCurrentDate(-1);
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        viewBox: "0 0 9 18",
                                        width: "9",
                                        height: "18",
                                        className: "inline-block mr-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "#92a8b8",
                                            d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                            fillRule: "evenodd"
                                        })
                                    }),
                                    "1 dan"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                className: "w-32",
                                onClick: ()=>{
                                    openFilterDatePickerDialog();
                                },
                                intent: (0, _core.Intent).PRIMARY,
                                children: short_week_days[current_date.getDay()] + ', ' + current_date.toLocaleString('sl-SI', {
                                    year: 'numeric',
                                    month: 'numeric',
                                    day: 'numeric'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                className: "w-24",
                                onClick: ()=>{
                                    setCurrentDate(new Date());
                                },
                                intent: (0, _core.Intent).PRIMARY,
                                disabled: (0, _momentDefault.default)(current_date).format('YYYY-MM-DD') == (0, _momentDefault.default)().format('YYYY-MM-DD'),
                                children: "Danes"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                onClick: ()=>{
                                    offsetCurrentDate(1);
                                },
                                children: [
                                    "1 dan",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        viewBox: "0 0 9 18",
                                        width: "9",
                                        height: "18",
                                        className: "inline-block ml-1",
                                        transform: "scale(-1,1)",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "#92a8b8",
                                            d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                            fillRule: "evenodd"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                onClick: ()=>{
                                    offsetCurrentDate(15);
                                },
                                children: [
                                    "15 dni",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        viewBox: "0 0 14 18",
                                        width: "14",
                                        height: "18",
                                        className: "inline-block ml-1",
                                        transform: "scale(-1,1)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fill: "#92a8b8",
                                                d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                fillRule: "evenodd"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fill: "#92a8b8",
                                                d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                fillRule: "evenodd"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                onClick: ()=>{
                                    offsetCurrentDate(30);
                                },
                                children: [
                                    "30 dni",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        viewBox: "0 0 20 18",
                                        width: "20",
                                        height: "18",
                                        className: "inline-block ml-1",
                                        transform: "scale(-1,1)",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            fillRule: "evenodd",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m14.589 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Suggest), {
                        className: "mr-4",
                        itemListPredicate: (query, items)=>{
                            if (query.length < 3) return [];
                            return items.filter((item)=>item.search_value.indexOf(query.toLowerCase()) > -1).slice(0, 25);
                        },
                        itemRenderer: (item, { handleClick, modifiers })=>{
                            const reservation = props.activity_reservations[item.id_activity_reservation];
                            /*
					levo zgoraj: šifra aktivnosti
						desno: nosilec
					druga vrstica levo: datum in termin
					tretja vrstica levo: naziv aktivnosti
						desno: število oseb
					
					išče po: nosilcu, šifri aktivnosti 
					*/ return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                active: modifiers.active,
                                onClick: handleClick,
                                text: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: reservation.internal_code
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: item.customer_name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: item.reservation_date.format('DD. MM. YYYY') + ', ' + weekdays[item.day_of_week]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: item.time_label
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: item.activity_title
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: "\u0161t. oseb: " + (item.guest_count + item.guest_child_count)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                className: "items-stretch"
                            }, item.id_activity_reservation);
                        },
                        noResults: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "p-2",
                            children: "Ni rezultatov"
                        }),
                        items: Object.values(props.activity_reservations || {}).map((reservation)=>{
                            let customer_name = '';
                            let search_value = reservation.internal_code;
                            let customer = props.customers[reservation.id_customer];
                            if (customer !== undefined) {
                                customer_name = customer.type == 'natural' ? customer.name + ' ' + customer.surname : customer.company_name;
                                search_value += ' ' + customer_name;
                            }
                            const time_slot = props.accommodation_item_schedule_time_slots[props.accommodation_item_schedule_time_slot_activities[reservation.id_accommodation_item_schedule_time_slot_activity].id_accommodation_item_schedule_time_slot];
                            const starts_at_arr = time_slot.starts_at.split(':');
                            const time_label = starts_at_arr.length != 3 ? '00:00' : starts_at_arr[0] + ':' + starts_at_arr[1];
                            return {
                                id_activity_reservation: reservation.id_activity_reservation,
                                search_value: search_value.toLowerCase(),
                                reservation_date: (0, _momentDefault.default)(reservation.reservation_date),
                                guest_count: reservation.guest_count,
                                guest_child_count: reservation.guest_child_count,
                                activity_title: props.activities[props.accommodation_item_schedule_time_slot_activities[reservation.id_accommodation_item_schedule_time_slot_activity].id_activity].title,
                                customer_name,
                                day_of_week: time_slot.day_of_week,
                                time_label
                            };
                        }).sort((a, b)=>{
                            if (a.reservation_date > b.reservation_date) return -1;
                            if (a.reservation_date < b.reservation_date) return 1;
                            return 0;
                        }),
                        onItemSelect: (item)=>{
                            const reservation = props.activity_reservations[item.id_activity_reservation];
                            openEditActivityItemDialog(reservation, reservation.id_accommodation_item_schedule_time_slot_activity, reservation.reservation_date);
                        },
                        openOnKeyDown: true,
                        popoverProps: {
                            targetProps: {
                                style: {
                                    display: 'block'
                                }
                            },
                            minimal: true
                        },
                        selectedItem: null,
                        inputProps: {
                            leftIcon: 'search',
                            placeholder: "I\u0161\u010Di (vsaj 3 znaki)",
                            rightElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                icon: "cross",
                                minimal: true,
                                onClick: ()=>{
                                    setReservationSearchQuery('');
                                }
                            })
                        },
                        inputValueRenderer: (item)=>item.search_value,
                        resetOnSelect: true,
                        query: reservation_search_query,
                        onQueryChange: (query)=>{
                            setReservationSearchQuery(query);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pt-4 flex flex-row justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                        className: "mr-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                onClick: ()=>{
                                    setSelectedActivities(all_activities);
                                },
                                children: "Izberi vse"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                onClick: ()=>{
                                    setSelectedActivities([]);
                                },
                                children: "Izberi nobenega"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1 h-4",
                        children: all_activities.map((id_activity)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                inline: true,
                                checked: isActivitySelected(id_activity),
                                label: props.activities[id_activity].title,
                                onChange: ()=>{
                                    toggleActivity(id_activity);
                                }
                            }, 'activity-' + id_activity);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mr-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            icon: "th",
                            onClick: ()=>(0, _raviger.navigate)('/reservation-activities-list'),
                            children: "Seznam rezervacij"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex-1",
                style: {
                    position: 'relative'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timelineActivitiesDefault.default), {
                    openReservation: (reservation)=>{
                        openReservationDialog(reservation);
                    },
                    currentDate: current_date,
                    scaleDays: scale_days,
                    selectedActivities: selected_activities,
                    idAccommodationItem: props.idAccommodationItem,
                    setCurrentDate: (date)=>setCurrentDate(date),
                    openEditActivityItemDialog: openEditActivityItemDialog,
                    closeEditActivityItemDialog: closeEditActivityItemDialog,
                    reservationInClipboard: reservation_in_clipboard,
                    cutReservation: cutReservation,
                    pasteReservation: pasteReservation
                })
            })
        ]
    });
}
function mapStateToProps(state) {
    return {
        accommodations: state.CodeTablesSlice.accommodations,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        activities: state.CodeTablesSlice.activities,
        customers: state.CodeTablesSlice.customers,
        activity_reservations: state.ReservationSlice.activity_reservations,
        accommodation_item_schedules: state.CodeTablesSlice.accommodation_item_schedules,
        accommodation_item_schedule_time_slots: state.CodeTablesSlice.accommodation_item_schedule_time_slots,
        accommodation_item_schedule_time_slot_activities: state.CodeTablesSlice.accommodation_item_schedule_time_slot_activities,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        api_url: state.ConstantsSlice.api_url
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(TimelineActivitiesWithFilter);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@blueprintjs/select":"3IMc6","moment":"1e4qG","raviger":"knnT1","./Reservation":"a8Yu8","./TimelineActivities":"hbWC1","../DatePickerDialog":"acPCW","./EditActivityItemDialog":"eGJmb","../../slices/ReservationSlice":"kTPna","../../api/Reservations":"8B3n3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hbWC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _reactSortablejs = require("react-sortablejs");
var _reactSortablejsDefault = parcelHelpers.interopDefault(_reactSortablejs);
var _editInvoiceDialog = require("../business/EditInvoiceDialog");
var _editInvoiceDialogDefault = parcelHelpers.interopDefault(_editInvoiceDialog);
var _waitFiscalVerificationDialog = require("../business/WaitFiscalVerificationDialog");
var _waitFiscalVerificationDialogDefault = parcelHelpers.interopDefault(_waitFiscalVerificationDialog);
var _reservationSlice = require("../../slices/ReservationSlice");
var _reservations = require("../../api/Reservations");
var _businessSlice = require("../../slices/BusinessSlice");
var _business = require("../../api/Business");
var _documentSlice = require("../../slices/DocumentSlice");
var _invoiceCreator = require("../../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _userTag = require("../UserTag");
var _userTagDefault = parcelHelpers.interopDefault(_userTag);
var _appSlice = require("../../slices/AppSlice");
class TimelineActivities extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.isActivitySelected = this.isActivitySelected.bind(this);
        this.updateFilteredItems = this.updateFilteredItems.bind(this);
        this.openGuestCount = this.openGuestCount.bind(this);
        this.closeGuestCount = this.closeGuestCount.bind(this);
        this.openNotePopup = this.openNotePopup.bind(this);
        this.closeNotePopup = this.closeNotePopup.bind(this);
        this.handleSortableChange = this.handleSortableChange.bind(this);
        this.moveReservationFromState = this.moveReservationFromState.bind(this);
        this.groupActivityReservationsByTimeSlotActivities = this.groupActivityReservationsByTimeSlotActivities.bind(this);
        this.openCreateInvoiceDialog = this.openCreateInvoiceDialog.bind(this);
        this.openEditInvoiceDialog = this.openEditInvoiceDialog.bind(this);
        this.closeEditInvoiceDialog = this.closeEditInvoiceDialog.bind(this);
        this.setCompact = this.setCompact.bind(this);
        this.openPrintPOSDialog = this.openPrintPOSDialog.bind(this);
        this.closePrintPOSDialog = this.closePrintPOSDialog.bind(this);
        this.getUserByUsername = this.getUserByUsername.bind(this);
        this.state = {
            items: this.updateFilteredItems(props, true),
            note_popup_id_activity_reservation: null,
            note_popup_note: '',
            guest_count_popup_id_activity_reservation: null,
            guest_count_popup_count: -1,
            guest_child_count_popup_count: -1,
            activity_reservations: this.groupActivityReservationsByTimeSlotActivities(props, true),
            create_invoice_dialog_open: false,
            create_invoice_dialog_item: null,
            create_invoice_dialog_type: '',
            compact: false,
            wait_fiscal_verification_dialog_open: false,
            wait_fiscal_verification_dialog_id_invoice: null,
            print_pos_dialog_open: false,
            print_pos_dialog_item: null,
            print_pos_dialog_id_activities_checked: {},
            request_move_reservation_open: false,
            request_move_reservation_from_id: -1,
            request_move_reservation_activity_item_key_from: -1,
            request_move_reservation_activity_item_key_to: -1,
            request_move_reservation_day_count: -1
        };
        this.skip_next_sortable_event = false;
    }
    updateFilteredItems(props, only_return) {
        only_return = only_return || false;
        let filtered_items = [];
        const all_items = [];
        if (props.accommodation_item_schedules !== undefined && props.accommodation_item_schedule_time_slots !== undefined && props.accommodation_item_schedule_time_slot_activities !== undefined) {
            const item_schedules = Object.values(props.accommodation_item_schedules).filter((item)=>item.id_accommodation_item == props.idAccommodationItem).sort((a, b)=>{
                if (a.valid_from > b.valid_from) return -1;
                if (a.valid_from < b.valid_from) return 1;
                if (a.valid_until === null) return -1;
                if (b.valid_until === null) return 1;
                return 0;
            });
            const weekdays = [
                'sunday',
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday'
            ];
            const current_date = (0, _momentDefault.default)(props.currentDate);
            for(let i = 0; i < props.scaleDays; i++){
                // find the most appropriate schedule
                const current_date_iso = current_date.format('YYYY-MM-DD');
                let accommodation_item_schedule = null;
                for(let j = 0; j < item_schedules.length; j++){
                    const item = item_schedules[j];
                    if (item.valid_from <= current_date_iso && (item.valid_until === null || item.valid_until >= current_date_iso) && (accommodation_item_schedule === null || item.valid_from > accommodation_item_schedule.valid_from)) accommodation_item_schedule = item;
                }
                if (accommodation_item_schedule === null) continue;
                const time_slots = Object.values(props.accommodation_item_schedule_time_slots).filter((item)=>item.id_accommodation_item_schedule == accommodation_item_schedule.id_accommodation_item_schedule);
                let time_slots_for_current_date = [];
                for(let i = 0; i < time_slots.length; i++)if (time_slots[i].day_of_week == weekdays[current_date.day()]) time_slots_for_current_date.push(time_slots[i]);
                time_slots_for_current_date.sort((a, b)=>{
                    if (a.starts_at < b.starts_at) return -1;
                    else if (a.starts_at > b.starts_at) return 1;
                    return 0;
                });
                const items = [];
                const activities_values = Object.values(props.accommodation_item_schedule_time_slot_activities);
                for(let i = 0; i < time_slots_for_current_date.length; i++){
                    const time_slot = time_slots_for_current_date[i];
                    const activities = activities_values.filter((item)=>item.id_accommodation_item_schedule_time_slot == time_slot.id_accommodation_item_schedule_time_slot && this.isActivitySelected(item.id_activity));
                    if (activities.length > 0 && Object.keys(props.activities).length > 0) {
                        const starts_at_arr = time_slot.starts_at.split(':');
                        const time_label = starts_at_arr.length != 3 ? '00:00' : starts_at_arr[0] + ':' + starts_at_arr[1];
                        const item = {
                            id_time_slot: time_slot.id_accommodation_item_schedule_time_slot,
                            time_label,
                            activities: activities.sort((a, b)=>{
                                return props.activities[a.id_activity].ord - props.activities[b.id_activity].ord;
                            }).map((activity)=>{
                                return {
                                    key: activity.id_accommodation_item_schedule_time_slot_activity,
                                    title: props.activities[activity.id_activity].title,
                                    max_guest_count: activity.max_guest_count,
                                    guests: []
                                };
                            })
                        };
                        items.push(item);
                    }
                }
                all_items.push(items);
                current_date.add(1, 'days');
            }
        }
        filtered_items = all_items;
        if (!only_return) this.setState({
            items: filtered_items
        });
        return filtered_items;
    }
    groupActivityReservationsByTimeSlotActivities(props, only_return) {
        only_return = only_return || false;
        const activity_reservations = {};
        if (props.activity_reservations !== undefined) for(let key in props.activity_reservations){
            const activity_reservation = props.activity_reservations[key];
            if (activity_reservation.status == 'reversed' || activity_reservation.status == 'no-show' || activity_reservation.deleted === true) continue;
            if (activity_reservations[activity_reservation.id_accommodation_item_schedule_time_slot_activity] === undefined) activity_reservations[activity_reservation.id_accommodation_item_schedule_time_slot_activity] = [];
            activity_reservations[activity_reservation.id_accommodation_item_schedule_time_slot_activity].push(activity_reservation);
        }
        if (!only_return) this.setState({
            activity_reservations
        });
        return activity_reservations;
    }
    isActivitySelected(activity) {
        return this.props.selectedActivities.indexOf(activity) != -1;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        prevProps.currentDate, this.props.currentDate;
        if (!this.compareArrays(prevProps.selectedActivities, this.props.selectedActivities) || prevProps.accommodation_item_schedule != this.props.accommodation_item_schedule || prevProps.accommodation_item_schedule_time_slots != this.props.accommodation_item_schedule_time_slots || prevProps.accommodation_item_schedule_time_slot_activities != this.props.accommodation_item_schedule_time_slot_activities || prevProps.scaleDays != this.props.scaleDays || prevProps.currentDate != this.props.currentDate) this.updateFilteredItems(this.props);
        if (prevProps.activity_reservations != this.props.activity_reservations) this.setState({
            activity_reservations: this.groupActivityReservationsByTimeSlotActivities(this.props, true),
            items: this.updateFilteredItems(this.props, true)
        });
    }
    compareArrays(arr1, arr2) {
        if (arr1.length != arr2.length) return false;
        for(var i = 0, l = arr1.length; i < l; i++){
            // Check if we have nested arrays
            if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
                // recurse into the nested arrays
                if (!arr1[i].equals(arr2[i])) return false;
            } else if (arr1[i] != arr2[i]) // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
        return true;
    }
    openGuestCount(reservation) {
        this.setState({
            guest_count_popup_id_activity_reservation: reservation.id_activity_reservation,
            guest_count_popup_count: reservation.guest_count,
            guest_child_count_popup_count: reservation.guest_child_count
        });
    }
    async closeGuestCount(save) {
        if (save) {
            const item = this.props.activity_reservations[this.state.guest_count_popup_id_activity_reservation];
            if (item === null || item === undefined) return;
            if (item.guest_count != this.state.guest_count_popup_count || item.guest_child_count != this.state.guest_child_count_popup_count) {
                let new_item = {
                    ...item
                };
                new_item.guest_count = this.state.guest_count_popup_count;
                new_item.guest_child_count = this.state.guest_child_count_popup_count;
                const dispatch = this.props.dispatch;
                const token = this.props.token;
                dispatch((0, _reservationSlice.addActivityReservation)({
                    item: new_item,
                    token
                }));
                new_item = await (0, _reservations.saveActivityReservation)(this.props.api_url, new_item, token);
                if (new_item !== null) dispatch((0, _reservationSlice.addActivityReservation)({
                    item: new_item,
                    token
                }));
            }
        }
        this.setState({
            guest_count_popup_id_activity_reservation: null
        });
    }
    openNotePopup(reservation) {
        this.setState({
            note_popup_id_activity_reservation: reservation.id_activity_reservation,
            note_popup_note: reservation.note
        });
    }
    async closeNotePopup(save) {
        if (save) {
            const item = this.props.activity_reservations[this.state.note_popup_id_activity_reservation];
            if (item === null || item === undefined) return;
            if (item.note != this.state.note_popup_note) {
                let new_item = {
                    ...item
                };
                new_item.note = this.state.note_popup_note;
                const dispatch = this.props.dispatch;
                const token = this.props.token;
                dispatch((0, _reservationSlice.addActivityReservation)({
                    item: new_item,
                    token
                }));
                new_item = await (0, _reservations.saveActivityReservation)(this.props.api_url, new_item, token);
                if (new_item !== null) dispatch((0, _reservationSlice.addActivityReservation)({
                    item: new_item,
                    token
                }));
            }
        }
        this.setState({
            note_popup_id_activity_reservation: null,
            note_popup_note: ''
        });
    }
    handleSortableChange(evt) {
        if (this.skip_next_sortable_event) {
            this.skip_next_sortable_event = false;
            return;
        }
        if (evt.from != evt.to) this.skip_next_sortable_event = true;
        const path_from = evt.from.dataset.path.split('--');
        const path_to = evt.to.dataset.path.split('--');
        const activity_item_key_from = path_from[0];
        const activity_item_key_to = path_to[0];
        const id_arr = evt.item.dataset.id.split('--');
        this.setState({
            request_move_reservation_open: true,
            request_move_reservation_from_id: id_arr[1],
            request_move_reservation_activity_item_key_from: activity_item_key_from,
            request_move_reservation_activity_item_key_to: activity_item_key_to,
            request_move_reservation_day_count: path_to[1]
        });
    }
    async moveReservationFromState() {
        let new_item = {
            ...this.props.activity_reservations[this.state.request_move_reservation_from_id]
        };
        new_item.id_accommodation_item_schedule_time_slot_activity = this.state.request_move_reservation_activity_item_key_to;
        new_item.reservation_date = (0, _momentDefault.default)(this.props.currentDate).add(this.state.request_move_reservation_day_count, 'days').format('YYYY-MM-DD');
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        dispatch((0, _reservationSlice.addActivityReservation)({
            item: new_item,
            token
        }));
        new_item = await (0, _reservations.saveActivityReservation)(this.props.api_url, new_item, token);
        if (new_item !== null) dispatch((0, _reservationSlice.addActivityReservation)({
            item: new_item,
            token
        }));
        this.setState({
            request_move_reservation_open: false,
            request_move_reservation_from_id: -1,
            request_move_reservation_activity_item_key_to: -1,
            request_move_reservation_day_count: -1
        });
    }
    openCreateInvoiceDialog(type, reservation) {
        const accommodation_item_schedule_time_slot_activity = this.props.accommodation_item_schedule_time_slot_activities[reservation.id_accommodation_item_schedule_time_slot_activity];
        const activity = this.props.activities[accommodation_item_schedule_time_slot_activity.id_activity];
        const people_counts = [];
        if (activity.id_item !== null) {
            if (reservation.guest_count > 0) people_counts.push({
                count: reservation.guest_count,
                type: 'adult'
            });
            if (reservation.guest_child_count > 0) people_counts.push({
                count: reservation.guest_child_count,
                type: 'child'
            });
        }
        this.openEditInvoiceDialog(type, {
            invoice_number_internal: '',
            invoice_type: type,
            note: '',
            invoice_number: '',
            id_customer: reservation.id_customer,
            invoice_date: (0, _momentDefault.default)().toISOString(true),
            payment_date: null,
            service_date_start: (0, _momentDefault.default)().toISOString(true),
            service_date_end: (0, _momentDefault.default)().toISOString(true),
            reference: '',
            reservation: '',
            id_payment_type: null,
            original_id_invoice: reservation.id_activity_reservation,
            original_invoice_type: 'activity-reservation',
            items: people_counts.map((people_count, idx)=>{
                const item = this.props.items[activity.id_item];
                const id_price_list = (0, _priceHelperDefault.default).FindBestPriceListMatch(new Date(), item.price_lists);
                const item_price_list = id_price_list === null ? null : item.price_lists[id_price_list];
                const measuring_unit = this.props.measuring_units[item.id_measuring_unit];
                const tax_rate = item_price_list === undefined ? null : this.props.tax_rates[item_price_list.id_tax_rate];
                return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                    id_invoice_item: (0, _uuidDefault.default).v4(),
                    description: '',
                    id_item: item.id_item,
                    id_item_price_list: id_price_list,
                    id_tax_rate: item_price_list === undefined ? null : item_price_list.id_tax_rate,
                    item_measuring_unit_code: measuring_unit.title,
                    item_measuring_unit_decimal_digit_count: measuring_unit.decimal_digit_count,
                    price: item_price_list.price,
                    quantity: people_count.count,
                    discount: people_count.type == 'adult' ? 0 : activity.item_child_discount,
                    tax_rate,
                    item_type: item.type,
                    item_ean: item.ean,
                    item_title: item.title,
                    ord: idx,
                    id_warehouse: item.item_type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === null ? null : this.props.cash_registers[this.props.current_id_cash_register], this.props.warehouses)
                });
            })
        });
    }
    openEditInvoiceDialog(type, item) {
        this.setState({
            create_invoice_dialog_open: true,
            create_invoice_dialog_type: type,
            create_invoice_dialog_item: item
        });
    }
    async closeEditInvoiceDialog(item, open_create_invoice_type, finish_invoice) {
        this.setState({
            create_invoice_dialog_open: false,
            create_invoice_dialog_item: null
        });
        if (item !== undefined) {
            this.props.dispatch((0, _businessSlice.addInvoice)({
                item,
                token: this.props.token
            }));
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            const new_items = await (0, _business.saveInvoice)(this.props.api_url, item, token, dispatch);
            if (new_items !== null) {
                if (new_items.invoices !== undefined) dispatch((0, _businessSlice.addInvoices)(new_items.invoices));
                if (new_items.document_associations !== undefined) dispatch((0, _documentSlice.addDocumentAssociations)(new_items.document_associations));
                if (new_items.advance_invoice_consumptions !== undefined) dispatch((0, _businessSlice.addAdvanceInvoiceConsumptions)(new_items.advance_invoice_consumptions));
                if (finish_invoice && this.props.document_types[item.invoice_type].fiscal_verification_enabled) this.setState({
                    wait_fiscal_verification_dialog_open: true,
                    wait_fiscal_verification_dialog_id_invoice: item.id_invoice
                });
            /*console.log({ item });
				for (let i=0; i<new_items.invoices.length; i++) {
					self.addAndSaveDocumentAssociation(
						new_items.invoices[i].id_invoice,
						new_items.invoices[i].invoice_type,
						item.id_activity_reservation,
						'activity-reservation'
					);
				}*/ }
        }
    }
    setCompact(enabled) {
        this.setState({
            compact: enabled
        });
    }
    openPrintPOSDialog(item, date, time_slot) {
        const activities_checked = {};
        for(let i = 0; i < item.activities.length; i++)activities_checked[item.activities[i].key] = false;
        this.setState({
            print_pos_dialog_open: true,
            print_pos_dialog_item: item,
            print_pos_dialog_date: date,
            print_pos_dialog_time_slot: time_slot,
            print_pos_dialog_id_activities_checked: activities_checked
        });
    }
    closePrintPOSDialog(print, id_activities) {
        this.setState({
            print_pos_dialog_open: false
        });
        if (print) {
            const activity_reservations = {};
            for(let i = 0; i < this.state.print_pos_dialog_item.activities.length; i++){
                if (this.state.print_pos_dialog_id_activities_checked[this.state.print_pos_dialog_item.activities[i].key] !== true) continue;
                activity_reservations[this.state.print_pos_dialog_item.activities[i].key] = (this.state.activity_reservations[this.state.print_pos_dialog_item.activities[i].key] || []).filter((x)=>x.reservation_date == this.state.print_pos_dialog_date).sort((a, b)=>{
                    if (a.created > b.created) return 1;
                    if (a.created < b.created) return -1;
                    return 0;
                });
            }
            this.props.dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                type: 'activities',
                item: this.state.print_pos_dialog_item,
                date: this.state.print_pos_dialog_date,
                time_slot: this.state.print_pos_dialog_time_slot,
                activity_reservations
            }));
        }
    }
    getUserByUsername(username) {
        if (this.props.users === null) return null;
        for(let id_user in this.props.users){
            const user = this.props.users[id_user];
            if (user !== undefined && user.username == username) return user;
        }
        return null;
    }
    render() {
        const weekdays = [
            'nedelja',
            'ponedeljek',
            'torek',
            'sreda',
            "\u010Detrtek",
            'petek',
            'sobota'
        ];
        const dbKeysToWeekdays = {
            sunday: 'nedelja',
            monday: 'ponedeljek',
            tuesday: 'torek',
            wednesday: 'sreda',
            thursday: "\u010Detrtek",
            friday: 'petek',
            saturday: 'sobota'
        };
        const items = this.state.items;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.create_invoice_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editInvoiceDialogDefault.default), {
                    closeEditInvoiceDialog: this.closeEditInvoiceDialog,
                    item: this.state.create_invoice_dialog_item,
                    type: this.state.create_invoice_dialog_type
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: this.state.note_popup_id_activity_reservation !== null,
                    onClose: ()=>this.closeNotePopup(false),
                    className: "dialog--note-popup-data",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                fixedToTop: false,
                                className: "bp5-dark",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: "Opomba"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        align: (0, _core.Alignment).RIGHT,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: ()=>this.closeNotePopup(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_BODY,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                    growVertically: true,
                                    large: true,
                                    fill: true,
                                    intent: (0, _core.Intent).PRIMARY,
                                    onChange: (e)=>{
                                        this.setState({
                                            note_popup_note: e.target.value
                                        });
                                    },
                                    value: this.state.note_popup_note
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            onClick: ()=>this.closeNotePopup(false),
                                            children: "Prekli\u010Di"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.closeNotePopup(true),
                                            children: "Shrani"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: this.state.guest_count_popup_id_activity_reservation !== null,
                    onClose: ()=>this.closeGuestCount(false),
                    style: {
                        width: 160
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                fixedToTop: false,
                                className: "bp5-dark",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: "\u0160t. oseb"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        align: (0, _core.Alignment).RIGHT,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: ()=>this.closeGuestCount(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_BODY + ' p-2',
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "Odrasli:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ControlGroup), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                icon: "minus",
                                                tabIndex: "-1",
                                                minimal: false,
                                                small: true,
                                                onClick: ()=>{
                                                    this.setState({
                                                        guest_count_popup_count: Math.max(0, this.state.guest_count_popup_count - 1)
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                                id: "guest-count--count",
                                                className: "centered-numeric-input",
                                                buttonPosition: "none",
                                                fill: true,
                                                value: this.state.guest_count_popup_count,
                                                min: 0,
                                                onValueChange: (val)=>{
                                                    this.setState({
                                                        guest_count_popup_count: val
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                icon: "plus",
                                                tabIndex: "-1",
                                                minimal: false,
                                                small: true,
                                                onClick: ()=>{
                                                    this.setState({
                                                        guest_count_popup_count: this.state.guest_count_popup_count + 1
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "Otroci:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ControlGroup), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                icon: "minus",
                                                tabIndex: "-1",
                                                minimal: false,
                                                small: true,
                                                onClick: ()=>{
                                                    this.setState({
                                                        guest_child_count_popup_count: Math.max(0, this.state.guest_child_count_popup_count - 1)
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                                id: "guest-child-count--count",
                                                className: "centered-numeric-input",
                                                buttonPosition: "none",
                                                fill: true,
                                                value: this.state.guest_child_count_popup_count,
                                                min: 0,
                                                onValueChange: (val)=>{
                                                    this.setState({
                                                        guest_child_count_popup_count: val
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                icon: "plus",
                                                tabIndex: "-1",
                                                minimal: false,
                                                small: true,
                                                onClick: ()=>{
                                                    this.setState({
                                                        guest_child_count_popup_count: this.state.guest_child_count_popup_count + 1
                                                    });
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            onClick: ()=>this.closeGuestCount(false),
                                            children: "Prekli\u010Di"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.closeGuestCount(true),
                                            children: "Shrani"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                !this.state.wait_fiscal_verification_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _waitFiscalVerificationDialogDefault.default), {
                    closeWaitFiscalVerificationDialog: (print)=>{
                        this.setState({
                            wait_fiscal_verification_dialog_open: false
                        });
                        if (print) {
                            const invoice = this.props.invoices[this.state.wait_fiscal_verification_dialog_id_invoice];
                            if (this.props.general_settings.auto_print_type == 'a4') this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                                type: 'invoice',
                                lang: 'sl',
                                invoice
                            }));
                            else if (this.props.general_settings.auto_print_type == 'pos') this.props.dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                                type: 'invoice',
                                invoice
                            }));
                        }
                    },
                    id_invoice: this.state.wait_fiscal_verification_dialog_id_invoice
                }),
                !this.state.print_pos_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    onClose: ()=>this.closePrintPOSDialog(false),
                    isOpen: true,
                    style: {
                        width: 260
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                fixedToTop: false,
                                className: "bp5-dark",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: "Izberi aktivnosti"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        align: (0, _core.Alignment).RIGHT,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: ()=>this.closePrintPOSDialog(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_BODY + ' p-2',
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                        checked: Object.values(this.state.print_pos_dialog_id_activities_checked).every((x)=>x),
                                        label: "Vse",
                                        onChange: (event)=>{
                                            const print_pos_dialog_id_activities_checked = {
                                                ...this.state.print_pos_dialog_id_activities_checked
                                            };
                                            for(let id_activity in print_pos_dialog_id_activities_checked)print_pos_dialog_id_activities_checked[id_activity] = event.target.checked;
                                            this.setState({
                                                print_pos_dialog_id_activities_checked
                                            });
                                        }
                                    }),
                                    this.state.print_pos_dialog_item.activities.map((activity)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: this.state.print_pos_dialog_id_activities_checked[activity.key],
                                            label: activity.title,
                                            onChange: (event)=>{
                                                const print_pos_dialog_id_activities_checked = {
                                                    ...this.state.print_pos_dialog_id_activities_checked
                                                };
                                                print_pos_dialog_id_activities_checked[activity.key] = event.target.checked;
                                                this.setState({
                                                    print_pos_dialog_id_activities_checked
                                                });
                                            }
                                        }, 'print-pos-dialog-activity' + activity.key))
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            onClick: ()=>this.closePrintPOSDialog(false),
                                            children: "Prekli\u010Di"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.closePrintPOSDialog(true),
                                            children: "Natisni"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                !this.state.request_move_reservation_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Dialog), {
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    isOpen: true,
                    style: {
                        minWidth: 580
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_BODY,
                            children: (()=>{
                                const reservation = this.props.activity_reservations[this.state.request_move_reservation_from_id];
                                const customer = this.props.customers[reservation.id_customer];
                                const customer_name = customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name;
                                const time_slot_from = this.props.accommodation_item_schedule_time_slots[this.props.accommodation_item_schedule_time_slot_activities[this.state.request_move_reservation_activity_item_key_from].id_accommodation_item_schedule_time_slot];
                                const activity_from = this.props.activities[this.props.accommodation_item_schedule_time_slot_activities[this.state.request_move_reservation_activity_item_key_from].id_activity];
                                const day_of_week_from = dbKeysToWeekdays[time_slot_from.day_of_week];
                                const starts_at_arr_from = time_slot_from.starts_at.split(':');
                                const time_label_from = starts_at_arr_from.length != 3 ? '00:00' : starts_at_arr_from[0] + ':' + starts_at_arr_from[1];
                                const time_slot_to = this.props.accommodation_item_schedule_time_slots[this.props.accommodation_item_schedule_time_slot_activities[this.state.request_move_reservation_activity_item_key_to].id_accommodation_item_schedule_time_slot];
                                const activity_to = this.props.activities[this.props.accommodation_item_schedule_time_slot_activities[this.state.request_move_reservation_activity_item_key_to].id_activity];
                                const day_of_week_to = dbKeysToWeekdays[time_slot_to.day_of_week];
                                const starts_at_arr_to = time_slot_to.starts_at.split(':');
                                const time_label_to = starts_at_arr_to.length != 3 ? '00:00' : starts_at_arr_to[0] + ':' + starts_at_arr_to[1];
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "mb-3",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: "Sprememba rezervacije?"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Rezervacija: "
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: reservation.internal_code
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "mb-3",
                                            children: [
                                                "Nosilec: ",
                                                customer_name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: "Sprememba:"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                "Iz: ",
                                                activity_from.title,
                                                ", ",
                                                day_of_week_from,
                                                ", ",
                                                time_label_from
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                "Na: ",
                                                activity_to.title,
                                                ", ",
                                                day_of_week_to,
                                                ", ",
                                                time_label_to
                                            ]
                                        })
                                    ]
                                });
                            })()
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        onClick: ()=>{
                                            this.setState({
                                                request_move_reservation_open: false,
                                                request_move_reservation_from_id: -1,
                                                request_move_reservation_activity_item_key_from: -1,
                                                request_move_reservation_activity_item_key_to: -1,
                                                request_move_reservation_day_count: -1
                                            });
                                        },
                                        children: "Prekli\u010Di"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        onClick: this.moveReservationFromState,
                                        children: "Da"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        position: 'absolute'
                    },
                    className: "timeline-activities overflow-auto mt-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: [
                                ...Array(this.props.scaleDays).keys()
                            ].map((x)=>'1fr').join(' ')
                        },
                        children: [
                            ...Array(this.props.scaleDays).keys()
                        ].map((day_idx)=>{
                            const curr_date = (0, _momentDefault.default)(this.props.currentDate).add(day_idx, 'days');
                            const curr_date_iso = curr_date.format('YYYY-MM-DD');
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: 'activities-guests-table activities-guests-table-header ' + (this.props.scaleDays > 1 ? 'narrow' : ''),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "activities-guests-table-header-col col-1",
                                                children: day_idx > 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: this.state.compact ? 'minimize' : 'maximize',
                                                    minimal: true,
                                                    onClick: ()=>{
                                                        this.setCompact(!this.state.compact);
                                                    },
                                                    intent: (0, _core.Intent).SUCCESS,
                                                    style: {
                                                        position: 'absolute',
                                                        left: '8px',
                                                        top: '5px',
                                                        color: '#ffffff'
                                                    }
                                                })
                                            }),
                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "activities-guests-table-header-col",
                                                children: "#"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "activities-guests-table-header-col",
                                                children: "Naziv"
                                            }),
                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "activities-guests-table-header-col",
                                                children: "Telefon"
                                            }),
                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "activities-guests-table-header-col",
                                                children: "E-po\u0161ta"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "activities-guests-table-header-col",
                                                children: "Osebe"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "activities-guests-table-header-col",
                                                children: "Opomba"
                                            }),
                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "activities-guests-table-header-col",
                                                children: "Kanal"
                                            }),
                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "activities-guests-table-header-col",
                                                children: "Dr\u017Eava"
                                            }),
                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "activities-guests-table-header-col",
                                                children: "Ra\u010Dun"
                                            })
                                        ]
                                    }),
                                    items[day_idx] === undefined ? null : items[day_idx].map((item, item_idx)=>{
                                        const counts = item.activities.reduce((acc, val)=>{
                                            const reservations = (this.state.activity_reservations[val.key] || []).filter((x)=>x.reservation_date == curr_date_iso);
                                            return [
                                                acc[0] + reservations.reduce((accx, x)=>accx + x.guest_count + x.guest_child_count, 0),
                                                acc[1] + val.max_guest_count
                                            ];
                                        }, [
                                            0,
                                            0
                                        ]);
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: 'activities-guests-table ' + (this.props.scaleDays > 1 ? 'narrow' : ''),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "activities-guests-table-col activities-guests-table-time-section col-1",
                                                            style: {
                                                                gridColumn: '1 / 1'
                                                            },
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "text-base",
                                                                children: item.time_label
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "activities-guests-table-col activities-guests-table-time-section col-2",
                                                            style: {
                                                                gridColumn: '2 / 6'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: "\u0161t. oseb: "
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: counts[0] + ' / ' + counts[1]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "activities-guests-table-col activities-guests-table-time-section col-2 text-right",
                                                            style: {
                                                                gridColumn: '6 / ' + (this.props.scaleDays == 1 ? '11' : '6')
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: weekdays[curr_date.day()].toUpperCase() + ', ' + curr_date.date() + '.' + (curr_date.month() + 1) + '.'
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                    className: "ml-2",
                                                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                                        icon: "print",
                                                                        color: "white"
                                                                    }),
                                                                    minimal: true,
                                                                    onClick: ()=>this.openPrintPOSDialog(item, curr_date_iso, this.props.accommodation_item_schedule_time_slots[item.id_time_slot])
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                item.activities.map((activity_item, activity_item_idx)=>{
                                                    const reservations = (this.state.activity_reservations[activity_item.key] || []).filter((x)=>x.reservation_date == curr_date_iso).sort((a, b)=>{
                                                        if (a.created > b.created) return 1;
                                                        if (a.created < b.created) return -1;
                                                        return 0;
                                                    });
                                                    const guest_count = reservations.reduce((acc, val)=>acc + val.guest_count + val.guest_child_count, 0);
                                                    const near_or_over_capacity = guest_count / activity_item.max_guest_count >= 0.8;
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: 'activities-guests-table ' + (this.props.scaleDays > 1 ? 'narrow' : '') + ' ' + (this.state.compact ? 'compact' : ''),
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "activities-guests-table-col activities-guests-table-activity-section col-1 flex flex-row items-center " + (near_or_over_capacity ? 'warning' : ''),
                                                                    style: {
                                                                        gridColumn: '1 / ' + (this.props.scaleDays == 1 ? '11' : '6')
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                            icon: "plus",
                                                                            small: true,
                                                                            intent: (0, _core.Intent).PRIMARY,
                                                                            className: "mr-2",
                                                                            onClick: ()=>{
                                                                                this.props.openEditActivityItemDialog(null, this.state.items[day_idx][item_idx].activities[activity_item_idx].key, curr_date_iso);
                                                                            }
                                                                        }),
                                                                        activity_item.title + ", \u0161t. oseb: " + guest_count + ' / ' + activity_item.max_guest_count,
                                                                        near_or_over_capacity ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                                            icon: "warning-sign",
                                                                            intent: (0, _core.Intent).WARNING,
                                                                            className: "ml-2",
                                                                            htmlTitle: "Blizu ali \u010Dez kapaciteto"
                                                                        }) : null,
                                                                        this.props.reservationInClipboard === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "flex-1"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                                                                    content: "Prestavi rezervacijo iz odlo\u017Ei\u0161\u010Da na ta termin",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                                        className: "mt-1 ml-1",
                                                                                        small: true,
                                                                                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                                                            color: "#5c7080",
                                                                                            icon: "bring-data"
                                                                                        }),
                                                                                        onClick: ()=>{
                                                                                            this.props.pasteReservation(this.state.items[day_idx][item_idx].activities[activity_item_idx].key, curr_date_iso);
                                                                                        }
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSortablejsDefault.default), {
                                                                options: {
                                                                    group: 'shared'
                                                                },
                                                                onChange: (order, sortable, evt)=>{
                                                                    this.handleSortableChange(evt);
                                                                },
                                                                "data-path": [
                                                                    activity_item.key,
                                                                    day_idx
                                                                ].join('--'),
                                                                className: "activities-guests-table-guests",
                                                                style: {
                                                                    gridColumn: day_idx + 1
                                                                },
                                                                children: reservations === undefined ? null : reservations.map((reservation, reservation_idx)=>{
                                                                    const cls = 'activities-guests-table-col activities-guests-table-guest';
                                                                    let pattern_cls = '';
                                                                    if (reservation.status == 'offer-sent') pattern_cls = 'pattern-polka-dots';
                                                                    else if (reservation.status == 'advance-invoice-sent' || reservation.status == 'not-for-rent' /*with red background*/ ) pattern_cls = 'pattern-diagonal-stripes';
                                                                    const customer = this.props.customers[reservation.id_customer] ?? null;
                                                                    const channel = this.props.channels[reservation.id_channel];
                                                                    const country = customer === null ? null : this.props.countries[customer.id_country];
                                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        "data-id": item.id_time_slot + '--' + reservation.id_activity_reservation,
                                                                        className: 'activities-guests-table ' + (this.props.scaleDays > 1 ? 'narrow' : '') + ' ' + pattern_cls + ' ' + 'status-' + reservation.status + ' ' + (reservation.status_2 === null ? '' : reservation.status_2) + ' ' + (this.state.compact ? 'compact' : ''),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                                version: "1.1",
                                                                                baseProfile: "full",
                                                                                width: "16",
                                                                                height: "16",
                                                                                className: "custom-status",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                    d: "M 0,0 L 16,0 L 0,16 L 0,0 z",
                                                                                    fill: "#ff0000"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: cls + ' col-1',
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                                    icon: "edit",
                                                                                    minimal: true,
                                                                                    small: true,
                                                                                    className: "mr-3",
                                                                                    onClick: ()=>{
                                                                                        this.props.openEditActivityItemDialog(reservation, this.state.items[day_idx][item_idx].activities[activity_item_idx].key, curr_date_iso);
                                                                                    }
                                                                                })
                                                                            }),
                                                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: cls,
                                                                                children: customer === null ? '' : customer.internal_code
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: cls,
                                                                                children: customer === null ? '' : customer.type == 'company' ? customer.company_name : customer.surname + ' ' + customer.name
                                                                            }),
                                                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: cls,
                                                                                children: customer === null ? '' : customer.phone
                                                                            }),
                                                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: cls,
                                                                                children: customer === null ? '' : customer.email
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: cls + ' guest-count text-center',
                                                                                onClick: ()=>{
                                                                                    this.openGuestCount(reservation);
                                                                                },
                                                                                children: [
                                                                                    reservation.guest_count,
                                                                                    " / ",
                                                                                    reservation.guest_child_count
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: cls + ' note',
                                                                                onClick: ()=>{
                                                                                    this.openNotePopup(reservation);
                                                                                },
                                                                                children: reservation.note
                                                                            }),
                                                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: cls + ' text-center',
                                                                                children: channel === undefined ? '' : channel.internal_code
                                                                            }),
                                                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: cls,
                                                                                children: country === undefined || country === null ? '' : country.official_name_local
                                                                            }),
                                                                            this.props.scaleDays > 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: cls,
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    style: {
                                                                                        height: 32,
                                                                                        display: 'flex'
                                                                                    },
                                                                                    className: "flex flex-row justify-between items-center",
                                                                                    children: [
                                                                                        reservation.status == 'paid' ? '' : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                                                    className: "mt-1",
                                                                                                    small: true,
                                                                                                    disabled: this.props.current_id_cash_register == 0,
                                                                                                    onClick: ()=>{
                                                                                                        this.openCreateInvoiceDialog('cash-invoice', reservation);
                                                                                                    },
                                                                                                    children: "Ra\u010Dun"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                                                    className: "mt-1 ml-1",
                                                                                                    small: true,
                                                                                                    onClick: ()=>{
                                                                                                        this.openCreateInvoiceDialog('invoice', reservation);
                                                                                                    },
                                                                                                    children: "Faktura"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userTagDefault.default), {
                                                                                            user: this.getUserByUsername(reservation.username),
                                                                                            reservation: reservation,
                                                                                            className: "ml-2"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                                                                            content: 'Prestavi rezervacijo na drug termin',
                                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                                                className: "ml-1",
                                                                                                small: true,
                                                                                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                                                                    color: "#5c7080",
                                                                                                    icon: "inheritance"
                                                                                                }),
                                                                                                disabled: this.props.reservationInClipboard !== null && this.props.reservationInClipboard.id_activity_reservation == reservation.id_activity_reservation,
                                                                                                onClick: ()=>{
                                                                                                    this.props.cutReservation(reservation);
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, 'activities-guests--' + reservation.id_activity_reservation);
                                                                })
                                                            })
                                                        ]
                                                    }, 'activities-guests-table-day-' + day_idx + '-item-' + item.id_time_slot + '-activity-' + activity_item.key);
                                                })
                                            ]
                                        }, 'activities-guests-table-day-' + day_idx + '-item-' + item.id_time_slot);
                                    })
                                ]
                            }, 'activities-guests-table-day-' + day_idx);
                        })
                    })
                })
            ]
        });
    }
}
TimelineActivities.propTypes = {
    openReservation: (0, _propTypesDefault.default).func,
    openExistingReservation: (0, _propTypesDefault.default).func,
    currentDate: (0, _propTypesDefault.default).object,
    scaleDays: (0, _propTypesDefault.default).number,
    selectedActivities: (0, _propTypesDefault.default).array
};
function mapStateToProps(state) {
    return {
        accommodation_item_schedules: state.CodeTablesSlice.accommodation_item_schedules,
        accommodation_item_schedule_time_slots: state.CodeTablesSlice.accommodation_item_schedule_time_slots,
        accommodation_item_schedule_time_slot_activities: state.CodeTablesSlice.accommodation_item_schedule_time_slot_activities,
        activities: state.CodeTablesSlice.activities,
        customers: state.CodeTablesSlice.customers,
        countries: state.CodeTablesSlice.countries,
        channels: state.CodeTablesSlice.channels,
        items: state.CodeTablesSlice.items,
        measuring_units: state.CodeTablesSlice.measuring_units,
        tax_rates: state.CodeTablesSlice.tax_rates,
        warehouses: state.CodeTablesSlice.warehouses,
        activity_reservations: state.ReservationSlice.activity_reservations,
        token: state.UserSlice.token,
        users: state.UserSlice.users,
        api_url: state.ConstantsSlice.api_url,
        document_associations: state.DocumentSlice.document_associations_id_documents,
        document_types: state.DocumentSlice.document_types,
        invoices: state.BusinessSlice.invoices,
        general_settings: state.SettingsSlice.general,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        cash_registers: state.CashRegisterSlice.cash_registers
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(TimelineActivities);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","moment":"1e4qG","uuid":"b52pV","react-sortablejs":"8SGd4","../business/EditInvoiceDialog":"kxL93","../business/WaitFiscalVerificationDialog":"bvSNl","../../slices/ReservationSlice":"kTPna","../../api/Reservations":"8B3n3","../../slices/BusinessSlice":"47JXm","../../api/Business":"fC7Hd","../../slices/DocumentSlice":"6gdAm","../../helpers/InvoiceCreator":"d7VsE","../../helpers/Invoice":"jffQW","../../helpers/PriceHelper":"91cdD","../UserTag":"jXGJj","../../slices/AppSlice":"aByTQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8SGd4":[function(require,module,exports,__globalThis) {
"use strict";
var Sortable = require("d0aac10df81764b4").default;
module.exports = Sortable;

},{"d0aac10df81764b4":"9jC5Y"}],"9jC5Y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("971a095401dbad2c"));
var _react = _interopRequireWildcard(require("45ffcdf537260e9b"));
var _sortablejs = _interopRequireDefault(require("ab27284b715b7b9"));
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var store = {
    nextSibling: null,
    activeComponent: null
};
var Sortable = /*#__PURE__*/ function(_Component) {
    _inherits(Sortable, _Component);
    function Sortable() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, Sortable);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Sortable)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty(_assertThisInitialized(_this), "sortable", null);
        return _this;
    }
    _createClass(Sortable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var options = _objectSpread({}, this.props.options);
                [
                    'onChoose',
                    'onStart',
                    'onEnd',
                    'onAdd',
                    'onUpdate',
                    'onSort',
                    'onRemove',
                    'onFilter',
                    'onMove',
                    'onClone'
                ].forEach(function(name) {
                    var eventHandler = options[name];
                    options[name] = function() {
                        for(var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)params[_key2] = arguments[_key2];
                        var evt = params[0];
                        if (name === 'onChoose') {
                            store.nextSibling = evt.item.nextElementSibling;
                            store.activeComponent = _this2;
                        } else if ((name === 'onAdd' || name === 'onUpdate') && _this2.props.onChange) {
                            var items = _this2.sortable.toArray();
                            var remote = store.activeComponent;
                            var remoteItems = remote.sortable.toArray();
                            var referenceNode = store.nextSibling && store.nextSibling.parentNode !== null ? store.nextSibling : null;
                            evt.from.insertBefore(evt.item, referenceNode);
                            if (remote !== _this2) {
                                var remoteOptions = remote.props.options || {};
                                if (_typeof(remoteOptions.group) === 'object' && remoteOptions.group.pull === 'clone') // Remove the node with the same data-reactid
                                evt.item.parentNode.removeChild(evt.item);
                                remote.props.onChange && remote.props.onChange(remoteItems, remote.sortable, evt);
                            }
                            _this2.props.onChange && _this2.props.onChange(items, _this2.sortable, evt);
                        }
                        if (evt.type === 'move') {
                            var _evt = params[0], originalEvent = params[1];
                            var canMove = eventHandler ? eventHandler(_evt, originalEvent) : true;
                            return canMove;
                        }
                        setTimeout(function() {
                            eventHandler && eventHandler(evt);
                        }, 0);
                    };
                });
                this.sortable = _sortablejs.default.create(this.node, options);
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                // If onChange is null, it is an UnControlled component
                // Don't let React re-render it by setting return to false
                if (!nextProps.onChange) return false;
                return true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.sortable) {
                    this.sortable.destroy();
                    this.sortable = null;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props = this.props, Component = _this$props.tag, options = _this$props.options, onChange = _this$props.onChange, props = _objectWithoutProperties(_this$props, [
                    "tag",
                    "options",
                    "onChange"
                ]);
                return _react.default.createElement(Component, _extends({}, props, {
                    ref: function ref(node) {
                        _this3.node = node;
                    }
                }));
            }
        }
    ]);
    return Sortable;
}(_react.Component);
_defineProperty(Sortable, "propTypes", {
    options: _propTypes.default.object,
    onChange: _propTypes.default.func,
    tag: _propTypes.default.oneOfType([
        _propTypes.default.string,
        _propTypes.default.func
    ]),
    style: _propTypes.default.object
});
_defineProperty(Sortable, "defaultProps", {
    options: {},
    tag: 'div',
    style: {}
});
var _default = Sortable;
exports.default = _default;

},{"971a095401dbad2c":"bnNSm","45ffcdf537260e9b":"9njXz","ab27284b715b7b9":"ccdOv"}],"ccdOv":[function(require,module,exports,__globalThis) {
/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiDrag", ()=>MultiDragPlugin);
parcelHelpers.export(exports, "Sortable", ()=>Sortable);
parcelHelpers.export(exports, "Swap", ()=>SwapPlugin);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
        return typeof obj;
    };
    else _typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var version = "1.15.6";
function userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
var captureMode = {
    capture: false,
    passive: false
};
function on(el, event, fn) {
    el.addEventListener(event, fn, !IE11OrLess && captureMode);
}
function off(el, event, fn) {
    el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}
function matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = getParentOrHost(el));
    }
    return null;
}
var R_SPACE = /\s+/g;
function toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? 'add' : 'remove'](name);
        else {
            var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
            el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
        }
    }
}
function css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, '');
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf('webkit') === -1) prop = '-webkit-' + prop;
            style[prop] = val + (typeof val === 'string' ? '' : 'px');
        }
    }
}
function matrix(el, selfOnly) {
    var appliedTransforms = '';
    if (typeof el === 'string') appliedTransforms = el;
    else do {
        var transform = css(el, 'transform');
        if (transform && transform !== 'none') appliedTransforms = transform + ' ' + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!IE11OrLess) {
            do if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt(css(container, 'border-top-width'));
                left -= containerRect.left + parseInt(css(container, 'border-left-width'));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function isScrolledPast(el, elSide, parentSide) {
    var parent = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = getRect(parent)[parentSide], visible = void 0;
        if (parentSide === 'top' || parentSide === 'left') visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === getWindowScrollingElement()) break;
        parent = getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
    if (el) do {
        var elMatrix = matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
            if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return getWindowScrollingElement();
}
function extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle(callback, ms) {
    return function() {
        if (!_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            _throttleTimeout = setTimeout(function() {
                _throttleTimeout = void 0;
            }, ms);
        }
    };
}
function cancelThrottle() {
    clearTimeout(_throttleTimeout);
    _throttleTimeout = void 0;
}
function scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function setRect(el, rect) {
    css(el, 'position', 'absolute');
    css(el, 'top', rect.top);
    css(el, 'left', rect.left);
    css(el, 'width', rect.width);
    css(el, 'height', rect.height);
}
function unsetRect(el) {
    css(el, 'position', '');
    css(el, 'top', '');
    css(el, 'left', '');
    css(el, 'width', '');
    css(el, 'height', '');
}
function getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var expando = 'Sortable' + new Date().getTime();
function AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
                animationStates.push({
                    target: child,
                    rect: getRect(child)
                });
                var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice(indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === 'function') callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === 'function') callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === 'function') callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                css(target, 'transition', '');
                css(target, 'transform', '');
                var elMatrix = matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                this.forRepaintDummy = repaint(target); // repaint
                css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                css(target, 'transform', 'translate3d(0,0,0)');
                typeof target.animated === 'number' && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    css(target, 'transition', '');
                    css(target, 'transform', '');
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function repaint(target) {
    return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var plugins = [];
var defaults = {
    initializeByDefault: true
};
var PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in defaults)if (defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = defaults[option];
        plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + 'Global';
        plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName](_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            _extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== 'undefined') sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== 'function') return;
            _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !IE11OrLess && !Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var _excluded = [
    "evt"
];
var pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = _objectWithoutProperties(_ref, _excluded);
    PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
        dragEl: dragEl,
        parentEl: parentEl,
        ghostEl: ghostEl,
        rootEl: rootEl,
        nextEl: nextEl,
        lastDownEl: lastDownEl,
        cloneEl: cloneEl,
        cloneHidden: cloneHidden,
        dragStarted: moved,
        putSortable: putSortable,
        activeSortable: Sortable.active,
        originalEvent: originalEvent,
        oldIndex: oldIndex,
        oldDraggableIndex: oldDraggableIndex,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        hideGhostForTarget: _hideGhostForTarget,
        unhideGhostForTarget: _unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            _dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function _dispatchEvent(info) {
    dispatchEvent(_objectSpread2({
        putSortable: putSortable,
        cloneEl: cloneEl,
        targetEl: dragEl,
        rootEl: rootEl,
        oldIndex: oldIndex,
        oldDraggableIndex: oldDraggableIndex,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex
    }, info));
}
var dragEl, parentEl, ghostEl, rootEl, nextEl, lastDownEl, cloneEl, cloneHidden, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, activeGroup, putSortable, awaitingDragStarted = false, ignoreNextClick = false, sortables = [], tapEvt, touchEvt, lastDx, lastDy, tapDistanceLeft, tapDistanceTop, moved, lastTarget, lastDirection, pastFirstInvertThresh = false, isCircumstantialInvert = false, targetMoveDistance, // For positioning ghost absolutely
ghostRelativeParent, ghostRelativeParentInitialScroll = [], // (left, top)
_silent = false, savedInputChecked = [];
/** @const */ var documentExists = typeof document !== 'undefined', PositionGhostAbsolutely = IOS, CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float', // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'), supportCssPointerEvents = function() {
    if (!documentExists) return;
    // false when <= IE11
    if (IE11OrLess) return false;
    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
}(), _detectDirection = function _detectDirection(el, options) {
    var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
    if (elCSS.display === 'flex') return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    if (elCSS.display === 'grid') return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
        var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
        return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }
    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
}, _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    sortables.some(function(sortable) {
        var threshold = sortable[expando].options.emptyInsertThreshold;
        if (!threshold || lastChild(sortable)) return;
        var rect = getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, _prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === 'clone') return value;
            else if (typeof value === 'function') return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || _typeof(originalGroup) != 'object') originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, _hideGhostForTarget = function _hideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) css(ghostEl, 'display', 'none');
}, _unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) css(ghostEl, 'display', '');
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if (documentExists && !ChromeForAndroid) document.addEventListener('click', function(evt) {
    if (ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        ignoreNextClick = false;
        return false;
    }
}, true);
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if (dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[expando]._onDragOver(event);
        }
    }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if (dragEl) dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function Sortable(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = _extends({}, options);
    // Export instance
    el[expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return _detectDirection(el, this.options);
        },
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        ignore: 'a, img',
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData('Text', dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: 'data-id',
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: 'sortable-fallback',
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
        supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && (!Safari || IOS),
        emptyInsertThreshold: 5
    };
    PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    _prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) on(el, 'pointerdown', this._onTapStart);
    else {
        on(el, 'mousedown', this._onTapStart);
        on(el, 'touchstart', this._onTapStart);
    }
    if (this.nativeDraggable) {
        on(el, 'dragover', this);
        on(el, 'dragenter', this);
    }
    sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    _extends(this, AnimationStateManager());
}
Sortable.prototype = /** @lends Sortable.prototype */ {
    constructor: Sortable,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        _saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if (dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') return;
        target = closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if (lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        oldIndex = index(target);
        oldDraggableIndex = index(target, options.draggable);
        // Check filter
        if (typeof filter === 'function') {
            if (filter.call(this, evt, target, this)) {
                _dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: 'filter',
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                pluginEvent('filter', _this, {
                    evt: evt
                });
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(',').some(function(criteria) {
                criteria = closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    _dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: 'filter',
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    pluginEvent('filter', _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !dragEl && target.parentNode === el) {
            var dragRect = getRect(target);
            rootEl = el;
            dragEl = target;
            parentEl = dragEl.parentNode;
            nextEl = dragEl.nextSibling;
            lastDownEl = target;
            activeGroup = options.group;
            Sortable.dragged = dragEl;
            tapEvt = {
                target: dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            tapDistanceLeft = tapEvt.clientX - dragRect.left;
            tapDistanceTop = tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            dragEl.style['will-change'] = 'all';
            dragStartFn = function dragStartFn() {
                pluginEvent('delayEnded', _this, {
                    evt: evt
                });
                if (Sortable.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!FireFox && _this.nativeDraggable) dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                _dispatchEvent({
                    sortable: _this,
                    name: 'choose',
                    originalEvent: evt
                });
                // Chosen item
                toggleClass(dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(',').forEach(function(criteria) {
                find(dragEl, criteria.trim(), _disableDraggable);
            });
            on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
            on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
            on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
            if (options.supportPointer) {
                on(ownerDocument, 'pointerup', _this._onDrop);
                // Native D&D triggers pointercancel
                !this.nativeDraggable && on(ownerDocument, 'pointercancel', _this._onDrop);
            } else {
                on(ownerDocument, 'mouseup', _this._onDrop);
                on(ownerDocument, 'touchend', _this._onDrop);
                on(ownerDocument, 'touchcancel', _this._onDrop);
            }
            // Make dragEl draggable (must be before delay for FireFox)
            if (FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                dragEl.draggable = true;
            }
            pluginEvent('delayStart', this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
                if (Sortable.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                if (options.supportPointer) {
                    on(ownerDocument, 'pointerup', _this._disableDelayedDrag);
                    on(ownerDocument, 'pointercancel', _this._disableDelayedDrag);
                } else {
                    on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                    on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                    on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                }
                on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        dragEl && _disableDraggable(dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        off(ownerDocument, 'mouseup', this._disableDelayedDrag);
        off(ownerDocument, 'touchend', this._disableDelayedDrag);
        off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
        off(ownerDocument, 'pointerup', this._disableDelayedDrag);
        off(ownerDocument, 'pointercancel', this._disableDelayedDrag);
        off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
        off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
        off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == 'touch' && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) on(document, 'pointermove', this._onTouchMove);
            else if (touch) on(document, 'touchmove', this._onTouchMove);
            else on(document, 'mousemove', this._onTouchMove);
        } else {
            on(dragEl, 'dragend', this);
            on(rootEl, 'dragstart', this._onDragStart);
        }
        try {
            if (document.selection) _nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        awaitingDragStarted = false;
        if (rootEl && dragEl) {
            pluginEvent('dragStarted', this, {
                evt: evt
            });
            if (this.nativeDraggable) on(document, 'dragover', _checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && toggleClass(dragEl, options.dragClass, false);
            toggleClass(dragEl, options.ghostClass, true);
            Sortable.active = this;
            fallback && this._appendGhost();
            // Drag start event
            _dispatchEvent({
                sortable: this,
                name: 'start',
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if (touchEvt) {
            this._lastX = touchEvt.clientX;
            this._lastY = touchEvt.clientY;
            _hideGhostForTarget();
            var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            dragEl.parentNode[expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[expando]) {
                    var inserted = void 0;
                    inserted = parent[expando]._onDragOver({
                        clientX: touchEvt.clientX,
                        clientY: touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = getParentOrHost(parent));
            _unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if (tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX = ghostEl && ghostMatrix && ghostMatrix.a, scaleY = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!Sortable.active && !awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if (ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - (lastDx || 0);
                    ghostMatrix.f += dy - (lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                css(ghostEl, 'webkitTransform', cssMatrix);
                css(ghostEl, 'mozTransform', cssMatrix);
                css(ghostEl, 'msTransform', cssMatrix);
                css(ghostEl, 'transform', cssMatrix);
                lastDx = dx;
                lastDy = dy;
                touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if (PositionGhostAbsolutely) {
                // Get relatively positioned parent
                ghostRelativeParent = container;
                while(css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document)ghostRelativeParent = ghostRelativeParent.parentNode;
                if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
                    if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
                    rect.top += ghostRelativeParent.scrollTop;
                    rect.left += ghostRelativeParent.scrollLeft;
                } else ghostRelativeParent = getWindowScrollingElement();
                ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
            }
            ghostEl = dragEl.cloneNode(true);
            toggleClass(ghostEl, options.ghostClass, false);
            toggleClass(ghostEl, options.fallbackClass, true);
            toggleClass(ghostEl, options.dragClass, true);
            css(ghostEl, 'transition', '');
            css(ghostEl, 'transform', '');
            css(ghostEl, 'box-sizing', 'border-box');
            css(ghostEl, 'margin', 0);
            css(ghostEl, 'top', rect.top);
            css(ghostEl, 'left', rect.left);
            css(ghostEl, 'width', rect.width);
            css(ghostEl, 'height', rect.height);
            css(ghostEl, 'opacity', '0.8');
            css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
            css(ghostEl, 'zIndex', '100000');
            css(ghostEl, 'pointerEvents', 'none');
            Sortable.ghost = ghostEl;
            container.appendChild(ghostEl);
            // Set transform-origin
            css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        pluginEvent('dragStart', this, {
            evt: evt
        });
        if (Sortable.eventCanceled) {
            this._onDrop();
            return;
        }
        pluginEvent('setupClone', this);
        if (!Sortable.eventCanceled) {
            cloneEl = clone(dragEl);
            cloneEl.removeAttribute("id");
            cloneEl.draggable = false;
            cloneEl.style['will-change'] = '';
            this._hideClone();
            toggleClass(cloneEl, this.options.chosenClass, false);
            Sortable.clone = cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = _nextTick(function() {
            pluginEvent('clone', _this);
            if (Sortable.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) rootEl.insertBefore(cloneEl, dragEl);
            _this._hideClone();
            _dispatchEvent({
                sortable: _this,
                name: 'clone'
            });
        });
        !fallback && toggleClass(dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            off(document, 'mouseup', _this._onDrop);
            off(document, 'touchend', _this._onDrop);
            off(document, 'touchcancel', _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = 'move';
                options.setData && options.setData.call(_this, dataTransfer, dragEl);
            }
            on(document, 'drop', _this);
            // #1276 fix:
            css(dragEl, 'transform', 'translateZ(0)');
        }
        awaitingDragStarted = true;
        _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
        on(document, 'selectstart', _this);
        moved = true;
        window.getSelection().removeAllRanges();
        if (Safari) css(document.body, 'user-select', 'none');
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if (_silent) return;
        function dragOverEvent(name, extra) {
            pluginEvent(name, _this, _objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? 'vertical' : 'horizontal',
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent('dragOverAnimationCapture');
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent('dragOverCompleted', {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    toggleClass(dragEl, options.ghostClass, true);
                }
                if (putSortable !== _this && _this !== Sortable.active) putSortable = _this;
                else if (_this === Sortable.active && putSortable) putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent('dragOverAnimationComplete');
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === dragEl && !dragEl.animated || target === el && !target.animated) lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);
            _dispatchEvent({
                sortable: _this,
                name: 'change',
                toEl: el,
                newIndex: newIndex,
                newDraggableIndex: newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = closest(target, options.draggable, el, true);
        dragOverEvent('dragOver');
        if (Sortable.eventCanceled) return completedFired;
        if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl // Reverting item into the original list
        ) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
            vertical = this._getDirection(evt, target) === 'vertical';
            dragRect = getRect(dragEl);
            dragOverEvent('dragOverValid');
            if (Sortable.eventCanceled) return completedFired;
            if (revert) {
                parentEl = rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent('revert');
                if (!Sortable.eventCanceled) {
                    if (nextEl) rootEl.insertBefore(dragEl, nextEl);
                    else rootEl.appendChild(dragEl);
                }
                return completed(true);
            }
            var elLastChild = lastChild(el, options.draggable);
            if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = getRect(target);
                if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore(dragEl, elLastChild.nextSibling);
                    else el.appendChild(dragEl);
                    parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = getChild(el, 0, options, true);
                if (firstChild === dragEl) return completed(false);
                target = firstChild;
                targetRect = getRect(target);
                if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore(dragEl, firstChild);
                    parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? 'top' : 'left', scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if (lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    pastFirstInvertThresh = false;
                    isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = index(dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = parentEl.children[dragIndex];
                    }while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                lastTarget = target;
                lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    _silent = true;
                    setTimeout(_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild(dragEl);
                    else target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    parentEl = dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains(dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        off(document, 'mousemove', this._onTouchMove);
        off(document, 'touchmove', this._onTouchMove);
        off(document, 'pointermove', this._onTouchMove);
        off(document, 'dragover', nearestEmptyInsertDetectEvent);
        off(document, 'mousemove', nearestEmptyInsertDetectEvent);
        off(document, 'touchmove', nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        off(ownerDocument, 'mouseup', this._onDrop);
        off(ownerDocument, 'touchend', this._onDrop);
        off(ownerDocument, 'pointerup', this._onDrop);
        off(ownerDocument, 'pointercancel', this._onDrop);
        off(ownerDocument, 'touchcancel', this._onDrop);
        off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        newIndex = index(dragEl);
        newDraggableIndex = index(dragEl, options.draggable);
        pluginEvent('drop', this, {
            evt: evt
        });
        parentEl = dragEl && dragEl.parentNode;
        // Get again after plugin event
        newIndex = index(dragEl);
        newDraggableIndex = index(dragEl, options.draggable);
        if (Sortable.eventCanceled) {
            this._nulling();
            return;
        }
        awaitingDragStarted = false;
        isCircumstantialInvert = false;
        pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        _cancelNextTick(this.cloneId);
        _cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            off(document, 'drop', this);
            off(el, 'dragstart', this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if (Safari) css(document.body, 'user-select', '');
        css(dragEl, 'transform', '');
        if (evt) {
            if (moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') // Remove clone(s)
            cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
            if (dragEl) {
                if (this.nativeDraggable) off(dragEl, 'dragend', this);
                _disableDraggable(dragEl);
                dragEl.style['will-change'] = '';
                // Remove classes
                // ghostClass is added in dragStarted
                if (moved && !awaitingDragStarted) toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
                toggleClass(dragEl, this.options.chosenClass, false);
                // Drag stop event
                _dispatchEvent({
                    sortable: this,
                    name: 'unchoose',
                    toEl: parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if (rootEl !== parentEl) {
                    if (newIndex >= 0) {
                        // Add event
                        _dispatchEvent({
                            rootEl: parentEl,
                            name: 'add',
                            toEl: parentEl,
                            fromEl: rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        _dispatchEvent({
                            sortable: this,
                            name: 'remove',
                            toEl: parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        _dispatchEvent({
                            rootEl: parentEl,
                            name: 'sort',
                            toEl: parentEl,
                            fromEl: rootEl,
                            originalEvent: evt
                        });
                        _dispatchEvent({
                            sortable: this,
                            name: 'sort',
                            toEl: parentEl,
                            originalEvent: evt
                        });
                    }
                    putSortable && putSortable.save();
                } else {
                    if (newIndex !== oldIndex) {
                        if (newIndex >= 0) {
                            // drag & drop within the same list
                            _dispatchEvent({
                                sortable: this,
                                name: 'update',
                                toEl: parentEl,
                                originalEvent: evt
                            });
                            _dispatchEvent({
                                sortable: this,
                                name: 'sort',
                                toEl: parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if (Sortable.active) {
                    /* jshint eqnull:true */ if (newIndex == null || newIndex === -1) {
                        newIndex = oldIndex;
                        newDraggableIndex = oldDraggableIndex;
                    }
                    _dispatchEvent({
                        sortable: this,
                        name: 'end',
                        toEl: parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        pluginEvent('nulling', this);
        rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
        savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        savedInputChecked.length = lastDx = lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case 'drop':
            case 'dragend':
                this._onDrop(evt);
                break;
            case 'dragenter':
            case 'dragover':
                if (dragEl) {
                    this._onDragOver(evt);
                    _globalDragOver(evt);
                }
                break;
            case 'selectstart':
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if (closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if (closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== 'undefined') options[name] = modifiedValue;
            else options[name] = value;
            if (name === 'group') _prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        pluginEvent('destroy', this);
        var el = this.el;
        el[expando] = null;
        off(el, 'mousedown', this._onTapStart);
        off(el, 'touchstart', this._onTapStart);
        off(el, 'pointerdown', this._onTapStart);
        if (this.nativeDraggable) {
            off(el, 'dragover', this);
            off(el, 'dragenter', this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function(el) {
            el.removeAttribute('draggable');
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        sortables.splice(sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!cloneHidden) {
            pluginEvent('hideClone', this);
            if (Sortable.eventCanceled) return;
            css(cloneEl, 'display', 'none');
            if (this.options.removeCloneOnHide && cloneEl.parentNode) cloneEl.parentNode.removeChild(cloneEl);
            cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== 'clone') {
            this._hideClone();
            return;
        }
        if (cloneHidden) {
            pluginEvent('showClone', this);
            if (Sortable.eventCanceled) return;
            // show clone at dragEl or original position
            if (dragEl.parentNode == rootEl && !this.options.group.revertClone) rootEl.insertBefore(cloneEl, dragEl);
            else if (nextEl) rootEl.insertBefore(cloneEl, nextEl);
            else rootEl.appendChild(cloneEl);
            if (this.options.group.revertClone) this.animate(dragEl, cloneEl);
            css(cloneEl, 'display', '');
            cloneHidden = false;
        }
    }
};
function _globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = 'move';
    evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !IE11OrLess && !Edge) evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent('move', true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function _disableDraggable(el) {
    el.draggable = false;
}
function _unsilent() {
    _silent = false;
}
function _ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = getRect(getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function _ghostIsLast(evt, vertical, sortable) {
    var lastElRect = getRect(lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            pastFirstInvertThresh = true;
            if (!pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - targetMoveDistance) return -lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return _getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function _getInsertDirection(target) {
    if (index(dragEl) < index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function _generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function _saveInputCheckedState(root) {
    savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && savedInputChecked.push(el);
    }
}
function _nextTick(fn) {
    return setTimeout(fn, 0);
}
function _cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if (documentExists) on(document, 'touchmove', function(evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
Sortable.utils = {
    on: on,
    off: off,
    css: css,
    find: find,
    is: function is(el, selector) {
        return !!closest(el, selector, el, false);
    },
    extend: extend,
    throttle: throttle,
    closest: closest,
    toggleClass: toggleClass,
    clone: clone,
    index: index,
    nextTick: _nextTick,
    cancelNextTick: _cancelNextTick,
    detectDirection: _detectDirection,
    getChild: getChild,
    expando: expando
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ Sortable.get = function(element) {
    return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ Sortable.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
        PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ Sortable.create = function(el, options) {
    return new Sortable(el, options);
};
// Export
Sortable.version = version;
var autoScrolls = [], scrollEl, scrollRootEl, scrolling = false, lastAutoScrollX, lastAutoScrollY, touchEvt$1, pointerElemChangedInterval;
function AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) on(document, 'dragover', this._handleAutoScroll);
            else {
                if (this.options.supportPointer) on(document, 'pointermove', this._handleFallbackAutoScroll);
                else if (originalEvent.touches) on(document, 'touchmove', this._handleFallbackAutoScroll);
                else on(document, 'mousemove', this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) off(document, 'dragover', this._handleAutoScroll);
            else {
                off(document, 'pointermove', this._handleFallbackAutoScroll);
                off(document, 'touchmove', this._handleFallbackAutoScroll);
                off(document, 'mousemove', this._handleFallbackAutoScroll);
            }
            clearPointerElemChangedInterval();
            clearAutoScrolls();
            cancelThrottle();
        },
        nulling: function nulling() {
            touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
            autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
                autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = getParentAutoScrollElement(elem, true);
                if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
                    pointerElemChangedInterval && clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    pointerElemChangedInterval = setInterval(function() {
                        var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            clearAutoScrolls();
                        }
                        autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    lastAutoScrollX = x;
                    lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
                    clearAutoScrolls();
                    return;
                }
                autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return _extends(AutoScroll, {
        pluginName: 'scroll',
        initializeByDefault: true
    });
}
function clearAutoScrolls() {
    autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    autoScrolls = [];
}
function clearPointerElemChangedInterval() {
    clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if (scrollRootEl !== rootEl) {
        scrollRootEl = rootEl;
        clearAutoScrolls();
        scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if (scrollEl === true) scrollEl = getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = scrollEl;
    do {
        var el = currentParent, rect = getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!autoScrolls[i]) autoScrolls[i] = {};
        }
        if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
            autoScrolls[layersOut].el = el;
            autoScrolls[layersOut].vx = vx;
            autoScrolls[layersOut].vy = vy;
            clearInterval(autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === 'function') {
                        if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') return;
                    }
                    scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
    scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent('spill');
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function Revert() {}
Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: drop
};
_extends(Revert, {
    pluginName: 'revertOnSpill'
});
function Remove() {}
Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: drop
};
_extends(Remove, {
    pluginName: 'removeOnSpill'
});
var lastSwapEl;
function SwapPlugin() {
    function Swap() {
        this.defaults = {
            swapClass: 'sortable-swap-highlight'
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = lastSwapEl;
                if (onMove(target) !== false) {
                    toggleClass(target, options.swapClass, true);
                    lastSwapEl = target;
                } else lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== lastSwapEl) toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);
            if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    swapNodes(dragEl, lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            lastSwapEl = null;
        }
    };
    return _extends(Swap, {
        pluginName: 'swap',
        eventProperties: function eventProperties() {
            return {
                swapItem: lastSwapEl
            };
        }
    });
}
function swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = index(n1);
    i2 = index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var multiDragElements = [], multiDragClones = [], lastMultiDragSelect, // for selection with modifier key down (SHIFT)
multiDragSortable, initialFolding = false, // Initial multi-drag fold when drag started
folding = false, // Folding any other time
dragStarted = false, dragEl$1, clonesFromRect, clonesHidden;
function MultiDragPlugin() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) on(document, 'pointerup', this._deselectMultiDrag);
            else {
                on(document, 'mouseup', this._deselectMultiDrag);
                on(document, 'touchend', this._deselectMultiDrag);
            }
        }
        on(document, 'keydown', this._checkKeyDown);
        on(document, 'keyup', this._checkKeyUp);
        this.defaults = {
            selectedClass: 'sortable-selected',
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = '';
                if (multiDragElements.length && multiDragSortable === sortable) multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? '' : ', ') + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData('Text', data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < multiDragElements.length; i++){
                multiDragClones.push(clone(multiDragElements[i]));
                multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
                multiDragClones[i].draggable = false;
                multiDragClones[i].style['will-change'] = '';
                toggleClass(multiDragClones[i], this.options.selectedClass, false);
                multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if (multiDragElements.length && multiDragSortable === sortable) {
                    insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent('clone');
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            insertMultiDragClones(false, rootEl);
            multiDragClones.forEach(function(clone) {
                css(clone, 'display', '');
            });
            cloneNowShown();
            clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            multiDragClones.forEach(function(clone) {
                css(clone, 'display', 'none');
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && multiDragSortable) multiDragSortable.multiDrag._deselectMultiDrag();
            multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = index(multiDragElement);
            });
            // Sort multi-drag elements
            multiDragElements = multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === dragEl$1) return;
                        css(multiDragElement, 'position', 'absolute');
                    });
                    var dragRect = getRect(dragEl$1, false, true, true);
                    multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === dragEl$1) return;
                        setRect(multiDragElement, dragRect);
                    });
                    folding = true;
                    initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                folding = false;
                initialFolding = false;
                if (_this2.options.animation) multiDragElements.forEach(function(multiDragElement) {
                    unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if (folding && ~multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if (multiDragElements.length > 1) {
                // Setup unfold animation
                multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: folding ? getRect(multiDragElement) : dragRect
                    });
                    unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                folding = false;
                insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = getRect(dragEl$1, false, true, true);
                    multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === dragEl$1) return;
                        setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!folding) removeMultiDragElements();
                    if (multiDragElements.length > 1) {
                        var clonesHiddenBefore = clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: clonesFromRect
                            });
                            clone.fromRect = clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                clonesFromRect = _extends({}, dragRect);
                var dragMatrix = matrix(dragEl$1, true);
                clonesFromRect.top -= dragMatrix.f;
                clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if (folding) {
                folding = false;
                removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));
                if (!~multiDragElements.indexOf(dragEl$1)) {
                    multiDragElements.push(dragEl$1);
                    dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'select',
                        targetEl: dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
                        var lastIndex = index(lastMultiDragSelect), currentIndex = index(dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) (function() {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            var filter = options.filter;
                            for(; i < n; i++){
                                if (~multiDragElements.indexOf(children[i])) continue;
                                // Check if element is draggable
                                if (!closest(children[i], options.draggable, parentEl, false)) continue;
                                // Check if element is filtered
                                var filtered = filter && (typeof filter === 'function' ? filter.call(sortable, evt, children[i], sortable) : filter.split(',').some(function(criteria) {
                                    return closest(children[i], criteria.trim(), parentEl, false);
                                }));
                                if (filtered) continue;
                                toggleClass(children[i], options.selectedClass, true);
                                multiDragElements.push(children[i]);
                                dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: 'select',
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        })();
                    } else lastMultiDragSelect = dragEl$1;
                    multiDragSortable = toSortable;
                } else {
                    multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
                    lastMultiDragSelect = null;
                    dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'deselect',
                        targetEl: dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if (dragStarted && this.isMultiDrag) {
                folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
                    var dragRect = getRect(dragEl$1), multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
                    if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!initialFolding) {
                        if (options.animation) {
                            dragEl$1.fromRect = dragRect;
                            multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== dragEl$1) {
                                    var rect = folding ? getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        removeMultiDragElements();
                        multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === index(dragEl$1)) {
                            var update = false;
                            multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent('update');
                                dispatchSortableEvent('sort');
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    multiDragElements.forEach(function(multiDragElement) {
                        unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = dragStarted = false;
            multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            off(document, 'pointerup', this._deselectMultiDrag);
            off(document, 'mouseup', this._deselectMultiDrag);
            off(document, 'touchend', this._deselectMultiDrag);
            off(document, 'keydown', this._checkKeyDown);
            off(document, 'keyup', this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof dragStarted !== "undefined" && dragStarted) return;
            // Only deselect if selection is in this sortable
            if (multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while(multiDragElements.length){
                var el = multiDragElements[0];
                toggleClass(el, this.options.selectedClass, false);
                multiDragElements.shift();
                dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: 'deselect',
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return _extends(MultiDrag, {
        // Static methods & properties
        pluginName: 'multiDrag',
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[expando];
                if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;
                if (multiDragSortable && multiDragSortable !== sortable) {
                    multiDragSortable.multiDrag._deselectMultiDrag();
                    multiDragSortable = sortable;
                }
                toggleClass(el, sortable.options.selectedClass, true);
                multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[expando], index = multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                toggleClass(el, sortable.options.selectedClass, false);
                multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if (folding && multiDragElement !== dragEl$1) newIndex = -1;
                else if (folding) newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
                else newIndex = index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: _toConsumableArray(multiDragElements),
                clones: [].concat(multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === 'ctrl') key = 'Control';
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function insertMultiDragElements(clonesInserted, rootEl) {
    multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function insertMultiDragClones(elementsInserted, rootEl) {
    multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function removeMultiDragElements() {
    multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
exports.default = Sortable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jXGJj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UserTag);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
function UserTag(props) {
    const getUserInitials = (user)=>{
        if (user === null) return '';
        return ((user.name.length == 0 ? '' : user.name.substr(0, 1)) + (user.surname === null || user.surname.length == 0 ? '' : user.surname.substr(0, 1))).toUpperCase();
    };
    const getFullUserName = (user)=>{
        if (user === null) return '';
        return (user.name + ' ' + (user.surname ?? '')).trim();
    };
    const { user, reservation, className, ...other } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
        content: getFullUserName(user) + (reservation === null ? '' : ', ' + (0, _momentDefault.default)(reservation.created).format('DD. MM. YYYY') + ' ob ' + (0, _momentDefault.default)(reservation.created).format('HH:mm:ss')),
        className: (className || '') + ' leading-normal',
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tag), {
            round: true,
            icon: "user",
            className: "p-1",
            children: getUserInitials(user)
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@blueprintjs/core":"6Mq52","moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGJmb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _customerSelect = require("../CustomerSelect");
var _customerSelectDefault = parcelHelpers.interopDefault(_customerSelect);
var _selectCustomerDialog = require("./SelectCustomerDialog");
var _selectCustomerDialogDefault = parcelHelpers.interopDefault(_selectCustomerDialog);
var _simpleSuggest = require("../SimpleSuggest");
var _simpleSuggestDefault = parcelHelpers.interopDefault(_simpleSuggest);
var _appToaster = require("../AppToaster");
var _documents = require("../Documents");
var _documentsDefault = parcelHelpers.interopDefault(_documents);
var _editInvoiceDialog = require("../business/EditInvoiceDialog");
var _editInvoiceDialogDefault = parcelHelpers.interopDefault(_editInvoiceDialog);
var _waitFiscalVerificationDialog = require("../business/WaitFiscalVerificationDialog");
var _waitFiscalVerificationDialogDefault = parcelHelpers.interopDefault(_waitFiscalVerificationDialog);
var _businessSlice = require("../../slices/BusinessSlice");
var _business = require("../../api/Business");
var _documentSlice = require("../../slices/DocumentSlice");
var _invoiceCreator = require("../../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _reservationSlice = require("../../slices/ReservationSlice");
var _reservations = require("../../api/Reservations");
var _documentsHelper = require("../../helpers/DocumentsHelper");
var _documentsHelperDefault = parcelHelpers.interopDefault(_documentsHelper);
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _userTag = require("../UserTag");
var _userTagDefault = parcelHelpers.interopDefault(_userTag);
var _appSlice = require("../../slices/AppSlice");
class EditActivityItemDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.openSelectCustomerDialog = this.openSelectCustomerDialog.bind(this);
        this.closeSelectCustomerDialog = this.closeSelectCustomerDialog.bind(this);
        this.openOfferDialog = this.openOfferDialog.bind(this);
        this.openEditInvoiceDialog = this.openEditInvoiceDialog.bind(this);
        this.closeEditInvoiceDialog = this.closeEditInvoiceDialog.bind(this);
        this.saveItem = this.saveItem.bind(this);
        this.getItem = this.getItem.bind(this);
        this.validate = this.validate.bind(this);
        this.getUserByUsername = this.getUserByUsername.bind(this);
        const default_id_channel = this.props.general_settings.activities_default_id_channel ?? -1;
        this.state = {
            item: this.props.item,
            internal_code: this.props.item === null ? null : this.props.item.internal_code,
            id_customer: this.props.item === null ? -1 : this.props.item.id_customer,
            guest_count: this.props.item === null ? 1 : this.props.item.guest_count,
            guest_child_count: this.props.item === null ? 0 : this.props.item.guest_child_count,
            note: this.props.item === null ? '' : this.props.item.note,
            id_channel: this.props.item === null ? default_id_channel : this.props.item.id_channel,
            phone: this.props.item === null ? '' : this.props.item.phone,
            email: this.props.item === null ? '' : this.props.item.email,
            reservation_date: this.props.item === null ? this.props.reservation_date : new Date(this.props.item.reservation_date),
            status: this.props.item === null ? 'new' : this.props.item.status,
            status_2: this.props.item === null ? null : this.props.item.status_2,
            deleted: this.props.item === null ? false : this.props.item.deleted,
            username: this.props.item === null ? this.props.user.username : this.props.item.username,
            select_customer_dialog_open: false,
            select_customer_dialog_surname: '',
            select_customer_dialog_item: null,
            validation_failed_fields: [],
            create_invoice_dialog_open: false,
            create_invoice_dialog_item: null,
            create_invoice_dialog_type: '',
            create_invoice_dialog_selected_advance_invoices_amounts: {},
            wait_fiscal_verification_dialog_open: false,
            wait_fiscal_verification_dialog_id_invoice: null,
            delete_requested: false
        };
    }
    openSelectCustomerDialog(query, item) {
        item = item || null;
        this.setState({
            select_customer_dialog_open: true,
            select_customer_dialog_surname: query,
            select_customer_dialog_item: item
        });
    }
    closeSelectCustomerDialog(id_customer) {
        const state = {
            select_customer_dialog_open: false
        };
        if (id_customer !== undefined) state.id_customer = id_customer;
        this.setState(state);
    }
    openOfferDialog() {
        const starts_at_arr = this.props.time_slot.starts_at.split(':');
        const time_label = starts_at_arr.length != 3 ? '00:00' : starts_at_arr[0] + ':' + starts_at_arr[1];
        let reservation_title = this.props.activity.title + " \u2022 " + time_label + " \u2022 " + (0, _momentDefault.default)(this.props.reservation_date).format('DD. MM. YYYY');
        const people_counts = [];
        if (this.props.activity.id_item !== null) {
            if (this.state.guest_count > 0) people_counts.push({
                count: this.state.guest_count,
                type: 'adult'
            });
            if (this.state.guest_child_count > 0) people_counts.push({
                count: this.state.guest_child_count,
                type: 'child'
            });
        }
        const new_item = (0, _invoiceCreatorDefault.default).CreateInvoiceFromInitialData({
            id_invoice: (0, _uuidDefault.default).v4(),
            reverse_invoice: false,
            id_customer: this.state.id_customer,
            invoice_date: (0, _momentDefault.default)().toISOString(true),
            invoice_type: 'offer',
            reservation: reservation_title,
            service_date_end: this.state.reservation_date === null ? null : (0, _momentDefault.default)(this.state.reservation_date).toISOString(true),
            service_date_start: this.state.reservation_date === null ? null : (0, _momentDefault.default)(this.state.reservation_date).toISOString(true),
            original_id_invoice: this.state.item === null ? undefined : this.state.item.id_activity_reservation,
            original_invoice_type: 'activity-reservation',
            items: people_counts.map((people_count, idx)=>{
                const item = this.props.items[this.props.activity.id_item];
                const id_price_list = (0, _priceHelperDefault.default).FindBestPriceListMatch(new Date(), item.price_lists);
                const item_price_list = id_price_list === null ? null : item.price_lists[id_price_list];
                const measuring_unit = this.props.measuring_units[item.id_measuring_unit];
                const tax_rate = item_price_list === undefined ? null : this.props.tax_rates[item_price_list.id_tax_rate];
                return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                    id_invoice_item: (0, _uuidDefault.default).v4(),
                    description: '',
                    id_item: item.id_item,
                    id_item_price_list: id_price_list,
                    id_tax_rate: item_price_list === undefined ? null : item_price_list.id_tax_rate,
                    item_measuring_unit_code: measuring_unit.title,
                    item_measuring_unit_decimal_digit_count: measuring_unit.decimal_digit_count,
                    price: item_price_list.price,
                    quantity: people_count.count,
                    discount: people_count.type == 'adult' ? 0 : this.props.activity.item_child_discount,
                    tax_rate,
                    item_type: item.type,
                    item_ean: item.ean,
                    item_title: item.title,
                    ord: idx,
                    id_warehouse: item.item_type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === null ? null : this.props.cash_registers[this.props.current_id_cash_register], this.props.warehouses)
                });
            })
        });
        this.openEditInvoiceDialog('offer', new_item, {});
    }
    openEditInvoiceDialog(type, item, selected_advance_invoices_amounts) {
        this.setState({
            create_invoice_dialog_open: true,
            create_invoice_dialog_type: type,
            create_invoice_dialog_item: item,
            create_invoice_dialog_selected_advance_invoices_amounts: selected_advance_invoices_amounts
        });
    }
    async closeEditInvoiceDialog(item, open_create_invoice_type, finish_invoice) {
        this.setState({
            create_invoice_dialog_open: false,
            create_invoice_dialog_item: null
        });
        if (item !== undefined) {
            this.props.dispatch((0, _businessSlice.addInvoice)({
                item,
                token: this.props.token
            }));
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            //self.increaseLoading();
            const new_items = await (0, _business.saveInvoice)(this.props.api_url, item, token, dispatch);
            if (new_items !== null) {
                //self.decreaseLoading();
                if (new_items.invoices !== undefined) dispatch((0, _businessSlice.addInvoices)(new_items.invoices));
                if (new_items.document_associations !== undefined) dispatch((0, _documentSlice.addDocumentAssociations)(new_items.document_associations));
                if (new_items.advance_invoice_consumptions !== undefined) dispatch((0, _businessSlice.addAdvanceInvoiceConsumptions)(new_items.advance_invoice_consumptions));
                /*for (let i=0; i<new_items.invoices.length; i++) {
					self.addAndSaveDocumentAssociation(
						new_items.invoices[i].id_invoice,
						new_items.invoices[i].invoice_type,
						self.state.reservation.id_reservation,
						'reservation'
					);
				}*/ if (finish_invoice && this.props.document_types[item.invoice_type].fiscal_verification_enabled) this.setState({
                    wait_fiscal_verification_dialog_open: true,
                    wait_fiscal_verification_dialog_id_invoice: item.id_invoice
                });
            }
        }
    }
    async saveItem() {
        const item = this.getItem();
        let new_item = {};
        if (this.state.item !== null) {
            new_item = {
                ...this.state.item
            };
            new_item.guest_count = item.guest_count;
            new_item.guest_child_count = item.guest_child_count;
            new_item.note = item.note;
            new_item.id_channel = item.id_channel == -1 ? null : item.id_channel;
            new_item.id_customer = item.id_customer;
            new_item.phone = '';
            new_item.email = '';
            new_item.reservation_date = item.reservation_date;
            new_item.status = item.status;
            new_item.status_2 = item.status_2 == '' ? null : item.status_2;
            new_item.deleted = item.deleted;
        } else new_item = {
            id_activity_reservation: -1,
            guest_count: item.guest_count,
            guest_child_count: item.guest_child_count,
            note: item.note,
            id_channel: item.id_channel == -1 ? null : item.id_channel,
            id_customer: item.id_customer,
            phone: '',
            email: '',
            status: item.status,
            status_2: item.status_2 == '' ? null : item.status_2,
            reservation_date: item.reservation_date,
            id_accommodation_item_schedule_time_slot_activity: this.props.accommodation_item_schedule_time_slot_activity.id_accommodation_item_schedule_time_slot_activity,
            username: this.state.username,
            deleted: item.deleted
        };
        if (!this.validate(new_item)) return;
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        dispatch((0, _reservationSlice.addActivityReservation)({
            item: new_item,
            token
        }));
        new_item = await (0, _reservations.saveActivityReservation)(this.props.api_url, new_item, token);
        if (new_item !== null) {
            this.setState({
                item: new_item
            });
            dispatch((0, _reservationSlice.addActivityReservation)({
                item: new_item,
                token
            }));
        }
    }
    getItem() {
        return {
            id_customer: this.state.id_customer,
            guest_count: this.state.guest_count,
            guest_child_count: this.state.guest_child_count,
            note: this.state.note,
            id_channel: this.state.id_channel,
            phone: '',
            email: '',
            reservation_date: (0, _momentDefault.default)(this.state.reservation_date).format('YYYY-MM-DD'),
            status: this.state.status,
            status_2: this.state.status_2 == '' ? null : this.state.status_2,
            deleted: this.state.status != 'reversed' && this.state.status != 'no-show' && this.state.deleted
        };
    }
    validate(item) {
        // validate missing/empty fields
        const validation_failed_fields = [];
        const validation_failed_field_titles = [];
        if (item.id_customer == -1) {
            validation_failed_fields.push('id_customer');
            validation_failed_field_titles.push('nosilec');
        }
        if (this.props.general_settings.activities_required_id_channel && item.id_channel === null) {
            validation_failed_fields.push('id_channel');
            validation_failed_field_titles.push('prodajni kanal');
        }
        this.setState({
            validation_failed_fields
        });
        if (validation_failed_fields.length > 0) {
            (0, _appToaster.AppToaster).show({
                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Za shranjevanje, izpolnite vsaj polja:",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: "\u2022 " + title
                            }, title))
                    ]
                }),
                intent: 'danger',
                icon: 'issue'
            });
            return false;
        }
        return true;
    }
    getUserByUsername(username) {
        if (this.props.users === null) return null;
        for(let id_user in this.props.users){
            const user = this.props.users[id_user];
            if (user !== undefined && user.username == username) return user;
        }
        return null;
    }
    render() {
        const customer = this.state.id_customer == -1 ? null : this.props.customers[this.state.id_customer];
        const starts_at_arr = this.props.time_slot.starts_at.split(':');
        const time_label = starts_at_arr.length != 3 ? '00:00' : starts_at_arr[0] + ':' + starts_at_arr[1];
        const weekdays = [
            'nedelja',
            'ponedeljek',
            'torek',
            'sreda',
            "\u010Detrtek",
            'petek',
            'sobota'
        ];
        // get connected documents, but ignore offers
        const documents = this.state.item === null ? [] : Object.values((0, _documentsHelperDefault.default).GetDocuments(this.props.document_associations, this.state.item.id_activity_reservation, 1)).filter((x)=>x.source_type != 'offer' && x.target_type != 'offer');
        const consider_deleted = this.state.deleted || this.state.status == 'reversed' || this.state.status == 'no-show';
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeEditActivityItemDialog(),
            className: 'edit-activity-item-dialog ' + (this.state.item === null ? '' : 'wide'),
            children: [
                !this.state.select_customer_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectCustomerDialogDefault.default), {
                    closeSelectCustomerDialog: this.closeSelectCustomerDialog,
                    surname: this.state.select_customer_dialog_surname,
                    item: this.state.select_customer_dialog_item
                }),
                !this.state.create_invoice_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editInvoiceDialogDefault.default), {
                    closeEditInvoiceDialog: this.closeEditInvoiceDialog,
                    item: this.state.create_invoice_dialog_item,
                    type: this.state.create_invoice_dialog_type,
                    selected_advance_invoices_amounts: this.state.create_invoice_dialog_selected_advance_invoices_amounts
                }),
                !this.state.wait_fiscal_verification_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _waitFiscalVerificationDialogDefault.default), {
                    closeWaitFiscalVerificationDialog: (print)=>{
                        this.setState({
                            wait_fiscal_verification_dialog_open: false
                        });
                        if (print) {
                            const invoice = this.props.invoices[this.state.wait_fiscal_verification_dialog_id_invoice];
                            if (this.props.general_settings.auto_print_type == 'a4') this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                                type: 'invoice',
                                lang: 'sl',
                                invoice
                            }));
                            else if (this.props.general_settings.auto_print_type == 'pos') this.props.dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                                type: 'invoice',
                                invoice
                            }));
                        }
                    },
                    id_invoice: this.state.wait_fiscal_verification_dialog_id_invoice
                }),
                !this.state.delete_requested ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Da",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: async ()=>{
                        this.setState({
                            deleted: true,
                            delete_requested: false
                        });
                        const new_item = this.getItem();
                        if (!this.validate(new_item)) return;
                        new_item.deleted = true;
                        this.props.closeEditActivityItemDialog(this.state.item, new_item);
                    },
                    onCancel: ()=>{
                        this.setState({
                            delete_requested: false
                        });
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Brisanje rezervacije?"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    "Rezervacija:",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: this.props.activity.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: weekdays[(0, _momentDefault.default)(this.props.reservation_date).day()] + ', ' + (0, _momentDefault.default)(this.props.reservation_date).format('DD. MM. YYYY') + ' ob ' + time_label
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mb-3",
                                children: [
                                    "Nosilec: ",
                                    this.state.id_customer === null || this.state.id_customer === undefined || this.state.id_customer == -1 || this.props.customers[this.state.id_customer] === undefined ? '' : this.props.customers[this.state.id_customer].type == 'natural' ? this.props.customers[this.state.id_customer].surname + ' ' + this.props.customers[this.state.id_customer].name : this.props.customers[this.state.id_customer].company_name
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mt-4 mb-4",
                                children: "Izbrisana rezervacija se bo evidentirala v seznamu rezervacij."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                            fixedToTop: false,
                            className: "bp5-dark",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Group, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: 'Rezervacija aktivnosti' + (this.state.internal_code === null ? '' : " \u2022 " + this.state.internal_code)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                            style: {
                                                backgroundColor: '#2c85c1'
                                            },
                                            options: [
                                                {
                                                    label: 'Nova',
                                                    value: 'new',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: 'V potrjevanju',
                                                    value: 'waiting-for-confirmation',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: 'Izdana ponudba',
                                                    value: 'offer-sent',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: 'Potrjena',
                                                    value: 'confirmed',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: 'Izdan avans',
                                                    value: 'advance-invoice-sent',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: "Pla\u010Dana",
                                                    value: 'closed',
                                                    disabled: consider_deleted
                                                },
                                                {
                                                    label: 'Stornirana',
                                                    value: 'reversed',
                                                    disabled: false
                                                },
                                                {
                                                    label: 'Neprihod',
                                                    value: 'no-show',
                                                    disabled: false
                                                }
                                            ],
                                            value: this.state.status,
                                            onChange: (e)=>{
                                                const val = e.currentTarget.value;
                                                this.setState({
                                                    status: val
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                            style: {
                                                backgroundColor: '#2c85c1'
                                            },
                                            className: "mr-6",
                                            options: [
                                                {
                                                    label: 'Izberi status po meri',
                                                    value: ''
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_1,
                                                    value: 'custom-status-1'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_2,
                                                    value: 'custom-status-2'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_3,
                                                    value: 'custom-status-3'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_4,
                                                    value: 'custom-status-4'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_5,
                                                    value: 'custom-status-5'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_6,
                                                    value: 'custom-status-6'
                                                },
                                                {
                                                    label: this.props.general_settings.title_custom_status_7,
                                                    value: 'custom-status-7'
                                                }
                                            ],
                                            value: this.state.status_2 ?? '',
                                            onChange: (e)=>{
                                                this.setState({
                                                    status_2: e.currentTarget.value
                                                });
                                            }
                                        }),
                                        this.state.item === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: false,
                                            disabled: consider_deleted,
                                            icon: "trash",
                                            text: "Izbri\u0161i",
                                            intent: "danger",
                                            className: "ml-6",
                                            onClick: ()=>{
                                                this.setState({
                                                    delete_requested: true
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Group, {
                                    align: (0, _core.Alignment).RIGHT,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userTagDefault.default), {
                                            user: this.getUserByUsername(this.state.username),
                                            reservation: this.state.item,
                                            className: "mr-2 mt-1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: ()=>this.props.closeEditActivityItemDialog()
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_BODY,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-grow flex-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: 'flex pr-2 flex-col ' + (this.state.item === null ? 'flex-1' : 'w-2/5'),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mb-6 flex flex-row justify-center text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: this.props.activity.title
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ml-2 mr-2",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: time_label
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ml-2 mr-2",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: weekdays[(0, _momentDefault.default)(this.props.reservation_date).day()] + ', ' + (0, _momentDefault.default)(this.props.reservation_date).format('DD. MM. YYYY')
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                                className: this.state.validation_failed_fields.indexOf('id_customer') == -1 ? '' : 'validation-failed',
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerSelectDefault.default), {
                                                    itemSelected: (item)=>{
                                                        this.setState({
                                                            id_customer: item.id_customer
                                                        });
                                                    },
                                                    addPersonClick: (query)=>{
                                                        this.openSelectCustomerDialog(query);
                                                    },
                                                    fieldTitle: "Nosilec"
                                                })
                                            }),
                                            customer === null || customer === undefined ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mb-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-row justify-between items-start",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "flex-1 flex flex-row",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "w-2/4",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "mb-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "opacity-50",
                                                                                        children: "Naziv:"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        children: customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "mb-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "opacity-50",
                                                                                        children: "Telefon:"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        children: customer.phone
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "mb-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "opacity-50",
                                                                                        children: "E-po\u0161ta:"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        children: customer.email
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "w-2/4",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "mb-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "opacity-50",
                                                                                        children: "\u0160tevilka stranke:"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        children: customer.internal_code
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "mb-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "opacity-50",
                                                                                        children: "Dr\u017Eava:"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        children: this.props.countries[customer.id_country].official_name_local
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                icon: "edit",
                                                                minimal: true,
                                                                onClick: ()=>{
                                                                    this.openSelectCustomerDialog('', customer);
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    customer.note === null || customer.note.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "opacity-50",
                                                                children: "Opomba:"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: customer.note
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex flex-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                        labelFor: "edit-activity-item--guest-count",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                label: "\u0160t. odraslih",
                                                                tooltip: "\u0160t. odraslih"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ControlGroup), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                        icon: "minus",
                                                                        tabIndex: "-1",
                                                                        minimal: false,
                                                                        small: true,
                                                                        onClick: ()=>{
                                                                            if (this.state.guest_count >= 1) this.setState({
                                                                                guest_count: this.state.guest_count - 1
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "w-8",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                                                            id: "edit-activity-item--guest-count",
                                                                            className: "centered-numeric-input",
                                                                            fill: true,
                                                                            buttonPosition: "none",
                                                                            value: this.state.guest_count,
                                                                            min: 0,
                                                                            onValueChange: (val)=>{
                                                                                this.setState({
                                                                                    guest_count: val
                                                                                });
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                        icon: "plus",
                                                                        tabIndex: "-1",
                                                                        minimal: false,
                                                                        small: true,
                                                                        onClick: ()=>{
                                                                            this.setState({
                                                                                guest_count: this.state.guest_count + 1
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                        labelFor: "edit-activity-item--guest-child-count",
                                                        className: "ml-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                label: "\u0160t. otrok",
                                                                tooltip: "\u0160t. otrok"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ControlGroup), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                        icon: "minus",
                                                                        tabIndex: "-1",
                                                                        minimal: false,
                                                                        small: true,
                                                                        onClick: ()=>{
                                                                            if (this.state.guest_child_count >= 1) this.setState({
                                                                                guest_child_count: this.state.guest_child_count - 1
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "w-8",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                                                            id: "edit-activity-item--guest-child-count",
                                                                            className: "centered-numeric-input",
                                                                            fill: true,
                                                                            buttonPosition: "none",
                                                                            value: this.state.guest_child_count,
                                                                            min: 0,
                                                                            onValueChange: (val)=>{
                                                                                this.setState({
                                                                                    guest_child_count: val
                                                                                });
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                        icon: "plus",
                                                                        tabIndex: "-1",
                                                                        minimal: false,
                                                                        small: true,
                                                                        onClick: ()=>{
                                                                            this.setState({
                                                                                guest_child_count: this.state.guest_child_count + 1
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                        labelFor: "edit-activity-item--channel-input",
                                                        className: 'ml-4 flex-1 ' + (this.state.validation_failed_fields.indexOf('id_channel') == -1 ? '' : 'validation-failed'),
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                label: "Prodajni kanal",
                                                                tooltip: "Prodajni kanal"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                                id: "id_channel",
                                                                fill: true,
                                                                options: [
                                                                    {
                                                                        label: 'Izberi prodajni kanal',
                                                                        value: -1
                                                                    }
                                                                ].concat(Object.values(this.props.channels).sort((a, b)=>a.ord - b.ord).map((item)=>{
                                                                    return {
                                                                        label: item.title,
                                                                        value: item.id_channel
                                                                    };
                                                                })),
                                                                value: this.state.id_channel,
                                                                onChange: (e)=>{
                                                                    this.setState({
                                                                        id_channel: e.currentTarget.value
                                                                    });
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "edit-activity-item--note",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Opomba",
                                                        tooltip: "Opomba"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                        id: "edit-activity-item--note",
                                                        growVertically: true,
                                                        fill: true,
                                                        style: {
                                                            minHeight: '6rem'
                                                        },
                                                        onChange: (e)=>{
                                                            this.setState({
                                                                note: e.target.value
                                                            });
                                                        },
                                                        value: this.state.note
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    this.state.item === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex w-3/5 pl-2 flex-col",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overflow-y-auto activity-item-dialog-documents",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentsDefault.default), {
                                                id_document: this.state.item.id_activity_reservation,
                                                deep: true,
                                                document_type: "activity-reservation"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                children: [
                                    this.props.setCurrentDate === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        style: {
                                            marginLeft: 0
                                        },
                                        onClick: ()=>this.props.setCurrentDate(this.state.reservation_date),
                                        children: "Prika\u017Ei termin"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        disabled: this.state.item === null,
                                        style: this.props.setCurrentDate === null ? {
                                            marginLeft: 0
                                        } : {},
                                        onClick: ()=>this.openOfferDialog(),
                                        children: "Izdelaj ponudbo"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex-1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        minimal: true,
                                        onClick: ()=>this.props.closeEditActivityItemDialog(),
                                        children: "Prekli\u010Di"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        onClick: ()=>this.saveItem(),
                                        children: "Shrani"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: (0, _core.Intent).PRIMARY,
                                        onClick: ()=>{
                                            const new_item = this.getItem();
                                            if (!this.validate(new_item)) return;
                                            this.props.closeEditActivityItemDialog(this.state.item, new_item);
                                        },
                                        children: "Shrani in zapri"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
}
EditActivityItemDialog.propTypes = {
    closeEditActivityItemDialog: (0, _propTypesDefault.default).func,
    surname: (0, _propTypesDefault.default).string
};
function mapStateToProps(state) {
    return {
        countries: state.CodeTablesSlice.countries,
        channels: state.CodeTablesSlice.channels,
        customers: state.CodeTablesSlice.customers,
        items: state.CodeTablesSlice.items,
        measuring_units: state.CodeTablesSlice.measuring_units,
        tax_rates: state.CodeTablesSlice.tax_rates,
        warehouses: state.CodeTablesSlice.warehouses,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        users: state.UserSlice.users,
        api_url: state.ConstantsSlice.api_url,
        document_types: state.DocumentSlice.document_types,
        document_associations: state.DocumentSlice.document_associations_id_documents,
        invoices: state.BusinessSlice.invoices,
        general_settings: state.SettingsSlice.general,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        cash_registers: state.CashRegisterSlice.cash_registers
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(EditActivityItemDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","moment":"1e4qG","uuid":"b52pV","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../CustomerSelect":"8sizu","./SelectCustomerDialog":"ewc5P","../SimpleSuggest":"82Xt0","../AppToaster":"izixN","../Documents":"jYQ4x","../business/EditInvoiceDialog":"kxL93","../business/WaitFiscalVerificationDialog":"bvSNl","../../slices/BusinessSlice":"47JXm","../../api/Business":"fC7Hd","../../slices/DocumentSlice":"6gdAm","../../helpers/InvoiceCreator":"d7VsE","../../slices/ReservationSlice":"kTPna","../../api/Reservations":"8B3n3","../../helpers/DocumentsHelper":"ep63y","../../helpers/Invoice":"jffQW","../../helpers/PriceHelper":"91cdD","../UserTag":"jXGJj","../../slices/AppSlice":"aByTQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f3krn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
class Dashboard extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {};
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('dashboard') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col flex-grow dashboard",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "text-2xl text-center pt-4 font-thin",
                    children: "Nadzorna plo\u0161\u010Da"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-1 dashboard-grid",
                    children: [
                        (this.props.user.access_roles ?? []).indexOf('dashboard--todo') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dashboard-item dashboard-item-1 shadow-md",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "dashboard-item-title",
                                    children: "Opomniki"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "stats-counter",
                                    children: [
                                        'test',
                                        'lodgge'
                                    ].indexOf(this.props.client) === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex flex-row mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "mr-4",
                                                        children: "11.10."
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "mr-2",
                                                        children: "AP 100"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex-1 text-right",
                                                        children: "Zamenjaj \u017Earnico"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex flex-row mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "mr-4",
                                                        children: "11.10."
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "mr-2",
                                                        children: "AP 100"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex-1 text-right",
                                                        children: "Zamenjaj WC \u0161koljko"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (this.props.user.access_roles ?? []).indexOf('dashboard--check-in') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dashboard-item dashboard-item-2 shadow-md",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "dashboard-item-title",
                                    children: "Prijave"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "stats-counter",
                                    children: [
                                        [
                                            'test',
                                            'lodgge'
                                        ].indexOf(this.props.client) === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mb-8",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "flex flex-row border-b mb-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: "Torek, 11.10."
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "flex-1 text-right",
                                                                        children: "6 oseb"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "pl-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "flex flex-row mb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "mr-2",
                                                                                children: "4 osebe"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "flex-1 text-right",
                                                                                children: "Matej Vertelj, soba 102"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "ml-2 w-8 text-right",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                    src: "images/flags/si.svg",
                                                                                    style: {
                                                                                        display: 'inline-block',
                                                                                        height: 12
                                                                                    }
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "flex flex-row mb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "mr-2",
                                                                                children: "2 osebi"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "flex-1 text-right",
                                                                                children: "Miha Vertelj, soba 99"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "ml-2 w-8 text-right",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                    src: "images/flags/si.svg",
                                                                                    style: {
                                                                                        display: 'inline-block',
                                                                                        height: 12
                                                                                    }
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "flex flex-row border-b mb-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: "Sreda, 12.10."
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "flex-1 text-right",
                                                                        children: "4 osebe"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "pl-4",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex flex-row mb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "mr-2",
                                                                            children: "4 osebe"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "flex-1 text-right",
                                                                            children: "Matej Vertelj, soba 23"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "ml-2 w-8 text-right",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                src: "images/flags/at.svg",
                                                                                style: {
                                                                                    display: 'inline-block',
                                                                                    height: 12
                                                                                }
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "mb-4 opacity-50",
                                            children: [
                                                'test',
                                                'lodgge'
                                            ].indexOf(this.props.client) === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "border-b mb-2 text-center",
                                                        children: "\u017De prijavljeni"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-row mb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "w-24",
                                                                children: "8.11. ob 11:45"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "mr-2",
                                                                children: "4 osebe"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "flex-1 text-right",
                                                                children: "Matej Vertelj, soba 102"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "ml-2 w-8 text-right",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: "images/flags/si.svg",
                                                                    style: {
                                                                        display: 'inline-block',
                                                                        height: 12
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-row mb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "w-24",
                                                                children: "7.11. ob 16:14"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "mr-2",
                                                                children: "2 osebi"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "flex-1 text-right",
                                                                children: "Miha Vertelj, soba 99"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "ml-2 w-8 text-right",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: "images/flags/si.svg",
                                                                    style: {
                                                                        display: 'inline-block',
                                                                        height: 12
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        (this.props.user.access_roles ?? []).indexOf('dashboard--check-out') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dashboard-item dashboard-item-3 shadow-md",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "dashboard-item-title",
                                    children: "Odjave"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "stats-counter",
                                    children: [
                                        'test',
                                        'lodgge'
                                    ].indexOf(this.props.client) === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mb-8",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "flex flex-row border-b mb-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: "Torek, 11.10."
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "flex-1 text-right",
                                                                        children: "6 oseb"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "pl-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "flex flex-row mb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "mr-2",
                                                                                children: "4 osebe"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "flex-1 text-right",
                                                                                children: "Matej Vertelj, soba 102, 12:00"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "ml-2 w-8 text-right",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                    src: "images/flags/si.svg",
                                                                                    style: {
                                                                                        display: 'inline-block',
                                                                                        height: 12
                                                                                    }
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "flex flex-row mb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "mr-2",
                                                                                children: "2 osebi"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "flex-1 text-right",
                                                                                children: "Miha Vertelj, soba 102, 12:00"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "ml-2 w-8 text-right",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                    src: "images/flags/si.svg",
                                                                                    style: {
                                                                                        display: 'inline-block',
                                                                                        height: 12
                                                                                    }
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "flex flex-row border-b mb-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: "Sreda, 12.10."
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "flex-1 text-right",
                                                                        children: "4 osebe"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "pl-4",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex flex-row mb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "mr-2",
                                                                            children: "4 osebe"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "flex-1 text-right",
                                                                            children: "Matej Vertelj, soba 102, 12:00"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "ml-2 w-8 text-right",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                src: "images/flags/at.svg",
                                                                                style: {
                                                                                    display: 'inline-block',
                                                                                    height: 12
                                                                                }
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mb-4 opacity-50",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "border-b mb-2 text-center",
                                                        children: "\u017De odjavljeni"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-row mb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "w-24",
                                                                children: "8.11. ob 11:45"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "mr-2",
                                                                children: "4 osebe"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "flex-1 text-right",
                                                                children: "Matej Vertelj, soba 102"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "ml-2 w-8 text-right",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: "images/flags/si.svg",
                                                                    style: {
                                                                        display: 'inline-block',
                                                                        height: 12
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-row mb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "w-24",
                                                                children: "7.11. ob 16:14"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "mr-2",
                                                                children: "2 osebi"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "flex-1 text-right",
                                                                children: "Miha Vertelj, soba 102"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "ml-2 w-8 text-right",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: "images/flags/si.svg",
                                                                    style: {
                                                                        display: 'inline-block',
                                                                        height: 12
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
function mapStateToProps(state) {
    return {
        client: state.ConstantsSlice.client,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Dashboard);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i8GW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditCountry = require("./AddEditCountry");
var _addEditCountryDefault = parcelHelpers.interopDefault(_addEditCountry);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "ISO koda - 2 \u010Drki",
                        fieldName: "iso_3166_1_a2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "ISO koda - 3 \u010Drke",
                        fieldName: "iso_3166_1_a3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 5,
                        ...sort_props,
                        title: "ISO koda - \u0161tevil\u010Dno",
                        fieldName: "iso_3166_1_n3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 6,
                        ...sort_props,
                        title: "Uradni naziv",
                        fieldName: "official_name_international"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 7,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "official_name_local"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.iso_3166_1_a2,
                            onChange: (event)=>handleFilterChange('iso_3166_1_a2', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.iso_3166_1_a3,
                            onChange: (event)=>handleFilterChange('iso_3166_1_a3', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 5,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.iso_3166_1_n3,
                            onChange: (event)=>handleFilterChange('iso_3166_1_n3', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 6,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.official_name_international,
                            onChange: (event)=>handleFilterChange('official_name_international', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 7,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.name,
                            onChange: (event)=>handleFilterChange('name', event)
                        })
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: item.iso_3166_1_a2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: item.iso_3166_1_a3
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: item.iso_3166_1_n3
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            child: item.official_name_international
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            child: item.official_name_local
                        })
                    ]
                }, 'countries-result--result-' + id);
            })
        ]
    });
}
//function Test() {
//	const {
//		CodeTablesSlice,
//	} = useSelector((state: RootState) => state);
//	
//	return <div>country count: { Object.keys(CodeTablesSlice.countries).length }</div>;
//}
class Countries extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: '',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                name: '',
                iso_3166_1_a3: '',
                iso_3166_1_a2: '',
                iso_3166_1_n3: '',
                official_name_international: ''
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.countries != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.countries);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        //TODO refresh sorting
        //TODO call this.filterTableItems(new_filters);
        return {
            table_items: props.countries,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = this.state.table_items[a_key][field];
            const b = this.state.table_items[b_key][field];
            if (field == 'official_name_local' || field == 'official_name_international') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_name = filters.name.toUpperCase();
        const filters_iso_3166_1_a3 = filters.iso_3166_1_a3.toUpperCase();
        const filters_iso_3166_1_a2 = filters.iso_3166_1_a2.toUpperCase();
        const filters_iso_3166_1_n3 = filters.iso_3166_1_n3.toUpperCase();
        const filters_official_name_international = filters.official_name_international.toUpperCase();
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_name != '' && item.official_name_local.toUpperCase().indexOf(filters_name) == -1) return false;
            if (filters_iso_3166_1_a3 != '' && item.iso_3166_1_a3.toUpperCase().indexOf(filters_iso_3166_1_a3) == -1) return false;
            if (filters_iso_3166_1_a2 != '' && item.iso_3166_1_a2.toUpperCase().indexOf(filters_iso_3166_1_a2) == -1) return false;
            if (filters_iso_3166_1_n3 != '' && item.iso_3166_1_n3.toString().indexOf(filters_iso_3166_1_n3) == -1) return false;
            if (filters_official_name_international != '' && item.official_name_international.toUpperCase().indexOf(filters_official_name_international) == -1) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            name: this.state.table_items_filters.name,
            iso_3166_1_a3: this.state.table_items_filters.iso_3166_1_a3,
            iso_3166_1_a2: this.state.table_items_filters.iso_3166_1_a2,
            iso_3166_1_n3: this.state.table_items_filters.iso_3166_1_n3,
            official_name_international: this.state.table_items_filters.official_name_international
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addCountry)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deleteCountry)(this.state.item_delete_requested.id_country));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditCountryDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow countries-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
Countries.propTypes = {};
function mapStateToProps(state) {
    return {
        countries: state.CodeTablesSlice.countries,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Countries);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditCountry":"ib41A","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ib41A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
class AddEditCountry extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_country: props.item === null ? -1 : props.item.id_country,
            common_name_international: props.item === null ? '' : props.item.common_name_international,
            official_name_international: props.item === null ? '' : props.item.official_name_international,
            common_name_local: props.item === null ? '' : props.item.common_name_local,
            official_name_local: props.item === null ? '' : props.item.official_name_local,
            iso_3166_1_a2: props.item === null ? '' : props.item.iso_3166_1_a2,
            iso_3166_1_a3: props.item === null ? '' : props.item.iso_3166_1_a3,
            iso_3166_1_n3: props.item === null ? '' : props.item.iso_3166_1_n3,
            currency: props.item === null ? '' : props.item.currency,
            calling_code: props.item === null ? '' : props.item.calling_code,
            validation_failed_fields: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-country-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi dr\u017Eavo"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-country-dialog--common_name_international",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('common_name_international') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-country-dialog--common_name_international",
                                            value: this.state.common_name_international,
                                            onChange: (event)=>{
                                                this.setState({
                                                    common_name_international: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-country-dialog--official_name_international",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('official_name_international') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Uradni naziv",
                                            tooltip: "Uradni naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-country-dialog--official_name_international",
                                            value: this.state.official_name_international,
                                            onChange: (event)=>{
                                                this.setState({
                                                    official_name_international: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-country-dialog--common_name_local",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('common_name_local') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Lokalni naziv",
                                            tooltip: "Lokalni Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-country-dialog--common_name_local",
                                            value: this.state.common_name_local,
                                            onChange: (event)=>{
                                                this.setState({
                                                    common_name_local: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-country-dialog--official_name_local",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('official_name_local') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Lokalni uradni naziv",
                                            tooltip: "Lokalni uradni naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-country-dialog--official_name_local",
                                            value: this.state.official_name_local,
                                            onChange: (event)=>{
                                                this.setState({
                                                    official_name_local: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-country-dialog--iso_3166_1_a2",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('iso_3166_1_a2') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "ISO 3166-1 koda (2 \u010Drki)",
                                            tooltip: "ISO 3166-1 koda (2 \u010Drki)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-country-dialog--iso_3166_1_a2",
                                            value: this.state.iso_3166_1_a2,
                                            onChange: (event)=>{
                                                this.setState({
                                                    iso_3166_1_a2: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-country-dialog--iso_3166_1_a3",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('iso_3166_1_a3') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "ISO 3166-1 koda (3 \u010Drke)",
                                            tooltip: "ISO 3166-1 koda (3 \u010Drke)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-country-dialog--iso_3166_1_a3",
                                            value: this.state.iso_3166_1_a3,
                                            onChange: (event)=>{
                                                this.setState({
                                                    iso_3166_1_a3: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-country-dialog--iso_3166_1_n3",
                                    className: this.state.validation_failed_fields.indexOf('iso_3166_1_n3') == -1 ? '' : 'validation-failed',
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "ISO 3166-1 koda (3 cifre)",
                                            tooltip: "ISO 3166-1 koda (3 cifre)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                            id: "add-edit-country-dialog--iso_3166_1_n3",
                                            fill: true,
                                            min: 0,
                                            value: this.state.iso_3166_1_n3,
                                            onValueChange: (val)=>{
                                                this.setState({
                                                    iso_3166_1_n3: val
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-country-dialog--currency",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('currency') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Koda valute",
                                            tooltip: "Koda valute"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-country-dialog--currency",
                                            value: this.state.currency,
                                            onChange: (event)=>{
                                                this.setState({
                                                    currency: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-country-dialog--calling_code",
                                    className: this.state.validation_failed_fields.indexOf('calling_code') == -1 ? '' : 'validation-failed',
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Klicna koda (brez +)",
                                            tooltip: "Klicna koda (brez +)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                            id: "add-edit-country-dialog--calling_code",
                                            fill: true,
                                            min: 0,
                                            value: this.state.calling_code,
                                            onValueChange: (val)=>{
                                                this.setState({
                                                    calling_code: val
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_country: this.state.id_country,
                                            common_name_international: this.state.common_name_international,
                                            official_name_international: this.state.official_name_international,
                                            common_name_local: this.state.common_name_local,
                                            official_name_local: this.state.official_name_local,
                                            iso_3166_1_a2: this.state.iso_3166_1_a2,
                                            iso_3166_1_a3: this.state.iso_3166_1_a3,
                                            iso_3166_1_n3: this.state.iso_3166_1_n3,
                                            currency: this.state.currency,
                                            calling_code: this.state.calling_code,
                                            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.common_name_international.length == 0) {
                                            validation_failed_fields.push('common_name_international');
                                            validation_failed_field_titles.push('Naziv');
                                        }
                                        if (new_item.official_name_international.length == 0) {
                                            validation_failed_fields.push('official_name_international');
                                            validation_failed_field_titles.push('Uradni naziv');
                                        }
                                        if (new_item.common_name_local.length == 0) {
                                            validation_failed_fields.push('common_name_local');
                                            validation_failed_field_titles.push('Lokalni naziv');
                                        }
                                        if (new_item.official_name_local.length == 0) {
                                            validation_failed_fields.push('official_name_local');
                                            validation_failed_field_titles.push('Lokalni uradni naziv');
                                        }
                                        if (new_item.iso_3166_1_a2.length == 0) {
                                            validation_failed_fields.push('iso_3166_1_a2');
                                            validation_failed_field_titles.push("ISO 3166-1 koda (2 \u010Drki)");
                                        }
                                        if (new_item.iso_3166_1_a3.length == 0) {
                                            validation_failed_fields.push('iso_3166_1_a3');
                                            validation_failed_field_titles.push("ISO 3166-1 koda (3 \u010Drke)");
                                        }
                                        if (new_item.iso_3166_1_n3.length == 0) {
                                            validation_failed_fields.push('iso_3166_1_n3');
                                            validation_failed_field_titles.push('ISO 3166-1 koda (3 cifre)');
                                        }
                                        if (new_item.currency.length == 0) {
                                            validation_failed_fields.push('currency');
                                            validation_failed_field_titles.push('Koda valute');
                                        }
                                        if (new_item.calling_code.length == 0) {
                                            validation_failed_fields.push('calling_code');
                                            validation_failed_field_titles.push('Klicna koda (brez +)');
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        if (new_item.iso_3166_1_a2.length != 2) {
                                            validation_failed_fields.push('iso_3166_1_a2');
                                            this.setState({
                                                validation_failed_fields
                                            });
                                            (0, _appToaster.AppToaster).show({
                                                message: "ISO 3166-1 koda (2 \u010Drki) mora vsebovati to\u010Dno 2 znaka",
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        if (new_item.iso_3166_1_a3.length != 3) {
                                            validation_failed_fields.push('iso_3166_1_a3');
                                            this.setState({
                                                validation_failed_fields
                                            });
                                            (0, _appToaster.AppToaster).show({
                                                message: "ISO 3166-1 koda (3 \u010Drke) mora vsebovati to\u010Dno 3 znake",
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        if (new_item.iso_3166_1_n3 < 100 || new_item.iso_3166_1_n3 > 999) {
                                            validation_failed_fields.push('new_item.iso_3166_1_n3');
                                            this.setState({
                                                validation_failed_fields
                                            });
                                            (0, _appToaster.AppToaster).show({
                                                message: 'ISO 3166-1 koda (3 cifre) mora biti med 100 in 999',
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditCountry.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = AddEditCountry;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g9R6b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditMeasuringUnit = require("./AddEditMeasuringUnit");
var _addEditMeasuringUnitDefault = parcelHelpers.interopDefault(_addEditMeasuringUnit);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 4,
                        title: "\u0160tevilo decimalk"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 5,
                        ...sort_props,
                        title: "Aktiven",
                        fieldName: "visible"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 6,
                        ...sort_props,
                        title: "Vrstni red",
                        fieldName: "ord"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.title,
                            onChange: (event)=>handleFilterChange('title', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 5,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                            checked: tableItemsFilters.visible === 1,
                            indeterminate: tableItemsFilters.visible === 0,
                            onChange: (event)=>{
                                let checked = 0;
                                if (tableItemsFilters.visible === 1) checked = -1;
                                else if (tableItemsFilters.visible === 0) checked = 1;
                                handleFilterChange('visible', checked);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 6
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: item.title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: item.decimal_digit_count.toString()
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: item.visible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "tick",
                                color: "#394b59"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "cross",
                                color: "#ff0000"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "text-right",
                            child: item.ord
                        })
                    ]
                }, 'countries-result--result-' + id);
            })
        ]
    });
}
class MeasuringUnits extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'ord',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                title: '',
                visible: 0
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
        this.state.table_items_sort_ids = this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, this.state.table_items_filtered_ids, table_items, true);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.measuring_units != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.measuring_units);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const table_items_sort_ids = this.state === undefined ? sort_ids : this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, ids, props.measuring_units, true);
        return {
            table_items: props.measuring_units,
            table_items_sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, items, only_return) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        items = items || this.state.table_items;
        only_return = only_return || false;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = items[a_key][field];
            const b = items[b_key][field];
            if (field == 'title') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        if (only_return) return ids;
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_title = filters.title.toUpperCase();
        const filters_visible = filters.visible;
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            if (filters_visible !== 0 && (item.visible === true && filters_visible === -1 || item.visible === false && filters_visible === 1)) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            title: this.state.table_items_filters.title,
            visible: this.state.table_items_filters.visible
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addMeasuringUnit)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deleteMeasuringUnit)(this.state.item_delete_requested.id_measuring_unit));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditMeasuringUnitDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow measuring-units-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
MeasuringUnits.propTypes = {};
function mapStateToProps(state) {
    return {
        measuring_units: state.CodeTablesSlice.measuring_units,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(MeasuringUnits);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditMeasuringUnit":"7hMoO","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7hMoO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
class AddEditMeasuringUnit extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_measuring_unit: props.item === null ? -1 : props.item.id_measuring_unit,
            title: props.item === null ? '' : props.item.title,
            decimal_digit_count: props.item === null ? 0 : props.item.decimal_digit_count,
            ord: props.item === null ? 1 : props.item.ord,
            visible: props.item === null ? true : props.item.visible,
            validation_failed_fields: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-measuring-unit-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi merilno enoto"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-measuring-unit-dialog--visible",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Aktiven",
                                            tooltip: "Aktiven"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: this.state.visible,
                                            onChange: (event)=>{
                                                this.setState({
                                                    visible: event.target.checked
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-measuring-unit-dialog--title",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('title') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-measuring-unit-dialog--title",
                                            value: this.state.title,
                                            onChange: (event)=>{
                                                this.setState({
                                                    title: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-measuring-unit-dialog--decimal-digit-count",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "\u0160tevilo decimalk",
                                            tooltip: "\u0160tevilo decimalk"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                            id: "add-edit-measuring-unit-dialog--decimal-digit-count",
                                            value: this.state.decimal_digit_count,
                                            min: 0,
                                            minorStepSize: 1,
                                            onValueChange: (val)=>{
                                                this.setState({
                                                    decimal_digit_count: val
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-measuring-unit-dialog--ord",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Vrstni red",
                                            tooltip: "Vrstni red"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                            id: "add-edit-measuring-unit-dialog--ord",
                                            value: this.state.ord,
                                            min: 0,
                                            minorStepSize: 1,
                                            onValueChange: (val)=>{
                                                this.setState({
                                                    ord: val
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_measuring_unit: this.state.id_measuring_unit,
                                            title: this.state.title,
                                            decimal_digit_count: this.state.decimal_digit_count,
                                            ord: this.state.ord,
                                            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code,
                                            visible: this.state.visible
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.title.length == 0) {
                                            validation_failed_fields.push('title');
                                            validation_failed_field_titles.push('naziv');
                                        }
                                        if (new_item.decimal_digit_count.length == 0) {
                                            validation_failed_fields.push('decimal_digit_count');
                                            validation_failed_field_titles.push("\u0161tevilo decimalk");
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditMeasuringUnit.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = AddEditMeasuringUnit;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8XhRw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditPaymentType = require("./AddEditPaymentType");
var _addEditPaymentTypeDefault = parcelHelpers.interopDefault(_addEditPaymentType);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const type_titles = {
        'cash': 'Gotovina',
        'cash-card': "Pla\u010Dilne kartice",
        'credit-card': 'Kartice',
        'bank-transfer': 'TRR',
        'gift-card': 'Bon',
        'other': 'Drugo'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Tip pla\u010Dila",
                        fieldName: "type"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 5,
                        ...sort_props,
                        title: "Aktiven",
                        fieldName: "visible"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 6,
                        ...sort_props,
                        title: "Prika\u017Ei na bl. dok.",
                        fieldName: "show_in_cash_register_document"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 7,
                        ...sort_props,
                        title: "Vrstni red",
                        fieldName: "ord"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.title,
                            onChange: (event)=>handleFilterChange('title', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 5,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                            checked: tableItemsFilters.visible === 1,
                            indeterminate: tableItemsFilters.visible === 0,
                            onChange: (event)=>{
                                let checked = 0;
                                if (tableItemsFilters.visible === 1) checked = -1;
                                else if (tableItemsFilters.visible === 0) checked = 1;
                                handleFilterChange('visible', checked);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 6,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                            checked: tableItemsFilters.show_in_cash_register_document === 1,
                            indeterminate: tableItemsFilters.show_in_cash_register_document === 0,
                            onChange: (event)=>{
                                let checked = 0;
                                if (tableItemsFilters.show_in_cash_register_document === 1) checked = -1;
                                else if (tableItemsFilters.show_in_cash_register_document === 0) checked = 1;
                                handleFilterChange('show_in_cash_register_document', checked);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 7
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: type_titles[item.type] || item.type
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: item.title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: item.visible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "tick",
                                color: "#394b59"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "cross",
                                color: "#ff0000"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            child: item.show_in_cash_register_document ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "tick",
                                color: "#394b59"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "cross",
                                color: "#ff0000"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "text-right",
                            child: item.ord
                        })
                    ]
                }, 'payment-types-result--result-' + id);
            })
        ]
    });
}
class PaymentTypes extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'ord',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                title: '',
                visible: 0,
                show_in_cash_register_document: 0
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
        this.state.table_items_sort_ids = this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, this.state.table_items_filtered_ids, table_items, true);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.payment_types != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.payment_types);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const table_items_sort_ids = this.state === undefined ? sort_ids : this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, ids, props.payment_types, true);
        return {
            table_items: props.payment_types,
            table_items_sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, items, only_return) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        items = items || this.state.table_items;
        only_return = only_return || false;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = items[a_key][field];
            const b = items[b_key][field];
            if (field == 'type' || field == 'title') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        if (only_return) return ids;
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_title = filters.title.toUpperCase();
        const filters_visible = filters.visible;
        const filters_show_in_cash_register_document = filters.show_in_cash_register_document;
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            if (filters_visible !== 0 && (item.visible === true && filters_visible === -1 || item.visible === false && filters_visible === 1)) return false;
            if (filters_show_in_cash_register_document !== 0 && (item.show_in_cash_register_document === true && filters_show_in_cash_register_document === -1 || item.show_in_cash_register_document === false && filters_show_in_cash_register_document === 1)) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            title: this.state.table_items_filters.title,
            visible: this.state.table_items_filters.visible,
            show_in_cash_register_document: this.state.table_items_filters.show_in_cash_register_document
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addPaymentType)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deletePaymentType)(this.state.item_delete_requested.id_payment_type));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditPaymentTypeDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow payment-types-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
PaymentTypes.propTypes = {};
function mapStateToProps(state) {
    return {
        payment_types: state.CodeTablesSlice.payment_types,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(PaymentTypes);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditPaymentType":"c7C3h","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7C3h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
class AddEditPaymentType extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_payment_type: props.item === null ? -1 : props.item.id_payment_type,
            type: props.item === null ? '' : props.item.type,
            title: props.item === null ? '' : props.item.title,
            visible: props.item === null ? true : props.item.visible,
            show_in_cash_register_document: props.item === null ? true : props.item.show_in_cash_register_document,
            ord: props.item === null ? 1 : props.item.ord,
            validation_failed_fields: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-payment-type-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi na\u010Din pla\u010Dila"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-payment-type-dialog--type",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('type') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Tip pla\u010Dila",
                                            tooltip: "Tip pla\u010Dila"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                            id: "add-edit-payment-type-dialog--type",
                                            fill: true,
                                            options: [
                                                {
                                                    title: 'Gotovina',
                                                    value: 'cash'
                                                },
                                                {
                                                    title: 'Kartice',
                                                    value: 'credit-card'
                                                },
                                                {
                                                    title: 'TRR',
                                                    value: 'bank-transfer'
                                                },
                                                {
                                                    title: 'Bon',
                                                    value: 'gift-card'
                                                },
                                                {
                                                    title: 'Drugo',
                                                    value: 'other'
                                                }
                                            ].map((item)=>{
                                                return {
                                                    label: item.title,
                                                    value: item.value
                                                };
                                            }),
                                            value: this.state.type,
                                            onChange: (e)=>{
                                                this.setState({
                                                    type: e.currentTarget.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-payment-type-dialog--title",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('title') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-payment-type-dialog--title",
                                            value: this.state.title,
                                            onChange: (event)=>{
                                                this.setState({
                                                    title: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-payment-type-dialog--visible",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Aktiven",
                                            tooltip: "Aktiven"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: this.state.visible,
                                            onChange: (event)=>{
                                                this.setState({
                                                    visible: event.target.checked
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-payment-type-dialog--show_in_cash_register_document",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Prika\u017Ei na blagajni\u0161kem dokumentu",
                                            tooltip: "Prika\u017Ei na blagajni\u0161kem dokumentu"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: this.state.show_in_cash_register_document,
                                            onChange: (event)=>{
                                                this.setState({
                                                    show_in_cash_register_document: event.target.checked
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-payment-type-dialog--ord",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Vrstni red",
                                            tooltip: "Vrstni red"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                            id: "add-edit-payment-type-dialog--ord",
                                            value: this.state.ord,
                                            min: 0,
                                            minorStepSize: 1,
                                            onValueChange: (val)=>{
                                                this.setState({
                                                    ord: val
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_payment_type: this.state.id_payment_type,
                                            type: this.state.type,
                                            title: this.state.title,
                                            visible: this.state.visible,
                                            show_in_cash_register_document: this.state.show_in_cash_register_document,
                                            ord: this.state.ord,
                                            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.type.length == 0) {
                                            validation_failed_fields.push('type');
                                            validation_failed_field_titles.push("tip pla\u010Dila");
                                        }
                                        if (new_item.title.length == 0) {
                                            validation_failed_fields.push('title');
                                            validation_failed_field_titles.push('naziv');
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditPaymentType.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = AddEditPaymentType;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"72AIt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _select = require("@blueprintjs/select");
var _addEditPostOffice = require("./AddEditPostOffice");
var _addEditPostOfficeDefault = parcelHelpers.interopDefault(_addEditPostOffice);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { countries, table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Po\u0161tna \u0161tevilka",
                        fieldName: "post_code"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 5,
                        title: "Dr\u017Eava"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.post_code,
                            onChange: (event)=>handleFilterChange('post_code', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.title,
                            onChange: (event)=>handleFilterChange('title', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 5,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Select), {
                            items: Object.values(countries),
                            itemPredicate: (query, item, idx, exactMatch)=>{
                                return item.official_name_local.toUpperCase().indexOf(query.toUpperCase()) > -1;
                            },
                            itemRenderer: (item, { handleClick, modifiers })=>{
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                    active: modifiers.active,
                                    onClick: handleClick,
                                    text: item.official_name_local
                                }, item.id_country);
                            },
                            onItemSelect: (item)=>{
                                handleFilterChange('id_country', item.id_country == 0 ? null : item.id_country);
                            },
                            popoverProps: {
                                targetTagName: 'div'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                text: tableItemsFilters.id_country == null ? "Izberi dr\u017Eavo" : countries[tableItemsFilters.id_country].official_name_local,
                                rightIcon: "double-caret-vertical",
                                fill: true,
                                small: true,
                                alignText: (0, _core.Alignment).LEFT
                            })
                        })
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: item.post_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: item.title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: countries[item.id_country].official_name_local
                        })
                    ]
                }, 'countries-result--result-' + id);
            })
        ]
    });
}
class PostOffices extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: '',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                post_code: '',
                title: '',
                id_country: null
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.post_offices != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.post_offices);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        //TODO refresh sorting
        //TODO call this.filterTableItems(new_filters);
        return {
            table_items: props.post_offices,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = this.state.table_items[a_key][field];
            const b = this.state.table_items[b_key][field];
            if (field == 'title') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_post_code = filters.post_code.toUpperCase();
        const filters_title = filters.title.toUpperCase();
        const filters_id_country = filters.id_country;
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_post_code != '' && item.post_code.toUpperCase().indexOf(filters_post_code) == -1) return false;
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            if (filters_id_country !== null && item.id_country != filters_id_country) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            post_code: this.state.table_items_filters.post_code,
            title: this.state.table_items_filters.title,
            id_country: this.state.table_items_filters.id_country
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addPostOffice)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deletePostOffice)(this.state.item_delete_requested.id_post_office));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditPostOfficeDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item,
                    countries: this.props.countries
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow post-offices-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    countries: this.props.countries,
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
PostOffices.propTypes = {};
function mapStateToProps(state) {
    return {
        countries: state.CodeTablesSlice.countries,
        post_offices: state.CodeTablesSlice.post_offices,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(PostOffices);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@blueprintjs/select":"3IMc6","./AddEditPostOffice":"4airz","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4airz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _select = require("@blueprintjs/select");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
class AddEditPostOffice extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_post_office: props.item === null ? -1 : props.item.id_post_office,
            post_code: props.item === null ? '' : props.item.post_code,
            title: props.item === null ? '' : props.item.title,
            id_country: props.item === null ? null : props.item.id_country,
            validation_failed_fields: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-post-office-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi po\u0161to"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-post-office-dialog--id_country",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('id_country') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Dr\u017Eava",
                                            tooltip: "Dr\u017Eava"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Select), {
                                            id: "add-edit-post-office-dialog--id_country",
                                            items: Object.values(this.props.countries),
                                            itemPredicate: (query, item, idx, exactMatch)=>{
                                                return item.official_name_local.toUpperCase().indexOf(query.toUpperCase()) > -1;
                                            },
                                            itemRenderer: (item, { handleClick, modifiers })=>{
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                    active: modifiers.active,
                                                    onClick: handleClick,
                                                    text: item.official_name_local
                                                }, item.id_country);
                                            },
                                            onItemSelect: (item)=>{
                                                this.setState({
                                                    id_country: item.id_country
                                                });
                                            },
                                            popoverProps: {
                                                targetTagName: 'div'
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                text: this.state.id_country == null ? "Izberi dr\u017Eavo" : this.props.countries[this.state.id_country].official_name_local,
                                                rightIcon: "double-caret-vertical",
                                                fill: true,
                                                alignText: (0, _core.Alignment).LEFT
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-post-office-dialog--post_code",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('post_code') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Po\u0161tna \u0161tevilka",
                                            tooltip: "Po\u0161tna \u0161tevilka"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-post-office-dialog--post_code",
                                            value: this.state.post_code,
                                            onChange: (event)=>{
                                                this.setState({
                                                    post_code: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-post-office-dialog--title",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('title') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-post-office-dialog--title",
                                            value: this.state.title,
                                            onChange: (event)=>{
                                                this.setState({
                                                    title: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_post_office: this.state.id_post_office,
                                            id_country: this.state.id_country,
                                            post_code: this.state.post_code,
                                            title: this.state.title,
                                            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.id_country === null) {
                                            validation_failed_fields.push('id_country');
                                            validation_failed_field_titles.push("dr\u017Eava");
                                        }
                                        if (new_item.post_code.length == 0) {
                                            validation_failed_fields.push('post_code');
                                            validation_failed_field_titles.push('koda');
                                        }
                                        if (new_item.title.length == 0) {
                                            validation_failed_fields.push('title');
                                            validation_failed_field_titles.push('naziv');
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditPostOffice.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object,
    countries: (0, _propTypesDefault.default).object
};
exports.default = AddEditPostOffice;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@blueprintjs/select":"3IMc6","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"qWzAp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditWarehouse = require("./AddEditWarehouse");
var _addEditWarehouseDefault = parcelHelpers.interopDefault(_addEditWarehouse);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 4,
                        title: "Privzeto skladi\u0161\u010De"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.title,
                            onChange: (event)=>handleFilterChange('title', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                            checked: tableItemsFilters.default_warehouse === 1,
                            indeterminate: tableItemsFilters.default_warehouse === 0,
                            onChange: (event)=>{
                                let checked = 0;
                                if (tableItemsFilters.default_warehouse === 1) checked = -1;
                                else if (tableItemsFilters.default_warehouse === 0) checked = 1;
                                handleFilterChange('default_warehouse', checked);
                            }
                        })
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "results-table-col col-1",
                            style: {
                                gridColumn: '1'
                            },
                            children: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "results-table-col col-2",
                            style: {
                                gridColumn: '2'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "edit",
                                    intent: "primary",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>openAddEditItemDialog(item)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "trash",
                                    intent: "danger",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>deleteItem(item)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: item.title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: item.default_warehouse ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "tick",
                                color: "#394b59"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "cross",
                                color: "#ff0000"
                            })
                        })
                    ]
                }, 'countries-result--result-' + id);
            })
        ]
    });
}
class Warehouses extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: '',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                title: '',
                default_warehouse: 0
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.warehouses != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.warehouses);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        //TODO refresh sorting
        //TODO call this.filterTableItems(new_filters);
        return {
            table_items: props.warehouses,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = this.state.table_items[a_key][field];
            const b = this.state.table_items[b_key][field];
            if (field == 'title') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_title = filters.title.toUpperCase();
        const filters_default_warehouse = filters.default_warehouse;
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            if (filters_default_warehouse !== 0 && (item.default_warehouse === true && filters_default_warehouse === -1 || item.default_warehouse === false && filters_default_warehouse === 1)) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            title: this.state.table_items_filters.title,
            default_warehouse: this.state.table_items_filters.default_warehouse
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) {
            if (item.default_warehouse) {
                let current_default_warehouse = null;
                for(let id_warehouse in this.props.warehouses)if (id_warehouse != item.id_warehouse && this.props.warehouses[id_warehouse].default_warehouse) {
                    current_default_warehouse = this.props.warehouses[id_warehouse];
                    break;
                }
                if (current_default_warehouse !== null) {
                    current_default_warehouse = {
                        ...current_default_warehouse,
                        default_warehouse: false
                    };
                    this.props.dispatch((0, _codeTablesSlice.addWarehouse)({
                        item: current_default_warehouse,
                        token: this.props.token,
                        save_to_api: true
                    }));
                }
            }
            this.props.dispatch((0, _codeTablesSlice.addWarehouse)({
                item,
                token: this.props.token,
                save_to_api: true
            }));
        }
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deleteWarehouse)(this.state.item_delete_requested.id_warehouse));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditWarehouseDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow warehouses-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
Warehouses.propTypes = {};
function mapStateToProps(state) {
    return {
        warehouses: state.CodeTablesSlice.warehouses,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Warehouses);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditWarehouse":"ib4zc","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ib4zc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
class AddEditWarehouse extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_warehouse: props.item === null ? -1 : props.item.id_warehouse,
            title: props.item === null ? '' : props.item.title,
            default_warehouse: props.item === null ? false : props.item.default_warehouse,
            validation_failed_fields: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-warehouse-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi skladi\u0161\u010De"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-warehouse-dialog--title",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('title') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-warehouse-dialog--title",
                                            value: this.state.title,
                                            onChange: (event)=>{
                                                this.setState({
                                                    title: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-warehouse-dialog--default_warehouse",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Privzeto skladi\u0161\u010De",
                                            tooltip: "Privzeto skladi\u0161\u010De"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: this.state.default_warehouse,
                                            onChange: (event)=>{
                                                this.setState({
                                                    default_warehouse: event.target.checked
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_warehouse: this.state.id_warehouse,
                                            title: this.state.title,
                                            commission_sale: false,
                                            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code,
                                            default_warehouse: this.state.default_warehouse
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.title.length == 0) {
                                            validation_failed_fields.push('title');
                                            validation_failed_field_titles.push('naziv');
                                        }
                                        //TODO check default_warehouse and warn user if we're overriding another warehouse's default_warehouse
                                        //TODO also warn if we're trying to turn off default_warehouse
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditWarehouse.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = AddEditWarehouse;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cMjQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditCashRegisters = require("./AddEditCashRegisters");
var _addEditCashRegistersDefault = parcelHelpers.interopDefault(_addEditCashRegisters);
var _cashRegisterSlice = require("../../slices/CashRegisterSlice");
var _cashRegisters = require("../../api/CashRegisters");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, business_premises, warehouses, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Interna \u0161ifra",
                        fieldName: "internal_code"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "Identifikator blagajne (FURS)",
                        fieldName: "furs_code"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 5,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 6,
                        ...sort_props,
                        title: "Poslovni prostor",
                        fieldName: "business_premise"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 7,
                        ...sort_props,
                        title: "Skladi\u0161\u010De",
                        fieldName: "warehouse"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.internal_code,
                            onChange: (event)=>handleFilterChange('internal_code', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.furs_code,
                            onChange: (event)=>handleFilterChange('furs_code', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 5,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.title,
                            onChange: (event)=>handleFilterChange('title', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 6
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 7
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                if (item.id_business_premise === undefined) return null;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: item.internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: item.furs_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: item.title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            child: business_premises[item.id_business_premise].furs_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            child: warehouses[item.id_warehouse].title
                        })
                    ]
                }, 'items-result--result-' + id);
            })
        ]
    });
}
class CashRegisters extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: '',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                internal_code: '',
                furs_code: '',
                title: ''
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.cash_registers != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.cash_registers);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        //TODO refresh sorting
        //TODO call this.filterTableItems(new_filters);
        return {
            table_items: props.cash_registers,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a, b;
            if (field == 'business_premise') {
                a = this.props.business_premises[this.state.table_items[a_key].id_business_premise].furs_code;
                b = this.props.business_premises[this.state.table_items[b_key].id_business_premise].furs_code;
            } else if (field == 'warehouse') {
                a = this.props.warehouses[this.state.table_items[a_key].id_warehouse].title;
                b = this.props.warehouses[this.state.table_items[b_key].id_warehouse].title;
            } else if (field == 'title') {
                a = this.state.table_items[a_key][field];
                b = this.state.table_items[b_key][field];
                return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            } else {
                a = this.state.table_items[a_key][field];
                b = this.state.table_items[b_key][field];
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_internal_code = filters.internal_code.toUpperCase();
        const filters_furs_code = filters.furs_code.toUpperCase();
        const filters_title = filters.title.toUpperCase();
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_internal_code != '' && item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) return false;
            if (filters_furs_code != '' && item.furs_code.toUpperCase().indexOf(filters_furs_code) == -1) return false;
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            internal_code: this.state.table_items_filters.internal_code,
            furs_code: this.state.table_items_filters.furs_code,
            title: this.state.table_items_filters.title
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    async closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) {
            this.props.dispatch((0, _cashRegisterSlice.addCashRegister)(item));
            const new_item = await (0, _cashRegisters.saveCashRegister)(this.props.api_url, item, this.props.token);
            this.props.dispatch((0, _cashRegisterSlice.addCashRegister)(new_item));
        }
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        //this.props.dispatch(deleteCashRegister(this.state.item_delete_requested.id_cash_register));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditCashRegistersDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow cash-registers-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    business_premises: this.props.business_premises,
                                    warehouses: this.props.warehouses,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
CashRegisters.propTypes = {};
function mapStateToProps(state) {
    return {
        api_url: state.BusinessSlice.api_url,
        cash_registers: state.CashRegisterSlice.cash_registers,
        business_premises: state.CodeTablesSlice.business_premises,
        warehouses: state.CodeTablesSlice.warehouses,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(CashRegisters);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditCashRegisters":"hTwR2","../../slices/CashRegisterSlice":"1FTf7","../../api/CashRegisters":"ixrrZ","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hTwR2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
class AddEditCashRegisters extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_cash_register: props.item === null ? (0, _uuidDefault.default).v4() : props.item.id_cash_register,
            internal_code: props.item === null ? '' : props.item.internal_code,
            furs_code: props.item === null ? '' : props.item.furs_code,
            title: props.item === null ? '' : props.item.title,
            expense: props.item === null ? 0 : props.item.expense,
            income: props.item === null ? 0 : props.item.income,
            log: props.item === null ? '' : props.item.log,
            id_business_premise: props.item === null ? -1 : props.item.id_business_premise,
            business_premise: props.item === null ? '' : props.item.business_premise,
            id_warehouse: props.item === null ? -1 : props.item.id_warehouse,
            validation_failed_fields: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-cash-register-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi blagajno"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-cash-register-dialog--internal_code",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('internal_code') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Interna \u0161ifra",
                                            tooltip: "Interna \u0161ifra"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-cash-register-dialog--internal_code",
                                            value: this.state.internal_code,
                                            onChange: (event)=>{
                                                if (event.target.value.length > 3) return;
                                                this.setState({
                                                    internal_code: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-cash-register-dialog--furs_code",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('furs_code') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Identifikator blagajne (FURS)",
                                            tooltip: "Identifikator blagajne (FURS)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-cash-register-dialog--furs_code",
                                            value: this.state.furs_code,
                                            onChange: (event)=>{
                                                this.setState({
                                                    furs_code: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-cash-register-dialog--title",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('title') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-cash-register-dialog--title",
                                            value: this.state.title,
                                            onChange: (event)=>{
                                                this.setState({
                                                    title: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-cash-register-dialog--id_business_premise",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('id_business_premise') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Poslovni prostor",
                                            tooltip: "Poslovni prostor"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                            fill: true,
                                            options: [
                                                {
                                                    label: 'Izberi poslovni prostor',
                                                    value: -1
                                                }
                                            ].concat(Object.values(this.props.business_premises).sort((a, b)=>a.ord - b.ord).map(function(item) {
                                                return {
                                                    label: item.furs_code,
                                                    value: item.id_business_premise
                                                };
                                            })),
                                            onChange: (e)=>{
                                                this.setState({
                                                    id_business_premise: e.currentTarget.value
                                                });
                                            },
                                            value: this.state.id_business_premise
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-cash-register-dialog--id_warehouse",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('id_warehouse') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Skladi\u0161\u010De",
                                            tooltip: "Skladi\u0161\u010De"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                            fill: true,
                                            options: [
                                                {
                                                    label: "Izberi skladi\u0161\u010De",
                                                    value: -1
                                                }
                                            ].concat(Object.values(this.props.warehouses).sort((a, b)=>a.ord - b.ord).map(function(item) {
                                                return {
                                                    label: item.title,
                                                    value: item.id_warehouse
                                                };
                                            })),
                                            onChange: (e)=>{
                                                this.setState({
                                                    id_warehouse: e.currentTarget.value
                                                });
                                            },
                                            value: this.state.id_warehouse
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_cash_register: this.state.id_cash_register,
                                            internal_code: this.state.internal_code,
                                            furs_code: this.state.furs_code,
                                            title: this.state.title,
                                            expense: this.state.expense,
                                            income: this.state.income,
                                            log: this.state.log,
                                            id_business_premise: this.state.id_business_premise,
                                            business_premise: this.state.business_premise,
                                            id_warehouse: this.state.id_warehouse
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.internal_code.length == 0) {
                                            validation_failed_fields.push('internal_code');
                                            validation_failed_field_titles.push("Interna \u0161ifra");
                                        }
                                        if (new_item.furs_code.length == 0) {
                                            validation_failed_fields.push('furs_code');
                                            validation_failed_field_titles.push('identifikator blagajne (FURS)');
                                        }
                                        if (new_item.title.length == 0) {
                                            validation_failed_fields.push('title');
                                            validation_failed_field_titles.push('naziv');
                                        }
                                        if (new_item.id_business_premise === null || new_item.id_business_premise == -1) {
                                            validation_failed_fields.push('id_business_premise');
                                            validation_failed_field_titles.push('poslovni prostor');
                                        }
                                        if (new_item.id_warehouse === null || new_item.id_warehouse == -1) {
                                            validation_failed_fields.push('id_warehouse');
                                            validation_failed_field_titles.push("skladi\u0161\u010De");
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditCashRegisters.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
function mapStateToProps(state) {
    return {
        business_premises: state.CodeTablesSlice.business_premises,
        warehouses: state.CodeTablesSlice.warehouses
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddEditCashRegisters);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","uuid":"b52pV","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixrrZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadCashRegisters", ()=>loadCashRegisters);
parcelHelpers.export(exports, "loadCashRegisterDailyStates", ()=>loadCashRegisterDailyStates);
parcelHelpers.export(exports, "loadCashRegisterDocuments", ()=>loadCashRegisterDocuments);
parcelHelpers.export(exports, "loadCashRegisterDocument", ()=>loadCashRegisterDocument);
parcelHelpers.export(exports, "saveCashRegister", ()=>saveCashRegister);
parcelHelpers.export(exports, "saveCashRegisterDailyState", ()=>saveCashRegisterDailyState);
parcelHelpers.export(exports, "saveCashRegisterDocument", ()=>saveCashRegisterDocument);
parcelHelpers.export(exports, "saveCashRegisterDocumentPaymentType", ()=>saveCashRegisterDocumentPaymentType);
parcelHelpers.export(exports, "saveCashRegisterDocumentInvoice", ()=>saveCashRegisterDocumentInvoice);
parcelHelpers.export(exports, "deleteCashRegisterDailyState", ()=>deleteCashRegisterDailyState);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _cashRegisterSlice = require("../slices/CashRegisterSlice");
var _userSlice = require("../slices/UserSlice");
async function loadCashRegisters(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CashRegisters/v1/cash-registers', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _cashRegisterSlice.addCashRegisters)(items));
}
async function loadCashRegisterDailyStates(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CashRegisters/v1/cash-register-daily-states', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _cashRegisterSlice.addCashRegisterDailyStates)(items));
}
async function loadCashRegisterDocuments(api_url, dispatch, token) {
    let response = await fetch(api_url + 'CashRegisters/v1/cash-register-documents', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _cashRegisterSlice.addCashRegisterDocuments)(items));
}
async function loadCashRegisterDocument(api_url, id_cash_register_document, dispatch, token) {
    let response = await fetch(api_url + 'CashRegisters/v1/cash-register-document?id_cash_register_document=' + id_cash_register_document, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let item = await response.json();
    if (item.error_code !== undefined) {
        if (item.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _cashRegisterSlice.addCashRegisterDocument)(item));
}
async function saveCashRegister(api_url, item, token) {
    return await saveCashRegisterItem(api_url, 'cash_registers', item, token);
}
async function saveCashRegisterDailyState(api_url, item, token) {
    return await saveCashRegisterItem(api_url, 'cash_register_daily_states', item, token);
}
async function saveCashRegisterDocument(api_url, item, token) {
    return await saveCashRegisterItem(api_url, 'cash_register_documents', item, token);
}
async function saveCashRegisterDocumentPaymentType(api_url, item, token) {
    return await saveCashRegisterItem(api_url, 'cash_register_document_payment_types', item, token);
}
async function saveCashRegisterDocumentInvoice(api_url, item, token) {
    return await saveCashRegisterItem(api_url, 'cash_register_document_invoices', item, token);
}
async function saveCashRegisterItem(api_url, name, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    const table_names_to_urls = {
        cash_registers: 'CashRegisters/v1/save-cash-register',
        cash_register_daily_states: 'CashRegisters/v1/save-cash-register-daily-state',
        cash_register_documents: 'CashRegisters/v1/save-cash-register-document',
        cash_register_document_payment_types: 'CashRegisters/v1/save-cash-register-document-payment-type',
        cash_register_document_invoices: 'CashRegisters/v1/save-cash-register-document-invoice'
    };
    const url = table_names_to_urls[name];
    if (url === undefined) return;
    let response = await fetch(api_url + url, {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function deleteCashRegisterDailyState(api_url, id_cash_register_daily_state, token) {
    const form_data = new FormData();
    form_data.set('id_cash_register_daily_state', id_cash_register_daily_state);
    let response = await fetch(api_url + 'CashRegisters/v1/delete-cash-register-daily-state', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let status = await response.json();
    if (status.error_code !== undefined) status.error_code;
}

},{"js-cookie":"2d7Fe","../slices/CashRegisterSlice":"1FTf7","../slices/UserSlice":"ikKoo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1bO6f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditChannel = require("./AddEditChannel");
var _addEditChannelDefault = parcelHelpers.interopDefault(_addEditChannel);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Oznaka",
                        fieldName: "internal_code"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 5,
                        ...sort_props,
                        title: "Aktiven",
                        fieldName: "visible"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 6,
                        ...sort_props,
                        title: "Vrstni red",
                        fieldName: "ord"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.internal_code,
                            onChange: (event)=>handleFilterChange('internal_code', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.title,
                            onChange: (event)=>handleFilterChange('title', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 5,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                            checked: tableItemsFilters.visible === 1,
                            indeterminate: tableItemsFilters.visible === 0,
                            onChange: (event)=>{
                                let checked = 0;
                                if (tableItemsFilters.visible === 1) checked = -1;
                                else if (tableItemsFilters.visible === 0) checked = 1;
                                handleFilterChange('visible', checked);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 6
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: item.internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: item.title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: item.visible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "tick",
                                color: "#394b59"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "cross",
                                color: "#ff0000"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "text-right",
                            child: item.ord
                        })
                    ]
                }, 'countries-result--result-' + id);
            })
        ]
    });
}
class Channels extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'ord',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                internal_code: '',
                title: '',
                visible: 0
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
        this.state.table_items_sort_ids = this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, this.state.table_items_filtered_ids, table_items, true);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.channels != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.channels);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const table_items_sort_ids = this.state === undefined ? sort_ids : this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, ids, props.channels, true);
        return {
            table_items: props.channels,
            table_items_sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, items, only_return) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        items = items || this.state.table_items;
        only_return = only_return || false;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = items[a_key][field];
            const b = items[b_key][field];
            if (field == 'title') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        if (only_return) return ids;
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_internal_code = filters.internal_code.toUpperCase();
        const filters_title = filters.title.toUpperCase();
        const filters_visible = filters.visible;
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_internal_code != '' && item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) return false;
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            if (filters_visible !== 0 && (item.visible === true && filters_visible === -1 || item.visible === false && filters_visible === 1)) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            internal_code: this.state.table_items_filters.internal_code,
            title: this.state.table_items_filters.title,
            visible: this.state.table_items_filters.visible
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addChannel)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deleteChannel)(this.state.item_delete_requested.id_channel));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditChannelDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow channels-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
Channels.propTypes = {};
function mapStateToProps(state) {
    return {
        channels: state.CodeTablesSlice.channels,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Channels);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditChannel":"6DxUf","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6DxUf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
class AddEditChannel extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_channel: props.item === null ? -1 : props.item.id_channel,
            internal_code: props.item === null ? '' : props.item.internal_code,
            title: props.item === null ? '' : props.item.title,
            visible: props.item === null ? true : props.item.visible,
            ord: props.item === null ? 1 : props.item.ord,
            validation_failed_fields: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-channel-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi prodajni kanal"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-channel-dialog--internal_code",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('internal_code') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Oznaka",
                                            tooltip: "Oznaka"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-channel-dialog--internal_code",
                                            value: this.state.internal_code,
                                            onChange: (event)=>{
                                                if (event.target.value.length > 2) return;
                                                this.setState({
                                                    internal_code: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-channel-dialog--title",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('title') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-channel-dialog--title",
                                            value: this.state.title,
                                            onChange: (event)=>{
                                                this.setState({
                                                    title: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-channel-dialog--visible",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Aktiven",
                                            tooltip: "Aktiven"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: this.state.visible,
                                            onChange: (event)=>{
                                                this.setState({
                                                    visible: event.target.checked
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-channel-dialog--ord",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Vrstni red",
                                            tooltip: "Vrstni red"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                            id: "add-edit-channel-dialog--ord",
                                            value: this.state.ord,
                                            min: 0,
                                            minorStepSize: 1,
                                            onValueChange: (val)=>{
                                                this.setState({
                                                    ord: val
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_channel: this.state.id_channel,
                                            internal_code: this.state.internal_code,
                                            title: this.state.title,
                                            visible: this.state.visible,
                                            ord: this.state.ord,
                                            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.internal_code.length == 0) {
                                            validation_failed_fields.push('internal_code');
                                            validation_failed_field_titles.push('oznaka');
                                        }
                                        if (new_item.title.length == 0) {
                                            validation_failed_fields.push('title');
                                            validation_failed_field_titles.push('naziv');
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditChannel.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = AddEditChannel;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffdTv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _addEditTaxRate = require("./AddEditTaxRate");
var _addEditTaxRateDefault = parcelHelpers.interopDefault(_addEditTaxRate);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const taxable_titles = {
        'taxable': "obdav\u010Deno",
        'nontaxable': "neobdav\u010Deno",
        'tax-exempt': "opro\u0161\u010Deno"
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Vrednost (%)",
                        fieldName: "value"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 5,
                        title: "Tip obdav\u010Ditve"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 6,
                        title: "Velja od/do"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 7,
                        ...sort_props,
                        title: "Vrstni red",
                        fieldName: "ord"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.title,
                            onChange: (event)=>handleFilterChange('title', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 5
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 6
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 7
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                let is_active = true;
                const current_date_iso = (0, _momentDefault.default)().format('YYYY-MM-DD');
                const valid_from_iso = (0, _momentDefault.default)(item.valid_from).format('YYYY-MM-DD');
                const valid_until_iso = item.valid_until === null ? null : (0, _momentDefault.default)(item.valid_until).format('YYYY-MM-DD');
                if (current_date_iso < valid_from_iso) is_active = false;
                else if (valid_until_iso !== null && current_date_iso > valid_until_iso) is_active = false;
                const cls = 'validity-' + (is_active ? 'active' : 'inactive');
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: cls,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: cls,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: cls + ' text-right',
                            child: parseFloat(item.value).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: cls,
                            child: item.title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: cls,
                            child: taxable_titles[item.taxable]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: cls,
                            child: item.valid_until === null ? 'od ' + (0, _momentDefault.default)(item.valid_from).format('DD. MM. YYYY') : (0, _momentDefault.default)(item.valid_from).format('DD. MM. YYYY') + ' do ' + (0, _momentDefault.default)(item.valid_until).format('DD. MM. YYYY')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: cls + ' text-right',
                            child: item.ord
                        })
                    ]
                }, 'countries-result--result-' + id);
            })
        ]
    });
}
class TaxRates extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'ord',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                title: ''
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
        this.state.table_items_sort_ids = this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, this.state.table_items_filtered_ids, table_items, true);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.tax_rates != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.tax_rates);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const table_items_sort_ids = this.state === undefined ? sort_ids : this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, ids, props.tax_rates, true);
        return {
            table_items: props.tax_rates,
            table_items_sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, items, only_return) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        items = items || this.state.table_items;
        only_return = only_return || false;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = items[a_key][field];
            const b = items[b_key][field];
            if (field == 'title') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        if (only_return) return ids;
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_title = filters.title.toUpperCase();
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            title: this.state.table_items_filters.title
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addTaxRate)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deleteTaxRate)(this.state.item_delete_requested.id_tax_rate));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditTaxRateDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow tax-rates-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
TaxRates.propTypes = {};
function mapStateToProps(state) {
    return {
        tax_rates: state.CodeTablesSlice.tax_rates,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(TaxRates);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","moment":"1e4qG","./AddEditTaxRate":"3NQYl","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3NQYl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
var _utils = require("../../utils");
class AddEditTaxRate extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_tax_rate: props.item === null ? -1 : props.item.id_tax_rate,
            title: props.item === null ? '' : props.item.title,
            value: props.item === null ? 0 : props.item.value,
            valid_from: props.item === null ? null : props.item.valid_from === null ? null : new Date(props.item.valid_from),
            valid_until: props.item === null ? null : props.item.valid_until === null ? null : new Date(props.item.valid_until),
            ord: props.item === null ? 1 : props.item.ord,
            taxable: props.item === null ? 'taxable' : props.item.taxable,
            validation_failed_fields: []
        };
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-tax-rate-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi dav\u010Dno stopnjo"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-tax-rate-dialog--title",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('title') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-tax-rate-dialog--title",
                                            value: this.state.title,
                                            onChange: (event)=>{
                                                this.setState({
                                                    title: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-tax-rate-dialog--taxable",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Tip obdav\u010Ditve",
                                            tooltip: "Tip obdav\u010Ditve"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                            id: "add-edit-tax-rate-dialog--taxable",
                                            fill: true,
                                            options: [
                                                {
                                                    title: "Obdav\u010Deno",
                                                    value: 'taxable'
                                                },
                                                {
                                                    title: "Neobdav\u010Deno",
                                                    value: 'nontaxable'
                                                },
                                                {
                                                    title: "Opro\u0161\u010Deno",
                                                    value: 'tax-exempt'
                                                }
                                            ].map((item)=>{
                                                return {
                                                    label: item.title,
                                                    value: item.value
                                                };
                                            }),
                                            value: this.state.taxable,
                                            onChange: (e)=>{
                                                this.setState({
                                                    taxable: e.currentTarget.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-tax-rate-dialog--value",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('value') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Vrednost (%)",
                                            tooltip: "Vrednost (%)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                            id: "add-edit-tax-rate-dialog--value",
                                            value: this.state.value,
                                            min: 0,
                                            max: 100,
                                            minorStepSize: 0.0001,
                                            onValueChange: (val, val_str)=>{
                                                this.setState({
                                                    value: val_str
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-tax-rate-dialog--valid_from",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Veljavno od",
                                            tooltip: "Veljavno od"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                            id: "add-edit-tax-rate-dialog--valid_from",
                                            dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                            dateFnsFormat: 'dd. MM. yyyy',
                                            locale: "sl",
                                            inputProps: {
                                                placeholder: '01. 01. ' + new Date().getFullYear()
                                            },
                                            selectAllOnFocus: true,
                                            minDate: new Date('1900-01-01'),
                                            maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                            onChange: (selectedDate, isUserChange)=>{
                                                if (isUserChange) this.setState({
                                                    valid_from: selectedDate === null ? null : new Date(selectedDate)
                                                });
                                            },
                                            value: this.state.valid_from === null ? null : (0, _formatISODefault.default)(this.state.valid_from)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-tax-rate-dialog--valid_until",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Veljavno do",
                                            tooltip: "Veljavno do"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                            id: "add-edit-tax-rate-dialog--valid_until",
                                            dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                            dateFnsFormat: 'dd. MM. yyyy',
                                            locale: "sl",
                                            inputProps: {
                                                placeholder: '31. 12. ' + new Date().getFullYear()
                                            },
                                            selectAllOnFocus: true,
                                            minDate: new Date('1900-01-01'),
                                            maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                            onChange: (selectedDate, isUserChange)=>{
                                                if (isUserChange) this.setState({
                                                    valid_until: selectedDate === null ? null : new Date(selectedDate)
                                                });
                                            },
                                            value: this.state.valid_until === null ? null : (0, _formatISODefault.default)(this.state.valid_until)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-tax-rate-dialog--ord",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Vrstni red",
                                            tooltip: "Vrstni red"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                            id: "add-edit-tax-rate-dialog--ord",
                                            value: this.state.ord,
                                            min: 0,
                                            minorStepSize: 1,
                                            onValueChange: (val)=>{
                                                this.setState({
                                                    ord: val
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_tax_rate: this.state.id_tax_rate,
                                            title: this.state.title,
                                            value: parseFloat(this.state.value),
                                            valid_from: this.state.valid_from === null ? null : this.state.valid_from.toISOString(true),
                                            valid_until: this.state.valid_until === null ? null : this.state.valid_until.toISOString(true),
                                            ord: this.state.ord,
                                            taxable: this.state.taxable,
                                            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.title.length == 0) {
                                            validation_failed_fields.push('title');
                                            validation_failed_field_titles.push('naziv');
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditTaxRate.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = AddEditTaxRate;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","moment":"1e4qG","date-fns/formatISO":"an1FA","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","../../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2RD0p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _addEditBusinessPremise = require("./AddEditBusinessPremise");
var _addEditBusinessPremiseDefault = parcelHelpers.interopDefault(_addEditBusinessPremise);
var _businessPremiseFiscalRegistrationHistoryDialog = require("./BusinessPremiseFiscalRegistrationHistoryDialog");
var _businessPremiseFiscalRegistrationHistoryDialogDefault = parcelHelpers.interopDefault(_businessPremiseFiscalRegistrationHistoryDialog);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, deleteItem, business_premise_fiscal_registrations, business_premise_fiscal_registrations_by_id_business_premises, openBusinessPremiseFiscalRegistrationHistoryDialog } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const toLocalStringWithTime = (date)=>{
        if (date === null) return '';
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear() + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 3,
                        title: "Status"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "Oznaka prostora (FURS)",
                        fieldName: "furs_code"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 5,
                        ...sort_props,
                        title: "\u0160t. katastrske ob\u010Dine",
                        fieldName: "cadastral_municipality"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 6,
                        ...sort_props,
                        title: "\u0160t. stavbe",
                        fieldName: "building_number"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 7,
                        ...sort_props,
                        title: "\u0160t. dela stavbe",
                        fieldName: "building_part_number"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 8,
                        ...sort_props,
                        title: "Ulica",
                        fieldName: "street"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 9,
                        ...sort_props,
                        title: "Hi\u0161na \u0161t.",
                        fieldName: "house_number"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 10,
                        ...sort_props,
                        title: "Dod. k hi\u0161ni \u0161t.",
                        fieldName: "house_number_appendix"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 11,
                        ...sort_props,
                        title: "Naselje",
                        fieldName: "town"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 12,
                        ...sort_props,
                        title: "Po\u0161tna \u0161t.",
                        fieldName: "post_code"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 13,
                        ...sort_props,
                        title: "Po\u0161ta",
                        fieldName: "post_office"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 14,
                        ...sort_props,
                        title: "Kraj",
                        fieldName: "city"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 15,
                        ...sort_props,
                        title: "Veljaven od",
                        fieldName: "valid_from"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 16,
                        ...sort_props,
                        title: "Prijavljen na FURS od",
                        fieldName: "registered_at_furs"
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                const business_premise_fiscal_registration = item.id_business_premise_fiscal_registration === null ? null : business_premise_fiscal_registrations[item.id_business_premise_fiscal_registration] || null;
                const business_premise_fiscal_registrations_for_business_premise = (business_premise_fiscal_registrations_by_id_business_premises === undefined ? undefined : business_premise_fiscal_registrations_by_id_business_premises[item.id_business_premise]) || [];
                const getStatus = (status)=>{
                    if (status === null) return "v po\u0161iljanju";
                    else if (status) return 'potrjeno';
                    return 'napaka pri potrjevanju';
                };
                let icon = '';
                let color = '';
                if (business_premise_fiscal_registration !== null) {
                    if (business_premise_fiscal_registration.status === null) {
                        icon = 'history';
                        color = '#d9822b';
                    } else if (business_premise_fiscal_registration.status) {
                        icon = 'tick-circle';
                        color = '#0f9960';
                    } else {
                        icon = 'warning-sign';
                        color = '#db3737';
                    }
                }
                const tooltip_content = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "grid grid-cols-2 col-gap-4 gap-x-4 row-gap-2 gap-y-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: business_premise_fiscal_registrations_for_business_premise.map((business_premise_fiscal_registration, statusIdx)=>{
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: statusIdx == 0 ? 'font-bold' : '',
                                            children: toLocalStringWithTime(new Date(business_premise_fiscal_registration.created + '00'))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: statusIdx == 0 ? 'font-bold' : '',
                                            children: getStatus(business_premise_fiscal_registration.status)
                                        })
                                    ]
                                }, 'business-premise-fiscal-registration-' + business_premise_fiscal_registration.id_business_premise_fiscal_registration);
                            })
                        })
                    })
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                content: tooltip_content,
                                position: "right-bottom",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                        color: color,
                                        icon: icon
                                    }),
                                    className: "ml-1",
                                    onClick: ()=>openBusinessPremiseFiscalRegistrationHistoryDialog(id)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: item.furs_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: item.cadastral_municipality
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            child: item.building_number
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            child: item.building_part_number
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            child: item.street
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            child: item.house_number
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            child: item.house_number_appendix
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            child: item.town
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 12,
                            child: item.post_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 13,
                            child: item.post_office
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 14,
                            child: item.city
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 15,
                            child: (0, _momentDefault.default)(item.valid_from).format('DD. MM. YYYY')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 16,
                            child: item.registered_at_furs === null ? '' : (0, _momentDefault.default)(item.registered_at_furs).format('DD. MM. YYYY HH:mm')
                        })
                    ]
                }, 'countries-result--result-' + id);
            })
        ]
    });
}
class BusinessPremises extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.openBusinessPremiseFiscalRegistrationHistoryDialog = this.openBusinessPremiseFiscalRegistrationHistoryDialog.bind(this);
        this.closeBusinessPremiseFiscalRegistrationHistoryDialog = this.closeBusinessPremiseFiscalRegistrationHistoryDialog.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'ord',
            table_items_sort_direction: 'ASC',
            table_items_filters: {},
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null,
            business_premise_fiscal_registration_history_dialog_open: false,
            business_premise_fiscal_registration_history_dialog_id_business_premise: null
        };
        this.state.table_items_sort_ids = this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, this.state.table_items_filtered_ids, table_items, true);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.business_premises != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.business_premises);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const table_items_sort_ids = this.state === undefined ? sort_ids : this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, ids, props.business_premises, true);
        return {
            table_items: props.business_premises,
            table_items_sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, items, only_return) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        items = items || this.state.table_items;
        only_return = only_return || false;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = items[a_key][field];
            const b = items[b_key][field];
            if (field == 'street' || field == 'town' || field == 'city') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        if (only_return) return ids;
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {};
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addBusinessPremise)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    openBusinessPremiseFiscalRegistrationHistoryDialog(id_business_premise) {
        this.setState({
            business_premise_fiscal_registration_history_dialog_open: true,
            business_premise_fiscal_registration_history_dialog_id_business_premise: id_business_premise
        });
    }
    closeBusinessPremiseFiscalRegistrationHistoryDialog() {
        this.setState({
            business_premise_fiscal_registration_history_dialog_open: false,
            business_premise_fiscal_registration_history_dialog_id_business_premise: null
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deleteBusinessPremise)(this.state.item_delete_requested.id_business_premise));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditBusinessPremiseDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                !this.state.business_premise_fiscal_registration_history_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _businessPremiseFiscalRegistrationHistoryDialogDefault.default), {
                    closeBusinessPremiseFiscalRegistrationHistoryDialog: this.closeBusinessPremiseFiscalRegistrationHistoryDialog,
                    id_business_premise: this.state.business_premise_fiscal_registration_history_dialog_id_business_premise
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow business-premises-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    deleteItem: this.deleteItem,
                                    business_premise_fiscal_registrations: this.props.business_premise_fiscal_registrations,
                                    business_premise_fiscal_registrations_by_id_business_premises: this.props.business_premise_fiscal_registrations_by_id_business_premises,
                                    openBusinessPremiseFiscalRegistrationHistoryDialog: this.openBusinessPremiseFiscalRegistrationHistoryDialog
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
BusinessPremises.propTypes = {};
function mapStateToProps(state) {
    return {
        business_premises: state.CodeTablesSlice.business_premises,
        business_premise_fiscal_registrations: state.CodeTablesSlice.business_premise_fiscal_registrations,
        business_premise_fiscal_registrations_by_id_business_premises: state.CodeTablesSlice.business_premise_fiscal_registrations_by_id_business_premises,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(BusinessPremises);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","moment":"1e4qG","./AddEditBusinessPremise":"1ZgpI","./BusinessPremiseFiscalRegistrationHistoryDialog":"c1AnY","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ZgpI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _dateTimePickerDialog = require("../DateTimePickerDialog");
var _dateTimePickerDialogDefault = parcelHelpers.interopDefault(_dateTimePickerDialog);
var _appToaster = require("../AppToaster");
var _utils = require("../../utils");
function FormTextInput(props) {
    const { fieldName, title, tooltip, value, changeValue, className, disabled } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
        labelFor: 'add-edit-item-dialog--' + fieldName,
        className: 'flex-1 ' + className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                label: title,
                tooltip: tooltip
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                id: 'add-edit-item-dialog--' + fieldName,
                value: value,
                disabled: disabled,
                onChange: (event)=>changeValue(event.target.value)
            })
        ]
    });
}
function FormDateInput(props) {
    const { fieldName, title, tooltip, value, changeValue, className, disabled } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
        labelFor: 'add-edit-item-dialog--' + fieldName,
        className: 'flex-1 ' + className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                label: title,
                tooltip: tooltip
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                id: 'add-edit-item-dialog--' + fieldName,
                dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                dateFnsFormat: 'dd. MM. yyyy',
                locale: "sl",
                inputProps: {
                    placeholder: '01. 01. ' + new Date().getFullYear()
                },
                selectAllOnFocus: true,
                minDate: new Date('1900-01-01'),
                maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                onChange: (selectedDate, isUserChange)=>{
                    if (isUserChange) changeValue(selectedDate === null ? null : new Date(selectedDate));
                },
                disabled: disabled,
                value: value === null ? null : (0, _formatISODefault.default)(value)
            })
        ]
    });
}
const BusinessPremiseTypes = {
    '1': "Nepremi\u010Dni prostor",
    '2A': "Premi\u010Dni prostor - premi\u010Dni objekt",
    '2B': "Premi\u010Dni prostor - objekt na stalni lokaciji",
    '2C': "Premi\u010Dni prostor - posamezna elektronska naprava"
};
class AddEditBusinessPremise extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.hasValidationFailed = this.hasValidationFailed.bind(this);
        this.getValidationClass = this.getValidationClass.bind(this);
        this.openDateTimePickerDialog = this.openDateTimePickerDialog.bind(this);
        this.closeDateTimePickerDialog = this.closeDateTimePickerDialog.bind(this);
        this.saveAndClose = this.saveAndClose.bind(this);
        this.state = {
            id_business_premise: props.item === null ? -1 : props.item.id_business_premise,
            furs_code: props.item === null ? '' : props.item.furs_code,
            cadastral_municipality: props.item === null ? '' : props.item.cadastral_municipality,
            building_number: props.item === null ? '' : props.item.building_number,
            building_part_number: props.item === null ? '' : props.item.building_part_number,
            street: props.item === null ? '' : props.item.street,
            house_number: props.item === null ? '' : props.item.house_number,
            house_number_appendix: props.item === null ? '' : props.item.house_number_appendix,
            town: props.item === null ? '' : props.item.town,
            post_code: props.item === null ? '' : props.item.post_code,
            post_office: props.item === null ? '' : props.item.post_office,
            city: props.item === null ? '' : props.item.city,
            software_maker_tax_number: props.item === null ? '' : props.item.software_maker_tax_number,
            valid_from: props.item === null ? null : props.item.valid_from === null ? null : new Date(props.item.valid_from),
            registered_at_furs: props.item === null ? null : props.item.registered_at_furs === null ? null : new Date(props.item.registered_at_furs + '00'),
            special_notes: props.item === null ? '' : props.item.special_notes,
            type: props.item === null ? '1' : props.item.type,
            closed: props.item === null ? false : props.item.closed,
            validation_failed_fields: [],
            date_picker_dialog_open: false,
            date_picker_dialog_state_name: null,
            date_picker_dialog_value: null
        };
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    hasValidationFailed(field_name) {
        return this.state.validation_failed_fields.indexOf(field_name) != -1;
    }
    getValidationClass(field_name) {
        return this.hasValidationFailed(field_name) ? 'validation-failed' : '';
    }
    openDateTimePickerDialog(state_name) {
        let value = this.state[state_name];
        this.setState({
            date_picker_dialog_open: true,
            date_picker_dialog_state_name: state_name,
            date_picker_dialog_value: value
        });
    }
    closeDateTimePickerDialog(newValue) {
        this.setState({
            date_picker_dialog_open: false
        });
        if (newValue !== false) {
            const obj = {};
            obj[this.state.date_picker_dialog_state_name] = newValue;
            this.setState(obj);
        }
    }
    saveAndClose(submit_to_furs) {
        const movable = this.state.type != '1';
        const new_item = {
            id_business_premise: this.state.id_business_premise,
            furs_code: this.state.furs_code,
            cadastral_municipality: this.state.cadastral_municipality,
            building_number: this.state.building_number,
            building_part_number: this.state.building_part_number,
            street: this.state.street,
            house_number: this.state.house_number,
            house_number_appendix: this.state.house_number_appendix,
            town: this.state.town,
            post_code: this.state.post_code,
            post_office: this.state.post_office,
            city: this.state.city,
            software_maker_tax_number: this.state.software_maker_tax_number,
            valid_from: this.state.valid_from === null ? null : this.state.valid_from.toISOString(true),
            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code,
            special_notes: this.state.special_notes,
            type: this.state.type,
            closed: this.state.closed,
            submit_to_furs: submit_to_furs ? 'true' : 'false'
        };
        // validate missing/empty fields
        const validation_failed_fields = [];
        const validation_failed_field_titles = [];
        if (new_item.furs_code.length == 0) {
            validation_failed_fields.push('furs_code');
            validation_failed_field_titles.push('oznaka prostora (FURS)');
        }
        if (new_item.software_maker_tax_number.length == 0) {
            validation_failed_fields.push('software_maker_tax_number');
            validation_failed_field_titles.push("dav\u010Dna \u0161t. izdajatelja programske opreme");
        }
        if (!movable) {
            if (new_item.cadastral_municipality.length == 0) {
                validation_failed_fields.push('cadastral_municipality');
                validation_failed_field_titles.push("\u0161tevilka katastrske ob\u010Dine");
            }
            if (new_item.building_number.length == 0) {
                validation_failed_fields.push('building_number');
                validation_failed_field_titles.push("\u0161tevilka stavbe");
            }
            if (new_item.building_part_number.length == 0) {
                validation_failed_fields.push('building_part_number');
                validation_failed_field_titles.push("\u0161tevilka dela stavbe");
            }
            if (new_item.street.length == 0) {
                validation_failed_fields.push('street');
                validation_failed_field_titles.push('ulica');
            }
            if (new_item.house_number.length == 0) {
                validation_failed_fields.push('house_number');
                validation_failed_field_titles.push("hi\u0161na \u0161tevilka");
            }
            if (new_item.post_code.length == 0) {
                validation_failed_fields.push('post_code');
                validation_failed_field_titles.push("po\u0161tna \u0161tevilka");
            }
            if (new_item.post_office.length == 0) {
                validation_failed_fields.push('post_office');
                validation_failed_field_titles.push("po\u0161ta");
            }
            if (new_item.town.length == 0) {
                validation_failed_fields.push('town');
                validation_failed_field_titles.push('naselje');
            }
        }
        this.setState({
            validation_failed_fields
        });
        if (validation_failed_fields.length > 0) {
            (0, _appToaster.AppToaster).show({
                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Za shranjevanje, izpolnite vsaj polja:",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: "\u2022 " + title
                            }, title))
                    ]
                }),
                intent: 'danger',
                icon: 'issue'
            });
            return;
        }
        this.props.closeAddEditItemDialog(new_item);
    }
    render() {
        const movable = this.state.type != '1';
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: !this.state.date_picker_dialog_open,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-business-premise-dialog",
            children: [
                !this.state.date_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePickerDialogDefault.default), {
                    closeDateTimePickerDialog: this.closeDateTimePickerDialog,
                    value: this.state.date_picker_dialog_value
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                            fixedToTop: false,
                            className: "bp5-dark",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                        children: "Dodaj / uredi poslovni prostor"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                    align: (0, _core.Alignment).RIGHT,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        minimal: true,
                                        icon: "cross",
                                        onClick: ()=>this.props.closeAddEditItemDialog()
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_BODY,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex flex-1 flex-row",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "add-edit-item-dialog--type",
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: "Tip poslovnega prostora",
                                                    tooltip: "Tip poslovnega prostora"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                    id: "add-edit-item-dialog--type",
                                                    fill: true,
                                                    options: Object.entries(BusinessPremiseTypes).map(([key, value])=>{
                                                        return {
                                                            label: value,
                                                            value: key
                                                        };
                                                    }),
                                                    value: this.state.type,
                                                    onChange: (e)=>{
                                                        this.setState({
                                                            type: e.currentTarget.value
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-1 flex-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: false,
                                                className: 'm-1 ' + this.getValidationClass('furs_code'),
                                                fieldName: "furs_code",
                                                title: "Oznaka prostora (FURS)",
                                                tooltip: "Oznaka prostora (FURS)",
                                                value: this.state.furs_code,
                                                changeValue: (val)=>this.setState({
                                                        furs_code: val
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: movable,
                                                className: 'm-1 ' + this.getValidationClass('cadastral_municipality'),
                                                fieldName: "cadastral_municipality",
                                                title: "\u0160tevilka katastrske ob\u010Dine",
                                                tooltip: "\u0160tevilka katastrske ob\u010Dine",
                                                value: this.state.cadastral_municipality,
                                                changeValue: (val)=>this.setState({
                                                        cadastral_municipality: val
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-1 flex-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: movable,
                                                className: 'm-1 ' + this.getValidationClass('building_number'),
                                                fieldName: "building_number",
                                                title: "\u0160tevilka stavbe",
                                                tooltip: "\u0160tevilka stavbe",
                                                value: this.state.building_number,
                                                changeValue: (val)=>this.setState({
                                                        building_number: val
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: movable,
                                                className: 'm-1 ' + this.getValidationClass('building_part_number'),
                                                fieldName: "building_part_number",
                                                title: "\u0160tevilka dela stavbe",
                                                tooltip: "\u0160tevilka dela stavbe",
                                                value: this.state.building_part_number,
                                                changeValue: (val)=>this.setState({
                                                        building_part_number: val
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-1 flex-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: movable,
                                                className: 'm-1 ' + this.getValidationClass('street'),
                                                fieldName: "street",
                                                title: "Ulica",
                                                tooltip: "Ulica",
                                                value: this.state.street,
                                                changeValue: (val)=>this.setState({
                                                        street: val
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: movable,
                                                className: 'm-1 ' + this.getValidationClass('house_number'),
                                                fieldName: "house_number",
                                                title: "Hi\u0161na \u0161tevilka",
                                                tooltip: "Hi\u0161na \u0161tevilka",
                                                value: this.state.house_number,
                                                changeValue: (val)=>this.setState({
                                                        house_number: val
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-1 flex-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: movable,
                                                className: 'm-1 ' + this.getValidationClass('house_number_appendix'),
                                                fieldName: "house_number_appendix",
                                                title: "Dodatek k hi\u0161ni \u0161tevilki",
                                                tooltip: "Dodatek k hi\u0161ni \u0161tevilki",
                                                value: this.state.house_number_appendix,
                                                changeValue: (val)=>this.setState({
                                                        house_number_appendix: val
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: movable,
                                                className: 'm-1 ' + this.getValidationClass('town'),
                                                fieldName: "town",
                                                title: "Naselje",
                                                tooltip: "Naselje",
                                                value: this.state.town,
                                                changeValue: (val)=>this.setState({
                                                        town: val
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-1 flex-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: movable,
                                                className: 'm-1 ' + this.getValidationClass('post_code'),
                                                fieldName: "post_code",
                                                title: "Po\u0161tna \u0161tevilka",
                                                tooltip: "Po\u0161tna \u0161tevilka",
                                                value: this.state.post_code,
                                                changeValue: (val)=>this.setState({
                                                        post_code: val
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: movable,
                                                className: 'm-1 ' + this.getValidationClass('post_office'),
                                                fieldName: "post_office",
                                                title: "Po\u0161ta",
                                                tooltip: "Po\u0161ta",
                                                value: this.state.post_office,
                                                changeValue: (val)=>this.setState({
                                                        post_office: val
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-1 flex-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: false,
                                                className: 'm-1',
                                                fieldName: "special_notes",
                                                title: "Opis",
                                                tooltip: "Opis",
                                                value: this.state.special_notes,
                                                changeValue: (val)=>this.setState({
                                                        special_notes: val
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                disabled: false,
                                                className: 'm-1 ' + this.getValidationClass('software_maker_tax_number'),
                                                fieldName: "software-maker-tax_number",
                                                title: "Dav\u010Dna \u0161t. izdajatelja programske opreme",
                                                tooltip: "Dav\u010Dna \u0161t. izdajatelja programske opreme",
                                                value: this.state.software_maker_tax_number,
                                                changeValue: (val)=>this.setState({
                                                        software_maker_tax_number: val
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-1 flex-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: 'add-edit-item-dialog--registered_at_furs',
                                                className: 'flex-1 m-1',
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Prijavljen na FURS od",
                                                        tooltip: "Prijavljen na FURS od"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "mt-1",
                                                        children: this.state.registered_at_furs === null || this.state.registered_at_furs === false ? '' : this.getMomentFormatter('DD. MM. YYYY HH:mm').formatDate(this.state.registered_at_furs, 'sl')
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormDateInput, {
                                                disabled: false,
                                                className: "m-1",
                                                fieldName: "valid_from",
                                                title: "Veljaven od",
                                                tooltip: "Veljaven od",
                                                value: this.state.valid_from,
                                                changeValue: (val)=>this.setState({
                                                        valid_from: val
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-item-dialog--closed",
                                                className: "flex-1 pt-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Zaprtje poslovnega prostora",
                                                        tooltip: "Zaprtje poslovnega prostora"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                        id: "add-edit-item-dialog--closed",
                                                        disabled: this.props.item !== null && this.props.item.closed,
                                                        checked: this.state.closed,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                closed: event.target.checked
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        minimal: true,
                                        onClick: ()=>this.props.closeAddEditItemDialog(),
                                        children: "Prekli\u010Di"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: (0, _core.Intent).PRIMARY,
                                        onClick: ()=>this.saveAndClose(false),
                                        children: "Shrani in zapri"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: (0, _core.Intent).PRIMARY,
                                        onClick: ()=>this.saveAndClose(true),
                                        children: "Shrani in po\u0161lji na FURS"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
}
AddEditBusinessPremise.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = AddEditBusinessPremise;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","moment":"1e4qG","date-fns/formatISO":"an1FA","../TextWithTooltip":"6kuHH","../DateTimePickerDialog":"5awK0","../AppToaster":"izixN","../../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c1AnY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
class BusinessPremiseFiscalRegistrationHistoryDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        const items = this.props.business_premise_fiscal_registrations_by_id_business_premises[this.props.id_business_premise];
        this.state = {
            selected_id_business_premise_fiscal_registration: items === null || items.length == 0 ? null : items[0].id_business_premise_fiscal_registration
        };
    }
    toLocalStringWithTime(date) {
        if (date === null) return '';
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear() + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');
    }
    getStatus(status) {
        if (status === null) return "v po\u0161iljanju";
        else if (status) return 'potrjeno';
        return 'napaka pri potrjevanju';
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        const business_premise_fiscal_registration_for_business_premise = (this.props.business_premise_fiscal_registrations_by_id_business_premises === undefined ? undefined : this.props.business_premise_fiscal_registrations_by_id_business_premises[this.props.id_business_premise]) || [];
        let sel_index = -1;
        for(let i = 0; i < business_premise_fiscal_registration_for_business_premise.length; i++)if (this.state.selected_id_business_premise_fiscal_registration == business_premise_fiscal_registration_for_business_premise[i].id_business_premise_fiscal_registration) {
            sel_index = i;
            break;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: false,
            onClose: ()=>this.props.closeBusinessPremiseFiscalRegistrationHistoryDialog(),
            className: "business-premise-fiscal-registration-history-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow h-full",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Zgodovina dav\u010Dnega potrjevanja"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeBusinessPremiseFiscalRegistrationHistoryDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY + ' flex flex-row items-stretch',
                        style: {
                            height: 'calc(100% - 70px)'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-row items-stretch",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-1/4 fiscal-verification-items overflow-y-auto",
                                    children: business_premise_fiscal_registration_for_business_premise.map((business_premise_fiscal_registration, statusIdx)=>{
                                        let icon = '';
                                        let color = '';
                                        if (business_premise_fiscal_registration !== null) {
                                            if (business_premise_fiscal_registration.status === null) {
                                                icon = 'history';
                                                color = '#d9822b';
                                            } else if (business_premise_fiscal_registration.status) {
                                                icon = 'tick-circle';
                                                color = '#0f9960';
                                            } else {
                                                icon = 'warning-sign';
                                                color = '#db3737';
                                            }
                                        }
                                        const cls = business_premise_fiscal_registration.id_business_premise_fiscal_registration == this.state.selected_id_business_premise_fiscal_registration ? 'selected' : '';
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: 'fiscal-verification-item flex flex-row ' + cls,
                                            onClick: ()=>this.setState({
                                                    selected_id_business_premise_fiscal_registration: business_premise_fiscal_registration.id_business_premise_fiscal_registration
                                                }),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "w-1/6",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                        icon: icon,
                                                        color: color
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: statusIdx == 0 ? 'font-bold' : '',
                                                            children: this.toLocalStringWithTime(new Date(business_premise_fiscal_registration.created))
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: statusIdx == 0 ? 'font-bold' : '',
                                                            children: this.getStatus(business_premise_fiscal_registration.status)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, 'business_premise-fiscal-verification-' + business_premise_fiscal_registration.id_business_premise_fiscal_registration);
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex-1 fiscal-verification-messages overflow-y-scroll",
                                    children: sel_index == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-center uppercase text-lg font-light",
                                                children: "Odgovor"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                                children: business_premise_fiscal_registration_for_business_premise[sel_index].response === null ? null : JSON.stringify(JSON.parse(business_premise_fiscal_registration_for_business_premise[sel_index].response), null, 2)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Divider), {
                                                className: "mt-4 mb-4"
                                            }),
                                            (()=>{
                                                let request = null;
                                                let sent_message = business_premise_fiscal_registration_for_business_premise[sel_index].sent_message;
                                                if (sent_message !== null) {
                                                    const sent_message_obj = JSON.parse(sent_message);
                                                    if (sent_message_obj.token !== null) {
                                                        const arr = sent_message_obj.token.split('.');
                                                        if (arr.length == 3) {
                                                            const request_obj = JSON.parse(atob(arr[1]));
                                                            request = JSON.stringify(request_obj, null, 2);
                                                        }
                                                    }
                                                }
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-center uppercase text-lg font-light",
                                                            children: "Zahtevek"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                                            children: request
                                                        })
                                                    ]
                                                });
                                            })()
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
function mapStateToProps(state) {
    return {
        business_premises: state.CodeTablesSlice.business_premises,
        business_premise_fiscal_registrations_by_id_business_premises: state.CodeTablesSlice.business_premise_fiscal_registrations_by_id_business_premises,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(BusinessPremiseFiscalRegistrationHistoryDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cnpWa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _selectCustomerDialog = require("../reservations/SelectCustomerDialog");
var _selectCustomerDialogDefault = parcelHelpers.interopDefault(_selectCustomerDialog);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _appSlice = require("../../slices/AppSlice");
var _resultComponents = require("./ResultComponents");
var _app = require("../../App");
function Results(props) {
    const { table_items_total_count, table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, countries, deleteItem, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const customer_types = {
        'natural': {
            ord: 1,
            key: 'natural',
            title: "Fizi\u010Dna oseba"
        },
        'company': {
            ord: 2,
            key: 'company',
            title: 'Pravna oseba'
        }
    };
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-auto sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: check_count > 0,
                                indeterminate: !all_checked && check_count > 0,
                                onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 2,
                            ...sort_props,
                            title: "",
                            fieldName: "internal_code"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 3,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 4,
                            ...sort_props,
                            title: "Naziv",
                            fieldName: "name"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 5,
                            ...sort_props,
                            title: "Naslov",
                            fieldName: "address"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 6,
                            ...sort_props,
                            title: "Po\u0161ta",
                            fieldName: "post_office"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 7,
                            ...sort_props,
                            title: "E-po\u0161ta",
                            fieldName: "email"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 8,
                            ...sort_props,
                            title: "Dr\u017Eava",
                            fieldName: "country"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 9,
                            ...sort_props,
                            title: "Dav\u010Dna \u0161t. / ID za DDV",
                            fieldName: "tax_number"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 10,
                            ...sort_props,
                            title: "Dobavitelj",
                            fieldName: "supplier"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 11,
                            ...sort_props,
                            title: "Tip stranke",
                            fieldName: "type"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.internal_code,
                                onChange: (event)=>handleFilterChange('internal_code', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.name,
                                onChange: (event)=>handleFilterChange('name', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.address,
                                onChange: (event)=>handleFilterChange('address', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.post_office,
                                onChange: (event)=>handleFilterChange('post_office', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.email,
                                onChange: (event)=>handleFilterChange('email', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col",
                            cls: "text-right",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.country,
                                onChange: (event)=>handleFilterChange('country', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col",
                            cls: "text-right",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.tax_number,
                                onChange: (event)=>handleFilterChange('tax_number', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: tableItemsFilters.supplier === 1,
                                indeterminate: tableItemsFilters.supplier === 0,
                                onChange: (event)=>{
                                    let checked = 0;
                                    if (tableItemsFilters.supplier === 1) checked = -1;
                                    else if (tableItemsFilters.supplier === 0) checked = 1;
                                    handleFilterChange('supplier', checked);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "key",
                                    title_field: "title",
                                    items: customer_types,
                                    filtered_keys: tableItemsFilters.customer_types,
                                    displaySort: (a, b)=>a.ord - b.ord,
                                    onFilterChange: (values)=>handleFilterChange('customer_types', values)
                                })
                            })
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: table_items_checked_ids[id] === true,
                                            onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        child: item.internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "edit",
                                                    intent: "primary",
                                                    minimal: true,
                                                    small: true,
                                                    onClick: ()=>openAddEditItemDialog(item)
                                                }),
                                                null
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        child: item.type == 'natural' ? item.surname + ' ' + item.name : item.company_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        child: item.address
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        child: item.post_code + ' ' + item.post_office
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        child: item.email
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        cls: "text-right",
                                        child: countries[item.id_country].official_name_local
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        cls: "text-right",
                                        child: item.vat_registered ? item.vat_prefix + item.tax_number : item.tax_number
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 10,
                                        child: item.supplier ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                            icon: "tick",
                                            color: "#394b59"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                            icon: "cross",
                                            color: "#ff0000"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 11,
                                        cls: "text-right",
                                        child: item.type == 'natural' ? "Fizi\u010Dna" : 'Pravna'
                                    })
                                ]
                            }, 'customers-result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-sum pb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "col",
                    children: [
                        "\u0160tevilo zapisov: ",
                        table_items_total_count,
                        table_items_total_count > table_items_sort_ids.length ? ' (prikazanih je ' + table_items_sort_ids.length + ' zapisov)' : ''
                    ]
                })
            })
        ]
    });
}
class Customers extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.printLabels = this.printLabels.bind(this);
        this.updateTableItemsFromPropsDebounce = (0, _app.debounce)((props, state)=>{
            this.setState({
                ...this.updateTableItemsFromProps(props, state)
            });
        }, 400);
        const table_items_filters = {
            internal_code: '',
            name: '',
            address: '',
            post_office: '',
            email: '',
            country: '',
            tax_number: '',
            customer_types: [],
            supplier: 0
        };
        const state = {
            table_items_filters,
            table_items_sort_field: 'internal_code',
            table_items_sort_direction: 'DESC',
            customers: props.customers
        };
        const { table_items_total_count, table_items, all_table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            ...state
        });
        this.state = {
            table_items_total_count,
            table_items,
            all_table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null,
            table_items_checked_ids: {},
            ...state
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.customers != this.state.customers) this.setState({
            customers: this.props.customers,
            ...this.updateTableItemsFromProps(this.props, this.state)
        });
    }
    updateTableItemsFromProps(props, state) {
        const items_from_props = props.customers;
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, {
            table_items: items_from_props,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        }, true);
        let items = {};
        let selected_sort_ids = [];
        let all_items = {};
        let c = 0;
        for(let i = 0; i < table_items_sort_ids.length; i++){
            const key = table_items_sort_ids[i];
            if (table_items_filtered_ids.indexOf(key) == -1) continue;
            if (c < 500) {
                items[key] = items_from_props[key];
                selected_sort_ids.push(key);
            }
            all_items[key] = items_from_props[key];
            c++;
        }
        const new_state = {
            table_items_total_count: c,
            table_items: items,
            all_table_items: all_items,
            table_items_sort_ids: selected_sort_ids,
            table_items_filtered_ids: selected_sort_ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        new_state.table_items_filtered_ids = selected_sort_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = selected_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            if (field == 'name') {
                const customer_a = state.table_items[a_key];
                const customer_b = state.table_items[b_key];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = customer_a === undefined ? '' : customer_a.type == 'natural' ? customer_a.surname + ' ' + customer_a.name : customer_a.company_name;
                    b = customer_b === undefined ? '' : customer_b.type == 'natural' ? customer_b.surname + ' ' + customer_b.name : customer_b.company_name;
                }
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'tax_number') {
                const customer_a = state.table_items[a_key];
                const customer_b = state.table_items[b_key];
                a = customer_a.vat_registered ? customer_a.vat_prefix + customer_a.tax_number : customer_a.tax_number;
                b = customer_b.vat_registered ? customer_b.vat_prefix + customer_b.tax_number : customer_b.tax_number;
            } else if (field == 'address') {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'country') {
                const id_country_a = state.table_items[a_key].id_country;
                const id_country_b = state.table_items[b_key].id_country;
                a = this.props.countries[id_country_a].official_name_local;
                b = this.props.countries[id_country_b].official_name_local;
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_internal_code = filters.internal_code.toString();
        const filters_name = filters.name.toUpperCase();
        const filters_address = filters.address.toUpperCase();
        const filters_post_office = filters.post_office.toUpperCase();
        const filters_email = filters.email.toUpperCase();
        const filters_country = filters.country.toUpperCase();
        const filters_tax_number = filters.tax_number.toUpperCase();
        const filters_customer_types = filters.customer_types;
        const filters_supplier = filters.supplier;
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_internal_code != '' && item.internal_code.toString().indexOf(filters_internal_code) == -1) return false;
            if (filters_name != '' && (item.type == 'natural' ? item.surname + ' ' + item.name : item.company_name).toUpperCase().indexOf(filters_name) == -1) return false;
            if (filters_address != '' && item.address.toUpperCase().indexOf(filters_address) == -1) return false;
            if (filters_post_office != '' && (item.post_code + ' ' + item.post_office).toUpperCase().indexOf(filters_post_office) == -1) return false;
            if (filters_email != '' && item.email.toUpperCase().indexOf(filters_email) == -1) return false;
            if (filters_country != '' && this.props.countries[item.id_country] !== undefined && this.props.countries[item.id_country].official_name_local.toUpperCase().indexOf(filters_country) == -1) return false;
            if (filters_tax_number != '' && (item.vat_registered ? item.vat_prefix + item.tax_number : item.tax_number).toUpperCase().indexOf(filters_tax_number) == -1) return false;
            if (filters_customer_types.length > 0) {
                let found = false;
                for(let i = 0; i < filters_customer_types.length; i++)if (item.type == filters_customer_types[i]) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (filters_supplier !== 0 && (item.supplier === true && filters_supplier === -1 || item.supplier === false && filters_supplier === 1)) return false;
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            internal_code: this.state.table_items_filters.internal_code,
            name: this.state.table_items_filters.name,
            address: this.state.table_items_filters.address,
            post_office: this.state.table_items_filters.post_office,
            email: this.state.table_items_filters.email,
            country: this.state.table_items_filters.country,
            tax_number: this.state.table_items_filters.tax_number,
            customer_types: this.state.table_items_filters.customer_types,
            supplier: this.state.table_items_filters.supplier
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.setState({
            table_items_filters: new_filters
        });
        this.updateTableItemsFromPropsDebounce(this.props, {
            ...this.state,
            table_items_filters: new_filters
        });
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(id_customer) {
        this.setState({
            add_edit_item_dialog_open: false
        });
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    printLabels(ids) {
        for(var i = 0; i < ids.length; i++)this.props.dispatch((0, _appSlice.enqueueItemOnLabelPrinterQueue)({
            type: 'person',
            item: {
                item: this.state.table_items[ids[i]]
            }
        }));
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1 || (this.props.user.access_roles ?? []).indexOf('code-tables--customers') === -1) return null;
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deleteCustomer)(this.state.item_delete_requested.id_customer));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectCustomerDialogDefault.default), {
                    closeSelectCustomerDialog: this.closeAddEditItemDialog,
                    surname: '',
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow customers-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "primary",
                                    icon: "plus",
                                    onClick: ()=>this.openAddEditItemDialog(null),
                                    children: "Nova stranka"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "primary",
                                    icon: "print",
                                    className: "ml-2",
                                    disabled: check_count == 0,
                                    onClick: ()=>{
                                        this.printLabels(this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true));
                                    },
                                    children: "Natisni nalepke"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items_total_count: this.state.table_items_total_count,
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    countries: this.props.countries,
                                    deleteItem: this.deleteItem,
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    }
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
Customers.propTypes = {};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        countries: state.CodeTablesSlice.countries,
        api_url: state.CodeTablesSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Customers);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","../reservations/SelectCustomerDialog":"ewc5P","../../slices/CodeTablesSlice":"hfPGz","../../slices/AppSlice":"aByTQ","./ResultComponents":"1eVlZ","../../App":"4sGPJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jpSHb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditItem = require("./AddEditItem");
var _addEditItemDefault = parcelHelpers.interopDefault(_addEditItem);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _codeTables = require("../../api/CodeTables");
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _itemLabelPrintDialog = require("../ItemLabelPrintDialog");
var _itemLabelPrintDialogDefault = parcelHelpers.interopDefault(_itemLabelPrintDialog);
var _appSlice = require("../../slices/AppSlice");
var _resultComponents = require("./ResultComponents");
var _app = require("../../App");
function Results(props) {
    const { table_items_total_count, table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, measuring_units, tax_rates, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const item_types = {
        'item': {
            ord: 1,
            key: 'item',
            title: 'artikel'
        },
        'service': {
            ord: 2,
            key: 'service',
            title: 'storitev'
        },
        'tourist_tax': {
            ord: 3,
            key: 'tourist_tax',
            title: "turisti\u010Dna taksa"
        }
    };
    const today = new Date();
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-auto sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: check_count > 0,
                                indeterminate: !all_checked && check_count > 0,
                                onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 2,
                            ...sort_props,
                            title: "",
                            fieldName: "serial_internal_code"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 3,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 4,
                            ...sort_props,
                            title: "\u0160ifra artikla/storitve",
                            fieldName: "internal_code"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 5,
                            ...sort_props,
                            title: "Naziv artikla/storitve",
                            fieldName: "title"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 6,
                            ...sort_props,
                            title: "\u010Crtna koda",
                            fieldName: "ean"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 7,
                            ...sort_props,
                            title: "EM",
                            fieldName: "id_measuring_unit"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 8,
                            ...sort_props,
                            title: "Tip",
                            fieldName: "type"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 9,
                            ...sort_props,
                            title: "Cena z DDV",
                            fieldName: "amount_with_vat",
                            cls: "text-right"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 10,
                            ...sort_props,
                            title: "Stopnja davka",
                            fieldName: "tax_rate"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 11,
                            ...sort_props,
                            title: "Dovoljen popust (%)",
                            fieldName: "allowed_discount",
                            cls: "text-right"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.serial_internal_code,
                                onChange: (event)=>handleFilterChange('serial_internal_code', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.internal_code,
                                onChange: (event)=>handleFilterChange('internal_code', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.title,
                                onChange: (event)=>handleFilterChange('title', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.ean,
                                onChange: (event)=>handleFilterChange('ean', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_measuring_unit",
                                    title_field: "title",
                                    items: measuring_units,
                                    filtered_keys: tableItemsFilters.measuring_units,
                                    displayFilter: (x)=>x.visible,
                                    displaySort: (a, b)=>a.ord - b.ord,
                                    onFilterChange: (values)=>handleFilterChange('measuring_units', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "key",
                                    title_field: "title",
                                    items: item_types,
                                    filtered_keys: tableItemsFilters.item_types,
                                    displaySort: (a, b)=>a.ord - b.ord,
                                    onFilterChange: (values)=>handleFilterChange('item_types', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_tax_rate",
                                    title_field: "title",
                                    items: tax_rates,
                                    filtered_keys: tableItemsFilters.tax_rates,
                                    displaySort: (a, b)=>a.ord - b.ord,
                                    onFilterChange: (values)=>handleFilterChange('tax_rates', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "filters-col"
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            const id_price_list = (0, _priceHelperDefault.default).FindBestPriceListMatch(today, item.price_lists);
                            const price_list = id_price_list === null ? null : item.price_lists[id_price_list];
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: table_items_checked_ids[id] === true,
                                            onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        child: item.serial_internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            icon: "edit",
                                            intent: "primary",
                                            minimal: true,
                                            small: true,
                                            disabled: false,
                                            onClick: ()=>openAddEditItemDialog(item)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        child: item.internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        child: item.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        child: item.ean
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        child: measuring_units[item.id_measuring_unit].title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        child: item_types[item.type].title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        cls: "text-right",
                                        child: price_list === null ? '' : parseFloat(price_list.price).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 10,
                                        child: price_list === null ? '' : parseFloat(tax_rates[price_list.id_tax_rate].value).toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 2
                                        }) + "% \u2022 " + tax_rates[price_list.id_tax_rate].title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 11,
                                        cls: "text-right",
                                        child: parseFloat(item.allowed_discount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    })
                                ]
                            }, 'items-result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-sum pb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "col",
                    children: [
                        "\u0160tevilo zapisov: ",
                        table_items_total_count,
                        table_items_total_count > table_items_sort_ids.length ? ' (prikazanih je ' + table_items_sort_ids.length + ' zapisov)' : ''
                    ]
                })
            })
        ]
    });
}
class Items extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.printLabels = this.printLabels.bind(this);
        this.openLabelPrintDialog = this.openLabelPrintDialog.bind(this);
        this.closeLabelPrintDialog = this.closeLabelPrintDialog.bind(this);
        this.updateTableItemsFromPropsDebounce = (0, _app.debounce)((props, state)=>{
            this.setState({
                ...this.updateTableItemsFromProps(props, state)
            });
        }, 400);
        const table_items_filters = {
            serial_internal_code: '',
            internal_code: '',
            title: '',
            ean: '',
            measuring_units: [],
            item_types: [],
            tax_rates: []
        };
        const state = {
            table_items_filters,
            table_items_sort_field: 'serial_internal_code',
            table_items_sort_direction: 'DESC',
            items: props.items
        };
        const { table_items_total_count, table_items, all_table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            ...state
        });
        this.state = {
            table_items_total_count,
            table_items,
            all_table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            table_items_checked_ids: {},
            label_print_dialog_open: false,
            label_print_dialog_items: [],
            ...state
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.items != this.state.items) this.setState({
            items: this.props.items,
            ...this.updateTableItemsFromProps(this.props, this.state)
        });
    }
    updateTableItemsFromProps(props, state) {
        const items_from_props = props.items;
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, {
            table_items: items_from_props,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        }, true);
        let items = {};
        let selected_sort_ids = [];
        let all_items = {};
        let c = 0;
        for(let i = 0; i < table_items_sort_ids.length; i++){
            const key = table_items_sort_ids[i];
            if (table_items_filtered_ids.indexOf(key) == -1) continue;
            if (c < 500) {
                items[key] = items_from_props[key];
                selected_sort_ids.push(key);
            }
            all_items[key] = items_from_props[key];
            c++;
        }
        const new_state = {
            table_items_total_count: c,
            table_items: items,
            all_table_items: all_items,
            table_items_sort_ids: selected_sort_ids,
            table_items_filtered_ids: selected_sort_ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        new_state.table_items_filtered_ids = selected_sort_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = selected_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            if (field == 'amount_with_vat' || field == 'tax_rate') {
                const customer_a = state.table_items[a_key];
                const customer_b = state.table_items[b_key];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    if (customer_a === undefined) a = 0;
                    else {
                        const price_lists = Object.values(customer_a.price_lists);
                        //TODO select price list based on date
                        const price_list = price_lists.length == 0 ? null : price_lists[0];
                        if (field == 'amount_with_vat') a = price_list === null ? 0 : price_list.price;
                        else if (field == 'tax_rate') a = price_list === null ? 0 : this.props.tax_rates[price_list.id_tax_rate].title;
                    }
                    if (customer_b === undefined) b = 0;
                    else {
                        const price_lists = Object.values(customer_b.price_lists);
                        //TODO select price list based on date
                        const price_list = price_lists.length == 0 ? null : price_lists[0];
                        if (field == 'amount_with_vat') b = price_list === null ? 0 : parseFloat(price_list.price);
                        else if (field == 'tax_rate') b = price_list === null ? 0 : this.props.tax_rates[price_list.id_tax_rate].title;
                    }
                }
            } else if (field == 'title') {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_serial_internal_code = filters.serial_internal_code;
        const filters_internal_code = filters.internal_code.trim().toUpperCase();
        const filters_title = filters.title.trim().toUpperCase();
        const filters_ean = filters.ean.trim().toUpperCase();
        const filters_measuring_units = filters.measuring_units;
        const filters_item_types = filters.item_types;
        const filters_tax_rates = filters.tax_rates;
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_serial_internal_code != '' && item.serial_internal_code.toString().indexOf(filters_serial_internal_code) == -1) return false;
            if (filters_internal_code != '' && item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) return false;
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            if (filters_ean != '' && item.ean.toUpperCase().indexOf(filters_ean) == -1) return false;
            if (filters_measuring_units.length > 0) {
                let found = false;
                for(let i = 0; i < filters_measuring_units.length; i++)if (item.id_measuring_unit == filters_measuring_units[i]) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (filters_item_types.length > 0) {
                let found = false;
                for(let i = 0; i < filters_item_types.length; i++)if (item.type == filters_item_types[i]) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (filters_tax_rates.length > 0) {
                let found = false;
                for(let i = 0; i < filters_tax_rates.length; i++){
                    const price_lists = Object.values(item.price_lists);
                    //TODO select price list based on date
                    const price_list = price_lists.length == 0 ? null : price_lists[0];
                    if (price_list.id_tax_rate == filters_tax_rates[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) return false;
            }
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            serial_internal_code: this.state.table_items_filters.serial_internal_code,
            internal_code: this.state.table_items_filters.internal_code,
            title: this.state.table_items_filters.title,
            ean: this.state.table_items_filters.ean,
            measuring_units: this.state.table_items_filters.measuring_units,
            item_types: this.state.table_items_filters.item_types,
            tax_rates: this.state.table_items_filters.tax_rates
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.setState({
            table_items_filters: new_filters
        });
        this.updateTableItemsFromPropsDebounce(this.props, {
            ...this.state,
            table_items_filters: new_filters
        });
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) {
            this.props.dispatch((0, _codeTablesSlice.addItem)({
                item,
                token: this.props.token,
                save_to_api: true
            }));
            setTimeout(()=>{
                (0, _codeTables.loadItems)(this.props.api_url, this.props.dispatch, this.props.token);
            }, 2000);
        }
    }
    exportToExcel() {
        const params = [];
        const data = {
            serial_internal_code: this.state.table_items_filters.serial_internal_code,
            internal_code: this.state.table_items_filters.internal_code,
            title: this.state.table_items_filters.title,
            ean: this.state.table_items_filters.ean,
            measuring_units: this.state.table_items_filters.measuring_units.join(','),
            item_types: this.state.table_items_filters.item_types.join(','),
            tax_rates: this.state.table_items_filters.tax_rates.join(','),
            sort_field: this.state.table_items_sort_field,
            sort_direction: this.state.table_items_sort_direction
        };
        const form = document.createElement('form');
        form.target = '_blank';
        form.method = 'POST';
        form.action = this.props.api_url + 'CodeTables/v1/export-items-to-excel?' + params.join('&');
        form.style.display = 'none';
        for(let key in data){
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
    openLabelPrintDialog(ids) {
        const today = new Date();
        const items = [];
        for(let i = 0; i < ids.length; i++){
            const item = this.state.table_items[ids[i]];
            const id_price_list = (0, _priceHelperDefault.default).FindBestPriceListMatch(today, item.price_lists);
            const price_list = id_price_list === null ? null : item.price_lists[id_price_list];
            const price = price_list === null ? 0 : price_list.price;
            items.push({
                item,
                price: parseFloat(price)
            });
        }
        this.setState({
            label_print_dialog_open: true,
            label_print_dialog_items: items
        });
    }
    closeLabelPrintDialog(items_with_counts) {
        this.setState({
            label_print_dialog_open: false,
            label_print_dialog_items: []
        });
        if (items_with_counts === null) return;
        this.printLabels(items_with_counts);
    }
    printLabels(items_with_counts) {
        for(let i = 0; i < items_with_counts.length; i++)for(let c = 0; c < items_with_counts[i].count; c++)this.props.dispatch((0, _appSlice.enqueueItemOnLabelPrinterQueue)({
            type: 'item',
            item: items_with_counts[i].item
        }));
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1 || (this.props.user.access_roles ?? []).indexOf('code-tables--items-and-services') === -1) return null;
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditItemDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item,
                    measuring_units: this.props.measuring_units,
                    tax_rates: this.props.tax_rates,
                    items: this.props.items
                }),
                !this.state.label_print_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemLabelPrintDialogDefault.default), {
                    items: this.state.label_print_dialog_items,
                    closeDialog: this.closeLabelPrintDialog
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow items-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "primary",
                                    icon: "plus",
                                    onClick: ()=>this.openAddEditItemDialog(null),
                                    children: "Nov artikel/storitev"
                                }),
                                (this.props.user.access_roles ?? []).indexOf('code-tables--items-and-services') === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "primary",
                                    icon: "cloud-download",
                                    className: "ml-2",
                                    onClick: ()=>this.exportToExcel(),
                                    children: "Izvoz v Excel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "primary",
                                    icon: "print",
                                    className: "ml-2",
                                    disabled: check_count == 0,
                                    onClick: ()=>{
                                        this.openLabelPrintDialog(this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true));
                                    },
                                    children: "Natisni nalepke"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items_total_count: this.state.table_items_total_count,
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    measuring_units: this.props.measuring_units,
                                    tax_rates: this.props.tax_rates,
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    }
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
Items.propTypes = {};
function mapStateToProps(state) {
    return {
        items: state.CodeTablesSlice.items,
        measuring_units: state.CodeTablesSlice.measuring_units,
        tax_rates: state.CodeTablesSlice.tax_rates,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        api_url: state.ConstantsSlice.api_url
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Items);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditItem":"f3Ovp","../../slices/CodeTablesSlice":"hfPGz","../../api/CodeTables":"4GMYC","../../helpers/PriceHelper":"91cdD","../ItemLabelPrintDialog":"dqGIh","../../slices/AppSlice":"aByTQ","./ResultComponents":"1eVlZ","../../App":"4sGPJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f3Ovp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _numbers = require("../../numbers");
var _utils = require("../../utils");
class AddEditItem extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.setCurrentItemPriceList = this.setCurrentItemPriceList.bind(this);
        this.saveItem = this.saveItem.bind(this);
        const first_measuring_unit = Object.values(this.props.measuring_units).sort((a, b)=>a.ord - b.ord)[0];
        this.state = {
            id_item: props.item === null ? (0, _uuidDefault.default).v4() : props.item.id_item,
            active: props.item === null ? true : props.item.active,
            internal_code: props.item === null ? '' : props.item.internal_code,
            title: props.item === null ? '' : props.item.title,
            description: props.item === null ? '' : props.item.description,
            show_description_on_documents: props.item === null ? false : props.item.show_description_on_documents,
            ean: props.item === null ? '' : props.item.ean,
            id_measuring_unit: props.item === null ? first_measuring_unit.id_measuring_unit : props.item.id_measuring_unit,
            type: props.item === null ? 'service' : props.item.type,
            allowed_discount: props.item === null ? 0 : props.item.allowed_discount,
            allow_changing_price: props.item === null ? false : props.item.allow_changing_price,
            price_lists: props.item === null ? [] : Object.values(this.props.item.price_lists),
            new_price_lists: [],
            current_item_price_list: null,
            current_item_price_list_price_with_vat: 0,
            current_item_price_list_price_without_vat: 0,
            current_item_price_list_id_tax_rate: null,
            current_item_price_list_valid_from: null,
            current_item_price_list_valid_until: null,
            validation_failed_fields: [],
            show_ean_warning: false,
            show_error: false,
            show_error_message: '',
            show_all_price_lists: false
        };
        this.state = {
            ...this.state,
            allowed_discount_formatted: parseFloat(this.state.allowed_discount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        };
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    setCurrentItemPriceList(price_list) {
        const tax_rate = this.props.tax_rates[price_list.id_tax_rate];
        const current_item_price_list_price_with_vat = parseFloat(price_list.price).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        const current_item_price_list_price_without_vat = (parseFloat(price_list.price) / (1 + parseFloat(tax_rate.value) / 100)).toLocaleString(undefined, {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
        });
        this.setState({
            current_item_price_list: price_list,
            current_item_price_list_price_with_vat,
            current_item_price_list_price_without_vat,
            current_item_price_list_price_with_vat_formatted: (0, _numbers.parseFloatLocal)(current_item_price_list_price_with_vat).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }),
            current_item_price_list_price_without_vat_formatted: (0, _numbers.parseFloatLocal)(current_item_price_list_price_without_vat).toLocaleString(undefined, {
                minimumFractionDigits: 4,
                maximumFractionDigits: 4
            }),
            current_item_price_list_id_tax_rate: price_list.id_tax_rate,
            current_item_price_list_valid_from: price_list.valid_from,
            current_item_price_list_valid_until: price_list.valid_until
        });
    }
    saveItem(skip_warning) {
        skip_warning = skip_warning || false;
        if (this.state.internal_code.length == 0) {
            this.setState({
                show_error: true,
                show_error_message: "Vnos \u0161ifre je obvezen"
            });
            return;
        }
        if (this.state.title.length == 0) {
            this.setState({
                show_error: true,
                show_error_message: 'Vnos naziva je obvezen'
            });
            return;
        }
        if (this.state.price_lists.length == 0) {
            this.setState({
                show_error: true,
                show_error_message: 'Vnesite vsaj eno ceno'
            });
            return;
        }
        if (this.props.item === null) {
            if (Object.values(this.props.items).find((x)=>x.internal_code.toUpperCase() == this.state.internal_code.toUpperCase()) !== undefined) {
                this.setState({
                    show_error: true,
                    show_error_message: "Vpisana \u0161ifra \u017Ee obstaja"
                });
                return;
            }
        }
        if (this.state.ean.length > 0 && Object.values(this.props.items).find((x)=>x.ean.toUpperCase() == this.state.ean.toUpperCase() && x.id_item != this.state.id_item) !== undefined && !skip_warning) {
            this.setState({
                show_ean_warning: true
            });
            return;
        }
        let price_lists = {};
        for(let i = 0; i < this.state.price_lists.length; i++)price_lists[this.state.price_lists[i].id_item_price_list] = this.state.price_lists[i];
        this.props.closeAddEditItemDialog({
            ...this.props.item === null ? {} : this.props.item,
            id_item: this.state.id_item,
            internal_code: this.state.internal_code,
            title: this.state.title,
            ean: this.state.ean,
            id_measuring_unit: this.state.id_measuring_unit,
            type: this.state.type,
            allowed_discount: this.state.allowed_discount,
            allow_changing_price: this.state.allow_changing_price,
            active: this.state.active,
            description: this.state.description,
            show_description_on_documents: this.state.show_description_on_documents,
            price_lists
        });
    }
    render() {
        const current_iso_date = (0, _momentDefault.default)().toISOString(true);
        const types = [
            {
                title: 'Storitev',
                value: 'service'
            },
            {
                title: 'Artikel',
                value: 'item'
            },
            {
                title: "Turisti\u010Dna taksa",
                value: 'tourist_tax'
            }
        ];
        const todayIso = (0, _momentDefault.default)().format('YYYY-MM-DD');
        let displayed_price_lists = this.state.price_lists.sort((a, b)=>a.valid_from < b.valid_from ? 1 : a.valid_from > b.valid_from ? -1 : 0);
        const all_price_list_count = displayed_price_lists.length;
        if (!this.state.show_all_price_lists) {
            let filtered_price_lists = [];
            for(let i = 0; i < displayed_price_lists.length; i++){
                const price_list = displayed_price_lists[i];
                const currently_valid = price_list.valid_until === null || price_list.valid_until >= todayIso;
                if (currently_valid || filtered_price_lists.length < 7) filtered_price_lists.push(price_list);
            }
            displayed_price_lists = filtered_price_lists;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: false,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-item-dialog",
            children: [
                !this.state.show_ean_warning ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Da",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "help",
                    intent: (0, _core.Intent).WARNING,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.saveItem(true);
                        this.setState({
                            show_ean_warning: false
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            show_ean_warning: false
                        });
                    },
                    children: "EAN koda \u017Ee obstaja. Vseeno nadaljujem?"
                }),
                !this.state.show_error ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    confirmButtonText: "Zapri",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "error",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.setState({
                            show_error: false
                        });
                    },
                    children: this.state.show_error_message
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar), {
                            fixedToTop: false,
                            className: "bp5-dark",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi artikel/storitev"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_BODY,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-fields",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        labelFor: "add-edit-item-dialog--internal_code",
                                        className: "internal-code",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                label: "\u0160ifra artikla/storitve",
                                                tooltip: "\u0160ifra artikla/storitve"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                tabIndex: "1",
                                                id: "add-edit-item-dialog--internal_code",
                                                value: this.state.internal_code,
                                                disabled: this.props.item !== null,
                                                onChange: (event)=>{
                                                    this.setState({
                                                        internal_code: event.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        labelFor: "add-edit-item-dialog--title",
                                        className: "title",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                label: "Naziv artikla/storitve",
                                                tooltip: "Naziv artikla/storitve"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                tabIndex: "7",
                                                id: "add-edit-item-dialog--title",
                                                value: this.state.title,
                                                onChange: (event)=>{
                                                    this.setState({
                                                        title: event.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        labelFor: "add-edit-item-dialog--description",
                                        className: "description",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                label: "Opis",
                                                tooltip: "Opis"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                tabIndex: "11",
                                                id: "add-edit-item-dialog--description",
                                                value: this.state.description,
                                                fill: true,
                                                onChange: (event)=>{
                                                    this.setState({
                                                        description: event.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        labelFor: "add-edit-item-dialog--ean",
                                        className: "ean",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                label: "\u010Crtna koda",
                                                tooltip: "\u010Crtna koda"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                tabIndex: "2",
                                                id: "add-edit-item-dialog--ean",
                                                value: this.state.ean,
                                                onChange: (event)=>{
                                                    this.setState({
                                                        ean: event.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-item-dialog--id_measuring_unit",
                                                className: "id-measuring-unit mr-2 flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "EM",
                                                        tooltip: "EM"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                        tabIndex: "8",
                                                        id: "add-edit-item-dialog--id_measuring_unit",
                                                        fill: true,
                                                        options: Object.values(this.props.measuring_units).sort((a, b)=>a.ord - b.ord).map((item)=>{
                                                            return {
                                                                label: item.title,
                                                                value: item.id_measuring_unit
                                                            };
                                                        }),
                                                        value: this.state.id_measuring_unit,
                                                        onChange: (e)=>{
                                                            this.setState({
                                                                id_measuring_unit: e.currentTarget.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-item-dialog--allowed_discount",
                                                className: "price_with_tax flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Dovoljen popust",
                                                        tooltip: "Dovoljen popust"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                        tabIndex: "9",
                                                        id: "add-edit-item-dialog--allowed_discount",
                                                        className: "text-right",
                                                        value: this.state.allowed_discount_formatted,
                                                        rightElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tag), {
                                                            minimal: true,
                                                            children: "%"
                                                        }),
                                                        onChange: (event)=>{
                                                            const value = event.target.value;
                                                            let val = (0, _numbers.parseFloatLocal)(value);
                                                            if (Object.is(val, NaN)) val = 0;
                                                            this.setState({
                                                                allowed_discount: val,
                                                                allowed_discount_formatted: value
                                                            });
                                                        },
                                                        onBlur: (event)=>{
                                                            this.setState({
                                                                allowed_discount_formatted: parseFloat(this.state.allowed_discount).toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        labelFor: "add-edit-item-dialog--type",
                                        className: "type",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                label: "Tip",
                                                tooltip: "Tip"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.RadioGroup), {
                                                id: "add-edit-item-dialog--type",
                                                onChange: (event)=>{
                                                    this.setState({
                                                        type: event.target.value
                                                    });
                                                },
                                                selectedValue: this.state.type,
                                                inline: true,
                                                children: types.map(function(item, idx) {
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                        tabIndex: 3 + idx,
                                                        value: item.value,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "inline-flex flex-row",
                                                            children: item.title
                                                        })
                                                    }, item.value);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        labelFor: "add-edit-item-dialog--active",
                                        className: "active",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                label: "Aktiven",
                                                tooltip: "Aktiven",
                                                cls: "wrap"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                tabIndex: "6",
                                                id: "add-edit-item-dialog--active",
                                                checked: this.state.active,
                                                onChange: (event)=>{
                                                    this.setState({
                                                        active: event.target.checked
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        labelFor: "add-edit-item-dialog--allow_changing_price",
                                        className: "allow_changing_price",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                label: "Sprememba prodajne cene na dokumentu",
                                                tooltip: "Sprememba prodajne cene na dokumentu",
                                                cls: "wrap"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                tabIndex: "10",
                                                id: "add-edit-item-dialog--allow_changing_price",
                                                checked: this.state.allow_changing_price,
                                                onChange: (event)=>{
                                                    this.setState({
                                                        allow_changing_price: event.target.checked
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        labelFor: "add-edit-item-dialog--show_description_on_documents",
                                        className: "show-description-on-documents",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                label: "Izpi\u0161i opis na dokumentu",
                                                tooltip: "Izpi\u0161i opis na dokumentu",
                                                cls: "wrap"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                tabIndex: "12",
                                                id: "add-edit-item-dialog--show_description_on_documents",
                                                checked: this.state.show_description_on_documents,
                                                onChange: (event)=>{
                                                    this.setState({
                                                        show_description_on_documents: event.target.checked
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Tabs), {
                                        selectedTabId: "price-list",
                                        className: "tabs",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                id: "price-list",
                                                title: "Ceniki",
                                                panel: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mb-4",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                intent: "primary",
                                                                icon: "plus",
                                                                onClick: ()=>{
                                                                    const price_lists_sorted = this.state.price_lists.sort((a, b)=>a.valid_from < b.valid_from ? 1 : a.valid_from > b.valid_from ? -1 : 0);
                                                                    const id_item_price_list = (0, _uuidDefault.default).v4();
                                                                    let valid_from = price_lists_sorted.length > 0 ? price_lists_sorted[0].valid_until : null;
                                                                    let valid_until = price_lists_sorted.length > 0 ? price_lists_sorted[0].valid_until : null;
                                                                    valid_from = valid_from === null ? (0, _momentDefault.default)() : (0, _momentDefault.default)(valid_from).add(1, 'd');
                                                                    valid_until = valid_until === null ? (0, _momentDefault.default)() : (0, _momentDefault.default)(valid_until).add(1, 'd');
                                                                    valid_from = valid_from.format('YYYY-MM-DD');
                                                                    valid_until = valid_until.format('YYYY-MM-DD');
                                                                    const price_lists = [
                                                                        {
                                                                            id_item_price_list,
                                                                            id_item: this.state.id_item,
                                                                            valid_from,
                                                                            valid_until,
                                                                            price: price_lists_sorted.length > 0 ? price_lists_sorted[0].price : 0,
                                                                            id_tax_rate: price_lists_sorted.length > 0 ? price_lists_sorted[0].id_tax_rate : 'ba475ef0-b6d2-4ac4-af12-c21db3e50f52' /* 22 % */ 
                                                                        },
                                                                        ...this.state.price_lists
                                                                    ];
                                                                    this.setState({
                                                                        price_lists,
                                                                        new_price_lists: [
                                                                            ...this.state.new_price_lists,
                                                                            id_item_price_list
                                                                        ]
                                                                    });
                                                                    this.setCurrentItemPriceList(price_lists[0]);
                                                                },
                                                                children: "Dodaj cenik"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex flex-row justify-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "price-list",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "price-list-items",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "font-bold"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "font-bold",
                                                                                    children: "Velja od"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "font-bold",
                                                                                    children: "Velja do"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "text-right font-bold",
                                                                                    children: "Cena brez DDV"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "text-right font-bold",
                                                                                    children: "Cena z DDV"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "text-right font-bold",
                                                                                    children: "Stopnja davka"
                                                                                }),
                                                                                displayed_price_lists.map((price_list)=>{
                                                                                    const tax_rate = this.props.tax_rates[price_list.id_tax_rate];
                                                                                    let cls = '';
                                                                                    if (this.state.current_item_price_list !== null && this.state.current_item_price_list.id_item_price_list == price_list.id_item_price_list) cls += ' font-bold';
                                                                                    let price_cls = '';
                                                                                    if (price_list.valid_until !== null && price_list.valid_until < todayIso) cls += ' text-gray-500';
                                                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: cls,
                                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                                                    icon: "edit",
                                                                                                    intent: "primary",
                                                                                                    minimal: true,
                                                                                                    small: true,
                                                                                                    onClick: ()=>{
                                                                                                        this.setCurrentItemPriceList(price_list);
                                                                                                    }
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: cls,
                                                                                                children: price_list.valid_from === null ? '' : (0, _momentDefault.default)(price_list.valid_from).format('DD.MM.YYYY')
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: cls,
                                                                                                children: price_list.valid_until === null ? '' : (0, _momentDefault.default)(price_list.valid_until).format('DD.MM.YYYY')
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: cls + price_cls + ' text-right',
                                                                                                children: (parseFloat(price_list.price) / (1 + parseFloat(tax_rate.value) / 100)).toLocaleString(undefined, {
                                                                                                    minimumFractionDigits: 2,
                                                                                                    maximumFractionDigits: 2
                                                                                                }) + ' EUR'
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: cls + price_cls + ' text-right',
                                                                                                children: parseFloat(price_list.price).toLocaleString(undefined, {
                                                                                                    minimumFractionDigits: 2,
                                                                                                    maximumFractionDigits: 2
                                                                                                }) + ' EUR'
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: cls + ' text-right',
                                                                                                children: tax_rate.title + ' (' + parseFloat(tax_rate.value).toLocaleString(undefined, {
                                                                                                    minimumFractionDigits: 2,
                                                                                                    maximumFractionDigits: 2
                                                                                                }) + '%)'
                                                                                            })
                                                                                        ]
                                                                                    }, 'price-list-' + price_list.id_item_price_list);
                                                                                })
                                                                            ]
                                                                        }),
                                                                        this.state.show_all_price_lists || all_price_list_count == displayed_price_lists.length ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                            className: "mt-2",
                                                                            onClick: ()=>this.setState({
                                                                                    show_all_price_lists: true
                                                                                }),
                                                                            children: "Prika\u017Ei vse cenike"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "price-list-edit",
                                                                    children: this.state.current_item_price_list === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                                    labelFor: "add-edit-item-dialog--item-price-list--id_tax_rate",
                                                                                    className: "id-tax-rate",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                                            label: "Stopnja davka",
                                                                                            tooltip: "Stopnja davka"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                                                            id: "add-edit-item-dialog--item-price-list--id_tax_rate",
                                                                                            fill: true,
                                                                                            options: Object.values(this.props.tax_rates).sort((a, b)=>a.ord - b.ord).filter((x)=>(x.valid_from === null || x.valid_from <= current_iso_date) && (x.valid_until === null || x.valid_until >= current_iso_date)).map((item)=>{
                                                                                                return {
                                                                                                    label: item.title + ' (' + parseFloat(item.value).toLocaleString(undefined, {
                                                                                                        minimumFractionDigits: 2,
                                                                                                        maximumFractionDigits: 2
                                                                                                    }) + '%)',
                                                                                                    value: item.id_tax_rate
                                                                                                };
                                                                                            }),
                                                                                            value: this.state.current_item_price_list_id_tax_rate,
                                                                                            onChange: (e)=>{
                                                                                                const tax_rate = this.props.tax_rates[e.currentTarget.value];
                                                                                                const current_item_price_list_price_without_vat = parseFloat(this.state.current_item_price_list_price_with_vat) / (1 + parseFloat(tax_rate.value) / 100);
                                                                                                this.setState({
                                                                                                    current_item_price_list_id_tax_rate: e.currentTarget.value,
                                                                                                    current_item_price_list_price_without_vat,
                                                                                                    current_item_price_list_price_without_vat_formatted: current_item_price_list_price_without_vat.toLocaleString(undefined, {
                                                                                                        minimumFractionDigits: 4,
                                                                                                        maximumFractionDigits: 4
                                                                                                    })
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "flex justify-end gap-4",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                                        labelFor: "add-edit-item-dialog--item-price-list--price",
                                                                                        className: "price w-24",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                                                label: "Cena brez DDV",
                                                                                                tooltip: "Cena brez DDV"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                                                                id: "add-edit-item-dialog--item-price-list--price",
                                                                                                className: "text-right",
                                                                                                value: this.state.current_item_price_list_price_without_vat_formatted,
                                                                                                onChange: (event)=>{
                                                                                                    const value = event.target.value;
                                                                                                    let val = (0, _numbers.parseFloatLocal)(value);
                                                                                                    if (Object.is(val, NaN)) val = 0;
                                                                                                    const tax_rate = this.props.tax_rates[this.state.current_item_price_list_id_tax_rate];
                                                                                                    const current_item_price_list_price_with_vat = parseFloat(val) * (1 + parseFloat(tax_rate.value) / 100);
                                                                                                    this.setState({
                                                                                                        current_item_price_list_price_with_vat,
                                                                                                        current_item_price_list_price_with_vat_formatted: current_item_price_list_price_with_vat.toLocaleString(undefined, {
                                                                                                            minimumFractionDigits: 2,
                                                                                                            maximumFractionDigits: 2
                                                                                                        }),
                                                                                                        current_item_price_list_price_without_vat: val,
                                                                                                        current_item_price_list_price_without_vat_formatted: value
                                                                                                    });
                                                                                                },
                                                                                                onBlur: (event)=>{
                                                                                                    this.setState({
                                                                                                        current_item_price_list_price_without_vat_formatted: parseFloat(this.state.current_item_price_list_price_without_vat).toLocaleString(undefined, {
                                                                                                            minimumFractionDigits: 4,
                                                                                                            maximumFractionDigits: 4
                                                                                                        })
                                                                                                    });
                                                                                                }
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                                        labelFor: "add-edit-item-dialog--item-price-list--price_with_tax",
                                                                                        className: "price_with_tax w-24",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                                                label: "Cena z DDV",
                                                                                                tooltip: "Cena z DDV"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                                                                id: "add-edit-item-dialog--item-price-list--price_with_tax",
                                                                                                className: "text-right",
                                                                                                value: this.state.current_item_price_list_price_with_vat_formatted,
                                                                                                onChange: (event)=>{
                                                                                                    const value = event.target.value;
                                                                                                    let val = (0, _numbers.parseFloatLocal)(value);
                                                                                                    if (Object.is(val, NaN)) val = 0;
                                                                                                    const tax_rate = this.props.tax_rates[this.state.current_item_price_list_id_tax_rate];
                                                                                                    const current_item_price_list_price_without_vat = parseFloat(val) / (1 + parseFloat(tax_rate.value) / 100);
                                                                                                    this.setState({
                                                                                                        current_item_price_list_price_with_vat: val,
                                                                                                        current_item_price_list_price_with_vat_formatted: value,
                                                                                                        current_item_price_list_price_without_vat,
                                                                                                        current_item_price_list_price_without_vat_formatted: current_item_price_list_price_without_vat.toLocaleString(undefined, {
                                                                                                            minimumFractionDigits: 4,
                                                                                                            maximumFractionDigits: 4
                                                                                                        })
                                                                                                    });
                                                                                                },
                                                                                                onBlur: (event)=>{
                                                                                                    this.setState({
                                                                                                        current_item_price_list_price_with_vat_formatted: parseFloat(this.state.current_item_price_list_price_with_vat).toLocaleString(undefined, {
                                                                                                            minimumFractionDigits: 2,
                                                                                                            maximumFractionDigits: 2
                                                                                                        })
                                                                                                    });
                                                                                                }
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "flex justify-end gap-4",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                                        labelFor: "add-edit-item-dialog--item-price-list--valid_from",
                                                                                        className: "valid_from w-24",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                                                label: "Velja od",
                                                                                                tooltip: "Velja od"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                                                                id: "add-edit-item-dialog--item-price-list--valid_from",
                                                                                                dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                                                                dateFnsFormat: 'dd. MM. yyyy',
                                                                                                locale: "sl",
                                                                                                inputProps: {
                                                                                                    placeholder: '01. 01. ' + new Date().getFullYear()
                                                                                                },
                                                                                                selectAllOnFocus: true,
                                                                                                minDate: new Date('1900-01-01'),
                                                                                                maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                                                                onChange: (selectedDate, isUserChange)=>{
                                                                                                    if (!isUserChange) return;
                                                                                                    this.setState({
                                                                                                        current_item_price_list_valid_from: selectedDate
                                                                                                    });
                                                                                                },
                                                                                                value: this.state.current_item_price_list_valid_from
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                                        labelFor: "add-edit-item-dialog--item-price-list--without_valid_until",
                                                                                        className: "without-valid-until mr-2",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                                                label: "Odprta cena",
                                                                                                tooltip: "Odprta cena",
                                                                                                cls: "wrap"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                                                                id: "add-edit-item-dialog--item-price-list--without_valid_until",
                                                                                                checked: this.state.current_item_price_list_valid_until === null,
                                                                                                onChange: (event)=>{
                                                                                                    this.setState({
                                                                                                        current_item_price_list_valid_until: event.target.checked ? null : (0, _momentDefault.default)().format('YYYY-MM-DD')
                                                                                                    });
                                                                                                }
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                                                        labelFor: "add-edit-item-dialog--item-price-list--valid_until",
                                                                                        className: "valid_until w-24",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                                                                label: "Velja do",
                                                                                                tooltip: "Velja do"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                                                                id: "add-edit-item-dialog--item-price-list--valid_until",
                                                                                                dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                                                                dateFnsFormat: 'dd. MM. yyyy',
                                                                                                locale: "sl",
                                                                                                inputProps: {
                                                                                                    placeholder: '01. 01. ' + new Date().getFullYear()
                                                                                                },
                                                                                                selectAllOnFocus: true,
                                                                                                minDate: new Date('1900-01-01'),
                                                                                                maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                                                                onChange: (selectedDate, isUserChange)=>{
                                                                                                    if (!isUserChange) return;
                                                                                                    this.setState({
                                                                                                        current_item_price_list_valid_until: selectedDate
                                                                                                    });
                                                                                                },
                                                                                                value: this.state.current_item_price_list_valid_until
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "flex justify-end gap-4 pt-4",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                                        minimal: true,
                                                                                        onClick: ()=>{
                                                                                            let price_lists = [
                                                                                                ...this.state.price_lists
                                                                                            ];
                                                                                            if (this.state.new_price_lists.indexOf(this.state.current_item_price_list.id_item_price_list) != -1) price_lists = price_lists.filter((x)=>x.id_item_price_list != this.state.current_item_price_list.id_item_price_list);
                                                                                            this.setState({
                                                                                                current_item_price_list: null,
                                                                                                price_lists
                                                                                            });
                                                                                        },
                                                                                        children: "Prekli\u010Di"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                                        intent: "primary",
                                                                                        onClick: ()=>{
                                                                                            const tax_rate = this.props.tax_rates[this.state.current_item_price_list_id_tax_rate];
                                                                                            const item = {
                                                                                                ...this.state.current_item_price_list,
                                                                                                price: parseFloat(this.state.current_item_price_list_price_with_vat),
                                                                                                id_tax_rate: this.state.current_item_price_list_id_tax_rate,
                                                                                                valid_from: this.state.current_item_price_list_valid_from,
                                                                                                valid_until: this.state.current_item_price_list_valid_until
                                                                                            };
                                                                                            const price_lists = [
                                                                                                ...this.state.price_lists
                                                                                            ];
                                                                                            for(let i = 0; i < price_lists.length; i++)if (price_lists[i].id_item_price_list == item.id_item_price_list) {
                                                                                                price_lists[i] = item;
                                                                                                break;
                                                                                            }
                                                                                            this.setState({
                                                                                                current_item_price_list: null,
                                                                                                price_lists
                                                                                            });
                                                                                        },
                                                                                        children: "Shrani ceno"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                id: "language",
                                                title: "Jezik",
                                                disabled: true,
                                                panel: null
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                id: "group",
                                                title: "Skupina",
                                                disabled: true,
                                                panel: null
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        minimal: true,
                                        disabled: this.state.current_item_price_list !== null,
                                        onClick: ()=>this.props.closeAddEditItemDialog(),
                                        children: "Prekli\u010Di"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: (0, _core.Intent).PRIMARY,
                                        disabled: this.state.current_item_price_list !== null,
                                        onClick: ()=>this.saveItem(),
                                        children: "Shrani in zapri"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
}
AddEditItem.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object,
    measuring_units: (0, _propTypesDefault.default).object,
    tax_rates: (0, _propTypesDefault.default).object
};
exports.default = AddEditItem;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","moment":"1e4qG","date-fns/formatISO":"an1FA","uuid":"b52pV","../TextWithTooltip":"6kuHH","../../numbers":"jOh9w","../../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dqGIh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("./TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _numbers = require("../numbers");
class ItemLabelPrintDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            items_with_counts: props.items.map((item)=>{
                return {
                    item,
                    count: props.counts === null || props.counts === undefined || props.counts[item.item.id_item] === undefined ? 1 : props.counts[item.item.id_item]
                };
            })
        };
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: false,
            onClose: ()=>{
                this.props.closeDialog(null);
            },
            className: "item-label-print-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Tiskanje nalepk"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>{
                                        this.props.closeDialog(null);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'grid gap-4 list',
                            children: this.state.items_with_counts.map((item_with_count, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: item_with_count.item.item.internal_code
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'text-gray-500',
                                                    children: item_with_count.item.item.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-right",
                                            children: item_with_count.item.price.toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                                value: item_with_count.count,
                                                min: 0,
                                                fill: true,
                                                buttonPosition: "none",
                                                onValueChange: (val)=>{
                                                    const items_with_counts = [
                                                        ...this.state.items_with_counts
                                                    ];
                                                    items_with_counts[idx].count = val;
                                                    this.setState({
                                                        items_with_counts
                                                    });
                                                },
                                                rightElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                        tabIndex: -1,
                                                        icon: "trash"
                                                    }),
                                                    disabled: item_with_count.count <= 0,
                                                    tabIndex: -1,
                                                    onClick: ()=>{
                                                        const items_with_counts = [
                                                            ...this.state.items_with_counts
                                                        ];
                                                        items_with_counts[idx].count = 0;
                                                        this.setState({
                                                            items_with_counts
                                                        });
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                }, item_with_count.item.item.id_item))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>{
                                        this.props.closeDialog(null);
                                    },
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.state.items_with_counts);
                                    },
                                    children: "Zapri in natisni"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
function mapStateToProps(state) {
    return {};
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ItemLabelPrintDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./TextWithTooltip":"6kuHH","../numbers":"jOh9w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4LGr9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditMarketSegmentationItem = require("./AddEditMarketSegmentationItem");
var _addEditMarketSegmentationItemDefault = parcelHelpers.interopDefault(_addEditMarketSegmentationItem);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Naziv artikla/storitve",
                        fieldName: "title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "Vrstni red",
                        fieldName: "ord"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.title,
                            onChange: (event)=>handleFilterChange('title', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: item.title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "text-right",
                            child: item.ord
                        })
                    ]
                }, 'market-segmentation-result--result-' + id);
            })
        ]
    });
}
class Items extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'ord',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                title: ''
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
        this.state.table_items_sort_ids = this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, this.state.table_items_filtered_ids, table_items, true);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.market_segmentation != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.market_segmentation);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const table_items_sort_ids = this.state === undefined ? sort_ids : this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, ids, props.market_segmentation, true);
        return {
            table_items: props.market_segmentation,
            table_items_sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, items, only_return) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        items = items || this.state.table_items;
        only_return = only_return || false;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = items[a_key][field];
            const b = items[b_key][field];
            if (field == 'title') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        if (only_return) return ids;
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_title = filters.title.toUpperCase();
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            title: this.state.table_items_filters.title
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addMarketSegmentationItem)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deleteMarketSegmentationItem)(this.state.item_delete_requested.id_market_segmentation));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditMarketSegmentationItemDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow market-segmentation-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov tr\u017Eni segment"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
Items.propTypes = {};
function mapStateToProps(state) {
    return {
        market_segmentation: state.CodeTablesSlice.market_segmentation,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Items);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditMarketSegmentationItem":"1F3nB","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1F3nB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
class AddEditMarketSegmentationItem extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_market_segmentation: props.item === null ? -1 : props.item.id_market_segmentation,
            title: props.item === null ? '' : props.item.title,
            ord: props.item === null ? 1 : props.item.ord,
            validation_failed_fields: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-market-segmentation-item-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi tr\u017Eni segment"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-market-segmentation-item-dialog--title",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('title') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-market-segmentation-item-dialog--title",
                                            value: this.state.title,
                                            onChange: (event)=>{
                                                this.setState({
                                                    title: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-market-segmentation-item-dialog--ord",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Vrstni red",
                                            tooltip: "Vrstni red"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                            id: "add-edit-market-segmentation-item-dialog--ord",
                                            value: this.state.ord,
                                            min: 0,
                                            minorStepSize: 1,
                                            onValueChange: (val)=>{
                                                this.setState({
                                                    ord: val
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_market_segmentation: this.state.id_market_segmentation,
                                            title: this.state.title,
                                            ord: this.state.ord,
                                            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.title.length == 0) {
                                            validation_failed_fields.push('title');
                                            validation_failed_field_titles.push('naziv');
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditMarketSegmentationItem.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = AddEditMarketSegmentationItem;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h4jEN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditIdentificationType = require("./AddEditIdentificationType");
var _addEditIdentificationTypeDefault = parcelHelpers.interopDefault(_addEditIdentificationType);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Oznaka",
                        fieldName: "internal_code"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 5,
                        ...sort_props,
                        title: "Vrstni red",
                        fieldName: "ord"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.internal_code,
                            onChange: (event)=>handleFilterChange('internal_code', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.title,
                            onChange: (event)=>handleFilterChange('title', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 5
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: item.internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: item.title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "text-right",
                            child: item.ord
                        })
                    ]
                }, 'countries-result--result-' + id);
            })
        ]
    });
}
class IdentificationTypes extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'ord',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                internal_code: '',
                title: ''
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
        this.state.table_items_sort_ids = this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, this.state.table_items_filtered_ids, table_items, true);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.identification_types != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.identification_types);
        let sort_ids = [];
        //TODO is this even needed anymore?
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const table_items_sort_ids = this.state === undefined ? sort_ids : this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, ids, props.identification_types, true);
        return {
            table_items: props.identification_types,
            table_items_sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, items, only_return) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        items = items || this.state.table_items;
        only_return = only_return || false;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = items[a_key][field];
            const b = items[b_key][field];
            if (field == 'title') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        if (only_return) return ids;
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_internal_code = filters.internal_code.toUpperCase();
        const filters_title = filters.title.toUpperCase();
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_internal_code != '' && item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) return false;
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            internal_code: this.state.table_items_filters.internal_code,
            title: this.state.table_items_filters.title
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addIdentificationType)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deleteIdentificationType)(this.state.item_delete_requested.id_identification_type));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditIdentificationTypeDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow identification-types-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
IdentificationTypes.propTypes = {};
function mapStateToProps(state) {
    return {
        identification_types: state.CodeTablesSlice.identification_types,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(IdentificationTypes);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditIdentificationType":"jNr9u","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jNr9u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
class AddEditIdentificationType extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_identification_type: props.item === null ? -1 : props.item.id_identification_type,
            internal_code: props.item === null ? '' : props.item.internal_code,
            title: props.item === null ? '' : props.item.title,
            ord: props.item === null ? 1 : props.item.ord,
            validation_failed_fields: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-identification-type-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi vrsto osebnega dokumenta"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-identification-type-dialog--internal_code",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('internal_code') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Oznaka",
                                            tooltip: "Oznaka"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-identification-type-dialog--internal_code",
                                            value: this.state.internal_code,
                                            onChange: (event)=>{
                                                this.setState({
                                                    internal_code: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-identification-type-dialog--title",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('title') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-identification-type-dialog--title",
                                            value: this.state.title,
                                            onChange: (event)=>{
                                                this.setState({
                                                    title: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-identification-type-dialog--ord",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Vrstni red",
                                            tooltip: "Vrstni red"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                            id: "add-edit-identification-type-dialog--ord",
                                            value: this.state.ord,
                                            min: 0,
                                            minorStepSize: 1,
                                            onValueChange: (val)=>{
                                                this.setState({
                                                    ord: val
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_identification_type: this.state.id_identification_type,
                                            internal_code: this.state.internal_code,
                                            title: this.state.title,
                                            ord: this.state.ord,
                                            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.internal_code.length == 0) {
                                            validation_failed_fields.push('internal_code');
                                            validation_failed_field_titles.push('oznaka');
                                        }
                                        if (new_item.title.length == 0) {
                                            validation_failed_fields.push('title');
                                            validation_failed_field_titles.push('naziv');
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditIdentificationType.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = AddEditIdentificationType;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9PDJk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditTouristTax = require("./AddEditTouristTax");
var _addEditTouristTaxDefault = parcelHelpers.interopDefault(_addEditTouristTax);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Oznaka",
                        fieldName: "internal_code"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "Popust (%)",
                        fieldName: "discount"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 5,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 6,
                        ...sort_props,
                        title: "Vrstni red",
                        fieldName: "ord"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.internal_code,
                            onChange: (event)=>handleFilterChange('internal_code', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 5,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.title,
                            onChange: (event)=>handleFilterChange('title', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 6
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: item.internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "text-right",
                            child: parseFloat(item.discount).toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: item.title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "text-right",
                            child: item.ord
                        })
                    ]
                }, 'items-result--result-' + id);
            })
        ]
    });
}
class TouristTaxes extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'ord',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                internal_code: '',
                title: ''
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
        this.state.table_items_sort_ids = this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, this.state.table_items_filtered_ids, table_items, true);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.tourist_taxes != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.tourist_taxes);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const table_items_sort_ids = this.state === undefined ? sort_ids : this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, ids, props.tourist_taxes, true);
        return {
            table_items: props.tourist_taxes,
            table_items_sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, items, only_return) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        items = items || this.state.table_items;
        only_return = only_return || false;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = items[a_key][field];
            const b = items[b_key][field];
            if (field == 'title') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        if (only_return) return ids;
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_internal_code = filters.internal_code.toUpperCase();
        const filters_title = filters.title.toUpperCase();
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_internal_code != '' && item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) return false;
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            internal_code: this.state.table_items_filters.internal_code,
            title: this.state.table_items_filters.title
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addTouristTax)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deleteTouristTax)(this.state.item_delete_requested.id_tourist_tax));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditTouristTaxDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow tourist-taxes-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
TouristTaxes.propTypes = {};
function mapStateToProps(state) {
    return {
        tourist_taxes: state.CodeTablesSlice.tourist_taxes,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(TouristTaxes);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditTouristTax":"2FlLQ","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2FlLQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _select = require("@blueprintjs/select");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
class AddEditTouristTax extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_tourist_tax: props.item === null ? -1 : props.item.id_tourist_tax,
            internal_code: props.item === null ? '' : props.item.internal_code,
            title: props.item === null ? '' : props.item.title,
            discount: props.item === null ? 0 : parseFloat(props.item.discount),
            ord: props.item === null ? 1 : props.item.ord,
            id_accommodations: props.item === null ? [] : props.item.id_accommodations || [],
            validation_failed_fields: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-tourist-tax-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi turisti\u010Dno takso"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-tourist-tax-dialog--internal_code",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('internal_code') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Oznaka",
                                            tooltip: "Oznaka"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-tourist-tax-dialog--internal_code",
                                            value: this.state.internal_code,
                                            onChange: (event)=>{
                                                this.setState({
                                                    internal_code: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-tourist-tax-dialog--title",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('title') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-tourist-tax-dialog--title",
                                            value: this.state.title,
                                            onChange: (event)=>{
                                                this.setState({
                                                    title: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-row justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "add-edit-tourist-tax-dialog--discount",
                                            className: this.state.validation_failed_fields.indexOf('discount') == -1 ? '' : 'validation-failed',
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: "Popust (%)",
                                                    tooltip: "Popust (%)"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                                    id: "add-edit-tourist-tax-dialog--discount",
                                                    value: this.state.discount,
                                                    min: 0,
                                                    max: 100,
                                                    minorStepSize: 1,
                                                    onValueChange: (val, val_str)=>{
                                                        this.setState({
                                                            discount: val_str
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "add-edit-tourist-tax-dialog--ord",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                    label: "Vrstni red",
                                                    tooltip: "Vrstni red"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                                    id: "add-edit-tourist-tax-dialog--ord",
                                                    value: this.state.ord,
                                                    min: 0,
                                                    minorStepSize: 1,
                                                    onValueChange: (val)=>{
                                                        this.setState({
                                                            ord: val
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Rezervacijska mesta",
                                            tooltip: "Rezervacijska mesta"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.MultiSelect), {
                                            items: Object.values(this.props.accommodations).filter((item)=>item.type == 'regular'),
                                            itemRenderer: (item, { handleClick, modifiers })=>{
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                    className: "bp5-menu-item-horizontal",
                                                    active: modifiers.active,
                                                    icon: this.state.id_accommodations.indexOf(item.id_accommodation) != -1 ? 'tick' : 'blank',
                                                    onClick: handleClick,
                                                    text: item.title
                                                }, item.id_accommodation);
                                            },
                                            onItemSelect: (item, e)=>{
                                                const id_accommodations = [
                                                    ...this.state.id_accommodations
                                                ];
                                                const idx = id_accommodations.indexOf(item.id_accommodation);
                                                if (idx == -1) id_accommodations.push(item.id_accommodation);
                                                else id_accommodations.splice(idx, 1);
                                                this.setState({
                                                    id_accommodations
                                                });
                                            },
                                            popoverProps: {
                                                targetTagName: 'div'
                                            },
                                            tagRenderer: (item)=>item.title,
                                            tagInputProps: {
                                                onRemove: (tag, idx)=>{
                                                    const id_accommodations = [
                                                        ...this.state.id_accommodations
                                                    ];
                                                    id_accommodations.splice(idx, 1);
                                                    this.setState({
                                                        id_accommodations
                                                    });
                                                }
                                            },
                                            itemsEqual: "id_accommodation",
                                            selectedItems: this.state.id_accommodations.map((id_accommodation)=>this.props.accommodations[id_accommodation])
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_tourist_tax: this.state.id_tourist_tax,
                                            internal_code: this.state.internal_code,
                                            title: this.state.title,
                                            discount: this.state.discount,
                                            ord: this.state.ord,
                                            id_accommodations: this.state.id_accommodations.length == 0 ? null : this.state.id_accommodations,
                                            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.internal_code.length == 0) {
                                            validation_failed_fields.push('internal_code');
                                            validation_failed_field_titles.push('oznaka');
                                        }
                                        if (new_item.title.length == 0) {
                                            validation_failed_fields.push('title');
                                            validation_failed_field_titles.push('naziv');
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditTouristTax.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
function mapStateToProps(state) {
    return {
        accommodations: state.CodeTablesSlice.accommodations
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddEditTouristTax);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@blueprintjs/select":"3IMc6","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2wx2I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditActivity = require("./AddEditActivity");
var _addEditActivityDefault = parcelHelpers.interopDefault(_addEditActivity);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _resultComponents = require("./ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, handleFilterChange, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "title"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "Vrstni red",
                        fieldName: "ord"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table filters-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3,
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.title,
                            onChange: (event)=>handleFilterChange('title', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: item.title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "text-right",
                            child: item.ord
                        })
                    ]
                }, 'results--result-' + id);
            })
        ]
    });
}
class Activities extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props);
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'ord',
            table_items_sort_direction: 'ASC',
            table_items_filters: {
                title: ''
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
        this.state.table_items_sort_ids = this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, this.state.table_items_filtered_ids, table_items, true);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.activities != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        const ids = Object.keys(props.activities);
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const table_items_sort_ids = this.state === undefined ? sort_ids : this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, ids, props.activities, true);
        return {
            table_items: props.activities,
            table_items_sort_ids,
            table_items_filtered_ids: ids
        };
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, items, only_return) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        items = items || this.state.table_items;
        only_return = only_return || false;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = items[a_key][field];
            const b = items[b_key][field];
            if (field == 'title') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        if (only_return) return ids;
        this.setState({
            table_items_sort_ids: ids
        });
    }
    filterTableItems(filters) {
        const filters_title = filters.title.toUpperCase();
        const ids = Object.keys(this.state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = this.state.table_items[id];
            if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            return true;
        });
        this.setState({
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        });
        this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, filtered_ids);
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            title: this.state.table_items_filters.title
        };
        let val = event;
        if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addActivity)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.props.dispatch((0, _codeTablesSlice.deleteActivity)(this.state.item_delete_requested.id_activity));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditActivityDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow activities-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
Activities.propTypes = {};
function mapStateToProps(state) {
    return {
        activities: state.CodeTablesSlice.activities,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Activities);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditActivity":"1CrKU","../../slices/CodeTablesSlice":"hfPGz","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1CrKU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
class AddEditActivity extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            id_activity: props.item === null ? -1 : props.item.id_activity,
            title: props.item === null ? '' : props.item.title,
            ord: props.item === null ? 1 : props.item.ord,
            color_foreground: props.item === null ? '#000000' : props.item.color_foreground,
            color_background: props.item === null ? '#ffffff' : props.item.color_background,
            validation_failed_fields: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-activity-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi aktivnost"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-activity-dialog--title",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('title') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv",
                                            tooltip: "Naziv"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-activity-dialog--title",
                                            value: this.state.title,
                                            onChange: (event)=>{
                                                this.setState({
                                                    title: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-activity-dialog--ord",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Vrstni red",
                                            tooltip: "Vrstni red"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                            id: "add-edit-activity-dialog--ord",
                                            value: this.state.ord,
                                            min: 0,
                                            minorStepSize: 1,
                                            onValueChange: (val)=>{
                                                this.setState({
                                                    ord: val
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-activity-dialog--color_foreground",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('color_foreground') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Barva",
                                            tooltip: "Barva"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-activity-dialog--color_foreground",
                                            value: this.state.color_foreground,
                                            onChange: (event)=>{
                                                this.setState({
                                                    color_foreground: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-activity-dialog--color_background",
                                    className: 'flex-1 ' + (this.state.validation_failed_fields.indexOf('color_background') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Barva (ozadje)",
                                            tooltip: "Barva (ozadje)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-activity-dialog--color_background",
                                            value: this.state.color_background,
                                            onChange: (event)=>{
                                                this.setState({
                                                    color_background: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_activity: this.state.id_activity,
                                            title: this.state.title,
                                            ord: this.state.ord,
                                            color_foreground: this.state.color_foreground,
                                            color_background: this.state.color_background,
                                            serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.title.length == 0) {
                                            validation_failed_fields.push('title');
                                            validation_failed_field_titles.push('naziv');
                                        }
                                        if (new_item.color_foreground.length == 0) {
                                            validation_failed_fields.push('color_foreground');
                                            validation_failed_field_titles.push('barva');
                                        }
                                        if (new_item.color_background.length == 0) {
                                            validation_failed_fields.push('color_background');
                                            validation_failed_field_titles.push('barva (ozadje)');
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditActivity.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = AddEditActivity;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"abacm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _addEditUser = require("./AddEditUser");
var _addEditUserDefault = parcelHelpers.interopDefault(_addEditUser);
var _users = require("../../api/Users");
var _userSlice = require("../../slices/UserSlice");
var _resultComponents = require("../code_tables/ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, deleteItem, tableItemsFilters, originalTableItemsFilters, handleFilterChange } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Urejanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 3,
                        ...sort_props,
                        title: "Uporabni\u0161ko ime",
                        fieldName: "username"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 4,
                        ...sort_props,
                        title: "Naziv",
                        fieldName: "name_surname"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 5,
                        ...sort_props,
                        title: "Dav\u010Dna \u0161t.",
                        fieldName: "operator_tax_number"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 6,
                        ...sort_props,
                        title: "Delavec",
                        fieldName: "is_worker"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 7,
                        ...sort_props,
                        title: "Aktiven",
                        fieldName: "is_active"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                        columnIdx: 8,
                        ...sort_props,
                        title: "Pravice",
                        fieldName: "access_roles"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1,
                        cls: "filters-col"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 2,
                        cls: "filters-col"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 3,
                        cls: "filters-col",
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.username,
                            onChange: (event)=>handleFilterChange('username', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 4,
                        cls: "filters-col",
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.name_surname,
                            onChange: (event)=>handleFilterChange('name_surname', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 5,
                        cls: "filters-col",
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                            value: tableItemsFilters.operator_tax_number,
                            onChange: (event)=>handleFilterChange('operator_tax_number', event)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 6,
                        cls: "filters-col",
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                            checked: tableItemsFilters.is_worker === true,
                            indeterminate: tableItemsFilters.is_worker === null,
                            inline: true,
                            onChange: (event)=>{
                                let checked = null;
                                if (tableItemsFilters.is_worker === true) checked = false;
                                else if (tableItemsFilters.is_worker === null) checked = true;
                                handleFilterChange('is_worker', checked);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 7,
                        cls: "filters-col",
                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                            checked: tableItemsFilters.is_active === true,
                            indeterminate: tableItemsFilters.is_active === null,
                            inline: true,
                            onChange: (event)=>{
                                let checked = null;
                                if (tableItemsFilters.is_active === true) checked = false;
                                else if (tableItemsFilters.is_active === null) checked = true;
                                handleFilterChange('is_active', checked);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 8,
                        cls: "filters-col"
                    })
                ]
            }),
            table_items_sort_ids.map((id, idx)=>{
                const item = table_items[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            child: item.serial_internal_code
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openAddEditItemDialog(item)
                                    }),
                                    deleteItem === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "trash",
                                        intent: "danger",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>deleteItem(item)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: item.username
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: item.name + ' ' + item.surname
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: item.operator_tax_number
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            child: item.is_worker ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "tick",
                                color: "#394b59"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "cross",
                                color: "#ff0000"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            child: item.is_active ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "tick",
                                color: "#394b59"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                icon: "cross",
                                color: "#ff0000"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            child: [
                                [
                                    'main',
                                    'Dostop - AssistPRO'
                                ],
                                [
                                    'doc',
                                    'Dostop - evidenca (vpis)'
                                ],
                                [
                                    'doc-entry',
                                    'Dostop - evidenca (vpis)'
                                ],
                                [
                                    'doc-entry-edit-bonus-1',
                                    'Dostop - evidenca (vpis, dodatek I.)'
                                ],
                                [
                                    'doc-entry-edit-bonus-2',
                                    'Dostop - evidenca (vpis, dodatek II.)'
                                ],
                                [
                                    'doc-entry-edit-bonus-3',
                                    'Dostop - evidenca (vpis, dodatek III.)'
                                ],
                                [
                                    'doc-entry-edit-bonus-extra',
                                    'Dostop - evidenca (vpis, dodatek Extra)'
                                ],
                                [
                                    'doc-admin',
                                    'Dostop - evidenca (polni dostop)'
                                ],
                                [
                                    'doc-statistics',
                                    'Dostop - evidenca (statistika)'
                                ],
                                [
                                    'doc-user-statistics',
                                    "Dostop - evidenca (obra\u010Dun)"
                                ],
                                [
                                    'doc-analytics',
                                    'Dostop - evidenca (analitika)'
                                ],
                                [
                                    'doc-settings',
                                    'Dostop - evidenca (nastavitve)'
                                ],
                                [
                                    'doc-worker',
                                    'Dostop - evidenca (mobilna)'
                                ],
                                [
                                    'doc-operative-activities',
                                    'Dostop - evidenca (operativa)'
                                ]
                            ].filter((x)=>item.access_roles.indexOf(x[0]) > -1).map((x)=>x[1]).join(', ')
                        })
                    ]
                }, 'countries-result--result-' + id);
            })
        ]
    });
}
class Users extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        const table_items_filters = {
            username: '',
            name_surname: '',
            operator_tax_number: '',
            is_worker: null,
            is_active: null,
            access_roles: []
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'name',
            table_items_sort_direction: 'ASC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'name',
            table_items_sort_direction: 'ASC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null
        };
        const sorted = this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction, this.state.table_items_filtered_ids, table_items, true);
        this.state.table_items_sort_ids = sorted.table_items_sort_ids;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.users != this.state.table_items) this.setState(this.updateTableItemsFromProps(this.props, this.state));
    }
    updateTableItemsFromProps(props, state) {
        //TODO this filter isn't working, so we've disabled is_worker filter and forced it to true
        const ids = Object.keys(props.users).filter((id_user)=>props.users[id_user].username != 'admin');
        let sort_ids = [];
        if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id = this.state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            table_items: props.users,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, items, return_only) {
        table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
        items = items || this.state.table_items;
        return_only = return_only || false;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            const a = items[a_key][field];
            const b = items[b_key][field];
            if (field == 'name') return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_username = filters.username.toUpperCase();
        const filters_name_surname = filters.name_surname.toUpperCase();
        const filters_operator_tax_number = filters.operator_tax_number;
        const filters_is_worker = filters.is_worker;
        const filters_is_active = filters.is_active;
        //const filters_access_roles        = filters.access_roles;
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_is_worker !== null && item.is_worker !== filters_is_worker) return false;
            if (filters_is_active !== null && item.is_active !== filters_is_active) return false;
            if (item.username == 'admin') return false;
            if (filters_username != '' && item.username.toUpperCase().indexOf(filters_username) == -1) return false;
            if (filters_name_surname != '' && (item.name + ' ' + item.surname).toUpperCase().indexOf(filters_name_surname) == -1) return false;
            if (filters_operator_tax_number != '' && (item.operator_tax_number ?? '').indexOf(filters_operator_tax_number) == -1) return false;
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, state.table_items, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            username: this.state.table_items_filters.username,
            name_surname: this.state.table_items_filters.name_surname,
            operator_tax_number: this.state.table_items_filters.operator_tax_number,
            is_worker: this.state.table_items_filters.is_worker,
            is_active: this.state.table_items_filters.is_active,
            access_roles: this.state.table_items_filters.access_roles
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    async closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) {
            const new_item = await (0, _users.saveUser)(this.props.api_url, item, this.props.token);
            if (new_item !== null && new_item.item !== null && new_item.item !== undefined) this.props.dispatch((0, _userSlice.addUsers)([
                new_item.item
            ]));
        }
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1 || (this.props.user.access_roles ?? []).indexOf('code-tables--users') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditUserDefault.default), {
                    closeAddEditItemDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow users-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: "primary",
                                icon: "plus",
                                onClick: ()=>this.openAddEditItemDialog(null),
                                children: "Nov vnos"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    deleteItem: null,
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
Users.propTypes = {};
function mapStateToProps(state) {
    return {
        users: state.UserSlice.users,
        token: state.UserSlice.token,
        api_url: state.UserSlice.api_url,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Users);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","./AddEditUser":"e58NB","../../api/Users":"keHdn","../../slices/UserSlice":"ikKoo","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e58NB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
var _simpleSuggest = require("../SimpleSuggest");
var _simpleSuggestDefault = parcelHelpers.interopDefault(_simpleSuggest);
var _resultComponents = require("./ResultComponents");
class AddEditUser extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.copyAccessRolesFromUser = this.copyAccessRolesFromUser.bind(this);
        this.state = {
            id_user: props.item === null ? -1 : props.item.id_user,
            username: props.item === null ? '' : props.item.username,
            name: props.item === null ? '' : props.item.name,
            surname: props.item === null ? '' : props.item.surname,
            is_worker: props.item === null ? false : props.item.is_worker,
            is_active: props.item === null ? true : props.item.is_active,
            password: props.item === null ? '' : props.item.password ?? '',
            operator_tax_number: props.item === null ? '' : props.item.operator_tax_number,
            access_roles: props.item === null ? [] : props.item.access_roles,
            is_foreigner: props.item === null ? false : props.item.is_foreigner,
            data_retention_days: props.item === null ? {} : props.item.data_retention_days,
            id_cash_registers: props.item === null ? [] : props.item.id_cash_registers,
            validation_failed_fields: [],
            copy_from_id_user: null
        };
    }
    copyAccessRolesFromUser() {
        if (this.state.copy_from_id_user === null) return;
        this.setState({
            access_roles: this.props.users[this.state.copy_from_id_user].access_roles,
            data_retention_days: this.props.users[this.state.copy_from_id_user].data_retention_days,
            copy_from_id_user: null
        });
    }
    render() {
        const dropdownUsers = Object.values(this.props.users).filter((x)=>x.username != 'admin' && x.id_user != this.state.id_user).sort((a, b)=>a.ord - b.ord).map((x)=>({
                ...x,
                full_name: (x.name + ' ' + x.surname).trim()
            }));
        const dropdownUsersById = new Map(dropdownUsers.map((x)=>[
                x.id_user,
                x
            ]));
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeAddEditItemDialog(),
            className: "add-edit-channel-dialog",
            style: {
                width: 900
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Dodaj / uredi uporabnika"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeAddEditItemDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-row flex-wrap",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-channel-dialog--username",
                                    className: 'w-2/4 box-border pr-2 ' + (this.state.validation_failed_fields.indexOf('username') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Uporabni\u0161ko ime",
                                            tooltip: "Uporabni\u0161ko ime"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-channel-dialog--username",
                                            value: this.state.username,
                                            onChange: (event)=>{
                                                this.setState({
                                                    username: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-channel-dialog--password",
                                    className: 'w-2/4 box-border pl-2 ' + (this.state.validation_failed_fields.indexOf('password') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Geslo (\u010De ostane prazno, se geslo ne spremeni)",
                                            tooltip: "Geslo"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-channel-dialog--password",
                                            value: this.state.password,
                                            onChange: (event)=>{
                                                this.setState({
                                                    password: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-channel-dialog--name",
                                    className: 'w-2/4 box-border pr-2 ' + (this.state.validation_failed_fields.indexOf('name') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Ime",
                                            tooltip: "Ime"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-channel-dialog--name",
                                            value: this.state.name,
                                            onChange: (event)=>{
                                                this.setState({
                                                    name: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-channel-dialog--surname",
                                    className: 'w-2/4 box-border pl-2 ' + (this.state.validation_failed_fields.indexOf('surname') == -1 ? '' : 'validation-failed'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Priimek",
                                            tooltip: "Priimek"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-channel-dialog--surname",
                                            value: this.state.surname,
                                            onChange: (event)=>{
                                                this.setState({
                                                    surname: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-channel-dialog--operator_tax_number",
                                    className: "w-2/4 box-border pr-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Dav\u010Dna \u0161tevilka",
                                            tooltip: "Dav\u010Dna \u0161tevilka"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "add-edit-channel-dialog--operator_tax_number",
                                            value: this.state.operator_tax_number,
                                            onChange: (event)=>{
                                                this.setState({
                                                    operator_tax_number: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "add-edit-channel-dialog--cash-registers",
                                    className: "w-2/4 box-border pl-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Blagajne",
                                            tooltip: "Blagajne"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                            empty_title: "Izberi",
                                            value_field: "id_cash_register",
                                            title_field: "title",
                                            items: this.props.cash_registers,
                                            filtered_keys: this.state.id_cash_registers,
                                            displayFilter: (x)=>true,
                                            displaySort: (a, b)=>a.title.localeCompare(b.title),
                                            onFilterChange: (values)=>this.setState({
                                                    id_cash_registers: values
                                                }),
                                            small: false,
                                            full_width: true,
                                            hide_close_button: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-row space-x-2 mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    checked: this.state.is_active,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            is_active: event.target.checked
                                                        });
                                                    },
                                                    children: "Aktiven"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    checked: this.state.is_worker,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            is_worker: event.target.checked
                                                        });
                                                    },
                                                    children: "Delavec"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    checked: this.state.is_foreigner,
                                                    disabled: true,
                                                    onChange: (event)=>{
                                                        this.setState({
                                                            is_foreigner: event.target.checked
                                                        });
                                                    },
                                                    children: "Tujec"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-row",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: "Pravice"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex-1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleSuggestDefault.default), {
                                                        matchKeyName: "full_name",
                                                        valueKeyName: "id_user",
                                                        items: dropdownUsers,
                                                        onItemSelect: (item)=>{
                                                            this.setState({
                                                                copy_from_id_user: item.id_user
                                                            });
                                                        },
                                                        selectedItem: this.state.copy_from_id_user === null ? null : dropdownUsersById.get(this.state.copy_from_id_user),
                                                        placeholder: "I\u0161\u010Di"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    disabled: this.state.copy_from_id_user === null,
                                                    onClick: this.copyAccessRolesFromUser,
                                                    children: "Nastavi pravice iz uporabnika"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                            labelFor: "add-edit-user-dialog--access_roles",
                                            className: "flex flex-col",
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    checked: this.state.access_roles.indexOf('main') !== -1,
                                                    onChange: (event)=>{
                                                        const access_roles = this.state.access_roles.filter((x)=>x != 'main');
                                                        if (event.target.checked) access_roles.push('main');
                                                        this.setState({
                                                            access_roles
                                                        });
                                                    },
                                                    children: "Dostop - AssistPRO"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "grid grid-cols-3",
                                                    children: [
                                                        [
                                                            {
                                                                role: 'dashboard',
                                                                level: 0,
                                                                title: "Nadzorna plo\u0161\u010Da"
                                                            },
                                                            {
                                                                role: 'dashboard--notifications',
                                                                level: 1,
                                                                title: 'opomniki',
                                                                data_retention: true
                                                            },
                                                            {
                                                                role: 'dashboard--check-in',
                                                                level: 1,
                                                                title: 'prijave'
                                                            },
                                                            {
                                                                role: 'dashboard--check-out',
                                                                level: 1,
                                                                title: 'odjave'
                                                            },
                                                            {
                                                                role: 'dashboard--todo',
                                                                level: 1,
                                                                title: 'TODO'
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                role: 'reservations',
                                                                level: 0,
                                                                title: 'Rezervacije'
                                                            },
                                                            {
                                                                role: 'reservations--list',
                                                                level: 1,
                                                                title: 'seznam'
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                role: 'business',
                                                                level: 0,
                                                                title: 'Poslovanje'
                                                            },
                                                            {
                                                                role: 'business--cash-invoices',
                                                                level: 1,
                                                                title: "blag. ra\u010Duni",
                                                                data_retention: true
                                                            },
                                                            {
                                                                role: 'business--business-invoices',
                                                                level: 1,
                                                                title: 'fakturiranje',
                                                                data_retention: true
                                                            },
                                                            {
                                                                role: 'business--offers',
                                                                level: 1,
                                                                title: 'ponudbe',
                                                                data_retention: true
                                                            },
                                                            {
                                                                role: 'business--invoices-book',
                                                                level: 1,
                                                                title: 'knjiga IR',
                                                                data_retention: true
                                                            },
                                                            {
                                                                role: 'business--prepayment-book',
                                                                level: 1,
                                                                title: 'knjiga PA',
                                                                data_retention: true
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                role: 'cash-register',
                                                                level: 0,
                                                                title: 'Blagajna'
                                                            },
                                                            {
                                                                role: 'cash-register--journals',
                                                                level: 1,
                                                                title: 'bl. dnevnik',
                                                                data_retention: true
                                                            },
                                                            {
                                                                role: 'cash-register--documents',
                                                                level: 1,
                                                                title: "blagajni\u0161ki dokumenti",
                                                                data_retention: true
                                                            },
                                                            {
                                                                role: 'cash-register--recapitulation',
                                                                level: 1,
                                                                title: 'rekapitulacija blagajne'
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                role: 'stock',
                                                                level: 0,
                                                                title: 'Zaloge'
                                                            },
                                                            {
                                                                role: 'stock--acquisitions',
                                                                level: 1,
                                                                title: 'prevzem',
                                                                data_retention: true
                                                            },
                                                            {
                                                                role: 'stock--delivery-notes',
                                                                level: 1,
                                                                title: 'dobavnica',
                                                                data_retention: true
                                                            },
                                                            {
                                                                role: 'stock--inventory',
                                                                level: 1,
                                                                title: 'stanje zalog'
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                role: 'etourism',
                                                                level: 0,
                                                                title: "Poro\u010Danje - e-Turizem"
                                                            },
                                                            {
                                                                role: 'etourism--guest-book',
                                                                level: 1,
                                                                title: 'prijava/knjiga gostov'
                                                            },
                                                            {
                                                                role: 'etourism--monthly-statistics',
                                                                level: 1,
                                                                title: "mese\u010Dna statistika"
                                                            },
                                                            {
                                                                role: 'etourism--tourist-taxes',
                                                                level: 1,
                                                                title: "turisti\u010Dna taksa"
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                role: 'reports',
                                                                level: 0,
                                                                title: "Poro\u010Dila"
                                                            },
                                                            {
                                                                role: 'reports--reservations-report',
                                                                level: 1,
                                                                title: 'rezervacije'
                                                            },
                                                            {
                                                                role: 'reports--activity-reservations',
                                                                level: 1,
                                                                title: 'artikli/storitve',
                                                                data_retention: true
                                                            },
                                                            {
                                                                role: 'reports--cash-registers',
                                                                level: 1,
                                                                title: 'blagajna'
                                                            },
                                                            [
                                                                'test',
                                                                'sr'
                                                            ].indexOf(this.props.client) == -1 ? null : {
                                                                role: 'reports--realization',
                                                                level: 1,
                                                                title: 'realizacija',
                                                                data_retention: true
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                role: 'code-tables',
                                                                level: 0,
                                                                title: "\u0160ifranti"
                                                            },
                                                            {
                                                                role: 'code-tables--customers',
                                                                level: 1,
                                                                title: 'stranke'
                                                            },
                                                            {
                                                                role: 'code-tables--customers--export-to-excel',
                                                                level: 2,
                                                                title: 'izvoz v Excel'
                                                            },
                                                            {
                                                                role: 'code-tables--items-and-services',
                                                                level: 1,
                                                                title: 'artikli/storitve'
                                                            },
                                                            {
                                                                role: 'code-tables--items-and-services--export-to-excel',
                                                                level: 2,
                                                                title: 'izvoz v Excel'
                                                            },
                                                            {
                                                                role: 'code-tables--users',
                                                                level: 1,
                                                                title: 'uporabniki'
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                role: 'settings',
                                                                level: 0,
                                                                title: 'Nastavitve'
                                                            },
                                                            {
                                                                role: 'settings--general',
                                                                level: 1,
                                                                title: "splo\u0161ne nastavitve"
                                                            },
                                                            {
                                                                role: 'settings--reports',
                                                                level: 1,
                                                                title: 'izpisi dokumentov'
                                                            },
                                                            {
                                                                role: 'settings--print',
                                                                level: 1,
                                                                title: 'tiskanje'
                                                            },
                                                            {
                                                                role: 'settings--parameters',
                                                                level: 1,
                                                                title: 'parametri'
                                                            }
                                                        ]
                                                    ].filter((x)=>x !== null).map((y, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "pb-2",
                                                            children: y.filter((a)=>a !== null).map((x, idx2)=>x.role == '' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: x.level == 0 ? '' : 'ml-' + 2 * x.level,
                                                                    children: x.title
                                                                }, idx + '--' + idx2) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex flex-row justify-between",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                                            checked: this.state.access_roles.indexOf(x.role) !== -1,
                                                                            className: x.level == 0 ? '' : 'ml-' + 4 * x.level,
                                                                            onChange: (event)=>{
                                                                                let access_roles = this.state.access_roles.filter((z)=>z != x.role);
                                                                                if (event.target.checked) access_roles.push(x.role);
                                                                                this.setState({
                                                                                    access_roles
                                                                                });
                                                                            },
                                                                            children: x.title
                                                                        }, x.role),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "ml-2 mr-2 pt-1 w-20",
                                                                            children: x.data_retention !== true ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                                                                inline: true,
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NumericInput), {
                                                                                    fill: true,
                                                                                    small: true,
                                                                                    size: 'small',
                                                                                    value: this.state.data_retention_days[x.role] ?? '',
                                                                                    min: 0,
                                                                                    minorStepSize: 1,
                                                                                    placeholder: "\u0161t. dni",
                                                                                    onValueChange: (val)=>{
                                                                                        const newVal = {
                                                                                            ...this.state.data_retention_days
                                                                                        };
                                                                                        newVal[x.role] = val;
                                                                                        this.setState({
                                                                                            data_retention_days: newVal
                                                                                        });
                                                                                    }
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }))
                                                        }))
                                                }),
                                                [
                                                    'test',
                                                    'sr',
                                                    'va',
                                                    'sags'
                                                ].indexOf(this.props.client) == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "pb-4"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            children: [
                                                                [
                                                                    {
                                                                        role: 'doc-admin',
                                                                        level: 0,
                                                                        title: 'Dostop - evidenca (polni dostop)'
                                                                    }
                                                                ],
                                                                [],
                                                                [
                                                                    {
                                                                        role: 'doc-entry',
                                                                        level: 0,
                                                                        title: 'Dostop - evidenca (vpis)'
                                                                    },
                                                                    {
                                                                        role: 'doc-entry-edit-bonus-1',
                                                                        level: 1,
                                                                        title: 'Dostop - evidenca (vpis, dodatek I.)'
                                                                    },
                                                                    {
                                                                        role: 'doc-entry-edit-bonus-2',
                                                                        level: 1,
                                                                        title: 'Dostop - evidenca (vpis, dodatek II.)'
                                                                    },
                                                                    {
                                                                        role: 'doc-entry-edit-bonus-3',
                                                                        level: 1,
                                                                        title: 'Dostop - evidenca (vpis, dodatek III.)'
                                                                    },
                                                                    {
                                                                        role: 'doc-entry-edit-bonus-extra',
                                                                        level: 1,
                                                                        title: 'Dostop - evidenca (vpis, dodatek Extra)'
                                                                    }
                                                                ],
                                                                [],
                                                                [
                                                                    {
                                                                        role: 'doc-statistics',
                                                                        level: 0,
                                                                        title: 'Dostop - evidenca (statistika)'
                                                                    }
                                                                ],
                                                                [
                                                                    {
                                                                        role: 'doc-user-statistics',
                                                                        level: 0,
                                                                        title: "Dostop - evidenca (obra\u010Dun)"
                                                                    }
                                                                ],
                                                                [
                                                                    {
                                                                        role: 'doc-analytics',
                                                                        level: 0,
                                                                        title: 'Dostop - evidenca (analitika)'
                                                                    }
                                                                ],
                                                                [
                                                                    {
                                                                        role: 'doc-operative-activities',
                                                                        level: 0,
                                                                        title: 'Dostop - evidenca (operativa)',
                                                                        data_retention: true
                                                                    }
                                                                ],
                                                                [
                                                                    {
                                                                        role: 'doc-settings',
                                                                        level: 0,
                                                                        title: 'Dostop - evidenca (nastavitve)'
                                                                    }
                                                                ]
                                                            ].map((y, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    children: y.map((x, idx2)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                                            checked: this.state.access_roles.indexOf(x.role) !== -1,
                                                                            className: x.level == 0 ? '' : 'ml-' + 4 * x.level,
                                                                            onChange: (event)=>{
                                                                                if (x.role == 'doc-admin') {
                                                                                    let access_roles = this.state.access_roles.filter((z)=>z != 'doc-admin');
                                                                                    if (event.target.checked) {
                                                                                        access_roles.push('doc-admin');
                                                                                        // remove roles superseded by this one
                                                                                        access_roles = access_roles.filter((z)=>{
                                                                                            return [
                                                                                                'doc',
                                                                                                'doc-entry',
                                                                                                'doc-entry-edit-bonus-1',
                                                                                                'doc-entry-edit-bonus-2',
                                                                                                'doc-entry-edit-bonus-3',
                                                                                                'doc-entry-edit-bonus-extra',
                                                                                                'doc-statistics',
                                                                                                'doc-user-statistics',
                                                                                                'doc-analytics',
                                                                                                'doc-operative-activities',
                                                                                                'doc-settings'
                                                                                            ].indexOf(z) === -1;
                                                                                        });
                                                                                    }
                                                                                    this.setState({
                                                                                        access_roles
                                                                                    });
                                                                                } else {
                                                                                    let access_roles = this.state.access_roles.filter((z)=>z != x.role);
                                                                                    if (event.target.checked) {
                                                                                        access_roles.push(x.role);
                                                                                        // remove admin role
                                                                                        access_roles = access_roles.filter((z)=>z != 'doc-admin');
                                                                                    }
                                                                                    this.setState({
                                                                                        access_roles
                                                                                    });
                                                                                }
                                                                            },
                                                                            children: x.title
                                                                        }, x.role))
                                                                }))
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                            className: "pt-4",
                                                            checked: this.state.access_roles.indexOf('doc-worker') !== -1,
                                                            onChange: (event)=>{
                                                                const access_roles = this.state.access_roles.filter((x)=>x != 'doc-worker');
                                                                if (event.target.checked) access_roles.push('doc-worker');
                                                                this.setState({
                                                                    access_roles
                                                                });
                                                            },
                                                            children: "Dostop - evidenca (mobilna)"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeAddEditItemDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const new_item = {
                                            id_user: this.state.id_user,
                                            username: this.state.username,
                                            name: this.state.name,
                                            surname: this.state.surname,
                                            is_worker: this.state.is_worker,
                                            is_active: this.state.is_active,
                                            password: this.state.password,
                                            operator_tax_number: this.state.operator_tax_number,
                                            access_roles: this.state.access_roles,
                                            is_foreigner: this.state.is_foreigner,
                                            data_retention_days: this.state.data_retention_days,
                                            id_cash_registers: this.state.id_cash_registers
                                        };
                                        // validate missing/empty fields
                                        const validation_failed_fields = [];
                                        const validation_failed_field_titles = [];
                                        if (new_item.username.length == 0) {
                                            validation_failed_fields.push('username');
                                            validation_failed_field_titles.push('oznaka');
                                        }
                                        if (new_item.name.length == 0) {
                                            validation_failed_fields.push('name');
                                            validation_failed_field_titles.push('ime');
                                        }
                                        if (new_item.surname.length == 0) {
                                            validation_failed_fields.push('surname');
                                            validation_failed_field_titles.push('priimek');
                                        }
                                        if (new_item.password.length == 0 && new_item.id_user === -1) {
                                            validation_failed_fields.push('password');
                                            validation_failed_field_titles.push('geslo');
                                        }
                                        this.setState({
                                            validation_failed_fields
                                        });
                                        if (validation_failed_fields.length > 0) {
                                            (0, _appToaster.AppToaster).show({
                                                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        "Za shranjevanje, izpolnite vsaj polja:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        validation_failed_field_titles.map((title)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: "\u2022 " + title
                                                            }, title))
                                                    ]
                                                }),
                                                intent: 'danger',
                                                icon: 'issue'
                                            });
                                            return;
                                        }
                                        // save item
                                        if (new_item.id_user === -1) new_item.id_user = (0, _uuidDefault.default).v4();
                                        this.props.closeAddEditItemDialog(new_item);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditUser.propTypes = {
    closeAddEditItemDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
function mapStateToProps(state) {
    return {
        client: state.ConstantsSlice.client,
        users: state.UserSlice.users,
        cash_registers: state.CashRegisterSlice.cash_registers
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddEditUser);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","uuid":"b52pV","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","../SimpleSuggest":"82Xt0","./ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67EhN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _invoiceFiscalVerificationHistoryDialog = require("./InvoiceFiscalVerificationHistoryDialog");
var _invoiceFiscalVerificationHistoryDialogDefault = parcelHelpers.interopDefault(_invoiceFiscalVerificationHistoryDialog);
var _businessSlice = require("../../slices/BusinessSlice");
var _business = require("../../api/Business");
var _dateRangePickerDialog = require("../DateRangePickerDialog");
var _dateRangePickerDialogDefault = parcelHelpers.interopDefault(_dateRangePickerDialog);
var _invoiceCreator = require("../../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _appSlice = require("../../slices/AppSlice");
var _resultComponents = require("../code_tables/ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, originalTableItemsFilters, handleFilterChange, customers, payment_types, cash_registers, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged, deleteItem, invoice_fiscal_verifications, invoice_fiscal_verifications_by_id_invoice, openInvoiceFiscalVerificationHistoryDialog, user } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const toLocalString = (date)=>{
        if (date === null || date === undefined) return '';
        if (!(date instanceof Date)) return date;
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
    };
    const toLocalStringWithTime = (date)=>{
        if (date === null) return '';
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear() + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');
    };
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    const invoice_types = {
        'cash-invoice': {
            ord: 1,
            visible: true,
            key: 'cash-invoice',
            title: "Blagajni\u0161ki ra\u010Dun"
        },
        'cash-prepayment-invoice': {
            ord: 2,
            visible: true,
            key: 'cash-prepayment-invoice',
            title: "Ra\u010Dun za predpla\u010Dilo"
        },
        'invoice': {
            ord: 3,
            visible: false,
            key: 'invoice',
            title: 'Faktura'
        },
        'prepayment-invoice': {
            ord: 4,
            visible: false,
            key: 'prepayment-invoice',
            title: 'Avans'
        },
        'credit-note': {
            ord: 5,
            visible: false,
            key: 'credit-note',
            title: 'Dobropis'
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-auto sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: check_count > 0,
                                indeterminate: !all_checked && check_count > 0,
                                onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 2,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 3,
                            title: "Status"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 4,
                            ...sort_props,
                            title: "\u0160t. ra\u010Duna",
                            fieldName: "invoice_number_internal"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 5,
                            ...sort_props,
                            title: "\u0160ifra",
                            fieldName: "customer_internal_code"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 6,
                            ...sort_props,
                            title: "Naziv stranke",
                            fieldName: "id_customer"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 7,
                            ...sort_props,
                            title: "Datum ra\u010Duna",
                            fieldName: "issued"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 8,
                            title: "Vrsta dokumenta"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 9,
                            title: "Na\u010Din pla\u010Dila"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 10,
                            ...sort_props,
                            title: "Blagajna",
                            fieldName: "cash_register_internal_code"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 11,
                            ...sort_props,
                            title: "Uporabnik",
                            fieldName: "username_creator"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 12,
                            ...sort_props,
                            cls: "text-right",
                            title: "Znesek",
                            fieldName: "invoice_amount"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.invoice_number_internal,
                                onChange: (event)=>handleFilterChange('invoice_number_internal', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_internal_code,
                                onChange: (event)=>handleFilterChange('customer_internal_code', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_name,
                                onChange: (event)=>handleFilterChange('customer_name', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.invoice_date_range,
                                original_start_date: originalTableItemsFilters.invoice_date_range[0],
                                original_end_date: originalTableItemsFilters.invoice_date_range[1],
                                onFilterChange: (values)=>handleFilterChange('invoice_date_range', values)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "key",
                                    title_field: "title",
                                    items: invoice_types,
                                    filtered_keys: tableItemsFilters.invoice_types,
                                    displayFilter: (x)=>x.visible,
                                    displaySort: (a, b)=>a.ord - b.ord,
                                    onFilterChange: (values)=>handleFilterChange('invoice_types', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_payment_type",
                                    title_field: "title",
                                    items: payment_types,
                                    filtered_keys: tableItemsFilters.id_payment_types,
                                    displayFilter: null,
                                    displaySort: (a, b)=>a.ord - b.ord,
                                    onFilterChange: (values)=>handleFilterChange('id_payment_types', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_cash_register",
                                    title_field: "internal_code",
                                    items: Object.keys(cash_registers).filter((id_cash_register)=>user.id_cash_registers.includes(id_cash_register)).reduce((obj, key)=>{
                                        obj[key] = cash_registers[key];
                                        return obj;
                                    }, {}),
                                    filtered_keys: tableItemsFilters.id_cash_registers,
                                    displayFilter: null,
                                    displaySort: (a, b)=>a.internal_code - b.internal_code,
                                    onFilterChange: (values)=>handleFilterChange('id_cash_registers', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.username_creator,
                                onChange: (event)=>handleFilterChange('username_creator', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 12,
                            cls: "text-right filters-col"
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            const issued = item.issued === null ? null : new Date(item.issued);
                            const invoice_fiscal_verification = item.id_invoice_fiscal_verification === null ? null : invoice_fiscal_verifications[item.id_invoice_fiscal_verification] || null;
                            const invoice_fiscal_verifications_for_invoice = (invoice_fiscal_verifications_by_id_invoice === undefined ? undefined : invoice_fiscal_verifications_by_id_invoice[item.id_invoice]) || [];
                            const getStatus = (status)=>{
                                if (status === null) return "v po\u0161iljanju";
                                else if (status) return 'potrjeno';
                                return 'napaka pri potrjevanju';
                            };
                            let icon = '';
                            let color = '';
                            if (invoice_fiscal_verification !== null) {
                                if (invoice_fiscal_verification.status === null) {
                                    icon = 'history';
                                    color = '#d9822b';
                                } else if (invoice_fiscal_verification.status) {
                                    icon = 'tick-circle';
                                    color = '#0f9960';
                                } else {
                                    icon = 'warning-sign';
                                    color = '#db3737';
                                }
                            }
                            const tooltip_content = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "grid grid-cols-2 col-gap-4 gap-x-4 row-gap-2 gap-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: "Dav\u010Dna \u0161tevilka ra\u010Duna:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: item.invoice_number
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                            children: invoice_fiscal_verifications_for_invoice.map((invoice_fiscal_verification, statusIdx)=>{
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: statusIdx == 0 ? 'font-bold' : '',
                                                            children: toLocalStringWithTime(new Date(invoice_fiscal_verification.created))
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: statusIdx == 0 ? 'font-bold' : '',
                                                            children: getStatus(invoice_fiscal_verification.status)
                                                        })
                                                    ]
                                                }, 'invoice-fiscal-verification-' + invoice_fiscal_verification.id_invoice_fiscal_verification);
                                            })
                                        })
                                    ]
                                })
                            });
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: table_items_checked_ids[id] === true,
                                            onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "edit",
                                                    intent: "primary",
                                                    minimal: true,
                                                    small: true,
                                                    onClick: ()=>openAddEditItemDialog(item, item.type)
                                                }),
                                                !item.draft ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "trash",
                                                    intent: "danger",
                                                    minimal: true,
                                                    small: true,
                                                    onClick: ()=>{
                                                        deleteItem(id);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        child: invoice_fiscal_verification === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                            content: tooltip_content,
                                            position: "right-bottom",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                minimal: true,
                                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                    color: color,
                                                    icon: icon
                                                }),
                                                className: "ml-1",
                                                onClick: ()=>openInvoiceFiscalVerificationHistoryDialog(id)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        child: item.draft ? 'osnutek' : item.invoice_number_internal
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        child: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        child: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].type == 'natural' ? customers[item.id_customer].surname + ' ' + customers[item.id_customer].name : customers[item.id_customer].company_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        child: toLocalStringWithTime(issued)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        child: invoice_types[item.invoice_type].title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        child: item.payments.map((x)=>payment_types[x.id_payment_type].title).join(', ')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 10,
                                        child: item.id_cash_register === null ? '' : cash_registers[item.id_cash_register].internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 11,
                                        child: item.username_creator
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 12,
                                        cls: "text-right font-bold col-invoice-amount",
                                        child: (item.reversed ? '[S] ' : '') + (parseFloat(item.invoice_amount) - parseFloat(item.advance_payment_amount)).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) + ' EUR'
                                    })
                                ]
                            }, 'result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-sum pb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col",
                        children: [
                            "\u0160tevilo zapisov: ",
                            table_items_sort_ids.length
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        children: table_items_sort_ids.map((id, idx)=>// don't include drafts in SUMs
                            table_items[id].draft ? 0 : parseFloat(table_items[id].invoice_amount) - parseFloat(table_items[id].advance_payment_amount)).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) + ' EUR'
                    })
                ]
            })
        ]
    });
}
class Invoices extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openDateRangePickerDialog = this.openDateRangePickerDialog.bind(this);
        this.closeDateRangePickerDialog = this.closeDateRangePickerDialog.bind(this);
        this.reverseItems = this.reverseItems.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.getAdvanceInvoicesWithAmountsForReverse = this.getAdvanceInvoicesWithAmountsForReverse.bind(this);
        this.fiscallyVerifyInvoices = this.fiscallyVerifyInvoices.bind(this);
        this.openInvoiceFiscalVerificationHistoryDialog = this.openInvoiceFiscalVerificationHistoryDialog.bind(this);
        this.closeInvoiceFiscalVerificationHistoryDialog = this.closeInvoiceFiscalVerificationHistoryDialog.bind(this);
        this.createInvoiceFromOriginal = this.createInvoiceFromOriginal.bind(this);
        this.printA4 = this.printA4.bind(this);
        const table_items_filters = {
            invoice_number_internal: '',
            customer_internal_code: '',
            customer_name: '',
            invoice_date_range: [
                (0, _momentDefault.default)().subtract(2, 'days').toDate(),
                (0, _momentDefault.default)().toDate()
            ],
            invoice_types: [],
            id_payment_types: [],
            id_cash_registers: props.current_id_cash_register === null || props.current_id_cash_register == 0 ? [] : [
                props.current_id_cash_register
            ],
            username_creator: ''
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'invoice_number_internal',
            table_items_sort_direction: 'DESC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'invoice_number_internal',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            table_items_checked_ids: {},
            date_range_picker_dialog_open: false,
            date_range_picker_dialog_filter_name: null,
            delete_item_dialog_open: false,
            delete_item_id_item: null,
            invoice_fiscal_verification_history_dialog_open: false,
            invoice_fiscal_verification_history_dialog_id_invoice: null
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.invoices != prevProps.invoices || this.props.invoice_fiscal_verifications != prevProps.invoice_fiscal_verifications) this.setState(this.updateTableItemsFromProps(this.props, this.state));
    }
    updateTableItemsFromProps(props, state) {
        const filtered_invoices = {};
        const invoice_types = [
            'cash-invoice',
            'cash-prepayment-invoice'
        ];
        for(let id_invoice in props.invoices){
            const invoice = props.invoices[id_invoice];
            if (invoice_types.indexOf(invoice.invoice_type) != -1) filtered_invoices[invoice.id_invoice] = invoice;
        }
        const ids = Object.keys(filtered_invoices);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            invoices: props.invoices,
            table_items: filtered_invoices,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            if (state.table_items[a_key].draft != state.table_items[b_key].draft) {
                a = state.table_items[a_key].draft;
                b = state.table_items[b_key].draft;
                dir = 'DESC';
            } else if (field == 'id_customer') {
                const customer_a = this.props.customers[state.table_items[a_key].id_customer];
                const customer_b = this.props.customers[state.table_items[b_key].id_customer];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = customer_a === undefined ? '' : customer_a.name + ' ' + customer_a.surname;
                    b = customer_b === undefined ? '' : customer_b.name + ' ' + customer_b.surname;
                    return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
                }
            } else if (field == 'username_creator') {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'customer_internal_code') {
                const customer_a = this.props.customers[state.table_items[a_key].id_customer];
                const customer_b = this.props.customers[state.table_items[b_key].id_customer];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = customer_a === undefined ? 0 : customer_a.internal_code;
                    b = customer_b === undefined ? 0 : customer_b.internal_code;
                }
            } else if (field == 'cash_register_internal_code') {
                const cash_register_a = this.props.cash_registers[state.table_items[a_key].id_cash_register];
                const cash_register_b = this.props.cash_registers[state.table_items[b_key].id_cash_register];
                if (cash_register_a === undefined && cash_register_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = cash_register_a === undefined ? 0 : cash_register_a.internal_code;
                    b = cash_register_b === undefined ? 0 : cash_register_b.internal_code;
                }
            } else {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_invoice_number_internal = filters.invoice_number_internal.toUpperCase();
        const filters_customer_internal_code = filters.customer_internal_code.toUpperCase();
        const filters_customer_name = filters.customer_name.toUpperCase();
        const filters_invoice_date_start = filters.invoice_date_range[0] === null ? null : this.toIsoString(filters.invoice_date_range[0]);
        const filters_invoice_date_end = filters.invoice_date_range[1] === null ? null : this.toIsoString(filters.invoice_date_range[1]);
        const filters_invoice_types = filters.invoice_types;
        const filters_id_payment_types = filters.id_payment_types;
        const filters_username = filters.username_creator.toUpperCase();
        let filters_id_cash_registers = filters.id_cash_registers.filter((x)=>this.props.user.id_cash_registers.indexOf(x) != -1);
        if (filters_id_cash_registers.length == 0) filters_id_cash_registers = this.props.user.id_cash_registers;
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['business--cash-invoices'] ?? 0);
        const filter_data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days').toISOString(true);
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_invoice_number_internal != '' && (item.draft ? 'osnutek' : item.invoice_number_internal).toUpperCase().indexOf(filters_invoice_number_internal) == -1) return false;
            if (filters_customer_internal_code != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || this.props.customers[item.id_customer].internal_code != filters_customer_internal_code)) return false;
            if (filters_customer_name != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || (this.props.customers[item.id_customer].surname + ' ' + this.props.customers[item.id_customer].name + ' ' + this.props.customers[item.id_customer].company_name).toUpperCase().indexOf(filters_customer_name) == -1)) return false;
            if (!item.draft && filter_data_retention_date_start !== null && item.issued !== null && this.toIsoString(new Date(item.issued)) <= filter_data_retention_date_start) return false;
            if (!item.draft && filters_invoice_date_start !== null && item.issued !== null && this.toIsoString(new Date(item.issued)) < filters_invoice_date_start) return false;
            if (!item.draft && filters_invoice_date_end !== null && item.issued !== null && this.toIsoString(new Date(item.issued)) > filters_invoice_date_end) return false;
            if (filters_invoice_types.length > 0) {
                let found = false;
                for(let i = 0; i < filters_invoice_types.length; i++)if (item.invoice_type == filters_invoice_types[i]) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (filters_id_payment_types.length > 0) {
                let found = false;
                for(let i = 0; i < filters_id_payment_types.length; i++){
                    for(let j = 0; j < item.payments.length; j++)if (item.payments[j].id_payment_type == filters_id_payment_types[i]) {
                        found = true;
                        break;
                    }
                    if (found) break;
                }
                if (!found) return false;
            }
            if (filters_id_cash_registers.length > 0) {
                if (!item.draft && (item.id_cash_register === null || filters_id_cash_registers.indexOf(item.id_cash_register) == -1)) return false;
            }
            if (filters_username != '' && (item.username_creator === null || item.username_creator == '' || item.username_creator.toUpperCase().indexOf(filters_username) == -1)) return false;
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        // find which invoice fiscal verifications we're missing
        let id_invoice_fiscal_verifications = [];
        for(let i = 0; i < table_items_sort_ids.length; i++){
            const invoice = this.props.invoices[table_items_sort_ids[i]];
            if (invoice.id_invoice_fiscal_verification !== null && invoice.id_invoice_fiscal_verification !== undefined && this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification] === undefined) id_invoice_fiscal_verifications.push(invoice.id_invoice_fiscal_verification);
        }
        if (id_invoice_fiscal_verifications.length > 0) {
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            (0, _business.loadInvoiceFiscalVerificationsByIds)(this.props.api_url, id_invoice_fiscal_verifications, this.props.dispatch, this.props.token);
        }
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            invoice_number_internal: this.state.table_items_filters.invoice_number_internal,
            customer_internal_code: this.state.table_items_filters.customer_internal_code,
            customer_name: this.state.table_items_filters.customer_name,
            invoice_date_range: this.state.table_items_filters.invoice_date_range,
            invoice_types: this.state.table_items_filters.invoice_types,
            id_payment_types: this.state.table_items_filters.id_payment_types,
            id_cash_registers: this.state.table_items_filters.id_cash_registers,
            username_creator: this.state.table_items_filters.username_creator
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openDateRangePickerDialog(filter_name) {
        this.setState({
            date_range_picker_dialog_open: true,
            date_range_picker_dialog_filter_name: filter_name
        });
    }
    closeDateRangePickerDialog(start_date, end_date) {
        this.setState({
            date_range_picker_dialog_open: false
        });
        if (start_date !== undefined && end_date !== undefined) this.handleFilterChange(this.state.date_range_picker_dialog_filter_name, [
            start_date,
            end_date === null ? start_date : end_date
        ]);
    }
    reverseItems(ids) {
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            const item = this.state.table_items[id];
            // skip drafts
            if (item.draft) continue; //TODO tell the user why we skipped it
            // skip already reversed items
            if (item.reversed) continue; //TODO tell the user why we skipped it
            // prepare advance invoices
            const selected_advance_invoices_amounts = {};
            const advance_id_invoices = this.props.id_advance_invoice_consumption_by_id_consumer_invoices[item.id_invoice] || [];
            for(let i = 0; i < advance_id_invoices.length; i++){
                const item = this.props.advance_invoice_consumptions[advance_id_invoices[i]];
                selected_advance_invoices_amounts[item.advance_id_invoice] = -item.amount;
            }
            // create inverse document
            const new_item = (0, _invoiceCreatorDefault.default).CreateInvoiceFromInitialData({
                id_invoice: (0, _uuidDefault.default).v4(),
                reverse_invoice: true,
                id_customer: item.id_customer,
                invoice_date: (0, _momentDefault.default)().toISOString(true),
                invoice_type: item.invoice_type,
                note: '',
                payment_date: (0, _momentDefault.default)().toISOString(true),
                reference: item.invoice_number_internal,
                reservation: item.reservation,
                service_date_end: item.service_date_end,
                service_date_start: item.service_date_start,
                invoice_amount: -item.invoice_amount,
                id_cash_register: this.props.current_id_cash_register,
                advance_payment_amount: -(item.advance_payment_amount - item.used_advance_payment_amount),
                credit_note_type: item.credit_note_type,
                items: item.items.map((item_item)=>{
                    return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                        id_invoice_item: (0, _uuidDefault.default).v4(),
                        description: item_item.description,
                        discount: item_item.discount,
                        id_item: item_item.id_item,
                        id_item_price_list: item_item.id_item_price_list,
                        id_tax_rate: item_item.id_tax_rate,
                        item_measuring_unit_code: item_item.item_measuring_unit_code,
                        item_measuring_unit_decimal_digit_count: item_item.item_measuring_unit_decimal_digit_count,
                        price: item_item.price,
                        quantity: -item_item.quantity,
                        tax_rate: item_item.tax_rate,
                        approved_percent: item_item.approved_percent,
                        item_type: item_item.item_type,
                        item_ean: item_item.item_ean,
                        item_title: item_item.item_title,
                        ord: item_item.ord,
                        taxable: item_item.taxable,
                        item_internal_code: item_item.item_internal_code,
                        id_warehouse: item_item.item_type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === null ? null : this.props.cash_registers[this.props.current_id_cash_register], this.props.warehouses)
                    });
                }),
                payments: item.payments.length == 0 ? [] : [
                    (0, _invoiceCreatorDefault.default).CreateInvoicePaymentFromInitialData({
                        id_invoice_payment: (0, _uuidDefault.default).v4(),
                        id_payment_type: item.payments.length == 1 ? item.payments[0].id_payment_type : '2db820c7-a652-4f9e-8c93-7e1b09d399d5',
                        amount: item.payments.reduce((acc, item)=>acc + item.amount, 0),
                        payment_date: new Date()
                    })
                ],
                reverse_invoice_reference: id,
                original_id_invoice: id,
                original_invoice_type: item.invoice_type,
                max_advance_payment_amount: item.advance_payment_amount - item.used_advance_payment_amount
            });
            this.props.openInvoiceDialog(new_item, new_item.invoice_type, selected_advance_invoices_amounts);
        }
        this.setState({
            table_items_checked_ids: {}
        });
    }
    deleteItem(id, confirmed) {
        if (!confirmed) {
            this.setState({
                delete_item_dialog_open: true,
                delete_item_id_item: id
            });
            return;
        }
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        (0, _business.deleteInvoice)(this.props.api_url, id, token).then((data)=>{
            if (data === null) return;
            for(let i = 0; i < data.id_invoices.length; i++)dispatch((0, _businessSlice.deleteInvoice)({
                id_invoice: data.id_invoices[i]
            }));
        });
    }
    getAdvanceInvoicesWithAmountsForReverse(source_id_invoice) {
        const id_advance_invoice_consumptions = this.props.id_advance_invoice_consumption_by_id_consumer_invoices[source_id_invoice] || [];
        const selected_advance_invoices_amounts = {};
        for(let i = 0; i < id_advance_invoice_consumptions.length; i++){
            const advance_invoice_consumption = this.props.advance_invoice_consumptions[id_advance_invoice_consumptions[i]];
            selected_advance_invoices_amounts[advance_invoice_consumption.advance_id_invoice] = -parseFloat(advance_invoice_consumption.amount);
        }
        return selected_advance_invoices_amounts;
    }
    fiscallyVerifyInvoices(ids) {
        const non_draft_ids = [];
        for(let i = 0; i < ids.length; i++)if (this.props.invoices[ids[i]].draft === false) non_draft_ids.push(ids[i]);
        if (non_draft_ids.length > 0) (0, _business.fiscallyVerifyInvoices)(this.props.api_url, non_draft_ids, this.props.token);
        this.setState({
            table_items_checked_ids: {}
        });
    }
    openInvoiceFiscalVerificationHistoryDialog(id_invoice) {
        this.setState({
            invoice_fiscal_verification_history_dialog_open: true,
            invoice_fiscal_verification_history_dialog_id_invoice: id_invoice
        });
    }
    closeInvoiceFiscalVerificationHistoryDialog() {
        this.setState({
            invoice_fiscal_verification_history_dialog_open: false,
            invoice_fiscal_verification_history_dialog_id_invoice: null
        });
    }
    createInvoiceFromOriginal(ids, invoice_type, advance_id_invoices) {
        ids = ids === null ? [] : Array.isArray(ids) ? ids : [
            ids
        ];
        advance_id_invoices = advance_id_invoices || [];
        let first_item = ids.length == 0 ? null : this.state.table_items[ids[0]];
        const amount_factor = invoice_type == 'credit-note' ? -1 : 1;
        const original_id_invoices = [];
        const original_invoice_types = [];
        const selected_advance_invoices_amounts = {};
        let advance_payment_amount = 0;
        let invoice_amount = 0;
        let items = [];
        let payments = [];
        for(let i = 0; i < advance_id_invoices.length; i++){
            const item = this.state.table_items[advance_id_invoices[i]];
            const advance_amount = Math.max(0, parseFloat(item.advance_payment_amount) - parseFloat(item.used_advance_payment_amount));
            advance_payment_amount += advance_amount;
            if (advance_amount > 0) selected_advance_invoices_amounts[item.id_invoice] = advance_amount;
        }
        for(let i = 0; i < ids.length; i++){
            const item = this.state.table_items[ids[i]];
            if (original_id_invoices.indexOf(ids[i]) == -1) {
                original_id_invoices.push(ids[i]);
                original_invoice_types.push(item.invoice_type);
            }
            invoice_amount += item.invoice_amount * amount_factor;
            items = [
                ...items,
                ...item.items.map((item_item)=>{
                    return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                        id_invoice_item: (0, _uuidDefault.default).v4(),
                        description: item_item.description,
                        discount: item_item.discount,
                        id_item: item_item.id_item,
                        id_item_price_list: item_item.id_item_price_list,
                        id_tax_rate: item_item.id_tax_rate,
                        item_measuring_unit_code: item_item.item_measuring_unit_code,
                        item_measuring_unit_decimal_digit_count: item_item.item_measuring_unit_decimal_digit_count,
                        price: item_item.price,
                        quantity: item_item.quantity * amount_factor,
                        tax_rate: item_item.tax_rate,
                        approved_percent: item_item.approved_percent,
                        item_type: item_item.item_type,
                        item_ean: item_item.item_ean,
                        item_title: item_item.item_title,
                        ord: item_item.ord,
                        taxable: item_item.taxable,
                        item_internal_code: item_item.item_internal_code,
                        id_warehouse: item_item.item_type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === null ? null : this.props.cash_registers[this.props.current_id_cash_register], this.props.warehouses)
                    });
                })
            ];
            payments = [
                ...payments
            ];
        }
        // create new document
        let payment_date = null;
        let invoice_date = null;
        let service_date_end = null;
        let service_date_start = null;
        if (first_item !== null) {
            payment_date = first_item.payment_date;
            invoice_date = first_item.invoice_date;
            service_date_end = first_item.service_date_end;
            service_date_start = first_item.service_date_start;
            if (invoice_type == 'credit-note' || invoice_type == 'prepayment-invoice' || invoice_type == 'cash-prepayment-invoice') {
                payment_date = new Date();
                invoice_date = new Date();
            } else if (invoice_type == 'invoice') {
                payment_date = null;
                invoice_date = new Date();
                service_date_end = new Date();
                service_date_start = new Date();
            }
        }
        const new_item = (0, _invoiceCreatorDefault.default).CreateInvoiceFromInitialData({
            id_invoice: (0, _uuidDefault.default).v4(),
            id_customer: first_item === null ? null : first_item.id_customer,
            invoice_date,
            invoice_type: invoice_type,
            note: '',
            payment_date,
            reference: first_item === null ? null : first_item.invoice_number_internal,
            reservation: first_item === null ? null : first_item.reservation,
            service_date_end,
            service_date_start,
            invoice_amount,
            id_cash_register: this.props.current_id_cash_register,
            advance_payment_amount,
            items,
            payments,
            original_id_invoice: original_id_invoices,
            original_invoice_type: original_invoice_types
        });
        this.props.openInvoiceDialog(new_item, new_item.invoice_type, selected_advance_invoices_amounts);
        this.setState({
            table_items_checked_ids: {}
        });
    }
    async printA4(lang) {
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        const ids = check_count == 0 ? this.state.table_items_sort_ids : this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        for(let i = 0; i < ids.length; i++){
            const invoice = this.state.table_items[ids[i]];
            let invoice_fiscal_verification = null;
            if (invoice.id_invoice_fiscal_verification !== null && invoice.id_invoice_fiscal_verification !== undefined) {
                if (this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification] !== undefined) invoice_fiscal_verification = this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification];
                else invoice_fiscal_verification = await loadInvoiceFiscalVerification(this.props.api_url, invoice.id_invoice_fiscal_verification, this.props.dispatch, this.props.token);
            }
            if (invoice_fiscal_verification !== null && invoice_fiscal_verification.eor !== null && invoice_fiscal_verification.signed_zoi !== null && invoice_fiscal_verification.eor.length > 0 && invoice_fiscal_verification.signed_zoi.length > 0) await (0, _business.increaseInvoicePrintCount)(this.props.api_url, ids[i], this.props.token);
            this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                type: 'invoice',
                lang,
                invoice
            }));
        }
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('business--cash-invoices') === -1) return null;
        const check_ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        const check_count = check_ids.length;
        const checked_draft_count = check_ids.filter((id)=>this.props.invoices[id].draft).length;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.date_range_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePickerDialogDefault.default), {
                    startValue: this.state.table_items_filters[this.state.date_range_picker_dialog_filter_name][0],
                    endValue: this.state.table_items_filters[this.state.date_range_picker_dialog_filter_name][1],
                    closeDialog: (start_date, end_date)=>{
                        this.closeDateRangePickerDialog(start_date, end_date);
                    }
                }),
                !this.state.delete_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Izbri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.deleteItem(this.state.delete_item_id_item, true);
                        this.setState({
                            delete_item_dialog_open: false,
                            delete_item_id_item: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            delete_item_dialog_open: false,
                            delete_item_id_item: null
                        });
                    },
                    children: "Res \u017Eelite izbrisati ta dokument?"
                }),
                !this.state.invoice_fiscal_verification_history_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _invoiceFiscalVerificationHistoryDialogDefault.default), {
                    closeInvoiceFiscalVerificationHistoryDialog: this.closeInvoiceFiscalVerificationHistoryDialog,
                    id_invoice: this.state.invoice_fiscal_verification_history_dialog_id_invoice
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow invoices-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "plus",
                                            disabled: this.props.current_id_cash_register == 0,
                                            onClick: ()=>this.props.openInvoiceDialog(null, 'cash-invoice'),
                                            children: "Nov blagajni\u0161ki ra\u010Dun"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "plus",
                                            disabled: true,
                                            onClick: ()=>this.props.openInvoiceDialog(null, 'cash-prepayment-invoice'),
                                            children: "Nov ra\u010Dun za predpla\u010Dilo"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "print",
                                            onClick: ()=>this.printA4('sl'),
                                            disabled: check_count <= 0 || checked_draft_count > 0,
                                            children: "Natisni"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            className: "pl-4 pr-4",
                                            onClick: ()=>this.printA4('en'),
                                            disabled: check_count <= 0 || checked_draft_count > 0,
                                            children: "EN"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            className: "pl-4 pr-4",
                                            onClick: ()=>this.printA4('de'),
                                            disabled: check_count <= 0 || checked_draft_count > 0,
                                            children: "DE"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "print",
                                            onClick: async ()=>{
                                                const ids = check_count == 0 ? this.state.table_items_sort_ids : this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                                for(let i = 0; i < ids.length; i++){
                                                    const invoice = this.state.table_items[ids[i]];
                                                    const invoice_fiscal_verification = invoice.id_invoice_fiscal_verification === null ? null : this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification] || null;
                                                    if (invoice_fiscal_verification !== null && invoice_fiscal_verification.eor !== null && invoice_fiscal_verification.signed_zoi !== null && invoice_fiscal_verification.eor.length > 0 && invoice_fiscal_verification.signed_zoi.length > 0) await (0, _business.increaseInvoicePrintCount)(this.props.api_url, ids[i], this.props.token);
                                                    this.props.dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                                                        type: 'invoice',
                                                        invoice
                                                    }));
                                                }
                                            },
                                            disabled: check_count <= 0 || checked_draft_count > 0,
                                            children: "Natisni POS"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "cloud-download",
                                            disabled: check_count <= 0,
                                            onClick: ()=>{},
                                            children: "Izvoz v Excel"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "danger",
                                    icon: "delete",
                                    onClick: ()=>{
                                        const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                        this.reverseItems(ids);
                                    },
                                    className: "ml-2",
                                    disabled: this.props.current_id_cash_register == 0 || check_count != 1 || this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).filter((id)=>!this.state.table_items[id].draft && !this.state.table_items[id].reversed).length != 1,
                                    children: "Storniraj"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "warning",
                                    icon: "changes",
                                    onClick: ()=>{
                                        const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                        this.fiscallyVerifyInvoices(ids);
                                    },
                                    className: "ml-2",
                                    disabled: check_count == 0 || this.props.current_id_cash_register == 0,
                                    children: "Po\u0161lji na FURS"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "duplicate",
                                            onClick: ()=>{
                                                const ids = Object.keys(this.state.table_items_checked_ids);
                                                if (ids.length == 0) return;
                                                const item = this.state.table_items[ids[0]];
                                                const new_item = (0, _invoiceCreatorDefault.default).Duplicate(item);
                                                new_item.id_invoice = (0, _uuidDefault.default).v4();
                                                new_item.invoice_number = '';
                                                new_item.invoice_number_internal = '';
                                                new_item.draft = true;
                                                new_item.note = '';
                                                for(let i = 0; i < new_item.payments.length; i++)new_item.payments[i].id_invoice_payment = null;
                                                for(let i = 0; i < new_item.items.length; i++)new_item.items[i].id_invoice_item = (0, _uuidDefault.default).v4();
                                                this.props.openInvoiceDialog(new_item, item.invoice_type);
                                                this.setState({
                                                    table_items_checked_ids: {}
                                                });
                                            },
                                            className: "ml-2",
                                            disabled: this.props.current_id_cash_register == 0 || check_count != 1,
                                            children: "Podvoji"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "inheritance",
                                            onClick: ()=>{
                                                const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                                if (ids.length == 1) this.createInvoiceFromOriginal(ids[0], 'cash-invoice', ids);
                                                else if (ids.length > 1) this.setState({
                                                    create_invoice_from_ids: ids,
                                                    create_invoice_from_ids_invoice_type: 'cash-invoice'
                                                });
                                            },
                                            disabled: check_count != 1 || this.state.table_items[Object.keys(this.state.table_items_checked_ids)[0]].invoice_type != 'cash-prepayment-invoice' || this.props.current_id_cash_register == 0,
                                            children: "Izdelaj blag. ra\u010Dun"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.props.openInvoiceDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    customers: this.props.customers,
                                    payment_types: this.props.payment_types,
                                    cash_registers: this.props.cash_registers,
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    deleteItem: this.deleteItem,
                                    invoice_fiscal_verifications: this.props.invoice_fiscal_verifications,
                                    invoice_fiscal_verifications_by_id_invoice: this.props.invoice_fiscal_verifications_by_id_invoice,
                                    openInvoiceFiscalVerificationHistoryDialog: this.openInvoiceFiscalVerificationHistoryDialog,
                                    user: this.props.user
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
Invoices.propTypes = {};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        payment_types: state.CodeTablesSlice.payment_types,
        invoices: state.BusinessSlice.invoices,
        invoice_fiscal_verifications: state.BusinessSlice.invoice_fiscal_verifications,
        invoice_fiscal_verifications_by_id_invoice: state.BusinessSlice.invoice_fiscal_verifications_by_id_invoice,
        api_url: state.BusinessSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        cash_registers: state.CashRegisterSlice.cash_registers,
        advance_invoice_consumptions: state.BusinessSlice.advance_invoice_consumptions,
        id_advance_invoice_consumption_by_id_consumer_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_consumer_invoices,
        document_types: state.DocumentSlice.document_types,
        general_settings: state.SettingsSlice.general,
        warehouses: state.CodeTablesSlice.warehouses
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Invoices);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","uuid":"b52pV","moment":"1e4qG","@blueprintjs/core":"6Mq52","./InvoiceFiscalVerificationHistoryDialog":"dYKBR","../../slices/BusinessSlice":"47JXm","../../api/Business":"fC7Hd","../DateRangePickerDialog":"eJXAI","../../helpers/InvoiceCreator":"d7VsE","../../helpers/Invoice":"jffQW","../../slices/AppSlice":"aByTQ","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYKBR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
class InvoiceFiscalVerificationHistoryDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        const items = this.props.invoice_fiscal_verifications_by_id_invoice[this.props.id_invoice];
        this.state = {
            selected_id_invoice_fiscal_verification: items === null || items.length == 0 ? null : items[0].id_invoice_fiscal_verification
        };
    }
    toLocalStringWithTime(date) {
        if (date === null) return '';
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear() + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');
    }
    getStatus(status) {
        if (status === null) return "v po\u0161iljanju";
        else if (status) return 'potrjeno';
        return 'napaka pri potrjevanju';
    }
    render() {
        const invoice = this.props.invoices[this.props.id_invoice];
        const invoice_fiscal_verifications_for_invoice = (this.props.invoice_fiscal_verifications_by_id_invoice === undefined ? undefined : this.props.invoice_fiscal_verifications_by_id_invoice[this.props.id_invoice]) || [];
        let sel_index = -1;
        for(let i = 0; i < invoice_fiscal_verifications_for_invoice.length; i++)if (this.state.selected_id_invoice_fiscal_verification == invoice_fiscal_verifications_for_invoice[i].id_invoice_fiscal_verification) {
            sel_index = i;
            break;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: false,
            onClose: ()=>this.props.closeInvoiceFiscalVerificationHistoryDialog(),
            className: "invoice-fiscal-verification-history-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow h-full",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Heading, {
                                    children: [
                                        "Zgodovina dav\u010Dnega potrjevanja \u2022 ",
                                        invoice.invoice_number_internal
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeInvoiceFiscalVerificationHistoryDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY + ' flex flex-row items-stretch',
                        style: {
                            height: 'calc(100% - 70px)'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-row items-stretch",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-1/4 fiscal-verification-items overflow-y-auto",
                                    children: invoice_fiscal_verifications_for_invoice.map((invoice_fiscal_verification, statusIdx)=>{
                                        let icon = '';
                                        let color = '';
                                        if (invoice_fiscal_verification !== null) {
                                            if (invoice_fiscal_verification.status === null) {
                                                icon = 'history';
                                                color = '#d9822b';
                                            } else if (invoice_fiscal_verification.status) {
                                                icon = 'tick-circle';
                                                color = '#0f9960';
                                            } else {
                                                icon = 'warning-sign';
                                                color = '#db3737';
                                            }
                                        }
                                        const cls = invoice_fiscal_verification.id_invoice_fiscal_verification == this.state.selected_id_invoice_fiscal_verification ? 'selected' : '';
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: 'fiscal-verification-item flex flex-row ' + cls,
                                            onClick: ()=>this.setState({
                                                    selected_id_invoice_fiscal_verification: invoice_fiscal_verification.id_invoice_fiscal_verification
                                                }),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "w-1/6",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                        icon: icon,
                                                        color: color
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: statusIdx == 0 ? 'font-bold' : '',
                                                            children: this.toLocalStringWithTime(new Date(invoice_fiscal_verification.created))
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: statusIdx == 0 ? 'font-bold' : '',
                                                            children: this.getStatus(invoice_fiscal_verification.status)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, 'invoice-fiscal-verification-' + invoice_fiscal_verification.id_invoice_fiscal_verification);
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex-1 fiscal-verification-messages overflow-y-scroll",
                                    children: sel_index == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-center uppercase text-lg font-light",
                                                children: "Odgovor"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                                children: invoice_fiscal_verifications_for_invoice[sel_index].response === null ? null : JSON.stringify(JSON.parse(invoice_fiscal_verifications_for_invoice[sel_index].response), null, 2)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Divider), {
                                                className: "mt-4 mb-4"
                                            }),
                                            (()=>{
                                                let request = null;
                                                let sent_message = invoice_fiscal_verifications_for_invoice[sel_index].sent_message;
                                                if (sent_message !== null) {
                                                    const sent_message_obj = JSON.parse(sent_message);
                                                    if (sent_message_obj.token !== null) {
                                                        const arr = sent_message_obj.token.split('.');
                                                        if (arr.length == 3) {
                                                            const request_obj = JSON.parse(atob(arr[1]));
                                                            request = JSON.stringify(request_obj, null, 2);
                                                        }
                                                    }
                                                }
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-center uppercase text-lg font-light",
                                                            children: "Zahtevek"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                                            children: request
                                                        })
                                                    ]
                                                });
                                            })()
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
function mapStateToProps(state) {
    return {
        invoices: state.BusinessSlice.invoices,
        invoice_fiscal_verifications_by_id_invoice: state.BusinessSlice.invoice_fiscal_verifications_by_id_invoice
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(InvoiceFiscalVerificationHistoryDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dsp7f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _editInvoiceDialog = require("./EditInvoiceDialog");
var _editInvoiceDialogDefault = parcelHelpers.interopDefault(_editInvoiceDialog);
var _waitFiscalVerificationDialog = require("./WaitFiscalVerificationDialog");
var _waitFiscalVerificationDialogDefault = parcelHelpers.interopDefault(_waitFiscalVerificationDialog);
var _businessSlice = require("../../slices/BusinessSlice");
var _business = require("../../api/Business");
var _documentSlice = require("../../slices/DocumentSlice");
var _dateRangePickerDialog = require("../DateRangePickerDialog");
var _dateRangePickerDialogDefault = parcelHelpers.interopDefault(_dateRangePickerDialog);
var _invoiceCreator = require("../../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _advanceInvoiceListDialog = require("./AdvanceInvoiceListDialog");
var _advanceInvoiceListDialogDefault = parcelHelpers.interopDefault(_advanceInvoiceListDialog);
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _appSlice = require("../../slices/AppSlice");
var _resultComponents = require("../code_tables/ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, originalTableItemsFilters, handleFilterChange, customers, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const toIsoString = (date)=>{
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    };
    const toLocalString = (date)=>{
        if (date === null || date === undefined) return '';
        if (!(date instanceof Date)) return date;
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
    };
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    const invoice_types = {
        'cash-invoice': {
            ord: 1,
            visible: false,
            key: 'cash-invoice',
            title: "Blagajni\u0161ki ra\u010Dun"
        },
        'cash-prepayment-invoice': {
            ord: 2,
            visible: false,
            key: 'cash-prepayment-invoice',
            title: "Ra\u010Dun za predpla\u010Dilo"
        },
        'invoice': {
            ord: 3,
            visible: true,
            key: 'invoice',
            title: 'Faktura'
        },
        'prepayment-invoice': {
            ord: 4,
            visible: true,
            key: 'prepayment-invoice',
            title: "Avansni ra\u010Dun"
        },
        'credit-note': {
            ord: 5,
            visible: true,
            key: 'credit-note',
            title: 'Dobropis'
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-auto sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: check_count > 0,
                                indeterminate: !all_checked && check_count > 0,
                                onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 2,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 3,
                            ...sort_props,
                            title: "\u0160t. ra\u010Duna",
                            fieldName: "invoice_number_internal"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 4,
                            ...sort_props,
                            title: "\u0160ifra",
                            fieldName: "customer_internal_code"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 5,
                            ...sort_props,
                            title: "Naziv stranke",
                            fieldName: "id_customer"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 6,
                            ...sort_props,
                            title: "Datum dokumenta",
                            fieldName: "invoice_date"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 7,
                            ...sort_props,
                            title: "Datum valute/pla\u010Dila",
                            fieldName: "due_date"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 8,
                            ...sort_props,
                            title: "Datum DDV",
                            fieldName: "vat_date"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 9,
                            ...sort_props,
                            title: "Pla\u010Dana",
                            fieldName: "paid"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 10,
                            title: "Vrsta dokumenta"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 11,
                            ...sort_props,
                            title: "Uporabnik",
                            fieldName: "username_creator"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 12,
                            ...sort_props,
                            cls: "text-right",
                            title: "Znesek",
                            fieldName: "invoice_amount"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.invoice_number_internal,
                                onChange: (event)=>handleFilterChange('invoice_number_internal', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_internal_code,
                                onChange: (event)=>handleFilterChange('customer_internal_code', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_name,
                                onChange: (event)=>handleFilterChange('customer_name', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.invoice_date_range,
                                original_start_date: originalTableItemsFilters.invoice_date_range[0],
                                original_end_date: originalTableItemsFilters.invoice_date_range[1],
                                onFilterChange: (values)=>handleFilterChange('invoice_date_range', values)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.payment_date_range,
                                original_start_date: originalTableItemsFilters.payment_date_range[0],
                                original_end_date: originalTableItemsFilters.payment_date_range[1],
                                onFilterChange: (values)=>handleFilterChange('payment_date_range', values)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: tableItemsFilters.paid === true,
                                indeterminate: tableItemsFilters.paid === null,
                                inline: true,
                                onChange: (event)=>{
                                    let checked = null;
                                    if (tableItemsFilters.paid === true) checked = false;
                                    else if (tableItemsFilters.paid === null) checked = true;
                                    handleFilterChange('paid', checked);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "key",
                                    title_field: "title",
                                    items: invoice_types,
                                    filtered_keys: tableItemsFilters.invoice_types,
                                    displayFilter: (x)=>x.visible,
                                    displaySort: (a, b)=>a.ord - b.ord,
                                    onFilterChange: (values)=>handleFilterChange('invoice_types', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.username_creator,
                                onChange: (event)=>handleFilterChange('username_creator', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 12,
                            cls: "filters-col text-right"
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            const invoice_date = item.invoice_date === null ? null : new Date(item.invoice_date);
                            let payment_date = item.payment_date === null ? null : new Date(item.payment_date);
                            let vat_date = null;
                            if (item.invoice_type == 'invoice') vat_date = new Date(item.service_date_end !== null ? item.service_date_end : item.service_date_start);
                            else if (item.invoice_type == 'prepayment-invoice') vat_date = payment_date;
                            else if (item.invoice_type == 'credit-note') {
                                payment_date = null;
                                vat_date = item.payment_date === null ? null : new Date(item.payment_date);
                            }
                            let cls = '';
                            if (item.reversed) cls += 'reversed ';
                            if (item.reverse_invoice) cls += 'reverse-invoice ';
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        cls: cls,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: table_items_checked_ids[id] === true,
                                            onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        cls: cls,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "edit",
                                                    intent: "primary",
                                                    minimal: true,
                                                    small: true,
                                                    onClick: ()=>openAddEditItemDialog(item, item.type)
                                                }),
                                                !item.draft ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "trash",
                                                    intent: "danger",
                                                    minimal: true,
                                                    small: true,
                                                    onClick: ()=>{
                                                        deleteItem(id);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        cls: cls,
                                        child: item.draft ? 'osnutek' : item.invoice_number_internal
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        cls: cls,
                                        child: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        cls: cls,
                                        child: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].type == 'natural' ? customers[item.id_customer].surname + ' ' + customers[item.id_customer].name : customers[item.id_customer].company_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        cls: cls,
                                        child: toLocalString(invoice_date)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        cls: cls,
                                        child: toLocalString(payment_date)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        cls: cls,
                                        child: toLocalString(vat_date)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        cls: cls,
                                        child: item.paid === true ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                            icon: "tick",
                                            color: "#394b59"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                            icon: "cross",
                                            color: "#ff0000"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 10,
                                        cls: cls,
                                        child: invoice_types[item.invoice_type].title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 11,
                                        cls: cls,
                                        child: item.username_creator
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 12,
                                        cls: cls + 'text-right font-bold col-invoice-amount',
                                        child: (item.reversed ? '[S] ' : '') + (item.invoice_type == 'prepayment-invoice' ? parseFloat(item.advance_payment_amount) : parseFloat(item.invoice_amount)).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) + ' EUR' + ''
                                    })
                                ]
                            }, 'result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-sum pb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col",
                        children: [
                            "\u0160tevilo zapisov: ",
                            table_items_sort_ids.length
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        children: table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            // don't include drafts in SUMs
                            if (item.draft) return 0;
                            else if (item.invoice_type == 'prepayment-invoice') return parseFloat(item.advance_payment_amount);
                            return parseFloat(item.invoice_amount);
                        }).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) + ' EUR'
                    })
                ]
            })
        ]
    });
}
class BusinessInvoices extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.openDateRangePickerDialog = this.openDateRangePickerDialog.bind(this);
        this.closeDateRangePickerDialog = this.closeDateRangePickerDialog.bind(this);
        this.reverseItems = this.reverseItems.bind(this);
        this.createInvoiceFromOriginal = this.createInvoiceFromOriginal.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.printA4 = this.printA4.bind(this);
        this.issuedInvoicesExportToExcel = this.issuedInvoicesExportToExcel.bind(this);
        this.markAsPaid = this.markAsPaid.bind(this);
        this.markAsUnpaid = this.markAsUnpaid.bind(this);
        this.markAsPaidUnpaid = this.markAsPaidUnpaid.bind(this);
        const table_items_filters = {
            invoice_number_internal: '',
            customer_internal_code: '',
            customer_name: '',
            invoice_date_range: [
                (0, _momentDefault.default)().subtract(1, 'month').toDate(),
                (0, _momentDefault.default)().toDate()
            ],
            payment_date_range: [
                null,
                null
            ],
            invoice_types: [],
            username_creator: '',
            paid: null
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'invoice_number_internal',
            table_items_sort_direction: 'DESC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'invoice_number_internal',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            table_items_checked_ids: {},
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            add_edit_item_dialog_type: null,
            add_edit_item_dialog_advance_invoices_amounts: {},
            date_range_picker_dialog_open: false,
            date_range_picker_dialog_filter_name: null,
            delete_item_dialog_open: false,
            delete_item_id_item: null,
            create_invoice_from_ids: null,
            create_invoice_from_ids_invoice_type: null,
            wait_fiscal_verification_dialog_open: false,
            wait_fiscal_verification_dialog_id_invoice: null
        };
    //this.state.table_items_sort_ids = this.refreshTableItemsSort(
    //	this.state.table_items_sort_field,
    //	this.state.table_items_sort_direction,
    //	this.state.table_items_filtered_ids,
    //	table_items,
    //	true
    //);
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.invoices != this.state.invoices) this.setState(this.updateTableItemsFromProps(this.props, this.state));
    }
    updateTableItemsFromProps(props, state) {
        const filtered_invoices = {};
        const invoice_types = [
            'invoice',
            'prepayment-invoice',
            'credit-note'
        ];
        for(let id_invoice in props.invoices){
            const invoice = props.invoices[id_invoice];
            if (invoice_types.indexOf(invoice.invoice_type) != -1) filtered_invoices[invoice.id_invoice] = invoice;
        }
        const ids = Object.keys(filtered_invoices);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            invoices: props.invoices,
            table_items: filtered_invoices,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            if (state.table_items[a_key].draft != state.table_items[b_key].draft) {
                a = state.table_items[a_key].draft;
                b = state.table_items[b_key].draft;
                dir = 'DESC';
            } else if (field == 'id_customer') {
                const customer_a = this.props.customers[state.table_items[a_key].id_customer];
                const customer_b = this.props.customers[state.table_items[b_key].id_customer];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = customer_a === undefined ? '' : customer_a.name + ' ' + customer_a.surname;
                    b = customer_b === undefined ? '' : customer_b.name + ' ' + customer_b.surname;
                }
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'username_creator') {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'customer_internal_code') {
                const customer_a = this.props.customers[state.table_items[a_key].id_customer];
                const customer_b = this.props.customers[state.table_items[b_key].id_customer];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = customer_a === undefined ? 0 : customer_a.internal_code;
                    b = customer_b === undefined ? 0 : customer_b.internal_code;
                }
            } else {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_invoice_number_internal = filters.invoice_number_internal.toUpperCase();
        const filters_customer_internal_code = filters.customer_internal_code.toUpperCase();
        const filters_customer_name = filters.customer_name.toUpperCase();
        const filters_invoice_date_start = filters.invoice_date_range[0] === null ? null : this.toIsoString(filters.invoice_date_range[0]);
        const filters_invoice_date_end = filters.invoice_date_range[1] === null ? null : this.toIsoString(filters.invoice_date_range[1]);
        const filters_payment_date_start = filters.payment_date_range[0] === null ? null : this.toIsoString(filters.payment_date_range[0]);
        const filters_payment_date_end = filters.payment_date_range[1] === null ? null : this.toIsoString(filters.payment_date_range[1]);
        const filters_invoice_types = filters.invoice_types;
        const filters_username = filters.username_creator.toUpperCase();
        const filters_paid = filters.paid;
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['business--business-invoices'] ?? 0);
        const filter_data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days').toISOString(true);
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_paid !== null && item.paid !== filters_paid) return false;
            if (filters_invoice_number_internal != '' && (item.draft ? 'osnutek' : item.invoice_number_internal).toUpperCase().indexOf(filters_invoice_number_internal) == -1) return false;
            if (filters_customer_internal_code != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || this.props.customers[item.id_customer].internal_code != filters_customer_internal_code)) return false;
            if (filters_customer_name != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || (this.props.customers[item.id_customer].surname + ' ' + this.props.customers[item.id_customer].name + ' ' + this.props.customers[item.id_customer].company_name).toUpperCase().indexOf(filters_customer_name) == -1)) return false;
            if (!item.draft && filter_data_retention_date_start !== null && item.invoice_date <= filter_data_retention_date_start) return false;
            if (!item.draft && filters_invoice_date_start !== null && item.invoice_date < filters_invoice_date_start) return false;
            if (!item.draft && filters_invoice_date_end !== null && item.invoice_date > filters_invoice_date_end) return false;
            let payment_date = item.invoice_type == 'credit-note' ? null : item.payment_date;
            if (filters_payment_date_start !== null && payment_date !== null && payment_date < filters_payment_date_start) return false;
            if (filters_payment_date_end !== null && payment_date !== null && payment_date > filters_payment_date_end) return false;
            if (filters_invoice_types.length > 0) {
                let found = false;
                for(let i = 0; i < filters_invoice_types.length; i++)if (item.invoice_type == filters_invoice_types[i]) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (filters_username != '' && (item.username_creator === null || item.username_creator == '' || item.username_creator.toUpperCase().indexOf(filters_username) == -1)) return false;
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            invoice_number_internal: this.state.table_items_filters.invoice_number_internal,
            customer_internal_code: this.state.table_items_filters.customer_internal_code,
            customer_name: this.state.table_items_filters.customer_name,
            invoice_date_range: this.state.table_items_filters.invoice_date_range,
            payment_date_range: this.state.table_items_filters.payment_date_range,
            invoice_types: this.state.table_items_filters.invoice_types,
            username_creator: this.state.table_items_filters.username_creator,
            paid: this.state.table_items_filters.paid
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item, type, advance_invoices_amounts) {
        advance_invoices_amounts = advance_invoices_amounts || {};
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item,
            add_edit_item_dialog_type: type,
            add_edit_item_dialog_advance_invoices_amounts: advance_invoices_amounts
        });
    }
    async closeAddEditItemDialog(item, open_create_invoice_type, finish_invoice) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) {
            this.props.dispatch((0, _businessSlice.addInvoice)({
                item,
                token: this.props.token
            }));
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            const new_items = await (0, _business.saveInvoice)(this.props.api_url, item, token, dispatch);
            if (new_items !== null) {
                if (new_items.invoices !== undefined) dispatch((0, _businessSlice.addInvoices)(new_items.invoices));
                if (new_items.document_associations !== undefined) dispatch((0, _documentSlice.addDocumentAssociations)(new_items.document_associations));
                if (new_items.advance_invoice_consumptions !== undefined) dispatch((0, _businessSlice.addAdvanceInvoiceConsumptions)(new_items.advance_invoice_consumptions));
                if (finish_invoice && this.props.document_types[item.invoice_type].fiscal_verification_enabled) this.setState({
                    wait_fiscal_verification_dialog_open: true,
                    wait_fiscal_verification_dialog_id_invoice: item.id_invoice
                });
            }
            if (open_create_invoice_type !== undefined) setTimeout(()=>{
                if (!this._ismounted) return;
                this.createInvoiceFromOriginal(item.id_invoice, open_create_invoice_type, [
                    item.id_invoice
                ]);
            }, 1000);
        }
    }
    openDateRangePickerDialog(filter_name) {
        this.setState({
            date_range_picker_dialog_open: true,
            date_range_picker_dialog_filter_name: filter_name
        });
    }
    closeDateRangePickerDialog(start_date, end_date) {
        this.setState({
            date_range_picker_dialog_open: false
        });
        if (start_date !== undefined && end_date !== undefined) this.handleFilterChange(this.state.date_range_picker_dialog_filter_name, [
            start_date,
            end_date === null ? start_date : end_date
        ]);
    }
    reverseItems(ids) {
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            const item = this.state.table_items[id];
            // skip drafts
            if (item.draft) continue; //TODO tell the user why we skipped it
            // skip already reversed items
            if (item.reversed) continue; //TODO tell the user why we skipped it
            // prepare advance invoices
            const selected_advance_invoices_amounts = {};
            const advance_id_invoices = this.props.id_advance_invoice_consumption_by_id_consumer_invoices[item.id_invoice] || [];
            for(let i = 0; i < advance_id_invoices.length; i++){
                const item = this.props.advance_invoice_consumptions[advance_id_invoices[i]];
                selected_advance_invoices_amounts[item.advance_id_invoice] = -item.amount;
            }
            // create inverse document
            const new_item = (0, _invoiceCreatorDefault.default).CreateInvoiceFromInitialData({
                id_invoice: (0, _uuidDefault.default).v4(),
                reverse_invoice: true,
                id_customer: item.id_customer,
                invoice_date: (0, _momentDefault.default)().toISOString(true),
                invoice_type: item.invoice_type,
                note: '',
                payment_date: (0, _momentDefault.default)().toISOString(true),
                reference: item.invoice_number_internal,
                reservation: item.reservation,
                service_date_end: item.service_date_end,
                service_date_start: item.service_date_start,
                invoice_amount: -item.invoice_amount,
                id_cash_register: this.props.current_id_cash_register,
                advance_payment_amount: -(item.advance_payment_amount - item.used_advance_payment_amount),
                credit_note_type: item.credit_note_type,
                items: item.items.map((item_item)=>{
                    return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                        id_invoice_item: (0, _uuidDefault.default).v4(),
                        description: item_item.description,
                        discount: item_item.discount,
                        id_item: item_item.id_item,
                        id_item_price_list: item_item.id_item_price_list,
                        id_tax_rate: item_item.id_tax_rate,
                        item_measuring_unit_code: item_item.item_measuring_unit_code,
                        item_measuring_unit_decimal_digit_count: item_item.item_measuring_unit_decimal_digit_count,
                        price: item_item.price,
                        quantity: -item_item.quantity,
                        tax_rate: item_item.tax_rate,
                        approved_percent: item_item.approved_percent,
                        item_type: item_item.item_type,
                        item_ean: item_item.item_ean,
                        item_title: item_item.item_title,
                        ord: item_item.ord,
                        taxable: item_item.taxable,
                        item_internal_code: item_item.item_internal_code,
                        id_warehouse: item_item.item_type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === null ? null : this.props.cash_registers[this.props.current_id_cash_register], this.props.warehouses)
                    });
                }),
                payments: item.payments.length == 0 ? [] : [
                    (0, _invoiceCreatorDefault.default).CreateInvoicePaymentFromInitialData({
                        id_invoice_payment: (0, _uuidDefault.default).v4(),
                        id_payment_type: item.payments.length == 1 ? item.payments[0].id_payment_type : '2db820c7-a652-4f9e-8c93-7e1b09d399d5',
                        amount: item.payments.reduce((acc, item)=>acc + item.amount, 0),
                        payment_date: new Date()
                    })
                ],
                reverse_invoice_reference: id,
                original_id_invoice: id,
                original_invoice_type: item.invoice_type,
                max_advance_payment_amount: item.advance_payment_amount - item.used_advance_payment_amount
            });
            this.openAddEditItemDialog(new_item, new_item.invoice_type, selected_advance_invoices_amounts);
        }
        this.setState({
            table_items_checked_ids: {}
        });
    }
    createInvoiceFromOriginal(ids, invoice_type, advance_id_invoices) {
        ids = ids === null ? [] : Array.isArray(ids) ? ids : [
            ids
        ];
        advance_id_invoices = advance_id_invoices || [];
        let first_item = ids.length == 0 ? null : this.state.table_items[ids[0]];
        const amount_factor = invoice_type == 'credit-note' ? -1 : 1;
        const original_id_invoices = [];
        const original_invoice_types = [];
        const selected_advance_invoices_amounts = {};
        let advance_payment_amount = 0;
        let invoice_amount = 0;
        let items = [];
        let payments = [];
        for(let i = 0; i < advance_id_invoices.length; i++){
            const item = this.state.table_items[advance_id_invoices[i]];
            const advance_amount = Math.max(0, parseFloat(item.advance_payment_amount) - parseFloat(item.used_advance_payment_amount));
            advance_payment_amount += advance_amount;
            if (advance_amount > 0) selected_advance_invoices_amounts[item.id_invoice] = advance_amount;
        }
        for(let i = 0; i < ids.length; i++){
            const item = this.state.table_items[ids[i]];
            if (original_id_invoices.indexOf(ids[i]) == -1) {
                original_id_invoices.push(ids[i]);
                original_invoice_types.push(item.invoice_type);
            }
            invoice_amount += item.invoice_amount * amount_factor;
            items = [
                ...items,
                ...item.items.map((item_item)=>{
                    return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                        id_invoice_item: (0, _uuidDefault.default).v4(),
                        description: item_item.description,
                        discount: item_item.discount,
                        id_item: item_item.id_item,
                        id_item_price_list: item_item.id_item_price_list,
                        id_tax_rate: item_item.id_tax_rate,
                        item_measuring_unit_code: item_item.item_measuring_unit_code,
                        item_measuring_unit_decimal_digit_count: item_item.item_measuring_unit_decimal_digit_count,
                        price: item_item.price,
                        quantity: item_item.quantity * amount_factor,
                        tax_rate: item_item.tax_rate,
                        approved_percent: item_item.approved_percent,
                        item_type: item_item.item_type,
                        item_ean: item_item.item_ean,
                        item_title: item_item.item_title,
                        ord: item_item.ord,
                        taxable: item_item.taxable,
                        item_internal_code: item_item.item_internal_code,
                        id_warehouse: item_item.item_type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === null ? null : this.props.cash_registers[this.props.current_id_cash_register], this.props.warehouses)
                    });
                })
            ];
            payments = [
                ...payments
            ];
        }
        // create new document
        let payment_date = null;
        let invoice_date = null;
        let service_date_end = null;
        let service_date_start = null;
        if (first_item !== null) {
            payment_date = first_item.payment_date;
            invoice_date = first_item.invoice_date;
            service_date_end = first_item.service_date_end;
            service_date_start = first_item.service_date_start;
            if (invoice_type == 'credit-note' || invoice_type == 'prepayment-invoice' || invoice_type == 'cash-prepayment-invoice') {
                payment_date = new Date();
                invoice_date = new Date();
            } else if (invoice_type == 'invoice') {
                payment_date = null;
                invoice_date = new Date();
                service_date_end = new Date();
                service_date_start = new Date();
            }
        }
        const new_item = (0, _invoiceCreatorDefault.default).CreateInvoiceFromInitialData({
            id_invoice: (0, _uuidDefault.default).v4(),
            id_customer: first_item === null ? null : first_item.id_customer,
            invoice_date,
            invoice_type,
            note: '',
            payment_date,
            reference: first_item === null ? null : first_item.invoice_number_internal,
            reservation: first_item === null ? null : first_item.reservation,
            service_date_end,
            service_date_start,
            invoice_amount,
            id_cash_register: this.props.current_id_cash_register,
            advance_payment_amount,
            items,
            payments,
            original_id_invoice: original_id_invoices,
            original_invoice_type: original_invoice_types
        });
        this.openAddEditItemDialog(new_item, new_item.invoice_type, selected_advance_invoices_amounts);
        this.setState({
            table_items_checked_ids: {}
        });
    }
    deleteItem(id, confirmed) {
        if (!confirmed) {
            this.setState({
                delete_item_dialog_open: true,
                delete_item_id_item: id
            });
            return;
        }
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        (0, _business.deleteInvoice)(this.props.api_url, id, token).then((data)=>{
            if (data === null) return;
            for(let i = 0; i < data.id_invoices.length; i++)dispatch((0, _businessSlice.deleteInvoice)({
                id_invoice: data.id_invoices[i]
            }));
        });
    }
    async printA4(lang) {
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        const ids = check_count == 0 ? this.state.table_items_sort_ids : this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        for(let i = 0; i < ids.length; i++){
            const invoice = this.state.table_items[ids[i]];
            let invoice_fiscal_verification = null;
            if (invoice.id_invoice_fiscal_verification !== null && invoice.id_invoice_fiscal_verification !== undefined) {
                if (this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification] !== undefined) invoice_fiscal_verification = this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification];
                else invoice_fiscal_verification = await (0, _business.loadInvoiceFiscalVerification)(this.props.api_url, invoice.id_invoice_fiscal_verification, this.props.dispatch, this.props.token);
            }
            if (invoice_fiscal_verification !== null && invoice_fiscal_verification.eor !== null && invoice_fiscal_verification.signed_zoi !== null && invoice_fiscal_verification.eor.length > 0 && invoice_fiscal_verification.signed_zoi.length > 0) await (0, _business.increaseInvoicePrintCount)(this.props.api_url, ids[i], this.props.token);
            this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                type: 'invoice',
                lang,
                invoice
            }));
        }
    }
    issuedInvoicesExportToExcel() {
        const params = [];
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['business--business-invoices'] ?? 0);
        const data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days').format('YYYY-MM-DD');
        let d;
        d = this.state.table_items_filters.invoice_date_range[0] === null ? null : (0, _momentDefault.default)(this.state.table_items_filters.invoice_date_range[0]).format('YYYY-MM-DD');
        if (d !== null) {
            console.log({
                d,
                data_retention_date_start,
                compare: d < data_retention_date_start
            });
            if (d < data_retention_date_start) d = data_retention_date_start;
            params.push('invoice_date_from=' + d);
        }
        d = this.state.table_items_filters.invoice_date_range[1] === null ? null : (0, _momentDefault.default)(this.state.table_items_filters.invoice_date_range[1]).format('YYYY-MM-DD');
        if (d !== null) {
            if (d < data_retention_date_start) d = data_retention_date_start;
            params.push('invoice_date_until=' + d);
        }
        d = this.state.table_items_filters.payment_date_range[0] === null ? null : (0, _momentDefault.default)(this.state.table_items_filters.payment_date_range[0]).format('YYYY-MM-DD');
        if (d !== null) {
            if (d < data_retention_date_start) d = data_retention_date_start;
            params.push('payment_date_from=' + d);
        }
        d = this.state.table_items_filters.payment_date_range[1] === null ? null : (0, _momentDefault.default)(this.state.table_items_filters.payment_date_range[1]).format('YYYY-MM-DD');
        if (d !== null) {
            if (d < data_retention_date_start) d = data_retention_date_start;
            params.push('payment_date_until=' + d);
        }
        if (this.state.table_items_filters.paid !== null) params.push('paid=' + encodeURIComponent(this.state.table_items_filters.paid ? 'true' : 'false'));
        params.push('invoice_number_internal=' + encodeURIComponent(this.state.table_items_filters.invoice_number_internal));
        params.push('customer_internal_code=' + encodeURIComponent(this.state.table_items_filters.customer_internal_code));
        params.push('customer_name=' + encodeURIComponent(this.state.table_items_filters.customer_name));
        params.push('invoice_types=' + encodeURIComponent(this.state.table_items_filters.invoice_types.join(',')));
        params.push('username=' + encodeURIComponent(this.state.table_items_filters.username_creator));
        console.log({
            params,
            data_retention_date_start
        });
        window.open(this.props.api_url + 'Invoices/v2/issued-invoices-export-excel?' + params.join('&'));
    }
    markAsPaid() {
        this.markAsPaidUnpaid(true);
    }
    markAsUnpaid() {
        this.markAsPaidUnpaid(false);
    }
    async markAsPaidUnpaid(paid) {
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        const ids = check_count == 0 ? this.state.table_items_sort_ids : this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        await (0, _business.setAsPaid)(this.props.api_url, ids, this.props.token, paid);
        this.setState({
            table_items_checked_ids: {}
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('business--business-invoices') === -1) return null;
        const check_ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        const check_count = check_ids.length;
        const checked_draft_count = check_ids.filter((id)=>this.props.invoices[id].draft).length;
        const checked_paid_count = check_ids.filter((id)=>this.props.invoices[id].paid).length;
        const checked_unpaid_count = check_ids.filter((id)=>!this.props.invoices[id].paid).length;
        const checked_prepayment_invoice_ids = Object.keys(this.state.table_items_checked_ids).filter((id)=>this.state.table_items[id].invoice_type == 'prepayment-invoice');
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editInvoiceDialogDefault.default), {
                    closeEditInvoiceDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item,
                    type: this.state.add_edit_item_dialog_type,
                    selected_advance_invoices_amounts: this.state.add_edit_item_dialog_advance_invoices_amounts
                }),
                !this.state.date_range_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePickerDialogDefault.default), {
                    startValue: this.state.table_items_filters[this.state.date_range_picker_dialog_filter_name][0],
                    endValue: this.state.table_items_filters[this.state.date_range_picker_dialog_filter_name][1],
                    closeDialog: (start_date, end_date)=>{
                        this.closeDateRangePickerDialog(start_date, end_date);
                    }
                }),
                !this.state.delete_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Izbri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.deleteItem(this.state.delete_item_id_item, true);
                        this.setState({
                            delete_item_dialog_open: false,
                            delete_item_id_item: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            delete_item_dialog_open: false,
                            delete_item_id_item: null
                        });
                    },
                    children: "Res \u017Eelite izbrisati ta dokument?"
                }),
                this.state.create_invoice_from_ids === undefined || this.state.create_invoice_from_ids === null || this.state.create_invoice_from_ids.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _advanceInvoiceListDialogDefault.default), {
                    closeDialog: (id_invoice)=>{
                        if (id_invoice !== undefined) this.createInvoiceFromOriginal(id_invoice, this.state.create_invoice_from_ids_invoice_type, this.state.create_invoice_from_ids);
                        this.setState({
                            create_invoice_from_ids_invoice_type: null,
                            create_invoice_from_ids: null
                        });
                    },
                    invoices: this.state.create_invoice_from_ids.map((id)=>this.state.table_items[id])
                }),
                !this.state.wait_fiscal_verification_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _waitFiscalVerificationDialogDefault.default), {
                    closeWaitFiscalVerificationDialog: (print)=>{
                        this.setState({
                            wait_fiscal_verification_dialog_open: false
                        });
                        if (print) {
                            const invoice = this.props.invoices[this.state.wait_fiscal_verification_dialog_id_invoice];
                            if (this.props.general_settings.auto_print_type == 'a4') this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                                type: 'invoice',
                                lang: 'sl',
                                invoice
                            }));
                            else if (this.props.general_settings.auto_print_type == 'pos') this.props.dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                                type: 'invoice',
                                invoice
                            }));
                        }
                    },
                    id_invoice: this.state.wait_fiscal_verification_dialog_id_invoice
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow business-invoices-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "plus",
                                            onClick: ()=>this.openAddEditItemDialog(null, 'invoice'),
                                            children: "Nova faktura"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "plus",
                                            onClick: ()=>this.openAddEditItemDialog(null, 'prepayment-invoice'),
                                            children: "Nov avansni ra\u010Dun"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "plus",
                                            onClick: ()=>this.openAddEditItemDialog(null, 'credit-note'),
                                            children: "Nov dobropis"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "print",
                                            onClick: ()=>this.printA4('sl'),
                                            disabled: check_count <= 0 || checked_draft_count > 0,
                                            children: "Natisni"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            className: "pl-4 pr-4",
                                            onClick: ()=>this.printA4('en'),
                                            disabled: check_count <= 0 || checked_draft_count > 0,
                                            children: "EN"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            className: "pl-4 pr-4",
                                            onClick: ()=>this.printA4('de'),
                                            disabled: check_count <= 0 || checked_draft_count > 0,
                                            children: "DE"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        icon: "cloud-download",
                                        onClick: this.issuedInvoicesExportToExcel,
                                        children: "Izvoz seznama v Excel"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "danger",
                                    icon: "delete",
                                    onClick: ()=>{
                                        const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                        this.reverseItems(ids);
                                    },
                                    className: "ml-2",
                                    disabled: check_count != 1 || this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).filter((id)=>!this.state.table_items[id].draft && !this.state.table_items[id].reversed).length != 1,
                                    children: "Storniraj"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "warning",
                                    icon: "changes",
                                    onClick: ()=>{},
                                    className: "ml-2",
                                    disabled: true,
                                    children: "Po\u0161lji na FURS"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "duplicate",
                                            onClick: ()=>{
                                                const ids = Object.keys(this.state.table_items_checked_ids);
                                                if (ids.length == 0) return;
                                                const item = this.state.table_items[ids[0]];
                                                const new_item = (0, _invoiceCreatorDefault.default).Duplicate(item);
                                                new_item.id_invoice = (0, _uuidDefault.default).v4();
                                                new_item.invoice_number = '';
                                                new_item.invoice_number_internal = '';
                                                new_item.draft = true;
                                                new_item.note = '';
                                                new_item.invoice_date = (0, _momentDefault.default)().toISOString(true);
                                                new_item.payment_date = null;
                                                new_item.service_date_start = (0, _momentDefault.default)().toISOString(true);
                                                new_item.service_date_end = (0, _momentDefault.default)().toISOString(true);
                                                const due_day_count = item.id_customer !== null ? this.props.customers[item.id_customer].due_day_count : this.props.settings.due_day_count;
                                                new_item.payment_date = (0, _momentDefault.default)(new_item.invoice_date).add(due_day_count, 'days').toDate();
                                                for(let i = 0; i < new_item.payments.length; i++)new_item.payments[i].id_invoice_payment = null;
                                                for(let i = 0; i < new_item.items.length; i++)new_item.items[i].id_invoice_item = (0, _uuidDefault.default).v4();
                                                this.openAddEditItemDialog(new_item, item.invoice_type);
                                                this.setState({
                                                    table_items_checked_ids: {}
                                                });
                                            },
                                            disabled: check_count != 1,
                                            children: "Podvoji"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "inheritance",
                                            onClick: ()=>{
                                                const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                                if (ids.length > 0) this.createInvoiceFromOriginal(ids[0], 'invoice', ids);
                                            },
                                            disabled: check_count == 0 || !Object.keys(this.state.table_items_checked_ids).every((x)=>this.state.table_items[x].invoice_type == 'prepayment-invoice'),
                                            children: "Izdelaj fakturo"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "inheritance",
                                            onClick: ()=>{
                                                const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                                if (ids.length == 1) this.createInvoiceFromOriginal(ids[0], 'cash-invoice', ids);
                                                else if (ids.length > 1) this.setState({
                                                    create_invoice_from_ids: ids,
                                                    create_invoice_from_ids_invoice_type: 'cash-invoice'
                                                });
                                            },
                                            disabled: this.props.current_id_cash_register == 0 || checked_prepayment_invoice_ids.length == 0,
                                            children: "Izdelaj blag. ra\u010Dun"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "inheritance",
                                            onClick: ()=>{
                                                const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                                if (ids.length > 0) this.createInvoiceFromOriginal(ids[0], 'credit-note');
                                            },
                                            disabled: check_count != 1 || this.state.table_items[Object.keys(this.state.table_items_checked_ids)[0]].invoice_type != 'invoice',
                                            children: "Izdelaj dobropis"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Popover), {
                                    content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Menu), {
                                        className: "default-popover",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                icon: "multi-select",
                                                text: "Ozna\u010Di kot pla\u010Dano",
                                                disabled: checked_unpaid_count == 0 || check_count != checked_unpaid_count,
                                                onClick: this.markAsPaid
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                                                icon: "multi-select",
                                                text: "Ozna\u010Di kot nepla\u010Dano",
                                                disabled: checked_paid_count == 0 || check_count != checked_paid_count,
                                                onClick: this.markAsUnpaid
                                            })
                                        ]
                                    }),
                                    placement: "left-start",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        icon: "caret-down",
                                        className: "ml-2"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    customers: this.props.customers,
                                    payment_types: this.props.payment_types,
                                    selectDateRangeFilter: (filter_name)=>this.openDateRangePickerDialog(filter_name),
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
BusinessInvoices.propTypes = {};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        payment_types: state.CodeTablesSlice.payment_types,
        invoices: state.BusinessSlice.invoices,
        api_url: state.BusinessSlice.api_url,
        advance_invoice_consumptions: state.BusinessSlice.advance_invoice_consumptions,
        id_advance_invoice_consumption_by_id_consumer_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_consumer_invoices,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        document_types: state.DocumentSlice.document_types,
        general_settings: state.SettingsSlice.general,
        settings: state.SettingsSlice,
        cash_registers: state.CashRegisterSlice.cash_registers,
        warehouses: state.CodeTablesSlice.warehouses
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(BusinessInvoices);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","uuid":"b52pV","moment":"1e4qG","@blueprintjs/core":"6Mq52","./EditInvoiceDialog":"kxL93","./WaitFiscalVerificationDialog":"bvSNl","../../slices/BusinessSlice":"47JXm","../../api/Business":"fC7Hd","../../slices/DocumentSlice":"6gdAm","../DateRangePickerDialog":"eJXAI","../../helpers/InvoiceCreator":"d7VsE","./AdvanceInvoiceListDialog":"iPwOj","../../helpers/Invoice":"jffQW","../../slices/AppSlice":"aByTQ","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iPwOj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
class AdvanceInvoiceListDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "advance-invoice-list-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Izbor glavnega ra\u010Duna"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "pb-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "Izberi ra\u010Dun, iz katerega naj sistem vzame podatke."
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "Ostali ra\u010Duni se bodo uporabili samo za znesek predpla\u010Dila."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "advance-invoice-list",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "advance-invoice-list-table floating-header",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "advance-invoice-list-table-header-col col-1",
                                                children: "Datum"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "advance-invoice-list-table-header-col col-2",
                                                children: "\u0160t. dokumenta"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "advance-invoice-list-table-header-col col-3",
                                                children: "Tip"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "advance-invoice-list-table-header-col col-4",
                                                children: "Stranka"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "advance-invoice-list-table-header-col col-5 text-right",
                                                children: "Znesek"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "advance-invoice-list-table-header-col col-6 text-right",
                                                children: "Neizkori\u0161\u010Den znesek"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "advance-invoice-list-table-header-col col-7"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "advance-invoice-list-table",
                                        children: this.props.invoices.map((invoice_item)=>{
                                            const document_date = invoice_item.invoice_date;
                                            const document_document_number = invoice_item.invoice_number_internal;
                                            let document_amount = invoice_item.invoice_amount;
                                            let document_type_title = "ra\u010Dun";
                                            switch(invoice_item.invoice_type){
                                                case 'cash-invoice':
                                                    document_type_title = "blagajni\u0161ki ra\u010Dun";
                                                    break;
                                                case 'offer':
                                                    document_type_title = 'ponudba';
                                                    break;
                                                case 'credit-note':
                                                    document_type_title = 'dobropis';
                                                    break;
                                                case 'prepayment-invoice':
                                                    document_type_title = "avansni ra\u010Dun";
                                                    document_amount = invoice_item.advance_payment_amount;
                                                    break;
                                            }
                                            const document_customer = invoice_item.id_customer === null ? null : this.props.customers[invoice_item.id_customer];
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "advance-invoice-list-table-col col-1",
                                                        children: document_date === null ? null : (0, _momentDefault.default)(document_date).format('DD.MM.YYYY')
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "advance-invoice-list-table-col col-2",
                                                        children: document_document_number
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "advance-invoice-list-table-col col-3",
                                                        children: document_type_title
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "advance-invoice-list-table-col col-4",
                                                        children: document_customer === null ? null : document_customer.type == 'natural' ? document_customer.surname + ' ' + document_customer.name : document_customer.company_name
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "advance-invoice-list-table-col col-5 text-right",
                                                        children: document_amount === null ? null : parseFloat(document_amount).toLocaleString(undefined, {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }) + ' EUR'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "advance-invoice-list-table-col col-6 text-right",
                                                        children: (parseFloat(invoice_item.advance_payment_amount) - parseFloat(invoice_item.used_advance_payment_amount)).toLocaleString(undefined, {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }) + ' EUR'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "advance-invoice-list-table-col col-7",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            small: true,
                                                            intent: (0, _core.Intent).PRIMARY,
                                                            className: 'cell-button',
                                                            onClick: ()=>this.props.closeDialog(invoice_item.id_invoice),
                                                            children: "Izberi"
                                                        })
                                                    })
                                                ]
                                            }, 'invoice-' + invoice_item.id_invoice);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>this.props.closeDialog(null),
                                    children: "Nadaljuj brez glavnega ra\u010Duna"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>this.props.closeDialog(this.props.invoices.map((invoice)=>invoice.id_invoice)),
                                    children: "Zdru\u017Ei vse ra\u010Dune"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(AdvanceInvoiceListDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hOUjD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _editInvoiceDialog = require("./EditInvoiceDialog");
var _editInvoiceDialogDefault = parcelHelpers.interopDefault(_editInvoiceDialog);
var _waitFiscalVerificationDialog = require("./WaitFiscalVerificationDialog");
var _waitFiscalVerificationDialogDefault = parcelHelpers.interopDefault(_waitFiscalVerificationDialog);
var _businessSlice = require("../../slices/BusinessSlice");
var _business = require("../../api/Business");
var _documentSlice = require("../../slices/DocumentSlice");
var _dateRangePickerDialog = require("../DateRangePickerDialog");
var _dateRangePickerDialogDefault = parcelHelpers.interopDefault(_dateRangePickerDialog);
var _invoiceCreator = require("../../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _appSlice = require("../../slices/AppSlice");
var _resultComponents = require("../code_tables/ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, originalTableItemsFilters, handleFilterChange, customers, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged, deleteItem } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const toLocalString = (date)=>{
        if (date === null || date === undefined) return '';
        if (!(date instanceof Date)) return date;
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
    };
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-auto sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: check_count > 0,
                                indeterminate: !all_checked && check_count > 0,
                                onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 2,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 3,
                            ...sort_props,
                            title: "\u0160t. ponudbe",
                            fieldName: "invoice_number_internal"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 4,
                            ...sort_props,
                            title: "\u0160ifra",
                            fieldName: "customer_internal_code"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 5,
                            ...sort_props,
                            title: "Naziv stranke",
                            fieldName: "customer_name"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 6,
                            ...sort_props,
                            title: "Datum dokumenta",
                            fieldName: "invoice_date"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 7,
                            ...sort_props,
                            title: "Datum veljavnosti",
                            fieldName: "payment_date"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 8,
                            ...sort_props,
                            title: "Uporabnik",
                            fieldName: "username_creator"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 9,
                            ...sort_props,
                            cls: "text-right",
                            title: "Znesek",
                            fieldName: "invoice_amount"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.invoice_number_internal,
                                onChange: (event)=>handleFilterChange('invoice_number_internal', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_internal_code,
                                onChange: (event)=>handleFilterChange('customer_internal_code', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_name,
                                onChange: (event)=>handleFilterChange('customer_name', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.invoice_date_range,
                                original_start_date: originalTableItemsFilters.invoice_date_range[0],
                                original_end_date: originalTableItemsFilters.invoice_date_range[1],
                                onFilterChange: (values)=>handleFilterChange('invoice_date_range', values)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.payment_date_range,
                                original_start_date: originalTableItemsFilters.payment_date_range[0],
                                original_end_date: originalTableItemsFilters.payment_date_range[1],
                                onFilterChange: (values)=>handleFilterChange('payment_date_range', values)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.username_creator,
                                onChange: (event)=>handleFilterChange('username_creator', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col text-right"
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            let cls = '';
                            if (item.reversed) cls += ' reversed';
                            if (item.reverse_invoice) cls += ' reverse-invoice';
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        cls: cls,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: table_items_checked_ids[id] === true,
                                            onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        cls: cls,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "edit",
                                                    intent: "primary",
                                                    minimal: true,
                                                    small: true,
                                                    onClick: ()=>openAddEditItemDialog(item, item.type)
                                                }),
                                                !item.draft ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "trash",
                                                    intent: "danger",
                                                    minimal: true,
                                                    small: true,
                                                    onClick: ()=>{
                                                        deleteItem(id);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        cls: cls,
                                        child: item.draft ? 'osnutek' : item.invoice_number_internal
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        cls: cls,
                                        child: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        cls: cls,
                                        child: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].type == 'natural' ? customers[item.id_customer].surname + ' ' + customers[item.id_customer].name : customers[item.id_customer].company_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        cls: cls,
                                        child: toLocalString(new Date(item.invoice_date))
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        cls: cls,
                                        child: toLocalString(new Date(item.payment_date))
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        cls: cls,
                                        child: item.username_creator
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        cls: cls + ' text-right font-bold col-invoice-amount',
                                        child: (item.reversed ? '[S] ' : '') + parseFloat(item.invoice_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) + ' EUR'
                                    })
                                ]
                            }, 'result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-sum pb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col",
                        children: [
                            "\u0160tevilo zapisov: ",
                            table_items_sort_ids.length
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        children: table_items_sort_ids.map((id, idx)=>// don't include drafts in SUMs
                            table_items[id].draft ? 0 : parseFloat(table_items[id].invoice_amount)).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) + ' EUR'
                    })
                ]
            })
        ]
    });
}
class Offers extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.openDateRangePickerDialog = this.openDateRangePickerDialog.bind(this);
        this.closeDateRangePickerDialog = this.closeDateRangePickerDialog.bind(this);
        this.createInvoiceFromOriginal = this.createInvoiceFromOriginal.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.printA4 = this.printA4.bind(this);
        const table_items_filters = {
            invoice_number_internal: '',
            customer_internal_code: '',
            customer_name: '',
            invoice_date_range: [
                (0, _momentDefault.default)().subtract(1, 'month').toDate(),
                (0, _momentDefault.default)().toDate()
            ],
            payment_date_range: [
                null,
                null
            ],
            id_payment_types: [],
            username_creator: ''
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'invoice_number_internal',
            table_items_sort_direction: 'DESC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'invoice_number_internal',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            table_items_checked_ids: {},
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            add_edit_item_dialog_type: null,
            date_range_picker_dialog_open: false,
            date_range_picker_dialog_filter_name: null,
            reverse_items_dialog_open: false,
            delete_item_dialog_open: false,
            delete_item_id_item: null,
            wait_fiscal_verification_dialog_open: false,
            wait_fiscal_verification_dialog_id_invoice: null
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.invoices != this.state.invoices) this.setState(this.updateTableItemsFromProps(this.props, this.state));
    }
    updateTableItemsFromProps(props, state) {
        const filtered_invoices = {};
        const invoice_types = [
            'offer'
        ];
        for(let id_invoice in props.invoices){
            const invoice = props.invoices[id_invoice];
            if (invoice_types.indexOf(invoice.invoice_type) != -1) filtered_invoices[invoice.id_invoice] = invoice;
        }
        const ids = Object.keys(filtered_invoices);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            invoices: props.invoices,
            table_items: filtered_invoices,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            if (state.table_items[a_key].draft != state.table_items[b_key].draft) {
                a = state.table_items[a_key].draft;
                b = state.table_items[b_key].draft;
                dir = 'DESC';
            } else if (field == 'id_customer') {
                const customer_a = this.props.customers[state.table_items[a_key].id_customer];
                const customer_b = this.props.customers[state.table_items[b_key].id_customer];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = customer_a === undefined ? '' : customer_a.name + ' ' + customer_a.surname;
                    b = customer_b === undefined ? '' : customer_b.name + ' ' + customer_b.surname;
                }
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'username_creator') {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'customer_internal_code') {
                const customer_a = this.props.customers[state.table_items[a_key].id_customer];
                const customer_b = this.props.customers[state.table_items[b_key].id_customer];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = customer_a === undefined ? 0 : customer_a.internal_code;
                    b = customer_b === undefined ? 0 : customer_b.internal_code;
                }
            } else {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_invoice_number_internal = filters.invoice_number_internal.toUpperCase();
        const filters_customer_internal_code = filters.customer_internal_code.toUpperCase();
        const filters_customer_name = filters.customer_name.toUpperCase();
        const filters_invoice_date_start = filters.invoice_date_range[0] === null ? null : this.toIsoString(filters.invoice_date_range[0]);
        const filters_invoice_date_end = filters.invoice_date_range[1] === null ? null : this.toIsoString(filters.invoice_date_range[1]);
        const filters_payment_date_start = filters.payment_date_range[0] === null ? null : this.toIsoString(filters.payment_date_range[0]);
        const filters_payment_date_end = filters.payment_date_range[1] === null ? null : this.toIsoString(filters.payment_date_range[1]);
        const filters_id_payment_types = filters.id_payment_types;
        const filters_username = filters.username_creator.toUpperCase();
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['business--offers'] ?? 0);
        const filter_data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days').toISOString(true);
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_invoice_number_internal != '' && (item.draft ? 'osnutek' : item.invoice_number_internal).toUpperCase().indexOf(filters_invoice_number_internal) == -1) return false;
            if (filters_customer_internal_code != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || this.props.customers[item.id_customer].internal_code != filters_customer_internal_code)) return false;
            if (filters_customer_name != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || (this.props.customers[item.id_customer].surname + ' ' + this.props.customers[item.id_customer].name + ' ' + this.props.customers[item.id_customer].company_name).toUpperCase().indexOf(filters_customer_name) == -1)) return false;
            if (!item.draft && filter_data_retention_date_start !== null && item.invoice_date !== null && this.toIsoString(new Date(item.invoice_date)) <= filter_data_retention_date_start) return false;
            if (!item.draft && filters_invoice_date_start !== null && item.invoice_date !== null && this.toIsoString(new Date(item.invoice_date)) < filters_invoice_date_start) return false;
            if (!item.draft && filters_invoice_date_end !== null && item.invoice_date !== null && this.toIsoString(new Date(item.invoice_date)) > filters_invoice_date_end) return false;
            if (filters_payment_date_start !== null && item.payment_date !== null && this.toIsoString(new Date(item.payment_date)) < filters_payment_date_start) return false;
            if (filters_payment_date_end !== null && item.payment_date !== null && this.toIsoString(new Date(item.payment_date)) > filters_payment_date_end) return false;
            if (filters_id_payment_types.length > 0) {
                let found = false;
                for(let i = 0; i < filters_id_payment_types.length; i++){
                    for(let j = 0; j < item.payments.length; j++)if (item.payments[j].id_payment_type == filters_id_payment_types[i]) {
                        found = true;
                        break;
                    }
                    if (found) break;
                }
                if (!found) return false;
            }
            if (filters_username != '' && (item.username_creator === null || item.username_creator == '' || item.username_creator.toUpperCase().indexOf(filters_username) == -1)) return false;
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            invoice_number_internal: this.state.table_items_filters.invoice_number_internal,
            customer_internal_code: this.state.table_items_filters.customer_internal_code,
            customer_name: this.state.table_items_filters.customer_name,
            invoice_date_range: this.state.table_items_filters.invoice_date_range,
            payment_date_range: this.state.table_items_filters.payment_date_range,
            id_payment_types: this.state.table_items_filters.id_payment_types,
            username_creator: this.state.table_items_filters.username_creator
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item, type) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item,
            add_edit_item_dialog_type: type
        });
    }
    async closeAddEditItemDialog(item, open_create_invoice_type, finish_invoice) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) {
            this.props.dispatch((0, _businessSlice.addInvoice)({
                item,
                token: this.props.token
            }));
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            const new_items = await (0, _business.saveInvoice)(this.props.api_url, item, token, dispatch);
            if (new_items !== null) {
                if (new_items.invoices !== undefined) dispatch((0, _businessSlice.addInvoices)(new_items.invoices));
                if (new_items.document_associations !== undefined) dispatch((0, _documentSlice.addDocumentAssociations)(new_items.document_associations));
                if (new_items.advance_invoice_consumptions !== undefined) dispatch((0, _businessSlice.addAdvanceInvoiceConsumptions)(new_items.advance_invoice_consumptions));
                if (finish_invoice && this.props.document_types[item.invoice_type].fiscal_verification_enabled) this.setState({
                    wait_fiscal_verification_dialog_open: true,
                    wait_fiscal_verification_dialog_id_invoice: item.id_invoice
                });
            }
            if (open_create_invoice_type !== undefined) setTimeout(()=>{
                if (!this._ismounted) return;
                this.createInvoiceFromOriginal(item.id_invoice, open_create_invoice_type, [
                    item.id_invoice
                ]);
            }, 1000);
        }
    }
    openDateRangePickerDialog(filter_name) {
        this.setState({
            date_range_picker_dialog_open: true,
            date_range_picker_dialog_filter_name: filter_name
        });
    }
    closeDateRangePickerDialog(start_date, end_date) {
        this.setState({
            date_range_picker_dialog_open: false
        });
        if (start_date !== undefined && end_date !== undefined) this.handleFilterChange(this.state.date_range_picker_dialog_filter_name, [
            start_date,
            end_date === null ? start_date : end_date
        ]);
    }
    createInvoiceFromOriginal(id, invoice_type) {
        const item = this.state.table_items[id];
        const amount_factor = 1;
        // create new document
        let payment_date = null;
        let invoice_date = null;
        let service_date_end = null;
        let service_date_start = null;
        if (item !== null) {
            payment_date = item.payment_date;
            invoice_date = item.invoice_date;
            service_date_end = item.service_date_end;
            service_date_start = item.service_date_start;
            if (invoice_type == 'credit-note' || invoice_type == 'prepayment-invoice' || invoice_type == 'cash-prepayment-invoice') {
                payment_date = new Date();
                invoice_date = new Date();
            } else if (invoice_type == 'invoice') {
                payment_date = null;
                invoice_date = new Date();
                service_date_end = new Date();
                service_date_start = new Date();
            }
        }
        const new_item = (0, _invoiceCreatorDefault.default).CreateInvoiceFromInitialData({
            id_invoice: (0, _uuidDefault.default).v4(),
            id_customer: item.id_customer,
            invoice_date,
            invoice_type: invoice_type,
            note: '',
            payment_date,
            reference: item.invoice_number_internal,
            reservation: item.reservation,
            service_date_end,
            service_date_start,
            invoice_amount: item.invoice_amount * amount_factor,
            id_cash_register: this.props.current_id_cash_register,
            advance_payment_amount: item.advance_payment_amount,
            credit_note_type: item.credit_note_type,
            items: item.items.map((item_item)=>{
                return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                    id_invoice_item: (0, _uuidDefault.default).v4(),
                    description: item_item.description,
                    discount: item_item.discount,
                    id_item: item_item.id_item,
                    id_item_price_list: item_item.id_item_price_list,
                    id_tax_rate: item_item.id_tax_rate,
                    item_measuring_unit_code: item_item.item_measuring_unit_code,
                    item_measuring_unit_decimal_digit_count: item_item.item_measuring_unit_decimal_digit_count,
                    price: item_item.price,
                    quantity: item_item.quantity * amount_factor,
                    tax_rate: item_item.tax_rate,
                    approved_percent: item_item.approved_percent,
                    item_type: item_item.item_type,
                    item_ean: item_item.item_ean,
                    item_title: item_item.item_title,
                    ord: item_item.ord,
                    taxable: item_item.taxable,
                    item_internal_code: item_item.item_internal_code,
                    id_warehouse: item_item.item_type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === null ? null : this.props.cash_registers[this.props.current_id_cash_register], this.props.warehouses)
                });
            }),
            payments: item.payments.map((item_payment)=>{
                return (0, _invoiceCreatorDefault.default).CreateInvoicePaymentFromInitialData({
                    id_invoice_payment: (0, _uuidDefault.default).v4(),
                    id_payment_type: item_payment.id_payment_type,
                    amount: item_payment.amount,
                    payment_date: item_payment.payment_date
                });
            }),
            original_id_invoice: id,
            original_invoice_type: item.invoice_type
        });
        this.openAddEditItemDialog(new_item, new_item.invoice_type);
        this.setState({
            table_items_checked_ids: {}
        });
    }
    deleteItem(id, confirmed) {
        if (!confirmed) {
            this.setState({
                delete_item_dialog_open: true,
                delete_item_id_item: id
            });
            return;
        }
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        (0, _business.deleteInvoice)(this.props.api_url, id, token).then((data)=>{
            if (data === null) return;
            for(let i = 0; i < data.id_invoices.length; i++)dispatch((0, _businessSlice.deleteInvoice)({
                id_invoice: data.id_invoices[i]
            }));
        });
    }
    async printA4(lang) {
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        const ids = check_count == 0 ? this.state.table_items_sort_ids : this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        for(let i = 0; i < ids.length; i++){
            const invoice = this.state.table_items[ids[i]];
            let invoice_fiscal_verification = null;
            if (invoice.id_invoice_fiscal_verification !== null && invoice.id_invoice_fiscal_verification !== undefined) {
                if (this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification] !== undefined) invoice_fiscal_verification = this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification];
                else invoice_fiscal_verification = await (0, _business.loadInvoiceFiscalVerification)(this.props.api_url, invoice.id_invoice_fiscal_verification, this.props.dispatch, this.props.token);
            }
            if (invoice_fiscal_verification !== null && invoice_fiscal_verification.eor !== null && invoice_fiscal_verification.signed_zoi !== null && invoice_fiscal_verification.eor.length > 0 && invoice_fiscal_verification.signed_zoi.length > 0) await (0, _business.increaseInvoicePrintCount)(this.props.api_url, ids[i], this.props.token);
            this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                type: 'invoice',
                lang,
                invoice
            }));
        }
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('business--offers') === -1) return null;
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        const selection_include_drafts = this.state.table_items_sort_ids.some((id)=>this.state.table_items_checked_ids[id] === true && this.state.table_items[id].draft);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editInvoiceDialogDefault.default), {
                    closeEditInvoiceDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item,
                    type: this.state.add_edit_item_dialog_type
                }),
                !this.state.date_range_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePickerDialogDefault.default), {
                    startValue: this.state.table_items_filters[this.state.date_range_picker_dialog_filter_name][0],
                    endValue: this.state.table_items_filters[this.state.date_range_picker_dialog_filter_name][1],
                    closeDialog: (start_date, end_date)=>{
                        this.closeDateRangePickerDialog(start_date, end_date);
                    }
                }),
                !this.state.delete_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Izbri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.deleteItem(this.state.delete_item_id_item, true);
                        this.setState({
                            delete_item_dialog_open: false,
                            delete_item_id_item: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            delete_item_dialog_open: false,
                            delete_item_id_item: null
                        });
                    },
                    children: "Res \u017Eelite izbrisati ta dokument?"
                }),
                !this.state.wait_fiscal_verification_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _waitFiscalVerificationDialogDefault.default), {
                    closeWaitFiscalVerificationDialog: (print)=>{
                        this.setState({
                            wait_fiscal_verification_dialog_open: false
                        });
                        if (print) {
                            const invoice = this.props.invoices[this.state.wait_fiscal_verification_dialog_id_invoice];
                            if (this.props.general_settings.auto_print_type == 'a4') this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                                type: 'invoice',
                                lang: 'sl',
                                invoice
                            }));
                            else if (this.props.general_settings.auto_print_type == 'pos') this.props.dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                                type: 'invoice',
                                invoice
                            }));
                        }
                    },
                    id_invoice: this.state.wait_fiscal_verification_dialog_id_invoice
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow offers-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    className: "align-middle",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "success",
                                        icon: "plus",
                                        onClick: ()=>this.openAddEditItemDialog(null, 'offer'),
                                        children: "Nova ponudba"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "print",
                                            onClick: ()=>this.printA4('sl'),
                                            disabled: check_count <= 0,
                                            children: "Natisni"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            className: "pl-4 pr-4",
                                            onClick: ()=>this.printA4('en'),
                                            disabled: check_count <= 0,
                                            children: "EN"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            className: "pl-4 pr-4",
                                            onClick: ()=>this.printA4('de'),
                                            disabled: check_count <= 0,
                                            children: "DE"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        icon: "cloud-download",
                                        disabled: check_count <= 0,
                                        onClick: ()=>{},
                                        children: "Izvoz v Excel"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "duplicate",
                                            onClick: ()=>{
                                                const ids = Object.keys(this.state.table_items_checked_ids);
                                                if (ids.length == 0) return;
                                                const item = this.state.table_items[ids[0]];
                                                const new_item = (0, _invoiceCreatorDefault.default).Duplicate(item);
                                                new_item.id_invoice = (0, _uuidDefault.default).v4();
                                                new_item.invoice_number = '';
                                                new_item.invoice_number_internal = '';
                                                new_item.draft = true;
                                                new_item.note = '';
                                                for(let i = 0; i < new_item.payments.length; i++)new_item.payments[i].id_invoice_payment = null;
                                                for(let i = 0; i < new_item.items.length; i++)new_item.items[i].id_invoice_item = (0, _uuidDefault.default).v4();
                                                this.openAddEditItemDialog(new_item, item.invoice_type);
                                                this.setState({
                                                    table_items_checked_ids: {}
                                                });
                                            },
                                            className: "ml-2",
                                            disabled: check_count != 1,
                                            children: "Podvoji"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "inheritance",
                                            onClick: ()=>{
                                                const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                                if (ids.length > 0) this.createInvoiceFromOriginal(ids[0], 'cash-invoice');
                                            },
                                            disabled: this.props.current_id_cash_register == 0 || check_count != 1 || selection_include_drafts,
                                            children: "Izdelaj blagajni\u0161ki ra\u010Dun"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "inheritance",
                                            onClick: ()=>{
                                                const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                                if (ids.length > 0) this.createInvoiceFromOriginal(ids[0], 'cash-prepayment-invoice');
                                            },
                                            disabled: true,
                                            children: "Izdelaj ra\u010Dun za predpla\u010Dilo"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "inheritance",
                                            onClick: ()=>{
                                                const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                                if (ids.length > 0) this.createInvoiceFromOriginal(ids[0], 'prepayment-invoice');
                                            },
                                            disabled: check_count != 1 || selection_include_drafts,
                                            children: "Izdelaj avansni ra\u010Dun"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "inheritance",
                                            onClick: ()=>{
                                                const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
                                                if (ids.length > 0) this.createInvoiceFromOriginal(ids[0], 'invoice');
                                            },
                                            disabled: check_count != 1 || selection_include_drafts,
                                            children: "Izdelaj fakturo"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    customers: this.props.customers,
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    deleteItem: this.deleteItem
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
Offers.propTypes = {};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        payment_types: state.CodeTablesSlice.payment_types,
        invoices: state.BusinessSlice.invoices,
        api_url: state.BusinessSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        document_types: state.DocumentSlice.document_types,
        general_settings: state.SettingsSlice.general,
        cash_registers: state.CashRegisterSlice.cash_registers,
        warehouses: state.CodeTablesSlice.warehouses
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Offers);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","uuid":"b52pV","moment":"1e4qG","@blueprintjs/core":"6Mq52","./EditInvoiceDialog":"kxL93","./WaitFiscalVerificationDialog":"bvSNl","../../slices/BusinessSlice":"47JXm","../../api/Business":"fC7Hd","../../slices/DocumentSlice":"6gdAm","../DateRangePickerDialog":"eJXAI","../../helpers/InvoiceCreator":"d7VsE","../../helpers/Invoice":"jffQW","../../slices/AppSlice":"aByTQ","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lTOaW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _business = require("../../api/Business");
var _dateRangePickerDialog = require("../DateRangePickerDialog");
var _dateRangePickerDialogDefault = parcelHelpers.interopDefault(_dateRangePickerDialog);
var _appSlice = require("../../slices/AppSlice");
var _resultComponents = require("../code_tables/ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, tableItemsFilters, originalTableItemsFilters, handleFilterChange, customers, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const toLocalString = (date)=>{
        if (date === null || date === undefined) return '';
        if (!(date instanceof Date)) return date;
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
    };
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    const invoice_types = {
        'invoice': {
            ord: 1,
            visible: true,
            key: 'invoice',
            title: 'Faktura'
        },
        'credit-note': {
            ord: 2,
            visible: true,
            key: 'credit-note',
            title: 'Dobropis'
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results mt-4 mb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 1,
                                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: check_count > 0,
                                    indeterminate: !all_checked && check_count > 0,
                                    onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 2,
                                title: "Urejanje"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 3,
                                ...sort_props,
                                title: "\u0160t. ra\u010Duna",
                                fieldName: "invoice_number_internal"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 4,
                                ...sort_props,
                                title: "\u0160ifra",
                                fieldName: "customer_internal_code"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 5,
                                ...sort_props,
                                title: "Naziv stranke",
                                fieldName: "id_customer"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 6,
                                title: "Datum dokumenta"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 7,
                                ...sort_props,
                                title: "Datum DDV",
                                fieldName: "vat_date"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 8,
                                title: "Vrsta dokumenta"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 9,
                                title: "Osnova"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 10,
                                title: "Davek"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 11,
                                title: "Neobdav\u010Deno"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 12,
                                title: "Skupaj"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table filters-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.invoice_number_internal,
                                    onChange: (event)=>handleFilterChange('invoice_number_internal', event)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 4,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.customer_internal_code,
                                    onChange: (event)=>handleFilterChange('customer_internal_code', event)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 5,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.customer_name,
                                    onChange: (event)=>handleFilterChange('customer_name', event)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 6
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 7,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                    filter_values: tableItemsFilters.payment_date_range,
                                    original_start_date: originalTableItemsFilters.payment_date_range[0],
                                    original_end_date: originalTableItemsFilters.payment_date_range[1],
                                    onFilterChange: (values)=>handleFilterChange('payment_date_range', values)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 8,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "key",
                                        title_field: "title",
                                        items: invoice_types,
                                        filtered_keys: tableItemsFilters.invoice_types,
                                        displayFilter: (x)=>x.visible,
                                        displaySort: (a, b)=>a.ord - b.ord,
                                        onFilterChange: (values)=>handleFilterChange('invoice_types', values)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 9
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 10
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 11
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 12
                            })
                        ]
                    }),
                    table_items_sort_ids.map((id, idx)=>{
                        const item = table_items[id];
                        const invoice_date = item.invoice_date === null ? null : new Date(item.invoice_date);
                        let payment_date = item.payment_date === null ? null : new Date(item.payment_date);
                        let vat_date = null;
                        if (item.invoice_type == 'invoice') vat_date = new Date(item.service_date_end !== null ? item.service_date_end : item.service_date_start);
                        else if (item.invoice_type == 'credit-note') {
                            vat_date = payment_date;
                            payment_date = null;
                        }
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "results-table",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 1,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                        checked: table_items_checked_ids[id] === true,
                                        onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 2,
                                    child: null
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 3,
                                    child: item.draft ? 'osnutek' : item.invoice_number_internal
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 4,
                                    child: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].internal_code
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 5,
                                    child: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].type == 'natural' ? customers[item.id_customer].surname + ' ' + customers[item.id_customer].name : customers[item.id_customer].company_name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 6,
                                    child: toLocalString(invoice_date)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 7,
                                    child: toLocalString(vat_date)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 8,
                                    child: invoice_types[item.invoice_type].title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 9,
                                    cls: "text-right",
                                    child: ''
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 10,
                                    cls: "text-right",
                                    child: ''
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 11,
                                    cls: "text-right",
                                    child: ''
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 12,
                                    cls: "text-right font-bold col-invoice-amount",
                                    child: parseFloat(item.invoice_amount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }) + ' EUR'
                                })
                            ]
                        }, 'result--result-' + id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-sum pb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col",
                        children: [
                            "\u0160tevilo zapisov: ",
                            table_items_sort_ids.length
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        children: table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            if (item.invoice_type == 'prepayment-invoice') return parseFloat(item.advance_payment_amount);
                            return parseFloat(item.invoice_amount);
                        }).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) + ' EUR'
                    })
                ]
            })
        ]
    });
}
class SalesInvoiceBookItems extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openDateRangePickerDialog = this.openDateRangePickerDialog.bind(this);
        this.closeDateRangePickerDialog = this.closeDateRangePickerDialog.bind(this);
        this.printA4 = this.printA4.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.showDraftAlertIfNeeded = this.showDraftAlertIfNeeded.bind(this);
        const table_items_filters = {
            invoice_number_internal: '',
            customer_internal_code: '',
            customer_name: '',
            invoice_date_range: [],
            payment_date_range: [
                (0, _momentDefault.default)().subtract(1, 'month').set('date', 1).toDate(),
                (0, _momentDefault.default)().set('date', 1).subtract(1, 'day').toDate()
            ],
            invoice_types: []
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'invoice_number_internal',
            table_items_sort_direction: 'DESC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'invoice_number_internal',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            table_items_checked_ids: {},
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            add_edit_item_dialog_type: null,
            add_edit_item_dialog_advance_invoices_amounts: {},
            date_range_picker_dialog_open: false,
            date_range_picker_dialog_filter_name: null,
            delete_item_dialog_open: false,
            delete_item_id_item: null,
            create_invoice_from_ids: null,
            create_invoice_from_ids_invoice_type: null,
            wait_fiscal_verification_dialog_open: false,
            wait_fiscal_verification_dialog_id_invoice: null,
            draft_invoices_warning_open: false,
            draft_invoices_warning_callback: null
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.invoices != this.state.invoices) this.setState(this.updateTableItemsFromProps(this.props, this.state));
    }
    updateTableItemsFromProps(props, state) {
        const filtered_invoices = {};
        const invoice_types = [
            'invoice',
            'credit-note'
        ];
        for(let id_invoice in props.invoices){
            const invoice = props.invoices[id_invoice];
            if (invoice_types.indexOf(invoice.invoice_type) == -1) continue;
            filtered_invoices[invoice.id_invoice] = invoice;
        }
        const ids = Object.keys(filtered_invoices);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            invoices: props.invoices,
            table_items: filtered_invoices,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            if (state.table_items[a_key].draft != state.table_items[b_key].draft) {
                a = state.table_items[a_key].draft;
                b = state.table_items[b_key].draft;
                dir = 'DESC';
            } else if (field == 'id_customer') {
                const customer_a = this.props.customers[state.table_items[a_key].id_customer];
                const customer_b = this.props.customers[state.table_items[b_key].id_customer];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = customer_a === undefined ? '' : customer_a.name + ' ' + customer_a.surname;
                    b = customer_b === undefined ? '' : customer_b.name + ' ' + customer_b.surname;
                }
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'customer_internal_code') {
                const customer_a = this.props.customers[state.table_items[a_key].id_customer];
                const customer_b = this.props.customers[state.table_items[b_key].id_customer];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = customer_a === undefined ? 0 : customer_a.internal_code;
                    b = customer_b === undefined ? 0 : customer_b.internal_code;
                }
            } else {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        if (date === undefined) return null;
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_invoice_number_internal = filters.invoice_number_internal.toUpperCase();
        const filters_customer_internal_code = filters.customer_internal_code.toUpperCase();
        const filters_customer_name = filters.customer_name.toUpperCase();
        const filters_invoice_date_start = filters.invoice_date_range[0] === null ? null : this.toIsoString(filters.invoice_date_range[0]);
        const filters_invoice_date_end = filters.invoice_date_range[1] === null ? null : this.toIsoString(filters.invoice_date_range[1]);
        const filters_payment_date_start = filters.payment_date_range[0] === null ? null : this.toIsoString(filters.payment_date_range[0]);
        const filters_payment_date_end = filters.payment_date_range[1] === null ? null : this.toIsoString(filters.payment_date_range[1]);
        const filters_invoice_types = filters.invoice_types;
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['business--invoices-book'] ?? 0);
        const filter_data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days').toISOString(true);
        const draft_invoices = {};
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_invoice_number_internal != '' && (item.draft ? 'osnutek' : item.invoice_number_internal).toUpperCase().indexOf(filters_invoice_number_internal) == -1) return false;
            if (filters_customer_internal_code != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || this.props.customers[item.id_customer].internal_code != filters_customer_internal_code)) return false;
            if (filters_customer_name != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || (this.props.customers[item.id_customer].surname + ' ' + this.props.customers[item.id_customer].name + ' ' + this.props.customers[item.id_customer].company_name).toUpperCase().indexOf(filters_customer_name) == -1)) return false;
            if (filter_data_retention_date_start !== null && item.invoice_date <= filter_data_retention_date_start) return false;
            if (filters_invoice_date_start !== null && item.invoice_date < filters_invoice_date_start) return false;
            if (filters_invoice_date_end !== null && item.invoice_date > filters_invoice_date_end) return false;
            let payment_date = item.payment_date === null ? null : item.payment_date;
            let vat_date = null;
            if (item.invoice_type == 'invoice') vat_date = item.service_date_end !== null ? item.service_date_end : item.service_date_start;
            else if (item.invoice_type == 'credit-note') {
                vat_date = payment_date;
                payment_date = null;
            }
            if (filters_payment_date_start !== null && vat_date !== null && vat_date < filters_payment_date_start) return false;
            if (filters_payment_date_end !== null && vat_date !== null && vat_date > filters_payment_date_end) return false;
            if (filters_invoice_types.length > 0) {
                let found = false;
                for(let i = 0; i < filters_invoice_types.length; i++)if (item.invoice_type == filters_invoice_types[i]) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (item.draft === true) draft_invoices[item.id_invoice] = item;
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters,
            draft_invoices
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            invoice_number_internal: this.state.table_items_filters.invoice_number_internal,
            customer_internal_code: this.state.table_items_filters.customer_internal_code,
            customer_name: this.state.table_items_filters.customer_name,
            invoice_date_range: this.state.table_items_filters.invoice_date_range,
            payment_date_range: this.state.table_items_filters.payment_date_range,
            invoice_types: this.state.table_items_filters.invoice_types
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openDateRangePickerDialog(filter_name) {
        this.setState({
            date_range_picker_dialog_open: true,
            date_range_picker_dialog_filter_name: filter_name
        });
    }
    closeDateRangePickerDialog(start_date, end_date) {
        this.setState({
            date_range_picker_dialog_open: false
        });
        if (start_date !== undefined && end_date !== undefined) this.handleFilterChange(this.state.date_range_picker_dialog_filter_name, [
            start_date,
            end_date === null ? start_date : end_date
        ]);
    }
    async printA4(lang) {
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        const ids = check_count == 0 ? this.state.table_items_sort_ids : this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        for(let i = 0; i < ids.length; i++){
            const invoice = this.state.table_items[ids[i]];
            let invoice_fiscal_verification = null;
            if (invoice.id_invoice_fiscal_verification !== null && invoice.id_invoice_fiscal_verification !== undefined) {
                if (this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification] !== undefined) invoice_fiscal_verification = this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification];
                else invoice_fiscal_verification = await (0, _business.loadInvoiceFiscalVerification)(this.props.api_url, invoice.id_invoice_fiscal_verification, this.props.dispatch, this.props.token);
            }
            if (invoice_fiscal_verification !== null && invoice_fiscal_verification.eor !== null && invoice_fiscal_verification.signed_zoi !== null && invoice_fiscal_verification.eor.length > 0 && invoice_fiscal_verification.signed_zoi.length > 0) await (0, _business.increaseInvoicePrintCount)(this.props.api_url, ids[i], this.props.token);
            this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                type: 'invoice',
                lang,
                invoice
            }));
        }
    }
    exportToExcel() {
        const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        const params = [];
        const data = {
            id_invoices: ids.join(',')
        };
        let is_only_payment_date_filtered = true;
        if (this.state.table_items_filters.invoice_number_internal.length > 0 || this.state.table_items_filters.customer_internal_code.length > 0 || this.state.table_items_filters.customer_name.length > 0 || this.state.table_items_filters.invoice_date_range.length == 2 && this.state.table_items_filters.invoice_date_range[0] !== undefined && this.state.table_items_filters.invoice_date_range[1] !== undefined || this.state.table_items_filters.invoice_types.length > 0) is_only_payment_date_filtered = false;
        if (is_only_payment_date_filtered) {
            params.push('date_start=' + (0, _momentDefault.default)(this.state.table_items_filters.payment_date_range[0]).format('YYYY-MM-DD'));
            params.push('date_end=' + (0, _momentDefault.default)(this.state.table_items_filters.payment_date_range[1]).format('YYYY-MM-DD'));
        }
        const form = document.createElement('form');
        form.target = '_blank';
        form.method = 'POST';
        form.action = this.props.api_url + 'Invoices/v1/invoice-sales-book-export-excel?' + params.join('&');
        form.style.display = 'none';
        for(let key in data){
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
    showDraftAlertIfNeeded(callback) {
        if (Object.values(this.state.draft_invoices ?? {}).length > 0) this.setState({
            draft_invoices_warning_open: true,
            draft_invoices_warning_callback: callback
        });
        else callback();
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('business--invoices-book') === -1) return null;
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.date_range_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePickerDialogDefault.default), {
                    startValue: this.state.table_items_filters[this.state.date_range_picker_dialog_filter_name][0],
                    endValue: this.state.table_items_filters[this.state.date_range_picker_dialog_filter_name][1],
                    closeDialog: (start_date, end_date)=>{
                        this.closeDateRangePickerDialog(start_date, end_date);
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Nadaljuj",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "warning-sign",
                    intent: (0, _core.Intent).WARNING,
                    isOpen: this.state.draft_invoices_warning_open,
                    onConfirm: ()=>{
                        if (this.state.draft_invoices_warning_callback !== null) this.state.draft_invoices_warning_callback();
                        this.setState({
                            draft_invoices_warning_open: false
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            draft_invoices_warning_open: false
                        });
                    },
                    children: "V izbranem obdobju obstajajo osnutki ra\u010Dunov, ki jih knjiga IR ne upo\u0161teva. Prosimo, preverite pravilnost podatkov."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow sales-invoice-book-items-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-row justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pl-4 pt-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                            className: "align-middle",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                intent: "success",
                                                icon: "plus",
                                                onClick: ()=>this.showDraftAlertIfNeeded(this.exportToExcel),
                                                disabled: check_count == 0,
                                                children: "Izvoz v Excel"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                            className: "ml-2 align-middle",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    intent: "primary",
                                                    icon: "print",
                                                    onClick: ()=>this.showDraftAlertIfNeeded(()=>this.printA4('sl')),
                                                    disabled: true,
                                                    children: "Natisni"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    intent: "primary",
                                                    className: "pl-4 pr-4",
                                                    onClick: ()=>this.showDraftAlertIfNeeded(()=>this.printA4('en')),
                                                    disabled: true,
                                                    children: "EN"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    intent: "primary",
                                                    className: "pl-4 pr-4",
                                                    onClick: ()=>this.showDraftAlertIfNeeded(()=>this.printA4('de')),
                                                    disabled: true,
                                                    children: "DE"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "pt-3 pr-4 text-red-600",
                                    children: Object.values(this.state.draft_invoices ?? {}).length == 0 ? '' : "V izbranem obdobju obstajajo osnutki ra\u010Dunov, ki jih knjiga IR ne upo\u0161teva. Prosimo, preverite pravilnost podatkov."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    customers: this.props.customers,
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    }
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
SalesInvoiceBookItems.propTypes = {};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        payment_types: state.CodeTablesSlice.payment_types,
        invoices: state.BusinessSlice.invoices,
        api_url: state.BusinessSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        document_types: state.DocumentSlice.document_types,
        general_settings: state.SettingsSlice.general
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(SalesInvoiceBookItems);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","moment":"1e4qG","@blueprintjs/core":"6Mq52","../../api/Business":"fC7Hd","../DateRangePickerDialog":"eJXAI","../../slices/AppSlice":"aByTQ","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Wn7j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _business = require("../../api/Business");
var _dateRangePickerDialog = require("../DateRangePickerDialog");
var _dateRangePickerDialogDefault = parcelHelpers.interopDefault(_dateRangePickerDialog);
var _appSlice = require("../../slices/AppSlice");
var _resultComponents = require("../code_tables/ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, tableItemsFilters, originalTableItemsFilters, handleFilterChange, customers, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged, findMatchingAdvanceConsumptions } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const toIsoString = (date)=>{
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    };
    const toLocalString = (date)=>{
        if (date === null || date === undefined) return '';
        if (!(date instanceof Date)) return date;
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
    };
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    const invoice_types = {
        'prepayment-invoice': {
            ord: 1,
            visible: true,
            key: 'prepayment-invoice',
            title: "Avansni ra\u010Dun"
        }
    };
    let sum_amount = 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results mt-4 mb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 1,
                                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: check_count > 0,
                                    indeterminate: !all_checked && check_count > 0,
                                    onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 2,
                                title: "Urejanje"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 3,
                                ...sort_props,
                                title: "\u0160t. ra\u010Duna",
                                fieldName: "invoice_number_internal"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 4,
                                ...sort_props,
                                title: "\u0160ifra",
                                fieldName: "customer_internal_code"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 5,
                                ...sort_props,
                                title: "Naziv stranke",
                                fieldName: "id_customer"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 6,
                                title: "Datum dokumenta"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 7,
                                ...sort_props,
                                title: "Datum DDV",
                                fieldName: "vat_date"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 8,
                                title: "Vrsta dokumenta"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 9,
                                title: "Osnova"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 10,
                                title: "Davek"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 11,
                                title: "Neobdav\u010Deno"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 12,
                                title: "Skupaj"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table filters-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.invoice_number_internal,
                                    onChange: (event)=>handleFilterChange('invoice_number_internal', event)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 4,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.customer_internal_code,
                                    onChange: (event)=>handleFilterChange('customer_internal_code', event)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 5,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.customer_name,
                                    onChange: (event)=>handleFilterChange('customer_name', event)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 6
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 7,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                    filter_values: tableItemsFilters.payment_date_range,
                                    original_start_date: originalTableItemsFilters.payment_date_range[0],
                                    original_end_date: originalTableItemsFilters.payment_date_range[1],
                                    onFilterChange: (values)=>handleFilterChange('payment_date_range', values),
                                    disable_from: tableItemsFilters.payment_date_range_disabled
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 8,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "key",
                                        title_field: "title",
                                        items: invoice_types,
                                        filtered_keys: tableItemsFilters.invoice_types,
                                        displayFilter: (x)=>x.visible,
                                        displaySort: (a, b)=>a.ord - b.ord,
                                        onFilterChange: (values)=>handleFilterChange('invoice_types', values)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 9
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 10
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 11
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 12
                            })
                        ]
                    }),
                    table_items_sort_ids.map((id, idx)=>{
                        const item = table_items[id];
                        const invoice_date = item.invoice_date === null ? null : new Date(item.invoice_date);
                        let payment_date = item.payment_date === null ? null : new Date(item.payment_date);
                        let vat_date = null;
                        if (item.invoice_type == 'prepayment-invoice') vat_date = payment_date;
                        const matching_advance_consumptions = findMatchingAdvanceConsumptions(item.id_invoice, tableItemsFilters.payment_date_range_disabled || tableItemsFilters.payment_date_range[0] === null ? null : toIsoString(tableItemsFilters.payment_date_range[0]), tableItemsFilters.payment_date_range[1] === null ? null : toIsoString(tableItemsFilters.payment_date_range[1]), tableItemsFilters.type, true);
                        const matching_advance_consumptions_amount_sum = matching_advance_consumptions.map((x)=>x.amount).reduce((prev, curr)=>prev + curr, 0);
                        const invoice_amount = tableItemsFilters.type == 'all' ? parseFloat(item.advance_payment_amount) : tableItemsFilters.type == 'used' || tableItemsFilters.type == 'used-cash' ? -matching_advance_consumptions_amount_sum : parseFloat(item.advance_payment_amount) - matching_advance_consumptions_amount_sum;
                        sum_amount += invoice_amount;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "results-table",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 1,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                        checked: table_items_checked_ids[id] === true,
                                        onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 2,
                                    child: null
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 3,
                                    child: item.draft ? 'osnutek' : item.invoice_number_internal
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 4,
                                    child: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].internal_code
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 5,
                                    child: customers[item.id_customer] === undefined ? '' : customers[item.id_customer].type == 'natural' ? customers[item.id_customer].surname + ' ' + customers[item.id_customer].name : customers[item.id_customer].company_name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 6,
                                    child: toLocalString(invoice_date)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 7,
                                    child: toLocalString(vat_date)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 8,
                                    child: invoice_types[item.invoice_type].title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 9,
                                    cls: "text-right",
                                    child: ''
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 10,
                                    cls: "text-right",
                                    child: ''
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 11,
                                    cls: "text-right",
                                    child: ''
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 12,
                                    cls: "text-right font-bold col-invoice-amount",
                                    child: invoice_amount.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }) + ' EUR'
                                })
                            ]
                        }, 'result--result-' + id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-sum pb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col",
                        children: [
                            "\u0160tevilo zapisov: ",
                            table_items_sort_ids.length
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        children: sum_amount.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) + ' EUR'
                    })
                ]
            })
        ]
    });
}
class PrepaymentBookItems extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openDateRangePickerDialog = this.openDateRangePickerDialog.bind(this);
        this.closeDateRangePickerDialog = this.closeDateRangePickerDialog.bind(this);
        this.printA4 = this.printA4.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.findMatchingAdvanceConsumptions = this.findMatchingAdvanceConsumptions.bind(this);
        this.showDraftAlertIfNeeded = this.showDraftAlertIfNeeded.bind(this);
        const table_items_filters = {
            invoice_number_internal: '',
            customer_internal_code: '',
            customer_name: '',
            invoice_date_range: [],
            payment_date_range: [
                (0, _momentDefault.default)().subtract(1, 'month').set('date', 1).toDate(),
                (0, _momentDefault.default)().set('date', 1).subtract(1, 'day').toDate()
            ],
            payment_date_range_disabled: false,
            invoice_types: [],
            type: 'all'
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'invoice_number_internal',
            table_items_sort_direction: 'DESC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'invoice_number_internal',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            table_items_checked_ids: {},
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            add_edit_item_dialog_type: null,
            add_edit_item_dialog_advance_invoices_amounts: {},
            date_range_picker_dialog_open: false,
            date_range_picker_dialog_filter_name: null,
            delete_item_dialog_open: false,
            delete_item_id_item: null,
            create_invoice_from_ids: null,
            create_invoice_from_ids_invoice_type: null,
            wait_fiscal_verification_dialog_open: false,
            wait_fiscal_verification_dialog_id_invoice: null,
            draft_invoices_warning_open: false,
            draft_invoices_warning_callback: null
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.invoices != this.state.invoices) this.setState(this.updateTableItemsFromProps(this.props, this.state));
    }
    updateTableItemsFromProps(props, state) {
        const filtered_invoices = {};
        const invoice_types = [
            'prepayment-invoice'
        ];
        for(let id_invoice in props.invoices){
            const invoice = props.invoices[id_invoice];
            if (invoice_types.indexOf(invoice.invoice_type) == -1) continue;
            filtered_invoices[invoice.id_invoice] = invoice;
        }
        const ids = Object.keys(filtered_invoices);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            invoices: props.invoices,
            table_items: filtered_invoices,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            if (state.table_items[a_key].draft != state.table_items[b_key].draft) {
                a = state.table_items[a_key].draft;
                b = state.table_items[b_key].draft;
                dir = 'DESC';
            } else if (field == 'id_customer') {
                const customer_a = this.props.customers[state.table_items[a_key].id_customer];
                const customer_b = this.props.customers[state.table_items[b_key].id_customer];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = customer_a === undefined ? '' : customer_a.name + ' ' + customer_a.surname;
                    b = customer_b === undefined ? '' : customer_b.name + ' ' + customer_b.surname;
                }
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'customer_internal_code') {
                const customer_a = this.props.customers[state.table_items[a_key].id_customer];
                const customer_b = this.props.customers[state.table_items[b_key].id_customer];
                if (customer_a === undefined && customer_b === undefined) {
                    a = 0;
                    b = 0;
                } else {
                    a = customer_a === undefined ? 0 : customer_a.internal_code;
                    b = customer_b === undefined ? 0 : customer_b.internal_code;
                }
            } else {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        if (date === undefined) return null;
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_invoice_number_internal = filters.invoice_number_internal.toUpperCase();
        const filters_customer_internal_code = filters.customer_internal_code.toUpperCase();
        const filters_customer_name = filters.customer_name.toUpperCase();
        const filters_invoice_date_start = filters.invoice_date_range[0] === null ? null : this.toIsoString(filters.invoice_date_range[0]);
        const filters_invoice_date_end = filters.invoice_date_range[1] === null ? null : this.toIsoString(filters.invoice_date_range[1]);
        const filters_payment_date_start = filters.payment_date_range[0] === null ? null : this.toIsoString(filters.payment_date_range[0]);
        const filters_payment_date_end = filters.payment_date_range[1] === null ? null : this.toIsoString(filters.payment_date_range[1]);
        const filters_payment_date_disabled = filters.payment_date_range_disabled;
        const filters_invoice_types = filters.invoice_types;
        const filter_used_unused = filters.type;
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['business--prepayment-book'] ?? 0);
        const filter_data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days').toISOString(true);
        const draft_invoices = {};
        const ids = Object.keys(state.table_items);
        let filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            const matching_advance_consumptions = this.findMatchingAdvanceConsumptions(item.id_invoice, filters_payment_date_disabled === true ? null : filters_payment_date_start, filters_payment_date_end, filter_used_unused, true);
            const matching_advance_consumptions_amount_sum = matching_advance_consumptions.map((x)=>x.amount).reduce((prev, curr)=>prev + curr, 0);
            /*const advances_by_consumer = this.findMatchingAdvanceConsumptions(
				item.id_invoice,
				filters_payment_date_disabled === true ? null : filters_payment_date_start,
				filters_payment_date_end,
				filter_used_unused,
				false
			);
			const matching_advance_consumptions_by_consumer_amount_sum =
				advances_by_consumer
					.map(x => x.amount)
					.reduce((prev, curr) => prev + curr, 0);*/ // hide reverse prepayment invoices from all lists
            if (filter_used_unused != 'all' && item.reverse_invoice === true) return false;
            // hide reverse prepayment invoices from all lists, except all
            filter_used_unused != 'all' && item.invoice_type == 'prepayment-invoice' && item.reverse_invoice;
            if (filter_used_unused == 'unused' && item.advance_payment_amount - matching_advance_consumptions_amount_sum /*+ matching_advance_consumptions_by_consumer_amount_sum*/  == 0) return false;
            if (filters_invoice_number_internal != '' && (item.draft ? 'osnutek' : item.invoice_number_internal).toUpperCase().indexOf(filters_invoice_number_internal) == -1) return false;
            if (filters_customer_internal_code != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || this.props.customers[item.id_customer].internal_code != filters_customer_internal_code)) return false;
            if (filters_customer_name != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || (this.props.customers[item.id_customer].surname + ' ' + this.props.customers[item.id_customer].name + ' ' + this.props.customers[item.id_customer].company_name).toUpperCase().indexOf(filters_customer_name) == -1)) return false;
            if (filter_data_retention_date_start !== null && item.invoice_date <= filter_data_retention_date_start) return false;
            if (filters_invoice_date_start !== null && item.invoice_date < filters_invoice_date_start) return false;
            if (filters_invoice_date_end !== null && item.invoice_date > filters_invoice_date_end) return false;
            if (filter_used_unused == 'all') {
                if (filters_payment_date_start !== null && item.payment_date < filters_payment_date_start) return false;
                if (filters_payment_date_end !== null && item.payment_date > filters_payment_date_end) return false;
            } else if (filter_used_unused == 'unused') {
                if (!filters_payment_date_disabled && filters_payment_date_start !== null && item.payment_date < filters_payment_date_start) return false;
                if (filters_payment_date_end !== null && item.payment_date > filters_payment_date_end) return false;
            } else if (filter_used_unused == 'used' || filter_used_unused == 'used-cash') {
                if (matching_advance_consumptions_amount_sum == 0) return false;
                if (filters_payment_date_start !== null || filters_payment_date_end !== null) {
                    const matching_advance_consumptions = this.findMatchingAdvanceConsumptions(item.id_invoice, filters_payment_date_start, filters_payment_date_end, filter_used_unused, true);
                    const payment_date_found = matching_advance_consumptions.length > 0;
                    if (!payment_date_found) return false;
                }
            }
            if (filters_invoice_types.length > 0) {
                let found = false;
                for(let i = 0; i < filters_invoice_types.length; i++)if (item.invoice_type == filters_invoice_types[i]) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (item.draft === true) draft_invoices[item.id_invoice] = item;
            return true;
        });
        /*if (filter_used_unused == 'all') { //filter_used_unused == 'used' || filter_used_unused == 'used-cash') {
			if (document.location.search != '?test') {
			// add reverse invoices for filtered items above
			const additional_ids = ids.filter(id => {
				const item = state.table_items[id];
				return item.reverse_invoice === true &&
					item.reverse_invoice_reference !== null &&
					filtered_ids.indexOf(item.reverse_invoice_reference) != -1 &&
					filtered_ids.indexOf(item.id_invoice) == -1;
			});
			
			filtered_ids = [ ...filtered_ids, ...additional_ids ];
			}
		}*/ const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters,
            draft_invoices
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    findMatchingAdvanceConsumptions(id_invoice, filters_payment_date_start, filters_payment_date_end, used_unused, by_advance) {
        const results = [];
        const advance_consumptions = by_advance ? this.props.id_advance_invoice_consumption_by_id_advance_invoices[id_invoice] : this.props.id_advance_invoice_consumption_by_id_consumer_invoices[id_invoice];
        if (advance_consumptions === undefined) return results;
        for(let i = 0; i < advance_consumptions.length; i++){
            const advance_invoice_consumption = this.props.advance_invoice_consumptions[advance_consumptions[i]];
            if (advance_invoice_consumption === undefined) continue;
            const invoice = this.props.invoices[by_advance ? advance_invoice_consumption.consumer_id_invoice : advance_invoice_consumption.advance_id_invoice];
            if (invoice === undefined) continue;
            let found = false;
            // compare to payment date for prepayment invoices
            if (invoice.invoice_type == 'prepayment-invoice') {
                if (([
                    'used-cash',
                    'used'
                ].indexOf(used_unused) != -1 && invoice.reverse_invoice === false || [
                    'used-cash',
                    'used'
                ].indexOf(used_unused) == -1) && invoice.payment_date !== null) {
                    if (filters_payment_date_start !== null && filters_payment_date_end === null) {
                        if (invoice.payment_date >= filters_payment_date_start) found = true;
                    } else if (filters_payment_date_start === null && filters_payment_date_end !== null) {
                        if (invoice.payment_date <= filters_payment_date_end) found = true;
                    } else if (invoice.payment_date >= filters_payment_date_start && invoice.payment_date <= filters_payment_date_end) found = true;
                }
                if (found) results.push({
                    dates: [
                        invoice.payment_date
                    ],
                    amount: parseFloat(advance_invoice_consumption.amount)
                });
            }
            // compare to service date range for invoices
            if (!found && [
                'used',
                'unused',
                'all'
            ].indexOf(used_unused) != -1 && invoice.invoice_type == 'invoice') {
                if (invoice.service_date_start !== null || invoice.service_date_end !== null) {
                    const service_date = invoice.service_date_end ?? invoice.service_date_start;
                    if (filters_payment_date_start !== null && filters_payment_date_end === null) {
                        if (filters_payment_date_start <= service_date) found = true;
                    } else if (filters_payment_date_start === null && filters_payment_date_end !== null) {
                        if (filters_payment_date_end >= service_date) found = true;
                    } else if (filters_payment_date_start <= service_date && filters_payment_date_end >= service_date) found = true;
                }
                if (found) results.push({
                    dates: [
                        invoice.service_date_start,
                        invoice.service_date_end
                    ],
                    amount: parseFloat(advance_invoice_consumption.amount)
                });
            }
            // compare to service date range for invoices
            if (!found && [
                'used-cash',
                'unused'
            ].indexOf(used_unused) != -1 && invoice.invoice_type == 'cash-invoice') {
                if (invoice.invoice_date !== null) {
                    if (filters_payment_date_start !== null && filters_payment_date_end === null) {
                        if (filters_payment_date_start <= invoice.invoice_date) found = true;
                    } else if (filters_payment_date_start === null && filters_payment_date_end !== null) {
                        if (filters_payment_date_end >= invoice.invoice_date) found = true;
                    } else if (filters_payment_date_start <= invoice.invoice_date && filters_payment_date_end >= invoice.invoice_date) found = true;
                }
                if (found) results.push({
                    dates: [
                        invoice.invoice_date,
                        invoice.invoice_date
                    ],
                    amount: parseFloat(advance_invoice_consumption.amount)
                });
            }
        }
        return results;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            invoice_number_internal: this.state.table_items_filters.invoice_number_internal,
            customer_internal_code: this.state.table_items_filters.customer_internal_code,
            customer_name: this.state.table_items_filters.customer_name,
            invoice_date_range: this.state.table_items_filters.invoice_date_range,
            payment_date_range: this.state.table_items_filters.payment_date_range,
            invoice_types: this.state.table_items_filters.invoice_types,
            type: this.state.table_items_filters.type
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        /*if (field_name == 'type') {
			if (val == 'unused') {
				new_filters.payment_date_range = [
					null,
					moment().subtract(1, 'month').endOf('month').toDate(),
				];
			}
			else {
				new_filters.payment_date_range = [
					moment().subtract(1, 'month').set('date', 1).toDate(),
					moment().subtract(1, 'month').endOf('month').toDate(),
				];
			}
		}*/ new_filters.payment_date_range_disabled = new_filters.type == 'unused';
        this.setState({
            table_items_checked_ids: {}
        });
        this.filterTableItems(new_filters);
    }
    openDateRangePickerDialog(filter_name) {
        this.setState({
            date_range_picker_dialog_open: true,
            date_range_picker_dialog_filter_name: filter_name
        });
    }
    closeDateRangePickerDialog(start_date, end_date) {
        this.setState({
            date_range_picker_dialog_open: false
        });
        if (start_date !== undefined && end_date !== undefined) this.handleFilterChange(this.state.date_range_picker_dialog_filter_name, [
            start_date,
            end_date === null ? start_date : end_date
        ]);
    }
    async printA4(lang) {
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        const ids = check_count == 0 ? this.state.table_items_sort_ids : this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        for(let i = 0; i < ids.length; i++){
            const invoice = this.state.table_items[ids[i]];
            let invoice_fiscal_verification = null;
            if (invoice.id_invoice_fiscal_verification !== null && invoice.id_invoice_fiscal_verification !== undefined) {
                if (this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification] !== undefined) invoice_fiscal_verification = this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification];
                else invoice_fiscal_verification = await (0, _business.loadInvoiceFiscalVerification)(this.props.api_url, invoice.id_invoice_fiscal_verification, this.props.dispatch, this.props.token);
            }
            if (invoice_fiscal_verification !== null && invoice_fiscal_verification.eor !== null && invoice_fiscal_verification.signed_zoi !== null && invoice_fiscal_verification.eor.length > 0 && invoice_fiscal_verification.signed_zoi.length > 0) await (0, _business.increaseInvoicePrintCount)(this.props.api_url, ids[i], this.props.token);
            this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                type: 'invoice',
                lang,
                invoice
            }));
        }
    }
    exportToExcel() {
        const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        const params = [];
        const data = {
            id_invoices: ids.join(',')
        };
        /*let is_only_payment_date_filtered = true;
		if (
			this.state.table_items_filters.invoice_number_internal.length > 0
			||
			this.state.table_items_filters.customer_internal_code.length > 0
			||
			this.state.table_items_filters.customer_name.length > 0
			||
			(
				this.state.table_items_filters.invoice_date_range.length == 2 &&
				this.state.table_items_filters.invoice_date_range[0] !== undefined &&
				this.state.table_items_filters.invoice_date_range[1] !== undefined
			)
			||
			this.state.table_items_filters.invoice_types.length > 0
		) {
			is_only_payment_date_filtered = false;
		}
		
		if (is_only_payment_date_filtered && !this.state.table_items_filters.payment_date_range_disabled) {
			if (this.state.table_items_filters.payment_date_range[0] !== null) {
				params.push(
					'date_start=' + moment(this.state.table_items_filters.payment_date_range[0]).format('YYYY-MM-DD')
				);
			}
			if (this.state.table_items_filters.payment_date_range[1] !== null) {
				params.push(
					'date_end=' + moment(this.state.table_items_filters.payment_date_range[1]).format('YYYY-MM-DD')
				);
			}
		}*/ if (!this.state.table_items_filters.payment_date_range_disabled && this.state.table_items_filters.payment_date_range[0] !== null) params.push('date_start=' + (0, _momentDefault.default)(this.state.table_items_filters.payment_date_range[0]).format('YYYY-MM-DD'));
        if (this.state.table_items_filters.payment_date_range[1] !== null) params.push('date_end=' + (0, _momentDefault.default)(this.state.table_items_filters.payment_date_range[1]).format('YYYY-MM-DD'));
        params.push('type=' + this.state.table_items_filters.type);
        const form = document.createElement('form');
        form.target = '_blank';
        form.method = 'POST';
        form.action = this.props.api_url + 'Invoices/v1/invoice-prepayment-book-export-excel?' + params.join('&');
        form.style.display = 'none';
        for(let key in data){
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
    showDraftAlertIfNeeded(callback) {
        if (Object.values(this.state.draft_invoices ?? {}).length > 0) this.setState({
            draft_invoices_warning_open: true,
            draft_invoices_warning_callback: callback
        });
        else callback();
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('business--prepayment-book') === -1) return null;
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.date_range_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePickerDialogDefault.default), {
                    startValue: this.state.table_items_filters[this.state.date_range_picker_dialog_filter_name][0],
                    endValue: this.state.table_items_filters[this.state.date_range_picker_dialog_filter_name][1],
                    closeDialog: (start_date, end_date)=>{
                        this.closeDateRangePickerDialog(start_date, end_date);
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Nadaljuj",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "warning-sign",
                    intent: (0, _core.Intent).WARNING,
                    isOpen: this.state.draft_invoices_warning_open,
                    onConfirm: ()=>{
                        if (this.state.draft_invoices_warning_callback !== null) this.state.draft_invoices_warning_callback();
                        this.setState({
                            draft_invoices_warning_open: false
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            draft_invoices_warning_open: false
                        });
                    },
                    children: "V izbranem obdobju obstajajo osnutki avansnih ra\u010Dunov, ki jih knjiga PA ne upo\u0161teva. Prosimo, preverite pravilnost podatkov."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow sales-invoice-book-items-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4 pr-4 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                            className: "align-middle",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                intent: "success",
                                                icon: "plus",
                                                onClick: ()=>this.showDraftAlertIfNeeded(this.exportToExcel),
                                                disabled: check_count == 0,
                                                children: "Izvoz v Excel"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                            className: "ml-2 align-middle",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    intent: "primary",
                                                    icon: "print",
                                                    onClick: ()=>this.showDraftAlertIfNeeded(()=>this.printA4('sl')),
                                                    disabled: true,
                                                    children: "Natisni"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    intent: "primary",
                                                    className: "pl-4 pr-4",
                                                    onClick: ()=>this.showDraftAlertIfNeeded(()=>this.printA4('en')),
                                                    disabled: true,
                                                    children: "EN"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    intent: "primary",
                                                    className: "pl-4 pr-4",
                                                    onClick: ()=>this.showDraftAlertIfNeeded(()=>this.printA4('de')),
                                                    disabled: true,
                                                    children: "DE"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "pt-1 pr-4 text-red-600",
                                            children: Object.values(this.state.draft_invoices ?? {}).length == 0 ? '' : "V izbranem obdobju obstajajo osnutki avansnih ra\u010Dunov, ki jih knjiga PA ne upo\u0161teva. Prosimo, preverite pravilnost podatkov."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "p-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.RadioGroup), {
                                                onChange: (event)=>this.handleFilterChange('type', event),
                                                inline: true,
                                                selectedValue: this.state.table_items_filters.type,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                        label: "Vsi",
                                                        value: "all"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                        label: "Kori\u0161\u010Deni (fakture)",
                                                        value: "used"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                        label: "Kori\u0161\u010Deni (blagajna)",
                                                        value: "used-cash"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                        label: "Nekori\u0161\u010Deni",
                                                        value: "unused"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    customers: this.props.customers,
                                    payment_types: this.props.payment_types,
                                    selectDateRangeFilter: (filter_name)=>this.openDateRangePickerDialog(filter_name),
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    deleteItem: this.deleteItem,
                                    findMatchingAdvanceConsumptions: this.findMatchingAdvanceConsumptions
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
PrepaymentBookItems.propTypes = {};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        payment_types: state.CodeTablesSlice.payment_types,
        invoices: state.BusinessSlice.invoices,
        api_url: state.BusinessSlice.api_url,
        id_advance_invoice_consumption_by_id_advance_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_advance_invoices,
        id_advance_invoice_consumption_by_id_consumer_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_consumer_invoices,
        advance_invoice_consumptions: state.BusinessSlice.advance_invoice_consumptions,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        document_types: state.DocumentSlice.document_types,
        general_settings: state.SettingsSlice.general
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(PrepaymentBookItems);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","moment":"1e4qG","@blueprintjs/core":"6Mq52","../../api/Business":"fC7Hd","../DateRangePickerDialog":"eJXAI","../../slices/AppSlice":"aByTQ","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avBi4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _reactBus = require("react-bus");
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _resultComponents = require("../code_tables/ResultComponents");
var _reservation = require("../reservations/Reservation");
var _reservationDefault = parcelHelpers.interopDefault(_reservation);
var _dateTimePickerDialog = require("../DateTimePickerDialog");
var _dateTimePickerDialogDefault = parcelHelpers.interopDefault(_dateTimePickerDialog);
var _reservationSlice = require("../../slices/ReservationSlice");
var _guestSlice = require("../../slices/GuestSlice");
var _reservations = require("../../api/Reservations");
var _guests = require("../../api/Guests");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, identification_types, tourist_taxes, setTableItemsSort, openReservationDialog, tableItemsFilters, handleFilterChange, originalTableItemsFilters, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged, id_reservation_customers_by_id_guest_book, reservation_customers, accommodations, countries, disable_filters } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const id_no_items = {};
    for(let id in table_items){
        const id_no = table_items[id].id_no;
        if (id_no_items[id_no] === undefined) {
            let accommodation_title = '';
            for(let id_accommodation in accommodations)if (accommodations[id_accommodation].etourism_id_rno == id_no) {
                accommodation_title = accommodations[id_accommodation].title;
                break;
            }
            id_no_items[id_no] = {
                title: id_no + " \u2022 " + accommodation_title,
                value: id_no
            };
        }
    }
    const etourism_statuses = {
        none: 'NEPOSLAN',
        waiting: "\u010CAKA NA PO\u0160ILJANJE",
        success: "POSLANO USPE\u0160NO",
        failure: "NAPAKA PRI PO\u0160ILJANJU"
    };
    const etourism_status_colors = {
        none: '#cccccc',
        waiting: 'orange',
        success: 'green',
        failure: 'red'
    };
    const statuses = {
        1: 'Veljaven',
        2: 'Storniran'
    };
    const identification_types_by_internal_codes = {};
    for(let id_identification_type in identification_types)identification_types_by_internal_codes[identification_types[id_identification_type].internal_code] = identification_types[id_identification_type];
    const tourist_taxes_by_internal_codes = {};
    for(let id_tourist_tax in tourist_taxes)tourist_taxes_by_internal_codes[tourist_taxes[id_tourist_tax].internal_code] = tourist_taxes[id_tourist_tax];
    const etourism_status_items = {
        none: {
            title: 'Neposlan',
            value: 'none'
        },
        waiting: {
            title: "\u010Caka na po\u0161iljanje",
            value: 'waiting'
        },
        success: {
            title: "Poslano uspe\u0161no",
            value: 'success'
        },
        failure: {
            title: "Napaka pri po\u0161iljanju",
            value: 'failure'
        }
    };
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    const now = new Date();
    const countries_by_iso_3166_a1_a2 = {};
    for(let id_country in countries)countries_by_iso_3166_a1_a2[countries[id_country].iso_3166_1_a2] = countries[id_country];
    const country_list = {};
    for(let id in table_items){
        const drzava = table_items[id].drzava;
        if (country_list[drzava] === undefined) {
            const country = countries_by_iso_3166_a1_a2[drzava];
            country_list[drzava] = {
                key: drzava,
                value: country === undefined ? drzava : drzava + " \u2022 " + country.common_name_local
            };
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results mt-4 mb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table without-vertical-lines",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 1,
                                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: check_count > 0,
                                    indeterminate: !all_checked && check_count > 0,
                                    onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: 2,
                                title: "Status"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 3,
                                ...sort_props,
                                title: "Odjavljen",
                                fieldName: "checked_out"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 4,
                                ...sort_props,
                                title: "RNO",
                                fieldName: "id_no"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 5,
                                ...sort_props,
                                title: "Zst",
                                fieldName: "zst"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 6,
                                ...sort_props,
                                title: "Ime in priimek",
                                fieldName: "name_surname"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 7,
                                ...sort_props,
                                title: "Datum roj.",
                                fieldName: "dt_roj"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 8,
                                ...sort_props,
                                title: "Spol",
                                fieldName: "sp"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 9,
                                ...sort_props,
                                title: "Dr\u017Eava",
                                fieldName: "drzava"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 10,
                                ...sort_props,
                                title: "Vrsta oseb. dok.",
                                fieldName: "vrsta_dok"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 11,
                                ...sort_props,
                                title: "\u0160t. oseb. dok.",
                                fieldName: "id_st_dok"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 12,
                                ...sort_props,
                                title: "Datum in ura prihoda",
                                fieldName: "cas_prihoda"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 13,
                                ...sort_props,
                                title: "Datum in ura odhoda",
                                fieldName: "cas_odhoda"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 14,
                                ...sort_props,
                                title: "Datum prijave",
                                fieldName: "created"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 15,
                                ...sort_props,
                                title: "Status",
                                fieldName: "status"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 16,
                                ...sort_props,
                                title: "\u0160t. no\u010D.",
                                fieldName: "night_count"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: 17,
                                ...sort_props,
                                title: "Tip TT",
                                fieldName: "tt_obracun"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table without-vertical-lines filters-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "value",
                                        title_field: "title",
                                        items: etourism_status_items,
                                        filtered_keys: tableItemsFilters.etourism_statuses,
                                        onFilterChange: (values)=>handleFilterChange('etourism_statuses', values),
                                        disabled: disable_filters
                                    })
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: tableItemsFilters.checked_out === 1,
                                    indeterminate: tableItemsFilters.checked_out === 0,
                                    onChange: (event)=>{
                                        let checked = 0;
                                        if (tableItemsFilters.checked_out === 1) checked = -1;
                                        else if (tableItemsFilters.checked_out === 0) checked = 1;
                                        handleFilterChange('checked_out', checked);
                                    },
                                    disabled: disable_filters
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 4,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "value",
                                        title_field: "title",
                                        items: id_no_items,
                                        filtered_keys: tableItemsFilters.id_no,
                                        displayFilter: (x)=>true,
                                        displaySort: (a, b)=>1,
                                        onFilterChange: (values)=>handleFilterChange('id_no', values),
                                        disabled: disable_filters
                                    })
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 5,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.zst,
                                    onChange: (event)=>handleFilterChange('zst', event),
                                    disabled: disable_filters
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 6,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.name_surname,
                                    onChange: (event)=>handleFilterChange('name_surname', event),
                                    disabled: disable_filters
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 7,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateFilter), {
                                    filter_value: tableItemsFilters.dt_roj,
                                    short_year: true,
                                    original_date: null,
                                    onFilterChange: (value)=>handleFilterChange('dt_roj', value),
                                    disabled: disable_filters
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 8,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: tableItemsFilters.sp === 1,
                                    indeterminate: tableItemsFilters.sp === 0,
                                    onChange: (event)=>{
                                        let checked = 0;
                                        if (tableItemsFilters.sp === 1) checked = -1;
                                        else if (tableItemsFilters.sp === 0) checked = 1;
                                        handleFilterChange('sp', checked);
                                    },
                                    disabled: disable_filters
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 9,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "key",
                                        title_field: "value",
                                        items: country_list,
                                        filtered_keys: tableItemsFilters.drzava,
                                        onFilterChange: (values)=>handleFilterChange('drzava', values),
                                        disabled: disable_filters
                                    })
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 10,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "internal_code",
                                        title_field: "title",
                                        items: identification_types_by_internal_codes,
                                        filtered_keys: tableItemsFilters.vrsta_dok,
                                        displayFilter: (x)=>1,
                                        displaySort: (a, b)=>a.ord - b.ord,
                                        onFilterChange: (values)=>handleFilterChange('vrsta_dok', values),
                                        disabled: disable_filters
                                    })
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 11,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.id_st_dok,
                                    onChange: (event)=>handleFilterChange('id_st_dok', event),
                                    disabled: disable_filters
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 12,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                    filter_values: tableItemsFilters.cas_prihoda_range,
                                    short_year: true,
                                    original_start_date: originalTableItemsFilters.cas_prihoda_range[0],
                                    original_end_date: originalTableItemsFilters.cas_prihoda_range[1],
                                    onFilterChange: (values)=>handleFilterChange('cas_prihoda_range', values),
                                    disabled: disable_filters
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 13,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                    filter_values: tableItemsFilters.cas_odhoda_range,
                                    short_year: true,
                                    original_start_date: originalTableItemsFilters.cas_odhoda_range[0],
                                    original_end_date: originalTableItemsFilters.cas_odhoda_range[1],
                                    onFilterChange: (values)=>handleFilterChange('cas_odhoda_range', values),
                                    disabled: disable_filters
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 14
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 15,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: tableItemsFilters.status === 1,
                                    indeterminate: tableItemsFilters.status === 0,
                                    onChange: (event)=>{
                                        let checked = 0;
                                        if (tableItemsFilters.status === 1) checked = -1;
                                        else if (tableItemsFilters.status === 0) checked = 1;
                                        handleFilterChange('status', checked);
                                    },
                                    disabled: disable_filters
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 16
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 17,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "internal_code",
                                        title_field: "title",
                                        items: tourist_taxes_by_internal_codes,
                                        filtered_keys: tableItemsFilters.tt_obracun,
                                        onFilterChange: (values)=>handleFilterChange('tt_obracun', values),
                                        disabled: disable_filters
                                    })
                                }),
                                ...sort_props
                            })
                        ]
                    }),
                    table_items_sort_ids.map((id, idx)=>{
                        const item = table_items[id];
                        const etourism_status_title = etourism_statuses[item.zst === null || item.etourism_status === null ? 'none' : item.etourism_status];
                        const etourism_status_color = etourism_status_colors[item.zst === null || item.etourism_status === null ? 'none' : item.etourism_status];
                        const etourism_tooltip_content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        "Stanje: ",
                                        etourism_status_title
                                    ]
                                }),
                                item === null || item.log === null || item.log.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "mt-6 mb-1",
                                            children: "Dnevnik dogodkov:"
                                        }),
                                        [
                                            ...item.log
                                        ].sort((log_item_a, log_item_b)=>log_item_a.created.localeCompare(log_item_b.created) * -1).map((guest_book_log)=>{
                                            let status_title = 'neznano';
                                            switch(guest_book_log.status){
                                                case 'success':
                                                    status_title = "POSLANO USPE\u0160NO";
                                                    break;
                                                case 'failure':
                                                    status_title = "NAPAKA PRI PO\u0160ILJANJU";
                                                    break;
                                            }
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    maxWidth: 480,
                                                    marginBottom: '1rem'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-row justify-between mb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "mr-12",
                                                                children: status_title
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: new Date(guest_book_log.created).toLocaleString('sl-SI')
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: JSON.parse(guest_book_log.message).map((message_item)=>message_item.error_message).join(', ')
                                                    })
                                                ]
                                            }, 'guest-book-log-' + guest_book_log.id_guest_book_log);
                                        })
                                    ]
                                })
                            ]
                        });
                        const id_reservation_customer = id_reservation_customers_by_id_guest_book[id];
                        const reservation_customer = id_reservation_customer === undefined ? null : reservation_customers[id_reservation_customer];
                        const checked_out = reservation_customer === null ? null : reservation_customer.checked_out;
                        const highlighted = checked_out !== false && new Date(item.cas_odhoda) < now && item.etourism_status == 'success';
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: 'results-table without-vertical-lines ' + (highlighted ? 'warning' : ''),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 1,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                        checked: table_items_checked_ids[id] === true,
                                        onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 2,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                                content: etourism_tooltip_content,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                    icon: reservation_customer !== null && reservation_customer.checked_out === false ? 'upload' : 'tick',
                                                    className: "ml-1",
                                                    color: etourism_status_color
                                                })
                                            }),
                                            reservation_customer === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                icon: "edit",
                                                intent: "primary",
                                                minimal: true,
                                                small: true,
                                                onClick: ()=>openReservationDialog(reservation_customer.id_reservation_customer)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 3,
                                    child: checked_out === null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                        icon: "help",
                                        color: "#cccccc"
                                    }) : checked_out === true ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                        icon: "tick",
                                        color: "#394b59"
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                        icon: "cross",
                                        color: "#ff0000"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 4,
                                    child: item.id_no
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 5,
                                    child: item.zst
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 6,
                                    cls: "truncate",
                                    child: item.ime + ' ' + item.pri
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 7,
                                    child: (0, _momentDefault.default)(item.dt_roj).format('DD. MM. YYYY')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 8,
                                    child: item.sp == 'M' ? 'M' : "\u017D"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 9,
                                    child: item.drzava
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 10,
                                    cls: "truncate",
                                    child: identification_types_by_internal_codes[item.vrsta_dok].title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 11,
                                    child: item.id_st_dok
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 12,
                                    child: (0, _momentDefault.default)(item.cas_prihoda).format('DD. MM. YYYY HH:mm:ss')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 13,
                                    child: (0, _momentDefault.default)(item.cas_odhoda).format('DD. MM. YYYY HH:mm:ss')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 14,
                                    child: (0, _momentDefault.default)(item.created).format('DD. MM. YYYY HH:mm:ss')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 15,
                                    cls: item.status == 2 ? 'text-red-600' : '',
                                    child: statuses[item.status]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 16,
                                    child: (0, _momentDefault.default)(item.cas_odhoda).set('second', 0).set('minute', 0).set('hour', 12).diff((0, _momentDefault.default)(item.cas_prihoda).set('second', 0).set('minute', 0).set('hour', 12), 'days')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 17,
                                    cls: "truncate",
                                    child: tourist_taxes_by_internal_codes[item.tt_obracun].title
                                })
                            ]
                        }, 'items-result--result-' + id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-sum pb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "col",
                    children: [
                        "\u0160tevilo zapisov: ",
                        table_items_sort_ids.length
                    ]
                })
            })
        ]
    });
}
function UploadButton(props) {
    const bus = (0, _reactBus.useBus)();
    const [dialog_visible, setDialogVisible] = (0, _react.useState)(false);
    const sendToETourism = async (dialog_result)=>{
        console.log({
            dialog_result
        });
        if (dialog_result === undefined) {
            setDialogVisible(true);
            return;
        } else {
            setDialogVisible(false);
            if (dialog_result === false) return;
        }
        const dispatch = props.dispatch;
        const token = props.token;
        const checked_ids_normal = [];
        const checked_ids_reverse = [];
        for(let i = 0; i < props.checked_ids.length; i++){
            const id = props.checked_ids[i];
            if (props.guest_book_items[id] === undefined || props.guest_book_items[id].status == 1) checked_ids_normal.push(id);
            else checked_ids_reverse.push(id);
        }
        //this.increaseLoading();
        if (checked_ids_normal.length > 0) await (0, _reservations.sendReservationCustomersToETourism)(props.api_url, checked_ids_normal, 'normal', token);
        if (checked_ids_reverse.length > 0) await (0, _reservations.sendReservationCustomersToETourism)(props.api_url, checked_ids_reverse, 'reverse', token);
        await (0, _guests.loadGuestBookItems)(props.api_url, dispatch, token);
        //this.decreaseLoading();
        props.finished();
        //TODO really check for response, if it was successful or not
        bus.emit('notification-message', {
            message: "Uspe\u0161no poslano",
            type: 'success'
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                cancelButtonText: "Prekli\u010Di",
                confirmButtonText: "Po\u0161lji",
                canEscapeKeyCancel: true,
                canOutsideClickCancel: true,
                icon: "upload",
                intent: (0, _core.Intent).WARNING,
                isOpen: dialog_visible,
                onConfirm: ()=>{
                    sendToETourism(true);
                },
                onCancel: ()=>{
                    sendToETourism(false);
                },
                children: "Res \u017Eelite poslati podatke na e-Turizem?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                intent: "warning",
                icon: "upload",
                onClick: ()=>{
                    sendToETourism();
                },
                disabled: props.checked_ids.length == 0,
                children: "Po\u0161lji na e-Turizem"
            })
        ]
    });
}
class GuestBook extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.toIsoString = this.toIsoString.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.openDateRangePickerDialog = this.openDateRangePickerDialog.bind(this);
        this.closeDateRangePickerDialog = this.closeDateRangePickerDialog.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.openReservationDialog = this.openReservationDialog.bind(this);
        this.closeReservationDialog = this.closeReservationDialog.bind(this);
        this.getResetState = this.getResetState.bind(this);
        this.checkOutCustomers = this.checkOutCustomers.bind(this);
        this.openDateTimePickerDialog = this.openDateTimePickerDialog.bind(this);
        this.closeDateTimePickerDialog = this.closeDateTimePickerDialog.bind(this);
        this.generateReservationCustomersByIdGuestBook = this.generateReservationCustomersByIdGuestBook.bind(this);
        this.setMainTableItemsUnsentChecked = this.setMainTableItemsUnsentChecked.bind(this);
        this.setMainTableItemsUnsentUnchecked = this.setMainTableItemsUnsentUnchecked.bind(this);
        this.setMainTableItemsLateCustomersChecked = this.setMainTableItemsLateCustomersChecked.bind(this);
        this.setMainTableItemsLateCustomersUnchecked = this.setMainTableItemsLateCustomersUnchecked.bind(this);
        this.setMainTableItemsActiveCustomersChecked = this.setMainTableItemsActiveCustomersChecked.bind(this);
        this.setMainTableItemsActiveCustomersUnchecked = this.setMainTableItemsActiveCustomersUnchecked.bind(this);
        this.unsetUnsentAndLateAndActiveCustomersCheckedIfNeeded = this.unsetUnsentAndLateAndActiveCustomersCheckedIfNeeded.bind(this);
        const table_items_filters = {
            etourism_statuses: [
                'none',
                'waiting',
                'failure'
            ],
            checked_out: 0,
            id_no: [],
            zst: '',
            name_surname: '',
            dt_roj: null,
            sp: 0,
            drzava: [],
            vrsta_dok: [],
            id_st_dok: '',
            cas_prihoda_range: [
                (0, _momentDefault.default)().toDate(),
                null
            ],
            cas_odhoda_range: [
                null,
                null
            ],
            status: 0,
            tt_obracun: []
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'cas_prihoda',
            table_items_sort_direction: 'DESC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'cas_prihoda',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            item_delete_requested: null,
            date_range_picker_dialog_open: false,
            date_range_picker_dialog_filter_name: null,
            table_items_checked_ids: {},
            id_reservation_customers_by_id_guest_book: this.generateReservationCustomersByIdGuestBook(this.props.reservation_customers),
            reservation_dialog_open: false,
            reservation_dialog_id_reservation: -1,
            reservation_dialog_id_reservation_customer: -1,
            date_picker_dialog_open: false,
            date_picker_dialog_initial_date: null,
            date_picker_dialog_id_reservation_customers: [],
            unsent_customers_selected: false,
            late_customers_selected: false,
            active_customers_selected: false
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.guest_book_items != this.state.table_items) {
            let new_state = {
                ...this.state,
                ...this.updateTableItemsFromProps(this.props, this.state)
            };
            if (this.state.unsent_customers_selected) new_state = this.setMainTableItemsUnsentChecked(new_state, true);
            if (this.state.late_customers_selected) new_state = this.setMainTableItemsLateCustomersChecked(new_state, true);
            if (this.state.active_customers_selected) new_state = this.setMainTableItemsActiveCustomersChecked(new_state, true);
            this.setState(new_state);
        }
        if (this.props.reservation_customers != prevProps.reservation_customers) {
            let new_state = {
                ...this.state,
                id_reservation_customers_by_id_guest_book: this.generateReservationCustomersByIdGuestBook(this.props.reservation_customers)
            };
            if (this.state.unsent_customers_selected) new_state = this.setMainTableItemsUnsentChecked(new_state, true);
            if (this.state.late_customers_selected) new_state = this.setMainTableItemsLateCustomersChecked(new_state, true);
            if (this.state.active_customers_selected) new_state = this.setMainTableItemsActiveCustomersChecked(new_state, true);
            this.setState(new_state);
        }
    }
    updateTableItemsFromProps(props, state) {
        const ids = Object.keys(props.guest_book_items);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            table_items: props.guest_book_items,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const identification_types_by_internal_codes = {};
        for(let id_identification_type in this.props.identification_types)identification_types_by_internal_codes[this.props.identification_types[id_identification_type].internal_code] = this.props.identification_types[id_identification_type];
        const tourist_taxes_by_internal_codes = {};
        for(let id_tourist_tax in this.props.tourist_taxes)tourist_taxes_by_internal_codes[this.props.tourist_taxes[id_tourist_tax].internal_code] = this.props.tourist_taxes[id_tourist_tax];
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            a = state.table_items[a_key].etourism_status;
            b = state.table_items[b_key].etourism_status;
            const both_waiting = a == b;
            const none_waiting = a != 'waiting' && b != 'waiting';
            if (a == 'waiting' && b != 'waiting') {
                a = 0;
                b = 1 * (dir == 'ASC' ? 1 : -1);
            } else if (a != 'waiting' && b == 'waiting') {
                a = 1 * (dir == 'ASC' ? 1 : -1);
                b = 0;
            }
            // sort secondarily by existence of zst
            if (a == b) {
                a = state.table_items[a_key].zst === null ? 0 : dir == 'ASC' ? 1 : -1;
                b = state.table_items[b_key].zst === null ? 0 : dir == 'ASC' ? 1 : -1;
            }
            if (both_waiting || none_waiting) {
                if (field == 'checked_out') {
                    const a_id_reservation_customer = this.state.id_reservation_customers_by_id_guest_book[state.table_items[a_key].id_guest_book];
                    const a_reservation_customer = a_id_reservation_customer === undefined ? null : this.props.reservation_customers[a_id_reservation_customer];
                    a = a_reservation_customer === null ? false : a_reservation_customer.checked_out;
                    const b_id_reservation_customer = this.state.id_reservation_customers_by_id_guest_book[state.table_items[b_key].id_guest_book];
                    const b_reservation_customer = b_id_reservation_customer === undefined ? null : this.props.reservation_customers[b_id_reservation_customer];
                    b = b_reservation_customer === null ? false : b_reservation_customer.checked_out;
                } else if (field == 'name_surname') {
                    const item_a = state.table_items[a_key];
                    const item_b = state.table_items[b_key];
                    a = item_a.ime + ' ' + item_a.pri;
                    b = item_b.ime + ' ' + item_b.pri;
                    return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
                } else if (field == 'sp') {
                    a = state.table_items[a_key].sp == 'M' ? 'M' : "\u017D";
                    b = state.table_items[b_key].sp == 'M' ? 'M' : "\u017D";
                } else if (field == 'vrsta_dok') {
                    a = identification_types_by_internal_codes[state.table_items[a_key].vrsta_dok].title;
                    b = identification_types_by_internal_codes[state.table_items[b_key].vrsta_dok].title;
                } else if (field == 'night_count') {
                    const item_a = state.table_items[a_key];
                    const item_b = state.table_items[b_key];
                    a = (0, _momentDefault.default)(item_a.cas_odhoda).set('second', 0).set('minute', 0).set('hour', 12).diff((0, _momentDefault.default)(item_a.cas_prihoda).set('second', 0).set('minute', 0).set('hour', 12), 'days');
                    b = (0, _momentDefault.default)(item_b.cas_odhoda).set('second', 0).set('minute', 0).set('hour', 12).diff((0, _momentDefault.default)(item_b.cas_prihoda).set('second', 0).set('minute', 0).set('hour', 12), 'days');
                } else if (field == 'tt_obracun') {
                    a = tourist_taxes_by_internal_codes[state.table_items[a_key].tt_obracun].title;
                    b = tourist_taxes_by_internal_codes[state.table_items[b_key].tt_obracun].title;
                } else {
                    a = state.table_items[a_key][field];
                    b = state.table_items[b_key][field];
                }
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filter_etourism_statuses = filters.etourism_statuses;
        const filter_checked_out = filters.checked_out;
        const filter_id_no = filters.id_no;
        const filter_zst = filters.zst;
        const filter_name_surname = filters.name_surname.toUpperCase();
        const filter_dt_roj = filters.dt_roj;
        const filter_sp = filters.sp;
        const filter_drzava = filters.drzava;
        const filter_vrsta_dok = filters.vrsta_dok;
        const filter_id_st_dok = filters.id_st_dok.toUpperCase();
        const filter_cas_prihoda_start = filters.cas_prihoda_range[0] === null ? null : this.toIsoString(filters.cas_prihoda_range[0]);
        const filter_cas_prihoda_end = filters.cas_prihoda_range[1] === null ? null : this.toIsoString(filters.cas_prihoda_range[1]);
        const filter_cas_odhoda_start = filters.cas_odhoda_range[0] === null ? null : this.toIsoString(filters.cas_odhoda_range[0]);
        const filter_cas_odhoda_end = filters.cas_odhoda_range[1] === null ? null : this.toIsoString(filters.cas_odhoda_range[1]);
        const filter_status = filters.status;
        const filter_tt_obracun = filters.tt_obracun;
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filter_etourism_statuses.length > 0 && !filter_etourism_statuses.some((x)=>x == item.etourism_status)) return false;
            if (filter_checked_out !== 0) {
                const id_reservation_customer = this.state.id_reservation_customers_by_id_guest_book[id];
                const reservation_customer = id_reservation_customer === undefined ? null : this.props.reservation_customers[id_reservation_customer];
                const checked_out = reservation_customer === null ? null : reservation_customer.checked_out;
                if (checked_out === null || checked_out === true && filter_checked_out === -1 || checked_out === false && filter_checked_out === 1) return false;
            }
            if (filter_id_no.length > 0 && !filter_id_no.some((x)=>x == item.id_no)) return false;
            if (filter_zst != '' && (item.zst === null || item.zst.toString().indexOf(filter_zst) == -1)) return false;
            if (filter_name_surname != '' && (item.ime + ' ' + item.pri).toUpperCase().indexOf(filter_name_surname) == -1) return false;
            if (filter_dt_roj != null && item.dt_roj != this.toIsoString(filter_dt_roj)) return false;
            if (filter_sp !== 0) {
                if (item.sp === 'M' && filter_sp === -1 || item.sp === 'F' && filter_sp === 1) return false;
            }
            if (filter_drzava.length > 0 && !filter_drzava.some((x)=>x == item.drzava)) return false;
            if (filter_vrsta_dok.length > 0 && !filter_vrsta_dok.some((x)=>x == item.vrsta_dok)) return false;
            if (filter_id_st_dok != '' && item.id_st_dok.toUpperCase().indexOf(filter_id_st_dok) == -1) return false;
            if (filter_cas_prihoda_start !== null && item.cas_prihoda !== null && this.toIsoString(new Date(item.cas_prihoda)) < filter_cas_prihoda_start) return false;
            if (filter_cas_prihoda_end !== null && item.cas_prihoda !== null && this.toIsoString(new Date(item.cas_prihoda)) > filter_cas_prihoda_end) return false;
            if (filter_cas_odhoda_start !== null && item.cas_odhoda !== null && this.toIsoString(new Date(item.cas_odhoda)) < filter_cas_odhoda_start) return false;
            if (filter_cas_odhoda_end !== null && item.cas_odhoda !== null && this.toIsoString(new Date(item.cas_odhoda)) > filter_cas_odhoda_end) return false;
            if (filter_status !== 0) {
                if (item.status === 1 && filter_status === -1 || item.status === 2 && filter_status === 1) return false;
            }
            if (filter_tt_obracun.length > 0 && !filter_tt_obracun.some((x)=>x == item.tt_obracun)) return false;
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            etourism_statuses: this.state.table_items_filters.etourism_statuses,
            checked_out: this.state.table_items_filters.checked_out,
            id_no: this.state.table_items_filters.id_no,
            zst: this.state.table_items_filters.zst,
            name_surname: this.state.table_items_filters.name_surname,
            dt_roj: this.state.table_items_filters.dt_roj,
            sp: this.state.table_items_filters.sp,
            drzava: this.state.table_items_filters.drzava,
            vrsta_dok: this.state.table_items_filters.vrsta_dok,
            id_st_dok: this.state.table_items_filters.id_st_dok,
            cas_prihoda_range: this.state.table_items_filters.cas_prihoda_range,
            cas_odhoda_range: this.state.table_items_filters.cas_odhoda_range,
            status: this.state.table_items_filters.status,
            tt_obracun: this.state.table_items_filters.tt_obracun
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
    }
    deleteItem(item) {
        this.setState({
            item_delete_requested: item,
            token: this.props.token
        });
    }
    openDateRangePickerDialog(filter_name) {
        this.setState({
            date_range_picker_dialog_open: true,
            date_range_picker_dialog_filter_name: filter_name
        });
    }
    closeDateRangePickerDialog(start_date, end_date) {
        this.setState({
            date_range_picker_dialog_open: false
        });
        if (start_date !== undefined && end_date !== undefined) this.handleFilterChange(this.state.date_range_picker_dialog_filter_name, [
            start_date,
            end_date === null ? start_date : end_date
        ]);
    }
    generateReservationCustomersByIdGuestBook(reservation_customers) {
        const items = {};
        for(let id_reservation_customer in reservation_customers){
            const reservation_customer = reservation_customers[id_reservation_customer];
            if (reservation_customer.id_guest_book !== null) items[reservation_customer.id_guest_book] = id_reservation_customer;
        }
        return items;
    }
    openReservationDialog(id_reservation_customer) {
        this.setState({
            reservation_dialog_open: true,
            reservation_dialog_id_reservation: this.props.reservation_customers[id_reservation_customer].id_reservation,
            reservation_dialog_id_reservation_customer: id_reservation_customer
        });
    }
    closeReservationDialog() {
        this.setState({
            reservation_dialog_open: false,
            reservation_dialog_id_reservation: -1,
            reservation_dialog_id_reservation_customer: -1
        });
    }
    getResetState(set_to_original) {
        set_to_original = set_to_original || false;
        const new_state = {
            table_items: this.props.guest_book_items,
            table_items_sort_ids: [],
            table_items_filtered_ids: [],
            table_items_sort_field: this.state.table_items_sort_field,
            table_items_sort_direction: this.state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(set_to_original ? this.state.original_table_items_filters : {
            etourism_statuses: [],
            checked_out: 0,
            id_no: [],
            zst: '',
            name_surname: '',
            dt_roj: null,
            sp: 0,
            drzava: [],
            vrsta_dok: [],
            id_st_dok: '',
            cas_prihoda_range: [
                null,
                null
            ],
            cas_odhoda_range: [
                null,
                null
            ],
            status: 0,
            tt_obracun: []
        }, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setMainTableItemsUnsentChecked(state, return_only) {
        state = state || this.state;
        return_only = return_only || false;
        const new_state = this.getResetState();
        const table_items_checked_ids = {};
        for(let i = 0; i < new_state.table_items_sort_ids.length; i++){
            const id = new_state.table_items_sort_ids[i];
            if (new_state.table_items[id].zst === null || new_state.table_items[id].etourism_status == 'waiting') table_items_checked_ids[id] = true;
        }
        new_state.table_items_checked_ids = table_items_checked_ids;
        new_state.table_items_filtered_ids = Object.keys(table_items_checked_ids);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, new_state.table_items_filtered_ids, {
            table_items_filtered_ids: new_state.table_items_filtered_ids,
            table_items_filters: new_state.table_items_filters,
            table_items: state.table_items
        }, true);
        new_state.table_items_sort_ids = table_items_sort_ids;
        new_state.unsent_customers_selected = true;
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    setMainTableItemsLateCustomersChecked(state, return_only) {
        state = state || this.state;
        return_only = return_only || false;
        let new_state = this.getResetState();
        const now = new Date();
        const table_items_checked_ids = {};
        for(let i = 0; i < new_state.table_items_sort_ids.length; i++){
            const id = new_state.table_items_sort_ids[i];
            if (state.id_reservation_customers_by_id_guest_book === undefined) {
                console.log('id_reservation_customers_by_id_guest_book is undefined, but should not be');
                continue;
            }
            const id_reservation_customer = state.id_reservation_customers_by_id_guest_book[id];
            const reservation_customer = id_reservation_customer === undefined ? null : this.props.reservation_customers[id_reservation_customer];
            const checked_out = reservation_customer === null ? null : reservation_customer.checked_out;
            if (checked_out === false && new Date(new_state.table_items[id].cas_odhoda) < now) table_items_checked_ids[id] = true;
        }
        new_state.table_items_checked_ids = table_items_checked_ids;
        new_state.table_items_filtered_ids = Object.keys(table_items_checked_ids);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, new_state.table_items_filtered_ids, {
            table_items_filtered_ids: new_state.table_items_filtered_ids,
            table_items_filters: new_state.table_items_filters,
            table_items: state.table_items
        }, true);
        new_state.table_items_sort_ids = table_items_sort_ids;
        new_state.late_customers_selected = true;
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    setMainTableItemsActiveCustomersChecked(state, return_only) {
        state = state || this.state;
        return_only = return_only || false;
        let new_state = this.getResetState();
        const today_iso = (0, _momentDefault.default)().format();
        const table_items_checked_ids = {};
        for(let i = 0; i < new_state.table_items_sort_ids.length; i++){
            const id = new_state.table_items_sort_ids[i];
            if (state.id_reservation_customers_by_id_guest_book === undefined) {
                console.log('id_reservation_customers_by_id_guest_book is undefined, but should not be');
                continue;
            }
            const id_reservation_customer = state.id_reservation_customers_by_id_guest_book[id];
            const reservation_customer = id_reservation_customer === undefined ? null : this.props.reservation_customers[id_reservation_customer];
            const checked_out = reservation_customer === null ? null : reservation_customer.checked_out;
            if (checked_out === false && (0, _momentDefault.default)(new_state.table_items[id].cas_prihoda).format() <= today_iso && (0, _momentDefault.default)(new_state.table_items[id].cas_odhoda).format() >= today_iso) table_items_checked_ids[id] = true;
        }
        new_state.table_items_checked_ids = table_items_checked_ids;
        new_state.table_items_filtered_ids = Object.keys(table_items_checked_ids);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, new_state.table_items_filtered_ids, {
            table_items_filtered_ids: new_state.table_items_filtered_ids,
            table_items_filters: new_state.table_items_filters,
            table_items: state.table_items
        }, true);
        new_state.table_items_sort_ids = table_items_sort_ids;
        new_state.active_customers_selected = true;
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    setMainTableItemsUnsentUnchecked() {
        this.setState({
            unsent_customers_selected: false,
            table_items_checked_ids: {},
            ...this.getResetState(true)
        });
    }
    setMainTableItemsLateCustomersUnchecked() {
        this.setState({
            late_customers_selected: false,
            table_items_checked_ids: {},
            ...this.getResetState(true)
        });
    }
    setMainTableItemsActiveCustomersUnchecked() {
        this.setState({
            active_customers_selected: false,
            table_items_checked_ids: {},
            ...this.getResetState(true)
        });
    }
    unsetUnsentAndLateAndActiveCustomersCheckedIfNeeded() {
        if (this.state.late_customers_selected) this.setMainTableItemsLateCustomersUnchecked();
        if (this.state.unsent_customers_selected) this.setMainTableItemsUnsentUnchecked();
        if (this.state.active_customers_selected) this.setMainTableItemsActiveCustomersUnchecked();
    }
    async checkOutCustomers(id_reservation_customers, set_check_out_to_now) {
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        const customers = id_reservation_customers.map((id_reservation_customer)=>{
            const reservation_customer = {
                ...this.props.reservation_customers[id_reservation_customer]
            };
            if (set_check_out_to_now) reservation_customer.check_out = (0, _momentDefault.default)().toISOString(true);
            reservation_customer.checked_out = true;
            return reservation_customer;
        });
        const new_items = await (0, _reservations.batchSaveReservationCustomer)(this.props.api_url, customers, token);
        dispatch((0, _reservationSlice.batchAddReservationCustomers)({
            items: new_items.reservation_customers,
            token
        }));
        dispatch((0, _guestSlice.batchAddGuestBookItems)({
            items: new_items.guest_book_items,
            token
        }));
        this.setState({
            table_items_checked_ids: {}
        });
        this.unsetUnsentAndLateAndActiveCustomersCheckedIfNeeded();
    }
    openDateTimePickerDialog(id_reservation_customers) {
        if (id_reservation_customers.length == 0) return;
        const reservation_customer = this.props.reservation_customers[id_reservation_customers[0]];
        const reservation = this.props.reservations[reservation_customer.id_reservation];
        const accommodation_item_place = this.props.accommodation_item_places[reservation.id_accommodation_item_place];
        const accommodation_item = this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
        const accommodation = this.props.accommodations[accommodation_item.id_accommodation];
        const initial_date = (0, _momentDefault.default)().add(1, 'day');
        const default_check_out_time = accommodation.default_check_out_time;
        const default_check_out_time_arr = default_check_out_time.split(':');
        if (default_check_out_time_arr.length == 3) {
            initial_date.hour(parseInt(default_check_out_time_arr[0], 10));
            initial_date.minute(parseInt(default_check_out_time_arr[1], 10));
        }
        this.setState({
            date_picker_dialog_open: true,
            date_picker_dialog_initial_date: initial_date.toDate(),
            date_picker_dialog_id_reservation_customers: id_reservation_customers
        });
        this.unsetUnsentAndLateAndActiveCustomersCheckedIfNeeded();
    }
    async closeDateTimePickerDialog(newValue) {
        this.setState({
            date_picker_dialog_open: false
        });
        if (newValue instanceof Date) {
            const id_reservation_customers = this.state.date_picker_dialog_id_reservation_customers;
            const new_date = newValue;
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            const customers = id_reservation_customers.map((id_reservation_customer)=>{
                const reservation_customer = {
                    ...this.props.reservation_customers[id_reservation_customer]
                };
                const new_date_moment = (0, _momentDefault.default)(new_date);
                new_date_moment.second(0);
                reservation_customer.check_out = new_date_moment.toISOString(true);
                return reservation_customer;
            });
            const new_items = await (0, _reservations.batchSaveReservationCustomer)(this.props.api_url, customers, token);
            dispatch((0, _reservationSlice.batchAddReservationCustomers)({
                items: new_items.reservation_customers,
                token
            }));
            dispatch((0, _guestSlice.batchAddGuestBookItems)({
                items: new_items.guest_book_items,
                token
            }));
        }
        this.setState({
            table_items_checked_ids: {}
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('etourism--guest-book') === -1) return null;
        const selected_id_reservation_customers = [];
        const selected_id_reservation_customers_not_checked_out = [];
        let can_log_out_customers = true;
        for(let i = 0; i < this.state.table_items_sort_ids.length; i++){
            const id_guest_book = this.state.table_items_sort_ids[i];
            const id_reservation_customer = this.state.id_reservation_customers_by_id_guest_book[id_guest_book];
            if (this.state.table_items_checked_ids[id_guest_book] === true && id_reservation_customer !== undefined) {
                selected_id_reservation_customers.push(id_reservation_customer);
                if (this.props.reservation_customers[id_reservation_customer].checked_out !== true) selected_id_reservation_customers_not_checked_out.push(id_reservation_customer);
                const guest = this.props.guest_book_items[id_guest_book];
                console.log({
                    guest,
                    zst: guest.zst
                });
                if (guest === null || guest.zst === null) can_log_out_customers = false;
            }
        }
        const checked_ids = [];
        for(let id_guest_book in this.state.table_items_checked_ids)if (this.state.table_items_checked_ids[id_guest_book] === true) checked_ids.push(id_guest_book);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                this.state.item_delete_requested === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        //this.props.dispatch(deleteItem(this.state.item_delete_requested.id_item));
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            item_delete_requested: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.reservation_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reservationDefault.default), {
                    closeReservation: this.closeReservationDialog,
                    deleteReservation: null,
                    reservation: this.props.reservations[this.state.reservation_dialog_id_reservation],
                    open_id_reservation_customer: this.state.reservation_dialog_id_reservation_customer
                }),
                !this.state.date_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePickerDialogDefault.default), {
                    closeDateTimePickerDialog: this.closeDateTimePickerDialog,
                    value: this.state.date_picker_dialog_initial_date
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow guest-book-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "align-middle mr-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "multi-select",
                                            className: "w-40",
                                            onClick: ()=>{
                                                if (this.state.unsent_customers_selected) this.setMainTableItemsUnsentUnchecked();
                                                else this.setMainTableItemsUnsentChecked();
                                            },
                                            disabled: this.state.late_customers_selected || this.state.active_customers_selected,
                                            children: this.state.unsent_customers_selected ? "Po\u010Disti filter" : 'Izberi neposlane'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "multi-select",
                                            className: "w-56",
                                            onClick: ()=>{
                                                if (this.state.late_customers_selected) this.setMainTableItemsLateCustomersUnchecked();
                                                else this.setMainTableItemsLateCustomersChecked();
                                            },
                                            disabled: this.state.unsent_customers_selected || this.state.active_customers_selected,
                                            children: this.state.late_customers_selected ? "Po\u010Disti filter" : "Izberi in prika\u017Ei zamudnike"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "multi-select",
                                            className: "w-48",
                                            onClick: ()=>{
                                                if (this.state.active_customers_selected) this.setMainTableItemsActiveCustomersUnchecked();
                                                else this.setMainTableItemsActiveCustomersChecked();
                                            },
                                            disabled: this.state.late_customers_selected || this.state.unsent_customers_selected,
                                            children: this.state.active_customers_selected ? "Po\u010Disti filter" : 'Trenutni gosti'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(UploadButton, {
                                    checked_ids: checked_ids,
                                    guest_book_items: this.props.guest_book_items,
                                    dispatch: this.props.dispatch,
                                    token: this.props.token,
                                    api_url: this.props.api_url,
                                    finished: ()=>{
                                        this.setState({
                                            table_items_checked_ids: {}
                                        });
                                        this.unsetUnsentAndLateAndActiveCustomersCheckedIfNeeded();
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "print",
                                            onClick: ()=>{},
                                            children: "Natisni knjigo gostov"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "cloud-download",
                                            className: "w-40",
                                            onClick: ()=>{
                                                if (checked_ids.length > 0) {
                                                    const checked_ids_joined = checked_ids.join(',');
                                                    const id_rnos = Object.values(this.props.accommodations).map((x)=>x.etourism_id_rno).join(',');
                                                    const params = [
                                                        'id_rnos=' + id_rnos
                                                    ];
                                                    const data = {
                                                        ids: checked_ids_joined
                                                    };
                                                    const form = document.createElement('form');
                                                    form.target = '_blank';
                                                    form.method = 'POST';
                                                    form.action = this.props.api_url + 'Guests/v1/export-guest-book-to-excel?' + params.join('&');
                                                    form.style.display = 'none';
                                                    for(let key in data){
                                                        const input = document.createElement('input');
                                                        input.type = 'hidden';
                                                        input.name = key;
                                                        input.value = data[key];
                                                        form.appendChild(input);
                                                    }
                                                    document.body.appendChild(form);
                                                    form.submit();
                                                    document.body.removeChild(form);
                                                } else {
                                                    const cas_prihoda_from = this.state.table_items_filters.cas_prihoda_range[0] === null ? null : (0, _momentDefault.default)(this.state.table_items_filters.cas_prihoda_range[0]).format('YYYY-MM-DD');
                                                    const cas_prihoda_until = this.state.table_items_filters.cas_prihoda_range[1] === null ? null : (0, _momentDefault.default)(this.state.table_items_filters.cas_prihoda_range[1]).format('YYYY-MM-DD');
                                                    const cas_odhoda_from = this.state.table_items_filters.cas_odhoda_range[0] === null ? null : (0, _momentDefault.default)(this.state.table_items_filters.cas_odhoda_range[0]).format('YYYY-MM-DD');
                                                    const cas_odhoda_until = this.state.table_items_filters.cas_odhoda_range[1] === null ? null : (0, _momentDefault.default)(this.state.table_items_filters.cas_odhoda_range[1]).format('YYYY-MM-DD');
                                                    const id_rnos = (this.state.table_items_filters.id_no.length > 0 ? this.state.table_items_filters.id_no : Object.values(this.props.accommodations).map((x)=>x.etourism_id_rno).filter((x)=>x > 0)).join(',');
                                                    const params = [
                                                        'date_check_in_from=' + (cas_prihoda_from === null ? '' : cas_prihoda_from),
                                                        'date_check_in_until=' + (cas_prihoda_until === null ? '' : cas_prihoda_until),
                                                        'date_check_out_from=' + (cas_odhoda_from === null ? '' : cas_odhoda_from),
                                                        'date_check_out_until=' + (cas_odhoda_until === null ? '' : cas_odhoda_until),
                                                        'id_rnos=' + id_rnos
                                                    ];
                                                    window.open(this.props.api_url + 'Guests/v1/export-guest-book-to-excel?' + params.join('&'));
                                                }
                                            },
                                            disabled: (this.state.unsent_customers_selected || this.state.late_customers_selected || this.state.active_customers_selected) && checked_ids.length == 0,
                                            children: "Izvoz v Excel"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                            className: "ml-2 align-middle"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "log-out",
                                            onClick: ()=>{
                                                this.checkOutCustomers(selected_id_reservation_customers, true);
                                            },
                                            disabled: selected_id_reservation_customers == 0 || !can_log_out_customers,
                                            children: "Odjavi s trenutnim datumom/\u010Dasom"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "log-out",
                                            onClick: ()=>{
                                                this.checkOutCustomers(selected_id_reservation_customers, false);
                                            },
                                            disabled: selected_id_reservation_customers == 0 || !can_log_out_customers,
                                            children: "Ozna\u010Di kot odjavljen"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "arrows-horizontal",
                                            onClick: ()=>{
                                                this.openDateTimePickerDialog(selected_id_reservation_customers_not_checked_out);
                                            },
                                            disabled: selected_id_reservation_customers_not_checked_out == 0,
                                            children: "Podalj\u0161aj odjavo"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openReservationDialog: this.openReservationDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    measuring_units: this.props.measuring_units,
                                    tourist_taxes: this.props.tourist_taxes,
                                    identification_types: this.props.identification_types,
                                    countries: this.props.countries,
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    id_reservation_customers_by_id_guest_book: this.state.id_reservation_customers_by_id_guest_book,
                                    reservation_customers: this.props.reservation_customers,
                                    accommodations: this.props.accommodations,
                                    disable_filters: this.state.late_customers_selected || this.state.unsent_customers_selected || this.state.active_customers_selected
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
GuestBook.propTypes = {};
function mapStateToProps(state) {
    return {
        guest_book_items: state.GuestSlice.guest_book_items,
        reservation_customers: state.ReservationSlice.reservation_customers,
        reservations: state.ReservationSlice.reservations,
        reservation_customers_by_id_reservations: state.ReservationSlice.reservation_customers_by_id_reservations,
        measuring_units: state.CodeTablesSlice.measuring_units,
        tax_rates: state.CodeTablesSlice.tax_rates,
        tourist_taxes: state.CodeTablesSlice.tourist_taxes,
        identification_types: state.CodeTablesSlice.identification_types,
        accommodations: state.CodeTablesSlice.accommodations,
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        countries: state.CodeTablesSlice.countries,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        api_url: state.GuestSlice.api_url
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(GuestBook);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","react-bus":"azSKq","@blueprintjs/core":"6Mq52","moment":"1e4qG","../code_tables/ResultComponents":"1eVlZ","../reservations/Reservation":"a8Yu8","../DateTimePickerDialog":"5awK0","../../slices/ReservationSlice":"kTPna","../../slices/GuestSlice":"bE5rS","../../api/Reservations":"8B3n3","../../api/Guests":"8327Q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzqJD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _guests = require("../../api/Guests");
var _addMonthlyGuestBookReportDialog = require("./AddMonthlyGuestBookReportDialog");
var _addMonthlyGuestBookReportDialogDefault = parcelHelpers.interopDefault(_addMonthlyGuestBookReportDialog);
var _resultComponents = require("../code_tables/ResultComponents");
const monthly_titles = {
    1: 'januar',
    2: 'februar',
    3: 'marec',
    4: 'april',
    5: 'maj',
    6: 'junij',
    7: 'julij',
    8: 'avgust',
    9: 'september',
    10: 'oktober',
    11: 'november',
    12: 'december'
};
const etourism_statuses = {
    none: 'NEPOSLAN',
    waiting: "\u010CAKA NA PO\u0160ILJANJE",
    success: "POSLANO USPE\u0160NO",
    failure: "NAPAKA PRI PO\u0160ILJANJU"
};
function Results(props) {
    const { table_items, table_items_sort_ids, tableItemsFilters, handleFilterChange, users, payment_types, accommodations } = props;
    const users_with_titles = {};
    for(let id_user in users)users_with_titles[id_user] = {
        id_user,
        title: users[id_user].name + ' ' + users[id_user].surname
    };
    const payment_types_with_titles = {};
    for(let id_payment_type in payment_types)payment_types_with_titles[id_payment_type] = {
        id_payment_type,
        title: payment_types[id_payment_type].title
    };
    const etourism_status_items = {
        none: {
            title: 'Neposlan',
            value: 'none'
        },
        waiting: {
            title: "\u010Caka na po\u0161iljanje",
            value: 'waiting'
        },
        success: {
            title: "Poslano uspe\u0161no",
            value: 'success'
        },
        failure: {
            title: "Napaka pri po\u0161iljanju",
            value: 'failure'
        }
    };
    const accommodations_by_id_nos = {};
    for(let id_accommodation in accommodations){
        const accommodation = accommodations[id_accommodation];
        if (accommodation.etourism_id_rno === null || accommodation.etourism_id_rno == 0 || accommodation.etourism_id_rno === undefined) continue;
        accommodations_by_id_nos[accommodation.etourism_id_rno] = accommodation;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-auto sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 2,
                            title: "Status"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 3,
                            title: "Leto"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 4,
                            title: "Mesec"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 5,
                            title: "idRNO"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 6,
                            title: "Status"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 7,
                            title: "Dod. le\u017Ei\u0161\u010Da"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 8,
                            title: "Prodane NE"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 9,
                            title: "Odprto \u0161t. dni"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "value",
                                    title_field: "title",
                                    items: etourism_status_items,
                                    filtered_keys: tableItemsFilters.etourism_statuses,
                                    onFilterChange: (values)=>handleFilterChange('etourism_statuses', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col"
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "search",
                                                    intent: "primary",
                                                    minimal: true,
                                                    small: true,
                                                    disabled: true,
                                                    onClick: ()=>{
                                                    //openAddEditItemDialog(item);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "trash",
                                                    intent: "danger",
                                                    minimal: true,
                                                    small: true,
                                                    disabled: true,
                                                    onClick: ()=>{
                                                    //TODO change
                                                    //deleteItem(id);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        child: etourism_statuses[item.etourism_status === null ? 'none' : item.etourism_status]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        child: item.year
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        child: monthly_titles[item.month]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        child: item.id_no + " \u2022 " + accommodations_by_id_nos[item.id_no].title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        child: item.etourism_report_status
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        child: item.extra_bed_count
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        child: item.sold_accommodation_unit_count
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        child: item.active_day_count
                                    })
                                ]
                            }, 'result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-sum pb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "col",
                    children: [
                        "\u0160tevilo zapisov: ",
                        table_items_sort_ids.length
                    ]
                })
            })
        ]
    });
}
class MonthlyGuestBookReports extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        const table_items_filters = {
            etourism_statuses: []
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'year-month-id_no',
            table_items_sort_direction: 'DESC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'year-month-id_no',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            saving: false,
            existing_item_warning_dialog_open: false,
            existing_item_warning_dialog_year: -1,
            existing_item_warning_dialog_month: -1,
            old_year_month_warning_dialog_open: false,
            warning_dialog_items: []
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    async closeAddEditItemDialog(items, force) {
        force = force === undefined ? false : force;
        if (items === null || items === undefined || items.length == 0) {
            this.setState({
                add_edit_item_dialog_open: false
            });
            return;
        }
        if (!force) {
            let warning_state = {};
            const year = items[0].year;
            const month = items[0].month;
            // check for 
            let found_year_month = false;
            for(let id_monthly_guest_book_report in this.props.monthly_guest_book_reports){
                const item = this.props.monthly_guest_book_reports[id_monthly_guest_book_report];
                if (item.year == year && item.month == month) {
                    found_year_month = true;
                    break;
                }
            }
            if (found_year_month) warning_state = {
                ...warning_state,
                existing_item_warning_dialog_open: true,
                existing_item_warning_dialog_year: year,
                existing_item_warning_dialog_month: month
            };
            if ((0, _momentDefault.default)().diff({
                year,
                month: month - 1
            }, 'months') > 1) warning_state = {
                ...warning_state,
                old_year_month_warning_dialog_open: true
            };
            if (Object.keys(warning_state).length > 0) {
                warning_state = {
                    ...warning_state,
                    warning_dialog_items: items
                };
                this.setState(warning_state);
                return;
            }
        }
        this.setState({
            saving: true
        });
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        for(let i = 0; i < items.length; i++)await (0, _guests.saveMonthlyGuestBookReport)(this.props.api_url, items[i], token);
        await (0, _guests.sendReservationCustomersToETourism)(this.props.api_url, token);
        (0, _guests.loadMonthlyGuestBookReports)(this.props.api_url, dispatch, token);
        this.setState({
            add_edit_item_dialog_open: false,
            saving: false
        });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.users != prevProps.users || this.props.monthly_guest_book_reports != prevProps.monthly_guest_book_reports) {
            const state = this.updateTableItemsFromProps(this.props, this.state);
            this.setState(state);
        }
    }
    updateTableItemsFromProps(props, state) {
        const ids = Object.keys(props.monthly_guest_book_reports);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        //TODO change
        const new_state = {
            invoices: props.invoices,
            table_items: props.monthly_guest_book_reports,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            a = state.table_items[a_key][field];
            b = state.table_items[b_key][field];
            if (field == 'year-month-id_no') {
                a = state.table_items[a_key]['year'] + '-' + (state.table_items[a_key]['month'] + '').padStart(2, '0') + '-' + (state.table_items[a_key]['id_no'] + '').padStart(20, '0');
                b = state.table_items[b_key]['year'] + '-' + (state.table_items[b_key]['month'] + '').padStart(2, '0') + '-' + (state.table_items[b_key]['id_no'] + '').padStart(20, '0');
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        //TODO change
        const filters_etourism_statuses = filters.etourism_statuses;
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_etourism_statuses.length > 0) {
                if (filters_etourism_statuses.indexOf(item.etourism_status) == -1) return false;
            }
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            etourism_statuses: this.state.table_items_filters.etourism_statuses
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('etourism--monthly-statistics') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addMonthlyGuestBookReportDialogDefault.default), {
                    closeDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: this.state.saving,
                    usePortal: true,
                    canOutsideClickClose: false,
                    canEscapeKeyClose: false,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex flex-col flex-grow",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_BODY,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ProgressBar), {
                                    animate: this.state.saving,
                                    intent: "primary"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-xl text-center font-light pt-5",
                                    children: "Shranjevanje"
                                })
                            ]
                        })
                    })
                }),
                !this.state.existing_item_warning_dialog_open && !this.state.old_year_month_warning_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Po\u0161lji poro\u010Dilo",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "warning-sign",
                    intent: (0, _core.Intent).WARNING,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.closeAddEditItemDialog(this.state.warning_dialog_items, true);
                        this.setState({
                            existing_item_warning_dialog_open: false,
                            old_year_month_warning_dialog_open: false
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            existing_item_warning_dialog_open: false,
                            old_year_month_warning_dialog_open: false
                        });
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            !this.state.existing_item_warning_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "p-1",
                                children: "Poro\u010Dilo za mesec " + monthly_titles[parseInt(this.state.existing_item_warning_dialog_month, 10)] + ' ' + this.state.existing_item_warning_dialog_year + " je \u017Ee bilo oddano. V kolikor ga \u017Eelite ponovno poslati, se bodo obstoje\u010Di podatki prepisali z novimi."
                            }),
                            !this.state.old_year_month_warning_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "Mese\u010Dno poro\u010Dilo je mo\u017Eno posredovati zgolj v omejenem obdobju."
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "Mese\u010Dno poro\u010Dilo za pretekle mesece (dovoljeno \u0161tevilo preteklih mesecev je 1), lahko oddate le do zadnjega dne v teko\u010Dem mesecu."
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "Mese\u010Dno poro\u010Dilo za teko\u010Di mesec, lahko oddate po prvem dnevu v teko\u010Dem mesecu."
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow base-list monthly-guest-book-report-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pl-4 pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                className: "align-middle",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "success",
                                    icon: "plus",
                                    onClick: ()=>this.openAddEditItemDialog(null),
                                    children: "Novo mese\u010Dno poro\u010Dilo"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    users: this.props.users,
                                    payment_types: this.props.payment_types,
                                    accommodations: this.props.accommodations
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
MonthlyGuestBookReports.propTypes = {};
function mapStateToProps(state) {
    return {
        api_url: state.CashRegisterSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        users: state.UserSlice.users,
        monthly_guest_book_reports: state.GuestSlice.monthly_guest_book_reports,
        accommodations: state.CodeTablesSlice.accommodations
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(MonthlyGuestBookReports);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","moment":"1e4qG","@blueprintjs/core":"6Mq52","../../api/Guests":"8327Q","./AddMonthlyGuestBookReportDialog":"kOPJO","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kOPJO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _appToaster = require("../AppToaster");
var _resultComponents = require("../code_tables/ResultComponents");
const eTourismReportStatuses = {
    '11': 'ODPRT - TURISTI SO PRIHAJALI',
    '12': 'ODPRT - TURISTOV NI BILO',
    '50': "ZA\u010CASNO ZAPRT - DRUGI RAZLOGI",
    '51': "ZA\u010CASNO ZAPRT - ADAPTACIJA",
    '54': "ZA\u010CASNO ZAPRT - SEZONSKA ZAPRTOST",
    '61': 'PRENEHANJE ODDAJANJA NASTANITVENIH KAPACITET TURISTOM',
    '62': "ZA\u010CASNO ZAPRT - NASTANITVENE KAPACITETE \u0160E V PRIPRAVI"
};
class AddMonthlyGuestBookReportDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.calculateUsedRooms = this.calculateUsedRooms.bind(this);
        const prev_month = (0, _momentDefault.default)().subtract(1, 'month');
        const year = prev_month.year();
        const month = prev_month.month() + 1;
        const day_count = new Date(year, month, 0).getDate();
        const used_count_by_id_accommodations = this.calculateUsedRooms(year + '-' + (month < 10 ? '0' + month : month) + '-01', year + '-' + (month < 10 ? '0' + month : month) + '-' + (day_count < 10 ? '0' + day_count : day_count));
        this.calculateUsedRooms('2021-01-01', '2021-09-15');
        const data_by_id_nos = {};
        for(let id_accommodation in props.accommodations){
            const id_no = props.accommodations[id_accommodation].etourism_id_rno;
            const accommodation = props.accommodations[id_accommodation];
            if (accommodation === undefined || accommodation.etourism_reporting !== true) continue;
            if (id_no === null || id_no == 0 || id_no === undefined) continue;
            data_by_id_nos[id_no] = {
                id_accommodation,
                checked: true,
                etourism_report_status: '11',
                extra_bed_count: 0,
                sold_accommodation_unit_count: used_count_by_id_accommodations[id_accommodation] || 0,
                active_day_count: day_count
            };
        }
        this.state = {
            year,
            month,
            data_by_id_nos
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.year != prevState.year || this.state.month != prevState.month) {
            const day_count = new Date(this.state.year, this.state.month, 0).getDate();
            const new_items = {
                ...this.state.data_by_id_nos
            };
            for(let id_no in new_items){
                new_items[id_no].active_day_count = day_count;
                new_items[id_no].sold_accommodation_unit_count = 0; // reset, so that we can set them again below
            }
            const used_count_by_id_accommodations = this.calculateUsedRooms(this.state.year + '-' + (this.state.month < 10 ? '0' + this.state.month : this.state.month) + '-01', this.state.year + '-' + (this.state.month < 10 ? '0' + this.state.month : this.state.month) + '-' + (day_count < 10 ? '0' + day_count : day_count));
            for(let id_accommodation in used_count_by_id_accommodations){
                const id_no = this.props.accommodations[id_accommodation].etourism_id_rno;
                const accommodation = this.props.accommodations[id_accommodation];
                if (accommodation === undefined || accommodation.etourism_reporting !== true) continue;
                if (id_no === null || id_no == 0 || id_no === undefined) continue;
                new_items[id_no].sold_accommodation_unit_count = used_count_by_id_accommodations[id_accommodation] || 0;
            }
            this.setState({
                data_by_id_nos: new_items
            });
        }
    }
    calculateUsedRooms(from_iso, until_iso) {
        const used_days_by_id_accommodations = {};
        for(let id_reservation in this.props.reservations){
            const reservation = this.props.reservations[id_reservation];
            if (reservation.deleted === true || reservation.status == 'not-for-rent') continue;
            const reservation_check_in_date_iso = (0, _momentDefault.default)(reservation.check_in).format('YYYY-MM-DD');
            const reservation_check_out_date_iso = (0, _momentDefault.default)(reservation.check_out).format('YYYY-MM-DD');
            if (reservation_check_out_date_iso < from_iso) continue;
            if (reservation_check_in_date_iso > until_iso) continue;
            const accommodation_item = this.props.accommodation_items[this.props.accommodation_item_places[reservation.id_accommodation_item_place].id_accommodation_item];
            if (accommodation_item === undefined) continue;
            const customers = this.props.reservation_customers_by_id_reservations[id_reservation];
            if (customers === undefined || customers.length == 0) continue;
            let reservation_matches = false;
            for(let id_reservation_customer in customers){
                const rc = customers[id_reservation_customer];
                if (rc.id_guest_book === null || rc.id_guest_book === undefined) continue;
                const guest_book = this.props.guest_book_items[rc.id_guest_book];
                if (guest_book !== undefined && guest_book.status == 1 /* check in */ ) {
                    reservation_matches = true;
                    break;
                }
            }
            if (!reservation_matches) continue;
            if (used_days_by_id_accommodations[reservation.id_accommodation_item_place] === undefined) used_days_by_id_accommodations[reservation.id_accommodation_item_place] = {};
            const reservation_length = Math.max(1, (0, _momentDefault.default)(reservation_check_out_date_iso).diff((0, _momentDefault.default)(reservation_check_in_date_iso), 'days'));
            let date = (0, _momentDefault.default)(reservation.check_in);
            for(let i = 0; i < reservation_length; i++){
                const date_iso = date.format('YYYY-MM-DD');
                if (date_iso >= from_iso && date_iso <= until_iso) {
                    if (used_days_by_id_accommodations[reservation.id_accommodation_item_place][date_iso] === undefined) used_days_by_id_accommodations[reservation.id_accommodation_item_place][date_iso] = 0;
                    used_days_by_id_accommodations[reservation.id_accommodation_item_place][date_iso]++;
                }
                date.add(1, 'day');
            }
        }
        const used_count_by_id_accommodations = {};
        const used_count_by_id_accommodation_items = {};
        for(let id_accommodation_item_place in used_days_by_id_accommodations){
            const accommodation_item_place = this.props.accommodation_item_places[id_accommodation_item_place];
            const id_accommodation_item = accommodation_item_place.id_accommodation_item;
            const accommodation_item = this.props.accommodation_items[id_accommodation_item];
            const id_accommodation = accommodation_item.id_accommodation;
            if (used_count_by_id_accommodation_items[id_accommodation_item] == undefined) used_count_by_id_accommodation_items[id_accommodation_item] = 0;
            if (used_count_by_id_accommodations[id_accommodation] === undefined) used_count_by_id_accommodations[id_accommodation] = 0;
            for(let date in used_days_by_id_accommodations[id_accommodation_item_place])if (used_days_by_id_accommodations[id_accommodation_item_place][date] > 0) {
                used_count_by_id_accommodation_items[id_accommodation_item]++;
                used_count_by_id_accommodations[id_accommodation]++;
            }
        }
        const used_count_by_id_accommodation_items_with_titles = {};
        for(let id_accommodation_item in used_count_by_id_accommodation_items)used_count_by_id_accommodation_items_with_titles[id_accommodation_item] = {
            count: used_count_by_id_accommodation_items[id_accommodation_item],
            title: this.props.accommodation_items[id_accommodation_item].title
        };
        console.log([
            from_iso,
            until_iso
        ]);
        console.log(used_count_by_id_accommodation_items_with_titles);
        return used_count_by_id_accommodations;
    }
    render() {
        const id_nos = Object.keys(this.state.data_by_id_nos);
        const check_count = id_nos.filter((id_no)=>this.state.data_by_id_nos[id_no].checked === true).length;
        const all_checked = id_nos.length == check_count;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "add-monthly-guest-book-report-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Mese\u010Dno poro\u010Dilo"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY + ' flex flex-col',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col flex-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "font-bold",
                                                    children: "Leto"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                        options: Object.keys(new Array(80).fill(1)).map((x)=>{
                                                            return {
                                                                value: 2000 + parseInt(x, 10),
                                                                label: 2000 + parseInt(x, 10)
                                                            };
                                                        }),
                                                        value: this.state.year,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                year: event.currentTarget.value
                                                            });
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "font-bold",
                                                    children: "Mesec"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                        options: [
                                                            {
                                                                value: 1,
                                                                label: 'januar'
                                                            },
                                                            {
                                                                value: 2,
                                                                label: 'februar'
                                                            },
                                                            {
                                                                value: 3,
                                                                label: 'marec'
                                                            },
                                                            {
                                                                value: 4,
                                                                label: 'april'
                                                            },
                                                            {
                                                                value: 5,
                                                                label: 'maj'
                                                            },
                                                            {
                                                                value: 6,
                                                                label: 'junij'
                                                            },
                                                            {
                                                                value: 7,
                                                                label: 'julij'
                                                            },
                                                            {
                                                                value: 8,
                                                                label: 'avgust'
                                                            },
                                                            {
                                                                value: 9,
                                                                label: 'september'
                                                            },
                                                            {
                                                                value: 10,
                                                                label: 'oktober'
                                                            },
                                                            {
                                                                value: 11,
                                                                label: 'november'
                                                            },
                                                            {
                                                                value: 12,
                                                                label: 'december'
                                                            }
                                                        ],
                                                        value: this.state.month,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                month: event.currentTarget.value
                                                            });
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mt-4 flex flex-col flex-1 self-stretch",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "base-list add-monthly-guest-book-report-dialog-documents-list flex-1 relative",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "results h-full relative",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "results-table overflow-y-auto sticky-header absolute max-h-full inset-x-0 top-0",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                        columnIdx: 1,
                                                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                            checked: check_count > 0,
                                                            indeterminate: !all_checked && check_count > 0,
                                                            onChange: (event)=>{
                                                                const new_items = {
                                                                    ...this.state.data_by_id_nos
                                                                };
                                                                for(const id_no in new_items)new_items[id_no].checked = event.target.checked;
                                                                this.setState({
                                                                    data_by_id_nos: new_items
                                                                });
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                        columnIdx: 2,
                                                        title: "ID RNO"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                        columnIdx: 3,
                                                        title: "Leto / mesec"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                        columnIdx: 4,
                                                        title: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                        columnIdx: 5,
                                                        title: "Dod. le\u017Ei\u0161\u010Da"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                        columnIdx: 6,
                                                        title: "Prodane NE"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                        columnIdx: 7,
                                                        title: "Odprto \u0161t. dni"
                                                    }),
                                                    Object.keys(this.state.data_by_id_nos).map((id_no)=>{
                                                        const item = this.state.data_by_id_nos[id_no];
                                                        const cls = item.checked ? '' : 'text-gray-500';
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                    columnIdx: 1,
                                                                    cls: cls,
                                                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                                        checked: item.checked,
                                                                        onChange: (event)=>{
                                                                            const new_items = {
                                                                                ...this.state.data_by_id_nos
                                                                            };
                                                                            new_items[id_no].checked = event.target.checked;
                                                                            this.setState({
                                                                                data_by_id_nos: new_items
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                    columnIdx: 2,
                                                                    cls: cls,
                                                                    child: id_no + " \u2022 " + this.props.accommodations[item.id_accommodation].title
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                    columnIdx: 3,
                                                                    cls: cls,
                                                                    child: this.state.year + ' / ' + this.state.month
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                    columnIdx: 4,
                                                                    cls: cls,
                                                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                                        options: Object.keys(eTourismReportStatuses).map((status)=>{
                                                                            return {
                                                                                value: status,
                                                                                label: status + " \u2022 " + eTourismReportStatuses[status]
                                                                            };
                                                                        }),
                                                                        value: item.etourism_report_status,
                                                                        disabled: !item.checked,
                                                                        onChange: (event)=>{
                                                                            const new_items = {
                                                                                ...this.state.data_by_id_nos
                                                                            };
                                                                            new_items[id_no].etourism_report_status = event.currentTarget.value;
                                                                            this.setState({
                                                                                data_by_id_nos: new_items
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                    columnIdx: 5,
                                                                    cls: cls,
                                                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                        type: "text",
                                                                        value: item.extra_bed_count,
                                                                        disabled: !item.checked,
                                                                        onChange: (event)=>{
                                                                            const value = event.target.value;
                                                                            const new_items = {
                                                                                ...this.state.data_by_id_nos
                                                                            };
                                                                            new_items[id_no].extra_bed_count = value;
                                                                            this.setState({
                                                                                data_by_id_nos: new_items
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                    columnIdx: 6,
                                                                    cls: cls,
                                                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                        type: "text",
                                                                        value: item.sold_accommodation_unit_count,
                                                                        disabled: !item.checked,
                                                                        onChange: (event)=>{
                                                                            const value = event.target.value;
                                                                            const new_items = {
                                                                                ...this.state.data_by_id_nos
                                                                            };
                                                                            new_items[id_no].sold_accommodation_unit_count = value;
                                                                            this.setState({
                                                                                data_by_id_nos: new_items
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                    columnIdx: 7,
                                                                    cls: cls,
                                                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                        type: "text",
                                                                        value: item.active_day_count,
                                                                        disabled: !item.checked,
                                                                        onChange: (event)=>{
                                                                            const value = event.target.value;
                                                                            const new_items = {
                                                                                ...this.state.data_by_id_nos
                                                                            };
                                                                            new_items[id_no].active_day_count = value;
                                                                            this.setState({
                                                                                data_by_id_nos: new_items
                                                                            });
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }, 'id-no-' + id_no);
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: this.props.item !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                intent: (0, _core.Intent).PRIMARY,
                                onClick: ()=>this.props.closeDialog(),
                                children: "Zapri"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        minimal: true,
                                        onClick: ()=>this.props.closeDialog(),
                                        children: "Prekli\u010Di"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: (0, _core.Intent).PRIMARY,
                                        onClick: ()=>{
                                            const invalid_values_length = Object.keys(this.state.data_by_id_nos).filter((id_no)=>this.state.data_by_id_nos[id_no].checked).filter((id_no)=>{
                                                if (isNaN(this.state.data_by_id_nos[id_no].extra_bed_count)) return true;
                                                if (isNaN(this.state.data_by_id_nos[id_no].sold_accommodation_unit_count)) return true;
                                                if (isNaN(this.state.data_by_id_nos[id_no].active_day_count)) return true;
                                                return false;
                                            }).length;
                                            if (invalid_values_length > 0) {
                                                (0, _appToaster.AppToaster).show({
                                                    message: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            children: "Vsaj ena od vpisanih vrednosti ni veljavna"
                                                        })
                                                    }),
                                                    intent: 'danger',
                                                    icon: 'issue'
                                                });
                                                return;
                                            }
                                            const items = Object.keys(this.state.data_by_id_nos).filter((id_no)=>this.state.data_by_id_nos[id_no].checked).map((id_no)=>{
                                                const item = this.state.data_by_id_nos[id_no];
                                                return {
                                                    id_monthly_guest_book_report: (0, _uuidDefault.default).v4(),
                                                    year: this.state.year,
                                                    month: this.state.month,
                                                    etourism_status: 'waiting',
                                                    etourism_report_status: item.etourism_report_status,
                                                    id_no: id_no,
                                                    extra_bed_count: item.extra_bed_count,
                                                    sold_accommodation_unit_count: item.sold_accommodation_unit_count,
                                                    active_day_count: item.active_day_count
                                                };
                                            });
                                            if (items.length == 0) {
                                                (0, _appToaster.AppToaster).show({
                                                    message: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            children: "Ozna\u010Dite vsaj en objekt"
                                                        })
                                                    }),
                                                    intent: 'danger',
                                                    icon: 'issue'
                                                });
                                                return;
                                            }
                                            this.props.closeDialog(items);
                                        },
                                        children: "Po\u0161lji poro\u010Dilo"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        });
    }
}
AddMonthlyGuestBookReportDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func
};
function mapStateToProps(state) {
    return {
        accommodations: state.CodeTablesSlice.accommodations,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
        guest_book_items: state.GuestSlice.guest_book_items,
        reservations: state.ReservationSlice.reservations,
        reservation_customers: state.ReservationSlice.reservation_customers,
        reservation_customers_by_id_reservations: state.ReservationSlice.reservation_customers_by_id_reservations
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddMonthlyGuestBookReportDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","uuid":"b52pV","@blueprintjs/core":"6Mq52","moment":"1e4qG","../AppToaster":"izixN","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cBLJ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _resultComponents = require("../code_tables/ResultComponents");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
class TouristTaxes extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.getIdRNOs = this.getIdRNOs.bind(this);
        this.mainFiltersValid = this.mainFiltersValid.bind(this);
        this.filterMainItems = this.filterMainItems.bind(this);
        const id_no_items = this.getIdRNOs();
        this.state = {
            main_filter__idrno: Object.keys(id_no_items).length == 1 ? [
                id_no_items[Object.keys(id_no_items)[0]].value
            ] : [],
            main_filter__date_range: [
                (0, _momentDefault.default)().subtract(1, 'month').startOf('month').toDate(),
                (0, _momentDefault.default)().subtract(1, 'month').endOf('month').add(1, 'day').toDate()
            ],
            main_table_items: null
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    getIdRNOs() {
        const id_no_items = {};
        for(let id_accommodation in this.props.accommodations){
            const accommodation_title = this.props.accommodations[id_accommodation].title;
            const id_rno = this.props.accommodations[id_accommodation].etourism_id_rno;
            if (id_rno === null || id_rno.length == 0) continue;
            if (id_no_items[id_rno] === undefined) id_no_items[id_rno] = {
                title: id_rno + " \u2022 " + accommodation_title,
                value: id_rno
            };
        }
        return id_no_items;
    }
    mainFiltersValid(state) {
        if (state.main_filter__idrno.length == 0) return false;
        if (state.main_filter__date_range[0] === null || state.main_filter__date_range[1] === null) return false;
        return true;
    }
    filterMainItems() {
        if (!this.mainFiltersValid(this.state)) return null;
        const items = {
            by_country: {},
            by_tourist_discount: {
                0: {
                    price_sum: 0,
                    night_count: 0
                },
                50: {
                    price_sum: 0,
                    night_count: 0
                },
                100: {
                    price_sum: 0,
                    night_count: 0
                }
            },
            domestic: {
                reservation_count: 0,
                night_count: 0
            },
            foreign: {
                reservation_count: 0,
                night_count: 0
            },
            total: {
                price_sum: 0,
                reservation_count: 0,
                night_count: 0
            }
        };
        const filter_from_date_iso = (0, _momentDefault.default)(this.state.main_filter__date_range[0]).format('YYYY-MM-DD');
        const filter_until_date_iso = (0, _momentDefault.default)(this.state.main_filter__date_range[1]).format('YYYY-MM-DD');
        for(let id_reservation_customer in this.props.reservation_customers){
            const reservation_customer = this.props.reservation_customers[id_reservation_customer];
            const customer = this.props.customers[reservation_customer.id_customer];
            const guest_book_item = this.props.guest_book_items[reservation_customer.id_guest_book];
            const tourist_tax = this.props.tourist_taxes[reservation_customer.id_tourist_tax];
            if (guest_book_item === undefined) {
                console.log('Guest book item empty for reservation customer ' + id_reservation_customer);
                continue;
            }
            if (reservation_customer.check_in > filter_until_date_iso || reservation_customer.check_out < filter_from_date_iso) continue;
            const reservation = this.props.reservations[reservation_customer.id_reservation];
            const accommodation_item_place = this.props.accommodation_item_places[reservation.id_accommodation_item_place];
            const accommodation_item = this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
            const accommodation = this.props.accommodations[accommodation_item.id_accommodation];
            if (this.state.main_filter__idrno.indexOf(accommodation.etourism_id_rno) == -1) continue;
            let is_check_in_inside_selected_date_range = true;
            let check_in = (0, _momentDefault.default)(reservation_customer.check_in).startOf('day');
            if (check_in.format('YYYY-MM-DD') < filter_from_date_iso) {
                check_in = (0, _momentDefault.default)(filter_from_date_iso).startOf('day');
                is_check_in_inside_selected_date_range = false;
            }
            let check_out = (0, _momentDefault.default)(reservation_customer.check_out).startOf('day');
            if (check_out.format('YYYY-MM-DD') > filter_until_date_iso) check_out = (0, _momentDefault.default)(filter_until_date_iso).startOf('day');
            const reservation_count = is_check_in_inside_selected_date_range ? 1 : 0;
            const reservation_length = check_out.diff(check_in, 'days');
            if (items.by_country[customer.id_country] === undefined) items.by_country[customer.id_country] = {
                reservation_count: 0,
                night_count: 0
            };
            items.by_country[customer.id_country].reservation_count += reservation_count;
            items.by_country[customer.id_country].night_count += reservation_length;
            if (customer.id_country == '3d9bf9d9-f261-4e82-9080-d67b62df7fcf' /* Slovenia */ ) {
                items.domestic.reservation_count += reservation_count;
                items.domestic.night_count += reservation_length;
            } else {
                items.foreign.reservation_count += reservation_count;
                items.foreign.night_count += reservation_length;
            }
            const discount = Math.round(tourist_tax.discount);
            const price = reservation_length * guest_book_item.tt_visina * (1 - tourist_tax.discount / 100);
            if (items.by_tourist_discount[discount] === undefined) items.by_tourist_discount[discount] = {
                price_sum: 0,
                night_count: 0
            };
            items.by_tourist_discount[discount].price_sum += price;
            items.by_tourist_discount[discount].night_count += reservation_length;
            items.total.price_sum += price;
            items.total.night_count += reservation_length;
            items.total.reservation_count += reservation_count;
        }
        this.setState({
            main_table_items: items
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('etourism--tourist-taxes') === -1) return null;
        const id_no_items = this.getIdRNOs();
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow base-list guest-tourist-taxes-list",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col items-start main-filters pl-4 pt-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row flex-wrap",
                                children: Object.values(id_no_items).map((item, idx)=>{
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                        className: "mr-4 mb-4",
                                        checked: this.state.main_filter__idrno.indexOf(item.value) > -1,
                                        label: item.title,
                                        onChange: (event)=>{
                                            const main_filter__idrno = [
                                                ...this.state.main_filter__idrno
                                            ];
                                            if (event.target.checked) {
                                                if (main_filter__idrno.indexOf(item.value) == -1) main_filter__idrno.push(item.value);
                                            } else if (main_filter__idrno.indexOf(item.value) > -1) main_filter__idrno.splice(main_filter__idrno.indexOf(item.value), 1);
                                            this.setState({
                                                main_filter__idrno
                                            });
                                        }
                                    }, 'idrno-' + item.value);
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                        label: "Obdobje",
                                        tooltip: "Za mese\u010Dni prikaz TT je pri obdobju potrebno izbrati prvi dan v mesecu (primer: 1.1.2021 do 1.2.2021)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                        filter_values: this.state.main_filter__date_range,
                                        original_start_date: null,
                                        original_end_date: null,
                                        onFilterChange: (values)=>{
                                            this.setState({
                                                main_filter__date_range: values
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-start pl-4 pb-4 mt-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                className: "w-32",
                                intent: "primary",
                                icon: "search",
                                disabled: !this.mainFiltersValid(this.state),
                                onClick: this.filterMainItems,
                                children: "Prika\u017Ei"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                className: "w-40 ml-2",
                                intent: "primary",
                                icon: "cloud-download",
                                disabled: !this.mainFiltersValid(this.state),
                                onClick: ()=>{
                                    const params = [
                                        'date_from=' + (0, _momentDefault.default)(this.state.main_filter__date_range[0]).format('YYYY-MM-DD'),
                                        'date_until=' + (0, _momentDefault.default)(this.state.main_filter__date_range[1]).format('YYYY-MM-DD'),
                                        'id_rnos=' + this.state.main_filter__idrno.join(',')
                                    ];
                                    window.open(this.props.api_url + 'Guests/v1/export-tourist-taxes-to-excel?' + params.join('&'));
                                },
                                children: "Izvoz v Excel"
                            })
                        ]
                    }),
                    this.state.main_table_items === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1 pl-4 pr-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-grow",
                            style: {
                                flexBasis: '0'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "by-countries-table",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "results",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "results-table without-vertical-lines",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                    columnIdx: 1,
                                                    title: "GOSTJE"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                    columnIdx: 2,
                                                    cls: "text-right",
                                                    title: "\u0160t. prihodov"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                    columnIdx: 3,
                                                    cls: "text-right",
                                                    title: "\u0160t. preno\u010Ditev"
                                                }),
                                                Object.values(this.props.countries).sort((a, b)=>a.common_name_local.localeCompare(b.common_name_local)).map((country)=>{
                                                    const item = this.state.main_table_items.by_country[country.id_country];
                                                    if (item === undefined) return null;
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                columnIdx: 1,
                                                                child: country.common_name_local
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                columnIdx: 2,
                                                                cls: "text-right",
                                                                child: item.reservation_count.toLocaleString(undefined, {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                columnIdx: 3,
                                                                cls: "text-right",
                                                                child: item.night_count.toLocaleString(undefined, {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })
                                                            })
                                                        ]
                                                    }, 'country-' + country.id_country);
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 1,
                                                    cls: "font-semibold",
                                                    child: 'SKUPAJ'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 2,
                                                    child: ''
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 3,
                                                    child: ''
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 1,
                                                    child: "Doma\u010Di"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 2,
                                                    cls: "font-semibold text-right",
                                                    child: this.state.main_table_items.domestic.reservation_count.toLocaleString(undefined, {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 3,
                                                    cls: "font-semibold text-right",
                                                    child: this.state.main_table_items.domestic.night_count.toLocaleString(undefined, {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 1,
                                                    child: 'Tuji skupaj'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 2,
                                                    cls: "font-semibold text-right",
                                                    child: this.state.main_table_items.foreign.reservation_count.toLocaleString(undefined, {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 3,
                                                    cls: "font-semibold text-right",
                                                    child: this.state.main_table_items.foreign.night_count.toLocaleString(undefined, {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 1,
                                                    cls: "font-semibold",
                                                    child: 'SKUPAJ'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 2,
                                                    cls: "font-semibold text-right",
                                                    child: this.state.main_table_items.total.reservation_count.toLocaleString(undefined, {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 3,
                                                    cls: "font-semibold text-right",
                                                    child: this.state.main_table_items.total.night_count.toLocaleString(undefined, {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "by-tourist-tax-types-table pt-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "results",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "results-table without-vertical-lines",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                    columnIdx: 1,
                                                    title: "TURISTI\u010CNA TAKSA"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                    columnIdx: 2,
                                                    cls: "text-right",
                                                    title: "\u0160t. preno\u010Ditev"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                    columnIdx: 3,
                                                    cls: "text-right",
                                                    title: "Obra\u010Dunana taksa (EUR)"
                                                }),
                                                Object.keys(this.state.main_table_items.by_tourist_discount).sort((a, b)=>a - b).map((discount)=>{
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                columnIdx: 1,
                                                                child: discount == 0 ? 'Polna taksa:' : "Opro\u0161\u010Deno " + discount + '%'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                columnIdx: 2,
                                                                cls: "text-right",
                                                                child: this.state.main_table_items.by_tourist_discount[discount].night_count.toLocaleString(undefined, {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                columnIdx: 3,
                                                                cls: "text-right",
                                                                child: this.state.main_table_items.by_tourist_discount[discount].price_sum.toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })
                                                            })
                                                        ]
                                                    }, 'tax-' + discount);
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 1,
                                                    cls: "font-semibold",
                                                    child: "SKUPAJ TURISTI\u010CNA TAKSA"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 2,
                                                    cls: "font-semibold text-right",
                                                    child: this.state.main_table_items.total.night_count.toLocaleString(undefined, {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 3,
                                                    cls: "font-semibold text-right",
                                                    child: this.state.main_table_items.total.price_sum.toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 1,
                                                    cls: "font-semibold",
                                                    child: 'PROMOCIJSKA TAKSA'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 2,
                                                    child: ''
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 3,
                                                    cls: "font-semibold text-right",
                                                    child: (this.state.main_table_items.total.price_sum * 0.25).toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 1,
                                                    cls: "font-semibold ",
                                                    child: 'SKUPAJ'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 2,
                                                    child: ''
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                    columnIdx: 3,
                                                    cls: "font-semibold text-right",
                                                    child: (this.state.main_table_items.total.price_sum + this.state.main_table_items.total.price_sum * 0.25).toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
TouristTaxes.propTypes = {};
function mapStateToProps(state) {
    return {
        api_url: state.CashRegisterSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        users: state.UserSlice.users,
        countries: state.CodeTablesSlice.countries,
        customers: state.CodeTablesSlice.customers,
        tourist_taxes: state.CodeTablesSlice.tourist_taxes,
        accommodations: state.CodeTablesSlice.accommodations,
        guest_book_items: state.GuestSlice.guest_book_items,
        reservation_customers: state.ReservationSlice.reservation_customers,
        reservations: state.ReservationSlice.reservations,
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodations: state.CodeTablesSlice.accommodations
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(TouristTaxes);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","moment":"1e4qG","@blueprintjs/core":"6Mq52","../code_tables/ResultComponents":"1eVlZ","../TextWithTooltip":"6kuHH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"krMZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _resultComponents = require("../code_tables/ResultComponents");
var _reservation = require("../reservations/Reservation");
var _reservationDefault = parcelHelpers.interopDefault(_reservation);
var _businessSlice = require("../../slices/BusinessSlice");
var _business = require("../../api/Business");
var _documentSlice = require("../../slices/DocumentSlice");
var _editInvoiceDialog = require("../business/EditInvoiceDialog");
var _editInvoiceDialogDefault = parcelHelpers.interopDefault(_editInvoiceDialog);
var _waitFiscalVerificationDialog = require("../business/WaitFiscalVerificationDialog");
var _waitFiscalVerificationDialogDefault = parcelHelpers.interopDefault(_waitFiscalVerificationDialog);
var _invoiceCreator = require("../../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _documentListDialog = require("../DocumentListDialog");
var _documentListDialogDefault = parcelHelpers.interopDefault(_documentListDialog);
var _appSlice = require("../../slices/AppSlice");
function Documents(props) {
    if (props.documents.length == 0) return null;
    let items = [];
    const document = props.documents[0];
    let id_document = document.id_document;
    let document_type = document.document_type;
    let document_document_number = null;
    let document_click_handler = null;
    if (document_type == 'cash-invoice' || document_type == 'invoice' || document_type == 'offer' || document_type == 'prepayment-invoice' || document_type == 'credit-note') {
        const invoice_item = props.invoices[id_document];
        if (invoice_item !== undefined) {
            document_document_number = invoice_item.invoice_number_internal;
            document_click_handler = ()=>{
                props.openEditInvoiceDialog(invoice_item.invoice_type, invoice_item);
            };
        }
    }
    items.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
        small: true,
        className: "cell-button",
        onClick: document_click_handler,
        children: document_document_number
    }, "latest-document"));
    if (props.documents.length > 1) items.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
        small: true,
        className: "cell-button ml-1",
        onClick: props.openDocumentListDialog,
        icon: "multi-select"
    }, "more-documents"));
    return items;
}
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, tableItemsFilters, originalTableItemsFilters, handleFilterChange, customers, reservation_customers, accommodations, accommodation_items, accommodation_item_places, countries, accommodation_item_place_titles, statuses, identification_types, openReservationDialog, guest_book_items, document_associations, invoices, openEditInvoiceDialog, expanded, openDocumentListDialog } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const toLocalString = (date)=>{
        if (date === null || date === undefined) return '';
        if (!(date instanceof Date)) return date;
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
    };
    const toLocalStringWithTime = (date)=>{
        if (date === null) return '';
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear() + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');
    };
    const items_id_accommodation_item_places = [];
    for(let id in table_items){
        const id_accommodation_item_place = table_items[id].id_accommodation_item_place;
        if (items_id_accommodation_item_places.indexOf(id_accommodation_item_place) == -1) items_id_accommodation_item_places.push(id_accommodation_item_place);
    }
    const accommodation_item_place_items = {};
    for(let id_accommodation in accommodations)for(let id_accommodation_item in accommodation_items){
        if (accommodation_items[id_accommodation_item].id_accommodation != id_accommodation) continue;
        for(let id_accommodation_item_place in accommodation_item_places){
            if (accommodation_item_places[id_accommodation_item_place].id_accommodation_item != id_accommodation_item) continue;
            // only display used ones
            if (items_id_accommodation_item_places.indexOf(id_accommodation_item_place) == -1) continue;
            let title = accommodations[id_accommodation].title + " \u2022 ";
            if (accommodation_items[id_accommodation_item].title != 'default') title += accommodation_items[id_accommodation_item].title + " \u2022 ";
            title += accommodation_item_places[id_accommodation_item_place].title;
            accommodation_item_place_items[id_accommodation_item_place] = {
                id_accommodation_item_place,
                title,
                ord: accommodations[id_accommodation].ord * 1000000 + accommodation_items[id_accommodation_item].ord * 10000 + accommodation_item_places[id_accommodation_item_place].ord
            };
        }
    }
    const customer_countries = {};
    for(let id_customer in customers){
        const id_country = customers[id_customer].id_country;
        if (customer_countries[id_country] !== undefined) continue;
        customer_countries[id_country] = {
            id_country,
            title: countries[id_country] === undefined ? '' : countries[id_country].common_name_local
        };
    }
    const identification_type_obj = {};
    for(let id_identification_type in identification_types)identification_type_obj[id_identification_type] = {
        id_identification_type,
        title: identification_types[id_identification_type].title,
        ord: identification_types[id_identification_type].ord
    };
    const reservation_customers_by_id_reservations = {};
    for(let id_reservation_customer in reservation_customers){
        const reservation_customer = reservation_customers[id_reservation_customer];
        if (reservation_customers_by_id_reservations[reservation_customer.id_reservation] === undefined) reservation_customers_by_id_reservations[reservation_customer.id_reservation] = [];
        reservation_customers_by_id_reservations[reservation_customer.id_reservation].push(reservation_customer);
    }
    const etourism_statuses = {
        none: 'NEPOSLAN',
        waiting: "\u010CAKA NA PO\u0160ILJANJE",
        success: "POSLANO USPE\u0160NO",
        failure: "NAPAKA PRI PO\u0160ILJANJU"
    };
    const etourism_status_colors = {
        none: '#cccccc',
        waiting: 'orange',
        success: 'green',
        failure: 'red'
    };
    const getDocuments = (id_document, max_depth, depth)=>{
        depth = depth || 1;
        let items = {};
        if (depth > max_depth) return items;
        let documents = Object.values(document_associations[id_document] || {});
        for(let i = 0; i < documents.length; i++){
            let item = documents[i];
            let curr_id_document = item.source_id_document;
            let document_type = item.source_type;
            if (item.source_id_document == id_document) {
                curr_id_document = item.target_id_document;
                document_type = item.target_type;
            }
            if (items[item.id_document_association] === undefined) items[item.id_document_association] = {
                id_document_association: item.id_document_association,
                created: item.created,
                id_document: curr_id_document,
                document_type
            };
            const subitems = getDocuments(curr_id_document, max_depth, depth + 1);
            for(let id_document_association in subitems)if (items[id_document_association] === undefined) items[id_document_association] = subitems[id_document_association];
        }
        return items;
    };
    let columnIdx = 1;
    let filtersColumnIdx = 1;
    let total_guest_adult_count = 0;
    let total_guest_child_1_count = 0;
    let total_guest_child_2_count = 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results mt-4 mb-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table without-vertical-lines",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: columnIdx++,
                                title: ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: columnIdx++,
                                title: ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Objekt",
                                fieldName: "accommodation"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Status",
                                fieldName: "status"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "\u0160ifra",
                                fieldName: "internal_code"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Nosilec / gosti",
                                fieldName: "guests"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Dr\u017Eava",
                                fieldName: "customer_id_country"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Osebni dokument",
                                fieldName: "customer_id_identification_type"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "\u0160t. dokumenta",
                                fieldName: "customer_identification_number"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: columnIdx++,
                                title: "Prihod"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: columnIdx++,
                                title: "Odhod"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Osebe",
                                fieldName: "guest_count"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: columnIdx++,
                                title: "Prijavljeni"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table without-vertical-lines filters-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "id_accommodation_item_place",
                                        title_field: "title",
                                        items: accommodation_item_place_items,
                                        displaySort: (a, b)=>a.ord - b.ord,
                                        filtered_keys: tableItemsFilters.id_accommodation_item_places,
                                        onFilterChange: (values)=>handleFilterChange('id_accommodation_item_places', values)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "key",
                                        title_field: "title",
                                        items: statuses,
                                        filtered_keys: tableItemsFilters.statuses,
                                        onFilterChange: (values)=>handleFilterChange('statuses', values)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.internal_code,
                                    onChange: (event)=>handleFilterChange('internal_code', event)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.customer_name,
                                    onChange: (event)=>handleFilterChange('customer_name', event)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "id_country",
                                        title_field: "title",
                                        items: customer_countries,
                                        filtered_keys: tableItemsFilters.customer_id_countries,
                                        onFilterChange: (values)=>handleFilterChange('customer_id_countries', values)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "id_identification_type",
                                        title_field: "title",
                                        items: identification_type_obj,
                                        filtered_keys: tableItemsFilters.customer_id_identification_types,
                                        displaySort: (a, b)=>a.ord - b.ord,
                                        onFilterChange: (values)=>handleFilterChange('customer_id_identification_types', values)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.customer_identification_number,
                                    onChange: (event)=>handleFilterChange('customer_identification_number', event)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                    filter_values: tableItemsFilters.check_in_range,
                                    short_year: true,
                                    original_start_date: originalTableItemsFilters.check_in_range[0],
                                    original_end_date: originalTableItemsFilters.check_in_range[1],
                                    onFilterChange: (values)=>handleFilterChange('check_in_range', values)
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                    filter_values: tableItemsFilters.check_out_range,
                                    short_year: true,
                                    original_start_date: originalTableItemsFilters.check_out_range[0],
                                    original_end_date: originalTableItemsFilters.check_out_range[1],
                                    onFilterChange: (values)=>handleFilterChange('check_out_range', values)
                                }),
                                ...sort_props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: tableItemsFilters.guests_checked_in === true,
                                    indeterminate: tableItemsFilters.guests_checked_in === null,
                                    onChange: (event)=>{
                                        let checked = true;
                                        if (tableItemsFilters.guests_checked_in === true) checked = null;
                                        else if (tableItemsFilters.guests_checked_in === null) checked = false;
                                        handleFilterChange('guests_checked_in', checked);
                                    }
                                })
                            })
                        ]
                    }),
                    table_items_sort_ids.map((id, idx)=>{
                        const item = table_items[id];
                        const customer = customers[item.id_customer] ?? null;
                        const documents = Object.values(getDocuments(item.id_reservation, 3)).sort((a, b)=>{
                            if (a.created < b.created) return 1;
                            if (a.created > b.created) return -1;
                            return 0;
                        }).filter((document)=>document.document_type == 'invoice' || document.document_type == 'cash-invoice');
                        let pattern_class_name = '';
                        if (item.status == 'offer-sent') pattern_class_name = 'reservation-list-pattern-polka-dots';
                        else if (item.status == 'advance-invoice-sent' || item.status == 'not-for-rent' /*with red background*/ ) pattern_class_name = 'reservation-list-pattern-diagonal-stripes';
                        total_guest_adult_count += item.guest_adult_count;
                        total_guest_child_1_count += item.guest_child_1_count;
                        total_guest_child_2_count += item.guest_child_2_count;
                        columnIdx = 1;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "results-table without-vertical-lines status-" + (item.deleted === true ? 'deleted' : item.status) + ' ' + (item.status_2 === null ? '' : item.status_2),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    version: "1.1",
                                    baseProfile: "full",
                                    width: "16",
                                    height: "16",
                                    className: "custom-status",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M 0,0 L 16,0 L 0,16 L 0,0 z",
                                        fill: "#ff0000"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openReservationDialog(item.id_reservation)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: pattern_class_name == '' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: pattern_class_name
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: accommodation_item_place_titles[item.id_accommodation_item_place]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: statuses[item.deleted === true ? 'deleted' : item.status].title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: item.internal_code
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "one-line-minimum",
                                                children: item.id_customer === null || customers[item.id_customer] === undefined ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "grid grid-cols-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: customers[item.id_customer].type == 'natural' ? customers[item.id_customer].surname + ' ' + customers[item.id_customer].name : customers[item.id_customer].company_name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-right",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Documents, {
                                                                documents: documents,
                                                                invoices: invoices,
                                                                openEditInvoiceDialog: openEditInvoiceDialog,
                                                                openDocumentListDialog: ()=>{
                                                                    openDocumentListDialog(item.id_reservation);
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            !expanded ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "reservation-list-guests-table",
                                                children: reservation_customers_by_id_reservations[id] === undefined ? null : Object.values(reservation_customers_by_id_reservations[id]).map((reservation_customer)=>{
                                                    const customer = customers[reservation_customer.id_customer];
                                                    if (customer === undefined || customer === null) return null;
                                                    const guest_book_item = guest_book_items[reservation_customer.id_guest_book];
                                                    const etourism_status_title = etourism_statuses[guest_book_item === undefined || guest_book_item.zst === null || guest_book_item.etourism_status === null ? 'none' : guest_book_item.etourism_status];
                                                    const etourism_status_color = etourism_status_colors[guest_book_item === undefined || guest_book_item.zst === null || guest_book_item.etourism_status === null ? 'none' : guest_book_item.etourism_status];
                                                    const etourism_tooltip_content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                children: [
                                                                    "Stanje: ",
                                                                    etourism_status_title
                                                                ]
                                                            }),
                                                            guest_book_item === null || guest_book_item === undefined || guest_book_item.log === null || guest_book_item.log.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "mt-6 mb-1",
                                                                        children: "Dnevnik dogodkov:"
                                                                    }),
                                                                    [
                                                                        ...guest_book_item.log
                                                                    ].sort((log_item_a, log_item_b)=>log_item_a.created.localeCompare(log_item_b.created) * -1).map((guest_book_log)=>{
                                                                        let status_title = 'neznano';
                                                                        switch(guest_book_log.status){
                                                                            case 'success':
                                                                                status_title = "POSLANO USPE\u0160NO";
                                                                                break;
                                                                            case 'failure':
                                                                                status_title = "NAPAKA PRI PO\u0160ILJANJU";
                                                                                break;
                                                                        }
                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            style: {
                                                                                maxWidth: 480,
                                                                                marginBottom: '1rem'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "flex flex-row justify-between mb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "mr-12",
                                                                                            children: status_title
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            children: new Date(guest_book_log.created).toLocaleString('sl-SI')
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    children: JSON.parse(guest_book_log.message).map((message_item)=>message_item.error_message).join(', ')
                                                                                })
                                                                            ]
                                                                        }, 'guest-book-log-' + guest_book_log.id_guest_book_log);
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    });
                                                    const documents = Object.values(getDocuments(reservation_customer.id_reservation_customer, 1)).sort((a, b)=>{
                                                        if (a.created < b.created) return 1;
                                                        if (a.created > b.created) return -1;
                                                        return 0;
                                                    }).filter((document)=>document.document_type == 'cash-invoice');
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                        icon: "edit",
                                                                        intent: "primary",
                                                                        minimal: true,
                                                                        small: true,
                                                                        onClick: ()=>openReservationDialog(item.id_reservation, reservation_customer.id_reservation_customer)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                                                        content: etourism_tooltip_content,
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                                            icon: reservation_customer.checked_out === false ? 'upload' : 'tick',
                                                                            className: "ml-1",
                                                                            color: etourism_status_color
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Documents, {
                                                                    documents: documents,
                                                                    invoices: invoices,
                                                                    openEditInvoiceDialog: openEditInvoiceDialog,
                                                                    openDocumentListDialog: ()=>{
                                                                        openDocumentListDialog(item.id_reservation);
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }, 'guest-' + reservation_customer.id_reservation_customer);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "one-line-minimum",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                    children: customer === null || customer.id_country === null || countries[customer.id_country] === undefined ? '' : countries[customer.id_country].common_name_local
                                                })
                                            }),
                                            !expanded ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "reservation-list-guests",
                                                children: reservation_customers_by_id_reservations[id] === undefined ? null : Object.values(reservation_customers_by_id_reservations[id]).map((reservation_customer)=>{
                                                    const customer = customers[reservation_customer.id_customer];
                                                    if (customer === undefined || customer === null) return null;
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: customer.id_country === null ? '' : countries[customer.id_country].common_name_local
                                                    }, 'guest-' + reservation_customer.id_reservation_customer);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "one-line-minimum",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                    children: customer === null || customer.id_identification_type === null ? '' : identification_types[customer.id_identification_type].title
                                                })
                                            }),
                                            !expanded ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "reservation-list-guests",
                                                children: reservation_customers_by_id_reservations[id] === undefined ? null : Object.values(reservation_customers_by_id_reservations[id]).map((reservation_customer)=>{
                                                    const customer = customers[reservation_customer.id_customer];
                                                    if (customer === undefined || customer === null) return null;
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: customer.id_identification_type === null ? '' : identification_types[customer.id_identification_type].title
                                                    }, 'guest-' + reservation_customer.id_reservation_customer);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "one-line-minimum",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                    children: customer === null ? '' : customer.identification_number
                                                })
                                            }),
                                            !expanded ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "reservation-list-guests",
                                                children: reservation_customers_by_id_reservations[id] === undefined ? null : Object.values(reservation_customers_by_id_reservations[id]).map((reservation_customer)=>{
                                                    const customer = customers[reservation_customer.id_customer];
                                                    if (customer === undefined || customer === null) return null;
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: customer.identification_number
                                                    }, 'guest-' + reservation_customer.id_reservation_customer);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "one-line-minimum",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                    children: toLocalString(new Date(item.check_in))
                                                })
                                            }),
                                            !expanded ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "reservation-list-guests",
                                                children: reservation_customers_by_id_reservations[id] === undefined ? null : Object.values(reservation_customers_by_id_reservations[id]).map((reservation_customer)=>{
                                                    const customer = customers[reservation_customer.id_customer];
                                                    if (customer === undefined || customer === null) return null;
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: toLocalStringWithTime(new Date(reservation_customer.check_in))
                                                    }, 'guest-' + reservation_customer.id_reservation_customer);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "one-line-minimum",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                    children: toLocalString(new Date(item.check_out))
                                                })
                                            }),
                                            !expanded ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "reservation-list-guests",
                                                children: reservation_customers_by_id_reservations[id] === undefined ? null : Object.values(reservation_customers_by_id_reservations[id]).map((reservation_customer)=>{
                                                    const customer = customers[reservation_customer.id_customer];
                                                    if (customer === undefined || customer === null) return null;
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: toLocalStringWithTime(new Date(reservation_customer.check_out))
                                                    }, 'guest-' + reservation_customer.id_reservation_customer);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: item.guest_adult_count + ' / ' + (item.guest_child_1_count + item.guest_child_2_count)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: item.guests_checked_in === true ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                        icon: "tick"
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                        icon: "cross"
                                    })
                                })
                            ]
                        }, 'result--result-' + id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results borderless mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            span: 4,
                            child: "\u0160tevilo zapisov: " + table_items_sort_ids.length
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 12,
                            cls: "font-bold",
                            child: total_guest_adult_count + ' / ' + (total_guest_child_1_count + total_guest_child_2_count)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 13,
                            child: ''
                        })
                    ]
                })
            })
        ]
    });
}
class ReservationList extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openReservationDialog = this.openReservationDialog.bind(this);
        this.closeReservationDialog = this.closeReservationDialog.bind(this);
        this.openEditInvoiceDialog = this.openEditInvoiceDialog.bind(this);
        this.closeEditInvoiceDialog = this.closeEditInvoiceDialog.bind(this);
        this.generateAccommodationItemPlaceTitles = this.generateAccommodationItemPlaceTitles.bind(this);
        this.generateAccommodationItemPlaceOrds = this.generateAccommodationItemPlaceOrds.bind(this);
        this.openDocumentListDialog = this.openDocumentListDialog.bind(this);
        this.closeDocumentListDialog = this.closeDocumentListDialog.bind(this);
        const table_items_filters = {
            id_accommodation_item_places: [],
            statuses: [],
            internal_code: '',
            customer_name: '',
            customer_id_countries: [],
            customer_id_identification_types: [],
            customer_identification_number: '',
            check_in_range: [
                null,
                null
            ],
            check_out_range: [
                (0, _momentDefault.default)().toDate(),
                (0, _momentDefault.default)().toDate()
            ],
            guests_checked_in: null
        };
        const accommodation_item_place_titles = this.generateAccommodationItemPlaceTitles(props.accommodations, props.accommodation_items, props.accommodation_item_places);
        const accommodation_item_place_ords = this.generateAccommodationItemPlaceOrds(props.accommodations, props.accommodation_items, props.accommodation_item_places);
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'accommodation',
            table_items_sort_direction: 'ASC',
            accommodation_item_place_titles,
            accommodation_item_place_ords
        });
        const statuses = {
            'new': {
                title: 'Nova',
                key: 'new'
            },
            'waiting-for-confirmation': {
                title: 'V potrjevanju',
                key: 'waiting-for-confirmation'
            },
            'offer-sent': {
                title: 'Izdana ponudba',
                key: 'offer-sent'
            },
            'confirmed': {
                title: 'Potrjena',
                key: 'confirmed'
            },
            'advance-invoice-sent': {
                title: 'Izdan avans',
                key: 'advance-invoice-sent'
            },
            'closed': {
                title: "Pla\u010Dana",
                key: 'closed'
            },
            'reversed': {
                title: 'Stornirana',
                key: 'reversed'
            },
            'no-show': {
                title: 'Neprihod',
                key: 'no-show'
            },
            'not-for-rent': {
                title: 'Ni za oddajo',
                key: 'not-for-rent'
            },
            'deleted': {
                title: 'Brisana',
                key: 'deleted'
            }
        };
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'accommodation',
            table_items_sort_direction: 'ASC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            date_range_picker_dialog_open: false,
            date_range_picker_dialog_filter_name: null,
            accommodation_item_place_titles,
            accommodation_item_place_ords,
            statuses,
            reservation_dialog_open: false,
            reservation_dialog_id_reservation: -1,
            reservation_dialog_id_reservation_customer: null,
            invoice_dialog_open: false,
            invoice_dialog_item: null,
            invoice_dialog_type: '',
            expanded: false,
            document_list_dialog_open: false,
            document_list_dialog_id_document: null,
            wait_fiscal_verification_dialog_open: false,
            wait_fiscal_verification_dialog_id_invoice: null
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.reservations != this.state.reservations || this.state.expanded != prevState.expanded) this.setState(this.updateTableItemsFromProps(this.props, this.state));
        if (this.props.accommodations != prevProps.accommodations || this.props.accommodation_items != prevProps.accommodation_items || this.props.accommodation_item_places != prevProps.accommodation_item_places) {
            this.setState({
                accommodation_item_place_titles: this.generateAccommodationItemPlaceTitles(this.props.accommodations, this.props.accommodation_items, this.props.accommodation_item_places),
                accommodation_item_place_ords: this.generateAccommodationItemPlaceOrds(this.props.accommodations, this.props.accommodation_items, this.props.accommodation_item_places)
            });
            this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction);
        }
        if (this.state.accommodation_item_place_titles != prevState.accommodation_item_place_titles || this.state.accommodation_item_place_ords != prevState.accommodation_item_place_ords) this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction);
    }
    generateAccommodationItemPlaceTitles(accommodations, accommodation_items, accommodation_item_places) {
        const accommodation_item_place_titles = {};
        if (accommodations !== null && accommodation_items !== null && accommodation_item_places !== null) {
            for(let id_accommodation in accommodations)for(let id_accommodation_item in accommodation_items){
                if (accommodation_items[id_accommodation_item].id_accommodation != id_accommodation) continue;
                for(let id_accommodation_item_place in accommodation_item_places){
                    if (accommodation_item_places[id_accommodation_item_place].id_accommodation_item != id_accommodation_item) continue;
                    let title = accommodations[id_accommodation].title + " \u2022 ";
                    if (accommodation_items[id_accommodation_item].title != 'default') title += accommodation_items[id_accommodation_item].title + " \u2022 ";
                    title += accommodation_item_places[id_accommodation_item_place].title;
                    accommodation_item_place_titles[id_accommodation_item_place] = title;
                }
            }
        }
        return accommodation_item_place_titles;
    }
    generateAccommodationItemPlaceOrds(accommodations, accommodation_items, accommodation_item_places) {
        const accommodation_item_place_ords = {};
        if (accommodations !== null && accommodation_items !== null && accommodation_item_places !== null) {
            for(let id_accommodation in accommodations)for(let id_accommodation_item in accommodation_items){
                if (accommodation_items[id_accommodation_item].id_accommodation != id_accommodation) continue;
                for(let id_accommodation_item_place in accommodation_item_places){
                    if (accommodation_item_places[id_accommodation_item_place].id_accommodation_item != id_accommodation_item) continue;
                    accommodation_item_place_ords[id_accommodation_item_place] = accommodations[id_accommodation].ord * 1000000 + accommodation_items[id_accommodation_item].ord * 10000 + accommodation_item_places[id_accommodation_item_place].ord;
                }
            }
        }
        return accommodation_item_place_ords;
    }
    updateTableItemsFromProps(props, state) {
        const filtered_reservations = {};
        for(let id_reservation in props.reservations){
            const reservation = props.reservations[id_reservation];
            filtered_reservations[id_reservation] = reservation;
        }
        const ids = Object.keys(filtered_reservations);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            reservations: props.reservations,
            table_items: filtered_reservations,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction,
            accommodation_item_place_titles: state.accommodation_item_place_titles,
            accommodation_item_place_ords: state.accommodation_item_place_ords,
            expanded: state.expanded
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            if (field == 'accommodation') {
                const reservation_a = state.table_items[a_key];
                const reservation_b = state.table_items[b_key];
                a = state.accommodation_item_place_ords === undefined ? 0 : state.accommodation_item_place_ords[reservation_a.id_accommodation_item_place] || 0;
                b = state.accommodation_item_place_ords === undefined ? 0 : state.accommodation_item_place_ords[reservation_b.id_accommodation_item_place] || 0;
            } else if (field == 'status') {
                a = state.statuses[state.table_items[a_key].deleted === true ? 'deleted' : state.table_items[a_key][field]].title;
                b = state.statuses[state.table_items[b_key].deleted === true ? 'deleted' : state.table_items[b_key][field]].title;
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'guests') {
                const reservation_a = state.table_items[a_key];
                const reservation_b = state.table_items[b_key];
                const customer_a = this.props.customers[reservation_a.id_customer];
                const customer_b = this.props.customers[reservation_b.id_customer];
                a = customer_a === undefined ? '' : customer_a.type == 'natural' ? customer_a.surname + ' ' + customer_a.name : customer_a.company_name;
                b = customer_b === undefined ? '' : customer_b.type == 'natural' ? customer_b.surname + ' ' + customer_b.name : customer_b.company_name;
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'customer_id_country') {
                const reservation_a = state.table_items[a_key];
                const reservation_b = state.table_items[b_key];
                const customer_a = this.props.customers[reservation_a.id_customer];
                const customer_b = this.props.customers[reservation_b.id_customer];
                a = customer_a === undefined ? '' : customer_a.id_country === null ? '' : this.props.countries[customer_a.id_country].common_name_local;
                b = customer_b === undefined ? '' : customer_b.id_country === null ? '' : this.props.countries[customer_b.id_country].common_name_local;
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'customer_id_identification_type') {
                const reservation_a = state.table_items[a_key];
                const reservation_b = state.table_items[b_key];
                const customer_a = this.props.customers[reservation_a.id_customer];
                const customer_b = this.props.customers[reservation_b.id_customer];
                a = customer_a === undefined ? '' : customer_a.id_identification_type === null ? '' : this.props.identification_types[customer_a.id_identification_type].title;
                b = customer_b === undefined ? '' : customer_b.id_identification_type === null ? '' : this.props.identification_types[customer_b.id_identification_type].title;
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'customer_identification_number') {
                const reservation_a = state.table_items[a_key];
                const reservation_b = state.table_items[b_key];
                const customer_a = this.props.customers[reservation_a.id_customer];
                const customer_b = this.props.customers[reservation_b.id_customer];
                a = customer_a === undefined ? '' : customer_a.identification_number ?? '';
                b = customer_b === undefined ? '' : customer_b.identification_number ?? '';
                return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'guest_count') {
                a = state.table_items[a_key].guest_adult_count + state.table_items[a_key].guest_child_1_count + state.table_items[a_key].guest_child_2_count;
                b = state.table_items[b_key].guest_adult_count + state.table_items[b_key].guest_child_1_count + state.table_items[b_key].guest_child_2_count;
            } else if (field == 'internal_code') {
                const reservation_a = state.table_items[a_key];
                const reservation_b = state.table_items[b_key];
                const pos_a = reservation_a.internal_code.indexOf('.');
                const internal_code_a = pos_a === -1 ? reservation_a.internal_code : reservation_a.internal_code.substring(pos_a + 1);
                const pos_b = reservation_b.internal_code.indexOf('.');
                const internal_code_b = pos_b === -1 ? reservation_b.internal_code : reservation_b.internal_code.substring(pos_b + 1);
                const internal_code_num_a = parseInt(internal_code_a, 10);
                const internal_code_num_b = parseInt(internal_code_b, 10);
                if (internal_code_num_a > internal_code_num_b) return 1 * (dir == 'ASC' ? 1 : -1);
                else if (internal_code_num_a < internal_code_num_b) return -1 * (dir == 'ASC' ? 1 : -1);
                return 0;
            } else {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_id_accommodation_item_places = filters.id_accommodation_item_places;
        const filters_statuses = filters.statuses;
        const filters_internal_code = filters.internal_code.toUpperCase();
        const filters_customer_name = filters.customer_name.toUpperCase();
        const filters_customer_id_countries = filters.customer_id_countries;
        const filters_customer_id_identification_types = filters.customer_id_identification_types;
        const filters_customer_identification_number = filters.customer_identification_number.toUpperCase();
        const filter_check_in_start = filters.check_in_range[0] === null ? null : this.toIsoString(filters.check_in_range[0]);
        const filter_check_in_end = filters.check_in_range[1] === null ? null : this.toIsoString(filters.check_in_range[1]);
        const filter_check_out_start = filters.check_out_range[0] === null ? null : this.toIsoString(filters.check_out_range[0]);
        const filter_check_out_end = filters.check_out_range[1] === null ? null : this.toIsoString(filters.check_out_range[1]);
        const filter_guests_checked_in = filters.guests_checked_in;
        console.log({
            filter_guests_checked_in
        });
        const reservation_customers_by_id_reservations = {};
        for(let id_reservation_customer in this.props.reservation_customers){
            const reservation_customer = this.props.reservation_customers[id_reservation_customer];
            if (reservation_customer === undefined) continue;
            if (reservation_customers_by_id_reservations[reservation_customer.id_reservation] === undefined) reservation_customers_by_id_reservations[reservation_customer.id_reservation] = [];
            reservation_customers_by_id_reservations[reservation_customer.id_reservation].push(reservation_customer);
        }
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_id_accommodation_item_places.length > 0) {
                let found = false;
                for(let i = 0; i < filters_id_accommodation_item_places.length; i++)if (item.id_accommodation_item_place == filters_id_accommodation_item_places[i]) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (filters_statuses.length > 0) {
                let found = false;
                for(let i = 0; i < filters_statuses.length; i++)if (filters_statuses[i] == 'deleted' && item.deleted === true || item.status == filters_statuses[i] && item.deleted !== true) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (filters_internal_code != '') {
                if (item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) return false;
            }
            // don't filter based on guests when they are hidden
            const reservation_customers = !state.expanded ? [] : reservation_customers_by_id_reservations[id] === undefined ? [] : Object.values(reservation_customers_by_id_reservations[id]);
            if (filters_customer_name != '') {
                const filter = (customer)=>{
                    if (customer === undefined || customer === null) return false;
                    return (customer.surname + ' ' + customer.name + ' ' + customer.company_name).toUpperCase().indexOf(filters_customer_name) != -1;
                };
                let found = filter(this.props.customers[item.id_customer]);
                found = found || reservation_customers.some((x)=>filter(this.props.customers[x.id_customer]));
                if (!found) return false;
            }
            if (filters_customer_id_countries.length > 0) {
                const filter = (customer)=>{
                    if (customer === undefined || customer === null) return false;
                    return customer.id_country !== null && filters_customer_id_countries.indexOf(customer.id_country) != -1;
                };
                let found = filter(this.props.customers[item.id_customer]);
                found = found || reservation_customers.some((x)=>filter(this.props.customers[x.id_customer]));
                if (!found) return false;
            }
            if (filters_customer_id_identification_types.length > 0) {
                const filter = (customer)=>{
                    if (customer === undefined || customer === null) return false;
                    return customer.id_identification_type !== null && filters_customer_id_identification_types.indexOf(customer.id_identification_type) != -1;
                };
                let found = filter(this.props.customers[item.id_customer]);
                found = found || reservation_customers.some((x)=>filter(this.props.customers[x.id_customer]));
                if (!found) return false;
            }
            if (filters_customer_identification_number != '') {
                const filter = (customer)=>{
                    if (customer === undefined || customer === null) return false;
                    return customer.identification_number !== null && customer.identification_number.toUpperCase().indexOf(filters_customer_identification_number) != -1;
                };
                let found = filter(this.props.customers[item.id_customer]);
                found = found || reservation_customers.some((x)=>filter(this.props.customers[x.id_customer]));
                if (!found) return false;
            }
            if (filter_check_in_start !== null) {
                const filter = (customer)=>{
                    if (customer === undefined || customer === null || customer.check_in === null || customer.check_in === undefined) return false;
                    let val = this.toIsoString(new Date(customer.check_in)) >= filter_check_in_start;
                    if (val && filter_check_in_end !== null) val = this.toIsoString(new Date(customer.check_in)) <= filter_check_in_end;
                    return val;
                };
                let found = filter(item);
                found = found || reservation_customers.some((x)=>filter(this.props.customers[x.id_customer]));
                if (!found) return false;
            }
            if (filter_check_in_end !== null) {
                const filter = (customer)=>{
                    if (customer === undefined || customer === null || customer.check_in === null || customer.check_in === undefined) return false;
                    return /*customer.check_in === null ||*/ this.toIsoString(new Date(customer.check_in)) <= filter_check_in_end;
                };
                let found = filter(item);
                found = found || reservation_customers.some((x)=>filter(this.props.customers[x.id_customer]));
                if (!found) return false;
            }
            if (filter_check_out_start !== null) {
                const filter = (customer)=>{
                    if (customer === undefined || customer === null || customer.check_out === null || customer.check_out === undefined) return false;
                    let val = this.toIsoString(new Date(customer.check_out)) >= filter_check_out_start;
                    if (val && filter_check_out_end !== null) val = this.toIsoString(new Date(customer.check_out)) <= filter_check_out_end;
                    return val;
                };
                let found = filter(item);
                found = found || reservation_customers.some((x)=>filter(this.props.customers[x.id_customer]));
                if (!found) return false;
            }
            if (filter_check_out_end !== null) {
                const filter = (customer)=>{
                    if (customer === undefined || customer === null || customer.check_out === null || customer.check_out === undefined) return false;
                    let val = this.toIsoString(new Date(customer.check_out)) <= filter_check_out_end;
                    if (val && filter_check_out_start !== null) val = this.toIsoString(new Date(customer.check_out)) >= filter_check_out_start;
                    return val;
                };
                let found = filter(item);
                found = found || reservation_customers.some((x)=>filter(this.props.customers[x.id_customer]));
                if (!found) return false;
            }
            if (filter_guests_checked_in !== null) {
                if (item.guests_checked_in !== filter_guests_checked_in) return false;
            }
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items,
            accommodation_item_place_titles: state.accommodation_item_place_titles,
            accommodation_item_place_ords: state.accommodation_item_place_ords
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            id_accommodation_item_places: this.state.table_items_filters.id_accommodation_item_places,
            statuses: this.state.table_items_filters.statuses,
            internal_code: this.state.table_items_filters.internal_code,
            customer_name: this.state.table_items_filters.customer_name,
            customer_id_countries: this.state.table_items_filters.customer_id_countries,
            customer_id_identification_types: this.state.table_items_filters.customer_id_identification_types,
            customer_identification_number: this.state.table_items_filters.customer_identification_number,
            check_in_range: this.state.table_items_filters.check_in_range,
            check_out_range: this.state.table_items_filters.check_out_range,
            guests_checked_in: this.state.table_items_filters.guests_checked_in
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openReservationDialog(id_reservation, id_reservation_customer) {
        this.setState({
            reservation_dialog_open: true,
            reservation_dialog_id_reservation: id_reservation,
            reservation_dialog_id_reservation_customer: id_reservation_customer || null
        });
    }
    closeReservationDialog() {
        this.setState({
            reservation_dialog_open: false,
            reservation_dialog_id_reservation: -1,
            reservation_dialog_id_reservation_customer: null
        });
    }
    openEditInvoiceDialog(type, item) {
        this.setState({
            invoice_dialog_open: true,
            invoice_dialog_type: type,
            invoice_dialog_item: item
        });
    }
    async closeEditInvoiceDialog(item, open_create_invoice_type, finish_invoice) {
        this.setState({
            invoice_dialog_open: false,
            invoice_dialog_item: null
        });
        if (item !== undefined) {
            this.props.dispatch((0, _businessSlice.addInvoice)({
                item,
                token: this.props.token
            }));
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            const new_items = await (0, _business.saveInvoice)(this.props.api_url, item, token, dispatch);
            if (new_items !== null) {
                if (new_items.invoices !== undefined) dispatch((0, _businessSlice.addInvoices)(new_items.invoices));
                if (new_items.document_associations !== undefined) dispatch((0, _documentSlice.addDocumentAssociations)(new_items.document_associations));
                if (new_items.advance_invoice_consumptions !== undefined) dispatch((0, _businessSlice.addAdvanceInvoiceConsumptions)(new_items.advance_invoice_consumptions));
                if (finish_invoice && this.props.document_types[item.invoice_type].fiscal_verification_enabled) this.setState({
                    wait_fiscal_verification_dialog_open: true,
                    wait_fiscal_verification_dialog_id_invoice: item.id_invoice
                });
            }
        }
        if (open_create_invoice_type !== undefined) {
            const new_item = (0, _invoiceCreatorDefault.default).Duplicate(item);
            new_item.id_invoice = (0, _uuidDefault.default).v4();
            new_item.invoice_number = '';
            new_item.invoice_number_internal = '';
            new_item.invoice_type = open_create_invoice_type;
            new_item.draft = true;
            new_item.reference = item.invoice_number_internal;
            new_item.original_id_invoice = item.id_invoice;
            new_item.original_invoice_type = item.invoice_type;
            new_item.note = '';
            if (open_create_invoice_type == 'prepayment-invoice') {
                new_item.invoice_date = this.toIsoString(new Date());
                new_item.payment_date = this.toIsoString(new Date());
            }
            for(let i = 0; i < new_item.payments.length; i++)new_item.payments[i].id_invoice_payment = null;
            for(let i = 0; i < new_item.items.length; i++)new_item.items[i].id_invoice_item = (0, _uuidDefault.default).v4();
            setTimeout(()=>{
                if (!this._ismounted) return;
                this.openEditInvoiceDialog(open_create_invoice_type, new_item);
            }, 1000);
        }
    }
    openDocumentListDialog(id_document) {
        this.setState({
            document_list_dialog_open: true,
            document_list_dialog_id_document: id_document
        });
    }
    closeDocumentListDialog() {
        this.setState({
            document_list_dialog_open: false,
            document_list_dialog_id_document: null
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('reservations--list') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.invoice_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editInvoiceDialogDefault.default), {
                    closeEditInvoiceDialog: this.closeEditInvoiceDialog,
                    item: this.state.invoice_dialog_item,
                    type: this.state.invoice_dialog_type
                }),
                !this.state.reservation_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reservationDefault.default), {
                    closeReservation: this.closeReservationDialog,
                    deleteReservation: null,
                    reservation: this.props.reservations[this.state.reservation_dialog_id_reservation],
                    open_id_reservation_customer: this.state.reservation_dialog_id_reservation_customer
                }),
                !this.state.document_list_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentListDialogDefault.default), {
                    id_document: this.state.document_list_dialog_id_document,
                    closeDialog: this.closeDocumentListDialog,
                    deep: true
                }),
                !this.state.wait_fiscal_verification_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _waitFiscalVerificationDialogDefault.default), {
                    closeWaitFiscalVerificationDialog: (print)=>{
                        this.setState({
                            wait_fiscal_verification_dialog_open: false
                        });
                        if (print) {
                            const invoice = this.props.invoices[this.state.wait_fiscal_verification_dialog_id_invoice];
                            if (this.props.general_settings.auto_print_type == 'a4') this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                                type: 'invoice',
                                lang: 'sl',
                                invoice
                            }));
                            else if (this.props.general_settings.auto_print_type == 'pos') this.props.dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                                type: 'invoice',
                                invoice
                            }));
                        }
                    },
                    id_invoice: this.state.wait_fiscal_verification_dialog_id_invoice
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow reservation-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pr-4 pt-4 flex",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "mr-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "filter",
                                            onClick: ()=>{
                                                const new_filters = {
                                                    id_accommodation_item_places: [],
                                                    statuses: [],
                                                    internal_code: '',
                                                    customer_name: '',
                                                    customer_id_countries: [],
                                                    customer_id_identification_types: [],
                                                    customer_identification_number: '',
                                                    check_in_range: [
                                                        (0, _momentDefault.default)().toDate(),
                                                        (0, _momentDefault.default)().toDate()
                                                    ],
                                                    check_out_range: [
                                                        null,
                                                        null
                                                    ],
                                                    guests_checked_in: null
                                                };
                                                this.filterTableItems(new_filters);
                                            },
                                            children: "Prihodi danes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "filter",
                                            onClick: ()=>{
                                                const new_filters = {
                                                    id_accommodation_item_places: [],
                                                    statuses: [],
                                                    internal_code: '',
                                                    customer_name: '',
                                                    customer_id_countries: [],
                                                    customer_id_identification_types: [],
                                                    customer_identification_number: '',
                                                    check_in_range: [
                                                        (0, _momentDefault.default)().add(1, 'day').toDate(),
                                                        (0, _momentDefault.default)().add(1, 'day').toDate()
                                                    ],
                                                    check_out_range: [
                                                        null,
                                                        null
                                                    ],
                                                    guests_checked_in: null
                                                };
                                                this.filterTableItems(new_filters);
                                            },
                                            children: "Prihodi jutri"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "mr-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "filter",
                                            onClick: ()=>{
                                                const new_filters = {
                                                    id_accommodation_item_places: [],
                                                    statuses: [],
                                                    internal_code: '',
                                                    customer_name: '',
                                                    customer_id_countries: [],
                                                    customer_id_identification_types: [],
                                                    customer_identification_number: '',
                                                    check_in_range: [
                                                        null,
                                                        null
                                                    ],
                                                    check_out_range: [
                                                        (0, _momentDefault.default)().toDate(),
                                                        (0, _momentDefault.default)().toDate()
                                                    ],
                                                    guests_checked_in: null
                                                };
                                                this.filterTableItems(new_filters);
                                            },
                                            children: "Odhodi danes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "warning",
                                            icon: "filter",
                                            onClick: ()=>{
                                                const new_filters = {
                                                    id_accommodation_item_places: [],
                                                    statuses: [],
                                                    internal_code: '',
                                                    customer_name: '',
                                                    customer_id_countries: [],
                                                    customer_id_identification_types: [],
                                                    customer_identification_number: '',
                                                    check_in_range: [
                                                        null,
                                                        null
                                                    ],
                                                    check_out_range: [
                                                        (0, _momentDefault.default)().add(1, 'day').toDate(),
                                                        (0, _momentDefault.default)().add(1, 'day').toDate()
                                                    ],
                                                    guests_checked_in: null
                                                };
                                                this.filterTableItems(new_filters);
                                            },
                                            children: "Odhodi jutri"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "primary",
                                    icon: "filter",
                                    onClick: ()=>{
                                        const new_filters = {
                                            id_accommodation_item_places: this.state.table_items_filters.id_accommodation_item_places,
                                            statuses: [
                                                'new',
                                                'waiting-for-confirmation',
                                                'offer-sent',
                                                'confirmed',
                                                'advance-invoice-sent'
                                            ],
                                            internal_code: this.state.table_items_filters.internal_code,
                                            customer_name: this.state.table_items_filters.customer_name,
                                            customer_id_countries: this.state.table_items_filters.customer_id_countries,
                                            customer_id_identification_types: this.state.table_items_filters.customer_id_identification_types,
                                            customer_identification_number: this.state.table_items_filters.customer_identification_number,
                                            check_in_range: this.state.table_items_filters.check_in_range,
                                            check_out_range: this.state.table_items_filters.check_out_range,
                                            guests_checked_in: this.state.table_items_filters.guests_checked_in
                                        };
                                        this.filterTableItems(new_filters);
                                    },
                                    children: "Odprte rezervacije (glede na izbrane filtre)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex-1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: "primary",
                                    icon: "expand-all",
                                    active: this.state.expanded,
                                    onClick: ()=>{
                                        this.setState({
                                            expanded: !this.state.expanded
                                        });
                                    },
                                    children: "Prika\u017Ei goste"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    reservation_customers: this.props.reservation_customers,
                                    customers: this.props.customers,
                                    accommodations: this.props.accommodations,
                                    accommodation_items: this.props.accommodation_items,
                                    accommodation_item_places: this.props.accommodation_item_places,
                                    countries: this.props.countries,
                                    accommodation_item_place_titles: this.state.accommodation_item_place_titles,
                                    statuses: this.state.statuses,
                                    identification_types: this.props.identification_types,
                                    openReservationDialog: this.openReservationDialog,
                                    guest_book_items: this.props.guest_book_items,
                                    document_associations: this.props.document_associations,
                                    invoices: this.props.invoices,
                                    openEditInvoiceDialog: this.openEditInvoiceDialog,
                                    expanded: this.state.expanded,
                                    openDocumentListDialog: this.openDocumentListDialog
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
ReservationList.propTypes = {};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        reservations: state.ReservationSlice.reservations,
        reservation_customers: state.ReservationSlice.reservation_customers,
        api_url: state.ReservationSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        accommodations: state.CodeTablesSlice.accommodations,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
        countries: state.CodeTablesSlice.countries,
        identification_types: state.CodeTablesSlice.identification_types,
        guest_book_items: state.GuestSlice.guest_book_items,
        document_associations: state.DocumentSlice.document_associations_id_documents,
        invoices: state.BusinessSlice.invoices,
        document_types: state.DocumentSlice.document_types,
        general_settings: state.SettingsSlice.general
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReservationList);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","uuid":"b52pV","moment":"1e4qG","@blueprintjs/core":"6Mq52","../code_tables/ResultComponents":"1eVlZ","../reservations/Reservation":"a8Yu8","../../slices/BusinessSlice":"47JXm","../../api/Business":"fC7Hd","../../slices/DocumentSlice":"6gdAm","../business/EditInvoiceDialog":"kxL93","../business/WaitFiscalVerificationDialog":"bvSNl","../../helpers/InvoiceCreator":"d7VsE","../DocumentListDialog":"3h6Eg","../../slices/AppSlice":"aByTQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eAUIs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _resultComponents = require("../code_tables/ResultComponents");
var _businessSlice = require("../../slices/BusinessSlice");
var _business = require("../../api/Business");
var _documentSlice = require("../../slices/DocumentSlice");
var _reservationSlice = require("../../slices/ReservationSlice");
var _reservations = require("../../api/Reservations");
var _editActivityItemDialog = require("./EditActivityItemDialog");
var _editActivityItemDialogDefault = parcelHelpers.interopDefault(_editActivityItemDialog);
var _waitFiscalVerificationDialog = require("../business/WaitFiscalVerificationDialog");
var _waitFiscalVerificationDialogDefault = parcelHelpers.interopDefault(_waitFiscalVerificationDialog);
var _editInvoiceDialog = require("../business/EditInvoiceDialog");
var _editInvoiceDialogDefault = parcelHelpers.interopDefault(_editInvoiceDialog);
var _invoiceCreator = require("../../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _documentListDialog = require("../DocumentListDialog");
var _documentListDialogDefault = parcelHelpers.interopDefault(_documentListDialog);
var _userTag = require("../UserTag");
var _userTagDefault = parcelHelpers.interopDefault(_userTag);
var _appSlice = require("../../slices/AppSlice");
function Documents(props) {
    if (props.documents.length == 0) return null;
    let items = [];
    const document = props.documents[0];
    let id_document = document.id_document;
    let document_type = document.document_type;
    let document_document_number = null;
    let document_click_handler = null;
    if (document_type == 'cash-invoice' || document_type == 'invoice' || document_type == 'offer' || document_type == 'prepayment-invoice' || document_type == 'credit-note') {
        const invoice_item = props.invoices[id_document];
        if (invoice_item !== undefined) {
            document_document_number = invoice_item.invoice_number_internal;
            document_click_handler = ()=>{
                props.openEditInvoiceDialog(invoice_item.invoice_type, invoice_item);
            };
        }
    }
    items.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
        small: true,
        className: "cell-button",
        onClick: document_click_handler,
        children: document_document_number
    }, "latest-document"));
    if (props.documents.length > 1) items.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
        small: true,
        className: "cell-button ml-1",
        onClick: props.openDocumentListDialog,
        icon: "multi-select"
    }, "more-documents"));
    return items;
}
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, tableItemsFilters, originalTableItemsFilters, handleFilterChange, customers, accommodation_item_schedule_time_slot_activities, accommodation_item_schedule_time_slots, activities, countries, statuses, openEditActivityItemDialog, openEditInvoiceDialog, channels, openDocumentListDialog, invoices, document_associations, users } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const toLocalString = (date)=>{
        if (date === null || date === undefined) return '';
        if (!(date instanceof Date)) return date;
        return (0, _momentDefault.default)(date).format('DD.MM.YYYY');
    };
    const customer_countries = {};
    for(let id_customer in customers){
        const id_country = customers[id_customer].id_country;
        if (customer_countries[id_country] !== undefined) continue;
        customer_countries[id_country] = {
            id_country,
            title: countries[id_country] === undefined ? '' : countries[id_country].common_name_local
        };
    }
    const getDocuments = (id_document, max_depth, depth)=>{
        depth = depth || 1;
        let items = {};
        if (depth > max_depth) return items;
        let documents = Object.values(document_associations[id_document] || {});
        for(let i = 0; i < documents.length; i++){
            let item = documents[i];
            let curr_id_document = item.source_id_document;
            let document_type = item.source_type;
            if (item.source_id_document == id_document) {
                curr_id_document = item.target_id_document;
                document_type = item.target_type;
            }
            if (items[item.id_document_association] === undefined) items[item.id_document_association] = {
                id_document_association: item.id_document_association,
                created: item.created,
                id_document: curr_id_document,
                document_type
            };
            const subitems = getDocuments(curr_id_document, max_depth, depth + 1);
            for(let id_document_association in subitems)if (items[id_document_association] === undefined) items[id_document_association] = subitems[id_document_association];
        }
        return items;
    };
    const getUserByUsername = (username)=>{
        if (users === null) return null;
        for(let id_user in users){
            const user = users[id_user];
            if (user !== undefined && user.username == username) return user;
        }
        return null;
    };
    let columnIdx = 1;
    let filtersColumnIdx = 1;
    let total_guest_count = 0;
    let total_guest_child_count = 0;
    const channels_for_filters = {
        '': {
            id_channel: '',
            title: 'Brez kanala',
            ord: 0
        },
        ...channels
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results mt-4 mb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table without-vertical-lines",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: columnIdx++,
                                title: ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: columnIdx++,
                                title: ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Datum in \u010Das",
                                fieldName: "reservation_date"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Aktivnost",
                                fieldName: "id_activity"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Status",
                                fieldName: "status"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "\u0160ifra",
                                fieldName: "internal_code"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Nosilec",
                                fieldName: "customer"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Dr\u017Eava",
                                fieldName: "customer_id_country"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Kanal",
                                fieldName: "id_channel"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                                columnIdx: columnIdx++,
                                ...sort_props,
                                title: "Osebe",
                                fieldName: "guest_count"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: columnIdx++,
                                title: "Vnesel"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                columnIdx: columnIdx++,
                                title: "Opomba"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "results-table without-vertical-lines filters-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                    filter_values: tableItemsFilters.reservation_date_range,
                                    short_year: true,
                                    original_start_date: originalTableItemsFilters.reservation_date_range[0],
                                    original_end_date: originalTableItemsFilters.reservation_date_range[1],
                                    onFilterChange: (values)=>handleFilterChange('reservation_date_range', values)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "id_activity",
                                        title_field: "title",
                                        items: activities,
                                        filtered_keys: tableItemsFilters.id_activities,
                                        displayFilter: null,
                                        displaySort: (a, b)=>a.title.localeCompare(b.title),
                                        onFilterChange: (values)=>handleFilterChange('id_activities', values)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "key",
                                        title_field: "title",
                                        items: statuses,
                                        filtered_keys: tableItemsFilters.statuses,
                                        onFilterChange: (values)=>handleFilterChange('statuses', values)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.internal_code,
                                    onChange: (event)=>handleFilterChange('internal_code', event)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                    value: tableItemsFilters.customer_name,
                                    onChange: (event)=>handleFilterChange('customer_name', event)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "id_country",
                                        title_field: "title",
                                        items: customer_countries,
                                        filtered_keys: tableItemsFilters.customer_id_countries,
                                        onFilterChange: (values)=>handleFilterChange('customer_id_countries', values)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                        empty_title: "Izberi",
                                        value_field: "id_channel",
                                        title_field: "title",
                                        items: channels_for_filters,
                                        filtered_keys: tableItemsFilters.id_channels,
                                        displayFilter: null,
                                        displaySort: (a, b)=>{
                                            if (a.ord == 0) return -1;
                                            if (b.ord == 0) return 1;
                                            return a.title.localeCompare(b.title);
                                        },
                                        onFilterChange: (values)=>handleFilterChange('id_channels', values)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: filtersColumnIdx++
                            })
                        ]
                    }),
                    table_items_sort_ids.map((id, idx)=>{
                        const item = table_items[id];
                        const customer = customers[item.id_customer] ?? null;
                        const accommodation_item_schedule_time_slot_activity = accommodation_item_schedule_time_slot_activities[item.id_accommodation_item_schedule_time_slot_activity];
                        const time_slot = accommodation_item_schedule_time_slots[accommodation_item_schedule_time_slot_activity.id_accommodation_item_schedule_time_slot];
                        const activity = activities[accommodation_item_schedule_time_slot_activity.id_activity];
                        const starts_at_arr = time_slot.starts_at.split(':');
                        const time_label = starts_at_arr.length != 3 ? '00:00' : starts_at_arr[0] + ':' + starts_at_arr[1];
                        let pattern_class_name = '';
                        if (item.status == 'offer-sent') pattern_class_name = 'reservation-list-pattern-polka-dots';
                        else if (item.status == 'advance-invoice-sent' || item.status == 'not-for-rent' /*with red background*/ ) pattern_class_name = 'reservation-list-pattern-diagonal-stripes';
                        const documents = Object.values(getDocuments(item.id_activity_reservation, 3)).sort((a, b)=>{
                            if (a.created < b.created) return 1;
                            if (a.created > b.created) return -1;
                            return 0;
                        }).filter((document)=>document.document_type == 'invoice' || document.document_type == 'cash-invoice');
                        total_guest_count += item.guest_count;
                        total_guest_child_count += item.guest_child_count;
                        columnIdx = 1;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "results-table without-vertical-lines status-" + (item.deleted === true ? 'deleted' : item.status) + ' ' + (item.status_2 === null ? '' : item.status_2),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    version: "1.1",
                                    baseProfile: "full",
                                    width: "16",
                                    height: "16",
                                    className: "custom-status",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M 0,0 L 16,0 L 0,16 L 0,0 z",
                                        fill: "#ff0000"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>openEditActivityItemDialog(item, item.id_accommodation_item_schedule_time_slot_activity, item.reservation_date)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: pattern_class_name == '' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: pattern_class_name
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: toLocalString(new Date(item.reservation_date)) + ' ob ' + time_label
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: activity.title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: statuses[item.deleted === true ? 'deleted' : item.status].title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: item.internal_code
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: item.id_customer === null || customers[item.id_customer] === undefined ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "grid grid-cols-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: customers[item.id_customer].type == 'natural' ? customers[item.id_customer].surname + ' ' + customers[item.id_customer].name : customers[item.id_customer].company_name
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-right",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Documents, {
                                                        documents: documents,
                                                        invoices: invoices,
                                                        openEditInvoiceDialog: openEditInvoiceDialog,
                                                        openDocumentListDialog: ()=>{
                                                            openDocumentListDialog(item.id_activity_reservation);
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: customer === null || customer.id_country === null || countries[customer.id_country] === undefined ? '' : countries[customer.id_country].common_name_local
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: item.id_channel === null ? '' : channels[item.id_channel].title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    child: item.guest_count + ' / ' + item.guest_child_count
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    cls: "flex items-center",
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userTagDefault.default), {
                                        user: getUserByUsername(item.username),
                                        reservation: item
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: columnIdx++,
                                    cls: "note",
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                        content: item.note,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: item.note
                                        })
                                    })
                                })
                            ]
                        }, 'result--result-' + id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results borderless mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            span: 4,
                            child: "\u0160tevilo zapisov: " + table_items_sort_ids.length
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            cls: "font-bold",
                            child: total_guest_count + ' / ' + total_guest_child_count
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            child: ''
                        })
                    ]
                })
            })
        ]
    });
}
class ActivitiesList extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openEditActivityItemDialog = this.openEditActivityItemDialog.bind(this);
        this.closeEditActivityItemDialog = this.closeEditActivityItemDialog.bind(this);
        //this.generateAccommodationItemPlaceTitles = this.generateAccommodationItemPlaceTitles.bind(this);
        //this.generateAccommodationItemPlaceOrds   = this.generateAccommodationItemPlaceOrds  .bind(this);
        this.openDocumentListDialog = this.openDocumentListDialog.bind(this);
        this.closeDocumentListDialog = this.closeDocumentListDialog.bind(this);
        this.openEditInvoiceDialog = this.openEditInvoiceDialog.bind(this);
        this.closeEditInvoiceDialog = this.closeEditInvoiceDialog.bind(this);
        const table_items_filters = {
            id_activities: [],
            id_channels: [],
            statuses: [],
            internal_code: '',
            customer_name: '',
            customer_id_countries: [],
            reservation_date_range: [
                (0, _momentDefault.default)({
                    hour: 0,
                    minute: 0
                }).toDate(),
                null
            ]
        };
        /*const accommodation_item_place_titles = this.generateAccommodationItemPlaceTitles(
			props.accommodations,
			props.accommodation_items,
			props.accommodation_item_places,
		);
		const accommodation_item_place_ords = this.generateAccommodationItemPlaceOrds(
			props.accommodations,
			props.accommodation_items,
			props.accommodation_item_places,
		);*/ const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'reservation_date',
            table_items_sort_direction: 'ASC'
        });
        const statuses = {
            'new': {
                title: 'Nova',
                key: 'new'
            },
            'waiting-for-confirmation': {
                title: 'V potrjevanju',
                key: 'waiting-for-confirmation'
            },
            'offer-sent': {
                title: 'Izdana ponudba',
                key: 'offer-sent'
            },
            'confirmed': {
                title: 'Potrjena',
                key: 'confirmed'
            },
            'advance-invoice-sent': {
                title: 'Izdan avans',
                key: 'advance-invoice-sent'
            },
            'closed': {
                title: "Pla\u010Dana",
                key: 'closed'
            },
            'reversed': {
                title: 'Stornirana',
                key: 'reversed'
            },
            'no-show': {
                title: 'Neprihod',
                key: 'no-show'
            },
            'deleted': {
                title: 'Brisana',
                key: 'deleted'
            }
        };
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'reservation_date',
            table_items_sort_direction: 'ASC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            date_range_picker_dialog_open: false,
            date_range_picker_dialog_filter_name: null,
            //accommodation_item_place_titles,
            //accommodation_item_place_ords,
            statuses,
            edit_activity_item_dialog_open: false,
            edit_activity_item_dialog_item: null,
            edit_activity_item_dialog_reservation_date: null,
            edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity: -1,
            document_list_dialog_open: false,
            document_list_dialog_id_document: null,
            invoice_dialog_open: false,
            invoice_dialog_item: null,
            invoice_dialog_type: '',
            wait_fiscal_verification_dialog_open: false,
            wait_fiscal_verification_dialog_id_invoice: null
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.activity_reservations != this.state.activity_reservations) this.setState(this.updateTableItemsFromProps(this.props, this.state));
        if (this.props.accommodations != prevProps.accommodations || this.props.accommodation_items != prevProps.accommodation_items || this.props.accommodation_item_places != prevProps.accommodation_item_places) /*this.setState({
				accommodation_item_place_titles: this.generateAccommodationItemPlaceTitles(
					this.props.accommodations,
					this.props.accommodation_items,
					this.props.accommodation_item_places,
				),
				accommodation_item_place_ords: this.generateAccommodationItemPlaceOrds(
					this.props.accommodations,
					this.props.accommodation_items,
					this.props.accommodation_item_places,
				),
			});*/ this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction);
    /*if (
			this.state.accommodation_item_place_titles != prevState.accommodation_item_place_titles ||
			this.state.accommodation_item_place_ords   != prevState.accommodation_item_place_ords
		) {
			this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction);
		}*/ }
    updateTableItemsFromProps(props, state) {
        const filtered_reservations = {};
        for(let id_activity_reservation in props.activity_reservations){
            const reservation = props.activity_reservations[id_activity_reservation];
            filtered_reservations[id_activity_reservation] = reservation;
        }
        const ids = Object.keys(filtered_reservations);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            activity_reservations: props.activity_reservations,
            table_items: filtered_reservations,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            let sort_val = 0;
            if (field == 'id_activity') {
                var id_activity_a = this.props.accommodation_item_schedule_time_slot_activities[state.table_items[a_key].id_accommodation_item_schedule_time_slot_activity].id_activity;
                var id_activity_b = this.props.accommodation_item_schedule_time_slot_activities[state.table_items[b_key].id_accommodation_item_schedule_time_slot_activity].id_activity;
                a = this.props.activities[id_activity_a].title;
                b = this.props.activities[id_activity_b].title;
                sort_val = a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'status') {
                a = state.statuses[state.table_items[a_key].deleted === true ? 'deleted' : state.table_items[a_key][field]].title;
                b = state.statuses[state.table_items[b_key].deleted === true ? 'deleted' : state.table_items[b_key][field]].title;
                sort_val = a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'customer') {
                const reservation_a = state.table_items[a_key];
                const reservation_b = state.table_items[b_key];
                const customer_a = this.props.customers[reservation_a.id_customer];
                const customer_b = this.props.customers[reservation_b.id_customer];
                a = customer_a === undefined ? '' : customer_a.type == 'natural' ? customer_a.surname + ' ' + customer_a.name : customer_a.company_name;
                b = customer_b === undefined ? '' : customer_b.type == 'natural' ? customer_b.surname + ' ' + customer_b.name : customer_b.company_name;
                sort_val = a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'customer_id_country') {
                const reservation_a = state.table_items[a_key];
                const reservation_b = state.table_items[b_key];
                const customer_a = this.props.customers[reservation_a.id_customer];
                const customer_b = this.props.customers[reservation_b.id_customer];
                a = customer_a === undefined ? '' : customer_a.id_country === null ? '' : this.props.countries[customer_a.id_country].common_name_local;
                b = customer_b === undefined ? '' : customer_b.id_country === null ? '' : this.props.countries[customer_b.id_country].common_name_local;
                sort_val = a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'reservation_date') {
                const reservation_a = state.table_items[a_key];
                const reservation_b = state.table_items[b_key];
                const time_slot_a = this.props.accommodation_item_schedule_time_slots[this.props.accommodation_item_schedule_time_slot_activities[reservation_a.id_accommodation_item_schedule_time_slot_activity].id_accommodation_item_schedule_time_slot];
                const starts_at_arr_a = time_slot_a.starts_at.split(':');
                let time_label_a = starts_at_arr_a.length != 3 ? '00:00' : starts_at_arr_a[0] + ':' + starts_at_arr_a[1];
                const time_slot_b = this.props.accommodation_item_schedule_time_slots[this.props.accommodation_item_schedule_time_slot_activities[reservation_b.id_accommodation_item_schedule_time_slot_activity].id_accommodation_item_schedule_time_slot];
                const starts_at_arr_b = time_slot_b.starts_at.split(':');
                let time_label_b = starts_at_arr_b.length != 3 ? '00:00' : starts_at_arr_b[0] + ':' + starts_at_arr_b[1];
                time_label_a = reservation_a.reservation_date + ' ' + time_label_a;
                time_label_b = reservation_b.reservation_date + ' ' + time_label_b;
                sort_val = time_label_a.localeCompare(time_label_b) * (dir == 'ASC' ? 1 : -1);
            } else {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
                sort_val = (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
            }
            // if otherwise equal, sort by created, older first
            if (sort_val == 0) {
                a = state.table_items[a_key].created;
                b = state.table_items[b_key].created;
                sort_val = a < b ? -1 : a > b ? 1 : 0;
            }
            return sort_val;
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_id_activities = filters.id_activities;
        const filters_id_channels = filters.id_channels;
        const filters_statuses = filters.statuses;
        const filters_internal_code = filters.internal_code.toUpperCase();
        const filters_customer_name = filters.customer_name.toUpperCase();
        const filters_customer_id_countries = filters.customer_id_countries;
        const filter_reservation_date_start = filters.reservation_date_range[0] === null ? null : this.toIsoString(filters.reservation_date_range[0]);
        const filter_reservation_date_end = filters.reservation_date_range[1] === null ? null : this.toIsoString(filters.reservation_date_range[1]);
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_id_activities.length > 0) {
                let found = false;
                for(let i = 0; i < filters_id_activities.length; i++){
                    const id_activity = this.props.accommodation_item_schedule_time_slot_activities[item.id_accommodation_item_schedule_time_slot_activity].id_activity;
                    if (id_activity == filters_id_activities[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) return false;
            }
            if (filters_id_channels.length > 0) {
                let found = false;
                for(let i = 0; i < filters_id_channels.length; i++)if (item.id_channel === null && filters_id_channels[i] == '' || item.id_channel == filters_id_channels[i]) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (filters_statuses.length > 0) {
                let found = false;
                for(let i = 0; i < filters_statuses.length; i++)if (filters_statuses[i] == 'deleted' && item.deleted === true || item.status == filters_statuses[i] && item.deleted !== true) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (filters_internal_code != '') {
                if (item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) return false;
            }
            if (filters_customer_name != '') {
                const filter = (customer)=>{
                    if (customer === undefined) return false;
                    return (customer.surname + ' ' + customer.name + ' ' + customer.company_name).toUpperCase().indexOf(filters_customer_name) != -1;
                };
                let found = filter(this.props.customers[item.id_customer]);
                if (!found) return false;
            }
            if (filters_customer_id_countries.length > 0) {
                const filter = (customer)=>{
                    if (customer === undefined) return false;
                    return customer.id_country !== null && filters_customer_id_countries.indexOf(customer.id_country) != -1;
                };
                let found = filter(this.props.customers[item.id_customer]);
                if (!found) return false;
            }
            if (filter_reservation_date_start !== null) {
                const filter = (customer)=>{
                    if (customer === undefined) return false;
                    return customer.reservation_date === null || this.toIsoString(new Date(customer.reservation_date)) >= filter_reservation_date_start;
                };
                let found = filter(item);
                if (!found) return false;
            }
            if (filter_reservation_date_end !== null) {
                const filter = (customer)=>{
                    if (customer === undefined) return false;
                    return customer.reservation_date === null || this.toIsoString(new Date(customer.reservation_date)) <= filter_reservation_date_end;
                };
                let found = filter(item);
                if (!found) return false;
            }
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            id_activities: this.state.table_items_filters.id_activities,
            id_channels: this.state.table_items_filters.id_channels,
            statuses: this.state.table_items_filters.statuses,
            internal_code: this.state.table_items_filters.internal_code,
            customer_name: this.state.table_items_filters.customer_name,
            customer_id_countries: this.state.table_items_filters.customer_id_countries,
            reservation_date_range: this.state.table_items_filters.reservation_date_range
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openEditActivityItemDialog(item, id_accommodation_item_schedule_time_slot_activity, reservation_date) {
        this.setState({
            edit_activity_item_dialog_open: true,
            edit_activity_item_dialog_item: item,
            edit_activity_item_dialog_reservation_date: reservation_date,
            edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity: id_accommodation_item_schedule_time_slot_activity
        });
    }
    async closeEditActivityItemDialog(original_item, item) {
        this.setState({
            edit_activity_item_dialog_open: false
        });
        if (item !== undefined) {
            let new_item = {};
            if (original_item !== null) {
                new_item = {
                    ...original_item
                };
                new_item.guest_count = item.guest_count;
                new_item.guest_child_count = item.guest_child_count;
                new_item.note = item.note;
                new_item.id_channel = item.id_channel == -1 ? null : item.id_channel;
                new_item.id_customer = item.id_customer;
                new_item.phone = '';
                new_item.email = '';
                new_item.reservation_date = item.reservation_date;
                new_item.status = item.status;
                new_item.status_2 = item.status_2 == '' ? null : item.status_2;
                new_item.deleted = item.deleted;
            } else new_item = {
                id_activity_reservation: -1,
                guest_count: item.guest_count,
                guest_child_count: item.guest_child_count,
                note: item.note,
                id_channel: item.id_channel == -1 ? null : item.id_channel,
                id_customer: item.id_customer,
                phone: '',
                email: '',
                status: item.status,
                status_2: item.status_2 == '' ? null : item.status_2,
                reservation_date: item.reservation_date,
                id_accommodation_item_schedule_time_slot_activity: this.state.edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity,
                deleted: false,
                username: this.props.user.username
            };
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            dispatch((0, _reservationSlice.addActivityReservation)({
                item: new_item,
                token
            }));
            new_item = await (0, _reservations.saveActivityReservation)(this.props.api_url, new_item, token);
            if (new_item !== null) dispatch((0, _reservationSlice.addActivityReservation)({
                item: new_item,
                token
            }));
        }
    }
    openDocumentListDialog(id_document) {
        this.setState({
            document_list_dialog_open: true,
            document_list_dialog_id_document: id_document
        });
    }
    closeDocumentListDialog() {
        this.setState({
            document_list_dialog_open: false,
            document_list_dialog_id_document: null
        });
    }
    openEditInvoiceDialog(type, item) {
        this.setState({
            invoice_dialog_open: true,
            invoice_dialog_type: type,
            invoice_dialog_item: item
        });
    }
    async closeEditInvoiceDialog(item, open_create_invoice_type, finish_invoice) {
        this.setState({
            invoice_dialog_open: false,
            invoice_dialog_item: null
        });
        if (item !== undefined) {
            this.props.dispatch((0, _businessSlice.addInvoice)({
                item,
                token: this.props.token
            }));
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            const new_items = await (0, _business.saveInvoice)(this.props.api_url, item, token, dispatch);
            if (new_items !== null) {
                if (new_items.invoices !== undefined) dispatch((0, _businessSlice.addInvoices)(new_items.invoices));
                if (new_items.document_associations !== undefined) dispatch((0, _documentSlice.addDocumentAssociations)(new_items.document_associations));
                if (new_items.advance_invoice_consumptions !== undefined) dispatch((0, _businessSlice.addAdvanceInvoiceConsumptions)(new_items.advance_invoice_consumptions));
                if (finish_invoice && this.props.document_types[item.invoice_type].fiscal_verification_enabled) this.setState({
                    wait_fiscal_verification_dialog_open: true,
                    wait_fiscal_verification_dialog_id_invoice: item.id_invoice
                });
            }
        }
        if (open_create_invoice_type !== undefined) {
            const new_item = (0, _invoiceCreatorDefault.default).Duplicate(item);
            new_item.id_invoice = (0, _uuidDefault.default).v4();
            new_item.invoice_number = '';
            new_item.invoice_number_internal = '';
            new_item.invoice_type = open_create_invoice_type;
            new_item.draft = true;
            new_item.reference = item.invoice_number_internal;
            new_item.original_id_invoice = item.id_invoice;
            new_item.original_invoice_type = item.invoice_type;
            new_item.note = '';
            if (open_create_invoice_type == 'prepayment-invoice') {
                new_item.invoice_date = this.toIsoString(new Date());
                new_item.payment_date = this.toIsoString(new Date());
            }
            for(let i = 0; i < new_item.payments.length; i++)new_item.payments[i].id_invoice_payment = null;
            for(let i = 0; i < new_item.items.length; i++)new_item.items[i].id_invoice_item = (0, _uuidDefault.default).v4();
            setTimeout(()=>{
                if (!this._ismounted) return;
                this.openEditInvoiceDialog(open_create_invoice_type, new_item);
            }, 1000);
        }
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('reservations') === -1) return null;
        if ((this.props.user.access_roles ?? []).indexOf('reservations--list') === -1) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.edit_activity_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editActivityItemDialogDefault.default), {
                    closeEditActivityItemDialog: this.closeEditActivityItemDialog,
                    item: this.state.edit_activity_item_dialog_item,
                    reservation_date: this.state.edit_activity_item_dialog_reservation_date,
                    time_slot: this.props.accommodation_item_schedule_time_slots[this.props.accommodation_item_schedule_time_slot_activities[this.state.edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity].id_accommodation_item_schedule_time_slot],
                    activity: this.props.activities[this.props.accommodation_item_schedule_time_slot_activities[this.state.edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity].id_activity],
                    accommodation_item_schedule_time_slot_activity: this.props.accommodation_item_schedule_time_slot_activities[this.state.edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity],
                    setCurrentDate: null
                }),
                !this.state.invoice_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editInvoiceDialogDefault.default), {
                    closeEditInvoiceDialog: this.closeEditInvoiceDialog,
                    item: this.state.invoice_dialog_item,
                    type: this.state.invoice_dialog_type
                }),
                !this.state.document_list_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentListDialogDefault.default), {
                    id_document: this.state.document_list_dialog_id_document,
                    closeDialog: this.closeDocumentListDialog
                }),
                !this.state.wait_fiscal_verification_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _waitFiscalVerificationDialogDefault.default), {
                    closeWaitFiscalVerificationDialog: (print)=>{
                        this.setState({
                            wait_fiscal_verification_dialog_open: false
                        });
                        if (print) {
                            const invoice = this.props.invoices[this.state.wait_fiscal_verification_dialog_id_invoice];
                            if (this.props.general_settings.auto_print_type == 'a4') this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                                type: 'invoice',
                                lang: 'sl',
                                invoice
                            }));
                            else if (this.props.general_settings.auto_print_type == 'pos') this.props.dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                                type: 'invoice',
                                invoice
                            }));
                        }
                    },
                    id_invoice: this.state.wait_fiscal_verification_dialog_id_invoice
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex flex-col flex-grow activity-reservation-list mt-16",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1 pl-4 pr-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-grow overflow-y-auto",
                            style: {
                                flexBasis: '0'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                table_items: this.state.table_items,
                                table_items_sort_ids: this.state.table_items_sort_ids,
                                table_items_sort_field: this.state.table_items_sort_field,
                                table_items_sort_direction: this.state.table_items_sort_direction,
                                setTableItemsSort: this.setTableItemsSort,
                                tableItemsFilters: this.state.table_items_filters,
                                originalTableItemsFilters: this.state.original_table_items_filters,
                                handleFilterChange: this.handleFilterChange,
                                customers: this.props.customers,
                                activities: this.props.activities,
                                countries: this.props.countries,
                                statuses: this.state.statuses,
                                openEditActivityItemDialog: this.openEditActivityItemDialog,
                                openEditInvoiceDialog: this.openEditInvoiceDialog,
                                channels: this.props.channels,
                                accommodation_item_schedule_time_slots: this.props.accommodation_item_schedule_time_slots,
                                accommodation_item_schedule_time_slot_activities: this.props.accommodation_item_schedule_time_slot_activities,
                                openDocumentListDialog: this.openDocumentListDialog,
                                document_associations: this.props.document_associations,
                                invoices: this.props.invoices,
                                users: this.props.users
                            })
                        })
                    })
                })
            ]
        });
    }
}
ActivitiesList.propTypes = {};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        api_url: state.ReservationSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        users: state.UserSlice.users,
        channels: state.CodeTablesSlice.channels,
        countries: state.CodeTablesSlice.countries,
        accommodation_item_schedules: state.CodeTablesSlice.accommodation_item_schedules,
        accommodation_item_schedule_time_slots: state.CodeTablesSlice.accommodation_item_schedule_time_slots,
        accommodation_item_schedule_time_slot_activities: state.CodeTablesSlice.accommodation_item_schedule_time_slot_activities,
        activities: state.CodeTablesSlice.activities,
        activity_reservations: state.ReservationSlice.activity_reservations,
        document_associations: state.DocumentSlice.document_associations_id_documents,
        invoices: state.BusinessSlice.invoices,
        document_types: state.DocumentSlice.document_types,
        general_settings: state.SettingsSlice.general
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ActivitiesList);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","uuid":"b52pV","moment":"1e4qG","@blueprintjs/core":"6Mq52","../code_tables/ResultComponents":"1eVlZ","../../slices/BusinessSlice":"47JXm","../../api/Business":"fC7Hd","../../slices/DocumentSlice":"6gdAm","../../slices/ReservationSlice":"kTPna","../../api/Reservations":"8B3n3","./EditActivityItemDialog":"eGJmb","../business/WaitFiscalVerificationDialog":"bvSNl","../business/EditInvoiceDialog":"kxL93","../../helpers/InvoiceCreator":"d7VsE","../DocumentListDialog":"3h6Eg","../UserTag":"jXGJj","../../slices/AppSlice":"aByTQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cS8Ej":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _settingsSlice = require("../../slices/SettingsSlice");
var _settings = require("../../api/Settings");
var _localStorageHelper = require("../../helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
var _resultComponents = require("../code_tables/ResultComponents");
var _editSettingsItemDialog = require("./EditSettingsItemDialog");
var _editSettingsItemDialogDefault = parcelHelpers.interopDefault(_editSettingsItemDialog);
var _editSettingsItemVATDialog = require("./EditSettingsItemVATDialog");
var _editSettingsItemVATDialogDefault = parcelHelpers.interopDefault(_editSettingsItemVATDialog);
var _editSettingsItemFileDialog = require("./EditSettingsItemFileDialog");
var _editSettingsItemFileDialogDefault = parcelHelpers.interopDefault(_editSettingsItemFileDialog);
var _editSettingsItemSwitchDialog = require("./EditSettingsItemSwitchDialog");
var _editSettingsItemSwitchDialogDefault = parcelHelpers.interopDefault(_editSettingsItemSwitchDialog);
var _editSettingsItemNumberDialog = require("./EditSettingsItemNumberDialog");
var _editSettingsItemNumberDialogDefault = parcelHelpers.interopDefault(_editSettingsItemNumberDialog);
var _editSettingsItemDropdownDialog = require("./EditSettingsItemDropdownDialog");
var _editSettingsItemDropdownDialogDefault = parcelHelpers.interopDefault(_editSettingsItemDropdownDialog);
var _editSettingsItemMultilineDialog = require("./EditSettingsItemMultilineDialog");
var _editSettingsItemMultilineDialogDefault = parcelHelpers.interopDefault(_editSettingsItemMultilineDialog);
const SubjectTypes = {
    'legal-person': 'Pravna oseba',
    'sole-proprietorship-simple-bookkeeping': 'Samostojni podjetnik - enostavno knjigovodstvo',
    'sole-proprietorship-double-bookkeeping': 'Samostojni podjetnik - dvostavno knjigovodstvo',
    'public-institution': 'Javni zavod',
    'association': "Dru\u0161tvo",
    'non-profit-organization-of-private-law': 'Nepridobitna organizacija zasebnega prava',
    'natural-person-with-activity': "Fizi\u010Dne osebe z dejavnostjo"
};
const ScannerChangeCase = {
    'original': 'Brez spremembe',
    'uppercase': "Velike \u010Drke",
    'lowercase': "Majhne \u010Drke",
    'title-case': "Velike za\u010Detnice"
};
function Results(props) {
    const { item, openEditSettingsItemDialog, subject_types } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: "Podatki o podjetju"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Nastavitev"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 3,
                        title: "Vrednost"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-table",
                children: [
                    {
                        key: 'subject_type',
                        title: 'Vrsta subjekta'
                    },
                    {
                        key: 'subject_long_name',
                        title: 'Uradni naziv subjekta'
                    },
                    {
                        key: 'subject_short_name',
                        title: "Kraj\u0161i naziv subjekta"
                    },
                    {
                        key: 'subject_address',
                        title: 'Naslov'
                    },
                    {
                        key: 'subject_post_code',
                        title: "Po\u0161tna \u0161tevilka"
                    },
                    {
                        key: 'subject_city',
                        title: 'Kraj'
                    },
                    {
                        key: 'subject_email',
                        title: "E-po\u0161ta"
                    },
                    {
                        key: 'subject_website',
                        title: 'Spletna stran'
                    },
                    {
                        key: 'subject_phone_1',
                        title: "Telefonska \u0161tevilka"
                    },
                    {
                        key: 'subject_phone_2',
                        title: "Mobilna \u0161tevilka"
                    },
                    {
                        key: 'subject_trr_1',
                        title: 'TRR (primarni)'
                    },
                    {
                        key: 'subject_trr_2',
                        title: 'TRR (dodatni)'
                    },
                    {
                        key: 'subject_tax_number',
                        title: "Dav\u010Dna \u0161tevilka"
                    },
                    {
                        key: 'vat',
                        title: 'Zavezanec za DDV'
                    },
                    {
                        key: 'subject_registration_number',
                        title: "Mati\u010Dna \u0161tevilka"
                    },
                    {
                        key: 'logo',
                        title: 'Logo'
                    },
                    {
                        key: 'footer',
                        title: 'Tekst v nogi'
                    },
                    {
                        key: 'tourist_tax_text',
                        title: 'Tekst za TT'
                    }
                ].map((property)=>{
                    let value = item[property.key];
                    let type = 'general';
                    if (property.key == 'subject_type') {
                        value = subject_types[value];
                        type = 'dropdown';
                    } else if (property.key == 'logo') {
                        value = value === null || value === undefined || value.length < 60 ? value : value.substring(0, 20) + '...' + value.substring(value.length - 20);
                        type = 'file';
                    } else if (property.key == 'footer' || property.key == 'tourist_tax_text') {
                        value = (value === null || value === undefined ? '' : value).replace('\n', ' ');
                        type = 'multiline';
                    } else if (property.key == 'vat') {
                        value = item.subject_vat_registered === null ? '' : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                            icon: item.subject_vat_registered ? 'tick' : 'cross'
                        });
                        if (value != '') value = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: value
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ml-1",
                                    children: item.subject_vat_registered ? item.subject_vat_number : item.subject_vat_registered_reason
                                })
                            ]
                        });
                        type = 'vat';
                    }
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "edit",
                                    intent: "primary",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>{
                                        openEditSettingsItemDialog(type, item, property.key);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2,
                                child: property.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: value
                            })
                        ]
                    }, 'settings-result--property-' + property.key);
                })
            }, 'settings-result-1'),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table mt-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: "Dav\u010Dna blagajna"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Nastavitev"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 3,
                        title: "Vrednost"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-table",
                children: [
                    {
                        key: 'certificate',
                        title: 'Certifikat'
                    },
                    {
                        key: 'certificate_password',
                        title: 'Geslo za certifikat'
                    }
                ].map((property)=>{
                    let value = item[property.key];
                    let type = 'general';
                    if (property.key == 'subject_type') {
                        value = subject_types[value];
                        type = 'dropdown';
                    } else if (property.key == 'certificate') {
                        value = value === null || value === undefined || value.length < 60 ? value : value.substring(0, 20) + '...' + value.substring(value.length - 20);
                        type = 'file';
                    }
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "edit",
                                    intent: "primary",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>{
                                        openEditSettingsItemDialog(type, item, property.key);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2,
                                child: property.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: value
                            })
                        ]
                    }, 'settings-result--property-' + property.key);
                })
            }, 'settings-result-2'),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table mt-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: "Razno"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Nastavitev"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 3,
                        title: "Vrednost"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-table",
                children: [
                    {
                        key: 'save_path',
                        title: 'Pot za shranjevanje dokumentov',
                        value: (0, _localStorageHelperDefault.default).GetValue(props.client + '__save_path')
                    }
                ].map((property)=>{
                    let key = property.key;
                    let value = property.value;
                    let type = 'general';
                    let new_item = item;
                    let extra = {};
                    if (key == 'save_path') {
                        new_item = {};
                        new_item[key] = value;
                    }
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "edit",
                                    intent: "primary",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>{
                                        openEditSettingsItemDialog(type, new_item, key, extra);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2,
                                child: property.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: value
                            })
                        ]
                    }, 'settings-result--property-' + key);
                })
            }, 'settings-result-4'),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table mt-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: "OCR"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Nastavitev"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 3,
                        title: "Vrednost"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-table",
                children: [
                    {
                        key: 'scanner_change_case',
                        title: "Sprememba velikosti \u010Drk",
                        value: ScannerChangeCase[item['scanner_change_case']]
                    }
                ].map((property)=>{
                    let key = property.key;
                    let value = property.value;
                    let type = 'general';
                    if (property.key == 'scanner_change_case') type = 'dropdown';
                    let new_item = item;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "edit",
                                    intent: "primary",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>{
                                        openEditSettingsItemDialog(type, new_item, key);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2,
                                child: property.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: value
                            })
                        ]
                    }, 'settings-result--property-' + key);
                })
            }, 'settings-result-5')
        ]
    });
}
class GeneralSettings extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.openEditSettingsItemDialog = this.openEditSettingsItemDialog.bind(this);
        this.closeEditSettingsItemDialog = this.closeEditSettingsItemDialog.bind(this);
        const { item } = this.updateTableItemsFromProps(props);
        this.state = {
            item,
            edit_settings_item_dialog_open: false,
            edit_settings_item_dialog_item: null,
            edit_settings_item_dialog_property_key: null,
            edit_settings_item_dialog_extra: null
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.general_settings != this.state.item) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        return {
            item: props.general_settings
        };
    }
    openEditSettingsItemDialog(type, item, property_key, extra) {
        this.setState({
            edit_settings_item_dialog_open: true,
            edit_settings_item_dialog_type: type,
            edit_settings_item_dialog_item: item,
            edit_settings_item_dialog_property_key: property_key,
            edit_settings_item_dialog_extra: extra ?? {}
        });
    }
    async closeEditSettingsItemDialog(item, property_key, new_value) {
        this.setState({
            edit_settings_item_dialog_open: false,
            edit_settings_item_dialog_type: null,
            edit_settings_item_dialog_item: null,
            edit_settings_item_dialog_property_key: null,
            edit_settings_item_dialog_extra: null
        });
        if (item !== undefined) {
            if (property_key == 'save_path') (0, _localStorageHelperDefault.default).SetValue(this.props.client + '__save_path', new_value);
            else if (property_key == 'vat') {
                let new_item = {
                    ...item
                };
                new_item.subject_vat_registered = new_value.subject_vat_registered;
                new_item.subject_vat_registered_reason = new_value.subject_vat_registered_reason;
                new_item.subject_vat_number = new_value.subject_vat_number;
                this.props.dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
                const dispatch = this.props.dispatch;
                const token = this.props.token;
                new_item = await (0, _settings.saveGeneralSettings)(this.props.api_url, new_item, token);
                if (new_item !== null) dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
            } else {
                let new_item = {
                    ...item
                };
                new_item[property_key] = new_value;
                this.props.dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
                const dispatch = this.props.dispatch;
                const token = this.props.token;
                new_item = await (0, _settings.saveGeneralSettings)(this.props.api_url, new_item, token);
                if (new_item !== null) dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
            }
        }
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('settings--general') === -1) return null;
        let edit_settings_dialog = null;
        if (this.state.edit_settings_item_dialog_open) {
            if (this.state.edit_settings_item_dialog_type == 'dropdown') {
                let options = SubjectTypes;
                if (this.state.edit_settings_item_dialog_property_key == 'scanner_change_case') options = ScannerChangeCase;
                edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemDropdownDialogDefault.default), {
                    item: this.state.edit_settings_item_dialog_item,
                    property_key: this.state.edit_settings_item_dialog_property_key,
                    extra: this.state.edit_settings_item_dialog_extra,
                    closeDialog: this.closeEditSettingsItemDialog,
                    options: options
                });
            } else if (this.state.edit_settings_item_dialog_type == 'file') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemFileDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else if (this.state.edit_settings_item_dialog_type == 'multiline') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemMultilineDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else if (this.state.edit_settings_item_dialog_type == 'bool') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemSwitchDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else if (this.state.edit_settings_item_dialog_type == 'vat') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemVATDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else if (this.state.edit_settings_item_dialog_type == 'number') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemNumberDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                edit_settings_dialog,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex flex-col flex-grow general-settings-list",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1 pl-4 pr-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-grow overflow-y-auto",
                            style: {
                                flexBasis: '0'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                item: this.state.item,
                                openEditSettingsItemDialog: this.openEditSettingsItemDialog,
                                subject_types: SubjectTypes,
                                client: this.props.client
                            })
                        })
                    })
                })
            ]
        });
    }
}
GeneralSettings.propTypes = {};
function mapStateToProps(state) {
    return {
        general_settings: state.SettingsSlice.general,
        api_url: state.SettingsSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        client: state.ConstantsSlice.client
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(GeneralSettings);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","../../slices/SettingsSlice":"ajHkF","../../api/Settings":"51MNf","../../helpers/LocalStorageHelper":"9I9tm","../code_tables/ResultComponents":"1eVlZ","./EditSettingsItemDialog":"3zOCG","./EditSettingsItemVATDialog":"6XqYR","./EditSettingsItemFileDialog":"bySUH","./EditSettingsItemSwitchDialog":"4SKSx","./EditSettingsItemNumberDialog":"9uFcm","./EditSettingsItemDropdownDialog":"3XDWw","./EditSettingsItemMultilineDialog":"c8mQ1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"51MNf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadGeneralSettings", ()=>loadGeneralSettings);
parcelHelpers.export(exports, "saveGeneralSettings", ()=>saveGeneralSettings);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _settingsSlice = require("../slices/SettingsSlice");
var _userSlice = require("../slices/UserSlice");
async function loadGeneralSettings(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Settings/v1/settings', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let item = await response.json();
    if (item.error_code !== undefined) {
        if (item.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _settingsSlice.setGeneralSettings)(item));
}
async function saveGeneralSettings(api_url, settings, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(settings));
    let response = await fetch(api_url + 'Settings/v1/save-settings', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else //delete new_item.items;
    //delete new_item.payments;
    //dispatch(addInvoice(new_item));
    return new_item;
    return null;
}

},{"js-cookie":"2d7Fe","../slices/SettingsSlice":"ajHkF","../slices/UserSlice":"ikKoo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3zOCG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
class EditSettingsItemDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            value: props.item[props.property_key]
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "edit-settings-item-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Uredi nastavitev"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-1 flex-col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                labelFor: "edit-settings-item-dialog--value",
                                className: "flex-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                    id: "edit-settings-item-dialog--value",
                                    value: this.state.value,
                                    onChange: (event)=>{
                                        this.setState({
                                            value: event.target.value
                                        });
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.props.item, this.props.property_key, this.state.value);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
EditSettingsItemDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = EditSettingsItemDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6XqYR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
class EditSettingsItemVATDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            subject_vat_registered: props.item.subject_vat_registered,
            subject_vat_registered_reason: props.item.subject_vat_registered_reason,
            subject_vat_number: props.item.subject_vat_number
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "edit-settings-item-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Uredi nastavitev"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "edit-settings-item-dialog--subject_vat_registered",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: "Zavezanec za DDV:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            id: "edit-settings-item-dialog--subject_vat_registered",
                                            checked: this.state.subject_vat_registered,
                                            onChange: (event)=>{
                                                this.setState({
                                                    subject_vat_registered: event.target.checked
                                                });
                                            }
                                        })
                                    ]
                                }),
                                this.state.subject_vat_registered === true ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "edit-settings-item-dialog--subject_vat_registered_reason",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: "Klavzula:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "edit-settings-item-dialog--subject_vat_registered_reason",
                                            value: this.state.subject_vat_registered_reason,
                                            onChange: (event)=>{
                                                this.setState({
                                                    subject_vat_registered_reason: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                this.state.subject_vat_registered === false ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    labelFor: "edit-settings-item-dialog--subject_vat_number",
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: "ID za DDV:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                            id: "edit-settings-item-dialog--subject_vat_number",
                                            value: this.state.subject_vat_number,
                                            onChange: (event)=>{
                                                this.setState({
                                                    subject_vat_number: event.target.value
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        const val = {
                                            subject_vat_registered: this.state.subject_vat_registered,
                                            subject_vat_registered_reason: this.state.subject_vat_registered ? '' : this.state.subject_vat_registered_reason,
                                            subject_vat_number: this.state.subject_vat_registered ? this.state.subject_vat_number : ''
                                        };
                                        this.props.closeDialog(this.props.item, this.props.property_key, val);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
EditSettingsItemVATDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = EditSettingsItemVATDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bySUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
class EditSettingsItemFileDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            value: props.item[props.property_key]
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "edit-settings-item-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Uredi nastavitev"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                    className: "flex-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FileInput), {
                                        text: "Izberi novo datoteko ...",
                                        onInputChange: async (e)=>{
                                            e.preventDefault();
                                            const reader = new FileReader();
                                            reader.onload = async (e)=>{
                                                const contents = e.target.result;
                                                const base64_contents = contents.substring(contents.indexOf(';base64,') + 8);
                                                this.setState({
                                                    value: base64_contents
                                                });
                                            };
                                            reader.readAsDataURL(e.target.files[0]);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: "Trenutna vsebina:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        wordBreak: 'break-all'
                                    },
                                    children: this.state.value === undefined || this.state.value === null || this.state.value.length < 60 ? this.state.value : this.state.value.substring(0, 20) + '...' + this.state.value.substring(this.state.value.length - 20)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).WARNING,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.props.item, this.props.property_key, '');
                                    },
                                    children: "Odstrani"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.props.item, this.props.property_key, this.state.value);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
EditSettingsItemFileDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = EditSettingsItemFileDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4SKSx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
class EditSettingsItemSwitchDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            value: props.item[props.property_key]
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "edit-settings-item-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Uredi nastavitev"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-1 flex-col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                labelFor: "edit-settings-item-dialog--value",
                                className: "flex-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    id: "edit-settings-item-dialog--value",
                                    checked: this.state.value,
                                    onChange: (event)=>{
                                        this.setState({
                                            value: event.target.checked
                                        });
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.props.item, this.props.property_key, this.state.value);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
EditSettingsItemSwitchDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = EditSettingsItemSwitchDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9uFcm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
class EditSettingsItemNumberDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            value: props.item[props.property_key]
        };
    }
    render() {
        console.log({
            item: this.props.item,
            comment: this.props.item.comment
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "edit-settings-item-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Uredi nastavitev"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-1 flex-col",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                    labelFor: "edit-settings-item-dialog--value",
                                    className: "flex-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                        id: "edit-settings-item-dialog--value",
                                        value: this.state.value,
                                        type: "number",
                                        onChange: (event)=>{
                                            this.setState({
                                                value: event.target.value
                                            });
                                        }
                                    })
                                })
                            }),
                            (this.props.extra.comment ?? '').length === 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: this.props.extra.comment
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.props.item, this.props.property_key, this.state.value);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
EditSettingsItemNumberDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = EditSettingsItemNumberDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3XDWw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
class EditSettingsItemDropdownDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        let value = props.item[props.property_key];
        if (value === null || value === undefined || value.length == 0 || props.options[value] === undefined) value = Object.keys(props.options)[0];
        this.state = {
            value
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "edit-settings-item-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Uredi nastavitev"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-1 flex-col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                labelFor: "edit-settings-item-dialog--value",
                                className: "flex-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                    id: "edit-settings-item-dialog--value",
                                    fill: true,
                                    options: Object.entries(this.props.options).map(([key, value])=>{
                                        return {
                                            label: value,
                                            value: key
                                        };
                                    }),
                                    value: this.state.value,
                                    onChange: (e)=>{
                                        this.setState({
                                            value: e.currentTarget.value
                                        });
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.props.item, this.props.property_key, this.state.value);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
EditSettingsItemDropdownDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = EditSettingsItemDropdownDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c8mQ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
class EditSettingsItemMultilineDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            value: props.item[props.property_key]
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "edit-settings-item-dialog multiline",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Uredi nastavitev"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY + ' flex flex-col',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-1 flex-col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                labelFor: "edit-settings-item-dialog--value",
                                className: "edit-settings-item-dialog-multiline-value",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                    id: "edit-settings-item-dialog--value",
                                    growVertically: true,
                                    large: true,
                                    fill: true,
                                    intent: (0, _core.Intent).PRIMARY,
                                    onChange: (event)=>{
                                        this.setState({
                                            value: event.target.value
                                        });
                                    },
                                    value: this.state.value
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.props.item, this.props.property_key, this.state.value);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
EditSettingsItemMultilineDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = EditSettingsItemMultilineDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fTMNn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _settingsSlice = require("../../slices/SettingsSlice");
var _settings = require("../../api/Settings");
var _localStorageHelper = require("../../helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
var _resultComponents = require("../code_tables/ResultComponents");
var _editSettingsItemColorPickerDialog = require("./EditSettingsItemColorPickerDialog");
var _editSettingsItemColorPickerDialogDefault = parcelHelpers.interopDefault(_editSettingsItemColorPickerDialog);
var _editSettingsItemDialog = require("./EditSettingsItemDialog");
var _editSettingsItemDialogDefault = parcelHelpers.interopDefault(_editSettingsItemDialog);
function Results(props) {
    const { item, openEditSettingsItemDialog } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: "Barve statusov"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Status"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 3,
                        title: "Vrednost"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-table",
                children: [
                    {
                        key: 'color_status_new',
                        title: 'Nova'
                    },
                    {
                        key: 'color_status_waiting_for_confirmation',
                        title: 'V potrjevanju'
                    },
                    {
                        key: 'color_status_offer_sent',
                        title: 'Izdana ponudba'
                    },
                    {
                        key: 'color_status_confirmed',
                        title: 'Potrjena'
                    },
                    {
                        key: 'color_status_advance_invoice_sent',
                        title: 'Izdan avans'
                    },
                    {
                        key: 'color_status_closed',
                        title: "Pla\u010Dana"
                    },
                    {
                        key: 'color_status_reversed',
                        title: 'Stornirana'
                    },
                    {
                        key: 'color_status_no_show',
                        title: 'Neprihod'
                    },
                    {
                        key: 'color_status_not_for_rent',
                        title: 'Ni za oddajo'
                    },
                    {
                        key: 'color_status_deleting',
                        title: 'Brisana'
                    },
                    {
                        key: 'color_status_invalid',
                        title: 'Neveljavno'
                    },
                    {
                        key: 'color_custom_status_1',
                        title: 'Po meri 1'
                    },
                    {
                        key: 'color_custom_status_2',
                        title: 'Po meri 2'
                    },
                    {
                        key: 'color_custom_status_3',
                        title: 'Po meri 3'
                    },
                    {
                        key: 'color_custom_status_4',
                        title: 'Po meri 4'
                    },
                    {
                        key: 'color_custom_status_5',
                        title: 'Po meri 5'
                    },
                    {
                        key: 'color_custom_status_6',
                        title: 'Po meri 6'
                    },
                    {
                        key: 'color_custom_status_7',
                        title: 'Po meri 7'
                    }
                ].map((property)=>{
                    let value = item[property.key];
                    let type = 'color-picker';
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "edit",
                                    intent: "primary",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>{
                                        openEditSettingsItemDialog(type, item, property.key, 'Status ' + property.title);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2,
                                child: property.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        width: 18,
                                        height: 18,
                                        marginTop: 5,
                                        backgroundColor: value
                                    }
                                })
                            })
                        ]
                    }, 'settings-result--property-' + property.key);
                })
            }, 'settings-result-1'),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: "Nazivi statusov"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Status"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 3,
                        title: "Vrednost"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-table",
                children: [
                    {
                        key: 'title_custom_status_1',
                        title: 'Po meri 1'
                    },
                    {
                        key: 'title_custom_status_2',
                        title: 'Po meri 2'
                    },
                    {
                        key: 'title_custom_status_3',
                        title: 'Po meri 3'
                    },
                    {
                        key: 'title_custom_status_4',
                        title: 'Po meri 4'
                    },
                    {
                        key: 'title_custom_status_5',
                        title: 'Po meri 5'
                    },
                    {
                        key: 'title_custom_status_6',
                        title: 'Po meri 6'
                    },
                    {
                        key: 'title_custom_status_7',
                        title: 'Po meri 7'
                    }
                ].map((property)=>{
                    let value = item[property.key];
                    let type = 'general';
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "edit",
                                    intent: "primary",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>{
                                        openEditSettingsItemDialog(type, item, property.key, 'Status ' + property.title);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2,
                                child: property.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: value
                            })
                        ]
                    }, 'settings-result--property-' + property.key);
                })
            }, 'settings-result-2')
        ]
    });
}
class StatusSettings extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.openEditSettingsItemDialog = this.openEditSettingsItemDialog.bind(this);
        this.closeEditSettingsItemDialog = this.closeEditSettingsItemDialog.bind(this);
        const { item } = this.updateTableItemsFromProps(props);
        this.state = {
            item,
            edit_settings_item_dialog_open: false,
            edit_settings_item_dialog_item: null,
            edit_settings_item_dialog_property_key: null
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.general_settings != this.state.item) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        return {
            item: props.general_settings
        };
    }
    openEditSettingsItemDialog(type, item, property_key, property_title) {
        this.setState({
            edit_settings_item_dialog_open: true,
            edit_settings_item_dialog_type: type,
            edit_settings_item_dialog_item: item,
            edit_settings_item_dialog_property_key: property_key,
            edit_settings_item_dialog_property_title: property_title
        });
    }
    async closeEditSettingsItemDialog(item, property_key, new_value) {
        this.setState({
            edit_settings_item_dialog_open: false,
            edit_settings_item_dialog_type: null,
            edit_settings_item_dialog_item: null,
            edit_settings_item_dialog_property_key: null,
            edit_settings_item_dialog_property_title: null
        });
        if (item !== undefined) {
            if (property_key == 'pos_printer_name') (0, _localStorageHelperDefault.default).SetValue(this.props.client + '__pos_printer_name', new_value);
            else if (property_key == 'pos_printer_width') (0, _localStorageHelperDefault.default).SetValue(this.props.client + '__pos_printer_width', new_value);
            else if (property_key == 'save_path') (0, _localStorageHelperDefault.default).SetValue(this.props.client + '__save_path', new_value);
            else if (property_key == 'vat') {
                let new_item = {
                    ...item
                };
                new_item.subject_vat_registered = new_value.subject_vat_registered;
                new_item.subject_vat_registered_reason = new_value.subject_vat_registered_reason;
                new_item.subject_vat_number = new_value.subject_vat_number;
                this.props.dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
                const dispatch = this.props.dispatch;
                const token = this.props.token;
                new_item = await (0, _settings.saveGeneralSettings)(this.props.api_url, new_item, token);
                if (new_item !== null) dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
            } else {
                let new_item = {
                    ...item
                };
                new_item[property_key] = new_value;
                this.props.dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
                const dispatch = this.props.dispatch;
                const token = this.props.token;
                new_item = await (0, _settings.saveGeneralSettings)(this.props.api_url, new_item, token);
                if (new_item !== null) dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
            }
        }
    }
    render() {
        let edit_settings_dialog = null;
        if (this.state.edit_settings_item_dialog_open) {
            if (this.state.edit_settings_item_dialog_type == 'color-picker') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemColorPickerDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                property_title: this.state.edit_settings_item_dialog_property_title,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                closeDialog: this.closeEditSettingsItemDialog
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                edit_settings_dialog,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex flex-col flex-grow general-settings-list",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1 pl-4 pr-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-grow overflow-y-auto",
                            style: {
                                flexBasis: '0'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                item: this.state.item,
                                openEditSettingsItemDialog: this.openEditSettingsItemDialog,
                                client: this.props.client
                            })
                        })
                    })
                })
            ]
        });
    }
}
StatusSettings.propTypes = {};
function mapStateToProps(state) {
    return {
        general_settings: state.SettingsSlice.general,
        api_url: state.SettingsSlice.api_url,
        token: state.UserSlice.token,
        printers: state.AppSlice.printers,
        client: state.ConstantsSlice.client
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(StatusSettings);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","../../slices/SettingsSlice":"ajHkF","../../api/Settings":"51MNf","../../helpers/LocalStorageHelper":"9I9tm","../code_tables/ResultComponents":"1eVlZ","./EditSettingsItemColorPickerDialog":"lPN8J","./EditSettingsItemDialog":"3zOCG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lPN8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _reactColor = require("react-color");
class EditSettingsItemColorPickerDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            value: props.item[props.property_key]
        };
    }
    render() {
        console.log(this.props);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "edit-settings-item-dialog color",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Uredi nastavitev \u2022 " + this.props.property_title
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-1 flex-col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactColor.SwatchesPicker), {
                                width: '100%',
                                height: 384,
                                color: this.state.value,
                                colors: [
                                    [
                                        '#ffebee',
                                        '#ffcdd2',
                                        '#ef9a9a',
                                        '#e57373',
                                        '#ef5350',
                                        '#f44336',
                                        '#e53935',
                                        '#d32f2f',
                                        '#c62828',
                                        '#b71c1c',
                                        '#ff8a80',
                                        '#ff5252',
                                        '#ff1744',
                                        '#d50000'
                                    ],
                                    [
                                        '#fce4ec',
                                        '#f8bbd0',
                                        '#f48fb1',
                                        '#f06292',
                                        '#ec407a',
                                        '#e91e63',
                                        '#d81b60',
                                        '#c2185b',
                                        '#ad1457',
                                        '#880e4f',
                                        '#ff80ab',
                                        '#ff4081',
                                        '#f50057',
                                        '#c51162'
                                    ],
                                    [
                                        '#f3e5f5',
                                        '#e1bee7',
                                        '#ce93d8',
                                        '#ba68c8',
                                        '#ab47bc',
                                        '#9c27b0',
                                        '#8e24aa',
                                        '#7b1fa2',
                                        '#6a1b9a',
                                        '#4a148c',
                                        '#ea80fc',
                                        '#e040fb',
                                        '#d500f9',
                                        '#aa00ff'
                                    ],
                                    [
                                        '#ede7f6',
                                        '#d1c4e9',
                                        '#b39ddb',
                                        '#9575cd',
                                        '#7e57c2',
                                        '#673ab7',
                                        '#5e35b1',
                                        '#512da8',
                                        '#4527a0',
                                        '#311b92',
                                        '#b388ff',
                                        '#7c4dff',
                                        '#651fff',
                                        '#6200ea'
                                    ],
                                    [
                                        '#e8eaf6',
                                        '#c5cae9',
                                        '#9fa8da',
                                        '#7986cb',
                                        '#5c6bc0',
                                        '#3f51b5',
                                        '#3949ab',
                                        '#303f9f',
                                        '#283593',
                                        '#1a237e',
                                        '#8c9eff',
                                        '#536dfe',
                                        '#3d5afe',
                                        '#304ffe'
                                    ],
                                    [
                                        '#e3f2fd',
                                        '#bbdefb',
                                        '#90caf9',
                                        '#64b5f6',
                                        '#42a5f5',
                                        '#2196f3',
                                        '#1e88e5',
                                        '#1976d2',
                                        '#1565c0',
                                        '#0d47a1',
                                        '#82b1ff',
                                        '#448aff',
                                        '#2979ff',
                                        '#2962ff'
                                    ],
                                    [
                                        '#e1f5fe',
                                        '#b3e5fc',
                                        '#81d4fa',
                                        '#4fc3f7',
                                        '#29b6f6',
                                        '#03a9f4',
                                        '#039be5',
                                        '#0288d1',
                                        '#0277bd',
                                        '#01579b',
                                        '#80d8ff',
                                        '#40c4ff',
                                        '#00b0ff',
                                        '#0091ea'
                                    ],
                                    [
                                        '#e0f7fa',
                                        '#b2ebf2',
                                        '#80deea',
                                        '#4dd0e1',
                                        '#26c6da',
                                        '#00bcd4',
                                        '#00acc1',
                                        '#0097a7',
                                        '#00838f',
                                        '#006064',
                                        '#84ffff',
                                        '#18ffff',
                                        '#00e5ff',
                                        '#00b8d4'
                                    ],
                                    [
                                        '#e0f2f1',
                                        '#b2dfdb',
                                        '#80cbc4',
                                        '#4db6ac',
                                        '#26a69a',
                                        '#009688',
                                        '#00897b',
                                        '#00796b',
                                        '#00695c',
                                        '#004d40',
                                        '#a7ffeb',
                                        '#64ffda',
                                        '#1de9b6',
                                        '#00bfa5'
                                    ],
                                    [
                                        '#e8f5e9',
                                        '#c8e6c9',
                                        '#a5d6a7',
                                        '#81c784',
                                        '#66bb6a',
                                        '#4caf50',
                                        '#43a047',
                                        '#388e3c',
                                        '#2e7d32',
                                        '#1b5e20',
                                        '#b9f6ca',
                                        '#69f0ae',
                                        '#00e676',
                                        '#00c853'
                                    ],
                                    [
                                        '#f1f8e9',
                                        '#dcedc8',
                                        '#c5e1a5',
                                        '#aed581',
                                        '#9ccc65',
                                        '#8bc34a',
                                        '#7cb342',
                                        '#689f38',
                                        '#558b2f',
                                        '#33691e',
                                        '#ccff90',
                                        '#b2ff59',
                                        '#76ff03',
                                        '#64dd17'
                                    ],
                                    [
                                        '#f9fbe7',
                                        '#f0f4c3',
                                        '#e6ee9c',
                                        '#dce775',
                                        '#d4e157',
                                        '#cddc39',
                                        '#c0ca33',
                                        '#afb42b',
                                        '#9e9d24',
                                        '#827717',
                                        '#f4ff81',
                                        '#eeff41',
                                        '#c6ff00',
                                        '#aeea00'
                                    ],
                                    [
                                        '#fffde7',
                                        '#fff9c4',
                                        '#fff59d',
                                        '#fff176',
                                        '#ffee58',
                                        '#ffeb3b',
                                        '#fdd835',
                                        '#fbc02d',
                                        '#f9a825',
                                        '#f57f17',
                                        '#ffff8d',
                                        '#ffff00',
                                        '#ffea00',
                                        '#ffd600'
                                    ],
                                    [
                                        '#fff8e1',
                                        '#ffecb3',
                                        '#ffe082',
                                        '#ffd54f',
                                        '#ffca28',
                                        '#ffc107',
                                        '#ffb300',
                                        '#ffa000',
                                        '#ff8f00',
                                        '#ff6f00',
                                        '#ffe57f',
                                        '#ffd740',
                                        '#ffc400',
                                        '#ffab00'
                                    ],
                                    [
                                        '#fff3e0',
                                        '#ffe0b2',
                                        '#ffcc80',
                                        '#ffb74d',
                                        '#ffa726',
                                        '#ff9800',
                                        '#fb8c00',
                                        '#f57c00',
                                        '#ef6c00',
                                        '#e65100',
                                        '#ffd180',
                                        '#ffab40',
                                        '#ff9100',
                                        '#ff6d00'
                                    ],
                                    [
                                        '#fbe9e7',
                                        '#ffccbc',
                                        '#ffab91',
                                        '#ff8a65',
                                        '#ff7043',
                                        '#ff5722',
                                        '#f4511e',
                                        '#e64a19',
                                        '#d84315',
                                        '#bf360c',
                                        '#ff9e80',
                                        '#ff6e40',
                                        '#ff3d00',
                                        '#dd2c00'
                                    ],
                                    [
                                        '#efebe9',
                                        '#d7ccc8',
                                        '#bcaaa4',
                                        '#a1887f',
                                        '#8d6e63',
                                        '#795548',
                                        '#6d4c41',
                                        '#5d4037',
                                        '#4e342e',
                                        '#3e2723'
                                    ],
                                    [
                                        '#fafafa',
                                        '#f5f5f5',
                                        '#eeeeee',
                                        '#e0e0e0',
                                        '#bdbdbd',
                                        '#9e9e9e',
                                        '#757575',
                                        '#616161',
                                        '#424242',
                                        '#212121'
                                    ],
                                    [
                                        '#eceff1',
                                        '#cfd8dc',
                                        '#b0bec5',
                                        '#90a4ae',
                                        '#78909c',
                                        '#607d8b',
                                        '#546e7a',
                                        '#455a64',
                                        '#37474f',
                                        '#263238'
                                    ]
                                ],
                                onChangeComplete: (color)=>this.setState({
                                        value: 'rgba(' + color.rgb.r + ', ' + color.rgb.g + ', ' + color.rgb.b + ', ' + color.rgb.a + ')'
                                    })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.props.item, this.props.property_key, this.state.value);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
EditSettingsItemColorPickerDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = EditSettingsItemColorPickerDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","react-color":"eCm3k","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eCm3k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPicker", ()=>(0, _alphaDefault.default));
parcelHelpers.export(exports, "BlockPicker", ()=>(0, _blockDefault.default));
parcelHelpers.export(exports, "CirclePicker", ()=>(0, _circleDefault.default));
parcelHelpers.export(exports, "ChromePicker", ()=>(0, _chromeDefault.default));
parcelHelpers.export(exports, "CompactPicker", ()=>(0, _compactDefault.default));
parcelHelpers.export(exports, "GithubPicker", ()=>(0, _githubDefault.default));
parcelHelpers.export(exports, "HuePicker", ()=>(0, _hueDefault.default));
parcelHelpers.export(exports, "MaterialPicker", ()=>(0, _materialDefault.default));
parcelHelpers.export(exports, "PhotoshopPicker", ()=>(0, _photoshopDefault.default));
parcelHelpers.export(exports, "SketchPicker", ()=>(0, _sketchDefault.default));
parcelHelpers.export(exports, "SliderPicker", ()=>(0, _sliderDefault.default));
parcelHelpers.export(exports, "SwatchesPicker", ()=>(0, _swatchesDefault.default));
parcelHelpers.export(exports, "TwitterPicker", ()=>(0, _twitterDefault.default));
parcelHelpers.export(exports, "GooglePicker", ()=>(0, _googleDefault.default));
parcelHelpers.export(exports, "CustomPicker", ()=>(0, _colorWrapDefault.default));
parcelHelpers.export(exports, "default", ()=>(0, _chromeDefault.default));
var _alpha = require("./components/alpha/Alpha");
var _alphaDefault = parcelHelpers.interopDefault(_alpha);
var _block = require("./components/block/Block");
var _blockDefault = parcelHelpers.interopDefault(_block);
var _circle = require("./components/circle/Circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _chrome = require("./components/chrome/Chrome");
var _chromeDefault = parcelHelpers.interopDefault(_chrome);
var _compact = require("./components/compact/Compact");
var _compactDefault = parcelHelpers.interopDefault(_compact);
var _github = require("./components/github/Github");
var _githubDefault = parcelHelpers.interopDefault(_github);
var _hue = require("./components/hue/Hue");
var _hueDefault = parcelHelpers.interopDefault(_hue);
var _material = require("./components/material/Material");
var _materialDefault = parcelHelpers.interopDefault(_material);
var _photoshop = require("./components/photoshop/Photoshop");
var _photoshopDefault = parcelHelpers.interopDefault(_photoshop);
var _sketch = require("./components/sketch/Sketch");
var _sketchDefault = parcelHelpers.interopDefault(_sketch);
var _slider = require("./components/slider/Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _swatches = require("./components/swatches/Swatches");
var _swatchesDefault = parcelHelpers.interopDefault(_swatches);
var _twitter = require("./components/twitter/Twitter");
var _twitterDefault = parcelHelpers.interopDefault(_twitter);
var _google = require("./components/google/Google");
var _googleDefault = parcelHelpers.interopDefault(_google);
var _colorWrap = require("./components/common/ColorWrap");
var _colorWrapDefault = parcelHelpers.interopDefault(_colorWrap);

},{"./components/alpha/Alpha":"ivNSt","./components/block/Block":"lM1AY","./components/circle/Circle":"4tT9V","./components/chrome/Chrome":"6EiGv","./components/compact/Compact":"4fCZ7","./components/github/Github":"5a9tU","./components/hue/Hue":"aRmaX","./components/material/Material":"jlcVF","./components/photoshop/Photoshop":"grH58","./components/sketch/Sketch":"761c2","./components/slider/Slider":"LOOqi","./components/swatches/Swatches":"in5kC","./components/twitter/Twitter":"lypvp","./components/google/Google":"bK2GH","./components/common/ColorWrap":"jBu17","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ivNSt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPicker", ()=>AlphaPicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var _alphaPointer = require("./AlphaPointer");
var _alphaPointerDefault = parcelHelpers.interopDefault(_alphaPointer);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var AlphaPicker = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            alpha: {
                radius: '2px',
                style: style
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'alpha-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), _extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
AlphaPicker.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, _alphaPointerDefault.default)
};
exports.default = (0, _common.ColorWrap)(AlphaPicker);

},{"react":"9njXz","reactcss":"7O6YP","../common":"f3pVr","./AlphaPointer":"dStp4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7O6YP":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
var _flattenNames = require("d21bbaf20f135ed7");
var _flattenNames2 = _interopRequireDefault(_flattenNames);
var _mergeClasses = require("7ab5259b27ba03f4");
var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
var _autoprefix = require("f7ab0b82c66de9f6");
var _autoprefix2 = _interopRequireDefault(_autoprefix);
var _hover2 = require("610a3f6b931726da");
var _hover3 = _interopRequireDefault(_hover2);
var _active = require("8d8d6281227b8365");
var _active2 = _interopRequireDefault(_active);
var _loop2 = require("c3bae8551a541b09");
var _loop3 = _interopRequireDefault(_loop2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, _flattenNames2.default)(activations);
    var merged = (0, _mergeClasses2.default)(classes, activeNames);
    return (0, _autoprefix2.default)(merged);
};
exports.default = ReactCSS;

},{"d21bbaf20f135ed7":"3ptd2","7ab5259b27ba03f4":"crkaN","f7ab0b82c66de9f6":"1xeaO","610a3f6b931726da":"5kyFi","8d8d6281227b8365":"fpdHy","c3bae8551a541b09":"leyEG"}],"3ptd2":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.flattenNames = undefined;
var _isString2 = require("cc07907b88eac890");
var _isString3 = _interopRequireDefault(_isString2);
var _forOwn2 = require("2db844d13e15e498");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _isPlainObject2 = require("8ea197129e7ee890");
var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
var _map2 = require("8f65518dcbd71fa0");
var _map3 = _interopRequireDefault(_map2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var flattenNames = exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, _map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, _isPlainObject3.default)(thing)) (0, _forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + '-' + value);
        });
        else if ((0, _isString3.default)(thing)) names.push(thing);
    });
    return names;
};
exports.default = flattenNames;

},{"cc07907b88eac890":"5nkFr","2db844d13e15e498":"jhROb","8ea197129e7ee890":"lCxAG","8f65518dcbd71fa0":"lEbGY"}],"5nkFr":[function(require,module,exports,__globalThis) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"5ltt8","46fdd4d2c5d7b4ab":"1DVeR","36ebbb6a9d8b3fe4":"4gOki"}],"5ltt8":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"crlKT","9b2aaf31b7bdd837":"66zQh","46d5beb3375f8a28":"7zYCt"}],"crlKT":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"gVq56"}],"gVq56":[function(require,module,exports,__globalThis) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"cd92e8811deaabf5":"egvmL"}],"egvmL":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"66zQh":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"crlKT"}],"7zYCt":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"1DVeR":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"4gOki":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"jhROb":[function(require,module,exports,__globalThis) {
var baseForOwn = require("29fecbf008d96984"), castFunction = require("e9d5e9d48b9f93d3");
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forOwn(object, iteratee) {
    return object && baseForOwn(object, castFunction(iteratee));
}
module.exports = forOwn;

},{"29fecbf008d96984":"i7P4y","e9d5e9d48b9f93d3":"jVEVZ"}],"i7P4y":[function(require,module,exports,__globalThis) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"9oLrx","1fb77c53defe5720":"9qKxr"}],"9oLrx":[function(require,module,exports,__globalThis) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"d4N9s"}],"d4N9s":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"9qKxr":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"aB7KR","e8453365fdacc8da":"f4fT3","7760b47b02971dfa":"kzICo"}],"aB7KR":[function(require,module,exports,__globalThis) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"iMrJS","9cdb51ffa56f149b":"bpegN","38cd49f1e493b3d7":"1DVeR","b379831fe1873fed":"26W2O","f362a34cd8321bb7":"bxLaX","c019db5297494469":"hq5rz"}],"iMrJS":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"bpegN":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"b56e5b7d86069686":"5IKlp","bead821d6af018b5":"4gOki"}],"5IKlp":[function(require,module,exports,__globalThis) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"5ltt8","b6cdbe52dcf709f8":"4gOki"}],"26W2O":[function(require,module,exports,__globalThis) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"gVq56","a1e87b138cf75d1d":"gotX4"}],"gotX4":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"bxLaX":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"hq5rz":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"jRqan","903f50eb1c16d257":"jVyhK","fa49853a82034c30":"bPzLC"}],"jRqan":[function(require,module,exports,__globalThis) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"5ltt8","f661b3a120d7a4cb":"aFNSq","cdd86c83797c0618":"4gOki"}],"aFNSq":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"jVyhK":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"bPzLC":[function(require,module,exports,__globalThis) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"egvmL"}],"f4fT3":[function(require,module,exports,__globalThis) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"6l00J","3ec652610d8dd5d3":"39iyK"}],"6l00J":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"39iyK":[function(require,module,exports,__globalThis) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"3OxAn"}],"3OxAn":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"kzICo":[function(require,module,exports,__globalThis) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"3A7xI","f3db08d4d1110aaf":"aFNSq"}],"3A7xI":[function(require,module,exports,__globalThis) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"5ltt8","3cba3c966459d528":"6hgJK"}],"6hgJK":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"jVEVZ":[function(require,module,exports,__globalThis) {
var identity = require("c0eaa1c5ad52cc2f");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == 'function' ? value : identity;
}
module.exports = castFunction;

},{"c0eaa1c5ad52cc2f":"2HXBf"}],"2HXBf":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"lCxAG":[function(require,module,exports,__globalThis) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"5ltt8","2ca5b85a120835de":"9DBU4","963b65e043435612":"4gOki"}],"9DBU4":[function(require,module,exports,__globalThis) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"3OxAn"}],"lEbGY":[function(require,module,exports,__globalThis) {
var arrayMap = require("61518c8bb036dd9b"), baseIteratee = require("8bad46685c8864d"), baseMap = require("51c76ab24fdb66f9"), isArray = require("7cb4cacc4dea406c");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
module.exports = map;

},{"61518c8bb036dd9b":"chzeu","8bad46685c8864d":"6jZAq","51c76ab24fdb66f9":"8JEHD","7cb4cacc4dea406c":"1DVeR"}],"chzeu":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"6jZAq":[function(require,module,exports,__globalThis) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"1Dnfv","4f010869f7b63154":"flZVA","28f06147d1eb9502":"2HXBf","3c56f88c4debf449":"1DVeR","aee920e0ef5bf111":"bSOBT"}],"1Dnfv":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"5GI5z","89e9034a8071e297":"eEnTQ","782598b150762386":"18Sgh"}],"5GI5z":[function(require,module,exports,__globalThis) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"cltFt","9003c0cc8ac007b6":"hrIE8"}],"cltFt":[function(require,module,exports,__globalThis) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"iugcK","ceda2a63c77c915":"5KcsT","91ee1b348d9d7172":"hJzOg","3fe28318f65b9332":"ck5Lg","724ca4def8b84e06":"Ez0QG","e9ceacb40d9582bd":"iepWB"}],"iugcK":[function(require,module,exports,__globalThis) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"5b3H7","b700cb849df2c166":"bZ5tW","d76dd90eead6cced":"11sMk","3d210628ba60ec8":"TkrmM","76026bf2d4cfff93":"cCYah"}],"5b3H7":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"bZ5tW":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"5AZA1"}],"5AZA1":[function(require,module,exports,__globalThis) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"evtiM"}],"evtiM":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"11sMk":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"5AZA1"}],"TkrmM":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"5AZA1"}],"cCYah":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"5AZA1"}],"5KcsT":[function(require,module,exports,__globalThis) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"iugcK"}],"hJzOg":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"ck5Lg":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"Ez0QG":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"iepWB":[function(require,module,exports,__globalThis) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"iugcK","1494efbafafa9552":"bEqpc","6049e8027fe9407f":"lV1BE"}],"bEqpc":[function(require,module,exports,__globalThis) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"ed0752fe9f482107":"bz0ok","29224713b8d411e6":"gVq56"}],"bz0ok":[function(require,module,exports,__globalThis) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"i4SFU","16db51a0e009bd8c":"fQ3rQ"}],"i4SFU":[function(require,module,exports,__globalThis) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"3A7xI","cabbc2adfaeb27d9":"eUAv3","cbb5703fe1562e7f":"6hgJK","388b819f47a43aa5":"2HVCC"}],"eUAv3":[function(require,module,exports,__globalThis) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"h0VAr"}],"h0VAr":[function(require,module,exports,__globalThis) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"gVq56"}],"2HVCC":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"fQ3rQ":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"lV1BE":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"6JGdu","d2967b0e32ccfa56":"jD16i","ca21409ea89624c0":"9OB5v","f88fd07f8dd1f67d":"hsHKK","dbf3eae765642a3b":"5bQCB"}],"6JGdu":[function(require,module,exports,__globalThis) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"1q5yZ","a07dcf3fd3097a0c":"iugcK","92c01c953ef00ded":"bEqpc"}],"1q5yZ":[function(require,module,exports,__globalThis) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"77BkF","bc25d439ccd1fb47":"jt1rM","f096b37295a92ab0":"finz6","d88173cbc6a133c8":"5E27p","afb9b3bae0461cbf":"giimS"}],"77BkF":[function(require,module,exports,__globalThis) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"lElJo"}],"lElJo":[function(require,module,exports,__globalThis) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"bz0ok"}],"jt1rM":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"finz6":[function(require,module,exports,__globalThis) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"lElJo"}],"5E27p":[function(require,module,exports,__globalThis) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"lElJo"}],"giimS":[function(require,module,exports,__globalThis) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"lElJo"}],"jD16i":[function(require,module,exports,__globalThis) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"hINJU"}],"hINJU":[function(require,module,exports,__globalThis) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"5JCrb"}],"5JCrb":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{}],"9OB5v":[function(require,module,exports,__globalThis) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"hINJU"}],"hsHKK":[function(require,module,exports,__globalThis) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"hINJU"}],"5bQCB":[function(require,module,exports,__globalThis) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"hINJU"}],"hrIE8":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"9gcZQ","809bbb0c20650dbc":"4gOki"}],"9gcZQ":[function(require,module,exports,__globalThis) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"cltFt","96bc8a1825db53a5":"cXMUl","8bdece495e87fb69":"7eeNO","bb94920432a68eca":"kyaB8","45495edff98e5837":"1chae","18256411ae9e2858":"1DVeR","e5ba7abf54247fc5":"26W2O","50d786bb5c7366af":"hq5rz"}],"cXMUl":[function(require,module,exports,__globalThis) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"irm8l","1ee20de911db0cb0":"bjRBC","defff3d81be91b23":"c2cDw"}],"irm8l":[function(require,module,exports,__globalThis) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"lV1BE","9a831e81e9a1f98c":"blGac","1a2b6c8a7399c39f":"h2eS8"}],"blGac":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"h2eS8":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"bjRBC":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"c2cDw":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"7eeNO":[function(require,module,exports,__globalThis) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"crlKT","dbf6aa5033a0f48":"eHExv","539966708f906e61":"evtiM","8142d4017f0a425f":"cXMUl","48cddf732eff33ba":"7z4fi","9dc78b26c5daba20":"lxNlE"}],"eHExv":[function(require,module,exports,__globalThis) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"gVq56"}],"7z4fi":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"lxNlE":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"kyaB8":[function(require,module,exports,__globalThis) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"lOHy9"}],"lOHy9":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"hu5MU","aa79b69a13f924db":"igqw1","e3ad83e53433bc8a":"9qKxr"}],"hu5MU":[function(require,module,exports,__globalThis) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"8JuEE","148b85918856c33a":"1DVeR"}],"8JuEE":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"igqw1":[function(require,module,exports,__globalThis) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"egrke","6b1c62cea92cdb9":"gRVIR"}],"egrke":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"gRVIR":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"1chae":[function(require,module,exports,__globalThis) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"7C8Fy","28e3344aae951f13":"bEqpc","b286298be5b1d9a4":"97fST","3ae50c158f89813":"juoJE","9f458755f627d456":"9vICk","8e9160b373d7fe66":"5ltt8","b210627dd951641f":"2HVCC"}],"7C8Fy":[function(require,module,exports,__globalThis) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
module.exports = DataView;

},{"a6517d0448dad786":"bz0ok","f83c375075418382":"gVq56"}],"97fST":[function(require,module,exports,__globalThis) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
module.exports = Promise;

},{"6940648d854355b5":"bz0ok","a5c6637bac681a0":"gVq56"}],"juoJE":[function(require,module,exports,__globalThis) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, 'Set');
module.exports = Set;

},{"56b792d64741a4ff":"bz0ok","ca486d41cdf819d4":"gVq56"}],"9vICk":[function(require,module,exports,__globalThis) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

},{"4507415bd8810d3c":"bz0ok","7a9a6581834a8452":"gVq56"}],"eEnTQ":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"6mRk0","94ffded3a85af2f6":"9qKxr"}],"6mRk0":[function(require,module,exports,__globalThis) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"6hgJK"}],"18Sgh":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"flZVA":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"hrIE8","d5ca180f7d6f956a":"dBTJh","3462bb3f546fa1f7":"105Hu","f5fef07966a1c4ee":"c7lh2","2a1cd212d48516":"6mRk0","885e72ee7fc6d296":"18Sgh","cd65eaf4a3af29f6":"b5swP"}],"dBTJh":[function(require,module,exports,__globalThis) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"5Vkba"}],"5Vkba":[function(require,module,exports,__globalThis) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"1tEcE","c3296f04fad32769":"b5swP"}],"1tEcE":[function(require,module,exports,__globalThis) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"1DVeR","e823e604d75f975b":"c7lh2","f5fff1c342107fbd":"6K5tB","b04e8cc634273c23":"iEDGT"}],"c7lh2":[function(require,module,exports,__globalThis) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"1DVeR","4cdff6c9e9ff5d38":"fMaHV"}],"fMaHV":[function(require,module,exports,__globalThis) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"5ltt8","74644060ad1a1d3c":"4gOki"}],"6K5tB":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"9EwFx"}],"9EwFx":[function(require,module,exports,__globalThis) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"kx0Xn"}],"kx0Xn":[function(require,module,exports,__globalThis) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"lV1BE"}],"iEDGT":[function(require,module,exports,__globalThis) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"E4Kq0"}],"E4Kq0":[function(require,module,exports,__globalThis) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"crlKT","8439a3a1551d0706":"chzeu","4b12c9f502d3288a":"1DVeR","a0ebd327d618908a":"fMaHV"}],"b5swP":[function(require,module,exports,__globalThis) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"fMaHV"}],"105Hu":[function(require,module,exports,__globalThis) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"fdP9g","b0aefd36de99e579":"7O6Cp"}],"fdP9g":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"7O6Cp":[function(require,module,exports,__globalThis) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"1tEcE","47ffafdab3ba0d6f":"bpegN","93ebd263ff0131c1":"1DVeR","252ef74480e01958":"bxLaX","23c2f64e75e90a2":"aFNSq","af5ade297cb685ee":"b5swP"}],"bSOBT":[function(require,module,exports,__globalThis) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"fzLOJ","abf31da39349df22":"f5Egk","a387ef4a4373de2c":"c7lh2","9315973458389ae7":"b5swP"}],"fzLOJ":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"f5Egk":[function(require,module,exports,__globalThis) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"5Vkba"}],"8JEHD":[function(require,module,exports,__globalThis) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"hbtgh","2924e2db4bb5430d":"kzICo"}],"hbtgh":[function(require,module,exports,__globalThis) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"i7P4y","f1e3fc84161ef3ec":"bY6r9"}],"bY6r9":[function(require,module,exports,__globalThis) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"kzICo"}],"crkaN":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mergeClasses = undefined;
var _forOwn2 = require("42f7fd880fbb6b28");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _cloneDeep2 = require("fe0598645aa3c32b");
var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, _forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = _extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
exports.default = mergeClasses;

},{"42f7fd880fbb6b28":"jhROb","fe0598645aa3c32b":"kA4yF"}],"kA4yF":[function(require,module,exports,__globalThis) {
var baseClone = require("9b38cc9a3ba32230");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;

},{"9b38cc9a3ba32230":"dqsfF"}],"dqsfF":[function(require,module,exports,__globalThis) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"cltFt","3a79976eb46af94a":"gM7YB","bc83a05a4f99d69b":"aKTSf","e6b4c3e6c85df6bb":"7HkQg","f340cc553ba5643c":"c7Ii5","e72e99883a50402d":"aNaSh","dc840ead07f1054":"lWbYv","309288e8ee190af0":"4A2Va","687fa30fede0b048":"7bLYw","bb0ba724f98b094d":"lOHy9","12bae1dca0e83064":"iZ6gY","4c3204eaea28d680":"1chae","fd7741200b462cdf":"cSkwN","f93a1d24ac08e076":"jeUN0","630039e80f692f17":"fGkGx","f37949484ab52dae":"1DVeR","ac876cc65d29c86e":"26W2O","1056c031d98783c0":"hm6iH","1800fb3122907fc2":"6hgJK","31f022f648037bd3":"7SeAd","5f3267fbd9848a7d":"9qKxr","7d3f3bdc4f2e7bb8":"6emcB"}],"gM7YB":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"aKTSf":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"ba13n","b62ef95b3cf1cde1":"evtiM"}],"ba13n":[function(require,module,exports,__globalThis) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"fUDy8"}],"fUDy8":[function(require,module,exports,__globalThis) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"bz0ok"}],"7HkQg":[function(require,module,exports,__globalThis) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"vDc33","fcf23a0242ef0da9":"9qKxr"}],"vDc33":[function(require,module,exports,__globalThis) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"aKTSf","9cddf6ac1a092765":"ba13n"}],"c7Ii5":[function(require,module,exports,__globalThis) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"vDc33","7697a1565646c93":"6emcB"}],"6emcB":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"aB7KR","194eb1a802636842":"5O0AO","ac15afdc3ddd76cd":"kzICo"}],"5O0AO":[function(require,module,exports,__globalThis) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"6hgJK","f7d53cd92b2b977b":"6l00J","c039208a16eb68bd":"8srRf"}],"8srRf":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"aNaSh":[function(require,module,exports,__globalThis) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"gVq56"}],"lWbYv":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"4A2Va":[function(require,module,exports,__globalThis) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"vDc33","39cbde2205d9399c":"igqw1"}],"7bLYw":[function(require,module,exports,__globalThis) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"vDc33","9b660e6b0c20d303":"IRyaH"}],"IRyaH":[function(require,module,exports,__globalThis) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"8JuEE","6ccae2aa7cfa3c66":"9DBU4","bdb501682ee9305d":"igqw1","7641fe4ae6d2cc96":"gRVIR"}],"iZ6gY":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"hu5MU","feede5d0a2d06427":"IRyaH","287f70f798405911":"6emcB"}],"cSkwN":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"jeUN0":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"ZLaCu","dbf04edaab2ae376":"kzyXT","763300f2dd9bdaf3":"aRqyO","c30e64d90e4b92d1":"2D8ix","d1edd8349e9ad54d":"WFexx"}],"ZLaCu":[function(require,module,exports,__globalThis) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"eHExv"}],"kzyXT":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"ZLaCu"}],"aRqyO":[function(require,module,exports,__globalThis) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"2D8ix":[function(require,module,exports,__globalThis) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"crlKT"}],"WFexx":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"ZLaCu"}],"fGkGx":[function(require,module,exports,__globalThis) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"5YCvM","8c92276927b7c3e0":"9DBU4","e939f15d7a0f64a5":"6l00J"}],"5YCvM":[function(require,module,exports,__globalThis) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"6hgJK"}],"hm6iH":[function(require,module,exports,__globalThis) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"iXyzE","6a7e6b1a2d9fb1d5":"jVyhK","7d4f449dd306450f":"bPzLC"}],"iXyzE":[function(require,module,exports,__globalThis) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"1chae","88260e33e0003386":"4gOki"}],"7SeAd":[function(require,module,exports,__globalThis) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"2H7vq","3cb35dba719c68b1":"jVyhK","7a3e899a332ff7be":"bPzLC"}],"2H7vq":[function(require,module,exports,__globalThis) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"1chae","b6fc875bc5f351c9":"4gOki"}],"1xeaO":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.autoprefix = undefined;
var _forOwn2 = require("6b2ab06ed0e74650");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(' ');
        return {
            position: 'absolute',
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            'extend': name
        };
    }
};
var autoprefix = exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, _forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, _forOwn3.default)(styles, function(value, key) {
            var transform = transforms[key];
            if (transform) expanded = _extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
exports.default = autoprefix;

},{"6b2ab06ed0e74650":"jhROb"}],"5kyFi":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hover = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("a618bb79e13970dd");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var hover = exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return _react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, _react2.default.createElement(Component, _extends({}, _this.props, _this.state)));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }(_react2.default.Component);
};
exports.default = hover;

},{"a618bb79e13970dd":"9njXz"}],"fpdHy":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.active = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("91e1b91cd0b21ba2");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var active = exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return _react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, _react2.default.createElement(Component, _extends({}, _this.props, _this.state)));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }(_react2.default.Component);
};
exports.default = active;

},{"91e1b91cd0b21ba2":"9njXz"}],"leyEG":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp('first-child');
    i === length - 1 && setProp('last-child');
    (i === 0 || i % 2 === 0) && setProp('even');
    Math.abs(i % 2) === 1 && setProp('odd');
    setProp('nth-child', i);
    return props;
};
exports.default = loopable;

},{}],"f3pVr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alpha", ()=>(0, _alphaDefault.default));
parcelHelpers.export(exports, "Checkboard", ()=>(0, _checkboardDefault.default));
parcelHelpers.export(exports, "EditableInput", ()=>(0, _editableInputDefault.default));
parcelHelpers.export(exports, "Hue", ()=>(0, _hueDefault.default));
parcelHelpers.export(exports, "Raised", ()=>(0, _raisedDefault.default));
parcelHelpers.export(exports, "Saturation", ()=>(0, _saturationDefault.default));
parcelHelpers.export(exports, "ColorWrap", ()=>(0, _colorWrapDefault.default));
parcelHelpers.export(exports, "Swatch", ()=>(0, _swatchDefault.default));
var _alpha = require("./Alpha");
var _alphaDefault = parcelHelpers.interopDefault(_alpha);
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _editableInput = require("./EditableInput");
var _editableInputDefault = parcelHelpers.interopDefault(_editableInput);
var _hue = require("./Hue");
var _hueDefault = parcelHelpers.interopDefault(_hue);
var _raised = require("./Raised");
var _raisedDefault = parcelHelpers.interopDefault(_raised);
var _saturation = require("./Saturation");
var _saturationDefault = parcelHelpers.interopDefault(_saturation);
var _colorWrap = require("./ColorWrap");
var _colorWrapDefault = parcelHelpers.interopDefault(_colorWrap);
var _swatch = require("./Swatch");
var _swatchDefault = parcelHelpers.interopDefault(_swatch);

},{"./Alpha":"bNP8e","./Checkboard":"fcpxn","./EditableInput":"3kxQY","./Hue":"gWPQU","./Raised":"4HUee","./Saturation":"lSRGQ","./ColorWrap":"jBu17","./Swatch":"aOxoG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bNP8e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alpha", ()=>Alpha);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _alpha = require("../../helpers/alpha");
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Alpha = function(_ref) {
    _inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        _classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = _alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleChange);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Alpha, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        alpha: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: '0px 0px 0px 0px',
                            overflow: 'hidden',
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: '0px 0px 0px 0px',
                            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: 'relative',
                            height: '100%',
                            margin: '0 3px'
                        },
                        pointer: {
                            position: 'absolute',
                            left: rgb.a * 100 + '%'
                        },
                        slider: {
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            marginTop: '1px',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        gradient: {
                            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + '%'
                        }
                    },
                    'overwrite': _extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === 'vertical',
                    overwrite: true
                });
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.checkboard
                }, (0, _reactDefault.default).createElement((0, _checkboardDefault.default), {
                    renderers: this.props.renderers
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.gradient
                }), (0, _reactDefault.default).createElement('div', {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Alpha;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/alpha":"6FdAZ","./Checkboard":"fcpxn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6FdAZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: 'rgb'
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: 'rgb'
        };
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fcpxn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkboard", ()=>Checkboard);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _checkboard = require("../../helpers/checkboard");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var Checkboard = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: '0px 0px 0px 0px',
                background: 'url(' + _checkboard.get(white, grey, size, renderers.canvas) + ') center left'
            }
        }
    });
    return (0, _react.isValidElement)(children) ? (0, _reactDefault.default).cloneElement(children, _extends({}, children.props, {
        style: _extends({}, children.props.style, styles.grid)
    })) : (0, _reactDefault.default).createElement('div', {
        style: styles.grid
    });
};
Checkboard.defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
};
exports.default = Checkboard;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/checkboard":"gWhkt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gWhkt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "get", ()=>get);
var checkboardCache = {};
var render = function render(c1, c2, size, serverCanvas) {
    if (typeof document === 'undefined' && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var get = function get(c1, c2, size, serverCanvas) {
    var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
    if (checkboardCache[key]) return checkboardCache[key];
    var checkboard = render(c1, c2, size, serverCanvas);
    checkboardCache[key] = checkboard;
    return checkboard;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3kxQY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditableInput", ()=>EditableInput);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var DEFAULT_ARROW_OFFSET = 1;
var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [
    UP_KEY_CODE,
    DOWN_KEY_CODE
];
var isValidKeyCode = function isValidKeyCode(keyCode) {
    return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ''));
};
var idCounter = 1;
var EditableInput = function(_ref) {
    _inherits(EditableInput, _ref);
    function EditableInput(props) {
        _classCallCheck(this, EditableInput);
        var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = getNumberValue(e.target.value);
            if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener('mousemove', _this.handleDrag);
                window.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleDrag);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = 'rc-editable-input-' + idCounter++;
        return _this;
    }
    _createClass(EditableInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'getValueObjectWithLabel',
            value: function getValueObjectWithLabel(value) {
                return _defineProperty({}, this.props.label, value);
            }
        },
        {
            key: 'getArrowOffset',
            value: function getArrowOffset() {
                return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: 'setUpdatedValue',
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        wrap: {
                            position: 'relative'
                        }
                    },
                    'user-override': {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    'dragLabel-true': {
                        label: {
                            cursor: 'ew-resize'
                        }
                    }
                }, {
                    'user-override': true
                }, this.props);
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.wrap
                }, (0, _reactDefault.default).createElement('input', {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: 'false'
                }), this.props.label && !this.props.hideLabel ? (0, _reactDefault.default).createElement('label', {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = EditableInput;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gWPQU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hue", ()=>Hue);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _hue = require("../../helpers/hue");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hue = function(_ref) {
    _inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        _classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = _hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Hue, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                window.removeEventListener('mousemove', this.handleChange);
                window.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? 'horizontal' : _props$direction;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        hue: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: '0 2px',
                            position: 'relative',
                            height: '100%',
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            left: this.props.hsl.h * 100 / 360 + '%'
                        },
                        slider: {
                            marginTop: '1px',
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        pointer: {
                            left: '0px',
                            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
                        }
                    }
                }, {
                    vertical: direction === 'vertical'
                });
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.hue
                }, (0, _reactDefault.default).createElement('div', {
                    className: 'hue-' + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), (0, _reactDefault.default).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Hue;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/hue":"gdsf5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gdsf5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4HUee":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Raised", ()=>Raised);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var Raised = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            wrap: {
                position: 'relative',
                display: 'inline-block'
            },
            content: {
                position: 'relative'
            },
            bg: {
                absolute: '0px 0px 0px 0px',
                boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
                borderRadius: radius,
                background: background
            }
        },
        'zDepth-0': {
            bg: {
                boxShadow: 'none'
            }
        },
        'zDepth-1': {
            bg: {
                boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
            }
        },
        'zDepth-2': {
            bg: {
                boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
            }
        },
        'zDepth-3': {
            bg: {
                boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
            }
        },
        'zDepth-4': {
            bg: {
                boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
            }
        },
        'zDepth-5': {
            bg: {
                boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
            }
        },
        'square': {
            bg: {
                borderRadius: '0'
            }
        },
        'circle': {
            bg: {
                borderRadius: '50%'
            }
        }
    }, passedStyles), {
        'zDepth-1': zDepth === 1
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.wrap
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.bg
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.content
    }, children));
};
Raised.propTypes = {
    background: (0, _propTypesDefault.default).string,
    zDepth: (0, _propTypesDefault.default).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, _propTypesDefault.default).number,
    styles: (0, _propTypesDefault.default).object
};
Raised.defaultProps = {
    background: '#fff',
    zDepth: 1,
    radius: 2,
    styles: {}
};
exports.default = Raised;

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQl8F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseMergeJs = require("./_baseMerge.js");
var _baseMergeJsDefault = parcelHelpers.interopDefault(_baseMergeJs);
var _createAssignerJs = require("./_createAssigner.js");
var _createAssignerJsDefault = parcelHelpers.interopDefault(_createAssignerJs);
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = (0, _createAssignerJsDefault.default)(function(object, source, srcIndex) {
    (0, _baseMergeJsDefault.default)(object, source, srcIndex);
});
exports.default = merge;

},{"./_baseMerge.js":"eeDiO","./_createAssigner.js":"ktr6u","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eeDiO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _baseForJs = require("./_baseFor.js");
var _baseForJsDefault = parcelHelpers.interopDefault(_baseForJs);
var _baseMergeDeepJs = require("./_baseMergeDeep.js");
var _baseMergeDeepJsDefault = parcelHelpers.interopDefault(_baseMergeDeepJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, _baseForJsDefault.default)(source, function(srcValue, key) {
        stack || (stack = new (0, _stackJsDefault.default));
        if ((0, _isObjectJsDefault.default)(srcValue)) (0, _baseMergeDeepJsDefault.default)(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, _safeGetJsDefault.default)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, _assignMergeValueJsDefault.default)(object, key, newValue);
        }
    }, (0, _keysInJsDefault.default));
}
exports.default = baseMerge;

},{"./_Stack.js":"6rfzp","./_assignMergeValue.js":"37hpW","./_baseFor.js":"1b7Jy","./_baseMergeDeep.js":"dHfag","./isObject.js":"ah1Cr","./keysIn.js":"dOdxD","./_safeGet.js":"b7qYM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6rfzp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _stackClearJs = require("./_stackClear.js");
var _stackClearJsDefault = parcelHelpers.interopDefault(_stackClearJs);
var _stackDeleteJs = require("./_stackDelete.js");
var _stackDeleteJsDefault = parcelHelpers.interopDefault(_stackDeleteJs);
var _stackGetJs = require("./_stackGet.js");
var _stackGetJsDefault = parcelHelpers.interopDefault(_stackGetJs);
var _stackHasJs = require("./_stackHas.js");
var _stackHasJsDefault = parcelHelpers.interopDefault(_stackHasJs);
var _stackSetJs = require("./_stackSet.js");
var _stackSetJsDefault = parcelHelpers.interopDefault(_stackSetJs);
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new (0, _listCacheJsDefault.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = (0, _stackClearJsDefault.default);
Stack.prototype['delete'] = (0, _stackDeleteJsDefault.default);
Stack.prototype.get = (0, _stackGetJsDefault.default);
Stack.prototype.has = (0, _stackHasJsDefault.default);
Stack.prototype.set = (0, _stackSetJsDefault.default);
exports.default = Stack;

},{"./_ListCache.js":"l0uYx","./_stackClear.js":"4HglF","./_stackDelete.js":"5fTer","./_stackGet.js":"ggfNK","./_stackHas.js":"aqvsn","./_stackSet.js":"4AL0c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l0uYx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheClearJs = require("./_listCacheClear.js");
var _listCacheClearJsDefault = parcelHelpers.interopDefault(_listCacheClearJs);
var _listCacheDeleteJs = require("./_listCacheDelete.js");
var _listCacheDeleteJsDefault = parcelHelpers.interopDefault(_listCacheDeleteJs);
var _listCacheGetJs = require("./_listCacheGet.js");
var _listCacheGetJsDefault = parcelHelpers.interopDefault(_listCacheGetJs);
var _listCacheHasJs = require("./_listCacheHas.js");
var _listCacheHasJsDefault = parcelHelpers.interopDefault(_listCacheHasJs);
var _listCacheSetJs = require("./_listCacheSet.js");
var _listCacheSetJsDefault = parcelHelpers.interopDefault(_listCacheSetJs);
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = (0, _listCacheClearJsDefault.default);
ListCache.prototype['delete'] = (0, _listCacheDeleteJsDefault.default);
ListCache.prototype.get = (0, _listCacheGetJsDefault.default);
ListCache.prototype.has = (0, _listCacheHasJsDefault.default);
ListCache.prototype.set = (0, _listCacheSetJsDefault.default);
exports.default = ListCache;

},{"./_listCacheClear.js":"e2ep2","./_listCacheDelete.js":"kGwFB","./_listCacheGet.js":"9ygkc","./_listCacheHas.js":"2iuXe","./_listCacheSet.js":"feYC4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e2ep2":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
exports.default = listCacheClear;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kGwFB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
exports.default = listCacheDelete;

},{"./_assocIndexOf.js":"6u8FR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6u8FR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, _eqJsDefault.default)(array[length][0], key)) return length;
    }
    return -1;
}
exports.default = assocIndexOf;

},{"./eq.js":"d11tM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d11tM":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function eq(value, other) {
    return value === other || value !== value && other !== other;
}
exports.default = eq;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ygkc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
exports.default = listCacheGet;

},{"./_assocIndexOf.js":"6u8FR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2iuXe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return (0, _assocIndexOfJsDefault.default)(this.__data__, key) > -1;
}
exports.default = listCacheHas;

},{"./_assocIndexOf.js":"6u8FR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"feYC4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
exports.default = listCacheSet;

},{"./_assocIndexOf.js":"6u8FR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4HglF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new (0, _listCacheJsDefault.default);
    this.size = 0;
}
exports.default = stackClear;

},{"./_ListCache.js":"l0uYx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5fTer":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
exports.default = stackDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ggfNK":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackGet(key) {
    return this.__data__.get(key);
}
exports.default = stackGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aqvsn":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackHas(key) {
    return this.__data__.has(key);
}
exports.default = stackHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4AL0c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, _listCacheJsDefault.default)) {
        var pairs = data.__data__;
        if (!(0, _mapJsDefault.default) || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, _mapCacheJsDefault.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
exports.default = stackSet;

},{"./_ListCache.js":"l0uYx","./_Map.js":"13fDv","./_MapCache.js":"iZCA7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"13fDv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Map = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Map');
exports.default = Map;

},{"./_getNative.js":"Z5FSj","./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Z5FSj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsNativeJs = require("./_baseIsNative.js");
var _baseIsNativeJsDefault = parcelHelpers.interopDefault(_baseIsNativeJs);
var _getValueJs = require("./_getValue.js");
var _getValueJsDefault = parcelHelpers.interopDefault(_getValueJs);
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = (0, _getValueJsDefault.default)(object, key);
    return (0, _baseIsNativeJsDefault.default)(value) ? value : undefined;
}
exports.default = getNative;

},{"./_baseIsNative.js":"1NgxH","./_getValue.js":"hw7N6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1NgxH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isMaskedJs = require("./_isMasked.js");
var _isMaskedJsDefault = parcelHelpers.interopDefault(_isMaskedJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!(0, _isObjectJsDefault.default)(value) || (0, _isMaskedJsDefault.default)(value)) return false;
    var pattern = (0, _isFunctionJsDefault.default)(value) ? reIsNative : reIsHostCtor;
    return pattern.test((0, _toSourceJsDefault.default)(value));
}
exports.default = baseIsNative;

},{"./isFunction.js":"7pb6H","./_isMasked.js":"bAGVh","./isObject.js":"ah1Cr","./_toSource.js":"755gJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7pb6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!(0, _isObjectJsDefault.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, _baseGetTagJsDefault.default)(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
exports.default = isFunction;

},{"./_baseGetTag.js":"9Chff","./isObject.js":"ah1Cr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Chff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _getRawTagJs = require("./_getRawTag.js");
var _getRawTagJsDefault = parcelHelpers.interopDefault(_getRawTagJs);
var _objectToStringJs = require("./_objectToString.js");
var _objectToStringJsDefault = parcelHelpers.interopDefault(_objectToStringJs);
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTagJsDefault.default)(value) : (0, _objectToStringJsDefault.default)(value);
}
exports.default = baseGetTag;

},{"./_Symbol.js":"c53Uj","./_getRawTag.js":"gkm0n","./_objectToString.js":"2GCBc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c53Uj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Symbol = (0, _rootJsDefault.default).Symbol;
exports.default = Symbol;

},{"./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"10cmd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = (0, _freeGlobalJsDefault.default) || freeSelf || Function('return this')();
exports.default = root;

},{"./_freeGlobal.js":"cvlFB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cvlFB":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
exports.default = freeGlobal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gkm0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
exports.default = getRawTag;

},{"./_Symbol.js":"c53Uj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2GCBc":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
exports.default = objectToString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ah1Cr":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bAGVh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coreJsDataJs = require("./_coreJsData.js");
var _coreJsDataJsDefault = parcelHelpers.interopDefault(_coreJsDataJs);
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, _coreJsDataJsDefault.default) && (0, _coreJsDataJsDefault.default).keys && (0, _coreJsDataJsDefault.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
exports.default = isMasked;

},{"./_coreJsData.js":"dEPG8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dEPG8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Used to detect overreaching core-js shims. */ var coreJsData = (0, _rootJsDefault.default)['__core-js_shared__'];
exports.default = coreJsData;

},{"./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"755gJ":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
exports.default = toSource;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hw7N6":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
exports.default = getValue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iZCA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheClearJs = require("./_mapCacheClear.js");
var _mapCacheClearJsDefault = parcelHelpers.interopDefault(_mapCacheClearJs);
var _mapCacheDeleteJs = require("./_mapCacheDelete.js");
var _mapCacheDeleteJsDefault = parcelHelpers.interopDefault(_mapCacheDeleteJs);
var _mapCacheGetJs = require("./_mapCacheGet.js");
var _mapCacheGetJsDefault = parcelHelpers.interopDefault(_mapCacheGetJs);
var _mapCacheHasJs = require("./_mapCacheHas.js");
var _mapCacheHasJsDefault = parcelHelpers.interopDefault(_mapCacheHasJs);
var _mapCacheSetJs = require("./_mapCacheSet.js");
var _mapCacheSetJsDefault = parcelHelpers.interopDefault(_mapCacheSetJs);
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = (0, _mapCacheClearJsDefault.default);
MapCache.prototype['delete'] = (0, _mapCacheDeleteJsDefault.default);
MapCache.prototype.get = (0, _mapCacheGetJsDefault.default);
MapCache.prototype.has = (0, _mapCacheHasJsDefault.default);
MapCache.prototype.set = (0, _mapCacheSetJsDefault.default);
exports.default = MapCache;

},{"./_mapCacheClear.js":"Y4N34","./_mapCacheDelete.js":"bwNmW","./_mapCacheGet.js":"a2tVV","./_mapCacheHas.js":"9OBkA","./_mapCacheSet.js":"aGCjp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Y4N34":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashJs = require("./_Hash.js");
var _hashJsDefault = parcelHelpers.interopDefault(_hashJs);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, _hashJsDefault.default),
        'map': new ((0, _mapJsDefault.default) || (0, _listCacheJsDefault.default)),
        'string': new (0, _hashJsDefault.default)
    };
}
exports.default = mapCacheClear;

},{"./_Hash.js":"fCdET","./_ListCache.js":"l0uYx","./_Map.js":"13fDv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fCdET":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashClearJs = require("./_hashClear.js");
var _hashClearJsDefault = parcelHelpers.interopDefault(_hashClearJs);
var _hashDeleteJs = require("./_hashDelete.js");
var _hashDeleteJsDefault = parcelHelpers.interopDefault(_hashDeleteJs);
var _hashGetJs = require("./_hashGet.js");
var _hashGetJsDefault = parcelHelpers.interopDefault(_hashGetJs);
var _hashHasJs = require("./_hashHas.js");
var _hashHasJsDefault = parcelHelpers.interopDefault(_hashHasJs);
var _hashSetJs = require("./_hashSet.js");
var _hashSetJsDefault = parcelHelpers.interopDefault(_hashSetJs);
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = (0, _hashClearJsDefault.default);
Hash.prototype['delete'] = (0, _hashDeleteJsDefault.default);
Hash.prototype.get = (0, _hashGetJsDefault.default);
Hash.prototype.has = (0, _hashHasJsDefault.default);
Hash.prototype.set = (0, _hashSetJsDefault.default);
exports.default = Hash;

},{"./_hashClear.js":"9SoV8","./_hashDelete.js":"13WpC","./_hashGet.js":"f7SyB","./_hashHas.js":"jRz4J","./_hashSet.js":"5hFaM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9SoV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = (0, _nativeCreateJsDefault.default) ? (0, _nativeCreateJsDefault.default)(null) : {};
    this.size = 0;
}
exports.default = hashClear;

},{"./_nativeCreate.js":"1gQwf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1gQwf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
/* Built-in method references that are verified to be native. */ var nativeCreate = (0, _getNativeJsDefault.default)(Object, 'create');
exports.default = nativeCreate;

},{"./_getNative.js":"Z5FSj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"13WpC":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = hashDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f7SyB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (0, _nativeCreateJsDefault.default) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
exports.default = hashGet;

},{"./_nativeCreate.js":"1gQwf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jRz4J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return (0, _nativeCreateJsDefault.default) ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
exports.default = hashHas;

},{"./_nativeCreate.js":"1gQwf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5hFaM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, _nativeCreateJsDefault.default) && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
exports.default = hashSet;

},{"./_nativeCreate.js":"1gQwf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bwNmW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = (0, _getMapDataJsDefault.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = mapCacheDelete;

},{"./_getMapData.js":"hwpVt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hwpVt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isKeyableJs = require("./_isKeyable.js");
var _isKeyableJsDefault = parcelHelpers.interopDefault(_isKeyableJs);
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return (0, _isKeyableJsDefault.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
exports.default = getMapData;

},{"./_isKeyable.js":"8UcYi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8UcYi":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
exports.default = isKeyable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a2tVV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return (0, _getMapDataJsDefault.default)(this, key).get(key);
}
exports.default = mapCacheGet;

},{"./_getMapData.js":"hwpVt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9OBkA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return (0, _getMapDataJsDefault.default)(this, key).has(key);
}
exports.default = mapCacheHas;

},{"./_getMapData.js":"hwpVt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aGCjp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = (0, _getMapDataJsDefault.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
exports.default = mapCacheSet;

},{"./_getMapData.js":"hwpVt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"37hpW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, _eqJsDefault.default)(object[key], value) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignMergeValue;

},{"./_baseAssignValue.js":"7WwSg","./eq.js":"d11tM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7WwSg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, _definePropertyJsDefault.default)) (0, _definePropertyJsDefault.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
exports.default = baseAssignValue;

},{"./_defineProperty.js":"hoPLT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hoPLT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var defineProperty = function() {
    try {
        var func = (0, _getNativeJsDefault.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
exports.default = defineProperty;

},{"./_getNative.js":"Z5FSj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1b7Jy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createBaseForJs = require("./_createBaseFor.js");
var _createBaseForJsDefault = parcelHelpers.interopDefault(_createBaseForJs);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = (0, _createBaseForJsDefault.default)();
exports.default = baseFor;

},{"./_createBaseFor.js":"2ZwGj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ZwGj":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
exports.default = createBaseFor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dHfag":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _cloneBufferJs = require("./_cloneBuffer.js");
var _cloneBufferJsDefault = parcelHelpers.interopDefault(_cloneBufferJs);
var _cloneTypedArrayJs = require("./_cloneTypedArray.js");
var _cloneTypedArrayJsDefault = parcelHelpers.interopDefault(_cloneTypedArrayJs);
var _copyArrayJs = require("./_copyArray.js");
var _copyArrayJsDefault = parcelHelpers.interopDefault(_copyArrayJs);
var _initCloneObjectJs = require("./_initCloneObject.js");
var _initCloneObjectJsDefault = parcelHelpers.interopDefault(_initCloneObjectJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isArrayLikeObjectJs = require("./isArrayLikeObject.js");
var _isArrayLikeObjectJsDefault = parcelHelpers.interopDefault(_isArrayLikeObjectJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPlainObjectJs = require("./isPlainObject.js");
var _isPlainObjectJsDefault = parcelHelpers.interopDefault(_isPlainObjectJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
var _toPlainObjectJs = require("./toPlainObject.js");
var _toPlainObjectJsDefault = parcelHelpers.interopDefault(_toPlainObjectJs);
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, _safeGetJsDefault.default)(object, key), srcValue = (0, _safeGetJsDefault.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, _assignMergeValueJsDefault.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, _isArrayJsDefault.default)(srcValue), isBuff = !isArr && (0, _isBufferJsDefault.default)(srcValue), isTyped = !isArr && !isBuff && (0, _isTypedArrayJsDefault.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, _isArrayJsDefault.default)(objValue)) newValue = objValue;
            else if ((0, _isArrayLikeObjectJsDefault.default)(objValue)) newValue = (0, _copyArrayJsDefault.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, _cloneBufferJsDefault.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, _cloneTypedArrayJsDefault.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, _isPlainObjectJsDefault.default)(srcValue) || (0, _isArgumentsJsDefault.default)(srcValue)) {
            newValue = objValue;
            if ((0, _isArgumentsJsDefault.default)(objValue)) newValue = (0, _toPlainObjectJsDefault.default)(objValue);
            else if (!(0, _isObjectJsDefault.default)(objValue) || (0, _isFunctionJsDefault.default)(objValue)) newValue = (0, _initCloneObjectJsDefault.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, _assignMergeValueJsDefault.default)(object, key, newValue);
}
exports.default = baseMergeDeep;

},{"./_assignMergeValue.js":"37hpW","./_cloneBuffer.js":"9bdhA","./_cloneTypedArray.js":"9tA9m","./_copyArray.js":"jjYsM","./_initCloneObject.js":"4hEhH","./isArguments.js":"3o5tK","./isArray.js":"dB5dn","./isArrayLikeObject.js":"4iqeX","./isBuffer.js":"dkqfQ","./isFunction.js":"7pb6H","./isObject.js":"ah1Cr","./isPlainObject.js":"fiE8B","./isTypedArray.js":"fH44A","./_safeGet.js":"b7qYM","./toPlainObject.js":"dGHEy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9bdhA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
exports.default = cloneBuffer;

},{"./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9tA9m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, _cloneArrayBufferJsDefault.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
exports.default = cloneTypedArray;

},{"./_cloneArrayBuffer.js":"1RxFP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1RxFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, _uint8ArrayJsDefault.default)(result).set(new (0, _uint8ArrayJsDefault.default)(arrayBuffer));
    return result;
}
exports.default = cloneArrayBuffer;

},{"./_Uint8Array.js":"cyDAa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cyDAa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Uint8Array = (0, _rootJsDefault.default).Uint8Array;
exports.default = Uint8Array;

},{"./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jjYsM":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
exports.default = copyArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4hEhH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCreateJs = require("./_baseCreate.js");
var _baseCreateJsDefault = parcelHelpers.interopDefault(_baseCreateJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, _isPrototypeJsDefault.default)(object) ? (0, _baseCreateJsDefault.default)((0, _getPrototypeJsDefault.default)(object)) : {};
}
exports.default = initCloneObject;

},{"./_baseCreate.js":"kSx59","./_getPrototype.js":"gSX6x","./_isPrototype.js":"kOZ2F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kSx59":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, _isObjectJsDefault.default)(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
exports.default = baseCreate;

},{"./isObject.js":"ah1Cr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gSX6x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/** Built-in value references. */ var getPrototype = (0, _overArgJsDefault.default)(Object.getPrototypeOf, Object);
exports.default = getPrototype;

},{"./_overArg.js":"gLjM1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gLjM1":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
exports.default = overArg;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kOZ2F":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
exports.default = isPrototype;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3o5tK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsArgumentsJs = require("./_baseIsArguments.js");
var _baseIsArgumentsJsDefault = parcelHelpers.interopDefault(_baseIsArgumentsJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = (0, _baseIsArgumentsJsDefault.default)(function() {
    return arguments;
}()) ? (0, _baseIsArgumentsJsDefault.default) : function(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
exports.default = isArguments;

},{"./_baseIsArguments.js":"3ufDO","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ufDO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == argsTag;
}
exports.default = baseIsArguments;

},{"./_baseGetTag.js":"9Chff","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kL9F":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
exports.default = isObjectLike;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dB5dn":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isArray = Array.isArray;
exports.default = isArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4iqeX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isArrayLikeJsDefault.default)(value);
}
exports.default = isArrayLikeObject;

},{"./isArrayLike.js":"6DRGr","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6DRGr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && (0, _isLengthJsDefault.default)(value.length) && !(0, _isFunctionJsDefault.default)(value);
}
exports.default = isArrayLike;

},{"./isFunction.js":"7pb6H","./isLength.js":"jbwyd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jbwyd":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
exports.default = isLength;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dkqfQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _stubFalseJs = require("./stubFalse.js");
var _stubFalseJsDefault = parcelHelpers.interopDefault(_stubFalseJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, _stubFalseJsDefault.default);
exports.default = isBuffer;

},{"./_root.js":"10cmd","./stubFalse.js":"hcocD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hcocD":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubFalse() {
    return false;
}
exports.default = stubFalse;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fiE8B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!(0, _isObjectLikeJsDefault.default)(value) || (0, _baseGetTagJsDefault.default)(value) != objectTag) return false;
    var proto = (0, _getPrototypeJsDefault.default)(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
exports.default = isPlainObject;

},{"./_baseGetTag.js":"9Chff","./_getPrototype.js":"gSX6x","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fH44A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsTypedArrayJs = require("./_baseIsTypedArray.js");
var _baseIsTypedArrayJsDefault = parcelHelpers.interopDefault(_baseIsTypedArrayJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsTypedArray = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? (0, _baseUnaryJsDefault.default)(nodeIsTypedArray) : (0, _baseIsTypedArrayJsDefault.default);
exports.default = isTypedArray;

},{"./_baseIsTypedArray.js":"kuqtj","./_baseUnary.js":"9mRng","./_nodeUtil.js":"jdWud","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kuqtj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isLengthJsDefault.default)(value.length) && !!typedArrayTags[(0, _baseGetTagJsDefault.default)(value)];
}
exports.default = baseIsTypedArray;

},{"./_baseGetTag.js":"9Chff","./isLength.js":"jbwyd","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9mRng":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
exports.default = baseUnary;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jdWud":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, _freeGlobalJsDefault.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
exports.default = nodeUtil;

},{"./_freeGlobal.js":"cvlFB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b7qYM":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
exports.default = safeGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGHEy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return (0, _copyObjectJsDefault.default)(value, (0, _keysInJsDefault.default)(value));
}
exports.default = toPlainObject;

},{"./_copyObject.js":"iLQwq","./keysIn.js":"dOdxD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iLQwq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignValueJs = require("./_assignValue.js");
var _assignValueJsDefault = parcelHelpers.interopDefault(_assignValueJs);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, _baseAssignValueJsDefault.default)(object, key, newValue);
        else (0, _assignValueJsDefault.default)(object, key, newValue);
    }
    return object;
}
exports.default = copyObject;

},{"./_assignValue.js":"6Dqnr","./_baseAssignValue.js":"7WwSg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Dqnr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && (0, _eqJsDefault.default)(objValue, value)) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignValue;

},{"./_baseAssignValue.js":"7WwSg","./eq.js":"d11tM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dOdxD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysInJs = require("./_baseKeysIn.js");
var _baseKeysInJsDefault = parcelHelpers.interopDefault(_baseKeysInJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object, true) : (0, _baseKeysInJsDefault.default)(object);
}
exports.default = keysIn;

},{"./_arrayLikeKeys.js":"fwfx8","./_baseKeysIn.js":"i1Mf7","./isArrayLike.js":"6DRGr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fwfx8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTimesJs = require("./_baseTimes.js");
var _baseTimesJsDefault = parcelHelpers.interopDefault(_baseTimesJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = (0, _isArrayJsDefault.default)(value), isArg = !isArr && (0, _isArgumentsJsDefault.default)(value), isBuff = !isArr && !isArg && (0, _isBufferJsDefault.default)(value), isType = !isArr && !isArg && !isBuff && (0, _isTypedArrayJsDefault.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, _baseTimesJsDefault.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, _isIndexJsDefault.default)(key, length)))) result.push(key);
    return result;
}
exports.default = arrayLikeKeys;

},{"./_baseTimes.js":"9nudW","./isArguments.js":"3o5tK","./isArray.js":"dB5dn","./isBuffer.js":"dkqfQ","./_isIndex.js":"axaW4","./isTypedArray.js":"fH44A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9nudW":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
exports.default = baseTimes;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"axaW4":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
exports.default = isIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i1Mf7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysInJs = require("./_nativeKeysIn.js");
var _nativeKeysInJsDefault = parcelHelpers.interopDefault(_nativeKeysInJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!(0, _isObjectJsDefault.default)(object)) return (0, _nativeKeysInJsDefault.default)(object);
    var isProto = (0, _isPrototypeJsDefault.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
exports.default = baseKeysIn;

},{"./isObject.js":"ah1Cr","./_isPrototype.js":"kOZ2F","./_nativeKeysIn.js":"cTfMl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cTfMl":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
exports.default = nativeKeysIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ktr6u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseRestJs = require("./_baseRest.js");
var _baseRestJsDefault = parcelHelpers.interopDefault(_baseRestJs);
var _isIterateeCallJs = require("./_isIterateeCall.js");
var _isIterateeCallJsDefault = parcelHelpers.interopDefault(_isIterateeCallJs);
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return (0, _baseRestJsDefault.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, _isIterateeCallJsDefault.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
exports.default = createAssigner;

},{"./_baseRest.js":"gtLav","./_isIterateeCall.js":"ddyyQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtLav":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _overRestJs = require("./_overRest.js");
var _overRestJsDefault = parcelHelpers.interopDefault(_overRestJs);
var _setToStringJs = require("./_setToString.js");
var _setToStringJsDefault = parcelHelpers.interopDefault(_setToStringJs);
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return (0, _setToStringJsDefault.default)((0, _overRestJsDefault.default)(func, start, (0, _identityJsDefault.default)), func + '');
}
exports.default = baseRest;

},{"./identity.js":"1Jo6N","./_overRest.js":"33KqE","./_setToString.js":"2i4Wc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Jo6N":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function identity(value) {
    return value;
}
exports.default = identity;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"33KqE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _applyJs = require("./_apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, _applyJsDefault.default)(func, this, otherArgs);
    };
}
exports.default = overRest;

},{"./_apply.js":"lEMSr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lEMSr":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
exports.default = apply;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2i4Wc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseSetToStringJs = require("./_baseSetToString.js");
var _baseSetToStringJsDefault = parcelHelpers.interopDefault(_baseSetToStringJs);
var _shortOutJs = require("./_shortOut.js");
var _shortOutJsDefault = parcelHelpers.interopDefault(_shortOutJs);
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = (0, _shortOutJsDefault.default)((0, _baseSetToStringJsDefault.default));
exports.default = setToString;

},{"./_baseSetToString.js":"6kp8T","./_shortOut.js":"fyiMt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kp8T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !(0, _definePropertyJsDefault.default) ? (0, _identityJsDefault.default) : function(func, string) {
    return (0, _definePropertyJsDefault.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, _constantJsDefault.default)(string),
        'writable': true
    });
};
exports.default = baseSetToString;

},{"./constant.js":"d1OmC","./_defineProperty.js":"hoPLT","./identity.js":"1Jo6N","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d1OmC":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function constant(value) {
    return function() {
        return value;
    };
}
exports.default = constant;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fyiMt":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
exports.default = shortOut;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ddyyQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!(0, _isObjectJsDefault.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, _isArrayLikeJsDefault.default)(object) && (0, _isIndexJsDefault.default)(index, object.length) : type == 'string' && index in object) return (0, _eqJsDefault.default)(object[index], value);
    return false;
}
exports.default = isIterateeCall;

},{"./eq.js":"d11tM","./isArrayLike.js":"6DRGr","./_isIndex.js":"axaW4","./isObject.js":"ah1Cr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lSRGQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Saturation", ()=>Saturation);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _throttle = require("lodash-es/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _saturation = require("../../helpers/saturation");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Saturation = function(_ref) {
    _inherits(Saturation, _ref);
    function Saturation(props) {
        _classCallCheck(this, Saturation);
        var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, _saturation.calculateChange(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener('mousemove', _this.handleChange);
            renderWindow.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, _throttleDefault.default)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    _createClass(Saturation, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: 'getContainerRenderWindow',
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener('mousemove', this.handleChange);
                renderWindow.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        color: {
                            absolute: '0px 0px 0px 0px',
                            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: '0px 0px 0px 0px',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            top: -(this.props.hsv.v * 100) + 100 + '%',
                            left: this.props.hsv.s * 100 + '%',
                            cursor: 'default'
                        },
                        circle: {
                            width: '4px',
                            height: '4px',
                            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
                            borderRadius: '50%',
                            cursor: 'hand',
                            transform: 'translate(-2px, -2px)'
                        }
                    },
                    'custom': {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    'custom': !!this.props.style
                });
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), (0, _reactDefault.default).createElement('div', {
                    style: styles.white,
                    className: 'saturation-white'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.black,
                    className: 'saturation-black'
                }), (0, _reactDefault.default).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement('div', {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Saturation;

},{"react":"9njXz","reactcss":"7O6YP","lodash-es/throttle":"aRatu","../../helpers/saturation":"3obSh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRatu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _debounceJs = require("./debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return (0, _debounceJsDefault.default)(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
exports.default = throttle;

},{"./debounce.js":"l3yba","./isObject.js":"ah1Cr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l3yba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _nowJs = require("./now.js");
var _nowJsDefault = parcelHelpers.interopDefault(_nowJs);
var _toNumberJs = require("./toNumber.js");
var _toNumberJsDefault = parcelHelpers.interopDefault(_toNumberJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = (0, _toNumberJsDefault.default)(wait) || 0;
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax((0, _toNumberJsDefault.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, _nowJsDefault.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, _nowJsDefault.default)());
    }
    function debounced() {
        var time = (0, _nowJsDefault.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
exports.default = debounce;

},{"./isObject.js":"ah1Cr","./now.js":"i9l7u","./toNumber.js":"4AdPu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9l7u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return (0, _rootJsDefault.default).Date.now();
};
exports.default = now;

},{"./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4AdPu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTrimJs = require("./_baseTrim.js");
var _baseTrimJsDefault = parcelHelpers.interopDefault(_baseTrimJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, _isSymbolJsDefault.default)(value)) return NAN;
    if ((0, _isObjectJsDefault.default)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, _isObjectJsDefault.default)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, _baseTrimJsDefault.default)(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
exports.default = toNumber;

},{"./_baseTrim.js":"luSuV","./isObject.js":"ah1Cr","./isSymbol.js":"8V8ty","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"luSuV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trimmedEndIndexJs = require("./_trimmedEndIndex.js");
var _trimmedEndIndexJsDefault = parcelHelpers.interopDefault(_trimmedEndIndexJs);
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, (0, _trimmedEndIndexJsDefault.default)(string) + 1).replace(reTrimStart, '') : string;
}
exports.default = baseTrim;

},{"./_trimmedEndIndex.js":"c0kTb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c0kTb":[function(require,module,exports,__globalThis) {
/** Used to match a single whitespace character. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
exports.default = trimmedEndIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8V8ty":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == symbolTag;
}
exports.default = isSymbol;

},{"./_baseGetTag.js":"9Chff","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3obSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: 'hsv'
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jBu17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorWrap", ()=>ColorWrap);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _debounce = require("lodash-es/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _color = require("../../helpers/color");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColorWrap = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        _inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            _classCallCheck(this, ColorPicker);
            var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = _color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = _color.toState(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = _color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = _color.toState(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = _extends({}, _color.toState(props.color, 0));
            _this.debounce = (0, _debounceDefault.default)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        _createClass(ColorPicker, [
            {
                key: 'render',
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, _reactDefault.default).createElement(Picker, _extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: 'getDerivedStateFromProps',
                value: function getDerivedStateFromProps(nextProps, state) {
                    return _extends({}, _color.toState(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, _react.PureComponent) || (0, _react.Component));
    ColorPicker.propTypes = _extends({}, Picker.propTypes);
    ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
exports.default = ColorWrap;

},{"react":"9njXz","lodash-es/debounce":"l3yba","../../helpers/color":"lNUGR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lNUGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "simpleCheckForValidColor", ()=>simpleCheckForValidColor);
parcelHelpers.export(exports, "toState", ()=>toState);
parcelHelpers.export(exports, "isValidHex", ()=>isValidHex);
parcelHelpers.export(exports, "getContrastingColor", ()=>getContrastingColor);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "isvalidColorString", ()=>isvalidColorString);
var _each = require("lodash-es/each");
var _eachDefault = parcelHelpers.interopDefault(_each);
var _tinycolor2 = require("tinycolor2");
var _tinycolor2Default = parcelHelpers.interopDefault(_tinycolor2);
var simpleCheckForValidColor = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        'r',
        'g',
        'b',
        'a',
        'h',
        's',
        'l',
        'v'
    ];
    var checked = 0;
    var passed = 0;
    (0, _eachDefault.default)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === 's' || letter === 'l') {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var toState = function toState(data, oldHue) {
    var color = data.hex ? (0, _tinycolor2Default.default)(data.hex) : (0, _tinycolor2Default.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? 'transparent' : '#' + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var isValidHex = function isValidHex(hex) {
    if (hex === 'transparent') return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2Default.default)(hex).isValid();
};
var getContrastingColor = function getContrastingColor(data) {
    if (!data) return '#fff';
    var col = toState(data);
    if (col.hex === 'transparent') return 'rgba(0,0,0,0.4)';
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
};
var red = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: '#ff0000',
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var isvalidColorString = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", '');
    return (0, _tinycolor2Default.default)(type + ' (' + stringWithoutDegree + ')')._ok;
};

},{"lodash-es/each":"jhCGo","tinycolor2":"4AVaN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jhCGo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _forEachJsDefault.default));
var _forEachJs = require("./forEach.js");
var _forEachJsDefault = parcelHelpers.interopDefault(_forEachJs);

},{"./forEach.js":"6jYhk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6jYhk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayEachJs = require("./_arrayEach.js");
var _arrayEachJsDefault = parcelHelpers.interopDefault(_arrayEachJs);
var _baseEachJs = require("./_baseEach.js");
var _baseEachJsDefault = parcelHelpers.interopDefault(_baseEachJs);
var _castFunctionJs = require("./_castFunction.js");
var _castFunctionJsDefault = parcelHelpers.interopDefault(_castFunctionJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forEach(collection, iteratee) {
    var func = (0, _isArrayJsDefault.default)(collection) ? (0, _arrayEachJsDefault.default) : (0, _baseEachJsDefault.default);
    return func(collection, (0, _castFunctionJsDefault.default)(iteratee));
}
exports.default = forEach;

},{"./_arrayEach.js":"4J6Eo","./_baseEach.js":"jNEvS","./_castFunction.js":"3z0qa","./isArray.js":"dB5dn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4J6Eo":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
exports.default = arrayEach;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jNEvS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseForOwnJs = require("./_baseForOwn.js");
var _baseForOwnJsDefault = parcelHelpers.interopDefault(_baseForOwnJs);
var _createBaseEachJs = require("./_createBaseEach.js");
var _createBaseEachJsDefault = parcelHelpers.interopDefault(_createBaseEachJs);
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = (0, _createBaseEachJsDefault.default)((0, _baseForOwnJsDefault.default));
exports.default = baseEach;

},{"./_baseForOwn.js":"3eFz9","./_createBaseEach.js":"ga21g","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3eFz9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseForJs = require("./_baseFor.js");
var _baseForJsDefault = parcelHelpers.interopDefault(_baseForJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && (0, _baseForJsDefault.default)(object, iteratee, (0, _keysJsDefault.default));
}
exports.default = baseForOwn;

},{"./_baseFor.js":"1b7Jy","./keys.js":"h1d6U","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h1d6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysJs = require("./_baseKeys.js");
var _baseKeysJsDefault = parcelHelpers.interopDefault(_baseKeysJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object) : (0, _baseKeysJsDefault.default)(object);
}
exports.default = keys;

},{"./_arrayLikeKeys.js":"fwfx8","./_baseKeys.js":"hSUtG","./isArrayLike.js":"6DRGr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hSUtG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysJs = require("./_nativeKeys.js");
var _nativeKeysJsDefault = parcelHelpers.interopDefault(_nativeKeysJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!(0, _isPrototypeJsDefault.default)(object)) return (0, _nativeKeysJsDefault.default)(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
exports.default = baseKeys;

},{"./_isPrototype.js":"kOZ2F","./_nativeKeys.js":"6brqc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6brqc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = (0, _overArgJsDefault.default)(Object.keys, Object);
exports.default = nativeKeys;

},{"./_overArg.js":"gLjM1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ga21g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, _isArrayLikeJsDefault.default)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
exports.default = createBaseEach;

},{"./isArrayLike.js":"6DRGr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3z0qa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == 'function' ? value : (0, _identityJsDefault.default);
}
exports.default = castFunction;

},{"./identity.js":"1Jo6N","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aOxoG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swatch", ()=>Swatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _interaction = require("../../helpers/interaction");
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var ENTER = 13;
var Swatch = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === 'transparent';
    var styles = (0, _reactcssDefault.default)({
        default: {
            swatch: _extends({
                background: color,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                position: 'relative',
                outline: 'none'
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, _reactDefault.default).createElement('div', _extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, _reactDefault.default).createElement((0, _checkboardDefault.default), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    }));
};
exports.default = (0, _interaction.handleFocus)(Swatch);

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/interaction":"7EkZ3","./Checkboard":"fcpxn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7EkZ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleFocus", ()=>handleFocus);
/* eslint-disable no-invalid-this */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: 'render',
                value: function render() {
                    return (0, _reactDefault.default).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, _reactDefault.default).createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, _reactDefault.default).Component);
};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dStp4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPointer", ()=>AlphaPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var AlphaPointer = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = AlphaPointer;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lM1AY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Block", ()=>Block);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var _blockSwatches = require("./BlockSwatches");
var _blockSwatchesDefault = parcelHelpers.interopDefault(_blockSwatches);
var Block = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var transparent = hex === 'transparent';
    var handleChange = function handleChange(hexCode, e) {
        _color.isValidHex(hexCode) && onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                boxShadow: '0 1px rgba(0,0,0,.1)',
                borderRadius: '6px',
                position: 'relative'
            },
            head: {
                height: '110px',
                background: hex,
                borderRadius: '6px 6px 0 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
            },
            body: {
                padding: '10px'
            },
            label: {
                fontSize: '18px',
                color: _color.getContrastingColor(hex),
                position: 'relative'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 10px 10px 10px',
                borderColor: 'transparent transparent ' + hex + ' transparent',
                position: 'absolute',
                top: '-10px',
                left: '50%',
                marginLeft: '-10px'
            },
            input: {
                width: '100%',
                fontSize: '12px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '22px',
                boxShadow: 'inset 0 0 0 1px #ddd',
                borderRadius: '4px',
                padding: '0 7px',
                boxSizing: 'border-box'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide'
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'block-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.triangle
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.head
    }, transparent && (0, _reactDefault.default).createElement((0, _common.Checkboard), {
        borderRadius: '6px 6px 0 0'
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.label
    }, hex)), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _reactDefault.default).createElement((0, _blockSwatchesDefault.default), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
Block.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    triangle: (0, _propTypesDefault.default).oneOf([
        'top',
        'hide'
    ]),
    styles: (0, _propTypesDefault.default).object
};
Block.defaultProps = {
    width: 170,
    colors: [
        '#D9E3F0',
        '#F47373',
        '#697689',
        '#37D67A',
        '#2CCCE4',
        '#555555',
        '#dce775',
        '#ff8a65',
        '#ba68c8'
    ],
    triangle: 'top',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Block);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../../helpers/color":"lNUGR","../common":"f3pVr","./BlockSwatches":"5a558","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5a558":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockSwatches", ()=>BlockSwatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _common = require("../common");
var BlockSwatches = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatches: {
                marginRight: '-10px'
            },
            swatch: {
                width: '22px',
                height: '22px',
                float: 'left',
                marginRight: '10px',
                marginBottom: '10px',
                borderRadius: '4px'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _common.Swatch), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    }));
};
exports.default = BlockSwatches;

},{"react":"9njXz","reactcss":"7O6YP","lodash-es/map":"8jKVV","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8jKVV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _baseIterateeJs = require("./_baseIteratee.js");
var _baseIterateeJsDefault = parcelHelpers.interopDefault(_baseIterateeJs);
var _baseMapJs = require("./_baseMap.js");
var _baseMapJsDefault = parcelHelpers.interopDefault(_baseMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = (0, _isArrayJsDefault.default)(collection) ? (0, _arrayMapJsDefault.default) : (0, _baseMapJsDefault.default);
    return func(collection, (0, _baseIterateeJsDefault.default)(iteratee, 3));
}
exports.default = map;

},{"./_arrayMap.js":"1tnvM","./_baseIteratee.js":"7juta","./_baseMap.js":"4OYjy","./isArray.js":"dB5dn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1tnvM":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
exports.default = arrayMap;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7juta":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseMatchesJs = require("./_baseMatches.js");
var _baseMatchesJsDefault = parcelHelpers.interopDefault(_baseMatchesJs);
var _baseMatchesPropertyJs = require("./_baseMatchesProperty.js");
var _baseMatchesPropertyJsDefault = parcelHelpers.interopDefault(_baseMatchesPropertyJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, _identityJsDefault.default;
    if (typeof value == 'object') return (0, _isArrayJsDefault.default)(value) ? (0, _baseMatchesPropertyJsDefault.default)(value[0], value[1]) : (0, _baseMatchesJsDefault.default)(value);
    return (0, _propertyJsDefault.default)(value);
}
exports.default = baseIteratee;

},{"./_baseMatches.js":"6cNES","./_baseMatchesProperty.js":"jSEeK","./identity.js":"1Jo6N","./isArray.js":"dB5dn","./property.js":"k8mcz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cNES":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsMatchJs = require("./_baseIsMatch.js");
var _baseIsMatchJsDefault = parcelHelpers.interopDefault(_baseIsMatchJs);
var _getMatchDataJs = require("./_getMatchData.js");
var _getMatchDataJsDefault = parcelHelpers.interopDefault(_getMatchDataJs);
var _matchesStrictComparableJs = require("./_matchesStrictComparable.js");
var _matchesStrictComparableJsDefault = parcelHelpers.interopDefault(_matchesStrictComparableJs);
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = (0, _getMatchDataJsDefault.default)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, _matchesStrictComparableJsDefault.default)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, _baseIsMatchJsDefault.default)(object, source, matchData);
    };
}
exports.default = baseMatches;

},{"./_baseIsMatch.js":"5QyMm","./_getMatchData.js":"fhomB","./_matchesStrictComparable.js":"knWvD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5QyMm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _baseIsEqualJs = require("./_baseIsEqual.js");
var _baseIsEqualJsDefault = parcelHelpers.interopDefault(_baseIsEqualJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, _stackJsDefault.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, _baseIsEqualJsDefault.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
exports.default = baseIsMatch;

},{"./_Stack.js":"6rfzp","./_baseIsEqual.js":"6HlYN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HlYN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsEqualDeepJs = require("./_baseIsEqualDeep.js");
var _baseIsEqualDeepJsDefault = parcelHelpers.interopDefault(_baseIsEqualDeepJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, _isObjectLikeJsDefault.default)(value) && !(0, _isObjectLikeJsDefault.default)(other)) return value !== value && other !== other;
    return (0, _baseIsEqualDeepJsDefault.default)(value, other, bitmask, customizer, baseIsEqual, stack);
}
exports.default = baseIsEqual;

},{"./_baseIsEqualDeep.js":"kCgzd","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kCgzd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _equalArraysJs = require("./_equalArrays.js");
var _equalArraysJsDefault = parcelHelpers.interopDefault(_equalArraysJs);
var _equalByTagJs = require("./_equalByTag.js");
var _equalByTagJsDefault = parcelHelpers.interopDefault(_equalByTagJs);
var _equalObjectsJs = require("./_equalObjects.js");
var _equalObjectsJsDefault = parcelHelpers.interopDefault(_equalObjectsJs);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, _isArrayJsDefault.default)(object), othIsArr = (0, _isArrayJsDefault.default)(other), objTag = objIsArr ? arrayTag : (0, _getTagJsDefault.default)(object), othTag = othIsArr ? arrayTag : (0, _getTagJsDefault.default)(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, _isBufferJsDefault.default)(object)) {
        if (!(0, _isBufferJsDefault.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, _stackJsDefault.default));
        return objIsArr || (0, _isTypedArrayJsDefault.default)(object) ? (0, _equalArraysJsDefault.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, _equalByTagJsDefault.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, _stackJsDefault.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, _stackJsDefault.default));
    return (0, _equalObjectsJsDefault.default)(object, other, bitmask, customizer, equalFunc, stack);
}
exports.default = baseIsEqualDeep;

},{"./_Stack.js":"6rfzp","./_equalArrays.js":"lsOdO","./_equalByTag.js":"7NOrr","./_equalObjects.js":"79mhq","./_getTag.js":"2LNQq","./isArray.js":"dB5dn","./isBuffer.js":"dkqfQ","./isTypedArray.js":"fH44A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lsOdO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setCacheJs = require("./_SetCache.js");
var _setCacheJsDefault = parcelHelpers.interopDefault(_setCacheJs);
var _arraySomeJs = require("./_arraySome.js");
var _arraySomeJsDefault = parcelHelpers.interopDefault(_arraySomeJs);
var _cacheHasJs = require("./_cacheHas.js");
var _cacheHasJsDefault = parcelHelpers.interopDefault(_cacheHasJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new (0, _setCacheJsDefault.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, _arraySomeJsDefault.default)(other, function(othValue, othIndex) {
                if (!(0, _cacheHasJsDefault.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
exports.default = equalArrays;

},{"./_SetCache.js":"1J5sL","./_arraySome.js":"kXvJ8","./_cacheHas.js":"66YrX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1J5sL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
var _setCacheAddJs = require("./_setCacheAdd.js");
var _setCacheAddJsDefault = parcelHelpers.interopDefault(_setCacheAddJs);
var _setCacheHasJs = require("./_setCacheHas.js");
var _setCacheHasJsDefault = parcelHelpers.interopDefault(_setCacheHasJs);
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, _mapCacheJsDefault.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = (0, _setCacheAddJsDefault.default);
SetCache.prototype.has = (0, _setCacheHasJsDefault.default);
exports.default = SetCache;

},{"./_MapCache.js":"iZCA7","./_setCacheAdd.js":"39Tn6","./_setCacheHas.js":"2s3eV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"39Tn6":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
exports.default = setCacheAdd;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2s3eV":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setCacheHas(value) {
    return this.__data__.has(value);
}
exports.default = setCacheHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kXvJ8":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
exports.default = arraySome;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"66YrX":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function cacheHas(cache, key) {
    return cache.has(key);
}
exports.default = cacheHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7NOrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
var _equalArraysJs = require("./_equalArrays.js");
var _equalArraysJsDefault = parcelHelpers.interopDefault(_equalArraysJs);
var _mapToArrayJs = require("./_mapToArray.js");
var _mapToArrayJsDefault = parcelHelpers.interopDefault(_mapToArrayJs);
var _setToArrayJs = require("./_setToArray.js");
var _setToArrayJsDefault = parcelHelpers.interopDefault(_setToArrayJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, _uint8ArrayJsDefault.default)(object), new (0, _uint8ArrayJsDefault.default)(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, _eqJsDefault.default)(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = (0, _mapToArrayJsDefault.default);
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, _setToArrayJsDefault.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, _equalArraysJsDefault.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
exports.default = equalByTag;

},{"./_Symbol.js":"c53Uj","./_Uint8Array.js":"cyDAa","./eq.js":"d11tM","./_equalArrays.js":"lsOdO","./_mapToArray.js":"dnqp1","./_setToArray.js":"eND1b","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dnqp1":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
exports.default = mapToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eND1b":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
exports.default = setToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"79mhq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getAllKeysJs = require("./_getAllKeys.js");
var _getAllKeysJsDefault = parcelHelpers.interopDefault(_getAllKeysJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = (0, _getAllKeysJsDefault.default)(object), objLength = objProps.length, othProps = (0, _getAllKeysJsDefault.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
exports.default = equalObjects;

},{"./_getAllKeys.js":"3kMpy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3kMpy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetAllKeysJs = require("./_baseGetAllKeys.js");
var _baseGetAllKeysJsDefault = parcelHelpers.interopDefault(_baseGetAllKeysJs);
var _getSymbolsJs = require("./_getSymbols.js");
var _getSymbolsJsDefault = parcelHelpers.interopDefault(_getSymbolsJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return (0, _baseGetAllKeysJsDefault.default)(object, (0, _keysJsDefault.default), (0, _getSymbolsJsDefault.default));
}
exports.default = getAllKeys;

},{"./_baseGetAllKeys.js":"dzcVX","./_getSymbols.js":"clM4u","./keys.js":"h1d6U","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzcVX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayPushJs = require("./_arrayPush.js");
var _arrayPushJsDefault = parcelHelpers.interopDefault(_arrayPushJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, _isArrayJsDefault.default)(object) ? result : (0, _arrayPushJsDefault.default)(result, symbolsFunc(object));
}
exports.default = baseGetAllKeys;

},{"./_arrayPush.js":"a6JW1","./isArray.js":"dB5dn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a6JW1":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
exports.default = arrayPush;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"clM4u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayFilterJs = require("./_arrayFilter.js");
var _arrayFilterJsDefault = parcelHelpers.interopDefault(_arrayFilterJs);
var _stubArrayJs = require("./stubArray.js");
var _stubArrayJsDefault = parcelHelpers.interopDefault(_stubArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? (0, _stubArrayJsDefault.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, _arrayFilterJsDefault.default)(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
exports.default = getSymbols;

},{"./_arrayFilter.js":"brmpQ","./stubArray.js":"bgOWo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"brmpQ":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
exports.default = arrayFilter;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bgOWo":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubArray() {
    return [];
}
exports.default = stubArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2LNQq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataViewJs = require("./_DataView.js");
var _dataViewJsDefault = parcelHelpers.interopDefault(_dataViewJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _promiseJs = require("./_Promise.js");
var _promiseJsDefault = parcelHelpers.interopDefault(_promiseJs);
var _setJs = require("./_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _weakMapJs = require("./_WeakMap.js");
var _weakMapJsDefault = parcelHelpers.interopDefault(_weakMapJs);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = (0, _toSourceJsDefault.default)((0, _dataViewJsDefault.default)), mapCtorString = (0, _toSourceJsDefault.default)((0, _mapJsDefault.default)), promiseCtorString = (0, _toSourceJsDefault.default)((0, _promiseJsDefault.default)), setCtorString = (0, _toSourceJsDefault.default)((0, _setJsDefault.default)), weakMapCtorString = (0, _toSourceJsDefault.default)((0, _weakMapJsDefault.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = (0, _baseGetTagJsDefault.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, _dataViewJsDefault.default) && getTag(new (0, _dataViewJsDefault.default)(new ArrayBuffer(1))) != dataViewTag || (0, _mapJsDefault.default) && getTag(new (0, _mapJsDefault.default)) != mapTag || (0, _promiseJsDefault.default) && getTag((0, _promiseJsDefault.default).resolve()) != promiseTag || (0, _setJsDefault.default) && getTag(new (0, _setJsDefault.default)) != setTag || (0, _weakMapJsDefault.default) && getTag(new (0, _weakMapJsDefault.default)) != weakMapTag) getTag = function(value) {
    var result = (0, _baseGetTagJsDefault.default)(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, _toSourceJsDefault.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
exports.default = getTag;

},{"./_DataView.js":"56JMA","./_Map.js":"13fDv","./_Promise.js":"gv9IS","./_Set.js":"9sKcS","./_WeakMap.js":"lEW1C","./_baseGetTag.js":"9Chff","./_toSource.js":"755gJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"56JMA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var DataView = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'DataView');
exports.default = DataView;

},{"./_getNative.js":"Z5FSj","./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gv9IS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Promise = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Promise');
exports.default = Promise;

},{"./_getNative.js":"Z5FSj","./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9sKcS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Set = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Set');
exports.default = Set;

},{"./_getNative.js":"Z5FSj","./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lEW1C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var WeakMap = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'WeakMap');
exports.default = WeakMap;

},{"./_getNative.js":"Z5FSj","./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fhomB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isStrictComparableJs = require("./_isStrictComparable.js");
var _isStrictComparableJsDefault = parcelHelpers.interopDefault(_isStrictComparableJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = (0, _keysJsDefault.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, _isStrictComparableJsDefault.default)(value)
        ];
    }
    return result;
}
exports.default = getMatchData;

},{"./_isStrictComparable.js":"fvm5A","./keys.js":"h1d6U","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fvm5A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !(0, _isObjectJsDefault.default)(value);
}
exports.default = isStrictComparable;

},{"./isObject.js":"ah1Cr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"knWvD":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
exports.default = matchesStrictComparable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jSEeK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsEqualJs = require("./_baseIsEqual.js");
var _baseIsEqualJsDefault = parcelHelpers.interopDefault(_baseIsEqualJs);
var _getJs = require("./get.js");
var _getJsDefault = parcelHelpers.interopDefault(_getJs);
var _hasInJs = require("./hasIn.js");
var _hasInJsDefault = parcelHelpers.interopDefault(_hasInJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _isStrictComparableJs = require("./_isStrictComparable.js");
var _isStrictComparableJsDefault = parcelHelpers.interopDefault(_isStrictComparableJs);
var _matchesStrictComparableJs = require("./_matchesStrictComparable.js");
var _matchesStrictComparableJsDefault = parcelHelpers.interopDefault(_matchesStrictComparableJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if ((0, _isKeyJsDefault.default)(path) && (0, _isStrictComparableJsDefault.default)(srcValue)) return (0, _matchesStrictComparableJsDefault.default)((0, _toKeyJsDefault.default)(path), srcValue);
    return function(object) {
        var objValue = (0, _getJsDefault.default)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, _hasInJsDefault.default)(object, path) : (0, _baseIsEqualJsDefault.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
exports.default = baseMatchesProperty;

},{"./_baseIsEqual.js":"6HlYN","./get.js":"khbYF","./hasIn.js":"il2K5","./_isKey.js":"f9sqz","./_isStrictComparable.js":"fvm5A","./_matchesStrictComparable.js":"knWvD","./_toKey.js":"aoJfk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"khbYF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetJs = require("./_baseGet.js");
var _baseGetJsDefault = parcelHelpers.interopDefault(_baseGetJs);
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, _baseGetJsDefault.default)(object, path);
    return result === undefined ? defaultValue : result;
}
exports.default = get;

},{"./_baseGet.js":"12l3C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"12l3C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _castPathJs = require("./_castPath.js");
var _castPathJsDefault = parcelHelpers.interopDefault(_castPathJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = (0, _castPathJsDefault.default)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, _toKeyJsDefault.default)(path[index++])];
    return index && index == length ? object : undefined;
}
exports.default = baseGet;

},{"./_castPath.js":"75Zqo","./_toKey.js":"aoJfk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"75Zqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _stringToPathJs = require("./_stringToPath.js");
var _stringToPathJsDefault = parcelHelpers.interopDefault(_stringToPathJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if ((0, _isArrayJsDefault.default)(value)) return value;
    return (0, _isKeyJsDefault.default)(value, object) ? [
        value
    ] : (0, _stringToPathJsDefault.default)((0, _toStringJsDefault.default)(value));
}
exports.default = castPath;

},{"./isArray.js":"dB5dn","./_isKey.js":"f9sqz","./_stringToPath.js":"e7FCA","./toString.js":"4if57","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f9sqz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if ((0, _isArrayJsDefault.default)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, _isSymbolJsDefault.default)(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
exports.default = isKey;

},{"./isArray.js":"dB5dn","./isSymbol.js":"8V8ty","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e7FCA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeCappedJs = require("./_memoizeCapped.js");
var _memoizeCappedJsDefault = parcelHelpers.interopDefault(_memoizeCappedJs);
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = (0, _memoizeCappedJsDefault.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
exports.default = stringToPath;

},{"./_memoizeCapped.js":"eYQBK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eYQBK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeJs = require("./memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = (0, _memoizeJsDefault.default)(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
exports.default = memoizeCapped;

},{"./memoize.js":"eD0Xs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eD0Xs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || (0, _mapCacheJsDefault.default));
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = (0, _mapCacheJsDefault.default);
exports.default = memoize;

},{"./_MapCache.js":"iZCA7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4if57":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseToStringJs = require("./_baseToString.js");
var _baseToStringJsDefault = parcelHelpers.interopDefault(_baseToStringJs);
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : (0, _baseToStringJsDefault.default)(value);
}
exports.default = toString;

},{"./_baseToString.js":"7fpnr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7fpnr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, _isArrayJsDefault.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, _arrayMapJsDefault.default)(value, baseToString) + '';
    if ((0, _isSymbolJsDefault.default)(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
exports.default = baseToString;

},{"./_Symbol.js":"c53Uj","./_arrayMap.js":"1tnvM","./isArray.js":"dB5dn","./isSymbol.js":"8V8ty","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aoJfk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || (0, _isSymbolJsDefault.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
exports.default = toKey;

},{"./isSymbol.js":"8V8ty","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"il2K5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseHasInJs = require("./_baseHasIn.js");
var _baseHasInJsDefault = parcelHelpers.interopDefault(_baseHasInJs);
var _hasPathJs = require("./_hasPath.js");
var _hasPathJsDefault = parcelHelpers.interopDefault(_hasPathJs);
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && (0, _hasPathJsDefault.default)(object, path, (0, _baseHasInJsDefault.default));
}
exports.default = hasIn;

},{"./_baseHasIn.js":"16Jzn","./_hasPath.js":"iHiGa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16Jzn":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
exports.default = baseHasIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iHiGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _castPathJs = require("./_castPath.js");
var _castPathJsDefault = parcelHelpers.interopDefault(_castPathJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = (0, _castPathJsDefault.default)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, _toKeyJsDefault.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, _isLengthJsDefault.default)(length) && (0, _isIndexJsDefault.default)(key, length) && ((0, _isArrayJsDefault.default)(object) || (0, _isArgumentsJsDefault.default)(object));
}
exports.default = hasPath;

},{"./_castPath.js":"75Zqo","./isArguments.js":"3o5tK","./isArray.js":"dB5dn","./_isIndex.js":"axaW4","./isLength.js":"jbwyd","./_toKey.js":"aoJfk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k8mcz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basePropertyJs = require("./_baseProperty.js");
var _basePropertyJsDefault = parcelHelpers.interopDefault(_basePropertyJs);
var _basePropertyDeepJs = require("./_basePropertyDeep.js");
var _basePropertyDeepJsDefault = parcelHelpers.interopDefault(_basePropertyDeepJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return (0, _isKeyJsDefault.default)(path) ? (0, _basePropertyJsDefault.default)((0, _toKeyJsDefault.default)(path)) : (0, _basePropertyDeepJsDefault.default)(path);
}
exports.default = property;

},{"./_baseProperty.js":"6B23c","./_basePropertyDeep.js":"gIV4H","./_isKey.js":"f9sqz","./_toKey.js":"aoJfk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6B23c":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
exports.default = baseProperty;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gIV4H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetJs = require("./_baseGet.js");
var _baseGetJsDefault = parcelHelpers.interopDefault(_baseGetJs);
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return (0, _baseGetJsDefault.default)(object, path);
    };
}
exports.default = basePropertyDeep;

},{"./_baseGet.js":"12l3C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4OYjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseEachJs = require("./_baseEach.js");
var _baseEachJsDefault = parcelHelpers.interopDefault(_baseEachJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = (0, _isArrayLikeJsDefault.default)(collection) ? Array(collection.length) : [];
    (0, _baseEachJsDefault.default)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
exports.default = baseMap;

},{"./_baseEach.js":"jNEvS","./isArrayLike.js":"6DRGr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4tT9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Circle", ()=>Circle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _materialColors = require("material-colors");
var _common = require("../common");
var _circleSwatch = require("./CircleSwatch");
var _circleSwatchDefault = parcelHelpers.interopDefault(_circleSwatch);
var Circle = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                display: 'flex',
                flexWrap: 'wrap',
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'circle-picker ' + className
    }, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _circleSwatchDefault.default), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
Circle.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    circleSize: (0, _propTypesDefault.default).number,
    circleSpacing: (0, _propTypesDefault.default).number,
    styles: (0, _propTypesDefault.default).object
};
Circle.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        _materialColors.red['500'],
        _materialColors.pink['500'],
        _materialColors.purple['500'],
        _materialColors.deepPurple['500'],
        _materialColors.indigo['500'],
        _materialColors.blue['500'],
        _materialColors.lightBlue['500'],
        _materialColors.cyan['500'],
        _materialColors.teal['500'],
        _materialColors.green['500'],
        _materialColors.lightGreen['500'],
        _materialColors.lime['500'],
        _materialColors.yellow['500'],
        _materialColors.amber['500'],
        _materialColors.orange['500'],
        _materialColors.deepOrange['500'],
        _materialColors.brown['500'],
        _materialColors.blueGrey['500']
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Circle);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/map":"8jKVV","lodash-es/merge":"jQl8F","material-colors":"5pcDo","../common":"f3pVr","./CircleSwatch":"h5WAH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5pcDo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "pink", ()=>pink);
parcelHelpers.export(exports, "purple", ()=>purple);
parcelHelpers.export(exports, "deepPurple", ()=>deepPurple);
parcelHelpers.export(exports, "indigo", ()=>indigo);
parcelHelpers.export(exports, "blue", ()=>blue);
parcelHelpers.export(exports, "lightBlue", ()=>lightBlue);
parcelHelpers.export(exports, "cyan", ()=>cyan);
parcelHelpers.export(exports, "teal", ()=>teal);
parcelHelpers.export(exports, "green", ()=>green);
parcelHelpers.export(exports, "lightGreen", ()=>lightGreen);
parcelHelpers.export(exports, "lime", ()=>lime);
parcelHelpers.export(exports, "yellow", ()=>yellow);
parcelHelpers.export(exports, "amber", ()=>amber);
parcelHelpers.export(exports, "orange", ()=>orange);
parcelHelpers.export(exports, "deepOrange", ()=>deepOrange);
parcelHelpers.export(exports, "brown", ()=>brown);
parcelHelpers.export(exports, "grey", ()=>grey);
parcelHelpers.export(exports, "blueGrey", ()=>blueGrey);
parcelHelpers.export(exports, "darkText", ()=>darkText);
parcelHelpers.export(exports, "lightText", ()=>lightText);
parcelHelpers.export(exports, "darkIcons", ()=>darkIcons);
parcelHelpers.export(exports, "lightIcons", ()=>lightIcons);
parcelHelpers.export(exports, "white", ()=>white);
parcelHelpers.export(exports, "black", ()=>black);
var red = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var pink = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var purple = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var deepPurple = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var indigo = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var blue = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var lightBlue = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var cyan = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var teal = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var green = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var lightGreen = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var lime = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var yellow = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var amber = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var orange = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var deepOrange = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var brown = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var grey = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var blueGrey = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var darkText = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var lightText = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var darkIcons = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var lightIcons = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var white = "#ffffff";
var black = "#000000";
exports.default = {
    red: red,
    pink: pink,
    purple: purple,
    deepPurple: deepPurple,
    indigo: indigo,
    blue: blue,
    lightBlue: lightBlue,
    cyan: cyan,
    teal: teal,
    green: green,
    lightGreen: lightGreen,
    lime: lime,
    yellow: yellow,
    amber: amber,
    orange: orange,
    deepOrange: deepOrange,
    brown: brown,
    grey: grey,
    blueGrey: blueGrey,
    darkText: darkText,
    lightText: lightText,
    darkIcons: darkIcons,
    lightIcons: lightIcons,
    white: white,
    black: black
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h5WAH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleSwatch", ()=>CircleSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var CircleSwatch = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: 'scale(1)',
                transition: '100ms transform ease'
            },
            Swatch: {
                borderRadius: '50%',
                background: 'transparent',
                boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
                transition: '100ms box-shadow ease'
            }
        },
        'hover': {
            swatch: {
                transform: 'scale(1.2)'
            }
        },
        'active': {
            Swatch: {
                boxShadow: 'inset 0 0 0 3px ' + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _common.Swatch), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color
        }
    }));
};
CircleSwatch.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
exports.default = (0, _reactcss.handleHover)(CircleSwatch);

},{"react":"9njXz","reactcss":"7O6YP","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6EiGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Chrome", ()=>Chrome);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _chromeFields = require("./ChromeFields");
var _chromeFieldsDefault = parcelHelpers.interopDefault(_chromeFields);
var _chromePointer = require("./ChromePointer");
var _chromePointerDefault = parcelHelpers.interopDefault(_chromePointer);
var _chromePointerCircle = require("./ChromePointerCircle");
var _chromePointerCircleDefault = parcelHelpers.interopDefault(_chromePointerCircle);
var Chrome = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                borderRadius: '2px',
                boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
                boxSizing: 'initial',
                fontFamily: 'Menlo'
            },
            saturation: {
                width: '100%',
                paddingBottom: '55%',
                position: 'relative',
                borderRadius: '2px 2px 0 0',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '2px 2px 0 0'
            },
            body: {
                padding: '16px 16px 12px'
            },
            controls: {
                display: 'flex'
            },
            color: {
                width: '32px'
            },
            swatch: {
                marginTop: '6px',
                width: '16px',
                height: '16px',
                borderRadius: '8px',
                position: 'relative',
                overflow: 'hidden'
            },
            active: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '8px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
                zIndex: '2'
            },
            toggles: {
                flex: '1'
            },
            hue: {
                height: '10px',
                position: 'relative',
                marginBottom: '8px'
            },
            Hue: {
                radius: '2px'
            },
            alpha: {
                height: '10px',
                position: 'relative'
            },
            Alpha: {
                radius: '2px'
            }
        },
        'disableAlpha': {
            color: {
                width: '22px'
            },
            alpha: {
                display: 'none'
            },
            hue: {
                marginBottom: '0px'
            },
            swatch: {
                width: '10px',
                height: '10px',
                marginTop: '0px'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'chrome-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, _chromePointerCircleDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.color
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.active
    }), (0, _reactDefault.default).createElement((0, _common.Checkboard), {
        renderers: renderers
    }))), (0, _reactDefault.default).createElement('div', {
        style: styles.toggles
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, _chromePointerDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, _chromePointerDefault.default),
        renderers: renderers,
        onChange: onChange
    })))), (0, _reactDefault.default).createElement((0, _chromeFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
Chrome.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    disableAlpha: (0, _propTypesDefault.default).bool,
    styles: (0, _propTypesDefault.default).object,
    defaultView: (0, _propTypesDefault.default).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
Chrome.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Chrome);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./ChromeFields":"4JtUy","./ChromePointer":"60CH6","./ChromePointerCircle":"ghSy8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4JtUy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromeFields", ()=>ChromeFields);
/* eslint-disable react/no-did-mount-set-state, no-param-reassign */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _isUndefined = require("lodash-es/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _common = require("../common");
var _unfoldMoreHorizontalIcon = require("@icons/material/UnfoldMoreHorizontalIcon");
var _unfoldMoreHorizontalIconDefault = parcelHelpers.interopDefault(_unfoldMoreHorizontalIcon);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChromeFields = function(_React$Component) {
    _inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        _classCallCheck(this, ChromeFields);
        var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === 'hex') _this.setState({
                view: 'rgb'
            });
            else if (_this.state.view === 'rgb') _this.setState({
                view: 'hsl'
            });
            else if (_this.state.view === 'hsl') {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: 'hex'
                });
                else _this.setState({
                    view: 'rgb'
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) _color.isValidHex(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: 'hex'
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: 'rgb'
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: 'rgb'
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === 'string' && data.s.includes('%')) data.s = data.s.replace('%', '');
                if (typeof data.l === 'string' && data.l.includes('%')) data.l = data.l.replace('%', '');
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, _isUndefinedDefault.default)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, _isUndefinedDefault.default)(data.l) ? data.l : _this.props.hsl.l),
                    source: 'hsl'
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = '#eee';
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = 'transparent';
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    _createClass(ChromeFields, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        wrap: {
                            paddingTop: '16px',
                            display: 'flex'
                        },
                        fields: {
                            flex: '1',
                            display: 'flex',
                            marginLeft: '-6px'
                        },
                        field: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        alpha: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        toggle: {
                            width: '32px',
                            textAlign: 'right',
                            position: 'relative'
                        },
                        icon: {
                            marginRight: '-4px',
                            marginTop: '12px',
                            cursor: 'pointer',
                            position: 'relative'
                        },
                        iconHighlight: {
                            position: 'absolute',
                            width: '24px',
                            height: '28px',
                            background: '#eee',
                            borderRadius: '4px',
                            top: '10px',
                            left: '12px',
                            display: 'none'
                        },
                        input: {
                            fontSize: '11px',
                            color: '#333',
                            width: '100%',
                            borderRadius: '2px',
                            border: 'none',
                            boxShadow: 'inset 0 0 0 1px #dadada',
                            height: '21px',
                            textAlign: 'center'
                        },
                        label: {
                            textTransform: 'uppercase',
                            fontSize: '11px',
                            lineHeight: '11px',
                            color: '#969696',
                            textAlign: 'center',
                            display: 'block',
                            marginTop: '12px'
                        },
                        svg: {
                            fill: '#333',
                            width: '24px',
                            height: '24px',
                            border: '1px transparent solid',
                            borderRadius: '5px'
                        }
                    },
                    'disableAlpha': {
                        alpha: {
                            display: 'none'
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === 'hex') fields = (0, _reactDefault.default).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'hex',
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'rgb') fields = (0, _reactDefault.default).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'r',
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'g',
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'b',
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'hsl') fields = (0, _reactDefault.default).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'h',
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 's',
                    value: Math.round(this.props.hsl.s * 100) + '%',
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'l',
                    value: Math.round(this.props.hsl.l * 100) + '%',
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.wrap,
                    className: 'flexbox-fix'
                }, fields, (0, _reactDefault.default).createElement('div', {
                    style: styles.toggle
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, _reactDefault.default).createElement((0, _unfoldMoreHorizontalIconDefault.default), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === 'hex') return {
                    view: 'rgb'
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, _reactDefault.default).Component);
ChromeFields.defaultProps = {
    view: "hex"
};
exports.default = ChromeFields;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","lodash-es/isUndefined":"fHZZI","../common":"f3pVr","@icons/material/UnfoldMoreHorizontalIcon":"gPvel","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fHZZI":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isUndefined(value) {
    return value === undefined;
}
exports.default = isUndefined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPvel":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("cab3160a8154bde");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var DEFAULT_SIZE = 24;
exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = _objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return _react2.default.createElement('svg', _extends({
        viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
        style: _extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), _react2.default.createElement('path', {
        d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
    }));
};

},{"cab3160a8154bde":"9njXz"}],"60CH6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromePointer", ()=>ChromePointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var ChromePointer = function ChromePointer() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                transform: 'translate(-6px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = ChromePointer;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ghSy8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromePointerCircle", ()=>ChromePointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var ChromePointerCircle = function ChromePointerCircle() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = ChromePointerCircle;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4fCZ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Compact", ()=>Compact);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var _compactColor = require("./CompactColor");
var _compactColorDefault = parcelHelpers.interopDefault(_compactColor);
var _compactFields = require("./CompactFields");
var _compactFieldsDefault = parcelHelpers.interopDefault(_compactFields);
var Compact = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            Compact: {
                background: '#f6f6f6',
                radius: '4px'
            },
            compact: {
                paddingTop: '5px',
                paddingLeft: '5px',
                boxSizing: 'initial',
                width: '240px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else onChange(data, e);
    };
    return (0, _reactDefault.default).createElement((0, _common.Raised), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.compact,
        className: 'compact-picker ' + className
    }, (0, _reactDefault.default).createElement('div', null, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _compactColorDefault.default), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    })), (0, _reactDefault.default).createElement((0, _compactFieldsDefault.default), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
Compact.propTypes = {
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    styles: (0, _propTypesDefault.default).object
};
Compact.defaultProps = {
    colors: [
        '#4D4D4D',
        '#999999',
        '#FFFFFF',
        '#F44E3B',
        '#FE9200',
        '#FCDC00',
        '#DBDF00',
        '#A4DD00',
        '#68CCCA',
        '#73D8FF',
        '#AEA1FF',
        '#FDA1FF',
        '#333333',
        '#808080',
        '#cccccc',
        '#D33115',
        '#E27300',
        '#FCC400',
        '#B0BC00',
        '#68BC00',
        '#16A5A5',
        '#009CE0',
        '#7B64FF',
        '#FA28FF',
        '#000000',
        '#666666',
        '#B3B3B3',
        '#9F0500',
        '#C45100',
        '#FB9E00',
        '#808900',
        '#194D33',
        '#0C797D',
        '#0062B1',
        '#653294',
        '#AB149E'
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Compact);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/map":"8jKVV","lodash-es/merge":"jQl8F","../../helpers/color":"lNUGR","../common":"f3pVr","./CompactColor":"diC19","./CompactFields":"7Lbwh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"diC19":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactColor", ()=>CompactColor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var CompactColor = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            color: {
                background: color,
                width: '15px',
                height: '15px',
                float: 'left',
                marginRight: '5px',
                marginBottom: '5px',
                position: 'relative',
                cursor: 'pointer'
            },
            dot: {
                absolute: '5px 5px 5px 5px',
                background: _color.getContrastingColor(color),
                borderRadius: '50%',
                opacity: '0'
            }
        },
        'active': {
            dot: {
                opacity: '1'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            dot: {
                background: '#000'
            }
        },
        'transparent': {
            dot: {
                background: '#000'
            }
        }
    }, {
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, _reactDefault.default).createElement((0, _common.Swatch), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.dot
    }));
};
exports.default = CompactColor;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Lbwh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactFields", ()=>CompactFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var CompactFields = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            fields: {
                display: 'flex',
                paddingBottom: '6px',
                paddingRight: '5px',
                position: 'relative'
            },
            active: {
                position: 'absolute',
                top: '6px',
                left: '5px',
                height: '9px',
                width: '9px',
                background: hex
            },
            HEXwrap: {
                flex: '6',
                position: 'relative'
            },
            HEXinput: {
                width: '80%',
                padding: '0px',
                paddingLeft: '20%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            HEXlabel: {
                display: 'none'
            },
            RGBwrap: {
                flex: '3',
                position: 'relative'
            },
            RGBinput: {
                width: '70%',
                padding: '0px',
                paddingLeft: '30%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '3px',
                left: '0px',
                lineHeight: '16px',
                textTransform: 'uppercase',
                fontSize: '12px',
                color: '#999'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.active
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }));
};
exports.default = CompactFields;

},{"react":"9njXz","reactcss":"7O6YP","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5a9tU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Github", ()=>Github);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _githubSwatch = require("./GithubSwatch");
var _githubSwatchDefault = parcelHelpers.interopDefault(_githubSwatch);
var Github = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '1px solid rgba(0,0,0,0.2)',
                boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                borderRadius: '4px',
                position: 'relative',
                padding: '5px',
                display: 'flex',
                flexWrap: 'wrap'
            },
            triangle: {
                position: 'absolute',
                border: '7px solid transparent',
                borderBottomColor: '#fff'
            },
            triangleShadow: {
                position: 'absolute',
                border: '8px solid transparent',
                borderBottomColor: 'rgba(0,0,0,0.15)'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-14px',
                left: '10px'
            },
            triangleShadow: {
                top: '-16px',
                left: '9px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-14px',
                right: '10px'
            },
            triangleShadow: {
                top: '-16px',
                right: '9px'
            }
        },
        'bottom-left-triangle': {
            triangle: {
                top: '35px',
                left: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                left: '9px',
                transform: 'rotate(180deg)'
            }
        },
        'bottom-right-triangle': {
            triangle: {
                top: '35px',
                right: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                right: '9px',
                transform: 'rotate(180deg)'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right',
        'bottom-left-triangle': triangle === 'bottom-left',
        'bottom-right-triangle': triangle === 'bottom-right'
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'github-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.triangleShadow
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.triangle
    }), (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _githubSwatchDefault.default), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
Github.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    triangle: (0, _propTypesDefault.default).oneOf([
        'hide',
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right'
    ]),
    styles: (0, _propTypesDefault.default).object
};
Github.defaultProps = {
    width: 200,
    colors: [
        '#B80000',
        '#DB3E00',
        '#FCCB00',
        '#008B02',
        '#006B76',
        '#1273DE',
        '#004DCF',
        '#5300EB',
        '#EB9694',
        '#FAD0C3',
        '#FEF3BD',
        '#C1E1C5',
        '#BEDADC',
        '#C4DEF6',
        '#BED3F3',
        '#D4C4FB'
    ],
    triangle: 'top-left',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Github);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/map":"8jKVV","lodash-es/merge":"jQl8F","../common":"f3pVr","./GithubSwatch":"Ge9C9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Ge9C9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GithubSwatch", ()=>GithubSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var GithubSwatch = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: 'relative',
        zIndex: '2',
        outline: '2px solid #fff',
        boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
    };
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatch: {
                width: '25px',
                height: '25px',
                fontSize: '0'
            }
        },
        'hover': {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _common.Swatch), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
exports.default = (0, _reactcss.handleHover)(GithubSwatch);

},{"react":"9njXz","reactcss":"7O6YP","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRmaX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HuePicker", ()=>HuePicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _huePointer = require("./HuePointer");
var _huePointerDefault = parcelHelpers.interopDefault(_huePointer);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var HuePicker = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'hue-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.Hue), _extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
HuePicker.propTypes = {
    styles: (0, _propTypesDefault.default).object
};
HuePicker.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, _huePointerDefault.default),
    styles: {}
};
exports.default = (0, _common.ColorWrap)(HuePicker);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./HuePointer":"kIjBW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kIjBW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderPointer", ()=>SliderPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderPointer = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = SliderPointer;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jlcVF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Material", ()=>Material);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var Material = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            material: {
                width: '98px',
                height: '98px',
                padding: '16px',
                fontFamily: 'Roboto'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '2px solid ' + hex,
                outline: 'none',
                height: '30px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '1px solid #eee',
                outline: 'none',
                height: '30px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            split: {
                display: 'flex',
                marginRight: '-10px',
                paddingTop: '11px'
            },
            third: {
                flex: '1',
                paddingRight: '10px'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
    };
    return (0, _reactDefault.default).createElement((0, _common.Raised), {
        styles: passedStyles
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.material,
        className: 'material-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.split,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    })))));
};
exports.default = (0, _common.ColorWrap)(Material);

},{"react":"9njXz","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grH58":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Photoshop", ()=>Photoshop);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _photoshopFields = require("./PhotoshopFields");
var _photoshopFieldsDefault = parcelHelpers.interopDefault(_photoshopFields);
var _photoshopPointerCircle = require("./PhotoshopPointerCircle");
var _photoshopPointerCircleDefault = parcelHelpers.interopDefault(_photoshopPointerCircle);
var _photoshopPointer = require("./PhotoshopPointer");
var _photoshopPointerDefault = parcelHelpers.interopDefault(_photoshopPointer);
var _photoshopButton = require("./PhotoshopButton");
var _photoshopButtonDefault = parcelHelpers.interopDefault(_photoshopButton);
var _photoshopPreviews = require("./PhotoshopPreviews");
var _photoshopPreviewsDefault = parcelHelpers.interopDefault(_photoshopPreviews);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Photoshop = function(_React$Component) {
    _inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        _classCallCheck(this, Photoshop);
        var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    _createClass(Photoshop, [
        {
            key: 'render',
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? '' : _props$className;
                var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
                    'default': {
                        picker: {
                            background: '#DCDCDC',
                            borderRadius: '4px',
                            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
                            boxSizing: 'initial',
                            width: '513px'
                        },
                        head: {
                            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
                            borderBottom: '1px solid #B1B1B1',
                            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
                            height: '23px',
                            lineHeight: '24px',
                            borderRadius: '4px 4px 0 0',
                            fontSize: '13px',
                            color: '#4D4D4D',
                            textAlign: 'center'
                        },
                        body: {
                            padding: '15px 15px 0',
                            display: 'flex'
                        },
                        saturation: {
                            width: '256px',
                            height: '256px',
                            position: 'relative',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0',
                            overflow: 'hidden'
                        },
                        hue: {
                            position: 'relative',
                            height: '256px',
                            width: '19px',
                            marginLeft: '10px',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0'
                        },
                        controls: {
                            width: '180px',
                            marginLeft: '10px'
                        },
                        top: {
                            display: 'flex'
                        },
                        previews: {
                            width: '60px'
                        },
                        actions: {
                            flex: '1',
                            marginLeft: '20px'
                        }
                    }
                }, passedStyles));
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.picker,
                    className: 'photoshop-picker ' + className
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.head
                }, this.props.header), (0, _reactDefault.default).createElement('div', {
                    style: styles.body,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.saturation
                }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, _photoshopPointerCircleDefault.default),
                    onChange: this.props.onChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.hue
                }, (0, _reactDefault.default).createElement((0, _common.Hue), {
                    direction: 'vertical',
                    hsl: this.props.hsl,
                    pointer: (0, _photoshopPointerDefault.default),
                    onChange: this.props.onChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.controls
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.top,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.previews
                }, (0, _reactDefault.default).createElement((0, _photoshopPreviewsDefault.default), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.actions
                }, (0, _reactDefault.default).createElement((0, _photoshopButtonDefault.default), {
                    label: 'OK',
                    onClick: this.props.onAccept,
                    active: true
                }), (0, _reactDefault.default).createElement((0, _photoshopButtonDefault.default), {
                    label: 'Cancel',
                    onClick: this.props.onCancel
                }), (0, _reactDefault.default).createElement((0, _photoshopFieldsDefault.default), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, _reactDefault.default).Component);
Photoshop.propTypes = {
    header: (0, _propTypesDefault.default).string,
    styles: (0, _propTypesDefault.default).object
};
Photoshop.defaultProps = {
    header: 'Color Picker',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Photoshop);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./PhotoshopFields":"ehPj5","./PhotoshopPointerCircle":"dbUrt","./PhotoshopPointer":"hjrq1","./PhotoshopButton":"hHf6K","./PhotoshopPreviews":"e6EKG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ehPj5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPicker", ()=>PhotoshopPicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var PhotoshopPicker = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            fields: {
                paddingTop: '5px',
                paddingBottom: '9px',
                width: '80px',
                position: 'relative'
            },
            divider: {
                height: '5px'
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                marginLeft: '40%',
                width: '40%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '5px',
                fontSize: '13px',
                paddingLeft: '3px',
                marginRight: '10px'
            },
            RGBlabel: {
                left: '0px',
                top: '0px',
                width: '34px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px',
                position: 'absolute'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                marginLeft: '20%',
                width: '80%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '6px',
                fontSize: '13px',
                paddingLeft: '3px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '14px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px'
            },
            fieldSymbols: {
                position: 'absolute',
                top: '5px',
                right: '-7px',
                fontSize: '13px'
            },
            symbol: {
                height: '20px',
                lineHeight: '22px',
                paddingBottom: '7px'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data['#']) _color.isValidHex(data['#']) && onChange({
            hex: data['#'],
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: 'hsv'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.fields
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'h',
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 's',
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'v',
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.divider
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.divider
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: '#',
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.fieldSymbols
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.symbol
    }, '\xB0'), (0, _reactDefault.default).createElement('div', {
        style: styles.symbol
    }, '%'), (0, _reactDefault.default).createElement('div', {
        style: styles.symbol
    }, '%')));
};
exports.default = PhotoshopPicker;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dbUrt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPointerCircle", ()=>PhotoshopPointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        },
        'black-outline': {
            picker: {
                boxShadow: 'inset 0 0 0 1px #000'
            }
        }
    }, {
        'black-outline': hsl.l > 0.5
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = PhotoshopPointerCircle;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hjrq1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPointerCircle", ()=>PhotoshopPointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPointerCircle = function PhotoshopPointerCircle() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '4px 0 4px 6px',
                borderColor: 'transparent transparent transparent #fff',
                position: 'absolute',
                top: '1px',
                left: '1px'
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '5px 0 5px 8px',
                borderColor: 'transparent transparent transparent #555'
            },
            left: {
                Extend: 'triangleBorder',
                transform: 'translate(-13px, -4px)'
            },
            leftInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            },
            right: {
                Extend: 'triangleBorder',
                transform: 'translate(20px, -14px) rotate(180deg)'
            },
            rightInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.pointer
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.left
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.leftInside
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.right
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.rightInside
    })));
};
exports.default = PhotoshopPointerCircle;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hHf6K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopButton", ()=>PhotoshopButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopButton = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            button: {
                backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
                border: '1px solid #878787',
                borderRadius: '2px',
                height: '20px',
                boxShadow: '0 1px 0 0 #EAEAEA',
                fontSize: '14px',
                color: '#000',
                lineHeight: '20px',
                textAlign: 'center',
                marginBottom: '10px',
                cursor: 'pointer'
            }
        },
        'active': {
            button: {
                boxShadow: '0 0 0 1px #878787'
            }
        }
    }, {
        active: active
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
exports.default = PhotoshopButton;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e6EKG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPreviews", ()=>PhotoshopPreviews);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPreviews = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatches: {
                border: '1px solid #B3B3B3',
                borderBottom: '1px solid #F0F0F0',
                marginBottom: '2px',
                marginTop: '1px'
            },
            new: {
                height: '34px',
                background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
            },
            current: {
                height: '34px',
                background: currentColor,
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
            },
            label: {
                fontSize: '14px',
                color: '#000',
                textAlign: 'center'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', null, (0, _reactDefault.default).createElement('div', {
        style: styles.label
    }, 'new'), (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.new
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.current
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.label
    }, 'current'));
};
exports.default = PhotoshopPreviews;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"761c2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sketch", ()=>Sketch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _sketchFields = require("./SketchFields");
var _sketchFieldsDefault = parcelHelpers.interopDefault(_sketchFields);
var _sketchPresetColors = require("./SketchPresetColors");
var _sketchPresetColorsDefault = parcelHelpers.interopDefault(_sketchPresetColors);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var Sketch = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': _extends({
            picker: {
                width: width,
                padding: '10px 10px 0',
                boxSizing: 'initial',
                background: '#fff',
                borderRadius: '4px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
            },
            saturation: {
                width: '100%',
                paddingBottom: '75%',
                position: 'relative',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '3px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            controls: {
                display: 'flex'
            },
            sliders: {
                padding: '4px 0',
                flex: '1'
            },
            color: {
                width: '24px',
                height: '24px',
                position: 'relative',
                marginTop: '4px',
                marginLeft: '4px',
                borderRadius: '3px'
            },
            activeColor: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '2px',
                background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            hue: {
                position: 'relative',
                height: '10px',
                overflow: 'hidden'
            },
            Hue: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            alpha: {
                position: 'relative',
                height: '10px',
                marginTop: '4px',
                overflow: 'hidden'
            },
            Alpha: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            }
        }, passedStyles),
        'disableAlpha': {
            color: {
                height: '10px'
            },
            hue: {
                height: '10px'
            },
            alpha: {
                display: 'none'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'sketch-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.sliders
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, _reactDefault.default).createElement('div', {
        style: styles.color
    }, (0, _reactDefault.default).createElement((0, _common.Checkboard), null), (0, _reactDefault.default).createElement('div', {
        style: styles.activeColor
    }))), (0, _reactDefault.default).createElement((0, _sketchFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, _reactDefault.default).createElement((0, _sketchPresetColorsDefault.default), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
Sketch.propTypes = {
    disableAlpha: (0, _propTypesDefault.default).bool,
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    styles: (0, _propTypesDefault.default).object
};
Sketch.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        '#D0021B',
        '#F5A623',
        '#F8E71C',
        '#8B572A',
        '#7ED321',
        '#417505',
        '#BD10E0',
        '#9013FE',
        '#4A90E2',
        '#50E3C2',
        '#B8E986',
        '#000000',
        '#4A4A4A',
        '#9B9B9B',
        '#FFFFFF'
    ]
};
exports.default = (0, _common.ColorWrap)(Sketch);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./SketchFields":"d9y7k","./SketchPresetColors":"d3ITg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9y7k":[function(require,module,exports,__globalThis) {
/* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SketchFields", ()=>SketchFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var SketchFields = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            fields: {
                display: 'flex',
                paddingTop: '4px'
            },
            single: {
                flex: '1',
                paddingLeft: '6px'
            },
            alpha: {
                flex: '1',
                paddingLeft: '6px'
            },
            double: {
                flex: '2'
            },
            input: {
                width: '80%',
                padding: '4px 10% 3px',
                border: 'none',
                boxShadow: 'inset 0 0 0 1px #ccc',
                fontSize: '11px'
            },
            label: {
                display: 'block',
                textAlign: 'center',
                fontSize: '11px',
                color: '#222',
                paddingTop: '3px',
                paddingBottom: '4px',
                textTransform: 'capitalize'
            }
        },
        'disableAlpha': {
            alpha: {
                display: 'none'
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: 'rgb'
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: 'rgb'
            }, e);
        }
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.double
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
    })));
};
exports.default = SketchFields;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d3ITg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SketchPresetColors", ()=>SketchPresetColors);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var SketchPresetColors = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            colors: {
                margin: '0 -10px',
                padding: '10px 0 0 10px',
                borderTop: '1px solid #eee',
                display: 'flex',
                flexWrap: 'wrap',
                position: 'relative'
            },
            swatchWrap: {
                width: '16px',
                height: '16px',
                margin: '0 10px 10px 0'
            },
            swatch: {
                borderRadius: '3px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
            }
        },
        'no-presets': {
            colors: {
                display: 'none'
            }
        }
    }, {
        'no-presets': !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.colors,
        className: 'flexbox-fix'
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === 'string' ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = '' + c.color + (c.title || '');
        return (0, _reactDefault.default).createElement('div', {
            key: key,
            style: styles.swatchWrap
        }, (0, _reactDefault.default).createElement((0, _common.Swatch), _extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
            }
        })));
    }));
};
SketchPresetColors.propTypes = {
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).shape({
            color: (0, _propTypesDefault.default).string,
            title: (0, _propTypesDefault.default).string
        })
    ])).isRequired
};
exports.default = SketchPresetColors;

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"LOOqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slider", ()=>Slider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _sliderSwatches = require("./SliderSwatches");
var _sliderSwatchesDefault = parcelHelpers.interopDefault(_sliderSwatches);
var _sliderPointer = require("./SliderPointer");
var _sliderPointerDefault = parcelHelpers.interopDefault(_sliderPointer);
var Slider = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            hue: {
                height: '12px',
                position: 'relative'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, _reactDefault.default).createElement('div', {
        style: styles.wrap || {},
        className: 'slider-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchesDefault.default), {
        hsl: hsl,
        onClick: onChange
    })));
};
Slider.propTypes = {
    styles: (0, _propTypesDefault.default).object
};
Slider.defaultProps = {
    pointer: (0, _sliderPointerDefault.default),
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Slider);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./SliderSwatches":"676z7","./SliderPointer":"JmgA6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"676z7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderSwatches", ()=>SliderSwatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _sliderSwatch = require("./SliderSwatch");
var _sliderSwatchDefault = parcelHelpers.interopDefault(_sliderSwatch);
var SliderSwatches = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatches: {
                marginTop: '20px'
            },
            swatch: {
                boxSizing: 'border-box',
                width: '20%',
                paddingRight: '1px',
                float: 'left'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    }));
};
exports.default = SliderSwatches;

},{"react":"9njXz","reactcss":"7O6YP","./SliderSwatch":"9gr7X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9gr7X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderSwatch", ()=>SliderSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderSwatch = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatch: {
                height: '12px',
                background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
                cursor: 'pointer'
            }
        },
        'first': {
            swatch: {
                borderRadius: '2px 0 0 2px'
            }
        },
        'last': {
            swatch: {
                borderRadius: '0 2px 2px 0'
            }
        },
        'active': {
            swatch: {
                transform: 'scaleY(1.8)',
                borderRadius: '3.6px/2px'
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: 'hsl'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatch,
        onClick: handleClick
    });
};
exports.default = SliderSwatch;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"JmgA6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderPointer", ()=>SliderPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderPointer = function SliderPointer() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '14px',
                height: '14px',
                borderRadius: '6px',
                transform: 'translate(-7px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = SliderPointer;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"in5kC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swatches", ()=>Swatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _materialColors = require("material-colors");
var _common = require("../common");
var _swatchesGroup = require("./SwatchesGroup");
var _swatchesGroupDefault = parcelHelpers.interopDefault(_swatchesGroup);
var Swatches = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: 'scroll'
            },
            body: {
                padding: '16px 0 6px 16px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'swatches-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.Raised), null, (0, _reactDefault.default).createElement('div', {
        style: styles.overflow
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _mapDefault.default)(colors, function(group) {
        return (0, _reactDefault.default).createElement((0, _swatchesGroupDefault.default), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    })))));
};
Swatches.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    height: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)),
    styles: (0, _propTypesDefault.default).object
};
Swatches.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            _materialColors.red['900'],
            _materialColors.red['700'],
            _materialColors.red['500'],
            _materialColors.red['300'],
            _materialColors.red['100']
        ],
        [
            _materialColors.pink['900'],
            _materialColors.pink['700'],
            _materialColors.pink['500'],
            _materialColors.pink['300'],
            _materialColors.pink['100']
        ],
        [
            _materialColors.purple['900'],
            _materialColors.purple['700'],
            _materialColors.purple['500'],
            _materialColors.purple['300'],
            _materialColors.purple['100']
        ],
        [
            _materialColors.deepPurple['900'],
            _materialColors.deepPurple['700'],
            _materialColors.deepPurple['500'],
            _materialColors.deepPurple['300'],
            _materialColors.deepPurple['100']
        ],
        [
            _materialColors.indigo['900'],
            _materialColors.indigo['700'],
            _materialColors.indigo['500'],
            _materialColors.indigo['300'],
            _materialColors.indigo['100']
        ],
        [
            _materialColors.blue['900'],
            _materialColors.blue['700'],
            _materialColors.blue['500'],
            _materialColors.blue['300'],
            _materialColors.blue['100']
        ],
        [
            _materialColors.lightBlue['900'],
            _materialColors.lightBlue['700'],
            _materialColors.lightBlue['500'],
            _materialColors.lightBlue['300'],
            _materialColors.lightBlue['100']
        ],
        [
            _materialColors.cyan['900'],
            _materialColors.cyan['700'],
            _materialColors.cyan['500'],
            _materialColors.cyan['300'],
            _materialColors.cyan['100']
        ],
        [
            _materialColors.teal['900'],
            _materialColors.teal['700'],
            _materialColors.teal['500'],
            _materialColors.teal['300'],
            _materialColors.teal['100']
        ],
        [
            '#194D33',
            _materialColors.green['700'],
            _materialColors.green['500'],
            _materialColors.green['300'],
            _materialColors.green['100']
        ],
        [
            _materialColors.lightGreen['900'],
            _materialColors.lightGreen['700'],
            _materialColors.lightGreen['500'],
            _materialColors.lightGreen['300'],
            _materialColors.lightGreen['100']
        ],
        [
            _materialColors.lime['900'],
            _materialColors.lime['700'],
            _materialColors.lime['500'],
            _materialColors.lime['300'],
            _materialColors.lime['100']
        ],
        [
            _materialColors.yellow['900'],
            _materialColors.yellow['700'],
            _materialColors.yellow['500'],
            _materialColors.yellow['300'],
            _materialColors.yellow['100']
        ],
        [
            _materialColors.amber['900'],
            _materialColors.amber['700'],
            _materialColors.amber['500'],
            _materialColors.amber['300'],
            _materialColors.amber['100']
        ],
        [
            _materialColors.orange['900'],
            _materialColors.orange['700'],
            _materialColors.orange['500'],
            _materialColors.orange['300'],
            _materialColors.orange['100']
        ],
        [
            _materialColors.deepOrange['900'],
            _materialColors.deepOrange['700'],
            _materialColors.deepOrange['500'],
            _materialColors.deepOrange['300'],
            _materialColors.deepOrange['100']
        ],
        [
            _materialColors.brown['900'],
            _materialColors.brown['700'],
            _materialColors.brown['500'],
            _materialColors.brown['300'],
            _materialColors.brown['100']
        ],
        [
            _materialColors.blueGrey['900'],
            _materialColors.blueGrey['700'],
            _materialColors.blueGrey['500'],
            _materialColors.blueGrey['300'],
            _materialColors.blueGrey['100']
        ],
        [
            '#000000',
            '#525252',
            '#969696',
            '#D9D9D9',
            '#FFFFFF'
        ]
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Swatches);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/map":"8jKVV","lodash-es/merge":"jQl8F","material-colors":"5pcDo","../common":"f3pVr","./SwatchesGroup":"cCLCe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cCLCe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwatchesGroup", ()=>SwatchesGroup);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _swatchesColor = require("./SwatchesColor");
var _swatchesColorDefault = parcelHelpers.interopDefault(_swatchesColor);
var SwatchesGroup = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            group: {
                paddingBottom: '10px',
                width: '40px',
                float: 'left',
                marginRight: '10px'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.group
    }, (0, _mapDefault.default)(group, function(color, i) {
        return (0, _reactDefault.default).createElement((0, _swatchesColorDefault.default), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
exports.default = SwatchesGroup;

},{"react":"9njXz","reactcss":"7O6YP","lodash-es/map":"8jKVV","./SwatchesColor":"cJdP3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cJdP3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwatchesColor", ()=>SwatchesColor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var _checkIcon = require("@icons/material/CheckIcon");
var _checkIconDefault = parcelHelpers.interopDefault(_checkIcon);
var SwatchesColor = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            color: {
                width: '40px',
                height: '24px',
                cursor: 'pointer',
                background: color,
                marginBottom: '1px'
            },
            check: {
                color: _color.getContrastingColor(color),
                marginLeft: '8px',
                display: 'none'
            }
        },
        'first': {
            color: {
                overflow: 'hidden',
                borderRadius: '2px 2px 0 0'
            }
        },
        'last': {
            color: {
                overflow: 'hidden',
                borderRadius: '0 0 2px 2px'
            }
        },
        'active': {
            check: {
                display: 'block'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            check: {
                color: '#333'
            }
        },
        'transparent': {
            check: {
                color: '#333'
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, _reactDefault.default).createElement((0, _common.Swatch), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.check
    }, (0, _reactDefault.default).createElement((0, _checkIconDefault.default), null)));
};
exports.default = SwatchesColor;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","../common":"f3pVr","@icons/material/CheckIcon":"26Pe1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"26Pe1":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("b7292f2d749daff7");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var DEFAULT_SIZE = 24;
exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = _objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return _react2.default.createElement('svg', _extends({
        viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
        style: _extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), _react2.default.createElement('path', {
        d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
    }));
};

},{"b7292f2d749daff7":"9njXz"}],"lypvp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Twitter", ()=>Twitter);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var Twitter = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '0 solid rgba(0,0,0,0.25)',
                boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
                borderRadius: '4px',
                position: 'relative'
            },
            body: {
                padding: '15px 9px 9px 15px'
            },
            label: {
                fontSize: '18px',
                color: '#fff'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent #fff transparent',
                position: 'absolute'
            },
            triangleShadow: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
                position: 'absolute'
            },
            hash: {
                background: '#F0F0F0',
                height: '30px',
                width: '30px',
                borderRadius: '4px 0 0 4px',
                float: 'left',
                color: '#98A1A4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            input: {
                width: '100px',
                fontSize: '14px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '28px',
                boxShadow: 'inset 0 0 0 1px #F0F0F0',
                boxSizing: 'content-box',
                borderRadius: '0 4px 4px 0',
                float: 'left',
                paddingLeft: '8px'
            },
            swatch: {
                width: '30px',
                height: '30px',
                float: 'left',
                borderRadius: '4px',
                margin: '0 6px 6px 0'
            },
            clear: {
                clear: 'both'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-10px',
                left: '12px'
            },
            triangleShadow: {
                top: '-11px',
                left: '12px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-10px',
                right: '12px'
            },
            triangleShadow: {
                top: '-11px',
                right: '12px'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right'
    });
    var handleChange = function handleChange(hexcode, e) {
        _color.isValidHex(hexcode) && onChange({
            hex: hexcode,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'twitter-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.triangleShadow
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.triangle
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _mapDefault.default)(colors, function(c, i) {
        return (0, _reactDefault.default).createElement((0, _common.Swatch), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.hash
    }, '#'), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    })));
};
Twitter.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    triangle: (0, _propTypesDefault.default).oneOf([
        'hide',
        'top-left',
        'top-right'
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    styles: (0, _propTypesDefault.default).object
};
Twitter.defaultProps = {
    width: 276,
    colors: [
        '#FF6900',
        '#FCB900',
        '#7BDCB5',
        '#00D084',
        '#8ED1FC',
        '#0693E3',
        '#ABB8C3',
        '#EB144C',
        '#F78DA7',
        '#9900EF'
    ],
    triangle: 'top-left',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Twitter);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/map":"8jKVV","lodash-es/merge":"jQl8F","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bK2GH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Google", ()=>Google);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _googlePointerCircle = require("./GooglePointerCircle");
var _googlePointerCircleDefault = parcelHelpers.interopDefault(_googlePointerCircle);
var _googlePointer = require("./GooglePointer");
var _googlePointerDefault = parcelHelpers.interopDefault(_googlePointer);
var _googleFields = require("./GoogleFields");
var _googleFieldsDefault = parcelHelpers.interopDefault(_googleFields);
var Google = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                border: '1px solid #dfe1e5',
                boxSizing: 'initial',
                display: 'flex',
                flexWrap: 'wrap',
                borderRadius: '8px 8px 0px 0px'
            },
            head: {
                height: '57px',
                width: '100%',
                paddingTop: '16px',
                paddingBottom: '16px',
                paddingLeft: '16px',
                fontSize: '20px',
                boxSizing: 'border-box',
                fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
            },
            saturation: {
                width: '70%',
                padding: '0px',
                position: 'relative',
                overflow: 'hidden'
            },
            swatch: {
                width: '30%',
                height: '228px',
                padding: '0px',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
                position: 'relative',
                overflow: 'hidden'
            },
            body: {
                margin: 'auto',
                width: '95%'
            },
            controls: {
                display: 'flex',
                boxSizing: 'border-box',
                height: '52px',
                paddingTop: '22px'
            },
            color: {
                width: '32px'
            },
            hue: {
                height: '8px',
                position: 'relative',
                margin: '0px 16px 0px 16px',
                width: '100%'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'google-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.head
    }, header), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, _googlePointerCircleDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        radius: '4px',
        pointer: (0, _googlePointerDefault.default),
        onChange: onChange
    }))), (0, _reactDefault.default).createElement((0, _googleFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
Google.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    styles: (0, _propTypesDefault.default).object,
    header: (0, _propTypesDefault.default).string
};
Google.defaultProps = {
    width: 652,
    styles: {},
    header: 'Color picker'
};
exports.default = (0, _common.ColorWrap)(Google);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./GooglePointerCircle":"d9qLv","./GooglePointer":"9U4G4","./GoogleFields":"i3CDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9qLv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GooglePointerCircle", ()=>GooglePointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var GooglePointerCircle = function GooglePointerCircle(props) {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                border: '2px #fff solid',
                transform: 'translate(-12px, -13px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
GooglePointerCircle.propTypes = {
    hsl: (0, _propTypesDefault.default).shape({
        h: (0, _propTypesDefault.default).number,
        s: (0, _propTypesDefault.default).number,
        l: (0, _propTypesDefault.default).number,
        a: (0, _propTypesDefault.default).number
    })
};
GooglePointerCircle.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
exports.default = GooglePointerCircle;

},{"react":"9njXz","reactcss":"7O6YP","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9U4G4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GooglePointer", ()=>GooglePointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var GooglePointer = function GooglePointer(props) {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                transform: 'translate(-10px, -7px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
                border: '2px white solid'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
GooglePointer.propTypes = {
    hsl: (0, _propTypesDefault.default).shape({
        h: (0, _propTypesDefault.default).number,
        s: (0, _propTypesDefault.default).number,
        l: (0, _propTypesDefault.default).number,
        a: (0, _propTypesDefault.default).number
    })
};
GooglePointer.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
exports.default = GooglePointer;

},{"react":"9njXz","reactcss":"7O6YP","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i3CDE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleFields", ()=>GoogleFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var GoogleFields = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(',');
            _color.isvalidColorString(data.rgb, 'rgb') && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: 'rgb'
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(',');
            if (_color.isvalidColorString(data.hsv, 'hsv')) {
                _values[2] = _values[2].replace('%', '');
                _values[1] = _values[1].replace('%', '');
                _values[0] = _values[0].replace("\xb0", '');
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: 'hsv'
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(',');
            if (_color.isvalidColorString(data.hsl, 'hsl')) {
                _values2[2] = _values2[2].replace('%', '');
                _values2[1] = _values2[1].replace('%', '');
                _values2[0] = _values2[0].replace("\xb0", '');
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: 'hsl'
                }, e);
            }
        }
    };
    var styles = (0, _reactcssDefault.default)({
        'default': {
            wrap: {
                display: 'flex',
                height: '100px',
                marginTop: '4px'
            },
            fields: {
                width: '100%'
            },
            column: {
                paddingTop: '10px',
                display: 'flex',
                justifyContent: 'space-between'
            },
            double: {
                padding: '0px 4.4px',
                boxSizing: 'border-box'
            },
            input: {
                width: '100%',
                height: '38px',
                boxSizing: 'border-box',
                padding: '4px 10% 3px',
                textAlign: 'center',
                border: '1px solid #dadce0',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            input2: {
                height: '38px',
                width: '100%',
                border: '1px solid #dadce0',
                boxSizing: 'border-box',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                paddingLeft: '10px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label: {
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '35px',
                top: '-6px',
                left: '0',
                right: '0',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label2: {
                left: '10px',
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '32px',
                top: '-6px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            single: {
                flexGrow: '1',
                margin: '0px 4.4px'
            }
        }
    });
    var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
    var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
    var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
    return (0, _reactDefault.default).createElement('div', {
        style: styles.wrap,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.fields
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.double
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.column
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'rgb',
        value: rgbValue,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsv',
        value: hsvValue,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsl',
        value: hslValue,
        onChange: handleChange
    })))));
};
exports.default = GoogleFields;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6rYmF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _settingsSlice = require("../../slices/SettingsSlice");
var _settings = require("../../api/Settings");
var _localStorageHelper = require("../../helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
var _resultComponents = require("../code_tables/ResultComponents");
var _editSettingsItemDialog = require("./EditSettingsItemDialog");
var _editSettingsItemDialogDefault = parcelHelpers.interopDefault(_editSettingsItemDialog);
var _editSettingsItemFileDialog = require("./EditSettingsItemFileDialog");
var _editSettingsItemFileDialogDefault = parcelHelpers.interopDefault(_editSettingsItemFileDialog);
var _editSettingsItemSwitchDialog = require("./EditSettingsItemSwitchDialog");
var _editSettingsItemSwitchDialogDefault = parcelHelpers.interopDefault(_editSettingsItemSwitchDialog);
var _editSettingsItemDropdownDialog = require("./EditSettingsItemDropdownDialog");
var _editSettingsItemDropdownDialogDefault = parcelHelpers.interopDefault(_editSettingsItemDropdownDialog);
var _editSettingsItemMultilineDialog = require("./EditSettingsItemMultilineDialog");
var _editSettingsItemMultilineDialogDefault = parcelHelpers.interopDefault(_editSettingsItemMultilineDialog);
var _editSettingsItemPrinterWidthDialog = require("./EditSettingsItemPrinterWidthDialog");
var _editSettingsItemPrinterWidthDialogDefault = parcelHelpers.interopDefault(_editSettingsItemPrinterWidthDialog);
const AutoPrintTypes = {
    'none': 'Ne tiskaj',
    'a4': 'A4',
    'pos': 'POS'
};
function Results(props) {
    const { item, openEditSettingsItemDialog, subject_types } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table mt-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: "Tiskanje"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Nastavitev"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 3,
                        title: "Vrednost"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-table",
                children: [
                    {
                        key: 'pos_printer_name',
                        title: 'POS tiskalnik',
                        value: (0, _localStorageHelperDefault.default).GetValue(props.client + '__pos_printer_name')
                    },
                    {
                        key: 'pos_printer_width',
                        title: "\u0160irina tiskanja POS (\u0161t. znakov)",
                        value: (0, _localStorageHelperDefault.default).GetValue(props.client + '__pos_printer_width')
                    },
                    {
                        key: 'logo_pos',
                        title: 'POS logo',
                        value: item['logo_pos']
                    },
                    {
                        key: 'auto_print_type',
                        title: 'Privzeto tiskaj na',
                        value: AutoPrintTypes[item['auto_print_type']]
                    },
                    {
                        key: 'label_printer_name',
                        title: 'Tiskalnik nalepk',
                        value: (0, _localStorageHelperDefault.default).GetValue(props.client + '__label_printer_name')
                    },
                    {
                        key: 'label_printer_item_template',
                        title: 'Predloga za nalepke artiklov',
                        value: item['label_printer_item_template']
                    },
                    {
                        key: 'label_printer_person_template',
                        title: 'Predloga za nalepke oseb',
                        value: item['label_printer_person_template']
                    },
                    {
                        key: 'print_footer_a4',
                        title: 'Natisni nogo na A4',
                        value: item['print_footer_a4']
                    }
                ].map((property)=>{
                    let key = property.key;
                    let value = property.value;
                    let type = 'general';
                    if (property.key == 'pos_printer_name' || property.key == 'auto_print_type' || property.key == 'label_printer_name') type = 'dropdown';
                    else if (property.key == 'logo_pos') {
                        value = value === null || value === undefined || value.length < 60 ? value : value.substring(0, 20) + '...' + value.substring(value.length - 20);
                        type = 'file';
                    } else if (property.key == 'label_printer_item_template' || property.key == 'label_printer_person_template') {
                        value = value === null || value === undefined || value.length < 10 ? 'ni nastavljeno' : 'nastavljeno';
                        type = 'file';
                    } else if (property.key == 'print_footer_a4') {
                        value = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                            icon: value ? 'tick' : 'cross'
                        });
                        type = 'bool';
                    }
                    let new_item = {
                        ...item
                    };
                    if (key == 'pos_printer_name') new_item[key] = value;
                    else if (key == 'pos_printer_width') {
                        new_item[key] = value;
                        type = 'printer_width';
                    } else if (key == 'label_printer_name') new_item[key] = value;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "edit",
                                    intent: "primary",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>{
                                        openEditSettingsItemDialog(type, new_item, key);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2,
                                child: property.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: value
                            })
                        ]
                    }, 'settings-result--property-' + key);
                })
            }, 'settings-result-3')
        ]
    });
}
class PrintSettings extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.openEditSettingsItemDialog = this.openEditSettingsItemDialog.bind(this);
        this.closeEditSettingsItemDialog = this.closeEditSettingsItemDialog.bind(this);
        const { item } = this.updateTableItemsFromProps(props);
        this.state = {
            item,
            edit_settings_item_dialog_open: false,
            edit_settings_item_dialog_item: null,
            edit_settings_item_dialog_property_key: null
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.general_settings != this.state.item) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        return {
            item: props.general_settings
        };
    }
    openEditSettingsItemDialog(type, item, property_key) {
        this.setState({
            edit_settings_item_dialog_open: true,
            edit_settings_item_dialog_type: type,
            edit_settings_item_dialog_item: item,
            edit_settings_item_dialog_property_key: property_key
        });
    }
    async closeEditSettingsItemDialog(item, property_key, new_value) {
        this.setState({
            edit_settings_item_dialog_open: false,
            edit_settings_item_dialog_type: null,
            edit_settings_item_dialog_item: null,
            edit_settings_item_dialog_property_key: null
        });
        if (item !== undefined) {
            if (property_key == 'pos_printer_name') (0, _localStorageHelperDefault.default).SetValue(this.props.client + '__pos_printer_name', new_value);
            else if (property_key == 'pos_printer_width') (0, _localStorageHelperDefault.default).SetValue(this.props.client + '__pos_printer_width', new_value);
            else if (property_key == 'label_printer_name') (0, _localStorageHelperDefault.default).SetValue(this.props.client + '__label_printer_name', new_value);
            else {
                let new_item = {
                    ...item
                };
                new_item[property_key] = new_value;
                this.props.dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
                const dispatch = this.props.dispatch;
                const token = this.props.token;
                new_item = await (0, _settings.saveGeneralSettings)(this.props.api_url, new_item, token);
                if (new_item !== null) dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
            }
        }
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('settings--print') === -1) return null;
        const printers = {};
        if (this.props.printers !== undefined) for(let i = 0; i < this.props.printers.length; i++)printers[this.props.printers[i]] = this.props.printers[i];
        printers['HTML'] = 'HTML';
        const label_printers = {};
        if (this.props.label_printers !== undefined) for(let i = 0; i < this.props.label_printers.length; i++)label_printers[this.props.label_printers[i]] = this.props.label_printers[i];
        let edit_settings_dialog = null;
        if (this.state.edit_settings_item_dialog_open) {
            if (this.state.edit_settings_item_dialog_type == 'dropdown') {
                let options = [];
                if (this.state.edit_settings_item_dialog_property_key == 'pos_printer_name') options = printers;
                else if (this.state.edit_settings_item_dialog_property_key == 'label_printer_name') options = label_printers;
                else if (this.state.edit_settings_item_dialog_property_key == 'auto_print_type') options = AutoPrintTypes;
                edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemDropdownDialogDefault.default), {
                    item: this.state.edit_settings_item_dialog_item,
                    property_key: this.state.edit_settings_item_dialog_property_key,
                    closeDialog: this.closeEditSettingsItemDialog,
                    options: options
                });
            } else if (this.state.edit_settings_item_dialog_type == 'file') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemFileDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else if (this.state.edit_settings_item_dialog_type == 'multiline') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemMultilineDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else if (this.state.edit_settings_item_dialog_type == 'bool') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemSwitchDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else if (this.state.edit_settings_item_dialog_type == 'printer_width') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemPrinterWidthDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                closeDialog: this.closeEditSettingsItemDialog
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                edit_settings_dialog,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex flex-col flex-grow general-settings-list",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1 pl-4 pr-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-grow overflow-y-auto",
                            style: {
                                flexBasis: '0'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                item: this.state.item,
                                openEditSettingsItemDialog: this.openEditSettingsItemDialog,
                                client: this.props.client
                            })
                        })
                    })
                })
            ]
        });
    }
}
PrintSettings.propTypes = {};
function mapStateToProps(state) {
    return {
        general_settings: state.SettingsSlice.general,
        api_url: state.SettingsSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        printers: state.AppSlice.printers,
        label_printers: state.AppSlice.label_printers,
        client: state.ConstantsSlice.client
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(PrintSettings);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","../../slices/SettingsSlice":"ajHkF","../../api/Settings":"51MNf","../../helpers/LocalStorageHelper":"9I9tm","../code_tables/ResultComponents":"1eVlZ","./EditSettingsItemDialog":"3zOCG","./EditSettingsItemFileDialog":"bySUH","./EditSettingsItemSwitchDialog":"4SKSx","./EditSettingsItemDropdownDialog":"3XDWw","./EditSettingsItemMultilineDialog":"c8mQ1","./EditSettingsItemPrinterWidthDialog":"2Bi8M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Bi8M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _appSlice = require("../../slices/AppSlice");
class EditSettingsItemPrinterWidthDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            value: props.item[props.property_key]
        };
        console.log({
            ...props,
            value: props.item[props.property_key]
        });
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "edit-settings-item-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Uredi nastavitev"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-1 flex-col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                labelFor: "edit-settings-item-dialog--value",
                                className: "flex-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                    id: "edit-settings-item-dialog--value",
                                    value: this.state.value,
                                    onChange: (event)=>{
                                        this.setState({
                                            value: event.target.value
                                        });
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    onClick: ()=>{
                                        this.props.dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                                            type: 'invoice',
                                            invoice: {
                                                type: 'test-width',
                                                width: parseInt(this.state.value, 10)
                                            }
                                        }));
                                    },
                                    children: "Natisni test \u0161irine"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog(this.props.item, this.props.property_key, this.state.value);
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
EditSettingsItemPrinterWidthDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
function mapStateToProps(state) {
    return {};
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(EditSettingsItemPrinterWidthDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","../../slices/AppSlice":"aByTQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dSAhz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _deepEqual = require("deep-equal");
var _deepEqualDefault = parcelHelpers.interopDefault(_deepEqual);
var _documentSlice = require("../../slices/DocumentSlice");
var _documents = require("../../api/Documents");
var _localStorageHelper = require("../../helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
var _resultComponents = require("../code_tables/ResultComponents");
var _editSettingsItemDocumentDialog = require("./EditSettingsItemDocumentDialog");
var _editSettingsItemDocumentDialogDefault = parcelHelpers.interopDefault(_editSettingsItemDocumentDialog);
function Results(props) {
    const { item, openEditSettingsItemDialog, document_types } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results documents mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table mt-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: "Dokumenti"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Nastavitev"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 3,
                        title: "SL"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 4,
                        title: "EN"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 5,
                        title: "DE"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 6,
                        title: "POS"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 7,
                        title: "Izpi\u0161i QR Skeniraj & Pla\u010Daj"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-table",
                children: [
                    {
                        key: 'cash-invoice',
                        title: "Blagajni\u0161ki ra\u010Dun",
                        display_pos_field: true
                    },
                    {
                        key: 'cash-prepayment-invoice',
                        title: "Ra\u010Dun za predpla\u010Dilo",
                        display_pos_field: true
                    },
                    //{ key: 'cash-register-invoice-income',        title: '',                     display_pos_field: false },
                    //{ key: 'cash-register-invoice-income-manual', title: '',                     display_pos_field: false },
                    //{ key: 'cash-register-invoice-outlay',        title: '',                     display_pos_field: false },
                    //{ key: 'cash-register-invoice-outlay-manual', title: '',                     display_pos_field: false },
                    //{ key: 'cash-register-journal',               title: '',                     display_pos_field: false },
                    {
                        key: 'credit-note',
                        title: 'Dobropis',
                        display_pos_field: false
                    },
                    //{ key: 'delivery-report',                     title: '',                     display_pos_field: false },
                    //{ key: 'gift-voucher',                        title: '',                     display_pos_field: false },
                    //{ key: 'guest-book',                          title: '',                     display_pos_field: false },
                    {
                        key: 'invoice',
                        title: 'Faktura',
                        display_pos_field: false
                    },
                    {
                        key: 'offer',
                        title: 'Ponudba',
                        display_pos_field: false
                    },
                    {
                        key: 'prepayment-invoice',
                        title: "Avansni ra\u010Dun",
                        display_pos_field: false
                    },
                    //{ key: 'proforma-invoice-book',               title: '',                     display_pos_field: false },
                    //{ key: 'sales-invoice-book',                  title: '',                     display_pos_field: false },
                    //{ key: 'stock-acquisition',                   title: '',                     display_pos_field: false },
                    //{ key: 'stock-delivery-document',             title: '',                     display_pos_field: false },
                    //{ key: 'warehouse-transfer-order',            title: '',                     display_pos_field: false },
                    {
                        key: 'delivery-note',
                        title: 'Dobavnica',
                        display_pos_field: false
                    }
                ].map((property)=>{
                    let key = property.key;
                    let type = 'document';
                    const document = document_types[key];
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "edit",
                                    intent: "primary",
                                    minimal: true,
                                    small: true,
                                    onClick: ()=>{
                                        openEditSettingsItemDialog(type, property, property.title, key);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2,
                                child: property.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: document.print_final_text === null || document.print_final_text.length == 0 ? 'cross' : 'tick'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 4,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: document.print_final_text_de === null || document.print_final_text_de.length == 0 ? 'cross' : 'tick'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 5,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: document.print_final_text_en === null || document.print_final_text_en.length == 0 ? 'cross' : 'tick'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 6,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: document.print_final_text_pos === null || document.print_final_text_pos.length == 0 ? 'cross' : 'tick'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 7,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: document.print_qr_pay_code ? 'tick' : 'cross'
                                })
                            })
                        ]
                    }, 'settings-result--property-' + key);
                })
            }, 'settings-result-1')
        ]
    });
}
class DocumentSettings extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.openEditSettingsItemDialog = this.openEditSettingsItemDialog.bind(this);
        this.closeEditSettingsItemDialog = this.closeEditSettingsItemDialog.bind(this);
        const { document_types } = this.updateTableItemsFromProps(props);
        this.state = {
            document_types,
            edit_settings_item_dialog_open: false,
            edit_settings_item_dialog_type: null,
            edit_settings_item_dialog_item: null,
            edit_settings_item_dialog_title: '',
            edit_settings_item_dialog_property_key: null,
            edit_settings_item_dialog_display_pos: false
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!(0, _deepEqualDefault.default)(this.props.document_types, this.state.document_types)) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        return {
            document_types: props.document_types
        };
    }
    openEditSettingsItemDialog(type, item, title, property_key) {
        this.setState({
            edit_settings_item_dialog_open: true,
            edit_settings_item_dialog_type: type,
            edit_settings_item_dialog_item: item,
            edit_settings_item_dialog_title: title,
            edit_settings_item_dialog_property_key: property_key,
            edit_settings_item_dialog_display_pos: item.display_pos_field
        });
    }
    async closeEditSettingsItemDialog(item) {
        this.setState({
            edit_settings_item_dialog_open: false,
            edit_settings_item_dialog_type: null,
            edit_settings_item_dialog_item: null,
            edit_settings_item_dialog_title: '',
            edit_settings_item_dialog_property_key: null,
            edit_settings_item_dialog_display_pos: false
        });
        if (item !== undefined) {
            let new_item = item;
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            new_item = await (0, _documents.saveDocumentType)(this.props.api_url, new_item, token);
            if (new_item !== null) dispatch((0, _documentSlice.addDocumentType)({
                item: new_item
            }));
        }
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('settings--reports') === -1) return null;
        let edit_settings_dialog = null;
        if (this.state.edit_settings_item_dialog_open) {
            const document = this.state.document_types[this.state.edit_settings_item_dialog_property_key];
            if (document !== undefined) edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemDocumentDialogDefault.default), {
                item: document,
                title: this.state.edit_settings_item_dialog_title,
                display_pos: this.state.edit_settings_item_dialog_display_pos,
                closeDialog: this.closeEditSettingsItemDialog
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                edit_settings_dialog,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex flex-col flex-grow general-settings-list",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1 pl-4 pr-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-grow overflow-y-auto",
                            style: {
                                flexBasis: '0'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                item: this.state.item,
                                openEditSettingsItemDialog: this.openEditSettingsItemDialog,
                                client: this.props.client,
                                document_types: this.props.document_types
                            })
                        })
                    })
                })
            ]
        });
    }
}
DocumentSettings.propTypes = {};
function mapStateToProps(state) {
    return {
        general_settings: state.SettingsSlice.general,
        api_url: state.SettingsSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        document_types: state.DocumentSlice.document_types,
        client: state.ConstantsSlice.client
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(DocumentSettings);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","deep-equal":"bX1wQ","../../slices/DocumentSlice":"6gdAm","../../api/Documents":"hSEi5","../../helpers/LocalStorageHelper":"9I9tm","../code_tables/ResultComponents":"1eVlZ","./EditSettingsItemDocumentDialog":"dfKJq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bX1wQ":[function(require,module,exports,__globalThis) {
'use strict';
var assign = require("66d7c2a795c02b5");
var callBound = require("2175dac8ae9ce911");
var flags = require("f60a9f85e965c8db");
var GetIntrinsic = require("f00f9b3fafe92103");
var getIterator = require("b463b0c7f7d7cf72");
var getSideChannel = require("1f5ab288d9f4acc3");
var is = require("4507ab82af52838e");
var isArguments = require("35e168c0757d86dc");
var isArray = require("a8ef0ae6409c8be7");
var isArrayBuffer = require("d4406e33036431eb");
var isDate = require("51869b400334d972");
var isRegex = require("e39d986f72f520d7");
var isSharedArrayBuffer = require("73e5c64ba4b1a19a");
var objectKeys = require("69b25d5c5741b949");
var whichBoxedPrimitive = require("d518d261984adf0e");
var whichCollection = require("72d15e59e8c459c4");
var whichTypedArray = require("e39d85a76a9fff43");
var byteLength = require("75f7ec9931b5a132");
var sabByteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);
var $getTime = callBound('Date.prototype.getTime');
var gPO = Object.getPrototypeOf;
var $objToString = callBound('Object.prototype.toString');
var $Set = GetIntrinsic('%Set%', true);
var $mapHas = callBound('Map.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSize = callBound('Map.prototype.size', true);
var $setAdd = callBound('Set.prototype.add', true);
var $setDelete = callBound('Set.prototype.delete', true);
var $setHas = callBound('Set.prototype.has', true);
var $setSize = callBound('Set.prototype.size', true);
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function setHasEqualElement(set, val1, opts, channel) {
    var i = getIterator(set);
    var result;
    while((result = i.next()) && !result.done)if (internalDeepEqual(val1, result.value, opts, channel)) {
        // Remove the matching element to make sure we do not check that again.
        $setDelete(set, result.value);
        return true;
    }
    return false;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function findLooseMatchingPrimitives(prim) {
    if (typeof prim === 'undefined') return null;
    if (typeof prim === 'object') return void 0;
    if (typeof prim === 'symbol') return false;
    if (typeof prim === 'string' || typeof prim === 'number') // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
    return true;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = $mapGet(b, altValue);
    var looseOpts = assign({}, opts, {
        strict: false
    });
    if (typeof curB === 'undefined' && !$mapHas(b, altValue) || !internalDeepEqual(item, curB, looseOpts, channel)) return false;
    // eslint-disable-next-line no-use-before-define
    return !$mapHas(a, altValue) && internalDeepEqual(item, curB, looseOpts, channel);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function setMightHaveLoosePrim(a, b, prim) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return $setHas(b, altValue) && !$setHas(a, altValue);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function mapHasEqualEntry(set, map, key1, item1, opts, channel) {
    var i = getIterator(set);
    var result;
    var key2;
    while((result = i.next()) && !result.done){
        key2 = result.value;
        if (// eslint-disable-next-line no-use-before-define
        internalDeepEqual(key1, key2, opts, channel) && internalDeepEqual(item1, $mapGet(map, key2), opts, channel)) {
            $setDelete(set, key2);
            return true;
        }
    }
    return false;
}
function internalDeepEqual(actual, expected, options, channel) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? is(actual, expected) : actual === expected) return true;
    var actualBoxed = whichBoxedPrimitive(actual);
    var expectedBoxed = whichBoxedPrimitive(expected);
    if (actualBoxed !== expectedBoxed) return false;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') return opts.strict ? is(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration
    var hasActual = channel.has(actual);
    var hasExpected = channel.has(expected);
    var sentinel;
    if (hasActual && hasExpected) {
        if (channel.get(actual) === channel.get(expected)) return true;
    } else sentinel = {};
    if (!hasActual) channel.set(actual, sentinel);
    if (!hasExpected) channel.set(expected, sentinel);
    // eslint-disable-next-line no-use-before-define
    return objEquiv(actual, expected, opts, channel);
}
function isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}
function setEquiv(a, b, opts, channel) {
    if ($setSize(a) !== $setSize(b)) return false;
    var iA = getIterator(a);
    var iB = getIterator(b);
    var resultA;
    var resultB;
    var set;
    while((resultA = iA.next()) && !resultA.done){
        if (resultA.value && typeof resultA.value === 'object') {
            if (!set) set = new $Set();
            $setAdd(set, resultA.value);
        } else if (!$setHas(b, resultA.value)) {
            if (opts.strict) return false;
            if (!setMightHaveLoosePrim(a, b, resultA.value)) return false;
            if (!set) set = new $Set();
            $setAdd(set, resultA.value);
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
            if (resultB.value && typeof resultB.value === 'object') {
                if (!setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
            } else if (!opts.strict && !$setHas(a, resultB.value) && !setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
        }
        return $setSize(set) === 0;
    }
    return true;
}
function mapEquiv(a, b, opts, channel) {
    if ($mapSize(a) !== $mapSize(b)) return false;
    var iA = getIterator(a);
    var iB = getIterator(b);
    var resultA;
    var resultB;
    var set;
    var key;
    var item1;
    var item2;
    while((resultA = iA.next()) && !resultA.done){
        key = resultA.value[0];
        item1 = resultA.value[1];
        if (key && typeof key === 'object') {
            if (!set) set = new $Set();
            $setAdd(set, key);
        } else {
            item2 = $mapGet(b, key);
            if (typeof item2 === 'undefined' && !$mapHas(b, key) || !internalDeepEqual(item1, item2, opts, channel)) {
                if (opts.strict) return false;
                if (!mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) return false;
                if (!set) set = new $Set();
                $setAdd(set, key);
            }
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            key = resultB.value[0];
            item2 = resultB.value[1];
            if (key && typeof key === 'object') {
                if (!mapHasEqualEntry(set, a, key, item2, opts, channel)) return false;
            } else if (!opts.strict && (!a.has(key) || !internalDeepEqual($mapGet(a, key), item2, opts, channel)) && !mapHasEqualEntry(set, a, key, item2, assign({}, opts, {
                strict: false
            }), channel)) return false;
        }
        return $setSize(set) === 0;
    }
    return true;
}
function objEquiv(a, b, opts, channel) {
    /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5], max-lines: [2, 400] */ var i, key;
    if (typeof a !== typeof b) return false;
    if (a == null || b == null) return false;
    if ($objToString(a) !== $objToString(b)) return false;
    if (isArguments(a) !== isArguments(b)) return false;
    var aIsArray = isArray(a);
    var bIsArray = isArray(b);
    if (aIsArray !== bIsArray) return false;
    // TODO: replace when a cross-realm brand check is available
    var aIsError = a instanceof Error;
    var bIsError = b instanceof Error;
    if (aIsError !== bIsError) return false;
    if (aIsError || bIsError) {
        if (a.name !== b.name || a.message !== b.message) return false;
    }
    var aIsRegex = isRegex(a);
    var bIsRegex = isRegex(b);
    if (aIsRegex !== bIsRegex) return false;
    if ((aIsRegex || bIsRegex) && (a.source !== b.source || flags(a) !== flags(b))) return false;
    var aIsDate = isDate(a);
    var bIsDate = isDate(b);
    if (aIsDate !== bIsDate) return false;
    if (aIsDate || bIsDate) {
        if ($getTime(a) !== $getTime(b)) return false;
    }
    if (opts.strict && gPO && gPO(a) !== gPO(b)) return false;
    var aWhich = whichTypedArray(a);
    var bWhich = whichTypedArray(b);
    if (aWhich !== bWhich) return false;
    if (aWhich || bWhich) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    var aIsBuffer = isBuffer(a);
    var bIsBuffer = isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    var aIsArrayBuffer = isArrayBuffer(a);
    var bIsArrayBuffer = isArrayBuffer(b);
    if (aIsArrayBuffer !== bIsArrayBuffer) return false;
    if (aIsArrayBuffer || bIsArrayBuffer) {
        if (byteLength(a) !== byteLength(b)) return false;
        return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    var aIsSAB = isSharedArrayBuffer(a);
    var bIsSAB = isSharedArrayBuffer(b);
    if (aIsSAB !== bIsSAB) return false;
    if (aIsSAB || bIsSAB) {
        if (sabByteLength(a) !== sabByteLength(b)) return false;
        return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    if (typeof a !== typeof b) return false;
    var ka = objectKeys(a);
    var kb = objectKeys(b);
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
         // eslint-disable-line eqeqeq
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!internalDeepEqual(a[key], b[key], opts, channel)) return false;
    }
    var aCollection = whichCollection(a);
    var bCollection = whichCollection(b);
    if (aCollection !== bCollection) return false;
    if (aCollection === 'Set' || bCollection === 'Set') return setEquiv(a, b, opts, channel);
    if (aCollection === 'Map') return mapEquiv(a, b, opts, channel);
    return true;
}
module.exports = function deepEqual(a, b, opts) {
    return internalDeepEqual(a, b, opts, getSideChannel());
};

},{"66d7c2a795c02b5":"aZINA","2175dac8ae9ce911":"6cPux","f60a9f85e965c8db":"dXFr5","f00f9b3fafe92103":"dRNto","b463b0c7f7d7cf72":"51qce","1f5ab288d9f4acc3":"giXmi","4507ab82af52838e":"41SFz","35e168c0757d86dc":"ikBfj","a8ef0ae6409c8be7":"bARuY","d4406e33036431eb":"1NQhl","51869b400334d972":"3HCJv","e39d986f72f520d7":"YNqlw","73e5c64ba4b1a19a":"j2S4e","69b25d5c5741b949":"7AE8b","d518d261984adf0e":"aQ0uQ","72d15e59e8c459c4":"4mQYw","e39d85a76a9fff43":"rQv5T","75f7ec9931b5a132":"dM108"}],"aZINA":[function(require,module,exports,__globalThis) {
'use strict';
var defineProperties = require("31006c3cfe40af17");
var callBind = require("4bd644f8ee56850a");
var implementation = require("7eb15e28e3121047");
var getPolyfill = require("741d58b7433c3ec2");
var shim = require("b106e2c495003b2a");
var polyfill = callBind.apply(getPolyfill());
// eslint-disable-next-line no-unused-vars
var bound = function assign(target, source1) {
    return polyfill(Object, arguments);
};
defineProperties(bound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = bound;

},{"31006c3cfe40af17":"iXqnd","4bd644f8ee56850a":"hMR6y","7eb15e28e3121047":"47eDt","741d58b7433c3ec2":"es1pE","b106e2c495003b2a":"9lBk5"}],"iXqnd":[function(require,module,exports,__globalThis) {
'use strict';
var keys = require("7ff177585d1618f0");
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = require("84ca194f5a28ce70");
var isFunction = function(fn) {
    return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};
var supportsDescriptors = require("c52d62086511583f")();
var defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!isFunction(predicate) || !predicate()) return;
    }
    if (supportsDescriptors) defineDataProperty(object, name, value, true);
    else defineDataProperty(object, name, value);
};
var defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
module.exports = defineProperties;

},{"7ff177585d1618f0":"7AE8b","84ca194f5a28ce70":"l1706","c52d62086511583f":"gruPM"}],"7AE8b":[function(require,module,exports,__globalThis) {
'use strict';
var slice = Array.prototype.slice;
var isArgs = require("93e8460f624c96f4");
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
    return origKeys(o);
} : require("344bb0d7b2568e03");
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if (isArgs(object)) return originalKeys(slice.call(object));
            return originalKeys(object);
        };
    } else Object.keys = keysShim;
    return Object.keys || keysShim;
};
module.exports = keysShim;

},{"93e8460f624c96f4":"hFngz","344bb0d7b2568e03":"5BYnt"}],"hFngz":[function(require,module,exports,__globalThis) {
'use strict';
var toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

},{}],"5BYnt":[function(require,module,exports,__globalThis) {
'use strict';
var keysShim;
if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = require("b0d8c8b84be91ffd"); // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
        toString: null
    }, 'toString');
    var hasProtoEnumBug = isEnumerable.call(function() {}, 'prototype');
    var dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !hasAutomationEqualityBug) return equalsConstructorPrototype(o);
        try {
            return equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = toStr.call(object) === '[object Function]';
        var isArguments = isArgs(object);
        var isString = isObject && toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && has.call(object, name)) theKeys.push(String(name));
        }
        if (hasDontEnumBug) {
            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < dontEnums.length; ++k)if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) theKeys.push(dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = keysShim;

},{"b0d8c8b84be91ffd":"hFngz"}],"l1706":[function(require,module,exports,__globalThis) {
'use strict';
var $defineProperty = require("f17fd23367965521");
var $SyntaxError = require("50f12088ee0f6bb");
var $TypeError = require("45c79de2b2f9c949");
var gopd = require("3f9bd39335781ec7");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $TypeError('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $TypeError('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $TypeError('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!gopd && gopd(obj, property);
    if ($defineProperty) $defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

},{"f17fd23367965521":"4nWJu","50f12088ee0f6bb":"kM1J4","45c79de2b2f9c949":"4FiSx","3f9bd39335781ec7":"iyLmA"}],"4nWJu":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ var $defineProperty = Object.defineProperty || false;
if ($defineProperty) try {
    $defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = false;
}
module.exports = $defineProperty;

},{}],"kM1J4":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

},{}],"4FiSx":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

},{}],"iyLmA":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ var $gOPD = require("2065a078be813600");
if ($gOPD) try {
    $gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
module.exports = $gOPD;

},{"2065a078be813600":"59Jmk"}],"59Jmk":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

},{}],"gruPM":[function(require,module,exports,__globalThis) {
'use strict';
var $defineProperty = require("1c3b0ce871129f60");
var hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$defineProperty) return null;
    try {
        return $defineProperty([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = hasPropertyDescriptors;

},{"1c3b0ce871129f60":"4nWJu"}],"hMR6y":[function(require,module,exports,__globalThis) {
'use strict';
var setFunctionLength = require("f4b53071c102d4e");
var $defineProperty = require("3426ee59b177cf96");
var callBindBasic = require("48445b01a0d39287");
var applyBind = require("2ccc4afca1db8d27");
module.exports = function callBind(originalFunction) {
    var func = callBindBasic(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return setFunctionLength(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($defineProperty) $defineProperty(module.exports, 'apply', {
    value: applyBind
});
else module.exports.apply = applyBind;

},{"f4b53071c102d4e":"hRIKQ","3426ee59b177cf96":"4nWJu","48445b01a0d39287":"WMD82","2ccc4afca1db8d27":"eTRzy"}],"hRIKQ":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("8b1c9107ef1524f2");
var define = require("37dd1486f0f556ef");
var hasDescriptors = require("6a9d2b46085df706")();
var gOPD = require("2d412b0f532d1834");
var $TypeError = require("4352c534d27fe477");
var $floor = GetIntrinsic('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $TypeError('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) throw new $TypeError('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && gOPD) {
        var desc = gOPD(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else define(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

},{"8b1c9107ef1524f2":"dRNto","37dd1486f0f556ef":"l1706","6a9d2b46085df706":"gruPM","2d412b0f532d1834":"iyLmA","4352c534d27fe477":"4FiSx"}],"dRNto":[function(require,module,exports,__globalThis) {
'use strict';
var undefined1;
var $Object = require("2664640474097f21");
var $Error = require("ff34c740859aa28e");
var $EvalError = require("349515b7ea9b6cef");
var $RangeError = require("9da01653b2dd9abf");
var $ReferenceError = require("68586abd6b0136da");
var $SyntaxError = require("662263fdbc077fc8");
var $TypeError = require("abdfc34e5f6bb86");
var $URIError = require("daca1f932429e03e");
var abs = require("6a52a0c0ffccac74");
var floor = require("d01cf04757c5320b");
var max = require("a2657a92cb7dae87");
var min = require("6367c0241be1f01");
var pow = require("9bee48b90a8c96d");
var round = require("b5cc049891156ba3");
var sign = require("8d956274d8c0407e");
var $Function = Function;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $gOPD = require("7f0abb73c570ef31");
var $defineProperty = require("3cbcb7341b0412ef");
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("1f00f712d594ccf")();
var getProto = require("89cf41d095fe5a0a");
var $ObjectGPO = require("a5e781ace21741c8");
var $ReflectGPO = require("db08b186beb7f382");
var $apply = require("213af9137f841281");
var $call = require("56d5af438508fcc0");
var needsEval = {};
var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': needsEval,
    '%AsyncGenerator%': needsEval,
    '%AsyncGeneratorFunction%': needsEval,
    '%AsyncIteratorPrototype%': needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $Error,
    '%eval%': eval,
    '%EvalError%': $EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $Function,
    '%GeneratorFunction%': needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $Object,
    '%Object.getOwnPropertyDescriptor%': $gOPD,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $RangeError,
    '%ReferenceError%': $ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $SyntaxError,
    '%ThrowTypeError%': ThrowTypeError,
    '%TypedArray%': TypedArray,
    '%TypeError%': $TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $call,
    '%Function.prototype.apply%': $apply,
    '%Object.defineProperty%': $defineProperty,
    '%Object.getPrototypeOf%': $ObjectGPO,
    '%Math.abs%': abs,
    '%Math.floor%': floor,
    '%Math.max%': max,
    '%Math.min%': min,
    '%Math.pow%': pow,
    '%Math.round%': round,
    '%Math.sign%': sign,
    '%Reflect.getPrototypeOf%': $ReflectGPO
};
if (getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS['%Error.prototype%'] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && getProto) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};
var bind = require("7c5e688e48cd07b0");
var hasOwn = require("af36d49b4b8c6c7c");
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $SyntaxError('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"2664640474097f21":"jtFM1","ff34c740859aa28e":"7OqOD","349515b7ea9b6cef":"bLeeT","9da01653b2dd9abf":"bX7m3","68586abd6b0136da":"39CPB","662263fdbc077fc8":"kM1J4","abdfc34e5f6bb86":"4FiSx","daca1f932429e03e":"cM9HK","6a52a0c0ffccac74":"77OnN","d01cf04757c5320b":"gJ7BF","a2657a92cb7dae87":"fau6D","6367c0241be1f01":"ahtCb","9bee48b90a8c96d":"6baT2","b5cc049891156ba3":"buQjL","8d956274d8c0407e":"k6rOv","7f0abb73c570ef31":"iyLmA","3cbcb7341b0412ef":"4nWJu","1f00f712d594ccf":"9IzVf","89cf41d095fe5a0a":"8CcHr","a5e781ace21741c8":"hfU1H","db08b186beb7f382":"5MT56","213af9137f841281":"l0B7X","56d5af438508fcc0":"ajLUt","7c5e688e48cd07b0":"jn7fQ","af36d49b4b8c6c7c":"aZ5G0"}],"jtFM1":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

},{}],"7OqOD":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

},{}],"bLeeT":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

},{}],"bX7m3":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

},{}],"39CPB":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

},{}],"cM9HK":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

},{}],"77OnN":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

},{}],"gJ7BF":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

},{}],"fau6D":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

},{}],"ahtCb":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

},{}],"6baT2":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

},{}],"buQjL":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

},{}],"k6rOv":[function(require,module,exports,__globalThis) {
'use strict';
var $isNaN = require("d292273fa9eecbef");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($isNaN(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

},{"d292273fa9eecbef":"ku7FW"}],"ku7FW":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

},{}],"9IzVf":[function(require,module,exports,__globalThis) {
'use strict';
var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require("3fb25678c62d2fce");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return hasSymbolSham();
};

},{"3fb25678c62d2fce":"77zbC"}],"77zbC":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{}],"8CcHr":[function(require,module,exports,__globalThis) {
'use strict';
var reflectGetProto = require("ba0ea764912daf49");
var originalGetProto = require("1bd809a13f9b0f46");
var getDunderProto = require("fbec8086c64f7968");
/** @type {import('.')} */ module.exports = reflectGetProto ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return reflectGetProto(O);
} : originalGetProto ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return originalGetProto(O);
} : getDunderProto ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return getDunderProto(O);
} : null;

},{"ba0ea764912daf49":"5MT56","1bd809a13f9b0f46":"hfU1H","fbec8086c64f7968":"6qohZ"}],"5MT56":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

},{}],"hfU1H":[function(require,module,exports,__globalThis) {
'use strict';
var $Object = require("23f06d8f004a91fb");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $Object.getPrototypeOf || null;

},{"23f06d8f004a91fb":"jtFM1"}],"6qohZ":[function(require,module,exports,__globalThis) {
'use strict';
var callBind = require("20202e6273970ec3");
var gOPD = require("6e9e415ed4ed192c");
var hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = desc && typeof desc.get === 'function' ? callBind([
    desc.get
]) : typeof $getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $getPrototypeOf(value == null ? value : $Object(value));
} : false;

},{"20202e6273970ec3":"WMD82","6e9e415ed4ed192c":"iyLmA"}],"WMD82":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("d6d8aee3c61fa381");
var $TypeError = require("3ad70b4ee76fdc3");
var $call = require("79792e7530a25b0e");
var $actualApply = require("1883a23d55f655c3");
/** @type {import('.')} */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $TypeError('a function is required');
    return $actualApply(bind, $call, args);
};

},{"d6d8aee3c61fa381":"jn7fQ","3ad70b4ee76fdc3":"4FiSx","79792e7530a25b0e":"ajLUt","1883a23d55f655c3":"e8fTV"}],"jn7fQ":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("12e173b4dbaee960");
module.exports = Function.prototype.bind || implementation;

},{"12e173b4dbaee960":"3CVeo"}],"3CVeo":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';
var concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, concatty(args, arguments));
    };
    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"ajLUt":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

},{}],"e8fTV":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("ba0cb57b961776b");
var $apply = require("8002d8d4a5e40cd8");
var $call = require("dd5326344bf1485c");
var $reflectApply = require("ddbf3cfadf2f22c");
/** @type {import('./actualApply')} */ module.exports = $reflectApply || bind.call($call, $apply);

},{"ba0cb57b961776b":"jn7fQ","8002d8d4a5e40cd8":"l0B7X","dd5326344bf1485c":"ajLUt","ddbf3cfadf2f22c":"5f1pB"}],"l0B7X":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

},{}],"5f1pB":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

},{}],"aZ5G0":[function(require,module,exports,__globalThis) {
'use strict';
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require("126cb75e62f8e17b");
/** @type {import('.')} */ module.exports = bind.call(call, $hasOwn);

},{"126cb75e62f8e17b":"jn7fQ"}],"eTRzy":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("a42cbe56dcf9275");
var $apply = require("374f458abdeecf5a");
var actualApply = require("5dc0de3ccb73e5d2");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return actualApply(bind, $apply, arguments);
};

},{"a42cbe56dcf9275":"jn7fQ","374f458abdeecf5a":"l0B7X","5dc0de3ccb73e5d2":"e8fTV"}],"47eDt":[function(require,module,exports,__globalThis) {
'use strict';
// modified from https://github.com/es-shims/es6-shim
var objectKeys = require("334c0bea01e613e6");
var hasSymbols = require("1964e25feb5e87a1")();
var callBound = require("20da938b12dae35d");
var $Object = require("5b3fc42904ffd60f");
var $push = callBound('Array.prototype.push');
var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols ? $Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $Object(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $Object(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = objectKeys(from);
        var getSymbols = hasSymbols && ($Object.getOwnPropertySymbols || originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($propIsEnumerable(from, key)) $push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

},{"334c0bea01e613e6":"7AE8b","1964e25feb5e87a1":"77zbC","20da938b12dae35d":"dhWMF","5b3fc42904ffd60f":"jtFM1"}],"dhWMF":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("90205503fa989ea7");
var callBindBasic = require("79b99f4b8fc521d");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $indexOf = callBindBasic([
    GetIntrinsic('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    // eslint-disable-next-line no-extra-parens
    var intrinsic = /** @type {Parameters<typeof callBindBasic>[0][0]} */ GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) return callBindBasic([
        intrinsic
    ]);
    return intrinsic;
};

},{"90205503fa989ea7":"dRNto","79b99f4b8fc521d":"WMD82"}],"es1pE":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("b7e83063a8ec29e5");
var lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return implementation;
    if (lacksProperEnumerationOrder()) return implementation;
    if (assignHasPendingExceptions()) return implementation;
    return Object.assign;
};

},{"b7e83063a8ec29e5":"47eDt"}],"9lBk5":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("6217b44f86f6933f");
var getPolyfill = require("1bf116323cb538f2");
module.exports = function shimAssign() {
    var polyfill = getPolyfill();
    define(Object, {
        assign: polyfill
    }, {
        assign: function() {
            return Object.assign !== polyfill;
        }
    });
    return polyfill;
};

},{"6217b44f86f6933f":"iXqnd","1bf116323cb538f2":"es1pE"}],"6cPux":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("8b08ecb81cf4de17");
var callBind = require("266fc50410cfc4a");
var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) return callBind(intrinsic);
    return intrinsic;
};

},{"8b08ecb81cf4de17":"dRNto","266fc50410cfc4a":"hMR6y"}],"dXFr5":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("234cd2776d15a037");
var callBind = require("6f662a760b1534f2");
var implementation = require("92a1454309a44466");
var getPolyfill = require("3ca514117a836edc");
var shim = require("e153862c910219d2");
var flagsBound = callBind(getPolyfill());
define(flagsBound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = flagsBound;

},{"234cd2776d15a037":"iXqnd","6f662a760b1534f2":"hMR6y","92a1454309a44466":"hbHj3","3ca514117a836edc":"kUBio","e153862c910219d2":"kJbzx"}],"hbHj3":[function(require,module,exports,__globalThis) {
'use strict';
var setFunctionName = require("73fe2073c023acf2");
var $TypeError = require("426e5953f3236710");
var $Object = Object;
module.exports = setFunctionName(function flags() {
    if (this == null || this !== $Object(this)) throw new $TypeError('RegExp.prototype.flags getter called on non-object');
    var result = '';
    if (this.hasIndices) result += 'd';
    if (this.global) result += 'g';
    if (this.ignoreCase) result += 'i';
    if (this.multiline) result += 'm';
    if (this.dotAll) result += 's';
    if (this.unicode) result += 'u';
    if (this.unicodeSets) result += 'v';
    if (this.sticky) result += 'y';
    return result;
}, 'get flags', true);

},{"73fe2073c023acf2":"56KB4","426e5953f3236710":"4FiSx"}],"56KB4":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("151b89e8a715d4f3");
var hasDescriptors = require("e4d428b901bb50")();
var functionsHaveConfigurableNames = require("ff3f0082d0e55515").functionsHaveConfigurableNames();
var $TypeError = require("e7e6dd6b278b3b4f");
/** @type {import('.')} */ module.exports = function setFunctionName(fn, name) {
    if (typeof fn !== 'function') throw new $TypeError('`fn` is not a function');
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || functionsHaveConfigurableNames) {
        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, 'name', name, true, true);
        else define(/** @type {Parameters<define>[0]} */ fn, 'name', name);
    }
    return fn;
};

},{"151b89e8a715d4f3":"l1706","e4d428b901bb50":"gruPM","ff3f0082d0e55515":"c55xM","e7e6dd6b278b3b4f":"4FiSx"}],"c55xM":[function(require,module,exports,__globalThis) {
'use strict';
var functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === 'string';
};
var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) try {
    gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    gOPD = null;
}
functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!functionsHaveNames() || !gOPD) return false;
    var desc = gOPD(function() {}, 'name');
    return !!desc && !!desc.configurable;
};
var $bind = Function.prototype.bind;
functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return functionsHaveNames() && typeof $bind === 'function' && (function f() {}).bind().name !== '';
};
module.exports = functionsHaveNames;

},{}],"kUBio":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("758a981608e1eeda");
var supportsDescriptors = require("6f5c0dd77da656ca").supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if (supportsDescriptors && /a/mig.flags === 'gim') {
        var descriptor = $gOPD(RegExp.prototype, 'flags');
        if (descriptor && typeof descriptor.get === 'function' && 'dotAll' in RegExp.prototype && 'hasIndices' in RegExp.prototype) {
            /* eslint getter-return: 0 */ var calls = '';
            var o = {};
            Object.defineProperty(o, 'hasIndices', {
                get: function() {
                    calls += 'd';
                }
            });
            Object.defineProperty(o, 'sticky', {
                get: function() {
                    calls += 'y';
                }
            });
            descriptor.get.call(o);
            if (calls === 'dy') return descriptor.get;
        }
    }
    return implementation;
};

},{"758a981608e1eeda":"hbHj3","6f5c0dd77da656ca":"iXqnd"}],"kJbzx":[function(require,module,exports,__globalThis) {
'use strict';
var supportsDescriptors = require("d860dcb1943639b0").supportsDescriptors;
var getPolyfill = require("cdfc6652a32f035d");
var gOPD = require("d83d77f4bd19dc79");
var defineProperty = Object.defineProperty;
var $TypeError = require("b24365cb4b9e8992");
var getProto = require("190962971f9082da");
var regex = /a/;
module.exports = function shimFlags() {
    if (!supportsDescriptors || !getProto) throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    var polyfill = getPolyfill();
    var proto = getProto(regex);
    var descriptor = gOPD(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) defineProperty(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

},{"d860dcb1943639b0":"iXqnd","cdfc6652a32f035d":"kUBio","d83d77f4bd19dc79":"iyLmA","b24365cb4b9e8992":"7OqOD","190962971f9082da":"8CcHr"}],"51qce":[function(require,module,exports,__globalThis) {
var process = require("fae62858926d8104");
'use strict';
/* eslint global-require: 0 */ // the code is structured this way so that bundlers can
// alias out `has-symbols` to `() => true` or `() => false` if your target
// environments' Symbol capabilities are known, and then use
// dead code elimination on the rest of this module.
//
// Similarly, `isarray` can be aliased to `Array.isArray` if
// available in all target environments.
var isArguments = require("6852acab7aecf9d6");
var getStopIterationIterator = require("91e22879998534c6");
if (require("b6127dd0618ca580")() || require("4cedb8cfde480f45")()) {
    var $iterator = Symbol.iterator;
    // Symbol is available natively or shammed
    // natively:
    //  - Chrome >= 38
    //  - Edge 12-14?, Edge >= 15 for sure
    //  - FF >= 36
    //  - Safari >= 9
    //  - node >= 0.12
    module.exports = function getIterator(iterable) {
        // alternatively, `iterable[$iterator]?.()`
        if (iterable != null && typeof iterable[$iterator] !== 'undefined') return iterable[$iterator]();
        if (isArguments(iterable)) // arguments objects lack Symbol.iterator
        // - node 0.12
        return Array.prototype[$iterator].call(iterable);
    };
} else {
    // Symbol is not available, native or shammed
    var isArray = require("9e40df185bc98ad2");
    var isString = require("4408d389fb64535");
    var GetIntrinsic = require("1dadc710d71d74ba");
    var $Map = GetIntrinsic('%Map%', true);
    var $Set = GetIntrinsic('%Set%', true);
    var callBound = require("99235f8f305089d6");
    var $arrayPush = callBound('Array.prototype.push');
    var $charCodeAt = callBound('String.prototype.charCodeAt');
    var $stringSlice = callBound('String.prototype.slice');
    var advanceStringIndex = function advanceStringIndex(S, index) {
        var length = S.length;
        if (index + 1 >= length) return index + 1;
        var first = $charCodeAt(S, index);
        if (first < 0xD800 || first > 0xDBFF) return index + 1;
        var second = $charCodeAt(S, index + 1);
        if (second < 0xDC00 || second > 0xDFFF) return index + 1;
        return index + 2;
    };
    var getArrayIterator = function getArrayIterator(arraylike) {
        var i = 0;
        return {
            next: function next() {
                var done = i >= arraylike.length;
                var value;
                if (!done) {
                    value = arraylike[i];
                    i += 1;
                }
                return {
                    done: done,
                    value: value
                };
            }
        };
    };
    var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
        if (isArray(iterable) || isArguments(iterable)) return getArrayIterator(iterable);
        if (isString(iterable)) {
            var i = 0;
            return {
                next: function next() {
                    var nextIndex = advanceStringIndex(iterable, i);
                    var value = $stringSlice(iterable, i, nextIndex);
                    i = nextIndex;
                    return {
                        done: nextIndex > iterable.length,
                        value: value
                    };
                }
            };
        }
        // es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
        if (noPrimordialCollections && typeof iterable['_es6-shim iterator_'] !== 'undefined') return iterable['_es6-shim iterator_']();
    };
    if (!$Map && !$Set) // the only language iterables are Array, String, arguments
    // - Safari <= 6.0
    // - Chrome < 38
    // - node < 0.12
    // - FF < 13
    // - IE < 11
    // - Edge < 11
    module.exports = function getIterator(iterable) {
        if (iterable != null) return getNonCollectionIterator(iterable, true);
    };
    else {
        // either Map or Set are available, but Symbol is not
        // - es6-shim on an ES5 browser
        // - Safari 6.2 (maybe 6.1?)
        // - FF v[13, 36)
        // - IE 11
        // - Edge 11
        // - Safari v[6, 9)
        var isMap = require("281327d695979bc1");
        var isSet = require("87d16ceb511608");
        // Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
        var $mapForEach = callBound('Map.prototype.forEach', true);
        var $setForEach = callBound('Set.prototype.forEach', true);
        if (typeof process === 'undefined' || !process.versions || !process.versions.node) {
            // Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
            // returns a value, or throws a StopIteration object. These browsers
            // do not have any other mechanism for iteration.
            var $mapIterator = callBound('Map.prototype.iterator', true);
            var $setIterator = callBound('Set.prototype.iterator', true);
        }
        // Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
        // this returns a proper iterator object, so we should use it instead of forEach.
        // newer es6-shim versions use a string "_es6-shim iterator_" property.
        var $mapAtAtIterator = callBound('Map.prototype.@@iterator', true) || callBound('Map.prototype._es6-shim iterator_', true);
        var $setAtAtIterator = callBound('Set.prototype.@@iterator', true) || callBound('Set.prototype._es6-shim iterator_', true);
        var getCollectionIterator = function getCollectionIterator(iterable) {
            if (isMap(iterable)) {
                if ($mapIterator) return getStopIterationIterator($mapIterator(iterable));
                if ($mapAtAtIterator) return $mapAtAtIterator(iterable);
                if ($mapForEach) {
                    var entries = [];
                    $mapForEach(iterable, function(v, k) {
                        $arrayPush(entries, [
                            k,
                            v
                        ]);
                    });
                    return getArrayIterator(entries);
                }
            }
            if (isSet(iterable)) {
                if ($setIterator) return getStopIterationIterator($setIterator(iterable));
                if ($setAtAtIterator) return $setAtAtIterator(iterable);
                if ($setForEach) {
                    var values = [];
                    $setForEach(iterable, function(v) {
                        $arrayPush(values, v);
                    });
                    return getArrayIterator(values);
                }
            }
        };
        module.exports = function getIterator(iterable) {
            return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
        };
    }
}

},{"fae62858926d8104":"5jT8D","6852acab7aecf9d6":"ikBfj","91e22879998534c6":"4rYrX","b6127dd0618ca580":"9IzVf","4cedb8cfde480f45":"77zbC","9e40df185bc98ad2":"bARuY","4408d389fb64535":"255bA","1dadc710d71d74ba":"dRNto","99235f8f305089d6":"6cPux","281327d695979bc1":"am0Uk","87d16ceb511608":"7bJVF"}],"ikBfj":[function(require,module,exports,__globalThis) {
'use strict';
var hasToStringTag = require("e2b01ce809f132fb")();
var callBound = require("4a3fd3308cb18520");
var $toString = callBound('Object.prototype.toString');
/** @type {import('.')} */ var isStandardArguments = function isArguments(value) {
    if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var isLegacyArguments = function isArguments(value) {
    if (isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $toString(value) !== '[object Array]' && 'callee' in value && $toString(value.callee) === '[object Function]';
};
var supportsStandardArguments = function() {
    return isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

},{"e2b01ce809f132fb":"daNF4","4a3fd3308cb18520":"dhWMF"}],"daNF4":[function(require,module,exports,__globalThis) {
'use strict';
var hasSymbols = require("2ef89576d4959bff");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return hasSymbols() && !!Symbol.toStringTag;
};

},{"2ef89576d4959bff":"77zbC"}],"4rYrX":[function(require,module,exports,__globalThis) {
'use strict';
var SLOT = require("86c99d501e630e");
var $SyntaxError = require("b11ce42eb48d117b");
var $StopIteration = typeof StopIteration === 'object' ? StopIteration : null;
/** @type {import('.')} */ module.exports = function getStopIterationIterator(origIterator) {
    if (!$StopIteration) throw new $SyntaxError('this environment lacks StopIteration');
    SLOT.set(origIterator, '[[Done]]', false);
    /** @template T @typedef {T extends Iterator<infer U> ? U : never} IteratorType */ /** @typedef {IteratorType<ReturnType<typeof getStopIterationIterator>>} T */ var siIterator = {
        next: /** @type {() => IteratorResult<T>} */ function next() {
            // eslint-disable-next-line no-extra-parens
            var iterator = /** @type {typeof origIterator} */ SLOT.get(this, '[[Iterator]]');
            var done = !!SLOT.get(iterator, '[[Done]]');
            try {
                return {
                    done: done,
                    // eslint-disable-next-line no-extra-parens
                    value: done ? void 0 : /** @type {T} */ iterator.next()
                };
            } catch (e) {
                SLOT.set(iterator, '[[Done]]', true);
                if (e !== $StopIteration) throw e;
                return {
                    done: true,
                    value: void 0
                };
            }
        }
    };
    SLOT.set(siIterator, '[[Iterator]]', origIterator);
    // @ts-expect-error TODO FIXME
    return siIterator;
};

},{"86c99d501e630e":"haMd1","b11ce42eb48d117b":"kM1J4"}],"haMd1":[function(require,module,exports,__globalThis) {
'use strict';
/** @typedef {`$${import('.').InternalSlot}`} SaltedInternalSlot */ /** @typedef {{ [k in SaltedInternalSlot]?: unknown }} SlotsObject */ var hasOwn = require("728883b0b84b20f1");
/** @type {import('side-channel').Channel<object, SlotsObject>} */ var channel = require("3f3258afb7cf97d7")();
var $TypeError = require("f0899af7efab064d");
/** @type {import('.')} */ var SLOT = {
    assert: function(O, slot) {
        if (!O || typeof O !== 'object' && typeof O !== 'function') throw new $TypeError('`O` is not an object');
        if (typeof slot !== 'string') throw new $TypeError('`slot` must be a string');
        channel.assert(O);
        if (!SLOT.has(O, slot)) throw new $TypeError('`' + slot + '` is not present on `O`');
    },
    get: function(O, slot) {
        if (!O || typeof O !== 'object' && typeof O !== 'function') throw new $TypeError('`O` is not an object');
        if (typeof slot !== 'string') throw new $TypeError('`slot` must be a string');
        var slots = channel.get(O);
        // eslint-disable-next-line no-extra-parens
        return slots && slots[/** @type {SaltedInternalSlot} */ '$' + slot];
    },
    has: function(O, slot) {
        if (!O || typeof O !== 'object' && typeof O !== 'function') throw new $TypeError('`O` is not an object');
        if (typeof slot !== 'string') throw new $TypeError('`slot` must be a string');
        var slots = channel.get(O);
        // eslint-disable-next-line no-extra-parens
        return !!slots && hasOwn(slots, /** @type {SaltedInternalSlot} */ '$' + slot);
    },
    set: function(O, slot, V) {
        if (!O || typeof O !== 'object' && typeof O !== 'function') throw new $TypeError('`O` is not an object');
        if (typeof slot !== 'string') throw new $TypeError('`slot` must be a string');
        var slots = channel.get(O);
        if (!slots) {
            slots = {};
            channel.set(O, slots);
        }
        // eslint-disable-next-line no-extra-parens
        slots[/** @type {SaltedInternalSlot} */ '$' + slot] = V;
    }
};
if (Object.freeze) Object.freeze(SLOT);
module.exports = SLOT;

},{"728883b0b84b20f1":"aZ5G0","3f3258afb7cf97d7":"giXmi","f0899af7efab064d":"4FiSx"}],"giXmi":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("1d3f7a3f029b095e");
var inspect = require("9f4f5a92d8c6543");
var getSideChannelList = require("5a169a7b609983a5");
var getSideChannelMap = require("e26eec6007592cd");
var getSideChannelWeakMap = require("a282926cb8532787");
var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError('Side channel does not contain ' + inspect(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

},{"1d3f7a3f029b095e":"4FiSx","9f4f5a92d8c6543":"igbgW","5a169a7b609983a5":"b074l","e26eec6007592cd":"9xmzu","a282926cb8532787":"2uEOS"}],"igbgW":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}
var utilInspect = require("faefcb1694f2ad90");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return isArray(obj) ? '[Array]' : '[Object]';
    var indent = getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if (indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !isRegExp(obj)) {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) return '[' + indentedJoin(xs, indent) + ']';
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) return utilInspect(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) return weakCollectionOf('WeakMap');
    if (isWeakSet(obj)) return weakCollectionOf('WeakSet');
    if (isWeakRef(obj)) return weakCollectionOf('WeakRef');
    if (isNumber(obj)) return markBoxed(inspect(Number(obj)));
    if (isBigInt(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
    if (isBoolean(obj)) return markBoxed(booleanValueOf.call(obj));
    if (isString(obj)) return markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof global !== 'undefined' && obj === global) return '{ [object globalThis] }';
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}
function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}
function isArray(obj) {
    return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isDate(obj) {
    return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isRegExp(obj) {
    return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isError(obj) {
    return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isString(obj) {
    return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isNumber(obj) {
    return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isBoolean(obj) {
    return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !symToString) return false;
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) return false;
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function has(obj, key) {
    return hasOwn.call(obj, key);
}
function toStr(obj) {
    return objectToString.call(obj);
}
function nameOf(f) {
    if (f.name) return f.name;
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') return false;
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') return false;
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') return false;
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') return false;
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}
function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
    return 'Object(' + str + ')';
}
function weakCollectionOf(type) {
    return type + ' { ? }';
}
function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if (indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}
function indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if (isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

},{"faefcb1694f2ad90":"aBjM4"}],"aBjM4":[function(require,module,exports,__globalThis) {
"use strict";

},{}],"b074l":[function(require,module,exports,__globalThis) {
'use strict';
var inspect = require("c82a24db877dbdb5");
var $TypeError = require("7492c0a54ac02a69");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var listSet = function(objects, key, value) {
    var node = listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var listHas = function(objects, key) {
    if (!objects) return false;
    return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var listDelete = function(objects, key) {
    if (objects) return listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError('Side channel does not contain ' + inspect(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return listGet($o, key);
        },
        has: function(key) {
            return listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

},{"c82a24db877dbdb5":"igbgW","7492c0a54ac02a69":"4FiSx"}],"9xmzu":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("a1eef823705394c3");
var callBound = require("5e33adfb500d5ba2");
var inspect = require("2202d24f09ef0ac8");
var $TypeError = require("2772cd2df080356f");
var $Map = GetIntrinsic('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $mapSize = callBound('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError('Side channel does not contain ' + inspect(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $mapDelete($m, key);
                if ($mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $Map();
            $mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

},{"a1eef823705394c3":"dRNto","5e33adfb500d5ba2":"dhWMF","2202d24f09ef0ac8":"igbgW","2772cd2df080356f":"4FiSx"}],"2uEOS":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("13f8b3ed6c08f802");
var callBound = require("fcc2ce3a04e4916a");
var inspect = require("92adfc822fa342a4");
var getSideChannelMap = require("1290b6babf3b47b6");
var $TypeError = require("2293e69a0f659b70");
var $WeakMap = GetIntrinsic('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $weakMapDelete = callBound('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError('Side channel does not contain ' + inspect(key));
        },
        'delete': function(key) {
            if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $weakMapDelete($wm, key);
            } else if (getSideChannelMap) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $WeakMap();
                $weakMapSet($wm, key, value);
            } else if (getSideChannelMap) {
                if (!$m) $m = getSideChannelMap();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : getSideChannelMap;

},{"13f8b3ed6c08f802":"dRNto","fcc2ce3a04e4916a":"dhWMF","92adfc822fa342a4":"igbgW","1290b6babf3b47b6":"9xmzu","2293e69a0f659b70":"4FiSx"}],"bARuY":[function(require,module,exports,__globalThis) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == '[object Array]';
};

},{}],"255bA":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("7797830052e17b97");
/** @type {(receiver: ThisParameterType<typeof String.prototype.valueOf>, ...args: Parameters<typeof String.prototype.valueOf>) => ReturnType<typeof String.prototype.valueOf>} */ var $strValueOf = callBound('String.prototype.valueOf');
/** @type {import('.')} */ var tryStringObject = function tryStringObject(value) {
    try {
        $strValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
};
/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $toString = callBound('Object.prototype.toString');
var strClass = '[object String]';
var hasToStringTag = require("dc253d94c90af370")();
/** @type {import('.')} */ module.exports = function isString(value) {
    if (typeof value === 'string') return true;
    if (!value || typeof value !== 'object') return false;
    return hasToStringTag ? tryStringObject(value) : $toString(value) === strClass;
};

},{"7797830052e17b97":"dhWMF","dc253d94c90af370":"daNF4"}],"am0Uk":[function(require,module,exports,__globalThis) {
'use strict';
/** @const */ var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;
var exported;
if (!$Map) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isMap(x) {
    // `Map` is not present in this environment.
    return false;
};
var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$mapHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isMap(x) {
    // `Map` does not have a `has` method
    return false;
};
/** @type {import('.')} */ module.exports = exported || function isMap(x) {
    if (!x || typeof x !== 'object') return false;
    try {
        $mapHas.call(x);
        if ($setHas) try {
            $setHas.call(x);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $Map is always truthy here
        return x instanceof $Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

},{}],"7bJVF":[function(require,module,exports,__globalThis) {
'use strict';
var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;
var exported;
if (!$Set) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isSet(x) {
    // `Set` is not present in this environment.
    return false;
};
var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$setHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isSet(x) {
    // `Set` does not have a `has` method
    return false;
};
/** @type {import('.')} */ module.exports = exported || function isSet(x) {
    if (!x || typeof x !== 'object') return false;
    try {
        $setHas.call(x);
        if ($mapHas) try {
            $mapHas.call(x);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $Set is always truthy here
        return x instanceof $Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

},{}],"41SFz":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("7a0bb7df335a6af");
var callBind = require("794ce1103c4a65ba");
var implementation = require("f52a71fcf365d3bd");
var getPolyfill = require("59addbaef079e040");
var shim = require("c0e8b0f7342ba484");
var polyfill = callBind(getPolyfill(), Object);
define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = polyfill;

},{"7a0bb7df335a6af":"iXqnd","794ce1103c4a65ba":"hMR6y","f52a71fcf365d3bd":"kxFs1","59addbaef079e040":"gpUkX","c0e8b0f7342ba484":"235ds"}],"kxFs1":[function(require,module,exports,__globalThis) {
'use strict';
var numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if (numberIsNaN(a) && numberIsNaN(b)) return true;
    return false;
};

},{}],"gpUkX":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("ff80ab827617d6fd");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : implementation;
};

},{"ff80ab827617d6fd":"kxFs1"}],"235ds":[function(require,module,exports,__globalThis) {
'use strict';
var getPolyfill = require("f188d636391a5061");
var define = require("155865cffc557cd");
module.exports = function shimObjectIs() {
    var polyfill = getPolyfill();
    define(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

},{"f188d636391a5061":"gpUkX","155865cffc557cd":"iXqnd"}],"1NQhl":[function(require,module,exports,__globalThis) {
'use strict';
var callBind = require("a30b9eee5dc55b4b");
var callBound = require("ad05cf87a5483492");
var GetIntrinsic = require("2e6ed2d884c5409");
var $ArrayBuffer = GetIntrinsic('%ArrayBuffer%', true);
/** @type {undefined | ((receiver: ArrayBuffer) => number) | ((receiver: unknown) => never)} */ var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);
var $toString = callBound('Object.prototype.toString');
// in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method
var abSlice = !!$ArrayBuffer && !$byteLength && new $ArrayBuffer(0).slice;
var $abSlice = !!abSlice && callBind(abSlice);
/** @type {import('.')} */ module.exports = $byteLength || $abSlice ? function isArrayBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    try {
        if ($byteLength) // @ts-expect-error no idea why TS can't handle the overload
        $byteLength(obj);
        else // @ts-expect-error TS chooses not to type-narrow inside a closure
        $abSlice(obj, 0);
        return true;
    } catch (e) {
        return false;
    }
} : $ArrayBuffer ? function isArrayBuffer(obj) {
    return $toString(obj) === '[object ArrayBuffer]';
} : function isArrayBuffer(obj) {
    return false;
};

},{"a30b9eee5dc55b4b":"hMR6y","ad05cf87a5483492":"dhWMF","2e6ed2d884c5409":"dRNto"}],"3HCJv":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("f7aa53f619d004c5");
var getDay = callBound('Date.prototype.getDay');
/** @type {import('.')} */ var tryDateObject = function tryDateGetDayCall(value) {
    try {
        getDay(value);
        return true;
    } catch (e) {
        return false;
    }
};
/** @type {(value: unknown) => string} */ var toStr = callBound('Object.prototype.toString');
var dateClass = '[object Date]';
var hasToStringTag = require("a0fda07f3b6c493a")();
/** @type {import('.')} */ module.exports = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) return false;
    return hasToStringTag ? tryDateObject(value) : toStr(value) === dateClass;
};

},{"f7aa53f619d004c5":"dhWMF","a0fda07f3b6c493a":"daNF4"}],"YNqlw":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("e8ae6fb50d24c345");
var hasToStringTag = require("a5e890a505b039e5")();
var hasOwn = require("a7c11bfda61a32f");
var gOPD = require("2ad64b17b65049b4");
/** @type {import('.')} */ var fn;
if (hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $exec = callBound('RegExp.prototype.exec');
    /** @type {object} */ var isRegexMarker = {};
    var throwRegexMarker = function() {
        throw isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var badStringifier = {
        toString: throwRegexMarker,
        valueOf: throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') badStringifier[Symbol.toPrimitive] = throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ gOPD(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $exec(value, /** @type {unknown} */ badStringifier);
        } catch (e) {
            return e === isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $toString = callBound('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var regexClass = '[object RegExp]';
    /** @type {import('.')} */ fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $toString(value) === regexClass;
    };
}
module.exports = fn;

},{"e8ae6fb50d24c345":"dhWMF","a5e890a505b039e5":"daNF4","a7c11bfda61a32f":"aZ5G0","2ad64b17b65049b4":"iyLmA"}],"j2S4e":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("2c2e7f091c1af1ff");
/** @type {undefined | ((thisArg: SharedArrayBuffer) => number)} */ var $byteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);
/** @type {import('.')} */ module.exports = $byteLength ? function isSharedArrayBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    try {
        // @ts-expect-error TS can't figure out this closed-over variable is non-nullable, and it's fine that `obj` might not be a SAB
        $byteLength(obj);
        return true;
    } catch (e) {
        return false;
    }
} : function isSharedArrayBuffer(_obj) {
    return false;
};

},{"2c2e7f091c1af1ff":"dhWMF"}],"aQ0uQ":[function(require,module,exports,__globalThis) {
'use strict';
var isString = require("11d3feda75cd5852");
var isNumber = require("a2d99dd0b4e7e2f");
var isBoolean = require("276e2da6a047a0b8");
var isSymbol = require("d5677c34fc7072a0");
var isBigInt = require("56526aa18a4172fb");
/** @type {import('.')} */ // eslint-disable-next-line consistent-return
module.exports = function whichBoxedPrimitive(value) {
    // eslint-disable-next-line eqeqeq
    if (value == null || typeof value !== 'object' && typeof value !== 'function') return null;
    if (isString(value)) return 'String';
    if (isNumber(value)) return 'Number';
    if (isBoolean(value)) return 'Boolean';
    if (isSymbol(value)) return 'Symbol';
    if (isBigInt(value)) return 'BigInt';
};

},{"11d3feda75cd5852":"255bA","a2d99dd0b4e7e2f":"jBd23","276e2da6a047a0b8":"49jIB","d5677c34fc7072a0":"ionHf","56526aa18a4172fb":"im61Q"}],"jBd23":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("686514a1546e2e02");
var $numToStr = callBound('Number.prototype.toString');
/** @type {import('.')} */ var tryNumberObject = function tryNumberObject(value) {
    try {
        $numToStr(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $toString = callBound('Object.prototype.toString');
var numClass = '[object Number]';
var hasToStringTag = require("6c3ebb022928d133")();
/** @type {import('.')} */ module.exports = function isNumberObject(value) {
    if (typeof value === 'number') return true;
    if (!value || typeof value !== 'object') return false;
    return hasToStringTag ? tryNumberObject(value) : $toString(value) === numClass;
};

},{"686514a1546e2e02":"dhWMF","6c3ebb022928d133":"daNF4"}],"49jIB":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("726d7551e5ce9bc6");
var $boolToStr = callBound('Boolean.prototype.toString');
var $toString = callBound('Object.prototype.toString');
/** @type {import('.')} */ var tryBooleanObject = function booleanBrandCheck(value) {
    try {
        $boolToStr(value);
        return true;
    } catch (e) {
        return false;
    }
};
var boolClass = '[object Boolean]';
var hasToStringTag = require("c7e31dd187752fb0")();
/** @type {import('.')} */ module.exports = function isBoolean(value) {
    if (typeof value === 'boolean') return true;
    if (value === null || typeof value !== 'object') return false;
    return hasToStringTag && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString(value) === boolClass;
};

},{"726d7551e5ce9bc6":"dhWMF","c7e31dd187752fb0":"daNF4"}],"ionHf":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("ff444bb3649385a8");
var $toString = callBound('Object.prototype.toString');
var hasSymbols = require("19da2b43c74a37a0")();
var safeRegexTest = require("d20208420ab81532");
if (hasSymbols) {
    var $symToStr = callBound('Symbol.prototype.toString');
    var isSymString = safeRegexTest(/^Symbol\(.*\)$/);
    /** @type {(value: object) => value is Symbol} */ var isSymbolObject = function isRealSymbolObject(value) {
        if (typeof value.valueOf() !== 'symbol') return false;
        return isSymString($symToStr(value));
    };
    /** @type {import('.')} */ module.exports = function isSymbol(value) {
        if (typeof value === 'symbol') return true;
        if (!value || typeof value !== 'object' || $toString(value) !== '[object Symbol]') return false;
        try {
            return isSymbolObject(value);
        } catch (e) {
            return false;
        }
    };
} else /** @type {import('.')} */ module.exports = function isSymbol(value) {
    // this environment does not support Symbols.
    return false;
};

},{"ff444bb3649385a8":"dhWMF","19da2b43c74a37a0":"9IzVf","d20208420ab81532":"joaPu"}],"joaPu":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("39b5e226f465bdc3");
var isRegex = require("a52af5ff2805a373");
var $exec = callBound('RegExp.prototype.exec');
var $TypeError = require("e0ef9e92c1444ab0");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!isRegex(regex)) throw new $TypeError('`regex` must be a RegExp');
    return function test(s) {
        return $exec(regex, s) !== null;
    };
};

},{"39b5e226f465bdc3":"dhWMF","a52af5ff2805a373":"YNqlw","e0ef9e92c1444ab0":"4FiSx"}],"im61Q":[function(require,module,exports,__globalThis) {
'use strict';
var hasBigInts = require("5d154ac48fe82ab8")();
if (hasBigInts) {
    var bigIntValueOf = BigInt.prototype.valueOf;
    /** @type {(value: object) => value is BigInt} */ var tryBigInt = function tryBigIntObject(value) {
        try {
            bigIntValueOf.call(value);
            return true;
        } catch (e) {}
        return false;
    };
    /** @type {import('.')} */ module.exports = function isBigInt(value) {
        if (value === null || typeof value === 'undefined' || typeof value === 'boolean' || typeof value === 'string' || typeof value === 'number' || typeof value === 'symbol' || typeof value === 'function') return false;
        if (typeof value === 'bigint') return true;
        return tryBigInt(value);
    };
} else /** @type {import('.')} */ module.exports = function isBigInt(value) {
    return false;
};

},{"5d154ac48fe82ab8":"49X5K"}],"49X5K":[function(require,module,exports,__globalThis) {
'use strict';
var $BigInt = typeof BigInt !== 'undefined' && BigInt;
/** @type {import('.')} */ module.exports = function hasNativeBigInts() {
    return typeof $BigInt === 'function' && typeof BigInt === 'function' && typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
     && typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};

},{}],"4mQYw":[function(require,module,exports,__globalThis) {
'use strict';
var isMap = require("d4cc45a59360005a");
var isSet = require("4af25f4aa4b77a83");
var isWeakMap = require("d0ab6821281ca1fa");
var isWeakSet = require("d25c2dcce56d3a64");
/** @type {import('.')} */ module.exports = function whichCollection(/** @type {unknown} */ value) {
    if (value && typeof value === 'object') {
        if (isMap(value)) return 'Map';
        if (isSet(value)) return 'Set';
        if (isWeakMap(value)) return 'WeakMap';
        if (isWeakSet(value)) return 'WeakSet';
    }
    return false;
};

},{"d4cc45a59360005a":"am0Uk","4af25f4aa4b77a83":"7bJVF","d0ab6821281ca1fa":"2k9Gd","d25c2dcce56d3a64":"kBoZG"}],"2k9Gd":[function(require,module,exports,__globalThis) {
'use strict';
var $WeakMap = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
var $WeakSet = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;
var exported;
if (!$WeakMap) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isWeakMap(x) {
    // `WeakMap` is not present in this environment.
    return false;
};
var $mapHas = $WeakMap ? $WeakMap.prototype.has : null;
var $setHas = $WeakSet ? $WeakSet.prototype.has : null;
if (!exported && !$mapHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isWeakMap(x) {
    // `WeakMap` does not have a `has` method
    return false;
};
/** @type {import('.')} */ module.exports = exported || function isWeakMap(x) {
    if (!x || typeof x !== 'object') return false;
    try {
        $mapHas.call(x, $mapHas);
        if ($setHas) try {
            $setHas.call(x, $setHas);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $WeakMap is always truthy here
        return x instanceof $WeakMap; // core-js workaround, pre-v3
    } catch (e) {}
    return false;
};

},{}],"kBoZG":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("5468f65dce743940");
var callBound = require("c711b1eed95ae4d4");
var $WeakSet = GetIntrinsic('%WeakSet%', true);
/** @type {undefined | (<V>(thisArg: Set<V>, value: V) => boolean)} */ var $setHas = callBound('WeakSet.prototype.has', true);
if ($setHas) {
    /** @type {undefined | (<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean)} */ var $mapHas = callBound('WeakMap.prototype.has', true);
    /** @type {import('.')} */ module.exports = function isWeakSet(x) {
        if (!x || typeof x !== 'object') return false;
        try {
            // @ts-expect-error TS can't figure out that $setHas is always truthy here
            $setHas(x, $setHas);
            if ($mapHas) try {
                // @ts-expect-error this indeed might not be a weak collection
                $mapHas(x, $mapHas);
            } catch (e) {
                return true;
            }
            // @ts-expect-error TS can't figure out that $WeakSet is always truthy here
            return x instanceof $WeakSet; // core-js workaround, pre-v3
        } catch (e) {}
        return false;
    };
} else /** @type {import('.')} */ // @ts-expect-error
module.exports = function isWeakSet(x) {
    // `WeakSet` does not exist, or does not have a `has` method
    return false;
};

},{"5468f65dce743940":"dRNto","c711b1eed95ae4d4":"dhWMF"}],"rQv5T":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var forEach = require("2941d48f36957e3c");
var availableTypedArrays = require("beaf5502a5823cce");
var callBind = require("e5d203a1b4c809f9");
var callBound = require("c1f328b1ef67e936");
var gOPD = require("ce6b45c571ba4e3e");
/** @type {(O: object) => string} */ var $toString = callBound('Object.prototype.toString');
var hasToStringTag = require("9e7ef6c88184c56")();
var g = typeof globalThis === 'undefined' ? global : globalThis;
var typedArrays = availableTypedArrays();
var $slice = callBound('String.prototype.slice');
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var cache = {
    __proto__: null
};
if (hasToStringTag && gOPD && getPrototypeOf) forEach(typedArrays, function(typedArray) {
    var arr = new g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = gOPD(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = gOPD(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        cache['$' + typedArray] = callBind(descriptor.get);
    }
});
else forEach(typedArrays, function(typedArray) {
    var arr = new g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    cache['$' + typedArray] = callBind(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    forEach(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ('$' + getter(value) === typedArray) found = $slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    forEach(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!hasToStringTag) {
        /** @type {string} */ var tag = $slice($toString(value), 8, -1);
        if ($indexOf(typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return trySlices(value);
    }
    if (!gOPD) return null;
     // unknown engine
    return tryTypedArrays(value);
};

},{"2941d48f36957e3c":"eq62e","beaf5502a5823cce":"jzp1M","e5d203a1b4c809f9":"hMR6y","c1f328b1ef67e936":"dhWMF","ce6b45c571ba4e3e":"iyLmA","9e7ef6c88184c56":"daNF4"}],"eq62e":[function(require,module,exports,__globalThis) {
'use strict';
var isCallable = require("e50ebc24bbb25feb");
var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if (hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if (hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if (toStr.call(list) === '[object Array]') forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') forEachString(list, iterator, receiver);
    else forEachObject(list, iterator, receiver);
};
module.exports = forEach;

},{"e50ebc24bbb25feb":"3iOA5"}],"3iOA5":[function(require,module,exports,__globalThis) {
'use strict';
var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw isCallableMarker;
        }
    });
    isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    reflectApply(function() {
        throw 42;
    }, null, badArrayLike);
} catch (_) {
    if (_ !== isCallableMarker) reflectApply = null;
}
else reflectApply = null;
var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = fnToStr.call(value);
        return constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if (isES6ClassFn(value)) return false;
        fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var all = document.all;
    if (toStr.call(all) === toStr.call(document.all)) isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = toStr.call(value);
            return (str === ddaClass || str === ddaClass2 || str === ddaClass3 // opera 12.16
             || str === objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = reflectApply ? function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        reflectApply(value, null, badArrayLike);
    } catch (e) {
        if (e !== isCallableMarker) return false;
    }
    return !isES6ClassFn(value) && tryFunctionObject(value);
} : function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if (hasToStringTag) return tryFunctionObject(value);
    if (isES6ClassFn(value)) return false;
    var strClass = toStr.call(value);
    if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) return false;
    return tryFunctionObject(value);
};

},{}],"jzp1M":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var possibleNames = require("3021d1584ad62785");
var g = typeof globalThis === 'undefined' ? global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < possibleNames.length; i++)if (typeof g[possibleNames[i]] === 'function') // @ts-expect-error
    out[out.length] = possibleNames[i];
    return out;
};

},{"3021d1584ad62785":"dBrCY"}],"dBrCY":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

},{}],"dM108":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("a0464b2f7ada73c1");
var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);
var isArrayBuffer = require("6382a20b4706fa1a");
/** @type {import('.')} */ module.exports = function byteLength(ab) {
    if (!isArrayBuffer(ab)) return NaN;
    return $byteLength ? $byteLength(ab) : ab.byteLength;
}; // in node < 0.11, byteLength is an own nonconfigurable property

},{"a0464b2f7ada73c1":"dhWMF","6382a20b4706fa1a":"1NQhl"}],"dfKJq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
class EditSettingsItemDocumentDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            logo_position: props.item.logo_position,
            print_final_text: props.item.print_final_text,
            print_final_text_de: props.item.print_final_text_de,
            print_final_text_en: props.item.print_final_text_en,
            print_final_text_pos: props.item.print_final_text_pos,
            print_qr_pay_code: props.item.print_qr_pay_code
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "edit-settings-item-dialog document",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: 'Uredi nastavitev | ' + this.props.title
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY + ' flex flex-col',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col items-stretch",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "mr-2",
                                            children: "Logo poravnan na levo:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: this.state.logo_position == 'left',
                                            onChange: (event)=>{
                                                this.setState({
                                                    logo_position: event.target.checked ? 'left' : 'right'
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ml-4 mr-2",
                                            children: "Prika\u017Ei QR Skeniraj & Pla\u010Daj"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: this.state.print_qr_pay_code,
                                            onChange: (event)=>{
                                                this.setState({
                                                    print_qr_pay_code: event.target.checked
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Tabs), {
                                    className: "mt-2 pt-2 border-t border-gray-500",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                            id: "sl",
                                            title: "Sloven\u0161\u010Dina",
                                            panel: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                className: "edit-settings-item-dialog-document-value",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Zaklju\u010Dni tekst",
                                                        tooltip: "Zaklju\u010Dni tekst"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                        style: {
                                                            height: 270
                                                        },
                                                        growVertically: false,
                                                        large: true,
                                                        fill: true,
                                                        intent: (0, _core.Intent).PRIMARY,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                print_final_text: event.target.value
                                                            });
                                                        },
                                                        value: this.state.print_final_text
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                            id: "en",
                                            title: "Angle\u0161\u010Dina",
                                            panel: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                className: "edit-settings-item-dialog-document-value",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Zaklju\u010Dni tekst",
                                                        tooltip: "Zaklju\u010Dni tekst"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                        style: {
                                                            height: 270
                                                        },
                                                        growVertically: false,
                                                        large: true,
                                                        fill: true,
                                                        intent: (0, _core.Intent).PRIMARY,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                print_final_text_en: event.target.value
                                                            });
                                                        },
                                                        value: this.state.print_final_text_en
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                            id: "de",
                                            title: "Nem\u0161\u010Dina",
                                            panel: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                className: "edit-settings-item-dialog-document-value",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Zaklju\u010Dni tekst",
                                                        tooltip: "Zaklju\u010Dni tekst"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                        style: {
                                                            height: 270
                                                        },
                                                        growVertically: false,
                                                        large: true,
                                                        fill: true,
                                                        intent: (0, _core.Intent).PRIMARY,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                print_final_text_de: event.target.value
                                                            });
                                                        },
                                                        value: this.state.print_final_text_de
                                                    })
                                                ]
                                            })
                                        }),
                                        this.props.display_pos && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                            id: "pos",
                                            title: "POS",
                                            panel: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                className: "edit-settings-item-dialog-document-value",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Zaklju\u010Dni tekst",
                                                        tooltip: "Zaklju\u010Dni tekst"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                        growVertically: false,
                                                        large: true,
                                                        fill: true,
                                                        intent: (0, _core.Intent).PRIMARY,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                print_final_text_pos: event.target.value
                                                            });
                                                        },
                                                        value: this.state.print_final_text_pos
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Prekli\u010Di"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>{
                                        this.props.closeDialog({
                                            ...this.props.item,
                                            logo_position: this.state.logo_position,
                                            print_final_text: this.state.print_final_text,
                                            print_final_text_de: this.state.print_final_text_de,
                                            print_final_text_en: this.state.print_final_text_en,
                                            print_final_text_pos: this.state.print_final_text_pos,
                                            print_qr_pay_code: this.state.print_qr_pay_code
                                        });
                                    },
                                    children: "Shrani in zapri"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
EditSettingsItemDocumentDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    item: (0, _propTypesDefault.default).object
};
exports.default = EditSettingsItemDocumentDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","../TextWithTooltip":"6kuHH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"10r98":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _settingsSlice = require("../../slices/SettingsSlice");
var _settings = require("../../api/Settings");
var _localStorageHelper = require("../../helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
var _resultComponents = require("../code_tables/ResultComponents");
var _editSettingsItemDialog = require("./EditSettingsItemDialog");
var _editSettingsItemDialogDefault = parcelHelpers.interopDefault(_editSettingsItemDialog);
var _editSettingsItemFileDialog = require("./EditSettingsItemFileDialog");
var _editSettingsItemFileDialogDefault = parcelHelpers.interopDefault(_editSettingsItemFileDialog);
var _editSettingsItemSwitchDialog = require("./EditSettingsItemSwitchDialog");
var _editSettingsItemSwitchDialogDefault = parcelHelpers.interopDefault(_editSettingsItemSwitchDialog);
var _editSettingsItemNumberDialog = require("./EditSettingsItemNumberDialog");
var _editSettingsItemNumberDialogDefault = parcelHelpers.interopDefault(_editSettingsItemNumberDialog);
var _editSettingsItemDropdownDialog = require("./EditSettingsItemDropdownDialog");
var _editSettingsItemDropdownDialogDefault = parcelHelpers.interopDefault(_editSettingsItemDropdownDialog);
var _editSettingsItemMultilineDialog = require("./EditSettingsItemMultilineDialog");
var _editSettingsItemMultilineDialogDefault = parcelHelpers.interopDefault(_editSettingsItemMultilineDialog);
var _editSettingsItemPrinterWidthDialog = require("./EditSettingsItemPrinterWidthDialog");
var _editSettingsItemPrinterWidthDialogDefault = parcelHelpers.interopDefault(_editSettingsItemPrinterWidthDialog);
const AutoPrintTypes = {
    'none': 'Ne tiskaj',
    'a4': 'A4',
    'pos': 'POS'
};
function Results(props) {
    const { item, openEditSettingsItemDialog, subject_types, user } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table mt-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: "Razno"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "Nastavitev"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 3,
                        title: "Vrednost"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    [
                        {
                            key: 'dsc_allow_editing_after_day_count',
                            title: "Evidenca/DOC \u0161t. dni za urejanje",
                            value: item['dsc_allow_editing_after_day_count']
                        }
                    ].map((property)=>{
                        let key = property.key;
                        let value = property.value;
                        let type = 'general';
                        let new_item = item;
                        let extra = {};
                        if (key == 'dsc_allow_editing_after_day_count') {
                            new_item[key] = value;
                            extra.comment = "Pomen vrednosti: -1 je brez omejitev, 0 popolnoma prepre\u010Di urejanje, 1 pomeni 'danes', 2 pomeni 'danes' in 'v\u010Deraj', itd";
                            type = 'number';
                        }
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 1,
                                    child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        icon: "edit",
                                        intent: "primary",
                                        minimal: true,
                                        small: true,
                                        onClick: ()=>{
                                            openEditSettingsItemDialog(type, new_item, key, extra);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 2,
                                    child: property.title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                    columnIdx: 3,
                                    child: value
                                })
                            ]
                        }, 'settings-result--property-' + key);
                    }),
                    props.client == 'sr' && [
                        'admin'
                    ].indexOf(user.username) == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1,
                                child: null
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2,
                                child: 'Prikaz vseh podatkov'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: ((0, _jsCookieDefault.default).get('force_retention_years') ?? '') != '',
                                    onChange: (event)=>{
                                        (0, _jsCookieDefault.default).set('force_retention_years', event.target.checked ? 100 : '');
                                        document.location.reload();
                                    }
                                })
                            })
                        ]
                    })
                ]
            }, 'settings-result-1')
        ]
    });
}
class ParameterSettings extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.openEditSettingsItemDialog = this.openEditSettingsItemDialog.bind(this);
        this.closeEditSettingsItemDialog = this.closeEditSettingsItemDialog.bind(this);
        const { item } = this.updateTableItemsFromProps(props);
        this.state = {
            item,
            edit_settings_item_dialog_open: false,
            edit_settings_item_dialog_item: null,
            edit_settings_item_dialog_property_key: null,
            edit_settings_item_dialog_extra: null
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.general_settings != this.state.item) this.setState(this.updateTableItemsFromProps(this.props));
    }
    updateTableItemsFromProps(props) {
        return {
            item: props.general_settings
        };
    }
    openEditSettingsItemDialog(type, item, property_key, extra) {
        this.setState({
            edit_settings_item_dialog_open: true,
            edit_settings_item_dialog_type: type,
            edit_settings_item_dialog_item: item,
            edit_settings_item_dialog_property_key: property_key,
            edit_settings_item_dialog_extra: extra ?? {}
        });
    }
    async closeEditSettingsItemDialog(item, property_key, new_value) {
        this.setState({
            edit_settings_item_dialog_open: false,
            edit_settings_item_dialog_type: null,
            edit_settings_item_dialog_item: null,
            edit_settings_item_dialog_property_key: null,
            edit_settings_item_dialog_extra: null
        });
        if (item !== undefined) {
            let new_item = {
                ...item
            };
            new_item[property_key] = new_value;
            this.props.dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
            const dispatch = this.props.dispatch;
            const token = this.props.token;
            new_item = await (0, _settings.saveGeneralSettings)(this.props.api_url, new_item, token);
            if (new_item !== null) dispatch((0, _settingsSlice.setGeneralSettings)(new_item));
        }
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('settings--parameters') === -1) return null;
        let edit_settings_dialog = null;
        if (this.state.edit_settings_item_dialog_open) {
            if (this.state.edit_settings_item_dialog_type == 'dropdown') {
                let options = [];
                if (this.state.edit_settings_item_dialog_property_key == 'pos_printer_name') options = printers;
                else if (this.state.edit_settings_item_dialog_property_key == 'label_printer_name') options = label_printers;
                else if (this.state.edit_settings_item_dialog_property_key == 'auto_print_type') options = AutoPrintTypes;
                edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemDropdownDialogDefault.default), {
                    item: this.state.edit_settings_item_dialog_item,
                    property_key: this.state.edit_settings_item_dialog_property_key,
                    extra: this.state.edit_settings_item_dialog_extra,
                    closeDialog: this.closeEditSettingsItemDialog,
                    options: options
                });
            } else if (this.state.edit_settings_item_dialog_type == 'file') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemFileDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else if (this.state.edit_settings_item_dialog_type == 'multiline') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemMultilineDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else if (this.state.edit_settings_item_dialog_type == 'bool') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemSwitchDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else if (this.state.edit_settings_item_dialog_type == 'printer_width') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemPrinterWidthDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else if (this.state.edit_settings_item_dialog_type == 'number') edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemNumberDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
            else edit_settings_dialog = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSettingsItemDialogDefault.default), {
                item: this.state.edit_settings_item_dialog_item,
                property_key: this.state.edit_settings_item_dialog_property_key,
                extra: this.state.edit_settings_item_dialog_extra,
                closeDialog: this.closeEditSettingsItemDialog
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                edit_settings_dialog,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex flex-col flex-grow general-settings-list",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1 pl-4 pr-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-grow overflow-y-auto",
                            style: {
                                flexBasis: '0'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                item: this.state.item,
                                openEditSettingsItemDialog: this.openEditSettingsItemDialog,
                                client: this.props.client,
                                user: this.props.user
                            })
                        })
                    })
                })
            ]
        });
    }
}
ParameterSettings.propTypes = {};
function mapStateToProps(state) {
    return {
        general_settings: state.SettingsSlice.general,
        api_url: state.SettingsSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        printers: state.AppSlice.printers,
        label_printers: state.AppSlice.label_printers,
        client: state.ConstantsSlice.client
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ParameterSettings);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","js-cookie":"2d7Fe","../../slices/SettingsSlice":"ajHkF","../../api/Settings":"51MNf","../../helpers/LocalStorageHelper":"9I9tm","../code_tables/ResultComponents":"1eVlZ","./EditSettingsItemDialog":"3zOCG","./EditSettingsItemFileDialog":"bySUH","./EditSettingsItemSwitchDialog":"4SKSx","./EditSettingsItemNumberDialog":"9uFcm","./EditSettingsItemDropdownDialog":"3XDWw","./EditSettingsItemMultilineDialog":"c8mQ1","./EditSettingsItemPrinterWidthDialog":"2Bi8M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jW4K8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _cashRegisterSlice = require("../../slices/CashRegisterSlice");
var _cashRegisters = require("../../api/CashRegisters");
var _addJournalDialog = require("./AddJournalDialog");
var _addJournalDialogDefault = parcelHelpers.interopDefault(_addJournalDialog);
var _appToaster = require("../AppToaster");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _utils = require("../../utils");
var _resultComponents = require("../code_tables/ResultComponents");
var _appSlice = require("../../slices/AppSlice");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged, openAddEditItemDialog, tableItemsFilters, originalTableItemsFilters, handleFilterChange, deleteItem, cash_registers, users, allow_delete_ids, cash_register_documents, user } = props;
    const users_with_titles = {};
    for(let id_user in users)users_with_titles[id_user] = {
        id_user,
        title: users[id_user].name + ' ' + users[id_user].surname
    };
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    const sums = {
        income: 0,
        expense: 0,
        cash_expense_amount: 0
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-scroll sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: check_count > 0,
                                indeterminate: !all_checked && check_count > 0,
                                onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 2,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 3,
                            title: "\u0160tevilka dnevnika"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 4,
                            title: "Datum"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 5,
                            title: "Blagajnik"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 6,
                            title: "Blagajna"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 7,
                            cls: "text-right",
                            title: "Za\u010Detni saldo"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 8,
                            cls: "text-right",
                            title: "Prejemki"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 9,
                            cls: "text-right",
                            title: "Izdatki"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 10,
                            cls: "text-right",
                            title: "Gotovina (izdatek)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 11,
                            cls: "text-right",
                            title: "Kon\u010Dni saldo"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.document_number,
                                onChange: (event)=>handleFilterChange('document_number', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.document_date_range,
                                original_start_date: originalTableItemsFilters.document_date_range[0],
                                original_end_date: originalTableItemsFilters.document_date_range[1],
                                onFilterChange: (values)=>handleFilterChange('document_date_range', values)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_user",
                                    title_field: "title",
                                    items: users_with_titles,
                                    filtered_keys: tableItemsFilters.id_users,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('id_users', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_cash_register",
                                    title_field: "title",
                                    items: Object.keys(cash_registers).filter((id_cash_register)=>user.id_cash_registers.includes(id_cash_register)).reduce((obj, key)=>{
                                        obj[key] = cash_registers[key];
                                        return obj;
                                    }, {}),
                                    filtered_keys: tableItemsFilters.id_cash_registers,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('id_cash_registers', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "filters-col"
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            const cash_id_payment_type = '2db820c7-a652-4f9e-8c93-7e1b09d399d5'; //TODO perhaps move this somewhere else?
                            let cash_expense_amount = 0;
                            if (item.expense_id_cash_register_document !== null) {
                                const expense_cash_register_document = cash_register_documents[item.expense_id_cash_register_document];
                                if (expense_cash_register_document !== undefined) for(let i = 0; i < (expense_cash_register_document.payment_types || []).length; i++){
                                    const doc_payment_type = expense_cash_register_document.payment_types[i];
                                    if (doc_payment_type.id_payment_type == cash_id_payment_type) cash_expense_amount += parseFloat(doc_payment_type.amount);
                                }
                            }
                            sums.income += parseFloat(item.income);
                            sums.expense += parseFloat(item.expense);
                            sums.cash_expense_amount += parseFloat(cash_expense_amount);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: table_items_checked_ids[id] === true,
                                            onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "search",
                                                    intent: "primary",
                                                    minimal: true,
                                                    small: true,
                                                    onClick: ()=>openAddEditItemDialog(item)
                                                }),
                                                allow_delete_ids.indexOf(item.id_cash_register_daily_state) === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "trash",
                                                    intent: "danger",
                                                    minimal: true,
                                                    small: true,
                                                    onClick: ()=>{
                                                        deleteItem(id);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        child: item.document_number
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        child: (0, _momentDefault.default)(item.document_date).format('DD. MM. YYYY')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        child: users[item.id_user].name + ' ' + users[item.id_user].surname
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        child: cash_registers[item.id_cash_register].title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        cls: "text-right",
                                        child: parseFloat(item.start_balance).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        cls: "text-right",
                                        child: parseFloat(item.income).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        cls: "text-right",
                                        child: parseFloat(item.expense).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 10,
                                        cls: "text-right",
                                        child: parseFloat(cash_expense_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 11,
                                        cls: "text-right",
                                        child: parseFloat(item.end_balance).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    })
                                ]
                            }, 'result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-sum pb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 1,
                        span: 6,
                        child: "\u0160tevilo zapisov: " + table_items_sort_ids.length
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 7,
                        cls: "text-right font-bold",
                        child: ''
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 8,
                        cls: "text-right font-bold",
                        child: sums.income.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 9,
                        cls: "text-right font-bold",
                        child: sums.expense.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 10,
                        cls: "text-right font-bold",
                        child: sums.cash_expense_amount.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                        columnIdx: 11,
                        cls: "text-right font-bold",
                        child: ''
                    })
                ]
            })
        ]
    });
}
class Journals extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.requestDeleteItem = this.requestDeleteItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.findLastCashRegisterDailyStates = this.findLastCashRegisterDailyStates.bind(this);
        this.printA4 = this.printA4.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.openSummaryPrintDialog = this.openSummaryPrintDialog.bind(this);
        this.closeSummaryPrintDialog = this.closeSummaryPrintDialog.bind(this);
        this.getMomentFormatter = this.getMomentFormatter.bind(this);
        this.openCashRegisterStateDialog = this.openCashRegisterStateDialog.bind(this);
        this.closeCashRegisterStateDialog = this.closeCashRegisterStateDialog.bind(this);
        this.printState = this.printState.bind(this);
        this.exportStateToExcel = this.exportStateToExcel.bind(this);
        const table_items_filters = {
            document_number: '',
            document_date_range: [
                (0, _momentDefault.default)().subtract(1, 'month').toDate(),
                null
            ],
            id_users: [],
            id_cash_registers: props.current_id_cash_register === null || props.current_id_cash_register == 0 ? [] : [
                props.current_id_cash_register
            ]
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'document_date',
            table_items_sort_direction: 'DESC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'document_date',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            table_items_checked_ids: {},
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_id_cash_register: null,
            add_edit_item_dialog_date: null,
            add_edit_item_dialog_start_balance: 0,
            add_edit_item_dialog_documents: [],
            add_edit_item_dialog_item: null,
            delete_request_id_item: null,
            summary_print_dialog_open: false,
            summary_print_dialog_date_start: null,
            summary_print_dialog_date_end: null,
            summary_print_dialog_display_detailed_list: false,
            summary_print_dialog_one_page: false,
            cash_register_state_dialog_open: false,
            cash_register_state_dialog_id_cash_register: null,
            cash_register_state_dialog_start_date: null,
            cash_register_state_dialog_end_date: null,
            cash_register_state_dialog_start_balance: null,
            cash_register_state_dialog_documents: []
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.users != prevProps.users || this.props.cash_registers != prevProps.cash_registers || this.props.cash_register_daily_states != prevProps.cash_register_daily_states) {
            const state = this.updateTableItemsFromProps(this.props, this.state);
            this.setState(state);
        }
    }
    updateTableItemsFromProps(props, state) {
        const ids = Object.keys(props.cash_register_daily_states);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            invoices: props.invoices,
            table_items: props.cash_register_daily_states,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            a = state.table_items[a_key][field];
            b = state.table_items[b_key][field];
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_document_number = filters.document_number;
        const filters_document_date_start = filters.document_date_range[0] === null ? null : (0, _momentDefault.default)(filters.document_date_range[0]).format('YYYY-MM-DD');
        const filters_document_date_end = filters.document_date_range[1] === null ? null : (0, _momentDefault.default)(filters.document_date_range[1]).format('YYYY-MM-DD');
        const filters_id_users = filters.id_users;
        let filters_id_cash_registers = filters.id_cash_registers.filter((x)=>this.props.user.id_cash_registers.indexOf(x) != -1);
        if (filters_id_cash_registers.length == 0) filters_id_cash_registers = this.props.user.id_cash_registers;
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['cash-register--journals'] ?? 0);
        const filter_data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days').toISOString(true);
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_document_number != '' && item.document_number.indexOf(filters_document_number) == -1) return false;
            if (filter_data_retention_date_start !== null && item.document_date !== null && item.document_date <= filter_data_retention_date_start) return false;
            if (filters_document_date_start !== null && item.document_date !== null && item.document_date < filters_document_date_start) return false;
            if (filters_document_date_end !== null && item.document_date !== null && item.document_date > filters_document_date_end) return false;
            if (filters_id_users.length > 0) {
                if (item.id_user === null || filters_id_users.indexOf(item.id_user) == -1) return false;
            }
            if (filters_id_cash_registers.length > 0) {
                if (item.id_cash_register === null || filters_id_cash_registers.indexOf(item.id_cash_register) == -1) return false;
            }
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            document_number: this.state.table_items_filters.document_number,
            document_date_range: this.state.table_items_filters.document_date_range,
            id_users: this.state.table_items_filters.id_users,
            id_cash_registers: this.state.table_items_filters.id_cash_registers
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        if (this.props.current_id_cash_register === null || this.props.current_id_cash_register == 0) //TODO display message
        return;
        if (item !== null && item !== undefined) {
            this.setState({
                add_edit_item_dialog_open: true,
                add_edit_item_dialog_id_cash_register: item.id_cash_register,
                add_edit_item_dialog_date: item.document_date,
                add_edit_item_dialog_start_balance: item.start_balance,
                add_edit_item_dialog_documents: Object.values(this.props.cash_register_documents).filter((x)=>x.id_cash_register_daily_state === item.id_cash_register_daily_state),
                add_edit_item_dialog_item: item
            });
            return;
        }
        // find latest daily state (for start balance)
        let last_daily_state = null;
        const sorted = Object.keys(this.props.cash_register_daily_states).filter((x)=>this.props.cash_register_daily_states[x].id_cash_register == this.props.current_id_cash_register).map((x)=>{
            return {
                id_cash_register_daily_state: x,
                document_date: this.props.cash_register_daily_states[x].document_date
            };
        }).sort((a, b)=>a.document_date < b.document_date ? 1 : a.document_date > b.document_date ? -1 : 0);
        if (sorted.length > 0) last_daily_state = this.props.cash_register_daily_states[sorted[0].id_cash_register_daily_state];
        // only use documents for currently selected cash register
        const filtered_ids = Object.keys(this.props.cash_register_documents).filter((x)=>{
            if (this.props.current_id_cash_register == this.props.cash_register_documents[x].id_cash_register) return true;
            return false;
        });
        // group document dates
        const available_documents_by_date = {};
        for(let i = 0; i < filtered_ids.length; i++){
            const item = this.props.cash_register_documents[filtered_ids[i]];
            if (item !== undefined && item.id_cash_register_daily_state !== null) continue;
            if (available_documents_by_date[item.document_date] === undefined) available_documents_by_date[item.document_date] = [];
            available_documents_by_date[item.document_date].push(item);
        }
        // find min document date
        const document_dates = Object.keys(available_documents_by_date);
        let min_document_date = null;
        for(let i = 0; i < document_dates.length; i++)if (min_document_date === null || document_dates[i] < min_document_date) min_document_date = document_dates[i];
        let selected_documents = [];
        if (min_document_date !== null) selected_documents = available_documents_by_date[min_document_date];
        if (min_document_date === null) min_document_date = (0, _momentDefault.default)().format('YYYY-MM-DD');
        const last_cash_register_daily_states = this.findLastCashRegisterDailyStates();
        if (Object.values(last_cash_register_daily_states).find((x)=>this.props.cash_register_daily_states[x.id_cash_register_daily_state].document_date == min_document_date && x.id_cash_register == this.props.current_id_cash_register) !== undefined) {
            (0, _appToaster.AppToaster).show({
                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Blagajni\u0161ki dnevnik za dan ",
                        (0, _momentDefault.default)(min_document_date).format('DD. MM. YYYY'),
                        " je bil \u017Ee zaklju\u010Den.",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "\u010Ce \u017Eelite ponovno zaklju\u010Diti blagajni\u0161ki dnevnik, je potrebno \u017Ee zaklju\u010Den blagajni\u0161ki dnevnik najprej stornirati."
                    ]
                }),
                intent: 'warning',
                icon: 'issue'
            });
            return;
        }
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_id_cash_register: this.props.current_id_cash_register,
            add_edit_item_dialog_date: min_document_date,
            add_edit_item_dialog_start_balance: last_daily_state === null ? 0 : last_daily_state.end_balance === undefined ? 0 : last_daily_state.end_balance,
            add_edit_item_dialog_documents: selected_documents,
            add_edit_item_dialog_item: null
        });
    }
    async closeAddEditItemDialog(document_date, income, expense, start_balance, cash_expense_amount, end_balance, id_cash_register) {
        if (document_date === undefined) {
            this.setState({
                add_edit_item_dialog_open: false
            });
            return;
        }
        const item = {
            id_cash_register_daily_state: (0, _uuidDefault.default).v4(),
            document_number: null,
            document_date,
            income,
            expense,
            start_balance,
            end_balance,
            id_cash_register,
            id_user: this.props.user.id_user
        };
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        this.props.dispatch((0, _cashRegisterSlice.addCashRegisterDailyState)(item));
        let new_item = await (0, _cashRegisters.saveCashRegisterDailyState)(this.props.api_url, item, token);
        if (new_item !== null) {
            dispatch((0, _cashRegisterSlice.addCashRegisterDailyState)(new_item));
            const expense_doc = await (0, _cashRegisters.saveCashRegisterDocument)(this.props.api_url, {
                id_cash_register_document: (0, _uuidDefault.default).v4(),
                id_user: this.props.user.id_user,
                id_customer: null,
                customer_id_country: null,
                customer_type: null,
                customer_address: null,
                customer_birth_date: null,
                customer_company_long_name: null,
                customer_company_name: null,
                customer_email: null,
                customer_name: null,
                customer_surname: null,
                customer_phone: null,
                customer_post_code: null,
                customer_post_office: null,
                customer_sex: null,
                customer_tax_number: null,
                customer_vat_prefix: null,
                customer_vat_registered: null,
                type: 'expense',
                document_number: null,
                reference: new_item.document_number,
                document_date: new_item.document_date,
                note: '',
                status: 'new',
                id_cash_register_daily_state: new_item.id_cash_register_daily_state,
                id_cash_register,
                manual: false
            }, token);
            new_item = {
                ...new_item,
                expense_id_cash_register_document: expense_doc.id_cash_register_document
            };
            await (0, _cashRegisters.saveCashRegisterDailyState)(this.props.api_url, new_item, token);
            dispatch((0, _cashRegisterSlice.addCashRegisterDailyState)(new_item));
            const cash_id_payment_type = '2db820c7-a652-4f9e-8c93-7e1b09d399d5'; //TODO perhaps move this somewhere else?
            let sums_by_payment_types = {};
            sums_by_payment_types[cash_id_payment_type] = {
                income: 0,
                expense: cash_expense_amount
            };
            for(let i = 0; i < this.state.add_edit_item_dialog_documents.length; i++){
                // update original document
                const doc = {
                    ...this.state.add_edit_item_dialog_documents[i]
                };
                doc.id_cash_register_daily_state = new_item.id_cash_register_daily_state;
                await (0, _cashRegisters.saveCashRegisterDocument)(this.props.api_url, doc, token);
                if (doc.payment_types !== null && doc.payment_types !== undefined) for(let j = 0; j < doc.payment_types.length; j++){
                    const doc_payment_type = doc.payment_types[j];
                    if (sums_by_payment_types[doc_payment_type.id_payment_type] === undefined) sums_by_payment_types[doc_payment_type.id_payment_type] = {
                        income: 0,
                        expense: 0
                    };
                    if (doc_payment_type.id_payment_type == cash_id_payment_type) ;
                    else {
                        sums_by_payment_types[doc_payment_type.id_payment_type].income += doc_payment_type.amount;
                        sums_by_payment_types[doc_payment_type.id_payment_type].expense += doc_payment_type.amount;
                    }
                }
            }
            for(let id_payment_type in sums_by_payment_types){
                if (sums_by_payment_types[id_payment_type].expense == 0) continue;
                await (0, _cashRegisters.saveCashRegisterDocumentPaymentType)(this.props.api_url, {
                    id_cash_register_document_payment_type: (0, _uuidDefault.default).v4(),
                    id_cash_register_document: expense_doc.id_cash_register_document,
                    id_payment_type: id_payment_type,
                    note: '',
                    amount: sums_by_payment_types[id_payment_type].expense,
                    full_amount: sums_by_payment_types[id_payment_type].expense,
                    id_tax_rate: null,
                    tax_rate: null
                }, token);
            }
            (0, _cashRegisters.loadCashRegisterDocuments)(this.props.api_url, dispatch, token);
        }
        this.setState({
            add_edit_item_dialog_open: false
        });
    }
    requestDeleteItem(id_item) {
        this.setState({
            delete_request_id_item: id_item
        });
    }
    async deleteItem(id_item) {
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        await (0, _cashRegisters.deleteCashRegisterDailyState)(this.props.api_url, id_item, token);
        dispatch((0, _cashRegisterSlice.deleteCashRegisterDailyState)(id_item));
        await (0, _cashRegisters.loadCashRegisterDailyStates)(this.props.api_url, dispatch, token);
        await (0, _cashRegisters.loadCashRegisterDocuments)(this.props.api_url, dispatch, token);
    }
    findLastCashRegisterDailyStates() {
        const last_cash_register_daily_states = {};
        for(let id_cash_register_daily_state in this.state.table_items){
            const item = this.state.table_items[id_cash_register_daily_state];
            const year = (0, _momentDefault.default)(item.document_date).format('YYYY');
            const id_cash_register = item.id_cash_register;
            const key = year + '-' + id_cash_register;
            if (last_cash_register_daily_states[key] === undefined || last_cash_register_daily_states[key].document_date < item.document_date) last_cash_register_daily_states[key] = {
                id_cash_register_daily_state: item.id_cash_register_daily_state,
                document_date: item.document_date,
                id_cash_register
            };
        }
        return last_cash_register_daily_states;
    }
    printA4(lang) {
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        const ids = check_count == 0 ? this.state.table_items_sort_ids : this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        for(let i = 0; i < ids.length; i++){
            const item = this.state.table_items[ids[i]];
            this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                type: 'journal',
                lang,
                item,
                id_cash_register: item.id_cash_register
            }));
        }
    }
    exportToExcel(lang) {
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        const ids = check_count == 0 ? this.state.table_items_sort_ids : this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        const params = [];
        const data = {
            id_cash_register_daily_states: ids.join(','),
            lang,
            display_detailed_list: 'true',
            is_summary: 'false',
            one_page: 'false',
            id_cash_register: this.props.current_id_cash_register
        };
        const form = document.createElement('form');
        form.target = '_blank';
        form.method = 'POST';
        form.action = this.props.api_url + 'CashRegisters/v1/journal-export-excel?' + params.join('&');
        form.style.display = 'none';
        for(let key in data){
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
    openSummaryPrintDialog() {
        this.setState({
            summary_print_dialog_open: true,
            summary_print_dialog_date_start: null,
            summary_print_dialog_date_end: null
        });
    }
    closeSummaryPrintDialog(start_date, end_date, display_detailed_list, one_page, type) {
        this.setState({
            summary_print_dialog_open: false
        });
        if (start_date === null || end_date === null) return;
        const start_date_iso = (0, _momentDefault.default)(start_date).format('YYYY-MM-DD');
        const end_date_iso = (0, _momentDefault.default)(end_date).format('YYYY-MM-DD');
        const items = Object.keys(this.state.table_items).filter((id_cash_register_daily_state)=>{
            const item = this.state.table_items[id_cash_register_daily_state];
            return this.props.current_id_cash_register == item.id_cash_register && item.document_date >= start_date_iso && item.document_date <= end_date_iso;
        }).map((id_cash_register_daily_state)=>this.state.table_items[id_cash_register_daily_state]);
        if (type == 'pdf') this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
            type: 'journal-summary',
            lang: 'sl',
            items,
            display_detailed_list,
            one_page,
            id_cash_register: this.props.current_id_cash_register
        }));
        else if (type == 'excel') {
            const ids = items.map((x)=>x.id_cash_register_daily_state);
            const params = [];
            const data = {
                id_cash_register_daily_states: ids.join(','),
                lang: 'sl',
                display_detailed_list: display_detailed_list ? 'true' : 'false',
                is_summary: 'true',
                one_page: one_page ? 'true' : 'false',
                id_cash_register: this.props.current_id_cash_register
            };
            const form = document.createElement('form');
            form.target = '_blank';
            form.method = 'POST';
            form.action = this.props.api_url + 'CashRegisters/v1/journal-export-excel?' + params.join('&');
            form.style.display = 'none';
            for(let key in data){
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = data[key];
                form.appendChild(input);
            }
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        }
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    openCashRegisterStateDialog() {
        if (this.props.current_id_cash_register === null || this.props.current_id_cash_register == 0) //TODO display message
        return;
        // find latest daily state (for start balance)
        let last_daily_state = null;
        const sorted = Object.keys(this.props.cash_register_daily_states).filter((x)=>this.props.cash_register_daily_states[x].id_cash_register == this.props.current_id_cash_register).map((x)=>{
            return {
                id_cash_register_daily_state: x,
                document_date: this.props.cash_register_daily_states[x].document_date
            };
        }).sort((a, b)=>a.document_date < b.document_date ? 1 : a.document_date > b.document_date ? -1 : 0);
        if (sorted.length > 0) last_daily_state = this.props.cash_register_daily_states[sorted[0].id_cash_register_daily_state];
        // only use documents for currently selected cash register
        const filtered_ids = Object.keys(this.props.cash_register_documents).filter((x)=>{
            if (this.props.current_id_cash_register == this.props.cash_register_documents[x].id_cash_register) return true;
            return false;
        });
        // find available documents
        let min_document_date = null;
        let max_document_date = null;
        const selected_documents = [];
        for(let i = 0; i < filtered_ids.length; i++){
            const item = this.props.cash_register_documents[filtered_ids[i]];
            if (item !== undefined && item.id_cash_register_daily_state !== null) continue;
            selected_documents.push(item);
            if (min_document_date === null || item.document_date < min_document_date) min_document_date = item.document_date;
            if (max_document_date === null || item.document_date > max_document_date) max_document_date = item.document_date;
        }
        if (selected_documents.length == 0) //TODO show warning
        return;
        this.setState({
            cash_register_state_dialog_open: true,
            cash_register_state_dialog_id_cash_register: this.props.current_id_cash_register,
            cash_register_state_dialog_start_date: min_document_date,
            cash_register_state_dialog_end_date: max_document_date,
            cash_register_state_dialog_start_balance: last_daily_state === null ? 0 : last_daily_state.end_balance === undefined ? 0 : last_daily_state.end_balance,
            cash_register_state_dialog_documents: selected_documents
        });
    }
    closeCashRegisterStateDialog() {
        this.setState({
            cash_register_state_dialog_open: false
        });
    }
    printState() {
        const ids = this.state.cash_register_state_dialog_documents.map((x)=>x.id_cash_register_document);
        this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
            type: 'journal-state',
            lang: 'sl',
            ids,
            id_cash_register: this.props.current_id_cash_register
        }));
    }
    exportStateToExcel() {
        const ids = this.state.cash_register_state_dialog_documents.map((x)=>x.id_cash_register_document);
        const params = [];
        const data = {
            id_cash_register_documents: ids.join(','),
            lang: 'sl',
            display_detailed_list: 'true',
            is_summary: 'true',
            one_page: 'true',
            id_cash_register: this.props.current_id_cash_register
        };
        const form = document.createElement('form');
        form.target = '_blank';
        form.method = 'POST';
        form.action = this.props.api_url + 'CashRegisters/v1/journal-state-export-excel?' + params.join('&');
        form.style.display = 'none';
        for(let key in data){
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('cash-register--journals') === -1) return null;
        // find last daily states for each year/cash register, since those should be the only ones deletable
        const last_cash_register_daily_states = this.findLastCashRegisterDailyStates();
        const last_cash_register_daily_state_ids = Object.values(last_cash_register_daily_states).map((x)=>x.id_cash_register_daily_state).filter((x)=>{
            if (this.props.current_id_cash_register === null || this.props.current_id_cash_register == 0) return true;
            if (this.props.current_id_cash_register == this.state.table_items[x].id_cash_register) return true;
            return false;
        });
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['cash-register--journals'] ?? 0);
        const data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days');
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addJournalDialogDefault.default), {
                    closeDialog: this.closeAddEditItemDialog,
                    id_cash_register: this.state.add_edit_item_dialog_id_cash_register,
                    date: [
                        this.state.add_edit_item_dialog_date
                    ],
                    start_balance: this.state.add_edit_item_dialog_start_balance,
                    documents: this.state.add_edit_item_dialog_documents,
                    item: this.state.add_edit_item_dialog_item,
                    readonly: this.state.add_edit_item_dialog_item !== null,
                    is_state: false,
                    printState: this.printState,
                    exportStateToExcel: this.exportStateToExcel
                }),
                !this.state.cash_register_state_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addJournalDialogDefault.default), {
                    closeDialog: this.closeCashRegisterStateDialog,
                    id_cash_register: this.state.cash_register_state_dialog_id_cash_register,
                    date: [
                        this.state.cash_register_state_dialog_start_date,
                        this.state.cash_register_state_dialog_end_date
                    ],
                    start_balance: this.state.cash_register_state_dialog_start_balance,
                    documents: this.state.cash_register_state_dialog_documents,
                    item: null,
                    readonly: true,
                    is_state: true,
                    printState: this.printState,
                    exportStateToExcel: this.exportStateToExcel
                }),
                this.state.delete_request_id_item === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Storniraj",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.deleteItem(this.state.delete_request_id_item);
                        this.setState({
                            delete_request_id_item: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            delete_request_id_item: null
                        });
                    },
                    children: "Stornirali boste blagajni\u0161ki dnevnik \u0161t. " + this.props.cash_register_daily_states[this.state.delete_request_id_item].document_number
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: this.state.summary_print_dialog_open,
                    onClose: this.closeSummaryPrintDialog,
                    className: "summary-print-dialog",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                fixedToTop: false,
                                className: "bp5-dark",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: "Izberi obdobje"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        align: (0, _core.Alignment).RIGHT,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: this.closeSummaryPrintDialog
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_BODY,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                label: "Izberi obdobje",
                                                tooltip: "Izberi obdobje"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateRangeInput3), {
                                                dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                dateFnsFormat: 'dd. MM. yyyy',
                                                locale: "sl",
                                                allowSingleDayRange: true,
                                                contiguousCalendarMonths: false,
                                                shortcuts: false,
                                                startInputProps: {
                                                    placeholder: 'Od',
                                                    className: 'from-until'
                                                },
                                                endInputProps: {
                                                    placeholder: 'Do',
                                                    className: 'from-until'
                                                },
                                                minDate: data_retention_date_start === null ? new Date('1900-01-01') : data_retention_date_start.toDate(),
                                                maxDate: new Date('2100-01-01'),
                                                selectAllOnFocus: true,
                                                onChange: (selectedRange)=>{
                                                    this.setState({
                                                        summary_print_dialog_date_start: selectedRange[0] === null ? null : selectedRange[0],
                                                        summary_print_dialog_date_end: selectedRange[1] === null ? null : selectedRange[1]
                                                    });
                                                },
                                                value: [
                                                    this.state.summary_print_dialog_date_start,
                                                    this.state.summary_print_dialog_date_end
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                        className: "mr-2",
                                        label: "Prika\u017Ei podrobni seznam dokumentov",
                                        checked: this.state.summary_print_dialog_display_detailed_list,
                                        onChange: (event)=>this.setState({
                                                summary_print_dialog_display_detailed_list: event.target.checked
                                            })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                        className: "mr-2",
                                        label: "Izpi\u0161i bl. dnevnike v izbranem obdobju v eno datoteko",
                                        checked: this.state.summary_print_dialog_one_page,
                                        onChange: (event)=>this.setState({
                                                summary_print_dialog_one_page: event.target.checked
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            onClick: this.closeSummaryPrintDialog,
                                            children: "Prekli\u010Di"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.closeSummaryPrintDialog(this.state.summary_print_dialog_date_start, this.state.summary_print_dialog_date_end, this.state.summary_print_dialog_display_detailed_list, this.state.summary_print_dialog_one_page, 'excel'),
                                            children: "Izvozi v Excel"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.closeSummaryPrintDialog(this.state.summary_print_dialog_date_start, this.state.summary_print_dialog_date_end, this.state.summary_print_dialog_display_detailed_list, this.state.summary_print_dialog_one_page, 'pdf'),
                                            children: "Natisni"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow base-list journal-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    className: "align-middle",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "success",
                                        icon: "plus",
                                        disabled: this.props.current_id_cash_register == 0,
                                        onClick: ()=>this.openAddEditItemDialog(),
                                        children: "Zaklju\u010Di dnevnik"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "print",
                                            disabled: check_count == 0,
                                            onClick: ()=>this.printA4('sl'),
                                            children: "Natisni"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "cloud-download",
                                            disabled: check_count == 0,
                                            onClick: ()=>this.exportToExcel('sl'),
                                            children: "Izvozi v Excel"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        icon: "print",
                                        disabled: this.props.current_id_cash_register === null || this.props.current_id_cash_register == 0,
                                        onClick: ()=>this.openSummaryPrintDialog(),
                                        children: "Zbirni dnevnik"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "warning",
                                        icon: "th",
                                        disabled: this.props.current_id_cash_register === null || this.props.current_id_cash_register == 0,
                                        onClick: ()=>this.openCashRegisterStateDialog(),
                                        children: "Stanje blagajne"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.requestDeleteItem,
                                    cash_registers: this.props.cash_registers,
                                    users: this.props.users,
                                    allow_delete_ids: last_cash_register_daily_state_ids,
                                    cash_register_documents: this.props.cash_register_documents,
                                    user: this.props.user
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
Journals.propTypes = {};
function mapStateToProps(state) {
    return {
        api_url: state.CashRegisterSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        users: state.UserSlice.users,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        cash_registers: state.CashRegisterSlice.cash_registers,
        cash_register_daily_states: state.CashRegisterSlice.cash_register_daily_states,
        cash_register_documents: state.CashRegisterSlice.cash_register_documents
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Journals);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","uuid":"b52pV","moment":"1e4qG","date-fns/formatISO":"an1FA","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","../../slices/CashRegisterSlice":"1FTf7","../../api/CashRegisters":"ixrrZ","./AddJournalDialog":"tysaY","../AppToaster":"izixN","../TextWithTooltip":"6kuHH","../../utils":"kh8Vf","../code_tables/ResultComponents":"1eVlZ","../../slices/AppSlice":"aByTQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"tysaY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
var _numbers = require("../../numbers");
var _resultComponents = require("../code_tables/ResultComponents");
function FormTextInput(props) {
    const { fieldName, title, tooltip, value, changeValue, className, disabled } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
        labelFor: 'add-edit-item-dialog--' + fieldName,
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                label: title,
                tooltip: tooltip
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                id: 'add-edit-item-dialog--' + fieldName,
                value: value,
                disabled: disabled,
                onChange: (event)=>changeValue(event.target.value)
            })
        ]
    });
}
const typeTitles = {
    income: 'Prejemek',
    expense: 'Izdatek'
};
class AddJournalDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        const cash_id_payment_type = '2db820c7-a652-4f9e-8c93-7e1b09d399d5'; //TODO perhaps move this somewhere else?
        let expense_cash_register_document = null;
        let sums_by_payment_types = {};
        for(let i = 0; i < props.documents.length; i++){
            const document = props.documents[i];
            if (props.item !== null && document.id_cash_register_document == props.item.expense_id_cash_register_document) expense_cash_register_document = document;
            if (document.payment_types !== null && document.payment_types !== undefined) for(let j = 0; j < document.payment_types.length; j++){
                const doc_payment_type = document.payment_types[j];
                if (sums_by_payment_types[doc_payment_type.id_payment_type] === undefined) sums_by_payment_types[doc_payment_type.id_payment_type] = {
                    income: 0,
                    expense: 0
                };
                if (doc_payment_type.id_payment_type == cash_id_payment_type) {
                    if (props.item !== null && document.id_cash_register_document == props.item.expense_id_cash_register_document) ;
                    else sums_by_payment_types[doc_payment_type.id_payment_type][document.type] += doc_payment_type.amount;
                } else if (props.item !== null) sums_by_payment_types[doc_payment_type.id_payment_type][document.type] += doc_payment_type.amount;
                else {
                    sums_by_payment_types[doc_payment_type.id_payment_type].income += doc_payment_type.amount;
                    sums_by_payment_types[doc_payment_type.id_payment_type].expense += doc_payment_type.amount;
                }
            }
        }
        // add cash if it's not present yet
        if (sums_by_payment_types[cash_id_payment_type] === undefined) sums_by_payment_types[cash_id_payment_type] = {
            income: 0,
            expense: 0
        };
        let cash_expense_amount = 0;
        if (props.item !== null) {
            if (expense_cash_register_document !== null) {
                let amount = 0;
                for(let i = 0; i < (expense_cash_register_document.payment_types || []).length; i++){
                    const doc_payment_type = expense_cash_register_document.payment_types[i];
                    if (doc_payment_type.id_payment_type == cash_id_payment_type) amount += doc_payment_type.amount;
                }
                cash_expense_amount = amount;
            }
        } else cash_expense_amount = Math.properRound(Math.max(0, sums_by_payment_types[cash_id_payment_type].income - sums_by_payment_types[cash_id_payment_type].expense + parseFloat(props.start_balance)), 2);
        this.state = {
            sums_by_payment_types,
            cash_expense_amount,
            cash_expense_amount_formatted: this.formatNumber(cash_expense_amount),
            saving: false
        };
        this.saving = false; // since setState is async, we use a local variable as well
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    render() {
        let income = 0;
        let expense = 0;
        let start_balance = parseFloat(this.props.start_balance);
        let end_balance = 0;
        for(let id_payment_type in this.state.sums_by_payment_types){
            income += this.state.sums_by_payment_types[id_payment_type].income;
            expense += this.state.sums_by_payment_types[id_payment_type].expense;
        }
        expense += this.state.cash_expense_amount;
        end_balance = Math.round((start_balance + income - expense) * 100) / 100;
        // get rid of -0
        if (end_balance == 0) end_balance = Math.abs(end_balance);
        if (this.props.item !== null) {
            income = parseFloat(this.props.item.income);
            expense = parseFloat(this.props.item.expense);
            start_balance = parseFloat(this.props.item.start_balance);
            end_balance = parseFloat(this.props.item.end_balance);
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "add-journal-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: this.props.is_state ? 'Stanje blagajne' : "Blagajni\u0161ki dnevnik"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY + ' flex flex-col',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col flex-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "font-bold mr-2",
                                            children: this.props.is_state ? 'Obdobje:' : 'Datum dnevnika:'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: (0, _momentDefault.default)(this.props.date[0]).format('DD. MM. YYYY') + (this.props.date.length < 2 ? '' : ' - ' + (0, _momentDefault.default)(this.props.date[1]).format('DD. MM. YYYY'))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex-1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "font-bold mr-2 ml-6",
                                            children: "Izbrana blagajna:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: this.props.cash_registers[this.props.id_cash_register].title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mt-4 flex flex-col flex-1 self-stretch",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "base-list add-journal-dialog-sums-list",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "results mt-4 mb-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "results-table overflow-y-auto sticky-header",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 1,
                                                            title: "Tip pla\u010Dila"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 2,
                                                            cls: "text-right",
                                                            title: "Prejemki"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 3,
                                                            cls: "text-right",
                                                            title: "Izdatki"
                                                        }),
                                                        Object.keys(this.state.sums_by_payment_types).sort((a, b)=>{
                                                            if (a == '2db820c7-a652-4f9e-8c93-7e1b09d399d5') return -1;
                                                            return 0;
                                                        }).map((id_payment_type)=>{
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 1,
                                                                        child: this.props.payment_types[id_payment_type].title
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 2,
                                                                        cls: "text-right",
                                                                        child: parseFloat(this.state.sums_by_payment_types[id_payment_type].income).toLocaleString(undefined, {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 3,
                                                                        cls: "text-right",
                                                                        child: parseFloat(this.state.sums_by_payment_types[id_payment_type].expense).toLocaleString(undefined, {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })
                                                                    })
                                                                ]
                                                            }, 'payment-type-' + id_payment_type);
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-row justify-end",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "add-journal-dialog-sums-field m-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-right",
                                                            children: "Skupaj prejemki"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "add-journal-dialog-sums-field-value text-right",
                                                            children: income.toLocaleString(undefined, {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "add-journal-dialog-sums-field m-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-right",
                                                            children: "Skupaj izdatki"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "add-journal-dialog-sums-field-value text-right",
                                                            children: expense.toLocaleString(undefined, {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-row justify-end",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "add-journal-dialog-sums-field m-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-right",
                                                            children: "Za\u010Detni saldo"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "add-journal-dialog-sums-field-value text-right",
                                                            children: start_balance.toLocaleString(undefined, {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })
                                                        })
                                                    ]
                                                }),
                                                !this.props.readonly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                    className: "m-1 vibrant",
                                                    fieldName: "cash",
                                                    title: "Gotovina (izdatek)",
                                                    tooltip: "Gotovina (izdatek)",
                                                    value: this.state.cash_expense_amount_formatted,
                                                    changeValue: (value)=>{
                                                        let val = (0, _numbers.parseFloatLocal)(value);
                                                        if (Object.is(val, NaN)) val = 0;
                                                        this.setState({
                                                            cash_expense_amount: val,
                                                            cash_expense_amount_formatted: value
                                                        });
                                                    }
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "add-journal-dialog-sums-field m-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-right",
                                                            children: "Gotovina (izdatek)"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "add-journal-dialog-sums-field-value text-right",
                                                            children: this.state.cash_expense_amount_formatted
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "add-journal-dialog-sums-field m-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-right",
                                                            children: "Kon\u010Dni saldo"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "add-journal-dialog-sums-field-value text-right",
                                                            children: end_balance.toLocaleString(undefined, {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "base-list add-journal-dialog-documents-list mt-12 flex-1 relative",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "results h-full relative",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "results-table overflow-y-auto sticky-header absolute max-h-full inset-x-0 top-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 1,
                                                            title: "Tip"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 2,
                                                            title: "Veza"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 3,
                                                            title: "Datum dokumenta"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 4,
                                                            title: "\u0160ifra stranke"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 5,
                                                            title: "Naziv stranke"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 6,
                                                            title: "Blagajnik"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 7,
                                                            title: "Na\u010Din pla\u010Dila"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 8,
                                                            cls: "text-right",
                                                            title: "Znesek"
                                                        }),
                                                        this.props.documents.sort((a, b)=>{
                                                            if (a.reference === null || b.reference === null) return 1;
                                                            if (a.reference < b.reference) return 1;
                                                            if (a.reference > b.reference) return -1;
                                                            return 0;
                                                        }).map((document)=>{
                                                            const customer = document.id_customer === null ? null : this.props.customers[document.id_customer] || null;
                                                            const user = this.props.users[document.id_user];
                                                            const amount = document.payment_types === null ? 0 : document.payment_types.reduce((acc, curr)=>acc + curr.amount, 0);
                                                            let cls = '';
                                                            if (document.type == 'expense') cls += 'font-bold';
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 1,
                                                                        cls: cls,
                                                                        child: typeTitles[document.type] || document.type
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 2,
                                                                        cls: cls,
                                                                        child: document.reference
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 3,
                                                                        cls: cls,
                                                                        child: (0, _momentDefault.default)(document.document_date).format('DD. MM. YYYY')
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 4,
                                                                        cls: cls,
                                                                        child: customer === null ? '' : customer.internal_code
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 5,
                                                                        cls: cls,
                                                                        child: customer === null ? '' : customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 6,
                                                                        cls: cls,
                                                                        child: user.name + ' ' + user.surname
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 7,
                                                                        cls: cls,
                                                                        child: document.payment_types === null ? '' : document.payment_types.map((x)=>x.id_payment_type).filter((value, index, self)=>{
                                                                            return self.indexOf(value) === index;
                                                                        }).map((x)=>this.props.payment_types[x].title).join(', ')
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 8,
                                                                        cls: cls + ' text-right',
                                                                        child: parseFloat(amount).toLocaleString(undefined, {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })
                                                                    })
                                                                ]
                                                            }, 'document-' + document.id_cash_register_document);
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: [
                                !this.props.is_state ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.props.printState(),
                                            children: "Natisni"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.props.exportStateToExcel(),
                                            children: "Izvozi v Excel"
                                        })
                                    ]
                                }),
                                this.props.readonly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Zapri"
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            onClick: ()=>this.props.closeDialog(),
                                            children: "Prekli\u010Di"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            disabled: this.state.saving,
                                            onClick: ()=>{
                                                if (this.saving) return;
                                                if (end_balance < 0) {
                                                    (0, _appToaster.AppToaster).show({
                                                        message: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            children: "Kon\u010Dni saldo ne sme biti manj\u0161i od 0"
                                                        }),
                                                        intent: 'danger',
                                                        icon: 'issue'
                                                    });
                                                    return;
                                                }
                                                if (this.props.documents.length == 0 && expense == 0) {
                                                    (0, _appToaster.AppToaster).show({
                                                        message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    children: "Blagajni\u0161ki dnevnik za dan " + (0, _momentDefault.default)(this.props.date[0]).format('DD. MM. YYYY') + " ni mogo\u010De zaklju\u010Diti."
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                "Zaklju\u010Duje se lahko samo blagajni\u0161ki dnevnik, na katerem so prikazani prejemki in/ali ro\u010Dni izdatki, oz. \u010De je znesek pri gotovinskem izdatku ve\u010Dji od 0."
                                                            ]
                                                        }),
                                                        intent: 'danger',
                                                        icon: 'issue'
                                                    });
                                                    return;
                                                }
                                                this.saving = true;
                                                this.setState({
                                                    saving: true
                                                });
                                                this.props.closeDialog(this.props.date[0], income, expense, start_balance, this.state.cash_expense_amount, end_balance, this.props.id_cash_register);
                                            },
                                            children: "Zaklju\u010Di"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddJournalDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    id_cash_register: (0, _propTypesDefault.default).string,
    date: (0, _propTypesDefault.default).string,
    documents: (0, _propTypesDefault.default).array
};
function mapStateToProps(state) {
    return {
        payment_types: state.CodeTablesSlice.payment_types,
        customers: state.CodeTablesSlice.customers,
        users: state.UserSlice.users,
        cash_registers: state.CashRegisterSlice.cash_registers
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddJournalDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","moment":"1e4qG","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","../../numbers":"jOh9w","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"livgl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _cashRegisters = require("../../api/CashRegisters");
var _addCashRegisterDocumentDialog = require("./AddCashRegisterDocumentDialog");
var _addCashRegisterDocumentDialogDefault = parcelHelpers.interopDefault(_addCashRegisterDocumentDialog);
var _resultComponents = require("../code_tables/ResultComponents");
var _appSlice = require("../../slices/AppSlice");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged, openAddEditItemDialog, tableItemsFilters, originalTableItemsFilters, handleFilterChange, deleteItem, cash_registers, users, payment_types, customers, allow_delete_ids, user } = props;
    const users_with_titles = {};
    for(let id_user in users)users_with_titles[id_user] = {
        id_user,
        title: users[id_user].name + ' ' + users[id_user].surname
    };
    const payment_types_with_titles = {};
    for(let id_payment_type in payment_types)payment_types_with_titles[id_payment_type] = {
        id_payment_type,
        title: payment_types[id_payment_type].title
    };
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-auto sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: check_count > 0,
                                indeterminate: !all_checked && check_count > 0,
                                onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 2,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 3,
                            title: "Tip"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 4,
                            title: "\u0160tevilka"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 5,
                            title: "\u0160t. dokumenta"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 6,
                            title: "Datum"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 7,
                            title: "\u0160ifra"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 8,
                            title: "Naziv stranke"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 9,
                            title: "Blagajna"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 10,
                            title: "Blagajnik"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 11,
                            title: "Na\u010Din pla\u010Dila"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 12,
                            cls: "text-right",
                            title: "Znesek"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "value",
                                    title_field: "title",
                                    items: {
                                        income: {
                                            value: 'income',
                                            title: 'Prejemek'
                                        },
                                        expense: {
                                            value: 'expense',
                                            title: 'Izdatek'
                                        }
                                    },
                                    filtered_keys: tableItemsFilters.types,
                                    onFilterChange: (values)=>handleFilterChange('types', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.document_number,
                                onChange: (event)=>handleFilterChange('document_number', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.reference,
                                onChange: (event)=>handleFilterChange('reference', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.document_date_range,
                                original_start_date: originalTableItemsFilters.document_date_range[0],
                                original_end_date: originalTableItemsFilters.document_date_range[1],
                                onFilterChange: (values)=>handleFilterChange('document_date_range', values)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_internal_code,
                                onChange: (event)=>handleFilterChange('customer_internal_code', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_name,
                                onChange: (event)=>handleFilterChange('customer_name', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_cash_register",
                                    title_field: "title",
                                    items: Object.keys(cash_registers).filter((id_cash_register)=>user.id_cash_registers.includes(id_cash_register)).reduce((obj, key)=>{
                                        obj[key] = cash_registers[key];
                                        return obj;
                                    }, {}),
                                    filtered_keys: tableItemsFilters.id_cash_registers,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('id_cash_registers', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_user",
                                    title_field: "title",
                                    items: users_with_titles,
                                    filtered_keys: tableItemsFilters.id_users,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('id_users', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_payment_type",
                                    title_field: "title",
                                    items: payment_types_with_titles,
                                    filtered_keys: tableItemsFilters.id_payment_types,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('id_payment_types', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 12,
                            cls: "filters-col"
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            const id_payment_types = [];
                            let amount = 0;
                            if (item.payment_types !== null && item.payment_types !== undefined) for(let i = 0; i < item.payment_types.length; i++){
                                const payment_type = item.payment_types[i];
                                if (id_payment_types.indexOf(payment_type.id_payment_type) == -1) id_payment_types.push(payment_type.id_payment_type);
                                amount += payment_type.amount;
                            }
                            const payment_type_titles = id_payment_types.map((id_payment_type)=>payment_types[id_payment_type].title);
                            const customer = item.id_customer === null ? null : customers[item.id_customer] || null;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: table_items_checked_ids[id] === true,
                                            onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "search",
                                                    intent: "primary",
                                                    minimal: true,
                                                    small: true,
                                                    onClick: ()=>openAddEditItemDialog(item)
                                                }),
                                                allow_delete_ids.indexOf(item.id_cash_register_daily_state) === -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    icon: "trash",
                                                    intent: "danger",
                                                    minimal: true,
                                                    small: true,
                                                    onClick: ()=>{
                                                        deleteItem(id);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        child: item.type == 'income' ? 'Prejemek' : 'Izdatek'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        child: item.document_number
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        child: item.reference
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        child: (0, _momentDefault.default)(item.document_date).format('DD. MM. YYYY')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        child: customer === null ? '' : customer.internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        child: customer === null ? '' : customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        child: cash_registers[item.id_cash_register].title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 10,
                                        child: users[item.id_user].name + ' ' + users[item.id_user].surname
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 11,
                                        child: payment_type_titles.join(', ')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 12,
                                        cls: "text-right font-bold",
                                        child: amount.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) + ' EUR'
                                    })
                                ]
                            }, 'result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-sum pb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col",
                        children: [
                            "\u0160tevilo zapisov: ",
                            table_items_sort_ids.length
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        children: table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            let amount = 0;
                            if (item.payment_types !== null && item.payment_types !== undefined) for(let i = 0; i < item.payment_types.length; i++){
                                const payment_type = item.payment_types[i];
                                amount += payment_type.amount;
                            }
                            return amount;
                        }).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) + ' EUR'
                    })
                ]
            })
        ]
    });
}
class CashRegisterDocuments extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.printA4 = this.printA4.bind(this);
        const table_items_filters = {
            types: [],
            document_number: '',
            reference: '',
            document_date_range: [
                (0, _momentDefault.default)().toDate(),
                (0, _momentDefault.default)().toDate()
            ],
            customer_internal_code: '',
            customer_name: '',
            id_cash_registers: props.current_id_cash_register === null || props.current_id_cash_register == 0 ? [] : [
                props.current_id_cash_register
            ],
            id_users: [],
            id_payment_types: []
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'document_number',
            table_items_sort_direction: 'DESC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'document_number',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            table_items_checked_ids: {},
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_type: '',
            add_edit_item_dialog_item: null
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    openAddEditItemDialog(item, type) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_type: type,
            add_edit_item_dialog_item: item
        });
    }
    async closeAddEditItemDialog(item) {
        if (item === null || item === undefined) {
            this.setState({
                add_edit_item_dialog_open: false
            });
            return;
        }
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        await (0, _cashRegisters.saveCashRegisterDocument)(this.props.api_url, item, token);
        for(let i = 0; i < item.payment_types.length; i++)await (0, _cashRegisters.saveCashRegisterDocumentPaymentType)(this.props.api_url, item.payment_types[i], token);
        (0, _cashRegisters.loadCashRegisterDocuments)(this.props.api_url, dispatch, token);
        this.setState({
            add_edit_item_dialog_open: false
        });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.users != prevProps.users || this.props.cash_registers != prevProps.cash_registers || this.props.cash_register_documents != prevProps.cash_register_documents) {
            const state = this.updateTableItemsFromProps(this.props, this.state);
            this.setState(state);
        }
    }
    updateTableItemsFromProps(props, state) {
        const ids = Object.keys(props.cash_register_documents);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            invoices: props.invoices,
            table_items: props.cash_register_documents,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            a = state.table_items[a_key][field];
            b = state.table_items[b_key][field];
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_types = filters.types;
        const filters_document_number = filters.document_number.toUpperCase();
        const filters_reference = filters.reference.toUpperCase();
        const filters_document_date_start = filters.document_date_range[0] === null ? null : (0, _momentDefault.default)(filters.document_date_range[0]).format('YYYY-MM-DD');
        const filters_document_date_end = filters.document_date_range[1] === null ? null : (0, _momentDefault.default)(filters.document_date_range[1]).format('YYYY-MM-DD');
        const filters_customer_internal_code = filters.customer_internal_code.toUpperCase();
        const filters_customer_name = filters.customer_name.toUpperCase();
        const filters_id_users = filters.id_users;
        const filters_id_payment_types = filters.id_payment_types;
        let filters_id_cash_registers = filters.id_cash_registers.filter((x)=>this.props.user.id_cash_registers.indexOf(x) != -1);
        if (filters_id_cash_registers.length == 0) filters_id_cash_registers = this.props.user.id_cash_registers;
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['cash-register--documents'] ?? 0);
        const filter_data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days').toISOString(true);
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_types.length > 0) {
                if (filters_types.indexOf(item.type) == -1) return false;
            }
            if (filters_document_number != '' && item.document_number.indexOf(filters_document_number) == -1) return false;
            if (filters_reference != '' && item.reference.indexOf(filters_reference) == -1) return false;
            if (filter_data_retention_date_start !== null && item.document_date !== null && item.document_date <= filter_data_retention_date_start) return false;
            if (filters_document_date_start !== null && item.document_date !== null && item.document_date < filters_document_date_start) return false;
            if (filters_document_date_end !== null && item.document_date !== null && item.document_date > filters_document_date_end) return false;
            if (filters_customer_internal_code != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || this.props.customers[item.id_customer].internal_code != filters_customer_internal_code)) return false;
            if (filters_customer_name != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || (this.props.customers[item.id_customer].surname + ' ' + this.props.customers[item.id_customer].name + ' ' + this.props.customers[item.id_customer].company_name).toUpperCase().indexOf(filters_customer_name) == -1)) return false;
            if (filters_id_cash_registers.length > 0) {
                if (item.id_cash_register === null || filters_id_cash_registers.indexOf(item.id_cash_register) == -1) return false;
            }
            if (filters_id_users.length > 0) {
                if (item.id_user === null || filters_id_users.indexOf(item.id_user) == -1) return false;
            }
            const id_payment_types = item.payment_types === null || item.payment_types === undefined ? [] : item.payment_types.map((x)=>x.id_payment_type);
            if (filters_id_payment_types.length > 0) {
                let found = false;
                for(let i = 0; i < filters_id_payment_types.length; i++)if (id_payment_types.indexOf(filters_id_payment_types[i]) > -1) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            types: this.state.table_items_filters.types,
            document_number: this.state.table_items_filters.document_number,
            reference: this.state.table_items_filters.reference,
            document_date_range: this.state.table_items_filters.document_date_range,
            customer_internal_code: this.state.table_items_filters.customer_internal_code,
            customer_name: this.state.table_items_filters.customer_name,
            id_cash_registers: this.state.table_items_filters.id_cash_registers,
            id_users: this.state.table_items_filters.id_users,
            id_payment_types: this.state.table_items_filters.id_payment_types
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    printA4(lang) {
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        const ids = check_count == 0 ? this.state.table_items_sort_ids : this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        for(let i = 0; i < ids.length; i++){
            const item = this.state.table_items[ids[i]];
            this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                type: 'cash-register-document',
                lang,
                item
            }));
        }
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('cash-register--documents') === -1) return null;
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addCashRegisterDocumentDialogDefault.default), {
                    closeDialog: this.closeAddEditItemDialog,
                    type: this.state.add_edit_item_dialog_type,
                    item: this.state.add_edit_item_dialog_item,
                    id_cash_register: this.props.current_id_cash_register,
                    user: this.props.user
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow base-list cash-register-documents-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "plus",
                                            disabled: this.props.current_id_cash_register == 0,
                                            onClick: ()=>this.openAddEditItemDialog(null, 'income'),
                                            children: "Nov prejemek"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            icon: "plus",
                                            disabled: this.props.current_id_cash_register == 0,
                                            onClick: ()=>this.openAddEditItemDialog(null, 'expense'),
                                            children: "Nov izdatek"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    className: "ml-2 align-middle",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        icon: "print",
                                        disabled: check_count == 0,
                                        onClick: ()=>this.printA4('sl'),
                                        children: "Natisni"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    deleteItem: this.requestDeleteItem,
                                    cash_registers: this.props.cash_registers,
                                    users: this.props.users,
                                    payment_types: this.props.payment_types,
                                    customers: this.props.customers,
                                    allow_delete_ids: [],
                                    user: this.props.user
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
CashRegisterDocuments.propTypes = {};
function mapStateToProps(state) {
    return {
        api_url: state.CashRegisterSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        users: state.UserSlice.users,
        customers: state.CodeTablesSlice.customers,
        payment_types: state.CodeTablesSlice.payment_types,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        cash_registers: state.CashRegisterSlice.cash_registers,
        cash_register_documents: state.CashRegisterSlice.cash_register_documents
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(CashRegisterDocuments);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","moment":"1e4qG","@blueprintjs/core":"6Mq52","../../api/CashRegisters":"ixrrZ","./AddCashRegisterDocumentDialog":"e5w5a","../code_tables/ResultComponents":"1eVlZ","../../slices/AppSlice":"aByTQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e5w5a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _appToaster = require("../AppToaster");
var _numbers = require("../../numbers");
var _customerSelect = require("../CustomerSelect");
var _customerSelectDefault = parcelHelpers.interopDefault(_customerSelect);
var _selectCustomerDialog = require("../reservations/SelectCustomerDialog");
var _selectCustomerDialogDefault = parcelHelpers.interopDefault(_selectCustomerDialog);
var _customerInfo = require("../business/CustomerInfo");
var _customerInfoDefault = parcelHelpers.interopDefault(_customerInfo);
var _utils = require("../../utils");
var _resultComponents = require("../code_tables/ResultComponents");
function FormTextInput(props) {
    const { fieldName, title, tooltip, value, changeValue, className, disabled } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
        labelFor: 'add-edit-item-dialog--' + fieldName,
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                label: title,
                tooltip: tooltip,
                className: "font-bold"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                id: 'add-edit-item-dialog--' + fieldName,
                className: "w-full",
                value: value,
                disabled: disabled,
                onChange: (event)=>changeValue(event.target.value)
            })
        ]
    });
}
function FormTextArea(props) {
    const { fieldName, title, tooltip, value, changeValue, className, disabled, growVertically, large } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
        labelFor: 'add-edit-item-dialog--' + fieldName,
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                label: title,
                tooltip: tooltip,
                className: "font-bold"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                id: 'add-edit-item-dialog--' + fieldName,
                className: "w-full",
                growVertically: growVertically,
                large: large,
                value: value,
                disabled: disabled,
                onChange: (event)=>changeValue(event.target.value)
            })
        ]
    });
}
function FormDateInput(props) {
    const { fieldName, title, tooltip, value, changeValue, className, disabled } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
        labelFor: 'add-edit-item-dialog--' + fieldName,
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                label: title,
                tooltip: tooltip,
                className: "font-bold"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                id: 'add-edit-item-dialog--' + fieldName,
                className: "w-full",
                dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                dateFnsFormat: 'dd. MM. yyyy',
                locale: "sl",
                inputProps: {
                    placeholder: '01. 01. ' + new Date().getFullYear()
                },
                selectAllOnFocus: true,
                minDate: new Date('1900-01-01'),
                maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                onChange: (selectedDate, isUserChange)=>{
                    if (isUserChange) changeValue(selectedDate === null ? null : new Date(selectedDate));
                },
                disabled: disabled,
                value: value === null ? null : (0, _formatISODefault.default)(value)
            })
        ]
    });
}
const typeTitles = {
    income: 'Prejemek',
    expense: 'Izdatek'
};
const typeTypeTitles = {
    'cash': 'Gotovina',
    'credit-card': 'Kartice',
    'bank-transfer': 'TRR',
    'gift-card': 'Bon',
    'other': 'Drugo'
};
class AddCashRegisterDocumentDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.openSelectCustomerDialog = this.openSelectCustomerDialog.bind(this);
        this.closeSelectCustomerDialog = this.closeSelectCustomerDialog.bind(this);
        const table_items = {};
        const payment_type_keys = Object.keys(props.payment_types);
        for(let i = 0; i < payment_type_keys.length; i++)table_items[payment_type_keys[i]] = {
            value: 0.0,
            formatted_value: 0.0.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }),
            note: ''
        };
        this.state = {
            table_items,
            document_date: new Date(),
            reference: '',
            note: '',
            id_customer: props.item === null ? null : this.props.item.id_customer,
            select_customer_dialog_open: false,
            select_customer_dialog_surname: '',
            select_customer_dialog_item: null
        };
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    openSelectCustomerDialog(query, item) {
        item = item || null;
        this.setState({
            select_customer_dialog_open: true,
            select_customer_dialog_surname: query,
            select_customer_dialog_item: item
        });
    }
    closeSelectCustomerDialog(id_customer, new_customer) {
        const state = {
            select_customer_dialog_open: false
        };
        /*if (id_customer !== undefined) {
			state.id_customer = id_customer;
			
			state.phone = new_customer.phone;
			state.email = new_customer.email;
		}*/ this.setState(state);
    }
    render() {
        const customer = this.state.id_customer === null ? null : this.props.customers[this.state.id_customer] || null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "add-cash-register-document-dialog",
            children: [
                !this.state.select_customer_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectCustomerDialogDefault.default), {
                    closeSelectCustomerDialog: this.closeSelectCustomerDialog,
                    surname: this.state.select_customer_dialog_surname,
                    item: this.state.select_customer_dialog_item
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                            fixedToTop: false,
                            className: "bp5-dark",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                        children: typeTitles[this.props.item !== null ? this.props.item.type : this.props.type]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                    align: (0, _core.Alignment).RIGHT,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        minimal: true,
                                        icon: "cross",
                                        onClick: ()=>this.props.closeDialog()
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_BODY + ' flex flex-col',
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-row flex-1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-col flex-1 mr-2",
                                        style: {
                                            flexBasis: '45%'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex flex-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex-1 flex-col",
                                                        style: {
                                                            flexBasis: '40%'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "mt-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "font-bold",
                                                                        children: "\u0160tevilka dokumenta"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: this.props.item === null ? 'nov dokument' : this.props.item.document_number
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "flex-1 mt-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "font-bold",
                                                                        children: "Blagajna"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: this.props.cash_registers[this.props.id_cash_register].title
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "flex-1 mt-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "font-bold",
                                                                        children: "Blagajnik"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: this.props.user.name + ' ' + this.props.user.surname
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex-1",
                                                        style: {
                                                            flexBasis: '60%'
                                                        },
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                                            className: "flex mt-1 mb-0",
                                                            children: this.props.item !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "font-bold",
                                                                        children: "Stranka"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerInfoDefault.default), {
                                                                        customer: customer,
                                                                        countries: this.props.countries
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerSelectDefault.default), {
                                                                        itemSelected: (item)=>{
                                                                            this.setState({
                                                                                id_customer: item.id_customer
                                                                            });
                                                                        },
                                                                        addPersonClick: (query)=>{
                                                                            this.openSelectCustomerDialog(query);
                                                                        },
                                                                        fieldTitle: "Stranka",
                                                                        titleClassName: "font-bold"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerInfoDefault.default), {
                                                                        customer: customer,
                                                                        countries: this.props.countries,
                                                                        editClick: ()=>{
                                                                            this.openSelectCustomerDialog('', customer);
                                                                        },
                                                                        clearClick: ()=>{
                                                                            this.setState({
                                                                                id_customer: null
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex flex-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex-1 mb-1 mt-3",
                                                        style: {
                                                            flexBasis: '40%'
                                                        },
                                                        children: this.props.item !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "font-bold",
                                                                    children: "Datum dokumenta"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    children: (0, _momentDefault.default)(this.props.item.document_date).format('DD. MM. YYYY')
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormDateInput, {
                                                            fieldName: "document_date",
                                                            title: "Datum dokumenta",
                                                            tooltip: "",
                                                            value: this.state.document_date,
                                                            changeValue: (value)=>{
                                                                this.setState({
                                                                    document_date: value
                                                                });
                                                            },
                                                            disabled: false
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex-1 mb-1 mt-3",
                                                        style: {
                                                            flexBasis: '60%'
                                                        },
                                                        children: this.props.item !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "font-bold",
                                                                    children: "Referenca"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    children: this.props.item.reference
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextInput, {
                                                            className: "vibrant",
                                                            fieldName: "cash",
                                                            title: "Veza",
                                                            tooltip: "",
                                                            value: this.state.reference,
                                                            changeValue: (value)=>{
                                                                this.setState({
                                                                    reference: value
                                                                });
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            this.props.item !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mt-1 mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "font-bold",
                                                        children: "Opomba"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "whitespace-pre",
                                                        children: this.props.item.note
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormTextArea, {
                                                className: "mt-1 mb-1 vibrant",
                                                fieldName: "cash",
                                                growVertically: true,
                                                large: true,
                                                title: "Opomba",
                                                tooltip: "",
                                                value: this.state.note,
                                                changeValue: (value)=>{
                                                    this.setState({
                                                        note: value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex flex-col flex-1",
                                        style: {
                                            flexBasis: '55%'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "base-list add-cash-register-document-dialog-payment-type-list flex-1 relative",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "results",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "results-table",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 1,
                                                            title: "Na\u010Din pla\u010Dila"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 2,
                                                            title: "Tip pla\u010Dila"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 3,
                                                            cls: "text-right",
                                                            title: "Znesek"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                                            columnIdx: 4,
                                                            title: "Opis"
                                                        }),
                                                        this.props.item !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                                            children: this.props.item.payment_types.map((payment_type_item)=>{
                                                                const payment_type = this.props.payment_types[payment_type_item.id_payment_type];
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                            columnIdx: 1,
                                                                            child: payment_type.title
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                            columnIdx: 2,
                                                                            child: typeTypeTitles[payment_type.type]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                            columnIdx: 3,
                                                                            child: parseFloat(payment_type_item.amount).toLocaleString(undefined, {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                            columnIdx: 4,
                                                                            cls: "text-right",
                                                                            child: payment_type_item.note
                                                                        })
                                                                    ]
                                                                }, 'payment-type-' + payment_type.id_payment_type);
                                                            })
                                                        }) : Object.values(this.props.payment_types).filter((x)=>x.visible && x.show_in_cash_register_document).sort((a, b)=>a.ord - b.ord).map((payment_type)=>{
                                                            const filled = this.state.table_items[payment_type.id_payment_type].value > 0;
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 1,
                                                                        cls: filled ? 'font-bold' : '',
                                                                        child: payment_type.title
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 2,
                                                                        cls: filled ? 'font-bold' : '',
                                                                        child: typeTypeTitles[payment_type.type]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 3,
                                                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                            type: "text",
                                                                            value: this.state.table_items[payment_type.id_payment_type].formatted_value,
                                                                            onChange: (event)=>{
                                                                                const value = event.target.value;
                                                                                let val = (0, _numbers.parseFloatLocal)(value);
                                                                                if (Object.is(val, NaN)) val = 0;
                                                                                const new_items = {
                                                                                    ...this.state.table_items
                                                                                };
                                                                                new_items[payment_type.id_payment_type].value = val;
                                                                                new_items[payment_type.id_payment_type].formatted_value = value;
                                                                                this.setState({
                                                                                    table_items: new_items
                                                                                });
                                                                            },
                                                                            onBlur: (event)=>{
                                                                                const new_items = {
                                                                                    ...this.state.table_items
                                                                                };
                                                                                new_items[payment_type.id_payment_type].formatted_value = new_items[payment_type.id_payment_type].value.toLocaleString(undefined, {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                });
                                                                                this.setState({
                                                                                    table_items: new_items
                                                                                });
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                                        columnIdx: 4,
                                                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                            type: "text",
                                                                            value: this.state.table_items[payment_type.id_payment_type].note,
                                                                            onChange: (event)=>{
                                                                                const value = event.target.value;
                                                                                const new_items = {
                                                                                    ...this.state.table_items
                                                                                };
                                                                                new_items[payment_type.id_payment_type].note = value;
                                                                                this.setState({
                                                                                    table_items: new_items
                                                                                });
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            }, 'payment-type-' + payment_type.id_payment_type);
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                children: this.props.item !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    intent: (0, _core.Intent).PRIMARY,
                                    onClick: ()=>this.props.closeDialog(),
                                    children: "Zapri"
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            onClick: ()=>this.props.closeDialog(),
                                            children: "Prekli\u010Di"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>{
                                                const valid_payment_count = Object.values(this.state.table_items).filter((x)=>x.value > 0).filter((x)=>x.note.length > 0).length;
                                                if (valid_payment_count == 0) {
                                                    (0, _appToaster.AppToaster).show({
                                                        message: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            children: "Vpisan mora biti vsaj en znesek, vsak vpisan znesek pa mora imeti vpisan tudi opis"
                                                        }),
                                                        intent: 'danger',
                                                        icon: 'issue'
                                                    });
                                                    return;
                                                }
                                                const item = this.props.item !== null ? {
                                                    ...this.props.item
                                                } : {
                                                    id_cash_register_document: (0, _uuidDefault.default).v4(),
                                                    id_user: this.props.user.id_user,
                                                    id_customer: customer === null ? null : customer.id_customer,
                                                    customer_id_country: customer === null ? null : customer.id_country,
                                                    customer_type: customer === null ? null : customer.type,
                                                    customer_address: customer === null ? null : customer.address,
                                                    customer_birth_date: customer === null ? null : customer.birth_date,
                                                    customer_company_long_name: customer === null ? null : customer.company_long_name,
                                                    customer_company_name: customer === null ? null : customer.company_name,
                                                    customer_email: customer === null ? null : customer.email,
                                                    customer_name: customer === null ? null : customer.name,
                                                    customer_surname: customer === null ? null : customer.surname,
                                                    customer_phone: customer === null ? null : customer.phone,
                                                    customer_post_code: customer === null ? null : customer.post_code,
                                                    customer_post_office: customer === null ? null : customer.post_office,
                                                    customer_seX: customer === null ? null : customer.seX,
                                                    customer_tax_number: customer === null ? null : customer.tax_number,
                                                    customer_vat_prefix: customer === null ? null : customer.vat_prefix,
                                                    customer_vat_registered: customer === null ? null : customer.vat_registered,
                                                    type: this.props.type,
                                                    document_number: null,
                                                    status: 'new',
                                                    id_cash_register_daily_state: null,
                                                    id_cash_register: this.props.id_cash_register,
                                                    item_type: null,
                                                    manual: true
                                                };
                                                item.document_date = (0, _momentDefault.default)(this.state.document_date).format('YYYY-MM-DD');
                                                item.reference = this.state.reference;
                                                item.note = this.state.note;
                                                item.payment_types = Object.keys(this.state.table_items).filter((id_payment_type)=>this.state.table_items[id_payment_type].value > 0).map((id_payment_type)=>{
                                                    const table_item = this.state.table_items[id_payment_type];
                                                    return {
                                                        id_cash_register_document_payment_type: (0, _uuidDefault.default).v4(),
                                                        id_cash_register_document: item.id_cash_register_document,
                                                        amount: table_item.value,
                                                        full_amount: table_item.value,
                                                        id_payment_type,
                                                        note: table_item.note,
                                                        item_type: null,
                                                        id_tax_rate: null,
                                                        tax_rate: null
                                                    };
                                                });
                                                this.props.closeDialog(item);
                                            },
                                            children: "Zaklju\u010Di"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
AddCashRegisterDocumentDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    id_cash_register: (0, _propTypesDefault.default).string,
    date: (0, _propTypesDefault.default).string,
    documents: (0, _propTypesDefault.default).array
};
function mapStateToProps(state) {
    return {
        payment_types: state.CodeTablesSlice.payment_types,
        customers: state.CodeTablesSlice.customers,
        countries: state.CodeTablesSlice.countries,
        users: state.UserSlice.users,
        cash_registers: state.CashRegisterSlice.cash_registers
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddCashRegisterDocumentDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","uuid":"b52pV","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","moment":"1e4qG","date-fns/formatISO":"an1FA","../TextWithTooltip":"6kuHH","../AppToaster":"izixN","../../numbers":"jOh9w","../CustomerSelect":"8sizu","../reservations/SelectCustomerDialog":"ewc5P","../business/CustomerInfo":"aE2R5","../../utils":"kh8Vf","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hGtgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _codeTables = require("../../api/CodeTables");
var _warehouses = require("../../api/Warehouses");
var _items = require("../../api/Items");
var _addEditStockAcquisitionDocumentDialog = require("./AddEditStockAcquisitionDocumentDialog");
var _addEditStockAcquisitionDocumentDialogDefault = parcelHelpers.interopDefault(_addEditStockAcquisitionDocumentDialog);
var _itemLabelPrintDialog = require("../ItemLabelPrintDialog");
var _itemLabelPrintDialogDefault = parcelHelpers.interopDefault(_itemLabelPrintDialog);
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _appSlice = require("../../slices/AppSlice");
var _resultComponents = require("../code_tables/ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, openAddEditItemDialog, tableItemsFilters, originalTableItemsFilters, handleFilterChange, users, customers, tax_rates, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged } = props;
    const users_with_titles = {};
    for(let id_user in users)users_with_titles[id_user] = {
        id_user,
        title: users[id_user].name + ' ' + users[id_user].surname
    };
    const types = {
        'acquisition': 'Prevzem',
        'write-off': 'Odpis zaloge',
        'reclamation': 'Reklamacija',
        'representation': 'Reprezentanca',
        'commission': 'Komisija',
        'debt-release': "Razdol\u017Enica",
        'internal-transfer': "Prenos med skladi\u0161\u010Di"
    };
    const types_with_titles = {};
    for(let type in types)types_with_titles[type] = {
        value: type,
        title: types[type]
    };
    let total_price_without_vat = 0;
    let total_price_with_vat = 0;
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-auto sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: check_count > 0,
                                indeterminate: !all_checked && check_count > 0,
                                onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 2,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 3,
                            title: "\u0160tevilka prevzema"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 4,
                            title: "\u0160ifra"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 5,
                            title: "Naziv dobavitelja"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 6,
                            title: "Datum prevzema"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 7,
                            title: "Datum knji\u017Eenja"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 8,
                            title: "\u0160tevilka dobavnice"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 9,
                            title: "Vrsta prevzema"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 10,
                            title: "Uporabnik"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 11,
                            cls: "text-right",
                            title: "Znesek brez DDV"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 12,
                            cls: "text-right",
                            title: "Znesek z DDV"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.document_number,
                                onChange: (event)=>handleFilterChange('document_number', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_internal_code,
                                onChange: (event)=>handleFilterChange('customer_internal_code', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_name,
                                onChange: (event)=>handleFilterChange('customer_name', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.document_date_range,
                                original_start_date: originalTableItemsFilters.document_date_range[0],
                                original_end_date: originalTableItemsFilters.document_date_range[1],
                                onFilterChange: (values)=>handleFilterChange('document_date_range', values),
                                short_year: true
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.book_date_range,
                                original_start_date: originalTableItemsFilters.book_date_range[0],
                                original_end_date: originalTableItemsFilters.book_date_range[1],
                                onFilterChange: (values)=>handleFilterChange('book_date_range', values),
                                short_year: true
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.delivery_note_number,
                                onChange: (event)=>handleFilterChange('delivery_note_number', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "value",
                                    title_field: "title",
                                    items: types_with_titles,
                                    filtered_keys: tableItemsFilters.types,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('types', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_user",
                                    title_field: "title",
                                    items: users_with_titles,
                                    filtered_keys: tableItemsFilters.id_users,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('id_users', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "filters-col",
                            child: null
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 12,
                            cls: "filters-col",
                            child: null
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            const supplier = customers[item.supplier_id_customer] || null;
                            const user = users[item.id_user];
                            let price_without_vat = 0;
                            let price_with_vat = 0;
                            for(let i = 0; i < (item.items ?? []).length; i++){
                                const purchase_price_without_vat = parseFloat(item.items[i].purchase_price_without_vat) * parseFloat(item.items[i].quantity) * (1 - parseFloat(item.items[i].purchase_discount) / 100);
                                price_without_vat += purchase_price_without_vat;
                                price_with_vat += purchase_price_without_vat * (1 + tax_rates[item.items[i].purchase_id_tax_rate].value / 100);
                            }
                            total_price_without_vat += price_without_vat;
                            total_price_with_vat += price_with_vat;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: table_items_checked_ids[id] === true,
                                            onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                icon: "edit",
                                                intent: "primary",
                                                minimal: true,
                                                small: true,
                                                onClick: ()=>openAddEditItemDialog(item)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        child: item.document_number
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        child: supplier === null || supplier === undefined ? null : supplier.internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        child: supplier === null || supplier === undefined ? null : supplier.type == 'natural' ? supplier.surname + ' ' + supplier.name : supplier.company_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        child: item.document_date === null ? null : (0, _momentDefault.default)(item.document_date).format('DD. MM. YYYY')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        child: item.book_date === null ? null : (0, _momentDefault.default)(item.book_date).format('DD. MM. YYYY')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        child: item.delivery_note_number
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        child: types[item.type]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 10,
                                        child: user === null || user === undefined ? null : user.name + ' ' + user.surname
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 11,
                                        cls: "text-right font-bold",
                                        child: price_without_vat.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) + ' EUR'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 12,
                                        cls: "text-right font-bold",
                                        child: price_with_vat.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) + ' EUR'
                                    })
                                ]
                            }, 'result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results borderless mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            span: 2,
                            child: "\u0160tevilo zapisov: " + table_items_sort_ids.length
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "text-right font-bold",
                            child: total_price_without_vat.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) + ' EUR'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 12,
                            cls: "text-right font-bold",
                            child: total_price_with_vat.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) + ' EUR'
                        })
                    ]
                })
            })
        ]
    });
}
class StockAcquisitionDocuments extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.requestDeleteItem = this.requestDeleteItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.exportItemToExcel = this.exportItemToExcel.bind(this);
        this.printLabels = this.printLabels.bind(this);
        this.openLabelPrintDialog = this.openLabelPrintDialog.bind(this);
        this.closeLabelPrintDialog = this.closeLabelPrintDialog.bind(this);
        const table_items_filters = {
            document_number: '',
            customer_internal_code: '',
            customer_name: '',
            document_date_range: [
                (0, _momentDefault.default)().subtract(3, 'months').toDate(),
                null
            ],
            book_date_range: [
                null,
                null
            ],
            delivery_note_number: '',
            types: [],
            id_users: []
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'document_number',
            table_items_sort_direction: 'DESC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'document_number',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            table_items_checked_ids: {},
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_id_cash_register: null,
            add_edit_item_dialog_date: null,
            add_edit_item_dialog_start_balance: 0,
            add_edit_item_dialog_documents: [],
            add_edit_item_dialog_item: null,
            delete_request_id_item: null,
            saving: false,
            label_print_dialog_open: false,
            label_print_dialog_items: [],
            label_print_dialog_counts: {}
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.users != prevProps.users || this.props.stock_acquisition_documents != prevProps.stock_acquisition_documents) {
            const state = this.updateTableItemsFromProps(this.props, this.state);
            this.setState(state);
        }
    }
    updateTableItemsFromProps(props, state) {
        const ids = Object.keys(props.stock_acquisition_documents);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            invoices: props.invoices,
            table_items: props.stock_acquisition_documents,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            a = state.table_items[a_key][field];
            b = state.table_items[b_key][field];
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        console.log({
            filters,
            document_date_range: filters.document_date_range,
            book_date_range: filters.book_date_range
        });
        const filters_document_number = filters.document_number.toUpperCase();
        const filters_customer_internal_code = filters.customer_internal_code.toUpperCase();
        const filters_customer_name = filters.customer_name.toUpperCase();
        const filters_document_date_start = filters.document_date_range[0] === null ? null : this.toIsoString(filters.document_date_range[0]);
        const filters_document_date_end = filters.document_date_range[1] === null ? null : this.toIsoString(filters.document_date_range[1]);
        const filters_book_date_start = filters.book_date_range[0] === null ? null : this.toIsoString(filters.book_date_range[0]);
        const filters_book_date_end = filters.book_date_range[1] === null ? null : this.toIsoString(filters.book_date_range[1]);
        const filters_delivery_note_number = filters.delivery_note_number.toUpperCase();
        const filters_types = filters.types;
        const filters_id_users = filters.id_users;
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['stock--acquisitions'] ?? 0);
        const filter_data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days').toISOString(true);
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_document_number != '' && (item.document_number === null || item.document_number.toUpperCase().indexOf(filters_document_number) == -1)) return false;
            if (filters_customer_internal_code != '' && (item.supplier_id_customer === null || this.props.customers[item.supplier_id_customer] === undefined || this.props.customers[item.supplier_id_customer].internal_code != filters_customer_internal_code)) return false;
            if (filters_customer_name != '' && (item.supplier_id_customer === null || this.props.customers[item.supplier_id_customer] === undefined || (this.props.customers[item.supplier_id_customer].surname + ' ' + this.props.customers[item.supplier_id_customer].name + ' ' + this.props.customers[item.supplier_id_customer].company_name).toUpperCase().indexOf(filters_customer_name) == -1)) return false;
            if (filter_data_retention_date_start !== null && item.document_date !== null && this.toIsoString(new Date(item.document_date)) <= filter_data_retention_date_start) return false;
            if (filters_document_date_start !== null && item.document_date !== null && this.toIsoString(new Date(item.document_date)) < filters_document_date_start) return false;
            if (filters_document_date_end !== null && item.document_date !== null && this.toIsoString(new Date(item.document_date)) > filters_document_date_end) return false;
            if (filters_book_date_start !== null && item.book_date !== null && this.toIsoString(new Date(item.book_date)) < filters_book_date_start) return false;
            if (filters_book_date_end !== null && item.book_date !== null && this.toIsoString(new Date(item.book_date)) > filters_book_date_end) return false;
            if (filters_delivery_note_number != '' && (item.delivery_note_number === null || item.delivery_note_number.toUpperCase().indexOf(filters_delivery_note_number) == -1)) return false;
            if (filters_id_users.length > 0) {
                if (item.id_user === null || filters_id_users.indexOf(item.id_user) == -1) return false;
            }
            if (filters_types.length > 0) {
                if (item.type === null || filters_types.indexOf(item.type) == -1) return false;
            }
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            document_number: this.state.table_items_filters.document_number,
            customer_internal_code: this.state.table_items_filters.customer_internal_code,
            customer_name: this.state.table_items_filters.customer_name,
            document_date_range: this.state.table_items_filters.document_date_range,
            book_date_range: this.state.table_items_filters.book_date_range,
            delivery_note_number: this.state.table_items_filters.delivery_note_number,
            types: this.state.table_items_filters.types,
            id_users: this.state.table_items_filters.id_users
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    async closeAddEditItemDialog(item, ignore_prices_for_id_stock_acquisition_document_items) {
        if (item === undefined) {
            this.setState({
                add_edit_item_dialog_open: false
            });
            return;
        }
        this.setState({
            saving: true
        });
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        const today = (0, _momentDefault.default)().format('YYYY-MM-DD');
        for(let i = 0; i < item.items.length; i++){
            let subitem = item.items[i];
            if (subitem.id_item === null) {
                const id_item = (0, _uuidDefault.default).v4();
                const id_item_price_list = (0, _uuidDefault.default).v4();
                const price_lists = {};
                price_lists[id_item_price_list] = {
                    id_item_price_list,
                    id_item,
                    id_tax_rate: subitem.id_tax_rate,
                    price: subitem.price,
                    valid_from: today,
                    valid_until: null
                };
                subitem = await (0, _items.saveItem)(this.props.api_url, {
                    id_item,
                    id_measuring_unit: '8ff9c423-df6d-41ae-b12a-064f403e2487',
                    type: 'item',
                    ean: subitem.ean,
                    internal_code: subitem.internal_code,
                    allowed_discount: subitem.allowed_discount,
                    title: subitem.title,
                    allow_changing_price: subitem.allow_changing_price,
                    description: subitem.description,
                    show_description_on_documents: subitem.show_description_on_documents,
                    price_lists
                }, token);
                item.items[i].id_item = subitem.id_item;
            } else {
                const item_item = {
                    ...this.props.items[subitem.id_item]
                };
                if (ignore_prices_for_id_stock_acquisition_document_items.indexOf(subitem.id_stock_acquisition_document_item) == -1) {
                    if (subitem.id_item_price_list !== null) {
                        item_item.price_lists = {
                            ...item_item.price_lists
                        };
                        item_item.price_lists[subitem.id_item_price_list] = {
                            ...item_item.price_lists[subitem.id_item_price_list],
                            price: subitem.price
                        };
                    } else {
                        subitem.id_item_price_list = (0, _uuidDefault.default).v4();
                        item_item.price_lists = {
                            ...item_item.price_lists
                        };
                        item_item.price_lists[subitem.id_item_price_list] = {
                            id_item_price_list: subitem.id_item_price_list,
                            id_item: item_item.id_item,
                            id_tax_rate: subitem.id_tax_rate,
                            price: subitem.price,
                            valid_from: today,
                            valid_until: null
                        };
                    }
                    await (0, _items.saveItem)(this.props.api_url, item_item, token);
                }
            }
        }
        await (0, _warehouses.saveStockAcquisitionDocument)(this.props.api_url, item, token);
        //loadStockAcquisitionDocuments(this.props.api_url, dispatch, token);
        //loadStockInventoryItems      (this.props.api_url, dispatch, token);
        this.setState({
            add_edit_item_dialog_open: false,
            saving: false
        });
    }
    requestDeleteItem(id_item) {
        this.setState({
            delete_request_id_item: id_item
        });
    }
    async deleteItem(id_item) {
        const dispatch = this.props.dispatch;
        const token = this.props.token;
    //await deleteCashRegisterDailyState(this.props.api_url, id_item, token);
    }
    exportToExcel() {
        const ids = this.state.table_items_sort_ids /*.filter(id => this.state.table_items_checked_ids[id] === true)*/ ;
        const params = [];
        const data = {
            id_stock_acquisition_document: ids.join(',')
        };
        const form = document.createElement('form');
        form.target = '_blank';
        form.method = 'POST';
        form.action = this.props.api_url + 'Warehouses/v1/acquisition-list-export-excel?' + params.join('&');
        form.style.display = 'none';
        for(let key in data){
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
    exportItemToExcel() {
        const ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        if (ids.length == 0) return;
        const params = [];
        const data = {
            id_stock_acquisition_document: ids[0]
        };
        const form = document.createElement('form');
        form.target = '_blank';
        form.method = 'POST';
        form.action = this.props.api_url + 'Warehouses/v1/acquisition-list-export-item-excel?' + params.join('&');
        form.style.display = 'none';
        for(let key in data){
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
    openLabelPrintDialog(ids) {
        const today = new Date();
        let items = [];
        let counts = {};
        for(let i = 0; i < ids.length; i++){
            const item_items = this.state.table_items[ids[i]].items;
            for(let j = 0; j < item_items.length; j++){
                const item = item_items[j];
                if (counts[item.id_item] === undefined) {
                    const item_item = this.props.items[item.id_item];
                    const id_price_list = (0, _priceHelperDefault.default).FindBestPriceListMatch(today, item_item.price_lists);
                    const price_list = id_price_list === null ? null : item_item.price_lists[id_price_list];
                    const price = price_list === null ? 0 : price_list.price;
                    items.push({
                        item: item_item,
                        price: parseFloat(price)
                    });
                    counts[item.id_item] = 0;
                }
                counts[item.id_item] += parseFloat(item.quantity);
            }
        }
        this.setState({
            label_print_dialog_open: true,
            label_print_dialog_items: items,
            label_print_dialog_counts: counts
        });
    }
    closeLabelPrintDialog(items_with_counts) {
        this.setState({
            label_print_dialog_open: false,
            label_print_dialog_items: [],
            label_print_dialog_counts: {}
        });
        if (items_with_counts === null) return;
        this.printLabels(items_with_counts);
    }
    printLabels(items_with_counts) {
        for(let i = 0; i < items_with_counts.length; i++)for(let c = 0; c < items_with_counts[i].count; c++)this.props.dispatch((0, _appSlice.enqueueItemOnLabelPrinterQueue)({
            type: 'item',
            item: items_with_counts[i].item
        }));
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('stock--acquisitions') === -1) return null;
        const check_count = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).length;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditStockAcquisitionDocumentDialogDefault.default), {
                    closeDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                this.state.delete_request_id_item === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.deleteItem(this.state.delete_request_id_item);
                        this.setState({
                            delete_request_id_item: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            delete_request_id_item: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.saving ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: true,
                    usePortal: true,
                    canOutsideClickClose: false,
                    canEscapeKeyClose: false,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex flex-col flex-grow",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_BODY,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ProgressBar), {
                                    animate: this.state.saving,
                                    intent: "primary"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-xl text-center font-light pt-5",
                                    children: "Shranjevanje"
                                })
                            ]
                        })
                    })
                }),
                !this.state.label_print_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemLabelPrintDialogDefault.default), {
                    items: this.state.label_print_dialog_items,
                    counts: this.state.label_print_dialog_counts,
                    closeDialog: this.closeLabelPrintDialog
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow base-list stock-acquisition-document-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "success",
                                        icon: "plus",
                                        className: "align-middle",
                                        onClick: ()=>this.openAddEditItemDialog(null),
                                        children: "Nov prevzem"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "ml-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "print",
                                            className: "align-middle",
                                            disabled: check_count == 0,
                                            onClick: ()=>{
                                                this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true).forEach((id)=>{
                                                    const item = this.state.table_items[id];
                                                    this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                                                        type: 'acquisition',
                                                        lang: 'sl',
                                                        item
                                                    }));
                                                });
                                            },
                                            children: "Natisni"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "print",
                                            className: "align-middle",
                                            disabled: check_count == 0,
                                            onClick: ()=>{
                                                this.openLabelPrintDialog(this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true));
                                            },
                                            children: "Natisni nalepke"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "ml-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "cloud-download",
                                            disabled: false,
                                            onClick: this.exportToExcel,
                                            children: "Izvoz seznama v Excel"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "primary",
                                            icon: "cloud-download",
                                            disabled: Object.values(this.state.table_items_checked_ids).length != 1,
                                            onClick: this.exportItemToExcel,
                                            children: "Izvoz prevzema v Excel"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    users: this.props.users,
                                    customers: this.props.customers,
                                    tax_rates: this.props.tax_rates,
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    }
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
StockAcquisitionDocuments.propTypes = {};
function mapStateToProps(state) {
    return {
        api_url: state.CashRegisterSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        users: state.UserSlice.users,
        items: state.CodeTablesSlice.items,
        customers: state.CodeTablesSlice.customers,
        tax_rates: state.CodeTablesSlice.tax_rates,
        stock_acquisition_documents: state.WarehouseSlice.stock_acquisition_documents
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(StockAcquisitionDocuments);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","uuid":"b52pV","moment":"1e4qG","@blueprintjs/core":"6Mq52","../../api/CodeTables":"4GMYC","../../api/Warehouses":"WVdXb","../../api/Items":"aBK6D","./AddEditStockAcquisitionDocumentDialog":"iAzvJ","../ItemLabelPrintDialog":"dqGIh","../../helpers/PriceHelper":"91cdD","../../slices/AppSlice":"aByTQ","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"WVdXb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadStockAcquisitionDocuments", ()=>loadStockAcquisitionDocuments);
parcelHelpers.export(exports, "loadStockAcquisitionDocument", ()=>loadStockAcquisitionDocument);
parcelHelpers.export(exports, "saveStockAcquisitionDocument", ()=>saveStockAcquisitionDocument);
parcelHelpers.export(exports, "loadDeliveryNotes", ()=>loadDeliveryNotes);
parcelHelpers.export(exports, "loadDeliveryNote", ()=>loadDeliveryNote);
parcelHelpers.export(exports, "saveDeliveryNote", ()=>saveDeliveryNote);
parcelHelpers.export(exports, "loadStockInventoryItems", ()=>loadStockInventoryItems);
parcelHelpers.export(exports, "loadStockInventoryItemsByDate", ()=>loadStockInventoryItemsByDate);
parcelHelpers.export(exports, "loadDetailedStockInventoryItems", ()=>loadDetailedStockInventoryItems);
parcelHelpers.export(exports, "loadLastStockDataByDate", ()=>loadLastStockDataByDate);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _warehouseSlice = require("../slices/WarehouseSlice");
var _userSlice = require("../slices/UserSlice");
async function loadStockAcquisitionDocuments(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Warehouses/v1/stock-acquisition-documents', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _warehouseSlice.addStockAcquisitionDocuments)(items));
}
async function loadStockAcquisitionDocument(api_url, id_item, dispatch, token) {
    let response = await fetch(api_url + 'Warehouses/v1/stock-acquisition-document?id_stock_acquisition_document=' + id_item, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let item = await response.json();
    if (item.error_code !== undefined) {
        if (item.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _warehouseSlice.addStockAcquisitionDocument)(item));
    return item;
}
async function saveStockAcquisitionDocument(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Warehouses/v1/save-stock-acquisition-document', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function loadDeliveryNotes(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Warehouses/v1/delivery-notes', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _warehouseSlice.addDeliveryNotes)(items));
}
async function loadDeliveryNote(api_url, id_item, dispatch, token) {
    let response = await fetch(api_url + 'Warehouses/v1/delivery-note?id_delivery_note=' + id_item, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let item = await response.json();
    if (item.error_code !== undefined) {
        if (item.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _warehouseSlice.addDeliveryNote)(item));
    return item;
}
async function saveDeliveryNote(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Warehouses/v1/save-delivery-note', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}
async function loadStockInventoryItems(api_url, dispatch, token) {
    let response = await fetch(api_url + 'Warehouses/v1/stock-inventory-new', {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else {
        dispatch((0, _warehouseSlice.addStockInventoryItems)(items.summary));
        dispatch((0, _warehouseSlice.addStockInventoryDetailed)(items.detailed));
        dispatch((0, _warehouseSlice.addStockInventoryDetailedAcquiredItems)(Object.values(items.acquired_items)));
        dispatch((0, _warehouseSlice.addStockInventoryDetailedSpentItems)(Object.values(items.spent_items)));
        dispatch((0, _warehouseSlice.addStockInventoryStockState)(items.stock));
    }
}
async function loadStockInventoryItemsByDate(api_url, dispatch, token, date) {
    let response = await fetch(api_url + 'Warehouses/v1/stock-inventory-new?date_end=' + date, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else {
        dispatch((0, _warehouseSlice.addStockInventoryItemsByDate)({
            date,
            items: items.summary
        }));
        dispatch((0, _warehouseSlice.addStockInventoryDetailedByDate)({
            date,
            items: items.detailed
        }));
        dispatch((0, _warehouseSlice.addStockInventoryDetailedAcquiredItemsByDate)({
            date,
            items: Object.values(items.acquired_items)
        }));
        dispatch((0, _warehouseSlice.addStockInventoryDetailedSpentItemsByDate)({
            date,
            items: Object.values(items.spent_items)
        }));
        dispatch((0, _warehouseSlice.addStockInventoryStockStateByDate)({
            date,
            items: items.stock
        }));
    }
}
async function loadDetailedStockInventoryItems(api_url, dispatch, token, just_return, from_date, until_date, internal_code) {
    just_return = just_return || false;
    let response = await fetch(api_url + 'Warehouses/v1/stock-inventory-new?detailed=true&date_start=' + from_date + '&date_end=' + until_date + '&internal_code=' + internal_code, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
        return null;
    } else {
        console.log({
            msg: 'setting detailed',
            items
        });
        if (just_return) return items.stock;
        dispatch((0, _warehouseSlice.addDetailedStockInventoryStockState)(items.stock));
    }
}
async function loadLastStockDataByDate(api_url, dispatch, token, date) {
    let response = await fetch(api_url + 'Warehouses/v1/last-stock-data-new?until_date=' + date, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let items = await response.json();
    if (items.error_code !== undefined) {
        if (items.error_code == 20001) dispatch((0, _userSlice.setUser)({
            user_info: null,
            token: null
        }));
    } else dispatch((0, _warehouseSlice.addLastStockDataByDate)({
        date,
        items
    }));
}

},{"js-cookie":"2d7Fe","../slices/WarehouseSlice":"8QIEM","../slices/UserSlice":"ikKoo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aBK6D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "saveItem", ()=>saveItem);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
async function saveItem(api_url, item, token) {
    const form_data = new FormData();
    form_data.set('item', JSON.stringify(item));
    let response = await fetch(api_url + 'Items/v1/save-item', {
        method: 'post',
        body: form_data,
        headers: {
            'Authorization': 'Bearer ' + token,
            'X-Force-Retention-Years': (0, _jsCookieDefault.default).get('force_retention_years') ?? ''
        }
    });
    let new_item = await response.json();
    if (new_item.error_code !== undefined) new_item.error_code;
    else return new_item;
    return null;
}

},{"js-cookie":"2d7Fe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iAzvJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _select = require("@blueprintjs/select");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _xlsx = require("xlsx");
var _xlsxDefault = parcelHelpers.interopDefault(_xlsx);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _customerSelect = require("../CustomerSelect");
var _customerSelectDefault = parcelHelpers.interopDefault(_customerSelect);
var _selectCustomerDialog = require("../reservations/SelectCustomerDialog");
var _selectCustomerDialogDefault = parcelHelpers.interopDefault(_selectCustomerDialog);
var _numbers = require("../../numbers");
var _documents = require("../Documents");
var _documentsDefault = parcelHelpers.interopDefault(_documents);
var _importStockAcquisitionFileDialog = require("./ImportStockAcquisitionFileDialog");
var _importStockAcquisitionFileDialogDefault = parcelHelpers.interopDefault(_importStockAcquisitionFileDialog);
var _importStockAcquisitionFromInventoryListFileDialog = require("./ImportStockAcquisitionFromInventoryListFileDialog");
var _importStockAcquisitionFromInventoryListFileDialogDefault = parcelHelpers.interopDefault(_importStockAcquisitionFromInventoryListFileDialog);
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _appToaster = require("../AppToaster");
var _warehouses = require("../../api/Warehouses");
var _utils = require("../../utils");
const Types = {
    'acquisition': 'Prevzem',
    'write-off': 'Odpis zaloge',
    'reclamation': 'Reklamacija',
    'representation': 'Reprezentanca',
    'commission': 'Komisija',
    'debt-release': "Razdol\u017Enica",
    'internal-transfer': "Prenos med skladi\u0161\u010Di"
};
class InvoiceItemViewModel {
    constructor(single_purchase_price_without_vat, single_purchase_price_with_vat, single_purchase_price_with_discount_without_vat, single_purchase_price_with_discount_with_vat, purchase_price_without_vat, purchase_price_with_vat, price_with_vat, invoice_item){
        this.single_purchase_price_without_vat = single_purchase_price_without_vat;
        this.single_purchase_price_with_vat = single_purchase_price_with_vat;
        this.single_purchase_price_with_discount_without_vat = single_purchase_price_with_discount_without_vat;
        this.single_purchase_price_with_discount_with_vat = single_purchase_price_with_discount_with_vat;
        this.purchase_price_without_vat = purchase_price_without_vat;
        this.purchase_price_with_vat = purchase_price_with_vat;
        this.price_with_vat = price_with_vat;
        this.invoice_item = invoice_item;
        this.quantity_formatted = this.formatNumber(this.invoice_item.quantity, this.invoice_item.item_measuring_unit_decimal_digit_count);
        this.purchase_discount_formatted = this.formatNumber(this.invoice_item.purchase_discount);
        this.single_purchase_price_without_vat_formatted = this.formatNumber(this.single_purchase_price_without_vat, 4);
        this.single_purchase_price_with_vat_formatted = this.formatNumber(this.single_purchase_price_with_vat, 4);
        this.single_purchase_price_with_discount_without_vat_formatted = this.formatNumber(this.single_purchase_price_with_discount_without_vat, 4);
        this.single_purchase_price_with_discount_with_vat_formatted = this.formatNumber(this.single_purchase_price_with_discount_with_vat, 4);
        this.purchase_price_without_vat_formatted = this.formatNumber(this.purchase_price_without_vat);
        this.purchase_price_with_vat_formatted = this.formatNumber(this.purchase_price_with_vat);
        this.price_with_vat_formatted = this.formatNumber(this.price_with_vat);
        this.price = this.price.bind(this);
        //this.priceWithoutVat = this.priceWithoutVat.bind(this);
        this.original_price_with_vat = price_with_vat;
        this.original_price_with_vat_formatted = this.formatNumber(this.original_price_with_vat);
        this.price_list_price_with_vat = price_with_vat;
        this.price_list_price_with_vat_formatted = this.formatNumber(this.price_list_price_with_vat);
    }
    static FromInvoiceItem(items, invoice_item, tax_rates) {
        const item = items[invoice_item.id_item];
        const price_list_items = item === undefined ? {} : item.price_lists;
        const price_list = invoice_item.id_item_price_list === null ? undefined : price_list_items[invoice_item.id_item_price_list];
        const price = invoice_item.price !== undefined ? invoice_item.price : price_list === undefined ? 0 : price_list.price;
        const quantity = invoice_item.quantity;
        const discount = invoice_item.purchase_discount;
        const purchase_price_without_vat = invoice_item.purchase_price_without_vat;
        const purchase_vat = invoice_item.purchase_id_tax_rate === null || invoice_item.purchase_id_tax_rate == -1 ? 0 : tax_rates[invoice_item.purchase_id_tax_rate].value;
        return new InvoiceItemViewModel(purchase_price_without_vat, purchase_price_without_vat * (1 + purchase_vat / 100), purchase_price_without_vat * (1 - discount / 100), purchase_price_without_vat * (1 - discount / 100) * (1 + purchase_vat / 100), purchase_price_without_vat * quantity * (1 - discount / 100), purchase_price_without_vat * quantity * (1 - discount / 100) * (1 + purchase_vat / 100), price, invoice_item);
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    price(priceList) {
        if (this.invoice_item.id_item_price_list === null) return 0;
        return priceList[this.invoice_item.id_item_price_list].price;
    }
}
const ItemsListItem = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    const item = props.item;
    const idx = props.idx;
    let vat = item.invoice_item.id_tax_rate === null || item.invoice_item.id_tax_rate == -1 ? 0 : props.tax_rates[item.invoice_item.id_tax_rate].value;
    let purchase_vat = item.invoice_item.purchase_id_tax_rate === null || item.invoice_item.purchase_id_tax_rate == -1 ? 0 : props.tax_rates[item.invoice_item.purchase_id_tax_rate].value;
    //if (idx >= main_table_refs.length) {
    //	main_table_refs.push(React.createRef());
    //}
    let column_idx = 1;
    return props.read_only ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-center",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                    icon: "trash",
                    intent: "danger",
                    minimal: true,
                    small: true,
                    disabled: props.read_only,
                    onClick: ()=>{}
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col",
                style: {
                    gridColumn: column_idx++
                },
                children: item.invoice_item.internal_code + " \u2022 " + item.invoice_item.item_title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-center",
                style: {
                    gridColumn: column_idx++
                },
                children: item.quantity_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_without_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: props.formatNumber(purchase_vat)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_with_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.purchase_discount_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_with_discount_without_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_with_discount_with_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.purchase_price_without_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.purchase_price_with_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: props.formatNumber(vat)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.price_with_vat_formatted
            })
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-center",
                style: {
                    gridColumn: column_idx++
                },
                children: item.invoice_item.id_item == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                    icon: "trash",
                    intent: "danger",
                    minimal: true,
                    small: true,
                    onClick: ()=>{
                        props.deleteItem(props.idx);
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col tight service-suggest",
                style: {
                    gridColumn: column_idx++
                },
                children: item.invoice_item.item_title !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: 'pl-2 text-selectable ' + (item.invoice_item.id_item === null ? 'text-green-500' : ''),
                    children: item.invoice_item.internal_code + " \u2022 " + item.invoice_item.item_title
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Suggest), {
                    itemPredicate: (query, item, idx, exactMatch)=>{
                        const trimmed_query = query.trim();
                        if (trimmed_query.length < 2) return false;
                        if (trimmed_query.length == 2) return item.internal_code.toLowerCase().indexOf(trimmed_query.toLowerCase()) == 0;
                        return item.title.toLowerCase().indexOf(trimmed_query.toLowerCase()) > -1 || item.internal_code.toLowerCase().indexOf(trimmed_query.toLowerCase()) > -1 || item.ean !== null && item.ean.length > 0 && item.ean == trimmed_query;
                    },
                    itemRenderer: (item, { handleClick, modifiers })=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                            active: modifiers.active,
                            onClick: handleClick,
                            text: item.internal_code + " \u2022 " + item.title,
                            label: item.ean
                        }, item.internal_code);
                    },
                    items: Object.values(props.items),
                    onItemSelect: (item)=>props.addItem(item, idx),
                    openOnKeyDown: true,
                    popoverProps: {
                        targetProps: {
                            style: {
                                display: 'block'
                            }
                        },
                        minimal: true
                    },
                    fill: true,
                    selectedItem: item.invoice_item.id_item == -1 ? null : props.items[item.invoice_item.id_item],
                    inputProps: {
                        placeholder: "I\u0161\u010Di"
                    },
                    inputValueRenderer: (item)=>item.internal_code + " \u2022 " + item.title,
                    resetOnSelect: true,
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-center tight",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    value: item.quantity_formatted,
                    className: "text-center",
                    /*ref={self.main_table_refs[idx]}*/ onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.invoice_item.quantity;
                        props.changeInvoiceItemValue(item, idx, [
                            'invoice_item',
                            'quantity'
                        ], val, null, 'quantity_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    className: "text-right",
                    value: item.single_purchase_price_without_vat_formatted,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.single_purchase_price_without_vat;
                        props.changeInvoiceItemValue(item, idx, 'single_purchase_price_without_vat', val, null, 'single_purchase_price_without_vat_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                    options: [
                        {
                            label: '-- izberi --',
                            value: -1
                        },
                        ...Object.keys(props.tax_rates).sort((a, b)=>props.tax_rates[b].value - props.tax_rates[a].value).map((x)=>{
                            return {
                                label: props.formatNumber(props.tax_rates[x].value) + "% \u2022 " + props.tax_rates[x].title,
                                value: x
                            };
                        })
                    ],
                    value: item.invoice_item.purchase_id_tax_rate,
                    onChange: (e)=>{
                        props.changeInvoiceItemValue(item, idx, [
                            'invoice_item',
                            'purchase_id_tax_rate'
                        ], e.currentTarget.value, null, '', '');
                    },
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    className: "text-right",
                    value: item.single_purchase_price_with_vat_formatted,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.single_purchase_price_with_vat;
                        props.changeInvoiceItemValue(item, idx, 'single_purchase_price_with_vat', val, null, 'single_purchase_price_with_vat_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col tight text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    className: "text-right",
                    value: item.purchase_discount_formatted,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.invoice_item.purchase_discount;
                        props.changeInvoiceItemValue(item, idx, [
                            'invoice_item',
                            'purchase_discount'
                        ], val, null, 'purchase_discount_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_with_discount_without_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_with_discount_with_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col tight text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    className: "text-right",
                    value: item.purchase_price_without_vat_formatted,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.purchase_price_without_vat;
                        props.changeInvoiceItemValue(item, idx, 'purchase_price_without_vat', val, null, 'purchase_price_without_vat_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col tight text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    className: "text-right",
                    value: item.purchase_price_with_vat_formatted,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.purchase_price_with_vat;
                        props.changeInvoiceItemValue(item, idx, 'purchase_price_with_vat', val, null, 'purchase_price_with_vat_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col",
                style: {
                    gridColumn: column_idx++
                },
                children: item.invoice_item.id_item != -1 && item.invoice_item.id_item !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: item.invoice_item.id_tax_rate === null || item.invoice_item.id_tax_rate === undefined || props.tax_rates[item.invoice_item.id_tax_rate] === undefined ? null : props.formatNumber(props.tax_rates[item.invoice_item.id_tax_rate].value) + "% \u2022 " + props.tax_rates[item.invoice_item.id_tax_rate].title
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                    options: [
                        {
                            label: '-- izberi --',
                            value: -1
                        },
                        ...Object.keys(props.tax_rates).sort((a, b)=>props.tax_rates[b].value - props.tax_rates[a].value).map((x)=>{
                            return {
                                label: props.formatNumber(props.tax_rates[x].value) + "% \u2022 " + props.tax_rates[x].title,
                                value: x
                            };
                        })
                    ],
                    value: item.invoice_item.id_tax_rate,
                    onChange: (e)=>{
                        props.changeInvoiceItemValue(item, idx, [
                            'invoice_item',
                            'id_tax_rate'
                        ], e.currentTarget.value, null, '', '');
                    },
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: item.price_with_vat == item.original_price_with_vat ? {
                    gridColumn: column_idx++
                } : {
                    gridColumn: column_idx++,
                    backgroundColor: '#ffa7a7'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    className: "text-right",
                    style: item.price_with_vat == item.original_price_with_vat ? {} : {
                        backgroundColor: 'transparent'
                    },
                    value: item.price_with_vat_formatted,
                    title: 'Cena iz cenika: ' + item.price_list_price_with_vat_formatted,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.price_with_vat;
                        props.changeInvoiceItemValue(item, idx, 'price_with_vat', val, null, 'price_with_vat_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            })
        ]
    });
});
class ItemsList extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.setMainTableItemsSort = this.setMainTableItemsSort.bind(this);
        this.formatNumber = this.formatNumber.bind(this);
        this.addEmptyItemIfNeeded = this.addEmptyItemIfNeeded.bind(this);
        this.changeInvoiceItemValue = this.changeInvoiceItemValue.bind(this);
        this.addItem = this.addItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.state = {
            main_table_items_sort_field: '',
            main_table_items_sort_direction: 'ASC'
        };
        this.main_table_refs = [];
    }
    setMainTableItemsSort(field) {
    //let direction = 'ASC';
    //if (this.state.main_table_items_sort_field == field) {
    //	direction = (this.state.main_table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC');
    //}
    //
    //const ids = this.state.main_table_items_sort_ids;
    //ids.sort((a_key, b_key) => {
    //	const a = this.state.main_table_items[a_key][field];
    //	const b = this.state.main_table_items[b_key][field];
    //	
    //	return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
    //});
    //
    //this.setState({
    //	main_table_items_sort_ids:       ids,
    //	main_table_items_sort_field:     field,
    //	main_table_items_sort_direction: direction,
    //});
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    addEmptyItemIfNeeded(document_items) {
        if (this.props.read_only) return;
        if (document_items.length == 0 || document_items[document_items.length - 1].invoice_item.id_item != -1) {
            const item = InvoiceItemViewModel.FromInvoiceItem(this.props.items, this.getEmptyInvoiceItem(), this.props.tax_rates);
            item.quantity = 1;
            document_items.push(item);
            this.props.setInvoiceItems(document_items);
        }
    }
    getEmptyInvoiceItem() {
        return {
            id_stock_acquisition_document_item: -1,
            id_stock_acquisition_document: -1,
            id_item: -1,
            quantity: 0,
            price: 0,
            id_tax_rate: -1,
            purchase_price_without_vat: 0,
            purchase_id_tax_rate: -1,
            purchase_discount: 0,
            item_title: null,
            id_item_price_list: -1,
            item_measuring_unit_decimal_digit_count: 0,
            ean: '',
            internal_code: ''
        };
    }
    changeInvoiceItemValue(item, idx, field_name, val, document_items, formatted_field_name, formatted_field_value) {
        document_items = [
            ...document_items || this.props.document_items
        ];
        const new_item = {
            ...document_items[idx]
        };
        if (Array.isArray(field_name)) new_item[field_name[0]][field_name[1]] = val;
        else if (field_name != 'refresh') new_item[field_name] = val;
        if (field_name == 'refresh') {
            // round quantity to item_measuring_unit_decimal_digit_count
            const quantity = parseFloat(new_item.invoice_item.quantity);
            const decimal_digit_count = 2; //parseFloat(new_item.invoice_item.item_measuring_unit_decimal_digit_count);
            let decimal_factor = 10 * decimal_digit_count;
            if (decimal_factor == 0) decimal_factor = 1;
            new_item.invoice_item.quantity = Math.round(quantity * decimal_factor) / decimal_factor;
        }
        /*let vat = 0;
		if (item.invoice_item !== undefined &&
			item.invoice_item.id_item_price_list !== null &&
			item.invoice_item.id_item != -1
		) {
			vat = this.props.tax_rates[
				this.props.items[item.invoice_item.id_item].price_lists[item.invoice_item.id_item_price_list].id_tax_rate
			].value;
		}*/ new_item.quantity_formatted = new_item.invoice_item.quantity;
        new_item.purchase_discount_formatted = new_item.invoice_item.purchase_discount;
        new_item.single_purchase_price_with_vat_formatted = new_item.single_purchase_price_with_vat;
        new_item.purchase_price_with_vat_formatted = new_item.purchase_price_with_vat;
        new_item.purchase_price_without_vat_formatted = new_item.purchase_price_without_vat;
        new_item.single_purchase_price_without_vat_formatted = new_item.single_purchase_price_without_vat;
        new_item.single_purchase_price_with_discount_without_vat_formatted = new_item.single_purchase_price_with_discount_without_vat;
        new_item.single_purchase_price_with_discount_with_vat_formatted = new_item.single_purchase_price_with_discount_with_vat;
        new_item.price_with_vat_formatted = new_item.price_with_vat;
        // set new price
        /*if (
			Array.isArray(field_name)             &&
			field_name.length == 2                &&
			field_name[0] == 'invoice_item'       &&
			field_name[1] == 'id_item_price_list'
		) {
			new_item.single_purchase_price_with_vat =
				this.props.items[item.invoice_item.id_item].price_lists[item.invoice_item.id_item_price_list].price;
		}*/ const purchase_id_tax_rate = new_item.invoice_item.purchase_id_tax_rate;
        const purchase_vat = purchase_id_tax_rate === null || purchase_id_tax_rate === undefined || purchase_id_tax_rate == -1 ? 0 : this.props.tax_rates[purchase_id_tax_rate].value;
        let purchase_price_without_vat = new_item.single_purchase_price_without_vat;
        if (field_name == 'single_purchase_price_with_vat') purchase_price_without_vat = new_item.single_purchase_price_with_vat / (1 + purchase_vat / 100);
        else if (field_name == 'purchase_price_with_vat') purchase_price_without_vat = new_item.purchase_price_with_vat / new_item.invoice_item.quantity / (1 - new_item.invoice_item.purchase_discount / 100) / (1 + purchase_vat / 100);
        else if (field_name == 'purchase_price_without_vat') purchase_price_without_vat = new_item.purchase_price_without_vat / new_item.invoice_item.quantity / (1 - new_item.invoice_item.purchase_discount / 100);
        // format discount
        if (formatted_field_name == 'purchase_discount_formatted') new_item.purchase_discount_formatted = formatted_field_value;
        else if (!Array.isArray(field_name) || field_name[1] != 'purchase_discount') new_item.purchase_discount_formatted = this.formatNumber(new_item.invoice_item.purchase_discount);
        // format quantity
        if (formatted_field_name == 'quantity_formatted') new_item.quantity_formatted = formatted_field_value;
        else if (!Array.isArray(field_name) || field_name[1] != 'quantity') new_item.quantity_formatted = this.formatNumber(new_item.invoice_item.quantity, new_item.invoice_item.item_measuring_unit_decimal_digit_count);
        // calculate and format single price without VAT
        if (formatted_field_name == 'single_purchase_price_without_vat_formatted') new_item.single_purchase_price_without_vat_formatted = formatted_field_value;
        else if (field_name != 'single_purchase_price_without_vat') {
            new_item.single_purchase_price_without_vat = purchase_price_without_vat;
            new_item.single_purchase_price_without_vat_formatted = this.formatNumber(new_item.single_purchase_price_without_vat, 4);
        }
        // calculate and format single price with VAT
        if (formatted_field_name == 'single_purchase_price_with_vat_formatted') new_item.single_purchase_price_with_vat_formatted = formatted_field_value;
        else if (field_name != 'single_purchase_price_with_vat') {
            new_item.single_purchase_price_with_vat = purchase_price_without_vat * (1 + purchase_vat / 100);
            new_item.single_purchase_price_with_vat_formatted = this.formatNumber(new_item.single_purchase_price_with_vat, 4);
        }
        // calculate and format single price with discount without VAT
        if (formatted_field_name == 'single_purchase_price_with_discount_without_vat_formatted') new_item.single_purchase_price_with_discount_without_vat_formatted = formatted_field_value;
        else if (field_name != 'single_purchase_price_with_discount_without_vat') {
            new_item.single_purchase_price_with_discount_without_vat = purchase_price_without_vat * (1 - new_item.invoice_item.purchase_discount / 100);
            new_item.single_purchase_price_with_discount_without_vat_formatted = this.formatNumber(new_item.single_purchase_price_with_discount_without_vat, 4);
        }
        // calculate and format single price with discount with VAT
        if (formatted_field_name == 'single_purchase_price_with_discount_with_vat_formatted') new_item.single_purchase_price_with_discount_with_vat_formatted = formatted_field_value;
        else if (field_name != 'single_purchase_price_with_discount_with_vat') {
            new_item.single_purchase_price_with_discount_with_vat = purchase_price_without_vat * (1 + purchase_vat / 100) * (1 - new_item.invoice_item.purchase_discount / 100);
            new_item.single_purchase_price_with_discount_with_vat_formatted = this.formatNumber(new_item.single_purchase_price_with_discount_with_vat, 4);
        }
        // calculate and format price with discount without VAT
        if (formatted_field_name == 'purchase_price_without_vat_formatted') new_item.purchase_price_without_vat_formatted = formatted_field_value;
        else if (field_name != 'purchase_price_without_vat') {
            new_item.purchase_price_without_vat = purchase_price_without_vat * new_item.invoice_item.quantity * (1 - new_item.invoice_item.purchase_discount / 100);
            new_item.purchase_price_without_vat_formatted = this.formatNumber(new_item.purchase_price_without_vat);
        }
        // calculate and format price with discount with VAT
        if (formatted_field_name == 'purchase_price_with_vat_formatted') new_item.purchase_price_with_vat_formatted = formatted_field_value;
        else if (field_name != 'purchase_price_with_vat') {
            new_item.purchase_price_with_vat = purchase_price_without_vat * (1 + purchase_vat / 100) * new_item.invoice_item.quantity * (1 - new_item.invoice_item.purchase_discount / 100);
            new_item.purchase_price_with_vat_formatted = this.formatNumber(new_item.purchase_price_with_vat);
        }
        // format single price with VAT
        if (formatted_field_name == 'price_with_vat_formatted') new_item.price_with_vat_formatted = formatted_field_value;
        else if (!Array.isArray(field_name) || field_name[1] != 'price_with_vat') new_item.price_with_vat_formatted = this.formatNumber(new_item.price_with_vat);
        document_items[idx] = new_item;
        this.props.setInvoiceItems(document_items);
    }
    addItem(item, idx) {
        const item_item = this.props.items[item.id_item];
        const document_items = [
            ...this.props.document_items
        ];
        let invoice_item = {
            id_stock_acquisition_document_item: -1,
            id_stock_acquisition_document: this.state.id_stock_acquisition_document,
            id_item: item.id_item,
            quantity: 1,
            price: 99,
            id_tax_rate: null,
            purchase_price_without_vat: 0,
            purchase_id_tax_rate: -1,
            purchase_discount: 0,
            item_title: null,
            id_item_price_list: -1,
            item_measuring_unit_decimal_digit_count: 0,
            ean: item_item.ean,
            internal_code: item_item.internal_code
        };
        invoice_item = {
            ...invoice_item,
            ...this.props.findLatestPrice(item_item, true)
        };
        console.log({
            type: this.props.type
        });
        if (this.props.type == 'acquisition' || this.props.type == 'write-off') {
            const id_warehouse = this.props.id_warehouse;
            console.log({
                id_item: item.id_item,
                last_stock_data: id_warehouse === null ? null : this.props.stock_state.last_stock_data[item.id_item + '--' + id_warehouse],
                item_price: id_warehouse === null ? null : this.props.stock_state.last_stock_data[item.id_item + '--' + id_warehouse]?.item_price ?? 0
            });
            invoice_item.purchase_price_without_vat = id_warehouse === null ? 0 : this.props.stock_state.last_stock_data[item.id_item + '--' + id_warehouse]?.item_price ?? 0;
        }
        invoice_item.item_measuring_unit_decimal_digit_count = this.props.measuring_units[item_item.id_measuring_unit].decimal_digit_count;
        document_items[idx] = InvoiceItemViewModel.FromInvoiceItem(this.props.items, invoice_item, this.props.tax_rates);
        this.props.setInvoiceItems(document_items);
        this.addEmptyItemIfNeeded(document_items);
        // refresh values
        this.changeInvoiceItemValue(document_items[idx], idx, 'refresh', null, document_items);
    /*if (idx < props.main_table_refs.length &&
			props.main_table_refs[idx] !== undefined &&
			props.main_table_refs[idx].current !== null)
		{
			props.main_table_refs[idx].current.focus();
			setTimeout(() => {
				props.main_table_refs[idx].current.select();
			}, 200);
		}*/ }
    deleteItem(idx) {
        const document_items = [
            ...this.props.document_items
        ];
        document_items.splice(idx, 1);
        this.props.setInvoiceItems(document_items);
    }
    render() {
        let column_idx = 1;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: 'items-table ' + (this.props.read_only ? 'read-only' : ''),
            children: [
                this.props.read_only ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "\u0160ifra in naziv"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col text-center",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Koli\u010Dina"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Cena",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Nabavni",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "DDV (%)"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Cena",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Popust (%)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Cena s pop.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Cena s pop.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Znesek",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Znesek",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Prodajni",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "DDV (%)"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "PC z DDV"
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('title');
                            },
                            children: [
                                "\u0160ifra in naziv",
                                this.state.main_table_items_sort_field != 'title' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-center",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('quantity');
                            },
                            children: [
                                "Koli\u010Dina",
                                this.state.main_table_items_sort_field != 'quantity' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('single_purchase_price_without_vat');
                            },
                            children: [
                                "Cena",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV",
                                this.state.main_table_items_sort_field != 'single_purchase_price_without_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('purchase_id_tax_rate');
                            },
                            children: [
                                "Nabavni",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "DDV (%)",
                                this.state.main_table_items_sort_field != 'purchase_id_tax_rate' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('single_purchase_price_with_vat');
                            },
                            children: [
                                "Cena",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV",
                                this.state.main_table_items_sort_field != 'single_purchase_price_with_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('purchase_discount');
                            },
                            children: [
                                "Popust (%)",
                                this.state.main_table_items_sort_field != 'purchase_discount' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('single_purchase_price_with_discount_without_vat');
                            },
                            children: [
                                "Cena s pop.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV",
                                this.state.main_table_items_sort_field != 'single_purchase_price_with_discount_without_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('single_purchase_price_with_discount_with_vat');
                            },
                            children: [
                                "Cena s pop.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV",
                                this.state.main_table_items_sort_field != 'single_purchase_price_with_discount_with_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('purchase_price_without_vat');
                            },
                            children: [
                                "Znesek",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV",
                                this.state.main_table_items_sort_field != 'purchase_price_without_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('purchase_price_with_vat');
                            },
                            children: [
                                "Znesek",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV",
                                this.state.main_table_items_sort_field != 'purchase_price_with_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('id_tax_rate');
                            },
                            children: [
                                "Prodajni",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "DDV (%)",
                                this.state.main_table_items_sort_field != 'id_tax_rate' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('price_with_vat');
                            },
                            children: [
                                "PC z DDV",
                                this.state.main_table_items_sort_field != 'price_with_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        })
                    ]
                }),
                this.props.document_items.map((item, idx)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ItemsListItem, {
                            idx: idx,
                            read_only: this.props.read_only,
                            item: item,
                            items: this.props.items,
                            tax_rates: this.props.tax_rates,
                            setInvoiceItems: this.props.setInvoiceItems,
                            addEmptyItemIfNeeded: this.addEmptyItemIfNeeded,
                            formatNumber: this.formatNumber,
                            id_stock_acquisition_document: this.state.id_stock_acquisition_document,
                            findBestPriceListMatch: this.props.findBestPriceListMatch,
                            findLatestPrice: this.props.findLatestPrice,
                            measuring_units: this.props.measuring_units,
                            changeInvoiceItemValue: this.changeInvoiceItemValue,
                            addItem: this.addItem,
                            deleteItem: this.deleteItem,
                            disabled: this.props.disabled
                        })
                    }, 'invoice-item-' + idx);
                })
            ]
        });
    }
}
class AddEditStockAcquisitionDocumentDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.openSelectCustomerDialog = this.openSelectCustomerDialog.bind(this);
        this.closeSelectCustomerDialog = this.closeSelectCustomerDialog.bind(this);
        this.getItemFromState = this.getItemFromState.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.closeDialogWithIgnore = this.closeDialogWithIgnore.bind(this);
        this.confirmCloseWithoutSave = this.confirmCloseWithoutSave.bind(this);
        this.convertDocumentItems = this.convertDocumentItems.bind(this);
        this.hasChanged = this.hasChanged.bind(this);
        this.isDraft = this.isDraft.bind(this);
        this.toLocalStringWithTime = this.toLocalStringWithTime.bind(this);
        this.openImportStockAcquisitionFileDialog = this.openImportStockAcquisitionFileDialog.bind(this);
        this.closeImportStockAcquisitionFileDialog = this.closeImportStockAcquisitionFileDialog.bind(this);
        this.openImportStockAcquisitionFromInventoryListFileDialog = this.openImportStockAcquisitionFromInventoryListFileDialog.bind(this);
        this.closeImportStockAcquisitionFromInventoryListFileDialog = this.closeImportStockAcquisitionFromInventoryListFileDialog.bind(this);
        this.findBestPriceListMatch = this.findBestPriceListMatch.bind(this);
        this.findLatestPrice = this.findLatestPrice.bind(this);
        this.setInvoiceItems = this.setInvoiceItems.bind(this);
        this.filterItems = this.filterItems.bind(this);
        this.validate = this.validate.bind(this);
        this.calculateSums = this.calculateSums.bind(this);
        this.loadStockInventoryForDate = this.loadStockInventoryForDate.bind(this);
        let draft = props.item === null ? true : props.item.draft;
        if (draft === undefined) draft = true;
        let read_only = false;
        //if (!draft) {
        //	read_only = true;
        //}
        this.state = {
            id_stock_acquisition_document: props.item === null ? (0, _uuidDefault.default).v4() : props.item.id_stock_acquisition_document,
            document_number: props.item === null || props.item.document_number === null ? '' : props.item.document_number,
            supplier_id_customer: props.item === null ? null : props.item.supplier_id_customer || null,
            document_date: props.item === null ? new Date() : props.item.document_date === null ? null : new Date(props.item.document_date),
            book_date: props.item === null ? new Date() : props.item.book_date === null ? null : new Date(props.item.book_date),
            delivery_note_date: props.item === null ? new Date() : props.item.delivery_note_date === null ? null : new Date(props.item.delivery_note_date),
            delivery_note_number: props.item === null ? '' : props.item.delivery_note_number,
            type: props.item === null ? null : props.item.type,
            note: props.item === null ? '' : props.item.note || '',
            document_items: [],
            commission_acquisition: props.item === null ? false : props.item.commission_acquisition,
            id_warehouse: props.item === null ? null : props.item.id_warehouse,
            stock_from_id_warehouse: props.item === null ? null : props.item.stock_from_id_warehouse,
            select_customer_dialog_open: false,
            select_customer_dialog_surname: '',
            close_dialog_save_as_draft: false,
            close_dialog_confirm_open: false,
            import_dialog_open: false,
            import_inventory_list_dialog_open: false,
            import_failure_alert_open: false,
            import_failure_alert_missing_tax_rates: [],
            import_failure_alert_warnings: [],
            draft,
            read_only,
            filtered_items: this.filterItems(props),
            ignore_prices_for_ids: [],
            confirm_price_overwrite_dialog_open: false,
            confirm_price_overwrite_dialog_checked: {},
            confirm_price_overwrite_dialog_items: {},
            confirm_price_overwrite_dialog_item: null
        };
        this.state.document_items = this.convertDocumentItems(props.item, read_only);
        if (this.state.book_date !== null) {
            const book_date_iso = (0, _momentDefault.default)(this.state.book_date).format('YYYY-MM-DD');
            this.loadStockInventoryForDate(book_date_iso);
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.document_items != prevState.document_items) // if an item was deleted, focus new/empty item
        {
            if (this.state.document_items.length < prevState.document_items.length) {
                const service_suggest_inputs = document.querySelectorAll('.service-suggest input');
                if (service_suggest_inputs.length > 0) service_suggest_inputs[service_suggest_inputs.length - 1].focus();
            }
        }
        if (this.props.items !== prevProps.items) this.setState({
            filtered_items: this.filterItems()
        });
        if (this.state.book_date != prevState.book_date) {
            if (this.state.book_date !== null) {
                const book_date_iso = (0, _momentDefault.default)(this.state.book_date).format('YYYY-MM-DD');
                //if (this.props.last_stock_data_by_date[book_date_iso] === undefined) {
                this.loadStockInventoryForDate(book_date_iso);
            //}
            }
        }
    }
    hasChanged() {
        /*if (this.props.item === null || this.props.item === undefined) {
			return true;
		}
		
		if (this.props.item.id_customer != this.state.id_customer) return true;
		
		let first_payment = null;
		let split_payment_types = [];
		if (this.props.item !== null && this.props.item.payments !== undefined && this.props.item.payments !== null) {
			if (this.props.item.payments.length == 1) {
				first_payment = this.props.item.payments[0];
			}
			split_payment_types = this.props.item.payments;
		}
		
		if (this.state.id_payment_type == -2) {
			if (first_payment !== null) return true;
			
			if (split_payment_types.length != this.state.split_payment_types.length) return true;
			
			let found_diff = false;
			for (let i=0; i<split_payment_types.length; i++) {
				let found = false;
				
				for (let j=0; j<this.state.split_payment_types.length; j++) {
					if (
						this.state.split_payment_types[j].id_payment_type == split_payment_types[i].id_payment_type &&
						this.state.split_payment_types[j].amount          == split_payment_types[i].amount
					) {
						found = true;
						break;
					}
				}
				
				if (!found) {
					found_diff = true;
					break;
				}
			}
			if (found_diff) return true;
		}
		else if (
			first_payment === null ||
			(first_payment !== null && this.state.id_payment_type != first_payment.id_payment_type)
		) {
			return true;
		}*/ return false;
    }
    isDraft() {
        return this.state.draft;
    }
    getEmptyInvoiceItem() {
        return {
            id_stock_acquisition_document_item: -1,
            id_stock_acquisition_document: -1,
            id_item: -1,
            quantity: 0,
            price: 0,
            id_tax_rate: -1,
            purchase_price_without_vat: 0,
            purchase_id_tax_rate: -1,
            purchase_discount: 0,
            item_title: null,
            id_item_price_list: -1,
            item_measuring_unit_decimal_digit_count: 0,
            ean: '',
            internal_code: ''
        };
    }
    convertDocumentItems(item, read_only) {
        const items = [];
        if (item !== null) for(let i = 0; i < item.items.length; i++){
            const existing_item = this.props.items[item.items[i].id_item];
            const item_item = {
                ...this.props.items[item.items[i].id_item],
                ...item.items[i],
                item_title: existing_item === undefined ? item.items[i].item_title : existing_item.title
            };
            item_item.id_item_price_list = this.findBestPriceListMatch(item_item);
            const invoice_item = InvoiceItemViewModel.FromInvoiceItem(this.props.items, item_item, this.props.tax_rates);
            // skip if item doesn't exist yet
            if (item.items[i] !== undefined && item.items[i].id_item !== null && this.props.items[item.items[i].id_item] !== undefined) {
                const original_price_data = this.findLatestPrice(this.props.items[item.items[i].id_item], true);
                if (original_price_data.id_item_price_list != -1) {
                    invoice_item.original_price_with_vat = original_price_data.price;
                    invoice_item.original_price_with_vat_formatted = this.formatNumber(invoice_item.original_price_with_vat);
                }
                const price_list_price_data = this.findLatestPrice(this.props.items[item.items[i].id_item], true);
                if (price_list_price_data.id_item_price_list != -1) {
                    invoice_item.price_list_price_with_vat = price_list_price_data.price;
                    invoice_item.price_list_price_with_vat_formatted = this.formatNumber(invoice_item.price_list_price_with_vat);
                }
            }
            items.push(invoice_item);
        }
        if (!read_only) {
            const empty_invoice_item_view = InvoiceItemViewModel.FromInvoiceItem(this.props.items, this.getEmptyInvoiceItem(), this.props.tax_rates);
            empty_invoice_item_view.invoice_item.quantity = 1;
            items.push(empty_invoice_item_view);
        }
        return items;
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    getMaxDate() {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 10);
        return date;
    }
    openSelectCustomerDialog(query, item) {
        item = item || null;
        this.setState({
            select_customer_dialog_open: true,
            select_customer_dialog_surname: query,
            select_customer_dialog_item: item
        });
    }
    closeSelectCustomerDialog(id_customer, new_customer) {
        const state = {
            select_customer_dialog_open: false
        };
        if (id_customer !== undefined) state.id_customer = id_customer;
        this.setState(state);
    }
    getItemFromState(save_as_draft) {
        const items = this.state.document_items.filter((x)=>/*x.invoice_item.id_item !== null &&*/ x.invoice_item.id_item != -1).map((x)=>{
            const id_stock_acquisition_document_item = (0, _uuidDefault.default).v4();
            return {
                changed_price: x.original_price_with_vat != x.price_with_vat,
                is_new: x.invoice_item.id_stock_acquisition_document_item == -1,
                item: {
                    id_stock_acquisition_document_item,
                    id_stock_acquisition_document: this.state.id_stock_acquisition_document,
                    id_item: x.invoice_item.id_item,
                    quantity: x.invoice_item.quantity,
                    price: x.price_with_vat,
                    id_tax_rate: x.invoice_item.id_tax_rate,
                    purchase_price_without_vat: x.single_purchase_price_without_vat,
                    purchase_id_tax_rate: x.invoice_item.purchase_id_tax_rate,
                    purchase_discount: x.invoice_item.purchase_discount,
                    title: x.invoice_item.item_title,
                    ean: x.invoice_item.ean,
                    internal_code: x.invoice_item.internal_code,
                    show_description_on_documents: x.invoice_item.show_description_on_documents ?? false,
                    allowed_discount: 0,
                    allow_changing_price: true,
                    description: '',
                    id_item_price_list: x.invoice_item.id_item_price_list
                }
            };
        });
        const items_with_changed_prices = items.filter((x)=>x.changed_price);
        const items_with_changed_prices_keyed = {};
        for(let i = 0; i < items_with_changed_prices.length; i++)items_with_changed_prices_keyed[items_with_changed_prices[i].item.id_stock_acquisition_document_item] = items_with_changed_prices[i].item;
        const ignore_existing_unchanged_ids = items.filter((x)=>!x.changed_price).map((x)=>x.item.id_stock_acquisition_document_item);
        return {
            items_with_changed_prices: items_with_changed_prices_keyed,
            ignore_existing_unchanged_ids,
            item: {
                id_stock_acquisition_document: this.state.id_stock_acquisition_document,
                document_number: this.state.document_number,
                id_user: this.props.user.id_user,
                supplier_id_customer: this.state.supplier_id_customer,
                document_date: this.state.document_date === null ? null : (0, _momentDefault.default)(this.state.document_date).format('YYYY-MM-DD'),
                commission_acquisition: this.state.commission_acquisition,
                id_warehouse: this.state.id_warehouse,
                type: this.state.type,
                draft: save_as_draft,
                book_date: this.state.book_date === null ? null : (0, _momentDefault.default)(this.state.book_date).format('YYYY-MM-DD'),
                delivery_note_date: this.state.delivery_note_date === null ? null : (0, _momentDefault.default)(this.state.delivery_note_date).format('YYYY-MM-DD'),
                delivery_note_number: this.state.delivery_note_number,
                note: this.state.note,
                stock_from_id_warehouse: this.state.stock_from_id_warehouse,
                items: items.map((x)=>x.item)
            }
        };
    }
    recalculateTable(document_items) {
        document_items = document_items || this.state.document_items;
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    closeDialog(save, save_as_draft) {
        if (!save) {
            this.props.closeDialog();
            return;
        }
        const validation_messages = this.validate();
        if (validation_messages.length > 0) {
            (0, _appToaster.AppToaster).show({
                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Napake na obrazcu:",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        validation_messages.map((title, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: "\u2022 " + title
                            }, idx))
                    ]
                }),
                intent: 'danger',
                icon: 'issue'
            });
            return;
        }
        const { items_with_changed_prices, ignore_existing_unchanged_ids, item } = this.getItemFromState(save_as_draft);
        // ask user to confirm price changes for existing items
        const changed_ids = Object.keys(items_with_changed_prices);
        if (changed_ids.length > 0) {
            const confirm_price_overwrite_dialog_checked = {};
            for(let i = 0; i < changed_ids.length; i++)confirm_price_overwrite_dialog_checked[changed_ids[i]] = true;
            this.setState({
                confirm_price_overwrite_dialog_open: true,
                confirm_price_overwrite_dialog_checked,
                confirm_price_overwrite_dialog_items: items_with_changed_prices,
                confirm_price_overwrite_dialog_item: item,
                ignore_prices_for_ids: ignore_existing_unchanged_ids
            });
            return;
        }
        this.closeDialogWithIgnore(item, ignore_existing_unchanged_ids);
    }
    closeDialogWithIgnore(item, ignore_prices_for_id_stock_acquisition_document_items) {
        this.props.closeDialog(item, ignore_prices_for_id_stock_acquisition_document_items);
    }
    confirmCloseWithoutSave() {
        this.setState({
            close_dialog_save_as_draft: false,
            close_dialog_confirm_open: true
        });
    }
    toLocalStringWithTime(date) {
        if (date === null) return '';
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear() + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');
    }
    openImportStockAcquisitionFileDialog() {
        this.setState({
            import_dialog_open: true
        });
    }
    closeImportStockAcquisitionFileDialog(data) {
        this.setState({
            import_dialog_open: false
        });
        if (data === undefined || data === null) return;
        const workbook = (0, _xlsxDefault.default).read(data, {
            type: 'array'
        });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const items = [];
        let row = 2; // skip first row
        while(true){
            const cell_a = worksheet['A' + row];
            const cell_b = worksheet['B' + row];
            if ((cell_a === undefined || cell_a.v == '') && (cell_b === undefined || cell_b.v == '')) break;
            items.push({
                id_item: null,
                ean: worksheet['A' + row] === undefined ? '' : worksheet['A' + row].v.trim(),
                internal_code: worksheet['B' + row] === undefined ? '' : worksheet['B' + row].v.trim(),
                item_title: worksheet['C' + row] === undefined ? '' : worksheet['C' + row].v.trim(),
                quantity: worksheet['D' + row] === undefined ? '' : worksheet['D' + row].v,
                price: worksheet['E' + row] === undefined ? '' : worksheet['E' + row].v,
                tax_rate: worksheet['F' + row] === undefined ? '' : worksheet['F' + row].v * 100,
                id_tax_rate: -1,
                purchase_price_without_vat: worksheet['G' + row] === undefined ? '' : worksheet['G' + row].v,
                purchase_tax_rate: worksheet['H' + row] === undefined ? '' : worksheet['H' + row].v * 100,
                purchase_id_tax_rate: -1,
                purchase_discount: worksheet['I' + row] === undefined ? '' : worksheet['I' + row].v * 100,
                id_item_price_list: null,
                item_measuring_unit_decimal_digit_count: 0
            });
            row++;
        }
        // check for existence of tax rates
        const tax_rates_by_values = {};
        for(let id_tax_rate in this.props.tax_rates)tax_rates_by_values[parseFloat(this.props.tax_rates[id_tax_rate].value)] = id_tax_rate;
        const missing_tax_rates = [];
        for(let i = 0; i < items.length; i++){
            const id_tax_rate = tax_rates_by_values[items[i].tax_rate];
            if (id_tax_rate === undefined) {
                if (missing_tax_rates.indexOf(items[i].tax_rate) == -1) missing_tax_rates.push(items[i].tax_rate);
            } else items[i].id_tax_rate = id_tax_rate;
            const purchase_id_tax_rate = tax_rates_by_values[items[i].purchase_tax_rate];
            if (purchase_id_tax_rate === undefined) {
                if (missing_tax_rates.indexOf(items[i].purchase_tax_rate) == -1) missing_tax_rates.push(items[i].purchase_tax_rate);
            } else items[i].purchase_id_tax_rate = purchase_id_tax_rate;
        }
        // find existing items
        const items_by_internal_code = {};
        for(let id_item in this.props.items)items_by_internal_code[this.props.items[id_item].internal_code] = id_item;
        for(let i = 0; i < items.length; i++){
            if (items[i].internal_code == '') continue;
            items[i].id_item = items_by_internal_code[items[i].internal_code] || null;
            if (items[i].id_item !== null) {
                const item_item = this.props.items[items[i].id_item];
                items[i].item_title = item_item.title;
                items[i].ean = item_item.ean;
                items[i].id_item_price_list = this.findBestPriceListMatch(item_item);
                if (items[i].id_item_price_list !== null) items[i].id_tax_rate = item_item.price_lists[items[i].id_item_price_list].id_tax_rate;
                items[i].item_measuring_unit_decimal_digit_count = this.props.measuring_units[item_item.id_measuring_unit].decimal_digit_count;
            }
        }
        const items_by_ean = {};
        for(let id_item in this.props.items)items_by_ean[this.props.items[id_item].ean] = id_item;
        for(let i = 0; i < items.length; i++){
            if (items[i].id_item !== null) continue;
            if (items[i].ean == '') continue;
            items[i].id_item = items_by_ean[items[i].ean] || null;
        }
        if (missing_tax_rates.length > 0) {
            this.setState({
                import_failure_alert_open: true,
                import_failure_alert_missing_tax_rates: missing_tax_rates
            });
            return;
        }
        this.setState({
            document_items: this.convertDocumentItems({
                ...this.props.item,
                items
            }, this.state.read_only)
        });
    }
    openImportStockAcquisitionFromInventoryListFileDialog() {
        this.setState({
            import_inventory_list_dialog_open: true
        });
    }
    closeImportStockAcquisitionFromInventoryListFileDialog(data, type, sheet_name) {
        this.setState({
            import_inventory_list_dialog_open: false
        });
        if (data === undefined || data === null) return;
        const workbook = (0, _xlsxDefault.default).read(data, {
            type: 'array'
        });
        const items = [];
        const items_by_ean_and_internal_code = {};
        for(let id_item in this.props.items){
            const item = this.props.items[id_item];
            items_by_ean_and_internal_code[item.ean + '--' + item.internal_code] = item;
        }
        const warnings = {};
        const worksheet = workbook.Sheets[sheet_name];
        let row = 6; // skip first rows
        row--; // because we're incrementing at beginning of loop
        while(true){
            row++;
            const cell_a = worksheet['A' + row];
            const cell_a_val = cell_a === undefined ? '' : cell_a.v;
            if (cell_a_val == '' || cell_a_val.indexOf("\u0160tevilo zapisov:") > -1) break;
            let ean = worksheet['B' + row] === undefined ? '' : worksheet['B' + row].v;
            let internal_code = worksheet['C' + row] === undefined ? '' : worksheet['C' + row].v;
            let item_title = worksheet['D' + row] === undefined ? '' : worksheet['D' + row].v;
            ean = ((ean ?? '') + '').trim();
            internal_code = ((internal_code ?? '') + '').trim();
            item_title = ((item_title ?? '') + '').trim();
            const quantity_1 = worksheet['F' + row] === undefined ? '' : worksheet['F' + row].v;
            const quantity_2 = worksheet['G' + row] === undefined ? '' : worksheet['G' + row].v;
            if (quantity_1 === '' || quantity_2 === '') {
                const warning_key = "Manjka trenutna oz. inventurna koli\u010Dina pri artiklih";
                if (warnings[warning_key] === undefined) warnings[warning_key] = [];
                warnings[warning_key].push(internal_code + " \u2022 " + item_title + (ean.length == 0 ? '' : " \u2022 " + ean));
                continue;
            }
            const quantity = quantity_2 - quantity_1;
            if (type == 'surplus' && quantity <= 0) continue;
            if (type == 'deficit' && quantity >= 0) continue;
            if (quantity == 0) continue;
            const item = items_by_ean_and_internal_code[ean + '--' + internal_code];
            if (item === undefined) {
                const warning_key = 'Neznani artikli';
                if (warnings[warning_key] === undefined) warnings[warning_key] = [];
                warnings[warning_key].push(internal_code + " \u2022 " + item_title + (ean.length == 0 ? '' : " \u2022 " + ean));
                continue;
            }
            const id_item_price_list = this.findBestPriceListMatch(item);
            if (id_item_price_list === null) {
                const warning_key = 'Neznana MPC pri artiklih';
                if (warnings[warning_key] === undefined) warnings[warning_key] = [];
                warnings[warning_key].push(internal_code + " \u2022 " + item_title + (ean.length == 0 ? '' : " \u2022 " + ean));
                continue;
            }
            const item_price_list = item.price_lists[id_item_price_list];
            const tax_rate = this.props.tax_rates[item_price_list.id_tax_rate];
            const latest_price = this.findLatestPrice(item, true);
            if (latest_price.purchase_id_tax_rate === null) {
                const warning_key = 'Neznana nabavna cena pri artiklih';
                if (warnings[warning_key] === undefined) warnings[warning_key] = [];
                warnings[warning_key].push(internal_code + " \u2022 " + item_title + (ean.length == 0 ? '' : " \u2022 " + ean));
                continue;
            }
            const id_warehouse = this.state.id_warehouse;
            const purchase_price_without_vat = id_warehouse === null || id_warehouse == '-1' ? 0 : this.props.last_stock_data_by_date[(0, _momentDefault.default)(this.state.book_date).format('YYYY-MM-DD')].last_stock_data[item.id_item + '--' + id_warehouse]?.item_price ?? 0;
            items.push({
                id_item: item.id_item,
                ean,
                internal_code,
                item_title,
                quantity,
                price: worksheet['E' + row] === undefined ? '' : worksheet['E' + row].v,
                tax_rate: tax_rate.value,
                id_tax_rate: tax_rate.id_tax_rate,
                purchase_price_without_vat,
                purchase_tax_rate: this.props.tax_rates[latest_price.purchase_id_tax_rate].value,
                purchase_id_tax_rate: latest_price.purchase_id_tax_rate,
                purchase_discount: 0,
                id_item_price_list,
                item_measuring_unit_decimal_digit_count: this.props.measuring_units[item.id_measuring_unit].decimal_digit_count
            });
        }
        if (Object.keys(warnings).length > 0) this.setState({
            import_failure_alert_open: true,
            import_failure_alert_warnings: warnings
        });
        this.setState({
            document_items: this.convertDocumentItems({
                ...this.props.item,
                items
            }, this.state.read_only)
        });
    }
    findBestPriceListMatch(item) {
        if (item === undefined || item === null || this.state.document_date === null || this.state.document_date === undefined) return null;
        return (0, _priceHelperDefault.default).FindBestPriceListMatch(this.state.document_date, item.price_lists);
    }
    findLatestPrice(item, skip_stock_acquisition_documents) {
        skip_stock_acquisition_documents = skip_stock_acquisition_documents || false;
        let stock_acquisition_documents = skip_stock_acquisition_documents ? [] : Object.values(this.props.stock_acquisition_documents);
        // limit to current document
        //if (this.props.item !== null) {
        //	stock_acquisition_documents = stock_acquisition_documents.filter(x => x.id_stock_acquisition_document == this.state.id_stock_acquisition_document)
        //}
        stock_acquisition_documents = stock_acquisition_documents.map((x)=>{
            let found_item = null;
            for(let i = 0; i < x.items.length; i++)if (x.items[i].id_item == item.id_item) found_item = x.items[i];
            return {
                document_date: x.document_date,
                stock_acquisition_document_item: found_item
            };
        }).filter((x)=>x.stock_acquisition_document_item !== null).sort((a, b)=>{
            if (a.document_date > b.document_date) return -1;
            else if (a.document_date < b.document_date) return 1;
            return 0;
        });
        if (stock_acquisition_documents.length > 0) {
            const stock_acquisition_document_item = stock_acquisition_documents[0].stock_acquisition_document_item;
            const id_item_price_list = this.findBestPriceListMatch(this.props.items[stock_acquisition_document_item.id_item]);
            return {
                id_tax_rate: stock_acquisition_document_item.id_tax_rate,
                price: stock_acquisition_document_item.price,
                purchase_id_tax_rate: stock_acquisition_document_item.purchase_id_tax_rate,
                purchase_price_without_vat: stock_acquisition_document_item.purchase_price_without_vat,
                id_item_price_list: id_item_price_list
            };
        }
        const id_item_price_list = this.findBestPriceListMatch(item);
        if (id_item_price_list !== null) {
            const retval = {
                id_tax_rate: item.price_lists[id_item_price_list].id_tax_rate,
                price: item.price_lists[id_item_price_list].price,
                purchase_id_tax_rate: 0,
                purchase_price_without_vat: 0,
                id_item_price_list
            };
            retval.purchase_id_tax_rate = retval.id_tax_rate;
            retval.purchase_price_without_vat = retval.price / (1 + this.props.tax_rates[retval.id_tax_rate].value / 100);
            return retval;
        }
        return {
            id_tax_rate: null,
            price: this.props.items[item.id_item].price,
            purchase_id_tax_rate: -1,
            purchase_price_without_vat: 0,
            id_item_price_list: -1
        };
    }
    setInvoiceItems(document_items) {
        this.setState({
            document_items
        });
    }
    filterItems(props) {
        props = props || this.props;
        const items = {};
        for(let id_item in props.items){
            const item = props.items[id_item];
            if (item.type == 'item') items[id_item] = item;
        }
        return items;
    }
    validate() {
        const messages = [];
        if (this.state.supplier_id_customer === null) messages.push('Dobavitelj ni izbran');
        if (this.state.id_warehouse === null || this.state.id_warehouse == '-1') messages.push("Skladi\u0161\u010De ni izbrano");
        if (this.state.type === null || this.state.type == '-1') messages.push('Tip prevzema ni izbran');
        if (this.state.document_date === null) messages.push('Datum prevzema ni izbran');
        if (this.state.book_date === null) messages.push("Datum knji\u017Eenja ni izbran");
        if (this.state.document_items.length <= 1) messages.push('Dokument ne sme biti prazen');
        const internal_code_counts = {};
        const ean_counts = {};
        const quantity_must_be_positive = this.state.type == 'internal-transfer';
        let negative_quantities_exist = false;
        for(let i = 0; i < this.state.document_items.length; i++){
            const item = this.state.document_items[i];
            if (item.invoice_item.id_item == -1) continue;
            let title = item.invoice_item.item_title;
            if (title === null && item.invoice_item.id_item !== null && this.props.items[item.invoice_item.id_item] !== undefined) title = this.props.items[item.invoice_item.id_item].title;
            if (item.invoice_item.internal_code !== null && item.invoice_item.internal_code.length > 0) {
                if (internal_code_counts[item.invoice_item.internal_code] === undefined) internal_code_counts[item.invoice_item.internal_code] = {
                    id_item: item.invoice_item.id_item,
                    title,
                    count: 0
                };
                internal_code_counts[item.invoice_item.internal_code].count++;
            }
            if (item.invoice_item.ean !== null && item.invoice_item.ean.length > 0) {
                if (ean_counts[item.invoice_item.ean] === undefined) ean_counts[item.invoice_item.ean] = {
                    id_item: item.invoice_item.id_item,
                    title,
                    count: 0
                };
                ean_counts[item.invoice_item.ean].count++;
            }
            if ([
                item.price_with_vat,
                item.purchase_price_with_vat,
                item.purchase_price_without_vat,
                item.single_purchase_price_with_discount_with_vat,
                item.single_purchase_price_with_discount_without_vat,
                item.single_purchase_price_with_vat,
                item.single_purchase_price_without_vat,
                item.invoice_item.price,
                item.invoice_item.purchase_discount,
                item.invoice_item.purchase_price_without_vat,
                item.invoice_item.quantity
            ].some((x)=>isNaN(x) || x === '')) messages.push('Artikel ' + (title === null ? 'neznano' : title) + ' ima vsaj eno neveljavno vrednost');
            if (item.invoice_item.quantity == 0) messages.push('Artikel ' + (title === null ? 'neznano' : title) + " ima koli\u010Dino 0");
            if (item.price_with_vat <= 0) messages.push('Artikel ' + (title === null ? 'neznano' : title) + ' ima ceno 0 ali manj');
            if (item.single_purchase_price_without_vat_formatted <= 0) messages.push('Artikel ' + (title === null ? 'neznano' : title) + ' ima nabavno ceno 0 ali manj');
            if (item.invoice_item.id_tax_rate == -1 || item.invoice_item.purchase_id_tax_rate == -1) messages.push('Artikel ' + (title === null ? 'neznano' : title) + " nima nastavljene dav\u010Dne stopnje");
            if (quantity_must_be_positive && item.invoice_item.quantity < 0) negative_quantities_exist = true;
        }
        for(let internal_code in internal_code_counts){
            if (internal_code_counts[internal_code].count <= 1) continue;
            const title = internal_code_counts[internal_code].title;
            messages.push('Artikel ' + (title === null ? 'neznano' : title) + " se ponovi ve\u010D kot enkrat");
        }
        for(let ean in ean_counts){
            if (ean_counts[ean].count <= 1) continue;
            const title = ean_counts[ean].title;
            const message = 'Artikel ' + (title === null ? 'neznano' : title) + " se ponovi ve\u010D kot enkrat";
            if (messages.indexOf(message) == -1) messages.push(message);
        }
        if (negative_quantities_exist) messages.push("Vse koli\u010Dine morajo biti pozitivne");
        if (this.state.type == 'internal-transfer' && this.state.stock_from_id_warehouse === null) messages.push("Pri prenosu med skladi\u0161\u010Di morata biti izbrani obe skladi\u0161\u010Di");
        if (this.state.stock_from_id_warehouse !== null && this.state.stock_from_id_warehouse === this.state.id_warehouse) messages.push("Zalogo je lahko prene\u0161ena samo v drugo skladi\u0161\u010De");
        return messages;
    }
    calculateSums() {
        const sums = {
            purchase_price_without_vat: 0,
            purchase_price_with_vat: 0,
            quantity: 0,
            count: 0
        };
        for(let i = 0; i < this.state.document_items.length; i++){
            const item = this.state.document_items[i];
            if (item.invoice_item.id_item === -1) continue;
            sums.purchase_price_without_vat += parseFloat(item.purchase_price_without_vat);
            sums.purchase_price_with_vat += parseFloat(item.purchase_price_with_vat);
            sums.quantity += parseFloat(item.invoice_item.quantity);
            sums.count += 1;
        }
        return sums;
    }
    loadStockInventoryForDate(date_iso) {
        (0, _warehouses.loadLastStockDataByDate)(this.props.api_url, this.props.dispatch, this.props.token, date_iso);
    }
    render() {
        const customer = this.state.supplier_id_customer === null ? null : this.props.customers[this.state.supplier_id_customer] || null;
        const sums = this.calculateSums();
        const disabled = this.state.id_warehouse === null || this.state.id_warehouse == '-1' || this.state.type === null || this.state.type == '-1' || this.state.book_date === null || this.props.last_stock_data_by_date[(0, _momentDefault.default)(this.state.book_date).format('YYYY-MM-DD')] === undefined;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: false,
            className: "add-edit-stock-acquisition-document-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    !this.state.select_customer_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectCustomerDialogDefault.default), {
                        closeSelectCustomerDialog: this.closeSelectCustomerDialog,
                        surname: this.state.select_customer_dialog_surname,
                        item: null
                    }),
                    !this.state.close_dialog_confirm_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                        cancelButtonText: "Prekli\u010Di",
                        confirmButtonText: "Zapri",
                        canEscapeKeyCancel: true,
                        canOutsideClickCancel: true,
                        icon: "help",
                        intent: (0, _core.Intent).PRIMARY,
                        isOpen: true,
                        onConfirm: ()=>{
                            this.closeDialog(false, this.state.close_dialog_save_as_draft);
                            this.setState({
                                close_dialog_save_as_draft: false,
                                close_dialog_confirm_open: false
                            });
                        },
                        onCancel: ()=>{
                            this.setState({
                                close_dialog_save_as_draft: false,
                                close_dialog_confirm_open: false
                            });
                        },
                        children: "Res \u017Eelite zapreti brez shranjevanja?"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                        confirmButtonText: "V redu",
                        icon: "warning-sign",
                        intent: (0, _core.Intent).WARNING,
                        isOpen: this.state.import_failure_alert_open && this.state.import_failure_alert_missing_tax_rates.length > 0,
                        onConfirm: ()=>{
                            this.setState({
                                import_failure_alert_open: false,
                                import_failure_alert_missing_tax_rates: []
                            });
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "bp5-heading",
                                    children: "Uvoz ni uspel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        "Manjkajo naslednje stopnje davka: ",
                                        this.state.import_failure_alert_missing_tax_rates.map((x)=>this.formatNumber(x) + '%').join(', ')
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                        confirmButtonText: "V redu",
                        icon: "warning-sign",
                        intent: (0, _core.Intent).WARNING,
                        isOpen: this.state.import_failure_alert_open && Object.keys(this.state.import_failure_alert_warnings).length > 0,
                        onConfirm: ()=>{
                            this.setState({
                                import_failure_alert_open: false,
                                import_failure_alert_warnings: []
                            });
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "bp5-heading",
                                    children: "Uvoz ni uspel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-selectable",
                                    children: Object.keys(this.state.import_failure_alert_warnings).map((warning)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "text-selectable",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-selectable font-semibold mt-1",
                                                    children: warning + ':'
                                                }),
                                                this.state.import_failure_alert_warnings[warning].map((x, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-selectable",
                                                        children: x
                                                    }, 'warning-' + warning + '-' + idx))
                                            ]
                                        }, warning))
                                })
                            ]
                        })
                    }),
                    !this.state.select_customer_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectCustomerDialogDefault.default), {
                        closeSelectCustomerDialog: this.closeSelectCustomerDialog,
                        surname: this.state.select_customer_dialog_surname,
                        item: this.state.select_customer_dialog_item
                    }),
                    !this.state.import_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importStockAcquisitionFileDialogDefault.default), {
                        closeDialog: this.closeImportStockAcquisitionFileDialog
                    }),
                    !this.state.import_inventory_list_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importStockAcquisitionFromInventoryListFileDialogDefault.default), {
                        closeDialog: this.closeImportStockAcquisitionFromInventoryListFileDialog
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                        isOpen: this.state.confirm_price_overwrite_dialog_open,
                        usePortal: true,
                        canOutsideClickCancel: false,
                        canEscapeKeyCancel: false,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col flex-grow",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _core.Classes).DIALOG_BODY,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h5", {
                                            className: "bp5-heading pb-4",
                                            children: [
                                                "Prodajne cene dolo\u010Denih artiklov so se spremenile.",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                "Ozna\u010Dite tiste, katere \u017Eelite spremeniti."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: Object.keys(this.state.confirm_price_overwrite_dialog_checked).map((id_stock_acquisition_document_item)=>{
                                                const item = this.state.confirm_price_overwrite_dialog_items[id_stock_acquisition_document_item];
                                                let internal_code = item.internal_code;
                                                let title = item.title;
                                                let ean = item.ean;
                                                if (internal_code === null || title === null || ean === null) {
                                                    const item_item = this.props.items[item.id_item];
                                                    internal_code = item_item.internal_code;
                                                    title = item_item.title;
                                                    ean = item_item.ean;
                                                }
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    label: internal_code + " \u2022 " + title + (ean.length == 0 ? '' : " \u2022 " + ean),
                                                    checked: this.state.confirm_price_overwrite_dialog_checked[item.id_stock_acquisition_document_item],
                                                    onChange: (event)=>{
                                                        const confirm_price_overwrite_dialog_checked = {
                                                            ...this.state.confirm_price_overwrite_dialog_checked
                                                        };
                                                        confirm_price_overwrite_dialog_checked[item.id_stock_acquisition_document_item] = event.target.checked;
                                                        this.setState({
                                                            confirm_price_overwrite_dialog_checked
                                                        });
                                                    }
                                                }, 'overwrite-' + item.id_stock_acquisition_document_item);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                minimal: true,
                                                onClick: ()=>{
                                                    this.setState({
                                                        confirm_price_overwrite_dialog_open: false,
                                                        confirm_price_overwrite_dialog_checked: {},
                                                        confirm_price_overwrite_dialog_item: null
                                                    });
                                                },
                                                children: "Prekli\u010Di"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                intent: (0, _core.Intent).PRIMARY,
                                                onClick: ()=>{
                                                    this.closeDialogWithIgnore(this.state.confirm_price_overwrite_dialog_item, [
                                                        ...Object.keys(this.state.confirm_price_overwrite_dialog_checked).filter((x)=>!this.state.confirm_price_overwrite_dialog_checked[x]),
                                                        ...this.state.ignore_prices_for_ids
                                                    ]);
                                                },
                                                children: "Nadaljuj"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: 'Vnos prevzema'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        icon: "import",
                                        onClick: ()=>this.openImportStockAcquisitionFromInventoryListFileDialog(),
                                        className: "w-64 mr-2",
                                        disabled: disabled,
                                        children: "Uvozi iz Excela (inventurni list)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        icon: "import",
                                        onClick: ()=>this.openImportStockAcquisitionFileDialog(),
                                        className: "w-56 mr-10",
                                        disabled: disabled,
                                        children: "Uvozi iz Excela (prevzem)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        icon: "floppy-disk",
                                        onClick: ()=>this.closeDialog(true, true),
                                        className: "w-48",
                                        disabled: true,
                                        children: "Shrani kot osnutek"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "success",
                                        icon: "tick",
                                        onClick: ()=>this.closeDialog(true, false),
                                        className: "w-48 ml-2",
                                        disabled: false,
                                        children: "Zapri in zaklju\u010Di"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "danger",
                                        icon: "cross",
                                        onClick: ()=>this.confirmCloseWithoutSave(),
                                        className: "w-48 ml-10",
                                        children: "Zapri brez shranjevanja"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-grow flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "invoice-header",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "document-number",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                                className: "bp5-heading",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-thin",
                                                        children: "Prevzem \u0161t.: "
                                                    }),
                                                    this.state.draft ? 'osnutek' : this.state.document_number
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "customer",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerSelectDefault.default), {
                                                    itemSelected: (item)=>{
                                                        this.setState({
                                                            supplier_id_customer: item.id_customer
                                                        });
                                                    },
                                                    addPersonClick: (query)=>{
                                                        this.openSelectCustomerDialog(query);
                                                    },
                                                    fieldTitle: "Dobavitelj",
                                                    formGroupCls: "mb-0",
                                                    focus: true,
                                                    itemFilter: (item)=>item.supplier === true
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "customer-info",
                                                    style: {
                                                        position: 'relative'
                                                    },
                                                    children: customer === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "customer-info-inner",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: (()=>{
                                                                            const arr = [];
                                                                            if (customer.address.length > 0) arr.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                children: customer.address
                                                                            }, "address"));
                                                                            if (customer.post_office.length > 0) arr.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                children: (customer.post_code + ' ' + customer.post_office).trim()
                                                                            }, "post-office"));
                                                                            if (customer.id_country !== null) arr.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                children: this.props.countries[customer.id_country].iso_3166_1_a2
                                                                            }, "country"));
                                                                            return arr;
                                                                        })()
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "pt-2",
                                                                        children: customer.vat_registered ? 'ID za DDV: ' + customer.vat_prefix + customer.tax_number : "Dav\u010Dna \u0161t.: " + customer.tax_number
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "opacity-50 text-right pr-2",
                                                                style: {
                                                                    position: 'absolute',
                                                                    right: 0,
                                                                    bottom: 0
                                                                },
                                                                children: customer.internal_code
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                style: {
                                                                    position: 'absolute',
                                                                    right: 0,
                                                                    top: 11
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                    icon: "edit",
                                                                    minimal: true,
                                                                    onClick: ()=>{
                                                                        this.openSelectCustomerDialog('', customer);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                style: {
                                                                    position: 'absolute',
                                                                    right: 0,
                                                                    top: 32
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                    icon: "cross",
                                                                    minimal: true,
                                                                    onClick: ()=>{
                                                                        this.setState({
                                                                            supplier_id_customer: null
                                                                        });
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "document-date",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--document-date",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Datum prevzema",
                                                        tooltip: "Datum prevzema"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                        id: "add-edit-stock-acq-document--document-date",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: 'dd. MM. yyyy',
                                                        locale: "sl",
                                                        inputProps: {
                                                            placeholder: '01. 01. ' + new Date().getFullYear()
                                                        },
                                                        selectAllOnFocus: true,
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                        disabled: this.state.read_only,
                                                        onChange: (selectedDate, isUserChange)=>{
                                                            if (isUserChange) this.setState({
                                                                document_date: selectedDate === null ? null : new Date(selectedDate)
                                                            });
                                                        },
                                                        value: this.state.document_date === null ? null : (0, _formatISODefault.default)(this.state.document_date)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "book-date",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--book-date",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Datum knji\u017Eenja",
                                                        tooltip: "Datum knji\u017Eenja"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                        id: "add-edit-stock-acq-document--book-date",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: 'dd. MM. yyyy',
                                                        locale: "sl",
                                                        inputProps: {
                                                            placeholder: '01. 01. ' + new Date().getFullYear()
                                                        },
                                                        selectAllOnFocus: true,
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                        onChange: (selectedDate, isUserChange)=>{
                                                            if (isUserChange) this.setState({
                                                                book_date: selectedDate === null ? null : new Date(selectedDate)
                                                            });
                                                        },
                                                        value: this.state.book_date === null ? null : (0, _formatISODefault.default)(this.state.book_date)
                                                    })
                                                ]
                                            })
                                        }),
                                        null,
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "delivery-note-date",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--delivery-note-date",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Datum dobavnice",
                                                        tooltip: "Datum dobavnice"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                        id: "add-edit-stock-acq-document--delivery-note-date",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: 'dd. MM. yyyy',
                                                        locale: "sl",
                                                        inputProps: {
                                                            placeholder: '01. 01. ' + new Date().getFullYear()
                                                        },
                                                        selectAllOnFocus: true,
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                        disabled: this.state.read_only,
                                                        onChange: (selectedDate, isUserChange)=>{
                                                            if (isUserChange) this.setState({
                                                                delivery_note_date: selectedDate === null ? null : new Date(selectedDate)
                                                            });
                                                        },
                                                        value: this.state.delivery_note_date === null ? null : (0, _formatISODefault.default)(this.state.delivery_note_date)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "delivery-note-number",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--delivery-note-number",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "\u0160tevilka dobavnice",
                                                        tooltip: "\u0160tevilka dobavnice"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                        id: "add-edit-stock-acq-document--delivery-note-number",
                                                        value: this.state.delivery_note_number,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                delivery_note_number: event.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "type",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--type",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Vrsta prevzema",
                                                        tooltip: "Vrsta prevzema"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                        id: "add-edit-stock-acq-document--type",
                                                        fill: true,
                                                        options: [
                                                            {
                                                                label: '-- izberi --',
                                                                value: -1
                                                            },
                                                            ...Object.keys(Types).map((x)=>{
                                                                return {
                                                                    label: Types[x],
                                                                    value: x
                                                                };
                                                            })
                                                        ],
                                                        value: this.state.type || '',
                                                        onChange: (e)=>{
                                                            this.setState({
                                                                type: e.currentTarget.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "warehouse",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--warehouse",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: this.state.type == 'internal-transfer' ? "Ciljno skladi\u0161\u010De" : "Skladi\u0161\u010De",
                                                        tooltip: "Skladi\u0161\u010De"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                        id: "add-edit-stock-acq-document--warehouse",
                                                        fill: true,
                                                        options: [
                                                            {
                                                                label: '-- izberi --',
                                                                value: -1
                                                            },
                                                            ...Object.values(this.props.warehouses).map((x)=>{
                                                                return {
                                                                    label: x.title,
                                                                    value: x.id_warehouse
                                                                };
                                                            })
                                                        ],
                                                        value: this.state.id_warehouse || '',
                                                        onChange: (e)=>{
                                                            this.setState({
                                                                id_warehouse: e.currentTarget.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "stock-from-warehouse",
                                            children: this.state.type != 'internal-transfer' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--stock-from-warehouse",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Zaloga iz skladi\u0161\u010Da",
                                                        tooltip: "Zaloga iz skladi\u0161\u010Da"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                        id: "add-edit-stock-acq-document--stock-from-warehouse",
                                                        fill: true,
                                                        options: [
                                                            {
                                                                label: '-- izberi --',
                                                                value: -1
                                                            },
                                                            ...Object.values(this.props.warehouses).map((x)=>{
                                                                return {
                                                                    label: x.title,
                                                                    value: x.id_warehouse
                                                                };
                                                            })
                                                        ],
                                                        value: this.state.stock_from_id_warehouse || '',
                                                        onChange: (e)=>{
                                                            this.setState({
                                                                stock_from_id_warehouse: e.currentTarget.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "documents flex flex-row",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Tabs), {
                                                className: "flex flex-col flex-1",
                                                vertical: false,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                        id: "comment",
                                                        title: "Opomba",
                                                        panelClassName: "flex-grow",
                                                        panel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                            className: "table-full-h",
                                                            fill: true,
                                                            onChange: (e)=>{
                                                                this.setState({
                                                                    note: e.target.value
                                                                });
                                                            },
                                                            value: this.state.note
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                        id: "documents",
                                                        title: "Dokumenti",
                                                        panelClassName: "flex-grow h-full",
                                                        panel: this.props.item === null || this.props.item.id_stock_acquisition_document === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentsDefault.default), {
                                                            id_document: this.props.item.id_stock_acquisition_document,
                                                            deep: true
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-list-wrapper flex-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "items-list-scroll-container",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "items-list",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ItemsList, {
                                                read_only: this.state.read_only,
                                                document_items: this.state.document_items,
                                                items: this.state.filtered_items,
                                                tax_rates: this.props.tax_rates,
                                                invoice_date: this.state.invoice_date,
                                                measuring_units: this.props.measuring_units,
                                                stock_state: disabled ? null : this.props.last_stock_data_by_date[(0, _momentDefault.default)(this.state.book_date).format('YYYY-MM-DD')],
                                                setInvoiceItems: this.setInvoiceItems,
                                                document_date: this.state.document_date,
                                                findBestPriceListMatch: this.findBestPriceListMatch,
                                                findLatestPrice: this.findLatestPrice,
                                                id_warehouse: this.state.id_warehouse,
                                                type: this.state.type,
                                                disabled: disabled
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "items-summary font-semibold text-base",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-1 font-normal",
                                            children: "\u0160tevilo vrstic:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-3 text-right font-normal",
                                            children: sums.count
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-5",
                                            children: "Rabat:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-6 text-right",
                                            children: this.formatNumber(0)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-8",
                                            children: "Znesek brez DDV:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-9 text-right",
                                            children: this.formatNumber(sums.purchase_price_without_vat)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-1 font-normal",
                                            children: "Skupna koli\u010Dina:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-3 text-right font-normal",
                                            children: sums.quantity
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-5",
                                            children: "Odvisni stro\u0161ki:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-6 text-right",
                                            children: this.formatNumber(0)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-8",
                                            children: "Znesek DDV:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-9 text-right",
                                            children: this.formatNumber(sums.purchase_price_with_vat - sums.purchase_price_without_vat)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-5"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-6"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-8",
                                            children: "Znesek z DDV:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-9 text-right",
                                            children: this.formatNumber(sums.purchase_price_with_vat)
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditStockAcquisitionDocumentDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func
};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        payment_types: state.CodeTablesSlice.payment_types,
        items: state.CodeTablesSlice.items,
        countries: state.CodeTablesSlice.countries,
        tax_rates: state.CodeTablesSlice.tax_rates,
        measuring_units: state.CodeTablesSlice.measuring_units,
        warehouses: state.CodeTablesSlice.warehouses,
        api_url: state.CodeTablesSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        settings: state.SettingsSlice,
        document_types: state.DocumentSlice.document_types,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        invoices: state.BusinessSlice.invoices,
        advance_invoice_consumptions: state.BusinessSlice.advance_invoice_consumptions,
        id_advance_invoice_consumption_by_id_consumer_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_consumer_invoices,
        stock_acquisition_documents: state.WarehouseSlice.stock_acquisition_documents,
        last_stock_data_by_date: state.WarehouseSlice.last_stock_data_by_date
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddEditStockAcquisitionDocumentDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","uuid":"b52pV","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","@blueprintjs/select":"3IMc6","moment":"1e4qG","date-fns/formatISO":"an1FA","xlsx":"eqXnQ","../TextWithTooltip":"6kuHH","../CustomerSelect":"8sizu","../reservations/SelectCustomerDialog":"ewc5P","../../numbers":"jOh9w","../Documents":"jYQ4x","./ImportStockAcquisitionFileDialog":"4TW7P","./ImportStockAcquisitionFromInventoryListFileDialog":"jOAEO","../../helpers/PriceHelper":"91cdD","../AppToaster":"izixN","../../api/Warehouses":"WVdXb","../../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eqXnQ":[function(require,module,exports,__globalThis) {
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global global, exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false */ var global = arguments[3];
var Buffer = require("a66ff1c21c5e5b1").Buffer;
var process = require("bfbde4dddeb0bada");
var XLSX = {};
function make_xlsx_lib(XLSX) {
    XLSX.version = '0.16.9';
    var current_codepage = 1200, current_ansi = 1252;
    if (typeof cptable === 'undefined') {
        if (typeof global !== 'undefined') global.cptable = require("919a7bedd2525af3");
        else if (typeof window !== 'undefined') window.cptable = require("919a7bedd2525af3");
    }
    var VALID_ANSI = [
        874,
        932,
        936,
        949,
        950
    ];
    for(var i = 0; i <= 8; ++i)VALID_ANSI.push(1250 + i);
    /* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var CS2CP = {
        0: 1252,
        /* ANSI */ 1: 65001,
        /* DEFAULT */ 2: 65001,
        /* SYMBOL */ 77: 10000,
        /* MAC */ 128: 932,
        /* SHIFTJIS */ 129: 949,
        /* HANGUL */ 130: 1361,
        /* JOHAB */ 134: 936,
        /* GB2312 */ 136: 950,
        /* CHINESEBIG5 */ 161: 1253,
        /* GREEK */ 162: 1254,
        /* TURKISH */ 163: 1258,
        /* VIETNAMESE */ 177: 1255,
        /* HEBREW */ 178: 1256,
        /* ARABIC */ 186: 1257,
        /* BALTIC */ 204: 1251,
        /* RUSSIAN */ 222: 874,
        /* THAI */ 238: 1250,
        /* EASTEUROPE */ 255: 1252,
        /* OEM */ 69: 6969 /* MISC */ 
    };
    var set_ansi = function(cp) {
        if (VALID_ANSI.indexOf(cp) == -1) return;
        current_ansi = CS2CP[0] = cp;
    };
    function reset_ansi() {
        set_ansi(1252);
    }
    var set_cp = function(cp) {
        current_codepage = cp;
        set_ansi(cp);
    };
    function reset_cp() {
        set_cp(1200);
        reset_ansi();
    }
    function char_codes(data) {
        var o = [];
        for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
        return o;
    }
    function utf16leread(data) {
        var o = [];
        for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
        return o.join("");
    }
    function utf16beread(data) {
        var o = [];
        for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
        return o.join("");
    }
    var debom = function(data) {
        var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
        if (c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
        if (c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
        if (c1 == 0xFEFF) return data.slice(1);
        return data;
    };
    var _getchar = function _gc1(x) {
        return String.fromCharCode(x);
    };
    var _getansi = function _ga1(x) {
        return String.fromCharCode(x);
    };
    if (typeof cptable !== 'undefined') {
        set_cp = function(cp) {
            current_codepage = cp;
            set_ansi(cp);
        };
        debom = function(data) {
            if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return cptable.utils.decode(1200, char_codes(data.slice(2)));
            return data;
        };
        _getchar = function _gc2(x) {
            if (current_codepage === 1200) return String.fromCharCode(x);
            return cptable.utils.decode(current_codepage, [
                x & 255,
                x >> 8
            ])[0];
        };
        _getansi = function _ga2(x) {
            return cptable.utils.decode(current_ansi, [
                x
            ])[0];
        };
    }
    var DENSE = null;
    var DIF_XL = true;
    var Base64 = function make_b64() {
        var map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        return {
            encode: function(input) {
                var o = "";
                var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
                for(var i = 0; i < input.length;){
                    c1 = input.charCodeAt(i++);
                    e1 = c1 >> 2;
                    c2 = input.charCodeAt(i++);
                    e2 = (c1 & 3) << 4 | c2 >> 4;
                    c3 = input.charCodeAt(i++);
                    e3 = (c2 & 15) << 2 | c3 >> 6;
                    e4 = c3 & 63;
                    if (isNaN(c2)) e3 = e4 = 64;
                    else if (isNaN(c3)) e4 = 64;
                    o += map.charAt(e1) + map.charAt(e2) + map.charAt(e3) + map.charAt(e4);
                }
                return o;
            },
            decode: function b64_decode(input) {
                var o = "";
                var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
                input = input.replace(/[^\w\+\/\=]/g, "");
                for(var i = 0; i < input.length;){
                    e1 = map.indexOf(input.charAt(i++));
                    e2 = map.indexOf(input.charAt(i++));
                    c1 = e1 << 2 | e2 >> 4;
                    o += String.fromCharCode(c1);
                    e3 = map.indexOf(input.charAt(i++));
                    c2 = (e2 & 15) << 4 | e3 >> 2;
                    if (e3 !== 64) o += String.fromCharCode(c2);
                    e4 = map.indexOf(input.charAt(i++));
                    c3 = (e3 & 3) << 6 | e4;
                    if (e4 !== 64) o += String.fromCharCode(c3);
                }
                return o;
            }
        };
    }();
    var has_buf = typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node;
    var Buffer_from = function() {};
    if (typeof Buffer !== 'undefined') {
        var nbfs = !Buffer.from;
        if (!nbfs) try {
            Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        Buffer_from = nbfs ? function(buf, enc) {
            return enc ? new Buffer(buf, enc) : new Buffer(buf);
        } : Buffer.from.bind(Buffer);
        // $FlowIgnore
        if (!Buffer.alloc) Buffer.alloc = function(n) {
            return new Buffer(n);
        };
        // $FlowIgnore
        if (!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) {
            return new Buffer(n);
        };
    }
    function new_raw_buf(len) {
        /* jshint -W056 */ return has_buf ? Buffer.alloc(len) : new Array(len);
    /* jshint +W056 */ }
    function new_unsafe_buf(len) {
        /* jshint -W056 */ return has_buf ? Buffer.allocUnsafe(len) : new Array(len);
    /* jshint +W056 */ }
    var s2a = function s2a(s) {
        if (has_buf) return Buffer_from(s, "binary");
        return s.split("").map(function(x) {
            return x.charCodeAt(0) & 0xff;
        });
    };
    function s2ab(s) {
        if (typeof ArrayBuffer === 'undefined') return s2a(s);
        var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
        for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
    function a2s(data) {
        if (Array.isArray(data)) return data.map(function(c) {
            return String.fromCharCode(c);
        }).join("");
        var o = [];
        for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
        return o.join("");
    }
    function a2u(data) {
        if (typeof Uint8Array === 'undefined') throw new Error("Unsupported");
        return new Uint8Array(data);
    }
    function ab2a(data) {
        if (typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
        if (data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
        var o = new Array(data.length);
        for(var i = 0; i < data.length; ++i)o[i] = data[i];
        return o;
    }
    var bconcat = function(bufs) {
        return [].concat.apply([], bufs);
    };
    var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
    /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ var SSF = {};
    var make_ssf = function make_ssf(SSF) {
        SSF.version = '0.11.2';
        function _strrev(x) {
            var o = "", i = x.length - 1;
            while(i >= 0)o += x.charAt(i--);
            return o;
        }
        function fill(c, l) {
            var o = "";
            while(o.length < l)o += c;
            return o;
        }
        function pad0(v, d) {
            var t = "" + v;
            return t.length >= d ? t : fill('0', d - t.length) + t;
        }
        function pad_(v, d) {
            var t = "" + v;
            return t.length >= d ? t : fill(' ', d - t.length) + t;
        }
        function rpad_(v, d) {
            var t = "" + v;
            return t.length >= d ? t : t + fill(' ', d - t.length);
        }
        function pad0r1(v, d) {
            var t = "" + Math.round(v);
            return t.length >= d ? t : fill('0', d - t.length) + t;
        }
        function pad0r2(v, d) {
            var t = "" + v;
            return t.length >= d ? t : fill('0', d - t.length) + t;
        }
        var p2_32 = Math.pow(2, 32);
        function pad0r(v, d) {
            if (v > p2_32 || v < -p2_32) return pad0r1(v, d);
            var i = Math.round(v);
            return pad0r2(i, d);
        }
        function isgeneral(s, i) {
            i = i || 0;
            return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
        }
        var days = [
            [
                'Sun',
                'Sunday'
            ],
            [
                'Mon',
                'Monday'
            ],
            [
                'Tue',
                'Tuesday'
            ],
            [
                'Wed',
                'Wednesday'
            ],
            [
                'Thu',
                'Thursday'
            ],
            [
                'Fri',
                'Friday'
            ],
            [
                'Sat',
                'Saturday'
            ]
        ];
        var months = [
            [
                'J',
                'Jan',
                'January'
            ],
            [
                'F',
                'Feb',
                'February'
            ],
            [
                'M',
                'Mar',
                'March'
            ],
            [
                'A',
                'Apr',
                'April'
            ],
            [
                'M',
                'May',
                'May'
            ],
            [
                'J',
                'Jun',
                'June'
            ],
            [
                'J',
                'Jul',
                'July'
            ],
            [
                'A',
                'Aug',
                'August'
            ],
            [
                'S',
                'Sep',
                'September'
            ],
            [
                'O',
                'Oct',
                'October'
            ],
            [
                'N',
                'Nov',
                'November'
            ],
            [
                'D',
                'Dec',
                'December'
            ]
        ];
        function init_table(t) {
            t[0] = 'General';
            t[1] = '0';
            t[2] = '0.00';
            t[3] = '#,##0';
            t[4] = '#,##0.00';
            t[9] = '0%';
            t[10] = '0.00%';
            t[11] = '0.00E+00';
            t[12] = '# ?/?';
            t[13] = '# ??/??';
            t[14] = 'm/d/yy';
            t[15] = 'd-mmm-yy';
            t[16] = 'd-mmm';
            t[17] = 'mmm-yy';
            t[18] = 'h:mm AM/PM';
            t[19] = 'h:mm:ss AM/PM';
            t[20] = 'h:mm';
            t[21] = 'h:mm:ss';
            t[22] = 'm/d/yy h:mm';
            t[37] = '#,##0 ;(#,##0)';
            t[38] = '#,##0 ;[Red](#,##0)';
            t[39] = '#,##0.00;(#,##0.00)';
            t[40] = '#,##0.00;[Red](#,##0.00)';
            t[45] = 'mm:ss';
            t[46] = '[h]:mm:ss';
            t[47] = 'mmss.0';
            t[48] = '##0.0E+0';
            t[49] = '@';
            t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
        }
        var table_fmt = {};
        init_table(table_fmt);
        /* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var default_map = [];
        var defi = 0;
        //  5 -> 37 ...  8 -> 40
        for(defi = 5; defi <= 8; ++defi)default_map[defi] = 32 + defi;
        // 23 ->  0 ... 26 ->  0
        for(defi = 23; defi <= 26; ++defi)default_map[defi] = 0;
        // 27 -> 14 ... 31 -> 14
        for(defi = 27; defi <= 31; ++defi)default_map[defi] = 14;
        // 50 -> 14 ... 58 -> 14
        for(defi = 50; defi <= 58; ++defi)default_map[defi] = 14;
        // 59 ->  1 ... 62 ->  4
        for(defi = 59; defi <= 62; ++defi)default_map[defi] = defi - 58;
        // 67 ->  9 ... 68 -> 10
        for(defi = 67; defi <= 68; ++defi)default_map[defi] = defi - 58;
        // 72 -> 14 ... 75 -> 17
        for(defi = 72; defi <= 75; ++defi)default_map[defi] = defi - 58;
        // 69 -> 12 ... 71 -> 14
        for(defi = 67; defi <= 68; ++defi)default_map[defi] = defi - 57;
        // 76 -> 20 ... 78 -> 22
        for(defi = 76; defi <= 78; ++defi)default_map[defi] = defi - 56;
        // 79 -> 45 ... 81 -> 47
        for(defi = 79; defi <= 81; ++defi)default_map[defi] = defi - 34;
        // 82 ->  0 ... 65536 -> 0 (omitted)
        /* These formats technically refer to Accounting formats with no equivalent */ var default_str = [];
        //  5 -- Currency,   0 decimal, black negative
        default_str[5] = default_str[63] = '"$"#,##0_);\\("$"#,##0\\)';
        //  6 -- Currency,   0 decimal, red   negative
        default_str[6] = default_str[64] = '"$"#,##0_);[Red]\\("$"#,##0\\)';
        //  7 -- Currency,   2 decimal, black negative
        default_str[7] = default_str[65] = '"$"#,##0.00_);\\("$"#,##0.00\\)';
        //  8 -- Currency,   2 decimal, red   negative
        default_str[8] = default_str[66] = '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)';
        // 41 -- Accounting, 0 decimal, No Symbol
        default_str[41] = '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)';
        // 42 -- Accounting, 0 decimal, $  Symbol
        default_str[42] = '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)';
        // 43 -- Accounting, 2 decimal, No Symbol
        default_str[43] = '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)';
        // 44 -- Accounting, 2 decimal, $  Symbol
        default_str[44] = '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)';
        function frac(x, D, mixed) {
            var sgn = x < 0 ? -1 : 1;
            var B = x * sgn;
            var P_2 = 0, P_1 = 1, P = 0;
            var Q_2 = 1, Q_1 = 0, Q = 0;
            var A = Math.floor(B);
            while(Q_1 < D){
                A = Math.floor(B);
                P = A * P_1 + P_2;
                Q = A * Q_1 + Q_2;
                if (B - A < 0.00000005) break;
                B = 1 / (B - A);
                P_2 = P_1;
                P_1 = P;
                Q_2 = Q_1;
                Q_1 = Q;
            }
            if (Q > D) {
                if (Q_1 > D) {
                    Q = Q_2;
                    P = P_2;
                } else {
                    Q = Q_1;
                    P = P_1;
                }
            }
            if (!mixed) return [
                0,
                sgn * P,
                Q
            ];
            var q = Math.floor(sgn * P / Q);
            return [
                q,
                sgn * P - q * Q,
                Q
            ];
        }
        function parse_date_code(v, opts, b2) {
            if (v > 2958465 || v < 0) return null;
            var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
            var dout = [];
            var out = {
                D: date,
                T: time,
                u: 86400 * (v - date) - time,
                y: 0,
                m: 0,
                d: 0,
                H: 0,
                M: 0,
                S: 0,
                q: 0
            };
            if (Math.abs(out.u) < 1e-6) out.u = 0;
            if (opts && opts.date1904) date += 1462;
            if (out.u > 0.9999) {
                out.u = 0;
                if (++time == 86400) {
                    out.T = time = 0;
                    ++date;
                    ++out.D;
                }
            }
            if (date === 60) {
                dout = b2 ? [
                    1317,
                    10,
                    29
                ] : [
                    1900,
                    2,
                    29
                ];
                dow = 3;
            } else if (date === 0) {
                dout = b2 ? [
                    1317,
                    8,
                    29
                ] : [
                    1900,
                    1,
                    0
                ];
                dow = 6;
            } else {
                if (date > 60) --date;
                /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
                d.setDate(d.getDate() + date - 1);
                dout = [
                    d.getFullYear(),
                    d.getMonth() + 1,
                    d.getDate()
                ];
                dow = d.getDay();
                if (date < 60) dow = (dow + 6) % 7;
                if (b2) dow = fix_hijri(d, dout);
            }
            out.y = dout[0];
            out.m = dout[1];
            out.d = dout[2];
            out.S = time % 60;
            time = Math.floor(time / 60);
            out.M = time % 60;
            time = Math.floor(time / 60);
            out.H = time;
            out.q = dow;
            return out;
        }
        SSF.parse_date_code = parse_date_code;
        var basedate = new Date(1899, 11, 31, 0, 0, 0);
        var dnthresh = basedate.getTime();
        var base1904 = new Date(1900, 2, 1, 0, 0, 0);
        function datenum_local(v, date1904) {
            var epoch = v.getTime();
            if (date1904) epoch -= 126230400000;
            else if (v >= base1904) epoch += 86400000;
            return (epoch - (dnthresh + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000)) / 86400000;
        }
        /* The longest 32-bit integer text is "-4294967296", exactly 11 chars */ function general_fmt_int(v) {
            return v.toString(10);
        }
        SSF._general_int = general_fmt_int;
        /* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ var general_fmt_num = function make_general_fmt_num() {
            var trailing_zeroes_and_decimal = /(?:\.0*|(\.\d*[1-9])0+)$/;
            function strip_decimal(o) {
                return o.indexOf(".") == -1 ? o : o.replace(trailing_zeroes_and_decimal, "$1");
            }
            /* General Exponential always shows 2 digits exp and trims the mantissa */ var mantissa_zeroes_and_decimal = /(?:\.0*|(\.\d*[1-9])0+)[Ee]/;
            var exp_with_single_digit = /(E[+-])(\d)$/;
            function normalize_exp(o) {
                if (o.indexOf("E") == -1) return o;
                return o.replace(mantissa_zeroes_and_decimal, "$1E").replace(exp_with_single_digit, "$10$2");
            }
            /* exponent >= -9 and <= 9 */ function small_exp(v) {
                var w = v < 0 ? 12 : 11;
                var o = strip_decimal(v.toFixed(12));
                if (o.length <= w) return o;
                o = v.toPrecision(10);
                if (o.length <= w) return o;
                return v.toExponential(5);
            }
            /* exponent >= 11 or <= -10 likely exponential */ function large_exp(v) {
                var o = strip_decimal(v.toFixed(11));
                return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
            }
            function general_fmt_num_base(v) {
                var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
                if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
                else if (Math.abs(V) <= 9) o = small_exp(v);
                else if (V === 10) o = v.toFixed(10).substr(0, 12);
                else o = large_exp(v);
                return strip_decimal(normalize_exp(o.toUpperCase()));
            }
            return general_fmt_num_base;
        }();
        SSF._general_num = general_fmt_num;
        /*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	TODO: technically the display depends on the width of the cell
*/ function general_fmt(v, opts) {
            switch(typeof v){
                case 'string':
                    return v;
                case 'boolean':
                    return v ? "TRUE" : "FALSE";
                case 'number':
                    return (v | 0) === v ? v.toString(10) : general_fmt_num(v);
                case 'undefined':
                    return "";
                case 'object':
                    if (v == null) return "";
                    if (v instanceof Date) return format(14, datenum_local(v, opts && opts.date1904), opts);
            }
            throw new Error("unsupported value in General format: " + v);
        }
        SSF._general = general_fmt;
        function fix_hijri(date, o) {
            /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
            var dow = date.getDay();
            if (date < 60) dow = (dow + 6) % 7;
            return dow;
        }
        //var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
        /*jshint -W086 */ function write_date(type, fmt, val, ss0) {
            var o = "", ss = 0, tt = 0, y = val.y, out, outl = 0;
            switch(type){
                case 98:
                    /* 'b' buddhist year */ y = val.y + 543;
                /* falls through */ case 121:
                    /* 'y' year */ switch(fmt.length){
                        case 1:
                        case 2:
                            out = y % 100;
                            outl = 2;
                            break;
                        default:
                            out = y % 10000;
                            outl = 4;
                            break;
                    }
                    break;
                case 109:
                    /* 'm' month */ switch(fmt.length){
                        case 1:
                        case 2:
                            out = val.m;
                            outl = fmt.length;
                            break;
                        case 3:
                            return months[val.m - 1][1];
                        case 5:
                            return months[val.m - 1][0];
                        default:
                            return months[val.m - 1][2];
                    }
                    break;
                case 100:
                    /* 'd' day */ switch(fmt.length){
                        case 1:
                        case 2:
                            out = val.d;
                            outl = fmt.length;
                            break;
                        case 3:
                            return days[val.q][0];
                        default:
                            return days[val.q][1];
                    }
                    break;
                case 104:
                    /* 'h' 12-hour */ switch(fmt.length){
                        case 1:
                        case 2:
                            out = 1 + (val.H + 11) % 12;
                            outl = fmt.length;
                            break;
                        default:
                            throw 'bad hour format: ' + fmt;
                    }
                    break;
                case 72:
                    /* 'H' 24-hour */ switch(fmt.length){
                        case 1:
                        case 2:
                            out = val.H;
                            outl = fmt.length;
                            break;
                        default:
                            throw 'bad hour format: ' + fmt;
                    }
                    break;
                case 77:
                    /* 'M' minutes */ switch(fmt.length){
                        case 1:
                        case 2:
                            out = val.M;
                            outl = fmt.length;
                            break;
                        default:
                            throw 'bad minute format: ' + fmt;
                    }
                    break;
                case 115:
                    /* 's' seconds */ if (fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
                    if (val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
                    if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
                    else tt = ss0 === 1 ? 10 : 1;
                    ss = Math.round(tt * (val.S + val.u));
                    if (ss >= 60 * tt) ss = 0;
                    if (fmt === 's') return ss === 0 ? "0" : "" + ss / tt;
                    o = pad0(ss, 2 + ss0);
                    if (fmt === 'ss') return o.substr(0, 2);
                    return "." + o.substr(2, fmt.length - 1);
                case 90:
                    /* 'Z' absolute time */ switch(fmt){
                        case '[h]':
                        case '[hh]':
                            out = val.D * 24 + val.H;
                            break;
                        case '[m]':
                        case '[mm]':
                            out = (val.D * 24 + val.H) * 60 + val.M;
                            break;
                        case '[s]':
                        case '[ss]':
                            out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + Math.round(val.S + val.u);
                            break;
                        default:
                            throw 'bad abstime format: ' + fmt;
                    }
                    outl = fmt.length === 3 ? 1 : 2;
                    break;
                case 101:
                    /* 'e' era */ out = y;
                    outl = 1;
                    break;
            }
            var outstr = outl > 0 ? pad0(out, outl) : "";
            return outstr;
        }
        /*jshint +W086 */ function commaify(s) {
            var w = 3;
            if (s.length <= w) return s;
            var j = s.length % w, o = s.substr(0, j);
            for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
            return o;
        }
        var write_num = function make_write_num() {
            var pct1 = /%/g;
            function write_num_pct(type, fmt, val) {
                var sfmt = fmt.replace(pct1, ""), mul = fmt.length - sfmt.length;
                return write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + fill("%", mul);
            }
            function write_num_cm(type, fmt, val) {
                var idx = fmt.length - 1;
                while(fmt.charCodeAt(idx - 1) === 44)--idx;
                return write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
            }
            function write_num_exp(fmt, val) {
                var o;
                var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
                if (fmt.match(/^#+0.0E\+0$/)) {
                    if (val == 0) return "0.0E+0";
                    else if (val < 0) return "-" + write_num_exp(fmt, -val);
                    var period = fmt.indexOf(".");
                    if (period === -1) period = fmt.indexOf('E');
                    var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
                    if (ee < 0) ee += period;
                    o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
                    if (o.indexOf("e") === -1) {
                        var fakee = Math.floor(Math.log(val) * Math.LOG10E);
                        if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
                        else o += "E+" + (fakee - ee);
                        while(o.substr(0, 2) === "0."){
                            o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                            o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
                        }
                        o = o.replace(/\+-/, "-");
                    }
                    o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
                        return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
                    });
                } else o = val.toExponential(idx);
                if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
                if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
                return o.replace("e", "E");
            }
            var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
            function write_num_f1(r, aval, sign) {
                var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
                var myn = rr - base * den, myd = den;
                return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn, r[1].length) + r[2] + "/" + r[3] + pad0(myd, r[4].length));
            }
            function write_num_f2(r, aval, sign) {
                return sign + (aval === 0 ? "" : "" + aval) + fill(" ", r[1].length + 2 + r[4].length);
            }
            var dec1 = /^#*0*\.([0#]+)/;
            var closeparen = /\).*[0#]/;
            var phone = /\(###\) ###\\?-####/;
            function hashq(str) {
                var o = "", cc;
                for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
                    case 35:
                        break;
                    case 63:
                        o += " ";
                        break;
                    case 48:
                        o += "0";
                        break;
                    default:
                        o += String.fromCharCode(cc);
                }
                return o;
            }
            function rnd(val, d) {
                var dd = Math.pow(10, d);
                return "" + Math.round(val * dd) / dd;
            }
            function dec(val, d) {
                var _frac = val - Math.floor(val), dd = Math.pow(10, d);
                if (d < ('' + Math.round(_frac * dd)).length) return 0;
                return Math.round(_frac * dd);
            }
            function carry(val, d) {
                if (d < ('' + Math.round((val - Math.floor(val)) * Math.pow(10, d))).length) return 1;
                return 0;
            }
            function flr(val) {
                if (val < 2147483647 && val > -2147483648) return "" + (val >= 0 ? val | 0 : val - 1 | 0);
                return "" + Math.floor(val);
            }
            function write_num_flt(type, fmt, val) {
                if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
                    var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
                    if (val >= 0) return write_num_flt('n', ffmt, val);
                    return '(' + write_num_flt('n', ffmt, -val) + ')';
                }
                if (fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
                if (fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
                if (fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
                if (fmt.charCodeAt(0) === 36) return "$" + write_num_flt(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val);
                var o;
                var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
                if (fmt.match(/^00+$/)) return sign + pad0r(aval, fmt.length);
                if (fmt.match(/^[#?]+$/)) {
                    o = pad0r(val, 0);
                    if (o === "0") o = "";
                    return o.length > fmt.length ? o : hashq(fmt.substr(0, fmt.length - o.length)) + o;
                }
                if (r = fmt.match(frac1)) return write_num_f1(r, aval, sign);
                if (fmt.match(/^#+0+$/)) return sign + pad0r(aval, fmt.length - fmt.indexOf("0"));
                if (r = fmt.match(dec1)) {
                    o = rnd(val, r[1].length).replace(/^([^\.]+)$/, "$1." + hashq(r[1])).replace(/\.$/, "." + hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
                        return "." + $1 + fill("0", hashq(r[1]).length - $1.length);
                    });
                    return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
                }
                fmt = fmt.replace(/^#+([0.])/, "$1");
                if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
                if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + commaify(pad0r(aval, 0));
                if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify("" + (Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length), r[1].length);
                if (r = fmt.match(/^#,#*,#0/)) return write_num_flt(type, fmt.replace(/^#,#*,/, ""), val);
                if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
                    o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g, ""), val));
                    ri = 0;
                    return _strrev(_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
                        return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
                    }));
                }
                if (fmt.match(phone)) {
                    o = write_num_flt(type, "##########", val);
                    return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
                }
                var oa = "";
                if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
                    ri = Math.min(r[4].length, 7);
                    ff = frac(aval, Math.pow(10, ri) - 1, false);
                    o = "" + sign;
                    oa = write_num("n", r[1], ff[1]);
                    if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
                    o += oa + r[2] + "/" + r[3];
                    oa = rpad_(ff[2], ri);
                    if (oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length - oa.length)) + oa;
                    o += oa;
                    return o;
                }
                if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
                    ri = Math.min(Math.max(r[1].length, r[4].length), 7);
                    ff = frac(aval, Math.pow(10, ri) - 1, true);
                    return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1], ri) + r[2] + "/" + r[3] + rpad_(ff[2], ri) : fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
                }
                if (r = fmt.match(/^[#0?]+$/)) {
                    o = pad0r(val, 0);
                    if (fmt.length <= o.length) return o;
                    return hashq(fmt.substr(0, fmt.length - o.length)) + o;
                }
                if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
                    o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
                    ri = o.indexOf(".");
                    var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
                    return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
                }
                if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
                    ri = dec(val, r[1].length);
                    return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
                        return "00," + ($$.length < 3 ? pad0(0, 3 - $$.length) : "") + $$;
                    }) + "." + pad0(ri, r[1].length);
                }
                switch(fmt){
                    case "###,##0.00":
                        return write_num_flt(type, "#,##0.00", val);
                    case "###,###":
                    case "##,###":
                    case "#,###":
                        var x = commaify(pad0r(aval, 0));
                        return x !== "0" ? sign + x : "";
                    case "###,###.00":
                        return write_num_flt(type, "###,##0.00", val).replace(/^0\./, ".");
                    case "#,###.00":
                        return write_num_flt(type, "#,##0.00", val).replace(/^0\./, ".");
                    default:
                }
                throw new Error("unsupported format |" + fmt + "|");
            }
            function write_num_cm2(type, fmt, val) {
                var idx = fmt.length - 1;
                while(fmt.charCodeAt(idx - 1) === 44)--idx;
                return write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
            }
            function write_num_pct2(type, fmt, val) {
                var sfmt = fmt.replace(pct1, ""), mul = fmt.length - sfmt.length;
                return write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + fill("%", mul);
            }
            function write_num_exp2(fmt, val) {
                var o;
                var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
                if (fmt.match(/^#+0.0E\+0$/)) {
                    if (val == 0) return "0.0E+0";
                    else if (val < 0) return "-" + write_num_exp2(fmt, -val);
                    var period = fmt.indexOf(".");
                    if (period === -1) period = fmt.indexOf('E');
                    var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
                    if (ee < 0) ee += period;
                    o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
                    if (!o.match(/[Ee]/)) {
                        var fakee = Math.floor(Math.log(val) * Math.LOG10E);
                        if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
                        else o += "E+" + (fakee - ee);
                        o = o.replace(/\+-/, "-");
                    }
                    o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
                        return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
                    });
                } else o = val.toExponential(idx);
                if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
                if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
                return o.replace("e", "E");
            }
            function write_num_int(type, fmt, val) {
                if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
                    var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
                    if (val >= 0) return write_num_int('n', ffmt, val);
                    return '(' + write_num_int('n', ffmt, -val) + ')';
                }
                if (fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
                if (fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
                if (fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
                if (fmt.charCodeAt(0) === 36) return "$" + write_num_int(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val);
                var o;
                var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
                if (fmt.match(/^00+$/)) return sign + pad0(aval, fmt.length);
                if (fmt.match(/^[#?]+$/)) {
                    o = "" + val;
                    if (val === 0) o = "";
                    return o.length > fmt.length ? o : hashq(fmt.substr(0, fmt.length - o.length)) + o;
                }
                if (r = fmt.match(frac1)) return write_num_f2(r, aval, sign);
                if (fmt.match(/^#+0+$/)) return sign + pad0(aval, fmt.length - fmt.indexOf("0"));
                if (r = fmt.match(dec1)) {
                    o = ("" + val).replace(/^([^\.]+)$/, "$1." + hashq(r[1])).replace(/\.$/, "." + hashq(r[1]));
                    o = o.replace(/\.(\d*)$/, function($$, $1) {
                        return "." + $1 + fill("0", hashq(r[1]).length - $1.length);
                    });
                    return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
                }
                fmt = fmt.replace(/^#+([0.])/, "$1");
                if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
                if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + commaify("" + aval);
                if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify("" + val) + "." + fill('0', r[1].length);
                if (r = fmt.match(/^#,#*,#0/)) return write_num_int(type, fmt.replace(/^#,#*,/, ""), val);
                if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
                    o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g, ""), val));
                    ri = 0;
                    return _strrev(_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
                        return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
                    }));
                }
                if (fmt.match(phone)) {
                    o = write_num_int(type, "##########", val);
                    return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
                }
                var oa = "";
                if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
                    ri = Math.min(r[4].length, 7);
                    ff = frac(aval, Math.pow(10, ri) - 1, false);
                    o = "" + sign;
                    oa = write_num("n", r[1], ff[1]);
                    if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
                    o += oa + r[2] + "/" + r[3];
                    oa = rpad_(ff[2], ri);
                    if (oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length - oa.length)) + oa;
                    o += oa;
                    return o;
                }
                if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
                    ri = Math.min(Math.max(r[1].length, r[4].length), 7);
                    ff = frac(aval, Math.pow(10, ri) - 1, true);
                    return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1], ri) + r[2] + "/" + r[3] + rpad_(ff[2], ri) : fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
                }
                if (r = fmt.match(/^[#0?]+$/)) {
                    o = "" + val;
                    if (fmt.length <= o.length) return o;
                    return hashq(fmt.substr(0, fmt.length - o.length)) + o;
                }
                if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
                    o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
                    ri = o.indexOf(".");
                    var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
                    return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
                }
                if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify("" + val).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
                    return "00," + ($$.length < 3 ? pad0(0, 3 - $$.length) : "") + $$;
                }) + "." + pad0(0, r[1].length);
                switch(fmt){
                    case "###,###":
                    case "##,###":
                    case "#,###":
                        var x = commaify("" + aval);
                        return x !== "0" ? sign + x : "";
                    default:
                        if (fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
                }
                throw new Error("unsupported format |" + fmt + "|");
            }
            return function write_num(type, fmt, val) {
                return (val | 0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
            };
        }();
        function split_fmt(fmt) {
            var out = [];
            var in_str = false /*, cc*/ ;
            for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
                case 34:
                    /* '"' */ in_str = !in_str;
                    break;
                case 95:
                case 42:
                case 92:
                    /* '_' '*' '\\' */ ++i;
                    break;
                case 59:
                    /* ';' */ out[out.length] = fmt.substr(j, i - j);
                    j = i + 1;
            }
            out[out.length] = fmt.substr(j);
            if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
            return out;
        }
        SSF._split = split_fmt;
        var abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
        function fmt_is_date(fmt) {
            var i = 0, /*cc = 0,*/ c = "", o = "";
            while(i < fmt.length)switch(c = fmt.charAt(i)){
                case 'G':
                    if (isgeneral(fmt, i)) i += 6;
                    i++;
                    break;
                case '"':
                    for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
                    ++i;
                    break;
                case '\\':
                    i += 2;
                    break;
                case '_':
                    i += 2;
                    break;
                case '@':
                    ++i;
                    break;
                case 'B':
                case 'b':
                    if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
                /* falls through */ case 'M':
                case 'D':
                case 'Y':
                case 'H':
                case 'S':
                case 'E':
                /* falls through */ case 'm':
                case 'd':
                case 'y':
                case 'h':
                case 's':
                case 'e':
                case 'g':
                    return true;
                case 'A':
                case 'a':
                case "\u4E0A":
                    if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
                    if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
                    if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
                    ++i;
                    break;
                case '[':
                    o = c;
                    while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
                    if (o.match(abstime)) return true;
                    break;
                case '.':
                /* falls through */ case '0':
                case '#':
                    while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == '\\' && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
                    break;
                case '?':
                    while(fmt.charAt(++i) === c);
                    break;
                case '*':
                    ++i;
                    if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
                    break;
                case '(':
                case ')':
                    ++i;
                    break;
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                case '9':
                    while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
                    break;
                case ' ':
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
            return false;
        }
        SSF.is_date = fmt_is_date;
        function eval_fmt(fmt, v, opts, flen) {
            var out = [], o = "", i = 0, c = "", lst = 't', dt, j, cc;
            var hr = 'H';
            /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
                case 'G':
                    /* General */ if (!isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' + fmt);
                    out[out.length] = {
                        t: 'G',
                        v: 'General'
                    };
                    i += 7;
                    break;
                case '"':
                    /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
                    out[out.length] = {
                        t: 't',
                        v: o
                    };
                    ++i;
                    break;
                case '\\':
                    var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : 't';
                    out[out.length] = {
                        t: t,
                        v: w
                    };
                    ++i;
                    break;
                case '_':
                    out[out.length] = {
                        t: 't',
                        v: " "
                    };
                    i += 2;
                    break;
                case '@':
                    /* Text Placeholder */ out[out.length] = {
                        t: 'T',
                        v: v
                    };
                    ++i;
                    break;
                case 'B':
                case 'b':
                    if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                        if (dt == null) {
                            dt = parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                            if (dt == null) return "";
                        }
                        out[out.length] = {
                            t: 'X',
                            v: fmt.substr(i, 2)
                        };
                        lst = c;
                        i += 2;
                        break;
                    }
                /* falls through */ case 'M':
                case 'D':
                case 'Y':
                case 'H':
                case 'S':
                case 'E':
                    c = c.toLowerCase();
                /* falls through */ case 'm':
                case 'd':
                case 'y':
                case 'h':
                case 's':
                case 'e':
                case 'g':
                    if (v < 0) return "";
                    if (dt == null) {
                        dt = parse_date_code(v, opts);
                        if (dt == null) return "";
                    }
                    o = c;
                    while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
                    if (c === 'm' && lst.toLowerCase() === 'h') c = 'M';
                    if (c === 'h') c = hr;
                    out[out.length] = {
                        t: c,
                        v: o
                    };
                    lst = c;
                    break;
                case 'A':
                case 'a':
                case "\u4E0A":
                    var q = {
                        t: c,
                        v: c
                    };
                    if (dt == null) dt = parse_date_code(v, opts);
                    if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                        if (dt != null) q.v = dt.H >= 12 ? "P" : "A";
                        q.t = 'T';
                        hr = 'h';
                        i += 3;
                    } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                        if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                        q.t = 'T';
                        i += 5;
                        hr = 'h';
                    } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                        if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                        q.t = 'T';
                        i += 5;
                        hr = 'h';
                    } else {
                        q.t = "t";
                        ++i;
                    }
                    if (dt == null && q.t === 'T') return "";
                    out[out.length] = q;
                    lst = c;
                    break;
                case '[':
                    o = c;
                    while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
                    if (o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
                    if (o.match(abstime)) {
                        if (dt == null) {
                            dt = parse_date_code(v, opts);
                            if (dt == null) return "";
                        }
                        out[out.length] = {
                            t: 'Z',
                            v: o.toLowerCase()
                        };
                        lst = o.charAt(1);
                    } else if (o.indexOf("$") > -1) {
                        o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                        if (!fmt_is_date(fmt)) out[out.length] = {
                            t: 't',
                            v: o
                        };
                    }
                    break;
                /* Numbers */ case '.':
                    if (dt != null) {
                        o = c;
                        while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                        out[out.length] = {
                            t: 's',
                            v: o
                        };
                        break;
                    }
                /* falls through */ case '0':
                case '#':
                    o = c;
                    while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
                    out[out.length] = {
                        t: 'n',
                        v: o
                    };
                    break;
                case '?':
                    o = c;
                    while(fmt.charAt(++i) === c)o += c;
                    out[out.length] = {
                        t: c,
                        v: o
                    };
                    lst = c;
                    break;
                case '*':
                    ++i;
                    if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
                    break; // **
                case '(':
                case ')':
                    out[out.length] = {
                        t: flen === 1 ? 't' : c,
                        v: c
                    };
                    ++i;
                    break;
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                case '9':
                    o = c;
                    while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
                    out[out.length] = {
                        t: 'D',
                        v: o
                    };
                    break;
                case ' ':
                    out[out.length] = {
                        t: c,
                        v: c
                    };
                    ++i;
                    break;
                case '$':
                    out[out.length] = {
                        t: 't',
                        v: '$'
                    };
                    ++i;
                    break;
                default:
                    if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
                    out[out.length] = {
                        t: 't',
                        v: c
                    };
                    ++i;
                    break;
            }
            /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
            for(i = out.length - 1, lst = 't'; i >= 0; --i)switch(out[i].t){
                case 'h':
                case 'H':
                    out[i].t = hr;
                    lst = 'h';
                    if (bt < 1) bt = 1;
                    break;
                case 's':
                    if (ssm = out[i].v.match(/\.0+$/)) ss0 = Math.max(ss0, ssm[0].length - 1);
                    if (bt < 3) bt = 3;
                /* falls through */ case 'd':
                case 'y':
                case 'M':
                case 'e':
                    lst = out[i].t;
                    break;
                case 'm':
                    if (lst === 's') {
                        out[i].t = 'M';
                        if (bt < 2) bt = 2;
                    }
                    break;
                case 'X':
                    break;
                case 'Z':
                    if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
                    if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
                    if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
            }
            /* time rounding depends on presence of minute / second / usec fields */ switch(bt){
                case 0:
                    break;
                case 1:
                    if (dt.u >= 0.5) {
                        dt.u = 0;
                        ++dt.S;
                    }
                    if (dt.S >= 60) {
                        dt.S = 0;
                        ++dt.M;
                    }
                    if (dt.M >= 60) {
                        dt.M = 0;
                        ++dt.H;
                    }
                    break;
                case 2:
                    if (dt.u >= 0.5) {
                        dt.u = 0;
                        ++dt.S;
                    }
                    if (dt.S >= 60) {
                        dt.S = 0;
                        ++dt.M;
                    }
                    break;
            }
            /* replace fields */ var nstr = "", jj;
            for(i = 0; i < out.length; ++i)switch(out[i].t){
                case 't':
                case 'T':
                case ' ':
                case 'D':
                    break;
                case 'X':
                    out[i].v = "";
                    out[i].t = ";";
                    break;
                case 'd':
                case 'm':
                case 'y':
                case 'h':
                case 'H':
                case 'M':
                case 's':
                case 'e':
                case 'b':
                case 'Z':
                    out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
                    out[i].t = 't';
                    break;
                case 'n':
                case '?':
                    jj = i + 1;
                    while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === '?' || out[jj + 1].t === "t" && out[jj + 1].v === '/') || out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') || c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj + 1] != null && out[jj + 1].t == '?'))){
                        out[i].v += out[jj].v;
                        out[jj] = {
                            v: "",
                            t: ";"
                        };
                        ++jj;
                    }
                    nstr += out[i].v;
                    i = jj - 1;
                    break;
                case 'G':
                    out[i].t = 't';
                    out[i].v = general_fmt(v, opts);
                    break;
            }
            var vv = "", myv, ostr;
            if (nstr.length > 0) {
                if (nstr.charCodeAt(0) == 40) /* '(' */ {
                    myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
                    ostr = write_num('n', nstr, myv);
                } else {
                    myv = v < 0 && flen > 1 ? -v : v;
                    ostr = write_num('n', nstr, myv);
                    if (myv < 0 && out[0] && out[0].t == 't') {
                        ostr = ostr.substr(1);
                        out[0].v = "-" + out[0].v;
                    }
                }
                jj = ostr.length - 1;
                var decpt = out.length;
                for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) {
                    decpt = i;
                    break;
                }
                var lasti = out.length;
                if (decpt === out.length && ostr.indexOf("E") === -1) {
                    for(i = out.length - 1; i >= 0; --i){
                        if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                        if (jj >= out[i].v.length - 1) {
                            jj -= out[i].v.length;
                            out[i].v = ostr.substr(jj + 1, out[i].v.length);
                        } else if (jj < 0) out[i].v = "";
                        else {
                            out[i].v = ostr.substr(0, jj + 1);
                            jj = -1;
                        }
                        out[i].t = 't';
                        lasti = i;
                    }
                    if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
                } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
                    jj = ostr.indexOf(".") - 1;
                    for(i = decpt; i >= 0; --i){
                        if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                        j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                        vv = out[i].v.substr(j + 1);
                        for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                        out[i].v = vv;
                        out[i].t = 't';
                        lasti = i;
                    }
                    if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
                    jj = ostr.indexOf(".") + 1;
                    for(i = decpt; i < out.length; ++i){
                        if (out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt) continue;
                        j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                        vv = out[i].v.substr(0, j);
                        for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                        out[i].v = vv;
                        out[i].t = 't';
                        lasti = i;
                    }
                }
            }
            for(i = 0; i < out.length; ++i)if (out[i] != null && 'n?'.indexOf(out[i].t) > -1) {
                myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
                out[i].v = write_num(out[i].t, out[i].v, myv);
                out[i].t = 't';
            }
            var retval = "";
            for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
            return retval;
        }
        SSF._eval = eval_fmt;
        var cfregex = /\[[=<>]/;
        var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
        function chkcond(v, rr) {
            if (rr == null) return false;
            var thresh = parseFloat(rr[2]);
            switch(rr[1]){
                case "=":
                    if (v == thresh) return true;
                    break;
                case ">":
                    if (v > thresh) return true;
                    break;
                case "<":
                    if (v < thresh) return true;
                    break;
                case "<>":
                    if (v != thresh) return true;
                    break;
                case ">=":
                    if (v >= thresh) return true;
                    break;
                case "<=":
                    if (v <= thresh) return true;
                    break;
            }
            return false;
        }
        function choose_fmt(f, v) {
            var fmt = split_fmt(f);
            var l = fmt.length, lat = fmt[l - 1].indexOf("@");
            if (l < 4 && lat > -1) --l;
            if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
            if (typeof v !== "number") return [
                4,
                fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
            ];
            switch(fmt.length){
                case 1:
                    fmt = lat > -1 ? [
                        "General",
                        "General",
                        "General",
                        fmt[0]
                    ] : [
                        fmt[0],
                        fmt[0],
                        fmt[0],
                        "@"
                    ];
                    break;
                case 2:
                    fmt = lat > -1 ? [
                        fmt[0],
                        fmt[0],
                        fmt[0],
                        fmt[1]
                    ] : [
                        fmt[0],
                        fmt[1],
                        fmt[0],
                        "@"
                    ];
                    break;
                case 3:
                    fmt = lat > -1 ? [
                        fmt[0],
                        fmt[1],
                        fmt[0],
                        fmt[2]
                    ] : [
                        fmt[0],
                        fmt[1],
                        fmt[2],
                        "@"
                    ];
                    break;
                case 4:
                    break;
            }
            var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
            if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
                l,
                ff
            ];
            if (fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
                var m1 = fmt[0].match(cfregex2);
                var m2 = fmt[1].match(cfregex2);
                return chkcond(v, m1) ? [
                    l,
                    fmt[0]
                ] : chkcond(v, m2) ? [
                    l,
                    fmt[1]
                ] : [
                    l,
                    fmt[m1 != null && m2 != null ? 2 : 1]
                ];
            }
            return [
                l,
                ff
            ];
        }
        function format(fmt, v, o) {
            if (o == null) o = {};
            var sfmt = "";
            switch(typeof fmt){
                case "string":
                    if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
                    else sfmt = fmt;
                    break;
                case "number":
                    if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
                    else sfmt = (o.table != null ? o.table : table_fmt)[fmt];
                    if (sfmt == null) sfmt = o.table && o.table[default_map[fmt]] || table_fmt[default_map[fmt]];
                    if (sfmt == null) sfmt = default_str[fmt] || "General";
                    break;
            }
            if (isgeneral(sfmt, 0)) return general_fmt(v, o);
            if (v instanceof Date) v = datenum_local(v, o.date1904);
            var f = choose_fmt(sfmt, v);
            if (isgeneral(f[1])) return general_fmt(v, o);
            if (v === true) v = "TRUE";
            else if (v === false) v = "FALSE";
            else if (v === "" || v == null) return "";
            return eval_fmt(f[1], v, o, f[0]);
        }
        function load_entry(fmt, idx) {
            if (typeof idx != 'number') {
                idx = +idx || -1;
                for(var i = 0; i < 0x0188; ++i){
                    if (table_fmt[i] == undefined) {
                        if (idx < 0) idx = i;
                        continue;
                    }
                    if (table_fmt[i] == fmt) {
                        idx = i;
                        break;
                    }
                }
                if (idx < 0) idx = 0x187;
            }
            table_fmt[idx] = fmt;
            return idx;
        }
        SSF.load = load_entry;
        SSF._table = table_fmt;
        SSF.get_table = function get_table() {
            return table_fmt;
        };
        SSF.load_table = function load_table(tbl) {
            for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) load_entry(tbl[i], i);
        };
        SSF.init_table = init_table;
        SSF.format = format;
    };
    make_ssf(SSF);
    /* map from xlml named formats to SSF TODO: localize */ var XLMLFormatMap /*{[string]:string}*/  = {
        "General Number": "General",
        "General Date": SSF._table[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": SSF._table[15],
        "Short Date": SSF._table[14],
        "Long Time": SSF._table[19],
        "Medium Time": SSF._table[18],
        "Short Time": SSF._table[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": SSF._table[2],
        "Standard": SSF._table[4],
        "Percent": SSF._table[10],
        "Scientific": SSF._table[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    };
    var SSFImplicit /*{[number]:string}*/  = {
        "5": '"$"#,##0_);\\("$"#,##0\\)',
        "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
        "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
        "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "23": 'General',
        "24": 'General',
        "25": 'General',
        "26": 'General',
        "27": 'm/d/yy',
        "28": 'm/d/yy',
        "29": 'm/d/yy',
        "30": 'm/d/yy',
        "31": 'm/d/yy',
        "32": 'h:mm:ss',
        "33": 'h:mm:ss',
        "34": 'h:mm:ss',
        "35": 'h:mm:ss',
        "36": 'm/d/yy',
        "41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
        "42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
        "43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
        "44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
        "50": 'm/d/yy',
        "51": 'm/d/yy',
        "52": 'm/d/yy',
        "53": 'm/d/yy',
        "54": 'm/d/yy',
        "55": 'm/d/yy',
        "56": 'm/d/yy',
        "57": 'm/d/yy',
        "58": 'm/d/yy',
        "59": '0',
        "60": '0.00',
        "61": '#,##0',
        "62": '#,##0.00',
        "63": '"$"#,##0_);\\("$"#,##0\\)',
        "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
        "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
        "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "67": '0%',
        "68": '0.00%',
        "69": '# ?/?',
        "70": '# ??/??',
        "71": 'm/d/yy',
        "72": 'm/d/yy',
        "73": 'd-mmm-yy',
        "74": 'd-mmm',
        "75": 'mmm-yy',
        "76": 'h:mm',
        "77": 'h:mm:ss',
        "78": 'm/d/yy h:mm',
        "79": 'mm:ss',
        "80": '[h]:mm:ss',
        "81": 'mmss.0'
    };
    /* dateNF parse TODO: move to SSF */ var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
    function dateNF_regex(dateNF) {
        var fmt = typeof dateNF == "number" ? SSF._table[dateNF] : dateNF;
        fmt = fmt.replace(dateNFregex, "(\\d+)");
        return new RegExp("^" + fmt + "$");
    }
    function dateNF_fix(str, dateNF, match) {
        var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
        (dateNF.match(dateNFregex) || []).forEach(function(n, i) {
            var v = parseInt(match[i + 1], 10);
            switch(n.toLowerCase().charAt(0)){
                case 'y':
                    Y = v;
                    break;
                case 'd':
                    d = v;
                    break;
                case 'h':
                    H = v;
                    break;
                case 's':
                    S = v;
                    break;
                case 'm':
                    if (H >= 0) M = v;
                    else m = v;
                    break;
            }
        });
        if (S >= 0 && M == -1 && m >= 0) {
            M = m;
            m = -1;
        }
        var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
        if (datestr.length == 7) datestr = "0" + datestr;
        if (datestr.length == 8) datestr = "20" + datestr;
        var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
        if (H == -1 && M == -1 && S == -1) return datestr;
        if (Y == -1 && m == -1 && d == -1) return timestr;
        return datestr + "T" + timestr;
    }
    var DO_NOT_EXPORT_CFB = true;
    /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var CRC32;
    (function(factory) {
        /*jshint ignore:start */ /*eslint-disable */ factory(CRC32 = {});
    /*eslint-enable */ /*jshint ignore:end */ })(function(CRC32) {
        CRC32.version = '1.2.0';
        /* see perf/crc32table.js */ /*global Int32Array */ function signed_crc_table() {
            var c = 0, table = new Array(256);
            for(var n = 0; n != 256; ++n){
                c = n;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                table[n] = c;
            }
            return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
        }
        var T = signed_crc_table();
        function crc32_bstr(bstr, seed) {
            var C = seed ^ -1, L = bstr.length - 1;
            for(var i = 0; i < L;){
                C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 0xFF];
            }
            if (i === L) C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i)) & 0xFF];
            return C ^ -1;
        }
        function crc32_buf(buf, seed) {
            if (buf.length > 10000) return crc32_buf_8(buf, seed);
            var C = seed ^ -1, L = buf.length - 3;
            for(var i = 0; i < L;){
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            }
            while(i < L + 3)C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            return C ^ -1;
        }
        function crc32_buf_8(buf, seed) {
            var C = seed ^ -1, L = buf.length - 7;
            for(var i = 0; i < L;){
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            }
            while(i < L + 7)C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            return C ^ -1;
        }
        function crc32_str(str, seed) {
            var C = seed ^ -1;
            for(var i = 0, L = str.length, c, d; i < L;){
                c = str.charCodeAt(i++);
                if (c < 0x80) C = C >>> 8 ^ T[(C ^ c) & 0xFF];
                else if (c < 0x800) {
                    C = C >>> 8 ^ T[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 0xFF];
                } else if (c >= 0xD800 && c < 0xE000) {
                    c = (c & 1023) + 64;
                    d = str.charCodeAt(i++) & 1023;
                    C = C >>> 8 ^ T[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | d & 63)) & 0xFF];
                } else {
                    C = C >>> 8 ^ T[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 0xFF];
                }
            }
            return C ^ -1;
        }
        CRC32.table = T;
        CRC32.bstr = crc32_bstr;
        CRC32.buf = crc32_buf;
        CRC32.str = crc32_str;
    });
    /* [MS-CFB] v20171201 */ var CFB = function _CFB() {
        var exports1 = {};
        exports1.version = '1.1.4';
        /* [MS-CFB] 2.6.4 */ function namecmp(l, r) {
            var L = l.split("/"), R = r.split("/");
            for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
                if (c = L[i].length - R[i].length) return c;
                if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
            }
            return L.length - R.length;
        }
        function dirname(p) {
            if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
            var c = p.lastIndexOf("/");
            return c === -1 ? p : p.slice(0, c + 1);
        }
        function filename(p) {
            if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
            var c = p.lastIndexOf("/");
            return c === -1 ? p : p.slice(c + 1);
        }
        /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf, date) {
            if (typeof date === "string") date = new Date(date);
            var hms = date.getHours();
            hms = hms << 6 | date.getMinutes();
            hms = hms << 5 | date.getSeconds() >>> 1;
            buf.write_shift(2, hms);
            var ymd = date.getFullYear() - 1980;
            ymd = ymd << 4 | date.getMonth() + 1;
            ymd = ymd << 5 | date.getDate();
            buf.write_shift(2, ymd);
        }
        /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf) {
            var hms = buf.read_shift(2) & 0xFFFF;
            var ymd = buf.read_shift(2) & 0xFFFF;
            var val = new Date();
            var d = ymd & 0x1F;
            ymd >>>= 5;
            var m = ymd & 0x0F;
            ymd >>>= 4;
            val.setMilliseconds(0);
            val.setFullYear(ymd + 1980);
            val.setMonth(m - 1);
            val.setDate(d);
            var S = hms & 0x1F;
            hms >>>= 5;
            var M = hms & 0x3F;
            hms >>>= 6;
            val.setHours(hms);
            val.setMinutes(M);
            val.setSeconds(S << 1);
            return val;
        }
        function parse_extra_field(blob) {
            prep_blob(blob, 0);
            var o = {};
            var flags = 0;
            while(blob.l <= blob.length - 4){
                var type = blob.read_shift(2);
                var sz = blob.read_shift(2), tgt = blob.l + sz;
                var p = {};
                switch(type){
                    /* UNIX-style Timestamps */ case 0x5455:
                        flags = blob.read_shift(1);
                        if (flags & 1) p.mtime = blob.read_shift(4);
                        /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                            if (flags & 2) p.atime = blob.read_shift(4);
                            if (flags & 4) p.ctime = blob.read_shift(4);
                        }
                        if (p.mtime) p.mt = new Date(p.mtime * 1000);
                        break;
                }
                blob.l = tgt;
                o[type] = p;
            }
            return o;
        }
        var fs;
        function get_fs() {
            return fs || (fs = require("d0d1d500be3fa453"));
        }
        function parse(file, options) {
            if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
            if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
            var mver = 3;
            var ssz = 512;
            var nmfs = 0; // number of mini FAT sectors
            var difat_sec_cnt = 0;
            var dir_start = 0;
            var minifat_start = 0;
            var difat_start = 0;
            var fat_addrs = []; // locations of FAT sectors
            /* [MS-CFB] 2.2 Compound File Header */ var blob = file.slice(0, 512);
            prep_blob(blob, 0);
            /* major version */ var mv = check_get_mver(blob);
            mver = mv[0];
            switch(mver){
                case 3:
                    ssz = 512;
                    break;
                case 4:
                    ssz = 4096;
                    break;
                case 0:
                    if (mv[1] == 0) return parse_zip(file, options);
                /* falls through */ default:
                    throw new Error("Major Version: Expected 3 or 4 saw " + mver);
            }
            /* reprocess header */ if (ssz !== 512) {
                blob = file.slice(0, ssz);
                prep_blob(blob, 28 /* blob.l */ );
            }
            /* Save header for final object */ var header = file.slice(0, ssz);
            check_shifts(blob, mver);
            // Number of Directory Sectors
            var dir_cnt = blob.read_shift(4, 'i');
            if (mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
            // Number of FAT Sectors
            blob.l += 4;
            // First Directory Sector Location
            dir_start = blob.read_shift(4, 'i');
            // Transaction Signature
            blob.l += 4;
            // Mini Stream Cutoff Size
            blob.chk('00100000', 'Mini Stream Cutoff Size: ');
            // First Mini FAT Sector Location
            minifat_start = blob.read_shift(4, 'i');
            // Number of Mini FAT Sectors
            nmfs = blob.read_shift(4, 'i');
            // First DIFAT sector location
            difat_start = blob.read_shift(4, 'i');
            // Number of DIFAT Sectors
            difat_sec_cnt = blob.read_shift(4, 'i');
            // Grab FAT Sector Locations
            for(var q = -1, j = 0; j < 109; ++j){
                q = blob.read_shift(4, 'i');
                if (q < 0) break;
                fat_addrs[j] = q;
            }
            /** Break the file up into sectors */ var sectors = sectorify(file, ssz);
            sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
            /** Chains */ var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);
            sector_list[dir_start].name = "!Directory";
            if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
            sector_list[fat_addrs[0]].name = "!FAT";
            sector_list.fat_addrs = fat_addrs;
            sector_list.ssz = ssz;
            /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files = {}, Paths = [], FileIndex = [], FullPaths = [];
            read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
            build_full_paths(FileIndex, FullPaths, Paths);
            Paths.shift();
            var o = {
                FileIndex: FileIndex,
                FullPaths: FullPaths
            };
            // $FlowIgnore
            if (options && options.raw) o.raw = {
                header: header,
                sectors: sectors
            };
            return o;
        } // parse
        /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob) {
            if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
                0,
                0
            ];
            // header signature 8
            blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
            // clsid 16
            //blob.chk(HEADER_CLSID, 'CLSID: ');
            blob.l += 16;
            // minor version 2
            var mver = blob.read_shift(2, 'u');
            return [
                blob.read_shift(2, 'u'),
                mver
            ];
        }
        function check_shifts(blob, mver) {
            var shift = 0x09;
            // Byte Order
            //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
            blob.l += 2;
            // Sector Shift
            switch(shift = blob.read_shift(2)){
                case 0x09:
                    if (mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift);
                    break;
                case 0x0c:
                    if (mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift);
                    break;
                default:
                    throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
            }
            // Mini Sector Shift
            blob.chk('0600', 'Mini Sector Shift: ');
            // Reserved
            blob.chk('000000000000', 'Reserved: ');
        }
        /** Break the file up into sectors */ function sectorify(file, ssz) {
            var nsectors = Math.ceil(file.length / ssz) - 1;
            var sectors = [];
            for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
            sectors[nsectors - 1] = file.slice(nsectors * ssz);
            return sectors;
        }
        /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI, FP, Paths) {
            var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
            var dad = [], q = [];
            for(; i < pl; ++i){
                dad[i] = q[i] = i;
                FP[i] = Paths[i];
            }
            for(; j < q.length; ++j){
                i = q[j];
                L = FI[i].L;
                R = FI[i].R;
                C = FI[i].C;
                if (dad[i] === i) {
                    if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                    if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
                }
                if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
                if (L !== -1 && i != dad[i]) {
                    dad[L] = dad[i];
                    if (q.lastIndexOf(L) < j) q.push(L);
                }
                if (R !== -1 && i != dad[i]) {
                    dad[R] = dad[i];
                    if (q.lastIndexOf(R) < j) q.push(R);
                }
            }
            for(i = 1; i < pl; ++i)if (dad[i] === i) {
                if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
                else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
            }
            for(i = 1; i < pl; ++i){
                if (FI[i].type === 0 /* unknown */ ) continue;
                j = i;
                if (j != dad[j]) do {
                    j = dad[j];
                    FP[i] = FP[j] + "/" + FP[i];
                }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
                dad[i] = -1;
            }
            FP[0] += "/";
            for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
        }
        function get_mfat_entry(entry, payload, mini) {
            var start = entry.start, size = entry.size;
            //return (payload.slice(start*MSSZ, start*MSSZ + size));
            var o = [];
            var idx = start;
            while(mini && size > 0 && idx >= 0){
                o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
                size -= MSSZ;
                idx = __readInt32LE(mini, idx * 4);
            }
            if (o.length === 0) return new_buf(0);
            return bconcat(o).slice(0, entry.size);
        }
        /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
            var q = ENDOFCHAIN;
            if (idx === ENDOFCHAIN) {
                if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
            } else if (idx !== -1 /*FREESECT*/ ) {
                var sector = sectors[idx], m = (ssz >>> 2) - 1;
                if (!sector) return;
                for(var i = 0; i < m; ++i){
                    if ((q = __readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                    fat_addrs.push(q);
                }
                sleuth_fat(__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
            }
        }
        /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
            var buf = [], buf_chain = [];
            if (!chkd) chkd = [];
            var modulus = ssz - 1, j = 0, jj = 0;
            for(j = start; j >= 0;){
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = __readInt32LE(sectors[addr], jj);
            }
            return {
                nodes: buf,
                data: __toBuffer([
                    buf_chain
                ])
            };
        }
        /** Chase down the sector linked lists */ function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
            var sl = sectors.length, sector_list = [];
            var chkd = [], buf = [], buf_chain = [];
            var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
            for(i = 0; i < sl; ++i){
                buf = [];
                k = i + dir_start;
                if (k >= sl) k -= sl;
                if (chkd[k]) continue;
                buf_chain = [];
                var seen = [];
                for(j = k; j >= 0;){
                    seen[j] = true;
                    chkd[j] = true;
                    buf[buf.length] = j;
                    buf_chain.push(sectors[j]);
                    var addr = fat_addrs[Math.floor(j * 4 / ssz)];
                    jj = j * 4 & modulus;
                    if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                    if (!sectors[addr]) break;
                    j = __readInt32LE(sectors[addr], jj);
                    if (seen[j]) break;
                }
                sector_list[k] = {
                    nodes: buf,
                    data: __toBuffer([
                        buf_chain
                    ])
                };
            }
            return sector_list;
        }
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
            var minifat_store = 0, pl = Paths.length ? 2 : 0;
            var sector = sector_list[dir_start].data;
            var i = 0, namelen = 0, name;
            for(; i < sector.length; i += 128){
                var blob = sector.slice(i, i + 128);
                prep_blob(blob, 64);
                namelen = blob.read_shift(2);
                name = __utf16le(blob, 0, namelen - pl);
                Paths.push(name);
                var o = {
                    name: name,
                    type: blob.read_shift(1),
                    color: blob.read_shift(1),
                    L: blob.read_shift(4, 'i'),
                    R: blob.read_shift(4, 'i'),
                    C: blob.read_shift(4, 'i'),
                    clsid: blob.read_shift(16),
                    state: blob.read_shift(4, 'i'),
                    start: 0,
                    size: 0
                };
                var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
                if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
                var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
                if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
                o.start = blob.read_shift(4, 'i');
                o.size = blob.read_shift(4, 'i');
                if (o.size < 0 && o.start < 0) {
                    o.size = o.type = 0;
                    o.start = ENDOFCHAIN;
                    o.name = "";
                }
                if (o.type === 5) {
                    minifat_store = o.start;
                    if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
                /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                    o.storage = 'fat';
                    if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                    sector_list[o.start].name = o.name;
                    o.content = sector_list[o.start].data.slice(0, o.size);
                } else {
                    o.storage = 'minifat';
                    if (o.size < 0) o.size = 0;
                    else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
                }
                if (o.content) prep_blob(o.content, 0);
                files[name] = o;
                FileIndex.push(o);
            }
        }
        function read_date(blob, offset) {
            return new Date((__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + __readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
        }
        function read_file(filename, options) {
            get_fs();
            return parse(fs.readFileSync(filename), options);
        }
        function read(blob, options) {
            switch(options && options.type || "base64"){
                case "file":
                    return read_file(blob, options);
                case "base64":
                    return parse(s2a(Base64.decode(blob)), options);
                case "binary":
                    return parse(s2a(blob), options);
            }
            return parse(blob, options);
        }
        function init_cfb(cfb, opts) {
            var o = opts || {}, root = o.root || "Root Entry";
            if (!cfb.FullPaths) cfb.FullPaths = [];
            if (!cfb.FileIndex) cfb.FileIndex = [];
            if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
            if (cfb.FullPaths.length === 0) {
                cfb.FullPaths[0] = root + "/";
                cfb.FileIndex[0] = {
                    name: root,
                    type: 5
                };
            }
            if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
            seed_cfb(cfb);
        }
        function seed_cfb(cfb) {
            var nm = "\u0001Sh33tJ5";
            if (CFB.find(cfb, "/" + nm)) return;
            var p = new_buf(4);
            p[0] = 55;
            p[1] = p[3] = 50;
            p[2] = 54;
            cfb.FileIndex.push({
                name: nm,
                type: 2,
                content: p,
                size: 4,
                L: 69,
                R: 69,
                C: 69
            });
            cfb.FullPaths.push(cfb.FullPaths[0] + nm);
            rebuild_cfb(cfb);
        }
        function rebuild_cfb(cfb, f) {
            init_cfb(cfb);
            var gc = false, s = false;
            for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
                var _file = cfb.FileIndex[i];
                switch(_file.type){
                    case 0:
                        if (s) gc = true;
                        else {
                            cfb.FileIndex.pop();
                            cfb.FullPaths.pop();
                        }
                        break;
                    case 1:
                    case 2:
                    case 5:
                        s = true;
                        if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                        if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                        break;
                    default:
                        gc = true;
                        break;
                }
            }
            if (!gc && !f) return;
            var now = new Date(1987, 1, 19), j = 0;
            var data = [];
            for(i = 0; i < cfb.FullPaths.length; ++i){
                if (cfb.FileIndex[i].type === 0) continue;
                data.push([
                    cfb.FullPaths[i],
                    cfb.FileIndex[i]
                ]);
            }
            for(i = 0; i < data.length; ++i){
                var dad = dirname(data[i][0]);
                s = false;
                for(j = 0; j < data.length; ++j)if (data[j][0] === dad) s = true;
                if (!s) data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    }
                ]);
            }
            data.sort(function(x, y) {
                return namecmp(x[0], y[0]);
            });
            cfb.FullPaths = [];
            cfb.FileIndex = [];
            for(i = 0; i < data.length; ++i){
                cfb.FullPaths[i] = data[i][0];
                cfb.FileIndex[i] = data[i][1];
            }
            for(i = 0; i < data.length; ++i){
                var elt = cfb.FileIndex[i];
                var nm = cfb.FullPaths[i];
                elt.name = filename(nm).replace("/", "");
                elt.L = elt.R = elt.C = -(elt.color = 1);
                elt.size = elt.content ? elt.content.length : 0;
                elt.start = 0;
                elt.clsid = elt.clsid || HEADER_CLSID;
                if (i === 0) {
                    elt.C = data.length > 1 ? 1 : -1;
                    elt.size = 0;
                    elt.type = 5;
                } else if (nm.slice(-1) == "/") {
                    for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                    elt.C = j >= data.length ? -1 : j;
                    for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                    elt.R = j >= data.length ? -1 : j;
                    elt.type = 1;
                } else {
                    if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                    elt.type = 2;
                }
            }
        }
        function _write(cfb, options) {
            var _opts = options || {};
            rebuild_cfb(cfb);
            if (_opts.fileType == 'zip') return write_zip(cfb, _opts);
            var L = function(cfb) {
                var mini_size = 0, fat_size = 0;
                for(var i = 0; i < cfb.FileIndex.length; ++i){
                    var file = cfb.FileIndex[i];
                    if (!file.content) continue;
                    var flen = file.content.length;
                    if (flen > 0) {
                        if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                        else fat_size += flen + 0x01FF >> 9;
                    }
                }
                var dir_cnt = cfb.FullPaths.length + 3 >> 2;
                var mini_cnt = mini_size + 7 >> 3;
                var mfat_cnt = mini_size + 0x7F >> 7;
                var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
                var fat_cnt = fat_base + 0x7F >> 7;
                var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
                while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
                var L = [
                    1,
                    difat_cnt,
                    fat_cnt,
                    mfat_cnt,
                    dir_cnt,
                    fat_size,
                    mini_size,
                    0
                ];
                cfb.FileIndex[0].size = mini_size << 6;
                L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
                return L;
            }(cfb);
            var o = new_buf(L[7] << 9);
            var i = 0, T = 0;
            for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
            for(i = 0; i < 8; ++i)o.write_shift(2, 0);
            o.write_shift(2, 0x003E);
            o.write_shift(2, 0x0003);
            o.write_shift(2, 0xFFFE);
            o.write_shift(2, 0x0009);
            o.write_shift(2, 0x0006);
            for(i = 0; i < 3; ++i)o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, L[2]);
            o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
            o.write_shift(4, 0);
            o.write_shift(4, 4096);
            o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
            o.write_shift(4, L[3]);
            o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
            o.write_shift(4, L[1]);
            for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            if (L[1]) for(T = 0; T < L[1]; ++T){
                for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
                o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
            }
            var chainit = function(w) {
                for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
                if (w) {
                    ++i;
                    o.write_shift(-4, ENDOFCHAIN);
                }
            };
            T = i = 0;
            for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
            for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
            chainit(L[3]);
            chainit(L[4]);
            var j = 0, flen = 0;
            var file = cfb.FileIndex[0];
            for(; j < cfb.FileIndex.length; ++j){
                file = cfb.FileIndex[j];
                if (!file.content) continue;
                flen = file.content.length;
                if (flen < 0x1000) continue;
                file.start = T;
                chainit(flen + 0x01FF >> 9);
            }
            chainit(L[6] + 7 >> 3);
            while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
            T = i = 0;
            for(j = 0; j < cfb.FileIndex.length; ++j){
                file = cfb.FileIndex[j];
                if (!file.content) continue;
                flen = file.content.length;
                if (!flen || flen >= 0x1000) continue;
                file.start = T;
                chainit(flen + 0x3F >> 6);
            }
            while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
            for(i = 0; i < L[4] << 2; ++i){
                var nm = cfb.FullPaths[i];
                if (!nm || nm.length === 0) {
                    for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                    for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                    for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                    continue;
                }
                file = cfb.FileIndex[i];
                if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
                var _nm = i === 0 && _opts.root || file.name;
                flen = 2 * (_nm.length + 1);
                o.write_shift(64, _nm, "utf16le");
                o.write_shift(2, flen);
                o.write_shift(1, file.type);
                o.write_shift(1, file.color);
                o.write_shift(-4, file.L);
                o.write_shift(-4, file.R);
                o.write_shift(-4, file.C);
                if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
                else o.write_shift(16, file.clsid, "hex");
                o.write_shift(4, file.state || 0);
                o.write_shift(4, 0);
                o.write_shift(4, 0);
                o.write_shift(4, 0);
                o.write_shift(4, 0);
                o.write_shift(4, file.start);
                o.write_shift(4, file.size);
                o.write_shift(4, 0);
            }
            for(i = 1; i < cfb.FileIndex.length; ++i){
                file = cfb.FileIndex[i];
                if (file.size >= 0x1000) {
                    o.l = file.start + 1 << 9;
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
            for(i = 1; i < cfb.FileIndex.length; ++i){
                file = cfb.FileIndex[i];
                if (file.size > 0 && file.size < 0x1000) {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
            while(o.l < o.length)o.write_shift(1, 0);
            return o;
        }
        /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb, path) {
            var UCFullPaths = cfb.FullPaths.map(function(x) {
                return x.toUpperCase();
            });
            var UCPaths = UCFullPaths.map(function(x) {
                var y = x.split("/");
                return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
            });
            var k = false;
            if (path.charCodeAt(0) === 47 /* "/" */ ) {
                k = true;
                path = UCFullPaths[0].slice(0, -1) + path;
            } else k = path.indexOf("/") !== -1;
            var UCPath = path.toUpperCase();
            var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
            if (w !== -1) return cfb.FileIndex[w];
            var m = !UCPath.match(chr1);
            UCPath = UCPath.replace(chr0, '');
            if (m) UCPath = UCPath.replace(chr1, '!');
            for(w = 0; w < UCFullPaths.length; ++w){
                if ((m ? UCFullPaths[w].replace(chr1, '!') : UCFullPaths[w]).replace(chr0, '') == UCPath) return cfb.FileIndex[w];
                if ((m ? UCPaths[w].replace(chr1, '!') : UCPaths[w]).replace(chr0, '') == UCPath) return cfb.FileIndex[w];
            }
            return null;
        }
        /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
        //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
        /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
        /* 2.2 Compound File Header */ var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
        var HEADER_SIG = [
            0xD0,
            0xCF,
            0x11,
            0xE0,
            0xA1,
            0xB1,
            0x1A,
            0xE1
        ];
        var HEADER_CLSID = '00000000000000000000000000000000';
        var consts = {
            /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
            DIFSECT: -4,
            FATSECT: -3,
            ENDOFCHAIN: ENDOFCHAIN,
            FREESECT: -1,
            /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
            HEADER_MINOR_VERSION: '3e00',
            MAXREGSID: -6,
            NOSTREAM: -1,
            HEADER_CLSID: HEADER_CLSID,
            /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
                'unknown',
                'storage',
                'stream',
                'lockbytes',
                'property',
                'root'
            ]
        };
        function write_file(cfb, filename, options) {
            get_fs();
            var o = _write(cfb, options);
            fs.writeFileSync(filename, o);
        }
        function a2s(o) {
            var out = new Array(o.length);
            for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
            return out.join("");
        }
        function write(cfb, options) {
            var o = _write(cfb, options);
            switch(options && options.type){
                case "file":
                    get_fs();
                    fs.writeFileSync(options.filename, o);
                    return o;
                case "binary":
                    return a2s(o);
                case "base64":
                    return Base64.encode(a2s(o));
            }
            return o;
        }
        /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
        function use_zlib(zlib) {
            try {
                var InflateRaw = zlib.InflateRaw;
                var InflRaw = new InflateRaw();
                InflRaw._processChunk(new Uint8Array([
                    3,
                    0
                ]), InflRaw._finishFlushFlag);
                if (InflRaw.bytesRead) _zlib = zlib;
                else throw new Error("zlib does not expose bytesRead");
            } catch (e) {
                console.error("cannot use native zlib: " + (e.message || e));
            }
        }
        function _inflateRawSync(payload, usz) {
            if (!_zlib) return _inflate(payload, usz);
            var InflateRaw = _zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
            payload.l += InflRaw.bytesRead;
            return out;
        }
        function _deflateRawSync(payload) {
            return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
        }
        var CLEN_ORDER = [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ];
        /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            13,
            15,
            17,
            19,
            23,
            27,
            31,
            35,
            43,
            51,
            59,
            67,
            83,
            99,
            115,
            131,
            163,
            195,
            227,
            258
        ];
        /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
            1,
            2,
            3,
            4,
            5,
            7,
            9,
            13,
            17,
            25,
            33,
            49,
            65,
            97,
            129,
            193,
            257,
            385,
            513,
            769,
            1025,
            1537,
            2049,
            3073,
            4097,
            6145,
            8193,
            12289,
            16385,
            24577
        ];
        function bit_swap_8(n) {
            var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
            return (t >> 16 | t >> 8 | t) & 0xFF;
        }
        var use_typed_arrays = typeof Uint8Array !== 'undefined';
        var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
        for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
        function bit_swap_n(n, b) {
            var rev = bitswap8[n & 0xFF];
            if (b <= 8) return rev >>> 8 - b;
            rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
            if (b <= 16) return rev >>> 16 - b;
            rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
            return rev >>> 24 - b;
        }
        /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
            var w = bl & 7, h = bl >>> 3;
            return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
        }
        function read_bits_3(buf, bl) {
            var w = bl & 7, h = bl >>> 3;
            return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
        }
        function read_bits_4(buf, bl) {
            var w = bl & 7, h = bl >>> 3;
            return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
        }
        function read_bits_5(buf, bl) {
            var w = bl & 7, h = bl >>> 3;
            return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
        }
        function read_bits_7(buf, bl) {
            var w = bl & 7, h = bl >>> 3;
            return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
        }
        /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
            var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
            var v = buf[h] >>> w;
            if (n < 8 - w) return v & f;
            v |= buf[h + 1] << 8 - w;
            if (n < 16 - w) return v & f;
            v |= buf[h + 2] << 16 - w;
            if (n < 24 - w) return v & f;
            v |= buf[h + 3] << 24 - w;
            return v & f;
        }
        /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz) {
            var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
            if (L >= sz) return b;
            if (has_buf) {
                var o = new_unsafe_buf(M);
                // $FlowIgnore
                if (b.copy) b.copy(o);
                else for(; i < b.length; ++i)o[i] = b[i];
                return o;
            } else if (use_typed_arrays) {
                var a = new Uint8Array(M);
                if (a.set) a.set(b);
                else for(; i < b.length; ++i)a[i] = b[i];
                return a;
            }
            b.length = M;
            return b;
        }
        /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
            var o = new Array(n);
            for(var i = 0; i < n; ++i)o[i] = 0;
            return o;
        }
        var _deflate = function() {
            var _deflateRaw = function() {
                return function deflateRaw(data, out) {
                    var boff = 0;
                    while(boff < data.length){
                        var L = Math.min(0xFFFF, data.length - boff);
                        var h = boff + L == data.length;
                        /* TODO: this is only type 0 stored */ out.write_shift(1, +h);
                        out.write_shift(2, L);
                        out.write_shift(2, ~L & 0xFFFF);
                        while(L-- > 0)out[out.l++] = data[boff++];
                    }
                    return out.l;
                };
            }();
            return function(data) {
                var buf = new_buf(50 + Math.floor(data.length * 1.1));
                var off = _deflateRaw(data, buf);
                return buf.slice(0, off);
            };
        }();
        /* modified inflate function also moves original read head */ /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX) {
            var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
            var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
            for(i = 0; i < 32; ++i)bl_count[i] = 0;
            for(i = L; i < MAX; ++i)clens[i] = 0;
            L = clens.length;
            var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
            /* build code tree */ for(i = 0; i < L; ++i){
                bl_count[w = clens[i]]++;
                if (maxlen < w) maxlen = w;
                ctree[i] = 0;
            }
            bl_count[0] = 0;
            for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
            for(i = 0; i < L; ++i){
                ccode = clens[i];
                if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
            }
            /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
            for(i = 0; i < L; ++i){
                cleni = clens[i];
                if (cleni != 0) {
                    ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                    for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
                }
            }
            return maxlen;
        }
        var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
        var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        if (!use_typed_arrays) {
            for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
            for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
        }
        (function() {
            var dlens = [];
            var i = 0;
            for(; i < 32; i++)dlens.push(5);
            build_tree(dlens, fix_dmap, 32);
            var clens = [];
            i = 0;
            for(; i <= 143; i++)clens.push(8);
            for(; i <= 255; i++)clens.push(9);
            for(; i <= 279; i++)clens.push(7);
            for(; i <= 287; i++)clens.push(8);
            build_tree(clens, fix_lmap, 288);
        })();
        var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
        var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
        var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
        var dyn_len_1 = 1, dyn_len_2 = 1;
        /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff) {
            /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
            boff += 5;
            var _HDIST = read_bits_5(data, boff) + 1;
            boff += 5;
            var _HCLEN = read_bits_4(data, boff) + 4;
            boff += 4;
            var w = 0;
            /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
            var ctree = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            var maxlen = 1;
            var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
            var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
            var L = clens.length; /* 19 */ 
            for(var i = 0; i < _HCLEN; ++i){
                clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
                if (maxlen < w) maxlen = w;
                bl_count[w]++;
                boff += 3;
            }
            /* build code tree */ var ccode = 0;
            bl_count[0] = 0;
            for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
            for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
            /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
            for(i = 0; i < L; ++i){
                cleni = clens[i];
                if (cleni != 0) {
                    ccode = bitswap8[ctree[i]] >> 8 - cleni;
                    for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
                }
            }
            /* read literal and dist codes at once */ var hcodes = [];
            maxlen = 1;
            for(; hcodes.length < _HLIT + _HDIST;){
                ccode = dyn_cmap[read_bits_7(data, boff)];
                boff += ccode & 7;
                switch(ccode >>>= 3){
                    case 16:
                        w = 3 + read_bits_2(data, boff);
                        boff += 2;
                        ccode = hcodes[hcodes.length - 1];
                        while(w-- > 0)hcodes.push(ccode);
                        break;
                    case 17:
                        w = 3 + read_bits_3(data, boff);
                        boff += 3;
                        while(w-- > 0)hcodes.push(0);
                        break;
                    case 18:
                        w = 11 + read_bits_7(data, boff);
                        boff += 7;
                        while(w-- > 0)hcodes.push(0);
                        break;
                    default:
                        hcodes.push(ccode);
                        if (maxlen < ccode) maxlen = ccode;
                        break;
                }
            }
            /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
            for(i = _HLIT; i < 286; ++i)h1[i] = 0;
            for(i = _HDIST; i < 30; ++i)h2[i] = 0;
            dyn_len_1 = build_tree(h1, dyn_lmap, 286);
            dyn_len_2 = build_tree(h2, dyn_dmap, 30);
            return boff;
        }
        /* return [ data, bytesRead ] */ function inflate(data, usz) {
            /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
                new_raw_buf(usz),
                2
            ];
            /* bit offset */ var boff = 0;
            /* header includes final bit and type bits */ var header = 0;
            var outbuf = new_unsafe_buf(usz ? usz : 262144);
            var woff = 0;
            var OL = outbuf.length >>> 0;
            var max_len_1 = 0, max_len_2 = 0;
            while((header & 1) == 0){
                header = read_bits_3(data, boff);
                boff += 3;
                if (header >>> 1 == 0) {
                    /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                    /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                    boff += 32;
                    /* push sz bytes */ if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    if (typeof data.copy === 'function') {
                        // $FlowIgnore
                        data.copy(outbuf, woff, boff >>> 3, (boff >>> 3) + sz);
                        woff += sz;
                        boff += 8 * sz;
                    } else while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                    continue;
                } else if (header >>> 1 == 1) {
                    /* Fixed Huffman */ max_len_1 = 9;
                    max_len_2 = 5;
                } else {
                    /* Dynamic Huffman */ boff = dyn(data, boff);
                    max_len_1 = dyn_len_1;
                    max_len_2 = dyn_len_2;
                }
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                for(;;){
                    /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                    var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                    else if (code == 256) break;
                    else {
                        code -= 257;
                        var len_eb = code < 8 ? 0 : code - 4 >> 2;
                        if (len_eb > 5) len_eb = 0;
                        var tgt = woff + LEN_LN[code];
                        /* length extra bits */ if (len_eb > 0) {
                            tgt += read_bits_n(data, boff, len_eb);
                            boff += len_eb;
                        }
                        /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                        code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                        boff += code & 15;
                        code >>>= 4;
                        var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                        var dst = DST_LN[code];
                        /* dist extra bits */ if (dst_eb > 0) {
                            dst += read_bits_n(data, boff, dst_eb);
                            boff += dst_eb;
                        }
                        /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                            outbuf = realloc(outbuf, tgt);
                            OL = outbuf.length;
                        }
                        while(woff < tgt){
                            outbuf[woff] = outbuf[woff - dst];
                            ++woff;
                        }
                    }
                }
            }
            return [
                usz ? outbuf : outbuf.slice(0, woff),
                boff + 7 >>> 3
            ];
        }
        function _inflate(payload, usz) {
            var data = payload.slice(payload.l || 0);
            var out = inflate(data, usz);
            payload.l += out[1];
            return out[0];
        }
        function warn_or_throw(wrn, msg) {
            if (wrn) {
                if (typeof console !== 'undefined') console.error(msg);
            } else throw new Error(msg);
        }
        function parse_zip(file, options) {
            var blob = file;
            prep_blob(blob, 0);
            var FileIndex = [], FullPaths = [];
            var o = {
                FileIndex: FileIndex,
                FullPaths: FullPaths
            };
            init_cfb(o, {
                root: options.root
            });
            /* find end of central directory, start just after signature */ var i = blob.length - 4;
            while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
            blob.l = i + 4;
            /* parse end of central directory */ blob.l += 4;
            var fcnt = blob.read_shift(2);
            blob.l += 6;
            var start_cd = blob.read_shift(4);
            /* parse central directory */ blob.l = start_cd;
            for(i = 0; i < fcnt; ++i){
                /* trust local file header instead of CD entry */ blob.l += 20;
                var csz = blob.read_shift(4);
                var usz = blob.read_shift(4);
                var namelen = blob.read_shift(2);
                var efsz = blob.read_shift(2);
                var fcsz = blob.read_shift(2);
                blob.l += 8;
                var offset = blob.read_shift(4);
                var EF = parse_extra_field(blob.slice(blob.l + namelen, blob.l + namelen + efsz));
                blob.l += namelen + efsz + fcsz;
                var L = blob.l;
                blob.l = offset + 4;
                parse_local_file(blob, csz, usz, o, EF);
                blob.l = L;
            }
            return o;
        }
        /* head starts just after local file header signature */ function parse_local_file(blob, csz, usz, o, EF) {
            /* [local file header] */ blob.l += 2;
            var flags = blob.read_shift(2);
            var meth = blob.read_shift(2);
            var date = parse_dos_date(blob);
            if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
            var crc32 = blob.read_shift(4);
            var _csz = blob.read_shift(4);
            var _usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            // TODO: flags & (1<<11) // UTF8
            var name = "";
            for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
            if (efsz) {
                var ef = parse_extra_field(blob.slice(blob.l, blob.l + efsz));
                if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
                if (((EF || {})[0x5455] || {}).mt) date = EF[0x5455].mt;
            }
            blob.l += efsz;
            /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
            switch(meth){
                case 8:
                    data = _inflateRawSync(blob, _usz);
                    break;
                case 0:
                    break;
                default:
                    throw new Error("Unsupported ZIP Compression method " + meth);
            }
            /* [data descriptor] */ var wrn = false;
            if (flags & 8) {
                crc32 = blob.read_shift(4);
                if (crc32 == 0x08074b50) {
                    crc32 = blob.read_shift(4);
                    wrn = true;
                }
                _csz = blob.read_shift(4);
                _usz = blob.read_shift(4);
            }
            if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
            if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
            var _crc32 = CRC32.buf(data, 0);
            if (crc32 >> 0 != _crc32 >> 0) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
            cfb_add(o, name, data, {
                unsafe: true,
                mt: date
            });
        }
        function write_zip(cfb, options) {
            var _opts = options || {};
            var out = [], cdirs = [];
            var o = new_buf(1);
            var method = _opts.compression ? 8 : 0, flags = 0;
            var desc = false;
            if (desc) flags |= 8;
            var i = 0, j = 0;
            var start_cd = 0, fcnt = 0;
            var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
            var crcs = [];
            var sz_cd = 0;
            for(i = 1; i < cfb.FullPaths.length; ++i){
                fp = cfb.FullPaths[i].slice(root.length);
                fi = cfb.FileIndex[i];
                if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
                var start = start_cd;
                /* TODO: CP437 filename */ var namebuf = new_buf(fp.length);
                for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
                namebuf = namebuf.slice(0, namebuf.l);
                crcs[fcnt] = CRC32.buf(fi.content, 0);
                var outbuf = fi.content;
                if (method == 8) outbuf = _deflateRawSync(outbuf);
                /* local file header */ o = new_buf(30);
                o.write_shift(4, 0x04034b50);
                o.write_shift(2, 20);
                o.write_shift(2, flags);
                o.write_shift(2, method);
                /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
                else o.write_shift(4, 0);
                o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
                o.write_shift(4, flags & 8 ? 0 : outbuf.length);
                o.write_shift(4, flags & 8 ? 0 : fi.content.length);
                o.write_shift(2, namebuf.length);
                o.write_shift(2, 0);
                start_cd += o.length;
                out.push(o);
                start_cd += namebuf.length;
                out.push(namebuf);
                /* TODO: encryption header ? */ start_cd += outbuf.length;
                out.push(outbuf);
                /* data descriptor */ if (flags & 8) {
                    o = new_buf(12);
                    o.write_shift(-4, crcs[fcnt]);
                    o.write_shift(4, outbuf.length);
                    o.write_shift(4, fi.content.length);
                    start_cd += o.l;
                    out.push(o);
                }
                /* central directory */ o = new_buf(46);
                o.write_shift(4, 0x02014b50);
                o.write_shift(2, 0);
                o.write_shift(2, 20);
                o.write_shift(2, flags);
                o.write_shift(2, method);
                o.write_shift(4, 0); /* TODO: last mod file time/date */ 
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, fi.content.length);
                o.write_shift(2, namebuf.length);
                o.write_shift(2, 0);
                o.write_shift(2, 0);
                o.write_shift(2, 0);
                o.write_shift(2, 0);
                o.write_shift(4, 0);
                o.write_shift(4, start);
                sz_cd += o.l;
                cdirs.push(o);
                sz_cd += namebuf.length;
                cdirs.push(namebuf);
                ++fcnt;
            }
            /* end of central directory */ o = new_buf(22);
            o.write_shift(4, 0x06054b50);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, fcnt);
            o.write_shift(2, fcnt);
            o.write_shift(4, sz_cd);
            o.write_shift(4, start_cd);
            o.write_shift(2, 0);
            return bconcat([
                bconcat(out),
                bconcat(cdirs),
                o
            ]);
        }
        function cfb_new(opts) {
            var o = {};
            init_cfb(o, opts);
            return o;
        }
        function cfb_add(cfb, name, content, opts) {
            var unsafe = opts && opts.unsafe;
            if (!unsafe) init_cfb(cfb);
            var file = !unsafe && CFB.find(cfb, name);
            if (!file) {
                var fpath = cfb.FullPaths[0];
                if (name.slice(0, fpath.length) == fpath) fpath = name;
                else {
                    if (fpath.slice(-1) != "/") fpath += "/";
                    fpath = (fpath + name).replace("//", "/");
                }
                file = {
                    name: filename(name),
                    type: 2
                };
                cfb.FileIndex.push(file);
                cfb.FullPaths.push(fpath);
                if (!unsafe) CFB.utils.cfb_gc(cfb);
            }
            file.content = content;
            file.size = content ? content.length : 0;
            if (opts) {
                if (opts.CLSID) file.clsid = opts.CLSID;
                if (opts.mt) file.mt = opts.mt;
                if (opts.ct) file.ct = opts.ct;
            }
            return file;
        }
        function cfb_del(cfb, name) {
            init_cfb(cfb);
            var file = CFB.find(cfb, name);
            if (file) {
                for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                    cfb.FileIndex.splice(j, 1);
                    cfb.FullPaths.splice(j, 1);
                    return true;
                }
            }
            return false;
        }
        function cfb_mov(cfb, old_name, new_name) {
            init_cfb(cfb);
            var file = CFB.find(cfb, old_name);
            if (file) {
                for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                    cfb.FileIndex[j].name = filename(new_name);
                    cfb.FullPaths[j] = new_name;
                    return true;
                }
            }
            return false;
        }
        function cfb_gc(cfb) {
            rebuild_cfb(cfb, true);
        }
        exports1.find = find;
        exports1.read = read;
        exports1.parse = parse;
        exports1.write = write;
        exports1.writeFile = write_file;
        exports1.utils = {
            cfb_new: cfb_new,
            cfb_add: cfb_add,
            cfb_del: cfb_del,
            cfb_mov: cfb_mov,
            cfb_gc: cfb_gc,
            ReadShift: ReadShift,
            CheckField: CheckField,
            prep_blob: prep_blob,
            bconcat: bconcat,
            use_zlib: use_zlib,
            _deflateRaw: _deflate,
            _inflateRaw: _inflate,
            consts: consts
        };
        return exports1;
    }();
    if (typeof DO_NOT_EXPORT_CFB === 'undefined') module.exports = CFB;
    var _fs;
    try {
        _fs = require("d0d1d500be3fa453");
    } catch (e) {}
    /* normalize data for blob ctor */ function blobify(data) {
        if (typeof data === "string") return s2ab(data);
        if (Array.isArray(data)) return a2u(data);
        return data;
    }
    /* write or download file */ function write_dl(fname, payload, enc) {
        /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
        var data = enc == "utf8" ? utf8write(payload) : payload;
        if (typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
        if (typeof Blob !== 'undefined') {
            var blob = new Blob([
                blobify(data)
            ], {
                type: "application/octet-stream"
            });
            if (typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
            if (typeof saveAs !== 'undefined') return saveAs(blob, fname);
            if (typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
                var url = URL.createObjectURL(blob);
                if (typeof chrome === 'object' && typeof (chrome.downloads || {}).download == "function") {
                    if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                        URL.revokeObjectURL(url);
                    }, 60000);
                    return chrome.downloads.download({
                        url: url,
                        filename: fname,
                        saveAs: true
                    });
                }
                var a = document.createElement("a");
                if (a.download != null) {
                    a.download = fname;
                    a.href = url;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                        URL.revokeObjectURL(url);
                    }, 60000);
                    return url;
                }
            }
        }
        // $FlowIgnore
        if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
            // $FlowIgnore
            var out = File(fname);
            out.open("w");
            out.encoding = "binary";
            if (Array.isArray(payload)) payload = a2s(payload);
            out.write(payload);
            out.close();
            return payload;
        } catch (e) {
            if (!e.message || !e.message.match(/onstruct/)) throw e;
        }
        throw new Error("cannot save file " + fname);
    }
    /* read binary data from file */ function read_binary(path) {
        if (typeof _fs !== 'undefined') return _fs.readFileSync(path);
        // $FlowIgnore
        if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
            // $FlowIgnore
            var infile = File(path);
            infile.open("r");
            infile.encoding = "binary";
            var data = infile.read();
            infile.close();
            return data;
        } catch (e) {
            if (!e.message || !e.message.match(/onstruct/)) throw e;
        }
        throw new Error("Cannot access file " + path);
    }
    function keys(o) {
        var ks = Object.keys(o), o2 = [];
        for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
        return o2;
    }
    function evert_key(obj, key) {
        var o = [], K = keys(obj);
        for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
        return o;
    }
    function evert(obj) {
        var o = [], K = keys(obj);
        for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
        return o;
    }
    function evert_num(obj) {
        var o = [], K = keys(obj);
        for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
        return o;
    }
    function evert_arr(obj) {
        var o = [], K = keys(obj);
        for(var i = 0; i !== K.length; ++i){
            if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
            o[obj[K[i]]].push(K[i]);
        }
        return o;
    }
    var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
    function datenum(v, date1904) {
        var epoch = v.getTime();
        if (date1904) epoch -= 126316800000;
        var dnthresh = basedate.getTime() + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
        return (epoch - dnthresh) / 86400000;
    }
    var refdate = new Date();
    var dnthresh = basedate.getTime() + (refdate.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
    var refoffset = refdate.getTimezoneOffset();
    function numdate(v) {
        var out = new Date();
        out.setTime(v * 86400000 + dnthresh);
        if (out.getTimezoneOffset() !== refoffset) out.setTime(out.getTime() + (out.getTimezoneOffset() - refoffset) * 60000);
        return out;
    }
    /* ISO 8601 Duration */ function parse_isodur(s) {
        var sec = 0, mt = 0, time = false;
        var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
        if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
        for(var i = 1; i != m.length; ++i){
            if (!m[i]) continue;
            mt = 1;
            if (i > 3) time = true;
            switch(m[i].slice(m[i].length - 1)){
                case 'Y':
                    throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
                case 'D':
                    mt *= 24;
                /* falls through */ case 'H':
                    mt *= 60;
                /* falls through */ case 'M':
                    if (!time) throw new Error("Unsupported ISO Duration Field: M");
                    else mt *= 60;
                /* falls through */ case 'S':
                    break;
            }
            sec += mt * parseInt(m[i], 10);
        }
        return sec;
    }
    var good_pd_date = new Date('2017-02-19T19:06:09.000Z');
    if (isNaN(good_pd_date.getFullYear())) good_pd_date = new Date('2/19/17');
    var good_pd = good_pd_date.getFullYear() == 2017;
    /* parses a date as a local date */ function parseDate(str, fixdate) {
        var d = new Date(str);
        if (good_pd) {
            if (fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60000);
            else if (fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60000);
            return d;
        }
        if (str instanceof Date) return str;
        if (good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
            var s = d.getFullYear();
            if (str.indexOf("" + s) > -1) return d;
            d.setFullYear(d.getFullYear() + 100);
            return d;
        }
        var n = str.match(/\d+/g) || [
            "2017",
            "2",
            "19",
            "0",
            "0",
            "0"
        ];
        var out = new Date(+n[0], +n[1] - 1, +n[2], +n[3] || 0, +n[4] || 0, +n[5] || 0);
        if (str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60000);
        return out;
    }
    function cc2str(arr) {
        var o = "";
        for(var i = 0; i != arr.length; ++i)o += String.fromCharCode(arr[i]);
        return o;
    }
    function dup(o) {
        if (typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
        if (typeof o != 'object' || o == null) return o;
        if (o instanceof Date) return new Date(o.getTime());
        var out = {};
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = dup(o[k]);
        return out;
    }
    function fill(c, l) {
        var o = "";
        while(o.length < l)o += c;
        return o;
    }
    /* TODO: stress test */ function fuzzynum(s) {
        var v = Number(s);
        if (!isNaN(v)) return v;
        if (!/\d/.test(s)) return v;
        var wt = 1;
        var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
            wt *= 100;
            return "";
        });
        if (!isNaN(v = Number(ss))) return v / wt;
        ss = ss.replace(/[(](.*)[)]/, function($$, $1) {
            wt = -wt;
            return $1;
        });
        if (!isNaN(v = Number(ss))) return v / wt;
        return v;
    }
    function fuzzydate(s) {
        var o = new Date(s), n = new Date(NaN);
        var y = o.getYear(), m = o.getMonth(), d = o.getDate();
        if (isNaN(d)) return n;
        if (y < 0 || y > 8099) return n;
        if ((m > 0 || d > 1) && y != 101) return o;
        if (s.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) return o;
        if (s.match(/[^-0-9:,\/\\]/)) return n;
        return o;
    }
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    function split_regex(str, re, def) {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    }
    function getdatastr(data) {
        if (!data) return null;
        if (data.data) return debom(data.data);
        if (data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
        if (data.asBinary) return debom(data.asBinary());
        if (data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
        if (data.content && data.type) return debom(cc2str(data.content));
        return null;
    }
    function getdatabin(data) {
        if (!data) return null;
        if (data.data) return char_codes(data.data);
        if (data.asNodeBuffer && has_buf) return data.asNodeBuffer();
        if (data._data && data._data.getContent) {
            var o = data._data.getContent();
            if (typeof o == "string") return char_codes(o);
            return Array.prototype.slice.call(o);
        }
        if (data.content && data.type) return data.content;
        return null;
    }
    function getdata(data) {
        return data && data.name.slice(-4) === ".bin" ? getdatabin(data) : getdatastr(data);
    }
    /* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function safegetzipfile(zip, file) {
        var k = zip.FullPaths || keys(zip.files);
        var f = file.toLowerCase(), g = f.replace(/\//g, '\\');
        for(var i = 0; i < k.length; ++i){
            var n = k[i].toLowerCase();
            if (f == n || g == n) return zip.files[k[i]];
        }
        return null;
    }
    function getzipfile(zip, file) {
        var o = safegetzipfile(zip, file);
        if (o == null) throw new Error("Cannot find file " + file + " in zip");
        return o;
    }
    function getzipdata(zip, file, safe) {
        if (!safe) return getdata(getzipfile(zip, file));
        if (!file) return null;
        try {
            return getzipdata(zip, file);
        } catch (e) {
            return null;
        }
    }
    function getzipstr(zip, file, safe) {
        if (!safe) return getdatastr(getzipfile(zip, file));
        if (!file) return null;
        try {
            return getzipstr(zip, file);
        } catch (e) {
            return null;
        }
    }
    function zipentries(zip) {
        var k = zip.FullPaths || keys(zip.files), o = [];
        for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != '/') o.push(k[i]);
        return o.sort();
    }
    function zip_add_file(zip, path, content) {
        if (zip.FullPaths) CFB.utils.cfb_add(zip, path, content);
        else zip.file(path, content);
    }
    var jszip;
    /*global JSZipSync:true */ if (typeof JSZipSync !== 'undefined') jszip = JSZipSync;
    if (0, module.exports) {
        if (typeof jszip === 'undefined') jszip = require("fdb983bb55cd9233");
    }
    function zip_new() {
        if (!jszip) return CFB.utils.cfb_new();
        return new jszip();
    }
    function zip_read(d, o) {
        var zip;
        if (jszip) switch(o.type){
            case "base64":
                zip = new jszip(d, {
                    base64: true
                });
                break;
            case "binary":
            case "array":
                zip = new jszip(d, {
                    base64: false
                });
                break;
            case "buffer":
                zip = new jszip(d);
                break;
            default:
                throw new Error("Unrecognized type " + o.type);
        }
        else switch(o.type){
            case "base64":
                zip = CFB.read(d, {
                    type: "base64"
                });
                break;
            case "binary":
                zip = CFB.read(d, {
                    type: "binary"
                });
                break;
            case "buffer":
            case "array":
                zip = CFB.read(d, {
                    type: "buffer"
                });
                break;
            default:
                throw new Error("Unrecognized type " + o.type);
        }
        return zip;
    }
    function resolve_path(path, base) {
        if (path.charAt(0) == "/") return path.slice(1);
        var result = base.split('/');
        if (base.slice(-1) != "/") result.pop(); // folder path
        var target = path.split('/');
        while(target.length !== 0){
            var step = target.shift();
            if (step === '..') result.pop();
            else if (step !== '.') result.push(step);
        }
        return result.join('/');
    }
    var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
    var attregexg = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
    var tagregex = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s?[\/\?]?>/mg;
    if (!XML_HEADER.match(tagregex)) tagregex = /<[^>]*>/g;
    var nsregex = /<\w*:/, nsregex2 = /<(\/?)\w+:/;
    function parsexmltag(tag, skip_root, skip_LC) {
        var z = {};
        var eq = 0, c = 0;
        for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
        if (!skip_root) z[0] = tag.slice(0, eq);
        if (eq === tag.length) return z;
        var m = tag.match(attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
        if (m) for(i = 0; i != m.length; ++i){
            cc = m[i];
            for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
            q = cc.slice(0, c).trim();
            while(cc.charCodeAt(c + 1) == 32)++c;
            quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
            v = cc.slice(c + 1 + quot, cc.length - quot);
            for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
            if (j === q.length) {
                if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
                z[q] = v;
                if (!skip_LC) z[q.toLowerCase()] = v;
            } else {
                var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
                if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
                z[k] = v;
                if (!skip_LC) z[k.toLowerCase()] = v;
            }
        }
        return z;
    }
    function strip_ns(x) {
        return x.replace(nsregex2, "<$1");
    }
    var encodings = {
        '&quot;': '"',
        '&apos;': "'",
        '&gt;': '>',
        '&lt;': '<',
        '&amp;': '&'
    };
    var rencoding = evert(encodings);
    //var rencstr = "&<>'\"".split("");
    // TODO: CP remap (need to read file version to determine OS)
    var unescapexml = function() {
        /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
        return function unescapexml(text) {
            var s = text + '', i = s.indexOf("<![CDATA[");
            if (i == -1) return s.replace(encregex, function($$, $1) {
                return encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
            }).replace(coderegex, function(m, c) {
                return String.fromCharCode(parseInt(c, 16));
            });
            var j = s.indexOf("]]>");
            return unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + unescapexml(s.slice(j + 3));
        };
    }();
    var decregex = /[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
    function escapexml(text) {
        var s = text + '';
        return s.replace(decregex, function(y) {
            return rencoding[y];
        }).replace(charegex, function(s) {
            return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
        });
    }
    function escapexmltag(text) {
        return escapexml(text).replace(/ /g, "_x0020_");
    }
    var htmlcharegex = /[\u0000-\u001f]/g;
    function escapehtml(text) {
        var s = text + '';
        return s.replace(decregex, function(y) {
            return rencoding[y];
        }).replace(/\n/g, "<br/>").replace(htmlcharegex, function(s) {
            return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
        });
    }
    function escapexlml(text) {
        var s = text + '';
        return s.replace(decregex, function(y) {
            return rencoding[y];
        }).replace(htmlcharegex, function(s) {
            return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
        });
    }
    /* TODO: handle codepages */ var xlml_fixstr = function() {
        var entregex = /&#(\d+);/g;
        function entrepl($$, $1) {
            return String.fromCharCode(parseInt($1, 10));
        }
        return function xlml_fixstr(str) {
            return str.replace(entregex, entrepl);
        };
    }();
    var xlml_unfixstr = function() {
        return function xlml_unfixstr(str) {
            return str.replace(/(\r\n|[\r\n])/g, "\&#10;");
        };
    }();
    function parsexmlbool(value) {
        switch(value){
            case 1:
            case true:
            case '1':
            case 'true':
            case 'TRUE':
                return true;
            /* case '0': case 'false': case 'FALSE':*/ default:
                return false;
        }
    }
    var utf8read = function utf8reada(orig) {
        var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
        while(i < orig.length){
            c = orig.charCodeAt(i++);
            if (c < 128) {
                out += String.fromCharCode(c);
                continue;
            }
            d = orig.charCodeAt(i++);
            if (c > 191 && c < 224) {
                f = (c & 31) << 6;
                f |= d & 63;
                out += String.fromCharCode(f);
                continue;
            }
            e = orig.charCodeAt(i++);
            if (c < 240) {
                out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
                continue;
            }
            f = orig.charCodeAt(i++);
            w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
            out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
            out += String.fromCharCode(0xDC00 + (w & 1023));
        }
        return out;
    };
    var utf8write = function(orig) {
        var out = [], i = 0, c = 0, d = 0;
        while(i < orig.length){
            c = orig.charCodeAt(i++);
            switch(true){
                case c < 128:
                    out.push(String.fromCharCode(c));
                    break;
                case c < 2048:
                    out.push(String.fromCharCode(192 + (c >> 6)));
                    out.push(String.fromCharCode(128 + (c & 63)));
                    break;
                case c >= 55296 && c < 57344:
                    c -= 55296;
                    d = orig.charCodeAt(i++) - 56320 + (c << 10);
                    out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                    out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                    out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                    out.push(String.fromCharCode(128 + (d & 63)));
                    break;
                default:
                    out.push(String.fromCharCode(224 + (c >> 12)));
                    out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                    out.push(String.fromCharCode(128 + (c & 63)));
            }
        }
        return out.join("");
    };
    if (has_buf) {
        var utf8readb = function utf8readb(data) {
            var out = Buffer.alloc(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
            for(i = 0; i < data.length; i += j){
                j = 1;
                if ((c = data.charCodeAt(i)) < 128) w = c;
                else if (c < 224) {
                    w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
                    j = 2;
                } else if (c < 240) {
                    w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
                    j = 3;
                } else {
                    j = 4;
                    w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
                    w -= 65536;
                    ww = 0xD800 + (w >>> 10 & 1023);
                    w = 0xDC00 + (w & 1023);
                }
                if (ww !== 0) {
                    out[k++] = ww & 255;
                    out[k++] = ww >>> 8;
                    ww = 0;
                }
                out[k++] = w % 256;
                out[k++] = w >>> 8;
            }
            return out.slice(0, k).toString('ucs2');
        };
        var corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
        if (utf8read(corpus) == utf8readb(corpus)) utf8read = utf8readb;
        var utf8readc = function utf8readc(data) {
            return Buffer_from(data, 'binary').toString('utf8');
        };
        if (utf8read(corpus) == utf8readc(corpus)) utf8read = utf8readc;
        utf8write = function(data) {
            return Buffer_from(data, 'utf8').toString("binary");
        };
    }
    // matches <foo>...</foo> extracts content
    var matchtag = function() {
        var mtcache = {};
        return function matchtag(f, g) {
            var t = f + "|" + (g || "");
            if (mtcache[t]) return mtcache[t];
            return mtcache[t] = new RegExp('<(?:\\w+:)?' + f + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + f + '>', g || "");
        };
    }();
    var htmldecode = function() {
        var entities = [
            [
                'nbsp',
                ' '
            ],
            [
                'middot',
                "\xb7"
            ],
            [
                'quot',
                '"'
            ],
            [
                'apos',
                "'"
            ],
            [
                'gt',
                '>'
            ],
            [
                'lt',
                '<'
            ],
            [
                'amp',
                '&'
            ]
        ].map(function(x) {
            return [
                new RegExp('&' + x[0] + ';', "ig"),
                x[1]
            ];
        });
        return function htmldecode(str) {
            var o = str// Remove new lines and spaces from start of content
            .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
            .replace(/[\t\n\r ]+$/, "")// Added line which removes any white space characters after and before html tags
            .replace(/>\s+/g, ">").replace(/\s+</g, "<")// Replace remaining new lines and spaces with space
            .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
            .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
            .replace(/<[^>]*>/g, "");
            for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
            return o;
        };
    }();
    var vtregex = function() {
        var vt_cache = {};
        return function vt_regex(bt) {
            if (vt_cache[bt] !== undefined) return vt_cache[bt];
            return vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g');
        };
    }();
    var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
    function parseVector(data, opts) {
        var h = parsexmltag(data);
        var matches = data.match(vtregex(h.baseType)) || [];
        var res = [];
        if (matches.length != h.size) {
            if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
            return res;
        }
        matches.forEach(function(x) {
            var v = x.replace(vtvregex, "").match(vtmregex);
            if (v) res.push({
                v: utf8read(v[2]),
                t: v[1]
            });
        });
        return res;
    }
    var wtregex = /(^\s|\s$|\n)/;
    function writetag(f, g) {
        return '<' + f + (g.match(wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';
    }
    function wxt_helper(h) {
        return keys(h).map(function(k) {
            return " " + k + '="' + h[k] + '"';
        }).join("");
    }
    function writextag(f, g, h) {
        return '<' + f + (h != null ? wxt_helper(h) : "") + (g != null ? (g.match(wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';
    }
    function write_w3cdtf(d, t) {
        try {
            return d.toISOString().replace(/\.\d*/, "");
        } catch (e) {
            if (t) throw e;
        }
        return "";
    }
    function write_vt(s, xlsx) {
        switch(typeof s){
            case 'string':
                var o = writextag('vt:lpwstr', escapexml(s));
                if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
                return o;
            case 'number':
                return writextag((s | 0) == s ? 'vt:i4' : 'vt:r8', escapexml(String(s)));
            case 'boolean':
                return writextag('vt:bool', s ? 'true' : 'false');
        }
        if (s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
        throw new Error("Unable to serialize " + s);
    }
    var XMLNS = {
        'dc': 'http://purl.org/dc/elements/1.1/',
        'dcterms': 'http://purl.org/dc/terms/',
        'dcmitype': 'http://purl.org/dc/dcmitype/',
        'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
        'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
        'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
        'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
        'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
        'xsd': 'http://www.w3.org/2001/XMLSchema'
    };
    XMLNS.main = [
        'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
        'http://purl.oclc.org/ooxml/spreadsheetml/main',
        'http://schemas.microsoft.com/office/excel/2006/main',
        'http://schemas.microsoft.com/office/excel/2006/2'
    ];
    var XLMLNS = {
        'o': 'urn:schemas-microsoft-com:office:office',
        'x': 'urn:schemas-microsoft-com:office:excel',
        'ss': 'urn:schemas-microsoft-com:office:spreadsheet',
        'dt': 'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
        'mv': 'http://macVmlSchemaUri',
        'v': 'urn:schemas-microsoft-com:vml',
        'html': 'http://www.w3.org/TR/REC-html40'
    };
    function read_double_le(b, idx) {
        var s = 1 - 2 * (b[idx + 7] >>> 7);
        var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
        var m = b[idx + 6] & 0x0f;
        for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
        if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
        if (e == 0) e = -1022;
        else {
            e -= 1023;
            m += Math.pow(2, 52);
        }
        return s * Math.pow(2, e - 52) * m;
    }
    function write_double_le(b, v, idx) {
        var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
        var av = bs ? -v : v;
        if (!isFinite(av)) {
            e = 0x7ff;
            m = isNaN(v) ? 0x6969 : 0;
        } else if (av == 0) e = m = 0;
        else {
            e = Math.floor(Math.log(av) / Math.LN2);
            m = av * Math.pow(2, 52 - e);
            if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
            else {
                m -= Math.pow(2, 52);
                e += 1023;
            }
        }
        for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
        b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
        b[idx + 7] = e >> 4 | bs;
    }
    var __toBuffer = function(bufs) {
        var x = [], w = 10240;
        for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
        return x;
    };
    var ___toBuffer = __toBuffer;
    var __utf16le = function(b, s, e) {
        var ss = [];
        for(var i = s; i < e; i += 2)ss.push(String.fromCharCode(__readUInt16LE(b, i)));
        return ss.join("").replace(chr0, '');
    };
    var ___utf16le = __utf16le;
    var __hexlify = function(b, s, l) {
        var ss = [];
        for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
        return ss.join("");
    };
    var ___hexlify = __hexlify;
    var __utf8 = function(b, s, e) {
        var ss = [];
        for(var i = s; i < e; i++)ss.push(String.fromCharCode(__readUInt8(b, i)));
        return ss.join("");
    };
    var ___utf8 = __utf8;
    var __lpstr = function(b, i) {
        var len = __readUInt32LE(b, i);
        return len > 0 ? __utf8(b, i + 4, i + 4 + len - 1) : "";
    };
    var ___lpstr = __lpstr;
    var __cpstr = function(b, i) {
        var len = __readUInt32LE(b, i);
        return len > 0 ? __utf8(b, i + 4, i + 4 + len - 1) : "";
    };
    var ___cpstr = __cpstr;
    var __lpwstr = function(b, i) {
        var len = 2 * __readUInt32LE(b, i);
        return len > 0 ? __utf8(b, i + 4, i + 4 + len - 1) : "";
    };
    var ___lpwstr = __lpwstr;
    var __lpp4, ___lpp4;
    __lpp4 = ___lpp4 = function lpp4_(b, i) {
        var len = __readUInt32LE(b, i);
        return len > 0 ? __utf16le(b, i + 4, i + 4 + len) : "";
    };
    var __8lpp4 = function(b, i) {
        var len = __readUInt32LE(b, i);
        return len > 0 ? __utf8(b, i + 4, i + 4 + len) : "";
    };
    var ___8lpp4 = __8lpp4;
    var __double, ___double;
    __double = ___double = function(b, idx) {
        return read_double_le(b, idx);
    };
    var is_buf = function is_buf_a(a) {
        return Array.isArray(a);
    };
    if (has_buf) {
        __utf16le = function(b, s, e) {
            if (!Buffer.isBuffer(b)) return ___utf16le(b, s, e);
            return b.toString('utf16le', s, e).replace(chr0, '') /*.replace(chr1,'!')*/ ;
        };
        __hexlify = function(b, s, l) {
            return Buffer.isBuffer(b) ? b.toString('hex', s, s + l) : ___hexlify(b, s, l);
        };
        __lpstr = function lpstr_b(b, i) {
            if (!Buffer.isBuffer(b)) return ___lpstr(b, i);
            var len = b.readUInt32LE(i);
            return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
        };
        __cpstr = function cpstr_b(b, i) {
            if (!Buffer.isBuffer(b)) return ___cpstr(b, i);
            var len = b.readUInt32LE(i);
            return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
        };
        __lpwstr = function lpwstr_b(b, i) {
            if (!Buffer.isBuffer(b)) return ___lpwstr(b, i);
            var len = 2 * b.readUInt32LE(i);
            return b.toString('utf16le', i + 4, i + 4 + len - 1);
        };
        __lpp4 = function lpp4_b(b, i) {
            if (!Buffer.isBuffer(b)) return ___lpp4(b, i);
            var len = b.readUInt32LE(i);
            return b.toString('utf16le', i + 4, i + 4 + len);
        };
        __8lpp4 = function lpp4_8b(b, i) {
            if (!Buffer.isBuffer(b)) return ___8lpp4(b, i);
            var len = b.readUInt32LE(i);
            return b.toString('utf8', i + 4, i + 4 + len);
        };
        __utf8 = function utf8_b(b, s, e) {
            return Buffer.isBuffer(b) ? b.toString('utf8', s, e) : ___utf8(b, s, e);
        };
        __toBuffer = function(bufs) {
            return bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0]) ? Buffer.concat(bufs[0]) : ___toBuffer(bufs);
        };
        bconcat = function(bufs) {
            return Buffer.isBuffer(bufs[0]) ? Buffer.concat(bufs) : [].concat.apply([], bufs);
        };
        __double = function double_(b, i) {
            if (Buffer.isBuffer(b)) return b.readDoubleLE(i);
            return ___double(b, i);
        };
        is_buf = function is_buf_b(a) {
            return Buffer.isBuffer(a) || Array.isArray(a);
        };
    }
    /* from js-xls */ if (typeof cptable !== 'undefined') {
        __utf16le = function(b, s, e) {
            return cptable.utils.decode(1200, b.slice(s, e)).replace(chr0, '');
        };
        __utf8 = function(b, s, e) {
            return cptable.utils.decode(65001, b.slice(s, e));
        };
        __lpstr = function(b, i) {
            var len = __readUInt32LE(b, i);
            return len > 0 ? cptable.utils.decode(current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
        };
        __cpstr = function(b, i) {
            var len = __readUInt32LE(b, i);
            return len > 0 ? cptable.utils.decode(current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
        };
        __lpwstr = function(b, i) {
            var len = 2 * __readUInt32LE(b, i);
            return len > 0 ? cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
        };
        __lpp4 = function(b, i) {
            var len = __readUInt32LE(b, i);
            return len > 0 ? cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
        };
        __8lpp4 = function(b, i) {
            var len = __readUInt32LE(b, i);
            return len > 0 ? cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
        };
    }
    var __readUInt8 = function(b, idx) {
        return b[idx];
    };
    var __readUInt16LE = function(b, idx) {
        return b[idx + 1] * 256 + b[idx];
    };
    var __readInt16LE = function(b, idx) {
        var u = b[idx + 1] * 256 + b[idx];
        return u < 0x8000 ? u : (0xffff - u + 1) * -1;
    };
    var __readUInt32LE = function(b, idx) {
        return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
    };
    var __readInt32LE = function(b, idx) {
        return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
    };
    var __readInt32BE = function(b, idx) {
        return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
    };
    function ReadShift(size, t) {
        var o = "", oI, oR, oo = [], w, vv, i, loc;
        switch(t){
            case 'dbcs':
                loc = this.l;
                if (has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
                else for(i = 0; i < size; ++i){
                    o += String.fromCharCode(__readUInt16LE(this, loc));
                    loc += 2;
                }
                size *= 2;
                break;
            case 'utf8':
                o = __utf8(this, this.l, this.l + size);
                break;
            case 'utf16le':
                size *= 2;
                o = __utf16le(this, this.l, this.l + size);
                break;
            case 'wstr':
                if (typeof cptable !== 'undefined') o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l + 2 * size));
                else return ReadShift.call(this, size, 'dbcs');
                size = 2 * size;
                break;
            /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case 'lpstr-ansi':
                o = __lpstr(this, this.l);
                size = 4 + __readUInt32LE(this, this.l);
                break;
            case 'lpstr-cp':
                o = __cpstr(this, this.l);
                size = 4 + __readUInt32LE(this, this.l);
                break;
            /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case 'lpwstr':
                o = __lpwstr(this, this.l);
                size = 4 + 2 * __readUInt32LE(this, this.l);
                break;
            /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case 'lpp4':
                size = 4 + __readUInt32LE(this, this.l);
                o = __lpp4(this, this.l);
                if (size & 0x02) size += 2;
                break;
            /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case '8lpp4':
                size = 4 + __readUInt32LE(this, this.l);
                o = __8lpp4(this, this.l);
                if (size & 0x03) size += 4 - (size & 0x03);
                break;
            case 'cstr':
                size = 0;
                o = "";
                while((w = __readUInt8(this, this.l + size++)) !== 0)oo.push(_getchar(w));
                o = oo.join("");
                break;
            case '_wstr':
                size = 0;
                o = "";
                while((w = __readUInt16LE(this, this.l + size)) !== 0){
                    oo.push(_getchar(w));
                    size += 2;
                }
                size += 2;
                o = oo.join("");
                break;
            /* sbcs and dbcs support continue records in the SST way TODO codepages */ case 'dbcs-cont':
                o = "";
                loc = this.l;
                for(i = 0; i < size; ++i){
                    if (this.lens && this.lens.indexOf(loc) !== -1) {
                        w = __readUInt8(this, loc);
                        this.l = loc + 1;
                        vv = ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                        return oo.join("") + vv;
                    }
                    oo.push(_getchar(__readUInt16LE(this, loc)));
                    loc += 2;
                }
                o = oo.join("");
                size *= 2;
                break;
            case 'cpstr':
                if (typeof cptable !== 'undefined') {
                    o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
                    break;
                }
            /* falls through */ case 'sbcs-cont':
                o = "";
                loc = this.l;
                for(i = 0; i != size; ++i){
                    if (this.lens && this.lens.indexOf(loc) !== -1) {
                        w = __readUInt8(this, loc);
                        this.l = loc + 1;
                        vv = ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                        return oo.join("") + vv;
                    }
                    oo.push(_getchar(__readUInt8(this, loc)));
                    loc += 1;
                }
                o = oo.join("");
                break;
            default:
                switch(size){
                    case 1:
                        oI = __readUInt8(this, this.l);
                        this.l++;
                        return oI;
                    case 2:
                        oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l);
                        this.l += 2;
                        return oI;
                    case 4:
                    case -4:
                        if (t === 'i' || (this[this.l + 3] & 0x80) === 0) {
                            oI = (size > 0 ? __readInt32LE : __readInt32BE)(this, this.l);
                            this.l += 4;
                            return oI;
                        } else {
                            oR = __readUInt32LE(this, this.l);
                            this.l += 4;
                        }
                        return oR;
                    case 8:
                    case -8:
                        if (t === 'f') {
                            if (size == 8) oR = __double(this, this.l);
                            else oR = __double([
                                this[this.l + 7],
                                this[this.l + 6],
                                this[this.l + 5],
                                this[this.l + 4],
                                this[this.l + 3],
                                this[this.l + 2],
                                this[this.l + 1],
                                this[this.l + 0]
                            ], 0);
                            this.l += 8;
                            return oR;
                        } else size = 8;
                    /* falls through */ case 16:
                        o = __hexlify(this, this.l, size);
                        break;
                }
        }
        this.l += size;
        return o;
    }
    var __writeUInt32LE = function(b, val, idx) {
        b[idx] = val & 0xFF;
        b[idx + 1] = val >>> 8 & 0xFF;
        b[idx + 2] = val >>> 16 & 0xFF;
        b[idx + 3] = val >>> 24 & 0xFF;
    };
    var __writeInt32LE = function(b, val, idx) {
        b[idx] = val & 0xFF;
        b[idx + 1] = val >> 8 & 0xFF;
        b[idx + 2] = val >> 16 & 0xFF;
        b[idx + 3] = val >> 24 & 0xFF;
    };
    var __writeUInt16LE = function(b, val, idx) {
        b[idx] = val & 0xFF;
        b[idx + 1] = val >>> 8 & 0xFF;
    };
    function WriteShift(t, val, f) {
        var size = 0, i = 0;
        if (f === 'dbcs') {
            for(i = 0; i != val.length; ++i)__writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
            size = 2 * val.length;
        } else if (f === 'sbcs') {
            if (typeof cptable !== 'undefined' && current_ansi == 874) /* TODO: use tables directly, don't encode */ for(i = 0; i != val.length; ++i){
                var cppayload = cptable.utils.encode(current_ansi, val.charAt(i));
                this[this.l + i] = cppayload[0];
            }
            else {
                val = val.replace(/[^\x00-\x7F]/g, "_");
                for(i = 0; i != val.length; ++i)this[this.l + i] = val.charCodeAt(i) & 0xFF;
            }
            size = val.length;
        } else if (f === 'hex') {
            for(; i < t; ++i)this[this.l++] = parseInt(val.slice(2 * i, 2 * i + 2), 16) || 0;
            return this;
        } else if (f === 'utf16le') {
            var end = Math.min(this.l + t, this.length);
            for(i = 0; i < Math.min(val.length, t); ++i){
                var cc = val.charCodeAt(i);
                this[this.l++] = cc & 0xff;
                this[this.l++] = cc >> 8;
            }
            while(this.l < end)this[this.l++] = 0;
            return this;
        } else switch(t){
            case 1:
                size = 1;
                this[this.l] = val & 0xFF;
                break;
            case 2:
                size = 2;
                this[this.l] = val & 0xFF;
                val >>>= 8;
                this[this.l + 1] = val & 0xFF;
                break;
            case 3:
                size = 3;
                this[this.l] = val & 0xFF;
                val >>>= 8;
                this[this.l + 1] = val & 0xFF;
                val >>>= 8;
                this[this.l + 2] = val & 0xFF;
                break;
            case 4:
                size = 4;
                __writeUInt32LE(this, val, this.l);
                break;
            case 8:
                size = 8;
                if (f === 'f') {
                    write_double_le(this, val, this.l);
                    break;
                }
            /* falls through */ case 16:
                break;
            case -4:
                size = 4;
                __writeInt32LE(this, val, this.l);
                break;
        }
        this.l += size;
        return this;
    }
    function CheckField(hexstr, fld) {
        var m = __hexlify(this, this.l, hexstr.length >> 1);
        if (m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
        this.l += hexstr.length >> 1;
    }
    function prep_blob(blob, pos) {
        blob.l = pos;
        blob.read_shift = ReadShift;
        blob.chk = CheckField;
        blob.write_shift = WriteShift;
    }
    function parsenoop(blob, length) {
        blob.l += length;
    }
    function new_buf(sz) {
        var o = new_raw_buf(sz);
        prep_blob(o, 0);
        return o;
    }
    /* [MS-XLSB] 2.1.4 Record */ function recordhopper(data, cb, opts) {
        if (!data) return;
        var tmpbyte, cntbyte, length;
        prep_blob(data, data.l || 0);
        var L = data.length, RT = 0, tgt = 0;
        while(data.l < L){
            RT = data.read_shift(1);
            if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
            var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
            tmpbyte = data.read_shift(1);
            length = tmpbyte & 0x7F;
            for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
            tgt = data.l + length;
            var d = (R.f || parsenoop)(data, length, opts);
            data.l = tgt;
            if (cb(d, R.n, RT)) return;
        }
    }
    /* control buffer usage for fixed-length buffers */ function buf_array() {
        var bufs = [], blksz = has_buf ? 256 : 2048;
        var newblk = function ba_newblk(sz) {
            var o = new_buf(sz);
            prep_blob(o, 0);
            return o;
        };
        var curbuf = newblk(blksz);
        var endbuf = function ba_endbuf() {
            if (!curbuf) return;
            if (curbuf.length > curbuf.l) {
                curbuf = curbuf.slice(0, curbuf.l);
                curbuf.l = curbuf.length;
            }
            if (curbuf.length > 0) bufs.push(curbuf);
            curbuf = null;
        };
        var next = function ba_next(sz) {
            if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
            endbuf();
            return curbuf = newblk(Math.max(sz + 1, blksz));
        };
        var end = function ba_end() {
            endbuf();
            return __toBuffer([
                bufs
            ]);
        };
        var push = function ba_push(buf) {
            endbuf();
            curbuf = buf;
            if (curbuf.l == null) curbuf.l = curbuf.length;
            next(blksz);
        };
        return {
            next: next,
            push: push,
            end: end,
            _bufs: bufs
        };
    }
    function write_record(ba, type, payload, length) {
        var t = +XLSBRE[type], l;
        if (isNaN(t)) return; // TODO: throw something here?
        if (!length) length = XLSBRecordEnum[t].p || (payload || []).length || 0;
        l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
        if (length >= 0x80) ++l;
        if (length >= 0x4000) ++l;
        if (length >= 0x200000) ++l;
        var o = ba.next(l);
        if (t <= 0x7F) o.write_shift(1, t);
        else {
            o.write_shift(1, (t & 0x7F) + 0x80);
            o.write_shift(1, t >> 7);
        }
        for(var i = 0; i != 4; ++i)if (length >= 0x80) {
            o.write_shift(1, (length & 0x7F) + 0x80);
            length >>= 7;
        } else {
            o.write_shift(1, length);
            break;
        }
        if (length > 0 && is_buf(payload)) ba.push(payload);
    }
    /* XLS ranges enforced */ function shift_cell_xls(cell, tgt, opts) {
        var out = dup(cell);
        if (tgt.s) {
            if (out.cRel) out.c += tgt.s.c;
            if (out.rRel) out.r += tgt.s.r;
        } else {
            if (out.cRel) out.c += tgt.c;
            if (out.rRel) out.r += tgt.r;
        }
        if (!opts || opts.biff < 12) {
            while(out.c >= 0x100)out.c -= 0x100;
            while(out.r >= 0x10000)out.r -= 0x10000;
        }
        return out;
    }
    function shift_range_xls(cell, range, opts) {
        var out = dup(cell);
        out.s = shift_cell_xls(out.s, range.s, opts);
        out.e = shift_cell_xls(out.e, range.s, opts);
        return out;
    }
    function encode_cell_xls(c, biff) {
        if (c.cRel && c.c < 0) {
            c = dup(c);
            while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
        }
        if (c.rRel && c.r < 0) {
            c = dup(c);
            while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
        }
        var s = encode_cell(c);
        if (!c.cRel && c.cRel != null) s = fix_col(s);
        if (!c.rRel && c.rRel != null) s = fix_row(s);
        return s;
    }
    function encode_range_xls(r, opts) {
        if (r.s.r == 0 && !r.s.rRel) {
            if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
        }
        if (r.s.c == 0 && !r.s.cRel) {
            if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
        }
        return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
    }
    var OFFCRYPTO = {};
    var make_offcrypto = function(O, _crypto) {
        var crypto1;
        if (typeof _crypto !== 'undefined') crypto1 = _crypto;
        else try {
            crypto1 = require("7da297ca2e6a8125");
        } catch (e) {
            crypto1 = null;
        }
        O.rc4 = function(key, data) {
            var S = new Array(256);
            var c = 0, i = 0, j = 0, t = 0;
            for(i = 0; i != 256; ++i)S[i] = i;
            for(i = 0; i != 256; ++i){
                j = j + S[i] + key[i % key.length].charCodeAt(0) & 255;
                t = S[i];
                S[i] = S[j];
                S[j] = t;
            }
            // $FlowIgnore
            i = j = 0;
            var out = new_raw_buf(data.length);
            for(c = 0; c != data.length; ++c){
                i = i + 1 & 255;
                j = (j + S[i]) % 256;
                t = S[i];
                S[i] = S[j];
                S[j] = t;
                out[c] = data[c] ^ S[S[i] + S[j] & 255];
            }
            return out;
        };
        O.md5 = function(hex) {
            if (!crypto1) throw new Error("Unsupported crypto");
            return crypto1.createHash('md5').update(hex).digest('hex');
        };
    };
    /*global crypto:true */ make_offcrypto(OFFCRYPTO, typeof crypto !== "undefined" ? crypto : undefined);
    function decode_row(rowstr) {
        return parseInt(unfix_row(rowstr), 10) - 1;
    }
    function encode_row(row) {
        return "" + (row + 1);
    }
    function fix_row(cstr) {
        return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
    }
    function unfix_row(cstr) {
        return cstr.replace(/\$(\d+)$/, "$1");
    }
    function decode_col(colstr) {
        var c = unfix_col(colstr), d = 0, i = 0;
        for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
        return d - 1;
    }
    function encode_col(col) {
        if (col < 0) throw new Error("invalid column " + col);
        var s = "";
        for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
        return s;
    }
    function fix_col(cstr) {
        return cstr.replace(/^([A-Z])/, "$$$1");
    }
    function unfix_col(cstr) {
        return cstr.replace(/^\$([A-Z])/, "$1");
    }
    function split_cell(cstr) {
        return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
    }
    //function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
    function decode_cell(cstr) {
        var R = 0, C = 0;
        for(var i = 0; i < cstr.length; ++i){
            var cc = cstr.charCodeAt(i);
            if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
            else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
        }
        return {
            c: C - 1,
            r: R - 1
        };
    }
    //function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
    function encode_cell(cell) {
        var col = cell.c + 1;
        var s = "";
        for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
        return s + (cell.r + 1);
    }
    function decode_range(range) {
        var idx = range.indexOf(":");
        if (idx == -1) return {
            s: decode_cell(range),
            e: decode_cell(range)
        };
        return {
            s: decode_cell(range.slice(0, idx)),
            e: decode_cell(range.slice(idx + 1))
        };
    }
    function encode_range(cs, ce) {
        if (typeof ce === 'undefined' || typeof ce === 'number') return encode_range(cs.s, cs.e);
        if (typeof cs !== 'string') cs = encode_cell(cs);
        if (typeof ce !== 'string') ce = encode_cell(ce);
        return cs == ce ? cs : cs + ":" + ce;
    }
    function safe_decode_range(range) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        var idx = 0, i = 0, cc = 0;
        var len = range.length;
        for(idx = 0; i < len; ++i){
            if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
            idx = 26 * idx + cc;
        }
        o.s.c = --idx;
        for(idx = 0; i < len; ++i){
            if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
            idx = 10 * idx + cc;
        }
        o.s.r = --idx;
        if (i === len || range.charCodeAt(++i) === 58) {
            o.e.c = o.s.c;
            o.e.r = o.s.r;
            return o;
        }
        for(idx = 0; i != len; ++i){
            if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
            idx = 26 * idx + cc;
        }
        o.e.c = --idx;
        for(idx = 0; i != len; ++i){
            if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
            idx = 10 * idx + cc;
        }
        o.e.r = --idx;
        return o;
    }
    function safe_format_cell(cell, v) {
        var q = cell.t == 'd' && v instanceof Date;
        if (cell.z != null) try {
            return cell.w = SSF.format(cell.z, q ? datenum(v) : v);
        } catch (e) {}
        try {
            return cell.w = SSF.format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? datenum(v) : v);
        } catch (e) {
            return '' + v;
        }
    }
    function format_cell(cell, v, o) {
        if (cell == null || cell.t == null || cell.t == 'z') return "";
        if (cell.w !== undefined) return cell.w;
        if (cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
        if (v == undefined) return safe_format_cell(cell, cell.v);
        return safe_format_cell(cell, v);
    }
    function sheet_to_workbook(sheet, opts) {
        var n = opts && opts.sheet ? opts.sheet : "Sheet1";
        var sheets = {};
        sheets[n] = sheet;
        return {
            SheetNames: [
                n
            ],
            Sheets: sheets
        };
    }
    function sheet_add_aoa(_ws, data, opts) {
        var o = opts || {};
        var dense = _ws ? Array.isArray(_ws) : o.dense;
        if (DENSE != null && dense == null) dense = DENSE;
        var ws = _ws || (dense ? [] : {});
        var _R = 0, _C = 0;
        if (ws && o.origin != null) {
            if (typeof o.origin == 'number') _R = o.origin;
            else {
                var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
                _R = _origin.r;
                _C = _origin.c;
            }
            if (!ws["!ref"]) ws["!ref"] = "A1:A1";
        }
        var range = {
            s: {
                c: 10000000,
                r: 10000000
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (ws['!ref']) {
            var _range = safe_decode_range(ws['!ref']);
            range.s.c = _range.s.c;
            range.s.r = _range.s.r;
            range.e.c = Math.max(range.e.c, _range.e.c);
            range.e.r = Math.max(range.e.r, _range.e.r);
            if (_R == -1) range.e.r = _R = _range.e.r + 1;
        }
        for(var R = 0; R != data.length; ++R){
            if (!data[R]) continue;
            if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
            for(var C = 0; C != data[R].length; ++C){
                if (typeof data[R][C] === 'undefined') continue;
                var cell = {
                    v: data[R][C]
                };
                var __R = _R + R, __C = _C + C;
                if (range.s.r > __R) range.s.r = __R;
                if (range.s.c > __C) range.s.c = __C;
                if (range.e.r < __R) range.e.r = __R;
                if (range.e.c < __C) range.e.c = __C;
                if (data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
                else {
                    if (Array.isArray(cell.v)) {
                        cell.f = data[R][C][1];
                        cell.v = cell.v[0];
                    }
                    if (cell.v === null) {
                        if (cell.f) cell.t = 'n';
                        else if (!o.sheetStubs) continue;
                        else cell.t = 'z';
                    } else if (typeof cell.v === 'number') cell.t = 'n';
                    else if (typeof cell.v === 'boolean') cell.t = 'b';
                    else if (cell.v instanceof Date) {
                        cell.z = o.dateNF || SSF._table[14];
                        if (o.cellDates) {
                            cell.t = 'd';
                            cell.w = SSF.format(cell.z, datenum(cell.v));
                        } else {
                            cell.t = 'n';
                            cell.v = datenum(cell.v);
                            cell.w = SSF.format(cell.z, cell.v);
                        }
                    } else cell.t = 's';
                }
                if (dense) {
                    if (!ws[__R]) ws[__R] = [];
                    if (ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
                    ws[__R][__C] = cell;
                } else {
                    var cell_ref = encode_cell({
                        c: __C,
                        r: __R
                    });
                    if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                    ws[cell_ref] = cell;
                }
            }
        }
        if (range.s.c < 10000000) ws['!ref'] = encode_range(range);
        return ws;
    }
    function aoa_to_sheet(data, opts) {
        return sheet_add_aoa(null, data, opts);
    }
    function write_UInt32LE(x, o) {
        if (!o) o = new_buf(4);
        o.write_shift(4, x);
        return o;
    }
    /* [MS-XLSB] 2.5.168 */ function parse_XLWideString(data) {
        var cchCharacters = data.read_shift(4);
        return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
    }
    function write_XLWideString(data, o) {
        var _null = false;
        if (o == null) {
            _null = true;
            o = new_buf(4 + 2 * data.length);
        }
        o.write_shift(4, data.length);
        if (data.length > 0) o.write_shift(0, data, 'dbcs');
        return _null ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data) {
    //	var cchCharacters = data.read_shift(2);
    //	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
    //}
    /* [MS-XLSB] 2.5.143 */ function parse_StrRun(data) {
        return {
            ich: data.read_shift(2),
            ifnt: data.read_shift(2)
        };
    }
    function write_StrRun(run, o) {
        if (!o) o = new_buf(4);
        o.write_shift(2, run.ich || 0);
        o.write_shift(2, run.ifnt || 0);
        return o;
    }
    /* [MS-XLSB] 2.5.121 */ function parse_RichStr(data, length) {
        var start = data.l;
        var flags = data.read_shift(1);
        var str = parse_XLWideString(data);
        var rgsStrRun = [];
        var z = {
            t: str,
            h: str
        };
        if ((flags & 1) !== 0) {
            /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
            for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push(parse_StrRun(data));
            z.r = rgsStrRun;
        } else z.r = [
            {
                ich: 0,
                ifnt: 0
            }
        ];
        //if((flags & 2) !== 0) { /* fExtStr */
        //	/* TODO: phonetic string */
        //}
        data.l = start + length;
        return z;
    }
    function write_RichStr(str, o) {
        /* TODO: formatted string */ var _null = false;
        if (o == null) {
            _null = true;
            o = new_buf(15 + 4 * str.t.length);
        }
        o.write_shift(1, 0);
        write_XLWideString(str.t, o);
        return _null ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var parse_BrtCommentText = parse_RichStr;
    function write_BrtCommentText(str, o) {
        /* TODO: formatted string */ var _null = false;
        if (o == null) {
            _null = true;
            o = new_buf(23 + 4 * str.t.length);
        }
        o.write_shift(1, 1);
        write_XLWideString(str.t, o);
        o.write_shift(4, 1);
        write_StrRun({
            ich: 0,
            ifnt: 0
        }, o);
        return _null ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.5.9 */ function parse_XLSBCell(data) {
        var col = data.read_shift(4);
        var iStyleRef = data.read_shift(2);
        iStyleRef += data.read_shift(1) << 16;
        data.l++; //var fPhShow = data.read_shift(1);
        return {
            c: col,
            iStyleRef: iStyleRef
        };
    }
    function write_XLSBCell(cell, o) {
        if (o == null) o = new_buf(8);
        o.write_shift(-4, cell.c);
        o.write_shift(3, cell.iStyleRef || cell.s);
        o.write_shift(1, 0); /* fPhShow */ 
        return o;
    }
    /* [MS-XLSB] 2.5.21 */ var parse_XLSBCodeName = parse_XLWideString;
    var write_XLSBCodeName = write_XLWideString;
    /* [MS-XLSB] 2.5.166 */ function parse_XLNullableWideString(data) {
        var cchCharacters = data.read_shift(4);
        return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
    }
    function write_XLNullableWideString(data, o) {
        var _null = false;
        if (o == null) {
            _null = true;
            o = new_buf(127);
        }
        o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
        if (data.length > 0) o.write_shift(0, data, 'dbcs');
        return _null ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.5.165 */ var parse_XLNameWideString = parse_XLWideString;
    //var write_XLNameWideString = write_XLWideString;
    /* [MS-XLSB] 2.5.114 */ var parse_RelID = parse_XLNullableWideString;
    var write_RelID = write_XLNullableWideString;
    /* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function parse_RkNumber(data) {
        var b = data.slice(data.l, data.l + 4);
        var fX100 = b[0] & 1, fInt = b[0] & 2;
        data.l += 4;
        b[0] &= 0xFC; // b[0] &= ~3;
        var RK = fInt === 0 ? __double([
            0,
            0,
            0,
            0,
            b[0],
            b[1],
            b[2],
            b[3]
        ], 0) : __readInt32LE(b, 0) >> 2;
        return fX100 ? RK / 100 : RK;
    }
    function write_RkNumber(data, o) {
        if (o == null) o = new_buf(4);
        var fX100 = 0, fInt = 0, d100 = data * 100;
        if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
        else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
            fInt = 1;
            fX100 = 1;
        }
        if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
        else throw new Error("unsupported RkNumber " + data); // TODO
    }
    /* [MS-XLSB] 2.5.117 RfX */ function parse_RfX(data) {
        var cell = {
            s: {},
            e: {}
        };
        cell.s.r = data.read_shift(4);
        cell.e.r = data.read_shift(4);
        cell.s.c = data.read_shift(4);
        cell.e.c = data.read_shift(4);
        return cell;
    }
    function write_RfX(r, o) {
        if (!o) o = new_buf(16);
        o.write_shift(4, r.s.r);
        o.write_shift(4, r.e.r);
        o.write_shift(4, r.s.c);
        o.write_shift(4, r.e.c);
        return o;
    }
    /* [MS-XLSB] 2.5.153 UncheckedRfX */ var parse_UncheckedRfX = parse_RfX;
    var write_UncheckedRfX = write_RfX;
    /* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
    //	var cnt = data.read_shift(4);
    //	var out = [];
    //	for(var i = 0; i < cnt; ++i) {
    //		var rng = parse_UncheckedRfX(data);
    //		out.push(encode_range(rng));
    //	}
    //	return out.join(",");
    //}
    //function write_UncheckedSqRfX(sqrfx) {
    //	var parts = sqrfx.split(/\s*,\s*/);
    //	var o = new_buf(4); o.write_shift(4, parts.length);
    //	var out = [o];
    //	parts.forEach(function(rng) {
    //		out.push(write_UncheckedRfX(safe_decode_range(rng)));
    //	});
    //	return bconcat(out);
    //}
    /* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function parse_Xnum(data) {
        return data.read_shift(8, 'f');
    }
    function write_Xnum(data, o) {
        return (o || new_buf(8)).write_shift(8, data, 'f');
    }
    /* [MS-XLSB] 2.4.324 BrtColor */ function parse_BrtColor(data) {
        var out = {};
        var d = data.read_shift(1);
        //var fValidRGB = d & 1;
        var xColorType = d >>> 1;
        var index = data.read_shift(1);
        var nTS = data.read_shift(2, 'i');
        var bR = data.read_shift(1);
        var bG = data.read_shift(1);
        var bB = data.read_shift(1);
        data.l++; //var bAlpha = data.read_shift(1);
        switch(xColorType){
            case 0:
                out.auto = 1;
                break;
            case 1:
                out.index = index;
                var icv = XLSIcv[index];
                /* automatic pseudo index 81 */ if (icv) out.rgb = rgb2Hex(icv);
                break;
            case 2:
                /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = rgb2Hex([
                    bR,
                    bG,
                    bB
                ]);
                break;
            case 3:
                out.theme = index;
                break;
        }
        if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
        return out;
    }
    function write_BrtColor(color, o) {
        if (!o) o = new_buf(8);
        if (!color || color.auto) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            return o;
        }
        if (color.index != null) {
            o.write_shift(1, 0x02);
            o.write_shift(1, color.index);
        } else if (color.theme != null) {
            o.write_shift(1, 0x06);
            o.write_shift(1, color.theme);
        } else {
            o.write_shift(1, 0x05);
            o.write_shift(1, 0);
        }
        var nTS = color.tint || 0;
        if (nTS > 0) nTS *= 32767;
        else if (nTS < 0) nTS *= 32768;
        o.write_shift(2, nTS);
        if (!color.rgb || color.theme != null) {
            o.write_shift(2, 0);
            o.write_shift(1, 0);
            o.write_shift(1, 0);
        } else {
            var rgb = color.rgb || 'FFFFFF';
            if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
            o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
            o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
            o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
            o.write_shift(1, 0xFF);
        }
        return o;
    }
    /* [MS-XLSB] 2.5.52 */ function parse_FontFlags(data) {
        var d = data.read_shift(1);
        data.l++;
        var out = {
            fBold: d & 0x01,
            fItalic: d & 0x02,
            fUnderline: d & 0x04,
            fStrikeout: d & 0x08,
            fOutline: d & 0x10,
            fShadow: d & 0x20,
            fCondense: d & 0x40,
            fExtend: d & 0x80
        };
        return out;
    }
    function write_FontFlags(font, o) {
        if (!o) o = new_buf(2);
        var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
        o.write_shift(1, grbit);
        o.write_shift(1, 0);
        return o;
    }
    /* [MS-OLEDS] 2.3.1 and 2.3.2 */ function parse_ClipboardFormatOrString(o, w) {
        // $FlowIgnore
        var ClipFmt = {
            2: "BITMAP",
            3: "METAFILEPICT",
            8: "DIB",
            14: "ENHMETAFILE"
        };
        var m = o.read_shift(4);
        switch(m){
            case 0x00000000:
                return "";
            case 0xffffffff:
            case 0xfffffffe:
                return ClipFmt[o.read_shift(4)] || "";
        }
        if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
        o.l -= 4;
        return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
    }
    function parse_ClipboardFormatOrAnsiString(o) {
        return parse_ClipboardFormatOrString(o, 1);
    }
    function parse_ClipboardFormatOrUnicodeString(o) {
        return parse_ClipboardFormatOrString(o, 2);
    }
    /* [MS-OLEPS] 2.2 PropertyType */ //var VT_EMPTY    = 0x0000;
    //var VT_NULL     = 0x0001;
    var VT_I2 = 0x0002;
    var VT_I4 = 0x0003;
    //var VT_R4       = 0x0004;
    //var VT_R8       = 0x0005;
    //var VT_CY       = 0x0006;
    //var VT_DATE     = 0x0007;
    //var VT_BSTR     = 0x0008;
    //var VT_ERROR    = 0x000A;
    var VT_BOOL = 0x000B;
    var VT_VARIANT = 0x000C;
    //var VT_DECIMAL  = 0x000E;
    //var VT_I1       = 0x0010;
    //var VT_UI1      = 0x0011;
    //var VT_UI2      = 0x0012;
    var VT_UI4 = 0x0013;
    //var VT_I8       = 0x0014;
    //var VT_UI8      = 0x0015;
    //var VT_INT      = 0x0016;
    //var VT_UINT     = 0x0017;
    var VT_LPSTR = 0x001E;
    //var VT_LPWSTR   = 0x001F;
    var VT_FILETIME = 0x0040;
    var VT_BLOB = 0x0041;
    //var VT_STREAM   = 0x0042;
    //var VT_STORAGE  = 0x0043;
    //var VT_STREAMED_Object  = 0x0044;
    //var VT_STORED_Object    = 0x0045;
    //var VT_BLOB_Object      = 0x0046;
    var VT_CF = 0x0047;
    //var VT_CLSID    = 0x0048;
    //var VT_VERSIONED_STREAM = 0x0049;
    var VT_VECTOR = 0x1000;
    //var VT_ARRAY    = 0x2000;
    var VT_STRING = 0x0050; // 2.3.3.1.11 VtString
    var VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
    var VT_CUSTOM = [
        VT_STRING,
        VT_USTR
    ];
    /* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var DocSummaryPIDDSI = {
        0x01: {
            n: 'CodePage',
            t: VT_I2
        },
        0x02: {
            n: 'Category',
            t: VT_STRING
        },
        0x03: {
            n: 'PresentationFormat',
            t: VT_STRING
        },
        0x04: {
            n: 'ByteCount',
            t: VT_I4
        },
        0x05: {
            n: 'LineCount',
            t: VT_I4
        },
        0x06: {
            n: 'ParagraphCount',
            t: VT_I4
        },
        0x07: {
            n: 'SlideCount',
            t: VT_I4
        },
        0x08: {
            n: 'NoteCount',
            t: VT_I4
        },
        0x09: {
            n: 'HiddenCount',
            t: VT_I4
        },
        0x0a: {
            n: 'MultimediaClipCount',
            t: VT_I4
        },
        0x0b: {
            n: 'ScaleCrop',
            t: VT_BOOL
        },
        0x0c: {
            n: 'HeadingPairs',
            t: VT_VECTOR | VT_VARIANT
        },
        0x0d: {
            n: 'TitlesOfParts',
            t: VT_VECTOR | VT_LPSTR
        },
        0x0e: {
            n: 'Manager',
            t: VT_STRING
        },
        0x0f: {
            n: 'Company',
            t: VT_STRING
        },
        0x10: {
            n: 'LinksUpToDate',
            t: VT_BOOL
        },
        0x11: {
            n: 'CharacterCount',
            t: VT_I4
        },
        0x13: {
            n: 'SharedDoc',
            t: VT_BOOL
        },
        0x16: {
            n: 'HyperlinksChanged',
            t: VT_BOOL
        },
        0x17: {
            n: 'AppVersion',
            t: VT_I4,
            p: 'version'
        },
        0x18: {
            n: 'DigSig',
            t: VT_BLOB
        },
        0x1A: {
            n: 'ContentType',
            t: VT_STRING
        },
        0x1B: {
            n: 'ContentStatus',
            t: VT_STRING
        },
        0x1C: {
            n: 'Language',
            t: VT_STRING
        },
        0x1D: {
            n: 'Version',
            t: VT_STRING
        },
        0xFF: {}
    };
    /* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var SummaryPIDSI = {
        0x01: {
            n: 'CodePage',
            t: VT_I2
        },
        0x02: {
            n: 'Title',
            t: VT_STRING
        },
        0x03: {
            n: 'Subject',
            t: VT_STRING
        },
        0x04: {
            n: 'Author',
            t: VT_STRING
        },
        0x05: {
            n: 'Keywords',
            t: VT_STRING
        },
        0x06: {
            n: 'Comments',
            t: VT_STRING
        },
        0x07: {
            n: 'Template',
            t: VT_STRING
        },
        0x08: {
            n: 'LastAuthor',
            t: VT_STRING
        },
        0x09: {
            n: 'RevNumber',
            t: VT_STRING
        },
        0x0A: {
            n: 'EditTime',
            t: VT_FILETIME
        },
        0x0B: {
            n: 'LastPrinted',
            t: VT_FILETIME
        },
        0x0C: {
            n: 'CreatedDate',
            t: VT_FILETIME
        },
        0x0D: {
            n: 'ModifiedDate',
            t: VT_FILETIME
        },
        0x0E: {
            n: 'PageCount',
            t: VT_I4
        },
        0x0F: {
            n: 'WordCount',
            t: VT_I4
        },
        0x10: {
            n: 'CharCount',
            t: VT_I4
        },
        0x11: {
            n: 'Thumbnail',
            t: VT_CF
        },
        0x12: {
            n: 'Application',
            t: VT_STRING
        },
        0x13: {
            n: 'DocSecurity',
            t: VT_I4
        },
        0xFF: {}
    };
    /* [MS-OLEPS] 2.18 */ var SpecialProperties = {
        0x80000000: {
            n: 'Locale',
            t: VT_UI4
        },
        0x80000003: {
            n: 'Behavior',
            t: VT_UI4
        },
        0x72627262: {}
    };
    (function() {
        for(var y in SpecialProperties)if (Object.prototype.hasOwnProperty.call(SpecialProperties, y)) DocSummaryPIDDSI[y] = SummaryPIDSI[y] = SpecialProperties[y];
    })();
    var DocSummaryRE = evert_key(DocSummaryPIDDSI, "n");
    var SummaryRE = evert_key(SummaryPIDSI, "n");
    /* [MS-XLS] 2.4.63 Country/Region codes */ var CountryEnum = {
        0x0001: "US",
        0x0002: "CA",
        0x0003: "",
        0x0007: "RU",
        0x0014: "EG",
        0x001E: "GR",
        0x001F: "NL",
        0x0020: "BE",
        0x0021: "FR",
        0x0022: "ES",
        0x0024: "HU",
        0x0027: "IT",
        0x0029: "CH",
        0x002B: "AT",
        0x002C: "GB",
        0x002D: "DK",
        0x002E: "SE",
        0x002F: "NO",
        0x0030: "PL",
        0x0031: "DE",
        0x0034: "MX",
        0x0037: "BR",
        0x003d: "AU",
        0x0040: "NZ",
        0x0042: "TH",
        0x0051: "JP",
        0x0052: "KR",
        0x0054: "VN",
        0x0056: "CN",
        0x005A: "TR",
        0x0069: "JS",
        0x00D5: "DZ",
        0x00D8: "MA",
        0x00DA: "LY",
        0x015F: "PT",
        0x0162: "IS",
        0x0166: "FI",
        0x01A4: "CZ",
        0x0376: "TW",
        0x03C1: "LB",
        0x03C2: "JO",
        0x03C3: "SY",
        0x03C4: "IQ",
        0x03C5: "KW",
        0x03C6: "SA",
        0x03CB: "AE",
        0x03CC: "IL",
        0x03CE: "QA",
        0x03D5: "IR",
        0xFFFF: "US" // United States
    };
    /* [MS-XLS] 2.5.127 */ var XLSFillPattern = [
        null,
        'solid',
        'mediumGray',
        'darkGray',
        'lightGray',
        'darkHorizontal',
        'darkVertical',
        'darkDown',
        'darkUp',
        'darkGrid',
        'darkTrellis',
        'lightHorizontal',
        'lightVertical',
        'lightDown',
        'lightUp',
        'lightGrid',
        'lightTrellis',
        'gray125',
        'gray0625'
    ];
    function rgbify(arr) {
        return arr.map(function(x) {
            return [
                x >> 16 & 255,
                x >> 8 & 255,
                x & 255
            ];
        });
    }
    /* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var _XLSIcv = rgbify([
        /* Color Constants */ 0x000000,
        0xFFFFFF,
        0xFF0000,
        0x00FF00,
        0x0000FF,
        0xFFFF00,
        0xFF00FF,
        0x00FFFF,
        /* Overridable Defaults */ 0x000000,
        0xFFFFFF,
        0xFF0000,
        0x00FF00,
        0x0000FF,
        0xFFFF00,
        0xFF00FF,
        0x00FFFF,
        0x800000,
        0x008000,
        0x000080,
        0x808000,
        0x800080,
        0x008080,
        0xC0C0C0,
        0x808080,
        0x9999FF,
        0x993366,
        0xFFFFCC,
        0xCCFFFF,
        0x660066,
        0xFF8080,
        0x0066CC,
        0xCCCCFF,
        0x000080,
        0xFF00FF,
        0xFFFF00,
        0x00FFFF,
        0x800080,
        0x800000,
        0x008080,
        0x0000FF,
        0x00CCFF,
        0xCCFFFF,
        0xCCFFCC,
        0xFFFF99,
        0x99CCFF,
        0xFF99CC,
        0xCC99FF,
        0xFFCC99,
        0x3366FF,
        0x33CCCC,
        0x99CC00,
        0xFFCC00,
        0xFF9900,
        0xFF6600,
        0x666699,
        0x969696,
        0x003366,
        0x339966,
        0x003300,
        0x333300,
        0x993300,
        0x993366,
        0x333399,
        0x333333,
        /* Other entries to appease BIFF8/12 */ 0xFFFFFF,
        /* 0x40 icvForeground ?? */ 0x000000,
        /* 0x41 icvBackground ?? */ 0x000000,
        /* 0x42 icvFrame ?? */ 0x000000,
        /* 0x43 icv3D ?? */ 0x000000,
        /* 0x44 icv3DText ?? */ 0x000000,
        /* 0x45 icv3DHilite ?? */ 0x000000,
        /* 0x46 icv3DShadow ?? */ 0x000000,
        /* 0x47 icvHilite ?? */ 0x000000,
        /* 0x48 icvCtlText ?? */ 0x000000,
        /* 0x49 icvCtlScrl ?? */ 0x000000,
        /* 0x4A icvCtlInv ?? */ 0x000000,
        /* 0x4B icvCtlBody ?? */ 0x000000,
        /* 0x4C icvCtlFrame ?? */ 0x000000,
        /* 0x4D icvCtlFore ?? */ 0x000000,
        /* 0x4E icvCtlBack ?? */ 0x000000,
        /* 0x4F icvCtlNeutral */ 0x000000,
        /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
    ]);
    var XLSIcv = dup(_XLSIcv);
    /* [MS-XLSB] 2.5.97.2 */ var BErr = {
        0x00: "#NULL!",
        0x07: "#DIV/0!",
        0x0F: "#VALUE!",
        0x17: "#REF!",
        0x1D: "#NAME?",
        0x24: "#NUM!",
        0x2A: "#N/A",
        0x2B: "#GETTING_DATA",
        0xFF: "#WTF?"
    };
    var RBErr = evert_num(BErr);
    /* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var ct2type /*{[string]:string}*/  = {
        /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
        /* Worksheet */ "application/vnd.ms-excel.binIndexWs": "TODO",
        /* Binary Index */ /* Macrosheet */ "application/vnd.ms-excel.intlmacrosheet": "TODO",
        "application/vnd.ms-excel.binIndexMs": "TODO",
        /* Binary Index */ /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
        "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
        "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
        /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
        /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
        /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
        /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
        /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
        /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
        /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
        /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
        /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
        "application/vnd.ms-office.activeX+xml": "TODO",
        /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
        /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
        /* External Links */ "application/vnd.ms-excel.externalLink": "links",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
        /* Metadata */ "application/vnd.ms-excel.sheetMetadata": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "TODO",
        /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
        "application/vnd.ms-excel.pivotCacheRecords": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
        /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
        /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
        "application/vnd.ms-excel.revisionHeaders": "TODO",
        "application/vnd.ms-excel.revisionLog": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
        /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
        /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
        "application/vnd.ms-excel.slicerCache": "TODO",
        "application/vnd.ms-excel.slicer+xml": "TODO",
        "application/vnd.ms-excel.slicerCache+xml": "TODO",
        /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
        /* Table */ "application/vnd.ms-excel.table": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
        /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
        /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
        /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
        /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
        /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
        "application/vnd.ms-office.vbaProjectSignature": "vba",
        /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
        /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
        /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
        /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
        /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
        "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
        /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
        "application/vnd.openxmlformats-package.relationships+xml": "rels",
        "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
        /* Image */ "image/png": "TODO",
        "sheet": "js"
    };
    var CT_LIST = function() {
        var o = {
            workbooks: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
                xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
                xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
                xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
                xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
            },
            strs: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
                xlsb: "application/vnd.ms-excel.sharedStrings"
            },
            comments: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
                xlsb: "application/vnd.ms-excel.comments"
            },
            sheets: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
                xlsb: "application/vnd.ms-excel.worksheet"
            },
            charts: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
                xlsb: "application/vnd.ms-excel.chartsheet"
            },
            dialogs: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
                xlsb: "application/vnd.ms-excel.dialogsheet"
            },
            macros: {
                xlsx: "application/vnd.ms-excel.macrosheet+xml",
                xlsb: "application/vnd.ms-excel.macrosheet"
            },
            styles: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
                xlsb: "application/vnd.ms-excel.styles"
            }
        };
        keys(o).forEach(function(k) {
            [
                "xlsm",
                "xlam"
            ].forEach(function(v) {
                if (!o[k][v]) o[k][v] = o[k].xlsx;
            });
        });
        keys(o).forEach(function(k) {
            keys(o[k]).forEach(function(v) {
                ct2type[o[k][v]] = k;
            });
        });
        return o;
    }();
    var type2ct /*{[string]:Array<string>}*/  = evert_arr(ct2type);
    XMLNS.CT = 'http://schemas.openxmlformats.org/package/2006/content-types';
    function new_ct() {
        return {
            workbooks: [],
            sheets: [],
            charts: [],
            dialogs: [],
            macros: [],
            rels: [],
            strs: [],
            comments: [],
            links: [],
            coreprops: [],
            extprops: [],
            custprops: [],
            themes: [],
            styles: [],
            calcchains: [],
            vba: [],
            drawings: [],
            TODO: [],
            xmlns: ""
        };
    }
    function parse_ct(data) {
        var ct = new_ct();
        if (!data || !data.match) return ct;
        var ctext = {};
        (data.match(tagregex) || []).forEach(function(x) {
            var y = parsexmltag(x);
            switch(y[0].replace(nsregex, "<")){
                case '<?xml':
                    break;
                case '<Types':
                    ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/) || [
                        "",
                        ""
                    ])[1]];
                    break;
                case '<Default':
                    ctext[y.Extension] = y.ContentType;
                    break;
                case '<Override':
                    if (ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
                    break;
            }
        });
        if (ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
        ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
        ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
        ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
        ct.defaults = ctext;
        delete ct.calcchains;
        return ct;
    }
    var CTYPE_XML_ROOT = writextag('Types', null, {
        'xmlns': XMLNS.CT,
        'xmlns:xsd': XMLNS.xsd,
        'xmlns:xsi': XMLNS.xsi
    });
    var CTYPE_DEFAULTS = [
        [
            'xml',
            'application/xml'
        ],
        [
            'bin',
            'application/vnd.ms-excel.sheet.binary.macroEnabled.main'
        ],
        [
            'vml',
            'application/vnd.openxmlformats-officedocument.vmlDrawing'
        ],
        [
            'data',
            'application/vnd.openxmlformats-officedocument.model+data'
        ],
        /* from test files */ [
            'bmp',
            'image/bmp'
        ],
        [
            'png',
            'image/png'
        ],
        [
            'gif',
            'image/gif'
        ],
        [
            'emf',
            'image/x-emf'
        ],
        [
            'wmf',
            'image/x-wmf'
        ],
        [
            'jpg',
            'image/jpeg'
        ],
        [
            'jpeg',
            'image/jpeg'
        ],
        [
            'tif',
            'image/tiff'
        ],
        [
            'tiff',
            'image/tiff'
        ],
        [
            'pdf',
            'application/pdf'
        ],
        [
            'rels',
            type2ct.rels[0]
        ]
    ].map(function(x) {
        return writextag('Default', null, {
            'Extension': x[0],
            'ContentType': x[1]
        });
    });
    function write_ct(ct, opts) {
        var o = [], v;
        o[o.length] = XML_HEADER;
        o[o.length] = CTYPE_XML_ROOT;
        o = o.concat(CTYPE_DEFAULTS);
        /* only write first instance */ var f1 = function(w) {
            if (ct[w] && ct[w].length > 0) {
                v = ct[w][0];
                o[o.length] = writextag('Override', null, {
                    'PartName': (v[0] == '/' ? "" : "/") + v,
                    'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
                });
            }
        };
        /* book type-specific */ var f2 = function(w) {
            (ct[w] || []).forEach(function(v) {
                o[o.length] = writextag('Override', null, {
                    'PartName': (v[0] == '/' ? "" : "/") + v,
                    'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
                });
            });
        };
        /* standard type */ var f3 = function(t) {
            (ct[t] || []).forEach(function(v) {
                o[o.length] = writextag('Override', null, {
                    'PartName': (v[0] == '/' ? "" : "/") + v,
                    'ContentType': type2ct[t][0]
                });
            });
        };
        f1('workbooks');
        f2('sheets');
        f2('charts');
        f3('themes');
        [
            'strs',
            'styles'
        ].forEach(f1);
        [
            'coreprops',
            'extprops',
            'custprops'
        ].forEach(f3);
        f3('vba');
        f3('comments');
        f3('drawings');
        if (o.length > 2) {
            o[o.length] = '</Types>';
            o[1] = o[1].replace("/>", ">");
        }
        return o.join("");
    }
    /* 9.3 Relationships */ var RELS = {
        WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
        SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
        HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
        VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
        XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
        XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
        XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
        CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
        CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
        VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
    };
    /* 9.3.3 Representing Relationships */ function get_rels_path(file) {
        var n = file.lastIndexOf("/");
        return file.slice(0, n + 1) + '_rels/' + file.slice(n + 1) + ".rels";
    }
    function parse_rels(data, currentFilePath) {
        var rels = {
            "!id": {}
        };
        if (!data) return rels;
        if (currentFilePath.charAt(0) !== '/') currentFilePath = '/' + currentFilePath;
        var hash = {};
        (data.match(tagregex) || []).forEach(function(x) {
            var y = parsexmltag(x);
            /* 9.3.2.2 OPC_Relationships */ if (y[0] === '<Relationship') {
                var rel = {};
                rel.Type = y.Type;
                rel.Target = y.Target;
                rel.Id = y.Id;
                rel.TargetMode = y.TargetMode;
                var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
                rels[canonictarget] = rel;
                hash[y.Id] = rel;
            }
        });
        rels["!id"] = hash;
        return rels;
    }
    XMLNS.RELS = 'http://schemas.openxmlformats.org/package/2006/relationships';
    var RELS_ROOT = writextag('Relationships', null, {
        //'xmlns:ns0': XMLNS.RELS,
        'xmlns': XMLNS.RELS
    });
    /* TODO */ function write_rels(rels) {
        var o = [
            XML_HEADER,
            RELS_ROOT
        ];
        keys(rels['!id']).forEach(function(rid) {
            o[o.length] = writextag('Relationship', null, rels['!id'][rid]);
        });
        if (o.length > 2) {
            o[o.length] = '</Relationships>';
            o[1] = o[1].replace("/>", ">");
        }
        return o.join("");
    }
    var RELS_EXTERN = [
        RELS.HLINK,
        RELS.XPATH,
        RELS.XMISS
    ];
    function add_rels(rels, rId, f, type, relobj, targetmode) {
        if (!relobj) relobj = {};
        if (!rels['!id']) rels['!id'] = {};
        if (rId < 0) for(rId = 1; rels['!id']['rId' + rId]; ++rId);
        relobj.Id = 'rId' + rId;
        relobj.Type = type;
        relobj.Target = f;
        if (targetmode) relobj.TargetMode = targetmode;
        else if (RELS_EXTERN.indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
        if (rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
        rels['!id'][relobj.Id] = relobj;
        rels[('/' + relobj.Target).replace("//", "/")] = relobj;
        return rId;
    }
    /* Open Document Format for Office Applications (OpenDocument) Version 1.2 */ /* Part 3 Section 4 Manifest File */ var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
    function parse_manifest(d, opts) {
        var str = xlml_normalize(d);
        var Rn;
        var FEtag;
        while(Rn = xlmlregex.exec(str))switch(Rn[3]){
            case 'manifest':
                break; // 4.2 <manifest:manifest>
            case 'file-entry':
                FEtag = parsexmltag(Rn[0], false);
                if (FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
                break;
            case 'encryption-data':
            case 'algorithm':
            case 'start-key-generation':
            case 'key-derivation':
                throw new Error("Unsupported ODS Encryption");
            default:
                if (opts && opts.WTF) throw Rn;
        }
    }
    function write_manifest(manifest) {
        var o = [
            XML_HEADER
        ];
        o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
        o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
        for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
        o.push('</manifest:manifest>');
        return o.join("");
    }
    /* Part 3 Section 6 Metadata Manifest File */ function write_rdf_type(file, res, tag) {
        return [
            '  <rdf:Description rdf:about="' + file + '">\n',
            '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
            '  </rdf:Description>\n'
        ].join("");
    }
    function write_rdf_has(base, file) {
        return [
            '  <rdf:Description rdf:about="' + base + '">\n',
            '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
            '  </rdf:Description>\n'
        ].join("");
    }
    function write_rdf(rdf) {
        var o = [
            XML_HEADER
        ];
        o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
        for(var i = 0; i != rdf.length; ++i){
            o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
            o.push(write_rdf_has("", rdf[i][0]));
        }
        o.push(write_rdf_type("", "Document", "pkg"));
        o.push('</rdf:RDF>');
        return o.join("");
    }
    /* TODO: pull properties */ var write_meta_ods = function() {
        var payload = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
        return function wmo() {
            return payload;
        };
    }();
    /* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var CORE_PROPS = [
        [
            "cp:category",
            "Category"
        ],
        [
            "cp:contentStatus",
            "ContentStatus"
        ],
        [
            "cp:keywords",
            "Keywords"
        ],
        [
            "cp:lastModifiedBy",
            "LastAuthor"
        ],
        [
            "cp:lastPrinted",
            "LastPrinted"
        ],
        [
            "cp:revision",
            "RevNumber"
        ],
        [
            "cp:version",
            "Version"
        ],
        [
            "dc:creator",
            "Author"
        ],
        [
            "dc:description",
            "Comments"
        ],
        [
            "dc:identifier",
            "Identifier"
        ],
        [
            "dc:language",
            "Language"
        ],
        [
            "dc:subject",
            "Subject"
        ],
        [
            "dc:title",
            "Title"
        ],
        [
            "dcterms:created",
            "CreatedDate",
            'date'
        ],
        [
            "dcterms:modified",
            "ModifiedDate",
            'date'
        ]
    ];
    XMLNS.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
    RELS.CORE_PROPS = 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';
    var CORE_PROPS_REGEX = function() {
        var r = new Array(CORE_PROPS.length);
        for(var i = 0; i < CORE_PROPS.length; ++i){
            var f = CORE_PROPS[i];
            var g = "(?:" + f[0].slice(0, f[0].indexOf(":")) + ":)" + f[0].slice(f[0].indexOf(":") + 1);
            r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
        }
        return r;
    }();
    function parse_core_props(data) {
        var p = {};
        data = utf8read(data);
        for(var i = 0; i < CORE_PROPS.length; ++i){
            var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
            if (cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
            if (f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
        }
        return p;
    }
    var CORE_PROPS_XML_ROOT = writextag('cp:coreProperties', null, {
        //'xmlns': XMLNS.CORE_PROPS,
        'xmlns:cp': XMLNS.CORE_PROPS,
        'xmlns:dc': XMLNS.dc,
        'xmlns:dcterms': XMLNS.dcterms,
        'xmlns:dcmitype': XMLNS.dcmitype,
        'xmlns:xsi': XMLNS.xsi
    });
    function cp_doit(f, g, h, o, p) {
        if (p[f] != null || g == null || g === "") return;
        p[f] = g;
        g = escapexml(g);
        o[o.length] = h ? writextag(f, g, h) : writetag(f, g);
    }
    function write_core_props(cp, _opts) {
        var opts = _opts || {};
        var o = [
            XML_HEADER,
            CORE_PROPS_XML_ROOT
        ], p = {};
        if (!cp && !opts.Props) return o.join("");
        if (cp) {
            if (cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {
                "xsi:type": "dcterms:W3CDTF"
            }, o, p);
            if (cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {
                "xsi:type": "dcterms:W3CDTF"
            }, o, p);
        }
        for(var i = 0; i != CORE_PROPS.length; ++i){
            var f = CORE_PROPS[i];
            var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
            if (v === true) v = "1";
            else if (v === false) v = "0";
            else if (typeof v == "number") v = String(v);
            if (v != null) cp_doit(f[0], v, null, o, p);
        }
        if (o.length > 2) {
            o[o.length] = '</cp:coreProperties>';
            o[1] = o[1].replace("/>", ">");
        }
        return o.join("");
    }
    /* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var EXT_PROPS = [
        [
            "Application",
            "Application",
            "string"
        ],
        [
            "AppVersion",
            "AppVersion",
            "string"
        ],
        [
            "Company",
            "Company",
            "string"
        ],
        [
            "DocSecurity",
            "DocSecurity",
            "string"
        ],
        [
            "Manager",
            "Manager",
            "string"
        ],
        [
            "HyperlinksChanged",
            "HyperlinksChanged",
            "bool"
        ],
        [
            "SharedDoc",
            "SharedDoc",
            "bool"
        ],
        [
            "LinksUpToDate",
            "LinksUpToDate",
            "bool"
        ],
        [
            "ScaleCrop",
            "ScaleCrop",
            "bool"
        ],
        [
            "HeadingPairs",
            "HeadingPairs",
            "raw"
        ],
        [
            "TitlesOfParts",
            "TitlesOfParts",
            "raw"
        ]
    ];
    XMLNS.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
    RELS.EXT_PROPS = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';
    var PseudoPropsPairs = [
        "Worksheets",
        "SheetNames",
        "NamedRanges",
        "DefinedNames",
        "Chartsheets",
        "ChartNames"
    ];
    function load_props_pairs(HP, TOP, props, opts) {
        var v = [];
        if (typeof HP == "string") v = parseVector(HP, opts);
        else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
            return {
                v: hp
            };
        }));
        var parts = typeof TOP == "string" ? parseVector(TOP, opts).map(function(x) {
            return x.v;
        }) : TOP;
        var idx = 0, len = 0;
        if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
            len = +v[i + 1].v;
            switch(v[i].v){
                case "Worksheets":
                case "\u5DE5\u4F5C\u8868":
                case "\u041B\u0438\u0441\u0442\u044B":
                case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
                case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
                case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
                case "Arbeitsbl\xe4tter":
                case "\xc7al\u0131\u015Fma Sayfalar\u0131":
                case "Feuilles de calcul":
                case "Fogli di lavoro":
                case "Folhas de c\xe1lculo":
                case "Planilhas":
                case "Regneark":
                case "Hojas de c\xe1lculo":
                case "Werkbladen":
                    props.Worksheets = len;
                    props.SheetNames = parts.slice(idx, idx + len);
                    break;
                case "Named Ranges":
                case "Rangos con nombre":
                case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
                case "Benannte Bereiche":
                case "Navngivne omr\xe5der":
                    props.NamedRanges = len;
                    props.DefinedNames = parts.slice(idx, idx + len);
                    break;
                case "Charts":
                case "Diagramme":
                    props.Chartsheets = len;
                    props.ChartNames = parts.slice(idx, idx + len);
                    break;
            }
            idx += len;
        }
    }
    function parse_ext_props(data, p, opts) {
        var q = {};
        if (!p) p = {};
        data = utf8read(data);
        EXT_PROPS.forEach(function(f) {
            var xml = (data.match(matchtag(f[0])) || [])[1];
            switch(f[2]){
                case "string":
                    if (xml) p[f[1]] = unescapexml(xml);
                    break;
                case "bool":
                    p[f[1]] = xml === "true";
                    break;
                case "raw":
                    var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
                    if (cur && cur.length > 0) q[f[1]] = cur[1];
                    break;
            }
        });
        if (q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
        return p;
    }
    var EXT_PROPS_XML_ROOT = writextag('Properties', null, {
        'xmlns': XMLNS.EXT_PROPS,
        'xmlns:vt': XMLNS.vt
    });
    function write_ext_props(cp) {
        var o = [], W = writextag;
        if (!cp) cp = {};
        cp.Application = "SheetJS";
        o[o.length] = XML_HEADER;
        o[o.length] = EXT_PROPS_XML_ROOT;
        EXT_PROPS.forEach(function(f) {
            if (cp[f[1]] === undefined) return;
            var v;
            switch(f[2]){
                case 'string':
                    v = escapexml(String(cp[f[1]]));
                    break;
                case 'bool':
                    v = cp[f[1]] ? 'true' : 'false';
                    break;
            }
            if (v !== undefined) o[o.length] = W(f[0], v);
        });
        /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>') + W('vt:variant', W('vt:i4', String(cp.Worksheets))), {
            size: 2,
            baseType: "variant"
        }));
        o[o.length] = W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) {
            return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>";
        }).join(""), {
            size: cp.Worksheets,
            baseType: "lpstr"
        }));
        if (o.length > 2) {
            o[o.length] = '</Properties>';
            o[1] = o[1].replace("/>", ">");
        }
        return o.join("");
    }
    /* 15.2.12.2 Custom File Properties Part */ XMLNS.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";
    RELS.CUST_PROPS = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';
    var custregex = /<[^>]+>[^<]*/g;
    function parse_cust_props(data, opts) {
        var p = {}, name = "";
        var m = data.match(custregex);
        if (m) for(var i = 0; i != m.length; ++i){
            var x = m[i], y = parsexmltag(x);
            switch(y[0]){
                case '<?xml':
                    break;
                case '<Properties':
                    break;
                case '<property':
                    name = unescapexml(y.name);
                    break;
                case '</property>':
                    name = null;
                    break;
                default:
                    if (x.indexOf('<vt:') === 0) {
                        var toks = x.split('>');
                        var type = toks[0].slice(4), text = toks[1];
                        /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                            case 'lpstr':
                            case 'bstr':
                            case 'lpwstr':
                                p[name] = unescapexml(text);
                                break;
                            case 'bool':
                                p[name] = parsexmlbool(text);
                                break;
                            case 'i1':
                            case 'i2':
                            case 'i4':
                            case 'i8':
                            case 'int':
                            case 'uint':
                                p[name] = parseInt(text, 10);
                                break;
                            case 'r4':
                            case 'r8':
                            case 'decimal':
                                p[name] = parseFloat(text);
                                break;
                            case 'filetime':
                            case 'date':
                                p[name] = parseDate(text);
                                break;
                            case 'cy':
                            case 'error':
                                p[name] = unescapexml(text);
                                break;
                            default:
                                if (type.slice(-1) == '/') break;
                                if (opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
                        }
                    } else if (x.slice(0, 2) === "</") ;
                    else if (opts.WTF) throw new Error(x);
            }
        }
        return p;
    }
    var CUST_PROPS_XML_ROOT = writextag('Properties', null, {
        'xmlns': XMLNS.CUST_PROPS,
        'xmlns:vt': XMLNS.vt
    });
    function write_cust_props(cp) {
        var o = [
            XML_HEADER,
            CUST_PROPS_XML_ROOT
        ];
        if (!cp) return o.join("");
        var pid = 1;
        keys(cp).forEach(function custprop(k) {
            ++pid;
            o[o.length] = writextag('property', write_vt(cp[k], true), {
                'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
                'pid': pid,
                'name': escapexml(k)
            });
        });
        if (o.length > 2) {
            o[o.length] = '</Properties>';
            o[1] = o[1].replace("/>", ">");
        }
        return o.join("");
    }
    /* Common Name -> XLML Name */ var XLMLDocPropsMap = {
        Title: 'Title',
        Subject: 'Subject',
        Author: 'Author',
        Keywords: 'Keywords',
        Comments: 'Description',
        LastAuthor: 'LastAuthor',
        RevNumber: 'Revision',
        Application: 'AppName',
        /* TotalTime: 'TotalTime', */ LastPrinted: 'LastPrinted',
        CreatedDate: 'Created',
        ModifiedDate: 'LastSaved',
        /* Pages */ /* Words */ /* Characters */ Category: 'Category',
        /* PresentationFormat */ Manager: 'Manager',
        Company: 'Company',
        /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: 'Version',
        ContentStatus: 'ContentStatus',
        /* NOTE: missing from schema */ Identifier: 'Identifier',
        /* NOTE: missing from schema */ Language: 'Language' /* NOTE: missing from schema */ 
    };
    var evert_XLMLDPM = evert(XLMLDocPropsMap);
    function xlml_set_prop(Props, tag, val) {
        tag = evert_XLMLDPM[tag] || tag;
        Props[tag] = val;
    }
    function xlml_write_docprops(Props, opts) {
        var o = [];
        keys(XLMLDocPropsMap).map(function(m) {
            for(var i = 0; i < CORE_PROPS.length; ++i)if (CORE_PROPS[i][1] == m) return CORE_PROPS[i];
            for(i = 0; i < EXT_PROPS.length; ++i)if (EXT_PROPS[i][1] == m) return EXT_PROPS[i];
            throw m;
        }).forEach(function(p) {
            if (Props[p[1]] == null) return;
            var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
            switch(p[2]){
                case 'date':
                    m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                    break;
            }
            if (typeof m == 'number') m = String(m);
            else if (m === true || m === false) m = m ? "1" : "0";
            else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
            o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
        });
        return writextag('DocumentProperties', o.join(""), {
            xmlns: XLMLNS.o
        });
    }
    function xlml_write_custprops(Props, Custprops) {
        var BLACKLIST = [
            "Worksheets",
            "SheetNames"
        ];
        var T = 'CustomDocumentProperties';
        var o = [];
        if (Props) keys(Props).forEach(function(k) {
            if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
            for(var i = 0; i < CORE_PROPS.length; ++i)if (k == CORE_PROPS[i][1]) return;
            for(i = 0; i < EXT_PROPS.length; ++i)if (k == EXT_PROPS[i][1]) return;
            for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
            var m = Props[k];
            var t = "string";
            if (typeof m == 'number') {
                t = "float";
                m = String(m);
            } else if (m === true || m === false) {
                t = "boolean";
                m = m ? "1" : "0";
            } else m = String(m);
            o.push(writextag(escapexmltag(k), m, {
                "dt:dt": t
            }));
        });
        if (Custprops) keys(Custprops).forEach(function(k) {
            if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
            if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
            var m = Custprops[k];
            var t = "string";
            if (typeof m == 'number') {
                t = "float";
                m = String(m);
            } else if (m === true || m === false) {
                t = "boolean";
                m = m ? "1" : "0";
            } else if (m instanceof Date) {
                t = "dateTime.tz";
                m = m.toISOString();
            } else m = String(m);
            o.push(writextag(escapexmltag(k), m, {
                "dt:dt": t
            }));
        });
        return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
    }
    /* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function parse_FILETIME(blob) {
        var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
        return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
    }
    function write_FILETIME(time) {
        var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
        var t = date.getTime() / 1000 + 11644473600;
        var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
        l *= 1e7;
        h *= 1e7;
        var w = l / Math.pow(2, 32) | 0;
        if (w > 0) {
            l = l % Math.pow(2, 32);
            h += w;
        }
        var o = new_buf(8);
        o.write_shift(4, l);
        o.write_shift(4, h);
        return o;
    }
    /* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function parse_lpstr(blob, type, pad) {
        var start = blob.l;
        var str = blob.read_shift(0, 'lpstr-cp');
        if (pad) while(blob.l - start & 3)++blob.l;
        return str;
    }
    /* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function parse_lpwstr(blob, type, pad) {
        var str = blob.read_shift(0, 'lpwstr');
        if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
        return str;
    }
    /* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function parse_VtStringBase(blob, stringType, pad) {
        if (stringType === 0x1F /*VT_LPWSTR*/ ) return parse_lpwstr(blob);
        return parse_lpstr(blob, stringType, pad);
    }
    function parse_VtString(blob, t, pad) {
        return parse_VtStringBase(blob, t, pad === false ? 0 : 4);
    }
    function parse_VtUnalignedString(blob, t) {
        if (!t) throw new Error("VtUnalignedString must have positive length");
        return parse_VtStringBase(blob, t, 0);
    }
    /* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function parse_VtVecUnalignedLpstrValue(blob) {
        var length = blob.read_shift(4);
        var ret = [];
        for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0, '');
        return ret;
    }
    /* [MS-OSHARED] 2.3.3.1.10 VtVecUnalignedLpstr */ function parse_VtVecUnalignedLpstr(blob) {
        return parse_VtVecUnalignedLpstrValue(blob);
    }
    /* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function parse_VtHeadingPair(blob) {
        var headingString = parse_TypedPropertyValue(blob, VT_USTR);
        var headerParts = parse_TypedPropertyValue(blob, VT_I4);
        return [
            headingString,
            headerParts
        ];
    }
    /* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function parse_VtVecHeadingPairValue(blob) {
        var cElements = blob.read_shift(4);
        var out = [];
        for(var i = 0; i != cElements / 2; ++i)out.push(parse_VtHeadingPair(blob));
        return out;
    }
    /* [MS-OSHARED] 2.3.3.1.15 VtVecHeadingPair */ function parse_VtVecHeadingPair(blob) {
        // NOTE: When invoked, wType & padding were already consumed
        return parse_VtVecHeadingPairValue(blob);
    }
    /* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function parse_dictionary(blob, CodePage) {
        var cnt = blob.read_shift(4);
        var dict = {};
        for(var j = 0; j != cnt; ++j){
            var pid = blob.read_shift(4);
            var len = blob.read_shift(4);
            dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? 'utf16le' : 'utf8').replace(chr0, '').replace(chr1, '!');
            if (CodePage === 0x4B0 && len % 2) blob.l += 2;
        }
        if (blob.l & 3) blob.l = blob.l >> 3 << 2;
        return dict;
    }
    /* [MS-OLEPS] 2.9 BLOB */ function parse_BLOB(blob) {
        var size = blob.read_shift(4);
        var bytes = blob.slice(blob.l, blob.l + size);
        blob.l += size;
        if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
        return bytes;
    }
    /* [MS-OLEPS] 2.11 ClipboardData */ function parse_ClipboardData(blob) {
        // TODO
        var o = {};
        o.Size = blob.read_shift(4);
        //o.Format = blob.read_shift(4);
        blob.l += o.Size + 3 - (o.Size - 1) % 4;
        return o;
    }
    /* [MS-OLEPS] 2.15 TypedPropertyValue */ function parse_TypedPropertyValue(blob, type, _opts) {
        var t = blob.read_shift(2), ret, opts = _opts || {};
        blob.l += 2;
        if (type !== VT_VARIANT) {
            if (t !== type && VT_CUSTOM.indexOf(type) === -1) throw new Error('Expected type ' + type + ' saw ' + t);
        }
        switch(type === VT_VARIANT ? t : type){
            case 0x02 /*VT_I2*/ :
                ret = blob.read_shift(2, 'i');
                if (!opts.raw) blob.l += 2;
                return ret;
            case 0x03 /*VT_I4*/ :
                ret = blob.read_shift(4, 'i');
                return ret;
            case 0x0B /*VT_BOOL*/ :
                return blob.read_shift(4) !== 0x0;
            case 0x13 /*VT_UI4*/ :
                ret = blob.read_shift(4);
                return ret;
            case 0x1E /*VT_LPSTR*/ :
                return parse_lpstr(blob, t, 4).replace(chr0, '');
            case 0x1F /*VT_LPWSTR*/ :
                return parse_lpwstr(blob);
            case 0x40 /*VT_FILETIME*/ :
                return parse_FILETIME(blob);
            case 0x41 /*VT_BLOB*/ :
                return parse_BLOB(blob);
            case 0x47 /*VT_CF*/ :
                return parse_ClipboardData(blob);
            case 0x50 /*VT_STRING*/ :
                return parse_VtString(blob, t, !opts.raw).replace(chr0, '');
            case 0x51 /*VT_USTR*/ :
                return parse_VtUnalignedString(blob, t /*, 4*/ ).replace(chr0, '');
            case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                return parse_VtVecHeadingPair(blob);
            case 0x101E /*VT_LPSTR*/ :
                return parse_VtVecUnalignedLpstr(blob);
            default:
                throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
        }
    }
    function write_TypedPropertyValue(type, value) {
        var o = new_buf(4), p = new_buf(4);
        o.write_shift(4, type == 0x50 ? 0x1F : type);
        switch(type){
            case 0x03 /*VT_I4*/ :
                p.write_shift(-4, value);
                break;
            case 0x05 /*VT_I4*/ :
                p = new_buf(8);
                p.write_shift(8, value, 'f');
                break;
            case 0x0B /*VT_BOOL*/ :
                p.write_shift(4, value ? 0x01 : 0x00);
                break;
            case 0x40 /*VT_FILETIME*/ :
                p = write_FILETIME(value);
                break;
            case 0x1F /*VT_LPWSTR*/ :
            case 0x50 /*VT_STRING*/ :
                p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
                p.write_shift(4, value.length + 1);
                p.write_shift(0, value, "dbcs");
                while(p.l != p.length)p.write_shift(1, 0);
                break;
            default:
                throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
        }
        return bconcat([
            o,
            p
        ]);
    }
    /* [MS-OLEPS] 2.20 PropertySet */ function parse_PropertySet(blob, PIDSI) {
        var start_addr = blob.l;
        var size = blob.read_shift(4);
        var NumProps = blob.read_shift(4);
        var Props = [], i = 0;
        var CodePage = 0;
        var Dictionary = -1, DictObj = {};
        for(i = 0; i != NumProps; ++i){
            var PropID = blob.read_shift(4);
            var Offset = blob.read_shift(4);
            Props[i] = [
                PropID,
                Offset + start_addr
            ];
        }
        Props.sort(function(x, y) {
            return x[1] - y[1];
        });
        var PropH = {};
        for(i = 0; i != NumProps; ++i){
            if (blob.l !== Props[i][1]) {
                var fail = true;
                if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                    case 0x02 /*VT_I2*/ :
                        if (blob.l + 2 === Props[i][1]) {
                            blob.l += 2;
                            fail = false;
                        }
                        break;
                    case 0x50 /*VT_STRING*/ :
                        if (blob.l <= Props[i][1]) {
                            blob.l = Props[i][1];
                            fail = false;
                        }
                        break;
                    case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                        if (blob.l <= Props[i][1]) {
                            blob.l = Props[i][1];
                            fail = false;
                        }
                        break;
                }
                if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                    fail = false;
                    blob.l = Props[i][1];
                }
                if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
            }
            if (PIDSI) {
                var piddsi = PIDSI[Props[i][0]];
                PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {
                    raw: true
                });
                if (piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
                if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                    case 0:
                        PropH[piddsi.n] = 1252;
                    /* falls through */ case 874:
                    case 932:
                    case 936:
                    case 949:
                    case 950:
                    case 1250:
                    case 1251:
                    case 1253:
                    case 1254:
                    case 1255:
                    case 1256:
                    case 1257:
                    case 1258:
                    case 10000:
                    case 1200:
                    case 1201:
                    case 1252:
                    case 65000:
                    case -536:
                    case 65001:
                    case -535:
                        set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                        break;
                    default:
                        throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
                }
            } else {
                if (Props[i][0] === 0x1) {
                    CodePage = PropH.CodePage = parse_TypedPropertyValue(blob, VT_I2);
                    set_cp(CodePage);
                    if (Dictionary !== -1) {
                        var oldpos = blob.l;
                        blob.l = Props[Dictionary][1];
                        DictObj = parse_dictionary(blob, CodePage);
                        blob.l = oldpos;
                    }
                } else if (Props[i][0] === 0) {
                    if (CodePage === 0) {
                        Dictionary = i;
                        blob.l = Props[i + 1][1];
                        continue;
                    }
                    DictObj = parse_dictionary(blob, CodePage);
                } else {
                    var name = DictObj[Props[i][0]];
                    var val;
                    /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                        case 0x41 /*VT_BLOB*/ :
                            blob.l += 4;
                            val = parse_BLOB(blob);
                            break;
                        case 0x1E /*VT_LPSTR*/ :
                            blob.l += 4;
                            val = parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                            break;
                        case 0x1F /*VT_LPWSTR*/ :
                            blob.l += 4;
                            val = parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                            break;
                        case 0x03 /*VT_I4*/ :
                            blob.l += 4;
                            val = blob.read_shift(4, 'i');
                            break;
                        case 0x13 /*VT_UI4*/ :
                            blob.l += 4;
                            val = blob.read_shift(4);
                            break;
                        case 0x05 /*VT_R8*/ :
                            blob.l += 4;
                            val = blob.read_shift(8, 'f');
                            break;
                        case 0x0B /*VT_BOOL*/ :
                            blob.l += 4;
                            val = parsebool(blob, 4);
                            break;
                        case 0x40 /*VT_FILETIME*/ :
                            blob.l += 4;
                            val = parseDate(parse_FILETIME(blob));
                            break;
                        default:
                            throw new Error("unparsed value: " + blob[blob.l]);
                    }
                    PropH[name] = val;
                }
            }
        }
        blob.l = start_addr + size; /* step ahead to skip padding */ 
        return PropH;
    }
    var XLSPSSkip = [
        "CodePage",
        "Thumbnail",
        "_PID_LINKBASE",
        "_PID_HLINKS",
        "SystemIdentifier",
        "FMTID"
    ].concat(PseudoPropsPairs);
    function guess_property_type(val) {
        switch(typeof val){
            case "boolean":
                return 0x0B;
            case "number":
                return (val | 0) == val ? 0x03 : 0x05;
            case "string":
                return 0x1F;
            case "object":
                if (val instanceof Date) return 0x40;
                break;
        }
        return -1;
    }
    function write_PropertySet(entries, RE, PIDSI) {
        var hdr = new_buf(8), piao = [], prop = [];
        var sz = 8, i = 0;
        var pr = new_buf(8), pio = new_buf(8);
        pr.write_shift(4, 0x0002);
        pr.write_shift(4, 0x04B0);
        pio.write_shift(4, 0x0001);
        prop.push(pr);
        piao.push(pio);
        sz += 8 + pr.length;
        if (!RE) {
            pio = new_buf(8);
            pio.write_shift(4, 0);
            piao.unshift(pio);
            var bufs = [
                new_buf(4)
            ];
            bufs[0].write_shift(4, entries.length);
            for(i = 0; i < entries.length; ++i){
                var value = entries[i][0];
                pr = new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
                pr.write_shift(4, i + 2);
                pr.write_shift(4, value.length + 1);
                pr.write_shift(0, value, "dbcs");
                while(pr.l != pr.length)pr.write_shift(1, 0);
                bufs.push(pr);
            }
            pr = bconcat(bufs);
            prop.unshift(pr);
            sz += 8 + pr.length;
        }
        for(i = 0; i < entries.length; ++i){
            if (RE && !RE[entries[i][0]]) continue;
            if (XLSPSSkip.indexOf(entries[i][0]) > -1) continue;
            if (entries[i][1] == null) continue;
            var val = entries[i][1], idx = 0;
            if (RE) {
                idx = +RE[entries[i][0]];
                var pinfo = PIDSI[idx];
                if (pinfo.p == "version" && typeof val == "string") {
                    var arr = val.split(".");
                    val = (+arr[0] << 16) + (+arr[1] || 0);
                }
                pr = write_TypedPropertyValue(pinfo.t, val);
            } else {
                var T = guess_property_type(val);
                if (T == -1) {
                    T = 0x1F;
                    val = String(val);
                }
                pr = write_TypedPropertyValue(T, val);
            }
            prop.push(pr);
            pio = new_buf(8);
            pio.write_shift(4, !RE ? 2 + i : idx);
            piao.push(pio);
            sz += 8 + pr.length;
        }
        var w = 8 * (prop.length + 1);
        for(i = 0; i < prop.length; ++i){
            piao[i].write_shift(4, w);
            w += prop[i].length;
        }
        hdr.write_shift(4, sz);
        hdr.write_shift(4, prop.length);
        return bconcat([
            hdr
        ].concat(piao).concat(prop));
    }
    /* [MS-OLEPS] 2.21 PropertySetStream */ function parse_PropertySetStream(file, PIDSI, clsid) {
        var blob = file.content;
        if (!blob) return {};
        prep_blob(blob, 0);
        var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
        blob.chk('feff', 'Byte Order: ');
        /*var vers = */ blob.read_shift(2); // TODO: check version
        var SystemIdentifier = blob.read_shift(4);
        var CLSID = blob.read_shift(16);
        if (CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
        NumSets = blob.read_shift(4);
        if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
        FMTID0 = blob.read_shift(16);
        Offset0 = blob.read_shift(4);
        if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
        else if (NumSets === 2) {
            FMTID1 = blob.read_shift(16);
            Offset1 = blob.read_shift(4);
        }
        var PSet0 = parse_PropertySet(blob, PIDSI);
        var rval = {
            SystemIdentifier: SystemIdentifier
        };
        for(var y in PSet0)rval[y] = PSet0[y];
        //rval.blob = blob;
        rval.FMTID = FMTID0;
        //rval.PSet0 = PSet0;
        if (NumSets === 1) return rval;
        if (Offset1 - blob.l == 2) blob.l += 2;
        if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
        var PSet1;
        try {
            PSet1 = parse_PropertySet(blob, null);
        } catch (e) {}
        for(y in PSet1)rval[y] = PSet1[y];
        rval.FMTID = [
            FMTID0,
            FMTID1
        ]; // TODO: verify FMTID0/1
        return rval;
    }
    function write_PropertySetStream(entries, clsid, RE, PIDSI, entries2, clsid2) {
        var hdr = new_buf(entries2 ? 68 : 48);
        var bufs = [
            hdr
        ];
        hdr.write_shift(2, 0xFFFE);
        hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
        hdr.write_shift(4, 0x32363237);
        hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
        hdr.write_shift(4, entries2 ? 2 : 1);
        hdr.write_shift(16, clsid, "hex");
        hdr.write_shift(4, entries2 ? 68 : 48);
        var ps0 = write_PropertySet(entries, RE, PIDSI);
        bufs.push(ps0);
        if (entries2) {
            var ps1 = write_PropertySet(entries2, null, null);
            hdr.write_shift(16, clsid2, "hex");
            hdr.write_shift(4, 68 + ps0.length);
            bufs.push(ps1);
        }
        return bconcat(bufs);
    }
    function parsenoop2(blob, length) {
        blob.read_shift(length);
        return null;
    }
    function writezeroes(n, o) {
        if (!o) o = new_buf(n);
        for(var j = 0; j < n; ++j)o.write_shift(1, 0);
        return o;
    }
    function parslurp(blob, length, cb) {
        var arr = [], target = blob.l + length;
        while(blob.l < target)arr.push(cb(blob, target - blob.l));
        if (target !== blob.l) throw new Error("Slurp error");
        return arr;
    }
    function parsebool(blob, length) {
        return blob.read_shift(length) === 0x1;
    }
    function writebool(v, o) {
        if (!o) o = new_buf(2);
        o.write_shift(2, +!!v);
        return o;
    }
    function parseuint16(blob) {
        return blob.read_shift(2, 'u');
    }
    function writeuint16(v, o) {
        if (!o) o = new_buf(2);
        o.write_shift(2, v);
        return o;
    }
    function parseuint16a(blob, length) {
        return parslurp(blob, length, parseuint16);
    }
    /* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function parse_Bes(blob) {
        var v = blob.read_shift(1), t = blob.read_shift(1);
        return t === 0x01 ? v : v === 0x01;
    }
    function write_Bes(v, t, o) {
        if (!o) o = new_buf(2);
        o.write_shift(1, +v);
        o.write_shift(1, t == 'e' ? 1 : 0);
        return o;
    }
    /* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function parse_ShortXLUnicodeString(blob, length, opts) {
        var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
        var encoding = 'sbcs-cont';
        var cp = current_codepage;
        if (opts && opts.biff >= 8) current_codepage = 1200;
        if (!opts || opts.biff == 8) {
            var fHighByte = blob.read_shift(1);
            if (fHighByte) encoding = 'dbcs-cont';
        } else if (opts.biff == 12) encoding = 'wstr';
        if (opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
        var o = cch ? blob.read_shift(cch, encoding) : "";
        current_codepage = cp;
        return o;
    }
    /* 2.5.293 XLUnicodeRichExtendedString */ function parse_XLUnicodeRichExtendedString(blob) {
        var cp = current_codepage;
        current_codepage = 1200;
        var cch = blob.read_shift(2), flags = blob.read_shift(1);
        var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
        var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
        var cRun = 0, cbExtRst;
        var z = {};
        if (fRichSt) cRun = blob.read_shift(2);
        if (fExtSt) cbExtRst = blob.read_shift(4);
        var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
        var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
        if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
        if (fExtSt) blob.l += cbExtRst; //TODO: parse this
        z.t = msg;
        if (!fRichSt) {
            z.raw = "<t>" + z.t + "</t>";
            z.r = z.t;
        }
        current_codepage = cp;
        return z;
    }
    function write_XLUnicodeRichExtendedString(xlstr) {
        var str = xlstr.t || "", nfmts = 1;
        var hdr = new_buf(3 + (nfmts > 1 ? 2 : 0));
        hdr.write_shift(2, str.length);
        hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
        if (nfmts > 1) hdr.write_shift(2, nfmts);
        var otext = new_buf(2 * str.length);
        otext.write_shift(2 * str.length, str, 'utf16le');
        var out = [
            hdr,
            otext
        ];
        return bconcat(out);
    }
    /* 2.5.296 XLUnicodeStringNoCch */ function parse_XLUnicodeStringNoCch(blob, cch, opts) {
        var retval;
        if (opts) {
            if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
            if (opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
        }
        var fHighByte = blob.read_shift(1);
        if (fHighByte === 0) retval = blob.read_shift(cch, 'sbcs-cont');
        else retval = blob.read_shift(cch, 'dbcs-cont');
        return retval;
    }
    /* 2.5.294 XLUnicodeString */ function parse_XLUnicodeString(blob, length, opts) {
        var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
        if (cch === 0) {
            blob.l++;
            return "";
        }
        return parse_XLUnicodeStringNoCch(blob, cch, opts);
    }
    /* BIFF5 override */ function parse_XLUnicodeString2(blob, length, opts) {
        if (opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
        var cch = blob.read_shift(1);
        if (cch === 0) {
            blob.l++;
            return "";
        }
        return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? 'cpstr' : 'sbcs-cont');
    }
    /* TODO: BIFF5 and lower, codepage awareness */ function write_XLUnicodeString(str, opts, o) {
        if (!o) o = new_buf(3 + 2 * str.length);
        o.write_shift(2, str.length);
        o.write_shift(1, 1);
        o.write_shift(31, str, 'utf16le');
        return o;
    }
    /* [MS-XLS] 2.5.61 ControlInfo */ function parse_ControlInfo(blob) {
        var flags = blob.read_shift(1);
        blob.l++;
        var accel = blob.read_shift(2);
        blob.l += 2;
        return [
            flags,
            accel
        ];
    }
    /* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function parse_URLMoniker(blob) {
        var len = blob.read_shift(4), start = blob.l;
        var extra = false;
        if (len > 24) {
            /* look ahead */ blob.l += len - 24;
            if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
            blob.l = start;
        }
        var url = blob.read_shift((extra ? len - 24 : len) >> 1, 'utf16le').replace(chr0, "");
        if (extra) blob.l += 24;
        return url;
    }
    /* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function parse_FileMoniker(blob) {
        blob.l += 2; //var cAnti = blob.read_shift(2);
        var ansiPath = blob.read_shift(0, 'lpstr-ansi');
        blob.l += 2; //var endServer = blob.read_shift(2);
        if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
        var sz = blob.read_shift(4);
        if (sz === 0) return ansiPath.replace(/\\/g, "/");
        var bytes = blob.read_shift(4);
        if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
        var unicodePath = blob.read_shift(bytes >> 1, 'utf16le').replace(chr0, "");
        return unicodePath;
    }
    /* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function parse_HyperlinkMoniker(blob, length) {
        var clsid = blob.read_shift(16);
        length -= 16;
        switch(clsid){
            case "e0c9ea79f9bace118c8200aa004ba90b":
                return parse_URLMoniker(blob, length);
            case "0303000000000000c000000000000046":
                return parse_FileMoniker(blob, length);
            default:
                throw new Error("Unsupported Moniker " + clsid);
        }
    }
    /* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function parse_HyperlinkString(blob) {
        var len = blob.read_shift(4);
        var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
        return o;
    }
    /* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function parse_Hyperlink(blob, length) {
        var end = blob.l + length;
        var sVer = blob.read_shift(4);
        if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
        var flags = blob.read_shift(2);
        blob.l += 2;
        var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
        if (flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
        if (flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
        if ((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
        if ((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
        if (flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
        if (flags & 0x0020) guid = blob.read_shift(16);
        if (flags & 0x0040) fileTime = parse_FILETIME(blob /*, 8*/ );
        blob.l = end;
        var target = targetFrameName || moniker || oleMoniker || "";
        if (target && Loc) target += "#" + Loc;
        if (!target) target = "#" + Loc;
        var out = {
            Target: target
        };
        if (guid) out.guid = guid;
        if (fileTime) out.time = fileTime;
        if (displayName) out.Tooltip = displayName;
        return out;
    }
    function write_Hyperlink(hl) {
        var out = new_buf(512), i = 0;
        var Target = hl.Target;
        var F = Target.indexOf("#") > -1 ? 0x1f : 0x17;
        switch(Target.charAt(0)){
            case "#":
                F = 0x1c;
                break;
            case ".":
                F &= -3;
                break;
        }
        out.write_shift(4, 2);
        out.write_shift(4, F);
        var data = [
            8,
            6815827,
            6619237,
            4849780,
            83
        ];
        for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
        if (F == 0x1C) {
            Target = Target.slice(1);
            out.write_shift(4, Target.length + 1);
            for(i = 0; i < Target.length; ++i)out.write_shift(2, Target.charCodeAt(i));
            out.write_shift(2, 0);
        } else if (F & 0x02) {
            data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
            for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
            out.write_shift(4, 2 * (Target.length + 1));
            for(i = 0; i < Target.length; ++i)out.write_shift(2, Target.charCodeAt(i));
            out.write_shift(2, 0);
        } else {
            data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
            for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
            var P = 0;
            while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
            out.write_shift(2, P);
            out.write_shift(4, Target.length + 1);
            for(i = 0; i < Target.length; ++i)out.write_shift(1, Target.charCodeAt(i) & 0xFF);
            out.write_shift(1, 0);
            out.write_shift(2, 0xFFFF);
            out.write_shift(2, 0xDEAD);
            for(i = 0; i < 6; ++i)out.write_shift(4, 0);
        }
        return out.slice(0, out.l);
    }
    /* 2.5.178 LongRGBA */ function parse_LongRGBA(blob) {
        var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
        return [
            r,
            g,
            b,
            a
        ];
    }
    /* 2.5.177 LongRGB */ function parse_LongRGB(blob, length) {
        var x = parse_LongRGBA(blob, length);
        x[3] = 0;
        return x;
    }
    /* [MS-XLS] 2.5.19 */ function parse_XLSCell(blob) {
        var rw = blob.read_shift(2); // 0-indexed
        var col = blob.read_shift(2);
        var ixfe = blob.read_shift(2);
        return {
            r: rw,
            c: col,
            ixfe: ixfe
        };
    }
    function write_XLSCell(R, C, ixfe, o) {
        if (!o) o = new_buf(6);
        o.write_shift(2, R);
        o.write_shift(2, C);
        o.write_shift(2, ixfe || 0);
        return o;
    }
    /* [MS-XLS] 2.5.134 */ function parse_frtHeader(blob) {
        var rt = blob.read_shift(2);
        var flags = blob.read_shift(2); // TODO: parse these flags
        blob.l += 8;
        return {
            type: rt,
            flags: flags
        };
    }
    function parse_OptXLUnicodeString(blob, length, opts) {
        return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts);
    }
    /* [MS-XLS] 2.5.344 */ function parse_XTI(blob, length, opts) {
        var w = opts.biff > 8 ? 4 : 2;
        var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, 'i'), itabLast = blob.read_shift(w, 'i');
        return [
            iSupBook,
            itabFirst,
            itabLast
        ];
    }
    /* [MS-XLS] 2.5.218 */ function parse_RkRec(blob) {
        var ixfe = blob.read_shift(2);
        var RK = parse_RkNumber(blob);
        return [
            ixfe,
            RK
        ];
    }
    /* [MS-XLS] 2.5.1 */ function parse_AddinUdf(blob, length, opts) {
        blob.l += 4;
        length -= 4;
        var l = blob.l + length;
        var udfName = parse_ShortXLUnicodeString(blob, length, opts);
        var cb = blob.read_shift(2);
        l -= blob.l;
        if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
        blob.l += cb;
        return udfName;
    }
    /* [MS-XLS] 2.5.209 TODO: Check sizes */ function parse_Ref8U(blob) {
        var rwFirst = blob.read_shift(2);
        var rwLast = blob.read_shift(2);
        var colFirst = blob.read_shift(2);
        var colLast = blob.read_shift(2);
        return {
            s: {
                c: colFirst,
                r: rwFirst
            },
            e: {
                c: colLast,
                r: rwLast
            }
        };
    }
    function write_Ref8U(r, o) {
        if (!o) o = new_buf(8);
        o.write_shift(2, r.s.r);
        o.write_shift(2, r.e.r);
        o.write_shift(2, r.s.c);
        o.write_shift(2, r.e.c);
        return o;
    }
    /* [MS-XLS] 2.5.211 */ function parse_RefU(blob) {
        var rwFirst = blob.read_shift(2);
        var rwLast = blob.read_shift(2);
        var colFirst = blob.read_shift(1);
        var colLast = blob.read_shift(1);
        return {
            s: {
                c: colFirst,
                r: rwFirst
            },
            e: {
                c: colLast,
                r: rwLast
            }
        };
    }
    /* [MS-XLS] 2.5.207 */ var parse_Ref = parse_RefU;
    /* [MS-XLS] 2.5.143 */ function parse_FtCmo(blob) {
        blob.l += 4;
        var ot = blob.read_shift(2);
        var id = blob.read_shift(2);
        var flags = blob.read_shift(2);
        blob.l += 12;
        return [
            id,
            ot,
            flags
        ];
    }
    /* [MS-XLS] 2.5.149 */ function parse_FtNts(blob) {
        var out = {};
        blob.l += 4;
        blob.l += 16; // GUID TODO
        out.fSharedNote = blob.read_shift(2);
        blob.l += 4;
        return out;
    }
    /* [MS-XLS] 2.5.142 */ function parse_FtCf(blob) {
        var out = {};
        blob.l += 4;
        blob.cf = blob.read_shift(2);
        return out;
    }
    /* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function parse_FtSkip(blob) {
        blob.l += 2;
        blob.l += blob.read_shift(2);
    }
    var FtTab = {
        0x00: parse_FtSkip,
        /* FtEnd */ 0x04: parse_FtSkip,
        /* FtMacro */ 0x05: parse_FtSkip,
        /* FtButton */ 0x06: parse_FtSkip,
        /* FtGmo */ 0x07: parse_FtCf,
        /* FtCf */ 0x08: parse_FtSkip,
        /* FtPioGrbit */ 0x09: parse_FtSkip,
        /* FtPictFmla */ 0x0A: parse_FtSkip,
        /* FtCbls */ 0x0B: parse_FtSkip,
        /* FtRbo */ 0x0C: parse_FtSkip,
        /* FtSbs */ 0x0D: parse_FtNts,
        /* FtNts */ 0x0E: parse_FtSkip,
        /* FtSbsFmla */ 0x0F: parse_FtSkip,
        /* FtGboData */ 0x10: parse_FtSkip,
        /* FtEdoData */ 0x11: parse_FtSkip,
        /* FtRboData */ 0x12: parse_FtSkip,
        /* FtCblsData */ 0x13: parse_FtSkip,
        /* FtLbsData */ 0x14: parse_FtSkip,
        /* FtCblsFmla */ 0x15: parse_FtCmo
    };
    function parse_FtArray(blob, length) {
        var tgt = blob.l + length;
        var fts = [];
        while(blob.l < tgt){
            var ft = blob.read_shift(2);
            blob.l -= 2;
            try {
                fts.push(FtTab[ft](blob, tgt - blob.l));
            } catch (e) {
                blob.l = tgt;
                return fts;
            }
        }
        if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
        return fts;
    }
    /* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function parse_BOF(blob, length) {
        var o = {
            BIFFVer: 0,
            dt: 0
        };
        o.BIFFVer = blob.read_shift(2);
        length -= 2;
        if (length >= 2) {
            o.dt = blob.read_shift(2);
            blob.l -= 2;
        }
        switch(o.BIFFVer){
            case 0x0600:
            /* BIFF8 */ case 0x0500:
            /* BIFF5 */ case 0x0400:
            /* BIFF4 */ case 0x0300:
            /* BIFF3 */ case 0x0200:
            /* BIFF2 */ case 0x0002:
            case 0x0007:
                break;
            default:
                if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
        }
        blob.read_shift(length);
        return o;
    }
    function write_BOF(wb, t, o) {
        var h = 0x0600, w = 16;
        switch(o.bookType){
            case 'biff8':
                break;
            case 'biff5':
                h = 0x0500;
                w = 8;
                break;
            case 'biff4':
                h = 0x0004;
                w = 6;
                break;
            case 'biff3':
                h = 0x0003;
                w = 6;
                break;
            case 'biff2':
                h = 0x0002;
                w = 4;
                break;
            case 'xla':
                break;
            default:
                throw new Error("unsupported BIFF version");
        }
        var out = new_buf(w);
        out.write_shift(2, h);
        out.write_shift(2, t);
        if (w > 4) out.write_shift(2, 0x7262);
        if (w > 6) out.write_shift(2, 0x07CD);
        if (w > 8) {
            out.write_shift(2, 0xC009);
            out.write_shift(2, 0x0001);
            out.write_shift(2, 0x0706);
            out.write_shift(2, 0x0000);
        }
        return out;
    }
    /* [MS-XLS] 2.4.146 */ function parse_InterfaceHdr(blob, length) {
        if (length === 0) return 0x04b0;
        blob.read_shift(2);
        return 0x04b0;
    }
    /* [MS-XLS] 2.4.349 */ function parse_WriteAccess(blob, length, opts) {
        if (opts.enc) {
            blob.l += length;
            return "";
        }
        var l = blob.l;
        // TODO: make sure XLUnicodeString doesnt overrun
        var UserName = parse_XLUnicodeString2(blob, 0, opts);
        blob.read_shift(length + l - blob.l);
        return UserName;
    }
    function write_WriteAccess(s, opts) {
        var b8 = !opts || opts.biff == 8;
        var o = new_buf(b8 ? 112 : 54);
        o.write_shift(opts.biff == 8 ? 2 : 1, 7);
        if (b8) o.write_shift(1, 0);
        o.write_shift(4, 0x33336853);
        o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
        while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
        return o;
    }
    /* [MS-XLS] 2.4.351 */ function parse_WsBool(blob, length, opts) {
        var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
        return {
            fDialog: flags & 0x10
        };
    }
    /* [MS-XLS] 2.4.28 */ function parse_BoundSheet8(blob, length, opts) {
        var pos = blob.read_shift(4);
        var hidden = blob.read_shift(1) & 0x03;
        var dt = blob.read_shift(1);
        switch(dt){
            case 0:
                dt = 'Worksheet';
                break;
            case 1:
                dt = 'Macrosheet';
                break;
            case 2:
                dt = 'Chartsheet';
                break;
            case 6:
                dt = 'VBAModule';
                break;
        }
        var name = parse_ShortXLUnicodeString(blob, 0, opts);
        if (name.length === 0) name = "Sheet1";
        return {
            pos: pos,
            hs: hidden,
            dt: dt,
            name: name
        };
    }
    function write_BoundSheet8(data, opts) {
        var w = !opts || opts.biff >= 8 ? 2 : 1;
        var o = new_buf(8 + w * data.name.length);
        o.write_shift(4, data.pos);
        o.write_shift(1, data.hs || 0);
        o.write_shift(1, data.dt);
        o.write_shift(1, data.name.length);
        if (opts.biff >= 8) o.write_shift(1, 1);
        o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
        var out = o.slice(0, o.l);
        out.l = o.l;
        return out;
    }
    /* [MS-XLS] 2.4.265 TODO */ function parse_SST(blob, length) {
        var end = blob.l + length;
        var cnt = blob.read_shift(4);
        var ucnt = blob.read_shift(4);
        var strs = [];
        for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push(parse_XLUnicodeRichExtendedString(blob));
        strs.Count = cnt;
        strs.Unique = ucnt;
        return strs;
    }
    function write_SST(sst, opts) {
        var header = new_buf(8);
        header.write_shift(4, sst.Count);
        header.write_shift(4, sst.Unique);
        var strs = [];
        for(var j = 0; j < sst.length; ++j)strs[j] = write_XLUnicodeRichExtendedString(sst[j], opts);
        var o = bconcat([
            header
        ].concat(strs));
        o.parts = [
            header.length
        ].concat(strs.map(function(str) {
            return str.length;
        }));
        return o;
    }
    /* [MS-XLS] 2.4.107 */ function parse_ExtSST(blob, length) {
        var extsst = {};
        extsst.dsst = blob.read_shift(2);
        blob.l += length - 2;
        return extsst;
    }
    /* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function parse_Row(blob) {
        var z = {};
        z.r = blob.read_shift(2);
        z.c = blob.read_shift(2);
        z.cnt = blob.read_shift(2) - z.c;
        var miyRw = blob.read_shift(2);
        blob.l += 4; // reserved(2), unused(2)
        var flags = blob.read_shift(1); // various flags
        blob.l += 3; // reserved(8), ixfe(12), flags(4)
        if (flags & 0x07) z.level = flags & 0x07;
        // collapsed: flags & 0x10
        if (flags & 0x20) z.hidden = true;
        if (flags & 0x40) z.hpt = miyRw / 20;
        return z;
    }
    /* [MS-XLS] 2.4.125 */ function parse_ForceFullCalculation(blob) {
        var header = parse_frtHeader(blob);
        if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
        var fullcalc = blob.read_shift(4);
        return fullcalc !== 0x0;
    }
    /* [MS-XLS] 2.4.215 rt */ function parse_RecalcId(blob) {
        blob.read_shift(2);
        return blob.read_shift(4);
    }
    /* [MS-XLS] 2.4.87 */ function parse_DefaultRowHeight(blob, length, opts) {
        var f = 0;
        if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
        var miyRw = blob.read_shift(2);
        if (opts && opts.biff == 2) {
            f = 1 - (miyRw >> 15);
            miyRw &= 0x7fff;
        }
        var fl = {
            Unsynced: f & 1,
            DyZero: (f & 2) >> 1,
            ExAsc: (f & 4) >> 2,
            ExDsc: (f & 8) >> 3
        };
        return [
            fl,
            miyRw
        ];
    }
    /* [MS-XLS] 2.4.345 TODO */ function parse_Window1(blob) {
        var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
        var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
        var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
        return {
            Pos: [
                xWn,
                yWn
            ],
            Dim: [
                dxWn,
                dyWn
            ],
            Flags: flags,
            CurTab: iTabCur,
            FirstTab: iTabFirst,
            Selected: ctabSel,
            TabRatio: wTabRatio
        };
    }
    function write_Window1() {
        var o = new_buf(18);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0x7260);
        o.write_shift(2, 0x44c0);
        o.write_shift(2, 0x38);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 1);
        o.write_shift(2, 0x01f4);
        return o;
    }
    /* [MS-XLS] 2.4.346 TODO */ function parse_Window2(blob, length, opts) {
        if (opts && opts.biff >= 2 && opts.biff < 5) return {};
        var f = blob.read_shift(2);
        return {
            RTL: f & 0x40
        };
    }
    function write_Window2(view) {
        var o = new_buf(18), f = 0x6b6;
        if (view && view.RTL) f |= 0x40;
        o.write_shift(2, f);
        o.write_shift(4, 0);
        o.write_shift(4, 64);
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    /* [MS-XLS] 2.4.189 TODO */ function parse_Pane() {}
    /* [MS-XLS] 2.4.122 TODO */ function parse_Font(blob, length, opts) {
        var o = {
            dyHeight: blob.read_shift(2),
            fl: blob.read_shift(2)
        };
        switch(opts && opts.biff || 8){
            case 2:
                break;
            case 3:
            case 4:
                blob.l += 2;
                break;
            default:
                blob.l += 10;
                break;
        }
        o.name = parse_ShortXLUnicodeString(blob, 0, opts);
        return o;
    }
    function write_Font(data, opts) {
        var name = data.name || "Arial";
        var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
        var o = new_buf(w);
        o.write_shift(2, (data.sz || 12) * 20);
        o.write_shift(4, 0);
        o.write_shift(2, 400);
        o.write_shift(4, 0);
        o.write_shift(2, 0);
        o.write_shift(1, name.length);
        if (!b5) o.write_shift(1, 1);
        o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
        return o;
    }
    /* [MS-XLS] 2.4.149 */ function parse_LabelSst(blob) {
        var cell = parse_XLSCell(blob);
        cell.isst = blob.read_shift(4);
        return cell;
    }
    function write_LabelSst(R, C, v, os) {
        var o = new_buf(10);
        write_XLSCell(R, C, os, o);
        o.write_shift(4, v);
        return o;
    }
    /* [MS-XLS] 2.4.148 */ function parse_Label(blob, length, opts) {
        var target = blob.l + length;
        var cell = parse_XLSCell(blob, 6);
        if (opts.biff == 2) blob.l++;
        var str = parse_XLUnicodeString(blob, target - blob.l, opts);
        cell.val = str;
        return cell;
    }
    function write_Label(R, C, v, os, opts) {
        var b8 = !opts || opts.biff == 8;
        var o = new_buf(8 + +b8 + (1 + b8) * v.length);
        write_XLSCell(R, C, os, o);
        o.write_shift(2, v.length);
        if (b8) o.write_shift(1, 1);
        o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
        return o;
    }
    /* [MS-XLS] 2.4.126 Number Formats */ function parse_Format(blob, length, opts) {
        var numFmtId = blob.read_shift(2);
        var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
        return [
            numFmtId,
            fmtstr
        ];
    }
    function write_Format(i, f, opts, o) {
        var b5 = opts && opts.biff == 5;
        if (!o) o = new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
        o.write_shift(2, i);
        o.write_shift(b5 ? 1 : 2, f.length);
        if (!b5) o.write_shift(1, 1);
        o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? 'sbcs' : 'utf16le');
        var out = o.length > o.l ? o.slice(0, o.l) : o;
        if (out.l == null) out.l = out.length;
        return out;
    }
    var parse_BIFF2Format = parse_XLUnicodeString2;
    /* [MS-XLS] 2.4.90 */ function parse_Dimensions(blob, length, opts) {
        var end = blob.l + length;
        var w = opts.biff == 8 || !opts.biff ? 4 : 2;
        var r = blob.read_shift(w), R = blob.read_shift(w);
        var c = blob.read_shift(2), C = blob.read_shift(2);
        blob.l = end;
        return {
            s: {
                r: r,
                c: c
            },
            e: {
                r: R,
                c: C
            }
        };
    }
    function write_Dimensions(range, opts) {
        var w = opts.biff == 8 || !opts.biff ? 4 : 2;
        var o = new_buf(2 * w + 6);
        o.write_shift(w, range.s.r);
        o.write_shift(w, range.e.r + 1);
        o.write_shift(2, range.s.c);
        o.write_shift(2, range.e.c + 1);
        o.write_shift(2, 0);
        return o;
    }
    /* [MS-XLS] 2.4.220 */ function parse_RK(blob) {
        var rw = blob.read_shift(2), col = blob.read_shift(2);
        var rkrec = parse_RkRec(blob);
        return {
            r: rw,
            c: col,
            ixfe: rkrec[0],
            rknum: rkrec[1]
        };
    }
    /* [MS-XLS] 2.4.175 */ function parse_MulRk(blob, length) {
        var target = blob.l + length - 2;
        var rw = blob.read_shift(2), col = blob.read_shift(2);
        var rkrecs = [];
        while(blob.l < target)rkrecs.push(parse_RkRec(blob));
        if (blob.l !== target) throw new Error("MulRK read error");
        var lastcol = blob.read_shift(2);
        if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
        return {
            r: rw,
            c: col,
            C: lastcol,
            rkrec: rkrecs
        };
    }
    /* [MS-XLS] 2.4.174 */ function parse_MulBlank(blob, length) {
        var target = blob.l + length - 2;
        var rw = blob.read_shift(2), col = blob.read_shift(2);
        var ixfes = [];
        while(blob.l < target)ixfes.push(blob.read_shift(2));
        if (blob.l !== target) throw new Error("MulBlank read error");
        var lastcol = blob.read_shift(2);
        if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
        return {
            r: rw,
            c: col,
            C: lastcol,
            ixfe: ixfes
        };
    }
    /* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function parse_CellStyleXF(blob, length, style, opts) {
        var o = {};
        var a = blob.read_shift(4), b = blob.read_shift(4);
        var c = blob.read_shift(4), d = blob.read_shift(2);
        o.patternType = XLSFillPattern[c >> 26];
        if (!opts.cellStyles) return o;
        o.alc = a & 0x07;
        o.fWrap = a >> 3 & 0x01;
        o.alcV = a >> 4 & 0x07;
        o.fJustLast = a >> 7 & 0x01;
        o.trot = a >> 8 & 0xFF;
        o.cIndent = a >> 16 & 0x0F;
        o.fShrinkToFit = a >> 20 & 0x01;
        o.iReadOrder = a >> 22 & 0x02;
        o.fAtrNum = a >> 26 & 0x01;
        o.fAtrFnt = a >> 27 & 0x01;
        o.fAtrAlc = a >> 28 & 0x01;
        o.fAtrBdr = a >> 29 & 0x01;
        o.fAtrPat = a >> 30 & 0x01;
        o.fAtrProt = a >> 31 & 0x01;
        o.dgLeft = b & 0x0F;
        o.dgRight = b >> 4 & 0x0F;
        o.dgTop = b >> 8 & 0x0F;
        o.dgBottom = b >> 12 & 0x0F;
        o.icvLeft = b >> 16 & 0x7F;
        o.icvRight = b >> 23 & 0x7F;
        o.grbitDiag = b >> 30 & 0x03;
        o.icvTop = c & 0x7F;
        o.icvBottom = c >> 7 & 0x7F;
        o.icvDiag = c >> 14 & 0x7F;
        o.dgDiag = c >> 21 & 0x0F;
        o.icvFore = d & 0x7F;
        o.icvBack = d >> 7 & 0x7F;
        o.fsxButton = d >> 14 & 0x01;
        return o;
    }
    //function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
    //function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
    /* [MS-XLS] 2.4.353 TODO: actually do this right */ function parse_XF(blob, length, opts) {
        var o = {};
        o.ifnt = blob.read_shift(2);
        o.numFmtId = blob.read_shift(2);
        o.flags = blob.read_shift(2);
        o.fStyle = o.flags >> 2 & 0x01;
        length -= 6;
        o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
        return o;
    }
    function write_XF(data, ixfeP, opts, o) {
        var b5 = opts && opts.biff == 5;
        if (!o) o = new_buf(b5 ? 16 : 20);
        o.write_shift(2, 0);
        if (data.style) {
            o.write_shift(2, data.numFmtId || 0);
            o.write_shift(2, 0xFFF4);
        } else {
            o.write_shift(2, data.numFmtId || 0);
            o.write_shift(2, ixfeP << 4);
        }
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        if (!b5) o.write_shift(4, 0);
        o.write_shift(2, 0);
        return o;
    }
    /* [MS-XLS] 2.4.134 */ function parse_Guts(blob) {
        blob.l += 4;
        var out = [
            blob.read_shift(2),
            blob.read_shift(2)
        ];
        if (out[0] !== 0) out[0]--;
        if (out[1] !== 0) out[1]--;
        if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
        return out;
    }
    function write_Guts(guts) {
        var o = new_buf(8);
        o.write_shift(4, 0);
        o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
        o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
        return o;
    }
    /* [MS-XLS] 2.4.24 */ function parse_BoolErr(blob, length, opts) {
        var cell = parse_XLSCell(blob, 6);
        if (opts.biff == 2) ++blob.l;
        var val = parse_Bes(blob, 2);
        cell.val = val;
        cell.t = val === true || val === false ? 'b' : 'e';
        return cell;
    }
    function write_BoolErr(R, C, v, os, opts, t) {
        var o = new_buf(8);
        write_XLSCell(R, C, os, o);
        write_Bes(v, t, o);
        return o;
    }
    /* [MS-XLS] 2.4.180 Number */ function parse_Number(blob) {
        var cell = parse_XLSCell(blob, 6);
        var xnum = parse_Xnum(blob, 8);
        cell.val = xnum;
        return cell;
    }
    function write_Number(R, C, v, os) {
        var o = new_buf(14);
        write_XLSCell(R, C, os, o);
        write_Xnum(v, o);
        return o;
    }
    var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136
    /* [MS-XLS] 2.4.271 */ function parse_SupBook(blob, length, opts) {
        var end = blob.l + length;
        var ctab = blob.read_shift(2);
        var cch = blob.read_shift(2);
        opts.sbcch = cch;
        if (cch == 0x0401 || cch == 0x3A01) return [
            cch,
            ctab
        ];
        if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
        var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
        /* TODO: 2.5.277 Virtual Path */ var rgst = [];
        while(end > blob.l)rgst.push(parse_XLUnicodeString(blob));
        return [
            cch,
            ctab,
            virtPath,
            rgst
        ];
    }
    /* [MS-XLS] 2.4.105 TODO */ function parse_ExternName(blob, length, opts) {
        var flags = blob.read_shift(2);
        var body;
        var o = {
            fBuiltIn: flags & 0x01,
            fWantAdvise: flags >>> 1 & 0x01,
            fWantPict: flags >>> 2 & 0x01,
            fOle: flags >>> 3 & 0x01,
            fOleLink: flags >>> 4 & 0x01,
            cf: flags >>> 5 & 0x3FF,
            fIcon: flags >>> 15 & 0x01
        };
        if (opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length - 2, opts);
        //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
        o.body = body || blob.read_shift(length - 2);
        if (typeof body === "string") o.Name = body;
        return o;
    }
    /* [MS-XLS] 2.4.150 TODO */ var XLSLblBuiltIn = [
        "_xlnm.Consolidate_Area",
        "_xlnm.Auto_Open",
        "_xlnm.Auto_Close",
        "_xlnm.Extract",
        "_xlnm.Database",
        "_xlnm.Criteria",
        "_xlnm.Print_Area",
        "_xlnm.Print_Titles",
        "_xlnm.Recorder",
        "_xlnm.Data_Form",
        "_xlnm.Auto_Activate",
        "_xlnm.Auto_Deactivate",
        "_xlnm.Sheet_Title",
        "_xlnm._FilterDatabase"
    ];
    function parse_Lbl(blob, length, opts) {
        var target = blob.l + length;
        var flags = blob.read_shift(2);
        var chKey = blob.read_shift(1);
        var cch = blob.read_shift(1);
        var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
        var itab = 0;
        if (!opts || opts.biff >= 5) {
            if (opts.biff != 5) blob.l += 2;
            itab = blob.read_shift(2);
            if (opts.biff == 5) blob.l += 2;
            blob.l += 4;
        }
        var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
        if (flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
        var npflen = target - blob.l;
        if (opts && opts.biff == 2) --npflen;
        var rgce = target == blob.l || cce === 0 ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
        return {
            chKey: chKey,
            Name: name,
            itab: itab,
            rgce: rgce
        };
    }
    /* [MS-XLS] 2.4.106 TODO: verify filename encoding */ function parse_ExternSheet(blob, length, opts) {
        if (opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
        var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
        while(len-- !== 0)o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
        // [iSupBook, itabFirst, itabLast];
        if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
        return o;
    }
    function parse_BIFF5ExternSheet(blob, length, opts) {
        if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
        var o = parse_ShortXLUnicodeString(blob, length, opts);
        return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
    }
    /* [MS-XLS] 2.4.176 TODO: check older biff */ function parse_NameCmt(blob, length, opts) {
        if (opts.biff < 8) {
            blob.l += length;
            return;
        }
        var cchName = blob.read_shift(2);
        var cchComment = blob.read_shift(2);
        var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
        var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
        return [
            name,
            comment
        ];
    }
    /* [MS-XLS] 2.4.260 */ function parse_ShrFmla(blob, length, opts) {
        var ref = parse_RefU(blob, 6);
        blob.l++;
        var cUse = blob.read_shift(1);
        length -= 8;
        return [
            parse_SharedParsedFormula(blob, length, opts),
            cUse,
            ref
        ];
    }
    /* [MS-XLS] 2.4.4 TODO */ function parse_Array(blob, length, opts) {
        var ref = parse_Ref(blob, 6);
        /* TODO: fAlwaysCalc */ switch(opts.biff){
            case 2:
                blob.l++;
                length -= 7;
                break;
            case 3:
            case 4:
                blob.l += 2;
                length -= 8;
                break;
            default:
                blob.l += 6;
                length -= 12;
        }
        return [
            ref,
            parse_ArrayParsedFormula(blob, length, opts, ref)
        ];
    }
    /* [MS-XLS] 2.4.173 */ function parse_MTRSettings(blob) {
        var fMTREnabled = blob.read_shift(4) !== 0x00;
        var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
        var cUserThreadCount = blob.read_shift(4);
        return [
            fMTREnabled,
            fUserSetThreadCount,
            cUserThreadCount
        ];
    }
    /* [MS-XLS] 2.5.186 TODO: BIFF5 */ function parse_NoteSh(blob, length, opts) {
        if (opts.biff < 8) return;
        var row = blob.read_shift(2), col = blob.read_shift(2);
        var flags = blob.read_shift(2), idObj = blob.read_shift(2);
        var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
        if (opts.biff < 8) blob.read_shift(1);
        return [
            {
                r: row,
                c: col
            },
            stAuthor,
            idObj,
            flags
        ];
    }
    /* [MS-XLS] 2.4.179 */ function parse_Note(blob, length, opts) {
        /* TODO: Support revisions */ return parse_NoteSh(blob, length, opts);
    }
    /* [MS-XLS] 2.4.168 */ function parse_MergeCells(blob, length) {
        var merges = [];
        var cmcs = blob.read_shift(2);
        while(cmcs--)merges.push(parse_Ref8U(blob, length));
        return merges;
    }
    function write_MergeCells(merges) {
        var o = new_buf(2 + merges.length * 8);
        o.write_shift(2, merges.length);
        for(var i = 0; i < merges.length; ++i)write_Ref8U(merges[i], o);
        return o;
    }
    /* [MS-XLS] 2.4.181 TODO: parse all the things! */ function parse_Obj(blob, length, opts) {
        if (opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
        var cmo = parse_FtCmo(blob, 22); // id, ot, flags
        var fts = parse_FtArray(blob, length - 22, cmo[1]);
        return {
            cmo: cmo,
            ft: fts
        };
    }
    /* from older spec */ var parse_BIFF5OT = [];
    parse_BIFF5OT[0x08] = function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    };
    function parse_BIFF5Obj(blob, length, opts) {
        blob.l += 4; //var cnt = blob.read_shift(4);
        var ot = blob.read_shift(2);
        var id = blob.read_shift(2);
        var grbit = blob.read_shift(2);
        blob.l += 2; //var colL = blob.read_shift(2);
        blob.l += 2; //var dxL = blob.read_shift(2);
        blob.l += 2; //var rwT = blob.read_shift(2);
        blob.l += 2; //var dyT = blob.read_shift(2);
        blob.l += 2; //var colR = blob.read_shift(2);
        blob.l += 2; //var dxR = blob.read_shift(2);
        blob.l += 2; //var rwB = blob.read_shift(2);
        blob.l += 2; //var dyB = blob.read_shift(2);
        blob.l += 2; //var cbMacro = blob.read_shift(2);
        blob.l += 6;
        length -= 36;
        var fts = [];
        fts.push((parse_BIFF5OT[ot] || parsenoop)(blob, length, opts));
        return {
            cmo: [
                id,
                ot,
                grbit
            ],
            ft: fts
        };
    }
    /* [MS-XLS] 2.4.329 TODO: parse properly */ function parse_TxO(blob, length, opts) {
        var s = blob.l;
        var texts = "";
        try {
            blob.l += 4;
            var ot = (opts.lastobj || {
                cmo: [
                    0,
                    0
                ]
            }).cmo[1];
            var controlInfo; // eslint-disable-line no-unused-vars
            if ([
                0,
                5,
                7,
                11,
                12,
                14
            ].indexOf(ot) == -1) blob.l += 6;
            else controlInfo = parse_ControlInfo(blob, 6, opts);
            var cchText = blob.read_shift(2);
            /*var cbRuns = */ blob.read_shift(2);
            /*var ifntEmpty = */ parseuint16(blob, 2);
            var len = blob.read_shift(2);
            blob.l += len;
            //var fmla = parse_ObjFmla(blob, s + length - blob.l);
            for(var i = 1; i < blob.lens.length - 1; ++i){
                if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
                var hdr = blob[blob.l];
                var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
                texts += t;
                if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
            }
            if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
            blob.l = s + length;
            /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
            //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
            //	var cchText2 = blob.read_shift(2);
            //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
            //	blob.l += 6;
            //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
            return {
                t: texts
            };
        } catch (e) {
            blob.l = s + length;
            return {
                t: texts
            };
        }
    }
    /* [MS-XLS] 2.4.140 */ function parse_HLink(blob, length) {
        var ref = parse_Ref8U(blob, 8);
        blob.l += 16; /* CLSID */ 
        var hlink = parse_Hyperlink(blob, length - 24);
        return [
            ref,
            hlink
        ];
    }
    function write_HLink(hl) {
        var O = new_buf(24);
        var ref = decode_cell(hl[0]);
        O.write_shift(2, ref.r);
        O.write_shift(2, ref.r);
        O.write_shift(2, ref.c);
        O.write_shift(2, ref.c);
        var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
        return bconcat([
            O,
            write_Hyperlink(hl[1])
        ]);
    }
    /* [MS-XLS] 2.4.141 */ function parse_HLinkTooltip(blob, length) {
        blob.read_shift(2);
        var ref = parse_Ref8U(blob, 8);
        var wzTooltip = blob.read_shift((length - 10) / 2, 'dbcs-cont');
        wzTooltip = wzTooltip.replace(chr0, "");
        return [
            ref,
            wzTooltip
        ];
    }
    function write_HLinkTooltip(hl) {
        var TT = hl[1].Tooltip;
        var O = new_buf(10 + 2 * (TT.length + 1));
        O.write_shift(2, 0x0800);
        var ref = decode_cell(hl[0]);
        O.write_shift(2, ref.r);
        O.write_shift(2, ref.r);
        O.write_shift(2, ref.c);
        O.write_shift(2, ref.c);
        for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
        O.write_shift(2, 0);
        return O;
    }
    /* [MS-XLS] 2.4.63 */ function parse_Country(blob) {
        var o = [
            0,
            0
        ], d;
        d = blob.read_shift(2);
        o[0] = CountryEnum[d] || d;
        d = blob.read_shift(2);
        o[1] = CountryEnum[d] || d;
        return o;
    }
    function write_Country(o) {
        if (!o) o = new_buf(4);
        o.write_shift(2, 0x01);
        o.write_shift(2, 0x01);
        return o;
    }
    /* [MS-XLS] 2.4.50 ClrtClient */ function parse_ClrtClient(blob) {
        var ccv = blob.read_shift(2);
        var o = [];
        while(ccv-- > 0)o.push(parse_LongRGB(blob, 8));
        return o;
    }
    /* [MS-XLS] 2.4.188 */ function parse_Palette(blob) {
        var ccv = blob.read_shift(2);
        var o = [];
        while(ccv-- > 0)o.push(parse_LongRGB(blob, 8));
        return o;
    }
    /* [MS-XLS] 2.4.354 */ function parse_XFCRC(blob) {
        blob.l += 2;
        var o = {
            cxfs: 0,
            crc: 0
        };
        o.cxfs = blob.read_shift(2);
        o.crc = blob.read_shift(4);
        return o;
    }
    /* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function parse_ColInfo(blob, length, opts) {
        if (!opts.cellStyles) return parsenoop(blob, length);
        var w = opts && opts.biff >= 12 ? 4 : 2;
        var colFirst = blob.read_shift(w);
        var colLast = blob.read_shift(w);
        var coldx = blob.read_shift(w);
        var ixfe = blob.read_shift(w);
        var flags = blob.read_shift(2);
        if (w == 2) blob.l += 2;
        var o = {
            s: colFirst,
            e: colLast,
            w: coldx,
            ixfe: ixfe,
            flags: flags
        };
        if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
        return o;
    }
    /* [MS-XLS] 2.4.257 */ function parse_Setup(blob, length) {
        var o = {};
        if (length < 32) return o;
        blob.l += 16;
        o.header = parse_Xnum(blob, 8);
        o.footer = parse_Xnum(blob, 8);
        blob.l += 2;
        return o;
    }
    /* [MS-XLS] 2.4.261 */ function parse_ShtProps(blob, length, opts) {
        var def = {
            area: false
        };
        if (opts.biff != 5) {
            blob.l += length;
            return def;
        }
        var d = blob.read_shift(1);
        blob.l += 3;
        if (d & 0x10) def.area = true;
        return def;
    }
    /* [MS-XLS] 2.4.241 */ function write_RRTabId(n) {
        var out = new_buf(2 * n);
        for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
        return out;
    }
    var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
    var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
    var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
    /* --- Specific to versions before BIFF8 --- */ function parse_ImData(blob) {
        var cf = blob.read_shift(2);
        var env = blob.read_shift(2);
        var lcb = blob.read_shift(4);
        var o = {
            fmt: cf,
            env: env,
            len: lcb,
            data: blob.slice(blob.l, blob.l + lcb)
        };
        blob.l += lcb;
        return o;
    }
    /* BIFF2_??? where ??? is the name from [XLS] */ function parse_BIFF2STR(blob, length, opts) {
        var cell = parse_XLSCell(blob, 6);
        ++blob.l;
        var str = parse_XLUnicodeString2(blob, length - 7, opts);
        cell.t = 'str';
        cell.val = str;
        return cell;
    }
    function parse_BIFF2NUM(blob) {
        var cell = parse_XLSCell(blob, 6);
        ++blob.l;
        var num = parse_Xnum(blob, 8);
        cell.t = 'n';
        cell.val = num;
        return cell;
    }
    function write_BIFF2NUM(r, c, val) {
        var out = new_buf(15);
        write_BIFF2Cell(out, r, c);
        out.write_shift(8, val, 'f');
        return out;
    }
    function parse_BIFF2INT(blob) {
        var cell = parse_XLSCell(blob, 6);
        ++blob.l;
        var num = blob.read_shift(2);
        cell.t = 'n';
        cell.val = num;
        return cell;
    }
    function write_BIFF2INT(r, c, val) {
        var out = new_buf(9);
        write_BIFF2Cell(out, r, c);
        out.write_shift(2, val);
        return out;
    }
    function parse_BIFF2STRING(blob) {
        var cch = blob.read_shift(1);
        if (cch === 0) {
            blob.l++;
            return "";
        }
        return blob.read_shift(cch, 'sbcs-cont');
    }
    /* TODO: convert to BIFF8 font struct */ function parse_BIFF2FONTXTRA(blob, length) {
        blob.l += 6; // unknown
        blob.l += 2; // font weight "bls"
        blob.l += 1; // charset
        blob.l += 3; // unknown
        blob.l += 1; // font family
        blob.l += length - 13;
    }
    /* TODO: parse rich text runs */ function parse_RString(blob, length, opts) {
        var end = blob.l + length;
        var cell = parse_XLSCell(blob, 6);
        var cch = blob.read_shift(2);
        var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
        blob.l = end;
        cell.t = 'str';
        cell.val = str;
        return cell;
    }
    /* from js-harb (C) 2014-present  SheetJS */ var DBF = function() {
        var dbf_codepage_map = {
            /* Code Pages Supported by Visual FoxPro */ 0x01: 437,
            0x02: 850,
            0x03: 1252,
            0x04: 10000,
            0x64: 852,
            0x65: 866,
            0x66: 865,
            0x67: 861,
            0x68: 895,
            0x69: 620,
            0x6A: 737,
            0x6B: 857,
            0x78: 950,
            0x79: 949,
            0x7A: 936,
            0x7B: 932,
            0x7C: 874,
            0x7D: 1255,
            0x7E: 1256,
            0x96: 10007,
            0x97: 10029,
            0x98: 10006,
            0xC8: 1250,
            0xC9: 1251,
            0xCA: 1254,
            0xCB: 1253,
            /* shapefile DBF extension */ 0x00: 20127,
            0x08: 865,
            0x09: 437,
            0x0A: 850,
            0x0B: 437,
            0x0D: 437,
            0x0E: 850,
            0x0F: 437,
            0x10: 850,
            0x11: 437,
            0x12: 850,
            0x13: 932,
            0x14: 850,
            0x15: 437,
            0x16: 850,
            0x17: 865,
            0x18: 437,
            0x19: 437,
            0x1A: 850,
            0x1B: 437,
            0x1C: 863,
            0x1D: 850,
            0x1F: 852,
            0x22: 852,
            0x23: 852,
            0x24: 860,
            0x25: 850,
            0x26: 866,
            0x37: 850,
            0x40: 852,
            0x4D: 936,
            0x4E: 949,
            0x4F: 950,
            0x50: 874,
            0x57: 1252,
            0x58: 1252,
            0x59: 1252,
            0xFF: 16969
        };
        var dbf_reverse_map = evert({
            0x01: 437,
            0x02: 850,
            0x03: 1252,
            0x04: 10000,
            0x64: 852,
            0x65: 866,
            0x66: 865,
            0x67: 861,
            0x68: 895,
            0x69: 620,
            0x6A: 737,
            0x6B: 857,
            0x78: 950,
            0x79: 949,
            0x7A: 936,
            0x7B: 932,
            0x7C: 874,
            0x7D: 1255,
            0x7E: 1256,
            0x96: 10007,
            0x97: 10029,
            0x98: 10006,
            0xC8: 1250,
            0xC9: 1251,
            0xCA: 1254,
            0xCB: 1253,
            0x00: 20127
        });
        var DBF_SUPPORTED_VERSIONS = [
            0x02,
            0x03,
            0x30,
            0x31,
            0x83,
            0x8B,
            0x8C,
            0xF5
        ];
        /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) {
            var out = [];
            /* TODO: browser based */ var d = new_raw_buf(1);
            switch(opts.type){
                case 'base64':
                    d = s2a(Base64.decode(buf));
                    break;
                case 'binary':
                    d = s2a(buf);
                    break;
                case 'buffer':
                case 'array':
                    d = buf;
                    break;
            }
            prep_blob(d, 0);
            /* header */ var ft = d.read_shift(1);
            var memo = false;
            var vfp = false, l7 = false;
            switch(ft){
                case 0x02:
                case 0x03:
                    break;
                case 0x30:
                    vfp = true;
                    memo = true;
                    break;
                case 0x31:
                    vfp = true;
                    break;
                case 0x83:
                    memo = true;
                    break;
                case 0x8B:
                    memo = true;
                    break;
                case 0x8C:
                    memo = true;
                    l7 = true;
                    break;
                case 0xF5:
                    memo = true;
                    break;
                default:
                    throw new Error("DBF Unsupported Version: " + ft.toString(16));
            }
            var /*filedate = new Date(),*/ nrow = 0, fpos = 0;
            if (ft == 0x02) nrow = d.read_shift(2);
            /*filedate = new Date(d.read_shift(1) + 1900, d.read_shift(1) - 1, d.read_shift(1));*/ d.l += 3;
            if (ft != 0x02) nrow = d.read_shift(4);
            if (ft != 0x02) fpos = d.read_shift(2);
            var rlen = d.read_shift(2);
            var /*flags = 0,*/ current_cp = 1252;
            if (ft != 0x02) {
                d.l += 16;
                /*flags = */ d.read_shift(1);
                //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
                /* codepage present in FoxPro */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
                d.l += 1;
                d.l += 2;
            }
            if (l7) d.l += 36;
            var fields = [], field = {};
            var hend = fpos - 10 - (vfp ? 264 : 0), ww = l7 ? 32 : 11;
            while(ft == 0x02 ? d.l < d.length && d[d.l] != 0x0d : d.l < hend){
                field = {};
                field.name = cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)).replace(/[\u0000\r\n].*$/g, "");
                d.l += ww;
                field.type = String.fromCharCode(d.read_shift(1));
                if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
                field.len = d.read_shift(1);
                if (ft == 0x02) field.offset = d.read_shift(2);
                field.dec = d.read_shift(1);
                if (field.name.length) fields.push(field);
                if (ft != 0x02) d.l += l7 ? 13 : 14;
                switch(field.type){
                    case 'B':
                        if ((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                        break;
                    case 'G':
                    case 'P':
                        if (opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                        break;
                    case 'C':
                    case 'D':
                    case 'F':
                    case 'I':
                    case 'L':
                    case 'M':
                    case 'N':
                    case 'O':
                    case 'T':
                    case 'Y':
                    case '0':
                    case '@':
                    case '+':
                        break;
                    default:
                        throw new Error('Unknown Field Type: ' + field.type);
                }
            }
            if (d[d.l] !== 0x0D) d.l = fpos - 1;
            else if (ft == 0x02) d.l = 0x209;
            if (ft != 0x02) {
                if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
                d.l = fpos;
            }
            /* data */ var R = 0, C = 0;
            out[0] = [];
            for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
            while(nrow-- > 0){
                if (d[d.l] === 0x2A) {
                    d.l += rlen;
                    continue;
                }
                ++d.l;
                out[++R] = [];
                C = 0;
                for(C = 0; C != fields.length; ++C){
                    var dd = d.slice(d.l, d.l + fields[C].len);
                    d.l += fields[C].len;
                    prep_blob(dd, 0);
                    var s = cptable.utils.decode(current_cp, dd);
                    switch(fields[C].type){
                        case 'C':
                            out[R][C] = cptable.utils.decode(current_cp, dd);
                            out[R][C] = out[R][C].trim();
                            break;
                        case 'D':
                            if (s.length === 8) out[R][C] = new Date(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8));
                            else out[R][C] = s;
                            break;
                        case 'F':
                            out[R][C] = parseFloat(s.trim());
                            break;
                        case '+':
                        case 'I':
                            out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i');
                            break;
                        case 'L':
                            switch(s.toUpperCase()){
                                case 'Y':
                                case 'T':
                                    out[R][C] = true;
                                    break;
                                case 'N':
                                case 'F':
                                    out[R][C] = false;
                                    break;
                                case ' ':
                                case '?':
                                    out[R][C] = false;
                                    break; /* NOTE: technically uninitialized */ 
                                default:
                                    throw new Error("DBF Unrecognized L:|" + s + "|");
                            }
                            break;
                        case 'M':
                            /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                            out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                            break;
                        case 'N':
                            out[R][C] = +s.replace(/\u0000/g, "").trim();
                            break;
                        case '@':
                            out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
                            break;
                        case 'T':
                            out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4));
                            break;
                        case 'Y':
                            out[R][C] = dd.read_shift(4, 'i') / 1e4;
                            break;
                        case 'O':
                            out[R][C] = -dd.read_shift(-8, 'f');
                            break;
                        case 'B':
                            if (vfp && fields[C].len == 8) {
                                out[R][C] = dd.read_shift(8, 'f');
                                break;
                            }
                        /* falls through */ case 'G':
                        case 'P':
                            dd.l += fields[C].len;
                            break;
                        case '0':
                            if (fields[C].name === '_NullFlags') break;
                        /* falls through */ default:
                            throw new Error("DBF Unsupported data type " + fields[C].type);
                    }
                }
            }
            if (ft != 0x02) {
                if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
            }
            if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
            return out;
        }
        function dbf_to_sheet(buf, opts) {
            var o = opts || {};
            if (!o.dateNF) o.dateNF = "yyyymmdd";
            return aoa_to_sheet(dbf_to_aoa(buf, o), o);
        }
        function dbf_to_workbook(buf, opts) {
            try {
                return sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
            } catch (e) {
                if (opts && opts.WTF) throw e;
            }
            return {
                SheetNames: [],
                Sheets: {}
            };
        }
        var _RLEN = {
            'B': 8,
            'C': 250,
            'L': 1,
            'D': 8,
            '?': 0,
            '': 0
        };
        function sheet_to_dbf(ws, opts) {
            var o = opts || {};
            if (+o.codepage >= 0) set_cp(+o.codepage);
            if (o.type == "string") throw new Error("Cannot write DBF to JS string");
            var ba = buf_array();
            var aoa = sheet_to_json(ws, {
                header: 1,
                raw: true,
                cellDates: true
            });
            var headers = aoa[0], data = aoa.slice(1);
            var i = 0, j = 0, hcnt = 0, rlen = 1;
            for(i = 0; i < headers.length; ++i){
                if (i == null) continue;
                ++hcnt;
                if (typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
                if (typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
                if (headers.indexOf(headers[i]) !== i) {
                    for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                        headers[i] += "_" + j;
                        break;
                    }
                }
            }
            var range = safe_decode_range(ws['!ref']);
            var coltypes = [];
            for(i = 0; i <= range.e.c - range.s.c; ++i){
                var col = [];
                for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
                if (col.length == 0 || headers[i] == null) {
                    coltypes[i] = '?';
                    continue;
                }
                var guess = '', _guess = '';
                for(j = 0; j < col.length; ++j){
                    switch(typeof col[j]){
                        /* TODO: check if L2 compat is desired */ case 'number':
                            _guess = 'B';
                            break;
                        case 'string':
                            _guess = 'C';
                            break;
                        case 'boolean':
                            _guess = 'L';
                            break;
                        case 'object':
                            _guess = col[j] instanceof Date ? 'D' : 'C';
                            break;
                        default:
                            _guess = 'C';
                    }
                    guess = guess && guess != _guess ? 'C' : _guess;
                    if (guess == 'C') break;
                }
                rlen += _RLEN[guess] || 0;
                coltypes[i] = guess;
            }
            var h = ba.next(32);
            h.write_shift(4, 0x13021130);
            h.write_shift(4, data.length);
            h.write_shift(2, 296 + 32 * hcnt);
            h.write_shift(2, rlen);
            for(i = 0; i < 4; ++i)h.write_shift(4, 0);
            h.write_shift(4, 0x00000000 | (+dbf_reverse_map[current_ansi] || 0x03) << 8);
            for(i = 0, j = 0; i < headers.length; ++i){
                if (headers[i] == null) continue;
                var hf = ba.next(32);
                var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
                hf.write_shift(1, _f, "sbcs");
                hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
                hf.write_shift(4, j);
                hf.write_shift(1, _RLEN[coltypes[i]] || 0);
                hf.write_shift(1, 0);
                hf.write_shift(1, 0x02);
                hf.write_shift(4, 0);
                hf.write_shift(1, 0);
                hf.write_shift(4, 0);
                hf.write_shift(4, 0);
                j += _RLEN[coltypes[i]] || 0;
            }
            var hb = ba.next(264);
            hb.write_shift(4, 0x0000000D);
            for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
            for(i = 0; i < data.length; ++i){
                var rout = ba.next(rlen);
                rout.write_shift(1, 0);
                for(j = 0; j < headers.length; ++j){
                    if (headers[j] == null) continue;
                    switch(coltypes[j]){
                        case 'L':
                            rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                            break;
                        case 'B':
                            rout.write_shift(8, data[i][j] || 0, 'f');
                            break;
                        case 'D':
                            if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                            else {
                                rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                                rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                                rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                            }
                            break;
                        case 'C':
                            var _s = String(data[i][j] || "");
                            rout.write_shift(1, _s, "sbcs");
                            for(hcnt = 0; hcnt < 250 - _s.length; ++hcnt)rout.write_shift(1, 0x20);
                            break;
                    }
                }
            // data
            }
            ba.next(1).write_shift(1, 0x1A);
            return ba.end();
        }
        return {
            versions: DBF_SUPPORTED_VERSIONS,
            to_workbook: dbf_to_workbook,
            to_sheet: dbf_to_sheet,
            from_sheet: sheet_to_dbf
        };
    }();
    var SYLK = function() {
        /* TODO: stress test sequences */ var sylk_escapes = {
            AA: "\xc0",
            BA: "\xc1",
            CA: "\xc2",
            DA: 195,
            HA: "\xc4",
            JA: 197,
            AE: "\xc8",
            BE: "\xc9",
            CE: "\xca",
            HE: "\xcb",
            AI: "\xcc",
            BI: "\xcd",
            CI: "\xce",
            HI: "\xcf",
            AO: "\xd2",
            BO: "\xd3",
            CO: "\xd4",
            DO: 213,
            HO: "\xd6",
            AU: "\xd9",
            BU: "\xda",
            CU: "\xdb",
            HU: "\xdc",
            Aa: "\xe0",
            Ba: "\xe1",
            Ca: "\xe2",
            Da: 227,
            Ha: "\xe4",
            Ja: 229,
            Ae: "\xe8",
            Be: "\xe9",
            Ce: "\xea",
            He: "\xeb",
            Ai: "\xec",
            Bi: "\xed",
            Ci: "\xee",
            Hi: "\xef",
            Ao: "\xf2",
            Bo: "\xf3",
            Co: "\xf4",
            Do: 245,
            Ho: "\xf6",
            Au: "\xf9",
            Bu: "\xfa",
            Cu: "\xfb",
            Hu: "\xfc",
            KC: "\xc7",
            Kc: "\xe7",
            q: "\xe6",
            z: "\u0153",
            a: "\xc6",
            j: "\u0152",
            DN: 209,
            Dn: 241,
            Hy: 255,
            S: 169,
            c: 170,
            R: 174,
            B: 180,
            0: 176,
            1: 177,
            2: 178,
            3: 179,
            5: 181,
            6: 182,
            7: 183,
            Q: 185,
            k: 186,
            b: 208,
            i: 216,
            l: 222,
            s: 240,
            y: 248,
            "!": 161,
            '"': 162,
            "#": 163,
            "(": 164,
            "%": 165,
            "'": 167,
            "H ": 168,
            "+": 171,
            ";": 187,
            "<": 188,
            "=": 189,
            ">": 190,
            "?": 191,
            "{": 223
        };
        var sylk_char_regex = new RegExp("\u001BN(" + keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
        var sylk_char_fn = function(_, $1) {
            var o = sylk_escapes[$1];
            return typeof o == "number" ? _getansi(o) : o;
        };
        var decode_sylk_char = function($$, $1, $2) {
            var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
            return newcc == 59 ? $$ : _getansi(newcc);
        };
        sylk_escapes["|"] = 254;
        /* TODO: find an actual specification */ function sylk_to_aoa(d, opts) {
            switch(opts.type){
                case 'base64':
                    return sylk_to_aoa_str(Base64.decode(d), opts);
                case 'binary':
                    return sylk_to_aoa_str(d, opts);
                case 'buffer':
                    return sylk_to_aoa_str(d.toString('binary'), opts);
                case 'array':
                    return sylk_to_aoa_str(cc2str(d), opts);
            }
            throw new Error("Unrecognized type " + opts.type);
        }
        function sylk_to_aoa_str(str, opts) {
            var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
            var formats = [];
            var next_cell_format = null;
            var sht = {}, rowinfo = [], colinfo = [], cw = [];
            var Mval = 0, j;
            if (+opts.codepage >= 0) set_cp(+opts.codepage);
            for(; ri !== records.length; ++ri){
                Mval = 0;
                var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
                var record = rstr.replace(/;;/g, "\u0000").split(";").map(function(x) {
                    return x.replace(/\u0000/g, ";");
                });
                var RT = record[0], val;
                if (rstr.length > 0) switch(RT){
                    case 'ID':
                        break; /* header */ 
                    case 'E':
                        break; /* EOF */ 
                    case 'B':
                        break; /* dimensions */ 
                    case 'O':
                        break; /* options? */ 
                    case 'P':
                        if (record[1].charAt(0) == 'P') formats.push(rstr.slice(3).replace(/;;/g, ";"));
                        break;
                    case 'C':
                        var C_seen_K = false, C_seen_X = false;
                        for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                            case 'X':
                                C = parseInt(record[rj].slice(1)) - 1;
                                C_seen_X = true;
                                break;
                            case 'Y':
                                R = parseInt(record[rj].slice(1)) - 1;
                                if (!C_seen_X) C = 0;
                                for(j = arr.length; j <= R; ++j)arr[j] = [];
                                break;
                            case 'K':
                                val = record[rj].slice(1);
                                if (val.charAt(0) === '"') val = val.slice(1, val.length - 1);
                                else if (val === 'TRUE') val = true;
                                else if (val === 'FALSE') val = false;
                                else if (!isNaN(fuzzynum(val))) {
                                    val = fuzzynum(val);
                                    if (next_cell_format !== null && SSF.is_date(next_cell_format)) val = numdate(val);
                                } else if (!isNaN(fuzzydate(val).getDate())) val = parseDate(val);
                                if (typeof cptable !== 'undefined' && typeof val == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val = cptable.utils.decode(opts.codepage, val);
                                C_seen_K = true;
                                break;
                            case 'E':
                                var formula = rc_to_a1(record[rj].slice(1), {
                                    r: R,
                                    c: C
                                });
                                arr[R][C] = [
                                    arr[R][C],
                                    formula
                                ];
                                break;
                            default:
                                if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                        }
                        if (C_seen_K) {
                            arr[R][C] = val;
                            next_cell_format = null;
                        }
                        break;
                    case 'F':
                        var F_seen = 0;
                        for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                            case 'X':
                                C = parseInt(record[rj].slice(1)) - 1;
                                ++F_seen;
                                break;
                            case 'Y':
                                R = parseInt(record[rj].slice(1)) - 1; /*C = 0;*/ 
                                for(j = arr.length; j <= R; ++j)arr[j] = [];
                                break;
                            case 'M':
                                Mval = parseInt(record[rj].slice(1)) / 20;
                                break;
                            case 'F':
                                break; /* ??? */ 
                            case 'G':
                                break; /* hide grid */ 
                            case 'P':
                                next_cell_format = formats[parseInt(record[rj].slice(1))];
                                break;
                            case 'S':
                                break; /* cell style */ 
                            case 'D':
                                break; /* column */ 
                            case 'N':
                                break; /* font */ 
                            case 'W':
                                cw = record[rj].slice(1).split(" ");
                                for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                    Mval = parseInt(cw[2], 10);
                                    colinfo[j - 1] = Mval === 0 ? {
                                        hidden: true
                                    } : {
                                        wch: Mval
                                    };
                                    process_col(colinfo[j - 1]);
                                }
                                break;
                            case 'C':
                                /* default column format */ C = parseInt(record[rj].slice(1)) - 1;
                                if (!colinfo[C]) colinfo[C] = {};
                                break;
                            case 'R':
                                /* row properties */ R = parseInt(record[rj].slice(1)) - 1;
                                if (!rowinfo[R]) rowinfo[R] = {};
                                if (Mval > 0) {
                                    rowinfo[R].hpt = Mval;
                                    rowinfo[R].hpx = pt2px(Mval);
                                } else if (Mval === 0) rowinfo[R].hidden = true;
                                break;
                            default:
                                if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                        }
                        if (F_seen < 1) next_cell_format = null;
                        break;
                    default:
                        if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                }
            }
            if (rowinfo.length > 0) sht['!rows'] = rowinfo;
            if (colinfo.length > 0) sht['!cols'] = colinfo;
            if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
            return [
                arr,
                sht
            ];
        }
        function sylk_to_sheet(d, opts) {
            var aoasht = sylk_to_aoa(d, opts);
            var aoa = aoasht[0], ws = aoasht[1];
            var o = aoa_to_sheet(aoa, opts);
            keys(ws).forEach(function(k) {
                o[k] = ws[k];
            });
            return o;
        }
        function sylk_to_workbook(d, opts) {
            return sheet_to_workbook(sylk_to_sheet(d, opts), opts);
        }
        function write_ws_cell_sylk(cell, ws, R, C) {
            var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
            switch(cell.t){
                case 'n':
                    o += cell.v || 0;
                    if (cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {
                        r: R,
                        c: C
                    });
                    break;
                case 'b':
                    o += cell.v ? "TRUE" : "FALSE";
                    break;
                case 'e':
                    o += cell.w || cell.v;
                    break;
                case 'd':
                    o += '"' + (cell.w || cell.v) + '"';
                    break;
                case 's':
                    o += '"' + cell.v.replace(/"/g, "") + '"';
                    break;
            }
            return o;
        }
        function write_ws_cols_sylk(out, cols) {
            cols.forEach(function(col, i) {
                var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
                if (col.hidden) rec += "0";
                else {
                    if (typeof col.width == 'number') col.wpx = width2px(col.width);
                    if (typeof col.wpx == 'number') col.wch = px2char(col.wpx);
                    if (typeof col.wch == 'number') rec += Math.round(col.wch);
                }
                if (rec.charAt(rec.length - 1) != " ") out.push(rec);
            });
        }
        function write_ws_rows_sylk(out, rows) {
            rows.forEach(function(row, i) {
                var rec = "F;";
                if (row.hidden) rec += "M0;";
                else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
                else if (row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
                if (rec.length > 2) out.push(rec + "R" + (i + 1));
            });
        }
        function sheet_to_sylk(ws, opts) {
            var preamble = [
                "ID;PWXL;N;E"
            ], o = [];
            var r = safe_decode_range(ws['!ref']), cell;
            var dense = Array.isArray(ws);
            var RS = "\r\n";
            preamble.push("P;PGeneral");
            preamble.push("F;P0;DG0G8;M255");
            if (ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
            if (ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
            preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
                r.s.c,
                r.s.r,
                r.e.c,
                r.e.r
            ].join(" "));
            for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws[R] || [])[C] : ws[coord];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
            }
            return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
        }
        return {
            to_workbook: sylk_to_workbook,
            to_sheet: sylk_to_sheet,
            from_sheet: sheet_to_sylk
        };
    }();
    var DIF = function() {
        function dif_to_aoa(d, opts) {
            switch(opts.type){
                case 'base64':
                    return dif_to_aoa_str(Base64.decode(d), opts);
                case 'binary':
                    return dif_to_aoa_str(d, opts);
                case 'buffer':
                    return dif_to_aoa_str(d.toString('binary'), opts);
                case 'array':
                    return dif_to_aoa_str(cc2str(d), opts);
            }
            throw new Error("Unrecognized type " + opts.type);
        }
        function dif_to_aoa_str(str, opts) {
            var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
            for(; ri !== records.length; ++ri){
                if (records[ri].trim() === 'BOT') {
                    arr[++R] = [];
                    C = 0;
                    continue;
                }
                if (R < 0) continue;
                var metadata = records[ri].trim().split(",");
                var type = metadata[0], value = metadata[1];
                ++ri;
                var data = records[ri].trim();
                switch(+type){
                    case -1:
                        if (data === 'BOT') {
                            arr[++R] = [];
                            C = 0;
                            continue;
                        } else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
                        break;
                    case 0:
                        if (data === 'TRUE') arr[R][C] = true;
                        else if (data === 'FALSE') arr[R][C] = false;
                        else if (!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
                        else if (!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
                        else arr[R][C] = value;
                        ++C;
                        break;
                    case 1:
                        data = data.slice(1, data.length - 1);
                        arr[R][C++] = data !== '' ? data : null;
                        break;
                }
                if (data === 'EOD') break;
            }
            if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
            return arr;
        }
        function dif_to_sheet(str, opts) {
            return aoa_to_sheet(dif_to_aoa(str, opts), opts);
        }
        function dif_to_workbook(str, opts) {
            return sheet_to_workbook(dif_to_sheet(str, opts), opts);
        }
        var sheet_to_dif = function() {
            var push_field = function pf(o, topic, v, n, s) {
                o.push(topic);
                o.push(v + "," + n);
                o.push('"' + s.replace(/"/g, '""') + '"');
            };
            var push_value = function po(o, type, v, s) {
                o.push(type + "," + v);
                o.push(type == 1 ? '"' + s.replace(/"/g, '""') + '"' : s);
            };
            return function sheet_to_dif(ws) {
                var o = [];
                var r = safe_decode_range(ws['!ref']), cell;
                var dense = Array.isArray(ws);
                push_field(o, "TABLE", 0, 1, "sheetjs");
                push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1, "");
                push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1, "");
                push_field(o, "DATA", 0, 0, "");
                for(var R = r.s.r; R <= r.e.r; ++R){
                    push_value(o, -1, 0, "BOT");
                    for(var C = r.s.c; C <= r.e.c; ++C){
                        var coord = encode_cell({
                            r: R,
                            c: C
                        });
                        cell = dense ? (ws[R] || [])[C] : ws[coord];
                        if (!cell) {
                            push_value(o, 1, 0, "");
                            continue;
                        }
                        switch(cell.t){
                            case 'n':
                                var val = DIF_XL ? cell.w : cell.v;
                                if (!val && cell.v != null) val = cell.v;
                                if (val == null) {
                                    if (DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
                                    else push_value(o, 1, 0, "");
                                } else push_value(o, 0, val, "V");
                                break;
                            case 'b':
                                push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
                                break;
                            case 's':
                                push_value(o, 1, 0, !DIF_XL || isNaN(cell.v) ? cell.v : '="' + cell.v + '"');
                                break;
                            case 'd':
                                if (!cell.w) cell.w = SSF.format(cell.z || SSF._table[14], datenum(parseDate(cell.v)));
                                if (DIF_XL) push_value(o, 0, cell.w, "V");
                                else push_value(o, 1, 0, cell.w);
                                break;
                            default:
                                push_value(o, 1, 0, "");
                        }
                    }
                }
                push_value(o, -1, 0, "EOD");
                var RS = "\r\n";
                var oo = o.join(RS);
                //while((oo.length & 0x7F) != 0) oo += "\0";
                return oo;
            };
        }();
        return {
            to_workbook: dif_to_workbook,
            to_sheet: dif_to_sheet,
            from_sheet: sheet_to_dif
        };
    }();
    var ETH = function() {
        function decode(s) {
            return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
        }
        function encode(s) {
            return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
        }
        function eth_to_aoa(str, opts) {
            var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
            for(; ri !== records.length; ++ri){
                var record = records[ri].trim().split(":");
                if (record[0] !== 'cell') continue;
                var addr = decode_cell(record[1]);
                if (arr.length <= addr.r) {
                    for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
                }
                R = addr.r;
                C = addr.c;
                switch(record[2]){
                    case 't':
                        arr[R][C] = decode(record[3]);
                        break;
                    case 'v':
                        arr[R][C] = +record[3];
                        break;
                    case 'vtf':
                        var _f = record[record.length - 1];
                    /* falls through */ case 'vtc':
                        switch(record[3]){
                            case 'nl':
                                arr[R][C] = +record[4] ? true : false;
                                break;
                            default:
                                arr[R][C] = +record[4];
                                break;
                        }
                        if (record[2] == 'vtf') arr[R][C] = [
                            arr[R][C],
                            _f
                        ];
                }
            }
            if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
            return arr;
        }
        function eth_to_sheet(d, opts) {
            return aoa_to_sheet(eth_to_aoa(d, opts), opts);
        }
        function eth_to_workbook(d, opts) {
            return sheet_to_workbook(eth_to_sheet(d, opts), opts);
        }
        var header = [
            "socialcalc:version:1.5",
            "MIME-Version: 1.0",
            "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
        ].join("\n");
        var sep = [
            "--SocialCalcSpreadsheetControlSave",
            "Content-type: text/plain; charset=UTF-8"
        ].join("\n") + "\n";
        /* TODO: the other parts */ var meta = [
            "# SocialCalc Spreadsheet Control Save",
            "part:sheet"
        ].join("\n");
        var end = "--SocialCalcSpreadsheetControlSave--";
        function sheet_to_eth_data(ws) {
            if (!ws || !ws['!ref']) return "";
            var o = [], oo = [], cell, coord = "";
            var r = decode_range(ws['!ref']);
            var dense = Array.isArray(ws);
            for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
                coord = encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws[R] || [])[C] : ws[coord];
                if (!cell || cell.v == null || cell.t === 'z') continue;
                oo = [
                    "cell",
                    coord,
                    't'
                ];
                switch(cell.t){
                    case 's':
                    case 'str':
                        oo.push(encode(cell.v));
                        break;
                    case 'n':
                        if (!cell.f) {
                            oo[2] = 'v';
                            oo[3] = cell.v;
                        } else {
                            oo[2] = 'vtf';
                            oo[3] = 'n';
                            oo[4] = cell.v;
                            oo[5] = encode(cell.f);
                        }
                        break;
                    case 'b':
                        oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                        oo[3] = 'nl';
                        oo[4] = cell.v ? "1" : "0";
                        oo[5] = encode(cell.f || (cell.v ? 'TRUE' : 'FALSE'));
                        break;
                    case 'd':
                        var t = datenum(parseDate(cell.v));
                        oo[2] = 'vtc';
                        oo[3] = 'nd';
                        oo[4] = "" + t;
                        oo[5] = cell.w || SSF.format(cell.z || SSF._table[14], t);
                        break;
                    case 'e':
                        continue;
                }
                o.push(oo.join(":"));
            }
            o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
            o.push("valueformat:1:text-wiki");
            //o.push("copiedfrom:" + ws['!ref']); // clipboard only
            return o.join("\n");
        }
        function sheet_to_eth(ws) {
            return [
                header,
                sep,
                meta,
                sep,
                sheet_to_eth_data(ws),
                end
            ].join("\n");
        // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
        }
        return {
            to_workbook: eth_to_workbook,
            to_sheet: eth_to_sheet,
            from_sheet: sheet_to_eth
        };
    }();
    var PRN = function() {
        function set_text_arr(data, arr, R, C, o) {
            if (o.raw) arr[R][C] = data;
            else if (data === 'TRUE') arr[R][C] = true;
            else if (data === 'FALSE') arr[R][C] = false;
            else if (data === "") ;
            else if (!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
            else if (!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
            else arr[R][C] = data;
        }
        function prn_to_aoa_str(f, opts) {
            var o = opts || {};
            var arr = [];
            if (!f || f.length === 0) return arr;
            var lines = f.split(/[\r\n]/);
            var L = lines.length - 1;
            while(L >= 0 && lines[L].length === 0)--L;
            var start = 10, idx = 0;
            var R = 0;
            for(; R <= L; ++R){
                idx = lines[R].indexOf(" ");
                if (idx == -1) idx = lines[R].length;
                else idx++;
                start = Math.max(start, idx);
            }
            for(R = 0; R <= L; ++R){
                arr[R] = [];
                /* TODO: confirm that widths are always 10 */ var C = 0;
                set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
                for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
            }
            if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
            return arr;
        }
        // List of accepted CSV separators
        var guess_seps = {
            0x2C: ',',
            0x09: "\t",
            0x3B: ';'
        };
        // CSV separator weights to be used in case of equal numbers
        var guess_sep_weights = {
            0x2C: 3,
            0x09: 2,
            0x3B: 1
        };
        function guess_sep(str) {
            var cnt = {}, instr = false, end = 0, cc = 0;
            for(; end < str.length; ++end){
                if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
                else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
            }
            cc = [];
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
            if (!cc.length) {
                cnt = guess_sep_weights;
                for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                    cnt[end],
                    end
                ]);
            }
            cc.sort(function(a, b) {
                return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
            });
            return guess_seps[cc.pop()[1]];
        }
        function dsv_to_sheet_str(str, opts) {
            var o = opts || {};
            var sep = "";
            if (DENSE != null && o.dense == null) o.dense = DENSE;
            var ws = o.dense ? [] : {};
            var range = {
                s: {
                    c: 0,
                    r: 0
                },
                e: {
                    c: 0,
                    r: 0
                }
            };
            if (str.slice(0, 4) == "sep=") {
                // If the line ends in \r\n
                if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                    sep = str.charAt(4);
                    str = str.slice(7);
                } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                    //
                    sep = str.charAt(4);
                    str = str.slice(6);
                }
            } else sep = guess_sep(str.slice(0, 1024));
            var R = 0, C = 0, v = 0;
            var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0;
            str = str.replace(/\r\n/mg, "\n");
            var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
            function finish_cell() {
                var s = str.slice(start, end);
                var cell = {};
                if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
                if (s.length === 0) cell.t = 'z';
                else if (o.raw) {
                    cell.t = 's';
                    cell.v = s;
                } else if (s.trim().length === 0) {
                    cell.t = 's';
                    cell.v = s;
                } else if (s.charCodeAt(0) == 0x3D) {
                    if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                        cell.t = 's';
                        cell.v = s.slice(2, -1).replace(/""/g, '"');
                    } else if (fuzzyfmla(s)) {
                        cell.t = 'n';
                        cell.f = s.slice(1);
                    } else {
                        cell.t = 's';
                        cell.v = s;
                    }
                } else if (s == "TRUE") {
                    cell.t = 'b';
                    cell.v = true;
                } else if (s == "FALSE") {
                    cell.t = 'b';
                    cell.v = false;
                } else if (!isNaN(v = fuzzynum(s))) {
                    cell.t = 'n';
                    if (o.cellText !== false) cell.w = s;
                    cell.v = v;
                } else if (!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
                    cell.z = o.dateNF || SSF._table[14];
                    var k = 0;
                    if (_re && s.match(_re)) {
                        s = dateNF_fix(s, o.dateNF, s.match(_re) || []);
                        k = 1;
                    }
                    if (o.cellDates) {
                        cell.t = 'd';
                        cell.v = parseDate(s, k);
                    } else {
                        cell.t = 'n';
                        cell.v = datenum(parseDate(s, k));
                    }
                    if (o.cellText !== false) cell.w = SSF.format(cell.z, cell.v instanceof Date ? datenum(cell.v) : cell.v);
                    if (!o.cellNF) delete cell.z;
                } else {
                    cell.t = 's';
                    cell.v = s;
                }
                if (cell.t == 'z') ;
                else if (o.dense) {
                    if (!ws[R]) ws[R] = [];
                    ws[R][C] = cell;
                } else ws[encode_cell({
                    c: C,
                    r: R
                })] = cell;
                start = end + 1;
                if (range.e.c < C) range.e.c = C;
                if (range.e.r < R) range.e.r = R;
                if (cc == sepcc) ++C;
                else {
                    C = 0;
                    ++R;
                    if (o.sheetRows && o.sheetRows <= R) return true;
                }
            }
            outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
                case 0x22:
                    instr = !instr;
                    break;
                case sepcc:
                case 0x0a:
                case 0x0d:
                    if (!instr && finish_cell()) break outer;
                    break;
                default:
                    break;
            }
            if (end - start > 0) finish_cell();
            ws['!ref'] = encode_range(range);
            return ws;
        }
        function prn_to_sheet_str(str, opts) {
            if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
            if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
            if (str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
            return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
        }
        function prn_to_sheet(d, opts) {
            var str = "", bytes = opts.type == 'string' ? [
                0,
                0,
                0,
                0
            ] : firstbyte(d, opts);
            switch(opts.type){
                case 'base64':
                    str = Base64.decode(d);
                    break;
                case 'binary':
                    str = d;
                    break;
                case 'buffer':
                    if (opts.codepage == 65001) str = d.toString('utf8');
                    else if (opts.codepage && typeof cptable !== 'undefined') str = cptable.utils.decode(opts.codepage, d);
                    else str = d.toString('binary');
                    break;
                case 'array':
                    str = cc2str(d);
                    break;
                case 'string':
                    str = d;
                    break;
                default:
                    throw new Error("Unrecognized type " + opts.type);
            }
            if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
            else if (opts.type == 'binary' && typeof cptable !== 'undefined' && opts.codepage) str = cptable.utils.decode(opts.codepage, cptable.utils.encode(1252, str));
            if (str.slice(0, 19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
            return prn_to_sheet_str(str, opts);
        }
        function prn_to_workbook(d, opts) {
            return sheet_to_workbook(prn_to_sheet(d, opts), opts);
        }
        function sheet_to_prn(ws) {
            var o = [];
            var r = safe_decode_range(ws['!ref']), cell;
            var dense = Array.isArray(ws);
            for(var R = r.s.r; R <= r.e.r; ++R){
                var oo = [];
                for(var C = r.s.c; C <= r.e.c; ++C){
                    var coord = encode_cell({
                        r: R,
                        c: C
                    });
                    cell = dense ? (ws[R] || [])[C] : ws[coord];
                    if (!cell || cell.v == null) {
                        oo.push("          ");
                        continue;
                    }
                    var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0, 10);
                    while(w.length < 10)w += " ";
                    oo.push(w + (C === 0 ? " " : ""));
                }
                o.push(oo.join(""));
            }
            return o.join("\n");
        }
        return {
            to_workbook: prn_to_workbook,
            to_sheet: prn_to_sheet,
            from_sheet: sheet_to_prn
        };
    }();
    /* Excel defaults to SYLK but warns if data is not valid */ function read_wb_ID(d, opts) {
        var o = opts || {}, OLD_WTF = !!o.WTF;
        o.WTF = true;
        try {
            var out = SYLK.to_workbook(d, o);
            o.WTF = OLD_WTF;
            return out;
        } catch (e) {
            o.WTF = OLD_WTF;
            if (!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
            return PRN.to_workbook(d, opts);
        }
    }
    var WK_ = function() {
        function lotushopper(data, cb, opts) {
            if (!data) return;
            prep_blob(data, data.l || 0);
            var Enum = opts.Enum || WK1Enum;
            while(data.l < data.length){
                var RT = data.read_shift(2);
                var R = Enum[RT] || Enum[0xFF];
                var length = data.read_shift(2);
                var tgt = data.l + length;
                var d = (R.f || parsenoop)(data, length, opts);
                data.l = tgt;
                if (cb(d, R.n, RT)) return;
            }
        }
        function lotus_to_workbook(d, opts) {
            switch(opts.type){
                case 'base64':
                    return lotus_to_workbook_buf(s2a(Base64.decode(d)), opts);
                case 'binary':
                    return lotus_to_workbook_buf(s2a(d), opts);
                case 'buffer':
                case 'array':
                    return lotus_to_workbook_buf(d, opts);
            }
            throw "Unsupported type " + opts.type;
        }
        function lotus_to_workbook_buf(d, opts) {
            if (!d) return d;
            var o = opts || {};
            if (DENSE != null && o.dense == null) o.dense = DENSE;
            var s = o.dense ? [] : {}, n = "Sheet1", sidx = 0;
            var sheets = {}, snames = [
                n
            ];
            var refguess = {
                s: {
                    r: 0,
                    c: 0
                },
                e: {
                    r: 0,
                    c: 0
                }
            };
            var sheetRows = o.sheetRows || 0;
            if (d[2] == 0x02) o.Enum = WK1Enum;
            else if (d[2] == 0x1a) o.Enum = WK3Enum;
            else if (d[2] == 0x0e) {
                o.Enum = WK3Enum;
                o.qpro = true;
                d.l = 0;
            } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
            lotushopper(d, function(val, Rn, RT) {
                if (d[2] == 0x02) switch(RT){
                    case 0x00:
                        o.vers = val;
                        if (val >= 0x1000) o.qpro = true;
                        break;
                    case 0x06:
                        refguess = val;
                        break; /* RANGE */ 
                    case 0x0F:
                        /* LABEL */ if (!o.qpro) val[1].v = val[1].v.slice(1);
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                    /* FORMULA */ case 0x33:
                        /* STRING */ /* TODO: actual translation of the format code */ if (RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
                            val[1].z = o.dateNF || SSF._table[14];
                            if (o.cellDates) {
                                val[1].t = 'd';
                                val[1].v = numdate(val[1].v);
                            }
                        }
                        if (o.dense) {
                            if (!s[val[0].r]) s[val[0].r] = [];
                            s[val[0].r][val[0].c] = val[1];
                        } else s[encode_cell(val[0])] = val[1];
                        break;
                }
                else switch(RT){
                    case 0x16:
                        /* LABEL16 */ val[1].v = val[1].v.slice(1);
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val[3] > sidx) {
                            s["!ref"] = encode_range(refguess);
                            sheets[n] = s;
                            s = o.dense ? [] : {};
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val[3];
                            n = "Sheet" + (sidx + 1);
                            snames.push(n);
                        }
                        if (sheetRows > 0 && val[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!s[val[0].r]) s[val[0].r] = [];
                            s[val[0].r][val[0].c] = val[1];
                        } else s[encode_cell(val[0])] = val[1];
                        if (refguess.e.c < val[0].c) refguess.e.c = val[0].c;
                        if (refguess.e.r < val[0].r) refguess.e.r = val[0].r;
                        break;
                    default:
                        break;
                }
            }, o);
            s["!ref"] = encode_range(refguess);
            sheets[n] = s;
            return {
                SheetNames: snames,
                Sheets: sheets
            };
        }
        function parse_RANGE(blob) {
            var o = {
                s: {
                    c: 0,
                    r: 0
                },
                e: {
                    c: 0,
                    r: 0
                }
            };
            o.s.c = blob.read_shift(2);
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(2);
            o.e.r = blob.read_shift(2);
            if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
            return o;
        }
        function parse_cell(blob, length, opts) {
            var o = [
                {
                    c: 0,
                    r: 0
                },
                {
                    t: 'n',
                    v: 0
                },
                0
            ];
            if (opts.qpro && opts.vers != 0x5120) {
                o[0].c = blob.read_shift(1);
                blob.l++;
                o[0].r = blob.read_shift(2);
                blob.l += 2;
            } else {
                o[2] = blob.read_shift(1);
                o[0].c = blob.read_shift(2);
                o[0].r = blob.read_shift(2);
            }
            return o;
        }
        function parse_LABEL(blob, length, opts) {
            var tgt = blob.l + length;
            var o = parse_cell(blob, length, opts);
            o[1].t = 's';
            if (opts.vers == 0x5120) {
                blob.l++;
                var len = blob.read_shift(1);
                o[1].v = blob.read_shift(len, 'utf8');
                return o;
            }
            if (opts.qpro) blob.l++;
            o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
            return o;
        }
        function parse_INTEGER(blob, length, opts) {
            var o = parse_cell(blob, length, opts);
            o[1].v = blob.read_shift(2, 'i');
            return o;
        }
        function parse_NUMBER(blob, length, opts) {
            var o = parse_cell(blob, length, opts);
            o[1].v = blob.read_shift(8, 'f');
            return o;
        }
        function parse_FORMULA(blob, length, opts) {
            var tgt = blob.l + length;
            var o = parse_cell(blob, length, opts);
            /* TODO: formula */ o[1].v = blob.read_shift(8, 'f');
            if (opts.qpro) blob.l = tgt;
            else {
                var flen = blob.read_shift(2);
                blob.l += flen;
            }
            return o;
        }
        function parse_cell_3(blob) {
            var o = [
                {
                    c: 0,
                    r: 0
                },
                {
                    t: 'n',
                    v: 0
                },
                0
            ];
            o[0].r = blob.read_shift(2);
            o[3] = blob[blob.l++];
            o[0].c = blob[blob.l++];
            return o;
        }
        function parse_LABEL_16(blob, length) {
            var o = parse_cell_3(blob, length);
            o[1].t = 's';
            o[1].v = blob.read_shift(length - 4, 'cstr');
            return o;
        }
        function parse_NUMBER_18(blob, length) {
            var o = parse_cell_3(blob, length);
            o[1].v = blob.read_shift(2);
            var v = o[1].v >> 1;
            /* TODO: figure out all of the corner cases */ if (o[1].v & 0x1) switch(v & 0x07){
                case 1:
                    v = (v >> 3) * 500;
                    break;
                case 2:
                    v = (v >> 3) / 20;
                    break;
                case 4:
                    v = (v >> 3) / 2000;
                    break;
                case 6:
                    v = (v >> 3) / 16;
                    break;
                case 7:
                    v = (v >> 3) / 64;
                    break;
                default:
                    throw "unknown NUMBER_18 encoding " + (v & 0x07);
            }
            o[1].v = v;
            return o;
        }
        function parse_NUMBER_17(blob, length) {
            var o = parse_cell_3(blob, length);
            var v1 = blob.read_shift(4);
            var v2 = blob.read_shift(4);
            var e = blob.read_shift(2);
            if (e == 0xFFFF) {
                o[1].v = 0;
                return o;
            }
            var s = e & 0x8000;
            e = (e & 0x7FFF) - 16446;
            o[1].v = (s * 2 - 1) * ((e > 0 ? v2 << e : v2 >>> -e) + (e > -32 ? v1 << e + 32 : v1 >>> -(e + 32)));
            return o;
        }
        function parse_FORMULA_19(blob, length) {
            var o = parse_NUMBER_17(blob, 14);
            blob.l += length - 14; /* TODO: formula */ 
            return o;
        }
        function parse_NUMBER_25(blob, length) {
            var o = parse_cell_3(blob, length);
            var v1 = blob.read_shift(4);
            o[1].v = v1 >> 6;
            return o;
        }
        function parse_NUMBER_27(blob, length) {
            var o = parse_cell_3(blob, length);
            var v1 = blob.read_shift(8, 'f');
            o[1].v = v1;
            return o;
        }
        function parse_FORMULA_28(blob, length) {
            var o = parse_NUMBER_27(blob, 14);
            blob.l += length - 10; /* TODO: formula */ 
            return o;
        }
        var WK1Enum = {
            0x0000: {
                n: "BOF",
                f: parseuint16
            },
            0x0001: {
                n: "EOF"
            },
            0x0002: {
                n: "CALCMODE"
            },
            0x0003: {
                n: "CALCORDER"
            },
            0x0004: {
                n: "SPLIT"
            },
            0x0005: {
                n: "SYNC"
            },
            0x0006: {
                n: "RANGE",
                f: parse_RANGE
            },
            0x0007: {
                n: "WINDOW1"
            },
            0x0008: {
                n: "COLW1"
            },
            0x0009: {
                n: "WINTWO"
            },
            0x000A: {
                n: "COLW2"
            },
            0x000B: {
                n: "NAME"
            },
            0x000C: {
                n: "BLANK"
            },
            0x000D: {
                n: "INTEGER",
                f: parse_INTEGER
            },
            0x000E: {
                n: "NUMBER",
                f: parse_NUMBER
            },
            0x000F: {
                n: "LABEL",
                f: parse_LABEL
            },
            0x0010: {
                n: "FORMULA",
                f: parse_FORMULA
            },
            0x0018: {
                n: "TABLE"
            },
            0x0019: {
                n: "ORANGE"
            },
            0x001A: {
                n: "PRANGE"
            },
            0x001B: {
                n: "SRANGE"
            },
            0x001C: {
                n: "FRANGE"
            },
            0x001D: {
                n: "KRANGE1"
            },
            0x0020: {
                n: "HRANGE"
            },
            0x0023: {
                n: "KRANGE2"
            },
            0x0024: {
                n: "PROTEC"
            },
            0x0025: {
                n: "FOOTER"
            },
            0x0026: {
                n: "HEADER"
            },
            0x0027: {
                n: "SETUP"
            },
            0x0028: {
                n: "MARGINS"
            },
            0x0029: {
                n: "LABELFMT"
            },
            0x002A: {
                n: "TITLES"
            },
            0x002B: {
                n: "SHEETJS"
            },
            0x002D: {
                n: "GRAPH"
            },
            0x002E: {
                n: "NGRAPH"
            },
            0x002F: {
                n: "CALCCOUNT"
            },
            0x0030: {
                n: "UNFORMATTED"
            },
            0x0031: {
                n: "CURSORW12"
            },
            0x0032: {
                n: "WINDOW"
            },
            0x0033: {
                n: "STRING",
                f: parse_LABEL
            },
            0x0037: {
                n: "PASSWORD"
            },
            0x0038: {
                n: "LOCKED"
            },
            0x003C: {
                n: "QUERY"
            },
            0x003D: {
                n: "QUERYNAME"
            },
            0x003E: {
                n: "PRINT"
            },
            0x003F: {
                n: "PRINTNAME"
            },
            0x0040: {
                n: "GRAPH2"
            },
            0x0041: {
                n: "GRAPHNAME"
            },
            0x0042: {
                n: "ZOOM"
            },
            0x0043: {
                n: "SYMSPLIT"
            },
            0x0044: {
                n: "NSROWS"
            },
            0x0045: {
                n: "NSCOLS"
            },
            0x0046: {
                n: "RULER"
            },
            0x0047: {
                n: "NNAME"
            },
            0x0048: {
                n: "ACOMM"
            },
            0x0049: {
                n: "AMACRO"
            },
            0x004A: {
                n: "PARSE"
            },
            0x00FF: {
                n: "",
                f: parsenoop
            }
        };
        var WK3Enum = {
            0x0000: {
                n: "BOF"
            },
            0x0001: {
                n: "EOF"
            },
            0x0003: {
                n: "??"
            },
            0x0004: {
                n: "??"
            },
            0x0005: {
                n: "??"
            },
            0x0006: {
                n: "??"
            },
            0x0007: {
                n: "??"
            },
            0x0009: {
                n: "??"
            },
            0x000a: {
                n: "??"
            },
            0x000b: {
                n: "??"
            },
            0x000c: {
                n: "??"
            },
            0x000e: {
                n: "??"
            },
            0x000f: {
                n: "??"
            },
            0x0010: {
                n: "??"
            },
            0x0011: {
                n: "??"
            },
            0x0012: {
                n: "??"
            },
            0x0013: {
                n: "??"
            },
            0x0015: {
                n: "??"
            },
            0x0016: {
                n: "LABEL16",
                f: parse_LABEL_16
            },
            0x0017: {
                n: "NUMBER17",
                f: parse_NUMBER_17
            },
            0x0018: {
                n: "NUMBER18",
                f: parse_NUMBER_18
            },
            0x0019: {
                n: "FORMULA19",
                f: parse_FORMULA_19
            },
            0x001a: {
                n: "??"
            },
            0x001b: {
                n: "??"
            },
            0x001c: {
                n: "??"
            },
            0x001d: {
                n: "??"
            },
            0x001e: {
                n: "??"
            },
            0x001f: {
                n: "??"
            },
            0x0021: {
                n: "??"
            },
            0x0025: {
                n: "NUMBER25",
                f: parse_NUMBER_25
            },
            0x0027: {
                n: "NUMBER27",
                f: parse_NUMBER_27
            },
            0x0028: {
                n: "FORMULA28",
                f: parse_FORMULA_28
            },
            0x00FF: {
                n: "",
                f: parsenoop
            }
        };
        return {
            to_workbook: lotus_to_workbook
        };
    }();
    /* 18.4.7 rPr CT_RPrElt */ function parse_rpr(rpr) {
        var font = {}, m = rpr.match(tagregex), i = 0;
        var pass = false;
        if (m) for(; i != m.length; ++i){
            var y = parsexmltag(m[i]);
            switch(y[0].replace(/\w*:/g, "")){
                /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case '<condense':
                    break;
                /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case '<extend':
                    break;
                /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case '<shadow':
                    if (!y.val) break;
                /* falls through */ case '<shadow>':
                case '<shadow/>':
                    font.shadow = 1;
                    break;
                case '</shadow>':
                    break;
                /* 18.4.1 charset CT_IntProperty TODO */ case '<charset':
                    if (y.val == '1') break;
                    font.cp = CS2CP[parseInt(y.val, 10)];
                    break;
                /* 18.4.2 outline CT_BooleanProperty TODO */ case '<outline':
                    if (!y.val) break;
                /* falls through */ case '<outline>':
                case '<outline/>':
                    font.outline = 1;
                    break;
                case '</outline>':
                    break;
                /* 18.4.5 rFont CT_FontName */ case '<rFont':
                    font.name = y.val;
                    break;
                /* 18.4.11 sz CT_FontSize */ case '<sz':
                    font.sz = y.val;
                    break;
                /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                    if (!y.val) break;
                /* falls through */ case '<strike>':
                case '<strike/>':
                    font.strike = 1;
                    break;
                case '</strike>':
                    break;
                /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                    if (!y.val) break;
                    switch(y.val){
                        case 'double':
                            font.uval = "double";
                            break;
                        case 'singleAccounting':
                            font.uval = "single-accounting";
                            break;
                        case 'doubleAccounting':
                            font.uval = "double-accounting";
                            break;
                    }
                /* falls through */ case '<u>':
                case '<u/>':
                    font.u = 1;
                    break;
                case '</u>':
                    break;
                /* 18.8.2 b */ case '<b':
                    if (y.val == '0') break;
                /* falls through */ case '<b>':
                case '<b/>':
                    font.b = 1;
                    break;
                case '</b>':
                    break;
                /* 18.8.26 i */ case '<i':
                    if (y.val == '0') break;
                /* falls through */ case '<i>':
                case '<i/>':
                    font.i = 1;
                    break;
                case '</i>':
                    break;
                /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case '<color':
                    if (y.rgb) font.color = y.rgb.slice(2, 8);
                    break;
                /* 18.8.18 family ST_FontFamily */ case '<family':
                    font.family = y.val;
                    break;
                /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case '<vertAlign':
                    font.valign = y.val;
                    break;
                /* 18.8.35 scheme CT_FontScheme TODO */ case '<scheme':
                    break;
                /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
                case '<extLst>':
                case '</extLst>':
                    break;
                case '<ext':
                    pass = true;
                    break;
                case '</ext>':
                    pass = false;
                    break;
                default:
                    if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
            }
        }
        return font;
    }
    var parse_rs = function() {
        var tregex = matchtag("t"), rpregex = matchtag("rPr");
        /* 18.4.4 r CT_RElt */ function parse_r(r) {
            /* 18.4.12 t ST_Xstring */ var t = r.match(tregex) /*, cp = 65001*/ ;
            if (!t) return {
                t: "s",
                v: ""
            };
            var o = {
                t: 's',
                v: unescapexml(t[1])
            };
            var rpr = r.match(rpregex);
            if (rpr) o.s = parse_rpr(rpr[1]);
            return o;
        }
        var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
        return function parse_rs(rs) {
            return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
                return r.v;
            });
        };
    }();
    /* Parse a list of <r> tags */ var rs_to_html = function parse_rs_factory() {
        var nlregex = /(\r\n|\n)/g;
        function parse_rpr2(font, intro, outro) {
            var style = [];
            if (font.u) style.push("text-decoration: underline;");
            if (font.uval) style.push("text-underline-style:" + font.uval + ";");
            if (font.sz) style.push("font-size:" + font.sz + "pt;");
            if (font.outline) style.push("text-effect: outline;");
            if (font.shadow) style.push("text-shadow: auto;");
            intro.push('<span style="' + style.join("") + '">');
            if (font.b) {
                intro.push("<b>");
                outro.push("</b>");
            }
            if (font.i) {
                intro.push("<i>");
                outro.push("</i>");
            }
            if (font.strike) {
                intro.push("<s>");
                outro.push("</s>");
            }
            var align = font.valign || "";
            if (align == "superscript" || align == "super") align = "sup";
            else if (align == "subscript") align = "sub";
            if (align != "") {
                intro.push("<" + align + ">");
                outro.push("</" + align + ">");
            }
            outro.push("</span>");
            return font;
        }
        /* 18.4.4 r CT_RElt */ function r_to_html(r) {
            var terms = [
                [],
                r.v,
                []
            ];
            if (!r.v) return "";
            if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
            return terms[0].join("") + terms[1].replace(nlregex, '<br/>') + terms[2].join("");
        }
        return function parse_rs(rs) {
            return rs.map(r_to_html).join("");
        };
    }();
    /* 18.4.8 si CT_Rst */ var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
    var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
    function parse_si(x, opts) {
        var html = opts ? opts.cellHTML : true;
        var z = {};
        if (!x) return {
            t: ""
        };
        //var y;
        /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
        if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
            z.t = unescapexml(utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""));
            z.r = utf8read(x);
            if (html) z.h = escapehtml(z.t);
        } else if (/*y = */ x.match(sirregex)) {
            z.r = utf8read(x);
            z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex) || []).join("").replace(tagregex, "")));
            if (html) z.h = rs_to_html(parse_rs(z.r));
        }
        /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
    }
    /* 18.4 Shared String Table */ var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
    var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
    var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
    function parse_sst_xml(data, opts) {
        var s = [], ss = "";
        if (!data) return s;
        /* 18.4.9 sst CT_Sst */ var sst = data.match(sstr0);
        if (sst) {
            ss = sst[2].replace(sstr1, "").split(sstr2);
            for(var i = 0; i != ss.length; ++i){
                var o = parse_si(ss[i].trim(), opts);
                if (o != null) s[s.length] = o;
            }
            sst = parsexmltag(sst[1]);
            s.Count = sst.count;
            s.Unique = sst.uniqueCount;
        }
        return s;
    }
    RELS.SST = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
    var straywsregex = /^\s|\s$|[\t\n\r]/;
    function write_sst_xml(sst, opts) {
        if (!opts.bookSST) return "";
        var o = [
            XML_HEADER
        ];
        o[o.length] = writextag('sst', null, {
            xmlns: XMLNS.main[0],
            count: sst.Count,
            uniqueCount: sst.Unique
        });
        for(var i = 0; i != sst.length; ++i){
            if (sst[i] == null) continue;
            var s = sst[i];
            var sitag = "<si>";
            if (s.r) sitag += s.r;
            else {
                sitag += "<t";
                if (!s.t) s.t = "";
                if (s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
                sitag += ">" + escapexml(s.t) + "</t>";
            }
            sitag += "</si>";
            o[o.length] = sitag;
        }
        if (o.length > 2) {
            o[o.length] = '</sst>';
            o[1] = o[1].replace("/>", ">");
        }
        return o.join("");
    }
    /* [MS-XLSB] 2.4.221 BrtBeginSst */ function parse_BrtBeginSst(data) {
        return [
            data.read_shift(4),
            data.read_shift(4)
        ];
    }
    /* [MS-XLSB] 2.1.7.45 Shared Strings */ function parse_sst_bin(data, opts) {
        var s = [];
        var pass = false;
        recordhopper(data, function hopper_sst(val, R_n, RT) {
            switch(RT){
                case 0x009F:
                    /* 'BrtBeginSst' */ s.Count = val[0];
                    s.Unique = val[1];
                    break;
                case 0x0013:
                    /* 'BrtSSTItem' */ s.push(val);
                    break;
                case 0x00A0:
                    /* 'BrtEndSst' */ return true;
                case 0x0023:
                    /* 'BrtFRTBegin' */ pass = true;
                    break;
                case 0x0024:
                    /* 'BrtFRTEnd' */ pass = false;
                    break;
                default:
                    if (R_n.indexOf("Begin") > 0) ;
                    else R_n.indexOf("End");
                    if (!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
            }
        });
        return s;
    }
    function write_BrtBeginSst(sst, o) {
        if (!o) o = new_buf(8);
        o.write_shift(4, sst.Count);
        o.write_shift(4, sst.Unique);
        return o;
    }
    var write_BrtSSTItem = write_RichStr;
    function write_sst_bin(sst) {
        var ba = buf_array();
        write_record(ba, "BrtBeginSst", write_BrtBeginSst(sst));
        for(var i = 0; i < sst.length; ++i)write_record(ba, "BrtSSTItem", write_BrtSSTItem(sst[i]));
        /* FRTSST */ write_record(ba, "BrtEndSst");
        return ba.end();
    }
    function _JS2ANSI(str) {
        if (typeof cptable !== 'undefined') return cptable.utils.encode(current_ansi, str);
        var o = [], oo = str.split("");
        for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
        return o;
    }
    /* [MS-OFFCRYPTO] 2.1.4 Version */ function parse_CRYPTOVersion(blob, length) {
        var o = {};
        o.Major = blob.read_shift(2);
        o.Minor = blob.read_shift(2);
        if (length >= 4) blob.l += length - 4;
        return o;
    }
    /* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function parse_DataSpaceVersionInfo(blob) {
        var o = {};
        o.id = blob.read_shift(0, 'lpp4');
        o.R = parse_CRYPTOVersion(blob, 4);
        o.U = parse_CRYPTOVersion(blob, 4);
        o.W = parse_CRYPTOVersion(blob, 4);
        return o;
    }
    /* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function parse_DataSpaceMapEntry(blob) {
        var len = blob.read_shift(4);
        var end = blob.l + len - 4;
        var o = {};
        var cnt = blob.read_shift(4);
        var comps = [];
        /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
            t: blob.read_shift(4),
            v: blob.read_shift(0, 'lpp4')
        });
        o.name = blob.read_shift(0, 'lpp4');
        o.comps = comps;
        if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
        return o;
    }
    /* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function parse_DataSpaceMap(blob) {
        var o = [];
        blob.l += 4; // must be 0x8
        var cnt = blob.read_shift(4);
        while(cnt-- > 0)o.push(parse_DataSpaceMapEntry(blob));
        return o;
    }
    /* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function parse_DataSpaceDefinition(blob) {
        var o = [];
        blob.l += 4; // must be 0x8
        var cnt = blob.read_shift(4);
        while(cnt-- > 0)o.push(blob.read_shift(0, 'lpp4'));
        return o;
    }
    /* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function parse_TransformInfoHeader(blob) {
        var o = {};
        /*var len = */ blob.read_shift(4);
        blob.l += 4; // must be 0x1
        o.id = blob.read_shift(0, 'lpp4');
        o.name = blob.read_shift(0, 'lpp4');
        o.R = parse_CRYPTOVersion(blob, 4);
        o.U = parse_CRYPTOVersion(blob, 4);
        o.W = parse_CRYPTOVersion(blob, 4);
        return o;
    }
    function parse_Primary(blob) {
        /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = parse_TransformInfoHeader(blob);
        /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, '8lpp4');
        hdr.blksz = blob.read_shift(4);
        hdr.cmode = blob.read_shift(4);
        if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
        return hdr;
    }
    /* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function parse_EncryptionHeader(blob, length) {
        var tgt = blob.l + length;
        var o = {};
        o.Flags = blob.read_shift(4) & 0x3F;
        blob.l += 4;
        o.AlgID = blob.read_shift(4);
        var valid = false;
        switch(o.AlgID){
            case 0x660E:
            case 0x660F:
            case 0x6610:
                valid = o.Flags == 0x24;
                break;
            case 0x6801:
                valid = o.Flags == 0x04;
                break;
            case 0:
                valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
                break;
            default:
                throw 'Unrecognized encryption algorithm: ' + o.AlgID;
        }
        if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
        o.AlgIDHash = blob.read_shift(4);
        o.KeySize = blob.read_shift(4);
        o.ProviderType = blob.read_shift(4);
        blob.l += 8;
        o.CSPName = blob.read_shift(tgt - blob.l >> 1, 'utf16le');
        blob.l = tgt;
        return o;
    }
    /* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function parse_EncryptionVerifier(blob, length) {
        var o = {}, tgt = blob.l + length;
        blob.l += 4; // SaltSize must be 0x10
        o.Salt = blob.slice(blob.l, blob.l + 16);
        blob.l += 16;
        o.Verifier = blob.slice(blob.l, blob.l + 16);
        blob.l += 16;
        /*var sz = */ blob.read_shift(4);
        o.VerifierHash = blob.slice(blob.l, tgt);
        blob.l = tgt;
        return o;
    }
    /* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function parse_EncryptionInfo(blob) {
        var vers = parse_CRYPTOVersion(blob);
        switch(vers.Minor){
            case 0x02:
                return [
                    vers.Minor,
                    parse_EncInfoStd(blob, vers)
                ];
            case 0x03:
                return [
                    vers.Minor,
                    parse_EncInfoExt(blob, vers)
                ];
            case 0x04:
                return [
                    vers.Minor,
                    parse_EncInfoAgl(blob, vers)
                ];
        }
        throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
    }
    /* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function parse_EncInfoStd(blob) {
        var flags = blob.read_shift(4);
        if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
        var sz = blob.read_shift(4);
        //var tgt = blob.l + sz;
        var hdr = parse_EncryptionHeader(blob, sz);
        var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
        return {
            t: "Std",
            h: hdr,
            v: verifier
        };
    }
    /* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function parse_EncInfoExt() {
        throw new Error("File is password-protected: ECMA-376 Extensible");
    }
    /* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function parse_EncInfoAgl(blob) {
        var KeyData = [
            "saltSize",
            "blockSize",
            "keyBits",
            "hashSize",
            "cipherAlgorithm",
            "cipherChaining",
            "hashAlgorithm",
            "saltValue"
        ];
        blob.l += 4;
        var xml = blob.read_shift(blob.length - blob.l, 'utf8');
        var o = {};
        xml.replace(tagregex, function xml_agile(x) {
            var y = parsexmltag(x);
            switch(strip_ns(y[0])){
                case '<?xml':
                    break;
                case '<encryption':
                case '</encryption>':
                    break;
                case '<keyData':
                    KeyData.forEach(function(k) {
                        o[k] = y[k];
                    });
                    break;
                case '<dataIntegrity':
                    o.encryptedHmacKey = y.encryptedHmacKey;
                    o.encryptedHmacValue = y.encryptedHmacValue;
                    break;
                case '<keyEncryptors>':
                case '<keyEncryptors':
                    o.encs = [];
                    break;
                case '</keyEncryptors>':
                    break;
                case '<keyEncryptor':
                    o.uri = y.uri;
                    break;
                case '</keyEncryptor>':
                    break;
                case '<encryptedKey':
                    o.encs.push(y);
                    break;
                default:
                    throw y[0];
            }
        });
        return o;
    }
    /* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function parse_RC4CryptoHeader(blob, length) {
        var o = {};
        var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
        length -= 4;
        if (vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
        if (vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
        o.Flags = blob.read_shift(4);
        length -= 4;
        var sz = blob.read_shift(4);
        length -= 4;
        o.EncryptionHeader = parse_EncryptionHeader(blob, sz);
        length -= sz;
        o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
        return o;
    }
    /* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function parse_RC4Header(blob) {
        var o = {};
        var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
        if (vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
        o.Salt = blob.read_shift(16);
        o.EncryptedVerifier = blob.read_shift(16);
        o.EncryptedVerifierHash = blob.read_shift(16);
        return o;
    }
    /* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function crypto_CreatePasswordVerifier_Method1(Password) {
        var Verifier = 0x0000, PasswordArray;
        var PasswordDecoded = _JS2ANSI(Password);
        var len = PasswordDecoded.length + 1, i, PasswordByte;
        var Intermediate1, Intermediate2, Intermediate3;
        PasswordArray = new_raw_buf(len);
        PasswordArray[0] = PasswordDecoded.length;
        for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
        for(i = len - 1; i >= 0; --i){
            PasswordByte = PasswordArray[i];
            Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
            Intermediate2 = Verifier << 1 & 0x7FFF;
            Intermediate3 = Intermediate1 | Intermediate2;
            Verifier = Intermediate3 ^ PasswordByte;
        }
        return Verifier ^ 0xCE4B;
    }
    /* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var crypto_CreateXorArray_Method1 = function() {
        var PadArray = [
            0xBB,
            0xFF,
            0xFF,
            0xBA,
            0xFF,
            0xFF,
            0xB9,
            0x80,
            0x00,
            0xBE,
            0x0F,
            0x00,
            0xBF,
            0x0F,
            0x00
        ];
        var InitialCode = [
            0xE1F0,
            0x1D0F,
            0xCC9C,
            0x84C0,
            0x110C,
            0x0E10,
            0xF1CE,
            0x313E,
            0x1872,
            0xE139,
            0xD40F,
            0x84F9,
            0x280C,
            0xA96A,
            0x4EC3
        ];
        var XorMatrix = [
            0xAEFC,
            0x4DD9,
            0x9BB2,
            0x2745,
            0x4E8A,
            0x9D14,
            0x2A09,
            0x7B61,
            0xF6C2,
            0xFDA5,
            0xEB6B,
            0xC6F7,
            0x9DCF,
            0x2BBF,
            0x4563,
            0x8AC6,
            0x05AD,
            0x0B5A,
            0x16B4,
            0x2D68,
            0x5AD0,
            0x0375,
            0x06EA,
            0x0DD4,
            0x1BA8,
            0x3750,
            0x6EA0,
            0xDD40,
            0xD849,
            0xA0B3,
            0x5147,
            0xA28E,
            0x553D,
            0xAA7A,
            0x44D5,
            0x6F45,
            0xDE8A,
            0xAD35,
            0x4A4B,
            0x9496,
            0x390D,
            0x721A,
            0xEB23,
            0xC667,
            0x9CEF,
            0x29FF,
            0x53FE,
            0xA7FC,
            0x5FD9,
            0x47D3,
            0x8FA6,
            0x0F6D,
            0x1EDA,
            0x3DB4,
            0x7B68,
            0xF6D0,
            0xB861,
            0x60E3,
            0xC1C6,
            0x93AD,
            0x377B,
            0x6EF6,
            0xDDEC,
            0x45A0,
            0x8B40,
            0x06A1,
            0x0D42,
            0x1A84,
            0x3508,
            0x6A10,
            0xAA51,
            0x4483,
            0x8906,
            0x022D,
            0x045A,
            0x08B4,
            0x1168,
            0x76B4,
            0xED68,
            0xCAF1,
            0x85C3,
            0x1BA7,
            0x374E,
            0x6E9C,
            0x3730,
            0x6E60,
            0xDCC0,
            0xA9A1,
            0x4363,
            0x86C6,
            0x1DAD,
            0x3331,
            0x6662,
            0xCCC4,
            0x89A9,
            0x0373,
            0x06E6,
            0x0DCC,
            0x1021,
            0x2042,
            0x4084,
            0x8108,
            0x1231,
            0x2462,
            0x48C4
        ];
        var Ror = function(Byte) {
            return (Byte / 2 | Byte * 128) & 0xFF;
        };
        var XorRor = function(byte1, byte2) {
            return Ror(byte1 ^ byte2);
        };
        var CreateXorKey_Method1 = function(Password) {
            var XorKey = InitialCode[Password.length - 1];
            var CurrentElement = 0x68;
            for(var i = Password.length - 1; i >= 0; --i){
                var Char = Password[i];
                for(var j = 0; j != 7; ++j){
                    if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                    Char *= 2;
                    --CurrentElement;
                }
            }
            return XorKey;
        };
        return function(password) {
            var Password = _JS2ANSI(password);
            var XorKey = CreateXorKey_Method1(Password);
            var Index = Password.length;
            var ObfuscationArray = new_raw_buf(16);
            for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
            var Temp, PasswordLastChar, PadIndex;
            if ((Index & 1) === 1) {
                Temp = XorKey >> 8;
                ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
                --Index;
                Temp = XorKey & 0xFF;
                PasswordLastChar = Password[Password.length - 1];
                ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
            }
            while(Index > 0){
                --Index;
                Temp = XorKey >> 8;
                ObfuscationArray[Index] = XorRor(Password[Index], Temp);
                --Index;
                Temp = XorKey & 0xFF;
                ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            }
            Index = 15;
            PadIndex = 15 - Password.length;
            while(PadIndex > 0){
                Temp = XorKey >> 8;
                ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
                --Index;
                --PadIndex;
                Temp = XorKey & 0xFF;
                ObfuscationArray[Index] = XorRor(Password[Index], Temp);
                --Index;
                --PadIndex;
            }
            return ObfuscationArray;
        };
    }();
    /* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
        /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
        if (!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
        var Index, Value;
        for(Index = 0; Index != Data.length; ++Index){
            Value = Data[Index];
            Value ^= XorArray[XorArrayIndex];
            Value = (Value >> 5 | Value << 3) & 0xFF;
            O[Index] = Value;
            ++XorArrayIndex;
        }
        return [
            O,
            XorArrayIndex,
            XorArray
        ];
    };
    var crypto_MakeXorDecryptor = function(password) {
        var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
        return function(Data) {
            var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
            XorArrayIndex = O[1];
            return O[0];
        };
    };
    /* 2.5.343 */ function parse_XORObfuscation(blob, length, opts, out) {
        var o = {
            key: parseuint16(blob),
            verificationBytes: parseuint16(blob)
        };
        if (opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
        out.valid = o.verificationBytes === o.verifier;
        if (out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
        return o;
    }
    /* 2.4.117 */ function parse_FilePassHeader(blob, length, oo) {
        var o = oo || {};
        o.Info = blob.read_shift(2);
        blob.l -= 2;
        if (o.Info === 1) o.Data = parse_RC4Header(blob, length);
        else o.Data = parse_RC4CryptoHeader(blob, length);
        return o;
    }
    function parse_FilePass(blob, length, opts) {
        var o = {
            Type: opts.biff >= 8 ? blob.read_shift(2) : 0
        }; /* wEncryptionType */ 
        if (o.Type) parse_FilePassHeader(blob, length - 2, o);
        else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
        return o;
    }
    var RTF = function() {
        function rtf_to_sheet(d, opts) {
            switch(opts.type){
                case 'base64':
                    return rtf_to_sheet_str(Base64.decode(d), opts);
                case 'binary':
                    return rtf_to_sheet_str(d, opts);
                case 'buffer':
                    return rtf_to_sheet_str(d.toString('binary'), opts);
                case 'array':
                    return rtf_to_sheet_str(cc2str(d), opts);
            }
            throw new Error("Unrecognized type " + opts.type);
        }
        function rtf_to_sheet_str(str, opts) {
            var o = opts || {};
            var ws = o.dense ? [] : {};
            var range = {
                s: {
                    c: 0,
                    r: 0
                },
                e: {
                    c: 0,
                    r: 0
                }
            };
            // TODO: parse
            if (!str.match(/\\trowd/)) throw new Error("RTF missing table");
            ws['!ref'] = encode_range(range);
            return ws;
        }
        function rtf_to_workbook(d, opts) {
            return sheet_to_workbook(rtf_to_sheet(d, opts), opts);
        }
        /* TODO: this is a stub */ function sheet_to_rtf(ws) {
            var o = [
                "{\\rtf1\\ansi"
            ];
            var r = safe_decode_range(ws['!ref']), cell;
            var dense = Array.isArray(ws);
            for(var R = r.s.r; R <= r.e.r; ++R){
                o.push("\\trowd\\trautofit1");
                for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
                o.push("\\pard\\intbl");
                for(C = r.s.c; C <= r.e.c; ++C){
                    var coord = encode_cell({
                        r: R,
                        c: C
                    });
                    cell = dense ? (ws[R] || [])[C] : ws[coord];
                    if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                    o.push(" " + (cell.w || (format_cell(cell), cell.w)));
                    o.push("\\cell");
                }
                o.push("\\pard\\intbl\\row");
            }
            return o.join("") + "}";
        }
        return {
            to_workbook: rtf_to_workbook,
            to_sheet: rtf_to_sheet,
            from_sheet: sheet_to_rtf
        };
    }();
    function hex2RGB(h) {
        var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
        return [
            parseInt(o.slice(0, 2), 16),
            parseInt(o.slice(2, 4), 16),
            parseInt(o.slice(4, 6), 16)
        ];
    }
    function rgb2Hex(rgb) {
        for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
        return o.toString(16).toUpperCase().slice(1);
    }
    function rgb2HSL(rgb) {
        var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
        var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
        if (C === 0) return [
            0,
            0,
            R
        ];
        var H6 = 0, S = 0, L2 = M + m;
        S = C / (L2 > 1 ? 2 - L2 : L2);
        switch(M){
            case R:
                H6 = ((G - B) / C + 6) % 6;
                break;
            case G:
                H6 = (B - R) / C + 2;
                break;
            case B:
                H6 = (R - G) / C + 4;
                break;
        }
        return [
            H6 / 6,
            S,
            L2 / 2
        ];
    }
    function hsl2RGB(hsl) {
        var H = hsl[0], S = hsl[1], L = hsl[2];
        var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
        var rgb = [
            m,
            m,
            m
        ], h6 = 6 * H;
        var X;
        if (S !== 0) switch(h6 | 0){
            case 0:
            case 6:
                X = C * h6;
                rgb[0] += C;
                rgb[1] += X;
                break;
            case 1:
                X = C * (2 - h6);
                rgb[0] += X;
                rgb[1] += C;
                break;
            case 2:
                X = C * (h6 - 2);
                rgb[1] += C;
                rgb[2] += X;
                break;
            case 3:
                X = C * (4 - h6);
                rgb[1] += X;
                rgb[2] += C;
                break;
            case 4:
                X = C * (h6 - 4);
                rgb[2] += C;
                rgb[0] += X;
                break;
            case 5:
                X = C * (6 - h6);
                rgb[2] += X;
                rgb[0] += C;
                break;
        }
        for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
        return rgb;
    }
    /* 18.8.3 bgColor tint algorithm */ function rgb_tint(hex, tint) {
        if (tint === 0) return hex;
        var hsl = rgb2HSL(hex2RGB(hex));
        if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
        else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
        return rgb2Hex(hsl2RGB(hsl));
    }
    /* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
    function width2px(width) {
        return Math.floor((width + Math.round(128 / MDW) / 256) * MDW);
    }
    function px2char(px) {
        return Math.floor((px - 5) / MDW * 100 + 0.5) / 100;
    }
    function char2width(chr) {
        return Math.round((chr * MDW + 5) / MDW * 256) / 256;
    }
    //function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
    //function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
    function cycle_width(collw) {
        return char2width(px2char(width2px(collw)));
    }
    /* XLSX/XLSB/XLS specify width in units of MDW */ function find_mdw_colw(collw) {
        var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
        if (delta > 0.005) {
            for(MDW = MIN_MDW; MDW < MAX_MDW; ++MDW)if (Math.abs(collw - cycle_width(collw)) <= delta) {
                delta = Math.abs(collw - cycle_width(collw));
                _MDW = MDW;
            }
        }
        MDW = _MDW;
    }
    /* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function process_col(coll) {
        if (coll.width) {
            coll.wpx = width2px(coll.width);
            coll.wch = px2char(coll.wpx);
            coll.MDW = MDW;
        } else if (coll.wpx) {
            coll.wch = px2char(coll.wpx);
            coll.width = char2width(coll.wch);
            coll.MDW = MDW;
        } else if (typeof coll.wch == 'number') {
            coll.width = char2width(coll.wch);
            coll.wpx = width2px(coll.width);
            coll.MDW = MDW;
        }
        if (coll.customWidth) delete coll.customWidth;
    }
    var DEF_PPI = 96, PPI = DEF_PPI;
    function px2pt(px) {
        return px * 96 / PPI;
    }
    function pt2px(pt) {
        return pt * PPI / 96;
    }
    /* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var XLMLPatternTypeMap = {
        "None": "none",
        "Solid": "solid",
        "Gray50": "mediumGray",
        "Gray75": "darkGray",
        "Gray25": "lightGray",
        "HorzStripe": "darkHorizontal",
        "VertStripe": "darkVertical",
        "ReverseDiagStripe": "darkDown",
        "DiagStripe": "darkUp",
        "DiagCross": "darkGrid",
        "ThickDiagCross": "darkTrellis",
        "ThinHorzStripe": "lightHorizontal",
        "ThinVertStripe": "lightVertical",
        "ThinReverseDiagStripe": "lightDown",
        "ThinHorzCross": "lightGrid"
    };
    /* 18.8.5 borders CT_Borders */ function parse_borders(t, styles, themes, opts) {
        styles.Borders = [];
        var border = {};
        var pass = false;
        (t[0].match(tagregex) || []).forEach(function(x) {
            var y = parsexmltag(x);
            switch(strip_ns(y[0])){
                case '<borders':
                case '<borders>':
                case '</borders>':
                    break;
                /* 18.8.4 border CT_Border */ case '<border':
                case '<border>':
                case '<border/>':
                    border = {};
                    if (y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
                    if (y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
                    styles.Borders.push(border);
                    break;
                case '</border>':
                    break;
                /* note: not in spec, appears to be CT_BorderPr */ case '<left/>':
                    break;
                case '<left':
                case '<left>':
                    break;
                case '</left>':
                    break;
                /* note: not in spec, appears to be CT_BorderPr */ case '<right/>':
                    break;
                case '<right':
                case '<right>':
                    break;
                case '</right>':
                    break;
                /* 18.8.43 top CT_BorderPr */ case '<top/>':
                    break;
                case '<top':
                case '<top>':
                    break;
                case '</top>':
                    break;
                /* 18.8.6 bottom CT_BorderPr */ case '<bottom/>':
                    break;
                case '<bottom':
                case '<bottom>':
                    break;
                case '</bottom>':
                    break;
                /* 18.8.13 diagonal CT_BorderPr */ case '<diagonal':
                case '<diagonal>':
                case '<diagonal/>':
                    break;
                case '</diagonal>':
                    break;
                /* 18.8.25 horizontal CT_BorderPr */ case '<horizontal':
                case '<horizontal>':
                case '<horizontal/>':
                    break;
                case '</horizontal>':
                    break;
                /* 18.8.44 vertical CT_BorderPr */ case '<vertical':
                case '<vertical>':
                case '<vertical/>':
                    break;
                case '</vertical>':
                    break;
                /* 18.8.37 start CT_BorderPr */ case '<start':
                case '<start>':
                case '<start/>':
                    break;
                case '</start>':
                    break;
                /* 18.8.16 end CT_BorderPr */ case '<end':
                case '<end>':
                case '<end/>':
                    break;
                case '</end>':
                    break;
                /* 18.8.? color CT_Color */ case '<color':
                case '<color>':
                    break;
                case '<color/>':
                case '</color>':
                    break;
                /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
                case '<extLst>':
                case '</extLst>':
                    break;
                case '<ext':
                    pass = true;
                    break;
                case '</ext>':
                    pass = false;
                    break;
                default:
                    if (opts && opts.WTF) {
                        if (!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
                    }
            }
        });
    }
    /* 18.8.21 fills CT_Fills */ function parse_fills(t, styles, themes, opts) {
        styles.Fills = [];
        var fill = {};
        var pass = false;
        (t[0].match(tagregex) || []).forEach(function(x) {
            var y = parsexmltag(x);
            switch(strip_ns(y[0])){
                case '<fills':
                case '<fills>':
                case '</fills>':
                    break;
                /* 18.8.20 fill CT_Fill */ case '<fill>':
                case '<fill':
                case '<fill/>':
                    fill = {};
                    styles.Fills.push(fill);
                    break;
                case '</fill>':
                    break;
                /* 18.8.24 gradientFill CT_GradientFill */ case '<gradientFill>':
                    break;
                case '<gradientFill':
                case '</gradientFill>':
                    styles.Fills.push(fill);
                    fill = {};
                    break;
                /* 18.8.32 patternFill CT_PatternFill */ case '<patternFill':
                case '<patternFill>':
                    if (y.patternType) fill.patternType = y.patternType;
                    break;
                case '<patternFill/>':
                case '</patternFill>':
                    break;
                /* 18.8.3 bgColor CT_Color */ case '<bgColor':
                    if (!fill.bgColor) fill.bgColor = {};
                    if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                    if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                    if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                    /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                    break;
                case '<bgColor/>':
                case '</bgColor>':
                    break;
                /* 18.8.19 fgColor CT_Color */ case '<fgColor':
                    if (!fill.fgColor) fill.fgColor = {};
                    if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                    if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                    /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                    break;
                case '<fgColor/>':
                case '</fgColor>':
                    break;
                /* 18.8.38 stop CT_GradientStop */ case '<stop':
                case '<stop/>':
                    break;
                case '</stop>':
                    break;
                /* 18.8.? color CT_Color */ case '<color':
                case '<color/>':
                    break;
                case '</color>':
                    break;
                /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
                case '<extLst>':
                case '</extLst>':
                    break;
                case '<ext':
                    pass = true;
                    break;
                case '</ext>':
                    pass = false;
                    break;
                default:
                    if (opts && opts.WTF) {
                        if (!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
                    }
            }
        });
    }
    /* 18.8.23 fonts CT_Fonts */ function parse_fonts(t, styles, themes, opts) {
        styles.Fonts = [];
        var font = {};
        var pass = false;
        (t[0].match(tagregex) || []).forEach(function(x) {
            var y = parsexmltag(x);
            switch(strip_ns(y[0])){
                case '<fonts':
                case '<fonts>':
                case '</fonts>':
                    break;
                /* 18.8.22 font CT_Font */ case '<font':
                case '<font>':
                    break;
                case '</font>':
                case '<font/>':
                    styles.Fonts.push(font);
                    font = {};
                    break;
                /* 18.8.29 name CT_FontName */ case '<name':
                    if (y.val) font.name = utf8read(y.val);
                    break;
                case '<name/>':
                case '</name>':
                    break;
                /* 18.8.2  b CT_BooleanProperty */ case '<b':
                    font.bold = y.val ? parsexmlbool(y.val) : 1;
                    break;
                case '<b/>':
                    font.bold = 1;
                    break;
                /* 18.8.26 i CT_BooleanProperty */ case '<i':
                    font.italic = y.val ? parsexmlbool(y.val) : 1;
                    break;
                case '<i/>':
                    font.italic = 1;
                    break;
                /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                    switch(y.val){
                        case "none":
                            font.underline = 0x00;
                            break;
                        case "single":
                            font.underline = 0x01;
                            break;
                        case "double":
                            font.underline = 0x02;
                            break;
                        case "singleAccounting":
                            font.underline = 0x21;
                            break;
                        case "doubleAccounting":
                            font.underline = 0x22;
                            break;
                    }
                    break;
                case '<u/>':
                    font.underline = 1;
                    break;
                /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                    font.strike = y.val ? parsexmlbool(y.val) : 1;
                    break;
                case '<strike/>':
                    font.strike = 1;
                    break;
                /* 18.4.2  outline CT_BooleanProperty */ case '<outline':
                    font.outline = y.val ? parsexmlbool(y.val) : 1;
                    break;
                case '<outline/>':
                    font.outline = 1;
                    break;
                /* 18.8.36 shadow CT_BooleanProperty */ case '<shadow':
                    font.shadow = y.val ? parsexmlbool(y.val) : 1;
                    break;
                case '<shadow/>':
                    font.shadow = 1;
                    break;
                /* 18.8.12 condense CT_BooleanProperty */ case '<condense':
                    font.condense = y.val ? parsexmlbool(y.val) : 1;
                    break;
                case '<condense/>':
                    font.condense = 1;
                    break;
                /* 18.8.17 extend CT_BooleanProperty */ case '<extend':
                    font.extend = y.val ? parsexmlbool(y.val) : 1;
                    break;
                case '<extend/>':
                    font.extend = 1;
                    break;
                /* 18.4.11 sz CT_FontSize */ case '<sz':
                    if (y.val) font.sz = +y.val;
                    break;
                case '<sz/>':
                case '</sz>':
                    break;
                /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case '<vertAlign':
                    if (y.val) font.vertAlign = y.val;
                    break;
                case '<vertAlign/>':
                case '</vertAlign>':
                    break;
                /* 18.8.18 family CT_FontFamily */ case '<family':
                    if (y.val) font.family = parseInt(y.val, 10);
                    break;
                case '<family/>':
                case '</family>':
                    break;
                /* 18.8.35 scheme CT_FontScheme */ case '<scheme':
                    if (y.val) font.scheme = y.val;
                    break;
                case '<scheme/>':
                case '</scheme>':
                    break;
                /* 18.4.1 charset CT_IntProperty */ case '<charset':
                    if (y.val == '1') break;
                    y.codepage = CS2CP[parseInt(y.val, 10)];
                    break;
                /* 18.?.? color CT_Color */ case '<color':
                    if (!font.color) font.color = {};
                    if (y.auto) font.color.auto = parsexmlbool(y.auto);
                    if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                    else if (y.indexed) {
                        font.color.index = parseInt(y.indexed, 10);
                        var icv = XLSIcv[font.color.index];
                        if (font.color.index == 81) icv = XLSIcv[1];
                        if (!icv) throw new Error(x);
                        font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                    } else if (y.theme) {
                        font.color.theme = parseInt(y.theme, 10);
                        if (y.tint) font.color.tint = parseFloat(y.tint);
                        if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                    }
                    break;
                case '<color/>':
                case '</color>':
                    break;
                /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                    pass = true;
                    break;
                case '</AlternateContent>':
                    pass = false;
                    break;
                /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
                case '<extLst>':
                case '</extLst>':
                    break;
                case '<ext':
                    pass = true;
                    break;
                case '</ext>':
                    pass = false;
                    break;
                default:
                    if (opts && opts.WTF) {
                        if (!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
                    }
            }
        });
    }
    /* 18.8.31 numFmts CT_NumFmts */ function parse_numFmts(t, styles, opts) {
        styles.NumberFmt = [];
        var k /*Array<number>*/  = keys(SSF._table);
        for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = SSF._table[k[i]];
        var m = t[0].match(tagregex);
        if (!m) return;
        for(i = 0; i < m.length; ++i){
            var y = parsexmltag(m[i]);
            switch(strip_ns(y[0])){
                case '<numFmts':
                case '</numFmts>':
                case '<numFmts/>':
                case '<numFmts>':
                    break;
                case '<numFmt':
                    var f = unescapexml(utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                    styles.NumberFmt[j] = f;
                    if (j > 0) {
                        if (j > 0x188) {
                            for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                            styles.NumberFmt[j] = f;
                        }
                        SSF.load(f, j);
                    }
                    break;
                case '</numFmt>':
                    break;
                default:
                    if (opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
            }
        }
    }
    function write_numFmts(NF) {
        var o = [
            "<numFmts>"
        ];
        [
            [
                5,
                8
            ],
            [
                23,
                26
            ],
            [
                41,
                44
            ],
            [
                /*63*/ 50,
                /*66],[164,*/ 392
            ]
        ].forEach(function(r) {
            for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = writextag('numFmt', null, {
                numFmtId: i,
                formatCode: escapexml(NF[i])
            });
        });
        if (o.length === 1) return "";
        o[o.length] = "</numFmts>";
        o[0] = writextag('numFmts', null, {
            count: o.length - 2
        }).replace("/>", ">");
        return o.join("");
    }
    /* 18.8.10 cellXfs CT_CellXfs */ var cellXF_uint = [
        "numFmtId",
        "fillId",
        "fontId",
        "borderId",
        "xfId"
    ];
    var cellXF_bool = [
        "applyAlignment",
        "applyBorder",
        "applyFill",
        "applyFont",
        "applyNumberFormat",
        "applyProtection",
        "pivotButton",
        "quotePrefix"
    ];
    function parse_cellXfs(t, styles, opts) {
        styles.CellXf = [];
        var xf;
        var pass = false;
        (t[0].match(tagregex) || []).forEach(function(x) {
            var y = parsexmltag(x), i = 0;
            switch(strip_ns(y[0])){
                case '<cellXfs':
                case '<cellXfs>':
                case '<cellXfs/>':
                case '</cellXfs>':
                    break;
                /* 18.8.45 xf CT_Xf */ case '<xf':
                case '<xf/>':
                    xf = y;
                    delete xf[0];
                    for(i = 0; i < cellXF_uint.length; ++i)if (xf[cellXF_uint[i]]) xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
                    for(i = 0; i < cellXF_bool.length; ++i)if (xf[cellXF_bool[i]]) xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
                    if (xf.numFmtId > 0x188) {
                        for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                            xf.numFmtId = i;
                            break;
                        }
                    }
                    styles.CellXf.push(xf);
                    break;
                case '</xf>':
                    break;
                /* 18.8.1 alignment CT_CellAlignment */ case '<alignment':
                case '<alignment/>':
                    var alignment = {};
                    if (y.vertical) alignment.vertical = y.vertical;
                    if (y.horizontal) alignment.horizontal = y.horizontal;
                    if (y.textRotation != null) alignment.textRotation = y.textRotation;
                    if (y.indent) alignment.indent = y.indent;
                    if (y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
                    xf.alignment = alignment;
                    break;
                case '</alignment>':
                    break;
                /* 18.8.33 protection CT_CellProtection */ case '<protection':
                    break;
                case '</protection>':
                case '<protection/>':
                    break;
                /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                    pass = true;
                    break;
                case '</AlternateContent>':
                    pass = false;
                    break;
                /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
                case '<extLst>':
                case '</extLst>':
                    break;
                case '<ext':
                    pass = true;
                    break;
                case '</ext>':
                    pass = false;
                    break;
                default:
                    if (opts && opts.WTF) {
                        if (!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
                    }
            }
        });
    }
    function write_cellXfs(cellXfs) {
        var o = [];
        o[o.length] = writextag('cellXfs', null);
        cellXfs.forEach(function(c) {
            o[o.length] = writextag('xf', null, c);
        });
        o[o.length] = "</cellXfs>";
        if (o.length === 2) return "";
        o[0] = writextag('cellXfs', null, {
            count: o.length - 2
        }).replace("/>", ">");
        return o.join("");
    }
    /* 18.8 Styles CT_Stylesheet*/ var parse_sty_xml = function make_pstyx() {
        var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
        var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
        var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
        var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
        var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
        return function parse_sty_xml(data, themes, opts) {
            var styles = {};
            if (!data) return styles;
            data = data.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
            /* 18.8.39 styleSheet CT_Stylesheet */ var t;
            /* 18.8.31 numFmts CT_NumFmts ? */ if (t = data.match(numFmtRegex)) parse_numFmts(t, styles, opts);
            /* 18.8.23 fonts CT_Fonts ? */ if (t = data.match(fontsRegex)) parse_fonts(t, styles, themes, opts);
            /* 18.8.21 fills CT_Fills ? */ if (t = data.match(fillsRegex)) parse_fills(t, styles, themes, opts);
            /* 18.8.5  borders CT_Borders ? */ if (t = data.match(bordersRegex)) parse_borders(t, styles, themes, opts);
            /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = data.match(cellXfRegex)) parse_cellXfs(t, styles, opts);
            /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
        };
    }();
    var STYLES_XML_ROOT = writextag('styleSheet', null, {
        'xmlns': XMLNS.main[0],
        'xmlns:vt': XMLNS.vt
    });
    RELS.STY = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";
    function write_sty_xml(wb, opts) {
        var o = [
            XML_HEADER,
            STYLES_XML_ROOT
        ], w;
        if (wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
        o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
        o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
        o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
        o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
        if (w = write_cellXfs(opts.cellXfs)) o[o.length] = w;
        o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
        o[o.length] = '<dxfs count="0"/>';
        o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
        if (o.length > 2) {
            o[o.length] = '</styleSheet>';
            o[1] = o[1].replace("/>", ">");
        }
        return o.join("");
    }
    /* [MS-XLSB] 2.4.657 BrtFmt */ function parse_BrtFmt(data, length) {
        var numFmtId = data.read_shift(2);
        var stFmtCode = parse_XLWideString(data, length - 2);
        return [
            numFmtId,
            stFmtCode
        ];
    }
    function write_BrtFmt(i, f, o) {
        if (!o) o = new_buf(6 + 4 * f.length);
        o.write_shift(2, i);
        write_XLWideString(f, o);
        var out = o.length > o.l ? o.slice(0, o.l) : o;
        if (o.l == null) o.l = o.length;
        return out;
    }
    /* [MS-XLSB] 2.4.659 BrtFont TODO */ function parse_BrtFont(data, length, opts) {
        var out = {};
        out.sz = data.read_shift(2) / 20;
        var grbit = parse_FontFlags(data, 2, opts);
        if (grbit.fItalic) out.italic = 1;
        if (grbit.fCondense) out.condense = 1;
        if (grbit.fExtend) out.extend = 1;
        if (grbit.fShadow) out.shadow = 1;
        if (grbit.fOutline) out.outline = 1;
        if (grbit.fStrikeout) out.strike = 1;
        var bls = data.read_shift(2);
        if (bls === 0x02BC) out.bold = 1;
        switch(data.read_shift(2)){
            /* case 0: out.vertAlign = "baseline"; break; */ case 1:
                out.vertAlign = "superscript";
                break;
            case 2:
                out.vertAlign = "subscript";
                break;
        }
        var underline = data.read_shift(1);
        if (underline != 0) out.underline = underline;
        var family = data.read_shift(1);
        if (family > 0) out.family = family;
        var bCharSet = data.read_shift(1);
        if (bCharSet > 0) out.charset = bCharSet;
        data.l++;
        out.color = parse_BrtColor(data, 8);
        switch(data.read_shift(1)){
            /* case 0: out.scheme = "none": break; */ case 1:
                out.scheme = "major";
                break;
            case 2:
                out.scheme = "minor";
                break;
        }
        out.name = parse_XLWideString(data, length - 21);
        return out;
    }
    function write_BrtFont(font, o) {
        if (!o) o = new_buf(153);
        o.write_shift(2, font.sz * 20);
        write_FontFlags(font, o);
        o.write_shift(2, font.bold ? 0x02BC : 0x0190);
        var sss = 0;
        if (font.vertAlign == "superscript") sss = 1;
        else if (font.vertAlign == "subscript") sss = 2;
        o.write_shift(2, sss);
        o.write_shift(1, font.underline || 0);
        o.write_shift(1, font.family || 0);
        o.write_shift(1, font.charset || 0);
        o.write_shift(1, 0);
        write_BrtColor(font.color, o);
        var scheme = 0;
        if (font.scheme == "major") scheme = 1;
        if (font.scheme == "minor") scheme = 2;
        o.write_shift(1, scheme);
        write_XLWideString(font.name, o);
        return o.length > o.l ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.4.650 BrtFill */ var XLSBFillPTNames = [
        "none",
        "solid",
        "mediumGray",
        "darkGray",
        "lightGray",
        "darkHorizontal",
        "darkVertical",
        "darkDown",
        "darkUp",
        "darkGrid",
        "darkTrellis",
        "lightHorizontal",
        "lightVertical",
        "lightDown",
        "lightUp",
        "lightGrid",
        "lightTrellis",
        "gray125",
        "gray0625"
    ];
    var rev_XLSBFillPTNames = evert(XLSBFillPTNames);
    /* TODO: gradient fill representation */ var parse_BrtFill = parsenoop;
    function write_BrtFill(fill, o) {
        if (!o) o = new_buf(84);
        var fls = rev_XLSBFillPTNames[fill.patternType];
        if (fls == null) fls = 0x28;
        o.write_shift(4, fls);
        var j = 0;
        if (fls != 0x28) {
            /* TODO: custom FG Color */ write_BrtColor({
                auto: 1
            }, o);
            /* TODO: custom BG Color */ write_BrtColor({
                auto: 1
            }, o);
            for(; j < 12; ++j)o.write_shift(4, 0);
        } else {
            for(; j < 4; ++j)o.write_shift(4, 0);
            for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
        /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
        return o.length > o.l ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.4.824 BrtXF */ function parse_BrtXF(data, length) {
        var tgt = data.l + length;
        var ixfeParent = data.read_shift(2);
        var ifmt = data.read_shift(2);
        data.l = tgt;
        return {
            ixfe: ixfeParent,
            numFmtId: ifmt
        };
    }
    function write_BrtXF(data, ixfeP, o) {
        if (!o) o = new_buf(16);
        o.write_shift(2, ixfeP || 0);
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0); /* iFont */ 
        o.write_shift(2, 0); /* iFill */ 
        o.write_shift(2, 0); /* ixBorder */ 
        o.write_shift(1, 0); /* trot */ 
        o.write_shift(1, 0); /* indent */ 
        var flow = 0;
        o.write_shift(1, flow); /* flags */ 
        o.write_shift(1, 0); /* flags */ 
        o.write_shift(1, 0); /* xfGrbitAtr */ 
        o.write_shift(1, 0);
        return o;
    }
    /* [MS-XLSB] 2.5.4 Blxf TODO */ function write_Blxf(data, o) {
        if (!o) o = new_buf(10);
        o.write_shift(1, 0); /* dg */ 
        o.write_shift(1, 0);
        o.write_shift(4, 0); /* color */ 
        o.write_shift(4, 0); /* color */ 
        return o;
    }
    /* [MS-XLSB] 2.4.302 BrtBorder TODO */ var parse_BrtBorder = parsenoop;
    function write_BrtBorder(border, o) {
        if (!o) o = new_buf(51);
        o.write_shift(1, 0); /* diagonal */ 
        write_Blxf(null, o); /* top */ 
        write_Blxf(null, o); /* bottom */ 
        write_Blxf(null, o); /* left */ 
        write_Blxf(null, o); /* right */ 
        write_Blxf(null, o); /* diag */ 
        return o.length > o.l ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.4.763 BrtStyle TODO */ function write_BrtStyle(style, o) {
        if (!o) o = new_buf(52);
        o.write_shift(4, style.xfId);
        o.write_shift(2, 1);
        o.write_shift(1, +style.builtinId);
        o.write_shift(1, 0); /* iLevel */ 
        write_XLNullableWideString(style.name || "", o);
        return o.length > o.l ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
        var o = new_buf(2052);
        o.write_shift(4, cnt);
        write_XLNullableWideString(defTableStyle, o);
        write_XLNullableWideString(defPivotStyle, o);
        return o.length > o.l ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.1.7.50 Styles */ function parse_sty_bin(data, themes, opts) {
        var styles = {};
        styles.NumberFmt = [];
        for(var y in SSF._table)styles.NumberFmt[y] = SSF._table[y];
        styles.CellXf = [];
        styles.Fonts = [];
        var state = [];
        var pass = false;
        recordhopper(data, function hopper_sty(val, R_n, RT) {
            switch(RT){
                case 0x002C:
                    /* 'BrtFmt' */ styles.NumberFmt[val[0]] = val[1];
                    SSF.load(val[1], val[0]);
                    break;
                case 0x002B:
                    /* 'BrtFont' */ styles.Fonts.push(val);
                    if (val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
                    break;
                case 0x0401:
                    break;
                case 0x002D:
                    break;
                case 0x002E:
                    break;
                case 0x002F:
                    /* 'BrtXF' */ if (state[state.length - 1] == "BrtBeginCellXFs") styles.CellXf.push(val);
                    break;
                case 0x0030:
                /* 'BrtStyle' */ case 0x01FB:
                /* 'BrtDXF' */ case 0x023C:
                /* 'BrtMRUColor' */ case 0x01DB:
                    break;
                case 0x0493:
                /* 'BrtDXF14' */ case 0x0836:
                /* 'BrtDXF15' */ case 0x046A:
                /* 'BrtSlicerStyleElement' */ case 0x0200:
                /* 'BrtTableStyleElement' */ case 0x082F:
                /* 'BrtTimelineStyleElement' */ case 0x0C00:
                    break;
                case 0x0023:
                    /* 'BrtFRTBegin' */ pass = true;
                    break;
                case 0x0024:
                    /* 'BrtFRTEnd' */ pass = false;
                    break;
                case 0x0025:
                    /* 'BrtACBegin' */ state.push(R_n);
                    pass = true;
                    break;
                case 0x0026:
                    /* 'BrtACEnd' */ state.pop();
                    pass = false;
                    break;
                default:
                    if ((R_n || "").indexOf("Begin") > 0) state.push(R_n);
                    else if ((R_n || "").indexOf("End") > 0) state.pop();
                    else if (!pass || opts.WTF && state[state.length - 1] != "BrtACBegin") throw new Error("Unexpected record " + RT + " " + R_n);
            }
        });
        return styles;
    }
    function write_FMTS_bin(ba, NF) {
        if (!NF) return;
        var cnt = 0;
        [
            [
                5,
                8
            ],
            [
                23,
                26
            ],
            [
                41,
                44
            ],
            [
                /*63*/ 50,
                /*66],[164,*/ 392
            ]
        ].forEach(function(r) {
            for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
        });
        if (cnt == 0) return;
        write_record(ba, "BrtBeginFmts", write_UInt32LE(cnt));
        [
            [
                5,
                8
            ],
            [
                23,
                26
            ],
            [
                41,
                44
            ],
            [
                /*63*/ 50,
                /*66],[164,*/ 392
            ]
        ].forEach(function(r) {
            for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) write_record(ba, "BrtFmt", write_BrtFmt(i, NF[i]));
        });
        write_record(ba, "BrtEndFmts");
    }
    function write_FONTS_bin(ba) {
        var cnt = 1;
        if (cnt == 0) return;
        write_record(ba, "BrtBeginFonts", write_UInt32LE(cnt));
        write_record(ba, "BrtFont", write_BrtFont({
            sz: 12,
            color: {
                theme: 1
            },
            name: "Calibri",
            family: 2,
            scheme: "minor"
        }));
        /* 1*65491BrtFont [ACFONTS] */ write_record(ba, "BrtEndFonts");
    }
    function write_FILLS_bin(ba) {
        var cnt = 2;
        if (cnt == 0) return;
        write_record(ba, "BrtBeginFills", write_UInt32LE(cnt));
        write_record(ba, "BrtFill", write_BrtFill({
            patternType: "none"
        }));
        write_record(ba, "BrtFill", write_BrtFill({
            patternType: "gray125"
        }));
        /* 1*65431BrtFill */ write_record(ba, "BrtEndFills");
    }
    function write_BORDERS_bin(ba) {
        var cnt = 1;
        if (cnt == 0) return;
        write_record(ba, "BrtBeginBorders", write_UInt32LE(cnt));
        write_record(ba, "BrtBorder", write_BrtBorder({}));
        /* 1*65430BrtBorder */ write_record(ba, "BrtEndBorders");
    }
    function write_CELLSTYLEXFS_bin(ba) {
        var cnt = 1;
        write_record(ba, "BrtBeginCellStyleXFs", write_UInt32LE(cnt));
        write_record(ba, "BrtXF", write_BrtXF({
            numFmtId: 0,
            fontId: 0,
            fillId: 0,
            borderId: 0
        }, 0xFFFF));
        /* 1*65430(BrtXF *FRT) */ write_record(ba, "BrtEndCellStyleXFs");
    }
    function write_CELLXFS_bin(ba, data) {
        write_record(ba, "BrtBeginCellXFs", write_UInt32LE(data.length));
        data.forEach(function(c) {
            write_record(ba, "BrtXF", write_BrtXF(c, 0));
        });
        /* 1*65430(BrtXF *FRT) */ write_record(ba, "BrtEndCellXFs");
    }
    function write_STYLES_bin(ba) {
        var cnt = 1;
        write_record(ba, "BrtBeginStyles", write_UInt32LE(cnt));
        write_record(ba, "BrtStyle", write_BrtStyle({
            xfId: 0,
            builtinId: 0,
            name: "Normal"
        }));
        /* 1*65430(BrtStyle *FRT) */ write_record(ba, "BrtEndStyles");
    }
    function write_DXFS_bin(ba) {
        var cnt = 0;
        write_record(ba, "BrtBeginDXFs", write_UInt32LE(cnt));
        /* *2147483647(BrtDXF *FRT) */ write_record(ba, "BrtEndDXFs");
    }
    function write_TABLESTYLES_bin(ba) {
        var cnt = 0;
        write_record(ba, "BrtBeginTableStyles", write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
        /* *TABLESTYLE */ write_record(ba, "BrtEndTableStyles");
    }
    function write_COLORPALETTE_bin() {
        return;
    /* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
    /* [MS-XLSB] 2.1.7.50 Styles */ function write_sty_bin(wb, opts) {
        var ba = buf_array();
        write_record(ba, "BrtBeginStyleSheet");
        write_FMTS_bin(ba, wb.SSF);
        write_FONTS_bin(ba, wb);
        write_FILLS_bin(ba, wb);
        write_BORDERS_bin(ba, wb);
        write_CELLSTYLEXFS_bin(ba, wb);
        write_CELLXFS_bin(ba, opts.cellXfs);
        write_STYLES_bin(ba, wb);
        write_DXFS_bin(ba, wb);
        write_TABLESTYLES_bin(ba, wb);
        write_COLORPALETTE_bin(ba, wb);
        /* FRTSTYLESHEET*/ write_record(ba, "BrtEndStyleSheet");
        return ba.end();
    }
    RELS.THEME = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";
    /* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var XLSXThemeClrScheme = [
        '</a:lt1>',
        '</a:dk1>',
        '</a:lt2>',
        '</a:dk2>',
        '</a:accent1>',
        '</a:accent2>',
        '</a:accent3>',
        '</a:accent4>',
        '</a:accent5>',
        '</a:accent6>',
        '</a:hlink>',
        '</a:folHlink>'
    ];
    /* 20.1.6.2 clrScheme CT_ColorScheme */ function parse_clrScheme(t, themes, opts) {
        themes.themeElements.clrScheme = [];
        var color = {};
        (t[0].match(tagregex) || []).forEach(function(x) {
            var y = parsexmltag(x);
            switch(y[0]){
                /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case '<a:clrScheme':
                case '</a:clrScheme>':
                    break;
                /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case '<a:srgbClr':
                    color.rgb = y.val;
                    break;
                /* 20.1.2.3.33 sysClr CT_SystemColor */ case '<a:sysClr':
                    color.rgb = y.lastClr;
                    break;
                /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case '<a:dk1>':
                case '</a:dk1>':
                case '<a:lt1>':
                case '</a:lt1>':
                case '<a:dk2>':
                case '</a:dk2>':
                case '<a:lt2>':
                case '</a:lt2>':
                case '<a:accent1>':
                case '</a:accent1>':
                case '<a:accent2>':
                case '</a:accent2>':
                case '<a:accent3>':
                case '</a:accent3>':
                case '<a:accent4>':
                case '</a:accent4>':
                case '<a:accent5>':
                case '</a:accent5>':
                case '<a:accent6>':
                case '</a:accent6>':
                case '<a:hlink>':
                case '</a:hlink>':
                case '<a:folHlink>':
                case '</a:folHlink>':
                    if (y[0].charAt(1) === '/') {
                        themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])] = color;
                        color = {};
                    } else color.name = y[0].slice(3, y[0].length - 1);
                    break;
                default:
                    if (opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
            }
        });
    }
    /* 20.1.4.1.18 fontScheme CT_FontScheme */ function parse_fontScheme() {}
    /* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function parse_fmtScheme() {}
    var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
    var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
    var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
    /* 20.1.6.10 themeElements CT_BaseStyles */ function parse_themeElements(data, themes, opts) {
        themes.themeElements = {};
        var t;
        [
            /* clrScheme CT_ColorScheme */ [
                'clrScheme',
                clrsregex,
                parse_clrScheme
            ],
            /* fontScheme CT_FontScheme */ [
                'fontScheme',
                fntsregex,
                parse_fontScheme
            ],
            /* fmtScheme CT_StyleMatrix */ [
                'fmtScheme',
                fmtsregex,
                parse_fmtScheme
            ]
        ].forEach(function(m) {
            if (!(t = data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
            m[2](t, themes, opts);
        });
    }
    var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
    /* 14.2.7 Theme Part */ function parse_theme_xml(data, opts) {
        /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) return parse_theme_xml(write_theme());
        var t;
        var themes = {};
        /* themeElements CT_BaseStyles */ if (!(t = data.match(themeltregex))) throw new Error('themeElements not found in theme');
        parse_themeElements(t[0], themes, opts);
        themes.raw = data;
        return themes;
    }
    function write_theme(Themes, opts) {
        if (opts && opts.themeXLSX) return opts.themeXLSX;
        if (Themes && typeof Themes.raw == "string") return Themes.raw;
        var o = [
            XML_HEADER
        ];
        o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
        o[o.length] = '<a:themeElements>';
        o[o.length] = '<a:clrScheme name="Office">';
        o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
        o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
        o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
        o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
        o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
        o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
        o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
        o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
        o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
        o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
        o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
        o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
        o[o.length] = '</a:clrScheme>';
        o[o.length] = '<a:fontScheme name="Office">';
        o[o.length] = '<a:majorFont>';
        o[o.length] = '<a:latin typeface="Cambria"/>';
        o[o.length] = '<a:ea typeface=""/>';
        o[o.length] = '<a:cs typeface=""/>';
        o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
        o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
        o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
        o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
        o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
        o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
        o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
        o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
        o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
        o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
        o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
        o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
        o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
        o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
        o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
        o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
        o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
        o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
        o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
        o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
        o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
        o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
        o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
        o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
        o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
        o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
        o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
        o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
        o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
        o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
        o[o.length] = '</a:majorFont>';
        o[o.length] = '<a:minorFont>';
        o[o.length] = '<a:latin typeface="Calibri"/>';
        o[o.length] = '<a:ea typeface=""/>';
        o[o.length] = '<a:cs typeface=""/>';
        o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
        o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
        o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
        o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
        o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
        o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
        o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
        o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
        o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
        o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
        o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
        o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
        o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
        o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
        o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
        o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
        o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
        o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
        o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
        o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
        o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
        o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
        o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
        o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
        o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
        o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
        o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
        o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
        o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
        o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
        o[o.length] = '</a:minorFont>';
        o[o.length] = '</a:fontScheme>';
        o[o.length] = '<a:fmtScheme name="Office">';
        o[o.length] = '<a:fillStyleLst>';
        o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
        o[o.length] = '<a:gradFill rotWithShape="1">';
        o[o.length] = '<a:gsLst>';
        o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
        o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
        o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
        o[o.length] = '</a:gsLst>';
        o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
        o[o.length] = '</a:gradFill>';
        o[o.length] = '<a:gradFill rotWithShape="1">';
        o[o.length] = '<a:gsLst>';
        o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
        o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
        o[o.length] = '</a:gsLst>';
        o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
        o[o.length] = '</a:gradFill>';
        o[o.length] = '</a:fillStyleLst>';
        o[o.length] = '<a:lnStyleLst>';
        o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
        o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
        o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
        o[o.length] = '</a:lnStyleLst>';
        o[o.length] = '<a:effectStyleLst>';
        o[o.length] = '<a:effectStyle>';
        o[o.length] = '<a:effectLst>';
        o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
        o[o.length] = '</a:effectLst>';
        o[o.length] = '</a:effectStyle>';
        o[o.length] = '<a:effectStyle>';
        o[o.length] = '<a:effectLst>';
        o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
        o[o.length] = '</a:effectLst>';
        o[o.length] = '</a:effectStyle>';
        o[o.length] = '<a:effectStyle>';
        o[o.length] = '<a:effectLst>';
        o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
        o[o.length] = '</a:effectLst>';
        o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
        o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
        o[o.length] = '</a:effectStyle>';
        o[o.length] = '</a:effectStyleLst>';
        o[o.length] = '<a:bgFillStyleLst>';
        o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
        o[o.length] = '<a:gradFill rotWithShape="1">';
        o[o.length] = '<a:gsLst>';
        o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
        o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
        o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
        o[o.length] = '</a:gsLst>';
        o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
        o[o.length] = '</a:gradFill>';
        o[o.length] = '<a:gradFill rotWithShape="1">';
        o[o.length] = '<a:gsLst>';
        o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
        o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
        o[o.length] = '</a:gsLst>';
        o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
        o[o.length] = '</a:gradFill>';
        o[o.length] = '</a:bgFillStyleLst>';
        o[o.length] = '</a:fmtScheme>';
        o[o.length] = '</a:themeElements>';
        o[o.length] = '<a:objectDefaults>';
        o[o.length] = '<a:spDef>';
        o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
        o[o.length] = '</a:spDef>';
        o[o.length] = '<a:lnDef>';
        o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
        o[o.length] = '</a:lnDef>';
        o[o.length] = '</a:objectDefaults>';
        o[o.length] = '<a:extraClrSchemeLst/>';
        o[o.length] = '</a:theme>';
        return o.join("");
    }
    /* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function parse_Theme(blob, length, opts) {
        var end = blob.l + length;
        var dwThemeVersion = blob.read_shift(4);
        if (dwThemeVersion === 124226) return;
        if (!opts.cellStyles || !jszip) {
            blob.l = end;
            return;
        }
        var data = blob.slice(blob.l);
        blob.l = end;
        var zip;
        try {
            zip = new jszip(data);
        } catch (e) {
            return;
        }
        var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
        if (!themeXML) return;
        return parse_theme_xml(themeXML, opts);
    }
    /* 2.5.49 */ function parse_ColorTheme(blob) {
        return blob.read_shift(4);
    }
    /* 2.5.155 */ function parse_FullColorExt(blob) {
        var o = {};
        o.xclrType = blob.read_shift(2);
        o.nTintShade = blob.read_shift(2);
        switch(o.xclrType){
            case 0:
                blob.l += 4;
                break;
            case 1:
                o.xclrValue = parse_IcvXF(blob, 4);
                break;
            case 2:
                o.xclrValue = parse_LongRGBA(blob, 4);
                break;
            case 3:
                o.xclrValue = parse_ColorTheme(blob, 4);
                break;
            case 4:
                blob.l += 4;
                break;
        }
        blob.l += 8;
        return o;
    }
    /* 2.5.164 TODO: read 7 bits*/ function parse_IcvXF(blob, length) {
        return parsenoop(blob, length);
    }
    /* 2.5.280 */ function parse_XFExtGradient(blob, length) {
        return parsenoop(blob, length);
    }
    /* [MS-XLS] 2.5.108 */ function parse_ExtProp(blob) {
        var extType = blob.read_shift(2);
        var cb = blob.read_shift(2) - 4;
        var o = [
            extType
        ];
        switch(extType){
            case 0x04:
            case 0x05:
            case 0x07:
            case 0x08:
            case 0x09:
            case 0x0A:
            case 0x0B:
            case 0x0D:
                o[1] = parse_FullColorExt(blob, cb);
                break;
            case 0x06:
                o[1] = parse_XFExtGradient(blob, cb);
                break;
            case 0x0E:
            case 0x0F:
                o[1] = blob.read_shift(cb === 1 ? 1 : 2);
                break;
            default:
                throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
        }
        return o;
    }
    /* 2.4.355 */ function parse_XFExt(blob, length) {
        var end = blob.l + length;
        blob.l += 2;
        var ixfe = blob.read_shift(2);
        blob.l += 2;
        var cexts = blob.read_shift(2);
        var ext = [];
        while(cexts-- > 0)ext.push(parse_ExtProp(blob, end - blob.l));
        return {
            ixfe: ixfe,
            ext: ext
        };
    }
    /* xf is an XF, see parse_XFExt for xfext */ function update_xfext(xf, xfext) {
        xfext.forEach(function(xfe) {
            xfe[0];
        });
    }
    /* 18.6 Calculation Chain */ function parse_cc_xml(data) {
        var d = [];
        if (!data) return d;
        var i = 1;
        (data.match(tagregex) || []).forEach(function(x) {
            var y = parsexmltag(x);
            switch(y[0]){
                case '<?xml':
                    break;
                /* 18.6.2  calcChain CT_CalcChain 1 */ case '<calcChain':
                case '<calcChain>':
                case '</calcChain>':
                    break;
                /* 18.6.1  c CT_CalcCell 1 */ case '<c':
                    delete y[0];
                    if (y.i) i = y.i;
                    else y.i = i;
                    d.push(y);
                    break;
            }
        });
        return d;
    }
    //function write_cc_xml(data, opts) { }
    /* [MS-XLSB] 2.6.4.1 */ function parse_BrtCalcChainItem$(data) {
        var out = {};
        out.i = data.read_shift(4);
        var cell = {};
        cell.r = data.read_shift(4);
        cell.c = data.read_shift(4);
        out.r = encode_cell(cell);
        var flags = data.read_shift(1);
        if (flags & 0x2) out.l = '1';
        if (flags & 0x8) out.a = '1';
        return out;
    }
    /* 18.6 Calculation Chain */ function parse_cc_bin(data, name, opts) {
        var out = [];
        var pass = false;
        recordhopper(data, function hopper_cc(val, R_n, RT) {
            switch(RT){
                case 0x003F:
                    /* 'BrtCalcChainItem$' */ out.push(val);
                    break;
                default:
                    if ((R_n || "").indexOf("Begin") > 0) ;
                    else if ((R_n || "").indexOf("End") > 0) ;
                    else if (!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
            }
        });
        return out;
    }
    //function write_cc_bin(data, opts) { }
    /* 18.14 Supplementary Workbook Data */ function parse_xlink_xml() {
    //var opts = _opts || {};
    //if(opts.WTF) throw "XLSX External Link";
    }
    /* [MS-XLSB] 2.1.7.25 External Link */ function parse_xlink_bin(data, rel, name, _opts) {
        if (!data) return data;
        var opts = _opts || {};
        var pass = false, end = false;
        recordhopper(data, function xlink_parse(val, R_n, RT) {
            if (end) return;
            switch(RT){
                case 0x0167:
                /* 'BrtSupTabs' */ case 0x016B:
                /* 'BrtExternTableStart' */ case 0x016C:
                /* 'BrtExternTableEnd' */ case 0x016E:
                /* 'BrtExternRowHdr' */ case 0x016F:
                /* 'BrtExternCellBlank' */ case 0x0170:
                /* 'BrtExternCellReal' */ case 0x0171:
                /* 'BrtExternCellBool' */ case 0x0172:
                /* 'BrtExternCellError' */ case 0x0173:
                /* 'BrtExternCellString' */ case 0x01D8:
                /* 'BrtExternValueMeta' */ case 0x0241:
                /* 'BrtSupNameStart' */ case 0x0242:
                /* 'BrtSupNameValueStart' */ case 0x0243:
                /* 'BrtSupNameValueEnd' */ case 0x0244:
                /* 'BrtSupNameNum' */ case 0x0245:
                /* 'BrtSupNameErr' */ case 0x0246:
                /* 'BrtSupNameSt' */ case 0x0247:
                /* 'BrtSupNameNil' */ case 0x0248:
                /* 'BrtSupNameBool' */ case 0x0249:
                /* 'BrtSupNameFmla' */ case 0x024A:
                /* 'BrtSupNameBits' */ case 0x024B:
                    break;
                case 0x0023:
                    /* 'BrtFRTBegin' */ pass = true;
                    break;
                case 0x0024:
                    /* 'BrtFRTEnd' */ pass = false;
                    break;
                default:
                    if ((R_n || "").indexOf("Begin") > 0) ;
                    else if ((R_n || "").indexOf("End") > 0) ;
                    else if (!pass || opts.WTF) throw new Error("Unexpected record " + RT.toString(16) + " " + R_n);
            }
        }, opts);
    }
    /* 20.5 DrawingML - SpreadsheetML Drawing */ RELS.IMG = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
    RELS.DRAW = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";
    /* 20.5.2.35 wsDr CT_Drawing */ function parse_drawing(data, rels) {
        if (!data) return "??";
        /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/) || [
            "",
            ""
        ])[1];
        return rels['!id'][id].Target;
    }
    /* L.5.5.2 SpreadsheetML Comments + VML Schema */ var _shapeid = 1024;
    function write_comments_vml(rId, comments) {
        var csize = [
            21600,
            21600
        ];
        /* L.5.2.1.2 Path Attribute */ var bbox = [
            "m0,0l0",
            csize[1],
            csize[0],
            csize[1],
            csize[0],
            "0xe"
        ].join(",");
        var o = [
            writextag("xml", null, {
                'xmlns:v': XLMLNS.v,
                'xmlns:o': XLMLNS.o,
                'xmlns:x': XLMLNS.x,
                'xmlns:mv': XLMLNS.mv
            }).replace(/\/>/, ">"),
            writextag("o:shapelayout", writextag("o:idmap", null, {
                'v:ext': "edit",
                'data': rId
            }), {
                'v:ext': "edit"
            }),
            writextag("v:shapetype", [
                writextag("v:stroke", null, {
                    joinstyle: "miter"
                }),
                writextag("v:path", null, {
                    gradientshapeok: "t",
                    'o:connecttype': "rect"
                })
            ].join(""), {
                id: "_x0000_t202",
                'o:spt': 202,
                coordsize: csize.join(","),
                path: bbox
            })
        ];
        while(_shapeid < rId * 1000)_shapeid += 1000;
        comments.forEach(function(x) {
            var c = decode_cell(x[0]);
            var fillopts = {
                'color2': "#BEFF82",
                'type': "gradient"
            };
            if (fillopts.type == "gradient") fillopts.angle = "-180";
            var fillparm = fillopts.type == "gradient" ? writextag("o:fill", null, {
                type: "gradientUnscaled",
                'v:ext': "view"
            }) : null;
            var fillxml = writextag('v:fill', fillparm, fillopts);
            var shadata = {
                on: "t",
                'obscured': "t"
            };
            ++_shapeid;
            o = o.concat([
                '<v:shape' + wxt_helper({
                    id: '_x0000_s' + _shapeid,
                    type: "#_x0000_t202",
                    style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
                    fillcolor: "#ECFAD4",
                    strokecolor: "#edeaa1"
                }) + '>',
                fillxml,
                writextag("v:shadow", null, shadata),
                writextag("v:path", null, {
                    'o:connecttype': "none"
                }),
                '<v:textbox><div style="text-align:left"></div></v:textbox>',
                '<x:ClientData ObjectType="Note">',
                '<x:MoveWithCells/>',
                '<x:SizeWithCells/>',
                /* Part 4 19.4.2.3 Anchor (Anchor) */ writetag('x:Anchor', [
                    c.c + 1,
                    0,
                    c.r + 1,
                    0,
                    c.c + 3,
                    20,
                    c.r + 5,
                    20
                ].join(",")),
                writetag('x:AutoFill', "False"),
                writetag('x:Row', String(c.r)),
                writetag('x:Column', String(c.c)),
                x[1].hidden ? '' : '<x:Visible/>',
                '</x:ClientData>',
                '</v:shape>'
            ]);
        });
        o.push('</xml>');
        return o.join("");
    }
    RELS.CMNT = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";
    function sheet_insert_comments(sheet, comments) {
        var dense = Array.isArray(sheet);
        var cell;
        comments.forEach(function(comment) {
            var r = decode_cell(comment.ref);
            if (dense) {
                if (!sheet[r.r]) sheet[r.r] = [];
                cell = sheet[r.r][r.c];
            } else cell = sheet[comment.ref];
            if (!cell) {
                cell = {
                    t: "z"
                };
                if (dense) sheet[r.r][r.c] = cell;
                else sheet[comment.ref] = cell;
                var range = safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
                if (range.s.r > r.r) range.s.r = r.r;
                if (range.e.r < r.r) range.e.r = r.r;
                if (range.s.c > r.c) range.s.c = r.c;
                if (range.e.c < r.c) range.e.c = r.c;
                var encoded = encode_range(range);
                if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
            }
            if (!cell.c) cell.c = [];
            var o = {
                a: comment.author,
                t: comment.t,
                r: comment.r
            };
            if (comment.h) o.h = comment.h;
            cell.c.push(o);
        });
    }
    /* 18.7 Comments */ function parse_comments_xml(data, opts) {
        /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
        var authors = [];
        var commentList = [];
        var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
        if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
            if (x === "" || x.trim() === "") return;
            var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
            if (a) authors.push(a[1]);
        });
        var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
        if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
            if (x === "" || x.trim() === "") return;
            var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
            if (!cm) return;
            var y = parsexmltag(cm[0]);
            var comment = {
                author: y.authorId && authors[y.authorId] || "sheetjsghost",
                ref: y.ref,
                guid: y.guid
            };
            var cell = decode_cell(y.ref);
            if (opts.sheetRows && opts.sheetRows <= cell.r) return;
            var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
            var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {
                r: "",
                t: "",
                h: ""
            };
            comment.r = rt.r;
            if (rt.r == "<t></t>") rt.t = rt.h = "";
            comment.t = rt.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
            if (opts.cellHTML) comment.h = rt.h;
            commentList.push(comment);
        });
        return commentList;
    }
    var CMNT_XML_ROOT = writextag('comments', null, {
        'xmlns': XMLNS.main[0]
    });
    function write_comments_xml(data) {
        var o = [
            XML_HEADER,
            CMNT_XML_ROOT
        ];
        var iauthor = [];
        o.push("<authors>");
        data.forEach(function(x) {
            x[1].forEach(function(w) {
                var a = escapexml(w.a);
                if (iauthor.indexOf(a) > -1) return;
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            });
        });
        o.push("</authors>");
        o.push("<commentList>");
        data.forEach(function(d) {
            d[1].forEach(function(c) {
                /* 18.7.3 CT_Comment */ o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf(escapexml(c.a)) + '"><text>');
                o.push(writetag("t", c.t == null ? "" : escapexml(c.t)));
                o.push('</text></comment>');
            });
        });
        o.push("</commentList>");
        if (o.length > 2) {
            o[o.length] = '</comments>';
            o[1] = o[1].replace("/>", ">");
        }
        return o.join("");
    }
    /* [MS-XLSB] 2.4.28 BrtBeginComment */ function parse_BrtBeginComment(data) {
        var out = {};
        out.iauthor = data.read_shift(4);
        var rfx = parse_UncheckedRfX(data, 16);
        out.rfx = rfx.s;
        out.ref = encode_cell(rfx.s);
        data.l += 16; /*var guid = parse_GUID(data); */ 
        return out;
    }
    function write_BrtBeginComment(data, o) {
        if (o == null) o = new_buf(36);
        o.write_shift(4, data[1].iauthor);
        write_UncheckedRfX(data[0], o);
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    /* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var parse_BrtCommentAuthor = parse_XLWideString;
    function write_BrtCommentAuthor(data) {
        return write_XLWideString(data.slice(0, 54));
    }
    /* [MS-XLSB] 2.1.7.8 Comments */ function parse_comments_bin(data, opts) {
        var out = [];
        var authors = [];
        var c = {};
        var pass = false;
        recordhopper(data, function hopper_cmnt(val, R_n, RT) {
            switch(RT){
                case 0x0278:
                    /* 'BrtCommentAuthor' */ authors.push(val);
                    break;
                case 0x027B:
                    /* 'BrtBeginComment' */ c = val;
                    break;
                case 0x027D:
                    /* 'BrtCommentText' */ c.t = val.t;
                    c.h = val.h;
                    c.r = val.r;
                    break;
                case 0x027C:
                    /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                    delete c.iauthor;
                    if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                    if (!c.t) c.t = "";
                    delete c.rfx;
                    out.push(c);
                    break;
                case 0x0C00:
                    break;
                case 0x0023:
                    /* 'BrtFRTBegin' */ pass = true;
                    break;
                case 0x0024:
                    /* 'BrtFRTEnd' */ pass = false;
                    break;
                case 0x0025:
                    break;
                case 0x0026:
                    break;
                default:
                    if ((R_n || "").indexOf("Begin") > 0) ;
                    else if ((R_n || "").indexOf("End") > 0) ;
                    else if (!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
            }
        });
        return out;
    }
    function write_comments_bin(data) {
        var ba = buf_array();
        var iauthor = [];
        write_record(ba, "BrtBeginComments");
        write_record(ba, "BrtBeginCommentAuthors");
        data.forEach(function(comment) {
            comment[1].forEach(function(c) {
                if (iauthor.indexOf(c.a) > -1) return;
                iauthor.push(c.a.slice(0, 54));
                write_record(ba, "BrtCommentAuthor", write_BrtCommentAuthor(c.a));
            });
        });
        write_record(ba, "BrtEndCommentAuthors");
        write_record(ba, "BrtBeginCommentList");
        data.forEach(function(comment) {
            comment[1].forEach(function(c) {
                c.iauthor = iauthor.indexOf(c.a);
                var range = {
                    s: decode_cell(comment[0]),
                    e: decode_cell(comment[0])
                };
                write_record(ba, "BrtBeginComment", write_BrtBeginComment([
                    range,
                    c
                ]));
                if (c.t && c.t.length > 0) write_record(ba, "BrtCommentText", write_BrtCommentText(c));
                write_record(ba, "BrtEndComment");
                delete c.iauthor;
            });
        });
        write_record(ba, "BrtEndCommentList");
        write_record(ba, "BrtEndComments");
        return ba.end();
    }
    var CT_VBA = "application/vnd.ms-office.vbaProject";
    function make_vba_xls(cfb) {
        var newcfb = CFB.utils.cfb_new({
            root: "R"
        });
        cfb.FullPaths.forEach(function(p, i) {
            if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
            var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
            CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
        });
        return CFB.write(newcfb);
    }
    function fill_vba_xls(cfb, vba) {
        vba.FullPaths.forEach(function(p, i) {
            if (i == 0) return;
            var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
            if (newpath.slice(-1) !== "/") CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
        });
    }
    var VBAFMTS = [
        "xlsb",
        "xlsm",
        "xlam",
        "biff8",
        "xla"
    ];
    RELS.DS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";
    RELS.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";
    /* macro and dialog sheet stubs */ function parse_ds_bin() {
        return {
            '!type': 'dialog'
        };
    }
    function parse_ds_xml() {
        return {
            '!type': 'dialog'
        };
    }
    function parse_ms_bin() {
        return {
            '!type': 'macro'
        };
    }
    function parse_ms_xml() {
        return {
            '!type': 'macro'
        };
    }
    /* TODO: it will be useful to parse the function str */ var rc_to_a1 = function() {
        var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
        var rcbase = {
            r: 0,
            c: 0
        };
        function rcfunc($$, $1, $2, $3) {
            var cRel = false, rRel = false;
            if ($2.length == 0) rRel = true;
            else if ($2.charAt(0) == "[") {
                rRel = true;
                $2 = $2.slice(1, -1);
            }
            if ($3.length == 0) cRel = true;
            else if ($3.charAt(0) == "[") {
                cRel = true;
                $3 = $3.slice(1, -1);
            }
            var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
            if (cRel) C += rcbase.c;
            else --C;
            if (rRel) R += rcbase.r;
            else --R;
            return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
        }
        return function rc_to_a1(fstr, base) {
            rcbase = base;
            return fstr.replace(rcregex, rcfunc);
        };
    }();
    var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
    var a1_to_rc = function() {
        return function a1_to_rc(fstr, base) {
            return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
                var c = decode_col($3) - ($2 ? 0 : base.c);
                var r = decode_row($5) - ($4 ? 0 : base.r);
                var R = r == 0 ? "" : !$4 ? "[" + r + "]" : r + 1;
                var C = c == 0 ? "" : !$2 ? "[" + c + "]" : c + 1;
                return $1 + "R" + R + "C" + C;
            });
        };
    }();
    /* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function shift_formula_str(f, delta) {
        return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
            return $1 + ($2 == "$" ? $2 + $3 : encode_col(decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : encode_row(decode_row($5) + delta.r));
        });
    }
    function shift_formula_xlsx(f, range, cell) {
        var r = decode_range(range), s = r.s, c = decode_cell(cell);
        var delta = {
            r: c.r - s.r,
            c: c.c - s.c
        };
        return shift_formula_str(f, delta);
    }
    /* TODO: parse formula */ function fuzzyfmla(f) {
        if (f.length == 1) return false;
        return true;
    }
    function _xlfn(f) {
        return f.replace(/_xlfn\./g, "");
    }
    function parseread1(blob) {
        blob.l += 1;
        return;
    }
    /* [MS-XLS] 2.5.51 */ function parse_ColRelU(blob, length) {
        var c = blob.read_shift(length == 1 ? 1 : 2);
        return [
            c & 0x3FFF,
            c >> 14 & 1,
            c >> 15 & 1
        ];
    }
    /* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function parse_RgceArea(blob, length, opts) {
        var w = 2;
        if (opts) {
            if (opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
            else if (opts.biff == 12) w = 4;
        }
        var r = blob.read_shift(w), R = blob.read_shift(w);
        var c = parse_ColRelU(blob, 2);
        var C = parse_ColRelU(blob, 2);
        return {
            s: {
                r: r,
                c: c[0],
                cRel: c[1],
                rRel: c[2]
            },
            e: {
                r: R,
                c: C[0],
                cRel: C[1],
                rRel: C[2]
            }
        };
    }
    /* BIFF 2-5 encodes flags in the row field */ function parse_RgceArea_BIFF2(blob) {
        var r = parse_ColRelU(blob, 2), R = parse_ColRelU(blob, 2);
        var c = blob.read_shift(1);
        var C = blob.read_shift(1);
        return {
            s: {
                r: r[0],
                c: c,
                cRel: r[1],
                rRel: r[2]
            },
            e: {
                r: R[0],
                c: C,
                cRel: R[1],
                rRel: R[2]
            }
        };
    }
    /* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function parse_RgceAreaRel(blob, length, opts) {
        if (opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
        var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
        var c = parse_ColRelU(blob, 2);
        var C = parse_ColRelU(blob, 2);
        return {
            s: {
                r: r,
                c: c[0],
                cRel: c[1],
                rRel: c[2]
            },
            e: {
                r: R,
                c: C[0],
                cRel: C[1],
                rRel: C[2]
            }
        };
    }
    /* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function parse_RgceLoc(blob, length, opts) {
        if (opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
        var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
        var c = parse_ColRelU(blob, 2);
        return {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        };
    }
    function parse_RgceLoc_BIFF2(blob) {
        var r = parse_ColRelU(blob, 2);
        var c = blob.read_shift(1);
        return {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        };
    }
    /* [MS-XLS] 2.5.198.107, 2.5.47 */ function parse_RgceElfLoc(blob) {
        var r = blob.read_shift(2);
        var c = blob.read_shift(2);
        return {
            r: r,
            c: c & 0xFF,
            fQuoted: !!(c & 0x4000),
            cRel: c >> 15,
            rRel: c >> 15
        };
    }
    /* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function parse_RgceLocRel(blob, length, opts) {
        var biff = opts && opts.biff ? opts.biff : 8;
        if (biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
        var r = blob.read_shift(biff >= 12 ? 4 : 2);
        var cl = blob.read_shift(2);
        var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
        cl &= 0x3FFF;
        if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
        if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
        return {
            r: r,
            c: cl,
            cRel: cRel,
            rRel: rRel
        };
    }
    function parse_RgceLocRel_BIFF2(blob) {
        var rl = blob.read_shift(2);
        var c = blob.read_shift(1);
        var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
        rl &= 0x3FFF;
        if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
        if (cRel == 1 && c >= 0x80) c = c - 0x100;
        return {
            r: rl,
            c: c,
            cRel: cRel,
            rRel: rRel
        };
    }
    /* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function parse_PtgArea(blob, length, opts) {
        var type = (blob[blob.l++] & 0x60) >> 5;
        var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
        return [
            type,
            area
        ];
    }
    /* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function parse_PtgArea3d(blob, length, opts) {
        var type = (blob[blob.l++] & 0x60) >> 5;
        var ixti = blob.read_shift(2, 'i');
        var w = 8;
        if (opts) switch(opts.biff){
            case 5:
                blob.l += 12;
                w = 6;
                break;
            case 12:
                w = 12;
                break;
        }
        var area = parse_RgceArea(blob, w, opts);
        return [
            type,
            ixti,
            area
        ];
    }
    /* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function parse_PtgAreaErr(blob, length, opts) {
        var type = (blob[blob.l++] & 0x60) >> 5;
        blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
        return [
            type
        ];
    }
    /* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function parse_PtgAreaErr3d(blob, length, opts) {
        var type = (blob[blob.l++] & 0x60) >> 5;
        var ixti = blob.read_shift(2);
        var w = 8;
        if (opts) switch(opts.biff){
            case 5:
                blob.l += 12;
                w = 6;
                break;
            case 12:
                w = 12;
                break;
        }
        blob.l += w;
        return [
            type,
            ixti
        ];
    }
    /* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function parse_PtgAreaN(blob, length, opts) {
        var type = (blob[blob.l++] & 0x60) >> 5;
        var area = parse_RgceAreaRel(blob, length - 1, opts);
        return [
            type,
            area
        ];
    }
    /* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function parse_PtgArray(blob, length, opts) {
        var type = (blob[blob.l++] & 0x60) >> 5;
        blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
        return [
            type
        ];
    }
    /* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function parse_PtgAttrBaxcel(blob) {
        var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
        var bitBaxcel = 1;
        blob.l += 4;
        return [
            bitSemi,
            bitBaxcel
        ];
    }
    /* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function parse_PtgAttrChoose(blob, length, opts) {
        blob.l += 2;
        var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
        var o = [];
        /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
        return o;
    }
    /* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function parse_PtgAttrGoto(blob, length, opts) {
        var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
        blob.l += 2;
        return [
            bitGoto,
            blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
        ];
    }
    /* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function parse_PtgAttrIf(blob, length, opts) {
        var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
        blob.l += 2;
        return [
            bitIf,
            blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
        ];
    }
    /* [MS-XLSB] 2.5.97.28 */ function parse_PtgAttrIfError(blob) {
        var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
        blob.l += 2;
        return [
            bitIf,
            blob.read_shift(2)
        ];
    }
    /* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function parse_PtgAttrSemi(blob, length, opts) {
        var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
        blob.l += opts && opts.biff == 2 ? 3 : 4;
        return [
            bitSemi
        ];
    }
    /* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function parse_PtgAttrSpaceType(blob) {
        var type = blob.read_shift(1), cch = blob.read_shift(1);
        return [
            type,
            cch
        ];
    }
    /* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function parse_PtgAttrSpace(blob) {
        blob.read_shift(2);
        return parse_PtgAttrSpaceType(blob, 2);
    }
    /* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function parse_PtgAttrSpaceSemi(blob) {
        blob.read_shift(2);
        return parse_PtgAttrSpaceType(blob, 2);
    }
    /* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function parse_PtgRef(blob, length, opts) {
        //var ptg = blob[blob.l] & 0x1F;
        var type = (blob[blob.l] & 0x60) >> 5;
        blob.l += 1;
        var loc = parse_RgceLoc(blob, 0, opts);
        return [
            type,
            loc
        ];
    }
    /* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function parse_PtgRefN(blob, length, opts) {
        var type = (blob[blob.l] & 0x60) >> 5;
        blob.l += 1;
        var loc = parse_RgceLocRel(blob, 0, opts);
        return [
            type,
            loc
        ];
    }
    /* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function parse_PtgRef3d(blob, length, opts) {
        var type = (blob[blob.l] & 0x60) >> 5;
        blob.l += 1;
        var ixti = blob.read_shift(2); // XtiIndex
        if (opts && opts.biff == 5) blob.l += 12;
        var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
        return [
            type,
            ixti,
            loc
        ];
    }
    /* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function parse_PtgFunc(blob, length, opts) {
        //var ptg = blob[blob.l] & 0x1F;
        var type = (blob[blob.l] & 0x60) >> 5;
        blob.l += 1;
        var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
        return [
            FtabArgc[iftab],
            Ftab[iftab],
            type
        ];
    }
    /* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function parse_PtgFuncVar(blob, length, opts) {
        var type = blob[blob.l++];
        var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
            type == 0x58 ? -1 : 0,
            blob.read_shift(1)
        ] : parsetab(blob);
        return [
            cparams,
            (tab[0] === 0 ? Ftab : Cetab)[tab[1]]
        ];
    }
    function parsetab(blob) {
        return [
            blob[blob.l + 1] >> 7,
            blob.read_shift(2) & 0x7FFF
        ];
    }
    /* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function parse_PtgAttrSum(blob, length, opts) {
        blob.l += opts && opts.biff == 2 ? 3 : 4;
        return;
    }
    /* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function parse_PtgExp(blob, length, opts) {
        blob.l++;
        if (opts && opts.biff == 12) return [
            blob.read_shift(4, 'i'),
            0
        ];
        var row = blob.read_shift(2);
        var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
        return [
            row,
            col
        ];
    }
    /* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function parse_PtgErr(blob) {
        blob.l++;
        return BErr[blob.read_shift(1)];
    }
    /* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function parse_PtgInt(blob) {
        blob.l++;
        return blob.read_shift(2);
    }
    /* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function parse_PtgBool(blob) {
        blob.l++;
        return blob.read_shift(1) !== 0;
    }
    /* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function parse_PtgNum(blob) {
        blob.l++;
        return parse_Xnum(blob, 8);
    }
    /* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function parse_PtgStr(blob, length, opts) {
        blob.l++;
        return parse_ShortXLUnicodeString(blob, length - 1, opts);
    }
    /* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function parse_SerAr(blob, biff) {
        var val = [
            blob.read_shift(1)
        ];
        if (biff == 12) switch(val[0]){
            case 0x02:
                val[0] = 0x04;
                break; /* SerBool */ 
            case 0x04:
                val[0] = 0x10;
                break; /* SerErr */ 
            case 0x00:
                val[0] = 0x01;
                break; /* SerNum */ 
            case 0x01:
                val[0] = 0x02;
                break; /* SerStr */ 
        }
        switch(val[0]){
            case 0x04:
                /* SerBool -- boolean */ val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
                if (biff != 12) blob.l += 7;
                break;
            case 0x25:
            /* appears to be an alias */ case 0x10:
                /* SerErr -- error */ val[1] = BErr[blob[blob.l]];
                blob.l += biff == 12 ? 4 : 8;
                break;
            case 0x00:
                /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
                break;
            case 0x01:
                /* SerNum -- Xnum */ val[1] = parse_Xnum(blob, 8);
                break;
            case 0x02:
                /* SerStr -- XLUnicodeString (<256 chars) */ val[1] = parse_XLUnicodeString2(blob, 0, {
                    biff: biff > 0 && biff < 8 ? 2 : biff
                });
                break;
            default:
                throw new Error("Bad SerAr: " + val[0]); /* Unreachable */ 
        }
        return val;
    }
    /* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function parse_PtgExtraMem(blob, cce, opts) {
        var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
        var out = [];
        for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
        return out;
    }
    /* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function parse_PtgExtraArray(blob, length, opts) {
        var rows = 0, cols = 0;
        if (opts.biff == 12) {
            rows = blob.read_shift(4); // DRw
            cols = blob.read_shift(4); // DCol
        } else {
            cols = 1 + blob.read_shift(1); //DColByteU
            rows = 1 + blob.read_shift(2); //DRw
        }
        if (opts.biff >= 2 && opts.biff < 8) {
            --rows;
            if (--cols == 0) cols = 0x100;
        }
        // $FlowIgnore
        for(var i = 0, o = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = parse_SerAr(blob, opts.biff);
        return o;
    }
    /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function parse_PtgName(blob, length, opts) {
        var type = blob.read_shift(1) >>> 5 & 0x03;
        var w = !opts || opts.biff >= 8 ? 4 : 2;
        var nameindex = blob.read_shift(w);
        switch(opts.biff){
            case 2:
                blob.l += 5;
                break;
            case 3:
            case 4:
                blob.l += 8;
                break;
            case 5:
                blob.l += 12;
                break;
        }
        return [
            type,
            0,
            nameindex
        ];
    }
    /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function parse_PtgNameX(blob, length, opts) {
        if (opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
        var type = blob.read_shift(1) >>> 5 & 0x03;
        var ixti = blob.read_shift(2); // XtiIndex
        var nameindex = blob.read_shift(4);
        return [
            type,
            ixti,
            nameindex
        ];
    }
    function parse_PtgNameX_BIFF5(blob) {
        var type = blob.read_shift(1) >>> 5 & 0x03;
        var ixti = blob.read_shift(2, 'i'); // XtiIndex
        blob.l += 8;
        var nameindex = blob.read_shift(2);
        blob.l += 12;
        return [
            type,
            ixti,
            nameindex
        ];
    }
    /* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function parse_PtgMemArea(blob, length, opts) {
        var type = blob.read_shift(1) >>> 5 & 0x03;
        blob.l += opts && opts.biff == 2 ? 3 : 4;
        var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
        return [
            type,
            cce
        ];
    }
    /* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function parse_PtgMemFunc(blob, length, opts) {
        var type = blob.read_shift(1) >>> 5 & 0x03;
        var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
        return [
            type,
            cce
        ];
    }
    /* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function parse_PtgRefErr(blob, length, opts) {
        var type = blob.read_shift(1) >>> 5 & 0x03;
        blob.l += 4;
        if (opts.biff < 8) blob.l--;
        if (opts.biff == 12) blob.l += 2;
        return [
            type
        ];
    }
    /* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function parse_PtgRefErr3d(blob, length, opts) {
        var type = (blob[blob.l++] & 0x60) >> 5;
        var ixti = blob.read_shift(2);
        var w = 4;
        if (opts) switch(opts.biff){
            case 5:
                w = 15;
                break;
            case 12:
                w = 6;
                break;
        }
        blob.l += w;
        return [
            type,
            ixti
        ];
    }
    /* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var parse_PtgMemErr = parsenoop;
    /* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var parse_PtgMemNoMem = parsenoop;
    /* [MS-XLS] 2.5.198.92 */ var parse_PtgTbl = parsenoop;
    function parse_PtgElfLoc(blob, length, opts) {
        blob.l += 2;
        return [
            parse_RgceElfLoc(blob, 4, opts)
        ];
    }
    function parse_PtgElfNoop(blob) {
        blob.l += 6;
        return [];
    }
    /* [MS-XLS] 2.5.198.46 */ var parse_PtgElfCol = parse_PtgElfLoc;
    /* [MS-XLS] 2.5.198.47 */ var parse_PtgElfColS = parse_PtgElfNoop;
    /* [MS-XLS] 2.5.198.48 */ var parse_PtgElfColSV = parse_PtgElfNoop;
    /* [MS-XLS] 2.5.198.49 */ var parse_PtgElfColV = parse_PtgElfLoc;
    /* [MS-XLS] 2.5.198.50 */ function parse_PtgElfLel(blob) {
        blob.l += 2;
        return [
            parseuint16(blob),
            blob.read_shift(2) & 0x01
        ];
    }
    /* [MS-XLS] 2.5.198.51 */ var parse_PtgElfRadical = parse_PtgElfLoc;
    /* [MS-XLS] 2.5.198.52 */ var parse_PtgElfRadicalLel = parse_PtgElfLel;
    /* [MS-XLS] 2.5.198.53 */ var parse_PtgElfRadicalS = parse_PtgElfNoop;
    /* [MS-XLS] 2.5.198.54 */ var parse_PtgElfRw = parse_PtgElfLoc;
    /* [MS-XLS] 2.5.198.55 */ var parse_PtgElfRwV = parse_PtgElfLoc;
    /* [MS-XLSB] 2.5.97.52 TODO */ var PtgListRT = [
        "Data",
        "All",
        "Headers",
        "??",
        "?Data2",
        "??",
        "?DataHeaders",
        "??",
        "Totals",
        "??",
        "??",
        "??",
        "?DataTotals",
        "??",
        "??",
        "??",
        "?Current"
    ];
    function parse_PtgList(blob) {
        blob.l += 2;
        var ixti = blob.read_shift(2);
        var flags = blob.read_shift(2);
        var idx = blob.read_shift(4);
        var c = blob.read_shift(2);
        var C = blob.read_shift(2);
        var rt = PtgListRT[flags >> 2 & 0x1F];
        return {
            ixti: ixti,
            coltype: flags & 0x3,
            rt: rt,
            idx: idx,
            c: c,
            C: C
        };
    }
    /* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function parse_PtgSxName(blob) {
        blob.l += 2;
        return [
            blob.read_shift(4)
        ];
    }
    /* [XLS] old spec */ function parse_PtgSheet(blob, length, opts) {
        blob.l += 5;
        blob.l += 2;
        blob.l += opts.biff == 2 ? 1 : 4;
        return [
            "PTGSHEET"
        ];
    }
    function parse_PtgEndSheet(blob, length, opts) {
        blob.l += opts.biff == 2 ? 4 : 5;
        return [
            "PTGENDSHEET"
        ];
    }
    function parse_PtgMemAreaN(blob) {
        var type = blob.read_shift(1) >>> 5 & 0x03;
        var cce = blob.read_shift(2);
        return [
            type,
            cce
        ];
    }
    function parse_PtgMemNoMemN(blob) {
        var type = blob.read_shift(1) >>> 5 & 0x03;
        var cce = blob.read_shift(2);
        return [
            type,
            cce
        ];
    }
    function parse_PtgAttrNoop(blob) {
        blob.l += 4;
        return [
            0,
            0
        ];
    }
    /* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var PtgTypes = {
        0x01: {
            n: 'PtgExp',
            f: parse_PtgExp
        },
        0x02: {
            n: 'PtgTbl',
            f: parse_PtgTbl
        },
        0x03: {
            n: 'PtgAdd',
            f: parseread1
        },
        0x04: {
            n: 'PtgSub',
            f: parseread1
        },
        0x05: {
            n: 'PtgMul',
            f: parseread1
        },
        0x06: {
            n: 'PtgDiv',
            f: parseread1
        },
        0x07: {
            n: 'PtgPower',
            f: parseread1
        },
        0x08: {
            n: 'PtgConcat',
            f: parseread1
        },
        0x09: {
            n: 'PtgLt',
            f: parseread1
        },
        0x0A: {
            n: 'PtgLe',
            f: parseread1
        },
        0x0B: {
            n: 'PtgEq',
            f: parseread1
        },
        0x0C: {
            n: 'PtgGe',
            f: parseread1
        },
        0x0D: {
            n: 'PtgGt',
            f: parseread1
        },
        0x0E: {
            n: 'PtgNe',
            f: parseread1
        },
        0x0F: {
            n: 'PtgIsect',
            f: parseread1
        },
        0x10: {
            n: 'PtgUnion',
            f: parseread1
        },
        0x11: {
            n: 'PtgRange',
            f: parseread1
        },
        0x12: {
            n: 'PtgUplus',
            f: parseread1
        },
        0x13: {
            n: 'PtgUminus',
            f: parseread1
        },
        0x14: {
            n: 'PtgPercent',
            f: parseread1
        },
        0x15: {
            n: 'PtgParen',
            f: parseread1
        },
        0x16: {
            n: 'PtgMissArg',
            f: parseread1
        },
        0x17: {
            n: 'PtgStr',
            f: parse_PtgStr
        },
        0x1A: {
            n: 'PtgSheet',
            f: parse_PtgSheet
        },
        0x1B: {
            n: 'PtgEndSheet',
            f: parse_PtgEndSheet
        },
        0x1C: {
            n: 'PtgErr',
            f: parse_PtgErr
        },
        0x1D: {
            n: 'PtgBool',
            f: parse_PtgBool
        },
        0x1E: {
            n: 'PtgInt',
            f: parse_PtgInt
        },
        0x1F: {
            n: 'PtgNum',
            f: parse_PtgNum
        },
        0x20: {
            n: 'PtgArray',
            f: parse_PtgArray
        },
        0x21: {
            n: 'PtgFunc',
            f: parse_PtgFunc
        },
        0x22: {
            n: 'PtgFuncVar',
            f: parse_PtgFuncVar
        },
        0x23: {
            n: 'PtgName',
            f: parse_PtgName
        },
        0x24: {
            n: 'PtgRef',
            f: parse_PtgRef
        },
        0x25: {
            n: 'PtgArea',
            f: parse_PtgArea
        },
        0x26: {
            n: 'PtgMemArea',
            f: parse_PtgMemArea
        },
        0x27: {
            n: 'PtgMemErr',
            f: parse_PtgMemErr
        },
        0x28: {
            n: 'PtgMemNoMem',
            f: parse_PtgMemNoMem
        },
        0x29: {
            n: 'PtgMemFunc',
            f: parse_PtgMemFunc
        },
        0x2A: {
            n: 'PtgRefErr',
            f: parse_PtgRefErr
        },
        0x2B: {
            n: 'PtgAreaErr',
            f: parse_PtgAreaErr
        },
        0x2C: {
            n: 'PtgRefN',
            f: parse_PtgRefN
        },
        0x2D: {
            n: 'PtgAreaN',
            f: parse_PtgAreaN
        },
        0x2E: {
            n: 'PtgMemAreaN',
            f: parse_PtgMemAreaN
        },
        0x2F: {
            n: 'PtgMemNoMemN',
            f: parse_PtgMemNoMemN
        },
        0x39: {
            n: 'PtgNameX',
            f: parse_PtgNameX
        },
        0x3A: {
            n: 'PtgRef3d',
            f: parse_PtgRef3d
        },
        0x3B: {
            n: 'PtgArea3d',
            f: parse_PtgArea3d
        },
        0x3C: {
            n: 'PtgRefErr3d',
            f: parse_PtgRefErr3d
        },
        0x3D: {
            n: 'PtgAreaErr3d',
            f: parse_PtgAreaErr3d
        },
        0xFF: {}
    };
    /* These are duplicated in the PtgTypes table */ var PtgDupes = {
        0x40: 0x20,
        0x60: 0x20,
        0x41: 0x21,
        0x61: 0x21,
        0x42: 0x22,
        0x62: 0x22,
        0x43: 0x23,
        0x63: 0x23,
        0x44: 0x24,
        0x64: 0x24,
        0x45: 0x25,
        0x65: 0x25,
        0x46: 0x26,
        0x66: 0x26,
        0x47: 0x27,
        0x67: 0x27,
        0x48: 0x28,
        0x68: 0x28,
        0x49: 0x29,
        0x69: 0x29,
        0x4A: 0x2A,
        0x6A: 0x2A,
        0x4B: 0x2B,
        0x6B: 0x2B,
        0x4C: 0x2C,
        0x6C: 0x2C,
        0x4D: 0x2D,
        0x6D: 0x2D,
        0x4E: 0x2E,
        0x6E: 0x2E,
        0x4F: 0x2F,
        0x6F: 0x2F,
        0x58: 0x22,
        0x78: 0x22,
        0x59: 0x39,
        0x79: 0x39,
        0x5A: 0x3A,
        0x7A: 0x3A,
        0x5B: 0x3B,
        0x7B: 0x3B,
        0x5C: 0x3C,
        0x7C: 0x3C,
        0x5D: 0x3D,
        0x7D: 0x3D
    };
    (function() {
        for(var y in PtgDupes)PtgTypes[y] = PtgTypes[PtgDupes[y]];
    })();
    var Ptg18 = {
        0x01: {
            n: 'PtgElfLel',
            f: parse_PtgElfLel
        },
        0x02: {
            n: 'PtgElfRw',
            f: parse_PtgElfRw
        },
        0x03: {
            n: 'PtgElfCol',
            f: parse_PtgElfCol
        },
        0x06: {
            n: 'PtgElfRwV',
            f: parse_PtgElfRwV
        },
        0x07: {
            n: 'PtgElfColV',
            f: parse_PtgElfColV
        },
        0x0A: {
            n: 'PtgElfRadical',
            f: parse_PtgElfRadical
        },
        0x0B: {
            n: 'PtgElfRadicalS',
            f: parse_PtgElfRadicalS
        },
        0x0D: {
            n: 'PtgElfColS',
            f: parse_PtgElfColS
        },
        0x0F: {
            n: 'PtgElfColSV',
            f: parse_PtgElfColSV
        },
        0x10: {
            n: 'PtgElfRadicalLel',
            f: parse_PtgElfRadicalLel
        },
        0x19: {
            n: 'PtgList',
            f: parse_PtgList
        },
        0x1D: {
            n: 'PtgSxName',
            f: parse_PtgSxName
        },
        0xFF: {}
    };
    var Ptg19 = {
        0x00: {
            n: 'PtgAttrNoop',
            f: parse_PtgAttrNoop
        },
        0x01: {
            n: 'PtgAttrSemi',
            f: parse_PtgAttrSemi
        },
        0x02: {
            n: 'PtgAttrIf',
            f: parse_PtgAttrIf
        },
        0x04: {
            n: 'PtgAttrChoose',
            f: parse_PtgAttrChoose
        },
        0x08: {
            n: 'PtgAttrGoto',
            f: parse_PtgAttrGoto
        },
        0x10: {
            n: 'PtgAttrSum',
            f: parse_PtgAttrSum
        },
        0x20: {
            n: 'PtgAttrBaxcel',
            f: parse_PtgAttrBaxcel
        },
        0x40: {
            n: 'PtgAttrSpace',
            f: parse_PtgAttrSpace
        },
        0x41: {
            n: 'PtgAttrSpaceSemi',
            f: parse_PtgAttrSpaceSemi
        },
        0x80: {
            n: 'PtgAttrIfError',
            f: parse_PtgAttrIfError
        },
        0xFF: {}
    };
    Ptg19[0x21] = Ptg19[0x20];
    /* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function parse_RgbExtra(blob, length, rgce, opts) {
        if (opts.biff < 8) return parsenoop(blob, length);
        var target = blob.l + length;
        var o = [];
        for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
            case 'PtgArray':
                /* PtgArray -> PtgExtraArray */ rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
                o.push(rgce[i][1]);
                break;
            case 'PtgMemArea':
                /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
                o.push(rgce[i][2]);
                break;
            case 'PtgExp':
                /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                    rgce[i][1][1] = blob.read_shift(4);
                    o.push(rgce[i][1]);
                }
                break;
            case 'PtgList':
            /* TODO: PtgList -> PtgExtraList */ case 'PtgElfRadicalS':
            /* TODO: PtgElfRadicalS -> PtgExtraElf */ case 'PtgElfColS':
            /* TODO: PtgElfColS -> PtgExtraElf */ case 'PtgElfColSV':
                /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
            default:
                break;
        }
        length = target - blob.l;
        /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
        if (length !== 0) o.push(parsenoop(blob, length));
        return o;
    }
    /* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function parse_Rgce(blob, length, opts) {
        var target = blob.l + length;
        var R, id, ptgs = [];
        while(target != blob.l){
            length = target - blob.l;
            id = blob[blob.l];
            R = PtgTypes[id];
            if (id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
            if (!R || !R.f) parsenoop(blob, length);
            else ptgs.push([
                R.n,
                R.f(blob, length, opts)
            ]);
        }
        return ptgs;
    }
    function stringify_array(f) {
        var o = [];
        for(var i = 0; i < f.length; ++i){
            var x = f[i], r = [];
            for(var j = 0; j < x.length; ++j){
                var y = x[j];
                if (y) switch(y[0]){
                    // TODO: handle embedded quotes
                    case 0x02:
                        r.push('"' + y[1].replace(/"/g, '""') + '"');
                        break;
                    default:
                        r.push(y[1]);
                }
                else r.push("");
            }
            o.push(r.join(","));
        }
        return o.join(";");
    }
    /* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var PtgBinOp = {
        PtgAdd: "+",
        PtgConcat: "&",
        PtgDiv: "/",
        PtgEq: "=",
        PtgGe: ">=",
        PtgGt: ">",
        PtgLe: "<=",
        PtgLt: "<",
        PtgMul: "*",
        PtgNe: "<>",
        PtgPower: "^",
        PtgSub: "-"
    };
    // List of invalid characters needs to be tested further
    var quoteCharacters = new RegExp(/[^\w\u4E00-\u9FFF\u3040-\u30FF]/);
    function formula_quote_sheet_name(sname, opts) {
        if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
        if (quoteCharacters.test(sname)) return "'" + sname + "'";
        return sname;
    }
    function get_ixti_raw(supbooks, ixti, opts) {
        if (!supbooks) return "SH33TJSERR0";
        if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
        if (!supbooks.XTI) return "SH33TJSERR6";
        var XTI = supbooks.XTI[ixti];
        if (opts.biff < 8) {
            if (ixti > 10000) ixti -= 65536;
            if (ixti < 0) ixti = -ixti;
            return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
        }
        if (!XTI) return "SH33TJSERR1";
        var o = "";
        if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
            case 0x0165:
                /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
                return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
            case 0x0166:
                /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
                return "SH33TJSSAME" + supbooks[XTI[0]][0];
            case 0x0163:
            /* 'BrtSupBookSrc' */ /* falls through */ default:
                return "SH33TJSSRC" + supbooks[XTI[0]][0];
        }
        switch(supbooks[XTI[0]][0][0]){
            case 0x0401:
                o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
                return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
            case 0x3A01:
                return supbooks[XTI[0]].slice(1).map(function(name) {
                    return name.Name;
                }).join(";;"); //return "SH33TJSERR8";
            default:
                if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
                o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
                return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
        }
    }
    function get_ixti(supbooks, ixti, opts) {
        return formula_quote_sheet_name(get_ixti_raw(supbooks, ixti, opts), opts);
    }
    function stringify_formula(formula /*Array<any>*/ , range, cell, supbooks, opts) {
        var biff = opts && opts.biff || 8;
        var _range = /*range != null ? range :*/ {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        var stack = [], e1, e2, c, ixti = 0, nameidx = 0, r, sname = "";
        if (!formula[0] || !formula[0][0]) return "";
        var last_sp = -1, sp = "";
        for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
            var f = formula[0][ff];
            switch(f[0]){
                case 'PtgUminus':
                    /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                    break;
                case 'PtgUplus':
                    /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                    break;
                case 'PtgPercent':
                    /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                    break;
                case 'PtgAdd':
                /* [MS-XLS] 2.5.198.26 */ case 'PtgConcat':
                /* [MS-XLS] 2.5.198.43 */ case 'PtgDiv':
                /* [MS-XLS] 2.5.198.45 */ case 'PtgEq':
                /* [MS-XLS] 2.5.198.56 */ case 'PtgGe':
                /* [MS-XLS] 2.5.198.64 */ case 'PtgGt':
                /* [MS-XLS] 2.5.198.65 */ case 'PtgLe':
                /* [MS-XLS] 2.5.198.68 */ case 'PtgLt':
                /* [MS-XLS] 2.5.198.69 */ case 'PtgMul':
                /* [MS-XLS] 2.5.198.75 */ case 'PtgNe':
                /* [MS-XLS] 2.5.198.78 */ case 'PtgPower':
                /* [MS-XLS] 2.5.198.82 */ case 'PtgSub':
                    /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                    e2 = stack.pop();
                    if (last_sp >= 0) {
                        switch(formula[0][last_sp][1][0]){
                            case 0:
                                // $FlowIgnore
                                sp = fill(" ", formula[0][last_sp][1][1]);
                                break;
                            case 1:
                                // $FlowIgnore
                                sp = fill("\r", formula[0][last_sp][1][1]);
                                break;
                            default:
                                sp = "";
                                // $FlowIgnore
                                if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                        }
                        e2 = e2 + sp;
                        last_sp = -1;
                    }
                    stack.push(e2 + PtgBinOp[f[0]] + e1);
                    break;
                case 'PtgIsect':
                    /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                    e2 = stack.pop();
                    stack.push(e2 + " " + e1);
                    break;
                case 'PtgUnion':
                    /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                    e2 = stack.pop();
                    stack.push(e2 + "," + e1);
                    break;
                case 'PtgRange':
                    /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                    e2 = stack.pop();
                    stack.push(e2 + ":" + e1);
                    break;
                case 'PtgAttrChoose':
                    break;
                case 'PtgAttrGoto':
                    break;
                case 'PtgAttrIf':
                    break;
                case 'PtgAttrIfError':
                    break;
                case 'PtgRef':
                    /* [MS-XLS] 2.5.198.84 */ c = shift_cell_xls(f[1][1], _range, opts);
                    stack.push(encode_cell_xls(c, biff));
                    break;
                case 'PtgRefN':
                    /* [MS-XLS] 2.5.198.88 */ c = cell ? shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                    stack.push(encode_cell_xls(c, biff));
                    break;
                case 'PtgRef3d':
                    /* [MS-XLS] 2.5.198.85 */ ixti = f[1][1];
                    c = shift_cell_xls(f[1][2], _range, opts);
                    sname = get_ixti(supbooks, ixti, opts);
                    var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                    stack.push(sname + "!" + encode_cell_xls(c, biff));
                    break;
                case 'PtgFunc':
                /* [MS-XLS] 2.5.198.62 */ case 'PtgFuncVar':
                    /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc = f[1][0], func = f[1][1];
                    if (!argc) argc = 0;
                    argc &= 0x7F;
                    var args = argc == 0 ? [] : stack.slice(-argc);
                    stack.length -= argc;
                    if (func === 'User') func = args.shift();
                    stack.push(func + "(" + args.join(",") + ")");
                    break;
                case 'PtgBool':
                    /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                    break;
                case 'PtgInt':
                    /* [MS-XLS] 2.5.198.66 */ stack.push(f[1]);
                    break;
                case 'PtgNum':
                    /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                    break;
                case 'PtgStr':
                    /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                    stack.push('"' + f[1].replace(/"/g, '""') + '"');
                    break;
                case 'PtgErr':
                    /* [MS-XLS] 2.5.198.57 */ stack.push(f[1]);
                    break;
                case 'PtgAreaN':
                    /* [MS-XLS] 2.5.198.31 TODO */ r = shift_range_xls(f[1][1], cell ? {
                        s: cell
                    } : _range, opts);
                    stack.push(encode_range_xls(r, opts));
                    break;
                case 'PtgArea':
                    /* [MS-XLS] 2.5.198.27 TODO: fixed points */ r = shift_range_xls(f[1][1], _range, opts);
                    stack.push(encode_range_xls(r, opts));
                    break;
                case 'PtgArea3d':
                    /* [MS-XLS] 2.5.198.28 TODO */ ixti = f[1][1];
                    r = f[1][2];
                    sname = get_ixti(supbooks, ixti, opts);
                    stack.push(sname + "!" + encode_range_xls(r, opts));
                    break;
                case 'PtgAttrSum':
                    /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                    break;
                case 'PtgAttrBaxcel':
                /* [MS-XLS] 2.5.198.33 */ case 'PtgAttrSemi':
                    break;
                case 'PtgName':
                    /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                    var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                    var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                    if (name in XLSXFutureFunctions) name = XLSXFutureFunctions[name];
                    stack.push(name);
                    break;
                case 'PtgNameX':
                    /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx = f[1][1];
                    nameidx = f[1][2];
                    var externbook;
                    /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                        if (bookidx < 0) bookidx = -bookidx;
                        if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                    } else {
                        var o = "";
                        if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                        else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                            if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                        } else o = supbooks.SheetNames[nameidx - 1] + "!";
                        if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                        else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                        else {
                            var ixtidata = get_ixti_raw(supbooks, bookidx, opts).split(";;");
                            if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                            else o += "SH33TJSERRX";
                        }
                        stack.push(o);
                        break;
                    }
                    if (!externbook) externbook = {
                        Name: "SH33TJSERRY"
                    };
                    stack.push(externbook.Name);
                    break;
                case 'PtgParen':
                    /* [MS-XLS] 2.5.198.80 */ var lp = '(', rp = ')';
                    if (last_sp >= 0) {
                        sp = "";
                        switch(formula[0][last_sp][1][0]){
                            // $FlowIgnore
                            case 2:
                                lp = fill(" ", formula[0][last_sp][1][1]) + lp;
                                break;
                            // $FlowIgnore
                            case 3:
                                lp = fill("\r", formula[0][last_sp][1][1]) + lp;
                                break;
                            // $FlowIgnore
                            case 4:
                                rp = fill(" ", formula[0][last_sp][1][1]) + rp;
                                break;
                            // $FlowIgnore
                            case 5:
                                rp = fill("\r", formula[0][last_sp][1][1]) + rp;
                                break;
                            default:
                                // $FlowIgnore
                                if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                        }
                        last_sp = -1;
                    }
                    stack.push(lp + stack.pop() + rp);
                    break;
                case 'PtgRefErr':
                    /* [MS-XLS] 2.5.198.86 */ stack.push('#REF!');
                    break;
                case 'PtgRefErr3d':
                    /* [MS-XLS] 2.5.198.87 */ stack.push('#REF!');
                    break;
                case 'PtgExp':
                    /* [MS-XLS] 2.5.198.58 TODO */ c = {
                        c: f[1][1],
                        r: f[1][0]
                    };
                    var q = {
                        c: cell.c,
                        r: cell.r
                    };
                    if (supbooks.sharedf[encode_cell(c)]) {
                        var parsedf = supbooks.sharedf[encode_cell(c)];
                        stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
                    } else {
                        var fnd = false;
                        for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                            /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                            if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                            if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                            stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
                            fnd = true;
                            break;
                        }
                        if (!fnd) stack.push(f[1]);
                    }
                    break;
                case 'PtgArray':
                    /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + stringify_array(f[1]) + "}");
                    break;
                case 'PtgMemArea':
                    break;
                case 'PtgAttrSpace':
                /* [MS-XLS] 2.5.198.38 */ case 'PtgAttrSpaceSemi':
                    /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                    break;
                case 'PtgTbl':
                    break;
                case 'PtgMemErr':
                    break;
                case 'PtgMissArg':
                    /* [MS-XLS] 2.5.198.74 */ stack.push("");
                    break;
                case 'PtgAreaErr':
                    /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                    break;
                case 'PtgAreaErr3d':
                    /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                    break;
                case 'PtgList':
                    /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                    stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                    break;
                case 'PtgMemAreaN':
                case 'PtgMemNoMemN':
                case 'PtgAttrNoop':
                case 'PtgSheet':
                case 'PtgEndSheet':
                    break;
                case 'PtgMemFunc':
                    break;
                case 'PtgMemNoMem':
                    break;
                case 'PtgElfCol':
                /* [MS-XLS] 2.5.198.46 */ case 'PtgElfColS':
                /* [MS-XLS] 2.5.198.47 */ case 'PtgElfColSV':
                /* [MS-XLS] 2.5.198.48 */ case 'PtgElfColV':
                /* [MS-XLS] 2.5.198.49 */ case 'PtgElfLel':
                /* [MS-XLS] 2.5.198.50 */ case 'PtgElfRadical':
                /* [MS-XLS] 2.5.198.51 */ case 'PtgElfRadicalLel':
                /* [MS-XLS] 2.5.198.52 */ case 'PtgElfRadicalS':
                /* [MS-XLS] 2.5.198.53 */ case 'PtgElfRw':
                /* [MS-XLS] 2.5.198.54 */ case 'PtgElfRwV':
                    /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
                case 'PtgSxName':
                    /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error('Unrecognized Formula Token: ' + String(f));
                default:
                    throw new Error('Unrecognized Formula Token: ' + String(f));
            }
            var PtgNonDisp = [
                'PtgAttrSpace',
                'PtgAttrSpaceSemi',
                'PtgAttrGoto'
            ];
            if (opts.biff != 3) {
                if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                    f = formula[0][last_sp];
                    var _left = true;
                    switch(f[1][0]){
                        /* note: some bad XLSB files omit the PtgParen */ case 4:
                            _left = false;
                        /* falls through */ case 0:
                            // $FlowIgnore
                            sp = fill(" ", f[1][1]);
                            break;
                        case 5:
                            _left = false;
                        /* falls through */ case 1:
                            // $FlowIgnore
                            sp = fill("\r", f[1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                    }
                    stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                    last_sp = -1;
                }
            }
        }
        if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
        return stack[0];
    }
    /* [MS-XLS] 2.5.198.1 TODO */ function parse_ArrayParsedFormula(blob, length, opts) {
        var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
        var rgcb, cce = blob.read_shift(len); // length of rgce
        if (cce == 0xFFFF) return [
            [],
            parsenoop(blob, length - 2)
        ];
        var rgce = parse_Rgce(blob, cce, opts);
        if (length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
        blob.l = target;
        return [
            rgce,
            rgcb
        ];
    }
    /* [MS-XLS] 2.5.198.3 TODO */ function parse_XLSCellParsedFormula(blob, length, opts) {
        var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
        var rgcb, cce = blob.read_shift(len); // length of rgce
        if (cce == 0xFFFF) return [
            [],
            parsenoop(blob, length - 2)
        ];
        var rgce = parse_Rgce(blob, cce, opts);
        if (length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
        blob.l = target;
        return [
            rgce,
            rgcb
        ];
    }
    /* [MS-XLS] 2.5.198.21 */ function parse_NameParsedFormula(blob, length, opts, cce) {
        var target = blob.l + length;
        var rgce = parse_Rgce(blob, cce, opts);
        var rgcb;
        if (target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
        return [
            rgce,
            rgcb
        ];
    }
    /* [MS-XLS] 2.5.198.118 TODO */ function parse_SharedParsedFormula(blob, length, opts) {
        var target = blob.l + length;
        var rgcb, cce = blob.read_shift(2); // length of rgce
        var rgce = parse_Rgce(blob, cce, opts);
        if (cce == 0xFFFF) return [
            [],
            parsenoop(blob, length - 2)
        ];
        if (length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
        return [
            rgce,
            rgcb
        ];
    }
    /* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function parse_FormulaValue(blob) {
        var b;
        if (__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
            parse_Xnum(blob),
            'n'
        ];
        switch(blob[blob.l]){
            case 0x00:
                blob.l += 8;
                return [
                    "String",
                    's'
                ];
            case 0x01:
                b = blob[blob.l + 2] === 0x1;
                blob.l += 8;
                return [
                    b,
                    'b'
                ];
            case 0x02:
                b = blob[blob.l + 2];
                blob.l += 8;
                return [
                    b,
                    'e'
                ];
            case 0x03:
                blob.l += 8;
                return [
                    "",
                    's'
                ];
        }
        return [];
    }
    function write_FormulaValue(value) {
        if (value == null) {
            // Blank String Value
            var o = new_buf(8);
            o.write_shift(1, 0x03);
            o.write_shift(1, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        } else if (typeof value == "number") return write_Xnum(value);
        return write_Xnum(0);
    }
    /* [MS-XLS] 2.4.127 TODO */ function parse_Formula(blob, length, opts) {
        var end = blob.l + length;
        var cell = parse_XLSCell(blob, 6);
        if (opts.biff == 2) ++blob.l;
        var val = parse_FormulaValue(blob, 8);
        var flags = blob.read_shift(1);
        if (opts.biff != 2) {
            blob.read_shift(1);
            if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
        }
        var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
        return {
            cell: cell,
            val: val[0],
            formula: cbf,
            shared: flags >> 3 & 1,
            tt: val[1]
        };
    }
    function write_Formula(cell, R, C, opts, os) {
        // Cell
        var o1 = write_XLSCell(R, C, os);
        // FormulaValue
        var o2 = write_FormulaValue(cell.v);
        // flags + cache
        var o3 = new_buf(6);
        var flags = 33;
        o3.write_shift(2, flags);
        o3.write_shift(4, 0);
        // CellParsedFormula
        var bf = new_buf(cell.bf.length);
        for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
        var out = bconcat([
            o1,
            o2,
            o3,
            bf
        ]);
        return out;
    }
    /* XLSB Parsed Formula records have the same shape */ function parse_XLSBParsedFormula(data, length, opts) {
        var cce = data.read_shift(4);
        var rgce = parse_Rgce(data, cce, opts);
        var cb = data.read_shift(4);
        var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
        return [
            rgce,
            rgcb
        ];
    }
    /* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
    /* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
    /* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
    /* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
    /* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
    /* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
    /* [MS-XLS] 2.5.198.4 */ var Cetab = {
        0x0000: 'BEEP',
        0x0001: 'OPEN',
        0x0002: 'OPEN.LINKS',
        0x0003: 'CLOSE.ALL',
        0x0004: 'SAVE',
        0x0005: 'SAVE.AS',
        0x0006: 'FILE.DELETE',
        0x0007: 'PAGE.SETUP',
        0x0008: 'PRINT',
        0x0009: 'PRINTER.SETUP',
        0x000A: 'QUIT',
        0x000B: 'NEW.WINDOW',
        0x000C: 'ARRANGE.ALL',
        0x000D: 'WINDOW.SIZE',
        0x000E: 'WINDOW.MOVE',
        0x000F: 'FULL',
        0x0010: 'CLOSE',
        0x0011: 'RUN',
        0x0016: 'SET.PRINT.AREA',
        0x0017: 'SET.PRINT.TITLES',
        0x0018: 'SET.PAGE.BREAK',
        0x0019: 'REMOVE.PAGE.BREAK',
        0x001A: 'FONT',
        0x001B: 'DISPLAY',
        0x001C: 'PROTECT.DOCUMENT',
        0x001D: 'PRECISION',
        0x001E: 'A1.R1C1',
        0x001F: 'CALCULATE.NOW',
        0x0020: 'CALCULATION',
        0x0022: 'DATA.FIND',
        0x0023: 'EXTRACT',
        0x0024: 'DATA.DELETE',
        0x0025: 'SET.DATABASE',
        0x0026: 'SET.CRITERIA',
        0x0027: 'SORT',
        0x0028: 'DATA.SERIES',
        0x0029: 'TABLE',
        0x002A: 'FORMAT.NUMBER',
        0x002B: 'ALIGNMENT',
        0x002C: 'STYLE',
        0x002D: 'BORDER',
        0x002E: 'CELL.PROTECTION',
        0x002F: 'COLUMN.WIDTH',
        0x0030: 'UNDO',
        0x0031: 'CUT',
        0x0032: 'COPY',
        0x0033: 'PASTE',
        0x0034: 'CLEAR',
        0x0035: 'PASTE.SPECIAL',
        0x0036: 'EDIT.DELETE',
        0x0037: 'INSERT',
        0x0038: 'FILL.RIGHT',
        0x0039: 'FILL.DOWN',
        0x003D: 'DEFINE.NAME',
        0x003E: 'CREATE.NAMES',
        0x003F: 'FORMULA.GOTO',
        0x0040: 'FORMULA.FIND',
        0x0041: 'SELECT.LAST.CELL',
        0x0042: 'SHOW.ACTIVE.CELL',
        0x0043: 'GALLERY.AREA',
        0x0044: 'GALLERY.BAR',
        0x0045: 'GALLERY.COLUMN',
        0x0046: 'GALLERY.LINE',
        0x0047: 'GALLERY.PIE',
        0x0048: 'GALLERY.SCATTER',
        0x0049: 'COMBINATION',
        0x004A: 'PREFERRED',
        0x004B: 'ADD.OVERLAY',
        0x004C: 'GRIDLINES',
        0x004D: 'SET.PREFERRED',
        0x004E: 'AXES',
        0x004F: 'LEGEND',
        0x0050: 'ATTACH.TEXT',
        0x0051: 'ADD.ARROW',
        0x0052: 'SELECT.CHART',
        0x0053: 'SELECT.PLOT.AREA',
        0x0054: 'PATTERNS',
        0x0055: 'MAIN.CHART',
        0x0056: 'OVERLAY',
        0x0057: 'SCALE',
        0x0058: 'FORMAT.LEGEND',
        0x0059: 'FORMAT.TEXT',
        0x005A: 'EDIT.REPEAT',
        0x005B: 'PARSE',
        0x005C: 'JUSTIFY',
        0x005D: 'HIDE',
        0x005E: 'UNHIDE',
        0x005F: 'WORKSPACE',
        0x0060: 'FORMULA',
        0x0061: 'FORMULA.FILL',
        0x0062: 'FORMULA.ARRAY',
        0x0063: 'DATA.FIND.NEXT',
        0x0064: 'DATA.FIND.PREV',
        0x0065: 'FORMULA.FIND.NEXT',
        0x0066: 'FORMULA.FIND.PREV',
        0x0067: 'ACTIVATE',
        0x0068: 'ACTIVATE.NEXT',
        0x0069: 'ACTIVATE.PREV',
        0x006A: 'UNLOCKED.NEXT',
        0x006B: 'UNLOCKED.PREV',
        0x006C: 'COPY.PICTURE',
        0x006D: 'SELECT',
        0x006E: 'DELETE.NAME',
        0x006F: 'DELETE.FORMAT',
        0x0070: 'VLINE',
        0x0071: 'HLINE',
        0x0072: 'VPAGE',
        0x0073: 'HPAGE',
        0x0074: 'VSCROLL',
        0x0075: 'HSCROLL',
        0x0076: 'ALERT',
        0x0077: 'NEW',
        0x0078: 'CANCEL.COPY',
        0x0079: 'SHOW.CLIPBOARD',
        0x007A: 'MESSAGE',
        0x007C: 'PASTE.LINK',
        0x007D: 'APP.ACTIVATE',
        0x007E: 'DELETE.ARROW',
        0x007F: 'ROW.HEIGHT',
        0x0080: 'FORMAT.MOVE',
        0x0081: 'FORMAT.SIZE',
        0x0082: 'FORMULA.REPLACE',
        0x0083: 'SEND.KEYS',
        0x0084: 'SELECT.SPECIAL',
        0x0085: 'APPLY.NAMES',
        0x0086: 'REPLACE.FONT',
        0x0087: 'FREEZE.PANES',
        0x0088: 'SHOW.INFO',
        0x0089: 'SPLIT',
        0x008A: 'ON.WINDOW',
        0x008B: 'ON.DATA',
        0x008C: 'DISABLE.INPUT',
        0x008E: 'OUTLINE',
        0x008F: 'LIST.NAMES',
        0x0090: 'FILE.CLOSE',
        0x0091: 'SAVE.WORKBOOK',
        0x0092: 'DATA.FORM',
        0x0093: 'COPY.CHART',
        0x0094: 'ON.TIME',
        0x0095: 'WAIT',
        0x0096: 'FORMAT.FONT',
        0x0097: 'FILL.UP',
        0x0098: 'FILL.LEFT',
        0x0099: 'DELETE.OVERLAY',
        0x009B: 'SHORT.MENUS',
        0x009F: 'SET.UPDATE.STATUS',
        0x00A1: 'COLOR.PALETTE',
        0x00A2: 'DELETE.STYLE',
        0x00A3: 'WINDOW.RESTORE',
        0x00A4: 'WINDOW.MAXIMIZE',
        0x00A6: 'CHANGE.LINK',
        0x00A7: 'CALCULATE.DOCUMENT',
        0x00A8: 'ON.KEY',
        0x00A9: 'APP.RESTORE',
        0x00AA: 'APP.MOVE',
        0x00AB: 'APP.SIZE',
        0x00AC: 'APP.MINIMIZE',
        0x00AD: 'APP.MAXIMIZE',
        0x00AE: 'BRING.TO.FRONT',
        0x00AF: 'SEND.TO.BACK',
        0x00B9: 'MAIN.CHART.TYPE',
        0x00BA: 'OVERLAY.CHART.TYPE',
        0x00BB: 'SELECT.END',
        0x00BC: 'OPEN.MAIL',
        0x00BD: 'SEND.MAIL',
        0x00BE: 'STANDARD.FONT',
        0x00BF: 'CONSOLIDATE',
        0x00C0: 'SORT.SPECIAL',
        0x00C1: 'GALLERY.3D.AREA',
        0x00C2: 'GALLERY.3D.COLUMN',
        0x00C3: 'GALLERY.3D.LINE',
        0x00C4: 'GALLERY.3D.PIE',
        0x00C5: 'VIEW.3D',
        0x00C6: 'GOAL.SEEK',
        0x00C7: 'WORKGROUP',
        0x00C8: 'FILL.GROUP',
        0x00C9: 'UPDATE.LINK',
        0x00CA: 'PROMOTE',
        0x00CB: 'DEMOTE',
        0x00CC: 'SHOW.DETAIL',
        0x00CE: 'UNGROUP',
        0x00CF: 'OBJECT.PROPERTIES',
        0x00D0: 'SAVE.NEW.OBJECT',
        0x00D1: 'SHARE',
        0x00D2: 'SHARE.NAME',
        0x00D3: 'DUPLICATE',
        0x00D4: 'APPLY.STYLE',
        0x00D5: 'ASSIGN.TO.OBJECT',
        0x00D6: 'OBJECT.PROTECTION',
        0x00D7: 'HIDE.OBJECT',
        0x00D8: 'SET.EXTRACT',
        0x00D9: 'CREATE.PUBLISHER',
        0x00DA: 'SUBSCRIBE.TO',
        0x00DB: 'ATTRIBUTES',
        0x00DC: 'SHOW.TOOLBAR',
        0x00DE: 'PRINT.PREVIEW',
        0x00DF: 'EDIT.COLOR',
        0x00E0: 'SHOW.LEVELS',
        0x00E1: 'FORMAT.MAIN',
        0x00E2: 'FORMAT.OVERLAY',
        0x00E3: 'ON.RECALC',
        0x00E4: 'EDIT.SERIES',
        0x00E5: 'DEFINE.STYLE',
        0x00F0: 'LINE.PRINT',
        0x00F3: 'ENTER.DATA',
        0x00F9: 'GALLERY.RADAR',
        0x00FA: 'MERGE.STYLES',
        0x00FB: 'EDITION.OPTIONS',
        0x00FC: 'PASTE.PICTURE',
        0x00FD: 'PASTE.PICTURE.LINK',
        0x00FE: 'SPELLING',
        0x0100: 'ZOOM',
        0x0103: 'INSERT.OBJECT',
        0x0104: 'WINDOW.MINIMIZE',
        0x0109: 'SOUND.NOTE',
        0x010A: 'SOUND.PLAY',
        0x010B: 'FORMAT.SHAPE',
        0x010C: 'EXTEND.POLYGON',
        0x010D: 'FORMAT.AUTO',
        0x0110: 'GALLERY.3D.BAR',
        0x0111: 'GALLERY.3D.SURFACE',
        0x0112: 'FILL.AUTO',
        0x0114: 'CUSTOMIZE.TOOLBAR',
        0x0115: 'ADD.TOOL',
        0x0116: 'EDIT.OBJECT',
        0x0117: 'ON.DOUBLECLICK',
        0x0118: 'ON.ENTRY',
        0x0119: 'WORKBOOK.ADD',
        0x011A: 'WORKBOOK.MOVE',
        0x011B: 'WORKBOOK.COPY',
        0x011C: 'WORKBOOK.OPTIONS',
        0x011D: 'SAVE.WORKSPACE',
        0x0120: 'CHART.WIZARD',
        0x0121: 'DELETE.TOOL',
        0x0122: 'MOVE.TOOL',
        0x0123: 'WORKBOOK.SELECT',
        0x0124: 'WORKBOOK.ACTIVATE',
        0x0125: 'ASSIGN.TO.TOOL',
        0x0127: 'COPY.TOOL',
        0x0128: 'RESET.TOOL',
        0x0129: 'CONSTRAIN.NUMERIC',
        0x012A: 'PASTE.TOOL',
        0x012E: 'WORKBOOK.NEW',
        0x0131: 'SCENARIO.CELLS',
        0x0132: 'SCENARIO.DELETE',
        0x0133: 'SCENARIO.ADD',
        0x0134: 'SCENARIO.EDIT',
        0x0135: 'SCENARIO.SHOW',
        0x0136: 'SCENARIO.SHOW.NEXT',
        0x0137: 'SCENARIO.SUMMARY',
        0x0138: 'PIVOT.TABLE.WIZARD',
        0x0139: 'PIVOT.FIELD.PROPERTIES',
        0x013A: 'PIVOT.FIELD',
        0x013B: 'PIVOT.ITEM',
        0x013C: 'PIVOT.ADD.FIELDS',
        0x013E: 'OPTIONS.CALCULATION',
        0x013F: 'OPTIONS.EDIT',
        0x0140: 'OPTIONS.VIEW',
        0x0141: 'ADDIN.MANAGER',
        0x0142: 'MENU.EDITOR',
        0x0143: 'ATTACH.TOOLBARS',
        0x0144: 'VBAActivate',
        0x0145: 'OPTIONS.CHART',
        0x0148: 'VBA.INSERT.FILE',
        0x014A: 'VBA.PROCEDURE.DEFINITION',
        0x0150: 'ROUTING.SLIP',
        0x0152: 'ROUTE.DOCUMENT',
        0x0153: 'MAIL.LOGON',
        0x0156: 'INSERT.PICTURE',
        0x0157: 'EDIT.TOOL',
        0x0158: 'GALLERY.DOUGHNUT',
        0x015E: 'CHART.TREND',
        0x0160: 'PIVOT.ITEM.PROPERTIES',
        0x0162: 'WORKBOOK.INSERT',
        0x0163: 'OPTIONS.TRANSITION',
        0x0164: 'OPTIONS.GENERAL',
        0x0172: 'FILTER.ADVANCED',
        0x0175: 'MAIL.ADD.MAILER',
        0x0176: 'MAIL.DELETE.MAILER',
        0x0177: 'MAIL.REPLY',
        0x0178: 'MAIL.REPLY.ALL',
        0x0179: 'MAIL.FORWARD',
        0x017A: 'MAIL.NEXT.LETTER',
        0x017B: 'DATA.LABEL',
        0x017C: 'INSERT.TITLE',
        0x017D: 'FONT.PROPERTIES',
        0x017E: 'MACRO.OPTIONS',
        0x017F: 'WORKBOOK.HIDE',
        0x0180: 'WORKBOOK.UNHIDE',
        0x0181: 'WORKBOOK.DELETE',
        0x0182: 'WORKBOOK.NAME',
        0x0184: 'GALLERY.CUSTOM',
        0x0186: 'ADD.CHART.AUTOFORMAT',
        0x0187: 'DELETE.CHART.AUTOFORMAT',
        0x0188: 'CHART.ADD.DATA',
        0x0189: 'AUTO.OUTLINE',
        0x018A: 'TAB.ORDER',
        0x018B: 'SHOW.DIALOG',
        0x018C: 'SELECT.ALL',
        0x018D: 'UNGROUP.SHEETS',
        0x018E: 'SUBTOTAL.CREATE',
        0x018F: 'SUBTOTAL.REMOVE',
        0x0190: 'RENAME.OBJECT',
        0x019C: 'WORKBOOK.SCROLL',
        0x019D: 'WORKBOOK.NEXT',
        0x019E: 'WORKBOOK.PREV',
        0x019F: 'WORKBOOK.TAB.SPLIT',
        0x01A0: 'FULL.SCREEN',
        0x01A1: 'WORKBOOK.PROTECT',
        0x01A4: 'SCROLLBAR.PROPERTIES',
        0x01A5: 'PIVOT.SHOW.PAGES',
        0x01A6: 'TEXT.TO.COLUMNS',
        0x01A7: 'FORMAT.CHARTTYPE',
        0x01A8: 'LINK.FORMAT',
        0x01A9: 'TRACER.DISPLAY',
        0x01AE: 'TRACER.NAVIGATE',
        0x01AF: 'TRACER.CLEAR',
        0x01B0: 'TRACER.ERROR',
        0x01B1: 'PIVOT.FIELD.GROUP',
        0x01B2: 'PIVOT.FIELD.UNGROUP',
        0x01B3: 'CHECKBOX.PROPERTIES',
        0x01B4: 'LABEL.PROPERTIES',
        0x01B5: 'LISTBOX.PROPERTIES',
        0x01B6: 'EDITBOX.PROPERTIES',
        0x01B7: 'PIVOT.REFRESH',
        0x01B8: 'LINK.COMBO',
        0x01B9: 'OPEN.TEXT',
        0x01BA: 'HIDE.DIALOG',
        0x01BB: 'SET.DIALOG.FOCUS',
        0x01BC: 'ENABLE.OBJECT',
        0x01BD: 'PUSHBUTTON.PROPERTIES',
        0x01BE: 'SET.DIALOG.DEFAULT',
        0x01BF: 'FILTER',
        0x01C0: 'FILTER.SHOW.ALL',
        0x01C1: 'CLEAR.OUTLINE',
        0x01C2: 'FUNCTION.WIZARD',
        0x01C3: 'ADD.LIST.ITEM',
        0x01C4: 'SET.LIST.ITEM',
        0x01C5: 'REMOVE.LIST.ITEM',
        0x01C6: 'SELECT.LIST.ITEM',
        0x01C7: 'SET.CONTROL.VALUE',
        0x01C8: 'SAVE.COPY.AS',
        0x01CA: 'OPTIONS.LISTS.ADD',
        0x01CB: 'OPTIONS.LISTS.DELETE',
        0x01CC: 'SERIES.AXES',
        0x01CD: 'SERIES.X',
        0x01CE: 'SERIES.Y',
        0x01CF: 'ERRORBAR.X',
        0x01D0: 'ERRORBAR.Y',
        0x01D1: 'FORMAT.CHART',
        0x01D2: 'SERIES.ORDER',
        0x01D3: 'MAIL.LOGOFF',
        0x01D4: 'CLEAR.ROUTING.SLIP',
        0x01D5: 'APP.ACTIVATE.MICROSOFT',
        0x01D6: 'MAIL.EDIT.MAILER',
        0x01D7: 'ON.SHEET',
        0x01D8: 'STANDARD.WIDTH',
        0x01D9: 'SCENARIO.MERGE',
        0x01DA: 'SUMMARY.INFO',
        0x01DB: 'FIND.FILE',
        0x01DC: 'ACTIVE.CELL.FONT',
        0x01DD: 'ENABLE.TIPWIZARD',
        0x01DE: 'VBA.MAKE.ADDIN',
        0x01E0: 'INSERTDATATABLE',
        0x01E1: 'WORKGROUP.OPTIONS',
        0x01E2: 'MAIL.SEND.MAILER',
        0x01E5: 'AUTOCORRECT',
        0x01E9: 'POST.DOCUMENT',
        0x01EB: 'PICKLIST',
        0x01ED: 'VIEW.SHOW',
        0x01EE: 'VIEW.DEFINE',
        0x01EF: 'VIEW.DELETE',
        0x01FD: 'SHEET.BACKGROUND',
        0x01FE: 'INSERT.MAP.OBJECT',
        0x01FF: 'OPTIONS.MENONO',
        0x0205: 'MSOCHECKS',
        0x0206: 'NORMAL',
        0x0207: 'LAYOUT',
        0x0208: 'RM.PRINT.AREA',
        0x0209: 'CLEAR.PRINT.AREA',
        0x020A: 'ADD.PRINT.AREA',
        0x020B: 'MOVE.BRK',
        0x0221: 'HIDECURR.NOTE',
        0x0222: 'HIDEALL.NOTES',
        0x0223: 'DELETE.NOTE',
        0x0224: 'TRAVERSE.NOTES',
        0x0225: 'ACTIVATE.NOTES',
        0x026C: 'PROTECT.REVISIONS',
        0x026D: 'UNPROTECT.REVISIONS',
        0x0287: 'OPTIONS.ME',
        0x028D: 'WEB.PUBLISH',
        0x029B: 'NEWWEBQUERY',
        0x02A1: 'PIVOT.TABLE.CHART',
        0x02F1: 'OPTIONS.SAVE',
        0x02F3: 'OPTIONS.SPELL',
        0x0328: 'HIDEALL.INKANNOTS'
    };
    /* [MS-XLS] 2.5.198.17 */ /* [MS-XLSB] 2.5.97.10 */ var Ftab = {
        0x0000: 'COUNT',
        0x0001: 'IF',
        0x0002: 'ISNA',
        0x0003: 'ISERROR',
        0x0004: 'SUM',
        0x0005: 'AVERAGE',
        0x0006: 'MIN',
        0x0007: 'MAX',
        0x0008: 'ROW',
        0x0009: 'COLUMN',
        0x000A: 'NA',
        0x000B: 'NPV',
        0x000C: 'STDEV',
        0x000D: 'DOLLAR',
        0x000E: 'FIXED',
        0x000F: 'SIN',
        0x0010: 'COS',
        0x0011: 'TAN',
        0x0012: 'ATAN',
        0x0013: 'PI',
        0x0014: 'SQRT',
        0x0015: 'EXP',
        0x0016: 'LN',
        0x0017: 'LOG10',
        0x0018: 'ABS',
        0x0019: 'INT',
        0x001A: 'SIGN',
        0x001B: 'ROUND',
        0x001C: 'LOOKUP',
        0x001D: 'INDEX',
        0x001E: 'REPT',
        0x001F: 'MID',
        0x0020: 'LEN',
        0x0021: 'VALUE',
        0x0022: 'TRUE',
        0x0023: 'FALSE',
        0x0024: 'AND',
        0x0025: 'OR',
        0x0026: 'NOT',
        0x0027: 'MOD',
        0x0028: 'DCOUNT',
        0x0029: 'DSUM',
        0x002A: 'DAVERAGE',
        0x002B: 'DMIN',
        0x002C: 'DMAX',
        0x002D: 'DSTDEV',
        0x002E: 'VAR',
        0x002F: 'DVAR',
        0x0030: 'TEXT',
        0x0031: 'LINEST',
        0x0032: 'TREND',
        0x0033: 'LOGEST',
        0x0034: 'GROWTH',
        0x0035: 'GOTO',
        0x0036: 'HALT',
        0x0037: 'RETURN',
        0x0038: 'PV',
        0x0039: 'FV',
        0x003A: 'NPER',
        0x003B: 'PMT',
        0x003C: 'RATE',
        0x003D: 'MIRR',
        0x003E: 'IRR',
        0x003F: 'RAND',
        0x0040: 'MATCH',
        0x0041: 'DATE',
        0x0042: 'TIME',
        0x0043: 'DAY',
        0x0044: 'MONTH',
        0x0045: 'YEAR',
        0x0046: 'WEEKDAY',
        0x0047: 'HOUR',
        0x0048: 'MINUTE',
        0x0049: 'SECOND',
        0x004A: 'NOW',
        0x004B: 'AREAS',
        0x004C: 'ROWS',
        0x004D: 'COLUMNS',
        0x004E: 'OFFSET',
        0x004F: 'ABSREF',
        0x0050: 'RELREF',
        0x0051: 'ARGUMENT',
        0x0052: 'SEARCH',
        0x0053: 'TRANSPOSE',
        0x0054: 'ERROR',
        0x0055: 'STEP',
        0x0056: 'TYPE',
        0x0057: 'ECHO',
        0x0058: 'SET.NAME',
        0x0059: 'CALLER',
        0x005A: 'DEREF',
        0x005B: 'WINDOWS',
        0x005C: 'SERIES',
        0x005D: 'DOCUMENTS',
        0x005E: 'ACTIVE.CELL',
        0x005F: 'SELECTION',
        0x0060: 'RESULT',
        0x0061: 'ATAN2',
        0x0062: 'ASIN',
        0x0063: 'ACOS',
        0x0064: 'CHOOSE',
        0x0065: 'HLOOKUP',
        0x0066: 'VLOOKUP',
        0x0067: 'LINKS',
        0x0068: 'INPUT',
        0x0069: 'ISREF',
        0x006A: 'GET.FORMULA',
        0x006B: 'GET.NAME',
        0x006C: 'SET.VALUE',
        0x006D: 'LOG',
        0x006E: 'EXEC',
        0x006F: 'CHAR',
        0x0070: 'LOWER',
        0x0071: 'UPPER',
        0x0072: 'PROPER',
        0x0073: 'LEFT',
        0x0074: 'RIGHT',
        0x0075: 'EXACT',
        0x0076: 'TRIM',
        0x0077: 'REPLACE',
        0x0078: 'SUBSTITUTE',
        0x0079: 'CODE',
        0x007A: 'NAMES',
        0x007B: 'DIRECTORY',
        0x007C: 'FIND',
        0x007D: 'CELL',
        0x007E: 'ISERR',
        0x007F: 'ISTEXT',
        0x0080: 'ISNUMBER',
        0x0081: 'ISBLANK',
        0x0082: 'T',
        0x0083: 'N',
        0x0084: 'FOPEN',
        0x0085: 'FCLOSE',
        0x0086: 'FSIZE',
        0x0087: 'FREADLN',
        0x0088: 'FREAD',
        0x0089: 'FWRITELN',
        0x008A: 'FWRITE',
        0x008B: 'FPOS',
        0x008C: 'DATEVALUE',
        0x008D: 'TIMEVALUE',
        0x008E: 'SLN',
        0x008F: 'SYD',
        0x0090: 'DDB',
        0x0091: 'GET.DEF',
        0x0092: 'REFTEXT',
        0x0093: 'TEXTREF',
        0x0094: 'INDIRECT',
        0x0095: 'REGISTER',
        0x0096: 'CALL',
        0x0097: 'ADD.BAR',
        0x0098: 'ADD.MENU',
        0x0099: 'ADD.COMMAND',
        0x009A: 'ENABLE.COMMAND',
        0x009B: 'CHECK.COMMAND',
        0x009C: 'RENAME.COMMAND',
        0x009D: 'SHOW.BAR',
        0x009E: 'DELETE.MENU',
        0x009F: 'DELETE.COMMAND',
        0x00A0: 'GET.CHART.ITEM',
        0x00A1: 'DIALOG.BOX',
        0x00A2: 'CLEAN',
        0x00A3: 'MDETERM',
        0x00A4: 'MINVERSE',
        0x00A5: 'MMULT',
        0x00A6: 'FILES',
        0x00A7: 'IPMT',
        0x00A8: 'PPMT',
        0x00A9: 'COUNTA',
        0x00AA: 'CANCEL.KEY',
        0x00AB: 'FOR',
        0x00AC: 'WHILE',
        0x00AD: 'BREAK',
        0x00AE: 'NEXT',
        0x00AF: 'INITIATE',
        0x00B0: 'REQUEST',
        0x00B1: 'POKE',
        0x00B2: 'EXECUTE',
        0x00B3: 'TERMINATE',
        0x00B4: 'RESTART',
        0x00B5: 'HELP',
        0x00B6: 'GET.BAR',
        0x00B7: 'PRODUCT',
        0x00B8: 'FACT',
        0x00B9: 'GET.CELL',
        0x00BA: 'GET.WORKSPACE',
        0x00BB: 'GET.WINDOW',
        0x00BC: 'GET.DOCUMENT',
        0x00BD: 'DPRODUCT',
        0x00BE: 'ISNONTEXT',
        0x00BF: 'GET.NOTE',
        0x00C0: 'NOTE',
        0x00C1: 'STDEVP',
        0x00C2: 'VARP',
        0x00C3: 'DSTDEVP',
        0x00C4: 'DVARP',
        0x00C5: 'TRUNC',
        0x00C6: 'ISLOGICAL',
        0x00C7: 'DCOUNTA',
        0x00C8: 'DELETE.BAR',
        0x00C9: 'UNREGISTER',
        0x00CC: 'USDOLLAR',
        0x00CD: 'FINDB',
        0x00CE: 'SEARCHB',
        0x00CF: 'REPLACEB',
        0x00D0: 'LEFTB',
        0x00D1: 'RIGHTB',
        0x00D2: 'MIDB',
        0x00D3: 'LENB',
        0x00D4: 'ROUNDUP',
        0x00D5: 'ROUNDDOWN',
        0x00D6: 'ASC',
        0x00D7: 'DBCS',
        0x00D8: 'RANK',
        0x00DB: 'ADDRESS',
        0x00DC: 'DAYS360',
        0x00DD: 'TODAY',
        0x00DE: 'VDB',
        0x00DF: 'ELSE',
        0x00E0: 'ELSE.IF',
        0x00E1: 'END.IF',
        0x00E2: 'FOR.CELL',
        0x00E3: 'MEDIAN',
        0x00E4: 'SUMPRODUCT',
        0x00E5: 'SINH',
        0x00E6: 'COSH',
        0x00E7: 'TANH',
        0x00E8: 'ASINH',
        0x00E9: 'ACOSH',
        0x00EA: 'ATANH',
        0x00EB: 'DGET',
        0x00EC: 'CREATE.OBJECT',
        0x00ED: 'VOLATILE',
        0x00EE: 'LAST.ERROR',
        0x00EF: 'CUSTOM.UNDO',
        0x00F0: 'CUSTOM.REPEAT',
        0x00F1: 'FORMULA.CONVERT',
        0x00F2: 'GET.LINK.INFO',
        0x00F3: 'TEXT.BOX',
        0x00F4: 'INFO',
        0x00F5: 'GROUP',
        0x00F6: 'GET.OBJECT',
        0x00F7: 'DB',
        0x00F8: 'PAUSE',
        0x00FB: 'RESUME',
        0x00FC: 'FREQUENCY',
        0x00FD: 'ADD.TOOLBAR',
        0x00FE: 'DELETE.TOOLBAR',
        0x00FF: 'User',
        0x0100: 'RESET.TOOLBAR',
        0x0101: 'EVALUATE',
        0x0102: 'GET.TOOLBAR',
        0x0103: 'GET.TOOL',
        0x0104: 'SPELLING.CHECK',
        0x0105: 'ERROR.TYPE',
        0x0106: 'APP.TITLE',
        0x0107: 'WINDOW.TITLE',
        0x0108: 'SAVE.TOOLBAR',
        0x0109: 'ENABLE.TOOL',
        0x010A: 'PRESS.TOOL',
        0x010B: 'REGISTER.ID',
        0x010C: 'GET.WORKBOOK',
        0x010D: 'AVEDEV',
        0x010E: 'BETADIST',
        0x010F: 'GAMMALN',
        0x0110: 'BETAINV',
        0x0111: 'BINOMDIST',
        0x0112: 'CHIDIST',
        0x0113: 'CHIINV',
        0x0114: 'COMBIN',
        0x0115: 'CONFIDENCE',
        0x0116: 'CRITBINOM',
        0x0117: 'EVEN',
        0x0118: 'EXPONDIST',
        0x0119: 'FDIST',
        0x011A: 'FINV',
        0x011B: 'FISHER',
        0x011C: 'FISHERINV',
        0x011D: 'FLOOR',
        0x011E: 'GAMMADIST',
        0x011F: 'GAMMAINV',
        0x0120: 'CEILING',
        0x0121: 'HYPGEOMDIST',
        0x0122: 'LOGNORMDIST',
        0x0123: 'LOGINV',
        0x0124: 'NEGBINOMDIST',
        0x0125: 'NORMDIST',
        0x0126: 'NORMSDIST',
        0x0127: 'NORMINV',
        0x0128: 'NORMSINV',
        0x0129: 'STANDARDIZE',
        0x012A: 'ODD',
        0x012B: 'PERMUT',
        0x012C: 'POISSON',
        0x012D: 'TDIST',
        0x012E: 'WEIBULL',
        0x012F: 'SUMXMY2',
        0x0130: 'SUMX2MY2',
        0x0131: 'SUMX2PY2',
        0x0132: 'CHITEST',
        0x0133: 'CORREL',
        0x0134: 'COVAR',
        0x0135: 'FORECAST',
        0x0136: 'FTEST',
        0x0137: 'INTERCEPT',
        0x0138: 'PEARSON',
        0x0139: 'RSQ',
        0x013A: 'STEYX',
        0x013B: 'SLOPE',
        0x013C: 'TTEST',
        0x013D: 'PROB',
        0x013E: 'DEVSQ',
        0x013F: 'GEOMEAN',
        0x0140: 'HARMEAN',
        0x0141: 'SUMSQ',
        0x0142: 'KURT',
        0x0143: 'SKEW',
        0x0144: 'ZTEST',
        0x0145: 'LARGE',
        0x0146: 'SMALL',
        0x0147: 'QUARTILE',
        0x0148: 'PERCENTILE',
        0x0149: 'PERCENTRANK',
        0x014A: 'MODE',
        0x014B: 'TRIMMEAN',
        0x014C: 'TINV',
        0x014E: 'MOVIE.COMMAND',
        0x014F: 'GET.MOVIE',
        0x0150: 'CONCATENATE',
        0x0151: 'POWER',
        0x0152: 'PIVOT.ADD.DATA',
        0x0153: 'GET.PIVOT.TABLE',
        0x0154: 'GET.PIVOT.FIELD',
        0x0155: 'GET.PIVOT.ITEM',
        0x0156: 'RADIANS',
        0x0157: 'DEGREES',
        0x0158: 'SUBTOTAL',
        0x0159: 'SUMIF',
        0x015A: 'COUNTIF',
        0x015B: 'COUNTBLANK',
        0x015C: 'SCENARIO.GET',
        0x015D: 'OPTIONS.LISTS.GET',
        0x015E: 'ISPMT',
        0x015F: 'DATEDIF',
        0x0160: 'DATESTRING',
        0x0161: 'NUMBERSTRING',
        0x0162: 'ROMAN',
        0x0163: 'OPEN.DIALOG',
        0x0164: 'SAVE.DIALOG',
        0x0165: 'VIEW.GET',
        0x0166: 'GETPIVOTDATA',
        0x0167: 'HYPERLINK',
        0x0168: 'PHONETIC',
        0x0169: 'AVERAGEA',
        0x016A: 'MAXA',
        0x016B: 'MINA',
        0x016C: 'STDEVPA',
        0x016D: 'VARPA',
        0x016E: 'STDEVA',
        0x016F: 'VARA',
        0x0170: 'BAHTTEXT',
        0x0171: 'THAIDAYOFWEEK',
        0x0172: 'THAIDIGIT',
        0x0173: 'THAIMONTHOFYEAR',
        0x0174: 'THAINUMSOUND',
        0x0175: 'THAINUMSTRING',
        0x0176: 'THAISTRINGLENGTH',
        0x0177: 'ISTHAIDIGIT',
        0x0178: 'ROUNDBAHTDOWN',
        0x0179: 'ROUNDBAHTUP',
        0x017A: 'THAIYEAR',
        0x017B: 'RTD',
        0x017C: 'CUBEVALUE',
        0x017D: 'CUBEMEMBER',
        0x017E: 'CUBEMEMBERPROPERTY',
        0x017F: 'CUBERANKEDMEMBER',
        0x0180: 'HEX2BIN',
        0x0181: 'HEX2DEC',
        0x0182: 'HEX2OCT',
        0x0183: 'DEC2BIN',
        0x0184: 'DEC2HEX',
        0x0185: 'DEC2OCT',
        0x0186: 'OCT2BIN',
        0x0187: 'OCT2HEX',
        0x0188: 'OCT2DEC',
        0x0189: 'BIN2DEC',
        0x018A: 'BIN2OCT',
        0x018B: 'BIN2HEX',
        0x018C: 'IMSUB',
        0x018D: 'IMDIV',
        0x018E: 'IMPOWER',
        0x018F: 'IMABS',
        0x0190: 'IMSQRT',
        0x0191: 'IMLN',
        0x0192: 'IMLOG2',
        0x0193: 'IMLOG10',
        0x0194: 'IMSIN',
        0x0195: 'IMCOS',
        0x0196: 'IMEXP',
        0x0197: 'IMARGUMENT',
        0x0198: 'IMCONJUGATE',
        0x0199: 'IMAGINARY',
        0x019A: 'IMREAL',
        0x019B: 'COMPLEX',
        0x019C: 'IMSUM',
        0x019D: 'IMPRODUCT',
        0x019E: 'SERIESSUM',
        0x019F: 'FACTDOUBLE',
        0x01A0: 'SQRTPI',
        0x01A1: 'QUOTIENT',
        0x01A2: 'DELTA',
        0x01A3: 'GESTEP',
        0x01A4: 'ISEVEN',
        0x01A5: 'ISODD',
        0x01A6: 'MROUND',
        0x01A7: 'ERF',
        0x01A8: 'ERFC',
        0x01A9: 'BESSELJ',
        0x01AA: 'BESSELK',
        0x01AB: 'BESSELY',
        0x01AC: 'BESSELI',
        0x01AD: 'XIRR',
        0x01AE: 'XNPV',
        0x01AF: 'PRICEMAT',
        0x01B0: 'YIELDMAT',
        0x01B1: 'INTRATE',
        0x01B2: 'RECEIVED',
        0x01B3: 'DISC',
        0x01B4: 'PRICEDISC',
        0x01B5: 'YIELDDISC',
        0x01B6: 'TBILLEQ',
        0x01B7: 'TBILLPRICE',
        0x01B8: 'TBILLYIELD',
        0x01B9: 'PRICE',
        0x01BA: 'YIELD',
        0x01BB: 'DOLLARDE',
        0x01BC: 'DOLLARFR',
        0x01BD: 'NOMINAL',
        0x01BE: 'EFFECT',
        0x01BF: 'CUMPRINC',
        0x01C0: 'CUMIPMT',
        0x01C1: 'EDATE',
        0x01C2: 'EOMONTH',
        0x01C3: 'YEARFRAC',
        0x01C4: 'COUPDAYBS',
        0x01C5: 'COUPDAYS',
        0x01C6: 'COUPDAYSNC',
        0x01C7: 'COUPNCD',
        0x01C8: 'COUPNUM',
        0x01C9: 'COUPPCD',
        0x01CA: 'DURATION',
        0x01CB: 'MDURATION',
        0x01CC: 'ODDLPRICE',
        0x01CD: 'ODDLYIELD',
        0x01CE: 'ODDFPRICE',
        0x01CF: 'ODDFYIELD',
        0x01D0: 'RANDBETWEEN',
        0x01D1: 'WEEKNUM',
        0x01D2: 'AMORDEGRC',
        0x01D3: 'AMORLINC',
        0x01D4: 'CONVERT',
        0x02D4: 'SHEETJS',
        0x01D5: 'ACCRINT',
        0x01D6: 'ACCRINTM',
        0x01D7: 'WORKDAY',
        0x01D8: 'NETWORKDAYS',
        0x01D9: 'GCD',
        0x01DA: 'MULTINOMIAL',
        0x01DB: 'LCM',
        0x01DC: 'FVSCHEDULE',
        0x01DD: 'CUBEKPIMEMBER',
        0x01DE: 'CUBESET',
        0x01DF: 'CUBESETCOUNT',
        0x01E0: 'IFERROR',
        0x01E1: 'COUNTIFS',
        0x01E2: 'SUMIFS',
        0x01E3: 'AVERAGEIF',
        0x01E4: 'AVERAGEIFS'
    };
    var FtabArgc = {
        0x0002: 1,
        /* ISNA */ 0x0003: 1,
        /* ISERROR */ 0x000A: 0,
        /* NA */ 0x000F: 1,
        /* SIN */ 0x0010: 1,
        /* COS */ 0x0011: 1,
        /* TAN */ 0x0012: 1,
        /* ATAN */ 0x0013: 0,
        /* PI */ 0x0014: 1,
        /* SQRT */ 0x0015: 1,
        /* EXP */ 0x0016: 1,
        /* LN */ 0x0017: 1,
        /* LOG10 */ 0x0018: 1,
        /* ABS */ 0x0019: 1,
        /* INT */ 0x001A: 1,
        /* SIGN */ 0x001B: 2,
        /* ROUND */ 0x001E: 2,
        /* REPT */ 0x001F: 3,
        /* MID */ 0x0020: 1,
        /* LEN */ 0x0021: 1,
        /* VALUE */ 0x0022: 0,
        /* TRUE */ 0x0023: 0,
        /* FALSE */ 0x0026: 1,
        /* NOT */ 0x0027: 2,
        /* MOD */ 0x0028: 3,
        /* DCOUNT */ 0x0029: 3,
        /* DSUM */ 0x002A: 3,
        /* DAVERAGE */ 0x002B: 3,
        /* DMIN */ 0x002C: 3,
        /* DMAX */ 0x002D: 3,
        /* DSTDEV */ 0x002F: 3,
        /* DVAR */ 0x0030: 2,
        /* TEXT */ 0x0035: 1,
        /* GOTO */ 0x003D: 3,
        /* MIRR */ 0x003F: 0,
        /* RAND */ 0x0041: 3,
        /* DATE */ 0x0042: 3,
        /* TIME */ 0x0043: 1,
        /* DAY */ 0x0044: 1,
        /* MONTH */ 0x0045: 1,
        /* YEAR */ 0x0046: 1,
        /* WEEKDAY */ 0x0047: 1,
        /* HOUR */ 0x0048: 1,
        /* MINUTE */ 0x0049: 1,
        /* SECOND */ 0x004A: 0,
        /* NOW */ 0x004B: 1,
        /* AREAS */ 0x004C: 1,
        /* ROWS */ 0x004D: 1,
        /* COLUMNS */ 0x004F: 2,
        /* ABSREF */ 0x0050: 2,
        /* RELREF */ 0x0053: 1,
        /* TRANSPOSE */ 0x0055: 0,
        /* STEP */ 0x0056: 1,
        /* TYPE */ 0x0059: 0,
        /* CALLER */ 0x005A: 1,
        /* DEREF */ 0x005E: 0,
        /* ACTIVE.CELL */ 0x005F: 0,
        /* SELECTION */ 0x0061: 2,
        /* ATAN2 */ 0x0062: 1,
        /* ASIN */ 0x0063: 1,
        /* ACOS */ 0x0065: 3,
        /* HLOOKUP */ 0x0066: 3,
        /* VLOOKUP */ 0x0069: 1,
        /* ISREF */ 0x006A: 1,
        /* GET.FORMULA */ 0x006C: 2,
        /* SET.VALUE */ 0x006F: 1,
        /* CHAR */ 0x0070: 1,
        /* LOWER */ 0x0071: 1,
        /* UPPER */ 0x0072: 1,
        /* PROPER */ 0x0075: 2,
        /* EXACT */ 0x0076: 1,
        /* TRIM */ 0x0077: 4,
        /* REPLACE */ 0x0079: 1,
        /* CODE */ 0x007E: 1,
        /* ISERR */ 0x007F: 1,
        /* ISTEXT */ 0x0080: 1,
        /* ISNUMBER */ 0x0081: 1,
        /* ISBLANK */ 0x0082: 1,
        /* T */ 0x0083: 1,
        /* N */ 0x0085: 1,
        /* FCLOSE */ 0x0086: 1,
        /* FSIZE */ 0x0087: 1,
        /* FREADLN */ 0x0088: 2,
        /* FREAD */ 0x0089: 2,
        /* FWRITELN */ 0x008A: 2,
        /* FWRITE */ 0x008C: 1,
        /* DATEVALUE */ 0x008D: 1,
        /* TIMEVALUE */ 0x008E: 3,
        /* SLN */ 0x008F: 4,
        /* SYD */ 0x0090: 4,
        /* DDB */ 0x00A1: 1,
        /* DIALOG.BOX */ 0x00A2: 1,
        /* CLEAN */ 0x00A3: 1,
        /* MDETERM */ 0x00A4: 1,
        /* MINVERSE */ 0x00A5: 2,
        /* MMULT */ 0x00AC: 1,
        /* WHILE */ 0x00AF: 2,
        /* INITIATE */ 0x00B0: 2,
        /* REQUEST */ 0x00B1: 3,
        /* POKE */ 0x00B2: 2,
        /* EXECUTE */ 0x00B3: 1,
        /* TERMINATE */ 0x00B8: 1,
        /* FACT */ 0x00BA: 1,
        /* GET.WORKSPACE */ 0x00BD: 3,
        /* DPRODUCT */ 0x00BE: 1,
        /* ISNONTEXT */ 0x00C3: 3,
        /* DSTDEVP */ 0x00C4: 3,
        /* DVARP */ 0x00C5: 1,
        /* TRUNC */ 0x00C6: 1,
        /* ISLOGICAL */ 0x00C7: 3,
        /* DCOUNTA */ 0x00C9: 1,
        /* UNREGISTER */ 0x00CF: 4,
        /* REPLACEB */ 0x00D2: 3,
        /* MIDB */ 0x00D3: 1,
        /* LENB */ 0x00D4: 2,
        /* ROUNDUP */ 0x00D5: 2,
        /* ROUNDDOWN */ 0x00D6: 1,
        /* ASC */ 0x00D7: 1,
        /* DBCS */ 0x00E1: 0,
        /* END.IF */ 0x00E5: 1,
        /* SINH */ 0x00E6: 1,
        /* COSH */ 0x00E7: 1,
        /* TANH */ 0x00E8: 1,
        /* ASINH */ 0x00E9: 1,
        /* ACOSH */ 0x00EA: 1,
        /* ATANH */ 0x00EB: 3,
        /* DGET */ 0x00F4: 1,
        /* INFO */ 0x00F7: 4,
        /* DB */ 0x00FC: 2,
        /* FREQUENCY */ 0x0101: 1,
        /* EVALUATE */ 0x0105: 1,
        /* ERROR.TYPE */ 0x010F: 1,
        /* GAMMALN */ 0x0111: 4,
        /* BINOMDIST */ 0x0112: 2,
        /* CHIDIST */ 0x0113: 2,
        /* CHIINV */ 0x0114: 2,
        /* COMBIN */ 0x0115: 3,
        /* CONFIDENCE */ 0x0116: 3,
        /* CRITBINOM */ 0x0117: 1,
        /* EVEN */ 0x0118: 3,
        /* EXPONDIST */ 0x0119: 3,
        /* FDIST */ 0x011A: 3,
        /* FINV */ 0x011B: 1,
        /* FISHER */ 0x011C: 1,
        /* FISHERINV */ 0x011D: 2,
        /* FLOOR */ 0x011E: 4,
        /* GAMMADIST */ 0x011F: 3,
        /* GAMMAINV */ 0x0120: 2,
        /* CEILING */ 0x0121: 4,
        /* HYPGEOMDIST */ 0x0122: 3,
        /* LOGNORMDIST */ 0x0123: 3,
        /* LOGINV */ 0x0124: 3,
        /* NEGBINOMDIST */ 0x0125: 4,
        /* NORMDIST */ 0x0126: 1,
        /* NORMSDIST */ 0x0127: 3,
        /* NORMINV */ 0x0128: 1,
        /* NORMSINV */ 0x0129: 3,
        /* STANDARDIZE */ 0x012A: 1,
        /* ODD */ 0x012B: 2,
        /* PERMUT */ 0x012C: 3,
        /* POISSON */ 0x012D: 3,
        /* TDIST */ 0x012E: 4,
        /* WEIBULL */ 0x012F: 2,
        /* SUMXMY2 */ 0x0130: 2,
        /* SUMX2MY2 */ 0x0131: 2,
        /* SUMX2PY2 */ 0x0132: 2,
        /* CHITEST */ 0x0133: 2,
        /* CORREL */ 0x0134: 2,
        /* COVAR */ 0x0135: 3,
        /* FORECAST */ 0x0136: 2,
        /* FTEST */ 0x0137: 2,
        /* INTERCEPT */ 0x0138: 2,
        /* PEARSON */ 0x0139: 2,
        /* RSQ */ 0x013A: 2,
        /* STEYX */ 0x013B: 2,
        /* SLOPE */ 0x013C: 4,
        /* TTEST */ 0x0145: 2,
        /* LARGE */ 0x0146: 2,
        /* SMALL */ 0x0147: 2,
        /* QUARTILE */ 0x0148: 2,
        /* PERCENTILE */ 0x014B: 2,
        /* TRIMMEAN */ 0x014C: 2,
        /* TINV */ 0x0151: 2,
        /* POWER */ 0x0156: 1,
        /* RADIANS */ 0x0157: 1,
        /* DEGREES */ 0x015A: 2,
        /* COUNTIF */ 0x015B: 1,
        /* COUNTBLANK */ 0x015E: 4,
        /* ISPMT */ 0x015F: 3,
        /* DATEDIF */ 0x0160: 1,
        /* DATESTRING */ 0x0161: 2,
        /* NUMBERSTRING */ 0x0168: 1,
        /* PHONETIC */ 0x0170: 1,
        /* BAHTTEXT */ 0x0171: 1,
        /* THAIDAYOFWEEK */ 0x0172: 1,
        /* THAIDIGIT */ 0x0173: 1,
        /* THAIMONTHOFYEAR */ 0x0174: 1,
        /* THAINUMSOUND */ 0x0175: 1,
        /* THAINUMSTRING */ 0x0176: 1,
        /* THAISTRINGLENGTH */ 0x0177: 1,
        /* ISTHAIDIGIT */ 0x0178: 1,
        /* ROUNDBAHTDOWN */ 0x0179: 1,
        /* ROUNDBAHTUP */ 0x017A: 1,
        /* THAIYEAR */ 0x017E: 3,
        /* CUBEMEMBERPROPERTY */ 0x0181: 1,
        /* HEX2DEC */ 0x0188: 1,
        /* OCT2DEC */ 0x0189: 1,
        /* BIN2DEC */ 0x018C: 2,
        /* IMSUB */ 0x018D: 2,
        /* IMDIV */ 0x018E: 2,
        /* IMPOWER */ 0x018F: 1,
        /* IMABS */ 0x0190: 1,
        /* IMSQRT */ 0x0191: 1,
        /* IMLN */ 0x0192: 1,
        /* IMLOG2 */ 0x0193: 1,
        /* IMLOG10 */ 0x0194: 1,
        /* IMSIN */ 0x0195: 1,
        /* IMCOS */ 0x0196: 1,
        /* IMEXP */ 0x0197: 1,
        /* IMARGUMENT */ 0x0198: 1,
        /* IMCONJUGATE */ 0x0199: 1,
        /* IMAGINARY */ 0x019A: 1,
        /* IMREAL */ 0x019E: 4,
        /* SERIESSUM */ 0x019F: 1,
        /* FACTDOUBLE */ 0x01A0: 1,
        /* SQRTPI */ 0x01A1: 2,
        /* QUOTIENT */ 0x01A4: 1,
        /* ISEVEN */ 0x01A5: 1,
        /* ISODD */ 0x01A6: 2,
        /* MROUND */ 0x01A8: 1,
        /* ERFC */ 0x01A9: 2,
        /* BESSELJ */ 0x01AA: 2,
        /* BESSELK */ 0x01AB: 2,
        /* BESSELY */ 0x01AC: 2,
        /* BESSELI */ 0x01AE: 3,
        /* XNPV */ 0x01B6: 3,
        /* TBILLEQ */ 0x01B7: 3,
        /* TBILLPRICE */ 0x01B8: 3,
        /* TBILLYIELD */ 0x01BB: 2,
        /* DOLLARDE */ 0x01BC: 2,
        /* DOLLARFR */ 0x01BD: 2,
        /* NOMINAL */ 0x01BE: 2,
        /* EFFECT */ 0x01BF: 6,
        /* CUMPRINC */ 0x01C0: 6,
        /* CUMIPMT */ 0x01C1: 2,
        /* EDATE */ 0x01C2: 2,
        /* EOMONTH */ 0x01D0: 2,
        /* RANDBETWEEN */ 0x01D4: 3,
        /* CONVERT */ 0x01DC: 2,
        /* FVSCHEDULE */ 0x01DF: 1,
        /* CUBESETCOUNT */ 0x01E0: 2,
        /* IFERROR */ 0xFFFF: 0
    };
    /* [MS-XLSX] 2.2.3 Functions */ /* [MS-XLSB] 2.5.97.10 Ftab */ var XLSXFutureFunctions = {
        "_xlfn.ACOT": "ACOT",
        "_xlfn.ACOTH": "ACOTH",
        "_xlfn.AGGREGATE": "AGGREGATE",
        "_xlfn.ARABIC": "ARABIC",
        "_xlfn.AVERAGEIF": "AVERAGEIF",
        "_xlfn.AVERAGEIFS": "AVERAGEIFS",
        "_xlfn.BASE": "BASE",
        "_xlfn.BETA.DIST": "BETA.DIST",
        "_xlfn.BETA.INV": "BETA.INV",
        "_xlfn.BINOM.DIST": "BINOM.DIST",
        "_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
        "_xlfn.BINOM.INV": "BINOM.INV",
        "_xlfn.BITAND": "BITAND",
        "_xlfn.BITLSHIFT": "BITLSHIFT",
        "_xlfn.BITOR": "BITOR",
        "_xlfn.BITRSHIFT": "BITRSHIFT",
        "_xlfn.BITXOR": "BITXOR",
        "_xlfn.CEILING.MATH": "CEILING.MATH",
        "_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
        "_xlfn.CHISQ.DIST": "CHISQ.DIST",
        "_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
        "_xlfn.CHISQ.INV": "CHISQ.INV",
        "_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
        "_xlfn.CHISQ.TEST": "CHISQ.TEST",
        "_xlfn.COMBINA": "COMBINA",
        "_xlfn.CONCAT": "CONCAT",
        "_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
        "_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
        "_xlfn.COT": "COT",
        "_xlfn.COTH": "COTH",
        "_xlfn.COUNTIFS": "COUNTIFS",
        "_xlfn.COVARIANCE.P": "COVARIANCE.P",
        "_xlfn.COVARIANCE.S": "COVARIANCE.S",
        "_xlfn.CSC": "CSC",
        "_xlfn.CSCH": "CSCH",
        "_xlfn.DAYS": "DAYS",
        "_xlfn.DECIMAL": "DECIMAL",
        "_xlfn.ECMA.CEILING": "ECMA.CEILING",
        "_xlfn.ERF.PRECISE": "ERF.PRECISE",
        "_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
        "_xlfn.EXPON.DIST": "EXPON.DIST",
        "_xlfn.F.DIST": "F.DIST",
        "_xlfn.F.DIST.RT": "F.DIST.RT",
        "_xlfn.F.INV": "F.INV",
        "_xlfn.F.INV.RT": "F.INV.RT",
        "_xlfn.F.TEST": "F.TEST",
        "_xlfn.FILTERXML": "FILTERXML",
        "_xlfn.FLOOR.MATH": "FLOOR.MATH",
        "_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
        "_xlfn.FORECAST.ETS": "FORECAST.ETS",
        "_xlfn.FORECAST.ETS.CONFINT": "FORECAST.ETS.CONFINT",
        "_xlfn.FORECAST.ETS.SEASONALITY": "FORECAST.ETS.SEASONALITY",
        "_xlfn.FORECAST.ETS.STAT": "FORECAST.ETS.STAT",
        "_xlfn.FORECAST.LINEAR": "FORECAST.LINEAR",
        "_xlfn.FORMULATEXT": "FORMULATEXT",
        "_xlfn.GAMMA": "GAMMA",
        "_xlfn.GAMMA.DIST": "GAMMA.DIST",
        "_xlfn.GAMMA.INV": "GAMMA.INV",
        "_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
        "_xlfn.GAUSS": "GAUSS",
        "_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
        "_xlfn.IFERROR": "IFERROR",
        "_xlfn.IFNA": "IFNA",
        "_xlfn.IFS": "IFS",
        "_xlfn.IMCOSH": "IMCOSH",
        "_xlfn.IMCOT": "IMCOT",
        "_xlfn.IMCSC": "IMCSC",
        "_xlfn.IMCSCH": "IMCSCH",
        "_xlfn.IMSEC": "IMSEC",
        "_xlfn.IMSECH": "IMSECH",
        "_xlfn.IMSINH": "IMSINH",
        "_xlfn.IMTAN": "IMTAN",
        "_xlfn.ISFORMULA": "ISFORMULA",
        "_xlfn.ISO.CEILING": "ISO.CEILING",
        "_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
        "_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
        "_xlfn.LOGNORM.INV": "LOGNORM.INV",
        "_xlfn.MAXIFS": "MAXIFS",
        "_xlfn.MINIFS": "MINIFS",
        "_xlfn.MODE.MULT": "MODE.MULT",
        "_xlfn.MODE.SNGL": "MODE.SNGL",
        "_xlfn.MUNIT": "MUNIT",
        "_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
        "_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
        "_xlfn.NIGBINOM": "NIGBINOM",
        "_xlfn.NORM.DIST": "NORM.DIST",
        "_xlfn.NORM.INV": "NORM.INV",
        "_xlfn.NORM.S.DIST": "NORM.S.DIST",
        "_xlfn.NORM.S.INV": "NORM.S.INV",
        "_xlfn.NUMBERVALUE": "NUMBERVALUE",
        "_xlfn.PDURATION": "PDURATION",
        "_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
        "_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
        "_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
        "_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
        "_xlfn.PERMUTATIONA": "PERMUTATIONA",
        "_xlfn.PHI": "PHI",
        "_xlfn.POISSON.DIST": "POISSON.DIST",
        "_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
        "_xlfn.QUARTILE.INC": "QUARTILE.INC",
        "_xlfn.QUERYSTRING": "QUERYSTRING",
        "_xlfn.RANK.AVG": "RANK.AVG",
        "_xlfn.RANK.EQ": "RANK.EQ",
        "_xlfn.RRI": "RRI",
        "_xlfn.SEC": "SEC",
        "_xlfn.SECH": "SECH",
        "_xlfn.SHEET": "SHEET",
        "_xlfn.SHEETS": "SHEETS",
        "_xlfn.SKEW.P": "SKEW.P",
        "_xlfn.STDEV.P": "STDEV.P",
        "_xlfn.STDEV.S": "STDEV.S",
        "_xlfn.SUMIFS": "SUMIFS",
        "_xlfn.SWITCH": "SWITCH",
        "_xlfn.T.DIST": "T.DIST",
        "_xlfn.T.DIST.2T": "T.DIST.2T",
        "_xlfn.T.DIST.RT": "T.DIST.RT",
        "_xlfn.T.INV": "T.INV",
        "_xlfn.T.INV.2T": "T.INV.2T",
        "_xlfn.T.TEST": "T.TEST",
        "_xlfn.TEXTJOIN": "TEXTJOIN",
        "_xlfn.UNICHAR": "UNICHAR",
        "_xlfn.UNICODE": "UNICODE",
        "_xlfn.VAR.P": "VAR.P",
        "_xlfn.VAR.S": "VAR.S",
        "_xlfn.WEBSERVICE": "WEBSERVICE",
        "_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
        "_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
        "_xlfn.XOR": "XOR",
        "_xlfn.Z.TEST": "Z.TEST"
    };
    /* Part 3 TODO: actually parse formulae */ function ods_to_csf_formula(f) {
        if (f.slice(0, 3) == "of:") f = f.slice(3);
        /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
            f = f.slice(1);
            if (f.charCodeAt(0) == 61) f = f.slice(1);
        }
        f = f.replace(/COM\.MICROSOFT\./g, "");
        /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
            return $1.replace(/\./g, "");
        });
        /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
        return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
    }
    function csf_to_ods_formula(f) {
        var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
        /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
    }
    function ods_to_csf_3D(r) {
        var a = r.split(":");
        var s = a[0].split(".")[0];
        return [
            s,
            a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
        ];
    }
    function csf_to_ods_3D(r) {
        return r.replace(/\./, "!");
    }
    var strs = {}; // shared strings
    var _ssfopts = {}; // spreadsheet formatting options
    RELS.WS = [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ];
    /*global Map */ var browser_has_Map = typeof Map !== 'undefined';
    function get_sst_id(sst, str, rev) {
        var i = 0, len = sst.length;
        if (rev) {
            if (browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
                var revarr = browser_has_Map ? rev.get(str) : rev[str];
                for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                    sst.Count++;
                    return revarr[i];
                }
            }
        } else for(; i < len; ++i)if (sst[i].t === str) {
            sst.Count++;
            return i;
        }
        sst[len] = {
            t: str
        };
        sst.Count++;
        sst.Unique++;
        if (rev) {
            if (browser_has_Map) {
                if (!rev.has(str)) rev.set(str, []);
                rev.get(str).push(len);
            } else {
                if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
                rev[str].push(len);
            }
        }
        return len;
    }
    function col_obj_w(C, col) {
        var p = {
            min: C + 1,
            max: C + 1
        };
        /* wch (chars), wpx (pixels) */ var wch = -1;
        if (col.MDW) MDW = col.MDW;
        if (col.width != null) p.customWidth = 1;
        else if (col.wpx != null) wch = px2char(col.wpx);
        else if (col.wch != null) wch = col.wch;
        if (wch > -1) {
            p.width = char2width(wch);
            p.customWidth = 1;
        } else if (col.width != null) p.width = col.width;
        if (col.hidden) p.hidden = true;
        return p;
    }
    function default_margins(margins, mode) {
        if (!margins) return;
        var defs = [
            0.7,
            0.7,
            0.75,
            0.75,
            0.3,
            0.3
        ];
        if (mode == 'xlml') defs = [
            1,
            1,
            1,
            1,
            0.5,
            0.5
        ];
        if (margins.left == null) margins.left = defs[0];
        if (margins.right == null) margins.right = defs[1];
        if (margins.top == null) margins.top = defs[2];
        if (margins.bottom == null) margins.bottom = defs[3];
        if (margins.header == null) margins.header = defs[4];
        if (margins.footer == null) margins.footer = defs[5];
    }
    function get_cell_style(styles, cell, opts) {
        var z = opts.revssf[cell.z != null ? cell.z : "General"];
        var i = 0x3c, len = styles.length;
        if (z == null && opts.ssf) {
            for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
                SSF.load(cell.z, i);
                // $FlowIgnore
                opts.ssf[i] = cell.z;
                opts.revssf[cell.z] = z = i;
                break;
            }
        }
        for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
        styles[len] = {
            numFmtId: z,
            fontId: 0,
            fillId: 0,
            borderId: 0,
            xfId: 0,
            applyNumberFormat: 1
        };
        return len;
    }
    function safe_format(p, fmtid, fillid, opts, themes, styles) {
        try {
            if (opts.cellNF) p.z = SSF._table[fmtid];
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (p.t === 'z') return;
        if (p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
        if (!opts || opts.cellText !== false) try {
            if (SSF._table[fmtid] == null) SSF.load(SSFImplicit[fmtid] || "General", fmtid);
            if (p.t === 'e') p.w = p.w || BErr[p.v];
            else if (fmtid === 0) {
                if (p.t === 'n') {
                    if ((p.v | 0) === p.v) p.w = SSF._general_int(p.v);
                    else p.w = SSF._general_num(p.v);
                } else if (p.t === 'd') {
                    var dd = datenum(p.v);
                    if ((dd | 0) === dd) p.w = SSF._general_int(dd);
                    else p.w = SSF._general_num(dd);
                } else if (p.v === undefined) return "";
                else p.w = SSF._general(p.v, _ssfopts);
            } else if (p.t === 'd') p.w = SSF.format(fmtid, datenum(p.v), _ssfopts);
            else p.w = SSF.format(fmtid, p.v, _ssfopts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (!opts.cellStyles) return;
        if (fillid != null) try {
            p.s = styles.Fills[fillid];
            if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
                p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
                if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
            }
            if (p.s.bgColor && p.s.bgColor.theme) {
                p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
                if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
            }
        } catch (e) {
            if (opts.WTF && styles.Fills) throw e;
        }
    }
    function check_ws(ws, sname, i) {
        if (ws && ws['!ref']) {
            var range = safe_decode_range(ws['!ref']);
            if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
        }
    }
    function parse_ws_xml_dim(ws, s) {
        var d = safe_decode_range(s);
        if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = encode_range(d);
    }
    var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
    var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
    var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
    var dimregex = /"(\w*:\w*)"/;
    var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
    var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
    var marginregex = /<(?:\w:)?pageMargins[^>]*\/>/g;
    var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
    var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
    /* 18.3 Worksheets */ function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
        if (!data) return data;
        if (!rels) rels = {
            '!id': {}
        };
        if (DENSE != null && opts.dense == null) opts.dense = DENSE;
        /* 18.3.1.99 worksheet CT_Worksheet */ var s = opts.dense ? [] : {};
        var refguess = {
            s: {
                r: 2000000,
                c: 2000000
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var data1 = "", data2 = "";
        var mtch = data.match(sheetdataregex);
        if (mtch) {
            data1 = data.slice(0, mtch.index);
            data2 = data.slice(mtch.index + mtch[0].length);
        } else data1 = data2 = data;
        /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match(sheetprregex);
        if (sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
        /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
            index: -1
        }).index;
        if (ridx > 0) {
            var ref = data1.slice(ridx, ridx + 50).match(dimregex);
            if (ref) parse_ws_xml_dim(s, ref[1]);
        }
        /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = data1.match(svsregex);
        if (svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);
        /* 18.3.1.17 cols CT_Cols */ var columns = [];
        if (opts.cellStyles) {
            /* 18.3.1.13 col CT_Col */ var cols = data1.match(colregex);
            if (cols) parse_ws_xml_cols(columns, cols);
        }
        /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
        /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match(afregex);
        if (afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);
        /* 18.3.1.55 mergeCells CT_MergeCells */ var merges = [];
        var _merge = data2.match(mergecregex);
        if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"") + 1));
        /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match(hlinkregex);
        if (hlink) parse_ws_xml_hlinks(s, hlink, rels);
        /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match(marginregex);
        if (margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));
        if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
        if (opts.sheetRows > 0 && s["!ref"]) {
            var tmpref = safe_decode_range(s["!ref"]);
            if (opts.sheetRows <= +tmpref.e.r) {
                tmpref.e.r = opts.sheetRows - 1;
                if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
                if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
                if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
                if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
                s["!fullref"] = s["!ref"];
                s["!ref"] = encode_range(tmpref);
            }
        }
        if (columns.length > 0) s["!cols"] = columns;
        if (merges.length > 0) s["!merges"] = merges;
        return s;
    }
    function write_ws_xml_merges(merges) {
        if (merges.length === 0) return "";
        var o = '<mergeCells count="' + merges.length + '">';
        for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
        return o + '</mergeCells>';
    }
    /* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
        var data = parsexmltag(sheetPr);
        if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
        if (data.codeName) wb.Sheets[idx].CodeName = unescapexml(utf8read(data.codeName));
    }
    function write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
        var needed = false;
        var props = {}, payload = null;
        if (opts.bookType !== 'xlsx' && wb.vbaraw) {
            var cname = wb.SheetNames[idx];
            try {
                if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
            } catch (e) {}
            needed = true;
            props.codeName = utf8write(escapexml(cname));
        }
        if (ws && ws["!outline"]) {
            var outlineprops = {
                summaryBelow: 1,
                summaryRight: 1
            };
            if (ws["!outline"].above) outlineprops.summaryBelow = 0;
            if (ws["!outline"].left) outlineprops.summaryRight = 0;
            payload = (payload || "") + writextag('outlinePr', null, outlineprops);
        }
        if (!needed && !payload) return;
        o[o.length] = writextag('sheetPr', payload, props);
    }
    /* 18.3.1.85 sheetProtection CT_SheetProtection */ var sheetprot_deffalse = [
        "objects",
        "scenarios",
        "selectLockedCells",
        "selectUnlockedCells"
    ];
    var sheetprot_deftrue = [
        "formatColumns",
        "formatRows",
        "formatCells",
        "insertColumns",
        "insertRows",
        "insertHyperlinks",
        "deleteColumns",
        "deleteRows",
        "sort",
        "autoFilter",
        "pivotTables"
    ];
    function write_ws_xml_protection(sp) {
        // algorithmName, hashValue, saltValue, spinCount
        var o = {
            sheet: 1
        };
        sheetprot_deffalse.forEach(function(n) {
            if (sp[n] != null && sp[n]) o[n] = "1";
        });
        sheetprot_deftrue.forEach(function(n) {
            if (sp[n] != null && !sp[n]) o[n] = "0";
        });
        /* TODO: algorithm */ if (sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
        return writextag('sheetProtection', null, o);
    }
    function parse_ws_xml_hlinks(s, data, rels) {
        var dense = Array.isArray(s);
        for(var i = 0; i != data.length; ++i){
            var val = parsexmltag(utf8read(data[i]), true);
            if (!val.ref) return;
            var rel = ((rels || {})['!id'] || [])[val.id];
            if (rel) {
                val.Target = rel.Target;
                if (val.location) val.Target += "#" + val.location;
            } else {
                val.Target = "#" + val.location;
                rel = {
                    Target: val.Target,
                    TargetMode: 'Internal'
                };
            }
            val.Rel = rel;
            if (val.tooltip) {
                val.Tooltip = val.tooltip;
                delete val.tooltip;
            }
            var rng = safe_decode_range(val.ref);
            for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
                var addr = encode_cell({
                    c: C,
                    r: R
                });
                if (dense) {
                    if (!s[R]) s[R] = [];
                    if (!s[R][C]) s[R][C] = {
                        t: "z",
                        v: undefined
                    };
                    s[R][C].l = val;
                } else {
                    if (!s[addr]) s[addr] = {
                        t: "z",
                        v: undefined
                    };
                    s[addr].l = val;
                }
            }
        }
    }
    function parse_ws_xml_margins(margin) {
        var o = {};
        [
            "left",
            "right",
            "top",
            "bottom",
            "header",
            "footer"
        ].forEach(function(k) {
            if (margin[k]) o[k] = parseFloat(margin[k]);
        });
        return o;
    }
    function write_ws_xml_margins(margin) {
        default_margins(margin);
        return writextag('pageMargins', null, margin);
    }
    function parse_ws_xml_cols(columns, cols) {
        var seencol = false;
        for(var coli = 0; coli != cols.length; ++coli){
            var coll = parsexmltag(cols[coli], true);
            if (coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
            var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
            delete coll.min;
            delete coll.max;
            coll.width = +coll.width;
            if (!seencol && coll.width) {
                seencol = true;
                find_mdw_colw(coll.width);
            }
            process_col(coll);
            while(colm <= colM)columns[colm++] = dup(coll);
        }
    }
    function write_ws_xml_cols(ws, cols) {
        var o = [
            "<cols>"
        ], col;
        for(var i = 0; i != cols.length; ++i){
            if (!(col = cols[i])) continue;
            o[o.length] = writextag('col', null, col_obj_w(i, col));
        }
        o[o.length] = "</cols>";
        return o.join("");
    }
    function parse_ws_xml_autofilter(data) {
        var o = {
            ref: (data.match(/ref="([^"]*)"/) || [])[1]
        };
        return o;
    }
    function write_ws_xml_autofilter(data, ws, wb, idx) {
        var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
        if (!wb.Workbook) wb.Workbook = {
            Sheets: []
        };
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        var names = wb.Workbook.Names;
        var range = decode_range(ref);
        if (range.s.r == range.e.r) {
            range.e.r = decode_range(ws["!ref"]).e.r;
            ref = encode_range(range);
        }
        for(var i = 0; i < names.length; ++i){
            var name = names[i];
            if (name.Name != '_xlnm._FilterDatabase') continue;
            if (name.Sheet != idx) continue;
            name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref;
            break;
        }
        if (i == names.length) names.push({
            Name: '_xlnm._FilterDatabase',
            Sheet: idx,
            Ref: "'" + wb.SheetNames[idx] + "'!" + ref
        });
        return writextag("autoFilter", null, {
            ref: ref
        });
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
    function parse_ws_xml_sheetviews(data, wb) {
        if (!wb.Views) wb.Views = [
            {}
        ];
        (data.match(sviewregex) || []).forEach(function(r, i) {
            var tag = parsexmltag(r);
            // $FlowIgnore
            if (!wb.Views[i]) wb.Views[i] = {};
            // $FlowIgnore
            if (parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
        });
    }
    function write_ws_xml_sheetviews(ws, opts, idx, wb) {
        var sview = {
            workbookViewId: "0"
        };
        // $FlowIgnore
        if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
        return writextag("sheetViews", writextag("sheetView", null, sview), {});
    }
    function write_ws_xml_cell(cell, ref, ws, opts) {
        if (cell.v === undefined && typeof cell.f !== "string" || cell.t === 'z') return "";
        var vv = "";
        var oldt = cell.t, oldv = cell.v;
        if (cell.t !== "z") switch(cell.t){
            case 'b':
                vv = cell.v ? "1" : "0";
                break;
            case 'n':
                vv = '' + cell.v;
                break;
            case 'e':
                vv = BErr[cell.v];
                break;
            case 'd':
                if (opts && opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
                else {
                    cell = dup(cell);
                    cell.t = 'n';
                    vv = '' + (cell.v = datenum(parseDate(cell.v)));
                }
                if (typeof cell.z === 'undefined') cell.z = SSF._table[14];
                break;
            default:
                vv = cell.v;
                break;
        }
        var v = writetag('v', escapexml(vv)), o = {
            r: ref
        };
        /* TODO: cell style */ var os = get_cell_style(opts.cellXfs, cell, opts);
        if (os !== 0) o.s = os;
        switch(cell.t){
            case 'n':
                break;
            case 'd':
                o.t = "d";
                break;
            case 'b':
                o.t = "b";
                break;
            case 'e':
                o.t = "e";
                break;
            case 'z':
                break;
            default:
                if (cell.v == null) {
                    delete cell.t;
                    break;
                }
                if (opts && opts.bookSST) {
                    v = writetag('v', '' + get_sst_id(opts.Strings, cell.v, opts.revStrings));
                    o.t = "s";
                    break;
                }
                o.t = "str";
                break;
        }
        if (cell.t != oldt) {
            cell.t = oldt;
            cell.v = oldv;
        }
        if (typeof cell.f == "string" && cell.f) {
            var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
                t: "array",
                ref: cell.F
            } : null;
            v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
        }
        if (cell.l) ws['!links'].push([
            ref,
            cell.l
        ]);
        if (cell.c) ws['!comments'].push([
            ref,
            cell.c
        ]);
        return writextag('c', v, o);
    }
    var parse_ws_xml_data = function() {
        var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
        var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
        var refregex = /ref=["']([^"']*)["']/;
        var match_v = matchtag("v"), match_f = matchtag("f");
        return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
            var ri = 0, x = "", cells = [], cref = [], idx = 0, i = 0, cc = 0, d = "", p;
            var tag, tagr = 0, tagc = 0;
            var sstr, ftag;
            var fmtid = 0, fillid = 0;
            var do_format = Array.isArray(styles.CellXf), cf;
            var arrayf = [];
            var sharedf = [];
            var dense = Array.isArray(s);
            var rows = [], rowobj = {}, rowrite = false;
            var sheetStubs = !!opts.sheetStubs;
            for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
                x = marr[mt].trim();
                var xlen = x.length;
                if (xlen === 0) continue;
                /* 18.3.1.73 row CT_Row */ for(ri = 0; ri < xlen; ++ri)if (x.charCodeAt(ri) === 62) break;
                ++ri;
                tag = parsexmltag(x.slice(0, ri), true);
                tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                tagc = -1;
                if (opts.sheetRows && opts.sheetRows < tagr) continue;
                if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
                if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
                if (opts && opts.cellStyles) {
                    rowobj = {};
                    rowrite = false;
                    if (tag.ht) {
                        rowrite = true;
                        rowobj.hpt = parseFloat(tag.ht);
                        rowobj.hpx = pt2px(rowobj.hpt);
                    }
                    if (tag.hidden == "1") {
                        rowrite = true;
                        rowobj.hidden = true;
                    }
                    if (tag.outlineLevel != null) {
                        rowrite = true;
                        rowobj.level = +tag.outlineLevel;
                    }
                    if (rowrite) rows[tagr - 1] = rowobj;
                }
                /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
                for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
                cells = cells.slice(rslice);
                for(ri = 0; ri != cells.length; ++ri){
                    x = cells[ri].trim();
                    if (x.length === 0) continue;
                    cref = x.match(rregex);
                    idx = ri;
                    i = 0;
                    cc = 0;
                    x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                    if (cref != null && cref.length === 2) {
                        idx = 0;
                        d = cref[1];
                        for(i = 0; i != d.length; ++i){
                            if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                            idx = 26 * idx + cc;
                        }
                        --idx;
                        tagc = idx;
                    } else ++tagc;
                    for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                    ++i;
                    tag = parsexmltag(x.slice(0, i), true);
                    if (!tag.r) tag.r = encode_cell({
                        r: tagr - 1,
                        c: tagc
                    });
                    d = x.slice(i);
                    p = {
                        t: ""
                    };
                    if ((cref = d.match(match_v)) != null && cref[1] !== '') p.v = unescapexml(cref[1]);
                    if (opts.cellFormula) {
                        if ((cref = d.match(match_f)) != null && cref[1] !== '') {
                            /* TODO: match against XLSXFutureFunctions */ p.f = unescapexml(utf8read(cref[1])).replace(/\r\n/g, "\n");
                            if (!opts.xlfn) p.f = _xlfn(p.f);
                            if (cref[0].indexOf('t="array"') > -1) {
                                p.F = (d.match(refregex) || [])[1];
                                if (p.F.indexOf(":") > -1) arrayf.push([
                                    safe_decode_range(p.F),
                                    p.F
                                ]);
                            } else if (cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = parsexmltag(cref[0]);
                                var ___f = unescapexml(utf8read(cref[1]));
                                if (!opts.xlfn) ___f = _xlfn(___f);
                                sharedf[parseInt(ftag.si, 10)] = [
                                    ftag,
                                    ___f,
                                    tag.r
                                ];
                            }
                        } else if (cref = d.match(/<f[^>]*\/>/)) {
                            ftag = parsexmltag(cref[0]);
                            if (sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                        }
                        /* TODO: factor out contains logic */ var _tag = decode_cell(tag.r);
                        for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                            if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                        }
                    }
                    if (tag.t == null && p.v === undefined) {
                        if (p.f || p.F) {
                            p.v = 0;
                            p.t = "n";
                        } else if (!sheetStubs) continue;
                        else p.t = "z";
                    } else p.t = tag.t || "n";
                    if (guess.s.c > tagc) guess.s.c = tagc;
                    if (guess.e.c < tagc) guess.e.c = tagc;
                    /* 18.18.11 t ST_CellType */ switch(p.t){
                        case 'n':
                            if (p.v == "" || p.v == null) {
                                if (!sheetStubs) continue;
                                p.t = 'z';
                            } else p.v = parseFloat(p.v);
                            break;
                        case 's':
                            if (typeof p.v == 'undefined') {
                                if (!sheetStubs) continue;
                                p.t = 'z';
                            } else {
                                sstr = strs[parseInt(p.v, 10)];
                                p.v = sstr.t;
                                p.r = sstr.r;
                                if (opts.cellHTML) p.h = sstr.h;
                            }
                            break;
                        case 'str':
                            p.t = "s";
                            p.v = p.v != null ? utf8read(p.v) : '';
                            if (opts.cellHTML) p.h = escapehtml(p.v);
                            break;
                        case 'inlineStr':
                            cref = d.match(isregex);
                            p.t = 's';
                            if (cref != null && (sstr = parse_si(cref[1]))) {
                                p.v = sstr.t;
                                if (opts.cellHTML) p.h = sstr.h;
                            } else p.v = "";
                            break;
                        case 'b':
                            p.v = parsexmlbool(p.v);
                            break;
                        case 'd':
                            if (opts.cellDates) p.v = parseDate(p.v, 1);
                            else {
                                p.v = datenum(parseDate(p.v, 1));
                                p.t = 'n';
                            }
                            break;
                        /* error string in .w, number in .v */ case 'e':
                            if (!opts || opts.cellText !== false) p.w = p.v;
                            p.v = RBErr[p.v];
                            break;
                    }
                    /* formatting */ fmtid = fillid = 0;
                    cf = null;
                    if (do_format && tag.s !== undefined) {
                        cf = styles.CellXf[tag.s];
                        if (cf != null) {
                            if (cf.numFmtId != null) fmtid = cf.numFmtId;
                            if (opts.cellStyles) {
                                if (cf.fillId != null) fillid = cf.fillId;
                            }
                        }
                    }
                    safe_format(p, fmtid, fillid, opts, themes, styles);
                    if (opts.cellDates && do_format && p.t == 'n' && SSF.is_date(SSF._table[fmtid])) {
                        p.t = 'd';
                        p.v = numdate(p.v);
                    }
                    if (dense) {
                        var _r = decode_cell(tag.r);
                        if (!s[_r.r]) s[_r.r] = [];
                        s[_r.r][_r.c] = p;
                    } else s[tag.r] = p;
                }
            }
            if (rows.length > 0) s['!rows'] = rows;
        };
    }();
    function write_ws_xml_data(ws, opts, idx, wb) {
        var o = [], r = [], range = safe_decode_range(ws['!ref']), cell = "", ref, rr = "", cols = [], R = 0, C = 0, rows = ws['!rows'];
        var dense = Array.isArray(ws);
        var params = {
            r: rr
        }, row, height = -1;
        for(C = range.s.c; C <= range.e.c; ++C)cols[C] = encode_col(C);
        for(R = range.s.r; R <= range.e.r; ++R){
            r = [];
            rr = encode_row(R);
            for(C = range.s.c; C <= range.e.c; ++C){
                ref = cols[C] + rr;
                var _cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (_cell === undefined) continue;
                if ((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
            }
            if (r.length > 0 || rows && rows[R]) {
                params = {
                    r: rr
                };
                if (rows && rows[R]) {
                    row = rows[R];
                    if (row.hidden) params.hidden = 1;
                    height = -1;
                    if (row.hpx) height = px2pt(row.hpx);
                    else if (row.hpt) height = row.hpt;
                    if (height > -1) {
                        params.ht = height;
                        params.customHeight = 1;
                    }
                    if (row.level) params.outlineLevel = row.level;
                }
                o[o.length] = writextag('row', r.join(""), params);
            }
        }
        if (rows) {
            for(; R < rows.length; ++R)if (rows && rows[R]) {
                params = {
                    r: R + 1
                };
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
                o[o.length] = writextag('row', "", params);
            }
        }
        return o.join("");
    }
    var WS_XML_ROOT = writextag('worksheet', null, {
        'xmlns': XMLNS.main[0],
        'xmlns:r': XMLNS.r
    });
    function write_ws_xml(idx, opts, wb, rels) {
        var o = [
            XML_HEADER,
            WS_XML_ROOT
        ];
        var s = wb.SheetNames[idx], sidx = 0, rdata = "";
        var ws = wb.Sheets[s];
        if (ws == null) ws = {};
        var ref = ws['!ref'] || 'A1';
        var range = safe_decode_range(ref);
        if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
            if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
            range.e.c = Math.min(range.e.c, 0x3FFF);
            range.e.r = Math.min(range.e.c, 0xFFFFF);
            ref = encode_range(range);
        }
        if (!rels) rels = {};
        ws['!comments'] = [];
        var _drawing = [];
        write_ws_xml_sheetpr(ws, wb, idx, opts, o);
        o[o.length] = writextag('dimension', null, {
            'ref': ref
        });
        o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);
        /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = writextag('sheetFormatPr', null, {
            defaultRowHeight: opts.sheetFormat.defaultRowHeight || '16',
            baseColWidth: opts.sheetFormat.baseColWidth || '10',
            outlineLevelRow: opts.sheetFormat.outlineLevelRow || '7'
        });
        if (ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = write_ws_xml_cols(ws, ws['!cols']);
        o[sidx = o.length] = '<sheetData/>';
        ws['!links'] = [];
        if (ws['!ref'] != null) {
            rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
            if (rdata.length > 0) o[o.length] = rdata;
        }
        if (o.length > sidx + 1) {
            o[o.length] = '</sheetData>';
            o[sidx] = o[sidx].replace("/>", ">");
        }
        /* sheetCalcPr */ if (ws['!protect'] != null) o[o.length] = write_ws_xml_protection(ws['!protect']);
        /* protectedRanges */ /* scenarios */ if (ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
        /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = write_ws_xml_merges(ws['!merges']);
        /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
        if (ws['!links'].length > 0) {
            o[o.length] = "<hyperlinks>";
            ws['!links'].forEach(function(l) {
                if (!l[1].Target) return;
                rel = {
                    "ref": l[0]
                };
                if (l[1].Target.charAt(0) != "#") {
                    rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
                    rel["r:id"] = "rId" + rId;
                }
                if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc + 1));
                if (l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
                o[o.length] = writextag("hyperlink", null, rel);
            });
            o[o.length] = "</hyperlinks>";
        }
        delete ws['!links'];
        /* printOptions */ if (ws['!margins'] != null) o[o.length] = write_ws_xml_margins(ws['!margins']);
        /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {
            numberStoredAsText: 1,
            sqref: ref
        }));
        /* smartTags */ if (_drawing.length > 0) {
            rId = add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", RELS.DRAW);
            o[o.length] = writextag("drawing", null, {
                "r:id": "rId" + rId
            });
            ws['!drawing'] = _drawing;
        }
        if (ws['!comments'].length > 0) {
            rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", RELS.VML);
            o[o.length] = writextag("legacyDrawing", null, {
                "r:id": "rId" + rId
            });
            ws['!legacy'] = rId;
        }
        /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
            o[o.length] = '</worksheet>';
            o[1] = o[1].replace("/>", ">");
        }
        return o.join("");
    }
    /* [MS-XLSB] 2.4.726 BrtRowHdr */ function parse_BrtRowHdr(data, length) {
        var z = {};
        var tgt = data.l + length;
        z.r = data.read_shift(4);
        data.l += 4; // TODO: ixfe
        var miyRw = data.read_shift(2);
        data.l += 1; // TODO: top/bot padding
        var flags = data.read_shift(1);
        data.l = tgt;
        if (flags & 0x07) z.level = flags & 0x07;
        if (flags & 0x10) z.hidden = true;
        if (flags & 0x20) z.hpt = miyRw / 20;
        return z;
    }
    function write_BrtRowHdr(R, range, ws) {
        var o = new_buf(145);
        var row = (ws['!rows'] || [])[R] || {};
        o.write_shift(4, R);
        o.write_shift(4, 0); /* TODO: ixfe */ 
        var miyRw = 0x0140;
        if (row.hpx) miyRw = px2pt(row.hpx) * 20;
        else if (row.hpt) miyRw = row.hpt * 20;
        o.write_shift(2, miyRw);
        o.write_shift(1, 0); /* top/bot padding */ 
        var flags = 0x0;
        if (row.level) flags |= row.level;
        if (row.hidden) flags |= 0x10;
        if (row.hpx || row.hpt) flags |= 0x20;
        o.write_shift(1, flags);
        o.write_shift(1, 0); /* phonetic guide */ 
        /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
        o.l += 4;
        var caddr = {
            r: R,
            c: 0
        };
        for(var i = 0; i < 16; ++i){
            if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
            var first = -1, last = -1;
            for(var j = i << 10; j < i + 1 << 10; ++j){
                caddr.c = j;
                var cell = Array.isArray(ws) ? (ws[caddr.r] || [])[caddr.c] : ws[encode_cell(caddr)];
                if (cell) {
                    if (first < 0) first = j;
                    last = j;
                }
            }
            if (first < 0) continue;
            ++ncolspan;
            o.write_shift(4, first);
            o.write_shift(4, last);
        }
        var l = o.l;
        o.l = lcs;
        o.write_shift(4, ncolspan);
        o.l = l;
        return o.length > o.l ? o.slice(0, o.l) : o;
    }
    function write_row_header(ba, ws, range, R) {
        var o = write_BrtRowHdr(R, range, ws);
        if (o.length > 17 || (ws['!rows'] || [])[R]) write_record(ba, 'BrtRowHdr', o);
    }
    /* [MS-XLSB] 2.4.820 BrtWsDim */ var parse_BrtWsDim = parse_UncheckedRfX;
    var write_BrtWsDim = write_UncheckedRfX;
    /* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function parse_BrtWsFmtInfo() {}
    //function write_BrtWsFmtInfo(ws, o) { }
    /* [MS-XLSB] 2.4.823 BrtWsProp */ function parse_BrtWsProp(data, length) {
        var z = {};
        /* TODO: pull flags */ data.l += 19;
        z.name = parse_XLSBCodeName(data, length - 19);
        return z;
    }
    function write_BrtWsProp(str, o) {
        if (o == null) o = new_buf(84 + 4 * str.length);
        for(var i = 0; i < 3; ++i)o.write_shift(1, 0);
        write_BrtColor({
            auto: 1
        }, o);
        o.write_shift(-4, -1);
        o.write_shift(-4, -1);
        write_XLSBCodeName(str, o);
        return o.slice(0, o.l);
    }
    /* [MS-XLSB] 2.4.306 BrtCellBlank */ function parse_BrtCellBlank(data) {
        var cell = parse_XLSBCell(data);
        return [
            cell
        ];
    }
    function write_BrtCellBlank(cell, ncell, o) {
        if (o == null) o = new_buf(8);
        return write_XLSBCell(ncell, o);
    }
    /* [MS-XLSB] 2.4.307 BrtCellBool */ function parse_BrtCellBool(data) {
        var cell = parse_XLSBCell(data);
        var fBool = data.read_shift(1);
        return [
            cell,
            fBool,
            'b'
        ];
    }
    function write_BrtCellBool(cell, ncell, o) {
        if (o == null) o = new_buf(9);
        write_XLSBCell(ncell, o);
        o.write_shift(1, cell.v ? 1 : 0);
        return o;
    }
    /* [MS-XLSB] 2.4.308 BrtCellError */ function parse_BrtCellError(data) {
        var cell = parse_XLSBCell(data);
        var bError = data.read_shift(1);
        return [
            cell,
            bError,
            'e'
        ];
    }
    /* [MS-XLSB] 2.4.311 BrtCellIsst */ function parse_BrtCellIsst(data) {
        var cell = parse_XLSBCell(data);
        var isst = data.read_shift(4);
        return [
            cell,
            isst,
            's'
        ];
    }
    function write_BrtCellIsst(cell, ncell, o) {
        if (o == null) o = new_buf(12);
        write_XLSBCell(ncell, o);
        o.write_shift(4, ncell.v);
        return o;
    }
    /* [MS-XLSB] 2.4.313 BrtCellReal */ function parse_BrtCellReal(data) {
        var cell = parse_XLSBCell(data);
        var value = parse_Xnum(data);
        return [
            cell,
            value,
            'n'
        ];
    }
    function write_BrtCellReal(cell, ncell, o) {
        if (o == null) o = new_buf(16);
        write_XLSBCell(ncell, o);
        write_Xnum(cell.v, o);
        return o;
    }
    /* [MS-XLSB] 2.4.314 BrtCellRk */ function parse_BrtCellRk(data) {
        var cell = parse_XLSBCell(data);
        var value = parse_RkNumber(data);
        return [
            cell,
            value,
            'n'
        ];
    }
    function write_BrtCellRk(cell, ncell, o) {
        if (o == null) o = new_buf(12);
        write_XLSBCell(ncell, o);
        write_RkNumber(cell.v, o);
        return o;
    }
    /* [MS-XLSB] 2.4.317 BrtCellSt */ function parse_BrtCellSt(data) {
        var cell = parse_XLSBCell(data);
        var value = parse_XLWideString(data);
        return [
            cell,
            value,
            'str'
        ];
    }
    function write_BrtCellSt(cell, ncell, o) {
        if (o == null) o = new_buf(12 + 4 * cell.v.length);
        write_XLSBCell(ncell, o);
        write_XLWideString(cell.v, o);
        return o.length > o.l ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.4.653 BrtFmlaBool */ function parse_BrtFmlaBool(data, length, opts) {
        var end = data.l + length;
        var cell = parse_XLSBCell(data);
        cell.r = opts['!row'];
        var value = data.read_shift(1);
        var o = [
            cell,
            value,
            'b'
        ];
        if (opts.cellFormula) {
            data.l += 2;
            var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
            o[3] = stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
        } else data.l = end;
        return o;
    }
    /* [MS-XLSB] 2.4.654 BrtFmlaError */ function parse_BrtFmlaError(data, length, opts) {
        var end = data.l + length;
        var cell = parse_XLSBCell(data);
        cell.r = opts['!row'];
        var value = data.read_shift(1);
        var o = [
            cell,
            value,
            'e'
        ];
        if (opts.cellFormula) {
            data.l += 2;
            var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
            o[3] = stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
        } else data.l = end;
        return o;
    }
    /* [MS-XLSB] 2.4.655 BrtFmlaNum */ function parse_BrtFmlaNum(data, length, opts) {
        var end = data.l + length;
        var cell = parse_XLSBCell(data);
        cell.r = opts['!row'];
        var value = parse_Xnum(data);
        var o = [
            cell,
            value,
            'n'
        ];
        if (opts.cellFormula) {
            data.l += 2;
            var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
            o[3] = stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
        } else data.l = end;
        return o;
    }
    /* [MS-XLSB] 2.4.656 BrtFmlaString */ function parse_BrtFmlaString(data, length, opts) {
        var end = data.l + length;
        var cell = parse_XLSBCell(data);
        cell.r = opts['!row'];
        var value = parse_XLWideString(data);
        var o = [
            cell,
            value,
            'str'
        ];
        if (opts.cellFormula) {
            data.l += 2;
            var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
            o[3] = stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
        } else data.l = end;
        return o;
    }
    /* [MS-XLSB] 2.4.682 BrtMergeCell */ var parse_BrtMergeCell = parse_UncheckedRfX;
    var write_BrtMergeCell = write_UncheckedRfX;
    /* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function write_BrtBeginMergeCells(cnt, o) {
        if (o == null) o = new_buf(4);
        o.write_shift(4, cnt);
        return o;
    }
    /* [MS-XLSB] 2.4.662 BrtHLink */ function parse_BrtHLink(data, length) {
        var end = data.l + length;
        var rfx = parse_UncheckedRfX(data, 16);
        var relId = parse_XLNullableWideString(data);
        var loc = parse_XLWideString(data);
        var tooltip = parse_XLWideString(data);
        var display = parse_XLWideString(data);
        data.l = end;
        var o = {
            rfx: rfx,
            relId: relId,
            loc: loc,
            display: display
        };
        if (tooltip) o.Tooltip = tooltip;
        return o;
    }
    function write_BrtHLink(l, rId) {
        var o = new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
        write_UncheckedRfX({
            s: decode_cell(l[0]),
            e: decode_cell(l[0])
        }, o);
        write_RelID("rId" + rId, o);
        var locidx = l[1].Target.indexOf("#");
        var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
        write_XLWideString(loc || "", o);
        write_XLWideString(l[1].Tooltip || "", o);
        write_XLWideString("", o);
        return o.slice(0, o.l);
    }
    /* [MS-XLSB] 2.4.692 BrtPane */ function parse_BrtPane() {}
    /* [MS-XLSB] 2.4.6 BrtArrFmla */ function parse_BrtArrFmla(data, length, opts) {
        var end = data.l + length;
        var rfx = parse_RfX(data, 16);
        var fAlwaysCalc = data.read_shift(1);
        var o = [
            rfx
        ];
        o[2] = fAlwaysCalc;
        if (opts.cellFormula) {
            var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
            o[1] = formula;
        } else data.l = end;
        return o;
    }
    /* [MS-XLSB] 2.4.750 BrtShrFmla */ function parse_BrtShrFmla(data, length, opts) {
        var end = data.l + length;
        var rfx = parse_UncheckedRfX(data, 16);
        var o = [
            rfx
        ];
        if (opts.cellFormula) {
            var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
            o[1] = formula;
            data.l = end;
        } else data.l = end;
        return o;
    }
    /* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function write_BrtColInfo(C, col, o) {
        if (o == null) o = new_buf(18);
        var p = col_obj_w(C, col);
        o.write_shift(-4, C);
        o.write_shift(-4, C);
        o.write_shift(4, (p.width || 10) * 256);
        o.write_shift(4, 0 /*ixfe*/ ); // style
        var flags = 0;
        if (col.hidden) flags |= 0x01;
        if (typeof p.width == 'number') flags |= 0x02;
        if (col.level) flags |= col.level << 8;
        o.write_shift(2, flags); // bit flag
        return o;
    }
    /* [MS-XLSB] 2.4.678 BrtMargins */ var BrtMarginKeys = [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ];
    function parse_BrtMargins(data) {
        var margins = {};
        BrtMarginKeys.forEach(function(k) {
            margins[k] = parse_Xnum(data, 8);
        });
        return margins;
    }
    function write_BrtMargins(margins, o) {
        if (o == null) o = new_buf(48);
        default_margins(margins);
        BrtMarginKeys.forEach(function(k) {
            write_Xnum(margins[k], o);
        });
        return o;
    }
    /* [MS-XLSB] 2.4.299 BrtBeginWsView */ function parse_BrtBeginWsView(data) {
        var f = data.read_shift(2);
        data.l += 28;
        return {
            RTL: f & 0x20
        };
    }
    function write_BrtBeginWsView(ws, Workbook, o) {
        if (o == null) o = new_buf(30);
        var f = 0x39c;
        if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
        o.write_shift(2, f); // bit flag
        o.write_shift(4, 0);
        o.write_shift(4, 0); // view first row
        o.write_shift(4, 0); // view first col
        o.write_shift(1, 0); // gridline color ICV
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 100); // zoom scale
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(4, 0); // workbook view id
        return o;
    }
    /* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function write_BrtCellIgnoreEC(ref) {
        var o = new_buf(24);
        o.write_shift(4, 4);
        o.write_shift(4, 1);
        write_UncheckedRfX(ref, o);
        return o;
    }
    /* [MS-XLSB] 2.4.748 BrtSheetProtection */ function write_BrtSheetProtection(sp, o) {
        if (o == null) o = new_buf(66);
        o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
        o.write_shift(4, 1); // this record should not be written if no protection
        [
            [
                "objects",
                false
            ],
            [
                "scenarios",
                false
            ],
            [
                "formatCells",
                true
            ],
            [
                "formatColumns",
                true
            ],
            [
                "formatRows",
                true
            ],
            [
                "insertColumns",
                true
            ],
            [
                "insertRows",
                true
            ],
            [
                "insertHyperlinks",
                true
            ],
            [
                "deleteColumns",
                true
            ],
            [
                "deleteRows",
                true
            ],
            [
                "selectLockedCells",
                false
            ],
            [
                "sort",
                true
            ],
            [
                "autoFilter",
                true
            ],
            [
                "pivotTables",
                true
            ],
            [
                "selectUnlockedCells",
                false
            ] // fSelUnlockedCells
        ].forEach(function(n) {
            if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
            else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
        });
        return o;
    }
    function parse_BrtDVal() {}
    function parse_BrtDVal14() {}
    /* [MS-XLSB] 2.1.7.61 Worksheet */ function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
        if (!data) return data;
        var opts = _opts || {};
        if (!rels) rels = {
            '!id': {}
        };
        if (DENSE != null && opts.dense == null) opts.dense = DENSE;
        var s = opts.dense ? [] : {};
        var ref;
        var refguess = {
            s: {
                r: 2000000,
                c: 2000000
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var state = [];
        var pass = false, end = false;
        var row, p, cf, R, C, addr, sstr, rr, cell;
        var merges = [];
        opts.biff = 12;
        opts['!row'] = 0;
        var ai = 0, af = false;
        var arrayf = [];
        var sharedf = {};
        var supbooks = opts.supbooks || wb.supbooks || [
            []
        ];
        supbooks.sharedf = sharedf;
        supbooks.arrayf = arrayf;
        supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
            return x.name;
        });
        if (!opts.supbooks) {
            opts.supbooks = supbooks;
            if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
        }
        var colinfo = [], rowinfo = [];
        var seencol = false;
        recordhopper(data, function ws_parse(val, R_n, RT) {
            if (end) return;
            switch(RT){
                case 0x0094:
                    /* 'BrtWsDim' */ ref = val;
                    break;
                case 0x0000:
                    /* 'BrtRowHdr' */ row = val;
                    if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                    rr = encode_row(R = row.r);
                    opts['!row'] = row.r;
                    if (val.hidden || val.hpt || val.level != null) {
                        if (val.hpt) val.hpx = pt2px(val.hpt);
                        rowinfo[val.r] = val;
                    }
                    break;
                case 0x0002:
                /* 'BrtCellRk' */ case 0x0003:
                /* 'BrtCellError' */ case 0x0004:
                /* 'BrtCellBool' */ case 0x0005:
                /* 'BrtCellReal' */ case 0x0006:
                /* 'BrtCellSt' */ case 0x0007:
                /* 'BrtCellIsst' */ case 0x0008:
                /* 'BrtFmlaString' */ case 0x0009:
                /* 'BrtFmlaNum' */ case 0x000A:
                /* 'BrtFmlaBool' */ case 0x000B:
                    /* 'BrtFmlaError' */ p = {
                        t: val[2]
                    };
                    switch(val[2]){
                        case 'n':
                            p.v = val[1];
                            break;
                        case 's':
                            sstr = strs[val[1]];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            break;
                        case 'b':
                            p.v = val[1] ? true : false;
                            break;
                        case 'e':
                            p.v = val[1];
                            if (opts.cellText !== false) p.w = BErr[p.v];
                            break;
                        case 'str':
                            p.t = 's';
                            p.v = val[1];
                            break;
                    }
                    if (cf = styles.CellXf[val[0].iStyleRef]) safe_format(p, cf.numFmtId, null, opts, themes, styles);
                    C = val[0].c;
                    if (opts.dense) {
                        if (!s[R]) s[R] = [];
                        s[R][C] = p;
                    } else s[encode_col(C) + rr] = p;
                    if (opts.cellFormula) {
                        af = false;
                        for(ai = 0; ai < arrayf.length; ++ai){
                            var aii = arrayf[ai];
                            if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                                if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                    p.F = encode_range(aii[0]);
                                    af = true;
                                }
                            }
                        }
                        if (!af && val.length > 3) p.f = val[3];
                    }
                    if (refguess.s.r > row.r) refguess.s.r = row.r;
                    if (refguess.s.c > C) refguess.s.c = C;
                    if (refguess.e.r < row.r) refguess.e.r = row.r;
                    if (refguess.e.c < C) refguess.e.c = C;
                    if (opts.cellDates && cf && p.t == 'n' && SSF.is_date(SSF._table[cf.numFmtId])) {
                        var _d = SSF.parse_date_code(p.v);
                        if (_d) {
                            p.t = 'd';
                            p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
                        }
                    }
                    break;
                case 0x0001:
                    /* 'BrtCellBlank' */ if (!opts.sheetStubs || pass) break;
                    p = {
                        t: 'z',
                        v: undefined
                    };
                    C = val[0].c;
                    if (opts.dense) {
                        if (!s[R]) s[R] = [];
                        s[R][C] = p;
                    } else s[encode_col(C) + rr] = p;
                    if (refguess.s.r > row.r) refguess.s.r = row.r;
                    if (refguess.s.c > C) refguess.s.c = C;
                    if (refguess.e.r < row.r) refguess.e.r = row.r;
                    if (refguess.e.c < C) refguess.e.c = C;
                    break;
                case 0x00B0:
                    /* 'BrtMergeCell' */ merges.push(val);
                    break;
                case 0x01EE:
                    /* 'BrtHLink' */ var rel = rels['!id'][val.relId];
                    if (rel) {
                        val.Target = rel.Target;
                        if (val.loc) val.Target += "#" + val.loc;
                        val.Rel = rel;
                    } else if (val.relId == '') val.Target = "#" + val.loc;
                    for(R = val.rfx.s.r; R <= val.rfx.e.r; ++R)for(C = val.rfx.s.c; C <= val.rfx.e.c; ++C)if (opts.dense) {
                        if (!s[R]) s[R] = [];
                        if (!s[R][C]) s[R][C] = {
                            t: 'z',
                            v: undefined
                        };
                        s[R][C].l = val;
                    } else {
                        addr = encode_cell({
                            c: C,
                            r: R
                        });
                        if (!s[addr]) s[addr] = {
                            t: 'z',
                            v: undefined
                        };
                        s[addr].l = val;
                    }
                    break;
                case 0x01AA:
                    /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                    arrayf.push(val);
                    cell = opts.dense ? s[R][C] : s[encode_col(C) + rr];
                    cell.f = stringify_formula(val[1], refguess, {
                        r: row.r,
                        c: C
                    }, supbooks, opts);
                    cell.F = encode_range(val[0]);
                    break;
                case 0x01AB:
                    /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                    sharedf[encode_cell(val[0].s)] = val[1];
                    cell = opts.dense ? s[R][C] : s[encode_col(C) + rr];
                    cell.f = stringify_formula(val[1], refguess, {
                        r: row.r,
                        c: C
                    }, supbooks, opts);
                    break;
                /* identical to 'ColInfo' in XLS */ case 0x003C:
                    /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                    while(val.e >= val.s){
                        colinfo[val.e--] = {
                            width: val.w / 256,
                            hidden: !!(val.flags & 0x01),
                            level: val.level
                        };
                        if (!seencol) {
                            seencol = true;
                            find_mdw_colw(val.w / 256);
                        }
                        process_col(colinfo[val.e + 1]);
                    }
                    break;
                case 0x00A1:
                    /* 'BrtBeginAFilter' */ s['!autofilter'] = {
                        ref: encode_range(val)
                    };
                    break;
                case 0x01DC:
                    /* 'BrtMargins' */ s['!margins'] = val;
                    break;
                case 0x0093:
                    /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                    if (val.name) wb.Sheets[idx].CodeName = val.name;
                    break;
                case 0x0089:
                    /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                        {}
                    ];
                    if (!wb.Views[0]) wb.Views[0] = {};
                    if (val.RTL) wb.Views[0].RTL = true;
                    break;
                case 0x01E5:
                    break;
                case 0x0040:
                /* 'BrtDVal' */ case 0x041D:
                    break;
                case 0x0097:
                    break;
                case 0x00AF:
                /* 'BrtAFilterDateGroupItem' */ case 0x0284:
                /* 'BrtActiveX' */ case 0x0271:
                /* 'BrtBigName' */ case 0x0232:
                /* 'BrtBkHim' */ case 0x018C:
                /* 'BrtBrk' */ case 0x0458:
                /* 'BrtCFIcon' */ case 0x047A:
                /* 'BrtCFRuleExt' */ case 0x01D7:
                /* 'BrtCFVO' */ case 0x041A:
                /* 'BrtCFVO14' */ case 0x0289:
                /* 'BrtCellIgnoreEC' */ case 0x0451:
                /* 'BrtCellIgnoreEC14' */ case 0x0031:
                /* 'BrtCellMeta' */ case 0x024D:
                /* 'BrtCellSmartTagProperty' */ case 0x025F:
                /* 'BrtCellWatch' */ case 0x0234:
                /* 'BrtColor' */ case 0x041F:
                /* 'BrtColor14' */ case 0x00A8:
                /* 'BrtColorFilter' */ case 0x00AE:
                /* 'BrtCustomFilter' */ case 0x049C:
                /* 'BrtCustomFilter14' */ case 0x01F3:
                /* 'BrtDRef' */ case 0x01FB:
                /* 'BrtDXF' */ case 0x0226:
                /* 'BrtDrawing' */ case 0x00AB:
                /* 'BrtDynamicFilter' */ case 0x00A7:
                /* 'BrtFilter' */ case 0x0499:
                /* 'BrtFilter14' */ case 0x00A9:
                /* 'BrtIconFilter' */ case 0x049D:
                /* 'BrtIconFilter14' */ case 0x0227:
                /* 'BrtLegacyDrawing' */ case 0x0228:
                /* 'BrtLegacyDrawingHF' */ case 0x0295:
                /* 'BrtListPart' */ case 0x027F:
                /* 'BrtOleObject' */ case 0x01DE:
                /* 'BrtPageSetup' */ case 0x0219:
                /* 'BrtPhoneticInfo' */ case 0x01DD:
                /* 'BrtPrintOptions' */ case 0x0218:
                /* 'BrtRangeProtection' */ case 0x044F:
                /* 'BrtRangeProtection14' */ case 0x02A8:
                /* 'BrtRangeProtectionIso' */ case 0x0450:
                /* 'BrtRangeProtectionIso14' */ case 0x0400:
                /* 'BrtRwDescent' */ case 0x0098:
                /* 'BrtSel' */ case 0x0297:
                /* 'BrtSheetCalcProp' */ case 0x0217:
                /* 'BrtSheetProtection' */ case 0x02A6:
                /* 'BrtSheetProtectionIso' */ case 0x01F8:
                /* 'BrtSlc' */ case 0x0413:
                /* 'BrtSparkline' */ case 0x01AC:
                /* 'BrtTable' */ case 0x00AA:
                /* 'BrtTop10Filter' */ case 0x0C00:
                /* 'BrtUid' */ case 0x0032:
                /* 'BrtValueMeta' */ case 0x0816:
                /* 'BrtWebExtension' */ case 0x0415:
                    break;
                case 0x0023:
                    /* 'BrtFRTBegin' */ pass = true;
                    break;
                case 0x0024:
                    /* 'BrtFRTEnd' */ pass = false;
                    break;
                case 0x0025:
                    /* 'BrtACBegin' */ state.push(R_n);
                    pass = true;
                    break;
                case 0x0026:
                    /* 'BrtACEnd' */ state.pop();
                    pass = false;
                    break;
                default:
                    if ((R_n || "").indexOf("Begin") > 0) ;
                    else if ((R_n || "").indexOf("End") > 0) ;
                    else if (!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
            }
        }, opts);
        delete opts.supbooks;
        delete opts['!row'];
        if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
        if (opts.sheetRows && s["!ref"]) {
            var tmpref = safe_decode_range(s["!ref"]);
            if (opts.sheetRows <= +tmpref.e.r) {
                tmpref.e.r = opts.sheetRows - 1;
                if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
                if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
                if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
                if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
                s["!fullref"] = s["!ref"];
                s["!ref"] = encode_range(tmpref);
            }
        }
        if (merges.length > 0) s["!merges"] = merges;
        if (colinfo.length > 0) s["!cols"] = colinfo;
        if (rowinfo.length > 0) s["!rows"] = rowinfo;
        return s;
    }
    /* TODO: something useful -- this is a stub */ function write_ws_bin_cell(ba, cell, R, C, opts, ws) {
        if (cell.v === undefined) return;
        var vv = "";
        switch(cell.t){
            case 'b':
                vv = cell.v ? "1" : "0";
                break;
            case 'd':
                cell = dup(cell);
                cell.z = cell.z || SSF._table[14];
                cell.v = datenum(parseDate(cell.v));
                cell.t = 'n';
                break;
            /* falls through */ case 'n':
            case 'e':
                vv = '' + cell.v;
                break;
            default:
                vv = cell.v;
                break;
        }
        var o = {
            r: R,
            c: C
        };
        /* TODO: cell style */ o.s = get_cell_style(opts.cellXfs, cell, opts);
        if (cell.l) ws['!links'].push([
            encode_cell(o),
            cell.l
        ]);
        if (cell.c) ws['!comments'].push([
            encode_cell(o),
            cell.c
        ]);
        switch(cell.t){
            case 's':
            case 'str':
                if (opts.bookSST) {
                    vv = get_sst_id(opts.Strings, cell.v, opts.revStrings);
                    o.t = "s";
                    o.v = vv;
                    write_record(ba, "BrtCellIsst", write_BrtCellIsst(cell, o));
                } else {
                    o.t = "str";
                    write_record(ba, "BrtCellSt", write_BrtCellSt(cell, o));
                }
                return;
            case 'n':
                /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) write_record(ba, "BrtCellRk", write_BrtCellRk(cell, o));
                else write_record(ba, "BrtCellReal", write_BrtCellReal(cell, o));
                return;
            case 'b':
                o.t = "b";
                write_record(ba, "BrtCellBool", write_BrtCellBool(cell, o));
                return;
            case 'e':
                /* TODO: error */ o.t = "e";
                break;
        }
        write_record(ba, "BrtCellBlank", write_BrtCellBlank(cell, o));
    }
    function write_CELLTABLE(ba, ws, idx, opts) {
        var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
        write_record(ba, 'BrtBeginSheetData');
        var dense = Array.isArray(ws);
        var cap = range.e.r;
        if (ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
        for(var R = range.s.r; R <= cap; ++R){
            rr = encode_row(R);
            /* [ACCELLTABLE] */ /* BrtRowHdr */ write_row_header(ba, ws, range, R);
            if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
                /* *16384CELL */ if (R === range.s.r) cols[C] = encode_col(C);
                ref = cols[C] + rr;
                var cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (!cell) continue;
                /* write cell */ write_ws_bin_cell(ba, cell, R, C, opts, ws);
            }
        }
        write_record(ba, 'BrtEndSheetData');
    }
    function write_MERGECELLS(ba, ws) {
        if (!ws || !ws['!merges']) return;
        write_record(ba, 'BrtBeginMergeCells', write_BrtBeginMergeCells(ws['!merges'].length));
        ws['!merges'].forEach(function(m) {
            write_record(ba, 'BrtMergeCell', write_BrtMergeCell(m));
        });
        write_record(ba, 'BrtEndMergeCells');
    }
    function write_COLINFOS(ba, ws) {
        if (!ws || !ws['!cols']) return;
        write_record(ba, 'BrtBeginColInfos');
        ws['!cols'].forEach(function(m, i) {
            if (m) write_record(ba, 'BrtColInfo', write_BrtColInfo(i, m));
        });
        write_record(ba, 'BrtEndColInfos');
    }
    function write_IGNOREECS(ba, ws) {
        if (!ws || !ws['!ref']) return;
        write_record(ba, 'BrtBeginCellIgnoreECs');
        write_record(ba, 'BrtCellIgnoreEC', write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
        write_record(ba, 'BrtEndCellIgnoreECs');
    }
    function write_HLINKS(ba, ws, rels) {
        /* *BrtHLink */ ws['!links'].forEach(function(l) {
            if (!l[1].Target) return;
            var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
            write_record(ba, "BrtHLink", write_BrtHLink(l, rId));
        });
        delete ws['!links'];
    }
    function write_LEGACYDRAWING(ba, ws, idx, rels) {
        /* [BrtLegacyDrawing] */ if (ws['!comments'].length > 0) {
            var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", RELS.VML);
            write_record(ba, "BrtLegacyDrawing", write_RelID("rId" + rId));
            ws['!legacy'] = rId;
        }
    }
    function write_AUTOFILTER(ba, ws, wb, idx) {
        if (!ws['!autofilter']) return;
        var data = ws['!autofilter'];
        var ref = typeof data.ref === "string" ? data.ref : encode_range(data.ref);
        /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
            Sheets: []
        };
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        var names = wb.Workbook.Names;
        var range = decode_range(ref);
        if (range.s.r == range.e.r) {
            range.e.r = decode_range(ws["!ref"]).e.r;
            ref = encode_range(range);
        }
        for(var i = 0; i < names.length; ++i){
            var name = names[i];
            if (name.Name != '_xlnm._FilterDatabase') continue;
            if (name.Sheet != idx) continue;
            name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref;
            break;
        }
        if (i == names.length) names.push({
            Name: '_xlnm._FilterDatabase',
            Sheet: idx,
            Ref: "'" + wb.SheetNames[idx] + "'!" + ref
        });
        write_record(ba, "BrtBeginAFilter", write_UncheckedRfX(safe_decode_range(ref)));
        /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ write_record(ba, "BrtEndAFilter");
    }
    function write_WSVIEWS2(ba, ws, Workbook) {
        write_record(ba, "BrtBeginWsViews");
        /* [ACUID] */ write_record(ba, "BrtBeginWsView", write_BrtBeginWsView(ws, Workbook));
        /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ write_record(ba, "BrtEndWsView");
        /* *FRT */ write_record(ba, "BrtEndWsViews");
    }
    function write_WSFMTINFO() {
    /* [ACWSFMTINFO] */ //write_record(ba, "BrtWsFmtInfo", write_BrtWsFmtInfo(ws));
    }
    function write_SHEETPROTECT(ba, ws) {
        if (!ws['!protect']) return;
        /* [BrtSheetProtectionIso] */ write_record(ba, "BrtSheetProtection", write_BrtSheetProtection(ws['!protect']));
    }
    function write_ws_bin(idx, opts, wb, rels) {
        var ba = buf_array();
        var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
        var c = s;
        try {
            if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
        } catch (e) {}
        var r = safe_decode_range(ws['!ref'] || "A1");
        if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
            if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
            r.e.c = Math.min(r.e.c, 0x3FFF);
            r.e.r = Math.min(r.e.c, 0xFFFFF);
        }
        ws['!links'] = [];
        /* passed back to write_zip and removed there */ ws['!comments'] = [];
        write_record(ba, "BrtBeginSheet");
        if (wb.vbaraw) write_record(ba, "BrtWsProp", write_BrtWsProp(c));
        write_record(ba, "BrtWsDim", write_BrtWsDim(r));
        write_WSVIEWS2(ba, ws, wb.Workbook);
        write_WSFMTINFO(ba, ws);
        write_COLINFOS(ba, ws, idx, opts, wb);
        write_CELLTABLE(ba, ws, idx, opts, wb);
        /* [BrtSheetCalcProp] */ write_SHEETPROTECT(ba, ws);
        /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ write_AUTOFILTER(ba, ws, wb, idx);
        /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ write_MERGECELLS(ba, ws);
        /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ write_HLINKS(ba, ws, rels);
        /* [BrtPrintOptions] */ if (ws['!margins']) write_record(ba, "BrtMargins", write_BrtMargins(ws['!margins']));
        /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) write_IGNOREECS(ba, ws);
        /* [SMARTTAGS] */ /* [BrtDrawing] */ write_LEGACYDRAWING(ba, ws, idx, rels);
        /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ write_record(ba, "BrtEndSheet");
        return ba.end();
    }
    RELS.CHART = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart";
    RELS.CHARTEX = "http://schemas.microsoft.com/office/2014/relationships/chartEx";
    function parse_Cache(data) {
        var col = [];
        var num = data.match(/^<c:numCache>/);
        var f;
        /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(pt) {
            var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
            if (!q) return;
            col[+q[1]] = num ? +q[2] : q[2];
        });
        /* 21.2.2.71 formatCode CT_Xstring */ var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [
            "",
            "General"
        ])[1]);
        (data.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(F) {
            f = F.replace(/<.*?>/g, "");
        });
        return [
            col,
            nf,
            f
        ];
    }
    /* 21.2 DrawingML - Charts */ function parse_chart(data, name, opts, rels, wb, csheet) {
        var cs = csheet || {
            "!type": "chart"
        };
        if (!data) return csheet;
        /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
        var refguess = {
            s: {
                r: 2000000,
                c: 2000000
            },
            e: {
                r: 0,
                c: 0
            }
        };
        /* 21.2.2.120 numCache CT_NumData */ (data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(nc) {
            var cache = parse_Cache(nc);
            refguess.s.r = refguess.s.c = 0;
            refguess.e.c = C;
            col = encode_col(C);
            cache[0].forEach(function(n, i) {
                cs[col + encode_row(i)] = {
                    t: 'n',
                    v: n,
                    z: cache[1]
                };
                R = i;
            });
            if (refguess.e.r < R) refguess.e.r = R;
            ++C;
        });
        if (C > 0) cs["!ref"] = encode_range(refguess);
        return cs;
    }
    RELS.CS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";
    var CS_XML_ROOT = writextag('chartsheet', null, {
        'xmlns': XMLNS.main[0],
        'xmlns:r': XMLNS.r
    });
    /* 18.3 Worksheets also covers Chartsheets */ function parse_cs_xml(data, opts, idx, rels, wb) {
        if (!data) return data;
        /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
            '!id': {}
        };
        var s = {
            '!type': "chart",
            '!drawel': null,
            '!rel': ""
        };
        var m;
        /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match(sheetprregex);
        if (sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
        /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s['!rel'] = m[1];
        if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
        return s;
    }
    function write_cs_xml(idx, opts, wb, rels) {
        var o = [
            XML_HEADER,
            CS_XML_ROOT
        ];
        o[o.length] = writextag("drawing", null, {
            "r:id": "rId1"
        });
        add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", RELS.DRAW);
        if (o.length > 2) {
            o[o.length] = '</chartsheet>';
            o[1] = o[1].replace("/>", ">");
        }
        return o.join("");
    }
    /* [MS-XLSB] 2.4.331 BrtCsProp */ function parse_BrtCsProp(data, length) {
        data.l += 10;
        var name = parse_XLWideString(data, length - 10);
        return {
            name: name
        };
    }
    /* [MS-XLSB] 2.1.7.7 Chart Sheet */ function parse_cs_bin(data, opts, idx, rels, wb) {
        if (!data) return data;
        if (!rels) rels = {
            '!id': {}
        };
        var s = {
            '!type': "chart",
            '!drawel': null,
            '!rel': ""
        };
        var state = [];
        var pass = false;
        recordhopper(data, function cs_parse(val, R_n, RT) {
            switch(RT){
                case 0x0226:
                    /* 'BrtDrawing' */ s['!rel'] = val;
                    break;
                case 0x028B:
                    /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                    if (val.name) wb.Sheets[idx].CodeName = val.name;
                    break;
                case 0x0232:
                /* 'BrtBkHim' */ case 0x028C:
                /* 'BrtCsPageSetup' */ case 0x029D:
                /* 'BrtCsProtection' */ case 0x02A7:
                /* 'BrtCsProtectionIso' */ case 0x0227:
                /* 'BrtLegacyDrawing' */ case 0x0228:
                /* 'BrtLegacyDrawingHF' */ case 0x01DC:
                /* 'BrtMargins' */ case 0x0C00:
                    break;
                case 0x0023:
                    /* 'BrtFRTBegin' */ pass = true;
                    break;
                case 0x0024:
                    /* 'BrtFRTEnd' */ pass = false;
                    break;
                case 0x0025:
                    /* 'BrtACBegin' */ state.push(R_n);
                    break;
                case 0x0026:
                    /* 'BrtACEnd' */ state.pop();
                    break;
                default:
                    if ((R_n || "").indexOf("Begin") > 0) state.push(R_n);
                    else if ((R_n || "").indexOf("End") > 0) state.pop();
                    else if (!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
            }
        }, opts);
        if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
        return s;
    }
    function write_cs_bin() {
        var ba = buf_array();
        write_record(ba, "BrtBeginSheet");
        /* [BrtCsProp] */ /* CSVIEWS */ /* [[BrtCsProtectionIso] BrtCsProtection] */ /* [USERCSVIEWS] */ /* [BrtMargins] */ /* [BrtCsPageSetup] */ /* [HEADERFOOTER] */ /* BrtDrawing */ /* [BrtLegacyDrawing] */ /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [WEBPUBITEMS] */ /* FRTCHARTSHEET */ write_record(ba, "BrtEndSheet");
        return ba.end();
    }
    /* 18.2.28 (CT_WorkbookProtection) Defaults */ var WBPropsDef = [
        [
            'allowRefreshQuery',
            false,
            "bool"
        ],
        [
            'autoCompressPictures',
            true,
            "bool"
        ],
        [
            'backupFile',
            false,
            "bool"
        ],
        [
            'checkCompatibility',
            false,
            "bool"
        ],
        [
            'CodeName',
            ''
        ],
        [
            'date1904',
            false,
            "bool"
        ],
        [
            'defaultThemeVersion',
            0,
            "int"
        ],
        [
            'filterPrivacy',
            false,
            "bool"
        ],
        [
            'hidePivotFieldList',
            false,
            "bool"
        ],
        [
            'promptedSolutions',
            false,
            "bool"
        ],
        [
            'publishItems',
            false,
            "bool"
        ],
        [
            'refreshAllConnections',
            false,
            "bool"
        ],
        [
            'saveExternalLinkValues',
            true,
            "bool"
        ],
        [
            'showBorderUnselectedTables',
            true,
            "bool"
        ],
        [
            'showInkAnnotation',
            true,
            "bool"
        ],
        [
            'showObjects',
            'all'
        ],
        [
            'showPivotChartFilter',
            false,
            "bool"
        ],
        [
            'updateLinks',
            'userSet'
        ]
    ];
    /* 18.2.30 (CT_BookView) Defaults */ var WBViewDef = [
        [
            'activeTab',
            0,
            "int"
        ],
        [
            'autoFilterDateGrouping',
            true,
            "bool"
        ],
        [
            'firstSheet',
            0,
            "int"
        ],
        [
            'minimized',
            false,
            "bool"
        ],
        [
            'showHorizontalScroll',
            true,
            "bool"
        ],
        [
            'showSheetTabs',
            true,
            "bool"
        ],
        [
            'showVerticalScroll',
            true,
            "bool"
        ],
        [
            'tabRatio',
            600,
            "int"
        ],
        [
            'visibility',
            'visible'
        ]
    ];
    /* 18.2.19 (CT_Sheet) Defaults */ var SheetDef = [];
    /* 18.2.2  (CT_CalcPr) Defaults */ var CalcPrDef = [
        [
            'calcCompleted',
            'true'
        ],
        [
            'calcMode',
            'auto'
        ],
        [
            'calcOnSave',
            'true'
        ],
        [
            'concurrentCalc',
            'true'
        ],
        [
            'fullCalcOnLoad',
            'false'
        ],
        [
            'fullPrecision',
            'true'
        ],
        [
            'iterate',
            'false'
        ],
        [
            'iterateCount',
            '100'
        ],
        [
            'iterateDelta',
            '0.001'
        ],
        [
            'refMode',
            'A1'
        ]
    ];
    /* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function push_defaults_array(target, defaults) {
        for(var j = 0; j != target.length; ++j){
            var w = target[j];
            for(var i = 0; i != defaults.length; ++i){
                var z = defaults[i];
                if (w[z[0]] == null) w[z[0]] = z[1];
                else switch(z[2]){
                    case "bool":
                        if (typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]);
                        break;
                    case "int":
                        if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                        break;
                }
            }
        }
    }
    function push_defaults(target, defaults) {
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (target[z[0]] == null) target[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]);
                    break;
                case "int":
                    if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                    break;
            }
        }
    }
    function parse_wb_defaults(wb) {
        push_defaults(wb.WBProps, WBPropsDef);
        push_defaults(wb.CalcPr, CalcPrDef);
        push_defaults_array(wb.WBView, WBViewDef);
        push_defaults_array(wb.Sheets, SheetDef);
        _ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
    }
    function safe1904(wb) {
        /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
        if (!wb.Workbook.WBProps) return "false";
        return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
    }
    var badchars = "][*?\/\\".split("");
    function check_ws_name(n, safe) {
        if (n.length > 31) {
            if (safe) return false;
            throw new Error("Sheet names cannot exceed 31 chars");
        }
        var _good = true;
        badchars.forEach(function(c) {
            if (n.indexOf(c) == -1) return;
            if (!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
            _good = false;
        });
        return _good;
    }
    function check_wb_names(N, S, codes) {
        N.forEach(function(n, i) {
            check_ws_name(n);
            for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
            if (codes) {
                var cn = S && S[i] && S[i].CodeName || n;
                if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
            }
        });
    }
    function check_wb(wb) {
        if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
        if (!wb.SheetNames.length) throw new Error("Workbook is empty");
        var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
        check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
        for(var i = 0; i < wb.SheetNames.length; ++i)check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
    /* TODO: validate workbook */ }
    /* 18.2 Workbook */ var wbnsregex = /<\w+:workbook/;
    function parse_wb_xml(data, opts) {
        if (!data) throw new Error("Could not find file");
        var wb = {
            AppVersion: {},
            WBProps: {},
            WBView: [],
            Sheets: [],
            CalcPr: {},
            Names: [],
            xmlns: ""
        };
        var pass = false, xmlns = "xmlns";
        var dname = {}, dnstart = 0;
        data.replace(tagregex, function xml_wb(x, idx) {
            var y = parsexmltag(x);
            switch(strip_ns(y[0])){
                case '<?xml':
                    break;
                /* 18.2.27 workbook CT_Workbook 1 */ case '<workbook':
                    if (x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                    wb.xmlns = y[xmlns];
                    break;
                case '</workbook>':
                    break;
                /* 18.2.13 fileVersion CT_FileVersion ? */ case '<fileVersion':
                    delete y[0];
                    wb.AppVersion = y;
                    break;
                case '<fileVersion/>':
                case '</fileVersion>':
                    break;
                /* 18.2.12 fileSharing CT_FileSharing ? */ case '<fileSharing':
                    break;
                case '<fileSharing/>':
                    break;
                /* 18.2.28 workbookPr CT_WorkbookPr ? */ case '<workbookPr':
                case '<workbookPr/>':
                    WBPropsDef.forEach(function(w) {
                        if (y[w[0]] == null) return;
                        switch(w[2]){
                            case "bool":
                                wb.WBProps[w[0]] = parsexmlbool(y[w[0]]);
                                break;
                            case "int":
                                wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                                break;
                            default:
                                wb.WBProps[w[0]] = y[w[0]];
                        }
                    });
                    if (y.codeName) wb.WBProps.CodeName = utf8read(y.codeName);
                    break;
                case '</workbookPr>':
                    break;
                /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case '<workbookProtection':
                    break;
                case '<workbookProtection/>':
                    break;
                /* 18.2.1  bookViews CT_BookViews ? */ case '<bookViews':
                case '<bookViews>':
                case '</bookViews>':
                    break;
                /* 18.2.30   workbookView CT_BookView + */ case '<workbookView':
                case '<workbookView/>':
                    delete y[0];
                    wb.WBView.push(y);
                    break;
                case '</workbookView>':
                    break;
                /* 18.2.20 sheets CT_Sheets 1 */ case '<sheets':
                case '<sheets>':
                case '</sheets>':
                    break; // aggregate sheet
                /* 18.2.19   sheet CT_Sheet + */ case '<sheet':
                    switch(y.state){
                        case "hidden":
                            y.Hidden = 1;
                            break;
                        case "veryHidden":
                            y.Hidden = 2;
                            break;
                        default:
                            y.Hidden = 0;
                    }
                    delete y.state;
                    y.name = unescapexml(utf8read(y.name));
                    delete y[0];
                    wb.Sheets.push(y);
                    break;
                case '</sheet>':
                    break;
                /* 18.2.15 functionGroups CT_FunctionGroups ? */ case '<functionGroups':
                case '<functionGroups/>':
                    break;
                /* 18.2.14   functionGroup CT_FunctionGroup + */ case '<functionGroup':
                    break;
                /* 18.2.9  externalReferences CT_ExternalReferences ? */ case '<externalReferences':
                case '</externalReferences>':
                case '<externalReferences>':
                    break;
                /* 18.2.8    externalReference CT_ExternalReference + */ case '<externalReference':
                    break;
                /* 18.2.6  definedNames CT_DefinedNames ? */ case '<definedNames/>':
                    break;
                case '<definedNames>':
                case '<definedNames':
                    pass = true;
                    break;
                case '</definedNames>':
                    pass = false;
                    break;
                /* 18.2.5    definedName CT_DefinedName + */ case '<definedName':
                    dname = {};
                    dname.Name = utf8read(y.name);
                    if (y.comment) dname.Comment = y.comment;
                    if (y.localSheetId) dname.Sheet = +y.localSheetId;
                    if (parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                    dnstart = idx + x.length;
                    break;
                case '</definedName>':
                    dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
                    wb.Names.push(dname);
                    break;
                case '<definedName/>':
                    break;
                /* 18.2.2  calcPr CT_CalcPr ? */ case '<calcPr':
                    delete y[0];
                    wb.CalcPr = y;
                    break;
                case '<calcPr/>':
                    delete y[0];
                    wb.CalcPr = y;
                    break;
                case '</calcPr>':
                    break;
                /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case '<oleSize':
                    break;
                /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case '<customWorkbookViews>':
                case '</customWorkbookViews>':
                case '<customWorkbookViews':
                    break;
                /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case '<customWorkbookView':
                case '</customWorkbookView>':
                    break;
                /* 18.2.18 pivotCaches CT_PivotCaches ? */ case '<pivotCaches>':
                case '</pivotCaches>':
                case '<pivotCaches':
                    break;
                /* 18.2.17 pivotCache CT_PivotCache ? */ case '<pivotCache':
                    break;
                /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case '<smartTagPr':
                case '<smartTagPr/>':
                    break;
                /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case '<smartTagTypes':
                case '<smartTagTypes>':
                case '</smartTagTypes>':
                    break;
                /* 18.2.22 smartTagType CT_SmartTagType ? */ case '<smartTagType':
                    break;
                /* 18.2.24 webPublishing CT_WebPublishing ? */ case '<webPublishing':
                case '<webPublishing/>':
                    break;
                /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case '<fileRecoveryPr':
                case '<fileRecoveryPr/>':
                    break;
                /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case '<webPublishObjects>':
                case '<webPublishObjects':
                case '</webPublishObjects>':
                    break;
                /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case '<webPublishObject':
                    break;
                /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
                case '<extLst>':
                case '</extLst>':
                case '<extLst/>':
                    break;
                /* 18.2.7  ext CT_Extension + */ case '<ext':
                    pass = true;
                    break; //TODO: check with versions of excel
                case '</ext>':
                    pass = false;
                    break;
                /* Others */ case '<ArchID':
                    break;
                case '<AlternateContent':
                case '<AlternateContent>':
                    pass = true;
                    break;
                case '</AlternateContent>':
                    pass = false;
                    break;
                /* TODO */ case '<revisionPtr':
                    break;
                default:
                    if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
            }
            return x;
        });
        if (XMLNS.main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
        parse_wb_defaults(wb);
        return wb;
    }
    var WB_XML_ROOT = writextag('workbook', null, {
        'xmlns': XMLNS.main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS.main[0],
        'xmlns:r': XMLNS.r
    });
    function write_wb_xml(wb) {
        var o = [
            XML_HEADER
        ];
        o[o.length] = WB_XML_ROOT;
        var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
        /* fileVersion */ /* fileSharing */ var workbookPr = {
            codeName: "ThisWorkbook"
        };
        if (wb.Workbook && wb.Workbook.WBProps) {
            WBPropsDef.forEach(function(x) {
                if (wb.Workbook.WBProps[x[0]] == null) return;
                if (wb.Workbook.WBProps[x[0]] == x[1]) return;
                workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
            });
            if (wb.Workbook.WBProps.CodeName) {
                workbookPr.codeName = wb.Workbook.WBProps.CodeName;
                delete workbookPr.CodeName;
            }
        }
        o[o.length] = writextag('workbookPr', null, workbookPr);
        /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
        var i = 0;
        /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
            o[o.length] = "<bookViews>";
            for(i = 0; i != wb.SheetNames.length; ++i){
                if (!sheets[i]) break;
                if (!sheets[i].Hidden) break;
            }
            if (i == wb.SheetNames.length) i = 0;
            o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
            o[o.length] = "</bookViews>";
        }
        o[o.length] = "<sheets>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            var sht = {
                name: escapexml(wb.SheetNames[i].slice(0, 31))
            };
            sht.sheetId = "" + (i + 1);
            sht["r:id"] = "rId" + (i + 1);
            if (sheets[i]) switch(sheets[i].Hidden){
                case 1:
                    sht.state = "hidden";
                    break;
                case 2:
                    sht.state = "veryHidden";
                    break;
            }
            o[o.length] = writextag('sheet', null, sht);
        }
        o[o.length] = "</sheets>";
        /* functionGroups */ /* externalReferences */ if (write_names) {
            o[o.length] = "<definedNames>";
            if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
                var d = {
                    name: n.Name
                };
                if (n.Comment) d.comment = n.Comment;
                if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
                if (n.Hidden) d.hidden = "1";
                if (!n.Ref) return;
                o[o.length] = writextag('definedName', escapexml(n.Ref), d);
            });
            o[o.length] = "</definedNames>";
        }
        /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
            o[o.length] = '</workbook>';
            o[1] = o[1].replace("/>", ">");
        }
        return o.join("");
    }
    /* [MS-XLSB] 2.4.304 BrtBundleSh */ function parse_BrtBundleSh(data, length) {
        var z = {};
        z.Hidden = data.read_shift(4); //hsState ST_SheetState
        z.iTabID = data.read_shift(4);
        z.strRelID = parse_RelID(data, length - 8);
        z.name = parse_XLWideString(data);
        return z;
    }
    function write_BrtBundleSh(data, o) {
        if (!o) o = new_buf(127);
        o.write_shift(4, data.Hidden);
        o.write_shift(4, data.iTabID);
        write_RelID(data.strRelID, o);
        write_XLWideString(data.name.slice(0, 31), o);
        return o.length > o.l ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.4.815 BrtWbProp */ function parse_BrtWbProp(data, length) {
        var o = {};
        var flags = data.read_shift(4);
        o.defaultThemeVersion = data.read_shift(4);
        var strName = length > 8 ? parse_XLWideString(data) : "";
        if (strName.length > 0) o.CodeName = strName;
        o.autoCompressPictures = !!(flags & 0x10000);
        o.backupFile = !!(flags & 0x40);
        o.checkCompatibility = !!(flags & 0x1000);
        o.date1904 = !!(flags & 0x01);
        o.filterPrivacy = !!(flags & 0x08);
        o.hidePivotFieldList = !!(flags & 0x400);
        o.promptedSolutions = !!(flags & 0x10);
        o.publishItems = !!(flags & 0x800);
        o.refreshAllConnections = !!(flags & 0x40000);
        o.saveExternalLinkValues = !!(flags & 0x80);
        o.showBorderUnselectedTables = !!(flags & 0x04);
        o.showInkAnnotation = !!(flags & 0x20);
        o.showObjects = [
            "all",
            "placeholders",
            "none"
        ][flags >> 13 & 0x03];
        o.showPivotChartFilter = !!(flags & 0x8000);
        o.updateLinks = [
            "userSet",
            "never",
            "always"
        ][flags >> 8 & 0x03];
        return o;
    }
    function write_BrtWbProp(data, o) {
        if (!o) o = new_buf(72);
        var flags = 0;
        if (data) /* TODO: mirror parse_BrtWbProp fields */ {
            if (data.filterPrivacy) flags |= 0x08;
        }
        o.write_shift(4, flags);
        o.write_shift(4, 0);
        write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
        return o.slice(0, o.l);
    }
    function parse_BrtFRTArchID$(data, length) {
        var o = {};
        data.read_shift(4);
        o.ArchID = data.read_shift(4);
        data.l += length - 8;
        return o;
    }
    /* [MS-XLSB] 2.4.687 BrtName */ function parse_BrtName(data, length, opts) {
        var end = data.l + length;
        data.l += 4; //var flags = data.read_shift(4);
        data.l += 1; //var chKey = data.read_shift(1);
        var itab = data.read_shift(4);
        var name = parse_XLNameWideString(data);
        var formula = parse_XLSBNameParsedFormula(data, 0, opts);
        var comment = parse_XLNullableWideString(data);
        //if(0 /* fProc */) {
        // unusedstring1: XLNullableWideString
        // description: XLNullableWideString
        // helpTopic: XLNullableWideString
        // unusedstring2: XLNullableWideString
        //}
        data.l = end;
        var out = {
            Name: name,
            Ptg: formula
        };
        if (itab < 0xFFFFFFF) out.Sheet = itab;
        if (comment) out.Comment = comment;
        return out;
    }
    /* [MS-XLSB] 2.1.7.61 Workbook */ function parse_wb_bin(data, opts) {
        var wb = {
            AppVersion: {},
            WBProps: {},
            WBView: [],
            Sheets: [],
            CalcPr: {},
            xmlns: ""
        };
        var state = [];
        var pass = false;
        if (!opts) opts = {};
        opts.biff = 12;
        var Names = [];
        var supbooks = [
            []
        ];
        supbooks.SheetNames = [];
        supbooks.XTI = [];
        recordhopper(data, function hopper_wb(val, R_n, RT) {
            switch(RT){
                case 0x009C:
                    /* 'BrtBundleSh' */ supbooks.SheetNames.push(val.name);
                    wb.Sheets.push(val);
                    break;
                case 0x0099:
                    /* 'BrtWbProp' */ wb.WBProps = val;
                    break;
                case 0x0027:
                    /* 'BrtName' */ if (val.Sheet != null) opts.SID = val.Sheet;
                    val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
                    delete opts.SID;
                    delete val.Ptg;
                    Names.push(val);
                    break;
                case 0x040C:
                    break;
                case 0x0165:
                /* 'BrtSupSelf' */ case 0x0166:
                /* 'BrtSupSame' */ case 0x0163:
                /* 'BrtSupBookSrc' */ case 0x029B:
                    /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                        RT,
                        val
                    ];
                    else supbooks.push([
                        RT,
                        val
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x016A:
                    /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                    supbooks.XTI = supbooks.XTI.concat(val);
                    break;
                case 0x0169:
                    break;
                /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
                /* 'BrtUid' */ case 0x0C01:
                /* 'BrtRevisionPtr' */ case 0x0817:
                /* 'BrtAbsPath15' */ case 0x0216:
                /* 'BrtBookProtection' */ case 0x02A5:
                /* 'BrtBookProtectionIso' */ case 0x009E:
                /* 'BrtBookView' */ case 0x009D:
                /* 'BrtCalcProp' */ case 0x0262:
                /* 'BrtCrashRecErr' */ case 0x0802:
                /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
                /* 'BrtFileRecover' */ case 0x0224:
                /* 'BrtFileSharing' */ case 0x02A4:
                /* 'BrtFileSharingIso' */ case 0x0080:
                /* 'BrtFileVersion' */ case 0x0299:
                /* 'BrtFnGroup' */ case 0x0850:
                /* 'BrtModelRelationship' */ case 0x084D:
                /* 'BrtModelTable' */ case 0x0225:
                /* 'BrtOleSize' */ case 0x0805:
                /* 'BrtPivotTableRef' */ case 0x0254:
                /* 'BrtSmartTagType' */ case 0x081C:
                /* 'BrtTableSlicerCacheID' */ case 0x081B:
                /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
                /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
                /* 'BrtUserBookView' */ case 0x009A:
                /* 'BrtWbFactoid' */ case 0x045D:
                /* 'BrtWbProp14' */ case 0x0229:
                /* 'BrtWebOpt' */ case 0x082B:
                    break;
                case 0x0023:
                    /* 'BrtFRTBegin' */ state.push(R_n);
                    pass = true;
                    break;
                case 0x0024:
                    /* 'BrtFRTEnd' */ state.pop();
                    pass = false;
                    break;
                case 0x0025:
                    /* 'BrtACBegin' */ state.push(R_n);
                    pass = true;
                    break;
                case 0x0026:
                    /* 'BrtACEnd' */ state.pop();
                    pass = false;
                    break;
                case 0x0010:
                    break;
                default:
                    if ((R_n || "").indexOf("Begin") > 0) ;
                    else if ((R_n || "").indexOf("End") > 0) ;
                    else if (!pass || opts.WTF && state[state.length - 1] != "BrtACBegin" && state[state.length - 1] != "BrtFRTBegin") throw new Error("Unexpected record " + RT + " " + R_n);
            }
        }, opts);
        parse_wb_defaults(wb);
        // $FlowIgnore
        wb.Names = Names;
        wb.supbooks = supbooks;
        return wb;
    }
    function write_BUNDLESHS(ba, wb) {
        write_record(ba, "BrtBeginBundleShs");
        for(var idx = 0; idx != wb.SheetNames.length; ++idx){
            var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
            var d = {
                Hidden: viz,
                iTabID: idx + 1,
                strRelID: 'rId' + (idx + 1),
                name: wb.SheetNames[idx]
            };
            write_record(ba, "BrtBundleSh", write_BrtBundleSh(d));
        }
        write_record(ba, "BrtEndBundleShs");
    }
    /* [MS-XLSB] 2.4.649 BrtFileVersion */ function write_BrtFileVersion(data, o) {
        if (!o) o = new_buf(127);
        for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
        write_XLWideString("SheetJS", o);
        write_XLWideString(XLSX.version, o);
        write_XLWideString(XLSX.version, o);
        write_XLWideString("7262", o);
        o.length = o.l;
        return o.length > o.l ? o.slice(0, o.l) : o;
    }
    /* [MS-XLSB] 2.4.301 BrtBookView */ function write_BrtBookView(idx, o) {
        if (!o) o = new_buf(29);
        o.write_shift(-4, 0);
        o.write_shift(-4, 460);
        o.write_shift(4, 28800);
        o.write_shift(4, 17600);
        o.write_shift(4, 500);
        o.write_shift(4, idx);
        o.write_shift(4, idx);
        var flags = 0x78;
        o.write_shift(1, flags);
        return o.length > o.l ? o.slice(0, o.l) : o;
    }
    function write_BOOKVIEWS(ba, wb) {
        /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
        var sheets = wb.Workbook.Sheets;
        var i = 0, vistab = -1, hidden = -1;
        for(; i < sheets.length; ++i){
            if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
            else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
        }
        if (hidden > vistab) return;
        write_record(ba, "BrtBeginBookViews");
        write_record(ba, "BrtBookView", write_BrtBookView(vistab));
        /* 1*(BrtBookView *FRT) */ write_record(ba, "BrtEndBookViews");
    }
    /* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function write_wb_bin(wb, opts) {
        var ba = buf_array();
        write_record(ba, "BrtBeginBook");
        write_record(ba, "BrtFileVersion", write_BrtFileVersion());
        /* [[BrtFileSharingIso] BrtFileSharing] */ write_record(ba, "BrtWbProp", write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
        /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ write_BOOKVIEWS(ba, wb, opts);
        write_BUNDLESHS(ba, wb, opts);
        /* [FNGROUP] */ /* [EXTERNALS] */ /* *BrtName */ /* write_record(ba, "BrtCalcProp", write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, "BrtFileRecover", write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ write_record(ba, "BrtEndBook");
        return ba.end();
    }
    function parse_wb(data, name, opts) {
        if (name.slice(-4) === ".bin") return parse_wb_bin(data, opts);
        return parse_wb_xml(data, opts);
    }
    function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
        if (name.slice(-4) === ".bin") return parse_ws_bin(data, opts, idx, rels, wb, themes, styles);
        return parse_ws_xml(data, opts, idx, rels, wb, themes, styles);
    }
    function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
        if (name.slice(-4) === ".bin") return parse_cs_bin(data, opts, idx, rels, wb, themes, styles);
        return parse_cs_xml(data, opts, idx, rels, wb, themes, styles);
    }
    function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
        if (name.slice(-4) === ".bin") return parse_ms_bin(data, opts, idx, rels, wb, themes, styles);
        return parse_ms_xml(data, opts, idx, rels, wb, themes, styles);
    }
    function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
        if (name.slice(-4) === ".bin") return parse_ds_bin(data, opts, idx, rels, wb, themes, styles);
        return parse_ds_xml(data, opts, idx, rels, wb, themes, styles);
    }
    function parse_sty(data, name, themes, opts) {
        if (name.slice(-4) === ".bin") return parse_sty_bin(data, themes, opts);
        return parse_sty_xml(data, themes, opts);
    }
    function parse_theme(data, name, opts) {
        return parse_theme_xml(data, opts);
    }
    function parse_sst(data, name, opts) {
        if (name.slice(-4) === ".bin") return parse_sst_bin(data, opts);
        return parse_sst_xml(data, opts);
    }
    function parse_cmnt(data, name, opts) {
        if (name.slice(-4) === ".bin") return parse_comments_bin(data, opts);
        return parse_comments_xml(data, opts);
    }
    function parse_cc(data, name, opts) {
        if (name.slice(-4) === ".bin") return parse_cc_bin(data, name, opts);
        return parse_cc_xml(data, name, opts);
    }
    function parse_xlink(data, rel, name, opts) {
        if (name.slice(-4) === ".bin") return parse_xlink_bin(data, rel, name, opts);
        return parse_xlink_xml(data, rel, name, opts);
    }
    function write_wb(wb, name, opts) {
        return (name.slice(-4) === ".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
    }
    function write_ws(data, name, opts, wb, rels) {
        return (name.slice(-4) === ".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
    }
    // eslint-disable-next-line no-unused-vars
    function write_cs(data, name, opts, wb, rels) {
        return (name.slice(-4) === ".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
    }
    function write_sty(data, name, opts) {
        return (name.slice(-4) === ".bin" ? write_sty_bin : write_sty_xml)(data, opts);
    }
    function write_sst(data, name, opts) {
        return (name.slice(-4) === ".bin" ? write_sst_bin : write_sst_xml)(data, opts);
    }
    function write_cmnt(data, name, opts) {
        return (name.slice(-4) === ".bin" ? write_comments_bin : write_comments_xml)(data, opts);
    }
    /*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/ var attregexg2 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
    var attregex2 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
    function xlml_parsexmltag(tag, skip_root) {
        var words = tag.split(/\s+/);
        var z = [];
        if (!skip_root) z[0] = words[0];
        if (words.length === 1) return z;
        var m = tag.match(attregexg2), y, j, w, i;
        if (m) for(i = 0; i != m.length; ++i){
            y = m[i].match(attregex2);
            if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
            else {
                if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
                else w = y[1].slice(j + 1);
                z[w] = y[2].slice(1, y[2].length - 1);
            }
        }
        return z;
    }
    function xlml_parsexmltagobj(tag) {
        var words = tag.split(/\s+/);
        var z = {};
        if (words.length === 1) return z;
        var m = tag.match(attregexg2), y, j, w, i;
        if (m) for(i = 0; i != m.length; ++i){
            y = m[i].match(attregex2);
            if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
            else {
                if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
                else w = y[1].slice(j + 1);
                z[w] = y[2].slice(1, y[2].length - 1);
            }
        }
        return z;
    }
    // ----
    function xlml_format(format, value) {
        var fmt = XLMLFormatMap[format] || unescapexml(format);
        if (fmt === "General") return SSF._general(value);
        return SSF.format(fmt, value);
    }
    function xlml_set_custprop(Custprops, key, cp, val) {
        var oval = val;
        switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
            "",
            ""
        ])[1]){
            case "boolean":
                oval = parsexmlbool(val);
                break;
            case "i2":
            case "int":
                oval = parseInt(val, 10);
                break;
            case "r4":
            case "float":
                oval = parseFloat(val);
                break;
            case "date":
            case "dateTime.tz":
                oval = parseDate(val);
                break;
            case "i8":
            case "string":
            case "fixed":
            case "uuid":
            case "bin.base64":
                break;
            default:
                throw new Error("bad custprop:" + cp[0]);
        }
        Custprops[unescapexml(key)] = oval;
    }
    function safe_format_xlml(cell, nf, o) {
        if (cell.t === 'z') return;
        if (!o || o.cellText !== false) try {
            if (cell.t === 'e') cell.w = cell.w || BErr[cell.v];
            else if (nf === "General") {
                if (cell.t === 'n') {
                    if ((cell.v | 0) === cell.v) cell.w = SSF._general_int(cell.v);
                    else cell.w = SSF._general_num(cell.v);
                } else cell.w = SSF._general(cell.v);
            } else cell.w = xlml_format(nf || "General", cell.v);
        } catch (e) {
            if (o.WTF) throw e;
        }
        try {
            var z = XLMLFormatMap[nf] || nf || "General";
            if (o.cellNF) cell.z = z;
            if (o.cellDates && cell.t == 'n' && SSF.is_date(z)) {
                var _d = SSF.parse_date_code(cell.v);
                if (_d) {
                    cell.t = 'd';
                    cell.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
                }
            }
        } catch (e) {
            if (o.WTF) throw e;
        }
    }
    function process_style_xlml(styles, stag, opts) {
        if (opts.cellStyles) {
            if (stag.Interior) {
                var I = stag.Interior;
                if (I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
            }
        }
        styles[stag.ID] = stag;
    }
    /* TODO: there must exist some form of OSP-blessed spec */ function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
        var nf = "General", sid = cell.StyleID, S = {};
        o = o || {};
        var interiors = [];
        var i = 0;
        if (sid === undefined && row) sid = row.StyleID;
        if (sid === undefined && csty) sid = csty.StyleID;
        while(styles[sid] !== undefined){
            if (styles[sid].nf) nf = styles[sid].nf;
            if (styles[sid].Interior) interiors.push(styles[sid].Interior);
            if (!styles[sid].Parent) break;
            sid = styles[sid].Parent;
        }
        switch(data.Type){
            case 'Boolean':
                cell.t = 'b';
                cell.v = parsexmlbool(xml);
                break;
            case 'String':
                cell.t = 's';
                cell.r = xlml_fixstr(unescapexml(xml));
                cell.v = xml.indexOf("<") > -1 ? unescapexml(ss || xml).replace(/<.*?>/g, "") : cell.r; // todo: BR etc
                break;
            case 'DateTime':
                if (xml.slice(-1) != "Z") xml += "Z";
                cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / 86400000;
                if (cell.v !== cell.v) cell.v = unescapexml(xml);
                else if (cell.v < 60) cell.v = cell.v - 1;
                if (!nf || nf == "General") nf = "yyyy-mm-dd";
            /* falls through */ case 'Number':
                if (cell.v === undefined) cell.v = +xml;
                if (!cell.t) cell.t = 'n';
                break;
            case 'Error':
                cell.t = 'e';
                cell.v = RBErr[xml];
                if (o.cellText !== false) cell.w = xml;
                break;
            default:
                if (xml == "" && ss == "") cell.t = 'z';
                else {
                    cell.t = 's';
                    cell.v = xlml_fixstr(ss || xml);
                }
                break;
        }
        safe_format_xlml(cell, nf, o);
        if (o.cellFormula !== false) {
            if (cell.Formula) {
                var fstr = unescapexml(cell.Formula);
                /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
                cell.f = rc_to_a1(fstr, base);
                delete cell.Formula;
                if (cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
                else if (cell.ArrayRange) {
                    cell.F = rc_to_a1(cell.ArrayRange, base);
                    arrayf.push([
                        safe_decode_range(cell.F),
                        cell.F
                    ]);
                }
            } else {
                for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                    if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
                }
            }
        }
        if (o.cellStyles) {
            interiors.forEach(function(x) {
                if (!S.patternType && x.patternType) S.patternType = x.patternType;
            });
            cell.s = S;
        }
        if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
    }
    function xlml_clean_comment(comment) {
        comment.t = comment.v || "";
        comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        comment.v = comment.w = comment.ixfe = undefined;
    }
    function xlml_normalize(d) {
        if (has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
        if (typeof d === 'string') return d;
        /* duktape */ if (typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
        throw new Error("Bad input format: expected Buffer or string");
    }
    /* TODO: Everything */ /* UOS uses CJK in tags */ var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
    //var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
    function parse_xlml_xml(d, _opts) {
        var opts = _opts || {};
        make_ssf(SSF);
        var str = debom(xlml_normalize(d));
        if (opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
            if (typeof cptable !== 'undefined') str = cptable.utils.decode(65001, char_codes(str));
            else str = utf8read(str);
        }
        var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
        if (opening.indexOf("<?xml") == -1) [
            "html",
            "table",
            "head",
            "meta",
            "script",
            "style",
            "div"
        ].forEach(function(tag) {
            if (opening.indexOf("<" + tag) >= 0) ishtml = true;
        });
        if (ishtml) return HTML_.to_workbook(str, opts);
        var Rn;
        var state = [], tmp;
        if (DENSE != null && opts.dense == null) opts.dense = DENSE;
        var sheets = {}, sheetnames = [], cursheet = opts.dense ? [] : {}, sheetname = "";
        var table = {}, cell = {}, row = {}; // eslint-disable-line no-unused-vars
        var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
        var c = 0, r = 0;
        var refguess = {
            s: {
                r: 2000000,
                c: 2000000
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var styles = {}, stag = {};
        var ss = "", fidx = 0;
        var merges = [];
        var Props = {}, Custprops = {}, pidx = 0, cp = [];
        var comments = [], comment = {};
        var cstys = [], csty, seencol = false;
        var arrayf = [];
        var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
        var Workbook = {
            Sheets: [],
            WBProps: {
                date1904: false
            }
        }, wsprops = {};
        xlmlregex.lastIndex = 0;
        str = str.replace(/<!--([\s\S]*?)-->/mg, "");
        var raw_Rn3 = "";
        while(Rn = xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
            case 'data' /*case 'Data'*/ :
                if (raw_Rn3 == "data") {
                    if (Rn[1] === '/') {
                        if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                    } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                        Rn[3],
                        true
                    ]);
                    break;
                }
                if (state[state.length - 1][1]) break;
                if (Rn[1] === '/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                    c: c,
                    r: r
                }, styles, cstys[c], row, arrayf, opts);
                else {
                    ss = "";
                    dtag = xlml_parsexmltag(Rn[0]);
                    didx = Rn.index + Rn[0].length;
                }
                break;
            case 'cell' /*case 'Cell'*/ :
                if (Rn[1] === '/') {
                    if (comments.length > 0) cell.c = comments;
                    if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
                        if (opts.dense) {
                            if (!cursheet[r]) cursheet[r] = [];
                            cursheet[r][c] = cell;
                        } else cursheet[encode_col(c) + encode_row(r)] = cell;
                    }
                    if (cell.HRef) {
                        cell.l = {
                            Target: cell.HRef
                        };
                        if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                        delete cell.HRef;
                        delete cell.HRefScreenTip;
                    }
                    if (cell.MergeAcross || cell.MergeDown) {
                        cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                        rr = r + (parseInt(cell.MergeDown, 10) | 0);
                        merges.push({
                            s: {
                                c: c,
                                r: r
                            },
                            e: {
                                c: cc,
                                r: rr
                            }
                        });
                    }
                    if (!opts.sheetStubs) {
                        if (cell.MergeAcross) c = cc + 1;
                        else ++c;
                    } else if (cell.MergeAcross || cell.MergeDown) {
                        for(var cma = c; cma <= cc; ++cma){
                            for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                                if (opts.dense) {
                                    if (!cursheet[cmd]) cursheet[cmd] = [];
                                    cursheet[cmd][cma] = {
                                        t: 'z'
                                    };
                                } else cursheet[encode_col(cma) + encode_row(cmd)] = {
                                    t: 'z'
                                };
                            }
                        }
                        c = cc + 1;
                    } else ++c;
                } else {
                    cell = xlml_parsexmltagobj(Rn[0]);
                    if (cell.Index) c = +cell.Index - 1;
                    if (c < refguess.s.c) refguess.s.c = c;
                    if (c > refguess.e.c) refguess.e.c = c;
                    if (Rn[0].slice(-2) === "/>") ++c;
                    comments = [];
                }
                break;
            case 'row' /*case 'Row'*/ :
                if (Rn[1] === '/' || Rn[0].slice(-2) === "/>") {
                    if (r < refguess.s.r) refguess.s.r = r;
                    if (r > refguess.e.r) refguess.e.r = r;
                    if (Rn[0].slice(-2) === "/>") {
                        row = xlml_parsexmltag(Rn[0]);
                        if (row.Index) r = +row.Index - 1;
                    }
                    c = 0;
                    ++r;
                } else {
                    row = xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                    rowobj = {};
                    if (row.AutoFitHeight == "0" || row.Height) {
                        rowobj.hpx = parseInt(row.Height, 10);
                        rowobj.hpt = px2pt(rowobj.hpx);
                        rowinfo[r] = rowobj;
                    }
                    if (row.Hidden == "1") {
                        rowobj.hidden = true;
                        rowinfo[r] = rowobj;
                    }
                }
                break;
            case 'worksheet' /*case 'Worksheet'*/ :
                /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                    sheetnames.push(sheetname);
                    if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                        cursheet["!ref"] = encode_range(refguess);
                        if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                            cursheet["!fullref"] = cursheet["!ref"];
                            refguess.e.r = opts.sheetRows - 1;
                            cursheet["!ref"] = encode_range(refguess);
                        }
                    }
                    if (merges.length) cursheet["!merges"] = merges;
                    if (cstys.length > 0) cursheet["!cols"] = cstys;
                    if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                    sheets[sheetname] = cursheet;
                } else {
                    refguess = {
                        s: {
                            r: 2000000,
                            c: 2000000
                        },
                        e: {
                            r: 0,
                            c: 0
                        }
                    };
                    r = c = 0;
                    state.push([
                        Rn[3],
                        false
                    ]);
                    tmp = xlml_parsexmltag(Rn[0]);
                    sheetname = unescapexml(tmp.Name);
                    cursheet = opts.dense ? [] : {};
                    merges = [];
                    arrayf = [];
                    rowinfo = [];
                    wsprops = {
                        name: sheetname,
                        Hidden: 0
                    };
                    Workbook.Sheets.push(wsprops);
                }
                break;
            case 'table' /*case 'Table'*/ :
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].slice(-2) == "/>") break;
                else {
                    table = xlml_parsexmltag(Rn[0]);
                    state.push([
                        Rn[3],
                        false
                    ]);
                    cstys = [];
                    seencol = false;
                }
                break;
            case 'style' /*case 'Style'*/ :
                if (Rn[1] === '/') process_style_xlml(styles, stag, opts);
                else stag = xlml_parsexmltag(Rn[0]);
                break;
            case 'numberformat' /*case 'NumberFormat'*/ :
                stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
                if (XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
                for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if (SSF._table[ssfidx] == stag.nf) break;
                if (ssfidx == 0x188) {
                    for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if (SSF._table[ssfidx] == null) {
                        SSF.load(stag.nf, ssfidx);
                        break;
                    }
                }
                break;
            case 'column' /*case 'Column'*/ :
                if (state[state.length - 1][0] !== /*'Table'*/ 'table') break;
                csty = xlml_parsexmltag(Rn[0]);
                if (csty.Hidden) {
                    csty.hidden = true;
                    delete csty.Hidden;
                }
                if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
                if (!seencol && csty.wpx > 10) {
                    seencol = true;
                    MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
                    for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) process_col(cstys[_col]);
                }
                if (seencol) process_col(csty);
                cstys[csty.Index - 1 || cstys.length] = csty;
                for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = dup(csty);
                break;
            case 'namedrange' /*case 'NamedRange'*/ :
                if (Rn[1] === '/') break;
                if (!Workbook.Names) Workbook.Names = [];
                var _NamedRange = parsexmltag(Rn[0]);
                var _DefinedName = {
                    Name: _NamedRange.Name,
                    Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {
                        r: 0,
                        c: 0
                    })
                };
                if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
                Workbook.Names.push(_DefinedName);
                break;
            case 'namedcell' /*case 'NamedCell'*/ :
                break;
            case 'b' /*case 'B'*/ :
                break;
            case 'i' /*case 'I'*/ :
                break;
            case 'u' /*case 'U'*/ :
                break;
            case 's' /*case 'S'*/ :
                break;
            case 'em' /*case 'EM'*/ :
                break;
            case 'h2' /*case 'H2'*/ :
                break;
            case 'h3' /*case 'H3'*/ :
                break;
            case 'sub' /*case 'Sub'*/ :
                break;
            case 'sup' /*case 'Sup'*/ :
                break;
            case 'span' /*case 'Span'*/ :
                break;
            case 'alignment' /*case 'Alignment'*/ :
                break;
            case 'borders' /*case 'Borders'*/ :
                break;
            case 'border' /*case 'Border'*/ :
                break;
            case 'font' /*case 'Font'*/ :
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
                else fidx = Rn.index + Rn[0].length;
                break;
            case 'interior' /*case 'Interior'*/ :
                if (!opts.cellStyles) break;
                stag.Interior = xlml_parsexmltag(Rn[0]);
                break;
            case 'protection' /*case 'Protection'*/ :
                break;
            case 'author' /*case 'Author'*/ :
            case 'title' /*case 'Title'*/ :
            case 'description' /*case 'Description'*/ :
            case 'created' /*case 'Created'*/ :
            case 'keywords' /*case 'Keywords'*/ :
            case 'subject' /*case 'Subject'*/ :
            case 'category' /*case 'Category'*/ :
            case 'company' /*case 'Company'*/ :
            case 'lastauthor' /*case 'LastAuthor'*/ :
            case 'lastsaved' /*case 'LastSaved'*/ :
            case 'lastprinted' /*case 'LastPrinted'*/ :
            case 'version' /*case 'Version'*/ :
            case 'revision' /*case 'Revision'*/ :
            case 'totaltime' /*case 'TotalTime'*/ :
            case 'hyperlinkbase' /*case 'HyperlinkBase'*/ :
            case 'manager' /*case 'Manager'*/ :
            case 'contentstatus' /*case 'ContentStatus'*/ :
            case 'identifier' /*case 'Identifier'*/ :
            case 'language' /*case 'Language'*/ :
            case 'appname' /*case 'AppName'*/ :
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
                else pidx = Rn.index + Rn[0].length;
                break;
            case 'paragraphs' /*case 'Paragraphs'*/ :
                break;
            case 'styles' /*case 'Styles'*/ :
            case 'workbook' /*case 'Workbook'*/ :
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else state.push([
                    Rn[3],
                    false
                ]);
                break;
            case 'comment' /*case 'Comment'*/ :
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                    xlml_clean_comment(comment);
                    comments.push(comment);
                } else {
                    state.push([
                        Rn[3],
                        false
                    ]);
                    tmp = xlml_parsexmltag(Rn[0]);
                    comment = {
                        a: tmp.Author
                    };
                }
                break;
            case 'autofilter' /*case 'AutoFilter'*/ :
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                    var AutoFilter = xlml_parsexmltag(Rn[0]);
                    cursheet['!autofilter'] = {
                        ref: rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                    };
                    state.push([
                        Rn[3],
                        true
                    ]);
                }
                break;
            case 'name' /*case 'Name'*/ :
                break;
            case 'datavalidation' /*case 'DataValidation'*/ :
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                    Rn[3],
                    true
                ]);
                break;
            case 'pixelsperinch' /*case 'PixelsPerInch'*/ :
                break;
            case 'componentoptions' /*case 'ComponentOptions'*/ :
            case 'documentproperties' /*case 'DocumentProperties'*/ :
            case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/ :
            case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
            case 'pivottable' /*case 'PivotTable'*/ :
            case 'pivotcache' /*case 'PivotCache'*/ :
            case 'names' /*case 'Names'*/ :
            case 'mapinfo' /*case 'MapInfo'*/ :
            case 'pagebreaks' /*case 'PageBreaks'*/ :
            case 'querytable' /*case 'QueryTable'*/ :
            case 'sorting' /*case 'Sorting'*/ :
            case 'schema' /*case 'Schema'*/ :
            case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
            case 'smarttagtype' /*case 'SmartTagType'*/ :
            case 'smarttags' /*case 'SmartTags'*/ :
            case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
            case 'workbookoptions' /*case 'WorkbookOptions'*/ :
            case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                    Rn[3],
                    true
                ]);
                break;
            default:
                /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
                /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return parse_fods(str, opts);
                var seen = true;
                switch(state[state.length - 1][0]){
                    /* OfficeDocumentSettings */ case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
                        switch(Rn[3]){
                            case 'allowpng' /*case 'AllowPNG'*/ :
                                break;
                            case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/ :
                                break;
                            case 'downloadcomponents' /*case 'DownloadComponents'*/ :
                                break;
                            case 'locationofcomponents' /*case 'LocationOfComponents'*/ :
                                break;
                            case 'colors' /*case 'Colors'*/ :
                                break;
                            case 'color' /*case 'Color'*/ :
                                break;
                            case 'index' /*case 'Index'*/ :
                                break;
                            case 'rgb' /*case 'RGB'*/ :
                                break;
                            case 'targetscreensize' /*case 'TargetScreenSize'*/ :
                                break;
                            case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    /* ComponentOptions */ case 'componentoptions' /*case 'ComponentOptions'*/ :
                        switch(Rn[3]){
                            case 'toolbar' /*case 'Toolbar'*/ :
                                break;
                            case 'hideofficelogo' /*case 'HideOfficeLogo'*/ :
                                break;
                            case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/ :
                                break;
                            case 'label' /*case 'Label'*/ :
                                break;
                            case 'caption' /*case 'Caption'*/ :
                                break;
                            case 'maxheight' /*case 'MaxHeight'*/ :
                                break;
                            case 'maxwidth' /*case 'MaxWidth'*/ :
                                break;
                            case 'nextsheetnumber' /*case 'NextSheetNumber'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    /* ExcelWorkbook */ case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
                        switch(Rn[3]){
                            case 'date1904' /*case 'Date1904'*/ :
                                Workbook.WBProps.date1904 = true;
                                break;
                            case 'windowheight' /*case 'WindowHeight'*/ :
                                break;
                            case 'windowwidth' /*case 'WindowWidth'*/ :
                                break;
                            case 'windowtopx' /*case 'WindowTopX'*/ :
                                break;
                            case 'windowtopy' /*case 'WindowTopY'*/ :
                                break;
                            case 'tabratio' /*case 'TabRatio'*/ :
                                break;
                            case 'protectstructure' /*case 'ProtectStructure'*/ :
                                break;
                            case 'protectwindow' /*case 'ProtectWindow'*/ :
                                break;
                            case 'protectwindows' /*case 'ProtectWindows'*/ :
                                break;
                            case 'activesheet' /*case 'ActiveSheet'*/ :
                                break;
                            case 'displayinknotes' /*case 'DisplayInkNotes'*/ :
                                break;
                            case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/ :
                                break;
                            case 'supbook' /*case 'SupBook'*/ :
                                break;
                            case 'sheetname' /*case 'SheetName'*/ :
                                break;
                            case 'sheetindex' /*case 'SheetIndex'*/ :
                                break;
                            case 'sheetindexfirst' /*case 'SheetIndexFirst'*/ :
                                break;
                            case 'sheetindexlast' /*case 'SheetIndexLast'*/ :
                                break;
                            case 'dll' /*case 'Dll'*/ :
                                break;
                            case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/ :
                                break;
                            case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/ :
                                break;
                            case 'iteration' /*case 'Iteration'*/ :
                                break;
                            case 'maxiterations' /*case 'MaxIterations'*/ :
                                break;
                            case 'maxchange' /*case 'MaxChange'*/ :
                                break;
                            case 'path' /*case 'Path'*/ :
                                break;
                            case 'xct' /*case 'Xct'*/ :
                                break;
                            case 'count' /*case 'Count'*/ :
                                break;
                            case 'selectedsheets' /*case 'SelectedSheets'*/ :
                                break;
                            case 'calculation' /*case 'Calculation'*/ :
                                break;
                            case 'uncalced' /*case 'Uncalced'*/ :
                                break;
                            case 'startupprompt' /*case 'StartupPrompt'*/ :
                                break;
                            case 'crn' /*case 'Crn'*/ :
                                break;
                            case 'externname' /*case 'ExternName'*/ :
                                break;
                            case 'formula' /*case 'Formula'*/ :
                                break;
                            case 'colfirst' /*case 'ColFirst'*/ :
                                break;
                            case 'collast' /*case 'ColLast'*/ :
                                break;
                            case 'wantadvise' /*case 'WantAdvise'*/ :
                                break;
                            case 'boolean' /*case 'Boolean'*/ :
                                break;
                            case 'error' /*case 'Error'*/ :
                                break;
                            case 'text' /*case 'Text'*/ :
                                break;
                            case 'ole' /*case 'OLE'*/ :
                                break;
                            case 'noautorecover' /*case 'NoAutoRecover'*/ :
                                break;
                            case 'publishobjects' /*case 'PublishObjects'*/ :
                                break;
                            case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/ :
                                break;
                            case 'number' /*case 'Number'*/ :
                                break;
                            case 'refmoder1c1' /*case 'RefModeR1C1'*/ :
                                break;
                            case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    /* WorkbookOptions */ case 'workbookoptions' /*case 'WorkbookOptions'*/ :
                        switch(Rn[3]){
                            case 'owcversion' /*case 'OWCVersion'*/ :
                                break;
                            case 'height' /*case 'Height'*/ :
                                break;
                            case 'width' /*case 'Width'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    /* WorksheetOptions */ case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
                        switch(Rn[3]){
                            case 'visible' /*case 'Visible'*/ :
                                if (Rn[0].slice(-2) === "/>") ;
                                else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                    case "SheetHidden":
                                        wsprops.Hidden = 1;
                                        break;
                                    case "SheetVeryHidden":
                                        wsprops.Hidden = 2;
                                        break;
                                }
                                else pidx = Rn.index + Rn[0].length;
                                break;
                            case 'header' /*case 'Header'*/ :
                                if (!cursheet['!margins']) default_margins(cursheet['!margins'] = {}, 'xlml');
                                cursheet['!margins'].header = parsexmltag(Rn[0]).Margin;
                                break;
                            case 'footer' /*case 'Footer'*/ :
                                if (!cursheet['!margins']) default_margins(cursheet['!margins'] = {}, 'xlml');
                                cursheet['!margins'].footer = parsexmltag(Rn[0]).Margin;
                                break;
                            case 'pagemargins' /*case 'PageMargins'*/ :
                                var pagemargins = parsexmltag(Rn[0]);
                                if (!cursheet['!margins']) default_margins(cursheet['!margins'] = {}, 'xlml');
                                if (pagemargins.Top) cursheet['!margins'].top = pagemargins.Top;
                                if (pagemargins.Left) cursheet['!margins'].left = pagemargins.Left;
                                if (pagemargins.Right) cursheet['!margins'].right = pagemargins.Right;
                                if (pagemargins.Bottom) cursheet['!margins'].bottom = pagemargins.Bottom;
                                break;
                            case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/ :
                                if (!Workbook.Views) Workbook.Views = [];
                                if (!Workbook.Views[0]) Workbook.Views[0] = {};
                                Workbook.Views[0].RTL = true;
                                break;
                            case 'freezepanes' /*case 'FreezePanes'*/ :
                                break;
                            case 'frozennosplit' /*case 'FrozenNoSplit'*/ :
                                break;
                            case 'splithorizontal' /*case 'SplitHorizontal'*/ :
                            case 'splitvertical' /*case 'SplitVertical'*/ :
                                break;
                            case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/ :
                                break;
                            case 'activerow' /*case 'ActiveRow'*/ :
                                break;
                            case 'activecol' /*case 'ActiveCol'*/ :
                                break;
                            case 'toprowbottompane' /*case 'TopRowBottomPane'*/ :
                                break;
                            case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/ :
                                break;
                            case 'unsynced' /*case 'Unsynced'*/ :
                                break;
                            case 'print' /*case 'Print'*/ :
                                break;
                            case 'panes' /*case 'Panes'*/ :
                                break;
                            case 'scale' /*case 'Scale'*/ :
                                break;
                            case 'pane' /*case 'Pane'*/ :
                                break;
                            case 'number' /*case 'Number'*/ :
                                break;
                            case 'layout' /*case 'Layout'*/ :
                                break;
                            case 'pagesetup' /*case 'PageSetup'*/ :
                                break;
                            case 'selected' /*case 'Selected'*/ :
                                break;
                            case 'protectobjects' /*case 'ProtectObjects'*/ :
                                break;
                            case 'enableselection' /*case 'EnableSelection'*/ :
                                break;
                            case 'protectscenarios' /*case 'ProtectScenarios'*/ :
                                break;
                            case 'validprinterinfo' /*case 'ValidPrinterInfo'*/ :
                                break;
                            case 'horizontalresolution' /*case 'HorizontalResolution'*/ :
                                break;
                            case 'verticalresolution' /*case 'VerticalResolution'*/ :
                                break;
                            case 'numberofcopies' /*case 'NumberofCopies'*/ :
                                break;
                            case 'activepane' /*case 'ActivePane'*/ :
                                break;
                            case 'toprowvisible' /*case 'TopRowVisible'*/ :
                                break;
                            case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/ :
                                break;
                            case 'fittopage' /*case 'FitToPage'*/ :
                                break;
                            case 'rangeselection' /*case 'RangeSelection'*/ :
                                break;
                            case 'papersizeindex' /*case 'PaperSizeIndex'*/ :
                                break;
                            case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/ :
                                break;
                            case 'pagebreakzoom' /*case 'PageBreakZoom'*/ :
                                break;
                            case 'filteron' /*case 'FilterOn'*/ :
                                break;
                            case 'fitwidth' /*case 'FitWidth'*/ :
                                break;
                            case 'fitheight' /*case 'FitHeight'*/ :
                                break;
                            case 'commentslayout' /*case 'CommentsLayout'*/ :
                                break;
                            case 'zoom' /*case 'Zoom'*/ :
                                break;
                            case 'lefttoright' /*case 'LeftToRight'*/ :
                                break;
                            case 'gridlines' /*case 'Gridlines'*/ :
                                break;
                            case 'allowsort' /*case 'AllowSort'*/ :
                                break;
                            case 'allowfilter' /*case 'AllowFilter'*/ :
                                break;
                            case 'allowinsertrows' /*case 'AllowInsertRows'*/ :
                                break;
                            case 'allowdeleterows' /*case 'AllowDeleteRows'*/ :
                                break;
                            case 'allowinsertcols' /*case 'AllowInsertCols'*/ :
                                break;
                            case 'allowdeletecols' /*case 'AllowDeleteCols'*/ :
                                break;
                            case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/ :
                                break;
                            case 'allowformatcells' /*case 'AllowFormatCells'*/ :
                                break;
                            case 'allowsizecols' /*case 'AllowSizeCols'*/ :
                                break;
                            case 'allowsizerows' /*case 'AllowSizeRows'*/ :
                                break;
                            case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/ :
                                break;
                            case 'tabcolorindex' /*case 'TabColorIndex'*/ :
                                break;
                            case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/ :
                                break;
                            case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/ :
                                break;
                            case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/ :
                                break;
                            case 'blackandwhite' /*case 'BlackAndWhite'*/ :
                                break;
                            case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/ :
                                break;
                            case 'displaypagebreak' /*case 'DisplayPageBreak'*/ :
                                break;
                            case 'rowcolheadings' /*case 'RowColHeadings'*/ :
                                break;
                            case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/ :
                                break;
                            case 'noorientation' /*case 'NoOrientation'*/ :
                                break;
                            case 'allowusepivottables' /*case 'AllowUsePivotTables'*/ :
                                break;
                            case 'zeroheight' /*case 'ZeroHeight'*/ :
                                break;
                            case 'viewablerange' /*case 'ViewableRange'*/ :
                                break;
                            case 'selection' /*case 'Selection'*/ :
                                break;
                            case 'protectcontents' /*case 'ProtectContents'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    /* PivotTable */ case 'pivottable' /*case 'PivotTable'*/ :
                    case 'pivotcache' /*case 'PivotCache'*/ :
                        switch(Rn[3]){
                            case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/ :
                                break;
                            case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/ :
                                break;
                            case 'compactrowindent' /*case 'CompactRowIndent'*/ :
                                break;
                            case 'location' /*case 'Location'*/ :
                                break;
                            case 'pivotfield' /*case 'PivotField'*/ :
                                break;
                            case 'orientation' /*case 'Orientation'*/ :
                                break;
                            case 'layoutform' /*case 'LayoutForm'*/ :
                                break;
                            case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/ :
                                break;
                            case 'layoutcompactrow' /*case 'LayoutCompactRow'*/ :
                                break;
                            case 'position' /*case 'Position'*/ :
                                break;
                            case 'pivotitem' /*case 'PivotItem'*/ :
                                break;
                            case 'datatype' /*case 'DataType'*/ :
                                break;
                            case 'datafield' /*case 'DataField'*/ :
                                break;
                            case 'sourcename' /*case 'SourceName'*/ :
                                break;
                            case 'parentfield' /*case 'ParentField'*/ :
                                break;
                            case 'ptlineitems' /*case 'PTLineItems'*/ :
                                break;
                            case 'ptlineitem' /*case 'PTLineItem'*/ :
                                break;
                            case 'countofsameitems' /*case 'CountOfSameItems'*/ :
                                break;
                            case 'item' /*case 'Item'*/ :
                                break;
                            case 'itemtype' /*case 'ItemType'*/ :
                                break;
                            case 'ptsource' /*case 'PTSource'*/ :
                                break;
                            case 'cacheindex' /*case 'CacheIndex'*/ :
                                break;
                            case 'consolidationreference' /*case 'ConsolidationReference'*/ :
                                break;
                            case 'filename' /*case 'FileName'*/ :
                                break;
                            case 'reference' /*case 'Reference'*/ :
                                break;
                            case 'nocolumngrand' /*case 'NoColumnGrand'*/ :
                                break;
                            case 'norowgrand' /*case 'NoRowGrand'*/ :
                                break;
                            case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/ :
                                break;
                            case 'hidden' /*case 'Hidden'*/ :
                                break;
                            case 'subtotal' /*case 'Subtotal'*/ :
                                break;
                            case 'basefield' /*case 'BaseField'*/ :
                                break;
                            case 'mapchilditems' /*case 'MapChildItems'*/ :
                                break;
                            case 'function' /*case 'Function'*/ :
                                break;
                            case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/ :
                                break;
                            case 'printsettitles' /*case 'PrintSetTitles'*/ :
                                break;
                            case 'mergelabels' /*case 'MergeLabels'*/ :
                                break;
                            case 'defaultversion' /*case 'DefaultVersion'*/ :
                                break;
                            case 'refreshname' /*case 'RefreshName'*/ :
                                break;
                            case 'refreshdate' /*case 'RefreshDate'*/ :
                                break;
                            case 'refreshdatecopy' /*case 'RefreshDateCopy'*/ :
                                break;
                            case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                                break;
                            case 'versionlastupdate' /*case 'VersionLastUpdate'*/ :
                                break;
                            case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/ :
                                break;
                            case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/ :
                                break;
                            case 'calculation' /*case 'Calculation'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    /* PageBreaks */ case 'pagebreaks' /*case 'PageBreaks'*/ :
                        switch(Rn[3]){
                            case 'colbreaks' /*case 'ColBreaks'*/ :
                                break;
                            case 'colbreak' /*case 'ColBreak'*/ :
                                break;
                            case 'rowbreaks' /*case 'RowBreaks'*/ :
                                break;
                            case 'rowbreak' /*case 'RowBreak'*/ :
                                break;
                            case 'colstart' /*case 'ColStart'*/ :
                                break;
                            case 'colend' /*case 'ColEnd'*/ :
                                break;
                            case 'rowend' /*case 'RowEnd'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    /* AutoFilter */ case 'autofilter' /*case 'AutoFilter'*/ :
                        switch(Rn[3]){
                            case 'autofiltercolumn' /*case 'AutoFilterColumn'*/ :
                                break;
                            case 'autofiltercondition' /*case 'AutoFilterCondition'*/ :
                                break;
                            case 'autofilterand' /*case 'AutoFilterAnd'*/ :
                                break;
                            case 'autofilteror' /*case 'AutoFilterOr'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    /* QueryTable */ case 'querytable' /*case 'QueryTable'*/ :
                        switch(Rn[3]){
                            case 'id' /*case 'Id'*/ :
                                break;
                            case 'autoformatfont' /*case 'AutoFormatFont'*/ :
                                break;
                            case 'autoformatpattern' /*case 'AutoFormatPattern'*/ :
                                break;
                            case 'querysource' /*case 'QuerySource'*/ :
                                break;
                            case 'querytype' /*case 'QueryType'*/ :
                                break;
                            case 'enableredirections' /*case 'EnableRedirections'*/ :
                                break;
                            case 'refreshedinxl9' /*case 'RefreshedInXl9'*/ :
                                break;
                            case 'urlstring' /*case 'URLString'*/ :
                                break;
                            case 'htmltables' /*case 'HTMLTables'*/ :
                                break;
                            case 'connection' /*case 'Connection'*/ :
                                break;
                            case 'commandtext' /*case 'CommandText'*/ :
                                break;
                            case 'refreshinfo' /*case 'RefreshInfo'*/ :
                                break;
                            case 'notitles' /*case 'NoTitles'*/ :
                                break;
                            case 'nextid' /*case 'NextId'*/ :
                                break;
                            case 'columninfo' /*case 'ColumnInfo'*/ :
                                break;
                            case 'overwritecells' /*case 'OverwriteCells'*/ :
                                break;
                            case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/ :
                                break;
                            case 'textwizardsettings' /*case 'TextWizardSettings'*/ :
                                break;
                            case 'source' /*case 'Source'*/ :
                                break;
                            case 'number' /*case 'Number'*/ :
                                break;
                            case 'decimal' /*case 'Decimal'*/ :
                                break;
                            case 'thousandseparator' /*case 'ThousandSeparator'*/ :
                                break;
                            case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/ :
                                break;
                            case 'formatsettings' /*case 'FormatSettings'*/ :
                                break;
                            case 'fieldtype' /*case 'FieldType'*/ :
                                break;
                            case 'delimiters' /*case 'Delimiters'*/ :
                                break;
                            case 'tab' /*case 'Tab'*/ :
                                break;
                            case 'comma' /*case 'Comma'*/ :
                                break;
                            case 'autoformatname' /*case 'AutoFormatName'*/ :
                                break;
                            case 'versionlastedit' /*case 'VersionLastEdit'*/ :
                                break;
                            case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    case 'datavalidation' /*case 'DataValidation'*/ :
                        switch(Rn[3]){
                            case 'range' /*case 'Range'*/ :
                                break;
                            case 'type' /*case 'Type'*/ :
                                break;
                            case 'min' /*case 'Min'*/ :
                                break;
                            case 'max' /*case 'Max'*/ :
                                break;
                            case 'sort' /*case 'Sort'*/ :
                                break;
                            case 'descending' /*case 'Descending'*/ :
                                break;
                            case 'order' /*case 'Order'*/ :
                                break;
                            case 'casesensitive' /*case 'CaseSensitive'*/ :
                                break;
                            case 'value' /*case 'Value'*/ :
                                break;
                            case 'errorstyle' /*case 'ErrorStyle'*/ :
                                break;
                            case 'errormessage' /*case 'ErrorMessage'*/ :
                                break;
                            case 'errortitle' /*case 'ErrorTitle'*/ :
                                break;
                            case 'inputmessage' /*case 'InputMessage'*/ :
                                break;
                            case 'inputtitle' /*case 'InputTitle'*/ :
                                break;
                            case 'combohide' /*case 'ComboHide'*/ :
                                break;
                            case 'inputhide' /*case 'InputHide'*/ :
                                break;
                            case 'condition' /*case 'Condition'*/ :
                                break;
                            case 'qualifier' /*case 'Qualifier'*/ :
                                break;
                            case 'useblank' /*case 'UseBlank'*/ :
                                break;
                            case 'value1' /*case 'Value1'*/ :
                                break;
                            case 'value2' /*case 'Value2'*/ :
                                break;
                            case 'format' /*case 'Format'*/ :
                                break;
                            case 'cellrangelist' /*case 'CellRangeList'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    case 'sorting' /*case 'Sorting'*/ :
                    case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
                        switch(Rn[3]){
                            case 'range' /*case 'Range'*/ :
                                break;
                            case 'type' /*case 'Type'*/ :
                                break;
                            case 'min' /*case 'Min'*/ :
                                break;
                            case 'max' /*case 'Max'*/ :
                                break;
                            case 'sort' /*case 'Sort'*/ :
                                break;
                            case 'descending' /*case 'Descending'*/ :
                                break;
                            case 'order' /*case 'Order'*/ :
                                break;
                            case 'casesensitive' /*case 'CaseSensitive'*/ :
                                break;
                            case 'value' /*case 'Value'*/ :
                                break;
                            case 'errorstyle' /*case 'ErrorStyle'*/ :
                                break;
                            case 'errormessage' /*case 'ErrorMessage'*/ :
                                break;
                            case 'errortitle' /*case 'ErrorTitle'*/ :
                                break;
                            case 'cellrangelist' /*case 'CellRangeList'*/ :
                                break;
                            case 'inputmessage' /*case 'InputMessage'*/ :
                                break;
                            case 'inputtitle' /*case 'InputTitle'*/ :
                                break;
                            case 'combohide' /*case 'ComboHide'*/ :
                                break;
                            case 'inputhide' /*case 'InputHide'*/ :
                                break;
                            case 'condition' /*case 'Condition'*/ :
                                break;
                            case 'qualifier' /*case 'Qualifier'*/ :
                                break;
                            case 'useblank' /*case 'UseBlank'*/ :
                                break;
                            case 'value1' /*case 'Value1'*/ :
                                break;
                            case 'value2' /*case 'Value2'*/ :
                                break;
                            case 'format' /*case 'Format'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    /* MapInfo (schema) */ case 'mapinfo' /*case 'MapInfo'*/ :
                    case 'schema' /*case 'Schema'*/ :
                    case 'data' /*case 'data'*/ :
                        switch(Rn[3]){
                            case 'map' /*case 'Map'*/ :
                                break;
                            case 'entry' /*case 'Entry'*/ :
                                break;
                            case 'range' /*case 'Range'*/ :
                                break;
                            case 'xpath' /*case 'XPath'*/ :
                                break;
                            case 'field' /*case 'Field'*/ :
                                break;
                            case 'xsdtype' /*case 'XSDType'*/ :
                                break;
                            case 'filteron' /*case 'FilterOn'*/ :
                                break;
                            case 'aggregate' /*case 'Aggregate'*/ :
                                break;
                            case 'elementtype' /*case 'ElementType'*/ :
                                break;
                            case 'attributetype' /*case 'AttributeType'*/ :
                                break;
                            /* These are from xsd (XML Schema Definition) */ case 'schema' /*case 'schema'*/ :
                            case 'element' /*case 'element'*/ :
                            case 'complextype' /*case 'complexType'*/ :
                            case 'datatype' /*case 'datatype'*/ :
                            case 'all' /*case 'all'*/ :
                            case 'attribute' /*case 'attribute'*/ :
                            case 'extends' /*case 'extends'*/ :
                                break;
                            case 'row' /*case 'row'*/ :
                                break;
                            default:
                                seen = false;
                        }
                        break;
                    /* SmartTags (can be anything) */ case 'smarttags' /*case 'SmartTags'*/ :
                        break;
                    default:
                        seen = false;
                        break;
                }
                if (seen) break;
                /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
                if (!state[state.length - 1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
                if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ 'customdocumentproperties') {
                    if (Rn[0].slice(-2) === "/>") break;
                    else if (Rn[1] === "/") xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                    else {
                        cp = Rn;
                        pidx = Rn.index + Rn[0].length;
                    }
                    break;
                }
                if (opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
        }
        var out = {};
        if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
        out.SheetNames = sheetnames;
        out.Workbook = Workbook;
        out.SSF = SSF.get_table();
        out.Props = Props;
        out.Custprops = Custprops;
        return out;
    }
    function parse_xlml(data, opts) {
        fix_read_opts(opts = opts || {});
        switch(opts.type || "base64"){
            case "base64":
                return parse_xlml_xml(Base64.decode(data), opts);
            case "binary":
            case "buffer":
            case "file":
                return parse_xlml_xml(data, opts);
            case "array":
                return parse_xlml_xml(a2s(data), opts);
        }
    }
    /* TODO */ function write_props_xlml(wb, opts) {
        var o = [];
        /* DocumentProperties */ if (wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
        /* CustomDocumentProperties */ if (wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
        return o.join("");
    }
    /* TODO */ function write_wb_xlml() {
        /* OfficeDocumentSettings */ /* ExcelWorkbook */ return "";
    }
    /* TODO */ function write_sty_xlml(wb, opts) {
        /* Styles */ var styles = [
            '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
        ];
        opts.cellXfs.forEach(function(xf, id) {
            var payload = [];
            payload.push(writextag('NumberFormat', null, {
                "ss:Format": escapexml(SSF._table[xf.numFmtId])
            }));
            var o = {
                "ss:ID": "s" + (21 + id)
            };
            styles.push(writextag('Style', payload.join(""), o));
        });
        return writextag("Styles", styles.join(""));
    }
    function write_name_xlml(n) {
        return writextag("NamedRange", null, {
            "ss:Name": n.Name,
            "ss:RefersTo": "=" + a1_to_rc(n.Ref, {
                r: 0,
                c: 0
            })
        });
    }
    function write_names_xlml(wb) {
        if (!((wb || {}).Workbook || {}).Names) return "";
        var names = wb.Workbook.Names;
        var out = [];
        for(var i = 0; i < names.length; ++i){
            var n = names[i];
            if (n.Sheet != null) continue;
            if (n.Name.match(/^_xlfn\./)) continue;
            out.push(write_name_xlml(n));
        }
        return writextag("Names", out.join(""));
    }
    function write_ws_xlml_names(ws, opts, idx, wb) {
        if (!ws) return "";
        if (!((wb || {}).Workbook || {}).Names) return "";
        var names = wb.Workbook.Names;
        var out = [];
        for(var i = 0; i < names.length; ++i){
            var n = names[i];
            if (n.Sheet != idx) continue;
            /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
            out.push(write_name_xlml(n));
        }
        return out.join("");
    }
    /* WorksheetOptions */ function write_ws_xlml_wsopts(ws, opts, idx, wb) {
        if (!ws) return "";
        var o = [];
        /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws['!margins']) {
            o.push("<PageSetup>");
            if (ws['!margins'].header) o.push(writextag("Header", null, {
                'x:Margin': ws['!margins'].header
            }));
            if (ws['!margins'].footer) o.push(writextag("Footer", null, {
                'x:Margin': ws['!margins'].footer
            }));
            o.push(writextag("PageMargins", null, {
                'x:Bottom': ws['!margins'].bottom || "0.75",
                'x:Left': ws['!margins'].left || "0.7",
                'x:Right': ws['!margins'].right || "0.7",
                'x:Top': ws['!margins'].top || "0.75"
            }));
            o.push("</PageSetup>");
        }
        /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
            /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
            else {
                /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
                if (i == idx) o.push("<Selected/>");
            }
        }
        /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
        /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws['!protect']) {
            o.push(writetag("ProtectContents", "True"));
            if (ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
            if (ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
            if (ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
            else if (ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
            [
                [
                    "formatCells",
                    "AllowFormatCells"
                ],
                [
                    "formatColumns",
                    "AllowSizeCols"
                ],
                [
                    "formatRows",
                    "AllowSizeRows"
                ],
                [
                    "insertColumns",
                    "AllowInsertCols"
                ],
                [
                    "insertRows",
                    "AllowInsertRows"
                ],
                [
                    "insertHyperlinks",
                    "AllowInsertHyperlinks"
                ],
                [
                    "deleteColumns",
                    "AllowDeleteCols"
                ],
                [
                    "deleteRows",
                    "AllowDeleteRows"
                ],
                [
                    "sort",
                    "AllowSort"
                ],
                [
                    "autoFilter",
                    "AllowFilter"
                ],
                [
                    "pivotTables",
                    "AllowUsePivotTables"
                ]
            ].forEach(function(x) {
                if (ws['!protect'][x[0]]) o.push("<" + x[1] + "/>");
            });
        }
        if (o.length == 0) return "";
        return writextag("WorksheetOptions", o.join(""), {
            xmlns: XLMLNS.x
        });
    }
    function write_ws_xlml_comment(comments) {
        return comments.map(function(c) {
            // TODO: formatted text
            var t = xlml_unfixstr(c.t || "");
            var d = writextag("ss:Data", t, {
                "xmlns": "http://www.w3.org/TR/REC-html40"
            });
            return writextag("Comment", d, {
                "ss:Author": c.a
            });
        }).join("");
    }
    function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr) {
        if (!cell || cell.v == undefined && cell.f == undefined) return "";
        var attr = {};
        if (cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
        if (cell.F && cell.F.slice(0, ref.length) == ref) {
            var end = decode_cell(cell.F.slice(ref.length + 1));
            attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
        }
        if (cell.l && cell.l.Target) {
            attr["ss:HRef"] = escapexml(cell.l.Target);
            if (cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
        }
        if (ws['!merges']) {
            var marr = ws['!merges'];
            for(var mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
                if (marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
                if (marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
            }
        }
        var t = "", p = "";
        switch(cell.t){
            case 'z':
                if (!opts.sheetStubs) return "";
                break;
            case 'n':
                t = 'Number';
                p = String(cell.v);
                break;
            case 'b':
                t = 'Boolean';
                p = cell.v ? "1" : "0";
                break;
            case 'e':
                t = 'Error';
                p = BErr[cell.v];
                break;
            case 'd':
                t = 'DateTime';
                p = new Date(cell.v).toISOString();
                if (cell.z == null) cell.z = cell.z || SSF._table[14];
                break;
            case 's':
                t = 'String';
                p = escapexlml(cell.v || "");
                break;
        }
        /* TODO: cell style */ var os = get_cell_style(opts.cellXfs, cell, opts);
        attr["ss:StyleID"] = "s" + (21 + os);
        attr["ss:Index"] = addr.c + 1;
        var _v = cell.v != null ? p : "";
        var m = cell.t == 'z' ? "" : '<Data ss:Type="' + t + '">' + _v + '</Data>';
        if ((cell.c || []).length > 0) m += write_ws_xlml_comment(cell.c);
        return writextag("Cell", m, attr);
    }
    function write_ws_xlml_row(R, row) {
        var o = '<Row ss:Index="' + (R + 1) + '"';
        if (row) {
            if (row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
            if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
            if (row.hidden) o += ' ss:Hidden="1"';
        }
        return o + '>';
    }
    /* TODO */ function write_ws_xlml_table(ws, opts, idx, wb) {
        if (!ws['!ref']) return "";
        var range = safe_decode_range(ws['!ref']);
        var marr = ws['!merges'] || [], mi = 0;
        var o = [];
        if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
            process_col(n);
            var w = !!n.width;
            var p = col_obj_w(i, n);
            var k = {
                "ss:Index": i + 1
            };
            if (w) k['ss:Width'] = width2px(p.width);
            if (n.hidden) k['ss:Hidden'] = "1";
            o.push(writextag("Column", null, k));
        });
        var dense = Array.isArray(ws);
        for(var R = range.s.r; R <= range.e.r; ++R){
            var row = [
                write_ws_xlml_row(R, (ws['!rows'] || [])[R])
            ];
            for(var C = range.s.c; C <= range.e.c; ++C){
                var skip = false;
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    break;
                }
                if (skip) continue;
                var addr = {
                    r: R,
                    c: C
                };
                var ref = encode_cell(addr), cell = dense ? (ws[R] || [])[C] : ws[ref];
                row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
            }
            row.push("</Row>");
            if (row.length > 2) o.push(row.join(""));
        }
        return o.join("");
    }
    function write_ws_xlml(idx, opts, wb) {
        var o = [];
        var s = wb.SheetNames[idx];
        var ws = wb.Sheets[s];
        var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
        if (t.length > 0) o.push("<Names>" + t + "</Names>");
        /* Table */ t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
        if (t.length > 0) o.push("<Table>" + t + "</Table>");
        /* WorksheetOptions */ o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));
        return o.join("");
    }
    function write_xlml(wb, opts) {
        if (!opts) opts = {};
        if (!wb.SSF) wb.SSF = SSF.get_table();
        if (wb.SSF) {
            make_ssf(SSF);
            SSF.load_table(wb.SSF);
            // $FlowIgnore
            opts.revssf = evert_num(wb.SSF);
            opts.revssf[wb.SSF[65535]] = 0;
            opts.ssf = wb.SSF;
            opts.cellXfs = [];
            get_cell_style(opts.cellXfs, {}, {
                revssf: {
                    "General": 0
                }
            });
        }
        var d = [];
        d.push(write_props_xlml(wb, opts));
        d.push(write_wb_xlml(wb, opts));
        d.push("");
        d.push("");
        for(var i = 0; i < wb.SheetNames.length; ++i)d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {
            "ss:Name": escapexml(wb.SheetNames[i])
        }));
        d[2] = write_sty_xlml(wb, opts);
        d[3] = write_names_xlml(wb, opts);
        return XML_HEADER + writextag("Workbook", d.join(""), {
            'xmlns': XLMLNS.ss,
            'xmlns:o': XLMLNS.o,
            'xmlns:x': XLMLNS.x,
            'xmlns:ss': XLMLNS.ss,
            'xmlns:dt': XLMLNS.dt,
            'xmlns:html': XLMLNS.html
        });
    }
    /* [MS-OLEDS] 2.3.8 CompObjStream */ function parse_compobj(obj) {
        var v = {};
        var o = obj.content;
        /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
        v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
        v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);
        if (o.length - o.l <= 4) return v;
        var m = o.read_shift(4);
        if (m == 0 || m > 40) return v;
        o.l -= 4;
        v.Reserved1 = o.read_shift(0, "lpstr-ansi");
        if (o.length - o.l <= 4) return v;
        m = o.read_shift(4);
        if (m !== 0x71b239f4) return v;
        v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);
        m = o.read_shift(4);
        if (m == 0 || m > 40) return v;
        o.l -= 4;
        v.Reserved2 = o.read_shift(0, "lpwstr");
    }
    /*
	Continue logic for:
	- 2.4.58 Continue
	- 2.4.59 ContinueBigName
	- 2.4.60 ContinueFrt
	- 2.4.61 ContinueFrt11
	- 2.4.62 ContinueFrt12
*/ function slurp(R, blob, length, opts) {
        var l = length;
        var bufs = [];
        var d = blob.slice(blob.l, blob.l + l);
        if (opts && opts.enc && opts.enc.insitu) switch(R.n){
            case 'BOF':
            case 'FilePass':
            case 'FileLock':
            case 'InterfaceHdr':
            case 'RRDInfo':
            case 'RRDHead':
            case 'UsrExcl':
                break;
            default:
                if (d.length === 0) break;
                opts.enc.insitu(d);
        }
        bufs.push(d);
        blob.l += l;
        var next = XLSRecordEnum[__readUInt16LE(blob, blob.l)];
        var start = 0;
        while(next != null && next.n.slice(0, 8) === 'Continue'){
            l = __readUInt16LE(blob, blob.l + 2);
            start = blob.l + 4;
            if (next.n == 'ContinueFrt') start += 4;
            else if (next.n.slice(0, 11) == 'ContinueFrt') start += 12;
            bufs.push(blob.slice(start, blob.l + 4 + l));
            blob.l += 4 + l;
            next = XLSRecordEnum[__readUInt16LE(blob, blob.l)];
        }
        var b = bconcat(bufs);
        prep_blob(b, 0);
        var ll = 0;
        b.lens = [];
        for(var j = 0; j < bufs.length; ++j){
            b.lens.push(ll);
            ll += bufs[j].length;
        }
        return R.f(b, b.length, opts);
    }
    function safe_format_xf(p, opts, date1904) {
        if (p.t === 'z') return;
        if (!p.XF) return;
        var fmtid = 0;
        try {
            fmtid = p.z || p.XF.numFmtId || 0;
            if (opts.cellNF) p.z = SSF._table[fmtid];
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (!opts || opts.cellText !== false) try {
            if (p.t === 'e') p.w = p.w || BErr[p.v];
            else if (fmtid === 0 || fmtid == "General") {
                if (p.t === 'n') {
                    if ((p.v | 0) === p.v) p.w = SSF._general_int(p.v);
                    else p.w = SSF._general_num(p.v);
                } else p.w = SSF._general(p.v);
            } else p.w = SSF.format(fmtid, p.v, {
                date1904: !!date1904
            });
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellDates && fmtid && p.t == 'n' && SSF.is_date(SSF._table[fmtid] || String(fmtid))) {
            var _d = SSF.parse_date_code(p.v);
            if (_d) {
                p.t = 'd';
                p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
            }
        }
    }
    function make_cell(val, ixfe, t) {
        return {
            v: val,
            ixfe: ixfe,
            t: t
        };
    }
    // 2.3.2
    function parse_workbook(blob, options) {
        var wb = {
            opts: {}
        };
        var Sheets = {};
        if (DENSE != null && options.dense == null) options.dense = DENSE;
        var out = options.dense ? [] : {};
        var Directory = {};
        var range = {};
        var last_formula = null;
        var sst = [];
        var cur_sheet = "";
        var Preamble = {};
        var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
        var sharedf = {};
        var arrayf = [];
        var temp_val;
        var country;
        var cell_valid = true;
        var XFs = []; /* XF records */ 
        var palette = [];
        var Workbook = {
            Sheets: [],
            WBProps: {
                date1904: false
            },
            Views: [
                {}
            ]
        }, wsprops = {};
        var get_rgb = function getrgb(icv) {
            if (icv < 8) return XLSIcv[icv];
            if (icv < 64) return palette[icv - 8] || XLSIcv[icv];
            return XLSIcv[icv];
        };
        var process_cell_style = function pcs(cell, line, options) {
            var xfd = line.XF.data;
            if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
            line.s = {};
            line.s.patternType = xfd.patternType;
            var t;
            if (t = rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
                rgb: t
            };
            if (t = rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
                rgb: t
            };
        };
        var addcell = function addcell(cell, line, options) {
            if (file_depth > 1) return;
            if (options.sheetRows && cell.r >= options.sheetRows) cell_valid = false;
            if (!cell_valid) return;
            if (options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
            delete line.ixfe;
            delete line.XF;
            lastcell = cell;
            last_cell = encode_cell(cell);
            if (!range || !range.s || !range.e) range = {
                s: {
                    r: 0,
                    c: 0
                },
                e: {
                    r: 0,
                    c: 0
                }
            };
            if (cell.r < range.s.r) range.s.r = cell.r;
            if (cell.c < range.s.c) range.s.c = cell.c;
            if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
            if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
            if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
                if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
                if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
                line.F = encode_range(arrayf[afi][0]);
                if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
                if (line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
                break;
            }
            if (options.dense) {
                if (!out[cell.r]) out[cell.r] = [];
                out[cell.r][cell.c] = line;
            } else out[last_cell] = line;
        };
        var opts = {
            enc: false,
            sbcch: 0,
            snames: [],
            sharedf: sharedf,
            arrayf: arrayf,
            rrtabid: [],
            lastuser: "",
            biff: 8,
            codepage: 0,
            winlocked: 0,
            cellStyles: !!options && !!options.cellStyles,
            WTF: !!options && !!options.wtf
        };
        if (options.password) opts.password = options.password;
        var themes;
        var merges = [];
        var objects = [];
        var colinfo = [], rowinfo = [];
        // eslint-disable-next-line no-unused-vars
        var defwidth = 0, defheight = 0; // twips / MDW respectively
        var seencol = false;
        var supbooks = []; // 1-indexed, will hold extern names
        supbooks.SheetNames = opts.snames;
        supbooks.sharedf = opts.sharedf;
        supbooks.arrayf = opts.arrayf;
        supbooks.names = [];
        supbooks.XTI = [];
        var last_Rn = '';
        var file_depth = 0; /* TODO: make a real stack */ 
        var BIFF2Fmt = 0, BIFF2FmtTable = [];
        var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
        var last_lbl;
        /* explicit override for some broken writers */ opts.codepage = 1200;
        set_cp(1200);
        var seen_codepage = false;
        while(blob.l < blob.length - 1){
            var s = blob.l;
            var RecordType = blob.read_shift(2);
            if (RecordType === 0 && last_Rn === 'EOF') break;
            var length = blob.l === blob.length ? 0 : blob.read_shift(2);
            var R = XLSRecordEnum[RecordType];
            //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
            //if(!R) console.log(blob.slice(blob.l, blob.l + length));
            if (R && R.f) {
                if (options.bookSheets) {
                    if (last_Rn === 'BoundSheet8' && R.n !== 'BoundSheet8') break;
                }
                last_Rn = R.n;
                if (R.r === 2 || R.r == 12) {
                    var rt = blob.read_shift(2);
                    length -= 2;
                    if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                    if (R.r == 12) {
                        blob.l += 10;
                        length -= 10;
                    } // skip FRT
                }
                //console.error(R,blob.l,length,blob.length);
                var val = {};
                if (R.n === 'EOF') val = R.f(blob, length, opts);
                else val = slurp(R, blob, length, opts);
                var Rn = R.n;
                if (file_depth == 0 && Rn != 'BOF') continue;
                /* nested switch statements to workaround V8 128 limit */ switch(Rn){
                    /* Workbook Options */ case 'Date1904':
                        wb.opts.Date1904 = Workbook.WBProps.date1904 = val;
                        break;
                    case 'WriteProtect':
                        wb.opts.WriteProtect = true;
                        break;
                    case 'FilePass':
                        if (!opts.enc) blob.l = 0;
                        opts.enc = val;
                        if (!options.password) throw new Error("File is password-protected");
                        if (val.valid == null) throw new Error("Encryption scheme unsupported");
                        if (!val.valid) throw new Error("Password is incorrect");
                        break;
                    case 'WriteAccess':
                        opts.lastuser = val;
                        break;
                    case 'FileSharing':
                        break; //TODO
                    case 'CodePage':
                        var cpval = Number(val);
                        /* overrides based on test cases */ switch(cpval){
                            case 0x5212:
                                cpval = 1200;
                                break;
                            case 0x8000:
                                cpval = 10000;
                                break;
                            case 0x8001:
                                cpval = 1252;
                                break;
                        }
                        set_cp(opts.codepage = cpval);
                        seen_codepage = true;
                        break;
                    case 'RRTabId':
                        opts.rrtabid = val;
                        break;
                    case 'WinProtect':
                        opts.winlocked = val;
                        break;
                    case 'Template':
                        break; // TODO
                    case 'BookBool':
                        break; // TODO
                    case 'UsesELFs':
                        break;
                    case 'MTRSettings':
                        break;
                    case 'RefreshAll':
                    case 'CalcCount':
                    case 'CalcDelta':
                    case 'CalcIter':
                    case 'CalcMode':
                    case 'CalcPrecision':
                    case 'CalcSaveRecalc':
                        wb.opts[Rn] = val;
                        break;
                    case 'CalcRefMode':
                        opts.CalcRefMode = val;
                        break; // TODO: implement R1C1
                    case 'Uncalced':
                        break;
                    case 'ForceFullCalculation':
                        wb.opts.FullCalc = val;
                        break;
                    case 'WsBool':
                        if (val.fDialog) out["!type"] = "dialog";
                        break; // TODO
                    case 'XF':
                        XFs.push(val);
                        break;
                    case 'ExtSST':
                        break; // TODO
                    case 'BookExt':
                        break; // TODO
                    case 'RichTextStream':
                        break;
                    case 'BkHim':
                        break;
                    case 'SupBook':
                        supbooks.push([
                            val
                        ]);
                        supbooks[supbooks.length - 1].XTI = [];
                        break;
                    case 'ExternName':
                        supbooks[supbooks.length - 1].push(val);
                        break;
                    case 'Index':
                        break; // TODO
                    case 'Lbl':
                        last_lbl = {
                            Name: val.Name,
                            Ref: stringify_formula(val.rgce, range, null, supbooks, opts)
                        };
                        if (val.itab > 0) last_lbl.Sheet = val.itab - 1;
                        supbooks.names.push(last_lbl);
                        if (!supbooks[0]) {
                            supbooks[0] = [];
                            supbooks[0].XTI = [];
                        }
                        supbooks[supbooks.length - 1].push(val);
                        if (val.Name == "_xlnm._FilterDatabase" && val.itab > 0) {
                            if (val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d') FilterDatabases[val.itab - 1] = {
                                ref: encode_range(val.rgce[0][0][1][2])
                            };
                        }
                        break;
                    case 'ExternCount':
                        opts.ExternCount = val;
                        break;
                    case 'ExternSheet':
                        if (supbooks.length == 0) {
                            supbooks[0] = [];
                            supbooks[0].XTI = [];
                        }
                        supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                        supbooks.XTI = supbooks.XTI.concat(val);
                        break;
                    case 'NameCmt':
                        /* TODO: search for correct name */ if (opts.biff < 8) break;
                        if (last_lbl != null) last_lbl.Comment = val[1];
                        break;
                    case 'Protect':
                        out["!protect"] = val;
                        break; /* for sheet or book */ 
                    case 'Password':
                        if (val !== 0 && opts.WTF) console.error("Password verifier: " + val);
                        break;
                    case 'Prot4Rev':
                    case 'Prot4RevPass':
                        break; /*TODO: Revision Control*/ 
                    case 'BoundSheet8':
                        Directory[val.pos] = val;
                        opts.snames.push(val.name);
                        break;
                    case 'EOF':
                        if (--file_depth) break;
                        if (range.e) {
                            if (range.e.r > 0 && range.e.c > 0) {
                                range.e.r--;
                                range.e.c--;
                                out["!ref"] = encode_range(range);
                                if (options.sheetRows && options.sheetRows <= range.e.r) {
                                    var tmpri = range.e.r;
                                    range.e.r = options.sheetRows - 1;
                                    out["!fullref"] = out["!ref"];
                                    out["!ref"] = encode_range(range);
                                    range.e.r = tmpri;
                                }
                                range.e.r++;
                                range.e.c++;
                            }
                            if (merges.length > 0) out["!merges"] = merges;
                            if (objects.length > 0) out["!objects"] = objects;
                            if (colinfo.length > 0) out["!cols"] = colinfo;
                            if (rowinfo.length > 0) out["!rows"] = rowinfo;
                            Workbook.Sheets.push(wsprops);
                        }
                        if (cur_sheet === "") Preamble = out;
                        else Sheets[cur_sheet] = out;
                        out = options.dense ? [] : {};
                        break;
                    case 'BOF':
                        if (opts.biff === 8) opts.biff = ({
                            0x0009: 2,
                            0x0209: 3,
                            0x0409: 4
                        })[RecordType] || ({
                            0x0200: 2,
                            0x0300: 3,
                            0x0400: 4,
                            0x0500: 5,
                            0x0600: 8,
                            0x0002: 2,
                            0x0007: 2
                        })[val.BIFFVer] || 8;
                        if (opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
                        if (file_depth++) break;
                        cell_valid = true;
                        out = options.dense ? [] : {};
                        if (opts.biff < 8 && !seen_codepage) {
                            seen_codepage = true;
                            set_cp(opts.codepage = options.codepage || 1252);
                        }
                        if (opts.biff < 5) {
                            if (cur_sheet === "") cur_sheet = "Sheet1";
                            range = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            /* fake BoundSheet8 */ var fakebs8 = {
                                pos: blob.l - length,
                                name: cur_sheet
                            };
                            Directory[fakebs8.pos] = fakebs8;
                            opts.snames.push(cur_sheet);
                        } else cur_sheet = (Directory[s] || {
                            name: ""
                        }).name;
                        if (val.dt == 0x20) out["!type"] = "chart";
                        if (val.dt == 0x40) out["!type"] = "macro";
                        merges = [];
                        objects = [];
                        opts.arrayf = arrayf = [];
                        colinfo = [];
                        rowinfo = [];
                        defwidth = defheight = 0;
                        seencol = false;
                        wsprops = {
                            Hidden: (Directory[s] || {
                                hs: 0
                            }).hs,
                            name: cur_sheet
                        };
                        break;
                    case 'Number':
                    case 'BIFF2NUM':
                    case 'BIFF2INT':
                        if (out["!type"] == "chart") {
                            if (options.dense ? (out[val.r] || [])[val.c] : out[encode_cell({
                                c: val.c,
                                r: val.r
                            })]) ++val.c;
                        }
                        temp_val = {
                            ixfe: val.ixfe,
                            XF: XFs[val.ixfe] || {},
                            v: val.val,
                            t: 'n'
                        };
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x1F];
                        safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                        break;
                    case 'BoolErr':
                        temp_val = {
                            ixfe: val.ixfe,
                            XF: XFs[val.ixfe],
                            v: val.val,
                            t: val.t
                        };
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x1F];
                        safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                        break;
                    case 'RK':
                        temp_val = {
                            ixfe: val.ixfe,
                            XF: XFs[val.ixfe],
                            v: val.rknum,
                            t: 'n'
                        };
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x1F];
                        safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                        break;
                    case 'MulRk':
                        for(var j = val.c; j <= val.C; ++j){
                            var ixfe = val.rkrec[j - val.c][0];
                            temp_val = {
                                ixfe: ixfe,
                                XF: XFs[ixfe],
                                v: val.rkrec[j - val.c][1],
                                t: 'n'
                            };
                            if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x1F];
                            safe_format_xf(temp_val, options, wb.opts.Date1904);
                            addcell({
                                c: j,
                                r: val.r
                            }, temp_val, options);
                        }
                        break;
                    case 'Formula':
                        if (val.val == 'String') {
                            last_formula = val;
                            break;
                        }
                        temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) {
                            var _f = val.formula;
                            if (_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
                                var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                                var _fe = encode_cell({
                                    r: _fr,
                                    c: _fc
                                });
                                if (sharedf[_fe]) temp_val.f = "" + stringify_formula(val.formula, range, val.cell, supbooks, opts);
                                else temp_val.F = ((options.dense ? (out[_fr] || [])[_fc] : out[_fe]) || {}).F;
                            } else temp_val.f = "" + stringify_formula(val.formula, range, val.cell, supbooks, opts);
                        }
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x1F];
                        safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(val.cell, temp_val, options);
                        last_formula = val;
                        break;
                    case 'String':
                        if (last_formula) {
                            last_formula.val = val;
                            temp_val = make_cell(val, last_formula.cell.ixfe, 's');
                            temp_val.XF = XFs[temp_val.ixfe];
                            if (options.cellFormula) temp_val.f = "" + stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                            if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x1F];
                            safe_format_xf(temp_val, options, wb.opts.Date1904);
                            addcell(last_formula.cell, temp_val, options);
                            last_formula = null;
                        } else throw new Error("String record expects Formula");
                        break;
                    case 'Array':
                        arrayf.push(val);
                        var _arraystart = encode_cell(val[0].s);
                        cc = options.dense ? (out[val[0].s.r] || [])[val[0].s.c] : out[_arraystart];
                        if (options.cellFormula && cc) {
                            if (!last_formula) break; /* technically unreachable */ 
                            if (!_arraystart || !cc) break;
                            cc.f = "" + stringify_formula(val[1], range, val[0], supbooks, opts);
                            cc.F = encode_range(val[0]);
                        }
                        break;
                    case 'ShrFmla':
                        if (!cell_valid) break;
                        if (!options.cellFormula) break;
                        if (last_cell) {
                            /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                            sharedf[encode_cell(last_formula.cell)] = val[0];
                            cc = options.dense ? (out[last_formula.cell.r] || [])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
                            (cc || {}).f = "" + stringify_formula(val[0], range, lastcell, supbooks, opts);
                        }
                        break;
                    case 'LabelSst':
                        temp_val = make_cell(sst[val.isst].t, val.ixfe, 's');
                        if (sst[val.isst].h) temp_val.h = sst[val.isst].h;
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x1F];
                        safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                        break;
                    case 'Blank':
                        if (options.sheetStubs) {
                            temp_val = {
                                ixfe: val.ixfe,
                                XF: XFs[val.ixfe],
                                t: 'z'
                            };
                            if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x1F];
                            safe_format_xf(temp_val, options, wb.opts.Date1904);
                            addcell({
                                c: val.c,
                                r: val.r
                            }, temp_val, options);
                        }
                        break;
                    case 'MulBlank':
                        if (options.sheetStubs) for(var _j = val.c; _j <= val.C; ++_j){
                            var _ixfe = val.ixfe[_j - val.c];
                            temp_val = {
                                ixfe: _ixfe,
                                XF: XFs[_ixfe],
                                t: 'z'
                            };
                            if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x1F];
                            safe_format_xf(temp_val, options, wb.opts.Date1904);
                            addcell({
                                c: _j,
                                r: val.r
                            }, temp_val, options);
                        }
                        break;
                    case 'RString':
                    case 'Label':
                    case 'BIFF2STR':
                        temp_val = make_cell(val.val, val.ixfe, 's');
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x1F];
                        safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                        break;
                    case 'Dimensions':
                        if (file_depth === 1) range = val; /* TODO: stack */ 
                        break;
                    case 'SST':
                        sst = val;
                        break;
                    case 'Format':
                        if (opts.biff == 4) {
                            BIFF2FmtTable[BIFF2Fmt++] = val[1];
                            for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if (SSF._table[b4idx] == val[1]) break;
                            if (b4idx >= 163) SSF.load(val[1], BIFF2Fmt + 163);
                        } else SSF.load(val[1], val[0]);
                        break;
                    case 'BIFF2FORMAT':
                        BIFF2FmtTable[BIFF2Fmt++] = val;
                        for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if (SSF._table[b2idx] == val) break;
                        if (b2idx >= 163) SSF.load(val, BIFF2Fmt + 163);
                        break;
                    case 'MergeCells':
                        merges = merges.concat(val);
                        break;
                    case 'Obj':
                        objects[val.cmo[0]] = opts.lastobj = val;
                        break;
                    case 'TxO':
                        opts.lastobj.TxO = val;
                        break;
                    case 'ImData':
                        opts.lastobj.ImData = val;
                        break;
                    case 'HLink':
                        for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                            cc = options.dense ? (out[rngR] || [])[rngC] : out[encode_cell({
                                c: rngC,
                                r: rngR
                            })];
                            if (cc) cc.l = val[1];
                        }
                        break;
                    case 'HLinkTooltip':
                        for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                            cc = options.dense ? (out[rngR] || [])[rngC] : out[encode_cell({
                                c: rngC,
                                r: rngR
                            })];
                            if (cc && cc.l) cc.l.Tooltip = val[1];
                        }
                        break;
                    /* Comments */ case 'Note':
                        if (opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */ 
                        cc = options.dense ? (out[val[0].r] || [])[val[0].c] : out[encode_cell(val[0])];
                        var noteobj = objects[val[2]];
                        if (!cc) {
                            if (options.dense) {
                                if (!out[val[0].r]) out[val[0].r] = [];
                                cc = out[val[0].r][val[0].c] = {
                                    t: "z"
                                };
                            } else cc = out[encode_cell(val[0])] = {
                                t: "z"
                            };
                            range.e.r = Math.max(range.e.r, val[0].r);
                            range.s.r = Math.min(range.s.r, val[0].r);
                            range.e.c = Math.max(range.e.c, val[0].c);
                            range.s.c = Math.min(range.s.c, val[0].c);
                        }
                        if (!cc.c) cc.c = [];
                        cmnt = {
                            a: val[1],
                            t: noteobj.TxO.t
                        };
                        cc.c.push(cmnt);
                        break;
                    default:
                        switch(R.n){
                            case 'ClrtClient':
                                break;
                            case 'XFExt':
                                update_xfext(XFs[val.ixfe], val.ext);
                                break;
                            case 'DefColWidth':
                                defwidth = val;
                                break;
                            case 'DefaultRowHeight':
                                defheight = val[1];
                                break; // TODO: flags
                            case 'ColInfo':
                                if (!opts.cellStyles) break;
                                while(val.e >= val.s){
                                    colinfo[val.e--] = {
                                        width: val.w / 256
                                    };
                                    if (!seencol) {
                                        seencol = true;
                                        find_mdw_colw(val.w / 256);
                                    }
                                    process_col(colinfo[val.e + 1]);
                                }
                                break;
                            case 'Row':
                                var rowobj = {};
                                if (val.level != null) {
                                    rowinfo[val.r] = rowobj;
                                    rowobj.level = val.level;
                                }
                                if (val.hidden) {
                                    rowinfo[val.r] = rowobj;
                                    rowobj.hidden = true;
                                }
                                if (val.hpt) {
                                    rowinfo[val.r] = rowobj;
                                    rowobj.hpt = val.hpt;
                                    rowobj.hpx = pt2px(val.hpt);
                                }
                                break;
                            case 'LeftMargin':
                            case 'RightMargin':
                            case 'TopMargin':
                            case 'BottomMargin':
                                if (!out['!margins']) default_margins(out['!margins'] = {});
                                out['!margins'][Rn.slice(0, -6).toLowerCase()] = val;
                                break;
                            case 'Setup':
                                if (!out['!margins']) default_margins(out['!margins'] = {});
                                out['!margins'].header = val.header;
                                out['!margins'].footer = val.footer;
                                break;
                            case 'Window2':
                                // $FlowIgnore
                                if (val.RTL) Workbook.Views[0].RTL = true;
                                break;
                            case 'Header':
                                break; // TODO
                            case 'Footer':
                                break; // TODO
                            case 'HCenter':
                                break; // TODO
                            case 'VCenter':
                                break; // TODO
                            case 'Pls':
                                break; // TODO
                            case 'GCW':
                                break;
                            case 'LHRecord':
                                break;
                            case 'DBCell':
                                break; // TODO
                            case 'EntExU2':
                                break; // TODO
                            case 'SxView':
                                break; // TODO
                            case 'Sxvd':
                                break; // TODO
                            case 'SXVI':
                                break; // TODO
                            case 'SXVDEx':
                                break; // TODO
                            case 'SxIvd':
                                break; // TODO
                            case 'SXString':
                                break; // TODO
                            case 'Sync':
                                break;
                            case 'Addin':
                                break;
                            case 'SXDI':
                                break; // TODO
                            case 'SXLI':
                                break; // TODO
                            case 'SXEx':
                                break; // TODO
                            case 'QsiSXTag':
                                break; // TODO
                            case 'Selection':
                                break;
                            case 'Feat':
                                break;
                            case 'FeatHdr':
                            case 'FeatHdr11':
                                break;
                            case 'Feature11':
                            case 'Feature12':
                            case 'List12':
                                break;
                            case 'Country':
                                country = val;
                                break;
                            case 'RecalcId':
                                break;
                            case 'DxGCol':
                                break; // TODO: htmlify
                            case 'Fbi':
                            case 'Fbi2':
                            case 'GelFrame':
                                break;
                            case 'Font':
                                break; // TODO
                            case 'XFCRC':
                                break; // TODO
                            case 'Style':
                                break; // TODO
                            case 'StyleExt':
                                break; // TODO
                            case 'Palette':
                                palette = val;
                                break;
                            case 'Theme':
                                themes = val;
                                break;
                            /* Protection */ case 'ScenarioProtect':
                                break;
                            case 'ObjProtect':
                                break;
                            /* Conditional Formatting */ case 'CondFmt12':
                                break;
                            /* Table */ case 'Table':
                                break; // TODO
                            case 'TableStyles':
                                break; // TODO
                            case 'TableStyle':
                                break; // TODO
                            case 'TableStyleElement':
                                break; // TODO
                            /* PivotTable */ case 'SXStreamID':
                                break; // TODO
                            case 'SXVS':
                                break; // TODO
                            case 'DConRef':
                                break; // TODO
                            case 'SXAddl':
                                break; // TODO
                            case 'DConBin':
                                break; // TODO
                            case 'DConName':
                                break; // TODO
                            case 'SXPI':
                                break; // TODO
                            case 'SxFormat':
                                break; // TODO
                            case 'SxSelect':
                                break; // TODO
                            case 'SxRule':
                                break; // TODO
                            case 'SxFilt':
                                break; // TODO
                            case 'SxItm':
                                break; // TODO
                            case 'SxDXF':
                                break; // TODO
                            /* Scenario Manager */ case 'ScenMan':
                                break;
                            /* Data Consolidation */ case 'DCon':
                                break;
                            /* Watched Cell */ case 'CellWatch':
                                break;
                            /* Print Settings */ case 'PrintRowCol':
                                break;
                            case 'PrintGrid':
                                break;
                            case 'PrintSize':
                                break;
                            case 'XCT':
                                break;
                            case 'CRN':
                                break;
                            case 'Scl':
                                break;
                            case 'SheetExt':
                                break;
                            case 'SheetExtOptional':
                                break;
                            /* VBA */ case 'ObNoMacros':
                                break;
                            case 'ObProj':
                                break;
                            case 'CodeName':
                                if (!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
                                else wsprops.CodeName = val || wsprops.name;
                                break;
                            case 'GUIDTypeLib':
                                break;
                            case 'WOpt':
                                break; // TODO: WTF?
                            case 'PhoneticInfo':
                                break;
                            case 'OleObjectSize':
                                break;
                            /* Differential Formatting */ case 'DXF':
                            case 'DXFN':
                            case 'DXFN12':
                            case 'DXFN12List':
                            case 'DXFN12NoCB':
                                break;
                            /* Data Validation */ case 'Dv':
                            case 'DVal':
                                break;
                            /* Data Series */ case 'BRAI':
                            case 'Series':
                            case 'SeriesText':
                                break;
                            /* Data Connection */ case 'DConn':
                                break;
                            case 'DbOrParamQry':
                                break;
                            case 'DBQueryExt':
                                break;
                            case 'OleDbConn':
                                break;
                            case 'ExtString':
                                break;
                            /* Formatting */ case 'IFmtRecord':
                                break;
                            case 'CondFmt':
                            case 'CF':
                            case 'CF12':
                            case 'CFEx':
                                break;
                            /* Explicitly Ignored */ case 'Excel9File':
                                break;
                            case 'Units':
                                break;
                            case 'InterfaceHdr':
                            case 'Mms':
                            case 'InterfaceEnd':
                            case 'DSF':
                                break;
                            case 'BuiltInFnGroupCount':
                                break;
                            /* View Stuff */ case 'Window1':
                            case 'HideObj':
                            case 'GridSet':
                            case 'Guts':
                            case 'UserBView':
                            case 'UserSViewBegin':
                            case 'UserSViewEnd':
                                break;
                            case 'Pane':
                                break;
                            default:
                                switch(R.n){
                                    /* Chart */ case 'Dat':
                                    case 'Begin':
                                    case 'End':
                                    case 'StartBlock':
                                    case 'EndBlock':
                                    case 'Frame':
                                    case 'Area':
                                    case 'Axis':
                                    case 'AxisLine':
                                    case 'Tick':
                                        break;
                                    case 'AxesUsed':
                                    case 'CrtLayout12':
                                    case 'CrtLayout12A':
                                    case 'CrtLink':
                                    case 'CrtLine':
                                    case 'CrtMlFrt':
                                    case 'CrtMlFrtContinue':
                                        break;
                                    case 'LineFormat':
                                    case 'AreaFormat':
                                    case 'Chart':
                                    case 'Chart3d':
                                    case 'Chart3DBarShape':
                                    case 'ChartFormat':
                                    case 'ChartFrtInfo':
                                        break;
                                    case 'PlotArea':
                                    case 'PlotGrowth':
                                        break;
                                    case 'SeriesList':
                                    case 'SerParent':
                                    case 'SerAuxTrend':
                                        break;
                                    case 'DataFormat':
                                    case 'SerToCrt':
                                    case 'FontX':
                                        break;
                                    case 'CatSerRange':
                                    case 'AxcExt':
                                    case 'SerFmt':
                                        break;
                                    case 'ShtProps':
                                        break;
                                    case 'DefaultText':
                                    case 'Text':
                                    case 'CatLab':
                                        break;
                                    case 'DataLabExtContents':
                                        break;
                                    case 'Legend':
                                    case 'LegendException':
                                        break;
                                    case 'Pie':
                                    case 'Scatter':
                                        break;
                                    case 'PieFormat':
                                    case 'MarkerFormat':
                                        break;
                                    case 'StartObject':
                                    case 'EndObject':
                                        break;
                                    case 'AlRuns':
                                    case 'ObjectLink':
                                        break;
                                    case 'SIIndex':
                                        break;
                                    case 'AttachedLabel':
                                    case 'YMult':
                                        break;
                                    /* Chart Group */ case 'Line':
                                    case 'Bar':
                                        break;
                                    case 'Surf':
                                        break;
                                    /* Axis Group */ case 'AxisParent':
                                        break;
                                    case 'Pos':
                                        break;
                                    case 'ValueRange':
                                        break;
                                    /* Pivot Chart */ case 'SXViewEx9':
                                        break; // TODO
                                    case 'SXViewLink':
                                        break;
                                    case 'PivotChartBits':
                                        break;
                                    case 'SBaseRef':
                                        break;
                                    case 'TextPropsStream':
                                        break;
                                    /* Chart Misc */ case 'LnExt':
                                        break;
                                    case 'MkrExt':
                                        break;
                                    case 'CrtCoopt':
                                        break;
                                    /* Query Table */ case 'Qsi':
                                    case 'Qsif':
                                    case 'Qsir':
                                    case 'QsiSXTag':
                                        break;
                                    case 'TxtQry':
                                        break;
                                    /* Filter */ case 'FilterMode':
                                        break;
                                    case 'AutoFilter':
                                    case 'AutoFilterInfo':
                                        break;
                                    case 'AutoFilter12':
                                        break;
                                    case 'DropDownObjIds':
                                        break;
                                    case 'Sort':
                                        break;
                                    case 'SortData':
                                        break;
                                    /* Drawing */ case 'ShapePropsStream':
                                        break;
                                    case 'MsoDrawing':
                                    case 'MsoDrawingGroup':
                                    case 'MsoDrawingSelection':
                                        break;
                                    /* Pub Stuff */ case 'WebPub':
                                    case 'AutoWebPub':
                                        break;
                                    /* Print Stuff */ case 'HeaderFooter':
                                    case 'HFPicture':
                                    case 'PLV':
                                    case 'HorizontalPageBreaks':
                                    case 'VerticalPageBreaks':
                                        break;
                                    /* Behavioral */ case 'Backup':
                                    case 'CompressPictures':
                                    case 'Compat12':
                                        break;
                                    /* Should not Happen */ case 'Continue':
                                    case 'ContinueFrt12':
                                        break;
                                    /* Future Records */ case 'FrtFontList':
                                    case 'FrtWrapper':
                                        break;
                                    default:
                                        switch(R.n){
                                            /* BIFF5 records */ case 'TabIdConf':
                                            case 'Radar':
                                            case 'RadarArea':
                                            case 'DropBar':
                                            case 'Intl':
                                            case 'CoordList':
                                            case 'SerAuxErrBar':
                                                break;
                                            /* BIFF2-4 records */ case 'BIFF2FONTCLR':
                                            case 'BIFF2FMTCNT':
                                            case 'BIFF2FONTXTRA':
                                                break;
                                            case 'BIFF2XF':
                                            case 'BIFF3XF':
                                            case 'BIFF4XF':
                                                break;
                                            case 'BIFF4FMTCNT':
                                            case 'BIFF2ROW':
                                            case 'BIFF2WINDOW2':
                                                break;
                                            /* Miscellaneous */ case 'SCENARIO':
                                            case 'DConBin':
                                            case 'PicF':
                                            case 'DataLabExt':
                                            case 'Lel':
                                            case 'BopPop':
                                            case 'BopPopCustom':
                                            case 'RealTimeData':
                                            case 'Name':
                                                break;
                                            case 'LHNGraph':
                                            case 'FnGroupName':
                                            case 'AddMenu':
                                            case 'LPr':
                                                break;
                                            case 'ListObj':
                                            case 'ListField':
                                                break;
                                            case 'RRSort':
                                                break;
                                            case 'BigName':
                                                break;
                                            case 'ToolbarHdr':
                                            case 'ToolbarEnd':
                                                break;
                                            case 'DDEObjName':
                                                break;
                                            case 'FRTArchId$':
                                                break;
                                            default:
                                                if (options.WTF) throw 'Unrecognized Record ' + R.n;
                                        }
                                }
                        }
                }
            } else blob.l += length;
        }
        wb.SheetNames = keys(Directory).sort(function(a, b) {
            return Number(a) - Number(b);
        }).map(function(x) {
            return Directory[x].name;
        });
        if (!options.bookSheets) wb.Sheets = Sheets;
        if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
            wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r;
        });
        wb.Preamble = Preamble;
        wb.Strings = sst;
        wb.SSF = SSF.get_table();
        if (opts.enc) wb.Encryption = opts.enc;
        if (themes) wb.Themes = themes;
        wb.Metadata = {};
        if (country !== undefined) wb.Metadata.Country = country;
        if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
        wb.Workbook = Workbook;
        return wb;
    }
    /* TODO: split props*/ var PSCLSID = {
        SI: "e0859ff2f94f6810ab9108002b27b3d9",
        DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
        UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
    };
    function parse_xls_props(cfb, props, o) {
        /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = CFB.find(cfb, '!DocumentSummaryInformation');
        if (DSI && DSI.size > 0) try {
            var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
            for(var d in DocSummary)props[d] = DocSummary[d];
        } catch (e) {
            if (o.WTF) throw e; /* empty */ 
        }
        /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = CFB.find(cfb, '!SummaryInformation');
        if (SI && SI.size > 0) try {
            var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
            for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
        } catch (e) {
            if (o.WTF) throw e; /* empty */ 
        }
        if (props.HeadingPairs && props.TitlesOfParts) {
            load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
            delete props.HeadingPairs;
            delete props.TitlesOfParts;
        }
    }
    function write_xls_props(wb, cfb) {
        var DSEntries = [], SEntries = [], CEntries = [];
        var i = 0, Keys;
        if (wb.Props) {
            Keys = keys(wb.Props);
            // $FlowIgnore
            for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
                Keys[i],
                wb.Props[Keys[i]]
            ]);
        }
        if (wb.Custprops) {
            Keys = keys(wb.Custprops);
            // $FlowIgnore
            for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
                Keys[i],
                wb.Custprops[Keys[i]]
            ]);
        }
        var CEntries2 = [];
        for(i = 0; i < CEntries.length; ++i){
            if (XLSPSSkip.indexOf(CEntries[i][0]) > -1) continue;
            if (CEntries[i][1] == null) continue;
            CEntries2.push(CEntries[i]);
        }
        if (SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
        if (DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
    }
    function parse_xlscfb(cfb, options) {
        if (!options) options = {};
        fix_read_opts(options);
        reset_cp();
        if (options.codepage) set_ansi(options.codepage);
        var CompObj, WB;
        if (cfb.FullPaths) {
            if (CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
            CompObj = CFB.find(cfb, '!CompObj');
            WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
        } else {
            switch(options.type){
                case 'base64':
                    cfb = s2a(Base64.decode(cfb));
                    break;
                case 'binary':
                    cfb = s2a(cfb);
                    break;
                case 'buffer':
                    break;
                case 'array':
                    if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                    break;
            }
            prep_blob(cfb, 0);
            WB = {
                content: cfb
            };
        }
        var WorkbookP;
        var _data;
        if (CompObj) parse_compobj(CompObj);
        if (options.bookProps && !options.bookSheets) WorkbookP = {};
        else {
            var T = has_buf ? 'buffer' : 'array';
            if (WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
            else if ((_data = CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
            else if ((_data = CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
            else throw new Error("Cannot find Workbook stream");
            if (options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
        }
        var props = {};
        if (cfb.FullPaths) parse_xls_props(cfb, props, options);
        WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
        if (options.bookFiles) WorkbookP.cfb = cfb;
        /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
    }
    function write_xlscfb(wb, opts) {
        var o = opts || {};
        var cfb = CFB.utils.cfb_new({
            root: "R"
        });
        var wbpath = "/Workbook";
        switch(o.bookType || "xls"){
            case "xls":
                o.bookType = "biff8";
            /* falls through */ case "xla":
                if (!o.bookType) o.bookType = "xla";
            /* falls through */ case "biff8":
                wbpath = "/Workbook";
                o.biff = 8;
                break;
            case "biff5":
                wbpath = "/Book";
                o.biff = 5;
                break;
            default:
                throw new Error("invalid type " + o.bookType + " for XLS CFB");
        }
        CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
        if (o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
        // TODO: SI, DSI, CO
        if (o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {
            type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
        }));
        return cfb;
    }
    /* [MS-XLSB] 2.3 Record Enumeration */ var XLSBRecordEnum = {
        0x0000: {
            n: "BrtRowHdr",
            f: parse_BrtRowHdr
        },
        0x0001: {
            n: "BrtCellBlank",
            f: parse_BrtCellBlank
        },
        0x0002: {
            n: "BrtCellRk",
            f: parse_BrtCellRk
        },
        0x0003: {
            n: "BrtCellError",
            f: parse_BrtCellError
        },
        0x0004: {
            n: "BrtCellBool",
            f: parse_BrtCellBool
        },
        0x0005: {
            n: "BrtCellReal",
            f: parse_BrtCellReal
        },
        0x0006: {
            n: "BrtCellSt",
            f: parse_BrtCellSt
        },
        0x0007: {
            n: "BrtCellIsst",
            f: parse_BrtCellIsst
        },
        0x0008: {
            n: "BrtFmlaString",
            f: parse_BrtFmlaString
        },
        0x0009: {
            n: "BrtFmlaNum",
            f: parse_BrtFmlaNum
        },
        0x000A: {
            n: "BrtFmlaBool",
            f: parse_BrtFmlaBool
        },
        0x000B: {
            n: "BrtFmlaError",
            f: parse_BrtFmlaError
        },
        0x0010: {
            n: "BrtFRTArchID$",
            f: parse_BrtFRTArchID$
        },
        0x0013: {
            n: "BrtSSTItem",
            f: parse_RichStr
        },
        0x0014: {
            n: "BrtPCDIMissing"
        },
        0x0015: {
            n: "BrtPCDINumber"
        },
        0x0016: {
            n: "BrtPCDIBoolean"
        },
        0x0017: {
            n: "BrtPCDIError"
        },
        0x0018: {
            n: "BrtPCDIString"
        },
        0x0019: {
            n: "BrtPCDIDatetime"
        },
        0x001A: {
            n: "BrtPCDIIndex"
        },
        0x001B: {
            n: "BrtPCDIAMissing"
        },
        0x001C: {
            n: "BrtPCDIANumber"
        },
        0x001D: {
            n: "BrtPCDIABoolean"
        },
        0x001E: {
            n: "BrtPCDIAError"
        },
        0x001F: {
            n: "BrtPCDIAString"
        },
        0x0020: {
            n: "BrtPCDIADatetime"
        },
        0x0021: {
            n: "BrtPCRRecord"
        },
        0x0022: {
            n: "BrtPCRRecordDt"
        },
        0x0023: {
            n: "BrtFRTBegin"
        },
        0x0024: {
            n: "BrtFRTEnd"
        },
        0x0025: {
            n: "BrtACBegin"
        },
        0x0026: {
            n: "BrtACEnd"
        },
        0x0027: {
            n: "BrtName",
            f: parse_BrtName
        },
        0x0028: {
            n: "BrtIndexRowBlock"
        },
        0x002A: {
            n: "BrtIndexBlock"
        },
        0x002B: {
            n: "BrtFont",
            f: parse_BrtFont
        },
        0x002C: {
            n: "BrtFmt",
            f: parse_BrtFmt
        },
        0x002D: {
            n: "BrtFill",
            f: parse_BrtFill
        },
        0x002E: {
            n: "BrtBorder",
            f: parse_BrtBorder
        },
        0x002F: {
            n: "BrtXF",
            f: parse_BrtXF
        },
        0x0030: {
            n: "BrtStyle"
        },
        0x0031: {
            n: "BrtCellMeta"
        },
        0x0032: {
            n: "BrtValueMeta"
        },
        0x0033: {
            n: "BrtMdb"
        },
        0x0034: {
            n: "BrtBeginFmd"
        },
        0x0035: {
            n: "BrtEndFmd"
        },
        0x0036: {
            n: "BrtBeginMdx"
        },
        0x0037: {
            n: "BrtEndMdx"
        },
        0x0038: {
            n: "BrtBeginMdxTuple"
        },
        0x0039: {
            n: "BrtEndMdxTuple"
        },
        0x003A: {
            n: "BrtMdxMbrIstr"
        },
        0x003B: {
            n: "BrtStr"
        },
        0x003C: {
            n: "BrtColInfo",
            f: parse_ColInfo
        },
        0x003E: {
            n: "BrtCellRString"
        },
        0x003F: {
            n: "BrtCalcChainItem$",
            f: parse_BrtCalcChainItem$
        },
        0x0040: {
            n: "BrtDVal",
            f: parse_BrtDVal
        },
        0x0041: {
            n: "BrtSxvcellNum"
        },
        0x0042: {
            n: "BrtSxvcellStr"
        },
        0x0043: {
            n: "BrtSxvcellBool"
        },
        0x0044: {
            n: "BrtSxvcellErr"
        },
        0x0045: {
            n: "BrtSxvcellDate"
        },
        0x0046: {
            n: "BrtSxvcellNil"
        },
        0x0080: {
            n: "BrtFileVersion"
        },
        0x0081: {
            n: "BrtBeginSheet"
        },
        0x0082: {
            n: "BrtEndSheet"
        },
        0x0083: {
            n: "BrtBeginBook",
            f: parsenoop,
            p: 0
        },
        0x0084: {
            n: "BrtEndBook"
        },
        0x0085: {
            n: "BrtBeginWsViews"
        },
        0x0086: {
            n: "BrtEndWsViews"
        },
        0x0087: {
            n: "BrtBeginBookViews"
        },
        0x0088: {
            n: "BrtEndBookViews"
        },
        0x0089: {
            n: "BrtBeginWsView",
            f: parse_BrtBeginWsView
        },
        0x008A: {
            n: "BrtEndWsView"
        },
        0x008B: {
            n: "BrtBeginCsViews"
        },
        0x008C: {
            n: "BrtEndCsViews"
        },
        0x008D: {
            n: "BrtBeginCsView"
        },
        0x008E: {
            n: "BrtEndCsView"
        },
        0x008F: {
            n: "BrtBeginBundleShs"
        },
        0x0090: {
            n: "BrtEndBundleShs"
        },
        0x0091: {
            n: "BrtBeginSheetData"
        },
        0x0092: {
            n: "BrtEndSheetData"
        },
        0x0093: {
            n: "BrtWsProp",
            f: parse_BrtWsProp
        },
        0x0094: {
            n: "BrtWsDim",
            f: parse_BrtWsDim,
            p: 16
        },
        0x0097: {
            n: "BrtPane",
            f: parse_BrtPane
        },
        0x0098: {
            n: "BrtSel"
        },
        0x0099: {
            n: "BrtWbProp",
            f: parse_BrtWbProp
        },
        0x009A: {
            n: "BrtWbFactoid"
        },
        0x009B: {
            n: "BrtFileRecover"
        },
        0x009C: {
            n: "BrtBundleSh",
            f: parse_BrtBundleSh
        },
        0x009D: {
            n: "BrtCalcProp"
        },
        0x009E: {
            n: "BrtBookView"
        },
        0x009F: {
            n: "BrtBeginSst",
            f: parse_BrtBeginSst
        },
        0x00A0: {
            n: "BrtEndSst"
        },
        0x00A1: {
            n: "BrtBeginAFilter",
            f: parse_UncheckedRfX
        },
        0x00A2: {
            n: "BrtEndAFilter"
        },
        0x00A3: {
            n: "BrtBeginFilterColumn"
        },
        0x00A4: {
            n: "BrtEndFilterColumn"
        },
        0x00A5: {
            n: "BrtBeginFilters"
        },
        0x00A6: {
            n: "BrtEndFilters"
        },
        0x00A7: {
            n: "BrtFilter"
        },
        0x00A8: {
            n: "BrtColorFilter"
        },
        0x00A9: {
            n: "BrtIconFilter"
        },
        0x00AA: {
            n: "BrtTop10Filter"
        },
        0x00AB: {
            n: "BrtDynamicFilter"
        },
        0x00AC: {
            n: "BrtBeginCustomFilters"
        },
        0x00AD: {
            n: "BrtEndCustomFilters"
        },
        0x00AE: {
            n: "BrtCustomFilter"
        },
        0x00AF: {
            n: "BrtAFilterDateGroupItem"
        },
        0x00B0: {
            n: "BrtMergeCell",
            f: parse_BrtMergeCell
        },
        0x00B1: {
            n: "BrtBeginMergeCells"
        },
        0x00B2: {
            n: "BrtEndMergeCells"
        },
        0x00B3: {
            n: "BrtBeginPivotCacheDef"
        },
        0x00B4: {
            n: "BrtEndPivotCacheDef"
        },
        0x00B5: {
            n: "BrtBeginPCDFields"
        },
        0x00B6: {
            n: "BrtEndPCDFields"
        },
        0x00B7: {
            n: "BrtBeginPCDField"
        },
        0x00B8: {
            n: "BrtEndPCDField"
        },
        0x00B9: {
            n: "BrtBeginPCDSource"
        },
        0x00BA: {
            n: "BrtEndPCDSource"
        },
        0x00BB: {
            n: "BrtBeginPCDSRange"
        },
        0x00BC: {
            n: "BrtEndPCDSRange"
        },
        0x00BD: {
            n: "BrtBeginPCDFAtbl"
        },
        0x00BE: {
            n: "BrtEndPCDFAtbl"
        },
        0x00BF: {
            n: "BrtBeginPCDIRun"
        },
        0x00C0: {
            n: "BrtEndPCDIRun"
        },
        0x00C1: {
            n: "BrtBeginPivotCacheRecords"
        },
        0x00C2: {
            n: "BrtEndPivotCacheRecords"
        },
        0x00C3: {
            n: "BrtBeginPCDHierarchies"
        },
        0x00C4: {
            n: "BrtEndPCDHierarchies"
        },
        0x00C5: {
            n: "BrtBeginPCDHierarchy"
        },
        0x00C6: {
            n: "BrtEndPCDHierarchy"
        },
        0x00C7: {
            n: "BrtBeginPCDHFieldsUsage"
        },
        0x00C8: {
            n: "BrtEndPCDHFieldsUsage"
        },
        0x00C9: {
            n: "BrtBeginExtConnection"
        },
        0x00CA: {
            n: "BrtEndExtConnection"
        },
        0x00CB: {
            n: "BrtBeginECDbProps"
        },
        0x00CC: {
            n: "BrtEndECDbProps"
        },
        0x00CD: {
            n: "BrtBeginECOlapProps"
        },
        0x00CE: {
            n: "BrtEndECOlapProps"
        },
        0x00CF: {
            n: "BrtBeginPCDSConsol"
        },
        0x00D0: {
            n: "BrtEndPCDSConsol"
        },
        0x00D1: {
            n: "BrtBeginPCDSCPages"
        },
        0x00D2: {
            n: "BrtEndPCDSCPages"
        },
        0x00D3: {
            n: "BrtBeginPCDSCPage"
        },
        0x00D4: {
            n: "BrtEndPCDSCPage"
        },
        0x00D5: {
            n: "BrtBeginPCDSCPItem"
        },
        0x00D6: {
            n: "BrtEndPCDSCPItem"
        },
        0x00D7: {
            n: "BrtBeginPCDSCSets"
        },
        0x00D8: {
            n: "BrtEndPCDSCSets"
        },
        0x00D9: {
            n: "BrtBeginPCDSCSet"
        },
        0x00DA: {
            n: "BrtEndPCDSCSet"
        },
        0x00DB: {
            n: "BrtBeginPCDFGroup"
        },
        0x00DC: {
            n: "BrtEndPCDFGroup"
        },
        0x00DD: {
            n: "BrtBeginPCDFGItems"
        },
        0x00DE: {
            n: "BrtEndPCDFGItems"
        },
        0x00DF: {
            n: "BrtBeginPCDFGRange"
        },
        0x00E0: {
            n: "BrtEndPCDFGRange"
        },
        0x00E1: {
            n: "BrtBeginPCDFGDiscrete"
        },
        0x00E2: {
            n: "BrtEndPCDFGDiscrete"
        },
        0x00E3: {
            n: "BrtBeginPCDSDTupleCache"
        },
        0x00E4: {
            n: "BrtEndPCDSDTupleCache"
        },
        0x00E5: {
            n: "BrtBeginPCDSDTCEntries"
        },
        0x00E6: {
            n: "BrtEndPCDSDTCEntries"
        },
        0x00E7: {
            n: "BrtBeginPCDSDTCEMembers"
        },
        0x00E8: {
            n: "BrtEndPCDSDTCEMembers"
        },
        0x00E9: {
            n: "BrtBeginPCDSDTCEMember"
        },
        0x00EA: {
            n: "BrtEndPCDSDTCEMember"
        },
        0x00EB: {
            n: "BrtBeginPCDSDTCQueries"
        },
        0x00EC: {
            n: "BrtEndPCDSDTCQueries"
        },
        0x00ED: {
            n: "BrtBeginPCDSDTCQuery"
        },
        0x00EE: {
            n: "BrtEndPCDSDTCQuery"
        },
        0x00EF: {
            n: "BrtBeginPCDSDTCSets"
        },
        0x00F0: {
            n: "BrtEndPCDSDTCSets"
        },
        0x00F1: {
            n: "BrtBeginPCDSDTCSet"
        },
        0x00F2: {
            n: "BrtEndPCDSDTCSet"
        },
        0x00F3: {
            n: "BrtBeginPCDCalcItems"
        },
        0x00F4: {
            n: "BrtEndPCDCalcItems"
        },
        0x00F5: {
            n: "BrtBeginPCDCalcItem"
        },
        0x00F6: {
            n: "BrtEndPCDCalcItem"
        },
        0x00F7: {
            n: "BrtBeginPRule"
        },
        0x00F8: {
            n: "BrtEndPRule"
        },
        0x00F9: {
            n: "BrtBeginPRFilters"
        },
        0x00FA: {
            n: "BrtEndPRFilters"
        },
        0x00FB: {
            n: "BrtBeginPRFilter"
        },
        0x00FC: {
            n: "BrtEndPRFilter"
        },
        0x00FD: {
            n: "BrtBeginPNames"
        },
        0x00FE: {
            n: "BrtEndPNames"
        },
        0x00FF: {
            n: "BrtBeginPName"
        },
        0x0100: {
            n: "BrtEndPName"
        },
        0x0101: {
            n: "BrtBeginPNPairs"
        },
        0x0102: {
            n: "BrtEndPNPairs"
        },
        0x0103: {
            n: "BrtBeginPNPair"
        },
        0x0104: {
            n: "BrtEndPNPair"
        },
        0x0105: {
            n: "BrtBeginECWebProps"
        },
        0x0106: {
            n: "BrtEndECWebProps"
        },
        0x0107: {
            n: "BrtBeginEcWpTables"
        },
        0x0108: {
            n: "BrtEndECWPTables"
        },
        0x0109: {
            n: "BrtBeginECParams"
        },
        0x010A: {
            n: "BrtEndECParams"
        },
        0x010B: {
            n: "BrtBeginECParam"
        },
        0x010C: {
            n: "BrtEndECParam"
        },
        0x010D: {
            n: "BrtBeginPCDKPIs"
        },
        0x010E: {
            n: "BrtEndPCDKPIs"
        },
        0x010F: {
            n: "BrtBeginPCDKPI"
        },
        0x0110: {
            n: "BrtEndPCDKPI"
        },
        0x0111: {
            n: "BrtBeginDims"
        },
        0x0112: {
            n: "BrtEndDims"
        },
        0x0113: {
            n: "BrtBeginDim"
        },
        0x0114: {
            n: "BrtEndDim"
        },
        0x0115: {
            n: "BrtIndexPartEnd"
        },
        0x0116: {
            n: "BrtBeginStyleSheet"
        },
        0x0117: {
            n: "BrtEndStyleSheet"
        },
        0x0118: {
            n: "BrtBeginSXView"
        },
        0x0119: {
            n: "BrtEndSXVI"
        },
        0x011A: {
            n: "BrtBeginSXVI"
        },
        0x011B: {
            n: "BrtBeginSXVIs"
        },
        0x011C: {
            n: "BrtEndSXVIs"
        },
        0x011D: {
            n: "BrtBeginSXVD"
        },
        0x011E: {
            n: "BrtEndSXVD"
        },
        0x011F: {
            n: "BrtBeginSXVDs"
        },
        0x0120: {
            n: "BrtEndSXVDs"
        },
        0x0121: {
            n: "BrtBeginSXPI"
        },
        0x0122: {
            n: "BrtEndSXPI"
        },
        0x0123: {
            n: "BrtBeginSXPIs"
        },
        0x0124: {
            n: "BrtEndSXPIs"
        },
        0x0125: {
            n: "BrtBeginSXDI"
        },
        0x0126: {
            n: "BrtEndSXDI"
        },
        0x0127: {
            n: "BrtBeginSXDIs"
        },
        0x0128: {
            n: "BrtEndSXDIs"
        },
        0x0129: {
            n: "BrtBeginSXLI"
        },
        0x012A: {
            n: "BrtEndSXLI"
        },
        0x012B: {
            n: "BrtBeginSXLIRws"
        },
        0x012C: {
            n: "BrtEndSXLIRws"
        },
        0x012D: {
            n: "BrtBeginSXLICols"
        },
        0x012E: {
            n: "BrtEndSXLICols"
        },
        0x012F: {
            n: "BrtBeginSXFormat"
        },
        0x0130: {
            n: "BrtEndSXFormat"
        },
        0x0131: {
            n: "BrtBeginSXFormats"
        },
        0x0132: {
            n: "BrtEndSxFormats"
        },
        0x0133: {
            n: "BrtBeginSxSelect"
        },
        0x0134: {
            n: "BrtEndSxSelect"
        },
        0x0135: {
            n: "BrtBeginISXVDRws"
        },
        0x0136: {
            n: "BrtEndISXVDRws"
        },
        0x0137: {
            n: "BrtBeginISXVDCols"
        },
        0x0138: {
            n: "BrtEndISXVDCols"
        },
        0x0139: {
            n: "BrtEndSXLocation"
        },
        0x013A: {
            n: "BrtBeginSXLocation"
        },
        0x013B: {
            n: "BrtEndSXView"
        },
        0x013C: {
            n: "BrtBeginSXTHs"
        },
        0x013D: {
            n: "BrtEndSXTHs"
        },
        0x013E: {
            n: "BrtBeginSXTH"
        },
        0x013F: {
            n: "BrtEndSXTH"
        },
        0x0140: {
            n: "BrtBeginISXTHRws"
        },
        0x0141: {
            n: "BrtEndISXTHRws"
        },
        0x0142: {
            n: "BrtBeginISXTHCols"
        },
        0x0143: {
            n: "BrtEndISXTHCols"
        },
        0x0144: {
            n: "BrtBeginSXTDMPS"
        },
        0x0145: {
            n: "BrtEndSXTDMPs"
        },
        0x0146: {
            n: "BrtBeginSXTDMP"
        },
        0x0147: {
            n: "BrtEndSXTDMP"
        },
        0x0148: {
            n: "BrtBeginSXTHItems"
        },
        0x0149: {
            n: "BrtEndSXTHItems"
        },
        0x014A: {
            n: "BrtBeginSXTHItem"
        },
        0x014B: {
            n: "BrtEndSXTHItem"
        },
        0x014C: {
            n: "BrtBeginMetadata"
        },
        0x014D: {
            n: "BrtEndMetadata"
        },
        0x014E: {
            n: "BrtBeginEsmdtinfo"
        },
        0x014F: {
            n: "BrtMdtinfo"
        },
        0x0150: {
            n: "BrtEndEsmdtinfo"
        },
        0x0151: {
            n: "BrtBeginEsmdb"
        },
        0x0152: {
            n: "BrtEndEsmdb"
        },
        0x0153: {
            n: "BrtBeginEsfmd"
        },
        0x0154: {
            n: "BrtEndEsfmd"
        },
        0x0155: {
            n: "BrtBeginSingleCells"
        },
        0x0156: {
            n: "BrtEndSingleCells"
        },
        0x0157: {
            n: "BrtBeginList"
        },
        0x0158: {
            n: "BrtEndList"
        },
        0x0159: {
            n: "BrtBeginListCols"
        },
        0x015A: {
            n: "BrtEndListCols"
        },
        0x015B: {
            n: "BrtBeginListCol"
        },
        0x015C: {
            n: "BrtEndListCol"
        },
        0x015D: {
            n: "BrtBeginListXmlCPr"
        },
        0x015E: {
            n: "BrtEndListXmlCPr"
        },
        0x015F: {
            n: "BrtListCCFmla"
        },
        0x0160: {
            n: "BrtListTrFmla"
        },
        0x0161: {
            n: "BrtBeginExternals"
        },
        0x0162: {
            n: "BrtEndExternals"
        },
        0x0163: {
            n: "BrtSupBookSrc",
            f: parse_RelID
        },
        0x0165: {
            n: "BrtSupSelf"
        },
        0x0166: {
            n: "BrtSupSame"
        },
        0x0167: {
            n: "BrtSupTabs"
        },
        0x0168: {
            n: "BrtBeginSupBook"
        },
        0x0169: {
            n: "BrtPlaceholderName"
        },
        0x016A: {
            n: "BrtExternSheet",
            f: parse_ExternSheet
        },
        0x016B: {
            n: "BrtExternTableStart"
        },
        0x016C: {
            n: "BrtExternTableEnd"
        },
        0x016E: {
            n: "BrtExternRowHdr"
        },
        0x016F: {
            n: "BrtExternCellBlank"
        },
        0x0170: {
            n: "BrtExternCellReal"
        },
        0x0171: {
            n: "BrtExternCellBool"
        },
        0x0172: {
            n: "BrtExternCellError"
        },
        0x0173: {
            n: "BrtExternCellString"
        },
        0x0174: {
            n: "BrtBeginEsmdx"
        },
        0x0175: {
            n: "BrtEndEsmdx"
        },
        0x0176: {
            n: "BrtBeginMdxSet"
        },
        0x0177: {
            n: "BrtEndMdxSet"
        },
        0x0178: {
            n: "BrtBeginMdxMbrProp"
        },
        0x0179: {
            n: "BrtEndMdxMbrProp"
        },
        0x017A: {
            n: "BrtBeginMdxKPI"
        },
        0x017B: {
            n: "BrtEndMdxKPI"
        },
        0x017C: {
            n: "BrtBeginEsstr"
        },
        0x017D: {
            n: "BrtEndEsstr"
        },
        0x017E: {
            n: "BrtBeginPRFItem"
        },
        0x017F: {
            n: "BrtEndPRFItem"
        },
        0x0180: {
            n: "BrtBeginPivotCacheIDs"
        },
        0x0181: {
            n: "BrtEndPivotCacheIDs"
        },
        0x0182: {
            n: "BrtBeginPivotCacheID"
        },
        0x0183: {
            n: "BrtEndPivotCacheID"
        },
        0x0184: {
            n: "BrtBeginISXVIs"
        },
        0x0185: {
            n: "BrtEndISXVIs"
        },
        0x0186: {
            n: "BrtBeginColInfos"
        },
        0x0187: {
            n: "BrtEndColInfos"
        },
        0x0188: {
            n: "BrtBeginRwBrk"
        },
        0x0189: {
            n: "BrtEndRwBrk"
        },
        0x018A: {
            n: "BrtBeginColBrk"
        },
        0x018B: {
            n: "BrtEndColBrk"
        },
        0x018C: {
            n: "BrtBrk"
        },
        0x018D: {
            n: "BrtUserBookView"
        },
        0x018E: {
            n: "BrtInfo"
        },
        0x018F: {
            n: "BrtCUsr"
        },
        0x0190: {
            n: "BrtUsr"
        },
        0x0191: {
            n: "BrtBeginUsers"
        },
        0x0193: {
            n: "BrtEOF"
        },
        0x0194: {
            n: "BrtUCR"
        },
        0x0195: {
            n: "BrtRRInsDel"
        },
        0x0196: {
            n: "BrtRREndInsDel"
        },
        0x0197: {
            n: "BrtRRMove"
        },
        0x0198: {
            n: "BrtRREndMove"
        },
        0x0199: {
            n: "BrtRRChgCell"
        },
        0x019A: {
            n: "BrtRREndChgCell"
        },
        0x019B: {
            n: "BrtRRHeader"
        },
        0x019C: {
            n: "BrtRRUserView"
        },
        0x019D: {
            n: "BrtRRRenSheet"
        },
        0x019E: {
            n: "BrtRRInsertSh"
        },
        0x019F: {
            n: "BrtRRDefName"
        },
        0x01A0: {
            n: "BrtRRNote"
        },
        0x01A1: {
            n: "BrtRRConflict"
        },
        0x01A2: {
            n: "BrtRRTQSIF"
        },
        0x01A3: {
            n: "BrtRRFormat"
        },
        0x01A4: {
            n: "BrtRREndFormat"
        },
        0x01A5: {
            n: "BrtRRAutoFmt"
        },
        0x01A6: {
            n: "BrtBeginUserShViews"
        },
        0x01A7: {
            n: "BrtBeginUserShView"
        },
        0x01A8: {
            n: "BrtEndUserShView"
        },
        0x01A9: {
            n: "BrtEndUserShViews"
        },
        0x01AA: {
            n: "BrtArrFmla",
            f: parse_BrtArrFmla
        },
        0x01AB: {
            n: "BrtShrFmla",
            f: parse_BrtShrFmla
        },
        0x01AC: {
            n: "BrtTable"
        },
        0x01AD: {
            n: "BrtBeginExtConnections"
        },
        0x01AE: {
            n: "BrtEndExtConnections"
        },
        0x01AF: {
            n: "BrtBeginPCDCalcMems"
        },
        0x01B0: {
            n: "BrtEndPCDCalcMems"
        },
        0x01B1: {
            n: "BrtBeginPCDCalcMem"
        },
        0x01B2: {
            n: "BrtEndPCDCalcMem"
        },
        0x01B3: {
            n: "BrtBeginPCDHGLevels"
        },
        0x01B4: {
            n: "BrtEndPCDHGLevels"
        },
        0x01B5: {
            n: "BrtBeginPCDHGLevel"
        },
        0x01B6: {
            n: "BrtEndPCDHGLevel"
        },
        0x01B7: {
            n: "BrtBeginPCDHGLGroups"
        },
        0x01B8: {
            n: "BrtEndPCDHGLGroups"
        },
        0x01B9: {
            n: "BrtBeginPCDHGLGroup"
        },
        0x01BA: {
            n: "BrtEndPCDHGLGroup"
        },
        0x01BB: {
            n: "BrtBeginPCDHGLGMembers"
        },
        0x01BC: {
            n: "BrtEndPCDHGLGMembers"
        },
        0x01BD: {
            n: "BrtBeginPCDHGLGMember"
        },
        0x01BE: {
            n: "BrtEndPCDHGLGMember"
        },
        0x01BF: {
            n: "BrtBeginQSI"
        },
        0x01C0: {
            n: "BrtEndQSI"
        },
        0x01C1: {
            n: "BrtBeginQSIR"
        },
        0x01C2: {
            n: "BrtEndQSIR"
        },
        0x01C3: {
            n: "BrtBeginDeletedNames"
        },
        0x01C4: {
            n: "BrtEndDeletedNames"
        },
        0x01C5: {
            n: "BrtBeginDeletedName"
        },
        0x01C6: {
            n: "BrtEndDeletedName"
        },
        0x01C7: {
            n: "BrtBeginQSIFs"
        },
        0x01C8: {
            n: "BrtEndQSIFs"
        },
        0x01C9: {
            n: "BrtBeginQSIF"
        },
        0x01CA: {
            n: "BrtEndQSIF"
        },
        0x01CB: {
            n: "BrtBeginAutoSortScope"
        },
        0x01CC: {
            n: "BrtEndAutoSortScope"
        },
        0x01CD: {
            n: "BrtBeginConditionalFormatting"
        },
        0x01CE: {
            n: "BrtEndConditionalFormatting"
        },
        0x01CF: {
            n: "BrtBeginCFRule"
        },
        0x01D0: {
            n: "BrtEndCFRule"
        },
        0x01D1: {
            n: "BrtBeginIconSet"
        },
        0x01D2: {
            n: "BrtEndIconSet"
        },
        0x01D3: {
            n: "BrtBeginDatabar"
        },
        0x01D4: {
            n: "BrtEndDatabar"
        },
        0x01D5: {
            n: "BrtBeginColorScale"
        },
        0x01D6: {
            n: "BrtEndColorScale"
        },
        0x01D7: {
            n: "BrtCFVO"
        },
        0x01D8: {
            n: "BrtExternValueMeta"
        },
        0x01D9: {
            n: "BrtBeginColorPalette"
        },
        0x01DA: {
            n: "BrtEndColorPalette"
        },
        0x01DB: {
            n: "BrtIndexedColor"
        },
        0x01DC: {
            n: "BrtMargins",
            f: parse_BrtMargins
        },
        0x01DD: {
            n: "BrtPrintOptions"
        },
        0x01DE: {
            n: "BrtPageSetup"
        },
        0x01DF: {
            n: "BrtBeginHeaderFooter"
        },
        0x01E0: {
            n: "BrtEndHeaderFooter"
        },
        0x01E1: {
            n: "BrtBeginSXCrtFormat"
        },
        0x01E2: {
            n: "BrtEndSXCrtFormat"
        },
        0x01E3: {
            n: "BrtBeginSXCrtFormats"
        },
        0x01E4: {
            n: "BrtEndSXCrtFormats"
        },
        0x01E5: {
            n: "BrtWsFmtInfo",
            f: parse_BrtWsFmtInfo
        },
        0x01E6: {
            n: "BrtBeginMgs"
        },
        0x01E7: {
            n: "BrtEndMGs"
        },
        0x01E8: {
            n: "BrtBeginMGMaps"
        },
        0x01E9: {
            n: "BrtEndMGMaps"
        },
        0x01EA: {
            n: "BrtBeginMG"
        },
        0x01EB: {
            n: "BrtEndMG"
        },
        0x01EC: {
            n: "BrtBeginMap"
        },
        0x01ED: {
            n: "BrtEndMap"
        },
        0x01EE: {
            n: "BrtHLink",
            f: parse_BrtHLink
        },
        0x01EF: {
            n: "BrtBeginDCon"
        },
        0x01F0: {
            n: "BrtEndDCon"
        },
        0x01F1: {
            n: "BrtBeginDRefs"
        },
        0x01F2: {
            n: "BrtEndDRefs"
        },
        0x01F3: {
            n: "BrtDRef"
        },
        0x01F4: {
            n: "BrtBeginScenMan"
        },
        0x01F5: {
            n: "BrtEndScenMan"
        },
        0x01F6: {
            n: "BrtBeginSct"
        },
        0x01F7: {
            n: "BrtEndSct"
        },
        0x01F8: {
            n: "BrtSlc"
        },
        0x01F9: {
            n: "BrtBeginDXFs"
        },
        0x01FA: {
            n: "BrtEndDXFs"
        },
        0x01FB: {
            n: "BrtDXF"
        },
        0x01FC: {
            n: "BrtBeginTableStyles"
        },
        0x01FD: {
            n: "BrtEndTableStyles"
        },
        0x01FE: {
            n: "BrtBeginTableStyle"
        },
        0x01FF: {
            n: "BrtEndTableStyle"
        },
        0x0200: {
            n: "BrtTableStyleElement"
        },
        0x0201: {
            n: "BrtTableStyleClient"
        },
        0x0202: {
            n: "BrtBeginVolDeps"
        },
        0x0203: {
            n: "BrtEndVolDeps"
        },
        0x0204: {
            n: "BrtBeginVolType"
        },
        0x0205: {
            n: "BrtEndVolType"
        },
        0x0206: {
            n: "BrtBeginVolMain"
        },
        0x0207: {
            n: "BrtEndVolMain"
        },
        0x0208: {
            n: "BrtBeginVolTopic"
        },
        0x0209: {
            n: "BrtEndVolTopic"
        },
        0x020A: {
            n: "BrtVolSubtopic"
        },
        0x020B: {
            n: "BrtVolRef"
        },
        0x020C: {
            n: "BrtVolNum"
        },
        0x020D: {
            n: "BrtVolErr"
        },
        0x020E: {
            n: "BrtVolStr"
        },
        0x020F: {
            n: "BrtVolBool"
        },
        0x0210: {
            n: "BrtBeginCalcChain$"
        },
        0x0211: {
            n: "BrtEndCalcChain$"
        },
        0x0212: {
            n: "BrtBeginSortState"
        },
        0x0213: {
            n: "BrtEndSortState"
        },
        0x0214: {
            n: "BrtBeginSortCond"
        },
        0x0215: {
            n: "BrtEndSortCond"
        },
        0x0216: {
            n: "BrtBookProtection"
        },
        0x0217: {
            n: "BrtSheetProtection"
        },
        0x0218: {
            n: "BrtRangeProtection"
        },
        0x0219: {
            n: "BrtPhoneticInfo"
        },
        0x021A: {
            n: "BrtBeginECTxtWiz"
        },
        0x021B: {
            n: "BrtEndECTxtWiz"
        },
        0x021C: {
            n: "BrtBeginECTWFldInfoLst"
        },
        0x021D: {
            n: "BrtEndECTWFldInfoLst"
        },
        0x021E: {
            n: "BrtBeginECTwFldInfo"
        },
        0x0224: {
            n: "BrtFileSharing"
        },
        0x0225: {
            n: "BrtOleSize"
        },
        0x0226: {
            n: "BrtDrawing",
            f: parse_RelID
        },
        0x0227: {
            n: "BrtLegacyDrawing"
        },
        0x0228: {
            n: "BrtLegacyDrawingHF"
        },
        0x0229: {
            n: "BrtWebOpt"
        },
        0x022A: {
            n: "BrtBeginWebPubItems"
        },
        0x022B: {
            n: "BrtEndWebPubItems"
        },
        0x022C: {
            n: "BrtBeginWebPubItem"
        },
        0x022D: {
            n: "BrtEndWebPubItem"
        },
        0x022E: {
            n: "BrtBeginSXCondFmt"
        },
        0x022F: {
            n: "BrtEndSXCondFmt"
        },
        0x0230: {
            n: "BrtBeginSXCondFmts"
        },
        0x0231: {
            n: "BrtEndSXCondFmts"
        },
        0x0232: {
            n: "BrtBkHim"
        },
        0x0234: {
            n: "BrtColor"
        },
        0x0235: {
            n: "BrtBeginIndexedColors"
        },
        0x0236: {
            n: "BrtEndIndexedColors"
        },
        0x0239: {
            n: "BrtBeginMRUColors"
        },
        0x023A: {
            n: "BrtEndMRUColors"
        },
        0x023C: {
            n: "BrtMRUColor"
        },
        0x023D: {
            n: "BrtBeginDVals"
        },
        0x023E: {
            n: "BrtEndDVals"
        },
        0x0241: {
            n: "BrtSupNameStart"
        },
        0x0242: {
            n: "BrtSupNameValueStart"
        },
        0x0243: {
            n: "BrtSupNameValueEnd"
        },
        0x0244: {
            n: "BrtSupNameNum"
        },
        0x0245: {
            n: "BrtSupNameErr"
        },
        0x0246: {
            n: "BrtSupNameSt"
        },
        0x0247: {
            n: "BrtSupNameNil"
        },
        0x0248: {
            n: "BrtSupNameBool"
        },
        0x0249: {
            n: "BrtSupNameFmla"
        },
        0x024A: {
            n: "BrtSupNameBits"
        },
        0x024B: {
            n: "BrtSupNameEnd"
        },
        0x024C: {
            n: "BrtEndSupBook"
        },
        0x024D: {
            n: "BrtCellSmartTagProperty"
        },
        0x024E: {
            n: "BrtBeginCellSmartTag"
        },
        0x024F: {
            n: "BrtEndCellSmartTag"
        },
        0x0250: {
            n: "BrtBeginCellSmartTags"
        },
        0x0251: {
            n: "BrtEndCellSmartTags"
        },
        0x0252: {
            n: "BrtBeginSmartTags"
        },
        0x0253: {
            n: "BrtEndSmartTags"
        },
        0x0254: {
            n: "BrtSmartTagType"
        },
        0x0255: {
            n: "BrtBeginSmartTagTypes"
        },
        0x0256: {
            n: "BrtEndSmartTagTypes"
        },
        0x0257: {
            n: "BrtBeginSXFilters"
        },
        0x0258: {
            n: "BrtEndSXFilters"
        },
        0x0259: {
            n: "BrtBeginSXFILTER"
        },
        0x025A: {
            n: "BrtEndSXFilter"
        },
        0x025B: {
            n: "BrtBeginFills"
        },
        0x025C: {
            n: "BrtEndFills"
        },
        0x025D: {
            n: "BrtBeginCellWatches"
        },
        0x025E: {
            n: "BrtEndCellWatches"
        },
        0x025F: {
            n: "BrtCellWatch"
        },
        0x0260: {
            n: "BrtBeginCRErrs"
        },
        0x0261: {
            n: "BrtEndCRErrs"
        },
        0x0262: {
            n: "BrtCrashRecErr"
        },
        0x0263: {
            n: "BrtBeginFonts"
        },
        0x0264: {
            n: "BrtEndFonts"
        },
        0x0265: {
            n: "BrtBeginBorders"
        },
        0x0266: {
            n: "BrtEndBorders"
        },
        0x0267: {
            n: "BrtBeginFmts"
        },
        0x0268: {
            n: "BrtEndFmts"
        },
        0x0269: {
            n: "BrtBeginCellXFs"
        },
        0x026A: {
            n: "BrtEndCellXFs"
        },
        0x026B: {
            n: "BrtBeginStyles"
        },
        0x026C: {
            n: "BrtEndStyles"
        },
        0x0271: {
            n: "BrtBigName"
        },
        0x0272: {
            n: "BrtBeginCellStyleXFs"
        },
        0x0273: {
            n: "BrtEndCellStyleXFs"
        },
        0x0274: {
            n: "BrtBeginComments"
        },
        0x0275: {
            n: "BrtEndComments"
        },
        0x0276: {
            n: "BrtBeginCommentAuthors"
        },
        0x0277: {
            n: "BrtEndCommentAuthors"
        },
        0x0278: {
            n: "BrtCommentAuthor",
            f: parse_BrtCommentAuthor
        },
        0x0279: {
            n: "BrtBeginCommentList"
        },
        0x027A: {
            n: "BrtEndCommentList"
        },
        0x027B: {
            n: "BrtBeginComment",
            f: parse_BrtBeginComment
        },
        0x027C: {
            n: "BrtEndComment"
        },
        0x027D: {
            n: "BrtCommentText",
            f: parse_BrtCommentText
        },
        0x027E: {
            n: "BrtBeginOleObjects"
        },
        0x027F: {
            n: "BrtOleObject"
        },
        0x0280: {
            n: "BrtEndOleObjects"
        },
        0x0281: {
            n: "BrtBeginSxrules"
        },
        0x0282: {
            n: "BrtEndSxRules"
        },
        0x0283: {
            n: "BrtBeginActiveXControls"
        },
        0x0284: {
            n: "BrtActiveX"
        },
        0x0285: {
            n: "BrtEndActiveXControls"
        },
        0x0286: {
            n: "BrtBeginPCDSDTCEMembersSortBy"
        },
        0x0288: {
            n: "BrtBeginCellIgnoreECs"
        },
        0x0289: {
            n: "BrtCellIgnoreEC"
        },
        0x028A: {
            n: "BrtEndCellIgnoreECs"
        },
        0x028B: {
            n: "BrtCsProp",
            f: parse_BrtCsProp
        },
        0x028C: {
            n: "BrtCsPageSetup"
        },
        0x028D: {
            n: "BrtBeginUserCsViews"
        },
        0x028E: {
            n: "BrtEndUserCsViews"
        },
        0x028F: {
            n: "BrtBeginUserCsView"
        },
        0x0290: {
            n: "BrtEndUserCsView"
        },
        0x0291: {
            n: "BrtBeginPcdSFCIEntries"
        },
        0x0292: {
            n: "BrtEndPCDSFCIEntries"
        },
        0x0293: {
            n: "BrtPCDSFCIEntry"
        },
        0x0294: {
            n: "BrtBeginListParts"
        },
        0x0295: {
            n: "BrtListPart"
        },
        0x0296: {
            n: "BrtEndListParts"
        },
        0x0297: {
            n: "BrtSheetCalcProp"
        },
        0x0298: {
            n: "BrtBeginFnGroup"
        },
        0x0299: {
            n: "BrtFnGroup"
        },
        0x029A: {
            n: "BrtEndFnGroup"
        },
        0x029B: {
            n: "BrtSupAddin"
        },
        0x029C: {
            n: "BrtSXTDMPOrder"
        },
        0x029D: {
            n: "BrtCsProtection"
        },
        0x029F: {
            n: "BrtBeginWsSortMap"
        },
        0x02A0: {
            n: "BrtEndWsSortMap"
        },
        0x02A1: {
            n: "BrtBeginRRSort"
        },
        0x02A2: {
            n: "BrtEndRRSort"
        },
        0x02A3: {
            n: "BrtRRSortItem"
        },
        0x02A4: {
            n: "BrtFileSharingIso"
        },
        0x02A5: {
            n: "BrtBookProtectionIso"
        },
        0x02A6: {
            n: "BrtSheetProtectionIso"
        },
        0x02A7: {
            n: "BrtCsProtectionIso"
        },
        0x02A8: {
            n: "BrtRangeProtectionIso"
        },
        0x02A9: {
            n: "BrtDValList"
        },
        0x0400: {
            n: "BrtRwDescent"
        },
        0x0401: {
            n: "BrtKnownFonts"
        },
        0x0402: {
            n: "BrtBeginSXTupleSet"
        },
        0x0403: {
            n: "BrtEndSXTupleSet"
        },
        0x0404: {
            n: "BrtBeginSXTupleSetHeader"
        },
        0x0405: {
            n: "BrtEndSXTupleSetHeader"
        },
        0x0406: {
            n: "BrtSXTupleSetHeaderItem"
        },
        0x0407: {
            n: "BrtBeginSXTupleSetData"
        },
        0x0408: {
            n: "BrtEndSXTupleSetData"
        },
        0x0409: {
            n: "BrtBeginSXTupleSetRow"
        },
        0x040A: {
            n: "BrtEndSXTupleSetRow"
        },
        0x040B: {
            n: "BrtSXTupleSetRowItem"
        },
        0x040C: {
            n: "BrtNameExt"
        },
        0x040D: {
            n: "BrtPCDH14"
        },
        0x040E: {
            n: "BrtBeginPCDCalcMem14"
        },
        0x040F: {
            n: "BrtEndPCDCalcMem14"
        },
        0x0410: {
            n: "BrtSXTH14"
        },
        0x0411: {
            n: "BrtBeginSparklineGroup"
        },
        0x0412: {
            n: "BrtEndSparklineGroup"
        },
        0x0413: {
            n: "BrtSparkline"
        },
        0x0414: {
            n: "BrtSXDI14"
        },
        0x0415: {
            n: "BrtWsFmtInfoEx14"
        },
        0x0416: {
            n: "BrtBeginConditionalFormatting14"
        },
        0x0417: {
            n: "BrtEndConditionalFormatting14"
        },
        0x0418: {
            n: "BrtBeginCFRule14"
        },
        0x0419: {
            n: "BrtEndCFRule14"
        },
        0x041A: {
            n: "BrtCFVO14"
        },
        0x041B: {
            n: "BrtBeginDatabar14"
        },
        0x041C: {
            n: "BrtBeginIconSet14"
        },
        0x041D: {
            n: "BrtDVal14",
            f: parse_BrtDVal14
        },
        0x041E: {
            n: "BrtBeginDVals14"
        },
        0x041F: {
            n: "BrtColor14"
        },
        0x0420: {
            n: "BrtBeginSparklines"
        },
        0x0421: {
            n: "BrtEndSparklines"
        },
        0x0422: {
            n: "BrtBeginSparklineGroups"
        },
        0x0423: {
            n: "BrtEndSparklineGroups"
        },
        0x0425: {
            n: "BrtSXVD14"
        },
        0x0426: {
            n: "BrtBeginSXView14"
        },
        0x0427: {
            n: "BrtEndSXView14"
        },
        0x0428: {
            n: "BrtBeginSXView16"
        },
        0x0429: {
            n: "BrtEndSXView16"
        },
        0x042A: {
            n: "BrtBeginPCD14"
        },
        0x042B: {
            n: "BrtEndPCD14"
        },
        0x042C: {
            n: "BrtBeginExtConn14"
        },
        0x042D: {
            n: "BrtEndExtConn14"
        },
        0x042E: {
            n: "BrtBeginSlicerCacheIDs"
        },
        0x042F: {
            n: "BrtEndSlicerCacheIDs"
        },
        0x0430: {
            n: "BrtBeginSlicerCacheID"
        },
        0x0431: {
            n: "BrtEndSlicerCacheID"
        },
        0x0433: {
            n: "BrtBeginSlicerCache"
        },
        0x0434: {
            n: "BrtEndSlicerCache"
        },
        0x0435: {
            n: "BrtBeginSlicerCacheDef"
        },
        0x0436: {
            n: "BrtEndSlicerCacheDef"
        },
        0x0437: {
            n: "BrtBeginSlicersEx"
        },
        0x0438: {
            n: "BrtEndSlicersEx"
        },
        0x0439: {
            n: "BrtBeginSlicerEx"
        },
        0x043A: {
            n: "BrtEndSlicerEx"
        },
        0x043B: {
            n: "BrtBeginSlicer"
        },
        0x043C: {
            n: "BrtEndSlicer"
        },
        0x043D: {
            n: "BrtSlicerCachePivotTables"
        },
        0x043E: {
            n: "BrtBeginSlicerCacheOlapImpl"
        },
        0x043F: {
            n: "BrtEndSlicerCacheOlapImpl"
        },
        0x0440: {
            n: "BrtBeginSlicerCacheLevelsData"
        },
        0x0441: {
            n: "BrtEndSlicerCacheLevelsData"
        },
        0x0442: {
            n: "BrtBeginSlicerCacheLevelData"
        },
        0x0443: {
            n: "BrtEndSlicerCacheLevelData"
        },
        0x0444: {
            n: "BrtBeginSlicerCacheSiRanges"
        },
        0x0445: {
            n: "BrtEndSlicerCacheSiRanges"
        },
        0x0446: {
            n: "BrtBeginSlicerCacheSiRange"
        },
        0x0447: {
            n: "BrtEndSlicerCacheSiRange"
        },
        0x0448: {
            n: "BrtSlicerCacheOlapItem"
        },
        0x0449: {
            n: "BrtBeginSlicerCacheSelections"
        },
        0x044A: {
            n: "BrtSlicerCacheSelection"
        },
        0x044B: {
            n: "BrtEndSlicerCacheSelections"
        },
        0x044C: {
            n: "BrtBeginSlicerCacheNative"
        },
        0x044D: {
            n: "BrtEndSlicerCacheNative"
        },
        0x044E: {
            n: "BrtSlicerCacheNativeItem"
        },
        0x044F: {
            n: "BrtRangeProtection14"
        },
        0x0450: {
            n: "BrtRangeProtectionIso14"
        },
        0x0451: {
            n: "BrtCellIgnoreEC14"
        },
        0x0457: {
            n: "BrtList14"
        },
        0x0458: {
            n: "BrtCFIcon"
        },
        0x0459: {
            n: "BrtBeginSlicerCachesPivotCacheIDs"
        },
        0x045A: {
            n: "BrtEndSlicerCachesPivotCacheIDs"
        },
        0x045B: {
            n: "BrtBeginSlicers"
        },
        0x045C: {
            n: "BrtEndSlicers"
        },
        0x045D: {
            n: "BrtWbProp14"
        },
        0x045E: {
            n: "BrtBeginSXEdit"
        },
        0x045F: {
            n: "BrtEndSXEdit"
        },
        0x0460: {
            n: "BrtBeginSXEdits"
        },
        0x0461: {
            n: "BrtEndSXEdits"
        },
        0x0462: {
            n: "BrtBeginSXChange"
        },
        0x0463: {
            n: "BrtEndSXChange"
        },
        0x0464: {
            n: "BrtBeginSXChanges"
        },
        0x0465: {
            n: "BrtEndSXChanges"
        },
        0x0466: {
            n: "BrtSXTupleItems"
        },
        0x0468: {
            n: "BrtBeginSlicerStyle"
        },
        0x0469: {
            n: "BrtEndSlicerStyle"
        },
        0x046A: {
            n: "BrtSlicerStyleElement"
        },
        0x046B: {
            n: "BrtBeginStyleSheetExt14"
        },
        0x046C: {
            n: "BrtEndStyleSheetExt14"
        },
        0x046D: {
            n: "BrtBeginSlicerCachesPivotCacheID"
        },
        0x046E: {
            n: "BrtEndSlicerCachesPivotCacheID"
        },
        0x046F: {
            n: "BrtBeginConditionalFormattings"
        },
        0x0470: {
            n: "BrtEndConditionalFormattings"
        },
        0x0471: {
            n: "BrtBeginPCDCalcMemExt"
        },
        0x0472: {
            n: "BrtEndPCDCalcMemExt"
        },
        0x0473: {
            n: "BrtBeginPCDCalcMemsExt"
        },
        0x0474: {
            n: "BrtEndPCDCalcMemsExt"
        },
        0x0475: {
            n: "BrtPCDField14"
        },
        0x0476: {
            n: "BrtBeginSlicerStyles"
        },
        0x0477: {
            n: "BrtEndSlicerStyles"
        },
        0x0478: {
            n: "BrtBeginSlicerStyleElements"
        },
        0x0479: {
            n: "BrtEndSlicerStyleElements"
        },
        0x047A: {
            n: "BrtCFRuleExt"
        },
        0x047B: {
            n: "BrtBeginSXCondFmt14"
        },
        0x047C: {
            n: "BrtEndSXCondFmt14"
        },
        0x047D: {
            n: "BrtBeginSXCondFmts14"
        },
        0x047E: {
            n: "BrtEndSXCondFmts14"
        },
        0x0480: {
            n: "BrtBeginSortCond14"
        },
        0x0481: {
            n: "BrtEndSortCond14"
        },
        0x0482: {
            n: "BrtEndDVals14"
        },
        0x0483: {
            n: "BrtEndIconSet14"
        },
        0x0484: {
            n: "BrtEndDatabar14"
        },
        0x0485: {
            n: "BrtBeginColorScale14"
        },
        0x0486: {
            n: "BrtEndColorScale14"
        },
        0x0487: {
            n: "BrtBeginSxrules14"
        },
        0x0488: {
            n: "BrtEndSxrules14"
        },
        0x0489: {
            n: "BrtBeginPRule14"
        },
        0x048A: {
            n: "BrtEndPRule14"
        },
        0x048B: {
            n: "BrtBeginPRFilters14"
        },
        0x048C: {
            n: "BrtEndPRFilters14"
        },
        0x048D: {
            n: "BrtBeginPRFilter14"
        },
        0x048E: {
            n: "BrtEndPRFilter14"
        },
        0x048F: {
            n: "BrtBeginPRFItem14"
        },
        0x0490: {
            n: "BrtEndPRFItem14"
        },
        0x0491: {
            n: "BrtBeginCellIgnoreECs14"
        },
        0x0492: {
            n: "BrtEndCellIgnoreECs14"
        },
        0x0493: {
            n: "BrtDxf14"
        },
        0x0494: {
            n: "BrtBeginDxF14s"
        },
        0x0495: {
            n: "BrtEndDxf14s"
        },
        0x0499: {
            n: "BrtFilter14"
        },
        0x049A: {
            n: "BrtBeginCustomFilters14"
        },
        0x049C: {
            n: "BrtCustomFilter14"
        },
        0x049D: {
            n: "BrtIconFilter14"
        },
        0x049E: {
            n: "BrtPivotCacheConnectionName"
        },
        0x0800: {
            n: "BrtBeginDecoupledPivotCacheIDs"
        },
        0x0801: {
            n: "BrtEndDecoupledPivotCacheIDs"
        },
        0x0802: {
            n: "BrtDecoupledPivotCacheID"
        },
        0x0803: {
            n: "BrtBeginPivotTableRefs"
        },
        0x0804: {
            n: "BrtEndPivotTableRefs"
        },
        0x0805: {
            n: "BrtPivotTableRef"
        },
        0x0806: {
            n: "BrtSlicerCacheBookPivotTables"
        },
        0x0807: {
            n: "BrtBeginSxvcells"
        },
        0x0808: {
            n: "BrtEndSxvcells"
        },
        0x0809: {
            n: "BrtBeginSxRow"
        },
        0x080A: {
            n: "BrtEndSxRow"
        },
        0x080C: {
            n: "BrtPcdCalcMem15"
        },
        0x0813: {
            n: "BrtQsi15"
        },
        0x0814: {
            n: "BrtBeginWebExtensions"
        },
        0x0815: {
            n: "BrtEndWebExtensions"
        },
        0x0816: {
            n: "BrtWebExtension"
        },
        0x0817: {
            n: "BrtAbsPath15"
        },
        0x0818: {
            n: "BrtBeginPivotTableUISettings"
        },
        0x0819: {
            n: "BrtEndPivotTableUISettings"
        },
        0x081B: {
            n: "BrtTableSlicerCacheIDs"
        },
        0x081C: {
            n: "BrtTableSlicerCacheID"
        },
        0x081D: {
            n: "BrtBeginTableSlicerCache"
        },
        0x081E: {
            n: "BrtEndTableSlicerCache"
        },
        0x081F: {
            n: "BrtSxFilter15"
        },
        0x0820: {
            n: "BrtBeginTimelineCachePivotCacheIDs"
        },
        0x0821: {
            n: "BrtEndTimelineCachePivotCacheIDs"
        },
        0x0822: {
            n: "BrtTimelineCachePivotCacheID"
        },
        0x0823: {
            n: "BrtBeginTimelineCacheIDs"
        },
        0x0824: {
            n: "BrtEndTimelineCacheIDs"
        },
        0x0825: {
            n: "BrtBeginTimelineCacheID"
        },
        0x0826: {
            n: "BrtEndTimelineCacheID"
        },
        0x0827: {
            n: "BrtBeginTimelinesEx"
        },
        0x0828: {
            n: "BrtEndTimelinesEx"
        },
        0x0829: {
            n: "BrtBeginTimelineEx"
        },
        0x082A: {
            n: "BrtEndTimelineEx"
        },
        0x082B: {
            n: "BrtWorkBookPr15"
        },
        0x082C: {
            n: "BrtPCDH15"
        },
        0x082D: {
            n: "BrtBeginTimelineStyle"
        },
        0x082E: {
            n: "BrtEndTimelineStyle"
        },
        0x082F: {
            n: "BrtTimelineStyleElement"
        },
        0x0830: {
            n: "BrtBeginTimelineStylesheetExt15"
        },
        0x0831: {
            n: "BrtEndTimelineStylesheetExt15"
        },
        0x0832: {
            n: "BrtBeginTimelineStyles"
        },
        0x0833: {
            n: "BrtEndTimelineStyles"
        },
        0x0834: {
            n: "BrtBeginTimelineStyleElements"
        },
        0x0835: {
            n: "BrtEndTimelineStyleElements"
        },
        0x0836: {
            n: "BrtDxf15"
        },
        0x0837: {
            n: "BrtBeginDxfs15"
        },
        0x0838: {
            n: "brtEndDxfs15"
        },
        0x0839: {
            n: "BrtSlicerCacheHideItemsWithNoData"
        },
        0x083A: {
            n: "BrtBeginItemUniqueNames"
        },
        0x083B: {
            n: "BrtEndItemUniqueNames"
        },
        0x083C: {
            n: "BrtItemUniqueName"
        },
        0x083D: {
            n: "BrtBeginExtConn15"
        },
        0x083E: {
            n: "BrtEndExtConn15"
        },
        0x083F: {
            n: "BrtBeginOledbPr15"
        },
        0x0840: {
            n: "BrtEndOledbPr15"
        },
        0x0841: {
            n: "BrtBeginDataFeedPr15"
        },
        0x0842: {
            n: "BrtEndDataFeedPr15"
        },
        0x0843: {
            n: "BrtTextPr15"
        },
        0x0844: {
            n: "BrtRangePr15"
        },
        0x0845: {
            n: "BrtDbCommand15"
        },
        0x0846: {
            n: "BrtBeginDbTables15"
        },
        0x0847: {
            n: "BrtEndDbTables15"
        },
        0x0848: {
            n: "BrtDbTable15"
        },
        0x0849: {
            n: "BrtBeginDataModel"
        },
        0x084A: {
            n: "BrtEndDataModel"
        },
        0x084B: {
            n: "BrtBeginModelTables"
        },
        0x084C: {
            n: "BrtEndModelTables"
        },
        0x084D: {
            n: "BrtModelTable"
        },
        0x084E: {
            n: "BrtBeginModelRelationships"
        },
        0x084F: {
            n: "BrtEndModelRelationships"
        },
        0x0850: {
            n: "BrtModelRelationship"
        },
        0x0851: {
            n: "BrtBeginECTxtWiz15"
        },
        0x0852: {
            n: "BrtEndECTxtWiz15"
        },
        0x0853: {
            n: "BrtBeginECTWFldInfoLst15"
        },
        0x0854: {
            n: "BrtEndECTWFldInfoLst15"
        },
        0x0855: {
            n: "BrtBeginECTWFldInfo15"
        },
        0x0856: {
            n: "BrtFieldListActiveItem"
        },
        0x0857: {
            n: "BrtPivotCacheIdVersion"
        },
        0x0858: {
            n: "BrtSXDI15"
        },
        0x0859: {
            n: "BrtBeginModelTimeGroupings"
        },
        0x085A: {
            n: "BrtEndModelTimeGroupings"
        },
        0x085B: {
            n: "BrtBeginModelTimeGrouping"
        },
        0x085C: {
            n: "BrtEndModelTimeGrouping"
        },
        0x085D: {
            n: "BrtModelTimeGroupingCalcCol"
        },
        0x0C00: {
            n: "BrtUid"
        },
        0x0C01: {
            n: "BrtRevisionPtr"
        },
        0x13e7: {
            n: "BrtBeginCalcFeatures"
        },
        0x13e8: {
            n: "BrtEndCalcFeatures"
        },
        0x13e9: {
            n: "BrtCalcFeature"
        },
        0xFFFF: {
            n: ""
        }
    };
    var XLSBRE = evert_key(XLSBRecordEnum, 'n');
    /* [MS-XLS] 2.3 Record Enumeration */ var XLSRecordEnum = {
        0x0003: {
            n: "BIFF2NUM",
            f: parse_BIFF2NUM
        },
        0x0004: {
            n: "BIFF2STR",
            f: parse_BIFF2STR
        },
        0x0006: {
            n: "Formula",
            f: parse_Formula
        },
        0x0009: {
            n: 'BOF',
            f: parse_BOF
        },
        0x000a: {
            n: 'EOF',
            f: parsenoop2
        },
        0x000c: {
            n: "CalcCount",
            f: parseuint16
        },
        0x000d: {
            n: "CalcMode",
            f: parseuint16
        },
        0x000e: {
            n: "CalcPrecision",
            f: parsebool
        },
        0x000f: {
            n: "CalcRefMode",
            f: parsebool
        },
        0x0010: {
            n: "CalcDelta",
            f: parse_Xnum
        },
        0x0011: {
            n: "CalcIter",
            f: parsebool
        },
        0x0012: {
            n: "Protect",
            f: parsebool
        },
        0x0013: {
            n: "Password",
            f: parseuint16
        },
        0x0014: {
            n: "Header",
            f: parse_XLHeaderFooter
        },
        0x0015: {
            n: "Footer",
            f: parse_XLHeaderFooter
        },
        0x0017: {
            n: "ExternSheet",
            f: parse_ExternSheet
        },
        0x0018: {
            n: "Lbl",
            f: parse_Lbl
        },
        0x0019: {
            n: "WinProtect",
            f: parsebool
        },
        0x001a: {
            n: "VerticalPageBreaks"
        },
        0x001b: {
            n: "HorizontalPageBreaks"
        },
        0x001c: {
            n: "Note",
            f: parse_Note
        },
        0x001d: {
            n: "Selection"
        },
        0x0022: {
            n: "Date1904",
            f: parsebool
        },
        0x0023: {
            n: "ExternName",
            f: parse_ExternName
        },
        0x0024: {
            n: "COLWIDTH"
        },
        0x0026: {
            n: "LeftMargin",
            f: parse_Xnum
        },
        0x0027: {
            n: "RightMargin",
            f: parse_Xnum
        },
        0x0028: {
            n: "TopMargin",
            f: parse_Xnum
        },
        0x0029: {
            n: "BottomMargin",
            f: parse_Xnum
        },
        0x002a: {
            n: "PrintRowCol",
            f: parsebool
        },
        0x002b: {
            n: "PrintGrid",
            f: parsebool
        },
        0x002f: {
            n: "FilePass",
            f: parse_FilePass
        },
        0x0031: {
            n: "Font",
            f: parse_Font
        },
        0x0033: {
            n: "PrintSize",
            f: parseuint16
        },
        0x003c: {
            n: "Continue"
        },
        0x003d: {
            n: "Window1",
            f: parse_Window1
        },
        0x0040: {
            n: "Backup",
            f: parsebool
        },
        0x0041: {
            n: "Pane",
            f: parse_Pane
        },
        0x0042: {
            n: 'CodePage',
            f: parseuint16
        },
        0x004d: {
            n: "Pls"
        },
        0x0050: {
            n: "DCon"
        },
        0x0051: {
            n: "DConRef"
        },
        0x0052: {
            n: "DConName"
        },
        0x0055: {
            n: "DefColWidth",
            f: parseuint16
        },
        0x0059: {
            n: "XCT"
        },
        0x005a: {
            n: "CRN"
        },
        0x005b: {
            n: "FileSharing"
        },
        0x005c: {
            n: 'WriteAccess',
            f: parse_WriteAccess
        },
        0x005d: {
            n: "Obj",
            f: parse_Obj
        },
        0x005e: {
            n: "Uncalced"
        },
        0x005f: {
            n: "CalcSaveRecalc",
            f: parsebool
        },
        0x0060: {
            n: "Template"
        },
        0x0061: {
            n: "Intl"
        },
        0x0063: {
            n: "ObjProtect",
            f: parsebool
        },
        0x007d: {
            n: "ColInfo",
            f: parse_ColInfo
        },
        0x0080: {
            n: "Guts",
            f: parse_Guts
        },
        0x0081: {
            n: "WsBool",
            f: parse_WsBool
        },
        0x0082: {
            n: "GridSet",
            f: parseuint16
        },
        0x0083: {
            n: "HCenter",
            f: parsebool
        },
        0x0084: {
            n: "VCenter",
            f: parsebool
        },
        0x0085: {
            n: 'BoundSheet8',
            f: parse_BoundSheet8
        },
        0x0086: {
            n: "WriteProtect"
        },
        0x008c: {
            n: "Country",
            f: parse_Country
        },
        0x008d: {
            n: "HideObj",
            f: parseuint16
        },
        0x0090: {
            n: "Sort"
        },
        0x0092: {
            n: "Palette",
            f: parse_Palette
        },
        0x0097: {
            n: "Sync"
        },
        0x0098: {
            n: "LPr"
        },
        0x0099: {
            n: "DxGCol"
        },
        0x009a: {
            n: "FnGroupName"
        },
        0x009b: {
            n: "FilterMode"
        },
        0x009c: {
            n: "BuiltInFnGroupCount",
            f: parseuint16
        },
        0x009d: {
            n: "AutoFilterInfo"
        },
        0x009e: {
            n: "AutoFilter"
        },
        0x00a0: {
            n: "Scl",
            f: parse_Scl
        },
        0x00a1: {
            n: "Setup",
            f: parse_Setup
        },
        0x00ae: {
            n: "ScenMan"
        },
        0x00af: {
            n: "SCENARIO"
        },
        0x00b0: {
            n: "SxView"
        },
        0x00b1: {
            n: "Sxvd"
        },
        0x00b2: {
            n: "SXVI"
        },
        0x00b4: {
            n: "SxIvd"
        },
        0x00b5: {
            n: "SXLI"
        },
        0x00b6: {
            n: "SXPI"
        },
        0x00b8: {
            n: "DocRoute"
        },
        0x00b9: {
            n: "RecipName"
        },
        0x00bd: {
            n: "MulRk",
            f: parse_MulRk
        },
        0x00be: {
            n: "MulBlank",
            f: parse_MulBlank
        },
        0x00c1: {
            n: 'Mms',
            f: parsenoop2
        },
        0x00c5: {
            n: "SXDI"
        },
        0x00c6: {
            n: "SXDB"
        },
        0x00c7: {
            n: "SXFDB"
        },
        0x00c8: {
            n: "SXDBB"
        },
        0x00c9: {
            n: "SXNum"
        },
        0x00ca: {
            n: "SxBool",
            f: parsebool
        },
        0x00cb: {
            n: "SxErr"
        },
        0x00cc: {
            n: "SXInt"
        },
        0x00cd: {
            n: "SXString"
        },
        0x00ce: {
            n: "SXDtr"
        },
        0x00cf: {
            n: "SxNil"
        },
        0x00d0: {
            n: "SXTbl"
        },
        0x00d1: {
            n: "SXTBRGIITM"
        },
        0x00d2: {
            n: "SxTbpg"
        },
        0x00d3: {
            n: "ObProj"
        },
        0x00d5: {
            n: "SXStreamID"
        },
        0x00d7: {
            n: "DBCell"
        },
        0x00d8: {
            n: "SXRng"
        },
        0x00d9: {
            n: "SxIsxoper"
        },
        0x00da: {
            n: "BookBool",
            f: parseuint16
        },
        0x00dc: {
            n: "DbOrParamQry"
        },
        0x00dd: {
            n: "ScenarioProtect",
            f: parsebool
        },
        0x00de: {
            n: "OleObjectSize"
        },
        0x00e0: {
            n: "XF",
            f: parse_XF
        },
        0x00e1: {
            n: 'InterfaceHdr',
            f: parse_InterfaceHdr
        },
        0x00e2: {
            n: 'InterfaceEnd',
            f: parsenoop2
        },
        0x00e3: {
            n: "SXVS"
        },
        0x00e5: {
            n: "MergeCells",
            f: parse_MergeCells
        },
        0x00e9: {
            n: "BkHim"
        },
        0x00eb: {
            n: "MsoDrawingGroup"
        },
        0x00ec: {
            n: "MsoDrawing"
        },
        0x00ed: {
            n: "MsoDrawingSelection"
        },
        0x00ef: {
            n: "PhoneticInfo"
        },
        0x00f0: {
            n: "SxRule"
        },
        0x00f1: {
            n: "SXEx"
        },
        0x00f2: {
            n: "SxFilt"
        },
        0x00f4: {
            n: "SxDXF"
        },
        0x00f5: {
            n: "SxItm"
        },
        0x00f6: {
            n: "SxName"
        },
        0x00f7: {
            n: "SxSelect"
        },
        0x00f8: {
            n: "SXPair"
        },
        0x00f9: {
            n: "SxFmla"
        },
        0x00fb: {
            n: "SxFormat"
        },
        0x00fc: {
            n: "SST",
            f: parse_SST
        },
        0x00fd: {
            n: "LabelSst",
            f: parse_LabelSst
        },
        0x00ff: {
            n: "ExtSST",
            f: parse_ExtSST
        },
        0x0100: {
            n: "SXVDEx"
        },
        0x0103: {
            n: "SXFormula"
        },
        0x0122: {
            n: "SXDBEx"
        },
        0x0137: {
            n: "RRDInsDel"
        },
        0x0138: {
            n: "RRDHead"
        },
        0x013b: {
            n: "RRDChgCell"
        },
        0x013d: {
            n: "RRTabId",
            f: parseuint16a
        },
        0x013e: {
            n: "RRDRenSheet"
        },
        0x013f: {
            n: "RRSort"
        },
        0x0140: {
            n: "RRDMove"
        },
        0x014a: {
            n: "RRFormat"
        },
        0x014b: {
            n: "RRAutoFmt"
        },
        0x014d: {
            n: "RRInsertSh"
        },
        0x014e: {
            n: "RRDMoveBegin"
        },
        0x014f: {
            n: "RRDMoveEnd"
        },
        0x0150: {
            n: "RRDInsDelBegin"
        },
        0x0151: {
            n: "RRDInsDelEnd"
        },
        0x0152: {
            n: "RRDConflict"
        },
        0x0153: {
            n: "RRDDefName"
        },
        0x0154: {
            n: "RRDRstEtxp"
        },
        0x015f: {
            n: "LRng"
        },
        0x0160: {
            n: "UsesELFs",
            f: parsebool
        },
        0x0161: {
            n: "DSF",
            f: parsenoop2
        },
        0x0191: {
            n: "CUsr"
        },
        0x0192: {
            n: "CbUsr"
        },
        0x0193: {
            n: "UsrInfo"
        },
        0x0194: {
            n: "UsrExcl"
        },
        0x0195: {
            n: "FileLock"
        },
        0x0196: {
            n: "RRDInfo"
        },
        0x0197: {
            n: "BCUsrs"
        },
        0x0198: {
            n: "UsrChk"
        },
        0x01a9: {
            n: "UserBView"
        },
        0x01aa: {
            n: "UserSViewBegin"
        },
        0x01ab: {
            n: "UserSViewEnd"
        },
        0x01ac: {
            n: "RRDUserView"
        },
        0x01ad: {
            n: "Qsi"
        },
        0x01ae: {
            n: "SupBook",
            f: parse_SupBook
        },
        0x01af: {
            n: "Prot4Rev",
            f: parsebool
        },
        0x01b0: {
            n: "CondFmt"
        },
        0x01b1: {
            n: "CF"
        },
        0x01b2: {
            n: "DVal"
        },
        0x01b5: {
            n: "DConBin"
        },
        0x01b6: {
            n: "TxO",
            f: parse_TxO
        },
        0x01b7: {
            n: "RefreshAll",
            f: parsebool
        },
        0x01b8: {
            n: "HLink",
            f: parse_HLink
        },
        0x01b9: {
            n: "Lel"
        },
        0x01ba: {
            n: "CodeName",
            f: parse_XLUnicodeString
        },
        0x01bb: {
            n: "SXFDBType"
        },
        0x01bc: {
            n: "Prot4RevPass",
            f: parseuint16
        },
        0x01bd: {
            n: "ObNoMacros"
        },
        0x01be: {
            n: "Dv"
        },
        0x01c0: {
            n: "Excel9File",
            f: parsenoop2
        },
        0x01c1: {
            n: "RecalcId",
            f: parse_RecalcId,
            r: 2
        },
        0x01c2: {
            n: "EntExU2",
            f: parsenoop2
        },
        0x0200: {
            n: "Dimensions",
            f: parse_Dimensions
        },
        0x0201: {
            n: "Blank",
            f: parse_Blank
        },
        0x0203: {
            n: "Number",
            f: parse_Number
        },
        0x0204: {
            n: "Label",
            f: parse_Label
        },
        0x0205: {
            n: "BoolErr",
            f: parse_BoolErr
        },
        0x0206: {
            n: "Formula",
            f: parse_Formula
        },
        0x0207: {
            n: "String",
            f: parse_String
        },
        0x0208: {
            n: 'Row',
            f: parse_Row
        },
        0x020b: {
            n: "Index"
        },
        0x0221: {
            n: "Array",
            f: parse_Array
        },
        0x0225: {
            n: "DefaultRowHeight",
            f: parse_DefaultRowHeight
        },
        0x0236: {
            n: "Table"
        },
        0x023e: {
            n: "Window2",
            f: parse_Window2
        },
        0x027e: {
            n: "RK",
            f: parse_RK
        },
        0x0293: {
            n: "Style"
        },
        0x0406: {
            n: "Formula",
            f: parse_Formula
        },
        0x0418: {
            n: "BigName"
        },
        0x041e: {
            n: "Format",
            f: parse_Format
        },
        0x043c: {
            n: "ContinueBigName"
        },
        0x04bc: {
            n: "ShrFmla",
            f: parse_ShrFmla
        },
        0x0800: {
            n: "HLinkTooltip",
            f: parse_HLinkTooltip
        },
        0x0801: {
            n: "WebPub"
        },
        0x0802: {
            n: "QsiSXTag"
        },
        0x0803: {
            n: "DBQueryExt"
        },
        0x0804: {
            n: "ExtString"
        },
        0x0805: {
            n: "TxtQry"
        },
        0x0806: {
            n: "Qsir"
        },
        0x0807: {
            n: "Qsif"
        },
        0x0808: {
            n: "RRDTQSIF"
        },
        0x0809: {
            n: 'BOF',
            f: parse_BOF
        },
        0x080a: {
            n: "OleDbConn"
        },
        0x080b: {
            n: "WOpt"
        },
        0x080c: {
            n: "SXViewEx"
        },
        0x080d: {
            n: "SXTH"
        },
        0x080e: {
            n: "SXPIEx"
        },
        0x080f: {
            n: "SXVDTEx"
        },
        0x0810: {
            n: "SXViewEx9"
        },
        0x0812: {
            n: "ContinueFrt"
        },
        0x0813: {
            n: "RealTimeData"
        },
        0x0850: {
            n: "ChartFrtInfo"
        },
        0x0851: {
            n: "FrtWrapper"
        },
        0x0852: {
            n: "StartBlock"
        },
        0x0853: {
            n: "EndBlock"
        },
        0x0854: {
            n: "StartObject"
        },
        0x0855: {
            n: "EndObject"
        },
        0x0856: {
            n: "CatLab"
        },
        0x0857: {
            n: "YMult"
        },
        0x0858: {
            n: "SXViewLink"
        },
        0x0859: {
            n: "PivotChartBits"
        },
        0x085a: {
            n: "FrtFontList"
        },
        0x0862: {
            n: "SheetExt"
        },
        0x0863: {
            n: "BookExt",
            r: 12
        },
        0x0864: {
            n: "SXAddl"
        },
        0x0865: {
            n: "CrErr"
        },
        0x0866: {
            n: "HFPicture"
        },
        0x0867: {
            n: 'FeatHdr',
            f: parsenoop2
        },
        0x0868: {
            n: "Feat"
        },
        0x086a: {
            n: "DataLabExt"
        },
        0x086b: {
            n: "DataLabExtContents"
        },
        0x086c: {
            n: "CellWatch"
        },
        0x0871: {
            n: "FeatHdr11"
        },
        0x0872: {
            n: "Feature11"
        },
        0x0874: {
            n: "DropDownObjIds"
        },
        0x0875: {
            n: "ContinueFrt11"
        },
        0x0876: {
            n: "DConn"
        },
        0x0877: {
            n: "List12"
        },
        0x0878: {
            n: "Feature12"
        },
        0x0879: {
            n: "CondFmt12"
        },
        0x087a: {
            n: "CF12"
        },
        0x087b: {
            n: "CFEx"
        },
        0x087c: {
            n: "XFCRC",
            f: parse_XFCRC,
            r: 12
        },
        0x087d: {
            n: "XFExt",
            f: parse_XFExt,
            r: 12
        },
        0x087e: {
            n: "AutoFilter12"
        },
        0x087f: {
            n: "ContinueFrt12"
        },
        0x0884: {
            n: "MDTInfo"
        },
        0x0885: {
            n: "MDXStr"
        },
        0x0886: {
            n: "MDXTuple"
        },
        0x0887: {
            n: "MDXSet"
        },
        0x0888: {
            n: "MDXProp"
        },
        0x0889: {
            n: "MDXKPI"
        },
        0x088a: {
            n: "MDB"
        },
        0x088b: {
            n: "PLV"
        },
        0x088c: {
            n: "Compat12",
            f: parsebool,
            r: 12
        },
        0x088d: {
            n: "DXF"
        },
        0x088e: {
            n: "TableStyles",
            r: 12
        },
        0x088f: {
            n: "TableStyle"
        },
        0x0890: {
            n: "TableStyleElement"
        },
        0x0892: {
            n: "StyleExt"
        },
        0x0893: {
            n: "NamePublish"
        },
        0x0894: {
            n: "NameCmt",
            f: parse_NameCmt,
            r: 12
        },
        0x0895: {
            n: "SortData"
        },
        0x0896: {
            n: "Theme",
            f: parse_Theme,
            r: 12
        },
        0x0897: {
            n: "GUIDTypeLib"
        },
        0x0898: {
            n: "FnGrp12"
        },
        0x0899: {
            n: "NameFnGrp12"
        },
        0x089a: {
            n: "MTRSettings",
            f: parse_MTRSettings,
            r: 12
        },
        0x089b: {
            n: "CompressPictures",
            f: parsenoop2
        },
        0x089c: {
            n: "HeaderFooter"
        },
        0x089d: {
            n: "CrtLayout12"
        },
        0x089e: {
            n: "CrtMlFrt"
        },
        0x089f: {
            n: "CrtMlFrtContinue"
        },
        0x08a3: {
            n: "ForceFullCalculation",
            f: parse_ForceFullCalculation
        },
        0x08a4: {
            n: "ShapePropsStream"
        },
        0x08a5: {
            n: "TextPropsStream"
        },
        0x08a6: {
            n: "RichTextStream"
        },
        0x08a7: {
            n: "CrtLayout12A"
        },
        0x1001: {
            n: "Units"
        },
        0x1002: {
            n: "Chart"
        },
        0x1003: {
            n: "Series"
        },
        0x1006: {
            n: "DataFormat"
        },
        0x1007: {
            n: "LineFormat"
        },
        0x1009: {
            n: "MarkerFormat"
        },
        0x100a: {
            n: "AreaFormat"
        },
        0x100b: {
            n: "PieFormat"
        },
        0x100c: {
            n: "AttachedLabel"
        },
        0x100d: {
            n: "SeriesText"
        },
        0x1014: {
            n: "ChartFormat"
        },
        0x1015: {
            n: "Legend"
        },
        0x1016: {
            n: "SeriesList"
        },
        0x1017: {
            n: "Bar"
        },
        0x1018: {
            n: "Line"
        },
        0x1019: {
            n: "Pie"
        },
        0x101a: {
            n: "Area"
        },
        0x101b: {
            n: "Scatter"
        },
        0x101c: {
            n: "CrtLine"
        },
        0x101d: {
            n: "Axis"
        },
        0x101e: {
            n: "Tick"
        },
        0x101f: {
            n: "ValueRange"
        },
        0x1020: {
            n: "CatSerRange"
        },
        0x1021: {
            n: "AxisLine"
        },
        0x1022: {
            n: "CrtLink"
        },
        0x1024: {
            n: "DefaultText"
        },
        0x1025: {
            n: "Text"
        },
        0x1026: {
            n: "FontX",
            f: parseuint16
        },
        0x1027: {
            n: "ObjectLink"
        },
        0x1032: {
            n: "Frame"
        },
        0x1033: {
            n: "Begin"
        },
        0x1034: {
            n: "End"
        },
        0x1035: {
            n: "PlotArea"
        },
        0x103a: {
            n: "Chart3d"
        },
        0x103c: {
            n: "PicF"
        },
        0x103d: {
            n: "DropBar"
        },
        0x103e: {
            n: "Radar"
        },
        0x103f: {
            n: "Surf"
        },
        0x1040: {
            n: "RadarArea"
        },
        0x1041: {
            n: "AxisParent"
        },
        0x1043: {
            n: "LegendException"
        },
        0x1044: {
            n: "ShtProps",
            f: parse_ShtProps
        },
        0x1045: {
            n: "SerToCrt"
        },
        0x1046: {
            n: "AxesUsed"
        },
        0x1048: {
            n: "SBaseRef"
        },
        0x104a: {
            n: "SerParent"
        },
        0x104b: {
            n: "SerAuxTrend"
        },
        0x104e: {
            n: "IFmtRecord"
        },
        0x104f: {
            n: "Pos"
        },
        0x1050: {
            n: "AlRuns"
        },
        0x1051: {
            n: "BRAI"
        },
        0x105b: {
            n: "SerAuxErrBar"
        },
        0x105c: {
            n: "ClrtClient",
            f: parse_ClrtClient
        },
        0x105d: {
            n: "SerFmt"
        },
        0x105f: {
            n: "Chart3DBarShape"
        },
        0x1060: {
            n: "Fbi"
        },
        0x1061: {
            n: "BopPop"
        },
        0x1062: {
            n: "AxcExt"
        },
        0x1063: {
            n: "Dat"
        },
        0x1064: {
            n: "PlotGrowth"
        },
        0x1065: {
            n: "SIIndex"
        },
        0x1066: {
            n: "GelFrame"
        },
        0x1067: {
            n: "BopPopCustom"
        },
        0x1068: {
            n: "Fbi2"
        },
        0x0000: {
            n: "Dimensions",
            f: parse_Dimensions
        },
        0x0002: {
            n: "BIFF2INT",
            f: parse_BIFF2INT
        },
        0x0005: {
            n: "BoolErr",
            f: parse_BoolErr
        },
        0x0007: {
            n: "String",
            f: parse_BIFF2STRING
        },
        0x0008: {
            n: "BIFF2ROW"
        },
        0x000b: {
            n: "Index"
        },
        0x0016: {
            n: "ExternCount",
            f: parseuint16
        },
        0x001e: {
            n: "BIFF2FORMAT",
            f: parse_BIFF2Format
        },
        0x001f: {
            n: "BIFF2FMTCNT"
        },
        /* 16-bit cnt of BIFF2FORMAT records */ 0x0020: {
            n: "BIFF2COLINFO"
        },
        0x0021: {
            n: "Array",
            f: parse_Array
        },
        0x0025: {
            n: "DefaultRowHeight",
            f: parse_DefaultRowHeight
        },
        0x0032: {
            n: "BIFF2FONTXTRA",
            f: parse_BIFF2FONTXTRA
        },
        0x0034: {
            n: "DDEObjName"
        },
        0x003e: {
            n: "BIFF2WINDOW2"
        },
        0x0043: {
            n: "BIFF2XF"
        },
        0x0045: {
            n: "BIFF2FONTCLR"
        },
        0x0056: {
            n: "BIFF4FMTCNT"
        },
        /* 16-bit cnt, similar to BIFF2 */ 0x007e: {
            n: "RK"
        },
        /* Not necessarily same as 0x027e */ 0x007f: {
            n: "ImData",
            f: parse_ImData
        },
        0x0087: {
            n: "Addin"
        },
        0x0088: {
            n: "Edg"
        },
        0x0089: {
            n: "Pub"
        },
        0x0091: {
            n: "Sub"
        },
        0x0094: {
            n: "LHRecord"
        },
        0x0095: {
            n: "LHNGraph"
        },
        0x0096: {
            n: "Sound"
        },
        0x00a9: {
            n: "CoordList"
        },
        0x00ab: {
            n: "GCW"
        },
        0x00bc: {
            n: "ShrFmla"
        },
        /* Not necessarily same as 0x04bc */ 0x00bf: {
            n: "ToolbarHdr"
        },
        0x00c0: {
            n: "ToolbarEnd"
        },
        0x00c2: {
            n: "AddMenu"
        },
        0x00c3: {
            n: "DelMenu"
        },
        0x00d6: {
            n: "RString",
            f: parse_RString
        },
        0x00df: {
            n: "UDDesc"
        },
        0x00ea: {
            n: "TabIdConf"
        },
        0x0162: {
            n: "XL5Modify"
        },
        0x01a5: {
            n: "FileSharing2"
        },
        0x0209: {
            n: 'BOF',
            f: parse_BOF
        },
        0x0218: {
            n: "Lbl",
            f: parse_Lbl
        },
        0x0223: {
            n: "ExternName",
            f: parse_ExternName
        },
        0x0231: {
            n: "Font"
        },
        0x0243: {
            n: "BIFF3XF"
        },
        0x0409: {
            n: 'BOF',
            f: parse_BOF
        },
        0x0443: {
            n: "BIFF4XF"
        },
        0x086d: {
            n: "FeatInfo"
        },
        0x0873: {
            n: "FeatInfo11"
        },
        0x0881: {
            n: "SXAddl12"
        },
        0x08c0: {
            n: "AutoWebPub"
        },
        0x08c1: {
            n: "ListObj"
        },
        0x08c2: {
            n: "ListField"
        },
        0x08c3: {
            n: "ListDV"
        },
        0x08c4: {
            n: "ListCondFmt"
        },
        0x08c5: {
            n: "ListCF"
        },
        0x08c6: {
            n: "FMQry"
        },
        0x08c7: {
            n: "FMSQry"
        },
        0x08c8: {
            n: "PLV"
        },
        0x08c9: {
            n: "LnExt"
        },
        0x08ca: {
            n: "MkrExt"
        },
        0x08cb: {
            n: "CrtCoopt"
        },
        0x08d6: {
            n: "FRTArchId$",
            r: 12
        },
        0x7262: {}
    };
    var XLSRE = evert_key(XLSRecordEnum, 'n');
    function write_biff_rec(ba, type, payload, length) {
        var t = +type || +XLSRE[type];
        if (isNaN(t)) return;
        var len = length || (payload || []).length || 0;
        var o = ba.next(4);
        o.write_shift(2, t);
        o.write_shift(2, len);
        if (len > 0 && is_buf(payload)) ba.push(payload);
    }
    function write_biff_continue(ba, type, payload, length) {
        var len = length || (payload || []).length || 0;
        if (len <= 8224) return write_biff_rec(ba, type, payload, len);
        var t = +type || +XLSRE[type];
        if (isNaN(t)) return;
        var parts = payload.parts || [], sidx = 0;
        var i = 0, w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        var o = ba.next(4);
        o.write_shift(2, t);
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
        while(i < len){
            o = ba.next(4);
            o.write_shift(2, 0x3c); // TODO: figure out correct continue type
            w = 0;
            while(w + (parts[sidx] || 8224) <= 8224){
                w += parts[sidx] || 8224;
                sidx++;
            }
            o.write_shift(2, w);
            ba.push(payload.slice(i, i + w));
            i += w;
        }
    }
    function write_BIFF2Cell(out, r, c) {
        if (!out) out = new_buf(7);
        out.write_shift(2, r);
        out.write_shift(2, c);
        out.write_shift(2, 0);
        out.write_shift(1, 0);
        return out;
    }
    function write_BIFF2BERR(r, c, val, t) {
        var out = new_buf(9);
        write_BIFF2Cell(out, r, c);
        if (t == 'e') {
            out.write_shift(1, val);
            out.write_shift(1, 1);
        } else {
            out.write_shift(1, val ? 1 : 0);
            out.write_shift(1, 0);
        }
        return out;
    }
    /* TODO: codepage, large strings */ function write_BIFF2LABEL(r, c, val) {
        var out = new_buf(8 + 2 * val.length);
        write_BIFF2Cell(out, r, c);
        out.write_shift(1, val.length);
        out.write_shift(val.length, val, 'sbcs');
        return out.l < out.length ? out.slice(0, out.l) : out;
    }
    function write_ws_biff2_cell(ba, cell, R, C) {
        if (cell.v != null) switch(cell.t){
            case 'd':
            case 'n':
                var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
                if (v == (v | 0) && v >= 0 && v < 65536) write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
                else write_biff_rec(ba, 0x0003, write_BIFF2NUM(R, C, v));
                return;
            case 'b':
            case 'e':
                write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t));
                return;
            /* TODO: codepage, sst */ case 's':
            case 'str':
                write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, cell.v));
                return;
        }
        write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
    }
    function write_ws_biff2(ba, ws, idx, opts) {
        var dense = Array.isArray(ws);
        var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
        if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
            if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
            range.e.c = Math.min(range.e.c, 0xFF);
            range.e.r = Math.min(range.e.c, 0x3FFF);
            ref = encode_range(range);
        }
        for(var R = range.s.r; R <= range.e.r; ++R){
            rr = encode_row(R);
            for(var C = range.s.c; C <= range.e.c; ++C){
                if (R === range.s.r) cols[C] = encode_col(C);
                ref = cols[C] + rr;
                var cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (!cell) continue;
                /* write cell */ write_ws_biff2_cell(ba, cell, R, C, opts);
            }
        }
    }
    /* Based on test files */ function write_biff2_buf(wb, opts) {
        var o = opts || {};
        if (DENSE != null && o.dense == null) o.dense = DENSE;
        var ba = buf_array();
        var idx = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
        if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
        write_biff_rec(ba, 0x0009, write_BOF(wb, 0x10, o));
        /* ... */ write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
        /* ... */ write_biff_rec(ba, 0x000A);
        return ba.end();
    }
    function write_FONTS_biff8(ba, data, opts) {
        write_biff_rec(ba, "Font", write_Font({
            sz: 12,
            color: {
                theme: 1
            },
            name: "Arial",
            family: 2,
            scheme: "minor"
        }, opts));
    }
    function write_FMTS_biff8(ba, NF, opts) {
        if (!NF) return;
        [
            [
                5,
                8
            ],
            [
                23,
                26
            ],
            [
                41,
                44
            ],
            [
                /*63*/ 50,
                /*66],[164,*/ 392
            ]
        ].forEach(function(r) {
            for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) write_biff_rec(ba, "Format", write_Format(i, NF[i], opts));
        });
    }
    function write_FEAT(ba, ws) {
        /* [MS-XLS] 2.4.112 */ var o = new_buf(19);
        o.write_shift(4, 0x867);
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        o.write_shift(2, 3);
        o.write_shift(1, 1);
        o.write_shift(4, 0);
        write_biff_rec(ba, "FeatHdr", o);
        /* [MS-XLS] 2.4.111 */ o = new_buf(39);
        o.write_shift(4, 0x868);
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        o.write_shift(2, 3);
        o.write_shift(1, 0);
        o.write_shift(4, 0);
        o.write_shift(2, 1);
        o.write_shift(4, 4);
        o.write_shift(2, 0);
        write_Ref8U(safe_decode_range(ws['!ref'] || "A1"), o);
        o.write_shift(4, 4);
        write_biff_rec(ba, "Feat", o);
    }
    function write_CELLXFS_biff8(ba, opts) {
        for(var i = 0; i < 16; ++i)write_biff_rec(ba, "XF", write_XF({
            numFmtId: 0,
            style: true
        }, 0, opts));
        opts.cellXfs.forEach(function(c) {
            write_biff_rec(ba, "XF", write_XF(c, 0, opts));
        });
    }
    function write_ws_biff8_hlinks(ba, ws) {
        for(var R = 0; R < ws['!links'].length; ++R){
            var HL = ws['!links'][R];
            write_biff_rec(ba, "HLink", write_HLink(HL));
            if (HL[1].Tooltip) write_biff_rec(ba, "HLinkTooltip", write_HLinkTooltip(HL));
        }
        delete ws['!links'];
    }
    function write_ws_biff8_cell(ba, cell, R, C, opts) {
        var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
        if (cell.v == null && !cell.bf) {
            write_biff_rec(ba, "Blank", write_XLSCell(R, C, os));
            return;
        }
        if (cell.bf) write_biff_rec(ba, "Formula", write_Formula(cell, R, C, opts, os));
        else switch(cell.t){
            case 'd':
            case 'n':
                var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
                /* TODO: emit RK as appropriate */ write_biff_rec(ba, "Number", write_Number(R, C, v, os, opts));
                break;
            case 'b':
            case 'e':
                write_biff_rec(ba, 0x0205, write_BoolErr(R, C, cell.v, os, opts, cell.t));
                break;
            /* TODO: codepage, sst */ case 's':
            case 'str':
                if (opts.bookSST) {
                    var isst = get_sst_id(opts.Strings, cell.v, opts.revStrings);
                    write_biff_rec(ba, "LabelSst", write_LabelSst(R, C, isst, os, opts));
                } else write_biff_rec(ba, "Label", write_Label(R, C, cell.v, os, opts));
                break;
            default:
                write_biff_rec(ba, "Blank", write_XLSCell(R, C, os));
        }
    }
    /* [MS-XLS] 2.1.7.20.5 */ function write_ws_biff8(idx, opts, wb) {
        var ba = buf_array();
        var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
        var _WB = (wb || {}).Workbook || {};
        var _sheet = (_WB.Sheets || [])[idx] || {};
        var dense = Array.isArray(ws);
        var b8 = opts.biff == 8;
        var ref, rr = "", cols = [];
        var range = safe_decode_range(ws['!ref'] || "A1");
        var MAX_ROWS = b8 ? 65536 : 16384;
        if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
            if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
            range.e.c = Math.min(range.e.c, 0xFF);
            range.e.r = Math.min(range.e.c, MAX_ROWS - 1);
        }
        write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
        /* [Uncalced] Index */ write_biff_rec(ba, "CalcMode", writeuint16(1));
        write_biff_rec(ba, "CalcCount", writeuint16(100));
        write_biff_rec(ba, "CalcRefMode", writebool(true));
        write_biff_rec(ba, "CalcIter", writebool(false));
        write_biff_rec(ba, "CalcDelta", write_Xnum(0.001));
        write_biff_rec(ba, "CalcSaveRecalc", writebool(true));
        write_biff_rec(ba, "PrintRowCol", writebool(false));
        write_biff_rec(ba, "PrintGrid", writebool(false));
        write_biff_rec(ba, "GridSet", writeuint16(1));
        write_biff_rec(ba, "Guts", write_Guts([
            0,
            0
        ]));
        /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ write_biff_rec(ba, "HCenter", writebool(false));
        write_biff_rec(ba, "VCenter", writebool(false));
        /* ... */ write_biff_rec(ba, 0x200, write_Dimensions(range, opts));
        /* ... */ if (b8) ws['!links'] = [];
        for(var R = range.s.r; R <= range.e.r; ++R){
            rr = encode_row(R);
            for(var C = range.s.c; C <= range.e.c; ++C){
                if (R === range.s.r) cols[C] = encode_col(C);
                ref = cols[C] + rr;
                var cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (!cell) continue;
                /* write cell */ write_ws_biff8_cell(ba, cell, R, C, opts);
                if (b8 && cell.l) ws['!links'].push([
                    ref,
                    cell.l
                ]);
            }
        }
        var cname = _sheet.CodeName || _sheet.name || s;
        /* ... */ if (b8) write_biff_rec(ba, "Window2", write_Window2((_WB.Views || [])[0]));
        /* ... */ if (b8 && (ws['!merges'] || []).length) write_biff_rec(ba, "MergeCells", write_MergeCells(ws['!merges']));
        /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) write_ws_biff8_hlinks(ba, ws);
        /* [DVAL] */ write_biff_rec(ba, "CodeName", write_XLUnicodeString(cname, opts));
        /* *WebPub *CellWatch [SheetExt] */ if (b8) write_FEAT(ba, ws);
        /* *FEAT11 *RECORD12 */ write_biff_rec(ba, "EOF");
        return ba.end();
    }
    /* [MS-XLS] 2.1.7.20.3 */ function write_biff8_global(wb, bufs, opts) {
        var A = buf_array();
        var _WB = (wb || {}).Workbook || {};
        var _sheets = _WB.Sheets || [];
        var _wb = _WB.WBProps || {};
        var b8 = opts.biff == 8, b5 = opts.biff == 5;
        write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
        if (opts.bookType == "xla") write_biff_rec(A, "Addin");
        write_biff_rec(A, "InterfaceHdr", b8 ? writeuint16(0x04b0) : null);
        write_biff_rec(A, "Mms", writezeroes(2));
        if (b5) write_biff_rec(A, "ToolbarHdr");
        if (b5) write_biff_rec(A, "ToolbarEnd");
        write_biff_rec(A, "InterfaceEnd");
        write_biff_rec(A, "WriteAccess", write_WriteAccess("SheetJS", opts));
        /* [FileSharing] */ write_biff_rec(A, "CodePage", writeuint16(b8 ? 0x04b0 : 0x04E4));
        /* *2047 Lel */ if (b8) write_biff_rec(A, "DSF", writeuint16(0));
        if (b8) write_biff_rec(A, "Excel9File");
        write_biff_rec(A, "RRTabId", write_RRTabId(wb.SheetNames.length));
        if (b8 && wb.vbaraw) write_biff_rec(A, "ObProj");
        /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
            var cname = _wb.CodeName || "ThisWorkbook";
            write_biff_rec(A, "CodeName", write_XLUnicodeString(cname, opts));
        }
        write_biff_rec(A, "BuiltInFnGroupCount", writeuint16(0x11));
        /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ write_biff_rec(A, "WinProtect", writebool(false));
        write_biff_rec(A, "Protect", writebool(false));
        write_biff_rec(A, "Password", writeuint16(0));
        if (b8) write_biff_rec(A, "Prot4Rev", writebool(false));
        if (b8) write_biff_rec(A, "Prot4RevPass", writeuint16(0));
        write_biff_rec(A, "Window1", write_Window1(opts));
        write_biff_rec(A, "Backup", writebool(false));
        write_biff_rec(A, "HideObj", writeuint16(0));
        write_biff_rec(A, "Date1904", writebool(safe1904(wb) == "true"));
        write_biff_rec(A, "CalcPrecision", writebool(true));
        if (b8) write_biff_rec(A, "RefreshAll", writebool(false));
        write_biff_rec(A, "BookBool", writeuint16(0));
        /* ... */ write_FONTS_biff8(A, wb, opts);
        write_FMTS_biff8(A, wb.SSF, opts);
        write_CELLXFS_biff8(A, opts);
        /* ... */ if (b8) write_biff_rec(A, "UsesELFs", writebool(false));
        var a = A.end();
        var C = buf_array();
        /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) write_biff_rec(C, "Country", write_Country());
        /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */ /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) write_biff_continue(C, "SST", write_SST(opts.Strings, opts));
        /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ write_biff_rec(C, "EOF");
        var c = C.end();
        var B = buf_array();
        var blen = 0, j = 0;
        for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
        var start = a.length + blen + c.length;
        for(j = 0; j < wb.SheetNames.length; ++j){
            var _sheet = _sheets[j] || {};
            write_biff_rec(B, "BoundSheet8", write_BoundSheet8({
                pos: start,
                hs: _sheet.Hidden || 0,
                dt: 0,
                name: wb.SheetNames[j]
            }, opts));
            start += bufs[j].length;
        }
        /* 1*BoundSheet8 */ var b = B.end();
        if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
        var out = [];
        if (a.length) out.push(a);
        if (b.length) out.push(b);
        if (c.length) out.push(c);
        return __toBuffer([
            out
        ]);
    }
    /* [MS-XLS] 2.1.7.20 Workbook Stream */ function write_biff8_buf(wb, opts) {
        var o = opts || {};
        var bufs = [];
        if (wb && !wb.SSF) wb.SSF = SSF.get_table();
        if (wb && wb.SSF) {
            make_ssf(SSF);
            SSF.load_table(wb.SSF);
            // $FlowIgnore
            o.revssf = evert_num(wb.SSF);
            o.revssf[wb.SSF[65535]] = 0;
            o.ssf = wb.SSF;
        }
        o.Strings = [];
        o.Strings.Count = 0;
        o.Strings.Unique = 0;
        fix_write_opts(o);
        o.cellXfs = [];
        get_cell_style(o.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
        if (!wb.Props) wb.Props = {};
        for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = write_ws_biff8(i, o, wb);
        bufs.unshift(write_biff8_global(wb, bufs, o));
        return __toBuffer([
            bufs
        ]);
    }
    function write_biff_buf(wb, opts) {
        var o = opts || {};
        switch(o.biff || 2){
            case 8:
            case 5:
                return write_biff8_buf(wb, opts);
            case 4:
            case 3:
            case 2:
                return write_biff2_buf(wb, opts);
        }
        throw new Error("invalid type " + o.bookType + " for BIFF");
    }
    /* note: browser DOM element cannot see mso- style attrs, must parse */ var HTML_ = function() {
        function html_to_sheet(str, _opts) {
            var opts = _opts || {};
            if (DENSE != null && opts.dense == null) opts.dense = DENSE;
            var ws = opts.dense ? [] : {};
            str = str.replace(/<!--.*?-->/g, "");
            var mtch = str.match(/<table/i);
            if (!mtch) throw new Error("Invalid HTML: could not find <table>");
            var mtch2 = str.match(/<\/table/i);
            var i = mtch.index, j = mtch2 && mtch2.index || str.length;
            var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
            var R = -1, C = 0, RS = 0, CS = 0;
            var range = {
                s: {
                    r: 10000000,
                    c: 10000000
                },
                e: {
                    r: 0,
                    c: 0
                }
            };
            var merges = [];
            for(i = 0; i < rows.length; ++i){
                var row = rows[i].trim();
                var hd = row.slice(0, 3).toLowerCase();
                if (hd == "<tr") {
                    ++R;
                    if (opts.sheetRows && opts.sheetRows <= R) {
                        --R;
                        break;
                    }
                    C = 0;
                    continue;
                }
                if (hd != "<td" && hd != "<th") continue;
                var cells = row.split(/<\/t[dh]>/i);
                for(j = 0; j < cells.length; ++j){
                    var cell = cells[j].trim();
                    if (!cell.match(/<t[dh]/i)) continue;
                    var m = cell, cc = 0;
                    /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
                    for(var midx = 0; midx < merges.length; ++midx){
                        var _merge = merges[midx];
                        if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                            C = _merge.e.c + 1;
                            midx = -1;
                        }
                    }
                    var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
                    CS = tag.colspan ? +tag.colspan : 1;
                    if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                        s: {
                            r: R,
                            c: C
                        },
                        e: {
                            r: R + (RS || 1) - 1,
                            c: C + CS - 1
                        }
                    });
                    var _t = tag.t || "";
                    /* TODO: generate stub cells */ if (!m.length) {
                        C += CS;
                        continue;
                    }
                    m = htmldecode(m);
                    if (range.s.r > R) range.s.r = R;
                    if (range.e.r < R) range.e.r = R;
                    if (range.s.c > C) range.s.c = C;
                    if (range.e.c < C) range.e.c = C;
                    if (!m.length) continue;
                    var o = {
                        t: 's',
                        v: m
                    };
                    if (opts.raw || !m.trim().length || _t == 's') ;
                    else if (m === 'TRUE') o = {
                        t: 'b',
                        v: true
                    };
                    else if (m === 'FALSE') o = {
                        t: 'b',
                        v: false
                    };
                    else if (!isNaN(fuzzynum(m))) o = {
                        t: 'n',
                        v: fuzzynum(m)
                    };
                    else if (!isNaN(fuzzydate(m).getDate())) {
                        o = {
                            t: 'd',
                            v: parseDate(m)
                        };
                        if (!opts.cellDates) o = {
                            t: 'n',
                            v: datenum(o.v)
                        };
                        o.z = opts.dateNF || SSF._table[14];
                    }
                    if (opts.dense) {
                        if (!ws[R]) ws[R] = [];
                        ws[R][C] = o;
                    } else ws[encode_cell({
                        r: R,
                        c: C
                    })] = o;
                    C += CS;
                }
            }
            ws['!ref'] = encode_range(range);
            if (merges.length) ws["!merges"] = merges;
            return ws;
        }
        function html_to_book(str, opts) {
            return sheet_to_workbook(html_to_sheet(str, opts), opts);
        }
        function make_html_row(ws, r, R, o) {
            var M = ws['!merges'] || [];
            var oo = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var RS = 0, CS = 0;
                for(var j = 0; j < M.length; ++j){
                    if (M[j].s.r > R || M[j].s.c > C) continue;
                    if (M[j].e.r < R || M[j].e.c < C) continue;
                    if (M[j].s.r < R || M[j].s.c < C) {
                        RS = -1;
                        break;
                    }
                    RS = M[j].e.r - M[j].s.r + 1;
                    CS = M[j].e.c - M[j].s.c + 1;
                    break;
                }
                if (RS < 0) continue;
                var coord = encode_cell({
                    r: R,
                    c: C
                });
                var cell = o.dense ? (ws[R] || [])[C] : ws[coord];
                /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
                var sp = {};
                if (RS > 1) sp.rowspan = RS;
                if (CS > 1) sp.colspan = CS;
                sp.t = cell && cell.t || 'z';
                if (o.editable) w = '<span contenteditable="true">' + w + '</span>';
                sp.id = (o.id || "sjs") + "-" + coord;
                if (sp.t != "z") {
                    sp.v = cell.v;
                    if (cell.z != null) sp.z = cell.z;
                }
                oo.push(writextag('td', w, sp));
            }
            var preamble = "<tr>";
            return preamble + oo.join("") + "</tr>";
        }
        function make_html_preamble(ws, R, o) {
            var out = [];
            return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
        }
        var _BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
        var _END = '</body></html>';
        function sheet_to_html(ws, opts /*, wb:?Workbook*/ ) {
            var o = opts || {};
            var header = o.header != null ? o.header : _BEGIN;
            var footer = o.footer != null ? o.footer : _END;
            var out = [
                header
            ];
            var r = decode_range(ws['!ref']);
            o.dense = Array.isArray(ws);
            out.push(make_html_preamble(ws, r, o));
            for(var R = r.s.r; R <= r.e.r; ++R)out.push(make_html_row(ws, r, R, o));
            out.push("</table>" + footer);
            return out.join("");
        }
        return {
            to_workbook: html_to_book,
            to_sheet: html_to_sheet,
            _row: make_html_row,
            BEGIN: _BEGIN,
            END: _END,
            _preamble: make_html_preamble,
            from_sheet: sheet_to_html
        };
    }();
    function sheet_add_dom(ws, table, _opts) {
        var opts = _opts || {};
        if (DENSE != null) opts.dense = DENSE;
        var or_R = 0, or_C = 0;
        if (opts.origin != null) {
            if (typeof opts.origin == 'number') or_R = opts.origin;
            else {
                var _origin = typeof opts.origin == "string" ? decode_cell(opts.origin) : opts.origin;
                or_R = _origin.r;
                or_C = _origin.c;
            }
        }
        var rows = table.getElementsByTagName('tr');
        var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
        var range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: or_R,
                c: or_C
            }
        };
        if (ws["!ref"]) {
            var _range = decode_range(ws["!ref"]);
            range.s.r = Math.min(range.s.r, _range.s.r);
            range.s.c = Math.min(range.s.c, _range.s.c);
            range.e.r = Math.max(range.e.r, _range.e.r);
            range.e.c = Math.max(range.e.c, _range.e.c);
            if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
        }
        var merges = [], midx = 0;
        var rowinfo = ws["!rows"] || (ws["!rows"] = []);
        var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
        if (!ws["!cols"]) ws['!cols'] = [];
        for(; _R < rows.length && R < sheetRows; ++_R){
            var row = rows[_R];
            if (is_dom_element_hidden(row)) {
                if (opts.display) continue;
                rowinfo[R] = {
                    hidden: true
                };
            }
            var elts = row.children;
            for(_C = C = 0; _C < elts.length; ++_C){
                var elt = elts[_C];
                if (opts.display && is_dom_element_hidden(elt)) continue;
                var v = elt.hasAttribute('v') ? elt.getAttribute('v') : htmldecode(elt.innerHTML);
                var z = elt.getAttribute('z');
                for(midx = 0; midx < merges.length; ++midx){
                    var m = merges[midx];
                    if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                        C = m.e.c + 1 - or_C;
                        midx = -1;
                    }
                }
                /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
                if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                    s: {
                        r: R + or_R,
                        c: C + or_C
                    },
                    e: {
                        r: R + or_R + (RS || 1) - 1,
                        c: C + or_C + (CS || 1) - 1
                    }
                });
                var o = {
                    t: 's',
                    v: v
                };
                var _t = elt.getAttribute("t") || "";
                if (v != null) {
                    if (v.length == 0) o.t = _t || 'z';
                    else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                    else if (v === 'TRUE') o = {
                        t: 'b',
                        v: true
                    };
                    else if (v === 'FALSE') o = {
                        t: 'b',
                        v: false
                    };
                    else if (!isNaN(fuzzynum(v))) o = {
                        t: 'n',
                        v: fuzzynum(v)
                    };
                    else if (!isNaN(fuzzydate(v).getDate())) {
                        o = {
                            t: 'd',
                            v: parseDate(v)
                        };
                        if (!opts.cellDates) o = {
                            t: 'n',
                            v: datenum(o.v)
                        };
                        o.z = opts.dateNF || SSF._table[14];
                    }
                }
                if (o.z === undefined && z != null) o.z = z;
                if (opts.dense) {
                    if (!ws[R + or_R]) ws[R + or_R] = [];
                    ws[R + or_R][C + or_C] = o;
                } else ws[encode_cell({
                    c: C + or_C,
                    r: R + or_R
                })] = o;
                if (range.e.c < C + or_C) range.e.c = C + or_C;
                C += CS;
            }
            ++R;
        }
        if (merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
        range.e.r = Math.max(range.e.r, R - 1 + or_R);
        ws['!ref'] = encode_range(range);
        if (R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
        return ws;
    }
    function parse_dom_table(table, _opts) {
        var opts = _opts || {};
        var ws = opts.dense ? [] : {};
        return sheet_add_dom(ws, table, _opts);
    }
    function table_to_book(table, opts) {
        return sheet_to_workbook(parse_dom_table(table, opts), opts);
    }
    function is_dom_element_hidden(element) {
        var display = '';
        var get_computed_style = get_get_computed_style_function(element);
        if (get_computed_style) display = get_computed_style(element).getPropertyValue('display');
        if (!display) display = element.style.display; // Fallback for cases when getComputedStyle is not available (e.g. an old browser or some Node.js environments) or doesn't work (e.g. if the element is not inserted to a document)
        return display === 'none';
    }
    /* global getComputedStyle */ function get_get_computed_style_function(element) {
        // The proper getComputedStyle implementation is the one defined in the element window
        if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
        // If it is not available, try to get one from the global namespace
        if (typeof getComputedStyle === 'function') return getComputedStyle;
        return null;
    }
    /* OpenDocument */ var parse_content_xml = function() {
        var parse_text_p = function(text) {
            /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
                return Array(parseInt($1, 10) + 1).join(" ");
            }).replace(/<text:tab[^>]*\/>/g, "\t").replace(/<text:line-break\/>/g, "\n");
            var v = unescapexml(fixed.replace(/<[^>]*>/g, ""));
            return [
                v
            ];
        };
        var number_formats = {
            /* ods name: [short ssf fmt, long ssf fmt] */ day: [
                "d",
                "dd"
            ],
            month: [
                "m",
                "mm"
            ],
            year: [
                "y",
                "yy"
            ],
            hours: [
                "h",
                "hh"
            ],
            minutes: [
                "m",
                "mm"
            ],
            seconds: [
                "s",
                "ss"
            ],
            "am-pm": [
                "A/P",
                "AM/PM"
            ],
            "day-of-week": [
                "ddd",
                "dddd"
            ],
            era: [
                "e",
                "ee"
            ],
            /* there is no native representation of LO "Q" format */ quarter: [
                "\\Qm",
                "m\\\"th quarter\""
            ]
        };
        return function pcx(d, _opts) {
            var opts = _opts || {};
            if (DENSE != null && opts.dense == null) opts.dense = DENSE;
            var str = xlml_normalize(d);
            var state = [], tmp;
            var tag;
            var NFtag = {
                name: ""
            }, NF = "", pidx = 0;
            var sheetag;
            var rowtag;
            var Sheets = {}, SheetNames = [];
            var ws = opts.dense ? [] : {};
            var Rn, q;
            var ctag = {
                value: ""
            };
            var textp = "", textpidx = 0, textptag;
            var textR = [];
            var R = -1, C = -1, range = {
                s: {
                    r: 1000000,
                    c: 10000000
                },
                e: {
                    r: 0,
                    c: 0
                }
            };
            var row_ol = 0;
            var number_format_map = {};
            var merges = [], mrange = {}, mR = 0, mC = 0;
            var rowinfo = [], rowpeat = 1, colpeat = 1;
            var arrayf = [];
            var WB = {
                Names: []
            };
            var atag = {};
            var _Ref = [
                "",
                ""
            ];
            var comments = [], comment = {};
            var creator = "", creatoridx = 0;
            var isstub = false, intable = false;
            var i = 0;
            xlmlregex.lastIndex = 0;
            str = str.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
            while(Rn = xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_.*$/, "")){
                case 'table':
                case "\u5DE5\u4F5C\u8868":
                    if (Rn[1] === '/') {
                        if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
                        else ws['!ref'] = "A1:A1";
                        if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                            ws['!fullref'] = ws['!ref'];
                            range.e.r = opts.sheetRows - 1;
                            ws['!ref'] = encode_range(range);
                        }
                        if (merges.length) ws['!merges'] = merges;
                        if (rowinfo.length) ws["!rows"] = rowinfo;
                        sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                        if (typeof JSON !== 'undefined') JSON.stringify(sheetag);
                        SheetNames.push(sheetag.name);
                        Sheets[sheetag.name] = ws;
                        intable = false;
                    } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                        sheetag = parsexmltag(Rn[0], false);
                        R = C = -1;
                        range.s.r = range.s.c = 10000000;
                        range.e.r = range.e.c = 0;
                        ws = opts.dense ? [] : {};
                        merges = [];
                        rowinfo = [];
                        intable = true;
                    }
                    break;
                case 'table-row-group':
                    if (Rn[1] === "/") --row_ol;
                    else ++row_ol;
                    break;
                case 'table-row':
                case "\u884C":
                    if (Rn[1] === '/') {
                        R += rowpeat;
                        rowpeat = 1;
                        break;
                    }
                    rowtag = parsexmltag(Rn[0], false);
                    if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
                    else if (R == -1) R = 0;
                    rowpeat = +rowtag['number-rows-repeated'] || 1;
                    /* TODO: remove magic */ if (rowpeat < 10) {
                        for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                            level: row_ol
                        };
                    }
                    C = -1;
                    break;
                case 'covered-table-cell':
                    if (Rn[1] !== '/') ++C;
                    if (opts.sheetStubs) {
                        if (opts.dense) {
                            if (!ws[R]) ws[R] = [];
                            ws[R][C] = {
                                t: 'z'
                            };
                        } else ws[encode_cell({
                            r: R,
                            c: C
                        })] = {
                            t: 'z'
                        };
                    }
                    textp = "";
                    textR = [];
                    break; /* stub */ 
                case 'table-cell':
                case "\u6570\u636E":
                    if (Rn[0].charAt(Rn[0].length - 2) === '/') {
                        ++C;
                        ctag = parsexmltag(Rn[0], false);
                        colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                        q = {
                            t: 'z',
                            v: null
                        };
                        if (ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
                        if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type']) == "string") {
                            q.t = "s";
                            q.v = unescapexml(ctag['string-value'] || "");
                            if (opts.dense) {
                                if (!ws[R]) ws[R] = [];
                                ws[R][C] = q;
                            } else ws[encode_cell({
                                r: R,
                                c: C
                            })] = q;
                        }
                        C += colpeat - 1;
                    } else if (Rn[1] !== '/') {
                        ++C;
                        colpeat = 1;
                        var rptR = rowpeat ? R + rowpeat - 1 : R;
                        if (C > range.e.c) range.e.c = C;
                        if (C < range.s.c) range.s.c = C;
                        if (R < range.s.r) range.s.r = R;
                        if (rptR > range.e.r) range.e.r = rptR;
                        ctag = parsexmltag(Rn[0], false);
                        comments = [];
                        comment = {};
                        q = {
                            t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type'],
                            v: null
                        };
                        if (opts.cellFormula) {
                            if (ctag.formula) ctag.formula = unescapexml(ctag.formula);
                            if (ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
                                mR = parseInt(ctag['number-matrix-rows-spanned'], 10) || 0;
                                mC = parseInt(ctag['number-matrix-columns-spanned'], 10) || 0;
                                mrange = {
                                    s: {
                                        r: R,
                                        c: C
                                    },
                                    e: {
                                        r: R + mR - 1,
                                        c: C + mC - 1
                                    }
                                };
                                q.F = encode_range(mrange);
                                arrayf.push([
                                    mrange,
                                    q.F
                                ]);
                            }
                            if (ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
                            else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                                if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                            }
                        }
                        if (ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
                            mR = parseInt(ctag['number-rows-spanned'], 10) || 0;
                            mC = parseInt(ctag['number-columns-spanned'], 10) || 0;
                            mrange = {
                                s: {
                                    r: R,
                                    c: C
                                },
                                e: {
                                    r: R + mR - 1,
                                    c: C + mC - 1
                                }
                            };
                            merges.push(mrange);
                        }
                        /* 19.675.2 table:number-columns-repeated */ if (ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
                        /* 19.385 office:value-type */ switch(q.t){
                            case 'boolean':
                                q.t = 'b';
                                q.v = parsexmlbool(ctag['boolean-value']);
                                break;
                            case 'float':
                                q.t = 'n';
                                q.v = parseFloat(ctag.value);
                                break;
                            case 'percentage':
                                q.t = 'n';
                                q.v = parseFloat(ctag.value);
                                break;
                            case 'currency':
                                q.t = 'n';
                                q.v = parseFloat(ctag.value);
                                break;
                            case 'date':
                                q.t = 'd';
                                q.v = parseDate(ctag['date-value']);
                                if (!opts.cellDates) {
                                    q.t = 'n';
                                    q.v = datenum(q.v);
                                }
                                q.z = 'm/d/yy';
                                break;
                            case 'time':
                                q.t = 'n';
                                q.v = parse_isodur(ctag['time-value']) / 86400;
                                break;
                            case 'number':
                                q.t = 'n';
                                q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                                break;
                            default:
                                if (q.t === 'string' || q.t === 'text' || !q.t) {
                                    q.t = 's';
                                    if (ctag['string-value'] != null) {
                                        textp = unescapexml(ctag['string-value']);
                                        textR = [];
                                    }
                                } else throw new Error('Unsupported value type ' + q.t);
                        }
                    } else {
                        isstub = false;
                        if (q.t === 's') {
                            q.v = textp || '';
                            if (textR.length) q.R = textR;
                            isstub = textpidx == 0;
                        }
                        if (atag.Target) q.l = atag;
                        if (comments.length > 0) {
                            q.c = comments;
                            comments = [];
                        }
                        if (textp && opts.cellText !== false) q.w = textp;
                        if (isstub) {
                            q.t = "z";
                            delete q.v;
                        }
                        if (!isstub || opts.sheetStubs) {
                            if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                                if (opts.dense) {
                                    if (!ws[R + rpt]) ws[R + rpt] = [];
                                    ws[R + rpt][C] = rpt == 0 ? q : dup(q);
                                    while(--colpeat > 0)ws[R + rpt][C + colpeat] = dup(q);
                                } else {
                                    ws[encode_cell({
                                        r: R + rpt,
                                        c: C
                                    })] = q;
                                    while(--colpeat > 0)ws[encode_cell({
                                        r: R + rpt,
                                        c: C + colpeat
                                    })] = dup(q);
                                }
                                if (range.e.c <= C) range.e.c = C;
                            }
                        }
                        colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                        C += colpeat - 1;
                        colpeat = 0;
                        q = {};
                        textp = "";
                        textR = [];
                    }
                    atag = {};
                    break; // 9.1.4 <table:table-cell>
                /* pure state */ case 'document':
                case 'document-content':
                case "\u7535\u5B50\u8868\u683C\u6587\u6863":
                case 'spreadsheet':
                case "\u4E3B\u4F53":
                case 'scripts':
                case 'styles':
                case 'font-face-decls':
                case 'master-styles':
                    if (Rn[1] === '/') {
                        if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                    } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                        Rn[3],
                        true
                    ]);
                    break;
                case 'annotation':
                    if (Rn[1] === '/') {
                        if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                        comment.t = textp;
                        if (textR.length) comment.R = textR;
                        comment.a = creator;
                        comments.push(comment);
                    } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                        Rn[3],
                        false
                    ]);
                    creator = "";
                    creatoridx = 0;
                    textp = "";
                    textpidx = 0;
                    textR = [];
                    break;
                case 'creator':
                    if (Rn[1] === '/') creator = str.slice(creatoridx, Rn.index);
                    else creatoridx = Rn.index + Rn[0].length;
                    break;
                /* ignore state */ case 'meta':
                case "\u5143\u6570\u636E":
                case 'settings':
                case 'config-item-set':
                case 'config-item-map-indexed':
                case 'config-item-map-entry':
                case 'config-item-map-named':
                case 'shapes':
                case 'frame':
                case 'text-box':
                case 'image':
                case 'data-pilot-tables':
                case 'list-style':
                case 'form':
                case 'dde-links':
                case 'event-listeners':
                case 'chart':
                    if (Rn[1] === '/') {
                        if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                    } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                        Rn[3],
                        false
                    ]);
                    textp = "";
                    textpidx = 0;
                    textR = [];
                    break;
                case 'scientific-number':
                    break;
                case 'currency-symbol':
                    break;
                case 'currency-style':
                    break;
                case 'number-style':
                case 'percentage-style':
                case 'date-style':
                case 'time-style':
                    if (Rn[1] === '/') {
                        number_format_map[NFtag.name] = NF;
                        if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                    } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                        NF = "";
                        NFtag = parsexmltag(Rn[0], false);
                        state.push([
                            Rn[3],
                            true
                        ]);
                    }
                    break;
                case 'script':
                    break; // 3.13 <office:script>
                case 'libraries':
                    break; // TODO: <ooo:libraries>
                case 'automatic-styles':
                    break; // 3.15.3 <office:automatic-styles>
                case 'default-style':
                case 'page-layout':
                    break; // TODO: <style:page-layout>
                case 'style':
                    break;
                case 'map':
                    break; // 16.3 <style:map>
                case 'font-face':
                    break; // 16.21 <style:font-face>
                case 'paragraph-properties':
                    break; // 17.6 <style:paragraph-properties>
                case 'table-properties':
                    break; // 17.15 <style:table-properties>
                case 'table-column-properties':
                    break; // 17.16 <style:table-column-properties>
                case 'table-row-properties':
                    break; // 17.17 <style:table-row-properties>
                case 'table-cell-properties':
                    break; // 17.18 <style:table-cell-properties>
                case 'number':
                    switch(state[state.length - 1][0]){
                        case 'time-style':
                        case 'date-style':
                            tag = parsexmltag(Rn[0], false);
                            NF += number_formats[Rn[3]][tag.style === 'long' ? 1 : 0];
                            break;
                    }
                    break;
                case 'fraction':
                    break; // TODO 16.27.6 <number:fraction>
                case 'day':
                case 'month':
                case 'year':
                case 'era':
                case 'day-of-week':
                case 'week-of-year':
                case 'quarter':
                case 'hours':
                case 'minutes':
                case 'seconds':
                case 'am-pm':
                    switch(state[state.length - 1][0]){
                        case 'time-style':
                        case 'date-style':
                            tag = parsexmltag(Rn[0], false);
                            NF += number_formats[Rn[3]][tag.style === 'long' ? 1 : 0];
                            break;
                    }
                    break;
                case 'boolean-style':
                    break; // 16.27.23 <number:boolean-style>
                case 'boolean':
                    break; // 16.27.24 <number:boolean>
                case 'text-style':
                    break; // 16.27.25 <number:text-style>
                case 'text':
                    if (Rn[0].slice(-2) === "/>") break;
                    else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                        case 'number-style':
                        case 'date-style':
                        case 'time-style':
                            NF += str.slice(pidx, Rn.index);
                            break;
                    }
                    else pidx = Rn.index + Rn[0].length;
                    break;
                case 'named-range':
                    tag = parsexmltag(Rn[0], false);
                    _Ref = ods_to_csf_3D(tag['cell-range-address']);
                    var nrange = {
                        Name: tag.name,
                        Ref: _Ref[0] + '!' + _Ref[1]
                    };
                    if (intable) nrange.Sheet = SheetNames.length;
                    WB.Names.push(nrange);
                    break;
                case 'text-content':
                    break; // 16.27.27 <number:text-content>
                case 'text-properties':
                    break; // 16.27.27 <style:text-properties>
                case 'embedded-text':
                    break; // 16.27.4 <number:embedded-text>
                case 'body':
                case "\u7535\u5B50\u8868\u683C":
                    break; // 3.3 16.9.6 19.726.3
                case 'forms':
                    break; // 12.25.2 13.2
                case 'table-column':
                    break; // 9.1.6 <table:table-column>
                case 'table-header-rows':
                    break; // 9.1.7 <table:table-header-rows>
                case 'table-rows':
                    break; // 9.1.12 <table:table-rows>
                /* TODO: outline levels */ case 'table-column-group':
                    break; // 9.1.10 <table:table-column-group>
                case 'table-header-columns':
                    break; // 9.1.11 <table:table-header-columns>
                case 'table-columns':
                    break; // 9.1.12 <table:table-columns>
                case 'null-date':
                    break; // 9.4.2 <table:null-date> TODO: date1904
                case 'graphic-properties':
                    break; // 17.21 <style:graphic-properties>
                case 'calculation-settings':
                    break; // 9.4.1 <table:calculation-settings>
                case 'named-expressions':
                    break; // 9.4.11 <table:named-expressions>
                case 'label-range':
                    break; // 9.4.9 <table:label-range>
                case 'label-ranges':
                    break; // 9.4.10 <table:label-ranges>
                case 'named-expression':
                    break; // 9.4.13 <table:named-expression>
                case 'sort':
                    break; // 9.4.19 <table:sort>
                case 'sort-by':
                    break; // 9.4.20 <table:sort-by>
                case 'sort-groups':
                    break; // 9.4.22 <table:sort-groups>
                case 'tab':
                    break; // 6.1.4 <text:tab>
                case 'line-break':
                    break; // 6.1.5 <text:line-break>
                case 'span':
                    break; // 6.1.7 <text:span>
                case 'p':
                case "\u6587\u672C\u4E32":
                    if ([
                        'master-styles'
                    ].indexOf(state[state.length - 1][0]) > -1) break;
                    if (Rn[1] === '/' && (!ctag || !ctag['string-value'])) {
                        var ptp = parse_text_p(str.slice(textpidx, Rn.index), textptag);
                        textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
                    } else {
                        textptag = parsexmltag(Rn[0], false);
                        textpidx = Rn.index + Rn[0].length;
                    }
                    break; // <text:p>
                case 's':
                    break; // <text:s>
                case 'database-range':
                    if (Rn[1] === '/') break;
                    try {
                        _Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
                        Sheets[_Ref[0]]['!autofilter'] = {
                            ref: _Ref[1]
                        };
                    } catch (e) {}
                    break;
                case 'date':
                    break; // <*:date>
                case 'object':
                    break; // 10.4.6.2 <draw:object>
                case 'title':
                case "\u6807\u9898":
                    break; // <*:title> OR <uof:标题>
                case 'desc':
                    break; // <*:desc>
                case 'binary-data':
                    break; // 10.4.5 TODO: b64 blob
                /* 9.2 Advanced Tables */ case 'table-source':
                    break; // 9.2.6
                case 'scenario':
                    break; // 9.2.6
                case 'iteration':
                    break; // 9.4.3 <table:iteration>
                case 'content-validations':
                    break; // 9.4.4 <table:
                case 'content-validation':
                    break; // 9.4.5 <table:
                case 'help-message':
                    break; // 9.4.6 <table:
                case 'error-message':
                    break; // 9.4.7 <table:
                case 'database-ranges':
                    break; // 9.4.14 <table:database-ranges>
                case 'filter':
                    break; // 9.5.2 <table:filter>
                case 'filter-and':
                    break; // 9.5.3 <table:filter-and>
                case 'filter-or':
                    break; // 9.5.4 <table:filter-or>
                case 'filter-condition':
                    break; // 9.5.5 <table:filter-condition>
                case 'list-level-style-bullet':
                    break; // 16.31 <text:
                case 'list-level-style-number':
                    break; // 16.32 <text:
                case 'list-level-properties':
                    break; // 17.19 <style:
                /* 7.3 Document Fields */ case 'sender-firstname':
                case 'sender-lastname':
                case 'sender-initials':
                case 'sender-title':
                case 'sender-position':
                case 'sender-email':
                case 'sender-phone-private':
                case 'sender-fax':
                case 'sender-company':
                case 'sender-phone-work':
                case 'sender-street':
                case 'sender-city':
                case 'sender-postal-code':
                case 'sender-country':
                case 'sender-state-or-province':
                case 'author-name':
                case 'author-initials':
                case 'chapter':
                case 'file-name':
                case 'template-name':
                case 'sheet-name':
                    break;
                case 'event-listener':
                    break;
                /* TODO: FODS Properties */ case 'initial-creator':
                case 'creation-date':
                case 'print-date':
                case 'generator':
                case 'document-statistic':
                case 'user-defined':
                case 'editing-duration':
                case 'editing-cycles':
                    break;
                /* TODO: FODS Config */ case 'config-item':
                    break;
                /* TODO: style tokens */ case 'page-number':
                    break; // TODO <text:page-number>
                case 'page-count':
                    break; // TODO <text:page-count>
                case 'time':
                    break; // TODO <text:time>
                /* 9.3 Advanced Table Cells */ case 'cell-range-source':
                    break; // 9.3.1 <table:
                case 'detective':
                    break; // 9.3.2 <table:
                case 'operation':
                    break; // 9.3.3 <table:
                case 'highlighted-range':
                    break; // 9.3.4 <table:
                /* 9.6 Data Pilot Tables <table: */ case 'data-pilot-table':
                case 'source-cell-range':
                case 'source-service':
                case 'data-pilot-field':
                case 'data-pilot-level':
                case 'data-pilot-subtotals':
                case 'data-pilot-subtotal':
                case 'data-pilot-members':
                case 'data-pilot-member':
                case 'data-pilot-display-info':
                case 'data-pilot-sort-info':
                case 'data-pilot-layout-info':
                case 'data-pilot-field-reference':
                case 'data-pilot-groups':
                case 'data-pilot-group':
                case 'data-pilot-group-member':
                    break;
                /* 10.3 Drawing Shapes */ case 'rect':
                    break;
                /* 14.6 DDE Connections */ case 'dde-connection-decls':
                case 'dde-connection-decl':
                case 'dde-link':
                case 'dde-source':
                    break;
                case 'properties':
                    break; // 13.7 <form:properties>
                case 'property':
                    break; // 13.8 <form:property>
                case 'a':
                    if (Rn[1] !== '/') {
                        atag = parsexmltag(Rn[0], false);
                        if (!atag.href) break;
                        atag.Target = atag.href;
                        delete atag.href;
                        if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                            _Ref = ods_to_csf_3D(atag.Target.slice(1));
                            atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                        }
                    }
                    break;
                /* non-standard */ case 'table-protection':
                    break;
                case 'data-pilot-grand-total':
                    break; // <table:
                case 'office-document-common-attrs':
                    break; // bare
                default:
                    switch(Rn[2]){
                        case 'dc:':
                        case 'calcext:':
                        case 'loext:':
                        case 'ooo:':
                        case 'chartooo:':
                        case 'draw:':
                        case 'style:':
                        case 'chart:':
                        case 'form:':
                        case 'uof:':
                        case "\u8868:":
                        case "\u5B57:":
                            break;
                        default:
                            if (opts.WTF) throw new Error(Rn);
                    }
            }
            var out = {
                Sheets: Sheets,
                SheetNames: SheetNames,
                Workbook: WB
            };
            if (opts.bookSheets) delete out.Sheets;
            return out;
        };
    }();
    function parse_ods(zip, opts) {
        opts = opts || {};
        var ods = !!safegetzipfile(zip, 'objectdata');
        if (ods) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
        var content = getzipstr(zip, 'content.xml');
        if (!content) throw new Error("Missing content.xml in " + (ods ? "ODS" : "UOF") + " file");
        var wb = parse_content_xml(ods ? content : utf8read(content), opts);
        if (safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
        return wb;
    }
    function parse_fods(data, opts) {
        return parse_content_xml(data, opts);
    }
    /* OpenDocument */ var write_styles_ods = function() {
        var payload = '<office:document-styles ' + wxt_helper({
            'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            'xmlns:xlink': "http://www.w3.org/1999/xlink",
            'xmlns:dc': "http://purl.org/dc/elements/1.1/",
            'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            'office:version': "1.2"
        }) + '></office:document-styles>';
        return function wso() {
            return XML_HEADER + payload;
        };
    }();
    var write_content_ods = function() {
        /* 6.1.2 White Space Characters */ var write_text_p = function(text) {
            return escapexml(text).replace(/  +/g, function($$) {
                return '<text:s text:c="' + $$.length + '"/>';
            }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "<text:line-break/>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
        };
        var null_cell_xml = '          <table:table-cell />\n';
        var covered_cell_xml = '          <table:covered-table-cell/>\n';
        var write_ws = function(ws, wb, i) {
            /* Section 9 Tables */ var o = [];
            o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
            var R = 0, C = 0, range = decode_range(ws['!ref']);
            var marr = ws['!merges'] || [], mi = 0;
            var dense = Array.isArray(ws);
            for(R = 0; R < range.s.r; ++R)o.push('        <table:table-row></table:table-row>\n');
            for(; R <= range.e.r; ++R){
                o.push('        <table:table-row>\n');
                for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
                for(; C <= range.e.c; ++C){
                    var skip = false, ct = {}, textp = "";
                    for(mi = 0; mi != marr.length; ++mi){
                        if (marr[mi].s.c > C) continue;
                        if (marr[mi].s.r > R) continue;
                        if (marr[mi].e.c < C) continue;
                        if (marr[mi].e.r < R) continue;
                        if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                        ct['table:number-columns-spanned'] = marr[mi].e.c - marr[mi].s.c + 1;
                        ct['table:number-rows-spanned'] = marr[mi].e.r - marr[mi].s.r + 1;
                        break;
                    }
                    if (skip) {
                        o.push(covered_cell_xml);
                        continue;
                    }
                    var ref = encode_cell({
                        r: R,
                        c: C
                    }), cell = dense ? (ws[R] || [])[C] : ws[ref];
                    if (cell && cell.f) {
                        ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
                        if (cell.F) {
                            if (cell.F.slice(0, ref.length) == ref) {
                                var _Fref = decode_range(cell.F);
                                ct['table:number-matrix-columns-spanned'] = _Fref.e.c - _Fref.s.c + 1;
                                ct['table:number-matrix-rows-spanned'] = _Fref.e.r - _Fref.s.r + 1;
                            }
                        }
                    }
                    if (!cell) {
                        o.push(null_cell_xml);
                        continue;
                    }
                    switch(cell.t){
                        case 'b':
                            textp = cell.v ? 'TRUE' : 'FALSE';
                            ct['office:value-type'] = "boolean";
                            ct['office:boolean-value'] = cell.v ? 'true' : 'false';
                            break;
                        case 'n':
                            textp = cell.w || String(cell.v || 0);
                            ct['office:value-type'] = "float";
                            ct['office:value'] = cell.v || 0;
                            break;
                        case 's':
                        case 'str':
                            textp = cell.v == null ? "" : cell.v;
                            ct['office:value-type'] = "string";
                            break;
                        case 'd':
                            textp = cell.w || parseDate(cell.v).toISOString();
                            ct['office:value-type'] = "date";
                            ct['office:date-value'] = parseDate(cell.v).toISOString();
                            ct['table:style-name'] = "ce1";
                            break;
                        //case 'e':
                        default:
                            o.push(null_cell_xml);
                            continue;
                    }
                    var text_p = write_text_p(textp);
                    if (cell.l && cell.l.Target) {
                        var _tgt = cell.l.Target;
                        _tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                        text_p = writextag('text:a', text_p, {
                            'xlink:href': _tgt
                        });
                    }
                    o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
                }
                o.push('        </table:table-row>\n');
            }
            o.push('      </table:table>\n');
            return o.join("");
        };
        var write_automatic_styles_ods = function(o) {
            o.push(' <office:automatic-styles>\n');
            o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
            o.push('   <number:month number:style="long"/>\n');
            o.push('   <number:text>/</number:text>\n');
            o.push('   <number:day number:style="long"/>\n');
            o.push('   <number:text>/</number:text>\n');
            o.push('   <number:year/>\n');
            o.push('  </number:date-style>\n');
            /* table */ o.push('  <style:style style:name="ta1" style:family="table">\n'); // style:master-page-name="mp1">\n');
            o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
            o.push('  </style:style>\n');
            /* table cells, text */ o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
            /* page-layout */ o.push(' </office:automatic-styles>\n');
        };
        return function wcx(wb, opts) {
            var o = [
                XML_HEADER
            ];
            /* 3.1.3.2 */ var attr = wxt_helper({
                'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
                'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
                'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
                'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
                'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
                'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
                'xmlns:xlink': "http://www.w3.org/1999/xlink",
                'xmlns:dc': "http://purl.org/dc/elements/1.1/",
                'xmlns:meta': "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
                'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
                'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
                'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
                'xmlns:chart': "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
                'xmlns:dr3d': "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
                'xmlns:math': "http://www.w3.org/1998/Math/MathML",
                'xmlns:form': "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
                'xmlns:script': "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
                'xmlns:ooo': "http://openoffice.org/2004/office",
                'xmlns:ooow': "http://openoffice.org/2004/writer",
                'xmlns:oooc': "http://openoffice.org/2004/calc",
                'xmlns:dom': "http://www.w3.org/2001/xml-events",
                'xmlns:xforms': "http://www.w3.org/2002/xforms",
                'xmlns:xsd': "http://www.w3.org/2001/XMLSchema",
                'xmlns:xsi': "http://www.w3.org/2001/XMLSchema-instance",
                'xmlns:sheet': "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
                'xmlns:rpt': "http://openoffice.org/2005/report",
                'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
                'xmlns:xhtml': "http://www.w3.org/1999/xhtml",
                'xmlns:grddl': "http://www.w3.org/2003/g/data-view#",
                'xmlns:tableooo': "http://openoffice.org/2009/table",
                'xmlns:drawooo': "http://openoffice.org/2010/draw",
                'xmlns:calcext': "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
                'xmlns:loext': "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
                'xmlns:field': "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
                'xmlns:formx': "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
                'xmlns:css3t': "http://www.w3.org/TR/css3-text/",
                'office:version': "1.2"
            });
            var fods = wxt_helper({
                'xmlns:config': "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
                'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
            });
            if (opts.bookType == "fods") o.push('<office:document' + attr + fods + '>\n');
            else o.push('<office:document-content' + attr + '>\n');
            write_automatic_styles_ods(o);
            o.push('  <office:body>\n');
            o.push('    <office:spreadsheet>\n');
            for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
            o.push('    </office:spreadsheet>\n');
            o.push('  </office:body>\n');
            if (opts.bookType == "fods") o.push('</office:document>');
            else o.push('</office:document-content>');
            return o.join("");
        };
    }();
    function write_ods(wb, opts) {
        if (opts.bookType == "fods") return write_content_ods(wb, opts);
        var zip = zip_new();
        var f = "";
        var manifest = [];
        var rdf = [];
        /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
        zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
        /* Part 1 Section 2.2 Documents */ f = "content.xml";
        zip_add_file(zip, f, write_content_ods(wb, opts));
        manifest.push([
            f,
            "text/xml"
        ]);
        rdf.push([
            f,
            "ContentFile"
        ]);
        /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
        zip_add_file(zip, f, write_styles_ods(wb, opts));
        manifest.push([
            f,
            "text/xml"
        ]);
        rdf.push([
            f,
            "StylesFile"
        ]);
        /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
        zip_add_file(zip, f, write_meta_ods());
        manifest.push([
            f,
            "text/xml"
        ]);
        rdf.push([
            f,
            "MetadataFile"
        ]);
        /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
        zip_add_file(zip, f, write_rdf(rdf /*, opts*/ ));
        manifest.push([
            f,
            "application/rdf+xml"
        ]);
        /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
        zip_add_file(zip, f, write_manifest(manifest /*, opts*/ ));
        return zip;
    }
    function write_sheet_index(wb, sheet) {
        if (!sheet) return 0;
        var idx = wb.SheetNames.indexOf(sheet);
        if (idx == -1) throw new Error("Sheet not found: " + sheet);
        return idx;
    }
    function write_obj_str(factory) {
        return function write_str(wb, o) {
            var idx = write_sheet_index(wb, o.sheet);
            return factory.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb);
        };
    }
    var write_htm_str = write_obj_str(HTML_);
    var write_csv_str = write_obj_str({
        from_sheet: sheet_to_csv
    });
    var write_slk_str = write_obj_str(typeof SYLK !== "undefined" ? SYLK : {});
    var write_dif_str = write_obj_str(typeof DIF !== "undefined" ? DIF : {});
    var write_prn_str = write_obj_str(typeof PRN !== "undefined" ? PRN : {});
    var write_rtf_str = write_obj_str(typeof RTF !== "undefined" ? RTF : {});
    var write_txt_str = write_obj_str({
        from_sheet: sheet_to_txt
    });
    var write_dbf_buf = write_obj_str(typeof DBF !== "undefined" ? DBF : {});
    var write_eth_str = write_obj_str(typeof ETH !== "undefined" ? ETH : {});
    function fix_opts_func(defaults) {
        return function fix_opts(opts) {
            for(var i = 0; i != defaults.length; ++i){
                var d = defaults[i];
                if (opts[d[0]] === undefined) opts[d[0]] = d[1];
                if (d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
            }
        };
    }
    var fix_read_opts = function(opts) {
        fix_opts_func([
            [
                'cellNF',
                false
            ],
            /* emit cell number format string as .z */ [
                'cellHTML',
                true
            ],
            /* emit html string as .h */ [
                'cellFormula',
                true
            ],
            /* emit formulae as .f */ [
                'cellStyles',
                false
            ],
            /* emits style/theme as .s */ [
                'cellText',
                true
            ],
            /* emit formatted text as .w */ [
                'cellDates',
                false
            ],
            /* emit date cells with type `d` */ [
                'sheetStubs',
                false
            ],
            /* emit empty cells */ [
                'sheetRows',
                0,
                'n'
            ],
            /* read n rows (0 = read all rows) */ [
                'bookDeps',
                false
            ],
            /* parse calculation chains */ [
                'bookSheets',
                false
            ],
            /* only try to get sheet names (no Sheets) */ [
                'bookProps',
                false
            ],
            /* only try to get properties (no Sheets) */ [
                'bookFiles',
                false
            ],
            /* include raw file structure (keys, files, cfb) */ [
                'bookVBA',
                false
            ],
            /* include vba raw data (vbaraw) */ [
                'password',
                ''
            ],
            /* password */ [
                'WTF',
                false
            ]
        ])(opts);
    };
    var fix_write_opts = fix_opts_func([
        [
            'cellDates',
            false
        ],
        /* write date cells with type `d` */ [
            'bookSST',
            false
        ],
        /* Generate Shared String Table */ [
            'bookType',
            'xlsx'
        ],
        /* Type of workbook (xlsx/m/b) */ [
            'compression',
            false
        ],
        /* Use file compression */ [
            'WTF',
            false
        ]
    ]);
    function get_sheet_type(n) {
        if (RELS.WS.indexOf(n) > -1) return "sheet";
        if (RELS.CS && n == RELS.CS) return "chart";
        if (RELS.DS && n == RELS.DS) return "dialog";
        if (RELS.MS && n == RELS.MS) return "macro";
        return n && n.length ? n : "sheet";
    }
    function safe_parse_wbrels(wbrels, sheets) {
        if (!wbrels) return 0;
        try {
            wbrels = sheets.map(function pwbr(w) {
                if (!w.id) w.id = w.strRelID;
                return [
                    w.name,
                    wbrels['!id'][w.id].Target,
                    get_sheet_type(wbrels['!id'][w.id].Type)
                ];
            });
        } catch (e) {
            return null;
        }
        return !wbrels || wbrels.length === 0 ? null : wbrels;
    }
    function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
        try {
            sheetRels[sheet] = parse_rels(getzipstr(zip, relsPath, true), path);
            var data = getzipdata(zip, path);
            var _ws;
            switch(stype){
                case 'sheet':
                    _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                    break;
                case 'chart':
                    _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                    if (!_ws || !_ws['!drawel']) break;
                    var dfile = resolve_path(_ws['!drawel'].Target, path);
                    var drelsp = get_rels_path(dfile);
                    var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
                    var chartp = resolve_path(draw, dfile);
                    var crelsp = get_rels_path(chartp);
                    _ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
                    break;
                case 'macro':
                    _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                    break;
                case 'dialog':
                    _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                    break;
                default:
                    throw new Error("Unrecognized sheet type " + stype);
            }
            sheets[sheet] = _ws;
            /* scan rels for comments */ var comments = [];
            if (sheetRels && sheetRels[sheet]) keys(sheetRels[sheet]).forEach(function(n) {
                if (sheetRels[sheet][n].Type == RELS.CMNT) {
                    var dfile = resolve_path(sheetRels[sheet][n].Target, path);
                    comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
                    if (!comments || !comments.length) return;
                    sheet_insert_comments(_ws, comments);
                }
            });
        } catch (e) {
            if (opts.WTF) throw e;
        }
    }
    function strip_front_slash(x) {
        return x.charAt(0) == '/' ? x.slice(1) : x;
    }
    function parse_zip(zip, opts) {
        make_ssf(SSF);
        opts = opts || {};
        fix_read_opts(opts);
        /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if (safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
        /* UOC */ if (safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
        /* Numbers */ if (safegetzipfile(zip, 'Index/Document.iwa')) throw new Error('Unsupported NUMBERS file');
        var entries = zipentries(zip);
        var dir = parse_ct(getzipstr(zip, '[Content_Types].xml'));
        var xlsb = false;
        var sheets, binname;
        if (dir.workbooks.length === 0) {
            binname = "xl/workbook.xml";
            if (getzipdata(zip, binname, true)) dir.workbooks.push(binname);
        }
        if (dir.workbooks.length === 0) {
            binname = "xl/workbook.bin";
            if (!getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
            dir.workbooks.push(binname);
            xlsb = true;
        }
        if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
        var themes = {};
        var styles = {};
        if (!opts.bookSheets && !opts.bookProps) {
            strs = [];
            if (dir.sst) try {
                strs = parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts);
            } catch (e) {
                if (opts.WTF) throw e;
            }
            if (opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//, ''), true) || "", dir.themes[0], opts);
            if (dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
        }
        /*var externbooks = */ dir.links.map(function(link) {
            try {
                var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
                return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
            } catch (e) {}
        });
        var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
        var props = {}, propdata = "";
        if (dir.coreprops.length) {
            propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
            if (propdata) props = parse_core_props(propdata);
            if (dir.extprops.length !== 0) {
                propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
                if (propdata) parse_ext_props(propdata, props, opts);
            }
        }
        var custprops = {};
        if (!opts.bookSheets || opts.bookProps) {
            if (dir.custprops.length !== 0) {
                propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
                if (propdata) custprops = parse_cust_props(propdata, opts);
            }
        }
        var out = {};
        if (opts.bookSheets || opts.bookProps) {
            if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
                return x.name;
            });
            else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
            if (opts.bookProps) {
                out.Props = props;
                out.Custprops = custprops;
            }
            if (opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
            if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
        }
        sheets = {};
        var deps = {};
        if (opts.bookDeps && dir.calcchain) deps = parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)), dir.calcchain, opts);
        var i = 0;
        var sheetRels = {};
        var path, relsPath;
        var wbsheets = wb.Sheets;
        props.Worksheets = wbsheets.length;
        props.SheetNames = [];
        for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
        var wbext = xlsb ? "bin" : "xml";
        var wbrelsi = dir.workbooks[0].lastIndexOf("/");
        var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
        if (!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
        var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile);
        if (wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);
        /* Numbers iOS hack */ var nmode = getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
        wsloop: for(i = 0; i != props.Worksheets; ++i){
            var stype = "sheet";
            if (wbrels && wbrels[i]) {
                path = 'xl/' + wbrels[i][1].replace(/[\/]?xl\//, "");
                if (!safegetzipfile(zip, path)) path = wbrels[i][1];
                if (!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/, "") + wbrels[i][1];
                stype = wbrels[i][2];
            } else {
                path = 'xl/worksheets/sheet' + (i + 1 - nmode) + "." + wbext;
                path = path.replace(/sheet0\./, "sheet.");
            }
            relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
            if (opts && opts.sheets != null) switch(typeof opts.sheets){
                case "number":
                    if (i != opts.sheets) continue wsloop;
                    break;
                case "string":
                    if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                    break;
                default:
                    if (Array.isArray && Array.isArray(opts.sheets)) {
                        var snjseen = false;
                        for(var snj = 0; snj != opts.sheets.length; ++snj){
                            if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                            if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                        }
                        if (!snjseen) continue wsloop;
                    }
            }
            safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
        }
        out = {
            Directory: dir,
            Workbook: wb,
            Props: props,
            Custprops: custprops,
            Deps: deps,
            Sheets: sheets,
            SheetNames: props.SheetNames,
            Strings: strs,
            Styles: styles,
            Themes: themes,
            SSF: SSF.get_table()
        };
        if (opts && opts.bookFiles) {
            out.keys = entries;
            out.files = zip.files;
        }
        if (opts && opts.bookVBA) {
            if (dir.vba.length > 0) out.vbaraw = getzipdata(zip, strip_front_slash(dir.vba[0]), true);
            else if (dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin', true);
        }
        return out;
    }
    /* [MS-OFFCRYPTO] 2.1.1 */ function parse_xlsxcfb(cfb, _opts) {
        var opts = _opts || {};
        var f = 'Workbook', data = CFB.find(cfb, f);
        try {
            f = '/!DataSpaces/Version';
            data = CFB.find(cfb, f);
            if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
            /*var version = */ parse_DataSpaceVersionInfo(data.content);
            /* 2.3.4.1 */ f = '/!DataSpaces/DataSpaceMap';
            data = CFB.find(cfb, f);
            if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
            var dsm = parse_DataSpaceMap(data.content);
            if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
            /* 2.3.4.2 */ f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
            data = CFB.find(cfb, f);
            if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
            var seds = parse_DataSpaceDefinition(data.content);
            if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
            /* 2.3.4.3 */ f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
            data = CFB.find(cfb, f);
            if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
            /*var hdr = */ parse_Primary(data.content);
        } catch (e) {}
        f = '/EncryptionInfo';
        data = CFB.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var einfo = parse_EncryptionInfo(data.content);
        /* 2.3.4.4 */ f = '/EncryptedPackage';
        data = CFB.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*global decrypt_agile */ if (einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
        /*global decrypt_std76 */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
        throw new Error("File is password-protected");
    }
    function write_zip(wb, opts) {
        _shapeid = 1024;
        if (opts.bookType == "ods") return write_ods(wb, opts);
        if (wb && !wb.SSF) wb.SSF = SSF.get_table();
        if (wb && wb.SSF) {
            make_ssf(SSF);
            SSF.load_table(wb.SSF);
            // $FlowIgnore
            opts.revssf = evert_num(wb.SSF);
            opts.revssf[wb.SSF[65535]] = 0;
            opts.ssf = wb.SSF;
        }
        opts.rels = {};
        opts.wbrels = {};
        opts.Strings = [];
        opts.Strings.Count = 0;
        opts.Strings.Unique = 0;
        if (browser_has_Map) opts.revStrings = new Map();
        else {
            opts.revStrings = {};
            opts.revStrings.foo = [];
            delete opts.revStrings.foo;
        }
        var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
        var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
        var ct = new_ct();
        fix_write_opts(opts = opts || {});
        var zip = zip_new();
        var f = "", rId = 0;
        opts.cellXfs = [];
        get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
        if (!wb.Props) wb.Props = {};
        f = "docProps/core.xml";
        zip_add_file(zip, f, write_core_props(wb.Props, opts));
        ct.coreprops.push(f);
        add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
        f = "docProps/app.xml";
        if (wb.Props && wb.Props.SheetNames) ;
        else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
        else {
            var _sn = [];
            for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
            wb.Props.SheetNames = _sn;
        }
        wb.Props.Worksheets = wb.Props.SheetNames.length;
        zip_add_file(zip, f, write_ext_props(wb.Props, opts));
        ct.extprops.push(f);
        add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
        if (wb.Custprops !== wb.Props && keys(wb.Custprops || {}).length > 0) {
            f = "docProps/custom.xml";
            zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
            ct.custprops.push(f);
            add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
        }
        for(rId = 1; rId <= wb.SheetNames.length; ++rId){
            var wsrels = {
                '!id': {}
            };
            var ws = wb.Sheets[wb.SheetNames[rId - 1]];
            var _type = (ws || {})["!type"] || "sheet";
            _type;
            f = "xl/worksheets/sheet" + rId + "." + wbext;
            zip_add_file(zip, f, write_ws(rId - 1, f, opts, wb, wsrels));
            ct.sheets.push(f);
            add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
            if (ws) {
                var comments = ws['!comments'];
                var need_vml = false;
                if (comments && comments.length > 0) {
                    var cf = "xl/comments" + rId + "." + wbext;
                    zip_add_file(zip, cf, write_cmnt(comments, cf, opts));
                    ct.comments.push(cf);
                    add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
                    need_vml = true;
                }
                if (ws['!legacy']) {
                    if (need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", write_comments_vml(rId, ws['!comments']));
                }
                delete ws['!comments'];
                delete ws['!legacy'];
            }
            if (wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
        }
        if (opts.Strings != null && opts.Strings.length > 0) {
            f = "xl/sharedStrings." + wbext;
            zip_add_file(zip, f, write_sst(opts.Strings, f, opts));
            ct.strs.push(f);
            add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
        }
        f = "xl/workbook." + wbext;
        zip_add_file(zip, f, write_wb(wb, f, opts));
        ct.workbooks.push(f);
        add_rels(opts.rels, 1, f, RELS.WB);
        /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
        zip_add_file(zip, f, write_theme(wb.Themes, opts));
        ct.themes.push(f);
        add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
        /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
        zip_add_file(zip, f, write_sty(wb, f, opts));
        ct.styles.push(f);
        add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
        if (wb.vbaraw && vbafmt) {
            f = "xl/vbaProject.bin";
            zip_add_file(zip, f, wb.vbaraw);
            ct.vba.push(f);
            add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
        }
        zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
        zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
        zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
        delete opts.revssf;
        delete opts.ssf;
        return zip;
    }
    function firstbyte(f, o) {
        var x = "";
        switch((o || {}).type || "base64"){
            case 'buffer':
                return [
                    f[0],
                    f[1],
                    f[2],
                    f[3],
                    f[4],
                    f[5],
                    f[6],
                    f[7]
                ];
            case 'base64':
                x = Base64.decode(f.slice(0, 12));
                break;
            case 'binary':
                x = f;
                break;
            case 'array':
                return [
                    f[0],
                    f[1],
                    f[2],
                    f[3],
                    f[4],
                    f[5],
                    f[6],
                    f[7]
                ];
            default:
                throw new Error("Unrecognized type " + (o && o.type || "undefined"));
        }
        return [
            x.charCodeAt(0),
            x.charCodeAt(1),
            x.charCodeAt(2),
            x.charCodeAt(3),
            x.charCodeAt(4),
            x.charCodeAt(5),
            x.charCodeAt(6),
            x.charCodeAt(7)
        ];
    }
    function read_cfb(cfb, opts) {
        if (CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
        return parse_xlscfb(cfb, opts);
    }
    function read_zip(data, opts) {
        var zip, d = data;
        var o = opts || {};
        if (!o.type) o.type = has_buf && Buffer.isBuffer(data) ? "buffer" : "base64";
        zip = zip_read(d, o);
        return parse_zip(zip, o);
    }
    function read_plaintext(data, o) {
        var i = 0;
        main: while(i < data.length)switch(data.charCodeAt(i)){
            case 0x0A:
            case 0x0D:
            case 0x20:
                ++i;
                break;
            case 0x3C:
                return parse_xlml(data.slice(i), o);
            default:
                break main;
        }
        return PRN.to_workbook(data, o);
    }
    function read_plaintext_raw(data, o) {
        var str = "", bytes = firstbyte(data, o);
        switch(o.type){
            case 'base64':
                str = Base64.decode(data);
                break;
            case 'binary':
                str = data;
                break;
            case 'buffer':
                str = data.toString('binary');
                break;
            case 'array':
                str = cc2str(data);
                break;
            default:
                throw new Error("Unrecognized type " + o.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
        return read_plaintext(str, o);
    }
    function read_utf16(data, o) {
        var d = data;
        if (o.type == 'base64') d = Base64.decode(d);
        d = cptable.utils.decode(1200, d.slice(2), 'str');
        o.type = "binary";
        return read_plaintext(d, o);
    }
    function bstrify(data) {
        return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
    }
    function read_prn(data, d, o, str) {
        if (str) {
            o.type = "string";
            return PRN.to_workbook(data, o);
        }
        return PRN.to_workbook(d, o);
    }
    function readSync(data, opts) {
        reset_cp();
        if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), opts);
        var d = data, n = [
            0,
            0,
            0,
            0
        ], str = false;
        var o = opts || {};
        if (o.cellStyles) {
            o.cellNF = true;
            o.sheetStubs = true;
        }
        _ssfopts = {};
        if (o.dateNF) _ssfopts.dateNF = o.dateNF;
        if (!o.type) o.type = has_buf && Buffer.isBuffer(data) ? "buffer" : "base64";
        if (o.type == "file") {
            o.type = has_buf ? "buffer" : "binary";
            d = read_binary(data);
        }
        if (o.type == "string") {
            str = true;
            o.type = "binary";
            o.codepage = 65001;
            d = bstrify(data);
        }
        if (o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
            // $FlowIgnore
            var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
            vu.foo = "bar";
            // $FlowIgnore
            if (!vu.foo) {
                o = dup(o);
                o.type = 'array';
                return readSync(ab2a(d), o);
            }
        }
        switch((n = firstbyte(d, o))[0]){
            case 0xD0:
                if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return read_cfb(CFB.read(d, o), o);
                break;
            case 0x09:
                if (n[1] <= 0x04) return parse_xlscfb(d, o);
                break;
            case 0x3C:
                return parse_xlml(d, o);
            case 0x49:
                if (n[1] === 0x44) return read_wb_ID(d, o);
                break;
            case 0x54:
                if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o);
                break;
            case 0x50:
                return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? read_zip(d, o) : read_prn(data, d, o, str);
            case 0xEF:
                return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
            case 0xFF:
                if (n[1] === 0xFE) return read_utf16(d, o);
                break;
            case 0x00:
                if (n[1] === 0x00 && n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
                break;
            case 0x03:
            case 0x83:
            case 0x8B:
            case 0x8C:
                return DBF.to_workbook(d, o);
            case 0x7B:
                if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o);
                break;
            case 0x0A:
            case 0x0D:
            case 0x20:
                return read_plaintext_raw(d, o);
        }
        if (DBF.versions.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
        return read_prn(data, d, o, str);
    }
    function readFileSync(filename, opts) {
        var o = opts || {};
        o.type = 'file';
        return readSync(filename, o);
    }
    function write_cfb_ctr(cfb, o) {
        switch(o.type){
            case "base64":
            case "binary":
                break;
            case "buffer":
            case "array":
                o.type = "";
                break;
            case "file":
                return write_dl(o.file, CFB.write(cfb, {
                    type: has_buf ? 'buffer' : ""
                }));
            case "string":
                throw new Error("'string' output type invalid for '" + o.bookType + "' files");
            default:
                throw new Error("Unrecognized type " + o.type);
        }
        return CFB.write(cfb, o);
    }
    function write_zip_type(wb, opts) {
        var o = opts || {};
        var z = write_zip(wb, o);
        var oopts = {};
        if (o.compression) oopts.compression = 'DEFLATE';
        if (o.password) oopts.type = has_buf ? "nodebuffer" : "string";
        else switch(o.type){
            case "base64":
                oopts.type = "base64";
                break;
            case "binary":
                oopts.type = "string";
                break;
            case "string":
                throw new Error("'string' output type invalid for '" + o.bookType + "' files");
            case "buffer":
            case "file":
                oopts.type = has_buf ? "nodebuffer" : "string";
                break;
            default:
                throw new Error("Unrecognized type " + o.type);
        }
        var out = z.FullPaths ? CFB.write(z, {
            fileType: "zip",
            type: {
                "nodebuffer": "buffer",
                "string": "binary"
            }[oopts.type] || oopts.type
        }) : z.generate(oopts);
        /*jshint -W083 */ if (o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
        /*jshint +W083 */ if (o.type === "file") return write_dl(o.file, out);
        return o.type == "string" ? utf8read(out) : out;
    }
    function write_cfb_type(wb, opts) {
        var o = opts || {};
        var cfb = write_xlscfb(wb, o);
        return write_cfb_ctr(cfb, o);
    }
    function write_string_type(out, opts, bom) {
        if (!bom) bom = "";
        var o = bom + out;
        switch(opts.type){
            case "base64":
                return Base64.encode(utf8write(o));
            case "binary":
                return utf8write(o);
            case "string":
                return out;
            case "file":
                return write_dl(opts.file, o, 'utf8');
            case "buffer":
                if (has_buf) return Buffer_from(o, 'utf8');
                else return write_string_type(o, {
                    type: 'binary'
                }).split("").map(function(c) {
                    return c.charCodeAt(0);
                });
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function write_stxt_type(out, opts) {
        switch(opts.type){
            case "base64":
                return Base64.encode(out);
            case "binary":
                return out;
            case "string":
                return out; /* override in sheet_to_txt */ 
            case "file":
                return write_dl(opts.file, out, 'binary');
            case "buffer":
                if (has_buf) return Buffer_from(out, 'binary');
                else return out.split("").map(function(c) {
                    return c.charCodeAt(0);
                });
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    /* TODO: test consistency */ function write_binary_type(out, opts) {
        switch(opts.type){
            case "string":
            case "base64":
            case "binary":
                var bstr = "";
                // $FlowIgnore
                for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
                return opts.type == 'base64' ? Base64.encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
            case "file":
                return write_dl(opts.file, out);
            case "buffer":
                return out;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
    }
    function writeSync(wb, opts) {
        reset_cp();
        check_wb(wb);
        var o = opts || {};
        if (o.cellStyles) {
            o.cellNF = true;
            o.sheetStubs = true;
        }
        if (o.type == "array") {
            o.type = "binary";
            var out = writeSync(wb, o);
            o.type = "array";
            return s2ab(out);
        }
        switch(o.bookType || 'xlsb'){
            case 'xml':
            case 'xlml':
                return write_string_type(write_xlml(wb, o), o);
            case 'slk':
            case 'sylk':
                return write_string_type(write_slk_str(wb, o), o);
            case 'htm':
            case 'html':
                return write_string_type(write_htm_str(wb, o), o);
            case 'txt':
                return write_stxt_type(write_txt_str(wb, o), o);
            case 'csv':
                return write_string_type(write_csv_str(wb, o), o, "\ufeff");
            case 'dif':
                return write_string_type(write_dif_str(wb, o), o);
            case 'dbf':
                return write_binary_type(write_dbf_buf(wb, o), o);
            case 'prn':
                return write_string_type(write_prn_str(wb, o), o);
            case 'rtf':
                return write_string_type(write_rtf_str(wb, o), o);
            case 'eth':
                return write_string_type(write_eth_str(wb, o), o);
            case 'fods':
                return write_string_type(write_ods(wb, o), o);
            case 'biff2':
                if (!o.biff) o.biff = 2; /* falls through */ 
            case 'biff3':
                if (!o.biff) o.biff = 3; /* falls through */ 
            case 'biff4':
                if (!o.biff) o.biff = 4;
                return write_binary_type(write_biff_buf(wb, o), o);
            case 'biff5':
                if (!o.biff) o.biff = 5; /* falls through */ 
            case 'biff8':
            case 'xla':
            case 'xls':
                if (!o.biff) o.biff = 8;
                return write_cfb_type(wb, o);
            case 'xlsx':
            case 'xlsm':
            case 'xlam':
            case 'xlsb':
            case 'ods':
                return write_zip_type(wb, o);
            default:
                throw new Error("Unrecognized bookType |" + o.bookType + "|");
        }
    }
    function resolve_book_type(o) {
        if (o.bookType) return;
        var _BT = {
            "xls": "biff8",
            "htm": "html",
            "slk": "sylk",
            "socialcalc": "eth",
            "Sh33tJS": "WTF"
        };
        var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
        if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
        o.bookType = _BT[o.bookType] || o.bookType;
    }
    function writeFileSync(wb, filename, opts) {
        var o = opts || {};
        o.type = 'file';
        o.file = filename;
        resolve_book_type(o);
        return writeSync(wb, o);
    }
    function writeFileAsync(filename, wb, opts, cb) {
        var o = opts || {};
        o.type = 'file';
        o.file = filename;
        resolve_book_type(o);
        o.type = 'buffer';
        var _cb = cb;
        if (!(_cb instanceof Function)) _cb = opts;
        return _fs.writeFile(filename, writeSync(wb, o), _cb);
    }
    function make_json_row(sheet, r, R, cols, header, hdr, dense, o) {
        var rr = encode_row(R);
        var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
        var isempty = true;
        var row = header === 1 ? [] : {};
        if (header !== 1) {
            if (Object.defineProperty) try {
                Object.defineProperty(row, '__rowNum__', {
                    value: R,
                    enumerable: false
                });
            } catch (e) {
                row.__rowNum__ = R;
            }
            else row.__rowNum__ = R;
        }
        if (!dense || sheet[R]) for(var C = r.s.c; C <= r.e.c; ++C){
            var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
            if (val === undefined || val.t === undefined) {
                if (defval === undefined) continue;
                if (hdr[C] != null) row[hdr[C]] = defval;
                continue;
            }
            var v = val.v;
            switch(val.t){
                case 'z':
                    if (v == null) break;
                    continue;
                case 'e':
                    v = void 0;
                    break;
                case 's':
                case 'd':
                case 'b':
                case 'n':
                    break;
                default:
                    throw new Error('unrecognized type ' + val.t);
            }
            if (hdr[C] != null) {
                if (v == null) {
                    if (defval !== undefined) row[hdr[C]] = defval;
                    else if (raw && v === null) row[hdr[C]] = null;
                    else continue;
                } else row[hdr[C]] = raw || o.rawNumbers && val.t == "n" ? v : format_cell(val, v, o);
                if (v != null) isempty = false;
            }
        }
        return {
            row: row,
            isempty: isempty
        };
    }
    function sheet_to_json(sheet, opts) {
        if (sheet == null || sheet["!ref"] == null) return [];
        var val = {
            t: 'n',
            v: 0
        }, header = 0, offset = 1, hdr = [], v = 0, vv = "";
        var r = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var o = opts || {};
        var range = o.range != null ? o.range : sheet["!ref"];
        if (o.header === 1) header = 1;
        else if (o.header === "A") header = 2;
        else if (Array.isArray(o.header)) header = 3;
        else if (o.header == null) header = 0;
        switch(typeof range){
            case 'string':
                r = safe_decode_range(range);
                break;
            case 'number':
                r = safe_decode_range(sheet["!ref"]);
                r.s.r = range;
                break;
            default:
                r = range;
        }
        if (header > 0) offset = 0;
        var rr = encode_row(r.s.r);
        var cols = [];
        var out = [];
        var outi = 0, counter = 0;
        var dense = Array.isArray(sheet);
        var R = r.s.r, C = 0, CC = 0;
        if (dense && !sheet[R]) sheet[R] = [];
        for(C = r.s.c; C <= r.e.c; ++C){
            cols[C] = encode_col(C);
            val = dense ? sheet[R][C] : sheet[cols[C] + rr];
            switch(header){
                case 1:
                    hdr[C] = C - r.s.c;
                    break;
                case 2:
                    hdr[C] = cols[C];
                    break;
                case 3:
                    hdr[C] = o.header[C - r.s.c];
                    break;
                default:
                    if (val == null) val = {
                        w: "__EMPTY",
                        t: "s"
                    };
                    vv = v = format_cell(val, null, o);
                    counter = 0;
                    for(CC = 0; CC < hdr.length; ++CC)if (hdr[CC] == vv) vv = v + "_" + ++counter;
                    hdr[C] = vv;
            }
        }
        for(R = r.s.r + offset; R <= r.e.r; ++R){
            var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
        }
        out.length = outi;
        return out;
    }
    var qreg = /"/g;
    function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
        var isempty = true;
        var row = [], txt = "", rr = encode_row(R);
        for(var C = r.s.c; C <= r.e.c; ++C){
            if (!cols[C]) continue;
            var val = o.dense ? (sheet[R] || [])[C] : sheet[cols[C] + rr];
            if (val == null) txt = "";
            else if (val.v != null) {
                isempty = false;
                txt = '' + (o.rawNumbers && val.t == "n" ? val.v : format_cell(val, null, o));
                for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                    txt = "\"" + txt.replace(qreg, '""') + "\"";
                    break;
                }
                if (txt == "ID") txt = '"ID"';
            } else if (val.f != null && !val.F) {
                isempty = false;
                txt = '=' + val.f;
                if (txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
            } else txt = "";
            /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
        }
        if (o.blankrows === false && isempty) return null;
        return row.join(FS);
    }
    function sheet_to_csv(sheet, opts) {
        var out = [];
        var o = opts == null ? {} : opts;
        if (sheet == null || sheet["!ref"] == null) return "";
        var r = safe_decode_range(sheet["!ref"]);
        var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
        var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
        var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
        var row = "", cols = [];
        o.dense = Array.isArray(sheet);
        var colinfo = o.skipHidden && sheet["!cols"] || [];
        var rowinfo = o.skipHidden && sheet["!rows"] || [];
        for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = encode_col(C);
        for(var R = r.s.r; R <= r.e.r; ++R){
            if ((rowinfo[R] || {}).hidden) continue;
            row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
            if (row == null) continue;
            if (o.strip) row = row.replace(endregex, "");
            out.push(row + RS);
        }
        delete o.dense;
        return out.join("");
    }
    function sheet_to_txt(sheet, opts) {
        if (!opts) opts = {};
        opts.FS = "\t";
        opts.RS = "\n";
        var s = sheet_to_csv(sheet, opts);
        if (typeof cptable == 'undefined' || opts.type == 'string') return s;
        var o = cptable.utils.encode(1200, s, 'str');
        return String.fromCharCode(255) + String.fromCharCode(254) + o;
    }
    function sheet_to_formulae(sheet) {
        var y = "", x, val = "";
        if (sheet == null || sheet["!ref"] == null) return [];
        var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
        var cmds = [];
        var dense = Array.isArray(sheet);
        for(C = r.s.c; C <= r.e.c; ++C)cols[C] = encode_col(C);
        for(var R = r.s.r; R <= r.e.r; ++R){
            rr = encode_row(R);
            for(C = r.s.c; C <= r.e.c; ++C){
                y = cols[C] + rr;
                x = dense ? (sheet[R] || [])[C] : sheet[y];
                val = "";
                if (x === undefined) continue;
                else if (x.F != null) {
                    y = x.F;
                    if (!x.f) continue;
                    val = x.f;
                    if (y.indexOf(":") == -1) y = y + ":" + y;
                }
                if (x.f != null) val = x.f;
                else if (x.t == 'z') continue;
                else if (x.t == 'n' && x.v != null) val = "" + x.v;
                else if (x.t == 'b') val = x.v ? "TRUE" : "FALSE";
                else if (x.w !== undefined) val = "'" + x.w;
                else if (x.v === undefined) continue;
                else if (x.t == 's') val = "'" + x.v;
                else val = "" + x.v;
                cmds[cmds.length] = y + "=" + val;
            }
        }
        return cmds;
    }
    function sheet_add_json(_ws, js, opts) {
        var o = opts || {};
        var offset = +!o.skipHeader;
        var ws = _ws || {};
        var _R = 0, _C = 0;
        if (ws && o.origin != null) {
            if (typeof o.origin == 'number') _R = o.origin;
            else {
                var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
                _R = _origin.r;
                _C = _origin.c;
            }
        }
        var cell;
        var range = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: _C,
                r: _R + js.length - 1 + offset
            }
        };
        if (ws['!ref']) {
            var _range = safe_decode_range(ws['!ref']);
            range.e.c = Math.max(range.e.c, _range.e.c);
            range.e.r = Math.max(range.e.r, _range.e.r);
            if (_R == -1) {
                _R = _range.e.r + 1;
                range.e.r = _R + js.length - 1 + offset;
            }
        } else if (_R == -1) {
            _R = 0;
            range.e.r = js.length - 1 + offset;
        }
        var hdr = o.header || [], C = 0;
        js.forEach(function(JS, R) {
            keys(JS).forEach(function(k) {
                if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
                var v = JS[k];
                var t = 'z';
                var z = "";
                var ref = encode_cell({
                    c: _C + C,
                    r: _R + R + offset
                });
                cell = utils.sheet_get_cell(ws, ref);
                if (v && typeof v === 'object' && !(v instanceof Date)) ws[ref] = v;
                else {
                    if (typeof v == 'number') t = 'n';
                    else if (typeof v == 'boolean') t = 'b';
                    else if (typeof v == 'string') t = 's';
                    else if (v instanceof Date) {
                        t = 'd';
                        if (!o.cellDates) {
                            t = 'n';
                            v = datenum(v);
                        }
                        z = o.dateNF || SSF._table[14];
                    }
                    if (!cell) ws[ref] = cell = {
                        t: t,
                        v: v
                    };
                    else {
                        cell.t = t;
                        cell.v = v;
                        delete cell.w;
                        delete cell.R;
                        if (z) cell.z = z;
                    }
                    if (z) cell.z = z;
                }
            });
        });
        range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
        var __R = encode_row(_R);
        if (offset) for(C = 0; C < hdr.length; ++C)ws[encode_col(C + _C) + __R] = {
            t: 's',
            v: hdr[C]
        };
        ws['!ref'] = encode_range(range);
        return ws;
    }
    function json_to_sheet(js, opts) {
        return sheet_add_json(null, js, opts);
    }
    var utils = {
        encode_col: encode_col,
        encode_row: encode_row,
        encode_cell: encode_cell,
        encode_range: encode_range,
        decode_col: decode_col,
        decode_row: decode_row,
        split_cell: split_cell,
        decode_cell: decode_cell,
        decode_range: decode_range,
        format_cell: format_cell,
        get_formulae: sheet_to_formulae,
        make_csv: sheet_to_csv,
        make_json: sheet_to_json,
        make_formulae: sheet_to_formulae,
        sheet_add_aoa: sheet_add_aoa,
        sheet_add_json: sheet_add_json,
        sheet_add_dom: sheet_add_dom,
        aoa_to_sheet: aoa_to_sheet,
        json_to_sheet: json_to_sheet,
        table_to_sheet: parse_dom_table,
        table_to_book: table_to_book,
        sheet_to_csv: sheet_to_csv,
        sheet_to_txt: sheet_to_txt,
        sheet_to_json: sheet_to_json,
        sheet_to_html: HTML_.from_sheet,
        sheet_to_formulae: sheet_to_formulae,
        sheet_to_row_object_array: sheet_to_json
    };
    (function(utils) {
        utils.consts = utils.consts || {};
        function add_consts(R /*Array<any>*/ ) {
            R.forEach(function(a) {
                utils.consts[a[0]] = a[1];
            });
        }
        function get_default(x, y, z) {
            return x[y] != null ? x[y] : x[y] = z;
        }
        /* get cell, creating a stub if necessary */ function ws_get_cell_stub(ws, R, C) {
            /* A1 cell address */ if (typeof R == "string") {
                /* dense */ if (Array.isArray(ws)) {
                    var RC = decode_cell(R);
                    if (!ws[RC.r]) ws[RC.r] = [];
                    return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {
                        t: 'z'
                    });
                }
                return ws[R] || (ws[R] = {
                    t: 'z'
                });
            }
            /* cell address object */ if (typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
            /* R and C are 0-based indices */ return ws_get_cell_stub(ws, encode_cell({
                r: R,
                c: C || 0
            }));
        }
        utils.sheet_get_cell = ws_get_cell_stub;
        /* find sheet index for given name / validate index */ function wb_sheet_idx(wb, sh) {
            if (typeof sh == "number") {
                if (sh >= 0 && wb.SheetNames.length > sh) return sh;
                throw new Error("Cannot find sheet # " + sh);
            } else if (typeof sh == "string") {
                var idx = wb.SheetNames.indexOf(sh);
                if (idx > -1) return idx;
                throw new Error("Cannot find sheet name |" + sh + "|");
            } else throw new Error("Cannot find sheet |" + sh + "|");
        }
        /* simple blank workbook object */ utils.book_new = function() {
            return {
                SheetNames: [],
                Sheets: {}
            };
        };
        /* add a worksheet to the end of a given workbook */ utils.book_append_sheet = function(wb, ws, name) {
            if (!name) {
                for(var i = 1; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
            }
            if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
            check_ws_name(name);
            if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
            wb.SheetNames.push(name);
            wb.Sheets[name] = ws;
        };
        /* set sheet visibility (visible/hidden/very hidden) */ utils.book_set_sheet_visibility = function(wb, sh, vis) {
            get_default(wb, "Workbook", {});
            get_default(wb.Workbook, "Sheets", []);
            var idx = wb_sheet_idx(wb, sh);
            // $FlowIgnore
            get_default(wb.Workbook.Sheets, idx, {});
            switch(vis){
                case 0:
                case 1:
                case 2:
                    break;
                default:
                    throw new Error("Bad sheet visibility setting " + vis);
            }
            // $FlowIgnore
            wb.Workbook.Sheets[idx].Hidden = vis;
        };
        add_consts([
            [
                "SHEET_VISIBLE",
                0
            ],
            [
                "SHEET_HIDDEN",
                1
            ],
            [
                "SHEET_VERY_HIDDEN",
                2
            ]
        ]);
        /* set number format */ utils.cell_set_number_format = function(cell, fmt) {
            cell.z = fmt;
            return cell;
        };
        /* set cell hyperlink */ utils.cell_set_hyperlink = function(cell, target, tooltip) {
            if (!target) delete cell.l;
            else {
                cell.l = {
                    Target: target
                };
                if (tooltip) cell.l.Tooltip = tooltip;
            }
            return cell;
        };
        utils.cell_set_internal_link = function(cell, range, tooltip) {
            return utils.cell_set_hyperlink(cell, "#" + range, tooltip);
        };
        /* add to cell comments */ utils.cell_add_comment = function(cell, text, author) {
            if (!cell.c) cell.c = [];
            cell.c.push({
                t: text,
                a: author || "SheetJS"
            });
        };
        /* set array formula and flush related cells */ utils.sheet_set_array_formula = function(ws, range, formula) {
            var rng = typeof range != "string" ? range : safe_decode_range(range);
            var rngstr = typeof range == "string" ? range : encode_range(range);
            for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
                var cell = ws_get_cell_stub(ws, R, C);
                cell.t = 'n';
                cell.F = rngstr;
                delete cell.v;
                if (R == rng.s.r && C == rng.s.c) cell.f = formula;
            }
            return ws;
        };
        return utils;
    })(utils);
    if (has_buf && true) (function() {
        var Readable = require("14fca37c927e9a31").Readable;
        var write_csv_stream = function(sheet, opts) {
            var stream = Readable();
            var o = opts == null ? {} : opts;
            if (sheet == null || sheet["!ref"] == null) {
                stream.push(null);
                return stream;
            }
            var r = safe_decode_range(sheet["!ref"]);
            var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
            var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
            var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
            var row = "", cols = [];
            o.dense = Array.isArray(sheet);
            var colinfo = o.skipHidden && sheet["!cols"] || [];
            var rowinfo = o.skipHidden && sheet["!rows"] || [];
            for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = encode_col(C);
            var R = r.s.r;
            var BOM = false;
            stream._read = function() {
                if (!BOM) {
                    BOM = true;
                    return stream.push("\uFEFF");
                }
                while(R <= r.e.r){
                    ++R;
                    if ((rowinfo[R - 1] || {}).hidden) continue;
                    row = make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, o);
                    if (row != null) {
                        if (o.strip) row = row.replace(endregex, "");
                        stream.push(row + RS);
                        break;
                    }
                }
                if (R > r.e.r) return stream.push(null);
            };
            return stream;
        };
        var write_html_stream = function(ws, opts) {
            var stream = Readable();
            var o = opts || {};
            var header = o.header != null ? o.header : HTML_.BEGIN;
            var footer = o.footer != null ? o.footer : HTML_.END;
            stream.push(header);
            var r = decode_range(ws['!ref']);
            o.dense = Array.isArray(ws);
            stream.push(HTML_._preamble(ws, r, o));
            var R = r.s.r;
            var end = false;
            stream._read = function() {
                if (R > r.e.r) {
                    if (!end) {
                        end = true;
                        stream.push("</table>" + footer);
                    }
                    return stream.push(null);
                }
                while(R <= r.e.r){
                    stream.push(HTML_._row(ws, r, R, o));
                    ++R;
                    break;
                }
            };
            return stream;
        };
        var write_json_stream = function(sheet, opts) {
            var stream = Readable({
                objectMode: true
            });
            if (sheet == null || sheet["!ref"] == null) {
                stream.push(null);
                return stream;
            }
            var val = {
                t: 'n',
                v: 0
            }, header = 0, offset = 1, hdr = [], v = 0, vv = "";
            var r = {
                s: {
                    r: 0,
                    c: 0
                },
                e: {
                    r: 0,
                    c: 0
                }
            };
            var o = opts || {};
            var range = o.range != null ? o.range : sheet["!ref"];
            if (o.header === 1) header = 1;
            else if (o.header === "A") header = 2;
            else if (Array.isArray(o.header)) header = 3;
            switch(typeof range){
                case 'string':
                    r = safe_decode_range(range);
                    break;
                case 'number':
                    r = safe_decode_range(sheet["!ref"]);
                    r.s.r = range;
                    break;
                default:
                    r = range;
            }
            if (header > 0) offset = 0;
            var rr = encode_row(r.s.r);
            var cols = [];
            var counter = 0;
            var dense = Array.isArray(sheet);
            var R = r.s.r, C = 0, CC = 0;
            if (dense && !sheet[R]) sheet[R] = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cols[C] = encode_col(C);
                val = dense ? sheet[R][C] : sheet[cols[C] + rr];
                switch(header){
                    case 1:
                        hdr[C] = C - r.s.c;
                        break;
                    case 2:
                        hdr[C] = cols[C];
                        break;
                    case 3:
                        hdr[C] = o.header[C - r.s.c];
                        break;
                    default:
                        if (val == null) val = {
                            w: "__EMPTY",
                            t: "s"
                        };
                        vv = v = format_cell(val, null, o);
                        counter = 0;
                        for(CC = 0; CC < hdr.length; ++CC)if (hdr[CC] == vv) vv = v + "_" + ++counter;
                        hdr[C] = vv;
                }
            }
            R = r.s.r + offset;
            stream._read = function() {
                if (R > r.e.r) return stream.push(null);
                while(R <= r.e.r){
                    //if ((rowinfo[R-1]||{}).hidden) continue;
                    var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
                    ++R;
                    if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                        stream.push(row.row);
                        break;
                    }
                }
            };
            return stream;
        };
        XLSX.stream = {
            to_json: write_json_stream,
            to_html: write_html_stream,
            to_csv: write_csv_stream
        };
    })();
    if (typeof parse_xlscfb !== "undefined") XLSX.parse_xlscfb = parse_xlscfb;
    XLSX.parse_zip = parse_zip;
    XLSX.read = readSync; //xlsread
    XLSX.readFile = readFileSync; //readFile
    XLSX.readFileSync = readFileSync;
    XLSX.write = writeSync;
    XLSX.writeFile = writeFileSync;
    XLSX.writeFileSync = writeFileSync;
    XLSX.writeFileAsync = writeFileAsync;
    XLSX.utils = utils;
    XLSX.SSF = SSF;
    if (typeof CFB !== "undefined") XLSX.CFB = CFB;
}
make_xlsx_lib(exports);
/*exported XLS, ODS */ var XLS = XLSX, ODS = XLSX;

},{"a66ff1c21c5e5b1":"aBjM4","bfbde4dddeb0bada":"aBjM4","919a7bedd2525af3":"2p7rD","d0d1d500be3fa453":"aBjM4","fdb983bb55cd9233":"1HvPu","7da297ca2e6a8125":"aBjM4","14fca37c927e9a31":"aBjM4"}],"2p7rD":[function(require,module,exports,__globalThis) {
/* cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W100 */ var Buffer = require("bb049d426c59ff1e").Buffer;
var cptable = {
    version: "1.14.0"
};
cptable[437] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[620] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\u0105\xe7\xea\xeb\xe8\xef\xee\u0107\xc4\u0104\u0118\u0119\u0142\xf4\xf6\u0106\xfb\xf9\u015A\xd6\xdc\xa2\u0141\xa5\u015B\u0192\u0179\u017B\xf3\xd3\u0144\u0143\u017A\u017C\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[737] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u03C5\u03C6\u03C7\u03C8\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03C9\u03AC\u03AD\u03AE\u03CA\u03AF\u03CC\u03CD\u03CB\u03CE\u0386\u0388\u0389\u038A\u038C\u038E\u038F\xb1\u2265\u2264\u03AA\u03AB\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[850] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u0131\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[852] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\u016F\u0107\xe7\u0142\xeb\u0150\u0151\xee\u0179\xc4\u0106\xc9\u0139\u013A\xf4\xf6\u013D\u013E\u015A\u015B\xd6\xdc\u0164\u0165\u0141\xd7\u010D\xe1\xed\xf3\xfa\u0104\u0105\u017D\u017E\u0118\u0119\xac\u017A\u010C\u015F\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\u011A\u015E\u2563\u2551\u2557\u255D\u017B\u017C\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0102\u0103\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u0111\u0110\u010E\xcb\u010F\u0147\xcd\xce\u011B\u2518\u250C\u2588\u2584\u0162\u016E\u2580\xd3\xdf\xd4\u0143\u0144\u0148\u0160\u0161\u0154\xda\u0155\u0170\xfd\xdd\u0163\xb4\xad\u02DD\u02DB\u02C7\u02D8\xa7\xf7\xb8\xb0\xa8\u02D9\u0171\u0158\u0159\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[857] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\u0131\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\u0130\xd6\xdc\xf8\xa3\xd8\u015E\u015F\xe1\xed\xf3\xfa\xf1\xd1\u011E\u011F\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xba\xaa\xca\xcb\xc8\uFFFD\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\uFFFD\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1\uFFFD\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[861] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[865] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xa4\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[866] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\xa4\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[874] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\u2026\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[895] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u010C\xfc\xe9\u010F\xe4\u010E\u0164\u010D\u011B\u011A\u0139\xcd\u013E\u01EA\xc4\xc1\xc9\u017E\u017D\xf4\xf6\xd3\u016F\xda\xfd\xd6\xdc\u0160\u013D\xdd\u0158\u0165\xe1\xed\xf3\xfa\u0148\u0147\u016E\xd4\u0161\u0159\u0155\u0154\xbc\xa7\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[932] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF61\uFF62\uFF63\uFF64\uFF65\uFF66\uFF67\uFF68\uFF69\uFF6A\uFF6B\uFF6C\uFF6D\uFF6E\uFF6F\uFF70\uFF71\uFF72\uFF73\uFF74\uFF75\uFF76\uFF77\uFF78\uFF79\uFF7A\uFF7B\uFF7C\uFF7D\uFF7E\uFF7F\uFF80\uFF81\uFF82\uFF83\uFF84\uFF85\uFF86\uFF87\uFF88\uFF89\uFF8A\uFF8B\uFF8C\uFF8D\uFF8E\uFF8F\uFF90\uFF91\uFF92\uFF93\uFF94\uFF95\uFF96\uFF97\uFF98\uFF99\uFF9A\uFF9B\uFF9C\uFF9D\uFF9E\uFF9F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[129] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3010\u3011\uFF0B\uFF0D\xb1\xd7\uFFFD\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6\uFFFD\uFFFD\uFFFD\uFFFD\u25EF\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[129].length; ++j)if (D[129][j].charCodeAt(0) !== 0xFFFD) {
        e[D[129][j]] = 33024 + j;
        d[33024 + j] = D[129][j];
    }
    D[130] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFFFD\uFFFD\uFFFD\uFFFD\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[130].length; ++j)if (D[130][j].charCodeAt(0) !== 0xFFFD) {
        e[D[130][j]] = 33280 + j;
        d[33280 + j] = D[130][j];
    }
    D[131] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\uFFFD\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[131].length; ++j)if (D[131][j].charCodeAt(0) !== 0xFFFD) {
        e[D[131][j]] = 33536 + j;
        d[33536 + j] = D[131][j];
    }
    D[132] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\uFFFD\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[132].length; ++j)if (D[132][j].charCodeAt(0) !== 0xFFFD) {
        e[D[132][j]] = 33792 + j;
        d[33792 + j] = D[132][j];
    }
    D[135] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\u246A\u246B\u246C\u246D\u246E\u246F\u2470\u2471\u2472\u2473\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\uFFFD\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u337B\uFFFD\u301D\u301F\u2116\u33CD\u2121\u32A4\u32A5\u32A6\u32A7\u32A8\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[135].length; ++j)if (D[135][j].charCodeAt(0) !== 0xFFFD) {
        e[D[135][j]] = 34560 + j;
        d[34560 + j] = D[135][j];
    }
    D[136] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[136].length; ++j)if (D[136][j].charCodeAt(0) !== 0xFFFD) {
        e[D[136][j]] = 34816 + j;
        d[34816 + j] = D[136][j];
    }
    D[137] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186\uFFFD\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[137].length; ++j)if (D[137][j].charCodeAt(0) !== 0xFFFD) {
        e[D[137][j]] = 35072 + j;
        d[35072 + j] = D[137][j];
    }
    D[138] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B\uFFFD\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[138].length; ++j)if (D[138][j].charCodeAt(0) !== 0xFFFD) {
        e[D[138][j]] = 35328 + j;
        d[35328 + j] = D[138][j];
    }
    D[139] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551\uFFFD\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[139].length; ++j)if (D[139][j].charCodeAt(0) !== 0xFFFD) {
        e[D[139][j]] = 35584 + j;
        d[35584 + j] = D[139][j];
    }
    D[140] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8\uFFFD\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[140].length; ++j)if (D[140][j].charCodeAt(0) !== 0xFFFD) {
        e[D[140][j]] = 35840 + j;
        d[35840 + j] = D[140][j];
    }
    D[141] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D\uFFFD\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[141].length; ++j)if (D[141][j].charCodeAt(0) !== 0xFFFD) {
        e[D[141][j]] = 36096 + j;
        d[36096 + j] = D[141][j];
    }
    D[142] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62\uFFFD\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[142].length; ++j)if (D[142][j].charCodeAt(0) !== 0xFFFD) {
        e[D[142][j]] = 36352 + j;
        d[36352 + j] = D[142][j];
    }
    D[143] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3\uFFFD\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[143].length; ++j)if (D[143][j].charCodeAt(0) !== 0xFFFD) {
        e[D[143][j]] = 36608 + j;
        d[36608 + j] = D[143][j];
    }
    D[144] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8\uFFFD\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[144].length; ++j)if (D[144][j].charCodeAt(0) !== 0xFFFD) {
        e[D[144][j]] = 36864 + j;
        d[36864 + j] = D[144][j];
    }
    D[145] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB\uFFFD\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[145].length; ++j)if (D[145][j].charCodeAt(0) !== 0xFFFD) {
        e[D[145][j]] = 37120 + j;
        d[37120 + j] = D[145][j];
    }
    D[146] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4\uFFFD\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[146].length; ++j)if (D[146][j].charCodeAt(0) !== 0xFFFD) {
        e[D[146][j]] = 37376 + j;
        d[37376 + j] = D[146][j];
    }
    D[147] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC\uFFFD\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[147].length; ++j)if (D[147][j].charCodeAt(0) !== 0xFFFD) {
        e[D[147][j]] = 37632 + j;
        d[37632 + j] = D[147][j];
    }
    D[148] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885\uFFFD\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[148].length; ++j)if (D[148][j].charCodeAt(0) !== 0xFFFD) {
        e[D[148][j]] = 37888 + j;
        d[37888 + j] = D[148][j];
    }
    D[149] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577\uFFFD\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[149].length; ++j)if (D[149][j].charCodeAt(0) !== 0xFFFD) {
        e[D[149][j]] = 38144 + j;
        d[38144 + j] = D[149][j];
    }
    D[150] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6\uFFFD\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[150].length; ++j)if (D[150][j].charCodeAt(0) !== 0xFFFD) {
        e[D[150][j]] = 38400 + j;
        d[38400 + j] = D[150][j];
    }
    D[151] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32\uFFFD\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[151].length; ++j)if (D[151][j].charCodeAt(0) !== 0xFFFD) {
        e[D[151][j]] = 38656 + j;
        d[38656 + j] = D[151][j];
    }
    D[152] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[152].length; ++j)if (D[152][j].charCodeAt(0) !== 0xFFFD) {
        e[D[152][j]] = 38912 + j;
        d[38912 + j] = D[152][j];
    }
    D[153] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED\uFFFD\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[153].length; ++j)if (D[153][j].charCodeAt(0) !== 0xFFFD) {
        e[D[153][j]] = 39168 + j;
        d[39168 + j] = D[153][j];
    }
    D[154] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638\uFFFD\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[154].length; ++j)if (D[154][j].charCodeAt(0) !== 0xFFFD) {
        e[D[154][j]] = 39424 + j;
        d[39424 + j] = D[154][j];
    }
    D[155] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80\uFFFD\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[155].length; ++j)if (D[155][j].charCodeAt(0) !== 0xFFFD) {
        e[D[155][j]] = 39680 + j;
        d[39680 + j] = D[155][j];
    }
    D[156] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060\uFFFD\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[156].length; ++j)if (D[156][j].charCodeAt(0) !== 0xFFFD) {
        e[D[156][j]] = 39936 + j;
        d[39936 + j] = D[156][j];
    }
    D[157] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B\uFFFD\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[157].length; ++j)if (D[157][j].charCodeAt(0) !== 0xFFFD) {
        e[D[157][j]] = 40192 + j;
        d[40192 + j] = D[157][j];
    }
    D[158] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E\uFFFD\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[158].length; ++j)if (D[158][j].charCodeAt(0) !== 0xFFFD) {
        e[D[158][j]] = 40448 + j;
        d[40448 + j] = D[158][j];
    }
    D[159] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF\uFFFD\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[159].length; ++j)if (D[159][j].charCodeAt(0) !== 0xFFFD) {
        e[D[159][j]] = 40704 + j;
        d[40704 + j] = D[159][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD\uFFFD\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF\uFFFD\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0\uFFFD\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37\uFFFD\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264\uFFFD\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC\uFFFD\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7\uFFFD\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C\uFFFD\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599\uFFFD\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43\uFFFD\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF\uFFFD\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFFFD\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\uFFFD\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1\uFFFD\uFFFD\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\uFFE2\uFFE4\uFF07\uFF02\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[250] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u2235\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\uFFFD\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[250].length; ++j)if (D[250][j].charCodeAt(0) !== 0xFFFD) {
        e[D[250][j]] = 64000 + j;
        d[64000 + j] = D[250][j];
    }
    D[251] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFFFD\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[251].length; ++j)if (D[251][j].charCodeAt(0) !== 0xFFFD) {
        e[D[251][j]] = 64256 + j;
        d[64256 + j] = D[251][j];
    }
    D[252] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[252].length; ++j)if (D[252][j].charCodeAt(0) !== 0xFFFD) {
        e[D[252][j]] = 64512 + j;
        d[64512 + j] = D[252][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
cptable[936] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[129] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E02\u4E04\u4E05\u4E06\u4E0F\u4E12\u4E17\u4E1F\u4E20\u4E21\u4E23\u4E26\u4E29\u4E2E\u4E2F\u4E31\u4E33\u4E35\u4E37\u4E3C\u4E40\u4E41\u4E42\u4E44\u4E46\u4E4A\u4E51\u4E55\u4E57\u4E5A\u4E5B\u4E62\u4E63\u4E64\u4E65\u4E67\u4E68\u4E6A\u4E6B\u4E6C\u4E6D\u4E6E\u4E6F\u4E72\u4E74\u4E75\u4E76\u4E77\u4E78\u4E79\u4E7A\u4E7B\u4E7C\u4E7D\u4E7F\u4E80\u4E81\u4E82\u4E83\u4E84\u4E85\u4E87\u4E8A\uFFFD\u4E90\u4E96\u4E97\u4E99\u4E9C\u4E9D\u4E9E\u4EA3\u4EAA\u4EAF\u4EB0\u4EB1\u4EB4\u4EB6\u4EB7\u4EB8\u4EB9\u4EBC\u4EBD\u4EBE\u4EC8\u4ECC\u4ECF\u4ED0\u4ED2\u4EDA\u4EDB\u4EDC\u4EE0\u4EE2\u4EE6\u4EE7\u4EE9\u4EED\u4EEE\u4EEF\u4EF1\u4EF4\u4EF8\u4EF9\u4EFA\u4EFC\u4EFE\u4F00\u4F02\u4F03\u4F04\u4F05\u4F06\u4F07\u4F08\u4F0B\u4F0C\u4F12\u4F13\u4F14\u4F15\u4F16\u4F1C\u4F1D\u4F21\u4F23\u4F28\u4F29\u4F2C\u4F2D\u4F2E\u4F31\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E\u4F3F\u4F40\u4F41\u4F42\u4F44\u4F45\u4F47\u4F48\u4F49\u4F4A\u4F4B\u4F4C\u4F52\u4F54\u4F56\u4F61\u4F62\u4F66\u4F68\u4F6A\u4F6B\u4F6D\u4F6E\u4F71\u4F72\u4F75\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F80\u4F81\u4F82\u4F85\u4F86\u4F87\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F95\u4F96\u4F98\u4F99\u4F9A\u4F9C\u4F9E\u4F9F\u4FA1\u4FA2\uFFFD".split("");
    for(j = 0; j != D[129].length; ++j)if (D[129][j].charCodeAt(0) !== 0xFFFD) {
        e[D[129][j]] = 33024 + j;
        d[33024 + j] = D[129][j];
    }
    D[130] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4FA4\u4FAB\u4FAD\u4FB0\u4FB1\u4FB2\u4FB3\u4FB4\u4FB6\u4FB7\u4FB8\u4FB9\u4FBA\u4FBB\u4FBC\u4FBD\u4FBE\u4FC0\u4FC1\u4FC2\u4FC6\u4FC7\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FD2\u4FD3\u4FD4\u4FD5\u4FD6\u4FD9\u4FDB\u4FE0\u4FE2\u4FE4\u4FE5\u4FE7\u4FEB\u4FEC\u4FF0\u4FF2\u4FF4\u4FF5\u4FF6\u4FF7\u4FF9\u4FFB\u4FFC\u4FFD\u4FFF\u5000\u5001\u5002\u5003\u5004\u5005\u5006\u5007\u5008\u5009\u500A\uFFFD\u500B\u500E\u5010\u5011\u5013\u5015\u5016\u5017\u501B\u501D\u501E\u5020\u5022\u5023\u5024\u5027\u502B\u502F\u5030\u5031\u5032\u5033\u5034\u5035\u5036\u5037\u5038\u5039\u503B\u503D\u503F\u5040\u5041\u5042\u5044\u5045\u5046\u5049\u504A\u504B\u504D\u5050\u5051\u5052\u5053\u5054\u5056\u5057\u5058\u5059\u505B\u505D\u505E\u505F\u5060\u5061\u5062\u5063\u5064\u5066\u5067\u5068\u5069\u506A\u506B\u506D\u506E\u506F\u5070\u5071\u5072\u5073\u5074\u5075\u5078\u5079\u507A\u507C\u507D\u5081\u5082\u5083\u5084\u5086\u5087\u5089\u508A\u508B\u508C\u508E\u508F\u5090\u5091\u5092\u5093\u5094\u5095\u5096\u5097\u5098\u5099\u509A\u509B\u509C\u509D\u509E\u509F\u50A0\u50A1\u50A2\u50A4\u50A6\u50AA\u50AB\u50AD\u50AE\u50AF\u50B0\u50B1\u50B3\u50B4\u50B5\u50B6\u50B7\u50B8\u50B9\u50BC\uFFFD".split("");
    for(j = 0; j != D[130].length; ++j)if (D[130][j].charCodeAt(0) !== 0xFFFD) {
        e[D[130][j]] = 33280 + j;
        d[33280 + j] = D[130][j];
    }
    D[131] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u50BD\u50BE\u50BF\u50C0\u50C1\u50C2\u50C3\u50C4\u50C5\u50C6\u50C7\u50C8\u50C9\u50CA\u50CB\u50CC\u50CD\u50CE\u50D0\u50D1\u50D2\u50D3\u50D4\u50D5\u50D7\u50D8\u50D9\u50DB\u50DC\u50DD\u50DE\u50DF\u50E0\u50E1\u50E2\u50E3\u50E4\u50E5\u50E8\u50E9\u50EA\u50EB\u50EF\u50F0\u50F1\u50F2\u50F4\u50F6\u50F7\u50F8\u50F9\u50FA\u50FC\u50FD\u50FE\u50FF\u5100\u5101\u5102\u5103\u5104\u5105\u5108\uFFFD\u5109\u510A\u510C\u510D\u510E\u510F\u5110\u5111\u5113\u5114\u5115\u5116\u5117\u5118\u5119\u511A\u511B\u511C\u511D\u511E\u511F\u5120\u5122\u5123\u5124\u5125\u5126\u5127\u5128\u5129\u512A\u512B\u512C\u512D\u512E\u512F\u5130\u5131\u5132\u5133\u5134\u5135\u5136\u5137\u5138\u5139\u513A\u513B\u513C\u513D\u513E\u5142\u5147\u514A\u514C\u514E\u514F\u5150\u5152\u5153\u5157\u5158\u5159\u515B\u515D\u515E\u515F\u5160\u5161\u5163\u5164\u5166\u5167\u5169\u516A\u516F\u5172\u517A\u517E\u517F\u5183\u5184\u5186\u5187\u518A\u518B\u518E\u518F\u5190\u5191\u5193\u5194\u5198\u519A\u519D\u519E\u519F\u51A1\u51A3\u51A6\u51A7\u51A8\u51A9\u51AA\u51AD\u51AE\u51B4\u51B8\u51B9\u51BA\u51BE\u51BF\u51C1\u51C2\u51C3\u51C5\u51C8\u51CA\u51CD\u51CE\u51D0\u51D2\u51D3\u51D4\u51D5\u51D6\u51D7\uFFFD".split("");
    for(j = 0; j != D[131].length; ++j)if (D[131][j].charCodeAt(0) !== 0xFFFD) {
        e[D[131][j]] = 33536 + j;
        d[33536 + j] = D[131][j];
    }
    D[132] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u51D8\u51D9\u51DA\u51DC\u51DE\u51DF\u51E2\u51E3\u51E5\u51E6\u51E7\u51E8\u51E9\u51EA\u51EC\u51EE\u51F1\u51F2\u51F4\u51F7\u51FE\u5204\u5205\u5209\u520B\u520C\u520F\u5210\u5213\u5214\u5215\u521C\u521E\u521F\u5221\u5222\u5223\u5225\u5226\u5227\u522A\u522C\u522F\u5231\u5232\u5234\u5235\u523C\u523E\u5244\u5245\u5246\u5247\u5248\u5249\u524B\u524E\u524F\u5252\u5253\u5255\u5257\u5258\uFFFD\u5259\u525A\u525B\u525D\u525F\u5260\u5262\u5263\u5264\u5266\u5268\u526B\u526C\u526D\u526E\u5270\u5271\u5273\u5274\u5275\u5276\u5277\u5278\u5279\u527A\u527B\u527C\u527E\u5280\u5283\u5284\u5285\u5286\u5287\u5289\u528A\u528B\u528C\u528D\u528E\u528F\u5291\u5292\u5294\u5295\u5296\u5297\u5298\u5299\u529A\u529C\u52A4\u52A5\u52A6\u52A7\u52AE\u52AF\u52B0\u52B4\u52B5\u52B6\u52B7\u52B8\u52B9\u52BA\u52BB\u52BC\u52BD\u52C0\u52C1\u52C2\u52C4\u52C5\u52C6\u52C8\u52CA\u52CC\u52CD\u52CE\u52CF\u52D1\u52D3\u52D4\u52D5\u52D7\u52D9\u52DA\u52DB\u52DC\u52DD\u52DE\u52E0\u52E1\u52E2\u52E3\u52E5\u52E6\u52E7\u52E8\u52E9\u52EA\u52EB\u52EC\u52ED\u52EE\u52EF\u52F1\u52F2\u52F3\u52F4\u52F5\u52F6\u52F7\u52F8\u52FB\u52FC\u52FD\u5301\u5302\u5303\u5304\u5307\u5309\u530A\u530B\u530C\u530E\uFFFD".split("");
    for(j = 0; j != D[132].length; ++j)if (D[132][j].charCodeAt(0) !== 0xFFFD) {
        e[D[132][j]] = 33792 + j;
        d[33792 + j] = D[132][j];
    }
    D[133] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5311\u5312\u5313\u5314\u5318\u531B\u531C\u531E\u531F\u5322\u5324\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u532F\u5330\u5331\u5332\u5333\u5334\u5335\u5336\u5337\u5338\u533C\u533D\u5340\u5342\u5344\u5346\u534B\u534C\u534D\u5350\u5354\u5358\u5359\u535B\u535D\u5365\u5368\u536A\u536C\u536D\u5372\u5376\u5379\u537B\u537C\u537D\u537E\u5380\u5381\u5383\u5387\u5388\u538A\u538E\u538F\uFFFD\u5390\u5391\u5392\u5393\u5394\u5396\u5397\u5399\u539B\u539C\u539E\u53A0\u53A1\u53A4\u53A7\u53AA\u53AB\u53AC\u53AD\u53AF\u53B0\u53B1\u53B2\u53B3\u53B4\u53B5\u53B7\u53B8\u53B9\u53BA\u53BC\u53BD\u53BE\u53C0\u53C3\u53C4\u53C5\u53C6\u53C7\u53CE\u53CF\u53D0\u53D2\u53D3\u53D5\u53DA\u53DC\u53DD\u53DE\u53E1\u53E2\u53E7\u53F4\u53FA\u53FE\u53FF\u5400\u5402\u5405\u5407\u540B\u5414\u5418\u5419\u541A\u541C\u5422\u5424\u5425\u542A\u5430\u5433\u5436\u5437\u543A\u543D\u543F\u5441\u5442\u5444\u5445\u5447\u5449\u544C\u544D\u544E\u544F\u5451\u545A\u545D\u545E\u545F\u5460\u5461\u5463\u5465\u5467\u5469\u546A\u546B\u546C\u546D\u546E\u546F\u5470\u5474\u5479\u547A\u547E\u547F\u5481\u5483\u5485\u5487\u5488\u5489\u548A\u548D\u5491\u5493\u5497\u5498\u549C\u549E\u549F\u54A0\u54A1\uFFFD".split("");
    for(j = 0; j != D[133].length; ++j)if (D[133][j].charCodeAt(0) !== 0xFFFD) {
        e[D[133][j]] = 34048 + j;
        d[34048 + j] = D[133][j];
    }
    D[134] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54A2\u54A5\u54AE\u54B0\u54B2\u54B5\u54B6\u54B7\u54B9\u54BA\u54BC\u54BE\u54C3\u54C5\u54CA\u54CB\u54D6\u54D8\u54DB\u54E0\u54E1\u54E2\u54E3\u54E4\u54EB\u54EC\u54EF\u54F0\u54F1\u54F4\u54F5\u54F6\u54F7\u54F8\u54F9\u54FB\u54FE\u5500\u5502\u5503\u5504\u5505\u5508\u550A\u550B\u550C\u550D\u550E\u5512\u5513\u5515\u5516\u5517\u5518\u5519\u551A\u551C\u551D\u551E\u551F\u5521\u5525\u5526\uFFFD\u5528\u5529\u552B\u552D\u5532\u5534\u5535\u5536\u5538\u5539\u553A\u553B\u553D\u5540\u5542\u5545\u5547\u5548\u554B\u554C\u554D\u554E\u554F\u5551\u5552\u5553\u5554\u5557\u5558\u5559\u555A\u555B\u555D\u555E\u555F\u5560\u5562\u5563\u5568\u5569\u556B\u556F\u5570\u5571\u5572\u5573\u5574\u5579\u557A\u557D\u557F\u5585\u5586\u558C\u558D\u558E\u5590\u5592\u5593\u5595\u5596\u5597\u559A\u559B\u559E\u55A0\u55A1\u55A2\u55A3\u55A4\u55A5\u55A6\u55A8\u55A9\u55AA\u55AB\u55AC\u55AD\u55AE\u55AF\u55B0\u55B2\u55B4\u55B6\u55B8\u55BA\u55BC\u55BF\u55C0\u55C1\u55C2\u55C3\u55C6\u55C7\u55C8\u55CA\u55CB\u55CE\u55CF\u55D0\u55D5\u55D7\u55D8\u55D9\u55DA\u55DB\u55DE\u55E0\u55E2\u55E7\u55E9\u55ED\u55EE\u55F0\u55F1\u55F4\u55F6\u55F8\u55F9\u55FA\u55FB\u55FC\u55FF\u5602\u5603\u5604\u5605\uFFFD".split("");
    for(j = 0; j != D[134].length; ++j)if (D[134][j].charCodeAt(0) !== 0xFFFD) {
        e[D[134][j]] = 34304 + j;
        d[34304 + j] = D[134][j];
    }
    D[135] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5606\u5607\u560A\u560B\u560D\u5610\u5611\u5612\u5613\u5614\u5615\u5616\u5617\u5619\u561A\u561C\u561D\u5620\u5621\u5622\u5625\u5626\u5628\u5629\u562A\u562B\u562E\u562F\u5630\u5633\u5635\u5637\u5638\u563A\u563C\u563D\u563E\u5640\u5641\u5642\u5643\u5644\u5645\u5646\u5647\u5648\u5649\u564A\u564B\u564F\u5650\u5651\u5652\u5653\u5655\u5656\u565A\u565B\u565D\u565E\u565F\u5660\u5661\uFFFD\u5663\u5665\u5666\u5667\u566D\u566E\u566F\u5670\u5672\u5673\u5674\u5675\u5677\u5678\u5679\u567A\u567D\u567E\u567F\u5680\u5681\u5682\u5683\u5684\u5687\u5688\u5689\u568A\u568B\u568C\u568D\u5690\u5691\u5692\u5694\u5695\u5696\u5697\u5698\u5699\u569A\u569B\u569C\u569D\u569E\u569F\u56A0\u56A1\u56A2\u56A4\u56A5\u56A6\u56A7\u56A8\u56A9\u56AA\u56AB\u56AC\u56AD\u56AE\u56B0\u56B1\u56B2\u56B3\u56B4\u56B5\u56B6\u56B8\u56B9\u56BA\u56BB\u56BD\u56BE\u56BF\u56C0\u56C1\u56C2\u56C3\u56C4\u56C5\u56C6\u56C7\u56C8\u56C9\u56CB\u56CC\u56CD\u56CE\u56CF\u56D0\u56D1\u56D2\u56D3\u56D5\u56D6\u56D8\u56D9\u56DC\u56E3\u56E5\u56E6\u56E7\u56E8\u56E9\u56EA\u56EC\u56EE\u56EF\u56F2\u56F3\u56F6\u56F7\u56F8\u56FB\u56FC\u5700\u5701\u5702\u5705\u5707\u570B\u570C\u570D\u570E\u570F\u5710\u5711\uFFFD".split("");
    for(j = 0; j != D[135].length; ++j)if (D[135][j].charCodeAt(0) !== 0xFFFD) {
        e[D[135][j]] = 34560 + j;
        d[34560 + j] = D[135][j];
    }
    D[136] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5712\u5713\u5714\u5715\u5716\u5717\u5718\u5719\u571A\u571B\u571D\u571E\u5720\u5721\u5722\u5724\u5725\u5726\u5727\u572B\u5731\u5732\u5734\u5735\u5736\u5737\u5738\u573C\u573D\u573F\u5741\u5743\u5744\u5745\u5746\u5748\u5749\u574B\u5752\u5753\u5754\u5755\u5756\u5758\u5759\u5762\u5763\u5765\u5767\u576C\u576E\u5770\u5771\u5772\u5774\u5775\u5778\u5779\u577A\u577D\u577E\u577F\u5780\uFFFD\u5781\u5787\u5788\u5789\u578A\u578D\u578E\u578F\u5790\u5791\u5794\u5795\u5796\u5797\u5798\u5799\u579A\u579C\u579D\u579E\u579F\u57A5\u57A8\u57AA\u57AC\u57AF\u57B0\u57B1\u57B3\u57B5\u57B6\u57B7\u57B9\u57BA\u57BB\u57BC\u57BD\u57BE\u57BF\u57C0\u57C1\u57C4\u57C5\u57C6\u57C7\u57C8\u57C9\u57CA\u57CC\u57CD\u57D0\u57D1\u57D3\u57D6\u57D7\u57DB\u57DC\u57DE\u57E1\u57E2\u57E3\u57E5\u57E6\u57E7\u57E8\u57E9\u57EA\u57EB\u57EC\u57EE\u57F0\u57F1\u57F2\u57F3\u57F5\u57F6\u57F7\u57FB\u57FC\u57FE\u57FF\u5801\u5803\u5804\u5805\u5808\u5809\u580A\u580C\u580E\u580F\u5810\u5812\u5813\u5814\u5816\u5817\u5818\u581A\u581B\u581C\u581D\u581F\u5822\u5823\u5825\u5826\u5827\u5828\u5829\u582B\u582C\u582D\u582E\u582F\u5831\u5832\u5833\u5834\u5836\u5837\u5838\u5839\u583A\u583B\u583C\u583D\uFFFD".split("");
    for(j = 0; j != D[136].length; ++j)if (D[136][j].charCodeAt(0) !== 0xFFFD) {
        e[D[136][j]] = 34816 + j;
        d[34816 + j] = D[136][j];
    }
    D[137] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u583E\u583F\u5840\u5841\u5842\u5843\u5845\u5846\u5847\u5848\u5849\u584A\u584B\u584E\u584F\u5850\u5852\u5853\u5855\u5856\u5857\u5859\u585A\u585B\u585C\u585D\u585F\u5860\u5861\u5862\u5863\u5864\u5866\u5867\u5868\u5869\u586A\u586D\u586E\u586F\u5870\u5871\u5872\u5873\u5874\u5875\u5876\u5877\u5878\u5879\u587A\u587B\u587C\u587D\u587F\u5882\u5884\u5886\u5887\u5888\u588A\u588B\u588C\uFFFD\u588D\u588E\u588F\u5890\u5891\u5894\u5895\u5896\u5897\u5898\u589B\u589C\u589D\u58A0\u58A1\u58A2\u58A3\u58A4\u58A5\u58A6\u58A7\u58AA\u58AB\u58AC\u58AD\u58AE\u58AF\u58B0\u58B1\u58B2\u58B3\u58B4\u58B5\u58B6\u58B7\u58B8\u58B9\u58BA\u58BB\u58BD\u58BE\u58BF\u58C0\u58C2\u58C3\u58C4\u58C6\u58C7\u58C8\u58C9\u58CA\u58CB\u58CC\u58CD\u58CE\u58CF\u58D0\u58D2\u58D3\u58D4\u58D6\u58D7\u58D8\u58D9\u58DA\u58DB\u58DC\u58DD\u58DE\u58DF\u58E0\u58E1\u58E2\u58E3\u58E5\u58E6\u58E7\u58E8\u58E9\u58EA\u58ED\u58EF\u58F1\u58F2\u58F4\u58F5\u58F7\u58F8\u58FA\u58FB\u58FC\u58FD\u58FE\u58FF\u5900\u5901\u5903\u5905\u5906\u5908\u5909\u590A\u590B\u590C\u590E\u5910\u5911\u5912\u5913\u5917\u5918\u591B\u591D\u591E\u5920\u5921\u5922\u5923\u5926\u5928\u592C\u5930\u5932\u5933\u5935\u5936\u593B\uFFFD".split("");
    for(j = 0; j != D[137].length; ++j)if (D[137][j].charCodeAt(0) !== 0xFFFD) {
        e[D[137][j]] = 35072 + j;
        d[35072 + j] = D[137][j];
    }
    D[138] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u593D\u593E\u593F\u5940\u5943\u5945\u5946\u594A\u594C\u594D\u5950\u5952\u5953\u5959\u595B\u595C\u595D\u595E\u595F\u5961\u5963\u5964\u5966\u5967\u5968\u5969\u596A\u596B\u596C\u596D\u596E\u596F\u5970\u5971\u5972\u5975\u5977\u597A\u597B\u597C\u597E\u597F\u5980\u5985\u5989\u598B\u598C\u598E\u598F\u5990\u5991\u5994\u5995\u5998\u599A\u599B\u599C\u599D\u599F\u59A0\u59A1\u59A2\u59A6\uFFFD\u59A7\u59AC\u59AD\u59B0\u59B1\u59B3\u59B4\u59B5\u59B6\u59B7\u59B8\u59BA\u59BC\u59BD\u59BF\u59C0\u59C1\u59C2\u59C3\u59C4\u59C5\u59C7\u59C8\u59C9\u59CC\u59CD\u59CE\u59CF\u59D5\u59D6\u59D9\u59DB\u59DE\u59DF\u59E0\u59E1\u59E2\u59E4\u59E6\u59E7\u59E9\u59EA\u59EB\u59ED\u59EE\u59EF\u59F0\u59F1\u59F2\u59F3\u59F4\u59F5\u59F6\u59F7\u59F8\u59FA\u59FC\u59FD\u59FE\u5A00\u5A02\u5A0A\u5A0B\u5A0D\u5A0E\u5A0F\u5A10\u5A12\u5A14\u5A15\u5A16\u5A17\u5A19\u5A1A\u5A1B\u5A1D\u5A1E\u5A21\u5A22\u5A24\u5A26\u5A27\u5A28\u5A2A\u5A2B\u5A2C\u5A2D\u5A2E\u5A2F\u5A30\u5A33\u5A35\u5A37\u5A38\u5A39\u5A3A\u5A3B\u5A3D\u5A3E\u5A3F\u5A41\u5A42\u5A43\u5A44\u5A45\u5A47\u5A48\u5A4B\u5A4C\u5A4D\u5A4E\u5A4F\u5A50\u5A51\u5A52\u5A53\u5A54\u5A56\u5A57\u5A58\u5A59\u5A5B\u5A5C\u5A5D\u5A5E\u5A5F\u5A60\uFFFD".split("");
    for(j = 0; j != D[138].length; ++j)if (D[138][j].charCodeAt(0) !== 0xFFFD) {
        e[D[138][j]] = 35328 + j;
        d[35328 + j] = D[138][j];
    }
    D[139] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5A61\u5A63\u5A64\u5A65\u5A66\u5A68\u5A69\u5A6B\u5A6C\u5A6D\u5A6E\u5A6F\u5A70\u5A71\u5A72\u5A73\u5A78\u5A79\u5A7B\u5A7C\u5A7D\u5A7E\u5A80\u5A81\u5A82\u5A83\u5A84\u5A85\u5A86\u5A87\u5A88\u5A89\u5A8A\u5A8B\u5A8C\u5A8D\u5A8E\u5A8F\u5A90\u5A91\u5A93\u5A94\u5A95\u5A96\u5A97\u5A98\u5A99\u5A9C\u5A9D\u5A9E\u5A9F\u5AA0\u5AA1\u5AA2\u5AA3\u5AA4\u5AA5\u5AA6\u5AA7\u5AA8\u5AA9\u5AAB\u5AAC\uFFFD\u5AAD\u5AAE\u5AAF\u5AB0\u5AB1\u5AB4\u5AB6\u5AB7\u5AB9\u5ABA\u5ABB\u5ABC\u5ABD\u5ABF\u5AC0\u5AC3\u5AC4\u5AC5\u5AC6\u5AC7\u5AC8\u5ACA\u5ACB\u5ACD\u5ACE\u5ACF\u5AD0\u5AD1\u5AD3\u5AD5\u5AD7\u5AD9\u5ADA\u5ADB\u5ADD\u5ADE\u5ADF\u5AE2\u5AE4\u5AE5\u5AE7\u5AE8\u5AEA\u5AEC\u5AED\u5AEE\u5AEF\u5AF0\u5AF2\u5AF3\u5AF4\u5AF5\u5AF6\u5AF7\u5AF8\u5AF9\u5AFA\u5AFB\u5AFC\u5AFD\u5AFE\u5AFF\u5B00\u5B01\u5B02\u5B03\u5B04\u5B05\u5B06\u5B07\u5B08\u5B0A\u5B0B\u5B0C\u5B0D\u5B0E\u5B0F\u5B10\u5B11\u5B12\u5B13\u5B14\u5B15\u5B18\u5B19\u5B1A\u5B1B\u5B1C\u5B1D\u5B1E\u5B1F\u5B20\u5B21\u5B22\u5B23\u5B24\u5B25\u5B26\u5B27\u5B28\u5B29\u5B2A\u5B2B\u5B2C\u5B2D\u5B2E\u5B2F\u5B30\u5B31\u5B33\u5B35\u5B36\u5B38\u5B39\u5B3A\u5B3B\u5B3C\u5B3D\u5B3E\u5B3F\u5B41\u5B42\u5B43\u5B44\u5B45\u5B46\u5B47\uFFFD".split("");
    for(j = 0; j != D[139].length; ++j)if (D[139][j].charCodeAt(0) !== 0xFFFD) {
        e[D[139][j]] = 35584 + j;
        d[35584 + j] = D[139][j];
    }
    D[140] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5B48\u5B49\u5B4A\u5B4B\u5B4C\u5B4D\u5B4E\u5B4F\u5B52\u5B56\u5B5E\u5B60\u5B61\u5B67\u5B68\u5B6B\u5B6D\u5B6E\u5B6F\u5B72\u5B74\u5B76\u5B77\u5B78\u5B79\u5B7B\u5B7C\u5B7E\u5B7F\u5B82\u5B86\u5B8A\u5B8D\u5B8E\u5B90\u5B91\u5B92\u5B94\u5B96\u5B9F\u5BA7\u5BA8\u5BA9\u5BAC\u5BAD\u5BAE\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBB\u5BBC\u5BC0\u5BC1\u5BC3\u5BC8\u5BC9\u5BCA\u5BCB\u5BCD\u5BCE\u5BCF\uFFFD\u5BD1\u5BD4\u5BD5\u5BD6\u5BD7\u5BD8\u5BD9\u5BDA\u5BDB\u5BDC\u5BE0\u5BE2\u5BE3\u5BE6\u5BE7\u5BE9\u5BEA\u5BEB\u5BEC\u5BED\u5BEF\u5BF1\u5BF2\u5BF3\u5BF4\u5BF5\u5BF6\u5BF7\u5BFD\u5BFE\u5C00\u5C02\u5C03\u5C05\u5C07\u5C08\u5C0B\u5C0C\u5C0D\u5C0E\u5C10\u5C12\u5C13\u5C17\u5C19\u5C1B\u5C1E\u5C1F\u5C20\u5C21\u5C23\u5C26\u5C28\u5C29\u5C2A\u5C2B\u5C2D\u5C2E\u5C2F\u5C30\u5C32\u5C33\u5C35\u5C36\u5C37\u5C43\u5C44\u5C46\u5C47\u5C4C\u5C4D\u5C52\u5C53\u5C54\u5C56\u5C57\u5C58\u5C5A\u5C5B\u5C5C\u5C5D\u5C5F\u5C62\u5C64\u5C67\u5C68\u5C69\u5C6A\u5C6B\u5C6C\u5C6D\u5C70\u5C72\u5C73\u5C74\u5C75\u5C76\u5C77\u5C78\u5C7B\u5C7C\u5C7D\u5C7E\u5C80\u5C83\u5C84\u5C85\u5C86\u5C87\u5C89\u5C8A\u5C8B\u5C8E\u5C8F\u5C92\u5C93\u5C95\u5C9D\u5C9E\u5C9F\u5CA0\u5CA1\u5CA4\u5CA5\u5CA6\u5CA7\u5CA8\uFFFD".split("");
    for(j = 0; j != D[140].length; ++j)if (D[140][j].charCodeAt(0) !== 0xFFFD) {
        e[D[140][j]] = 35840 + j;
        d[35840 + j] = D[140][j];
    }
    D[141] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5CAA\u5CAE\u5CAF\u5CB0\u5CB2\u5CB4\u5CB6\u5CB9\u5CBA\u5CBB\u5CBC\u5CBE\u5CC0\u5CC2\u5CC3\u5CC5\u5CC6\u5CC7\u5CC8\u5CC9\u5CCA\u5CCC\u5CCD\u5CCE\u5CCF\u5CD0\u5CD1\u5CD3\u5CD4\u5CD5\u5CD6\u5CD7\u5CD8\u5CDA\u5CDB\u5CDC\u5CDD\u5CDE\u5CDF\u5CE0\u5CE2\u5CE3\u5CE7\u5CE9\u5CEB\u5CEC\u5CEE\u5CEF\u5CF1\u5CF2\u5CF3\u5CF4\u5CF5\u5CF6\u5CF7\u5CF8\u5CF9\u5CFA\u5CFC\u5CFD\u5CFE\u5CFF\u5D00\uFFFD\u5D01\u5D04\u5D05\u5D08\u5D09\u5D0A\u5D0B\u5D0C\u5D0D\u5D0F\u5D10\u5D11\u5D12\u5D13\u5D15\u5D17\u5D18\u5D19\u5D1A\u5D1C\u5D1D\u5D1F\u5D20\u5D21\u5D22\u5D23\u5D25\u5D28\u5D2A\u5D2B\u5D2C\u5D2F\u5D30\u5D31\u5D32\u5D33\u5D35\u5D36\u5D37\u5D38\u5D39\u5D3A\u5D3B\u5D3C\u5D3F\u5D40\u5D41\u5D42\u5D43\u5D44\u5D45\u5D46\u5D48\u5D49\u5D4D\u5D4E\u5D4F\u5D50\u5D51\u5D52\u5D53\u5D54\u5D55\u5D56\u5D57\u5D59\u5D5A\u5D5C\u5D5E\u5D5F\u5D60\u5D61\u5D62\u5D63\u5D64\u5D65\u5D66\u5D67\u5D68\u5D6A\u5D6D\u5D6E\u5D70\u5D71\u5D72\u5D73\u5D75\u5D76\u5D77\u5D78\u5D79\u5D7A\u5D7B\u5D7C\u5D7D\u5D7E\u5D7F\u5D80\u5D81\u5D83\u5D84\u5D85\u5D86\u5D87\u5D88\u5D89\u5D8A\u5D8B\u5D8C\u5D8D\u5D8E\u5D8F\u5D90\u5D91\u5D92\u5D93\u5D94\u5D95\u5D96\u5D97\u5D98\u5D9A\u5D9B\u5D9C\u5D9E\u5D9F\u5DA0\uFFFD".split("");
    for(j = 0; j != D[141].length; ++j)if (D[141][j].charCodeAt(0) !== 0xFFFD) {
        e[D[141][j]] = 36096 + j;
        d[36096 + j] = D[141][j];
    }
    D[142] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5DA1\u5DA2\u5DA3\u5DA4\u5DA5\u5DA6\u5DA7\u5DA8\u5DA9\u5DAA\u5DAB\u5DAC\u5DAD\u5DAE\u5DAF\u5DB0\u5DB1\u5DB2\u5DB3\u5DB4\u5DB5\u5DB6\u5DB8\u5DB9\u5DBA\u5DBB\u5DBC\u5DBD\u5DBE\u5DBF\u5DC0\u5DC1\u5DC2\u5DC3\u5DC4\u5DC6\u5DC7\u5DC8\u5DC9\u5DCA\u5DCB\u5DCC\u5DCE\u5DCF\u5DD0\u5DD1\u5DD2\u5DD3\u5DD4\u5DD5\u5DD6\u5DD7\u5DD8\u5DD9\u5DDA\u5DDC\u5DDF\u5DE0\u5DE3\u5DE4\u5DEA\u5DEC\u5DED\uFFFD\u5DF0\u5DF5\u5DF6\u5DF8\u5DF9\u5DFA\u5DFB\u5DFC\u5DFF\u5E00\u5E04\u5E07\u5E09\u5E0A\u5E0B\u5E0D\u5E0E\u5E12\u5E13\u5E17\u5E1E\u5E1F\u5E20\u5E21\u5E22\u5E23\u5E24\u5E25\u5E28\u5E29\u5E2A\u5E2B\u5E2C\u5E2F\u5E30\u5E32\u5E33\u5E34\u5E35\u5E36\u5E39\u5E3A\u5E3E\u5E3F\u5E40\u5E41\u5E43\u5E46\u5E47\u5E48\u5E49\u5E4A\u5E4B\u5E4D\u5E4E\u5E4F\u5E50\u5E51\u5E52\u5E53\u5E56\u5E57\u5E58\u5E59\u5E5A\u5E5C\u5E5D\u5E5F\u5E60\u5E63\u5E64\u5E65\u5E66\u5E67\u5E68\u5E69\u5E6A\u5E6B\u5E6C\u5E6D\u5E6E\u5E6F\u5E70\u5E71\u5E75\u5E77\u5E79\u5E7E\u5E81\u5E82\u5E83\u5E85\u5E88\u5E89\u5E8C\u5E8D\u5E8E\u5E92\u5E98\u5E9B\u5E9D\u5EA1\u5EA2\u5EA3\u5EA4\u5EA8\u5EA9\u5EAA\u5EAB\u5EAC\u5EAE\u5EAF\u5EB0\u5EB1\u5EB2\u5EB4\u5EBA\u5EBB\u5EBC\u5EBD\u5EBF\u5EC0\u5EC1\u5EC2\u5EC3\u5EC4\u5EC5\uFFFD".split("");
    for(j = 0; j != D[142].length; ++j)if (D[142][j].charCodeAt(0) !== 0xFFFD) {
        e[D[142][j]] = 36352 + j;
        d[36352 + j] = D[142][j];
    }
    D[143] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5EC6\u5EC7\u5EC8\u5ECB\u5ECC\u5ECD\u5ECE\u5ECF\u5ED0\u5ED4\u5ED5\u5ED7\u5ED8\u5ED9\u5EDA\u5EDC\u5EDD\u5EDE\u5EDF\u5EE0\u5EE1\u5EE2\u5EE3\u5EE4\u5EE5\u5EE6\u5EE7\u5EE9\u5EEB\u5EEC\u5EED\u5EEE\u5EEF\u5EF0\u5EF1\u5EF2\u5EF3\u5EF5\u5EF8\u5EF9\u5EFB\u5EFC\u5EFD\u5F05\u5F06\u5F07\u5F09\u5F0C\u5F0D\u5F0E\u5F10\u5F12\u5F14\u5F16\u5F19\u5F1A\u5F1C\u5F1D\u5F1E\u5F21\u5F22\u5F23\u5F24\uFFFD\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F32\u5F33\u5F34\u5F35\u5F36\u5F37\u5F38\u5F3B\u5F3D\u5F3E\u5F3F\u5F41\u5F42\u5F43\u5F44\u5F45\u5F46\u5F47\u5F48\u5F49\u5F4A\u5F4B\u5F4C\u5F4D\u5F4E\u5F4F\u5F51\u5F54\u5F59\u5F5A\u5F5B\u5F5C\u5F5E\u5F5F\u5F60\u5F63\u5F65\u5F67\u5F68\u5F6B\u5F6E\u5F6F\u5F72\u5F74\u5F75\u5F76\u5F78\u5F7A\u5F7D\u5F7E\u5F7F\u5F83\u5F86\u5F8D\u5F8E\u5F8F\u5F91\u5F93\u5F94\u5F96\u5F9A\u5F9B\u5F9D\u5F9E\u5F9F\u5FA0\u5FA2\u5FA3\u5FA4\u5FA5\u5FA6\u5FA7\u5FA9\u5FAB\u5FAC\u5FAF\u5FB0\u5FB1\u5FB2\u5FB3\u5FB4\u5FB6\u5FB8\u5FB9\u5FBA\u5FBB\u5FBE\u5FBF\u5FC0\u5FC1\u5FC2\u5FC7\u5FC8\u5FCA\u5FCB\u5FCE\u5FD3\u5FD4\u5FD5\u5FDA\u5FDB\u5FDC\u5FDE\u5FDF\u5FE2\u5FE3\u5FE5\u5FE6\u5FE8\u5FE9\u5FEC\u5FEF\u5FF0\u5FF2\u5FF3\u5FF4\u5FF6\u5FF7\u5FF9\u5FFA\u5FFC\u6007\uFFFD".split("");
    for(j = 0; j != D[143].length; ++j)if (D[143][j].charCodeAt(0) !== 0xFFFD) {
        e[D[143][j]] = 36608 + j;
        d[36608 + j] = D[143][j];
    }
    D[144] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6008\u6009\u600B\u600C\u6010\u6011\u6013\u6017\u6018\u601A\u601E\u601F\u6022\u6023\u6024\u602C\u602D\u602E\u6030\u6031\u6032\u6033\u6034\u6036\u6037\u6038\u6039\u603A\u603D\u603E\u6040\u6044\u6045\u6046\u6047\u6048\u6049\u604A\u604C\u604E\u604F\u6051\u6053\u6054\u6056\u6057\u6058\u605B\u605C\u605E\u605F\u6060\u6061\u6065\u6066\u606E\u6071\u6072\u6074\u6075\u6077\u607E\u6080\uFFFD\u6081\u6082\u6085\u6086\u6087\u6088\u608A\u608B\u608E\u608F\u6090\u6091\u6093\u6095\u6097\u6098\u6099\u609C\u609E\u60A1\u60A2\u60A4\u60A5\u60A7\u60A9\u60AA\u60AE\u60B0\u60B3\u60B5\u60B6\u60B7\u60B9\u60BA\u60BD\u60BE\u60BF\u60C0\u60C1\u60C2\u60C3\u60C4\u60C7\u60C8\u60C9\u60CC\u60CD\u60CE\u60CF\u60D0\u60D2\u60D3\u60D4\u60D6\u60D7\u60D9\u60DB\u60DE\u60E1\u60E2\u60E3\u60E4\u60E5\u60EA\u60F1\u60F2\u60F5\u60F7\u60F8\u60FB\u60FC\u60FD\u60FE\u60FF\u6102\u6103\u6104\u6105\u6107\u610A\u610B\u610C\u6110\u6111\u6112\u6113\u6114\u6116\u6117\u6118\u6119\u611B\u611C\u611D\u611E\u6121\u6122\u6125\u6128\u6129\u612A\u612C\u612D\u612E\u612F\u6130\u6131\u6132\u6133\u6134\u6135\u6136\u6137\u6138\u6139\u613A\u613B\u613C\u613D\u613E\u6140\u6141\u6142\u6143\u6144\u6145\u6146\uFFFD".split("");
    for(j = 0; j != D[144].length; ++j)if (D[144][j].charCodeAt(0) !== 0xFFFD) {
        e[D[144][j]] = 36864 + j;
        d[36864 + j] = D[144][j];
    }
    D[145] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6147\u6149\u614B\u614D\u614F\u6150\u6152\u6153\u6154\u6156\u6157\u6158\u6159\u615A\u615B\u615C\u615E\u615F\u6160\u6161\u6163\u6164\u6165\u6166\u6169\u616A\u616B\u616C\u616D\u616E\u616F\u6171\u6172\u6173\u6174\u6176\u6178\u6179\u617A\u617B\u617C\u617D\u617E\u617F\u6180\u6181\u6182\u6183\u6184\u6185\u6186\u6187\u6188\u6189\u618A\u618C\u618D\u618F\u6190\u6191\u6192\u6193\u6195\uFFFD\u6196\u6197\u6198\u6199\u619A\u619B\u619C\u619E\u619F\u61A0\u61A1\u61A2\u61A3\u61A4\u61A5\u61A6\u61AA\u61AB\u61AD\u61AE\u61AF\u61B0\u61B1\u61B2\u61B3\u61B4\u61B5\u61B6\u61B8\u61B9\u61BA\u61BB\u61BC\u61BD\u61BF\u61C0\u61C1\u61C3\u61C4\u61C5\u61C6\u61C7\u61C9\u61CC\u61CD\u61CE\u61CF\u61D0\u61D3\u61D5\u61D6\u61D7\u61D8\u61D9\u61DA\u61DB\u61DC\u61DD\u61DE\u61DF\u61E0\u61E1\u61E2\u61E3\u61E4\u61E5\u61E7\u61E8\u61E9\u61EA\u61EB\u61EC\u61ED\u61EE\u61EF\u61F0\u61F1\u61F2\u61F3\u61F4\u61F6\u61F7\u61F8\u61F9\u61FA\u61FB\u61FC\u61FD\u61FE\u6200\u6201\u6202\u6203\u6204\u6205\u6207\u6209\u6213\u6214\u6219\u621C\u621D\u621E\u6220\u6223\u6226\u6227\u6228\u6229\u622B\u622D\u622F\u6230\u6231\u6232\u6235\u6236\u6238\u6239\u623A\u623B\u623C\u6242\u6244\u6245\u6246\u624A\uFFFD".split("");
    for(j = 0; j != D[145].length; ++j)if (D[145][j].charCodeAt(0) !== 0xFFFD) {
        e[D[145][j]] = 37120 + j;
        d[37120 + j] = D[145][j];
    }
    D[146] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u624F\u6250\u6255\u6256\u6257\u6259\u625A\u625C\u625D\u625E\u625F\u6260\u6261\u6262\u6264\u6265\u6268\u6271\u6272\u6274\u6275\u6277\u6278\u627A\u627B\u627D\u6281\u6282\u6283\u6285\u6286\u6287\u6288\u628B\u628C\u628D\u628E\u628F\u6290\u6294\u6299\u629C\u629D\u629E\u62A3\u62A6\u62A7\u62A9\u62AA\u62AD\u62AE\u62AF\u62B0\u62B2\u62B3\u62B4\u62B6\u62B7\u62B8\u62BA\u62BE\u62C0\u62C1\uFFFD\u62C3\u62CB\u62CF\u62D1\u62D5\u62DD\u62DE\u62E0\u62E1\u62E4\u62EA\u62EB\u62F0\u62F2\u62F5\u62F8\u62F9\u62FA\u62FB\u6300\u6303\u6304\u6305\u6306\u630A\u630B\u630C\u630D\u630F\u6310\u6312\u6313\u6314\u6315\u6317\u6318\u6319\u631C\u6326\u6327\u6329\u632C\u632D\u632E\u6330\u6331\u6333\u6334\u6335\u6336\u6337\u6338\u633B\u633C\u633E\u633F\u6340\u6341\u6344\u6347\u6348\u634A\u6351\u6352\u6353\u6354\u6356\u6357\u6358\u6359\u635A\u635B\u635C\u635D\u6360\u6364\u6365\u6366\u6368\u636A\u636B\u636C\u636F\u6370\u6372\u6373\u6374\u6375\u6378\u6379\u637C\u637D\u637E\u637F\u6381\u6383\u6384\u6385\u6386\u638B\u638D\u6391\u6393\u6394\u6395\u6397\u6399\u639A\u639B\u639C\u639D\u639E\u639F\u63A1\u63A4\u63A6\u63AB\u63AF\u63B1\u63B2\u63B5\u63B6\u63B9\u63BB\u63BD\u63BF\u63C0\uFFFD".split("");
    for(j = 0; j != D[146].length; ++j)if (D[146][j].charCodeAt(0) !== 0xFFFD) {
        e[D[146][j]] = 37376 + j;
        d[37376 + j] = D[146][j];
    }
    D[147] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u63C1\u63C2\u63C3\u63C5\u63C7\u63C8\u63CA\u63CB\u63CC\u63D1\u63D3\u63D4\u63D5\u63D7\u63D8\u63D9\u63DA\u63DB\u63DC\u63DD\u63DF\u63E2\u63E4\u63E5\u63E6\u63E7\u63E8\u63EB\u63EC\u63EE\u63EF\u63F0\u63F1\u63F3\u63F5\u63F7\u63F9\u63FA\u63FB\u63FC\u63FE\u6403\u6404\u6406\u6407\u6408\u6409\u640A\u640D\u640E\u6411\u6412\u6415\u6416\u6417\u6418\u6419\u641A\u641D\u641F\u6422\u6423\u6424\uFFFD\u6425\u6427\u6428\u6429\u642B\u642E\u642F\u6430\u6431\u6432\u6433\u6435\u6436\u6437\u6438\u6439\u643B\u643C\u643E\u6440\u6442\u6443\u6449\u644B\u644C\u644D\u644E\u644F\u6450\u6451\u6453\u6455\u6456\u6457\u6459\u645A\u645B\u645C\u645D\u645F\u6460\u6461\u6462\u6463\u6464\u6465\u6466\u6468\u646A\u646B\u646C\u646E\u646F\u6470\u6471\u6472\u6473\u6474\u6475\u6476\u6477\u647B\u647C\u647D\u647E\u647F\u6480\u6481\u6483\u6486\u6488\u6489\u648A\u648B\u648C\u648D\u648E\u648F\u6490\u6493\u6494\u6497\u6498\u649A\u649B\u649C\u649D\u649F\u64A0\u64A1\u64A2\u64A3\u64A5\u64A6\u64A7\u64A8\u64AA\u64AB\u64AF\u64B1\u64B2\u64B3\u64B4\u64B6\u64B9\u64BB\u64BD\u64BE\u64BF\u64C1\u64C3\u64C4\u64C6\u64C7\u64C8\u64C9\u64CA\u64CB\u64CC\u64CF\u64D1\u64D3\u64D4\u64D5\u64D6\u64D9\u64DA\uFFFD".split("");
    for(j = 0; j != D[147].length; ++j)if (D[147][j].charCodeAt(0) !== 0xFFFD) {
        e[D[147][j]] = 37632 + j;
        d[37632 + j] = D[147][j];
    }
    D[148] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u64DB\u64DC\u64DD\u64DF\u64E0\u64E1\u64E3\u64E5\u64E7\u64E8\u64E9\u64EA\u64EB\u64EC\u64ED\u64EE\u64EF\u64F0\u64F1\u64F2\u64F3\u64F4\u64F5\u64F6\u64F7\u64F8\u64F9\u64FA\u64FB\u64FC\u64FD\u64FE\u64FF\u6501\u6502\u6503\u6504\u6505\u6506\u6507\u6508\u650A\u650B\u650C\u650D\u650E\u650F\u6510\u6511\u6513\u6514\u6515\u6516\u6517\u6519\u651A\u651B\u651C\u651D\u651E\u651F\u6520\u6521\uFFFD\u6522\u6523\u6524\u6526\u6527\u6528\u6529\u652A\u652C\u652D\u6530\u6531\u6532\u6533\u6537\u653A\u653C\u653D\u6540\u6541\u6542\u6543\u6544\u6546\u6547\u654A\u654B\u654D\u654E\u6550\u6552\u6553\u6554\u6557\u6558\u655A\u655C\u655F\u6560\u6561\u6564\u6565\u6567\u6568\u6569\u656A\u656D\u656E\u656F\u6571\u6573\u6575\u6576\u6578\u6579\u657A\u657B\u657C\u657D\u657E\u657F\u6580\u6581\u6582\u6583\u6584\u6585\u6586\u6588\u6589\u658A\u658D\u658E\u658F\u6592\u6594\u6595\u6596\u6598\u659A\u659D\u659E\u65A0\u65A2\u65A3\u65A6\u65A8\u65AA\u65AC\u65AE\u65B1\u65B2\u65B3\u65B4\u65B5\u65B6\u65B7\u65B8\u65BA\u65BB\u65BE\u65BF\u65C0\u65C2\u65C7\u65C8\u65C9\u65CA\u65CD\u65D0\u65D1\u65D3\u65D4\u65D5\u65D8\u65D9\u65DA\u65DB\u65DC\u65DD\u65DE\u65DF\u65E1\u65E3\u65E4\u65EA\u65EB\uFFFD".split("");
    for(j = 0; j != D[148].length; ++j)if (D[148][j].charCodeAt(0) !== 0xFFFD) {
        e[D[148][j]] = 37888 + j;
        d[37888 + j] = D[148][j];
    }
    D[149] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u65F2\u65F3\u65F4\u65F5\u65F8\u65F9\u65FB\u65FC\u65FD\u65FE\u65FF\u6601\u6604\u6605\u6607\u6608\u6609\u660B\u660D\u6610\u6611\u6612\u6616\u6617\u6618\u661A\u661B\u661C\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6632\u6633\u6637\u6638\u6639\u663A\u663B\u663D\u663F\u6640\u6642\u6644\u6645\u6646\u6647\u6648\u6649\u664A\u664D\u664E\u6650\u6651\u6658\uFFFD\u6659\u665B\u665C\u665D\u665E\u6660\u6662\u6663\u6665\u6667\u6669\u666A\u666B\u666C\u666D\u6671\u6672\u6673\u6675\u6678\u6679\u667B\u667C\u667D\u667F\u6680\u6681\u6683\u6685\u6686\u6688\u6689\u668A\u668B\u668D\u668E\u668F\u6690\u6692\u6693\u6694\u6695\u6698\u6699\u669A\u669B\u669C\u669E\u669F\u66A0\u66A1\u66A2\u66A3\u66A4\u66A5\u66A6\u66A9\u66AA\u66AB\u66AC\u66AD\u66AF\u66B0\u66B1\u66B2\u66B3\u66B5\u66B6\u66B7\u66B8\u66BA\u66BB\u66BC\u66BD\u66BF\u66C0\u66C1\u66C2\u66C3\u66C4\u66C5\u66C6\u66C7\u66C8\u66C9\u66CA\u66CB\u66CC\u66CD\u66CE\u66CF\u66D0\u66D1\u66D2\u66D3\u66D4\u66D5\u66D6\u66D7\u66D8\u66DA\u66DE\u66DF\u66E0\u66E1\u66E2\u66E3\u66E4\u66E5\u66E7\u66E8\u66EA\u66EB\u66EC\u66ED\u66EE\u66EF\u66F1\u66F5\u66F6\u66F8\u66FA\u66FB\u66FD\u6701\u6702\u6703\uFFFD".split("");
    for(j = 0; j != D[149].length; ++j)if (D[149][j].charCodeAt(0) !== 0xFFFD) {
        e[D[149][j]] = 38144 + j;
        d[38144 + j] = D[149][j];
    }
    D[150] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6704\u6705\u6706\u6707\u670C\u670E\u670F\u6711\u6712\u6713\u6716\u6718\u6719\u671A\u671C\u671E\u6720\u6721\u6722\u6723\u6724\u6725\u6727\u6729\u672E\u6730\u6732\u6733\u6736\u6737\u6738\u6739\u673B\u673C\u673E\u673F\u6741\u6744\u6745\u6747\u674A\u674B\u674D\u6752\u6754\u6755\u6757\u6758\u6759\u675A\u675B\u675D\u6762\u6763\u6764\u6766\u6767\u676B\u676C\u676E\u6771\u6774\u6776\uFFFD\u6778\u6779\u677A\u677B\u677D\u6780\u6782\u6783\u6785\u6786\u6788\u678A\u678C\u678D\u678E\u678F\u6791\u6792\u6793\u6794\u6796\u6799\u679B\u679F\u67A0\u67A1\u67A4\u67A6\u67A9\u67AC\u67AE\u67B1\u67B2\u67B4\u67B9\u67BA\u67BB\u67BC\u67BD\u67BE\u67BF\u67C0\u67C2\u67C5\u67C6\u67C7\u67C8\u67C9\u67CA\u67CB\u67CC\u67CD\u67CE\u67D5\u67D6\u67D7\u67DB\u67DF\u67E1\u67E3\u67E4\u67E6\u67E7\u67E8\u67EA\u67EB\u67ED\u67EE\u67F2\u67F5\u67F6\u67F7\u67F8\u67F9\u67FA\u67FB\u67FC\u67FE\u6801\u6802\u6803\u6804\u6806\u680D\u6810\u6812\u6814\u6815\u6818\u6819\u681A\u681B\u681C\u681E\u681F\u6820\u6822\u6823\u6824\u6825\u6826\u6827\u6828\u682B\u682C\u682D\u682E\u682F\u6830\u6831\u6834\u6835\u6836\u683A\u683B\u683F\u6847\u684B\u684D\u684F\u6852\u6856\u6857\u6858\u6859\u685A\u685B\uFFFD".split("");
    for(j = 0; j != D[150].length; ++j)if (D[150][j].charCodeAt(0) !== 0xFFFD) {
        e[D[150][j]] = 38400 + j;
        d[38400 + j] = D[150][j];
    }
    D[151] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u685C\u685D\u685E\u685F\u686A\u686C\u686D\u686E\u686F\u6870\u6871\u6872\u6873\u6875\u6878\u6879\u687A\u687B\u687C\u687D\u687E\u687F\u6880\u6882\u6884\u6887\u6888\u6889\u688A\u688B\u688C\u688D\u688E\u6890\u6891\u6892\u6894\u6895\u6896\u6898\u6899\u689A\u689B\u689C\u689D\u689E\u689F\u68A0\u68A1\u68A3\u68A4\u68A5\u68A9\u68AA\u68AB\u68AC\u68AE\u68B1\u68B2\u68B4\u68B6\u68B7\u68B8\uFFFD\u68B9\u68BA\u68BB\u68BC\u68BD\u68BE\u68BF\u68C1\u68C3\u68C4\u68C5\u68C6\u68C7\u68C8\u68CA\u68CC\u68CE\u68CF\u68D0\u68D1\u68D3\u68D4\u68D6\u68D7\u68D9\u68DB\u68DC\u68DD\u68DE\u68DF\u68E1\u68E2\u68E4\u68E5\u68E6\u68E7\u68E8\u68E9\u68EA\u68EB\u68EC\u68ED\u68EF\u68F2\u68F3\u68F4\u68F6\u68F7\u68F8\u68FB\u68FD\u68FE\u68FF\u6900\u6902\u6903\u6904\u6906\u6907\u6908\u6909\u690A\u690C\u690F\u6911\u6913\u6914\u6915\u6916\u6917\u6918\u6919\u691A\u691B\u691C\u691D\u691E\u6921\u6922\u6923\u6925\u6926\u6927\u6928\u6929\u692A\u692B\u692C\u692E\u692F\u6931\u6932\u6933\u6935\u6936\u6937\u6938\u693A\u693B\u693C\u693E\u6940\u6941\u6943\u6944\u6945\u6946\u6947\u6948\u6949\u694A\u694B\u694C\u694D\u694E\u694F\u6950\u6951\u6952\u6953\u6955\u6956\u6958\u6959\u695B\u695C\u695F\uFFFD".split("");
    for(j = 0; j != D[151].length; ++j)if (D[151][j].charCodeAt(0) !== 0xFFFD) {
        e[D[151][j]] = 38656 + j;
        d[38656 + j] = D[151][j];
    }
    D[152] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6961\u6962\u6964\u6965\u6967\u6968\u6969\u696A\u696C\u696D\u696F\u6970\u6972\u6973\u6974\u6975\u6976\u697A\u697B\u697D\u697E\u697F\u6981\u6983\u6985\u698A\u698B\u698C\u698E\u698F\u6990\u6991\u6992\u6993\u6996\u6997\u6999\u699A\u699D\u699E\u699F\u69A0\u69A1\u69A2\u69A3\u69A4\u69A5\u69A6\u69A9\u69AA\u69AC\u69AE\u69AF\u69B0\u69B2\u69B3\u69B5\u69B6\u69B8\u69B9\u69BA\u69BC\u69BD\uFFFD\u69BE\u69BF\u69C0\u69C2\u69C3\u69C4\u69C5\u69C6\u69C7\u69C8\u69C9\u69CB\u69CD\u69CF\u69D1\u69D2\u69D3\u69D5\u69D6\u69D7\u69D8\u69D9\u69DA\u69DC\u69DD\u69DE\u69E1\u69E2\u69E3\u69E4\u69E5\u69E6\u69E7\u69E8\u69E9\u69EA\u69EB\u69EC\u69EE\u69EF\u69F0\u69F1\u69F3\u69F4\u69F5\u69F6\u69F7\u69F8\u69F9\u69FA\u69FB\u69FC\u69FE\u6A00\u6A01\u6A02\u6A03\u6A04\u6A05\u6A06\u6A07\u6A08\u6A09\u6A0B\u6A0C\u6A0D\u6A0E\u6A0F\u6A10\u6A11\u6A12\u6A13\u6A14\u6A15\u6A16\u6A19\u6A1A\u6A1B\u6A1C\u6A1D\u6A1E\u6A20\u6A22\u6A23\u6A24\u6A25\u6A26\u6A27\u6A29\u6A2B\u6A2C\u6A2D\u6A2E\u6A30\u6A32\u6A33\u6A34\u6A36\u6A37\u6A38\u6A39\u6A3A\u6A3B\u6A3C\u6A3F\u6A40\u6A41\u6A42\u6A43\u6A45\u6A46\u6A48\u6A49\u6A4A\u6A4B\u6A4C\u6A4D\u6A4E\u6A4F\u6A51\u6A52\u6A53\u6A54\u6A55\u6A56\u6A57\u6A5A\uFFFD".split("");
    for(j = 0; j != D[152].length; ++j)if (D[152][j].charCodeAt(0) !== 0xFFFD) {
        e[D[152][j]] = 38912 + j;
        d[38912 + j] = D[152][j];
    }
    D[153] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A5C\u6A5D\u6A5E\u6A5F\u6A60\u6A62\u6A63\u6A64\u6A66\u6A67\u6A68\u6A69\u6A6A\u6A6B\u6A6C\u6A6D\u6A6E\u6A6F\u6A70\u6A72\u6A73\u6A74\u6A75\u6A76\u6A77\u6A78\u6A7A\u6A7B\u6A7D\u6A7E\u6A7F\u6A81\u6A82\u6A83\u6A85\u6A86\u6A87\u6A88\u6A89\u6A8A\u6A8B\u6A8C\u6A8D\u6A8F\u6A92\u6A93\u6A94\u6A95\u6A96\u6A98\u6A99\u6A9A\u6A9B\u6A9C\u6A9D\u6A9E\u6A9F\u6AA1\u6AA2\u6AA3\u6AA4\u6AA5\u6AA6\uFFFD\u6AA7\u6AA8\u6AAA\u6AAD\u6AAE\u6AAF\u6AB0\u6AB1\u6AB2\u6AB3\u6AB4\u6AB5\u6AB6\u6AB7\u6AB8\u6AB9\u6ABA\u6ABB\u6ABC\u6ABD\u6ABE\u6ABF\u6AC0\u6AC1\u6AC2\u6AC3\u6AC4\u6AC5\u6AC6\u6AC7\u6AC8\u6AC9\u6ACA\u6ACB\u6ACC\u6ACD\u6ACE\u6ACF\u6AD0\u6AD1\u6AD2\u6AD3\u6AD4\u6AD5\u6AD6\u6AD7\u6AD8\u6AD9\u6ADA\u6ADB\u6ADC\u6ADD\u6ADE\u6ADF\u6AE0\u6AE1\u6AE2\u6AE3\u6AE4\u6AE5\u6AE6\u6AE7\u6AE8\u6AE9\u6AEA\u6AEB\u6AEC\u6AED\u6AEE\u6AEF\u6AF0\u6AF1\u6AF2\u6AF3\u6AF4\u6AF5\u6AF6\u6AF7\u6AF8\u6AF9\u6AFA\u6AFB\u6AFC\u6AFD\u6AFE\u6AFF\u6B00\u6B01\u6B02\u6B03\u6B04\u6B05\u6B06\u6B07\u6B08\u6B09\u6B0A\u6B0B\u6B0C\u6B0D\u6B0E\u6B0F\u6B10\u6B11\u6B12\u6B13\u6B14\u6B15\u6B16\u6B17\u6B18\u6B19\u6B1A\u6B1B\u6B1C\u6B1D\u6B1E\u6B1F\u6B25\u6B26\u6B28\u6B29\u6B2A\u6B2B\u6B2C\u6B2D\u6B2E\uFFFD".split("");
    for(j = 0; j != D[153].length; ++j)if (D[153][j].charCodeAt(0) !== 0xFFFD) {
        e[D[153][j]] = 39168 + j;
        d[39168 + j] = D[153][j];
    }
    D[154] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6B2F\u6B30\u6B31\u6B33\u6B34\u6B35\u6B36\u6B38\u6B3B\u6B3C\u6B3D\u6B3F\u6B40\u6B41\u6B42\u6B44\u6B45\u6B48\u6B4A\u6B4B\u6B4D\u6B4E\u6B4F\u6B50\u6B51\u6B52\u6B53\u6B54\u6B55\u6B56\u6B57\u6B58\u6B5A\u6B5B\u6B5C\u6B5D\u6B5E\u6B5F\u6B60\u6B61\u6B68\u6B69\u6B6B\u6B6C\u6B6D\u6B6E\u6B6F\u6B70\u6B71\u6B72\u6B73\u6B74\u6B75\u6B76\u6B77\u6B78\u6B7A\u6B7D\u6B7E\u6B7F\u6B80\u6B85\u6B88\uFFFD\u6B8C\u6B8E\u6B8F\u6B90\u6B91\u6B94\u6B95\u6B97\u6B98\u6B99\u6B9C\u6B9D\u6B9E\u6B9F\u6BA0\u6BA2\u6BA3\u6BA4\u6BA5\u6BA6\u6BA7\u6BA8\u6BA9\u6BAB\u6BAC\u6BAD\u6BAE\u6BAF\u6BB0\u6BB1\u6BB2\u6BB6\u6BB8\u6BB9\u6BBA\u6BBB\u6BBC\u6BBD\u6BBE\u6BC0\u6BC3\u6BC4\u6BC6\u6BC7\u6BC8\u6BC9\u6BCA\u6BCC\u6BCE\u6BD0\u6BD1\u6BD8\u6BDA\u6BDC\u6BDD\u6BDE\u6BDF\u6BE0\u6BE2\u6BE3\u6BE4\u6BE5\u6BE6\u6BE7\u6BE8\u6BE9\u6BEC\u6BED\u6BEE\u6BF0\u6BF1\u6BF2\u6BF4\u6BF6\u6BF7\u6BF8\u6BFA\u6BFB\u6BFC\u6BFE\u6BFF\u6C00\u6C01\u6C02\u6C03\u6C04\u6C08\u6C09\u6C0A\u6C0B\u6C0C\u6C0E\u6C12\u6C17\u6C1C\u6C1D\u6C1E\u6C20\u6C23\u6C25\u6C2B\u6C2C\u6C2D\u6C31\u6C33\u6C36\u6C37\u6C39\u6C3A\u6C3B\u6C3C\u6C3E\u6C3F\u6C43\u6C44\u6C45\u6C48\u6C4B\u6C4C\u6C4D\u6C4E\u6C4F\u6C51\u6C52\u6C53\u6C56\u6C58\uFFFD".split("");
    for(j = 0; j != D[154].length; ++j)if (D[154][j].charCodeAt(0) !== 0xFFFD) {
        e[D[154][j]] = 39424 + j;
        d[39424 + j] = D[154][j];
    }
    D[155] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C59\u6C5A\u6C62\u6C63\u6C65\u6C66\u6C67\u6C6B\u6C6C\u6C6D\u6C6E\u6C6F\u6C71\u6C73\u6C75\u6C77\u6C78\u6C7A\u6C7B\u6C7C\u6C7F\u6C80\u6C84\u6C87\u6C8A\u6C8B\u6C8D\u6C8E\u6C91\u6C92\u6C95\u6C96\u6C97\u6C98\u6C9A\u6C9C\u6C9D\u6C9E\u6CA0\u6CA2\u6CA8\u6CAC\u6CAF\u6CB0\u6CB4\u6CB5\u6CB6\u6CB7\u6CBA\u6CC0\u6CC1\u6CC2\u6CC3\u6CC6\u6CC7\u6CC8\u6CCB\u6CCD\u6CCE\u6CCF\u6CD1\u6CD2\u6CD8\uFFFD\u6CD9\u6CDA\u6CDC\u6CDD\u6CDF\u6CE4\u6CE6\u6CE7\u6CE9\u6CEC\u6CED\u6CF2\u6CF4\u6CF9\u6CFF\u6D00\u6D02\u6D03\u6D05\u6D06\u6D08\u6D09\u6D0A\u6D0D\u6D0F\u6D10\u6D11\u6D13\u6D14\u6D15\u6D16\u6D18\u6D1C\u6D1D\u6D1F\u6D20\u6D21\u6D22\u6D23\u6D24\u6D26\u6D28\u6D29\u6D2C\u6D2D\u6D2F\u6D30\u6D34\u6D36\u6D37\u6D38\u6D3A\u6D3F\u6D40\u6D42\u6D44\u6D49\u6D4C\u6D50\u6D55\u6D56\u6D57\u6D58\u6D5B\u6D5D\u6D5F\u6D61\u6D62\u6D64\u6D65\u6D67\u6D68\u6D6B\u6D6C\u6D6D\u6D70\u6D71\u6D72\u6D73\u6D75\u6D76\u6D79\u6D7A\u6D7B\u6D7D\u6D7E\u6D7F\u6D80\u6D81\u6D83\u6D84\u6D86\u6D87\u6D8A\u6D8B\u6D8D\u6D8F\u6D90\u6D92\u6D96\u6D97\u6D98\u6D99\u6D9A\u6D9C\u6DA2\u6DA5\u6DAC\u6DAD\u6DB0\u6DB1\u6DB3\u6DB4\u6DB6\u6DB7\u6DB9\u6DBA\u6DBB\u6DBC\u6DBD\u6DBE\u6DC1\u6DC2\u6DC3\u6DC8\u6DC9\u6DCA\uFFFD".split("");
    for(j = 0; j != D[155].length; ++j)if (D[155][j].charCodeAt(0) !== 0xFFFD) {
        e[D[155][j]] = 39680 + j;
        d[39680 + j] = D[155][j];
    }
    D[156] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6DCD\u6DCE\u6DCF\u6DD0\u6DD2\u6DD3\u6DD4\u6DD5\u6DD7\u6DDA\u6DDB\u6DDC\u6DDF\u6DE2\u6DE3\u6DE5\u6DE7\u6DE8\u6DE9\u6DEA\u6DED\u6DEF\u6DF0\u6DF2\u6DF4\u6DF5\u6DF6\u6DF8\u6DFA\u6DFD\u6DFE\u6DFF\u6E00\u6E01\u6E02\u6E03\u6E04\u6E06\u6E07\u6E08\u6E09\u6E0B\u6E0F\u6E12\u6E13\u6E15\u6E18\u6E19\u6E1B\u6E1C\u6E1E\u6E1F\u6E22\u6E26\u6E27\u6E28\u6E2A\u6E2C\u6E2E\u6E30\u6E31\u6E33\u6E35\uFFFD\u6E36\u6E37\u6E39\u6E3B\u6E3C\u6E3D\u6E3E\u6E3F\u6E40\u6E41\u6E42\u6E45\u6E46\u6E47\u6E48\u6E49\u6E4A\u6E4B\u6E4C\u6E4F\u6E50\u6E51\u6E52\u6E55\u6E57\u6E59\u6E5A\u6E5C\u6E5D\u6E5E\u6E60\u6E61\u6E62\u6E63\u6E64\u6E65\u6E66\u6E67\u6E68\u6E69\u6E6A\u6E6C\u6E6D\u6E6F\u6E70\u6E71\u6E72\u6E73\u6E74\u6E75\u6E76\u6E77\u6E78\u6E79\u6E7A\u6E7B\u6E7C\u6E7D\u6E80\u6E81\u6E82\u6E84\u6E87\u6E88\u6E8A\u6E8B\u6E8C\u6E8D\u6E8E\u6E91\u6E92\u6E93\u6E94\u6E95\u6E96\u6E97\u6E99\u6E9A\u6E9B\u6E9D\u6E9E\u6EA0\u6EA1\u6EA3\u6EA4\u6EA6\u6EA8\u6EA9\u6EAB\u6EAC\u6EAD\u6EAE\u6EB0\u6EB3\u6EB5\u6EB8\u6EB9\u6EBC\u6EBE\u6EBF\u6EC0\u6EC3\u6EC4\u6EC5\u6EC6\u6EC8\u6EC9\u6ECA\u6ECC\u6ECD\u6ECE\u6ED0\u6ED2\u6ED6\u6ED8\u6ED9\u6EDB\u6EDC\u6EDD\u6EE3\u6EE7\u6EEA\u6EEB\u6EEC\u6EED\u6EEE\u6EEF\uFFFD".split("");
    for(j = 0; j != D[156].length; ++j)if (D[156][j].charCodeAt(0) !== 0xFFFD) {
        e[D[156][j]] = 39936 + j;
        d[39936 + j] = D[156][j];
    }
    D[157] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6EF0\u6EF1\u6EF2\u6EF3\u6EF5\u6EF6\u6EF7\u6EF8\u6EFA\u6EFB\u6EFC\u6EFD\u6EFE\u6EFF\u6F00\u6F01\u6F03\u6F04\u6F05\u6F07\u6F08\u6F0A\u6F0B\u6F0C\u6F0D\u6F0E\u6F10\u6F11\u6F12\u6F16\u6F17\u6F18\u6F19\u6F1A\u6F1B\u6F1C\u6F1D\u6F1E\u6F1F\u6F21\u6F22\u6F23\u6F25\u6F26\u6F27\u6F28\u6F2C\u6F2E\u6F30\u6F32\u6F34\u6F35\u6F37\u6F38\u6F39\u6F3A\u6F3B\u6F3C\u6F3D\u6F3F\u6F40\u6F41\u6F42\uFFFD\u6F43\u6F44\u6F45\u6F48\u6F49\u6F4A\u6F4C\u6F4E\u6F4F\u6F50\u6F51\u6F52\u6F53\u6F54\u6F55\u6F56\u6F57\u6F59\u6F5A\u6F5B\u6F5D\u6F5F\u6F60\u6F61\u6F63\u6F64\u6F65\u6F67\u6F68\u6F69\u6F6A\u6F6B\u6F6C\u6F6F\u6F70\u6F71\u6F73\u6F75\u6F76\u6F77\u6F79\u6F7B\u6F7D\u6F7E\u6F7F\u6F80\u6F81\u6F82\u6F83\u6F85\u6F86\u6F87\u6F8A\u6F8B\u6F8F\u6F90\u6F91\u6F92\u6F93\u6F94\u6F95\u6F96\u6F97\u6F98\u6F99\u6F9A\u6F9B\u6F9D\u6F9E\u6F9F\u6FA0\u6FA2\u6FA3\u6FA4\u6FA5\u6FA6\u6FA8\u6FA9\u6FAA\u6FAB\u6FAC\u6FAD\u6FAE\u6FAF\u6FB0\u6FB1\u6FB2\u6FB4\u6FB5\u6FB7\u6FB8\u6FBA\u6FBB\u6FBC\u6FBD\u6FBE\u6FBF\u6FC1\u6FC3\u6FC4\u6FC5\u6FC6\u6FC7\u6FC8\u6FCA\u6FCB\u6FCC\u6FCD\u6FCE\u6FCF\u6FD0\u6FD3\u6FD4\u6FD5\u6FD6\u6FD7\u6FD8\u6FD9\u6FDA\u6FDB\u6FDC\u6FDD\u6FDF\u6FE2\u6FE3\u6FE4\u6FE5\uFFFD".split("");
    for(j = 0; j != D[157].length; ++j)if (D[157][j].charCodeAt(0) !== 0xFFFD) {
        e[D[157][j]] = 40192 + j;
        d[40192 + j] = D[157][j];
    }
    D[158] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FE6\u6FE7\u6FE8\u6FE9\u6FEA\u6FEB\u6FEC\u6FED\u6FF0\u6FF1\u6FF2\u6FF3\u6FF4\u6FF5\u6FF6\u6FF7\u6FF8\u6FF9\u6FFA\u6FFB\u6FFC\u6FFD\u6FFE\u6FFF\u7000\u7001\u7002\u7003\u7004\u7005\u7006\u7007\u7008\u7009\u700A\u700B\u700C\u700D\u700E\u700F\u7010\u7012\u7013\u7014\u7015\u7016\u7017\u7018\u7019\u701C\u701D\u701E\u701F\u7020\u7021\u7022\u7024\u7025\u7026\u7027\u7028\u7029\u702A\uFFFD\u702B\u702C\u702D\u702E\u702F\u7030\u7031\u7032\u7033\u7034\u7036\u7037\u7038\u703A\u703B\u703C\u703D\u703E\u703F\u7040\u7041\u7042\u7043\u7044\u7045\u7046\u7047\u7048\u7049\u704A\u704B\u704D\u704E\u7050\u7051\u7052\u7053\u7054\u7055\u7056\u7057\u7058\u7059\u705A\u705B\u705C\u705D\u705F\u7060\u7061\u7062\u7063\u7064\u7065\u7066\u7067\u7068\u7069\u706A\u706E\u7071\u7072\u7073\u7074\u7077\u7079\u707A\u707B\u707D\u7081\u7082\u7083\u7084\u7086\u7087\u7088\u708B\u708C\u708D\u708F\u7090\u7091\u7093\u7097\u7098\u709A\u709B\u709E\u709F\u70A0\u70A1\u70A2\u70A3\u70A4\u70A5\u70A6\u70A7\u70A8\u70A9\u70AA\u70B0\u70B2\u70B4\u70B5\u70B6\u70BA\u70BE\u70BF\u70C4\u70C5\u70C6\u70C7\u70C9\u70CB\u70CC\u70CD\u70CE\u70CF\u70D0\u70D1\u70D2\u70D3\u70D4\u70D5\u70D6\u70D7\u70DA\uFFFD".split("");
    for(j = 0; j != D[158].length; ++j)if (D[158][j].charCodeAt(0) !== 0xFFFD) {
        e[D[158][j]] = 40448 + j;
        d[40448 + j] = D[158][j];
    }
    D[159] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u70DC\u70DD\u70DE\u70E0\u70E1\u70E2\u70E3\u70E5\u70EA\u70EE\u70F0\u70F1\u70F2\u70F3\u70F4\u70F5\u70F6\u70F8\u70FA\u70FB\u70FC\u70FE\u70FF\u7100\u7101\u7102\u7103\u7104\u7105\u7106\u7107\u7108\u710B\u710C\u710D\u710E\u710F\u7111\u7112\u7114\u7117\u711B\u711C\u711D\u711E\u711F\u7120\u7121\u7122\u7123\u7124\u7125\u7127\u7128\u7129\u712A\u712B\u712C\u712D\u712E\u7132\u7133\u7134\uFFFD\u7135\u7137\u7138\u7139\u713A\u713B\u713C\u713D\u713E\u713F\u7140\u7141\u7142\u7143\u7144\u7146\u7147\u7148\u7149\u714B\u714D\u714F\u7150\u7151\u7152\u7153\u7154\u7155\u7156\u7157\u7158\u7159\u715A\u715B\u715D\u715F\u7160\u7161\u7162\u7163\u7165\u7169\u716A\u716B\u716C\u716D\u716F\u7170\u7171\u7174\u7175\u7176\u7177\u7179\u717B\u717C\u717E\u717F\u7180\u7181\u7182\u7183\u7185\u7186\u7187\u7188\u7189\u718B\u718C\u718D\u718E\u7190\u7191\u7192\u7193\u7195\u7196\u7197\u719A\u719B\u719C\u719D\u719E\u71A1\u71A2\u71A3\u71A4\u71A5\u71A6\u71A7\u71A9\u71AA\u71AB\u71AD\u71AE\u71AF\u71B0\u71B1\u71B2\u71B4\u71B6\u71B7\u71B8\u71BA\u71BB\u71BC\u71BD\u71BE\u71BF\u71C0\u71C1\u71C2\u71C4\u71C5\u71C6\u71C7\u71C8\u71C9\u71CA\u71CB\u71CC\u71CD\u71CF\u71D0\u71D1\u71D2\u71D3\uFFFD".split("");
    for(j = 0; j != D[159].length; ++j)if (D[159][j].charCodeAt(0) !== 0xFFFD) {
        e[D[159][j]] = 40704 + j;
        d[40704 + j] = D[159][j];
    }
    D[160] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u71D6\u71D7\u71D8\u71D9\u71DA\u71DB\u71DC\u71DD\u71DE\u71DF\u71E1\u71E2\u71E3\u71E4\u71E6\u71E8\u71E9\u71EA\u71EB\u71EC\u71ED\u71EF\u71F0\u71F1\u71F2\u71F3\u71F4\u71F5\u71F6\u71F7\u71F8\u71FA\u71FB\u71FC\u71FD\u71FE\u71FF\u7200\u7201\u7202\u7203\u7204\u7205\u7207\u7208\u7209\u720A\u720B\u720C\u720D\u720E\u720F\u7210\u7211\u7212\u7213\u7214\u7215\u7216\u7217\u7218\u7219\u721A\uFFFD\u721B\u721C\u721E\u721F\u7220\u7221\u7222\u7223\u7224\u7225\u7226\u7227\u7229\u722B\u722D\u722E\u722F\u7232\u7233\u7234\u723A\u723C\u723E\u7240\u7241\u7242\u7243\u7244\u7245\u7246\u7249\u724A\u724B\u724E\u724F\u7250\u7251\u7253\u7254\u7255\u7257\u7258\u725A\u725C\u725E\u7260\u7263\u7264\u7265\u7268\u726A\u726B\u726C\u726D\u7270\u7271\u7273\u7274\u7276\u7277\u7278\u727B\u727C\u727D\u7282\u7283\u7285\u7286\u7287\u7288\u7289\u728C\u728E\u7290\u7291\u7293\u7294\u7295\u7296\u7297\u7298\u7299\u729A\u729B\u729C\u729D\u729E\u72A0\u72A1\u72A2\u72A3\u72A4\u72A5\u72A6\u72A7\u72A8\u72A9\u72AA\u72AB\u72AE\u72B1\u72B2\u72B3\u72B5\u72BA\u72BB\u72BC\u72BD\u72BE\u72BF\u72C0\u72C5\u72C6\u72C7\u72C9\u72CA\u72CB\u72CC\u72CF\u72D1\u72D3\u72D4\u72D5\u72D6\u72D8\u72DA\u72DB\uFFFD".split("");
    for(j = 0; j != D[160].length; ++j)if (D[160][j].charCodeAt(0) !== 0xFFFD) {
        e[D[160][j]] = 40960 + j;
        d[40960 + j] = D[160][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\u3001\u3002\xb7\u02C9\u02C7\xa8\u3003\u3005\u2014\uFF5E\u2016\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2488\u2489\u248A\u248B\u248C\u248D\u248E\u248F\u2490\u2491\u2492\u2493\u2494\u2495\u2496\u2497\u2498\u2499\u249A\u249B\u2474\u2475\u2476\u2477\u2478\u2479\u247A\u247B\u247C\u247D\u247E\u247F\u2480\u2481\u2482\u2483\u2484\u2485\u2486\u2487\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\uFFFD\uFFFD\u3220\u3221\u3222\u3223\u3224\u3225\u3226\u3227\u3228\u3229\uFFFD\uFFFD\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\u216A\u216B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF01\uFF02\uFF03\uFFE5\uFF05\uFF06\uFF07\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF3B\uFF3C\uFF3D\uFF3E\uFF3F\uFF40\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFF5B\uFF5C\uFF5D\uFFE3\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFE35\uFE36\uFE39\uFE3A\uFE3F\uFE40\uFE3D\uFE3E\uFE41\uFE42\uFE43\uFE44\uFFFD\uFFFD\uFE3B\uFE3C\uFE37\uFE38\uFE31\uFFFD\uFE33\uFE34\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u02CA\u02CB\u02D9\u2013\u2015\u2025\u2035\u2105\u2109\u2196\u2197\u2198\u2199\u2215\u221F\u2223\u2252\u2266\u2267\u22BF\u2550\u2551\u2552\u2553\u2554\u2555\u2556\u2557\u2558\u2559\u255A\u255B\u255C\u255D\u255E\u255F\u2560\u2561\u2562\u2563\u2564\u2565\u2566\u2567\u2568\u2569\u256A\u256B\u256C\u256D\u256E\u256F\u2570\u2571\u2572\u2573\u2581\u2582\u2583\u2584\u2585\u2586\u2587\uFFFD\u2588\u2589\u258A\u258B\u258C\u258D\u258E\u258F\u2593\u2594\u2595\u25BC\u25BD\u25E2\u25E3\u25E4\u25E5\u2609\u2295\u3012\u301D\u301E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\u0251\uFFFD\u0144\u0148\uFFFD\u0261\uFFFD\uFFFD\uFFFD\uFFFD\u3105\u3106\u3107\u3108\u3109\u310A\u310B\u310C\u310D\u310E\u310F\u3110\u3111\u3112\u3113\u3114\u3115\u3116\u3117\u3118\u3119\u311A\u311B\u311C\u311D\u311E\u311F\u3120\u3121\u3122\u3123\u3124\u3125\u3126\u3127\u3128\u3129\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3021\u3022\u3023\u3024\u3025\u3026\u3027\u3028\u3029\u32A3\u338E\u338F\u339C\u339D\u339E\u33A1\u33C4\u33CE\u33D1\u33D2\u33D5\uFE30\uFFE2\uFFE4\uFFFD\u2121\u3231\uFFFD\u2010\uFFFD\uFFFD\uFFFD\u30FC\u309B\u309C\u30FD\u30FE\u3006\u309D\u309E\uFE49\uFE4A\uFE4B\uFE4C\uFE4D\uFE4E\uFE4F\uFE50\uFE51\uFE52\uFE54\uFE55\uFE56\uFE57\uFE59\uFE5A\uFE5B\uFE5C\uFE5D\uFE5E\uFE5F\uFE60\uFE61\uFFFD\uFE62\uFE63\uFE64\uFE65\uFE66\uFE68\uFE69\uFE6A\uFE6B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3007\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2500\u2501\u2502\u2503\u2504\u2505\u2506\u2507\u2508\u2509\u250A\u250B\u250C\u250D\u250E\u250F\u2510\u2511\u2512\u2513\u2514\u2515\u2516\u2517\u2518\u2519\u251A\u251B\u251C\u251D\u251E\u251F\u2520\u2521\u2522\u2523\u2524\u2525\u2526\u2527\u2528\u2529\u252A\u252B\u252C\u252D\u252E\u252F\u2530\u2531\u2532\u2533\u2534\u2535\u2536\u2537\u2538\u2539\u253A\u253B\u253C\u253D\u253E\u253F\u2540\u2541\u2542\u2543\u2544\u2545\u2546\u2547\u2548\u2549\u254A\u254B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[170] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u72DC\u72DD\u72DF\u72E2\u72E3\u72E4\u72E5\u72E6\u72E7\u72EA\u72EB\u72F5\u72F6\u72F9\u72FD\u72FE\u72FF\u7300\u7302\u7304\u7305\u7306\u7307\u7308\u7309\u730B\u730C\u730D\u730F\u7310\u7311\u7312\u7314\u7318\u7319\u731A\u731F\u7320\u7323\u7324\u7326\u7327\u7328\u732D\u732F\u7330\u7332\u7333\u7335\u7336\u733A\u733B\u733C\u733D\u7340\u7341\u7342\u7343\u7344\u7345\u7346\u7347\u7348\uFFFD\u7349\u734A\u734B\u734C\u734E\u734F\u7351\u7353\u7354\u7355\u7356\u7358\u7359\u735A\u735B\u735C\u735D\u735E\u735F\u7361\u7362\u7363\u7364\u7365\u7366\u7367\u7368\u7369\u736A\u736B\u736E\u7370\u7371\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[170].length; ++j)if (D[170][j].charCodeAt(0) !== 0xFFFD) {
        e[D[170][j]] = 43520 + j;
        d[43520 + j] = D[170][j];
    }
    D[171] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7372\u7373\u7374\u7375\u7376\u7377\u7378\u7379\u737A\u737B\u737C\u737D\u737F\u7380\u7381\u7382\u7383\u7385\u7386\u7388\u738A\u738C\u738D\u738F\u7390\u7392\u7393\u7394\u7395\u7397\u7398\u7399\u739A\u739C\u739D\u739E\u73A0\u73A1\u73A3\u73A4\u73A5\u73A6\u73A7\u73A8\u73AA\u73AC\u73AD\u73B1\u73B4\u73B5\u73B6\u73B8\u73B9\u73BC\u73BD\u73BE\u73BF\u73C1\u73C3\u73C4\u73C5\u73C6\u73C7\uFFFD\u73CB\u73CC\u73CE\u73D2\u73D3\u73D4\u73D5\u73D6\u73D7\u73D8\u73DA\u73DB\u73DC\u73DD\u73DF\u73E1\u73E2\u73E3\u73E4\u73E6\u73E8\u73EA\u73EB\u73EC\u73EE\u73EF\u73F0\u73F1\u73F3\u73F4\u73F5\u73F6\u73F7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[171].length; ++j)if (D[171][j].charCodeAt(0) !== 0xFFFD) {
        e[D[171][j]] = 43776 + j;
        d[43776 + j] = D[171][j];
    }
    D[172] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u73F8\u73F9\u73FA\u73FB\u73FC\u73FD\u73FE\u73FF\u7400\u7401\u7402\u7404\u7407\u7408\u740B\u740C\u740D\u740E\u7411\u7412\u7413\u7414\u7415\u7416\u7417\u7418\u7419\u741C\u741D\u741E\u741F\u7420\u7421\u7423\u7424\u7427\u7429\u742B\u742D\u742F\u7431\u7432\u7437\u7438\u7439\u743A\u743B\u743D\u743E\u743F\u7440\u7442\u7443\u7444\u7445\u7446\u7447\u7448\u7449\u744A\u744B\u744C\u744D\uFFFD\u744E\u744F\u7450\u7451\u7452\u7453\u7454\u7456\u7458\u745D\u7460\u7461\u7462\u7463\u7464\u7465\u7466\u7467\u7468\u7469\u746A\u746B\u746C\u746E\u746F\u7471\u7472\u7473\u7474\u7475\u7478\u7479\u747A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[172].length; ++j)if (D[172][j].charCodeAt(0) !== 0xFFFD) {
        e[D[172][j]] = 44032 + j;
        d[44032 + j] = D[172][j];
    }
    D[173] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u747B\u747C\u747D\u747F\u7482\u7484\u7485\u7486\u7488\u7489\u748A\u748C\u748D\u748F\u7491\u7492\u7493\u7494\u7495\u7496\u7497\u7498\u7499\u749A\u749B\u749D\u749F\u74A0\u74A1\u74A2\u74A3\u74A4\u74A5\u74A6\u74AA\u74AB\u74AC\u74AD\u74AE\u74AF\u74B0\u74B1\u74B2\u74B3\u74B4\u74B5\u74B6\u74B7\u74B8\u74B9\u74BB\u74BC\u74BD\u74BE\u74BF\u74C0\u74C1\u74C2\u74C3\u74C4\u74C5\u74C6\u74C7\uFFFD\u74C8\u74C9\u74CA\u74CB\u74CC\u74CD\u74CE\u74CF\u74D0\u74D1\u74D3\u74D4\u74D5\u74D6\u74D7\u74D8\u74D9\u74DA\u74DB\u74DD\u74DF\u74E1\u74E5\u74E7\u74E8\u74E9\u74EA\u74EB\u74EC\u74ED\u74F0\u74F1\u74F2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[173].length; ++j)if (D[173][j].charCodeAt(0) !== 0xFFFD) {
        e[D[173][j]] = 44288 + j;
        d[44288 + j] = D[173][j];
    }
    D[174] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74F3\u74F5\u74F8\u74F9\u74FA\u74FB\u74FC\u74FD\u74FE\u7500\u7501\u7502\u7503\u7505\u7506\u7507\u7508\u7509\u750A\u750B\u750C\u750E\u7510\u7512\u7514\u7515\u7516\u7517\u751B\u751D\u751E\u7520\u7521\u7522\u7523\u7524\u7526\u7527\u752A\u752E\u7534\u7536\u7539\u753C\u753D\u753F\u7541\u7542\u7543\u7544\u7546\u7547\u7549\u754A\u754D\u7550\u7551\u7552\u7553\u7555\u7556\u7557\u7558\uFFFD\u755D\u755E\u755F\u7560\u7561\u7562\u7563\u7564\u7567\u7568\u7569\u756B\u756C\u756D\u756E\u756F\u7570\u7571\u7573\u7575\u7576\u7577\u757A\u757B\u757C\u757D\u757E\u7580\u7581\u7582\u7584\u7585\u7587\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[174].length; ++j)if (D[174][j].charCodeAt(0) !== 0xFFFD) {
        e[D[174][j]] = 44544 + j;
        d[44544 + j] = D[174][j];
    }
    D[175] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7588\u7589\u758A\u758C\u758D\u758E\u7590\u7593\u7595\u7598\u759B\u759C\u759E\u75A2\u75A6\u75A7\u75A8\u75A9\u75AA\u75AD\u75B6\u75B7\u75BA\u75BB\u75BF\u75C0\u75C1\u75C6\u75CB\u75CC\u75CE\u75CF\u75D0\u75D1\u75D3\u75D7\u75D9\u75DA\u75DC\u75DD\u75DF\u75E0\u75E1\u75E5\u75E9\u75EC\u75ED\u75EE\u75EF\u75F2\u75F3\u75F5\u75F6\u75F7\u75F8\u75FA\u75FB\u75FD\u75FE\u7602\u7604\u7606\u7607\uFFFD\u7608\u7609\u760B\u760D\u760E\u760F\u7611\u7612\u7613\u7614\u7616\u761A\u761C\u761D\u761E\u7621\u7623\u7627\u7628\u762C\u762E\u762F\u7631\u7632\u7636\u7637\u7639\u763A\u763B\u763D\u7641\u7642\u7644\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[175].length; ++j)if (D[175][j].charCodeAt(0) !== 0xFFFD) {
        e[D[175][j]] = 44800 + j;
        d[44800 + j] = D[175][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7645\u7646\u7647\u7648\u7649\u764A\u764B\u764E\u764F\u7650\u7651\u7652\u7653\u7655\u7657\u7658\u7659\u765A\u765B\u765D\u765F\u7660\u7661\u7662\u7664\u7665\u7666\u7667\u7668\u7669\u766A\u766C\u766D\u766E\u7670\u7671\u7672\u7673\u7674\u7675\u7676\u7677\u7679\u767A\u767C\u767F\u7680\u7681\u7683\u7685\u7689\u768A\u768C\u768D\u768F\u7690\u7692\u7694\u7695\u7697\u7698\u769A\u769B\uFFFD\u769C\u769D\u769E\u769F\u76A0\u76A1\u76A2\u76A3\u76A5\u76A6\u76A7\u76A8\u76A9\u76AA\u76AB\u76AC\u76AD\u76AF\u76B0\u76B3\u76B5\u76B6\u76B7\u76B8\u76B9\u76BA\u76BB\u76BC\u76BD\u76BE\u76C0\u76C1\u76C3\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u76C4\u76C7\u76C9\u76CB\u76CC\u76D3\u76D5\u76D9\u76DA\u76DC\u76DD\u76DE\u76E0\u76E1\u76E2\u76E3\u76E4\u76E6\u76E7\u76E8\u76E9\u76EA\u76EB\u76EC\u76ED\u76F0\u76F3\u76F5\u76F6\u76F7\u76FA\u76FB\u76FD\u76FF\u7700\u7702\u7703\u7705\u7706\u770A\u770C\u770E\u770F\u7710\u7711\u7712\u7713\u7714\u7715\u7716\u7717\u7718\u771B\u771C\u771D\u771E\u7721\u7723\u7724\u7725\u7727\u772A\u772B\uFFFD\u772C\u772E\u7730\u7731\u7732\u7733\u7734\u7739\u773B\u773D\u773E\u773F\u7742\u7744\u7745\u7746\u7748\u7749\u774A\u774B\u774C\u774D\u774E\u774F\u7752\u7753\u7754\u7755\u7756\u7757\u7758\u7759\u775C\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u775D\u775E\u775F\u7760\u7764\u7767\u7769\u776A\u776D\u776E\u776F\u7770\u7771\u7772\u7773\u7774\u7775\u7776\u7777\u7778\u777A\u777B\u777C\u7781\u7782\u7783\u7786\u7787\u7788\u7789\u778A\u778B\u778F\u7790\u7793\u7794\u7795\u7796\u7797\u7798\u7799\u779A\u779B\u779C\u779D\u779E\u77A1\u77A3\u77A4\u77A6\u77A8\u77AB\u77AD\u77AE\u77AF\u77B1\u77B2\u77B4\u77B6\u77B7\u77B8\u77B9\u77BA\uFFFD\u77BC\u77BE\u77C0\u77C1\u77C2\u77C3\u77C4\u77C5\u77C6\u77C7\u77C8\u77C9\u77CA\u77CB\u77CC\u77CE\u77CF\u77D0\u77D1\u77D2\u77D3\u77D4\u77D5\u77D6\u77D8\u77D9\u77DA\u77DD\u77DE\u77DF\u77E0\u77E1\u77E4\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77E6\u77E8\u77EA\u77EF\u77F0\u77F1\u77F2\u77F4\u77F5\u77F7\u77F9\u77FA\u77FB\u77FC\u7803\u7804\u7805\u7806\u7807\u7808\u780A\u780B\u780E\u780F\u7810\u7813\u7815\u7819\u781B\u781E\u7820\u7821\u7822\u7824\u7828\u782A\u782B\u782E\u782F\u7831\u7832\u7833\u7835\u7836\u783D\u783F\u7841\u7842\u7843\u7844\u7846\u7848\u7849\u784A\u784B\u784D\u784F\u7851\u7853\u7854\u7858\u7859\u785A\uFFFD\u785B\u785C\u785E\u785F\u7860\u7861\u7862\u7863\u7864\u7865\u7866\u7867\u7868\u7869\u786F\u7870\u7871\u7872\u7873\u7874\u7875\u7876\u7878\u7879\u787A\u787B\u787D\u787E\u787F\u7880\u7881\u7882\u7883\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7884\u7885\u7886\u7888\u788A\u788B\u788F\u7890\u7892\u7894\u7895\u7896\u7899\u789D\u789E\u78A0\u78A2\u78A4\u78A6\u78A8\u78A9\u78AA\u78AB\u78AC\u78AD\u78AE\u78AF\u78B5\u78B6\u78B7\u78B8\u78BA\u78BB\u78BC\u78BD\u78BF\u78C0\u78C2\u78C3\u78C4\u78C6\u78C7\u78C8\u78CC\u78CD\u78CE\u78CF\u78D1\u78D2\u78D3\u78D6\u78D7\u78D8\u78DA\u78DB\u78DC\u78DD\u78DE\u78DF\u78E0\u78E1\u78E2\u78E3\uFFFD\u78E4\u78E5\u78E6\u78E7\u78E9\u78EA\u78EB\u78ED\u78EE\u78EF\u78F0\u78F1\u78F3\u78F5\u78F6\u78F8\u78F9\u78FB\u78FC\u78FD\u78FE\u78FF\u7900\u7902\u7903\u7904\u7906\u7907\u7908\u7909\u790A\u790B\u790C\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u790D\u790E\u790F\u7910\u7911\u7912\u7914\u7915\u7916\u7917\u7918\u7919\u791A\u791B\u791C\u791D\u791F\u7920\u7921\u7922\u7923\u7925\u7926\u7927\u7928\u7929\u792A\u792B\u792C\u792D\u792E\u792F\u7930\u7931\u7932\u7933\u7935\u7936\u7937\u7938\u7939\u793D\u793F\u7942\u7943\u7944\u7945\u7947\u794A\u794B\u794C\u794D\u794E\u794F\u7950\u7951\u7952\u7954\u7955\u7958\u7959\u7961\u7963\uFFFD\u7964\u7966\u7969\u796A\u796B\u796C\u796E\u7970\u7971\u7972\u7973\u7974\u7975\u7976\u7979\u797B\u797C\u797D\u797E\u797F\u7982\u7983\u7986\u7987\u7988\u7989\u798B\u798C\u798D\u798E\u7990\u7991\u7992\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7993\u7994\u7995\u7996\u7997\u7998\u7999\u799B\u799C\u799D\u799E\u799F\u79A0\u79A1\u79A2\u79A3\u79A4\u79A5\u79A6\u79A8\u79A9\u79AA\u79AB\u79AC\u79AD\u79AE\u79AF\u79B0\u79B1\u79B2\u79B4\u79B5\u79B6\u79B7\u79B8\u79BC\u79BF\u79C2\u79C4\u79C5\u79C7\u79C8\u79CA\u79CC\u79CE\u79CF\u79D0\u79D3\u79D4\u79D6\u79D7\u79D9\u79DA\u79DB\u79DC\u79DD\u79DE\u79E0\u79E1\u79E2\u79E5\u79E8\u79EA\uFFFD\u79EC\u79EE\u79F1\u79F2\u79F3\u79F4\u79F5\u79F6\u79F7\u79F9\u79FA\u79FC\u79FE\u79FF\u7A01\u7A04\u7A05\u7A07\u7A08\u7A09\u7A0A\u7A0C\u7A0F\u7A10\u7A11\u7A12\u7A13\u7A15\u7A16\u7A18\u7A19\u7A1B\u7A1C\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A1D\u7A1F\u7A21\u7A22\u7A24\u7A25\u7A26\u7A27\u7A28\u7A29\u7A2A\u7A2B\u7A2C\u7A2D\u7A2E\u7A2F\u7A30\u7A31\u7A32\u7A34\u7A35\u7A36\u7A38\u7A3A\u7A3E\u7A40\u7A41\u7A42\u7A43\u7A44\u7A45\u7A47\u7A48\u7A49\u7A4A\u7A4B\u7A4C\u7A4D\u7A4E\u7A4F\u7A50\u7A52\u7A53\u7A54\u7A55\u7A56\u7A58\u7A59\u7A5A\u7A5B\u7A5C\u7A5D\u7A5E\u7A5F\u7A60\u7A61\u7A62\u7A63\u7A64\u7A65\u7A66\u7A67\u7A68\uFFFD\u7A69\u7A6A\u7A6B\u7A6C\u7A6D\u7A6E\u7A6F\u7A71\u7A72\u7A73\u7A75\u7A7B\u7A7C\u7A7D\u7A7E\u7A82\u7A85\u7A87\u7A89\u7A8A\u7A8B\u7A8C\u7A8E\u7A8F\u7A90\u7A93\u7A94\u7A99\u7A9A\u7A9B\u7A9E\u7AA1\u7AA2\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7AA3\u7AA4\u7AA7\u7AA9\u7AAA\u7AAB\u7AAE\u7AAF\u7AB0\u7AB1\u7AB2\u7AB4\u7AB5\u7AB6\u7AB7\u7AB8\u7AB9\u7ABA\u7ABB\u7ABC\u7ABD\u7ABE\u7AC0\u7AC1\u7AC2\u7AC3\u7AC4\u7AC5\u7AC6\u7AC7\u7AC8\u7AC9\u7ACA\u7ACC\u7ACD\u7ACE\u7ACF\u7AD0\u7AD1\u7AD2\u7AD3\u7AD4\u7AD5\u7AD7\u7AD8\u7ADA\u7ADB\u7ADC\u7ADD\u7AE1\u7AE2\u7AE4\u7AE7\u7AE8\u7AE9\u7AEA\u7AEB\u7AEC\u7AEE\u7AF0\u7AF1\u7AF2\u7AF3\uFFFD\u7AF4\u7AF5\u7AF6\u7AF7\u7AF8\u7AFB\u7AFC\u7AFE\u7B00\u7B01\u7B02\u7B05\u7B07\u7B09\u7B0C\u7B0D\u7B0E\u7B10\u7B12\u7B13\u7B16\u7B17\u7B18\u7B1A\u7B1C\u7B1D\u7B1F\u7B21\u7B22\u7B23\u7B27\u7B29\u7B2D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7B2F\u7B30\u7B32\u7B34\u7B35\u7B36\u7B37\u7B39\u7B3B\u7B3D\u7B3F\u7B40\u7B41\u7B42\u7B43\u7B44\u7B46\u7B48\u7B4A\u7B4D\u7B4E\u7B53\u7B55\u7B57\u7B59\u7B5C\u7B5E\u7B5F\u7B61\u7B63\u7B64\u7B65\u7B66\u7B67\u7B68\u7B69\u7B6A\u7B6B\u7B6C\u7B6D\u7B6F\u7B70\u7B73\u7B74\u7B76\u7B78\u7B7A\u7B7C\u7B7D\u7B7F\u7B81\u7B82\u7B83\u7B84\u7B86\u7B87\u7B88\u7B89\u7B8A\u7B8B\u7B8C\u7B8E\u7B8F\uFFFD\u7B91\u7B92\u7B93\u7B96\u7B98\u7B99\u7B9A\u7B9B\u7B9E\u7B9F\u7BA0\u7BA3\u7BA4\u7BA5\u7BAE\u7BAF\u7BB0\u7BB2\u7BB3\u7BB5\u7BB6\u7BB7\u7BB9\u7BBA\u7BBB\u7BBC\u7BBD\u7BBE\u7BBF\u7BC0\u7BC2\u7BC3\u7BC4\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7BC5\u7BC8\u7BC9\u7BCA\u7BCB\u7BCD\u7BCE\u7BCF\u7BD0\u7BD2\u7BD4\u7BD5\u7BD6\u7BD7\u7BD8\u7BDB\u7BDC\u7BDE\u7BDF\u7BE0\u7BE2\u7BE3\u7BE4\u7BE7\u7BE8\u7BE9\u7BEB\u7BEC\u7BED\u7BEF\u7BF0\u7BF2\u7BF3\u7BF4\u7BF5\u7BF6\u7BF8\u7BF9\u7BFA\u7BFB\u7BFD\u7BFF\u7C00\u7C01\u7C02\u7C03\u7C04\u7C05\u7C06\u7C08\u7C09\u7C0A\u7C0D\u7C0E\u7C10\u7C11\u7C12\u7C13\u7C14\u7C15\u7C17\u7C18\u7C19\uFFFD\u7C1A\u7C1B\u7C1C\u7C1D\u7C1E\u7C20\u7C21\u7C22\u7C23\u7C24\u7C25\u7C28\u7C29\u7C2B\u7C2C\u7C2D\u7C2E\u7C2F\u7C30\u7C31\u7C32\u7C33\u7C34\u7C35\u7C36\u7C37\u7C39\u7C3A\u7C3B\u7C3C\u7C3D\u7C3E\u7C42\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7C43\u7C44\u7C45\u7C46\u7C47\u7C48\u7C49\u7C4A\u7C4B\u7C4C\u7C4E\u7C4F\u7C50\u7C51\u7C52\u7C53\u7C54\u7C55\u7C56\u7C57\u7C58\u7C59\u7C5A\u7C5B\u7C5C\u7C5D\u7C5E\u7C5F\u7C60\u7C61\u7C62\u7C63\u7C64\u7C65\u7C66\u7C67\u7C68\u7C69\u7C6A\u7C6B\u7C6C\u7C6D\u7C6E\u7C6F\u7C70\u7C71\u7C72\u7C75\u7C76\u7C77\u7C78\u7C79\u7C7A\u7C7E\u7C7F\u7C80\u7C81\u7C82\u7C83\u7C84\u7C85\u7C86\u7C87\uFFFD\u7C88\u7C8A\u7C8B\u7C8C\u7C8D\u7C8E\u7C8F\u7C90\u7C93\u7C94\u7C96\u7C99\u7C9A\u7C9B\u7CA0\u7CA1\u7CA3\u7CA6\u7CA7\u7CA8\u7CA9\u7CAB\u7CAC\u7CAD\u7CAF\u7CB0\u7CB4\u7CB5\u7CB6\u7CB7\u7CB8\u7CBA\u7CBB\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7CBF\u7CC0\u7CC2\u7CC3\u7CC4\u7CC6\u7CC9\u7CCB\u7CCE\u7CCF\u7CD0\u7CD1\u7CD2\u7CD3\u7CD4\u7CD8\u7CDA\u7CDB\u7CDD\u7CDE\u7CE1\u7CE2\u7CE3\u7CE4\u7CE5\u7CE6\u7CE7\u7CE9\u7CEA\u7CEB\u7CEC\u7CED\u7CEE\u7CF0\u7CF1\u7CF2\u7CF3\u7CF4\u7CF5\u7CF6\u7CF7\u7CF9\u7CFA\u7CFC\u7CFD\u7CFE\u7CFF\u7D00\u7D01\u7D02\u7D03\u7D04\u7D05\u7D06\u7D07\u7D08\u7D09\u7D0B\u7D0C\u7D0D\u7D0E\u7D0F\u7D10\uFFFD\u7D11\u7D12\u7D13\u7D14\u7D15\u7D16\u7D17\u7D18\u7D19\u7D1A\u7D1B\u7D1C\u7D1D\u7D1E\u7D1F\u7D21\u7D23\u7D24\u7D25\u7D26\u7D28\u7D29\u7D2A\u7D2C\u7D2D\u7D2E\u7D30\u7D31\u7D32\u7D33\u7D34\u7D35\u7D36\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D37\u7D38\u7D39\u7D3A\u7D3B\u7D3C\u7D3D\u7D3E\u7D3F\u7D40\u7D41\u7D42\u7D43\u7D44\u7D45\u7D46\u7D47\u7D48\u7D49\u7D4A\u7D4B\u7D4C\u7D4D\u7D4E\u7D4F\u7D50\u7D51\u7D52\u7D53\u7D54\u7D55\u7D56\u7D57\u7D58\u7D59\u7D5A\u7D5B\u7D5C\u7D5D\u7D5E\u7D5F\u7D60\u7D61\u7D62\u7D63\u7D64\u7D65\u7D66\u7D67\u7D68\u7D69\u7D6A\u7D6B\u7D6C\u7D6D\u7D6F\u7D70\u7D71\u7D72\u7D73\u7D74\u7D75\u7D76\uFFFD\u7D78\u7D79\u7D7A\u7D7B\u7D7C\u7D7D\u7D7E\u7D7F\u7D80\u7D81\u7D82\u7D83\u7D84\u7D85\u7D86\u7D87\u7D88\u7D89\u7D8A\u7D8B\u7D8C\u7D8D\u7D8E\u7D8F\u7D90\u7D91\u7D92\u7D93\u7D94\u7D95\u7D96\u7D97\u7D98\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D99\u7D9A\u7D9B\u7D9C\u7D9D\u7D9E\u7D9F\u7DA0\u7DA1\u7DA2\u7DA3\u7DA4\u7DA5\u7DA7\u7DA8\u7DA9\u7DAA\u7DAB\u7DAC\u7DAD\u7DAF\u7DB0\u7DB1\u7DB2\u7DB3\u7DB4\u7DB5\u7DB6\u7DB7\u7DB8\u7DB9\u7DBA\u7DBB\u7DBC\u7DBD\u7DBE\u7DBF\u7DC0\u7DC1\u7DC2\u7DC3\u7DC4\u7DC5\u7DC6\u7DC7\u7DC8\u7DC9\u7DCA\u7DCB\u7DCC\u7DCD\u7DCE\u7DCF\u7DD0\u7DD1\u7DD2\u7DD3\u7DD4\u7DD5\u7DD6\u7DD7\u7DD8\u7DD9\uFFFD\u7DDA\u7DDB\u7DDC\u7DDD\u7DDE\u7DDF\u7DE0\u7DE1\u7DE2\u7DE3\u7DE4\u7DE5\u7DE6\u7DE7\u7DE8\u7DE9\u7DEA\u7DEB\u7DEC\u7DED\u7DEE\u7DEF\u7DF0\u7DF1\u7DF2\u7DF3\u7DF4\u7DF5\u7DF6\u7DF7\u7DF8\u7DF9\u7DFA\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7DFB\u7DFC\u7DFD\u7DFE\u7DFF\u7E00\u7E01\u7E02\u7E03\u7E04\u7E05\u7E06\u7E07\u7E08\u7E09\u7E0A\u7E0B\u7E0C\u7E0D\u7E0E\u7E0F\u7E10\u7E11\u7E12\u7E13\u7E14\u7E15\u7E16\u7E17\u7E18\u7E19\u7E1A\u7E1B\u7E1C\u7E1D\u7E1E\u7E1F\u7E20\u7E21\u7E22\u7E23\u7E24\u7E25\u7E26\u7E27\u7E28\u7E29\u7E2A\u7E2B\u7E2C\u7E2D\u7E2E\u7E2F\u7E30\u7E31\u7E32\u7E33\u7E34\u7E35\u7E36\u7E37\u7E38\u7E39\uFFFD\u7E3A\u7E3C\u7E3D\u7E3E\u7E3F\u7E40\u7E42\u7E43\u7E44\u7E45\u7E46\u7E48\u7E49\u7E4A\u7E4B\u7E4C\u7E4D\u7E4E\u7E4F\u7E50\u7E51\u7E52\u7E53\u7E54\u7E55\u7E56\u7E57\u7E58\u7E59\u7E5A\u7E5B\u7E5C\u7E5D\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E5E\u7E5F\u7E60\u7E61\u7E62\u7E63\u7E64\u7E65\u7E66\u7E67\u7E68\u7E69\u7E6A\u7E6B\u7E6C\u7E6D\u7E6E\u7E6F\u7E70\u7E71\u7E72\u7E73\u7E74\u7E75\u7E76\u7E77\u7E78\u7E79\u7E7A\u7E7B\u7E7C\u7E7D\u7E7E\u7E7F\u7E80\u7E81\u7E83\u7E84\u7E85\u7E86\u7E87\u7E88\u7E89\u7E8A\u7E8B\u7E8C\u7E8D\u7E8E\u7E8F\u7E90\u7E91\u7E92\u7E93\u7E94\u7E95\u7E96\u7E97\u7E98\u7E99\u7E9A\u7E9C\u7E9D\u7E9E\uFFFD\u7EAE\u7EB4\u7EBB\u7EBC\u7ED6\u7EE4\u7EEC\u7EF9\u7F0A\u7F10\u7F1E\u7F37\u7F39\u7F3B\u7F3C\u7F3D\u7F3E\u7F3F\u7F40\u7F41\u7F43\u7F46\u7F47\u7F48\u7F49\u7F4A\u7F4B\u7F4C\u7F4D\u7F4E\u7F4F\u7F52\u7F53\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7F56\u7F59\u7F5B\u7F5C\u7F5D\u7F5E\u7F60\u7F63\u7F64\u7F65\u7F66\u7F67\u7F6B\u7F6C\u7F6D\u7F6F\u7F70\u7F73\u7F75\u7F76\u7F77\u7F78\u7F7A\u7F7B\u7F7C\u7F7D\u7F7F\u7F80\u7F82\u7F83\u7F84\u7F85\u7F86\u7F87\u7F88\u7F89\u7F8B\u7F8D\u7F8F\u7F90\u7F91\u7F92\u7F93\u7F95\u7F96\u7F97\u7F98\u7F99\u7F9B\u7F9C\u7FA0\u7FA2\u7FA3\u7FA5\u7FA6\u7FA8\u7FA9\u7FAA\u7FAB\u7FAC\u7FAD\u7FAE\u7FB1\uFFFD\u7FB3\u7FB4\u7FB5\u7FB6\u7FB7\u7FBA\u7FBB\u7FBE\u7FC0\u7FC2\u7FC3\u7FC4\u7FC6\u7FC7\u7FC8\u7FC9\u7FCB\u7FCD\u7FCF\u7FD0\u7FD1\u7FD2\u7FD3\u7FD6\u7FD7\u7FD9\u7FDA\u7FDB\u7FDC\u7FDD\u7FDE\u7FE2\u7FE3\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7FE4\u7FE7\u7FE8\u7FEA\u7FEB\u7FEC\u7FED\u7FEF\u7FF2\u7FF4\u7FF5\u7FF6\u7FF7\u7FF8\u7FF9\u7FFA\u7FFD\u7FFE\u7FFF\u8002\u8007\u8008\u8009\u800A\u800E\u800F\u8011\u8013\u801A\u801B\u801D\u801E\u801F\u8021\u8023\u8024\u802B\u802C\u802D\u802E\u802F\u8030\u8032\u8034\u8039\u803A\u803C\u803E\u8040\u8041\u8044\u8045\u8047\u8048\u8049\u804E\u804F\u8050\u8051\u8053\u8055\u8056\u8057\uFFFD\u8059\u805B\u805C\u805D\u805E\u805F\u8060\u8061\u8062\u8063\u8064\u8065\u8066\u8067\u8068\u806B\u806C\u806D\u806E\u806F\u8070\u8072\u8073\u8074\u8075\u8076\u8077\u8078\u8079\u807A\u807B\u807C\u807D\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u807E\u8081\u8082\u8085\u8088\u808A\u808D\u808E\u808F\u8090\u8091\u8092\u8094\u8095\u8097\u8099\u809E\u80A3\u80A6\u80A7\u80A8\u80AC\u80B0\u80B3\u80B5\u80B6\u80B8\u80B9\u80BB\u80C5\u80C7\u80C8\u80C9\u80CA\u80CB\u80CF\u80D0\u80D1\u80D2\u80D3\u80D4\u80D5\u80D8\u80DF\u80E0\u80E2\u80E3\u80E6\u80EE\u80F5\u80F7\u80F9\u80FB\u80FE\u80FF\u8100\u8101\u8103\u8104\u8105\u8107\u8108\u810B\uFFFD\u810C\u8115\u8117\u8119\u811B\u811C\u811D\u811F\u8120\u8121\u8122\u8123\u8124\u8125\u8126\u8127\u8128\u8129\u812A\u812B\u812D\u812E\u8130\u8133\u8134\u8135\u8137\u8139\u813A\u813B\u813C\u813D\u813F\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8140\u8141\u8142\u8143\u8144\u8145\u8147\u8149\u814D\u814E\u814F\u8152\u8156\u8157\u8158\u815B\u815C\u815D\u815E\u815F\u8161\u8162\u8163\u8164\u8166\u8168\u816A\u816B\u816C\u816F\u8172\u8173\u8175\u8176\u8177\u8178\u8181\u8183\u8184\u8185\u8186\u8187\u8189\u818B\u818C\u818D\u818E\u8190\u8192\u8193\u8194\u8195\u8196\u8197\u8199\u819A\u819E\u819F\u81A0\u81A1\u81A2\u81A4\u81A5\uFFFD\u81A7\u81A9\u81AB\u81AC\u81AD\u81AE\u81AF\u81B0\u81B1\u81B2\u81B4\u81B5\u81B6\u81B7\u81B8\u81B9\u81BC\u81BD\u81BE\u81BF\u81C4\u81C5\u81C7\u81C8\u81C9\u81CB\u81CD\u81CE\u81CF\u81D0\u81D1\u81D2\u81D3\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u81D4\u81D5\u81D6\u81D7\u81D8\u81D9\u81DA\u81DB\u81DC\u81DD\u81DE\u81DF\u81E0\u81E1\u81E2\u81E4\u81E5\u81E6\u81E8\u81E9\u81EB\u81EE\u81EF\u81F0\u81F1\u81F2\u81F5\u81F6\u81F7\u81F8\u81F9\u81FA\u81FD\u81FF\u8203\u8207\u8208\u8209\u820A\u820B\u820E\u820F\u8211\u8213\u8215\u8216\u8217\u8218\u8219\u821A\u821D\u8220\u8224\u8225\u8226\u8227\u8229\u822E\u8232\u823A\u823C\u823D\u823F\uFFFD\u8240\u8241\u8242\u8243\u8245\u8246\u8248\u824A\u824C\u824D\u824E\u8250\u8251\u8252\u8253\u8254\u8255\u8256\u8257\u8259\u825B\u825C\u825D\u825E\u8260\u8261\u8262\u8263\u8264\u8265\u8266\u8267\u8269\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u826A\u826B\u826C\u826D\u8271\u8275\u8276\u8277\u8278\u827B\u827C\u8280\u8281\u8283\u8285\u8286\u8287\u8289\u828C\u8290\u8293\u8294\u8295\u8296\u829A\u829B\u829E\u82A0\u82A2\u82A3\u82A7\u82B2\u82B5\u82B6\u82BA\u82BB\u82BC\u82BF\u82C0\u82C2\u82C3\u82C5\u82C6\u82C9\u82D0\u82D6\u82D9\u82DA\u82DD\u82E2\u82E7\u82E8\u82E9\u82EA\u82EC\u82ED\u82EE\u82F0\u82F2\u82F3\u82F5\u82F6\u82F8\uFFFD\u82FA\u82FC\u82FD\u82FE\u82FF\u8300\u830A\u830B\u830D\u8310\u8312\u8313\u8316\u8318\u8319\u831D\u831E\u831F\u8320\u8321\u8322\u8323\u8324\u8325\u8326\u8329\u832A\u832E\u8330\u8332\u8337\u833B\u833D\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[199] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u833E\u833F\u8341\u8342\u8344\u8345\u8348\u834A\u834B\u834C\u834D\u834E\u8353\u8355\u8356\u8357\u8358\u8359\u835D\u8362\u8370\u8371\u8372\u8373\u8374\u8375\u8376\u8379\u837A\u837E\u837F\u8380\u8381\u8382\u8383\u8384\u8387\u8388\u838A\u838B\u838C\u838D\u838F\u8390\u8391\u8394\u8395\u8396\u8397\u8399\u839A\u839D\u839F\u83A1\u83A2\u83A3\u83A4\u83A5\u83A6\u83A7\u83AC\u83AD\u83AE\uFFFD\u83AF\u83B5\u83BB\u83BE\u83BF\u83C2\u83C3\u83C4\u83C6\u83C8\u83C9\u83CB\u83CD\u83CE\u83D0\u83D1\u83D2\u83D3\u83D5\u83D7\u83D9\u83DA\u83DB\u83DE\u83E2\u83E3\u83E4\u83E6\u83E7\u83E8\u83EB\u83EC\u83ED\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20\uFFFD".split("");
    for(j = 0; j != D[199].length; ++j)if (D[199][j].charCodeAt(0) !== 0xFFFD) {
        e[D[199][j]] = 50944 + j;
        d[50944 + j] = D[199][j];
    }
    D[200] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u83EE\u83EF\u83F3\u83F4\u83F5\u83F6\u83F7\u83FA\u83FB\u83FC\u83FE\u83FF\u8400\u8402\u8405\u8407\u8408\u8409\u840A\u8410\u8412\u8413\u8414\u8415\u8416\u8417\u8419\u841A\u841B\u841E\u841F\u8420\u8421\u8422\u8423\u8429\u842A\u842B\u842C\u842D\u842E\u842F\u8430\u8432\u8433\u8434\u8435\u8436\u8437\u8439\u843A\u843B\u843E\u843F\u8440\u8441\u8442\u8443\u8444\u8445\u8447\u8448\u8449\uFFFD\u844A\u844B\u844C\u844D\u844E\u844F\u8450\u8452\u8453\u8454\u8455\u8456\u8458\u845D\u845E\u845F\u8460\u8462\u8464\u8465\u8466\u8467\u8468\u846A\u846E\u846F\u8470\u8472\u8474\u8477\u8479\u847B\u847C\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1\uFFFD".split("");
    for(j = 0; j != D[200].length; ++j)if (D[200][j].charCodeAt(0) !== 0xFFFD) {
        e[D[200][j]] = 51200 + j;
        d[51200 + j] = D[200][j];
    }
    D[201] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u847D\u847E\u847F\u8480\u8481\u8483\u8484\u8485\u8486\u848A\u848D\u848F\u8490\u8491\u8492\u8493\u8494\u8495\u8496\u8498\u849A\u849B\u849D\u849E\u849F\u84A0\u84A2\u84A3\u84A4\u84A5\u84A6\u84A7\u84A8\u84A9\u84AA\u84AB\u84AC\u84AD\u84AE\u84B0\u84B1\u84B3\u84B5\u84B6\u84B7\u84BB\u84BC\u84BE\u84C0\u84C2\u84C3\u84C5\u84C6\u84C7\u84C8\u84CB\u84CC\u84CE\u84CF\u84D2\u84D4\u84D5\u84D7\uFFFD\u84D8\u84D9\u84DA\u84DB\u84DC\u84DE\u84E1\u84E2\u84E4\u84E7\u84E8\u84E9\u84EA\u84EB\u84ED\u84EE\u84EF\u84F1\u84F2\u84F3\u84F4\u84F5\u84F6\u84F7\u84F8\u84F9\u84FA\u84FB\u84FD\u84FE\u8500\u8501\u8502\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3\uFFFD".split("");
    for(j = 0; j != D[201].length; ++j)if (D[201][j].charCodeAt(0) !== 0xFFFD) {
        e[D[201][j]] = 51456 + j;
        d[51456 + j] = D[201][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8503\u8504\u8505\u8506\u8507\u8508\u8509\u850A\u850B\u850D\u850E\u850F\u8510\u8512\u8514\u8515\u8516\u8518\u8519\u851B\u851C\u851D\u851E\u8520\u8522\u8523\u8524\u8525\u8526\u8527\u8528\u8529\u852A\u852D\u852E\u852F\u8530\u8531\u8532\u8533\u8534\u8535\u8536\u853E\u853F\u8540\u8541\u8542\u8544\u8545\u8546\u8547\u854B\u854C\u854D\u854E\u854F\u8550\u8551\u8552\u8553\u8554\u8555\uFFFD\u8557\u8558\u855A\u855B\u855C\u855D\u855F\u8560\u8561\u8562\u8563\u8565\u8566\u8567\u8569\u856A\u856B\u856C\u856D\u856E\u856F\u8570\u8571\u8573\u8575\u8576\u8577\u8578\u857C\u857D\u857F\u8580\u8581\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8582\u8583\u8586\u8588\u8589\u858A\u858B\u858C\u858D\u858E\u8590\u8591\u8592\u8593\u8594\u8595\u8596\u8597\u8598\u8599\u859A\u859D\u859E\u859F\u85A0\u85A1\u85A2\u85A3\u85A5\u85A6\u85A7\u85A9\u85AB\u85AC\u85AD\u85B1\u85B2\u85B3\u85B4\u85B5\u85B6\u85B8\u85BA\u85BB\u85BC\u85BD\u85BE\u85BF\u85C0\u85C2\u85C3\u85C4\u85C5\u85C6\u85C7\u85C8\u85CA\u85CB\u85CC\u85CD\u85CE\u85D1\u85D2\uFFFD\u85D4\u85D6\u85D7\u85D8\u85D9\u85DA\u85DB\u85DD\u85DE\u85DF\u85E0\u85E1\u85E2\u85E3\u85E5\u85E6\u85E7\u85E8\u85EA\u85EB\u85EC\u85ED\u85EE\u85EF\u85F0\u85F1\u85F2\u85F3\u85F4\u85F5\u85F6\u85F7\u85F8\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u85F9\u85FA\u85FC\u85FD\u85FE\u8600\u8601\u8602\u8603\u8604\u8606\u8607\u8608\u8609\u860A\u860B\u860C\u860D\u860E\u860F\u8610\u8612\u8613\u8614\u8615\u8617\u8618\u8619\u861A\u861B\u861C\u861D\u861E\u861F\u8620\u8621\u8622\u8623\u8624\u8625\u8626\u8628\u862A\u862B\u862C\u862D\u862E\u862F\u8630\u8631\u8632\u8633\u8634\u8635\u8636\u8637\u8639\u863A\u863B\u863D\u863E\u863F\u8640\uFFFD\u8641\u8642\u8643\u8644\u8645\u8646\u8647\u8648\u8649\u864A\u864B\u864C\u8652\u8653\u8655\u8656\u8657\u8658\u8659\u865B\u865C\u865D\u865F\u8660\u8661\u8663\u8664\u8665\u8666\u8667\u8668\u8669\u866A\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u866D\u866F\u8670\u8672\u8673\u8674\u8675\u8676\u8677\u8678\u8683\u8684\u8685\u8686\u8687\u8688\u8689\u868E\u868F\u8690\u8691\u8692\u8694\u8696\u8697\u8698\u8699\u869A\u869B\u869E\u869F\u86A0\u86A1\u86A2\u86A5\u86A6\u86AB\u86AD\u86AE\u86B2\u86B3\u86B7\u86B8\u86B9\u86BB\u86BC\u86BD\u86BE\u86BF\u86C1\u86C2\u86C3\u86C5\u86C8\u86CC\u86CD\u86D2\u86D3\u86D5\u86D6\u86D7\u86DA\u86DC\uFFFD\u86DD\u86E0\u86E1\u86E2\u86E3\u86E5\u86E6\u86E7\u86E8\u86EA\u86EB\u86EC\u86EF\u86F5\u86F6\u86F7\u86FA\u86FB\u86FC\u86FD\u86FF\u8701\u8704\u8705\u8706\u870B\u870C\u870E\u870F\u8710\u8711\u8714\u8716\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8719\u871B\u871D\u871F\u8720\u8724\u8726\u8727\u8728\u872A\u872B\u872C\u872D\u872F\u8730\u8732\u8733\u8735\u8736\u8738\u8739\u873A\u873C\u873D\u8740\u8741\u8742\u8743\u8744\u8745\u8746\u874A\u874B\u874D\u874F\u8750\u8751\u8752\u8754\u8755\u8756\u8758\u875A\u875B\u875C\u875D\u875E\u875F\u8761\u8762\u8766\u8767\u8768\u8769\u876A\u876B\u876C\u876D\u876F\u8771\u8772\u8773\u8775\uFFFD\u8777\u8778\u8779\u877A\u877F\u8780\u8781\u8784\u8786\u8787\u8789\u878A\u878C\u878E\u878F\u8790\u8791\u8792\u8794\u8795\u8796\u8798\u8799\u879A\u879B\u879C\u879D\u879E\u87A0\u87A1\u87A2\u87A3\u87A4\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u87A5\u87A6\u87A7\u87A9\u87AA\u87AE\u87B0\u87B1\u87B2\u87B4\u87B6\u87B7\u87B8\u87B9\u87BB\u87BC\u87BE\u87BF\u87C1\u87C2\u87C3\u87C4\u87C5\u87C7\u87C8\u87C9\u87CC\u87CD\u87CE\u87CF\u87D0\u87D4\u87D5\u87D6\u87D7\u87D8\u87D9\u87DA\u87DC\u87DD\u87DE\u87DF\u87E1\u87E2\u87E3\u87E4\u87E6\u87E7\u87E8\u87E9\u87EB\u87EC\u87ED\u87EF\u87F0\u87F1\u87F2\u87F3\u87F4\u87F5\u87F6\u87F7\u87F8\uFFFD\u87FA\u87FB\u87FC\u87FD\u87FF\u8800\u8801\u8802\u8804\u8805\u8806\u8807\u8808\u8809\u880B\u880C\u880D\u880E\u880F\u8810\u8811\u8812\u8814\u8817\u8818\u8819\u881A\u881C\u881D\u881E\u881F\u8820\u8823\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8824\u8825\u8826\u8827\u8828\u8829\u882A\u882B\u882C\u882D\u882E\u882F\u8830\u8831\u8833\u8834\u8835\u8836\u8837\u8838\u883A\u883B\u883D\u883E\u883F\u8841\u8842\u8843\u8846\u8847\u8848\u8849\u884A\u884B\u884E\u884F\u8850\u8851\u8852\u8853\u8855\u8856\u8858\u885A\u885B\u885C\u885D\u885E\u885F\u8860\u8866\u8867\u886A\u886D\u886F\u8871\u8873\u8874\u8875\u8876\u8878\u8879\u887A\uFFFD\u887B\u887C\u8880\u8883\u8886\u8887\u8889\u888A\u888C\u888E\u888F\u8890\u8891\u8893\u8894\u8895\u8897\u8898\u8899\u889A\u889B\u889D\u889E\u889F\u88A0\u88A1\u88A3\u88A5\u88A6\u88A7\u88A8\u88A9\u88AA\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u88AC\u88AE\u88AF\u88B0\u88B2\u88B3\u88B4\u88B5\u88B6\u88B8\u88B9\u88BA\u88BB\u88BD\u88BE\u88BF\u88C0\u88C3\u88C4\u88C7\u88C8\u88CA\u88CB\u88CC\u88CD\u88CF\u88D0\u88D1\u88D3\u88D6\u88D7\u88DA\u88DB\u88DC\u88DD\u88DE\u88E0\u88E1\u88E6\u88E7\u88E9\u88EA\u88EB\u88EC\u88ED\u88EE\u88EF\u88F2\u88F5\u88F6\u88F7\u88FA\u88FB\u88FD\u88FF\u8900\u8901\u8903\u8904\u8905\u8906\u8907\u8908\uFFFD\u8909\u890B\u890C\u890D\u890E\u890F\u8911\u8914\u8915\u8916\u8917\u8918\u891C\u891D\u891E\u891F\u8920\u8922\u8923\u8924\u8926\u8927\u8928\u8929\u892C\u892D\u892E\u892F\u8931\u8932\u8933\u8935\u8937\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8938\u8939\u893A\u893B\u893C\u893D\u893E\u893F\u8940\u8942\u8943\u8945\u8946\u8947\u8948\u8949\u894A\u894B\u894C\u894D\u894E\u894F\u8950\u8951\u8952\u8953\u8954\u8955\u8956\u8957\u8958\u8959\u895A\u895B\u895C\u895D\u8960\u8961\u8962\u8963\u8964\u8965\u8967\u8968\u8969\u896A\u896B\u896C\u896D\u896E\u896F\u8970\u8971\u8972\u8973\u8974\u8975\u8976\u8977\u8978\u8979\u897A\u897C\uFFFD\u897D\u897E\u8980\u8982\u8984\u8985\u8987\u8988\u8989\u898A\u898B\u898C\u898D\u898E\u898F\u8990\u8991\u8992\u8993\u8994\u8995\u8996\u8997\u8998\u8999\u899A\u899B\u899C\u899D\u899E\u899F\u89A0\u89A1\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u89A2\u89A3\u89A4\u89A5\u89A6\u89A7\u89A8\u89A9\u89AA\u89AB\u89AC\u89AD\u89AE\u89AF\u89B0\u89B1\u89B2\u89B3\u89B4\u89B5\u89B6\u89B7\u89B8\u89B9\u89BA\u89BB\u89BC\u89BD\u89BE\u89BF\u89C0\u89C3\u89CD\u89D3\u89D4\u89D5\u89D7\u89D8\u89D9\u89DB\u89DD\u89DF\u89E0\u89E1\u89E2\u89E4\u89E7\u89E8\u89E9\u89EA\u89EC\u89ED\u89EE\u89F0\u89F1\u89F2\u89F4\u89F5\u89F6\u89F7\u89F8\u89F9\u89FA\uFFFD\u89FB\u89FC\u89FD\u89FE\u89FF\u8A01\u8A02\u8A03\u8A04\u8A05\u8A06\u8A08\u8A09\u8A0A\u8A0B\u8A0C\u8A0D\u8A0E\u8A0F\u8A10\u8A11\u8A12\u8A13\u8A14\u8A15\u8A16\u8A17\u8A18\u8A19\u8A1A\u8A1B\u8A1C\u8A1D\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8A1E\u8A1F\u8A20\u8A21\u8A22\u8A23\u8A24\u8A25\u8A26\u8A27\u8A28\u8A29\u8A2A\u8A2B\u8A2C\u8A2D\u8A2E\u8A2F\u8A30\u8A31\u8A32\u8A33\u8A34\u8A35\u8A36\u8A37\u8A38\u8A39\u8A3A\u8A3B\u8A3C\u8A3D\u8A3F\u8A40\u8A41\u8A42\u8A43\u8A44\u8A45\u8A46\u8A47\u8A49\u8A4A\u8A4B\u8A4C\u8A4D\u8A4E\u8A4F\u8A50\u8A51\u8A52\u8A53\u8A54\u8A55\u8A56\u8A57\u8A58\u8A59\u8A5A\u8A5B\u8A5C\u8A5D\u8A5E\uFFFD\u8A5F\u8A60\u8A61\u8A62\u8A63\u8A64\u8A65\u8A66\u8A67\u8A68\u8A69\u8A6A\u8A6B\u8A6C\u8A6D\u8A6E\u8A6F\u8A70\u8A71\u8A72\u8A73\u8A74\u8A75\u8A76\u8A77\u8A78\u8A7A\u8A7B\u8A7C\u8A7D\u8A7E\u8A7F\u8A80\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8A81\u8A82\u8A83\u8A84\u8A85\u8A86\u8A87\u8A88\u8A8B\u8A8C\u8A8D\u8A8E\u8A8F\u8A90\u8A91\u8A92\u8A94\u8A95\u8A96\u8A97\u8A98\u8A99\u8A9A\u8A9B\u8A9C\u8A9D\u8A9E\u8A9F\u8AA0\u8AA1\u8AA2\u8AA3\u8AA4\u8AA5\u8AA6\u8AA7\u8AA8\u8AA9\u8AAA\u8AAB\u8AAC\u8AAD\u8AAE\u8AAF\u8AB0\u8AB1\u8AB2\u8AB3\u8AB4\u8AB5\u8AB6\u8AB7\u8AB8\u8AB9\u8ABA\u8ABB\u8ABC\u8ABD\u8ABE\u8ABF\u8AC0\u8AC1\u8AC2\uFFFD\u8AC3\u8AC4\u8AC5\u8AC6\u8AC7\u8AC8\u8AC9\u8ACA\u8ACB\u8ACC\u8ACD\u8ACE\u8ACF\u8AD0\u8AD1\u8AD2\u8AD3\u8AD4\u8AD5\u8AD6\u8AD7\u8AD8\u8AD9\u8ADA\u8ADB\u8ADC\u8ADD\u8ADE\u8ADF\u8AE0\u8AE1\u8AE2\u8AE3\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AE4\u8AE5\u8AE6\u8AE7\u8AE8\u8AE9\u8AEA\u8AEB\u8AEC\u8AED\u8AEE\u8AEF\u8AF0\u8AF1\u8AF2\u8AF3\u8AF4\u8AF5\u8AF6\u8AF7\u8AF8\u8AF9\u8AFA\u8AFB\u8AFC\u8AFD\u8AFE\u8AFF\u8B00\u8B01\u8B02\u8B03\u8B04\u8B05\u8B06\u8B08\u8B09\u8B0A\u8B0B\u8B0C\u8B0D\u8B0E\u8B0F\u8B10\u8B11\u8B12\u8B13\u8B14\u8B15\u8B16\u8B17\u8B18\u8B19\u8B1A\u8B1B\u8B1C\u8B1D\u8B1E\u8B1F\u8B20\u8B21\u8B22\u8B23\uFFFD\u8B24\u8B25\u8B27\u8B28\u8B29\u8B2A\u8B2B\u8B2C\u8B2D\u8B2E\u8B2F\u8B30\u8B31\u8B32\u8B33\u8B34\u8B35\u8B36\u8B37\u8B38\u8B39\u8B3A\u8B3B\u8B3C\u8B3D\u8B3E\u8B3F\u8B40\u8B41\u8B42\u8B43\u8B44\u8B45\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B46\u8B47\u8B48\u8B49\u8B4A\u8B4B\u8B4C\u8B4D\u8B4E\u8B4F\u8B50\u8B51\u8B52\u8B53\u8B54\u8B55\u8B56\u8B57\u8B58\u8B59\u8B5A\u8B5B\u8B5C\u8B5D\u8B5E\u8B5F\u8B60\u8B61\u8B62\u8B63\u8B64\u8B65\u8B67\u8B68\u8B69\u8B6A\u8B6B\u8B6D\u8B6E\u8B6F\u8B70\u8B71\u8B72\u8B73\u8B74\u8B75\u8B76\u8B77\u8B78\u8B79\u8B7A\u8B7B\u8B7C\u8B7D\u8B7E\u8B7F\u8B80\u8B81\u8B82\u8B83\u8B84\u8B85\u8B86\uFFFD\u8B87\u8B88\u8B89\u8B8A\u8B8B\u8B8C\u8B8D\u8B8E\u8B8F\u8B90\u8B91\u8B92\u8B93\u8B94\u8B95\u8B96\u8B97\u8B98\u8B99\u8B9A\u8B9B\u8B9C\u8B9D\u8B9E\u8B9F\u8BAC\u8BB1\u8BBB\u8BC7\u8BD0\u8BEA\u8C09\u8C1E\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8C38\u8C39\u8C3A\u8C3B\u8C3C\u8C3D\u8C3E\u8C3F\u8C40\u8C42\u8C43\u8C44\u8C45\u8C48\u8C4A\u8C4B\u8C4D\u8C4E\u8C4F\u8C50\u8C51\u8C52\u8C53\u8C54\u8C56\u8C57\u8C58\u8C59\u8C5B\u8C5C\u8C5D\u8C5E\u8C5F\u8C60\u8C63\u8C64\u8C65\u8C66\u8C67\u8C68\u8C69\u8C6C\u8C6D\u8C6E\u8C6F\u8C70\u8C71\u8C72\u8C74\u8C75\u8C76\u8C77\u8C7B\u8C7C\u8C7D\u8C7E\u8C7F\u8C80\u8C81\u8C83\u8C84\u8C86\u8C87\uFFFD\u8C88\u8C8B\u8C8D\u8C8E\u8C8F\u8C90\u8C91\u8C92\u8C93\u8C95\u8C96\u8C97\u8C99\u8C9A\u8C9B\u8C9C\u8C9D\u8C9E\u8C9F\u8CA0\u8CA1\u8CA2\u8CA3\u8CA4\u8CA5\u8CA6\u8CA7\u8CA8\u8CA9\u8CAA\u8CAB\u8CAC\u8CAD\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8CAE\u8CAF\u8CB0\u8CB1\u8CB2\u8CB3\u8CB4\u8CB5\u8CB6\u8CB7\u8CB8\u8CB9\u8CBA\u8CBB\u8CBC\u8CBD\u8CBE\u8CBF\u8CC0\u8CC1\u8CC2\u8CC3\u8CC4\u8CC5\u8CC6\u8CC7\u8CC8\u8CC9\u8CCA\u8CCB\u8CCC\u8CCD\u8CCE\u8CCF\u8CD0\u8CD1\u8CD2\u8CD3\u8CD4\u8CD5\u8CD6\u8CD7\u8CD8\u8CD9\u8CDA\u8CDB\u8CDC\u8CDD\u8CDE\u8CDF\u8CE0\u8CE1\u8CE2\u8CE3\u8CE4\u8CE5\u8CE6\u8CE7\u8CE8\u8CE9\u8CEA\u8CEB\u8CEC\uFFFD\u8CED\u8CEE\u8CEF\u8CF0\u8CF1\u8CF2\u8CF3\u8CF4\u8CF5\u8CF6\u8CF7\u8CF8\u8CF9\u8CFA\u8CFB\u8CFC\u8CFD\u8CFE\u8CFF\u8D00\u8D01\u8D02\u8D03\u8D04\u8D05\u8D06\u8D07\u8D08\u8D09\u8D0A\u8D0B\u8D0C\u8D0D\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8D0E\u8D0F\u8D10\u8D11\u8D12\u8D13\u8D14\u8D15\u8D16\u8D17\u8D18\u8D19\u8D1A\u8D1B\u8D1C\u8D20\u8D51\u8D52\u8D57\u8D5F\u8D65\u8D68\u8D69\u8D6A\u8D6C\u8D6E\u8D6F\u8D71\u8D72\u8D78\u8D79\u8D7A\u8D7B\u8D7C\u8D7D\u8D7E\u8D7F\u8D80\u8D82\u8D83\u8D86\u8D87\u8D88\u8D89\u8D8C\u8D8D\u8D8E\u8D8F\u8D90\u8D92\u8D93\u8D95\u8D96\u8D97\u8D98\u8D99\u8D9A\u8D9B\u8D9C\u8D9D\u8D9E\u8DA0\u8DA1\uFFFD\u8DA2\u8DA4\u8DA5\u8DA6\u8DA7\u8DA8\u8DA9\u8DAA\u8DAB\u8DAC\u8DAD\u8DAE\u8DAF\u8DB0\u8DB2\u8DB6\u8DB7\u8DB9\u8DBB\u8DBD\u8DC0\u8DC1\u8DC2\u8DC5\u8DC7\u8DC8\u8DC9\u8DCA\u8DCD\u8DD0\u8DD2\u8DD3\u8DD4\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8DD5\u8DD8\u8DD9\u8DDC\u8DE0\u8DE1\u8DE2\u8DE5\u8DE6\u8DE7\u8DE9\u8DED\u8DEE\u8DF0\u8DF1\u8DF2\u8DF4\u8DF6\u8DFC\u8DFE\u8DFF\u8E00\u8E01\u8E02\u8E03\u8E04\u8E06\u8E07\u8E08\u8E0B\u8E0D\u8E0E\u8E10\u8E11\u8E12\u8E13\u8E15\u8E16\u8E17\u8E18\u8E19\u8E1A\u8E1B\u8E1C\u8E20\u8E21\u8E24\u8E25\u8E26\u8E27\u8E28\u8E2B\u8E2D\u8E30\u8E32\u8E33\u8E34\u8E36\u8E37\u8E38\u8E3B\u8E3C\u8E3E\uFFFD\u8E3F\u8E43\u8E45\u8E46\u8E4C\u8E4D\u8E4E\u8E4F\u8E50\u8E53\u8E54\u8E55\u8E56\u8E57\u8E58\u8E5A\u8E5B\u8E5C\u8E5D\u8E5E\u8E5F\u8E60\u8E61\u8E62\u8E63\u8E64\u8E65\u8E67\u8E68\u8E6A\u8E6B\u8E6E\u8E71\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E73\u8E75\u8E77\u8E78\u8E79\u8E7A\u8E7B\u8E7D\u8E7E\u8E80\u8E82\u8E83\u8E84\u8E86\u8E88\u8E89\u8E8A\u8E8B\u8E8C\u8E8D\u8E8E\u8E91\u8E92\u8E93\u8E95\u8E96\u8E97\u8E98\u8E99\u8E9A\u8E9B\u8E9D\u8E9F\u8EA0\u8EA1\u8EA2\u8EA3\u8EA4\u8EA5\u8EA6\u8EA7\u8EA8\u8EA9\u8EAA\u8EAD\u8EAE\u8EB0\u8EB1\u8EB3\u8EB4\u8EB5\u8EB6\u8EB7\u8EB8\u8EB9\u8EBB\u8EBC\u8EBD\u8EBE\u8EBF\u8EC0\u8EC1\u8EC2\uFFFD\u8EC3\u8EC4\u8EC5\u8EC6\u8EC7\u8EC8\u8EC9\u8ECA\u8ECB\u8ECC\u8ECD\u8ECF\u8ED0\u8ED1\u8ED2\u8ED3\u8ED4\u8ED5\u8ED6\u8ED7\u8ED8\u8ED9\u8EDA\u8EDB\u8EDC\u8EDD\u8EDE\u8EDF\u8EE0\u8EE1\u8EE2\u8EE3\u8EE4\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8EE5\u8EE6\u8EE7\u8EE8\u8EE9\u8EEA\u8EEB\u8EEC\u8EED\u8EEE\u8EEF\u8EF0\u8EF1\u8EF2\u8EF3\u8EF4\u8EF5\u8EF6\u8EF7\u8EF8\u8EF9\u8EFA\u8EFB\u8EFC\u8EFD\u8EFE\u8EFF\u8F00\u8F01\u8F02\u8F03\u8F04\u8F05\u8F06\u8F07\u8F08\u8F09\u8F0A\u8F0B\u8F0C\u8F0D\u8F0E\u8F0F\u8F10\u8F11\u8F12\u8F13\u8F14\u8F15\u8F16\u8F17\u8F18\u8F19\u8F1A\u8F1B\u8F1C\u8F1D\u8F1E\u8F1F\u8F20\u8F21\u8F22\u8F23\uFFFD\u8F24\u8F25\u8F26\u8F27\u8F28\u8F29\u8F2A\u8F2B\u8F2C\u8F2D\u8F2E\u8F2F\u8F30\u8F31\u8F32\u8F33\u8F34\u8F35\u8F36\u8F37\u8F38\u8F39\u8F3A\u8F3B\u8F3C\u8F3D\u8F3E\u8F3F\u8F40\u8F41\u8F42\u8F43\u8F44\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F45\u8F46\u8F47\u8F48\u8F49\u8F4A\u8F4B\u8F4C\u8F4D\u8F4E\u8F4F\u8F50\u8F51\u8F52\u8F53\u8F54\u8F55\u8F56\u8F57\u8F58\u8F59\u8F5A\u8F5B\u8F5C\u8F5D\u8F5E\u8F5F\u8F60\u8F61\u8F62\u8F63\u8F64\u8F65\u8F6A\u8F80\u8F8C\u8F92\u8F9D\u8FA0\u8FA1\u8FA2\u8FA4\u8FA5\u8FA6\u8FA7\u8FAA\u8FAC\u8FAD\u8FAE\u8FAF\u8FB2\u8FB3\u8FB4\u8FB5\u8FB7\u8FB8\u8FBA\u8FBB\u8FBC\u8FBF\u8FC0\u8FC3\u8FC6\uFFFD\u8FC9\u8FCA\u8FCB\u8FCC\u8FCD\u8FCF\u8FD2\u8FD6\u8FD7\u8FDA\u8FE0\u8FE1\u8FE3\u8FE7\u8FEC\u8FEF\u8FF1\u8FF2\u8FF4\u8FF5\u8FF6\u8FFA\u8FFB\u8FFC\u8FFE\u8FFF\u9007\u9008\u900C\u900E\u9013\u9015\u9018\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9019\u901C\u9023\u9024\u9025\u9027\u9028\u9029\u902A\u902B\u902C\u9030\u9031\u9032\u9033\u9034\u9037\u9039\u903A\u903D\u903F\u9040\u9043\u9045\u9046\u9048\u9049\u904A\u904B\u904C\u904E\u9054\u9055\u9056\u9059\u905A\u905C\u905D\u905E\u905F\u9060\u9061\u9064\u9066\u9067\u9069\u906A\u906B\u906C\u906F\u9070\u9071\u9072\u9073\u9076\u9077\u9078\u9079\u907A\u907B\u907C\u907E\u9081\uFFFD\u9084\u9085\u9086\u9087\u9089\u908A\u908C\u908D\u908E\u908F\u9090\u9092\u9094\u9096\u9098\u909A\u909C\u909E\u909F\u90A0\u90A4\u90A5\u90A7\u90A8\u90A9\u90AB\u90AD\u90B2\u90B7\u90BC\u90BD\u90BF\u90C0\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90C2\u90C3\u90C6\u90C8\u90C9\u90CB\u90CC\u90CD\u90D2\u90D4\u90D5\u90D6\u90D8\u90D9\u90DA\u90DE\u90DF\u90E0\u90E3\u90E4\u90E5\u90E9\u90EA\u90EC\u90EE\u90F0\u90F1\u90F2\u90F3\u90F5\u90F6\u90F7\u90F9\u90FA\u90FB\u90FC\u90FF\u9100\u9101\u9103\u9105\u9106\u9107\u9108\u9109\u910A\u910B\u910C\u910D\u910E\u910F\u9110\u9111\u9112\u9113\u9114\u9115\u9116\u9117\u9118\u911A\u911B\u911C\uFFFD\u911D\u911F\u9120\u9121\u9124\u9125\u9126\u9127\u9128\u9129\u912A\u912B\u912C\u912D\u912E\u9130\u9132\u9133\u9134\u9135\u9136\u9137\u9138\u913A\u913B\u913C\u913D\u913E\u913F\u9140\u9141\u9142\u9144\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9145\u9147\u9148\u9151\u9153\u9154\u9155\u9156\u9158\u9159\u915B\u915C\u915F\u9160\u9166\u9167\u9168\u916B\u916D\u9173\u917A\u917B\u917C\u9180\u9181\u9182\u9183\u9184\u9186\u9188\u918A\u918E\u918F\u9193\u9194\u9195\u9196\u9197\u9198\u9199\u919C\u919D\u919E\u919F\u91A0\u91A1\u91A4\u91A5\u91A6\u91A7\u91A8\u91A9\u91AB\u91AC\u91B0\u91B1\u91B2\u91B3\u91B6\u91B7\u91B8\u91B9\u91BB\uFFFD\u91BC\u91BD\u91BE\u91BF\u91C0\u91C1\u91C2\u91C3\u91C4\u91C5\u91C6\u91C8\u91CB\u91D0\u91D2\u91D3\u91D4\u91D5\u91D6\u91D7\u91D8\u91D9\u91DA\u91DB\u91DD\u91DE\u91DF\u91E0\u91E1\u91E2\u91E3\u91E4\u91E5\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u91E6\u91E7\u91E8\u91E9\u91EA\u91EB\u91EC\u91ED\u91EE\u91EF\u91F0\u91F1\u91F2\u91F3\u91F4\u91F5\u91F6\u91F7\u91F8\u91F9\u91FA\u91FB\u91FC\u91FD\u91FE\u91FF\u9200\u9201\u9202\u9203\u9204\u9205\u9206\u9207\u9208\u9209\u920A\u920B\u920C\u920D\u920E\u920F\u9210\u9211\u9212\u9213\u9214\u9215\u9216\u9217\u9218\u9219\u921A\u921B\u921C\u921D\u921E\u921F\u9220\u9221\u9222\u9223\u9224\uFFFD\u9225\u9226\u9227\u9228\u9229\u922A\u922B\u922C\u922D\u922E\u922F\u9230\u9231\u9232\u9233\u9234\u9235\u9236\u9237\u9238\u9239\u923A\u923B\u923C\u923D\u923E\u923F\u9240\u9241\u9242\u9243\u9244\u9245\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967\u9968\u9969\u996A\u996B\u996C\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9246\u9247\u9248\u9249\u924A\u924B\u924C\u924D\u924E\u924F\u9250\u9251\u9252\u9253\u9254\u9255\u9256\u9257\u9258\u9259\u925A\u925B\u925C\u925D\u925E\u925F\u9260\u9261\u9262\u9263\u9264\u9265\u9266\u9267\u9268\u9269\u926A\u926B\u926C\u926D\u926E\u926F\u9270\u9271\u9272\u9273\u9275\u9276\u9277\u9278\u9279\u927A\u927B\u927C\u927D\u927E\u927F\u9280\u9281\u9282\u9283\u9284\u9285\uFFFD\u9286\u9287\u9288\u9289\u928A\u928B\u928C\u928D\u928F\u9290\u9291\u9292\u9293\u9294\u9295\u9296\u9297\u9298\u9299\u929A\u929B\u929C\u929D\u929E\u929F\u92A0\u92A1\u92A2\u92A3\u92A4\u92A5\u92A6\u92A7\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u92A8\u92A9\u92AA\u92AB\u92AC\u92AD\u92AF\u92B0\u92B1\u92B2\u92B3\u92B4\u92B5\u92B6\u92B7\u92B8\u92B9\u92BA\u92BB\u92BC\u92BD\u92BE\u92BF\u92C0\u92C1\u92C2\u92C3\u92C4\u92C5\u92C6\u92C7\u92C9\u92CA\u92CB\u92CC\u92CD\u92CE\u92CF\u92D0\u92D1\u92D2\u92D3\u92D4\u92D5\u92D6\u92D7\u92D8\u92D9\u92DA\u92DB\u92DC\u92DD\u92DE\u92DF\u92E0\u92E1\u92E2\u92E3\u92E4\u92E5\u92E6\u92E7\u92E8\uFFFD\u92E9\u92EA\u92EB\u92EC\u92ED\u92EE\u92EF\u92F0\u92F1\u92F2\u92F3\u92F4\u92F5\u92F6\u92F7\u92F8\u92F9\u92FA\u92FB\u92FC\u92FD\u92FE\u92FF\u9300\u9301\u9302\u9303\u9304\u9305\u9306\u9307\u9308\u9309\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u930A\u930B\u930C\u930D\u930E\u930F\u9310\u9311\u9312\u9313\u9314\u9315\u9316\u9317\u9318\u9319\u931A\u931B\u931C\u931D\u931E\u931F\u9320\u9321\u9322\u9323\u9324\u9325\u9326\u9327\u9328\u9329\u932A\u932B\u932C\u932D\u932E\u932F\u9330\u9331\u9332\u9333\u9334\u9335\u9336\u9337\u9338\u9339\u933A\u933B\u933C\u933D\u933F\u9340\u9341\u9342\u9343\u9344\u9345\u9346\u9347\u9348\u9349\uFFFD\u934A\u934B\u934C\u934D\u934E\u934F\u9350\u9351\u9352\u9353\u9354\u9355\u9356\u9357\u9358\u9359\u935A\u935B\u935C\u935D\u935E\u935F\u9360\u9361\u9362\u9363\u9364\u9365\u9366\u9367\u9368\u9369\u936B\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u936C\u936D\u936E\u936F\u9370\u9371\u9372\u9373\u9374\u9375\u9376\u9377\u9378\u9379\u937A\u937B\u937C\u937D\u937E\u937F\u9380\u9381\u9382\u9383\u9384\u9385\u9386\u9387\u9388\u9389\u938A\u938B\u938C\u938D\u938E\u9390\u9391\u9392\u9393\u9394\u9395\u9396\u9397\u9398\u9399\u939A\u939B\u939C\u939D\u939E\u939F\u93A0\u93A1\u93A2\u93A3\u93A4\u93A5\u93A6\u93A7\u93A8\u93A9\u93AA\u93AB\uFFFD\u93AC\u93AD\u93AE\u93AF\u93B0\u93B1\u93B2\u93B3\u93B4\u93B5\u93B6\u93B7\u93B8\u93B9\u93BA\u93BB\u93BC\u93BD\u93BE\u93BF\u93C0\u93C1\u93C2\u93C3\u93C4\u93C5\u93C6\u93C7\u93C8\u93C9\u93CB\u93CC\u93CD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u93CE\u93CF\u93D0\u93D1\u93D2\u93D3\u93D4\u93D5\u93D7\u93D8\u93D9\u93DA\u93DB\u93DC\u93DD\u93DE\u93DF\u93E0\u93E1\u93E2\u93E3\u93E4\u93E5\u93E6\u93E7\u93E8\u93E9\u93EA\u93EB\u93EC\u93ED\u93EE\u93EF\u93F0\u93F1\u93F2\u93F3\u93F4\u93F5\u93F6\u93F7\u93F8\u93F9\u93FA\u93FB\u93FC\u93FD\u93FE\u93FF\u9400\u9401\u9402\u9403\u9404\u9405\u9406\u9407\u9408\u9409\u940A\u940B\u940C\u940D\uFFFD\u940E\u940F\u9410\u9411\u9412\u9413\u9414\u9415\u9416\u9417\u9418\u9419\u941A\u941B\u941C\u941D\u941E\u941F\u9420\u9421\u9422\u9423\u9424\u9425\u9426\u9427\u9428\u9429\u942A\u942B\u942C\u942D\u942E\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21\u7F22\u7F23\u7F24\u7F25\u7F26\u7F27\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F\u7F30\u7F31\u7F32\u7F33\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u942F\u9430\u9431\u9432\u9433\u9434\u9435\u9436\u9437\u9438\u9439\u943A\u943B\u943C\u943D\u943F\u9440\u9441\u9442\u9443\u9444\u9445\u9446\u9447\u9448\u9449\u944A\u944B\u944C\u944D\u944E\u944F\u9450\u9451\u9452\u9453\u9454\u9455\u9456\u9457\u9458\u9459\u945A\u945B\u945C\u945D\u945E\u945F\u9460\u9461\u9462\u9463\u9464\u9465\u9466\u9467\u9468\u9469\u946A\u946C\u946D\u946E\u946F\uFFFD\u9470\u9471\u9472\u9473\u9474\u9475\u9476\u9477\u9478\u9479\u947A\u947B\u947C\u947D\u947E\u947F\u9480\u9481\u9482\u9483\u9484\u9491\u9496\u9498\u94C7\u94CF\u94D3\u94D4\u94DA\u94E6\u94FB\u951C\u9520\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9527\u9533\u953D\u9543\u9548\u954B\u9555\u955A\u9560\u956E\u9574\u9575\u9577\u9578\u9579\u957A\u957B\u957C\u957D\u957E\u9580\u9581\u9582\u9583\u9584\u9585\u9586\u9587\u9588\u9589\u958A\u958B\u958C\u958D\u958E\u958F\u9590\u9591\u9592\u9593\u9594\u9595\u9596\u9597\u9598\u9599\u959A\u959B\u959C\u959D\u959E\u959F\u95A0\u95A1\u95A2\u95A3\u95A4\u95A5\u95A6\u95A7\u95A8\u95A9\u95AA\uFFFD\u95AB\u95AC\u95AD\u95AE\u95AF\u95B0\u95B1\u95B2\u95B3\u95B4\u95B5\u95B6\u95B7\u95B8\u95B9\u95BA\u95BB\u95BC\u95BD\u95BE\u95BF\u95C0\u95C1\u95C2\u95C3\u95C4\u95C5\u95C6\u95C7\u95C8\u95C9\u95CA\u95CB\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u95CC\u95CD\u95CE\u95CF\u95D0\u95D1\u95D2\u95D3\u95D4\u95D5\u95D6\u95D7\u95D8\u95D9\u95DA\u95DB\u95DC\u95DD\u95DE\u95DF\u95E0\u95E1\u95E2\u95E3\u95E4\u95E5\u95E6\u95E7\u95EC\u95FF\u9607\u9613\u9618\u961B\u961E\u9620\u9623\u9624\u9625\u9626\u9627\u9628\u9629\u962B\u962C\u962D\u962F\u9630\u9637\u9638\u9639\u963A\u963E\u9641\u9643\u964A\u964E\u964F\u9651\u9652\u9653\u9656\u9657\uFFFD\u9658\u9659\u965A\u965C\u965D\u965E\u9660\u9663\u9665\u9666\u966B\u966D\u966E\u966F\u9670\u9671\u9673\u9678\u9679\u967A\u967B\u967C\u967D\u967E\u967F\u9680\u9681\u9682\u9683\u9684\u9687\u9689\u968A\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u968C\u968E\u9691\u9692\u9693\u9695\u9696\u969A\u969B\u969D\u969E\u969F\u96A0\u96A1\u96A2\u96A3\u96A4\u96A5\u96A6\u96A8\u96A9\u96AA\u96AB\u96AC\u96AD\u96AE\u96AF\u96B1\u96B2\u96B4\u96B5\u96B7\u96B8\u96BA\u96BB\u96BF\u96C2\u96C3\u96C8\u96CA\u96CB\u96D0\u96D1\u96D3\u96D4\u96D6\u96D7\u96D8\u96D9\u96DA\u96DB\u96DC\u96DD\u96DE\u96DF\u96E1\u96E2\u96E3\u96E4\u96E5\u96E6\u96E7\u96EB\uFFFD\u96EC\u96ED\u96EE\u96F0\u96F1\u96F2\u96F4\u96F5\u96F8\u96FA\u96FB\u96FC\u96FD\u96FF\u9702\u9703\u9705\u970A\u970B\u970C\u9710\u9711\u9712\u9714\u9715\u9717\u9718\u9719\u971A\u971B\u971D\u971F\u9720\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9721\u9722\u9723\u9724\u9725\u9726\u9727\u9728\u9729\u972B\u972C\u972E\u972F\u9731\u9733\u9734\u9735\u9736\u9737\u973A\u973B\u973C\u973D\u973F\u9740\u9741\u9742\u9743\u9744\u9745\u9746\u9747\u9748\u9749\u974A\u974B\u974C\u974D\u974E\u974F\u9750\u9751\u9754\u9755\u9757\u9758\u975A\u975C\u975D\u975F\u9763\u9764\u9766\u9767\u9768\u976A\u976B\u976C\u976D\u976E\u976F\u9770\u9771\uFFFD\u9772\u9775\u9777\u9778\u9779\u977A\u977B\u977D\u977E\u977F\u9780\u9781\u9782\u9783\u9784\u9786\u9787\u9788\u9789\u978A\u978C\u978E\u978F\u9790\u9793\u9795\u9796\u9797\u9799\u979A\u979B\u979C\u979D\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u979E\u979F\u97A1\u97A2\u97A4\u97A5\u97A6\u97A7\u97A8\u97A9\u97AA\u97AC\u97AE\u97B0\u97B1\u97B3\u97B5\u97B6\u97B7\u97B8\u97B9\u97BA\u97BB\u97BC\u97BD\u97BE\u97BF\u97C0\u97C1\u97C2\u97C3\u97C4\u97C5\u97C6\u97C7\u97C8\u97C9\u97CA\u97CB\u97CC\u97CD\u97CE\u97CF\u97D0\u97D1\u97D2\u97D3\u97D4\u97D5\u97D6\u97D7\u97D8\u97D9\u97DA\u97DB\u97DC\u97DD\u97DE\u97DF\u97E0\u97E1\u97E2\u97E3\uFFFD\u97E4\u97E5\u97E8\u97EE\u97EF\u97F0\u97F1\u97F2\u97F4\u97F7\u97F8\u97F9\u97FA\u97FB\u97FC\u97FD\u97FE\u97FF\u9800\u9801\u9802\u9803\u9804\u9805\u9806\u9807\u9808\u9809\u980A\u980B\u980C\u980D\u980E\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u980F\u9810\u9811\u9812\u9813\u9814\u9815\u9816\u9817\u9818\u9819\u981A\u981B\u981C\u981D\u981E\u981F\u9820\u9821\u9822\u9823\u9824\u9825\u9826\u9827\u9828\u9829\u982A\u982B\u982C\u982D\u982E\u982F\u9830\u9831\u9832\u9833\u9834\u9835\u9836\u9837\u9838\u9839\u983A\u983B\u983C\u983D\u983E\u983F\u9840\u9841\u9842\u9843\u9844\u9845\u9846\u9847\u9848\u9849\u984A\u984B\u984C\u984D\uFFFD\u984E\u984F\u9850\u9851\u9852\u9853\u9854\u9855\u9856\u9857\u9858\u9859\u985A\u985B\u985C\u985D\u985E\u985F\u9860\u9861\u9862\u9863\u9864\u9865\u9866\u9867\u9868\u9869\u986A\u986B\u986C\u986D\u986E\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6\u94B7\u94B8\u94B9\u94BA\u94BC\u94BD\u94BF\u94C4\u94C8\u94C9\u94CA\u94CB\u94CC\u94CD\u94CE\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u986F\u9870\u9871\u9872\u9873\u9874\u988B\u988E\u9892\u9895\u9899\u98A3\u98A8\u98A9\u98AA\u98AB\u98AC\u98AD\u98AE\u98AF\u98B0\u98B1\u98B2\u98B3\u98B4\u98B5\u98B6\u98B7\u98B8\u98B9\u98BA\u98BB\u98BC\u98BD\u98BE\u98BF\u98C0\u98C1\u98C2\u98C3\u98C4\u98C5\u98C6\u98C7\u98C8\u98C9\u98CA\u98CB\u98CC\u98CD\u98CF\u98D0\u98D4\u98D6\u98D7\u98DB\u98DC\u98DD\u98E0\u98E1\u98E2\u98E3\u98E4\uFFFD\u98E5\u98E6\u98E9\u98EA\u98EB\u98EC\u98ED\u98EE\u98EF\u98F0\u98F1\u98F2\u98F3\u98F4\u98F5\u98F6\u98F7\u98F8\u98F9\u98FA\u98FB\u98FC\u98FD\u98FE\u98FF\u9900\u9901\u9902\u9903\u9904\u9905\u9906\u9907\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512\u9513\u9514\u9515\u9516\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564\u9565\u9566\u9567\u9568\u9569\u956A\u956B\u956C\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9908\u9909\u990A\u990B\u990C\u990E\u990F\u9911\u9912\u9913\u9914\u9915\u9916\u9917\u9918\u9919\u991A\u991B\u991C\u991D\u991E\u991F\u9920\u9921\u9922\u9923\u9924\u9925\u9926\u9927\u9928\u9929\u992A\u992B\u992C\u992D\u992F\u9930\u9931\u9932\u9933\u9934\u9935\u9936\u9937\u9938\u9939\u993A\u993B\u993C\u993D\u993E\u993F\u9940\u9941\u9942\u9943\u9944\u9945\u9946\u9947\u9948\u9949\uFFFD\u994A\u994B\u994C\u994D\u994E\u994F\u9950\u9951\u9952\u9953\u9956\u9957\u9958\u9959\u995A\u995B\u995C\u995D\u995E\u995F\u9960\u9961\u9962\u9964\u9966\u9973\u9978\u9979\u997B\u997E\u9982\u9983\u9989\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28\u9E29\u9E2A\u9E2B\u9E2C\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66\u9E67\u9E68\u9E69\u9E6A\u9E6B\u9E6C\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u998C\u998E\u999A\u999B\u999C\u999D\u999E\u999F\u99A0\u99A1\u99A2\u99A3\u99A4\u99A6\u99A7\u99A9\u99AA\u99AB\u99AC\u99AD\u99AE\u99AF\u99B0\u99B1\u99B2\u99B3\u99B4\u99B5\u99B6\u99B7\u99B8\u99B9\u99BA\u99BB\u99BC\u99BD\u99BE\u99BF\u99C0\u99C1\u99C2\u99C3\u99C4\u99C5\u99C6\u99C7\u99C8\u99C9\u99CA\u99CB\u99CC\u99CD\u99CE\u99CF\u99D0\u99D1\u99D2\u99D3\u99D4\u99D5\u99D6\u99D7\u99D8\uFFFD\u99D9\u99DA\u99DB\u99DC\u99DD\u99DE\u99DF\u99E0\u99E1\u99E2\u99E3\u99E4\u99E5\u99E6\u99E7\u99E8\u99E9\u99EA\u99EB\u99EC\u99ED\u99EE\u99EF\u99F0\u99F1\u99F2\u99F3\u99F4\u99F5\u99F6\u99F7\u99F8\u99F9\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u99FA\u99FB\u99FC\u99FD\u99FE\u99FF\u9A00\u9A01\u9A02\u9A03\u9A04\u9A05\u9A06\u9A07\u9A08\u9A09\u9A0A\u9A0B\u9A0C\u9A0D\u9A0E\u9A0F\u9A10\u9A11\u9A12\u9A13\u9A14\u9A15\u9A16\u9A17\u9A18\u9A19\u9A1A\u9A1B\u9A1C\u9A1D\u9A1E\u9A1F\u9A20\u9A21\u9A22\u9A23\u9A24\u9A25\u9A26\u9A27\u9A28\u9A29\u9A2A\u9A2B\u9A2C\u9A2D\u9A2E\u9A2F\u9A30\u9A31\u9A32\u9A33\u9A34\u9A35\u9A36\u9A37\u9A38\uFFFD\u9A39\u9A3A\u9A3B\u9A3C\u9A3D\u9A3E\u9A3F\u9A40\u9A41\u9A42\u9A43\u9A44\u9A45\u9A46\u9A47\u9A48\u9A49\u9A4A\u9A4B\u9A4C\u9A4D\u9A4E\u9A4F\u9A50\u9A51\u9A52\u9A53\u9A54\u9A55\u9A56\u9A57\u9A58\u9A59\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9A5A\u9A5B\u9A5C\u9A5D\u9A5E\u9A5F\u9A60\u9A61\u9A62\u9A63\u9A64\u9A65\u9A66\u9A67\u9A68\u9A69\u9A6A\u9A6B\u9A72\u9A83\u9A89\u9A8D\u9A8E\u9A94\u9A95\u9A99\u9AA6\u9AA9\u9AAA\u9AAB\u9AAC\u9AAD\u9AAE\u9AAF\u9AB2\u9AB3\u9AB4\u9AB5\u9AB9\u9ABB\u9ABD\u9ABE\u9ABF\u9AC3\u9AC4\u9AC6\u9AC7\u9AC8\u9AC9\u9ACA\u9ACD\u9ACE\u9ACF\u9AD0\u9AD2\u9AD4\u9AD5\u9AD6\u9AD7\u9AD9\u9ADA\u9ADB\u9ADC\uFFFD\u9ADD\u9ADE\u9AE0\u9AE2\u9AE3\u9AE4\u9AE5\u9AE7\u9AE8\u9AE9\u9AEA\u9AEC\u9AEE\u9AF0\u9AF1\u9AF2\u9AF3\u9AF4\u9AF5\u9AF6\u9AF7\u9AF8\u9AFA\u9AFC\u9AFD\u9AFE\u9AFF\u9B00\u9B01\u9B02\u9B04\u9B05\u9B06\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B07\u9B09\u9B0A\u9B0B\u9B0C\u9B0D\u9B0E\u9B10\u9B11\u9B12\u9B14\u9B15\u9B16\u9B17\u9B18\u9B19\u9B1A\u9B1B\u9B1C\u9B1D\u9B1E\u9B20\u9B21\u9B22\u9B24\u9B25\u9B26\u9B27\u9B28\u9B29\u9B2A\u9B2B\u9B2C\u9B2D\u9B2E\u9B30\u9B31\u9B33\u9B34\u9B35\u9B36\u9B37\u9B38\u9B39\u9B3A\u9B3D\u9B3E\u9B3F\u9B40\u9B46\u9B4A\u9B4B\u9B4C\u9B4E\u9B50\u9B52\u9B53\u9B55\u9B56\u9B57\u9B58\u9B59\u9B5A\uFFFD\u9B5B\u9B5C\u9B5D\u9B5E\u9B5F\u9B60\u9B61\u9B62\u9B63\u9B64\u9B65\u9B66\u9B67\u9B68\u9B69\u9B6A\u9B6B\u9B6C\u9B6D\u9B6E\u9B6F\u9B70\u9B71\u9B72\u9B73\u9B74\u9B75\u9B76\u9B77\u9B78\u9B79\u9B7A\u9B7B\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B7C\u9B7D\u9B7E\u9B7F\u9B80\u9B81\u9B82\u9B83\u9B84\u9B85\u9B86\u9B87\u9B88\u9B89\u9B8A\u9B8B\u9B8C\u9B8D\u9B8E\u9B8F\u9B90\u9B91\u9B92\u9B93\u9B94\u9B95\u9B96\u9B97\u9B98\u9B99\u9B9A\u9B9B\u9B9C\u9B9D\u9B9E\u9B9F\u9BA0\u9BA1\u9BA2\u9BA3\u9BA4\u9BA5\u9BA6\u9BA7\u9BA8\u9BA9\u9BAA\u9BAB\u9BAC\u9BAD\u9BAE\u9BAF\u9BB0\u9BB1\u9BB2\u9BB3\u9BB4\u9BB5\u9BB6\u9BB7\u9BB8\u9BB9\u9BBA\uFFFD\u9BBB\u9BBC\u9BBD\u9BBE\u9BBF\u9BC0\u9BC1\u9BC2\u9BC3\u9BC4\u9BC5\u9BC6\u9BC7\u9BC8\u9BC9\u9BCA\u9BCB\u9BCC\u9BCD\u9BCE\u9BCF\u9BD0\u9BD1\u9BD2\u9BD3\u9BD4\u9BD5\u9BD6\u9BD7\u9BD8\u9BD9\u9BDA\u9BDB\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9BDC\u9BDD\u9BDE\u9BDF\u9BE0\u9BE1\u9BE2\u9BE3\u9BE4\u9BE5\u9BE6\u9BE7\u9BE8\u9BE9\u9BEA\u9BEB\u9BEC\u9BED\u9BEE\u9BEF\u9BF0\u9BF1\u9BF2\u9BF3\u9BF4\u9BF5\u9BF6\u9BF7\u9BF8\u9BF9\u9BFA\u9BFB\u9BFC\u9BFD\u9BFE\u9BFF\u9C00\u9C01\u9C02\u9C03\u9C04\u9C05\u9C06\u9C07\u9C08\u9C09\u9C0A\u9C0B\u9C0C\u9C0D\u9C0E\u9C0F\u9C10\u9C11\u9C12\u9C13\u9C14\u9C15\u9C16\u9C17\u9C18\u9C19\u9C1A\uFFFD\u9C1B\u9C1C\u9C1D\u9C1E\u9C1F\u9C20\u9C21\u9C22\u9C23\u9C24\u9C25\u9C26\u9C27\u9C28\u9C29\u9C2A\u9C2B\u9C2C\u9C2D\u9C2E\u9C2F\u9C30\u9C31\u9C32\u9C33\u9C34\u9C35\u9C36\u9C37\u9C38\u9C39\u9C3A\u9C3B\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85\u9F86\u9F87\u9F88\u9F89\u9F8A\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E\u9C9F\u9CA0\u9CA1\u9CA2\u9CA3\u9CA5\u9CA6\u9CA7\u9CA8\u9CA9\u9CAB\u9CAD\u9CAE\u9CB0\u9CB1\u9CB2\u9CB3\u9CB4\u9CB5\u9CB6\u9CB7\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9C3C\u9C3D\u9C3E\u9C3F\u9C40\u9C41\u9C42\u9C43\u9C44\u9C45\u9C46\u9C47\u9C48\u9C49\u9C4A\u9C4B\u9C4C\u9C4D\u9C4E\u9C4F\u9C50\u9C51\u9C52\u9C53\u9C54\u9C55\u9C56\u9C57\u9C58\u9C59\u9C5A\u9C5B\u9C5C\u9C5D\u9C5E\u9C5F\u9C60\u9C61\u9C62\u9C63\u9C64\u9C65\u9C66\u9C67\u9C68\u9C69\u9C6A\u9C6B\u9C6C\u9C6D\u9C6E\u9C6F\u9C70\u9C71\u9C72\u9C73\u9C74\u9C75\u9C76\u9C77\u9C78\u9C79\u9C7A\uFFFD\u9C7B\u9C7D\u9C7E\u9C80\u9C83\u9C84\u9C89\u9C8A\u9C8C\u9C8F\u9C93\u9C96\u9C97\u9C98\u9C99\u9C9D\u9CAA\u9CAC\u9CAF\u9CB9\u9CBE\u9CBF\u9CC0\u9CC1\u9CC2\u9CC8\u9CC9\u9CD1\u9CD2\u9CDA\u9CDB\u9CE0\u9CE1\u9CCC\u9CCD\u9CCE\u9CCF\u9CD0\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    D[248] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9CE3\u9CE4\u9CE5\u9CE6\u9CE7\u9CE8\u9CE9\u9CEA\u9CEB\u9CEC\u9CED\u9CEE\u9CEF\u9CF0\u9CF1\u9CF2\u9CF3\u9CF4\u9CF5\u9CF6\u9CF7\u9CF8\u9CF9\u9CFA\u9CFB\u9CFC\u9CFD\u9CFE\u9CFF\u9D00\u9D01\u9D02\u9D03\u9D04\u9D05\u9D06\u9D07\u9D08\u9D09\u9D0A\u9D0B\u9D0C\u9D0D\u9D0E\u9D0F\u9D10\u9D11\u9D12\u9D13\u9D14\u9D15\u9D16\u9D17\u9D18\u9D19\u9D1A\u9D1B\u9D1C\u9D1D\u9D1E\u9D1F\u9D20\u9D21\uFFFD\u9D22\u9D23\u9D24\u9D25\u9D26\u9D27\u9D28\u9D29\u9D2A\u9D2B\u9D2C\u9D2D\u9D2E\u9D2F\u9D30\u9D31\u9D32\u9D33\u9D34\u9D35\u9D36\u9D37\u9D38\u9D39\u9D3A\u9D3B\u9D3C\u9D3D\u9D3E\u9D3F\u9D40\u9D41\u9D42\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[248].length; ++j)if (D[248][j].charCodeAt(0) !== 0xFFFD) {
        e[D[248][j]] = 63488 + j;
        d[63488 + j] = D[248][j];
    }
    D[249] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D43\u9D44\u9D45\u9D46\u9D47\u9D48\u9D49\u9D4A\u9D4B\u9D4C\u9D4D\u9D4E\u9D4F\u9D50\u9D51\u9D52\u9D53\u9D54\u9D55\u9D56\u9D57\u9D58\u9D59\u9D5A\u9D5B\u9D5C\u9D5D\u9D5E\u9D5F\u9D60\u9D61\u9D62\u9D63\u9D64\u9D65\u9D66\u9D67\u9D68\u9D69\u9D6A\u9D6B\u9D6C\u9D6D\u9D6E\u9D6F\u9D70\u9D71\u9D72\u9D73\u9D74\u9D75\u9D76\u9D77\u9D78\u9D79\u9D7A\u9D7B\u9D7C\u9D7D\u9D7E\u9D7F\u9D80\u9D81\uFFFD\u9D82\u9D83\u9D84\u9D85\u9D86\u9D87\u9D88\u9D89\u9D8A\u9D8B\u9D8C\u9D8D\u9D8E\u9D8F\u9D90\u9D91\u9D92\u9D93\u9D94\u9D95\u9D96\u9D97\u9D98\u9D99\u9D9A\u9D9B\u9D9C\u9D9D\u9D9E\u9D9F\u9DA0\u9DA1\u9DA2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[249].length; ++j)if (D[249][j].charCodeAt(0) !== 0xFFFD) {
        e[D[249][j]] = 63744 + j;
        d[63744 + j] = D[249][j];
    }
    D[250] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9DA3\u9DA4\u9DA5\u9DA6\u9DA7\u9DA8\u9DA9\u9DAA\u9DAB\u9DAC\u9DAD\u9DAE\u9DAF\u9DB0\u9DB1\u9DB2\u9DB3\u9DB4\u9DB5\u9DB6\u9DB7\u9DB8\u9DB9\u9DBA\u9DBB\u9DBC\u9DBD\u9DBE\u9DBF\u9DC0\u9DC1\u9DC2\u9DC3\u9DC4\u9DC5\u9DC6\u9DC7\u9DC8\u9DC9\u9DCA\u9DCB\u9DCC\u9DCD\u9DCE\u9DCF\u9DD0\u9DD1\u9DD2\u9DD3\u9DD4\u9DD5\u9DD6\u9DD7\u9DD8\u9DD9\u9DDA\u9DDB\u9DDC\u9DDD\u9DDE\u9DDF\u9DE0\u9DE1\uFFFD\u9DE2\u9DE3\u9DE4\u9DE5\u9DE6\u9DE7\u9DE8\u9DE9\u9DEA\u9DEB\u9DEC\u9DED\u9DEE\u9DEF\u9DF0\u9DF1\u9DF2\u9DF3\u9DF4\u9DF5\u9DF6\u9DF7\u9DF8\u9DF9\u9DFA\u9DFB\u9DFC\u9DFD\u9DFE\u9DFF\u9E00\u9E01\u9E02\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[250].length; ++j)if (D[250][j].charCodeAt(0) !== 0xFFFD) {
        e[D[250][j]] = 64000 + j;
        d[64000 + j] = D[250][j];
    }
    D[251] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9E03\u9E04\u9E05\u9E06\u9E07\u9E08\u9E09\u9E0A\u9E0B\u9E0C\u9E0D\u9E0E\u9E0F\u9E10\u9E11\u9E12\u9E13\u9E14\u9E15\u9E16\u9E17\u9E18\u9E19\u9E1A\u9E1B\u9E1C\u9E1D\u9E1E\u9E24\u9E27\u9E2E\u9E30\u9E34\u9E3B\u9E3C\u9E40\u9E4D\u9E50\u9E52\u9E53\u9E54\u9E56\u9E59\u9E5D\u9E5F\u9E60\u9E61\u9E62\u9E65\u9E6E\u9E6F\u9E72\u9E74\u9E75\u9E76\u9E77\u9E78\u9E79\u9E7A\u9E7B\u9E7C\u9E7D\u9E80\uFFFD\u9E81\u9E83\u9E84\u9E85\u9E86\u9E89\u9E8A\u9E8C\u9E8D\u9E8E\u9E8F\u9E90\u9E91\u9E94\u9E95\u9E96\u9E97\u9E98\u9E99\u9E9A\u9E9B\u9E9C\u9E9E\u9EA0\u9EA1\u9EA2\u9EA3\u9EA4\u9EA5\u9EA7\u9EA8\u9EA9\u9EAA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[251].length; ++j)if (D[251][j].charCodeAt(0) !== 0xFFFD) {
        e[D[251][j]] = 64256 + j;
        d[64256 + j] = D[251][j];
    }
    D[252] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9EAB\u9EAC\u9EAD\u9EAE\u9EAF\u9EB0\u9EB1\u9EB2\u9EB3\u9EB5\u9EB6\u9EB7\u9EB9\u9EBA\u9EBC\u9EBF\u9EC0\u9EC1\u9EC2\u9EC3\u9EC5\u9EC6\u9EC7\u9EC8\u9ECA\u9ECB\u9ECC\u9ED0\u9ED2\u9ED3\u9ED5\u9ED6\u9ED7\u9ED9\u9EDA\u9EDE\u9EE1\u9EE3\u9EE4\u9EE6\u9EE8\u9EEB\u9EEC\u9EED\u9EEE\u9EF0\u9EF1\u9EF2\u9EF3\u9EF4\u9EF5\u9EF6\u9EF7\u9EF8\u9EFA\u9EFD\u9EFF\u9F00\u9F01\u9F02\u9F03\u9F04\u9F05\uFFFD\u9F06\u9F07\u9F08\u9F09\u9F0A\u9F0C\u9F0F\u9F11\u9F12\u9F14\u9F15\u9F16\u9F18\u9F1A\u9F1B\u9F1C\u9F1D\u9F1E\u9F1F\u9F21\u9F23\u9F24\u9F25\u9F26\u9F27\u9F28\u9F29\u9F2A\u9F2B\u9F2D\u9F2E\u9F30\u9F31\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[252].length; ++j)if (D[252][j].charCodeAt(0) !== 0xFFFD) {
        e[D[252][j]] = 64512 + j;
        d[64512 + j] = D[252][j];
    }
    D[253] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9F32\u9F33\u9F34\u9F35\u9F36\u9F38\u9F3A\u9F3C\u9F3F\u9F40\u9F41\u9F42\u9F43\u9F45\u9F46\u9F47\u9F48\u9F49\u9F4A\u9F4B\u9F4C\u9F4D\u9F4E\u9F4F\u9F52\u9F53\u9F54\u9F55\u9F56\u9F57\u9F58\u9F59\u9F5A\u9F5B\u9F5C\u9F5D\u9F5E\u9F5F\u9F60\u9F61\u9F62\u9F63\u9F64\u9F65\u9F66\u9F67\u9F68\u9F69\u9F6A\u9F6B\u9F6C\u9F6D\u9F6E\u9F6F\u9F70\u9F71\u9F72\u9F73\u9F74\u9F75\u9F76\u9F77\u9F78\uFFFD\u9F79\u9F7A\u9F7B\u9F7C\u9F7D\u9F7E\u9F81\u9F82\u9F8D\u9F8E\u9F8F\u9F90\u9F91\u9F92\u9F93\u9F94\u9F95\u9F96\u9F97\u9F98\u9F9C\u9F9D\u9F9E\u9FA1\u9FA2\u9FA3\u9FA4\u9FA5\uF92C\uF979\uF995\uF9E7\uF9F1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[253].length; ++j)if (D[253][j].charCodeAt(0) !== 0xFFFD) {
        e[D[253][j]] = 64768 + j;
        d[64768 + j] = D[253][j];
    }
    D[254] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFA0C\uFA0D\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA18\uFA1F\uFA20\uFA21\uFA23\uFA24\uFA27\uFA28\uFA29\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[254].length; ++j)if (D[254][j].charCodeAt(0) !== 0xFFFD) {
        e[D[254][j]] = 65024 + j;
        d[65024 + j] = D[254][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
cptable[949] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[129] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAC02\uAC03\uAC05\uAC06\uAC0B\uAC0C\uAC0D\uAC0E\uAC0F\uAC18\uAC1E\uAC1F\uAC21\uAC22\uAC23\uAC25\uAC26\uAC27\uAC28\uAC29\uAC2A\uAC2B\uAC2E\uAC32\uAC33\uAC34\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAC35\uAC36\uAC37\uAC3A\uAC3B\uAC3D\uAC3E\uAC3F\uAC41\uAC42\uAC43\uAC44\uAC45\uAC46\uAC47\uAC48\uAC49\uAC4A\uAC4C\uAC4E\uAC4F\uAC50\uAC51\uAC52\uAC53\uAC55\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAC56\uAC57\uAC59\uAC5A\uAC5B\uAC5D\uAC5E\uAC5F\uAC60\uAC61\uAC62\uAC63\uAC64\uAC65\uAC66\uAC67\uAC68\uAC69\uAC6A\uAC6B\uAC6C\uAC6D\uAC6E\uAC6F\uAC72\uAC73\uAC75\uAC76\uAC79\uAC7B\uAC7C\uAC7D\uAC7E\uAC7F\uAC82\uAC87\uAC88\uAC8D\uAC8E\uAC8F\uAC91\uAC92\uAC93\uAC95\uAC96\uAC97\uAC98\uAC99\uAC9A\uAC9B\uAC9E\uACA2\uACA3\uACA4\uACA5\uACA6\uACA7\uACAB\uACAD\uACAE\uACB1\uACB2\uACB3\uACB4\uACB5\uACB6\uACB7\uACBA\uACBE\uACBF\uACC0\uACC2\uACC3\uACC5\uACC6\uACC7\uACC9\uACCA\uACCB\uACCD\uACCE\uACCF\uACD0\uACD1\uACD2\uACD3\uACD4\uACD6\uACD8\uACD9\uACDA\uACDB\uACDC\uACDD\uACDE\uACDF\uACE2\uACE3\uACE5\uACE6\uACE9\uACEB\uACED\uACEE\uACF2\uACF4\uACF7\uACF8\uACF9\uACFA\uACFB\uACFE\uACFF\uAD01\uAD02\uAD03\uAD05\uAD07\uAD08\uAD09\uAD0A\uAD0B\uAD0E\uAD10\uAD12\uAD13\uFFFD".split("");
    for(j = 0; j != D[129].length; ++j)if (D[129][j].charCodeAt(0) !== 0xFFFD) {
        e[D[129][j]] = 33024 + j;
        d[33024 + j] = D[129][j];
    }
    D[130] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAD14\uAD15\uAD16\uAD17\uAD19\uAD1A\uAD1B\uAD1D\uAD1E\uAD1F\uAD21\uAD22\uAD23\uAD24\uAD25\uAD26\uAD27\uAD28\uAD2A\uAD2B\uAD2E\uAD2F\uAD30\uAD31\uAD32\uAD33\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAD36\uAD37\uAD39\uAD3A\uAD3B\uAD3D\uAD3E\uAD3F\uAD40\uAD41\uAD42\uAD43\uAD46\uAD48\uAD4A\uAD4B\uAD4C\uAD4D\uAD4E\uAD4F\uAD51\uAD52\uAD53\uAD55\uAD56\uAD57\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAD59\uAD5A\uAD5B\uAD5C\uAD5D\uAD5E\uAD5F\uAD60\uAD62\uAD64\uAD65\uAD66\uAD67\uAD68\uAD69\uAD6A\uAD6B\uAD6E\uAD6F\uAD71\uAD72\uAD77\uAD78\uAD79\uAD7A\uAD7E\uAD80\uAD83\uAD84\uAD85\uAD86\uAD87\uAD8A\uAD8B\uAD8D\uAD8E\uAD8F\uAD91\uAD92\uAD93\uAD94\uAD95\uAD96\uAD97\uAD98\uAD99\uAD9A\uAD9B\uAD9E\uAD9F\uADA0\uADA1\uADA2\uADA3\uADA5\uADA6\uADA7\uADA8\uADA9\uADAA\uADAB\uADAC\uADAD\uADAE\uADAF\uADB0\uADB1\uADB2\uADB3\uADB4\uADB5\uADB6\uADB8\uADB9\uADBA\uADBB\uADBC\uADBD\uADBE\uADBF\uADC2\uADC3\uADC5\uADC6\uADC7\uADC9\uADCA\uADCB\uADCC\uADCD\uADCE\uADCF\uADD2\uADD4\uADD5\uADD6\uADD7\uADD8\uADD9\uADDA\uADDB\uADDD\uADDE\uADDF\uADE1\uADE2\uADE3\uADE5\uADE6\uADE7\uADE8\uADE9\uADEA\uADEB\uADEC\uADED\uADEE\uADEF\uADF0\uADF1\uADF2\uADF3\uADF4\uADF5\uADF6\uADF7\uFFFD".split("");
    for(j = 0; j != D[130].length; ++j)if (D[130][j].charCodeAt(0) !== 0xFFFD) {
        e[D[130][j]] = 33280 + j;
        d[33280 + j] = D[130][j];
    }
    D[131] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uADFA\uADFB\uADFD\uADFE\uAE02\uAE03\uAE04\uAE05\uAE06\uAE07\uAE0A\uAE0C\uAE0E\uAE0F\uAE10\uAE11\uAE12\uAE13\uAE15\uAE16\uAE17\uAE18\uAE19\uAE1A\uAE1B\uAE1C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAE1D\uAE1E\uAE1F\uAE20\uAE21\uAE22\uAE23\uAE24\uAE25\uAE26\uAE27\uAE28\uAE29\uAE2A\uAE2B\uAE2C\uAE2D\uAE2E\uAE2F\uAE32\uAE33\uAE35\uAE36\uAE39\uAE3B\uAE3C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAE3D\uAE3E\uAE3F\uAE42\uAE44\uAE47\uAE48\uAE49\uAE4B\uAE4F\uAE51\uAE52\uAE53\uAE55\uAE57\uAE58\uAE59\uAE5A\uAE5B\uAE5E\uAE62\uAE63\uAE64\uAE66\uAE67\uAE6A\uAE6B\uAE6D\uAE6E\uAE6F\uAE71\uAE72\uAE73\uAE74\uAE75\uAE76\uAE77\uAE7A\uAE7E\uAE7F\uAE80\uAE81\uAE82\uAE83\uAE86\uAE87\uAE88\uAE89\uAE8A\uAE8B\uAE8D\uAE8E\uAE8F\uAE90\uAE91\uAE92\uAE93\uAE94\uAE95\uAE96\uAE97\uAE98\uAE99\uAE9A\uAE9B\uAE9C\uAE9D\uAE9E\uAE9F\uAEA0\uAEA1\uAEA2\uAEA3\uAEA4\uAEA5\uAEA6\uAEA7\uAEA8\uAEA9\uAEAA\uAEAB\uAEAC\uAEAD\uAEAE\uAEAF\uAEB0\uAEB1\uAEB2\uAEB3\uAEB4\uAEB5\uAEB6\uAEB7\uAEB8\uAEB9\uAEBA\uAEBB\uAEBF\uAEC1\uAEC2\uAEC3\uAEC5\uAEC6\uAEC7\uAEC8\uAEC9\uAECA\uAECB\uAECE\uAED2\uAED3\uAED4\uAED5\uAED6\uAED7\uAEDA\uAEDB\uAEDD\uAEDE\uAEDF\uAEE0\uAEE1\uAEE2\uAEE3\uAEE4\uAEE5\uFFFD".split("");
    for(j = 0; j != D[131].length; ++j)if (D[131][j].charCodeAt(0) !== 0xFFFD) {
        e[D[131][j]] = 33536 + j;
        d[33536 + j] = D[131][j];
    }
    D[132] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAEE6\uAEE7\uAEE9\uAEEA\uAEEC\uAEEE\uAEEF\uAEF0\uAEF1\uAEF2\uAEF3\uAEF5\uAEF6\uAEF7\uAEF9\uAEFA\uAEFB\uAEFD\uAEFE\uAEFF\uAF00\uAF01\uAF02\uAF03\uAF04\uAF05\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAF06\uAF09\uAF0A\uAF0B\uAF0C\uAF0E\uAF0F\uAF11\uAF12\uAF13\uAF14\uAF15\uAF16\uAF17\uAF18\uAF19\uAF1A\uAF1B\uAF1C\uAF1D\uAF1E\uAF1F\uAF20\uAF21\uAF22\uAF23\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAF24\uAF25\uAF26\uAF27\uAF28\uAF29\uAF2A\uAF2B\uAF2E\uAF2F\uAF31\uAF33\uAF35\uAF36\uAF37\uAF38\uAF39\uAF3A\uAF3B\uAF3E\uAF40\uAF44\uAF45\uAF46\uAF47\uAF4A\uAF4B\uAF4C\uAF4D\uAF4E\uAF4F\uAF51\uAF52\uAF53\uAF54\uAF55\uAF56\uAF57\uAF58\uAF59\uAF5A\uAF5B\uAF5E\uAF5F\uAF60\uAF61\uAF62\uAF63\uAF66\uAF67\uAF68\uAF69\uAF6A\uAF6B\uAF6C\uAF6D\uAF6E\uAF6F\uAF70\uAF71\uAF72\uAF73\uAF74\uAF75\uAF76\uAF77\uAF78\uAF7A\uAF7B\uAF7C\uAF7D\uAF7E\uAF7F\uAF81\uAF82\uAF83\uAF85\uAF86\uAF87\uAF89\uAF8A\uAF8B\uAF8C\uAF8D\uAF8E\uAF8F\uAF92\uAF93\uAF94\uAF96\uAF97\uAF98\uAF99\uAF9A\uAF9B\uAF9D\uAF9E\uAF9F\uAFA0\uAFA1\uAFA2\uAFA3\uAFA4\uAFA5\uAFA6\uAFA7\uAFA8\uAFA9\uAFAA\uAFAB\uAFAC\uAFAD\uAFAE\uAFAF\uAFB0\uAFB1\uAFB2\uAFB3\uAFB4\uAFB5\uAFB6\uAFB7\uAFBA\uAFBB\uAFBD\uAFBE\uFFFD".split("");
    for(j = 0; j != D[132].length; ++j)if (D[132][j].charCodeAt(0) !== 0xFFFD) {
        e[D[132][j]] = 33792 + j;
        d[33792 + j] = D[132][j];
    }
    D[133] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAFBF\uAFC1\uAFC2\uAFC3\uAFC4\uAFC5\uAFC6\uAFCA\uAFCC\uAFCF\uAFD0\uAFD1\uAFD2\uAFD3\uAFD5\uAFD6\uAFD7\uAFD8\uAFD9\uAFDA\uAFDB\uAFDD\uAFDE\uAFDF\uAFE0\uAFE1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAFE2\uAFE3\uAFE4\uAFE5\uAFE6\uAFE7\uAFEA\uAFEB\uAFEC\uAFED\uAFEE\uAFEF\uAFF2\uAFF3\uAFF5\uAFF6\uAFF7\uAFF9\uAFFA\uAFFB\uAFFC\uAFFD\uAFFE\uAFFF\uB002\uB003\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB005\uB006\uB007\uB008\uB009\uB00A\uB00B\uB00D\uB00E\uB00F\uB011\uB012\uB013\uB015\uB016\uB017\uB018\uB019\uB01A\uB01B\uB01E\uB01F\uB020\uB021\uB022\uB023\uB024\uB025\uB026\uB027\uB029\uB02A\uB02B\uB02C\uB02D\uB02E\uB02F\uB030\uB031\uB032\uB033\uB034\uB035\uB036\uB037\uB038\uB039\uB03A\uB03B\uB03C\uB03D\uB03E\uB03F\uB040\uB041\uB042\uB043\uB046\uB047\uB049\uB04B\uB04D\uB04F\uB050\uB051\uB052\uB056\uB058\uB05A\uB05B\uB05C\uB05E\uB05F\uB060\uB061\uB062\uB063\uB064\uB065\uB066\uB067\uB068\uB069\uB06A\uB06B\uB06C\uB06D\uB06E\uB06F\uB070\uB071\uB072\uB073\uB074\uB075\uB076\uB077\uB078\uB079\uB07A\uB07B\uB07E\uB07F\uB081\uB082\uB083\uB085\uB086\uB087\uB088\uB089\uB08A\uB08B\uB08E\uB090\uB092\uB093\uB094\uB095\uB096\uB097\uB09B\uB09D\uB09E\uB0A3\uB0A4\uFFFD".split("");
    for(j = 0; j != D[133].length; ++j)if (D[133][j].charCodeAt(0) !== 0xFFFD) {
        e[D[133][j]] = 34048 + j;
        d[34048 + j] = D[133][j];
    }
    D[134] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB0A5\uB0A6\uB0A7\uB0AA\uB0B0\uB0B2\uB0B6\uB0B7\uB0B9\uB0BA\uB0BB\uB0BD\uB0BE\uB0BF\uB0C0\uB0C1\uB0C2\uB0C3\uB0C6\uB0CA\uB0CB\uB0CC\uB0CD\uB0CE\uB0CF\uB0D2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB0D3\uB0D5\uB0D6\uB0D7\uB0D9\uB0DA\uB0DB\uB0DC\uB0DD\uB0DE\uB0DF\uB0E1\uB0E2\uB0E3\uB0E4\uB0E6\uB0E7\uB0E8\uB0E9\uB0EA\uB0EB\uB0EC\uB0ED\uB0EE\uB0EF\uB0F0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB0F1\uB0F2\uB0F3\uB0F4\uB0F5\uB0F6\uB0F7\uB0F8\uB0F9\uB0FA\uB0FB\uB0FC\uB0FD\uB0FE\uB0FF\uB100\uB101\uB102\uB103\uB104\uB105\uB106\uB107\uB10A\uB10D\uB10E\uB10F\uB111\uB114\uB115\uB116\uB117\uB11A\uB11E\uB11F\uB120\uB121\uB122\uB126\uB127\uB129\uB12A\uB12B\uB12D\uB12E\uB12F\uB130\uB131\uB132\uB133\uB136\uB13A\uB13B\uB13C\uB13D\uB13E\uB13F\uB142\uB143\uB145\uB146\uB147\uB149\uB14A\uB14B\uB14C\uB14D\uB14E\uB14F\uB152\uB153\uB156\uB157\uB159\uB15A\uB15B\uB15D\uB15E\uB15F\uB161\uB162\uB163\uB164\uB165\uB166\uB167\uB168\uB169\uB16A\uB16B\uB16C\uB16D\uB16E\uB16F\uB170\uB171\uB172\uB173\uB174\uB175\uB176\uB177\uB17A\uB17B\uB17D\uB17E\uB17F\uB181\uB183\uB184\uB185\uB186\uB187\uB18A\uB18C\uB18E\uB18F\uB190\uB191\uB195\uB196\uB197\uB199\uB19A\uB19B\uB19D\uFFFD".split("");
    for(j = 0; j != D[134].length; ++j)if (D[134][j].charCodeAt(0) !== 0xFFFD) {
        e[D[134][j]] = 34304 + j;
        d[34304 + j] = D[134][j];
    }
    D[135] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB19E\uB19F\uB1A0\uB1A1\uB1A2\uB1A3\uB1A4\uB1A5\uB1A6\uB1A7\uB1A9\uB1AA\uB1AB\uB1AC\uB1AD\uB1AE\uB1AF\uB1B0\uB1B1\uB1B2\uB1B3\uB1B4\uB1B5\uB1B6\uB1B7\uB1B8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB1B9\uB1BA\uB1BB\uB1BC\uB1BD\uB1BE\uB1BF\uB1C0\uB1C1\uB1C2\uB1C3\uB1C4\uB1C5\uB1C6\uB1C7\uB1C8\uB1C9\uB1CA\uB1CB\uB1CD\uB1CE\uB1CF\uB1D1\uB1D2\uB1D3\uB1D5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB1D6\uB1D7\uB1D8\uB1D9\uB1DA\uB1DB\uB1DE\uB1E0\uB1E1\uB1E2\uB1E3\uB1E4\uB1E5\uB1E6\uB1E7\uB1EA\uB1EB\uB1ED\uB1EE\uB1EF\uB1F1\uB1F2\uB1F3\uB1F4\uB1F5\uB1F6\uB1F7\uB1F8\uB1FA\uB1FC\uB1FE\uB1FF\uB200\uB201\uB202\uB203\uB206\uB207\uB209\uB20A\uB20D\uB20E\uB20F\uB210\uB211\uB212\uB213\uB216\uB218\uB21A\uB21B\uB21C\uB21D\uB21E\uB21F\uB221\uB222\uB223\uB224\uB225\uB226\uB227\uB228\uB229\uB22A\uB22B\uB22C\uB22D\uB22E\uB22F\uB230\uB231\uB232\uB233\uB235\uB236\uB237\uB238\uB239\uB23A\uB23B\uB23D\uB23E\uB23F\uB240\uB241\uB242\uB243\uB244\uB245\uB246\uB247\uB248\uB249\uB24A\uB24B\uB24C\uB24D\uB24E\uB24F\uB250\uB251\uB252\uB253\uB254\uB255\uB256\uB257\uB259\uB25A\uB25B\uB25D\uB25E\uB25F\uB261\uB262\uB263\uB264\uB265\uB266\uB267\uB26A\uB26B\uB26C\uB26D\uB26E\uFFFD".split("");
    for(j = 0; j != D[135].length; ++j)if (D[135][j].charCodeAt(0) !== 0xFFFD) {
        e[D[135][j]] = 34560 + j;
        d[34560 + j] = D[135][j];
    }
    D[136] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB26F\uB270\uB271\uB272\uB273\uB276\uB277\uB278\uB279\uB27A\uB27B\uB27D\uB27E\uB27F\uB280\uB281\uB282\uB283\uB286\uB287\uB288\uB28A\uB28B\uB28C\uB28D\uB28E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB28F\uB292\uB293\uB295\uB296\uB297\uB29B\uB29C\uB29D\uB29E\uB29F\uB2A2\uB2A4\uB2A7\uB2A8\uB2A9\uB2AB\uB2AD\uB2AE\uB2AF\uB2B1\uB2B2\uB2B3\uB2B5\uB2B6\uB2B7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB2B8\uB2B9\uB2BA\uB2BB\uB2BC\uB2BD\uB2BE\uB2BF\uB2C0\uB2C1\uB2C2\uB2C3\uB2C4\uB2C5\uB2C6\uB2C7\uB2CA\uB2CB\uB2CD\uB2CE\uB2CF\uB2D1\uB2D3\uB2D4\uB2D5\uB2D6\uB2D7\uB2DA\uB2DC\uB2DE\uB2DF\uB2E0\uB2E1\uB2E3\uB2E7\uB2E9\uB2EA\uB2F0\uB2F1\uB2F2\uB2F6\uB2FC\uB2FD\uB2FE\uB302\uB303\uB305\uB306\uB307\uB309\uB30A\uB30B\uB30C\uB30D\uB30E\uB30F\uB312\uB316\uB317\uB318\uB319\uB31A\uB31B\uB31D\uB31E\uB31F\uB320\uB321\uB322\uB323\uB324\uB325\uB326\uB327\uB328\uB329\uB32A\uB32B\uB32C\uB32D\uB32E\uB32F\uB330\uB331\uB332\uB333\uB334\uB335\uB336\uB337\uB338\uB339\uB33A\uB33B\uB33C\uB33D\uB33E\uB33F\uB340\uB341\uB342\uB343\uB344\uB345\uB346\uB347\uB348\uB349\uB34A\uB34B\uB34C\uB34D\uB34E\uB34F\uB350\uB351\uB352\uB353\uB357\uB359\uB35A\uB35D\uB360\uB361\uB362\uB363\uFFFD".split("");
    for(j = 0; j != D[136].length; ++j)if (D[136][j].charCodeAt(0) !== 0xFFFD) {
        e[D[136][j]] = 34816 + j;
        d[34816 + j] = D[136][j];
    }
    D[137] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB366\uB368\uB36A\uB36C\uB36D\uB36F\uB372\uB373\uB375\uB376\uB377\uB379\uB37A\uB37B\uB37C\uB37D\uB37E\uB37F\uB382\uB386\uB387\uB388\uB389\uB38A\uB38B\uB38D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB38E\uB38F\uB391\uB392\uB393\uB395\uB396\uB397\uB398\uB399\uB39A\uB39B\uB39C\uB39D\uB39E\uB39F\uB3A2\uB3A3\uB3A4\uB3A5\uB3A6\uB3A7\uB3A9\uB3AA\uB3AB\uB3AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB3AE\uB3AF\uB3B0\uB3B1\uB3B2\uB3B3\uB3B4\uB3B5\uB3B6\uB3B7\uB3B8\uB3B9\uB3BA\uB3BB\uB3BC\uB3BD\uB3BE\uB3BF\uB3C0\uB3C1\uB3C2\uB3C3\uB3C6\uB3C7\uB3C9\uB3CA\uB3CD\uB3CF\uB3D1\uB3D2\uB3D3\uB3D6\uB3D8\uB3DA\uB3DC\uB3DE\uB3DF\uB3E1\uB3E2\uB3E3\uB3E5\uB3E6\uB3E7\uB3E9\uB3EA\uB3EB\uB3EC\uB3ED\uB3EE\uB3EF\uB3F0\uB3F1\uB3F2\uB3F3\uB3F4\uB3F5\uB3F6\uB3F7\uB3F8\uB3F9\uB3FA\uB3FB\uB3FD\uB3FE\uB3FF\uB400\uB401\uB402\uB403\uB404\uB405\uB406\uB407\uB408\uB409\uB40A\uB40B\uB40C\uB40D\uB40E\uB40F\uB411\uB412\uB413\uB414\uB415\uB416\uB417\uB419\uB41A\uB41B\uB41D\uB41E\uB41F\uB421\uB422\uB423\uB424\uB425\uB426\uB427\uB42A\uB42C\uB42D\uB42E\uB42F\uB430\uB431\uB432\uB433\uB435\uB436\uB437\uB438\uB439\uB43A\uB43B\uB43C\uB43D\uB43E\uB43F\uB440\uB441\uB442\uB443\uB444\uFFFD".split("");
    for(j = 0; j != D[137].length; ++j)if (D[137][j].charCodeAt(0) !== 0xFFFD) {
        e[D[137][j]] = 35072 + j;
        d[35072 + j] = D[137][j];
    }
    D[138] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB445\uB446\uB447\uB448\uB449\uB44A\uB44B\uB44C\uB44D\uB44E\uB44F\uB452\uB453\uB455\uB456\uB457\uB459\uB45A\uB45B\uB45C\uB45D\uB45E\uB45F\uB462\uB464\uB466\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB467\uB468\uB469\uB46A\uB46B\uB46D\uB46E\uB46F\uB470\uB471\uB472\uB473\uB474\uB475\uB476\uB477\uB478\uB479\uB47A\uB47B\uB47C\uB47D\uB47E\uB47F\uB481\uB482\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB483\uB484\uB485\uB486\uB487\uB489\uB48A\uB48B\uB48C\uB48D\uB48E\uB48F\uB490\uB491\uB492\uB493\uB494\uB495\uB496\uB497\uB498\uB499\uB49A\uB49B\uB49C\uB49E\uB49F\uB4A0\uB4A1\uB4A2\uB4A3\uB4A5\uB4A6\uB4A7\uB4A9\uB4AA\uB4AB\uB4AD\uB4AE\uB4AF\uB4B0\uB4B1\uB4B2\uB4B3\uB4B4\uB4B6\uB4B8\uB4BA\uB4BB\uB4BC\uB4BD\uB4BE\uB4BF\uB4C1\uB4C2\uB4C3\uB4C5\uB4C6\uB4C7\uB4C9\uB4CA\uB4CB\uB4CC\uB4CD\uB4CE\uB4CF\uB4D1\uB4D2\uB4D3\uB4D4\uB4D6\uB4D7\uB4D8\uB4D9\uB4DA\uB4DB\uB4DE\uB4DF\uB4E1\uB4E2\uB4E5\uB4E7\uB4E8\uB4E9\uB4EA\uB4EB\uB4EE\uB4F0\uB4F2\uB4F3\uB4F4\uB4F5\uB4F6\uB4F7\uB4F9\uB4FA\uB4FB\uB4FC\uB4FD\uB4FE\uB4FF\uB500\uB501\uB502\uB503\uB504\uB505\uB506\uB507\uB508\uB509\uB50A\uB50B\uB50C\uB50D\uB50E\uB50F\uB510\uB511\uB512\uB513\uB516\uB517\uB519\uB51A\uB51D\uFFFD".split("");
    for(j = 0; j != D[138].length; ++j)if (D[138][j].charCodeAt(0) !== 0xFFFD) {
        e[D[138][j]] = 35328 + j;
        d[35328 + j] = D[138][j];
    }
    D[139] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB51E\uB51F\uB520\uB521\uB522\uB523\uB526\uB52B\uB52C\uB52D\uB52E\uB52F\uB532\uB533\uB535\uB536\uB537\uB539\uB53A\uB53B\uB53C\uB53D\uB53E\uB53F\uB542\uB546\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB547\uB548\uB549\uB54A\uB54E\uB54F\uB551\uB552\uB553\uB555\uB556\uB557\uB558\uB559\uB55A\uB55B\uB55E\uB562\uB563\uB564\uB565\uB566\uB567\uB568\uB569\uB56A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB56B\uB56C\uB56D\uB56E\uB56F\uB570\uB571\uB572\uB573\uB574\uB575\uB576\uB577\uB578\uB579\uB57A\uB57B\uB57C\uB57D\uB57E\uB57F\uB580\uB581\uB582\uB583\uB584\uB585\uB586\uB587\uB588\uB589\uB58A\uB58B\uB58C\uB58D\uB58E\uB58F\uB590\uB591\uB592\uB593\uB594\uB595\uB596\uB597\uB598\uB599\uB59A\uB59B\uB59C\uB59D\uB59E\uB59F\uB5A2\uB5A3\uB5A5\uB5A6\uB5A7\uB5A9\uB5AC\uB5AD\uB5AE\uB5AF\uB5B2\uB5B6\uB5B7\uB5B8\uB5B9\uB5BA\uB5BE\uB5BF\uB5C1\uB5C2\uB5C3\uB5C5\uB5C6\uB5C7\uB5C8\uB5C9\uB5CA\uB5CB\uB5CE\uB5D2\uB5D3\uB5D4\uB5D5\uB5D6\uB5D7\uB5D9\uB5DA\uB5DB\uB5DC\uB5DD\uB5DE\uB5DF\uB5E0\uB5E1\uB5E2\uB5E3\uB5E4\uB5E5\uB5E6\uB5E7\uB5E8\uB5E9\uB5EA\uB5EB\uB5ED\uB5EE\uB5EF\uB5F0\uB5F1\uB5F2\uB5F3\uB5F4\uB5F5\uB5F6\uB5F7\uB5F8\uB5F9\uB5FA\uB5FB\uB5FC\uB5FD\uB5FE\uB5FF\uFFFD".split("");
    for(j = 0; j != D[139].length; ++j)if (D[139][j].charCodeAt(0) !== 0xFFFD) {
        e[D[139][j]] = 35584 + j;
        d[35584 + j] = D[139][j];
    }
    D[140] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB600\uB601\uB602\uB603\uB604\uB605\uB606\uB607\uB608\uB609\uB60A\uB60B\uB60C\uB60D\uB60E\uB60F\uB612\uB613\uB615\uB616\uB617\uB619\uB61A\uB61B\uB61C\uB61D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB61E\uB61F\uB620\uB621\uB622\uB623\uB624\uB626\uB627\uB628\uB629\uB62A\uB62B\uB62D\uB62E\uB62F\uB630\uB631\uB632\uB633\uB635\uB636\uB637\uB638\uB639\uB63A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB63B\uB63C\uB63D\uB63E\uB63F\uB640\uB641\uB642\uB643\uB644\uB645\uB646\uB647\uB649\uB64A\uB64B\uB64C\uB64D\uB64E\uB64F\uB650\uB651\uB652\uB653\uB654\uB655\uB656\uB657\uB658\uB659\uB65A\uB65B\uB65C\uB65D\uB65E\uB65F\uB660\uB661\uB662\uB663\uB665\uB666\uB667\uB669\uB66A\uB66B\uB66C\uB66D\uB66E\uB66F\uB670\uB671\uB672\uB673\uB674\uB675\uB676\uB677\uB678\uB679\uB67A\uB67B\uB67C\uB67D\uB67E\uB67F\uB680\uB681\uB682\uB683\uB684\uB685\uB686\uB687\uB688\uB689\uB68A\uB68B\uB68C\uB68D\uB68E\uB68F\uB690\uB691\uB692\uB693\uB694\uB695\uB696\uB697\uB698\uB699\uB69A\uB69B\uB69E\uB69F\uB6A1\uB6A2\uB6A3\uB6A5\uB6A6\uB6A7\uB6A8\uB6A9\uB6AA\uB6AD\uB6AE\uB6AF\uB6B0\uB6B2\uB6B3\uB6B4\uB6B5\uB6B6\uB6B7\uB6B8\uB6B9\uB6BA\uB6BB\uB6BC\uB6BD\uB6BE\uB6BF\uB6C0\uB6C1\uB6C2\uFFFD".split("");
    for(j = 0; j != D[140].length; ++j)if (D[140][j].charCodeAt(0) !== 0xFFFD) {
        e[D[140][j]] = 35840 + j;
        d[35840 + j] = D[140][j];
    }
    D[141] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB6C3\uB6C4\uB6C5\uB6C6\uB6C7\uB6C8\uB6C9\uB6CA\uB6CB\uB6CC\uB6CD\uB6CE\uB6CF\uB6D0\uB6D1\uB6D2\uB6D3\uB6D5\uB6D6\uB6D7\uB6D8\uB6D9\uB6DA\uB6DB\uB6DC\uB6DD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB6DE\uB6DF\uB6E0\uB6E1\uB6E2\uB6E3\uB6E4\uB6E5\uB6E6\uB6E7\uB6E8\uB6E9\uB6EA\uB6EB\uB6EC\uB6ED\uB6EE\uB6EF\uB6F1\uB6F2\uB6F3\uB6F5\uB6F6\uB6F7\uB6F9\uB6FA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB6FB\uB6FC\uB6FD\uB6FE\uB6FF\uB702\uB703\uB704\uB706\uB707\uB708\uB709\uB70A\uB70B\uB70C\uB70D\uB70E\uB70F\uB710\uB711\uB712\uB713\uB714\uB715\uB716\uB717\uB718\uB719\uB71A\uB71B\uB71C\uB71D\uB71E\uB71F\uB720\uB721\uB722\uB723\uB724\uB725\uB726\uB727\uB72A\uB72B\uB72D\uB72E\uB731\uB732\uB733\uB734\uB735\uB736\uB737\uB73A\uB73C\uB73D\uB73E\uB73F\uB740\uB741\uB742\uB743\uB745\uB746\uB747\uB749\uB74A\uB74B\uB74D\uB74E\uB74F\uB750\uB751\uB752\uB753\uB756\uB757\uB758\uB759\uB75A\uB75B\uB75C\uB75D\uB75E\uB75F\uB761\uB762\uB763\uB765\uB766\uB767\uB769\uB76A\uB76B\uB76C\uB76D\uB76E\uB76F\uB772\uB774\uB776\uB777\uB778\uB779\uB77A\uB77B\uB77E\uB77F\uB781\uB782\uB783\uB785\uB786\uB787\uB788\uB789\uB78A\uB78B\uB78E\uB793\uB794\uB795\uB79A\uB79B\uB79D\uB79E\uFFFD".split("");
    for(j = 0; j != D[141].length; ++j)if (D[141][j].charCodeAt(0) !== 0xFFFD) {
        e[D[141][j]] = 36096 + j;
        d[36096 + j] = D[141][j];
    }
    D[142] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB79F\uB7A1\uB7A2\uB7A3\uB7A4\uB7A5\uB7A6\uB7A7\uB7AA\uB7AE\uB7AF\uB7B0\uB7B1\uB7B2\uB7B3\uB7B6\uB7B7\uB7B9\uB7BA\uB7BB\uB7BC\uB7BD\uB7BE\uB7BF\uB7C0\uB7C1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB7C2\uB7C3\uB7C4\uB7C5\uB7C6\uB7C8\uB7CA\uB7CB\uB7CC\uB7CD\uB7CE\uB7CF\uB7D0\uB7D1\uB7D2\uB7D3\uB7D4\uB7D5\uB7D6\uB7D7\uB7D8\uB7D9\uB7DA\uB7DB\uB7DC\uB7DD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB7DE\uB7DF\uB7E0\uB7E1\uB7E2\uB7E3\uB7E4\uB7E5\uB7E6\uB7E7\uB7E8\uB7E9\uB7EA\uB7EB\uB7EE\uB7EF\uB7F1\uB7F2\uB7F3\uB7F5\uB7F6\uB7F7\uB7F8\uB7F9\uB7FA\uB7FB\uB7FE\uB802\uB803\uB804\uB805\uB806\uB80A\uB80B\uB80D\uB80E\uB80F\uB811\uB812\uB813\uB814\uB815\uB816\uB817\uB81A\uB81C\uB81E\uB81F\uB820\uB821\uB822\uB823\uB826\uB827\uB829\uB82A\uB82B\uB82D\uB82E\uB82F\uB830\uB831\uB832\uB833\uB836\uB83A\uB83B\uB83C\uB83D\uB83E\uB83F\uB841\uB842\uB843\uB845\uB846\uB847\uB848\uB849\uB84A\uB84B\uB84C\uB84D\uB84E\uB84F\uB850\uB852\uB854\uB855\uB856\uB857\uB858\uB859\uB85A\uB85B\uB85E\uB85F\uB861\uB862\uB863\uB865\uB866\uB867\uB868\uB869\uB86A\uB86B\uB86E\uB870\uB872\uB873\uB874\uB875\uB876\uB877\uB879\uB87A\uB87B\uB87D\uB87E\uB87F\uB880\uB881\uB882\uB883\uB884\uFFFD".split("");
    for(j = 0; j != D[142].length; ++j)if (D[142][j].charCodeAt(0) !== 0xFFFD) {
        e[D[142][j]] = 36352 + j;
        d[36352 + j] = D[142][j];
    }
    D[143] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB885\uB886\uB887\uB888\uB889\uB88A\uB88B\uB88C\uB88E\uB88F\uB890\uB891\uB892\uB893\uB894\uB895\uB896\uB897\uB898\uB899\uB89A\uB89B\uB89C\uB89D\uB89E\uB89F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB8A0\uB8A1\uB8A2\uB8A3\uB8A4\uB8A5\uB8A6\uB8A7\uB8A9\uB8AA\uB8AB\uB8AC\uB8AD\uB8AE\uB8AF\uB8B1\uB8B2\uB8B3\uB8B5\uB8B6\uB8B7\uB8B9\uB8BA\uB8BB\uB8BC\uB8BD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB8BE\uB8BF\uB8C2\uB8C4\uB8C6\uB8C7\uB8C8\uB8C9\uB8CA\uB8CB\uB8CD\uB8CE\uB8CF\uB8D1\uB8D2\uB8D3\uB8D5\uB8D6\uB8D7\uB8D8\uB8D9\uB8DA\uB8DB\uB8DC\uB8DE\uB8E0\uB8E2\uB8E3\uB8E4\uB8E5\uB8E6\uB8E7\uB8EA\uB8EB\uB8ED\uB8EE\uB8EF\uB8F1\uB8F2\uB8F3\uB8F4\uB8F5\uB8F6\uB8F7\uB8FA\uB8FC\uB8FE\uB8FF\uB900\uB901\uB902\uB903\uB905\uB906\uB907\uB908\uB909\uB90A\uB90B\uB90C\uB90D\uB90E\uB90F\uB910\uB911\uB912\uB913\uB914\uB915\uB916\uB917\uB919\uB91A\uB91B\uB91C\uB91D\uB91E\uB91F\uB921\uB922\uB923\uB924\uB925\uB926\uB927\uB928\uB929\uB92A\uB92B\uB92C\uB92D\uB92E\uB92F\uB930\uB931\uB932\uB933\uB934\uB935\uB936\uB937\uB938\uB939\uB93A\uB93B\uB93E\uB93F\uB941\uB942\uB943\uB945\uB946\uB947\uB948\uB949\uB94A\uB94B\uB94D\uB94E\uB950\uB952\uB953\uB954\uB955\uB956\uB957\uFFFD".split("");
    for(j = 0; j != D[143].length; ++j)if (D[143][j].charCodeAt(0) !== 0xFFFD) {
        e[D[143][j]] = 36608 + j;
        d[36608 + j] = D[143][j];
    }
    D[144] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB95A\uB95B\uB95D\uB95E\uB95F\uB961\uB962\uB963\uB964\uB965\uB966\uB967\uB96A\uB96C\uB96E\uB96F\uB970\uB971\uB972\uB973\uB976\uB977\uB979\uB97A\uB97B\uB97D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB97E\uB97F\uB980\uB981\uB982\uB983\uB986\uB988\uB98B\uB98C\uB98F\uB990\uB991\uB992\uB993\uB994\uB995\uB996\uB997\uB998\uB999\uB99A\uB99B\uB99C\uB99D\uB99E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB99F\uB9A0\uB9A1\uB9A2\uB9A3\uB9A4\uB9A5\uB9A6\uB9A7\uB9A8\uB9A9\uB9AA\uB9AB\uB9AE\uB9AF\uB9B1\uB9B2\uB9B3\uB9B5\uB9B6\uB9B7\uB9B8\uB9B9\uB9BA\uB9BB\uB9BE\uB9C0\uB9C2\uB9C3\uB9C4\uB9C5\uB9C6\uB9C7\uB9CA\uB9CB\uB9CD\uB9D3\uB9D4\uB9D5\uB9D6\uB9D7\uB9DA\uB9DC\uB9DF\uB9E0\uB9E2\uB9E6\uB9E7\uB9E9\uB9EA\uB9EB\uB9ED\uB9EE\uB9EF\uB9F0\uB9F1\uB9F2\uB9F3\uB9F6\uB9FB\uB9FC\uB9FD\uB9FE\uB9FF\uBA02\uBA03\uBA04\uBA05\uBA06\uBA07\uBA09\uBA0A\uBA0B\uBA0C\uBA0D\uBA0E\uBA0F\uBA10\uBA11\uBA12\uBA13\uBA14\uBA16\uBA17\uBA18\uBA19\uBA1A\uBA1B\uBA1C\uBA1D\uBA1E\uBA1F\uBA20\uBA21\uBA22\uBA23\uBA24\uBA25\uBA26\uBA27\uBA28\uBA29\uBA2A\uBA2B\uBA2C\uBA2D\uBA2E\uBA2F\uBA30\uBA31\uBA32\uBA33\uBA34\uBA35\uBA36\uBA37\uBA3A\uBA3B\uBA3D\uBA3E\uBA3F\uBA41\uBA43\uBA44\uBA45\uBA46\uFFFD".split("");
    for(j = 0; j != D[144].length; ++j)if (D[144][j].charCodeAt(0) !== 0xFFFD) {
        e[D[144][j]] = 36864 + j;
        d[36864 + j] = D[144][j];
    }
    D[145] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBA47\uBA4A\uBA4C\uBA4F\uBA50\uBA51\uBA52\uBA56\uBA57\uBA59\uBA5A\uBA5B\uBA5D\uBA5E\uBA5F\uBA60\uBA61\uBA62\uBA63\uBA66\uBA6A\uBA6B\uBA6C\uBA6D\uBA6E\uBA6F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBA72\uBA73\uBA75\uBA76\uBA77\uBA79\uBA7A\uBA7B\uBA7C\uBA7D\uBA7E\uBA7F\uBA80\uBA81\uBA82\uBA86\uBA88\uBA89\uBA8A\uBA8B\uBA8D\uBA8E\uBA8F\uBA90\uBA91\uBA92\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBA93\uBA94\uBA95\uBA96\uBA97\uBA98\uBA99\uBA9A\uBA9B\uBA9C\uBA9D\uBA9E\uBA9F\uBAA0\uBAA1\uBAA2\uBAA3\uBAA4\uBAA5\uBAA6\uBAA7\uBAAA\uBAAD\uBAAE\uBAAF\uBAB1\uBAB3\uBAB4\uBAB5\uBAB6\uBAB7\uBABA\uBABC\uBABE\uBABF\uBAC0\uBAC1\uBAC2\uBAC3\uBAC5\uBAC6\uBAC7\uBAC9\uBACA\uBACB\uBACC\uBACD\uBACE\uBACF\uBAD0\uBAD1\uBAD2\uBAD3\uBAD4\uBAD5\uBAD6\uBAD7\uBADA\uBADB\uBADC\uBADD\uBADE\uBADF\uBAE0\uBAE1\uBAE2\uBAE3\uBAE4\uBAE5\uBAE6\uBAE7\uBAE8\uBAE9\uBAEA\uBAEB\uBAEC\uBAED\uBAEE\uBAEF\uBAF0\uBAF1\uBAF2\uBAF3\uBAF4\uBAF5\uBAF6\uBAF7\uBAF8\uBAF9\uBAFA\uBAFB\uBAFD\uBAFE\uBAFF\uBB01\uBB02\uBB03\uBB05\uBB06\uBB07\uBB08\uBB09\uBB0A\uBB0B\uBB0C\uBB0E\uBB10\uBB12\uBB13\uBB14\uBB15\uBB16\uBB17\uBB19\uBB1A\uBB1B\uBB1D\uBB1E\uBB1F\uBB21\uBB22\uBB23\uBB24\uBB25\uBB26\uBB27\uFFFD".split("");
    for(j = 0; j != D[145].length; ++j)if (D[145][j].charCodeAt(0) !== 0xFFFD) {
        e[D[145][j]] = 37120 + j;
        d[37120 + j] = D[145][j];
    }
    D[146] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBB28\uBB2A\uBB2C\uBB2D\uBB2E\uBB2F\uBB30\uBB31\uBB32\uBB33\uBB37\uBB39\uBB3A\uBB3F\uBB40\uBB41\uBB42\uBB43\uBB46\uBB48\uBB4A\uBB4B\uBB4C\uBB4E\uBB51\uBB52\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBB53\uBB55\uBB56\uBB57\uBB59\uBB5A\uBB5B\uBB5C\uBB5D\uBB5E\uBB5F\uBB60\uBB62\uBB64\uBB65\uBB66\uBB67\uBB68\uBB69\uBB6A\uBB6B\uBB6D\uBB6E\uBB6F\uBB70\uBB71\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBB72\uBB73\uBB74\uBB75\uBB76\uBB77\uBB78\uBB79\uBB7A\uBB7B\uBB7C\uBB7D\uBB7E\uBB7F\uBB80\uBB81\uBB82\uBB83\uBB84\uBB85\uBB86\uBB87\uBB89\uBB8A\uBB8B\uBB8D\uBB8E\uBB8F\uBB91\uBB92\uBB93\uBB94\uBB95\uBB96\uBB97\uBB98\uBB99\uBB9A\uBB9B\uBB9C\uBB9D\uBB9E\uBB9F\uBBA0\uBBA1\uBBA2\uBBA3\uBBA5\uBBA6\uBBA7\uBBA9\uBBAA\uBBAB\uBBAD\uBBAE\uBBAF\uBBB0\uBBB1\uBBB2\uBBB3\uBBB5\uBBB6\uBBB8\uBBB9\uBBBA\uBBBB\uBBBC\uBBBD\uBBBE\uBBBF\uBBC1\uBBC2\uBBC3\uBBC5\uBBC6\uBBC7\uBBC9\uBBCA\uBBCB\uBBCC\uBBCD\uBBCE\uBBCF\uBBD1\uBBD2\uBBD4\uBBD5\uBBD6\uBBD7\uBBD8\uBBD9\uBBDA\uBBDB\uBBDC\uBBDD\uBBDE\uBBDF\uBBE0\uBBE1\uBBE2\uBBE3\uBBE4\uBBE5\uBBE6\uBBE7\uBBE8\uBBE9\uBBEA\uBBEB\uBBEC\uBBED\uBBEE\uBBEF\uBBF0\uBBF1\uBBF2\uBBF3\uBBF4\uBBF5\uBBF6\uBBF7\uBBFA\uBBFB\uBBFD\uBBFE\uBC01\uFFFD".split("");
    for(j = 0; j != D[146].length; ++j)if (D[146][j].charCodeAt(0) !== 0xFFFD) {
        e[D[146][j]] = 37376 + j;
        d[37376 + j] = D[146][j];
    }
    D[147] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBC03\uBC04\uBC05\uBC06\uBC07\uBC0A\uBC0E\uBC10\uBC12\uBC13\uBC19\uBC1A\uBC20\uBC21\uBC22\uBC23\uBC26\uBC28\uBC2A\uBC2B\uBC2C\uBC2E\uBC2F\uBC32\uBC33\uBC35\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBC36\uBC37\uBC39\uBC3A\uBC3B\uBC3C\uBC3D\uBC3E\uBC3F\uBC42\uBC46\uBC47\uBC48\uBC4A\uBC4B\uBC4E\uBC4F\uBC51\uBC52\uBC53\uBC54\uBC55\uBC56\uBC57\uBC58\uBC59\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBC5A\uBC5B\uBC5C\uBC5E\uBC5F\uBC60\uBC61\uBC62\uBC63\uBC64\uBC65\uBC66\uBC67\uBC68\uBC69\uBC6A\uBC6B\uBC6C\uBC6D\uBC6E\uBC6F\uBC70\uBC71\uBC72\uBC73\uBC74\uBC75\uBC76\uBC77\uBC78\uBC79\uBC7A\uBC7B\uBC7C\uBC7D\uBC7E\uBC7F\uBC80\uBC81\uBC82\uBC83\uBC86\uBC87\uBC89\uBC8A\uBC8D\uBC8F\uBC90\uBC91\uBC92\uBC93\uBC96\uBC98\uBC9B\uBC9C\uBC9D\uBC9E\uBC9F\uBCA2\uBCA3\uBCA5\uBCA6\uBCA9\uBCAA\uBCAB\uBCAC\uBCAD\uBCAE\uBCAF\uBCB2\uBCB6\uBCB7\uBCB8\uBCB9\uBCBA\uBCBB\uBCBE\uBCBF\uBCC1\uBCC2\uBCC3\uBCC5\uBCC6\uBCC7\uBCC8\uBCC9\uBCCA\uBCCB\uBCCC\uBCCE\uBCD2\uBCD3\uBCD4\uBCD6\uBCD7\uBCD9\uBCDA\uBCDB\uBCDD\uBCDE\uBCDF\uBCE0\uBCE1\uBCE2\uBCE3\uBCE4\uBCE5\uBCE6\uBCE7\uBCE8\uBCE9\uBCEA\uBCEB\uBCEC\uBCED\uBCEE\uBCEF\uBCF0\uBCF1\uBCF2\uBCF3\uBCF7\uBCF9\uBCFA\uBCFB\uBCFD\uFFFD".split("");
    for(j = 0; j != D[147].length; ++j)if (D[147][j].charCodeAt(0) !== 0xFFFD) {
        e[D[147][j]] = 37632 + j;
        d[37632 + j] = D[147][j];
    }
    D[148] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBCFE\uBCFF\uBD00\uBD01\uBD02\uBD03\uBD06\uBD08\uBD0A\uBD0B\uBD0C\uBD0D\uBD0E\uBD0F\uBD11\uBD12\uBD13\uBD15\uBD16\uBD17\uBD18\uBD19\uBD1A\uBD1B\uBD1C\uBD1D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBD1E\uBD1F\uBD20\uBD21\uBD22\uBD23\uBD25\uBD26\uBD27\uBD28\uBD29\uBD2A\uBD2B\uBD2D\uBD2E\uBD2F\uBD30\uBD31\uBD32\uBD33\uBD34\uBD35\uBD36\uBD37\uBD38\uBD39\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBD3A\uBD3B\uBD3C\uBD3D\uBD3E\uBD3F\uBD41\uBD42\uBD43\uBD44\uBD45\uBD46\uBD47\uBD4A\uBD4B\uBD4D\uBD4E\uBD4F\uBD51\uBD52\uBD53\uBD54\uBD55\uBD56\uBD57\uBD5A\uBD5B\uBD5C\uBD5D\uBD5E\uBD5F\uBD60\uBD61\uBD62\uBD63\uBD65\uBD66\uBD67\uBD69\uBD6A\uBD6B\uBD6C\uBD6D\uBD6E\uBD6F\uBD70\uBD71\uBD72\uBD73\uBD74\uBD75\uBD76\uBD77\uBD78\uBD79\uBD7A\uBD7B\uBD7C\uBD7D\uBD7E\uBD7F\uBD82\uBD83\uBD85\uBD86\uBD8B\uBD8C\uBD8D\uBD8E\uBD8F\uBD92\uBD94\uBD96\uBD97\uBD98\uBD9B\uBD9D\uBD9E\uBD9F\uBDA0\uBDA1\uBDA2\uBDA3\uBDA5\uBDA6\uBDA7\uBDA8\uBDA9\uBDAA\uBDAB\uBDAC\uBDAD\uBDAE\uBDAF\uBDB1\uBDB2\uBDB3\uBDB4\uBDB5\uBDB6\uBDB7\uBDB9\uBDBA\uBDBB\uBDBC\uBDBD\uBDBE\uBDBF\uBDC0\uBDC1\uBDC2\uBDC3\uBDC4\uBDC5\uBDC6\uBDC7\uBDC8\uBDC9\uBDCA\uBDCB\uBDCC\uBDCD\uBDCE\uBDCF\uBDD0\uBDD1\uFFFD".split("");
    for(j = 0; j != D[148].length; ++j)if (D[148][j].charCodeAt(0) !== 0xFFFD) {
        e[D[148][j]] = 37888 + j;
        d[37888 + j] = D[148][j];
    }
    D[149] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBDD2\uBDD3\uBDD6\uBDD7\uBDD9\uBDDA\uBDDB\uBDDD\uBDDE\uBDDF\uBDE0\uBDE1\uBDE2\uBDE3\uBDE4\uBDE5\uBDE6\uBDE7\uBDE8\uBDEA\uBDEB\uBDEC\uBDED\uBDEE\uBDEF\uBDF1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBDF2\uBDF3\uBDF5\uBDF6\uBDF7\uBDF9\uBDFA\uBDFB\uBDFC\uBDFD\uBDFE\uBDFF\uBE01\uBE02\uBE04\uBE06\uBE07\uBE08\uBE09\uBE0A\uBE0B\uBE0E\uBE0F\uBE11\uBE12\uBE13\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBE15\uBE16\uBE17\uBE18\uBE19\uBE1A\uBE1B\uBE1E\uBE20\uBE21\uBE22\uBE23\uBE24\uBE25\uBE26\uBE27\uBE28\uBE29\uBE2A\uBE2B\uBE2C\uBE2D\uBE2E\uBE2F\uBE30\uBE31\uBE32\uBE33\uBE34\uBE35\uBE36\uBE37\uBE38\uBE39\uBE3A\uBE3B\uBE3C\uBE3D\uBE3E\uBE3F\uBE40\uBE41\uBE42\uBE43\uBE46\uBE47\uBE49\uBE4A\uBE4B\uBE4D\uBE4F\uBE50\uBE51\uBE52\uBE53\uBE56\uBE58\uBE5C\uBE5D\uBE5E\uBE5F\uBE62\uBE63\uBE65\uBE66\uBE67\uBE69\uBE6B\uBE6C\uBE6D\uBE6E\uBE6F\uBE72\uBE76\uBE77\uBE78\uBE79\uBE7A\uBE7E\uBE7F\uBE81\uBE82\uBE83\uBE85\uBE86\uBE87\uBE88\uBE89\uBE8A\uBE8B\uBE8E\uBE92\uBE93\uBE94\uBE95\uBE96\uBE97\uBE9A\uBE9B\uBE9C\uBE9D\uBE9E\uBE9F\uBEA0\uBEA1\uBEA2\uBEA3\uBEA4\uBEA5\uBEA6\uBEA7\uBEA9\uBEAA\uBEAB\uBEAC\uBEAD\uBEAE\uBEAF\uBEB0\uBEB1\uBEB2\uBEB3\uBEB4\uBEB5\uBEB6\uBEB7\uFFFD".split("");
    for(j = 0; j != D[149].length; ++j)if (D[149][j].charCodeAt(0) !== 0xFFFD) {
        e[D[149][j]] = 38144 + j;
        d[38144 + j] = D[149][j];
    }
    D[150] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBEB8\uBEB9\uBEBA\uBEBB\uBEBC\uBEBD\uBEBE\uBEBF\uBEC0\uBEC1\uBEC2\uBEC3\uBEC4\uBEC5\uBEC6\uBEC7\uBEC8\uBEC9\uBECA\uBECB\uBECC\uBECD\uBECE\uBECF\uBED2\uBED3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBED5\uBED6\uBED9\uBEDA\uBEDB\uBEDC\uBEDD\uBEDE\uBEDF\uBEE1\uBEE2\uBEE6\uBEE7\uBEE8\uBEE9\uBEEA\uBEEB\uBEED\uBEEE\uBEEF\uBEF0\uBEF1\uBEF2\uBEF3\uBEF4\uBEF5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBEF6\uBEF7\uBEF8\uBEF9\uBEFA\uBEFB\uBEFC\uBEFD\uBEFE\uBEFF\uBF00\uBF02\uBF03\uBF04\uBF05\uBF06\uBF07\uBF0A\uBF0B\uBF0C\uBF0D\uBF0E\uBF0F\uBF10\uBF11\uBF12\uBF13\uBF14\uBF15\uBF16\uBF17\uBF1A\uBF1E\uBF1F\uBF20\uBF21\uBF22\uBF23\uBF24\uBF25\uBF26\uBF27\uBF28\uBF29\uBF2A\uBF2B\uBF2C\uBF2D\uBF2E\uBF2F\uBF30\uBF31\uBF32\uBF33\uBF34\uBF35\uBF36\uBF37\uBF38\uBF39\uBF3A\uBF3B\uBF3C\uBF3D\uBF3E\uBF3F\uBF42\uBF43\uBF45\uBF46\uBF47\uBF49\uBF4A\uBF4B\uBF4C\uBF4D\uBF4E\uBF4F\uBF52\uBF53\uBF54\uBF56\uBF57\uBF58\uBF59\uBF5A\uBF5B\uBF5C\uBF5D\uBF5E\uBF5F\uBF60\uBF61\uBF62\uBF63\uBF64\uBF65\uBF66\uBF67\uBF68\uBF69\uBF6A\uBF6B\uBF6C\uBF6D\uBF6E\uBF6F\uBF70\uBF71\uBF72\uBF73\uBF74\uBF75\uBF76\uBF77\uBF78\uBF79\uBF7A\uBF7B\uBF7C\uBF7D\uBF7E\uBF7F\uBF80\uBF81\uBF82\uFFFD".split("");
    for(j = 0; j != D[150].length; ++j)if (D[150][j].charCodeAt(0) !== 0xFFFD) {
        e[D[150][j]] = 38400 + j;
        d[38400 + j] = D[150][j];
    }
    D[151] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBF83\uBF84\uBF85\uBF86\uBF87\uBF88\uBF89\uBF8A\uBF8B\uBF8C\uBF8D\uBF8E\uBF8F\uBF90\uBF91\uBF92\uBF93\uBF95\uBF96\uBF97\uBF98\uBF99\uBF9A\uBF9B\uBF9C\uBF9D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBF9E\uBF9F\uBFA0\uBFA1\uBFA2\uBFA3\uBFA4\uBFA5\uBFA6\uBFA7\uBFA8\uBFA9\uBFAA\uBFAB\uBFAC\uBFAD\uBFAE\uBFAF\uBFB1\uBFB2\uBFB3\uBFB4\uBFB5\uBFB6\uBFB7\uBFB8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBFB9\uBFBA\uBFBB\uBFBC\uBFBD\uBFBE\uBFBF\uBFC0\uBFC1\uBFC2\uBFC3\uBFC4\uBFC6\uBFC7\uBFC8\uBFC9\uBFCA\uBFCB\uBFCE\uBFCF\uBFD1\uBFD2\uBFD3\uBFD5\uBFD6\uBFD7\uBFD8\uBFD9\uBFDA\uBFDB\uBFDD\uBFDE\uBFE0\uBFE2\uBFE3\uBFE4\uBFE5\uBFE6\uBFE7\uBFE8\uBFE9\uBFEA\uBFEB\uBFEC\uBFED\uBFEE\uBFEF\uBFF0\uBFF1\uBFF2\uBFF3\uBFF4\uBFF5\uBFF6\uBFF7\uBFF8\uBFF9\uBFFA\uBFFB\uBFFC\uBFFD\uBFFE\uBFFF\uC000\uC001\uC002\uC003\uC004\uC005\uC006\uC007\uC008\uC009\uC00A\uC00B\uC00C\uC00D\uC00E\uC00F\uC010\uC011\uC012\uC013\uC014\uC015\uC016\uC017\uC018\uC019\uC01A\uC01B\uC01C\uC01D\uC01E\uC01F\uC020\uC021\uC022\uC023\uC024\uC025\uC026\uC027\uC028\uC029\uC02A\uC02B\uC02C\uC02D\uC02E\uC02F\uC030\uC031\uC032\uC033\uC034\uC035\uC036\uC037\uC038\uC039\uC03A\uC03B\uC03D\uC03E\uC03F\uFFFD".split("");
    for(j = 0; j != D[151].length; ++j)if (D[151][j].charCodeAt(0) !== 0xFFFD) {
        e[D[151][j]] = 38656 + j;
        d[38656 + j] = D[151][j];
    }
    D[152] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC040\uC041\uC042\uC043\uC044\uC045\uC046\uC047\uC048\uC049\uC04A\uC04B\uC04C\uC04D\uC04E\uC04F\uC050\uC052\uC053\uC054\uC055\uC056\uC057\uC059\uC05A\uC05B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC05D\uC05E\uC05F\uC061\uC062\uC063\uC064\uC065\uC066\uC067\uC06A\uC06B\uC06C\uC06D\uC06E\uC06F\uC070\uC071\uC072\uC073\uC074\uC075\uC076\uC077\uC078\uC079\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC07A\uC07B\uC07C\uC07D\uC07E\uC07F\uC080\uC081\uC082\uC083\uC084\uC085\uC086\uC087\uC088\uC089\uC08A\uC08B\uC08C\uC08D\uC08E\uC08F\uC092\uC093\uC095\uC096\uC097\uC099\uC09A\uC09B\uC09C\uC09D\uC09E\uC09F\uC0A2\uC0A4\uC0A6\uC0A7\uC0A8\uC0A9\uC0AA\uC0AB\uC0AE\uC0B1\uC0B2\uC0B7\uC0B8\uC0B9\uC0BA\uC0BB\uC0BE\uC0C2\uC0C3\uC0C4\uC0C6\uC0C7\uC0CA\uC0CB\uC0CD\uC0CE\uC0CF\uC0D1\uC0D2\uC0D3\uC0D4\uC0D5\uC0D6\uC0D7\uC0DA\uC0DE\uC0DF\uC0E0\uC0E1\uC0E2\uC0E3\uC0E6\uC0E7\uC0E9\uC0EA\uC0EB\uC0ED\uC0EE\uC0EF\uC0F0\uC0F1\uC0F2\uC0F3\uC0F6\uC0F8\uC0FA\uC0FB\uC0FC\uC0FD\uC0FE\uC0FF\uC101\uC102\uC103\uC105\uC106\uC107\uC109\uC10A\uC10B\uC10C\uC10D\uC10E\uC10F\uC111\uC112\uC113\uC114\uC116\uC117\uC118\uC119\uC11A\uC11B\uC121\uC122\uC125\uC128\uC129\uC12A\uC12B\uC12E\uFFFD".split("");
    for(j = 0; j != D[152].length; ++j)if (D[152][j].charCodeAt(0) !== 0xFFFD) {
        e[D[152][j]] = 38912 + j;
        d[38912 + j] = D[152][j];
    }
    D[153] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC132\uC133\uC134\uC135\uC137\uC13A\uC13B\uC13D\uC13E\uC13F\uC141\uC142\uC143\uC144\uC145\uC146\uC147\uC14A\uC14E\uC14F\uC150\uC151\uC152\uC153\uC156\uC157\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC159\uC15A\uC15B\uC15D\uC15E\uC15F\uC160\uC161\uC162\uC163\uC166\uC16A\uC16B\uC16C\uC16D\uC16E\uC16F\uC171\uC172\uC173\uC175\uC176\uC177\uC179\uC17A\uC17B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC17C\uC17D\uC17E\uC17F\uC180\uC181\uC182\uC183\uC184\uC186\uC187\uC188\uC189\uC18A\uC18B\uC18F\uC191\uC192\uC193\uC195\uC197\uC198\uC199\uC19A\uC19B\uC19E\uC1A0\uC1A2\uC1A3\uC1A4\uC1A6\uC1A7\uC1AA\uC1AB\uC1AD\uC1AE\uC1AF\uC1B1\uC1B2\uC1B3\uC1B4\uC1B5\uC1B6\uC1B7\uC1B8\uC1B9\uC1BA\uC1BB\uC1BC\uC1BE\uC1BF\uC1C0\uC1C1\uC1C2\uC1C3\uC1C5\uC1C6\uC1C7\uC1C9\uC1CA\uC1CB\uC1CD\uC1CE\uC1CF\uC1D0\uC1D1\uC1D2\uC1D3\uC1D5\uC1D6\uC1D9\uC1DA\uC1DB\uC1DC\uC1DD\uC1DE\uC1DF\uC1E1\uC1E2\uC1E3\uC1E5\uC1E6\uC1E7\uC1E9\uC1EA\uC1EB\uC1EC\uC1ED\uC1EE\uC1EF\uC1F2\uC1F4\uC1F5\uC1F6\uC1F7\uC1F8\uC1F9\uC1FA\uC1FB\uC1FE\uC1FF\uC201\uC202\uC203\uC205\uC206\uC207\uC208\uC209\uC20A\uC20B\uC20E\uC210\uC212\uC213\uC214\uC215\uC216\uC217\uC21A\uC21B\uC21D\uC21E\uC221\uC222\uC223\uFFFD".split("");
    for(j = 0; j != D[153].length; ++j)if (D[153][j].charCodeAt(0) !== 0xFFFD) {
        e[D[153][j]] = 39168 + j;
        d[39168 + j] = D[153][j];
    }
    D[154] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC224\uC225\uC226\uC227\uC22A\uC22C\uC22E\uC230\uC233\uC235\uC236\uC237\uC238\uC239\uC23A\uC23B\uC23C\uC23D\uC23E\uC23F\uC240\uC241\uC242\uC243\uC244\uC245\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC246\uC247\uC249\uC24A\uC24B\uC24C\uC24D\uC24E\uC24F\uC252\uC253\uC255\uC256\uC257\uC259\uC25A\uC25B\uC25C\uC25D\uC25E\uC25F\uC261\uC262\uC263\uC264\uC266\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC267\uC268\uC269\uC26A\uC26B\uC26E\uC26F\uC271\uC272\uC273\uC275\uC276\uC277\uC278\uC279\uC27A\uC27B\uC27E\uC280\uC282\uC283\uC284\uC285\uC286\uC287\uC28A\uC28B\uC28C\uC28D\uC28E\uC28F\uC291\uC292\uC293\uC294\uC295\uC296\uC297\uC299\uC29A\uC29C\uC29E\uC29F\uC2A0\uC2A1\uC2A2\uC2A3\uC2A6\uC2A7\uC2A9\uC2AA\uC2AB\uC2AE\uC2AF\uC2B0\uC2B1\uC2B2\uC2B3\uC2B6\uC2B8\uC2BA\uC2BB\uC2BC\uC2BD\uC2BE\uC2BF\uC2C0\uC2C1\uC2C2\uC2C3\uC2C4\uC2C5\uC2C6\uC2C7\uC2C8\uC2C9\uC2CA\uC2CB\uC2CC\uC2CD\uC2CE\uC2CF\uC2D0\uC2D1\uC2D2\uC2D3\uC2D4\uC2D5\uC2D6\uC2D7\uC2D8\uC2D9\uC2DA\uC2DB\uC2DE\uC2DF\uC2E1\uC2E2\uC2E5\uC2E6\uC2E7\uC2E8\uC2E9\uC2EA\uC2EE\uC2F0\uC2F2\uC2F3\uC2F4\uC2F5\uC2F7\uC2FA\uC2FD\uC2FE\uC2FF\uC301\uC302\uC303\uC304\uC305\uC306\uC307\uC30A\uC30B\uC30E\uC30F\uFFFD".split("");
    for(j = 0; j != D[154].length; ++j)if (D[154][j].charCodeAt(0) !== 0xFFFD) {
        e[D[154][j]] = 39424 + j;
        d[39424 + j] = D[154][j];
    }
    D[155] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC310\uC311\uC312\uC316\uC317\uC319\uC31A\uC31B\uC31D\uC31E\uC31F\uC320\uC321\uC322\uC323\uC326\uC327\uC32A\uC32B\uC32C\uC32D\uC32E\uC32F\uC330\uC331\uC332\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC333\uC334\uC335\uC336\uC337\uC338\uC339\uC33A\uC33B\uC33C\uC33D\uC33E\uC33F\uC340\uC341\uC342\uC343\uC344\uC346\uC347\uC348\uC349\uC34A\uC34B\uC34C\uC34D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC34E\uC34F\uC350\uC351\uC352\uC353\uC354\uC355\uC356\uC357\uC358\uC359\uC35A\uC35B\uC35C\uC35D\uC35E\uC35F\uC360\uC361\uC362\uC363\uC364\uC365\uC366\uC367\uC36A\uC36B\uC36D\uC36E\uC36F\uC371\uC373\uC374\uC375\uC376\uC377\uC37A\uC37B\uC37E\uC37F\uC380\uC381\uC382\uC383\uC385\uC386\uC387\uC389\uC38A\uC38B\uC38D\uC38E\uC38F\uC390\uC391\uC392\uC393\uC394\uC395\uC396\uC397\uC398\uC399\uC39A\uC39B\uC39C\uC39D\uC39E\uC39F\uC3A0\uC3A1\uC3A2\uC3A3\uC3A4\uC3A5\uC3A6\uC3A7\uC3A8\uC3A9\uC3AA\uC3AB\uC3AC\uC3AD\uC3AE\uC3AF\uC3B0\uC3B1\uC3B2\uC3B3\uC3B4\uC3B5\uC3B6\uC3B7\uC3B8\uC3B9\uC3BA\uC3BB\uC3BC\uC3BD\uC3BE\uC3BF\uC3C1\uC3C2\uC3C3\uC3C4\uC3C5\uC3C6\uC3C7\uC3C8\uC3C9\uC3CA\uC3CB\uC3CC\uC3CD\uC3CE\uC3CF\uC3D0\uC3D1\uC3D2\uC3D3\uC3D4\uC3D5\uC3D6\uC3D7\uC3DA\uFFFD".split("");
    for(j = 0; j != D[155].length; ++j)if (D[155][j].charCodeAt(0) !== 0xFFFD) {
        e[D[155][j]] = 39680 + j;
        d[39680 + j] = D[155][j];
    }
    D[156] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC3DB\uC3DD\uC3DE\uC3E1\uC3E3\uC3E4\uC3E5\uC3E6\uC3E7\uC3EA\uC3EB\uC3EC\uC3EE\uC3EF\uC3F0\uC3F1\uC3F2\uC3F3\uC3F6\uC3F7\uC3F9\uC3FA\uC3FB\uC3FC\uC3FD\uC3FE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC3FF\uC400\uC401\uC402\uC403\uC404\uC405\uC406\uC407\uC409\uC40A\uC40B\uC40C\uC40D\uC40E\uC40F\uC411\uC412\uC413\uC414\uC415\uC416\uC417\uC418\uC419\uC41A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC41B\uC41C\uC41D\uC41E\uC41F\uC420\uC421\uC422\uC423\uC425\uC426\uC427\uC428\uC429\uC42A\uC42B\uC42D\uC42E\uC42F\uC431\uC432\uC433\uC435\uC436\uC437\uC438\uC439\uC43A\uC43B\uC43E\uC43F\uC440\uC441\uC442\uC443\uC444\uC445\uC446\uC447\uC449\uC44A\uC44B\uC44C\uC44D\uC44E\uC44F\uC450\uC451\uC452\uC453\uC454\uC455\uC456\uC457\uC458\uC459\uC45A\uC45B\uC45C\uC45D\uC45E\uC45F\uC460\uC461\uC462\uC463\uC466\uC467\uC469\uC46A\uC46B\uC46D\uC46E\uC46F\uC470\uC471\uC472\uC473\uC476\uC477\uC478\uC47A\uC47B\uC47C\uC47D\uC47E\uC47F\uC481\uC482\uC483\uC484\uC485\uC486\uC487\uC488\uC489\uC48A\uC48B\uC48C\uC48D\uC48E\uC48F\uC490\uC491\uC492\uC493\uC495\uC496\uC497\uC498\uC499\uC49A\uC49B\uC49D\uC49E\uC49F\uC4A0\uC4A1\uC4A2\uC4A3\uC4A4\uC4A5\uC4A6\uC4A7\uC4A8\uC4A9\uFFFD".split("");
    for(j = 0; j != D[156].length; ++j)if (D[156][j].charCodeAt(0) !== 0xFFFD) {
        e[D[156][j]] = 39936 + j;
        d[39936 + j] = D[156][j];
    }
    D[157] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC4AA\uC4AB\uC4AC\uC4AD\uC4AE\uC4AF\uC4B0\uC4B1\uC4B2\uC4B3\uC4B4\uC4B5\uC4B6\uC4B7\uC4B9\uC4BA\uC4BB\uC4BD\uC4BE\uC4BF\uC4C0\uC4C1\uC4C2\uC4C3\uC4C4\uC4C5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC4C6\uC4C7\uC4C8\uC4C9\uC4CA\uC4CB\uC4CC\uC4CD\uC4CE\uC4CF\uC4D0\uC4D1\uC4D2\uC4D3\uC4D4\uC4D5\uC4D6\uC4D7\uC4D8\uC4D9\uC4DA\uC4DB\uC4DC\uC4DD\uC4DE\uC4DF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC4E0\uC4E1\uC4E2\uC4E3\uC4E4\uC4E5\uC4E6\uC4E7\uC4E8\uC4EA\uC4EB\uC4EC\uC4ED\uC4EE\uC4EF\uC4F2\uC4F3\uC4F5\uC4F6\uC4F7\uC4F9\uC4FB\uC4FC\uC4FD\uC4FE\uC502\uC503\uC504\uC505\uC506\uC507\uC508\uC509\uC50A\uC50B\uC50D\uC50E\uC50F\uC511\uC512\uC513\uC515\uC516\uC517\uC518\uC519\uC51A\uC51B\uC51D\uC51E\uC51F\uC520\uC521\uC522\uC523\uC524\uC525\uC526\uC527\uC52A\uC52B\uC52D\uC52E\uC52F\uC531\uC532\uC533\uC534\uC535\uC536\uC537\uC53A\uC53C\uC53E\uC53F\uC540\uC541\uC542\uC543\uC546\uC547\uC54B\uC54F\uC550\uC551\uC552\uC556\uC55A\uC55B\uC55C\uC55F\uC562\uC563\uC565\uC566\uC567\uC569\uC56A\uC56B\uC56C\uC56D\uC56E\uC56F\uC572\uC576\uC577\uC578\uC579\uC57A\uC57B\uC57E\uC57F\uC581\uC582\uC583\uC585\uC586\uC588\uC589\uC58A\uC58B\uC58E\uC590\uC592\uC593\uC594\uFFFD".split("");
    for(j = 0; j != D[157].length; ++j)if (D[157][j].charCodeAt(0) !== 0xFFFD) {
        e[D[157][j]] = 40192 + j;
        d[40192 + j] = D[157][j];
    }
    D[158] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC596\uC599\uC59A\uC59B\uC59D\uC59E\uC59F\uC5A1\uC5A2\uC5A3\uC5A4\uC5A5\uC5A6\uC5A7\uC5A8\uC5AA\uC5AB\uC5AC\uC5AD\uC5AE\uC5AF\uC5B0\uC5B1\uC5B2\uC5B3\uC5B6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC5B7\uC5BA\uC5BF\uC5C0\uC5C1\uC5C2\uC5C3\uC5CB\uC5CD\uC5CF\uC5D2\uC5D3\uC5D5\uC5D6\uC5D7\uC5D9\uC5DA\uC5DB\uC5DC\uC5DD\uC5DE\uC5DF\uC5E2\uC5E4\uC5E6\uC5E7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC5E8\uC5E9\uC5EA\uC5EB\uC5EF\uC5F1\uC5F2\uC5F3\uC5F5\uC5F8\uC5F9\uC5FA\uC5FB\uC602\uC603\uC604\uC609\uC60A\uC60B\uC60D\uC60E\uC60F\uC611\uC612\uC613\uC614\uC615\uC616\uC617\uC61A\uC61D\uC61E\uC61F\uC620\uC621\uC622\uC623\uC626\uC627\uC629\uC62A\uC62B\uC62F\uC631\uC632\uC636\uC638\uC63A\uC63C\uC63D\uC63E\uC63F\uC642\uC643\uC645\uC646\uC647\uC649\uC64A\uC64B\uC64C\uC64D\uC64E\uC64F\uC652\uC656\uC657\uC658\uC659\uC65A\uC65B\uC65E\uC65F\uC661\uC662\uC663\uC664\uC665\uC666\uC667\uC668\uC669\uC66A\uC66B\uC66D\uC66E\uC670\uC672\uC673\uC674\uC675\uC676\uC677\uC67A\uC67B\uC67D\uC67E\uC67F\uC681\uC682\uC683\uC684\uC685\uC686\uC687\uC68A\uC68C\uC68E\uC68F\uC690\uC691\uC692\uC693\uC696\uC697\uC699\uC69A\uC69B\uC69D\uC69E\uC69F\uC6A0\uC6A1\uC6A2\uC6A3\uC6A6\uFFFD".split("");
    for(j = 0; j != D[158].length; ++j)if (D[158][j].charCodeAt(0) !== 0xFFFD) {
        e[D[158][j]] = 40448 + j;
        d[40448 + j] = D[158][j];
    }
    D[159] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC6A8\uC6AA\uC6AB\uC6AC\uC6AD\uC6AE\uC6AF\uC6B2\uC6B3\uC6B5\uC6B6\uC6B7\uC6BB\uC6BC\uC6BD\uC6BE\uC6BF\uC6C2\uC6C4\uC6C6\uC6C7\uC6C8\uC6C9\uC6CA\uC6CB\uC6CE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC6CF\uC6D1\uC6D2\uC6D3\uC6D5\uC6D6\uC6D7\uC6D8\uC6D9\uC6DA\uC6DB\uC6DE\uC6DF\uC6E2\uC6E3\uC6E4\uC6E5\uC6E6\uC6E7\uC6EA\uC6EB\uC6ED\uC6EE\uC6EF\uC6F1\uC6F2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC6F3\uC6F4\uC6F5\uC6F6\uC6F7\uC6FA\uC6FB\uC6FC\uC6FE\uC6FF\uC700\uC701\uC702\uC703\uC706\uC707\uC709\uC70A\uC70B\uC70D\uC70E\uC70F\uC710\uC711\uC712\uC713\uC716\uC718\uC71A\uC71B\uC71C\uC71D\uC71E\uC71F\uC722\uC723\uC725\uC726\uC727\uC729\uC72A\uC72B\uC72C\uC72D\uC72E\uC72F\uC732\uC734\uC736\uC738\uC739\uC73A\uC73B\uC73E\uC73F\uC741\uC742\uC743\uC745\uC746\uC747\uC748\uC749\uC74B\uC74E\uC750\uC759\uC75A\uC75B\uC75D\uC75E\uC75F\uC761\uC762\uC763\uC764\uC765\uC766\uC767\uC769\uC76A\uC76C\uC76D\uC76E\uC76F\uC770\uC771\uC772\uC773\uC776\uC777\uC779\uC77A\uC77B\uC77F\uC780\uC781\uC782\uC786\uC78B\uC78C\uC78D\uC78F\uC792\uC793\uC795\uC799\uC79B\uC79C\uC79D\uC79E\uC79F\uC7A2\uC7A7\uC7A8\uC7A9\uC7AA\uC7AB\uC7AE\uC7AF\uC7B1\uC7B2\uC7B3\uC7B5\uC7B6\uC7B7\uFFFD".split("");
    for(j = 0; j != D[159].length; ++j)if (D[159][j].charCodeAt(0) !== 0xFFFD) {
        e[D[159][j]] = 40704 + j;
        d[40704 + j] = D[159][j];
    }
    D[160] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC7B8\uC7B9\uC7BA\uC7BB\uC7BE\uC7C2\uC7C3\uC7C4\uC7C5\uC7C6\uC7C7\uC7CA\uC7CB\uC7CD\uC7CF\uC7D1\uC7D2\uC7D3\uC7D4\uC7D5\uC7D6\uC7D7\uC7D9\uC7DA\uC7DB\uC7DC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC7DE\uC7DF\uC7E0\uC7E1\uC7E2\uC7E3\uC7E5\uC7E6\uC7E7\uC7E9\uC7EA\uC7EB\uC7ED\uC7EE\uC7EF\uC7F0\uC7F1\uC7F2\uC7F3\uC7F4\uC7F5\uC7F6\uC7F7\uC7F8\uC7F9\uC7FA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC7FB\uC7FC\uC7FD\uC7FE\uC7FF\uC802\uC803\uC805\uC806\uC807\uC809\uC80B\uC80C\uC80D\uC80E\uC80F\uC812\uC814\uC817\uC818\uC819\uC81A\uC81B\uC81E\uC81F\uC821\uC822\uC823\uC825\uC826\uC827\uC828\uC829\uC82A\uC82B\uC82E\uC830\uC832\uC833\uC834\uC835\uC836\uC837\uC839\uC83A\uC83B\uC83D\uC83E\uC83F\uC841\uC842\uC843\uC844\uC845\uC846\uC847\uC84A\uC84B\uC84E\uC84F\uC850\uC851\uC852\uC853\uC855\uC856\uC857\uC858\uC859\uC85A\uC85B\uC85C\uC85D\uC85E\uC85F\uC860\uC861\uC862\uC863\uC864\uC865\uC866\uC867\uC868\uC869\uC86A\uC86B\uC86C\uC86D\uC86E\uC86F\uC872\uC873\uC875\uC876\uC877\uC879\uC87B\uC87C\uC87D\uC87E\uC87F\uC882\uC884\uC888\uC889\uC88A\uC88E\uC88F\uC890\uC891\uC892\uC893\uC895\uC896\uC897\uC898\uC899\uC89A\uC89B\uC89C\uC89E\uC8A0\uC8A2\uC8A3\uC8A4\uFFFD".split("");
    for(j = 0; j != D[160].length; ++j)if (D[160][j].charCodeAt(0) !== 0xFFFD) {
        e[D[160][j]] = 40960 + j;
        d[40960 + j] = D[160][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC8A5\uC8A6\uC8A7\uC8A9\uC8AA\uC8AB\uC8AC\uC8AD\uC8AE\uC8AF\uC8B0\uC8B1\uC8B2\uC8B3\uC8B4\uC8B5\uC8B6\uC8B7\uC8B8\uC8B9\uC8BA\uC8BB\uC8BE\uC8BF\uC8C0\uC8C1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC8C2\uC8C3\uC8C5\uC8C6\uC8C7\uC8C9\uC8CA\uC8CB\uC8CD\uC8CE\uC8CF\uC8D0\uC8D1\uC8D2\uC8D3\uC8D6\uC8D8\uC8DA\uC8DB\uC8DC\uC8DD\uC8DE\uC8DF\uC8E2\uC8E3\uC8E5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC8E6\uC8E7\uC8E8\uC8E9\uC8EA\uC8EB\uC8EC\uC8ED\uC8EE\uC8EF\uC8F0\uC8F1\uC8F2\uC8F3\uC8F4\uC8F6\uC8F7\uC8F8\uC8F9\uC8FA\uC8FB\uC8FE\uC8FF\uC901\uC902\uC903\uC907\uC908\uC909\uC90A\uC90B\uC90E\u3000\u3001\u3002\xb7\u2025\u2026\xa8\u3003\xad\u2015\u2225\uFF3C\u223C\u2018\u2019\u201C\u201D\u3014\u3015\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3010\u3011\xb1\xd7\xf7\u2260\u2264\u2265\u221E\u2234\xb0\u2032\u2033\u2103\u212B\uFFE0\uFFE1\uFFE5\u2642\u2640\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\xa7\u203B\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u2192\u2190\u2191\u2193\u2194\u3013\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\u2227\u2228\uFFE2\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC910\uC912\uC913\uC914\uC915\uC916\uC917\uC919\uC91A\uC91B\uC91C\uC91D\uC91E\uC91F\uC920\uC921\uC922\uC923\uC924\uC925\uC926\uC927\uC928\uC929\uC92A\uC92B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC92D\uC92E\uC92F\uC930\uC931\uC932\uC933\uC935\uC936\uC937\uC938\uC939\uC93A\uC93B\uC93C\uC93D\uC93E\uC93F\uC940\uC941\uC942\uC943\uC944\uC945\uC946\uC947\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC948\uC949\uC94A\uC94B\uC94C\uC94D\uC94E\uC94F\uC952\uC953\uC955\uC956\uC957\uC959\uC95A\uC95B\uC95C\uC95D\uC95E\uC95F\uC962\uC964\uC965\uC966\uC967\uC968\uC969\uC96A\uC96B\uC96D\uC96E\uC96F\u21D2\u21D4\u2200\u2203\xb4\uFF5E\u02C7\u02D8\u02DD\u02DA\u02D9\xb8\u02DB\xa1\xbf\u02D0\u222E\u2211\u220F\xa4\u2109\u2030\u25C1\u25C0\u25B7\u25B6\u2664\u2660\u2661\u2665\u2667\u2663\u2299\u25C8\u25A3\u25D0\u25D1\u2592\u25A4\u25A5\u25A8\u25A7\u25A6\u25A9\u2668\u260F\u260E\u261C\u261E\xb6\u2020\u2021\u2195\u2197\u2199\u2196\u2198\u266D\u2669\u266A\u266C\u327F\u321C\u2116\u33C7\u2122\u33C2\u33D8\u2121\u20AC\xae\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC971\uC972\uC973\uC975\uC976\uC977\uC978\uC979\uC97A\uC97B\uC97D\uC97E\uC97F\uC980\uC981\uC982\uC983\uC984\uC985\uC986\uC987\uC98A\uC98B\uC98D\uC98E\uC98F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC991\uC992\uC993\uC994\uC995\uC996\uC997\uC99A\uC99C\uC99E\uC99F\uC9A0\uC9A1\uC9A2\uC9A3\uC9A4\uC9A5\uC9A6\uC9A7\uC9A8\uC9A9\uC9AA\uC9AB\uC9AC\uC9AD\uC9AE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC9AF\uC9B0\uC9B1\uC9B2\uC9B3\uC9B4\uC9B5\uC9B6\uC9B7\uC9B8\uC9B9\uC9BA\uC9BB\uC9BC\uC9BD\uC9BE\uC9BF\uC9C2\uC9C3\uC9C5\uC9C6\uC9C9\uC9CB\uC9CC\uC9CD\uC9CE\uC9CF\uC9D2\uC9D4\uC9D7\uC9D8\uC9DB\uFF01\uFF02\uFF03\uFF04\uFF05\uFF06\uFF07\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF3B\uFFE6\uFF3D\uFF3E\uFF3F\uFF40\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFF5B\uFF5C\uFF5D\uFFE3\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC9DE\uC9DF\uC9E1\uC9E3\uC9E5\uC9E6\uC9E8\uC9E9\uC9EA\uC9EB\uC9EE\uC9F2\uC9F3\uC9F4\uC9F5\uC9F6\uC9F7\uC9FA\uC9FB\uC9FD\uC9FE\uC9FF\uCA01\uCA02\uCA03\uCA04\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA05\uCA06\uCA07\uCA0A\uCA0E\uCA0F\uCA10\uCA11\uCA12\uCA13\uCA15\uCA16\uCA17\uCA19\uCA1A\uCA1B\uCA1C\uCA1D\uCA1E\uCA1F\uCA20\uCA21\uCA22\uCA23\uCA24\uCA25\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA26\uCA27\uCA28\uCA2A\uCA2B\uCA2C\uCA2D\uCA2E\uCA2F\uCA30\uCA31\uCA32\uCA33\uCA34\uCA35\uCA36\uCA37\uCA38\uCA39\uCA3A\uCA3B\uCA3C\uCA3D\uCA3E\uCA3F\uCA40\uCA41\uCA42\uCA43\uCA44\uCA45\uCA46\u3131\u3132\u3133\u3134\u3135\u3136\u3137\u3138\u3139\u313A\u313B\u313C\u313D\u313E\u313F\u3140\u3141\u3142\u3143\u3144\u3145\u3146\u3147\u3148\u3149\u314A\u314B\u314C\u314D\u314E\u314F\u3150\u3151\u3152\u3153\u3154\u3155\u3156\u3157\u3158\u3159\u315A\u315B\u315C\u315D\u315E\u315F\u3160\u3161\u3162\u3163\u3164\u3165\u3166\u3167\u3168\u3169\u316A\u316B\u316C\u316D\u316E\u316F\u3170\u3171\u3172\u3173\u3174\u3175\u3176\u3177\u3178\u3179\u317A\u317B\u317C\u317D\u317E\u317F\u3180\u3181\u3182\u3183\u3184\u3185\u3186\u3187\u3188\u3189\u318A\u318B\u318C\u318D\u318E\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA47\uCA48\uCA49\uCA4A\uCA4B\uCA4E\uCA4F\uCA51\uCA52\uCA53\uCA55\uCA56\uCA57\uCA58\uCA59\uCA5A\uCA5B\uCA5E\uCA62\uCA63\uCA64\uCA65\uCA66\uCA67\uCA69\uCA6A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA6B\uCA6C\uCA6D\uCA6E\uCA6F\uCA70\uCA71\uCA72\uCA73\uCA74\uCA75\uCA76\uCA77\uCA78\uCA79\uCA7A\uCA7B\uCA7C\uCA7E\uCA7F\uCA80\uCA81\uCA82\uCA83\uCA85\uCA86\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA87\uCA88\uCA89\uCA8A\uCA8B\uCA8C\uCA8D\uCA8E\uCA8F\uCA90\uCA91\uCA92\uCA93\uCA94\uCA95\uCA96\uCA97\uCA99\uCA9A\uCA9B\uCA9C\uCA9D\uCA9E\uCA9F\uCAA0\uCAA1\uCAA2\uCAA3\uCAA4\uCAA5\uCAA6\uCAA7\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCAA8\uCAA9\uCAAA\uCAAB\uCAAC\uCAAD\uCAAE\uCAAF\uCAB0\uCAB1\uCAB2\uCAB3\uCAB4\uCAB5\uCAB6\uCAB7\uCAB8\uCAB9\uCABA\uCABB\uCABE\uCABF\uCAC1\uCAC2\uCAC3\uCAC5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCAC6\uCAC7\uCAC8\uCAC9\uCACA\uCACB\uCACE\uCAD0\uCAD2\uCAD4\uCAD5\uCAD6\uCAD7\uCADA\uCADB\uCADC\uCADD\uCADE\uCADF\uCAE1\uCAE2\uCAE3\uCAE4\uCAE5\uCAE6\uCAE7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCAE8\uCAE9\uCAEA\uCAEB\uCAED\uCAEE\uCAEF\uCAF0\uCAF1\uCAF2\uCAF3\uCAF5\uCAF6\uCAF7\uCAF8\uCAF9\uCAFA\uCAFB\uCAFC\uCAFD\uCAFE\uCAFF\uCB00\uCB01\uCB02\uCB03\uCB04\uCB05\uCB06\uCB07\uCB09\uCB0A\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\u2512\u2511\u251A\u2519\u2516\u2515\u250E\u250D\u251E\u251F\u2521\u2522\u2526\u2527\u2529\u252A\u252D\u252E\u2531\u2532\u2535\u2536\u2539\u253A\u253D\u253E\u2540\u2541\u2543\u2544\u2545\u2546\u2547\u2548\u2549\u254A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB0B\uCB0C\uCB0D\uCB0E\uCB0F\uCB11\uCB12\uCB13\uCB15\uCB16\uCB17\uCB19\uCB1A\uCB1B\uCB1C\uCB1D\uCB1E\uCB1F\uCB22\uCB23\uCB24\uCB25\uCB26\uCB27\uCB28\uCB29\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB2A\uCB2B\uCB2C\uCB2D\uCB2E\uCB2F\uCB30\uCB31\uCB32\uCB33\uCB34\uCB35\uCB36\uCB37\uCB38\uCB39\uCB3A\uCB3B\uCB3C\uCB3D\uCB3E\uCB3F\uCB40\uCB42\uCB43\uCB44\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB45\uCB46\uCB47\uCB4A\uCB4B\uCB4D\uCB4E\uCB4F\uCB51\uCB52\uCB53\uCB54\uCB55\uCB56\uCB57\uCB5A\uCB5B\uCB5C\uCB5E\uCB5F\uCB60\uCB61\uCB62\uCB63\uCB65\uCB66\uCB67\uCB68\uCB69\uCB6A\uCB6B\uCB6C\u3395\u3396\u3397\u2113\u3398\u33C4\u33A3\u33A4\u33A5\u33A6\u3399\u339A\u339B\u339C\u339D\u339E\u339F\u33A0\u33A1\u33A2\u33CA\u338D\u338E\u338F\u33CF\u3388\u3389\u33C8\u33A7\u33A8\u33B0\u33B1\u33B2\u33B3\u33B4\u33B5\u33B6\u33B7\u33B8\u33B9\u3380\u3381\u3382\u3383\u3384\u33BA\u33BB\u33BC\u33BD\u33BE\u33BF\u3390\u3391\u3392\u3393\u3394\u2126\u33C0\u33C1\u338A\u338B\u338C\u33D6\u33C5\u33AD\u33AE\u33AF\u33DB\u33A9\u33AA\u33AB\u33AC\u33DD\u33D0\u33D3\u33C3\u33C9\u33DC\u33C6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB6D\uCB6E\uCB6F\uCB70\uCB71\uCB72\uCB73\uCB74\uCB75\uCB76\uCB77\uCB7A\uCB7B\uCB7C\uCB7D\uCB7E\uCB7F\uCB80\uCB81\uCB82\uCB83\uCB84\uCB85\uCB86\uCB87\uCB88\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB89\uCB8A\uCB8B\uCB8C\uCB8D\uCB8E\uCB8F\uCB90\uCB91\uCB92\uCB93\uCB94\uCB95\uCB96\uCB97\uCB98\uCB99\uCB9A\uCB9B\uCB9D\uCB9E\uCB9F\uCBA0\uCBA1\uCBA2\uCBA3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBA4\uCBA5\uCBA6\uCBA7\uCBA8\uCBA9\uCBAA\uCBAB\uCBAC\uCBAD\uCBAE\uCBAF\uCBB0\uCBB1\uCBB2\uCBB3\uCBB4\uCBB5\uCBB6\uCBB7\uCBB9\uCBBA\uCBBB\uCBBC\uCBBD\uCBBE\uCBBF\uCBC0\uCBC1\uCBC2\uCBC3\uCBC4\xc6\xd0\xaa\u0126\uFFFD\u0132\uFFFD\u013F\u0141\xd8\u0152\xba\xde\u0166\u014A\uFFFD\u3260\u3261\u3262\u3263\u3264\u3265\u3266\u3267\u3268\u3269\u326A\u326B\u326C\u326D\u326E\u326F\u3270\u3271\u3272\u3273\u3274\u3275\u3276\u3277\u3278\u3279\u327A\u327B\u24D0\u24D1\u24D2\u24D3\u24D4\u24D5\u24D6\u24D7\u24D8\u24D9\u24DA\u24DB\u24DC\u24DD\u24DE\u24DF\u24E0\u24E1\u24E2\u24E3\u24E4\u24E5\u24E6\u24E7\u24E8\u24E9\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\u246A\u246B\u246C\u246D\u246E\xbd\u2153\u2154\xbc\xbe\u215B\u215C\u215D\u215E\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBC5\uCBC6\uCBC7\uCBC8\uCBC9\uCBCA\uCBCB\uCBCC\uCBCD\uCBCE\uCBCF\uCBD0\uCBD1\uCBD2\uCBD3\uCBD5\uCBD6\uCBD7\uCBD8\uCBD9\uCBDA\uCBDB\uCBDC\uCBDD\uCBDE\uCBDF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBE0\uCBE1\uCBE2\uCBE3\uCBE5\uCBE6\uCBE8\uCBEA\uCBEB\uCBEC\uCBED\uCBEE\uCBEF\uCBF0\uCBF1\uCBF2\uCBF3\uCBF4\uCBF5\uCBF6\uCBF7\uCBF8\uCBF9\uCBFA\uCBFB\uCBFC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBFD\uCBFE\uCBFF\uCC00\uCC01\uCC02\uCC03\uCC04\uCC05\uCC06\uCC07\uCC08\uCC09\uCC0A\uCC0B\uCC0E\uCC0F\uCC11\uCC12\uCC13\uCC15\uCC16\uCC17\uCC18\uCC19\uCC1A\uCC1B\uCC1E\uCC1F\uCC20\uCC23\uCC24\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0140\u0142\xf8\u0153\xdf\xfe\u0167\u014B\u0149\u3200\u3201\u3202\u3203\u3204\u3205\u3206\u3207\u3208\u3209\u320A\u320B\u320C\u320D\u320E\u320F\u3210\u3211\u3212\u3213\u3214\u3215\u3216\u3217\u3218\u3219\u321A\u321B\u249C\u249D\u249E\u249F\u24A0\u24A1\u24A2\u24A3\u24A4\u24A5\u24A6\u24A7\u24A8\u24A9\u24AA\u24AB\u24AC\u24AD\u24AE\u24AF\u24B0\u24B1\u24B2\u24B3\u24B4\u24B5\u2474\u2475\u2476\u2477\u2478\u2479\u247A\u247B\u247C\u247D\u247E\u247F\u2480\u2481\u2482\xb9\xb2\xb3\u2074\u207F\u2081\u2082\u2083\u2084\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[170] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC25\uCC26\uCC2A\uCC2B\uCC2D\uCC2F\uCC31\uCC32\uCC33\uCC34\uCC35\uCC36\uCC37\uCC3A\uCC3F\uCC40\uCC41\uCC42\uCC43\uCC46\uCC47\uCC49\uCC4A\uCC4B\uCC4D\uCC4E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC4F\uCC50\uCC51\uCC52\uCC53\uCC56\uCC5A\uCC5B\uCC5C\uCC5D\uCC5E\uCC5F\uCC61\uCC62\uCC63\uCC65\uCC67\uCC69\uCC6A\uCC6B\uCC6C\uCC6D\uCC6E\uCC6F\uCC71\uCC72\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC73\uCC74\uCC76\uCC77\uCC78\uCC79\uCC7A\uCC7B\uCC7C\uCC7D\uCC7E\uCC7F\uCC80\uCC81\uCC82\uCC83\uCC84\uCC85\uCC86\uCC87\uCC88\uCC89\uCC8A\uCC8B\uCC8C\uCC8D\uCC8E\uCC8F\uCC90\uCC91\uCC92\uCC93\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[170].length; ++j)if (D[170][j].charCodeAt(0) !== 0xFFFD) {
        e[D[170][j]] = 43520 + j;
        d[43520 + j] = D[170][j];
    }
    D[171] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC94\uCC95\uCC96\uCC97\uCC9A\uCC9B\uCC9D\uCC9E\uCC9F\uCCA1\uCCA2\uCCA3\uCCA4\uCCA5\uCCA6\uCCA7\uCCAA\uCCAE\uCCAF\uCCB0\uCCB1\uCCB2\uCCB3\uCCB6\uCCB7\uCCB9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCCBA\uCCBB\uCCBD\uCCBE\uCCBF\uCCC0\uCCC1\uCCC2\uCCC3\uCCC6\uCCC8\uCCCA\uCCCB\uCCCC\uCCCD\uCCCE\uCCCF\uCCD1\uCCD2\uCCD3\uCCD5\uCCD6\uCCD7\uCCD8\uCCD9\uCCDA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCCDB\uCCDC\uCCDD\uCCDE\uCCDF\uCCE0\uCCE1\uCCE2\uCCE3\uCCE5\uCCE6\uCCE7\uCCE8\uCCE9\uCCEA\uCCEB\uCCED\uCCEE\uCCEF\uCCF1\uCCF2\uCCF3\uCCF4\uCCF5\uCCF6\uCCF7\uCCF8\uCCF9\uCCFA\uCCFB\uCCFC\uCCFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[171].length; ++j)if (D[171][j].charCodeAt(0) !== 0xFFFD) {
        e[D[171][j]] = 43776 + j;
        d[43776 + j] = D[171][j];
    }
    D[172] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCCFE\uCCFF\uCD00\uCD02\uCD03\uCD04\uCD05\uCD06\uCD07\uCD0A\uCD0B\uCD0D\uCD0E\uCD0F\uCD11\uCD12\uCD13\uCD14\uCD15\uCD16\uCD17\uCD1A\uCD1C\uCD1E\uCD1F\uCD20\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD21\uCD22\uCD23\uCD25\uCD26\uCD27\uCD29\uCD2A\uCD2B\uCD2D\uCD2E\uCD2F\uCD30\uCD31\uCD32\uCD33\uCD34\uCD35\uCD36\uCD37\uCD38\uCD3A\uCD3B\uCD3C\uCD3D\uCD3E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD3F\uCD40\uCD41\uCD42\uCD43\uCD44\uCD45\uCD46\uCD47\uCD48\uCD49\uCD4A\uCD4B\uCD4C\uCD4D\uCD4E\uCD4F\uCD50\uCD51\uCD52\uCD53\uCD54\uCD55\uCD56\uCD57\uCD58\uCD59\uCD5A\uCD5B\uCD5D\uCD5E\uCD5F\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[172].length; ++j)if (D[172][j].charCodeAt(0) !== 0xFFFD) {
        e[D[172][j]] = 44032 + j;
        d[44032 + j] = D[172][j];
    }
    D[173] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD61\uCD62\uCD63\uCD65\uCD66\uCD67\uCD68\uCD69\uCD6A\uCD6B\uCD6E\uCD70\uCD72\uCD73\uCD74\uCD75\uCD76\uCD77\uCD79\uCD7A\uCD7B\uCD7C\uCD7D\uCD7E\uCD7F\uCD80\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD81\uCD82\uCD83\uCD84\uCD85\uCD86\uCD87\uCD89\uCD8A\uCD8B\uCD8C\uCD8D\uCD8E\uCD8F\uCD90\uCD91\uCD92\uCD93\uCD96\uCD97\uCD99\uCD9A\uCD9B\uCD9D\uCD9E\uCD9F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCDA0\uCDA1\uCDA2\uCDA3\uCDA6\uCDA8\uCDAA\uCDAB\uCDAC\uCDAD\uCDAE\uCDAF\uCDB1\uCDB2\uCDB3\uCDB4\uCDB5\uCDB6\uCDB7\uCDB8\uCDB9\uCDBA\uCDBB\uCDBC\uCDBD\uCDBE\uCDBF\uCDC0\uCDC1\uCDC2\uCDC3\uCDC5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[173].length; ++j)if (D[173][j].charCodeAt(0) !== 0xFFFD) {
        e[D[173][j]] = 44288 + j;
        d[44288 + j] = D[173][j];
    }
    D[174] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCDC6\uCDC7\uCDC8\uCDC9\uCDCA\uCDCB\uCDCD\uCDCE\uCDCF\uCDD1\uCDD2\uCDD3\uCDD4\uCDD5\uCDD6\uCDD7\uCDD8\uCDD9\uCDDA\uCDDB\uCDDC\uCDDD\uCDDE\uCDDF\uCDE0\uCDE1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCDE2\uCDE3\uCDE4\uCDE5\uCDE6\uCDE7\uCDE9\uCDEA\uCDEB\uCDED\uCDEE\uCDEF\uCDF1\uCDF2\uCDF3\uCDF4\uCDF5\uCDF6\uCDF7\uCDFA\uCDFC\uCDFE\uCDFF\uCE00\uCE01\uCE02\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE03\uCE05\uCE06\uCE07\uCE09\uCE0A\uCE0B\uCE0D\uCE0E\uCE0F\uCE10\uCE11\uCE12\uCE13\uCE15\uCE16\uCE17\uCE18\uCE1A\uCE1B\uCE1C\uCE1D\uCE1E\uCE1F\uCE22\uCE23\uCE25\uCE26\uCE27\uCE29\uCE2A\uCE2B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[174].length; ++j)if (D[174][j].charCodeAt(0) !== 0xFFFD) {
        e[D[174][j]] = 44544 + j;
        d[44544 + j] = D[174][j];
    }
    D[175] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE2C\uCE2D\uCE2E\uCE2F\uCE32\uCE34\uCE36\uCE37\uCE38\uCE39\uCE3A\uCE3B\uCE3C\uCE3D\uCE3E\uCE3F\uCE40\uCE41\uCE42\uCE43\uCE44\uCE45\uCE46\uCE47\uCE48\uCE49\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE4A\uCE4B\uCE4C\uCE4D\uCE4E\uCE4F\uCE50\uCE51\uCE52\uCE53\uCE54\uCE55\uCE56\uCE57\uCE5A\uCE5B\uCE5D\uCE5E\uCE62\uCE63\uCE64\uCE65\uCE66\uCE67\uCE6A\uCE6C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE6E\uCE6F\uCE70\uCE71\uCE72\uCE73\uCE76\uCE77\uCE79\uCE7A\uCE7B\uCE7D\uCE7E\uCE7F\uCE80\uCE81\uCE82\uCE83\uCE86\uCE88\uCE8A\uCE8B\uCE8C\uCE8D\uCE8E\uCE8F\uCE92\uCE93\uCE95\uCE96\uCE97\uCE99\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[175].length; ++j)if (D[175][j].charCodeAt(0) !== 0xFFFD) {
        e[D[175][j]] = 44800 + j;
        d[44800 + j] = D[175][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE9A\uCE9B\uCE9C\uCE9D\uCE9E\uCE9F\uCEA2\uCEA6\uCEA7\uCEA8\uCEA9\uCEAA\uCEAB\uCEAE\uCEAF\uCEB0\uCEB1\uCEB2\uCEB3\uCEB4\uCEB5\uCEB6\uCEB7\uCEB8\uCEB9\uCEBA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCEBB\uCEBC\uCEBD\uCEBE\uCEBF\uCEC0\uCEC2\uCEC3\uCEC4\uCEC5\uCEC6\uCEC7\uCEC8\uCEC9\uCECA\uCECB\uCECC\uCECD\uCECE\uCECF\uCED0\uCED1\uCED2\uCED3\uCED4\uCED5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCED6\uCED7\uCED8\uCED9\uCEDA\uCEDB\uCEDC\uCEDD\uCEDE\uCEDF\uCEE0\uCEE1\uCEE2\uCEE3\uCEE6\uCEE7\uCEE9\uCEEA\uCEED\uCEEE\uCEEF\uCEF0\uCEF1\uCEF2\uCEF3\uCEF6\uCEFA\uCEFB\uCEFC\uCEFD\uCEFE\uCEFF\uAC00\uAC01\uAC04\uAC07\uAC08\uAC09\uAC0A\uAC10\uAC11\uAC12\uAC13\uAC14\uAC15\uAC16\uAC17\uAC19\uAC1A\uAC1B\uAC1C\uAC1D\uAC20\uAC24\uAC2C\uAC2D\uAC2F\uAC30\uAC31\uAC38\uAC39\uAC3C\uAC40\uAC4B\uAC4D\uAC54\uAC58\uAC5C\uAC70\uAC71\uAC74\uAC77\uAC78\uAC7A\uAC80\uAC81\uAC83\uAC84\uAC85\uAC86\uAC89\uAC8A\uAC8B\uAC8C\uAC90\uAC94\uAC9C\uAC9D\uAC9F\uACA0\uACA1\uACA8\uACA9\uACAA\uACAC\uACAF\uACB0\uACB8\uACB9\uACBB\uACBC\uACBD\uACC1\uACC4\uACC8\uACCC\uACD5\uACD7\uACE0\uACE1\uACE4\uACE7\uACE8\uACEA\uACEC\uACEF\uACF0\uACF1\uACF3\uACF5\uACF6\uACFC\uACFD\uAD00\uAD04\uAD06\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF02\uCF03\uCF05\uCF06\uCF07\uCF09\uCF0A\uCF0B\uCF0C\uCF0D\uCF0E\uCF0F\uCF12\uCF14\uCF16\uCF17\uCF18\uCF19\uCF1A\uCF1B\uCF1D\uCF1E\uCF1F\uCF21\uCF22\uCF23\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF25\uCF26\uCF27\uCF28\uCF29\uCF2A\uCF2B\uCF2E\uCF32\uCF33\uCF34\uCF35\uCF36\uCF37\uCF39\uCF3A\uCF3B\uCF3C\uCF3D\uCF3E\uCF3F\uCF40\uCF41\uCF42\uCF43\uCF44\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF45\uCF46\uCF47\uCF48\uCF49\uCF4A\uCF4B\uCF4C\uCF4D\uCF4E\uCF4F\uCF50\uCF51\uCF52\uCF53\uCF56\uCF57\uCF59\uCF5A\uCF5B\uCF5D\uCF5E\uCF5F\uCF60\uCF61\uCF62\uCF63\uCF66\uCF68\uCF6A\uCF6B\uCF6C\uAD0C\uAD0D\uAD0F\uAD11\uAD18\uAD1C\uAD20\uAD29\uAD2C\uAD2D\uAD34\uAD35\uAD38\uAD3C\uAD44\uAD45\uAD47\uAD49\uAD50\uAD54\uAD58\uAD61\uAD63\uAD6C\uAD6D\uAD70\uAD73\uAD74\uAD75\uAD76\uAD7B\uAD7C\uAD7D\uAD7F\uAD81\uAD82\uAD88\uAD89\uAD8C\uAD90\uAD9C\uAD9D\uADA4\uADB7\uADC0\uADC1\uADC4\uADC8\uADD0\uADD1\uADD3\uADDC\uADE0\uADE4\uADF8\uADF9\uADFC\uADFF\uAE00\uAE01\uAE08\uAE09\uAE0B\uAE0D\uAE14\uAE30\uAE31\uAE34\uAE37\uAE38\uAE3A\uAE40\uAE41\uAE43\uAE45\uAE46\uAE4A\uAE4C\uAE4D\uAE4E\uAE50\uAE54\uAE56\uAE5C\uAE5D\uAE5F\uAE60\uAE61\uAE65\uAE68\uAE69\uAE6C\uAE70\uAE78\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF6D\uCF6E\uCF6F\uCF72\uCF73\uCF75\uCF76\uCF77\uCF79\uCF7A\uCF7B\uCF7C\uCF7D\uCF7E\uCF7F\uCF81\uCF82\uCF83\uCF84\uCF86\uCF87\uCF88\uCF89\uCF8A\uCF8B\uCF8D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF8E\uCF8F\uCF90\uCF91\uCF92\uCF93\uCF94\uCF95\uCF96\uCF97\uCF98\uCF99\uCF9A\uCF9B\uCF9C\uCF9D\uCF9E\uCF9F\uCFA0\uCFA2\uCFA3\uCFA4\uCFA5\uCFA6\uCFA7\uCFA9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCFAA\uCFAB\uCFAC\uCFAD\uCFAE\uCFAF\uCFB1\uCFB2\uCFB3\uCFB4\uCFB5\uCFB6\uCFB7\uCFB8\uCFB9\uCFBA\uCFBB\uCFBC\uCFBD\uCFBE\uCFBF\uCFC0\uCFC1\uCFC2\uCFC3\uCFC5\uCFC6\uCFC7\uCFC8\uCFC9\uCFCA\uCFCB\uAE79\uAE7B\uAE7C\uAE7D\uAE84\uAE85\uAE8C\uAEBC\uAEBD\uAEBE\uAEC0\uAEC4\uAECC\uAECD\uAECF\uAED0\uAED1\uAED8\uAED9\uAEDC\uAEE8\uAEEB\uAEED\uAEF4\uAEF8\uAEFC\uAF07\uAF08\uAF0D\uAF10\uAF2C\uAF2D\uAF30\uAF32\uAF34\uAF3C\uAF3D\uAF3F\uAF41\uAF42\uAF43\uAF48\uAF49\uAF50\uAF5C\uAF5D\uAF64\uAF65\uAF79\uAF80\uAF84\uAF88\uAF90\uAF91\uAF95\uAF9C\uAFB8\uAFB9\uAFBC\uAFC0\uAFC7\uAFC8\uAFC9\uAFCB\uAFCD\uAFCE\uAFD4\uAFDC\uAFE8\uAFE9\uAFF0\uAFF1\uAFF4\uAFF8\uB000\uB001\uB004\uB00C\uB010\uB014\uB01C\uB01D\uB028\uB044\uB045\uB048\uB04A\uB04C\uB04E\uB053\uB054\uB055\uB057\uB059\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCFCC\uCFCD\uCFCE\uCFCF\uCFD0\uCFD1\uCFD2\uCFD3\uCFD4\uCFD5\uCFD6\uCFD7\uCFD8\uCFD9\uCFDA\uCFDB\uCFDC\uCFDD\uCFDE\uCFDF\uCFE2\uCFE3\uCFE5\uCFE6\uCFE7\uCFE9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCFEA\uCFEB\uCFEC\uCFED\uCFEE\uCFEF\uCFF2\uCFF4\uCFF6\uCFF7\uCFF8\uCFF9\uCFFA\uCFFB\uCFFD\uCFFE\uCFFF\uD001\uD002\uD003\uD005\uD006\uD007\uD008\uD009\uD00A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD00B\uD00C\uD00D\uD00E\uD00F\uD010\uD012\uD013\uD014\uD015\uD016\uD017\uD019\uD01A\uD01B\uD01C\uD01D\uD01E\uD01F\uD020\uD021\uD022\uD023\uD024\uD025\uD026\uD027\uD028\uD029\uD02A\uD02B\uD02C\uB05D\uB07C\uB07D\uB080\uB084\uB08C\uB08D\uB08F\uB091\uB098\uB099\uB09A\uB09C\uB09F\uB0A0\uB0A1\uB0A2\uB0A8\uB0A9\uB0AB\uB0AC\uB0AD\uB0AE\uB0AF\uB0B1\uB0B3\uB0B4\uB0B5\uB0B8\uB0BC\uB0C4\uB0C5\uB0C7\uB0C8\uB0C9\uB0D0\uB0D1\uB0D4\uB0D8\uB0E0\uB0E5\uB108\uB109\uB10B\uB10C\uB110\uB112\uB113\uB118\uB119\uB11B\uB11C\uB11D\uB123\uB124\uB125\uB128\uB12C\uB134\uB135\uB137\uB138\uB139\uB140\uB141\uB144\uB148\uB150\uB151\uB154\uB155\uB158\uB15C\uB160\uB178\uB179\uB17C\uB180\uB182\uB188\uB189\uB18B\uB18D\uB192\uB193\uB194\uB198\uB19C\uB1A8\uB1CC\uB1D0\uB1D4\uB1DC\uB1DD\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD02E\uD02F\uD030\uD031\uD032\uD033\uD036\uD037\uD039\uD03A\uD03B\uD03D\uD03E\uD03F\uD040\uD041\uD042\uD043\uD046\uD048\uD04A\uD04B\uD04C\uD04D\uD04E\uD04F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD051\uD052\uD053\uD055\uD056\uD057\uD059\uD05A\uD05B\uD05C\uD05D\uD05E\uD05F\uD061\uD062\uD063\uD064\uD065\uD066\uD067\uD068\uD069\uD06A\uD06B\uD06E\uD06F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD071\uD072\uD073\uD075\uD076\uD077\uD078\uD079\uD07A\uD07B\uD07E\uD07F\uD080\uD082\uD083\uD084\uD085\uD086\uD087\uD088\uD089\uD08A\uD08B\uD08C\uD08D\uD08E\uD08F\uD090\uD091\uD092\uD093\uD094\uB1DF\uB1E8\uB1E9\uB1EC\uB1F0\uB1F9\uB1FB\uB1FD\uB204\uB205\uB208\uB20B\uB20C\uB214\uB215\uB217\uB219\uB220\uB234\uB23C\uB258\uB25C\uB260\uB268\uB269\uB274\uB275\uB27C\uB284\uB285\uB289\uB290\uB291\uB294\uB298\uB299\uB29A\uB2A0\uB2A1\uB2A3\uB2A5\uB2A6\uB2AA\uB2AC\uB2B0\uB2B4\uB2C8\uB2C9\uB2CC\uB2D0\uB2D2\uB2D8\uB2D9\uB2DB\uB2DD\uB2E2\uB2E4\uB2E5\uB2E6\uB2E8\uB2EB\uB2EC\uB2ED\uB2EE\uB2EF\uB2F3\uB2F4\uB2F5\uB2F7\uB2F8\uB2F9\uB2FA\uB2FB\uB2FF\uB300\uB301\uB304\uB308\uB310\uB311\uB313\uB314\uB315\uB31C\uB354\uB355\uB356\uB358\uB35B\uB35C\uB35E\uB35F\uB364\uB365\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD095\uD096\uD097\uD098\uD099\uD09A\uD09B\uD09C\uD09D\uD09E\uD09F\uD0A0\uD0A1\uD0A2\uD0A3\uD0A6\uD0A7\uD0A9\uD0AA\uD0AB\uD0AD\uD0AE\uD0AF\uD0B0\uD0B1\uD0B2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD0B3\uD0B6\uD0B8\uD0BA\uD0BB\uD0BC\uD0BD\uD0BE\uD0BF\uD0C2\uD0C3\uD0C5\uD0C6\uD0C7\uD0CA\uD0CB\uD0CC\uD0CD\uD0CE\uD0CF\uD0D2\uD0D6\uD0D7\uD0D8\uD0D9\uD0DA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD0DB\uD0DE\uD0DF\uD0E1\uD0E2\uD0E3\uD0E5\uD0E6\uD0E7\uD0E8\uD0E9\uD0EA\uD0EB\uD0EE\uD0F2\uD0F3\uD0F4\uD0F5\uD0F6\uD0F7\uD0F9\uD0FA\uD0FB\uD0FC\uD0FD\uD0FE\uD0FF\uD100\uD101\uD102\uD103\uD104\uB367\uB369\uB36B\uB36E\uB370\uB371\uB374\uB378\uB380\uB381\uB383\uB384\uB385\uB38C\uB390\uB394\uB3A0\uB3A1\uB3A8\uB3AC\uB3C4\uB3C5\uB3C8\uB3CB\uB3CC\uB3CE\uB3D0\uB3D4\uB3D5\uB3D7\uB3D9\uB3DB\uB3DD\uB3E0\uB3E4\uB3E8\uB3FC\uB410\uB418\uB41C\uB420\uB428\uB429\uB42B\uB434\uB450\uB451\uB454\uB458\uB460\uB461\uB463\uB465\uB46C\uB480\uB488\uB49D\uB4A4\uB4A8\uB4AC\uB4B5\uB4B7\uB4B9\uB4C0\uB4C4\uB4C8\uB4D0\uB4D5\uB4DC\uB4DD\uB4E0\uB4E3\uB4E4\uB4E6\uB4EC\uB4ED\uB4EF\uB4F1\uB4F8\uB514\uB515\uB518\uB51B\uB51C\uB524\uB525\uB527\uB528\uB529\uB52A\uB530\uB531\uB534\uB538\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD105\uD106\uD107\uD108\uD109\uD10A\uD10B\uD10C\uD10E\uD10F\uD110\uD111\uD112\uD113\uD114\uD115\uD116\uD117\uD118\uD119\uD11A\uD11B\uD11C\uD11D\uD11E\uD11F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD120\uD121\uD122\uD123\uD124\uD125\uD126\uD127\uD128\uD129\uD12A\uD12B\uD12C\uD12D\uD12E\uD12F\uD132\uD133\uD135\uD136\uD137\uD139\uD13B\uD13C\uD13D\uD13E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD13F\uD142\uD146\uD147\uD148\uD149\uD14A\uD14B\uD14E\uD14F\uD151\uD152\uD153\uD155\uD156\uD157\uD158\uD159\uD15A\uD15B\uD15E\uD160\uD162\uD163\uD164\uD165\uD166\uD167\uD169\uD16A\uD16B\uD16D\uB540\uB541\uB543\uB544\uB545\uB54B\uB54C\uB54D\uB550\uB554\uB55C\uB55D\uB55F\uB560\uB561\uB5A0\uB5A1\uB5A4\uB5A8\uB5AA\uB5AB\uB5B0\uB5B1\uB5B3\uB5B4\uB5B5\uB5BB\uB5BC\uB5BD\uB5C0\uB5C4\uB5CC\uB5CD\uB5CF\uB5D0\uB5D1\uB5D8\uB5EC\uB610\uB611\uB614\uB618\uB625\uB62C\uB634\uB648\uB664\uB668\uB69C\uB69D\uB6A0\uB6A4\uB6AB\uB6AC\uB6B1\uB6D4\uB6F0\uB6F4\uB6F8\uB700\uB701\uB705\uB728\uB729\uB72C\uB72F\uB730\uB738\uB739\uB73B\uB744\uB748\uB74C\uB754\uB755\uB760\uB764\uB768\uB770\uB771\uB773\uB775\uB77C\uB77D\uB780\uB784\uB78C\uB78D\uB78F\uB790\uB791\uB792\uB796\uB797\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD16E\uD16F\uD170\uD171\uD172\uD173\uD174\uD175\uD176\uD177\uD178\uD179\uD17A\uD17B\uD17D\uD17E\uD17F\uD180\uD181\uD182\uD183\uD185\uD186\uD187\uD189\uD18A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD18B\uD18C\uD18D\uD18E\uD18F\uD190\uD191\uD192\uD193\uD194\uD195\uD196\uD197\uD198\uD199\uD19A\uD19B\uD19C\uD19D\uD19E\uD19F\uD1A2\uD1A3\uD1A5\uD1A6\uD1A7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD1A9\uD1AA\uD1AB\uD1AC\uD1AD\uD1AE\uD1AF\uD1B2\uD1B4\uD1B6\uD1B7\uD1B8\uD1B9\uD1BB\uD1BD\uD1BE\uD1BF\uD1C1\uD1C2\uD1C3\uD1C4\uD1C5\uD1C6\uD1C7\uD1C8\uD1C9\uD1CA\uD1CB\uD1CC\uD1CD\uD1CE\uD1CF\uB798\uB799\uB79C\uB7A0\uB7A8\uB7A9\uB7AB\uB7AC\uB7AD\uB7B4\uB7B5\uB7B8\uB7C7\uB7C9\uB7EC\uB7ED\uB7F0\uB7F4\uB7FC\uB7FD\uB7FF\uB800\uB801\uB807\uB808\uB809\uB80C\uB810\uB818\uB819\uB81B\uB81D\uB824\uB825\uB828\uB82C\uB834\uB835\uB837\uB838\uB839\uB840\uB844\uB851\uB853\uB85C\uB85D\uB860\uB864\uB86C\uB86D\uB86F\uB871\uB878\uB87C\uB88D\uB8A8\uB8B0\uB8B4\uB8B8\uB8C0\uB8C1\uB8C3\uB8C5\uB8CC\uB8D0\uB8D4\uB8DD\uB8DF\uB8E1\uB8E8\uB8E9\uB8EC\uB8F0\uB8F8\uB8F9\uB8FB\uB8FD\uB904\uB918\uB920\uB93C\uB93D\uB940\uB944\uB94C\uB94F\uB951\uB958\uB959\uB95C\uB960\uB968\uB969\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD1D0\uD1D1\uD1D2\uD1D3\uD1D4\uD1D5\uD1D6\uD1D7\uD1D9\uD1DA\uD1DB\uD1DC\uD1DD\uD1DE\uD1DF\uD1E0\uD1E1\uD1E2\uD1E3\uD1E4\uD1E5\uD1E6\uD1E7\uD1E8\uD1E9\uD1EA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD1EB\uD1EC\uD1ED\uD1EE\uD1EF\uD1F0\uD1F1\uD1F2\uD1F3\uD1F5\uD1F6\uD1F7\uD1F9\uD1FA\uD1FB\uD1FC\uD1FD\uD1FE\uD1FF\uD200\uD201\uD202\uD203\uD204\uD205\uD206\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD208\uD20A\uD20B\uD20C\uD20D\uD20E\uD20F\uD211\uD212\uD213\uD214\uD215\uD216\uD217\uD218\uD219\uD21A\uD21B\uD21C\uD21D\uD21E\uD21F\uD220\uD221\uD222\uD223\uD224\uD225\uD226\uD227\uD228\uD229\uB96B\uB96D\uB974\uB975\uB978\uB97C\uB984\uB985\uB987\uB989\uB98A\uB98D\uB98E\uB9AC\uB9AD\uB9B0\uB9B4\uB9BC\uB9BD\uB9BF\uB9C1\uB9C8\uB9C9\uB9CC\uB9CE\uB9CF\uB9D0\uB9D1\uB9D2\uB9D8\uB9D9\uB9DB\uB9DD\uB9DE\uB9E1\uB9E3\uB9E4\uB9E5\uB9E8\uB9EC\uB9F4\uB9F5\uB9F7\uB9F8\uB9F9\uB9FA\uBA00\uBA01\uBA08\uBA15\uBA38\uBA39\uBA3C\uBA40\uBA42\uBA48\uBA49\uBA4B\uBA4D\uBA4E\uBA53\uBA54\uBA55\uBA58\uBA5C\uBA64\uBA65\uBA67\uBA68\uBA69\uBA70\uBA71\uBA74\uBA78\uBA83\uBA84\uBA85\uBA87\uBA8C\uBAA8\uBAA9\uBAAB\uBAAC\uBAB0\uBAB2\uBAB8\uBAB9\uBABB\uBABD\uBAC4\uBAC8\uBAD8\uBAD9\uBAFC\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD22A\uD22B\uD22E\uD22F\uD231\uD232\uD233\uD235\uD236\uD237\uD238\uD239\uD23A\uD23B\uD23E\uD240\uD242\uD243\uD244\uD245\uD246\uD247\uD249\uD24A\uD24B\uD24C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD24D\uD24E\uD24F\uD250\uD251\uD252\uD253\uD254\uD255\uD256\uD257\uD258\uD259\uD25A\uD25B\uD25D\uD25E\uD25F\uD260\uD261\uD262\uD263\uD265\uD266\uD267\uD268\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD269\uD26A\uD26B\uD26C\uD26D\uD26E\uD26F\uD270\uD271\uD272\uD273\uD274\uD275\uD276\uD277\uD278\uD279\uD27A\uD27B\uD27C\uD27D\uD27E\uD27F\uD282\uD283\uD285\uD286\uD287\uD289\uD28A\uD28B\uD28C\uBB00\uBB04\uBB0D\uBB0F\uBB11\uBB18\uBB1C\uBB20\uBB29\uBB2B\uBB34\uBB35\uBB36\uBB38\uBB3B\uBB3C\uBB3D\uBB3E\uBB44\uBB45\uBB47\uBB49\uBB4D\uBB4F\uBB50\uBB54\uBB58\uBB61\uBB63\uBB6C\uBB88\uBB8C\uBB90\uBBA4\uBBA8\uBBAC\uBBB4\uBBB7\uBBC0\uBBC4\uBBC8\uBBD0\uBBD3\uBBF8\uBBF9\uBBFC\uBBFF\uBC00\uBC02\uBC08\uBC09\uBC0B\uBC0C\uBC0D\uBC0F\uBC11\uBC14\uBC15\uBC16\uBC17\uBC18\uBC1B\uBC1C\uBC1D\uBC1E\uBC1F\uBC24\uBC25\uBC27\uBC29\uBC2D\uBC30\uBC31\uBC34\uBC38\uBC40\uBC41\uBC43\uBC44\uBC45\uBC49\uBC4C\uBC4D\uBC50\uBC5D\uBC84\uBC85\uBC88\uBC8B\uBC8C\uBC8E\uBC94\uBC95\uBC97\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD28D\uD28E\uD28F\uD292\uD293\uD294\uD296\uD297\uD298\uD299\uD29A\uD29B\uD29D\uD29E\uD29F\uD2A1\uD2A2\uD2A3\uD2A5\uD2A6\uD2A7\uD2A8\uD2A9\uD2AA\uD2AB\uD2AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD2AE\uD2AF\uD2B0\uD2B2\uD2B3\uD2B4\uD2B5\uD2B6\uD2B7\uD2BA\uD2BB\uD2BD\uD2BE\uD2C1\uD2C3\uD2C4\uD2C5\uD2C6\uD2C7\uD2CA\uD2CC\uD2CD\uD2CE\uD2CF\uD2D0\uD2D1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD2D2\uD2D3\uD2D5\uD2D6\uD2D7\uD2D9\uD2DA\uD2DB\uD2DD\uD2DE\uD2DF\uD2E0\uD2E1\uD2E2\uD2E3\uD2E6\uD2E7\uD2E8\uD2E9\uD2EA\uD2EB\uD2EC\uD2ED\uD2EE\uD2EF\uD2F2\uD2F3\uD2F5\uD2F6\uD2F7\uD2F9\uD2FA\uBC99\uBC9A\uBCA0\uBCA1\uBCA4\uBCA7\uBCA8\uBCB0\uBCB1\uBCB3\uBCB4\uBCB5\uBCBC\uBCBD\uBCC0\uBCC4\uBCCD\uBCCF\uBCD0\uBCD1\uBCD5\uBCD8\uBCDC\uBCF4\uBCF5\uBCF6\uBCF8\uBCFC\uBD04\uBD05\uBD07\uBD09\uBD10\uBD14\uBD24\uBD2C\uBD40\uBD48\uBD49\uBD4C\uBD50\uBD58\uBD59\uBD64\uBD68\uBD80\uBD81\uBD84\uBD87\uBD88\uBD89\uBD8A\uBD90\uBD91\uBD93\uBD95\uBD99\uBD9A\uBD9C\uBDA4\uBDB0\uBDB8\uBDD4\uBDD5\uBDD8\uBDDC\uBDE9\uBDF0\uBDF4\uBDF8\uBE00\uBE03\uBE05\uBE0C\uBE0D\uBE10\uBE14\uBE1C\uBE1D\uBE1F\uBE44\uBE45\uBE48\uBE4C\uBE4E\uBE54\uBE55\uBE57\uBE59\uBE5A\uBE5B\uBE60\uBE61\uBE64\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD2FB\uD2FC\uD2FD\uD2FE\uD2FF\uD302\uD304\uD306\uD307\uD308\uD309\uD30A\uD30B\uD30F\uD311\uD312\uD313\uD315\uD317\uD318\uD319\uD31A\uD31B\uD31E\uD322\uD323\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD324\uD326\uD327\uD32A\uD32B\uD32D\uD32E\uD32F\uD331\uD332\uD333\uD334\uD335\uD336\uD337\uD33A\uD33E\uD33F\uD340\uD341\uD342\uD343\uD346\uD347\uD348\uD349\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD34A\uD34B\uD34C\uD34D\uD34E\uD34F\uD350\uD351\uD352\uD353\uD354\uD355\uD356\uD357\uD358\uD359\uD35A\uD35B\uD35C\uD35D\uD35E\uD35F\uD360\uD361\uD362\uD363\uD364\uD365\uD366\uD367\uD368\uD369\uBE68\uBE6A\uBE70\uBE71\uBE73\uBE74\uBE75\uBE7B\uBE7C\uBE7D\uBE80\uBE84\uBE8C\uBE8D\uBE8F\uBE90\uBE91\uBE98\uBE99\uBEA8\uBED0\uBED1\uBED4\uBED7\uBED8\uBEE0\uBEE3\uBEE4\uBEE5\uBEEC\uBF01\uBF08\uBF09\uBF18\uBF19\uBF1B\uBF1C\uBF1D\uBF40\uBF41\uBF44\uBF48\uBF50\uBF51\uBF55\uBF94\uBFB0\uBFC5\uBFCC\uBFCD\uBFD0\uBFD4\uBFDC\uBFDF\uBFE1\uC03C\uC051\uC058\uC05C\uC060\uC068\uC069\uC090\uC091\uC094\uC098\uC0A0\uC0A1\uC0A3\uC0A5\uC0AC\uC0AD\uC0AF\uC0B0\uC0B3\uC0B4\uC0B5\uC0B6\uC0BC\uC0BD\uC0BF\uC0C0\uC0C1\uC0C5\uC0C8\uC0C9\uC0CC\uC0D0\uC0D8\uC0D9\uC0DB\uC0DC\uC0DD\uC0E4\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD36A\uD36B\uD36C\uD36D\uD36E\uD36F\uD370\uD371\uD372\uD373\uD374\uD375\uD376\uD377\uD378\uD379\uD37A\uD37B\uD37E\uD37F\uD381\uD382\uD383\uD385\uD386\uD387\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD388\uD389\uD38A\uD38B\uD38E\uD392\uD393\uD394\uD395\uD396\uD397\uD39A\uD39B\uD39D\uD39E\uD39F\uD3A1\uD3A2\uD3A3\uD3A4\uD3A5\uD3A6\uD3A7\uD3AA\uD3AC\uD3AE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD3AF\uD3B0\uD3B1\uD3B2\uD3B3\uD3B5\uD3B6\uD3B7\uD3B9\uD3BA\uD3BB\uD3BD\uD3BE\uD3BF\uD3C0\uD3C1\uD3C2\uD3C3\uD3C6\uD3C7\uD3CA\uD3CB\uD3CC\uD3CD\uD3CE\uD3CF\uD3D1\uD3D2\uD3D3\uD3D4\uD3D5\uD3D6\uC0E5\uC0E8\uC0EC\uC0F4\uC0F5\uC0F7\uC0F9\uC100\uC104\uC108\uC110\uC115\uC11C\uC11D\uC11E\uC11F\uC120\uC123\uC124\uC126\uC127\uC12C\uC12D\uC12F\uC130\uC131\uC136\uC138\uC139\uC13C\uC140\uC148\uC149\uC14B\uC14C\uC14D\uC154\uC155\uC158\uC15C\uC164\uC165\uC167\uC168\uC169\uC170\uC174\uC178\uC185\uC18C\uC18D\uC18E\uC190\uC194\uC196\uC19C\uC19D\uC19F\uC1A1\uC1A5\uC1A8\uC1A9\uC1AC\uC1B0\uC1BD\uC1C4\uC1C8\uC1CC\uC1D4\uC1D7\uC1D8\uC1E0\uC1E4\uC1E8\uC1F0\uC1F1\uC1F3\uC1FC\uC1FD\uC200\uC204\uC20C\uC20D\uC20F\uC211\uC218\uC219\uC21C\uC21F\uC220\uC228\uC229\uC22B\uC22D\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD3D7\uD3D9\uD3DA\uD3DB\uD3DC\uD3DD\uD3DE\uD3DF\uD3E0\uD3E2\uD3E4\uD3E5\uD3E6\uD3E7\uD3E8\uD3E9\uD3EA\uD3EB\uD3EE\uD3EF\uD3F1\uD3F2\uD3F3\uD3F5\uD3F6\uD3F7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD3F8\uD3F9\uD3FA\uD3FB\uD3FE\uD400\uD402\uD403\uD404\uD405\uD406\uD407\uD409\uD40A\uD40B\uD40C\uD40D\uD40E\uD40F\uD410\uD411\uD412\uD413\uD414\uD415\uD416\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD417\uD418\uD419\uD41A\uD41B\uD41C\uD41E\uD41F\uD420\uD421\uD422\uD423\uD424\uD425\uD426\uD427\uD428\uD429\uD42A\uD42B\uD42C\uD42D\uD42E\uD42F\uD430\uD431\uD432\uD433\uD434\uD435\uD436\uD437\uC22F\uC231\uC232\uC234\uC248\uC250\uC251\uC254\uC258\uC260\uC265\uC26C\uC26D\uC270\uC274\uC27C\uC27D\uC27F\uC281\uC288\uC289\uC290\uC298\uC29B\uC29D\uC2A4\uC2A5\uC2A8\uC2AC\uC2AD\uC2B4\uC2B5\uC2B7\uC2B9\uC2DC\uC2DD\uC2E0\uC2E3\uC2E4\uC2EB\uC2EC\uC2ED\uC2EF\uC2F1\uC2F6\uC2F8\uC2F9\uC2FB\uC2FC\uC300\uC308\uC309\uC30C\uC30D\uC313\uC314\uC315\uC318\uC31C\uC324\uC325\uC328\uC329\uC345\uC368\uC369\uC36C\uC370\uC372\uC378\uC379\uC37C\uC37D\uC384\uC388\uC38C\uC3C0\uC3D8\uC3D9\uC3DC\uC3DF\uC3E0\uC3E2\uC3E8\uC3E9\uC3ED\uC3F4\uC3F5\uC3F8\uC408\uC410\uC424\uC42C\uC430\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD438\uD439\uD43A\uD43B\uD43C\uD43D\uD43E\uD43F\uD441\uD442\uD443\uD445\uD446\uD447\uD448\uD449\uD44A\uD44B\uD44C\uD44D\uD44E\uD44F\uD450\uD451\uD452\uD453\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD454\uD455\uD456\uD457\uD458\uD459\uD45A\uD45B\uD45D\uD45E\uD45F\uD461\uD462\uD463\uD465\uD466\uD467\uD468\uD469\uD46A\uD46B\uD46C\uD46E\uD470\uD471\uD472\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD473\uD474\uD475\uD476\uD477\uD47A\uD47B\uD47D\uD47E\uD481\uD483\uD484\uD485\uD486\uD487\uD48A\uD48C\uD48E\uD48F\uD490\uD491\uD492\uD493\uD495\uD496\uD497\uD498\uD499\uD49A\uD49B\uD49C\uD49D\uC434\uC43C\uC43D\uC448\uC464\uC465\uC468\uC46C\uC474\uC475\uC479\uC480\uC494\uC49C\uC4B8\uC4BC\uC4E9\uC4F0\uC4F1\uC4F4\uC4F8\uC4FA\uC4FF\uC500\uC501\uC50C\uC510\uC514\uC51C\uC528\uC529\uC52C\uC530\uC538\uC539\uC53B\uC53D\uC544\uC545\uC548\uC549\uC54A\uC54C\uC54D\uC54E\uC553\uC554\uC555\uC557\uC558\uC559\uC55D\uC55E\uC560\uC561\uC564\uC568\uC570\uC571\uC573\uC574\uC575\uC57C\uC57D\uC580\uC584\uC587\uC58C\uC58D\uC58F\uC591\uC595\uC597\uC598\uC59C\uC5A0\uC5A9\uC5B4\uC5B5\uC5B8\uC5B9\uC5BB\uC5BC\uC5BD\uC5BE\uC5C4\uC5C5\uC5C6\uC5C7\uC5C8\uC5C9\uC5CA\uC5CC\uC5CE\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD49E\uD49F\uD4A0\uD4A1\uD4A2\uD4A3\uD4A4\uD4A5\uD4A6\uD4A7\uD4A8\uD4AA\uD4AB\uD4AC\uD4AD\uD4AE\uD4AF\uD4B0\uD4B1\uD4B2\uD4B3\uD4B4\uD4B5\uD4B6\uD4B7\uD4B8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD4B9\uD4BA\uD4BB\uD4BC\uD4BD\uD4BE\uD4BF\uD4C0\uD4C1\uD4C2\uD4C3\uD4C4\uD4C5\uD4C6\uD4C7\uD4C8\uD4C9\uD4CA\uD4CB\uD4CD\uD4CE\uD4CF\uD4D1\uD4D2\uD4D3\uD4D5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD4D6\uD4D7\uD4D8\uD4D9\uD4DA\uD4DB\uD4DD\uD4DE\uD4E0\uD4E1\uD4E2\uD4E3\uD4E4\uD4E5\uD4E6\uD4E7\uD4E9\uD4EA\uD4EB\uD4ED\uD4EE\uD4EF\uD4F1\uD4F2\uD4F3\uD4F4\uD4F5\uD4F6\uD4F7\uD4F9\uD4FA\uD4FC\uC5D0\uC5D1\uC5D4\uC5D8\uC5E0\uC5E1\uC5E3\uC5E5\uC5EC\uC5ED\uC5EE\uC5F0\uC5F4\uC5F6\uC5F7\uC5FC\uC5FD\uC5FE\uC5FF\uC600\uC601\uC605\uC606\uC607\uC608\uC60C\uC610\uC618\uC619\uC61B\uC61C\uC624\uC625\uC628\uC62C\uC62D\uC62E\uC630\uC633\uC634\uC635\uC637\uC639\uC63B\uC640\uC641\uC644\uC648\uC650\uC651\uC653\uC654\uC655\uC65C\uC65D\uC660\uC66C\uC66F\uC671\uC678\uC679\uC67C\uC680\uC688\uC689\uC68B\uC68D\uC694\uC695\uC698\uC69C\uC6A4\uC6A5\uC6A7\uC6A9\uC6B0\uC6B1\uC6B4\uC6B8\uC6B9\uC6BA\uC6C0\uC6C1\uC6C3\uC6C5\uC6CC\uC6CD\uC6D0\uC6D4\uC6DC\uC6DD\uC6E0\uC6E1\uC6E8\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD4FE\uD4FF\uD500\uD501\uD502\uD503\uD505\uD506\uD507\uD509\uD50A\uD50B\uD50D\uD50E\uD50F\uD510\uD511\uD512\uD513\uD516\uD518\uD519\uD51A\uD51B\uD51C\uD51D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD51E\uD51F\uD520\uD521\uD522\uD523\uD524\uD525\uD526\uD527\uD528\uD529\uD52A\uD52B\uD52C\uD52D\uD52E\uD52F\uD530\uD531\uD532\uD533\uD534\uD535\uD536\uD537\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD538\uD539\uD53A\uD53B\uD53E\uD53F\uD541\uD542\uD543\uD545\uD546\uD547\uD548\uD549\uD54A\uD54B\uD54E\uD550\uD552\uD553\uD554\uD555\uD556\uD557\uD55A\uD55B\uD55D\uD55E\uD55F\uD561\uD562\uD563\uC6E9\uC6EC\uC6F0\uC6F8\uC6F9\uC6FD\uC704\uC705\uC708\uC70C\uC714\uC715\uC717\uC719\uC720\uC721\uC724\uC728\uC730\uC731\uC733\uC735\uC737\uC73C\uC73D\uC740\uC744\uC74A\uC74C\uC74D\uC74F\uC751\uC752\uC753\uC754\uC755\uC756\uC757\uC758\uC75C\uC760\uC768\uC76B\uC774\uC775\uC778\uC77C\uC77D\uC77E\uC783\uC784\uC785\uC787\uC788\uC789\uC78A\uC78E\uC790\uC791\uC794\uC796\uC797\uC798\uC79A\uC7A0\uC7A1\uC7A3\uC7A4\uC7A5\uC7A6\uC7AC\uC7AD\uC7B0\uC7B4\uC7BC\uC7BD\uC7BF\uC7C0\uC7C1\uC7C8\uC7C9\uC7CC\uC7CE\uC7D0\uC7D8\uC7DD\uC7E4\uC7E8\uC7EC\uC800\uC801\uC804\uC808\uC80A\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD564\uD566\uD567\uD56A\uD56C\uD56E\uD56F\uD570\uD571\uD572\uD573\uD576\uD577\uD579\uD57A\uD57B\uD57D\uD57E\uD57F\uD580\uD581\uD582\uD583\uD586\uD58A\uD58B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD58C\uD58D\uD58E\uD58F\uD591\uD592\uD593\uD594\uD595\uD596\uD597\uD598\uD599\uD59A\uD59B\uD59C\uD59D\uD59E\uD59F\uD5A0\uD5A1\uD5A2\uD5A3\uD5A4\uD5A6\uD5A7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD5A8\uD5A9\uD5AA\uD5AB\uD5AC\uD5AD\uD5AE\uD5AF\uD5B0\uD5B1\uD5B2\uD5B3\uD5B4\uD5B5\uD5B6\uD5B7\uD5B8\uD5B9\uD5BA\uD5BB\uD5BC\uD5BD\uD5BE\uD5BF\uD5C0\uD5C1\uD5C2\uD5C3\uD5C4\uD5C5\uD5C6\uD5C7\uC810\uC811\uC813\uC815\uC816\uC81C\uC81D\uC820\uC824\uC82C\uC82D\uC82F\uC831\uC838\uC83C\uC840\uC848\uC849\uC84C\uC84D\uC854\uC870\uC871\uC874\uC878\uC87A\uC880\uC881\uC883\uC885\uC886\uC887\uC88B\uC88C\uC88D\uC894\uC89D\uC89F\uC8A1\uC8A8\uC8BC\uC8BD\uC8C4\uC8C8\uC8CC\uC8D4\uC8D5\uC8D7\uC8D9\uC8E0\uC8E1\uC8E4\uC8F5\uC8FC\uC8FD\uC900\uC904\uC905\uC906\uC90C\uC90D\uC90F\uC911\uC918\uC92C\uC934\uC950\uC951\uC954\uC958\uC960\uC961\uC963\uC96C\uC970\uC974\uC97C\uC988\uC989\uC98C\uC990\uC998\uC999\uC99B\uC99D\uC9C0\uC9C1\uC9C4\uC9C7\uC9C8\uC9CA\uC9D0\uC9D1\uC9D3\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD5CA\uD5CB\uD5CD\uD5CE\uD5CF\uD5D1\uD5D3\uD5D4\uD5D5\uD5D6\uD5D7\uD5DA\uD5DC\uD5DE\uD5DF\uD5E0\uD5E1\uD5E2\uD5E3\uD5E6\uD5E7\uD5E9\uD5EA\uD5EB\uD5ED\uD5EE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD5EF\uD5F0\uD5F1\uD5F2\uD5F3\uD5F6\uD5F8\uD5FA\uD5FB\uD5FC\uD5FD\uD5FE\uD5FF\uD602\uD603\uD605\uD606\uD607\uD609\uD60A\uD60B\uD60C\uD60D\uD60E\uD60F\uD612\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD616\uD617\uD618\uD619\uD61A\uD61B\uD61D\uD61E\uD61F\uD621\uD622\uD623\uD625\uD626\uD627\uD628\uD629\uD62A\uD62B\uD62C\uD62E\uD62F\uD630\uD631\uD632\uD633\uD634\uD635\uD636\uD637\uD63A\uD63B\uC9D5\uC9D6\uC9D9\uC9DA\uC9DC\uC9DD\uC9E0\uC9E2\uC9E4\uC9E7\uC9EC\uC9ED\uC9EF\uC9F0\uC9F1\uC9F8\uC9F9\uC9FC\uCA00\uCA08\uCA09\uCA0B\uCA0C\uCA0D\uCA14\uCA18\uCA29\uCA4C\uCA4D\uCA50\uCA54\uCA5C\uCA5D\uCA5F\uCA60\uCA61\uCA68\uCA7D\uCA84\uCA98\uCABC\uCABD\uCAC0\uCAC4\uCACC\uCACD\uCACF\uCAD1\uCAD3\uCAD8\uCAD9\uCAE0\uCAEC\uCAF4\uCB08\uCB10\uCB14\uCB18\uCB20\uCB21\uCB41\uCB48\uCB49\uCB4C\uCB50\uCB58\uCB59\uCB5D\uCB64\uCB78\uCB79\uCB9C\uCBB8\uCBD4\uCBE4\uCBE7\uCBE9\uCC0C\uCC0D\uCC10\uCC14\uCC1C\uCC1D\uCC21\uCC22\uCC27\uCC28\uCC29\uCC2C\uCC2E\uCC30\uCC38\uCC39\uCC3B\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD63D\uD63E\uD63F\uD641\uD642\uD643\uD644\uD646\uD647\uD64A\uD64C\uD64E\uD64F\uD650\uD652\uD653\uD656\uD657\uD659\uD65A\uD65B\uD65D\uD65E\uD65F\uD660\uD661\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD662\uD663\uD664\uD665\uD666\uD668\uD66A\uD66B\uD66C\uD66D\uD66E\uD66F\uD672\uD673\uD675\uD676\uD677\uD678\uD679\uD67A\uD67B\uD67C\uD67D\uD67E\uD67F\uD680\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD681\uD682\uD684\uD686\uD687\uD688\uD689\uD68A\uD68B\uD68E\uD68F\uD691\uD692\uD693\uD695\uD696\uD697\uD698\uD699\uD69A\uD69B\uD69C\uD69E\uD6A0\uD6A2\uD6A3\uD6A4\uD6A5\uD6A6\uD6A7\uD6A9\uD6AA\uCC3C\uCC3D\uCC3E\uCC44\uCC45\uCC48\uCC4C\uCC54\uCC55\uCC57\uCC58\uCC59\uCC60\uCC64\uCC66\uCC68\uCC70\uCC75\uCC98\uCC99\uCC9C\uCCA0\uCCA8\uCCA9\uCCAB\uCCAC\uCCAD\uCCB4\uCCB5\uCCB8\uCCBC\uCCC4\uCCC5\uCCC7\uCCC9\uCCD0\uCCD4\uCCE4\uCCEC\uCCF0\uCD01\uCD08\uCD09\uCD0C\uCD10\uCD18\uCD19\uCD1B\uCD1D\uCD24\uCD28\uCD2C\uCD39\uCD5C\uCD60\uCD64\uCD6C\uCD6D\uCD6F\uCD71\uCD78\uCD88\uCD94\uCD95\uCD98\uCD9C\uCDA4\uCDA5\uCDA7\uCDA9\uCDB0\uCDC4\uCDCC\uCDD0\uCDE8\uCDEC\uCDF0\uCDF8\uCDF9\uCDFB\uCDFD\uCE04\uCE08\uCE0C\uCE14\uCE19\uCE20\uCE21\uCE24\uCE28\uCE30\uCE31\uCE33\uCE35\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD6AB\uD6AD\uD6AE\uD6AF\uD6B1\uD6B2\uD6B3\uD6B4\uD6B5\uD6B6\uD6B7\uD6B8\uD6BA\uD6BC\uD6BD\uD6BE\uD6BF\uD6C0\uD6C1\uD6C2\uD6C3\uD6C6\uD6C7\uD6C9\uD6CA\uD6CB\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD6CD\uD6CE\uD6CF\uD6D0\uD6D2\uD6D3\uD6D5\uD6D6\uD6D8\uD6DA\uD6DB\uD6DC\uD6DD\uD6DE\uD6DF\uD6E1\uD6E2\uD6E3\uD6E5\uD6E6\uD6E7\uD6E9\uD6EA\uD6EB\uD6EC\uD6ED\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD6EE\uD6EF\uD6F1\uD6F2\uD6F3\uD6F4\uD6F6\uD6F7\uD6F8\uD6F9\uD6FA\uD6FB\uD6FE\uD6FF\uD701\uD702\uD703\uD705\uD706\uD707\uD708\uD709\uD70A\uD70B\uD70C\uD70D\uD70E\uD70F\uD710\uD712\uD713\uD714\uCE58\uCE59\uCE5C\uCE5F\uCE60\uCE61\uCE68\uCE69\uCE6B\uCE6D\uCE74\uCE75\uCE78\uCE7C\uCE84\uCE85\uCE87\uCE89\uCE90\uCE91\uCE94\uCE98\uCEA0\uCEA1\uCEA3\uCEA4\uCEA5\uCEAC\uCEAD\uCEC1\uCEE4\uCEE5\uCEE8\uCEEB\uCEEC\uCEF4\uCEF5\uCEF7\uCEF8\uCEF9\uCF00\uCF01\uCF04\uCF08\uCF10\uCF11\uCF13\uCF15\uCF1C\uCF20\uCF24\uCF2C\uCF2D\uCF2F\uCF30\uCF31\uCF38\uCF54\uCF55\uCF58\uCF5C\uCF64\uCF65\uCF67\uCF69\uCF70\uCF71\uCF74\uCF78\uCF80\uCF85\uCF8C\uCFA1\uCFA8\uCFB0\uCFC4\uCFE0\uCFE1\uCFE4\uCFE8\uCFF0\uCFF1\uCFF3\uCFF5\uCFFC\uD000\uD004\uD011\uD018\uD02D\uD034\uD035\uD038\uD03C\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD715\uD716\uD717\uD71A\uD71B\uD71D\uD71E\uD71F\uD721\uD722\uD723\uD724\uD725\uD726\uD727\uD72A\uD72C\uD72E\uD72F\uD730\uD731\uD732\uD733\uD736\uD737\uD739\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD73A\uD73B\uD73D\uD73E\uD73F\uD740\uD741\uD742\uD743\uD745\uD746\uD748\uD74A\uD74B\uD74C\uD74D\uD74E\uD74F\uD752\uD753\uD755\uD75A\uD75B\uD75C\uD75D\uD75E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD75F\uD762\uD764\uD766\uD767\uD768\uD76A\uD76B\uD76D\uD76E\uD76F\uD771\uD772\uD773\uD775\uD776\uD777\uD778\uD779\uD77A\uD77B\uD77E\uD77F\uD780\uD782\uD783\uD784\uD785\uD786\uD787\uD78A\uD78B\uD044\uD045\uD047\uD049\uD050\uD054\uD058\uD060\uD06C\uD06D\uD070\uD074\uD07C\uD07D\uD081\uD0A4\uD0A5\uD0A8\uD0AC\uD0B4\uD0B5\uD0B7\uD0B9\uD0C0\uD0C1\uD0C4\uD0C8\uD0C9\uD0D0\uD0D1\uD0D3\uD0D4\uD0D5\uD0DC\uD0DD\uD0E0\uD0E4\uD0EC\uD0ED\uD0EF\uD0F0\uD0F1\uD0F8\uD10D\uD130\uD131\uD134\uD138\uD13A\uD140\uD141\uD143\uD144\uD145\uD14C\uD14D\uD150\uD154\uD15C\uD15D\uD15F\uD161\uD168\uD16C\uD17C\uD184\uD188\uD1A0\uD1A1\uD1A4\uD1A8\uD1B0\uD1B1\uD1B3\uD1B5\uD1BA\uD1BC\uD1C0\uD1D8\uD1F4\uD1F8\uD207\uD209\uD210\uD22C\uD22D\uD230\uD234\uD23C\uD23D\uD23F\uD241\uD248\uD25C\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD78D\uD78E\uD78F\uD791\uD792\uD793\uD794\uD795\uD796\uD797\uD79A\uD79C\uD79E\uD79F\uD7A0\uD7A1\uD7A2\uD7A3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD264\uD280\uD281\uD284\uD288\uD290\uD291\uD295\uD29C\uD2A0\uD2A4\uD2AC\uD2B1\uD2B8\uD2B9\uD2BC\uD2BF\uD2C0\uD2C2\uD2C8\uD2C9\uD2CB\uD2D4\uD2D8\uD2DC\uD2E4\uD2E5\uD2F0\uD2F1\uD2F4\uD2F8\uD300\uD301\uD303\uD305\uD30C\uD30D\uD30E\uD310\uD314\uD316\uD31C\uD31D\uD31F\uD320\uD321\uD325\uD328\uD329\uD32C\uD330\uD338\uD339\uD33B\uD33C\uD33D\uD344\uD345\uD37C\uD37D\uD380\uD384\uD38C\uD38D\uD38F\uD390\uD391\uD398\uD399\uD39C\uD3A0\uD3A8\uD3A9\uD3AB\uD3AD\uD3B4\uD3B8\uD3BC\uD3C4\uD3C5\uD3C8\uD3C9\uD3D0\uD3D8\uD3E1\uD3E3\uD3EC\uD3ED\uD3F0\uD3F4\uD3FC\uD3FD\uD3FF\uD401\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[199] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD408\uD41D\uD440\uD444\uD45C\uD460\uD464\uD46D\uD46F\uD478\uD479\uD47C\uD47F\uD480\uD482\uD488\uD489\uD48B\uD48D\uD494\uD4A9\uD4CC\uD4D0\uD4D4\uD4DC\uD4DF\uD4E8\uD4EC\uD4F0\uD4F8\uD4FB\uD4FD\uD504\uD508\uD50C\uD514\uD515\uD517\uD53C\uD53D\uD540\uD544\uD54C\uD54D\uD54F\uD551\uD558\uD559\uD55C\uD560\uD565\uD568\uD569\uD56B\uD56D\uD574\uD575\uD578\uD57C\uD584\uD585\uD587\uD588\uD589\uD590\uD5A5\uD5C8\uD5C9\uD5CC\uD5D0\uD5D2\uD5D8\uD5D9\uD5DB\uD5DD\uD5E4\uD5E5\uD5E8\uD5EC\uD5F4\uD5F5\uD5F7\uD5F9\uD600\uD601\uD604\uD608\uD610\uD611\uD613\uD614\uD615\uD61C\uD620\uFFFD".split("");
    for(j = 0; j != D[199].length; ++j)if (D[199][j].charCodeAt(0) !== 0xFFFD) {
        e[D[199][j]] = 50944 + j;
        d[50944 + j] = D[199][j];
    }
    D[200] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD624\uD62D\uD638\uD639\uD63C\uD640\uD645\uD648\uD649\uD64B\uD64D\uD651\uD654\uD655\uD658\uD65C\uD667\uD669\uD670\uD671\uD674\uD683\uD685\uD68C\uD68D\uD690\uD694\uD69D\uD69F\uD6A1\uD6A8\uD6AC\uD6B0\uD6B9\uD6BB\uD6C4\uD6C5\uD6C8\uD6CC\uD6D1\uD6D4\uD6D7\uD6D9\uD6E0\uD6E4\uD6E8\uD6F0\uD6F5\uD6FC\uD6FD\uD700\uD704\uD711\uD718\uD719\uD71C\uD720\uD728\uD729\uD72B\uD72D\uD734\uD735\uD738\uD73C\uD744\uD747\uD749\uD750\uD751\uD754\uD756\uD757\uD758\uD759\uD760\uD761\uD763\uD765\uD769\uD76C\uD770\uD774\uD77C\uD77D\uD781\uD788\uD789\uD78C\uD790\uD798\uD799\uD79B\uD79D\uFFFD".split("");
    for(j = 0; j != D[200].length; ++j)if (D[200][j].charCodeAt(0) !== 0xFFFD) {
        e[D[200][j]] = 51200 + j;
        d[51200 + j] = D[200][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F3D\u4F73\u5047\u50F9\u52A0\u53EF\u5475\u54E5\u5609\u5AC1\u5BB6\u6687\u67B6\u67B7\u67EF\u6B4C\u73C2\u75C2\u7A3C\u82DB\u8304\u8857\u8888\u8A36\u8CC8\u8DCF\u8EFB\u8FE6\u99D5\u523B\u5374\u5404\u606A\u6164\u6BBC\u73CF\u811A\u89BA\u89D2\u95A3\u4F83\u520A\u58BE\u5978\u59E6\u5E72\u5E79\u61C7\u63C0\u6746\u67EC\u687F\u6F97\u764E\u770B\u78F5\u7A08\u7AFF\u7C21\u809D\u826E\u8271\u8AEB\u9593\u4E6B\u559D\u66F7\u6E34\u78A3\u7AED\u845B\u8910\u874E\u97A8\u52D8\u574E\u582A\u5D4C\u611F\u61BE\u6221\u6562\u67D1\u6A44\u6E1B\u7518\u75B3\u76E3\u77B0\u7D3A\u90AF\u9451\u9452\u9F95\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5323\u5CAC\u7532\u80DB\u9240\u9598\u525B\u5808\u59DC\u5CA1\u5D17\u5EB7\u5F3A\u5F4A\u6177\u6C5F\u757A\u7586\u7CE0\u7D73\u7DB1\u7F8C\u8154\u8221\u8591\u8941\u8B1B\u92FC\u964D\u9C47\u4ECB\u4EF7\u500B\u51F1\u584F\u6137\u613E\u6168\u6539\u69EA\u6F11\u75A5\u7686\u76D6\u7B87\u82A5\u84CB\uF900\u93A7\u958B\u5580\u5BA2\u5751\uF901\u7CB3\u7FB9\u91B5\u5028\u53BB\u5C45\u5DE8\u62D2\u636E\u64DA\u64E7\u6E20\u70AC\u795B\u8DDD\u8E1E\uF902\u907D\u9245\u92F8\u4E7E\u4EF6\u5065\u5DFE\u5EFA\u6106\u6957\u8171\u8654\u8E47\u9375\u9A2B\u4E5E\u5091\u6770\u6840\u5109\u528D\u5292\u6AA2\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77BC\u9210\u9ED4\u52AB\u602F\u8FF2\u5048\u61A9\u63ED\u64CA\u683C\u6A84\u6FC0\u8188\u89A1\u9694\u5805\u727D\u72AC\u7504\u7D79\u7E6D\u80A9\u898B\u8B74\u9063\u9D51\u6289\u6C7A\u6F54\u7D50\u7F3A\u8A23\u517C\u614A\u7B9D\u8B19\u9257\u938C\u4EAC\u4FD3\u501E\u50BE\u5106\u52C1\u52CD\u537F\u5770\u5883\u5E9A\u5F91\u6176\u61AC\u64CE\u656C\u666F\u66BB\u66F4\u6897\u6D87\u7085\u70F1\u749F\u74A5\u74CA\u75D9\u786C\u78EC\u7ADF\u7AF6\u7D45\u7D93\u8015\u803F\u811B\u8396\u8B66\u8F15\u9015\u93E1\u9803\u9838\u9A5A\u9BE8\u4FC2\u5553\u583A\u5951\u5B63\u5C46\u60B8\u6212\u6842\u68B0\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u68E8\u6EAA\u754C\u7678\u78CE\u7A3D\u7CFB\u7E6B\u7E7C\u8A08\u8AA1\u8C3F\u968E\u9DC4\u53E4\u53E9\u544A\u5471\u56FA\u59D1\u5B64\u5C3B\u5EAB\u62F7\u6537\u6545\u6572\u66A0\u67AF\u69C1\u6CBD\u75FC\u7690\u777E\u7A3F\u7F94\u8003\u80A1\u818F\u82E6\u82FD\u83F0\u85C1\u8831\u88B4\u8AA5\uF903\u8F9C\u932E\u96C7\u9867\u9AD8\u9F13\u54ED\u659B\u66F2\u688F\u7A40\u8C37\u9D60\u56F0\u5764\u5D11\u6606\u68B1\u68CD\u6EFE\u7428\u889E\u9BE4\u6C68\uF904\u9AA8\u4F9B\u516C\u5171\u529F\u5B54\u5DE5\u6050\u606D\u62F1\u63A7\u653B\u73D9\u7A7A\u86A3\u8CA2\u978F\u4E32\u5BE1\u6208\u679C\u74DC\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u79D1\u83D3\u8A87\u8AB2\u8DE8\u904E\u934B\u9846\u5ED3\u69E8\u85FF\u90ED\uF905\u51A0\u5B98\u5BEC\u6163\u68FA\u6B3E\u704C\u742F\u74D8\u7BA1\u7F50\u83C5\u89C0\u8CAB\u95DC\u9928\u522E\u605D\u62EC\u9002\u4F8A\u5149\u5321\u58D9\u5EE3\u66E0\u6D38\u709A\u72C2\u73D6\u7B50\u80F1\u945B\u5366\u639B\u7F6B\u4E56\u5080\u584A\u58DE\u602A\u6127\u62D0\u69D0\u9B41\u5B8F\u7D18\u80B1\u8F5F\u4EA4\u50D1\u54AC\u55AC\u5B0C\u5DA0\u5DE7\u652A\u654E\u6821\u6A4B\u72E1\u768E\u77EF\u7D5E\u7FF9\u81A0\u854E\u86DF\u8F03\u8F4E\u90CA\u9903\u9A55\u9BAB\u4E18\u4E45\u4E5D\u4EC7\u4FF1\u5177\u52FE\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5340\u53E3\u53E5\u548E\u5614\u5775\u57A2\u5BC7\u5D87\u5ED0\u61FC\u62D8\u6551\u67B8\u67E9\u69CB\u6B50\u6BC6\u6BEC\u6C42\u6E9D\u7078\u72D7\u7396\u7403\u77BF\u77E9\u7A76\u7D7F\u8009\u81FC\u8205\u820A\u82DF\u8862\u8B33\u8CFC\u8EC0\u9011\u90B1\u9264\u92B6\u99D2\u9A45\u9CE9\u9DD7\u9F9C\u570B\u5C40\u83CA\u97A0\u97AB\u9EB4\u541B\u7A98\u7FA4\u88D9\u8ECD\u90E1\u5800\u5C48\u6398\u7A9F\u5BAE\u5F13\u7A79\u7AAE\u828E\u8EAC\u5026\u5238\u52F8\u5377\u5708\u62F3\u6372\u6B0A\u6DC3\u7737\u53A5\u7357\u8568\u8E76\u95D5\u673A\u6AC3\u6F70\u8A6D\u8ECC\u994B\uF906\u6677\u6B78\u8CB4\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B3C\uF907\u53EB\u572D\u594E\u63C6\u69FB\u73EA\u7845\u7ABA\u7AC5\u7CFE\u8475\u898F\u8D73\u9035\u95A8\u52FB\u5747\u7547\u7B60\u83CC\u921E\uF908\u6A58\u514B\u524B\u5287\u621F\u68D8\u6975\u9699\u50C5\u52A4\u52E4\u61C3\u65A4\u6839\u69FF\u747E\u7B4B\u82B9\u83EB\u89B2\u8B39\u8FD1\u9949\uF909\u4ECA\u5997\u64D2\u6611\u6A8E\u7434\u7981\u79BD\u82A9\u887E\u887F\u895F\uF90A\u9326\u4F0B\u53CA\u6025\u6271\u6C72\u7D1A\u7D66\u4E98\u5162\u77DC\u80AF\u4F01\u4F0E\u5176\u5180\u55DC\u5668\u573B\u57FA\u57FC\u5914\u5947\u5993\u5BC4\u5C90\u5D0E\u5DF1\u5E7E\u5FCC\u6280\u65D7\u65E3\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u671E\u671F\u675E\u68CB\u68C4\u6A5F\u6B3A\u6C23\u6C7D\u6C82\u6DC7\u7398\u7426\u742A\u7482\u74A3\u7578\u757F\u7881\u78EF\u7941\u7947\u7948\u797A\u7B95\u7D00\u7DBA\u7F88\u8006\u802D\u808C\u8A18\u8B4F\u8C48\u8D77\u9321\u9324\u98E2\u9951\u9A0E\u9A0F\u9A65\u9E92\u7DCA\u4F76\u5409\u62EE\u6854\u91D1\u55AB\u513A\uF90B\uF90C\u5A1C\u61E6\uF90D\u62CF\u62FF\uF90E\uF90F\uF910\uF911\uF912\uF913\u90A3\uF914\uF915\uF916\uF917\uF918\u8AFE\uF919\uF91A\uF91B\uF91C\u6696\uF91D\u7156\uF91E\uF91F\u96E3\uF920\u634F\u637A\u5357\uF921\u678F\u6960\u6E73\uF922\u7537\uF923\uF924\uF925\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D0D\uF926\uF927\u8872\u56CA\u5A18\uF928\uF929\uF92A\uF92B\uF92C\u4E43\uF92D\u5167\u5948\u67F0\u8010\uF92E\u5973\u5E74\u649A\u79CA\u5FF5\u606C\u62C8\u637B\u5BE7\u5BD7\u52AA\uF92F\u5974\u5F29\u6012\uF930\uF931\uF932\u7459\uF933\uF934\uF935\uF936\uF937\uF938\u99D1\uF939\uF93A\uF93B\uF93C\uF93D\uF93E\uF93F\uF940\uF941\uF942\uF943\u6FC3\uF944\uF945\u81BF\u8FB2\u60F1\uF946\uF947\u8166\uF948\uF949\u5C3F\uF94A\uF94B\uF94C\uF94D\uF94E\uF94F\uF950\uF951\u5AE9\u8A25\u677B\u7D10\uF952\uF953\uF954\uF955\uF956\uF957\u80FD\uF958\uF959\u5C3C\u6CE5\u533F\u6EBA\u591A\u8336\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E39\u4EB6\u4F46\u55AE\u5718\u58C7\u5F56\u65B7\u65E6\u6A80\u6BB5\u6E4D\u77ED\u7AEF\u7C1E\u7DDE\u86CB\u8892\u9132\u935B\u64BB\u6FBE\u737A\u75B8\u9054\u5556\u574D\u61BA\u64D4\u66C7\u6DE1\u6E5B\u6F6D\u6FB9\u75F0\u8043\u81BD\u8541\u8983\u8AC7\u8B5A\u931F\u6C93\u7553\u7B54\u8E0F\u905D\u5510\u5802\u5858\u5E62\u6207\u649E\u68E0\u7576\u7CD6\u87B3\u9EE8\u4EE3\u5788\u576E\u5927\u5C0D\u5CB1\u5E36\u5F85\u6234\u64E1\u73B3\u81FA\u888B\u8CB8\u968A\u9EDB\u5B85\u5FB7\u60B3\u5012\u5200\u5230\u5716\u5835\u5857\u5C0E\u5C60\u5CF6\u5D8B\u5EA6\u5F92\u60BC\u6311\u6389\u6417\u6843\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u68F9\u6AC2\u6DD8\u6E21\u6ED4\u6FE4\u71FE\u76DC\u7779\u79B1\u7A3B\u8404\u89A9\u8CED\u8DF3\u8E48\u9003\u9014\u9053\u90FD\u934D\u9676\u97DC\u6BD2\u7006\u7258\u72A2\u7368\u7763\u79BF\u7BE4\u7E9B\u8B80\u58A9\u60C7\u6566\u65FD\u66BE\u6C8C\u711E\u71C9\u8C5A\u9813\u4E6D\u7A81\u4EDD\u51AC\u51CD\u52D5\u540C\u61A7\u6771\u6850\u68DF\u6D1E\u6F7C\u75BC\u77B3\u7AE5\u80F4\u8463\u9285\u515C\u6597\u675C\u6793\u75D8\u7AC7\u8373\uF95A\u8C46\u9017\u982D\u5C6F\u81C0\u829A\u9041\u906F\u920D\u5F97\u5D9D\u6A59\u71C8\u767B\u7B49\u85E4\u8B04\u9127\u9A30\u5587\u61F6\uF95B\u7669\u7F85\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u863F\u87BA\u88F8\u908F\uF95C\u6D1B\u70D9\u73DE\u7D61\u843D\uF95D\u916A\u99F1\uF95E\u4E82\u5375\u6B04\u6B12\u703E\u721B\u862D\u9E1E\u524C\u8FA3\u5D50\u64E5\u652C\u6B16\u6FEB\u7C43\u7E9C\u85CD\u8964\u89BD\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u7405\u746F\u8782\u90DE\u4F86\u5D0D\u5FA0\u840A\u51B7\u63A0\u7565\u4EAE\u5006\u5169\u51C9\u6881\u6A11\u7CAE\u7CB1\u7CE7\u826F\u8AD2\u8F1B\u91CF\u4FB6\u5137\u52F5\u5442\u5EEC\u616E\u623E\u65C5\u6ADA\u6FFE\u792A\u85DC\u8823\u95AD\u9A62\u9A6A\u9E97\u9ECE\u529B\u66C6\u6B77\u701D\u792B\u8F62\u9742\u6190\u6200\u6523\u6F23\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7149\u7489\u7DF4\u806F\u84EE\u8F26\u9023\u934A\u51BD\u5217\u52A3\u6D0C\u70C8\u88C2\u5EC9\u6582\u6BAE\u6FC2\u7C3E\u7375\u4EE4\u4F36\u56F9\uF95F\u5CBA\u5DBA\u601C\u73B2\u7B2D\u7F9A\u7FCE\u8046\u901E\u9234\u96F6\u9748\u9818\u9F61\u4F8B\u6FA7\u79AE\u91B4\u96B7\u52DE\uF960\u6488\u64C4\u6AD3\u6F5E\u7018\u7210\u76E7\u8001\u8606\u865C\u8DEF\u8F05\u9732\u9B6F\u9DFA\u9E75\u788C\u797F\u7DA0\u83C9\u9304\u9E7F\u9E93\u8AD6\u58DF\u5F04\u6727\u7027\u74CF\u7C60\u807E\u5121\u7028\u7262\u78CA\u8CC2\u8CDA\u8CF4\u96F7\u4E86\u50DA\u5BEE\u5ED6\u6599\u71CE\u7642\u77AD\u804A\u84FC\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u907C\u9B27\u9F8D\u58D8\u5A41\u5C62\u6A13\u6DDA\u6F0F\u763B\u7D2F\u7E37\u851E\u8938\u93E4\u964B\u5289\u65D2\u67F3\u69B4\u6D41\u6E9C\u700F\u7409\u7460\u7559\u7624\u786B\u8B2C\u985E\u516D\u622E\u9678\u4F96\u502B\u5D19\u6DEA\u7DB8\u8F2A\u5F8B\u6144\u6817\uF961\u9686\u52D2\u808B\u51DC\u51CC\u695E\u7A1C\u7DBE\u83F1\u9675\u4FDA\u5229\u5398\u540F\u550E\u5C65\u60A7\u674E\u68A8\u6D6C\u7281\u72F8\u7406\u7483\uF962\u75E2\u7C6C\u7F79\u7FB8\u8389\u88CF\u88E1\u91CC\u91D0\u96E2\u9BC9\u541D\u6F7E\u71D0\u7498\u85FA\u8EAA\u96A3\u9C57\u9E9F\u6797\u6DCB\u7433\u81E8\u9716\u782C\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7ACB\u7B20\u7C92\u6469\u746A\u75F2\u78BC\u78E8\u99AC\u9B54\u9EBB\u5BDE\u5E55\u6F20\u819C\u83AB\u9088\u4E07\u534D\u5A29\u5DD2\u5F4E\u6162\u633D\u6669\u66FC\u6EFF\u6F2B\u7063\u779E\u842C\u8513\u883B\u8F13\u9945\u9C3B\u551C\u62B9\u672B\u6CAB\u8309\u896A\u977A\u4EA1\u5984\u5FD8\u5FD9\u671B\u7DB2\u7F54\u8292\u832B\u83BD\u8F1E\u9099\u57CB\u59B9\u5A92\u5BD0\u6627\u679A\u6885\u6BCF\u7164\u7F75\u8CB7\u8CE3\u9081\u9B45\u8108\u8C8A\u964C\u9A40\u9EA5\u5B5F\u6C13\u731B\u76F2\u76DF\u840C\u51AA\u8993\u514D\u5195\u52C9\u68C9\u6C94\u7704\u7720\u7DBF\u7DEC\u9762\u9EB5\u6EC5\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8511\u51A5\u540D\u547D\u660E\u669D\u6927\u6E9F\u76BF\u7791\u8317\u84C2\u879F\u9169\u9298\u9CF4\u8882\u4FAE\u5192\u52DF\u59C6\u5E3D\u6155\u6478\u6479\u66AE\u67D0\u6A21\u6BCD\u6BDB\u725F\u7261\u7441\u7738\u77DB\u8017\u82BC\u8305\u8B00\u8B28\u8C8C\u6728\u6C90\u7267\u76EE\u7766\u7A46\u9DA9\u6B7F\u6C92\u5922\u6726\u8499\u536F\u5893\u5999\u5EDF\u63CF\u6634\u6773\u6E3A\u732B\u7AD7\u82D7\u9328\u52D9\u5DEB\u61AE\u61CB\u620A\u62C7\u64AB\u65E0\u6959\u6B66\u6BCB\u7121\u73F7\u755D\u7E46\u821E\u8302\u856A\u8AA3\u8CBF\u9727\u9D61\u58A8\u9ED8\u5011\u520E\u543B\u554F\u6587\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C76\u7D0A\u7D0B\u805E\u868A\u9580\u96EF\u52FF\u6C95\u7269\u5473\u5A9A\u5C3E\u5D4B\u5F4C\u5FAE\u672A\u68B6\u6963\u6E3C\u6E44\u7709\u7C73\u7F8E\u8587\u8B0E\u8FF7\u9761\u9EF4\u5CB7\u60B6\u610D\u61AB\u654F\u65FB\u65FC\u6C11\u6CEF\u739F\u73C9\u7DE1\u9594\u5BC6\u871C\u8B10\u525D\u535A\u62CD\u640F\u64B2\u6734\u6A38\u6CCA\u73C0\u749E\u7B94\u7C95\u7E1B\u818A\u8236\u8584\u8FEB\u96F9\u99C1\u4F34\u534A\u53CD\u53DB\u62CC\u642C\u6500\u6591\u69C3\u6CEE\u6F58\u73ED\u7554\u7622\u76E4\u76FC\u78D0\u78FB\u792C\u7D46\u822C\u87E0\u8FD4\u9812\u98EF\u52C3\u62D4\u64A5\u6E24\u6F51\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u767C\u8DCB\u91B1\u9262\u9AEE\u9B43\u5023\u508D\u574A\u59A8\u5C28\u5E47\u5F77\u623F\u653E\u65B9\u65C1\u6609\u678B\u699C\u6EC2\u78C5\u7D21\u80AA\u8180\u822B\u82B3\u84A1\u868C\u8A2A\u8B17\u90A6\u9632\u9F90\u500D\u4FF3\uF963\u57F9\u5F98\u62DC\u6392\u676F\u6E43\u7119\u76C3\u80CC\u80DA\u88F4\u88F5\u8919\u8CE0\u8F29\u914D\u966A\u4F2F\u4F70\u5E1B\u67CF\u6822\u767D\u767E\u9B44\u5E61\u6A0A\u7169\u71D4\u756A\uF964\u7E41\u8543\u85E9\u98DC\u4F10\u7B4F\u7F70\u95A5\u51E1\u5E06\u68B5\u6C3E\u6C4E\u6CDB\u72AF\u7BC4\u8303\u6CD5\u743A\u50FB\u5288\u58C1\u64D8\u6A97\u74A7\u7656\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u78A7\u8617\u95E2\u9739\uF965\u535E\u5F01\u8B8A\u8FA8\u8FAF\u908A\u5225\u77A5\u9C49\u9F08\u4E19\u5002\u5175\u5C5B\u5E77\u661E\u663A\u67C4\u68C5\u70B3\u7501\u75C5\u79C9\u7ADD\u8F27\u9920\u9A08\u4FDD\u5821\u5831\u5BF6\u666E\u6B65\u6D11\u6E7A\u6F7D\u73E4\u752B\u83E9\u88DC\u8913\u8B5C\u8F14\u4F0F\u50D5\u5310\u535C\u5B93\u5FA9\u670D\u798F\u8179\u832F\u8514\u8907\u8986\u8F39\u8F3B\u99A5\u9C12\u672C\u4E76\u4FF8\u5949\u5C01\u5CEF\u5CF0\u6367\u68D2\u70FD\u71A2\u742B\u7E2B\u84EC\u8702\u9022\u92D2\u9CF3\u4E0D\u4ED8\u4FEF\u5085\u5256\u526F\u5426\u5490\u57E0\u592B\u5A66\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5B5A\u5B75\u5BCC\u5E9C\uF966\u6276\u6577\u65A7\u6D6E\u6EA5\u7236\u7B26\u7C3F\u7F36\u8150\u8151\u819A\u8240\u8299\u83A9\u8A03\u8CA0\u8CE6\u8CFB\u8D74\u8DBA\u90E8\u91DC\u961C\u9644\u99D9\u9CE7\u5317\u5206\u5429\u5674\u58B3\u5954\u596E\u5FFF\u61A4\u626E\u6610\u6C7E\u711A\u76C6\u7C89\u7CDE\u7D1B\u82AC\u8CC1\u96F0\uF967\u4F5B\u5F17\u5F7F\u62C2\u5D29\u670B\u68DA\u787C\u7E43\u9D6C\u4E15\u5099\u5315\u532A\u5351\u5983\u5A62\u5E87\u60B2\u618A\u6249\u6279\u6590\u6787\u69A7\u6BD4\u6BD6\u6BD7\u6BD8\u6CB8\uF968\u7435\u75FA\u7812\u7891\u79D5\u79D8\u7C83\u7DCB\u7FE1\u80A5\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u813E\u81C2\u83F2\u871A\u88E8\u8AB9\u8B6C\u8CBB\u9119\u975E\u98DB\u9F3B\u56AC\u5B2A\u5F6C\u658C\u6AB3\u6BAF\u6D5C\u6FF1\u7015\u725D\u73AD\u8CA7\u8CD3\u983B\u6191\u6C37\u8058\u9A01\u4E4D\u4E8B\u4E9B\u4ED5\u4F3A\u4F3C\u4F7F\u4FDF\u50FF\u53F2\u53F8\u5506\u55E3\u56DB\u58EB\u5962\u5A11\u5BEB\u5BFA\u5C04\u5DF3\u5E2B\u5F99\u601D\u6368\u659C\u65AF\u67F6\u67FB\u68AD\u6B7B\u6C99\u6CD7\u6E23\u7009\u7345\u7802\u793E\u7940\u7960\u79C1\u7BE9\u7D17\u7D72\u8086\u820D\u838E\u84D1\u86C7\u88DF\u8A50\u8A5E\u8B1D\u8CDC\u8D66\u8FAD\u90AA\u98FC\u99DF\u9E9D\u524A\uF969\u6714\uF96A\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5098\u522A\u5C71\u6563\u6C55\u73CA\u7523\u759D\u7B97\u849C\u9178\u9730\u4E77\u6492\u6BBA\u715E\u85A9\u4E09\uF96B\u6749\u68EE\u6E17\u829F\u8518\u886B\u63F7\u6F81\u9212\u98AF\u4E0A\u50B7\u50CF\u511F\u5546\u55AA\u5617\u5B40\u5C19\u5CE0\u5E38\u5E8A\u5EA0\u5EC2\u60F3\u6851\u6A61\u6E58\u723D\u7240\u72C0\u76F8\u7965\u7BB1\u7FD4\u88F3\u89F4\u8A73\u8C61\u8CDE\u971C\u585E\u74BD\u8CFD\u55C7\uF96C\u7A61\u7D22\u8272\u7272\u751F\u7525\uF96D\u7B19\u5885\u58FB\u5DBC\u5E8F\u5EB6\u5F90\u6055\u6292\u637F\u654D\u6691\u66D9\u66F8\u6816\u68F2\u7280\u745E\u7B6E\u7D6E\u7DD6\u7F72\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u80E5\u8212\u85AF\u897F\u8A93\u901D\u92E4\u9ECD\u9F20\u5915\u596D\u5E2D\u60DC\u6614\u6673\u6790\u6C50\u6DC5\u6F5F\u77F3\u78A9\u84C6\u91CB\u932B\u4ED9\u50CA\u5148\u5584\u5B0B\u5BA3\u6247\u657E\u65CB\u6E32\u717D\u7401\u7444\u7487\u74BF\u766C\u79AA\u7DDA\u7E55\u7FA8\u817A\u81B3\u8239\u861A\u87EC\u8A75\u8DE3\u9078\u9291\u9425\u994D\u9BAE\u5368\u5C51\u6954\u6CC4\u6D29\u6E2B\u820C\u859B\u893B\u8A2D\u8AAA\u96EA\u9F67\u5261\u66B9\u6BB2\u7E96\u87FE\u8D0D\u9583\u965D\u651D\u6D89\u71EE\uF96E\u57CE\u59D3\u5BAC\u6027\u60FA\u6210\u661F\u665F\u7329\u73F9\u76DB\u7701\u7B6C\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8056\u8072\u8165\u8AA0\u9192\u4E16\u52E2\u6B72\u6D17\u7A05\u7B39\u7D30\uF96F\u8CB0\u53EC\u562F\u5851\u5BB5\u5C0F\u5C11\u5DE2\u6240\u6383\u6414\u662D\u68B3\u6CBC\u6D88\u6EAF\u701F\u70A4\u71D2\u7526\u758F\u758E\u7619\u7B11\u7BE0\u7C2B\u7D20\u7D39\u852C\u856D\u8607\u8A34\u900D\u9061\u90B5\u92B7\u97F6\u9A37\u4FD7\u5C6C\u675F\u6D91\u7C9F\u7E8C\u8B16\u8D16\u901F\u5B6B\u5DFD\u640D\u84C0\u905C\u98E1\u7387\u5B8B\u609A\u677E\u6DDE\u8A1F\u8AA6\u9001\u980C\u5237\uF970\u7051\u788E\u9396\u8870\u91D7\u4FEE\u53D7\u55FD\u56DA\u5782\u58FD\u5AC2\u5B88\u5CAB\u5CC0\u5E25\u6101\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u620D\u624B\u6388\u641C\u6536\u6578\u6A39\u6B8A\u6C34\u6D19\u6F31\u71E7\u72E9\u7378\u7407\u74B2\u7626\u7761\u79C0\u7A57\u7AEA\u7CB9\u7D8F\u7DAC\u7E61\u7F9E\u8129\u8331\u8490\u84DA\u85EA\u8896\u8AB0\u8B90\u8F38\u9042\u9083\u916C\u9296\u92B9\u968B\u96A7\u96A8\u96D6\u9700\u9808\u9996\u9AD3\u9B1A\u53D4\u587E\u5919\u5B70\u5BBF\u6DD1\u6F5A\u719F\u7421\u74B9\u8085\u83FD\u5DE1\u5F87\u5FAA\u6042\u65EC\u6812\u696F\u6A53\u6B89\u6D35\u6DF3\u73E3\u76FE\u77AC\u7B4D\u7D14\u8123\u821C\u8340\u84F4\u8563\u8A62\u8AC4\u9187\u931E\u9806\u99B4\u620C\u8853\u8FF0\u9265\u5D07\u5D27\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5D69\u745F\u819D\u8768\u6FD5\u62FE\u7FD2\u8936\u8972\u4E1E\u4E58\u50E7\u52DD\u5347\u627F\u6607\u7E69\u8805\u965E\u4F8D\u5319\u5636\u59CB\u5AA4\u5C38\u5C4E\u5C4D\u5E02\u5F11\u6043\u65BD\u662F\u6642\u67BE\u67F4\u731C\u77E2\u793A\u7FC5\u8494\u84CD\u8996\u8A66\u8A69\u8AE1\u8C55\u8C7A\u57F4\u5BD4\u5F0F\u606F\u62ED\u690D\u6B96\u6E5C\u7184\u7BD2\u8755\u8B58\u8EFE\u98DF\u98FE\u4F38\u4F81\u4FE1\u547B\u5A20\u5BB8\u613C\u65B0\u6668\u71FC\u7533\u795E\u7D33\u814E\u81E3\u8398\u85AA\u85CE\u8703\u8A0A\u8EAB\u8F9B\uF971\u8FC5\u5931\u5BA4\u5BE6\u6089\u5BE9\u5C0B\u5FC3\u6C81\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF972\u6DF1\u700B\u751A\u82AF\u8AF6\u4EC0\u5341\uF973\u96D9\u6C0F\u4E9E\u4FC4\u5152\u555E\u5A25\u5CE8\u6211\u7259\u82BD\u83AA\u86FE\u8859\u8A1D\u963F\u96C5\u9913\u9D09\u9D5D\u580A\u5CB3\u5DBD\u5E44\u60E1\u6115\u63E1\u6A02\u6E25\u9102\u9354\u984E\u9C10\u9F77\u5B89\u5CB8\u6309\u664F\u6848\u773C\u96C1\u978D\u9854\u9B9F\u65A1\u8B01\u8ECB\u95BC\u5535\u5CA9\u5DD6\u5EB5\u6697\u764C\u83F4\u95C7\u58D3\u62BC\u72CE\u9D28\u4EF0\u592E\u600F\u663B\u6B83\u79E7\u9D26\u5393\u54C0\u57C3\u5D16\u611B\u66D6\u6DAF\u788D\u827E\u9698\u9744\u5384\u627C\u6396\u6DB2\u7E0A\u814B\u984D\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6AFB\u7F4C\u9DAF\u9E1A\u4E5F\u503B\u51B6\u591C\u60F9\u63F6\u6930\u723A\u8036\uF974\u91CE\u5F31\uF975\uF976\u7D04\u82E5\u846F\u84BB\u85E5\u8E8D\uF977\u4F6F\uF978\uF979\u58E4\u5B43\u6059\u63DA\u6518\u656D\u6698\uF97A\u694A\u6A23\u6D0B\u7001\u716C\u75D2\u760D\u79B3\u7A70\uF97B\u7F8A\uF97C\u8944\uF97D\u8B93\u91C0\u967D\uF97E\u990A\u5704\u5FA1\u65BC\u6F01\u7600\u79A6\u8A9E\u99AD\u9B5A\u9F6C\u5104\u61B6\u6291\u6A8D\u81C6\u5043\u5830\u5F66\u7109\u8A00\u8AFA\u5B7C\u8616\u4FFA\u513C\u56B4\u5944\u63A9\u6DF9\u5DAA\u696D\u5186\u4E88\u4F59\uF97F\uF980\uF981\u5982\uF982\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF983\u6B5F\u6C5D\uF984\u74B5\u7916\uF985\u8207\u8245\u8339\u8F3F\u8F5D\uF986\u9918\uF987\uF988\uF989\u4EA6\uF98A\u57DF\u5F79\u6613\uF98B\uF98C\u75AB\u7E79\u8B6F\uF98D\u9006\u9A5B\u56A5\u5827\u59F8\u5A1F\u5BB4\uF98E\u5EF6\uF98F\uF990\u6350\u633B\uF991\u693D\u6C87\u6CBF\u6D8E\u6D93\u6DF5\u6F14\uF992\u70DF\u7136\u7159\uF993\u71C3\u71D5\uF994\u784F\u786F\uF995\u7B75\u7DE3\uF996\u7E2F\uF997\u884D\u8EDF\uF998\uF999\uF99A\u925B\uF99B\u9CF6\uF99C\uF99D\uF99E\u6085\u6D85\uF99F\u71B1\uF9A0\uF9A1\u95B1\u53AD\uF9A2\uF9A3\uF9A4\u67D3\uF9A5\u708E\u7130\u7430\u8276\u82D2\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF9A6\u95BB\u9AE5\u9E7D\u66C4\uF9A7\u71C1\u8449\uF9A8\uF9A9\u584B\uF9AA\uF9AB\u5DB8\u5F71\uF9AC\u6620\u668E\u6979\u69AE\u6C38\u6CF3\u6E36\u6F41\u6FDA\u701B\u702F\u7150\u71DF\u7370\uF9AD\u745B\uF9AE\u74D4\u76C8\u7A4E\u7E93\uF9AF\uF9B0\u82F1\u8A60\u8FCE\uF9B1\u9348\uF9B2\u9719\uF9B3\uF9B4\u4E42\u502A\uF9B5\u5208\u53E1\u66F3\u6C6D\u6FCA\u730A\u777F\u7A62\u82AE\u85DD\u8602\uF9B6\u88D4\u8A63\u8B7D\u8C6B\uF9B7\u92B3\uF9B8\u9713\u9810\u4E94\u4F0D\u4FC9\u50B2\u5348\u543E\u5433\u55DA\u5862\u58BA\u5967\u5A1B\u5BE4\u609F\uF9B9\u61CA\u6556\u65FF\u6664\u68A7\u6C5A\u6FB3\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u70CF\u71AC\u7352\u7B7D\u8708\u8AA4\u9C32\u9F07\u5C4B\u6C83\u7344\u7389\u923A\u6EAB\u7465\u761F\u7A69\u7E15\u860A\u5140\u58C5\u64C1\u74EE\u7515\u7670\u7FC1\u9095\u96CD\u9954\u6E26\u74E6\u7AA9\u7AAA\u81E5\u86D9\u8778\u8A1B\u5A49\u5B8C\u5B9B\u68A1\u6900\u6D63\u73A9\u7413\u742C\u7897\u7DE9\u7FEB\u8118\u8155\u839E\u8C4C\u962E\u9811\u66F0\u5F80\u65FA\u6789\u6C6A\u738B\u502D\u5A03\u6B6A\u77EE\u5916\u5D6C\u5DCD\u7325\u754F\uF9BA\uF9BB\u50E5\u51F9\u582F\u592D\u5996\u59DA\u5BE5\uF9BC\uF9BD\u5DA2\u62D7\u6416\u6493\u64FE\uF9BE\u66DC\uF9BF\u6A48\uF9C0\u71FF\u7464\uF9C1\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A88\u7AAF\u7E47\u7E5E\u8000\u8170\uF9C2\u87EF\u8981\u8B20\u9059\uF9C3\u9080\u9952\u617E\u6B32\u6D74\u7E1F\u8925\u8FB1\u4FD1\u50AD\u5197\u52C7\u57C7\u5889\u5BB9\u5EB8\u6142\u6995\u6D8C\u6E67\u6EB6\u7194\u7462\u7528\u752C\u8073\u8338\u84C9\u8E0A\u9394\u93DE\uF9C4\u4E8E\u4F51\u5076\u512A\u53C8\u53CB\u53F3\u5B87\u5BD3\u5C24\u611A\u6182\u65F4\u725B\u7397\u7440\u76C2\u7950\u7991\u79B9\u7D06\u7FBD\u828B\u85D5\u865E\u8FC2\u9047\u90F5\u91EA\u9685\u96E8\u96E9\u52D6\u5F67\u65ED\u6631\u682F\u715C\u7A36\u90C1\u980A\u4E91\uF9C5\u6A52\u6B9E\u6F90\u7189\u8018\u82B8\u8553\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u904B\u9695\u96F2\u97FB\u851A\u9B31\u4E90\u718A\u96C4\u5143\u539F\u54E1\u5713\u5712\u57A3\u5A9B\u5AC4\u5BC3\u6028\u613F\u63F4\u6C85\u6D39\u6E72\u6E90\u7230\u733F\u7457\u82D1\u8881\u8F45\u9060\uF9C6\u9662\u9858\u9D1B\u6708\u8D8A\u925E\u4F4D\u5049\u50DE\u5371\u570D\u59D4\u5A01\u5C09\u6170\u6690\u6E2D\u7232\u744B\u7DEF\u80C3\u840E\u8466\u853F\u875F\u885B\u8918\u8B02\u9055\u97CB\u9B4F\u4E73\u4F91\u5112\u516A\uF9C7\u552F\u55A9\u5B7A\u5BA5\u5E7C\u5E7D\u5EBE\u60A0\u60DF\u6108\u6109\u63C4\u6538\u6709\uF9C8\u67D4\u67DA\uF9C9\u6961\u6962\u6CB9\u6D27\uF9CA\u6E38\uF9CB\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FE1\u7336\u7337\uF9CC\u745C\u7531\uF9CD\u7652\uF9CE\uF9CF\u7DAD\u81FE\u8438\u88D5\u8A98\u8ADB\u8AED\u8E30\u8E42\u904A\u903E\u907A\u9149\u91C9\u936E\uF9D0\uF9D1\u5809\uF9D2\u6BD3\u8089\u80B2\uF9D3\uF9D4\u5141\u596B\u5C39\uF9D5\uF9D6\u6F64\u73A7\u80E4\u8D07\uF9D7\u9217\u958F\uF9D8\uF9D9\uF9DA\uF9DB\u807F\u620E\u701C\u7D68\u878D\uF9DC\u57A0\u6069\u6147\u6BB7\u8ABE\u9280\u96B1\u4E59\u541F\u6DEB\u852D\u9670\u97F3\u98EE\u63D6\u6CE3\u9091\u51DD\u61C9\u81BA\u9DF9\u4F9D\u501A\u5100\u5B9C\u610F\u61FF\u64EC\u6905\u6BC5\u7591\u77E3\u7FA9\u8264\u858F\u87FB\u8863\u8ABC\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B70\u91AB\u4E8C\u4EE5\u4F0A\uF9DD\uF9DE\u5937\u59E8\uF9DF\u5DF2\u5F1B\u5F5B\u6021\uF9E0\uF9E1\uF9E2\uF9E3\u723E\u73E5\uF9E4\u7570\u75CD\uF9E5\u79FB\uF9E6\u800C\u8033\u8084\u82E1\u8351\uF9E7\uF9E8\u8CBD\u8CB3\u9087\uF9E9\uF9EA\u98F4\u990C\uF9EB\uF9EC\u7037\u76CA\u7FCA\u7FCC\u7FFC\u8B1A\u4EBA\u4EC1\u5203\u5370\uF9ED\u54BD\u56E0\u59FB\u5BC5\u5F15\u5FCD\u6E6E\uF9EE\uF9EF\u7D6A\u8335\uF9F0\u8693\u8A8D\uF9F1\u976D\u9777\uF9F2\uF9F3\u4E00\u4F5A\u4F7E\u58F9\u65E5\u6EA2\u9038\u93B0\u99B9\u4EFB\u58EC\u598A\u59D9\u6041\uF9F4\uF9F5\u7A14\uF9F6\u834F\u8CC3\u5165\u5344\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF9F7\uF9F8\uF9F9\u4ECD\u5269\u5B55\u82BF\u4ED4\u523A\u54A8\u59C9\u59FF\u5B50\u5B57\u5B5C\u6063\u6148\u6ECB\u7099\u716E\u7386\u74F7\u75B5\u78C1\u7D2B\u8005\u81EA\u8328\u8517\u85C9\u8AEE\u8CC7\u96CC\u4F5C\u52FA\u56BC\u65AB\u6628\u707C\u70B8\u7235\u7DBD\u828D\u914C\u96C0\u9D72\u5B71\u68E7\u6B98\u6F7A\u76DE\u5C91\u66AB\u6F5B\u7BB4\u7C2A\u8836\u96DC\u4E08\u4ED7\u5320\u5834\u58BB\u58EF\u596C\u5C07\u5E33\u5E84\u5F35\u638C\u66B2\u6756\u6A1F\u6AA3\u6B0C\u6F3F\u7246\uF9FA\u7350\u748B\u7AE0\u7CA7\u8178\u81DF\u81E7\u838A\u846C\u8523\u8594\u85CF\u88DD\u8D13\u91AC\u9577\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u969C\u518D\u54C9\u5728\u5BB0\u624D\u6750\u683D\u6893\u6E3D\u6ED3\u707D\u7E21\u88C1\u8CA1\u8F09\u9F4B\u9F4E\u722D\u7B8F\u8ACD\u931A\u4F47\u4F4E\u5132\u5480\u59D0\u5E95\u62B5\u6775\u696E\u6A17\u6CAE\u6E1A\u72D9\u732A\u75BD\u7BB8\u7D35\u82E7\u83F9\u8457\u85F7\u8A5B\u8CAF\u8E87\u9019\u90B8\u96CE\u9F5F\u52E3\u540A\u5AE1\u5BC2\u6458\u6575\u6EF4\u72C4\uF9FB\u7684\u7A4D\u7B1B\u7C4D\u7E3E\u7FDF\u837B\u8B2B\u8CCA\u8D64\u8DE1\u8E5F\u8FEA\u8FF9\u9069\u93D1\u4F43\u4F7A\u50B3\u5168\u5178\u524D\u526A\u5861\u587C\u5960\u5C08\u5C55\u5EDB\u609B\u6230\u6813\u6BBF\u6C08\u6FB1\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u714E\u7420\u7530\u7538\u7551\u7672\u7B4C\u7B8B\u7BAD\u7BC6\u7E8F\u8A6E\u8F3E\u8F49\u923F\u9293\u9322\u942B\u96FB\u985A\u986B\u991E\u5207\u622A\u6298\u6D59\u7664\u7ACA\u7BC0\u7D76\u5360\u5CBE\u5E97\u6F38\u70B9\u7C98\u9711\u9B8E\u9EDE\u63A5\u647A\u8776\u4E01\u4E95\u4EAD\u505C\u5075\u5448\u59C3\u5B9A\u5E40\u5EAD\u5EF7\u5F81\u60C5\u633A\u653F\u6574\u65CC\u6676\u6678\u67FE\u6968\u6A89\u6B63\u6C40\u6DC0\u6DE8\u6E1F\u6E5E\u701E\u70A1\u738E\u73FD\u753A\u775B\u7887\u798E\u7A0B\u7A7D\u7CBE\u7D8E\u8247\u8A02\u8AEA\u8C9E\u912D\u914A\u91D8\u9266\u92CC\u9320\u9706\u9756\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u975C\u9802\u9F0E\u5236\u5291\u557C\u5824\u5E1D\u5F1F\u608C\u63D0\u68AF\u6FDF\u796D\u7B2C\u81CD\u85BA\u88FD\u8AF8\u8E44\u918D\u9664\u969B\u973D\u984C\u9F4A\u4FCE\u5146\u51CB\u52A9\u5632\u5F14\u5F6B\u63AA\u64CD\u65E9\u6641\u66FA\u66F9\u671D\u689D\u68D7\u69FD\u6F15\u6F6E\u7167\u71E5\u722A\u74AA\u773A\u7956\u795A\u79DF\u7A20\u7A95\u7C97\u7CDF\u7D44\u7E70\u8087\u85FB\u86A4\u8A54\u8ABF\u8D99\u8E81\u9020\u906D\u91E3\u963B\u96D5\u9CE5\u65CF\u7C07\u8DB3\u93C3\u5B58\u5C0A\u5352\u62D9\u731D\u5027\u5B97\u5F9E\u60B0\u616B\u68D5\u6DD9\u742E\u7A2E\u7D42\u7D9C\u7E31\u816B\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E2A\u8E35\u937E\u9418\u4F50\u5750\u5DE6\u5EA7\u632B\u7F6A\u4E3B\u4F4F\u4F8F\u505A\u59DD\u80C4\u546A\u5468\u55FE\u594F\u5B99\u5DDE\u5EDA\u665D\u6731\u67F1\u682A\u6CE8\u6D32\u6E4A\u6F8D\u70B7\u73E0\u7587\u7C4C\u7D02\u7D2C\u7DA2\u821F\u86DB\u8A3B\u8A85\u8D70\u8E8A\u8F33\u9031\u914E\u9152\u9444\u99D0\u7AF9\u7CA5\u4FCA\u5101\u51C6\u57C8\u5BEF\u5CFB\u6659\u6A3D\u6D5A\u6E96\u6FEC\u710C\u756F\u7AE3\u8822\u9021\u9075\u96CB\u99FF\u8301\u4E2D\u4EF2\u8846\u91CD\u537D\u6ADB\u696B\u6C41\u847A\u589E\u618E\u66FE\u62EF\u70DD\u7511\u75C7\u7E52\u84B8\u8B49\u8D08\u4E4B\u53EA\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54AB\u5730\u5740\u5FD7\u6301\u6307\u646F\u652F\u65E8\u667A\u679D\u67B3\u6B62\u6C60\u6C9A\u6F2C\u77E5\u7825\u7949\u7957\u7D19\u80A2\u8102\u81F3\u829D\u82B7\u8718\u8A8C\uF9FC\u8D04\u8DBE\u9072\u76F4\u7A19\u7A37\u7E54\u8077\u5507\u55D4\u5875\u632F\u6422\u6649\u664B\u686D\u699B\u6B84\u6D25\u6EB1\u73CD\u7468\u74A1\u755B\u75B9\u76E1\u771E\u778B\u79E6\u7E09\u7E1D\u81FB\u852F\u8897\u8A3A\u8CD1\u8EEB\u8FB0\u9032\u93AD\u9663\u9673\u9707\u4F84\u53F1\u59EA\u5AC9\u5E19\u684E\u74C6\u75BE\u79E9\u7A92\u81A3\u86ED\u8CEA\u8DCC\u8FED\u659F\u6715\uF9FD\u57F7\u6F57\u7DDD\u8F2F\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u93F6\u96C6\u5FB5\u61F2\u6F84\u4E14\u4F98\u501F\u53C9\u55DF\u5D6F\u5DEE\u6B21\u6B64\u78CB\u7B9A\uF9FE\u8E49\u8ECA\u906E\u6349\u643E\u7740\u7A84\u932F\u947F\u9F6A\u64B0\u6FAF\u71E6\u74A8\u74DA\u7AC4\u7C12\u7E82\u7CB2\u7E98\u8B9A\u8D0A\u947D\u9910\u994C\u5239\u5BDF\u64E6\u672D\u7D2E\u50ED\u53C3\u5879\u6158\u6159\u61FA\u65AC\u7AD9\u8B92\u8B96\u5009\u5021\u5275\u5531\u5A3C\u5EE0\u5F70\u6134\u655E\u660C\u6636\u66A2\u69CD\u6EC4\u6F32\u7316\u7621\u7A93\u8139\u8259\u83D6\u84BC\u50B5\u57F0\u5BC0\u5BE8\u5F69\u63A1\u7826\u7DB5\u83DC\u8521\u91C7\u91F5\u518A\u67F5\u7B56\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8CAC\u51C4\u59BB\u60BD\u8655\u501C\uF9FF\u5254\u5C3A\u617D\u621A\u62D3\u64F2\u65A5\u6ECC\u7620\u810A\u8E60\u965F\u96BB\u4EDF\u5343\u5598\u5929\u5DDD\u64C5\u6CC9\u6DFA\u7394\u7A7F\u821B\u85A6\u8CE4\u8E10\u9077\u91E7\u95E1\u9621\u97C6\u51F8\u54F2\u5586\u5FB9\u64A4\u6F88\u7DB4\u8F1F\u8F4D\u9435\u50C9\u5C16\u6CBE\u6DFB\u751B\u77BB\u7C3D\u7C64\u8A79\u8AC2\u581E\u59BE\u5E16\u6377\u7252\u758A\u776B\u8ADC\u8CBC\u8F12\u5EF3\u6674\u6DF8\u807D\u83C1\u8ACB\u9751\u9BD6\uFA00\u5243\u66FF\u6D95\u6EEF\u7DE0\u8AE6\u902E\u905E\u9AD4\u521D\u527F\u54E8\u6194\u6284\u62DB\u68A2\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6912\u695A\u6A35\u7092\u7126\u785D\u7901\u790E\u79D2\u7A0D\u8096\u8278\u82D5\u8349\u8549\u8C82\u8D85\u9162\u918B\u91AE\u4FC3\u56D1\u71ED\u77D7\u8700\u89F8\u5BF8\u5FD6\u6751\u90A8\u53E2\u585A\u5BF5\u60A4\u6181\u6460\u7E3D\u8070\u8525\u9283\u64AE\u50AC\u5D14\u6700\u589C\u62BD\u63A8\u690E\u6978\u6A1E\u6E6B\u76BA\u79CB\u82BB\u8429\u8ACF\u8DA8\u8FFD\u9112\u914B\u919C\u9310\u9318\u939A\u96DB\u9A36\u9C0D\u4E11\u755C\u795D\u7AFA\u7B51\u7BC9\u7E2E\u84C4\u8E59\u8E74\u8EF8\u9010\u6625\u693F\u7443\u51FA\u672E\u9EDC\u5145\u5FE0\u6C96\u87F2\u885D\u8877\u60B4\u81B5\u8403\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8D05\u53D6\u5439\u5634\u5A36\u5C31\u708A\u7FE0\u805A\u8106\u81ED\u8DA3\u9189\u9A5F\u9DF2\u5074\u4EC4\u53A0\u60FB\u6E2C\u5C64\u4F88\u5024\u55E4\u5CD9\u5E5F\u6065\u6894\u6CBB\u6DC4\u71BE\u75D4\u75F4\u7661\u7A1A\u7A49\u7DC7\u7DFB\u7F6E\u81F4\u86A9\u8F1C\u96C9\u99B3\u9F52\u5247\u52C5\u98ED\u89AA\u4E03\u67D2\u6F06\u4FB5\u5BE2\u6795\u6C88\u6D78\u741B\u7827\u91DD\u937C\u87C4\u79E4\u7A31\u5FEB\u4ED6\u54A4\u553E\u58AE\u59A5\u60F0\u6253\u62D6\u6736\u6955\u8235\u9640\u99B1\u99DD\u502C\u5353\u5544\u577C\uFA01\u6258\uFA02\u64E2\u666B\u67DD\u6FC1\u6FEF\u7422\u7438\u8A17\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9438\u5451\u5606\u5766\u5F48\u619A\u6B4E\u7058\u70AD\u7DBB\u8A95\u596A\u812B\u63A2\u7708\u803D\u8CAA\u5854\u642D\u69BB\u5B95\u5E11\u6E6F\uFA03\u8569\u514C\u53F0\u592A\u6020\u614B\u6B86\u6C70\u6CF0\u7B1E\u80CE\u82D4\u8DC6\u90B0\u98B1\uFA04\u64C7\u6FA4\u6491\u6504\u514E\u5410\u571F\u8A0E\u615F\u6876\uFA05\u75DB\u7B52\u7D71\u901A\u5806\u69CC\u817F\u892A\u9000\u9839\u5078\u5957\u59AC\u6295\u900F\u9B2A\u615D\u7279\u95D6\u5761\u5A46\u5DF4\u628A\u64AD\u64FA\u6777\u6CE2\u6D3E\u722C\u7436\u7834\u7F77\u82AD\u8DDB\u9817\u5224\u5742\u677F\u7248\u74E3\u8CA9\u8FA6\u9211\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    D[248] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u962A\u516B\u53ED\u634C\u4F69\u5504\u6096\u6557\u6C9B\u6D7F\u724C\u72FD\u7A17\u8987\u8C9D\u5F6D\u6F8E\u70F9\u81A8\u610E\u4FBF\u504F\u6241\u7247\u7BC7\u7DE8\u7FE9\u904D\u97AD\u9A19\u8CB6\u576A\u5E73\u67B0\u840D\u8A55\u5420\u5B16\u5E63\u5EE2\u5F0A\u6583\u80BA\u853D\u9589\u965B\u4F48\u5305\u530D\u530F\u5486\u54FA\u5703\u5E03\u6016\u629B\u62B1\u6355\uFA06\u6CE1\u6D66\u75B1\u7832\u80DE\u812F\u82DE\u8461\u84B2\u888D\u8912\u900B\u92EA\u98FD\u9B91\u5E45\u66B4\u66DD\u7011\u7206\uFA07\u4FF5\u527D\u5F6A\u6153\u6753\u6A19\u6F02\u74E2\u7968\u8868\u8C79\u98C7\u98C4\u9A43\uFFFD".split("");
    for(j = 0; j != D[248].length; ++j)if (D[248][j].charCodeAt(0) !== 0xFFFD) {
        e[D[248][j]] = 63488 + j;
        d[63488 + j] = D[248][j];
    }
    D[249] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54C1\u7A1F\u6953\u8AF7\u8C4A\u98A8\u99AE\u5F7C\u62AB\u75B2\u76AE\u88AB\u907F\u9642\u5339\u5F3C\u5FC5\u6CCC\u73CC\u7562\u758B\u7B46\u82FE\u999D\u4E4F\u903C\u4E0B\u4F55\u53A6\u590F\u5EC8\u6630\u6CB3\u7455\u8377\u8766\u8CC0\u9050\u971E\u9C15\u58D1\u5B78\u8650\u8B14\u9DB4\u5BD2\u6068\u608D\u65F1\u6C57\u6F22\u6FA3\u701A\u7F55\u7FF0\u9591\u9592\u9650\u97D3\u5272\u8F44\u51FD\u542B\u54B8\u5563\u558A\u6ABB\u6DB5\u7DD8\u8266\u929C\u9677\u9E79\u5408\u54C8\u76D2\u86E4\u95A4\u95D4\u965C\u4EA2\u4F09\u59EE\u5AE6\u5DF7\u6052\u6297\u676D\u6841\u6C86\u6E2F\u7F38\u809B\u822A\uFFFD".split("");
    for(j = 0; j != D[249].length; ++j)if (D[249][j].charCodeAt(0) !== 0xFFFD) {
        e[D[249][j]] = 63744 + j;
        d[63744 + j] = D[249][j];
    }
    D[250] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFA08\uFA09\u9805\u4EA5\u5055\u54B3\u5793\u595A\u5B69\u5BB3\u61C8\u6977\u6D77\u7023\u87F9\u89E3\u8A72\u8AE7\u9082\u99ED\u9AB8\u52BE\u6838\u5016\u5E78\u674F\u8347\u884C\u4EAB\u5411\u56AE\u73E6\u9115\u97FF\u9909\u9957\u9999\u5653\u589F\u865B\u8A31\u61B2\u6AF6\u737B\u8ED2\u6B47\u96AA\u9A57\u5955\u7200\u8D6B\u9769\u4FD4\u5CF4\u5F26\u61F8\u665B\u6CEB\u70AB\u7384\u73B9\u73FE\u7729\u774D\u7D43\u7D62\u7E23\u8237\u8852\uFA0A\u8CE2\u9249\u986F\u5B51\u7A74\u8840\u9801\u5ACC\u4FE0\u5354\u593E\u5CFD\u633E\u6D79\u72F9\u8105\u8107\u83A2\u92CF\u9830\u4EA8\u5144\u5211\u578B\uFFFD".split("");
    for(j = 0; j != D[250].length; ++j)if (D[250][j].charCodeAt(0) !== 0xFFFD) {
        e[D[250][j]] = 64000 + j;
        d[64000 + j] = D[250][j];
    }
    D[251] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F62\u6CC2\u6ECE\u7005\u7050\u70AF\u7192\u73E9\u7469\u834A\u87A2\u8861\u9008\u90A2\u93A3\u99A8\u516E\u5F57\u60E0\u6167\u66B3\u8559\u8E4A\u91AF\u978B\u4E4E\u4E92\u547C\u58D5\u58FA\u597D\u5CB5\u5F27\u6236\u6248\u660A\u6667\u6BEB\u6D69\u6DCF\u6E56\u6EF8\u6F94\u6FE0\u6FE9\u705D\u72D0\u7425\u745A\u74E0\u7693\u795C\u7CCA\u7E1E\u80E1\u82A6\u846B\u84BF\u864E\u865F\u8774\u8B77\u8C6A\u93AC\u9800\u9865\u60D1\u6216\u9177\u5A5A\u660F\u6DF7\u6E3E\u743F\u9B42\u5FFD\u60DA\u7B0F\u54C4\u5F18\u6C5E\u6CD3\u6D2A\u70D8\u7D05\u8679\u8A0C\u9D3B\u5316\u548C\u5B05\u6A3A\u706B\u7575\uFFFD".split("");
    for(j = 0; j != D[251].length; ++j)if (D[251][j].charCodeAt(0) !== 0xFFFD) {
        e[D[251][j]] = 64256 + j;
        d[64256 + j] = D[251][j];
    }
    D[252] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u798D\u79BE\u82B1\u83EF\u8A71\u8B41\u8CA8\u9774\uFA0B\u64F4\u652B\u78BA\u78BB\u7A6B\u4E38\u559A\u5950\u5BA6\u5E7B\u60A3\u63DB\u6B61\u6665\u6853\u6E19\u7165\u74B0\u7D08\u9084\u9A69\u9C25\u6D3B\u6ED1\u733E\u8C41\u95CA\u51F0\u5E4C\u5FA8\u604D\u60F6\u6130\u614C\u6643\u6644\u69A5\u6CC1\u6E5F\u6EC9\u6F62\u714C\u749C\u7687\u7BC1\u7C27\u8352\u8757\u9051\u968D\u9EC3\u532F\u56DE\u5EFB\u5F8A\u6062\u6094\u61F7\u6666\u6703\u6A9C\u6DEE\u6FAE\u7070\u736A\u7E6A\u81BE\u8334\u86D4\u8AA8\u8CC4\u5283\u7372\u5B96\u6A6B\u9404\u54EE\u5686\u5B5D\u6548\u6585\u66C9\u689F\u6D8D\u6DC6\uFFFD".split("");
    for(j = 0; j != D[252].length; ++j)if (D[252][j].charCodeAt(0) !== 0xFFFD) {
        e[D[252][j]] = 64512 + j;
        d[64512 + j] = D[252][j];
    }
    D[253] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u723B\u80B4\u9175\u9A4D\u4FAF\u5019\u539A\u540E\u543C\u5589\u55C5\u5E3F\u5F8C\u673D\u7166\u73DD\u9005\u52DB\u52F3\u5864\u58CE\u7104\u718F\u71FB\u85B0\u8A13\u6688\u85A8\u55A7\u6684\u714A\u8431\u5349\u5599\u6BC1\u5F59\u5FBD\u63EE\u6689\u7147\u8AF1\u8F1D\u9EBE\u4F11\u643A\u70CB\u7566\u8667\u6064\u8B4E\u9DF8\u5147\u51F6\u5308\u6D36\u80F8\u9ED1\u6615\u6B23\u7098\u75D5\u5403\u5C79\u7D07\u8A16\u6B20\u6B3D\u6B46\u5438\u6070\u6D3D\u7FD5\u8208\u50D6\u51DE\u559C\u566B\u56CD\u59EC\u5B09\u5E0C\u6199\u6198\u6231\u665E\u66E6\u7199\u71B9\u71BA\u72A7\u79A7\u7A00\u7FB2\u8A70\uFFFD".split("");
    for(j = 0; j != D[253].length; ++j)if (D[253][j].charCodeAt(0) !== 0xFFFD) {
        e[D[253][j]] = 64768 + j;
        d[64768 + j] = D[253][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
cptable[950] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\uFF0C\u3001\u3002\uFF0E\u2027\uFF1B\uFF1A\uFF1F\uFF01\uFE30\u2026\u2025\uFE50\uFE51\uFE52\xb7\uFE54\uFE55\uFE56\uFE57\uFF5C\u2013\uFE31\u2014\uFE33\u2574\uFE34\uFE4F\uFF08\uFF09\uFE35\uFE36\uFF5B\uFF5D\uFE37\uFE38\u3014\u3015\uFE39\uFE3A\u3010\u3011\uFE3B\uFE3C\u300A\u300B\uFE3D\uFE3E\u3008\u3009\uFE3F\uFE40\u300C\u300D\uFE41\uFE42\u300E\u300F\uFE43\uFE44\uFE59\uFE5A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFE5B\uFE5C\uFE5D\uFE5E\u2018\u2019\u201C\u201D\u301D\u301E\u2035\u2032\uFF03\uFF06\uFF0A\u203B\xa7\u3003\u25CB\u25CF\u25B3\u25B2\u25CE\u2606\u2605\u25C7\u25C6\u25A1\u25A0\u25BD\u25BC\u32A3\u2105\xaf\uFFE3\uFF3F\u02CD\uFE49\uFE4A\uFE4D\uFE4E\uFE4B\uFE4C\uFE5F\uFE60\uFE61\uFF0B\uFF0D\xd7\xf7\xb1\u221A\uFF1C\uFF1E\uFF1D\u2266\u2267\u2260\u221E\u2252\u2261\uFE62\uFE63\uFE64\uFE65\uFE66\uFF5E\u2229\u222A\u22A5\u2220\u221F\u22BF\u33D2\u33D1\u222B\u222E\u2235\u2234\u2640\u2642\u2295\u2299\u2191\u2193\u2190\u2192\u2196\u2197\u2199\u2198\u2225\u2223\uFF0F\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF3C\u2215\uFE68\uFF04\uFFE5\u3012\uFFE0\uFFE1\uFF05\uFF20\u2103\u2109\uFE69\uFE6A\uFE6B\u33D5\u339C\u339D\u339E\u33CE\u33A1\u338E\u338F\u33C4\xb0\u5159\u515B\u515E\u515D\u5161\u5163\u55E7\u74E9\u7CCE\u2581\u2582\u2583\u2584\u2585\u2586\u2587\u2588\u258F\u258E\u258D\u258C\u258B\u258A\u2589\u253C\u2534\u252C\u2524\u251C\u2594\u2500\u2502\u2595\u250C\u2510\u2514\u2518\u256D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u256E\u2570\u256F\u2550\u255E\u256A\u2561\u25E2\u25E3\u25E5\u25E4\u2571\u2572\u2573\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\u3021\u3022\u3023\u3024\u3025\u3026\u3027\u3028\u3029\u5341\u5344\u5345\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF57\uFF58\uFF59\uFF5A\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u3105\u3106\u3107\u3108\u3109\u310A\u310B\u310C\u310D\u310E\u310F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3110\u3111\u3112\u3113\u3114\u3115\u3116\u3117\u3118\u3119\u311A\u311B\u311C\u311D\u311E\u311F\u3120\u3121\u3122\u3123\u3124\u3125\u3126\u3127\u3128\u3129\u02D9\u02C9\u02CA\u02C7\u02CB\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E00\u4E59\u4E01\u4E03\u4E43\u4E5D\u4E86\u4E8C\u4EBA\u513F\u5165\u516B\u51E0\u5200\u5201\u529B\u5315\u5341\u535C\u53C8\u4E09\u4E0B\u4E08\u4E0A\u4E2B\u4E38\u51E1\u4E45\u4E48\u4E5F\u4E5E\u4E8E\u4EA1\u5140\u5203\u52FA\u5343\u53C9\u53E3\u571F\u58EB\u5915\u5927\u5973\u5B50\u5B51\u5B53\u5BF8\u5C0F\u5C22\u5C38\u5C71\u5DDD\u5DE5\u5DF1\u5DF2\u5DF3\u5DFE\u5E72\u5EFE\u5F0B\u5F13\u624D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E11\u4E10\u4E0D\u4E2D\u4E30\u4E39\u4E4B\u5C39\u4E88\u4E91\u4E95\u4E92\u4E94\u4EA2\u4EC1\u4EC0\u4EC3\u4EC6\u4EC7\u4ECD\u4ECA\u4ECB\u4EC4\u5143\u5141\u5167\u516D\u516E\u516C\u5197\u51F6\u5206\u5207\u5208\u52FB\u52FE\u52FF\u5316\u5339\u5348\u5347\u5345\u535E\u5384\u53CB\u53CA\u53CD\u58EC\u5929\u592B\u592A\u592D\u5B54\u5C11\u5C24\u5C3A\u5C6F\u5DF4\u5E7B\u5EFF\u5F14\u5F15\u5FC3\u6208\u6236\u624B\u624E\u652F\u6587\u6597\u65A4\u65B9\u65E5\u66F0\u6708\u6728\u6B20\u6B62\u6B79\u6BCB\u6BD4\u6BDB\u6C0F\u6C34\u706B\u722A\u7236\u723B\u7247\u7259\u725B\u72AC\u738B\u4E19\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E16\u4E15\u4E14\u4E18\u4E3B\u4E4D\u4E4F\u4E4E\u4EE5\u4ED8\u4ED4\u4ED5\u4ED6\u4ED7\u4EE3\u4EE4\u4ED9\u4EDE\u5145\u5144\u5189\u518A\u51AC\u51F9\u51FA\u51F8\u520A\u52A0\u529F\u5305\u5306\u5317\u531D\u4EDF\u534A\u5349\u5361\u5360\u536F\u536E\u53BB\u53EF\u53E4\u53F3\u53EC\u53EE\u53E9\u53E8\u53FC\u53F8\u53F5\u53EB\u53E6\u53EA\u53F2\u53F1\u53F0\u53E5\u53ED\u53FB\u56DB\u56DA\u5916\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u592E\u5931\u5974\u5976\u5B55\u5B83\u5C3C\u5DE8\u5DE7\u5DE6\u5E02\u5E03\u5E73\u5E7C\u5F01\u5F18\u5F17\u5FC5\u620A\u6253\u6254\u6252\u6251\u65A5\u65E6\u672E\u672C\u672A\u672B\u672D\u6B63\u6BCD\u6C11\u6C10\u6C38\u6C41\u6C40\u6C3E\u72AF\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7529\u7530\u7531\u7532\u7533\u758B\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79BE\u7A74\u7ACB\u4E1E\u4E1F\u4E52\u4E53\u4E69\u4E99\u4EA4\u4EA6\u4EA5\u4EFF\u4F09\u4F19\u4F0A\u4F15\u4F0D\u4F10\u4F11\u4F0F\u4EF2\u4EF6\u4EFB\u4EF0\u4EF3\u4EFD\u4F01\u4F0B\u5149\u5147\u5146\u5148\u5168\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5171\u518D\u51B0\u5217\u5211\u5212\u520E\u5216\u52A3\u5308\u5321\u5320\u5370\u5371\u5409\u540F\u540C\u540A\u5410\u5401\u540B\u5404\u5411\u540D\u5408\u5403\u540E\u5406\u5412\u56E0\u56DE\u56DD\u5733\u5730\u5728\u572D\u572C\u572F\u5729\u5919\u591A\u5937\u5938\u5984\u5978\u5983\u597D\u5979\u5982\u5981\u5B57\u5B58\u5B87\u5B88\u5B85\u5B89\u5BFA\u5C16\u5C79\u5DDE\u5E06\u5E76\u5E74\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F0F\u5F1B\u5FD9\u5FD6\u620E\u620C\u620D\u6210\u6263\u625B\u6258\u6536\u65E9\u65E8\u65EC\u65ED\u66F2\u66F3\u6709\u673D\u6734\u6731\u6735\u6B21\u6B64\u6B7B\u6C16\u6C5D\u6C57\u6C59\u6C5F\u6C60\u6C50\u6C55\u6C61\u6C5B\u6C4D\u6C4E\u7070\u725F\u725D\u767E\u7AF9\u7C73\u7CF8\u7F36\u7F8A\u7FBD\u8001\u8003\u800C\u8012\u8033\u807F\u8089\u808B\u808C\u81E3\u81EA\u81F3\u81FC\u820C\u821B\u821F\u826E\u8272\u827E\u866B\u8840\u884C\u8863\u897F\u9621\u4E32\u4EA8\u4F4D\u4F4F\u4F47\u4F57\u4F5E\u4F34\u4F5B\u4F55\u4F30\u4F50\u4F51\u4F3D\u4F3A\u4F38\u4F43\u4F54\u4F3C\u4F46\u4F63\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F5C\u4F60\u4F2F\u4F4E\u4F36\u4F59\u4F5D\u4F48\u4F5A\u514C\u514B\u514D\u5175\u51B6\u51B7\u5225\u5224\u5229\u522A\u5228\u52AB\u52A9\u52AA\u52AC\u5323\u5373\u5375\u541D\u542D\u541E\u543E\u5426\u544E\u5427\u5446\u5443\u5433\u5448\u5442\u541B\u5429\u544A\u5439\u543B\u5438\u542E\u5435\u5436\u5420\u543C\u5440\u5431\u542B\u541F\u542C\u56EA\u56F0\u56E4\u56EB\u574A\u5751\u5740\u574D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5747\u574E\u573E\u5750\u574F\u573B\u58EF\u593E\u599D\u5992\u59A8\u599E\u59A3\u5999\u5996\u598D\u59A4\u5993\u598A\u59A5\u5B5D\u5B5C\u5B5A\u5B5B\u5B8C\u5B8B\u5B8F\u5C2C\u5C40\u5C41\u5C3F\u5C3E\u5C90\u5C91\u5C94\u5C8C\u5DEB\u5E0C\u5E8F\u5E87\u5E8A\u5EF7\u5F04\u5F1F\u5F64\u5F62\u5F77\u5F79\u5FD8\u5FCC\u5FD7\u5FCD\u5FF1\u5FEB\u5FF8\u5FEA\u6212\u6211\u6284\u6297\u6296\u6280\u6276\u6289\u626D\u628A\u627C\u627E\u6279\u6273\u6292\u626F\u6298\u626E\u6295\u6293\u6291\u6286\u6539\u653B\u6538\u65F1\u66F4\u675F\u674E\u674F\u6750\u6751\u675C\u6756\u675E\u6749\u6746\u6760\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6753\u6757\u6B65\u6BCF\u6C42\u6C5E\u6C99\u6C81\u6C88\u6C89\u6C85\u6C9B\u6C6A\u6C7A\u6C90\u6C70\u6C8C\u6C68\u6C96\u6C92\u6C7D\u6C83\u6C72\u6C7E\u6C74\u6C86\u6C76\u6C8D\u6C94\u6C98\u6C82\u7076\u707C\u707D\u7078\u7262\u7261\u7260\u72C4\u72C2\u7396\u752C\u752B\u7537\u7538\u7682\u76EF\u77E3\u79C1\u79C0\u79BF\u7A76\u7CFB\u7F55\u8096\u8093\u809D\u8098\u809B\u809A\u80B2\u826F\u8292\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u828B\u828D\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FC2\u8FC6\u8FC5\u8FC4\u5DE1\u9091\u90A2\u90AA\u90A6\u90A3\u9149\u91C6\u91CC\u9632\u962E\u9631\u962A\u962C\u4E26\u4E56\u4E73\u4E8B\u4E9B\u4E9E\u4EAB\u4EAC\u4F6F\u4F9D\u4F8D\u4F73\u4F7F\u4F6C\u4F9B\u4F8B\u4F86\u4F83\u4F70\u4F75\u4F88\u4F69\u4F7B\u4F96\u4F7E\u4F8F\u4F91\u4F7A\u5154\u5152\u5155\u5169\u5177\u5176\u5178\u51BD\u51FD\u523B\u5238\u5237\u523A\u5230\u522E\u5236\u5241\u52BE\u52BB\u5352\u5354\u5353\u5351\u5366\u5377\u5378\u5379\u53D6\u53D4\u53D7\u5473\u5475\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5496\u5478\u5495\u5480\u547B\u5477\u5484\u5492\u5486\u547C\u5490\u5471\u5476\u548C\u549A\u5462\u5468\u548B\u547D\u548E\u56FA\u5783\u5777\u576A\u5769\u5761\u5766\u5764\u577C\u591C\u5949\u5947\u5948\u5944\u5954\u59BE\u59BB\u59D4\u59B9\u59AE\u59D1\u59C6\u59D0\u59CD\u59CB\u59D3\u59CA\u59AF\u59B3\u59D2\u59C5\u5B5F\u5B64\u5B63\u5B97\u5B9A\u5B98\u5B9C\u5B99\u5B9B\u5C1A\u5C48\u5C45\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5C46\u5CB7\u5CA1\u5CB8\u5CA9\u5CAB\u5CB1\u5CB3\u5E18\u5E1A\u5E16\u5E15\u5E1B\u5E11\u5E78\u5E9A\u5E97\u5E9C\u5E95\u5E96\u5EF6\u5F26\u5F27\u5F29\u5F80\u5F81\u5F7F\u5F7C\u5FDD\u5FE0\u5FFD\u5FF5\u5FFF\u600F\u6014\u602F\u6035\u6016\u602A\u6015\u6021\u6027\u6029\u602B\u601B\u6216\u6215\u623F\u623E\u6240\u627F\u62C9\u62CC\u62C4\u62BF\u62C2\u62B9\u62D2\u62DB\u62AB\u62D3\u62D4\u62CB\u62C8\u62A8\u62BD\u62BC\u62D0\u62D9\u62C7\u62CD\u62B5\u62DA\u62B1\u62D8\u62D6\u62D7\u62C6\u62AC\u62CE\u653E\u65A7\u65BC\u65FA\u6614\u6613\u660C\u6606\u6602\u660E\u6600\u660F\u6615\u660A\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[170] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6607\u670D\u670B\u676D\u678B\u6795\u6771\u679C\u6773\u6777\u6787\u679D\u6797\u676F\u6770\u677F\u6789\u677E\u6790\u6775\u679A\u6793\u677C\u676A\u6772\u6B23\u6B66\u6B67\u6B7F\u6C13\u6C1B\u6CE3\u6CE8\u6CF3\u6CB1\u6CCC\u6CE5\u6CB3\u6CBD\u6CBE\u6CBC\u6CE2\u6CAB\u6CD5\u6CD3\u6CB8\u6CC4\u6CB9\u6CC1\u6CAE\u6CD7\u6CC5\u6CF1\u6CBF\u6CBB\u6CE1\u6CDB\u6CCA\u6CAC\u6CEF\u6CDC\u6CD6\u6CE0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7095\u708E\u7092\u708A\u7099\u722C\u722D\u7238\u7248\u7267\u7269\u72C0\u72CE\u72D9\u72D7\u72D0\u73A9\u73A8\u739F\u73AB\u73A5\u753D\u759D\u7599\u759A\u7684\u76C2\u76F2\u76F4\u77E5\u77FD\u793E\u7940\u7941\u79C9\u79C8\u7A7A\u7A79\u7AFA\u7CFE\u7F54\u7F8C\u7F8B\u8005\u80BA\u80A5\u80A2\u80B1\u80A1\u80AB\u80A9\u80B4\u80AA\u80AF\u81E5\u81FE\u820D\u82B3\u829D\u8299\u82AD\u82BD\u829F\u82B9\u82B1\u82AC\u82A5\u82AF\u82B8\u82A3\u82B0\u82BE\u82B7\u864E\u8671\u521D\u8868\u8ECB\u8FCE\u8FD4\u8FD1\u90B5\u90B8\u90B1\u90B6\u91C7\u91D1\u9577\u9580\u961C\u9640\u963F\u963B\u9644\uFFFD".split("");
    for(j = 0; j != D[170].length; ++j)if (D[170][j].charCodeAt(0) !== 0xFFFD) {
        e[D[170][j]] = 43520 + j;
        d[43520 + j] = D[170][j];
    }
    D[171] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9642\u96B9\u96E8\u9752\u975E\u4E9F\u4EAD\u4EAE\u4FE1\u4FB5\u4FAF\u4FBF\u4FE0\u4FD1\u4FCF\u4FDD\u4FC3\u4FB6\u4FD8\u4FDF\u4FCA\u4FD7\u4FAE\u4FD0\u4FC4\u4FC2\u4FDA\u4FCE\u4FDE\u4FB7\u5157\u5192\u5191\u51A0\u524E\u5243\u524A\u524D\u524C\u524B\u5247\u52C7\u52C9\u52C3\u52C1\u530D\u5357\u537B\u539A\u53DB\u54AC\u54C0\u54A8\u54CE\u54C9\u54B8\u54A6\u54B3\u54C7\u54C2\u54BD\u54AA\u54C1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54C4\u54C8\u54AF\u54AB\u54B1\u54BB\u54A9\u54A7\u54BF\u56FF\u5782\u578B\u57A0\u57A3\u57A2\u57CE\u57AE\u5793\u5955\u5951\u594F\u594E\u5950\u59DC\u59D8\u59FF\u59E3\u59E8\u5A03\u59E5\u59EA\u59DA\u59E6\u5A01\u59FB\u5B69\u5BA3\u5BA6\u5BA4\u5BA2\u5BA5\u5C01\u5C4E\u5C4F\u5C4D\u5C4B\u5CD9\u5CD2\u5DF7\u5E1D\u5E25\u5E1F\u5E7D\u5EA0\u5EA6\u5EFA\u5F08\u5F2D\u5F65\u5F88\u5F85\u5F8A\u5F8B\u5F87\u5F8C\u5F89\u6012\u601D\u6020\u6025\u600E\u6028\u604D\u6070\u6068\u6062\u6046\u6043\u606C\u606B\u606A\u6064\u6241\u62DC\u6316\u6309\u62FC\u62ED\u6301\u62EE\u62FD\u6307\u62F1\u62F7\uFFFD".split("");
    for(j = 0; j != D[171].length; ++j)if (D[171][j].charCodeAt(0) !== 0xFFFD) {
        e[D[171][j]] = 43776 + j;
        d[43776 + j] = D[171][j];
    }
    D[172] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u62EF\u62EC\u62FE\u62F4\u6311\u6302\u653F\u6545\u65AB\u65BD\u65E2\u6625\u662D\u6620\u6627\u662F\u661F\u6628\u6631\u6624\u66F7\u67FF\u67D3\u67F1\u67D4\u67D0\u67EC\u67B6\u67AF\u67F5\u67E9\u67EF\u67C4\u67D1\u67B4\u67DA\u67E5\u67B8\u67CF\u67DE\u67F3\u67B0\u67D9\u67E2\u67DD\u67D2\u6B6A\u6B83\u6B86\u6BB5\u6BD2\u6BD7\u6C1F\u6CC9\u6D0B\u6D32\u6D2A\u6D41\u6D25\u6D0C\u6D31\u6D1E\u6D17\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D3B\u6D3D\u6D3E\u6D36\u6D1B\u6CF5\u6D39\u6D27\u6D38\u6D29\u6D2E\u6D35\u6D0E\u6D2B\u70AB\u70BA\u70B3\u70AC\u70AF\u70AD\u70B8\u70AE\u70A4\u7230\u7272\u726F\u7274\u72E9\u72E0\u72E1\u73B7\u73CA\u73BB\u73B2\u73CD\u73C0\u73B3\u751A\u752D\u754F\u754C\u754E\u754B\u75AB\u75A4\u75A5\u75A2\u75A3\u7678\u7686\u7687\u7688\u76C8\u76C6\u76C3\u76C5\u7701\u76F9\u76F8\u7709\u770B\u76FE\u76FC\u7707\u77DC\u7802\u7814\u780C\u780D\u7946\u7949\u7948\u7947\u79B9\u79BA\u79D1\u79D2\u79CB\u7A7F\u7A81\u7AFF\u7AFD\u7C7D\u7D02\u7D05\u7D00\u7D09\u7D07\u7D04\u7D06\u7F38\u7F8E\u7FBF\u8004\uFFFD".split("");
    for(j = 0; j != D[172].length; ++j)if (D[172][j].charCodeAt(0) !== 0xFFFD) {
        e[D[172][j]] = 44032 + j;
        d[44032 + j] = D[172][j];
    }
    D[173] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8010\u800D\u8011\u8036\u80D6\u80E5\u80DA\u80C3\u80C4\u80CC\u80E1\u80DB\u80CE\u80DE\u80E4\u80DD\u81F4\u8222\u82E7\u8303\u8305\u82E3\u82DB\u82E6\u8304\u82E5\u8302\u8309\u82D2\u82D7\u82F1\u8301\u82DC\u82D4\u82D1\u82DE\u82D3\u82DF\u82EF\u8306\u8650\u8679\u867B\u867A\u884D\u886B\u8981\u89D4\u8A08\u8A02\u8A03\u8C9E\u8CA0\u8D74\u8D73\u8DB4\u8ECD\u8ECC\u8FF0\u8FE6\u8FE2\u8FEA\u8FE5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8FED\u8FEB\u8FE4\u8FE8\u90CA\u90CE\u90C1\u90C3\u914B\u914A\u91CD\u9582\u9650\u964B\u964C\u964D\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u4E58\u4EB3\u500C\u500D\u5023\u4FEF\u5026\u5025\u4FF8\u5029\u5016\u5006\u503C\u501F\u501A\u5012\u5011\u4FFA\u5000\u5014\u5028\u4FF1\u5021\u500B\u5019\u5018\u4FF3\u4FEE\u502D\u502A\u4FFE\u502B\u5009\u517C\u51A4\u51A5\u51A2\u51CD\u51CC\u51C6\u51CB\u5256\u525C\u5254\u525B\u525D\u532A\u537F\u539F\u539D\u53DF\u54E8\u5510\u5501\u5537\u54FC\u54E5\u54F2\u5506\u54FA\u5514\u54E9\u54ED\u54E1\u5509\u54EE\u54EA\uFFFD".split("");
    for(j = 0; j != D[173].length; ++j)if (D[173][j].charCodeAt(0) !== 0xFFFD) {
        e[D[173][j]] = 44288 + j;
        d[44288 + j] = D[173][j];
    }
    D[174] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54E6\u5527\u5507\u54FD\u550F\u5703\u5704\u57C2\u57D4\u57CB\u57C3\u5809\u590F\u5957\u5958\u595A\u5A11\u5A18\u5A1C\u5A1F\u5A1B\u5A13\u59EC\u5A20\u5A23\u5A29\u5A25\u5A0C\u5A09\u5B6B\u5C58\u5BB0\u5BB3\u5BB6\u5BB4\u5BAE\u5BB5\u5BB9\u5BB8\u5C04\u5C51\u5C55\u5C50\u5CED\u5CFD\u5CFB\u5CEA\u5CE8\u5CF0\u5CF6\u5D01\u5CF4\u5DEE\u5E2D\u5E2B\u5EAB\u5EAD\u5EA7\u5F31\u5F92\u5F91\u5F90\u6059\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6063\u6065\u6050\u6055\u606D\u6069\u606F\u6084\u609F\u609A\u608D\u6094\u608C\u6085\u6096\u6247\u62F3\u6308\u62FF\u634E\u633E\u632F\u6355\u6342\u6346\u634F\u6349\u633A\u6350\u633D\u632A\u632B\u6328\u634D\u634C\u6548\u6549\u6599\u65C1\u65C5\u6642\u6649\u664F\u6643\u6652\u664C\u6645\u6641\u66F8\u6714\u6715\u6717\u6821\u6838\u6848\u6846\u6853\u6839\u6842\u6854\u6829\u68B3\u6817\u684C\u6851\u683D\u67F4\u6850\u6840\u683C\u6843\u682A\u6845\u6813\u6818\u6841\u6B8A\u6B89\u6BB7\u6C23\u6C27\u6C28\u6C26\u6C24\u6CF0\u6D6A\u6D95\u6D88\u6D87\u6D66\u6D78\u6D77\u6D59\u6D93\uFFFD".split("");
    for(j = 0; j != D[174].length; ++j)if (D[174][j].charCodeAt(0) !== 0xFFFD) {
        e[D[174][j]] = 44544 + j;
        d[44544 + j] = D[174][j];
    }
    D[175] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D6C\u6D89\u6D6E\u6D5A\u6D74\u6D69\u6D8C\u6D8A\u6D79\u6D85\u6D65\u6D94\u70CA\u70D8\u70E4\u70D9\u70C8\u70CF\u7239\u7279\u72FC\u72F9\u72FD\u72F8\u72F7\u7386\u73ED\u7409\u73EE\u73E0\u73EA\u73DE\u7554\u755D\u755C\u755A\u7559\u75BE\u75C5\u75C7\u75B2\u75B3\u75BD\u75BC\u75B9\u75C2\u75B8\u768B\u76B0\u76CA\u76CD\u76CE\u7729\u771F\u7720\u7728\u77E9\u7830\u7827\u7838\u781D\u7834\u7837\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7825\u782D\u7820\u781F\u7832\u7955\u7950\u7960\u795F\u7956\u795E\u795D\u7957\u795A\u79E4\u79E3\u79E7\u79DF\u79E6\u79E9\u79D8\u7A84\u7A88\u7AD9\u7B06\u7B11\u7C89\u7D21\u7D17\u7D0B\u7D0A\u7D20\u7D22\u7D14\u7D10\u7D15\u7D1A\u7D1C\u7D0D\u7D19\u7D1B\u7F3A\u7F5F\u7F94\u7FC5\u7FC1\u8006\u8018\u8015\u8019\u8017\u803D\u803F\u80F1\u8102\u80F0\u8105\u80ED\u80F4\u8106\u80F8\u80F3\u8108\u80FD\u810A\u80FC\u80EF\u81ED\u81EC\u8200\u8210\u822A\u822B\u8228\u822C\u82BB\u832B\u8352\u8354\u834A\u8338\u8350\u8349\u8335\u8334\u834F\u8332\u8339\u8336\u8317\u8340\u8331\u8328\u8343\uFFFD".split("");
    for(j = 0; j != D[175].length; ++j)if (D[175][j].charCodeAt(0) !== 0xFFFD) {
        e[D[175][j]] = 44800 + j;
        d[44800 + j] = D[175][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8654\u868A\u86AA\u8693\u86A4\u86A9\u868C\u86A3\u869C\u8870\u8877\u8881\u8882\u887D\u8879\u8A18\u8A10\u8A0E\u8A0C\u8A15\u8A0A\u8A17\u8A13\u8A16\u8A0F\u8A11\u8C48\u8C7A\u8C79\u8CA1\u8CA2\u8D77\u8EAC\u8ED2\u8ED4\u8ECF\u8FB1\u9001\u9006\u8FF7\u9000\u8FFA\u8FF4\u9003\u8FFD\u9005\u8FF8\u9095\u90E1\u90DD\u90E2\u9152\u914D\u914C\u91D8\u91DD\u91D7\u91DC\u91D9\u9583\u9662\u9663\u9661\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u965B\u965D\u9664\u9658\u965E\u96BB\u98E2\u99AC\u9AA8\u9AD8\u9B25\u9B32\u9B3C\u4E7E\u507A\u507D\u505C\u5047\u5043\u504C\u505A\u5049\u5065\u5076\u504E\u5055\u5075\u5074\u5077\u504F\u500F\u506F\u506D\u515C\u5195\u51F0\u526A\u526F\u52D2\u52D9\u52D8\u52D5\u5310\u530F\u5319\u533F\u5340\u533E\u53C3\u66FC\u5546\u556A\u5566\u5544\u555E\u5561\u5543\u554A\u5531\u5556\u554F\u5555\u552F\u5564\u5538\u552E\u555C\u552C\u5563\u5533\u5541\u5557\u5708\u570B\u5709\u57DF\u5805\u580A\u5806\u57E0\u57E4\u57FA\u5802\u5835\u57F7\u57F9\u5920\u5962\u5A36\u5A41\u5A49\u5A66\u5A6A\u5A40\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5A3C\u5A62\u5A5A\u5A46\u5A4A\u5B70\u5BC7\u5BC5\u5BC4\u5BC2\u5BBF\u5BC6\u5C09\u5C08\u5C07\u5C60\u5C5C\u5C5D\u5D07\u5D06\u5D0E\u5D1B\u5D16\u5D22\u5D11\u5D29\u5D14\u5D19\u5D24\u5D27\u5D17\u5DE2\u5E38\u5E36\u5E33\u5E37\u5EB7\u5EB8\u5EB6\u5EB5\u5EBE\u5F35\u5F37\u5F57\u5F6C\u5F69\u5F6B\u5F97\u5F99\u5F9E\u5F98\u5FA1\u5FA0\u5F9C\u607F\u60A3\u6089\u60A0\u60A8\u60CB\u60B4\u60E6\u60BD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u60C5\u60BB\u60B5\u60DC\u60BC\u60D8\u60D5\u60C6\u60DF\u60B8\u60DA\u60C7\u621A\u621B\u6248\u63A0\u63A7\u6372\u6396\u63A2\u63A5\u6377\u6367\u6398\u63AA\u6371\u63A9\u6389\u6383\u639B\u636B\u63A8\u6384\u6388\u6399\u63A1\u63AC\u6392\u638F\u6380\u637B\u6369\u6368\u637A\u655D\u6556\u6551\u6559\u6557\u555F\u654F\u6558\u6555\u6554\u659C\u659B\u65AC\u65CF\u65CB\u65CC\u65CE\u665D\u665A\u6664\u6668\u6666\u665E\u66F9\u52D7\u671B\u6881\u68AF\u68A2\u6893\u68B5\u687F\u6876\u68B1\u68A7\u6897\u68B0\u6883\u68C4\u68AD\u6886\u6885\u6894\u689D\u68A8\u689F\u68A1\u6882\u6B32\u6BBA\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6BEB\u6BEC\u6C2B\u6D8E\u6DBC\u6DF3\u6DD9\u6DB2\u6DE1\u6DCC\u6DE4\u6DFB\u6DFA\u6E05\u6DC7\u6DCB\u6DAF\u6DD1\u6DAE\u6DDE\u6DF9\u6DB8\u6DF7\u6DF5\u6DC5\u6DD2\u6E1A\u6DB5\u6DDA\u6DEB\u6DD8\u6DEA\u6DF1\u6DEE\u6DE8\u6DC6\u6DC4\u6DAA\u6DEC\u6DBF\u6DE6\u70F9\u7109\u710A\u70FD\u70EF\u723D\u727D\u7281\u731C\u731B\u7316\u7313\u7319\u7387\u7405\u740A\u7403\u7406\u73FE\u740D\u74E0\u74F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74F7\u751C\u7522\u7565\u7566\u7562\u7570\u758F\u75D4\u75D5\u75B5\u75CA\u75CD\u768E\u76D4\u76D2\u76DB\u7737\u773E\u773C\u7736\u7738\u773A\u786B\u7843\u784E\u7965\u7968\u796D\u79FB\u7A92\u7A95\u7B20\u7B28\u7B1B\u7B2C\u7B26\u7B19\u7B1E\u7B2E\u7C92\u7C97\u7C95\u7D46\u7D43\u7D71\u7D2E\u7D39\u7D3C\u7D40\u7D30\u7D33\u7D44\u7D2F\u7D42\u7D32\u7D31\u7F3D\u7F9E\u7F9A\u7FCC\u7FCE\u7FD2\u801C\u804A\u8046\u812F\u8116\u8123\u812B\u8129\u8130\u8124\u8202\u8235\u8237\u8236\u8239\u838E\u839E\u8398\u8378\u83A2\u8396\u83BD\u83AB\u8392\u838A\u8393\u8389\u83A0\u8377\u837B\u837C\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8386\u83A7\u8655\u5F6A\u86C7\u86C0\u86B6\u86C4\u86B5\u86C6\u86CB\u86B1\u86AF\u86C9\u8853\u889E\u8888\u88AB\u8892\u8896\u888D\u888B\u8993\u898F\u8A2A\u8A1D\u8A23\u8A25\u8A31\u8A2D\u8A1F\u8A1B\u8A22\u8C49\u8C5A\u8CA9\u8CAC\u8CAB\u8CA8\u8CAA\u8CA7\u8D67\u8D66\u8DBE\u8DBA\u8EDB\u8EDF\u9019\u900D\u901A\u9017\u9023\u901F\u901D\u9010\u9015\u901E\u9020\u900F\u9022\u9016\u901B\u9014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90E8\u90ED\u90FD\u9157\u91CE\u91F5\u91E6\u91E3\u91E7\u91ED\u91E9\u9589\u966A\u9675\u9673\u9678\u9670\u9674\u9676\u9677\u966C\u96C0\u96EA\u96E9\u7AE0\u7ADF\u9802\u9803\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u50A2\u508D\u5085\u5099\u5091\u5080\u5096\u5098\u509A\u6700\u51F1\u5272\u5274\u5275\u5269\u52DE\u52DD\u52DB\u535A\u53A5\u557B\u5580\u55A7\u557C\u558A\u559D\u5598\u5582\u559C\u55AA\u5594\u5587\u558B\u5583\u55B3\u55AE\u559F\u553E\u55B2\u559A\u55BB\u55AC\u55B1\u557E\u5589\u55AB\u5599\u570D\u582F\u582A\u5834\u5824\u5830\u5831\u5821\u581D\u5820\u58F9\u58FA\u5960\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5A77\u5A9A\u5A7F\u5A92\u5A9B\u5AA7\u5B73\u5B71\u5BD2\u5BCC\u5BD3\u5BD0\u5C0A\u5C0B\u5C31\u5D4C\u5D50\u5D34\u5D47\u5DFD\u5E45\u5E3D\u5E40\u5E43\u5E7E\u5ECA\u5EC1\u5EC2\u5EC4\u5F3C\u5F6D\u5FA9\u5FAA\u5FA8\u60D1\u60E1\u60B2\u60B6\u60E0\u611C\u6123\u60FA\u6115\u60F0\u60FB\u60F4\u6168\u60F1\u610E\u60F6\u6109\u6100\u6112\u621F\u6249\u63A3\u638C\u63CF\u63C0\u63E9\u63C9\u63C6\u63CD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u63D2\u63E3\u63D0\u63E1\u63D6\u63ED\u63EE\u6376\u63F4\u63EA\u63DB\u6452\u63DA\u63F9\u655E\u6566\u6562\u6563\u6591\u6590\u65AF\u666E\u6670\u6674\u6676\u666F\u6691\u667A\u667E\u6677\u66FE\u66FF\u671F\u671D\u68FA\u68D5\u68E0\u68D8\u68D7\u6905\u68DF\u68F5\u68EE\u68E7\u68F9\u68D2\u68F2\u68E3\u68CB\u68CD\u690D\u6912\u690E\u68C9\u68DA\u696E\u68FB\u6B3E\u6B3A\u6B3D\u6B98\u6B96\u6BBC\u6BEF\u6C2E\u6C2F\u6C2C\u6E2F\u6E38\u6E54\u6E21\u6E32\u6E67\u6E4A\u6E20\u6E25\u6E23\u6E1B\u6E5B\u6E58\u6E24\u6E56\u6E6E\u6E2D\u6E26\u6E6F\u6E34\u6E4D\u6E3A\u6E2C\u6E43\u6E1D\u6E3E\u6ECB\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6E89\u6E19\u6E4E\u6E63\u6E44\u6E72\u6E69\u6E5F\u7119\u711A\u7126\u7130\u7121\u7136\u716E\u711C\u724C\u7284\u7280\u7336\u7325\u7334\u7329\u743A\u742A\u7433\u7422\u7425\u7435\u7436\u7434\u742F\u741B\u7426\u7428\u7525\u7526\u756B\u756A\u75E2\u75DB\u75E3\u75D9\u75D8\u75DE\u75E0\u767B\u767C\u7696\u7693\u76B4\u76DC\u774F\u77ED\u785D\u786C\u786F\u7A0D\u7A08\u7A0B\u7A05\u7A00\u7A98\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A97\u7A96\u7AE5\u7AE3\u7B49\u7B56\u7B46\u7B50\u7B52\u7B54\u7B4D\u7B4B\u7B4F\u7B51\u7C9F\u7CA5\u7D5E\u7D50\u7D68\u7D55\u7D2B\u7D6E\u7D72\u7D61\u7D66\u7D62\u7D70\u7D73\u5584\u7FD4\u7FD5\u800B\u8052\u8085\u8155\u8154\u814B\u8151\u814E\u8139\u8146\u813E\u814C\u8153\u8174\u8212\u821C\u83E9\u8403\u83F8\u840D\u83E0\u83C5\u840B\u83C1\u83EF\u83F1\u83F4\u8457\u840A\u83F0\u840C\u83CC\u83FD\u83F2\u83CA\u8438\u840E\u8404\u83DC\u8407\u83D4\u83DF\u865B\u86DF\u86D9\u86ED\u86D4\u86DB\u86E4\u86D0\u86DE\u8857\u88C1\u88C2\u88B1\u8983\u8996\u8A3B\u8A60\u8A55\u8A5E\u8A3C\u8A41\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8A54\u8A5B\u8A50\u8A46\u8A34\u8A3A\u8A36\u8A56\u8C61\u8C82\u8CAF\u8CBC\u8CB3\u8CBD\u8CC1\u8CBB\u8CC0\u8CB4\u8CB7\u8CB6\u8CBF\u8CB8\u8D8A\u8D85\u8D81\u8DCE\u8DDD\u8DCB\u8DDA\u8DD1\u8DCC\u8DDB\u8DC6\u8EFB\u8EF8\u8EFC\u8F9C\u902E\u9035\u9031\u9038\u9032\u9036\u9102\u90F5\u9109\u90FE\u9163\u9165\u91CF\u9214\u9215\u9223\u9209\u921E\u920D\u9210\u9207\u9211\u9594\u958F\u958B\u9591\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9593\u9592\u958E\u968A\u968E\u968B\u967D\u9685\u9686\u968D\u9672\u9684\u96C1\u96C5\u96C4\u96C6\u96C7\u96EF\u96F2\u97CC\u9805\u9806\u9808\u98E7\u98EA\u98EF\u98E9\u98F2\u98ED\u99AE\u99AD\u9EC3\u9ECD\u9ED1\u4E82\u50AD\u50B5\u50B2\u50B3\u50C5\u50BE\u50AC\u50B7\u50BB\u50AF\u50C7\u527F\u5277\u527D\u52DF\u52E6\u52E4\u52E2\u52E3\u532F\u55DF\u55E8\u55D3\u55E6\u55CE\u55DC\u55C7\u55D1\u55E3\u55E4\u55EF\u55DA\u55E1\u55C5\u55C6\u55E5\u55C9\u5712\u5713\u585E\u5851\u5858\u5857\u585A\u5854\u586B\u584C\u586D\u584A\u5862\u5852\u584B\u5967\u5AC1\u5AC9\u5ACC\u5ABE\u5ABD\u5ABC\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5AB3\u5AC2\u5AB2\u5D69\u5D6F\u5E4C\u5E79\u5EC9\u5EC8\u5F12\u5F59\u5FAC\u5FAE\u611A\u610F\u6148\u611F\u60F3\u611B\u60F9\u6101\u6108\u614E\u614C\u6144\u614D\u613E\u6134\u6127\u610D\u6106\u6137\u6221\u6222\u6413\u643E\u641E\u642A\u642D\u643D\u642C\u640F\u641C\u6414\u640D\u6436\u6416\u6417\u6406\u656C\u659F\u65B0\u6697\u6689\u6687\u6688\u6696\u6684\u6698\u668D\u6703\u6994\u696D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u695A\u6977\u6960\u6954\u6975\u6930\u6982\u694A\u6968\u696B\u695E\u6953\u6979\u6986\u695D\u6963\u695B\u6B47\u6B72\u6BC0\u6BBF\u6BD3\u6BFD\u6EA2\u6EAF\u6ED3\u6EB6\u6EC2\u6E90\u6E9D\u6EC7\u6EC5\u6EA5\u6E98\u6EBC\u6EBA\u6EAB\u6ED1\u6E96\u6E9C\u6EC4\u6ED4\u6EAA\u6EA7\u6EB4\u714E\u7159\u7169\u7164\u7149\u7167\u715C\u716C\u7166\u714C\u7165\u715E\u7146\u7168\u7156\u723A\u7252\u7337\u7345\u733F\u733E\u746F\u745A\u7455\u745F\u745E\u7441\u743F\u7459\u745B\u745C\u7576\u7578\u7600\u75F0\u7601\u75F2\u75F1\u75FA\u75FF\u75F4\u75F3\u76DE\u76DF\u775B\u776B\u7766\u775E\u7763\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7779\u776A\u776C\u775C\u7765\u7768\u7762\u77EE\u788E\u78B0\u7897\u7898\u788C\u7889\u787C\u7891\u7893\u787F\u797A\u797F\u7981\u842C\u79BD\u7A1C\u7A1A\u7A20\u7A14\u7A1F\u7A1E\u7A9F\u7AA0\u7B77\u7BC0\u7B60\u7B6E\u7B67\u7CB1\u7CB3\u7CB5\u7D93\u7D79\u7D91\u7D81\u7D8F\u7D5B\u7F6E\u7F69\u7F6A\u7F72\u7FA9\u7FA8\u7FA4\u8056\u8058\u8086\u8084\u8171\u8170\u8178\u8165\u816E\u8173\u816B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8179\u817A\u8166\u8205\u8247\u8482\u8477\u843D\u8431\u8475\u8466\u846B\u8449\u846C\u845B\u843C\u8435\u8461\u8463\u8469\u846D\u8446\u865E\u865C\u865F\u86F9\u8713\u8708\u8707\u8700\u86FE\u86FB\u8702\u8703\u8706\u870A\u8859\u88DF\u88D4\u88D9\u88DC\u88D8\u88DD\u88E1\u88CA\u88D5\u88D2\u899C\u89E3\u8A6B\u8A72\u8A73\u8A66\u8A69\u8A70\u8A87\u8A7C\u8A63\u8AA0\u8A71\u8A85\u8A6D\u8A62\u8A6E\u8A6C\u8A79\u8A7B\u8A3E\u8A68\u8C62\u8C8A\u8C89\u8CCA\u8CC7\u8CC8\u8CC4\u8CB2\u8CC3\u8CC2\u8CC5\u8DE1\u8DDF\u8DE8\u8DEF\u8DF3\u8DFA\u8DEA\u8DE4\u8DE6\u8EB2\u8F03\u8F09\u8EFE\u8F0A\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F9F\u8FB2\u904B\u904A\u9053\u9042\u9054\u903C\u9055\u9050\u9047\u904F\u904E\u904D\u9051\u903E\u9041\u9112\u9117\u916C\u916A\u9169\u91C9\u9237\u9257\u9238\u923D\u9240\u923E\u925B\u924B\u9264\u9251\u9234\u9249\u924D\u9245\u9239\u923F\u925A\u9598\u9698\u9694\u9695\u96CD\u96CB\u96C9\u96CA\u96F7\u96FB\u96F9\u96F6\u9756\u9774\u9776\u9810\u9811\u9813\u980A\u9812\u980C\u98FC\u98F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u98FD\u98FE\u99B3\u99B1\u99B4\u9AE1\u9CE9\u9E82\u9F0E\u9F13\u9F20\u50E7\u50EE\u50E5\u50D6\u50ED\u50DA\u50D5\u50CF\u50D1\u50F1\u50CE\u50E9\u5162\u51F3\u5283\u5282\u5331\u53AD\u55FE\u5600\u561B\u5617\u55FD\u5614\u5606\u5609\u560D\u560E\u55F7\u5616\u561F\u5608\u5610\u55F6\u5718\u5716\u5875\u587E\u5883\u5893\u588A\u5879\u5885\u587D\u58FD\u5925\u5922\u5924\u596A\u5969\u5AE1\u5AE6\u5AE9\u5AD7\u5AD6\u5AD8\u5AE3\u5B75\u5BDE\u5BE7\u5BE1\u5BE5\u5BE6\u5BE8\u5BE2\u5BE4\u5BDF\u5C0D\u5C62\u5D84\u5D87\u5E5B\u5E63\u5E55\u5E57\u5E54\u5ED3\u5ED6\u5F0A\u5F46\u5F70\u5FB9\u6147\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u613F\u614B\u6177\u6162\u6163\u615F\u615A\u6158\u6175\u622A\u6487\u6458\u6454\u64A4\u6478\u645F\u647A\u6451\u6467\u6434\u646D\u647B\u6572\u65A1\u65D7\u65D6\u66A2\u66A8\u669D\u699C\u69A8\u6995\u69C1\u69AE\u69D3\u69CB\u699B\u69B7\u69BB\u69AB\u69B4\u69D0\u69CD\u69AD\u69CC\u69A6\u69C3\u69A3\u6B49\u6B4C\u6C33\u6F33\u6F14\u6EFE\u6F13\u6EF4\u6F29\u6F3E\u6F20\u6F2C\u6F0F\u6F02\u6F22\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6EFF\u6EEF\u6F06\u6F31\u6F38\u6F32\u6F23\u6F15\u6F2B\u6F2F\u6F88\u6F2A\u6EEC\u6F01\u6EF2\u6ECC\u6EF7\u7194\u7199\u717D\u718A\u7184\u7192\u723E\u7292\u7296\u7344\u7350\u7464\u7463\u746A\u7470\u746D\u7504\u7591\u7627\u760D\u760B\u7609\u7613\u76E1\u76E3\u7784\u777D\u777F\u7761\u78C1\u789F\u78A7\u78B3\u78A9\u78A3\u798E\u798F\u798D\u7A2E\u7A31\u7AAA\u7AA9\u7AED\u7AEF\u7BA1\u7B95\u7B8B\u7B75\u7B97\u7B9D\u7B94\u7B8F\u7BB8\u7B87\u7B84\u7CB9\u7CBD\u7CBE\u7DBB\u7DB0\u7D9C\u7DBD\u7DBE\u7DA0\u7DCA\u7DB4\u7DB2\u7DB1\u7DBA\u7DA2\u7DBF\u7DB5\u7DB8\u7DAD\u7DD2\u7DC7\u7DAC\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7F70\u7FE0\u7FE1\u7FDF\u805E\u805A\u8087\u8150\u8180\u818F\u8188\u818A\u817F\u8182\u81E7\u81FA\u8207\u8214\u821E\u824B\u84C9\u84BF\u84C6\u84C4\u8499\u849E\u84B2\u849C\u84CB\u84B8\u84C0\u84D3\u8490\u84BC\u84D1\u84CA\u873F\u871C\u873B\u8722\u8725\u8734\u8718\u8755\u8737\u8729\u88F3\u8902\u88F4\u88F9\u88F8\u88FD\u88E8\u891A\u88EF\u8AA6\u8A8C\u8A9E\u8AA3\u8A8D\u8AA1\u8A93\u8AA4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AAA\u8AA5\u8AA8\u8A98\u8A91\u8A9A\u8AA7\u8C6A\u8C8D\u8C8C\u8CD3\u8CD1\u8CD2\u8D6B\u8D99\u8D95\u8DFC\u8F14\u8F12\u8F15\u8F13\u8FA3\u9060\u9058\u905C\u9063\u9059\u905E\u9062\u905D\u905B\u9119\u9118\u911E\u9175\u9178\u9177\u9174\u9278\u9280\u9285\u9298\u9296\u927B\u9293\u929C\u92A8\u927C\u9291\u95A1\u95A8\u95A9\u95A3\u95A5\u95A4\u9699\u969C\u969B\u96CC\u96D2\u9700\u977C\u9785\u97F6\u9817\u9818\u98AF\u98B1\u9903\u9905\u990C\u9909\u99C1\u9AAF\u9AB0\u9AE6\u9B41\u9B42\u9CF4\u9CF6\u9CF3\u9EBC\u9F3B\u9F4A\u5104\u5100\u50FB\u50F5\u50F9\u5102\u5108\u5109\u5105\u51DC\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5287\u5288\u5289\u528D\u528A\u52F0\u53B2\u562E\u563B\u5639\u5632\u563F\u5634\u5629\u5653\u564E\u5657\u5674\u5636\u562F\u5630\u5880\u589F\u589E\u58B3\u589C\u58AE\u58A9\u58A6\u596D\u5B09\u5AFB\u5B0B\u5AF5\u5B0C\u5B08\u5BEE\u5BEC\u5BE9\u5BEB\u5C64\u5C65\u5D9D\u5D94\u5E62\u5E5F\u5E61\u5EE2\u5EDA\u5EDF\u5EDD\u5EE3\u5EE0\u5F48\u5F71\u5FB7\u5FB5\u6176\u6167\u616E\u615D\u6155\u6182\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u617C\u6170\u616B\u617E\u61A7\u6190\u61AB\u618E\u61AC\u619A\u61A4\u6194\u61AE\u622E\u6469\u646F\u6479\u649E\u64B2\u6488\u6490\u64B0\u64A5\u6493\u6495\u64A9\u6492\u64AE\u64AD\u64AB\u649A\u64AC\u6499\u64A2\u64B3\u6575\u6577\u6578\u66AE\u66AB\u66B4\u66B1\u6A23\u6A1F\u69E8\u6A01\u6A1E\u6A19\u69FD\u6A21\u6A13\u6A0A\u69F3\u6A02\u6A05\u69ED\u6A11\u6B50\u6B4E\u6BA4\u6BC5\u6BC6\u6F3F\u6F7C\u6F84\u6F51\u6F66\u6F54\u6F86\u6F6D\u6F5B\u6F78\u6F6E\u6F8E\u6F7A\u6F70\u6F64\u6F97\u6F58\u6ED5\u6F6F\u6F60\u6F5F\u719F\u71AC\u71B1\u71A8\u7256\u729B\u734E\u7357\u7469\u748B\u7483\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u747E\u7480\u757F\u7620\u7629\u761F\u7624\u7626\u7621\u7622\u769A\u76BA\u76E4\u778E\u7787\u778C\u7791\u778B\u78CB\u78C5\u78BA\u78CA\u78BE\u78D5\u78BC\u78D0\u7A3F\u7A3C\u7A40\u7A3D\u7A37\u7A3B\u7AAF\u7AAE\u7BAD\u7BB1\u7BC4\u7BB4\u7BC6\u7BC7\u7BC1\u7BA0\u7BCC\u7CCA\u7DE0\u7DF4\u7DEF\u7DFB\u7DD8\u7DEC\u7DDD\u7DE8\u7DE3\u7DDA\u7DDE\u7DE9\u7D9E\u7DD9\u7DF2\u7DF9\u7F75\u7F77\u7FAF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7FE9\u8026\u819B\u819C\u819D\u81A0\u819A\u8198\u8517\u853D\u851A\u84EE\u852C\u852D\u8513\u8511\u8523\u8521\u8514\u84EC\u8525\u84FF\u8506\u8782\u8774\u8776\u8760\u8766\u8778\u8768\u8759\u8757\u874C\u8753\u885B\u885D\u8910\u8907\u8912\u8913\u8915\u890A\u8ABC\u8AD2\u8AC7\u8AC4\u8A95\u8ACB\u8AF8\u8AB2\u8AC9\u8AC2\u8ABF\u8AB0\u8AD6\u8ACD\u8AB6\u8AB9\u8ADB\u8C4C\u8C4E\u8C6C\u8CE0\u8CDE\u8CE6\u8CE4\u8CEC\u8CED\u8CE2\u8CE3\u8CDC\u8CEA\u8CE1\u8D6D\u8D9F\u8DA3\u8E2B\u8E10\u8E1D\u8E22\u8E0F\u8E29\u8E1F\u8E21\u8E1E\u8EBA\u8F1D\u8F1B\u8F1F\u8F29\u8F26\u8F2A\u8F1C\u8F1E\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F25\u9069\u906E\u9068\u906D\u9077\u9130\u912D\u9127\u9131\u9187\u9189\u918B\u9183\u92C5\u92BB\u92B7\u92EA\u92AC\u92E4\u92C1\u92B3\u92BC\u92D2\u92C7\u92F0\u92B2\u95AD\u95B1\u9704\u9706\u9707\u9709\u9760\u978D\u978B\u978F\u9821\u982B\u981C\u98B3\u990A\u9913\u9912\u9918\u99DD\u99D0\u99DF\u99DB\u99D1\u99D5\u99D2\u99D9\u9AB7\u9AEE\u9AEF\u9B27\u9B45\u9B44\u9B77\u9B6F\u9D06\u9D09\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D03\u9EA9\u9EBE\u9ECE\u58A8\u9F52\u5112\u5118\u5114\u5110\u5115\u5180\u51AA\u51DD\u5291\u5293\u52F3\u5659\u566B\u5679\u5669\u5664\u5678\u566A\u5668\u5665\u5671\u566F\u566C\u5662\u5676\u58C1\u58BE\u58C7\u58C5\u596E\u5B1D\u5B34\u5B78\u5BF0\u5C0E\u5F4A\u61B2\u6191\u61A9\u618A\u61CD\u61B6\u61BE\u61CA\u61C8\u6230\u64C5\u64C1\u64CB\u64BB\u64BC\u64DA\u64C4\u64C7\u64C2\u64CD\u64BF\u64D2\u64D4\u64BE\u6574\u66C6\u66C9\u66B9\u66C4\u66C7\u66B8\u6A3D\u6A38\u6A3A\u6A59\u6A6B\u6A58\u6A39\u6A44\u6A62\u6A61\u6A4B\u6A47\u6A35\u6A5F\u6A48\u6B59\u6B77\u6C05\u6FC2\u6FB1\u6FA1\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FC3\u6FA4\u6FC1\u6FA7\u6FB3\u6FC0\u6FB9\u6FB6\u6FA6\u6FA0\u6FB4\u71BE\u71C9\u71D0\u71D2\u71C8\u71D5\u71B9\u71CE\u71D9\u71DC\u71C3\u71C4\u7368\u749C\u74A3\u7498\u749F\u749E\u74E2\u750C\u750D\u7634\u7638\u763A\u76E7\u76E5\u77A0\u779E\u779F\u77A5\u78E8\u78DA\u78EC\u78E7\u79A6\u7A4D\u7A4E\u7A46\u7A4C\u7A4B\u7ABA\u7BD9\u7C11\u7BC9\u7BE4\u7BDB\u7BE1\u7BE9\u7BE6\u7CD5\u7CD6\u7E0A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E11\u7E08\u7E1B\u7E23\u7E1E\u7E1D\u7E09\u7E10\u7F79\u7FB2\u7FF0\u7FF1\u7FEE\u8028\u81B3\u81A9\u81A8\u81FB\u8208\u8258\u8259\u854A\u8559\u8548\u8568\u8569\u8543\u8549\u856D\u856A\u855E\u8783\u879F\u879E\u87A2\u878D\u8861\u892A\u8932\u8925\u892B\u8921\u89AA\u89A6\u8AE6\u8AFA\u8AEB\u8AF1\u8B00\u8ADC\u8AE7\u8AEE\u8AFE\u8B01\u8B02\u8AF7\u8AED\u8AF3\u8AF6\u8AFC\u8C6B\u8C6D\u8C93\u8CF4\u8E44\u8E31\u8E34\u8E42\u8E39\u8E35\u8F3B\u8F2F\u8F38\u8F33\u8FA8\u8FA6\u9075\u9074\u9078\u9072\u907C\u907A\u9134\u9192\u9320\u9336\u92F8\u9333\u932F\u9322\u92FC\u932B\u9304\u931A\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9310\u9326\u9321\u9315\u932E\u9319\u95BB\u96A7\u96A8\u96AA\u96D5\u970E\u9711\u9716\u970D\u9713\u970F\u975B\u975C\u9766\u9798\u9830\u9838\u983B\u9837\u982D\u9839\u9824\u9910\u9928\u991E\u991B\u9921\u991A\u99ED\u99E2\u99F1\u9AB8\u9ABC\u9AFB\u9AED\u9B28\u9B91\u9D15\u9D23\u9D26\u9D28\u9D12\u9D1B\u9ED8\u9ED4\u9F8D\u9F9C\u512A\u511F\u5121\u5132\u52F5\u568E\u5680\u5690\u5685\u5687\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u568F\u58D5\u58D3\u58D1\u58CE\u5B30\u5B2A\u5B24\u5B7A\u5C37\u5C68\u5DBC\u5DBA\u5DBD\u5DB8\u5E6B\u5F4C\u5FBD\u61C9\u61C2\u61C7\u61E6\u61CB\u6232\u6234\u64CE\u64CA\u64D8\u64E0\u64F0\u64E6\u64EC\u64F1\u64E2\u64ED\u6582\u6583\u66D9\u66D6\u6A80\u6A94\u6A84\u6AA2\u6A9C\u6ADB\u6AA3\u6A7E\u6A97\u6A90\u6AA0\u6B5C\u6BAE\u6BDA\u6C08\u6FD8\u6FF1\u6FDF\u6FE0\u6FDB\u6FE4\u6FEB\u6FEF\u6F80\u6FEC\u6FE1\u6FE9\u6FD5\u6FEE\u6FF0\u71E7\u71DF\u71EE\u71E6\u71E5\u71ED\u71EC\u71F4\u71E0\u7235\u7246\u7370\u7372\u74A9\u74B0\u74A6\u74A8\u7646\u7642\u764C\u76EA\u77B3\u77AA\u77B0\u77AC\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77A7\u77AD\u77EF\u78F7\u78FA\u78F4\u78EF\u7901\u79A7\u79AA\u7A57\u7ABF\u7C07\u7C0D\u7BFE\u7BF7\u7C0C\u7BE0\u7CE0\u7CDC\u7CDE\u7CE2\u7CDF\u7CD9\u7CDD\u7E2E\u7E3E\u7E46\u7E37\u7E32\u7E43\u7E2B\u7E3D\u7E31\u7E45\u7E41\u7E34\u7E39\u7E48\u7E35\u7E3F\u7E2F\u7F44\u7FF3\u7FFC\u8071\u8072\u8070\u806F\u8073\u81C6\u81C3\u81BA\u81C2\u81C0\u81BF\u81BD\u81C9\u81BE\u81E8\u8209\u8271\u85AA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8584\u857E\u859C\u8591\u8594\u85AF\u859B\u8587\u85A8\u858A\u8667\u87C0\u87D1\u87B3\u87D2\u87C6\u87AB\u87BB\u87BA\u87C8\u87CB\u893B\u8936\u8944\u8938\u893D\u89AC\u8B0E\u8B17\u8B19\u8B1B\u8B0A\u8B20\u8B1D\u8B04\u8B10\u8C41\u8C3F\u8C73\u8CFA\u8CFD\u8CFC\u8CF8\u8CFB\u8DA8\u8E49\u8E4B\u8E48\u8E4A\u8F44\u8F3E\u8F42\u8F45\u8F3F\u907F\u907D\u9084\u9081\u9082\u9080\u9139\u91A3\u919E\u919C\u934D\u9382\u9328\u9375\u934A\u9365\u934B\u9318\u937E\u936C\u935B\u9370\u935A\u9354\u95CA\u95CB\u95CC\u95C8\u95C6\u96B1\u96B8\u96D6\u971C\u971E\u97A0\u97D3\u9846\u98B6\u9935\u9A01\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u99FF\u9BAE\u9BAB\u9BAA\u9BAD\u9D3B\u9D3F\u9E8B\u9ECF\u9EDE\u9EDC\u9EDD\u9EDB\u9F3E\u9F4B\u53E2\u5695\u56AE\u58D9\u58D8\u5B38\u5F5D\u61E3\u6233\u64F4\u64F2\u64FE\u6506\u64FA\u64FB\u64F7\u65B7\u66DC\u6726\u6AB3\u6AAC\u6AC3\u6ABB\u6AB8\u6AC2\u6AAE\u6AAF\u6B5F\u6B78\u6BAF\u7009\u700B\u6FFE\u7006\u6FFA\u7011\u700F\u71FB\u71FC\u71FE\u71F8\u7377\u7375\u74A7\u74BF\u7515\u7656\u7658\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7652\u77BD\u77BF\u77BB\u77BC\u790E\u79AE\u7A61\u7A62\u7A60\u7AC4\u7AC5\u7C2B\u7C27\u7C2A\u7C1E\u7C23\u7C21\u7CE7\u7E54\u7E55\u7E5E\u7E5A\u7E61\u7E52\u7E59\u7F48\u7FF9\u7FFB\u8077\u8076\u81CD\u81CF\u820A\u85CF\u85A9\u85CD\u85D0\u85C9\u85B0\u85BA\u85B9\u85A6\u87EF\u87EC\u87F2\u87E0\u8986\u89B2\u89F4\u8B28\u8B39\u8B2C\u8B2B\u8C50\u8D05\u8E59\u8E63\u8E66\u8E64\u8E5F\u8E55\u8EC0\u8F49\u8F4D\u9087\u9083\u9088\u91AB\u91AC\u91D0\u9394\u938A\u9396\u93A2\u93B3\u93AE\u93AC\u93B0\u9398\u939A\u9397\u95D4\u95D6\u95D0\u95D5\u96E2\u96DC\u96D9\u96DB\u96DE\u9724\u97A3\u97A6\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u97AD\u97F9\u984D\u984F\u984C\u984E\u9853\u98BA\u993E\u993F\u993D\u992E\u99A5\u9A0E\u9AC1\u9B03\u9B06\u9B4F\u9B4E\u9B4D\u9BCA\u9BC9\u9BFD\u9BC8\u9BC0\u9D51\u9D5D\u9D60\u9EE0\u9F15\u9F2C\u5133\u56A5\u58DE\u58DF\u58E2\u5BF5\u9F90\u5EEC\u61F2\u61F7\u61F6\u61F5\u6500\u650F\u66E0\u66DD\u6AE5\u6ADD\u6ADA\u6AD3\u701B\u701F\u7028\u701A\u701D\u7015\u7018\u7206\u720D\u7258\u72A2\u7378\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u737A\u74BD\u74CA\u74E3\u7587\u7586\u765F\u7661\u77C7\u7919\u79B1\u7A6B\u7A69\u7C3E\u7C3F\u7C38\u7C3D\u7C37\u7C40\u7E6B\u7E6D\u7E79\u7E69\u7E6A\u7F85\u7E73\u7FB6\u7FB9\u7FB8\u81D8\u85E9\u85DD\u85EA\u85D5\u85E4\u85E5\u85F7\u87FB\u8805\u880D\u87F9\u87FE\u8960\u895F\u8956\u895E\u8B41\u8B5C\u8B58\u8B49\u8B5A\u8B4E\u8B4F\u8B46\u8B59\u8D08\u8D0A\u8E7C\u8E72\u8E87\u8E76\u8E6C\u8E7A\u8E74\u8F54\u8F4E\u8FAD\u908A\u908B\u91B1\u91AE\u93E1\u93D1\u93DF\u93C3\u93C8\u93DC\u93DD\u93D6\u93E2\u93CD\u93D8\u93E4\u93D7\u93E8\u95DC\u96B4\u96E3\u972A\u9727\u9761\u97DC\u97FB\u985E\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9858\u985B\u98BC\u9945\u9949\u9A16\u9A19\u9B0D\u9BE8\u9BE7\u9BD6\u9BDB\u9D89\u9D61\u9D72\u9D6A\u9D6C\u9E92\u9E97\u9E93\u9EB4\u52F8\u56A8\u56B7\u56B6\u56B4\u56BC\u58E4\u5B40\u5B43\u5B7D\u5BF6\u5DC9\u61F8\u61FA\u6518\u6514\u6519\u66E6\u6727\u6AEC\u703E\u7030\u7032\u7210\u737B\u74CF\u7662\u7665\u7926\u792A\u792C\u792B\u7AC7\u7AF6\u7C4C\u7C43\u7C4D\u7CEF\u7CF0\u8FAE\u7E7D\u7E7C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E82\u7F4C\u8000\u81DA\u8266\u85FB\u85F9\u8611\u85FA\u8606\u860B\u8607\u860A\u8814\u8815\u8964\u89BA\u89F8\u8B70\u8B6C\u8B66\u8B6F\u8B5F\u8B6B\u8D0F\u8D0D\u8E89\u8E81\u8E85\u8E82\u91B4\u91CB\u9418\u9403\u93FD\u95E1\u9730\u98C4\u9952\u9951\u99A8\u9A2B\u9A30\u9A37\u9A35\u9C13\u9C0D\u9E79\u9EB5\u9EE8\u9F2F\u9F5F\u9F63\u9F61\u5137\u5138\u56C1\u56C0\u56C2\u5914\u5C6C\u5DCD\u61FC\u61FE\u651D\u651C\u6595\u66E9\u6AFB\u6B04\u6AFA\u6BB2\u704C\u721B\u72A7\u74D6\u74D4\u7669\u77D3\u7C50\u7E8F\u7E8C\u7FBC\u8617\u862D\u861A\u8823\u8822\u8821\u881F\u896A\u896C\u89BD\u8B74\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B77\u8B7D\u8D13\u8E8A\u8E8D\u8E8B\u8F5F\u8FAF\u91BA\u942E\u9433\u9435\u943A\u9438\u9432\u942B\u95E2\u9738\u9739\u9732\u97FF\u9867\u9865\u9957\u9A45\u9A43\u9A40\u9A3E\u9ACF\u9B54\u9B51\u9C2D\u9C25\u9DAF\u9DB4\u9DC2\u9DB8\u9E9D\u9EEF\u9F19\u9F5C\u9F66\u9F67\u513C\u513B\u56C8\u56CA\u56C9\u5B7F\u5DD4\u5DD2\u5F4E\u61FF\u6524\u6B0A\u6B61\u7051\u7058\u7380\u74E4\u758A\u766E\u766C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u79B3\u7C60\u7C5F\u807E\u807D\u81DF\u8972\u896F\u89FC\u8B80\u8D16\u8D17\u8E91\u8E93\u8F61\u9148\u9444\u9451\u9452\u973D\u973E\u97C3\u97C1\u986B\u9955\u9A55\u9A4D\u9AD2\u9B1A\u9C49\u9C31\u9C3E\u9C3B\u9DD3\u9DD7\u9F34\u9F6C\u9F6A\u9F94\u56CC\u5DD6\u6200\u6523\u652B\u652A\u66EC\u6B10\u74DA\u7ACA\u7C64\u7C63\u7C65\u7E93\u7E96\u7E94\u81E2\u8638\u863F\u8831\u8B8A\u9090\u908F\u9463\u9460\u9464\u9768\u986F\u995C\u9A5A\u9A5B\u9A57\u9AD3\u9AD4\u9AD1\u9C54\u9C57\u9C56\u9DE5\u9E9F\u9EF4\u56D1\u58E9\u652C\u705E\u7671\u7672\u77D7\u7F50\u7F88\u8836\u8839\u8862\u8B93\u8B92\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B96\u8277\u8D1B\u91C0\u946A\u9742\u9748\u9744\u97C6\u9870\u9A5F\u9B22\u9B58\u9C5F\u9DF9\u9DFA\u9E7C\u9E7D\u9F07\u9F77\u9F72\u5EF3\u6B16\u7063\u7C6C\u7C6E\u883B\u89C0\u8EA1\u91C1\u9472\u9470\u9871\u995E\u9AD6\u9B23\u9ECC\u7064\u77DA\u8B9A\u9477\u97C9\u9A62\u9A65\u7E9C\u8B9C\u8EAA\u91C5\u947D\u947E\u947C\u9C77\u9C78\u9EF7\u8C54\u947F\u9E1A\u7228\u9A6A\u9B31\u9E1B\u9E1E\u7C72\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[201] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E42\u4E5C\u51F5\u531A\u5382\u4E07\u4E0C\u4E47\u4E8D\u56D7\uFA0C\u5C6E\u5F73\u4E0F\u5187\u4E0E\u4E2E\u4E93\u4EC2\u4EC9\u4EC8\u5198\u52FC\u536C\u53B9\u5720\u5903\u592C\u5C10\u5DFF\u65E1\u6BB3\u6BCC\u6C14\u723F\u4E31\u4E3C\u4EE8\u4EDC\u4EE9\u4EE1\u4EDD\u4EDA\u520C\u531C\u534C\u5722\u5723\u5917\u592F\u5B81\u5B84\u5C12\u5C3B\u5C74\u5C73\u5E04\u5E80\u5E82\u5FC9\u6209\u6250\u6C15\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C36\u6C43\u6C3F\u6C3B\u72AE\u72B0\u738A\u79B8\u808A\u961E\u4F0E\u4F18\u4F2C\u4EF5\u4F14\u4EF1\u4F00\u4EF7\u4F08\u4F1D\u4F02\u4F05\u4F22\u4F13\u4F04\u4EF4\u4F12\u51B1\u5213\u5209\u5210\u52A6\u5322\u531F\u534D\u538A\u5407\u56E1\u56DF\u572E\u572A\u5734\u593C\u5980\u597C\u5985\u597B\u597E\u5977\u597F\u5B56\u5C15\u5C25\u5C7C\u5C7A\u5C7B\u5C7E\u5DDF\u5E75\u5E84\u5F02\u5F1A\u5F74\u5FD5\u5FD4\u5FCF\u625C\u625E\u6264\u6261\u6266\u6262\u6259\u6260\u625A\u6265\u65EF\u65EE\u673E\u6739\u6738\u673B\u673A\u673F\u673C\u6733\u6C18\u6C46\u6C52\u6C5C\u6C4F\u6C4A\u6C54\u6C4B\uFFFD".split("");
    for(j = 0; j != D[201].length; ++j)if (D[201][j].charCodeAt(0) !== 0xFFFD) {
        e[D[201][j]] = 51456 + j;
        d[51456 + j] = D[201][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C4C\u7071\u725E\u72B4\u72B5\u738E\u752A\u767F\u7A75\u7F51\u8278\u827C\u8280\u827D\u827F\u864D\u897E\u9099\u9097\u9098\u909B\u9094\u9622\u9624\u9620\u9623\u4F56\u4F3B\u4F62\u4F49\u4F53\u4F64\u4F3E\u4F67\u4F52\u4F5F\u4F41\u4F58\u4F2D\u4F33\u4F3F\u4F61\u518F\u51B9\u521C\u521E\u5221\u52AD\u52AE\u5309\u5363\u5372\u538E\u538F\u5430\u5437\u542A\u5454\u5445\u5419\u541C\u5425\u5418\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u543D\u544F\u5441\u5428\u5424\u5447\u56EE\u56E7\u56E5\u5741\u5745\u574C\u5749\u574B\u5752\u5906\u5940\u59A6\u5998\u59A0\u5997\u598E\u59A2\u5990\u598F\u59A7\u59A1\u5B8E\u5B92\u5C28\u5C2A\u5C8D\u5C8F\u5C88\u5C8B\u5C89\u5C92\u5C8A\u5C86\u5C93\u5C95\u5DE0\u5E0A\u5E0E\u5E8B\u5E89\u5E8C\u5E88\u5E8D\u5F05\u5F1D\u5F78\u5F76\u5FD2\u5FD1\u5FD0\u5FED\u5FE8\u5FEE\u5FF3\u5FE1\u5FE4\u5FE3\u5FFA\u5FEF\u5FF7\u5FFB\u6000\u5FF4\u623A\u6283\u628C\u628E\u628F\u6294\u6287\u6271\u627B\u627A\u6270\u6281\u6288\u6277\u627D\u6272\u6274\u6537\u65F0\u65F4\u65F3\u65F2\u65F5\u6745\u6747\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6759\u6755\u674C\u6748\u675D\u674D\u675A\u674B\u6BD0\u6C19\u6C1A\u6C78\u6C67\u6C6B\u6C84\u6C8B\u6C8F\u6C71\u6C6F\u6C69\u6C9A\u6C6D\u6C87\u6C95\u6C9C\u6C66\u6C73\u6C65\u6C7B\u6C8E\u7074\u707A\u7263\u72BF\u72BD\u72C3\u72C6\u72C1\u72BA\u72C5\u7395\u7397\u7393\u7394\u7392\u753A\u7539\u7594\u7595\u7681\u793D\u8034\u8095\u8099\u8090\u8092\u809C\u8290\u828F\u8285\u828E\u8291\u8293\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u828A\u8283\u8284\u8C78\u8FC9\u8FBF\u909F\u90A1\u90A5\u909E\u90A7\u90A0\u9630\u9628\u962F\u962D\u4E33\u4F98\u4F7C\u4F85\u4F7D\u4F80\u4F87\u4F76\u4F74\u4F89\u4F84\u4F77\u4F4C\u4F97\u4F6A\u4F9A\u4F79\u4F81\u4F78\u4F90\u4F9C\u4F94\u4F9E\u4F92\u4F82\u4F95\u4F6B\u4F6E\u519E\u51BC\u51BE\u5235\u5232\u5233\u5246\u5231\u52BC\u530A\u530B\u533C\u5392\u5394\u5487\u547F\u5481\u5491\u5482\u5488\u546B\u547A\u547E\u5465\u546C\u5474\u5466\u548D\u546F\u5461\u5460\u5498\u5463\u5467\u5464\u56F7\u56F9\u576F\u5772\u576D\u576B\u5771\u5770\u5776\u5780\u5775\u577B\u5773\u5774\u5762\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5768\u577D\u590C\u5945\u59B5\u59BA\u59CF\u59CE\u59B2\u59CC\u59C1\u59B6\u59BC\u59C3\u59D6\u59B1\u59BD\u59C0\u59C8\u59B4\u59C7\u5B62\u5B65\u5B93\u5B95\u5C44\u5C47\u5CAE\u5CA4\u5CA0\u5CB5\u5CAF\u5CA8\u5CAC\u5C9F\u5CA3\u5CAD\u5CA2\u5CAA\u5CA7\u5C9D\u5CA5\u5CB6\u5CB0\u5CA6\u5E17\u5E14\u5E19\u5F28\u5F22\u5F23\u5F24\u5F54\u5F82\u5F7E\u5F7D\u5FDE\u5FE5\u602D\u6026\u6019\u6032\u600B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6034\u600A\u6017\u6033\u601A\u601E\u602C\u6022\u600D\u6010\u602E\u6013\u6011\u600C\u6009\u601C\u6214\u623D\u62AD\u62B4\u62D1\u62BE\u62AA\u62B6\u62CA\u62AE\u62B3\u62AF\u62BB\u62A9\u62B0\u62B8\u653D\u65A8\u65BB\u6609\u65FC\u6604\u6612\u6608\u65FB\u6603\u660B\u660D\u6605\u65FD\u6611\u6610\u66F6\u670A\u6785\u676C\u678E\u6792\u6776\u677B\u6798\u6786\u6784\u6774\u678D\u678C\u677A\u679F\u6791\u6799\u6783\u677D\u6781\u6778\u6779\u6794\u6B25\u6B80\u6B7E\u6BDE\u6C1D\u6C93\u6CEC\u6CEB\u6CEE\u6CD9\u6CB6\u6CD4\u6CAD\u6CE7\u6CB7\u6CD0\u6CC2\u6CBA\u6CC3\u6CC6\u6CED\u6CF2\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6CD2\u6CDD\u6CB4\u6C8A\u6C9D\u6C80\u6CDE\u6CC0\u6D30\u6CCD\u6CC7\u6CB0\u6CF9\u6CCF\u6CE9\u6CD1\u7094\u7098\u7085\u7093\u7086\u7084\u7091\u7096\u7082\u709A\u7083\u726A\u72D6\u72CB\u72D8\u72C9\u72DC\u72D2\u72D4\u72DA\u72CC\u72D1\u73A4\u73A1\u73AD\u73A6\u73A2\u73A0\u73AC\u739D\u74DD\u74E8\u753F\u7540\u753E\u758C\u7598\u76AF\u76F3\u76F1\u76F0\u76F5\u77F8\u77FC\u77F9\u77FB\u77FA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77F7\u7942\u793F\u79C5\u7A78\u7A7B\u7AFB\u7C75\u7CFD\u8035\u808F\u80AE\u80A3\u80B8\u80B5\u80AD\u8220\u82A0\u82C0\u82AB\u829A\u8298\u829B\u82B5\u82A7\u82AE\u82BC\u829E\u82BA\u82B4\u82A8\u82A1\u82A9\u82C2\u82A4\u82C3\u82B6\u82A2\u8670\u866F\u866D\u866E\u8C56\u8FD2\u8FCB\u8FD3\u8FCD\u8FD6\u8FD5\u8FD7\u90B2\u90B4\u90AF\u90B3\u90B0\u9639\u963D\u963C\u963A\u9643\u4FCD\u4FC5\u4FD3\u4FB2\u4FC9\u4FCB\u4FC1\u4FD4\u4FDC\u4FD9\u4FBB\u4FB3\u4FDB\u4FC7\u4FD6\u4FBA\u4FC0\u4FB9\u4FEC\u5244\u5249\u52C0\u52C2\u533D\u537C\u5397\u5396\u5399\u5398\u54BA\u54A1\u54AD\u54A5\u54CF\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54C3\u830D\u54B7\u54AE\u54D6\u54B6\u54C5\u54C6\u54A0\u5470\u54BC\u54A2\u54BE\u5472\u54DE\u54B0\u57B5\u579E\u579F\u57A4\u578C\u5797\u579D\u579B\u5794\u5798\u578F\u5799\u57A5\u579A\u5795\u58F4\u590D\u5953\u59E1\u59DE\u59EE\u5A00\u59F1\u59DD\u59FA\u59FD\u59FC\u59F6\u59E4\u59F2\u59F7\u59DB\u59E9\u59F3\u59F5\u59E0\u59FE\u59F4\u59ED\u5BA8\u5C4C\u5CD0\u5CD8\u5CCC\u5CD7\u5CCB\u5CDB\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5CDE\u5CDA\u5CC9\u5CC7\u5CCA\u5CD6\u5CD3\u5CD4\u5CCF\u5CC8\u5CC6\u5CCE\u5CDF\u5CF8\u5DF9\u5E21\u5E22\u5E23\u5E20\u5E24\u5EB0\u5EA4\u5EA2\u5E9B\u5EA3\u5EA5\u5F07\u5F2E\u5F56\u5F86\u6037\u6039\u6054\u6072\u605E\u6045\u6053\u6047\u6049\u605B\u604C\u6040\u6042\u605F\u6024\u6044\u6058\u6066\u606E\u6242\u6243\u62CF\u630D\u630B\u62F5\u630E\u6303\u62EB\u62F9\u630F\u630C\u62F8\u62F6\u6300\u6313\u6314\u62FA\u6315\u62FB\u62F0\u6541\u6543\u65AA\u65BF\u6636\u6621\u6632\u6635\u661C\u6626\u6622\u6633\u662B\u663A\u661D\u6634\u6639\u662E\u670F\u6710\u67C1\u67F2\u67C8\u67BA\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u67DC\u67BB\u67F8\u67D8\u67C0\u67B7\u67C5\u67EB\u67E4\u67DF\u67B5\u67CD\u67B3\u67F7\u67F6\u67EE\u67E3\u67C2\u67B9\u67CE\u67E7\u67F0\u67B2\u67FC\u67C6\u67ED\u67CC\u67AE\u67E6\u67DB\u67FA\u67C9\u67CA\u67C3\u67EA\u67CB\u6B28\u6B82\u6B84\u6BB6\u6BD6\u6BD8\u6BE0\u6C20\u6C21\u6D28\u6D34\u6D2D\u6D1F\u6D3C\u6D3F\u6D12\u6D0A\u6CDA\u6D33\u6D04\u6D19\u6D3A\u6D1A\u6D11\u6D00\u6D1D\u6D42\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D01\u6D18\u6D37\u6D03\u6D0F\u6D40\u6D07\u6D20\u6D2C\u6D08\u6D22\u6D09\u6D10\u70B7\u709F\u70BE\u70B1\u70B0\u70A1\u70B4\u70B5\u70A9\u7241\u7249\u724A\u726C\u7270\u7273\u726E\u72CA\u72E4\u72E8\u72EB\u72DF\u72EA\u72E6\u72E3\u7385\u73CC\u73C2\u73C8\u73C5\u73B9\u73B6\u73B5\u73B4\u73EB\u73BF\u73C7\u73BE\u73C3\u73C6\u73B8\u73CB\u74EC\u74EE\u752E\u7547\u7548\u75A7\u75AA\u7679\u76C4\u7708\u7703\u7704\u7705\u770A\u76F7\u76FB\u76FA\u77E7\u77E8\u7806\u7811\u7812\u7805\u7810\u780F\u780E\u7809\u7803\u7813\u794A\u794C\u794B\u7945\u7944\u79D5\u79CD\u79CF\u79D6\u79CE\u7A80\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A7E\u7AD1\u7B00\u7B01\u7C7A\u7C78\u7C79\u7C7F\u7C80\u7C81\u7D03\u7D08\u7D01\u7F58\u7F91\u7F8D\u7FBE\u8007\u800E\u800F\u8014\u8037\u80D8\u80C7\u80E0\u80D1\u80C8\u80C2\u80D0\u80C5\u80E3\u80D9\u80DC\u80CA\u80D5\u80C9\u80CF\u80D7\u80E6\u80CD\u81FF\u8221\u8294\u82D9\u82FE\u82F9\u8307\u82E8\u8300\u82D5\u833A\u82EB\u82D6\u82F4\u82EC\u82E1\u82F2\u82F5\u830C\u82FB\u82F6\u82F0\u82EA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u82E4\u82E0\u82FA\u82F3\u82ED\u8677\u8674\u867C\u8673\u8841\u884E\u8867\u886A\u8869\u89D3\u8A04\u8A07\u8D72\u8FE3\u8FE1\u8FEE\u8FE0\u90F1\u90BD\u90BF\u90D5\u90C5\u90BE\u90C7\u90CB\u90C8\u91D4\u91D3\u9654\u964F\u9651\u9653\u964A\u964E\u501E\u5005\u5007\u5013\u5022\u5030\u501B\u4FF5\u4FF4\u5033\u5037\u502C\u4FF6\u4FF7\u5017\u501C\u5020\u5027\u5035\u502F\u5031\u500E\u515A\u5194\u5193\u51CA\u51C4\u51C5\u51C8\u51CE\u5261\u525A\u5252\u525E\u525F\u5255\u5262\u52CD\u530E\u539E\u5526\u54E2\u5517\u5512\u54E7\u54F3\u54E4\u551A\u54FF\u5504\u5508\u54EB\u5511\u5505\u54F1\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u550A\u54FB\u54F7\u54F8\u54E0\u550E\u5503\u550B\u5701\u5702\u57CC\u5832\u57D5\u57D2\u57BA\u57C6\u57BD\u57BC\u57B8\u57B6\u57BF\u57C7\u57D0\u57B9\u57C1\u590E\u594A\u5A19\u5A16\u5A2D\u5A2E\u5A15\u5A0F\u5A17\u5A0A\u5A1E\u5A33\u5B6C\u5BA7\u5BAD\u5BAC\u5C03\u5C56\u5C54\u5CEC\u5CFF\u5CEE\u5CF1\u5CF7\u5D00\u5CF9\u5E29\u5E28\u5EA8\u5EAE\u5EAA\u5EAC\u5F33\u5F30\u5F67\u605D\u605A\u6067\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6041\u60A2\u6088\u6080\u6092\u6081\u609D\u6083\u6095\u609B\u6097\u6087\u609C\u608E\u6219\u6246\u62F2\u6310\u6356\u632C\u6344\u6345\u6336\u6343\u63E4\u6339\u634B\u634A\u633C\u6329\u6341\u6334\u6358\u6354\u6359\u632D\u6347\u6333\u635A\u6351\u6338\u6357\u6340\u6348\u654A\u6546\u65C6\u65C3\u65C4\u65C2\u664A\u665F\u6647\u6651\u6712\u6713\u681F\u681A\u6849\u6832\u6833\u683B\u684B\u684F\u6816\u6831\u681C\u6835\u682B\u682D\u682F\u684E\u6844\u6834\u681D\u6812\u6814\u6826\u6828\u682E\u684D\u683A\u6825\u6820\u6B2C\u6B2F\u6B2D\u6B31\u6B34\u6B6D\u8082\u6B88\u6BE6\u6BE4\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6BE8\u6BE3\u6BE2\u6BE7\u6C25\u6D7A\u6D63\u6D64\u6D76\u6D0D\u6D61\u6D92\u6D58\u6D62\u6D6D\u6D6F\u6D91\u6D8D\u6DEF\u6D7F\u6D86\u6D5E\u6D67\u6D60\u6D97\u6D70\u6D7C\u6D5F\u6D82\u6D98\u6D2F\u6D68\u6D8B\u6D7E\u6D80\u6D84\u6D16\u6D83\u6D7B\u6D7D\u6D75\u6D90\u70DC\u70D3\u70D1\u70DD\u70CB\u7F39\u70E2\u70D7\u70D2\u70DE\u70E0\u70D4\u70CD\u70C5\u70C6\u70C7\u70DA\u70CE\u70E1\u7242\u7278\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7277\u7276\u7300\u72FA\u72F4\u72FE\u72F6\u72F3\u72FB\u7301\u73D3\u73D9\u73E5\u73D6\u73BC\u73E7\u73E3\u73E9\u73DC\u73D2\u73DB\u73D4\u73DD\u73DA\u73D7\u73D8\u73E8\u74DE\u74DF\u74F4\u74F5\u7521\u755B\u755F\u75B0\u75C1\u75BB\u75C4\u75C0\u75BF\u75B6\u75BA\u768A\u76C9\u771D\u771B\u7710\u7713\u7712\u7723\u7711\u7715\u7719\u771A\u7722\u7727\u7823\u782C\u7822\u7835\u782F\u7828\u782E\u782B\u7821\u7829\u7833\u782A\u7831\u7954\u795B\u794F\u795C\u7953\u7952\u7951\u79EB\u79EC\u79E0\u79EE\u79ED\u79EA\u79DC\u79DE\u79DD\u7A86\u7A89\u7A85\u7A8B\u7A8C\u7A8A\u7A87\u7AD8\u7B10\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7B04\u7B13\u7B05\u7B0F\u7B08\u7B0A\u7B0E\u7B09\u7B12\u7C84\u7C91\u7C8A\u7C8C\u7C88\u7C8D\u7C85\u7D1E\u7D1D\u7D11\u7D0E\u7D18\u7D16\u7D13\u7D1F\u7D12\u7D0F\u7D0C\u7F5C\u7F61\u7F5E\u7F60\u7F5D\u7F5B\u7F96\u7F92\u7FC3\u7FC2\u7FC0\u8016\u803E\u8039\u80FA\u80F2\u80F9\u80F5\u8101\u80FB\u8100\u8201\u822F\u8225\u8333\u832D\u8344\u8319\u8351\u8325\u8356\u833F\u8341\u8326\u831C\u8322\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8342\u834E\u831B\u832A\u8308\u833C\u834D\u8316\u8324\u8320\u8337\u832F\u8329\u8347\u8345\u834C\u8353\u831E\u832C\u834B\u8327\u8348\u8653\u8652\u86A2\u86A8\u8696\u868D\u8691\u869E\u8687\u8697\u8686\u868B\u869A\u8685\u86A5\u8699\u86A1\u86A7\u8695\u8698\u868E\u869D\u8690\u8694\u8843\u8844\u886D\u8875\u8876\u8872\u8880\u8871\u887F\u886F\u8883\u887E\u8874\u887C\u8A12\u8C47\u8C57\u8C7B\u8CA4\u8CA3\u8D76\u8D78\u8DB5\u8DB7\u8DB6\u8ED1\u8ED3\u8FFE\u8FF5\u9002\u8FFF\u8FFB\u9004\u8FFC\u8FF6\u90D6\u90E0\u90D9\u90DA\u90E3\u90DF\u90E5\u90D8\u90DB\u90D7\u90DC\u90E4\u9150\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u914E\u914F\u91D5\u91E2\u91DA\u965C\u965F\u96BC\u98E3\u9ADF\u9B2F\u4E7F\u5070\u506A\u5061\u505E\u5060\u5053\u504B\u505D\u5072\u5048\u504D\u5041\u505B\u504A\u5062\u5015\u5045\u505F\u5069\u506B\u5063\u5064\u5046\u5040\u506E\u5073\u5057\u5051\u51D0\u526B\u526D\u526C\u526E\u52D6\u52D3\u532D\u539C\u5575\u5576\u553C\u554D\u5550\u5534\u552A\u5551\u5562\u5536\u5535\u5530\u5552\u5545\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u550C\u5532\u5565\u554E\u5539\u5548\u552D\u553B\u5540\u554B\u570A\u5707\u57FB\u5814\u57E2\u57F6\u57DC\u57F4\u5800\u57ED\u57FD\u5808\u57F8\u580B\u57F3\u57CF\u5807\u57EE\u57E3\u57F2\u57E5\u57EC\u57E1\u580E\u57FC\u5810\u57E7\u5801\u580C\u57F1\u57E9\u57F0\u580D\u5804\u595C\u5A60\u5A58\u5A55\u5A67\u5A5E\u5A38\u5A35\u5A6D\u5A50\u5A5F\u5A65\u5A6C\u5A53\u5A64\u5A57\u5A43\u5A5D\u5A52\u5A44\u5A5B\u5A48\u5A8E\u5A3E\u5A4D\u5A39\u5A4C\u5A70\u5A69\u5A47\u5A51\u5A56\u5A42\u5A5C\u5B72\u5B6E\u5BC1\u5BC0\u5C59\u5D1E\u5D0B\u5D1D\u5D1A\u5D20\u5D0C\u5D28\u5D0D\u5D26\u5D25\u5D0F\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5D30\u5D12\u5D23\u5D1F\u5D2E\u5E3E\u5E34\u5EB1\u5EB4\u5EB9\u5EB2\u5EB3\u5F36\u5F38\u5F9B\u5F96\u5F9F\u608A\u6090\u6086\u60BE\u60B0\u60BA\u60D3\u60D4\u60CF\u60E4\u60D9\u60DD\u60C8\u60B1\u60DB\u60B7\u60CA\u60BF\u60C3\u60CD\u60C0\u6332\u6365\u638A\u6382\u637D\u63BD\u639E\u63AD\u639D\u6397\u63AB\u638E\u636F\u6387\u6390\u636E\u63AF\u6375\u639C\u636D\u63AE\u637C\u63A4\u633B\u639F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6378\u6385\u6381\u6391\u638D\u6370\u6553\u65CD\u6665\u6661\u665B\u6659\u665C\u6662\u6718\u6879\u6887\u6890\u689C\u686D\u686E\u68AE\u68AB\u6956\u686F\u68A3\u68AC\u68A9\u6875\u6874\u68B2\u688F\u6877\u6892\u687C\u686B\u6872\u68AA\u6880\u6871\u687E\u689B\u6896\u688B\u68A0\u6889\u68A4\u6878\u687B\u6891\u688C\u688A\u687D\u6B36\u6B33\u6B37\u6B38\u6B91\u6B8F\u6B8D\u6B8E\u6B8C\u6C2A\u6DC0\u6DAB\u6DB4\u6DB3\u6E74\u6DAC\u6DE9\u6DE2\u6DB7\u6DF6\u6DD4\u6E00\u6DC8\u6DE0\u6DDF\u6DD6\u6DBE\u6DE5\u6DDC\u6DDD\u6DDB\u6DF4\u6DCA\u6DBD\u6DED\u6DF0\u6DBA\u6DD5\u6DC2\u6DCF\u6DC9\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6DD0\u6DF2\u6DD3\u6DFD\u6DD7\u6DCD\u6DE3\u6DBB\u70FA\u710D\u70F7\u7117\u70F4\u710C\u70F0\u7104\u70F3\u7110\u70FC\u70FF\u7106\u7113\u7100\u70F8\u70F6\u710B\u7102\u710E\u727E\u727B\u727C\u727F\u731D\u7317\u7307\u7311\u7318\u730A\u7308\u72FF\u730F\u731E\u7388\u73F6\u73F8\u73F5\u7404\u7401\u73FD\u7407\u7400\u73FA\u73FC\u73FF\u740C\u740B\u73F4\u7408\u7564\u7563\u75CE\u75D2\u75CF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u75CB\u75CC\u75D1\u75D0\u768F\u7689\u76D3\u7739\u772F\u772D\u7731\u7732\u7734\u7733\u773D\u7725\u773B\u7735\u7848\u7852\u7849\u784D\u784A\u784C\u7826\u7845\u7850\u7964\u7967\u7969\u796A\u7963\u796B\u7961\u79BB\u79FA\u79F8\u79F6\u79F7\u7A8F\u7A94\u7A90\u7B35\u7B47\u7B34\u7B25\u7B30\u7B22\u7B24\u7B33\u7B18\u7B2A\u7B1D\u7B31\u7B2B\u7B2D\u7B2F\u7B32\u7B38\u7B1A\u7B23\u7C94\u7C98\u7C96\u7CA3\u7D35\u7D3D\u7D38\u7D36\u7D3A\u7D45\u7D2C\u7D29\u7D41\u7D47\u7D3E\u7D3F\u7D4A\u7D3B\u7D28\u7F63\u7F95\u7F9C\u7F9D\u7F9B\u7FCA\u7FCB\u7FCD\u7FD0\u7FD1\u7FC7\u7FCF\u7FC9\u801F\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u801E\u801B\u8047\u8043\u8048\u8118\u8125\u8119\u811B\u812D\u811F\u812C\u811E\u8121\u8115\u8127\u811D\u8122\u8211\u8238\u8233\u823A\u8234\u8232\u8274\u8390\u83A3\u83A8\u838D\u837A\u8373\u83A4\u8374\u838F\u8381\u8395\u8399\u8375\u8394\u83A9\u837D\u8383\u838C\u839D\u839B\u83AA\u838B\u837E\u83A5\u83AF\u8388\u8397\u83B0\u837F\u83A6\u8387\u83AE\u8376\u839A\u8659\u8656\u86BF\u86B7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u86C2\u86C1\u86C5\u86BA\u86B0\u86C8\u86B9\u86B3\u86B8\u86CC\u86B4\u86BB\u86BC\u86C3\u86BD\u86BE\u8852\u8889\u8895\u88A8\u88A2\u88AA\u889A\u8891\u88A1\u889F\u8898\u88A7\u8899\u889B\u8897\u88A4\u88AC\u888C\u8893\u888E\u8982\u89D6\u89D9\u89D5\u8A30\u8A27\u8A2C\u8A1E\u8C39\u8C3B\u8C5C\u8C5D\u8C7D\u8CA5\u8D7D\u8D7B\u8D79\u8DBC\u8DC2\u8DB9\u8DBF\u8DC1\u8ED8\u8EDE\u8EDD\u8EDC\u8ED7\u8EE0\u8EE1\u9024\u900B\u9011\u901C\u900C\u9021\u90EF\u90EA\u90F0\u90F4\u90F2\u90F3\u90D4\u90EB\u90EC\u90E9\u9156\u9158\u915A\u9153\u9155\u91EC\u91F4\u91F1\u91F3\u91F8\u91E4\u91F9\u91EA\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u91EB\u91F7\u91E8\u91EE\u957A\u9586\u9588\u967C\u966D\u966B\u9671\u966F\u96BF\u976A\u9804\u98E5\u9997\u509B\u5095\u5094\u509E\u508B\u50A3\u5083\u508C\u508E\u509D\u5068\u509C\u5092\u5082\u5087\u515F\u51D4\u5312\u5311\u53A4\u53A7\u5591\u55A8\u55A5\u55AD\u5577\u5645\u55A2\u5593\u5588\u558F\u55B5\u5581\u55A3\u5592\u55A4\u557D\u558C\u55A6\u557F\u5595\u55A1\u558E\u570C\u5829\u5837\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5819\u581E\u5827\u5823\u5828\u57F5\u5848\u5825\u581C\u581B\u5833\u583F\u5836\u582E\u5839\u5838\u582D\u582C\u583B\u5961\u5AAF\u5A94\u5A9F\u5A7A\u5AA2\u5A9E\u5A78\u5AA6\u5A7C\u5AA5\u5AAC\u5A95\u5AAE\u5A37\u5A84\u5A8A\u5A97\u5A83\u5A8B\u5AA9\u5A7B\u5A7D\u5A8C\u5A9C\u5A8F\u5A93\u5A9D\u5BEA\u5BCD\u5BCB\u5BD4\u5BD1\u5BCA\u5BCE\u5C0C\u5C30\u5D37\u5D43\u5D6B\u5D41\u5D4B\u5D3F\u5D35\u5D51\u5D4E\u5D55\u5D33\u5D3A\u5D52\u5D3D\u5D31\u5D59\u5D42\u5D39\u5D49\u5D38\u5D3C\u5D32\u5D36\u5D40\u5D45\u5E44\u5E41\u5F58\u5FA6\u5FA5\u5FAB\u60C9\u60B9\u60CC\u60E2\u60CE\u60C4\u6114\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u60F2\u610A\u6116\u6105\u60F5\u6113\u60F8\u60FC\u60FE\u60C1\u6103\u6118\u611D\u6110\u60FF\u6104\u610B\u624A\u6394\u63B1\u63B0\u63CE\u63E5\u63E8\u63EF\u63C3\u649D\u63F3\u63CA\u63E0\u63F6\u63D5\u63F2\u63F5\u6461\u63DF\u63BE\u63DD\u63DC\u63C4\u63D8\u63D3\u63C2\u63C7\u63CC\u63CB\u63C8\u63F0\u63D7\u63D9\u6532\u6567\u656A\u6564\u655C\u6568\u6565\u658C\u659D\u659E\u65AE\u65D0\u65D2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u667C\u666C\u667B\u6680\u6671\u6679\u666A\u6672\u6701\u690C\u68D3\u6904\u68DC\u692A\u68EC\u68EA\u68F1\u690F\u68D6\u68F7\u68EB\u68E4\u68F6\u6913\u6910\u68F3\u68E1\u6907\u68CC\u6908\u6970\u68B4\u6911\u68EF\u68C6\u6914\u68F8\u68D0\u68FD\u68FC\u68E8\u690B\u690A\u6917\u68CE\u68C8\u68DD\u68DE\u68E6\u68F4\u68D1\u6906\u68D4\u68E9\u6915\u6925\u68C7\u6B39\u6B3B\u6B3F\u6B3C\u6B94\u6B97\u6B99\u6B95\u6BBD\u6BF0\u6BF2\u6BF3\u6C30\u6DFC\u6E46\u6E47\u6E1F\u6E49\u6E88\u6E3C\u6E3D\u6E45\u6E62\u6E2B\u6E3F\u6E41\u6E5D\u6E73\u6E1C\u6E33\u6E4B\u6E40\u6E51\u6E3B\u6E03\u6E2E\u6E5E\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6E68\u6E5C\u6E61\u6E31\u6E28\u6E60\u6E71\u6E6B\u6E39\u6E22\u6E30\u6E53\u6E65\u6E27\u6E78\u6E64\u6E77\u6E55\u6E79\u6E52\u6E66\u6E35\u6E36\u6E5A\u7120\u711E\u712F\u70FB\u712E\u7131\u7123\u7125\u7122\u7132\u711F\u7128\u713A\u711B\u724B\u725A\u7288\u7289\u7286\u7285\u728B\u7312\u730B\u7330\u7322\u7331\u7333\u7327\u7332\u732D\u7326\u7323\u7335\u730C\u742E\u742C\u7430\u742B\u7416\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u741A\u7421\u742D\u7431\u7424\u7423\u741D\u7429\u7420\u7432\u74FB\u752F\u756F\u756C\u75E7\u75DA\u75E1\u75E6\u75DD\u75DF\u75E4\u75D7\u7695\u7692\u76DA\u7746\u7747\u7744\u774D\u7745\u774A\u774E\u774B\u774C\u77DE\u77EC\u7860\u7864\u7865\u785C\u786D\u7871\u786A\u786E\u7870\u7869\u7868\u785E\u7862\u7974\u7973\u7972\u7970\u7A02\u7A0A\u7A03\u7A0C\u7A04\u7A99\u7AE6\u7AE4\u7B4A\u7B3B\u7B44\u7B48\u7B4C\u7B4E\u7B40\u7B58\u7B45\u7CA2\u7C9E\u7CA8\u7CA1\u7D58\u7D6F\u7D63\u7D53\u7D56\u7D67\u7D6A\u7D4F\u7D6D\u7D5C\u7D6B\u7D52\u7D54\u7D69\u7D51\u7D5F\u7D4E\u7F3E\u7F3F\u7F65\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7F66\u7FA2\u7FA0\u7FA1\u7FD7\u8051\u804F\u8050\u80FE\u80D4\u8143\u814A\u8152\u814F\u8147\u813D\u814D\u813A\u81E6\u81EE\u81F7\u81F8\u81F9\u8204\u823C\u823D\u823F\u8275\u833B\u83CF\u83F9\u8423\u83C0\u83E8\u8412\u83E7\u83E4\u83FC\u83F6\u8410\u83C6\u83C8\u83EB\u83E3\u83BF\u8401\u83DD\u83E5\u83D8\u83FF\u83E1\u83CB\u83CE\u83D6\u83F5\u83C9\u8409\u840F\u83DE\u8411\u8406\u83C2\u83F3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u83D5\u83FA\u83C7\u83D1\u83EA\u8413\u83C3\u83EC\u83EE\u83C4\u83FB\u83D7\u83E2\u841B\u83DB\u83FE\u86D8\u86E2\u86E6\u86D3\u86E3\u86DA\u86EA\u86DD\u86EB\u86DC\u86EC\u86E9\u86D7\u86E8\u86D1\u8848\u8856\u8855\u88BA\u88D7\u88B9\u88B8\u88C0\u88BE\u88B6\u88BC\u88B7\u88BD\u88B2\u8901\u88C9\u8995\u8998\u8997\u89DD\u89DA\u89DB\u8A4E\u8A4D\u8A39\u8A59\u8A40\u8A57\u8A58\u8A44\u8A45\u8A52\u8A48\u8A51\u8A4A\u8A4C\u8A4F\u8C5F\u8C81\u8C80\u8CBA\u8CBE\u8CB0\u8CB9\u8CB5\u8D84\u8D80\u8D89\u8DD8\u8DD3\u8DCD\u8DC7\u8DD6\u8DDC\u8DCF\u8DD5\u8DD9\u8DC8\u8DD7\u8DC5\u8EEF\u8EF7\u8EFA\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8EF9\u8EE6\u8EEE\u8EE5\u8EF5\u8EE7\u8EE8\u8EF6\u8EEB\u8EF1\u8EEC\u8EF4\u8EE9\u902D\u9034\u902F\u9106\u912C\u9104\u90FF\u90FC\u9108\u90F9\u90FB\u9101\u9100\u9107\u9105\u9103\u9161\u9164\u915F\u9162\u9160\u9201\u920A\u9225\u9203\u921A\u9226\u920F\u920C\u9200\u9212\u91FF\u91FD\u9206\u9204\u9227\u9202\u921C\u9224\u9219\u9217\u9205\u9216\u957B\u958D\u958C\u9590\u9687\u967E\u9688\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9689\u9683\u9680\u96C2\u96C8\u96C3\u96F1\u96F0\u976C\u9770\u976E\u9807\u98A9\u98EB\u9CE6\u9EF9\u4E83\u4E84\u4EB6\u50BD\u50BF\u50C6\u50AE\u50C4\u50CA\u50B4\u50C8\u50C2\u50B0\u50C1\u50BA\u50B1\u50CB\u50C9\u50B6\u50B8\u51D7\u527A\u5278\u527B\u527C\u55C3\u55DB\u55CC\u55D0\u55CB\u55CA\u55DD\u55C0\u55D4\u55C4\u55E9\u55BF\u55D2\u558D\u55CF\u55D5\u55E2\u55D6\u55C8\u55F2\u55CD\u55D9\u55C2\u5714\u5853\u5868\u5864\u584F\u584D\u5849\u586F\u5855\u584E\u585D\u5859\u5865\u585B\u583D\u5863\u5871\u58FC\u5AC7\u5AC4\u5ACB\u5ABA\u5AB8\u5AB1\u5AB5\u5AB0\u5ABF\u5AC8\u5ABB\u5AC6\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5AB7\u5AC0\u5ACA\u5AB4\u5AB6\u5ACD\u5AB9\u5A90\u5BD6\u5BD8\u5BD9\u5C1F\u5C33\u5D71\u5D63\u5D4A\u5D65\u5D72\u5D6C\u5D5E\u5D68\u5D67\u5D62\u5DF0\u5E4F\u5E4E\u5E4A\u5E4D\u5E4B\u5EC5\u5ECC\u5EC6\u5ECB\u5EC7\u5F40\u5FAF\u5FAD\u60F7\u6149\u614A\u612B\u6145\u6136\u6132\u612E\u6146\u612F\u614F\u6129\u6140\u6220\u9168\u6223\u6225\u6224\u63C5\u63F1\u63EB\u6410\u6412\u6409\u6420\u6424\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6433\u6443\u641F\u6415\u6418\u6439\u6437\u6422\u6423\u640C\u6426\u6430\u6428\u6441\u6435\u642F\u640A\u641A\u6440\u6425\u6427\u640B\u63E7\u641B\u642E\u6421\u640E\u656F\u6592\u65D3\u6686\u668C\u6695\u6690\u668B\u668A\u6699\u6694\u6678\u6720\u6966\u695F\u6938\u694E\u6962\u6971\u693F\u6945\u696A\u6939\u6942\u6957\u6959\u697A\u6948\u6949\u6935\u696C\u6933\u693D\u6965\u68F0\u6978\u6934\u6969\u6940\u696F\u6944\u6976\u6958\u6941\u6974\u694C\u693B\u694B\u6937\u695C\u694F\u6951\u6932\u6952\u692F\u697B\u693C\u6B46\u6B45\u6B43\u6B42\u6B48\u6B41\u6B9B\uFA0D\u6BFB\u6BFC\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6BF9\u6BF7\u6BF8\u6E9B\u6ED6\u6EC8\u6E8F\u6EC0\u6E9F\u6E93\u6E94\u6EA0\u6EB1\u6EB9\u6EC6\u6ED2\u6EBD\u6EC1\u6E9E\u6EC9\u6EB7\u6EB0\u6ECD\u6EA6\u6ECF\u6EB2\u6EBE\u6EC3\u6EDC\u6ED8\u6E99\u6E92\u6E8E\u6E8D\u6EA4\u6EA1\u6EBF\u6EB3\u6ED0\u6ECA\u6E97\u6EAE\u6EA3\u7147\u7154\u7152\u7163\u7160\u7141\u715D\u7162\u7172\u7178\u716A\u7161\u7142\u7158\u7143\u714B\u7170\u715F\u7150\u7153\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7144\u714D\u715A\u724F\u728D\u728C\u7291\u7290\u728E\u733C\u7342\u733B\u733A\u7340\u734A\u7349\u7444\u744A\u744B\u7452\u7451\u7457\u7440\u744F\u7450\u744E\u7442\u7446\u744D\u7454\u74E1\u74FF\u74FE\u74FD\u751D\u7579\u7577\u6983\u75EF\u760F\u7603\u75F7\u75FE\u75FC\u75F9\u75F8\u7610\u75FB\u75F6\u75ED\u75F5\u75FD\u7699\u76B5\u76DD\u7755\u775F\u7760\u7752\u7756\u775A\u7769\u7767\u7754\u7759\u776D\u77E0\u7887\u789A\u7894\u788F\u7884\u7895\u7885\u7886\u78A1\u7883\u7879\u7899\u7880\u7896\u787B\u797C\u7982\u797D\u7979\u7A11\u7A18\u7A19\u7A12\u7A17\u7A15\u7A22\u7A13\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A1B\u7A10\u7AA3\u7AA2\u7A9E\u7AEB\u7B66\u7B64\u7B6D\u7B74\u7B69\u7B72\u7B65\u7B73\u7B71\u7B70\u7B61\u7B78\u7B76\u7B63\u7CB2\u7CB4\u7CAF\u7D88\u7D86\u7D80\u7D8D\u7D7F\u7D85\u7D7A\u7D8E\u7D7B\u7D83\u7D7C\u7D8C\u7D94\u7D84\u7D7D\u7D92\u7F6D\u7F6B\u7F67\u7F68\u7F6C\u7FA6\u7FA5\u7FA7\u7FDB\u7FDC\u8021\u8164\u8160\u8177\u815C\u8169\u815B\u8162\u8172\u6721\u815E\u8176\u8167\u816F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8144\u8161\u821D\u8249\u8244\u8240\u8242\u8245\u84F1\u843F\u8456\u8476\u8479\u848F\u848D\u8465\u8451\u8440\u8486\u8467\u8430\u844D\u847D\u845A\u8459\u8474\u8473\u845D\u8507\u845E\u8437\u843A\u8434\u847A\u8443\u8478\u8432\u8445\u8429\u83D9\u844B\u842F\u8442\u842D\u845F\u8470\u8439\u844E\u844C\u8452\u846F\u84C5\u848E\u843B\u8447\u8436\u8433\u8468\u847E\u8444\u842B\u8460\u8454\u846E\u8450\u870B\u8704\u86F7\u870C\u86FA\u86D6\u86F5\u874D\u86F8\u870E\u8709\u8701\u86F6\u870D\u8705\u88D6\u88CB\u88CD\u88CE\u88DE\u88DB\u88DA\u88CC\u88D0\u8985\u899B\u89DF\u89E5\u89E4\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u89E1\u89E0\u89E2\u89DC\u89E6\u8A76\u8A86\u8A7F\u8A61\u8A3F\u8A77\u8A82\u8A84\u8A75\u8A83\u8A81\u8A74\u8A7A\u8C3C\u8C4B\u8C4A\u8C65\u8C64\u8C66\u8C86\u8C84\u8C85\u8CCC\u8D68\u8D69\u8D91\u8D8C\u8D8E\u8D8F\u8D8D\u8D93\u8D94\u8D90\u8D92\u8DF0\u8DE0\u8DEC\u8DF1\u8DEE\u8DD0\u8DE9\u8DE3\u8DE2\u8DE7\u8DF2\u8DEB\u8DF4\u8F06\u8EFF\u8F01\u8F00\u8F05\u8F07\u8F08\u8F02\u8F0B\u9052\u903F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9044\u9049\u903D\u9110\u910D\u910F\u9111\u9116\u9114\u910B\u910E\u916E\u916F\u9248\u9252\u9230\u923A\u9266\u9233\u9265\u925E\u9283\u922E\u924A\u9246\u926D\u926C\u924F\u9260\u9267\u926F\u9236\u9261\u9270\u9231\u9254\u9263\u9250\u9272\u924E\u9253\u924C\u9256\u9232\u959F\u959C\u959E\u959B\u9692\u9693\u9691\u9697\u96CE\u96FA\u96FD\u96F8\u96F5\u9773\u9777\u9778\u9772\u980F\u980D\u980E\u98AC\u98F6\u98F9\u99AF\u99B2\u99B0\u99B5\u9AAD\u9AAB\u9B5B\u9CEA\u9CED\u9CE7\u9E80\u9EFD\u50E6\u50D4\u50D7\u50E8\u50F3\u50DB\u50EA\u50DD\u50E4\u50D3\u50EC\u50F0\u50EF\u50E3\u50E0\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u51D8\u5280\u5281\u52E9\u52EB\u5330\u53AC\u5627\u5615\u560C\u5612\u55FC\u560F\u561C\u5601\u5613\u5602\u55FA\u561D\u5604\u55FF\u55F9\u5889\u587C\u5890\u5898\u5886\u5881\u587F\u5874\u588B\u587A\u5887\u5891\u588E\u5876\u5882\u5888\u587B\u5894\u588F\u58FE\u596B\u5ADC\u5AEE\u5AE5\u5AD5\u5AEA\u5ADA\u5AED\u5AEB\u5AF3\u5AE2\u5AE0\u5ADB\u5AEC\u5ADE\u5ADD\u5AD9\u5AE8\u5ADF\u5B77\u5BE0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5BE3\u5C63\u5D82\u5D80\u5D7D\u5D86\u5D7A\u5D81\u5D77\u5D8A\u5D89\u5D88\u5D7E\u5D7C\u5D8D\u5D79\u5D7F\u5E58\u5E59\u5E53\u5ED8\u5ED1\u5ED7\u5ECE\u5EDC\u5ED5\u5ED9\u5ED2\u5ED4\u5F44\u5F43\u5F6F\u5FB6\u612C\u6128\u6141\u615E\u6171\u6173\u6152\u6153\u6172\u616C\u6180\u6174\u6154\u617A\u615B\u6165\u613B\u616A\u6161\u6156\u6229\u6227\u622B\u642B\u644D\u645B\u645D\u6474\u6476\u6472\u6473\u647D\u6475\u6466\u64A6\u644E\u6482\u645E\u645C\u644B\u6453\u6460\u6450\u647F\u643F\u646C\u646B\u6459\u6465\u6477\u6573\u65A0\u66A1\u66A0\u669F\u6705\u6704\u6722\u69B1\u69B6\u69C9\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u69A0\u69CE\u6996\u69B0\u69AC\u69BC\u6991\u6999\u698E\u69A7\u698D\u69A9\u69BE\u69AF\u69BF\u69C4\u69BD\u69A4\u69D4\u69B9\u69CA\u699A\u69CF\u69B3\u6993\u69AA\u69A1\u699E\u69D9\u6997\u6990\u69C2\u69B5\u69A5\u69C6\u6B4A\u6B4D\u6B4B\u6B9E\u6B9F\u6BA0\u6BC3\u6BC4\u6BFE\u6ECE\u6EF5\u6EF1\u6F03\u6F25\u6EF8\u6F37\u6EFB\u6F2E\u6F09\u6F4E\u6F19\u6F1A\u6F27\u6F18\u6F3B\u6F12\u6EED\u6F0A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6F36\u6F73\u6EF9\u6EEE\u6F2D\u6F40\u6F30\u6F3C\u6F35\u6EEB\u6F07\u6F0E\u6F43\u6F05\u6EFD\u6EF6\u6F39\u6F1C\u6EFC\u6F3A\u6F1F\u6F0D\u6F1E\u6F08\u6F21\u7187\u7190\u7189\u7180\u7185\u7182\u718F\u717B\u7186\u7181\u7197\u7244\u7253\u7297\u7295\u7293\u7343\u734D\u7351\u734C\u7462\u7473\u7471\u7475\u7472\u7467\u746E\u7500\u7502\u7503\u757D\u7590\u7616\u7608\u760C\u7615\u7611\u760A\u7614\u76B8\u7781\u777C\u7785\u7782\u776E\u7780\u776F\u777E\u7783\u78B2\u78AA\u78B4\u78AD\u78A8\u787E\u78AB\u789E\u78A5\u78A0\u78AC\u78A2\u78A4\u7998\u798A\u798B\u7996\u7995\u7994\u7993\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7997\u7988\u7992\u7990\u7A2B\u7A4A\u7A30\u7A2F\u7A28\u7A26\u7AA8\u7AAB\u7AAC\u7AEE\u7B88\u7B9C\u7B8A\u7B91\u7B90\u7B96\u7B8D\u7B8C\u7B9B\u7B8E\u7B85\u7B98\u5284\u7B99\u7BA4\u7B82\u7CBB\u7CBF\u7CBC\u7CBA\u7DA7\u7DB7\u7DC2\u7DA3\u7DAA\u7DC1\u7DC0\u7DC5\u7D9D\u7DCE\u7DC4\u7DC6\u7DCB\u7DCC\u7DAF\u7DB9\u7D96\u7DBC\u7D9F\u7DA6\u7DAE\u7DA9\u7DA1\u7DC9\u7F73\u7FE2\u7FE3\u7FE5\u7FDE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8024\u805D\u805C\u8189\u8186\u8183\u8187\u818D\u818C\u818B\u8215\u8497\u84A4\u84A1\u849F\u84BA\u84CE\u84C2\u84AC\u84AE\u84AB\u84B9\u84B4\u84C1\u84CD\u84AA\u849A\u84B1\u84D0\u849D\u84A7\u84BB\u84A2\u8494\u84C7\u84CC\u849B\u84A9\u84AF\u84A8\u84D6\u8498\u84B6\u84CF\u84A0\u84D7\u84D4\u84D2\u84DB\u84B0\u8491\u8661\u8733\u8723\u8728\u876B\u8740\u872E\u871E\u8721\u8719\u871B\u8743\u872C\u8741\u873E\u8746\u8720\u8732\u872A\u872D\u873C\u8712\u873A\u8731\u8735\u8742\u8726\u8727\u8738\u8724\u871A\u8730\u8711\u88F7\u88E7\u88F1\u88F2\u88FA\u88FE\u88EE\u88FC\u88F6\u88FB\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u88F0\u88EC\u88EB\u899D\u89A1\u899F\u899E\u89E9\u89EB\u89E8\u8AAB\u8A99\u8A8B\u8A92\u8A8F\u8A96\u8C3D\u8C68\u8C69\u8CD5\u8CCF\u8CD7\u8D96\u8E09\u8E02\u8DFF\u8E0D\u8DFD\u8E0A\u8E03\u8E07\u8E06\u8E05\u8DFE\u8E00\u8E04\u8F10\u8F11\u8F0E\u8F0D\u9123\u911C\u9120\u9122\u911F\u911D\u911A\u9124\u9121\u911B\u917A\u9172\u9179\u9173\u92A5\u92A4\u9276\u929B\u927A\u92A0\u9294\u92AA\u928D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u92A6\u929A\u92AB\u9279\u9297\u927F\u92A3\u92EE\u928E\u9282\u9295\u92A2\u927D\u9288\u92A1\u928A\u9286\u928C\u9299\u92A7\u927E\u9287\u92A9\u929D\u928B\u922D\u969E\u96A1\u96FF\u9758\u977D\u977A\u977E\u9783\u9780\u9782\u977B\u9784\u9781\u977F\u97CE\u97CD\u9816\u98AD\u98AE\u9902\u9900\u9907\u999D\u999C\u99C3\u99B9\u99BB\u99BA\u99C2\u99BD\u99C7\u9AB1\u9AE3\u9AE7\u9B3E\u9B3F\u9B60\u9B61\u9B5F\u9CF1\u9CF2\u9CF5\u9EA7\u50FF\u5103\u5130\u50F8\u5106\u5107\u50F6\u50FE\u510B\u510C\u50FD\u510A\u528B\u528C\u52F1\u52EF\u5648\u5642\u564C\u5635\u5641\u564A\u5649\u5646\u5658\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u565A\u5640\u5633\u563D\u562C\u563E\u5638\u562A\u563A\u571A\u58AB\u589D\u58B1\u58A0\u58A3\u58AF\u58AC\u58A5\u58A1\u58FF\u5AFF\u5AF4\u5AFD\u5AF7\u5AF6\u5B03\u5AF8\u5B02\u5AF9\u5B01\u5B07\u5B05\u5B0F\u5C67\u5D99\u5D97\u5D9F\u5D92\u5DA2\u5D93\u5D95\u5DA0\u5D9C\u5DA1\u5D9A\u5D9E\u5E69\u5E5D\u5E60\u5E5C\u7DF3\u5EDB\u5EDE\u5EE1\u5F49\u5FB2\u618B\u6183\u6179\u61B1\u61B0\u61A2\u6189\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u619B\u6193\u61AF\u61AD\u619F\u6192\u61AA\u61A1\u618D\u6166\u61B3\u622D\u646E\u6470\u6496\u64A0\u6485\u6497\u649C\u648F\u648B\u648A\u648C\u64A3\u649F\u6468\u64B1\u6498\u6576\u657A\u6579\u657B\u65B2\u65B3\u66B5\u66B0\u66A9\u66B2\u66B7\u66AA\u66AF\u6A00\u6A06\u6A17\u69E5\u69F8\u6A15\u69F1\u69E4\u6A20\u69FF\u69EC\u69E2\u6A1B\u6A1D\u69FE\u6A27\u69F2\u69EE\u6A14\u69F7\u69E7\u6A40\u6A08\u69E6\u69FB\u6A0D\u69FC\u69EB\u6A09\u6A04\u6A18\u6A25\u6A0F\u69F6\u6A26\u6A07\u69F4\u6A16\u6B51\u6BA5\u6BA3\u6BA2\u6BA6\u6C01\u6C00\u6BFF\u6C02\u6F41\u6F26\u6F7E\u6F87\u6FC6\u6F92\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6F8D\u6F89\u6F8C\u6F62\u6F4F\u6F85\u6F5A\u6F96\u6F76\u6F6C\u6F82\u6F55\u6F72\u6F52\u6F50\u6F57\u6F94\u6F93\u6F5D\u6F00\u6F61\u6F6B\u6F7D\u6F67\u6F90\u6F53\u6F8B\u6F69\u6F7F\u6F95\u6F63\u6F77\u6F6A\u6F7B\u71B2\u71AF\u719B\u71B0\u71A0\u719A\u71A9\u71B5\u719D\u71A5\u719E\u71A4\u71A1\u71AA\u719C\u71A7\u71B3\u7298\u729A\u7358\u7352\u735E\u735F\u7360\u735D\u735B\u7361\u735A\u7359\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7362\u7487\u7489\u748A\u7486\u7481\u747D\u7485\u7488\u747C\u7479\u7508\u7507\u757E\u7625\u761E\u7619\u761D\u761C\u7623\u761A\u7628\u761B\u769C\u769D\u769E\u769B\u778D\u778F\u7789\u7788\u78CD\u78BB\u78CF\u78CC\u78D1\u78CE\u78D4\u78C8\u78C3\u78C4\u78C9\u799A\u79A1\u79A0\u799C\u79A2\u799B\u6B76\u7A39\u7AB2\u7AB4\u7AB3\u7BB7\u7BCB\u7BBE\u7BAC\u7BCE\u7BAF\u7BB9\u7BCA\u7BB5\u7CC5\u7CC8\u7CCC\u7CCB\u7DF7\u7DDB\u7DEA\u7DE7\u7DD7\u7DE1\u7E03\u7DFA\u7DE6\u7DF6\u7DF1\u7DF0\u7DEE\u7DDF\u7F76\u7FAC\u7FB0\u7FAD\u7FED\u7FEB\u7FEA\u7FEC\u7FE6\u7FE8\u8064\u8067\u81A3\u819F\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u819E\u8195\u81A2\u8199\u8197\u8216\u824F\u8253\u8252\u8250\u824E\u8251\u8524\u853B\u850F\u8500\u8529\u850E\u8509\u850D\u851F\u850A\u8527\u851C\u84FB\u852B\u84FA\u8508\u850C\u84F4\u852A\u84F2\u8515\u84F7\u84EB\u84F3\u84FC\u8512\u84EA\u84E9\u8516\u84FE\u8528\u851D\u852E\u8502\u84FD\u851E\u84F6\u8531\u8526\u84E7\u84E8\u84F0\u84EF\u84F9\u8518\u8520\u8530\u850B\u8519\u852F\u8662\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8756\u8763\u8764\u8777\u87E1\u8773\u8758\u8754\u875B\u8752\u8761\u875A\u8751\u875E\u876D\u876A\u8750\u874E\u875F\u875D\u876F\u876C\u877A\u876E\u875C\u8765\u874F\u877B\u8775\u8762\u8767\u8769\u885A\u8905\u890C\u8914\u890B\u8917\u8918\u8919\u8906\u8916\u8911\u890E\u8909\u89A2\u89A4\u89A3\u89ED\u89F0\u89EC\u8ACF\u8AC6\u8AB8\u8AD3\u8AD1\u8AD4\u8AD5\u8ABB\u8AD7\u8ABE\u8AC0\u8AC5\u8AD8\u8AC3\u8ABA\u8ABD\u8AD9\u8C3E\u8C4D\u8C8F\u8CE5\u8CDF\u8CD9\u8CE8\u8CDA\u8CDD\u8CE7\u8DA0\u8D9C\u8DA1\u8D9B\u8E20\u8E23\u8E25\u8E24\u8E2E\u8E15\u8E1B\u8E16\u8E11\u8E19\u8E26\u8E27\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E14\u8E12\u8E18\u8E13\u8E1C\u8E17\u8E1A\u8F2C\u8F24\u8F18\u8F1A\u8F20\u8F23\u8F16\u8F17\u9073\u9070\u906F\u9067\u906B\u912F\u912B\u9129\u912A\u9132\u9126\u912E\u9185\u9186\u918A\u9181\u9182\u9184\u9180\u92D0\u92C3\u92C4\u92C0\u92D9\u92B6\u92CF\u92F1\u92DF\u92D8\u92E9\u92D7\u92DD\u92CC\u92EF\u92C2\u92E8\u92CA\u92C8\u92CE\u92E6\u92CD\u92D5\u92C9\u92E0\u92DE\u92E7\u92D1\u92D3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u92B5\u92E1\u92C6\u92B4\u957C\u95AC\u95AB\u95AE\u95B0\u96A4\u96A2\u96D3\u9705\u9708\u9702\u975A\u978A\u978E\u9788\u97D0\u97CF\u981E\u981D\u9826\u9829\u9828\u9820\u981B\u9827\u98B2\u9908\u98FA\u9911\u9914\u9916\u9917\u9915\u99DC\u99CD\u99CF\u99D3\u99D4\u99CE\u99C9\u99D6\u99D8\u99CB\u99D7\u99CC\u9AB3\u9AEC\u9AEB\u9AF3\u9AF2\u9AF1\u9B46\u9B43\u9B67\u9B74\u9B71\u9B66\u9B76\u9B75\u9B70\u9B68\u9B64\u9B6C\u9CFC\u9CFA\u9CFD\u9CFF\u9CF7\u9D07\u9D00\u9CF9\u9CFB\u9D08\u9D05\u9D04\u9E83\u9ED3\u9F0F\u9F10\u511C\u5113\u5117\u511A\u5111\u51DE\u5334\u53E1\u5670\u5660\u566E\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5673\u5666\u5663\u566D\u5672\u565E\u5677\u571C\u571B\u58C8\u58BD\u58C9\u58BF\u58BA\u58C2\u58BC\u58C6\u5B17\u5B19\u5B1B\u5B21\u5B14\u5B13\u5B10\u5B16\u5B28\u5B1A\u5B20\u5B1E\u5BEF\u5DAC\u5DB1\u5DA9\u5DA7\u5DB5\u5DB0\u5DAE\u5DAA\u5DA8\u5DB2\u5DAD\u5DAF\u5DB4\u5E67\u5E68\u5E66\u5E6F\u5EE9\u5EE7\u5EE6\u5EE8\u5EE5\u5F4B\u5FBC\u619D\u61A8\u6196\u61C5\u61B4\u61C6\u61C1\u61CC\u61BA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u61BF\u61B8\u618C\u64D7\u64D6\u64D0\u64CF\u64C9\u64BD\u6489\u64C3\u64DB\u64F3\u64D9\u6533\u657F\u657C\u65A2\u66C8\u66BE\u66C0\u66CA\u66CB\u66CF\u66BD\u66BB\u66BA\u66CC\u6723\u6A34\u6A66\u6A49\u6A67\u6A32\u6A68\u6A3E\u6A5D\u6A6D\u6A76\u6A5B\u6A51\u6A28\u6A5A\u6A3B\u6A3F\u6A41\u6A6A\u6A64\u6A50\u6A4F\u6A54\u6A6F\u6A69\u6A60\u6A3C\u6A5E\u6A56\u6A55\u6A4D\u6A4E\u6A46\u6B55\u6B54\u6B56\u6BA7\u6BAA\u6BAB\u6BC8\u6BC7\u6C04\u6C03\u6C06\u6FAD\u6FCB\u6FA3\u6FC7\u6FBC\u6FCE\u6FC8\u6F5E\u6FC4\u6FBD\u6F9E\u6FCA\u6FA8\u7004\u6FA5\u6FAE\u6FBA\u6FAC\u6FAA\u6FCF\u6FBF\u6FB8\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FA2\u6FC9\u6FAB\u6FCD\u6FAF\u6FB2\u6FB0\u71C5\u71C2\u71BF\u71B8\u71D6\u71C0\u71C1\u71CB\u71D4\u71CA\u71C7\u71CF\u71BD\u71D8\u71BC\u71C6\u71DA\u71DB\u729D\u729E\u7369\u7366\u7367\u736C\u7365\u736B\u736A\u747F\u749A\u74A0\u7494\u7492\u7495\u74A1\u750B\u7580\u762F\u762D\u7631\u763D\u7633\u763C\u7635\u7632\u7630\u76BB\u76E6\u779A\u779D\u77A1\u779C\u779B\u77A2\u77A3\u7795\u7799\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7797\u78DD\u78E9\u78E5\u78EA\u78DE\u78E3\u78DB\u78E1\u78E2\u78ED\u78DF\u78E0\u79A4\u7A44\u7A48\u7A47\u7AB6\u7AB8\u7AB5\u7AB1\u7AB7\u7BDE\u7BE3\u7BE7\u7BDD\u7BD5\u7BE5\u7BDA\u7BE8\u7BF9\u7BD4\u7BEA\u7BE2\u7BDC\u7BEB\u7BD8\u7BDF\u7CD2\u7CD4\u7CD7\u7CD0\u7CD1\u7E12\u7E21\u7E17\u7E0C\u7E1F\u7E20\u7E13\u7E0E\u7E1C\u7E15\u7E1A\u7E22\u7E0B\u7E0F\u7E16\u7E0D\u7E14\u7E25\u7E24\u7F43\u7F7B\u7F7C\u7F7A\u7FB1\u7FEF\u802A\u8029\u806C\u81B1\u81A6\u81AE\u81B9\u81B5\u81AB\u81B0\u81AC\u81B4\u81B2\u81B7\u81A7\u81F2\u8255\u8256\u8257\u8556\u8545\u856B\u854D\u8553\u8561\u8558\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8540\u8546\u8564\u8541\u8562\u8544\u8551\u8547\u8563\u853E\u855B\u8571\u854E\u856E\u8575\u8555\u8567\u8560\u858C\u8566\u855D\u8554\u8565\u856C\u8663\u8665\u8664\u879B\u878F\u8797\u8793\u8792\u8788\u8781\u8796\u8798\u8779\u8787\u87A3\u8785\u8790\u8791\u879D\u8784\u8794\u879C\u879A\u8789\u891E\u8926\u8930\u892D\u892E\u8927\u8931\u8922\u8929\u8923\u892F\u892C\u891F\u89F1\u8AE0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AE2\u8AF2\u8AF4\u8AF5\u8ADD\u8B14\u8AE4\u8ADF\u8AF0\u8AC8\u8ADE\u8AE1\u8AE8\u8AFF\u8AEF\u8AFB\u8C91\u8C92\u8C90\u8CF5\u8CEE\u8CF1\u8CF0\u8CF3\u8D6C\u8D6E\u8DA5\u8DA7\u8E33\u8E3E\u8E38\u8E40\u8E45\u8E36\u8E3C\u8E3D\u8E41\u8E30\u8E3F\u8EBD\u8F36\u8F2E\u8F35\u8F32\u8F39\u8F37\u8F34\u9076\u9079\u907B\u9086\u90FA\u9133\u9135\u9136\u9193\u9190\u9191\u918D\u918F\u9327\u931E\u9308\u931F\u9306\u930F\u937A\u9338\u933C\u931B\u9323\u9312\u9301\u9346\u932D\u930E\u930D\u92CB\u931D\u92FA\u9325\u9313\u92F9\u92F7\u9334\u9302\u9324\u92FF\u9329\u9339\u9335\u932A\u9314\u930C\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u930B\u92FE\u9309\u9300\u92FB\u9316\u95BC\u95CD\u95BE\u95B9\u95BA\u95B6\u95BF\u95B5\u95BD\u96A9\u96D4\u970B\u9712\u9710\u9799\u9797\u9794\u97F0\u97F8\u9835\u982F\u9832\u9924\u991F\u9927\u9929\u999E\u99EE\u99EC\u99E5\u99E4\u99F0\u99E3\u99EA\u99E9\u99E7\u9AB9\u9ABF\u9AB4\u9ABB\u9AF6\u9AFA\u9AF9\u9AF7\u9B33\u9B80\u9B85\u9B87\u9B7C\u9B7E\u9B7B\u9B82\u9B93\u9B92\u9B90\u9B7A\u9B95\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B7D\u9B88\u9D25\u9D17\u9D20\u9D1E\u9D14\u9D29\u9D1D\u9D18\u9D22\u9D10\u9D19\u9D1F\u9E88\u9E86\u9E87\u9EAE\u9EAD\u9ED5\u9ED6\u9EFA\u9F12\u9F3D\u5126\u5125\u5122\u5124\u5120\u5129\u52F4\u5693\u568C\u568D\u5686\u5684\u5683\u567E\u5682\u567F\u5681\u58D6\u58D4\u58CF\u58D2\u5B2D\u5B25\u5B32\u5B23\u5B2C\u5B27\u5B26\u5B2F\u5B2E\u5B7B\u5BF1\u5BF2\u5DB7\u5E6C\u5E6A\u5FBE\u5FBB\u61C3\u61B5\u61BC\u61E7\u61E0\u61E5\u61E4\u61E8\u61DE\u64EF\u64E9\u64E3\u64EB\u64E4\u64E8\u6581\u6580\u65B6\u65DA\u66D2\u6A8D\u6A96\u6A81\u6AA5\u6A89\u6A9F\u6A9B\u6AA1\u6A9E\u6A87\u6A93\u6A8E\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A95\u6A83\u6AA8\u6AA4\u6A91\u6A7F\u6AA6\u6A9A\u6A85\u6A8C\u6A92\u6B5B\u6BAD\u6C09\u6FCC\u6FA9\u6FF4\u6FD4\u6FE3\u6FDC\u6FED\u6FE7\u6FE6\u6FDE\u6FF2\u6FDD\u6FE2\u6FE8\u71E1\u71F1\u71E8\u71F2\u71E4\u71F0\u71E2\u7373\u736E\u736F\u7497\u74B2\u74AB\u7490\u74AA\u74AD\u74B1\u74A5\u74AF\u7510\u7511\u7512\u750F\u7584\u7643\u7648\u7649\u7647\u76A4\u76E9\u77B5\u77AB\u77B2\u77B7\u77B6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77B4\u77B1\u77A8\u77F0\u78F3\u78FD\u7902\u78FB\u78FC\u78F2\u7905\u78F9\u78FE\u7904\u79AB\u79A8\u7A5C\u7A5B\u7A56\u7A58\u7A54\u7A5A\u7ABE\u7AC0\u7AC1\u7C05\u7C0F\u7BF2\u7C00\u7BFF\u7BFB\u7C0E\u7BF4\u7C0B\u7BF3\u7C02\u7C09\u7C03\u7C01\u7BF8\u7BFD\u7C06\u7BF0\u7BF1\u7C10\u7C0A\u7CE8\u7E2D\u7E3C\u7E42\u7E33\u9848\u7E38\u7E2A\u7E49\u7E40\u7E47\u7E29\u7E4C\u7E30\u7E3B\u7E36\u7E44\u7E3A\u7F45\u7F7F\u7F7E\u7F7D\u7FF4\u7FF2\u802C\u81BB\u81C4\u81CC\u81CA\u81C5\u81C7\u81BC\u81E9\u825B\u825A\u825C\u8583\u8580\u858F\u85A7\u8595\u85A0\u858B\u85A3\u857B\u85A4\u859A\u859E\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8577\u857C\u8589\u85A1\u857A\u8578\u8557\u858E\u8596\u8586\u858D\u8599\u859D\u8581\u85A2\u8582\u8588\u8585\u8579\u8576\u8598\u8590\u859F\u8668\u87BE\u87AA\u87AD\u87C5\u87B0\u87AC\u87B9\u87B5\u87BC\u87AE\u87C9\u87C3\u87C2\u87CC\u87B7\u87AF\u87C4\u87CA\u87B4\u87B6\u87BF\u87B8\u87BD\u87DE\u87B2\u8935\u8933\u893C\u893E\u8941\u8952\u8937\u8942\u89AD\u89AF\u89AE\u89F2\u89F3\u8B1E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B18\u8B16\u8B11\u8B05\u8B0B\u8B22\u8B0F\u8B12\u8B15\u8B07\u8B0D\u8B08\u8B06\u8B1C\u8B13\u8B1A\u8C4F\u8C70\u8C72\u8C71\u8C6F\u8C95\u8C94\u8CF9\u8D6F\u8E4E\u8E4D\u8E53\u8E50\u8E4C\u8E47\u8F43\u8F40\u9085\u907E\u9138\u919A\u91A2\u919B\u9199\u919F\u91A1\u919D\u91A0\u93A1\u9383\u93AF\u9364\u9356\u9347\u937C\u9358\u935C\u9376\u9349\u9350\u9351\u9360\u936D\u938F\u934C\u936A\u9379\u9357\u9355\u9352\u934F\u9371\u9377\u937B\u9361\u935E\u9363\u9367\u9380\u934E\u9359\u95C7\u95C0\u95C9\u95C3\u95C5\u95B7\u96AE\u96B0\u96AC\u9720\u971F\u9718\u971D\u9719\u979A\u97A1\u979C\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u979E\u979D\u97D5\u97D4\u97F1\u9841\u9844\u984A\u9849\u9845\u9843\u9925\u992B\u992C\u992A\u9933\u9932\u992F\u992D\u9931\u9930\u9998\u99A3\u99A1\u9A02\u99FA\u99F4\u99F7\u99F9\u99F8\u99F6\u99FB\u99FD\u99FE\u99FC\u9A03\u9ABE\u9AFE\u9AFD\u9B01\u9AFC\u9B48\u9B9A\u9BA8\u9B9E\u9B9B\u9BA6\u9BA1\u9BA5\u9BA4\u9B86\u9BA2\u9BA0\u9BAF\u9D33\u9D41\u9D67\u9D36\u9D2E\u9D2F\u9D31\u9D38\u9D30\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D45\u9D42\u9D43\u9D3E\u9D37\u9D40\u9D3D\u7FF5\u9D2D\u9E8A\u9E89\u9E8D\u9EB0\u9EC8\u9EDA\u9EFB\u9EFF\u9F24\u9F23\u9F22\u9F54\u9FA0\u5131\u512D\u512E\u5698\u569C\u5697\u569A\u569D\u5699\u5970\u5B3C\u5C69\u5C6A\u5DC0\u5E6D\u5E6E\u61D8\u61DF\u61ED\u61EE\u61F1\u61EA\u61F0\u61EB\u61D6\u61E9\u64FF\u6504\u64FD\u64F8\u6501\u6503\u64FC\u6594\u65DB\u66DA\u66DB\u66D8\u6AC5\u6AB9\u6ABD\u6AE1\u6AC6\u6ABA\u6AB6\u6AB7\u6AC7\u6AB4\u6AAD\u6B5E\u6BC9\u6C0B\u7007\u700C\u700D\u7001\u7005\u7014\u700E\u6FFF\u7000\u6FFB\u7026\u6FFC\u6FF7\u700A\u7201\u71FF\u71F9\u7203\u71FD\u7376\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74B8\u74C0\u74B5\u74C1\u74BE\u74B6\u74BB\u74C2\u7514\u7513\u765C\u7664\u7659\u7650\u7653\u7657\u765A\u76A6\u76BD\u76EC\u77C2\u77BA\u78FF\u790C\u7913\u7914\u7909\u7910\u7912\u7911\u79AD\u79AC\u7A5F\u7C1C\u7C29\u7C19\u7C20\u7C1F\u7C2D\u7C1D\u7C26\u7C28\u7C22\u7C25\u7C30\u7E5C\u7E50\u7E56\u7E63\u7E58\u7E62\u7E5F\u7E51\u7E60\u7E57\u7E53\u7FB5\u7FB3\u7FF7\u7FF8\u8075\u81D1\u81D2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u81D0\u825F\u825E\u85B4\u85C6\u85C0\u85C3\u85C2\u85B3\u85B5\u85BD\u85C7\u85C4\u85BF\u85CB\u85CE\u85C8\u85C5\u85B1\u85B6\u85D2\u8624\u85B8\u85B7\u85BE\u8669\u87E7\u87E6\u87E2\u87DB\u87EB\u87EA\u87E5\u87DF\u87F3\u87E4\u87D4\u87DC\u87D3\u87ED\u87D8\u87E3\u87A4\u87D7\u87D9\u8801\u87F4\u87E8\u87DD\u8953\u894B\u894F\u894C\u8946\u8950\u8951\u8949\u8B2A\u8B27\u8B23\u8B33\u8B30\u8B35\u8B47\u8B2F\u8B3C\u8B3E\u8B31\u8B25\u8B37\u8B26\u8B36\u8B2E\u8B24\u8B3B\u8B3D\u8B3A\u8C42\u8C75\u8C99\u8C98\u8C97\u8CFE\u8D04\u8D02\u8D00\u8E5C\u8E62\u8E60\u8E57\u8E56\u8E5E\u8E65\u8E67\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E5B\u8E5A\u8E61\u8E5D\u8E69\u8E54\u8F46\u8F47\u8F48\u8F4B\u9128\u913A\u913B\u913E\u91A8\u91A5\u91A7\u91AF\u91AA\u93B5\u938C\u9392\u93B7\u939B\u939D\u9389\u93A7\u938E\u93AA\u939E\u93A6\u9395\u9388\u9399\u939F\u938D\u93B1\u9391\u93B2\u93A4\u93A8\u93B4\u93A3\u93A5\u95D2\u95D3\u95D1\u96B3\u96D7\u96DA\u5DC2\u96DF\u96D8\u96DD\u9723\u9722\u9725\u97AC\u97AE\u97A8\u97AB\u97A4\u97AA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u97A2\u97A5\u97D7\u97D9\u97D6\u97D8\u97FA\u9850\u9851\u9852\u98B8\u9941\u993C\u993A\u9A0F\u9A0B\u9A09\u9A0D\u9A04\u9A11\u9A0A\u9A05\u9A07\u9A06\u9AC0\u9ADC\u9B08\u9B04\u9B05\u9B29\u9B35\u9B4A\u9B4C\u9B4B\u9BC7\u9BC6\u9BC3\u9BBF\u9BC1\u9BB5\u9BB8\u9BD3\u9BB6\u9BC4\u9BB9\u9BBD\u9D5C\u9D53\u9D4F\u9D4A\u9D5B\u9D4B\u9D59\u9D56\u9D4C\u9D57\u9D52\u9D54\u9D5F\u9D58\u9D5A\u9E8E\u9E8C\u9EDF\u9F01\u9F00\u9F16\u9F25\u9F2B\u9F2A\u9F29\u9F28\u9F4C\u9F55\u5134\u5135\u5296\u52F7\u53B4\u56AB\u56AD\u56A6\u56A7\u56AA\u56AC\u58DA\u58DD\u58DB\u5912\u5B3D\u5B3E\u5B3F\u5DC3\u5E70\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5FBF\u61FB\u6507\u6510\u650D\u6509\u650C\u650E\u6584\u65DE\u65DD\u66DE\u6AE7\u6AE0\u6ACC\u6AD1\u6AD9\u6ACB\u6ADF\u6ADC\u6AD0\u6AEB\u6ACF\u6ACD\u6ADE\u6B60\u6BB0\u6C0C\u7019\u7027\u7020\u7016\u702B\u7021\u7022\u7023\u7029\u7017\u7024\u701C\u702A\u720C\u720A\u7207\u7202\u7205\u72A5\u72A6\u72A4\u72A3\u72A1\u74CB\u74C5\u74B7\u74C3\u7516\u7660\u77C9\u77CA\u77C4\u77F1\u791D\u791B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7921\u791C\u7917\u791E\u79B0\u7A67\u7A68\u7C33\u7C3C\u7C39\u7C2C\u7C3B\u7CEC\u7CEA\u7E76\u7E75\u7E78\u7E70\u7E77\u7E6F\u7E7A\u7E72\u7E74\u7E68\u7F4B\u7F4A\u7F83\u7F86\u7FB7\u7FFD\u7FFE\u8078\u81D7\u81D5\u8264\u8261\u8263\u85EB\u85F1\u85ED\u85D9\u85E1\u85E8\u85DA\u85D7\u85EC\u85F2\u85F8\u85D8\u85DF\u85E3\u85DC\u85D1\u85F0\u85E6\u85EF\u85DE\u85E2\u8800\u87FA\u8803\u87F6\u87F7\u8809\u880C\u880B\u8806\u87FC\u8808\u87FF\u880A\u8802\u8962\u895A\u895B\u8957\u8961\u895C\u8958\u895D\u8959\u8988\u89B7\u89B6\u89F6\u8B50\u8B48\u8B4A\u8B40\u8B53\u8B56\u8B54\u8B4B\u8B55\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B51\u8B42\u8B52\u8B57\u8C43\u8C77\u8C76\u8C9A\u8D06\u8D07\u8D09\u8DAC\u8DAA\u8DAD\u8DAB\u8E6D\u8E78\u8E73\u8E6A\u8E6F\u8E7B\u8EC2\u8F52\u8F51\u8F4F\u8F50\u8F53\u8FB4\u9140\u913F\u91B0\u91AD\u93DE\u93C7\u93CF\u93C2\u93DA\u93D0\u93F9\u93EC\u93CC\u93D9\u93A9\u93E6\u93CA\u93D4\u93EE\u93E3\u93D5\u93C4\u93CE\u93C0\u93D2\u93E7\u957D\u95DA\u95DB\u96E1\u9729\u972B\u972C\u9728\u9726\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u97B3\u97B7\u97B6\u97DD\u97DE\u97DF\u985C\u9859\u985D\u9857\u98BF\u98BD\u98BB\u98BE\u9948\u9947\u9943\u99A6\u99A7\u9A1A\u9A15\u9A25\u9A1D\u9A24\u9A1B\u9A22\u9A20\u9A27\u9A23\u9A1E\u9A1C\u9A14\u9AC2\u9B0B\u9B0A\u9B0E\u9B0C\u9B37\u9BEA\u9BEB\u9BE0\u9BDE\u9BE4\u9BE6\u9BE2\u9BF0\u9BD4\u9BD7\u9BEC\u9BDC\u9BD9\u9BE5\u9BD5\u9BE1\u9BDA\u9D77\u9D81\u9D8A\u9D84\u9D88\u9D71\u9D80\u9D78\u9D86\u9D8B\u9D8C\u9D7D\u9D6B\u9D74\u9D75\u9D70\u9D69\u9D85\u9D73\u9D7B\u9D82\u9D6F\u9D79\u9D7F\u9D87\u9D68\u9E94\u9E91\u9EC0\u9EFC\u9F2D\u9F40\u9F41\u9F4D\u9F56\u9F57\u9F58\u5337\u56B2\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u56B5\u56B3\u58E3\u5B45\u5DC6\u5DC7\u5EEE\u5EEF\u5FC0\u5FC1\u61F9\u6517\u6516\u6515\u6513\u65DF\u66E8\u66E3\u66E4\u6AF3\u6AF0\u6AEA\u6AE8\u6AF9\u6AF1\u6AEE\u6AEF\u703C\u7035\u702F\u7037\u7034\u7031\u7042\u7038\u703F\u703A\u7039\u7040\u703B\u7033\u7041\u7213\u7214\u72A8\u737D\u737C\u74BA\u76AB\u76AA\u76BE\u76ED\u77CC\u77CE\u77CF\u77CD\u77F2\u7925\u7923\u7927\u7928\u7924\u7929\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u79B2\u7A6E\u7A6C\u7A6D\u7AF7\u7C49\u7C48\u7C4A\u7C47\u7C45\u7CEE\u7E7B\u7E7E\u7E81\u7E80\u7FBA\u7FFF\u8079\u81DB\u81D9\u820B\u8268\u8269\u8622\u85FF\u8601\u85FE\u861B\u8600\u85F6\u8604\u8609\u8605\u860C\u85FD\u8819\u8810\u8811\u8817\u8813\u8816\u8963\u8966\u89B9\u89F7\u8B60\u8B6A\u8B5D\u8B68\u8B63\u8B65\u8B67\u8B6D\u8DAE\u8E86\u8E88\u8E84\u8F59\u8F56\u8F57\u8F55\u8F58\u8F5A\u908D\u9143\u9141\u91B7\u91B5\u91B2\u91B3\u940B\u9413\u93FB\u9420\u940F\u9414\u93FE\u9415\u9410\u9428\u9419\u940D\u93F5\u9400\u93F7\u9407\u940E\u9416\u9412\u93FA\u9409\u93F8\u940A\u93FF\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u93FC\u940C\u93F6\u9411\u9406\u95DE\u95E0\u95DF\u972E\u972F\u97B9\u97BB\u97FD\u97FE\u9860\u9862\u9863\u985F\u98C1\u98C2\u9950\u994E\u9959\u994C\u994B\u9953\u9A32\u9A34\u9A31\u9A2C\u9A2A\u9A36\u9A29\u9A2E\u9A38\u9A2D\u9AC7\u9ACA\u9AC6\u9B10\u9B12\u9B11\u9C0B\u9C08\u9BF7\u9C05\u9C12\u9BF8\u9C40\u9C07\u9C0E\u9C06\u9C17\u9C14\u9C09\u9D9F\u9D99\u9DA4\u9D9D\u9D92\u9D98\u9D90\u9D9B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9DA0\u9D94\u9D9C\u9DAA\u9D97\u9DA1\u9D9A\u9DA2\u9DA8\u9D9E\u9DA3\u9DBF\u9DA9\u9D96\u9DA6\u9DA7\u9E99\u9E9B\u9E9A\u9EE5\u9EE4\u9EE7\u9EE6\u9F30\u9F2E\u9F5B\u9F60\u9F5E\u9F5D\u9F59\u9F91\u513A\u5139\u5298\u5297\u56C3\u56BD\u56BE\u5B48\u5B47\u5DCB\u5DCF\u5EF1\u61FD\u651B\u6B02\u6AFC\u6B03\u6AF8\u6B00\u7043\u7044\u704A\u7048\u7049\u7045\u7046\u721D\u721A\u7219\u737E\u7517\u766A\u77D0\u792D\u7931\u792F\u7C54\u7C53\u7CF2\u7E8A\u7E87\u7E88\u7E8B\u7E86\u7E8D\u7F4D\u7FBB\u8030\u81DD\u8618\u862A\u8626\u861F\u8623\u861C\u8619\u8627\u862E\u8621\u8620\u8629\u861E\u8625\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8829\u881D\u881B\u8820\u8824\u881C\u882B\u884A\u896D\u8969\u896E\u896B\u89FA\u8B79\u8B78\u8B45\u8B7A\u8B7B\u8D10\u8D14\u8DAF\u8E8E\u8E8C\u8F5E\u8F5B\u8F5D\u9146\u9144\u9145\u91B9\u943F\u943B\u9436\u9429\u943D\u943C\u9430\u9439\u942A\u9437\u942C\u9440\u9431\u95E5\u95E4\u95E3\u9735\u973A\u97BF\u97E1\u9864\u98C9\u98C6\u98C0\u9958\u9956\u9A39\u9A3D\u9A46\u9A44\u9A42\u9A41\u9A3A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9A3F\u9ACD\u9B15\u9B17\u9B18\u9B16\u9B3A\u9B52\u9C2B\u9C1D\u9C1C\u9C2C\u9C23\u9C28\u9C29\u9C24\u9C21\u9DB7\u9DB6\u9DBC\u9DC1\u9DC7\u9DCA\u9DCF\u9DBE\u9DC5\u9DC3\u9DBB\u9DB5\u9DCE\u9DB9\u9DBA\u9DAC\u9DC8\u9DB1\u9DAD\u9DCC\u9DB3\u9DCD\u9DB2\u9E7A\u9E9C\u9EEB\u9EEE\u9EED\u9F1B\u9F18\u9F1A\u9F31\u9F4E\u9F65\u9F64\u9F92\u4EB9\u56C6\u56C5\u56CB\u5971\u5B4B\u5B4C\u5DD5\u5DD1\u5EF2\u6521\u6520\u6526\u6522\u6B0B\u6B08\u6B09\u6C0D\u7055\u7056\u7057\u7052\u721E\u721F\u72A9\u737F\u74D8\u74D5\u74D9\u74D7\u766D\u76AD\u7935\u79B4\u7A70\u7A71\u7C57\u7C5C\u7C59\u7C5B\u7C5A\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7CF4\u7CF1\u7E91\u7F4F\u7F87\u81DE\u826B\u8634\u8635\u8633\u862C\u8632\u8636\u882C\u8828\u8826\u882A\u8825\u8971\u89BF\u89BE\u89FB\u8B7E\u8B84\u8B82\u8B86\u8B85\u8B7F\u8D15\u8E95\u8E94\u8E9A\u8E92\u8E90\u8E96\u8E97\u8F60\u8F62\u9147\u944C\u9450\u944A\u944B\u944F\u9447\u9445\u9448\u9449\u9446\u973F\u97E3\u986A\u9869\u98CB\u9954\u995B\u9A4E\u9A53\u9A54\u9A4C\u9A4F\u9A48\u9A4A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9A49\u9A52\u9A50\u9AD0\u9B19\u9B2B\u9B3B\u9B56\u9B55\u9C46\u9C48\u9C3F\u9C44\u9C39\u9C33\u9C41\u9C3C\u9C37\u9C34\u9C32\u9C3D\u9C36\u9DDB\u9DD2\u9DDE\u9DDA\u9DCB\u9DD0\u9DDC\u9DD1\u9DDF\u9DE9\u9DD9\u9DD8\u9DD6\u9DF5\u9DD5\u9DDD\u9EB6\u9EF0\u9F35\u9F33\u9F32\u9F42\u9F6B\u9F95\u9FA2\u513D\u5299\u58E8\u58E7\u5972\u5B4D\u5DD8\u882F\u5F4F\u6201\u6203\u6204\u6529\u6525\u6596\u66EB\u6B11\u6B12\u6B0F\u6BCA\u705B\u705A\u7222\u7382\u7381\u7383\u7670\u77D4\u7C67\u7C66\u7E95\u826C\u863A\u8640\u8639\u863C\u8631\u863B\u863E\u8830\u8832\u882E\u8833\u8976\u8974\u8973\u89FE\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    D[248] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B8C\u8B8E\u8B8B\u8B88\u8C45\u8D19\u8E98\u8F64\u8F63\u91BC\u9462\u9455\u945D\u9457\u945E\u97C4\u97C5\u9800\u9A56\u9A59\u9B1E\u9B1F\u9B20\u9C52\u9C58\u9C50\u9C4A\u9C4D\u9C4B\u9C55\u9C59\u9C4C\u9C4E\u9DFB\u9DF7\u9DEF\u9DE3\u9DEB\u9DF8\u9DE4\u9DF6\u9DE1\u9DEE\u9DE6\u9DF2\u9DF0\u9DE2\u9DEC\u9DF4\u9DF3\u9DE8\u9DED\u9EC2\u9ED0\u9EF2\u9EF3\u9F06\u9F1C\u9F38\u9F37\u9F36\u9F43\u9F4F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9F71\u9F70\u9F6E\u9F6F\u56D3\u56CD\u5B4E\u5C6D\u652D\u66ED\u66EE\u6B13\u705F\u7061\u705D\u7060\u7223\u74DB\u74E5\u77D5\u7938\u79B7\u79B6\u7C6A\u7E97\u7F89\u826D\u8643\u8838\u8837\u8835\u884B\u8B94\u8B95\u8E9E\u8E9F\u8EA0\u8E9D\u91BE\u91BD\u91C2\u946B\u9468\u9469\u96E5\u9746\u9743\u9747\u97C7\u97E5\u9A5E\u9AD5\u9B59\u9C63\u9C67\u9C66\u9C62\u9C5E\u9C60\u9E02\u9DFE\u9E07\u9E03\u9E06\u9E05\u9E00\u9E01\u9E09\u9DFF\u9DFD\u9E04\u9EA0\u9F1E\u9F46\u9F74\u9F75\u9F76\u56D4\u652E\u65B8\u6B18\u6B19\u6B17\u6B1A\u7062\u7226\u72AA\u77D8\u77D9\u7939\u7C69\u7C6B\u7CF6\u7E9A\uFFFD".split("");
    for(j = 0; j != D[248].length; ++j)if (D[248][j].charCodeAt(0) !== 0xFFFD) {
        e[D[248][j]] = 63488 + j;
        d[63488 + j] = D[248][j];
    }
    D[249] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E98\u7E9B\u7E99\u81E0\u81E1\u8646\u8647\u8648\u8979\u897A\u897C\u897B\u89FF\u8B98\u8B99\u8EA5\u8EA4\u8EA3\u946E\u946D\u946F\u9471\u9473\u9749\u9872\u995F\u9C68\u9C6E\u9C6D\u9E0B\u9E0D\u9E10\u9E0F\u9E12\u9E11\u9EA1\u9EF5\u9F09\u9F47\u9F78\u9F7B\u9F7A\u9F79\u571E\u7066\u7C6F\u883C\u8DB2\u8EA6\u91C3\u9474\u9478\u9476\u9475\u9A60\u9C74\u9C73\u9C71\u9C75\u9E14\u9E13\u9EF6\u9F0A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9FA4\u7068\u7065\u7CF7\u866A\u883E\u883D\u883F\u8B9E\u8C9C\u8EA9\u8EC9\u974B\u9873\u9874\u98CC\u9961\u99AB\u9A64\u9A66\u9A67\u9B24\u9E15\u9E17\u9F48\u6207\u6B1E\u7227\u864C\u8EA8\u9482\u9480\u9481\u9A69\u9A68\u9B2E\u9E19\u7229\u864B\u8B9F\u9483\u9C79\u9EB7\u7675\u9A6B\u9C7A\u9E1D\u7069\u706A\u9EA4\u9F7E\u9F49\u9F98\u7881\u92B9\u88CF\u58BB\u6052\u7CA7\u5AFA\u2554\u2566\u2557\u2560\u256C\u2563\u255A\u2569\u255D\u2552\u2564\u2555\u255E\u256A\u2561\u2558\u2567\u255B\u2553\u2565\u2556\u255F\u256B\u2562\u2559\u2568\u255C\u2551\u2550\u256D\u256E\u2570\u256F\u2593\uFFFD".split("");
    for(j = 0; j != D[249].length; ++j)if (D[249][j].charCodeAt(0) !== 0xFFFD) {
        e[D[249][j]] = 63744 + j;
        d[63744 + j] = D[249][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
cptable[1250] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\u0160\u2039\u015A\u0164\u017D\u0179\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0161\u203A\u015B\u0165\u017E\u017A\xa0\u02C7\u02D8\u0141\xa4\u0104\xa6\xa7\xa8\xa9\u015E\xab\xac\xad\xae\u017B\xb0\xb1\u02DB\u0142\xb4\xb5\xb6\xb7\xb8\u0105\u015F\xbb\u013D\u02DD\u013E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[1251] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u040C\u040B\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u045C\u045B\u045F\xa0\u040E\u045E\u0408\xa4\u0490\xa6\xa7\u0401\xa9\u0404\xab\xac\xad\xae\u0407\xb0\xb1\u0406\u0456\u0491\xb5\xb6\xb7\u0451\u2116\u0454\xbb\u0458\u0405\u0455\u0457\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[1252] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\u017D\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\u017E\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[1253] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0385\u0386\xa3\xa4\xa5\xa6\xa7\xa8\xa9\uFFFD\xab\xac\xad\xae\u2015\xb0\xb1\xb2\xb3\u0384\xb5\xb6\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[1254] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[1255] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\xa1\xa2\xa3\u20AA\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbf\u05B0\u05B1\u05B2\u05B3\u05B4\u05B5\u05B6\u05B7\u05B8\u05B9\uFFFD\u05BB\u05BC\u05BD\u05BE\u05BF\u05C0\u05C1\u05C2\u05C3\u05F0\u05F1\u05F2\u05F3\u05F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[1256] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\u067E\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0679\u2039\u0152\u0686\u0698\u0688\u06AF\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u06A9\u2122\u0691\u203A\u0153\u200C\u200D\u06BA\xa0\u060C\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\u06BE\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\u061B\xbb\xbc\xbd\xbe\u061F\u06C1\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\xd7\u0637\u0638\u0639\u063A\u0640\u0641\u0642\u0643\xe0\u0644\xe2\u0645\u0646\u0647\u0648\xe7\xe8\xe9\xea\xeb\u0649\u064A\xee\xef\u064B\u064C\u064D\u064E\xf4\u064F\u0650\xf7\u0651\xf9\u0652\xfb\xfc\u200E\u200F\u06D2", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[1257] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\xa8\u02C7\xb8\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\xaf\u02DB\uFFFD\xa0\uFFFD\xa2\xa3\xa4\uFFFD\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u02D9", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[1258] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[10000] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[10006] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\xad\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\u0387\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[10007] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\xa2\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u2202\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[10008] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\x80\uF8D8\uF8D9\uF8DA\uF8DB\uF8DC\uF8DD\uF8DE\uF8DF\uF8E0\uF8E1\uF8E2\uF8E3\uF8E4\uF8E5\uF8E6\uF8E7\uF8E8\uF8E9\uF8EA\uF8EB\uF8EC\uF8ED\uF8EE\uF8EF\uF8F0\uF8F1\uF8F2\uF8F3\uF8F4\uF8F5\uF8F6\uF8F7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF8F8\uF8F9\uF8FA\uF8FB\uF8FC\uF8FD\uF8FE\uF8FF".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\u3001\u3002\u30FB\u02C9\u02C7\xa8\u3003\u3005\u2015\uFF5E\uFFFD\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2488\u2489\u248A\u248B\u248C\u248D\u248E\u248F\u2490\u2491\u2492\u2493\u2494\u2495\u2496\u2497\u2498\u2499\u249A\u249B\u2474\u2475\u2476\u2477\u2478\u2479\u247A\u247B\u247C\u247D\u247E\u247F\u2480\u2481\u2482\u2483\u2484\u2485\u2486\u2487\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\uFFFD\uFFFD\u3220\u3221\u3222\u3223\u3224\u3225\u3226\u3227\u3228\u3229\uFFFD\uFFFD\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\u216A\u216B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF01\uFF02\uFF03\uFFE5\uFF05\uFF06\uFF07\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF3B\uFF3C\uFF3D\uFF3E\uFF3F\uFF40\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFF5B\uFF5C\uFF5D\uFFE3\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3105\u3106\u3107\u3108\u3109\u310A\u310B\u310C\u310D\u310E\u310F\u3110\u3111\u3112\u3113\u3114\u3115\u3116\u3117\u3118\u3119\u311A\u311B\u311C\u311D\u311E\u311F\u3120\u3121\u3122\u3123\u3124\u3125\u3126\u3127\u3128\u3129\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2500\u2501\u2502\u2503\u2504\u2505\u2506\u2507\u2508\u2509\u250A\u250B\u250C\u250D\u250E\u250F\u2510\u2511\u2512\u2513\u2514\u2515\u2516\u2517\u2518\u2519\u251A\u251B\u251C\u251D\u251E\u251F\u2520\u2521\u2522\u2523\u2524\u2525\u2526\u2527\u2528\u2529\u252A\u252B\u252C\u252D\u252E\u252F\u2530\u2531\u2532\u2533\u2534\u2535\u2536\u2537\u2538\u2539\u253A\u253B\u253C\u253D\u253E\u253F\u2540\u2541\u2542\u2543\u2544\u2545\u2546\u2547\u2548\u2549\u254A\u254B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[199] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20\uFFFD".split("");
    for(j = 0; j != D[199].length; ++j)if (D[199][j].charCodeAt(0) !== 0xFFFD) {
        e[D[199][j]] = 50944 + j;
        d[50944 + j] = D[199][j];
    }
    D[200] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1\uFFFD".split("");
    for(j = 0; j != D[200].length; ++j)if (D[200][j].charCodeAt(0) !== 0xFFFD) {
        e[D[200][j]] = 51200 + j;
        d[51200 + j] = D[200][j];
    }
    D[201] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3\uFFFD".split("");
    for(j = 0; j != D[201].length; ++j)if (D[201][j].charCodeAt(0) !== 0xFFFD) {
        e[D[201][j]] = 51456 + j;
        d[51456 + j] = D[201][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967\u9968\u9969\u996A\u996B\u996C\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21\u7F22\u7F23\u7F24\u7F25\u7F26\u7F27\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F\u7F30\u7F31\u7F32\u7F33\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6\u94B7\u94B8\u94B9\u94BA\u94BC\u94BD\u94BF\u94C4\u94C8\u94C9\u94CA\u94CB\u94CC\u94CD\u94CE\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512\u9513\u9514\u9515\u9516\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564\u9565\u9566\u9567\u9568\u9569\u956A\u956B\u956C\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28\u9E29\u9E2A\u9E2B\u9E2C\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66\u9E67\u9E68\u9E69\u9E6A\u9E6B\u9E6C\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85\u9F86\u9F87\u9F88\u9F89\u9F8A\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E\u9C9F\u9CA0\u9CA1\u9CA2\u9CA3\u9CA5\u9CA6\u9CA7\u9CA8\u9CA9\u9CAB\u9CAD\u9CAE\u9CB0\u9CB1\u9CB2\u9CB3\u9CB4\u9CB5\u9CB6\u9CB7\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9CCC\u9CCD\u9CCE\u9CCF\u9CD0\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
cptable[10029] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[10079] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
cptable[10081] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\uFFFD\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
// eslint-disable-next-line no-undef
if ((0, module.exports) && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
/* cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ft=javascript: */ /*jshint newcap: false */ (function(root, factory) {
    /*jshint ignore:start */ /*eslint-disable */ "use strict";
    if (typeof cptable === "undefined") {
        var cpt = cptable;
        if ((0, module.exports) && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
        else root.cptable = factory(cpt);
    } else cptable = factory(cptable);
/*eslint-enable */ /*jshint ignore:end */ })(this, function(cpt) {
    "use strict";
    /*global module, Buffer */ var magic = {
        "1200": "utf16le",
        "1201": "utf16be",
        "12000": "utf32le",
        "12001": "utf32be",
        "16969": "utf64le",
        "20127": "ascii",
        "65000": "utf7",
        "65001": "utf8"
    };
    var sbcs_cache = [
        874,
        1250,
        1251,
        1252,
        1253,
        1254,
        1255,
        1256,
        10000
    ];
    var dbcs_cache = [
        932,
        936,
        949,
        950
    ];
    var magic_cache = [
        65001
    ];
    var magic_decode = {};
    var magic_encode = {};
    var cpdcache = {};
    var cpecache = {};
    var sfcc = function sfcc(x) {
        return String.fromCharCode(x);
    };
    var cca = function cca(x) {
        return x.charCodeAt(0);
    };
    var has_buf = typeof Buffer !== 'undefined';
    var Buffer_from = function() {};
    if (has_buf) {
        var nbfs = !Buffer.from;
        if (!nbfs) try {
            Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        Buffer_from = nbfs ? function(buf, enc) {
            return enc ? new Buffer(buf, enc) : new Buffer(buf);
        } : Buffer.from.bind(Buffer);
        // $FlowIgnore
        if (!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) {
            return new Buffer(n);
        };
        var mdl = 1024, mdb = Buffer.allocUnsafe(mdl);
        var make_EE = function make_EE(E) {
            var EE = Buffer.allocUnsafe(65536);
            for(var i = 0; i < 65536; ++i)EE[i] = 0;
            var keys = Object.keys(E), len = keys.length;
            for(var ee = 0, e = keys[ee]; ee < len; ++ee){
                if (!(e = keys[ee])) continue;
                EE[e.charCodeAt(0)] = E[e];
            }
            return EE;
        };
        var sbcs_encode = function make_sbcs_encode(cp) {
            var EE = make_EE(cpt[cp].enc);
            return function sbcs_e(data, ofmt) {
                var len = data.length;
                var out, i = 0, j = 0, D = 0, w = 0;
                if (typeof data === 'string') {
                    out = Buffer.allocUnsafe(len);
                    for(i = 0; i < len; ++i)out[i] = EE[data.charCodeAt(i)];
                } else if (Buffer.isBuffer(data)) {
                    out = Buffer.allocUnsafe(2 * len);
                    j = 0;
                    for(i = 0; i < len; ++i){
                        D = data[i];
                        if (D < 128) out[j++] = EE[D];
                        else if (D < 224) {
                            out[j++] = EE[((D & 31) << 6) + (data[i + 1] & 63)];
                            ++i;
                        } else if (D < 240) {
                            out[j++] = EE[((D & 15) << 12) + ((data[i + 1] & 63) << 6) + (data[i + 2] & 63)];
                            i += 2;
                        } else {
                            w = ((D & 7) << 18) + ((data[i + 1] & 63) << 12) + ((data[i + 2] & 63) << 6) + (data[i + 3] & 63);
                            i += 3;
                            if (w < 65536) out[j++] = EE[w];
                            else {
                                w -= 65536;
                                out[j++] = EE[0xD800 + (w >> 10 & 1023)];
                                out[j++] = EE[0xDC00 + (w & 1023)];
                            }
                        }
                    }
                    out = out.slice(0, j);
                } else {
                    out = Buffer.allocUnsafe(len);
                    for(i = 0; i < len; ++i)out[i] = EE[data[i].charCodeAt(0)];
                }
                if (!ofmt || ofmt === 'buf') return out;
                if (ofmt !== 'arr') return out.toString('binary');
                return [].slice.call(out);
            };
        };
        var sbcs_decode = function make_sbcs_decode(cp) {
            var D = cpt[cp].dec;
            var DD = Buffer.allocUnsafe(131072), d = 0, c = "";
            for(d = 0; d < D.length; ++d){
                if (!(c = D[d])) continue;
                var w = c.charCodeAt(0);
                DD[2 * d] = w & 255;
                DD[2 * d + 1] = w >> 8;
            }
            return function sbcs_d(data) {
                var len = data.length, i = 0, j = 0;
                if (2 * len > mdl) {
                    mdl = 2 * len;
                    mdb = Buffer.allocUnsafe(mdl);
                }
                if (Buffer.isBuffer(data)) for(i = 0; i < len; i++){
                    j = 2 * data[i];
                    mdb[2 * i] = DD[j];
                    mdb[2 * i + 1] = DD[j + 1];
                }
                else if (typeof data === "string") for(i = 0; i < len; i++){
                    j = 2 * data.charCodeAt(i);
                    mdb[2 * i] = DD[j];
                    mdb[2 * i + 1] = DD[j + 1];
                }
                else for(i = 0; i < len; i++){
                    j = 2 * data[i];
                    mdb[2 * i] = DD[j];
                    mdb[2 * i + 1] = DD[j + 1];
                }
                return mdb.slice(0, 2 * len).toString('ucs2');
            };
        };
        var dbcs_encode = function make_dbcs_encode(cp) {
            var E = cpt[cp].enc;
            var EE = Buffer.allocUnsafe(131072);
            for(var i = 0; i < 131072; ++i)EE[i] = 0;
            var keys = Object.keys(E);
            for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee){
                if (!(e = keys[ee])) continue;
                var f = e.charCodeAt(0);
                EE[2 * f] = E[e] & 255;
                EE[2 * f + 1] = E[e] >> 8;
            }
            return function dbcs_e(data, ofmt) {
                var len = data.length, out = Buffer.allocUnsafe(2 * len), i = 0, j = 0, jj = 0, k = 0, D = 0;
                if (typeof data === 'string') {
                    for(i = k = 0; i < len; ++i){
                        j = data.charCodeAt(i) * 2;
                        out[k++] = EE[j + 1] || EE[j];
                        if (EE[j + 1] > 0) out[k++] = EE[j];
                    }
                    out = out.slice(0, k);
                } else if (Buffer.isBuffer(data)) {
                    for(i = k = 0; i < len; ++i){
                        D = data[i];
                        if (D < 128) j = D;
                        else if (D < 224) {
                            j = ((D & 31) << 6) + (data[i + 1] & 63);
                            ++i;
                        } else if (D < 240) {
                            j = ((D & 15) << 12) + ((data[i + 1] & 63) << 6) + (data[i + 2] & 63);
                            i += 2;
                        } else {
                            j = ((D & 7) << 18) + ((data[i + 1] & 63) << 12) + ((data[i + 2] & 63) << 6) + (data[i + 3] & 63);
                            i += 3;
                        }
                        if (j < 65536) {
                            j *= 2;
                            out[k++] = EE[j + 1] || EE[j];
                            if (EE[j + 1] > 0) out[k++] = EE[j];
                        } else {
                            jj = j - 65536;
                            j = 2 * (0xD800 + (jj >> 10 & 1023));
                            out[k++] = EE[j + 1] || EE[j];
                            if (EE[j + 1] > 0) out[k++] = EE[j];
                            j = 2 * (0xDC00 + (jj & 1023));
                            out[k++] = EE[j + 1] || EE[j];
                            if (EE[j + 1] > 0) out[k++] = EE[j];
                        }
                    }
                    out = out.slice(0, k);
                } else for(i = k = 0; i < len; i++){
                    j = data[i].charCodeAt(0) * 2;
                    out[k++] = EE[j + 1] || EE[j];
                    if (EE[j + 1] > 0) out[k++] = EE[j];
                }
                if (!ofmt || ofmt === 'buf') return out;
                if (ofmt !== 'arr') return out.toString('binary');
                return [].slice.call(out);
            };
        };
        var dbcs_decode = function make_dbcs_decode(cp) {
            var D = cpt[cp].dec;
            var DD = Buffer.allocUnsafe(131072), d = 0, c, w = 0, j = 0, i = 0;
            for(i = 0; i < 65536; ++i){
                DD[2 * i] = 0xFF;
                DD[2 * i + 1] = 0xFD;
            }
            for(d = 0; d < D.length; ++d){
                if (!(c = D[d])) continue;
                w = c.charCodeAt(0);
                j = 2 * d;
                DD[j] = w & 255;
                DD[j + 1] = w >> 8;
            }
            return function dbcs_d(data) {
                var len = data.length, out = Buffer.allocUnsafe(2 * len), i = 0, j = 0, k = 0;
                if (Buffer.isBuffer(data)) for(i = 0; i < len; i++){
                    j = 2 * data[i];
                    if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
                        j = 2 * ((data[i] << 8) + data[i + 1]);
                        ++i;
                    }
                    out[k++] = DD[j];
                    out[k++] = DD[j + 1];
                }
                else if (typeof data === "string") for(i = 0; i < len; i++){
                    j = 2 * data.charCodeAt(i);
                    if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
                        j = 2 * ((data.charCodeAt(i) << 8) + data.charCodeAt(i + 1));
                        ++i;
                    }
                    out[k++] = DD[j];
                    out[k++] = DD[j + 1];
                }
                else for(i = 0; i < len; i++){
                    j = 2 * data[i];
                    if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
                        j = 2 * ((data[i] << 8) + data[i + 1]);
                        ++i;
                    }
                    out[k++] = DD[j];
                    out[k++] = DD[j + 1];
                }
                return out.slice(0, k).toString('ucs2');
            };
        };
        magic_decode[65001] = function utf8_d(data) {
            if (typeof data === "string") return utf8_d(data.split("").map(cca));
            var len = data.length, w = 0, ww = 0;
            if (4 * len > mdl) {
                mdl = 4 * len;
                mdb = Buffer.allocUnsafe(mdl);
            }
            var i = 0;
            if (len >= 3 && data[0] == 0xEF) {
                if (data[1] == 0xBB && data[2] == 0xBF) i = 3;
            }
            for(var j = 1, k = 0, D = 0; i < len; i += j){
                j = 1;
                D = data[i];
                if (D < 128) w = D;
                else if (D < 224) {
                    w = (D & 31) * 64 + (data[i + 1] & 63);
                    j = 2;
                } else if (D < 240) {
                    w = ((D & 15) << 12) + (data[i + 1] & 63) * 64 + (data[i + 2] & 63);
                    j = 3;
                } else {
                    w = (D & 7) * 262144 + ((data[i + 1] & 63) << 12) + (data[i + 2] & 63) * 64 + (data[i + 3] & 63);
                    j = 4;
                }
                if (w < 65536) {
                    mdb[k++] = w & 255;
                    mdb[k++] = w >> 8;
                } else {
                    w -= 65536;
                    ww = 0xD800 + (w >> 10 & 1023);
                    w = 0xDC00 + (w & 1023);
                    mdb[k++] = ww & 255;
                    mdb[k++] = ww >>> 8;
                    mdb[k++] = w & 255;
                    mdb[k++] = w >>> 8 & 255;
                }
            }
            return mdb.slice(0, k).toString('ucs2');
        };
        magic_encode[65001] = function utf8_e(data, ofmt) {
            if (has_buf && Buffer.isBuffer(data)) {
                if (!ofmt || ofmt === 'buf') return data;
                if (ofmt !== 'arr') return data.toString('binary');
                return [].slice.call(data);
            }
            var len = data.length, w = 0, ww = 0, j = 0;
            var direct = typeof data === "string";
            if (4 * len > mdl) {
                mdl = 4 * len;
                mdb = Buffer.allocUnsafe(mdl);
            }
            for(var i = 0; i < len; ++i){
                w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
                if (w <= 0x007F) mdb[j++] = w;
                else if (w <= 0x07FF) {
                    mdb[j++] = 192 + (w >> 6);
                    mdb[j++] = 128 + (w & 63);
                } else if (w >= 0xD800 && w <= 0xDFFF) {
                    w -= 0xD800;
                    ++i;
                    ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
                    mdb[j++] = 240 + (ww >>> 18 & 0x07);
                    mdb[j++] = 144 + (ww >>> 12 & 0x3F);
                    mdb[j++] = 128 + (ww >>> 6 & 0x3F);
                    mdb[j++] = 128 + (ww & 0x3F);
                } else {
                    mdb[j++] = 224 + (w >> 12);
                    mdb[j++] = 128 + (w >> 6 & 63);
                    mdb[j++] = 128 + (w & 63);
                }
            }
            if (!ofmt || ofmt === 'buf') return mdb.slice(0, j);
            if (ofmt !== 'arr') return mdb.slice(0, j).toString('binary');
            return [].slice.call(mdb, 0, j);
        };
    }
    var encache = function encache() {
        if (has_buf) {
            if (cpdcache[sbcs_cache[0]]) return;
            var i = 0, s = 0;
            for(i = 0; i < sbcs_cache.length; ++i){
                s = sbcs_cache[i];
                if (cpt[s]) {
                    cpdcache[s] = sbcs_decode(s);
                    cpecache[s] = sbcs_encode(s);
                }
            }
            for(i = 0; i < dbcs_cache.length; ++i){
                s = dbcs_cache[i];
                if (cpt[s]) {
                    cpdcache[s] = dbcs_decode(s);
                    cpecache[s] = dbcs_encode(s);
                }
            }
            for(i = 0; i < magic_cache.length; ++i){
                s = magic_cache[i];
                if (magic_decode[s]) cpdcache[s] = magic_decode[s];
                if (magic_encode[s]) cpecache[s] = magic_encode[s];
            }
        }
    };
    var null_enc = function(data, ofmt) {
        return "";
    };
    var cp_decache = function cp_decache(cp) {
        delete cpdcache[cp];
        delete cpecache[cp];
    };
    var decache = function decache() {
        if (has_buf) {
            if (!cpdcache[sbcs_cache[0]]) return;
            sbcs_cache.forEach(cp_decache);
            dbcs_cache.forEach(cp_decache);
            magic_cache.forEach(cp_decache);
        }
        last_enc = null_enc;
        last_cp = 0;
    };
    var cache = {
        encache: encache,
        decache: decache,
        sbcs: sbcs_cache,
        dbcs: dbcs_cache
    };
    encache();
    var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
    var last_enc = null_enc, last_cp = 0;
    var encode = function encode(cp, data, ofmt) {
        if (cp === last_cp && last_enc) return last_enc(data, ofmt);
        if (cpecache[cp]) {
            last_enc = cpecache[last_cp = cp];
            return last_enc(data, ofmt);
        }
        if (has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
        var len = data.length;
        var out = has_buf ? Buffer.allocUnsafe(4 * len) : [], w = 0, i = 0, j = 0, ww = 0;
        var C = cpt[cp], E, M = "";
        var isstr = typeof data === 'string';
        if (C && (E = C.enc)) for(i = 0; i < len; ++i, ++j){
            w = E[isstr ? data.charAt(i) : data[i]];
            if (w > 255) {
                out[j] = w >> 8;
                out[++j] = w & 255;
            } else out[j] = w & 255;
        }
        else if (M = magic[cp]) switch(M){
            case "utf8":
                if (has_buf && isstr) {
                    out = Buffer_from(data, M);
                    j = out.length;
                    break;
                }
                for(i = 0; i < len; ++i, ++j){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    if (w <= 0x007F) out[j] = w;
                    else if (w <= 0x07FF) {
                        out[j] = 192 + (w >> 6);
                        out[++j] = 128 + (w & 63);
                    } else if (w >= 0xD800 && w <= 0xDFFF) {
                        w -= 0xD800;
                        ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
                        out[j] = 240 + (ww >>> 18 & 0x07);
                        out[++j] = 144 + (ww >>> 12 & 0x3F);
                        out[++j] = 128 + (ww >>> 6 & 0x3F);
                        out[++j] = 128 + (ww & 0x3F);
                    } else {
                        out[j] = 224 + (w >> 12);
                        out[++j] = 128 + (w >> 6 & 63);
                        out[++j] = 128 + (w & 63);
                    }
                }
                break;
            case "ascii":
                if (has_buf && typeof data === "string") {
                    out = Buffer_from(data, M);
                    j = out.length;
                    break;
                }
                for(i = 0; i < len; ++i, ++j){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    if (w <= 0x007F) out[j] = w;
                    else throw new Error("bad ascii " + w);
                }
                break;
            case "utf16le":
                if (has_buf && typeof data === "string") {
                    out = Buffer_from(data, M);
                    j = out.length;
                    break;
                }
                for(i = 0; i < len; ++i){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    out[j++] = w & 255;
                    out[j++] = w >> 8;
                }
                break;
            case "utf16be":
                for(i = 0; i < len; ++i){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    out[j++] = w >> 8;
                    out[j++] = w & 255;
                }
                break;
            case "utf32le":
                for(i = 0; i < len; ++i){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    if (w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + (w - 0xD800 << 10) + (data[++i].charCodeAt(0) - 0xDC00);
                    out[j++] = w & 255;
                    w >>= 8;
                    out[j++] = w & 255;
                    w >>= 8;
                    out[j++] = w & 255;
                    w >>= 8;
                    out[j++] = w & 255;
                }
                break;
            case "utf32be":
                for(i = 0; i < len; ++i){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    if (w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + (w - 0xD800 << 10) + (data[++i].charCodeAt(0) - 0xDC00);
                    out[j + 3] = w & 255;
                    w >>= 8;
                    out[j + 2] = w & 255;
                    w >>= 8;
                    out[j + 1] = w & 255;
                    w >>= 8;
                    out[j] = w & 255;
                    j += 4;
                }
                break;
            case "utf7":
                for(i = 0; i < len; i++){
                    var c = isstr ? data.charAt(i) : data[i].charAt(0);
                    if (c === "+") {
                        out[j++] = 0x2b;
                        out[j++] = 0x2d;
                        continue;
                    }
                    if (SetD.indexOf(c) > -1) {
                        out[j++] = c.charCodeAt(0);
                        continue;
                    }
                    var tt = encode(1201, c);
                    out[j++] = 0x2b;
                    out[j++] = BM.charCodeAt(tt[0] >> 2);
                    out[j++] = BM.charCodeAt(((tt[0] & 0x03) << 4) + ((tt[1] || 0) >> 4));
                    out[j++] = BM.charCodeAt(((tt[1] & 0x0F) << 2) + ((tt[2] || 0) >> 6));
                    out[j++] = 0x2d;
                }
                break;
            default:
                throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
        }
        else throw new Error("Unrecognized CP: " + cp);
        out = out.slice(0, j);
        if (!has_buf) return ofmt == 'str' ? out.map(sfcc).join("") : out;
        if (!ofmt || ofmt === 'buf') return out;
        if (ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
    };
    var decode = function decode(cp, data) {
        var F;
        if (F = cpdcache[cp]) return F(data);
        if (typeof data === "string") return decode(cp, data.split("").map(cca));
        var len = data.length, out = new Array(len), s = "", w = 0, i = 0, j = 1, k = 0, ww = 0;
        var C = cpt[cp], D, M = "";
        if (C && (D = C.dec)) for(i = 0; i < len; i += j){
            j = 2;
            s = D[(data[i] << 8) + data[i + 1]];
            if (!s) {
                j = 1;
                s = D[data[i]];
            }
            if (!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i + j - 1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
            out[k++] = s;
        }
        else if (M = magic[cp]) switch(M){
            case "utf8":
                if (len >= 3 && data[0] == 0xEF) {
                    if (data[1] == 0xBB && data[2] == 0xBF) i = 3;
                }
                for(; i < len; i += j){
                    j = 1;
                    if (data[i] < 128) w = data[i];
                    else if (data[i] < 224) {
                        w = (data[i] & 31) * 64 + (data[i + 1] & 63);
                        j = 2;
                    } else if (data[i] < 240) {
                        w = ((data[i] & 15) << 12) + (data[i + 1] & 63) * 64 + (data[i + 2] & 63);
                        j = 3;
                    } else {
                        w = (data[i] & 7) * 262144 + ((data[i + 1] & 63) << 12) + (data[i + 2] & 63) * 64 + (data[i + 3] & 63);
                        j = 4;
                    }
                    if (w < 65536) out[k++] = String.fromCharCode(w);
                    else {
                        w -= 65536;
                        ww = 0xD800 + (w >> 10 & 1023);
                        w = 0xDC00 + (w & 1023);
                        out[k++] = String.fromCharCode(ww);
                        out[k++] = String.fromCharCode(w);
                    }
                }
                break;
            case "ascii":
                if (has_buf && Buffer.isBuffer(data)) return data.toString(M);
                for(i = 0; i < len; i++)out[i] = String.fromCharCode(data[i]);
                k = len;
                break;
            case "utf16le":
                if (len >= 2 && data[0] == 0xFF) {
                    if (data[1] == 0xFE) i = 2;
                }
                if (has_buf && Buffer.isBuffer(data)) return data.toString(M);
                j = 2;
                for(; i + 1 < len; i += j)out[k++] = String.fromCharCode((data[i + 1] << 8) + data[i]);
                break;
            case "utf16be":
                if (len >= 2 && data[0] == 0xFE) {
                    if (data[1] == 0xFF) i = 2;
                }
                j = 2;
                for(; i + 1 < len; i += j)out[k++] = String.fromCharCode((data[i] << 8) + data[i + 1]);
                break;
            case "utf32le":
                if (len >= 4 && data[0] == 0xFF) {
                    if (data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
                }
                j = 4;
                for(; i < len; i += j){
                    w = (data[i + 3] << 24) + (data[i + 2] << 16) + (data[i + 1] << 8) + data[i];
                    if (w > 0xFFFF) {
                        w -= 0x10000;
                        out[k++] = String.fromCharCode(0xD800 + (w >> 10 & 0x3FF));
                        out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
                    } else out[k++] = String.fromCharCode(w);
                }
                break;
            case "utf32be":
                if (len >= 4 && data[3] == 0xFF) {
                    if (data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
                }
                j = 4;
                for(; i < len; i += j){
                    w = (data[i] << 24) + (data[i + 1] << 16) + (data[i + 2] << 8) + data[i + 3];
                    if (w > 0xFFFF) {
                        w -= 0x10000;
                        out[k++] = String.fromCharCode(0xD800 + (w >> 10 & 0x3FF));
                        out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
                    } else out[k++] = String.fromCharCode(w);
                }
                break;
            case "utf7":
                if (len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
                    if (len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
                    else if (data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
                }
                for(; i < len; i += j){
                    if (data[i] !== 0x2b) {
                        j = 1;
                        out[k++] = String.fromCharCode(data[i]);
                        continue;
                    }
                    j = 1;
                    if (data[i + 1] === 0x2d) {
                        j = 2;
                        out[k++] = "+";
                        continue;
                    }
                    // eslint-disable-next-line no-useless-escape
                    while(String.fromCharCode(data[i + j]).match(/[A-Za-z0-9+\/]/))j++;
                    var dash = 0;
                    if (data[i + j] === 0x2d) {
                        ++j;
                        dash = 1;
                    }
                    var tt = [];
                    var o64 = "";
                    var c1 = 0, c2 = 0, c3 = 0;
                    var e1 = 0, e2 = 0, e3 = 0, e4 = 0;
                    for(var l = 1; l < j - dash;){
                        e1 = BM.indexOf(String.fromCharCode(data[i + l++]));
                        e2 = BM.indexOf(String.fromCharCode(data[i + l++]));
                        c1 = e1 << 2 | e2 >> 4;
                        tt.push(c1);
                        e3 = BM.indexOf(String.fromCharCode(data[i + l++]));
                        if (e3 === -1) break;
                        c2 = (e2 & 15) << 4 | e3 >> 2;
                        tt.push(c2);
                        e4 = BM.indexOf(String.fromCharCode(data[i + l++]));
                        if (e4 === -1) break;
                        c3 = (e3 & 3) << 6 | e4;
                        if (e4 < 64) tt.push(c3);
                    }
                    o64 = decode(1201, tt);
                    for(l = 0; l < o64.length; ++l)out[k++] = o64.charAt(l);
                }
                break;
            default:
                throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
        }
        else throw new Error("Unrecognized CP: " + cp);
        return out.slice(0, k).join("");
    };
    var hascp = function hascp(cp) {
        return !!(cpt[cp] || magic[cp]);
    };
    cpt.utils = {
        decode: decode,
        encode: encode,
        hascp: hascp,
        magic: magic,
        cache: cache
    };
    return cpt;
});

},{"bb049d426c59ff1e":"aBjM4"}],"1HvPu":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var Buffer = require("a174c9591802d99d").Buffer;
/*

JSZip - A Javascript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/master/LICENSE

Note: since JSZip 3 removed critical functionality, this version assigns to the
`JSZipSync` variable.  Another JSZip version can be loaded in parallel.
*/ (function(e) {
    if ("undefined" == typeof DO_NOT_EXPORT_JSZIP) module.exports = e();
    else if ("function" == typeof define && define.amd && "undefined" == typeof DO_NOT_EXPORT_JSZIP) {
        JSZipSync = e();
        define([], e);
    } else {
        var f;
        "undefined" != typeof globalThis ? f = globalThis : "undefined" != typeof window ? f = window : "undefined" != typeof global ? f = global : "undefined" != typeof $ && $.global ? f = $.global : "undefined" != typeof self && (f = self), f.JSZipSync = e();
    }
})(function() {
    var define1, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    throw new Error("Cannot find module '" + o + "'");
                }
                var f = n[o] = {
                    exports: {}
                };
                t[o][0].call(f.exports, function(_e) {
                    var n = t[o][1][_e];
                    return s(n ? n : _e);
                }, f, f.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                'use strict';
                // private property
                var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                // public method for encoding
                exports.encode = function(input, utf8) {
                    var output = "";
                    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
                    var i = 0;
                    while(i < input.length){
                        chr1 = input.charCodeAt(i++);
                        chr2 = input.charCodeAt(i++);
                        chr3 = input.charCodeAt(i++);
                        enc1 = chr1 >> 2;
                        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
                        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
                        enc4 = chr3 & 63;
                        if (isNaN(chr2)) enc3 = enc4 = 64;
                        else if (isNaN(chr3)) enc4 = 64;
                        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
                    }
                    return output;
                };
                // public method for decoding
                exports.decode = function(input, utf8) {
                    var output = "";
                    var chr1, chr2, chr3;
                    var enc1, enc2, enc3, enc4;
                    var i = 0;
                    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
                    while(i < input.length){
                        enc1 = _keyStr.indexOf(input.charAt(i++));
                        enc2 = _keyStr.indexOf(input.charAt(i++));
                        enc3 = _keyStr.indexOf(input.charAt(i++));
                        enc4 = _keyStr.indexOf(input.charAt(i++));
                        chr1 = enc1 << 2 | enc2 >> 4;
                        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
                        chr3 = (enc3 & 3) << 6 | enc4;
                        output = output + String.fromCharCode(chr1);
                        if (enc3 != 64) output = output + String.fromCharCode(chr2);
                        if (enc4 != 64) output = output + String.fromCharCode(chr3);
                    }
                    return output;
                };
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                'use strict';
                function CompressedObject() {
                    this.compressedSize = 0;
                    this.uncompressedSize = 0;
                    this.crc32 = 0;
                    this.compressionMethod = null;
                    this.compressedContent = null;
                }
                CompressedObject.prototype = {
                    /**
     * Return the decompressed content in an unspecified format.
     * The format will depend on the decompressor.
     * @return {Object} the decompressed content.
     */ getContent: function() {
                        return null; // see implementation
                    },
                    /**
     * Return the compressed content in an unspecified format.
     * The format will depend on the compressed conten source.
     * @return {Object} the compressed content.
     */ getCompressedContent: function() {
                        return null; // see implementation
                    }
                };
                module1.exports = CompressedObject;
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                'use strict';
                exports.STORE = {
                    magic: "\x00\x00",
                    compress: function(content) {
                        return content; // no compression
                    },
                    uncompress: function(content) {
                        return content; // no compression
                    },
                    compressInputType: null,
                    uncompressInputType: null
                };
                exports.DEFLATE = _dereq_('./flate');
            },
            {
                "./flate": 8
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                var utils = _dereq_('./utils');
                var table = [
                    0x00000000,
                    0x77073096,
                    0xEE0E612C,
                    0x990951BA,
                    0x076DC419,
                    0x706AF48F,
                    0xE963A535,
                    0x9E6495A3,
                    0x0EDB8832,
                    0x79DCB8A4,
                    0xE0D5E91E,
                    0x97D2D988,
                    0x09B64C2B,
                    0x7EB17CBD,
                    0xE7B82D07,
                    0x90BF1D91,
                    0x1DB71064,
                    0x6AB020F2,
                    0xF3B97148,
                    0x84BE41DE,
                    0x1ADAD47D,
                    0x6DDDE4EB,
                    0xF4D4B551,
                    0x83D385C7,
                    0x136C9856,
                    0x646BA8C0,
                    0xFD62F97A,
                    0x8A65C9EC,
                    0x14015C4F,
                    0x63066CD9,
                    0xFA0F3D63,
                    0x8D080DF5,
                    0x3B6E20C8,
                    0x4C69105E,
                    0xD56041E4,
                    0xA2677172,
                    0x3C03E4D1,
                    0x4B04D447,
                    0xD20D85FD,
                    0xA50AB56B,
                    0x35B5A8FA,
                    0x42B2986C,
                    0xDBBBC9D6,
                    0xACBCF940,
                    0x32D86CE3,
                    0x45DF5C75,
                    0xDCD60DCF,
                    0xABD13D59,
                    0x26D930AC,
                    0x51DE003A,
                    0xC8D75180,
                    0xBFD06116,
                    0x21B4F4B5,
                    0x56B3C423,
                    0xCFBA9599,
                    0xB8BDA50F,
                    0x2802B89E,
                    0x5F058808,
                    0xC60CD9B2,
                    0xB10BE924,
                    0x2F6F7C87,
                    0x58684C11,
                    0xC1611DAB,
                    0xB6662D3D,
                    0x76DC4190,
                    0x01DB7106,
                    0x98D220BC,
                    0xEFD5102A,
                    0x71B18589,
                    0x06B6B51F,
                    0x9FBFE4A5,
                    0xE8B8D433,
                    0x7807C9A2,
                    0x0F00F934,
                    0x9609A88E,
                    0xE10E9818,
                    0x7F6A0DBB,
                    0x086D3D2D,
                    0x91646C97,
                    0xE6635C01,
                    0x6B6B51F4,
                    0x1C6C6162,
                    0x856530D8,
                    0xF262004E,
                    0x6C0695ED,
                    0x1B01A57B,
                    0x8208F4C1,
                    0xF50FC457,
                    0x65B0D9C6,
                    0x12B7E950,
                    0x8BBEB8EA,
                    0xFCB9887C,
                    0x62DD1DDF,
                    0x15DA2D49,
                    0x8CD37CF3,
                    0xFBD44C65,
                    0x4DB26158,
                    0x3AB551CE,
                    0xA3BC0074,
                    0xD4BB30E2,
                    0x4ADFA541,
                    0x3DD895D7,
                    0xA4D1C46D,
                    0xD3D6F4FB,
                    0x4369E96A,
                    0x346ED9FC,
                    0xAD678846,
                    0xDA60B8D0,
                    0x44042D73,
                    0x33031DE5,
                    0xAA0A4C5F,
                    0xDD0D7CC9,
                    0x5005713C,
                    0x270241AA,
                    0xBE0B1010,
                    0xC90C2086,
                    0x5768B525,
                    0x206F85B3,
                    0xB966D409,
                    0xCE61E49F,
                    0x5EDEF90E,
                    0x29D9C998,
                    0xB0D09822,
                    0xC7D7A8B4,
                    0x59B33D17,
                    0x2EB40D81,
                    0xB7BD5C3B,
                    0xC0BA6CAD,
                    0xEDB88320,
                    0x9ABFB3B6,
                    0x03B6E20C,
                    0x74B1D29A,
                    0xEAD54739,
                    0x9DD277AF,
                    0x04DB2615,
                    0x73DC1683,
                    0xE3630B12,
                    0x94643B84,
                    0x0D6D6A3E,
                    0x7A6A5AA8,
                    0xE40ECF0B,
                    0x9309FF9D,
                    0x0A00AE27,
                    0x7D079EB1,
                    0xF00F9344,
                    0x8708A3D2,
                    0x1E01F268,
                    0x6906C2FE,
                    0xF762575D,
                    0x806567CB,
                    0x196C3671,
                    0x6E6B06E7,
                    0xFED41B76,
                    0x89D32BE0,
                    0x10DA7A5A,
                    0x67DD4ACC,
                    0xF9B9DF6F,
                    0x8EBEEFF9,
                    0x17B7BE43,
                    0x60B08ED5,
                    0xD6D6A3E8,
                    0xA1D1937E,
                    0x38D8C2C4,
                    0x4FDFF252,
                    0xD1BB67F1,
                    0xA6BC5767,
                    0x3FB506DD,
                    0x48B2364B,
                    0xD80D2BDA,
                    0xAF0A1B4C,
                    0x36034AF6,
                    0x41047A60,
                    0xDF60EFC3,
                    0xA867DF55,
                    0x316E8EEF,
                    0x4669BE79,
                    0xCB61B38C,
                    0xBC66831A,
                    0x256FD2A0,
                    0x5268E236,
                    0xCC0C7795,
                    0xBB0B4703,
                    0x220216B9,
                    0x5505262F,
                    0xC5BA3BBE,
                    0xB2BD0B28,
                    0x2BB45A92,
                    0x5CB36A04,
                    0xC2D7FFA7,
                    0xB5D0CF31,
                    0x2CD99E8B,
                    0x5BDEAE1D,
                    0x9B64C2B0,
                    0xEC63F226,
                    0x756AA39C,
                    0x026D930A,
                    0x9C0906A9,
                    0xEB0E363F,
                    0x72076785,
                    0x05005713,
                    0x95BF4A82,
                    0xE2B87A14,
                    0x7BB12BAE,
                    0x0CB61B38,
                    0x92D28E9B,
                    0xE5D5BE0D,
                    0x7CDCEFB7,
                    0x0BDBDF21,
                    0x86D3D2D4,
                    0xF1D4E242,
                    0x68DDB3F8,
                    0x1FDA836E,
                    0x81BE16CD,
                    0xF6B9265B,
                    0x6FB077E1,
                    0x18B74777,
                    0x88085AE6,
                    0xFF0F6A70,
                    0x66063BCA,
                    0x11010B5C,
                    0x8F659EFF,
                    0xF862AE69,
                    0x616BFFD3,
                    0x166CCF45,
                    0xA00AE278,
                    0xD70DD2EE,
                    0x4E048354,
                    0x3903B3C2,
                    0xA7672661,
                    0xD06016F7,
                    0x4969474D,
                    0x3E6E77DB,
                    0xAED16A4A,
                    0xD9D65ADC,
                    0x40DF0B66,
                    0x37D83BF0,
                    0xA9BCAE53,
                    0xDEBB9EC5,
                    0x47B2CF7F,
                    0x30B5FFE9,
                    0xBDBDF21C,
                    0xCABAC28A,
                    0x53B39330,
                    0x24B4A3A6,
                    0xBAD03605,
                    0xCDD70693,
                    0x54DE5729,
                    0x23D967BF,
                    0xB3667A2E,
                    0xC4614AB8,
                    0x5D681B02,
                    0x2A6F2B94,
                    0xB40BBE37,
                    0xC30C8EA1,
                    0x5A05DF1B,
                    0x2D02EF8D
                ];
                /**
 *
 *  Javascript crc32
 *  http://www.webtoolkit.info/
 *
 */ module1.exports = function crc32(input, crc) {
                    if (typeof input === "undefined" || !input.length) return 0;
                    var isArray = utils.getTypeOf(input) !== "string";
                    if (typeof crc == "undefined") crc = 0;
                    var x = 0;
                    var y = 0;
                    var b = 0;
                    crc = crc ^ -1;
                    for(var i = 0, iTop = input.length; i < iTop; i++){
                        b = isArray ? input[i] : input.charCodeAt(i);
                        y = (crc ^ b) & 0xFF;
                        x = table[y];
                        crc = crc >>> 8 ^ x;
                    }
                    return crc ^ -1;
                };
            // vim: set shiftwidth=4 softtabstop=4:
            },
            {
                "./utils": 21
            }
        ],
        5: [
            function(_dereq_, module1, exports) {
                'use strict';
                var utils = _dereq_('./utils');
                function DataReader(data) {
                    this.data = null; // type : see implementation
                    this.length = 0;
                    this.index = 0;
                }
                DataReader.prototype = {
                    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */ checkOffset: function(offset) {
                        this.checkIndex(this.index + offset);
                    },
                    /**
     * Check that the specifed index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */ checkIndex: function(newIndex) {
                        if (this.length < newIndex || newIndex < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + newIndex + "). Corrupted zip ?");
                    },
                    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */ setIndex: function(newIndex) {
                        this.checkIndex(newIndex);
                        this.index = newIndex;
                    },
                    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */ skip: function(n) {
                        this.setIndex(this.index + n);
                    },
                    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */ byteAt: function(i) {
                    // see implementations
                    },
                    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */ readInt: function(size) {
                        var result = 0, i;
                        this.checkOffset(size);
                        for(i = this.index + size - 1; i >= this.index; i--)result = (result << 8) + this.byteAt(i);
                        this.index += size;
                        return result;
                    },
                    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */ readString: function(size) {
                        return utils.transformTo("string", this.readData(size));
                    },
                    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */ readData: function(size) {
                    // see implementations
                    },
                    /**
     * Find the last occurence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurence, -1 if not found.
     */ lastIndexOfSignature: function(sig) {
                    // see implementations
                    },
                    /**
     * Get the next date.
     * @return {Date} the date.
     */ readDate: function() {
                        var dostime = this.readInt(4);
                        return new Date((dostime >> 25 & 0x7f) + 1980, (dostime >> 21 & 0x0f) - 1, dostime >> 16 & 0x1f, dostime >> 11 & 0x1f, dostime >> 5 & 0x3f, (dostime & 0x1f) << 1); // second
                    }
                };
                module1.exports = DataReader;
            },
            {
                "./utils": 21
            }
        ],
        6: [
            function(_dereq_, module1, exports) {
                'use strict';
                exports.base64 = false;
                exports.binary = false;
                exports.dir = false;
                exports.createFolders = false;
                exports.date = null;
                exports.compression = null;
                exports.comment = null;
            },
            {}
        ],
        7: [
            function(_dereq_, module1, exports) {
                'use strict';
                var utils = _dereq_('./utils');
                /**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */ exports.string2binary = function(str) {
                    return utils.string2binary(str);
                };
                /**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */ exports.string2Uint8Array = function(str) {
                    return utils.transformTo("uint8array", str);
                };
                /**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */ exports.uint8Array2String = function(array) {
                    return utils.transformTo("string", array);
                };
                /**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */ exports.string2Blob = function(str) {
                    var buffer = utils.transformTo("arraybuffer", str);
                    return utils.arrayBuffer2Blob(buffer);
                };
                /**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */ exports.arrayBuffer2Blob = function(buffer) {
                    return utils.arrayBuffer2Blob(buffer);
                };
                /**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */ exports.transformTo = function(outputType, input) {
                    return utils.transformTo(outputType, input);
                };
                /**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */ exports.getTypeOf = function(input) {
                    return utils.getTypeOf(input);
                };
                /**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */ exports.checkSupport = function(type) {
                    return utils.checkSupport(type);
                };
                /**
 * @deprecated
 * This value will be removed in a future version without replacement.
 */ exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;
                /**
 * @deprecated
 * This value will be removed in a future version without replacement.
 */ exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;
                /**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */ exports.pretty = function(str) {
                    return utils.pretty(str);
                };
                /**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */ exports.findCompression = function(compressionMethod) {
                    return utils.findCompression(compressionMethod);
                };
                /**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */ exports.isRegExp = function(object) {
                    return utils.isRegExp(object);
                };
            },
            {
                "./utils": 21
            }
        ],
        8: [
            function(_dereq_, module1, exports) {
                'use strict';
                var USE_TYPEDARRAY = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Uint32Array !== 'undefined';
                var pako = _dereq_("pako");
                exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
                exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
                exports.magic = "\x08\x00";
                exports.compress = function(input) {
                    return pako.deflateRaw(input);
                };
                exports.uncompress = function(input) {
                    return pako.inflateRaw(input);
                };
            },
            {
                "pako": 24
            }
        ],
        9: [
            function(_dereq_, module1, exports) {
                'use strict';
                var base64 = _dereq_('./base64');
                /**
Usage:
   zip = new JSZip();
   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
   zip.folder("images").file("smile.gif", base64Data, {base64: true});
   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
   zip.remove("tempfile");

   base64zip = zip.generate();

**/ /**
 * Representation a of zip file in js
 * @constructor
 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
 * @param {Object=} options the options for creating this objects (optional).
 */ function JSZipSync1(data, options) {
                    // if this constructor is used without `new`, it adds `new` before itself:
                    if (!(this instanceof JSZipSync1)) return new JSZipSync1(data, options);
                    // object containing the files :
                    // {
                    //   "folder/" : {...},
                    //   "folder/data.txt" : {...}
                    // }
                    this.files = {};
                    this.comment = null;
                    // Where we are in the hierarchy
                    this.root = "";
                    if (data) this.load(data, options);
                    this.clone = function() {
                        var newObj = new JSZipSync1();
                        for(var i in this)if (typeof this[i] !== "function") newObj[i] = this[i];
                        return newObj;
                    };
                }
                JSZipSync1.prototype = _dereq_('./object');
                JSZipSync1.prototype.load = _dereq_('./load');
                JSZipSync1.support = _dereq_('./support');
                JSZipSync1.defaults = _dereq_('./defaults');
                /**
 * @deprecated
 * This namespace will be removed in a future version without replacement.
 */ JSZipSync1.utils = _dereq_('./deprecatedPublicUtils');
                JSZipSync1.base64 = {
                    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */ encode: function(input) {
                        return base64.encode(input);
                    },
                    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */ decode: function(input) {
                        return base64.decode(input);
                    }
                };
                JSZipSync1.compressions = _dereq_('./compressions');
                module1.exports = JSZipSync1;
            },
            {
                "./base64": 1,
                "./compressions": 3,
                "./defaults": 6,
                "./deprecatedPublicUtils": 7,
                "./load": 10,
                "./object": 13,
                "./support": 17
            }
        ],
        10: [
            function(_dereq_, module1, exports) {
                'use strict';
                var base64 = _dereq_('./base64');
                var ZipEntries = _dereq_('./zipEntries');
                module1.exports = function(data, options) {
                    var files, zipEntries, i, input;
                    options = options || {};
                    if (options.base64) data = base64.decode(data);
                    zipEntries = new ZipEntries(data, options);
                    files = zipEntries.files;
                    for(i = 0; i < files.length; i++){
                        input = files[i];
                        this.file(input.fileName, input.decompressed, {
                            binary: true,
                            optimizedBinaryString: true,
                            date: input.date,
                            dir: input.dir,
                            comment: input.fileComment.length ? input.fileComment : null,
                            createFolders: options.createFolders
                        });
                    }
                    if (zipEntries.zipComment.length) this.comment = zipEntries.zipComment;
                    return this;
                };
            },
            {
                "./base64": 1,
                "./zipEntries": 22
            }
        ],
        11: [
            function(_dereq_, module1, exports) {
                (function(Buffer) {
                    'use strict';
                    var Buffer_from = /*::(*/ function() {} /*:: :any)*/ ;
                    if (typeof Buffer !== 'undefined') {
                        var nbfs = !Buffer.from;
                        if (!nbfs) try {
                            Buffer.from("foo", "utf8");
                        } catch (e) {
                            nbfs = true;
                        }
                        Buffer_from = nbfs ? function(buf, enc) {
                            return enc ? new Buffer(buf, enc) : new Buffer(buf);
                        } : Buffer.from.bind(Buffer);
                        // $FlowIgnore
                        if (!Buffer.alloc) Buffer.alloc = function(n) {
                            return new Buffer(n);
                        };
                    }
                    module1.exports = function(data, encoding) {
                        return typeof data == 'number' ? Buffer.alloc(data) : Buffer_from(data, encoding);
                    };
                    module1.exports.test = function(b) {
                        return Buffer.isBuffer(b);
                    };
                }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
            },
            {}
        ],
        12: [
            function(_dereq_, module1, exports) {
                'use strict';
                var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
                function NodeBufferReader(data) {
                    this.data = data;
                    this.length = this.data.length;
                    this.index = 0;
                }
                NodeBufferReader.prototype = new Uint8ArrayReader();
                /**
 * @see DataReader.readData
 */ NodeBufferReader.prototype.readData = function(size) {
                    this.checkOffset(size);
                    var result = this.data.slice(this.index, this.index + size);
                    this.index += size;
                    return result;
                };
                module1.exports = NodeBufferReader;
            },
            {
                "./uint8ArrayReader": 18
            }
        ],
        13: [
            function(_dereq_, module1, exports) {
                'use strict';
                var support = _dereq_('./support');
                var utils = _dereq_('./utils');
                var crc32 = _dereq_('./crc32');
                var signature = _dereq_('./signature');
                var defaults = _dereq_('./defaults');
                var base64 = _dereq_('./base64');
                var compressions = _dereq_('./compressions');
                var CompressedObject = _dereq_('./compressedObject');
                var nodeBuffer = _dereq_('./nodeBuffer');
                var utf8 = _dereq_('./utf8');
                var StringWriter = _dereq_('./stringWriter');
                var Uint8ArrayWriter = _dereq_('./uint8ArrayWriter');
                /**
 * Returns the raw data of a ZipObject, decompress the content if necessary.
 * @param {ZipObject} file the file to use.
 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
 */ var getRawData = function(file) {
                    if (file._data instanceof CompressedObject) {
                        file._data = file._data.getContent();
                        file.options.binary = true;
                        file.options.base64 = false;
                        if (utils.getTypeOf(file._data) === "uint8array") {
                            var copy = file._data;
                            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
                            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
                            file._data = new Uint8Array(copy.length);
                            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
                            if (copy.length !== 0) file._data.set(copy, 0);
                        }
                    }
                    return file._data;
                };
                /**
 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
 * @param {ZipObject} file the file to use.
 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
 */ var getBinaryData = function(file) {
                    var result = getRawData(file), type = utils.getTypeOf(result);
                    if (type === "string") {
                        if (!file.options.binary) {
                            // unicode text !
                            // unicode string => binary string is a painful process, check if we can avoid it.
                            if (support.nodebuffer) return nodeBuffer(result, "utf-8");
                        }
                        return file.asBinary();
                    }
                    return result;
                };
                /**
 * Transform this._data into a string.
 * @param {function} filter a function String -> String, applied if not null on the result.
 * @return {String} the string representing this._data.
 */ var dataToString = function(asUTF8) {
                    var result = getRawData(this);
                    if (result === null || typeof result === "undefined") return "";
                    // if the data is a base64 string, we decode it before checking the encoding !
                    if (this.options.base64) result = base64.decode(result);
                    if (asUTF8 && this.options.binary) // JSZip.prototype.utf8decode supports arrays as input
                    // skip to array => string step, utf8decode will do it.
                    result = out.utf8decode(result);
                    else // no utf8 transformation, do the array => string step.
                    result = utils.transformTo("string", result);
                    if (!asUTF8 && !this.options.binary) result = utils.transformTo("string", out.utf8encode(result));
                    return result;
                };
                /**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */ var ZipObject = function(name, data, options) {
                    this.name = name;
                    this.dir = options.dir;
                    this.date = options.date;
                    this.comment = options.comment;
                    this._data = data;
                    this.options = options;
                    /*
     * This object contains initial values for dir and date.
     * With them, we can check if the user changed the deprecated metadata in
     * `ZipObject#options` or not.
     */ this._initialMetadata = {
                        dir: options.dir,
                        date: options.date
                    };
                };
                ZipObject.prototype = {
                    /**
     * Return the content as UTF8 string.
     * @return {string} the UTF8 string.
     */ asText: function() {
                        return dataToString.call(this, true);
                    },
                    /**
     * Returns the binary content.
     * @return {string} the content as binary.
     */ asBinary: function() {
                        return dataToString.call(this, false);
                    },
                    /**
     * Returns the content as a nodejs Buffer.
     * @return {Buffer} the content as a Buffer.
     */ asNodeBuffer: function() {
                        var result = getBinaryData(this);
                        return utils.transformTo("nodebuffer", result);
                    },
                    /**
     * Returns the content as an Uint8Array.
     * @return {Uint8Array} the content as an Uint8Array.
     */ asUint8Array: function() {
                        var result = getBinaryData(this);
                        return utils.transformTo("uint8array", result);
                    },
                    /**
     * Returns the content as an ArrayBuffer.
     * @return {ArrayBuffer} the content as an ArrayBufer.
     */ asArrayBuffer: function() {
                        return this.asUint8Array().buffer;
                    }
                };
                /**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */ var decToHex = function(dec, bytes) {
                    var hex = "", i;
                    for(i = 0; i < bytes; i++){
                        hex += String.fromCharCode(dec & 0xff);
                        dec = dec >>> 8;
                    }
                    return hex;
                };
                /**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */ var extend = function() {
                    var result = {}, i, attr;
                    for(i = 0; i < arguments.length; i++){
                        for(attr in arguments[i])if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") result[attr] = arguments[i][attr];
                    }
                    return result;
                };
                /**
 * Transforms the (incomplete) options from the user into the complete
 * set of options to create a file.
 * @private
 * @param {Object} o the options from the user.
 * @return {Object} the complete set of options.
 */ var prepareFileAttrs = function(o) {
                    o = o || {};
                    if (o.base64 === true && (o.binary === null || o.binary === undefined)) o.binary = true;
                    o = extend(o, defaults);
                    o.date = o.date || new Date();
                    if (o.compression !== null) o.compression = o.compression.toUpperCase();
                    return o;
                };
                /**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} o the options of the file
 * @return {Object} the new file.
 */ var fileAdd = function(name, data, o) {
                    // be sure sub folders exist
                    var dataType = utils.getTypeOf(data), parent;
                    o = prepareFileAttrs(o);
                    if (o.createFolders && (parent = parentFolder(name))) folderAdd.call(this, parent, true);
                    if (o.dir || data === null || typeof data === "undefined") {
                        o.base64 = false;
                        o.binary = false;
                        data = null;
                    } else if (dataType === "string") {
                        if (o.binary && !o.base64) // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
                        {
                            if (o.optimizedBinaryString !== true) // this is a string, not in a base64 format.
                            // Be sure that this is a correct "binary string"
                            data = utils.string2binary(data);
                        }
                    } else {
                        o.base64 = false;
                        o.binary = true;
                        if (!dataType && !(data instanceof CompressedObject)) throw new Error("The data of '" + name + "' is in an unsupported format !");
                        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
                        if (dataType === "arraybuffer") data = utils.transformTo("uint8array", data);
                    }
                    var object = new ZipObject(name, data, o);
                    this.files[name] = object;
                    return object;
                };
                /**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */ var parentFolder = function(path) {
                    if (path.slice(-1) == '/') path = path.substring(0, path.length - 1);
                    var lastSlash = path.lastIndexOf('/');
                    return lastSlash > 0 ? path.substring(0, lastSlash) : "";
                };
                /**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */ var folderAdd = function(name, createFolders) {
                    // Check the name ends with a /
                    if (name.slice(-1) != "/") name += "/"; // IE doesn't like substr(-1)
                    createFolders = typeof createFolders !== 'undefined' ? createFolders : false;
                    // Does this folder already exist?
                    if (!this.files[name]) fileAdd.call(this, name, null, {
                        dir: true,
                        createFolders: createFolders
                    });
                    return this.files[name];
                };
                /**
 * Generate a JSZip.CompressedObject for a given zipOject.
 * @param {ZipObject} file the object to read.
 * @param {JSZip.compression} compression the compression to use.
 * @return {JSZip.CompressedObject} the compressed result.
 */ var generateCompressedObjectFrom = function(file, compression) {
                    var result = new CompressedObject(), content;
                    // the data has not been decompressed, we might reuse things !
                    if (file._data instanceof CompressedObject) {
                        result.uncompressedSize = file._data.uncompressedSize;
                        result.crc32 = file._data.crc32;
                        if (result.uncompressedSize === 0 || file.dir) {
                            compression = compressions['STORE'];
                            result.compressedContent = "";
                            result.crc32 = 0;
                        } else if (file._data.compressionMethod === compression.magic) result.compressedContent = file._data.getCompressedContent();
                        else {
                            content = file._data.getContent();
                            // need to decompress / recompress
                            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
                        }
                    } else {
                        // have uncompressed data
                        content = getBinaryData(file);
                        if (!content || content.length === 0 || file.dir) {
                            compression = compressions['STORE'];
                            content = "";
                        }
                        result.uncompressedSize = content.length;
                        result.crc32 = crc32(content);
                        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
                    }
                    result.compressedSize = result.compressedContent.length;
                    result.compressionMethod = compression.magic;
                    return result;
                };
                /**
 * Generate the various parts used in the construction of the final zip file.
 * @param {string} name the file name.
 * @param {ZipObject} file the file content.
 * @param {JSZip.CompressedObject} compressedObject the compressed object.
 * @param {number} offset the current offset from the start of the zip file.
 * @return {object} the zip parts.
 */ var generateZipParts = function(name, file, compressedObject, offset) {
                    var data = compressedObject.compressedContent, utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)), comment = file.comment || "", utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)), useUTF8ForFileName = utfEncodedFileName.length !== file.name.length, useUTF8ForComment = utfEncodedComment.length !== comment.length, o = file.options, dosTime, dosDate, extraFields = "", unicodePathExtraField = "", unicodeCommentExtraField = "", dir, date;
                    // handle the deprecated options.dir
                    if (file._initialMetadata.dir !== file.dir) dir = file.dir;
                    else dir = o.dir;
                    // handle the deprecated options.date
                    if (file._initialMetadata.date !== file.date) date = file.date;
                    else date = o.date;
                    dosTime = date.getHours();
                    dosTime = dosTime << 6;
                    dosTime = dosTime | date.getMinutes();
                    dosTime = dosTime << 5;
                    dosTime = dosTime | date.getSeconds() / 2;
                    dosDate = date.getFullYear() - 1980;
                    dosDate = dosDate << 4;
                    dosDate = dosDate | date.getMonth() + 1;
                    dosDate = dosDate << 5;
                    dosDate = dosDate | date.getDate();
                    if (useUTF8ForFileName) {
                        // set the unicode path extra field. unzip needs at least one extra
                        // field to correctly handle unicode path, so using the path is as good
                        // as any other information. This could improve the situation with
                        // other archive managers too.
                        // This field is usually used without the utf8 flag, with a non
                        // unicode path in the header (winrar, winzip). This helps (a bit)
                        // with the messy Windows' default compressed folders feature but
                        // breaks on p7zip which doesn't seek the unicode path extra field.
                        // So for now, UTF-8 everywhere !
                        unicodePathExtraField = // Version
                        decToHex(1, 1) + // NameCRC32
                        decToHex(crc32(utfEncodedFileName), 4) + // UnicodeName
                        utfEncodedFileName;
                        extraFields += // Info-ZIP Unicode Path Extra Field
                        "\x75\x70" + // size
                        decToHex(unicodePathExtraField.length, 2) + // content
                        unicodePathExtraField;
                    }
                    if (useUTF8ForComment) {
                        unicodeCommentExtraField = // Version
                        decToHex(1, 1) + // CommentCRC32
                        decToHex(this.crc32(utfEncodedComment), 4) + // UnicodeName
                        utfEncodedComment;
                        extraFields += // Info-ZIP Unicode Path Extra Field
                        "\x75\x63" + // size
                        decToHex(unicodeCommentExtraField.length, 2) + // content
                        unicodeCommentExtraField;
                    }
                    var header = "";
                    // version needed to extract
                    header += "\x0A\x00";
                    // general purpose bit flag
                    // set bit 11 if utf8
                    header += useUTF8ForFileName || useUTF8ForComment ? "\x00\x08" : "\x00\x00";
                    // compression method
                    header += compressedObject.compressionMethod;
                    // last mod file time
                    header += decToHex(dosTime, 2);
                    // last mod file date
                    header += decToHex(dosDate, 2);
                    // crc-32
                    header += decToHex(compressedObject.crc32, 4);
                    // compressed size
                    header += decToHex(compressedObject.compressedSize, 4);
                    // uncompressed size
                    header += decToHex(compressedObject.uncompressedSize, 4);
                    // file name length
                    header += decToHex(utfEncodedFileName.length, 2);
                    // extra field length
                    header += decToHex(extraFields.length, 2);
                    var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;
                    var dirRecord = signature.CENTRAL_FILE_HEADER + // version made by (00: DOS)
                    "\x14\x00" + // file header (common to file and central directory)
                    header + // file comment length
                    decToHex(utfEncodedComment.length, 2) + // disk number start
                    "\x00\x00" + // internal file attributes TODO
                    "\x00\x00" + // external file attributes
                    (dir === true ? "\x10\x00\x00\x00" : "\x00\x00\x00\x00") + // relative offset of local header
                    decToHex(offset, 4) + // file name
                    utfEncodedFileName + // extra field
                    extraFields + // file comment
                    utfEncodedComment;
                    return {
                        fileRecord: fileRecord,
                        dirRecord: dirRecord,
                        compressedObject: compressedObject
                    };
                };
                // return the actual prototype of JSZip
                var out = {
                    /**
     * Read an existing zip and merge the data in the current JSZip object.
     * The implementation is in jszip-load.js, don't forget to include it.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
     * @param {Object} options Options for loading the stream.
     *  options.base64 : is the stream in base64 ? default : false
     * @return {JSZip} the current JSZip object
     */ load: function(stream, options) {
                        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
                    },
                    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */ filter: function(search) {
                        var result = [], filename, relativePath, file, fileClone;
                        for(filename in this.files){
                            if (!this.files.hasOwnProperty(filename)) continue;
                            file = this.files[filename];
                            // return a new object, don't let the user mess with our internal objects :)
                            fileClone = new ZipObject(file.name, file._data, extend(file.options));
                            relativePath = filename.slice(this.root.length, filename.length);
                            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
                            search(relativePath, fileClone)) result.push(fileClone);
                        }
                        return result;
                    },
                    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */ file: function(name, data, o) {
                        if (arguments.length === 1) {
                            if (utils.isRegExp(name)) {
                                var regexp = name;
                                return this.filter(function(relativePath, file) {
                                    return !file.dir && regexp.test(relativePath);
                                });
                            } else return this.filter(function(relativePath, file) {
                                return !file.dir && relativePath === name;
                            })[0] || null;
                        } else {
                            name = this.root + name;
                            fileAdd.call(this, name, data, o);
                        }
                        return this;
                    },
                    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */ folder: function(arg) {
                        if (!arg) return this;
                        if (utils.isRegExp(arg)) return this.filter(function(relativePath, file) {
                            return file.dir && arg.test(relativePath);
                        });
                        // else, name is a new folder
                        var name = this.root + arg;
                        var newFolder = folderAdd.call(this, name);
                        // Allow chaining by returning a new object with this folder as the root
                        var ret = this.clone();
                        ret.root = newFolder.name;
                        return ret;
                    },
                    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */ remove: function(name) {
                        name = this.root + name;
                        var file = this.files[name];
                        if (!file) {
                            // Look for any folders
                            if (name.slice(-1) != "/") name += "/";
                            file = this.files[name];
                        }
                        if (file && !file.dir) // file
                        delete this.files[name];
                        else {
                            // maybe a folder, delete recursively
                            var kids = this.filter(function(relativePath, file) {
                                return file.name.slice(0, name.length) === name;
                            });
                            for(var i = 0; i < kids.length; i++)delete this.files[kids[i].name];
                        }
                        return this;
                    },
                    /**
     * Generate the complete zip file
     * @param {Object} options the options to generate the zip file :
     * - base64, (deprecated, use type instead) true to generate base64.
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
     */ generate: function(options) {
                        options = extend(options || {}, {
                            base64: true,
                            compression: "STORE",
                            type: "base64",
                            comment: null
                        });
                        utils.checkSupport(options.type);
                        var zipData = [], localDirLength = 0, centralDirLength = 0, writer, i, utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || ""));
                        // first, generate all the zip parts.
                        for(var name in this.files){
                            if (!this.files.hasOwnProperty(name)) continue;
                            var file = this.files[name];
                            var compressionName = file.options.compression || options.compression.toUpperCase();
                            var compression = compressions[compressionName];
                            if (!compression) throw new Error(compressionName + " is not a valid compression method !");
                            var compressedObject = generateCompressedObjectFrom.call(this, file, compression);
                            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength);
                            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
                            centralDirLength += zipPart.dirRecord.length;
                            zipData.push(zipPart);
                        }
                        var dirEnd = "";
                        // end of central dir signature
                        dirEnd = signature.CENTRAL_DIRECTORY_END + // number of this disk
                        "\x00\x00" + // number of the disk with the start of the central directory
                        "\x00\x00" + // total number of entries in the central directory on this disk
                        decToHex(zipData.length, 2) + // total number of entries in the central directory
                        decToHex(zipData.length, 2) + // size of the central directory   4 bytes
                        decToHex(centralDirLength, 4) + // offset of start of central directory with respect to the starting disk number
                        decToHex(localDirLength, 4) + // .ZIP file comment length
                        decToHex(utfEncodedComment.length, 2) + // .ZIP file comment
                        utfEncodedComment;
                        // we have all the parts (and the total length)
                        // time to create a writer !
                        var typeName = options.type.toLowerCase();
                        if (typeName === "uint8array" || typeName === "arraybuffer" || typeName === "blob" || typeName === "nodebuffer") writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
                        else writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
                        for(i = 0; i < zipData.length; i++){
                            writer.append(zipData[i].fileRecord);
                            writer.append(zipData[i].compressedObject.compressedContent);
                        }
                        for(i = 0; i < zipData.length; i++)writer.append(zipData[i].dirRecord);
                        writer.append(dirEnd);
                        var zip = writer.finalize();
                        switch(options.type.toLowerCase()){
                            // case "zip is an Uint8Array"
                            case "uint8array":
                            case "arraybuffer":
                            case "nodebuffer":
                                return utils.transformTo(options.type.toLowerCase(), zip);
                            case "blob":
                                return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip));
                            // case "zip is a string"
                            case "base64":
                                return options.base64 ? base64.encode(zip) : zip;
                            default:
                                return zip;
                        }
                    },
                    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */ crc32: function(input, crc) {
                        return crc32(input, crc);
                    },
                    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */ utf8encode: function(string) {
                        return utils.transformTo("string", utf8.utf8encode(string));
                    },
                    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */ utf8decode: function(input) {
                        return utf8.utf8decode(input);
                    }
                };
                module1.exports = out;
            },
            {
                "./base64": 1,
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./defaults": 6,
                "./nodeBuffer": 11,
                "./signature": 14,
                "./stringWriter": 16,
                "./support": 17,
                "./uint8ArrayWriter": 19,
                "./utf8": 20,
                "./utils": 21
            }
        ],
        14: [
            function(_dereq_, module1, exports) {
                'use strict';
                exports.LOCAL_FILE_HEADER = "PK\x03\x04";
                exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
                exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
                exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
                exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
                exports.DATA_DESCRIPTOR = "PK\x07\x08";
            },
            {}
        ],
        15: [
            function(_dereq_, module1, exports) {
                'use strict';
                var DataReader = _dereq_('./dataReader');
                var utils = _dereq_('./utils');
                function StringReader(data, optimizedBinaryString) {
                    this.data = data;
                    if (!optimizedBinaryString) this.data = utils.string2binary(this.data);
                    this.length = this.data.length;
                    this.index = 0;
                }
                StringReader.prototype = new DataReader();
                /**
 * @see DataReader.byteAt
 */ StringReader.prototype.byteAt = function(i) {
                    return this.data.charCodeAt(i);
                };
                /**
 * @see DataReader.lastIndexOfSignature
 */ StringReader.prototype.lastIndexOfSignature = function(sig) {
                    return this.data.lastIndexOf(sig);
                };
                /**
 * @see DataReader.readData
 */ StringReader.prototype.readData = function(size) {
                    this.checkOffset(size);
                    // this will work because the constructor applied the "& 0xff" mask.
                    var result = this.data.slice(this.index, this.index + size);
                    this.index += size;
                    return result;
                };
                module1.exports = StringReader;
            },
            {
                "./dataReader": 5,
                "./utils": 21
            }
        ],
        16: [
            function(_dereq_, module1, exports) {
                'use strict';
                var utils = _dereq_('./utils');
                /**
 * An object to write any content to a string.
 * @constructor
 */ var StringWriter = function() {
                    this.data = [];
                };
                StringWriter.prototype = {
                    /**
     * Append any content to the current string.
     * @param {Object} input the content to add.
     */ append: function(input) {
                        input = utils.transformTo("string", input);
                        this.data.push(input);
                    },
                    /**
     * Finalize the construction an return the result.
     * @return {string} the generated string.
     */ finalize: function() {
                        return this.data.join("");
                    }
                };
                module1.exports = StringWriter;
            },
            {
                "./utils": 21
            }
        ],
        17: [
            function(_dereq_, module1, exports) {
                (function(Buffer) {
                    'use strict';
                    exports.base64 = true;
                    exports.array = true;
                    exports.string = true;
                    exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
                    // contains true if JSZip can read/generate nodejs Buffer, false otherwise.
                    // Browserify will provide a Buffer implementation for browsers, which is
                    // an augmented Uint8Array (i.e., can be used as either Buffer or U8).
                    exports.nodebuffer = typeof Buffer !== "undefined";
                    // contains true if JSZip can read/generate Uint8Array, false otherwise.
                    exports.uint8array = typeof Uint8Array !== "undefined";
                    if (typeof ArrayBuffer === "undefined") exports.blob = false;
                    else {
                        var buffer = new ArrayBuffer(0);
                        try {
                            exports.blob = new Blob([
                                buffer
                            ], {
                                type: "application/zip"
                            }).size === 0;
                        } catch (e) {
                            try {
                                var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
                                var builder = new Builder();
                                builder.append(buffer);
                                exports.blob = builder.getBlob('application/zip').size === 0;
                            } catch (e) {
                                exports.blob = false;
                            }
                        }
                    }
                }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
            },
            {}
        ],
        18: [
            function(_dereq_, module1, exports) {
                'use strict';
                var DataReader = _dereq_('./dataReader');
                function Uint8ArrayReader(data) {
                    if (data) {
                        this.data = data;
                        this.length = this.data.length;
                        this.index = 0;
                    }
                }
                Uint8ArrayReader.prototype = new DataReader();
                /**
 * @see DataReader.byteAt
 */ Uint8ArrayReader.prototype.byteAt = function(i) {
                    return this.data[i];
                };
                /**
 * @see DataReader.lastIndexOfSignature
 */ Uint8ArrayReader.prototype.lastIndexOfSignature = function(sig) {
                    var sig0 = sig.charCodeAt(0), sig1 = sig.charCodeAt(1), sig2 = sig.charCodeAt(2), sig3 = sig.charCodeAt(3);
                    for(var i = this.length - 4; i >= 0; --i){
                        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) return i;
                    }
                    return -1;
                };
                /**
 * @see DataReader.readData
 */ Uint8ArrayReader.prototype.readData = function(size) {
                    this.checkOffset(size);
                    if (size === 0) // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
                    return new Uint8Array(0);
                    var result = this.data.subarray(this.index, this.index + size);
                    this.index += size;
                    return result;
                };
                module1.exports = Uint8ArrayReader;
            },
            {
                "./dataReader": 5
            }
        ],
        19: [
            function(_dereq_, module1, exports) {
                'use strict';
                var utils = _dereq_('./utils');
                /**
 * An object to write any content to an Uint8Array.
 * @constructor
 * @param {number} length The length of the array.
 */ var Uint8ArrayWriter = function(length) {
                    this.data = new Uint8Array(length);
                    this.index = 0;
                };
                Uint8ArrayWriter.prototype = {
                    /**
     * Append any content to the current array.
     * @param {Object} input the content to add.
     */ append: function(input) {
                        if (input.length !== 0) {
                            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
                            input = utils.transformTo("uint8array", input);
                            this.data.set(input, this.index);
                            this.index += input.length;
                        }
                    },
                    /**
     * Finalize the construction an return the result.
     * @return {Uint8Array} the generated array.
     */ finalize: function() {
                        return this.data;
                    }
                };
                module1.exports = Uint8ArrayWriter;
            },
            {
                "./utils": 21
            }
        ],
        20: [
            function(_dereq_, module1, exports) {
                'use strict';
                var utils = _dereq_('./utils');
                var support = _dereq_('./support');
                var nodeBuffer = _dereq_('./nodeBuffer');
                /**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */ // Table with utf8 lengths (calculated by first byte of sequence)
                // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
                // because max possible codepoint is 0x10ffff
                var _utf8len = new Array(256);
                for(var i = 0; i < 256; i++)_utf8len[i] = i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1;
                _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
                // convert string to array (typed, when possible)
                var string2buf = function(str) {
                    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
                    // count binary size
                    for(m_pos = 0; m_pos < str_len; m_pos++){
                        c = str.charCodeAt(m_pos);
                        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                            c2 = str.charCodeAt(m_pos + 1);
                            if ((c2 & 0xfc00) === 0xdc00) {
                                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                                m_pos++;
                            }
                        }
                        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
                    }
                    // allocate buffer
                    if (support.uint8array) buf = new Uint8Array(buf_len);
                    else buf = new Array(buf_len);
                    // convert
                    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
                        c = str.charCodeAt(m_pos);
                        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                            c2 = str.charCodeAt(m_pos + 1);
                            if ((c2 & 0xfc00) === 0xdc00) {
                                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                                m_pos++;
                            }
                        }
                        if (c < 0x80) /* one byte */ buf[i++] = c;
                        else if (c < 0x800) {
                            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
                            buf[i++] = 0x80 | c & 0x3f;
                        } else if (c < 0x10000) {
                            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
                            buf[i++] = 0x80 | c >>> 6 & 0x3f;
                            buf[i++] = 0x80 | c & 0x3f;
                        } else {
                            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
                            buf[i++] = 0x80 | c >>> 12 & 0x3f;
                            buf[i++] = 0x80 | c >>> 6 & 0x3f;
                            buf[i++] = 0x80 | c & 0x3f;
                        }
                    }
                    return buf;
                };
                // Calculate max possible position in utf8 buffer,
                // that will not break sequence. If that's not possible
                // - (very small limits) return max size as is.
                //
                // buf[] - utf8 bytes array
                // max   - length limit (mandatory);
                var utf8border = function(buf, max) {
                    var pos;
                    max = max || buf.length;
                    if (max > buf.length) max = buf.length;
                    // go back from last position, until start of sequence found
                    pos = max - 1;
                    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
                    // Fuckup - very small and broken sequence,
                    // return max, because we should return something anyway.
                    if (pos < 0) return max;
                    // If we came to start of buffer - that means vuffer is too small,
                    // return max too.
                    if (pos === 0) return max;
                    return pos + _utf8len[buf[pos]] > max ? pos : max;
                };
                // convert array to string
                var buf2string = function(buf) {
                    var str, i, out, c, c_len;
                    var len = buf.length;
                    // Reserve max possible length (2 words per char)
                    // NB: by unknown reasons, Array is significantly faster for
                    //     String.fromCharCode.apply than Uint16Array.
                    var utf16buf = new Array(len * 2);
                    for(out = 0, i = 0; i < len;){
                        c = buf[i++];
                        // quick process ascii
                        if (c < 0x80) {
                            utf16buf[out++] = c;
                            continue;
                        }
                        c_len = _utf8len[c];
                        // skip 5 & 6 byte codes
                        if (c_len > 4) {
                            utf16buf[out++] = 0xfffd;
                            i += c_len - 1;
                            continue;
                        }
                        // apply mask on first byte
                        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
                        // join the rest
                        while(c_len > 1 && i < len){
                            c = c << 6 | buf[i++] & 0x3f;
                            c_len--;
                        }
                        // terminated by end of string?
                        if (c_len > 1) {
                            utf16buf[out++] = 0xfffd;
                            continue;
                        }
                        if (c < 0x10000) utf16buf[out++] = c;
                        else {
                            c -= 0x10000;
                            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
                            utf16buf[out++] = 0xdc00 | c & 0x3ff;
                        }
                    }
                    // shrinkBuf(utf16buf, out)
                    if (utf16buf.length !== out) {
                        if (utf16buf.subarray) utf16buf = utf16buf.subarray(0, out);
                        else utf16buf.length = out;
                    }
                    // return String.fromCharCode.apply(null, utf16buf);
                    return utils.applyFromCharCode(utf16buf);
                };
                // That's all for the pako functions.
                /**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */ exports.utf8encode = function utf8encode(str) {
                    if (support.nodebuffer) return nodeBuffer(str, "utf-8");
                    return string2buf(str);
                };
                /**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */ exports.utf8decode = function utf8decode(buf) {
                    if (support.nodebuffer) return utils.transformTo("nodebuffer", buf).toString("utf-8");
                    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
                    // return buf2string(buf);
                    // Chrome prefers to work with "small" chunks of data
                    // for the method buf2string.
                    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
                    var result = [], k = 0, len = buf.length, chunk = 65536;
                    while(k < len){
                        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
                        if (support.uint8array) result.push(buf2string(buf.subarray(k, nextBoundary)));
                        else result.push(buf2string(buf.slice(k, nextBoundary)));
                        k = nextBoundary;
                    }
                    return result.join("");
                };
            // vim: set shiftwidth=4 softtabstop=4:
            },
            {
                "./nodeBuffer": 11,
                "./support": 17,
                "./utils": 21
            }
        ],
        21: [
            function(_dereq_, module1, exports) {
                'use strict';
                var support = _dereq_('./support');
                var compressions = _dereq_('./compressions');
                var nodeBuffer = _dereq_('./nodeBuffer');
                /**
 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
 * @param {string} str the string to transform.
 * @return {String} the binary string.
 */ exports.string2binary = function(str) {
                    var result = "";
                    for(var i = 0; i < str.length; i++)result += String.fromCharCode(str.charCodeAt(i) & 0xff);
                    return result;
                };
                exports.arrayBuffer2Blob = function(buffer) {
                    exports.checkSupport("blob");
                    try {
                        // Blob constructor
                        return new Blob([
                            buffer
                        ], {
                            type: "application/zip"
                        });
                    } catch (e) {
                        try {
                            // deprecated, browser only, old way
                            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
                            var builder = new Builder();
                            builder.append(buffer);
                            return builder.getBlob('application/zip');
                        } catch (e) {
                            // well, fuck ?!
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                /**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */ function identity(input) {
                    return input;
                }
                /**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */ function stringToArrayLike(str, array) {
                    for(var i = 0; i < str.length; ++i)array[i] = str.charCodeAt(i) & 0xFF;
                    return array;
                }
                /**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */ function arrayLikeToString(array) {
                    // Performances notes :
                    // --------------------
                    // String.fromCharCode.apply(null, array) is the fastest, see
                    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
                    // but the stack is limited (and we can get huge arrays !).
                    //
                    // result += String.fromCharCode(array[i]); generate too many strings !
                    //
                    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
                    var chunk = 65536;
                    var result = [], len = array.length, type = exports.getTypeOf(array), k = 0, canUseApply = true;
                    try {
                        switch(type){
                            case "uint8array":
                                String.fromCharCode.apply(null, new Uint8Array(0));
                                break;
                            case "nodebuffer":
                                String.fromCharCode.apply(null, nodeBuffer(0));
                                break;
                        }
                    } catch (e) {
                        canUseApply = false;
                    }
                    // no apply : slow and painful algorithm
                    // default browser on android 4.*
                    if (!canUseApply) {
                        var resultStr = "";
                        for(var i = 0; i < array.length; i++)resultStr += String.fromCharCode(array[i]);
                        return resultStr;
                    }
                    while(k < len && chunk > 1)try {
                        if (type === "array" || type === "nodebuffer") result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
                        else result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
                        k += chunk;
                    } catch (e) {
                        chunk = Math.floor(chunk / 2);
                    }
                    return result.join("");
                }
                exports.applyFromCharCode = arrayLikeToString;
                /**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */ function arrayLikeToArrayLike(arrayFrom, arrayTo) {
                    for(var i = 0; i < arrayFrom.length; i++)arrayTo[i] = arrayFrom[i];
                    return arrayTo;
                }
                // a matrix containing functions to transform everything into everything.
                var transform = {};
                // string to ?
                transform["string"] = {
                    "string": identity,
                    "array": function(input) {
                        return stringToArrayLike(input, new Array(input.length));
                    },
                    "arraybuffer": function(input) {
                        return transform["string"]["uint8array"](input).buffer;
                    },
                    "uint8array": function(input) {
                        return stringToArrayLike(input, new Uint8Array(input.length));
                    },
                    "nodebuffer": function(input) {
                        return stringToArrayLike(input, nodeBuffer(input.length));
                    }
                };
                // array to ?
                transform["array"] = {
                    "string": arrayLikeToString,
                    "array": identity,
                    "arraybuffer": function(input) {
                        return new Uint8Array(input).buffer;
                    },
                    "uint8array": function(input) {
                        return new Uint8Array(input);
                    },
                    "nodebuffer": function(input) {
                        return nodeBuffer(input);
                    }
                };
                // arraybuffer to ?
                transform["arraybuffer"] = {
                    "string": function(input) {
                        return arrayLikeToString(new Uint8Array(input));
                    },
                    "array": function(input) {
                        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
                    },
                    "arraybuffer": identity,
                    "uint8array": function(input) {
                        return new Uint8Array(input);
                    },
                    "nodebuffer": function(input) {
                        return nodeBuffer(new Uint8Array(input));
                    }
                };
                // uint8array to ?
                transform["uint8array"] = {
                    "string": arrayLikeToString,
                    "array": function(input) {
                        return arrayLikeToArrayLike(input, new Array(input.length));
                    },
                    "arraybuffer": function(input) {
                        return input.buffer;
                    },
                    "uint8array": identity,
                    "nodebuffer": function(input) {
                        return nodeBuffer(input);
                    }
                };
                // nodebuffer to ?
                transform["nodebuffer"] = {
                    "string": arrayLikeToString,
                    "array": function(input) {
                        return arrayLikeToArrayLike(input, new Array(input.length));
                    },
                    "arraybuffer": function(input) {
                        return transform["nodebuffer"]["uint8array"](input).buffer;
                    },
                    "uint8array": function(input) {
                        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
                    },
                    "nodebuffer": identity
                };
                /**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */ exports.transformTo = function(outputType, input) {
                    if (!input) // undefined, null, etc
                    // an empty string won't harm.
                    input = "";
                    if (!outputType) return input;
                    exports.checkSupport(outputType);
                    var inputType = exports.getTypeOf(input);
                    var result = transform[inputType][outputType](input);
                    return result;
                };
                /**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */ exports.getTypeOf = function(input) {
                    if (typeof input === "string") return "string";
                    if (Object.prototype.toString.call(input) === "[object Array]") return "array";
                    if (support.nodebuffer && nodeBuffer.test(input)) return "nodebuffer";
                    if (support.uint8array && input instanceof Uint8Array) return "uint8array";
                    if (support.arraybuffer && input instanceof ArrayBuffer) return "arraybuffer";
                };
                /**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */ exports.checkSupport = function(type) {
                    var supported = support[type.toLowerCase()];
                    if (!supported) throw new Error(type + " is not supported by this browser");
                };
                exports.MAX_VALUE_16BITS = 65535;
                exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
                /**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */ exports.pretty = function(str) {
                    var res = '', code, i;
                    for(i = 0; i < (str || "").length; i++){
                        code = str.charCodeAt(i);
                        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
                    }
                    return res;
                };
                /**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */ exports.findCompression = function(compressionMethod) {
                    for(var method in compressions){
                        if (!compressions.hasOwnProperty(method)) continue;
                        if (compressions[method].magic === compressionMethod) return compressions[method];
                    }
                    return null;
                };
                /**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/ exports.isRegExp = function(object) {
                    return Object.prototype.toString.call(object) === "[object RegExp]";
                };
            },
            {
                "./compressions": 3,
                "./nodeBuffer": 11,
                "./support": 17
            }
        ],
        22: [
            function(_dereq_, module1, exports) {
                'use strict';
                var StringReader = _dereq_('./stringReader');
                var NodeBufferReader = _dereq_('./nodeBufferReader');
                var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
                var utils = _dereq_('./utils');
                var sig = _dereq_('./signature');
                var ZipEntry = _dereq_('./zipEntry');
                var support = _dereq_('./support');
                var jszipProto = _dereq_('./object');
                //  class ZipEntries {{{
                /**
 * All the entries in the zip file.
 * @constructor
 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
 * @param {Object} loadOptions Options for loading the stream.
 */ function ZipEntries(data, loadOptions) {
                    this.files = [];
                    this.loadOptions = loadOptions;
                    if (data) this.load(data);
                }
                ZipEntries.prototype = {
                    /**
     * Check that the reader is on the speficied signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */ checkSignature: function(expectedSignature) {
                        var signature = this.reader.readString(4);
                        if (signature !== expectedSignature) throw new Error("Corrupted zip or bug : unexpected signature (" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
                    },
                    /**
     * Read the end of the central directory.
     */ readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2);
                        this.diskWithCentralDirStart = this.reader.readInt(2);
                        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
                        this.centralDirRecords = this.reader.readInt(2);
                        this.centralDirSize = this.reader.readInt(4);
                        this.centralDirOffset = this.reader.readInt(4);
                        this.zipCommentLength = this.reader.readInt(2);
                        // warning : the encoding depends of the system locale
                        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
                        // On a windows machine, this field is encoded with the localized windows code page.
                        this.zipComment = this.reader.readString(this.zipCommentLength);
                        // To get consistent behavior with the generation part, we will assume that
                        // this is utf8 encoded.
                        this.zipComment = jszipProto.utf8decode(this.zipComment);
                    },
                    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */ readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8);
                        this.versionMadeBy = this.reader.readString(2);
                        this.versionNeeded = this.reader.readInt(2);
                        this.diskNumber = this.reader.readInt(4);
                        this.diskWithCentralDirStart = this.reader.readInt(4);
                        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
                        this.centralDirRecords = this.reader.readInt(8);
                        this.centralDirSize = this.reader.readInt(8);
                        this.centralDirOffset = this.reader.readInt(8);
                        this.zip64ExtensibleData = {};
                        var extraDataSize = this.zip64EndOfCentralSize - 44, index = 0, extraFieldId, extraFieldLength, extraFieldValue;
                        while(index < extraDataSize){
                            extraFieldId = this.reader.readInt(2);
                            extraFieldLength = this.reader.readInt(4);
                            extraFieldValue = this.reader.readString(extraFieldLength);
                            this.zip64ExtensibleData[extraFieldId] = {
                                id: extraFieldId,
                                length: extraFieldLength,
                                value: extraFieldValue
                            };
                        }
                    },
                    /**
     * Read the end of the Zip 64 central directory locator.
     */ readBlockZip64EndOfCentralLocator: function() {
                        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
                        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
                        this.disksCount = this.reader.readInt(4);
                        if (this.disksCount > 1) throw new Error("Multi-volumes zip are not supported");
                    },
                    /**
     * Read the local files, based on the offset read in the central part.
     */ readLocalFiles: function() {
                        var i, file;
                        for(i = 0; i < this.files.length; i++){
                            file = this.files[i];
                            this.reader.setIndex(file.localHeaderOffset);
                            this.checkSignature(sig.LOCAL_FILE_HEADER);
                            file.readLocalPart(this.reader);
                            file.handleUTF8();
                        }
                    },
                    /**
     * Read the central directory.
     */ readCentralDir: function() {
                        var file;
                        this.reader.setIndex(this.centralDirOffset);
                        while(this.reader.readString(4) === sig.CENTRAL_FILE_HEADER){
                            file = new ZipEntry({
                                zip64: this.zip64
                            }, this.loadOptions);
                            file.readCentralPart(this.reader);
                            this.files.push(file);
                        }
                    },
                    /**
     * Read the end of central directory.
     */ readEndOfCentral: function() {
                        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
                        if (offset === -1) throw new Error("Corrupted zip : can't find end of central directory");
                        this.reader.setIndex(offset);
                        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
                        this.readBlockEndOfCentral();
                        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */ if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
                            this.zip64 = true;
                            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */ // should look for a zip64 EOCD locator
                            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
                            if (offset === -1) throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
                            this.reader.setIndex(offset);
                            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
                            this.readBlockZip64EndOfCentralLocator();
                            // now the zip64 EOCD record
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
                            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
                            this.readBlockZip64EndOfCentral();
                        }
                    },
                    prepareReader: function(data) {
                        var type = utils.getTypeOf(data);
                        if (type === "string" && !support.uint8array) this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
                        else if (type === "nodebuffer") this.reader = new NodeBufferReader(data);
                        else this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
                    },
                    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */ load: function(data) {
                        this.prepareReader(data);
                        this.readEndOfCentral();
                        this.readCentralDir();
                        this.readLocalFiles();
                    }
                };
                // }}} end of ZipEntries
                module1.exports = ZipEntries;
            },
            {
                "./nodeBufferReader": 12,
                "./object": 13,
                "./signature": 14,
                "./stringReader": 15,
                "./support": 17,
                "./uint8ArrayReader": 18,
                "./utils": 21,
                "./zipEntry": 23
            }
        ],
        23: [
            function(_dereq_, module1, exports) {
                'use strict';
                var StringReader = _dereq_('./stringReader');
                var utils = _dereq_('./utils');
                var CompressedObject = _dereq_('./compressedObject');
                var jszipProto = _dereq_('./object');
                // class ZipEntry {{{
                /**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */ function ZipEntry(options, loadOptions) {
                    this.options = options;
                    this.loadOptions = loadOptions;
                }
                ZipEntry.prototype = {
                    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */ isEncrypted: function() {
                        // bit 1 is set
                        return (this.bitFlag & 0x0001) === 0x0001;
                    },
                    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */ useUTF8: function() {
                        // bit 11 is set
                        return (this.bitFlag & 0x0800) === 0x0800;
                    },
                    /**
     * Prepare the function used to generate the compressed content from this ZipFile.
     * @param {DataReader} reader the reader to use.
     * @param {number} from the offset from where we should read the data.
     * @param {number} length the length of the data to read.
     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
     */ prepareCompressedContent: function(reader, from, length) {
                        return function() {
                            var previousIndex = reader.index;
                            reader.setIndex(from);
                            var compressedFileData = reader.readData(length);
                            reader.setIndex(previousIndex);
                            return compressedFileData;
                        };
                    },
                    /**
     * Prepare the function used to generate the uncompressed content from this ZipFile.
     * @param {DataReader} reader the reader to use.
     * @param {number} from the offset from where we should read the data.
     * @param {number} length the length of the data to read.
     * @param {JSZip.compression} compression the compression used on this file.
     * @param {number} uncompressedSize the uncompressed size to expect.
     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
     */ prepareContent: function(reader, from, length, compression, uncompressedSize) {
                        return function() {
                            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
                            var uncompressedFileData = compression.uncompress(compressedFileData);
                            if (uncompressedFileData.length !== uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                            return uncompressedFileData;
                        };
                    },
                    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */ readLocalPart: function(reader) {
                        var compression, localExtraFieldsLength;
                        // we already know everything from the central dir !
                        // If the central dir data are false, we are doomed.
                        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
                        // The less data we get here, the more reliable this should be.
                        // Let's skip the whole header and dash to the data !
                        reader.skip(22);
                        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
                        // Strangely, the filename here is OK.
                        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
                        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
                        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
                        // the internet.
                        //
                        // I think I see the logic here : the central directory is used to display
                        // content and the local directory is used to extract the files. Mixing / and \
                        // may be used to display \ to windows users and use / when extracting the files.
                        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
                        this.fileNameLength = reader.readInt(2);
                        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
                        this.fileName = reader.readString(this.fileNameLength);
                        reader.skip(localExtraFieldsLength);
                        if (this.compressedSize == -1 || this.uncompressedSize == -1) throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory (compressedSize == -1 || uncompressedSize == -1)");
                        compression = utils.findCompression(this.compressionMethod);
                        if (compression === null) throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
                        this.decompressed = new CompressedObject();
                        this.decompressed.compressedSize = this.compressedSize;
                        this.decompressed.uncompressedSize = this.uncompressedSize;
                        this.decompressed.crc32 = this.crc32;
                        this.decompressed.compressionMethod = this.compressionMethod;
                        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
                        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);
                        // we need to compute the crc32...
                        if (this.loadOptions.checkCRC32) {
                            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
                            if (jszipProto.crc32(this.decompressed) !== this.crc32) throw new Error("Corrupted zip : CRC32 mismatch");
                        }
                    },
                    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */ readCentralPart: function(reader) {
                        this.versionMadeBy = reader.readString(2);
                        this.versionNeeded = reader.readInt(2);
                        this.bitFlag = reader.readInt(2);
                        this.compressionMethod = reader.readString(2);
                        this.date = reader.readDate();
                        this.crc32 = reader.readInt(4);
                        this.compressedSize = reader.readInt(4);
                        this.uncompressedSize = reader.readInt(4);
                        this.fileNameLength = reader.readInt(2);
                        this.extraFieldsLength = reader.readInt(2);
                        this.fileCommentLength = reader.readInt(2);
                        this.diskNumberStart = reader.readInt(2);
                        this.internalFileAttributes = reader.readInt(2);
                        this.externalFileAttributes = reader.readInt(4);
                        this.localHeaderOffset = reader.readInt(4);
                        if (this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        this.fileName = reader.readString(this.fileNameLength);
                        this.readExtraFields(reader);
                        this.parseZIP64ExtraField(reader);
                        this.fileComment = reader.readString(this.fileCommentLength);
                        // warning, this is true only for zip with madeBy == DOS (plateform dependent feature)
                        this.dir = this.externalFileAttributes & 0x00000010 ? true : false;
                    },
                    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */ parseZIP64ExtraField: function(reader) {
                        if (!this.extraFields[0x0001]) return;
                        // should be something, preparing the extra reader
                        var extraReader = new StringReader(this.extraFields[0x0001].value);
                        // I really hope that these 64bits integer can fit in 32 bits integer, because js
                        // won't let us have more.
                        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) this.uncompressedSize = extraReader.readInt(8);
                        if (this.compressedSize === utils.MAX_VALUE_32BITS) this.compressedSize = extraReader.readInt(8);
                        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) this.localHeaderOffset = extraReader.readInt(8);
                        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) this.diskNumberStart = extraReader.readInt(4);
                    },
                    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */ readExtraFields: function(reader) {
                        var start = reader.index, extraFieldId, extraFieldLength, extraFieldValue;
                        this.extraFields = this.extraFields || {};
                        while(reader.index < start + this.extraFieldsLength){
                            extraFieldId = reader.readInt(2);
                            extraFieldLength = reader.readInt(2);
                            extraFieldValue = reader.readString(extraFieldLength);
                            this.extraFields[extraFieldId] = {
                                id: extraFieldId,
                                length: extraFieldLength,
                                value: extraFieldValue
                            };
                        }
                    },
                    /**
     * Apply an UTF8 transformation if needed.
     */ handleUTF8: function() {
                        if (this.useUTF8()) {
                            this.fileName = jszipProto.utf8decode(this.fileName);
                            this.fileComment = jszipProto.utf8decode(this.fileComment);
                        } else {
                            var upath = this.findExtraFieldUnicodePath();
                            if (upath !== null) this.fileName = upath;
                            var ucomment = this.findExtraFieldUnicodeComment();
                            if (ucomment !== null) this.fileComment = ucomment;
                        }
                    },
                    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */ findExtraFieldUnicodePath: function() {
                        var upathField = this.extraFields[0x7075];
                        if (upathField) {
                            var extraReader = new StringReader(upathField.value);
                            // wrong version
                            if (extraReader.readInt(1) !== 1) return null;
                            // the crc of the filename changed, this field is out of date.
                            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) return null;
                            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
                        }
                        return null;
                    },
                    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */ findExtraFieldUnicodeComment: function() {
                        var ucommentField = this.extraFields[0x6375];
                        if (ucommentField) {
                            var extraReader = new StringReader(ucommentField.value);
                            // wrong version
                            if (extraReader.readInt(1) !== 1) return null;
                            // the crc of the comment changed, this field is out of date.
                            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) return null;
                            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
                        }
                        return null;
                    }
                };
                module1.exports = ZipEntry;
            },
            {
                "./compressedObject": 2,
                "./object": 13,
                "./stringReader": 15,
                "./utils": 21
            }
        ],
        24: [
            function(_dereq_, module1, exports) {
                // Top level file is just a mixin of submodules & constants
                'use strict';
                var assign = _dereq_('./lib/utils/common').assign;
                var deflate = _dereq_('./lib/deflate');
                var inflate = _dereq_('./lib/inflate');
                var constants = _dereq_('./lib/zlib/constants');
                var pako = {};
                assign(pako, deflate, inflate, constants);
                module1.exports = pako;
            },
            {
                "./lib/deflate": 25,
                "./lib/inflate": 26,
                "./lib/utils/common": 27,
                "./lib/zlib/constants": 30
            }
        ],
        25: [
            function(_dereq_, module1, exports) {
                'use strict';
                var zlib_deflate = _dereq_('./zlib/deflate.js');
                var utils = _dereq_('./utils/common');
                var strings = _dereq_('./utils/strings');
                var msg = _dereq_('./zlib/messages');
                var zstream = _dereq_('./zlib/zstream');
                /* Public constants ==========================================================*/ /* ===========================================================================*/ var Z_NO_FLUSH = 0;
                var Z_FINISH = 4;
                var Z_OK = 0;
                var Z_STREAM_END = 1;
                var Z_DEFAULT_COMPRESSION = -1;
                var Z_DEFAULT_STRATEGY = 0;
                var Z_DEFLATED = 8;
                /* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overriden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ var Deflate = function(options) {
                    this.options = utils.assign({
                        level: Z_DEFAULT_COMPRESSION,
                        method: Z_DEFLATED,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: Z_DEFAULT_STRATEGY,
                        to: ''
                    }, options || {});
                    var opt = this.options;
                    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
                    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
                    this.err = 0; // error code, if happens (0 = Z_OK)
                    this.msg = ''; // error message
                    this.ended = false; // used to avoid multiple onEnd() calls
                    this.chunks = []; // chunks of compressed data
                    this.strm = new zstream();
                    this.strm.avail_out = 0;
                    var status = zlib_deflate.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
                    if (status !== Z_OK) throw new Error(msg[status]);
                    if (opt.header) zlib_deflate.deflateSetHeader(this.strm, opt.header);
                };
                /**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|String): input data. Strings will be converted to
 *   utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
 * [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ Deflate.prototype.push = function(data, mode) {
                    var strm = this.strm;
                    var chunkSize = this.options.chunkSize;
                    var status, _mode;
                    if (this.ended) return false;
                    _mode = mode === ~~mode ? mode : mode === true ? Z_FINISH : Z_NO_FLUSH;
                    // Convert data if needed
                    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
                    strm.input = strings.string2buf(data);
                    else strm.input = data;
                    strm.next_in = 0;
                    strm.avail_in = strm.input.length;
                    do {
                        if (strm.avail_out === 0) {
                            strm.output = new utils.Buf8(chunkSize);
                            strm.next_out = 0;
                            strm.avail_out = chunkSize;
                        }
                        status = zlib_deflate.deflate(strm, _mode); /* no bad return value */ 
                        if (status !== Z_STREAM_END && status !== Z_OK) {
                            this.onEnd(status);
                            this.ended = true;
                            return false;
                        }
                        if (strm.avail_out === 0 || strm.avail_in === 0 && _mode === Z_FINISH) {
                            if (this.options.to === 'string') this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
                            else this.onData(utils.shrinkBuf(strm.output, strm.next_out));
                        }
                    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
                    // Finalize on the last chunk.
                    if (_mode === Z_FINISH) {
                        status = zlib_deflate.deflateEnd(this.strm);
                        this.onEnd(status);
                        this.ended = true;
                        return status === Z_OK;
                    }
                    return true;
                };
                /**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ Deflate.prototype.onData = function(chunk) {
                    this.chunks.push(chunk);
                };
                /**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that input stream complete
 * or error happenned. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ Deflate.prototype.onEnd = function(status) {
                    // On success - join
                    if (status === Z_OK) {
                        if (this.options.to === 'string') this.result = this.chunks.join('');
                        else this.result = utils.flattenChunks(this.chunks);
                    }
                    this.chunks = [];
                    this.err = status;
                    this.msg = this.strm.msg;
                };
                /**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate alrorythm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function deflate(input, options) {
                    var deflator = new Deflate(options);
                    deflator.push(input, true);
                    // That will never happens, if you don't cheat with options :)
                    if (deflator.err) throw deflator.msg;
                    return deflator.result;
                }
                /**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function deflateRaw(input, options) {
                    options = options || {};
                    options.raw = true;
                    return deflate(input, options);
                }
                /**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function gzip(input, options) {
                    options = options || {};
                    options.gzip = true;
                    return deflate(input, options);
                }
                exports.Deflate = Deflate;
                exports.deflate = deflate;
                exports.deflateRaw = deflateRaw;
                exports.gzip = gzip;
            },
            {
                "./utils/common": 27,
                "./utils/strings": 28,
                "./zlib/deflate.js": 32,
                "./zlib/messages": 37,
                "./zlib/zstream": 39
            }
        ],
        26: [
            function(_dereq_, module1, exports) {
                'use strict';
                var zlib_inflate = _dereq_('./zlib/inflate.js');
                var utils = _dereq_('./utils/common');
                var strings = _dereq_('./utils/strings');
                var c = _dereq_('./zlib/constants');
                var msg = _dereq_('./zlib/messages');
                var zstream = _dereq_('./zlib/zstream');
                var gzheader = _dereq_('./zlib/gzheader');
                /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overriden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ var Inflate = function(options) {
                    this.options = utils.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ''
                    }, options || {});
                    var opt = this.options;
                    // Force window size for `raw` data, if not set directly,
                    // because we have no header for autodetect.
                    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
                        opt.windowBits = -opt.windowBits;
                        if (opt.windowBits === 0) opt.windowBits = -15;
                    }
                    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
                    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
                    // Gzip header has no info about windows size, we can do autodetect only
                    // for deflate. So, if window size not set, force it to max when gzip possible
                    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
                    // bit 4 (32) -> autodetect gzip/deflate
                    {
                        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
                    }
                    this.err = 0; // error code, if happens (0 = Z_OK)
                    this.msg = ''; // error message
                    this.ended = false; // used to avoid multiple onEnd() calls
                    this.chunks = []; // chunks of compressed data
                    this.strm = new zstream();
                    this.strm.avail_out = 0;
                    var status = zlib_inflate.inflateInit2(this.strm, opt.windowBits);
                    if (status !== c.Z_OK) throw new Error(msg[status]);
                    this.header = new gzheader();
                    zlib_inflate.inflateGetHeader(this.strm, this.header);
                };
                /**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
 * [[Inflate#onEnd]].
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ Inflate.prototype.push = function(data, mode) {
                    var strm = this.strm;
                    var chunkSize = this.options.chunkSize;
                    var status, _mode;
                    var next_out_utf8, tail, utf8str;
                    if (this.ended) return false;
                    _mode = mode === ~~mode ? mode : mode === true ? c.Z_FINISH : c.Z_NO_FLUSH;
                    // Convert data if needed
                    if (typeof data === 'string') // Only binary strings can be decompressed on practice
                    strm.input = strings.binstring2buf(data);
                    else strm.input = data;
                    strm.next_in = 0;
                    strm.avail_in = strm.input.length;
                    do {
                        if (strm.avail_out === 0) {
                            strm.output = new utils.Buf8(chunkSize);
                            strm.next_out = 0;
                            strm.avail_out = chunkSize;
                        }
                        status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH); /* no bad return value */ 
                        if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
                            this.onEnd(status);
                            this.ended = true;
                            return false;
                        }
                        if (strm.next_out) {
                            if (strm.avail_out === 0 || status === c.Z_STREAM_END || strm.avail_in === 0 && _mode === c.Z_FINISH) {
                                if (this.options.to === 'string') {
                                    next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
                                    tail = strm.next_out - next_out_utf8;
                                    utf8str = strings.buf2string(strm.output, next_out_utf8);
                                    // move tail
                                    strm.next_out = tail;
                                    strm.avail_out = chunkSize - tail;
                                    if (tail) utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                                    this.onData(utf8str);
                                } else this.onData(utils.shrinkBuf(strm.output, strm.next_out));
                            }
                        }
                    }while (strm.avail_in > 0 && status !== c.Z_STREAM_END);
                    if (status === c.Z_STREAM_END) _mode = c.Z_FINISH;
                    // Finalize on the last chunk.
                    if (_mode === c.Z_FINISH) {
                        status = zlib_inflate.inflateEnd(this.strm);
                        this.onEnd(status);
                        this.ended = true;
                        return status === c.Z_OK;
                    }
                    return true;
                };
                /**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ Inflate.prototype.onData = function(chunk) {
                    this.chunks.push(chunk);
                };
                /**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell inflate that input stream complete
 * or error happenned. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ Inflate.prototype.onEnd = function(status) {
                    // On success - join
                    if (status === c.Z_OK) {
                        if (this.options.to === 'string') // Glue & convert here, until we teach pako to send
                        // utf8 alligned strings to onData
                        this.result = this.chunks.join('');
                        else this.result = utils.flattenChunks(this.chunks);
                    }
                    this.chunks = [];
                    this.err = status;
                    this.msg = this.strm.msg;
                };
                /**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function inflate(input, options) {
                    var inflator = new Inflate(options);
                    inflator.push(input, true);
                    // That will never happens, if you don't cheat with options :)
                    if (inflator.err) throw inflator.msg;
                    return inflator.result;
                }
                /**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function inflateRaw(input, options) {
                    options = options || {};
                    options.raw = true;
                    return inflate(input, options);
                }
                /**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ exports.Inflate = Inflate;
                exports.inflate = inflate;
                exports.inflateRaw = inflateRaw;
                exports.ungzip = inflate;
            },
            {
                "./utils/common": 27,
                "./utils/strings": 28,
                "./zlib/constants": 30,
                "./zlib/gzheader": 33,
                "./zlib/inflate.js": 35,
                "./zlib/messages": 37,
                "./zlib/zstream": 39
            }
        ],
        27: [
            function(_dereq_, module1, exports) {
                'use strict';
                var TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
                exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
                    var sources = Array.prototype.slice.call(arguments, 1);
                    while(sources.length){
                        var source = sources.shift();
                        if (!source) continue;
                        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
                        for(var p in source)if (source.hasOwnProperty(p)) obj[p] = source[p];
                    }
                    return obj;
                };
                // reduce buffer size, avoiding mem copy
                exports.shrinkBuf = function(buf, size) {
                    if (buf.length === size) return buf;
                    if (buf.subarray) return buf.subarray(0, size);
                    buf.length = size;
                    return buf;
                };
                var fnTyped = {
                    arraySet: function(dest, src, src_offs, len, dest_offs) {
                        if (src.subarray && dest.subarray) {
                            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
                            return;
                        }
                        // Fallback to ordinary array
                        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
                    },
                    // Join array of chunks to single array.
                    flattenChunks: function(chunks) {
                        var i, l, len, pos, chunk, result;
                        // calculate data length
                        len = 0;
                        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
                        // join chunks
                        result = new Uint8Array(len);
                        pos = 0;
                        for(i = 0, l = chunks.length; i < l; i++){
                            chunk = chunks[i];
                            result.set(chunk, pos);
                            pos += chunk.length;
                        }
                        return result;
                    }
                };
                var fnUntyped = {
                    arraySet: function(dest, src, src_offs, len, dest_offs) {
                        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
                    },
                    // Join array of chunks to single array.
                    flattenChunks: function(chunks) {
                        return [].concat.apply([], chunks);
                    }
                };
                // Enable/Disable typed arrays use, for testing
                //
                exports.setTyped = function(on) {
                    if (on) {
                        exports.Buf8 = Uint8Array;
                        exports.Buf16 = Uint16Array;
                        exports.Buf32 = Int32Array;
                        exports.assign(exports, fnTyped);
                    } else {
                        exports.Buf8 = Array;
                        exports.Buf16 = Array;
                        exports.Buf32 = Array;
                        exports.assign(exports, fnUntyped);
                    }
                };
                exports.setTyped(TYPED_OK);
            },
            {}
        ],
        28: [
            function(_dereq_, module1, exports) {
                // String encode/decode helpers
                'use strict';
                var utils = _dereq_('./common');
                // Quick check if we can use fast array to bin string conversion
                //
                // - apply(Array) can fail on Android 2.2
                // - apply(Uint8Array) can fail on iOS 5.1 Safary
                //
                var STR_APPLY_OK = true;
                var STR_APPLY_UIA_OK = true;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (__) {
                    STR_APPLY_OK = false;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (__) {
                    STR_APPLY_UIA_OK = false;
                }
                // Table with utf8 lengths (calculated by first byte of sequence)
                // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
                // because max possible codepoint is 0x10ffff
                var _utf8len = new utils.Buf8(256);
                for(var i = 0; i < 256; i++)_utf8len[i] = i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1;
                _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
                // convert string to array (typed, when possible)
                exports.string2buf = function(str) {
                    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
                    // count binary size
                    for(m_pos = 0; m_pos < str_len; m_pos++){
                        c = str.charCodeAt(m_pos);
                        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                            c2 = str.charCodeAt(m_pos + 1);
                            if ((c2 & 0xfc00) === 0xdc00) {
                                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                                m_pos++;
                            }
                        }
                        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
                    }
                    // allocate buffer
                    buf = new utils.Buf8(buf_len);
                    // convert
                    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
                        c = str.charCodeAt(m_pos);
                        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                            c2 = str.charCodeAt(m_pos + 1);
                            if ((c2 & 0xfc00) === 0xdc00) {
                                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                                m_pos++;
                            }
                        }
                        if (c < 0x80) /* one byte */ buf[i++] = c;
                        else if (c < 0x800) {
                            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
                            buf[i++] = 0x80 | c & 0x3f;
                        } else if (c < 0x10000) {
                            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
                            buf[i++] = 0x80 | c >>> 6 & 0x3f;
                            buf[i++] = 0x80 | c & 0x3f;
                        } else {
                            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
                            buf[i++] = 0x80 | c >>> 12 & 0x3f;
                            buf[i++] = 0x80 | c >>> 6 & 0x3f;
                            buf[i++] = 0x80 | c & 0x3f;
                        }
                    }
                    return buf;
                };
                // Helper (used in 2 places)
                function buf2binstring(buf, len) {
                    // use fallback for big arrays to avoid stack overflow
                    if (len < 65537) {
                        if (buf.subarray && STR_APPLY_UIA_OK || !buf.subarray && STR_APPLY_OK) return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
                    }
                    var result = '';
                    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
                    return result;
                }
                // Convert byte array to binary string
                exports.buf2binstring = function(buf) {
                    return buf2binstring(buf, buf.length);
                };
                // Convert binary string (typed, when possible)
                exports.binstring2buf = function(str) {
                    var buf = new utils.Buf8(str.length);
                    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
                    return buf;
                };
                // convert array to string
                exports.buf2string = function(buf, max) {
                    var i, out, c, c_len;
                    var len = max || buf.length;
                    // Reserve max possible length (2 words per char)
                    // NB: by unknown reasons, Array is significantly faster for
                    //     String.fromCharCode.apply than Uint16Array.
                    var utf16buf = new Array(len * 2);
                    for(out = 0, i = 0; i < len;){
                        c = buf[i++];
                        // quick process ascii
                        if (c < 0x80) {
                            utf16buf[out++] = c;
                            continue;
                        }
                        c_len = _utf8len[c];
                        // skip 5 & 6 byte codes
                        if (c_len > 4) {
                            utf16buf[out++] = 0xfffd;
                            i += c_len - 1;
                            continue;
                        }
                        // apply mask on first byte
                        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
                        // join the rest
                        while(c_len > 1 && i < len){
                            c = c << 6 | buf[i++] & 0x3f;
                            c_len--;
                        }
                        // terminated by end of string?
                        if (c_len > 1) {
                            utf16buf[out++] = 0xfffd;
                            continue;
                        }
                        if (c < 0x10000) utf16buf[out++] = c;
                        else {
                            c -= 0x10000;
                            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
                            utf16buf[out++] = 0xdc00 | c & 0x3ff;
                        }
                    }
                    return buf2binstring(utf16buf, out);
                };
                // Calculate max possible position in utf8 buffer,
                // that will not break sequence. If that's not possible
                // - (very small limits) return max size as is.
                //
                // buf[] - utf8 bytes array
                // max   - length limit (mandatory);
                exports.utf8border = function(buf, max) {
                    var pos;
                    max = max || buf.length;
                    if (max > buf.length) max = buf.length;
                    // go back from last position, until start of sequence found
                    pos = max - 1;
                    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
                    // Fuckup - very small and broken sequence,
                    // return max, because we should return something anyway.
                    if (pos < 0) return max;
                    // If we came to start of buffer - that means vuffer is too small,
                    // return max too.
                    if (pos === 0) return max;
                    return pos + _utf8len[buf[pos]] > max ? pos : max;
                };
            },
            {
                "./common": 27
            }
        ],
        29: [
            function(_dereq_, module1, exports) {
                'use strict';
                // Note: adler32 takes 12% for level 0 and 2% for level 6.
                // It doesn't worth to make additional optimizationa as in original.
                // Small size is preferable.
                function adler32(adler, buf, len, pos) {
                    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
                    while(len !== 0){
                        // Set limit ~ twice less than 5552, to keep
                        // s2 in 31-bits, because we force signed ints.
                        // in other case %= will fail.
                        n = len > 2000 ? 2000 : len;
                        len -= n;
                        do {
                            s1 = s1 + buf[pos++] | 0;
                            s2 = s2 + s1 | 0;
                        }while (--n);
                        s1 %= 65521;
                        s2 %= 65521;
                    }
                    return s1 | s2 << 16 | 0;
                }
                module1.exports = adler32;
            },
            {}
        ],
        30: [
            function(_dereq_, module1, exports) {
                module1.exports = {
                    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    //Z_MEM_ERROR:     -4,
                    Z_BUF_ERROR: -5,
                    //Z_VERSION_ERROR: -6,
                    /* compression levels */ Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
                    Z_TEXT: 1,
                    //Z_ASCII:                1, // = Z_TEXT (deprecated)
                    Z_UNKNOWN: 2,
                    /* The deflate compression method */ Z_DEFLATED: 8
                };
            },
            {}
        ],
        31: [
            function(_dereq_, module1, exports) {
                'use strict';
                // Note: we can't get significant speed boost here.
                // So write code to minimize size - no pregenerated tables
                // and array tools dependencies.
                // Use ordinary array, since untyped makes no boost here
                function makeTable() {
                    var c, table = [];
                    for(var n = 0; n < 256; n++){
                        c = n;
                        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
                        table[n] = c;
                    }
                    return table;
                }
                // Create table on load. Just 255 signed longs. Not a problem.
                var crcTable = makeTable();
                function crc32(crc, buf, len, pos) {
                    var t = crcTable, end = pos + len;
                    crc = crc ^ -1;
                    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
                    return crc ^ -1; // >>> 0;
                }
                module1.exports = crc32;
            },
            {}
        ],
        32: [
            function(_dereq_, module1, exports) {
                'use strict';
                var utils = _dereq_('../utils/common');
                var trees = _dereq_('./trees');
                var adler32 = _dereq_('./adler32');
                var crc32 = _dereq_('./crc32');
                var msg = _dereq_('./messages');
                /* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var Z_NO_FLUSH = 0;
                var Z_PARTIAL_FLUSH = 1;
                //var Z_SYNC_FLUSH    = 2;
                var Z_FULL_FLUSH = 3;
                var Z_FINISH = 4;
                var Z_BLOCK = 5;
                //var Z_TREES         = 6;
                /* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
                var Z_STREAM_END = 1;
                //var Z_NEED_DICT     = 2;
                //var Z_ERRNO         = -1;
                var Z_STREAM_ERROR = -2;
                var Z_DATA_ERROR = -3;
                //var Z_MEM_ERROR     = -4;
                var Z_BUF_ERROR = -5;
                //var Z_VERSION_ERROR = -6;
                /* compression levels */ //var Z_NO_COMPRESSION      = 0;
                //var Z_BEST_SPEED          = 1;
                //var Z_BEST_COMPRESSION    = 9;
                var Z_DEFAULT_COMPRESSION = -1;
                var Z_FILTERED = 1;
                var Z_HUFFMAN_ONLY = 2;
                var Z_RLE = 3;
                var Z_FIXED = 4;
                var Z_DEFAULT_STRATEGY = 0;
                /* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
                //var Z_TEXT                = 1;
                //var Z_ASCII               = 1; // = Z_TEXT
                var Z_UNKNOWN = 2;
                /* The deflate compression method */ var Z_DEFLATED = 8;
                /*============================================================================*/ var MAX_MEM_LEVEL = 9;
                /* Maximum value for memLevel in deflateInit2 */ var MAX_WBITS = 15;
                /* 32K LZ77 window */ var DEF_MEM_LEVEL = 8;
                var LENGTH_CODES = 29;
                /* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
                /* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
                /* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
                /* number of distance codes */ var BL_CODES = 19;
                /* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
                /* maximum heap size */ var MAX_BITS = 15;
                /* All codes must not exceed MAX_BITS bits */ var MIN_MATCH = 3;
                var MAX_MATCH = 258;
                var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
                var PRESET_DICT = 0x20;
                var INIT_STATE = 42;
                var EXTRA_STATE = 69;
                var NAME_STATE = 73;
                var COMMENT_STATE = 91;
                var HCRC_STATE = 103;
                var BUSY_STATE = 113;
                var FINISH_STATE = 666;
                var BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
                var BS_BLOCK_DONE = 2; /* block flush performed */ 
                var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
                var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
                var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
                function err(strm, errorCode) {
                    strm.msg = msg[errorCode];
                    return errorCode;
                }
                function rank(f) {
                    return (f << 1) - (f > 4 ? 9 : 0);
                }
                function zero(buf) {
                    var len = buf.length;
                    while(--len >= 0)buf[len] = 0;
                }
                /* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function flush_pending(strm) {
                    var s = strm.state;
                    //_tr_flush_bits(s);
                    var len = s.pending;
                    if (len > strm.avail_out) len = strm.avail_out;
                    if (len === 0) return;
                    utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
                    strm.next_out += len;
                    s.pending_out += len;
                    strm.total_out += len;
                    strm.avail_out -= len;
                    s.pending -= len;
                    if (s.pending === 0) s.pending_out = 0;
                }
                function flush_block_only(s, last) {
                    trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
                    s.block_start = s.strstart;
                    flush_pending(s.strm);
                }
                function put_byte(s, b) {
                    s.pending_buf[s.pending++] = b;
                }
                /* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function putShortMSB(s, b) {
                    //  put_byte(s, (Byte)(b >> 8));
                    //  put_byte(s, (Byte)(b & 0xff));
                    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
                    s.pending_buf[s.pending++] = b & 0xff;
                }
                /* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function read_buf(strm, buf, start, size) {
                    var len = strm.avail_in;
                    if (len > size) len = size;
                    if (len === 0) return 0;
                    strm.avail_in -= len;
                    utils.arraySet(buf, strm.input, strm.next_in, len, start);
                    if (strm.state.wrap === 1) strm.adler = adler32(strm.adler, buf, len, start);
                    else if (strm.state.wrap === 2) strm.adler = crc32(strm.adler, buf, len, start);
                    strm.next_in += len;
                    strm.total_in += len;
                    return len;
                }
                /* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function longest_match(s, cur_match) {
                    var chain_length = s.max_chain_length; /* max hash chain length */ 
                    var scan = s.strstart; /* current string */ 
                    var match; /* matched string */ 
                    var len; /* length of current match */ 
                    var best_len = s.prev_length; /* best match length so far */ 
                    var nice_match = s.nice_match; /* stop if match long enough */ 
                    var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
                    var _win = s.window; // shortcut
                    var wmask = s.w_mask;
                    var prev = s.prev;
                    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + MAX_MATCH;
                    var scan_end1 = _win[scan + best_len - 1];
                    var scan_end = _win[scan + best_len];
                    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
                    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
                    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
                    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
                    do {
                        // Assert(cur_match < s->strstart, "no future");
                        match = cur_match;
                        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
                        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
                        match++;
                        // Assert(*scan == *match, "match[2]?");
                        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
                        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
                        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                        len = MAX_MATCH - (strend - scan);
                        scan = strend - MAX_MATCH;
                        if (len > best_len) {
                            s.match_start = cur_match;
                            best_len = len;
                            if (len >= nice_match) break;
                            scan_end1 = _win[scan + best_len - 1];
                            scan_end = _win[scan + best_len];
                        }
                    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
                    if (best_len <= s.lookahead) return best_len;
                    return s.lookahead;
                }
                /* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function fill_window(s) {
                    var _w_size = s.w_size;
                    var p, n, m, more, str;
                    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
                    do {
                        more = s.window_size - s.lookahead - s.strstart;
                        // JS ints have 32 bit, block below not needed
                        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
                        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                        //        more = wsize;
                        //
                        //  } else if (more == (unsigned)(-1)) {
                        //        /* Very unlikely, but possible on 16 bit machine if
                        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                        //         */
                        //        more--;
                        //    }
                        //}
                        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                            utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
                            s.match_start -= _w_size;
                            s.strstart -= _w_size;
                            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
                            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
                            p = n;
                            do {
                                m = s.head[--p];
                                s.head[p] = m >= _w_size ? m - _w_size : 0;
                            }while (--n);
                            n = _w_size;
                            p = n;
                            do {
                                m = s.prev[--p];
                                s.prev[p] = m >= _w_size ? m - _w_size : 0;
                            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
                            more += _w_size;
                        }
                        if (s.strm.avail_in === 0) break;
                        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
                        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                        s.lookahead += n;
                        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
                            str = s.strstart - s.insert;
                            s.ins_h = s.window[str];
                            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
                            //#if MIN_MATCH != 3
                            //        Call update_hash() MIN_MATCH-3 more times
                            //#endif
                            while(s.insert){
                                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                                s.prev[str & s.w_mask] = s.head[s.ins_h];
                                s.head[s.ins_h] = str;
                                str++;
                                s.insert--;
                                if (s.lookahead + s.insert < MIN_MATCH) break;
                            }
                        }
                    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
                /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
                //    var curr = s.strstart + s.lookahead;
                //    var init = 0;
                //
                //    if (s.high_water < curr) {
                //      /* Previous high water mark below current data -- zero WIN_INIT
                //       * bytes or up to end of window, whichever is less.
                //       */
                //      init = s.window_size - curr;
                //      if (init > WIN_INIT)
                //        init = WIN_INIT;
                //      zmemzero(s->window + curr, (unsigned)init);
                //      s->high_water = curr + init;
                //    }
                //    else if (s->high_water < (ulg)curr + WIN_INIT) {
                //      /* High water mark at or above current data, but below current data
                //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
                //       * to end of window, whichever is less.
                //       */
                //      init = (ulg)curr + WIN_INIT - s->high_water;
                //      if (init > s->window_size - s->high_water)
                //        init = s->window_size - s->high_water;
                //      zmemzero(s->window + s->high_water, (unsigned)init);
                //      s->high_water += init;
                //    }
                //  }
                //
                //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
                //    "not enough room for search");
                }
                /* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function deflate_stored(s, flush) {
                    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
                    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
                    /* Copy as much as possible from input to output: */ for(;;){
                        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
                            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                            //  s->block_start >= (long)s->w_size, "slide too late");
                            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                            //        s.block_start >= s.w_size)) {
                            //        throw  new Error("slide too late");
                            //      }
                            fill_window(s);
                            if (s.lookahead === 0 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break;
                        /* flush the current block */ }
                        //Assert(s->block_start >= 0L, "block gone");
                        //    if (s.block_start < 0) throw new Error("block gone");
                        s.strstart += s.lookahead;
                        s.lookahead = 0;
                        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
                        if (s.strstart === 0 || s.strstart >= max_start) {
                            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
                            s.strstart = max_start;
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = 0;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.strstart > s.block_start) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_NEED_MORE;
                }
                /* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function deflate_fast(s, flush) {
                    var hash_head; /* head of the hash chain */ 
                    var bflush; /* set if current block must be flushed */ 
                    for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
                            fill_window(s);
                            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break; /* flush the current block */ 
                        }
                        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
                        if (s.lookahead >= MIN_MATCH) {
                            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                        /***/ }
                        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
                        if (s.match_length >= MIN_MATCH) {
                            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
                            s.lookahead -= s.match_length;
                            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                                s.match_length--; /* string at strstart already in table */ 
                                do {
                                    s.strstart++;
                                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                                    s.head[s.ins_h] = s.strstart;
                                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                                s.strstart++;
                            } else {
                                s.strstart += s.match_length;
                                s.match_length = 0;
                                s.ins_h = s.window[s.strstart];
                                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
                            //#if MIN_MATCH != 3
                            //                Call UPDATE_HASH() MIN_MATCH-3 more times
                            //#endif
                            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
                        } else {
                            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
                            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                            s.lookahead--;
                            s.strstart++;
                        }
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function deflate_slow(s, flush) {
                    var hash_head; /* head of hash chain */ 
                    var bflush; /* set if current block must be flushed */ 
                    var max_insert;
                    /* Process the input block. */ for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
                            fill_window(s);
                            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break;
                             /* flush the current block */ 
                        }
                        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
                        if (s.lookahead >= MIN_MATCH) {
                            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                        /***/ }
                        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
                        s.prev_match = s.match_start;
                        s.match_length = MIN_MATCH - 1;
                        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
                            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
                        }
                        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
                            max_insert = s.strstart + s.lookahead - MIN_MATCH;
                            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
                            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
                            s.prev_length -= 2;
                            do if (++s.strstart <= max_insert) {
                                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                                s.head[s.ins_h] = s.strstart;
                            /***/ }
                            while (--s.prev_length !== 0);
                            s.match_available = 0;
                            s.match_length = MIN_MATCH - 1;
                            s.strstart++;
                            if (bflush) {
                                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                                if (s.strm.avail_out === 0) return BS_NEED_MORE;
                            /***/ }
                        } else if (s.match_available) {
                            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
                            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
                            s.strstart++;
                            s.lookahead--;
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        } else {
                            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
                            s.strstart++;
                            s.lookahead--;
                        }
                    }
                    //Assert (flush != Z_NO_FLUSH, "no flush?");
                    if (s.match_available) {
                        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
                        s.match_available = 0;
                    }
                    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function deflate_rle(s, flush) {
                    var bflush; /* set if current block must be flushed */ 
                    var prev; /* byte at distance one to match */ 
                    var scan, strend; /* scan goes up to strend for length of run */ 
                    var _win = s.window;
                    for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
                            fill_window(s);
                            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break;
                             /* flush the current block */ 
                        }
                        /* See how many times the previous byte repeats */ s.match_length = 0;
                        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
                            scan = s.strstart - 1;
                            prev = _win[scan];
                            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                                strend = s.strstart + MAX_MATCH;
                                do ;
                                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                                s.match_length = MAX_MATCH - (strend - scan);
                                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
                            }
                        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                        }
                        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
                            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
                            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
                            s.lookahead -= s.match_length;
                            s.strstart += s.match_length;
                            s.match_length = 0;
                        } else {
                            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
                            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                            s.lookahead--;
                            s.strstart++;
                        }
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = 0;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function deflate_huff(s, flush) {
                    var bflush; /* set if current block must be flushed */ 
                    for(;;){
                        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
                            fill_window(s);
                            if (s.lookahead === 0) {
                                if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
                                break; /* flush the current block */ 
                            }
                        }
                        /* Output a literal byte */ s.match_length = 0;
                        //Tracevv((stderr,"%c", s->window[s->strstart]));
                        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                        s.lookahead--;
                        s.strstart++;
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = 0;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ var Config = function(good_length, max_lazy, nice_length, max_chain, func) {
                    this.good_length = good_length;
                    this.max_lazy = max_lazy;
                    this.nice_length = nice_length;
                    this.max_chain = max_chain;
                    this.func = func;
                };
                var configuration_table;
                configuration_table = [
                    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
                    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
                    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
                    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
                    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
                    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
                    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
                    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
                    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
                    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
                ];
                /* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function lm_init(s) {
                    s.window_size = 2 * s.w_size;
                    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
                    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
                    s.good_match = configuration_table[s.level].good_length;
                    s.nice_match = configuration_table[s.level].nice_length;
                    s.max_chain_length = configuration_table[s.level].max_chain;
                    s.strstart = 0;
                    s.block_start = 0;
                    s.lookahead = 0;
                    s.insert = 0;
                    s.match_length = s.prev_length = MIN_MATCH - 1;
                    s.match_available = 0;
                    s.ins_h = 0;
                }
                function DeflateState() {
                    this.strm = null; /* pointer back to this zlib stream */ 
                    this.status = 0; /* as the name implies */ 
                    this.pending_buf = null; /* output still pending */ 
                    this.pending_buf_size = 0; /* size of pending_buf */ 
                    this.pending_out = 0; /* next pending byte to output to the stream */ 
                    this.pending = 0; /* nb of bytes in the pending buffer */ 
                    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
                    this.gzhead = null; /* gzip header information to write */ 
                    this.gzindex = 0; /* where in extra, name, or comment */ 
                    this.method = Z_DEFLATED; /* can only be DEFLATED */ 
                    this.last_flush = -1; /* value of flush param for previous deflate call */ 
                    this.w_size = 0; /* LZ77 window size (32K by default) */ 
                    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
                    this.w_mask = 0; /* w_size - 1 */ 
                    this.window = null;
                    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
                    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
                    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
                    this.ins_h = 0; /* hash index of string to be inserted */ 
                    this.hash_size = 0; /* number of elements in hash table */ 
                    this.hash_bits = 0; /* log2(hash_size) */ 
                    this.hash_mask = 0; /* hash_size-1 */ 
                    this.hash_shift = 0;
                    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
                    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
                    this.prev_match = 0; /* previous match */ 
                    this.match_available = 0; /* set if previous match exists */ 
                    this.strstart = 0; /* start of string to insert */ 
                    this.match_start = 0; /* start of matching string */ 
                    this.lookahead = 0; /* number of valid bytes ahead in window */ 
                    this.prev_length = 0;
                    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
                    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
                    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
                    //this.max_insert_length = 0;
                    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
                    this.strategy = 0; /* favor or force Huffman coding*/ 
                    this.good_match = 0;
                    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
                    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
                    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
                    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
                    // Use flat array of DOUBLE size, with interleaved fata,
                    // because JS does not support effective
                    this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
                    this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
                    this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
                    zero(this.dyn_ltree);
                    zero(this.dyn_dtree);
                    zero(this.bl_tree);
                    this.l_desc = null; /* desc. for literal tree */ 
                    this.d_desc = null; /* desc. for distance tree */ 
                    this.bl_desc = null; /* desc. for bit length tree */ 
                    //ush bl_count[MAX_BITS+1];
                    this.bl_count = new utils.Buf16(MAX_BITS + 1);
                    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
                    this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
                    zero(this.heap);
                    this.heap_len = 0; /* number of elements in the heap */ 
                    this.heap_max = 0; /* element of largest frequency */ 
                    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
                    zero(this.depth);
                    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
                    this.lit_bufsize = 0;
                    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
                    this.d_buf = 0;
                    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
                    this.static_len = 0; /* bit length of current block with static trees */ 
                    this.matches = 0; /* number of string matches in current block */ 
                    this.insert = 0; /* bytes at end of window left to insert */ 
                    this.bi_buf = 0;
                    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
                /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
                // sense only for pointers and memory check tools.
                //this.high_water = 0;
                /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
                function deflateResetKeep(strm) {
                    var s;
                    if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR);
                    strm.total_in = strm.total_out = 0;
                    strm.data_type = Z_UNKNOWN;
                    s = strm.state;
                    s.pending = 0;
                    s.pending_out = 0;
                    if (s.wrap < 0) s.wrap = -s.wrap;
                    s.status = s.wrap ? INIT_STATE : BUSY_STATE;
                    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
                     : 1; // adler32(0, Z_NULL, 0)
                    s.last_flush = Z_NO_FLUSH;
                    trees._tr_init(s);
                    return Z_OK;
                }
                function deflateReset(strm) {
                    var ret = deflateResetKeep(strm);
                    if (ret === Z_OK) lm_init(strm.state);
                    return ret;
                }
                function deflateSetHeader(strm, head) {
                    if (!strm || !strm.state) return Z_STREAM_ERROR;
                    if (strm.state.wrap !== 2) return Z_STREAM_ERROR;
                    strm.state.gzhead = head;
                    return Z_OK;
                }
                function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
                    if (!strm) return Z_STREAM_ERROR;
                    var wrap = 1;
                    if (level === Z_DEFAULT_COMPRESSION) level = 6;
                    if (windowBits < 0) {
                        wrap = 0;
                        windowBits = -windowBits;
                    } else if (windowBits > 15) {
                        wrap = 2; /* write gzip wrapper instead */ 
                        windowBits -= 16;
                    }
                    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR);
                    if (windowBits === 8) windowBits = 9;
                    /* until 256-byte window bug fixed */ var s = new DeflateState();
                    strm.state = s;
                    s.strm = strm;
                    s.wrap = wrap;
                    s.gzhead = null;
                    s.w_bits = windowBits;
                    s.w_size = 1 << s.w_bits;
                    s.w_mask = s.w_size - 1;
                    s.hash_bits = memLevel + 7;
                    s.hash_size = 1 << s.hash_bits;
                    s.hash_mask = s.hash_size - 1;
                    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
                    s.window = new utils.Buf8(s.w_size * 2);
                    s.head = new utils.Buf16(s.hash_size);
                    s.prev = new utils.Buf16(s.w_size);
                    // Don't need mem init magic for JS.
                    //s.high_water = 0;  /* nothing written to s->window yet */
                    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
                    s.pending_buf_size = s.lit_bufsize * 4;
                    s.pending_buf = new utils.Buf8(s.pending_buf_size);
                    s.d_buf = s.lit_bufsize >> 1;
                    s.l_buf = 3 * s.lit_bufsize;
                    s.level = level;
                    s.strategy = strategy;
                    s.method = method;
                    return deflateReset(strm);
                }
                function deflateInit(strm, level) {
                    return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
                }
                function deflate(strm, flush) {
                    var old_flush, s;
                    var beg, val; // for gzip header write only
                    if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
                    s = strm.state;
                    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
                    s.strm = strm; /* just in case */ 
                    old_flush = s.last_flush;
                    s.last_flush = flush;
                    /* Write the header */ if (s.status === INIT_STATE) {
                        if (s.wrap === 2) {
                            strm.adler = 0; //crc32(0L, Z_NULL, 0);
                            put_byte(s, 31);
                            put_byte(s, 139);
                            put_byte(s, 8);
                            if (!s.gzhead) {
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                                put_byte(s, OS_CODE);
                                s.status = BUSY_STATE;
                            } else {
                                put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                                put_byte(s, s.gzhead.time & 0xff);
                                put_byte(s, s.gzhead.time >> 8 & 0xff);
                                put_byte(s, s.gzhead.time >> 16 & 0xff);
                                put_byte(s, s.gzhead.time >> 24 & 0xff);
                                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                                put_byte(s, s.gzhead.os & 0xff);
                                if (s.gzhead.extra && s.gzhead.extra.length) {
                                    put_byte(s, s.gzhead.extra.length & 0xff);
                                    put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                                }
                                if (s.gzhead.hcrc) strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
                                s.gzindex = 0;
                                s.status = EXTRA_STATE;
                            }
                        } else {
                            var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
                            var level_flags = -1;
                            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
                            else if (s.level < 6) level_flags = 1;
                            else if (s.level === 6) level_flags = 2;
                            else level_flags = 3;
                            header |= level_flags << 6;
                            if (s.strstart !== 0) header |= PRESET_DICT;
                            header += 31 - header % 31;
                            s.status = BUSY_STATE;
                            putShortMSB(s, header);
                            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                                putShortMSB(s, strm.adler >>> 16);
                                putShortMSB(s, strm.adler & 0xffff);
                            }
                            strm.adler = 1; // adler32(0L, Z_NULL, 0);
                        }
                    }
                    //#ifdef GZIP
                    if (s.status === EXTRA_STATE) {
                        if (s.gzhead.extra /* != Z_NULL*/ ) {
                            beg = s.pending; /* start of bytes to update crc */ 
                            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                                if (s.pending === s.pending_buf_size) {
                                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                    flush_pending(strm);
                                    beg = s.pending;
                                    if (s.pending === s.pending_buf_size) break;
                                }
                                put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                                s.gzindex++;
                            }
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                            if (s.gzindex === s.gzhead.extra.length) {
                                s.gzindex = 0;
                                s.status = NAME_STATE;
                            }
                        } else s.status = NAME_STATE;
                    }
                    if (s.status === NAME_STATE) {
                        if (s.gzhead.name /* != Z_NULL*/ ) {
                            beg = s.pending; /* start of bytes to update crc */ 
                            //int val;
                            do {
                                if (s.pending === s.pending_buf_size) {
                                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                    flush_pending(strm);
                                    beg = s.pending;
                                    if (s.pending === s.pending_buf_size) {
                                        val = 1;
                                        break;
                                    }
                                }
                                // JS specific: little magic to add zero terminator to end of string
                                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                                else val = 0;
                                put_byte(s, val);
                            }while (val !== 0);
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                            if (val === 0) {
                                s.gzindex = 0;
                                s.status = COMMENT_STATE;
                            }
                        } else s.status = COMMENT_STATE;
                    }
                    if (s.status === COMMENT_STATE) {
                        if (s.gzhead.comment /* != Z_NULL*/ ) {
                            beg = s.pending; /* start of bytes to update crc */ 
                            //int val;
                            do {
                                if (s.pending === s.pending_buf_size) {
                                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                    flush_pending(strm);
                                    beg = s.pending;
                                    if (s.pending === s.pending_buf_size) {
                                        val = 1;
                                        break;
                                    }
                                }
                                // JS specific: little magic to add zero terminator to end of string
                                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                                else val = 0;
                                put_byte(s, val);
                            }while (val !== 0);
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                            if (val === 0) s.status = HCRC_STATE;
                        } else s.status = HCRC_STATE;
                    }
                    if (s.status === HCRC_STATE) {
                        if (s.gzhead.hcrc) {
                            if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
                            if (s.pending + 2 <= s.pending_buf_size) {
                                put_byte(s, strm.adler & 0xff);
                                put_byte(s, strm.adler >> 8 & 0xff);
                                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                                s.status = BUSY_STATE;
                            }
                        } else s.status = BUSY_STATE;
                    }
                    //#endif
                    /* Flush as much pending output as possible */ if (s.pending !== 0) {
                        flush_pending(strm);
                        if (strm.avail_out === 0) {
                            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
                            return Z_OK;
                        }
                    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) return err(strm, Z_BUF_ERROR);
                    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR);
                    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
                        var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
                        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
                        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                            if (strm.avail_out === 0) s.last_flush = -1;
                            return Z_OK;
                        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
                        if (bstate === BS_BLOCK_DONE) {
                            if (flush === Z_PARTIAL_FLUSH) trees._tr_align(s);
                            else if (flush !== Z_BLOCK) {
                                trees._tr_stored_block(s, 0, 0, false);
                                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH) {
                                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                                    if (s.lookahead === 0) {
                                        s.strstart = 0;
                                        s.block_start = 0;
                                        s.insert = 0;
                                    }
                                }
                            }
                            flush_pending(strm);
                            if (strm.avail_out === 0) {
                                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                                return Z_OK;
                            }
                        }
                    }
                    //Assert(strm->avail_out > 0, "bug2");
                    //if (strm.avail_out <= 0) { throw new Error("bug2");}
                    if (flush !== Z_FINISH) return Z_OK;
                    if (s.wrap <= 0) return Z_STREAM_END;
                    /* Write the trailer */ if (s.wrap === 2) {
                        put_byte(s, strm.adler & 0xff);
                        put_byte(s, strm.adler >> 8 & 0xff);
                        put_byte(s, strm.adler >> 16 & 0xff);
                        put_byte(s, strm.adler >> 24 & 0xff);
                        put_byte(s, strm.total_in & 0xff);
                        put_byte(s, strm.total_in >> 8 & 0xff);
                        put_byte(s, strm.total_in >> 16 & 0xff);
                        put_byte(s, strm.total_in >> 24 & 0xff);
                    } else {
                        putShortMSB(s, strm.adler >>> 16);
                        putShortMSB(s, strm.adler & 0xffff);
                    }
                    flush_pending(strm);
                    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
                    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK : Z_STREAM_END;
                }
                function deflateEnd(strm) {
                    var status;
                    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
                    status = strm.state.status;
                    if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR);
                    strm.state = null;
                    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
                }
                /* =========================================================================
 * Copy the source state to the destination state
 */ //function deflateCopy(dest, source) {
                //
                //}
                exports.deflateInit = deflateInit;
                exports.deflateInit2 = deflateInit2;
                exports.deflateReset = deflateReset;
                exports.deflateResetKeep = deflateResetKeep;
                exports.deflateSetHeader = deflateSetHeader;
                exports.deflate = deflate;
                exports.deflateEnd = deflateEnd;
                exports.deflateInfo = 'pako deflate (from Nodeca project)';
            /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ },
            {
                "../utils/common": 27,
                "./adler32": 29,
                "./crc32": 31,
                "./messages": 37,
                "./trees": 38
            }
        ],
        33: [
            function(_dereq_, module1, exports) {
                'use strict';
                function GZheader() {
                    /* true if compressed data believed to be text */ this.text = 0;
                    /* modification time */ this.time = 0;
                    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
                    /* operating system */ this.os = 0;
                    /* pointer to extra field or Z_NULL if none */ this.extra = null;
                    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
                    // but leave for few code modifications
                    //
                    // Setup limits is not necessary because in js we should not preallocate memory
                    // for inflate use constant limit in 65536 bytes
                    //
                    /* space at extra (only when reading header) */ // this.extra_max  = 0;
                    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
                    /* space at name (only when reading header) */ // this.name_max   = 0;
                    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
                    /* space at comment (only when reading header) */ // this.comm_max   = 0;
                    /* true if there was or will be a header crc */ this.hcrc = 0;
                    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
                }
                module1.exports = GZheader;
            },
            {}
        ],
        34: [
            function(_dereq_, module1, exports) {
                'use strict';
                // See state defs from inflate.js
                var BAD = 30; /* got a data error -- remain here until reset */ 
                var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
                /*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module1.exports = function inflate_fast(strm, start) {
                    var state;
                    var _in; /* local strm.input */ 
                    var last; /* have enough input while in < last */ 
                    var _out; /* local strm.output */ 
                    var beg; /* inflate()'s initial strm.output */ 
                    var end; /* while out < end, enough space available */ 
                    //#ifdef INFLATE_STRICT
                    var dmax; /* maximum distance from zlib header */ 
                    //#endif
                    var wsize; /* window size or zero if not using window */ 
                    var whave; /* valid bytes in the window */ 
                    var wnext; /* window write index */ 
                    var window1; /* allocated sliding window, if wsize != 0 */ 
                    var hold; /* local strm.hold */ 
                    var bits; /* local strm.bits */ 
                    var lcode; /* local strm.lencode */ 
                    var dcode; /* local strm.distcode */ 
                    var lmask; /* mask for first level of length codes */ 
                    var dmask; /* mask for first level of distance codes */ 
                    var here; /* retrieved table entry */ 
                    var op; /* code bits, operation, extra bits, or */ 
                    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
                    var dist; /* match distance */ 
                    var from; /* where to copy match from */ 
                    var from_source;
                    var input, output; // JS specific, because we have no pointers
                    /* copy state to local variables */ state = strm.state;
                    //here = state.here;
                    _in = strm.next_in;
                    input = strm.input;
                    last = _in + (strm.avail_in - 5);
                    _out = strm.next_out;
                    output = strm.output;
                    beg = _out - (start - strm.avail_out);
                    end = _out + (strm.avail_out - 257);
                    //#ifdef INFLATE_STRICT
                    dmax = state.dmax;
                    //#endif
                    wsize = state.wsize;
                    whave = state.whave;
                    wnext = state.wnext;
                    window1 = state.window;
                    hold = state.hold;
                    bits = state.bits;
                    lcode = state.lencode;
                    dcode = state.distcode;
                    lmask = (1 << state.lenbits) - 1;
                    dmask = (1 << state.distbits) - 1;
                    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
                        if (bits < 15) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            hold += input[_in++] << bits;
                            bits += 8;
                        }
                        here = lcode[hold & lmask];
                        dolen: for(;;){
                            op = here >>> 24 /*here.bits*/ ;
                            hold >>>= op;
                            bits -= op;
                            op = here >>> 16 & 0xff /*here.op*/ ;
                            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                            //        "inflate:         literal '%c'\n" :
                            //        "inflate:         literal 0x%02x\n", here.val));
                            output[_out++] = here & 0xffff /*here.val*/ ;
                            else if (op & 16) {
                                len = here & 0xffff /*here.val*/ ;
                                op &= 15; /* number of extra bits */ 
                                if (op) {
                                    if (bits < op) {
                                        hold += input[_in++] << bits;
                                        bits += 8;
                                    }
                                    len += hold & (1 << op) - 1;
                                    hold >>>= op;
                                    bits -= op;
                                }
                                //Tracevv((stderr, "inflate:         length %u\n", len));
                                if (bits < 15) {
                                    hold += input[_in++] << bits;
                                    bits += 8;
                                    hold += input[_in++] << bits;
                                    bits += 8;
                                }
                                here = dcode[hold & dmask];
                                dodist: for(;;){
                                    op = here >>> 24 /*here.bits*/ ;
                                    hold >>>= op;
                                    bits -= op;
                                    op = here >>> 16 & 0xff /*here.op*/ ;
                                    if (op & 16) {
                                        dist = here & 0xffff /*here.val*/ ;
                                        op &= 15; /* number of extra bits */ 
                                        if (bits < op) {
                                            hold += input[_in++] << bits;
                                            bits += 8;
                                            if (bits < op) {
                                                hold += input[_in++] << bits;
                                                bits += 8;
                                            }
                                        }
                                        dist += hold & (1 << op) - 1;
                                        //#ifdef INFLATE_STRICT
                                        if (dist > dmax) {
                                            strm.msg = 'invalid distance too far back';
                                            state.mode = BAD;
                                            break top;
                                        }
                                        //#endif
                                        hold >>>= op;
                                        bits -= op;
                                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                                        op = _out - beg; /* max distance in output */ 
                                        if (dist > op) {
                                            op = dist - op; /* distance back in window */ 
                                            if (op > whave) {
                                                if (state.sane) {
                                                    strm.msg = 'invalid distance too far back';
                                                    state.mode = BAD;
                                                    break top;
                                                }
                                            }
                                            from = 0; // window index
                                            from_source = window1;
                                            if (wnext === 0) {
                                                from += wsize - op;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = window1[from++];
                                                    while (--op);
                                                    from = _out - dist; /* rest from output */ 
                                                    from_source = output;
                                                }
                                            } else if (wnext < op) {
                                                from += wsize + wnext - op;
                                                op -= wnext;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = window1[from++];
                                                    while (--op);
                                                    from = 0;
                                                    if (wnext < len) {
                                                        op = wnext;
                                                        len -= op;
                                                        do output[_out++] = window1[from++];
                                                        while (--op);
                                                        from = _out - dist; /* rest from output */ 
                                                        from_source = output;
                                                    }
                                                }
                                            } else {
                                                from += wnext - op;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = window1[from++];
                                                    while (--op);
                                                    from = _out - dist; /* rest from output */ 
                                                    from_source = output;
                                                }
                                            }
                                            while(len > 2){
                                                output[_out++] = from_source[from++];
                                                output[_out++] = from_source[from++];
                                                output[_out++] = from_source[from++];
                                                len -= 3;
                                            }
                                            if (len) {
                                                output[_out++] = from_source[from++];
                                                if (len > 1) output[_out++] = from_source[from++];
                                            }
                                        } else {
                                            from = _out - dist; /* copy direct from output */ 
                                            do {
                                                output[_out++] = output[from++];
                                                output[_out++] = output[from++];
                                                output[_out++] = output[from++];
                                                len -= 3;
                                            }while (len > 2);
                                            if (len) {
                                                output[_out++] = output[from++];
                                                if (len > 1) output[_out++] = output[from++];
                                            }
                                        }
                                    } else if ((op & 64) === 0) {
                                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                                        continue dodist;
                                    } else {
                                        strm.msg = 'invalid distance code';
                                        state.mode = BAD;
                                        break top;
                                    }
                                    break; // need to emulate goto via "continue"
                                }
                            } else if ((op & 64) === 0) {
                                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                                continue dolen;
                            } else if (op & 32) {
                                //Tracevv((stderr, "inflate:         end of block\n"));
                                state.mode = TYPE;
                                break top;
                            } else {
                                strm.msg = 'invalid literal/length code';
                                state.mode = BAD;
                                break top;
                            }
                            break; // need to emulate goto via "continue"
                        }
                    }while (_in < last && _out < end);
                    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
                    _in -= len;
                    bits -= len << 3;
                    hold &= (1 << bits) - 1;
                    /* update state and return */ strm.next_in = _in;
                    strm.next_out = _out;
                    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
                    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
                    state.hold = hold;
                    state.bits = bits;
                    return;
                };
            },
            {}
        ],
        35: [
            function(_dereq_, module1, exports) {
                'use strict';
                var utils = _dereq_('../utils/common');
                var adler32 = _dereq_('./adler32');
                var crc32 = _dereq_('./crc32');
                var inflate_fast = _dereq_('./inffast');
                var inflate_table = _dereq_('./inftrees');
                var CODES = 0;
                var LENS = 1;
                var DISTS = 2;
                /* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
                //var Z_PARTIAL_FLUSH = 1;
                //var Z_SYNC_FLUSH    = 2;
                //var Z_FULL_FLUSH    = 3;
                var Z_FINISH = 4;
                var Z_BLOCK = 5;
                var Z_TREES = 6;
                /* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
                var Z_STREAM_END = 1;
                var Z_NEED_DICT = 2;
                //var Z_ERRNO         = -1;
                var Z_STREAM_ERROR = -2;
                var Z_DATA_ERROR = -3;
                var Z_MEM_ERROR = -4;
                var Z_BUF_ERROR = -5;
                //var Z_VERSION_ERROR = -6;
                /* The deflate compression method */ var Z_DEFLATED = 8;
                /* STATES ====================================================================*/ /* ===========================================================================*/ var HEAD = 1; /* i: waiting for magic header */ 
                var FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
                var TIME = 3; /* i: waiting for modification time (gzip) */ 
                var OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
                var EXLEN = 5; /* i: waiting for extra length (gzip) */ 
                var EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
                var NAME = 7; /* i: waiting for end of file name (gzip) */ 
                var COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
                var HCRC = 9; /* i: waiting for header crc (gzip) */ 
                var DICTID = 10; /* i: waiting for dictionary check value */ 
                var DICT = 11; /* waiting for inflateSetDictionary() call */ 
                var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
                var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
                var STORED = 14; /* i: waiting for stored size (length and complement) */ 
                var COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
                var COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
                var TABLE = 17; /* i: waiting for dynamic block table lengths */ 
                var LENLENS = 18; /* i: waiting for code length code lengths */ 
                var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
                var LEN_ = 20; /* i: same as LEN below, but only first time in */ 
                var LEN = 21; /* i: waiting for length/lit/eob code */ 
                var LENEXT = 22; /* i: waiting for length extra bits */ 
                var DIST = 23; /* i: waiting for distance code */ 
                var DISTEXT = 24; /* i: waiting for distance extra bits */ 
                var MATCH = 25; /* o: waiting for output space to copy string */ 
                var LIT = 26; /* o: waiting for output space to write literal */ 
                var CHECK = 27; /* i: waiting for 32-bit check value */ 
                var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
                var DONE = 29; /* finished check, done -- remain here until reset */ 
                var BAD = 30; /* got a data error -- remain here until reset */ 
                var MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
                var SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
                /* ===========================================================================*/ var ENOUGH_LENS = 852;
                var ENOUGH_DISTS = 592;
                //var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
                var MAX_WBITS = 15;
                /* 32K LZ77 window */ var DEF_WBITS = MAX_WBITS;
                function ZSWAP32(q) {
                    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
                }
                function InflateState() {
                    this.mode = 0; /* current inflate mode */ 
                    this.last = false; /* true if processing last block */ 
                    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
                    this.havedict = false; /* true if dictionary provided */ 
                    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
                    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
                    this.check = 0; /* protected copy of check value */ 
                    this.total = 0; /* protected copy of output count */ 
                    // TODO: may be {}
                    this.head = null; /* where to save gzip header information */ 
                    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
                    this.wsize = 0; /* window size or zero if not using window */ 
                    this.whave = 0; /* valid bytes in the window */ 
                    this.wnext = 0; /* window write index */ 
                    this.window = null; /* allocated sliding window, if needed */ 
                    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
                    this.bits = 0; /* number of bits in "in" */ 
                    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
                    this.offset = 0; /* distance back to copy string from */ 
                    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
                    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
                    this.distcode = null; /* starting table for distance codes */ 
                    this.lenbits = 0; /* index bits for lencode */ 
                    this.distbits = 0; /* index bits for distcode */ 
                    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
                    this.nlen = 0; /* number of length code lengths */ 
                    this.ndist = 0; /* number of distance code lengths */ 
                    this.have = 0; /* number of code lengths in lens[] */ 
                    this.next = null; /* next available space in codes[] */ 
                    this.lens = new utils.Buf16(320); /* temporary storage for code lengths */ 
                    this.work = new utils.Buf16(288); /* work area for code table building */ 
                    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
                    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
                    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
                    this.sane = 0; /* if false, allow invalid distance too far */ 
                    this.back = 0; /* bits back of last unprocessed length/lit */ 
                    this.was = 0; /* initial length of match */ 
                }
                function inflateResetKeep(strm) {
                    var state;
                    if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    strm.total_in = strm.total_out = state.total = 0;
                    strm.msg = ''; /*Z_NULL*/ 
                    if (state.wrap) strm.adler = state.wrap & 1;
                    state.mode = HEAD;
                    state.last = 0;
                    state.havedict = 0;
                    state.dmax = 32768;
                    state.head = null /*Z_NULL*/ ;
                    state.hold = 0;
                    state.bits = 0;
                    //state.lencode = state.distcode = state.next = state.codes;
                    state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
                    state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
                    state.sane = 1;
                    state.back = -1;
                    //Tracev((stderr, "inflate: reset\n"));
                    return Z_OK;
                }
                function inflateReset(strm) {
                    var state;
                    if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    state.wsize = 0;
                    state.whave = 0;
                    state.wnext = 0;
                    return inflateResetKeep(strm);
                }
                function inflateReset2(strm, windowBits) {
                    var wrap;
                    var state;
                    /* get the state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
                        wrap = 0;
                        windowBits = -windowBits;
                    } else {
                        wrap = (windowBits >> 4) + 1;
                        if (windowBits < 48) windowBits &= 15;
                    }
                    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
                    if (state.window !== null && state.wbits !== windowBits) state.window = null;
                    /* update state and reset the rest of it */ state.wrap = wrap;
                    state.wbits = windowBits;
                    return inflateReset(strm);
                }
                function inflateInit2(strm, windowBits) {
                    var ret;
                    var state;
                    if (!strm) return Z_STREAM_ERROR;
                    //strm.msg = Z_NULL;                 /* in case we return an error */
                    state = new InflateState();
                    //if (state === Z_NULL) return Z_MEM_ERROR;
                    //Tracev((stderr, "inflate: allocated\n"));
                    strm.state = state;
                    state.window = null /*Z_NULL*/ ;
                    ret = inflateReset2(strm, windowBits);
                    if (ret !== Z_OK) strm.state = null /*Z_NULL*/ ;
                    return ret;
                }
                function inflateInit(strm) {
                    return inflateInit2(strm, DEF_WBITS);
                }
                /*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var virgin = true;
                var lenfix, distfix; // We have no pointers in JS, so keep tables separate
                function fixedtables(state) {
                    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
                        var sym;
                        lenfix = new utils.Buf32(512);
                        distfix = new utils.Buf32(32);
                        /* literal/length table */ sym = 0;
                        while(sym < 144)state.lens[sym++] = 8;
                        while(sym < 256)state.lens[sym++] = 9;
                        while(sym < 280)state.lens[sym++] = 7;
                        while(sym < 288)state.lens[sym++] = 8;
                        inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
                            bits: 9
                        });
                        /* distance table */ sym = 0;
                        while(sym < 32)state.lens[sym++] = 5;
                        inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
                            bits: 5
                        });
                        /* do this just once */ virgin = false;
                    }
                    state.lencode = lenfix;
                    state.lenbits = 9;
                    state.distcode = distfix;
                    state.distbits = 5;
                }
                /*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function updatewindow(strm, src, end, copy) {
                    var dist;
                    var state = strm.state;
                    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
                        state.wsize = 1 << state.wbits;
                        state.wnext = 0;
                        state.whave = 0;
                        state.window = new utils.Buf8(state.wsize);
                    }
                    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
                        utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
                        state.wnext = 0;
                        state.whave = state.wsize;
                    } else {
                        dist = state.wsize - state.wnext;
                        if (dist > copy) dist = copy;
                        //zmemcpy(state->window + state->wnext, end - copy, dist);
                        utils.arraySet(state.window, src, end - copy, dist, state.wnext);
                        copy -= dist;
                        if (copy) {
                            //zmemcpy(state->window, end - copy, copy);
                            utils.arraySet(state.window, src, end - copy, copy, 0);
                            state.wnext = copy;
                            state.whave = state.wsize;
                        } else {
                            state.wnext += dist;
                            if (state.wnext === state.wsize) state.wnext = 0;
                            if (state.whave < state.wsize) state.whave += dist;
                        }
                    }
                    return 0;
                }
                function inflate(strm, flush) {
                    var state;
                    var input, output; // input/output buffers
                    var next; /* next input INDEX */ 
                    var put; /* next output INDEX */ 
                    var have, left; /* available input and output */ 
                    var hold; /* bit buffer */ 
                    var bits; /* bits in bit buffer */ 
                    var _in, _out; /* save starting available input and output */ 
                    var copy; /* number of stored or match bytes to copy */ 
                    var from; /* where to copy match bytes from */ 
                    var from_source;
                    var here = 0; /* current decoding table entry */ 
                    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
                    //var last;                   /* parent table entry */
                    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
                    var len; /* length to copy for repeats, bits to drop */ 
                    var ret; /* return code */ 
                    var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */ 
                    var opts;
                    var n; // temporary var for NEED_BITS
                    var order = /* permutation of code lengths */ [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
                    state = strm.state;
                    if (state.mode === TYPE) state.mode = TYPEDO;
                     /* skip check */ 
                    //--- LOAD() ---
                    put = strm.next_out;
                    output = strm.output;
                    left = strm.avail_out;
                    next = strm.next_in;
                    input = strm.input;
                    have = strm.avail_in;
                    hold = state.hold;
                    bits = state.bits;
                    //---
                    _in = have;
                    _out = left;
                    ret = Z_OK;
                    inf_leave: for(;;)switch(state.mode){
                        case HEAD:
                            if (state.wrap === 0) {
                                state.mode = TYPEDO;
                                break;
                            }
                            //=== NEEDBITS(16);
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.wrap & 2 && hold === 0x8b1f) {
                                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32(state.check, hbuf, 2, 0);
                                //===//
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                                //===//
                                state.mode = FLAGS;
                                break;
                            }
                            state.flags = 0; /* expect zlib header */ 
                            if (state.head) state.head.done = false;
                            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                                strm.msg = 'incorrect header check';
                                state.mode = BAD;
                                break;
                            }
                            if ((hold & 0x0f) !== Z_DEFLATED) {
                                strm.msg = 'unknown compression method';
                                state.mode = BAD;
                                break;
                            }
                            //--- DROPBITS(4) ---//
                            hold >>>= 4;
                            bits -= 4;
                            //---//
                            len = (hold & 0x0f) + 8;
                            if (state.wbits === 0) state.wbits = len;
                            else if (len > state.wbits) {
                                strm.msg = 'invalid window size';
                                state.mode = BAD;
                                break;
                            }
                            state.dmax = 1 << len;
                            //Tracev((stderr, "inflate:   zlib header ok\n"));
                            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
                            state.mode = hold & 0x200 ? DICTID : TYPE;
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            break;
                        case FLAGS:
                            //=== NEEDBITS(16); */
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.flags = hold;
                            if ((state.flags & 0xff) !== Z_DEFLATED) {
                                strm.msg = 'unknown compression method';
                                state.mode = BAD;
                                break;
                            }
                            if (state.flags & 0xe000) {
                                strm.msg = 'unknown header flags set';
                                state.mode = BAD;
                                break;
                            }
                            if (state.head) state.head.text = hold >> 8 & 1;
                            if (state.flags & 0x0200) {
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32(state.check, hbuf, 2, 0);
                            //===//
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = TIME;
                        /* falls through */ case TIME:
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.head) state.head.time = hold;
                            if (state.flags & 0x0200) {
                                //=== CRC4(state.check, hold)
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                hbuf[2] = hold >>> 16 & 0xff;
                                hbuf[3] = hold >>> 24 & 0xff;
                                state.check = crc32(state.check, hbuf, 4, 0);
                            //===
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = OS;
                        /* falls through */ case OS:
                            //=== NEEDBITS(16); */
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.head) {
                                state.head.xflags = hold & 0xff;
                                state.head.os = hold >> 8;
                            }
                            if (state.flags & 0x0200) {
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32(state.check, hbuf, 2, 0);
                            //===//
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = EXLEN;
                        /* falls through */ case EXLEN:
                            if (state.flags & 0x0400) {
                                //=== NEEDBITS(16); */
                                while(bits < 16){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.length = hold;
                                if (state.head) state.head.extra_len = hold;
                                if (state.flags & 0x0200) {
                                    //=== CRC2(state.check, hold);
                                    hbuf[0] = hold & 0xff;
                                    hbuf[1] = hold >>> 8 & 0xff;
                                    state.check = crc32(state.check, hbuf, 2, 0);
                                //===//
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
                            state.mode = EXTRA;
                        /* falls through */ case EXTRA:
                            if (state.flags & 0x0400) {
                                copy = state.length;
                                if (copy > have) copy = have;
                                if (copy) {
                                    if (state.head) {
                                        len = state.head.extra_len - state.length;
                                        if (!state.head.extra) // Use untyped array for more conveniend processing later
                                        state.head.extra = new Array(state.head.extra_len);
                                        utils.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                                        // - no need for additional size check
                                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                                    //zmemcpy(state.head.extra + len, next,
                                    //        len + copy > state.head.extra_max ?
                                    //        state.head.extra_max - len : copy);
                                    }
                                    if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                                    have -= copy;
                                    next += copy;
                                    state.length -= copy;
                                }
                                if (state.length) break inf_leave;
                            }
                            state.length = 0;
                            state.mode = NAME;
                        /* falls through */ case NAME:
                            if (state.flags & 0x0800) {
                                if (have === 0) break inf_leave;
                                copy = 0;
                                do {
                                    // TODO: 2 or 1 bytes?
                                    len = input[next + copy++];
                                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                                }while (len && copy < have);
                                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                                have -= copy;
                                next += copy;
                                if (len) break inf_leave;
                            } else if (state.head) state.head.name = null;
                            state.length = 0;
                            state.mode = COMMENT;
                        /* falls through */ case COMMENT:
                            if (state.flags & 0x1000) {
                                if (have === 0) break inf_leave;
                                copy = 0;
                                do {
                                    len = input[next + copy++];
                                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                                }while (len && copy < have);
                                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                                have -= copy;
                                next += copy;
                                if (len) break inf_leave;
                            } else if (state.head) state.head.comment = null;
                            state.mode = HCRC;
                        /* falls through */ case HCRC:
                            if (state.flags & 0x0200) {
                                //=== NEEDBITS(16); */
                                while(bits < 16){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                if (hold !== (state.check & 0xffff)) {
                                    strm.msg = 'header crc mismatch';
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            }
                            if (state.head) {
                                state.head.hcrc = state.flags >> 9 & 1;
                                state.head.done = true;
                            }
                            strm.adler = state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                            state.mode = TYPE;
                            break;
                        case DICTID:
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            strm.adler = state.check = ZSWAP32(hold);
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = DICT;
                        /* falls through */ case DICT:
                            if (state.havedict === 0) {
                                //--- RESTORE() ---
                                strm.next_out = put;
                                strm.avail_out = left;
                                strm.next_in = next;
                                strm.avail_in = have;
                                state.hold = hold;
                                state.bits = bits;
                                //---
                                return Z_NEED_DICT;
                            }
                            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
                            state.mode = TYPE;
                        /* falls through */ case TYPE:
                            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
                        /* falls through */ case TYPEDO:
                            if (state.last) {
                                //--- BYTEBITS() ---//
                                hold >>>= bits & 7;
                                bits -= bits & 7;
                                //---//
                                state.mode = CHECK;
                                break;
                            }
                            //=== NEEDBITS(3); */
                            while(bits < 3){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.last = hold & 0x01 /*BITS(1)*/ ;
                            //--- DROPBITS(1) ---//
                            hold >>>= 1;
                            bits -= 1;
                            //---//
                            switch(hold & 0x03){
                                case 0:
                                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = STORED;
                                    break;
                                case 1:
                                    /* fixed block */ fixedtables(state);
                                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = LEN_; /* decode codes */ 
                                    if (flush === Z_TREES) {
                                        //--- DROPBITS(2) ---//
                                        hold >>>= 2;
                                        bits -= 2;
                                        break inf_leave;
                                    }
                                    break;
                                case 2:
                                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = TABLE;
                                    break;
                                case 3:
                                    strm.msg = 'invalid block type';
                                    state.mode = BAD;
                            }
                            //--- DROPBITS(2) ---//
                            hold >>>= 2;
                            bits -= 2;
                            break;
                        case STORED:
                            //--- BYTEBITS() ---// /* go to byte boundary */
                            hold >>>= bits & 7;
                            bits -= bits & 7;
                            //---//
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                                strm.msg = 'invalid stored block lengths';
                                state.mode = BAD;
                                break;
                            }
                            state.length = hold & 0xffff;
                            //Tracev((stderr, "inflate:       stored length %u\n",
                            //        state.length));
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = COPY_;
                            if (flush === Z_TREES) break inf_leave;
                        /* falls through */ case COPY_:
                            state.mode = COPY;
                        /* falls through */ case COPY:
                            copy = state.length;
                            if (copy) {
                                if (copy > have) copy = have;
                                if (copy > left) copy = left;
                                if (copy === 0) break inf_leave;
                                //--- zmemcpy(put, next, copy); ---
                                utils.arraySet(output, input, next, copy, put);
                                //---//
                                have -= copy;
                                next += copy;
                                left -= copy;
                                put += copy;
                                state.length -= copy;
                                break;
                            }
                            //Tracev((stderr, "inflate:       stored end\n"));
                            state.mode = TYPE;
                            break;
                        case TABLE:
                            //=== NEEDBITS(14); */
                            while(bits < 14){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.nlen = (hold & 0x1f) + 257;
                            //--- DROPBITS(5) ---//
                            hold >>>= 5;
                            bits -= 5;
                            //---//
                            state.ndist = (hold & 0x1f) + 1;
                            //--- DROPBITS(5) ---//
                            hold >>>= 5;
                            bits -= 5;
                            //---//
                            state.ncode = (hold & 0x0f) + 4;
                            //--- DROPBITS(4) ---//
                            hold >>>= 4;
                            bits -= 4;
                            //---//
                            //#ifndef PKZIP_BUG_WORKAROUND
                            if (state.nlen > 286 || state.ndist > 30) {
                                strm.msg = 'too many length or distance symbols';
                                state.mode = BAD;
                                break;
                            }
                            //#endif
                            //Tracev((stderr, "inflate:       table sizes ok\n"));
                            state.have = 0;
                            state.mode = LENLENS;
                        /* falls through */ case LENLENS:
                            while(state.have < state.ncode){
                                //=== NEEDBITS(3);
                                while(bits < 3){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                                //--- DROPBITS(3) ---//
                                hold >>>= 3;
                                bits -= 3;
                            //---//
                            }
                            while(state.have < 19)state.lens[order[state.have++]] = 0;
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            //state.next = state.codes;
                            //state.lencode = state.next;
                            // Switch to use dynamic table
                            state.lencode = state.lendyn;
                            state.lenbits = 7;
                            opts = {
                                bits: state.lenbits
                            };
                            ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
                            state.lenbits = opts.bits;
                            if (ret) {
                                strm.msg = 'invalid code lengths set';
                                state.mode = BAD;
                                break;
                            }
                            //Tracev((stderr, "inflate:       code lengths ok\n"));
                            state.have = 0;
                            state.mode = CODELENS;
                        /* falls through */ case CODELENS:
                            while(state.have < state.nlen + state.ndist){
                                for(;;){
                                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                if (here_val < 16) {
                                    //--- DROPBITS(here.bits) ---//
                                    hold >>>= here_bits;
                                    bits -= here_bits;
                                    //---//
                                    state.lens[state.have++] = here_val;
                                } else {
                                    if (here_val === 16) {
                                        //=== NEEDBITS(here.bits + 2);
                                        n = here_bits + 2;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        if (state.have === 0) {
                                            strm.msg = 'invalid bit length repeat';
                                            state.mode = BAD;
                                            break;
                                        }
                                        len = state.lens[state.have - 1];
                                        copy = 3 + (hold & 0x03); //BITS(2);
                                        //--- DROPBITS(2) ---//
                                        hold >>>= 2;
                                        bits -= 2;
                                    //---//
                                    } else if (here_val === 17) {
                                        //=== NEEDBITS(here.bits + 3);
                                        n = here_bits + 3;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        len = 0;
                                        copy = 3 + (hold & 0x07); //BITS(3);
                                        //--- DROPBITS(3) ---//
                                        hold >>>= 3;
                                        bits -= 3;
                                    //---//
                                    } else {
                                        //=== NEEDBITS(here.bits + 7);
                                        n = here_bits + 7;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        len = 0;
                                        copy = 11 + (hold & 0x7f); //BITS(7);
                                        //--- DROPBITS(7) ---//
                                        hold >>>= 7;
                                        bits -= 7;
                                    //---//
                                    }
                                    if (state.have + copy > state.nlen + state.ndist) {
                                        strm.msg = 'invalid bit length repeat';
                                        state.mode = BAD;
                                        break;
                                    }
                                    while(copy--)state.lens[state.have++] = len;
                                }
                            }
                            /* handle error breaks in while */ if (state.mode === BAD) break;
                            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                                strm.msg = 'invalid code -- missing end-of-block';
                                state.mode = BAD;
                                break;
                            }
                            /* build code tables -- note: do not change the lenbits or distbits
         values here (9 and 6) without reading the comments in inftrees.h
         concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
                            opts = {
                                bits: state.lenbits
                            };
                            ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            // state.next_index = opts.table_index;
                            state.lenbits = opts.bits;
                            // state.lencode = state.next;
                            if (ret) {
                                strm.msg = 'invalid literal/lengths set';
                                state.mode = BAD;
                                break;
                            }
                            state.distbits = 6;
                            //state.distcode.copy(state.codes);
                            // Switch to use dynamic table
                            state.distcode = state.distdyn;
                            opts = {
                                bits: state.distbits
                            };
                            ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            // state.next_index = opts.table_index;
                            state.distbits = opts.bits;
                            // state.distcode = state.next;
                            if (ret) {
                                strm.msg = 'invalid distances set';
                                state.mode = BAD;
                                break;
                            }
                            //Tracev((stderr, 'inflate:       codes ok\n'));
                            state.mode = LEN_;
                            if (flush === Z_TREES) break inf_leave;
                        /* falls through */ case LEN_:
                            state.mode = LEN;
                        /* falls through */ case LEN:
                            if (have >= 6 && left >= 258) {
                                //--- RESTORE() ---
                                strm.next_out = put;
                                strm.avail_out = left;
                                strm.next_in = next;
                                strm.avail_in = have;
                                state.hold = hold;
                                state.bits = bits;
                                //---
                                inflate_fast(strm, _out);
                                //--- LOAD() ---
                                put = strm.next_out;
                                output = strm.output;
                                left = strm.avail_out;
                                next = strm.next_in;
                                input = strm.input;
                                have = strm.avail_in;
                                hold = state.hold;
                                bits = state.bits;
                                //---
                                if (state.mode === TYPE) state.back = -1;
                                break;
                            }
                            state.back = 0;
                            for(;;){
                                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                                here_bits = here >>> 24;
                                here_op = here >>> 16 & 0xff;
                                here_val = here & 0xffff;
                                if (here_bits <= bits) break;
                                //--- PULLBYTE() ---//
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            //---//
                            }
                            if (here_op && (here_op & 0xf0) === 0) {
                                last_bits = here_bits;
                                last_op = here_op;
                                last_val = here_val;
                                for(;;){
                                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (last_bits + here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                //--- DROPBITS(last.bits) ---//
                                hold >>>= last_bits;
                                bits -= last_bits;
                                //---//
                                state.back += last_bits;
                            }
                            //--- DROPBITS(here.bits) ---//
                            hold >>>= here_bits;
                            bits -= here_bits;
                            //---//
                            state.back += here_bits;
                            state.length = here_val;
                            if (here_op === 0) {
                                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                                //        "inflate:         literal '%c'\n" :
                                //        "inflate:         literal 0x%02x\n", here.val));
                                state.mode = LIT;
                                break;
                            }
                            if (here_op & 32) {
                                //Tracevv((stderr, "inflate:         end of block\n"));
                                state.back = -1;
                                state.mode = TYPE;
                                break;
                            }
                            if (here_op & 64) {
                                strm.msg = 'invalid literal/length code';
                                state.mode = BAD;
                                break;
                            }
                            state.extra = here_op & 15;
                            state.mode = LENEXT;
                        /* falls through */ case LENEXT:
                            if (state.extra) {
                                //=== NEEDBITS(state.extra);
                                n = state.extra;
                                while(bits < n){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                                //--- DROPBITS(state.extra) ---//
                                hold >>>= state.extra;
                                bits -= state.extra;
                                //---//
                                state.back += state.extra;
                            }
                            //Tracevv((stderr, "inflate:         length %u\n", state.length));
                            state.was = state.length;
                            state.mode = DIST;
                        /* falls through */ case DIST:
                            for(;;){
                                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                                here_bits = here >>> 24;
                                here_op = here >>> 16 & 0xff;
                                here_val = here & 0xffff;
                                if (here_bits <= bits) break;
                                //--- PULLBYTE() ---//
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            //---//
                            }
                            if ((here_op & 0xf0) === 0) {
                                last_bits = here_bits;
                                last_op = here_op;
                                last_val = here_val;
                                for(;;){
                                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (last_bits + here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                //--- DROPBITS(last.bits) ---//
                                hold >>>= last_bits;
                                bits -= last_bits;
                                //---//
                                state.back += last_bits;
                            }
                            //--- DROPBITS(here.bits) ---//
                            hold >>>= here_bits;
                            bits -= here_bits;
                            //---//
                            state.back += here_bits;
                            if (here_op & 64) {
                                strm.msg = 'invalid distance code';
                                state.mode = BAD;
                                break;
                            }
                            state.offset = here_val;
                            state.extra = here_op & 15;
                            state.mode = DISTEXT;
                        /* falls through */ case DISTEXT:
                            if (state.extra) {
                                //=== NEEDBITS(state.extra);
                                n = state.extra;
                                while(bits < n){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                                //--- DROPBITS(state.extra) ---//
                                hold >>>= state.extra;
                                bits -= state.extra;
                                //---//
                                state.back += state.extra;
                            }
                            //#ifdef INFLATE_STRICT
                            if (state.offset > state.dmax) {
                                strm.msg = 'invalid distance too far back';
                                state.mode = BAD;
                                break;
                            }
                            //#endif
                            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
                            state.mode = MATCH;
                        /* falls through */ case MATCH:
                            if (left === 0) break inf_leave;
                            copy = _out - left;
                            if (state.offset > copy) {
                                copy = state.offset - copy;
                                if (copy > state.whave) {
                                    if (state.sane) {
                                        strm.msg = 'invalid distance too far back';
                                        state.mode = BAD;
                                        break;
                                    }
                                }
                                if (copy > state.wnext) {
                                    copy -= state.wnext;
                                    from = state.wsize - copy;
                                } else from = state.wnext - copy;
                                if (copy > state.length) copy = state.length;
                                from_source = state.window;
                            } else {
                                from_source = output;
                                from = put - state.offset;
                                copy = state.length;
                            }
                            if (copy > left) copy = left;
                            left -= copy;
                            state.length -= copy;
                            do output[put++] = from_source[from++];
                            while (--copy);
                            if (state.length === 0) state.mode = LEN;
                            break;
                        case LIT:
                            if (left === 0) break inf_leave;
                            output[put++] = state.length;
                            left--;
                            state.mode = LEN;
                            break;
                        case CHECK:
                            if (state.wrap) {
                                //=== NEEDBITS(32);
                                while(bits < 32){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    // Use '|' insdead of '+' to make sure that result is signed
                                    hold |= input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                _out -= left;
                                strm.total_out += _out;
                                state.total += _out;
                                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                                _out = left;
                                // NB: crc32 stored as signed 32-bit int, ZSWAP32 returns signed too
                                if ((state.flags ? hold : ZSWAP32(hold)) !== state.check) {
                                    strm.msg = 'incorrect data check';
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            //Tracev((stderr, "inflate:   check matches trailer\n"));
                            }
                            state.mode = LENGTH;
                        /* falls through */ case LENGTH:
                            if (state.wrap && state.flags) {
                                //=== NEEDBITS(32);
                                while(bits < 32){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                if (hold !== (state.total & 0xffffffff)) {
                                    strm.msg = 'incorrect length check';
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            //Tracev((stderr, "inflate:   length matches trailer\n"));
                            }
                            state.mode = DONE;
                        /* falls through */ case DONE:
                            ret = Z_STREAM_END;
                            break inf_leave;
                        case BAD:
                            ret = Z_DATA_ERROR;
                            break inf_leave;
                        case MEM:
                            return Z_MEM_ERROR;
                        case SYNC:
                        /* falls through */ default:
                            return Z_STREAM_ERROR;
                    }
                    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
                    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
                    strm.next_out = put;
                    strm.avail_out = left;
                    strm.next_in = next;
                    strm.avail_in = have;
                    state.hold = hold;
                    state.bits = bits;
                    //---
                    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
                        if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
                            state.mode = MEM;
                            return Z_MEM_ERROR;
                        }
                    }
                    _in -= strm.avail_in;
                    _out -= strm.avail_out;
                    strm.total_in += _in;
                    strm.total_out += _out;
                    state.total += _out;
                    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
                    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
                    if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
                    return ret;
                }
                function inflateEnd(strm) {
                    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return Z_STREAM_ERROR;
                    var state = strm.state;
                    if (state.window) state.window = null;
                    strm.state = null;
                    return Z_OK;
                }
                function inflateGetHeader(strm, head) {
                    var state;
                    /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
                    /* save header structure */ state.head = head;
                    head.done = false;
                    return Z_OK;
                }
                exports.inflateReset = inflateReset;
                exports.inflateReset2 = inflateReset2;
                exports.inflateResetKeep = inflateResetKeep;
                exports.inflateInit = inflateInit;
                exports.inflateInit2 = inflateInit2;
                exports.inflate = inflate;
                exports.inflateEnd = inflateEnd;
                exports.inflateGetHeader = inflateGetHeader;
                exports.inflateInfo = 'pako inflate (from Nodeca project)';
            /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ },
            {
                "../utils/common": 27,
                "./adler32": 29,
                "./crc32": 31,
                "./inffast": 34,
                "./inftrees": 36
            }
        ],
        36: [
            function(_dereq_, module1, exports) {
                'use strict';
                var utils = _dereq_('../utils/common');
                var MAXBITS = 15;
                var ENOUGH_LENS = 852;
                var ENOUGH_DISTS = 592;
                //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
                var CODES = 0;
                var LENS = 1;
                var DISTS = 2;
                var lbase = [
                    /* Length codes 257..285 base */ 3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ];
                var lext = [
                    /* Length codes 257..285 extra */ 16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ];
                var dbase = [
                    /* Distance codes 0..29 base */ 1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ];
                var dext = [
                    /* Distance codes 0..29 extra */ 16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                module1.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
                    var bits = opts.bits;
                    //here = opts.here; /* table entry for duplication */
                    var len = 0; /* a code's length in bits */ 
                    var sym = 0; /* index of code symbols */ 
                    var min = 0, max = 0; /* minimum and maximum code lengths */ 
                    var root = 0; /* number of index bits for root table */ 
                    var curr = 0; /* number of index bits for current table */ 
                    var drop = 0; /* code bits to drop for sub-table */ 
                    var left = 0; /* number of prefix codes available */ 
                    var used = 0; /* code entries in table used */ 
                    var huff = 0; /* Huffman code */ 
                    var incr; /* for incrementing code, index */ 
                    var fill; /* index for replicating entries */ 
                    var low; /* low bits for current root entry */ 
                    var mask; /* mask for low root bits */ 
                    var next; /* next available space in table */ 
                    var base = null; /* base value table to use */ 
                    var base_index = 0;
                    //  var shoextra;    /* extra bits table to use */
                    var end; /* use base and extra for symbol > end */ 
                    var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
                    var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
                    var extra = null;
                    var extra_index = 0;
                    var here_bits, here_op, here_val;
                    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
                    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
                    /* bound code lengths, force root to be within code lengths */ root = bits;
                    for(max = MAXBITS; max >= 1; max--){
                        if (count[max] !== 0) break;
                    }
                    if (root > max) root = max;
                    if (max === 0) {
                        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
                        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
                        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
                        table[table_index++] = 20971520;
                        //table.op[opts.table_index] = 64;
                        //table.bits[opts.table_index] = 1;
                        //table.val[opts.table_index++] = 0;
                        table[table_index++] = 20971520;
                        opts.bits = 1;
                        return 0; /* no symbols, but wait for decoding to report error */ 
                    }
                    for(min = 1; min < max; min++){
                        if (count[min] !== 0) break;
                    }
                    if (root < min) root = min;
                    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
                    for(len = 1; len <= MAXBITS; len++){
                        left <<= 1;
                        left -= count[len];
                        if (left < 0) return -1;
                         /* over-subscribed */ 
                    }
                    if (left > 0 && (type === CODES || max !== 1)) return -1; /* incomplete set */ 
                    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
                    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
                    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
                    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
                    // to avoid deopts in old v8
                    if (type === CODES) {
                        base = extra = work; /* dummy value--not used */ 
                        end = 19;
                    } else if (type === LENS) {
                        base = lbase;
                        base_index -= 257;
                        extra = lext;
                        extra_index -= 257;
                        end = 256;
                    } else {
                        base = dbase;
                        extra = dext;
                        end = -1;
                    }
                    /* initialize opts for loop */ huff = 0; /* starting code */ 
                    sym = 0; /* starting code symbol */ 
                    len = min; /* starting code length */ 
                    next = table_index; /* current table to fill in */ 
                    curr = root; /* current table index bits */ 
                    drop = 0; /* current bits to drop from code for index */ 
                    low = -1; /* trigger new sub-table when len > root */ 
                    used = 1 << root; /* use root table entries */ 
                    mask = used - 1; /* mask for comparing low */ 
                    /* check available table space */ if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
                    var i = 0;
                    /* process all codes and make table entries */ for(;;){
                        i++;
                        /* create table entry */ here_bits = len - drop;
                        if (work[sym] < end) {
                            here_op = 0;
                            here_val = work[sym];
                        } else if (work[sym] > end) {
                            here_op = extra[extra_index + work[sym]];
                            here_val = base[base_index + work[sym]];
                        } else {
                            here_op = 96; /* end of block */ 
                            here_val = 0;
                        }
                        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
                        fill = 1 << curr;
                        min = fill; /* save offset to next table */ 
                        do {
                            fill -= incr;
                            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
                        }while (fill !== 0);
                        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
                        while(huff & incr)incr >>= 1;
                        if (incr !== 0) {
                            huff &= incr - 1;
                            huff += incr;
                        } else huff = 0;
                        /* go to next symbol, update count, len */ sym++;
                        if (--count[len] === 0) {
                            if (len === max) break;
                            len = lens[lens_index + work[sym]];
                        }
                        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
                            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
                            /* increment past last table */ next += min; /* here min is 1 << curr */ 
                            /* determine length of next table */ curr = len - drop;
                            left = 1 << curr;
                            while(curr + drop < max){
                                left -= count[curr + drop];
                                if (left <= 0) break;
                                curr++;
                                left <<= 1;
                            }
                            /* check for enough space */ used += 1 << curr;
                            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
                            /* point entry in root table to sub-table */ low = huff & mask;
                            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
                        }
                    }
                    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
                    //table.bits[next + huff] = len - drop;
                    //table.val[next + huff] = 0;
                    table[next + huff] = len - drop << 24 | 4194304;
                    /* set return parameters */ //opts.table_index += used;
                    opts.bits = root;
                    return 0;
                };
            },
            {
                "../utils/common": 27
            }
        ],
        37: [
            function(_dereq_, module1, exports) {
                'use strict';
                module1.exports = {
                    '2': 'need dictionary',
                    /* Z_NEED_DICT       2  */ '1': 'stream end',
                    /* Z_STREAM_END      1  */ '0': '',
                    /* Z_OK              0  */ '-1': 'file error',
                    /* Z_ERRNO         (-1) */ '-2': 'stream error',
                    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
                    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
                    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
                    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
                };
            },
            {}
        ],
        38: [
            function(_dereq_, module1, exports) {
                'use strict';
                var utils = _dereq_('../utils/common');
                /* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
                //var Z_HUFFMAN_ONLY      = 2;
                //var Z_RLE               = 3;
                var Z_FIXED = 4;
                //var Z_DEFAULT_STRATEGY  = 0;
                /* Possible values of the data_type field (though see inflate()) */ var Z_BINARY = 0;
                var Z_TEXT = 1;
                //var Z_ASCII             = 1; // = Z_TEXT
                var Z_UNKNOWN = 2;
                /*============================================================================*/ function zero(buf) {
                    var len = buf.length;
                    while(--len >= 0)buf[len] = 0;
                }
                // From zutil.h
                var STORED_BLOCK = 0;
                var STATIC_TREES = 1;
                var DYN_TREES = 2;
                /* The three kinds of block type */ var MIN_MATCH = 3;
                var MAX_MATCH = 258;
                /* The minimum and maximum match lengths */ // From deflate.h
                /* ===========================================================================
 * Internal compression state.
 */ var LENGTH_CODES = 29;
                /* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
                /* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
                /* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
                /* number of distance codes */ var BL_CODES = 19;
                /* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
                /* maximum heap size */ var MAX_BITS = 15;
                /* All codes must not exceed MAX_BITS bits */ var Buf_size = 16;
                /* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var MAX_BL_BITS = 7;
                /* Bit length codes must not exceed MAX_BL_BITS bits */ var END_BLOCK = 256;
                /* end of block literal code */ var REP_3_6 = 16;
                /* repeat previous bit length 3-6 times (2 bits of repeat count) */ var REPZ_3_10 = 17;
                /* repeat a zero length 3-10 times  (3 bits of repeat count) */ var REPZ_11_138 = 18;
                /* repeat a zero length 11-138 times  (7 bits of repeat count) */ var extra_lbits = /* extra bits for each length code */ [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ];
                var extra_dbits = /* extra bits for each distance code */ [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ];
                var extra_blbits = /* extra bits for each bit length code */ [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ];
                var bl_order = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ];
                /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
                var DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
                // !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
                var static_ltree = new Array((L_CODES + 2) * 2);
                zero(static_ltree);
                /* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var static_dtree = new Array(D_CODES * 2);
                zero(static_dtree);
                /* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var _dist_code = new Array(DIST_CODE_LEN);
                zero(_dist_code);
                /* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
                zero(_length_code);
                /* length code for each normalized match length (0 == MIN_MATCH) */ var base_length = new Array(LENGTH_CODES);
                zero(base_length);
                /* First normalized length for each code (0 = MIN_MATCH) */ var base_dist = new Array(D_CODES);
                zero(base_dist);
                /* First normalized distance for each code (0 = distance of 1) */ var StaticTreeDesc = function(static_tree, extra_bits, extra_base, elems, max_length) {
                    this.static_tree = static_tree; /* static tree or NULL */ 
                    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
                    this.extra_base = extra_base; /* base index for extra_bits */ 
                    this.elems = elems; /* max number of elements in the tree */ 
                    this.max_length = max_length; /* max bit length for the codes */ 
                    // show if `static_tree` has data or dummy - needed for monomorphic objects
                    this.has_stree = static_tree && static_tree.length;
                };
                var static_l_desc;
                var static_d_desc;
                var static_bl_desc;
                var TreeDesc = function(dyn_tree, stat_desc) {
                    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
                    this.max_code = 0; /* largest code with non zero frequency */ 
                    this.stat_desc = stat_desc; /* the corresponding static tree */ 
                };
                function d_code(dist) {
                    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
                }
                /* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function put_short(s, w) {
                    //    put_byte(s, (uch)((w) & 0xff));
                    //    put_byte(s, (uch)((ush)(w) >> 8));
                    s.pending_buf[s.pending++] = w & 0xff;
                    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
                }
                /* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function send_bits(s, value, length) {
                    if (s.bi_valid > Buf_size - length) {
                        s.bi_buf |= value << s.bi_valid & 0xffff;
                        put_short(s, s.bi_buf);
                        s.bi_buf = value >> Buf_size - s.bi_valid;
                        s.bi_valid += length - Buf_size;
                    } else {
                        s.bi_buf |= value << s.bi_valid & 0xffff;
                        s.bi_valid += length;
                    }
                }
                function send_code(s, c, tree) {
                    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
                }
                /* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function bi_reverse(code, len) {
                    var res = 0;
                    do {
                        res |= code & 1;
                        code >>>= 1;
                        res <<= 1;
                    }while (--len > 0);
                    return res >>> 1;
                }
                /* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function bi_flush(s) {
                    if (s.bi_valid === 16) {
                        put_short(s, s.bi_buf);
                        s.bi_buf = 0;
                        s.bi_valid = 0;
                    } else if (s.bi_valid >= 8) {
                        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                        s.bi_buf >>= 8;
                        s.bi_valid -= 8;
                    }
                }
                /* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function gen_bitlen(s, desc) //    deflate_state *s;
                //    tree_desc *desc;    /* the tree descriptor */
                {
                    var tree = desc.dyn_tree;
                    var max_code = desc.max_code;
                    var stree = desc.stat_desc.static_tree;
                    var has_stree = desc.stat_desc.has_stree;
                    var extra = desc.stat_desc.extra_bits;
                    var base = desc.stat_desc.extra_base;
                    var max_length = desc.stat_desc.max_length;
                    var h; /* heap index */ 
                    var n, m; /* iterate over the tree elements */ 
                    var bits; /* bit length */ 
                    var xbits; /* extra bits */ 
                    var f; /* frequency */ 
                    var overflow = 0; /* number of elements with bit length too large */ 
                    for(bits = 0; bits <= MAX_BITS; bits++)s.bl_count[bits] = 0;
                    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
                    for(h = s.heap_max + 1; h < HEAP_SIZE; h++){
                        n = s.heap[h];
                        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
                        if (bits > max_length) {
                            bits = max_length;
                            overflow++;
                        }
                        tree[n * 2 + 1] = bits;
                        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
                         /* not a leaf node */ 
                        s.bl_count[bits]++;
                        xbits = 0;
                        if (n >= base) xbits = extra[n - base];
                        f = tree[n * 2] /*.Freq*/ ;
                        s.opt_len += f * (bits + xbits);
                        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
                    }
                    if (overflow === 0) return;
                    // Trace((stderr,"\nbit length overflow\n"));
                    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
                        bits = max_length - 1;
                        while(s.bl_count[bits] === 0)bits--;
                        s.bl_count[bits]--; /* move one leaf down the tree */ 
                        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
                        s.bl_count[max_length]--;
                        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
                    }while (overflow > 0);
                    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
                        n = s.bl_count[bits];
                        while(n !== 0){
                            m = s.heap[--h];
                            if (m > max_code) continue;
                            if (tree[m * 2 + 1] !== bits) {
                                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                                tree[m * 2 + 1] = bits;
                            }
                            n--;
                        }
                    }
                }
                /* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
                //    int max_code;              /* largest code with non zero frequency */
                //    ushf *bl_count;            /* number of codes at each bit length */
                {
                    var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */ 
                    var code = 0; /* running code value */ 
                    var bits; /* bit index */ 
                    var n; /* code index */ 
                    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
                    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
                    //        "inconsistent bit counts");
                    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
                    for(n = 0; n <= max_code; n++){
                        var len = tree[n * 2 + 1] /*.Len*/ ;
                        if (len === 0) continue;
                        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
                    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
                    }
                }
                /* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function tr_static_init() {
                    var n; /* iterates over tree elements */ 
                    var bits; /* bit counter */ 
                    var length; /* length value */ 
                    var code; /* code value */ 
                    var dist; /* distance index */ 
                    var bl_count = new Array(MAX_BITS + 1);
                    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
                    //if (static_init_done) return;
                    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
                    for(code = 0; code < LENGTH_CODES - 1; code++){
                        base_length[code] = length;
                        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
                    }
                    //Assert (length == 256, "tr_static_init: length != 256");
                    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
                    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
                    for(code = 0; code < 16; code++){
                        base_dist[code] = dist;
                        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
                    }
                    //Assert (dist == 256, "tr_static_init: dist != 256");
                    dist >>= 7; /* from now on, all distances are divided by 128 */ 
                    for(; code < D_CODES; code++){
                        base_dist[code] = dist << 7;
                        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
                    }
                    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
                    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS; bits++)bl_count[bits] = 0;
                    n = 0;
                    while(n <= 143){
                        static_ltree[n * 2 + 1] = 8;
                        n++;
                        bl_count[8]++;
                    }
                    while(n <= 255){
                        static_ltree[n * 2 + 1] = 9;
                        n++;
                        bl_count[9]++;
                    }
                    while(n <= 279){
                        static_ltree[n * 2 + 1] = 7;
                        n++;
                        bl_count[7]++;
                    }
                    while(n <= 287){
                        static_ltree[n * 2 + 1] = 8;
                        n++;
                        bl_count[8]++;
                    }
                    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES + 1, bl_count);
                    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES; n++){
                        static_dtree[n * 2 + 1] = 5;
                        static_dtree[n * 2] = bi_reverse(n, 5);
                    }
                    // Now data ready and we can init static trees
                    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
                    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
                    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
                //static_init_done = true;
                }
                /* ===========================================================================
 * Initialize a new block.
 */ function init_block(s) {
                    var n; /* iterates over tree elements */ 
                    /* Initialize the trees. */ for(n = 0; n < L_CODES; n++)s.dyn_ltree[n * 2] = 0;
                    for(n = 0; n < D_CODES; n++)s.dyn_dtree[n * 2] = 0;
                    for(n = 0; n < BL_CODES; n++)s.bl_tree[n * 2] = 0;
                    s.dyn_ltree[END_BLOCK * 2] = 1;
                    s.opt_len = s.static_len = 0;
                    s.last_lit = s.matches = 0;
                }
                /* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function bi_windup(s) {
                    if (s.bi_valid > 8) put_short(s, s.bi_buf);
                    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
                    s.pending_buf[s.pending++] = s.bi_buf;
                    s.bi_buf = 0;
                    s.bi_valid = 0;
                }
                /* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function copy_block(s, buf, len, header) //DeflateState *s;
                //charf    *buf;    /* the input data */
                //unsigned len;     /* its length */
                //int      header;  /* true if block header must be written */
                {
                    bi_windup(s); /* align on byte boundary */ 
                    if (header) {
                        put_short(s, len);
                        put_short(s, ~len);
                    }
                    //  while (len--) {
                    //    put_byte(s, *buf++);
                    //  }
                    utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
                    s.pending += len;
                }
                /* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function smaller(tree, n, m, depth) {
                    var _n2 = n * 2;
                    var _m2 = m * 2;
                    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
                }
                /* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function pqdownheap(s, tree, k) //    deflate_state *s;
                //    ct_data *tree;  /* the tree to restore */
                //    int k;               /* node to move down */
                {
                    var v = s.heap[k];
                    var j = k << 1; /* left son of k */ 
                    while(j <= s.heap_len){
                        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
                        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
                        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
                        k = j;
                        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
                    }
                    s.heap[k] = v;
                }
                // inlined manually
                // var SMALLEST = 1;
                /* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function compress_block(s, ltree, dtree) //    deflate_state *s;
                //    const ct_data *ltree; /* literal tree */
                //    const ct_data *dtree; /* distance tree */
                {
                    var dist; /* distance of matched string */ 
                    var lc; /* match length or unmatched char (if dist == 0) */ 
                    var lx = 0; /* running index in l_buf */ 
                    var code; /* the code to send */ 
                    var extra; /* number of extra bits to send */ 
                    if (s.last_lit !== 0) do {
                        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
                        lc = s.pending_buf[s.l_buf + lx];
                        lx++;
                        if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
                        else {
                            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
                            send_code(s, code + LITERALS + 1, ltree); /* send the length code */ 
                            extra = extra_lbits[code];
                            if (extra !== 0) {
                                lc -= base_length[code];
                                send_bits(s, lc, extra); /* send the extra length bits */ 
                            }
                            dist--; /* dist is now the match distance - 1 */ 
                            code = d_code(dist);
                            //Assert (code < D_CODES, "bad d_code");
                            send_code(s, code, dtree); /* send the distance code */ 
                            extra = extra_dbits[code];
                            if (extra !== 0) {
                                dist -= base_dist[code];
                                send_bits(s, dist, extra); /* send the extra distance bits */ 
                            }
                        } /* literal or match pair ? */ 
                    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                    //       "pendingBuf overflow");
                    }while (lx < s.last_lit);
                    send_code(s, END_BLOCK, ltree);
                }
                /* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function build_tree(s, desc) //    deflate_state *s;
                //    tree_desc *desc; /* the tree descriptor */
                {
                    var tree = desc.dyn_tree;
                    var stree = desc.stat_desc.static_tree;
                    var has_stree = desc.stat_desc.has_stree;
                    var elems = desc.stat_desc.elems;
                    var n, m; /* iterate over heap elements */ 
                    var max_code = -1; /* largest code with non zero frequency */ 
                    var node; /* new node being created */ 
                    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
                    s.heap_max = HEAP_SIZE;
                    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
                        s.heap[++s.heap_len] = max_code = n;
                        s.depth[n] = 0;
                    } else tree[n * 2 + 1] = 0;
                    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
                        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                        tree[node * 2] = 1;
                        s.depth[node] = 0;
                        s.opt_len--;
                        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
                    /* node is 0 or 1 so it does not have extra bits */ }
                    desc.max_code = max_code;
                    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
                    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
                    do {
                        //pqremove(s, tree, n);  /* n = node of least frequency */
                        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
                        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
                        pqdownheap(s, tree, 1 /*SMALLEST*/ );
                        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
                        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
                        s.heap[--s.heap_max] = m;
                        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
                        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
                        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
                        pqdownheap(s, tree, 1 /*SMALLEST*/ );
                    }while (s.heap_len >= 2);
                    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
                    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
                    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
                }
                /* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function scan_tree(s, tree, max_code) //    deflate_state *s;
                //    ct_data *tree;   /* the tree to be scanned */
                //    int max_code;    /* and its largest code of non zero frequency */
                {
                    var n; /* iterates over all tree elements */ 
                    var prevlen = -1; /* last emitted length */ 
                    var curlen; /* length of current code */ 
                    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
                    var count = 0; /* repeat count of the current code */ 
                    var max_count = 7; /* max repeat count */ 
                    var min_count = 4; /* min repeat count */ 
                    if (nextlen === 0) {
                        max_count = 138;
                        min_count = 3;
                    }
                    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
                    for(n = 0; n <= max_code; n++){
                        curlen = nextlen;
                        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
                        if (++count < max_count && curlen === nextlen) continue;
                        else if (count < min_count) s.bl_tree[curlen * 2] += count;
                        else if (curlen !== 0) {
                            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
                            s.bl_tree[REP_3_6 * 2]++;
                        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
                        else s.bl_tree[REPZ_11_138 * 2]++;
                        count = 0;
                        prevlen = curlen;
                        if (nextlen === 0) {
                            max_count = 138;
                            min_count = 3;
                        } else if (curlen === nextlen) {
                            max_count = 6;
                            min_count = 3;
                        } else {
                            max_count = 7;
                            min_count = 4;
                        }
                    }
                }
                /* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function send_tree(s, tree, max_code) //    deflate_state *s;
                //    ct_data *tree; /* the tree to be scanned */
                //    int max_code;       /* and its largest code of non zero frequency */
                {
                    var n; /* iterates over all tree elements */ 
                    var prevlen = -1; /* last emitted length */ 
                    var curlen; /* length of current code */ 
                    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
                    var count = 0; /* repeat count of the current code */ 
                    var max_count = 7; /* max repeat count */ 
                    var min_count = 4; /* min repeat count */ 
                    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
                        max_count = 138;
                        min_count = 3;
                    }
                    for(n = 0; n <= max_code; n++){
                        curlen = nextlen;
                        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
                        if (++count < max_count && curlen === nextlen) continue;
                        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
                        while (--count !== 0);
                        else if (curlen !== 0) {
                            if (curlen !== prevlen) {
                                send_code(s, curlen, s.bl_tree);
                                count--;
                            }
                            //Assert(count >= 3 && count <= 6, " 3_6?");
                            send_code(s, REP_3_6, s.bl_tree);
                            send_bits(s, count - 3, 2);
                        } else if (count <= 10) {
                            send_code(s, REPZ_3_10, s.bl_tree);
                            send_bits(s, count - 3, 3);
                        } else {
                            send_code(s, REPZ_11_138, s.bl_tree);
                            send_bits(s, count - 11, 7);
                        }
                        count = 0;
                        prevlen = curlen;
                        if (nextlen === 0) {
                            max_count = 138;
                            min_count = 3;
                        } else if (curlen === nextlen) {
                            max_count = 6;
                            min_count = 3;
                        } else {
                            max_count = 7;
                            min_count = 4;
                        }
                    }
                }
                /* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function build_bl_tree(s) {
                    var max_blindex; /* index of last bit length code of non zero freq */ 
                    /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
                    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
                    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
                    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--){
                        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
                    }
                    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
                    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
                    //        s->opt_len, s->static_len));
                    return max_blindex;
                }
                /* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
                //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
                {
                    var rank; /* index in bl_order */ 
                    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
                    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
                    //        "too many codes");
                    //Tracev((stderr, "\nbl counts: "));
                    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
                    send_bits(s, dcodes - 1, 5);
                    send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
                    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
                    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
                    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
                    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
                    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
                //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
                }
                /* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function detect_data_type(s) {
                    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
                    var n;
                    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
                        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
                    }
                    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
                    for(n = 32; n < LITERALS; n++){
                        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
                    }
                    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
                }
                var static_init_done = false;
                /* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function _tr_init(s) {
                    if (!static_init_done) {
                        tr_static_init();
                        static_init_done = true;
                    }
                    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
                    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
                    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
                    s.bi_buf = 0;
                    s.bi_valid = 0;
                    /* Initialize the first block of the first file: */ init_block(s);
                }
                /* ===========================================================================
 * Send a stored block
 */ function _tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
                //charf *buf;       /* input block */
                //ulg stored_len;   /* length of input block */
                //int last;         /* one if this is the last block for a file */
                {
                    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
                    copy_block(s, buf, stored_len, true); /* with header */ 
                }
                /* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function _tr_align(s) {
                    send_bits(s, STATIC_TREES << 1, 3);
                    send_code(s, END_BLOCK, static_ltree);
                    bi_flush(s);
                }
                /* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function _tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
                //charf *buf;       /* input block, or NULL if too old */
                //ulg stored_len;   /* length of input block */
                //int last;         /* one if this is the last block for a file */
                {
                    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
                    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
                    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
                        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN) s.strm.data_type = detect_data_type(s);
                        /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
                        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                        //        s->static_len));
                        build_tree(s, s.d_desc);
                        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                        //        s->static_len));
                        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
                        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
                        static_lenb = s.static_len + 3 + 7 >>> 3;
                        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                        //        s->last_lit));
                        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
                    } else // Assert(buf != (char*)0, "lost buf");
                    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
                    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block(s, buf, stored_len, last);
                    else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                        compress_block(s, static_ltree, static_dtree);
                    } else {
                        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                        compress_block(s, s.dyn_ltree, s.dyn_dtree);
                    }
                    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
                    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
                    if (last) bi_windup(s);
                // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
                //       s->compressed_len-7*last));
                }
                /* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function _tr_tally(s, dist, lc) //    deflate_state *s;
                //    unsigned dist;  /* distance of matched string */
                //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
                {
                    //var out_length, in_length, dcode;
                    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
                    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
                    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
                    s.last_lit++;
                    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
                    else {
                        s.matches++;
                        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
                        //Assert((ush)dist < (ush)MAX_DIST(s) &&
                        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                        s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
                        s.dyn_dtree[d_code(dist) * 2]++;
                    }
                    // (!) This block is disabled in zlib defailts,
                    // don't enable it for binary compatibility
                    //#ifdef TRUNCATE_BLOCK
                    //  /* Try to guess if it is profitable to stop the current block here */
                    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
                    //    /* Compute an upper bound for the compressed length */
                    //    out_length = s.last_lit*8;
                    //    in_length = s.strstart - s.block_start;
                    //
                    //    for (dcode = 0; dcode < D_CODES; dcode++) {
                    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
                    //    }
                    //    out_length >>>= 3;
                    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
                    //    //       s->last_lit, in_length, out_length,
                    //    //       100L - out_length*100L/in_length));
                    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
                    //      return true;
                    //    }
                    //  }
                    //#endif
                    return s.last_lit === s.lit_bufsize - 1;
                /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
                exports._tr_init = _tr_init;
                exports._tr_stored_block = _tr_stored_block;
                exports._tr_flush_block = _tr_flush_block;
                exports._tr_tally = _tr_tally;
                exports._tr_align = _tr_align;
            },
            {
                "../utils/common": 27
            }
        ],
        39: [
            function(_dereq_, module1, exports) {
                'use strict';
                function ZStream() {
                    /* next input byte */ this.input = null; // JS specific, because we have no pointers
                    this.next_in = 0;
                    /* number of bytes available at input */ this.avail_in = 0;
                    /* total number of input bytes read so far */ this.total_in = 0;
                    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
                    this.next_out = 0;
                    /* remaining free space at output */ this.avail_out = 0;
                    /* total number of bytes output so far */ this.total_out = 0;
                    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
                    /* not visible by applications */ this.state = null;
                    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
                    /* adler32 value of the uncompressed data */ this.adler = 0;
                }
                module1.exports = ZStream;
            },
            {}
        ]
    }, {}, [
        9
    ])(9);
});

},{"a174c9591802d99d":"aBjM4"}],"4TW7P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
class ImportStockAcquisitionFileDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {};
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "import-stock-acquisition-file-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Uvoz iz Excela"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-1 flex-col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                className: "flex-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FileInput), {
                                    text: "Izberi datoteko ...",
                                    onInputChange: async (e)=>{
                                        e.preventDefault();
                                        const reader = new FileReader();
                                        reader.onload = async (e)=>{
                                            this.props.closeDialog(new Uint8Array(e.target.result));
                                        };
                                        reader.readAsArrayBuffer(e.target.files[0]);
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                minimal: true,
                                onClick: ()=>this.props.closeDialog(),
                                children: "Prekli\u010Di"
                            })
                        })
                    })
                ]
            })
        });
    }
}
ImportStockAcquisitionFileDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func
};
exports.default = ImportStockAcquisitionFileDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jOAEO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
var _xlsx = require("xlsx");
var _xlsxDefault = parcelHelpers.interopDefault(_xlsx);
class ImportStockAcquisitionFromInventoryListFileDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            type: 'deficit',
            current_data: null,
            sheet_names: []
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(),
            className: "import-stock-acquisition-file-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Uvoz iz Excela (inventurni list)"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.RadioGroup), {
                                    onChange: (event)=>{
                                        this.setState({
                                            type: event.target.value
                                        });
                                    },
                                    selectedValue: this.state.type,
                                    inline: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                            label: "Inventurni manko",
                                            value: "deficit"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                            label: "Inventurni vi\u0161ek",
                                            value: "surplus"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FormGroup), {
                                    className: "flex-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.FileInput), {
                                        text: "Izberi datoteko ...",
                                        onInputChange: async (e)=>{
                                            e.preventDefault();
                                            const reader = new FileReader();
                                            reader.onload = async (e)=>{
                                                const data = e.target.result;
                                                const workbook = (0, _xlsxDefault.default).read(data, {
                                                    type: 'array'
                                                });
                                                this.setState({
                                                    current_data: data,
                                                    sheet_names: workbook.SheetNames
                                                });
                                            };
                                            reader.readAsArrayBuffer(e.target.files[0]);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: 'transition-opacity duration-500 ease-in-out ' + (this.state.sheet_names.length == 0 ? 'opacity-25' : 'opacity-100'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "mt-2",
                                            children: "Izberi dobavitelja:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                            options: (this.state.sheet_names.length == 0 ? [
                                                'Prazno'
                                            ] : [
                                                'Izberi',
                                                ...this.state.sheet_names
                                            ]).map((item)=>{
                                                return {
                                                    label: item,
                                                    value: item
                                                };
                                            }),
                                            value: this.state.inventory_export_id_warehouse,
                                            onChange: (e)=>{
                                                this.props.closeDialog(new Uint8Array(this.state.current_data), this.state.type, e.currentTarget.value);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_FOOTER,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                minimal: true,
                                onClick: ()=>this.props.closeDialog(),
                                children: "Prekli\u010Di"
                            })
                        })
                    })
                ]
            })
        });
    }
}
ImportStockAcquisitionFromInventoryListFileDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func
};
exports.default = ImportStockAcquisitionFromInventoryListFileDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","xlsx":"eqXnQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1wmZH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _codeTables = require("../../api/CodeTables");
var _warehouses = require("../../api/Warehouses");
var _items = require("../../api/Items");
var _addEditDeliveryNoteDialog = require("./AddEditDeliveryNoteDialog");
var _addEditDeliveryNoteDialogDefault = parcelHelpers.interopDefault(_addEditDeliveryNoteDialog);
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _invoiceCreator = require("../../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _appSlice = require("../../slices/AppSlice");
var _resultComponents = require("../code_tables/ResultComponents");
function Results(props) {
    const { table_items, table_items_sort_ids, openAddEditItemDialog, tableItemsFilters, originalTableItemsFilters, handleFilterChange, users, customers, tax_rates, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged, document_associations } = props;
    const users_with_titles = {};
    for(let id_user in users)users_with_titles[id_user] = {
        id_user,
        title: users[id_user].name + ' ' + users[id_user].surname
    };
    const types = {
        'delivery': 'Dobavnica',
        'return': "Vra\u010Dilo v zalogo"
    };
    const types_with_titles = {};
    for(let type in types)types_with_titles[type] = {
        value: type,
        title: types[type]
    };
    let total_price_without_vat = 0;
    let total_price_with_vat = 0;
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-auto sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: check_count > 0,
                                indeterminate: !all_checked && check_count > 0,
                                onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 2,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 3,
                            title: "\u0160tevilka dobavnice"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 4,
                            title: "\u0160ifra"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 5,
                            title: "Naziv stranke"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 6,
                            title: "Datum dobavnice"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 7,
                            title: "Datum izdaje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 8,
                            title: "\u0160tevilka naro\u010Dila"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 9,
                            title: "Ra\u010Dun"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 10,
                            title: "Vrsta dokumenta"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 11,
                            title: "Uporabnik"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 12,
                            cls: "text-right",
                            title: "Znesek brez DDV"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 13,
                            cls: "text-right",
                            title: "Znesek z DDV"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.document_number,
                                onChange: (event)=>handleFilterChange('document_number', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_internal_code,
                                onChange: (event)=>handleFilterChange('customer_internal_code', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer_name,
                                onChange: (event)=>handleFilterChange('customer_name', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.document_date_range,
                                original_start_date: originalTableItemsFilters.document_date_range[0],
                                original_end_date: originalTableItemsFilters.document_date_range[1],
                                onFilterChange: (values)=>handleFilterChange('document_date_range', values),
                                short_year: true
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.issue_date_range,
                                original_start_date: originalTableItemsFilters.issue_date_range[0],
                                original_end_date: originalTableItemsFilters.issue_date_range[1],
                                onFilterChange: (values)=>handleFilterChange('issue_date_range', values),
                                short_year: true
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.order_number,
                                onChange: (event)=>handleFilterChange('order_number', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: tableItemsFilters.has_invoice === true,
                                indeterminate: tableItemsFilters.has_invoice === null,
                                inline: true,
                                onChange: (event)=>{
                                    let checked = null;
                                    if (tableItemsFilters.has_invoice === true) checked = false;
                                    else if (tableItemsFilters.has_invoice === null) checked = true;
                                    handleFilterChange('has_invoice', checked);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "value",
                                    title_field: "title",
                                    items: types_with_titles,
                                    filtered_keys: tableItemsFilters.types,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('types', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_user",
                                    title_field: "title",
                                    items: users_with_titles,
                                    filtered_keys: tableItemsFilters.id_users,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('id_users', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 12,
                            cls: "filters-col",
                            child: null
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 13,
                            cls: "filters-col",
                            child: null
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            const customer = customers[item.id_customer] || null;
                            const user = users[item.id_user];
                            let documents = document_associations[id];
                            if (document === undefined) documents = {};
                            let has_invoice = false;
                            for(let id_document in documents)if ((documents[id_document].source_type == 'invoice' || documents[id_document].source_type == 'cash-invoice') && documents[id_document].target_type == 'delivery-note') {
                                has_invoice = true;
                                break;
                            }
                            let price_without_vat = 0;
                            let price_with_vat = 0;
                            for(let i = 0; i < (item.items ?? []).length; i++){
                                const purchase_price_without_vat = parseFloat(item.items[i].purchase_price_without_vat) * parseFloat(item.items[i].quantity) * (1 - parseFloat(item.items[i].purchase_discount) / 100);
                                price_without_vat += purchase_price_without_vat;
                                price_with_vat += purchase_price_without_vat * (1 + tax_rates[item.items[i].purchase_id_tax_rate].value / 100);
                            }
                            total_price_without_vat += price_without_vat;
                            total_price_with_vat += price_with_vat;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: table_items_checked_ids[id] === true,
                                            onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                icon: "edit",
                                                intent: "primary",
                                                minimal: true,
                                                small: true,
                                                onClick: ()=>openAddEditItemDialog(item)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        child: item.document_number
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        child: customer === null || customer === undefined ? null : customer.internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        child: customer === null || customer === undefined ? null : customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        child: item.document_date === null ? null : (0, _momentDefault.default)(item.document_date).format('DD. MM. YYYY')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        child: item.issue_date === null ? null : (0, _momentDefault.default)(item.issue_date).format('DD. MM. YYYY')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        child: item.order_number
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        child: has_invoice === true ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                            icon: "tick",
                                            color: "#394b59"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                            icon: "cross",
                                            color: "#ff0000"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 10,
                                        child: types[item.type]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 11,
                                        child: user === null || user === undefined ? null : user.name + ' ' + user.surname
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 12,
                                        cls: "text-right font-bold",
                                        child: price_without_vat.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) + ' EUR'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 13,
                                        cls: "text-right font-bold",
                                        child: price_with_vat.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) + ' EUR'
                                    })
                                ]
                            }, 'result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results borderless mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            span: 2,
                            child: "\u0160tevilo zapisov: " + table_items_sort_ids.length
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            child: ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "text-right font-bold",
                            child: total_price_without_vat.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) + ' EUR'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 12,
                            cls: "text-right font-bold",
                            child: total_price_with_vat.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) + ' EUR'
                        })
                    ]
                })
            })
        ]
    });
}
class DeliveryNotes extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.requestDeleteItem = this.requestDeleteItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.createInvoiceFromOriginal = this.createInvoiceFromOriginal.bind(this);
        const table_items_filters = {
            document_number: '',
            customer_internal_code: '',
            customer_name: '',
            document_date_range: [
                (0, _momentDefault.default)().subtract(3, 'months').toDate(),
                null
            ],
            issue_date_range: [
                null,
                null
            ],
            order_number: '',
            types: [],
            id_users: [],
            has_invoice: null
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'document_number',
            table_items_sort_direction: 'DESC'
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'document_number',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            table_items_checked_ids: {},
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_id_cash_register: null,
            add_edit_item_dialog_date: null,
            add_edit_item_dialog_start_balance: 0,
            add_edit_item_dialog_documents: [],
            add_edit_item_dialog_item: null,
            delete_request_id_item: null,
            saving: false
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.users != prevProps.users || this.props.delivery_notes != prevProps.delivery_notes) {
            const state = this.updateTableItemsFromProps(this.props, this.state);
            this.setState(state);
        }
    }
    updateTableItemsFromProps(props, state) {
        const ids = Object.keys(props.delivery_notes);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            invoices: props.invoices,
            table_items: props.delivery_notes,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            a = state.table_items[a_key][field];
            b = state.table_items[b_key][field];
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        console.log({
            filters,
            document_date_range: filters.document_date_range,
            issue_date_range: filters.issue_date_range
        });
        const filters_document_number = filters.document_number.toUpperCase();
        const filters_customer_internal_code = filters.customer_internal_code.toUpperCase();
        const filters_customer_name = filters.customer_name.toUpperCase();
        const filters_document_date_start = filters.document_date_range[0] === null ? null : this.toIsoString(filters.document_date_range[0]);
        const filters_document_date_end = filters.document_date_range[1] === null ? null : this.toIsoString(filters.document_date_range[1]);
        const filters_issue_date_start = filters.issue_date_range[0] === null ? null : this.toIsoString(filters.issue_date_range[0]);
        const filters_issue_date_end = filters.issue_date_range[1] === null ? null : this.toIsoString(filters.issue_date_range[1]);
        const filters_order_number = filters.order_number.toUpperCase();
        const filters_types = filters.types;
        const filters_id_users = filters.id_users;
        const filters_has_invoice = filters.has_invoice;
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['stock--delivery-notes'] ?? 0);
        const filter_data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days').toISOString(true);
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_document_number != '' && (item.document_number === null || item.document_number.toUpperCase().indexOf(filters_document_number) == -1)) return false;
            if (filters_customer_internal_code != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || this.props.customers[item.id_customer].internal_code != filters_customer_internal_code)) return false;
            if (filters_customer_name != '' && (item.id_customer === null || this.props.customers[item.id_customer] === undefined || (this.props.customers[item.id_customer].surname + ' ' + this.props.customers[item.id_customer].name + ' ' + this.props.customers[item.id_customer].company_name).toUpperCase().indexOf(filters_customer_name) == -1)) return false;
            if (filter_data_retention_date_start !== null && item.document_date !== null && this.toIsoString(new Date(item.document_date)) <= filter_data_retention_date_start) return false;
            if (filters_document_date_start !== null && item.document_date !== null && this.toIsoString(new Date(item.document_date)) < filters_document_date_start) return false;
            if (filters_document_date_end !== null && item.document_date !== null && this.toIsoString(new Date(item.document_date)) > filters_document_date_end) return false;
            if (filters_issue_date_start !== null && item.issue_date !== null && this.toIsoString(new Date(item.issue_date)) < filters_issue_date_start) return false;
            if (filters_issue_date_end !== null && item.issue_date !== null && this.toIsoString(new Date(item.issue_date)) > filters_issue_date_end) return false;
            if (filters_order_number != '' && (item.order_number === null || item.order_number.toUpperCase().indexOf(filters_order_number) == -1)) return false;
            if (filters_id_users.length > 0) {
                if (item.id_user === null || filters_id_users.indexOf(item.id_user) == -1) return false;
            }
            if (filters_types.length > 0) {
                if (item.type === null || filters_types.indexOf(item.type) == -1) return false;
            }
            if (filters_has_invoice !== null) {
                let documents = this.props.document_associations[id];
                if (document === undefined) documents = {};
                let has_invoice = false;
                for(let id_document in documents)if ((documents[id_document].source_type == 'invoice' || documents[id_document].source_type == 'cash-invoice') && documents[id_document].target_type == 'delivery-note') {
                    has_invoice = true;
                    break;
                }
                if (filters_has_invoice != has_invoice) return false;
            }
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            document_number: this.state.table_items_filters.document_number,
            customer_internal_code: this.state.table_items_filters.customer_internal_code,
            customer_name: this.state.table_items_filters.customer_name,
            document_date_range: this.state.table_items_filters.document_date_range,
            issue_date_range: this.state.table_items_filters.issue_date_range,
            order_number: this.state.table_items_filters.order_number,
            types: this.state.table_items_filters.types,
            id_users: this.state.table_items_filters.id_users,
            has_invoice: this.state.table_items_filters.has_invoice
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    async closeAddEditItemDialog(item, ignore_prices_for_id_delivery_note_items, delivery_addresses) {
        if (item === undefined) {
            this.setState({
                add_edit_item_dialog_open: false
            });
            return;
        }
        this.setState({
            saving: true
        });
        const dispatch = this.props.dispatch;
        const token = this.props.token;
        await (0, _warehouses.saveDeliveryNote)(this.props.api_url, item, token);
        //loadDeliveryNotes(this.props.api_url, dispatch, token);
        //loadStockInventoryItems      (this.props.api_url, dispatch, token);
        console.log({
            ITEM2: item
        });
        // save new delivery address, if needed
        let customer = this.props.customers[item.id_customer];
        const customer_delivery_addresses = [
            ...delivery_addresses
        ];
        const delivery_address = item.delivery_address.trim();
        if (delivery_address.length > 0) {
            // if found, remove existing address
            // then add new address to start
            const delivery_address_lower = delivery_address.toLowerCase();
            for(let i = 0; i < customer_delivery_addresses.length; i++){
                const address = customer_delivery_addresses[i].toLowerCase();
                if (address == delivery_address_lower) {
                    customer_delivery_addresses.splice(i, 1);
                    break;
                }
            }
            customer_delivery_addresses.splice(0, 0, delivery_address);
        }
        customer = {
            ...customer,
            delivery_addresses: customer_delivery_addresses
        };
        await (0, _codeTables.saveCodeTableItem)(this.props.api_url, 'customers', customer, token);
        this.setState({
            add_edit_item_dialog_open: false,
            saving: false
        });
    }
    requestDeleteItem(id_item) {
        this.setState({
            delete_request_id_item: id_item
        });
    }
    async deleteItem(id_item) {
        const dispatch = this.props.dispatch;
        const token = this.props.token;
    //await deleteCashRegisterDailyState(this.props.api_url, id_item, token);
    }
    createInvoiceFromOriginal(ids, invoice_type) {
        const items = ids.map((id)=>this.state.table_items[id]).sort((a, b)=>a.document_number.localeCompare(b.document_number));
        let min_date = null;
        let max_date = null;
        let items_items = [];
        let note = '';
        for(let i = 0; i < items.length; i++){
            const item = items[i];
            if (min_date === null || item.document_date < min_date) min_date = item.document_date;
            if (max_date === null || item.document_date > max_date) max_date = item.document_date;
            items_items = items_items.concat(item.items);
            const delivery_address = item.delivery_address.trim();
            if (delivery_address.length > 0) note += delivery_address + '\n';
            note += "\u0160t. dobavnice: " + item.document_number + '\n';
            note += "\u0160t. naro\u010Dila: " + item.order_number + '\n';
            note += '\n';
        }
        const new_item = (0, _invoiceCreatorDefault.default).CreateInvoiceFromInitialData({
            id_invoice: (0, _uuidDefault.default).v4(),
            id_customer: items[0].id_customer,
            invoice_date: new Date(),
            invoice_type,
            note: note.trim(),
            payment_date: null,
            reference: '',
            reservation: '',
            service_date_start: (0, _momentDefault.default)(min_date).toDate(),
            service_date_end: (0, _momentDefault.default)(max_date).toDate(),
            invoice_amount: 0,
            id_cash_register: this.props.current_id_cash_register,
            advance_payment_amount: 0,
            credit_note_type: null,
            items: items_items.map((item_item, idx)=>{
                const item_item_item = this.props.items[item_item.id_item];
                const measuring_unit = this.props.measuring_units[item_item_item.id_measuring_unit];
                const id_price_list = (0, _priceHelperDefault.default).FindBestPriceListMatch(new Date(), item_item_item.price_lists);
                const price_list = item_item_item.price_lists[id_price_list];
                const tax_rate = this.props.tax_rates[price_list.id_tax_rate];
                return (0, _invoiceCreatorDefault.default).CreateInvoiceItemFromInitialData({
                    id_invoice_item: (0, _uuidDefault.default).v4(),
                    description: item_item_item.description,
                    discount: item_item.purchase_discount,
                    id_item: item_item_item.id_item,
                    id_item_price_list: id_price_list,
                    id_tax_rate: price_list.id_tax_rate,
                    item_measuring_unit_code: measuring_unit.title,
                    item_measuring_unit_decimal_digit_count: measuring_unit.decimal_digit_count,
                    price: parseFloat(item_item.price),
                    quantity: parseFloat(item_item.quantity),
                    tax_rate: parseFloat(tax_rate.value),
                    approved_percent: 100,
                    item_type: item_item_item.type,
                    item_ean: item_item_item.ean,
                    item_title: item_item_item.title,
                    ord: idx,
                    taxable: tax_rate.taxable,
                    item_internal_code: item_item_item.internal_code,
                    id_warehouse: item_item_item.type != 'item' ? null : (0, _invoiceDefault.default).findCurrentIdWarehouse(this.props.current_id_cash_register === undefined || this.props.current_id_cash_register === null ? null : this.props.cash_registers[this.props.current_id_cash_register], this.props.warehouses)
                });
            }),
            payments: [],
            original_id_invoice: '',
            original_invoice_type: ''
        });
        this.props.openInvoiceDialog(new_item, new_item.invoice_type, {}, ids.map((id_document)=>{
            return {
                id_document,
                document_type: 'delivery-note'
            };
        }));
        this.setState({
            table_items_checked_ids: {}
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('stock--delivery-notes') === -1) return null;
        const checked_ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        const check_count = checked_ids.length;
        let checked_items_have_same_customer = true;
        let prev_id_customer = null;
        for(let i = 0; i < checked_ids.length; i++){
            const id_customer = this.state.table_items[checked_ids[i]].id_customer;
            if (prev_id_customer !== null && prev_id_customer != id_customer) {
                checked_items_have_same_customer = false;
                break;
            }
            prev_id_customer = id_customer;
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.add_edit_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEditDeliveryNoteDialogDefault.default), {
                    closeDialog: this.closeAddEditItemDialog,
                    item: this.state.add_edit_item_dialog_item
                }),
                this.state.delete_request_id_item === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                    cancelButtonText: "Prekli\u010Di",
                    confirmButtonText: "Bri\u0161i",
                    canEscapeKeyCancel: true,
                    canOutsideClickCancel: true,
                    icon: "trash",
                    intent: (0, _core.Intent).DANGER,
                    isOpen: true,
                    onConfirm: ()=>{
                        this.deleteItem(this.state.delete_request_id_item);
                        this.setState({
                            delete_request_id_item: null
                        });
                    },
                    onCancel: ()=>{
                        this.setState({
                            delete_request_id_item: null
                        });
                    },
                    children: "Ali res \u017Eelite izbrisati ta zapis?"
                }),
                !this.state.saving ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: true,
                    usePortal: true,
                    canOutsideClickClose: false,
                    canEscapeKeyClose: false,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex flex-col flex-grow",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _core.Classes).DIALOG_BODY,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ProgressBar), {
                                    animate: this.state.saving,
                                    intent: "primary"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-xl text-center font-light pt-5",
                                    children: "Shranjevanje"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow base-list stock-acquisition-document-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "success",
                                        icon: "plus",
                                        className: "align-middle",
                                        onClick: ()=>this.openAddEditItemDialog(null),
                                        children: "Nova dobavnica"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    className: "ml-2",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        icon: "print",
                                        className: "align-middle",
                                        disabled: check_count == 0,
                                        onClick: ()=>{
                                            checked_ids.forEach((id)=>{
                                                const item = this.state.table_items[id];
                                                this.props.dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                                                    type: 'delivery-note',
                                                    lang: 'sl',
                                                    delivery_note: item
                                                }));
                                            });
                                        },
                                        children: "Natisni"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    className: "ml-2",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "warning",
                                        icon: "inheritance",
                                        className: "align-middle",
                                        disabled: check_count === 0 || !checked_items_have_same_customer,
                                        onClick: ()=>{
                                            this.createInvoiceFromOriginal(checked_ids, 'invoice');
                                        },
                                        children: "Izdelaj fakturo"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    users: this.props.users,
                                    customers: this.props.customers,
                                    tax_rates: this.props.tax_rates,
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    document_associations: this.props.document_associations
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
DeliveryNotes.propTypes = {};
function mapStateToProps(state) {
    return {
        api_url: state.CashRegisterSlice.api_url,
        cash_registers: state.CashRegisterSlice.cash_registers,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        users: state.UserSlice.users,
        items: state.CodeTablesSlice.items,
        customers: state.CodeTablesSlice.customers,
        tax_rates: state.CodeTablesSlice.tax_rates,
        measuring_units: state.CodeTablesSlice.measuring_units,
        warehouses: state.CodeTablesSlice.warehouses,
        delivery_notes: state.WarehouseSlice.delivery_notes,
        document_associations: state.DocumentSlice.document_associations_id_documents
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(DeliveryNotes);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","uuid":"b52pV","moment":"1e4qG","@blueprintjs/core":"6Mq52","../../api/CodeTables":"4GMYC","../../api/Warehouses":"WVdXb","../../api/Items":"aBK6D","./AddEditDeliveryNoteDialog":"2b0pH","../../helpers/PriceHelper":"91cdD","../../helpers/InvoiceCreator":"d7VsE","../../helpers/Invoice":"jffQW","../../slices/AppSlice":"aByTQ","../code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2b0pH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _select = require("@blueprintjs/select");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _xlsx = require("xlsx");
var _xlsxDefault = parcelHelpers.interopDefault(_xlsx);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _customerSelect = require("../CustomerSelect");
var _customerSelectDefault = parcelHelpers.interopDefault(_customerSelect);
var _selectCustomerDialog = require("../reservations/SelectCustomerDialog");
var _selectCustomerDialogDefault = parcelHelpers.interopDefault(_selectCustomerDialog);
var _numbers = require("../../numbers");
var _documents = require("../Documents");
var _documentsDefault = parcelHelpers.interopDefault(_documents);
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _appToaster = require("../AppToaster");
var _warehouses = require("../../api/Warehouses");
var _utils = require("../../utils");
var _customerDeliveryAddressPickerDialog = require("./CustomerDeliveryAddressPickerDialog");
var _customerDeliveryAddressPickerDialogDefault = parcelHelpers.interopDefault(_customerDeliveryAddressPickerDialog);
const Types = {
    'delivery': 'Dobavnica',
    'return': "Vra\u010Dilo v zalogo"
};
class InvoiceItemViewModel {
    constructor(single_purchase_price_without_vat, single_purchase_price_with_vat, single_purchase_price_with_discount_without_vat, single_purchase_price_with_discount_with_vat, purchase_price_without_vat, purchase_price_with_vat, price_with_vat, invoice_item){
        this.single_purchase_price_without_vat = single_purchase_price_without_vat;
        this.single_purchase_price_with_vat = single_purchase_price_with_vat;
        this.single_purchase_price_with_discount_without_vat = single_purchase_price_with_discount_without_vat;
        this.single_purchase_price_with_discount_with_vat = single_purchase_price_with_discount_with_vat;
        this.purchase_price_without_vat = purchase_price_without_vat;
        this.purchase_price_with_vat = purchase_price_with_vat;
        this.price_with_vat = price_with_vat;
        this.invoice_item = invoice_item;
        this.quantity_formatted = this.formatNumber(this.invoice_item.quantity, this.invoice_item.item_measuring_unit_decimal_digit_count);
        this.purchase_discount_formatted = this.formatNumber(this.invoice_item.purchase_discount);
        this.single_purchase_price_without_vat_formatted = this.formatNumber(this.single_purchase_price_without_vat, 4);
        this.single_purchase_price_with_vat_formatted = this.formatNumber(this.single_purchase_price_with_vat, 4);
        this.single_purchase_price_with_discount_without_vat_formatted = this.formatNumber(this.single_purchase_price_with_discount_without_vat, 4);
        this.single_purchase_price_with_discount_with_vat_formatted = this.formatNumber(this.single_purchase_price_with_discount_with_vat, 4);
        this.purchase_price_without_vat_formatted = this.formatNumber(this.purchase_price_without_vat);
        this.purchase_price_with_vat_formatted = this.formatNumber(this.purchase_price_with_vat);
        this.price_with_vat_formatted = this.formatNumber(this.price_with_vat);
        this.price = this.price.bind(this);
        //this.priceWithoutVat = this.priceWithoutVat.bind(this);
        this.original_price_with_vat = price_with_vat;
        this.original_price_with_vat_formatted = this.formatNumber(this.original_price_with_vat);
        this.price_list_price_with_vat = price_with_vat;
        this.price_list_price_with_vat_formatted = this.formatNumber(this.price_list_price_with_vat);
    }
    static FromInvoiceItem(items, invoice_item, tax_rates) {
        const item = items[invoice_item.id_item];
        const price_list_items = item === undefined ? {} : item.price_lists;
        const price_list = invoice_item.id_item_price_list === null ? undefined : price_list_items[invoice_item.id_item_price_list];
        const price = invoice_item.price !== undefined ? invoice_item.price : price_list === undefined ? 0 : price_list.price;
        const quantity = invoice_item.quantity;
        const discount = invoice_item.purchase_discount;
        const purchase_price_without_vat = invoice_item.purchase_price_without_vat;
        console.log({
            invoice_item
        });
        const purchase_vat = invoice_item.purchase_id_tax_rate === null || invoice_item.purchase_id_tax_rate == -1 ? 0 : tax_rates[invoice_item.purchase_id_tax_rate].value;
        return new InvoiceItemViewModel(purchase_price_without_vat, purchase_price_without_vat * (1 + purchase_vat / 100), purchase_price_without_vat * (1 - discount / 100), purchase_price_without_vat * (1 - discount / 100) * (1 + purchase_vat / 100), purchase_price_without_vat * quantity * (1 - discount / 100), purchase_price_without_vat * quantity * (1 - discount / 100) * (1 + purchase_vat / 100), price, invoice_item);
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    price(priceList) {
        if (this.invoice_item.id_item_price_list === null) return 0;
        return priceList[this.invoice_item.id_item_price_list].price;
    }
}
const ItemsListItem = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    const item = props.item;
    const idx = props.idx;
    let vat = item.invoice_item.id_tax_rate === null || item.invoice_item.id_tax_rate == -1 ? 0 : props.tax_rates[item.invoice_item.id_tax_rate].value;
    let column_idx = 1;
    const ref = /*#__PURE__*/ (0, _reactDefault.default).createRef();
    return props.read_only ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-center",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                    icon: "trash",
                    intent: "danger",
                    minimal: true,
                    small: true,
                    disabled: props.read_only,
                    onClick: ()=>{}
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col",
                style: {
                    gridColumn: column_idx++
                },
                children: item.invoice_item.internal_code + " \u2022 " + item.invoice_item.item_title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-center",
                style: {
                    gridColumn: column_idx++
                },
                children: item.quantity_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_without_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_with_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.purchase_discount_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_with_discount_without_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_with_discount_with_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.purchase_price_without_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.purchase_price_with_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: props.formatNumber(vat)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: props.stock_state_item === undefined ? '' : props.stock_state_item.count
            })
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-center",
                style: {
                    gridColumn: column_idx++
                },
                children: item.invoice_item.id_item == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                    icon: "trash",
                    intent: "danger",
                    minimal: true,
                    small: true,
                    onClick: ()=>{
                        props.deleteItem(props.idx);
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col tight service-suggest",
                style: {
                    gridColumn: column_idx++
                },
                children: item.invoice_item.item_title !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: 'pl-2 text-selectable ' + (item.invoice_item.id_item === null ? 'text-green-500' : ''),
                    children: item.invoice_item.internal_code + " \u2022 " + item.invoice_item.item_title
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Suggest), {
                    itemPredicate: (query, item, idx, exactMatch)=>{
                        const trimmed_query = query.trim();
                        if (trimmed_query.length < 2) return false;
                        if (trimmed_query.length == 2) return item.internal_code.toLowerCase().indexOf(trimmed_query.toLowerCase()) == 0;
                        return item.title.toLowerCase().indexOf(trimmed_query.toLowerCase()) > -1 || item.internal_code.toLowerCase().indexOf(trimmed_query.toLowerCase()) > -1 || item.ean !== null && item.ean.length > 0 && item.ean == trimmed_query;
                    },
                    itemRenderer: (item, { handleClick, modifiers })=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MenuItem), {
                            active: modifiers.active,
                            onClick: handleClick,
                            text: item.internal_code + " \u2022 " + item.title,
                            label: item.ean
                        }, item.internal_code);
                    },
                    items: Object.values(props.items),
                    onItemSelect: (item)=>{
                        props.addItem(item, idx);
                        if (ref !== undefined && ref !== null && ref.current !== undefined && ref.current !== null) {
                            const curr = ref.current;
                            curr.focus();
                            setTimeout(()=>{
                                curr.select();
                            }, 200);
                        }
                    },
                    openOnKeyDown: true,
                    popoverProps: {
                        targetProps: {
                            style: {
                                display: 'block'
                            }
                        },
                        minimal: true
                    },
                    fill: true,
                    selectedItem: item.invoice_item.id_item == -1 ? null : props.items[item.invoice_item.id_item],
                    inputProps: {
                        placeholder: "I\u0161\u010Di"
                    },
                    inputValueRenderer: (item)=>item.internal_code + " \u2022 " + item.title,
                    resetOnSelect: true,
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-center tight",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    value: item.quantity_formatted,
                    className: "text-center",
                    ref: ref,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.invoice_item.quantity;
                        props.changeInvoiceItemValue(item, idx, [
                            'invoice_item',
                            'quantity'
                        ], val, null, 'quantity_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    className: "text-right",
                    value: item.single_purchase_price_without_vat_formatted,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.single_purchase_price_without_vat;
                        props.changeInvoiceItemValue(item, idx, 'single_purchase_price_without_vat', val, null, 'single_purchase_price_without_vat_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    className: "text-right",
                    value: item.single_purchase_price_with_vat_formatted,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.single_purchase_price_with_vat;
                        props.changeInvoiceItemValue(item, idx, 'single_purchase_price_with_vat', val, null, 'single_purchase_price_with_vat_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col tight text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    className: "text-right",
                    value: item.purchase_discount_formatted,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.invoice_item.purchase_discount;
                        props.changeInvoiceItemValue(item, idx, [
                            'invoice_item',
                            'purchase_discount'
                        ], val, null, 'purchase_discount_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_with_discount_without_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: item.single_purchase_price_with_discount_with_vat_formatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col tight text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    className: "text-right",
                    value: item.purchase_price_without_vat_formatted,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.purchase_price_without_vat;
                        props.changeInvoiceItemValue(item, idx, 'purchase_price_without_vat', val, null, 'purchase_price_without_vat_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col tight text-right",
                style: {
                    gridColumn: column_idx++
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    className: "text-right",
                    value: item.purchase_price_with_vat_formatted,
                    onChange: (event)=>{
                        let val = (0, _numbers.parseFloatLocal)(event.target.value);
                        if (Object.is(val, NaN)) val = item.purchase_price_with_vat;
                        props.changeInvoiceItemValue(item, idx, 'purchase_price_with_vat', val, null, 'purchase_price_with_vat_formatted', event.target.value);
                    },
                    onBlur: (event)=>props.changeInvoiceItemValue(item, idx, 'refresh', null),
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col",
                style: {
                    gridColumn: column_idx++
                },
                children: item.invoice_item.id_item != -1 && item.invoice_item.id_item !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: item.invoice_item.id_tax_rate === null || item.invoice_item.id_tax_rate === undefined || props.tax_rates[item.invoice_item.id_tax_rate] === undefined ? null : props.formatNumber(props.tax_rates[item.invoice_item.id_tax_rate].value) + "% \u2022 " + props.tax_rates[item.invoice_item.id_tax_rate].title
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                    options: [
                        {
                            label: '-- izberi --',
                            value: -1
                        },
                        ...Object.keys(props.tax_rates).sort((a, b)=>props.tax_rates[b].value - props.tax_rates[a].value).map((x)=>{
                            return {
                                label: props.formatNumber(props.tax_rates[x].value) + "% \u2022 " + props.tax_rates[x].title,
                                value: x
                            };
                        })
                    ],
                    value: item.invoice_item.id_tax_rate,
                    onChange: (e)=>{
                        props.changeInvoiceItemValue(item, idx, [
                            'invoice_item',
                            'id_tax_rate'
                        ], e.currentTarget.value, null, '', '');
                    },
                    disabled: props.disabled
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-table-col text-right",
                style: item.price_with_vat == item.original_price_with_vat ? {
                    gridColumn: column_idx++
                } : {
                    gridColumn: column_idx++,
                    backgroundColor: '#ffa7a7'
                },
                children: props.stock_state_item === undefined ? '' : props.stock_state_item.count
            })
        ]
    });
});
class ItemsList extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.setMainTableItemsSort = this.setMainTableItemsSort.bind(this);
        this.formatNumber = this.formatNumber.bind(this);
        this.addEmptyItemIfNeeded = this.addEmptyItemIfNeeded.bind(this);
        this.changeInvoiceItemValue = this.changeInvoiceItemValue.bind(this);
        this.addItem = this.addItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.state = {
            main_table_items_sort_field: '',
            main_table_items_sort_direction: 'ASC'
        };
        this.main_table_refs = [];
    }
    setMainTableItemsSort(field) {
    //let direction = 'ASC';
    //if (this.state.main_table_items_sort_field == field) {
    //	direction = (this.state.main_table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC');
    //}
    //
    //const ids = this.state.main_table_items_sort_ids;
    //ids.sort((a_key, b_key) => {
    //	const a = this.state.main_table_items[a_key][field];
    //	const b = this.state.main_table_items[b_key][field];
    //	
    //	return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
    //});
    //
    //this.setState({
    //	main_table_items_sort_ids:       ids,
    //	main_table_items_sort_field:     field,
    //	main_table_items_sort_direction: direction,
    //});
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    addEmptyItemIfNeeded(document_items) {
        if (this.props.read_only) return;
        if (document_items.length == 0 || document_items[document_items.length - 1].invoice_item.id_item != -1) {
            const item = InvoiceItemViewModel.FromInvoiceItem(this.props.items, this.getEmptyInvoiceItem(), this.props.tax_rates);
            item.quantity = 1;
            document_items.push(item);
            this.props.setInvoiceItems(document_items);
        }
    }
    getEmptyInvoiceItem() {
        return {
            id_delivery_note_item: -1,
            id_delivery_note: -1,
            id_item: -1,
            quantity: 0,
            price: 0,
            id_tax_rate: -1,
            purchase_price_without_vat: 0,
            purchase_id_tax_rate: -1,
            purchase_discount: 0,
            item_title: null,
            id_item_price_list: -1,
            item_measuring_unit_decimal_digit_count: 0,
            ean: '',
            internal_code: ''
        };
    }
    changeInvoiceItemValue(item, idx, field_name, val, document_items, formatted_field_name, formatted_field_value) {
        document_items = [
            ...document_items || this.props.document_items
        ];
        const new_item = {
            ...document_items[idx]
        };
        if (Array.isArray(field_name)) new_item[field_name[0]][field_name[1]] = val;
        else if (field_name != 'refresh') new_item[field_name] = val;
        if (field_name == 'refresh') {
            // round quantity to item_measuring_unit_decimal_digit_count
            const quantity = parseFloat(new_item.invoice_item.quantity);
            const decimal_digit_count = 2; //parseFloat(new_item.invoice_item.item_measuring_unit_decimal_digit_count);
            let decimal_factor = 10 * decimal_digit_count;
            if (decimal_factor == 0) decimal_factor = 1;
            new_item.invoice_item.quantity = Math.round(quantity * decimal_factor) / decimal_factor;
        }
        /*let vat = 0;
		if (item.invoice_item !== undefined &&
			item.invoice_item.id_item_price_list !== null &&
			item.invoice_item.id_item != -1
		) {
			vat = this.props.tax_rates[
				this.props.items[item.invoice_item.id_item].price_lists[item.invoice_item.id_item_price_list].id_tax_rate
			].value;
		}*/ new_item.quantity_formatted = new_item.invoice_item.quantity;
        new_item.purchase_discount_formatted = new_item.invoice_item.purchase_discount;
        new_item.single_purchase_price_with_vat_formatted = new_item.single_purchase_price_with_vat;
        new_item.purchase_price_with_vat_formatted = new_item.purchase_price_with_vat;
        new_item.purchase_price_without_vat_formatted = new_item.purchase_price_without_vat;
        new_item.single_purchase_price_without_vat_formatted = new_item.single_purchase_price_without_vat;
        new_item.single_purchase_price_with_discount_without_vat_formatted = new_item.single_purchase_price_with_discount_without_vat;
        new_item.single_purchase_price_with_discount_with_vat_formatted = new_item.single_purchase_price_with_discount_with_vat;
        new_item.price_with_vat_formatted = new_item.price_with_vat;
        // set new price
        /*if (
			Array.isArray(field_name)             &&
			field_name.length == 2                &&
			field_name[0] == 'invoice_item'       &&
			field_name[1] == 'id_item_price_list'
		) {
			new_item.single_purchase_price_with_vat =
				this.props.items[item.invoice_item.id_item].price_lists[item.invoice_item.id_item_price_list].price;
		}*/ const purchase_id_tax_rate = new_item.invoice_item.purchase_id_tax_rate;
        const purchase_vat = purchase_id_tax_rate === null || purchase_id_tax_rate === undefined || purchase_id_tax_rate == -1 ? 0 : this.props.tax_rates[purchase_id_tax_rate].value;
        let purchase_price_without_vat = new_item.single_purchase_price_without_vat;
        if (field_name == 'single_purchase_price_with_vat') purchase_price_without_vat = new_item.single_purchase_price_with_vat / (1 + purchase_vat / 100);
        else if (field_name == 'purchase_price_with_vat') purchase_price_without_vat = new_item.purchase_price_with_vat / new_item.invoice_item.quantity / (1 - new_item.invoice_item.purchase_discount / 100) / (1 + purchase_vat / 100);
        else if (field_name == 'purchase_price_without_vat') purchase_price_without_vat = new_item.purchase_price_without_vat / new_item.invoice_item.quantity / (1 - new_item.invoice_item.purchase_discount / 100);
        // format discount
        if (formatted_field_name == 'purchase_discount_formatted') new_item.purchase_discount_formatted = formatted_field_value;
        else if (!Array.isArray(field_name) || field_name[1] != 'purchase_discount') new_item.purchase_discount_formatted = this.formatNumber(new_item.invoice_item.purchase_discount);
        // format quantity
        if (formatted_field_name == 'quantity_formatted') new_item.quantity_formatted = formatted_field_value;
        else if (!Array.isArray(field_name) || field_name[1] != 'quantity') new_item.quantity_formatted = this.formatNumber(new_item.invoice_item.quantity, new_item.invoice_item.item_measuring_unit_decimal_digit_count);
        // calculate and format single price without VAT
        if (formatted_field_name == 'single_purchase_price_without_vat_formatted') new_item.single_purchase_price_without_vat_formatted = formatted_field_value;
        else if (field_name != 'single_purchase_price_without_vat') {
            new_item.single_purchase_price_without_vat = purchase_price_without_vat;
            new_item.single_purchase_price_without_vat_formatted = this.formatNumber(new_item.single_purchase_price_without_vat, 4);
        }
        // calculate and format single price with VAT
        if (formatted_field_name == 'single_purchase_price_with_vat_formatted') new_item.single_purchase_price_with_vat_formatted = formatted_field_value;
        else if (field_name != 'single_purchase_price_with_vat') {
            new_item.single_purchase_price_with_vat = purchase_price_without_vat * (1 + purchase_vat / 100);
            new_item.single_purchase_price_with_vat_formatted = this.formatNumber(new_item.single_purchase_price_with_vat, 4);
        }
        // calculate and format single price with discount without VAT
        if (formatted_field_name == 'single_purchase_price_with_discount_without_vat_formatted') new_item.single_purchase_price_with_discount_without_vat_formatted = formatted_field_value;
        else if (field_name != 'single_purchase_price_with_discount_without_vat') {
            new_item.single_purchase_price_with_discount_without_vat = purchase_price_without_vat * (1 - new_item.invoice_item.purchase_discount / 100);
            new_item.single_purchase_price_with_discount_without_vat_formatted = this.formatNumber(new_item.single_purchase_price_with_discount_without_vat, 4);
        }
        // calculate and format single price with discount with VAT
        if (formatted_field_name == 'single_purchase_price_with_discount_with_vat_formatted') new_item.single_purchase_price_with_discount_with_vat_formatted = formatted_field_value;
        else if (field_name != 'single_purchase_price_with_discount_with_vat') {
            new_item.single_purchase_price_with_discount_with_vat = purchase_price_without_vat * (1 + purchase_vat / 100) * (1 - new_item.invoice_item.purchase_discount / 100);
            new_item.single_purchase_price_with_discount_with_vat_formatted = this.formatNumber(new_item.single_purchase_price_with_discount_with_vat, 4);
        }
        // calculate and format price with discount without VAT
        if (formatted_field_name == 'purchase_price_without_vat_formatted') new_item.purchase_price_without_vat_formatted = formatted_field_value;
        else if (field_name != 'purchase_price_without_vat') {
            new_item.purchase_price_without_vat = purchase_price_without_vat * new_item.invoice_item.quantity * (1 - new_item.invoice_item.purchase_discount / 100);
            new_item.purchase_price_without_vat_formatted = this.formatNumber(new_item.purchase_price_without_vat);
        }
        // calculate and format price with discount with VAT
        if (formatted_field_name == 'purchase_price_with_vat_formatted') new_item.purchase_price_with_vat_formatted = formatted_field_value;
        else if (field_name != 'purchase_price_with_vat') {
            new_item.purchase_price_with_vat = purchase_price_without_vat * (1 + purchase_vat / 100) * new_item.invoice_item.quantity * (1 - new_item.invoice_item.purchase_discount / 100);
            new_item.purchase_price_with_vat_formatted = this.formatNumber(new_item.purchase_price_with_vat);
        }
        // format single price with VAT
        if (formatted_field_name == 'price_with_vat_formatted') new_item.price_with_vat_formatted = formatted_field_value;
        else if (!Array.isArray(field_name) || field_name[1] != 'price_with_vat') new_item.price_with_vat_formatted = this.formatNumber(new_item.price_with_vat);
        document_items[idx] = new_item;
        this.props.setInvoiceItems(document_items);
    }
    addItem(item, idx) {
        const item_item = this.props.items[item.id_item];
        const document_items = [
            ...this.props.document_items
        ];
        let invoice_item = {
            id_delivery_note_item: -1,
            id_delivery_note: this.state.id_delivery_note,
            id_item: item.id_item,
            quantity: 1,
            price: 99,
            id_tax_rate: null,
            purchase_price_without_vat: 0,
            purchase_id_tax_rate: -1,
            purchase_discount: 0,
            item_title: null,
            id_item_price_list: -1,
            item_measuring_unit_decimal_digit_count: 0,
            ean: item_item.ean,
            internal_code: item_item.internal_code
        };
        invoice_item = {
            ...invoice_item,
            ...this.props.findLatestPrice(item_item, true)
        };
        console.log({
            type: this.props.type
        });
        //TODO
        //if (this.props.type == 'acquisition' || this.props.type == 'write-off') {
        //	const id_warehouse = this.props.id_warehouse;
        //	console.log({
        //		id_item: item.id_item,
        //		last_stock_data: id_warehouse === null ? null : this.props.stock_state.last_stock_data[item.id_item + '--' + id_warehouse],
        //		item_price: id_warehouse === null ? null : this.props.stock_state.last_stock_data[item.id_item + '--' + id_warehouse]?.item_price ?? 0,
        //	});
        //	
        //	invoice_item.purchase_price_without_vat = id_warehouse === null ? 0 : this.props.stock_state.last_stock_data[item.id_item + '--' + id_warehouse]?.item_price ?? 0;
        //}
        invoice_item.item_measuring_unit_decimal_digit_count = this.props.measuring_units[item_item.id_measuring_unit].decimal_digit_count;
        document_items[idx] = InvoiceItemViewModel.FromInvoiceItem(this.props.items, invoice_item, this.props.tax_rates);
        this.props.setInvoiceItems(document_items);
        this.addEmptyItemIfNeeded(document_items);
        // refresh values
        this.changeInvoiceItemValue(document_items[idx], idx, 'refresh', null, document_items);
    }
    deleteItem(idx) {
        const document_items = [
            ...this.props.document_items
        ];
        document_items.splice(idx, 1);
        this.props.setInvoiceItems(document_items);
    }
    render() {
        let column_idx = 1;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: 'items-table ' + (this.props.read_only ? 'read-only' : ''),
            children: [
                this.props.read_only ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "\u0160ifra in naziv"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col text-center",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Koli\u010Dina"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Cena",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Nabavni",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "DDV (%)"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Cena",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Popust (%)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Cena s pop.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Cena s pop.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Znesek",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Znesek",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: [
                                "Prodajni",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "DDV (%)"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "PC z DDV"
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "items-table-header-col",
                            style: {
                                gridColumn: column_idx++
                            },
                            children: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('title');
                            },
                            children: [
                                "\u0160ifra in naziv",
                                this.state.main_table_items_sort_field != 'title' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-center",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('quantity');
                            },
                            children: [
                                "Koli\u010Dina",
                                this.state.main_table_items_sort_field != 'quantity' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('single_purchase_price_without_vat');
                            },
                            children: [
                                "Cena",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV",
                                this.state.main_table_items_sort_field != 'single_purchase_price_without_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('single_purchase_price_with_vat');
                            },
                            children: [
                                "Cena",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV",
                                this.state.main_table_items_sort_field != 'single_purchase_price_with_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('purchase_discount');
                            },
                            children: [
                                "Popust (%)",
                                this.state.main_table_items_sort_field != 'purchase_discount' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('single_purchase_price_with_discount_without_vat');
                            },
                            children: [
                                "Cena s pop.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV",
                                this.state.main_table_items_sort_field != 'single_purchase_price_with_discount_without_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('single_purchase_price_with_discount_with_vat');
                            },
                            children: [
                                "Cena s pop.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV",
                                this.state.main_table_items_sort_field != 'single_purchase_price_with_discount_with_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('purchase_price_without_vat');
                            },
                            children: [
                                "Znesek",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "brez DDV",
                                this.state.main_table_items_sort_field != 'purchase_price_without_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('purchase_price_with_vat');
                            },
                            children: [
                                "Znesek",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "z DDV",
                                this.state.main_table_items_sort_field != 'purchase_price_with_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('id_tax_rate');
                            },
                            children: [
                                "Prodajni",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "DDV (%)",
                                this.state.main_table_items_sort_field != 'id_tax_rate' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "items-table-header-col text-right",
                            style: {
                                gridColumn: column_idx++
                            },
                            onClick: ()=>{
                                this.setMainTableItemsSort('price_with_vat');
                            },
                            children: [
                                "Trenutna zaloga",
                                this.state.main_table_items_sort_field != 'price_with_vat' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                    icon: 'caret-' + (this.state.main_table_items_sort_direction == 'ASC' ? 'up' : 'down'),
                                    color: "#888888"
                                })
                            ]
                        })
                    ]
                }),
                this.props.document_items.map((item, idx)=>{
                    const stock_state_item = this.props.all_stock_state.last_stock_data[item.invoice_item.id_item + '--' + (this.props.id_warehouse ?? 'null')];
                    console.log({
                        item,
                        key: item.invoice_item.id_item + '--' + (this.props.id_warehouse ?? 'null'),
                        stock_state_item
                    });
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ItemsListItem, {
                            idx: idx,
                            read_only: this.props.read_only,
                            item: item,
                            items: this.props.items,
                            tax_rates: this.props.tax_rates,
                            setInvoiceItems: this.props.setInvoiceItems,
                            addEmptyItemIfNeeded: this.addEmptyItemIfNeeded,
                            formatNumber: this.formatNumber,
                            id_delivery_note: this.state.id_delivery_note,
                            findBestPriceListMatch: this.props.findBestPriceListMatch,
                            findLatestPrice: this.props.findLatestPrice,
                            measuring_units: this.props.measuring_units,
                            changeInvoiceItemValue: this.changeInvoiceItemValue,
                            addItem: this.addItem,
                            deleteItem: this.deleteItem,
                            disabled: this.props.disabled,
                            stock_state_item: stock_state_item
                        })
                    }, 'invoice-item-' + idx);
                })
            ]
        });
    }
}
class AddEditDeliveryNoteDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.openSelectCustomerDialog = this.openSelectCustomerDialog.bind(this);
        this.closeSelectCustomerDialog = this.closeSelectCustomerDialog.bind(this);
        this.getItemFromState = this.getItemFromState.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.closeDialogWithIgnore = this.closeDialogWithIgnore.bind(this);
        this.confirmCloseWithoutSave = this.confirmCloseWithoutSave.bind(this);
        this.convertDocumentItems = this.convertDocumentItems.bind(this);
        this.hasChanged = this.hasChanged.bind(this);
        this.isDraft = this.isDraft.bind(this);
        this.toLocalStringWithTime = this.toLocalStringWithTime.bind(this);
        this.findBestPriceListMatch = this.findBestPriceListMatch.bind(this);
        this.findLatestPrice = this.findLatestPrice.bind(this);
        this.setInvoiceItems = this.setInvoiceItems.bind(this);
        this.filterItems = this.filterItems.bind(this);
        this.validate = this.validate.bind(this);
        this.calculateSums = this.calculateSums.bind(this);
        this.loadStockInventoryForDate = this.loadStockInventoryForDate.bind(this);
        let draft = props.item === null ? true : props.item.draft;
        if (draft === undefined) draft = true;
        let read_only = false;
        //if (!draft) {
        //	read_only = true;
        //}
        this.state = {
            id_delivery_note: props.item === null ? (0, _uuidDefault.default).v4() : props.item.id_delivery_note,
            document_number: props.item === null || props.item.document_number === null ? '' : props.item.document_number,
            id_customer: props.item === null ? null : props.item.id_customer || null,
            document_date: props.item === null ? new Date() : props.item.document_date === null ? null : new Date(props.item.document_date),
            issue_date: props.item === null ? new Date() : props.item.issue_date === null ? null : new Date(props.item.issue_date),
            order_date: props.item === null ? new Date() : props.item.order_date === null ? null : new Date(props.item.order_date),
            order_number: props.item === null ? '' : props.item.order_number,
            type: props.item === null ? null : props.item.type,
            note: props.item === null ? '' : props.item.note || '',
            document_items: [],
            id_warehouse: props.item === null ? null : props.item.id_warehouse,
            stock_from_id_warehouse: props.item === null ? null : props.item.stock_from_id_warehouse,
            delivery_address: props.item === null ? '' : props.item.delivery_address,
            delivery_addresses: props.item === null || props.item.id_customer === null ? [] : props.customers[props.item.id_customer].delivery_addresses,
            select_customer_dialog_open: false,
            select_customer_dialog_surname: '',
            close_dialog_save_as_draft: false,
            close_dialog_confirm_open: false,
            import_failure_alert_open: false,
            import_failure_alert_missing_tax_rates: [],
            import_failure_alert_warnings: [],
            draft,
            read_only,
            filtered_items: this.filterItems(props),
            ignore_prices_for_ids: [],
            customer_delivery_address_picker_dialog_open: false
        };
        this.state.document_items = this.convertDocumentItems(props.item, read_only);
        if (this.state.issue_date !== null) {
            const issue_date_iso = (0, _momentDefault.default)(this.state.issue_date).format('YYYY-MM-DD');
            this.loadStockInventoryForDate(issue_date_iso);
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.document_items != prevState.document_items) // if an item was deleted, focus new/empty item
        {
            if (this.state.document_items.length < prevState.document_items.length) {
                const service_suggest_inputs = document.querySelectorAll('.service-suggest input');
                if (service_suggest_inputs.length > 0) service_suggest_inputs[service_suggest_inputs.length - 1].focus();
            }
        }
        if (this.props.items !== prevProps.items) this.setState({
            filtered_items: this.filterItems()
        });
        if (this.state.issue_date != prevState.issue_date) {
            if (this.state.issue_date !== null) {
                const issue_date_iso = (0, _momentDefault.default)(this.state.issue_date).format('YYYY-MM-DD');
                //if (this.props.last_stock_data_by_date[issue_date_iso] === undefined) {
                this.loadStockInventoryForDate(issue_date_iso);
            //}
            }
        }
    }
    hasChanged() {
        /*if (this.props.item === null || this.props.item === undefined) {
			return true;
		}
		
		if (this.props.item.id_customer != this.state.id_customer) return true;
		
		let first_payment = null;
		let split_payment_types = [];
		if (this.props.item !== null && this.props.item.payments !== undefined && this.props.item.payments !== null) {
			if (this.props.item.payments.length == 1) {
				first_payment = this.props.item.payments[0];
			}
			split_payment_types = this.props.item.payments;
		}
		
		if (this.state.id_payment_type == -2) {
			if (first_payment !== null) return true;
			
			if (split_payment_types.length != this.state.split_payment_types.length) return true;
			
			let found_diff = false;
			for (let i=0; i<split_payment_types.length; i++) {
				let found = false;
				
				for (let j=0; j<this.state.split_payment_types.length; j++) {
					if (
						this.state.split_payment_types[j].id_payment_type == split_payment_types[i].id_payment_type &&
						this.state.split_payment_types[j].amount          == split_payment_types[i].amount
					) {
						found = true;
						break;
					}
				}
				
				if (!found) {
					found_diff = true;
					break;
				}
			}
			if (found_diff) return true;
		}
		else if (
			first_payment === null ||
			(first_payment !== null && this.state.id_payment_type != first_payment.id_payment_type)
		) {
			return true;
		}*/ return false;
    }
    isDraft() {
        return this.state.draft;
    }
    getEmptyInvoiceItem() {
        return {
            id_delivery_note_item: -1,
            id_delivery_note: -1,
            id_item: -1,
            quantity: 0,
            price: 0,
            id_tax_rate: -1,
            purchase_price_without_vat: 0,
            purchase_id_tax_rate: -1,
            purchase_discount: 0,
            item_title: null,
            id_item_price_list: -1,
            item_measuring_unit_decimal_digit_count: 0,
            ean: '',
            internal_code: ''
        };
    }
    convertDocumentItems(item, read_only) {
        const items = [];
        if (item !== null) for(let i = 0; i < item.items.length; i++){
            const existing_item = this.props.items[item.items[i].id_item];
            const item_item = {
                ...this.props.items[item.items[i].id_item],
                ...item.items[i],
                item_title: existing_item === undefined ? item.items[i].item_title : existing_item.title
            };
            item_item.id_item_price_list = this.findBestPriceListMatch(item_item);
            const invoice_item = InvoiceItemViewModel.FromInvoiceItem(this.props.items, item_item, this.props.tax_rates);
            // skip if item doesn't exist yet
            if (item.items[i] !== undefined && item.items[i].id_item !== null && this.props.items[item.items[i].id_item] !== undefined) {
                const original_price_data = this.findLatestPrice(this.props.items[item.items[i].id_item], true);
                if (original_price_data.id_item_price_list != -1) {
                    invoice_item.original_price_with_vat = original_price_data.price;
                    invoice_item.original_price_with_vat_formatted = this.formatNumber(invoice_item.original_price_with_vat);
                }
                const price_list_price_data = this.findLatestPrice(this.props.items[item.items[i].id_item], true);
                if (price_list_price_data.id_item_price_list != -1) {
                    invoice_item.price_list_price_with_vat = price_list_price_data.price;
                    invoice_item.price_list_price_with_vat_formatted = this.formatNumber(invoice_item.price_list_price_with_vat);
                }
            }
            items.push(invoice_item);
        }
        if (!read_only) {
            const empty_invoice_item_view = InvoiceItemViewModel.FromInvoiceItem(this.props.items, this.getEmptyInvoiceItem(), this.props.tax_rates);
            empty_invoice_item_view.invoice_item.quantity = 1;
            items.push(empty_invoice_item_view);
        }
        return items;
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    getMaxDate() {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 10);
        return date;
    }
    openSelectCustomerDialog(query, item) {
        item = item || null;
        this.setState({
            select_customer_dialog_open: true,
            select_customer_dialog_surname: query,
            select_customer_dialog_item: item
        });
    }
    closeSelectCustomerDialog(id_customer, new_customer) {
        const state = {
            select_customer_dialog_open: false
        };
        if (id_customer !== undefined) state.id_customer = id_customer;
        this.setState(state);
    }
    getItemFromState(save_as_draft) {
        const items = this.state.document_items.filter((x)=>/*x.invoice_item.id_item !== null &&*/ x.invoice_item.id_item != -1).map((x)=>{
            const id_delivery_note_item = (0, _uuidDefault.default).v4();
            return {
                changed_price: x.original_price_with_vat != x.price_with_vat,
                is_new: x.invoice_item.id_delivery_note_item == -1,
                item: {
                    id_delivery_note_item,
                    id_delivery_note: this.state.id_delivery_note,
                    id_item: x.invoice_item.id_item,
                    quantity: x.invoice_item.quantity,
                    price: x.price_with_vat,
                    id_tax_rate: x.invoice_item.id_tax_rate,
                    purchase_id_tax_rate: x.invoice_item.purchase_id_tax_rate,
                    purchase_price_without_vat: x.single_purchase_price_without_vat,
                    purchase_discount: x.invoice_item.purchase_discount,
                    title: x.invoice_item.item_title,
                    ean: x.invoice_item.ean,
                    internal_code: x.invoice_item.internal_code,
                    show_description_on_documents: x.invoice_item.show_description_on_documents ?? false,
                    allowed_discount: 0,
                    allow_changing_price: true,
                    description: '',
                    id_item_price_list: x.invoice_item.id_item_price_list
                }
            };
        });
        const items_with_changed_prices = items.filter((x)=>x.changed_price);
        const items_with_changed_prices_keyed = {};
        for(let i = 0; i < items_with_changed_prices.length; i++)items_with_changed_prices_keyed[items_with_changed_prices[i].item.id_delivery_note_item] = items_with_changed_prices[i].item;
        const ignore_existing_unchanged_ids = items.filter((x)=>!x.changed_price).map((x)=>x.item.id_delivery_note_item);
        return {
            items_with_changed_prices: items_with_changed_prices_keyed,
            ignore_existing_unchanged_ids,
            item: {
                id_delivery_note: this.state.id_delivery_note,
                document_number: this.state.document_number,
                id_user: this.props.user.id_user,
                id_customer: this.state.id_customer,
                document_date: this.state.document_date === null ? null : (0, _momentDefault.default)(this.state.document_date).format('YYYY-MM-DD'),
                id_warehouse: this.state.id_warehouse,
                type: this.state.type,
                draft: save_as_draft,
                issue_date: this.state.issue_date === null ? null : (0, _momentDefault.default)(this.state.issue_date).format('YYYY-MM-DD'),
                order_date: this.state.order_date === null ? null : (0, _momentDefault.default)(this.state.order_date).format('YYYY-MM-DD'),
                order_number: this.state.order_number,
                note: this.state.note,
                stock_from_id_warehouse: this.state.stock_from_id_warehouse,
                delivery_address: this.state.delivery_address,
                items: items.map((x)=>x.item)
            }
        };
    }
    recalculateTable(document_items) {
        document_items = document_items || this.state.document_items;
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        return parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    closeDialog(save, save_as_draft) {
        if (!save) {
            this.props.closeDialog();
            return;
        }
        const validation_messages = this.validate();
        if (validation_messages.length > 0) {
            (0, _appToaster.AppToaster).show({
                message: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Napake na obrazcu:",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        validation_messages.map((title, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: "\u2022 " + title
                            }, idx))
                    ]
                }),
                intent: 'danger',
                icon: 'issue'
            });
            return;
        }
        const { items_with_changed_prices, ignore_existing_unchanged_ids, item } = this.getItemFromState(save_as_draft);
        this.closeDialogWithIgnore(item, ignore_existing_unchanged_ids);
    }
    closeDialogWithIgnore(item, ignore_prices_for_id_delivery_note_items) {
        this.props.closeDialog(item, ignore_prices_for_id_delivery_note_items, this.state.delivery_addresses);
    }
    confirmCloseWithoutSave() {
        this.setState({
            close_dialog_save_as_draft: false,
            close_dialog_confirm_open: true
        });
    }
    toLocalStringWithTime(date) {
        if (date === null) return '';
        return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear() + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');
    }
    findBestPriceListMatch(item) {
        if (item === undefined || item === null || this.state.document_date === null || this.state.document_date === undefined) return null;
        return (0, _priceHelperDefault.default).FindBestPriceListMatch(this.state.document_date, item.price_lists);
    }
    findLatestPrice(item, skip_delivery_notes) {
        skip_delivery_notes = skip_delivery_notes || false;
        let delivery_notes = skip_delivery_notes ? [] : Object.values(this.props.delivery_notes);
        // limit to current document
        //if (this.props.item !== null) {
        //	delivery_notes = delivery_notes.filter(x => x.id_delivery_note == this.state.id_delivery_note)
        //}
        delivery_notes = delivery_notes.map((x)=>{
            let found_item = null;
            for(let i = 0; i < x.items.length; i++)if (x.items[i].id_item == item.id_item) found_item = x.items[i];
            return {
                document_date: x.document_date,
                delivery_note_item: found_item
            };
        }).filter((x)=>x.delivery_note_item !== null).sort((a, b)=>{
            if (a.document_date > b.document_date) return -1;
            else if (a.document_date < b.document_date) return 1;
            return 0;
        });
        if (delivery_notes.length > 0) {
            const delivery_note_item = delivery_notes[0].delivery_note_item;
            const id_item_price_list = this.findBestPriceListMatch(this.props.items[delivery_note_item.id_item]);
            return {
                id_tax_rate: delivery_note_item.id_tax_rate,
                price: delivery_note_item.price,
                purchase_id_tax_rate: stock_acquisition_document_item.purchase_id_tax_rate,
                purchase_price_without_vat: delivery_note_item.purchase_price_without_vat,
                id_item_price_list: id_item_price_list
            };
        }
        const id_item_price_list = this.findBestPriceListMatch(item);
        if (id_item_price_list !== null) {
            const retval = {
                id_tax_rate: item.price_lists[id_item_price_list].id_tax_rate,
                price: item.price_lists[id_item_price_list].price,
                purchase_id_tax_rate: 0,
                purchase_price_without_vat: 0,
                id_item_price_list
            };
            retval.purchase_id_tax_rate = retval.id_tax_rate;
            retval.purchase_price_without_vat = retval.price / (1 + this.props.tax_rates[retval.id_tax_rate].value / 100);
            return retval;
        }
        return {
            id_tax_rate: null,
            price: this.props.items[item.id_item].price,
            purchase_id_tax_rate: -1,
            purchase_price_without_vat: 0,
            id_item_price_list: -1
        };
    }
    setInvoiceItems(document_items) {
        this.setState({
            document_items
        });
    }
    filterItems(props) {
        props = props || this.props;
        const items = {};
        for(let id_item in props.items){
            const item = props.items[id_item];
            if (item.type == 'item') items[id_item] = item;
        }
        return items;
    }
    validate() {
        const messages = [];
        if (this.state.id_customer === null) messages.push('Dobavitelj ni izbran');
        if (this.state.id_warehouse === null || this.state.id_warehouse == '-1') messages.push("Skladi\u0161\u010De ni izbrano");
        if (this.state.type === null || this.state.type == '-1') messages.push('Tip prevzema ni izbran');
        if (this.state.document_date === null) messages.push('Datum prevzema ni izbran');
        if (this.state.issue_date === null) messages.push('Datum izdaje ni izbran');
        if (this.state.document_items.length <= 1) messages.push('Dokument ne sme biti prazen');
        const internal_code_counts = {};
        const ean_counts = {};
        const quantity_must_be_positive = this.state.type == 'internal-transfer';
        let negative_quantities_exist = false;
        for(let i = 0; i < this.state.document_items.length; i++){
            const item = this.state.document_items[i];
            if (item.invoice_item.id_item == -1) continue;
            let title = item.invoice_item.item_title;
            if (title === null && item.invoice_item.id_item !== null && this.props.items[item.invoice_item.id_item] !== undefined) title = this.props.items[item.invoice_item.id_item].title;
            if (item.invoice_item.internal_code !== null && item.invoice_item.internal_code.length > 0) {
                if (internal_code_counts[item.invoice_item.internal_code] === undefined) internal_code_counts[item.invoice_item.internal_code] = {
                    id_item: item.invoice_item.id_item,
                    title,
                    count: 0
                };
                internal_code_counts[item.invoice_item.internal_code].count++;
            }
            if (item.invoice_item.ean !== null && item.invoice_item.ean.length > 0) {
                if (ean_counts[item.invoice_item.ean] === undefined) ean_counts[item.invoice_item.ean] = {
                    id_item: item.invoice_item.id_item,
                    title,
                    count: 0
                };
                ean_counts[item.invoice_item.ean].count++;
            }
            if ([
                item.price_with_vat,
                item.purchase_price_with_vat,
                item.purchase_price_without_vat,
                item.single_purchase_price_with_discount_with_vat,
                item.single_purchase_price_with_discount_without_vat,
                item.single_purchase_price_with_vat,
                item.single_purchase_price_without_vat,
                item.invoice_item.price,
                item.invoice_item.purchase_discount,
                item.invoice_item.purchase_price_without_vat,
                item.invoice_item.quantity
            ].some((x)=>isNaN(x) || x === '')) messages.push('Artikel ' + (title === null ? 'neznano' : title) + ' ima vsaj eno neveljavno vrednost');
            if (item.invoice_item.quantity == 0) messages.push('Artikel ' + (title === null ? 'neznano' : title) + " ima koli\u010Dino 0");
            if (item.price_with_vat <= 0) messages.push('Artikel ' + (title === null ? 'neznano' : title) + ' ima ceno 0 ali manj');
            if (item.single_purchase_price_without_vat_formatted <= 0) messages.push('Artikel ' + (title === null ? 'neznano' : title) + ' ima nabavno ceno 0 ali manj');
            if (item.invoice_item.id_tax_rate == -1) messages.push('Artikel ' + (title === null ? 'neznano' : title) + " nima nastavljene dav\u010Dne stopnje");
            if (quantity_must_be_positive && item.invoice_item.quantity < 0) negative_quantities_exist = true;
        }
        for(let internal_code in internal_code_counts){
            if (internal_code_counts[internal_code].count <= 1) continue;
            const title = internal_code_counts[internal_code].title;
            messages.push('Artikel ' + (title === null ? 'neznano' : title) + " se ponovi ve\u010D kot enkrat");
        }
        for(let ean in ean_counts){
            if (ean_counts[ean].count <= 1) continue;
            const title = ean_counts[ean].title;
            const message = 'Artikel ' + (title === null ? 'neznano' : title) + " se ponovi ve\u010D kot enkrat";
            if (messages.indexOf(message) == -1) messages.push(message);
        }
        if (negative_quantities_exist) messages.push("Vse koli\u010Dine morajo biti pozitivne");
        if (this.state.stock_from_id_warehouse !== null && this.state.stock_from_id_warehouse === this.state.id_warehouse) messages.push("Zalogo je lahko prene\u0161ena samo v drugo skladi\u0161\u010De");
        return messages;
    }
    calculateSums() {
        const sums = {
            purchase_price_without_vat: 0,
            purchase_price_with_vat: 0,
            quantity: 0,
            count: 0
        };
        for(let i = 0; i < this.state.document_items.length; i++){
            const item = this.state.document_items[i];
            if (item.invoice_item.id_item === -1) continue;
            sums.purchase_price_without_vat += parseFloat(item.purchase_price_without_vat);
            sums.purchase_price_with_vat += parseFloat(item.purchase_price_with_vat);
            sums.quantity += parseFloat(item.invoice_item.quantity);
            sums.count += 1;
        }
        return sums;
    }
    loadStockInventoryForDate(date_iso) {
        (0, _warehouses.loadLastStockDataByDate)(this.props.api_url, this.props.dispatch, this.props.token, date_iso);
    }
    render() {
        const customer = this.state.id_customer === null ? null : this.props.customers[this.state.id_customer] || null;
        const sums = this.calculateSums();
        const disabled = this.state.id_warehouse === null || this.state.id_warehouse == '-1' || this.state.type === null || this.state.type == '-1' || this.state.issue_date === null || this.props.last_stock_data_by_date[(0, _momentDefault.default)(this.state.issue_date).format('YYYY-MM-DD')] === undefined;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: false,
            className: "add-edit-delivery-note-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    !this.state.select_customer_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectCustomerDialogDefault.default), {
                        closeSelectCustomerDialog: this.closeSelectCustomerDialog,
                        surname: this.state.select_customer_dialog_surname,
                        item: null
                    }),
                    !this.state.close_dialog_confirm_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                        cancelButtonText: "Prekli\u010Di",
                        confirmButtonText: "Zapri",
                        canEscapeKeyCancel: true,
                        canOutsideClickCancel: true,
                        icon: "help",
                        intent: (0, _core.Intent).PRIMARY,
                        isOpen: true,
                        onConfirm: ()=>{
                            this.closeDialog(false, this.state.close_dialog_save_as_draft);
                            this.setState({
                                close_dialog_save_as_draft: false,
                                close_dialog_confirm_open: false
                            });
                        },
                        onCancel: ()=>{
                            this.setState({
                                close_dialog_save_as_draft: false,
                                close_dialog_confirm_open: false
                            });
                        },
                        children: "Res \u017Eelite zapreti brez shranjevanja?"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                        confirmButtonText: "V redu",
                        icon: "warning-sign",
                        intent: (0, _core.Intent).WARNING,
                        isOpen: this.state.import_failure_alert_open && this.state.import_failure_alert_missing_tax_rates.length > 0,
                        onConfirm: ()=>{
                            this.setState({
                                import_failure_alert_open: false,
                                import_failure_alert_missing_tax_rates: []
                            });
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "bp5-heading",
                                    children: "Uvoz ni uspel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        "Manjkajo naslednje stopnje davka: ",
                                        this.state.import_failure_alert_missing_tax_rates.map((x)=>this.formatNumber(x) + '%').join(', ')
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Alert), {
                        confirmButtonText: "V redu",
                        icon: "warning-sign",
                        intent: (0, _core.Intent).WARNING,
                        isOpen: this.state.import_failure_alert_open && Object.keys(this.state.import_failure_alert_warnings).length > 0,
                        onConfirm: ()=>{
                            this.setState({
                                import_failure_alert_open: false,
                                import_failure_alert_warnings: []
                            });
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "bp5-heading",
                                    children: "Uvoz ni uspel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-selectable",
                                    children: Object.keys(this.state.import_failure_alert_warnings).map((warning)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "text-selectable",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-selectable font-semibold mt-1",
                                                    children: warning + ':'
                                                }),
                                                this.state.import_failure_alert_warnings[warning].map((x, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-selectable",
                                                        children: x
                                                    }, 'warning-' + warning + '-' + idx))
                                            ]
                                        }, warning))
                                })
                            ]
                        })
                    }),
                    !this.state.select_customer_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectCustomerDialogDefault.default), {
                        closeSelectCustomerDialog: this.closeSelectCustomerDialog,
                        surname: this.state.select_customer_dialog_surname,
                        item: this.state.select_customer_dialog_item
                    }),
                    customer === null || !this.state.customer_delivery_address_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerDeliveryAddressPickerDialogDefault.default), {
                        customer: customer,
                        closeDialog: (address, delivery_addresses)=>{
                            if (address !== undefined) this.setState({
                                delivery_address: address
                            });
                            this.setState({
                                customer_delivery_address_picker_dialog_open: false,
                                delivery_addresses
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: 'Vnos dobavnice'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        icon: "floppy-disk",
                                        onClick: ()=>this.closeDialog(true, true),
                                        className: "w-48",
                                        disabled: true,
                                        children: "Shrani kot osnutek"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "success",
                                        icon: "tick",
                                        onClick: ()=>this.closeDialog(true, false),
                                        className: "w-48 ml-2",
                                        disabled: false,
                                        children: "Zapri in zaklju\u010Di"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "danger",
                                        icon: "cross",
                                        onClick: ()=>this.confirmCloseWithoutSave(),
                                        className: "w-48 ml-10",
                                        children: "Zapri brez shranjevanja"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-grow flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "invoice-header",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "document-number",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                                className: "bp5-heading",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-thin",
                                                        children: "Dobavnica \u0161t.: "
                                                    }),
                                                    this.state.draft ? 'osnutek' : this.state.document_number
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "customer",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerSelectDefault.default), {
                                                    itemSelected: (item)=>{
                                                        this.setState({
                                                            id_customer: item.id_customer,
                                                            delivery_address: item.delivery_addresses.length == 0 ? '' : item.delivery_addresses[0],
                                                            delivery_addresses: item.delivery_addresses
                                                        });
                                                    },
                                                    addPersonClick: (query)=>{
                                                        this.openSelectCustomerDialog(query);
                                                    },
                                                    fieldTitle: "Stranka",
                                                    formGroupCls: "mb-0",
                                                    focus: true
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "customer-info",
                                                    style: {
                                                        position: 'relative'
                                                    },
                                                    children: customer === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "customer-info-inner",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: (()=>{
                                                                            const arr = [];
                                                                            if (customer.address.length > 0) arr.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                children: customer.address
                                                                            }, "address"));
                                                                            if (customer.post_office.length > 0) arr.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                children: (customer.post_code + ' ' + customer.post_office).trim()
                                                                            }, "post-office"));
                                                                            if (customer.id_country !== null) arr.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                children: this.props.countries[customer.id_country].iso_3166_1_a2
                                                                            }, "country"));
                                                                            return arr;
                                                                        })()
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "pt-2",
                                                                        children: customer.vat_registered ? 'ID za DDV: ' + customer.vat_prefix + customer.tax_number : "Dav\u010Dna \u0161t.: " + customer.tax_number
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "opacity-50 text-right pr-2",
                                                                style: {
                                                                    position: 'absolute',
                                                                    right: 0,
                                                                    bottom: 0
                                                                },
                                                                children: customer.internal_code
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                style: {
                                                                    position: 'absolute',
                                                                    right: 0,
                                                                    top: 11
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                    icon: "edit",
                                                                    minimal: true,
                                                                    onClick: ()=>{
                                                                        this.openSelectCustomerDialog('', customer);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                style: {
                                                                    position: 'absolute',
                                                                    right: 0,
                                                                    top: 32
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                    icon: "cross",
                                                                    minimal: true,
                                                                    onClick: ()=>{
                                                                        this.setState({
                                                                            id_customer: null
                                                                        });
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "document-date",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--document-date",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Datum dobavnice",
                                                        tooltip: "Datum dobavnice"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                        id: "add-edit-stock-acq-document--document-date",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: 'dd. MM. yyyy',
                                                        locale: "sl",
                                                        inputProps: {
                                                            placeholder: '01. 01. ' + new Date().getFullYear()
                                                        },
                                                        selectAllOnFocus: true,
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                        disabled: this.state.read_only,
                                                        onChange: (selectedDate, isUserChange)=>{
                                                            if (isUserChange) this.setState({
                                                                document_date: selectedDate === null ? null : new Date(selectedDate)
                                                            });
                                                        },
                                                        value: this.state.document_date === null ? null : (0, _formatISODefault.default)(this.state.document_date)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "issue-date",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--issue-date",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Datum izdaje",
                                                        tooltip: "Datum izdaje"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                        id: "add-edit-stock-acq-document--issue-date",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: 'dd. MM. yyyy',
                                                        locale: "sl",
                                                        inputProps: {
                                                            placeholder: '01. 01. ' + new Date().getFullYear()
                                                        },
                                                        selectAllOnFocus: true,
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                        onChange: (selectedDate, isUserChange)=>{
                                                            if (isUserChange) this.setState({
                                                                issue_date: selectedDate === null ? null : new Date(selectedDate)
                                                            });
                                                        },
                                                        value: this.state.issue_date === null ? null : (0, _formatISODefault.default)(this.state.issue_date)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "order-date",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--order-date",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Datum naro\u010Dila",
                                                        tooltip: "Datum naro\u010Dila"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                        id: "add-edit-stock-acq-document--order-date",
                                                        dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                        dateFnsFormat: 'dd. MM. yyyy',
                                                        locale: "sl",
                                                        inputProps: {
                                                            placeholder: '01. 01. ' + new Date().getFullYear()
                                                        },
                                                        selectAllOnFocus: true,
                                                        minDate: new Date('1900-01-01'),
                                                        maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                        disabled: this.state.read_only,
                                                        onChange: (selectedDate, isUserChange)=>{
                                                            if (isUserChange) this.setState({
                                                                order_date: selectedDate === null ? null : new Date(selectedDate)
                                                            });
                                                        },
                                                        value: this.state.order_date === null ? null : (0, _formatISODefault.default)(this.state.order_date)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "order-number",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--order-number",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "\u0160tevilka naro\u010Dila",
                                                        tooltip: "\u0160tevilka naro\u010Dila"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                        id: "add-edit-stock-acq-document--order-number",
                                                        value: this.state.order_number,
                                                        onChange: (event)=>{
                                                            this.setState({
                                                                order_number: event.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "type",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--type",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Vrsta dobavnice",
                                                        tooltip: "Vrsta dobavnice"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                        id: "add-edit-stock-acq-document--type",
                                                        fill: true,
                                                        options: [
                                                            {
                                                                label: '-- izberi --',
                                                                value: -1
                                                            },
                                                            ...Object.keys(Types).map((x)=>{
                                                                return {
                                                                    label: Types[x],
                                                                    value: x
                                                                };
                                                            })
                                                        ],
                                                        value: this.state.type || '',
                                                        onChange: (e)=>{
                                                            this.setState({
                                                                type: e.currentTarget.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "warehouse",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                labelFor: "add-edit-stock-acq-document--warehouse",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                        label: "Skladi\u0161\u010De",
                                                        tooltip: "Skladi\u0161\u010De"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                                        id: "add-edit-stock-acq-document--warehouse",
                                                        fill: true,
                                                        options: [
                                                            {
                                                                label: '-- izberi --',
                                                                value: -1
                                                            },
                                                            ...Object.values(this.props.warehouses).map((x)=>{
                                                                return {
                                                                    label: x.title,
                                                                    value: x.id_warehouse
                                                                };
                                                            })
                                                        ],
                                                        value: this.state.id_warehouse || '',
                                                        onChange: (e)=>{
                                                            this.setState({
                                                                id_warehouse: e.currentTarget.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "documents flex flex-row",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Tabs), {
                                                className: "flex flex-col flex-1",
                                                vertical: false,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                        id: "comment",
                                                        title: "Opomba",
                                                        panelClassName: "flex-grow",
                                                        panel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                            className: "table-full-h",
                                                            fill: true,
                                                            onChange: (e)=>{
                                                                this.setState({
                                                                    note: e.target.value
                                                                });
                                                            },
                                                            value: this.state.note
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                        id: "documents",
                                                        title: "Dokumenti",
                                                        panelClassName: "flex-grow h-full",
                                                        panel: this.props.item === null || this.props.item.id_delivery_note === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentsDefault.default), {
                                                            id_document: this.props.item.id_delivery_note,
                                                            deep: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tab), {
                                                        id: "delivery-address",
                                                        title: "Naslov za dostavo",
                                                        panelClassName: "flex flex-col flex-grow h-full",
                                                        panel: this.state.id_customer === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex flex-col flex-1",
                                                            children: [
                                                                customer.delivery_addresses.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                    className: "w-48 mt-1 mb-1",
                                                                    onClick: ()=>{
                                                                        this.setState({
                                                                            customer_delivery_address_picker_dialog_open: true
                                                                        });
                                                                    },
                                                                    children: "Izberi naslov"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                                    className: "table-full-h",
                                                                    fill: true,
                                                                    onChange: (e)=>{
                                                                        this.setState({
                                                                            delivery_address: e.target.value
                                                                        });
                                                                    },
                                                                    value: this.state.delivery_address
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "items-list-wrapper flex-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "items-list-scroll-container",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "items-list",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ItemsList, {
                                                read_only: this.state.read_only,
                                                document_items: this.state.document_items,
                                                items: this.state.filtered_items,
                                                tax_rates: this.props.tax_rates,
                                                invoice_date: this.state.invoice_date,
                                                measuring_units: this.props.measuring_units,
                                                stock_state: disabled ? null : this.props.last_stock_data_by_date[(0, _momentDefault.default)(this.state.issue_date).format('YYYY-MM-DD')],
                                                setInvoiceItems: this.setInvoiceItems,
                                                document_date: this.state.document_date,
                                                findBestPriceListMatch: this.findBestPriceListMatch,
                                                findLatestPrice: this.findLatestPrice,
                                                id_warehouse: this.state.id_warehouse,
                                                type: this.state.type,
                                                disabled: disabled,
                                                all_stock_state: this.props.stock_state
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "items-summary font-semibold text-base",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-1 font-normal",
                                            children: "\u0160tevilo vrstic:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-3 text-right font-normal",
                                            children: sums.count
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-5",
                                            children: "Rabat:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-6 text-right",
                                            children: this.formatNumber(0)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-8",
                                            children: "Znesek brez DDV:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-9 text-right",
                                            children: this.formatNumber(sums.purchase_price_without_vat)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-1 font-normal",
                                            children: "Skupna koli\u010Dina:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-3 text-right font-normal",
                                            children: sums.quantity
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-5",
                                            children: "Odvisni stro\u0161ki:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-6 text-right",
                                            children: this.formatNumber(0)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-8",
                                            children: "Znesek DDV:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-9 text-right",
                                            children: this.formatNumber(sums.purchase_price_with_vat - sums.purchase_price_without_vat)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-5"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-6"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-8",
                                            children: "Znesek z DDV:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-9 text-right",
                                            children: this.formatNumber(sums.purchase_price_with_vat)
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
AddEditDeliveryNoteDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func
};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        payment_types: state.CodeTablesSlice.payment_types,
        items: state.CodeTablesSlice.items,
        countries: state.CodeTablesSlice.countries,
        tax_rates: state.CodeTablesSlice.tax_rates,
        measuring_units: state.CodeTablesSlice.measuring_units,
        warehouses: state.CodeTablesSlice.warehouses,
        api_url: state.CodeTablesSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        settings: state.SettingsSlice,
        document_types: state.DocumentSlice.document_types,
        current_id_cash_register: state.SettingsSlice.current_id_cash_register,
        invoices: state.BusinessSlice.invoices,
        advance_invoice_consumptions: state.BusinessSlice.advance_invoice_consumptions,
        id_advance_invoice_consumption_by_id_consumer_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_consumer_invoices,
        delivery_notes: state.WarehouseSlice.delivery_notes,
        last_stock_data_by_date: state.WarehouseSlice.last_stock_data_by_date,
        stock_state: state.WarehouseSlice.stock_state
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddEditDeliveryNoteDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","uuid":"b52pV","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","@blueprintjs/select":"3IMc6","moment":"1e4qG","date-fns/formatISO":"an1FA","xlsx":"eqXnQ","../TextWithTooltip":"6kuHH","../CustomerSelect":"8sizu","../reservations/SelectCustomerDialog":"ewc5P","../../numbers":"jOh9w","../Documents":"jYQ4x","../../helpers/PriceHelper":"91cdD","../AppToaster":"izixN","../../api/Warehouses":"WVdXb","../../utils":"kh8Vf","./CustomerDeliveryAddressPickerDialog":"ffXDN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffXDN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _core = require("@blueprintjs/core");
class CustomerDeliveryAddressPickerDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            filter: '',
            delivery_addresses: props.customer.delivery_addresses
        };
    }
    render() {
        const filter = this.state.filter.toLowerCase();
        let filtered_addresses = [];
        for(let i = 0; i < this.state.delivery_addresses.length; i++)if (this.state.filter.length === 0 || this.state.delivery_addresses[i].toLowerCase().indexOf(filter) !== -1) filtered_addresses.push({
            idx: i,
            delivery_address: this.state.delivery_addresses[i]
        });
        /*filtered_addresses = [];
		for (let i=0; i<50; i++) {
			filtered_addresses.push(
				'test '.repeat(Math.floor(Math.random() * 20 + 5))
			);
			//filtered_addresses = [...filtered_addresses, ...filtered_addresses];
		}*/ return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: true,
            canEscapeKeyClose: true,
            onClose: ()=>this.props.closeDialog(undefined, this.state.delivery_addresses),
            className: "customer-delivery-address-picker-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow max-h-full",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: 'Izberi naslov'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog(undefined, this.state.delivery_addresses)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _core.Classes).DIALOG_BODY + ' flex flex-col',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "relative flex-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                    className: "mb-2",
                                    value: this.state.filter,
                                    onChange: (event)=>{
                                        this.setState({
                                            filter: event.target.value
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overflow-y-auto absolute inset-0",
                                    style: {
                                        top: 36
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "grid grid-cols-5 gap-1",
                                        style: {
                                            gridTemplateColumns: '24px 1fr 8px 24px 1fr'
                                        },
                                        children: filtered_addresses.map((x, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                        icon: "trash",
                                                        intent: "danger",
                                                        minimal: true,
                                                        small: true,
                                                        onClick: ()=>{
                                                            const delivery_addresses = [
                                                                ...this.state.delivery_addresses
                                                            ];
                                                            delivery_addresses.splice(x.idx, 1);
                                                            this.setState({
                                                                delivery_addresses
                                                            });
                                                        },
                                                        className: "justify-center items-center self-start"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                        onClick: ()=>this.props.closeDialog(x.delivery_address, this.state.delivery_addresses),
                                                        className: "justify-start items-start",
                                                        children: x.delivery_address.split('\n').map((line, line_idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                children: line
                                                            }, line_idx))
                                                    }),
                                                    idx % 2 == 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}) : null
                                                ]
                                            }, idx))
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
CustomerDeliveryAddressPickerDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func,
    customer: (0, _propTypesDefault.default).object
};
exports.default = CustomerDeliveryAddressPickerDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@blueprintjs/core":"6Mq52","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l0cLh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _codeTablesSlice = require("../../slices/CodeTablesSlice");
var _stockInventoryDetailedDialog = require("./StockInventoryDetailedDialog");
var _stockInventoryDetailedDialogDefault = parcelHelpers.interopDefault(_stockInventoryDetailedDialog);
var _warehouses = require("../../api/Warehouses");
var _resultComponents = require("../code_tables/ResultComponents");
var _app = require("../../App");
var _utils = require("../../utils");
function Results(props) {
    const { table_items_total_count, table_items, all_table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openDetailedDialog, tableItemsFilters, handleFilterChange, warehouses, suppliers, items } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const warehouses_with_empty = {
        ...warehouses
    };
    warehouses_with_empty.empty = {
        id_warehouse: 'empty',
        title: "Brez skladi\u0161\u010Da"
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-auto sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 2,
                            ...sort_props,
                            title: "Skladi\u0161\u010De",
                            fieldName: "id_warehouse"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 3,
                            ...sort_props,
                            title: "Dobavitelj",
                            fieldName: "supplier_id_customer"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 4,
                            ...sort_props,
                            title: "\u010Crtna koda",
                            fieldName: "ean"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 5,
                            ...sort_props,
                            title: "\u0160ifra artikla",
                            fieldName: "internal_code"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 6,
                            ...sort_props,
                            title: "Naziv artikla",
                            fieldName: "title"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 7,
                            title: "Koli\u010Dina",
                            cls: "text-right"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 8,
                            title: "Nab. vred. brez DDV",
                            cls: "text-right"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 9,
                            title: "Nab. vred. z DDV",
                            cls: "text-right"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_warehouse",
                                    title_field: "title",
                                    items: warehouses_with_empty,
                                    filtered_keys: tableItemsFilters.id_warehouses,
                                    displayFilter: (x)=>true,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('id_warehouses', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.supplier_customer_name,
                                onChange: (event)=>handleFilterChange('supplier_customer_name', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.ean,
                                onChange: (event)=>handleFilterChange('ean', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.internal_code,
                                onChange: (event)=>handleFilterChange('internal_code', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.title,
                                onChange: (event)=>handleFilterChange('title', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col"
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            const item_item = items[item.id_item];
                            const supplier = item === undefined || item.supplier_id_customer === null ? undefined : suppliers[item.supplier_id_customer];
                            let warehouse = item === undefined || item.id_warehouse === null ? undefined : warehouses[item.id_warehouse];
                            if (warehouse === undefined && Object.keys(warehouses).length > 0) warehouse = Object.values(warehouses)[0];
                            if (item !== undefined && item.real_count === null) warehouse = null;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                icon: "edit",
                                                intent: "primary",
                                                minimal: true,
                                                small: true,
                                                onClick: ()=>openDetailedDialog(item)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        child: warehouse === undefined || warehouse === null ? '' : warehouse.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        child: supplier === undefined ? '' : supplier.type == 'natural' ? supplier.surname + ' ' + supplier.name : supplier.company_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        child: item_item.ean
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        child: item_item.internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        child: item_item.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        cls: "text-right",
                                        child: parseFloat(item === undefined || item.real_count === null ? 0 : parseFloat(item.real_count)).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        cls: "text-right",
                                        child: parseFloat(item === undefined || item.price === null ? 0 : parseFloat(item.price)).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        cls: "text-right",
                                        child: parseFloat(item === undefined || item.price_with_vat === null ? 0 : parseFloat(item.price_with_vat)).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    })
                                ]
                            }, 'items-result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-sum pb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col",
                        children: [
                            "\u0160tevilo zapisov: ",
                            table_items_total_count,
                            table_items_total_count > table_items_sort_ids.length ? ' (prikazanih je ' + table_items_sort_ids.length + ' zapisov)' : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        style: {
                            flex: 0,
                            flexBasis: '100px'
                        },
                        children: Object.keys(all_table_items).map((id)=>all_table_items[id].real_count === null ? 0 : parseFloat(all_table_items[id].real_count)).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        style: {
                            flex: 0,
                            flexBasis: '140px'
                        },
                        children: Object.keys(all_table_items).map((id)=>all_table_items[id].price === null ? 0 : parseFloat(all_table_items[id].price)).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        style: {
                            flex: 0,
                            flexBasis: '140px'
                        },
                        children: Object.keys(all_table_items).map((id)=>all_table_items[id].price_with_vat === null ? 0 : parseFloat(all_table_items[id].price_with_vat)).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                    })
                ]
            })
        ]
    });
}
class StockInventory extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.openAddEditItemDialog = this.openAddEditItemDialog.bind(this);
        this.closeAddEditItemDialog = this.closeAddEditItemDialog.bind(this);
        this.exportInventorySheet = this.exportInventorySheet.bind(this);
        this.exportInventory = this.exportInventory.bind(this);
        this.exportInventorySummary = this.exportInventorySummary.bind(this);
        this.updateTableItemsFromPropsDebounce = (0, _app.debounce)((props, state)=>{
            this.setState({
                ...this.updateTableItemsFromProps(props, state)
            });
        }, 400);
        const table_items_filters = {
            id_warehouses: [],
            supplier_customer_name: '',
            ean: '',
            internal_code: '',
            title: '',
            type: 'all'
        };
        const state = {
            table_items_filters,
            table_items_sort_field: 'internal_code',
            table_items_sort_direction: 'ASC',
            stock_inventory_items: null,
            items: props.items
        };
        const { table_items_total_count, table_items, all_table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            ...state
        });
        this.state = {
            table_items_total_count,
            table_items,
            all_table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            add_edit_item_dialog_open: false,
            add_edit_item_dialog_item: null,
            detailed_dialog_open: false,
            detailed_dialog_internal_code: '',
            detailed_dialog_document_date_range: [
                null,
                null
            ],
            inventory_export_id_warehouse: 'empty',
            stock_date: new Date(),
            ...state
        };
    }
    componentDidMount() {
        (0, _warehouses.loadStockInventoryItemsByDate)(this.props.api_url, this.props.dispatch, this.props.token, (0, _momentDefault.default)(this.state.stock_date).format('YYYY-MM-DD'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const stock_state = this.props.stock_inventory_by_date[(0, _momentDefault.default)(this.state.stock_date).format('YYYY-MM-DD')] === undefined ? null : this.props.stock_inventory_by_date[(0, _momentDefault.default)(this.state.stock_date).format('YYYY-MM-DD')].stock_state.last_stock_data;
        if (this.state.stock_state != stock_state || this.state.items != this.props.items) this.setState({
            stock_state: stock_state,
            items: this.props.items,
            ...this.updateTableItemsFromProps(this.props, this.state)
        });
        if (this.state.stock_date != prevState.stock_date && this.state.stock_date !== null) (0, _warehouses.loadStockInventoryItemsByDate)(this.props.api_url, this.props.dispatch, this.props.token, (0, _momentDefault.default)(this.state.stock_date).format('YYYY-MM-DD'));
    }
    updateTableItemsFromProps(props, state) {
        const items_from_props = props.stock_inventory_by_date[(0, _momentDefault.default)(state.stock_date).format('YYYY-MM-DD')] === undefined ? {} : props.stock_inventory_by_date[(0, _momentDefault.default)(state.stock_date).format('YYYY-MM-DD')].stock_state.last_stock_data;
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, {
            table_items: items_from_props,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        }, true);
        let items = {};
        let selected_sort_ids = [];
        let all_items = {};
        let c = 0;
        for(let i = 0; i < table_items_sort_ids.length; i++){
            const key = table_items_sort_ids[i];
            if (table_items_filtered_ids.indexOf(key) == -1) continue;
            if (c < 500) {
                items[key] = items_from_props[key];
                selected_sort_ids.push(key);
            }
            all_items[key] = items_from_props[key];
            c++;
        }
        const new_state = {
            table_items_total_count: c,
            table_items: items,
            all_table_items: all_items,
            table_items_sort_ids: selected_sort_ids,
            table_items_filtered_ids: selected_sort_ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        new_state.table_items_filtered_ids = selected_sort_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = selected_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            if (field == 'title' || field == 'internal_code' || field == 'ean') {
                a = state.table_items[a_key];
                b = state.table_items[b_key];
                const item_a = this.props.items[a.id_item];
                const item_b = this.props.items[b.id_item];
                return item_a[field].localeCompare(item_b[field]) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'id_warehouse') {
                a = state.table_items[a_key];
                b = state.table_items[b_key];
                const stock_inventory_item_a = this.props.stock_inventory_by_date[(0, _momentDefault.default)(state.stock_date).format('YYYY-MM-DD')].stock_state.last_stock_data[a.id_item];
                const stock_inventory_item_b = this.props.stock_inventory_by_date[(0, _momentDefault.default)(state.stock_date).format('YYYY-MM-DD')].stock_state.last_stock_data[b.id_item];
                let warehouse_a = stock_inventory_item_a === undefined || stock_inventory_item_a.warehouse_id_customer === null ? undefined : this.props.warehouses[stock_inventory_item_a.id_warehouse];
                let warehouse_b = stock_inventory_item_b === undefined || stock_inventory_item_b.id_warehouse === null ? undefined : this.props.warehouses[stock_inventory_item_b.id_warehouse];
                if (warehouse_a === undefined && Object.keys(this.props.warehouses).length > 0) warehouse_a = Object.values(this.props.warehouses)[0];
                if (warehouse_b === undefined && Object.keys(this.props.warehouses).length > 0) warehouse_b = Object.values(this.props.warehouses)[0];
                const warehouse_title_a = warehouse_a === undefined ? '' : warehouse_a.title;
                const warehouse_title_b = warehouse_b === undefined ? '' : warehouse_b.title;
                return warehouse_title_a.localeCompare(warehouse_title_b) * (dir == 'ASC' ? 1 : -1);
            } else if (field == 'supplier_id_customer') {
                a = state.table_items[a_key];
                b = state.table_items[b_key];
                const stock_inventory_item_a = this.props.stock_inventory_by_date[(0, _momentDefault.default)(state.stock_date).format('YYYY-MM-DD')].stock_state.last_stock_data[a.id_item];
                const stock_inventory_item_b = this.props.stock_inventory_by_date[(0, _momentDefault.default)(state.stock_date).format('YYYY-MM-DD')].stock_state.last_stock_data[b.id_item];
                const supplier_a = stock_inventory_item_a === undefined || stock_inventory_item_a.supplier_id_customer === null ? undefined : this.props.customers[stock_inventory_item_a.supplier_id_customer];
                const supplier_b = stock_inventory_item_b === undefined || stock_inventory_item_b.supplier_id_customer === null ? undefined : this.props.customers[stock_inventory_item_b.supplier_id_customer];
                const supplier_title_a = supplier_a === undefined ? '' : supplier_a.type == 'natural' ? supplier_a.surname + ' ' + supplier_a.name : supplier_a.company_name;
                const supplier_title_b = supplier_b === undefined ? '' : supplier_b.type == 'natural' ? supplier_b.surname + ' ' + supplier_b.name : supplier_b.company_name;
                return supplier_title_a.localeCompare(supplier_title_b) * (dir == 'ASC' ? 1 : -1);
            } else {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_id_warehouses = filters.id_warehouses;
        const filters_supplier_customer_name = filters.supplier_customer_name.trim().toUpperCase();
        const filters_ean = filters.ean.trim().toUpperCase();
        const filters_internal_code = filters.internal_code.trim().toUpperCase();
        const filters_title = filters.title.trim().toUpperCase();
        const filter_type = filters.type;
        const ids = state.table_items === null || state.table_items === undefined ? [] : Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            const item_item = this.props.items[item.id_item];
            // only show items
            if (item_item.type != 'item') return false;
            if (filter_type == 'equal-to-0' && (item === undefined || item.real_count !== null && item.real_count != 0)) return false;
            else if (filter_type == 'larger-than-0' && (item === undefined || item.real_count <= 0)) return false;
            else if (filter_type == 'smaller-than-0' && (item === undefined || item.real_count >= 0)) return false;
            if (filters_id_warehouses.length > 0) {
                let found = false;
                let id_warehouse = item.real_count === null ? 'empty' : item.id_warehouse;
                if (id_warehouse === null && Object.keys(this.props.warehouses).length > 0) id_warehouse = Object.keys(this.props.warehouses)[0];
                for(let i = 0; i < filters_id_warehouses.length; i++)if (id_warehouse == filters_id_warehouses[i]) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            if (filters_supplier_customer_name.length > 0) {
                const supplier = item === undefined || item.supplier_id_customer === null ? undefined : this.props.customers[item.supplier_id_customer];
                if (supplier !== null && supplier !== undefined) {
                    const supplier_customer_name = supplier.type == 'natural' ? supplier.surname + ' ' + supplier.name : supplier.company_name;
                    if (supplier_customer_name.toUpperCase().indexOf(filters_supplier_customer_name) == -1) return false;
                } else return false;
            }
            if (filters_ean != '' && item_item.ean.toUpperCase().indexOf(filters_ean) == -1) return false;
            if (filters_internal_code != '' && item_item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) return false;
            if (filters_title != '' && item_item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            id_warehouses: this.state.table_items_filters.id_warehouses,
            supplier_customer_name: this.state.table_items_filters.supplier_customer_name,
            ean: this.state.table_items_filters.ean,
            internal_code: this.state.table_items_filters.internal_code,
            title: this.state.table_items_filters.title,
            type: this.state.table_items_filters.type
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.setState({
            table_items_filters: new_filters
        });
        this.updateTableItemsFromPropsDebounce(this.props, {
            ...this.state,
            table_items_filters: new_filters
        });
    }
    openAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: true,
            add_edit_item_dialog_item: item
        });
    }
    closeAddEditItemDialog(item) {
        this.setState({
            add_edit_item_dialog_open: false
        });
        if (item !== undefined) this.props.dispatch((0, _codeTablesSlice.addItem)({
            item,
            token: this.props.token,
            save_to_api: true
        }));
    }
    exportInventorySheet() {
        const params = [
            'id_warehouse=' + this.state.inventory_export_id_warehouse,
            'date=' + (0, _momentDefault.default)(this.state.stock_date).format('YYYY-MM-DD'),
            'version=new'
        ];
        const data = {
            id_warehouse: this.state.inventory_export_id_warehouse,
            date: (0, _momentDefault.default)(this.state.stock_date).format('YYYY-MM-DD')
        };
        const form = document.createElement('form');
        form.target = '_blank';
        form.method = 'POST';
        form.action = this.props.api_url + 'Warehouses/v1/inventory-sheet-export-excel?' + params.join('&');
        form.style.display = 'none';
        for(let key in data){
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
    exportInventory() {
        const params = [];
        const data = {
            id_items: this.state.table_items_sort_ids.join(','),
            type: this.state.table_items_filters.type,
            date: (0, _momentDefault.default)(this.state.stock_date).format('YYYY-MM-DD'),
            version: 'new'
        };
        const form = document.createElement('form');
        form.target = '_blank';
        form.method = 'POST';
        form.action = this.props.api_url + 'Warehouses/v1/inventory-export-excel?' + params.join('&');
        form.style.display = 'none';
        for(let key in data){
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
    exportInventorySummary() {
        const params = [];
        const data = {
            date: (0, _momentDefault.default)(this.state.stock_date).format('YYYY-MM-DD')
        };
        const form = document.createElement('form');
        form.target = '_blank';
        form.method = 'POST';
        form.action = this.props.api_url + 'Warehouses/v1/inventory-summary-export-excel?' + params.join('&');
        form.style.display = 'none';
        for(let key in data){
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('stock--inventory') === -1) return null;
        const suppliers = this.props.customers; //.filter(x => x.supplier === true);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.detailed_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stockInventoryDetailedDialogDefault.default), {
                    filter_internal_code: this.state.detailed_dialog_internal_code,
                    filter_document_date_range: this.state.detailed_dialog_document_date_range,
                    closeDialog: ()=>this.setState({
                            detailed_dialog_open: false
                        })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow stock-inventory-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4 flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            className: "mr-2",
                                            intent: "primary",
                                            onClick: ()=>this.setState({
                                                    detailed_dialog_open: true,
                                                    detailed_dialog_internal_code: '',
                                                    detailed_dialog_document_date_range: [
                                                        new Date(),
                                                        new Date()
                                                    ]
                                                }),
                                            children: "Kartica artikla"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            className: "mr-2",
                                            intent: "primary",
                                            icon: "cloud-download",
                                            disabled: this.state.table_items_sort_ids.length == 0,
                                            onClick: this.exportInventory,
                                            children: "Izvoz v Excel (artikli)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            className: "mr-2",
                                            intent: "primary",
                                            icon: "cloud-download",
                                            onClick: this.exportInventorySummary,
                                            children: "Izvoz v Excel (sumarno)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.HTMLSelect), {
                                            className: "ml-3",
                                            options: Object.values({
                                                empty: {
                                                    id_warehouse: 'empty',
                                                    title: "Brez skladi\u0161\u010Da"
                                                },
                                                ...this.props.warehouses
                                            }).map((item)=>{
                                                return {
                                                    label: item.title,
                                                    value: item.id_warehouse
                                                };
                                            }),
                                            value: this.state.inventory_export_id_warehouse,
                                            onChange: (e)=>{
                                                this.setState({
                                                    inventory_export_id_warehouse: e.currentTarget.value
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            className: "ml-1",
                                            intent: "primary",
                                            icon: "cloud-download",
                                            onClick: this.exportInventorySheet,
                                            children: "Inventurni list"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-row items-center p-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: "Stanje na dan:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ml-1 mr-2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateInput3), {
                                                dateFnsLocaleLoader: (0, _utils.loadDateFnsLocale),
                                                dateFnsFormat: 'dd. MM. yyyy',
                                                locale: "sl",
                                                inputProps: {
                                                    placeholder: '01. 01. ' + new Date().getFullYear(),
                                                    className: 'w-24'
                                                },
                                                selectAllOnFocus: true,
                                                minDate: new Date('1900-01-01'),
                                                maxDate: (0, _momentDefault.default)().add('10', 'years').toDate(),
                                                onChange: (selectedDate, isUserChange)=>{
                                                    if (isUserChange) this.setState({
                                                        stock_date: selectedDate === null ? null : new Date(selectedDate)
                                                    });
                                                },
                                                value: this.state.stock_date === null ? null : (0, _formatISODefault.default)(this.state.stock_date)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.RadioGroup), {
                                            className: "pt-1",
                                            onChange: (event)=>this.handleFilterChange('type', event),
                                            inline: true,
                                            selectedValue: this.state.table_items_filters.type,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                    className: "mb-2",
                                                    label: "Vsa zaloga",
                                                    value: "all"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                    className: "mb-2",
                                                    label: "Brez zaloge",
                                                    value: "equal-to-0"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                    className: "mb-2",
                                                    label: "Zaloga, ve\u010Dja od 0",
                                                    value: "larger-than-0"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                                    className: "mb-2",
                                                    label: "Zaloga, manj\u0161a od 0",
                                                    value: "smaller-than-0"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow overflow-y-auto",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items_total_count: this.state.table_items_total_count,
                                    table_items: this.state.table_items,
                                    all_table_items: this.state.all_table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openDetailedDialog: (item)=>{
                                        this.setState({
                                            detailed_dialog_open: true,
                                            detailed_dialog_internal_code: this.props.items[item.id_item].internal_code,
                                            detailed_dialog_document_date_range: [
                                                null,
                                                null
                                            ]
                                        });
                                    },
                                    tableItemsFilters: this.state.table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    warehouses: this.props.warehouses,
                                    suppliers: suppliers,
                                    items: this.props.items
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
StockInventory.propTypes = {};
function mapStateToProps(state) {
    return {
        items: state.CodeTablesSlice.items,
        warehouses: state.CodeTablesSlice.warehouses,
        customers: state.CodeTablesSlice.customers,
        stock_state: state.WarehouseSlice.stock_state,
        stock_inventory_by_date: state.WarehouseSlice.stock_inventory_by_date,
        api_url: state.WarehouseSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(StockInventory);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","moment":"1e4qG","date-fns/formatISO":"an1FA","../../slices/CodeTablesSlice":"hfPGz","./StockInventoryDetailedDialog":"4VqjA","../../api/Warehouses":"WVdXb","../code_tables/ResultComponents":"1eVlZ","../../App":"4sGPJ","../../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4VqjA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
var _resultComponents = require("../code_tables/ResultComponents");
var _warehouses = require("../../api/Warehouses");
const DocumentTypes = {
    'cash-invoice': {
        type: 'cash-invoice',
        title: "Blagajni\u0161ki ra\u010Dun"
    },
    'invoice': {
        type: 'invoice',
        title: 'Faktura'
    },
    'credit-note': {
        type: 'credit-note',
        title: 'Dobropis'
    },
    'acquisition': {
        type: 'acquisition',
        title: 'Prevzem'
    },
    'write-off': {
        type: 'write-off',
        title: 'Odpis zaloge'
    },
    'reclamation': {
        type: 'reclamation',
        title: 'Reklamacija'
    },
    'representation': {
        type: 'representation',
        title: 'Reprezentanca'
    },
    'commission': {
        type: 'commission',
        title: 'Komisija'
    },
    'debt-release': {
        type: 'debt-release',
        title: "Razdol\u017Enica"
    },
    'internal-transfer': {
        type: 'internal-transfer',
        title: "Prenos med skladi\u0161\u010Di"
    },
    'delivery-note-delivery': {
        type: 'delivery-note-delivery',
        title: 'Dobavnica'
    },
    'delivery-note-return': {
        type: 'delivery-note-return',
        title: "Vra\u010Dilo v zalogo"
    }
};
function Results(props) {
    const { table_items, table_items_sort_ids, openAddEditItemDialog, tableItemsFilters, handleFilterChange, warehouses, items, payment_types, customers, stock_state, getDocumentNumberForDocument } = props;
    let acquired_quantity_sum = 0;
    let spent_quantity_sum = 0;
    const found_last_stock_data = {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4 mb-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-auto sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: "Urejanje"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 2,
                            title: "Skladi\u0161\u010De"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 3,
                            title: "\u010Crtna koda"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 4,
                            title: "\u0160ifra artikla"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 5,
                            title: "Naziv artikla"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 6,
                            title: "\u0160t. dokumenta"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 7,
                            title: "Tip dokumenta"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 8,
                            title: "Na\u010Din pla\u010Dila"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 9,
                            title: "Dobavitelj"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 10,
                            title: "Datum"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 11,
                            title: "Prevzeto",
                            cls: "text-right"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 12,
                            title: "Izdano",
                            cls: "text-right"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 13,
                            title: "Zaloga",
                            cls: "text-right"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 14,
                            title: "Cena EM",
                            cls: "text-right"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 15,
                            title: "Vred. br. DDV",
                            cls: "text-right"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 16,
                            title: "Vred. z DDV",
                            cls: "text-right"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "id_warehouse",
                                    title_field: "title",
                                    items: warehouses,
                                    filtered_keys: tableItemsFilters.id_warehouses,
                                    displayFilter: (x)=>true,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('id_warehouses', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.title,
                                onChange: (event)=>handleFilterChange('title', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.document_number,
                                onChange: (event)=>handleFilterChange('document_number', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "type",
                                    title_field: "title",
                                    items: DocumentTypes,
                                    filtered_keys: tableItemsFilters.document_types,
                                    displayFilter: (x)=>true,
                                    displaySort: (a, b)=>a.title < b.title ? -1 : a.title > b.title ? 1 : 0,
                                    onFilterChange: (values)=>handleFilterChange('document_types', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.supplier_customer_name,
                                onChange: (event)=>handleFilterChange('supplier_customer_name', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 12,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 13,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 14,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 15,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 16,
                            cls: "filters-col"
                        }),
                        table_items_sort_ids.length > 500 ? null : table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            const item_item = items[item.id_item];
                            let document = item.document;
                            const supplier = document === null ? undefined : customers[document.supplier_id_customer] ?? undefined;
                            const warehouse = warehouses[item.id_warehouse];
                            const document_date = item.document_date;
                            const fixed_key = item.id_item + '--' + (warehouse?.id_warehouse ?? 'null');
                            found_last_stock_data[fixed_key] = stock_state.last_stock_data[fixed_key];
                            let document_type;
                            if (item.document_type == 'invoice') document_type = document === null ? '' : DocumentTypes[document.invoice_type];
                            else if (item.document_type == 'stock_acquisition_document') document_type = document === null ? '' : DocumentTypes[document.type];
                            else if (item.document_type == 'delivery_note') document_type = document === null ? '' : DocumentTypes['delivery-note-' + document.type];
                            if (document_type !== undefined) document_type = document_type.title;
                            else document_type = '';
                            const acquired_quantity = item.acquired_quantity;
                            const spent_quantity = item.spent_quantity;
                            const current_stock = item.current_stock;
                            acquired_quantity_sum += acquired_quantity;
                            spent_quantity_sum += spent_quantity;
                            const item_price = current_stock?.item_price ?? 0;
                            let payment_types_title = [
                                ...new Set((item?.document?.payments ?? []).map((x)=>x.id_payment_type))
                            ].sort((a, b)=>{
                                return payment_types[a].ord - payment_types[b].ord;
                            }).map((id_payment_type)=>payment_types[id_payment_type].title).join(', ');
                            // override for non-cash invoices (i.e. business invoices)
                            if (item?.document?.invoice_type != 'cash-invoice') payment_types_title = '';
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                            children: null
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        child: warehouse === undefined || warehouse === null ? '' : warehouse.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        child: item_item.ean
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        child: item_item.internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        child: item_item.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        child: getDocumentNumberForDocument(item.document_type, document)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        child: document_type
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            title: payment_types_title,
                                            style: {
                                                width: '100%',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden'
                                            },
                                            children: payment_types_title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        child: supplier === undefined ? '' : supplier.type == 'natural' ? supplier.surname + ' ' + supplier.name : supplier.company_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 10,
                                        child: document_date === null ? '' : (0, _momentDefault.default)(document_date).format('DD.MM.YYYY')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 11,
                                        cls: "text-right",
                                        child: acquired_quantity == 0 ? '' : acquired_quantity.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 12,
                                        cls: "text-right",
                                        child: spent_quantity == 0 ? '' : spent_quantity.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 13,
                                        cls: "text-right font-bold",
                                        child: (current_stock?.real_count ?? 0).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 14,
                                        cls: "text-right",
                                        child: item_price.toLocaleString(undefined, {
                                            minimumFractionDigits: 4,
                                            maximumFractionDigits: 4
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 15,
                                        cls: "text-right",
                                        child: (current_stock?.price ?? 0).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 16,
                                        cls: "text-right",
                                        child: (current_stock?.price_with_vat ?? 0).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    })
                                ]
                            }, 'items-result--result-' + id);
                        })
                    ]
                })
            }),
            table_items_sort_ids.length > 500 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-sum pb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col",
                        children: [
                            "\u0160tevilo zapisov: ",
                            table_items_sort_ids.length
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        style: {
                            flex: 0,
                            flexBasis: '60px'
                        },
                        children: acquired_quantity_sum.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        style: {
                            flex: 0,
                            flexBasis: '60px'
                        },
                        children: spent_quantity_sum.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        style: {
                            flex: 0,
                            flexBasis: '12px'
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        style: {
                            flex: 0,
                            flexBasis: '60px'
                        },
                        children: '' //last_stock_count.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        style: {
                            flex: 0,
                            flexBasis: '60px'
                        },
                        children: (()=>{
                            const price_with_count = Object.values(found_last_stock_data).filter((x)=>x !== undefined).reduce((prev, curr)=>{
                                return [
                                    prev[0] + curr.price,
                                    prev[1] + curr.count
                                ];
                            }, [
                                0,
                                0
                            ]);
                            return price_with_count[1] == 0 ? 0 : price_with_count[0] / price_with_count[1];
                        })().toLocaleString(undefined, {
                            minimumFractionDigits: 4,
                            maximumFractionDigits: 4
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        style: {
                            flex: 0,
                            flexBasis: '12px'
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        style: {
                            flex: 0,
                            flexBasis: '80px'
                        },
                        children: '' //last_price_with_vat.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col text-right font-bold",
                        style: {
                            flex: 0,
                            flexBasis: '80px'
                        },
                        children: '' //last_stock_count.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                    })
                ]
            }),
            table_items_sort_ids.length <= 500 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "pt-2",
                children: "Preve\u010D zadetkov za prikaz (\u0161t. zadetkov je " + table_items_sort_ids.length + ')'
            })
        ]
    });
}
class StockInventoryDetailedDialog extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.filterMainItems = this.filterMainItems.bind(this);
        this.mainFiltersValid = this.mainFiltersValid.bind(this);
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        //this.compareItemsForSort       = this.compareItemsForSort      .bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        const table_items_filters = {
            internal_code: '',
            document_types: [
                'cash-invoice',
                'invoice',
                'credit-note'
            ],
            id_warehouses: [],
            document_number: '',
            ean: '',
            title: '',
            supplier_customer_name: ''
        };
        const state = {
            table_items_filters,
            table_items_sort_field: 'internal_code',
            table_items_sort_direction: 'ASC',
            main_filter__internal_code: props.filter_internal_code,
            main_filter__document_date_range: props.filter_document_date_range,
            loading: false,
            detailed_stock_state: null
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            ...state
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            original_table_items_filters: {
                ...table_items_filters
            },
            ...state
        };
    //this.filterMainItems(this.state);
    }
    componentDidMount() {
    //loadDetailedStockInventoryItems(this.props.api_url, this.props.dispatch, this.props.token).then(() => {
    //	this.setState({ loading: false });
    //});
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.items != this.props.items || prevState.detailed_stock_state != this.state.detailed_stock_state) this.setState({
            ...this.updateTableItemsFromProps(this.props, this.state)
        });
    }
    filterMainItems(state) {
        state = state || this.state;
        if (!this.mainFiltersValid(state)) return;
        this.setState({
            loading: true
        });
        (0, _warehouses.loadDetailedStockInventoryItems)(this.props.api_url, this.props.dispatch, this.props.token, true, state.main_filter__document_date_range[0] === null ? '' : (0, _momentDefault.default)(state.main_filter__document_date_range[0]).format('YYYY-MM-DD'), state.main_filter__document_date_range[1] === null ? '' : (0, _momentDefault.default)(state.main_filter__document_date_range[1]).format('YYYY-MM-DD'), state.main_filter__internal_code).then((stock)=>{
            //console.log(Object.keys(stock));
            this.setState({
                loading: false,
                detailed_stock_state: stock
            });
        //this.setState(
        //	this.updateTableItemsFromProps(this.props, state)
        //);
        });
    }
    mainFiltersValid(state) {
        if (state === undefined) return false;
        console.log({
            state
        });
        return state.main_filter__internal_code.trim().length >= 2 || state.main_filter__document_date_range[0] !== null && state.main_filter__document_date_range[1] !== null;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    getDocumentNumberForDocument(type, doc) {
        if (doc === null || doc === undefined) return 'n/a';
        if (type == 'invoice') return doc.invoice_number_internal;
        else if (type == 'stock_acquisition_document' || type == 'delivery_note') return doc.document_number;
        return null;
    }
    updateTableItemsFromProps(props, state) {
        //console.log({
        //	aa: state.detailed_stock_state === null,
        //	bb: state.detailed_stock_state === null ? '' : (state.detailed_stock_state.item_documents === undefined),
        //});
        if (state.detailed_stock_state === null || state.detailed_stock_state.item_documents === undefined) return state;
        const filter_internal_code = state.main_filter__internal_code.trim().toUpperCase();
        const filter_document_date_start = state.main_filter__document_date_range[0] === null ? null : this.toIsoString(state.main_filter__document_date_range[0]);
        const filter_document_date_end = state.main_filter__document_date_range[1] === null ? null : this.toIsoString(state.main_filter__document_date_range[1]);
        let items = {};
        let ids = [];
        let sort_ids = [];
        if (this.mainFiltersValid(state)) {
            items = [];
            sort_ids = state.detailed_stock_state.item_document_sorted_ids;
            ids = state.detailed_stock_state.item_document_sorted_ids;
            /*sort_ids = ids = ids.filter(id => {
				const item      = state.detailed_stock_state.item_documents[id];
				const item_item = props.items[item.id_item];
				
				// only show items
				if (item_item.type != 'item') return false;
				
				if (
					filter_internal_code.length > 0 &&
					item_item.internal_code.trim().toUpperCase() != filter_internal_code &&
					item_item.ean          .trim().toUpperCase() != filter_internal_code
				) {
					return false;
				}
				
				if (filter_document_date_start !== null && item.document_date !== null && item.document_date < filter_document_date_start) {
					return false;
				}
				if (filter_document_date_end !== null && item.document_date !== null && item.document_date > filter_document_date_end) {
					return false;
				}
					
				return true;
			});*/ for(let i = 0; i < ids.length; i++)items[ids[i]] = state.detailed_stock_state.item_documents[ids[i]];
        }
        const new_state = {
            table_items: items,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        //console.log({ new_state });
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            a = state.table_items[a_key][field];
            b = state.table_items[b_key][field];
            if (a == b) {
                a = state.table_items[a_key].document_date;
                b = state.table_items[b_key].document_date;
            }
            if (a == b) {
                a = state.table_items[a_key].ord;
                b = state.table_items[b_key].ord;
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_internal_code = filters.internal_code.trim().toUpperCase();
        const filters_document_types = filters.document_types;
        const filters_id_warehouses = filters.id_warehouses;
        const filters_document_number = filters.document_number.trim().toUpperCase();
        const filters_ean = filters.ean.trim().toUpperCase();
        const filters_title = filters.title.trim().toUpperCase();
        const filters_supplier_customer_name = filters.supplier_customer_name.trim().toUpperCase();
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            const item_item = this.props.items[item.id_item];
            if (item.id_item == '05660f12-f52a-452b-b780-29260f3c899c') console.log({
                item
            });
            let document = item.document;
            if (filters_id_warehouses.length > 0) {
                let found = false;
                let warehouse = this.props.warehouses[document.id_warehouse];
                if (item.from_stock === true && document.stock_from_id_warehouse !== null) warehouse = this.props.warehouses[document.stock_from_id_warehouse];
                if (item.document_type == 'invoice') {
                    // get items from invoice directly, since stock data is missing items for documents
                    const doc_items = document.items;
                    for(let i = 0; i < doc_items.length; i++)if (doc_items[i].id_item == item_item.id_item) warehouse = doc_items[i].id_warehouse === null ? null : this.props.warehouses[doc_items[i].id_warehouse];
                }
                if (warehouse !== null && warehouse !== undefined) {
                    for(let i = 0; i < filters_id_warehouses.length; i++)if (warehouse.id_warehouse == filters_id_warehouses[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) return false;
            }
            if (filters_supplier_customer_name.length > 0) {
                const supplier = document === null || document === undefined || document.supplier_id_customer === null ? undefined : this.props.customers[document.supplier_id_customer];
                if (supplier !== null && supplier !== undefined) {
                    const supplier_customer_name = supplier.type == 'natural' ? supplier.surname + ' ' + supplier.name : supplier.company_name;
                    if (supplier_customer_name.toUpperCase().indexOf(filters_supplier_customer_name) == -1) return false;
                } else return false;
            }
            if (filters_ean != '' && item_item.ean.toUpperCase().indexOf(filters_ean) == -1) return false;
            if (filters_internal_code != '' && item_item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) return false;
            if (filters_title != '' && item_item.title.toUpperCase().indexOf(filters_title) == -1) return false;
            const document_number = this.getDocumentNumberForDocument(item.document_type, document);
            if (filters_document_number != '' && document_number.toUpperCase().indexOf(filters_document_number) == -1) return false;
            let document_type;
            if (item.document_type == 'invoice') document_type = document.invoice_type;
            else if (item.document_type == 'stock_acquisition_document') document_type = 'stock-acquisition';
            else if (item.document_type == 'delivery_note') document_type = 'delivery-note-' + document.type;
            if (document_type === undefined) document_type = '';
            if (filters_document_types.length > 0) {
                let found = false;
                for(let i = 0; i < filters_document_types.length; i++)if (document_type == filters_document_types[i] || item?.document?.type == filters_document_types[i]) {
                    found = true;
                    break;
                }
                if (!found) return false;
            }
            return true;
        });
        //console.log({
        //	filtered_ids,
        //});
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            internal_code: this.state.table_items_filters.internal_code,
            document_types: this.state.table_items_filters.document_types,
            id_warehouses: this.state.table_items_filters.id_warehouses,
            document_number: this.state.table_items_filters.document_number,
            ean: this.state.table_items_filters.ean,
            title: this.state.table_items_filters.title,
            supplier_customer_name: this.state.table_items_filters.supplier_customer_name
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    exportToExcel() {
        const params = [];
        if (this.state.main_filter__document_date_range[0] !== null) params.push('date_start=' + (0, _momentDefault.default)(this.state.main_filter__document_date_range[0]).format('YYYY-MM-DD'));
        if (this.state.main_filter__document_date_range[1] !== null) params.push('date_end=' + (0, _momentDefault.default)(this.state.main_filter__document_date_range[1]).format('YYYY-MM-DD'));
        if (this.state.main_filter__internal_code.length > 0) params.push('internal_code=' + encodeURIComponent(this.state.main_filter__internal_code));
        params.push('document_types=' + encodeURIComponent(this.state.table_items_filters.document_types.join(',')));
        params.push('id_warehouses=' + encodeURIComponent(this.state.table_items_filters.id_warehouses.join(',')));
        params.push('document_number=' + encodeURIComponent(this.state.table_items_filters.document_number));
        params.push('title=' + encodeURIComponent(this.state.table_items_filters.title));
        params.push('supplier_customer_name=' + encodeURIComponent(this.state.table_items_filters.supplier_customer_name));
        params.push('version=new');
        window.open(this.props.api_url + 'Warehouses/v1/export-detailed-stock-inventory-to-excel?' + params.join('&'));
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
            isOpen: true,
            usePortal: true,
            canOutsideClickClose: false,
            canEscapeKeyClose: false,
            onClose: ()=>this.props.closeDialog(),
            className: "stock-inventory-detailed-dialog",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                        fixedToTop: false,
                        className: "bp5-dark",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                    children: "Kartica artikla"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                align: (0, _core.Alignment).RIGHT,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    minimal: true,
                                    icon: "cross",
                                    onClick: ()=>this.props.closeDialog()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _core.Classes).DIALOG_BODY,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "h-1",
                                children: !this.state.loading ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ProgressBar), {
                                    animate: true,
                                    intent: "warning",
                                    className: "h-1"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "inner-body",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-grow flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-row main-filters",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    className: "mr-4",
                                                    labelFor: "stock-inventory-detailed-dialog--internal-code",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "\u0160ifra artikla / \u010Drtna koda",
                                                            tooltip: "\u0160ifra artikla / \u010Drtna koda"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.InputGroup), {
                                                            id: "stock-inventory-detailed-dialog--internal-code",
                                                            value: this.state.main_filter__internal_code,
                                                            onChange: (event)=>{
                                                                this.setState({
                                                                    main_filter__internal_code: event.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                                    className: "mr-4",
                                                    style: {
                                                        width: 190
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                                            label: "Datum dokumenta",
                                                            tooltip: "Datum dokumenta"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                                            filter_values: this.state.main_filter__document_date_range,
                                                            original_start_date: null,
                                                            original_end_date: null,
                                                            onFilterChange: (values)=>{
                                                                this.setState({
                                                                    main_filter__document_date_range: values
                                                                });
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex justify-start",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    className: "w-24",
                                                    intent: "primary",
                                                    disabled: !this.mainFiltersValid(this.state) || this.state.loading,
                                                    onClick: ()=>this.filterMainItems(this.state),
                                                    children: "I\u0161\u010Di"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                    className: "w-32 ml-2",
                                                    intent: "primary",
                                                    disabled: !this.mainFiltersValid(this.state) || this.state.loading,
                                                    onClick: this.exportToExcel,
                                                    children: "Izvoz v Excel"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex-1 stock-inventory-detailed-list",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "flex-grow",
                                                style: {
                                                    flexBasis: '0'
                                                },
                                                children: this.state.detailed_stock_state === null || this.state.detailed_stock_state.item_documents === undefined || this.state.table_items_sort_ids === undefined ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                                    table_items: this.state.table_items,
                                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                                    openAddEditItemDialog: this.openAddEditItemDialog,
                                                    tableItemsFilters: this.state.table_items_filters,
                                                    handleFilterChange: this.handleFilterChange,
                                                    warehouses: this.props.warehouses,
                                                    items: this.props.items,
                                                    payment_types: this.props.payment_types,
                                                    customers: this.props.customers,
                                                    stock_state: this.state.detailed_stock_state,
                                                    getDocumentNumberForDocument: this.getDocumentNumberForDocument
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
}
StockInventoryDetailedDialog.propTypes = {
    closeDialog: (0, _propTypesDefault.default).func
};
function mapStateToProps(state) {
    return {
        customers: state.CodeTablesSlice.customers,
        items: state.CodeTablesSlice.items,
        api_url: state.CodeTablesSlice.api_url,
        warehouses: state.CodeTablesSlice.warehouses,
        customers: state.CodeTablesSlice.customers,
        payment_types: state.CodeTablesSlice.payment_types,
        cash_registers: state.CashRegisterSlice.cash_registers,
        token: state.UserSlice.token
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(StockInventoryDetailedDialog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","moment":"1e4qG","../TextWithTooltip":"6kuHH","../code_tables/ResultComponents":"1eVlZ","../../api/Warehouses":"WVdXb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4jVwT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _resultComponents = require("../code_tables/ResultComponents");
var _textWithTooltip = require("../TextWithTooltip");
var _textWithTooltipDefault = parcelHelpers.interopDefault(_textWithTooltip);
class MainFilter extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.getFilters = this.getFilters.bind(this);
        let start_date = (0, _momentDefault.default)().startOf('month').toDate();
        if (props.min_date !== null) {
            if ((0, _momentDefault.default)(start_date).format('YYYY-MM-DD') < (0, _momentDefault.default)(props.min_date).format('YYYY-MM-DD')) start_date = (0, _momentDefault.default)(props.min_date).toDate();
        }
        this.state = {
            main_filter__invoice_type: [
                'cash-invoice',
                'invoice',
                'credit-note'
            ],
            main_filter__date_range: [
                start_date,
                new Date()
            ],
            main_filter__item_type: null,
            main_filter__item_internal_code: '',
            main_filter__item_ean: '',
            main_filter__item_title: ''
        };
    }
    getFilters() {
        return {
            invoice_type: this.state.main_filter__invoice_type,
            date_range: this.state.main_filter__date_range,
            item_type: this.state.main_filter__item_type,
            item_internal_code: this.state.main_filter__item_internal_code,
            item_ean: this.state.main_filter__item_ean,
            item_title: this.state.main_filter__item_title
        };
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col items-start main-filters pl-4 pt-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-row flex-wrap",
                            children: [
                                {
                                    value: 'cash-invoice',
                                    title: "Blagajni\u0161ki ra\u010Dun"
                                },
                                {
                                    value: 'invoice',
                                    title: 'Faktura'
                                },
                                {
                                    value: 'credit-note',
                                    title: 'Dobropis'
                                }
                            ].map((item)=>{
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    className: "mr-4 mb-4",
                                    checked: this.state.main_filter__invoice_type.indexOf(item.value) > -1,
                                    label: item.title,
                                    onChange: (event)=>{
                                        const main_filter__invoice_type = [
                                            ...this.state.main_filter__invoice_type
                                        ];
                                        if (event.target.checked) {
                                            if (main_filter__invoice_type.indexOf(item.value) == -1) main_filter__invoice_type.push(item.value);
                                        } else if (main_filter__invoice_type.indexOf(item.value) > -1) main_filter__invoice_type.splice(main_filter__invoice_type.indexOf(item.value), 1);
                                        this.setState({
                                            main_filter__invoice_type
                                        });
                                    }
                                }, 'invoice-type-' + item.value);
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    className: "mr-4",
                                    style: {
                                        width: 200
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Obdobje",
                                            tooltip: "Obdobje"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                            filter_values: this.state.main_filter__date_range,
                                            original_start_date: null,
                                            original_end_date: null,
                                            min_date: this.props.min_date,
                                            onFilterChange: (values)=>{
                                                this.setState({
                                                    main_filter__date_range: values
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    className: "mr-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "\u0160ifra artikla",
                                            tooltip: "\u0160ifra artikla"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                            value: this.state.main_filter__item_internal_code,
                                            onChange: (event)=>{
                                                const value = typeof event === 'string' ? event : event.target.value;
                                                this.setState({
                                                    main_filter__item_internal_code: value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    className: "mr-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "EAN",
                                            tooltip: "EAN"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                            value: this.state.main_filter__item_ean,
                                            onChange: (event)=>{
                                                const value = typeof event === 'string' ? event : event.target.value;
                                                this.setState({
                                                    main_filter__item_ean: value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.FormGroup), {
                                    className: "mr-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWithTooltipDefault.default), {
                                            label: "Naziv artikla",
                                            tooltip: "Naziv artikla"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                            value: this.state.main_filter__item_title,
                                            onChange: (event)=>{
                                                const value = typeof event === 'string' ? event : event.target.value;
                                                this.setState({
                                                    main_filter__item_title: value
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex justify-start pl-4 pb-4 mt-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            className: "w-32",
                            intent: "primary",
                            icon: "search",
                            disabled: !this.props.mainFiltersValid(this.getFilters()),
                            onClick: ()=>this.props.onChange(this.getFilters()),
                            children: "Prika\u017Ei"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                            className: "w-40 ml-2",
                            intent: "primary",
                            icon: "cloud-download",
                            disabled: !this.props.mainFiltersValid(this.getFilters()),
                            onClick: ()=>{
                                const params = [
                                    'date_from=' + (0, _momentDefault.default)(this.state.main_filter__date_range[0]).format('YYYY-MM-DD'),
                                    'date_until=' + (0, _momentDefault.default)(this.state.main_filter__date_range[1]).format('YYYY-MM-DD'),
                                    'invoice_types=' + this.state.main_filter__invoice_type.join(','),
                                    'item_type=' + (this.state.main_filter__item_type ?? ''),
                                    'item_internal_code=' + this.state.main_filter__item_internal_code,
                                    'item_ean=' + this.state.main_filter__item_ean,
                                    'item_title=' + this.state.main_filter__item_title
                                ];
                                window.open(this.props.api_url + 'Reports/v1/export-items-and-services-to-excel?' + params.join('&'));
                            },
                            children: "Izvoz v Excel"
                        })
                    ]
                })
            ]
        });
    }
}
class ItemsAndServices extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.mainFiltersValid = this.mainFiltersValid.bind(this);
        this.filterMainItems = this.filterMainItems.bind(this);
        this.state = {
            main_filters: null,
            main_table_items: null
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    mainFiltersValid(filters) {
        if (filters.invoice_type.length == 0) return false;
        if (filters.date_range[0] === null || filters.date_range[1] === null) return false;
        /*
			main_filter__item_type:          null,
			main_filter__item_internal_code: null,
			main_filter__item_title:         null,
		*/ return true;
    }
    filterMainItems(filters) {
        if (!this.mainFiltersValid(filters)) return null;
        const items = {
            items: {},
            sorted_id_items: [],
            total: {
                quantity: 0,
                price_with_vat_without_discount: 0,
                discount_amount: 0,
                price_without_vat_with_discount: 0,
                price_with_vat_with_discount: 0
            }
        };
        const filter_from_date_iso = (0, _momentDefault.default)(filters.date_range[0]).format('YYYY-MM-DD');
        const filter_until_date_iso = (0, _momentDefault.default)(filters.date_range[1]).format('YYYY-MM-DD');
        const item_title = filters.item_title.toLowerCase();
        const item_internal_code = filters.item_internal_code.toLowerCase();
        const item_ean = filters.item_ean.toLowerCase();
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['reports--activity-reservations'] ?? 0);
        const filter_data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1, 'days').toISOString(true);
        for(let id_invoice in this.props.invoices){
            const invoice = this.props.invoices[id_invoice];
            if (invoice.draft) continue;
            if (filters.invoice_type.indexOf(invoice.invoice_type) == -1) continue;
            if (invoice.invoice_date <= filter_data_retention_date_start) continue;
            if (invoice.invoice_date < filter_from_date_iso || invoice.invoice_date > filter_until_date_iso) continue;
            for(let i = 0; i < invoice.items.length; i++){
                const invoice_item = invoice.items[i];
                const item = this.props.items[invoice_item.id_item];
                if (filters.item_type !== null && item.type != filters.item_type) continue;
                if (item_internal_code.length > 0 && item.internal_code.toLowerCase() != item_internal_code) continue;
                if (item_ean.length > 0 && item.ean.toLowerCase().indexOf(item_ean)) continue;
                if (item_title.length > 0 && item.title.toLowerCase().indexOf(item_title) == -1) continue;
                if (items.items[item.id_item] === undefined) items.items[item.id_item] = {
                    id_item: item.id_item,
                    quantity: 0,
                    price_with_vat_without_discount: 0,
                    discount_amount: 0,
                    price_without_vat_with_discount: 0,
                    price_with_vat_with_discount: 0
                };
                const quantity = parseFloat(invoice_item.quantity);
                const price = parseFloat(invoice_item.price);
                const price_with_vat_without_discount = price * quantity;
                const discount_amount = price * quantity * (parseFloat(invoice_item.discount) / 100);
                const price_without_vat_with_discount = price * quantity * (1 - parseFloat(invoice_item.discount) / 100) / (1 + parseFloat(invoice_item.tax_rate) / 100);
                const price_with_vat_with_discount = price * quantity * (1 - parseFloat(invoice_item.discount) / 100);
                items.items[item.id_item].quantity += quantity;
                items.items[item.id_item].price_with_vat_without_discount += price_with_vat_without_discount;
                items.items[item.id_item].discount_amount += discount_amount;
                items.items[item.id_item].price_without_vat_with_discount += price_without_vat_with_discount;
                items.items[item.id_item].price_with_vat_with_discount += price_with_vat_with_discount;
                items.total.quantity += quantity;
                items.total.price_with_vat_without_discount += price_with_vat_without_discount;
                items.total.discount_amount += discount_amount;
                items.total.price_without_vat_with_discount += price_without_vat_with_discount;
                items.total.price_with_vat_with_discount += price_with_vat_with_discount;
            }
        }
        const sorted_id_items = [
            ...Object.keys(items.items)
        ];
        sorted_id_items.sort((a, b)=>{
            const item_a = this.props.items[a];
            const item_b = this.props.items[b];
            const title_a = item_a.internal_code + " \u2022 " + item_a.title;
            const title_b = item_b.internal_code + " \u2022 " + item_b.title;
            return title_a.localeCompare(title_b);
        });
        items.sorted_id_items = sorted_id_items;
        this.setState({
            main_table_items: items
        });
    }
    render() {
        if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('reports--activity-reservations') === -1) return null;
        const data_retention_day_count = Math.max(0, this.props.user.data_retention_days['reports--activity-reservations'] ?? 0);
        const data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1, 'days');
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col flex-grow base-list reports-items-and-services-list",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MainFilter, {
                        api_url: this.props.api_url,
                        mainFiltersValid: this.mainFiltersValid,
                        min_date: data_retention_date_start === null ? null : data_retention_date_start.format('YYYY-MM-DD'),
                        onChange: (filters)=>{
                            this.setState({
                                main_filters: filters
                            });
                            this.filterMainItems(filters);
                        }
                    }),
                    this.state.main_table_items === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1 pl-4 pr-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-grow",
                            style: {
                                flexBasis: '0'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "results",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "results-table without-vertical-lines",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                            columnIdx: 1,
                                            title: ""
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                            columnIdx: 2,
                                            title: "Artikel"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                            columnIdx: 3,
                                            title: "EAN"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                            columnIdx: 4,
                                            cls: "text-right",
                                            title: "Koli\u010Dina"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                            columnIdx: 5,
                                            cls: "text-right",
                                            title: "Znesek z DDV brez pop."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                            columnIdx: 6,
                                            cls: "text-right",
                                            title: "Znesek popusta"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                            columnIdx: 7,
                                            cls: "text-right",
                                            title: "Znesek brez DDV s pop."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                                            columnIdx: 8,
                                            cls: "text-right",
                                            title: "Znesek z DDV s pop."
                                        }),
                                        this.state.main_table_items.sorted_id_items.map((id_item)=>{
                                            const item = this.state.main_table_items.items[id_item];
                                            const item_item = this.props.items[item.id_item];
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                        columnIdx: 1,
                                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.AnchorButton), {
                                                            icon: "download",
                                                            minimal: true,
                                                            href: this.props.api_url + 'Reports/v1/export-item-and-service-documents-to-excel?id_item=' + item.id_item + '&date_from=' + (0, _momentDefault.default)(this.state.main_filters.date_range[0]).format('YYYY-MM-DD') + '&date_until=' + (0, _momentDefault.default)(this.state.main_filters.date_range[1]).format('YYYY-MM-DD'),
                                                            target: "_blank"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                        columnIdx: 2,
                                                        child: item_item.internal_code + " \u2022 " + item_item.title
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                        columnIdx: 3,
                                                        child: item_item.ean
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                        columnIdx: 4,
                                                        cls: "text-right",
                                                        child: item.quantity.toLocaleString(undefined, {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                        columnIdx: 5,
                                                        cls: "text-right",
                                                        child: item.price_with_vat_without_discount.toLocaleString(undefined, {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                        columnIdx: 6,
                                                        cls: "text-right",
                                                        child: item.discount_amount.toLocaleString(undefined, {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                        columnIdx: 7,
                                                        cls: "text-right",
                                                        child: item.price_without_vat_with_discount.toLocaleString(undefined, {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                                        columnIdx: 8,
                                                        cls: "text-right",
                                                        child: item.price_with_vat_with_discount.toLocaleString(undefined, {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })
                                                    })
                                                ]
                                            }, 'item-' + item.id_item);
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 1,
                                            cls: "font-bold",
                                            child: ''
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 2,
                                            cls: "font-bold",
                                            child: 'SKUPAJ'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 3,
                                            cls: "font-bold",
                                            child: ''
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 4,
                                            cls: "font-bold text-right",
                                            child: this.state.main_table_items.total.quantity.toLocaleString(undefined, {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 5,
                                            cls: "font-bold text-right",
                                            child: this.state.main_table_items.total.price_with_vat_without_discount.toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 6,
                                            cls: "font-bold text-right",
                                            child: this.state.main_table_items.total.discount_amount.toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 7,
                                            cls: "font-bold text-right",
                                            child: this.state.main_table_items.total.price_without_vat_with_discount.toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                            columnIdx: 8,
                                            cls: "font-bold text-right",
                                            child: this.state.main_table_items.total.price_with_vat_with_discount.toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        });
    }
}
ItemsAndServices.propTypes = {};
function mapStateToProps(state) {
    return {
        client: state.ConstantsSlice.client,
        api_url: state.CashRegisterSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        users: state.UserSlice.users,
        invoices: state.BusinessSlice.invoices,
        items: state.CodeTablesSlice.items
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ItemsAndServices);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","moment":"1e4qG","@blueprintjs/core":"6Mq52","../code_tables/ResultComponents":"1eVlZ","../TextWithTooltip":"6kuHH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bM41S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _raviger = require("raviger");
var _datePickerDialog = require("../DatePickerDialog");
var _datePickerDialogDefault = parcelHelpers.interopDefault(_datePickerDialog);
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _editActivityItemDialog = require("../reservations/EditActivityItemDialog");
var _editActivityItemDialogDefault = parcelHelpers.interopDefault(_editActivityItemDialog);
var _reservationSlice = require("../../slices/ReservationSlice");
var _reservations = require("../../api/Reservations");
class MainFilter extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            date: props.date,
            date_picker_dialog_open: false,
            selected_activities: props.selected_activities
        };
    }
    render() {
        const current_date = this.state.date;
        const current_date_iso = current_date.toISOString(true);
        const min_date_iso = this.props.min_date === null ? null : (0, _momentDefault.default)(this.props.min_date).toISOString(true);
        const offsetCurrentDate = (offset_days)=>{
            let d = (0, _momentDefault.default)(current_date).add(offset_days, 'days');
            if (min_date_iso !== null && d.toISOString(true) < min_date_iso) d = (0, _momentDefault.default)(min_date_iso);
            setCurrentDate(d.toDate());
        };
        const setCurrentDate = (date)=>{
            this.setState({
                date
            });
            this.props.onChangeDate(date);
        };
        const sortAndExtractIdActivities = (activities)=>{
            return Object.values(activities).sort((a, b)=>{
                if (a.ord < b.ord) return -1;
                else if (a.ord > b.ord) return 1;
                return 0;
            }).map((item)=>item.id_activity);
        };
        const all_activities = sortAndExtractIdActivities(this.props.activities);
        const isActivitySelected = (activity)=>{
            return this.state.selected_activities.indexOf(activity) != -1;
        };
        const toggleActivity = (activity)=>{
            const selected_activities_arr = Array.from(this.state.selected_activities);
            if (isActivitySelected(activity)) selected_activities_arr.splice(selected_activities_arr.indexOf(activity), 1);
            else selected_activities_arr.push(activity);
            this.setState({
                selected_activities: selected_activities_arr
            });
            this.props.onChangeSelectedActivities(selected_activities_arr);
        };
        const openFilterDatePickerDialog = ()=>{
            this.setState({
                date_picker_dialog_open: true
            });
        };
        const closeFilterDatePickerDialog = (newValue)=>{
            this.setState({
                date_picker_dialog_open: false
            });
            if (newValue instanceof Date) setCurrentDate(newValue);
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.date_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDialogDefault.default), {
                    closeDatePickerDialog: closeFilterDatePickerDialog,
                    min_date: this.props.min_date,
                    value: current_date
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col items-center main-filters pl-4 pt-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        offsetCurrentDate(-30);
                                    },
                                    disabled: this.props.min_date !== null && current_date_iso <= min_date_iso,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 20 18",
                                            width: "20",
                                            height: "18",
                                            className: "inline-block mr-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                fillRule: "evenodd",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m14.589 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    })
                                                ]
                                            })
                                        }),
                                        "30 dni"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        offsetCurrentDate(-15);
                                    },
                                    disabled: this.props.min_date !== null && current_date_iso <= min_date_iso,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            viewBox: "0 0 14 18",
                                            width: "14",
                                            height: "18",
                                            className: "inline-block mr-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                    fillRule: "evenodd"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                    fillRule: "evenodd"
                                                })
                                            ]
                                        }),
                                        "15 dni"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        offsetCurrentDate(-1);
                                    },
                                    disabled: this.props.min_date !== null && current_date_iso <= min_date_iso,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 9 18",
                                            width: "9",
                                            height: "18",
                                            className: "inline-block mr-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fill: "#92a8b8",
                                                d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                fillRule: "evenodd"
                                            })
                                        }),
                                        "1 dan"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    className: "w-24",
                                    onClick: ()=>{
                                        openFilterDatePickerDialog();
                                    },
                                    intent: (0, _core.Intent).PRIMARY,
                                    children: current_date.toLocaleString('sl-SI', {
                                        year: 'numeric',
                                        month: 'numeric',
                                        day: 'numeric'
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    className: "w-24",
                                    onClick: ()=>{
                                        setCurrentDate(new Date());
                                    },
                                    intent: (0, _core.Intent).PRIMARY,
                                    disabled: (0, _momentDefault.default)(current_date).format('YYYY-MM-DD') == (0, _momentDefault.default)().format('YYYY-MM-DD'),
                                    children: "Danes"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        offsetCurrentDate(1);
                                    },
                                    children: [
                                        "1 dan",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 9 18",
                                            width: "9",
                                            height: "18",
                                            className: "inline-block ml-1",
                                            transform: "scale(-1,1)",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fill: "#92a8b8",
                                                d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                fillRule: "evenodd"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        offsetCurrentDate(15);
                                    },
                                    children: [
                                        "15 dni",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            viewBox: "0 0 14 18",
                                            width: "14",
                                            height: "18",
                                            className: "inline-block ml-1",
                                            transform: "scale(-1,1)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                    fillRule: "evenodd"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "#92a8b8",
                                                    d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z",
                                                    fillRule: "evenodd"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Button), {
                                    onClick: ()=>{
                                        offsetCurrentDate(30);
                                    },
                                    children: [
                                        "30 dni",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 20 18",
                                            width: "20",
                                            height: "18",
                                            className: "inline-block ml-1",
                                            transform: "scale(-1,1)",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                fillRule: "evenodd",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m3.41 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m9 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "#92a8b8",
                                                        d: "m14.589 8 3.29-3.29c0.19-0.18 0.3-0.43 0.3-0.71a1.003 1.003 0 0 0-1.71-0.71l-4 4c-0.18 0.18-0.29 0.43-0.29 0.71s0.11 0.53 0.29 0.71l4 4a1.0041 1.0041 0 0 0 1.42-1.42z"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 h-4 mt-2",
                            children: all_activities.map((id_activity)=>{
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    inline: true,
                                    checked: isActivitySelected(id_activity),
                                    label: this.props.activities[id_activity].title,
                                    onChange: ()=>{
                                        toggleActivity(id_activity);
                                    }
                                }, 'activity-' + id_activity);
                            })
                        })
                    ]
                })
            ]
        });
    }
}
function groupActivityReservationsByTimeSlotActivities(activity_reservations, show_deleted, show_no_show, show_reversed) {
    const grouped_activity_reservations = {};
    if (activity_reservations !== undefined) for(let key in activity_reservations){
        const activity_reservation = activity_reservations[key];
        if (!show_deleted && activity_reservation.deleted === true) continue;
        if (!show_no_show && activity_reservation.status == 'no-show') continue;
        if (!show_reversed && activity_reservation.status == 'reversed') continue;
        if (grouped_activity_reservations[activity_reservation.id_accommodation_item_schedule_time_slot_activity] === undefined) grouped_activity_reservations[activity_reservation.id_accommodation_item_schedule_time_slot_activity] = [];
        grouped_activity_reservations[activity_reservation.id_accommodation_item_schedule_time_slot_activity].push(activity_reservation);
    }
    return grouped_activity_reservations;
}
function getDocuments(document_associations, id_document, max_depth, depth) {
    depth = depth || 1;
    let items = {};
    if (depth > max_depth) return items;
    let documents = Object.values(document_associations[id_document] || {});
    for(let i = 0; i < documents.length; i++){
        let item = documents[i];
        let curr_id_document = item.source_id_document;
        let document_type = item.source_type;
        if (item.source_id_document == id_document) {
            curr_id_document = item.target_id_document;
            document_type = item.target_type;
        }
        if (items[item.id_document_association] === undefined) items[item.id_document_association] = {
            id_document_association: item.id_document_association,
            created: item.created,
            id_document: curr_id_document,
            document_type
        };
        const subitems = getDocuments(document_associations, curr_id_document, max_depth, depth + 1);
        for(let id_document_association in subitems)if (items[id_document_association] === undefined) items[id_document_association] = subitems[id_document_association];
    }
    return items;
}
function ActivityReports(props) {
    const { accommodation_item, activities, accommodation_item_schedule_time_slots, accommodation_item_schedule_time_slot_activities, accommodation_item_schedules, activity_reservations, customers, document_associations, invoices, selected_activity_ids, date, all_items, show_deleted, setShowDeleted, show_no_show, setShowNoShow, show_reversed, setShowReversed, show_invoices, setShowInvoices, show_drafts, setShowDrafts, setCurrentDate, dispatch, token, api_url, openInvoiceDialog, payment_types, user } = props;
    const [edit_activity_item_dialog_open, setEditActivityItemDialogOpen] = (0, _react.useState)(false);
    const [edit_activity_item_dialog_item, setEditActivityItemDialogItem] = (0, _react.useState)(null);
    const [edit_activity_item_dialog_reservation_date, setEditActivityItemDialogReservationDate] = (0, _react.useState)(null);
    const [edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity, setEditActivityItemDialogIdAccommodationItemScheduleTimeSlotActivity] = (0, _react.useState)(-1);
    const isActivitySelected = (id_activity)=>selected_activity_ids.length == 0 || selected_activity_ids.indexOf(id_activity) !== -1;
    const current_date = (0, _momentDefault.default)(date);
    const curr_date_iso = current_date.format('YYYY-MM-DD');
    const id_accommodation_item = accommodation_item.id_accommodation_item;
    const weekdays = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
    ];
    const item_schedules = Object.values(accommodation_item_schedules).filter((item)=>item.id_accommodation_item == id_accommodation_item).sort((a, b)=>{
        if (a.valid_from > b.valid_from) return -1;
        if (a.valid_from < b.valid_from) return 1;
        if (a.valid_until === null) return -1;
        if (b.valid_until === null) return 1;
        return 0;
    });
    // find the most appropriate schedule
    const current_date_iso = current_date.format('YYYY-MM-DD');
    let accommodation_item_schedule = null;
    for(let j = 0; j < item_schedules.length; j++){
        const item = item_schedules[j];
        if (item.valid_from <= current_date_iso && (item.valid_until === null || item.valid_until >= current_date_iso) && (accommodation_item_schedule === null || item.valid_from > accommodation_item_schedule.valid_from)) accommodation_item_schedule = item;
    }
    const items = [];
    if (accommodation_item_schedule !== null) {
        const time_slots = Object.values(accommodation_item_schedule_time_slots).filter((item)=>item.id_accommodation_item_schedule == accommodation_item_schedule.id_accommodation_item_schedule);
        let time_slots_for_current_date = [];
        for(let i = 0; i < time_slots.length; i++)if (time_slots[i].day_of_week == weekdays[current_date.day()]) time_slots_for_current_date.push(time_slots[i]);
        time_slots_for_current_date.sort((a, b)=>{
            if (a.starts_at < b.starts_at) return -1;
            else if (a.starts_at > b.starts_at) return 1;
            return 0;
        });
        const activities_values = Object.values(accommodation_item_schedule_time_slot_activities);
        for(let i = 0; i < time_slots_for_current_date.length; i++){
            const time_slot = time_slots_for_current_date[i];
            const selected_activities = activities_values.filter((item)=>item.id_accommodation_item_schedule_time_slot == time_slot.id_accommodation_item_schedule_time_slot && isActivitySelected(item.id_activity));
            if (selected_activities.length > 0 && Object.keys(selected_activities).length > 0) {
                const starts_at_arr = time_slot.starts_at.split(':');
                const time_label = starts_at_arr.length != 3 ? '00:00' : starts_at_arr[0] + ':' + starts_at_arr[1];
                const item = {
                    id_time_slot: time_slot.id_accommodation_item_schedule_time_slot,
                    time_label,
                    activities: selected_activities.sort((a, b)=>{
                        return activities[a.id_activity].ord - activities[b.id_activity].ord;
                    }).map((activity)=>{
                        return {
                            key: activity.id_accommodation_item_schedule_time_slot_activity,
                            title: activities[activity.id_activity].title,
                            max_guest_count: activity.max_guest_count,
                            guests: []
                        };
                    })
                };
                items.push(item);
            }
        }
    //all_items.push(items);
    }
    const group_activity_reservations = groupActivityReservationsByTimeSlotActivities(activity_reservations, show_deleted, show_no_show, show_reversed);
    console.log({
        group_activity_reservations,
        curr_date_iso
    });
    let sum_amount = 0;
    let sum_amount_by_id_time_slot = {};
    let sum_amount_by_id_time_slot_id_activity = {};
    const invoice_documents_by_id_reservations = {};
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        for(let j = 0; j < item.activities.length; j++){
            const activity = item.activities[j];
            const reservations = (group_activity_reservations[activity.key] || []).filter((x)=>x.reservation_date == curr_date_iso);
            for(let j = 0; j < reservations.length; j++){
                const reservation = reservations[j];
                let invoice_documents = Object.values(getDocuments(document_associations, reservation.id_activity_reservation, 3)).filter((document)=>document.document_type == 'invoice' || document.document_type == 'cash-invoice').filter((document)=>{
                    const invoice = invoices[document.id_document];
                    if (!show_invoices && invoice.draft === false) return false;
                    if (!show_drafts && invoice.draft === true) return false;
                    return true;
                }).sort((a, b)=>{
                    if (a.created < b.created) return 1;
                    if (a.created > b.created) return -1;
                    return 0;
                });
                // remove duplicates
                invoice_documents = invoice_documents.filter((value, index, self)=>{
                    return self.findIndex((x)=>x.document_type == value.document_type && x.id_document == value.id_document) === index;
                });
                invoice_documents_by_id_reservations[reservation.id_activity_reservation] = invoice_documents;
                const amount = invoice_documents.reduce((acc, val)=>{
                    return acc + parseFloat(invoices[val.id_document].invoice_amount);
                }, 0);
                sum_amount += amount;
                sum_amount_by_id_time_slot[item.id_time_slot] = (sum_amount_by_id_time_slot[item.id_time_slot] ?? 0) + amount;
                sum_amount_by_id_time_slot_id_activity[item.id_time_slot + '--' + activity.key] = (sum_amount_by_id_time_slot_id_activity[item.id_time_slot + '--' + activity.key] ?? 0) + amount;
            }
        }
    }
    const openEditActivityItemDialog = (item, id_accommodation_item_schedule_time_slot_activity, reservation_date)=>{
        setEditActivityItemDialogOpen(true);
        setEditActivityItemDialogItem(item);
        setEditActivityItemDialogReservationDate(reservation_date);
        setEditActivityItemDialogIdAccommodationItemScheduleTimeSlotActivity(id_accommodation_item_schedule_time_slot_activity);
    };
    const closeEditActivityItemDialog = async (original_item, item)=>{
        setEditActivityItemDialogOpen(false);
        if (item !== undefined) {
            let new_item = {};
            if (original_item !== null) {
                new_item = {
                    ...original_item
                };
                new_item.guest_count = item.guest_count;
                new_item.guest_child_count = item.guest_child_count;
                new_item.note = item.note;
                new_item.id_channel = item.id_channel == -1 ? null : item.id_channel;
                new_item.id_customer = item.id_customer;
                new_item.phone = '';
                new_item.email = '';
                new_item.reservation_date = item.reservation_date;
                new_item.status = item.status;
                new_item.status_2 = item.status_2 == '' ? null : item.status_2;
                new_item.deleted = item.deleted;
            } else new_item = {
                id_activity_reservation: -1,
                guest_count: item.guest_count,
                guest_child_count: item.guest_child_count,
                note: item.note,
                id_channel: item.id_channel == -1 ? null : item.id_channel,
                id_customer: item.id_customer,
                phone: '',
                email: '',
                status: item.status,
                status_2: item.status_2 == '' ? null : item.status_2,
                reservation_date: item.reservation_date,
                id_accommodation_item_schedule_time_slot_activity: edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity,
                deleted: false,
                username: props.user.username
            };
            dispatch((0, _reservationSlice.addActivityReservation)({
                item: new_item,
                token
            }));
            new_item = await (0, _reservations.saveActivityReservation)(api_url, new_item, token);
            if (new_item !== null) dispatch((0, _reservationSlice.addActivityReservation)({
                item: new_item,
                token
            }));
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !edit_activity_item_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editActivityItemDialogDefault.default), {
                closeEditActivityItemDialog: closeEditActivityItemDialog,
                item: edit_activity_item_dialog_item,
                reservation_date: edit_activity_item_dialog_reservation_date,
                time_slot: accommodation_item_schedule_time_slots[accommodation_item_schedule_time_slot_activities[edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity].id_accommodation_item_schedule_time_slot],
                activity: activities[accommodation_item_schedule_time_slot_activities[edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity].id_activity],
                accommodation_item_schedule_time_slot_activity: accommodation_item_schedule_time_slot_activities[edit_activity_item_dialog_id_accommodation_item_schedule_time_slot_activity],
                setCurrentDate: setCurrentDate
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "reports-activity-reservations-list m-4 flex-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col col-1 time-header-col bg-gray-600 text-white flex flex-row items-center",
                        style: {
                            backgroundColor: '#394b59',
                            gridColumn: '1 / 9'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "pl-1 pr-4 pt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: show_deleted,
                                    onChange: (event)=>{
                                        setShowDeleted(event.target.checked);
                                    },
                                    label: "Brisane"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "pl-1 pr-4 pt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: show_no_show,
                                    onChange: (event)=>{
                                        setShowNoShow(event.target.checked);
                                    },
                                    label: "Neprihod"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "pl-1 pr-4 pt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: show_reversed,
                                    onChange: (event)=>{
                                        setShowReversed(event.target.checked);
                                    },
                                    label: "Stornirane"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "pl-8 pr-4 pt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: show_invoices,
                                    onChange: (event)=>{
                                        setShowInvoices(event.target.checked);
                                    },
                                    label: "Ra\u010Duni"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "pl-1 pr-4 pt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                    checked: show_drafts,
                                    onChange: (event)=>{
                                        setShowDrafts(event.target.checked);
                                    },
                                    label: "Osnutki"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col col-9 time-header-col bg-gray-600 text-white flex flex-row items-center justify-end text-right",
                        style: {
                            backgroundColor: '#394b59'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pr-2",
                            children: sum_amount.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        })
                    }),
                    items.map((item, item_idx)=>{
                        let reservation_count = 0;
                        for(let i = 0; i < item.activities.length; i++){
                            const activity = item.activities[i];
                            const reservations = (group_activity_reservations[activity.key] || []).filter((x)=>x.reservation_date == curr_date_iso);
                            reservation_count += reservations.length;
                        }
                        if (reservation_count == 0) return null;
                        const counts = item.activities.reduce((acc, val)=>{
                            const reservations = (group_activity_reservations[val.key] || []).filter((x)=>x.reservation_date == curr_date_iso);
                            return [
                                acc[0] + reservations.reduce((accx, x)=>accx + x.guest_count, 0),
                                acc[1] + reservations.reduce((accx, x)=>accx + x.guest_child_count, 0),
                                acc[2] + val.max_guest_count
                            ];
                        }, [
                            0,
                            0,
                            0
                        ]);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col col-1 time-header-col bg-gray-600 text-white flex flex-row items-center time-label",
                                    children: item.time_label
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col col-2 time-header-col bg-gray-600 text-white flex flex-row items-center",
                                    children: counts[0] + ' / ' + counts[1]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col col-3 time-header-col bg-gray-600 text-white flex flex-row items-center"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col col-4 time-header-col bg-gray-600 text-white flex flex-row items-center"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col col-5 time-header-col bg-gray-600 text-white flex flex-row items-center"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col col-6 time-header-col bg-gray-600 text-white flex flex-row items-center"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col col-7 time-header-col bg-gray-600 text-white flex flex-row items-center"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col col-8 time-header-col bg-gray-600 text-white flex flex-row items-center"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col col-9 time-header-col bg-gray-600 text-white flex flex-row items-center justify-end text-right",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "pr-2",
                                        children: sum_amount_by_id_time_slot[item.id_time_slot].toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                    children: item.activities.map((activity)=>{
                                        const reservations = (group_activity_reservations[activity.key] || []).filter((x)=>x.reservation_date == curr_date_iso).sort((a, b)=>{
                                            if (a.created > b.created) return 1;
                                            if (a.created < b.created) return -1;
                                            return 0;
                                        });
                                        if (reservations.length == 0) return null;
                                        const reservation_items_grouped = {};
                                        for(let i = 0; i < reservations.length; i++){
                                            const reservation = reservations[i];
                                            const accommodation_item_schedule_time_slot_activity = accommodation_item_schedule_time_slot_activities[reservation.id_accommodation_item_schedule_time_slot_activity];
                                            const activity = activities[accommodation_item_schedule_time_slot_activity.id_activity];
                                            if (activity.id_item === null) continue;
                                            const item = all_items[activity.id_item];
                                            if (reservation.guest_child_count > 0) {
                                                const key = item.id_item + (activity.item_child_discount > 0 ? '--' + activity.item_child_discount : '');
                                                if (reservation_items_grouped[key] === undefined) reservation_items_grouped[key] = {
                                                    id_item: item.id_item,
                                                    count: 0,
                                                    discount: activity.item_child_discount
                                                };
                                                reservation_items_grouped[key].count += reservation.guest_child_count;
                                            }
                                            if (reservation.guest_count > 0) {
                                                const key = item.id_item;
                                                if (reservation_items_grouped[key] === undefined) reservation_items_grouped[key] = {
                                                    id_item: item.id_item,
                                                    count: 0,
                                                    discount: 0
                                                };
                                                reservation_items_grouped[key].count += reservation.guest_count;
                                            }
                                        }
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col col-1 activity-header-col bg-gray-400 font-semibold flex flex-row items-center activity-label",
                                                    children: activity.title
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col col-2 activity-header-col bg-gray-400 font-semibold flex flex-row items-center",
                                                    children: "\u0160t. oseb"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col col-3 activity-header-col bg-gray-400 font-semibold flex flex-row items-center",
                                                    children: "Opomba"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col col-4 activity-header-col bg-gray-400 font-semibold flex flex-row items-center",
                                                    children: "Datum"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col col-5 activity-header-col bg-gray-400 font-semibold flex flex-row items-center",
                                                    children: "\u0160t. ra\u010Duna"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col col-6 activity-header-col bg-gray-400 font-semibold flex flex-row items-center",
                                                    children: "Ura izdaje"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col col-7 activity-header-col bg-gray-400 font-semibold flex flex-row items-center",
                                                    children: "Na\u010Din pla\u010Dila"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col col-8 activity-header-col bg-gray-400 font-semibold flex flex-row items-center",
                                                    children: "Blagajnik"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "col col-9 activity-header-col bg-gray-400 font-semibold flex flex-row items-center justify-end text-right",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "pr-2",
                                                        children: "Znesek (EUR)"
                                                    })
                                                }),
                                                reservations.map((reservation, reservation_idx)=>{
                                                    const customer = customers[reservation.id_customer] ?? null;
                                                    const invoice_documents = invoice_documents_by_id_reservations[reservation.id_activity_reservation];
                                                    let pattern_class_name = '';
                                                    if (reservation.status == 'offer-sent') pattern_class_name = 'reservation-list-pattern-polka-dots';
                                                    else if (reservation.status == 'advance-invoice-sent' || reservation.status == 'not-for-rent' /*with red background*/ ) pattern_class_name = 'reservation-list-pattern-diagonal-stripes';
                                                    let cls = pattern_class_name + ' ' + 'status-' + (reservation.deleted === true ? 'deleted' : reservation.status) + ' ' + (reservation.status_2 === null ? '' : reservation.status_2);
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "border-b border-gray-500 border-solid flex flex-row col col-1 reservation " + cls,
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                        version: "1.1",
                                                                        baseProfile: "full",
                                                                        width: "16",
                                                                        height: "16",
                                                                        className: "custom-status",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            d: "M 0,0 L 16,0 L 0,16 L 0,0 z",
                                                                            fill: "#ff0000"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "pl-2 pr-3 w-24",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                            className: "cell-button",
                                                                            small: true,
                                                                            onClick: ()=>openEditActivityItemDialog(reservation, reservation.id_accommodation_item_schedule_time_slot_activity, reservation.reservation_date),
                                                                            children: reservation.internal_code
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "customer-name",
                                                                        children: customer === null ? '' : customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "border-b border-gray-500 border-solid flex flex-row col col-2 reservation " + cls,
                                                                children: [
                                                                    reservation.guest_count,
                                                                    " / ",
                                                                    reservation.guest_child_count
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "border-b border-gray-500 border-solid flex flex-col col col-3 reservation " + cls,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                                                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: reservation.note.replaceAll('\n', '<br />')
                                                                        }
                                                                    }),
                                                                    targetClassName: "w-full",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "truncate",
                                                                        children: reservation.note
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "border-b border-gray-500 border-solid flex flex-col col col-4 reservation " + cls,
                                                                children: invoice_documents.map((invoice)=>{
                                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        style: {
                                                                            lineHeight: '25px'
                                                                        },
                                                                        children: (0, _momentDefault.default)(invoices[invoice.id_document].invoice_date).format('DD.MM.YYYY')
                                                                    }, 'date-' + invoice.id_document);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "border-b border-gray-500 border-solid flex flex-col col col-5 reservation " + cls,
                                                                children: invoice_documents.map((invoice)=>{
                                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                                            className: "cell-button",
                                                                            small: true,
                                                                            onClick: ()=>openInvoiceDialog(invoices[invoice.id_document], invoices[invoice.id_document].invoice_type),
                                                                            children: invoices[invoice.id_document].draft === true ? 'osnutek' : invoices[invoice.id_document].invoice_number_internal
                                                                        })
                                                                    }, 'invoice-number-internal-' + invoice.id_document);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "border-b border-gray-500 border-solid flex flex-col col col-6 reservation " + cls,
                                                                children: invoice_documents.map((invoice)=>{
                                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        style: {
                                                                            lineHeight: '25px'
                                                                        },
                                                                        children: (0, _momentDefault.default)(invoice.created).format('DD.MM.YYYY HH:mm')
                                                                    }, 'invoice-date-' + invoice.id_document);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "border-b border-gray-500 border-solid flex flex-col col col-7 reservation " + cls,
                                                                children: invoice_documents.map((invoice)=>{
                                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        style: {
                                                                            lineHeight: '25px'
                                                                        },
                                                                        children: invoices[invoice.id_document].payments.map((x)=>payment_types[x.id_payment_type].title).join(', ')
                                                                    }, 'invoice-payment-type-' + invoice.id_document);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "border-b border-gray-500 border-solid flex flex-col col col-8 reservation " + cls,
                                                                children: invoice_documents.map((invoice)=>{
                                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        style: {
                                                                            lineHeight: '25px'
                                                                        },
                                                                        children: invoices[invoice.id_document].username
                                                                    }, 'invoice-payment-type-' + invoice.id_document);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "border-b border-gray-500 border-solid flex flex-col justify-end text-right col col-9 reservation " + cls,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "pr-2",
                                                                    children: invoice_documents.map((invoice)=>{
                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            style: {
                                                                                lineHeight: '25px'
                                                                            },
                                                                            children: parseFloat(invoices[invoice.id_document].invoice_amount).toLocaleString(undefined, {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            })
                                                                        }, 'amount-' + invoice.id_document);
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }, reservation.id_activity_reservation);
                                                }),
                                                reservations.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "col col-1 border-b border-gray-500 border-solid flex flex-row items-center",
                                                            children: null
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "col col-2 border-b border-gray-500 border-solid flex flex-row items-center"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "col col-3 border-b border-gray-500 border-solid flex flex-row items-center"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "col col-4 border-b border-gray-500 border-solid flex flex-row items-center"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "col col-5 border-b border-gray-500 border-solid flex flex-row items-center"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "col col-6 border-b border-gray-500 border-solid flex flex-row items-center"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "col col-7 border-b border-gray-500 border-solid flex flex-row items-center"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "col col-8 border-b border-gray-500 border-solid flex flex-row items-center"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "col col-9 border-b border-gray-500 border-solid flex flex-row items-center justify-end text-right font-semibold",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "pr-2",
                                                                children: (sum_amount_by_id_time_slot_id_activity[item.id_time_slot + '--' + activity.key] ?? 0).toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, item.id_time_slot + '-' + activity.key);
                                    })
                                })
                            ]
                        }, item.id_time_slot);
                    })
                ]
            })
        ]
    });
}
function ActivityReservations(props) {
    if (props.user === null || props.user === undefined || (props.user.access_roles ?? []).indexOf('reports--realization') === -1) return null;
    let [{ current_date, selected_activities, show_deleted, show_no_show, show_reversed, show_invoices, show_drafts }, setQuery] = (0, _raviger.useQueryParams)();
    current_date = current_date === undefined ? new Date() : new Date(current_date);
    selected_activities = selected_activities === undefined ? [] : selected_activities;
    const data_retention_day_count = Math.max(0, props.user.data_retention_days['reports--realization'] ?? 0);
    const data_retention_date_start = data_retention_day_count == 0 ? null : (0, _momentDefault.default)().add(data_retention_day_count * -1 - 1, 'days');
    if (data_retention_date_start !== null && (0, _momentDefault.default)(current_date).toISOString(true) < data_retention_date_start.toISOString(true)) current_date = data_retention_date_start.toDate();
    show_deleted = show_deleted === 'true';
    show_no_show = show_no_show === 'true';
    show_reversed = show_reversed === 'true';
    show_invoices = show_invoices === undefined ? true : show_invoices === 'true';
    show_drafts = show_drafts === 'true';
    const getCurrentQueryParams = ()=>{
        return {
            current_date: (0, _momentDefault.default)(current_date).format('YYYY-MM-DD'),
            selected_activities,
            show_deleted,
            show_no_show,
            show_reversed,
            show_invoices,
            show_drafts
        };
    };
    const setCurrentDate = (value)=>{
        setQuery({
            ...getCurrentQueryParams(),
            current_date: (0, _momentDefault.default)(value).format('YYYY-MM-DD')
        });
    };
    const setSelectedActivities = (value)=>{
        setQuery({
            ...getCurrentQueryParams(),
            selected_activities: value
        });
    };
    const setShowDeleted = (value)=>{
        setQuery({
            ...getCurrentQueryParams(),
            show_deleted: value
        });
    };
    const setShowNoShow = (value)=>{
        setQuery({
            ...getCurrentQueryParams(),
            show_no_show: value
        });
    };
    const setShowReversed = (value)=>{
        setQuery({
            ...getCurrentQueryParams(),
            show_reversed: value
        });
    };
    const setShowInvoices = (value)=>{
        setQuery({
            ...getCurrentQueryParams(),
            show_invoices: value
        });
    };
    const setShowDrafts = (value)=>{
        setQuery({
            ...getCurrentQueryParams(),
            show_drafts: value
        });
    };
    const accommodation_activities = Object.values(props.accommodations).filter((x)=>x.type == 'activities');
    const accommodation_activity = accommodation_activities.length > 0 ? accommodation_activities[0] : null;
    if (accommodation_activity === null) return null;
    const accommodation_items = Object.values(props.accommodation_items).filter((x)=>x.id_accommodation == accommodation_activity.id_accommodation);
    const accommodation_item = accommodation_items.length > 0 ? accommodation_items[0] : null;
    if (accommodation_item === null) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MainFilter, {
                    activities: props.activities,
                    date: current_date,
                    min_date: data_retention_date_start === null ? null : data_retention_date_start.format('YYYY-MM-DD'),
                    onChangeDate: (date)=>{
                        setCurrentDate(date ?? new Date());
                    },
                    selected_activities: selected_activities,
                    onChangeSelectedActivities: (selected_activities)=>{
                        setSelectedActivities(selected_activities);
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-row",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActivityReports, {
                    accommodation_item: accommodation_item,
                    activities: props.activities,
                    accommodation_item_schedule_time_slots: props.accommodation_item_schedule_time_slots,
                    accommodation_item_schedule_time_slot_activities: props.accommodation_item_schedule_time_slot_activities,
                    accommodation_item_schedules: props.accommodation_item_schedules,
                    activity_reservations: props.activity_reservations,
                    customers: props.customers,
                    document_associations: props.document_associations,
                    invoices: props.invoices,
                    selected_activity_ids: selected_activities,
                    date: current_date,
                    all_items: props.items,
                    show_deleted: show_deleted,
                    setShowDeleted: setShowDeleted,
                    show_no_show: show_no_show,
                    setShowNoShow: setShowNoShow,
                    show_reversed: show_reversed,
                    setShowReversed: setShowReversed,
                    show_invoices: show_invoices,
                    setShowInvoices: setShowInvoices,
                    show_drafts: show_drafts,
                    setShowDrafts: setShowDrafts,
                    setCurrentDate: setCurrentDate,
                    dispatch: props.dispatch,
                    token: props.token,
                    api_url: props.api_url,
                    openInvoiceDialog: props.openInvoiceDialog,
                    payment_types: props.payment_types,
                    user: props.user
                })
            })
        ]
    });
}
function mapStateToProps(state) {
    return {
        client: state.ConstantsSlice.client,
        api_url: state.CashRegisterSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        users: state.UserSlice.users,
        invoices: state.BusinessSlice.invoices,
        items: state.CodeTablesSlice.items,
        activities: state.CodeTablesSlice.activities,
        payment_types: state.CodeTablesSlice.payment_types,
        accommodations: state.CodeTablesSlice.accommodations,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodation_item_schedules: state.CodeTablesSlice.accommodation_item_schedules,
        accommodation_item_schedule_time_slots: state.CodeTablesSlice.accommodation_item_schedule_time_slots,
        accommodation_item_schedule_time_slot_activities: state.CodeTablesSlice.accommodation_item_schedule_time_slot_activities,
        activity_reservations: state.ReservationSlice.activity_reservations,
        customers: state.CodeTablesSlice.customers,
        document_associations: state.DocumentSlice.document_associations_id_documents,
        invoices: state.BusinessSlice.invoices
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ActivityReservations);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","moment":"1e4qG","@blueprintjs/core":"6Mq52","raviger":"knnT1","../DatePickerDialog":"acPCW","../../helpers/PriceHelper":"91cdD","../reservations/EditActivityItemDialog":"eGJmb","../../slices/ReservationSlice":"kTPna","../../api/Reservations":"8B3n3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"57O8F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _raviger = require("raviger");
var _dateRangePickerDialog = require("../DateRangePickerDialog");
var _dateRangePickerDialogDefault = parcelHelpers.interopDefault(_dateRangePickerDialog);
var _priceHelper = require("../../helpers/PriceHelper");
var _priceHelperDefault = parcelHelpers.interopDefault(_priceHelper);
var _editActivityItemDialog = require("../reservations/EditActivityItemDialog");
var _editActivityItemDialogDefault = parcelHelpers.interopDefault(_editActivityItemDialog);
var _reservationSlice = require("../../slices/ReservationSlice");
var _reservations = require("../../api/Reservations");
var _resultComponents = require("../code_tables/ResultComponents");
var _numbers = require("../../numbers");
const Type = {
    occupancy_income: 'occupancy_income',
    arrivals: 'arrivals'
};
class MainFilter extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            from_date: props.date_range[0],
            until_date: props.date_range[1],
            type: props.type,
            statuses: props.statuses,
            date_picker_dialog_open: false,
            id_accommodation_items: props.selected_id_accommodation_items,
            display_inactive: props.display_inactive
        };
    }
    render() {
        const setDates = (from_date, until_date)=>{
            this.setState({
                from_date,
                until_date
            });
        //this.props.onChangeDate([ from_date, until_date ]);
        };
        const openFilterDateRangePickerDialog = ()=>{
            this.setState({
                date_picker_dialog_open: true
            });
        };
        const closeFilterDateRangePickerDialog = (newValueFrom, newValueUntil)=>{
            this.setState({
                date_picker_dialog_open: false
            });
            if (newValueFrom instanceof Date && newValueUntil instanceof Date) setDates(newValueFrom, newValueUntil);
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.date_picker_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePickerDialogDefault.default), {
                    closeDialog: closeFilterDateRangePickerDialog,
                    startValue: this.state.from_date,
                    endValue: this.state.until_date
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col items-start",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mt-4 flex flex-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.RadioGroup), {
                                    className: "flex flex-row items-center",
                                    onChange: (event)=>{
                                        this.setState({
                                            type: event.target.value
                                        });
                                    },
                                    selectedValue: this.state.type,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                            className: "mr-4 mb-0",
                                            label: "Zasedenost/prihodek",
                                            value: Type.occupancy_income
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Radio), {
                                            className: "mr-4 mb-0",
                                            label: "Prihodi/no\u010Ditve",
                                            value: Type.arrivals
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: 'flex flex-row items-center border-solid border-gray-500 border-l-2 pl-4 ' + (this.state.type != Type.occupancy_income ? 'invisible' : ''),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            className: "mr-2 mb-0",
                                            checked: this.state.display_inactive,
                                            onChange: (event)=>{
                                                this.setState({
                                                    display_inactive: event.target.checked
                                                });
                                            },
                                            children: "Prika\u017Ei samo neaktivne"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            disabled: this.state.display_inactive,
                                            onClick: ()=>{
                                                this.setState({
                                                    statuses: [
                                                        'new',
                                                        'waiting-for-confirmation',
                                                        'offer-sent',
                                                        'confirmed',
                                                        'advance-invoice-sent'
                                                    ]
                                                });
                                            },
                                            children: "Izberi aktivne"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            disabled: this.state.display_inactive,
                                            onClick: ()=>{
                                                this.setState({
                                                    statuses: [
                                                        'closed'
                                                    ]
                                                });
                                            },
                                            children: "Izberi pla\u010Dane"
                                        }),
                                        [
                                            {
                                                title: 'Nova',
                                                key: 'new'
                                            },
                                            {
                                                title: 'V potrjevanju',
                                                key: 'waiting-for-confirmation'
                                            },
                                            {
                                                title: 'Izdana ponudba',
                                                key: 'offer-sent'
                                            },
                                            {
                                                title: 'Potrjena',
                                                key: 'confirmed'
                                            },
                                            {
                                                title: 'Izdan avans',
                                                key: 'advance-invoice-sent'
                                            },
                                            {
                                                title: "Pla\u010Dana",
                                                key: 'closed'
                                            }
                                        ].map((x)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                className: "ml-2 mb-0",
                                                disabled: this.state.display_inactive,
                                                checked: this.state.statuses.indexOf(x.key) !== -1,
                                                onChange: (event)=>{
                                                    const statuses = event.target.checked ? [
                                                        ...this.state.statuses,
                                                        x.key
                                                    ] : this.state.statuses.filter((status)=>status != x.key);
                                                    this.setState({
                                                        statuses
                                                    });
                                                },
                                                children: x.title
                                            }, 'status-' + x.key))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mt-2",
                            style: {
                                width: 200
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: [
                                    this.state.from_date,
                                    this.state.until_date
                                ],
                                original_start_date: null,
                                original_end_date: null,
                                onFilterChange: (values)=>{
                                    setDates(values[0], values[1]);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-row flex-wrap mt-2",
                            children: Object.values(this.props.accommodations).filter((accommodation)=>accommodation.type == 'regular').map((accommodation)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pr-4 pl-2 mb-3 border-solid border-gray-500 border-l-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-row justify-between items-center",
                                            style: {
                                                minHeight: 27
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: (accommodation.etourism_id_rno === null ? '' : accommodation.etourism_id_rno + " \u2022 ") + accommodation.title
                                                }),
                                                Object.values(this.props.accommodation_items).filter((x)=>x.id_accommodation == accommodation.id_accommodation).length <= 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            text: "Izberi vse",
                                                            onClick: ()=>{
                                                                const items = [
                                                                    ...this.state.id_accommodation_items
                                                                ];
                                                                Object.values(this.props.accommodation_items).filter((x)=>x.id_accommodation == accommodation.id_accommodation).forEach((accommodation_item)=>{
                                                                    if (items.indexOf(accommodation_item.id_accommodation_item) === -1) items.push(accommodation_item.id_accommodation_item);
                                                                });
                                                                this.setState({
                                                                    id_accommodation_items: items
                                                                });
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                                            text: "Izberi nobenega",
                                                            onClick: ()=>{
                                                                const items = [
                                                                    ...this.state.id_accommodation_items
                                                                ];
                                                                Object.values(this.props.accommodation_items).filter((x)=>x.id_accommodation == accommodation.id_accommodation).forEach((accommodation_item)=>{
                                                                    if (items.indexOf(accommodation_item.id_accommodation_item) !== -1) items.splice(items.indexOf(accommodation_item.id_accommodation_item), 1);
                                                                });
                                                                this.setState({
                                                                    id_accommodation_items: items
                                                                });
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex flex-row flex-wrap mt-2",
                                            children: Object.values(this.props.accommodation_items).filter((x)=>x.id_accommodation == accommodation.id_accommodation).map((accommodation_item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                                    className: "mr-4",
                                                    label: accommodation_item.title == 'default' ? '' : accommodation_item.title,
                                                    checked: this.state.id_accommodation_items.indexOf(accommodation_item.id_accommodation_item) != -1,
                                                    onChange: (event)=>{
                                                        const items = [
                                                            ...this.state.id_accommodation_items
                                                        ];
                                                        if (event.target.checked) items.push(accommodation_item.id_accommodation_item);
                                                        else items.splice(items.indexOf(accommodation_item.id_accommodation_item), 1);
                                                        this.setState({
                                                            id_accommodation_items: items
                                                        });
                                                    }
                                                }, accommodation_item.id_accommodation_item))
                                        })
                                    ]
                                }, accommodation.id_accommodation))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mt-2 mb-8 flex flex-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    icon: "search",
                                    onClick: ()=>{
                                        this.props.onChangeFilters({
                                            type: this.state.type,
                                            statuses: this.state.statuses,
                                            dates: [
                                                this.state.from_date,
                                                this.state.until_date
                                            ],
                                            id_accommodation_items: this.state.id_accommodation_items,
                                            display_inactive: this.state.display_inactive
                                        });
                                    },
                                    intent: (0, _core.Intent).PRIMARY,
                                    children: "Prika\u017Ei"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                    className: "ml-1",
                                    icon: "cloud-download",
                                    onClick: ()=>{
                                        const params = [
                                            'date_from=' + (0, _momentDefault.default)(this.state.from_date).format('YYYY-MM-DD'),
                                            'date_until=' + (0, _momentDefault.default)(this.state.until_date).format('YYYY-MM-DD'),
                                            'type=' + this.state.type,
                                            'statuses=' + this.state.statuses.join(','),
                                            'id_accommodation_items=' + this.state.id_accommodation_items.join(','),
                                            'display_inactive=' + (this.state.display_inactive ? 'true' : 'false')
                                        ];
                                        window.open(this.props.api_url + 'Reports/v1/export-reservations-report-to-excel?' + params.join('&'));
                                    },
                                    intent: (0, _core.Intent).PRIMARY,
                                    children: "Izvoz v Excel"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
// when changing this method, also change ReportsServiceProvider.php
function Arrivals(props) {
    const sums_by_accommodation_item_places = {};
    const sums_by_accommodation_items = {};
    const sums_by_accommodation_items_countries = {};
    const sums_by_accommodations = {};
    const sums_by_accommodations_countries = {};
    const displayed_id_accommodations = [];
    const displayed_id_accommodation_items = [];
    const from_date_iso = (0, _momentDefault.default)(props.from_date).format('YYYY-MM-DD');
    const until_date_iso = (0, _momentDefault.default)(props.until_date).format('YYYY-MM-DD');
    for(let id_reservation_customer in props.reservation_customers){
        const reservation_customer = props.reservation_customers[id_reservation_customer];
        const customer = props.customers[reservation_customer.id_customer];
        const guest_book_item = props.guest_book_items[reservation_customer.id_guest_book];
        const tourist_tax = props.tourist_taxes[reservation_customer.id_tourist_tax];
        if (guest_book_item === undefined) {
            console.log('Guest book item empty for reservation customer ' + id_reservation_customer);
            continue;
        }
        if (reservation_customer.check_in > until_date_iso || reservation_customer.check_out < from_date_iso) continue;
        const reservation = props.reservations[reservation_customer.id_reservation];
        const accommodation_item_place = props.accommodation_item_places[reservation.id_accommodation_item_place];
        const accommodation_item = props.accommodation_items[accommodation_item_place.id_accommodation_item];
        const accommodation = props.accommodations[accommodation_item.id_accommodation];
        if (props.selected_id_accommodation_items.indexOf(accommodation_item.id_accommodation_item) == -1) continue;
        let is_check_in_inside_selected_date_range = true;
        let check_in = (0, _momentDefault.default)(reservation_customer.check_in).startOf('day');
        if (check_in.format('YYYY-MM-DD') < from_date_iso) {
            check_in = (0, _momentDefault.default)(from_date_iso).startOf('day');
            is_check_in_inside_selected_date_range = false;
        }
        let check_out = (0, _momentDefault.default)(reservation_customer.check_out).startOf('day');
        if (check_out.format('YYYY-MM-DD') > until_date_iso) check_out = (0, _momentDefault.default)(until_date_iso).startOf('day');
        const reservation_count = is_check_in_inside_selected_date_range ? 1 : 0;
        const reservation_length = check_out.diff(check_in, 'days');
        if (sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place] === undefined) sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place] = {};
        if (sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place][customer.id_country] === undefined) sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place][customer.id_country] = {
            reservation_count: 0,
            night_count: 0
        };
        sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place][customer.id_country].reservation_count += reservation_count;
        sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place][customer.id_country].night_count += reservation_length;
        if (sums_by_accommodation_items[accommodation_item.id_accommodation_item] === undefined) sums_by_accommodation_items[accommodation_item.id_accommodation_item] = {
            reservation_count: 0,
            night_count: 0
        };
        sums_by_accommodation_items[accommodation_item.id_accommodation_item].reservation_count += reservation_count;
        sums_by_accommodation_items[accommodation_item.id_accommodation_item].night_count += reservation_length;
        if (sums_by_accommodation_items_countries[accommodation_item.id_accommodation_item] === undefined) sums_by_accommodation_items_countries[accommodation_item.id_accommodation_item] = {};
        if (sums_by_accommodation_items_countries[accommodation_item.id_accommodation_item][customer.id_country] === undefined) sums_by_accommodation_items_countries[accommodation_item.id_accommodation_item][customer.id_country] = {
            reservation_count: 0,
            night_count: 0
        };
        sums_by_accommodation_items_countries[accommodation_item.id_accommodation_item][customer.id_country].reservation_count += reservation_count;
        sums_by_accommodation_items_countries[accommodation_item.id_accommodation_item][customer.id_country].night_count += reservation_length;
        if (sums_by_accommodations[accommodation.id_accommodation] === undefined) sums_by_accommodations[accommodation.id_accommodation] = {
            reservation_count: 0,
            night_count: 0
        };
        sums_by_accommodations[accommodation.id_accommodation].reservation_count += reservation_count;
        sums_by_accommodations[accommodation.id_accommodation].night_count += reservation_length;
        if (sums_by_accommodations_countries[accommodation.id_accommodation] === undefined) sums_by_accommodations_countries[accommodation.id_accommodation] = {};
        if (sums_by_accommodations_countries[accommodation.id_accommodation][customer.id_country] === undefined) sums_by_accommodations_countries[accommodation.id_accommodation][customer.id_country] = {
            reservation_count: 0,
            night_count: 0
        };
        sums_by_accommodations_countries[accommodation.id_accommodation][customer.id_country].reservation_count += reservation_count;
        sums_by_accommodations_countries[accommodation.id_accommodation][customer.id_country].night_count += reservation_length;
        if (displayed_id_accommodations.indexOf(accommodation.id_accommodation) == -1) displayed_id_accommodations.push(accommodation.id_accommodation);
        if (displayed_id_accommodation_items.indexOf(accommodation_item.id_accommodation_item) == -1) displayed_id_accommodation_items.push(accommodation_item.id_accommodation_item);
    }
    let c = 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-row items-start",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "reservations-report--arrivals--table mr-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gray-400 pt-2 pb-2 pl-2",
                        children: "Objekt"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gray-400 pt-2 pb-2",
                        children: "Narodnost"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gray-400 pt-2 pb-2 text-right",
                        children: "Prihodi"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gray-400 pt-2 pb-2 pr-2 text-right",
                        children: "No\u010Ditve"
                    }),
                    Object.values(props.accommodations).filter((accommodation)=>displayed_id_accommodations.indexOf(accommodation.id_accommodation) !== -1).sort((a, b)=>a.ord - b.ord).map((accommodation)=>{
                        let color = c % 2 == 0 ? 'bg-gray-350' : '';
                        c++;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'pt-1 pb-1 pl-2 border-solid border-gray-500 border-t font-extrabold ' + color,
                                    children: (accommodation.etourism_id_rno === null ? '' : accommodation.etourism_id_rno + " \u2022 ") + accommodation.title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'pt-1 pb-1 border-solid border-gray-500 border-t font-extrabold ' + color
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'pt-1 pb-1 border-solid border-gray-500 border-t font-extrabold text-right ' + color,
                                    children: sums_by_accommodations[accommodation.id_accommodation].reservation_count
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'pt-1 pb-1 pr-2 border-solid border-gray-500 border-t font-extrabold text-right ' + color,
                                    children: sums_by_accommodations[accommodation.id_accommodation].night_count
                                }),
                                Object.values(props.accommodation_items).sort((a, b)=>a.ord - b.ord).filter((accommodation_item)=>accommodation_item.id_accommodation == accommodation.id_accommodation && displayed_id_accommodation_items.indexOf(accommodation_item.id_accommodation_item) != -1).map((accommodation_item)=>{
                                    let color = c % 2 == 0 ? 'bg-gray-350' : '';
                                    c++;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                        children: [
                                            accommodation_item.title == 'default' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 pl-4 font-bold ' + color,
                                                        children: accommodation_item.title == 'default' ? '' : accommodation_item.title
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: color
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 text-right font-bold ' + color,
                                                        children: sums_by_accommodation_items[accommodation_item.id_accommodation_item].reservation_count
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 text-right font-bold pr-2 ' + color,
                                                        children: sums_by_accommodation_items[accommodation_item.id_accommodation_item].night_count
                                                    })
                                                ]
                                            }),
                                            Object.values(props.accommodation_item_places).filter((accommodation_item_place)=>accommodation_item_place.id_accommodation_item == accommodation_item.id_accommodation_item && sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place] !== undefined).sort((a, b)=>a.ord - b.ord).map((accommodation_item_place)=>{
                                                const retval = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                                                    children: Object.keys(sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place] ?? {}).sort((a, b)=>props.countries[a].official_name_local.localeCompare(props.countries[b].official_name_local)).map((id_country, idx)=>{
                                                        let color = c % 2 == 0 ? 'bg-gray-350' : '';
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: 'pt-1 pb-1 pl-8 ' + color,
                                                                    children: idx == 0 ? accommodation_item_place.title : ''
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: 'pt-1 pb-1 ' + color,
                                                                    children: props.countries[id_country].official_name_local
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: 'pt-1 pb-1 text-right ' + color,
                                                                    children: sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place][id_country].reservation_count
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: 'pt-1 pb-1 text-right pr-2 ' + color,
                                                                    children: sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place][id_country].night_count
                                                                })
                                                            ]
                                                        }, accommodation_item_place.id_accommodation_item_place + '--' + id_country);
                                                    })
                                                }, accommodation_item_place.id_accommodation_item_place);
                                                c++;
                                                return retval;
                                            })
                                        ]
                                    }, accommodation_item.id_accommodation_item);
                                })
                            ]
                        }, accommodation.id_accommodation);
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "reservations-report--arrivals--countries--table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gray-400 pt-2 pb-2 pl-2",
                        children: "Objekt"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gray-400 pt-2 pb-2",
                        children: "Narodnost"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gray-400 pt-2 pb-2 text-right",
                        children: "Prihodi"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-gray-400 pt-2 pb-2 pr-2 text-right",
                        children: "No\u010Ditve"
                    }),
                    Object.values(props.accommodations).filter((accommodation)=>displayed_id_accommodations.indexOf(accommodation.id_accommodation) !== -1).sort((a, b)=>a.ord - b.ord).map((accommodation)=>{
                        let color = c % 2 == 0 ? 'bg-gray-350' : '';
                        c++;
                        const accommodation_items = Object.values(props.accommodation_items).filter((accommodation_item)=>accommodation_item.id_accommodation == accommodation.id_accommodation && displayed_id_accommodation_items.indexOf(accommodation_item.id_accommodation_item) != -1);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'pt-1 pb-1 pl-2 border-solid border-gray-500 border-t font-extrabold ' + color,
                                    children: (accommodation.etourism_id_rno === null ? '' : accommodation.etourism_id_rno + " \u2022 ") + accommodation.title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'pt-1 pb-1 border-solid border-gray-500 border-t font-extrabold ' + color
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'pt-1 pb-1 border-solid border-gray-500 border-t font-extrabold text-right ' + color,
                                    children: sums_by_accommodations[accommodation.id_accommodation].reservation_count
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'pt-1 pb-1 pr-2 border-solid border-gray-500 border-t font-extrabold text-right ' + color,
                                    children: sums_by_accommodations[accommodation.id_accommodation].night_count
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                    children: Object.keys(sums_by_accommodations_countries[accommodation.id_accommodation] ?? {}).sort((a, b)=>props.countries[a].official_name_local.localeCompare(props.countries[b].official_name_local)).map((id_country, idx)=>{
                                        let color = c % 2 == 0 ? 'bg-gray-350' : '';
                                        c++;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 pl-8 ' + color
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 ' + color,
                                                    children: props.countries[id_country].official_name_local
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 text-right ' + color,
                                                    children: sums_by_accommodations_countries[accommodation.id_accommodation][id_country].reservation_count
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 text-right pr-2 ' + color,
                                                    children: sums_by_accommodations_countries[accommodation.id_accommodation][id_country].night_count
                                                })
                                            ]
                                        }, accommodation.id_accommodation + '--' + id_country);
                                    })
                                }),
                                accommodation_items.length <= 1 ? null : accommodation_items.sort((a, b)=>a.ord - b.ord).map((accommodation_item)=>{
                                    let color = c % 2 == 0 ? 'bg-gray-350' : '';
                                    c++;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                                        children: accommodation_item.title == 'default' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 pl-4 font-bold ' + color,
                                                    children: accommodation_item.title == 'default' ? '' : accommodation_item.title
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: color
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 text-right font-bold ' + color,
                                                    children: sums_by_accommodation_items[accommodation_item.id_accommodation_item].reservation_count
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 text-right font-bold pr-2 ' + color,
                                                    children: sums_by_accommodation_items[accommodation_item.id_accommodation_item].night_count
                                                }),
                                                Object.keys(sums_by_accommodation_items_countries[accommodation_item.id_accommodation_item] ?? {}).sort((a, b)=>props.countries[a].official_name_local.localeCompare(props.countries[b].official_name_local)).map((id_country, idx)=>{
                                                    let color = c % 2 == 0 ? 'bg-gray-350' : '';
                                                    c++;
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: 'pt-1 pb-1 pl-8 ' + color
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: 'pt-1 pb-1 ' + color,
                                                                children: props.countries[id_country].official_name_local
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: 'pt-1 pb-1 text-right ' + color,
                                                                children: sums_by_accommodation_items_countries[accommodation_item.id_accommodation_item][id_country].reservation_count
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: 'pt-1 pb-1 text-right pr-2 ' + color,
                                                                children: sums_by_accommodation_items_countries[accommodation_item.id_accommodation_item][id_country].night_count
                                                            })
                                                        ]
                                                    }, accommodation_item.id_accommodation_item + '--' + id_country);
                                                })
                                            ]
                                        })
                                    }, accommodation_item.id_accommodation_item);
                                })
                            ]
                        }, accommodation.id_accommodation);
                    })
                ]
            })
        ]
    });
}
// when changing this method, also change ReportsServiceProvider.php
function OccupancyIncome(props) {
    const sums_by_accommodation_item_places = {};
    const sums_by_accommodation_items = {};
    const sums_by_accommodations = {};
    const sums_total = {
        occupancy_count: 0,
        total_occupancy_count: 0,
        income: 0
    };
    const displayed_id_accommodations = [];
    let displayed_id_accommodation_items = [];
    const from_date_iso = (0, _momentDefault.default)(props.from_date).format('YYYY-MM-DD');
    const until_date_iso = (0, _momentDefault.default)(props.until_date).format('YYYY-MM-DD');
    const total_occupancy_count = (0, _momentDefault.default)(until_date_iso).diff((0, _momentDefault.default)(from_date_iso), 'days');
    const reservation_customers = Object.values(props.reservation_customers);
    // fill initial data
    Object.keys(props.accommodations).filter((id_accommodation)=>props.accommodations[id_accommodation].type == 'regular').forEach((id_accommodation)=>{
        sums_by_accommodations[id_accommodation] = {
            occupancy_count: 0,
            total_occupancy_count: 0,
            income: 0
        };
    });
    Object.keys(props.accommodation_items).forEach((id_accommodation_item)=>{
        displayed_id_accommodation_items.push(id_accommodation_item);
        sums_by_accommodation_items[id_accommodation_item] = {
            occupancy_count: 0,
            total_occupancy_count: 0,
            income: 0
        };
    });
    Object.keys(props.accommodation_item_places).forEach((id_accommodation_item_place)=>{
        sums_by_accommodation_item_places[id_accommodation_item_place] = {
            occupancy_count: 0,
            total_occupancy_count,
            income: 0
        };
        sums_by_accommodation_items[props.accommodation_item_places[id_accommodation_item_place].id_accommodation_item].total_occupancy_count += total_occupancy_count;
        sums_by_accommodations[props.accommodation_items[props.accommodation_item_places[id_accommodation_item_place].id_accommodation_item].id_accommodation].total_occupancy_count += total_occupancy_count;
        sums_total.total_occupancy_count += total_occupancy_count;
    });
    props.selected_id_accommodation_items.map((id_accommodation_item)=>{
        const id_accommodation = props.accommodation_items[id_accommodation_item].id_accommodation;
        if (displayed_id_accommodations.indexOf(id_accommodation) == -1) displayed_id_accommodations.push(id_accommodation);
    });
    const invoices_by_reverse_invoice_references = {};
    for(let id_invoice in props.invoices){
        const invoice = props.invoices[id_invoice];
        if (invoice.reverse_invoice_reference !== null) {
            if (invoices_by_reverse_invoice_references[invoice.reverse_invoice_reference] === undefined) invoices_by_reverse_invoice_references[invoice.reverse_invoice_reference] = [];
            invoices_by_reverse_invoice_references[invoice.reverse_invoice_reference].push(invoice);
        }
    }
    const used_invoices = [];
    for(let id_reservation in props.reservations){
        const reservation = props.reservations[id_reservation];
        if (reservation.check_in > until_date_iso || reservation.check_out < from_date_iso) continue;
        if (props.display_inactive) {
            if ([
                'reversed',
                'no-show',
                'not-for-rent'
            ].indexOf(reservation.status) === -1 && reservation.deleted === false) continue;
        } else {
            if (props.statuses.indexOf(reservation.status) === -1) continue;
        }
        const ignore_for_occupancy = [
            'reversed',
            'no-show',
            'not-for-rent'
        ].indexOf(reservation.status) !== -1 || reservation.deleted === true;
        const accommodation_item_place = props.accommodation_item_places[reservation.id_accommodation_item_place];
        const accommodation_item = props.accommodation_items[accommodation_item_place.id_accommodation_item];
        const accommodation = props.accommodations[accommodation_item.id_accommodation];
        let check_in = (0, _momentDefault.default)(reservation.check_in).startOf('day');
        if (check_in.format('YYYY-MM-DD') < from_date_iso) check_in = (0, _momentDefault.default)(from_date_iso).startOf('day');
        let check_out = (0, _momentDefault.default)(reservation.check_out).startOf('day');
        if (check_out.format('YYYY-MM-DD') > until_date_iso) check_out = (0, _momentDefault.default)(until_date_iso).startOf('day');
        const occupancy_count = ignore_for_occupancy ? 0 : check_out.diff(check_in, 'days');
        const id_invoices = new Set();
        const reservation_docs = Object.values(props.document_associations[reservation.id_reservation] ?? {}).filter((x)=>[
                'invoice',
                'cash-invoice'
            ].indexOf(x.source_type) !== -1);
        for(let i = 0; i < reservation_docs.length; i++)id_invoices.add(reservation_docs[i].source_id_document);
        const customers = reservation_customers.filter((x)=>x.id_reservation == reservation.id_reservation);
        for(let j = 0; j < customers.length; j++){
            const customer_docs = Object.values(props.document_associations[customers[j].id_reservation_customer] ?? {}).filter((x)=>[
                    'invoice',
                    'cash-invoice'
                ].indexOf(x.source_type) !== -1);
            for(let i = 0; i < customer_docs.length; i++)id_invoices.add(customer_docs[i].source_id_document);
        }
        const id_invoices_copy = new Set(id_invoices);
        // take into account reverse invoices as well
        id_invoices_copy.forEach((id_invoice)=>{
            const reverse_invoices = invoices_by_reverse_invoice_references[id_invoice] || [];
            for(let i = 0; i < reverse_invoices.length; i++)id_invoices.add(reverse_invoices[i].id_invoice);
        });
        let income = 0;
        id_invoices.forEach((id_invoice)=>{
            income += props.invoices[id_invoice].invoice_amount;
            used_invoices.push(props.invoices[id_invoice].invoice_number_internal);
        });
        sums_total.occupancy_count += occupancy_count;
        sums_total.income += income;
        sums_by_accommodations[accommodation.id_accommodation].occupancy_count += occupancy_count;
        sums_by_accommodations[accommodation.id_accommodation].income += income;
        sums_by_accommodation_items[accommodation_item.id_accommodation_item].occupancy_count += occupancy_count;
        sums_by_accommodation_items[accommodation_item.id_accommodation_item].income += income;
        sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].occupancy_count += occupancy_count;
        sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].income += income;
    }
    console.log({
        used_invoices: used_invoices.join('\n')
    });
    //displayed_id_accommodation_items = props.selected_id_accommodation_items;
    let c = 0;
    const filtered_accommodations = Object.values(props.accommodations).filter((accommodation)=>accommodation.type == 'regular');
    let level_1_count_sum = 0;
    let level_1_income_sum = 0;
    for(let idx in filtered_accommodations){
        level_1_count_sum += sums_by_accommodations[filtered_accommodations[idx].id_accommodation]?.occupancy_count ?? 0;
        level_1_income_sum += sums_by_accommodations[filtered_accommodations[idx].id_accommodation]?.income ?? 0;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "reservations-report--occupancy_income--table",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bg-gray-400 pt-2 pb-2 pl-2",
                    children: "Objekt"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bg-gray-400 pt-2 pb-2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bg-gray-400 pt-2 pb-2 col-span-3 text-center",
                    children: "Zasedenost (dnevi)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bg-gray-400 pt-2 pb-2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bg-gray-400 pt-2 pb-2 col-span-3 text-center",
                    children: "Prihodek z DDV (EUR)"
                }),
                filtered_accommodations//.filter(accommodation => displayed_id_accommodations.indexOf(accommodation.id_accommodation) !== -1)
                .sort((a, b)=>a.ord - b.ord).map((accommodation)=>{
                    let color = c % 2 == 0 ? 'bg-gray-350' : '';
                    c++;
                    const filtered_accommodation_items = Object.values(props.accommodation_items).sort((a, b)=>a.ord - b.ord).filter((accommodation_item)=>accommodation_item.id_accommodation == accommodation.id_accommodation && displayed_id_accommodation_items.indexOf(accommodation_item.id_accommodation_item) != -1);
                    let level_2_count_sum = 0;
                    let level_2_income_sum = 0;
                    for(let idx in filtered_accommodation_items){
                        level_2_count_sum += sums_by_accommodation_items[filtered_accommodation_items[idx].id_accommodation_item].occupancy_count;
                        level_2_income_sum += sums_by_accommodation_items[filtered_accommodation_items[idx].id_accommodation_item].income;
                    }
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 pl-2 border-solid border-gray-500 border-t font-extrabold ' + color,
                                children: (accommodation.etourism_id_rno === null ? '' : accommodation.etourism_id_rno + " \u2022 ") + accommodation.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 border-solid border-gray-500 border-t ' + color
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 border-solid border-gray-500 border-t font-extrabold text-right ' + color,
                                children: (sums_by_accommodations[accommodation.id_accommodation]?.occupancy_count ?? 0) + '/' + (sums_by_accommodations[accommodation.id_accommodation]?.total_occupancy_count ?? 0)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 pr-2 border-solid border-gray-500 border-t font-extrabold text-right ' + color,
                                children: (0, _numbers.toLocal)((sums_by_accommodations[accommodation.id_accommodation]?.total_occupancy_count ?? 0) == 0 ? 0 : sums_by_accommodations[accommodation.id_accommodation].occupancy_count / sums_by_accommodations[accommodation.id_accommodation].total_occupancy_count * 100, 2) + ' %'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 pr-2 border-solid border-gray-500 border-t font-extrabold text-right ' + color,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressBar, {
                                    value: (sums_by_accommodations[accommodation.id_accommodation]?.total_occupancy_count ?? 0) == 0 ? 0 : sums_by_accommodations[accommodation.id_accommodation].occupancy_count / sums_by_accommodations[accommodation.id_accommodation].total_occupancy_count
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 border-solid border-gray-500 border-t ' + color
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 border-solid border-gray-500 border-t font-extrabold text-right ' + color,
                                children: (0, _numbers.toLocal)(sums_by_accommodations[accommodation.id_accommodation]?.income ?? 0, 2)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 pr-2 border-solid border-gray-500 border-t font-extrabold text-right ' + color,
                                children: (0, _numbers.toLocal)(level_1_income_sum == 0 ? 0 : (sums_by_accommodations[accommodation.id_accommodation]?.income ?? 0) / level_1_income_sum * 100, 2) + ' %'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 pr-2 border-solid border-gray-500 border-t font-extrabold text-right ' + color,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressBar, {
                                    value: level_1_income_sum == 0 ? 0 : (sums_by_accommodations[accommodation.id_accommodation]?.income ?? 0) / level_1_income_sum
                                })
                            }),
                            filtered_accommodation_items.filter((x)=>props.selected_id_accommodation_items.indexOf(x.id_accommodation_item) !== -1).map((accommodation_item)=>{
                                let color = c % 2 == 0 ? 'bg-gray-350' : '';
                                c++;
                                const filtered_accommodation_item_places = Object.values(props.accommodation_item_places).filter((accommodation_item_place)=>accommodation_item_place.id_accommodation_item == accommodation_item.id_accommodation_item && sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place] !== undefined);
                                let level_3_count_sum = 0;
                                let level_3_income_sum = 0;
                                for(let idx in filtered_accommodation_item_places){
                                    level_3_count_sum += sums_by_accommodation_item_places[filtered_accommodation_item_places[idx].id_accommodation_item_place].occupancy_count;
                                    level_3_income_sum += sums_by_accommodation_item_places[filtered_accommodation_item_places[idx].id_accommodation_item_place].income;
                                }
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                    children: [
                                        accommodation_item.title == 'default' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 pl-4 font-bold ' + color,
                                                    children: accommodation_item.title == 'default' ? '' : accommodation_item.title
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 ' + color
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 text-right font-bold ' + color,
                                                    children: sums_by_accommodation_items[accommodation_item.id_accommodation_item].occupancy_count + '/' + sums_by_accommodation_items[accommodation_item.id_accommodation_item].total_occupancy_count
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 text-right font-bold pr-2 ' + color,
                                                    children: (0, _numbers.toLocal)(sums_by_accommodation_items[accommodation_item.id_accommodation_item].total_occupancy_count == 0 ? 0 : sums_by_accommodation_items[accommodation_item.id_accommodation_item].occupancy_count / sums_by_accommodation_items[accommodation_item.id_accommodation_item].total_occupancy_count * 100, 2) + ' %'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 pr-2 text-right ' + color,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressBar, {
                                                        value: sums_by_accommodation_items[accommodation_item.id_accommodation_item].total_occupancy_count == 0 ? 0 : sums_by_accommodation_items[accommodation_item.id_accommodation_item].occupancy_count / sums_by_accommodation_items[accommodation_item.id_accommodation_item].total_occupancy_count
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 ' + color
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 text-right font-bold ' + color,
                                                    children: (0, _numbers.toLocal)(sums_by_accommodation_items[accommodation_item.id_accommodation_item].income, 2)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 text-right font-bold pr-2 ' + color,
                                                    children: (0, _numbers.toLocal)(level_2_income_sum == 0 ? 0 : sums_by_accommodation_items[accommodation_item.id_accommodation_item].income / level_2_income_sum * 100, 2) + ' %'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: 'pt-1 pb-1 pr-2 text-right ' + color,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressBar, {
                                                        value: level_2_income_sum == 0 ? 0 : sums_by_accommodation_items[accommodation_item.id_accommodation_item].income / level_2_income_sum
                                                    })
                                                })
                                            ]
                                        }),
                                        filtered_accommodation_item_places.sort((a, b)=>a.ord - b.ord).map((accommodation_item_place)=>{
                                            let color = c % 2 == 0 ? 'bg-gray-350' : '';
                                            c++;
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 pl-8 ' + color,
                                                        children: accommodation_item_place.title
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 ' + color
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 text-right ' + color,
                                                        children: sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].occupancy_count + '/' + sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].total_occupancy_count
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 text-right pr-2 ' + color,
                                                        children: (0, _numbers.toLocal)(sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].total_occupancy_count == 0 ? 0 : sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].occupancy_count / sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].total_occupancy_count * 100, 2) + ' %'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 pr-2 text-right ' + color,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressBar, {
                                                            value: sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].total_occupancy_count == 0 ? 0 : sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].occupancy_count / sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].total_occupancy_count
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 ' + color
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 text-right ' + color,
                                                        children: (0, _numbers.toLocal)(sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].income, 2)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 text-right pr-2 ' + color,
                                                        children: (0, _numbers.toLocal)(level_3_income_sum == 0 ? 0 : sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].income / level_3_income_sum * 100, 2) + ' %'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'pt-1 pb-1 pr-2 text-right ' + color,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressBar, {
                                                            value: level_3_income_sum == 0 ? 0 : sums_by_accommodation_item_places[accommodation_item_place.id_accommodation_item_place].income / level_3_income_sum
                                                        })
                                                    })
                                                ]
                                            }, accommodation_item_place.id_accommodation_item_place);
                                        })
                                    ]
                                }, accommodation_item.id_accommodation_item);
                            })
                        ]
                    }, accommodation.id_accommodation);
                }),
                (()=>{
                    let color = c % 2 == 0 ? 'bg-gray-350' : '';
                    c++;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 pl-2 font-bold border-solid border-gray-500 border-t-2 ' + color,
                                children: "SKUPAJ"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 border-solid border-gray-500 border-t-2 ' + color
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 text-right font-bold border-solid border-gray-500 border-t-2 ' + color,
                                children: sums_total.occupancy_count + '/' + sums_total.total_occupancy_count
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 text-right font-bold pr-2 border-solid border-gray-500 border-t-2 ' + color,
                                children: (0, _numbers.toLocal)(sums_total.total_occupancy_count == 0 ? 0 : sums_total.occupancy_count / sums_total.total_occupancy_count * 100, 2) + ' %'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 pr-2 text-right border-solid border-gray-500 border-t-2 ' + color,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressBar, {
                                    value: sums_total.total_occupancy_count == 0 ? 0 : sums_total.occupancy_count / sums_total.total_occupancy_count
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 border-solid border-gray-500 border-t-2 ' + color
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 text-right font-bold border-solid border-gray-500 border-t-2 ' + color,
                                children: (0, _numbers.toLocal)(sums_total.income, 2)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 text-right font-bold pr-2 border-solid border-gray-500 border-t-2 ' + color,
                                children: (0, _numbers.toLocal)(100, 2) + ' %'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: 'pt-1 pb-1 pr-2 text-right border-solid border-gray-500 border-t-2 ' + color,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressBar, {
                                    value: 1
                                })
                            })
                        ]
                    });
                })()
            ]
        })
    });
}
function ProgressBar(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            display: 'inline-block',
            width: 220,
            height: 8,
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: '#ffffff',
                    borderRadius: 4
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    right: 100 - props.value * 100 + '%',
                    bottom: 0,
                    backgroundColor: '#394b59',
                    borderRadius: 4
                }
            })
        ]
    });
}
function ReservationsReport(props) {
    if (props.user === null || props.user === undefined || (props.user.access_roles ?? []).indexOf('reports--reservations-report') === -1) return null;
    let [{ from_date, until_date, type, statuses, id_accommodation_items, display_inactive }, setQuery] = (0, _raviger.useQueryParams)();
    from_date = from_date === undefined ? (0, _momentDefault.default)().startOf('month').toDate() : new Date(from_date);
    until_date = until_date === undefined ? new Date() : new Date(until_date);
    type = type === undefined ? Type.occupancy_income : type;
    statuses = statuses === undefined ? [
        'new',
        'waiting-for-confirmation',
        'offer-sent',
        'confirmed',
        'advance-invoice-sent',
        'closed'
    ] : statuses;
    id_accommodation_items = id_accommodation_items === undefined ? [] : id_accommodation_items;
    display_inactive = display_inactive === undefined ? false : display_inactive === 'true';
    if (id_accommodation_items === '') id_accommodation_items = [];
    if (!Array.isArray(id_accommodation_items)) id_accommodation_items = id_accommodation_items.split(',');
    if (statuses === '') statuses = [];
    if (!Array.isArray(statuses)) statuses = statuses.split(',');
    const getCurrentQueryParams = ()=>{
        return {
            from_date: (0, _momentDefault.default)(from_date).format('YYYY-MM-DD'),
            until_date: (0, _momentDefault.default)(until_date).format('YYYY-MM-DD'),
            type,
            statuses,
            id_accommodation_items,
            display_inactive: display_inactive ? 'true' : 'false'
        };
    };
    const setMainFilter = (from, until, type, statuses, id_accommodation_items, display_inactive)=>{
        setQuery({
            ...getCurrentQueryParams(),
            from_date: (0, _momentDefault.default)(from).format('YYYY-MM-DD'),
            until_date: (0, _momentDefault.default)(until).format('YYYY-MM-DD'),
            type,
            statuses: statuses.join(','),
            id_accommodation_items: id_accommodation_items.join(','),
            display_inactive: display_inactive ? 'true' : 'false'
        });
    };
    let view = null;
    if (type == Type.occupancy_income) view = /*#__PURE__*/ (0, _jsxRuntime.jsx)(OccupancyIncome, {
        from_date: from_date,
        until_date: until_date,
        accommodations: props.accommodations,
        accommodation_items: props.accommodation_items,
        accommodation_item_places: props.accommodation_item_places,
        reservation_customers: props.reservation_customers,
        countries: props.countries,
        customers: props.customers,
        tourist_taxes: props.tourist_taxes,
        guest_book_items: props.guest_book_items,
        reservations: props.reservations,
        selected_id_accommodation_items: id_accommodation_items,
        statuses: statuses,
        document_associations: props.document_associations,
        invoices: props.invoices,
        display_inactive: display_inactive
    });
    else if (type == Type.arrivals) view = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrivals, {
        from_date: from_date,
        until_date: until_date,
        accommodations: props.accommodations,
        accommodation_items: props.accommodation_items,
        accommodation_item_places: props.accommodation_item_places,
        reservation_customers: props.reservation_customers,
        countries: props.countries,
        customers: props.customers,
        tourist_taxes: props.tourist_taxes,
        guest_book_items: props.guest_book_items,
        reservations: props.reservations,
        selected_id_accommodation_items: id_accommodation_items
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "pl-4 pr-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MainFilter, {
                    date_range: [
                        from_date,
                        until_date
                    ],
                    onChangeDate: (date_range)=>{
                        setFromUntilDate(date_range[0], date_range[1]);
                    },
                    type: type,
                    statuses: statuses,
                    accommodations: props.accommodations,
                    accommodation_items: props.accommodation_items,
                    selected_id_accommodation_items: id_accommodation_items,
                    display_inactive: display_inactive,
                    onChangeType: (type)=>setType(type),
                    onChangeFilters: (filters)=>{
                        setMainFilter(filters.dates[0], filters.dates[1], filters.type, filters.statuses, filters.id_accommodation_items, filters.display_inactive);
                    },
                    api_url: props.api_url
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-row pb-2",
                children: view
            })
        ]
    });
}
function mapStateToProps(state) {
    return {
        client: state.ConstantsSlice.client,
        api_url: state.CashRegisterSlice.api_url,
        token: state.UserSlice.token,
        user: state.UserSlice.user,
        accommodations: state.CodeTablesSlice.accommodations,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
        countries: state.CodeTablesSlice.countries,
        customers: state.CodeTablesSlice.customers,
        tourist_taxes: state.CodeTablesSlice.tourist_taxes,
        reservation_customers: state.ReservationSlice.reservation_customers,
        reservations: state.ReservationSlice.reservations,
        guest_book_items: state.GuestSlice.guest_book_items,
        document_associations: state.DocumentSlice.document_associations_id_documents,
        invoices: state.BusinessSlice.invoices
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReservationsReport);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","moment":"1e4qG","@blueprintjs/core":"6Mq52","raviger":"knnT1","../DateRangePickerDialog":"eJXAI","../../helpers/PriceHelper":"91cdD","../reservations/EditActivityItemDialog":"eGJmb","../../slices/ReservationSlice":"kTPna","../../api/Reservations":"8B3n3","../code_tables/ResultComponents":"1eVlZ","../../numbers":"jOh9w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e91Vn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _qrcode = require("qrcode");
var _qrcodeDefault = parcelHelpers.interopDefault(_qrcode);
var _react1 = require("@honeybadger-io/react");
var _appSlice = require("../slices/AppSlice");
var _business = require("../api/Business");
var _print = require("../helpers/Print");
var _printDefault = parcelHelpers.interopDefault(_print);
var _invoice = require("../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
//import ErrorReportingHelper from '../helpers/ErrorReportingHelper';
var _localStorageHelper = require("../helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
class PosPrinterWatcher extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            current_item: null
        };
        this.wait_for_remote_confirmation = false;
        this.init = this.init.bind(this);
        this.cleanup = this.cleanup.bind(this);
        this.processQueue = this.processQueue.bind(this);
        this.generatePrintItemsForWidthTest = this.generatePrintItemsForWidthTest.bind(this);
        this.generatePrintItemsForInvoice = this.generatePrintItemsForInvoice.bind(this);
    }
    componentWillUnmount() {
        this.cleanup();
    }
    init() {
        console.log('init print ws');
        const ws = new WebSocket(this.props.ws_print_url);
        ws.onmessage = (event)=>{
            console.log({
                op: 'ws_onmessage',
                event
            });
            const data = JSON.parse(event.data);
            if (data.Action == 'raw-print') {
                const base64_encoded_print = data.Data;
                console.log('converting POS raw to HTML');
                fetch(this.props.api_url + 'escpos/convert_to_html.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: new URLSearchParams({
                        'data': base64_encoded_print,
                        'printer_width': (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__pos_printer_width')
                    })
                }).then((response)=>{
                    console.log({
                        response
                    });
                    return response.text();
                }).then((response)=>{
                    const win = window.open('', 'Title');
                    if (win === null || win === undefined) //TODO display a message saying to allow popups
                    return;
                    win.document.body.innerHTML = response;
                });
            } else if (data.Action == 'printers') this.props.setPrinters(JSON.parse(data.Data));
            else if (data.Action == 'version') {
                console.log([
                    'Got back version:',
                    data.Data
                ]);
                const version = parseInt(data.Data, 10);
                if (version >= 1004) this.wait_for_remote_confirmation = true;
                this.processQueue();
            } else if (data.Action == 'completed-print') {
                this.props.removeInvoiceFromPosPrinterQueue();
                /*if (item.type == 'invoice') {
					ErrorReportingHelper.ReportPosPrintInfo(
						JSON.stringify({ op: 'PosPrinterWatcher.processQueue: step finished', ts: (new Date()).toISOString(), id_invoice: item.invoice.id_invoice }),
						{ tags: 'pos_print, step_finished, item_' + item.invoice.id_invoice }
					);
				}*/ this.setState({
                    current_item: null
                });
                this.processQueue();
            }
        };
        ws.onopen = (event)=>{
            this.props.setPosPrinterConnectedStatus(true);
            if (ws.readyState == WebSocket.OPEN) {
                ws.send(JSON.stringify({
                    Action: 'get-printers',
                    Data: ''
                }));
                ws.send(JSON.stringify({
                    Action: 'get-version',
                    Data: ''
                }));
            }
        };
        ws.onclose = (event)=>{
            this.props.setPosPrinterConnectedStatus(false);
            setTimeout(()=>{
                this.ws = this.init();
            }, 5000);
        };
        return ws;
    }
    cleanup() {
        if (this.ws !== undefined && this.ws !== null) {
            // prevent auto reconnect
            this.ws.onclose = (event)=>{};
            this.ws.close();
            this.props.setPosPrinterConnectedStatus(false);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.ws_print_url != prevProps.ws_print_url) {
            this.cleanup();
            this.ws = this.init();
        }
        if (this.props.pos_printer_queue != prevProps.pos_printer_queue || this.state.current_item != prevState.current_item) this.processQueue();
    }
    componentDidMount() {
        if (this.props.ws_print_url !== null) this.ws = this.init();
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        let rounded_val = Math.properRound(parseFloat(val), decimal_digit_count);
        return rounded_val.toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    fitColumns(printer_width, columns) {
        let fit_columns = [
            ...columns
        ];
        // figure out how many columns we can fit
        let column_width_sum = 0;
        for(let i = 0; i < fit_columns.length; i++){
            column_width_sum += fit_columns[i].min_width;
            if (column_width_sum <= printer_width) {
                fit_columns[i].width = fit_columns[i].min_width;
                column_width_sum += 1; // spacing between columns
            }
        }
        // figure out best fit for columns
        let visible_column_count = fit_columns.filter((x)=>x.width > 0).length;
        let visible_column_width_sum = fit_columns.reduce((acc, cur)=>acc + cur.width, 0);
        let available_column_width = printer_width - (visible_column_count - 1);
        if (available_column_width > visible_column_width_sum) {
            // there is more space available than visible columns require, let's figure out best fit
            column_width_sum = 0;
            for(let i = 0; i < fit_columns.length; i++){
                if (fit_columns[i].width == 0) continue;
                let column_width = Math.round(fit_columns[i].width / visible_column_width_sum * available_column_width);
                // check if rounding put our column outside available space
                if (column_width + column_width_sum > available_column_width) column_width = available_column_width - column_width_sum;
                column_width_sum += column_width;
                fit_columns[i].width = column_width;
            }
        }
        return fit_columns;
    }
    async processQueue() {
        if (this.state.current_item !== null || this.props.pos_printer_queue.length == 0) return;
        if (this.ws.readyState != WebSocket.OPEN) return;
        let item = this.props.pos_printer_queue[0];
        console.log({
            op: 'PosPrinterWatcher.processQueue',
            item
        });
        if (item === undefined) {
            (0, _react1.Honeybadger).notify('PosPrinterWatcher, item is undefined', {
                name: 'Warning'
            });
            this.props.removeInvoiceFromPosPrinterQueue();
            return;
        }
        this.setState({
            current_item: item
        });
        let print_items = [];
        if (item.type == 'invoice') /*ErrorReportingHelper.ReportPosPrintInfo(
				JSON.stringify({ op: 'PosPrinterWatcher.processQueue: step 2', ts: (new Date()).toISOString(), id_invoice: item.invoice.id_invoice }),
				{ tags: 'pos_print, step_2, item_' + item.invoice.id_invoice }
			);*/ print_items = await this.generateInvoice(item.invoice);
        else if (item.type == 'activities') print_items = this.generateActivities(item.item, item.date, item.time_slot, item.activity_reservations);
        else if (item.type == 'available_invoices') print_items = this.generateAvailableAccommodations(item.grouped, item.from, item.to, item.language);
        else if (item.type == 'dsc_operative') print_items = this.generateDscOperative(item.date, item.stats);
        const settings_printer_name = (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__pos_printer_name');
        const settings_printer_width = (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__pos_printer_width');
        //console.log(print_items.filter(x => x !== null).join('\n'));
        console.log({
            op: 'PosPrinterWatcher.processQueue sending to helper'
        });
        console.log({
            ws_readyState: this.ws.readyState,
            print_items
        });
        if (this.ws.readyState == WebSocket.OPEN) {
            const msg = {
                Action: 'print',
                Data: JSON.stringify({
                    PrinterName: settings_printer_name == 'HTML' ? 'raw' : settings_printer_name,
                    PrinterWidth: settings_printer_width,
                    Contents: print_items.filter((x)=>x !== null).join('\n')
                })
            };
            this.ws.send(JSON.stringify(msg));
            console.log({
                op: 'PosPrinterWatcher.processQueue sent to helper',
                contents: msg
            });
        /*if (item.type == 'invoice') {
				ErrorReportingHelper.ReportPosPrintInfo(
					JSON.stringify({ op: 'PosPrinterWatcher.processQueue: step 4', ts: (new Date()).toISOString(), id_invoice: item.invoice.id_invoice }),
					{ tags: 'pos_print, step_4, item_' + item.invoice.id_invoice }
				);
			}*/ } else {
            // wait for connection
            this.setState({
                current_item: null
            });
            return;
        }
        if (!this.wait_for_remote_confirmation) {
            this.props.removeInvoiceFromPosPrinterQueue();
            this.setState({
                current_item: null
            });
        //this.processQueue();
        }
    }
    async generateInvoice(invoice) {
        console.log({
            op: 'PosPrinterWatcher.generateInvoice step 1'
        });
        if (invoice.id_invoice !== undefined) {
            invoice = await (0, _business.loadInvoice)(this.props.api_url, invoice.id_invoice, this.props.dispatch, this.props.token);
            invoice = {
                ...invoice,
                type: 'regular'
            };
        }
        console.log({
            op: 'PosPrinterWatcher.generateInvoice step 2'
        });
        // print
        console.log('printing POS');
        let print_items = [];
        if (invoice.type == 'test-width') print_items = this.generatePrintItemsForWidthTest(invoice);
        else print_items = await this.generatePrintItemsForInvoice(invoice);
        console.log({
            op: 'PosPrinterWatcher.generateInvoice step 3'
        });
        console.log({
            op: 'print items length',
            len: print_items.length
        });
        return print_items;
    }
    generateActivities(item, date, time_slot, activity_reservations) {
        console.log({
            item,
            date,
            time_slot,
            activity_reservations
        });
        let print_items = [];
        const printer_width = (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__pos_printer_width');
        for(let id_activity in activity_reservations){
            if (activity_reservations[id_activity].length == 0) continue;
            let activity_reservation = null;
            for(let i = 0; i < item.activities.length; i++)if (item.activities[i].key == id_activity) activity_reservation = item.activities[i];
            if (activity_reservation === null) continue;
            print_items.push('Tip rezervacije: ' + activity_reservation.title);
            print_items.push('<newline>');
            print_items.push('<newline>');
            const date_line = 'Datum: ' + (0, _momentDefault.default)(date).format('DD.MM.YYYY');
            print_items.push(date_line);
            print_items.push(('Termin ob: ' + item.time_label).padStart(printer_width - date_line.length));
            print_items.push('<newline>');
            print_items.push('<hr>');
            print_items.push('<newline>');
            const item_columns = [
                {
                    width: 0,
                    line1: 'Nosilec'
                },
                {
                    width: 7,
                    line1: "Dr\u017Eava"
                },
                {
                    width: 4,
                    line1: 'Pl.'
                },
                {
                    width: 7,
                    line1: 'Osebe'
                }
            ];
            item_columns[0].width = printer_width - item_columns[1].width - item_columns[2].width - item_columns[3].width;
            // add items column headers
            for(let i = 0; i < item_columns.length; i++){
                const width = item_columns[i].width;
                if (width == 0) continue;
                print_items.push(item_columns[i].line1.padEnd(width));
            }
            print_items.push('<newline>');
            print_items.push('<hr>');
            print_items.push('<newline>');
            let count = 0;
            for(let i = 0; i < activity_reservations[id_activity].length; i++){
                const reservation = activity_reservations[id_activity][i];
                const customer = this.props.customers[reservation.id_customer];
                let customer_name = customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name;
                if (customer_name.length > item_columns[0].width) customer_name = customer_name.substring(0, item_columns[0].width);
                const country = this.props.countries[customer.id_country];
                let country_title = country.iso_3166_1_a2;
                const paid = reservation.status == 'closed';
                print_items.push(customer_name.padEnd(item_columns[0].width));
                print_items.push(country_title.padEnd(item_columns[1].width));
                print_items.push((paid ? 'DA' : 'NE').padEnd(item_columns[2].width));
                print_items.push((reservation.guest_count + ' / ' + reservation.guest_child_count).padStart(item_columns[3].width));
                print_items.push('<newline>');
                if (customer.phone != '') {
                    print_items.push('   T: ' + customer.phone);
                    print_items.push('<newline>');
                }
                count += reservation.guest_count + reservation.guest_child_count;
            }
            print_items.push('<hr>');
            print_items.push('<newline>');
            print_items.push('Skupaj:'.padStart(printer_width - item_columns[3].width));
            print_items.push((count + '').padStart(item_columns[3].width));
            print_items.push('<newline>');
            print_items.push('<newline>');
            print_items.push('<newline>');
        }
        return print_items;
    }
    generateDscOperative(date, stats) {
        let print_items = [];
        const printer_width = (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__pos_printer_width');
        print_items.push('Plan dela za ' + (0, _momentDefault.default)(date).format('DD.MM.YYYY'));
        print_items.push('<newline>');
        print_items.push('<hr>');
        print_items.push('<newline>');
        for(let day_part_idx = 0; day_part_idx < 3; day_part_idx++)for(let id_activity in stats){
            const activity_stats = stats[id_activity];
            for (const day_part_key of [
                'day_parts',
                'day_parts_driver'
            ])if (activity_stats[day_part_key][day_part_idx] !== null && activity_stats[day_part_key][day_part_idx].length > 0) {
                print_items.push('I'.repeat(day_part_idx + 1) + '. ' + activity_stats.title + (day_part_key == 'day_parts' ? '' : " (\u0161ofer)"));
                print_items.push('<newline>');
                for(let i = 0; i < activity_stats[day_part_key][day_part_idx].length; i++){
                    print_items.push((activity_stats[day_part_key][day_part_idx][i].user_surname + ' ' + activity_stats[day_part_key][day_part_idx][i].user_name).trim());
                    print_items.push('<newline>');
                }
                print_items.push('<newline>');
            }
        }
        return print_items;
    }
    generateAvailableAccommodations(grouped, from, to, language) {
        const trans = {
            title: {
                'en': 'Available places',
                'sl': 'Prosta mesta',
                'de': "Freie Pl\xe4tze"
            },
            period: {
                'en': 'Period',
                'sl': 'Obdobje',
                'de': 'Zeitraum'
            }
        };
        let print_items = [];
        const printer_width = (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__pos_printer_width');
        print_items.push('<center>');
        print_items.push(trans.title[language]);
        print_items.push('<newline>');
        print_items.push('<newline>');
        print_items.push(trans.period[language] + ': ' + (0, _momentDefault.default)(from).format('DD.MM.') + ' - ' + (0, _momentDefault.default)(to).format('DD.MM.'));
        print_items.push('<newline>');
        print_items.push('<newline>');
        for(let id_accommodation in grouped){
            print_items.push(grouped[id_accommodation].accommodation.title);
            print_items.push('<newline>');
            for(let id_accommodation_item in grouped[id_accommodation].accommodation_items){
                const item = grouped[id_accommodation].accommodation_items[id_accommodation_item];
                if (item.accommodation_item.title != 'default') {
                    print_items.push(item.accommodation_item.title);
                    print_items.push('<newline>');
                }
                let line = '';
                for(let i = 0; i < item.accommodation_item_places.length; i++){
                    console.log({
                        accommodation_item_place: item.accommodation_item_places[i]
                    });
                    const title = item.accommodation_item_places[i].title + '   ';
                    if ((line + title).length > printer_width) {
                        print_items.push(line.trim());
                        print_items.push('<newline>');
                        line = '';
                    }
                    line += title;
                }
                line = line.trim();
                if (line.length > 0) print_items.push(line);
                print_items.push('<newline>');
                print_items.push('<hr>');
                print_items.push('<newline>');
            }
        }
        return print_items;
    }
    generatePrintItemsForWidthTest(item) {
        let line = '';
        for(let i = 0; i < item.width; i++)line += i % 10;
        return [
            line,
            '<newline>'
        ];
    }
    async generatePrintItemsForInvoice(invoice) {
        console.log({
            op: 'PosPrinterWatcher.generatePrintItemsForInvoice at start'
        });
        const general_settings = this.props.general_settings;
        const document_type = this.props.document_types[invoice.invoice_type];
        const invoice_fiscal_verification = invoice.id_invoice_fiscal_verification === null ? null : this.props.invoice_fiscal_verifications[invoice.id_invoice_fiscal_verification] || null;
        //TODO load invoice fiscal verification if it's not loaded yet
        let qr_value = null;
        if (invoice_fiscal_verification !== null && invoice_fiscal_verification.signed_zoi !== null) {
            qr_value = (0, _printDefault.default).BigNumberHexToDecimal(invoice_fiscal_verification.signed_zoi).padStart(39, '0') + invoice_fiscal_verification.tax_number + (0, _momentDefault.default)(invoice.issued).format('YYYYMMDDHHmmss');
            qr_value += (0, _printDefault.default).CalculateModulo10(qr_value);
        }
        const printer_width = (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__pos_printer_width');
        const itemOrEmpty = (value, condition)=>{
            if (condition === undefined) condition = value !== null && value.length > 0;
            if (!condition) return [];
            return [
                '<newline>',
                value
            ];
        };
        let customer_address = invoice.customer_address;
        if (customer_address !== null && customer_address !== undefined && customer_address.length > 0 && (invoice.customer_post_code.length > 0 || invoice.customer_post_office.length > 0)) {
            customer_address += ', ';
            customer_address += ((invoice.customer_post_code ?? '') + ' ' + (invoice.customer_post_office ?? '')).trim();
        }
        const cash_register = this.props.cash_registers[invoice.id_cash_register] || null;
        const business_premise = cash_register === null ? null : this.props.business_premises[cash_register.id_business_premise] || null;
        let place = '';
        if (business_premise !== null && business_premise.type == '1') place = business_premise.town;
        else place = general_settings.subject_city;
        let timestamp = (0, _momentDefault.default)(invoice.issued).format('DD.MM.YYYY \\o\\b HH:mm:ss');
        let place_with_time = '';
        if (place.length > 0) place_with_time += place + ', ';
        place_with_time += timestamp;
        const place_with_time_items = [];
        // if place + timestamp is too long, separate them into two lines
        if (place_with_time.length > printer_width) {
            if (place.length > 0) {
                place_with_time_items.push(place);
                place_with_time_items.push('<newline>');
            }
            place_with_time_items.push(timestamp);
            place_with_time_items.push('<newline>');
        } else {
            place_with_time_items.push(place_with_time);
            place_with_time_items.push('<newline>');
        }
        let customer_name = ((invoice.customer_name ?? '') + ' ' + (invoice.customer_surname ?? '')).trim();
        if (invoice.customer_type == 'company') {
            if (invoice.customer_display_company_long_name_on_invoices && invoice.customer_company_long_name.length > 0) customer_name = invoice.customer_company_long_name ?? '';
            else customer_name = invoice.customer_company_name ?? '';
        }
        const logo_width = printer_width <= 32 ? printer_width : Math.min(40, Math.round(0.9 * printer_width));
        let customer_data_items = [
            ...itemOrEmpty(customer_name.trim()),
            ...itemOrEmpty(customer_address),
            ...itemOrEmpty((invoice.customer_vat_registered ? 'ID za DDV: ' : "Dav\u010Dna \u0161t.: ") + invoice.customer_vat_prefix + invoice.customer_tax_number, ((invoice.customer_vat_prefix ?? '') + (invoice.customer_tax_number ?? '')).trim().length > 0)
        ];
        let print_items = [
            '<center>',
            general_settings.logo_pos === undefined || general_settings.logo_pos === null ? null : '<logo>',
            general_settings.logo_pos === undefined || general_settings.logo_pos === null ? null : logo_width,
            general_settings.logo_pos === undefined || general_settings.logo_pos === null ? null : general_settings.logo_pos,
            '<center>',
            ...itemOrEmpty(general_settings.subject_short_name),
            ...itemOrEmpty(general_settings.subject_address),
            ...itemOrEmpty((general_settings.subject_post_code + ' ' + general_settings.subject_city).trim()),
            ...itemOrEmpty((general_settings.subject_vat_registered ? 'ID za DDV: ' : "Dav\u010Dna \u0161t.: ") + general_settings.subject_tax_number, general_settings.subject_tax_number.length > 0),
            ...itemOrEmpty(((general_settings.subject_email.length == 0 ? '' : 'E: ' + general_settings.subject_email) + ' ' + (general_settings.subject_website.length == 0 ? '' : 'W: ' + general_settings.subject_website)).trim()),
            ...itemOrEmpty(((general_settings.subject_phone_1.length == 0 ? '' : 'T: ' + general_settings.subject_phone_1) + ' ' + (general_settings.subject_phone_2.length == 0 ? '' : 'M: ' + general_settings.subject_phone_2)).trim()),
            '<newline>',
            '<newline>',
            '<left>',
            '<enablebold>',
            '<newline>',
            "RA\u010CUN \u0160T.: " + invoice.invoice_number,
            '<disablebold>',
            '<newline>',
            ...itemOrEmpty('Podatki o stranki:', customer_data_items.length > 0),
            ...customer_data_items,
            ...itemOrEmpty('<newline>', customer_data_items.length > 0),
            '<newline>',
            ...place_with_time_items,
            '<hr>',
            '<newline>',
            "\u0160ifra".padEnd(8),
            'Opis',
            '<newline>'
        ];
        const item_columns = this.fitColumns(printer_width, [
            {
                min_width: 3,
                width: 0,
                line1: 'Kol',
                line2: ''
            },
            {
                min_width: 7,
                width: 0,
                line1: 'Cena',
                line2: 'z DDV'
            },
            {
                min_width: 6,
                width: 0,
                line1: 'Popust',
                line2: '%'
            },
            {
                min_width: 8,
                width: 0,
                line1: 'Vrednost',
                line2: 'br. DDV'
            },
            {
                min_width: 4,
                width: 0,
                line1: 'DDV',
                line2: '%'
            },
            {
                min_width: 8,
                width: 0,
                line1: 'Vrednost',
                line2: 'z DDV'
            }
        ]);
        // add invoice items column headers
        for(let line = 0; line < 2; line++){
            for(let i = 0; i < item_columns.length; i++){
                if (item_columns[i].width == 0) continue;
                const width = item_columns[i].width;
                let val = (line == 0 ? item_columns[i].line1 : item_columns[i].line2).padStart(width);
                // add spacing, but not for last item
                if (i < item_columns.length - 1 // not last item in array
                 && item_columns[i + 1].width > 0 // next item is visible
                ) val = val.padEnd(width + 1);
                print_items.push(val);
            }
            print_items.push('<newline>');
        }
        print_items.push('<hr>');
        print_items.push('<newline>');
        // add invoice items
        let tt_item_exists = false;
        for(let i = 0; i < invoice.items.length; i++){
            const invoice_item = invoice.items[i];
            const internal_code_width = 8;
            const title_width = printer_width - internal_code_width;
            if (invoice_item.item_internal_code.length < internal_code_width || invoice_item.item_title.length > title_width) {
                print_items.push(invoice_item.item_internal_code.padEnd(internal_code_width));
                print_items.push(invoice_item.item_title.padEnd(title_width).slice(0, title_width));
            } else {
                print_items.push(invoice_item.item_internal_code);
                print_items.push('<newline>');
                print_items.push(invoice_item.item_title);
            }
            print_items.push('<newline>');
            const columns = [
                this.formatNumber(invoice_item.quantity, 0),
                this.formatNumber(invoice_item.price, 2),
                this.formatNumber(invoice_item.discount, 2),
                this.formatNumber(invoice_item.quantity * invoice_item.price * (1 - invoice_item.discount / 100) / (1 + invoice_item.tax_rate / 100), 2),
                this.formatNumber(invoice_item.tax_rate, 1),
                this.formatNumber(invoice_item.quantity * invoice_item.price * (1 - invoice_item.discount / 100), 2)
            ];
            for(let j = 0; j < columns.length; j++){
                if (item_columns[j].width == 0) continue;
                const width = item_columns[j].width;
                let val = columns[j].padStart(width);
                // add spacing, but not for last item
                if (j < item_columns.length - 1 // not last item in array
                 && item_columns[j + 1].width > 0 // next item is visible
                ) val = val.padEnd(width + 1);
                print_items.push(val);
            }
            print_items.push('<newline>');
            if (invoice_item.item_type == 'tourist_tax') tt_item_exists = true;
        }
        let invoice_user = null;
        for(let id_user in this.props.users)if (this.props.users[id_user].username == invoice.username_creator) {
            invoice_user = this.props.users[id_user];
            break;
        }
        // taxes
        const { invoice_items_by_tax_rate, invoice_items_taxes_sums } = (0, _invoiceDefault.default).groupInvoiceItemsByTaxes(invoice, this.props.id_advance_invoice_consumption_by_id_consumer_invoices, this.props.advance_invoice_consumptions);
        print_items = print_items.concat([
            '<hr>',
            '<newline>'
        ]);
        if (invoice_items_taxes_sums[4] != 0) print_items = print_items.concat([
            'Vrednost brez DDV EUR'.padStart(printer_width - 10),
            this.formatNumber(invoice_items_taxes_sums[3], 2).padStart(10),
            '<newline>',
            'Popust EUR'.padStart(printer_width - 10),
            this.formatNumber(-invoice_items_taxes_sums[4], 2).padStart(10),
            '<newline>'
        ]);
        print_items = print_items.concat([
            "Dav\u010Dna osnova EUR".padStart(printer_width - 10),
            this.formatNumber(invoice_items_taxes_sums[0], 2).padStart(10),
            '<newline>',
            'Znesek davka EUR'.padStart(printer_width - 10),
            this.formatNumber(invoice_items_taxes_sums[1], 2).padStart(10),
            '<newline>',
            '<enablebold>',
            "Skupaj za pla\u010Dilo EUR".padStart(printer_width - 10),
            this.formatNumber(invoice_items_taxes_sums[2], 2).padStart(10),
            '<disablebold>',
            '<newline>',
            '<newline>',
            '<newline>'
        ]);
        if (Object.keys(invoice_items_by_tax_rate).length > 0) {
            const grouped_taxes_columns = this.fitColumns(printer_width, [
                {
                    min_width: 7,
                    width: 0,
                    value: 'Stopnja'
                },
                {
                    min_width: 9,
                    width: 0,
                    value: 'Osnova'
                },
                {
                    min_width: 9,
                    width: 0,
                    value: 'Davek'
                },
                {
                    min_width: 9,
                    width: 0,
                    value: 'Skupaj'
                }
            ]);
            // add grouped taxes column headers
            for(let i = 0; i < grouped_taxes_columns.length; i++){
                const width = grouped_taxes_columns[i].width;
                if (width == 0) continue;
                let val = grouped_taxes_columns[i].value.padStart(width);
                // add spacing, but not for last item
                if (i < grouped_taxes_columns.length - 1 // not last item in array
                 && grouped_taxes_columns[i + 1].width > 0 // next item is visible
                ) val = val.padEnd(width + 1);
                print_items.push(val);
            }
            print_items.push('<newline>');
            print_items.push('<hr>');
            print_items.push('<newline>');
            let taxes = [];
            let adjusted_tax_sums = [
                0,
                0,
                0
            ];
            const invoice_items_by_tax_rate_keys = Object.keys(invoice_items_by_tax_rate).sort((a, b)=>{
                if (parseFloat(a) < parseFloat(b)) return -1;
                if (parseFloat(a) > parseFloat(b)) return 1;
                return 0;
            });
            for(let i = 0; i < invoice_items_by_tax_rate_keys.length; i++){
                const key = invoice_items_by_tax_rate_keys[i];
                const tax_rate = parseFloat(invoice_items_by_tax_rate[key].tax_rate);
                const price = parseFloat(invoice_items_by_tax_rate[key].partial_price_discounted_without_tax);
                const tax_amount = parseFloat(invoice_items_by_tax_rate[key].partial_price_tax_amount);
                const total_amount = parseFloat(invoice_items_by_tax_rate[key].partial_price_discounted);
                adjusted_tax_sums[0] += price;
                adjusted_tax_sums[1] += tax_amount;
                adjusted_tax_sums[2] += total_amount;
                taxes.push([
                    key == -2 ? 'neobd.' : this.formatNumber(tax_rate, 1) + '%',
                    this.formatNumber(price, 2),
                    this.formatNumber(tax_amount, 2),
                    this.formatNumber(total_amount, 2)
                ]);
            }
            taxes.push([
                '',
                this.formatNumber(adjusted_tax_sums[0], 2),
                this.formatNumber(adjusted_tax_sums[1], 2),
                this.formatNumber(adjusted_tax_sums[2], 2)
            ]);
            for(let j = 0; j < taxes.length; j++){
                if (j == taxes.length - 1) {
                    print_items.push('<hr>');
                    print_items.push('<newline>');
                }
                for(let i = 0; i < grouped_taxes_columns.length; i++){
                    const width = grouped_taxes_columns[i].width;
                    if (width == 0) continue;
                    let val = taxes[j][i].padStart(width);
                    // add spacing, but not for last item
                    if (i < grouped_taxes_columns.length - 1 // not last item in array
                     && grouped_taxes_columns[i + 1].width > 0 // next item is visible
                    ) val = val.padEnd(width + 1);
                    print_items.push(val);
                }
                print_items.push('<newline>');
            }
        }
        // payment types
        let payment_types_sums = {};
        for(let i = 0; i < invoice.payments.length; i++){
            const invoice_payment = invoice.payments[i];
            const price = parseFloat(invoice_payment.amount);
            let key = invoice_payment.id_payment_type;
            if (payment_types_sums[key] === undefined) payment_types_sums[key] = {
                price: 0
            };
            payment_types_sums[key].price += price;
        }
        let payment_types = [];
        for(let key in payment_types_sums){
            const price = payment_types_sums[key].price;
            const payment_type = this.props.payment_types[key];
            payment_types.push(payment_type.title.padEnd(20));
            payment_types.push(this.formatNumber(price, 2).padStart(Math.min(12, printer_width - 24)));
            payment_types.push('<newline>');
        }
        if (invoice.advance_payment_amount != 0) {
            payment_types.push('Avans'.padEnd(20));
            payment_types.push(this.formatNumber(invoice.advance_payment_amount, 2).padStart(Math.min(12, printer_width - 24)));
            payment_types.push('<newline>');
            const advance_invoices = this.props.id_advance_invoice_consumption_by_id_consumer_invoices[invoice.id_invoice] ?? [];
            const advance_invoice_numbers = advance_invoices.map((x)=>this.props.invoices[this.props.advance_invoice_consumptions[x].advance_id_invoice].invoice_number);
            payment_types.push(advance_invoice_numbers.join(', '));
            payment_types.push('<newline>');
        }
        let qr_code = qr_value === null ? null : await (0, _qrcodeDefault.default).toDataURL(qr_value, {
            errorCorrectionLevel: 'M',
            version: 4
        });
        if (qr_code !== null && qr_code.indexOf('data:image/png;base64,') == 0) qr_code = qr_code.substring(22);
        print_items = print_items.concat([
            '<newline>',
            '<newline>',
            "Na\u010Din pla\u010Dila:",
            '<newline>',
            ...payment_types,
            '<newline>',
            ...itemOrEmpty('Blagajnik: ' + (invoice_user === null ? '' : (invoice_user.name + ' ' + (invoice_user.surname.length == 0 ? '' : invoice_user.surname.substring(0, 1) + '.')).trim()), invoice_user !== null),
            '<newline>',
            "Interna \u0161t.: " + invoice.invoice_number_internal,
            ...itemOrEmpty('Kopija: ' + invoice.copy_count, invoice.copy_count > 0),
            '<newline>',
            '<newline>',
            'ZOI: ' + (invoice_fiscal_verification === null ? '' : invoice_fiscal_verification.signed_zoi ?? ''),
            '<newline>',
            'EOR: ' + (invoice_fiscal_verification === null ? '' : invoice_fiscal_verification.eor ?? ''),
            '<newline>',
            '<newline>',
            '<center>',
            qr_code === null ? null : '<logo>',
            qr_code === null ? null : Math.min(16, printer_width),
            qr_code === null ? null : qr_code
        ]);
        // add VAT reason text
        if (general_settings.subject_vat_registered === false) {
            const vat_reason_items = [
                '<left>'
            ];
            const arr = (general_settings.subject_vat_registered_reason || '').split('\n');
            for(let i = 0; i < arr.length; i++){
                vat_reason_items.push('<newline>');
                vat_reason_items.push(arr[i]);
            }
            vat_reason_items.push('<newline>');
            print_items = print_items.concat(vat_reason_items);
        }
        // add tourist tax text
        if (tt_item_exists) {
            const tt_items = [
                '<left>'
            ];
            const arr = (general_settings.tourist_tax_text || '').split('\n');
            for(let i = 0; i < arr.length; i++){
                tt_items.push('<newline>');
                tt_items.push(arr[i]);
            }
            tt_items.push('<newline>');
            print_items = print_items.concat(tt_items);
        }
        // add final text
        if (document_type !== null && document_type !== undefined) {
            let print_final_text = document_type.print_final_text_pos;
            print_items.push('<left>');
            if (print_final_text !== null && print_final_text !== undefined) {
                const arr = print_final_text.split('\n');
                for(let i = 0; i < arr.length; i++){
                    print_items.push('<newline>');
                    if (arr[i] == '<right>') print_items.push('<right>');
                    else if (arr[i] == '</right>') print_items.push('<left>');
                    else print_items.push(arr[i]);
                }
            }
        }
        console.log({
            op: 'PosPrinterWatcher.generatePrintItemsForInvoice at end'
        });
        return print_items;
    }
    render() {
        return null;
    }
}
exports.default = (0, _reactRedux.connect)((state)=>{
    return {
        api_url: state.ConstantsSlice.api_url,
        ws_print_url: state.ConstantsSlice.ws_print_url,
        client: state.ConstantsSlice.client,
        pos_printer_queue: state.AppSlice.pos_printer_queue,
        general_settings: state.SettingsSlice.general,
        users: state.UserSlice.users,
        token: state.UserSlice.token,
        cash_registers: state.CashRegisterSlice.cash_registers,
        business_premises: state.CodeTablesSlice.business_premises,
        payment_types: state.CodeTablesSlice.payment_types,
        customers: state.CodeTablesSlice.customers,
        countries: state.CodeTablesSlice.countries,
        document_types: state.DocumentSlice.document_types,
        invoices: state.BusinessSlice.invoices,
        invoice_fiscal_verifications: state.BusinessSlice.invoice_fiscal_verifications,
        advance_invoice_consumptions: state.BusinessSlice.advance_invoice_consumptions,
        id_advance_invoice_consumption_by_id_consumer_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_consumer_invoices
    };
}, (dispatch)=>{
    return {
        dispatch,
        setPosPrinterConnectedStatus: (connected)=>dispatch((0, _appSlice.setPosPrinterConnectedStatus)({
                connected
            })),
        enqueueInvoiceOnPosPrinterQueue: (data)=>dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)(data)),
        requeueInvoiceOnPosPrinterQueue: (data)=>dispatch((0, _appSlice.requeueInvoiceOnPosPrinterQueue)(data)),
        removeInvoiceFromPosPrinterQueue: (data)=>dispatch((0, _appSlice.removeInvoiceFromPosPrinterQueue)(data)),
        setPrinters: (data)=>dispatch((0, _appSlice.setPrinters)({
                printers: data
            }))
    };
})(PosPrinterWatcher);

},{"react":"9njXz","react-redux":"5DyKE","moment":"1e4qG","qrcode":"6ja7x","@honeybadger-io/react":"jFoJ4","../slices/AppSlice":"aByTQ","../api/Business":"fC7Hd","../helpers/Print":"f3loA","../helpers/Invoice":"jffQW","../helpers/LocalStorageHelper":"9I9tm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ja7x":[function(require,module,exports,__globalThis) {
const canPromise = require("da1f68cc1fc16077");
const QRCode = require("8c6cf49ef2287430");
const CanvasRenderer = require("8a60cf7722cc14ce");
const SvgRenderer = require("f6fcc816b915ba37");
function renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !canPromise()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = QRCode.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = QRCode.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
exports.create = QRCode.create;
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);
// only svg for now.
exports.toString = renderCanvas.bind(null, function(data, _, opts) {
    return SvgRenderer.render(data, opts);
});

},{"da1f68cc1fc16077":"i071Y","8c6cf49ef2287430":"3cY97","8a60cf7722cc14ce":"ikCMf","f6fcc816b915ba37":"99yec"}],"i071Y":[function(require,module,exports,__globalThis) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};

},{}],"3cY97":[function(require,module,exports,__globalThis) {
const Utils = require("4cf6a8173d9f3a2");
const ECLevel = require("2ad62f61c352884c");
const BitBuffer = require("87d5a6270eb1dc26");
const BitMatrix = require("91abc94f777368cc");
const AlignmentPattern = require("9737c3939ab85d95");
const FinderPattern = require("cee3d371e219e45e");
const MaskPattern = require("8700c8c682afabf3");
const ECCode = require("65ad903a6ba3e");
const ReedSolomonEncoder = require("1e8e447afb4d169c");
const Version = require("8a4a19af97836d80");
const FormatInfo = require("26720f9d94c9e268");
const Mode = require("7b6429a248ecc51f");
const Segments = require("1368d0fa14524351");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = FinderPattern.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupAlignmentPattern(matrix, version) {
    const pos = AlignmentPattern.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = Version.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new BitBuffer();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = Utils.getSymbolTotalCodewords(version);
    const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = Utils.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new ReedSolomonEncoder(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = Segments.fromArray(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = Segments.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = Segments.fromString(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = Utils.getSymbolSize(version);
    const modules = new BitMatrix(moduleCount);
    // Add function modules
    setupFinderPattern(modules, version);
    setupTimingPattern(modules);
    setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) setupVersionInfo(modules, version);
    // Add data codewords
    setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules, setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    MaskPattern.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ exports.create = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = ECLevel.M;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M);
        version = Version.from(options.version);
        mask = MaskPattern.from(options.maskPattern);
        if (options.toSJISFunc) Utils.setToSJISFunction(options.toSJISFunc);
    }
    return createSymbol(data, version, errorCorrectionLevel, mask);
};

},{"4cf6a8173d9f3a2":"l1jBY","2ad62f61c352884c":"VarMN","87d5a6270eb1dc26":"i8FhJ","91abc94f777368cc":"hDcTA","9737c3939ab85d95":"4rjjI","cee3d371e219e45e":"1CmfA","8700c8c682afabf3":"3Thp5","65ad903a6ba3e":"edOY8","1e8e447afb4d169c":"jHt0G","8a4a19af97836d80":"dmpCD","26720f9d94c9e268":"61nPR","7b6429a248ecc51f":"73Yiq","1368d0fa14524351":"eKB3B"}],"l1jBY":[function(require,module,exports,__globalThis) {
let toSJISFunction;
const CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ exports.getSymbolSize = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ exports.getSymbolTotalCodewords = function getSymbolTotalCodewords(version) {
    return CODEWORDS_COUNT[version];
};
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ exports.getBCHDigit = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
exports.setToSJISFunction = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    toSJISFunction = f;
};
exports.isKanjiModeEnabled = function() {
    return typeof toSJISFunction !== 'undefined';
};
exports.toSJIS = function toSJIS(kanji) {
    return toSJISFunction(kanji);
};

},{}],"VarMN":[function(require,module,exports,__globalThis) {
exports.L = {
    bit: 1
};
exports.M = {
    bit: 0
};
exports.Q = {
    bit: 3
};
exports.H = {
    bit: 2
};
function fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return exports.L;
        case 'm':
        case 'medium':
            return exports.M;
        case 'q':
        case 'quartile':
            return exports.Q;
        case 'h':
        case 'high':
            return exports.H;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
exports.isValid = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) return value;
    try {
        return fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

},{}],"i8FhJ":[function(require,module,exports,__globalThis) {
function BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = BitBuffer;

},{}],"hDcTA":[function(require,module,exports,__globalThis) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = BitMatrix;

},{}],"4rjjI":[function(require,module,exports,__globalThis) {
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ const getSymbolSize = require("3fa093180e62a22a").getSymbolSize;
/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ exports.getRowColCoords = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ exports.getPositions = function getPositions(version) {
    const coords = [];
    const pos = exports.getRowColCoords(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

},{"3fa093180e62a22a":"l1jBY"}],"1CmfA":[function(require,module,exports,__globalThis) {
const getSymbolSize = require("6ec9ae5660047293").getSymbolSize;
const FINDER_PATTERN_SIZE = 7;
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ exports.getPositions = function getPositions(version) {
    const size = getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - FINDER_PATTERN_SIZE
        ]
    ];
};

},{"6ec9ae5660047293":"l1jBY"}],"3Thp5":[function(require,module,exports,__globalThis) {
/**
 * Data mask pattern reference
 * @type {Object}
 */ exports.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ exports.isValid = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ exports.from = function from(value) {
    return exports.isValid(value) ? parseInt(value, 10) : undefined;
};
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ exports.getPenaltyN1 = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ exports.getPenaltyN2 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * PenaltyScores.N2;
};
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ exports.getPenaltyN3 = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * PenaltyScores.N3;
};
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ exports.getPenaltyN4 = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case exports.Patterns.PATTERN000:
            return (i + j) % 2 === 0;
        case exports.Patterns.PATTERN001:
            return i % 2 === 0;
        case exports.Patterns.PATTERN010:
            return j % 3 === 0;
        case exports.Patterns.PATTERN011:
            return (i + j) % 3 === 0;
        case exports.Patterns.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case exports.Patterns.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case exports.Patterns.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case exports.Patterns.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ exports.applyMask = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, getMaskAt(pattern, row, col));
    }
};
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ exports.getBestMask = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys(exports.Patterns).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        exports.applyMask(p, data);
        // Calculate penalty
        const penalty = exports.getPenaltyN1(data) + exports.getPenaltyN2(data) + exports.getPenaltyN3(data) + exports.getPenaltyN4(data);
        // Undo previously applied mask
        exports.applyMask(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

},{}],"edOY8":[function(require,module,exports,__globalThis) {
const ECLevel = require("7baaa530584d1bc4");
const EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ exports.getBlocksCount = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case ECLevel.L:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case ECLevel.M:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case ECLevel.Q:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case ECLevel.H:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ exports.getTotalCodewordsCount = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case ECLevel.L:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case ECLevel.M:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case ECLevel.Q:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case ECLevel.H:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

},{"7baaa530584d1bc4":"VarMN"}],"jHt0G":[function(require,module,exports,__globalThis) {
const Polynomial = require("742a7ee6d6a2d145");
function ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = Polynomial.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = Polynomial.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = ReedSolomonEncoder;

},{"742a7ee6d6a2d145":"fSiR6"}],"fSiR6":[function(require,module,exports,__globalThis) {
const GF = require("780c74029318268c");
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ exports.mul = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= GF.mul(p1[i], p2[j]);
    return coeff;
};
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ exports.mod = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= GF.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ exports.generateECPolynomial = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = exports.mul(poly, new Uint8Array([
        1,
        GF.exp(i)
    ]));
    return poly;
};

},{"780c74029318268c":"7nz4i"}],"7nz4i":[function(require,module,exports,__globalThis) {
const EXP_TABLE = new Uint8Array(512);
const LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        EXP_TABLE[i] = x;
        LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)EXP_TABLE[i] = EXP_TABLE[i - 255];
})();
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ exports.log = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return LOG_TABLE[n];
};
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ exports.exp = function exp(n) {
    return EXP_TABLE[n];
};
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ exports.mul = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]];
};

},{}],"dmpCD":[function(require,module,exports,__globalThis) {
const Utils = require("f67b02cdf61cb7c6");
const ECCode = require("777da0d92c463f2e");
const ECLevel = require("acd5b4fcd696edf3");
const Mode = require("5303c314c4a688d7");
const VersionCheck = require("663d0e03da8b2897");
// Generator polynomial used to encode version information
const G18 = 7973;
const G18_BCH = Utils.getBCHDigit(G18);
function getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return Mode.getCharCountIndicator(mode, version) + 4;
}
function getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) return currentVersion;
    }
    return undefined;
}
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ exports.from = function from(value, defaultValue) {
    if (VersionCheck.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ exports.getCapacity = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!VersionCheck.isValid(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = Mode.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = Utils.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === Mode.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case Mode.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case Mode.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case Mode.KANJI:
            return Math.floor(usableBits / 13);
        case Mode.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ exports.getBestVersionForData = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ exports.getEncodedBits = function getEncodedBits(version) {
    if (!VersionCheck.isValid(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while(Utils.getBCHDigit(d) - G18_BCH >= 0)d ^= G18 << Utils.getBCHDigit(d) - G18_BCH;
    return version << 12 | d;
};

},{"f67b02cdf61cb7c6":"l1jBY","777da0d92c463f2e":"edOY8","acd5b4fcd696edf3":"VarMN","5303c314c4a688d7":"73Yiq","663d0e03da8b2897":"krwLI"}],"73Yiq":[function(require,module,exports,__globalThis) {
const VersionCheck = require("488660fac9162579");
const Regex = require("a23fd227d32f3622");
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ exports.NUMERIC = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ exports.ALPHANUMERIC = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ exports.BYTE = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ exports.KANJI = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ exports.MIXED = {
    bit: -1
};
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ exports.getCharCountIndicator = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!VersionCheck.isValid(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ exports.getBestModeForData = function getBestModeForData(dataStr) {
    if (Regex.testNumeric(dataStr)) return exports.NUMERIC;
    else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC;
    else if (Regex.testKanji(dataStr)) return exports.KANJI;
    else return exports.BYTE;
};
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ exports.toString = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ exports.isValid = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return exports.NUMERIC;
        case 'alphanumeric':
            return exports.ALPHANUMERIC;
        case 'kanji':
            return exports.KANJI;
        case 'byte':
            return exports.BYTE;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) return value;
    try {
        return fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

},{"488660fac9162579":"krwLI","a23fd227d32f3622":"bPpcW"}],"krwLI":[function(require,module,exports,__globalThis) {
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ exports.isValid = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

},{}],"bPpcW":[function(require,module,exports,__globalThis) {
const numeric = '[0-9]+';
const alphanumeric = '[A-Z $%*+\\-./:]+';
let kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
kanji = kanji.replace(/u/g, '\\u');
const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+';
exports.KANJI = new RegExp(kanji, 'g');
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
exports.BYTE = new RegExp(byte, 'g');
exports.NUMERIC = new RegExp(numeric, 'g');
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g');
const TEST_KANJI = new RegExp('^' + kanji + '$');
const TEST_NUMERIC = new RegExp('^' + numeric + '$');
const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
exports.testKanji = function testKanji(str) {
    return TEST_KANJI.test(str);
};
exports.testNumeric = function testNumeric(str) {
    return TEST_NUMERIC.test(str);
};
exports.testAlphanumeric = function testAlphanumeric(str) {
    return TEST_ALPHANUMERIC.test(str);
};

},{}],"61nPR":[function(require,module,exports,__globalThis) {
const Utils = require("eeca831a42e85d6c");
const G15 = 1335;
const G15_MASK = 21522;
const G15_BCH = Utils.getBCHDigit(G15);
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ exports.getEncodedBits = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while(Utils.getBCHDigit(d) - G15_BCH >= 0)d ^= G15 << Utils.getBCHDigit(d) - G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ G15_MASK;
};

},{"eeca831a42e85d6c":"l1jBY"}],"eKB3B":[function(require,module,exports,__globalThis) {
const Mode = require("45f6d4bff9d2fc72");
const NumericData = require("73109cbf4f3c309d");
const AlphanumericData = require("5320016e34c30467");
const ByteData = require("fd16f8f25b581951");
const KanjiData = require("8a7b84039f1cf0d2");
const Regex = require("79379a3a8f3c26bb");
const Utils = require("66903ca51bd2ea1d");
const dijkstra = require("3b9f47d541e7d71f");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function getSegmentsFromString(dataStr) {
    const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr);
    const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if (Utils.isKanjiModeEnabled()) {
        byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr);
        kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr);
    } else {
        byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function getSegmentBitsLength(length, mode) {
    switch(mode){
        case Mode.NUMERIC:
            return NumericData.getBitsLength(length);
        case Mode.ALPHANUMERIC:
            return AlphanumericData.getBitsLength(length);
        case Mode.KANJI:
            return KanjiData.getBitsLength(length);
        case Mode.BYTE:
            return ByteData.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case Mode.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case Mode.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case Mode.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: getStringByteLength(seg.data)
                    }
                ]);
                break;
            case Mode.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) + 4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = Mode.getBestModeForData(data);
    mode = Mode.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== Mode.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + Mode.toString(mode) + '.\n Suggested mode is: ' + Mode.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) mode = Mode.BYTE;
    switch(mode){
        case Mode.NUMERIC:
            return new NumericData(data);
        case Mode.ALPHANUMERIC:
            return new AlphanumericData(data);
        case Mode.KANJI:
            return new KanjiData(data);
        case Mode.BYTE:
            return new ByteData(data);
    }
}
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ exports.fromArray = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push(buildSingleSegment(seg, null));
        else if (seg.data) acc.push(buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ exports.fromString = function fromString(data, version) {
    const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled());
    const nodes = buildNodes(segs);
    const graph = buildGraph(nodes, version);
    const path = dijkstra.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return exports.fromArray(mergeSegments(optimizedSegs));
};
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ exports.rawSplit = function rawSplit(data) {
    return exports.fromArray(getSegmentsFromString(data, Utils.isKanjiModeEnabled()));
};

},{"45f6d4bff9d2fc72":"73Yiq","73109cbf4f3c309d":"7oI3F","5320016e34c30467":"asBTI","fd16f8f25b581951":"e97jW","8a7b84039f1cf0d2":"7mZmA","79379a3a8f3c26bb":"bPpcW","66903ca51bd2ea1d":"l1jBY","3b9f47d541e7d71f":"dgzN5"}],"7oI3F":[function(require,module,exports,__globalThis) {
const Mode = require("29134b0b0820b091");
function NumericData(data) {
    this.mode = Mode.NUMERIC;
    this.data = data.toString();
}
NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
NumericData.prototype.getBitsLength = function getBitsLength() {
    return NumericData.getBitsLength(this.data.length);
};
NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = NumericData;

},{"29134b0b0820b091":"73Yiq"}],"asBTI":[function(require,module,exports,__globalThis) {
const Mode = require("9c7c9b869570f846");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function AlphanumericData(data) {
    this.mode = Mode.ALPHANUMERIC;
    this.data = data;
}
AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return AlphanumericData.getBitsLength(this.data.length);
};
AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = AlphanumericData;

},{"9c7c9b869570f846":"73Yiq"}],"e97jW":[function(require,module,exports,__globalThis) {
const Mode = require("a20a51f6cd184253");
function ByteData(data) {
    this.mode = Mode.BYTE;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
ByteData.prototype.getBitsLength = function getBitsLength() {
    return ByteData.getBitsLength(this.data.length);
};
ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = ByteData;

},{"a20a51f6cd184253":"73Yiq"}],"7mZmA":[function(require,module,exports,__globalThis) {
const Mode = require("b935cfd1cd03a1f6");
const Utils = require("ca4944585cc8d12d");
function KanjiData(data) {
    this.mode = Mode.KANJI;
    this.data = data;
}
KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
KanjiData.prototype.getBitsLength = function getBitsLength() {
    return KanjiData.getBitsLength(this.data.length);
};
KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = Utils.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = KanjiData;

},{"b935cfd1cd03a1f6":"73Yiq","ca4944585cc8d12d":"l1jBY"}],"dgzN5":[function(require,module,exports,__globalThis) {
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
        return dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = dijkstra;

},{}],"ikCMf":[function(require,module,exports,__globalThis) {
const Utils = require("5b3f7c513802d6c7");
function clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
exports.render = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = getCanvasElement();
    opts = Utils.getOptions(opts);
    const size = Utils.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    Utils.qrToImageData(image.data, qrData, opts);
    clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
exports.renderToDataURL = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = exports.render(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

},{"5b3f7c513802d6c7":"2MRtf"}],"2MRtf":[function(require,module,exports,__globalThis) {
function hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
exports.getOptions = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: hex2rgba(options.color.dark || '#000000ff'),
            light: hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
exports.getScale = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
exports.getImageWidth = function getImageWidth(qrSize, opts) {
    const scale = exports.getScale(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
exports.qrToImageData = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = exports.getScale(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

},{}],"99yec":[function(require,module,exports,__globalThis) {
const Utils = require("c36bbcf663291acc");
function getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? svgCmd('M', col + margin, 0.5 + row + margin) : svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
exports.render = function render(qrData, options, cb) {
    const opts = Utils.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + getColorAttrib(opts.color.dark, 'stroke') + ' d="' + qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};

},{"c36bbcf663291acc":"2MRtf"}],"f3loA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    OpenPrint: (title, contents)=>{
        const print_window = window.open('/print.html');
        print_window.focus();
        print_window.addEventListener('load', ()=>{
            print_window.postMessage({
                type: 'loadDocument',
                data: {
                    title,
                    contents
                }
            });
            print_window.postMessage({
                type: 'print'
            });
        }, true);
    },
    // from https://stackoverflow.com/questions/16965915
    BigNumberHexToDecimal: (hex)=>{
        let dec = [];
        const hex_len = hex.length;
        for(let h = 0; h < hex_len; h++){
            let carry = parseInt(hex[h], 16);
            for(let i = 0; i < dec.length; i++){
                const val = dec[i] * 16 + carry;
                dec[i] = val % 10;
                carry = Math.floor(val / 10);
            }
            while(carry > 0){
                dec.push(carry % 10);
                carry = Math.floor(carry / 10);
            }
        }
        return dec.reverse().join('');
    },
    // translated from https://github.com/MPrtenjak/SLOTax/blob/master/SharedService/Modulo/Modulo10_Easy.cs
    CalculateModulo10: (value)=>{
        let sum = 0;
        for(let i = 0; i < value.length; i++)sum += parseInt(value[i], 10);
        return sum % 10;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Z4Ol":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _server = require("react-dom/server");
var _serverDefault = parcelHelpers.interopDefault(_server);
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _appSlice = require("../slices/AppSlice");
var _business = require("../api/Business");
var _invoice = require("../printing/a4/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _journal = require("../printing/a4/Journal");
var _journalDefault = parcelHelpers.interopDefault(_journal);
var _cashRegisterDocument = require("../printing/a4/CashRegisterDocument");
var _cashRegisterDocumentDefault = parcelHelpers.interopDefault(_cashRegisterDocument);
var _acquisition = require("../printing/a4/Acquisition");
var _acquisitionDefault = parcelHelpers.interopDefault(_acquisition);
var _deliveryNote = require("../printing/a4/DeliveryNote");
var _deliveryNoteDefault = parcelHelpers.interopDefault(_deliveryNote);
var _localStorageHelper = require("../helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
var _constants = require("../constants");
class A4PrinterWatcher extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            current_item: null,
            wait_for_remote_confirmation: false
        };
        this.init = this.init.bind(this);
        this.cleanup = this.cleanup.bind(this);
        this.processQueue = this.processQueue.bind(this);
        this.printInvoice = this.printInvoice.bind(this);
        this.printJournal = this.printJournal.bind(this);
        this.printJournalState = this.printJournalState.bind(this);
        this.printJournalSummary = this.printJournalSummary.bind(this);
        this.printJournalInternal = this.printJournalInternal.bind(this);
        this.printCashRegisterDocument = this.printCashRegisterDocument.bind(this);
        this.printDeliveryNote = this.printDeliveryNote.bind(this);
    }
    componentWillUnmount() {
        this.cleanup();
    }
    init() {
        console.log('init a4 print ws');
        const ws = new WebSocket(this.props.ws_print_url);
        ws.onmessage = (event)=>{
            console.log({
                event
            });
            const data = JSON.parse(event.data);
            if (data.Action == 'version') {
                const version = parseInt(data.Data, 10);
                if (version >= 1002) this.setState({
                    wait_for_remote_confirmation: true
                });
            } else if (data.Action == 'completed-convert-to-pdf-and-open') {
                this.props.removeInvoiceFromA4PrinterQueue();
                /*ErrorReportingHelper.ReportA4PrintInfo(
					JSON.stringify({ op: 'A4PrinterWatcher.processQueue: step finished', ts: (new Date()).toISOString(), id_invoice: item.id_invoice }),
					{ tags: 'a4_print, step_finished, item_' + item.id_invoice }
				);*/ this.setState({
                    current_item: null
                });
                this.processQueue();
            }
        };
        ws.onopen = (event)=>{
            this.props.setA4PrinterConnectedStatus(true);
            if (ws.readyState == WebSocket.OPEN) {
                ws.send(JSON.stringify({
                    Action: 'get-printers',
                    Data: ''
                }));
                ws.send(JSON.stringify({
                    Action: 'get-version',
                    Data: ''
                }));
            }
        };
        ws.onclose = (event)=>{
            this.props.setA4PrinterConnectedStatus(false);
            setTimeout(()=>{
                this.ws = this.init();
            }, 5000);
        };
        return ws;
    }
    cleanup() {
        if (this.ws !== undefined && this.ws !== null) {
            // prevent auto reconnect
            this.ws.onclose = (event)=>{};
            this.ws.close();
            this.props.setA4PrinterConnectedStatus(false);
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.ws_print_url != prevProps.ws_print_url) {
            this.cleanup();
            this.ws = this.init();
        }
        console.log(JSON.stringify(this.props.a4_printer_queue));
        if (this.props.a4_printer_queue != prevProps.a4_printer_queue) this.processQueue();
    }
    componentDidMount() {
        if (this.props.ws_print_url !== null) this.ws = this.init();
    }
    formatNumber(val, decimal_digit_count) {
        decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
        let rounded_val = Math.properRound(parseFloat(val), decimal_digit_count);
        return rounded_val.toLocaleString(undefined, {
            minimumFractionDigits: decimal_digit_count,
            maximumFractionDigits: decimal_digit_count
        });
    }
    async processQueue() {
        console.log('processQueue: queue length is ' + this.props.a4_printer_queue.length);
        if (this.state.current_item !== null || this.props.a4_printer_queue.length == 0) return;
        let item_data = this.props.a4_printer_queue[0];
        if (item_data.type == 'invoice') await this.printInvoice(item_data);
        else if (item_data.type == 'journal') await this.printJournal(item_data);
        else if (item_data.type == 'journal-state') await this.printJournalState(item_data);
        else if (item_data.type == 'journal-summary') await this.printJournalSummary(item_data);
        else if (item_data.type == 'cash-register-document') await this.printCashRegisterDocument(item_data);
        else if (item_data.type == 'acquisition') await this.printAcquisition(item_data);
        else if (item_data.type == 'delivery-note') await this.printDeliveryNote(item_data);
        if (!this.state.wait_for_remote_confirmation) {
            this.props.removeInvoiceFromA4PrinterQueue();
            this.setState({
                current_item: null
            });
        //this.processQueue();
        }
    }
    async getPrintHTML(type, html) {
        let result;
        result = await fetch(location.origin + '/print/print_template_a4_v6.html');
        result = await result.text();
        result = result.replaceAll('%CLASS%', type);
        result = result.replaceAll('%HTML%', html);
        result = result.replaceAll('"/print', '"' + window.location.protocol + '//' + window.location.host + '/print');
        return result;
    }
    async printInvoice(item_data) {
        let invoice_lang = item_data.lang;
        let invoice = item_data.invoice;
        invoice = await (0, _business.loadInvoice)(this.props.api_url, invoice.id_invoice, this.props.dispatch, this.props.token);
        this.setState({
            current_item: invoice
        });
        /*ErrorReportingHelper.ReportA4PrintInfo(
			JSON.stringify({ op: 'A4PrinterWatcher.processQueue: step 2', ts: (new Date()).toISOString(), id_invoice: invoice.id_invoice }),
			{ tags: 'a4_print, step_2, item_' + invoice.id_invoice }
		);*/ // print
        console.log('printing');
        const general_settings = this.props.general_settings;
        const cash_register = this.props.cash_registers[invoice.id_cash_register] || null;
        const business_premise = cash_register === null ? null : this.props.business_premises[cash_register.id_business_premise] || null;
        const document_type = this.props.document_types[invoice.invoice_type];
        const invoice_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _invoiceDefault.default), {
            company_data: {
                subject_type: general_settings.subject_type,
                subject_short_name: general_settings.subject_short_name,
                subject_long_name: general_settings.subject_long_name,
                subject_address: general_settings.subject_address,
                subject_post_code: general_settings.subject_post_code,
                subject_city: general_settings.subject_city,
                subject_email: general_settings.subject_email,
                subject_website: general_settings.subject_website,
                subject_phone_1: general_settings.subject_phone_1,
                subject_phone_2: general_settings.subject_phone_2,
                subject_trr_1: general_settings.subject_trr_1,
                subject_trr_2: general_settings.subject_trr_2,
                subject_tax_number: general_settings.subject_tax_number,
                subject_vat_registered: general_settings.subject_vat_registered,
                subject_vat_number: general_settings.subject_vat_number,
                subject_registration_number: general_settings.subject_registration_number,
                logo: general_settings.logo
            },
            item: invoice,
            business_premise: business_premise,
            payment_types: this.props.payment_types,
            id_advance_invoice_consumption_by_id_consumer_invoices: this.props.id_advance_invoice_consumption_by_id_consumer_invoices,
            invoices: this.props.invoices,
            advance_invoice_consumptions: this.props.advance_invoice_consumptions,
            users: this.props.users,
            invoice_fiscal_verifications: this.props.invoice_fiscal_verifications,
            customer_country: invoice.customer_id_country === null ? null : this.props.countries[invoice.customer_id_country],
            settings: {
                footer: general_settings.footer,
                tourist_tax_text: general_settings.tourist_tax_text,
                subject_vat_registered: general_settings.subject_vat_registered,
                subject_vat_registered_reason: general_settings.subject_vat_registered_reason,
                print_footer_a4: general_settings.print_footer_a4,
                print_final_text: document_type === undefined ? '' : document_type.print_final_text,
                print_final_text_en: document_type === undefined ? '' : document_type.print_final_text_en,
                print_final_text_de: document_type === undefined ? '' : document_type.print_final_text_de,
                logo_position: document_type === undefined ? 'right' : document_type.logo_position
            },
            lang: invoice_lang,
            document_type: document_type
        });
        let html = (0, _serverDefault.default).renderToStaticMarkup(invoice_element);
        console.log({
            html
        });
        html = await this.getPrintHTML('invoice', html);
        /*ErrorReportingHelper.ReportA4PrintInfo(
			JSON.stringify({ op: 'A4PrinterWatcher.processQueue: step 3', ts: (new Date()).toISOString(), id_invoice: invoice.id_invoice }),
			{ tags: 'a4_print, step_3, item_' + invoice.id_invoice }
		);*/ const print_preview = (0, _constants.ENVIRONMENT) == 'development';
        if (print_preview) {
            //const win = window.open('/print/print_template_a4.html?v=6', 'Title');
            const win = window.open('', 'Title');
            if (win === null || win === undefined) //TODO display a message saying to allow popups
            console.log('NOT ALLOWED');
            else win.document.body.innerHTML = html;
            this.props.removeInvoiceFromA4PrinterQueue();
            this.setState({
                current_item: null
            });
        //this.processQueue();
        }
        //console.log(print_items.filter(x => x !== null).join('\n'));
        if (!print_preview && this.ws.readyState == WebSocket.OPEN) {
            const type_names = {
                'cash-invoice': 'Racun',
                'cash-prepayment-invoice': 'Racun za predplacilo',
                'offer': 'Ponudba',
                'invoice': 'Faktura',
                'prepayment-invoice': 'Avansni racun'
            };
            const name_prefix = type_names[invoice.invoice_type] || '';
            const name_postfix = invoice_lang == 'sl' ? '' : invoice_lang.toUpperCase();
            /*ErrorReportingHelper.ReportA4PrintInfo(
				JSON.stringify({ op: 'A4PrinterWatcher.processQueue: step 4', ts: (new Date()).toISOString(), id_invoice: invoice.id_invoice }),
				{ tags: 'a4_print, step_4, item_' + invoice.id_invoice }
			);*/ this.ws.send(JSON.stringify({
                Action: 'convert-to-pdf-and-open',
                Data: JSON.stringify({
                    Html: html,
                    Path: (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__save_path'),
                    InvoiceNumber: (name_prefix + ' ' + invoice.invoice_number + ' ' + name_postfix).trim() + (invoice.copy_count < 1 ? '' : ' kopija ' + invoice.copy_count)
                })
            }));
        }
    }
    async printJournal(item_data) {
        const item_lang = item_data.lang;
        const item = item_data.item;
        const id_cash_register = item_data.id_cash_register;
        const cash_register = this.props.cash_registers[id_cash_register] || null;
        const documents = Object.values(this.props.cash_register_documents).filter((x)=>x.id_cash_register_daily_state === item.id_cash_register_daily_state);
        const documents_for_advance_payments = documents;
        const general_settings = this.props.general_settings;
        const filename = 'Blagajniski dnevnik_' + general_settings.subject_tax_number + '_' + item.document_number + '_' + (0, _momentDefault.default)(item.document_date).format('DDMMYY');
        const document_number = item.document_number;
        const last_document_number = null;
        const start_document_date = item.document_date;
        const end_document_date = null;
        const start_balance = item.start_balance;
        const end_balance = item.end_balance;
        await this.printJournalInternal([
            {
                document_number,
                last_document_number,
                start_document_date,
                end_document_date,
                start_balance,
                end_balance,
                cash_register,
                documents,
                documents_for_advance_payments
            }
        ], item_lang, true, filename, false);
    }
    async printJournalState(item_data) {
        const item_lang = item_data.lang;
        const ids = item_data.ids;
        const id_cash_register = item_data.id_cash_register;
        const cash_register = this.props.cash_registers[id_cash_register] || null;
        const documents = Object.values(this.props.cash_register_documents).filter((x)=>ids.indexOf(x.id_cash_register_document) != -1).sort((a, b)=>a.document_date > b.document_date ? 1 : a.document_date < b.document_date ? -1 : 0);
        const documents_for_advance_payments = documents;
        console.log({
            ids,
            documents
        });
        const document_number = null;
        const last_document_number = null;
        const start_document_date = documents.length < 1 ? null : documents[0].document_date;
        const end_document_date = documents.length < 2 ? null : documents[documents.length - 1].document_date;
        const start_balance = 0;
        const end_balance = 0;
        const general_settings = this.props.general_settings;
        const filename = 'Stanje blagajne_' + general_settings.subject_tax_number + '_' + this.props.cash_registers[id_cash_register].title + '_' + (0, _momentDefault.default)().format('DDMMYY');
        await this.printJournalInternal([
            {
                document_number,
                last_document_number,
                start_document_date,
                end_document_date,
                start_balance,
                end_balance,
                cash_register,
                documents,
                documents_for_advance_payments
            }
        ], item_lang, true, filename, true);
    }
    async printJournalSummary(item_data) {
        const item_lang = item_data.lang;
        const item_items = [
            ...item_data.items
        ];
        const display_detailed_list = item_data.display_detailed_list;
        const one_page = item_data.one_page;
        const id_cash_register = item_data.id_cash_register;
        item_items.sort((a, b)=>a.document_date < b.document_date ? -1 : a.document_date > b.document_date ? 1 : 0);
        const pages = [];
        const general_settings = this.props.general_settings;
        let filename = '';
        if (one_page) {
            for(let idx = 0; idx < item_items.length; idx++){
                const items = [
                    item_items[idx]
                ].sort((a, b)=>a.document_date > b.document_date ? 1 : a.document_date < b.document_date ? -1 : 0);
                const ids = items.map((item)=>item.id_cash_register_daily_state);
                const documents = Object.values(this.props.cash_register_documents).filter((x)=>ids.indexOf(x.id_cash_register_daily_state) != -1).sort((a, b)=>a.document_date > b.document_date ? 1 : a.document_date < b.document_date ? -1 : 0);
                const documents_for_advance_payments = documents;
                if (items.length > 0) pages.push({
                    document_number: items.length < 1 ? null : items[0].document_number,
                    last_document_number: null,
                    start_document_date: items.length < 1 ? null : items[0].document_date,
                    end_document_date: null,
                    start_balance: items.length < 1 ? null : items[0].start_balance,
                    end_balance: null,
                    cash_register: this.props.cash_registers[id_cash_register],
                    documents,
                    documents_for_advance_payments
                });
            }
            if (pages.length > 0) filename = "Dnevni iztr\u017Eki_" + general_settings.subject_tax_number + '_' + this.props.cash_registers[id_cash_register].title + '_' + (0, _momentDefault.default)(pages[0].start_document_date).format('DD.MM.YYYY') + '-' + (0, _momentDefault.default)(pages[pages.length - 1].start_document_date).format('DD.MM.YYYY') + '_sumarno' + (display_detailed_list ? '_podrobno' : '');
        } else {
            const items = [
                ...item_items
            ].sort((a, b)=>a.document_date > b.document_date ? 1 : a.document_date < b.document_date ? -1 : 0);
            const ids = items.map((item)=>item.id_cash_register_daily_state);
            const documents = Object.values(this.props.cash_register_documents).filter((x)=>ids.indexOf(x.id_cash_register_daily_state) != -1).sort((a, b)=>a.document_date > b.document_date ? 1 : a.document_date < b.document_date ? -1 : 0);
            const documents_for_advance_payments = documents;
            if (items.length > 0) {
                filename = 'Zbirnik_' + general_settings.subject_tax_number + '_' + this.props.cash_registers[items[0].id_cash_register].title + '_' + (0, _momentDefault.default)(items[0].document_date).format('DD.MM.YYYY') + '-' + (0, _momentDefault.default)(items[items.length - 1].document_date).format('DD.MM.YYYY') + (display_detailed_list ? '_podrobno' : '');
                pages.push({
                    document_number: items.length < 1 ? null : items[0].document_number,
                    last_document_number: items.length < 2 ? null : items[items.length - 1].document_number,
                    start_document_date: items.length < 1 ? null : items[0].document_date,
                    end_document_date: items.length < 2 ? null : items[items.length - 1].document_date,
                    start_balance: items.length < 1 ? null : items[0].start_balance,
                    end_balance: items.length < 2 ? null : items[items.length - 1].end_balance,
                    cash_register: this.props.cash_registers[id_cash_register],
                    documents,
                    documents_for_advance_payments
                });
            }
        }
        await this.printJournalInternal(pages, item_lang, display_detailed_list, filename, false);
    }
    async printJournalInternal(pages, item_lang, display_detailed_list, filename, is_journal_state) {
        if (pages.length == 0) {
            this.props.removeInvoiceFromA4PrinterQueue();
            return;
        }
        this.setState({
            current_item: pages
        });
        // print
        console.log('printing journal');
        const general_settings = this.props.general_settings;
        const journals = [];
        for(let idx = 0; idx < pages.length; idx++){
            const { cash_register, documents, documents_for_advance_payments, document_number, last_document_number, start_document_date, end_document_date, start_balance, end_balance } = pages[idx];
            // filter out reverse invoices and their references
            let reverse_invoice_ids = [];
            let reversed_invoice_ids = [];
            for(let i = 0; i < documents_for_advance_payments.length; i++){
                const doc_invoices = documents_for_advance_payments[i].invoices ?? [];
                for(let j = 0; j < doc_invoices.length; j++){
                    const invoice = this.props.invoices[doc_invoices[j].id_invoice];
                    if (invoice.reverse_invoice === true) {
                        reverse_invoice_ids.push(invoice.id_invoice);
                        reversed_invoice_ids.push(invoice.reverse_invoice_reference);
                    }
                }
            }
            const selected_documents_for_advance_payments = documents_for_advance_payments.map((doc)=>{
                return {
                    ...doc,
                    invoices: doc.invoices ?? []
                };
            });
            journals.push({
                company_data: {
                    subject_type: general_settings.subject_type,
                    subject_short_name: general_settings.subject_short_name,
                    subject_long_name: general_settings.subject_long_name,
                    subject_address: general_settings.subject_address,
                    subject_post_code: general_settings.subject_post_code,
                    subject_city: general_settings.subject_city,
                    subject_email: general_settings.subject_email,
                    subject_website: general_settings.subject_website,
                    subject_phone_1: general_settings.subject_phone_1,
                    subject_phone_2: general_settings.subject_phone_2,
                    subject_trr_1: general_settings.subject_trr_1,
                    subject_trr_2: general_settings.subject_trr_2,
                    subject_tax_number: general_settings.subject_tax_number,
                    subject_vat_registered: general_settings.subject_vat_registered,
                    subject_vat_number: general_settings.subject_vat_number,
                    subject_registration_number: general_settings.subject_registration_number,
                    logo: general_settings.logo
                },
                settings: {
                    footer: general_settings.footer,
                    logo_position: 'right'
                },
                documents,
                cash_register,
                display_detailed_list,
                documents_for_advance_payments: selected_documents_for_advance_payments,
                lang: item_lang,
                users: this.props.users,
                payment_types: this.props.payment_types,
                tax_rates: this.props.tax_rates,
                invoices: this.props.invoices,
                id_advance_invoice_consumption_by_id_consumer_invoices: this.props.id_advance_invoice_consumption_by_id_consumer_invoices,
                advance_invoice_consumptions: this.props.advance_invoice_consumptions,
                customers: this.props.customers,
                cash_registers: this.props.cash_registers,
                document_number,
                last_document_number,
                start_document_date,
                end_document_date,
                start_balance,
                end_balance,
                is_journal_state
            });
        }
        const item_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _journalDefault.default), {
            pages: journals
        });
        let html = (0, _serverDefault.default).renderToStaticMarkup(item_element);
        html = await this.getPrintHTML('journal', html);
        const print_preview = false;
        if (print_preview) {
            //const win = window.open('/print/print_template_a4.html?v=3', 'Title');
            const win = window.open('', 'Title');
            if (win === null || win === undefined) ;
            else win.document.body.innerHTML = html;
            console.log('removing journal from queue');
            this.props.removeInvoiceFromA4PrinterQueue();
            this.setState({
                current_item: null
            });
        //this.processQueue();
        }
        //console.log(print_items.filter(x => x !== null).join('\n'));
        if (!print_preview && this.ws.readyState == WebSocket.OPEN) this.ws.send(JSON.stringify({
            Action: 'convert-to-pdf-and-open',
            Data: JSON.stringify({
                Html: html,
                Path: (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__save_path'),
                InvoiceNumber: filename
            })
        }));
        console.log('finished printing journal');
    }
    async printCashRegisterDocument(item_data) {
        let item = item_data.item;
        this.setState({
            current_item: item
        });
        // print
        console.log('printing cash register document');
        const general_settings = this.props.general_settings;
        const invoice_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cashRegisterDocumentDefault.default), {
            company_data: {
                subject_type: general_settings.subject_type,
                subject_short_name: general_settings.subject_short_name,
                subject_long_name: general_settings.subject_long_name,
                subject_address: general_settings.subject_address,
                subject_post_code: general_settings.subject_post_code,
                subject_city: general_settings.subject_city,
                subject_email: general_settings.subject_email,
                subject_website: general_settings.subject_website,
                subject_phone_1: general_settings.subject_phone_1,
                subject_phone_2: general_settings.subject_phone_2,
                subject_trr_1: general_settings.subject_trr_1,
                subject_trr_2: general_settings.subject_trr_2,
                subject_tax_number: general_settings.subject_tax_number,
                subject_vat_registered: general_settings.subject_vat_registered,
                subject_vat_number: general_settings.subject_vat_number,
                subject_registration_number: general_settings.subject_registration_number,
                logo: general_settings.logo
            },
            item: item,
            payment_types: this.props.payment_types,
            cash_registers: this.props.cash_registers,
            users: this.props.users,
            customer_country: item.customer_id_country === null ? null : this.props.countries[item.customer_id_country],
            settings: {
                footer: general_settings.footer,
                logo_position: 'right'
            },
            lang: 'sl'
        });
        let html = (0, _serverDefault.default).renderToStaticMarkup(invoice_element);
        html = await this.getPrintHTML('invoice cash-register-document', html);
        const print_preview = false;
        if (print_preview) {
            //const win = window.open('/print/print_template_a4.html?v=3', 'Title');
            const win = window.open('', 'Title');
            if (win === null || win === undefined) ;
            else win.document.body.innerHTML = html;
            this.props.removeInvoiceFromA4PrinterQueue();
            this.setState({
                current_item: null
            });
        //this.processQueue();
        }
        //console.log(print_items.filter(x => x !== null).join('\n'));
        if (!print_preview && this.ws.readyState == WebSocket.OPEN) {
            const name_prefix = item.type == 'income' ? 'Blagajniski prejemek' : 'Blagajniski izdatek';
            const name_postfix = '';
            this.ws.send(JSON.stringify({
                Action: 'convert-to-pdf-and-open',
                Data: JSON.stringify({
                    Html: html,
                    Path: (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__save_path'),
                    InvoiceNumber: (name_prefix + ' ' + item.document_number + ' ' + name_postfix).trim()
                })
            }));
        }
    }
    async printAcquisition(item_data) {
        let item = item_data.item;
        this.setState({
            current_item: item
        });
        // print
        console.log('printing acquisition');
        const general_settings = this.props.general_settings;
        const item_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _acquisitionDefault.default), {
            item: item,
            items: this.props.items,
            tax_rates: this.props.tax_rates,
            warehouses: this.props.warehouses,
            customers: this.props.customers,
            countries: this.props.countries,
            company_data: {
                subject_type: general_settings.subject_type,
                subject_short_name: general_settings.subject_short_name,
                subject_long_name: general_settings.subject_long_name,
                subject_address: general_settings.subject_address,
                subject_post_code: general_settings.subject_post_code,
                subject_city: general_settings.subject_city,
                subject_email: general_settings.subject_email,
                subject_website: general_settings.subject_website,
                subject_phone_1: general_settings.subject_phone_1,
                subject_phone_2: general_settings.subject_phone_2,
                subject_trr_1: general_settings.subject_trr_1,
                subject_trr_2: general_settings.subject_trr_2,
                subject_tax_number: general_settings.subject_tax_number,
                subject_vat_registered: general_settings.subject_vat_registered,
                subject_vat_number: general_settings.subject_vat_number,
                subject_registration_number: general_settings.subject_registration_number,
                logo: general_settings.logo
            }
        });
        let html = (0, _serverDefault.default).renderToStaticMarkup(item_element);
        html = await this.getPrintHTML('acquisition', html);
        const print_preview = false;
        if (print_preview) {
            //const win = window.open('/print/print_template_a4.html?v=3', 'Title');
            const win = window.open('', 'Title');
            if (win === null || win === undefined) ;
            else win.document.body.innerHTML = html;
            this.props.removeInvoiceFromA4PrinterQueue();
            this.setState({
                current_item: null
            });
        //this.processQueue();
        }
        //console.log(print_items.filter(x => x !== null).join('\n'));
        if (!print_preview && this.ws.readyState == WebSocket.OPEN) this.ws.send(JSON.stringify({
            Action: 'convert-to-pdf-and-open',
            Data: JSON.stringify({
                Html: html,
                Path: (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__save_path'),
                InvoiceNumber: 'Prevzem ' + item.document_number
            })
        }));
    }
    async printDeliveryNote(item_data) {
        let delivery_note_lang = item_data.lang;
        let delivery_note = item_data.delivery_note;
        this.setState({
            current_item: delivery_note
        });
        // print
        console.log('printing');
        const general_settings = this.props.general_settings;
        const document_type = this.props.document_types['delivery-note'];
        const invoice_element = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deliveryNoteDefault.default), {
            company_data: {
                subject_type: general_settings.subject_type,
                subject_short_name: general_settings.subject_short_name,
                subject_long_name: general_settings.subject_long_name,
                subject_address: general_settings.subject_address,
                subject_post_code: general_settings.subject_post_code,
                subject_city: general_settings.subject_city,
                subject_email: general_settings.subject_email,
                subject_website: general_settings.subject_website,
                subject_phone_1: general_settings.subject_phone_1,
                subject_phone_2: general_settings.subject_phone_2,
                subject_trr_1: general_settings.subject_trr_1,
                subject_trr_2: general_settings.subject_trr_2,
                subject_tax_number: general_settings.subject_tax_number,
                subject_vat_registered: general_settings.subject_vat_registered,
                subject_vat_number: general_settings.subject_vat_number,
                subject_registration_number: general_settings.subject_registration_number,
                logo: general_settings.logo
            },
            item: delivery_note,
            payment_types: this.props.payment_types,
            id_advance_invoice_consumption_by_id_consumer_invoices: this.props.id_advance_invoice_consumption_by_id_consumer_invoices,
            invoices: this.props.invoices,
            advance_invoice_consumptions: this.props.advance_invoice_consumptions,
            users: this.props.users,
            invoice_fiscal_verifications: this.props.invoice_fiscal_verifications,
            customer: this.props.customers[delivery_note.id_customer],
            customer_country: this.props.countries[this.props.customers[delivery_note.id_customer].id_country],
            settings: {
                footer: general_settings.footer,
                tourist_tax_text: general_settings.tourist_tax_text,
                subject_vat_registered: general_settings.subject_vat_registered,
                subject_vat_registered_reason: general_settings.subject_vat_registered_reason,
                print_footer_a4: general_settings.print_footer_a4,
                print_final_text: document_type === undefined ? '' : document_type.print_final_text,
                print_final_text_en: document_type === undefined ? '' : document_type.print_final_text_en,
                print_final_text_de: document_type === undefined ? '' : document_type.print_final_text_de,
                logo_position: document_type === undefined ? 'right' : document_type.logo_position
            },
            lang: delivery_note_lang,
            items: this.props.items,
            measuring_units: this.props.measuring_units
        });
        let html = (0, _serverDefault.default).renderToStaticMarkup(invoice_element);
        html = await this.getPrintHTML('invoice', html);
        /*ErrorReportingHelper.ReportA4PrintInfo(
			JSON.stringify({ op: 'A4PrinterWatcher.processQueue: step 3', ts: (new Date()).toISOString(), id_invoice: delivery_note.id_invoice }),
			{ tags: 'a4_print, step_3, item_' + delivery_note.id_invoice }
		);*/ const print_preview = false;
        if (print_preview) {
            //const win = window.open('/print/print_template_a4.html?v=3', 'Title');
            const win = window.open('', 'Title');
            if (win === null || win === undefined) ;
            else win.document.body.innerHTML = html;
            this.props.removeInvoiceFromA4PrinterQueue();
            this.setState({
                current_item: null
            });
        //this.processQueue();
        }
        //console.log(print_items.filter(x => x !== null).join('\n'));
        if (!print_preview && this.ws.readyState == WebSocket.OPEN) {
            const type_names = {
                'delivery': 'Dobavnica',
                'return': 'Dobavnica'
            };
            const name_prefix = type_names[delivery_note.type] || '';
            const name_postfix = delivery_note_lang == 'sl' ? '' : delivery_note_lang.toUpperCase();
            /*ErrorReportingHelper.ReportA4PrintInfo(
				JSON.stringify({ op: 'A4PrinterWatcher.processQueue: step 4', ts: (new Date()).toISOString(), id_invoice: delivery_note.id_invoice }),
				{ tags: 'a4_print, step_4, item_' + delivery_note.id_invoice }
			);*/ this.ws.send(JSON.stringify({
                Action: 'convert-to-pdf-and-open',
                Data: JSON.stringify({
                    Html: html,
                    Path: (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__save_path'),
                    InvoiceNumber: (name_prefix + ' ' + delivery_note.document_number + ' ' + name_postfix).trim()
                })
            }));
        }
    }
    render() {
        return null;
    }
}
exports.default = (0, _reactRedux.connect)((state)=>{
    return {
        api_url: state.ConstantsSlice.api_url,
        ws_print_url: state.ConstantsSlice.ws_print_url,
        client: state.ConstantsSlice.client,
        a4_printer_queue: state.AppSlice.a4_printer_queue,
        general_settings: state.SettingsSlice.general,
        users: state.UserSlice.users,
        token: state.UserSlice.token,
        cash_registers: state.CashRegisterSlice.cash_registers,
        business_premises: state.CodeTablesSlice.business_premises,
        payment_types: state.CodeTablesSlice.payment_types,
        countries: state.CodeTablesSlice.countries,
        tax_rates: state.CodeTablesSlice.tax_rates,
        customers: state.CodeTablesSlice.customers,
        items: state.CodeTablesSlice.items,
        warehouses: state.CodeTablesSlice.warehouses,
        document_types: state.DocumentSlice.document_types,
        invoices: state.BusinessSlice.invoices,
        invoice_fiscal_verifications: state.BusinessSlice.invoice_fiscal_verifications,
        advance_invoice_consumptions: state.BusinessSlice.advance_invoice_consumptions,
        id_advance_invoice_consumption_by_id_consumer_invoices: state.BusinessSlice.id_advance_invoice_consumption_by_id_consumer_invoices,
        cash_register_documents: state.CashRegisterSlice.cash_register_documents,
        measuring_units: state.CodeTablesSlice.measuring_units
    };
}, (dispatch)=>{
    return {
        dispatch,
        setA4PrinterConnectedStatus: (connected)=>dispatch((0, _appSlice.setA4PrinterConnectedStatus)({
                connected
            })),
        enqueueInvoiceOnA4PrinterQueue: (data)=>dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)(data)),
        requeueInvoiceOnA4PrinterQueue: (data)=>dispatch((0, _appSlice.requeueInvoiceOnA4PrinterQueue)(data)),
        removeInvoiceFromA4PrinterQueue: (data)=>dispatch((0, _appSlice.removeInvoiceFromA4PrinterQueue)(data)),
        setPrinters: (data)=>dispatch((0, _appSlice.setPrinters)({
                printers: data
            }))
    };
})(A4PrinterWatcher);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dom/server":"cEUAl","react-redux":"5DyKE","moment":"1e4qG","../slices/AppSlice":"aByTQ","../api/Business":"fC7Hd","../printing/a4/Invoice":"6MCLg","../printing/a4/Journal":"jqs5j","../printing/a4/CashRegisterDocument":"e2KKT","../printing/a4/Acquisition":"edPHv","../printing/a4/DeliveryNote":"5tfJP","../helpers/LocalStorageHelper":"9I9tm","../constants":"g9BKl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cEUAl":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("d38e18015ef6662b");

},{"d38e18015ef6662b":"6RQYs"}],"6RQYs":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = require("2a760a3bc04cb618"), m = require("25c06765b630fbbf");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var q = 60106, r = 60107, u = 60108, z = 60114, B = 60109, aa = 60110, ba = 60112, D = 60113, ca = 60120, da = 60115, ea = 60116, fa = 60121, ha = 60117, ia = 60119, ja = 60129, ka = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    q = E("react.portal");
    r = E("react.fragment");
    u = E("react.strict_mode");
    z = E("react.profiler");
    B = E("react.provider");
    aa = E("react.context");
    ba = E("react.forward_ref");
    D = E("react.suspense");
    ca = E("react.suspense_list");
    da = E("react.memo");
    ea = E("react.lazy");
    fa = E("react.block");
    ha = E("react.fundamental");
    ia = E("react.scope");
    ja = E("react.debug_trace_mode");
    ka = E("react.legacy_hidden");
}
function F(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case r:
            return "Fragment";
        case q:
            return "Portal";
        case z:
            return "Profiler";
        case u:
            return "StrictMode";
        case D:
            return "Suspense";
        case ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case aa:
            return (a.displayName || "Context") + ".Consumer";
        case B:
            return (a._context.displayName || "Context") + ".Provider";
        case ba:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case da:
            return F(a.type);
        case fa:
            return F(a._render);
        case ea:
            b = a._payload;
            a = a._init;
            try {
                return F(a(b));
            } catch (c) {}
    }
    return null;
}
var la = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ma = {};
function I(a, b) {
    for(var c = a._threadCount | 0; c <= b; c++)a[c] = a._currentValue2, a._threadCount = c + 1;
}
function na(a, b, c, d) {
    if (d && (d = a.contextType, "object" === typeof d && null !== d)) return I(d, c), d[c];
    if (a = a.contextTypes) {
        c = {};
        for(var f in a)c[f] = b[f];
        b = c;
    } else b = ma;
    return b;
}
for(var J = new Uint16Array(16), K = 0; 15 > K; K++)J[K] = K + 1;
J[15] = 0;
var oa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, pa = Object.prototype.hasOwnProperty, qa = {}, ra = {};
function sa(a) {
    if (pa.call(ra, a)) return !0;
    if (pa.call(qa, a)) return !1;
    if (oa.test(a)) return ra[a] = !0;
    qa[a] = !0;
    return !1;
}
function ta(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function ua(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ta(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function M(a, b, c, d, f, h, t) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = h;
    this.removeEmptyString = t;
}
var N = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    N[a] = new M(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    N[b] = new M(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    N[a] = new M(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    N[a] = new M(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    N[a] = new M(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    N[a] = new M(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    N[a] = new M(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    N[a] = new M(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    N[a] = new M(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var va = /[\-:]([a-z])/g;
function wa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(va, wa);
    N[b] = new M(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(va, wa);
    N[b] = new M(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(va, wa);
    N[b] = new M(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    N[a] = new M(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
N.xlinkHref = new M("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    N[a] = new M(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var xa = /["'&<>]/;
function O(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = xa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
function ya(a, b) {
    var c = N.hasOwnProperty(a) ? N[a] : null;
    var d;
    if (d = "style" !== a) d = null !== c ? 0 === c.type : !(2 < a.length) || "o" !== a[0] && "O" !== a[0] || "n" !== a[1] && "N" !== a[1] ? !1 : !0;
    if (d || ua(a, b, c, !1)) return "";
    if (null !== c) {
        a = c.attributeName;
        d = c.type;
        if (3 === d || 4 === d && !0 === b) return a + '=""';
        c.sanitizeURL && (b = "" + b);
        return a + '="' + (O(b) + '"');
    }
    return sa(a) ? a + '="' + (O(b) + '"') : "";
}
function za(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var Aa = "function" === typeof Object.is ? Object.is : za, P = null, Q = null, R = null, S = !1, T = !1, U = null, V = 0;
function W() {
    if (null === P) throw Error(p(321));
    return P;
}
function Ba() {
    if (0 < V) throw Error(p(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function Ca() {
    null === R ? null === Q ? (S = !1, Q = R = Ba()) : (S = !0, R = Q) : null === R.next ? (S = !1, R = R.next = Ba()) : (S = !0, R = R.next);
    return R;
}
function Da(a, b, c, d) {
    for(; T;)T = !1, V += 1, R = null, c = a(b, d);
    Ea();
    return c;
}
function Ea() {
    P = null;
    T = !1;
    Q = null;
    V = 0;
    R = U = null;
}
function Fa(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Ga(a, b, c) {
    P = W();
    R = Ca();
    if (S) {
        var d = R.queue;
        b = d.dispatch;
        if (null !== U && (c = U.get(d), void 0 !== c)) {
            U.delete(d);
            d = R.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            R.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            R.memoizedState,
            b
        ];
    }
    a = a === Fa ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    R.memoizedState = a;
    a = R.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = Ha.bind(null, P, a);
    return [
        R.memoizedState,
        a
    ];
}
function Ia(a, b) {
    P = W();
    R = Ca();
    b = void 0 === b ? null : b;
    if (null !== R) {
        var c = R.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!Aa(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    R.memoizedState = [
        a,
        b
    ];
    return a;
}
function Ha(a, b, c) {
    if (!(25 > V)) throw Error(p(301));
    if (a === P) {
        if (T = !0, a = {
            action: c,
            next: null
        }, null === U && (U = new Map), c = U.get(b), void 0 === c) U.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function Ja() {}
var X = null, Ka = {
    readContext: function(a) {
        var b = X.threadID;
        I(a, b);
        return a[b];
    },
    useContext: function(a) {
        W();
        var b = X.threadID;
        I(a, b);
        return a[b];
    },
    useMemo: Ia,
    useReducer: Ga,
    useRef: function(a) {
        P = W();
        R = Ca();
        var b = R.memoizedState;
        return null === b ? (a = {
            current: a
        }, R.memoizedState = a) : b;
    },
    useState: function(a) {
        return Ga(Fa, a);
    },
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return Ia(function() {
            return a;
        }, b);
    },
    useImperativeHandle: Ja,
    useEffect: Ja,
    useDebugValue: Ja,
    useDeferredValue: function(a) {
        W();
        return a;
    },
    useTransition: function() {
        W();
        return [
            function(a) {
                a();
            },
            !1
        ];
    },
    useOpaqueIdentifier: function() {
        return (X.identifierPrefix || "") + "R:" + (X.uniqueID++).toString(36);
    },
    useMutableSource: function(a, b) {
        W();
        return b(a._source);
    }
}, La = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Ma(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
var Na = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
}, Oa = l({
    menuitem: !0
}, Na), Y = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, Pa = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(Y).forEach(function(a) {
    Pa.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        Y[b] = Y[a];
    });
});
var Qa = /([A-Z])/g, Ra = /^ms-/, Z = m.Children.toArray, Sa = la.ReactCurrentDispatcher, Ta = {
    listing: !0,
    pre: !0,
    textarea: !0
}, Ua = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Va = {}, Wa = {};
function Xa(a) {
    if (void 0 === a || null === a) return a;
    var b = "";
    m.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var Ya = Object.prototype.hasOwnProperty, Za = {
    children: null,
    dangerouslySetInnerHTML: null,
    suppressContentEditableWarning: null,
    suppressHydrationWarning: null
};
function $a(a, b) {
    if (void 0 === a) throw Error(p(152, F(b) || "Component"));
}
function ab(a, b, c) {
    function d(d, h) {
        var e = h.prototype && h.prototype.isReactComponent, f = na(h, b, c, e), t = [], g = !1, n = {
            isMounted: function() {
                return !1;
            },
            enqueueForceUpdate: function() {
                if (null === t) return null;
            },
            enqueueReplaceState: function(a, c) {
                g = !0;
                t = [
                    c
                ];
            },
            enqueueSetState: function(a, c) {
                if (null === t) return null;
                t.push(c);
            }
        };
        if (e) {
            if (e = new h(d.props, f, n), "function" === typeof h.getDerivedStateFromProps) {
                var k = h.getDerivedStateFromProps.call(null, d.props, e.state);
                null != k && (e.state = l({}, e.state, k));
            }
        } else if (P = {}, e = h(d.props, f, n), e = Da(h, d.props, e, f), null == e || null == e.render) {
            a = e;
            $a(a, h);
            return;
        }
        e.props = d.props;
        e.context = f;
        e.updater = n;
        n = e.state;
        void 0 === n && (e.state = n = null);
        if ("function" === typeof e.UNSAFE_componentWillMount || "function" === typeof e.componentWillMount) {
            if ("function" === typeof e.componentWillMount && "function" !== typeof h.getDerivedStateFromProps && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && "function" !== typeof h.getDerivedStateFromProps && e.UNSAFE_componentWillMount(), t.length) {
                n = t;
                var v = g;
                t = null;
                g = !1;
                if (v && 1 === n.length) e.state = n[0];
                else {
                    k = v ? n[0] : e.state;
                    var H = !0;
                    for(v = v ? 1 : 0; v < n.length; v++){
                        var x = n[v];
                        x = "function" === typeof x ? x.call(e, k, d.props, f) : x;
                        null != x && (H ? (H = !1, k = l({}, k, x)) : l(k, x));
                    }
                    e.state = k;
                }
            } else t = null;
        }
        a = e.render();
        $a(a, h);
        if ("function" === typeof e.getChildContext && (d = h.childContextTypes, "object" === typeof d)) {
            var y = e.getChildContext();
            for(var A in y)if (!(A in d)) throw Error(p(108, F(h) || "Unknown", A));
        }
        y && (b = l({}, b, y));
    }
    for(; m.isValidElement(a);){
        var f = a, h = f.type;
        if ("function" !== typeof h) break;
        d(f, h);
    }
    return {
        child: a,
        context: b
    };
}
var bb = function() {
    function a(a, b, f) {
        m.isValidElement(a) ? a.type !== r ? a = [
            a
        ] : (a = a.props.children, a = m.isValidElement(a) ? [
            a
        ] : Z(a)) : a = Z(a);
        a = {
            type: null,
            domNamespace: La.html,
            children: a,
            childIndex: 0,
            context: ma,
            footer: ""
        };
        var c = J[0];
        if (0 === c) {
            var d = J;
            c = d.length;
            var g = 2 * c;
            if (!(65536 >= g)) throw Error(p(304));
            var e = new Uint16Array(g);
            e.set(d);
            J = e;
            J[0] = c + 1;
            for(d = c; d < g - 1; d++)J[d] = d + 1;
            J[g - 1] = 0;
        } else J[0] = J[c];
        this.threadID = c;
        this.stack = [
            a
        ];
        this.exhausted = !1;
        this.currentSelectValue = null;
        this.previousWasTextNode = !1;
        this.makeStaticMarkup = b;
        this.suspenseDepth = 0;
        this.contextIndex = -1;
        this.contextStack = [];
        this.contextValueStack = [];
        this.uniqueID = 0;
        this.identifierPrefix = f && f.identifierPrefix || "";
    }
    var b = a.prototype;
    b.destroy = function() {
        if (!this.exhausted) {
            this.exhausted = !0;
            this.clearProviders();
            var a = this.threadID;
            J[a] = J[0];
            J[0] = a;
        }
    };
    b.pushProvider = function(a) {
        var b = ++this.contextIndex, c = a.type._context, h = this.threadID;
        I(c, h);
        var t = c[h];
        this.contextStack[b] = c;
        this.contextValueStack[b] = t;
        c[h] = a.props.value;
    };
    b.popProvider = function() {
        var a = this.contextIndex, b = this.contextStack[a], f = this.contextValueStack[a];
        this.contextStack[a] = null;
        this.contextValueStack[a] = null;
        this.contextIndex--;
        b[this.threadID] = f;
    };
    b.clearProviders = function() {
        for(var a = this.contextIndex; 0 <= a; a--)this.contextStack[a][this.threadID] = this.contextValueStack[a];
    };
    b.read = function(a) {
        if (this.exhausted) return null;
        var b = X;
        X = this;
        var c = Sa.current;
        Sa.current = Ka;
        try {
            for(var h = [
                ""
            ], t = !1; h[0].length < a;){
                if (0 === this.stack.length) {
                    this.exhausted = !0;
                    var g = this.threadID;
                    J[g] = J[0];
                    J[0] = g;
                    break;
                }
                var e = this.stack[this.stack.length - 1];
                if (t || e.childIndex >= e.children.length) {
                    var L = e.footer;
                    "" !== L && (this.previousWasTextNode = !1);
                    this.stack.pop();
                    if ("select" === e.type) this.currentSelectValue = null;
                    else if (null != e.type && null != e.type.type && e.type.type.$$typeof === B) this.popProvider(e.type);
                    else if (e.type === D) {
                        this.suspenseDepth--;
                        var G = h.pop();
                        if (t) {
                            t = !1;
                            var C = e.fallbackFrame;
                            if (!C) throw Error(p(303));
                            this.stack.push(C);
                            h[this.suspenseDepth] += "\x3c!--$!--\x3e";
                            continue;
                        } else h[this.suspenseDepth] += G;
                    }
                    h[this.suspenseDepth] += L;
                } else {
                    var n = e.children[e.childIndex++], k = "";
                    try {
                        k += this.render(n, e.context, e.domNamespace);
                    } catch (v) {
                        if (null != v && "function" === typeof v.then) throw Error(p(294));
                        throw v;
                    } finally{}
                    h.length <= this.suspenseDepth && h.push("");
                    h[this.suspenseDepth] += k;
                }
            }
            return h[0];
        } finally{
            Sa.current = c, X = b, Ea();
        }
    };
    b.render = function(a, b, f) {
        if ("string" === typeof a || "number" === typeof a) {
            f = "" + a;
            if ("" === f) return "";
            if (this.makeStaticMarkup) return O(f);
            if (this.previousWasTextNode) return "\x3c!-- --\x3e" + O(f);
            this.previousWasTextNode = !0;
            return O(f);
        }
        b = ab(a, b, this.threadID);
        a = b.child;
        b = b.context;
        if (null === a || !1 === a) return "";
        if (!m.isValidElement(a)) {
            if (null != a && null != a.$$typeof) {
                f = a.$$typeof;
                if (f === q) throw Error(p(257));
                throw Error(p(258, f.toString()));
            }
            a = Z(a);
            this.stack.push({
                type: null,
                domNamespace: f,
                children: a,
                childIndex: 0,
                context: b,
                footer: ""
            });
            return "";
        }
        var c = a.type;
        if ("string" === typeof c) return this.renderDOM(a, b, f);
        switch(c){
            case ka:
            case ja:
            case u:
            case z:
            case ca:
            case r:
                return a = Z(a.props.children), this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case D:
                throw Error(p(294));
            case ia:
                throw Error(p(343));
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case ba:
                P = {};
                var d = c.render(a.props, a.ref);
                d = Da(c.render, a.props, d, a.ref);
                d = Z(d);
                this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: d,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case da:
                return a = [
                    m.createElement(c.type, l({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case B:
                return c = Z(a.props.children), f = {
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }, this.pushProvider(a), this.stack.push(f), "";
            case aa:
                c = a.type;
                d = a.props;
                var g = this.threadID;
                I(c, g);
                c = Z(d.children(c[g]));
                this.stack.push({
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case ha:
                throw Error(p(338));
            case ea:
                return c = a.type, d = c._init, c = d(c._payload), a = [
                    m.createElement(c, l({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
        }
        throw Error(p(130, null == c ? c : typeof c, ""));
    };
    b.renderDOM = function(a, b, f) {
        var c = a.type.toLowerCase();
        f === La.html && Ma(c);
        if (!Va.hasOwnProperty(c)) {
            if (!Ua.test(c)) throw Error(p(65, c));
            Va[c] = !0;
        }
        var d = a.props;
        if ("input" === c) d = l({
            type: void 0
        }, d, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != d.value ? d.value : d.defaultValue,
            checked: null != d.checked ? d.checked : d.defaultChecked
        });
        else if ("textarea" === c) {
            var g = d.value;
            if (null == g) {
                g = d.defaultValue;
                var e = d.children;
                if (null != e) {
                    if (null != g) throw Error(p(92));
                    if (Array.isArray(e)) {
                        if (!(1 >= e.length)) throw Error(p(93));
                        e = e[0];
                    }
                    g = "" + e;
                }
                null == g && (g = "");
            }
            d = l({}, d, {
                value: void 0,
                children: "" + g
            });
        } else if ("select" === c) this.currentSelectValue = null != d.value ? d.value : d.defaultValue, d = l({}, d, {
            value: void 0
        });
        else if ("option" === c) {
            e = this.currentSelectValue;
            var L = Xa(d.children);
            if (null != e) {
                var G = null != d.value ? d.value + "" : L;
                g = !1;
                if (Array.isArray(e)) {
                    for(var C = 0; C < e.length; C++)if ("" + e[C] === G) {
                        g = !0;
                        break;
                    }
                } else g = "" + e === G;
                d = l({
                    selected: void 0,
                    children: void 0
                }, d, {
                    selected: g,
                    children: L
                });
            }
        }
        if (g = d) {
            if (Oa[c] && (null != g.children || null != g.dangerouslySetInnerHTML)) throw Error(p(137, c));
            if (null != g.dangerouslySetInnerHTML) {
                if (null != g.children) throw Error(p(60));
                if (!("object" === typeof g.dangerouslySetInnerHTML && "__html" in g.dangerouslySetInnerHTML)) throw Error(p(61));
            }
            if (null != g.style && "object" !== typeof g.style) throw Error(p(62));
        }
        g = d;
        e = this.makeStaticMarkup;
        L = 1 === this.stack.length;
        G = "<" + a.type;
        b: if (-1 === c.indexOf("-")) C = "string" === typeof g.is;
        else switch(c){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                C = !1;
                break b;
            default:
                C = !0;
        }
        for(w in g)if (Ya.call(g, w)) {
            var n = g[w];
            if (null != n) {
                if ("style" === w) {
                    var k = void 0, v = "", H = "";
                    for(k in n)if (n.hasOwnProperty(k)) {
                        var x = 0 === k.indexOf("--"), y = n[k];
                        if (null != y) {
                            if (x) var A = k;
                            else if (A = k, Wa.hasOwnProperty(A)) A = Wa[A];
                            else {
                                var cb = A.replace(Qa, "-$1").toLowerCase().replace(Ra, "-ms-");
                                A = Wa[A] = cb;
                            }
                            v += H + A + ":";
                            H = k;
                            x = null == y || "boolean" === typeof y || "" === y ? "" : x || "number" !== typeof y || 0 === y || Y.hasOwnProperty(H) && Y[H] ? ("" + y).trim() : y + "px";
                            v += x;
                            H = ";";
                        }
                    }
                    n = v || null;
                }
                k = null;
                C ? Za.hasOwnProperty(w) || (k = w, k = sa(k) && null != n ? k + '="' + (O(n) + '"') : "") : k = ya(w, n);
                k && (G += " " + k);
            }
        }
        e || L && (G += ' data-reactroot=""');
        var w = G;
        g = "";
        Na.hasOwnProperty(c) ? w += "/>" : (w += ">", g = "</" + a.type + ">");
        a: {
            e = d.dangerouslySetInnerHTML;
            if (null != e) {
                if (null != e.__html) {
                    e = e.__html;
                    break a;
                }
            } else if (e = d.children, "string" === typeof e || "number" === typeof e) {
                e = O(e);
                break a;
            }
            e = null;
        }
        null != e ? (d = [], Ta.hasOwnProperty(c) && "\n" === e.charAt(0) && (w += "\n"), w += e) : d = Z(d.children);
        a = a.type;
        f = null == f || "http://www.w3.org/1999/xhtml" === f ? Ma(a) : "http://www.w3.org/2000/svg" === f && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : f;
        this.stack.push({
            domNamespace: f,
            type: c,
            children: d,
            childIndex: 0,
            context: b,
            footer: g
        });
        this.previousWasTextNode = !1;
        return w;
    };
    return a;
}();
exports.renderToNodeStream = function() {
    throw Error(p(207));
};
exports.renderToStaticMarkup = function(a, b) {
    a = new bb(a, !0, b);
    try {
        return a.read(Infinity);
    } finally{
        a.destroy();
    }
};
exports.renderToStaticNodeStream = function() {
    throw Error(p(208));
};
exports.renderToString = function(a, b) {
    a = new bb(a, !1, b);
    try {
        return a.read(Infinity);
    } finally{
        a.destroy();
    }
};
exports.version = "17.0.2";

},{"2a760a3bc04cb618":"dudAz","25c06765b630fbbf":"9njXz"}],"6MCLg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Invoice);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _upnqr = require("upnqr");
var _iconvLite = require("iconv-lite");
var _qrcode = require("@rabbit-company/qrcode");
var _sepaPaymentQrCode = require("sepa-payment-qr-code");
var _sepaPaymentQrCodeDefault = parcelHelpers.interopDefault(_sepaPaymentQrCode);
var _print = require("../../helpers/Print");
var _printDefault = parcelHelpers.interopDefault(_print);
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _translation = require("../../helpers/Translation");
var _translationDefault = parcelHelpers.interopDefault(_translation);
var _common = require("./Common");
function formatNumber(val, decimal_digit_count) {
    decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
    let rounded_val = Math.properRound(parseFloat(val), decimal_digit_count);
    return rounded_val.toLocaleString(undefined, {
        minimumFractionDigits: decimal_digit_count,
        maximumFractionDigits: decimal_digit_count
    });
}
function MainInvoiceDetails(props) {
    // prepare data
    let place = null;
    if (props.business_premise !== null && props.business_premise.type == '1') place = props.business_premise.town;
    else place = props.company_data.subject_city;
    let timestamp_format = (0, _translationDefault.default).Print.MainInvoiceDetails.DateFormat[props.lang];
    let invoice_date = props.item.invoice_date;
    if ([
        'cash-invoice',
        'cash-prepayment-invoice'
    ].indexOf(props.item.invoice_type) != -1) {
        timestamp_format = (0, _translationDefault.default).Print.MainInvoiceDetails.TimestampFormat[props.lang];
        invoice_date = props.item.issued;
    }
    const timestamp = invoice_date === null ? '' : (0, _momentDefault.default)(invoice_date).format(timestamp_format);
    let service_date_start = (0, _momentDefault.default)(props.item.service_date_start);
    let service_date_end = (0, _momentDefault.default)(props.item.service_date_end);
    let service_date = '';
    if (props.item.service_date_start == props.item.service_date_end) service_date = service_date_start.format((0, _translationDefault.default).Print.MainInvoiceDetails.DateFormat[props.lang]);
    else service_date = service_date_start.format((0, _translationDefault.default).Print.MainInvoiceDetails.ShortDateFormat[props.lang]) + ' - ' + service_date_end.format((0, _translationDefault.default).Print.MainInvoiceDetails.ShortDateFormat[props.lang]);
    const title = (0, _translationDefault.default).Print.MainInvoiceDetails.InvoiceTitles[props.item.invoice_type];
    // prepare service date fragment
    let service_date_fragment = null;
    if ([
        'cash-invoice',
        'invoice',
        'cash-prepayment-invoice'
    ].includes(props.item.invoice_type)) service_date_fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.ServiceDate[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: service_date
            })
        ]
    });
    else if ([
        'prepayment-invoice',
        'offer'
    ].includes(props.item.invoice_type)) service_date_fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.EstimatedServiceDate[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: service_date
            })
        ]
    });
    // prepare reference fragment
    let reference_fragment = null;
    if ([
        'offer'
    ].includes(props.item.invoice_type)) reference_fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.Reference[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: props.item.invoice_number === null ? 'osnutek' : 'SI00 ' + props.item.invoice_number.replace('Po', '')
                    }),
                    props.item.reference.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: props.item.reference
                    })
                ]
            })
        ]
    });
    else if ([
        'cash-invoice',
        'cash-prepayment-invoice',
        'invoice',
        'prepayment-invoice',
        'stock-acquisition',
        'stock-delivery-document'
    ].includes(props.item.invoice_type)) reference_fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.Reference[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.item.reference
            })
        ]
    });
    // prepare payment date fragment
    let payment_date_fragment = null;
    if (props.item.payment_date !== null && [
        'invoice',
        'prepayment-invoice',
        'offer'
    ].includes(props.item.invoice_type)) {
        let fragment_title = (0, _translationDefault.default).Print.MainInvoiceDetails.PaymentDate[props.lang];
        let fragment_value = (0, _momentDefault.default)(props.item.payment_date).format((0, _translationDefault.default).Print.MainInvoiceDetails.DateFormat[props.lang]);
        if (props.item.invoice_type == 'prepayment-invoice') fragment_title = (0, _translationDefault.default).Print.MainInvoiceDetails.DateOfPayment[props.lang];
        else if (props.item.invoice_type == 'offer') fragment_title = (0, _translationDefault.default).Print.MainInvoiceDetails.ValidityDate[props.lang];
        else if (props.item.invoice_type == 'invoice') {
            if (props.item.paid === true) fragment_value = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: (0, _translationDefault.default).Print.MainInvoiceDetails.Paid[props.lang] + ' ' + fragment_value
                })
            });
        }
        payment_date_fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "emphasized",
                    children: fragment_title
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "emphasized",
                    children: fragment_value
                })
            ]
        });
    }
    // prepare reservation fragment
    let reservation_fragment = null;
    if (props.item.reservation !== null && props.item.reservation.length > 0 && [
        'cash-invoice',
        'cash-prepayment-invoice',
        'invoice',
        'prepayment-invoice',
        'offer'
    ].includes(props.item.invoice_type)) reservation_fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.Reservation[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.item.reservation
            })
        ]
    });
    // prepare delivery note fragment
    let delivery_note_fragment = null;
    // prepare user fragment
    let user_fragment = null;
    const user_titles = {
        'stock-acquisition': (0, _translationDefault.default).Print.MainInvoiceDetails.UserReceivedBy[props.lang],
        'stock-delivery-document': (0, _translationDefault.default).Print.MainInvoiceDetails.UserIssuedBy[props.lang],
        'warehouse-transfer-order': (0, _translationDefault.default).Print.MainInvoiceDetails.UserFulfilledBy[props.lang]
    };
    if (user_titles[props.item.invoice_type] !== undefined) {
        let invoice_user = null;
        for(let id_user in props.users)if (props.users[id_user].username == props.item.username_creator) {
            invoice_user = props.users[id_user];
            break;
        }
        if (invoice_user !== null) user_fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: user_titles[props.item.invoice_type]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: (invoice_user.name + ' ' + (invoice_user.surname.length == 0 ? '' : invoice_user.surname.substring(0, 1) + '.')).trim()
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "main-invoice-details",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    gridColumn: '1 / 3'
                },
                className: "font-large-6 deemphasized mb-05-line",
                children: title === undefined ? '' : title[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "emphasized mb-05-line font-large-1",
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.InvoiceNumber[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "emphasized mb-05-line font-large-1",
                children: props.item.invoice_number
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.Place[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: place
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.Timestamp[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: timestamp
            }),
            service_date_fragment,
            reference_fragment,
            null,
            delivery_note_fragment,
            payment_date_fragment,
            reservation_fragment,
            user_fragment
        ]
    });
}
function InvoiceItemsTable(props) {
    let items = [];
    items.push([
        (0, _translationDefault.default).Print.InvoiceItemsTable.ItemInternalCode[props.lang],
        (0, _translationDefault.default).Print.InvoiceItemsTable.ItemTitle[props.lang],
        (0, _translationDefault.default).Print.InvoiceItemsTable.Quantity[props.lang],
        (0, _translationDefault.default).Print.InvoiceItemsTable.ItemMeasuringUnitCode[props.lang],
        (0, _translationDefault.default).Print.InvoiceItemsTable.Price[props.lang],
        (0, _translationDefault.default).Print.InvoiceItemsTable.Discount[props.lang],
        (0, _translationDefault.default).Print.InvoiceItemsTable.AmountWithoutVAT[props.lang],
        (0, _translationDefault.default).Print.InvoiceItemsTable.VAT[props.lang],
        (0, _translationDefault.default).Print.InvoiceItemsTable.AmountWithVAT[props.lang]
    ]);
    const item_items = [
        ...props.item.items
    ];
    item_items.sort((a, b)=>{
        if (a.ord < b.ord) return -1;
        else if (a.ord > b.ord) return 1;
        return 0;
    });
    for(let i = 0; i < item_items.sort().length; i++){
        const invoice_item = item_items[i];
        items.push([
            invoice_item.item_internal_code,
            invoice_item.item_title,
            formatNumber(invoice_item.quantity, invoice_item.item_measuring_unit_decimal_digit_count),
            invoice_item.item_measuring_unit_code,
            formatNumber(invoice_item.price, 2),
            formatNumber(invoice_item.discount, 2),
            formatNumber(invoice_item.quantity * invoice_item.price * (1 - invoice_item.discount / 100) / (1 + invoice_item.tax_rate / 100), 2),
            formatNumber(invoice_item.tax_rate, 1),
            formatNumber(invoice_item.quantity * invoice_item.price * (1 - invoice_item.discount / 100), 2)
        ]);
        if (invoice_item.description !== null && invoice_item.description.length > 0) items.push([
            invoice_item.description
        ]);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "invoice-items-table",
        children: items.map((item, idx)=>{
            const cls = idx == 0 ? 'cell header-cell' : 'cell';
            if (item.length == 1) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls + ' second-description-cell font-small',
                        children: item[0]
                    })
                ]
            }, 'item-' + idx);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls + ' wrap',
                        children: item[0]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls + ' wrap',
                        children: item[1]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls + ' text-right',
                        children: item[2]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls,
                        children: item[3]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls + ' text-right',
                        children: item[4]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls + ' text-right',
                        children: item[5]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls + ' text-right',
                        children: item[6]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls + ' text-right',
                        children: item[7]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls + ' text-right',
                        children: item[8]
                    })
                ]
            }, 'item-' + idx);
        })
    });
}
function TaxesTable(props) {
    const { invoice_items_by_tax_rate, invoice_items_taxes_sums } = (0, _invoiceDefault.default).groupInvoiceItemsByTaxes(props.item, props.id_advance_invoice_consumption_by_id_consumer_invoices, props.advance_invoice_consumptions);
    let taxes = [];
    if (Object.keys(invoice_items_by_tax_rate).length > 0) {
        taxes.push([
            (0, _translationDefault.default).Print.TaxesTable.TaxRate[props.lang],
            (0, _translationDefault.default).Print.TaxesTable.TaxBase[props.lang],
            (0, _translationDefault.default).Print.TaxesTable.TaxAmount[props.lang],
            (0, _translationDefault.default).Print.TaxesTable.Total[props.lang]
        ]);
        let adjusted_tax_sums = [
            0,
            0,
            0
        ];
        const invoice_items_by_tax_rate_keys = Object.keys(invoice_items_by_tax_rate).sort((a, b)=>{
            if (parseFloat(a) < parseFloat(b)) return -1;
            if (parseFloat(a) > parseFloat(b)) return 1;
            return 0;
        });
        for(let i = 0; i < invoice_items_by_tax_rate_keys.length; i++){
            const key = invoice_items_by_tax_rate_keys[i];
            const tax_rate = parseFloat(invoice_items_by_tax_rate[key].tax_rate);
            const price = parseFloat(invoice_items_by_tax_rate[key].partial_price_discounted_without_tax);
            const tax_amount = parseFloat(invoice_items_by_tax_rate[key].partial_price_tax_amount);
            const total_amount = parseFloat(invoice_items_by_tax_rate[key].partial_price_discounted);
            adjusted_tax_sums[0] += price;
            adjusted_tax_sums[1] += tax_amount;
            adjusted_tax_sums[2] += total_amount;
            taxes.push([
                key == -2 ? (0, _translationDefault.default).Print.TaxesTable.Nontaxable[props.lang] : formatNumber(tax_rate, 1) + '%',
                formatNumber(price, 2),
                formatNumber(tax_amount, 2),
                formatNumber(total_amount, 2)
            ]);
        }
        taxes.push([
            '',
            formatNumber(adjusted_tax_sums[0], 2),
            formatNumber(adjusted_tax_sums[1], 2),
            formatNumber(adjusted_tax_sums[2], 2)
        ]);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "taxes-table",
        children: taxes.map((item, idx)=>{
            let cls = idx == 0 ? 'cell text-right header-cell' : 'cell text-right';
            if (idx == taxes.length - 1) cls += ' top-border';
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls,
                        children: item[0]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls,
                        children: item[1]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls,
                        children: item[2]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls,
                        children: item[3]
                    })
                ]
            }, 'tax-' + idx);
        })
    });
}
function InvoiceSums(props) {
    const { invoice_items_by_tax_rate, invoice_items_taxes_sums } = (0, _invoiceDefault.default).groupInvoiceItemsByTaxes(props.item, props.id_advance_invoice_consumption_by_id_consumer_invoices, props.advance_invoice_consumptions);
    let print_items = [];
    if (invoice_items_taxes_sums[4] != 0) print_items = print_items.concat([
        [
            (0, _translationDefault.default).Print.InvoiceSums.AmountWithoutVAT[props.lang],
            formatNumber(invoice_items_taxes_sums[3], 2),
            false
        ],
        [
            (0, _translationDefault.default).Print.InvoiceSums.DiscountAmount[props.lang],
            formatNumber(-invoice_items_taxes_sums[4], 2),
            false
        ]
    ]);
    print_items = print_items.concat([
        [
            (0, _translationDefault.default).Print.InvoiceSums.TaxBase[props.lang],
            formatNumber(invoice_items_taxes_sums[0], 2),
            false
        ],
        [
            (0, _translationDefault.default).Print.InvoiceSums.TaxAmount[props.lang],
            formatNumber(invoice_items_taxes_sums[1], 2),
            false
        ],
        [
            (0, _translationDefault.default).Print.InvoiceSums.Total[props.lang],
            formatNumber(invoice_items_taxes_sums[2], 2),
            true
        ],
        ...[
            'cash-prepayment-invoice',
            'prepayment-invoice',
            'invoice'
        ].indexOf(props.item.invoice_type) == -1 || props.item.advance_payment_amount == 0 ? [] : [
            [
                (0, _translationDefault.default).Print.InvoiceSums.AdvancePaymentAmount[props.lang],
                formatNumber(props.item.advance_payment_amount, 2),
                false
            ],
            props.item.invoice_type != 'invoice' ? null : [
                (props.id_advance_invoice_consumption_by_id_consumer_invoices[props.item.id_invoice] ?? []).map((x)=>props.invoices[props.advance_invoice_consumptions[x].advance_id_invoice].invoice_number).join(', '),
                false
            ],
            [
                (0, _translationDefault.default).Print.InvoiceSums.RemainingAmount[props.lang],
                formatNumber(invoice_items_taxes_sums[2] - props.item.advance_payment_amount, 2),
                true
            ]
        ]
    ]);
    const iban = (props.company_data.subject_trr_1.trim().length > 0 ? props.company_data.subject_trr_1 : props.company_data.subject_trr_2).replaceAll(' ', '').replaceAll('-', '');
    let qr_code = null;
    if (props.document_type.print_qr_pay_code && iban.length > 0 && props.lang == 'sl') {
        const encoded_qr = (0, _upnqr.encode)({
            ime_placnika: props.company_data.subject_long_name,
            ulica_placnika: props.company_data.subject_address,
            kraj_placnika: props.company_data.subject_post_code + ' ' + props.company_data.subject_city,
            znesek: (invoice_items_taxes_sums[2] - props.item.advance_payment_amount).toFixed(2),
            namen_placila: "Pla\u010Dilo " + props.item.invoice_number,
            rok_placila: (0, _momentDefault.default)(props.item.invoice_type == 'offer' ? props.item.invoice_date : props.item.payment_date).toDate(),
            IBAN_prejemnika: iban,
            referenca_prejemnika: 'SI00 ' + props.item.invoice_number.replace('Po', ''),
            koda_namena: 'GDSV',
            ime_prejemnika: '',
            ulica_prejemnika: '',
            kraj_prejemnika: '',
            rezerva: '',
            polog: false,
            dvig: false,
            nujno: false
        });
        const encoded_qr_iso_8859_2 = (0, _iconvLite.encode)(encoded_qr, 'iso-8859-2');
        qr_code = (0, _qrcode.QRCode).encodeBinary((0, _iconvLite.encode)(encoded_qr, 'iso-8859-2'), {
            errorCorrectionLevel: (0, _qrcode.ErrorCorrectionLevel).MEDIUM,
            boostEcc: false,
            minVersion: 15,
            maxVersion: 15,
            eci: (0, _qrcode.ECI).ISO_8859_2
        });
    } else if (props.document_type.print_qr_pay_code && iban.length > 0) {
        const sepaQR = (0, _sepaPaymentQrCodeDefault.default)({
            name: props.company_data.subject_long_name,
            iban,
            amount: invoice_items_taxes_sums[2] - props.item.advance_payment_amount,
            unstructuredReference: props.item.invoice_number
        });
        const sepaQR_encoded_iso_8859_2 = (0, _iconvLite.encode)(sepaQR, 'iso-8859-2');
        qr_code = (0, _qrcode.QRCode).encodeBinary((0, _iconvLite.encode)(sepaQR_encoded_iso_8859_2, 'iso-8859-2'), {
            errorCorrectionLevel: (0, _qrcode.ErrorCorrectionLevel).MEDIUM,
            boostEcc: false,
            minVersion: 13,
            maxVersion: 13,
            eci: (0, _qrcode.ECI).ISO_8859_2
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "invoice-sums-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "invoice-sums",
                children: print_items.map((item, idx)=>{
                    if (item === null) return null;
                    let cls = 'text-right';
                    if (item.length == 2) {
                        cls += ' span-2';
                        if (item[1]) cls += ' emphasized top-border';
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: cls,
                                children: item[0]
                            })
                        }, 'sum-' + idx);
                    }
                    if (item[2]) cls += ' emphasized top-border';
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: cls,
                                children: item[0]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: cls,
                                children: item[1]
                            })
                        ]
                    }, 'sum-' + idx);
                })
            }),
            qr_code !== null && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pay-qr",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            style: {
                                width: 160
                            },
                            src: qr_code.toDataURL()
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: props.lang == 'sl' ? "Skeniraj & pla\u010Daj" : 'Scan & Pay'
                    })
                ]
            })
        ]
    });
}
function PaymentTypesTable(props) {
    const { payment_types, id_advance_invoice_consumption_by_id_consumer_invoices, invoices, advance_invoice_consumptions } = props;
    const payment_type_items = [];
    let payment_types_sums = {};
    for(let i = 0; i < props.item.payments.length; i++){
        const invoice_payment = props.item.payments[i];
        const price = parseFloat(invoice_payment.amount);
        let key = invoice_payment.id_payment_type;
        if (payment_types_sums[key] === undefined) payment_types_sums[key] = {
            price: 0
        };
        payment_types_sums[key].price += price;
    }
    for(let key in payment_types_sums){
        const price = payment_types_sums[key].price;
        const payment_type = payment_types[key];
        payment_type_items.push([
            payment_type.title,
            formatNumber(price, 2)
        ]);
    }
    if (props.item.invoice_type != 'prepayment-invoice' && props.item.invoice_type != 'cash-prepayment-invoice' && props.item.advance_payment_amount != 0) {
        payment_type_items.push([
            (0, _translationDefault.default).Print.PaymentTypesTable.Advance[props.lang],
            formatNumber(props.item.advance_payment_amount, 2)
        ]);
        const advance_invoices = id_advance_invoice_consumption_by_id_consumer_invoices[props.item.id_invoice] ?? [];
        const advance_invoice_numbers = advance_invoices.map((x)=>invoices[advance_invoice_consumptions[x].advance_id_invoice].invoice_number);
        payment_type_items.push([
            advance_invoice_numbers.join(', ')
        ]);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "payment-types-table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "cell double-cell header-cell",
                children: (0, _translationDefault.default).Print.PaymentTypesTable.PaymentType[props.lang]
            }),
            payment_type_items.map((item, idx)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: item.length < 2 ? 'cell double-cell' : 'cell',
                            children: item[0]
                        }),
                        item.length < 2 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "cell text-right",
                            children: item[1]
                        })
                    ]
                }, 'payment-type-' + idx);
            })
        ]
    });
}
function AdditionalInvoiceDetails(props) {
    const { users, invoice_fiscal_verifications } = props;
    let invoice_user = null;
    for(let id_user in users)if (users[id_user].username == props.item.username_creator) {
        invoice_user = users[id_user];
        break;
    }
    const invoice_fiscal_verification = props.item.id_invoice_fiscal_verification === null ? null : invoice_fiscal_verifications[props.item.id_invoice_fiscal_verification] || null;
    //TODO load invoice fiscal verification if it's not loaded yet
    let qr_value = null;
    if (invoice_fiscal_verification !== null && invoice_fiscal_verification.signed_zoi !== null) {
        qr_value = (0, _printDefault.default).BigNumberHexToDecimal(invoice_fiscal_verification.signed_zoi).padStart(39, '0') + invoice_fiscal_verification.tax_number + (0, _momentDefault.default)(props.item.issued).format('YYYYMMDDHHmmss');
        qr_value += (0, _printDefault.default).CalculateModulo10(qr_value);
    }
    const qr = (0, _qrcode.QRCode).encode(qr_value, {
        errorCorrectionLevel: (0, _qrcode.ErrorCorrectionLevel).MEDIUM,
        boostEcc: false,
        minVersion: 4,
        maxVersion: 4
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "additional-invoice-details",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "fiscal-verification-qr-code",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    style: {
                        width: 100
                    },
                    src: qr.toDataURL()
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "additional-invoice-details-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: (0, _translationDefault.default).Print.AdditionalInvoiceDetails.User[props.lang]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: invoice_user === null ? '' : (invoice_user.name + ' ' + (invoice_user.surname.length == 0 ? '' : invoice_user.surname.substring(0, 1) + '.')).trim()
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: (0, _translationDefault.default).Print.AdditionalInvoiceDetails.InvoiceNumberInternal[props.lang]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: props.item.invoice_number_internal
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: (0, _translationDefault.default).Print.AdditionalInvoiceDetails.ZOI[props.lang]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: invoice_fiscal_verification === null ? '' : invoice_fiscal_verification.signed_zoi ?? ''
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: (0, _translationDefault.default).Print.AdditionalInvoiceDetails.EOR[props.lang]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: invoice_fiscal_verification === null ? '' : invoice_fiscal_verification.eor ?? ''
                    }),
                    props.item.copy_count == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: (0, _translationDefault.default).Print.AdditionalInvoiceDetails.CopyCount[props.lang]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: props.item.copy_count
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flex: 1
                }
            })
        ]
    });
}
function AdditionalDescription(props) {
    let tt_item_exists = false;
    for(let i = 0; i < props.item.items.length; i++)if (props.item.items[i].item_type == 'tourist_tax') {
        tt_item_exists = true;
        break;
    }
    let print_final_text = props.settings.print_final_text;
    if (props.lang == 'en') print_final_text = props.settings.print_final_text_en;
    else if (props.lang == 'de') print_final_text = props.settings.print_final_text_de;
    print_final_text = print_final_text || '';
    print_final_text = print_final_text.replaceAll('<right>', '<div style="text-align: right;">').replaceAll('</right>', '</div>');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "additional-description",
        children: [
            props.item.note === null || props.item.note.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-1-line",
                children: props.item.note
            }),
            props.lang != 'sl' || props.settings.subject_vat_registered !== false ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-1-line",
                children: props.settings.subject_vat_registered_reason
            }),
            !tt_item_exists || props.settings.tourist_tax_text === undefined || props.settings.tourist_tax_text.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-1-line",
                children: props.settings.tourist_tax_text
            }),
            print_final_text === undefined || print_final_text.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-1-line",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: print_final_text
                    }
                })
            })
        ]
    });
}
function Invoice(props) {
    const { company_data, item, business_premise, payment_types, id_advance_invoice_consumption_by_id_consumer_invoices, invoices, advance_invoice_consumptions, users, invoice_fiscal_verifications, customer_country, settings, lang, document_type } = props;
    let cls = 'print-document print-invoice';
    if (settings.logo_position == 'left') cls += ' reverse-logo';
    else if (settings.logo_position == 'hidden') cls += ' hide-logo';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cls,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "print-invoice-main",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.CompanyDetails), {
                        lang: lang,
                        company_data: company_data
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.Logo), {
                        lang: lang,
                        company_data: company_data
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.CustomerDetails), {
                        lang: lang,
                        item: item,
                        customer_country: customer_country
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MainInvoiceDetails, {
                        lang: lang,
                        item: item,
                        company_data: company_data,
                        business_premise: business_premise,
                        users: users
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvoiceItemsTable, {
                        lang: lang,
                        item: item
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(TaxesTable, {
                        lang: lang,
                        item: item,
                        id_advance_invoice_consumption_by_id_consumer_invoices: id_advance_invoice_consumption_by_id_consumer_invoices,
                        advance_invoice_consumptions: advance_invoice_consumptions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvoiceSums, {
                        lang: lang,
                        item: item,
                        id_advance_invoice_consumption_by_id_consumer_invoices: id_advance_invoice_consumption_by_id_consumer_invoices,
                        advance_invoice_consumptions: advance_invoice_consumptions,
                        invoices: invoices,
                        company_data: company_data,
                        document_type: document_type
                    }),
                    [
                        'cash-invoice',
                        'cash-prepayment-invoice'
                    ].indexOf(item.invoice_type) == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdditionalInvoiceDetails, {
                        lang: lang,
                        item: item,
                        users: users,
                        invoice_fiscal_verifications: invoice_fiscal_verifications
                    }),
                    [
                        'cash-invoice',
                        'cash-prepayment-invoice'
                    ].indexOf(item.invoice_type) == -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaymentTypesTable, {
                        lang: lang,
                        item: item,
                        payment_types: payment_types,
                        id_advance_invoice_consumption_by_id_consumer_invoices: id_advance_invoice_consumption_by_id_consumer_invoices,
                        invoices: invoices,
                        advance_invoice_consumptions: advance_invoice_consumptions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdditionalDescription, {
                        lang: lang,
                        item: item,
                        settings: settings
                    })
                ]
            }),
            !settings.print_footer_a4 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.Footer), {
                lang: lang,
                settings: settings
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","moment":"1e4qG","upnqr":"4CEla","iconv-lite":"lNAWE","@rabbit-company/qrcode":"kFRSF","sepa-payment-qr-code":"fn05Q","../../helpers/Print":"f3loA","../../helpers/Invoice":"jffQW","../../helpers/Translation":"19Xlw","./Common":"8GVuQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4CEla":[function(require,module,exports,__globalThis) {
'use strict';
const { validSlog, validKodaNamena, validLength, validIBAN, required, formatAmount, formatBool, formatDate, parseAmount, parseBool, parseDate } = require("73fb2643671ad452");
class UPNQRError extends Error {
    constructor(msg){
        super();
        this.name = 'UPNQRError';
        this.message = msg;
    }
}
const items = [
    {
        name: 'slog',
        filterIn: [
            validSlog
        ]
    },
    {
        name: 'IBAN_placnika',
        filterIn: [
            validIBAN
        ]
    },
    {
        name: 'polog',
        filterIn: [
            parseBool
        ],
        filterOut: [
            formatBool
        ]
    },
    {
        name: 'dvig',
        filterIn: [
            parseBool
        ],
        filterOut: [
            formatBool
        ]
    },
    {
        name: 'referenca_placnika',
        filterIn: [
            validLength(26)
        ]
    },
    {
        name: 'ime_placnika',
        filterIn: [
            validLength(33)
        ]
    },
    {
        name: 'ulica_placnika',
        filterIn: [
            validLength(33)
        ]
    },
    {
        name: 'kraj_placnika',
        filterIn: [
            validLength(33)
        ]
    },
    {
        name: 'znesek',
        filterIn: [
            required,
            validLength(11),
            parseAmount
        ],
        filterOut: [
            formatAmount
        ]
    },
    {
        name: 'datum_placila',
        filterIn: [
            parseDate
        ]
    },
    {
        name: 'nujno',
        filterIn: [
            parseBool
        ],
        filterOut: [
            formatBool
        ]
    },
    {
        name: 'koda_namena',
        filterIn: [
            validKodaNamena
        ]
    },
    {
        name: 'namen_placila'
    },
    {
        name: 'rok_placila',
        filterIn: [
            parseDate
        ],
        filterOut: [
            formatDate
        ]
    },
    {
        name: 'IBAN_prejemnika',
        filterIn: [
            required,
            validIBAN
        ]
    },
    {
        name: 'referenca_prejemnika'
    },
    {
        name: 'ime_prejemnika'
    },
    {
        name: 'ulica_prejemnika'
    },
    {
        name: 'kraj_prejemnika'
    },
    {
        name: 'vsota',
        filterIn: [
            required,
            parseFloat
        ]
    },
    {
        name: 'rezerva'
    }
];
function encode(upn) {
    if (!('slog' in upn)) upn.slog = 'UPNQR';
    let sum = 0;
    return items.map((item, i)=>{
        if (item.name === 'vsota') return sum + 19;
        let val = upn[item.name] || '';
        if (item.filterOut) val = applyFilters(val, item.filterOut, item.name);
        sum += val.length;
        return val;
    }).join('\n');
}
function decode(code) {
    if (code.length > 411) throw new UPNQRError('Code is too long');
    let sum = 0;
    const upn = code.split('\n').slice(0, 21).reduce((agg, val, i)=>{
        const item = items[i];
        if (i < 19) sum += val.length + 1;
        if (item.filterIn) val = applyFilters(val, item.filterIn, item.name);
        if (val !== '') agg[item.name] = val;
        return agg;
    }, {});
    if (sum !== upn.vsota) throw new UPNQRError(`Invalid checksum. Expected ${upn.vsota}, got ${sum}`);
    return upn;
}
function applyFilters(val, filters, name) {
    return filters.reduce((v, filter)=>filter(v, name), val);
}
module.exports = {
    encode,
    decode,
    UPNQRError
};

},{"73fb2643671ad452":"8nWsS"}],"8nWsS":[function(require,module,exports,__globalThis) {
'use strict';
function required(str, fieldName) {
    if (str.trim().length === 0) error(`${fieldName} is required`);
    return str;
}
function validSlog(str) {
    if (str !== 'UPNQR') error('Invalid code');
    return str;
}
function validIBAN(str) {
    if (str.length > 19) error('Invalid IBAN');
    return str;
}
const kodaNamenaRE = /^[A-Z]{4}$/;
function validKodaNamena(str, fieldName) {
    if (!kodaNamenaRE.test(str)) error(`Invalid ${fieldName}`);
    return str;
}
function parseDate(str) {
    if (!str) return str;
    if (str.length !== 10) error(`Invalid date length ${str}`);
    const parts = str.split('.');
    if (parts.length !== 3) error('Invalid date format');
    const d = new Date();
    d.setTime(0);
    d.setDate(num(parts[0]));
    d.setMonth(num(parts[1]) - 1);
    d.setFullYear(num(parts[2]));
    return d;
}
function parseBool(str, fieldName) {
    if (str !== '' && str !== 'X') error(`Invalid bool "${str}" for ${fieldName}`);
    return str === 'X';
}
function parseAmount(str) {
    const n = num(str);
    if (Number.isNaN(n)) error(`Invalid amount ${str}`);
    return n / 100;
}
function formatDate(date) {
    if (date === '') return date;
    if (!(date instanceof Date)) error('Invalid date object');
    return `${pad(date.getDate() + '')}.${pad(date.getMonth() + 1 + '')}.${date.getFullYear()}`;
}
function formatBool(bool) {
    return bool ? 'X' : '';
}
function formatAmount(amount) {
    return pad(Math.round(amount * 100).toString(), 11);
}
const validLength = memoize(function(length) {
    return function(str, fieldName) {
        if (str.length > length) error(`Invalid length. ${fieldName} max len is ${length}, got ${str.length}`);
        return str;
    };
});
function error(msg) {
    throw new (require("5e2559657fffe815")).UPNQRError(msg);
}
function num(str) {
    return parseInt(str, 10);
}
function pad(str, n = 2) {
    while(str.length < n)str = '0' + str;
    return str;
}
function memoize(fn) {
    return function() {
        let hash = '';
        let i = arguments.length;
        while(i--){
            const currentArg = arguments[i];
            hash += currentArg === Object(currentArg) ? JSON.stringify(currentArg) : currentArg;
        }
        if (!fn.memoize) fn.memoize = {};
        return hash in fn.memoize ? fn.memoize[hash] : fn.memoize[hash] = fn.apply(this, arguments);
    };
}
module.exports = {
    required,
    validSlog,
    validIBAN,
    validLength,
    validKodaNamena,
    parseDate,
    parseBool,
    parseAmount,
    formatDate,
    formatBool,
    formatAmount
};

},{"5e2559657fffe815":"4CEla"}],"lNAWE":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("d59043c74995af48").Buffer;
var bomHandling = require("dc2ac0bf59105a0e");
var mergeModules = require("4421825d2b5b62c0");
// All codecs and aliases are kept here, keyed by encoding name/alias.
// They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
// Cannot initialize with { __proto__: null } because Boolean({ __proto__: null }) === true
module.exports.encodings = null;
// Characters emitted in case of error.
module.exports.defaultCharUnicode = "\uFFFD";
module.exports.defaultCharSingleByte = "?";
// Public API.
module.exports.encode = function encode(str, encoding, options) {
    str = "" + (str || "" // Ensure string.
    );
    var encoder = module.exports.getEncoder(encoding, options);
    var res = encoder.write(str);
    var trail = encoder.end();
    return trail && trail.length > 0 ? Buffer.concat([
        res,
        trail
    ]) : res;
};
module.exports.decode = function decode(buf, encoding, options) {
    if (typeof buf === "string") {
        if (!module.exports.skipDecodeWarning) {
            console.error("Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding");
            module.exports.skipDecodeWarning = true;
        }
        buf = Buffer.from("" + (buf || ""), "binary") // Ensure buffer.
        ;
    }
    var decoder = module.exports.getDecoder(encoding, options);
    var res = decoder.write(buf);
    var trail = decoder.end();
    return trail ? res + trail : res;
};
module.exports.encodingExists = function encodingExists(enc) {
    try {
        module.exports.getCodec(enc);
        return true;
    } catch (e) {
        return false;
    }
};
// Legacy aliases to convert functions
module.exports.toEncoding = module.exports.encode;
module.exports.fromEncoding = module.exports.decode;
// Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
module.exports._codecDataCache = {
    __proto__: null
};
module.exports.getCodec = function getCodec(encoding) {
    if (!module.exports.encodings) {
        var raw = require("be03e21360668db1");
        // TODO: In future versions when old nodejs support is removed can use object.assign
        module.exports.encodings = {
            __proto__: null
        } // Initialize as empty object.
        ;
        mergeModules(module.exports.encodings, raw);
    }
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    var enc = module.exports._canonicalizeEncoding(encoding);
    // Traverse iconv.encodings to find actual codec.
    var codecOptions = {};
    while(true){
        var codec = module.exports._codecDataCache[enc];
        if (codec) return codec;
        var codecDef = module.exports.encodings[enc];
        switch(typeof codecDef){
            case "string":
                enc = codecDef;
                break;
            case "object":
                for(var key in codecDef)codecOptions[key] = codecDef[key];
                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                enc = codecDef.type;
                break;
            case "function":
                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                // The codec function must load all tables and return object with .encoder and .decoder methods.
                // It'll be called only once (for each different options object).
                //
                codec = new codecDef(codecOptions, module.exports);
                module.exports._codecDataCache[codecOptions.encodingName] = codec // Save it to be reused later.
                ;
                return codec;
            default:
                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '" + enc + "')");
        }
    }
};
module.exports._canonicalizeEncoding = function(encoding) {
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    return ("" + encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
};
module.exports.getEncoder = function getEncoder(encoding, options) {
    var codec = module.exports.getCodec(encoding);
    var encoder = new codec.encoder(options, codec);
    if (codec.bomAware && options && options.addBOM) encoder = new bomHandling.PrependBOM(encoder, options);
    return encoder;
};
module.exports.getDecoder = function getDecoder(encoding, options) {
    var codec = module.exports.getCodec(encoding);
    var decoder = new codec.decoder(options, codec);
    if (codec.bomAware && !(options && options.stripBOM === false)) decoder = new bomHandling.StripBOM(decoder, options);
    return decoder;
};
// Streaming API
// NOTE: Streaming API naturally depends on 'stream' module from Node.js. Unfortunately in browser environments this module can add
// up to 100Kb to the output bundle. To avoid unnecessary code bloat, we don't enable Streaming API in browser by default.
// If you would like to enable it explicitly, please add the following code to your app:
// > iconv.enableStreamingAPI(require('stream'));
module.exports.enableStreamingAPI = function enableStreamingAPI(streamModule) {
    if (module.exports.supportsStreams) return;
    // Dependency-inject stream module to create IconvLite stream classes.
    var streams = require("907a3f89ffdb20ae")(streamModule);
    // Not public API yet, but expose the stream classes.
    module.exports.IconvLiteEncoderStream = streams.IconvLiteEncoderStream;
    module.exports.IconvLiteDecoderStream = streams.IconvLiteDecoderStream;
    // Streaming API.
    module.exports.encodeStream = function encodeStream(encoding, options) {
        return new module.exports.IconvLiteEncoderStream(module.exports.getEncoder(encoding, options), options);
    };
    module.exports.decodeStream = function decodeStream(encoding, options) {
        return new module.exports.IconvLiteDecoderStream(module.exports.getDecoder(encoding, options), options);
    };
    module.exports.supportsStreams = true;
};
// Enable Streaming API automatically if 'stream' module is available and non-empty (the majority of environments).
var streamModule;
try {
    streamModule = require("573c4aacdb64cc88");
} catch (e) {}
if (streamModule && streamModule.Transform) module.exports.enableStreamingAPI(streamModule);
else // In rare cases where 'stream' module is not available by default, throw a helpful exception.
module.exports.encodeStream = module.exports.decodeStream = function() {
    throw new Error("iconv-lite Streaming API is not enabled. Use iconv.enableStreamingAPI(require('stream')); to enable it.");
};

},{"d59043c74995af48":"254Bi","dc2ac0bf59105a0e":"8qQTb","4421825d2b5b62c0":"63seJ","be03e21360668db1":"3KlqR","907a3f89ffdb20ae":"3B7mW","573c4aacdb64cc88":"aBjM4"}],"254Bi":[function(require,module,exports,__globalThis) {
/* eslint-disable node/no-deprecated-api */ var process = require("e7af3484edf6bee9");
'use strict';
var buffer = require("9b1fd4bf3515d7a6");
var Buffer = buffer.Buffer;
var safer = {};
var key;
for(key in buffer){
    if (!buffer.hasOwnProperty(key)) continue;
    if (key === 'SlowBuffer' || key === 'Buffer') continue;
    safer[key] = buffer[key];
}
var Safer = safer.Buffer = {};
for(key in Buffer){
    if (!Buffer.hasOwnProperty(key)) continue;
    if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue;
    Safer[key] = Buffer[key];
}
safer.Buffer.prototype = Buffer.prototype;
if (!Safer.from || Safer.from === Uint8Array.from) Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === 'undefined') throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value);
    return Buffer(value, encodingOrOffset, length);
};
if (!Safer.alloc) Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === 'string') buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!safer.kStringMaxLength) try {
    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!safer.constants) {
    safer.constants = {
        MAX_LENGTH: safer.kMaxLength
    };
    if (safer.kStringMaxLength) safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength;
}
module.exports = safer;

},{"e7af3484edf6bee9":"5jT8D","9b1fd4bf3515d7a6":"dB11O"}],"dB11O":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

},{"9c62938f1dccc73c":"ettWx","aceacb6a4531a9d2":"6DXND"}],"ettWx":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"6DXND":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"8qQTb":[function(require,module,exports,__globalThis) {
"use strict";
var BOMChar = "\uFEFF";
exports.PrependBOM = PrependBOMWrapper;
function PrependBOMWrapper(encoder, options) {
    this.encoder = encoder;
    this.addBOM = true;
}
PrependBOMWrapper.prototype.write = function(str) {
    if (this.addBOM) {
        str = BOMChar + str;
        this.addBOM = false;
    }
    return this.encoder.write(str);
};
PrependBOMWrapper.prototype.end = function() {
    return this.encoder.end();
};
// ------------------------------------------------------------------------------
exports.StripBOM = StripBOMWrapper;
function StripBOMWrapper(decoder, options) {
    this.decoder = decoder;
    this.pass = false;
    this.options = options || {};
}
StripBOMWrapper.prototype.write = function(buf) {
    var res = this.decoder.write(buf);
    if (this.pass || !res) return res;
    if (res[0] === BOMChar) {
        res = res.slice(1);
        if (typeof this.options.stripBOM === "function") this.options.stripBOM();
    }
    this.pass = true;
    return res;
};
StripBOMWrapper.prototype.end = function() {
    return this.decoder.end();
};

},{}],"63seJ":[function(require,module,exports,__globalThis) {
"use strict";
var hasOwn = typeof Object.hasOwn === "undefined" ? Function.call.bind(Object.prototype.hasOwnProperty) : Object.hasOwn;
function mergeModules(target, module1) {
    for(var key in module1)if (hasOwn(module1, key)) target[key] = module1[key];
}
module.exports = mergeModules;

},{}],"3KlqR":[function(require,module,exports,__globalThis) {
"use strict";
var mergeModules = require("7a16b6f17529a1ca");
// Update this array if you add/rename/remove files in this directory.
// We support Browserify by skipping automatic module discovery and requiring modules directly.
var modules = [
    require("bdaa557df13ed604"),
    require("613977c2b31891cb"),
    require("fd3dc965fc8aca3f"),
    require("eef39a6572ec0e16"),
    require("db74ee6b9422868a"),
    require("8a20a6a175d74380"),
    require("e647804c36d26de7"),
    require("1447d5a4b8fe2b16"),
    require("87cdd8efe5f0a905")
];
// Put all encoding/alias/codec definitions to single object and export it.
for(var i = 0; i < modules.length; i++){
    var module = modules[i];
    mergeModules(exports, module);
}

},{"7a16b6f17529a1ca":"63seJ","bdaa557df13ed604":"2bg8v","613977c2b31891cb":"leopJ","fd3dc965fc8aca3f":"hfFyY","eef39a6572ec0e16":"khcb2","db74ee6b9422868a":"1uKAP","8a20a6a175d74380":"gjdU9","e647804c36d26de7":"9YNWH","1447d5a4b8fe2b16":"dhW5E","87cdd8efe5f0a905":"2twwc"}],"2bg8v":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("b2563c082b744514").Buffer;
// Export Node.js internal encodings.
module.exports = {
    // Encodings
    utf8: {
        type: "_internal",
        bomAware: true
    },
    cesu8: {
        type: "_internal",
        bomAware: true
    },
    unicode11utf8: "utf8",
    ucs2: {
        type: "_internal",
        bomAware: true
    },
    utf16le: "ucs2",
    binary: {
        type: "_internal"
    },
    base64: {
        type: "_internal"
    },
    hex: {
        type: "_internal"
    },
    // Codec.
    _internal: InternalCodec
};
// ------------------------------------------------------------------------------
function InternalCodec(codecOptions, iconv) {
    this.enc = codecOptions.encodingName;
    this.bomAware = codecOptions.bomAware;
    if (this.enc === "base64") this.encoder = InternalEncoderBase64;
    else if (this.enc === "utf8") this.encoder = InternalEncoderUtf8;
    else if (this.enc === "cesu8") {
        this.enc = "utf8" // Use utf8 for decoding.
        ;
        this.encoder = InternalEncoderCesu8;
        // Add decoder for versions of Node not supporting CESU-8
        if (Buffer.from("eda0bdedb2a9", "hex").toString() !== "\uD83D\uDCA9") {
            this.decoder = InternalDecoderCesu8;
            this.defaultCharUnicode = iconv.defaultCharUnicode;
        }
    }
}
InternalCodec.prototype.encoder = InternalEncoder;
InternalCodec.prototype.decoder = InternalDecoder;
// ------------------------------------------------------------------------------
// We use node.js internal decoder. Its signature is the same as ours.
var StringDecoder = require("912b463ef1262b9c").StringDecoder;
function InternalDecoder(options, codec) {
    this.decoder = new StringDecoder(codec.enc);
}
InternalDecoder.prototype.write = function(buf) {
    if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
    return this.decoder.write(buf);
};
InternalDecoder.prototype.end = function() {
    return this.decoder.end();
};
// ------------------------------------------------------------------------------
// Encoder is mostly trivial
function InternalEncoder(options, codec) {
    this.enc = codec.enc;
}
InternalEncoder.prototype.write = function(str) {
    return Buffer.from(str, this.enc);
};
InternalEncoder.prototype.end = function() {};
// ------------------------------------------------------------------------------
// Except base64 encoder, which must keep its state.
function InternalEncoderBase64(options, codec) {
    this.prevStr = "";
}
InternalEncoderBase64.prototype.write = function(str) {
    str = this.prevStr + str;
    var completeQuads = str.length - str.length % 4;
    this.prevStr = str.slice(completeQuads);
    str = str.slice(0, completeQuads);
    return Buffer.from(str, "base64");
};
InternalEncoderBase64.prototype.end = function() {
    return Buffer.from(this.prevStr, "base64");
};
// ------------------------------------------------------------------------------
// CESU-8 encoder is also special.
function InternalEncoderCesu8(options, codec) {}
InternalEncoderCesu8.prototype.write = function(str) {
    var buf = Buffer.alloc(str.length * 3);
    var bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var charCode = str.charCodeAt(i);
        // Naive implementation, but it works because CESU-8 is especially easy
        // to convert from UTF-16 (which all JS strings are encoded in).
        if (charCode < 0x80) buf[bufIdx++] = charCode;
        else if (charCode < 0x800) {
            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        } else {
            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
            buf[bufIdx++] = 0x80 + (charCode >>> 6 & 0x3f);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        }
    }
    return buf.slice(0, bufIdx);
};
InternalEncoderCesu8.prototype.end = function() {};
// ------------------------------------------------------------------------------
// CESU-8 decoder is not implemented in Node v4.0+
function InternalDecoderCesu8(options, codec) {
    this.acc = 0;
    this.contBytes = 0;
    this.accBytes = 0;
    this.defaultCharUnicode = codec.defaultCharUnicode;
}
InternalDecoderCesu8.prototype.write = function(buf) {
    var acc = this.acc;
    var contBytes = this.contBytes;
    var accBytes = this.accBytes;
    var res = "";
    for(var i = 0; i < buf.length; i++){
        var curByte = buf[i];
        if ((curByte & 0xC0) !== 0x80) {
            if (contBytes > 0) {
                res += this.defaultCharUnicode;
                contBytes = 0;
            }
            if (curByte < 0x80) res += String.fromCharCode(curByte);
            else if (curByte < 0xE0) {
                acc = curByte & 0x1F;
                contBytes = 1;
                accBytes = 1;
            } else if (curByte < 0xF0) {
                acc = curByte & 0x0F;
                contBytes = 2;
                accBytes = 1;
            } else res += this.defaultCharUnicode;
        } else if (contBytes > 0) {
            acc = acc << 6 | curByte & 0x3f;
            contBytes--;
            accBytes++;
            if (contBytes === 0) {
                // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                if (accBytes === 2 && acc < 0x80 && acc > 0) res += this.defaultCharUnicode;
                else if (accBytes === 3 && acc < 0x800) res += this.defaultCharUnicode;
                else // Actually add character.
                res += String.fromCharCode(acc);
            }
        } else res += this.defaultCharUnicode;
    }
    this.acc = acc;
    this.contBytes = contBytes;
    this.accBytes = accBytes;
    return res;
};
InternalDecoderCesu8.prototype.end = function() {
    var res = 0;
    if (this.contBytes > 0) res += this.defaultCharUnicode;
    return res;
};
// ------------------------------------------------------------------------------
// check the chunk boundaries for surrogate pair
function InternalEncoderUtf8(options, codec) {
    this.highSurrogate = "";
}
InternalEncoderUtf8.prototype.write = function(str) {
    if (this.highSurrogate) {
        str = this.highSurrogate + str;
        this.highSurrogate = "";
    }
    if (str.length > 0) {
        var charCode = str.charCodeAt(str.length - 1);
        if (charCode >= 0xd800 && charCode < 0xdc00) {
            this.highSurrogate = str[str.length - 1];
            str = str.slice(0, str.length - 1);
        }
    }
    return Buffer.from(str, this.enc);
};
InternalEncoderUtf8.prototype.end = function() {
    if (this.highSurrogate) {
        var str = this.highSurrogate;
        this.highSurrogate = "";
        return Buffer.from(str, this.enc);
    }
};

},{"b2563c082b744514":"254Bi","912b463ef1262b9c":"8Iwjg"}],"8Iwjg":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
/*<replacement>*/ var Buffer = require("2a29807c689a070a").Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
StringDecoder.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

},{"2a29807c689a070a":"0F6vL"}],"0F6vL":[function(require,module,exports,__globalThis) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require("7e0d6ecd698c3ca6");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
SafeBuffer.prototype = Object.create(Buffer.prototype);
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return buffer.SlowBuffer(size);
};

},{"7e0d6ecd698c3ca6":"dB11O"}],"leopJ":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("f9c116f4f75bb528").Buffer;
// == UTF32-LE/BE codec. ==========================================================
exports._utf32 = Utf32Codec;
function Utf32Codec(codecOptions, iconv) {
    this.iconv = iconv;
    this.bomAware = true;
    this.isLE = codecOptions.isLE;
}
exports.utf32le = {
    type: "_utf32",
    isLE: true
};
exports.utf32be = {
    type: "_utf32",
    isLE: false
};
// Aliases
exports.ucs4le = "utf32le";
exports.ucs4be = "utf32be";
Utf32Codec.prototype.encoder = Utf32Encoder;
Utf32Codec.prototype.decoder = Utf32Decoder;
// -- Encoding
function Utf32Encoder(options, codec) {
    this.isLE = codec.isLE;
    this.highSurrogate = 0;
}
Utf32Encoder.prototype.write = function(str) {
    var src = Buffer.from(str, "ucs2");
    // src.length * 2 covers this chunk's code units (4 bytes each); the extra 4 bytes leave room for a
    // high surrogate held over from a previous chunk, which is flushed ahead of this chunk's units.
    var dst = Buffer.alloc(src.length * 2 + 4);
    var write32 = this.isLE ? dst.writeUInt32LE : dst.writeUInt32BE;
    var offset = 0;
    for(var i = 0; i < src.length; i += 2){
        var code = src.readUInt16LE(i);
        var isHighSurrogate = code >= 0xD800 && code < 0xDC00;
        var isLowSurrogate = code >= 0xDC00 && code < 0xE000;
        if (this.highSurrogate) {
            if (isHighSurrogate || !isLowSurrogate) {
                // There shouldn't be two high surrogates in a row, nor a high surrogate which isn't followed by a low
                // surrogate. If this happens, keep the pending high surrogate as a stand-alone semi-invalid character
                // (technically wrong, but expected by some applications, like Windows file names).
                write32.call(dst, this.highSurrogate, offset);
                offset += 4;
            } else {
                // Create 32-bit value from high and low surrogates;
                var codepoint = (this.highSurrogate - 0xD800 << 10 | code - 0xDC00) + 0x10000;
                write32.call(dst, codepoint, offset);
                offset += 4;
                this.highSurrogate = 0;
                continue;
            }
        }
        if (isHighSurrogate) this.highSurrogate = code;
        else {
            // Even if the current character is a low surrogate, with no previous high surrogate, we'll
            // encode it as a semi-invalid stand-alone character for the same reasons expressed above for
            // unpaired high surrogates.
            write32.call(dst, code, offset);
            offset += 4;
            this.highSurrogate = 0;
        }
    }
    if (offset < dst.length) dst = dst.slice(0, offset);
    return dst;
};
Utf32Encoder.prototype.end = function() {
    // Treat any leftover high surrogate as a semi-valid independent character.
    if (!this.highSurrogate) return;
    var buf = Buffer.alloc(4);
    if (this.isLE) buf.writeUInt32LE(this.highSurrogate, 0);
    else buf.writeUInt32BE(this.highSurrogate, 0);
    this.highSurrogate = 0;
    return buf;
};
// -- Decoding
function Utf32Decoder(options, codec) {
    this.isLE = codec.isLE;
    this.badChar = codec.iconv.defaultCharUnicode.charCodeAt(0);
    this.overflow = [];
}
Utf32Decoder.prototype.write = function(src) {
    if (src.length === 0) return "";
    var i = 0;
    var codepoint = 0;
    var dst = Buffer.alloc(src.length + 4);
    var offset = 0;
    var isLE = this.isLE;
    var overflow = this.overflow;
    var badChar = this.badChar;
    if (overflow.length > 0) {
        for(; i < src.length && overflow.length < 4; i++)overflow.push(src[i]);
        if (overflow.length === 4) {
            // NOTE: codepoint is a signed int32 and can be negative.
            // NOTE: We copied this block from below to help V8 optimize it (it works with array, not buffer).
            if (isLE) codepoint = overflow[0] | overflow[1] << 8 | overflow[2] << 16 | overflow[3] << 24;
            else codepoint = overflow[3] | overflow[2] << 8 | overflow[1] << 16 | overflow[0] << 24;
            overflow.length = 0;
            offset = _writeCodepoint(dst, offset, codepoint, badChar);
        }
    }
    // Main loop. Should be as optimized as possible.
    for(; i < src.length - 3; i += 4){
        // NOTE: codepoint is a signed int32 and can be negative.
        if (isLE) codepoint = src[i] | src[i + 1] << 8 | src[i + 2] << 16 | src[i + 3] << 24;
        else codepoint = src[i + 3] | src[i + 2] << 8 | src[i + 1] << 16 | src[i] << 24;
        offset = _writeCodepoint(dst, offset, codepoint, badChar);
    }
    // Keep overflowing bytes.
    for(; i < src.length; i++)overflow.push(src[i]);
    return dst.slice(0, offset).toString("ucs2");
};
function _writeCodepoint(dst, offset, codepoint, badChar) {
    // NOTE: codepoint is signed int32 and can be negative. We keep it that way to help V8 with optimizations.
    if (codepoint < 0 || codepoint > 0x10FFFF) // Not a valid Unicode codepoint
    codepoint = badChar;
    // Ephemeral Planes: Write high surrogate.
    if (codepoint >= 0x10000) {
        codepoint -= 0x10000;
        var high = 0xD800 | codepoint >> 10;
        dst[offset++] = high & 0xff;
        dst[offset++] = high >> 8;
        // Low surrogate is written below.
        var codepoint = 0xDC00 | codepoint & 0x3FF;
    }
    // Write BMP char or low surrogate.
    dst[offset++] = codepoint & 0xff;
    dst[offset++] = codepoint >> 8;
    return offset;
}
Utf32Decoder.prototype.end = function() {
    if (this.overflow.length === 0) return;
    // A leftover, incomplete 4-byte code unit at the end of the input is ill-formed. Substitute a
    // single U+FFFD (Unicode Standard conformance clause C10) instead of silently dropping the bytes.
    this.overflow.length = 0;
    return String.fromCharCode(this.badChar);
};
// == UTF-32 Auto codec =============================================================
// Decoder chooses automatically from UTF-32LE and UTF-32BE using BOM and space-based heuristic.
// Defaults to UTF-32LE. http://en.wikipedia.org/wiki/UTF-32
// Encoder/decoder default can be changed: iconv.decode(buf, 'utf32', {defaultEncoding: 'utf-32be'});
// Encoder prepends BOM (which can be overridden with (addBOM: false}).
exports.utf32 = Utf32AutoCodec;
exports.ucs4 = "utf32";
function Utf32AutoCodec(options, iconv) {
    this.iconv = iconv;
}
Utf32AutoCodec.prototype.encoder = Utf32AutoEncoder;
Utf32AutoCodec.prototype.decoder = Utf32AutoDecoder;
// -- Encoding
function Utf32AutoEncoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined) options.addBOM = true;
    this.encoder = codec.iconv.getEncoder(options.defaultEncoding || "utf-32le", options);
}
Utf32AutoEncoder.prototype.write = function(str) {
    return this.encoder.write(str);
};
Utf32AutoEncoder.prototype.end = function() {
    return this.encoder.end();
};
// -- Decoding
function Utf32AutoDecoder(options, codec) {
    this.decoder = null;
    this.initialBufs = [];
    this.initialBufsLen = 0;
    this.options = options || {};
    this.iconv = codec.iconv;
}
Utf32AutoDecoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBufs.push(buf);
        this.initialBufsLen += buf.length;
        if (this.initialBufsLen < 32) return "";
        // We have enough bytes -> detect endianness.
        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = "";
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.write(buf);
};
Utf32AutoDecoder.prototype.end = function() {
    if (!this.decoder) {
        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = "";
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        var trail = this.decoder.end();
        if (trail) resStr += trail;
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.end();
};
function detectEncoding(bufs, defaultEncoding) {
    var b = [];
    var charsProcessed = 0;
    var invalidLE = 0;
    var invalidBE = 0 // Number of invalid chars when decoded as LE or BE.
    ;
    var bmpCharsLE = 0;
    var bmpCharsBE = 0 // Number of BMP chars when decoded as LE or BE.
    ;
    outerLoop: for(var i = 0; i < bufs.length; i++){
        var buf = bufs[i];
        for(var j = 0; j < buf.length; j++){
            b.push(buf[j]);
            if (b.length === 4) {
                if (charsProcessed === 0) {
                    // Check BOM first.
                    if (b[0] === 0xFF && b[1] === 0xFE && b[2] === 0 && b[3] === 0) return "utf-32le";
                    if (b[0] === 0 && b[1] === 0 && b[2] === 0xFE && b[3] === 0xFF) return "utf-32be";
                }
                if (b[0] !== 0 || b[1] > 0x10) invalidBE++;
                if (b[3] !== 0 || b[2] > 0x10) invalidLE++;
                if (b[0] === 0 && b[1] === 0 && (b[2] !== 0 || b[3] !== 0)) bmpCharsBE++;
                if ((b[0] !== 0 || b[1] !== 0) && b[2] === 0 && b[3] === 0) bmpCharsLE++;
                b.length = 0;
                charsProcessed++;
                if (charsProcessed >= 100) break outerLoop;
            }
        }
    }
    // Make decisions.
    if (bmpCharsBE - invalidBE > bmpCharsLE - invalidLE) return "utf-32be";
    if (bmpCharsBE - invalidBE < bmpCharsLE - invalidLE) return "utf-32le";
    // Couldn't decide (likely all zeros or not enough data).
    return defaultEncoding || "utf-32le";
}

},{"f9c116f4f75bb528":"254Bi"}],"hfFyY":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("8456d24d7088f48").Buffer;
// Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js
// == UTF16-BE codec. ==========================================================
exports.utf16be = Utf16BECodec;
function Utf16BECodec() {}
Utf16BECodec.prototype.encoder = Utf16BEEncoder;
Utf16BECodec.prototype.decoder = Utf16BEDecoder;
Utf16BECodec.prototype.bomAware = true;
// -- Encoding
function Utf16BEEncoder() {}
Utf16BEEncoder.prototype.write = function(str) {
    var buf = Buffer.from(str, "ucs2");
    for(var i = 0; i < buf.length; i += 2){
        var tmp = buf[i];
        buf[i] = buf[i + 1];
        buf[i + 1] = tmp;
    }
    return buf;
};
Utf16BEEncoder.prototype.end = function() {};
// -- Decoding
function Utf16BEDecoder() {
    this.overflowByte = -1;
}
Utf16BEDecoder.prototype.write = function(buf) {
    if (buf.length == 0) return "";
    var buf2 = Buffer.alloc(buf.length + 1);
    var i = 0;
    var j = 0;
    if (this.overflowByte !== -1) {
        buf2[0] = buf[0];
        buf2[1] = this.overflowByte;
        i = 1;
        j = 2;
    }
    for(; i < buf.length - 1; i += 2, j += 2){
        buf2[j] = buf[i + 1];
        buf2[j + 1] = buf[i];
    }
    this.overflowByte = i == buf.length - 1 ? buf[buf.length - 1] : -1;
    return buf2.slice(0, j).toString("ucs2");
};
Utf16BEDecoder.prototype.end = function() {
    this.overflowByte = -1;
};
// == UTF-16 codec =============================================================
// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
// Defaults to UTF-16LE, as it's prevalent and default in Node.
// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
exports.utf16 = Utf16Codec;
function Utf16Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
Utf16Codec.prototype.encoder = Utf16Encoder;
Utf16Codec.prototype.decoder = Utf16Decoder;
// -- Encoding (pass-through)
function Utf16Encoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined) options.addBOM = true;
    this.encoder = codec.iconv.getEncoder("utf-16le", options);
}
Utf16Encoder.prototype.write = function(str) {
    return this.encoder.write(str);
};
Utf16Encoder.prototype.end = function() {
    return this.encoder.end();
};
// -- Decoding
function Utf16Decoder(options, codec) {
    this.decoder = null;
    this.initialBufs = [];
    this.initialBufsLen = 0;
    this.options = options || {};
    this.iconv = codec.iconv;
}
Utf16Decoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBufs.push(buf);
        this.initialBufsLen += buf.length;
        if (this.initialBufsLen < 16) return "";
        // We have enough bytes -> detect endianness.
        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = "";
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.write(buf);
};
Utf16Decoder.prototype.end = function() {
    if (!this.decoder) {
        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = "";
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        var trail = this.decoder.end();
        if (trail) resStr += trail;
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.end();
};
function detectEncoding(bufs, defaultEncoding) {
    var b = [];
    var charsProcessed = 0;
    // Number of ASCII chars when decoded as LE or BE.
    var asciiCharsLE = 0;
    var asciiCharsBE = 0;
    outerLoop: for(var i = 0; i < bufs.length; i++){
        var buf = bufs[i];
        for(var j = 0; j < buf.length; j++){
            b.push(buf[j]);
            if (b.length === 2) {
                if (charsProcessed === 0) {
                    // Check BOM first.
                    if (b[0] === 0xFF && b[1] === 0xFE) return "utf-16le";
                    if (b[0] === 0xFE && b[1] === 0xFF) return "utf-16be";
                }
                if (b[0] === 0 && b[1] !== 0) asciiCharsBE++;
                if (b[0] !== 0 && b[1] === 0) asciiCharsLE++;
                b.length = 0;
                charsProcessed++;
                if (charsProcessed >= 100) break outerLoop;
            }
        }
    }
    // Make decisions.
    // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
    // So, we count ASCII as if it was LE or BE, and decide from that.
    if (asciiCharsBE > asciiCharsLE) return "utf-16be";
    if (asciiCharsBE < asciiCharsLE) return "utf-16le";
    // Couldn't decide (likely all zeros or not enough data).
    return defaultEncoding || "utf-16le";
}

},{"8456d24d7088f48":"254Bi"}],"khcb2":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("3ed47161966685ce").Buffer;
// UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
exports.utf7 = Utf7Codec;
exports.unicode11utf7 = "utf7" // Alias UNICODE-1-1-UTF-7
;
function Utf7Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
Utf7Codec.prototype.encoder = Utf7Encoder;
Utf7Codec.prototype.decoder = Utf7Decoder;
Utf7Codec.prototype.bomAware = true;
// -- Encoding
// Why scape ()?./?
// eslint-disable-next-line no-useless-escape
var nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
function Utf7Encoder(options, codec) {
    this.iconv = codec.iconv;
}
Utf7Encoder.prototype.write = function(str) {
    // Naive implementation.
    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
    return Buffer.from(str.replace(nonDirectChars, (function(chunk) {
        return "+" + (chunk === "+" ? "" : this.iconv.encode(chunk, "utf16-be").toString("base64").replace(/=+$/, "")) + "-";
    }).bind(this)));
};
Utf7Encoder.prototype.end = function() {};
// -- Decoding
function Utf7Decoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = "";
}
// Why scape /?
// eslint-disable-next-line no-useless-escape
var base64Regex = /[A-Za-z0-9\/+]/;
var base64Chars = [];
for(var i = 0; i < 256; i++)base64Chars[i] = base64Regex.test(String.fromCharCode(i));
var plusChar = "+".charCodeAt(0);
var minusChar = "-".charCodeAt(0);
var andChar = "&".charCodeAt(0);
Utf7Decoder.prototype.write = function(buf) {
    var res = "";
    var lastI = 0;
    var inBase64 = this.inBase64;
    var base64Accum = this.base64Accum;
    // The decoder is more involved as we must handle chunks in stream.
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // Write direct chars until '+'
        {
            if (buf[i] == plusChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii") // Write direct chars.
                ;
                lastI = i + 1;
                inBase64 = true;
            }
        } else if (!base64Chars[buf[i]]) {
            if (i == lastI && buf[i] == minusChar) res += "+";
            else {
                var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), "ascii");
                res += this.iconv.decode(Buffer.from(b64str, "base64"), "utf16-be");
            }
            if (buf[i] != minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = "";
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii") // Write direct chars.
    ;
    else {
        var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), "ascii");
        var canBeDecoded = b64str.length - b64str.length % 8 // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        ;
        base64Accum = b64str.slice(canBeDecoded) // The rest will be decoded in future.
        ;
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode(Buffer.from(b64str, "base64"), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
Utf7Decoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode(Buffer.from(this.base64Accum, "base64"), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = "";
    return res;
};
// UTF-7-IMAP codec.
// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
// Differences:
//  * Base64 part is started by "&" instead of "+"
//  * Direct characters are 0x20-0x7E, except "&" (0x26)
//  * In Base64, "," is used instead of "/"
//  * Base64 must not be used to represent direct characters.
//  * No implicit shift back from Base64 (should always end with '-')
//  * String must end in non-shifted position.
//  * "-&" while in base64 is not allowed.
exports.utf7imap = Utf7IMAPCodec;
function Utf7IMAPCodec(codecOptions, iconv) {
    this.iconv = iconv;
}
Utf7IMAPCodec.prototype.encoder = Utf7IMAPEncoder;
Utf7IMAPCodec.prototype.decoder = Utf7IMAPDecoder;
Utf7IMAPCodec.prototype.bomAware = true;
// -- Encoding
function Utf7IMAPEncoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = Buffer.alloc(6);
    this.base64AccumIdx = 0;
}
Utf7IMAPEncoder.prototype.write = function(str) {
    var inBase64 = this.inBase64;
    var base64Accum = this.base64Accum;
    var base64AccumIdx = this.base64AccumIdx;
    var buf = Buffer.alloc(str.length * 5 + 10);
    var bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var uChar = str.charCodeAt(i);
        if (uChar >= 0x20 && uChar <= 0x7E) {
            if (inBase64) {
                if (base64AccumIdx > 0) {
                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString("base64").replace(/\//g, ",").replace(/=+$/, ""), bufIdx);
                    base64AccumIdx = 0;
                }
                buf[bufIdx++] = minusChar // Write '-', then go to direct mode.
                ;
                inBase64 = false;
            }
            if (!inBase64) {
                buf[bufIdx++] = uChar // Write direct character
                ;
                if (uChar === andChar) buf[bufIdx++] = minusChar;
            }
        } else {
            if (!inBase64) {
                buf[bufIdx++] = andChar // Write '&', then go to base64 mode.
                ;
                inBase64 = true;
            }
            if (inBase64) {
                base64Accum[base64AccumIdx++] = uChar >> 8;
                base64Accum[base64AccumIdx++] = uChar & 0xFF;
                if (base64AccumIdx == base64Accum.length) {
                    bufIdx += buf.write(base64Accum.toString("base64").replace(/\//g, ","), bufIdx);
                    base64AccumIdx = 0;
                }
            }
        }
    }
    this.inBase64 = inBase64;
    this.base64AccumIdx = base64AccumIdx;
    return buf.slice(0, bufIdx);
};
Utf7IMAPEncoder.prototype.end = function() {
    var buf = Buffer.alloc(10);
    var bufIdx = 0;
    if (this.inBase64) {
        if (this.base64AccumIdx > 0) {
            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString("base64").replace(/\//g, ",").replace(/=+$/, ""), bufIdx);
            this.base64AccumIdx = 0;
        }
        buf[bufIdx++] = minusChar // Write '-', then go to direct mode.
        ;
        this.inBase64 = false;
    }
    return buf.slice(0, bufIdx);
};
// -- Decoding
function Utf7IMAPDecoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = "";
}
var base64IMAPChars = base64Chars.slice();
base64IMAPChars[",".charCodeAt(0)] = true;
Utf7IMAPDecoder.prototype.write = function(buf) {
    var res = "";
    var lastI = 0;
    var inBase64 = this.inBase64;
    var base64Accum = this.base64Accum;
    // The decoder is more involved as we must handle chunks in stream.
    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // Write direct chars until '&'
        {
            if (buf[i] == andChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii") // Write direct chars.
                ;
                lastI = i + 1;
                inBase64 = true;
            }
        } else if (!base64IMAPChars[buf[i]]) {
            if (i == lastI && buf[i] == minusChar) res += "&";
            else {
                var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), "ascii").replace(/,/g, "/");
                res += this.iconv.decode(Buffer.from(b64str, "base64"), "utf16-be");
            }
            if (buf[i] != minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = "";
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii") // Write direct chars.
    ;
    else {
        var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), "ascii").replace(/,/g, "/");
        var canBeDecoded = b64str.length - b64str.length % 8 // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        ;
        base64Accum = b64str.slice(canBeDecoded) // The rest will be decoded in future.
        ;
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode(Buffer.from(b64str, "base64"), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
Utf7IMAPDecoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode(Buffer.from(this.base64Accum, "base64"), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = "";
    return res;
};

},{"3ed47161966685ce":"254Bi"}],"1uKAP":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("83e04ce10fc2395e").Buffer;
// Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
// correspond to encoded bytes (if 128 - then lower half is ASCII).
exports._sbcs = SBCSCodec;
function SBCSCodec(codecOptions, iconv) {
    if (!codecOptions) throw new Error("SBCS codec is called without the data.");
    // Prepare char buffer for decoding.
    if (!codecOptions.chars || codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256) throw new Error("Encoding '" + codecOptions.type + "' has incorrect 'chars' (must be of len 128 or 256)");
    if (codecOptions.chars.length === 128) {
        var asciiString = "";
        for(var i = 0; i < 128; i++)asciiString += String.fromCharCode(i);
        codecOptions.chars = asciiString + codecOptions.chars;
    }
    this.decodeBuf = Buffer.from(codecOptions.chars, "ucs2");
    // Encoding buffer.
    var encodeBuf = Buffer.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));
    for(var i = 0; i < codecOptions.chars.length; i++)encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
    this.encodeBuf = encodeBuf;
}
SBCSCodec.prototype.encoder = SBCSEncoder;
SBCSCodec.prototype.decoder = SBCSDecoder;
function SBCSEncoder(options, codec) {
    this.encodeBuf = codec.encodeBuf;
}
SBCSEncoder.prototype.write = function(str) {
    var buf = Buffer.alloc(str.length);
    for(var i = 0; i < str.length; i++)buf[i] = this.encodeBuf[str.charCodeAt(i)];
    return buf;
};
SBCSEncoder.prototype.end = function() {};
function SBCSDecoder(options, codec) {
    this.decodeBuf = codec.decodeBuf;
}
SBCSDecoder.prototype.write = function(buf) {
    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
    var decodeBuf = this.decodeBuf;
    var newBuf = Buffer.alloc(buf.length * 2);
    var idx1 = 0;
    var idx2 = 0;
    for(var i = 0; i < buf.length; i++){
        idx1 = buf[i] * 2;
        idx2 = i * 2;
        newBuf[idx2] = decodeBuf[idx1];
        newBuf[idx2 + 1] = decodeBuf[idx1 + 1];
    }
    return newBuf.toString("ucs2");
};
SBCSDecoder.prototype.end = function() {};

},{"83e04ce10fc2395e":"254Bi"}],"gjdU9":[function(require,module,exports,__globalThis) {
"use strict";
// Manually added data to be used by sbcs codec in addition to generated one.
module.exports = {
    // Not supported by iconv, not sure why.
    10029: "maccenteuro",
    maccenteuro: {
        type: "_sbcs",
        chars: "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7"
    },
    808: "cp808",
    ibm808: "cp808",
    cp808: {
        type: "_sbcs",
        chars: "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\u20AC\u25A0\xa0"
    },
    mik: {
        type: "_sbcs",
        chars: "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2514\u2534\u252C\u251C\u2500\u253C\u2563\u2551\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2510\u2591\u2592\u2593\u2502\u2524\u2116\xa7\u2557\u255D\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    cp720: {
        type: "_sbcs",
        chars: "\x80\x81\xe9\xe2\x84\xe0\x86\xe7\xea\xeb\xe8\xef\xee\x8d\x8e\x8f\x90\u0651\u0652\xf4\xa4\u0640\xfb\xf9\u0621\u0622\u0623\u0624\xa3\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0636\u0637\u0638\u0639\u063A\u0641\xb5\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u2261\u064B\u064C\u064D\u064E\u064F\u0650\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    // Aliases of generated encodings.
    ascii8bit: "ascii",
    usascii: "ascii",
    ansix34: "ascii",
    ansix341968: "ascii",
    ansix341986: "ascii",
    csascii: "ascii",
    cp367: "ascii",
    ibm367: "ascii",
    isoir6: "ascii",
    iso646us: "ascii",
    iso646irv: "ascii",
    us: "ascii",
    latin1: "iso88591",
    latin2: "iso88592",
    latin3: "iso88593",
    latin4: "iso88594",
    latin5: "iso88599",
    latin6: "iso885910",
    latin7: "iso885913",
    latin8: "iso885914",
    latin9: "iso885915",
    latin10: "iso885916",
    csisolatin1: "iso88591",
    csisolatin2: "iso88592",
    csisolatin3: "iso88593",
    csisolatin4: "iso88594",
    csisolatincyrillic: "iso88595",
    csisolatinarabic: "iso88596",
    csisolatingreek: "iso88597",
    csisolatinhebrew: "iso88598",
    csisolatin5: "iso88599",
    csisolatin6: "iso885910",
    l1: "iso88591",
    l2: "iso88592",
    l3: "iso88593",
    l4: "iso88594",
    l5: "iso88599",
    l6: "iso885910",
    l7: "iso885913",
    l8: "iso885914",
    l9: "iso885915",
    l10: "iso885916",
    isoir14: "iso646jp",
    isoir57: "iso646cn",
    isoir100: "iso88591",
    isoir101: "iso88592",
    isoir109: "iso88593",
    isoir110: "iso88594",
    isoir144: "iso88595",
    isoir127: "iso88596",
    isoir126: "iso88597",
    isoir138: "iso88598",
    isoir148: "iso88599",
    isoir157: "iso885910",
    isoir166: "tis620",
    isoir179: "iso885913",
    isoir199: "iso885914",
    isoir203: "iso885915",
    isoir226: "iso885916",
    cp819: "iso88591",
    ibm819: "iso88591",
    cyrillic: "iso88595",
    arabic: "iso88596",
    arabic8: "iso88596",
    ecma114: "iso88596",
    asmo708: "iso88596",
    greek: "iso88597",
    greek8: "iso88597",
    ecma118: "iso88597",
    elot928: "iso88597",
    hebrew: "iso88598",
    hebrew8: "iso88598",
    iso88598i: "iso88598",
    iso88598e: "iso88598",
    turkish: "iso88599",
    turkish8: "iso88599",
    thai: "iso885911",
    thai8: "iso885911",
    celtic: "iso885914",
    celtic8: "iso885914",
    isoceltic: "iso885914",
    tis6200: "tis620",
    tis62025291: "tis620",
    tis62025330: "tis620",
    10000: "macroman",
    10006: "macgreek",
    10007: "maccyrillic",
    10079: "maciceland",
    10081: "macturkish",
    cspc8codepage437: "cp437",
    cspc775baltic: "cp775",
    cspc850multilingual: "cp850",
    cspcp852: "cp852",
    cspc862latinhebrew: "cp862",
    cpgr: "cp869",
    msee: "cp1250",
    mscyrl: "cp1251",
    msansi: "cp1252",
    msgreek: "cp1253",
    msturk: "cp1254",
    mshebr: "cp1255",
    msarab: "cp1256",
    winbaltrim: "cp1257",
    cp20866: "koi8r",
    20866: "koi8r",
    ibm878: "koi8r",
    cskoi8r: "koi8r",
    cp21866: "koi8u",
    21866: "koi8u",
    ibm1168: "koi8u",
    strk10482002: "rk1048",
    tcvn5712: "tcvn",
    tcvn57121: "tcvn",
    gb198880: "iso646cn",
    cn: "iso646cn",
    csiso14jisc6220ro: "iso646jp",
    jisc62201969ro: "iso646jp",
    jp: "iso646jp",
    cshproman8: "hproman8",
    r8: "hproman8",
    roman8: "hproman8",
    xroman8: "hproman8",
    ibm1051: "hproman8",
    mac: "macintosh",
    csmacintosh: "macintosh"
};

},{}],"9YNWH":[function(require,module,exports,__globalThis) {
"use strict";
// Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
module.exports = {
    "437": "cp437",
    "737": "cp737",
    "775": "cp775",
    "850": "cp850",
    "852": "cp852",
    "855": "cp855",
    "856": "cp856",
    "857": "cp857",
    "858": "cp858",
    "860": "cp860",
    "861": "cp861",
    "862": "cp862",
    "863": "cp863",
    "864": "cp864",
    "865": "cp865",
    "866": "cp866",
    "869": "cp869",
    "874": "windows874",
    "922": "cp922",
    "1046": "cp1046",
    "1124": "cp1124",
    "1125": "cp1125",
    "1129": "cp1129",
    "1133": "cp1133",
    "1161": "cp1161",
    "1162": "cp1162",
    "1163": "cp1163",
    "1250": "windows1250",
    "1251": "windows1251",
    "1252": "windows1252",
    "1253": "windows1253",
    "1254": "windows1254",
    "1255": "windows1255",
    "1256": "windows1256",
    "1257": "windows1257",
    "1258": "windows1258",
    "28591": "iso88591",
    "28592": "iso88592",
    "28593": "iso88593",
    "28594": "iso88594",
    "28595": "iso88595",
    "28596": "iso88596",
    "28597": "iso88597",
    "28598": "iso88598",
    "28599": "iso88599",
    "28600": "iso885910",
    "28601": "iso885911",
    "28603": "iso885913",
    "28604": "iso885914",
    "28605": "iso885915",
    "28606": "iso885916",
    "windows874": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\u2026\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "win874": "windows874",
    "cp874": "windows874",
    "windows1250": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\u0160\u2039\u015A\u0164\u017D\u0179\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0161\u203A\u015B\u0165\u017E\u017A\xa0\u02C7\u02D8\u0141\xa4\u0104\xa6\xa7\xa8\xa9\u015E\xab\xac\xad\xae\u017B\xb0\xb1\u02DB\u0142\xb4\xb5\xb6\xb7\xb8\u0105\u015F\xbb\u013D\u02DD\u013E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "win1250": "windows1250",
    "cp1250": "windows1250",
    "windows1251": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u040C\u040B\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u045C\u045B\u045F\xa0\u040E\u045E\u0408\xa4\u0490\xa6\xa7\u0401\xa9\u0404\xab\xac\xad\xae\u0407\xb0\xb1\u0406\u0456\u0491\xb5\xb6\xb7\u0451\u2116\u0454\xbb\u0458\u0405\u0455\u0457\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "win1251": "windows1251",
    "cp1251": "windows1251",
    "windows1252": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\u017D\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\u017E\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "win1252": "windows1252",
    "cp1252": "windows1252",
    "windows1253": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0385\u0386\xa3\xa4\xa5\xa6\xa7\xa8\xa9\uFFFD\xab\xac\xad\xae\u2015\xb0\xb1\xb2\xb3\u0384\xb5\xb6\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "win1253": "windows1253",
    "cp1253": "windows1253",
    "windows1254": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "win1254": "windows1254",
    "cp1254": "windows1254",
    "windows1255": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\xa1\xa2\xa3\u20AA\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbf\u05B0\u05B1\u05B2\u05B3\u05B4\u05B5\u05B6\u05B7\u05B8\u05B9\u05BA\u05BB\u05BC\u05BD\u05BE\u05BF\u05C0\u05C1\u05C2\u05C3\u05F0\u05F1\u05F2\u05F3\u05F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "win1255": "windows1255",
    "cp1255": "windows1255",
    "windows1256": {
        "type": "_sbcs",
        "chars": "\u20AC\u067E\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0679\u2039\u0152\u0686\u0698\u0688\u06AF\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u06A9\u2122\u0691\u203A\u0153\u200C\u200D\u06BA\xa0\u060C\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\u06BE\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\u061B\xbb\xbc\xbd\xbe\u061F\u06C1\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\xd7\u0637\u0638\u0639\u063A\u0640\u0641\u0642\u0643\xe0\u0644\xe2\u0645\u0646\u0647\u0648\xe7\xe8\xe9\xea\xeb\u0649\u064A\xee\xef\u064B\u064C\u064D\u064E\xf4\u064F\u0650\xf7\u0651\xf9\u0652\xfb\xfc\u200E\u200F\u06D2"
    },
    "win1256": "windows1256",
    "cp1256": "windows1256",
    "windows1257": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\xa8\u02C7\xb8\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\xaf\u02DB\uFFFD\xa0\uFFFD\xa2\xa3\xa4\uFFFD\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u02D9"
    },
    "win1257": "windows1257",
    "cp1257": "windows1257",
    "windows1258": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "win1258": "windows1258",
    "cp1258": "windows1258",
    "iso88591": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28591": "iso88591",
    "iso88592": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u02D8\u0141\xa4\u013D\u015A\xa7\xa8\u0160\u015E\u0164\u0179\xad\u017D\u017B\xb0\u0105\u02DB\u0142\xb4\u013E\u015B\u02C7\xb8\u0161\u015F\u0165\u017A\u02DD\u017E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "cp28592": "iso88592",
    "iso88593": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0126\u02D8\xa3\xa4\uFFFD\u0124\xa7\xa8\u0130\u015E\u011E\u0134\xad\uFFFD\u017B\xb0\u0127\xb2\xb3\xb4\xb5\u0125\xb7\xb8\u0131\u015F\u011F\u0135\xbd\uFFFD\u017C\xc0\xc1\xc2\uFFFD\xc4\u010A\u0108\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\uFFFD\xd1\xd2\xd3\xd4\u0120\xd6\xd7\u011C\xd9\xda\xdb\xdc\u016C\u015C\xdf\xe0\xe1\xe2\uFFFD\xe4\u010B\u0109\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\uFFFD\xf1\xf2\xf3\xf4\u0121\xf6\xf7\u011D\xf9\xfa\xfb\xfc\u016D\u015D\u02D9"
    },
    "cp28593": "iso88593",
    "iso88594": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0138\u0156\xa4\u0128\u013B\xa7\xa8\u0160\u0112\u0122\u0166\xad\u017D\xaf\xb0\u0105\u02DB\u0157\xb4\u0129\u013C\u02C7\xb8\u0161\u0113\u0123\u0167\u014A\u017E\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\u012A\u0110\u0145\u014C\u0136\xd4\xd5\xd6\xd7\xd8\u0172\xda\xdb\xdc\u0168\u016A\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\u012B\u0111\u0146\u014D\u0137\xf4\xf5\xf6\xf7\xf8\u0173\xfa\xfb\xfc\u0169\u016B\u02D9"
    },
    "cp28594": "iso88594",
    "iso88595": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0403\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0453\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "cp28595": "iso88595",
    "iso88596": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\uFFFD\uFFFD\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u060C\xad\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u061B\uFFFD\uFFFD\uFFFD\u061F\uFFFD\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\u0638\u0639\u063A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28596": "iso88596",
    "iso88597": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u2018\u2019\xa3\u20AC\u20AF\xa6\xa7\xa8\xa9\u037A\xab\xac\xad\uFFFD\u2015\xb0\xb1\xb2\xb3\u0384\u0385\u0386\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "cp28597": "iso88597",
    "iso88598": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2017\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "cp28598": "iso88598",
    "iso88599": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "cp28599": "iso88599",
    "iso885910": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0112\u0122\u012A\u0128\u0136\xa7\u013B\u0110\u0160\u0166\u017D\xad\u016A\u014A\xb0\u0105\u0113\u0123\u012B\u0129\u0137\xb7\u013C\u0111\u0161\u0167\u017E\u2015\u016B\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\xcf\xd0\u0145\u014C\xd3\xd4\xd5\xd6\u0168\xd8\u0172\xda\xdb\xdc\xdd\xde\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\xef\xf0\u0146\u014D\xf3\xf4\xf5\xf6\u0169\xf8\u0173\xfa\xfb\xfc\xfd\xfe\u0138"
    },
    "cp28600": "iso885910",
    "iso885911": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28601": "iso885911",
    "iso885913": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u201D\xa2\xa3\xa4\u201E\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\u201C\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u2019"
    },
    "cp28603": "iso885913",
    "iso885914": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u1E02\u1E03\xa3\u010A\u010B\u1E0A\xa7\u1E80\xa9\u1E82\u1E0B\u1EF2\xad\xae\u0178\u1E1E\u1E1F\u0120\u0121\u1E40\u1E41\xb6\u1E56\u1E81\u1E57\u1E83\u1E60\u1EF3\u1E84\u1E85\u1E61\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0174\xd1\xd2\xd3\xd4\xd5\xd6\u1E6A\xd8\xd9\xda\xdb\xdc\xdd\u0176\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0175\xf1\xf2\xf3\xf4\xf5\xf6\u1E6B\xf8\xf9\xfa\xfb\xfc\xfd\u0177\xff"
    },
    "cp28604": "iso885914",
    "iso885915": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\u0160\xa7\u0161\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u017D\xb5\xb6\xb7\u017E\xb9\xba\xbb\u0152\u0153\u0178\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28605": "iso885915",
    "iso885916": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0105\u0141\u20AC\u201E\u0160\xa7\u0161\xa9\u0218\xab\u0179\xad\u017A\u017B\xb0\xb1\u010C\u0142\u017D\u201D\xb6\xb7\u017E\u010D\u0219\xbb\u0152\u0153\u0178\u017C\xc0\xc1\xc2\u0102\xc4\u0106\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0110\u0143\xd2\xd3\xd4\u0150\xd6\u015A\u0170\xd9\xda\xdb\xdc\u0118\u021A\xdf\xe0\xe1\xe2\u0103\xe4\u0107\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0111\u0144\xf2\xf3\xf4\u0151\xf6\u015B\u0171\xf9\xfa\xfb\xfc\u0119\u021B\xff"
    },
    "cp28606": "iso885916",
    "cp437": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm437": "cp437",
    "csibm437": "cp437",
    "cp737": {
        "type": "_sbcs",
        "chars": "\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u03C5\u03C6\u03C7\u03C8\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03C9\u03AC\u03AD\u03AE\u03CA\u03AF\u03CC\u03CD\u03CB\u03CE\u0386\u0388\u0389\u038A\u038C\u038E\u038F\xb1\u2265\u2264\u03AA\u03AB\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm737": "cp737",
    "csibm737": "cp737",
    "cp775": {
        "type": "_sbcs",
        "chars": "\u0106\xfc\xe9\u0101\xe4\u0123\xe5\u0107\u0142\u0113\u0156\u0157\u012B\u0179\xc4\xc5\xc9\xe6\xc6\u014D\xf6\u0122\xa2\u015A\u015B\xd6\xdc\xf8\xa3\xd8\xd7\xa4\u0100\u012A\xf3\u017B\u017C\u017A\u201D\xa6\xa9\xae\xac\xbd\xbc\u0141\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0104\u010C\u0118\u0116\u2563\u2551\u2557\u255D\u012E\u0160\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0172\u016A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u017D\u0105\u010D\u0119\u0117\u012F\u0161\u0173\u016B\u017E\u2518\u250C\u2588\u2584\u258C\u2590\u2580\xd3\xdf\u014C\u0143\xf5\xd5\xb5\u0144\u0136\u0137\u013B\u013C\u0146\u0112\u0145\u2019\xad\xb1\u201C\xbe\xb6\xa7\xf7\u201E\xb0\u2219\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm775": "cp775",
    "csibm775": "cp775",
    "cp850": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u0131\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm850": "cp850",
    "csibm850": "cp850",
    "cp852": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\u016F\u0107\xe7\u0142\xeb\u0150\u0151\xee\u0179\xc4\u0106\xc9\u0139\u013A\xf4\xf6\u013D\u013E\u015A\u015B\xd6\xdc\u0164\u0165\u0141\xd7\u010D\xe1\xed\xf3\xfa\u0104\u0105\u017D\u017E\u0118\u0119\xac\u017A\u010C\u015F\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\u011A\u015E\u2563\u2551\u2557\u255D\u017B\u017C\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0102\u0103\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u0111\u0110\u010E\xcb\u010F\u0147\xcd\xce\u011B\u2518\u250C\u2588\u2584\u0162\u016E\u2580\xd3\xdf\xd4\u0143\u0144\u0148\u0160\u0161\u0154\xda\u0155\u0170\xfd\xdd\u0163\xb4\xad\u02DD\u02DB\u02C7\u02D8\xa7\xf7\xb8\xb0\xa8\u02D9\u0171\u0158\u0159\u25A0\xa0"
    },
    "ibm852": "cp852",
    "csibm852": "cp852",
    "cp855": {
        "type": "_sbcs",
        "chars": "\u0452\u0402\u0453\u0403\u0451\u0401\u0454\u0404\u0455\u0405\u0456\u0406\u0457\u0407\u0458\u0408\u0459\u0409\u045A\u040A\u045B\u040B\u045C\u040C\u045E\u040E\u045F\u040F\u044E\u042E\u044A\u042A\u0430\u0410\u0431\u0411\u0446\u0426\u0434\u0414\u0435\u0415\u0444\u0424\u0433\u0413\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0445\u0425\u0438\u0418\u2563\u2551\u2557\u255D\u0439\u0419\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u043A\u041A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u043B\u041B\u043C\u041C\u043D\u041D\u043E\u041E\u043F\u2518\u250C\u2588\u2584\u041F\u044F\u2580\u042F\u0440\u0420\u0441\u0421\u0442\u0422\u0443\u0423\u0436\u0416\u0432\u0412\u044C\u042C\u2116\xad\u044B\u042B\u0437\u0417\u0448\u0428\u044D\u042D\u0449\u0429\u0447\u0427\xa7\u25A0\xa0"
    },
    "ibm855": "cp855",
    "csibm855": "cp855",
    "cp856": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\xa3\uFFFD\xd7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xae\xac\xbd\xbc\uFFFD\xab\xbb\u2591\u2592\u2593\u2502\u2524\uFFFD\uFFFD\uFFFD\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\uFFFD\uFFFD\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2518\u250C\u2588\u2584\xa6\uFFFD\u2580\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xb5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm856": "cp856",
    "csibm856": "cp856",
    "cp857": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\u0131\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\u0130\xd6\xdc\xf8\xa3\xd8\u015E\u015F\xe1\xed\xf3\xfa\xf1\xd1\u011E\u011F\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xba\xaa\xca\xcb\xc8\uFFFD\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\uFFFD\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1\uFFFD\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm857": "cp857",
    "csibm857": "cp857",
    "cp858": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u20AC\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm858": "cp858",
    "csibm858": "cp858",
    "cp860": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe3\xe0\xc1\xe7\xea\xca\xe8\xcd\xd4\xec\xc3\xc2\xc9\xc0\xc8\xf4\xf5\xf2\xda\xf9\xcc\xd5\xdc\xa2\xa3\xd9\u20A7\xd3\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xd2\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm860": "cp860",
    "csibm860": "cp860",
    "cp861": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm861": "cp861",
    "csibm861": "cp861",
    "cp862": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm862": "cp862",
    "csibm862": "cp862",
    "cp863": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xc2\xe0\xb6\xe7\xea\xeb\xe8\xef\xee\u2017\xc0\xa7\xc9\xc8\xca\xf4\xcb\xcf\xfb\xf9\xa4\xd4\xdc\xa2\xa3\xd9\xdb\u0192\xa6\xb4\xf3\xfa\xa8\xb8\xb3\xaf\xce\u2310\xac\xbd\xbc\xbe\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm863": "cp863",
    "csibm863": "cp863",
    "cp864": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$\u066A&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xb0\xb7\u2219\u221A\u2592\u2500\u2502\u253C\u2524\u252C\u251C\u2534\u2510\u250C\u2514\u2518\u03B2\u221E\u03C6\xb1\xbd\xbc\u2248\xab\xbb\uFEF7\uFEF8\uFFFD\uFFFD\uFEFB\uFEFC\uFFFD\xa0\xad\uFE82\xa3\xa4\uFE84\uFFFD\uFFFD\uFE8E\uFE8F\uFE95\uFE99\u060C\uFE9D\uFEA1\uFEA5\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFED1\u061B\uFEB1\uFEB5\uFEB9\u061F\xa2\uFE80\uFE81\uFE83\uFE85\uFECA\uFE8B\uFE8D\uFE91\uFE93\uFE97\uFE9B\uFE9F\uFEA3\uFEA7\uFEA9\uFEAB\uFEAD\uFEAF\uFEB3\uFEB7\uFEBB\uFEBF\uFEC1\uFEC5\uFECB\uFECF\xa6\xac\xf7\xd7\uFEC9\u0640\uFED3\uFED7\uFEDB\uFEDF\uFEE3\uFEE7\uFEEB\uFEED\uFEEF\uFEF3\uFEBD\uFECC\uFECE\uFECD\uFEE1\uFE7D\u0651\uFEE5\uFEE9\uFEEC\uFEF0\uFEF2\uFED0\uFED5\uFEF5\uFEF6\uFEDD\uFED9\uFEF1\u25A0\uFFFD"
    },
    "ibm864": "cp864",
    "csibm864": "cp864",
    "cp865": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xa4\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm865": "cp865",
    "csibm865": "cp865",
    "cp866": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm866": "cp866",
    "csibm866": "cp866",
    "cp869": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0386\uFFFD\xb7\xac\xa6\u2018\u2019\u0388\u2015\u0389\u038A\u03AA\u038C\uFFFD\uFFFD\u038E\u03AB\xa9\u038F\xb2\xb3\u03AC\xa3\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03CD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\xbd\u0398\u0399\xab\xbb\u2591\u2592\u2593\u2502\u2524\u039A\u039B\u039C\u039D\u2563\u2551\u2557\u255D\u039E\u039F\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u03A0\u03A1\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u2518\u250C\u2588\u2584\u03B4\u03B5\u2580\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u0384\xad\xb1\u03C5\u03C6\u03C7\xa7\u03C8\u0385\xb0\xa8\u03C9\u03CB\u03B0\u03CE\u25A0\xa0"
    },
    "ibm869": "cp869",
    "csibm869": "cp869",
    "cp922": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\u203E\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0160\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\u017D\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0161\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\u017E\xff"
    },
    "ibm922": "cp922",
    "csibm922": "cp922",
    "cp1046": {
        "type": "_sbcs",
        "chars": "\uFE88\xd7\xf7\uF8F6\uF8F5\uF8F4\uF8F7\uFE71\x88\u25A0\u2502\u2500\u2510\u250C\u2514\u2518\uFE79\uFE7B\uFE7D\uFE7F\uFE77\uFE8A\uFEF0\uFEF3\uFEF2\uFECE\uFECF\uFED0\uFEF6\uFEF8\uFEFA\uFEFC\xa0\uF8FA\uF8F9\uF8F8\xa4\uF8FB\uFE8B\uFE91\uFE97\uFE9B\uFE9F\uFEA3\u060C\xad\uFEA7\uFEB3\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFEB7\u061B\uFEBB\uFEBF\uFECA\u061F\uFECB\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\uFEC7\u0639\u063A\uFECC\uFE82\uFE84\uFE8E\uFED3\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFED7\uFEDB\uFEDF\uF8FC\uFEF5\uFEF7\uFEF9\uFEFB\uFEE3\uFEE7\uFEEC\uFEE9\uFFFD"
    },
    "ibm1046": "cp1046",
    "csibm1046": "cp1046",
    "cp1124": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0490\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0491\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "ibm1124": "cp1124",
    "csibm1124": "cp1124",
    "cp1125": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0490\u0491\u0404\u0454\u0406\u0456\u0407\u0457\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm1125": "cp1125",
    "csibm1125": "cp1125",
    "cp1129": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1129": "cp1129",
    "csibm1129": "cp1129",
    "cp1133": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E81\u0E82\u0E84\u0E87\u0E88\u0EAA\u0E8A\u0E8D\u0E94\u0E95\u0E96\u0E97\u0E99\u0E9A\u0E9B\u0E9C\u0E9D\u0E9E\u0E9F\u0EA1\u0EA2\u0EA3\u0EA5\u0EA7\u0EAB\u0EAD\u0EAE\uFFFD\uFFFD\uFFFD\u0EAF\u0EB0\u0EB2\u0EB3\u0EB4\u0EB5\u0EB6\u0EB7\u0EB8\u0EB9\u0EBC\u0EB1\u0EBB\u0EBD\uFFFD\uFFFD\uFFFD\u0EC0\u0EC1\u0EC2\u0EC3\u0EC4\u0EC8\u0EC9\u0ECA\u0ECB\u0ECC\u0ECD\u0EC6\uFFFD\u0EDC\u0EDD\u20AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0ED0\u0ED1\u0ED2\u0ED3\u0ED4\u0ED5\u0ED6\u0ED7\u0ED8\u0ED9\uFFFD\uFFFD\xa2\xac\xa6\uFFFD"
    },
    "ibm1133": "cp1133",
    "csibm1133": "cp1133",
    "cp1161": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E48\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\u0E49\u0E4A\u0E4B\u20AC\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\xa2\xac\xa6\xa0"
    },
    "ibm1161": "cp1161",
    "csibm1161": "cp1161",
    "cp1162": {
        "type": "_sbcs",
        "chars": "\u20AC\x81\x82\x83\x84\u2026\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "ibm1162": "cp1162",
    "csibm1162": "cp1162",
    "cp1163": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1163": "cp1163",
    "csibm1163": "cp1163",
    "maccroatian": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u2126\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uFFFD\xa9\u2044\xa4\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7"
    },
    "maccyrillic": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\xa2\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u2202\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "macgreek": {
        "type": "_sbcs",
        "chars": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\xad\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\u0387\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\uFFFD"
    },
    "maciceland": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macroman": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macromania": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u015E\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\u0103\u015F\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\u0162\u0163\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macthai": {
        "type": "_sbcs",
        "chars": "\xab\xbb\u2026\uF88C\uF88F\uF892\uF895\uF898\uF88B\uF88E\uF891\uF894\uF897\u201C\u201D\uF899\uFFFD\u2022\uF884\uF889\uF885\uF886\uF887\uF888\uF88A\uF88D\uF890\uF893\uF896\u2018\u2019\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFEFF\u200B\u2013\u2014\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u2122\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\xae\xa9\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "macturkish": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\uFFFD\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macukraine": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\u0490\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u0491\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "koi8r": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u2553\u2554\u2555\u2556\u2557\u2558\u2559\u255A\u255B\u255C\u255D\u255E\u255F\u2560\u2561\u0401\u2562\u2563\u2564\u2565\u2566\u2567\u2568\u2569\u256A\u256B\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8u": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u255D\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8ru": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u045E\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u040E\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8t": {
        "type": "_sbcs",
        "chars": "\u049B\u0493\u201A\u0492\u201E\u2026\u2020\u2021\uFFFD\u2030\u04B3\u2039\u04B2\u04B7\u04B6\uFFFD\u049A\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u04EF\u04EE\u0451\xa4\u04E3\xa6\xa7\uFFFD\uFFFD\uFFFD\xab\xac\xad\xae\uFFFD\xb0\xb1\xb2\u0401\uFFFD\u04E2\xb6\xb7\uFFFD\u2116\uFFFD\xbb\uFFFD\uFFFD\uFFFD\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "armscii8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\u0587\u0589)(\xbb\xab\u2014.\u055D,-\u058A\u2026\u055C\u055B\u055E\u0531\u0561\u0532\u0562\u0533\u0563\u0534\u0564\u0535\u0565\u0536\u0566\u0537\u0567\u0538\u0568\u0539\u0569\u053A\u056A\u053B\u056B\u053C\u056C\u053D\u056D\u053E\u056E\u053F\u056F\u0540\u0570\u0541\u0571\u0542\u0572\u0543\u0573\u0544\u0574\u0545\u0575\u0546\u0576\u0547\u0577\u0548\u0578\u0549\u0579\u054A\u057A\u054B\u057B\u054C\u057C\u054D\u057D\u054E\u057E\u054F\u057F\u0550\u0580\u0551\u0581\u0552\u0582\u0553\u0583\u0554\u0584\u0555\u0585\u0556\u0586\u055A\uFFFD"
    },
    "rk1048": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u049A\u04BA\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u049B\u04BB\u045F\xa0\u04B0\u04B1\u04D8\xa4\u04E8\xa6\xa7\u0401\xa9\u0492\xab\xac\xad\xae\u04AE\xb0\xb1\u0406\u0456\u04E9\xb5\xb6\xb7\u0451\u2116\u0493\xbb\u04D9\u04A2\u04A3\u04AF\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "tcvn": {
        "type": "_sbcs",
        "chars": "\0\xda\u1EE4\x03\u1EEA\u1EEC\u1EEE\x07\b	\n\v\f\r\x0e\x0f\x10\u1EE8\u1EF0\u1EF2\u1EF6\u1EF8\xdd\u1EF4\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc0\u1EA2\xc3\xc1\u1EA0\u1EB6\u1EAC\xc8\u1EBA\u1EBC\xc9\u1EB8\u1EC6\xcc\u1EC8\u0128\xcd\u1ECA\xd2\u1ECE\xd5\xd3\u1ECC\u1ED8\u1EDC\u1EDE\u1EE0\u1EDA\u1EE2\xd9\u1EE6\u0168\xa0\u0102\xc2\xca\xd4\u01A0\u01AF\u0110\u0103\xe2\xea\xf4\u01A1\u01B0\u0111\u1EB0\u0300\u0309\u0303\u0301\u0323\xe0\u1EA3\xe3\xe1\u1EA1\u1EB2\u1EB1\u1EB3\u1EB5\u1EAF\u1EB4\u1EAE\u1EA6\u1EA8\u1EAA\u1EA4\u1EC0\u1EB7\u1EA7\u1EA9\u1EAB\u1EA5\u1EAD\xe8\u1EC2\u1EBB\u1EBD\xe9\u1EB9\u1EC1\u1EC3\u1EC5\u1EBF\u1EC7\xec\u1EC9\u1EC4\u1EBE\u1ED2\u0129\xed\u1ECB\xf2\u1ED4\u1ECF\xf5\xf3\u1ECD\u1ED3\u1ED5\u1ED7\u1ED1\u1ED9\u1EDD\u1EDF\u1EE1\u1EDB\u1EE3\xf9\u1ED6\u1EE7\u0169\xfa\u1EE5\u1EEB\u1EED\u1EEF\u1EE9\u1EF1\u1EF3\u1EF7\u1EF9\xfd\u1EF5\u1ED0"
    },
    "georgianacademy": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10EF\u10F0\u10F1\u10F2\u10F3\u10F4\u10F5\u10F6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "georgianps": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10F1\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10F2\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10F3\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10F4\u10EF\u10F0\u10F5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "pt154": {
        "type": "_sbcs",
        "chars": "\u0496\u0492\u04EE\u0493\u201E\u2026\u04B6\u04AE\u04B2\u04AF\u04A0\u04E2\u04A2\u049A\u04BA\u04B8\u0497\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u04B3\u04B7\u04A1\u04E3\u04A3\u049B\u04BB\u04B9\xa0\u040E\u045E\u0408\u04E8\u0498\u04B0\xa7\u0401\xa9\u04D8\xab\xac\u04EF\xae\u049C\xb0\u04B1\u0406\u0456\u0499\u04E9\xb6\xb7\u0451\u2116\u04D9\xbb\u0458\u04AA\u04AB\u049D\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "viscii": {
        "type": "_sbcs",
        "chars": "\0\x01\u1EB2\x03\x04\u1EB4\u1EAA\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\u1EF6\x15\x16\x17\x18\u1EF8\x1a\x1b\x1c\x1d\u1EF4\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u1EA0\u1EAE\u1EB0\u1EB6\u1EA4\u1EA6\u1EA8\u1EAC\u1EBC\u1EB8\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EE2\u1EDA\u1EDC\u1EDE\u1ECA\u1ECE\u1ECC\u1EC8\u1EE6\u0168\u1EE4\u1EF2\xd5\u1EAF\u1EB1\u1EB7\u1EA5\u1EA7\u1EA9\u1EAD\u1EBD\u1EB9\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1ED1\u1ED3\u1ED5\u1ED7\u1EE0\u01A0\u1ED9\u1EDD\u1EDF\u1ECB\u1EF0\u1EE8\u1EEA\u1EEC\u01A1\u1EDB\u01AF\xc0\xc1\xc2\xc3\u1EA2\u0102\u1EB3\u1EB5\xc8\xc9\xca\u1EBA\xcc\xcd\u0128\u1EF3\u0110\u1EE9\xd2\xd3\xd4\u1EA1\u1EF7\u1EEB\u1EED\xd9\xda\u1EF9\u1EF5\xdd\u1EE1\u01B0\xe0\xe1\xe2\xe3\u1EA3\u0103\u1EEF\u1EAB\xe8\xe9\xea\u1EBB\xec\xed\u0129\u1EC9\u0111\u1EF1\xf2\xf3\xf4\xf5\u1ECF\u1ECD\u1EE5\xf9\xfa\u0169\u1EE7\xfd\u1EE3\u1EEE"
    },
    "iso646cn": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#\xa5%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "iso646jp": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\xa5]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "hproman8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xc0\xc2\xc8\xca\xcb\xce\xcf\xb4\u02CB\u02C6\xa8\u02DC\xd9\xdb\u20A4\xaf\xdd\xfd\xb0\xc7\xe7\xd1\xf1\xa1\xbf\xa4\xa3\xa5\xa7\u0192\xa2\xe2\xea\xf4\xfb\xe1\xe9\xf3\xfa\xe0\xe8\xf2\xf9\xe4\xeb\xf6\xfc\xc5\xee\xd8\xc6\xe5\xed\xf8\xe6\xc4\xec\xd6\xdc\xc9\xef\xdf\xd4\xc1\xc3\xe3\xd0\xf0\xcd\xcc\xd3\xd2\xd5\xf5\u0160\u0161\xda\u0178\xff\xde\xfe\xb7\xb5\xb6\xbe\u2014\xbc\xbd\xaa\xba\xab\u25A0\xbb\xb1\uFFFD"
    },
    "macintosh": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "ascii": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "tis620": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    }
};

},{}],"dhW5E":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("28f0481976da1ca4").Buffer;
// Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
// To save memory and loading time, we read table files only when requested.
exports._dbcs = DBCSCodec;
var UNASSIGNED = -1;
var GB18030_CODE = -2;
var SEQ_START = -10;
var NODE_START = -1000;
var UNASSIGNED_NODE = new Array(0x100);
var DEF_CHAR = -1;
for(var i = 0; i < 0x100; i++)UNASSIGNED_NODE[i] = UNASSIGNED;
// Class DBCSCodec reads and initializes mapping tables.
function DBCSCodec(codecOptions, iconv) {
    this.encodingName = codecOptions.encodingName;
    if (!codecOptions) throw new Error("DBCS codec is called without the data.");
    if (!codecOptions.table) throw new Error("Encoding '" + this.encodingName + "' has no data.");
    // Load tables.
    var mappingTable = codecOptions.table();
    // Decode tables: MBCS -> Unicode.
    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
    // Trie root is decodeTables[0].
    // Values: >=  0 -> unicode character code. can be > 0xFFFF
    //         == UNASSIGNED -> unknown/unassigned sequence.
    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
    //         <= NODE_START -> index of the next node in our trie to process next byte.
    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
    this.decodeTables = [];
    this.decodeTables[0] = UNASSIGNED_NODE.slice(0) // Create root node.
    ;
    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here.
    this.decodeTableSeq = [];
    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
    for(var i = 0; i < mappingTable.length; i++)this._addDecodeChunk(mappingTable[i]);
    // Load & create GB18030 tables when needed.
    if (typeof codecOptions.gb18030 === "function") {
        this.gb18030 = codecOptions.gb18030() // Load GB18030 ranges.
        ;
        // Add GB18030 common decode nodes.
        var commonThirdByteNodeIdx = this.decodeTables.length;
        this.decodeTables.push(UNASSIGNED_NODE.slice(0));
        var commonFourthByteNodeIdx = this.decodeTables.length;
        this.decodeTables.push(UNASSIGNED_NODE.slice(0));
        // Fill out the tree
        var firstByteNode = this.decodeTables[0];
        for(var i = 0x81; i <= 0xFE; i++){
            var secondByteNode = this.decodeTables[NODE_START - firstByteNode[i]];
            for(var j = 0x30; j <= 0x39; j++){
                if (secondByteNode[j] === UNASSIGNED) secondByteNode[j] = NODE_START - commonThirdByteNodeIdx;
                else if (secondByteNode[j] > NODE_START) throw new Error("gb18030 decode tables conflict at byte 2");
                var thirdByteNode = this.decodeTables[NODE_START - secondByteNode[j]];
                for(var k = 0x81; k <= 0xFE; k++){
                    if (thirdByteNode[k] === UNASSIGNED) thirdByteNode[k] = NODE_START - commonFourthByteNodeIdx;
                    else if (thirdByteNode[k] === NODE_START - commonFourthByteNodeIdx) continue;
                    else if (thirdByteNode[k] > NODE_START) throw new Error("gb18030 decode tables conflict at byte 3");
                    var fourthByteNode = this.decodeTables[NODE_START - thirdByteNode[k]];
                    for(var l = 0x30; l <= 0x39; l++)if (fourthByteNode[l] === UNASSIGNED) fourthByteNode[l] = GB18030_CODE;
                }
            }
        }
    }
    this.defaultCharUnicode = iconv.defaultCharUnicode;
    // Encode tables: Unicode -> DBCS.
    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
    //         == UNASSIGNED -> no conversion found. Output a default char.
    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
    this.encodeTable = [];
    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
    // means end of sequence (needed when one sequence is a strict subsequence of another).
    // Objects are kept separately from encodeTable to increase performance.
    this.encodeTableSeq = [];
    // Some chars can be decoded, but need not be encoded.
    var skipEncodeChars = {};
    if (codecOptions.encodeSkipVals) for(var i = 0; i < codecOptions.encodeSkipVals.length; i++){
        var val = codecOptions.encodeSkipVals[i];
        if (typeof val === "number") skipEncodeChars[val] = true;
        else for(var j = val.from; j <= val.to; j++)skipEncodeChars[j] = true;
    }
    // Use decode trie to recursively fill out encode tables.
    this._fillEncodeTable(0, 0, skipEncodeChars);
    // Add more encoding pairs when needed.
    if (codecOptions.encodeAdd) {
        for(var uChar in codecOptions.encodeAdd)if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar)) this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
    }
    this.defCharSB = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
    if (this.defCharSB === UNASSIGNED) this.defCharSB = this.encodeTable[0]["?"];
    if (this.defCharSB === UNASSIGNED) this.defCharSB = "?".charCodeAt(0);
}
DBCSCodec.prototype.encoder = DBCSEncoder;
DBCSCodec.prototype.decoder = DBCSDecoder;
// Decoder helpers
DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
    var bytes = [];
    for(; addr > 0; addr >>>= 8)bytes.push(addr & 0xFF);
    if (bytes.length == 0) bytes.push(0);
    var node = this.decodeTables[0];
    for(var i = bytes.length - 1; i > 0; i--){
        var val = node[bytes[i]];
        if (val == UNASSIGNED) {
            node[bytes[i]] = NODE_START - this.decodeTables.length;
            this.decodeTables.push(node = UNASSIGNED_NODE.slice(0));
        } else if (val <= NODE_START) node = this.decodeTables[NODE_START - val];
        else throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
    }
    return node;
};
DBCSCodec.prototype._addDecodeChunk = function(chunk) {
    // First element of chunk is the hex mbcs code where we start.
    var curAddr = parseInt(chunk[0], 16);
    // Choose the decoding node where we'll write our chars.
    var writeTable = this._getDecodeTrieNode(curAddr);
    curAddr = curAddr & 0xFF;
    // Write all other elements of the chunk to the table.
    for(var k = 1; k < chunk.length; k++){
        var part = chunk[k];
        if (typeof part === "string") for(var l = 0; l < part.length;){
            var code = part.charCodeAt(l++);
            if (code >= 0xD800 && code < 0xDC00) {
                var codeTrail = part.charCodeAt(l++);
                if (codeTrail >= 0xDC00 && codeTrail < 0xE000) writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                else throw new Error("Incorrect surrogate pair in " + this.encodingName + " at chunk " + chunk[0]);
            } else if (code > 0x0FF0 && code <= 0x0FFF) {
                var len = 0xFFF - code + 2;
                var seq = [];
                for(var m = 0; m < len; m++)seq.push(part.charCodeAt(l++));
                 // Simple variation: don't support surrogates or subsequences in seq.
                writeTable[curAddr++] = SEQ_START - this.decodeTableSeq.length;
                this.decodeTableSeq.push(seq);
            } else writeTable[curAddr++] = code;
             // Basic char
        }
        else if (typeof part === "number") {
            var charCode = writeTable[curAddr - 1] + 1;
            for(var l = 0; l < part; l++)writeTable[curAddr++] = charCode++;
        } else throw new Error("Incorrect type '" + typeof part + "' given in " + this.encodingName + " at chunk " + chunk[0]);
    }
    if (curAddr > 0xFF) throw new Error("Incorrect chunk in " + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
};
// Encoder helpers
DBCSCodec.prototype._getEncodeBucket = function(uCode) {
    var high = uCode >> 8 // This could be > 0xFF because of astral characters.
    ;
    if (this.encodeTable[high] === undefined) this.encodeTable[high] = UNASSIGNED_NODE.slice(0);
     // Create bucket on demand.
    return this.encodeTable[high];
};
DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    if (bucket[low] <= SEQ_START) this.encodeTableSeq[SEQ_START - bucket[low]][DEF_CHAR] = dbcsCode;
    else if (bucket[low] == UNASSIGNED) bucket[low] = dbcsCode;
};
DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
    // Get the root of character tree according to first character of the sequence.
    var uCode = seq[0];
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    var node;
    if (bucket[low] <= SEQ_START) // There's already a sequence with  - use it.
    node = this.encodeTableSeq[SEQ_START - bucket[low]];
    else {
        // There was no sequence object - allocate a new one.
        node = {};
        if (bucket[low] !== UNASSIGNED) node[DEF_CHAR] = bucket[low] // If a char was set before - make it a single-char subsequence.
        ;
        bucket[low] = SEQ_START - this.encodeTableSeq.length;
        this.encodeTableSeq.push(node);
    }
    // Traverse the character tree, allocating new nodes as needed.
    for(var j = 1; j < seq.length - 1; j++){
        var oldVal = node[uCode];
        if (typeof oldVal === "object") node = oldVal;
        else {
            node = node[uCode] = {};
            if (oldVal !== undefined) node[DEF_CHAR] = oldVal;
        }
    }
    // Set the leaf to given dbcsCode.
    uCode = seq[seq.length - 1];
    node[uCode] = dbcsCode;
};
DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
    var node = this.decodeTables[nodeIdx];
    var hasValues = false;
    var subNodeEmpty = {};
    for(var i = 0; i < 0x100; i++){
        var uCode = node[i];
        var mbCode = prefix + i;
        if (skipEncodeChars[mbCode]) continue;
        if (uCode >= 0) {
            this._setEncodeChar(uCode, mbCode);
            hasValues = true;
        } else if (uCode <= NODE_START) {
            var subNodeIdx = NODE_START - uCode;
            if (!subNodeEmpty[subNodeIdx]) {
                var newPrefix = mbCode << 8 >>> 0 // NOTE: '>>> 0' keeps 32-bit num positive.
                ;
                if (this._fillEncodeTable(subNodeIdx, newPrefix, skipEncodeChars)) hasValues = true;
                else subNodeEmpty[subNodeIdx] = true;
            }
        } else if (uCode <= SEQ_START) {
            this._setEncodeSequence(this.decodeTableSeq[SEQ_START - uCode], mbCode);
            hasValues = true;
        }
    }
    return hasValues;
};
// == Encoder ==================================================================
function DBCSEncoder(options, codec) {
    // Encoder state
    this.leadSurrogate = -1;
    this.seqObj = undefined;
    // Static data
    this.encodeTable = codec.encodeTable;
    this.encodeTableSeq = codec.encodeTableSeq;
    this.defaultCharSingleByte = codec.defCharSB;
    this.gb18030 = codec.gb18030;
}
DBCSEncoder.prototype.write = function(str) {
    var newBuf = Buffer.alloc(str.length * (this.gb18030 ? 4 : 3));
    var leadSurrogate = this.leadSurrogate;
    var seqObj = this.seqObj;
    var nextChar = -1;
    var i = 0;
    var j = 0;
    while(true){
        // 0. Get next character.
        if (nextChar === -1) {
            if (i == str.length) break;
            var uCode = str.charCodeAt(i++);
        } else {
            var uCode = nextChar;
            nextChar = -1;
        }
        // 1. Handle surrogates.
        if (uCode >= 0xD800 && uCode < 0xE000) {
            if (uCode < 0xDC00) {
                if (leadSurrogate === -1) {
                    leadSurrogate = uCode;
                    continue;
                } else {
                    leadSurrogate = uCode;
                    // Double lead surrogate found.
                    uCode = UNASSIGNED;
                }
            } else if (leadSurrogate !== -1) {
                uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                leadSurrogate = -1;
            } else // Incomplete surrogate pair - only trail surrogate found.
            uCode = UNASSIGNED;
        } else if (leadSurrogate !== -1) {
            // Incomplete surrogate pair - only lead surrogate found.
            nextChar = uCode;
            uCode = UNASSIGNED // Write an error, then current char.
            ;
            leadSurrogate = -1;
        }
        // 2. Convert uCode character.
        var dbcsCode = UNASSIGNED;
        if (seqObj !== undefined && uCode != UNASSIGNED) {
            var resCode = seqObj[uCode];
            if (typeof resCode === "object") {
                seqObj = resCode;
                continue;
            } else if (typeof resCode === "number") dbcsCode = resCode;
            else if (resCode == undefined) {
                // Try default character for this sequence
                resCode = seqObj[DEF_CHAR];
                if (resCode !== undefined) {
                    dbcsCode = resCode // Found. Write it.
                    ;
                    nextChar = uCode // Current character will be written too in the next iteration.
                    ;
                }
            }
            seqObj = undefined;
        } else if (uCode >= 0) {
            var subtable = this.encodeTable[uCode >> 8];
            if (subtable !== undefined) dbcsCode = subtable[uCode & 0xFF];
            if (dbcsCode <= SEQ_START) {
                seqObj = this.encodeTableSeq[SEQ_START - dbcsCode];
                continue;
            }
            if (dbcsCode == UNASSIGNED && this.gb18030) {
                // Use GB18030 algorithm to find character(s) to write.
                var idx = findIdx(this.gb18030.uChars, uCode);
                if (idx != -1) {
                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600);
                    dbcsCode = dbcsCode % 12600;
                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260);
                    dbcsCode = dbcsCode % 1260;
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10);
                    dbcsCode = dbcsCode % 10;
                    newBuf[j++] = 0x30 + dbcsCode;
                    continue;
                }
            }
        }
        // 3. Write dbcsCode character.
        if (dbcsCode === UNASSIGNED) dbcsCode = this.defaultCharSingleByte;
        if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
        else if (dbcsCode < 0x10000) {
            newBuf[j++] = dbcsCode >> 8 // high byte
            ;
            newBuf[j++] = dbcsCode & 0xFF // low byte
            ;
        } else if (dbcsCode < 0x1000000) {
            newBuf[j++] = dbcsCode >> 16;
            newBuf[j++] = dbcsCode >> 8 & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        } else {
            newBuf[j++] = dbcsCode >>> 24;
            newBuf[j++] = dbcsCode >>> 16 & 0xFF;
            newBuf[j++] = dbcsCode >>> 8 & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        }
    }
    this.seqObj = seqObj;
    this.leadSurrogate = leadSurrogate;
    return newBuf.slice(0, j);
};
DBCSEncoder.prototype.end = function() {
    if (this.leadSurrogate === -1 && this.seqObj === undefined) return;
     // All clean. Most often case.
    var newBuf = Buffer.alloc(10);
    var j = 0;
    if (this.seqObj) {
        var dbcsCode = this.seqObj[DEF_CHAR];
        if (dbcsCode !== undefined) {
            if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
            else {
                newBuf[j++] = dbcsCode >> 8 // high byte
                ;
                newBuf[j++] = dbcsCode & 0xFF // low byte
                ;
            }
        } else ;
        this.seqObj = undefined;
    }
    if (this.leadSurrogate !== -1) {
        // Incomplete surrogate pair - only lead surrogate found.
        newBuf[j++] = this.defaultCharSingleByte;
        this.leadSurrogate = -1;
    }
    return newBuf.slice(0, j);
};
// Export for testing
DBCSEncoder.prototype.findIdx = findIdx;
// == Decoder ==================================================================
function DBCSDecoder(options, codec) {
    // Decoder state
    this.nodeIdx = 0;
    this.prevBytes = [];
    // Static data
    this.decodeTables = codec.decodeTables;
    this.decodeTableSeq = codec.decodeTableSeq;
    this.defaultCharUnicode = codec.defaultCharUnicode;
    this.gb18030 = codec.gb18030;
}
DBCSDecoder.prototype.write = function(buf) {
    var newBuf = Buffer.alloc(buf.length * 2);
    var nodeIdx = this.nodeIdx;
    var prevBytes = this.prevBytes;
    var prevOffset = this.prevBytes.length;
    var seqStart = -this.prevBytes.length // idx of the start of current parsed sequence.
    ;
    var uCode;
    for(var i = 0, j = 0; i < buf.length; i++){
        var curByte = i >= 0 ? buf[i] : prevBytes[i + prevOffset];
        // Lookup in current trie node.
        var uCode = this.decodeTables[nodeIdx][curByte];
        if (uCode >= 0) ;
        else if (uCode === UNASSIGNED) {
            // TODO: Callback with seq.
            uCode = this.defaultCharUnicode.charCodeAt(0);
            i = seqStart // Skip one byte ('i' will be incremented by the for loop) and try to parse again.
            ;
        } else if (uCode === GB18030_CODE) {
            if (i >= 3) var ptr = (buf[i - 3] - 0x81) * 12600 + (buf[i - 2] - 0x30) * 1260 + (buf[i - 1] - 0x81) * 10 + (curByte - 0x30);
            else var ptr = (prevBytes[i - 3 + prevOffset] - 0x81) * 12600 + ((i - 2 >= 0 ? buf[i - 2] : prevBytes[i - 2 + prevOffset]) - 0x30) * 1260 + ((i - 1 >= 0 ? buf[i - 1] : prevBytes[i - 1 + prevOffset]) - 0x81) * 10 + (curByte - 0x30);
            var idx = findIdx(this.gb18030.gbChars, ptr);
            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
        } else if (uCode <= NODE_START) {
            nodeIdx = NODE_START - uCode;
            continue;
        } else if (uCode <= SEQ_START) {
            var seq = this.decodeTableSeq[SEQ_START - uCode];
            for(var k = 0; k < seq.length - 1; k++){
                uCode = seq[k];
                newBuf[j++] = uCode & 0xFF;
                newBuf[j++] = uCode >> 8;
            }
            uCode = seq[seq.length - 1];
        } else throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);
        // Write the character to buffer, handling higher planes using surrogate pair.
        if (uCode >= 0x10000) {
            uCode -= 0x10000;
            var uCodeLead = 0xD800 | uCode >> 10;
            newBuf[j++] = uCodeLead & 0xFF;
            newBuf[j++] = uCodeLead >> 8;
            uCode = 0xDC00 | uCode & 0x3FF;
        }
        newBuf[j++] = uCode & 0xFF;
        newBuf[j++] = uCode >> 8;
        // Reset trie node.
        nodeIdx = 0;
        seqStart = i + 1;
    }
    this.nodeIdx = nodeIdx;
    this.prevBytes = seqStart >= 0 ? Array.prototype.slice.call(buf, seqStart) : prevBytes.slice(seqStart + prevOffset).concat(Array.prototype.slice.call(buf));
    return newBuf.slice(0, j).toString("ucs2");
};
DBCSDecoder.prototype.end = function() {
    var ret = "";
    // Try to parse all remaining chars.
    while(this.prevBytes.length > 0){
        // Skip 1 character in the buffer.
        ret += this.defaultCharUnicode;
        var bytesArr = this.prevBytes.slice(1);
        // Parse remaining as usual.
        this.prevBytes = [];
        this.nodeIdx = 0;
        if (bytesArr.length > 0) ret += this.write(bytesArr);
    }
    this.prevBytes = [];
    this.nodeIdx = 0;
    return ret;
};
// Binary search for GB18030. Returns largest i such that table[i] <= val.
function findIdx(table, val) {
    if (table[0] > val) return -1;
    var l = 0;
    var r = table.length;
    while(l < r - 1){
        var mid = l + (r - l + 1 >> 1);
        if (table[mid] <= val) l = mid;
        else r = mid;
    }
    return l;
}

},{"28f0481976da1ca4":"254Bi"}],"2twwc":[function(require,module,exports,__globalThis) {
"use strict";
// Description of supported double byte encodings and aliases.
// Tables are not require()-d until they are needed to speed up library load.
// require()-s are direct to support Browserify.
module.exports = {
    // == Japanese/ShiftJIS ====================================================
    // All japanese encodings are based on JIS X set of standards:
    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes.
    //              Has several variations in 1978, 1983, 1990 and 1997.
    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
    //              2 planes, first is superset of 0208, second - revised 0212.
    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
    // Byte encodings are:
    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
    //               0x00-0x7F       - lower part of 0201
    //               0x8E, 0xA1-0xDF - upper part of 0201
    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
    //               Used as-is in ISO2022 family.
    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII,
    //                0201-1976 Roman, 0208-1978, 0208-1983.
    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
    //
    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
    //
    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
    shiftjis: {
        type: "_dbcs",
        table: function() {
            return require("7fd6e990ab3bef41");
        },
        encodeAdd: {
            "\u00a5": 0x5C,
            "\u203E": 0x7E
        },
        encodeSkipVals: [
            {
                from: 0xED40,
                to: 0xF940
            }
        ]
    },
    csshiftjis: "shiftjis",
    mskanji: "shiftjis",
    sjis: "shiftjis",
    windows31j: "shiftjis",
    ms31j: "shiftjis",
    xsjis: "shiftjis",
    windows932: "shiftjis",
    ms932: "shiftjis",
    932: "shiftjis",
    cp932: "shiftjis",
    eucjp: {
        type: "_dbcs",
        table: function() {
            return require("4ecedfe19d7d5f08");
        },
        encodeAdd: {
            "\u00a5": 0x5C,
            "\u203E": 0x7E
        }
    },
    // TODO: KDDI extension to Shift_JIS
    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
    // == Chinese/GBK ==========================================================
    // http://en.wikipedia.org/wiki/GBK
    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
    gb2312: "cp936",
    gb231280: "cp936",
    gb23121980: "cp936",
    csgb2312: "cp936",
    csiso58gb231280: "cp936",
    euccn: "cp936",
    // Microsoft's CP936 is a subset and approximation of GBK.
    windows936: "cp936",
    ms936: "cp936",
    936: "cp936",
    cp936: {
        type: "_dbcs",
        table: function() {
            return require("7a67b65f65727c4");
        }
    },
    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
    gbk: {
        type: "_dbcs",
        table: function() {
            return require("7a67b65f65727c4").concat(require("a573389a26b6ed04"));
        }
    },
    xgbk: "gbk",
    isoir58: "gbk",
    // GB18030 is an algorithmic extension of GBK.
    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
    // http://icu-project.org/docs/papers/gb18030.html
    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
    gb18030: {
        type: "_dbcs",
        table: function() {
            return require("7a67b65f65727c4").concat(require("a573389a26b6ed04"));
        },
        gb18030: function() {
            return require("8df748b1500da7b0");
        },
        encodeSkipVals: [
            0x80
        ],
        encodeAdd: {
            "\u20AC": 0xA2E3
        }
    },
    chinese: "gb18030",
    // == Korean ===============================================================
    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
    windows949: "cp949",
    ms949: "cp949",
    949: "cp949",
    cp949: {
        type: "_dbcs",
        table: function() {
            return require("97f577bf8532eb93");
        }
    },
    cseuckr: "cp949",
    csksc56011987: "cp949",
    euckr: "cp949",
    isoir149: "cp949",
    korean: "cp949",
    ksc56011987: "cp949",
    ksc56011989: "cp949",
    ksc5601: "cp949",
    // == Big5/Taiwan/Hong Kong ================================================
    // There are lots of tables for Big5 and cp950. Please see the following links for history:
    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
    // Variations, in roughly number of defined chars:
    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard.
    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
    //    Plus, it has 4 combining sequences.
    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
    //
    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
    windows950: "cp950",
    ms950: "cp950",
    950: "cp950",
    cp950: {
        type: "_dbcs",
        table: function() {
            return require("e119a7f28ac84bb1");
        }
    },
    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
    big5: "big5hkscs",
    big5hkscs: {
        type: "_dbcs",
        table: function() {
            return require("e119a7f28ac84bb1").concat(require("cf01c21de68946c"));
        },
        encodeSkipVals: [
            // Although Encoding Standard says we should avoid encoding to HKSCS area (See Step 1 of
            // https://encoding.spec.whatwg.org/#index-big5-pointer), we still do it to increase compatibility with ICU.
            // But if a single unicode point can be encoded both as HKSCS and regular Big5, we prefer the latter.
            0x8e69,
            0x8e6f,
            0x8e7e,
            0x8eab,
            0x8eb4,
            0x8ecd,
            0x8ed0,
            0x8f57,
            0x8f69,
            0x8f6e,
            0x8fcb,
            0x8ffe,
            0x906d,
            0x907a,
            0x90c4,
            0x90dc,
            0x90f1,
            0x91bf,
            0x92af,
            0x92b0,
            0x92b1,
            0x92b2,
            0x92d1,
            0x9447,
            0x94ca,
            0x95d9,
            0x96fc,
            0x9975,
            0x9b76,
            0x9b78,
            0x9b7b,
            0x9bc6,
            0x9bde,
            0x9bec,
            0x9bf6,
            0x9c42,
            0x9c53,
            0x9c62,
            0x9c68,
            0x9c6b,
            0x9c77,
            0x9cbc,
            0x9cbd,
            0x9cd0,
            0x9d57,
            0x9d5a,
            0x9dc4,
            0x9def,
            0x9dfb,
            0x9ea9,
            0x9eef,
            0x9efd,
            0x9f60,
            0x9fcb,
            0xa077,
            0xa0dc,
            0xa0df,
            0x8fcc,
            0x92c8,
            0x9644,
            0x96ed,
            // Step 2 of https://encoding.spec.whatwg.org/#index-big5-pointer: Use last pointer for U+2550, U+255E, U+2561, U+256A, U+5341, or U+5345
            0xa2a4,
            0xa2a5,
            0xa2a7,
            0xa2a6,
            0xa2cc,
            0xa2ce
        ]
    },
    cnbig5: "big5hkscs",
    csbig5: "big5hkscs",
    xxbig5: "big5hkscs"
};

},{"7fd6e990ab3bef41":"ljQao","4ecedfe19d7d5f08":"8ufcs","7a67b65f65727c4":"lHy4o","a573389a26b6ed04":"lCpwI","8df748b1500da7b0":"4Q69p","97f577bf8532eb93":"dmGGU","e119a7f28ac84bb1":"b0SFM","cf01c21de68946c":"9TDg5"}],"ljQao":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["0","\\u0000",128],["a1","\uFF61",62],["8140","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7"],["8180","\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["81b8","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["81c8","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["81da","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["81f0","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["81fc","\u25EF"],["824f","\uFF10",9],["8260","\uFF21",25],["8281","\uFF41",25],["829f","\u3041",82],["8340","\u30A1",62],["8380","\u30E0",22],["839f","\u0391",16,"\u03A3",6],["83bf","\u03B1",16,"\u03C3",6],["8440","\u0410",5,"\u0401\u0416",25],["8470","\u0430",5,"\u0451\u0436",7],["8480","\u043E",17],["849f","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["8740","\u2460",19,"\u2160",9],["875f","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["877e","\u337B"],["8780","\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["889f","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["8940","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186"],["8980","\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["8a40","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B"],["8a80","\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["8b40","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551"],["8b80","\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["8c40","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8"],["8c80","\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["8d40","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D"],["8d80","\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["8e40","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62"],["8e80","\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["8f40","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3"],["8f80","\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["9040","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8"],["9080","\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["9140","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB"],["9180","\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["9240","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4"],["9280","\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["9340","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC"],["9380","\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["9440","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885"],["9480","\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["9540","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577"],["9580","\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["9640","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6"],["9680","\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["9740","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32"],["9780","\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["9840","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["989f","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["9940","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED"],["9980","\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["9a40","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638"],["9a80","\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["9b40","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80"],["9b80","\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["9c40","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060"],["9c80","\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["9d40","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B"],["9d80","\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["9e40","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E"],["9e80","\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["9f40","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF"],["9f80","\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["e040","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD"],["e080","\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e140","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF"],["e180","\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e240","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0"],["e280","\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e340","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37"],["e380","\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e440","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264"],["e480","\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e540","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC"],["e580","\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["e640","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7"],["e680","\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["e740","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C"],["e780","\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["e840","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599"],["e880","\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["e940","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43"],["e980","\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["ea40","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF"],["ea80","\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199"],["ed40","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F"],["ed80","\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["ee40","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559"],["ee80","\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["eeef","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["f040","\uE000",62],["f080","\uE03F",124],["f140","\uE0BC",62],["f180","\uE0FB",124],["f240","\uE178",62],["f280","\uE1B7",124],["f340","\uE234",62],["f380","\uE273",124],["f440","\uE2F0",62],["f480","\uE32F",124],["f540","\uE3AC",62],["f580","\uE3EB",124],["f640","\uE468",62],["f680","\uE4A7",124],["f740","\uE524",62],["f780","\uE563",124],["f840","\uE5E0",62],["f880","\uE61F",124],["f940","\uE69C"],["fa40","\u2170",9,"\u2160",9,"\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u2235\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A"],["fa80","\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F"],["fb40","\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19"],["fb80","\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9"],["fc40","\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"]]');

},{}],"8ufcs":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["0","\\u0000",127],["8ea1","\uFF61",62],["a1a1","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7"],["a2a1","\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["a2ba","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["a2ca","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["a2dc","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["a2f2","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["a2fe","\u25EF"],["a3b0","\uFF10",9],["a3c1","\uFF21",25],["a3e1","\uFF41",25],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a8a1","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["ada1","\u2460",19,"\u2160",9],["adc0","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["addf","\u337B\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["b0a1","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["b1a1","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC"],["b2a1","\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["b3a1","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431"],["b4a1","\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["b5a1","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC"],["b6a1","\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["b7a1","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372"],["b8a1","\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["b9a1","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC"],["baa1","\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["bba1","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642"],["bca1","\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["bda1","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F"],["bea1","\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["bfa1","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE"],["c0a1","\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["c1a1","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E"],["c2a1","\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["c3a1","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5"],["c4a1","\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["c5a1","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230"],["c6a1","\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["c7a1","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6"],["c8a1","\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["c9a1","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D"],["caa1","\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["cba1","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80"],["cca1","\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["cda1","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483"],["cea1","\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["cfa1","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["d0a1","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["d1a1","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8"],["d2a1","\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["d3a1","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709"],["d4a1","\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["d5a1","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53"],["d6a1","\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["d7a1","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A"],["d8a1","\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["d9a1","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC"],["daa1","\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["dba1","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD"],["dca1","\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["dda1","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE"],["dea1","\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["dfa1","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC"],["e0a1","\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e1a1","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670"],["e2a1","\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e3a1","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50"],["e4a1","\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e5a1","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A"],["e6a1","\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e7a1","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9"],["e8a1","\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e9a1","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759"],["eaa1","\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["eba1","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B"],["eca1","\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["eda1","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8"],["eea1","\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["efa1","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E"],["f0a1","\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["f1a1","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7"],["f2a1","\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["f3a1","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0"],["f4a1","\u582F\u69C7\u9059\u7464\u51DC\u7199"],["f9a1","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7"],["faa1","\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["fba1","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA"],["fca1","\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["fcf1","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["8fa2af","\u02D8\u02C7\xb8\u02D9\u02DD\xaf\u02DB\u02DA\uFF5E\u0384\u0385"],["8fa2c2","\xa1\xa6\xbf"],["8fa2eb","\xba\xaa\xa9\xae\u2122\xa4\u2116"],["8fa6e1","\u0386\u0388\u0389\u038A\u03AA"],["8fa6e7","\u038C"],["8fa6e9","\u038E\u03AB"],["8fa6ec","\u038F"],["8fa6f1","\u03AC\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03C2\u03CD\u03CB\u03B0\u03CE"],["8fa7c2","\u0402",10,"\u040E\u040F"],["8fa7f2","\u0452",10,"\u045E\u045F"],["8fa9a1","\xc6\u0110"],["8fa9a4","\u0126"],["8fa9a6","\u0132"],["8fa9a8","\u0141\u013F"],["8fa9ab","\u014A\xd8\u0152"],["8fa9af","\u0166\xde"],["8fa9c1","\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0142\u0140\u0149\u014B\xf8\u0153\xdf\u0167\xfe"],["8faaa1","\xc1\xc0\xc4\xc2\u0102\u01CD\u0100\u0104\xc5\xc3\u0106\u0108\u010C\xc7\u010A\u010E\xc9\xc8\xcb\xca\u011A\u0116\u0112\u0118"],["8faaba","\u011C\u011E\u0122\u0120\u0124\xcd\xcc\xcf\xce\u01CF\u0130\u012A\u012E\u0128\u0134\u0136\u0139\u013D\u013B\u0143\u0147\u0145\xd1\xd3\xd2\xd6\xd4\u01D1\u0150\u014C\xd5\u0154\u0158\u0156\u015A\u015C\u0160\u015E\u0164\u0162\xda\xd9\xdc\xdb\u016C\u01D3\u0170\u016A\u0172\u016E\u0168\u01D7\u01DB\u01D9\u01D5\u0174\xdd\u0178\u0176\u0179\u017D\u017B"],["8faba1","\xe1\xe0\xe4\xe2\u0103\u01CE\u0101\u0105\xe5\xe3\u0107\u0109\u010D\xe7\u010B\u010F\xe9\xe8\xeb\xea\u011B\u0117\u0113\u0119\u01F5\u011D\u011F"],["8fabbd","\u0121\u0125\xed\xec\xef\xee\u01D0"],["8fabc5","\u012B\u012F\u0129\u0135\u0137\u013A\u013E\u013C\u0144\u0148\u0146\xf1\xf3\xf2\xf6\xf4\u01D2\u0151\u014D\xf5\u0155\u0159\u0157\u015B\u015D\u0161\u015F\u0165\u0163\xfa\xf9\xfc\xfb\u016D\u01D4\u0171\u016B\u0173\u016F\u0169\u01D8\u01DC\u01DA\u01D6\u0175\xfd\xff\u0177\u017A\u017E\u017C"],["8fb0a1","\u4E02\u4E04\u4E05\u4E0C\u4E12\u4E1F\u4E23\u4E24\u4E28\u4E2B\u4E2E\u4E2F\u4E30\u4E35\u4E40\u4E41\u4E44\u4E47\u4E51\u4E5A\u4E5C\u4E63\u4E68\u4E69\u4E74\u4E75\u4E79\u4E7F\u4E8D\u4E96\u4E97\u4E9D\u4EAF\u4EB9\u4EC3\u4ED0\u4EDA\u4EDB\u4EE0\u4EE1\u4EE2\u4EE8\u4EEF\u4EF1\u4EF3\u4EF5\u4EFD\u4EFE\u4EFF\u4F00\u4F02\u4F03\u4F08\u4F0B\u4F0C\u4F12\u4F15\u4F16\u4F17\u4F19\u4F2E\u4F31\u4F60\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E\u4F40\u4F42\u4F48\u4F49\u4F4B\u4F4C\u4F52\u4F54\u4F56\u4F58\u4F5F\u4F63\u4F6A\u4F6C\u4F6E\u4F71\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F7E\u4F81\u4F82\u4F84"],["8fb1a1","\u4F85\u4F89\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F94\u4F97\u4F99\u4F9A\u4F9E\u4F9F\u4FB2\u4FB7\u4FB9\u4FBB\u4FBC\u4FBD\u4FBE\u4FC0\u4FC1\u4FC5\u4FC6\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FCF\u4FD2\u4FDC\u4FE0\u4FE2\u4FF0\u4FF2\u4FFC\u4FFD\u4FFF\u5000\u5001\u5004\u5007\u500A\u500C\u500E\u5010\u5013\u5017\u5018\u501B\u501C\u501D\u501E\u5022\u5027\u502E\u5030\u5032\u5033\u5035\u5040\u5041\u5042\u5045\u5046\u504A\u504C\u504E\u5051\u5052\u5053\u5057\u5059\u505F\u5060\u5062\u5063\u5066\u5067\u506A\u506D\u5070\u5071\u503B\u5081\u5083\u5084\u5086\u508A\u508E\u508F\u5090"],["8fb2a1","\u5092\u5093\u5094\u5096\u509B\u509C\u509E",4,"\u50AA\u50AF\u50B0\u50B9\u50BA\u50BD\u50C0\u50C3\u50C4\u50C7\u50CC\u50CE\u50D0\u50D3\u50D4\u50D8\u50DC\u50DD\u50DF\u50E2\u50E4\u50E6\u50E8\u50E9\u50EF\u50F1\u50F6\u50FA\u50FE\u5103\u5106\u5107\u5108\u510B\u510C\u510D\u510E\u50F2\u5110\u5117\u5119\u511B\u511C\u511D\u511E\u5123\u5127\u5128\u512C\u512D\u512F\u5131\u5133\u5134\u5135\u5138\u5139\u5142\u514A\u514F\u5153\u5155\u5157\u5158\u515F\u5164\u5166\u517E\u5183\u5184\u518B\u518E\u5198\u519D\u51A1\u51A3\u51AD\u51B8\u51BA\u51BC\u51BE\u51BF\u51C2"],["8fb3a1","\u51C8\u51CF\u51D1\u51D2\u51D3\u51D5\u51D8\u51DE\u51E2\u51E5\u51EE\u51F2\u51F3\u51F4\u51F7\u5201\u5202\u5205\u5212\u5213\u5215\u5216\u5218\u5222\u5228\u5231\u5232\u5235\u523C\u5245\u5249\u5255\u5257\u5258\u525A\u525C\u525F\u5260\u5261\u5266\u526E\u5277\u5278\u5279\u5280\u5282\u5285\u528A\u528C\u5293\u5295\u5296\u5297\u5298\u529A\u529C\u52A4\u52A5\u52A6\u52A7\u52AF\u52B0\u52B6\u52B7\u52B8\u52BA\u52BB\u52BD\u52C0\u52C4\u52C6\u52C8\u52CC\u52CF\u52D1\u52D4\u52D6\u52DB\u52DC\u52E1\u52E5\u52E8\u52E9\u52EA\u52EC\u52F0\u52F1\u52F4\u52F6\u52F7\u5300\u5303\u530A\u530B"],["8fb4a1","\u530C\u5311\u5313\u5318\u531B\u531C\u531E\u531F\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u5330\u5332\u5335\u533C\u533D\u533E\u5342\u534C\u534B\u5359\u535B\u5361\u5363\u5365\u536C\u536D\u5372\u5379\u537E\u5383\u5387\u5388\u538E\u5393\u5394\u5399\u539D\u53A1\u53A4\u53AA\u53AB\u53AF\u53B2\u53B4\u53B5\u53B7\u53B8\u53BA\u53BD\u53C0\u53C5\u53CF\u53D2\u53D3\u53D5\u53DA\u53DD\u53DE\u53E0\u53E6\u53E7\u53F5\u5402\u5413\u541A\u5421\u5427\u5428\u542A\u542F\u5431\u5434\u5435\u5443\u5444\u5447\u544D\u544F\u545E\u5462\u5464\u5466\u5467\u5469\u546B\u546D\u546E\u5474\u547F"],["8fb5a1","\u5481\u5483\u5485\u5488\u5489\u548D\u5491\u5495\u5496\u549C\u549F\u54A1\u54A6\u54A7\u54A9\u54AA\u54AD\u54AE\u54B1\u54B7\u54B9\u54BA\u54BB\u54BF\u54C6\u54CA\u54CD\u54CE\u54E0\u54EA\u54EC\u54EF\u54F6\u54FC\u54FE\u54FF\u5500\u5501\u5505\u5508\u5509\u550C\u550D\u550E\u5515\u552A\u552B\u5532\u5535\u5536\u553B\u553C\u553D\u5541\u5547\u5549\u554A\u554D\u5550\u5551\u5558\u555A\u555B\u555E\u5560\u5561\u5564\u5566\u557F\u5581\u5582\u5586\u5588\u558E\u558F\u5591\u5592\u5593\u5594\u5597\u55A3\u55A4\u55AD\u55B2\u55BF\u55C1\u55C3\u55C6\u55C9\u55CB\u55CC\u55CE\u55D1\u55D2"],["8fb6a1","\u55D3\u55D7\u55D8\u55DB\u55DE\u55E2\u55E9\u55F6\u55FF\u5605\u5608\u560A\u560D",5,"\u5619\u562C\u5630\u5633\u5635\u5637\u5639\u563B\u563C\u563D\u563F\u5640\u5641\u5643\u5644\u5646\u5649\u564B\u564D\u564F\u5654\u565E\u5660\u5661\u5662\u5663\u5666\u5669\u566D\u566F\u5671\u5672\u5675\u5684\u5685\u5688\u568B\u568C\u5695\u5699\u569A\u569D\u569E\u569F\u56A6\u56A7\u56A8\u56A9\u56AB\u56AC\u56AD\u56B1\u56B3\u56B7\u56BE\u56C5\u56C9\u56CA\u56CB\u56CF\u56D0\u56CC\u56CD\u56D9\u56DC\u56DD\u56DF\u56E1\u56E4",4,"\u56F1\u56EB\u56ED"],["8fb7a1","\u56F6\u56F7\u5701\u5702\u5707\u570A\u570C\u5711\u5715\u571A\u571B\u571D\u5720\u5722\u5723\u5724\u5725\u5729\u572A\u572C\u572E\u572F\u5733\u5734\u573D\u573E\u573F\u5745\u5746\u574C\u574D\u5752\u5762\u5765\u5767\u5768\u576B\u576D",4,"\u5773\u5774\u5775\u5777\u5779\u577A\u577B\u577C\u577E\u5781\u5783\u578C\u5794\u5797\u5799\u579A\u579C\u579D\u579E\u579F\u57A1\u5795\u57A7\u57A8\u57A9\u57AC\u57B8\u57BD\u57C7\u57C8\u57CC\u57CF\u57D5\u57DD\u57DE\u57E4\u57E6\u57E7\u57E9\u57ED\u57F0\u57F5\u57F6\u57F8\u57FD\u57FE\u57FF\u5803\u5804\u5808\u5809\u57E1"],["8fb8a1","\u580C\u580D\u581B\u581E\u581F\u5820\u5826\u5827\u582D\u5832\u5839\u583F\u5849\u584C\u584D\u584F\u5850\u5855\u585F\u5861\u5864\u5867\u5868\u5878\u587C\u587F\u5880\u5881\u5887\u5888\u5889\u588A\u588C\u588D\u588F\u5890\u5894\u5896\u589D\u58A0\u58A1\u58A2\u58A6\u58A9\u58B1\u58B2\u58C4\u58BC\u58C2\u58C8\u58CD\u58CE\u58D0\u58D2\u58D4\u58D6\u58DA\u58DD\u58E1\u58E2\u58E9\u58F3\u5905\u5906\u590B\u590C\u5912\u5913\u5914\u8641\u591D\u5921\u5923\u5924\u5928\u592F\u5930\u5933\u5935\u5936\u593F\u5943\u5946\u5952\u5953\u5959\u595B\u595D\u595E\u595F\u5961\u5963\u596B\u596D"],["8fb9a1","\u596F\u5972\u5975\u5976\u5979\u597B\u597C\u598B\u598C\u598E\u5992\u5995\u5997\u599F\u59A4\u59A7\u59AD\u59AE\u59AF\u59B0\u59B3\u59B7\u59BA\u59BC\u59C1\u59C3\u59C4\u59C8\u59CA\u59CD\u59D2\u59DD\u59DE\u59DF\u59E3\u59E4\u59E7\u59EE\u59EF\u59F1\u59F2\u59F4\u59F7\u5A00\u5A04\u5A0C\u5A0D\u5A0E\u5A12\u5A13\u5A1E\u5A23\u5A24\u5A27\u5A28\u5A2A\u5A2D\u5A30\u5A44\u5A45\u5A47\u5A48\u5A4C\u5A50\u5A55\u5A5E\u5A63\u5A65\u5A67\u5A6D\u5A77\u5A7A\u5A7B\u5A7E\u5A8B\u5A90\u5A93\u5A96\u5A99\u5A9C\u5A9E\u5A9F\u5AA0\u5AA2\u5AA7\u5AAC\u5AB1\u5AB2\u5AB3\u5AB5\u5AB8\u5ABA\u5ABB\u5ABF"],["8fbaa1","\u5AC4\u5AC6\u5AC8\u5ACF\u5ADA\u5ADC\u5AE0\u5AE5\u5AEA\u5AEE\u5AF5\u5AF6\u5AFD\u5B00\u5B01\u5B08\u5B17\u5B34\u5B19\u5B1B\u5B1D\u5B21\u5B25\u5B2D\u5B38\u5B41\u5B4B\u5B4C\u5B52\u5B56\u5B5E\u5B68\u5B6E\u5B6F\u5B7C\u5B7D\u5B7E\u5B7F\u5B81\u5B84\u5B86\u5B8A\u5B8E\u5B90\u5B91\u5B93\u5B94\u5B96\u5BA8\u5BA9\u5BAC\u5BAD\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBC\u5BC0\u5BC1\u5BCD\u5BCF\u5BD6",4,"\u5BE0\u5BEF\u5BF1\u5BF4\u5BFD\u5C0C\u5C17\u5C1E\u5C1F\u5C23\u5C26\u5C29\u5C2B\u5C2C\u5C2E\u5C30\u5C32\u5C35\u5C36\u5C59\u5C5A\u5C5C\u5C62\u5C63\u5C67\u5C68\u5C69"],["8fbba1","\u5C6D\u5C70\u5C74\u5C75\u5C7A\u5C7B\u5C7C\u5C7D\u5C87\u5C88\u5C8A\u5C8F\u5C92\u5C9D\u5C9F\u5CA0\u5CA2\u5CA3\u5CA6\u5CAA\u5CB2\u5CB4\u5CB5\u5CBA\u5CC9\u5CCB\u5CD2\u5CDD\u5CD7\u5CEE\u5CF1\u5CF2\u5CF4\u5D01\u5D06\u5D0D\u5D12\u5D2B\u5D23\u5D24\u5D26\u5D27\u5D31\u5D34\u5D39\u5D3D\u5D3F\u5D42\u5D43\u5D46\u5D48\u5D55\u5D51\u5D59\u5D4A\u5D5F\u5D60\u5D61\u5D62\u5D64\u5D6A\u5D6D\u5D70\u5D79\u5D7A\u5D7E\u5D7F\u5D81\u5D83\u5D88\u5D8A\u5D92\u5D93\u5D94\u5D95\u5D99\u5D9B\u5D9F\u5DA0\u5DA7\u5DAB\u5DB0\u5DB4\u5DB8\u5DB9\u5DC3\u5DC7\u5DCB\u5DD0\u5DCE\u5DD8\u5DD9\u5DE0\u5DE4"],["8fbca1","\u5DE9\u5DF8\u5DF9\u5E00\u5E07\u5E0D\u5E12\u5E14\u5E15\u5E18\u5E1F\u5E20\u5E2E\u5E28\u5E32\u5E35\u5E3E\u5E4B\u5E50\u5E49\u5E51\u5E56\u5E58\u5E5B\u5E5C\u5E5E\u5E68\u5E6A",4,"\u5E70\u5E80\u5E8B\u5E8E\u5EA2\u5EA4\u5EA5\u5EA8\u5EAA\u5EAC\u5EB1\u5EB3\u5EBD\u5EBE\u5EBF\u5EC6\u5ECC\u5ECB\u5ECE\u5ED1\u5ED2\u5ED4\u5ED5\u5EDC\u5EDE\u5EE5\u5EEB\u5F02\u5F06\u5F07\u5F08\u5F0E\u5F19\u5F1C\u5F1D\u5F21\u5F22\u5F23\u5F24\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F34\u5F36\u5F3B\u5F3D\u5F3F\u5F40\u5F44\u5F45\u5F47\u5F4D\u5F50\u5F54\u5F58\u5F5B\u5F60\u5F63\u5F64\u5F67"],["8fbda1","\u5F6F\u5F72\u5F74\u5F75\u5F78\u5F7A\u5F7D\u5F7E\u5F89\u5F8D\u5F8F\u5F96\u5F9C\u5F9D\u5FA2\u5FA7\u5FAB\u5FA4\u5FAC\u5FAF\u5FB0\u5FB1\u5FB8\u5FC4\u5FC7\u5FC8\u5FC9\u5FCB\u5FD0",4,"\u5FDE\u5FE1\u5FE2\u5FE8\u5FE9\u5FEA\u5FEC\u5FED\u5FEE\u5FEF\u5FF2\u5FF3\u5FF6\u5FFA\u5FFC\u6007\u600A\u600D\u6013\u6014\u6017\u6018\u601A\u601F\u6024\u602D\u6033\u6035\u6040\u6047\u6048\u6049\u604C\u6051\u6054\u6056\u6057\u605D\u6061\u6067\u6071\u607E\u607F\u6082\u6086\u6088\u608A\u608E\u6091\u6093\u6095\u6098\u609D\u609E\u60A2\u60A4\u60A5\u60A8\u60B0\u60B1\u60B7"],["8fbea1","\u60BB\u60BE\u60C2\u60C4\u60C8\u60C9\u60CA\u60CB\u60CE\u60CF\u60D4\u60D5\u60D9\u60DB\u60DD\u60DE\u60E2\u60E5\u60F2\u60F5\u60F8\u60FC\u60FD\u6102\u6107\u610A\u610C\u6110",4,"\u6116\u6117\u6119\u611C\u611E\u6122\u612A\u612B\u6130\u6131\u6135\u6136\u6137\u6139\u6141\u6145\u6146\u6149\u615E\u6160\u616C\u6172\u6178\u617B\u617C\u617F\u6180\u6181\u6183\u6184\u618B\u618D\u6192\u6193\u6197\u6198\u619C\u619D\u619F\u61A0\u61A5\u61A8\u61AA\u61AD\u61B8\u61B9\u61BC\u61C0\u61C1\u61C2\u61CE\u61CF\u61D5\u61DC\u61DD\u61DE\u61DF\u61E1\u61E2\u61E7\u61E9\u61E5"],["8fbfa1","\u61EC\u61ED\u61EF\u6201\u6203\u6204\u6207\u6213\u6215\u621C\u6220\u6222\u6223\u6227\u6229\u622B\u6239\u623D\u6242\u6243\u6244\u6246\u624C\u6250\u6251\u6252\u6254\u6256\u625A\u625C\u6264\u626D\u626F\u6273\u627A\u627D\u628D\u628E\u628F\u6290\u62A6\u62A8\u62B3\u62B6\u62B7\u62BA\u62BE\u62BF\u62C4\u62CE\u62D5\u62D6\u62DA\u62EA\u62F2\u62F4\u62FC\u62FD\u6303\u6304\u630A\u630B\u630D\u6310\u6313\u6316\u6318\u6329\u632A\u632D\u6335\u6336\u6339\u633C\u6341\u6342\u6343\u6344\u6346\u634A\u634B\u634E\u6352\u6353\u6354\u6358\u635B\u6365\u6366\u636C\u636D\u6371\u6374\u6375"],["8fc0a1","\u6378\u637C\u637D\u637F\u6382\u6384\u6387\u638A\u6390\u6394\u6395\u6399\u639A\u639E\u63A4\u63A6\u63AD\u63AE\u63AF\u63BD\u63C1\u63C5\u63C8\u63CE\u63D1\u63D3\u63D4\u63D5\u63DC\u63E0\u63E5\u63EA\u63EC\u63F2\u63F3\u63F5\u63F8\u63F9\u6409\u640A\u6410\u6412\u6414\u6418\u641E\u6420\u6422\u6424\u6425\u6429\u642A\u642F\u6430\u6435\u643D\u643F\u644B\u644F\u6451\u6452\u6453\u6454\u645A\u645B\u645C\u645D\u645F\u6460\u6461\u6463\u646D\u6473\u6474\u647B\u647D\u6485\u6487\u648F\u6490\u6491\u6498\u6499\u649B\u649D\u649F\u64A1\u64A3\u64A6\u64A8\u64AC\u64B3\u64BD\u64BE\u64BF"],["8fc1a1","\u64C4\u64C9\u64CA\u64CB\u64CC\u64CE\u64D0\u64D1\u64D5\u64D7\u64E4\u64E5\u64E9\u64EA\u64ED\u64F0\u64F5\u64F7\u64FB\u64FF\u6501\u6504\u6508\u6509\u650A\u650F\u6513\u6514\u6516\u6519\u651B\u651E\u651F\u6522\u6526\u6529\u652E\u6531\u653A\u653C\u653D\u6543\u6547\u6549\u6550\u6552\u6554\u655F\u6560\u6567\u656B\u657A\u657D\u6581\u6585\u658A\u6592\u6595\u6598\u659D\u65A0\u65A3\u65A6\u65AE\u65B2\u65B3\u65B4\u65BF\u65C2\u65C8\u65C9\u65CE\u65D0\u65D4\u65D6\u65D8\u65DF\u65F0\u65F2\u65F4\u65F5\u65F9\u65FE\u65FF\u6600\u6604\u6608\u6609\u660D\u6611\u6612\u6615\u6616\u661D"],["8fc2a1","\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6631\u6633\u6639\u6637\u6640\u6645\u6646\u664A\u664C\u6651\u664E\u6657\u6658\u6659\u665B\u665C\u6660\u6661\u66FB\u666A\u666B\u666C\u667E\u6673\u6675\u667F\u6677\u6678\u6679\u667B\u6680\u667C\u668B\u668C\u668D\u6690\u6692\u6699\u669A\u669B\u669C\u669F\u66A0\u66A4\u66AD\u66B1\u66B2\u66B5\u66BB\u66BF\u66C0\u66C2\u66C3\u66C8\u66CC\u66CE\u66CF\u66D4\u66DB\u66DF\u66E8\u66EB\u66EC\u66EE\u66FA\u6705\u6707\u670E\u6713\u6719\u671C\u6720\u6722\u6733\u673E\u6745\u6747\u6748\u674C\u6754\u6755\u675D"],["8fc3a1","\u6766\u676C\u676E\u6774\u6776\u677B\u6781\u6784\u678E\u678F\u6791\u6793\u6796\u6798\u6799\u679B\u67B0\u67B1\u67B2\u67B5\u67BB\u67BC\u67BD\u67F9\u67C0\u67C2\u67C3\u67C5\u67C8\u67C9\u67D2\u67D7\u67D9\u67DC\u67E1\u67E6\u67F0\u67F2\u67F6\u67F7\u6852\u6814\u6819\u681D\u681F\u6828\u6827\u682C\u682D\u682F\u6830\u6831\u6833\u683B\u683F\u6844\u6845\u684A\u684C\u6855\u6857\u6858\u685B\u686B\u686E",4,"\u6875\u6879\u687A\u687B\u687C\u6882\u6884\u6886\u6888\u6896\u6898\u689A\u689C\u68A1\u68A3\u68A5\u68A9\u68AA\u68AE\u68B2\u68BB\u68C5\u68C8\u68CC\u68CF"],["8fc4a1","\u68D0\u68D1\u68D3\u68D6\u68D9\u68DC\u68DD\u68E5\u68E8\u68EA\u68EB\u68EC\u68ED\u68F0\u68F1\u68F5\u68F6\u68FB\u68FC\u68FD\u6906\u6909\u690A\u6910\u6911\u6913\u6916\u6917\u6931\u6933\u6935\u6938\u693B\u6942\u6945\u6949\u694E\u6957\u695B\u6963\u6964\u6965\u6966\u6968\u6969\u696C\u6970\u6971\u6972\u697A\u697B\u697F\u6980\u698D\u6992\u6996\u6998\u69A1\u69A5\u69A6\u69A8\u69AB\u69AD\u69AF\u69B7\u69B8\u69BA\u69BC\u69C5\u69C8\u69D1\u69D6\u69D7\u69E2\u69E5\u69EE\u69EF\u69F1\u69F3\u69F5\u69FE\u6A00\u6A01\u6A03\u6A0F\u6A11\u6A15\u6A1A\u6A1D\u6A20\u6A24\u6A28\u6A30\u6A32"],["8fc5a1","\u6A34\u6A37\u6A3B\u6A3E\u6A3F\u6A45\u6A46\u6A49\u6A4A\u6A4E\u6A50\u6A51\u6A52\u6A55\u6A56\u6A5B\u6A64\u6A67\u6A6A\u6A71\u6A73\u6A7E\u6A81\u6A83\u6A86\u6A87\u6A89\u6A8B\u6A91\u6A9B\u6A9D\u6A9E\u6A9F\u6AA5\u6AAB\u6AAF\u6AB0\u6AB1\u6AB4\u6ABD\u6ABE\u6ABF\u6AC6\u6AC9\u6AC8\u6ACC\u6AD0\u6AD4\u6AD5\u6AD6\u6ADC\u6ADD\u6AE4\u6AE7\u6AEC\u6AF0\u6AF1\u6AF2\u6AFC\u6AFD\u6B02\u6B03\u6B06\u6B07\u6B09\u6B0F\u6B10\u6B11\u6B17\u6B1B\u6B1E\u6B24\u6B28\u6B2B\u6B2C\u6B2F\u6B35\u6B36\u6B3B\u6B3F\u6B46\u6B4A\u6B4D\u6B52\u6B56\u6B58\u6B5D\u6B60\u6B67\u6B6B\u6B6E\u6B70\u6B75\u6B7D"],["8fc6a1","\u6B7E\u6B82\u6B85\u6B97\u6B9B\u6B9F\u6BA0\u6BA2\u6BA3\u6BA8\u6BA9\u6BAC\u6BAD\u6BAE\u6BB0\u6BB8\u6BB9\u6BBD\u6BBE\u6BC3\u6BC4\u6BC9\u6BCC\u6BD6\u6BDA\u6BE1\u6BE3\u6BE6\u6BE7\u6BEE\u6BF1\u6BF7\u6BF9\u6BFF\u6C02\u6C04\u6C05\u6C09\u6C0D\u6C0E\u6C10\u6C12\u6C19\u6C1F\u6C26\u6C27\u6C28\u6C2C\u6C2E\u6C33\u6C35\u6C36\u6C3A\u6C3B\u6C3F\u6C4A\u6C4B\u6C4D\u6C4F\u6C52\u6C54\u6C59\u6C5B\u6C5C\u6C6B\u6C6D\u6C6F\u6C74\u6C76\u6C78\u6C79\u6C7B\u6C85\u6C86\u6C87\u6C89\u6C94\u6C95\u6C97\u6C98\u6C9C\u6C9F\u6CB0\u6CB2\u6CB4\u6CC2\u6CC6\u6CCD\u6CCF\u6CD0\u6CD1\u6CD2\u6CD4\u6CD6"],["8fc7a1","\u6CDA\u6CDC\u6CE0\u6CE7\u6CE9\u6CEB\u6CEC\u6CEE\u6CF2\u6CF4\u6D04\u6D07\u6D0A\u6D0E\u6D0F\u6D11\u6D13\u6D1A\u6D26\u6D27\u6D28\u6C67\u6D2E\u6D2F\u6D31\u6D39\u6D3C\u6D3F\u6D57\u6D5E\u6D5F\u6D61\u6D65\u6D67\u6D6F\u6D70\u6D7C\u6D82\u6D87\u6D91\u6D92\u6D94\u6D96\u6D97\u6D98\u6DAA\u6DAC\u6DB4\u6DB7\u6DB9\u6DBD\u6DBF\u6DC4\u6DC8\u6DCA\u6DCE\u6DCF\u6DD6\u6DDB\u6DDD\u6DDF\u6DE0\u6DE2\u6DE5\u6DE9\u6DEF\u6DF0\u6DF4\u6DF6\u6DFC\u6E00\u6E04\u6E1E\u6E22\u6E27\u6E32\u6E36\u6E39\u6E3B\u6E3C\u6E44\u6E45\u6E48\u6E49\u6E4B\u6E4F\u6E51\u6E52\u6E53\u6E54\u6E57\u6E5C\u6E5D\u6E5E"],["8fc8a1","\u6E62\u6E63\u6E68\u6E73\u6E7B\u6E7D\u6E8D\u6E93\u6E99\u6EA0\u6EA7\u6EAD\u6EAE\u6EB1\u6EB3\u6EBB\u6EBF\u6EC0\u6EC1\u6EC3\u6EC7\u6EC8\u6ECA\u6ECD\u6ECE\u6ECF\u6EEB\u6EED\u6EEE\u6EF9\u6EFB\u6EFD\u6F04\u6F08\u6F0A\u6F0C\u6F0D\u6F16\u6F18\u6F1A\u6F1B\u6F26\u6F29\u6F2A\u6F2F\u6F30\u6F33\u6F36\u6F3B\u6F3C\u6F2D\u6F4F\u6F51\u6F52\u6F53\u6F57\u6F59\u6F5A\u6F5D\u6F5E\u6F61\u6F62\u6F68\u6F6C\u6F7D\u6F7E\u6F83\u6F87\u6F88\u6F8B\u6F8C\u6F8D\u6F90\u6F92\u6F93\u6F94\u6F96\u6F9A\u6F9F\u6FA0\u6FA5\u6FA6\u6FA7\u6FA8\u6FAE\u6FAF\u6FB0\u6FB5\u6FB6\u6FBC\u6FC5\u6FC7\u6FC8\u6FCA"],["8fc9a1","\u6FDA\u6FDE\u6FE8\u6FE9\u6FF0\u6FF5\u6FF9\u6FFC\u6FFD\u7000\u7005\u7006\u7007\u700D\u7017\u7020\u7023\u702F\u7034\u7037\u7039\u703C\u7043\u7044\u7048\u7049\u704A\u704B\u7054\u7055\u705D\u705E\u704E\u7064\u7065\u706C\u706E\u7075\u7076\u707E\u7081\u7085\u7086\u7094",4,"\u709B\u70A4\u70AB\u70B0\u70B1\u70B4\u70B7\u70CA\u70D1\u70D3\u70D4\u70D5\u70D6\u70D8\u70DC\u70E4\u70FA\u7103",4,"\u710B\u710C\u710F\u711E\u7120\u712B\u712D\u712F\u7130\u7131\u7138\u7141\u7145\u7146\u7147\u714A\u714B\u7150\u7152\u7157\u715A\u715C\u715E\u7160"],["8fcaa1","\u7168\u7179\u7180\u7185\u7187\u718C\u7192\u719A\u719B\u71A0\u71A2\u71AF\u71B0\u71B2\u71B3\u71BA\u71BF\u71C0\u71C1\u71C4\u71CB\u71CC\u71D3\u71D6\u71D9\u71DA\u71DC\u71F8\u71FE\u7200\u7207\u7208\u7209\u7213\u7217\u721A\u721D\u721F\u7224\u722B\u722F\u7234\u7238\u7239\u7241\u7242\u7243\u7245\u724E\u724F\u7250\u7253\u7255\u7256\u725A\u725C\u725E\u7260\u7263\u7268\u726B\u726E\u726F\u7271\u7277\u7278\u727B\u727C\u727F\u7284\u7289\u728D\u728E\u7293\u729B\u72A8\u72AD\u72AE\u72B1\u72B4\u72BE\u72C1\u72C7\u72C9\u72CC\u72D5\u72D6\u72D8\u72DF\u72E5\u72F3\u72F4\u72FA\u72FB"],["8fcba1","\u72FE\u7302\u7304\u7305\u7307\u730B\u730D\u7312\u7313\u7318\u7319\u731E\u7322\u7324\u7327\u7328\u732C\u7331\u7332\u7335\u733A\u733B\u733D\u7343\u734D\u7350\u7352\u7356\u7358\u735D\u735E\u735F\u7360\u7366\u7367\u7369\u736B\u736C\u736E\u736F\u7371\u7377\u7379\u737C\u7380\u7381\u7383\u7385\u7386\u738E\u7390\u7393\u7395\u7397\u7398\u739C\u739E\u739F\u73A0\u73A2\u73A5\u73A6\u73AA\u73AB\u73AD\u73B5\u73B7\u73B9\u73BC\u73BD\u73BF\u73C5\u73C6\u73C9\u73CB\u73CC\u73CF\u73D2\u73D3\u73D6\u73D9\u73DD\u73E1\u73E3\u73E6\u73E7\u73E9\u73F4\u73F5\u73F7\u73F9\u73FA\u73FB\u73FD"],["8fcca1","\u73FF\u7400\u7401\u7404\u7407\u740A\u7411\u741A\u741B\u7424\u7426\u7428",9,"\u7439\u7440\u7443\u7444\u7446\u7447\u744B\u744D\u7451\u7452\u7457\u745D\u7462\u7466\u7467\u7468\u746B\u746D\u746E\u7471\u7472\u7480\u7481\u7485\u7486\u7487\u7489\u748F\u7490\u7491\u7492\u7498\u7499\u749A\u749C\u749F\u74A0\u74A1\u74A3\u74A6\u74A8\u74A9\u74AA\u74AB\u74AE\u74AF\u74B1\u74B2\u74B5\u74B9\u74BB\u74BF\u74C8\u74C9\u74CC\u74D0\u74D3\u74D8\u74DA\u74DB\u74DE\u74DF\u74E4\u74E8\u74EA\u74EB\u74EF\u74F4\u74FA\u74FB\u74FC\u74FF\u7506"],["8fcda1","\u7512\u7516\u7517\u7520\u7521\u7524\u7527\u7529\u752A\u752F\u7536\u7539\u753D\u753E\u753F\u7540\u7543\u7547\u7548\u754E\u7550\u7552\u7557\u755E\u755F\u7561\u756F\u7571\u7579",5,"\u7581\u7585\u7590\u7592\u7593\u7595\u7599\u759C\u75A2\u75A4\u75B4\u75BA\u75BF\u75C0\u75C1\u75C4\u75C6\u75CC\u75CE\u75CF\u75D7\u75DC\u75DF\u75E0\u75E1\u75E4\u75E7\u75EC\u75EE\u75EF\u75F1\u75F9\u7600\u7602\u7603\u7604\u7607\u7608\u760A\u760C\u760F\u7612\u7613\u7615\u7616\u7619\u761B\u761C\u761D\u761E\u7623\u7625\u7626\u7629\u762D\u7632\u7633\u7635\u7638\u7639"],["8fcea1","\u763A\u763C\u764A\u7640\u7641\u7643\u7644\u7645\u7649\u764B\u7655\u7659\u765F\u7664\u7665\u766D\u766E\u766F\u7671\u7674\u7681\u7685\u768C\u768D\u7695\u769B\u769C\u769D\u769F\u76A0\u76A2",6,"\u76AA\u76AD\u76BD\u76C1\u76C5\u76C9\u76CB\u76CC\u76CE\u76D4\u76D9\u76E0\u76E6\u76E8\u76EC\u76F0\u76F1\u76F6\u76F9\u76FC\u7700\u7706\u770A\u770E\u7712\u7714\u7715\u7717\u7719\u771A\u771C\u7722\u7728\u772D\u772E\u772F\u7734\u7735\u7736\u7739\u773D\u773E\u7742\u7745\u7746\u774A\u774D\u774E\u774F\u7752\u7756\u7757\u775C\u775E\u775F\u7760\u7762"],["8fcfa1","\u7764\u7767\u776A\u776C\u7770\u7772\u7773\u7774\u777A\u777D\u7780\u7784\u778C\u778D\u7794\u7795\u7796\u779A\u779F\u77A2\u77A7\u77AA\u77AE\u77AF\u77B1\u77B5\u77BE\u77C3\u77C9\u77D1\u77D2\u77D5\u77D9\u77DE\u77DF\u77E0\u77E4\u77E6\u77EA\u77EC\u77F0\u77F1\u77F4\u77F8\u77FB\u7805\u7806\u7809\u780D\u780E\u7811\u781D\u7821\u7822\u7823\u782D\u782E\u7830\u7835\u7837\u7843\u7844\u7847\u7848\u784C\u784E\u7852\u785C\u785E\u7860\u7861\u7863\u7864\u7868\u786A\u786E\u787A\u787E\u788A\u788F\u7894\u7898\u78A1\u789D\u789E\u789F\u78A4\u78A8\u78AC\u78AD\u78B0\u78B1\u78B2\u78B3"],["8fd0a1","\u78BB\u78BD\u78BF\u78C7\u78C8\u78C9\u78CC\u78CE\u78D2\u78D3\u78D5\u78D6\u78E4\u78DB\u78DF\u78E0\u78E1\u78E6\u78EA\u78F2\u78F3\u7900\u78F6\u78F7\u78FA\u78FB\u78FF\u7906\u790C\u7910\u791A\u791C\u791E\u791F\u7920\u7925\u7927\u7929\u792D\u7931\u7934\u7935\u793B\u793D\u793F\u7944\u7945\u7946\u794A\u794B\u794F\u7951\u7954\u7958\u795B\u795C\u7967\u7969\u796B\u7972\u7979\u797B\u797C\u797E\u798B\u798C\u7991\u7993\u7994\u7995\u7996\u7998\u799B\u799C\u79A1\u79A8\u79A9\u79AB\u79AF\u79B1\u79B4\u79B8\u79BB\u79C2\u79C4\u79C7\u79C8\u79CA\u79CF\u79D4\u79D6\u79DA\u79DD\u79DE"],["8fd1a1","\u79E0\u79E2\u79E5\u79EA\u79EB\u79ED\u79F1\u79F8\u79FC\u7A02\u7A03\u7A07\u7A09\u7A0A\u7A0C\u7A11\u7A15\u7A1B\u7A1E\u7A21\u7A27\u7A2B\u7A2D\u7A2F\u7A30\u7A34\u7A35\u7A38\u7A39\u7A3A\u7A44\u7A45\u7A47\u7A48\u7A4C\u7A55\u7A56\u7A59\u7A5C\u7A5D\u7A5F\u7A60\u7A65\u7A67\u7A6A\u7A6D\u7A75\u7A78\u7A7E\u7A80\u7A82\u7A85\u7A86\u7A8A\u7A8B\u7A90\u7A91\u7A94\u7A9E\u7AA0\u7AA3\u7AAC\u7AB3\u7AB5\u7AB9\u7ABB\u7ABC\u7AC6\u7AC9\u7ACC\u7ACE\u7AD1\u7ADB\u7AE8\u7AE9\u7AEB\u7AEC\u7AF1\u7AF4\u7AFB\u7AFD\u7AFE\u7B07\u7B14\u7B1F\u7B23\u7B27\u7B29\u7B2A\u7B2B\u7B2D\u7B2E\u7B2F\u7B30"],["8fd2a1","\u7B31\u7B34\u7B3D\u7B3F\u7B40\u7B41\u7B47\u7B4E\u7B55\u7B60\u7B64\u7B66\u7B69\u7B6A\u7B6D\u7B6F\u7B72\u7B73\u7B77\u7B84\u7B89\u7B8E\u7B90\u7B91\u7B96\u7B9B\u7B9E\u7BA0\u7BA5\u7BAC\u7BAF\u7BB0\u7BB2\u7BB5\u7BB6\u7BBA\u7BBB\u7BBC\u7BBD\u7BC2\u7BC5\u7BC8\u7BCA\u7BD4\u7BD6\u7BD7\u7BD9\u7BDA\u7BDB\u7BE8\u7BEA\u7BF2\u7BF4\u7BF5\u7BF8\u7BF9\u7BFA\u7BFC\u7BFE\u7C01\u7C02\u7C03\u7C04\u7C06\u7C09\u7C0B\u7C0C\u7C0E\u7C0F\u7C19\u7C1B\u7C20\u7C25\u7C26\u7C28\u7C2C\u7C31\u7C33\u7C34\u7C36\u7C39\u7C3A\u7C46\u7C4A\u7C55\u7C51\u7C52\u7C53\u7C59",5],["8fd3a1","\u7C61\u7C63\u7C67\u7C69\u7C6D\u7C6E\u7C70\u7C72\u7C79\u7C7C\u7C7D\u7C86\u7C87\u7C8F\u7C94\u7C9E\u7CA0\u7CA6\u7CB0\u7CB6\u7CB7\u7CBA\u7CBB\u7CBC\u7CBF\u7CC4\u7CC7\u7CC8\u7CC9\u7CCD\u7CCF\u7CD3\u7CD4\u7CD5\u7CD7\u7CD9\u7CDA\u7CDD\u7CE6\u7CE9\u7CEB\u7CF5\u7D03\u7D07\u7D08\u7D09\u7D0F\u7D11\u7D12\u7D13\u7D16\u7D1D\u7D1E\u7D23\u7D26\u7D2A\u7D2D\u7D31\u7D3C\u7D3D\u7D3E\u7D40\u7D41\u7D47\u7D48\u7D4D\u7D51\u7D53\u7D57\u7D59\u7D5A\u7D5C\u7D5D\u7D65\u7D67\u7D6A\u7D70\u7D78\u7D7A\u7D7B\u7D7F\u7D81\u7D82\u7D83\u7D85\u7D86\u7D88\u7D8B\u7D8C\u7D8D\u7D91\u7D96\u7D97\u7D9D"],["8fd4a1","\u7D9E\u7DA6\u7DA7\u7DAA\u7DB3\u7DB6\u7DB7\u7DB9\u7DC2",4,"\u7DCC\u7DCD\u7DCE\u7DD7\u7DD9\u7E00\u7DE2\u7DE5\u7DE6\u7DEA\u7DEB\u7DED\u7DF1\u7DF5\u7DF6\u7DF9\u7DFA\u7E08\u7E10\u7E11\u7E15\u7E17\u7E1C\u7E1D\u7E20\u7E27\u7E28\u7E2C\u7E2D\u7E2F\u7E33\u7E36\u7E3F\u7E44\u7E45\u7E47\u7E4E\u7E50\u7E52\u7E58\u7E5F\u7E61\u7E62\u7E65\u7E6B\u7E6E\u7E6F\u7E73\u7E78\u7E7E\u7E81\u7E86\u7E87\u7E8A\u7E8D\u7E91\u7E95\u7E98\u7E9A\u7E9D\u7E9E\u7F3C\u7F3B\u7F3D\u7F3E\u7F3F\u7F43\u7F44\u7F47\u7F4F\u7F52\u7F53\u7F5B\u7F5C\u7F5D\u7F61\u7F63\u7F64\u7F65\u7F66\u7F6D"],["8fd5a1","\u7F71\u7F7D\u7F7E\u7F7F\u7F80\u7F8B\u7F8D\u7F8F\u7F90\u7F91\u7F96\u7F97\u7F9C\u7FA1\u7FA2\u7FA6\u7FAA\u7FAD\u7FB4\u7FBC\u7FBF\u7FC0\u7FC3\u7FC8\u7FCE\u7FCF\u7FDB\u7FDF\u7FE3\u7FE5\u7FE8\u7FEC\u7FEE\u7FEF\u7FF2\u7FFA\u7FFD\u7FFE\u7FFF\u8007\u8008\u800A\u800D\u800E\u800F\u8011\u8013\u8014\u8016\u801D\u801E\u801F\u8020\u8024\u8026\u802C\u802E\u8030\u8034\u8035\u8037\u8039\u803A\u803C\u803E\u8040\u8044\u8060\u8064\u8066\u806D\u8071\u8075\u8081\u8088\u808E\u809C\u809E\u80A6\u80A7\u80AB\u80B8\u80B9\u80C8\u80CD\u80CF\u80D2\u80D4\u80D5\u80D7\u80D8\u80E0\u80ED\u80EE"],["8fd6a1","\u80F0\u80F2\u80F3\u80F6\u80F9\u80FA\u80FE\u8103\u810B\u8116\u8117\u8118\u811C\u811E\u8120\u8124\u8127\u812C\u8130\u8135\u813A\u813C\u8145\u8147\u814A\u814C\u8152\u8157\u8160\u8161\u8167\u8168\u8169\u816D\u816F\u8177\u8181\u8190\u8184\u8185\u8186\u818B\u818E\u8196\u8198\u819B\u819E\u81A2\u81AE\u81B2\u81B4\u81BB\u81CB\u81C3\u81C5\u81CA\u81CE\u81CF\u81D5\u81D7\u81DB\u81DD\u81DE\u81E1\u81E4\u81EB\u81EC\u81F0\u81F1\u81F2\u81F5\u81F6\u81F8\u81F9\u81FD\u81FF\u8200\u8203\u820F\u8213\u8214\u8219\u821A\u821D\u8221\u8222\u8228\u8232\u8234\u823A\u8243\u8244\u8245\u8246"],["8fd7a1","\u824B\u824E\u824F\u8251\u8256\u825C\u8260\u8263\u8267\u826D\u8274\u827B\u827D\u827F\u8280\u8281\u8283\u8284\u8287\u8289\u828A\u828E\u8291\u8294\u8296\u8298\u829A\u829B\u82A0\u82A1\u82A3\u82A4\u82A7\u82A8\u82A9\u82AA\u82AE\u82B0\u82B2\u82B4\u82B7\u82BA\u82BC\u82BE\u82BF\u82C6\u82D0\u82D5\u82DA\u82E0\u82E2\u82E4\u82E8\u82EA\u82ED\u82EF\u82F6\u82F7\u82FD\u82FE\u8300\u8301\u8307\u8308\u830A\u830B\u8354\u831B\u831D\u831E\u831F\u8321\u8322\u832C\u832D\u832E\u8330\u8333\u8337\u833A\u833C\u833D\u8342\u8343\u8344\u8347\u834D\u834E\u8351\u8355\u8356\u8357\u8370\u8378"],["8fd8a1","\u837D\u837F\u8380\u8382\u8384\u8386\u838D\u8392\u8394\u8395\u8398\u8399\u839B\u839C\u839D\u83A6\u83A7\u83A9\u83AC\u83BE\u83BF\u83C0\u83C7\u83C9\u83CF\u83D0\u83D1\u83D4\u83DD\u8353\u83E8\u83EA\u83F6\u83F8\u83F9\u83FC\u8401\u8406\u840A\u840F\u8411\u8415\u8419\u83AD\u842F\u8439\u8445\u8447\u8448\u844A\u844D\u844F\u8451\u8452\u8456\u8458\u8459\u845A\u845C\u8460\u8464\u8465\u8467\u846A\u8470\u8473\u8474\u8476\u8478\u847C\u847D\u8481\u8485\u8492\u8493\u8495\u849E\u84A6\u84A8\u84A9\u84AA\u84AF\u84B1\u84B4\u84BA\u84BD\u84BE\u84C0\u84C2\u84C7\u84C8\u84CC\u84CF\u84D3"],["8fd9a1","\u84DC\u84E7\u84EA\u84EF\u84F0\u84F1\u84F2\u84F7\u8532\u84FA\u84FB\u84FD\u8502\u8503\u8507\u850C\u850E\u8510\u851C\u851E\u8522\u8523\u8524\u8525\u8527\u852A\u852B\u852F\u8533\u8534\u8536\u853F\u8546\u854F",4,"\u8556\u8559\u855C",6,"\u8564\u856B\u856F\u8579\u857A\u857B\u857D\u857F\u8581\u8585\u8586\u8589\u858B\u858C\u858F\u8593\u8598\u859D\u859F\u85A0\u85A2\u85A5\u85A7\u85B4\u85B6\u85B7\u85B8\u85BC\u85BD\u85BE\u85BF\u85C2\u85C7\u85CA\u85CB\u85CE\u85AD\u85D8\u85DA\u85DF\u85E0\u85E6\u85E8\u85ED\u85F3\u85F6\u85FC"],["8fdaa1","\u85FF\u8600\u8604\u8605\u860D\u860E\u8610\u8611\u8612\u8618\u8619\u861B\u861E\u8621\u8627\u8629\u8636\u8638\u863A\u863C\u863D\u8640\u8642\u8646\u8652\u8653\u8656\u8657\u8658\u8659\u865D\u8660",4,"\u8669\u866C\u866F\u8675\u8676\u8677\u867A\u868D\u8691\u8696\u8698\u869A\u869C\u86A1\u86A6\u86A7\u86A8\u86AD\u86B1\u86B3\u86B4\u86B5\u86B7\u86B8\u86B9\u86BF\u86C0\u86C1\u86C3\u86C5\u86D1\u86D2\u86D5\u86D7\u86DA\u86DC\u86E0\u86E3\u86E5\u86E7\u8688\u86FA\u86FC\u86FD\u8704\u8705\u8707\u870B\u870E\u870F\u8710\u8713\u8714\u8719\u871E\u871F\u8721\u8723"],["8fdba1","\u8728\u872E\u872F\u8731\u8732\u8739\u873A\u873C\u873D\u873E\u8740\u8743\u8745\u874D\u8758\u875D\u8761\u8764\u8765\u876F\u8771\u8772\u877B\u8783",6,"\u878B\u878C\u8790\u8793\u8795\u8797\u8798\u8799\u879E\u87A0\u87A3\u87A7\u87AC\u87AD\u87AE\u87B1\u87B5\u87BE\u87BF\u87C1\u87C8\u87C9\u87CA\u87CE\u87D5\u87D6\u87D9\u87DA\u87DC\u87DF\u87E2\u87E3\u87E4\u87EA\u87EB\u87ED\u87F1\u87F3\u87F8\u87FA\u87FF\u8801\u8803\u8806\u8809\u880A\u880B\u8810\u8819\u8812\u8813\u8814\u8818\u881A\u881B\u881C\u881E\u881F\u8828\u882D\u882E\u8830\u8832\u8835"],["8fdca1","\u883A\u883C\u8841\u8843\u8845\u8848\u8849\u884A\u884B\u884E\u8851\u8855\u8856\u8858\u885A\u885C\u885F\u8860\u8864\u8869\u8871\u8879\u887B\u8880\u8898\u889A\u889B\u889C\u889F\u88A0\u88A8\u88AA\u88BA\u88BD\u88BE\u88C0\u88CA",4,"\u88D1\u88D2\u88D3\u88DB\u88DE\u88E7\u88EF\u88F0\u88F1\u88F5\u88F7\u8901\u8906\u890D\u890E\u890F\u8915\u8916\u8918\u8919\u891A\u891C\u8920\u8926\u8927\u8928\u8930\u8931\u8932\u8935\u8939\u893A\u893E\u8940\u8942\u8945\u8946\u8949\u894F\u8952\u8957\u895A\u895B\u895C\u8961\u8962\u8963\u896B\u896E\u8970\u8973\u8975\u897A"],["8fdda1","\u897B\u897C\u897D\u8989\u898D\u8990\u8994\u8995\u899B\u899C\u899F\u89A0\u89A5\u89B0\u89B4\u89B5\u89B6\u89B7\u89BC\u89D4",4,"\u89E5\u89E9\u89EB\u89ED\u89F1\u89F3\u89F6\u89F9\u89FD\u89FF\u8A04\u8A05\u8A07\u8A0F\u8A11\u8A12\u8A14\u8A15\u8A1E\u8A20\u8A22\u8A24\u8A26\u8A2B\u8A2C\u8A2F\u8A35\u8A37\u8A3D\u8A3E\u8A40\u8A43\u8A45\u8A47\u8A49\u8A4D\u8A4E\u8A53\u8A56\u8A57\u8A58\u8A5C\u8A5D\u8A61\u8A65\u8A67\u8A75\u8A76\u8A77\u8A79\u8A7A\u8A7B\u8A7E\u8A7F\u8A80\u8A83\u8A86\u8A8B\u8A8F\u8A90\u8A92\u8A96\u8A97\u8A99\u8A9F\u8AA7\u8AA9\u8AAE\u8AAF\u8AB3"],["8fdea1","\u8AB6\u8AB7\u8ABB\u8ABE\u8AC3\u8AC6\u8AC8\u8AC9\u8ACA\u8AD1\u8AD3\u8AD4\u8AD5\u8AD7\u8ADD\u8ADF\u8AEC\u8AF0\u8AF4\u8AF5\u8AF6\u8AFC\u8AFF\u8B05\u8B06\u8B0B\u8B11\u8B1C\u8B1E\u8B1F\u8B0A\u8B2D\u8B30\u8B37\u8B3C\u8B42",4,"\u8B48\u8B52\u8B53\u8B54\u8B59\u8B4D\u8B5E\u8B63\u8B6D\u8B76\u8B78\u8B79\u8B7C\u8B7E\u8B81\u8B84\u8B85\u8B8B\u8B8D\u8B8F\u8B94\u8B95\u8B9C\u8B9E\u8B9F\u8C38\u8C39\u8C3D\u8C3E\u8C45\u8C47\u8C49\u8C4B\u8C4F\u8C51\u8C53\u8C54\u8C57\u8C58\u8C5B\u8C5D\u8C59\u8C63\u8C64\u8C66\u8C68\u8C69\u8C6D\u8C73\u8C75\u8C76\u8C7B\u8C7E\u8C86"],["8fdfa1","\u8C87\u8C8B\u8C90\u8C92\u8C93\u8C99\u8C9B\u8C9C\u8CA4\u8CB9\u8CBA\u8CC5\u8CC6\u8CC9\u8CCB\u8CCF\u8CD6\u8CD5\u8CD9\u8CDD\u8CE1\u8CE8\u8CEC\u8CEF\u8CF0\u8CF2\u8CF5\u8CF7\u8CF8\u8CFE\u8CFF\u8D01\u8D03\u8D09\u8D12\u8D17\u8D1B\u8D65\u8D69\u8D6C\u8D6E\u8D7F\u8D82\u8D84\u8D88\u8D8D\u8D90\u8D91\u8D95\u8D9E\u8D9F\u8DA0\u8DA6\u8DAB\u8DAC\u8DAF\u8DB2\u8DB5\u8DB7\u8DB9\u8DBB\u8DC0\u8DC5\u8DC6\u8DC7\u8DC8\u8DCA\u8DCE\u8DD1\u8DD4\u8DD5\u8DD7\u8DD9\u8DE4\u8DE5\u8DE7\u8DEC\u8DF0\u8DBC\u8DF1\u8DF2\u8DF4\u8DFD\u8E01\u8E04\u8E05\u8E06\u8E0B\u8E11\u8E14\u8E16\u8E20\u8E21\u8E22"],["8fe0a1","\u8E23\u8E26\u8E27\u8E31\u8E33\u8E36\u8E37\u8E38\u8E39\u8E3D\u8E40\u8E41\u8E4B\u8E4D\u8E4E\u8E4F\u8E54\u8E5B\u8E5C\u8E5D\u8E5E\u8E61\u8E62\u8E69\u8E6C\u8E6D\u8E6F\u8E70\u8E71\u8E79\u8E7A\u8E7B\u8E82\u8E83\u8E89\u8E90\u8E92\u8E95\u8E9A\u8E9B\u8E9D\u8E9E\u8EA2\u8EA7\u8EA9\u8EAD\u8EAE\u8EB3\u8EB5\u8EBA\u8EBB\u8EC0\u8EC1\u8EC3\u8EC4\u8EC7\u8ECF\u8ED1\u8ED4\u8EDC\u8EE8\u8EEE\u8EF0\u8EF1\u8EF7\u8EF9\u8EFA\u8EED\u8F00\u8F02\u8F07\u8F08\u8F0F\u8F10\u8F16\u8F17\u8F18\u8F1E\u8F20\u8F21\u8F23\u8F25\u8F27\u8F28\u8F2C\u8F2D\u8F2E\u8F34\u8F35\u8F36\u8F37\u8F3A\u8F40\u8F41"],["8fe1a1","\u8F43\u8F47\u8F4F\u8F51",4,"\u8F58\u8F5D\u8F5E\u8F65\u8F9D\u8FA0\u8FA1\u8FA4\u8FA5\u8FA6\u8FB5\u8FB6\u8FB8\u8FBE\u8FC0\u8FC1\u8FC6\u8FCA\u8FCB\u8FCD\u8FD0\u8FD2\u8FD3\u8FD5\u8FE0\u8FE3\u8FE4\u8FE8\u8FEE\u8FF1\u8FF5\u8FF6\u8FFB\u8FFE\u9002\u9004\u9008\u900C\u9018\u901B\u9028\u9029\u902F\u902A\u902C\u902D\u9033\u9034\u9037\u903F\u9043\u9044\u904C\u905B\u905D\u9062\u9066\u9067\u906C\u9070\u9074\u9079\u9085\u9088\u908B\u908C\u908E\u9090\u9095\u9097\u9098\u9099\u909B\u90A0\u90A1\u90A2\u90A5\u90B0\u90B2\u90B3\u90B4\u90B6\u90BD\u90CC\u90BE\u90C3"],["8fe2a1","\u90C4\u90C5\u90C7\u90C8\u90D5\u90D7\u90D8\u90D9\u90DC\u90DD\u90DF\u90E5\u90D2\u90F6\u90EB\u90EF\u90F0\u90F4\u90FE\u90FF\u9100\u9104\u9105\u9106\u9108\u910D\u9110\u9114\u9116\u9117\u9118\u911A\u911C\u911E\u9120\u9125\u9122\u9123\u9127\u9129\u912E\u912F\u9131\u9134\u9136\u9137\u9139\u913A\u913C\u913D\u9143\u9147\u9148\u914F\u9153\u9157\u9159\u915A\u915B\u9161\u9164\u9167\u916D\u9174\u9179\u917A\u917B\u9181\u9183\u9185\u9186\u918A\u918E\u9191\u9193\u9194\u9195\u9198\u919E\u91A1\u91A6\u91A8\u91AC\u91AD\u91AE\u91B0\u91B1\u91B2\u91B3\u91B6\u91BB\u91BC\u91BD\u91BF"],["8fe3a1","\u91C2\u91C3\u91C5\u91D3\u91D4\u91D7\u91D9\u91DA\u91DE\u91E4\u91E5\u91E9\u91EA\u91EC",5,"\u91F7\u91F9\u91FB\u91FD\u9200\u9201\u9204\u9205\u9206\u9207\u9209\u920A\u920C\u9210\u9212\u9213\u9216\u9218\u921C\u921D\u9223\u9224\u9225\u9226\u9228\u922E\u922F\u9230\u9233\u9235\u9236\u9238\u9239\u923A\u923C\u923E\u9240\u9242\u9243\u9246\u9247\u924A\u924D\u924E\u924F\u9251\u9258\u9259\u925C\u925D\u9260\u9261\u9265\u9267\u9268\u9269\u926E\u926F\u9270\u9275",4,"\u927B\u927C\u927D\u927F\u9288\u9289\u928A\u928D\u928E\u9292\u9297"],["8fe4a1","\u9299\u929F\u92A0\u92A4\u92A5\u92A7\u92A8\u92AB\u92AF\u92B2\u92B6\u92B8\u92BA\u92BB\u92BC\u92BD\u92BF",4,"\u92C5\u92C6\u92C7\u92C8\u92CB\u92CC\u92CD\u92CE\u92D0\u92D3\u92D5\u92D7\u92D8\u92D9\u92DC\u92DD\u92DF\u92E0\u92E1\u92E3\u92E5\u92E7\u92E8\u92EC\u92EE\u92F0\u92F9\u92FB\u92FF\u9300\u9302\u9308\u930D\u9311\u9314\u9315\u931C\u931D\u931E\u931F\u9321\u9324\u9325\u9327\u9329\u932A\u9333\u9334\u9336\u9337\u9347\u9348\u9349\u9350\u9351\u9352\u9355\u9357\u9358\u935A\u935E\u9364\u9365\u9367\u9369\u936A\u936D\u936F\u9370\u9371\u9373\u9374\u9376"],["8fe5a1","\u937A\u937D\u937F\u9380\u9381\u9382\u9388\u938A\u938B\u938D\u938F\u9392\u9395\u9398\u939B\u939E\u93A1\u93A3\u93A4\u93A6\u93A8\u93AB\u93B4\u93B5\u93B6\u93BA\u93A9\u93C1\u93C4\u93C5\u93C6\u93C7\u93C9",4,"\u93D3\u93D9\u93DC\u93DE\u93DF\u93E2\u93E6\u93E7\u93F9\u93F7\u93F8\u93FA\u93FB\u93FD\u9401\u9402\u9404\u9408\u9409\u940D\u940E\u940F\u9415\u9416\u9417\u941F\u942E\u942F\u9431\u9432\u9433\u9434\u943B\u943F\u943D\u9443\u9445\u9448\u944A\u944C\u9455\u9459\u945C\u945F\u9461\u9463\u9468\u946B\u946D\u946E\u946F\u9471\u9472\u9484\u9483\u9578\u9579"],["8fe6a1","\u957E\u9584\u9588\u958C\u958D\u958E\u959D\u959E\u959F\u95A1\u95A6\u95A9\u95AB\u95AC\u95B4\u95B6\u95BA\u95BD\u95BF\u95C6\u95C8\u95C9\u95CB\u95D0\u95D1\u95D2\u95D3\u95D9\u95DA\u95DD\u95DE\u95DF\u95E0\u95E4\u95E6\u961D\u961E\u9622\u9624\u9625\u9626\u962C\u9631\u9633\u9637\u9638\u9639\u963A\u963C\u963D\u9641\u9652\u9654\u9656\u9657\u9658\u9661\u966E\u9674\u967B\u967C\u967E\u967F\u9681\u9682\u9683\u9684\u9689\u9691\u9696\u969A\u969D\u969F\u96A4\u96A5\u96A6\u96A9\u96AE\u96AF\u96B3\u96BA\u96CA\u96D2\u5DB2\u96D8\u96DA\u96DD\u96DE\u96DF\u96E9\u96EF\u96F1\u96FA\u9702"],["8fe7a1","\u9703\u9705\u9709\u971A\u971B\u971D\u9721\u9722\u9723\u9728\u9731\u9733\u9741\u9743\u974A\u974E\u974F\u9755\u9757\u9758\u975A\u975B\u9763\u9767\u976A\u976E\u9773\u9776\u9777\u9778\u977B\u977D\u977F\u9780\u9789\u9795\u9796\u9797\u9799\u979A\u979E\u979F\u97A2\u97AC\u97AE\u97B1\u97B2\u97B5\u97B6\u97B8\u97B9\u97BA\u97BC\u97BE\u97BF\u97C1\u97C4\u97C5\u97C7\u97C9\u97CA\u97CC\u97CD\u97CE\u97D0\u97D1\u97D4\u97D7\u97D8\u97D9\u97DD\u97DE\u97E0\u97DB\u97E1\u97E4\u97EF\u97F1\u97F4\u97F7\u97F8\u97FA\u9807\u980A\u9819\u980D\u980E\u9814\u9816\u981C\u981E\u9820\u9823\u9826"],["8fe8a1","\u982B\u982E\u982F\u9830\u9832\u9833\u9835\u9825\u983E\u9844\u9847\u984A\u9851\u9852\u9853\u9856\u9857\u9859\u985A\u9862\u9863\u9865\u9866\u986A\u986C\u98AB\u98AD\u98AE\u98B0\u98B4\u98B7\u98B8\u98BA\u98BB\u98BF\u98C2\u98C5\u98C8\u98CC\u98E1\u98E3\u98E5\u98E6\u98E7\u98EA\u98F3\u98F6\u9902\u9907\u9908\u9911\u9915\u9916\u9917\u991A\u991B\u991C\u991F\u9922\u9926\u9927\u992B\u9931",4,"\u9939\u993A\u993B\u993C\u9940\u9941\u9946\u9947\u9948\u994D\u994E\u9954\u9958\u9959\u995B\u995C\u995E\u995F\u9960\u999B\u999D\u999F\u99A6\u99B0\u99B1\u99B2\u99B5"],["8fe9a1","\u99B9\u99BA\u99BD\u99BF\u99C3\u99C9\u99D3\u99D4\u99D9\u99DA\u99DC\u99DE\u99E7\u99EA\u99EB\u99EC\u99F0\u99F4\u99F5\u99F9\u99FD\u99FE\u9A02\u9A03\u9A04\u9A0B\u9A0C\u9A10\u9A11\u9A16\u9A1E\u9A20\u9A22\u9A23\u9A24\u9A27\u9A2D\u9A2E\u9A33\u9A35\u9A36\u9A38\u9A47\u9A41\u9A44\u9A4A\u9A4B\u9A4C\u9A4E\u9A51\u9A54\u9A56\u9A5D\u9AAA\u9AAC\u9AAE\u9AAF\u9AB2\u9AB4\u9AB5\u9AB6\u9AB9\u9ABB\u9ABE\u9ABF\u9AC1\u9AC3\u9AC6\u9AC8\u9ACE\u9AD0\u9AD2\u9AD5\u9AD6\u9AD7\u9ADB\u9ADC\u9AE0\u9AE4\u9AE5\u9AE7\u9AE9\u9AEC\u9AF2\u9AF3\u9AF5\u9AF9\u9AFA\u9AFD\u9AFF",4],["8feaa1","\u9B04\u9B05\u9B08\u9B09\u9B0B\u9B0C\u9B0D\u9B0E\u9B10\u9B12\u9B16\u9B19\u9B1B\u9B1C\u9B20\u9B26\u9B2B\u9B2D\u9B33\u9B34\u9B35\u9B37\u9B39\u9B3A\u9B3D\u9B48\u9B4B\u9B4C\u9B55\u9B56\u9B57\u9B5B\u9B5E\u9B61\u9B63\u9B65\u9B66\u9B68\u9B6A",4,"\u9B73\u9B75\u9B77\u9B78\u9B79\u9B7F\u9B80\u9B84\u9B85\u9B86\u9B87\u9B89\u9B8A\u9B8B\u9B8D\u9B8F\u9B90\u9B94\u9B9A\u9B9D\u9B9E\u9BA6\u9BA7\u9BA9\u9BAC\u9BB0\u9BB1\u9BB2\u9BB7\u9BB8\u9BBB\u9BBC\u9BBE\u9BBF\u9BC1\u9BC7\u9BC8\u9BCE\u9BD0\u9BD7\u9BD8\u9BDD\u9BDF\u9BE5\u9BE7\u9BEA\u9BEB\u9BEF\u9BF3\u9BF7\u9BF8"],["8feba1","\u9BF9\u9BFA\u9BFD\u9BFF\u9C00\u9C02\u9C0B\u9C0F\u9C11\u9C16\u9C18\u9C19\u9C1A\u9C1C\u9C1E\u9C22\u9C23\u9C26",4,"\u9C31\u9C35\u9C36\u9C37\u9C3D\u9C41\u9C43\u9C44\u9C45\u9C49\u9C4A\u9C4E\u9C4F\u9C50\u9C53\u9C54\u9C56\u9C58\u9C5B\u9C5D\u9C5E\u9C5F\u9C63\u9C69\u9C6A\u9C5C\u9C6B\u9C68\u9C6E\u9C70\u9C72\u9C75\u9C77\u9C7B\u9CE6\u9CF2\u9CF7\u9CF9\u9D0B\u9D02\u9D11\u9D17\u9D18\u9D1C\u9D1D\u9D1E\u9D2F\u9D30\u9D32\u9D33\u9D34\u9D3A\u9D3C\u9D45\u9D3D\u9D42\u9D43\u9D47\u9D4A\u9D53\u9D54\u9D5F\u9D63\u9D62\u9D65\u9D69\u9D6A\u9D6B\u9D70\u9D76\u9D77\u9D7B"],["8feca1","\u9D7C\u9D7E\u9D83\u9D84\u9D86\u9D8A\u9D8D\u9D8E\u9D92\u9D93\u9D95\u9D96\u9D97\u9D98\u9DA1\u9DAA\u9DAC\u9DAE\u9DB1\u9DB5\u9DB9\u9DBC\u9DBF\u9DC3\u9DC7\u9DC9\u9DCA\u9DD4\u9DD5\u9DD6\u9DD7\u9DDA\u9DDE\u9DDF\u9DE0\u9DE5\u9DE7\u9DE9\u9DEB\u9DEE\u9DF0\u9DF3\u9DF4\u9DFE\u9E0A\u9E02\u9E07\u9E0E\u9E10\u9E11\u9E12\u9E15\u9E16\u9E19\u9E1C\u9E1D\u9E7A\u9E7B\u9E7C\u9E80\u9E82\u9E83\u9E84\u9E85\u9E87\u9E8E\u9E8F\u9E96\u9E98\u9E9B\u9E9E\u9EA4\u9EA8\u9EAC\u9EAE\u9EAF\u9EB0\u9EB3\u9EB4\u9EB5\u9EC6\u9EC8\u9ECB\u9ED5\u9EDF\u9EE4\u9EE7\u9EEC\u9EED\u9EEE\u9EF0\u9EF1\u9EF2\u9EF5"],["8feda1","\u9EF8\u9EFF\u9F02\u9F03\u9F09\u9F0F\u9F10\u9F11\u9F12\u9F14\u9F16\u9F17\u9F19\u9F1A\u9F1B\u9F1F\u9F22\u9F26\u9F2A\u9F2B\u9F2F\u9F31\u9F32\u9F34\u9F37\u9F39\u9F3A\u9F3C\u9F3D\u9F3F\u9F41\u9F43",4,"\u9F53\u9F55\u9F56\u9F57\u9F58\u9F5A\u9F5D\u9F5E\u9F68\u9F69\u9F6D",4,"\u9F73\u9F75\u9F7A\u9F7D\u9F8F\u9F90\u9F91\u9F92\u9F94\u9F96\u9F97\u9F9E\u9FA1\u9FA2\u9FA3\u9FA5"]]');

},{}],"lHy4o":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["0","\\u0000",127,"\u20AC"],["8140","\u4E02\u4E04\u4E05\u4E06\u4E0F\u4E12\u4E17\u4E1F\u4E20\u4E21\u4E23\u4E26\u4E29\u4E2E\u4E2F\u4E31\u4E33\u4E35\u4E37\u4E3C\u4E40\u4E41\u4E42\u4E44\u4E46\u4E4A\u4E51\u4E55\u4E57\u4E5A\u4E5B\u4E62\u4E63\u4E64\u4E65\u4E67\u4E68\u4E6A",5,"\u4E72\u4E74",9,"\u4E7F",6,"\u4E87\u4E8A"],["8180","\u4E90\u4E96\u4E97\u4E99\u4E9C\u4E9D\u4E9E\u4EA3\u4EAA\u4EAF\u4EB0\u4EB1\u4EB4\u4EB6\u4EB7\u4EB8\u4EB9\u4EBC\u4EBD\u4EBE\u4EC8\u4ECC\u4ECF\u4ED0\u4ED2\u4EDA\u4EDB\u4EDC\u4EE0\u4EE2\u4EE6\u4EE7\u4EE9\u4EED\u4EEE\u4EEF\u4EF1\u4EF4\u4EF8\u4EF9\u4EFA\u4EFC\u4EFE\u4F00\u4F02",6,"\u4F0B\u4F0C\u4F12",4,"\u4F1C\u4F1D\u4F21\u4F23\u4F28\u4F29\u4F2C\u4F2D\u4F2E\u4F31\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E",4,"\u4F44\u4F45\u4F47",5,"\u4F52\u4F54\u4F56\u4F61\u4F62\u4F66\u4F68\u4F6A\u4F6B\u4F6D\u4F6E\u4F71\u4F72\u4F75\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F80\u4F81\u4F82\u4F85\u4F86\u4F87\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F95\u4F96\u4F98\u4F99\u4F9A\u4F9C\u4F9E\u4F9F\u4FA1\u4FA2"],["8240","\u4FA4\u4FAB\u4FAD\u4FB0",4,"\u4FB6",8,"\u4FC0\u4FC1\u4FC2\u4FC6\u4FC7\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FD2",4,"\u4FD9\u4FDB\u4FE0\u4FE2\u4FE4\u4FE5\u4FE7\u4FEB\u4FEC\u4FF0\u4FF2\u4FF4\u4FF5\u4FF6\u4FF7\u4FF9\u4FFB\u4FFC\u4FFD\u4FFF",11],["8280","\u500B\u500E\u5010\u5011\u5013\u5015\u5016\u5017\u501B\u501D\u501E\u5020\u5022\u5023\u5024\u5027\u502B\u502F",10,"\u503B\u503D\u503F\u5040\u5041\u5042\u5044\u5045\u5046\u5049\u504A\u504B\u504D\u5050",4,"\u5056\u5057\u5058\u5059\u505B\u505D",7,"\u5066",5,"\u506D",8,"\u5078\u5079\u507A\u507C\u507D\u5081\u5082\u5083\u5084\u5086\u5087\u5089\u508A\u508B\u508C\u508E",20,"\u50A4\u50A6\u50AA\u50AB\u50AD",4,"\u50B3",6,"\u50BC"],["8340","\u50BD",17,"\u50D0",5,"\u50D7\u50D8\u50D9\u50DB",10,"\u50E8\u50E9\u50EA\u50EB\u50EF\u50F0\u50F1\u50F2\u50F4\u50F6",4,"\u50FC",9,"\u5108"],["8380","\u5109\u510A\u510C",5,"\u5113",13,"\u5122",28,"\u5142\u5147\u514A\u514C\u514E\u514F\u5150\u5152\u5153\u5157\u5158\u5159\u515B\u515D",4,"\u5163\u5164\u5166\u5167\u5169\u516A\u516F\u5172\u517A\u517E\u517F\u5183\u5184\u5186\u5187\u518A\u518B\u518E\u518F\u5190\u5191\u5193\u5194\u5198\u519A\u519D\u519E\u519F\u51A1\u51A3\u51A6",4,"\u51AD\u51AE\u51B4\u51B8\u51B9\u51BA\u51BE\u51BF\u51C1\u51C2\u51C3\u51C5\u51C8\u51CA\u51CD\u51CE\u51D0\u51D2",5],["8440","\u51D8\u51D9\u51DA\u51DC\u51DE\u51DF\u51E2\u51E3\u51E5",5,"\u51EC\u51EE\u51F1\u51F2\u51F4\u51F7\u51FE\u5204\u5205\u5209\u520B\u520C\u520F\u5210\u5213\u5214\u5215\u521C\u521E\u521F\u5221\u5222\u5223\u5225\u5226\u5227\u522A\u522C\u522F\u5231\u5232\u5234\u5235\u523C\u523E\u5244",5,"\u524B\u524E\u524F\u5252\u5253\u5255\u5257\u5258"],["8480","\u5259\u525A\u525B\u525D\u525F\u5260\u5262\u5263\u5264\u5266\u5268\u526B\u526C\u526D\u526E\u5270\u5271\u5273",9,"\u527E\u5280\u5283",4,"\u5289",6,"\u5291\u5292\u5294",6,"\u529C\u52A4\u52A5\u52A6\u52A7\u52AE\u52AF\u52B0\u52B4",9,"\u52C0\u52C1\u52C2\u52C4\u52C5\u52C6\u52C8\u52CA\u52CC\u52CD\u52CE\u52CF\u52D1\u52D3\u52D4\u52D5\u52D7\u52D9",5,"\u52E0\u52E1\u52E2\u52E3\u52E5",10,"\u52F1",7,"\u52FB\u52FC\u52FD\u5301\u5302\u5303\u5304\u5307\u5309\u530A\u530B\u530C\u530E"],["8540","\u5311\u5312\u5313\u5314\u5318\u531B\u531C\u531E\u531F\u5322\u5324\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u532F",9,"\u533C\u533D\u5340\u5342\u5344\u5346\u534B\u534C\u534D\u5350\u5354\u5358\u5359\u535B\u535D\u5365\u5368\u536A\u536C\u536D\u5372\u5376\u5379\u537B\u537C\u537D\u537E\u5380\u5381\u5383\u5387\u5388\u538A\u538E\u538F"],["8580","\u5390",4,"\u5396\u5397\u5399\u539B\u539C\u539E\u53A0\u53A1\u53A4\u53A7\u53AA\u53AB\u53AC\u53AD\u53AF",6,"\u53B7\u53B8\u53B9\u53BA\u53BC\u53BD\u53BE\u53C0\u53C3",4,"\u53CE\u53CF\u53D0\u53D2\u53D3\u53D5\u53DA\u53DC\u53DD\u53DE\u53E1\u53E2\u53E7\u53F4\u53FA\u53FE\u53FF\u5400\u5402\u5405\u5407\u540B\u5414\u5418\u5419\u541A\u541C\u5422\u5424\u5425\u542A\u5430\u5433\u5436\u5437\u543A\u543D\u543F\u5441\u5442\u5444\u5445\u5447\u5449\u544C\u544D\u544E\u544F\u5451\u545A\u545D",4,"\u5463\u5465\u5467\u5469",7,"\u5474\u5479\u547A\u547E\u547F\u5481\u5483\u5485\u5487\u5488\u5489\u548A\u548D\u5491\u5493\u5497\u5498\u549C\u549E\u549F\u54A0\u54A1"],["8640","\u54A2\u54A5\u54AE\u54B0\u54B2\u54B5\u54B6\u54B7\u54B9\u54BA\u54BC\u54BE\u54C3\u54C5\u54CA\u54CB\u54D6\u54D8\u54DB\u54E0",4,"\u54EB\u54EC\u54EF\u54F0\u54F1\u54F4",5,"\u54FB\u54FE\u5500\u5502\u5503\u5504\u5505\u5508\u550A",4,"\u5512\u5513\u5515",5,"\u551C\u551D\u551E\u551F\u5521\u5525\u5526"],["8680","\u5528\u5529\u552B\u552D\u5532\u5534\u5535\u5536\u5538\u5539\u553A\u553B\u553D\u5540\u5542\u5545\u5547\u5548\u554B",4,"\u5551\u5552\u5553\u5554\u5557",4,"\u555D\u555E\u555F\u5560\u5562\u5563\u5568\u5569\u556B\u556F",5,"\u5579\u557A\u557D\u557F\u5585\u5586\u558C\u558D\u558E\u5590\u5592\u5593\u5595\u5596\u5597\u559A\u559B\u559E\u55A0",6,"\u55A8",8,"\u55B2\u55B4\u55B6\u55B8\u55BA\u55BC\u55BF",4,"\u55C6\u55C7\u55C8\u55CA\u55CB\u55CE\u55CF\u55D0\u55D5\u55D7",4,"\u55DE\u55E0\u55E2\u55E7\u55E9\u55ED\u55EE\u55F0\u55F1\u55F4\u55F6\u55F8",4,"\u55FF\u5602\u5603\u5604\u5605"],["8740","\u5606\u5607\u560A\u560B\u560D\u5610",7,"\u5619\u561A\u561C\u561D\u5620\u5621\u5622\u5625\u5626\u5628\u5629\u562A\u562B\u562E\u562F\u5630\u5633\u5635\u5637\u5638\u563A\u563C\u563D\u563E\u5640",11,"\u564F",4,"\u5655\u5656\u565A\u565B\u565D",4],["8780","\u5663\u5665\u5666\u5667\u566D\u566E\u566F\u5670\u5672\u5673\u5674\u5675\u5677\u5678\u5679\u567A\u567D",7,"\u5687",6,"\u5690\u5691\u5692\u5694",14,"\u56A4",10,"\u56B0",6,"\u56B8\u56B9\u56BA\u56BB\u56BD",12,"\u56CB",8,"\u56D5\u56D6\u56D8\u56D9\u56DC\u56E3\u56E5",5,"\u56EC\u56EE\u56EF\u56F2\u56F3\u56F6\u56F7\u56F8\u56FB\u56FC\u5700\u5701\u5702\u5705\u5707\u570B",6],["8840","\u5712",9,"\u571D\u571E\u5720\u5721\u5722\u5724\u5725\u5726\u5727\u572B\u5731\u5732\u5734",4,"\u573C\u573D\u573F\u5741\u5743\u5744\u5745\u5746\u5748\u5749\u574B\u5752",4,"\u5758\u5759\u5762\u5763\u5765\u5767\u576C\u576E\u5770\u5771\u5772\u5774\u5775\u5778\u5779\u577A\u577D\u577E\u577F\u5780"],["8880","\u5781\u5787\u5788\u5789\u578A\u578D",4,"\u5794",6,"\u579C\u579D\u579E\u579F\u57A5\u57A8\u57AA\u57AC\u57AF\u57B0\u57B1\u57B3\u57B5\u57B6\u57B7\u57B9",8,"\u57C4",6,"\u57CC\u57CD\u57D0\u57D1\u57D3\u57D6\u57D7\u57DB\u57DC\u57DE\u57E1\u57E2\u57E3\u57E5",7,"\u57EE\u57F0\u57F1\u57F2\u57F3\u57F5\u57F6\u57F7\u57FB\u57FC\u57FE\u57FF\u5801\u5803\u5804\u5805\u5808\u5809\u580A\u580C\u580E\u580F\u5810\u5812\u5813\u5814\u5816\u5817\u5818\u581A\u581B\u581C\u581D\u581F\u5822\u5823\u5825",4,"\u582B",4,"\u5831\u5832\u5833\u5834\u5836",7],["8940","\u583E",5,"\u5845",6,"\u584E\u584F\u5850\u5852\u5853\u5855\u5856\u5857\u5859",4,"\u585F",5,"\u5866",4,"\u586D",16,"\u587F\u5882\u5884\u5886\u5887\u5888\u588A\u588B\u588C"],["8980","\u588D",4,"\u5894",4,"\u589B\u589C\u589D\u58A0",7,"\u58AA",17,"\u58BD\u58BE\u58BF\u58C0\u58C2\u58C3\u58C4\u58C6",10,"\u58D2\u58D3\u58D4\u58D6",13,"\u58E5",5,"\u58ED\u58EF\u58F1\u58F2\u58F4\u58F5\u58F7\u58F8\u58FA",7,"\u5903\u5905\u5906\u5908",4,"\u590E\u5910\u5911\u5912\u5913\u5917\u5918\u591B\u591D\u591E\u5920\u5921\u5922\u5923\u5926\u5928\u592C\u5930\u5932\u5933\u5935\u5936\u593B"],["8a40","\u593D\u593E\u593F\u5940\u5943\u5945\u5946\u594A\u594C\u594D\u5950\u5952\u5953\u5959\u595B",4,"\u5961\u5963\u5964\u5966",12,"\u5975\u5977\u597A\u597B\u597C\u597E\u597F\u5980\u5985\u5989\u598B\u598C\u598E\u598F\u5990\u5991\u5994\u5995\u5998\u599A\u599B\u599C\u599D\u599F\u59A0\u59A1\u59A2\u59A6"],["8a80","\u59A7\u59AC\u59AD\u59B0\u59B1\u59B3",5,"\u59BA\u59BC\u59BD\u59BF",6,"\u59C7\u59C8\u59C9\u59CC\u59CD\u59CE\u59CF\u59D5\u59D6\u59D9\u59DB\u59DE",4,"\u59E4\u59E6\u59E7\u59E9\u59EA\u59EB\u59ED",11,"\u59FA\u59FC\u59FD\u59FE\u5A00\u5A02\u5A0A\u5A0B\u5A0D\u5A0E\u5A0F\u5A10\u5A12\u5A14\u5A15\u5A16\u5A17\u5A19\u5A1A\u5A1B\u5A1D\u5A1E\u5A21\u5A22\u5A24\u5A26\u5A27\u5A28\u5A2A",6,"\u5A33\u5A35\u5A37",4,"\u5A3D\u5A3E\u5A3F\u5A41",4,"\u5A47\u5A48\u5A4B",9,"\u5A56\u5A57\u5A58\u5A59\u5A5B",5],["8b40","\u5A61\u5A63\u5A64\u5A65\u5A66\u5A68\u5A69\u5A6B",8,"\u5A78\u5A79\u5A7B\u5A7C\u5A7D\u5A7E\u5A80",17,"\u5A93",6,"\u5A9C",13,"\u5AAB\u5AAC"],["8b80","\u5AAD",4,"\u5AB4\u5AB6\u5AB7\u5AB9",4,"\u5ABF\u5AC0\u5AC3",5,"\u5ACA\u5ACB\u5ACD",4,"\u5AD3\u5AD5\u5AD7\u5AD9\u5ADA\u5ADB\u5ADD\u5ADE\u5ADF\u5AE2\u5AE4\u5AE5\u5AE7\u5AE8\u5AEA\u5AEC",4,"\u5AF2",22,"\u5B0A",11,"\u5B18",25,"\u5B33\u5B35\u5B36\u5B38",7,"\u5B41",6],["8c40","\u5B48",7,"\u5B52\u5B56\u5B5E\u5B60\u5B61\u5B67\u5B68\u5B6B\u5B6D\u5B6E\u5B6F\u5B72\u5B74\u5B76\u5B77\u5B78\u5B79\u5B7B\u5B7C\u5B7E\u5B7F\u5B82\u5B86\u5B8A\u5B8D\u5B8E\u5B90\u5B91\u5B92\u5B94\u5B96\u5B9F\u5BA7\u5BA8\u5BA9\u5BAC\u5BAD\u5BAE\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBB\u5BBC\u5BC0\u5BC1\u5BC3\u5BC8\u5BC9\u5BCA\u5BCB\u5BCD\u5BCE\u5BCF"],["8c80","\u5BD1\u5BD4",8,"\u5BE0\u5BE2\u5BE3\u5BE6\u5BE7\u5BE9",4,"\u5BEF\u5BF1",6,"\u5BFD\u5BFE\u5C00\u5C02\u5C03\u5C05\u5C07\u5C08\u5C0B\u5C0C\u5C0D\u5C0E\u5C10\u5C12\u5C13\u5C17\u5C19\u5C1B\u5C1E\u5C1F\u5C20\u5C21\u5C23\u5C26\u5C28\u5C29\u5C2A\u5C2B\u5C2D\u5C2E\u5C2F\u5C30\u5C32\u5C33\u5C35\u5C36\u5C37\u5C43\u5C44\u5C46\u5C47\u5C4C\u5C4D\u5C52\u5C53\u5C54\u5C56\u5C57\u5C58\u5C5A\u5C5B\u5C5C\u5C5D\u5C5F\u5C62\u5C64\u5C67",6,"\u5C70\u5C72",6,"\u5C7B\u5C7C\u5C7D\u5C7E\u5C80\u5C83",4,"\u5C89\u5C8A\u5C8B\u5C8E\u5C8F\u5C92\u5C93\u5C95\u5C9D",4,"\u5CA4",4],["8d40","\u5CAA\u5CAE\u5CAF\u5CB0\u5CB2\u5CB4\u5CB6\u5CB9\u5CBA\u5CBB\u5CBC\u5CBE\u5CC0\u5CC2\u5CC3\u5CC5",5,"\u5CCC",5,"\u5CD3",5,"\u5CDA",6,"\u5CE2\u5CE3\u5CE7\u5CE9\u5CEB\u5CEC\u5CEE\u5CEF\u5CF1",9,"\u5CFC",4],["8d80","\u5D01\u5D04\u5D05\u5D08",5,"\u5D0F",4,"\u5D15\u5D17\u5D18\u5D19\u5D1A\u5D1C\u5D1D\u5D1F",4,"\u5D25\u5D28\u5D2A\u5D2B\u5D2C\u5D2F",4,"\u5D35",7,"\u5D3F",7,"\u5D48\u5D49\u5D4D",10,"\u5D59\u5D5A\u5D5C\u5D5E",10,"\u5D6A\u5D6D\u5D6E\u5D70\u5D71\u5D72\u5D73\u5D75",12,"\u5D83",21,"\u5D9A\u5D9B\u5D9C\u5D9E\u5D9F\u5DA0"],["8e40","\u5DA1",21,"\u5DB8",12,"\u5DC6",6,"\u5DCE",12,"\u5DDC\u5DDF\u5DE0\u5DE3\u5DE4\u5DEA\u5DEC\u5DED"],["8e80","\u5DF0\u5DF5\u5DF6\u5DF8",4,"\u5DFF\u5E00\u5E04\u5E07\u5E09\u5E0A\u5E0B\u5E0D\u5E0E\u5E12\u5E13\u5E17\u5E1E",7,"\u5E28",4,"\u5E2F\u5E30\u5E32",4,"\u5E39\u5E3A\u5E3E\u5E3F\u5E40\u5E41\u5E43\u5E46",5,"\u5E4D",6,"\u5E56",4,"\u5E5C\u5E5D\u5E5F\u5E60\u5E63",14,"\u5E75\u5E77\u5E79\u5E7E\u5E81\u5E82\u5E83\u5E85\u5E88\u5E89\u5E8C\u5E8D\u5E8E\u5E92\u5E98\u5E9B\u5E9D\u5EA1\u5EA2\u5EA3\u5EA4\u5EA8",4,"\u5EAE",4,"\u5EB4\u5EBA\u5EBB\u5EBC\u5EBD\u5EBF",6],["8f40","\u5EC6\u5EC7\u5EC8\u5ECB",5,"\u5ED4\u5ED5\u5ED7\u5ED8\u5ED9\u5EDA\u5EDC",11,"\u5EE9\u5EEB",8,"\u5EF5\u5EF8\u5EF9\u5EFB\u5EFC\u5EFD\u5F05\u5F06\u5F07\u5F09\u5F0C\u5F0D\u5F0E\u5F10\u5F12\u5F14\u5F16\u5F19\u5F1A\u5F1C\u5F1D\u5F1E\u5F21\u5F22\u5F23\u5F24"],["8f80","\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F32",6,"\u5F3B\u5F3D\u5F3E\u5F3F\u5F41",14,"\u5F51\u5F54\u5F59\u5F5A\u5F5B\u5F5C\u5F5E\u5F5F\u5F60\u5F63\u5F65\u5F67\u5F68\u5F6B\u5F6E\u5F6F\u5F72\u5F74\u5F75\u5F76\u5F78\u5F7A\u5F7D\u5F7E\u5F7F\u5F83\u5F86\u5F8D\u5F8E\u5F8F\u5F91\u5F93\u5F94\u5F96\u5F9A\u5F9B\u5F9D\u5F9E\u5F9F\u5FA0\u5FA2",5,"\u5FA9\u5FAB\u5FAC\u5FAF",5,"\u5FB6\u5FB8\u5FB9\u5FBA\u5FBB\u5FBE",4,"\u5FC7\u5FC8\u5FCA\u5FCB\u5FCE\u5FD3\u5FD4\u5FD5\u5FDA\u5FDB\u5FDC\u5FDE\u5FDF\u5FE2\u5FE3\u5FE5\u5FE6\u5FE8\u5FE9\u5FEC\u5FEF\u5FF0\u5FF2\u5FF3\u5FF4\u5FF6\u5FF7\u5FF9\u5FFA\u5FFC\u6007"],["9040","\u6008\u6009\u600B\u600C\u6010\u6011\u6013\u6017\u6018\u601A\u601E\u601F\u6022\u6023\u6024\u602C\u602D\u602E\u6030",4,"\u6036",4,"\u603D\u603E\u6040\u6044",6,"\u604C\u604E\u604F\u6051\u6053\u6054\u6056\u6057\u6058\u605B\u605C\u605E\u605F\u6060\u6061\u6065\u6066\u606E\u6071\u6072\u6074\u6075\u6077\u607E\u6080"],["9080","\u6081\u6082\u6085\u6086\u6087\u6088\u608A\u608B\u608E\u608F\u6090\u6091\u6093\u6095\u6097\u6098\u6099\u609C\u609E\u60A1\u60A2\u60A4\u60A5\u60A7\u60A9\u60AA\u60AE\u60B0\u60B3\u60B5\u60B6\u60B7\u60B9\u60BA\u60BD",7,"\u60C7\u60C8\u60C9\u60CC",4,"\u60D2\u60D3\u60D4\u60D6\u60D7\u60D9\u60DB\u60DE\u60E1",4,"\u60EA\u60F1\u60F2\u60F5\u60F7\u60F8\u60FB",4,"\u6102\u6103\u6104\u6105\u6107\u610A\u610B\u610C\u6110",4,"\u6116\u6117\u6118\u6119\u611B\u611C\u611D\u611E\u6121\u6122\u6125\u6128\u6129\u612A\u612C",18,"\u6140",6],["9140","\u6147\u6149\u614B\u614D\u614F\u6150\u6152\u6153\u6154\u6156",6,"\u615E\u615F\u6160\u6161\u6163\u6164\u6165\u6166\u6169",6,"\u6171\u6172\u6173\u6174\u6176\u6178",18,"\u618C\u618D\u618F",4,"\u6195"],["9180","\u6196",6,"\u619E",8,"\u61AA\u61AB\u61AD",9,"\u61B8",5,"\u61BF\u61C0\u61C1\u61C3",4,"\u61C9\u61CC",4,"\u61D3\u61D5",16,"\u61E7",13,"\u61F6",8,"\u6200",5,"\u6207\u6209\u6213\u6214\u6219\u621C\u621D\u621E\u6220\u6223\u6226\u6227\u6228\u6229\u622B\u622D\u622F\u6230\u6231\u6232\u6235\u6236\u6238",4,"\u6242\u6244\u6245\u6246\u624A"],["9240","\u624F\u6250\u6255\u6256\u6257\u6259\u625A\u625C",6,"\u6264\u6265\u6268\u6271\u6272\u6274\u6275\u6277\u6278\u627A\u627B\u627D\u6281\u6282\u6283\u6285\u6286\u6287\u6288\u628B",5,"\u6294\u6299\u629C\u629D\u629E\u62A3\u62A6\u62A7\u62A9\u62AA\u62AD\u62AE\u62AF\u62B0\u62B2\u62B3\u62B4\u62B6\u62B7\u62B8\u62BA\u62BE\u62C0\u62C1"],["9280","\u62C3\u62CB\u62CF\u62D1\u62D5\u62DD\u62DE\u62E0\u62E1\u62E4\u62EA\u62EB\u62F0\u62F2\u62F5\u62F8\u62F9\u62FA\u62FB\u6300\u6303\u6304\u6305\u6306\u630A\u630B\u630C\u630D\u630F\u6310\u6312\u6313\u6314\u6315\u6317\u6318\u6319\u631C\u6326\u6327\u6329\u632C\u632D\u632E\u6330\u6331\u6333",5,"\u633B\u633C\u633E\u633F\u6340\u6341\u6344\u6347\u6348\u634A\u6351\u6352\u6353\u6354\u6356",7,"\u6360\u6364\u6365\u6366\u6368\u636A\u636B\u636C\u636F\u6370\u6372\u6373\u6374\u6375\u6378\u6379\u637C\u637D\u637E\u637F\u6381\u6383\u6384\u6385\u6386\u638B\u638D\u6391\u6393\u6394\u6395\u6397\u6399",6,"\u63A1\u63A4\u63A6\u63AB\u63AF\u63B1\u63B2\u63B5\u63B6\u63B9\u63BB\u63BD\u63BF\u63C0"],["9340","\u63C1\u63C2\u63C3\u63C5\u63C7\u63C8\u63CA\u63CB\u63CC\u63D1\u63D3\u63D4\u63D5\u63D7",6,"\u63DF\u63E2\u63E4",4,"\u63EB\u63EC\u63EE\u63EF\u63F0\u63F1\u63F3\u63F5\u63F7\u63F9\u63FA\u63FB\u63FC\u63FE\u6403\u6404\u6406",4,"\u640D\u640E\u6411\u6412\u6415",5,"\u641D\u641F\u6422\u6423\u6424"],["9380","\u6425\u6427\u6428\u6429\u642B\u642E",5,"\u6435",4,"\u643B\u643C\u643E\u6440\u6442\u6443\u6449\u644B",6,"\u6453\u6455\u6456\u6457\u6459",4,"\u645F",7,"\u6468\u646A\u646B\u646C\u646E",9,"\u647B",6,"\u6483\u6486\u6488",8,"\u6493\u6494\u6497\u6498\u649A\u649B\u649C\u649D\u649F",4,"\u64A5\u64A6\u64A7\u64A8\u64AA\u64AB\u64AF\u64B1\u64B2\u64B3\u64B4\u64B6\u64B9\u64BB\u64BD\u64BE\u64BF\u64C1\u64C3\u64C4\u64C6",6,"\u64CF\u64D1\u64D3\u64D4\u64D5\u64D6\u64D9\u64DA"],["9440","\u64DB\u64DC\u64DD\u64DF\u64E0\u64E1\u64E3\u64E5\u64E7",24,"\u6501",7,"\u650A",7,"\u6513",4,"\u6519",8],["9480","\u6522\u6523\u6524\u6526",4,"\u652C\u652D\u6530\u6531\u6532\u6533\u6537\u653A\u653C\u653D\u6540",4,"\u6546\u6547\u654A\u654B\u654D\u654E\u6550\u6552\u6553\u6554\u6557\u6558\u655A\u655C\u655F\u6560\u6561\u6564\u6565\u6567\u6568\u6569\u656A\u656D\u656E\u656F\u6571\u6573\u6575\u6576\u6578",14,"\u6588\u6589\u658A\u658D\u658E\u658F\u6592\u6594\u6595\u6596\u6598\u659A\u659D\u659E\u65A0\u65A2\u65A3\u65A6\u65A8\u65AA\u65AC\u65AE\u65B1",7,"\u65BA\u65BB\u65BE\u65BF\u65C0\u65C2\u65C7\u65C8\u65C9\u65CA\u65CD\u65D0\u65D1\u65D3\u65D4\u65D5\u65D8",7,"\u65E1\u65E3\u65E4\u65EA\u65EB"],["9540","\u65F2\u65F3\u65F4\u65F5\u65F8\u65F9\u65FB",4,"\u6601\u6604\u6605\u6607\u6608\u6609\u660B\u660D\u6610\u6611\u6612\u6616\u6617\u6618\u661A\u661B\u661C\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6632\u6633\u6637",4,"\u663D\u663F\u6640\u6642\u6644",6,"\u664D\u664E\u6650\u6651\u6658"],["9580","\u6659\u665B\u665C\u665D\u665E\u6660\u6662\u6663\u6665\u6667\u6669",4,"\u6671\u6672\u6673\u6675\u6678\u6679\u667B\u667C\u667D\u667F\u6680\u6681\u6683\u6685\u6686\u6688\u6689\u668A\u668B\u668D\u668E\u668F\u6690\u6692\u6693\u6694\u6695\u6698",4,"\u669E",8,"\u66A9",4,"\u66AF",4,"\u66B5\u66B6\u66B7\u66B8\u66BA\u66BB\u66BC\u66BD\u66BF",25,"\u66DA\u66DE",7,"\u66E7\u66E8\u66EA",5,"\u66F1\u66F5\u66F6\u66F8\u66FA\u66FB\u66FD\u6701\u6702\u6703"],["9640","\u6704\u6705\u6706\u6707\u670C\u670E\u670F\u6711\u6712\u6713\u6716\u6718\u6719\u671A\u671C\u671E\u6720",5,"\u6727\u6729\u672E\u6730\u6732\u6733\u6736\u6737\u6738\u6739\u673B\u673C\u673E\u673F\u6741\u6744\u6745\u6747\u674A\u674B\u674D\u6752\u6754\u6755\u6757",4,"\u675D\u6762\u6763\u6764\u6766\u6767\u676B\u676C\u676E\u6771\u6774\u6776"],["9680","\u6778\u6779\u677A\u677B\u677D\u6780\u6782\u6783\u6785\u6786\u6788\u678A\u678C\u678D\u678E\u678F\u6791\u6792\u6793\u6794\u6796\u6799\u679B\u679F\u67A0\u67A1\u67A4\u67A6\u67A9\u67AC\u67AE\u67B1\u67B2\u67B4\u67B9",7,"\u67C2\u67C5",9,"\u67D5\u67D6\u67D7\u67DB\u67DF\u67E1\u67E3\u67E4\u67E6\u67E7\u67E8\u67EA\u67EB\u67ED\u67EE\u67F2\u67F5",7,"\u67FE\u6801\u6802\u6803\u6804\u6806\u680D\u6810\u6812\u6814\u6815\u6818",4,"\u681E\u681F\u6820\u6822",6,"\u682B",6,"\u6834\u6835\u6836\u683A\u683B\u683F\u6847\u684B\u684D\u684F\u6852\u6856",5],["9740","\u685C\u685D\u685E\u685F\u686A\u686C",7,"\u6875\u6878",8,"\u6882\u6884\u6887",7,"\u6890\u6891\u6892\u6894\u6895\u6896\u6898",9,"\u68A3\u68A4\u68A5\u68A9\u68AA\u68AB\u68AC\u68AE\u68B1\u68B2\u68B4\u68B6\u68B7\u68B8"],["9780","\u68B9",6,"\u68C1\u68C3",5,"\u68CA\u68CC\u68CE\u68CF\u68D0\u68D1\u68D3\u68D4\u68D6\u68D7\u68D9\u68DB",4,"\u68E1\u68E2\u68E4",9,"\u68EF\u68F2\u68F3\u68F4\u68F6\u68F7\u68F8\u68FB\u68FD\u68FE\u68FF\u6900\u6902\u6903\u6904\u6906",4,"\u690C\u690F\u6911\u6913",11,"\u6921\u6922\u6923\u6925",7,"\u692E\u692F\u6931\u6932\u6933\u6935\u6936\u6937\u6938\u693A\u693B\u693C\u693E\u6940\u6941\u6943",16,"\u6955\u6956\u6958\u6959\u695B\u695C\u695F"],["9840","\u6961\u6962\u6964\u6965\u6967\u6968\u6969\u696A\u696C\u696D\u696F\u6970\u6972",4,"\u697A\u697B\u697D\u697E\u697F\u6981\u6983\u6985\u698A\u698B\u698C\u698E",5,"\u6996\u6997\u6999\u699A\u699D",9,"\u69A9\u69AA\u69AC\u69AE\u69AF\u69B0\u69B2\u69B3\u69B5\u69B6\u69B8\u69B9\u69BA\u69BC\u69BD"],["9880","\u69BE\u69BF\u69C0\u69C2",7,"\u69CB\u69CD\u69CF\u69D1\u69D2\u69D3\u69D5",5,"\u69DC\u69DD\u69DE\u69E1",11,"\u69EE\u69EF\u69F0\u69F1\u69F3",9,"\u69FE\u6A00",9,"\u6A0B",11,"\u6A19",5,"\u6A20\u6A22",5,"\u6A29\u6A2B\u6A2C\u6A2D\u6A2E\u6A30\u6A32\u6A33\u6A34\u6A36",6,"\u6A3F",4,"\u6A45\u6A46\u6A48",7,"\u6A51",6,"\u6A5A"],["9940","\u6A5C",4,"\u6A62\u6A63\u6A64\u6A66",10,"\u6A72",6,"\u6A7A\u6A7B\u6A7D\u6A7E\u6A7F\u6A81\u6A82\u6A83\u6A85",8,"\u6A8F\u6A92",4,"\u6A98",7,"\u6AA1",5],["9980","\u6AA7\u6AA8\u6AAA\u6AAD",114,"\u6B25\u6B26\u6B28",6],["9a40","\u6B2F\u6B30\u6B31\u6B33\u6B34\u6B35\u6B36\u6B38\u6B3B\u6B3C\u6B3D\u6B3F\u6B40\u6B41\u6B42\u6B44\u6B45\u6B48\u6B4A\u6B4B\u6B4D",11,"\u6B5A",7,"\u6B68\u6B69\u6B6B",13,"\u6B7A\u6B7D\u6B7E\u6B7F\u6B80\u6B85\u6B88"],["9a80","\u6B8C\u6B8E\u6B8F\u6B90\u6B91\u6B94\u6B95\u6B97\u6B98\u6B99\u6B9C",4,"\u6BA2",7,"\u6BAB",7,"\u6BB6\u6BB8",6,"\u6BC0\u6BC3\u6BC4\u6BC6",4,"\u6BCC\u6BCE\u6BD0\u6BD1\u6BD8\u6BDA\u6BDC",4,"\u6BE2",7,"\u6BEC\u6BED\u6BEE\u6BF0\u6BF1\u6BF2\u6BF4\u6BF6\u6BF7\u6BF8\u6BFA\u6BFB\u6BFC\u6BFE",6,"\u6C08",4,"\u6C0E\u6C12\u6C17\u6C1C\u6C1D\u6C1E\u6C20\u6C23\u6C25\u6C2B\u6C2C\u6C2D\u6C31\u6C33\u6C36\u6C37\u6C39\u6C3A\u6C3B\u6C3C\u6C3E\u6C3F\u6C43\u6C44\u6C45\u6C48\u6C4B",4,"\u6C51\u6C52\u6C53\u6C56\u6C58"],["9b40","\u6C59\u6C5A\u6C62\u6C63\u6C65\u6C66\u6C67\u6C6B",4,"\u6C71\u6C73\u6C75\u6C77\u6C78\u6C7A\u6C7B\u6C7C\u6C7F\u6C80\u6C84\u6C87\u6C8A\u6C8B\u6C8D\u6C8E\u6C91\u6C92\u6C95\u6C96\u6C97\u6C98\u6C9A\u6C9C\u6C9D\u6C9E\u6CA0\u6CA2\u6CA8\u6CAC\u6CAF\u6CB0\u6CB4\u6CB5\u6CB6\u6CB7\u6CBA\u6CC0\u6CC1\u6CC2\u6CC3\u6CC6\u6CC7\u6CC8\u6CCB\u6CCD\u6CCE\u6CCF\u6CD1\u6CD2\u6CD8"],["9b80","\u6CD9\u6CDA\u6CDC\u6CDD\u6CDF\u6CE4\u6CE6\u6CE7\u6CE9\u6CEC\u6CED\u6CF2\u6CF4\u6CF9\u6CFF\u6D00\u6D02\u6D03\u6D05\u6D06\u6D08\u6D09\u6D0A\u6D0D\u6D0F\u6D10\u6D11\u6D13\u6D14\u6D15\u6D16\u6D18\u6D1C\u6D1D\u6D1F",5,"\u6D26\u6D28\u6D29\u6D2C\u6D2D\u6D2F\u6D30\u6D34\u6D36\u6D37\u6D38\u6D3A\u6D3F\u6D40\u6D42\u6D44\u6D49\u6D4C\u6D50\u6D55\u6D56\u6D57\u6D58\u6D5B\u6D5D\u6D5F\u6D61\u6D62\u6D64\u6D65\u6D67\u6D68\u6D6B\u6D6C\u6D6D\u6D70\u6D71\u6D72\u6D73\u6D75\u6D76\u6D79\u6D7A\u6D7B\u6D7D",4,"\u6D83\u6D84\u6D86\u6D87\u6D8A\u6D8B\u6D8D\u6D8F\u6D90\u6D92\u6D96",4,"\u6D9C\u6DA2\u6DA5\u6DAC\u6DAD\u6DB0\u6DB1\u6DB3\u6DB4\u6DB6\u6DB7\u6DB9",5,"\u6DC1\u6DC2\u6DC3\u6DC8\u6DC9\u6DCA"],["9c40","\u6DCD\u6DCE\u6DCF\u6DD0\u6DD2\u6DD3\u6DD4\u6DD5\u6DD7\u6DDA\u6DDB\u6DDC\u6DDF\u6DE2\u6DE3\u6DE5\u6DE7\u6DE8\u6DE9\u6DEA\u6DED\u6DEF\u6DF0\u6DF2\u6DF4\u6DF5\u6DF6\u6DF8\u6DFA\u6DFD",7,"\u6E06\u6E07\u6E08\u6E09\u6E0B\u6E0F\u6E12\u6E13\u6E15\u6E18\u6E19\u6E1B\u6E1C\u6E1E\u6E1F\u6E22\u6E26\u6E27\u6E28\u6E2A\u6E2C\u6E2E\u6E30\u6E31\u6E33\u6E35"],["9c80","\u6E36\u6E37\u6E39\u6E3B",7,"\u6E45",7,"\u6E4F\u6E50\u6E51\u6E52\u6E55\u6E57\u6E59\u6E5A\u6E5C\u6E5D\u6E5E\u6E60",10,"\u6E6C\u6E6D\u6E6F",14,"\u6E80\u6E81\u6E82\u6E84\u6E87\u6E88\u6E8A",4,"\u6E91",6,"\u6E99\u6E9A\u6E9B\u6E9D\u6E9E\u6EA0\u6EA1\u6EA3\u6EA4\u6EA6\u6EA8\u6EA9\u6EAB\u6EAC\u6EAD\u6EAE\u6EB0\u6EB3\u6EB5\u6EB8\u6EB9\u6EBC\u6EBE\u6EBF\u6EC0\u6EC3\u6EC4\u6EC5\u6EC6\u6EC8\u6EC9\u6ECA\u6ECC\u6ECD\u6ECE\u6ED0\u6ED2\u6ED6\u6ED8\u6ED9\u6EDB\u6EDC\u6EDD\u6EE3\u6EE7\u6EEA",5],["9d40","\u6EF0\u6EF1\u6EF2\u6EF3\u6EF5\u6EF6\u6EF7\u6EF8\u6EFA",7,"\u6F03\u6F04\u6F05\u6F07\u6F08\u6F0A",4,"\u6F10\u6F11\u6F12\u6F16",9,"\u6F21\u6F22\u6F23\u6F25\u6F26\u6F27\u6F28\u6F2C\u6F2E\u6F30\u6F32\u6F34\u6F35\u6F37",6,"\u6F3F\u6F40\u6F41\u6F42"],["9d80","\u6F43\u6F44\u6F45\u6F48\u6F49\u6F4A\u6F4C\u6F4E",9,"\u6F59\u6F5A\u6F5B\u6F5D\u6F5F\u6F60\u6F61\u6F63\u6F64\u6F65\u6F67",5,"\u6F6F\u6F70\u6F71\u6F73\u6F75\u6F76\u6F77\u6F79\u6F7B\u6F7D",6,"\u6F85\u6F86\u6F87\u6F8A\u6F8B\u6F8F",12,"\u6F9D\u6F9E\u6F9F\u6FA0\u6FA2",4,"\u6FA8",10,"\u6FB4\u6FB5\u6FB7\u6FB8\u6FBA",5,"\u6FC1\u6FC3",5,"\u6FCA",6,"\u6FD3",10,"\u6FDF\u6FE2\u6FE3\u6FE4\u6FE5"],["9e40","\u6FE6",7,"\u6FF0",32,"\u7012",7,"\u701C",6,"\u7024",6],["9e80","\u702B",9,"\u7036\u7037\u7038\u703A",17,"\u704D\u704E\u7050",13,"\u705F",11,"\u706E\u7071\u7072\u7073\u7074\u7077\u7079\u707A\u707B\u707D\u7081\u7082\u7083\u7084\u7086\u7087\u7088\u708B\u708C\u708D\u708F\u7090\u7091\u7093\u7097\u7098\u709A\u709B\u709E",12,"\u70B0\u70B2\u70B4\u70B5\u70B6\u70BA\u70BE\u70BF\u70C4\u70C5\u70C6\u70C7\u70C9\u70CB",12,"\u70DA"],["9f40","\u70DC\u70DD\u70DE\u70E0\u70E1\u70E2\u70E3\u70E5\u70EA\u70EE\u70F0",6,"\u70F8\u70FA\u70FB\u70FC\u70FE",10,"\u710B",4,"\u7111\u7112\u7114\u7117\u711B",10,"\u7127",7,"\u7132\u7133\u7134"],["9f80","\u7135\u7137",13,"\u7146\u7147\u7148\u7149\u714B\u714D\u714F",12,"\u715D\u715F",4,"\u7165\u7169",4,"\u716F\u7170\u7171\u7174\u7175\u7176\u7177\u7179\u717B\u717C\u717E",5,"\u7185",4,"\u718B\u718C\u718D\u718E\u7190\u7191\u7192\u7193\u7195\u7196\u7197\u719A",4,"\u71A1",6,"\u71A9\u71AA\u71AB\u71AD",5,"\u71B4\u71B6\u71B7\u71B8\u71BA",8,"\u71C4",9,"\u71CF",4],["a040","\u71D6",9,"\u71E1\u71E2\u71E3\u71E4\u71E6\u71E8",5,"\u71EF",9,"\u71FA",11,"\u7207",19],["a080","\u721B\u721C\u721E",9,"\u7229\u722B\u722D\u722E\u722F\u7232\u7233\u7234\u723A\u723C\u723E\u7240",6,"\u7249\u724A\u724B\u724E\u724F\u7250\u7251\u7253\u7254\u7255\u7257\u7258\u725A\u725C\u725E\u7260\u7263\u7264\u7265\u7268\u726A\u726B\u726C\u726D\u7270\u7271\u7273\u7274\u7276\u7277\u7278\u727B\u727C\u727D\u7282\u7283\u7285",4,"\u728C\u728E\u7290\u7291\u7293",11,"\u72A0",11,"\u72AE\u72B1\u72B2\u72B3\u72B5\u72BA",6,"\u72C5\u72C6\u72C7\u72C9\u72CA\u72CB\u72CC\u72CF\u72D1\u72D3\u72D4\u72D5\u72D6\u72D8\u72DA\u72DB"],["a1a1","\u3000\u3001\u3002\xb7\u02C9\u02C7\xa8\u3003\u3005\u2014\uFF5E\u2016\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008",7,"\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013"],["a2a1","\u2170",9],["a2b1","\u2488",19,"\u2474",19,"\u2460",9],["a2e5","\u3220",9],["a2f1","\u2160",11],["a3a1","\uFF01\uFF02\uFF03\uFFE5\uFF05",88,"\uFFE3"],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a6e0","\uFE35\uFE36\uFE39\uFE3A\uFE3F\uFE40\uFE3D\uFE3E\uFE41\uFE42\uFE43\uFE44"],["a6ee","\uFE3B\uFE3C\uFE37\uFE38\uFE31"],["a6f4","\uFE33\uFE34"],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a840","\u02CA\u02CB\u02D9\u2013\u2015\u2025\u2035\u2105\u2109\u2196\u2197\u2198\u2199\u2215\u221F\u2223\u2252\u2266\u2267\u22BF\u2550",35,"\u2581",6],["a880","\u2588",7,"\u2593\u2594\u2595\u25BC\u25BD\u25E2\u25E3\u25E4\u25E5\u2609\u2295\u3012\u301D\u301E"],["a8a1","\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\u0251"],["a8bd","\u0144\u0148"],["a8c0","\u0261"],["a8c5","\u3105",36],["a940","\u3021",8,"\u32A3\u338E\u338F\u339C\u339D\u339E\u33A1\u33C4\u33CE\u33D1\u33D2\u33D5\uFE30\uFFE2\uFFE4"],["a959","\u2121\u3231"],["a95c","\u2010"],["a960","\u30FC\u309B\u309C\u30FD\u30FE\u3006\u309D\u309E\uFE49",9,"\uFE54\uFE55\uFE56\uFE57\uFE59",8],["a980","\uFE62",4,"\uFE68\uFE69\uFE6A\uFE6B"],["a996","\u3007"],["a9a4","\u2500",75],["aa40","\u72DC\u72DD\u72DF\u72E2",5,"\u72EA\u72EB\u72F5\u72F6\u72F9\u72FD\u72FE\u72FF\u7300\u7302\u7304",5,"\u730B\u730C\u730D\u730F\u7310\u7311\u7312\u7314\u7318\u7319\u731A\u731F\u7320\u7323\u7324\u7326\u7327\u7328\u732D\u732F\u7330\u7332\u7333\u7335\u7336\u733A\u733B\u733C\u733D\u7340",8],["aa80","\u7349\u734A\u734B\u734C\u734E\u734F\u7351\u7353\u7354\u7355\u7356\u7358",7,"\u7361",10,"\u736E\u7370\u7371"],["ab40","\u7372",11,"\u737F",4,"\u7385\u7386\u7388\u738A\u738C\u738D\u738F\u7390\u7392\u7393\u7394\u7395\u7397\u7398\u7399\u739A\u739C\u739D\u739E\u73A0\u73A1\u73A3",5,"\u73AA\u73AC\u73AD\u73B1\u73B4\u73B5\u73B6\u73B8\u73B9\u73BC\u73BD\u73BE\u73BF\u73C1\u73C3",4],["ab80","\u73CB\u73CC\u73CE\u73D2",6,"\u73DA\u73DB\u73DC\u73DD\u73DF\u73E1\u73E2\u73E3\u73E4\u73E6\u73E8\u73EA\u73EB\u73EC\u73EE\u73EF\u73F0\u73F1\u73F3",4],["ac40","\u73F8",10,"\u7404\u7407\u7408\u740B\u740C\u740D\u740E\u7411",8,"\u741C",5,"\u7423\u7424\u7427\u7429\u742B\u742D\u742F\u7431\u7432\u7437",4,"\u743D\u743E\u743F\u7440\u7442",11],["ac80","\u744E",6,"\u7456\u7458\u745D\u7460",12,"\u746E\u746F\u7471",4,"\u7478\u7479\u747A"],["ad40","\u747B\u747C\u747D\u747F\u7482\u7484\u7485\u7486\u7488\u7489\u748A\u748C\u748D\u748F\u7491",10,"\u749D\u749F",7,"\u74AA",15,"\u74BB",12],["ad80","\u74C8",9,"\u74D3",8,"\u74DD\u74DF\u74E1\u74E5\u74E7",6,"\u74F0\u74F1\u74F2"],["ae40","\u74F3\u74F5\u74F8",6,"\u7500\u7501\u7502\u7503\u7505",7,"\u750E\u7510\u7512\u7514\u7515\u7516\u7517\u751B\u751D\u751E\u7520",4,"\u7526\u7527\u752A\u752E\u7534\u7536\u7539\u753C\u753D\u753F\u7541\u7542\u7543\u7544\u7546\u7547\u7549\u754A\u754D\u7550\u7551\u7552\u7553\u7555\u7556\u7557\u7558"],["ae80","\u755D",7,"\u7567\u7568\u7569\u756B",6,"\u7573\u7575\u7576\u7577\u757A",4,"\u7580\u7581\u7582\u7584\u7585\u7587"],["af40","\u7588\u7589\u758A\u758C\u758D\u758E\u7590\u7593\u7595\u7598\u759B\u759C\u759E\u75A2\u75A6",4,"\u75AD\u75B6\u75B7\u75BA\u75BB\u75BF\u75C0\u75C1\u75C6\u75CB\u75CC\u75CE\u75CF\u75D0\u75D1\u75D3\u75D7\u75D9\u75DA\u75DC\u75DD\u75DF\u75E0\u75E1\u75E5\u75E9\u75EC\u75ED\u75EE\u75EF\u75F2\u75F3\u75F5\u75F6\u75F7\u75F8\u75FA\u75FB\u75FD\u75FE\u7602\u7604\u7606\u7607"],["af80","\u7608\u7609\u760B\u760D\u760E\u760F\u7611\u7612\u7613\u7614\u7616\u761A\u761C\u761D\u761E\u7621\u7623\u7627\u7628\u762C\u762E\u762F\u7631\u7632\u7636\u7637\u7639\u763A\u763B\u763D\u7641\u7642\u7644"],["b040","\u7645",6,"\u764E",5,"\u7655\u7657",4,"\u765D\u765F\u7660\u7661\u7662\u7664",6,"\u766C\u766D\u766E\u7670",7,"\u7679\u767A\u767C\u767F\u7680\u7681\u7683\u7685\u7689\u768A\u768C\u768D\u768F\u7690\u7692\u7694\u7695\u7697\u7698\u769A\u769B"],["b080","\u769C",7,"\u76A5",8,"\u76AF\u76B0\u76B3\u76B5",9,"\u76C0\u76C1\u76C3\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265"],["b140","\u76C4\u76C7\u76C9\u76CB\u76CC\u76D3\u76D5\u76D9\u76DA\u76DC\u76DD\u76DE\u76E0",4,"\u76E6",7,"\u76F0\u76F3\u76F5\u76F6\u76F7\u76FA\u76FB\u76FD\u76FF\u7700\u7702\u7703\u7705\u7706\u770A\u770C\u770E",10,"\u771B\u771C\u771D\u771E\u7721\u7723\u7724\u7725\u7727\u772A\u772B"],["b180","\u772C\u772E\u7730",4,"\u7739\u773B\u773D\u773E\u773F\u7742\u7744\u7745\u7746\u7748",7,"\u7752",7,"\u775C\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3"],["b240","\u775D\u775E\u775F\u7760\u7764\u7767\u7769\u776A\u776D",11,"\u777A\u777B\u777C\u7781\u7782\u7783\u7786",5,"\u778F\u7790\u7793",11,"\u77A1\u77A3\u77A4\u77A6\u77A8\u77AB\u77AD\u77AE\u77AF\u77B1\u77B2\u77B4\u77B6",4],["b280","\u77BC\u77BE\u77C0",12,"\u77CE",8,"\u77D8\u77D9\u77DA\u77DD",4,"\u77E4\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316"],["b340","\u77E6\u77E8\u77EA\u77EF\u77F0\u77F1\u77F2\u77F4\u77F5\u77F7\u77F9\u77FA\u77FB\u77FC\u7803",5,"\u780A\u780B\u780E\u780F\u7810\u7813\u7815\u7819\u781B\u781E\u7820\u7821\u7822\u7824\u7828\u782A\u782B\u782E\u782F\u7831\u7832\u7833\u7835\u7836\u783D\u783F\u7841\u7842\u7843\u7844\u7846\u7848\u7849\u784A\u784B\u784D\u784F\u7851\u7853\u7854\u7858\u7859\u785A"],["b380","\u785B\u785C\u785E",11,"\u786F",7,"\u7878\u7879\u787A\u787B\u787D",6,"\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A"],["b440","\u7884\u7885\u7886\u7888\u788A\u788B\u788F\u7890\u7892\u7894\u7895\u7896\u7899\u789D\u789E\u78A0\u78A2\u78A4\u78A6\u78A8",7,"\u78B5\u78B6\u78B7\u78B8\u78BA\u78BB\u78BC\u78BD\u78BF\u78C0\u78C2\u78C3\u78C4\u78C6\u78C7\u78C8\u78CC\u78CD\u78CE\u78CF\u78D1\u78D2\u78D3\u78D6\u78D7\u78D8\u78DA",9],["b480","\u78E4\u78E5\u78E6\u78E7\u78E9\u78EA\u78EB\u78ED",4,"\u78F3\u78F5\u78F6\u78F8\u78F9\u78FB",5,"\u7902\u7903\u7904\u7906",6,"\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E"],["b540","\u790D",5,"\u7914",9,"\u791F",4,"\u7925",14,"\u7935",4,"\u793D\u793F\u7942\u7943\u7944\u7945\u7947\u794A",8,"\u7954\u7955\u7958\u7959\u7961\u7963"],["b580","\u7964\u7966\u7969\u796A\u796B\u796C\u796E\u7970",6,"\u7979\u797B",4,"\u7982\u7983\u7986\u7987\u7988\u7989\u798B\u798C\u798D\u798E\u7990\u7991\u7992\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0"],["b640","\u7993",6,"\u799B",11,"\u79A8",10,"\u79B4",4,"\u79BC\u79BF\u79C2\u79C4\u79C5\u79C7\u79C8\u79CA\u79CC\u79CE\u79CF\u79D0\u79D3\u79D4\u79D6\u79D7\u79D9",5,"\u79E0\u79E1\u79E2\u79E5\u79E8\u79EA"],["b680","\u79EC\u79EE\u79F1",6,"\u79F9\u79FA\u79FC\u79FE\u79FF\u7A01\u7A04\u7A05\u7A07\u7A08\u7A09\u7A0A\u7A0C\u7A0F",4,"\u7A15\u7A16\u7A18\u7A19\u7A1B\u7A1C\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C"],["b740","\u7A1D\u7A1F\u7A21\u7A22\u7A24",14,"\u7A34\u7A35\u7A36\u7A38\u7A3A\u7A3E\u7A40",5,"\u7A47",9,"\u7A52",4,"\u7A58",16],["b780","\u7A69",6,"\u7A71\u7A72\u7A73\u7A75\u7A7B\u7A7C\u7A7D\u7A7E\u7A82\u7A85\u7A87\u7A89\u7A8A\u7A8B\u7A8C\u7A8E\u7A8F\u7A90\u7A93\u7A94\u7A99\u7A9A\u7A9B\u7A9E\u7AA1\u7AA2\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D"],["b840","\u7AA3\u7AA4\u7AA7\u7AA9\u7AAA\u7AAB\u7AAE",4,"\u7AB4",10,"\u7AC0",10,"\u7ACC",9,"\u7AD7\u7AD8\u7ADA\u7ADB\u7ADC\u7ADD\u7AE1\u7AE2\u7AE4\u7AE7",5,"\u7AEE\u7AF0\u7AF1\u7AF2\u7AF3"],["b880","\u7AF4",4,"\u7AFB\u7AFC\u7AFE\u7B00\u7B01\u7B02\u7B05\u7B07\u7B09\u7B0C\u7B0D\u7B0E\u7B10\u7B12\u7B13\u7B16\u7B17\u7B18\u7B1A\u7B1C\u7B1D\u7B1F\u7B21\u7B22\u7B23\u7B27\u7B29\u7B2D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9"],["b940","\u7B2F\u7B30\u7B32\u7B34\u7B35\u7B36\u7B37\u7B39\u7B3B\u7B3D\u7B3F",5,"\u7B46\u7B48\u7B4A\u7B4D\u7B4E\u7B53\u7B55\u7B57\u7B59\u7B5C\u7B5E\u7B5F\u7B61\u7B63",10,"\u7B6F\u7B70\u7B73\u7B74\u7B76\u7B78\u7B7A\u7B7C\u7B7D\u7B7F\u7B81\u7B82\u7B83\u7B84\u7B86",6,"\u7B8E\u7B8F"],["b980","\u7B91\u7B92\u7B93\u7B96\u7B98\u7B99\u7B9A\u7B9B\u7B9E\u7B9F\u7BA0\u7BA3\u7BA4\u7BA5\u7BAE\u7BAF\u7BB0\u7BB2\u7BB3\u7BB5\u7BB6\u7BB7\u7BB9",7,"\u7BC2\u7BC3\u7BC4\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8"],["ba40","\u7BC5\u7BC8\u7BC9\u7BCA\u7BCB\u7BCD\u7BCE\u7BCF\u7BD0\u7BD2\u7BD4",4,"\u7BDB\u7BDC\u7BDE\u7BDF\u7BE0\u7BE2\u7BE3\u7BE4\u7BE7\u7BE8\u7BE9\u7BEB\u7BEC\u7BED\u7BEF\u7BF0\u7BF2",4,"\u7BF8\u7BF9\u7BFA\u7BFB\u7BFD\u7BFF",7,"\u7C08\u7C09\u7C0A\u7C0D\u7C0E\u7C10",5,"\u7C17\u7C18\u7C19"],["ba80","\u7C1A",4,"\u7C20",5,"\u7C28\u7C29\u7C2B",12,"\u7C39",5,"\u7C42\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56"],["bb40","\u7C43",9,"\u7C4E",36,"\u7C75",5,"\u7C7E",9],["bb80","\u7C88\u7C8A",6,"\u7C93\u7C94\u7C96\u7C99\u7C9A\u7C9B\u7CA0\u7CA1\u7CA3\u7CA6\u7CA7\u7CA8\u7CA9\u7CAB\u7CAC\u7CAD\u7CAF\u7CB0\u7CB4",4,"\u7CBA\u7CBB\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95"],["bc40","\u7CBF\u7CC0\u7CC2\u7CC3\u7CC4\u7CC6\u7CC9\u7CCB\u7CCE",6,"\u7CD8\u7CDA\u7CDB\u7CDD\u7CDE\u7CE1",6,"\u7CE9",5,"\u7CF0",7,"\u7CF9\u7CFA\u7CFC",13,"\u7D0B",5],["bc80","\u7D11",14,"\u7D21\u7D23\u7D24\u7D25\u7D26\u7D28\u7D29\u7D2A\u7D2C\u7D2D\u7D2E\u7D30",6,"\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6"],["bd40","\u7D37",54,"\u7D6F",7],["bd80","\u7D78",32,"\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78"],["be40","\u7D99",12,"\u7DA7",6,"\u7DAF",42],["be80","\u7DDA",32,"\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB"],["bf40","\u7DFB",62],["bf80","\u7E3A\u7E3C",4,"\u7E42",4,"\u7E48",21,"\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080"],["c040","\u7E5E",35,"\u7E83",23,"\u7E9C\u7E9D\u7E9E"],["c080","\u7EAE\u7EB4\u7EBB\u7EBC\u7ED6\u7EE4\u7EEC\u7EF9\u7F0A\u7F10\u7F1E\u7F37\u7F39\u7F3B",6,"\u7F43\u7F46",9,"\u7F52\u7F53\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0"],["c140","\u7F56\u7F59\u7F5B\u7F5C\u7F5D\u7F5E\u7F60\u7F63",4,"\u7F6B\u7F6C\u7F6D\u7F6F\u7F70\u7F73\u7F75\u7F76\u7F77\u7F78\u7F7A\u7F7B\u7F7C\u7F7D\u7F7F\u7F80\u7F82",7,"\u7F8B\u7F8D\u7F8F",4,"\u7F95",4,"\u7F9B\u7F9C\u7FA0\u7FA2\u7FA3\u7FA5\u7FA6\u7FA8",6,"\u7FB1"],["c180","\u7FB3",4,"\u7FBA\u7FBB\u7FBE\u7FC0\u7FC2\u7FC3\u7FC4\u7FC6\u7FC7\u7FC8\u7FC9\u7FCB\u7FCD\u7FCF",4,"\u7FD6\u7FD7\u7FD9",5,"\u7FE2\u7FE3\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF"],["c240","\u7FE4\u7FE7\u7FE8\u7FEA\u7FEB\u7FEC\u7FED\u7FEF\u7FF2\u7FF4",6,"\u7FFD\u7FFE\u7FFF\u8002\u8007\u8008\u8009\u800A\u800E\u800F\u8011\u8013\u801A\u801B\u801D\u801E\u801F\u8021\u8023\u8024\u802B",5,"\u8032\u8034\u8039\u803A\u803C\u803E\u8040\u8041\u8044\u8045\u8047\u8048\u8049\u804E\u804F\u8050\u8051\u8053\u8055\u8056\u8057"],["c280","\u8059\u805B",13,"\u806B",5,"\u8072",11,"\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B"],["c340","\u807E\u8081\u8082\u8085\u8088\u808A\u808D",5,"\u8094\u8095\u8097\u8099\u809E\u80A3\u80A6\u80A7\u80A8\u80AC\u80B0\u80B3\u80B5\u80B6\u80B8\u80B9\u80BB\u80C5\u80C7",4,"\u80CF",6,"\u80D8\u80DF\u80E0\u80E2\u80E3\u80E6\u80EE\u80F5\u80F7\u80F9\u80FB\u80FE\u80FF\u8100\u8101\u8103\u8104\u8105\u8107\u8108\u810B"],["c380","\u810C\u8115\u8117\u8119\u811B\u811C\u811D\u811F",12,"\u812D\u812E\u8130\u8133\u8134\u8135\u8137\u8139",4,"\u813F\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478"],["c440","\u8140",5,"\u8147\u8149\u814D\u814E\u814F\u8152\u8156\u8157\u8158\u815B",4,"\u8161\u8162\u8163\u8164\u8166\u8168\u816A\u816B\u816C\u816F\u8172\u8173\u8175\u8176\u8177\u8178\u8181\u8183",4,"\u8189\u818B\u818C\u818D\u818E\u8190\u8192",5,"\u8199\u819A\u819E",4,"\u81A4\u81A5"],["c480","\u81A7\u81A9\u81AB",7,"\u81B4",5,"\u81BC\u81BD\u81BE\u81BF\u81C4\u81C5\u81C7\u81C8\u81C9\u81CB\u81CD",6,"\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81"],["c540","\u81D4",14,"\u81E4\u81E5\u81E6\u81E8\u81E9\u81EB\u81EE",4,"\u81F5",5,"\u81FD\u81FF\u8203\u8207",4,"\u820E\u820F\u8211\u8213\u8215",5,"\u821D\u8220\u8224\u8225\u8226\u8227\u8229\u822E\u8232\u823A\u823C\u823D\u823F"],["c580","\u8240\u8241\u8242\u8243\u8245\u8246\u8248\u824A\u824C\u824D\u824E\u8250",7,"\u8259\u825B\u825C\u825D\u825E\u8260",7,"\u8269\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7"],["c640","\u826A\u826B\u826C\u826D\u8271\u8275\u8276\u8277\u8278\u827B\u827C\u8280\u8281\u8283\u8285\u8286\u8287\u8289\u828C\u8290\u8293\u8294\u8295\u8296\u829A\u829B\u829E\u82A0\u82A2\u82A3\u82A7\u82B2\u82B5\u82B6\u82BA\u82BB\u82BC\u82BF\u82C0\u82C2\u82C3\u82C5\u82C6\u82C9\u82D0\u82D6\u82D9\u82DA\u82DD\u82E2\u82E7\u82E8\u82E9\u82EA\u82EC\u82ED\u82EE\u82F0\u82F2\u82F3\u82F5\u82F6\u82F8"],["c680","\u82FA\u82FC",4,"\u830A\u830B\u830D\u8310\u8312\u8313\u8316\u8318\u8319\u831D",9,"\u8329\u832A\u832E\u8330\u8332\u8337\u833B\u833D\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390"],["c740","\u833E\u833F\u8341\u8342\u8344\u8345\u8348\u834A",4,"\u8353\u8355",4,"\u835D\u8362\u8370",6,"\u8379\u837A\u837E",6,"\u8387\u8388\u838A\u838B\u838C\u838D\u838F\u8390\u8391\u8394\u8395\u8396\u8397\u8399\u839A\u839D\u839F\u83A1",6,"\u83AC\u83AD\u83AE"],["c780","\u83AF\u83B5\u83BB\u83BE\u83BF\u83C2\u83C3\u83C4\u83C6\u83C8\u83C9\u83CB\u83CD\u83CE\u83D0\u83D1\u83D2\u83D3\u83D5\u83D7\u83D9\u83DA\u83DB\u83DE\u83E2\u83E3\u83E4\u83E6\u83E7\u83E8\u83EB\u83EC\u83ED\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20"],["c840","\u83EE\u83EF\u83F3",4,"\u83FA\u83FB\u83FC\u83FE\u83FF\u8400\u8402\u8405\u8407\u8408\u8409\u840A\u8410\u8412",5,"\u8419\u841A\u841B\u841E",5,"\u8429",7,"\u8432",5,"\u8439\u843A\u843B\u843E",7,"\u8447\u8448\u8449"],["c880","\u844A",6,"\u8452",4,"\u8458\u845D\u845E\u845F\u8460\u8462\u8464",4,"\u846A\u846E\u846F\u8470\u8472\u8474\u8477\u8479\u847B\u847C\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1"],["c940","\u847D",4,"\u8483\u8484\u8485\u8486\u848A\u848D\u848F",7,"\u8498\u849A\u849B\u849D\u849E\u849F\u84A0\u84A2",12,"\u84B0\u84B1\u84B3\u84B5\u84B6\u84B7\u84BB\u84BC\u84BE\u84C0\u84C2\u84C3\u84C5\u84C6\u84C7\u84C8\u84CB\u84CC\u84CE\u84CF\u84D2\u84D4\u84D5\u84D7"],["c980","\u84D8",4,"\u84DE\u84E1\u84E2\u84E4\u84E7",4,"\u84ED\u84EE\u84EF\u84F1",10,"\u84FD\u84FE\u8500\u8501\u8502\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3"],["ca40","\u8503",8,"\u850D\u850E\u850F\u8510\u8512\u8514\u8515\u8516\u8518\u8519\u851B\u851C\u851D\u851E\u8520\u8522",8,"\u852D",9,"\u853E",4,"\u8544\u8545\u8546\u8547\u854B",10],["ca80","\u8557\u8558\u855A\u855B\u855C\u855D\u855F",4,"\u8565\u8566\u8567\u8569",8,"\u8573\u8575\u8576\u8577\u8578\u857C\u857D\u857F\u8580\u8581\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31"],["cb40","\u8582\u8583\u8586\u8588",6,"\u8590",10,"\u859D",6,"\u85A5\u85A6\u85A7\u85A9\u85AB\u85AC\u85AD\u85B1",5,"\u85B8\u85BA",6,"\u85C2",6,"\u85CA",4,"\u85D1\u85D2"],["cb80","\u85D4\u85D6",5,"\u85DD",6,"\u85E5\u85E6\u85E7\u85E8\u85EA",14,"\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854"],["cc40","\u85F9\u85FA\u85FC\u85FD\u85FE\u8600",4,"\u8606",10,"\u8612\u8613\u8614\u8615\u8617",15,"\u8628\u862A",13,"\u8639\u863A\u863B\u863D\u863E\u863F\u8640"],["cc80","\u8641",11,"\u8652\u8653\u8655",4,"\u865B\u865C\u865D\u865F\u8660\u8661\u8663",7,"\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3"],["cd40","\u866D\u866F\u8670\u8672",6,"\u8683",6,"\u868E",4,"\u8694\u8696",5,"\u869E",4,"\u86A5\u86A6\u86AB\u86AD\u86AE\u86B2\u86B3\u86B7\u86B8\u86B9\u86BB",4,"\u86C1\u86C2\u86C3\u86C5\u86C8\u86CC\u86CD\u86D2\u86D3\u86D5\u86D6\u86D7\u86DA\u86DC"],["cd80","\u86DD\u86E0\u86E1\u86E2\u86E3\u86E5\u86E6\u86E7\u86E8\u86EA\u86EB\u86EC\u86EF\u86F5\u86F6\u86F7\u86FA\u86FB\u86FC\u86FD\u86FF\u8701\u8704\u8705\u8706\u870B\u870C\u870E\u870F\u8710\u8711\u8714\u8716\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01"],["ce40","\u8719\u871B\u871D\u871F\u8720\u8724\u8726\u8727\u8728\u872A\u872B\u872C\u872D\u872F\u8730\u8732\u8733\u8735\u8736\u8738\u8739\u873A\u873C\u873D\u8740",6,"\u874A\u874B\u874D\u874F\u8750\u8751\u8752\u8754\u8755\u8756\u8758\u875A",5,"\u8761\u8762\u8766",7,"\u876F\u8771\u8772\u8773\u8775"],["ce80","\u8777\u8778\u8779\u877A\u877F\u8780\u8781\u8784\u8786\u8787\u8789\u878A\u878C\u878E",4,"\u8794\u8795\u8796\u8798",6,"\u87A0",4,"\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A"],["cf40","\u87A5\u87A6\u87A7\u87A9\u87AA\u87AE\u87B0\u87B1\u87B2\u87B4\u87B6\u87B7\u87B8\u87B9\u87BB\u87BC\u87BE\u87BF\u87C1",4,"\u87C7\u87C8\u87C9\u87CC",4,"\u87D4",6,"\u87DC\u87DD\u87DE\u87DF\u87E1\u87E2\u87E3\u87E4\u87E6\u87E7\u87E8\u87E9\u87EB\u87EC\u87ED\u87EF",9],["cf80","\u87FA\u87FB\u87FC\u87FD\u87FF\u8800\u8801\u8802\u8804",5,"\u880B",7,"\u8814\u8817\u8818\u8819\u881A\u881C",4,"\u8823\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653"],["d040","\u8824",13,"\u8833",5,"\u883A\u883B\u883D\u883E\u883F\u8841\u8842\u8843\u8846",5,"\u884E",5,"\u8855\u8856\u8858\u885A",6,"\u8866\u8867\u886A\u886D\u886F\u8871\u8873\u8874\u8875\u8876\u8878\u8879\u887A"],["d080","\u887B\u887C\u8880\u8883\u8886\u8887\u8889\u888A\u888C\u888E\u888F\u8890\u8891\u8893\u8894\u8895\u8897",4,"\u889D",4,"\u88A3\u88A5",5,"\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384"],["d140","\u88AC\u88AE\u88AF\u88B0\u88B2",4,"\u88B8\u88B9\u88BA\u88BB\u88BD\u88BE\u88BF\u88C0\u88C3\u88C4\u88C7\u88C8\u88CA\u88CB\u88CC\u88CD\u88CF\u88D0\u88D1\u88D3\u88D6\u88D7\u88DA",4,"\u88E0\u88E1\u88E6\u88E7\u88E9",6,"\u88F2\u88F5\u88F6\u88F7\u88FA\u88FB\u88FD\u88FF\u8900\u8901\u8903",5],["d180","\u8909\u890B",4,"\u8911\u8914",4,"\u891C",4,"\u8922\u8923\u8924\u8926\u8927\u8928\u8929\u892C\u892D\u892E\u892F\u8931\u8932\u8933\u8935\u8937\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476"],["d240","\u8938",8,"\u8942\u8943\u8945",24,"\u8960",5,"\u8967",19,"\u897C"],["d280","\u897D\u897E\u8980\u8982\u8984\u8985\u8987",26,"\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690"],["d340","\u89A2",30,"\u89C3\u89CD\u89D3\u89D4\u89D5\u89D7\u89D8\u89D9\u89DB\u89DD\u89DF\u89E0\u89E1\u89E2\u89E4\u89E7\u89E8\u89E9\u89EA\u89EC\u89ED\u89EE\u89F0\u89F1\u89F2\u89F4",6],["d380","\u89FB",4,"\u8A01",5,"\u8A08",21,"\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89"],["d440","\u8A1E",31,"\u8A3F",8,"\u8A49",21],["d480","\u8A5F",25,"\u8A7A",6,"\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67"],["d540","\u8A81",7,"\u8A8B",7,"\u8A94",46],["d580","\u8AC3",32,"\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F"],["d640","\u8AE4",34,"\u8B08",27],["d680","\u8B24\u8B25\u8B27",30,"\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51"],["d740","\u8B46",31,"\u8B67",4,"\u8B6D",25],["d780","\u8B87",24,"\u8BAC\u8BB1\u8BBB\u8BC7\u8BD0\u8BEA\u8C09\u8C1E\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7"],["d840","\u8C38",8,"\u8C42\u8C43\u8C44\u8C45\u8C48\u8C4A\u8C4B\u8C4D",7,"\u8C56\u8C57\u8C58\u8C59\u8C5B",5,"\u8C63",6,"\u8C6C",6,"\u8C74\u8C75\u8C76\u8C77\u8C7B",6,"\u8C83\u8C84\u8C86\u8C87"],["d880","\u8C88\u8C8B\u8C8D",6,"\u8C95\u8C96\u8C97\u8C99",20,"\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D"],["d940","\u8CAE",62],["d980","\u8CED",32,"\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC"],["da40","\u8D0E",14,"\u8D20\u8D51\u8D52\u8D57\u8D5F\u8D65\u8D68\u8D69\u8D6A\u8D6C\u8D6E\u8D6F\u8D71\u8D72\u8D78",8,"\u8D82\u8D83\u8D86\u8D87\u8D88\u8D89\u8D8C",4,"\u8D92\u8D93\u8D95",9,"\u8DA0\u8DA1"],["da80","\u8DA2\u8DA4",12,"\u8DB2\u8DB6\u8DB7\u8DB9\u8DBB\u8DBD\u8DC0\u8DC1\u8DC2\u8DC5\u8DC7\u8DC8\u8DC9\u8DCA\u8DCD\u8DD0\u8DD2\u8DD3\u8DD4\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA"],["db40","\u8DD5\u8DD8\u8DD9\u8DDC\u8DE0\u8DE1\u8DE2\u8DE5\u8DE6\u8DE7\u8DE9\u8DED\u8DEE\u8DF0\u8DF1\u8DF2\u8DF4\u8DF6\u8DFC\u8DFE",6,"\u8E06\u8E07\u8E08\u8E0B\u8E0D\u8E0E\u8E10\u8E11\u8E12\u8E13\u8E15",7,"\u8E20\u8E21\u8E24",4,"\u8E2B\u8E2D\u8E30\u8E32\u8E33\u8E34\u8E36\u8E37\u8E38\u8E3B\u8E3C\u8E3E"],["db80","\u8E3F\u8E43\u8E45\u8E46\u8E4C",4,"\u8E53",5,"\u8E5A",11,"\u8E67\u8E68\u8E6A\u8E6B\u8E6E\u8E71\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD"],["dc40","\u8E73\u8E75\u8E77",4,"\u8E7D\u8E7E\u8E80\u8E82\u8E83\u8E84\u8E86\u8E88",6,"\u8E91\u8E92\u8E93\u8E95",6,"\u8E9D\u8E9F",11,"\u8EAD\u8EAE\u8EB0\u8EB1\u8EB3",6,"\u8EBB",7],["dc80","\u8EC3",10,"\u8ECF",21,"\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365"],["dd40","\u8EE5",62],["dd80","\u8F24",32,"\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A"],["de40","\u8F45",32,"\u8F6A\u8F80\u8F8C\u8F92\u8F9D\u8FA0\u8FA1\u8FA2\u8FA4\u8FA5\u8FA6\u8FA7\u8FAA\u8FAC\u8FAD\u8FAE\u8FAF\u8FB2\u8FB3\u8FB4\u8FB5\u8FB7\u8FB8\u8FBA\u8FBB\u8FBC\u8FBF\u8FC0\u8FC3\u8FC6"],["de80","\u8FC9",4,"\u8FCF\u8FD2\u8FD6\u8FD7\u8FDA\u8FE0\u8FE1\u8FE3\u8FE7\u8FEC\u8FEF\u8FF1\u8FF2\u8FF4\u8FF5\u8FF6\u8FFA\u8FFB\u8FFC\u8FFE\u8FFF\u9007\u9008\u900C\u900E\u9013\u9015\u9018\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496"],["df40","\u9019\u901C\u9023\u9024\u9025\u9027",5,"\u9030",4,"\u9037\u9039\u903A\u903D\u903F\u9040\u9043\u9045\u9046\u9048",4,"\u904E\u9054\u9055\u9056\u9059\u905A\u905C",5,"\u9064\u9066\u9067\u9069\u906A\u906B\u906C\u906F",4,"\u9076",6,"\u907E\u9081"],["df80","\u9084\u9085\u9086\u9087\u9089\u908A\u908C",4,"\u9092\u9094\u9096\u9098\u909A\u909C\u909E\u909F\u90A0\u90A4\u90A5\u90A7\u90A8\u90A9\u90AB\u90AD\u90B2\u90B7\u90BC\u90BD\u90BF\u90C0\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C"],["e040","\u90C2\u90C3\u90C6\u90C8\u90C9\u90CB\u90CC\u90CD\u90D2\u90D4\u90D5\u90D6\u90D8\u90D9\u90DA\u90DE\u90DF\u90E0\u90E3\u90E4\u90E5\u90E9\u90EA\u90EC\u90EE\u90F0\u90F1\u90F2\u90F3\u90F5\u90F6\u90F7\u90F9\u90FA\u90FB\u90FC\u90FF\u9100\u9101\u9103\u9105",19,"\u911A\u911B\u911C"],["e080","\u911D\u911F\u9120\u9121\u9124",10,"\u9130\u9132",6,"\u913A",8,"\u9144\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C"],["e140","\u9145\u9147\u9148\u9151\u9153\u9154\u9155\u9156\u9158\u9159\u915B\u915C\u915F\u9160\u9166\u9167\u9168\u916B\u916D\u9173\u917A\u917B\u917C\u9180",4,"\u9186\u9188\u918A\u918E\u918F\u9193",6,"\u919C",5,"\u91A4",5,"\u91AB\u91AC\u91B0\u91B1\u91B2\u91B3\u91B6\u91B7\u91B8\u91B9\u91BB"],["e180","\u91BC",10,"\u91C8\u91CB\u91D0\u91D2",9,"\u91DD",8,"\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA"],["e240","\u91E6",62],["e280","\u9225",32,"\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967",5,"\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042"],["e340","\u9246",45,"\u9275",16],["e380","\u9286",7,"\u928F",24,"\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE"],["e440","\u92A8",5,"\u92AF",24,"\u92C9",31],["e480","\u92E9",32,"\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1"],["e540","\u930A",51,"\u933F",10],["e580","\u934A",31,"\u936B\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3"],["e640","\u936C",34,"\u9390",27],["e680","\u93AC",29,"\u93CB\u93CC\u93CD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9"],["e740","\u93CE",7,"\u93D7",54],["e780","\u940E",32,"\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21",6,"\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F",4,"\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C"],["e840","\u942F",14,"\u943F",43,"\u946C\u946D\u946E\u946F"],["e880","\u9470",20,"\u9491\u9496\u9498\u94C7\u94CF\u94D3\u94D4\u94DA\u94E6\u94FB\u951C\u9520\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9"],["e940","\u9527\u9533\u953D\u9543\u9548\u954B\u9555\u955A\u9560\u956E\u9574\u9575\u9577",7,"\u9580",42],["e980","\u95AB",32,"\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B"],["ea40","\u95CC",27,"\u95EC\u95FF\u9607\u9613\u9618\u961B\u961E\u9620\u9623",6,"\u962B\u962C\u962D\u962F\u9630\u9637\u9638\u9639\u963A\u963E\u9641\u9643\u964A\u964E\u964F\u9651\u9652\u9653\u9656\u9657"],["ea80","\u9658\u9659\u965A\u965C\u965D\u965E\u9660\u9663\u9665\u9666\u966B\u966D",4,"\u9673\u9678",12,"\u9687\u9689\u968A\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0"],["eb40","\u968C\u968E\u9691\u9692\u9693\u9695\u9696\u969A\u969B\u969D",9,"\u96A8",7,"\u96B1\u96B2\u96B4\u96B5\u96B7\u96B8\u96BA\u96BB\u96BF\u96C2\u96C3\u96C8\u96CA\u96CB\u96D0\u96D1\u96D3\u96D4\u96D6",9,"\u96E1",6,"\u96EB"],["eb80","\u96EC\u96ED\u96EE\u96F0\u96F1\u96F2\u96F4\u96F5\u96F8\u96FA\u96FB\u96FC\u96FD\u96FF\u9702\u9703\u9705\u970A\u970B\u970C\u9710\u9711\u9712\u9714\u9715\u9717",4,"\u971D\u971F\u9720\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB"],["ec40","\u9721",8,"\u972B\u972C\u972E\u972F\u9731\u9733",4,"\u973A\u973B\u973C\u973D\u973F",18,"\u9754\u9755\u9757\u9758\u975A\u975C\u975D\u975F\u9763\u9764\u9766\u9767\u9768\u976A",7],["ec80","\u9772\u9775\u9777",4,"\u977D",7,"\u9786",4,"\u978C\u978E\u978F\u9790\u9793\u9795\u9796\u9797\u9799",4,"\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0"],["ed40","\u979E\u979F\u97A1\u97A2\u97A4",6,"\u97AC\u97AE\u97B0\u97B1\u97B3\u97B5",46],["ed80","\u97E4\u97E5\u97E8\u97EE",4,"\u97F4\u97F7",23,"\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768"],["ee40","\u980F",62],["ee80","\u984E",32,"\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6",4,"\u94BC\u94BD\u94BF\u94C4\u94C8",6,"\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA"],["ef40","\u986F",5,"\u988B\u988E\u9892\u9895\u9899\u98A3\u98A8",37,"\u98CF\u98D0\u98D4\u98D6\u98D7\u98DB\u98DC\u98DD\u98E0",4],["ef80","\u98E5\u98E6\u98E9",30,"\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512",4,"\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564",8,"\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14"],["f040","\u9908",4,"\u990E\u990F\u9911",28,"\u992F",26],["f080","\u994A",9,"\u9956",12,"\u9964\u9966\u9973\u9978\u9979\u997B\u997E\u9982\u9983\u9989\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28",4,"\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66",6,"\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619"],["f140","\u998C\u998E\u999A",10,"\u99A6\u99A7\u99A9",47],["f180","\u99D9",32,"\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883"],["f240","\u99FA",62],["f280","\u9A39",32,"\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2"],["f340","\u9A5A",17,"\u9A72\u9A83\u9A89\u9A8D\u9A8E\u9A94\u9A95\u9A99\u9AA6\u9AA9",6,"\u9AB2\u9AB3\u9AB4\u9AB5\u9AB9\u9ABB\u9ABD\u9ABE\u9ABF\u9AC3\u9AC4\u9AC6",4,"\u9ACD\u9ACE\u9ACF\u9AD0\u9AD2\u9AD4\u9AD5\u9AD6\u9AD7\u9AD9\u9ADA\u9ADB\u9ADC"],["f380","\u9ADD\u9ADE\u9AE0\u9AE2\u9AE3\u9AE4\u9AE5\u9AE7\u9AE8\u9AE9\u9AEA\u9AEC\u9AEE\u9AF0",8,"\u9AFA\u9AFC",6,"\u9B04\u9B05\u9B06\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B"],["f440","\u9B07\u9B09",5,"\u9B10\u9B11\u9B12\u9B14",10,"\u9B20\u9B21\u9B22\u9B24",10,"\u9B30\u9B31\u9B33",7,"\u9B3D\u9B3E\u9B3F\u9B40\u9B46\u9B4A\u9B4B\u9B4C\u9B4E\u9B50\u9B52\u9B53\u9B55",5],["f480","\u9B5B",32,"\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164"],["f540","\u9B7C",62],["f580","\u9BBB",32,"\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC"],["f640","\u9BDC",62],["f680","\u9C1B",32,"\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85",5,"\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E",5,"\u9CA5",4,"\u9CAB\u9CAD\u9CAE\u9CB0",7,"\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB"],["f740","\u9C3C",62],["f780","\u9C7B\u9C7D\u9C7E\u9C80\u9C83\u9C84\u9C89\u9C8A\u9C8C\u9C8F\u9C93\u9C96\u9C97\u9C98\u9C99\u9C9D\u9CAA\u9CAC\u9CAF\u9CB9\u9CBE",4,"\u9CC8\u9CC9\u9CD1\u9CD2\u9CDA\u9CDB\u9CE0\u9CE1\u9CCC",4,"\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44"],["f840","\u9CE3",62],["f880","\u9D22",32],["f940","\u9D43",62],["f980","\u9D82",32],["fa40","\u9DA3",62],["fa80","\u9DE2",32],["fb40","\u9E03",27,"\u9E24\u9E27\u9E2E\u9E30\u9E34\u9E3B\u9E3C\u9E40\u9E4D\u9E50\u9E52\u9E53\u9E54\u9E56\u9E59\u9E5D\u9E5F\u9E60\u9E61\u9E62\u9E65\u9E6E\u9E6F\u9E72\u9E74",9,"\u9E80"],["fb80","\u9E81\u9E83\u9E84\u9E85\u9E86\u9E89\u9E8A\u9E8C",5,"\u9E94",8,"\u9E9E\u9EA0",5,"\u9EA7\u9EA8\u9EA9\u9EAA"],["fc40","\u9EAB",8,"\u9EB5\u9EB6\u9EB7\u9EB9\u9EBA\u9EBC\u9EBF",4,"\u9EC5\u9EC6\u9EC7\u9EC8\u9ECA\u9ECB\u9ECC\u9ED0\u9ED2\u9ED3\u9ED5\u9ED6\u9ED7\u9ED9\u9EDA\u9EDE\u9EE1\u9EE3\u9EE4\u9EE6\u9EE8\u9EEB\u9EEC\u9EED\u9EEE\u9EF0",8,"\u9EFA\u9EFD\u9EFF",6],["fc80","\u9F06",4,"\u9F0C\u9F0F\u9F11\u9F12\u9F14\u9F15\u9F16\u9F18\u9F1A",5,"\u9F21\u9F23",8,"\u9F2D\u9F2E\u9F30\u9F31"],["fd40","\u9F32",4,"\u9F38\u9F3A\u9F3C\u9F3F",4,"\u9F45",10,"\u9F52",38],["fd80","\u9F79",5,"\u9F81\u9F82\u9F8D",11,"\u9F9C\u9F9D\u9F9E\u9FA1",4,"\uF92C\uF979\uF995\uF9E7\uF9F1"],["fe40","\uFA0C\uFA0D\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA18\uFA1F\uFA20\uFA21\uFA23\uFA24\uFA27\uFA28\uFA29"]]');

},{}],"lCpwI":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["a140","\uE4C6",62],["a180","\uE505",32],["a240","\uE526",62],["a280","\uE565",32],["a2ab","\uE766",5],["a2e3","\u20AC\uE76D"],["a2ef","\uE76E\uE76F"],["a2fd","\uE770\uE771"],["a340","\uE586",62],["a380","\uE5C5",31,"\u3000"],["a440","\uE5E6",62],["a480","\uE625",32],["a4f4","\uE772",10],["a540","\uE646",62],["a580","\uE685",32],["a5f7","\uE77D",7],["a640","\uE6A6",62],["a680","\uE6E5",32],["a6b9","\uE785",7],["a6d9","\uE78D",6],["a6ec","\uE794\uE795"],["a6f3","\uE796"],["a6f6","\uE797",8],["a740","\uE706",62],["a780","\uE745",32],["a7c2","\uE7A0",14],["a7f2","\uE7AF",12],["a896","\uE7BC",10],["a8bc","\u1E3F"],["a8bf","\u01F9"],["a8c1","\uE7C9\uE7CA\uE7CB\uE7CC"],["a8ea","\uE7CD",20],["a958","\uE7E2"],["a95b","\uE7E3"],["a95d","\uE7E4\uE7E5\uE7E6"],["a989","\u303E\u2FF0",11],["a997","\uE7F4",12],["a9f0","\uE801",14],["aaa1","\uE000",93],["aba1","\uE05E",93],["aca1","\uE0BC",93],["ada1","\uE11A",93],["aea1","\uE178",93],["afa1","\uE1D6",93],["d7fa","\uE810",4],["f8a1","\uE234",93],["f9a1","\uE292",93],["faa1","\uE2F0",93],["fba1","\uE34E",93],["fca1","\uE3AC",93],["fda1","\uE40A",93],["fe50","\u2E81\uE816\uE817\uE818\u2E84\u3473\u3447\u2E88\u2E8B\uE81E\u359E\u361A\u360E\u2E8C\u2E97\u396E\u3918\uE826\u39CF\u39DF\u3A73\u39D0\uE82B\uE82C\u3B4E\u3C6E\u3CE0\u2EA7\uE831\uE832\u2EAA\u4056\u415F\u2EAE\u4337\u2EB3\u2EB6\u2EB7\uE83B\u43B1\u43AC\u2EBB\u43DD\u44D6\u4661\u464C\uE843"],["fe80","\u4723\u4729\u477C\u478D\u2ECA\u4947\u497A\u497D\u4982\u4983\u4985\u4986\u499F\u499B\u49B7\u49B6\uE854\uE855\u4CA3\u4C9F\u4CA0\u4CA1\u4C77\u4CA2\u4D13",6,"\u4DAE\uE864\uE468",93],["8135f437","\uE7C7"]]');

},{}],"4Q69p":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"uChars\":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],\"gbChars\":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}");

},{}],"dmGGU":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["0","\\u0000",127],["8141","\uAC02\uAC03\uAC05\uAC06\uAC0B",4,"\uAC18\uAC1E\uAC1F\uAC21\uAC22\uAC23\uAC25",6,"\uAC2E\uAC32\uAC33\uAC34"],["8161","\uAC35\uAC36\uAC37\uAC3A\uAC3B\uAC3D\uAC3E\uAC3F\uAC41",9,"\uAC4C\uAC4E",5,"\uAC55"],["8181","\uAC56\uAC57\uAC59\uAC5A\uAC5B\uAC5D",18,"\uAC72\uAC73\uAC75\uAC76\uAC79\uAC7B",4,"\uAC82\uAC87\uAC88\uAC8D\uAC8E\uAC8F\uAC91\uAC92\uAC93\uAC95",6,"\uAC9E\uACA2",5,"\uACAB\uACAD\uACAE\uACB1",6,"\uACBA\uACBE\uACBF\uACC0\uACC2\uACC3\uACC5\uACC6\uACC7\uACC9\uACCA\uACCB\uACCD",7,"\uACD6\uACD8",7,"\uACE2\uACE3\uACE5\uACE6\uACE9\uACEB\uACED\uACEE\uACF2\uACF4\uACF7",4,"\uACFE\uACFF\uAD01\uAD02\uAD03\uAD05\uAD07",4,"\uAD0E\uAD10\uAD12\uAD13"],["8241","\uAD14\uAD15\uAD16\uAD17\uAD19\uAD1A\uAD1B\uAD1D\uAD1E\uAD1F\uAD21",7,"\uAD2A\uAD2B\uAD2E",5],["8261","\uAD36\uAD37\uAD39\uAD3A\uAD3B\uAD3D",6,"\uAD46\uAD48\uAD4A",5,"\uAD51\uAD52\uAD53\uAD55\uAD56\uAD57"],["8281","\uAD59",7,"\uAD62\uAD64",7,"\uAD6E\uAD6F\uAD71\uAD72\uAD77\uAD78\uAD79\uAD7A\uAD7E\uAD80\uAD83",4,"\uAD8A\uAD8B\uAD8D\uAD8E\uAD8F\uAD91",10,"\uAD9E",5,"\uADA5",17,"\uADB8",7,"\uADC2\uADC3\uADC5\uADC6\uADC7\uADC9",6,"\uADD2\uADD4",7,"\uADDD\uADDE\uADDF\uADE1\uADE2\uADE3\uADE5",18],["8341","\uADFA\uADFB\uADFD\uADFE\uAE02",5,"\uAE0A\uAE0C\uAE0E",5,"\uAE15",7],["8361","\uAE1D",18,"\uAE32\uAE33\uAE35\uAE36\uAE39\uAE3B\uAE3C"],["8381","\uAE3D\uAE3E\uAE3F\uAE42\uAE44\uAE47\uAE48\uAE49\uAE4B\uAE4F\uAE51\uAE52\uAE53\uAE55\uAE57",4,"\uAE5E\uAE62\uAE63\uAE64\uAE66\uAE67\uAE6A\uAE6B\uAE6D\uAE6E\uAE6F\uAE71",6,"\uAE7A\uAE7E",5,"\uAE86",5,"\uAE8D",46,"\uAEBF\uAEC1\uAEC2\uAEC3\uAEC5",6,"\uAECE\uAED2",5,"\uAEDA\uAEDB\uAEDD",8],["8441","\uAEE6\uAEE7\uAEE9\uAEEA\uAEEC\uAEEE",5,"\uAEF5\uAEF6\uAEF7\uAEF9\uAEFA\uAEFB\uAEFD",8],["8461","\uAF06\uAF09\uAF0A\uAF0B\uAF0C\uAF0E\uAF0F\uAF11",18],["8481","\uAF24",7,"\uAF2E\uAF2F\uAF31\uAF33\uAF35",6,"\uAF3E\uAF40\uAF44\uAF45\uAF46\uAF47\uAF4A",5,"\uAF51",10,"\uAF5E",5,"\uAF66",18,"\uAF7A",5,"\uAF81\uAF82\uAF83\uAF85\uAF86\uAF87\uAF89",6,"\uAF92\uAF93\uAF94\uAF96",5,"\uAF9D",26,"\uAFBA\uAFBB\uAFBD\uAFBE"],["8541","\uAFBF\uAFC1",5,"\uAFCA\uAFCC\uAFCF",4,"\uAFD5",6,"\uAFDD",4],["8561","\uAFE2",5,"\uAFEA",5,"\uAFF2\uAFF3\uAFF5\uAFF6\uAFF7\uAFF9",6,"\uB002\uB003"],["8581","\uB005",6,"\uB00D\uB00E\uB00F\uB011\uB012\uB013\uB015",6,"\uB01E",9,"\uB029",26,"\uB046\uB047\uB049\uB04B\uB04D\uB04F\uB050\uB051\uB052\uB056\uB058\uB05A\uB05B\uB05C\uB05E",29,"\uB07E\uB07F\uB081\uB082\uB083\uB085",6,"\uB08E\uB090\uB092",5,"\uB09B\uB09D\uB09E\uB0A3\uB0A4"],["8641","\uB0A5\uB0A6\uB0A7\uB0AA\uB0B0\uB0B2\uB0B6\uB0B7\uB0B9\uB0BA\uB0BB\uB0BD",6,"\uB0C6\uB0CA",5,"\uB0D2"],["8661","\uB0D3\uB0D5\uB0D6\uB0D7\uB0D9",6,"\uB0E1\uB0E2\uB0E3\uB0E4\uB0E6",10],["8681","\uB0F1",22,"\uB10A\uB10D\uB10E\uB10F\uB111\uB114\uB115\uB116\uB117\uB11A\uB11E",4,"\uB126\uB127\uB129\uB12A\uB12B\uB12D",6,"\uB136\uB13A",5,"\uB142\uB143\uB145\uB146\uB147\uB149",6,"\uB152\uB153\uB156\uB157\uB159\uB15A\uB15B\uB15D\uB15E\uB15F\uB161",22,"\uB17A\uB17B\uB17D\uB17E\uB17F\uB181\uB183",4,"\uB18A\uB18C\uB18E\uB18F\uB190\uB191\uB195\uB196\uB197\uB199\uB19A\uB19B\uB19D"],["8741","\uB19E",9,"\uB1A9",15],["8761","\uB1B9",18,"\uB1CD\uB1CE\uB1CF\uB1D1\uB1D2\uB1D3\uB1D5"],["8781","\uB1D6",5,"\uB1DE\uB1E0",7,"\uB1EA\uB1EB\uB1ED\uB1EE\uB1EF\uB1F1",7,"\uB1FA\uB1FC\uB1FE",5,"\uB206\uB207\uB209\uB20A\uB20D",6,"\uB216\uB218\uB21A",5,"\uB221",18,"\uB235",6,"\uB23D",26,"\uB259\uB25A\uB25B\uB25D\uB25E\uB25F\uB261",6,"\uB26A",4],["8841","\uB26F",4,"\uB276",5,"\uB27D",6,"\uB286\uB287\uB288\uB28A",4],["8861","\uB28F\uB292\uB293\uB295\uB296\uB297\uB29B",4,"\uB2A2\uB2A4\uB2A7\uB2A8\uB2A9\uB2AB\uB2AD\uB2AE\uB2AF\uB2B1\uB2B2\uB2B3\uB2B5\uB2B6\uB2B7"],["8881","\uB2B8",15,"\uB2CA\uB2CB\uB2CD\uB2CE\uB2CF\uB2D1\uB2D3",4,"\uB2DA\uB2DC\uB2DE\uB2DF\uB2E0\uB2E1\uB2E3\uB2E7\uB2E9\uB2EA\uB2F0\uB2F1\uB2F2\uB2F6\uB2FC\uB2FD\uB2FE\uB302\uB303\uB305\uB306\uB307\uB309",6,"\uB312\uB316",5,"\uB31D",54,"\uB357\uB359\uB35A\uB35D\uB360\uB361\uB362\uB363"],["8941","\uB366\uB368\uB36A\uB36C\uB36D\uB36F\uB372\uB373\uB375\uB376\uB377\uB379",6,"\uB382\uB386",5,"\uB38D"],["8961","\uB38E\uB38F\uB391\uB392\uB393\uB395",10,"\uB3A2",5,"\uB3A9\uB3AA\uB3AB\uB3AD"],["8981","\uB3AE",21,"\uB3C6\uB3C7\uB3C9\uB3CA\uB3CD\uB3CF\uB3D1\uB3D2\uB3D3\uB3D6\uB3D8\uB3DA\uB3DC\uB3DE\uB3DF\uB3E1\uB3E2\uB3E3\uB3E5\uB3E6\uB3E7\uB3E9",18,"\uB3FD",18,"\uB411",6,"\uB419\uB41A\uB41B\uB41D\uB41E\uB41F\uB421",6,"\uB42A\uB42C",7,"\uB435",15],["8a41","\uB445",10,"\uB452\uB453\uB455\uB456\uB457\uB459",6,"\uB462\uB464\uB466"],["8a61","\uB467",4,"\uB46D",18,"\uB481\uB482"],["8a81","\uB483",4,"\uB489",19,"\uB49E",5,"\uB4A5\uB4A6\uB4A7\uB4A9\uB4AA\uB4AB\uB4AD",7,"\uB4B6\uB4B8\uB4BA",5,"\uB4C1\uB4C2\uB4C3\uB4C5\uB4C6\uB4C7\uB4C9",6,"\uB4D1\uB4D2\uB4D3\uB4D4\uB4D6",5,"\uB4DE\uB4DF\uB4E1\uB4E2\uB4E5\uB4E7",4,"\uB4EE\uB4F0\uB4F2",5,"\uB4F9",26,"\uB516\uB517\uB519\uB51A\uB51D"],["8b41","\uB51E",5,"\uB526\uB52B",4,"\uB532\uB533\uB535\uB536\uB537\uB539",6,"\uB542\uB546"],["8b61","\uB547\uB548\uB549\uB54A\uB54E\uB54F\uB551\uB552\uB553\uB555",6,"\uB55E\uB562",8],["8b81","\uB56B",52,"\uB5A2\uB5A3\uB5A5\uB5A6\uB5A7\uB5A9\uB5AC\uB5AD\uB5AE\uB5AF\uB5B2\uB5B6",4,"\uB5BE\uB5BF\uB5C1\uB5C2\uB5C3\uB5C5",6,"\uB5CE\uB5D2",5,"\uB5D9",18,"\uB5ED",18],["8c41","\uB600",15,"\uB612\uB613\uB615\uB616\uB617\uB619",4],["8c61","\uB61E",6,"\uB626",5,"\uB62D",6,"\uB635",5],["8c81","\uB63B",12,"\uB649",26,"\uB665\uB666\uB667\uB669",50,"\uB69E\uB69F\uB6A1\uB6A2\uB6A3\uB6A5",5,"\uB6AD\uB6AE\uB6AF\uB6B0\uB6B2",16],["8d41","\uB6C3",16,"\uB6D5",8],["8d61","\uB6DE",17,"\uB6F1\uB6F2\uB6F3\uB6F5\uB6F6\uB6F7\uB6F9\uB6FA"],["8d81","\uB6FB",4,"\uB702\uB703\uB704\uB706",33,"\uB72A\uB72B\uB72D\uB72E\uB731",6,"\uB73A\uB73C",7,"\uB745\uB746\uB747\uB749\uB74A\uB74B\uB74D",6,"\uB756",9,"\uB761\uB762\uB763\uB765\uB766\uB767\uB769",6,"\uB772\uB774\uB776",5,"\uB77E\uB77F\uB781\uB782\uB783\uB785",6,"\uB78E\uB793\uB794\uB795\uB79A\uB79B\uB79D\uB79E"],["8e41","\uB79F\uB7A1",6,"\uB7AA\uB7AE",5,"\uB7B6\uB7B7\uB7B9",8],["8e61","\uB7C2",4,"\uB7C8\uB7CA",19],["8e81","\uB7DE",13,"\uB7EE\uB7EF\uB7F1\uB7F2\uB7F3\uB7F5",6,"\uB7FE\uB802",4,"\uB80A\uB80B\uB80D\uB80E\uB80F\uB811",6,"\uB81A\uB81C\uB81E",5,"\uB826\uB827\uB829\uB82A\uB82B\uB82D",6,"\uB836\uB83A",5,"\uB841\uB842\uB843\uB845",11,"\uB852\uB854",7,"\uB85E\uB85F\uB861\uB862\uB863\uB865",6,"\uB86E\uB870\uB872",5,"\uB879\uB87A\uB87B\uB87D",7],["8f41","\uB885",7,"\uB88E",17],["8f61","\uB8A0",7,"\uB8A9",6,"\uB8B1\uB8B2\uB8B3\uB8B5\uB8B6\uB8B7\uB8B9",4],["8f81","\uB8BE\uB8BF\uB8C2\uB8C4\uB8C6",5,"\uB8CD\uB8CE\uB8CF\uB8D1\uB8D2\uB8D3\uB8D5",7,"\uB8DE\uB8E0\uB8E2",5,"\uB8EA\uB8EB\uB8ED\uB8EE\uB8EF\uB8F1",6,"\uB8FA\uB8FC\uB8FE",5,"\uB905",18,"\uB919",6,"\uB921",26,"\uB93E\uB93F\uB941\uB942\uB943\uB945",6,"\uB94D\uB94E\uB950\uB952",5],["9041","\uB95A\uB95B\uB95D\uB95E\uB95F\uB961",6,"\uB96A\uB96C\uB96E",5,"\uB976\uB977\uB979\uB97A\uB97B\uB97D"],["9061","\uB97E",5,"\uB986\uB988\uB98B\uB98C\uB98F",15],["9081","\uB99F",12,"\uB9AE\uB9AF\uB9B1\uB9B2\uB9B3\uB9B5",6,"\uB9BE\uB9C0\uB9C2",5,"\uB9CA\uB9CB\uB9CD\uB9D3",4,"\uB9DA\uB9DC\uB9DF\uB9E0\uB9E2\uB9E6\uB9E7\uB9E9\uB9EA\uB9EB\uB9ED",6,"\uB9F6\uB9FB",4,"\uBA02",5,"\uBA09",11,"\uBA16",33,"\uBA3A\uBA3B\uBA3D\uBA3E\uBA3F\uBA41\uBA43\uBA44\uBA45\uBA46"],["9141","\uBA47\uBA4A\uBA4C\uBA4F\uBA50\uBA51\uBA52\uBA56\uBA57\uBA59\uBA5A\uBA5B\uBA5D",6,"\uBA66\uBA6A",5],["9161","\uBA72\uBA73\uBA75\uBA76\uBA77\uBA79",9,"\uBA86\uBA88\uBA89\uBA8A\uBA8B\uBA8D",5],["9181","\uBA93",20,"\uBAAA\uBAAD\uBAAE\uBAAF\uBAB1\uBAB3",4,"\uBABA\uBABC\uBABE",5,"\uBAC5\uBAC6\uBAC7\uBAC9",14,"\uBADA",33,"\uBAFD\uBAFE\uBAFF\uBB01\uBB02\uBB03\uBB05",7,"\uBB0E\uBB10\uBB12",5,"\uBB19\uBB1A\uBB1B\uBB1D\uBB1E\uBB1F\uBB21",6],["9241","\uBB28\uBB2A\uBB2C",7,"\uBB37\uBB39\uBB3A\uBB3F",4,"\uBB46\uBB48\uBB4A\uBB4B\uBB4C\uBB4E\uBB51\uBB52"],["9261","\uBB53\uBB55\uBB56\uBB57\uBB59",7,"\uBB62\uBB64",7,"\uBB6D",4],["9281","\uBB72",21,"\uBB89\uBB8A\uBB8B\uBB8D\uBB8E\uBB8F\uBB91",18,"\uBBA5\uBBA6\uBBA7\uBBA9\uBBAA\uBBAB\uBBAD",6,"\uBBB5\uBBB6\uBBB8",7,"\uBBC1\uBBC2\uBBC3\uBBC5\uBBC6\uBBC7\uBBC9",6,"\uBBD1\uBBD2\uBBD4",35,"\uBBFA\uBBFB\uBBFD\uBBFE\uBC01"],["9341","\uBC03",4,"\uBC0A\uBC0E\uBC10\uBC12\uBC13\uBC19\uBC1A\uBC20\uBC21\uBC22\uBC23\uBC26\uBC28\uBC2A\uBC2B\uBC2C\uBC2E\uBC2F\uBC32\uBC33\uBC35"],["9361","\uBC36\uBC37\uBC39",6,"\uBC42\uBC46\uBC47\uBC48\uBC4A\uBC4B\uBC4E\uBC4F\uBC51",8],["9381","\uBC5A\uBC5B\uBC5C\uBC5E",37,"\uBC86\uBC87\uBC89\uBC8A\uBC8D\uBC8F",4,"\uBC96\uBC98\uBC9B",4,"\uBCA2\uBCA3\uBCA5\uBCA6\uBCA9",6,"\uBCB2\uBCB6",5,"\uBCBE\uBCBF\uBCC1\uBCC2\uBCC3\uBCC5",7,"\uBCCE\uBCD2\uBCD3\uBCD4\uBCD6\uBCD7\uBCD9\uBCDA\uBCDB\uBCDD",22,"\uBCF7\uBCF9\uBCFA\uBCFB\uBCFD"],["9441","\uBCFE",5,"\uBD06\uBD08\uBD0A",5,"\uBD11\uBD12\uBD13\uBD15",8],["9461","\uBD1E",5,"\uBD25",6,"\uBD2D",12],["9481","\uBD3A",5,"\uBD41",6,"\uBD4A\uBD4B\uBD4D\uBD4E\uBD4F\uBD51",6,"\uBD5A",9,"\uBD65\uBD66\uBD67\uBD69",22,"\uBD82\uBD83\uBD85\uBD86\uBD8B",4,"\uBD92\uBD94\uBD96\uBD97\uBD98\uBD9B\uBD9D",6,"\uBDA5",10,"\uBDB1",6,"\uBDB9",24],["9541","\uBDD2\uBDD3\uBDD6\uBDD7\uBDD9\uBDDA\uBDDB\uBDDD",11,"\uBDEA",5,"\uBDF1"],["9561","\uBDF2\uBDF3\uBDF5\uBDF6\uBDF7\uBDF9",6,"\uBE01\uBE02\uBE04\uBE06",5,"\uBE0E\uBE0F\uBE11\uBE12\uBE13"],["9581","\uBE15",6,"\uBE1E\uBE20",35,"\uBE46\uBE47\uBE49\uBE4A\uBE4B\uBE4D\uBE4F",4,"\uBE56\uBE58\uBE5C\uBE5D\uBE5E\uBE5F\uBE62\uBE63\uBE65\uBE66\uBE67\uBE69\uBE6B",4,"\uBE72\uBE76",4,"\uBE7E\uBE7F\uBE81\uBE82\uBE83\uBE85",6,"\uBE8E\uBE92",5,"\uBE9A",13,"\uBEA9",14],["9641","\uBEB8",23,"\uBED2\uBED3"],["9661","\uBED5\uBED6\uBED9",6,"\uBEE1\uBEE2\uBEE6",5,"\uBEED",8],["9681","\uBEF6",10,"\uBF02",5,"\uBF0A",13,"\uBF1A\uBF1E",33,"\uBF42\uBF43\uBF45\uBF46\uBF47\uBF49",6,"\uBF52\uBF53\uBF54\uBF56",44],["9741","\uBF83",16,"\uBF95",8],["9761","\uBF9E",17,"\uBFB1",7],["9781","\uBFB9",11,"\uBFC6",5,"\uBFCE\uBFCF\uBFD1\uBFD2\uBFD3\uBFD5",6,"\uBFDD\uBFDE\uBFE0\uBFE2",89,"\uC03D\uC03E\uC03F"],["9841","\uC040",16,"\uC052",5,"\uC059\uC05A\uC05B"],["9861","\uC05D\uC05E\uC05F\uC061",6,"\uC06A",15],["9881","\uC07A",21,"\uC092\uC093\uC095\uC096\uC097\uC099",6,"\uC0A2\uC0A4\uC0A6",5,"\uC0AE\uC0B1\uC0B2\uC0B7",4,"\uC0BE\uC0C2\uC0C3\uC0C4\uC0C6\uC0C7\uC0CA\uC0CB\uC0CD\uC0CE\uC0CF\uC0D1",6,"\uC0DA\uC0DE",5,"\uC0E6\uC0E7\uC0E9\uC0EA\uC0EB\uC0ED",6,"\uC0F6\uC0F8\uC0FA",5,"\uC101\uC102\uC103\uC105\uC106\uC107\uC109",6,"\uC111\uC112\uC113\uC114\uC116",5,"\uC121\uC122\uC125\uC128\uC129\uC12A\uC12B\uC12E"],["9941","\uC132\uC133\uC134\uC135\uC137\uC13A\uC13B\uC13D\uC13E\uC13F\uC141",6,"\uC14A\uC14E",5,"\uC156\uC157"],["9961","\uC159\uC15A\uC15B\uC15D",6,"\uC166\uC16A",5,"\uC171\uC172\uC173\uC175\uC176\uC177\uC179\uC17A\uC17B"],["9981","\uC17C",8,"\uC186",5,"\uC18F\uC191\uC192\uC193\uC195\uC197",4,"\uC19E\uC1A0\uC1A2\uC1A3\uC1A4\uC1A6\uC1A7\uC1AA\uC1AB\uC1AD\uC1AE\uC1AF\uC1B1",11,"\uC1BE",5,"\uC1C5\uC1C6\uC1C7\uC1C9\uC1CA\uC1CB\uC1CD",6,"\uC1D5\uC1D6\uC1D9",6,"\uC1E1\uC1E2\uC1E3\uC1E5\uC1E6\uC1E7\uC1E9",6,"\uC1F2\uC1F4",7,"\uC1FE\uC1FF\uC201\uC202\uC203\uC205",6,"\uC20E\uC210\uC212",5,"\uC21A\uC21B\uC21D\uC21E\uC221\uC222\uC223"],["9a41","\uC224\uC225\uC226\uC227\uC22A\uC22C\uC22E\uC230\uC233\uC235",16],["9a61","\uC246\uC247\uC249",6,"\uC252\uC253\uC255\uC256\uC257\uC259",6,"\uC261\uC262\uC263\uC264\uC266"],["9a81","\uC267",4,"\uC26E\uC26F\uC271\uC272\uC273\uC275",6,"\uC27E\uC280\uC282",5,"\uC28A",5,"\uC291",6,"\uC299\uC29A\uC29C\uC29E",5,"\uC2A6\uC2A7\uC2A9\uC2AA\uC2AB\uC2AE",5,"\uC2B6\uC2B8\uC2BA",33,"\uC2DE\uC2DF\uC2E1\uC2E2\uC2E5",5,"\uC2EE\uC2F0\uC2F2\uC2F3\uC2F4\uC2F5\uC2F7\uC2FA\uC2FD\uC2FE\uC2FF\uC301",6,"\uC30A\uC30B\uC30E\uC30F"],["9b41","\uC310\uC311\uC312\uC316\uC317\uC319\uC31A\uC31B\uC31D",6,"\uC326\uC327\uC32A",8],["9b61","\uC333",17,"\uC346",7],["9b81","\uC34E",25,"\uC36A\uC36B\uC36D\uC36E\uC36F\uC371\uC373",4,"\uC37A\uC37B\uC37E",5,"\uC385\uC386\uC387\uC389\uC38A\uC38B\uC38D",50,"\uC3C1",22,"\uC3DA"],["9c41","\uC3DB\uC3DD\uC3DE\uC3E1\uC3E3",4,"\uC3EA\uC3EB\uC3EC\uC3EE",5,"\uC3F6\uC3F7\uC3F9",5],["9c61","\uC3FF",8,"\uC409",6,"\uC411",9],["9c81","\uC41B",8,"\uC425",6,"\uC42D\uC42E\uC42F\uC431\uC432\uC433\uC435",6,"\uC43E",9,"\uC449",26,"\uC466\uC467\uC469\uC46A\uC46B\uC46D",6,"\uC476\uC477\uC478\uC47A",5,"\uC481",18,"\uC495",6,"\uC49D",12],["9d41","\uC4AA",13,"\uC4B9\uC4BA\uC4BB\uC4BD",8],["9d61","\uC4C6",25],["9d81","\uC4E0",8,"\uC4EA",5,"\uC4F2\uC4F3\uC4F5\uC4F6\uC4F7\uC4F9\uC4FB\uC4FC\uC4FD\uC4FE\uC502",9,"\uC50D\uC50E\uC50F\uC511\uC512\uC513\uC515",6,"\uC51D",10,"\uC52A\uC52B\uC52D\uC52E\uC52F\uC531",6,"\uC53A\uC53C\uC53E",5,"\uC546\uC547\uC54B\uC54F\uC550\uC551\uC552\uC556\uC55A\uC55B\uC55C\uC55F\uC562\uC563\uC565\uC566\uC567\uC569",6,"\uC572\uC576",5,"\uC57E\uC57F\uC581\uC582\uC583\uC585\uC586\uC588\uC589\uC58A\uC58B\uC58E\uC590\uC592\uC593\uC594"],["9e41","\uC596\uC599\uC59A\uC59B\uC59D\uC59E\uC59F\uC5A1",7,"\uC5AA",9,"\uC5B6"],["9e61","\uC5B7\uC5BA\uC5BF",4,"\uC5CB\uC5CD\uC5CF\uC5D2\uC5D3\uC5D5\uC5D6\uC5D7\uC5D9",6,"\uC5E2\uC5E4\uC5E6\uC5E7"],["9e81","\uC5E8\uC5E9\uC5EA\uC5EB\uC5EF\uC5F1\uC5F2\uC5F3\uC5F5\uC5F8\uC5F9\uC5FA\uC5FB\uC602\uC603\uC604\uC609\uC60A\uC60B\uC60D\uC60E\uC60F\uC611",6,"\uC61A\uC61D",6,"\uC626\uC627\uC629\uC62A\uC62B\uC62F\uC631\uC632\uC636\uC638\uC63A\uC63C\uC63D\uC63E\uC63F\uC642\uC643\uC645\uC646\uC647\uC649",6,"\uC652\uC656",5,"\uC65E\uC65F\uC661",10,"\uC66D\uC66E\uC670\uC672",5,"\uC67A\uC67B\uC67D\uC67E\uC67F\uC681",6,"\uC68A\uC68C\uC68E",5,"\uC696\uC697\uC699\uC69A\uC69B\uC69D",6,"\uC6A6"],["9f41","\uC6A8\uC6AA",5,"\uC6B2\uC6B3\uC6B5\uC6B6\uC6B7\uC6BB",4,"\uC6C2\uC6C4\uC6C6",5,"\uC6CE"],["9f61","\uC6CF\uC6D1\uC6D2\uC6D3\uC6D5",6,"\uC6DE\uC6DF\uC6E2",5,"\uC6EA\uC6EB\uC6ED\uC6EE\uC6EF\uC6F1\uC6F2"],["9f81","\uC6F3",4,"\uC6FA\uC6FB\uC6FC\uC6FE",5,"\uC706\uC707\uC709\uC70A\uC70B\uC70D",6,"\uC716\uC718\uC71A",5,"\uC722\uC723\uC725\uC726\uC727\uC729",6,"\uC732\uC734\uC736\uC738\uC739\uC73A\uC73B\uC73E\uC73F\uC741\uC742\uC743\uC745",4,"\uC74B\uC74E\uC750\uC759\uC75A\uC75B\uC75D\uC75E\uC75F\uC761",6,"\uC769\uC76A\uC76C",7,"\uC776\uC777\uC779\uC77A\uC77B\uC77F\uC780\uC781\uC782\uC786\uC78B\uC78C\uC78D\uC78F\uC792\uC793\uC795\uC799\uC79B",4,"\uC7A2\uC7A7",4,"\uC7AE\uC7AF\uC7B1\uC7B2\uC7B3\uC7B5\uC7B6\uC7B7"],["a041","\uC7B8\uC7B9\uC7BA\uC7BB\uC7BE\uC7C2",5,"\uC7CA\uC7CB\uC7CD\uC7CF\uC7D1",6,"\uC7D9\uC7DA\uC7DB\uC7DC"],["a061","\uC7DE",5,"\uC7E5\uC7E6\uC7E7\uC7E9\uC7EA\uC7EB\uC7ED",13],["a081","\uC7FB",4,"\uC802\uC803\uC805\uC806\uC807\uC809\uC80B",4,"\uC812\uC814\uC817",4,"\uC81E\uC81F\uC821\uC822\uC823\uC825",6,"\uC82E\uC830\uC832",5,"\uC839\uC83A\uC83B\uC83D\uC83E\uC83F\uC841",6,"\uC84A\uC84B\uC84E",5,"\uC855",26,"\uC872\uC873\uC875\uC876\uC877\uC879\uC87B",4,"\uC882\uC884\uC888\uC889\uC88A\uC88E",5,"\uC895",7,"\uC89E\uC8A0\uC8A2\uC8A3\uC8A4"],["a141","\uC8A5\uC8A6\uC8A7\uC8A9",18,"\uC8BE\uC8BF\uC8C0\uC8C1"],["a161","\uC8C2\uC8C3\uC8C5\uC8C6\uC8C7\uC8C9\uC8CA\uC8CB\uC8CD",6,"\uC8D6\uC8D8\uC8DA",5,"\uC8E2\uC8E3\uC8E5"],["a181","\uC8E6",14,"\uC8F6",5,"\uC8FE\uC8FF\uC901\uC902\uC903\uC907",4,"\uC90E\u3000\u3001\u3002\xb7\u2025\u2026\xa8\u3003\xad\u2015\u2225\uFF3C\u223C\u2018\u2019\u201C\u201D\u3014\u3015\u3008",9,"\xb1\xd7\xf7\u2260\u2264\u2265\u221E\u2234\xb0\u2032\u2033\u2103\u212B\uFFE0\uFFE1\uFFE5\u2642\u2640\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\xa7\u203B\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u2192\u2190\u2191\u2193\u2194\u3013\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\u2227\u2228\uFFE2"],["a241","\uC910\uC912",5,"\uC919",18],["a261","\uC92D",6,"\uC935",18],["a281","\uC948",7,"\uC952\uC953\uC955\uC956\uC957\uC959",6,"\uC962\uC964",7,"\uC96D\uC96E\uC96F\u21D2\u21D4\u2200\u2203\xb4\uFF5E\u02C7\u02D8\u02DD\u02DA\u02D9\xb8\u02DB\xa1\xbf\u02D0\u222E\u2211\u220F\xa4\u2109\u2030\u25C1\u25C0\u25B7\u25B6\u2664\u2660\u2661\u2665\u2667\u2663\u2299\u25C8\u25A3\u25D0\u25D1\u2592\u25A4\u25A5\u25A8\u25A7\u25A6\u25A9\u2668\u260F\u260E\u261C\u261E\xb6\u2020\u2021\u2195\u2197\u2199\u2196\u2198\u266D\u2669\u266A\u266C\u327F\u321C\u2116\u33C7\u2122\u33C2\u33D8\u2121\u20AC\xae"],["a341","\uC971\uC972\uC973\uC975",6,"\uC97D",10,"\uC98A\uC98B\uC98D\uC98E\uC98F"],["a361","\uC991",6,"\uC99A\uC99C\uC99E",16],["a381","\uC9AF",16,"\uC9C2\uC9C3\uC9C5\uC9C6\uC9C9\uC9CB",4,"\uC9D2\uC9D4\uC9D7\uC9D8\uC9DB\uFF01",58,"\uFFE6\uFF3D",32,"\uFFE3"],["a441","\uC9DE\uC9DF\uC9E1\uC9E3\uC9E5\uC9E6\uC9E8\uC9E9\uC9EA\uC9EB\uC9EE\uC9F2",5,"\uC9FA\uC9FB\uC9FD\uC9FE\uC9FF\uCA01\uCA02\uCA03\uCA04"],["a461","\uCA05\uCA06\uCA07\uCA0A\uCA0E",5,"\uCA15\uCA16\uCA17\uCA19",12],["a481","\uCA26\uCA27\uCA28\uCA2A",28,"\u3131",93],["a541","\uCA47",4,"\uCA4E\uCA4F\uCA51\uCA52\uCA53\uCA55",6,"\uCA5E\uCA62",5,"\uCA69\uCA6A"],["a561","\uCA6B",17,"\uCA7E",5,"\uCA85\uCA86"],["a581","\uCA87",16,"\uCA99",14,"\u2170",9],["a5b0","\u2160",9],["a5c1","\u0391",16,"\u03A3",6],["a5e1","\u03B1",16,"\u03C3",6],["a641","\uCAA8",19,"\uCABE\uCABF\uCAC1\uCAC2\uCAC3\uCAC5"],["a661","\uCAC6",5,"\uCACE\uCAD0\uCAD2\uCAD4\uCAD5\uCAD6\uCAD7\uCADA",5,"\uCAE1",6],["a681","\uCAE8\uCAE9\uCAEA\uCAEB\uCAED",6,"\uCAF5",18,"\uCB09\uCB0A\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\u2512\u2511\u251A\u2519\u2516\u2515\u250E\u250D\u251E\u251F\u2521\u2522\u2526\u2527\u2529\u252A\u252D\u252E\u2531\u2532\u2535\u2536\u2539\u253A\u253D\u253E\u2540\u2541\u2543",7],["a741","\uCB0B",4,"\uCB11\uCB12\uCB13\uCB15\uCB16\uCB17\uCB19",6,"\uCB22",7],["a761","\uCB2A",22,"\uCB42\uCB43\uCB44"],["a781","\uCB45\uCB46\uCB47\uCB4A\uCB4B\uCB4D\uCB4E\uCB4F\uCB51",6,"\uCB5A\uCB5B\uCB5C\uCB5E",5,"\uCB65",7,"\u3395\u3396\u3397\u2113\u3398\u33C4\u33A3\u33A4\u33A5\u33A6\u3399",9,"\u33CA\u338D\u338E\u338F\u33CF\u3388\u3389\u33C8\u33A7\u33A8\u33B0",9,"\u3380",4,"\u33BA",5,"\u3390",4,"\u2126\u33C0\u33C1\u338A\u338B\u338C\u33D6\u33C5\u33AD\u33AE\u33AF\u33DB\u33A9\u33AA\u33AB\u33AC\u33DD\u33D0\u33D3\u33C3\u33C9\u33DC\u33C6"],["a841","\uCB6D",10,"\uCB7A",14],["a861","\uCB89",18,"\uCB9D",6],["a881","\uCBA4",19,"\uCBB9",11,"\xc6\xd0\xaa\u0126"],["a8a6","\u0132"],["a8a8","\u013F\u0141\xd8\u0152\xba\xde\u0166\u014A"],["a8b1","\u3260",27,"\u24D0",25,"\u2460",14,"\xbd\u2153\u2154\xbc\xbe\u215B\u215C\u215D\u215E"],["a941","\uCBC5",14,"\uCBD5",10],["a961","\uCBE0\uCBE1\uCBE2\uCBE3\uCBE5\uCBE6\uCBE8\uCBEA",18],["a981","\uCBFD",14,"\uCC0E\uCC0F\uCC11\uCC12\uCC13\uCC15",6,"\uCC1E\uCC1F\uCC20\uCC23\uCC24\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0140\u0142\xf8\u0153\xdf\xfe\u0167\u014B\u0149\u3200",27,"\u249C",25,"\u2474",14,"\xb9\xb2\xb3\u2074\u207F\u2081\u2082\u2083\u2084"],["aa41","\uCC25\uCC26\uCC2A\uCC2B\uCC2D\uCC2F\uCC31",6,"\uCC3A\uCC3F",4,"\uCC46\uCC47\uCC49\uCC4A\uCC4B\uCC4D\uCC4E"],["aa61","\uCC4F",4,"\uCC56\uCC5A",5,"\uCC61\uCC62\uCC63\uCC65\uCC67\uCC69",6,"\uCC71\uCC72"],["aa81","\uCC73\uCC74\uCC76",29,"\u3041",82],["ab41","\uCC94\uCC95\uCC96\uCC97\uCC9A\uCC9B\uCC9D\uCC9E\uCC9F\uCCA1",6,"\uCCAA\uCCAE",5,"\uCCB6\uCCB7\uCCB9"],["ab61","\uCCBA\uCCBB\uCCBD",6,"\uCCC6\uCCC8\uCCCA",5,"\uCCD1\uCCD2\uCCD3\uCCD5",5],["ab81","\uCCDB",8,"\uCCE5",6,"\uCCED\uCCEE\uCCEF\uCCF1",12,"\u30A1",85],["ac41","\uCCFE\uCCFF\uCD00\uCD02",5,"\uCD0A\uCD0B\uCD0D\uCD0E\uCD0F\uCD11",6,"\uCD1A\uCD1C\uCD1E\uCD1F\uCD20"],["ac61","\uCD21\uCD22\uCD23\uCD25\uCD26\uCD27\uCD29\uCD2A\uCD2B\uCD2D",11,"\uCD3A",4],["ac81","\uCD3F",28,"\uCD5D\uCD5E\uCD5F\u0410",5,"\u0401\u0416",25],["acd1","\u0430",5,"\u0451\u0436",25],["ad41","\uCD61\uCD62\uCD63\uCD65",6,"\uCD6E\uCD70\uCD72",5,"\uCD79",7],["ad61","\uCD81",6,"\uCD89",10,"\uCD96\uCD97\uCD99\uCD9A\uCD9B\uCD9D\uCD9E\uCD9F"],["ad81","\uCDA0\uCDA1\uCDA2\uCDA3\uCDA6\uCDA8\uCDAA",5,"\uCDB1",18,"\uCDC5"],["ae41","\uCDC6",5,"\uCDCD\uCDCE\uCDCF\uCDD1",16],["ae61","\uCDE2",5,"\uCDE9\uCDEA\uCDEB\uCDED\uCDEE\uCDEF\uCDF1",6,"\uCDFA\uCDFC\uCDFE",4],["ae81","\uCE03\uCE05\uCE06\uCE07\uCE09\uCE0A\uCE0B\uCE0D",6,"\uCE15\uCE16\uCE17\uCE18\uCE1A",5,"\uCE22\uCE23\uCE25\uCE26\uCE27\uCE29\uCE2A\uCE2B"],["af41","\uCE2C\uCE2D\uCE2E\uCE2F\uCE32\uCE34\uCE36",19],["af61","\uCE4A",13,"\uCE5A\uCE5B\uCE5D\uCE5E\uCE62",5,"\uCE6A\uCE6C"],["af81","\uCE6E",5,"\uCE76\uCE77\uCE79\uCE7A\uCE7B\uCE7D",6,"\uCE86\uCE88\uCE8A",5,"\uCE92\uCE93\uCE95\uCE96\uCE97\uCE99"],["b041","\uCE9A",5,"\uCEA2\uCEA6",5,"\uCEAE",12],["b061","\uCEBB",5,"\uCEC2",19],["b081","\uCED6",13,"\uCEE6\uCEE7\uCEE9\uCEEA\uCEED",6,"\uCEF6\uCEFA",5,"\uAC00\uAC01\uAC04\uAC07\uAC08\uAC09\uAC0A\uAC10",7,"\uAC19",4,"\uAC20\uAC24\uAC2C\uAC2D\uAC2F\uAC30\uAC31\uAC38\uAC39\uAC3C\uAC40\uAC4B\uAC4D\uAC54\uAC58\uAC5C\uAC70\uAC71\uAC74\uAC77\uAC78\uAC7A\uAC80\uAC81\uAC83\uAC84\uAC85\uAC86\uAC89\uAC8A\uAC8B\uAC8C\uAC90\uAC94\uAC9C\uAC9D\uAC9F\uACA0\uACA1\uACA8\uACA9\uACAA\uACAC\uACAF\uACB0\uACB8\uACB9\uACBB\uACBC\uACBD\uACC1\uACC4\uACC8\uACCC\uACD5\uACD7\uACE0\uACE1\uACE4\uACE7\uACE8\uACEA\uACEC\uACEF\uACF0\uACF1\uACF3\uACF5\uACF6\uACFC\uACFD\uAD00\uAD04\uAD06"],["b141","\uCF02\uCF03\uCF05\uCF06\uCF07\uCF09",6,"\uCF12\uCF14\uCF16",5,"\uCF1D\uCF1E\uCF1F\uCF21\uCF22\uCF23"],["b161","\uCF25",6,"\uCF2E\uCF32",5,"\uCF39",11],["b181","\uCF45",14,"\uCF56\uCF57\uCF59\uCF5A\uCF5B\uCF5D",6,"\uCF66\uCF68\uCF6A\uCF6B\uCF6C\uAD0C\uAD0D\uAD0F\uAD11\uAD18\uAD1C\uAD20\uAD29\uAD2C\uAD2D\uAD34\uAD35\uAD38\uAD3C\uAD44\uAD45\uAD47\uAD49\uAD50\uAD54\uAD58\uAD61\uAD63\uAD6C\uAD6D\uAD70\uAD73\uAD74\uAD75\uAD76\uAD7B\uAD7C\uAD7D\uAD7F\uAD81\uAD82\uAD88\uAD89\uAD8C\uAD90\uAD9C\uAD9D\uADA4\uADB7\uADC0\uADC1\uADC4\uADC8\uADD0\uADD1\uADD3\uADDC\uADE0\uADE4\uADF8\uADF9\uADFC\uADFF\uAE00\uAE01\uAE08\uAE09\uAE0B\uAE0D\uAE14\uAE30\uAE31\uAE34\uAE37\uAE38\uAE3A\uAE40\uAE41\uAE43\uAE45\uAE46\uAE4A\uAE4C\uAE4D\uAE4E\uAE50\uAE54\uAE56\uAE5C\uAE5D\uAE5F\uAE60\uAE61\uAE65\uAE68\uAE69\uAE6C\uAE70\uAE78"],["b241","\uCF6D\uCF6E\uCF6F\uCF72\uCF73\uCF75\uCF76\uCF77\uCF79",6,"\uCF81\uCF82\uCF83\uCF84\uCF86",5,"\uCF8D"],["b261","\uCF8E",18,"\uCFA2",5,"\uCFA9"],["b281","\uCFAA",5,"\uCFB1",18,"\uCFC5",6,"\uAE79\uAE7B\uAE7C\uAE7D\uAE84\uAE85\uAE8C\uAEBC\uAEBD\uAEBE\uAEC0\uAEC4\uAECC\uAECD\uAECF\uAED0\uAED1\uAED8\uAED9\uAEDC\uAEE8\uAEEB\uAEED\uAEF4\uAEF8\uAEFC\uAF07\uAF08\uAF0D\uAF10\uAF2C\uAF2D\uAF30\uAF32\uAF34\uAF3C\uAF3D\uAF3F\uAF41\uAF42\uAF43\uAF48\uAF49\uAF50\uAF5C\uAF5D\uAF64\uAF65\uAF79\uAF80\uAF84\uAF88\uAF90\uAF91\uAF95\uAF9C\uAFB8\uAFB9\uAFBC\uAFC0\uAFC7\uAFC8\uAFC9\uAFCB\uAFCD\uAFCE\uAFD4\uAFDC\uAFE8\uAFE9\uAFF0\uAFF1\uAFF4\uAFF8\uB000\uB001\uB004\uB00C\uB010\uB014\uB01C\uB01D\uB028\uB044\uB045\uB048\uB04A\uB04C\uB04E\uB053\uB054\uB055\uB057\uB059"],["b341","\uCFCC",19,"\uCFE2\uCFE3\uCFE5\uCFE6\uCFE7\uCFE9"],["b361","\uCFEA",5,"\uCFF2\uCFF4\uCFF6",5,"\uCFFD\uCFFE\uCFFF\uD001\uD002\uD003\uD005",5],["b381","\uD00B",5,"\uD012",5,"\uD019",19,"\uB05D\uB07C\uB07D\uB080\uB084\uB08C\uB08D\uB08F\uB091\uB098\uB099\uB09A\uB09C\uB09F\uB0A0\uB0A1\uB0A2\uB0A8\uB0A9\uB0AB",4,"\uB0B1\uB0B3\uB0B4\uB0B5\uB0B8\uB0BC\uB0C4\uB0C5\uB0C7\uB0C8\uB0C9\uB0D0\uB0D1\uB0D4\uB0D8\uB0E0\uB0E5\uB108\uB109\uB10B\uB10C\uB110\uB112\uB113\uB118\uB119\uB11B\uB11C\uB11D\uB123\uB124\uB125\uB128\uB12C\uB134\uB135\uB137\uB138\uB139\uB140\uB141\uB144\uB148\uB150\uB151\uB154\uB155\uB158\uB15C\uB160\uB178\uB179\uB17C\uB180\uB182\uB188\uB189\uB18B\uB18D\uB192\uB193\uB194\uB198\uB19C\uB1A8\uB1CC\uB1D0\uB1D4\uB1DC\uB1DD"],["b441","\uD02E",5,"\uD036\uD037\uD039\uD03A\uD03B\uD03D",6,"\uD046\uD048\uD04A",5],["b461","\uD051\uD052\uD053\uD055\uD056\uD057\uD059",6,"\uD061",10,"\uD06E\uD06F"],["b481","\uD071\uD072\uD073\uD075",6,"\uD07E\uD07F\uD080\uD082",18,"\uB1DF\uB1E8\uB1E9\uB1EC\uB1F0\uB1F9\uB1FB\uB1FD\uB204\uB205\uB208\uB20B\uB20C\uB214\uB215\uB217\uB219\uB220\uB234\uB23C\uB258\uB25C\uB260\uB268\uB269\uB274\uB275\uB27C\uB284\uB285\uB289\uB290\uB291\uB294\uB298\uB299\uB29A\uB2A0\uB2A1\uB2A3\uB2A5\uB2A6\uB2AA\uB2AC\uB2B0\uB2B4\uB2C8\uB2C9\uB2CC\uB2D0\uB2D2\uB2D8\uB2D9\uB2DB\uB2DD\uB2E2\uB2E4\uB2E5\uB2E6\uB2E8\uB2EB",4,"\uB2F3\uB2F4\uB2F5\uB2F7",4,"\uB2FF\uB300\uB301\uB304\uB308\uB310\uB311\uB313\uB314\uB315\uB31C\uB354\uB355\uB356\uB358\uB35B\uB35C\uB35E\uB35F\uB364\uB365"],["b541","\uD095",14,"\uD0A6\uD0A7\uD0A9\uD0AA\uD0AB\uD0AD",5],["b561","\uD0B3\uD0B6\uD0B8\uD0BA",5,"\uD0C2\uD0C3\uD0C5\uD0C6\uD0C7\uD0CA",5,"\uD0D2\uD0D6",4],["b581","\uD0DB\uD0DE\uD0DF\uD0E1\uD0E2\uD0E3\uD0E5",6,"\uD0EE\uD0F2",5,"\uD0F9",11,"\uB367\uB369\uB36B\uB36E\uB370\uB371\uB374\uB378\uB380\uB381\uB383\uB384\uB385\uB38C\uB390\uB394\uB3A0\uB3A1\uB3A8\uB3AC\uB3C4\uB3C5\uB3C8\uB3CB\uB3CC\uB3CE\uB3D0\uB3D4\uB3D5\uB3D7\uB3D9\uB3DB\uB3DD\uB3E0\uB3E4\uB3E8\uB3FC\uB410\uB418\uB41C\uB420\uB428\uB429\uB42B\uB434\uB450\uB451\uB454\uB458\uB460\uB461\uB463\uB465\uB46C\uB480\uB488\uB49D\uB4A4\uB4A8\uB4AC\uB4B5\uB4B7\uB4B9\uB4C0\uB4C4\uB4C8\uB4D0\uB4D5\uB4DC\uB4DD\uB4E0\uB4E3\uB4E4\uB4E6\uB4EC\uB4ED\uB4EF\uB4F1\uB4F8\uB514\uB515\uB518\uB51B\uB51C\uB524\uB525\uB527\uB528\uB529\uB52A\uB530\uB531\uB534\uB538"],["b641","\uD105",7,"\uD10E",17],["b661","\uD120",15,"\uD132\uD133\uD135\uD136\uD137\uD139\uD13B\uD13C\uD13D\uD13E"],["b681","\uD13F\uD142\uD146",5,"\uD14E\uD14F\uD151\uD152\uD153\uD155",6,"\uD15E\uD160\uD162",5,"\uD169\uD16A\uD16B\uD16D\uB540\uB541\uB543\uB544\uB545\uB54B\uB54C\uB54D\uB550\uB554\uB55C\uB55D\uB55F\uB560\uB561\uB5A0\uB5A1\uB5A4\uB5A8\uB5AA\uB5AB\uB5B0\uB5B1\uB5B3\uB5B4\uB5B5\uB5BB\uB5BC\uB5BD\uB5C0\uB5C4\uB5CC\uB5CD\uB5CF\uB5D0\uB5D1\uB5D8\uB5EC\uB610\uB611\uB614\uB618\uB625\uB62C\uB634\uB648\uB664\uB668\uB69C\uB69D\uB6A0\uB6A4\uB6AB\uB6AC\uB6B1\uB6D4\uB6F0\uB6F4\uB6F8\uB700\uB701\uB705\uB728\uB729\uB72C\uB72F\uB730\uB738\uB739\uB73B\uB744\uB748\uB74C\uB754\uB755\uB760\uB764\uB768\uB770\uB771\uB773\uB775\uB77C\uB77D\uB780\uB784\uB78C\uB78D\uB78F\uB790\uB791\uB792\uB796\uB797"],["b741","\uD16E",13,"\uD17D",6,"\uD185\uD186\uD187\uD189\uD18A"],["b761","\uD18B",20,"\uD1A2\uD1A3\uD1A5\uD1A6\uD1A7"],["b781","\uD1A9",6,"\uD1B2\uD1B4\uD1B6\uD1B7\uD1B8\uD1B9\uD1BB\uD1BD\uD1BE\uD1BF\uD1C1",14,"\uB798\uB799\uB79C\uB7A0\uB7A8\uB7A9\uB7AB\uB7AC\uB7AD\uB7B4\uB7B5\uB7B8\uB7C7\uB7C9\uB7EC\uB7ED\uB7F0\uB7F4\uB7FC\uB7FD\uB7FF\uB800\uB801\uB807\uB808\uB809\uB80C\uB810\uB818\uB819\uB81B\uB81D\uB824\uB825\uB828\uB82C\uB834\uB835\uB837\uB838\uB839\uB840\uB844\uB851\uB853\uB85C\uB85D\uB860\uB864\uB86C\uB86D\uB86F\uB871\uB878\uB87C\uB88D\uB8A8\uB8B0\uB8B4\uB8B8\uB8C0\uB8C1\uB8C3\uB8C5\uB8CC\uB8D0\uB8D4\uB8DD\uB8DF\uB8E1\uB8E8\uB8E9\uB8EC\uB8F0\uB8F8\uB8F9\uB8FB\uB8FD\uB904\uB918\uB920\uB93C\uB93D\uB940\uB944\uB94C\uB94F\uB951\uB958\uB959\uB95C\uB960\uB968\uB969"],["b841","\uD1D0",7,"\uD1D9",17],["b861","\uD1EB",8,"\uD1F5\uD1F6\uD1F7\uD1F9",13],["b881","\uD208\uD20A",5,"\uD211",24,"\uB96B\uB96D\uB974\uB975\uB978\uB97C\uB984\uB985\uB987\uB989\uB98A\uB98D\uB98E\uB9AC\uB9AD\uB9B0\uB9B4\uB9BC\uB9BD\uB9BF\uB9C1\uB9C8\uB9C9\uB9CC\uB9CE",4,"\uB9D8\uB9D9\uB9DB\uB9DD\uB9DE\uB9E1\uB9E3\uB9E4\uB9E5\uB9E8\uB9EC\uB9F4\uB9F5\uB9F7\uB9F8\uB9F9\uB9FA\uBA00\uBA01\uBA08\uBA15\uBA38\uBA39\uBA3C\uBA40\uBA42\uBA48\uBA49\uBA4B\uBA4D\uBA4E\uBA53\uBA54\uBA55\uBA58\uBA5C\uBA64\uBA65\uBA67\uBA68\uBA69\uBA70\uBA71\uBA74\uBA78\uBA83\uBA84\uBA85\uBA87\uBA8C\uBAA8\uBAA9\uBAAB\uBAAC\uBAB0\uBAB2\uBAB8\uBAB9\uBABB\uBABD\uBAC4\uBAC8\uBAD8\uBAD9\uBAFC"],["b941","\uD22A\uD22B\uD22E\uD22F\uD231\uD232\uD233\uD235",6,"\uD23E\uD240\uD242",5,"\uD249\uD24A\uD24B\uD24C"],["b961","\uD24D",14,"\uD25D",6,"\uD265\uD266\uD267\uD268"],["b981","\uD269",22,"\uD282\uD283\uD285\uD286\uD287\uD289\uD28A\uD28B\uD28C\uBB00\uBB04\uBB0D\uBB0F\uBB11\uBB18\uBB1C\uBB20\uBB29\uBB2B\uBB34\uBB35\uBB36\uBB38\uBB3B\uBB3C\uBB3D\uBB3E\uBB44\uBB45\uBB47\uBB49\uBB4D\uBB4F\uBB50\uBB54\uBB58\uBB61\uBB63\uBB6C\uBB88\uBB8C\uBB90\uBBA4\uBBA8\uBBAC\uBBB4\uBBB7\uBBC0\uBBC4\uBBC8\uBBD0\uBBD3\uBBF8\uBBF9\uBBFC\uBBFF\uBC00\uBC02\uBC08\uBC09\uBC0B\uBC0C\uBC0D\uBC0F\uBC11\uBC14",4,"\uBC1B",4,"\uBC24\uBC25\uBC27\uBC29\uBC2D\uBC30\uBC31\uBC34\uBC38\uBC40\uBC41\uBC43\uBC44\uBC45\uBC49\uBC4C\uBC4D\uBC50\uBC5D\uBC84\uBC85\uBC88\uBC8B\uBC8C\uBC8E\uBC94\uBC95\uBC97"],["ba41","\uD28D\uD28E\uD28F\uD292\uD293\uD294\uD296",5,"\uD29D\uD29E\uD29F\uD2A1\uD2A2\uD2A3\uD2A5",6,"\uD2AD"],["ba61","\uD2AE\uD2AF\uD2B0\uD2B2",5,"\uD2BA\uD2BB\uD2BD\uD2BE\uD2C1\uD2C3",4,"\uD2CA\uD2CC",5],["ba81","\uD2D2\uD2D3\uD2D5\uD2D6\uD2D7\uD2D9\uD2DA\uD2DB\uD2DD",6,"\uD2E6",9,"\uD2F2\uD2F3\uD2F5\uD2F6\uD2F7\uD2F9\uD2FA\uBC99\uBC9A\uBCA0\uBCA1\uBCA4\uBCA7\uBCA8\uBCB0\uBCB1\uBCB3\uBCB4\uBCB5\uBCBC\uBCBD\uBCC0\uBCC4\uBCCD\uBCCF\uBCD0\uBCD1\uBCD5\uBCD8\uBCDC\uBCF4\uBCF5\uBCF6\uBCF8\uBCFC\uBD04\uBD05\uBD07\uBD09\uBD10\uBD14\uBD24\uBD2C\uBD40\uBD48\uBD49\uBD4C\uBD50\uBD58\uBD59\uBD64\uBD68\uBD80\uBD81\uBD84\uBD87\uBD88\uBD89\uBD8A\uBD90\uBD91\uBD93\uBD95\uBD99\uBD9A\uBD9C\uBDA4\uBDB0\uBDB8\uBDD4\uBDD5\uBDD8\uBDDC\uBDE9\uBDF0\uBDF4\uBDF8\uBE00\uBE03\uBE05\uBE0C\uBE0D\uBE10\uBE14\uBE1C\uBE1D\uBE1F\uBE44\uBE45\uBE48\uBE4C\uBE4E\uBE54\uBE55\uBE57\uBE59\uBE5A\uBE5B\uBE60\uBE61\uBE64"],["bb41","\uD2FB",4,"\uD302\uD304\uD306",5,"\uD30F\uD311\uD312\uD313\uD315\uD317",4,"\uD31E\uD322\uD323"],["bb61","\uD324\uD326\uD327\uD32A\uD32B\uD32D\uD32E\uD32F\uD331",6,"\uD33A\uD33E",5,"\uD346\uD347\uD348\uD349"],["bb81","\uD34A",31,"\uBE68\uBE6A\uBE70\uBE71\uBE73\uBE74\uBE75\uBE7B\uBE7C\uBE7D\uBE80\uBE84\uBE8C\uBE8D\uBE8F\uBE90\uBE91\uBE98\uBE99\uBEA8\uBED0\uBED1\uBED4\uBED7\uBED8\uBEE0\uBEE3\uBEE4\uBEE5\uBEEC\uBF01\uBF08\uBF09\uBF18\uBF19\uBF1B\uBF1C\uBF1D\uBF40\uBF41\uBF44\uBF48\uBF50\uBF51\uBF55\uBF94\uBFB0\uBFC5\uBFCC\uBFCD\uBFD0\uBFD4\uBFDC\uBFDF\uBFE1\uC03C\uC051\uC058\uC05C\uC060\uC068\uC069\uC090\uC091\uC094\uC098\uC0A0\uC0A1\uC0A3\uC0A5\uC0AC\uC0AD\uC0AF\uC0B0\uC0B3\uC0B4\uC0B5\uC0B6\uC0BC\uC0BD\uC0BF\uC0C0\uC0C1\uC0C5\uC0C8\uC0C9\uC0CC\uC0D0\uC0D8\uC0D9\uC0DB\uC0DC\uC0DD\uC0E4"],["bc41","\uD36A",17,"\uD37E\uD37F\uD381\uD382\uD383\uD385\uD386\uD387"],["bc61","\uD388\uD389\uD38A\uD38B\uD38E\uD392",5,"\uD39A\uD39B\uD39D\uD39E\uD39F\uD3A1",6,"\uD3AA\uD3AC\uD3AE"],["bc81","\uD3AF",4,"\uD3B5\uD3B6\uD3B7\uD3B9\uD3BA\uD3BB\uD3BD",6,"\uD3C6\uD3C7\uD3CA",5,"\uD3D1",5,"\uC0E5\uC0E8\uC0EC\uC0F4\uC0F5\uC0F7\uC0F9\uC100\uC104\uC108\uC110\uC115\uC11C",4,"\uC123\uC124\uC126\uC127\uC12C\uC12D\uC12F\uC130\uC131\uC136\uC138\uC139\uC13C\uC140\uC148\uC149\uC14B\uC14C\uC14D\uC154\uC155\uC158\uC15C\uC164\uC165\uC167\uC168\uC169\uC170\uC174\uC178\uC185\uC18C\uC18D\uC18E\uC190\uC194\uC196\uC19C\uC19D\uC19F\uC1A1\uC1A5\uC1A8\uC1A9\uC1AC\uC1B0\uC1BD\uC1C4\uC1C8\uC1CC\uC1D4\uC1D7\uC1D8\uC1E0\uC1E4\uC1E8\uC1F0\uC1F1\uC1F3\uC1FC\uC1FD\uC200\uC204\uC20C\uC20D\uC20F\uC211\uC218\uC219\uC21C\uC21F\uC220\uC228\uC229\uC22B\uC22D"],["bd41","\uD3D7\uD3D9",7,"\uD3E2\uD3E4",7,"\uD3EE\uD3EF\uD3F1\uD3F2\uD3F3\uD3F5\uD3F6\uD3F7"],["bd61","\uD3F8\uD3F9\uD3FA\uD3FB\uD3FE\uD400\uD402",5,"\uD409",13],["bd81","\uD417",5,"\uD41E",25,"\uC22F\uC231\uC232\uC234\uC248\uC250\uC251\uC254\uC258\uC260\uC265\uC26C\uC26D\uC270\uC274\uC27C\uC27D\uC27F\uC281\uC288\uC289\uC290\uC298\uC29B\uC29D\uC2A4\uC2A5\uC2A8\uC2AC\uC2AD\uC2B4\uC2B5\uC2B7\uC2B9\uC2DC\uC2DD\uC2E0\uC2E3\uC2E4\uC2EB\uC2EC\uC2ED\uC2EF\uC2F1\uC2F6\uC2F8\uC2F9\uC2FB\uC2FC\uC300\uC308\uC309\uC30C\uC30D\uC313\uC314\uC315\uC318\uC31C\uC324\uC325\uC328\uC329\uC345\uC368\uC369\uC36C\uC370\uC372\uC378\uC379\uC37C\uC37D\uC384\uC388\uC38C\uC3C0\uC3D8\uC3D9\uC3DC\uC3DF\uC3E0\uC3E2\uC3E8\uC3E9\uC3ED\uC3F4\uC3F5\uC3F8\uC408\uC410\uC424\uC42C\uC430"],["be41","\uD438",7,"\uD441\uD442\uD443\uD445",14],["be61","\uD454",7,"\uD45D\uD45E\uD45F\uD461\uD462\uD463\uD465",7,"\uD46E\uD470\uD471\uD472"],["be81","\uD473",4,"\uD47A\uD47B\uD47D\uD47E\uD481\uD483",4,"\uD48A\uD48C\uD48E",5,"\uD495",8,"\uC434\uC43C\uC43D\uC448\uC464\uC465\uC468\uC46C\uC474\uC475\uC479\uC480\uC494\uC49C\uC4B8\uC4BC\uC4E9\uC4F0\uC4F1\uC4F4\uC4F8\uC4FA\uC4FF\uC500\uC501\uC50C\uC510\uC514\uC51C\uC528\uC529\uC52C\uC530\uC538\uC539\uC53B\uC53D\uC544\uC545\uC548\uC549\uC54A\uC54C\uC54D\uC54E\uC553\uC554\uC555\uC557\uC558\uC559\uC55D\uC55E\uC560\uC561\uC564\uC568\uC570\uC571\uC573\uC574\uC575\uC57C\uC57D\uC580\uC584\uC587\uC58C\uC58D\uC58F\uC591\uC595\uC597\uC598\uC59C\uC5A0\uC5A9\uC5B4\uC5B5\uC5B8\uC5B9\uC5BB\uC5BC\uC5BD\uC5BE\uC5C4",6,"\uC5CC\uC5CE"],["bf41","\uD49E",10,"\uD4AA",14],["bf61","\uD4B9",18,"\uD4CD\uD4CE\uD4CF\uD4D1\uD4D2\uD4D3\uD4D5"],["bf81","\uD4D6",5,"\uD4DD\uD4DE\uD4E0",7,"\uD4E9\uD4EA\uD4EB\uD4ED\uD4EE\uD4EF\uD4F1",6,"\uD4F9\uD4FA\uD4FC\uC5D0\uC5D1\uC5D4\uC5D8\uC5E0\uC5E1\uC5E3\uC5E5\uC5EC\uC5ED\uC5EE\uC5F0\uC5F4\uC5F6\uC5F7\uC5FC",5,"\uC605\uC606\uC607\uC608\uC60C\uC610\uC618\uC619\uC61B\uC61C\uC624\uC625\uC628\uC62C\uC62D\uC62E\uC630\uC633\uC634\uC635\uC637\uC639\uC63B\uC640\uC641\uC644\uC648\uC650\uC651\uC653\uC654\uC655\uC65C\uC65D\uC660\uC66C\uC66F\uC671\uC678\uC679\uC67C\uC680\uC688\uC689\uC68B\uC68D\uC694\uC695\uC698\uC69C\uC6A4\uC6A5\uC6A7\uC6A9\uC6B0\uC6B1\uC6B4\uC6B8\uC6B9\uC6BA\uC6C0\uC6C1\uC6C3\uC6C5\uC6CC\uC6CD\uC6D0\uC6D4\uC6DC\uC6DD\uC6E0\uC6E1\uC6E8"],["c041","\uD4FE",5,"\uD505\uD506\uD507\uD509\uD50A\uD50B\uD50D",6,"\uD516\uD518",5],["c061","\uD51E",25],["c081","\uD538\uD539\uD53A\uD53B\uD53E\uD53F\uD541\uD542\uD543\uD545",6,"\uD54E\uD550\uD552",5,"\uD55A\uD55B\uD55D\uD55E\uD55F\uD561\uD562\uD563\uC6E9\uC6EC\uC6F0\uC6F8\uC6F9\uC6FD\uC704\uC705\uC708\uC70C\uC714\uC715\uC717\uC719\uC720\uC721\uC724\uC728\uC730\uC731\uC733\uC735\uC737\uC73C\uC73D\uC740\uC744\uC74A\uC74C\uC74D\uC74F\uC751",7,"\uC75C\uC760\uC768\uC76B\uC774\uC775\uC778\uC77C\uC77D\uC77E\uC783\uC784\uC785\uC787\uC788\uC789\uC78A\uC78E\uC790\uC791\uC794\uC796\uC797\uC798\uC79A\uC7A0\uC7A1\uC7A3\uC7A4\uC7A5\uC7A6\uC7AC\uC7AD\uC7B0\uC7B4\uC7BC\uC7BD\uC7BF\uC7C0\uC7C1\uC7C8\uC7C9\uC7CC\uC7CE\uC7D0\uC7D8\uC7DD\uC7E4\uC7E8\uC7EC\uC800\uC801\uC804\uC808\uC80A"],["c141","\uD564\uD566\uD567\uD56A\uD56C\uD56E",5,"\uD576\uD577\uD579\uD57A\uD57B\uD57D",6,"\uD586\uD58A\uD58B"],["c161","\uD58C\uD58D\uD58E\uD58F\uD591",19,"\uD5A6\uD5A7"],["c181","\uD5A8",31,"\uC810\uC811\uC813\uC815\uC816\uC81C\uC81D\uC820\uC824\uC82C\uC82D\uC82F\uC831\uC838\uC83C\uC840\uC848\uC849\uC84C\uC84D\uC854\uC870\uC871\uC874\uC878\uC87A\uC880\uC881\uC883\uC885\uC886\uC887\uC88B\uC88C\uC88D\uC894\uC89D\uC89F\uC8A1\uC8A8\uC8BC\uC8BD\uC8C4\uC8C8\uC8CC\uC8D4\uC8D5\uC8D7\uC8D9\uC8E0\uC8E1\uC8E4\uC8F5\uC8FC\uC8FD\uC900\uC904\uC905\uC906\uC90C\uC90D\uC90F\uC911\uC918\uC92C\uC934\uC950\uC951\uC954\uC958\uC960\uC961\uC963\uC96C\uC970\uC974\uC97C\uC988\uC989\uC98C\uC990\uC998\uC999\uC99B\uC99D\uC9C0\uC9C1\uC9C4\uC9C7\uC9C8\uC9CA\uC9D0\uC9D1\uC9D3"],["c241","\uD5CA\uD5CB\uD5CD\uD5CE\uD5CF\uD5D1\uD5D3",4,"\uD5DA\uD5DC\uD5DE",5,"\uD5E6\uD5E7\uD5E9\uD5EA\uD5EB\uD5ED\uD5EE"],["c261","\uD5EF",4,"\uD5F6\uD5F8\uD5FA",5,"\uD602\uD603\uD605\uD606\uD607\uD609",6,"\uD612"],["c281","\uD616",5,"\uD61D\uD61E\uD61F\uD621\uD622\uD623\uD625",7,"\uD62E",9,"\uD63A\uD63B\uC9D5\uC9D6\uC9D9\uC9DA\uC9DC\uC9DD\uC9E0\uC9E2\uC9E4\uC9E7\uC9EC\uC9ED\uC9EF\uC9F0\uC9F1\uC9F8\uC9F9\uC9FC\uCA00\uCA08\uCA09\uCA0B\uCA0C\uCA0D\uCA14\uCA18\uCA29\uCA4C\uCA4D\uCA50\uCA54\uCA5C\uCA5D\uCA5F\uCA60\uCA61\uCA68\uCA7D\uCA84\uCA98\uCABC\uCABD\uCAC0\uCAC4\uCACC\uCACD\uCACF\uCAD1\uCAD3\uCAD8\uCAD9\uCAE0\uCAEC\uCAF4\uCB08\uCB10\uCB14\uCB18\uCB20\uCB21\uCB41\uCB48\uCB49\uCB4C\uCB50\uCB58\uCB59\uCB5D\uCB64\uCB78\uCB79\uCB9C\uCBB8\uCBD4\uCBE4\uCBE7\uCBE9\uCC0C\uCC0D\uCC10\uCC14\uCC1C\uCC1D\uCC21\uCC22\uCC27\uCC28\uCC29\uCC2C\uCC2E\uCC30\uCC38\uCC39\uCC3B"],["c341","\uD63D\uD63E\uD63F\uD641\uD642\uD643\uD644\uD646\uD647\uD64A\uD64C\uD64E\uD64F\uD650\uD652\uD653\uD656\uD657\uD659\uD65A\uD65B\uD65D",4],["c361","\uD662",4,"\uD668\uD66A",5,"\uD672\uD673\uD675",11],["c381","\uD681\uD682\uD684\uD686",5,"\uD68E\uD68F\uD691\uD692\uD693\uD695",7,"\uD69E\uD6A0\uD6A2",5,"\uD6A9\uD6AA\uCC3C\uCC3D\uCC3E\uCC44\uCC45\uCC48\uCC4C\uCC54\uCC55\uCC57\uCC58\uCC59\uCC60\uCC64\uCC66\uCC68\uCC70\uCC75\uCC98\uCC99\uCC9C\uCCA0\uCCA8\uCCA9\uCCAB\uCCAC\uCCAD\uCCB4\uCCB5\uCCB8\uCCBC\uCCC4\uCCC5\uCCC7\uCCC9\uCCD0\uCCD4\uCCE4\uCCEC\uCCF0\uCD01\uCD08\uCD09\uCD0C\uCD10\uCD18\uCD19\uCD1B\uCD1D\uCD24\uCD28\uCD2C\uCD39\uCD5C\uCD60\uCD64\uCD6C\uCD6D\uCD6F\uCD71\uCD78\uCD88\uCD94\uCD95\uCD98\uCD9C\uCDA4\uCDA5\uCDA7\uCDA9\uCDB0\uCDC4\uCDCC\uCDD0\uCDE8\uCDEC\uCDF0\uCDF8\uCDF9\uCDFB\uCDFD\uCE04\uCE08\uCE0C\uCE14\uCE19\uCE20\uCE21\uCE24\uCE28\uCE30\uCE31\uCE33\uCE35"],["c441","\uD6AB\uD6AD\uD6AE\uD6AF\uD6B1",7,"\uD6BA\uD6BC",7,"\uD6C6\uD6C7\uD6C9\uD6CA\uD6CB"],["c461","\uD6CD\uD6CE\uD6CF\uD6D0\uD6D2\uD6D3\uD6D5\uD6D6\uD6D8\uD6DA",5,"\uD6E1\uD6E2\uD6E3\uD6E5\uD6E6\uD6E7\uD6E9",4],["c481","\uD6EE\uD6EF\uD6F1\uD6F2\uD6F3\uD6F4\uD6F6",5,"\uD6FE\uD6FF\uD701\uD702\uD703\uD705",11,"\uD712\uD713\uD714\uCE58\uCE59\uCE5C\uCE5F\uCE60\uCE61\uCE68\uCE69\uCE6B\uCE6D\uCE74\uCE75\uCE78\uCE7C\uCE84\uCE85\uCE87\uCE89\uCE90\uCE91\uCE94\uCE98\uCEA0\uCEA1\uCEA3\uCEA4\uCEA5\uCEAC\uCEAD\uCEC1\uCEE4\uCEE5\uCEE8\uCEEB\uCEEC\uCEF4\uCEF5\uCEF7\uCEF8\uCEF9\uCF00\uCF01\uCF04\uCF08\uCF10\uCF11\uCF13\uCF15\uCF1C\uCF20\uCF24\uCF2C\uCF2D\uCF2F\uCF30\uCF31\uCF38\uCF54\uCF55\uCF58\uCF5C\uCF64\uCF65\uCF67\uCF69\uCF70\uCF71\uCF74\uCF78\uCF80\uCF85\uCF8C\uCFA1\uCFA8\uCFB0\uCFC4\uCFE0\uCFE1\uCFE4\uCFE8\uCFF0\uCFF1\uCFF3\uCFF5\uCFFC\uD000\uD004\uD011\uD018\uD02D\uD034\uD035\uD038\uD03C"],["c541","\uD715\uD716\uD717\uD71A\uD71B\uD71D\uD71E\uD71F\uD721",6,"\uD72A\uD72C\uD72E",5,"\uD736\uD737\uD739"],["c561","\uD73A\uD73B\uD73D",6,"\uD745\uD746\uD748\uD74A",5,"\uD752\uD753\uD755\uD75A",4],["c581","\uD75F\uD762\uD764\uD766\uD767\uD768\uD76A\uD76B\uD76D\uD76E\uD76F\uD771\uD772\uD773\uD775",6,"\uD77E\uD77F\uD780\uD782",5,"\uD78A\uD78B\uD044\uD045\uD047\uD049\uD050\uD054\uD058\uD060\uD06C\uD06D\uD070\uD074\uD07C\uD07D\uD081\uD0A4\uD0A5\uD0A8\uD0AC\uD0B4\uD0B5\uD0B7\uD0B9\uD0C0\uD0C1\uD0C4\uD0C8\uD0C9\uD0D0\uD0D1\uD0D3\uD0D4\uD0D5\uD0DC\uD0DD\uD0E0\uD0E4\uD0EC\uD0ED\uD0EF\uD0F0\uD0F1\uD0F8\uD10D\uD130\uD131\uD134\uD138\uD13A\uD140\uD141\uD143\uD144\uD145\uD14C\uD14D\uD150\uD154\uD15C\uD15D\uD15F\uD161\uD168\uD16C\uD17C\uD184\uD188\uD1A0\uD1A1\uD1A4\uD1A8\uD1B0\uD1B1\uD1B3\uD1B5\uD1BA\uD1BC\uD1C0\uD1D8\uD1F4\uD1F8\uD207\uD209\uD210\uD22C\uD22D\uD230\uD234\uD23C\uD23D\uD23F\uD241\uD248\uD25C"],["c641","\uD78D\uD78E\uD78F\uD791",6,"\uD79A\uD79C\uD79E",5],["c6a1","\uD264\uD280\uD281\uD284\uD288\uD290\uD291\uD295\uD29C\uD2A0\uD2A4\uD2AC\uD2B1\uD2B8\uD2B9\uD2BC\uD2BF\uD2C0\uD2C2\uD2C8\uD2C9\uD2CB\uD2D4\uD2D8\uD2DC\uD2E4\uD2E5\uD2F0\uD2F1\uD2F4\uD2F8\uD300\uD301\uD303\uD305\uD30C\uD30D\uD30E\uD310\uD314\uD316\uD31C\uD31D\uD31F\uD320\uD321\uD325\uD328\uD329\uD32C\uD330\uD338\uD339\uD33B\uD33C\uD33D\uD344\uD345\uD37C\uD37D\uD380\uD384\uD38C\uD38D\uD38F\uD390\uD391\uD398\uD399\uD39C\uD3A0\uD3A8\uD3A9\uD3AB\uD3AD\uD3B4\uD3B8\uD3BC\uD3C4\uD3C5\uD3C8\uD3C9\uD3D0\uD3D8\uD3E1\uD3E3\uD3EC\uD3ED\uD3F0\uD3F4\uD3FC\uD3FD\uD3FF\uD401"],["c7a1","\uD408\uD41D\uD440\uD444\uD45C\uD460\uD464\uD46D\uD46F\uD478\uD479\uD47C\uD47F\uD480\uD482\uD488\uD489\uD48B\uD48D\uD494\uD4A9\uD4CC\uD4D0\uD4D4\uD4DC\uD4DF\uD4E8\uD4EC\uD4F0\uD4F8\uD4FB\uD4FD\uD504\uD508\uD50C\uD514\uD515\uD517\uD53C\uD53D\uD540\uD544\uD54C\uD54D\uD54F\uD551\uD558\uD559\uD55C\uD560\uD565\uD568\uD569\uD56B\uD56D\uD574\uD575\uD578\uD57C\uD584\uD585\uD587\uD588\uD589\uD590\uD5A5\uD5C8\uD5C9\uD5CC\uD5D0\uD5D2\uD5D8\uD5D9\uD5DB\uD5DD\uD5E4\uD5E5\uD5E8\uD5EC\uD5F4\uD5F5\uD5F7\uD5F9\uD600\uD601\uD604\uD608\uD610\uD611\uD613\uD614\uD615\uD61C\uD620"],["c8a1","\uD624\uD62D\uD638\uD639\uD63C\uD640\uD645\uD648\uD649\uD64B\uD64D\uD651\uD654\uD655\uD658\uD65C\uD667\uD669\uD670\uD671\uD674\uD683\uD685\uD68C\uD68D\uD690\uD694\uD69D\uD69F\uD6A1\uD6A8\uD6AC\uD6B0\uD6B9\uD6BB\uD6C4\uD6C5\uD6C8\uD6CC\uD6D1\uD6D4\uD6D7\uD6D9\uD6E0\uD6E4\uD6E8\uD6F0\uD6F5\uD6FC\uD6FD\uD700\uD704\uD711\uD718\uD719\uD71C\uD720\uD728\uD729\uD72B\uD72D\uD734\uD735\uD738\uD73C\uD744\uD747\uD749\uD750\uD751\uD754\uD756\uD757\uD758\uD759\uD760\uD761\uD763\uD765\uD769\uD76C\uD770\uD774\uD77C\uD77D\uD781\uD788\uD789\uD78C\uD790\uD798\uD799\uD79B\uD79D"],["caa1","\u4F3D\u4F73\u5047\u50F9\u52A0\u53EF\u5475\u54E5\u5609\u5AC1\u5BB6\u6687\u67B6\u67B7\u67EF\u6B4C\u73C2\u75C2\u7A3C\u82DB\u8304\u8857\u8888\u8A36\u8CC8\u8DCF\u8EFB\u8FE6\u99D5\u523B\u5374\u5404\u606A\u6164\u6BBC\u73CF\u811A\u89BA\u89D2\u95A3\u4F83\u520A\u58BE\u5978\u59E6\u5E72\u5E79\u61C7\u63C0\u6746\u67EC\u687F\u6F97\u764E\u770B\u78F5\u7A08\u7AFF\u7C21\u809D\u826E\u8271\u8AEB\u9593\u4E6B\u559D\u66F7\u6E34\u78A3\u7AED\u845B\u8910\u874E\u97A8\u52D8\u574E\u582A\u5D4C\u611F\u61BE\u6221\u6562\u67D1\u6A44\u6E1B\u7518\u75B3\u76E3\u77B0\u7D3A\u90AF\u9451\u9452\u9F95"],["cba1","\u5323\u5CAC\u7532\u80DB\u9240\u9598\u525B\u5808\u59DC\u5CA1\u5D17\u5EB7\u5F3A\u5F4A\u6177\u6C5F\u757A\u7586\u7CE0\u7D73\u7DB1\u7F8C\u8154\u8221\u8591\u8941\u8B1B\u92FC\u964D\u9C47\u4ECB\u4EF7\u500B\u51F1\u584F\u6137\u613E\u6168\u6539\u69EA\u6F11\u75A5\u7686\u76D6\u7B87\u82A5\u84CB\uF900\u93A7\u958B\u5580\u5BA2\u5751\uF901\u7CB3\u7FB9\u91B5\u5028\u53BB\u5C45\u5DE8\u62D2\u636E\u64DA\u64E7\u6E20\u70AC\u795B\u8DDD\u8E1E\uF902\u907D\u9245\u92F8\u4E7E\u4EF6\u5065\u5DFE\u5EFA\u6106\u6957\u8171\u8654\u8E47\u9375\u9A2B\u4E5E\u5091\u6770\u6840\u5109\u528D\u5292\u6AA2"],["cca1","\u77BC\u9210\u9ED4\u52AB\u602F\u8FF2\u5048\u61A9\u63ED\u64CA\u683C\u6A84\u6FC0\u8188\u89A1\u9694\u5805\u727D\u72AC\u7504\u7D79\u7E6D\u80A9\u898B\u8B74\u9063\u9D51\u6289\u6C7A\u6F54\u7D50\u7F3A\u8A23\u517C\u614A\u7B9D\u8B19\u9257\u938C\u4EAC\u4FD3\u501E\u50BE\u5106\u52C1\u52CD\u537F\u5770\u5883\u5E9A\u5F91\u6176\u61AC\u64CE\u656C\u666F\u66BB\u66F4\u6897\u6D87\u7085\u70F1\u749F\u74A5\u74CA\u75D9\u786C\u78EC\u7ADF\u7AF6\u7D45\u7D93\u8015\u803F\u811B\u8396\u8B66\u8F15\u9015\u93E1\u9803\u9838\u9A5A\u9BE8\u4FC2\u5553\u583A\u5951\u5B63\u5C46\u60B8\u6212\u6842\u68B0"],["cda1","\u68E8\u6EAA\u754C\u7678\u78CE\u7A3D\u7CFB\u7E6B\u7E7C\u8A08\u8AA1\u8C3F\u968E\u9DC4\u53E4\u53E9\u544A\u5471\u56FA\u59D1\u5B64\u5C3B\u5EAB\u62F7\u6537\u6545\u6572\u66A0\u67AF\u69C1\u6CBD\u75FC\u7690\u777E\u7A3F\u7F94\u8003\u80A1\u818F\u82E6\u82FD\u83F0\u85C1\u8831\u88B4\u8AA5\uF903\u8F9C\u932E\u96C7\u9867\u9AD8\u9F13\u54ED\u659B\u66F2\u688F\u7A40\u8C37\u9D60\u56F0\u5764\u5D11\u6606\u68B1\u68CD\u6EFE\u7428\u889E\u9BE4\u6C68\uF904\u9AA8\u4F9B\u516C\u5171\u529F\u5B54\u5DE5\u6050\u606D\u62F1\u63A7\u653B\u73D9\u7A7A\u86A3\u8CA2\u978F\u4E32\u5BE1\u6208\u679C\u74DC"],["cea1","\u79D1\u83D3\u8A87\u8AB2\u8DE8\u904E\u934B\u9846\u5ED3\u69E8\u85FF\u90ED\uF905\u51A0\u5B98\u5BEC\u6163\u68FA\u6B3E\u704C\u742F\u74D8\u7BA1\u7F50\u83C5\u89C0\u8CAB\u95DC\u9928\u522E\u605D\u62EC\u9002\u4F8A\u5149\u5321\u58D9\u5EE3\u66E0\u6D38\u709A\u72C2\u73D6\u7B50\u80F1\u945B\u5366\u639B\u7F6B\u4E56\u5080\u584A\u58DE\u602A\u6127\u62D0\u69D0\u9B41\u5B8F\u7D18\u80B1\u8F5F\u4EA4\u50D1\u54AC\u55AC\u5B0C\u5DA0\u5DE7\u652A\u654E\u6821\u6A4B\u72E1\u768E\u77EF\u7D5E\u7FF9\u81A0\u854E\u86DF\u8F03\u8F4E\u90CA\u9903\u9A55\u9BAB\u4E18\u4E45\u4E5D\u4EC7\u4FF1\u5177\u52FE"],["cfa1","\u5340\u53E3\u53E5\u548E\u5614\u5775\u57A2\u5BC7\u5D87\u5ED0\u61FC\u62D8\u6551\u67B8\u67E9\u69CB\u6B50\u6BC6\u6BEC\u6C42\u6E9D\u7078\u72D7\u7396\u7403\u77BF\u77E9\u7A76\u7D7F\u8009\u81FC\u8205\u820A\u82DF\u8862\u8B33\u8CFC\u8EC0\u9011\u90B1\u9264\u92B6\u99D2\u9A45\u9CE9\u9DD7\u9F9C\u570B\u5C40\u83CA\u97A0\u97AB\u9EB4\u541B\u7A98\u7FA4\u88D9\u8ECD\u90E1\u5800\u5C48\u6398\u7A9F\u5BAE\u5F13\u7A79\u7AAE\u828E\u8EAC\u5026\u5238\u52F8\u5377\u5708\u62F3\u6372\u6B0A\u6DC3\u7737\u53A5\u7357\u8568\u8E76\u95D5\u673A\u6AC3\u6F70\u8A6D\u8ECC\u994B\uF906\u6677\u6B78\u8CB4"],["d0a1","\u9B3C\uF907\u53EB\u572D\u594E\u63C6\u69FB\u73EA\u7845\u7ABA\u7AC5\u7CFE\u8475\u898F\u8D73\u9035\u95A8\u52FB\u5747\u7547\u7B60\u83CC\u921E\uF908\u6A58\u514B\u524B\u5287\u621F\u68D8\u6975\u9699\u50C5\u52A4\u52E4\u61C3\u65A4\u6839\u69FF\u747E\u7B4B\u82B9\u83EB\u89B2\u8B39\u8FD1\u9949\uF909\u4ECA\u5997\u64D2\u6611\u6A8E\u7434\u7981\u79BD\u82A9\u887E\u887F\u895F\uF90A\u9326\u4F0B\u53CA\u6025\u6271\u6C72\u7D1A\u7D66\u4E98\u5162\u77DC\u80AF\u4F01\u4F0E\u5176\u5180\u55DC\u5668\u573B\u57FA\u57FC\u5914\u5947\u5993\u5BC4\u5C90\u5D0E\u5DF1\u5E7E\u5FCC\u6280\u65D7\u65E3"],["d1a1","\u671E\u671F\u675E\u68CB\u68C4\u6A5F\u6B3A\u6C23\u6C7D\u6C82\u6DC7\u7398\u7426\u742A\u7482\u74A3\u7578\u757F\u7881\u78EF\u7941\u7947\u7948\u797A\u7B95\u7D00\u7DBA\u7F88\u8006\u802D\u808C\u8A18\u8B4F\u8C48\u8D77\u9321\u9324\u98E2\u9951\u9A0E\u9A0F\u9A65\u9E92\u7DCA\u4F76\u5409\u62EE\u6854\u91D1\u55AB\u513A\uF90B\uF90C\u5A1C\u61E6\uF90D\u62CF\u62FF\uF90E",5,"\u90A3\uF914",4,"\u8AFE\uF919\uF91A\uF91B\uF91C\u6696\uF91D\u7156\uF91E\uF91F\u96E3\uF920\u634F\u637A\u5357\uF921\u678F\u6960\u6E73\uF922\u7537\uF923\uF924\uF925"],["d2a1","\u7D0D\uF926\uF927\u8872\u56CA\u5A18\uF928",4,"\u4E43\uF92D\u5167\u5948\u67F0\u8010\uF92E\u5973\u5E74\u649A\u79CA\u5FF5\u606C\u62C8\u637B\u5BE7\u5BD7\u52AA\uF92F\u5974\u5F29\u6012\uF930\uF931\uF932\u7459\uF933",5,"\u99D1\uF939",10,"\u6FC3\uF944\uF945\u81BF\u8FB2\u60F1\uF946\uF947\u8166\uF948\uF949\u5C3F\uF94A",7,"\u5AE9\u8A25\u677B\u7D10\uF952",5,"\u80FD\uF958\uF959\u5C3C\u6CE5\u533F\u6EBA\u591A\u8336"],["d3a1","\u4E39\u4EB6\u4F46\u55AE\u5718\u58C7\u5F56\u65B7\u65E6\u6A80\u6BB5\u6E4D\u77ED\u7AEF\u7C1E\u7DDE\u86CB\u8892\u9132\u935B\u64BB\u6FBE\u737A\u75B8\u9054\u5556\u574D\u61BA\u64D4\u66C7\u6DE1\u6E5B\u6F6D\u6FB9\u75F0\u8043\u81BD\u8541\u8983\u8AC7\u8B5A\u931F\u6C93\u7553\u7B54\u8E0F\u905D\u5510\u5802\u5858\u5E62\u6207\u649E\u68E0\u7576\u7CD6\u87B3\u9EE8\u4EE3\u5788\u576E\u5927\u5C0D\u5CB1\u5E36\u5F85\u6234\u64E1\u73B3\u81FA\u888B\u8CB8\u968A\u9EDB\u5B85\u5FB7\u60B3\u5012\u5200\u5230\u5716\u5835\u5857\u5C0E\u5C60\u5CF6\u5D8B\u5EA6\u5F92\u60BC\u6311\u6389\u6417\u6843"],["d4a1","\u68F9\u6AC2\u6DD8\u6E21\u6ED4\u6FE4\u71FE\u76DC\u7779\u79B1\u7A3B\u8404\u89A9\u8CED\u8DF3\u8E48\u9003\u9014\u9053\u90FD\u934D\u9676\u97DC\u6BD2\u7006\u7258\u72A2\u7368\u7763\u79BF\u7BE4\u7E9B\u8B80\u58A9\u60C7\u6566\u65FD\u66BE\u6C8C\u711E\u71C9\u8C5A\u9813\u4E6D\u7A81\u4EDD\u51AC\u51CD\u52D5\u540C\u61A7\u6771\u6850\u68DF\u6D1E\u6F7C\u75BC\u77B3\u7AE5\u80F4\u8463\u9285\u515C\u6597\u675C\u6793\u75D8\u7AC7\u8373\uF95A\u8C46\u9017\u982D\u5C6F\u81C0\u829A\u9041\u906F\u920D\u5F97\u5D9D\u6A59\u71C8\u767B\u7B49\u85E4\u8B04\u9127\u9A30\u5587\u61F6\uF95B\u7669\u7F85"],["d5a1","\u863F\u87BA\u88F8\u908F\uF95C\u6D1B\u70D9\u73DE\u7D61\u843D\uF95D\u916A\u99F1\uF95E\u4E82\u5375\u6B04\u6B12\u703E\u721B\u862D\u9E1E\u524C\u8FA3\u5D50\u64E5\u652C\u6B16\u6FEB\u7C43\u7E9C\u85CD\u8964\u89BD\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u7405\u746F\u8782\u90DE\u4F86\u5D0D\u5FA0\u840A\u51B7\u63A0\u7565\u4EAE\u5006\u5169\u51C9\u6881\u6A11\u7CAE\u7CB1\u7CE7\u826F\u8AD2\u8F1B\u91CF\u4FB6\u5137\u52F5\u5442\u5EEC\u616E\u623E\u65C5\u6ADA\u6FFE\u792A\u85DC\u8823\u95AD\u9A62\u9A6A\u9E97\u9ECE\u529B\u66C6\u6B77\u701D\u792B\u8F62\u9742\u6190\u6200\u6523\u6F23"],["d6a1","\u7149\u7489\u7DF4\u806F\u84EE\u8F26\u9023\u934A\u51BD\u5217\u52A3\u6D0C\u70C8\u88C2\u5EC9\u6582\u6BAE\u6FC2\u7C3E\u7375\u4EE4\u4F36\u56F9\uF95F\u5CBA\u5DBA\u601C\u73B2\u7B2D\u7F9A\u7FCE\u8046\u901E\u9234\u96F6\u9748\u9818\u9F61\u4F8B\u6FA7\u79AE\u91B4\u96B7\u52DE\uF960\u6488\u64C4\u6AD3\u6F5E\u7018\u7210\u76E7\u8001\u8606\u865C\u8DEF\u8F05\u9732\u9B6F\u9DFA\u9E75\u788C\u797F\u7DA0\u83C9\u9304\u9E7F\u9E93\u8AD6\u58DF\u5F04\u6727\u7027\u74CF\u7C60\u807E\u5121\u7028\u7262\u78CA\u8CC2\u8CDA\u8CF4\u96F7\u4E86\u50DA\u5BEE\u5ED6\u6599\u71CE\u7642\u77AD\u804A\u84FC"],["d7a1","\u907C\u9B27\u9F8D\u58D8\u5A41\u5C62\u6A13\u6DDA\u6F0F\u763B\u7D2F\u7E37\u851E\u8938\u93E4\u964B\u5289\u65D2\u67F3\u69B4\u6D41\u6E9C\u700F\u7409\u7460\u7559\u7624\u786B\u8B2C\u985E\u516D\u622E\u9678\u4F96\u502B\u5D19\u6DEA\u7DB8\u8F2A\u5F8B\u6144\u6817\uF961\u9686\u52D2\u808B\u51DC\u51CC\u695E\u7A1C\u7DBE\u83F1\u9675\u4FDA\u5229\u5398\u540F\u550E\u5C65\u60A7\u674E\u68A8\u6D6C\u7281\u72F8\u7406\u7483\uF962\u75E2\u7C6C\u7F79\u7FB8\u8389\u88CF\u88E1\u91CC\u91D0\u96E2\u9BC9\u541D\u6F7E\u71D0\u7498\u85FA\u8EAA\u96A3\u9C57\u9E9F\u6797\u6DCB\u7433\u81E8\u9716\u782C"],["d8a1","\u7ACB\u7B20\u7C92\u6469\u746A\u75F2\u78BC\u78E8\u99AC\u9B54\u9EBB\u5BDE\u5E55\u6F20\u819C\u83AB\u9088\u4E07\u534D\u5A29\u5DD2\u5F4E\u6162\u633D\u6669\u66FC\u6EFF\u6F2B\u7063\u779E\u842C\u8513\u883B\u8F13\u9945\u9C3B\u551C\u62B9\u672B\u6CAB\u8309\u896A\u977A\u4EA1\u5984\u5FD8\u5FD9\u671B\u7DB2\u7F54\u8292\u832B\u83BD\u8F1E\u9099\u57CB\u59B9\u5A92\u5BD0\u6627\u679A\u6885\u6BCF\u7164\u7F75\u8CB7\u8CE3\u9081\u9B45\u8108\u8C8A\u964C\u9A40\u9EA5\u5B5F\u6C13\u731B\u76F2\u76DF\u840C\u51AA\u8993\u514D\u5195\u52C9\u68C9\u6C94\u7704\u7720\u7DBF\u7DEC\u9762\u9EB5\u6EC5"],["d9a1","\u8511\u51A5\u540D\u547D\u660E\u669D\u6927\u6E9F\u76BF\u7791\u8317\u84C2\u879F\u9169\u9298\u9CF4\u8882\u4FAE\u5192\u52DF\u59C6\u5E3D\u6155\u6478\u6479\u66AE\u67D0\u6A21\u6BCD\u6BDB\u725F\u7261\u7441\u7738\u77DB\u8017\u82BC\u8305\u8B00\u8B28\u8C8C\u6728\u6C90\u7267\u76EE\u7766\u7A46\u9DA9\u6B7F\u6C92\u5922\u6726\u8499\u536F\u5893\u5999\u5EDF\u63CF\u6634\u6773\u6E3A\u732B\u7AD7\u82D7\u9328\u52D9\u5DEB\u61AE\u61CB\u620A\u62C7\u64AB\u65E0\u6959\u6B66\u6BCB\u7121\u73F7\u755D\u7E46\u821E\u8302\u856A\u8AA3\u8CBF\u9727\u9D61\u58A8\u9ED8\u5011\u520E\u543B\u554F\u6587"],["daa1","\u6C76\u7D0A\u7D0B\u805E\u868A\u9580\u96EF\u52FF\u6C95\u7269\u5473\u5A9A\u5C3E\u5D4B\u5F4C\u5FAE\u672A\u68B6\u6963\u6E3C\u6E44\u7709\u7C73\u7F8E\u8587\u8B0E\u8FF7\u9761\u9EF4\u5CB7\u60B6\u610D\u61AB\u654F\u65FB\u65FC\u6C11\u6CEF\u739F\u73C9\u7DE1\u9594\u5BC6\u871C\u8B10\u525D\u535A\u62CD\u640F\u64B2\u6734\u6A38\u6CCA\u73C0\u749E\u7B94\u7C95\u7E1B\u818A\u8236\u8584\u8FEB\u96F9\u99C1\u4F34\u534A\u53CD\u53DB\u62CC\u642C\u6500\u6591\u69C3\u6CEE\u6F58\u73ED\u7554\u7622\u76E4\u76FC\u78D0\u78FB\u792C\u7D46\u822C\u87E0\u8FD4\u9812\u98EF\u52C3\u62D4\u64A5\u6E24\u6F51"],["dba1","\u767C\u8DCB\u91B1\u9262\u9AEE\u9B43\u5023\u508D\u574A\u59A8\u5C28\u5E47\u5F77\u623F\u653E\u65B9\u65C1\u6609\u678B\u699C\u6EC2\u78C5\u7D21\u80AA\u8180\u822B\u82B3\u84A1\u868C\u8A2A\u8B17\u90A6\u9632\u9F90\u500D\u4FF3\uF963\u57F9\u5F98\u62DC\u6392\u676F\u6E43\u7119\u76C3\u80CC\u80DA\u88F4\u88F5\u8919\u8CE0\u8F29\u914D\u966A\u4F2F\u4F70\u5E1B\u67CF\u6822\u767D\u767E\u9B44\u5E61\u6A0A\u7169\u71D4\u756A\uF964\u7E41\u8543\u85E9\u98DC\u4F10\u7B4F\u7F70\u95A5\u51E1\u5E06\u68B5\u6C3E\u6C4E\u6CDB\u72AF\u7BC4\u8303\u6CD5\u743A\u50FB\u5288\u58C1\u64D8\u6A97\u74A7\u7656"],["dca1","\u78A7\u8617\u95E2\u9739\uF965\u535E\u5F01\u8B8A\u8FA8\u8FAF\u908A\u5225\u77A5\u9C49\u9F08\u4E19\u5002\u5175\u5C5B\u5E77\u661E\u663A\u67C4\u68C5\u70B3\u7501\u75C5\u79C9\u7ADD\u8F27\u9920\u9A08\u4FDD\u5821\u5831\u5BF6\u666E\u6B65\u6D11\u6E7A\u6F7D\u73E4\u752B\u83E9\u88DC\u8913\u8B5C\u8F14\u4F0F\u50D5\u5310\u535C\u5B93\u5FA9\u670D\u798F\u8179\u832F\u8514\u8907\u8986\u8F39\u8F3B\u99A5\u9C12\u672C\u4E76\u4FF8\u5949\u5C01\u5CEF\u5CF0\u6367\u68D2\u70FD\u71A2\u742B\u7E2B\u84EC\u8702\u9022\u92D2\u9CF3\u4E0D\u4ED8\u4FEF\u5085\u5256\u526F\u5426\u5490\u57E0\u592B\u5A66"],["dda1","\u5B5A\u5B75\u5BCC\u5E9C\uF966\u6276\u6577\u65A7\u6D6E\u6EA5\u7236\u7B26\u7C3F\u7F36\u8150\u8151\u819A\u8240\u8299\u83A9\u8A03\u8CA0\u8CE6\u8CFB\u8D74\u8DBA\u90E8\u91DC\u961C\u9644\u99D9\u9CE7\u5317\u5206\u5429\u5674\u58B3\u5954\u596E\u5FFF\u61A4\u626E\u6610\u6C7E\u711A\u76C6\u7C89\u7CDE\u7D1B\u82AC\u8CC1\u96F0\uF967\u4F5B\u5F17\u5F7F\u62C2\u5D29\u670B\u68DA\u787C\u7E43\u9D6C\u4E15\u5099\u5315\u532A\u5351\u5983\u5A62\u5E87\u60B2\u618A\u6249\u6279\u6590\u6787\u69A7\u6BD4\u6BD6\u6BD7\u6BD8\u6CB8\uF968\u7435\u75FA\u7812\u7891\u79D5\u79D8\u7C83\u7DCB\u7FE1\u80A5"],["dea1","\u813E\u81C2\u83F2\u871A\u88E8\u8AB9\u8B6C\u8CBB\u9119\u975E\u98DB\u9F3B\u56AC\u5B2A\u5F6C\u658C\u6AB3\u6BAF\u6D5C\u6FF1\u7015\u725D\u73AD\u8CA7\u8CD3\u983B\u6191\u6C37\u8058\u9A01\u4E4D\u4E8B\u4E9B\u4ED5\u4F3A\u4F3C\u4F7F\u4FDF\u50FF\u53F2\u53F8\u5506\u55E3\u56DB\u58EB\u5962\u5A11\u5BEB\u5BFA\u5C04\u5DF3\u5E2B\u5F99\u601D\u6368\u659C\u65AF\u67F6\u67FB\u68AD\u6B7B\u6C99\u6CD7\u6E23\u7009\u7345\u7802\u793E\u7940\u7960\u79C1\u7BE9\u7D17\u7D72\u8086\u820D\u838E\u84D1\u86C7\u88DF\u8A50\u8A5E\u8B1D\u8CDC\u8D66\u8FAD\u90AA\u98FC\u99DF\u9E9D\u524A\uF969\u6714\uF96A"],["dfa1","\u5098\u522A\u5C71\u6563\u6C55\u73CA\u7523\u759D\u7B97\u849C\u9178\u9730\u4E77\u6492\u6BBA\u715E\u85A9\u4E09\uF96B\u6749\u68EE\u6E17\u829F\u8518\u886B\u63F7\u6F81\u9212\u98AF\u4E0A\u50B7\u50CF\u511F\u5546\u55AA\u5617\u5B40\u5C19\u5CE0\u5E38\u5E8A\u5EA0\u5EC2\u60F3\u6851\u6A61\u6E58\u723D\u7240\u72C0\u76F8\u7965\u7BB1\u7FD4\u88F3\u89F4\u8A73\u8C61\u8CDE\u971C\u585E\u74BD\u8CFD\u55C7\uF96C\u7A61\u7D22\u8272\u7272\u751F\u7525\uF96D\u7B19\u5885\u58FB\u5DBC\u5E8F\u5EB6\u5F90\u6055\u6292\u637F\u654D\u6691\u66D9\u66F8\u6816\u68F2\u7280\u745E\u7B6E\u7D6E\u7DD6\u7F72"],["e0a1","\u80E5\u8212\u85AF\u897F\u8A93\u901D\u92E4\u9ECD\u9F20\u5915\u596D\u5E2D\u60DC\u6614\u6673\u6790\u6C50\u6DC5\u6F5F\u77F3\u78A9\u84C6\u91CB\u932B\u4ED9\u50CA\u5148\u5584\u5B0B\u5BA3\u6247\u657E\u65CB\u6E32\u717D\u7401\u7444\u7487\u74BF\u766C\u79AA\u7DDA\u7E55\u7FA8\u817A\u81B3\u8239\u861A\u87EC\u8A75\u8DE3\u9078\u9291\u9425\u994D\u9BAE\u5368\u5C51\u6954\u6CC4\u6D29\u6E2B\u820C\u859B\u893B\u8A2D\u8AAA\u96EA\u9F67\u5261\u66B9\u6BB2\u7E96\u87FE\u8D0D\u9583\u965D\u651D\u6D89\u71EE\uF96E\u57CE\u59D3\u5BAC\u6027\u60FA\u6210\u661F\u665F\u7329\u73F9\u76DB\u7701\u7B6C"],["e1a1","\u8056\u8072\u8165\u8AA0\u9192\u4E16\u52E2\u6B72\u6D17\u7A05\u7B39\u7D30\uF96F\u8CB0\u53EC\u562F\u5851\u5BB5\u5C0F\u5C11\u5DE2\u6240\u6383\u6414\u662D\u68B3\u6CBC\u6D88\u6EAF\u701F\u70A4\u71D2\u7526\u758F\u758E\u7619\u7B11\u7BE0\u7C2B\u7D20\u7D39\u852C\u856D\u8607\u8A34\u900D\u9061\u90B5\u92B7\u97F6\u9A37\u4FD7\u5C6C\u675F\u6D91\u7C9F\u7E8C\u8B16\u8D16\u901F\u5B6B\u5DFD\u640D\u84C0\u905C\u98E1\u7387\u5B8B\u609A\u677E\u6DDE\u8A1F\u8AA6\u9001\u980C\u5237\uF970\u7051\u788E\u9396\u8870\u91D7\u4FEE\u53D7\u55FD\u56DA\u5782\u58FD\u5AC2\u5B88\u5CAB\u5CC0\u5E25\u6101"],["e2a1","\u620D\u624B\u6388\u641C\u6536\u6578\u6A39\u6B8A\u6C34\u6D19\u6F31\u71E7\u72E9\u7378\u7407\u74B2\u7626\u7761\u79C0\u7A57\u7AEA\u7CB9\u7D8F\u7DAC\u7E61\u7F9E\u8129\u8331\u8490\u84DA\u85EA\u8896\u8AB0\u8B90\u8F38\u9042\u9083\u916C\u9296\u92B9\u968B\u96A7\u96A8\u96D6\u9700\u9808\u9996\u9AD3\u9B1A\u53D4\u587E\u5919\u5B70\u5BBF\u6DD1\u6F5A\u719F\u7421\u74B9\u8085\u83FD\u5DE1\u5F87\u5FAA\u6042\u65EC\u6812\u696F\u6A53\u6B89\u6D35\u6DF3\u73E3\u76FE\u77AC\u7B4D\u7D14\u8123\u821C\u8340\u84F4\u8563\u8A62\u8AC4\u9187\u931E\u9806\u99B4\u620C\u8853\u8FF0\u9265\u5D07\u5D27"],["e3a1","\u5D69\u745F\u819D\u8768\u6FD5\u62FE\u7FD2\u8936\u8972\u4E1E\u4E58\u50E7\u52DD\u5347\u627F\u6607\u7E69\u8805\u965E\u4F8D\u5319\u5636\u59CB\u5AA4\u5C38\u5C4E\u5C4D\u5E02\u5F11\u6043\u65BD\u662F\u6642\u67BE\u67F4\u731C\u77E2\u793A\u7FC5\u8494\u84CD\u8996\u8A66\u8A69\u8AE1\u8C55\u8C7A\u57F4\u5BD4\u5F0F\u606F\u62ED\u690D\u6B96\u6E5C\u7184\u7BD2\u8755\u8B58\u8EFE\u98DF\u98FE\u4F38\u4F81\u4FE1\u547B\u5A20\u5BB8\u613C\u65B0\u6668\u71FC\u7533\u795E\u7D33\u814E\u81E3\u8398\u85AA\u85CE\u8703\u8A0A\u8EAB\u8F9B\uF971\u8FC5\u5931\u5BA4\u5BE6\u6089\u5BE9\u5C0B\u5FC3\u6C81"],["e4a1","\uF972\u6DF1\u700B\u751A\u82AF\u8AF6\u4EC0\u5341\uF973\u96D9\u6C0F\u4E9E\u4FC4\u5152\u555E\u5A25\u5CE8\u6211\u7259\u82BD\u83AA\u86FE\u8859\u8A1D\u963F\u96C5\u9913\u9D09\u9D5D\u580A\u5CB3\u5DBD\u5E44\u60E1\u6115\u63E1\u6A02\u6E25\u9102\u9354\u984E\u9C10\u9F77\u5B89\u5CB8\u6309\u664F\u6848\u773C\u96C1\u978D\u9854\u9B9F\u65A1\u8B01\u8ECB\u95BC\u5535\u5CA9\u5DD6\u5EB5\u6697\u764C\u83F4\u95C7\u58D3\u62BC\u72CE\u9D28\u4EF0\u592E\u600F\u663B\u6B83\u79E7\u9D26\u5393\u54C0\u57C3\u5D16\u611B\u66D6\u6DAF\u788D\u827E\u9698\u9744\u5384\u627C\u6396\u6DB2\u7E0A\u814B\u984D"],["e5a1","\u6AFB\u7F4C\u9DAF\u9E1A\u4E5F\u503B\u51B6\u591C\u60F9\u63F6\u6930\u723A\u8036\uF974\u91CE\u5F31\uF975\uF976\u7D04\u82E5\u846F\u84BB\u85E5\u8E8D\uF977\u4F6F\uF978\uF979\u58E4\u5B43\u6059\u63DA\u6518\u656D\u6698\uF97A\u694A\u6A23\u6D0B\u7001\u716C\u75D2\u760D\u79B3\u7A70\uF97B\u7F8A\uF97C\u8944\uF97D\u8B93\u91C0\u967D\uF97E\u990A\u5704\u5FA1\u65BC\u6F01\u7600\u79A6\u8A9E\u99AD\u9B5A\u9F6C\u5104\u61B6\u6291\u6A8D\u81C6\u5043\u5830\u5F66\u7109\u8A00\u8AFA\u5B7C\u8616\u4FFA\u513C\u56B4\u5944\u63A9\u6DF9\u5DAA\u696D\u5186\u4E88\u4F59\uF97F\uF980\uF981\u5982\uF982"],["e6a1","\uF983\u6B5F\u6C5D\uF984\u74B5\u7916\uF985\u8207\u8245\u8339\u8F3F\u8F5D\uF986\u9918\uF987\uF988\uF989\u4EA6\uF98A\u57DF\u5F79\u6613\uF98B\uF98C\u75AB\u7E79\u8B6F\uF98D\u9006\u9A5B\u56A5\u5827\u59F8\u5A1F\u5BB4\uF98E\u5EF6\uF98F\uF990\u6350\u633B\uF991\u693D\u6C87\u6CBF\u6D8E\u6D93\u6DF5\u6F14\uF992\u70DF\u7136\u7159\uF993\u71C3\u71D5\uF994\u784F\u786F\uF995\u7B75\u7DE3\uF996\u7E2F\uF997\u884D\u8EDF\uF998\uF999\uF99A\u925B\uF99B\u9CF6\uF99C\uF99D\uF99E\u6085\u6D85\uF99F\u71B1\uF9A0\uF9A1\u95B1\u53AD\uF9A2\uF9A3\uF9A4\u67D3\uF9A5\u708E\u7130\u7430\u8276\u82D2"],["e7a1","\uF9A6\u95BB\u9AE5\u9E7D\u66C4\uF9A7\u71C1\u8449\uF9A8\uF9A9\u584B\uF9AA\uF9AB\u5DB8\u5F71\uF9AC\u6620\u668E\u6979\u69AE\u6C38\u6CF3\u6E36\u6F41\u6FDA\u701B\u702F\u7150\u71DF\u7370\uF9AD\u745B\uF9AE\u74D4\u76C8\u7A4E\u7E93\uF9AF\uF9B0\u82F1\u8A60\u8FCE\uF9B1\u9348\uF9B2\u9719\uF9B3\uF9B4\u4E42\u502A\uF9B5\u5208\u53E1\u66F3\u6C6D\u6FCA\u730A\u777F\u7A62\u82AE\u85DD\u8602\uF9B6\u88D4\u8A63\u8B7D\u8C6B\uF9B7\u92B3\uF9B8\u9713\u9810\u4E94\u4F0D\u4FC9\u50B2\u5348\u543E\u5433\u55DA\u5862\u58BA\u5967\u5A1B\u5BE4\u609F\uF9B9\u61CA\u6556\u65FF\u6664\u68A7\u6C5A\u6FB3"],["e8a1","\u70CF\u71AC\u7352\u7B7D\u8708\u8AA4\u9C32\u9F07\u5C4B\u6C83\u7344\u7389\u923A\u6EAB\u7465\u761F\u7A69\u7E15\u860A\u5140\u58C5\u64C1\u74EE\u7515\u7670\u7FC1\u9095\u96CD\u9954\u6E26\u74E6\u7AA9\u7AAA\u81E5\u86D9\u8778\u8A1B\u5A49\u5B8C\u5B9B\u68A1\u6900\u6D63\u73A9\u7413\u742C\u7897\u7DE9\u7FEB\u8118\u8155\u839E\u8C4C\u962E\u9811\u66F0\u5F80\u65FA\u6789\u6C6A\u738B\u502D\u5A03\u6B6A\u77EE\u5916\u5D6C\u5DCD\u7325\u754F\uF9BA\uF9BB\u50E5\u51F9\u582F\u592D\u5996\u59DA\u5BE5\uF9BC\uF9BD\u5DA2\u62D7\u6416\u6493\u64FE\uF9BE\u66DC\uF9BF\u6A48\uF9C0\u71FF\u7464\uF9C1"],["e9a1","\u7A88\u7AAF\u7E47\u7E5E\u8000\u8170\uF9C2\u87EF\u8981\u8B20\u9059\uF9C3\u9080\u9952\u617E\u6B32\u6D74\u7E1F\u8925\u8FB1\u4FD1\u50AD\u5197\u52C7\u57C7\u5889\u5BB9\u5EB8\u6142\u6995\u6D8C\u6E67\u6EB6\u7194\u7462\u7528\u752C\u8073\u8338\u84C9\u8E0A\u9394\u93DE\uF9C4\u4E8E\u4F51\u5076\u512A\u53C8\u53CB\u53F3\u5B87\u5BD3\u5C24\u611A\u6182\u65F4\u725B\u7397\u7440\u76C2\u7950\u7991\u79B9\u7D06\u7FBD\u828B\u85D5\u865E\u8FC2\u9047\u90F5\u91EA\u9685\u96E8\u96E9\u52D6\u5F67\u65ED\u6631\u682F\u715C\u7A36\u90C1\u980A\u4E91\uF9C5\u6A52\u6B9E\u6F90\u7189\u8018\u82B8\u8553"],["eaa1","\u904B\u9695\u96F2\u97FB\u851A\u9B31\u4E90\u718A\u96C4\u5143\u539F\u54E1\u5713\u5712\u57A3\u5A9B\u5AC4\u5BC3\u6028\u613F\u63F4\u6C85\u6D39\u6E72\u6E90\u7230\u733F\u7457\u82D1\u8881\u8F45\u9060\uF9C6\u9662\u9858\u9D1B\u6708\u8D8A\u925E\u4F4D\u5049\u50DE\u5371\u570D\u59D4\u5A01\u5C09\u6170\u6690\u6E2D\u7232\u744B\u7DEF\u80C3\u840E\u8466\u853F\u875F\u885B\u8918\u8B02\u9055\u97CB\u9B4F\u4E73\u4F91\u5112\u516A\uF9C7\u552F\u55A9\u5B7A\u5BA5\u5E7C\u5E7D\u5EBE\u60A0\u60DF\u6108\u6109\u63C4\u6538\u6709\uF9C8\u67D4\u67DA\uF9C9\u6961\u6962\u6CB9\u6D27\uF9CA\u6E38\uF9CB"],["eba1","\u6FE1\u7336\u7337\uF9CC\u745C\u7531\uF9CD\u7652\uF9CE\uF9CF\u7DAD\u81FE\u8438\u88D5\u8A98\u8ADB\u8AED\u8E30\u8E42\u904A\u903E\u907A\u9149\u91C9\u936E\uF9D0\uF9D1\u5809\uF9D2\u6BD3\u8089\u80B2\uF9D3\uF9D4\u5141\u596B\u5C39\uF9D5\uF9D6\u6F64\u73A7\u80E4\u8D07\uF9D7\u9217\u958F\uF9D8\uF9D9\uF9DA\uF9DB\u807F\u620E\u701C\u7D68\u878D\uF9DC\u57A0\u6069\u6147\u6BB7\u8ABE\u9280\u96B1\u4E59\u541F\u6DEB\u852D\u9670\u97F3\u98EE\u63D6\u6CE3\u9091\u51DD\u61C9\u81BA\u9DF9\u4F9D\u501A\u5100\u5B9C\u610F\u61FF\u64EC\u6905\u6BC5\u7591\u77E3\u7FA9\u8264\u858F\u87FB\u8863\u8ABC"],["eca1","\u8B70\u91AB\u4E8C\u4EE5\u4F0A\uF9DD\uF9DE\u5937\u59E8\uF9DF\u5DF2\u5F1B\u5F5B\u6021\uF9E0\uF9E1\uF9E2\uF9E3\u723E\u73E5\uF9E4\u7570\u75CD\uF9E5\u79FB\uF9E6\u800C\u8033\u8084\u82E1\u8351\uF9E7\uF9E8\u8CBD\u8CB3\u9087\uF9E9\uF9EA\u98F4\u990C\uF9EB\uF9EC\u7037\u76CA\u7FCA\u7FCC\u7FFC\u8B1A\u4EBA\u4EC1\u5203\u5370\uF9ED\u54BD\u56E0\u59FB\u5BC5\u5F15\u5FCD\u6E6E\uF9EE\uF9EF\u7D6A\u8335\uF9F0\u8693\u8A8D\uF9F1\u976D\u9777\uF9F2\uF9F3\u4E00\u4F5A\u4F7E\u58F9\u65E5\u6EA2\u9038\u93B0\u99B9\u4EFB\u58EC\u598A\u59D9\u6041\uF9F4\uF9F5\u7A14\uF9F6\u834F\u8CC3\u5165\u5344"],["eda1","\uF9F7\uF9F8\uF9F9\u4ECD\u5269\u5B55\u82BF\u4ED4\u523A\u54A8\u59C9\u59FF\u5B50\u5B57\u5B5C\u6063\u6148\u6ECB\u7099\u716E\u7386\u74F7\u75B5\u78C1\u7D2B\u8005\u81EA\u8328\u8517\u85C9\u8AEE\u8CC7\u96CC\u4F5C\u52FA\u56BC\u65AB\u6628\u707C\u70B8\u7235\u7DBD\u828D\u914C\u96C0\u9D72\u5B71\u68E7\u6B98\u6F7A\u76DE\u5C91\u66AB\u6F5B\u7BB4\u7C2A\u8836\u96DC\u4E08\u4ED7\u5320\u5834\u58BB\u58EF\u596C\u5C07\u5E33\u5E84\u5F35\u638C\u66B2\u6756\u6A1F\u6AA3\u6B0C\u6F3F\u7246\uF9FA\u7350\u748B\u7AE0\u7CA7\u8178\u81DF\u81E7\u838A\u846C\u8523\u8594\u85CF\u88DD\u8D13\u91AC\u9577"],["eea1","\u969C\u518D\u54C9\u5728\u5BB0\u624D\u6750\u683D\u6893\u6E3D\u6ED3\u707D\u7E21\u88C1\u8CA1\u8F09\u9F4B\u9F4E\u722D\u7B8F\u8ACD\u931A\u4F47\u4F4E\u5132\u5480\u59D0\u5E95\u62B5\u6775\u696E\u6A17\u6CAE\u6E1A\u72D9\u732A\u75BD\u7BB8\u7D35\u82E7\u83F9\u8457\u85F7\u8A5B\u8CAF\u8E87\u9019\u90B8\u96CE\u9F5F\u52E3\u540A\u5AE1\u5BC2\u6458\u6575\u6EF4\u72C4\uF9FB\u7684\u7A4D\u7B1B\u7C4D\u7E3E\u7FDF\u837B\u8B2B\u8CCA\u8D64\u8DE1\u8E5F\u8FEA\u8FF9\u9069\u93D1\u4F43\u4F7A\u50B3\u5168\u5178\u524D\u526A\u5861\u587C\u5960\u5C08\u5C55\u5EDB\u609B\u6230\u6813\u6BBF\u6C08\u6FB1"],["efa1","\u714E\u7420\u7530\u7538\u7551\u7672\u7B4C\u7B8B\u7BAD\u7BC6\u7E8F\u8A6E\u8F3E\u8F49\u923F\u9293\u9322\u942B\u96FB\u985A\u986B\u991E\u5207\u622A\u6298\u6D59\u7664\u7ACA\u7BC0\u7D76\u5360\u5CBE\u5E97\u6F38\u70B9\u7C98\u9711\u9B8E\u9EDE\u63A5\u647A\u8776\u4E01\u4E95\u4EAD\u505C\u5075\u5448\u59C3\u5B9A\u5E40\u5EAD\u5EF7\u5F81\u60C5\u633A\u653F\u6574\u65CC\u6676\u6678\u67FE\u6968\u6A89\u6B63\u6C40\u6DC0\u6DE8\u6E1F\u6E5E\u701E\u70A1\u738E\u73FD\u753A\u775B\u7887\u798E\u7A0B\u7A7D\u7CBE\u7D8E\u8247\u8A02\u8AEA\u8C9E\u912D\u914A\u91D8\u9266\u92CC\u9320\u9706\u9756"],["f0a1","\u975C\u9802\u9F0E\u5236\u5291\u557C\u5824\u5E1D\u5F1F\u608C\u63D0\u68AF\u6FDF\u796D\u7B2C\u81CD\u85BA\u88FD\u8AF8\u8E44\u918D\u9664\u969B\u973D\u984C\u9F4A\u4FCE\u5146\u51CB\u52A9\u5632\u5F14\u5F6B\u63AA\u64CD\u65E9\u6641\u66FA\u66F9\u671D\u689D\u68D7\u69FD\u6F15\u6F6E\u7167\u71E5\u722A\u74AA\u773A\u7956\u795A\u79DF\u7A20\u7A95\u7C97\u7CDF\u7D44\u7E70\u8087\u85FB\u86A4\u8A54\u8ABF\u8D99\u8E81\u9020\u906D\u91E3\u963B\u96D5\u9CE5\u65CF\u7C07\u8DB3\u93C3\u5B58\u5C0A\u5352\u62D9\u731D\u5027\u5B97\u5F9E\u60B0\u616B\u68D5\u6DD9\u742E\u7A2E\u7D42\u7D9C\u7E31\u816B"],["f1a1","\u8E2A\u8E35\u937E\u9418\u4F50\u5750\u5DE6\u5EA7\u632B\u7F6A\u4E3B\u4F4F\u4F8F\u505A\u59DD\u80C4\u546A\u5468\u55FE\u594F\u5B99\u5DDE\u5EDA\u665D\u6731\u67F1\u682A\u6CE8\u6D32\u6E4A\u6F8D\u70B7\u73E0\u7587\u7C4C\u7D02\u7D2C\u7DA2\u821F\u86DB\u8A3B\u8A85\u8D70\u8E8A\u8F33\u9031\u914E\u9152\u9444\u99D0\u7AF9\u7CA5\u4FCA\u5101\u51C6\u57C8\u5BEF\u5CFB\u6659\u6A3D\u6D5A\u6E96\u6FEC\u710C\u756F\u7AE3\u8822\u9021\u9075\u96CB\u99FF\u8301\u4E2D\u4EF2\u8846\u91CD\u537D\u6ADB\u696B\u6C41\u847A\u589E\u618E\u66FE\u62EF\u70DD\u7511\u75C7\u7E52\u84B8\u8B49\u8D08\u4E4B\u53EA"],["f2a1","\u54AB\u5730\u5740\u5FD7\u6301\u6307\u646F\u652F\u65E8\u667A\u679D\u67B3\u6B62\u6C60\u6C9A\u6F2C\u77E5\u7825\u7949\u7957\u7D19\u80A2\u8102\u81F3\u829D\u82B7\u8718\u8A8C\uF9FC\u8D04\u8DBE\u9072\u76F4\u7A19\u7A37\u7E54\u8077\u5507\u55D4\u5875\u632F\u6422\u6649\u664B\u686D\u699B\u6B84\u6D25\u6EB1\u73CD\u7468\u74A1\u755B\u75B9\u76E1\u771E\u778B\u79E6\u7E09\u7E1D\u81FB\u852F\u8897\u8A3A\u8CD1\u8EEB\u8FB0\u9032\u93AD\u9663\u9673\u9707\u4F84\u53F1\u59EA\u5AC9\u5E19\u684E\u74C6\u75BE\u79E9\u7A92\u81A3\u86ED\u8CEA\u8DCC\u8FED\u659F\u6715\uF9FD\u57F7\u6F57\u7DDD\u8F2F"],["f3a1","\u93F6\u96C6\u5FB5\u61F2\u6F84\u4E14\u4F98\u501F\u53C9\u55DF\u5D6F\u5DEE\u6B21\u6B64\u78CB\u7B9A\uF9FE\u8E49\u8ECA\u906E\u6349\u643E\u7740\u7A84\u932F\u947F\u9F6A\u64B0\u6FAF\u71E6\u74A8\u74DA\u7AC4\u7C12\u7E82\u7CB2\u7E98\u8B9A\u8D0A\u947D\u9910\u994C\u5239\u5BDF\u64E6\u672D\u7D2E\u50ED\u53C3\u5879\u6158\u6159\u61FA\u65AC\u7AD9\u8B92\u8B96\u5009\u5021\u5275\u5531\u5A3C\u5EE0\u5F70\u6134\u655E\u660C\u6636\u66A2\u69CD\u6EC4\u6F32\u7316\u7621\u7A93\u8139\u8259\u83D6\u84BC\u50B5\u57F0\u5BC0\u5BE8\u5F69\u63A1\u7826\u7DB5\u83DC\u8521\u91C7\u91F5\u518A\u67F5\u7B56"],["f4a1","\u8CAC\u51C4\u59BB\u60BD\u8655\u501C\uF9FF\u5254\u5C3A\u617D\u621A\u62D3\u64F2\u65A5\u6ECC\u7620\u810A\u8E60\u965F\u96BB\u4EDF\u5343\u5598\u5929\u5DDD\u64C5\u6CC9\u6DFA\u7394\u7A7F\u821B\u85A6\u8CE4\u8E10\u9077\u91E7\u95E1\u9621\u97C6\u51F8\u54F2\u5586\u5FB9\u64A4\u6F88\u7DB4\u8F1F\u8F4D\u9435\u50C9\u5C16\u6CBE\u6DFB\u751B\u77BB\u7C3D\u7C64\u8A79\u8AC2\u581E\u59BE\u5E16\u6377\u7252\u758A\u776B\u8ADC\u8CBC\u8F12\u5EF3\u6674\u6DF8\u807D\u83C1\u8ACB\u9751\u9BD6\uFA00\u5243\u66FF\u6D95\u6EEF\u7DE0\u8AE6\u902E\u905E\u9AD4\u521D\u527F\u54E8\u6194\u6284\u62DB\u68A2"],["f5a1","\u6912\u695A\u6A35\u7092\u7126\u785D\u7901\u790E\u79D2\u7A0D\u8096\u8278\u82D5\u8349\u8549\u8C82\u8D85\u9162\u918B\u91AE\u4FC3\u56D1\u71ED\u77D7\u8700\u89F8\u5BF8\u5FD6\u6751\u90A8\u53E2\u585A\u5BF5\u60A4\u6181\u6460\u7E3D\u8070\u8525\u9283\u64AE\u50AC\u5D14\u6700\u589C\u62BD\u63A8\u690E\u6978\u6A1E\u6E6B\u76BA\u79CB\u82BB\u8429\u8ACF\u8DA8\u8FFD\u9112\u914B\u919C\u9310\u9318\u939A\u96DB\u9A36\u9C0D\u4E11\u755C\u795D\u7AFA\u7B51\u7BC9\u7E2E\u84C4\u8E59\u8E74\u8EF8\u9010\u6625\u693F\u7443\u51FA\u672E\u9EDC\u5145\u5FE0\u6C96\u87F2\u885D\u8877\u60B4\u81B5\u8403"],["f6a1","\u8D05\u53D6\u5439\u5634\u5A36\u5C31\u708A\u7FE0\u805A\u8106\u81ED\u8DA3\u9189\u9A5F\u9DF2\u5074\u4EC4\u53A0\u60FB\u6E2C\u5C64\u4F88\u5024\u55E4\u5CD9\u5E5F\u6065\u6894\u6CBB\u6DC4\u71BE\u75D4\u75F4\u7661\u7A1A\u7A49\u7DC7\u7DFB\u7F6E\u81F4\u86A9\u8F1C\u96C9\u99B3\u9F52\u5247\u52C5\u98ED\u89AA\u4E03\u67D2\u6F06\u4FB5\u5BE2\u6795\u6C88\u6D78\u741B\u7827\u91DD\u937C\u87C4\u79E4\u7A31\u5FEB\u4ED6\u54A4\u553E\u58AE\u59A5\u60F0\u6253\u62D6\u6736\u6955\u8235\u9640\u99B1\u99DD\u502C\u5353\u5544\u577C\uFA01\u6258\uFA02\u64E2\u666B\u67DD\u6FC1\u6FEF\u7422\u7438\u8A17"],["f7a1","\u9438\u5451\u5606\u5766\u5F48\u619A\u6B4E\u7058\u70AD\u7DBB\u8A95\u596A\u812B\u63A2\u7708\u803D\u8CAA\u5854\u642D\u69BB\u5B95\u5E11\u6E6F\uFA03\u8569\u514C\u53F0\u592A\u6020\u614B\u6B86\u6C70\u6CF0\u7B1E\u80CE\u82D4\u8DC6\u90B0\u98B1\uFA04\u64C7\u6FA4\u6491\u6504\u514E\u5410\u571F\u8A0E\u615F\u6876\uFA05\u75DB\u7B52\u7D71\u901A\u5806\u69CC\u817F\u892A\u9000\u9839\u5078\u5957\u59AC\u6295\u900F\u9B2A\u615D\u7279\u95D6\u5761\u5A46\u5DF4\u628A\u64AD\u64FA\u6777\u6CE2\u6D3E\u722C\u7436\u7834\u7F77\u82AD\u8DDB\u9817\u5224\u5742\u677F\u7248\u74E3\u8CA9\u8FA6\u9211"],["f8a1","\u962A\u516B\u53ED\u634C\u4F69\u5504\u6096\u6557\u6C9B\u6D7F\u724C\u72FD\u7A17\u8987\u8C9D\u5F6D\u6F8E\u70F9\u81A8\u610E\u4FBF\u504F\u6241\u7247\u7BC7\u7DE8\u7FE9\u904D\u97AD\u9A19\u8CB6\u576A\u5E73\u67B0\u840D\u8A55\u5420\u5B16\u5E63\u5EE2\u5F0A\u6583\u80BA\u853D\u9589\u965B\u4F48\u5305\u530D\u530F\u5486\u54FA\u5703\u5E03\u6016\u629B\u62B1\u6355\uFA06\u6CE1\u6D66\u75B1\u7832\u80DE\u812F\u82DE\u8461\u84B2\u888D\u8912\u900B\u92EA\u98FD\u9B91\u5E45\u66B4\u66DD\u7011\u7206\uFA07\u4FF5\u527D\u5F6A\u6153\u6753\u6A19\u6F02\u74E2\u7968\u8868\u8C79\u98C7\u98C4\u9A43"],["f9a1","\u54C1\u7A1F\u6953\u8AF7\u8C4A\u98A8\u99AE\u5F7C\u62AB\u75B2\u76AE\u88AB\u907F\u9642\u5339\u5F3C\u5FC5\u6CCC\u73CC\u7562\u758B\u7B46\u82FE\u999D\u4E4F\u903C\u4E0B\u4F55\u53A6\u590F\u5EC8\u6630\u6CB3\u7455\u8377\u8766\u8CC0\u9050\u971E\u9C15\u58D1\u5B78\u8650\u8B14\u9DB4\u5BD2\u6068\u608D\u65F1\u6C57\u6F22\u6FA3\u701A\u7F55\u7FF0\u9591\u9592\u9650\u97D3\u5272\u8F44\u51FD\u542B\u54B8\u5563\u558A\u6ABB\u6DB5\u7DD8\u8266\u929C\u9677\u9E79\u5408\u54C8\u76D2\u86E4\u95A4\u95D4\u965C\u4EA2\u4F09\u59EE\u5AE6\u5DF7\u6052\u6297\u676D\u6841\u6C86\u6E2F\u7F38\u809B\u822A"],["faa1","\uFA08\uFA09\u9805\u4EA5\u5055\u54B3\u5793\u595A\u5B69\u5BB3\u61C8\u6977\u6D77\u7023\u87F9\u89E3\u8A72\u8AE7\u9082\u99ED\u9AB8\u52BE\u6838\u5016\u5E78\u674F\u8347\u884C\u4EAB\u5411\u56AE\u73E6\u9115\u97FF\u9909\u9957\u9999\u5653\u589F\u865B\u8A31\u61B2\u6AF6\u737B\u8ED2\u6B47\u96AA\u9A57\u5955\u7200\u8D6B\u9769\u4FD4\u5CF4\u5F26\u61F8\u665B\u6CEB\u70AB\u7384\u73B9\u73FE\u7729\u774D\u7D43\u7D62\u7E23\u8237\u8852\uFA0A\u8CE2\u9249\u986F\u5B51\u7A74\u8840\u9801\u5ACC\u4FE0\u5354\u593E\u5CFD\u633E\u6D79\u72F9\u8105\u8107\u83A2\u92CF\u9830\u4EA8\u5144\u5211\u578B"],["fba1","\u5F62\u6CC2\u6ECE\u7005\u7050\u70AF\u7192\u73E9\u7469\u834A\u87A2\u8861\u9008\u90A2\u93A3\u99A8\u516E\u5F57\u60E0\u6167\u66B3\u8559\u8E4A\u91AF\u978B\u4E4E\u4E92\u547C\u58D5\u58FA\u597D\u5CB5\u5F27\u6236\u6248\u660A\u6667\u6BEB\u6D69\u6DCF\u6E56\u6EF8\u6F94\u6FE0\u6FE9\u705D\u72D0\u7425\u745A\u74E0\u7693\u795C\u7CCA\u7E1E\u80E1\u82A6\u846B\u84BF\u864E\u865F\u8774\u8B77\u8C6A\u93AC\u9800\u9865\u60D1\u6216\u9177\u5A5A\u660F\u6DF7\u6E3E\u743F\u9B42\u5FFD\u60DA\u7B0F\u54C4\u5F18\u6C5E\u6CD3\u6D2A\u70D8\u7D05\u8679\u8A0C\u9D3B\u5316\u548C\u5B05\u6A3A\u706B\u7575"],["fca1","\u798D\u79BE\u82B1\u83EF\u8A71\u8B41\u8CA8\u9774\uFA0B\u64F4\u652B\u78BA\u78BB\u7A6B\u4E38\u559A\u5950\u5BA6\u5E7B\u60A3\u63DB\u6B61\u6665\u6853\u6E19\u7165\u74B0\u7D08\u9084\u9A69\u9C25\u6D3B\u6ED1\u733E\u8C41\u95CA\u51F0\u5E4C\u5FA8\u604D\u60F6\u6130\u614C\u6643\u6644\u69A5\u6CC1\u6E5F\u6EC9\u6F62\u714C\u749C\u7687\u7BC1\u7C27\u8352\u8757\u9051\u968D\u9EC3\u532F\u56DE\u5EFB\u5F8A\u6062\u6094\u61F7\u6666\u6703\u6A9C\u6DEE\u6FAE\u7070\u736A\u7E6A\u81BE\u8334\u86D4\u8AA8\u8CC4\u5283\u7372\u5B96\u6A6B\u9404\u54EE\u5686\u5B5D\u6548\u6585\u66C9\u689F\u6D8D\u6DC6"],["fda1","\u723B\u80B4\u9175\u9A4D\u4FAF\u5019\u539A\u540E\u543C\u5589\u55C5\u5E3F\u5F8C\u673D\u7166\u73DD\u9005\u52DB\u52F3\u5864\u58CE\u7104\u718F\u71FB\u85B0\u8A13\u6688\u85A8\u55A7\u6684\u714A\u8431\u5349\u5599\u6BC1\u5F59\u5FBD\u63EE\u6689\u7147\u8AF1\u8F1D\u9EBE\u4F11\u643A\u70CB\u7566\u8667\u6064\u8B4E\u9DF8\u5147\u51F6\u5308\u6D36\u80F8\u9ED1\u6615\u6B23\u7098\u75D5\u5403\u5C79\u7D07\u8A16\u6B20\u6B3D\u6B46\u5438\u6070\u6D3D\u7FD5\u8208\u50D6\u51DE\u559C\u566B\u56CD\u59EC\u5B09\u5E0C\u6199\u6198\u6231\u665E\u66E6\u7199\u71B9\u71BA\u72A7\u79A7\u7A00\u7FB2\u8A70"]]');

},{}],"b0SFM":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["0","\\u0000",127],["a140","\u3000\uFF0C\u3001\u3002\uFF0E\u2027\uFF1B\uFF1A\uFF1F\uFF01\uFE30\u2026\u2025\uFE50\uFE51\uFE52\xb7\uFE54\uFE55\uFE56\uFE57\uFF5C\u2013\uFE31\u2014\uFE33\u2574\uFE34\uFE4F\uFF08\uFF09\uFE35\uFE36\uFF5B\uFF5D\uFE37\uFE38\u3014\u3015\uFE39\uFE3A\u3010\u3011\uFE3B\uFE3C\u300A\u300B\uFE3D\uFE3E\u3008\u3009\uFE3F\uFE40\u300C\u300D\uFE41\uFE42\u300E\u300F\uFE43\uFE44\uFE59\uFE5A"],["a1a1","\uFE5B\uFE5C\uFE5D\uFE5E\u2018\u2019\u201C\u201D\u301D\u301E\u2035\u2032\uFF03\uFF06\uFF0A\u203B\xa7\u3003\u25CB\u25CF\u25B3\u25B2\u25CE\u2606\u2605\u25C7\u25C6\u25A1\u25A0\u25BD\u25BC\u32A3\u2105\xaf\uFFE3\uFF3F\u02CD\uFE49\uFE4A\uFE4D\uFE4E\uFE4B\uFE4C\uFE5F\uFE60\uFE61\uFF0B\uFF0D\xd7\xf7\xb1\u221A\uFF1C\uFF1E\uFF1D\u2266\u2267\u2260\u221E\u2252\u2261\uFE62",4,"\uFF5E\u2229\u222A\u22A5\u2220\u221F\u22BF\u33D2\u33D1\u222B\u222E\u2235\u2234\u2640\u2642\u2295\u2299\u2191\u2193\u2190\u2192\u2196\u2197\u2199\u2198\u2225\u2223\uFF0F"],["a240","\uFF3C\u2215\uFE68\uFF04\uFFE5\u3012\uFFE0\uFFE1\uFF05\uFF20\u2103\u2109\uFE69\uFE6A\uFE6B\u33D5\u339C\u339D\u339E\u33CE\u33A1\u338E\u338F\u33C4\xb0\u5159\u515B\u515E\u515D\u5161\u5163\u55E7\u74E9\u7CCE\u2581",7,"\u258F\u258E\u258D\u258C\u258B\u258A\u2589\u253C\u2534\u252C\u2524\u251C\u2594\u2500\u2502\u2595\u250C\u2510\u2514\u2518\u256D"],["a2a1","\u256E\u2570\u256F\u2550\u255E\u256A\u2561\u25E2\u25E3\u25E5\u25E4\u2571\u2572\u2573\uFF10",9,"\u2160",9,"\u3021",8,"\u5341\u5344\u5345\uFF21",25,"\uFF41",21],["a340","\uFF57\uFF58\uFF59\uFF5A\u0391",16,"\u03A3",6,"\u03B1",16,"\u03C3",6,"\u3105",10],["a3a1","\u3110",25,"\u02D9\u02C9\u02CA\u02C7\u02CB"],["a3e1","\u20AC"],["a440","\u4E00\u4E59\u4E01\u4E03\u4E43\u4E5D\u4E86\u4E8C\u4EBA\u513F\u5165\u516B\u51E0\u5200\u5201\u529B\u5315\u5341\u535C\u53C8\u4E09\u4E0B\u4E08\u4E0A\u4E2B\u4E38\u51E1\u4E45\u4E48\u4E5F\u4E5E\u4E8E\u4EA1\u5140\u5203\u52FA\u5343\u53C9\u53E3\u571F\u58EB\u5915\u5927\u5973\u5B50\u5B51\u5B53\u5BF8\u5C0F\u5C22\u5C38\u5C71\u5DDD\u5DE5\u5DF1\u5DF2\u5DF3\u5DFE\u5E72\u5EFE\u5F0B\u5F13\u624D"],["a4a1","\u4E11\u4E10\u4E0D\u4E2D\u4E30\u4E39\u4E4B\u5C39\u4E88\u4E91\u4E95\u4E92\u4E94\u4EA2\u4EC1\u4EC0\u4EC3\u4EC6\u4EC7\u4ECD\u4ECA\u4ECB\u4EC4\u5143\u5141\u5167\u516D\u516E\u516C\u5197\u51F6\u5206\u5207\u5208\u52FB\u52FE\u52FF\u5316\u5339\u5348\u5347\u5345\u535E\u5384\u53CB\u53CA\u53CD\u58EC\u5929\u592B\u592A\u592D\u5B54\u5C11\u5C24\u5C3A\u5C6F\u5DF4\u5E7B\u5EFF\u5F14\u5F15\u5FC3\u6208\u6236\u624B\u624E\u652F\u6587\u6597\u65A4\u65B9\u65E5\u66F0\u6708\u6728\u6B20\u6B62\u6B79\u6BCB\u6BD4\u6BDB\u6C0F\u6C34\u706B\u722A\u7236\u723B\u7247\u7259\u725B\u72AC\u738B\u4E19"],["a540","\u4E16\u4E15\u4E14\u4E18\u4E3B\u4E4D\u4E4F\u4E4E\u4EE5\u4ED8\u4ED4\u4ED5\u4ED6\u4ED7\u4EE3\u4EE4\u4ED9\u4EDE\u5145\u5144\u5189\u518A\u51AC\u51F9\u51FA\u51F8\u520A\u52A0\u529F\u5305\u5306\u5317\u531D\u4EDF\u534A\u5349\u5361\u5360\u536F\u536E\u53BB\u53EF\u53E4\u53F3\u53EC\u53EE\u53E9\u53E8\u53FC\u53F8\u53F5\u53EB\u53E6\u53EA\u53F2\u53F1\u53F0\u53E5\u53ED\u53FB\u56DB\u56DA\u5916"],["a5a1","\u592E\u5931\u5974\u5976\u5B55\u5B83\u5C3C\u5DE8\u5DE7\u5DE6\u5E02\u5E03\u5E73\u5E7C\u5F01\u5F18\u5F17\u5FC5\u620A\u6253\u6254\u6252\u6251\u65A5\u65E6\u672E\u672C\u672A\u672B\u672D\u6B63\u6BCD\u6C11\u6C10\u6C38\u6C41\u6C40\u6C3E\u72AF\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7529\u7530\u7531\u7532\u7533\u758B\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79BE\u7A74\u7ACB\u4E1E\u4E1F\u4E52\u4E53\u4E69\u4E99\u4EA4\u4EA6\u4EA5\u4EFF\u4F09\u4F19\u4F0A\u4F15\u4F0D\u4F10\u4F11\u4F0F\u4EF2\u4EF6\u4EFB\u4EF0\u4EF3\u4EFD\u4F01\u4F0B\u5149\u5147\u5146\u5148\u5168"],["a640","\u5171\u518D\u51B0\u5217\u5211\u5212\u520E\u5216\u52A3\u5308\u5321\u5320\u5370\u5371\u5409\u540F\u540C\u540A\u5410\u5401\u540B\u5404\u5411\u540D\u5408\u5403\u540E\u5406\u5412\u56E0\u56DE\u56DD\u5733\u5730\u5728\u572D\u572C\u572F\u5729\u5919\u591A\u5937\u5938\u5984\u5978\u5983\u597D\u5979\u5982\u5981\u5B57\u5B58\u5B87\u5B88\u5B85\u5B89\u5BFA\u5C16\u5C79\u5DDE\u5E06\u5E76\u5E74"],["a6a1","\u5F0F\u5F1B\u5FD9\u5FD6\u620E\u620C\u620D\u6210\u6263\u625B\u6258\u6536\u65E9\u65E8\u65EC\u65ED\u66F2\u66F3\u6709\u673D\u6734\u6731\u6735\u6B21\u6B64\u6B7B\u6C16\u6C5D\u6C57\u6C59\u6C5F\u6C60\u6C50\u6C55\u6C61\u6C5B\u6C4D\u6C4E\u7070\u725F\u725D\u767E\u7AF9\u7C73\u7CF8\u7F36\u7F8A\u7FBD\u8001\u8003\u800C\u8012\u8033\u807F\u8089\u808B\u808C\u81E3\u81EA\u81F3\u81FC\u820C\u821B\u821F\u826E\u8272\u827E\u866B\u8840\u884C\u8863\u897F\u9621\u4E32\u4EA8\u4F4D\u4F4F\u4F47\u4F57\u4F5E\u4F34\u4F5B\u4F55\u4F30\u4F50\u4F51\u4F3D\u4F3A\u4F38\u4F43\u4F54\u4F3C\u4F46\u4F63"],["a740","\u4F5C\u4F60\u4F2F\u4F4E\u4F36\u4F59\u4F5D\u4F48\u4F5A\u514C\u514B\u514D\u5175\u51B6\u51B7\u5225\u5224\u5229\u522A\u5228\u52AB\u52A9\u52AA\u52AC\u5323\u5373\u5375\u541D\u542D\u541E\u543E\u5426\u544E\u5427\u5446\u5443\u5433\u5448\u5442\u541B\u5429\u544A\u5439\u543B\u5438\u542E\u5435\u5436\u5420\u543C\u5440\u5431\u542B\u541F\u542C\u56EA\u56F0\u56E4\u56EB\u574A\u5751\u5740\u574D"],["a7a1","\u5747\u574E\u573E\u5750\u574F\u573B\u58EF\u593E\u599D\u5992\u59A8\u599E\u59A3\u5999\u5996\u598D\u59A4\u5993\u598A\u59A5\u5B5D\u5B5C\u5B5A\u5B5B\u5B8C\u5B8B\u5B8F\u5C2C\u5C40\u5C41\u5C3F\u5C3E\u5C90\u5C91\u5C94\u5C8C\u5DEB\u5E0C\u5E8F\u5E87\u5E8A\u5EF7\u5F04\u5F1F\u5F64\u5F62\u5F77\u5F79\u5FD8\u5FCC\u5FD7\u5FCD\u5FF1\u5FEB\u5FF8\u5FEA\u6212\u6211\u6284\u6297\u6296\u6280\u6276\u6289\u626D\u628A\u627C\u627E\u6279\u6273\u6292\u626F\u6298\u626E\u6295\u6293\u6291\u6286\u6539\u653B\u6538\u65F1\u66F4\u675F\u674E\u674F\u6750\u6751\u675C\u6756\u675E\u6749\u6746\u6760"],["a840","\u6753\u6757\u6B65\u6BCF\u6C42\u6C5E\u6C99\u6C81\u6C88\u6C89\u6C85\u6C9B\u6C6A\u6C7A\u6C90\u6C70\u6C8C\u6C68\u6C96\u6C92\u6C7D\u6C83\u6C72\u6C7E\u6C74\u6C86\u6C76\u6C8D\u6C94\u6C98\u6C82\u7076\u707C\u707D\u7078\u7262\u7261\u7260\u72C4\u72C2\u7396\u752C\u752B\u7537\u7538\u7682\u76EF\u77E3\u79C1\u79C0\u79BF\u7A76\u7CFB\u7F55\u8096\u8093\u809D\u8098\u809B\u809A\u80B2\u826F\u8292"],["a8a1","\u828B\u828D\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FC2\u8FC6\u8FC5\u8FC4\u5DE1\u9091\u90A2\u90AA\u90A6\u90A3\u9149\u91C6\u91CC\u9632\u962E\u9631\u962A\u962C\u4E26\u4E56\u4E73\u4E8B\u4E9B\u4E9E\u4EAB\u4EAC\u4F6F\u4F9D\u4F8D\u4F73\u4F7F\u4F6C\u4F9B\u4F8B\u4F86\u4F83\u4F70\u4F75\u4F88\u4F69\u4F7B\u4F96\u4F7E\u4F8F\u4F91\u4F7A\u5154\u5152\u5155\u5169\u5177\u5176\u5178\u51BD\u51FD\u523B\u5238\u5237\u523A\u5230\u522E\u5236\u5241\u52BE\u52BB\u5352\u5354\u5353\u5351\u5366\u5377\u5378\u5379\u53D6\u53D4\u53D7\u5473\u5475"],["a940","\u5496\u5478\u5495\u5480\u547B\u5477\u5484\u5492\u5486\u547C\u5490\u5471\u5476\u548C\u549A\u5462\u5468\u548B\u547D\u548E\u56FA\u5783\u5777\u576A\u5769\u5761\u5766\u5764\u577C\u591C\u5949\u5947\u5948\u5944\u5954\u59BE\u59BB\u59D4\u59B9\u59AE\u59D1\u59C6\u59D0\u59CD\u59CB\u59D3\u59CA\u59AF\u59B3\u59D2\u59C5\u5B5F\u5B64\u5B63\u5B97\u5B9A\u5B98\u5B9C\u5B99\u5B9B\u5C1A\u5C48\u5C45"],["a9a1","\u5C46\u5CB7\u5CA1\u5CB8\u5CA9\u5CAB\u5CB1\u5CB3\u5E18\u5E1A\u5E16\u5E15\u5E1B\u5E11\u5E78\u5E9A\u5E97\u5E9C\u5E95\u5E96\u5EF6\u5F26\u5F27\u5F29\u5F80\u5F81\u5F7F\u5F7C\u5FDD\u5FE0\u5FFD\u5FF5\u5FFF\u600F\u6014\u602F\u6035\u6016\u602A\u6015\u6021\u6027\u6029\u602B\u601B\u6216\u6215\u623F\u623E\u6240\u627F\u62C9\u62CC\u62C4\u62BF\u62C2\u62B9\u62D2\u62DB\u62AB\u62D3\u62D4\u62CB\u62C8\u62A8\u62BD\u62BC\u62D0\u62D9\u62C7\u62CD\u62B5\u62DA\u62B1\u62D8\u62D6\u62D7\u62C6\u62AC\u62CE\u653E\u65A7\u65BC\u65FA\u6614\u6613\u660C\u6606\u6602\u660E\u6600\u660F\u6615\u660A"],["aa40","\u6607\u670D\u670B\u676D\u678B\u6795\u6771\u679C\u6773\u6777\u6787\u679D\u6797\u676F\u6770\u677F\u6789\u677E\u6790\u6775\u679A\u6793\u677C\u676A\u6772\u6B23\u6B66\u6B67\u6B7F\u6C13\u6C1B\u6CE3\u6CE8\u6CF3\u6CB1\u6CCC\u6CE5\u6CB3\u6CBD\u6CBE\u6CBC\u6CE2\u6CAB\u6CD5\u6CD3\u6CB8\u6CC4\u6CB9\u6CC1\u6CAE\u6CD7\u6CC5\u6CF1\u6CBF\u6CBB\u6CE1\u6CDB\u6CCA\u6CAC\u6CEF\u6CDC\u6CD6\u6CE0"],["aaa1","\u7095\u708E\u7092\u708A\u7099\u722C\u722D\u7238\u7248\u7267\u7269\u72C0\u72CE\u72D9\u72D7\u72D0\u73A9\u73A8\u739F\u73AB\u73A5\u753D\u759D\u7599\u759A\u7684\u76C2\u76F2\u76F4\u77E5\u77FD\u793E\u7940\u7941\u79C9\u79C8\u7A7A\u7A79\u7AFA\u7CFE\u7F54\u7F8C\u7F8B\u8005\u80BA\u80A5\u80A2\u80B1\u80A1\u80AB\u80A9\u80B4\u80AA\u80AF\u81E5\u81FE\u820D\u82B3\u829D\u8299\u82AD\u82BD\u829F\u82B9\u82B1\u82AC\u82A5\u82AF\u82B8\u82A3\u82B0\u82BE\u82B7\u864E\u8671\u521D\u8868\u8ECB\u8FCE\u8FD4\u8FD1\u90B5\u90B8\u90B1\u90B6\u91C7\u91D1\u9577\u9580\u961C\u9640\u963F\u963B\u9644"],["ab40","\u9642\u96B9\u96E8\u9752\u975E\u4E9F\u4EAD\u4EAE\u4FE1\u4FB5\u4FAF\u4FBF\u4FE0\u4FD1\u4FCF\u4FDD\u4FC3\u4FB6\u4FD8\u4FDF\u4FCA\u4FD7\u4FAE\u4FD0\u4FC4\u4FC2\u4FDA\u4FCE\u4FDE\u4FB7\u5157\u5192\u5191\u51A0\u524E\u5243\u524A\u524D\u524C\u524B\u5247\u52C7\u52C9\u52C3\u52C1\u530D\u5357\u537B\u539A\u53DB\u54AC\u54C0\u54A8\u54CE\u54C9\u54B8\u54A6\u54B3\u54C7\u54C2\u54BD\u54AA\u54C1"],["aba1","\u54C4\u54C8\u54AF\u54AB\u54B1\u54BB\u54A9\u54A7\u54BF\u56FF\u5782\u578B\u57A0\u57A3\u57A2\u57CE\u57AE\u5793\u5955\u5951\u594F\u594E\u5950\u59DC\u59D8\u59FF\u59E3\u59E8\u5A03\u59E5\u59EA\u59DA\u59E6\u5A01\u59FB\u5B69\u5BA3\u5BA6\u5BA4\u5BA2\u5BA5\u5C01\u5C4E\u5C4F\u5C4D\u5C4B\u5CD9\u5CD2\u5DF7\u5E1D\u5E25\u5E1F\u5E7D\u5EA0\u5EA6\u5EFA\u5F08\u5F2D\u5F65\u5F88\u5F85\u5F8A\u5F8B\u5F87\u5F8C\u5F89\u6012\u601D\u6020\u6025\u600E\u6028\u604D\u6070\u6068\u6062\u6046\u6043\u606C\u606B\u606A\u6064\u6241\u62DC\u6316\u6309\u62FC\u62ED\u6301\u62EE\u62FD\u6307\u62F1\u62F7"],["ac40","\u62EF\u62EC\u62FE\u62F4\u6311\u6302\u653F\u6545\u65AB\u65BD\u65E2\u6625\u662D\u6620\u6627\u662F\u661F\u6628\u6631\u6624\u66F7\u67FF\u67D3\u67F1\u67D4\u67D0\u67EC\u67B6\u67AF\u67F5\u67E9\u67EF\u67C4\u67D1\u67B4\u67DA\u67E5\u67B8\u67CF\u67DE\u67F3\u67B0\u67D9\u67E2\u67DD\u67D2\u6B6A\u6B83\u6B86\u6BB5\u6BD2\u6BD7\u6C1F\u6CC9\u6D0B\u6D32\u6D2A\u6D41\u6D25\u6D0C\u6D31\u6D1E\u6D17"],["aca1","\u6D3B\u6D3D\u6D3E\u6D36\u6D1B\u6CF5\u6D39\u6D27\u6D38\u6D29\u6D2E\u6D35\u6D0E\u6D2B\u70AB\u70BA\u70B3\u70AC\u70AF\u70AD\u70B8\u70AE\u70A4\u7230\u7272\u726F\u7274\u72E9\u72E0\u72E1\u73B7\u73CA\u73BB\u73B2\u73CD\u73C0\u73B3\u751A\u752D\u754F\u754C\u754E\u754B\u75AB\u75A4\u75A5\u75A2\u75A3\u7678\u7686\u7687\u7688\u76C8\u76C6\u76C3\u76C5\u7701\u76F9\u76F8\u7709\u770B\u76FE\u76FC\u7707\u77DC\u7802\u7814\u780C\u780D\u7946\u7949\u7948\u7947\u79B9\u79BA\u79D1\u79D2\u79CB\u7A7F\u7A81\u7AFF\u7AFD\u7C7D\u7D02\u7D05\u7D00\u7D09\u7D07\u7D04\u7D06\u7F38\u7F8E\u7FBF\u8004"],["ad40","\u8010\u800D\u8011\u8036\u80D6\u80E5\u80DA\u80C3\u80C4\u80CC\u80E1\u80DB\u80CE\u80DE\u80E4\u80DD\u81F4\u8222\u82E7\u8303\u8305\u82E3\u82DB\u82E6\u8304\u82E5\u8302\u8309\u82D2\u82D7\u82F1\u8301\u82DC\u82D4\u82D1\u82DE\u82D3\u82DF\u82EF\u8306\u8650\u8679\u867B\u867A\u884D\u886B\u8981\u89D4\u8A08\u8A02\u8A03\u8C9E\u8CA0\u8D74\u8D73\u8DB4\u8ECD\u8ECC\u8FF0\u8FE6\u8FE2\u8FEA\u8FE5"],["ada1","\u8FED\u8FEB\u8FE4\u8FE8\u90CA\u90CE\u90C1\u90C3\u914B\u914A\u91CD\u9582\u9650\u964B\u964C\u964D\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u4E58\u4EB3\u500C\u500D\u5023\u4FEF\u5026\u5025\u4FF8\u5029\u5016\u5006\u503C\u501F\u501A\u5012\u5011\u4FFA\u5000\u5014\u5028\u4FF1\u5021\u500B\u5019\u5018\u4FF3\u4FEE\u502D\u502A\u4FFE\u502B\u5009\u517C\u51A4\u51A5\u51A2\u51CD\u51CC\u51C6\u51CB\u5256\u525C\u5254\u525B\u525D\u532A\u537F\u539F\u539D\u53DF\u54E8\u5510\u5501\u5537\u54FC\u54E5\u54F2\u5506\u54FA\u5514\u54E9\u54ED\u54E1\u5509\u54EE\u54EA"],["ae40","\u54E6\u5527\u5507\u54FD\u550F\u5703\u5704\u57C2\u57D4\u57CB\u57C3\u5809\u590F\u5957\u5958\u595A\u5A11\u5A18\u5A1C\u5A1F\u5A1B\u5A13\u59EC\u5A20\u5A23\u5A29\u5A25\u5A0C\u5A09\u5B6B\u5C58\u5BB0\u5BB3\u5BB6\u5BB4\u5BAE\u5BB5\u5BB9\u5BB8\u5C04\u5C51\u5C55\u5C50\u5CED\u5CFD\u5CFB\u5CEA\u5CE8\u5CF0\u5CF6\u5D01\u5CF4\u5DEE\u5E2D\u5E2B\u5EAB\u5EAD\u5EA7\u5F31\u5F92\u5F91\u5F90\u6059"],["aea1","\u6063\u6065\u6050\u6055\u606D\u6069\u606F\u6084\u609F\u609A\u608D\u6094\u608C\u6085\u6096\u6247\u62F3\u6308\u62FF\u634E\u633E\u632F\u6355\u6342\u6346\u634F\u6349\u633A\u6350\u633D\u632A\u632B\u6328\u634D\u634C\u6548\u6549\u6599\u65C1\u65C5\u6642\u6649\u664F\u6643\u6652\u664C\u6645\u6641\u66F8\u6714\u6715\u6717\u6821\u6838\u6848\u6846\u6853\u6839\u6842\u6854\u6829\u68B3\u6817\u684C\u6851\u683D\u67F4\u6850\u6840\u683C\u6843\u682A\u6845\u6813\u6818\u6841\u6B8A\u6B89\u6BB7\u6C23\u6C27\u6C28\u6C26\u6C24\u6CF0\u6D6A\u6D95\u6D88\u6D87\u6D66\u6D78\u6D77\u6D59\u6D93"],["af40","\u6D6C\u6D89\u6D6E\u6D5A\u6D74\u6D69\u6D8C\u6D8A\u6D79\u6D85\u6D65\u6D94\u70CA\u70D8\u70E4\u70D9\u70C8\u70CF\u7239\u7279\u72FC\u72F9\u72FD\u72F8\u72F7\u7386\u73ED\u7409\u73EE\u73E0\u73EA\u73DE\u7554\u755D\u755C\u755A\u7559\u75BE\u75C5\u75C7\u75B2\u75B3\u75BD\u75BC\u75B9\u75C2\u75B8\u768B\u76B0\u76CA\u76CD\u76CE\u7729\u771F\u7720\u7728\u77E9\u7830\u7827\u7838\u781D\u7834\u7837"],["afa1","\u7825\u782D\u7820\u781F\u7832\u7955\u7950\u7960\u795F\u7956\u795E\u795D\u7957\u795A\u79E4\u79E3\u79E7\u79DF\u79E6\u79E9\u79D8\u7A84\u7A88\u7AD9\u7B06\u7B11\u7C89\u7D21\u7D17\u7D0B\u7D0A\u7D20\u7D22\u7D14\u7D10\u7D15\u7D1A\u7D1C\u7D0D\u7D19\u7D1B\u7F3A\u7F5F\u7F94\u7FC5\u7FC1\u8006\u8018\u8015\u8019\u8017\u803D\u803F\u80F1\u8102\u80F0\u8105\u80ED\u80F4\u8106\u80F8\u80F3\u8108\u80FD\u810A\u80FC\u80EF\u81ED\u81EC\u8200\u8210\u822A\u822B\u8228\u822C\u82BB\u832B\u8352\u8354\u834A\u8338\u8350\u8349\u8335\u8334\u834F\u8332\u8339\u8336\u8317\u8340\u8331\u8328\u8343"],["b040","\u8654\u868A\u86AA\u8693\u86A4\u86A9\u868C\u86A3\u869C\u8870\u8877\u8881\u8882\u887D\u8879\u8A18\u8A10\u8A0E\u8A0C\u8A15\u8A0A\u8A17\u8A13\u8A16\u8A0F\u8A11\u8C48\u8C7A\u8C79\u8CA1\u8CA2\u8D77\u8EAC\u8ED2\u8ED4\u8ECF\u8FB1\u9001\u9006\u8FF7\u9000\u8FFA\u8FF4\u9003\u8FFD\u9005\u8FF8\u9095\u90E1\u90DD\u90E2\u9152\u914D\u914C\u91D8\u91DD\u91D7\u91DC\u91D9\u9583\u9662\u9663\u9661"],["b0a1","\u965B\u965D\u9664\u9658\u965E\u96BB\u98E2\u99AC\u9AA8\u9AD8\u9B25\u9B32\u9B3C\u4E7E\u507A\u507D\u505C\u5047\u5043\u504C\u505A\u5049\u5065\u5076\u504E\u5055\u5075\u5074\u5077\u504F\u500F\u506F\u506D\u515C\u5195\u51F0\u526A\u526F\u52D2\u52D9\u52D8\u52D5\u5310\u530F\u5319\u533F\u5340\u533E\u53C3\u66FC\u5546\u556A\u5566\u5544\u555E\u5561\u5543\u554A\u5531\u5556\u554F\u5555\u552F\u5564\u5538\u552E\u555C\u552C\u5563\u5533\u5541\u5557\u5708\u570B\u5709\u57DF\u5805\u580A\u5806\u57E0\u57E4\u57FA\u5802\u5835\u57F7\u57F9\u5920\u5962\u5A36\u5A41\u5A49\u5A66\u5A6A\u5A40"],["b140","\u5A3C\u5A62\u5A5A\u5A46\u5A4A\u5B70\u5BC7\u5BC5\u5BC4\u5BC2\u5BBF\u5BC6\u5C09\u5C08\u5C07\u5C60\u5C5C\u5C5D\u5D07\u5D06\u5D0E\u5D1B\u5D16\u5D22\u5D11\u5D29\u5D14\u5D19\u5D24\u5D27\u5D17\u5DE2\u5E38\u5E36\u5E33\u5E37\u5EB7\u5EB8\u5EB6\u5EB5\u5EBE\u5F35\u5F37\u5F57\u5F6C\u5F69\u5F6B\u5F97\u5F99\u5F9E\u5F98\u5FA1\u5FA0\u5F9C\u607F\u60A3\u6089\u60A0\u60A8\u60CB\u60B4\u60E6\u60BD"],["b1a1","\u60C5\u60BB\u60B5\u60DC\u60BC\u60D8\u60D5\u60C6\u60DF\u60B8\u60DA\u60C7\u621A\u621B\u6248\u63A0\u63A7\u6372\u6396\u63A2\u63A5\u6377\u6367\u6398\u63AA\u6371\u63A9\u6389\u6383\u639B\u636B\u63A8\u6384\u6388\u6399\u63A1\u63AC\u6392\u638F\u6380\u637B\u6369\u6368\u637A\u655D\u6556\u6551\u6559\u6557\u555F\u654F\u6558\u6555\u6554\u659C\u659B\u65AC\u65CF\u65CB\u65CC\u65CE\u665D\u665A\u6664\u6668\u6666\u665E\u66F9\u52D7\u671B\u6881\u68AF\u68A2\u6893\u68B5\u687F\u6876\u68B1\u68A7\u6897\u68B0\u6883\u68C4\u68AD\u6886\u6885\u6894\u689D\u68A8\u689F\u68A1\u6882\u6B32\u6BBA"],["b240","\u6BEB\u6BEC\u6C2B\u6D8E\u6DBC\u6DF3\u6DD9\u6DB2\u6DE1\u6DCC\u6DE4\u6DFB\u6DFA\u6E05\u6DC7\u6DCB\u6DAF\u6DD1\u6DAE\u6DDE\u6DF9\u6DB8\u6DF7\u6DF5\u6DC5\u6DD2\u6E1A\u6DB5\u6DDA\u6DEB\u6DD8\u6DEA\u6DF1\u6DEE\u6DE8\u6DC6\u6DC4\u6DAA\u6DEC\u6DBF\u6DE6\u70F9\u7109\u710A\u70FD\u70EF\u723D\u727D\u7281\u731C\u731B\u7316\u7313\u7319\u7387\u7405\u740A\u7403\u7406\u73FE\u740D\u74E0\u74F6"],["b2a1","\u74F7\u751C\u7522\u7565\u7566\u7562\u7570\u758F\u75D4\u75D5\u75B5\u75CA\u75CD\u768E\u76D4\u76D2\u76DB\u7737\u773E\u773C\u7736\u7738\u773A\u786B\u7843\u784E\u7965\u7968\u796D\u79FB\u7A92\u7A95\u7B20\u7B28\u7B1B\u7B2C\u7B26\u7B19\u7B1E\u7B2E\u7C92\u7C97\u7C95\u7D46\u7D43\u7D71\u7D2E\u7D39\u7D3C\u7D40\u7D30\u7D33\u7D44\u7D2F\u7D42\u7D32\u7D31\u7F3D\u7F9E\u7F9A\u7FCC\u7FCE\u7FD2\u801C\u804A\u8046\u812F\u8116\u8123\u812B\u8129\u8130\u8124\u8202\u8235\u8237\u8236\u8239\u838E\u839E\u8398\u8378\u83A2\u8396\u83BD\u83AB\u8392\u838A\u8393\u8389\u83A0\u8377\u837B\u837C"],["b340","\u8386\u83A7\u8655\u5F6A\u86C7\u86C0\u86B6\u86C4\u86B5\u86C6\u86CB\u86B1\u86AF\u86C9\u8853\u889E\u8888\u88AB\u8892\u8896\u888D\u888B\u8993\u898F\u8A2A\u8A1D\u8A23\u8A25\u8A31\u8A2D\u8A1F\u8A1B\u8A22\u8C49\u8C5A\u8CA9\u8CAC\u8CAB\u8CA8\u8CAA\u8CA7\u8D67\u8D66\u8DBE\u8DBA\u8EDB\u8EDF\u9019\u900D\u901A\u9017\u9023\u901F\u901D\u9010\u9015\u901E\u9020\u900F\u9022\u9016\u901B\u9014"],["b3a1","\u90E8\u90ED\u90FD\u9157\u91CE\u91F5\u91E6\u91E3\u91E7\u91ED\u91E9\u9589\u966A\u9675\u9673\u9678\u9670\u9674\u9676\u9677\u966C\u96C0\u96EA\u96E9\u7AE0\u7ADF\u9802\u9803\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u50A2\u508D\u5085\u5099\u5091\u5080\u5096\u5098\u509A\u6700\u51F1\u5272\u5274\u5275\u5269\u52DE\u52DD\u52DB\u535A\u53A5\u557B\u5580\u55A7\u557C\u558A\u559D\u5598\u5582\u559C\u55AA\u5594\u5587\u558B\u5583\u55B3\u55AE\u559F\u553E\u55B2\u559A\u55BB\u55AC\u55B1\u557E\u5589\u55AB\u5599\u570D\u582F\u582A\u5834\u5824\u5830\u5831\u5821\u581D\u5820\u58F9\u58FA\u5960"],["b440","\u5A77\u5A9A\u5A7F\u5A92\u5A9B\u5AA7\u5B73\u5B71\u5BD2\u5BCC\u5BD3\u5BD0\u5C0A\u5C0B\u5C31\u5D4C\u5D50\u5D34\u5D47\u5DFD\u5E45\u5E3D\u5E40\u5E43\u5E7E\u5ECA\u5EC1\u5EC2\u5EC4\u5F3C\u5F6D\u5FA9\u5FAA\u5FA8\u60D1\u60E1\u60B2\u60B6\u60E0\u611C\u6123\u60FA\u6115\u60F0\u60FB\u60F4\u6168\u60F1\u610E\u60F6\u6109\u6100\u6112\u621F\u6249\u63A3\u638C\u63CF\u63C0\u63E9\u63C9\u63C6\u63CD"],["b4a1","\u63D2\u63E3\u63D0\u63E1\u63D6\u63ED\u63EE\u6376\u63F4\u63EA\u63DB\u6452\u63DA\u63F9\u655E\u6566\u6562\u6563\u6591\u6590\u65AF\u666E\u6670\u6674\u6676\u666F\u6691\u667A\u667E\u6677\u66FE\u66FF\u671F\u671D\u68FA\u68D5\u68E0\u68D8\u68D7\u6905\u68DF\u68F5\u68EE\u68E7\u68F9\u68D2\u68F2\u68E3\u68CB\u68CD\u690D\u6912\u690E\u68C9\u68DA\u696E\u68FB\u6B3E\u6B3A\u6B3D\u6B98\u6B96\u6BBC\u6BEF\u6C2E\u6C2F\u6C2C\u6E2F\u6E38\u6E54\u6E21\u6E32\u6E67\u6E4A\u6E20\u6E25\u6E23\u6E1B\u6E5B\u6E58\u6E24\u6E56\u6E6E\u6E2D\u6E26\u6E6F\u6E34\u6E4D\u6E3A\u6E2C\u6E43\u6E1D\u6E3E\u6ECB"],["b540","\u6E89\u6E19\u6E4E\u6E63\u6E44\u6E72\u6E69\u6E5F\u7119\u711A\u7126\u7130\u7121\u7136\u716E\u711C\u724C\u7284\u7280\u7336\u7325\u7334\u7329\u743A\u742A\u7433\u7422\u7425\u7435\u7436\u7434\u742F\u741B\u7426\u7428\u7525\u7526\u756B\u756A\u75E2\u75DB\u75E3\u75D9\u75D8\u75DE\u75E0\u767B\u767C\u7696\u7693\u76B4\u76DC\u774F\u77ED\u785D\u786C\u786F\u7A0D\u7A08\u7A0B\u7A05\u7A00\u7A98"],["b5a1","\u7A97\u7A96\u7AE5\u7AE3\u7B49\u7B56\u7B46\u7B50\u7B52\u7B54\u7B4D\u7B4B\u7B4F\u7B51\u7C9F\u7CA5\u7D5E\u7D50\u7D68\u7D55\u7D2B\u7D6E\u7D72\u7D61\u7D66\u7D62\u7D70\u7D73\u5584\u7FD4\u7FD5\u800B\u8052\u8085\u8155\u8154\u814B\u8151\u814E\u8139\u8146\u813E\u814C\u8153\u8174\u8212\u821C\u83E9\u8403\u83F8\u840D\u83E0\u83C5\u840B\u83C1\u83EF\u83F1\u83F4\u8457\u840A\u83F0\u840C\u83CC\u83FD\u83F2\u83CA\u8438\u840E\u8404\u83DC\u8407\u83D4\u83DF\u865B\u86DF\u86D9\u86ED\u86D4\u86DB\u86E4\u86D0\u86DE\u8857\u88C1\u88C2\u88B1\u8983\u8996\u8A3B\u8A60\u8A55\u8A5E\u8A3C\u8A41"],["b640","\u8A54\u8A5B\u8A50\u8A46\u8A34\u8A3A\u8A36\u8A56\u8C61\u8C82\u8CAF\u8CBC\u8CB3\u8CBD\u8CC1\u8CBB\u8CC0\u8CB4\u8CB7\u8CB6\u8CBF\u8CB8\u8D8A\u8D85\u8D81\u8DCE\u8DDD\u8DCB\u8DDA\u8DD1\u8DCC\u8DDB\u8DC6\u8EFB\u8EF8\u8EFC\u8F9C\u902E\u9035\u9031\u9038\u9032\u9036\u9102\u90F5\u9109\u90FE\u9163\u9165\u91CF\u9214\u9215\u9223\u9209\u921E\u920D\u9210\u9207\u9211\u9594\u958F\u958B\u9591"],["b6a1","\u9593\u9592\u958E\u968A\u968E\u968B\u967D\u9685\u9686\u968D\u9672\u9684\u96C1\u96C5\u96C4\u96C6\u96C7\u96EF\u96F2\u97CC\u9805\u9806\u9808\u98E7\u98EA\u98EF\u98E9\u98F2\u98ED\u99AE\u99AD\u9EC3\u9ECD\u9ED1\u4E82\u50AD\u50B5\u50B2\u50B3\u50C5\u50BE\u50AC\u50B7\u50BB\u50AF\u50C7\u527F\u5277\u527D\u52DF\u52E6\u52E4\u52E2\u52E3\u532F\u55DF\u55E8\u55D3\u55E6\u55CE\u55DC\u55C7\u55D1\u55E3\u55E4\u55EF\u55DA\u55E1\u55C5\u55C6\u55E5\u55C9\u5712\u5713\u585E\u5851\u5858\u5857\u585A\u5854\u586B\u584C\u586D\u584A\u5862\u5852\u584B\u5967\u5AC1\u5AC9\u5ACC\u5ABE\u5ABD\u5ABC"],["b740","\u5AB3\u5AC2\u5AB2\u5D69\u5D6F\u5E4C\u5E79\u5EC9\u5EC8\u5F12\u5F59\u5FAC\u5FAE\u611A\u610F\u6148\u611F\u60F3\u611B\u60F9\u6101\u6108\u614E\u614C\u6144\u614D\u613E\u6134\u6127\u610D\u6106\u6137\u6221\u6222\u6413\u643E\u641E\u642A\u642D\u643D\u642C\u640F\u641C\u6414\u640D\u6436\u6416\u6417\u6406\u656C\u659F\u65B0\u6697\u6689\u6687\u6688\u6696\u6684\u6698\u668D\u6703\u6994\u696D"],["b7a1","\u695A\u6977\u6960\u6954\u6975\u6930\u6982\u694A\u6968\u696B\u695E\u6953\u6979\u6986\u695D\u6963\u695B\u6B47\u6B72\u6BC0\u6BBF\u6BD3\u6BFD\u6EA2\u6EAF\u6ED3\u6EB6\u6EC2\u6E90\u6E9D\u6EC7\u6EC5\u6EA5\u6E98\u6EBC\u6EBA\u6EAB\u6ED1\u6E96\u6E9C\u6EC4\u6ED4\u6EAA\u6EA7\u6EB4\u714E\u7159\u7169\u7164\u7149\u7167\u715C\u716C\u7166\u714C\u7165\u715E\u7146\u7168\u7156\u723A\u7252\u7337\u7345\u733F\u733E\u746F\u745A\u7455\u745F\u745E\u7441\u743F\u7459\u745B\u745C\u7576\u7578\u7600\u75F0\u7601\u75F2\u75F1\u75FA\u75FF\u75F4\u75F3\u76DE\u76DF\u775B\u776B\u7766\u775E\u7763"],["b840","\u7779\u776A\u776C\u775C\u7765\u7768\u7762\u77EE\u788E\u78B0\u7897\u7898\u788C\u7889\u787C\u7891\u7893\u787F\u797A\u797F\u7981\u842C\u79BD\u7A1C\u7A1A\u7A20\u7A14\u7A1F\u7A1E\u7A9F\u7AA0\u7B77\u7BC0\u7B60\u7B6E\u7B67\u7CB1\u7CB3\u7CB5\u7D93\u7D79\u7D91\u7D81\u7D8F\u7D5B\u7F6E\u7F69\u7F6A\u7F72\u7FA9\u7FA8\u7FA4\u8056\u8058\u8086\u8084\u8171\u8170\u8178\u8165\u816E\u8173\u816B"],["b8a1","\u8179\u817A\u8166\u8205\u8247\u8482\u8477\u843D\u8431\u8475\u8466\u846B\u8449\u846C\u845B\u843C\u8435\u8461\u8463\u8469\u846D\u8446\u865E\u865C\u865F\u86F9\u8713\u8708\u8707\u8700\u86FE\u86FB\u8702\u8703\u8706\u870A\u8859\u88DF\u88D4\u88D9\u88DC\u88D8\u88DD\u88E1\u88CA\u88D5\u88D2\u899C\u89E3\u8A6B\u8A72\u8A73\u8A66\u8A69\u8A70\u8A87\u8A7C\u8A63\u8AA0\u8A71\u8A85\u8A6D\u8A62\u8A6E\u8A6C\u8A79\u8A7B\u8A3E\u8A68\u8C62\u8C8A\u8C89\u8CCA\u8CC7\u8CC8\u8CC4\u8CB2\u8CC3\u8CC2\u8CC5\u8DE1\u8DDF\u8DE8\u8DEF\u8DF3\u8DFA\u8DEA\u8DE4\u8DE6\u8EB2\u8F03\u8F09\u8EFE\u8F0A"],["b940","\u8F9F\u8FB2\u904B\u904A\u9053\u9042\u9054\u903C\u9055\u9050\u9047\u904F\u904E\u904D\u9051\u903E\u9041\u9112\u9117\u916C\u916A\u9169\u91C9\u9237\u9257\u9238\u923D\u9240\u923E\u925B\u924B\u9264\u9251\u9234\u9249\u924D\u9245\u9239\u923F\u925A\u9598\u9698\u9694\u9695\u96CD\u96CB\u96C9\u96CA\u96F7\u96FB\u96F9\u96F6\u9756\u9774\u9776\u9810\u9811\u9813\u980A\u9812\u980C\u98FC\u98F4"],["b9a1","\u98FD\u98FE\u99B3\u99B1\u99B4\u9AE1\u9CE9\u9E82\u9F0E\u9F13\u9F20\u50E7\u50EE\u50E5\u50D6\u50ED\u50DA\u50D5\u50CF\u50D1\u50F1\u50CE\u50E9\u5162\u51F3\u5283\u5282\u5331\u53AD\u55FE\u5600\u561B\u5617\u55FD\u5614\u5606\u5609\u560D\u560E\u55F7\u5616\u561F\u5608\u5610\u55F6\u5718\u5716\u5875\u587E\u5883\u5893\u588A\u5879\u5885\u587D\u58FD\u5925\u5922\u5924\u596A\u5969\u5AE1\u5AE6\u5AE9\u5AD7\u5AD6\u5AD8\u5AE3\u5B75\u5BDE\u5BE7\u5BE1\u5BE5\u5BE6\u5BE8\u5BE2\u5BE4\u5BDF\u5C0D\u5C62\u5D84\u5D87\u5E5B\u5E63\u5E55\u5E57\u5E54\u5ED3\u5ED6\u5F0A\u5F46\u5F70\u5FB9\u6147"],["ba40","\u613F\u614B\u6177\u6162\u6163\u615F\u615A\u6158\u6175\u622A\u6487\u6458\u6454\u64A4\u6478\u645F\u647A\u6451\u6467\u6434\u646D\u647B\u6572\u65A1\u65D7\u65D6\u66A2\u66A8\u669D\u699C\u69A8\u6995\u69C1\u69AE\u69D3\u69CB\u699B\u69B7\u69BB\u69AB\u69B4\u69D0\u69CD\u69AD\u69CC\u69A6\u69C3\u69A3\u6B49\u6B4C\u6C33\u6F33\u6F14\u6EFE\u6F13\u6EF4\u6F29\u6F3E\u6F20\u6F2C\u6F0F\u6F02\u6F22"],["baa1","\u6EFF\u6EEF\u6F06\u6F31\u6F38\u6F32\u6F23\u6F15\u6F2B\u6F2F\u6F88\u6F2A\u6EEC\u6F01\u6EF2\u6ECC\u6EF7\u7194\u7199\u717D\u718A\u7184\u7192\u723E\u7292\u7296\u7344\u7350\u7464\u7463\u746A\u7470\u746D\u7504\u7591\u7627\u760D\u760B\u7609\u7613\u76E1\u76E3\u7784\u777D\u777F\u7761\u78C1\u789F\u78A7\u78B3\u78A9\u78A3\u798E\u798F\u798D\u7A2E\u7A31\u7AAA\u7AA9\u7AED\u7AEF\u7BA1\u7B95\u7B8B\u7B75\u7B97\u7B9D\u7B94\u7B8F\u7BB8\u7B87\u7B84\u7CB9\u7CBD\u7CBE\u7DBB\u7DB0\u7D9C\u7DBD\u7DBE\u7DA0\u7DCA\u7DB4\u7DB2\u7DB1\u7DBA\u7DA2\u7DBF\u7DB5\u7DB8\u7DAD\u7DD2\u7DC7\u7DAC"],["bb40","\u7F70\u7FE0\u7FE1\u7FDF\u805E\u805A\u8087\u8150\u8180\u818F\u8188\u818A\u817F\u8182\u81E7\u81FA\u8207\u8214\u821E\u824B\u84C9\u84BF\u84C6\u84C4\u8499\u849E\u84B2\u849C\u84CB\u84B8\u84C0\u84D3\u8490\u84BC\u84D1\u84CA\u873F\u871C\u873B\u8722\u8725\u8734\u8718\u8755\u8737\u8729\u88F3\u8902\u88F4\u88F9\u88F8\u88FD\u88E8\u891A\u88EF\u8AA6\u8A8C\u8A9E\u8AA3\u8A8D\u8AA1\u8A93\u8AA4"],["bba1","\u8AAA\u8AA5\u8AA8\u8A98\u8A91\u8A9A\u8AA7\u8C6A\u8C8D\u8C8C\u8CD3\u8CD1\u8CD2\u8D6B\u8D99\u8D95\u8DFC\u8F14\u8F12\u8F15\u8F13\u8FA3\u9060\u9058\u905C\u9063\u9059\u905E\u9062\u905D\u905B\u9119\u9118\u911E\u9175\u9178\u9177\u9174\u9278\u9280\u9285\u9298\u9296\u927B\u9293\u929C\u92A8\u927C\u9291\u95A1\u95A8\u95A9\u95A3\u95A5\u95A4\u9699\u969C\u969B\u96CC\u96D2\u9700\u977C\u9785\u97F6\u9817\u9818\u98AF\u98B1\u9903\u9905\u990C\u9909\u99C1\u9AAF\u9AB0\u9AE6\u9B41\u9B42\u9CF4\u9CF6\u9CF3\u9EBC\u9F3B\u9F4A\u5104\u5100\u50FB\u50F5\u50F9\u5102\u5108\u5109\u5105\u51DC"],["bc40","\u5287\u5288\u5289\u528D\u528A\u52F0\u53B2\u562E\u563B\u5639\u5632\u563F\u5634\u5629\u5653\u564E\u5657\u5674\u5636\u562F\u5630\u5880\u589F\u589E\u58B3\u589C\u58AE\u58A9\u58A6\u596D\u5B09\u5AFB\u5B0B\u5AF5\u5B0C\u5B08\u5BEE\u5BEC\u5BE9\u5BEB\u5C64\u5C65\u5D9D\u5D94\u5E62\u5E5F\u5E61\u5EE2\u5EDA\u5EDF\u5EDD\u5EE3\u5EE0\u5F48\u5F71\u5FB7\u5FB5\u6176\u6167\u616E\u615D\u6155\u6182"],["bca1","\u617C\u6170\u616B\u617E\u61A7\u6190\u61AB\u618E\u61AC\u619A\u61A4\u6194\u61AE\u622E\u6469\u646F\u6479\u649E\u64B2\u6488\u6490\u64B0\u64A5\u6493\u6495\u64A9\u6492\u64AE\u64AD\u64AB\u649A\u64AC\u6499\u64A2\u64B3\u6575\u6577\u6578\u66AE\u66AB\u66B4\u66B1\u6A23\u6A1F\u69E8\u6A01\u6A1E\u6A19\u69FD\u6A21\u6A13\u6A0A\u69F3\u6A02\u6A05\u69ED\u6A11\u6B50\u6B4E\u6BA4\u6BC5\u6BC6\u6F3F\u6F7C\u6F84\u6F51\u6F66\u6F54\u6F86\u6F6D\u6F5B\u6F78\u6F6E\u6F8E\u6F7A\u6F70\u6F64\u6F97\u6F58\u6ED5\u6F6F\u6F60\u6F5F\u719F\u71AC\u71B1\u71A8\u7256\u729B\u734E\u7357\u7469\u748B\u7483"],["bd40","\u747E\u7480\u757F\u7620\u7629\u761F\u7624\u7626\u7621\u7622\u769A\u76BA\u76E4\u778E\u7787\u778C\u7791\u778B\u78CB\u78C5\u78BA\u78CA\u78BE\u78D5\u78BC\u78D0\u7A3F\u7A3C\u7A40\u7A3D\u7A37\u7A3B\u7AAF\u7AAE\u7BAD\u7BB1\u7BC4\u7BB4\u7BC6\u7BC7\u7BC1\u7BA0\u7BCC\u7CCA\u7DE0\u7DF4\u7DEF\u7DFB\u7DD8\u7DEC\u7DDD\u7DE8\u7DE3\u7DDA\u7DDE\u7DE9\u7D9E\u7DD9\u7DF2\u7DF9\u7F75\u7F77\u7FAF"],["bda1","\u7FE9\u8026\u819B\u819C\u819D\u81A0\u819A\u8198\u8517\u853D\u851A\u84EE\u852C\u852D\u8513\u8511\u8523\u8521\u8514\u84EC\u8525\u84FF\u8506\u8782\u8774\u8776\u8760\u8766\u8778\u8768\u8759\u8757\u874C\u8753\u885B\u885D\u8910\u8907\u8912\u8913\u8915\u890A\u8ABC\u8AD2\u8AC7\u8AC4\u8A95\u8ACB\u8AF8\u8AB2\u8AC9\u8AC2\u8ABF\u8AB0\u8AD6\u8ACD\u8AB6\u8AB9\u8ADB\u8C4C\u8C4E\u8C6C\u8CE0\u8CDE\u8CE6\u8CE4\u8CEC\u8CED\u8CE2\u8CE3\u8CDC\u8CEA\u8CE1\u8D6D\u8D9F\u8DA3\u8E2B\u8E10\u8E1D\u8E22\u8E0F\u8E29\u8E1F\u8E21\u8E1E\u8EBA\u8F1D\u8F1B\u8F1F\u8F29\u8F26\u8F2A\u8F1C\u8F1E"],["be40","\u8F25\u9069\u906E\u9068\u906D\u9077\u9130\u912D\u9127\u9131\u9187\u9189\u918B\u9183\u92C5\u92BB\u92B7\u92EA\u92AC\u92E4\u92C1\u92B3\u92BC\u92D2\u92C7\u92F0\u92B2\u95AD\u95B1\u9704\u9706\u9707\u9709\u9760\u978D\u978B\u978F\u9821\u982B\u981C\u98B3\u990A\u9913\u9912\u9918\u99DD\u99D0\u99DF\u99DB\u99D1\u99D5\u99D2\u99D9\u9AB7\u9AEE\u9AEF\u9B27\u9B45\u9B44\u9B77\u9B6F\u9D06\u9D09"],["bea1","\u9D03\u9EA9\u9EBE\u9ECE\u58A8\u9F52\u5112\u5118\u5114\u5110\u5115\u5180\u51AA\u51DD\u5291\u5293\u52F3\u5659\u566B\u5679\u5669\u5664\u5678\u566A\u5668\u5665\u5671\u566F\u566C\u5662\u5676\u58C1\u58BE\u58C7\u58C5\u596E\u5B1D\u5B34\u5B78\u5BF0\u5C0E\u5F4A\u61B2\u6191\u61A9\u618A\u61CD\u61B6\u61BE\u61CA\u61C8\u6230\u64C5\u64C1\u64CB\u64BB\u64BC\u64DA\u64C4\u64C7\u64C2\u64CD\u64BF\u64D2\u64D4\u64BE\u6574\u66C6\u66C9\u66B9\u66C4\u66C7\u66B8\u6A3D\u6A38\u6A3A\u6A59\u6A6B\u6A58\u6A39\u6A44\u6A62\u6A61\u6A4B\u6A47\u6A35\u6A5F\u6A48\u6B59\u6B77\u6C05\u6FC2\u6FB1\u6FA1"],["bf40","\u6FC3\u6FA4\u6FC1\u6FA7\u6FB3\u6FC0\u6FB9\u6FB6\u6FA6\u6FA0\u6FB4\u71BE\u71C9\u71D0\u71D2\u71C8\u71D5\u71B9\u71CE\u71D9\u71DC\u71C3\u71C4\u7368\u749C\u74A3\u7498\u749F\u749E\u74E2\u750C\u750D\u7634\u7638\u763A\u76E7\u76E5\u77A0\u779E\u779F\u77A5\u78E8\u78DA\u78EC\u78E7\u79A6\u7A4D\u7A4E\u7A46\u7A4C\u7A4B\u7ABA\u7BD9\u7C11\u7BC9\u7BE4\u7BDB\u7BE1\u7BE9\u7BE6\u7CD5\u7CD6\u7E0A"],["bfa1","\u7E11\u7E08\u7E1B\u7E23\u7E1E\u7E1D\u7E09\u7E10\u7F79\u7FB2\u7FF0\u7FF1\u7FEE\u8028\u81B3\u81A9\u81A8\u81FB\u8208\u8258\u8259\u854A\u8559\u8548\u8568\u8569\u8543\u8549\u856D\u856A\u855E\u8783\u879F\u879E\u87A2\u878D\u8861\u892A\u8932\u8925\u892B\u8921\u89AA\u89A6\u8AE6\u8AFA\u8AEB\u8AF1\u8B00\u8ADC\u8AE7\u8AEE\u8AFE\u8B01\u8B02\u8AF7\u8AED\u8AF3\u8AF6\u8AFC\u8C6B\u8C6D\u8C93\u8CF4\u8E44\u8E31\u8E34\u8E42\u8E39\u8E35\u8F3B\u8F2F\u8F38\u8F33\u8FA8\u8FA6\u9075\u9074\u9078\u9072\u907C\u907A\u9134\u9192\u9320\u9336\u92F8\u9333\u932F\u9322\u92FC\u932B\u9304\u931A"],["c040","\u9310\u9326\u9321\u9315\u932E\u9319\u95BB\u96A7\u96A8\u96AA\u96D5\u970E\u9711\u9716\u970D\u9713\u970F\u975B\u975C\u9766\u9798\u9830\u9838\u983B\u9837\u982D\u9839\u9824\u9910\u9928\u991E\u991B\u9921\u991A\u99ED\u99E2\u99F1\u9AB8\u9ABC\u9AFB\u9AED\u9B28\u9B91\u9D15\u9D23\u9D26\u9D28\u9D12\u9D1B\u9ED8\u9ED4\u9F8D\u9F9C\u512A\u511F\u5121\u5132\u52F5\u568E\u5680\u5690\u5685\u5687"],["c0a1","\u568F\u58D5\u58D3\u58D1\u58CE\u5B30\u5B2A\u5B24\u5B7A\u5C37\u5C68\u5DBC\u5DBA\u5DBD\u5DB8\u5E6B\u5F4C\u5FBD\u61C9\u61C2\u61C7\u61E6\u61CB\u6232\u6234\u64CE\u64CA\u64D8\u64E0\u64F0\u64E6\u64EC\u64F1\u64E2\u64ED\u6582\u6583\u66D9\u66D6\u6A80\u6A94\u6A84\u6AA2\u6A9C\u6ADB\u6AA3\u6A7E\u6A97\u6A90\u6AA0\u6B5C\u6BAE\u6BDA\u6C08\u6FD8\u6FF1\u6FDF\u6FE0\u6FDB\u6FE4\u6FEB\u6FEF\u6F80\u6FEC\u6FE1\u6FE9\u6FD5\u6FEE\u6FF0\u71E7\u71DF\u71EE\u71E6\u71E5\u71ED\u71EC\u71F4\u71E0\u7235\u7246\u7370\u7372\u74A9\u74B0\u74A6\u74A8\u7646\u7642\u764C\u76EA\u77B3\u77AA\u77B0\u77AC"],["c140","\u77A7\u77AD\u77EF\u78F7\u78FA\u78F4\u78EF\u7901\u79A7\u79AA\u7A57\u7ABF\u7C07\u7C0D\u7BFE\u7BF7\u7C0C\u7BE0\u7CE0\u7CDC\u7CDE\u7CE2\u7CDF\u7CD9\u7CDD\u7E2E\u7E3E\u7E46\u7E37\u7E32\u7E43\u7E2B\u7E3D\u7E31\u7E45\u7E41\u7E34\u7E39\u7E48\u7E35\u7E3F\u7E2F\u7F44\u7FF3\u7FFC\u8071\u8072\u8070\u806F\u8073\u81C6\u81C3\u81BA\u81C2\u81C0\u81BF\u81BD\u81C9\u81BE\u81E8\u8209\u8271\u85AA"],["c1a1","\u8584\u857E\u859C\u8591\u8594\u85AF\u859B\u8587\u85A8\u858A\u8667\u87C0\u87D1\u87B3\u87D2\u87C6\u87AB\u87BB\u87BA\u87C8\u87CB\u893B\u8936\u8944\u8938\u893D\u89AC\u8B0E\u8B17\u8B19\u8B1B\u8B0A\u8B20\u8B1D\u8B04\u8B10\u8C41\u8C3F\u8C73\u8CFA\u8CFD\u8CFC\u8CF8\u8CFB\u8DA8\u8E49\u8E4B\u8E48\u8E4A\u8F44\u8F3E\u8F42\u8F45\u8F3F\u907F\u907D\u9084\u9081\u9082\u9080\u9139\u91A3\u919E\u919C\u934D\u9382\u9328\u9375\u934A\u9365\u934B\u9318\u937E\u936C\u935B\u9370\u935A\u9354\u95CA\u95CB\u95CC\u95C8\u95C6\u96B1\u96B8\u96D6\u971C\u971E\u97A0\u97D3\u9846\u98B6\u9935\u9A01"],["c240","\u99FF\u9BAE\u9BAB\u9BAA\u9BAD\u9D3B\u9D3F\u9E8B\u9ECF\u9EDE\u9EDC\u9EDD\u9EDB\u9F3E\u9F4B\u53E2\u5695\u56AE\u58D9\u58D8\u5B38\u5F5D\u61E3\u6233\u64F4\u64F2\u64FE\u6506\u64FA\u64FB\u64F7\u65B7\u66DC\u6726\u6AB3\u6AAC\u6AC3\u6ABB\u6AB8\u6AC2\u6AAE\u6AAF\u6B5F\u6B78\u6BAF\u7009\u700B\u6FFE\u7006\u6FFA\u7011\u700F\u71FB\u71FC\u71FE\u71F8\u7377\u7375\u74A7\u74BF\u7515\u7656\u7658"],["c2a1","\u7652\u77BD\u77BF\u77BB\u77BC\u790E\u79AE\u7A61\u7A62\u7A60\u7AC4\u7AC5\u7C2B\u7C27\u7C2A\u7C1E\u7C23\u7C21\u7CE7\u7E54\u7E55\u7E5E\u7E5A\u7E61\u7E52\u7E59\u7F48\u7FF9\u7FFB\u8077\u8076\u81CD\u81CF\u820A\u85CF\u85A9\u85CD\u85D0\u85C9\u85B0\u85BA\u85B9\u85A6\u87EF\u87EC\u87F2\u87E0\u8986\u89B2\u89F4\u8B28\u8B39\u8B2C\u8B2B\u8C50\u8D05\u8E59\u8E63\u8E66\u8E64\u8E5F\u8E55\u8EC0\u8F49\u8F4D\u9087\u9083\u9088\u91AB\u91AC\u91D0\u9394\u938A\u9396\u93A2\u93B3\u93AE\u93AC\u93B0\u9398\u939A\u9397\u95D4\u95D6\u95D0\u95D5\u96E2\u96DC\u96D9\u96DB\u96DE\u9724\u97A3\u97A6"],["c340","\u97AD\u97F9\u984D\u984F\u984C\u984E\u9853\u98BA\u993E\u993F\u993D\u992E\u99A5\u9A0E\u9AC1\u9B03\u9B06\u9B4F\u9B4E\u9B4D\u9BCA\u9BC9\u9BFD\u9BC8\u9BC0\u9D51\u9D5D\u9D60\u9EE0\u9F15\u9F2C\u5133\u56A5\u58DE\u58DF\u58E2\u5BF5\u9F90\u5EEC\u61F2\u61F7\u61F6\u61F5\u6500\u650F\u66E0\u66DD\u6AE5\u6ADD\u6ADA\u6AD3\u701B\u701F\u7028\u701A\u701D\u7015\u7018\u7206\u720D\u7258\u72A2\u7378"],["c3a1","\u737A\u74BD\u74CA\u74E3\u7587\u7586\u765F\u7661\u77C7\u7919\u79B1\u7A6B\u7A69\u7C3E\u7C3F\u7C38\u7C3D\u7C37\u7C40\u7E6B\u7E6D\u7E79\u7E69\u7E6A\u7F85\u7E73\u7FB6\u7FB9\u7FB8\u81D8\u85E9\u85DD\u85EA\u85D5\u85E4\u85E5\u85F7\u87FB\u8805\u880D\u87F9\u87FE\u8960\u895F\u8956\u895E\u8B41\u8B5C\u8B58\u8B49\u8B5A\u8B4E\u8B4F\u8B46\u8B59\u8D08\u8D0A\u8E7C\u8E72\u8E87\u8E76\u8E6C\u8E7A\u8E74\u8F54\u8F4E\u8FAD\u908A\u908B\u91B1\u91AE\u93E1\u93D1\u93DF\u93C3\u93C8\u93DC\u93DD\u93D6\u93E2\u93CD\u93D8\u93E4\u93D7\u93E8\u95DC\u96B4\u96E3\u972A\u9727\u9761\u97DC\u97FB\u985E"],["c440","\u9858\u985B\u98BC\u9945\u9949\u9A16\u9A19\u9B0D\u9BE8\u9BE7\u9BD6\u9BDB\u9D89\u9D61\u9D72\u9D6A\u9D6C\u9E92\u9E97\u9E93\u9EB4\u52F8\u56A8\u56B7\u56B6\u56B4\u56BC\u58E4\u5B40\u5B43\u5B7D\u5BF6\u5DC9\u61F8\u61FA\u6518\u6514\u6519\u66E6\u6727\u6AEC\u703E\u7030\u7032\u7210\u737B\u74CF\u7662\u7665\u7926\u792A\u792C\u792B\u7AC7\u7AF6\u7C4C\u7C43\u7C4D\u7CEF\u7CF0\u8FAE\u7E7D\u7E7C"],["c4a1","\u7E82\u7F4C\u8000\u81DA\u8266\u85FB\u85F9\u8611\u85FA\u8606\u860B\u8607\u860A\u8814\u8815\u8964\u89BA\u89F8\u8B70\u8B6C\u8B66\u8B6F\u8B5F\u8B6B\u8D0F\u8D0D\u8E89\u8E81\u8E85\u8E82\u91B4\u91CB\u9418\u9403\u93FD\u95E1\u9730\u98C4\u9952\u9951\u99A8\u9A2B\u9A30\u9A37\u9A35\u9C13\u9C0D\u9E79\u9EB5\u9EE8\u9F2F\u9F5F\u9F63\u9F61\u5137\u5138\u56C1\u56C0\u56C2\u5914\u5C6C\u5DCD\u61FC\u61FE\u651D\u651C\u6595\u66E9\u6AFB\u6B04\u6AFA\u6BB2\u704C\u721B\u72A7\u74D6\u74D4\u7669\u77D3\u7C50\u7E8F\u7E8C\u7FBC\u8617\u862D\u861A\u8823\u8822\u8821\u881F\u896A\u896C\u89BD\u8B74"],["c540","\u8B77\u8B7D\u8D13\u8E8A\u8E8D\u8E8B\u8F5F\u8FAF\u91BA\u942E\u9433\u9435\u943A\u9438\u9432\u942B\u95E2\u9738\u9739\u9732\u97FF\u9867\u9865\u9957\u9A45\u9A43\u9A40\u9A3E\u9ACF\u9B54\u9B51\u9C2D\u9C25\u9DAF\u9DB4\u9DC2\u9DB8\u9E9D\u9EEF\u9F19\u9F5C\u9F66\u9F67\u513C\u513B\u56C8\u56CA\u56C9\u5B7F\u5DD4\u5DD2\u5F4E\u61FF\u6524\u6B0A\u6B61\u7051\u7058\u7380\u74E4\u758A\u766E\u766C"],["c5a1","\u79B3\u7C60\u7C5F\u807E\u807D\u81DF\u8972\u896F\u89FC\u8B80\u8D16\u8D17\u8E91\u8E93\u8F61\u9148\u9444\u9451\u9452\u973D\u973E\u97C3\u97C1\u986B\u9955\u9A55\u9A4D\u9AD2\u9B1A\u9C49\u9C31\u9C3E\u9C3B\u9DD3\u9DD7\u9F34\u9F6C\u9F6A\u9F94\u56CC\u5DD6\u6200\u6523\u652B\u652A\u66EC\u6B10\u74DA\u7ACA\u7C64\u7C63\u7C65\u7E93\u7E96\u7E94\u81E2\u8638\u863F\u8831\u8B8A\u9090\u908F\u9463\u9460\u9464\u9768\u986F\u995C\u9A5A\u9A5B\u9A57\u9AD3\u9AD4\u9AD1\u9C54\u9C57\u9C56\u9DE5\u9E9F\u9EF4\u56D1\u58E9\u652C\u705E\u7671\u7672\u77D7\u7F50\u7F88\u8836\u8839\u8862\u8B93\u8B92"],["c640","\u8B96\u8277\u8D1B\u91C0\u946A\u9742\u9748\u9744\u97C6\u9870\u9A5F\u9B22\u9B58\u9C5F\u9DF9\u9DFA\u9E7C\u9E7D\u9F07\u9F77\u9F72\u5EF3\u6B16\u7063\u7C6C\u7C6E\u883B\u89C0\u8EA1\u91C1\u9472\u9470\u9871\u995E\u9AD6\u9B23\u9ECC\u7064\u77DA\u8B9A\u9477\u97C9\u9A62\u9A65\u7E9C\u8B9C\u8EAA\u91C5\u947D\u947E\u947C\u9C77\u9C78\u9EF7\u8C54\u947F\u9E1A\u7228\u9A6A\u9B31\u9E1B\u9E1E\u7C72"],["c940","\u4E42\u4E5C\u51F5\u531A\u5382\u4E07\u4E0C\u4E47\u4E8D\u56D7\uFA0C\u5C6E\u5F73\u4E0F\u5187\u4E0E\u4E2E\u4E93\u4EC2\u4EC9\u4EC8\u5198\u52FC\u536C\u53B9\u5720\u5903\u592C\u5C10\u5DFF\u65E1\u6BB3\u6BCC\u6C14\u723F\u4E31\u4E3C\u4EE8\u4EDC\u4EE9\u4EE1\u4EDD\u4EDA\u520C\u531C\u534C\u5722\u5723\u5917\u592F\u5B81\u5B84\u5C12\u5C3B\u5C74\u5C73\u5E04\u5E80\u5E82\u5FC9\u6209\u6250\u6C15"],["c9a1","\u6C36\u6C43\u6C3F\u6C3B\u72AE\u72B0\u738A\u79B8\u808A\u961E\u4F0E\u4F18\u4F2C\u4EF5\u4F14\u4EF1\u4F00\u4EF7\u4F08\u4F1D\u4F02\u4F05\u4F22\u4F13\u4F04\u4EF4\u4F12\u51B1\u5213\u5209\u5210\u52A6\u5322\u531F\u534D\u538A\u5407\u56E1\u56DF\u572E\u572A\u5734\u593C\u5980\u597C\u5985\u597B\u597E\u5977\u597F\u5B56\u5C15\u5C25\u5C7C\u5C7A\u5C7B\u5C7E\u5DDF\u5E75\u5E84\u5F02\u5F1A\u5F74\u5FD5\u5FD4\u5FCF\u625C\u625E\u6264\u6261\u6266\u6262\u6259\u6260\u625A\u6265\u65EF\u65EE\u673E\u6739\u6738\u673B\u673A\u673F\u673C\u6733\u6C18\u6C46\u6C52\u6C5C\u6C4F\u6C4A\u6C54\u6C4B"],["ca40","\u6C4C\u7071\u725E\u72B4\u72B5\u738E\u752A\u767F\u7A75\u7F51\u8278\u827C\u8280\u827D\u827F\u864D\u897E\u9099\u9097\u9098\u909B\u9094\u9622\u9624\u9620\u9623\u4F56\u4F3B\u4F62\u4F49\u4F53\u4F64\u4F3E\u4F67\u4F52\u4F5F\u4F41\u4F58\u4F2D\u4F33\u4F3F\u4F61\u518F\u51B9\u521C\u521E\u5221\u52AD\u52AE\u5309\u5363\u5372\u538E\u538F\u5430\u5437\u542A\u5454\u5445\u5419\u541C\u5425\u5418"],["caa1","\u543D\u544F\u5441\u5428\u5424\u5447\u56EE\u56E7\u56E5\u5741\u5745\u574C\u5749\u574B\u5752\u5906\u5940\u59A6\u5998\u59A0\u5997\u598E\u59A2\u5990\u598F\u59A7\u59A1\u5B8E\u5B92\u5C28\u5C2A\u5C8D\u5C8F\u5C88\u5C8B\u5C89\u5C92\u5C8A\u5C86\u5C93\u5C95\u5DE0\u5E0A\u5E0E\u5E8B\u5E89\u5E8C\u5E88\u5E8D\u5F05\u5F1D\u5F78\u5F76\u5FD2\u5FD1\u5FD0\u5FED\u5FE8\u5FEE\u5FF3\u5FE1\u5FE4\u5FE3\u5FFA\u5FEF\u5FF7\u5FFB\u6000\u5FF4\u623A\u6283\u628C\u628E\u628F\u6294\u6287\u6271\u627B\u627A\u6270\u6281\u6288\u6277\u627D\u6272\u6274\u6537\u65F0\u65F4\u65F3\u65F2\u65F5\u6745\u6747"],["cb40","\u6759\u6755\u674C\u6748\u675D\u674D\u675A\u674B\u6BD0\u6C19\u6C1A\u6C78\u6C67\u6C6B\u6C84\u6C8B\u6C8F\u6C71\u6C6F\u6C69\u6C9A\u6C6D\u6C87\u6C95\u6C9C\u6C66\u6C73\u6C65\u6C7B\u6C8E\u7074\u707A\u7263\u72BF\u72BD\u72C3\u72C6\u72C1\u72BA\u72C5\u7395\u7397\u7393\u7394\u7392\u753A\u7539\u7594\u7595\u7681\u793D\u8034\u8095\u8099\u8090\u8092\u809C\u8290\u828F\u8285\u828E\u8291\u8293"],["cba1","\u828A\u8283\u8284\u8C78\u8FC9\u8FBF\u909F\u90A1\u90A5\u909E\u90A7\u90A0\u9630\u9628\u962F\u962D\u4E33\u4F98\u4F7C\u4F85\u4F7D\u4F80\u4F87\u4F76\u4F74\u4F89\u4F84\u4F77\u4F4C\u4F97\u4F6A\u4F9A\u4F79\u4F81\u4F78\u4F90\u4F9C\u4F94\u4F9E\u4F92\u4F82\u4F95\u4F6B\u4F6E\u519E\u51BC\u51BE\u5235\u5232\u5233\u5246\u5231\u52BC\u530A\u530B\u533C\u5392\u5394\u5487\u547F\u5481\u5491\u5482\u5488\u546B\u547A\u547E\u5465\u546C\u5474\u5466\u548D\u546F\u5461\u5460\u5498\u5463\u5467\u5464\u56F7\u56F9\u576F\u5772\u576D\u576B\u5771\u5770\u5776\u5780\u5775\u577B\u5773\u5774\u5762"],["cc40","\u5768\u577D\u590C\u5945\u59B5\u59BA\u59CF\u59CE\u59B2\u59CC\u59C1\u59B6\u59BC\u59C3\u59D6\u59B1\u59BD\u59C0\u59C8\u59B4\u59C7\u5B62\u5B65\u5B93\u5B95\u5C44\u5C47\u5CAE\u5CA4\u5CA0\u5CB5\u5CAF\u5CA8\u5CAC\u5C9F\u5CA3\u5CAD\u5CA2\u5CAA\u5CA7\u5C9D\u5CA5\u5CB6\u5CB0\u5CA6\u5E17\u5E14\u5E19\u5F28\u5F22\u5F23\u5F24\u5F54\u5F82\u5F7E\u5F7D\u5FDE\u5FE5\u602D\u6026\u6019\u6032\u600B"],["cca1","\u6034\u600A\u6017\u6033\u601A\u601E\u602C\u6022\u600D\u6010\u602E\u6013\u6011\u600C\u6009\u601C\u6214\u623D\u62AD\u62B4\u62D1\u62BE\u62AA\u62B6\u62CA\u62AE\u62B3\u62AF\u62BB\u62A9\u62B0\u62B8\u653D\u65A8\u65BB\u6609\u65FC\u6604\u6612\u6608\u65FB\u6603\u660B\u660D\u6605\u65FD\u6611\u6610\u66F6\u670A\u6785\u676C\u678E\u6792\u6776\u677B\u6798\u6786\u6784\u6774\u678D\u678C\u677A\u679F\u6791\u6799\u6783\u677D\u6781\u6778\u6779\u6794\u6B25\u6B80\u6B7E\u6BDE\u6C1D\u6C93\u6CEC\u6CEB\u6CEE\u6CD9\u6CB6\u6CD4\u6CAD\u6CE7\u6CB7\u6CD0\u6CC2\u6CBA\u6CC3\u6CC6\u6CED\u6CF2"],["cd40","\u6CD2\u6CDD\u6CB4\u6C8A\u6C9D\u6C80\u6CDE\u6CC0\u6D30\u6CCD\u6CC7\u6CB0\u6CF9\u6CCF\u6CE9\u6CD1\u7094\u7098\u7085\u7093\u7086\u7084\u7091\u7096\u7082\u709A\u7083\u726A\u72D6\u72CB\u72D8\u72C9\u72DC\u72D2\u72D4\u72DA\u72CC\u72D1\u73A4\u73A1\u73AD\u73A6\u73A2\u73A0\u73AC\u739D\u74DD\u74E8\u753F\u7540\u753E\u758C\u7598\u76AF\u76F3\u76F1\u76F0\u76F5\u77F8\u77FC\u77F9\u77FB\u77FA"],["cda1","\u77F7\u7942\u793F\u79C5\u7A78\u7A7B\u7AFB\u7C75\u7CFD\u8035\u808F\u80AE\u80A3\u80B8\u80B5\u80AD\u8220\u82A0\u82C0\u82AB\u829A\u8298\u829B\u82B5\u82A7\u82AE\u82BC\u829E\u82BA\u82B4\u82A8\u82A1\u82A9\u82C2\u82A4\u82C3\u82B6\u82A2\u8670\u866F\u866D\u866E\u8C56\u8FD2\u8FCB\u8FD3\u8FCD\u8FD6\u8FD5\u8FD7\u90B2\u90B4\u90AF\u90B3\u90B0\u9639\u963D\u963C\u963A\u9643\u4FCD\u4FC5\u4FD3\u4FB2\u4FC9\u4FCB\u4FC1\u4FD4\u4FDC\u4FD9\u4FBB\u4FB3\u4FDB\u4FC7\u4FD6\u4FBA\u4FC0\u4FB9\u4FEC\u5244\u5249\u52C0\u52C2\u533D\u537C\u5397\u5396\u5399\u5398\u54BA\u54A1\u54AD\u54A5\u54CF"],["ce40","\u54C3\u830D\u54B7\u54AE\u54D6\u54B6\u54C5\u54C6\u54A0\u5470\u54BC\u54A2\u54BE\u5472\u54DE\u54B0\u57B5\u579E\u579F\u57A4\u578C\u5797\u579D\u579B\u5794\u5798\u578F\u5799\u57A5\u579A\u5795\u58F4\u590D\u5953\u59E1\u59DE\u59EE\u5A00\u59F1\u59DD\u59FA\u59FD\u59FC\u59F6\u59E4\u59F2\u59F7\u59DB\u59E9\u59F3\u59F5\u59E0\u59FE\u59F4\u59ED\u5BA8\u5C4C\u5CD0\u5CD8\u5CCC\u5CD7\u5CCB\u5CDB"],["cea1","\u5CDE\u5CDA\u5CC9\u5CC7\u5CCA\u5CD6\u5CD3\u5CD4\u5CCF\u5CC8\u5CC6\u5CCE\u5CDF\u5CF8\u5DF9\u5E21\u5E22\u5E23\u5E20\u5E24\u5EB0\u5EA4\u5EA2\u5E9B\u5EA3\u5EA5\u5F07\u5F2E\u5F56\u5F86\u6037\u6039\u6054\u6072\u605E\u6045\u6053\u6047\u6049\u605B\u604C\u6040\u6042\u605F\u6024\u6044\u6058\u6066\u606E\u6242\u6243\u62CF\u630D\u630B\u62F5\u630E\u6303\u62EB\u62F9\u630F\u630C\u62F8\u62F6\u6300\u6313\u6314\u62FA\u6315\u62FB\u62F0\u6541\u6543\u65AA\u65BF\u6636\u6621\u6632\u6635\u661C\u6626\u6622\u6633\u662B\u663A\u661D\u6634\u6639\u662E\u670F\u6710\u67C1\u67F2\u67C8\u67BA"],["cf40","\u67DC\u67BB\u67F8\u67D8\u67C0\u67B7\u67C5\u67EB\u67E4\u67DF\u67B5\u67CD\u67B3\u67F7\u67F6\u67EE\u67E3\u67C2\u67B9\u67CE\u67E7\u67F0\u67B2\u67FC\u67C6\u67ED\u67CC\u67AE\u67E6\u67DB\u67FA\u67C9\u67CA\u67C3\u67EA\u67CB\u6B28\u6B82\u6B84\u6BB6\u6BD6\u6BD8\u6BE0\u6C20\u6C21\u6D28\u6D34\u6D2D\u6D1F\u6D3C\u6D3F\u6D12\u6D0A\u6CDA\u6D33\u6D04\u6D19\u6D3A\u6D1A\u6D11\u6D00\u6D1D\u6D42"],["cfa1","\u6D01\u6D18\u6D37\u6D03\u6D0F\u6D40\u6D07\u6D20\u6D2C\u6D08\u6D22\u6D09\u6D10\u70B7\u709F\u70BE\u70B1\u70B0\u70A1\u70B4\u70B5\u70A9\u7241\u7249\u724A\u726C\u7270\u7273\u726E\u72CA\u72E4\u72E8\u72EB\u72DF\u72EA\u72E6\u72E3\u7385\u73CC\u73C2\u73C8\u73C5\u73B9\u73B6\u73B5\u73B4\u73EB\u73BF\u73C7\u73BE\u73C3\u73C6\u73B8\u73CB\u74EC\u74EE\u752E\u7547\u7548\u75A7\u75AA\u7679\u76C4\u7708\u7703\u7704\u7705\u770A\u76F7\u76FB\u76FA\u77E7\u77E8\u7806\u7811\u7812\u7805\u7810\u780F\u780E\u7809\u7803\u7813\u794A\u794C\u794B\u7945\u7944\u79D5\u79CD\u79CF\u79D6\u79CE\u7A80"],["d040","\u7A7E\u7AD1\u7B00\u7B01\u7C7A\u7C78\u7C79\u7C7F\u7C80\u7C81\u7D03\u7D08\u7D01\u7F58\u7F91\u7F8D\u7FBE\u8007\u800E\u800F\u8014\u8037\u80D8\u80C7\u80E0\u80D1\u80C8\u80C2\u80D0\u80C5\u80E3\u80D9\u80DC\u80CA\u80D5\u80C9\u80CF\u80D7\u80E6\u80CD\u81FF\u8221\u8294\u82D9\u82FE\u82F9\u8307\u82E8\u8300\u82D5\u833A\u82EB\u82D6\u82F4\u82EC\u82E1\u82F2\u82F5\u830C\u82FB\u82F6\u82F0\u82EA"],["d0a1","\u82E4\u82E0\u82FA\u82F3\u82ED\u8677\u8674\u867C\u8673\u8841\u884E\u8867\u886A\u8869\u89D3\u8A04\u8A07\u8D72\u8FE3\u8FE1\u8FEE\u8FE0\u90F1\u90BD\u90BF\u90D5\u90C5\u90BE\u90C7\u90CB\u90C8\u91D4\u91D3\u9654\u964F\u9651\u9653\u964A\u964E\u501E\u5005\u5007\u5013\u5022\u5030\u501B\u4FF5\u4FF4\u5033\u5037\u502C\u4FF6\u4FF7\u5017\u501C\u5020\u5027\u5035\u502F\u5031\u500E\u515A\u5194\u5193\u51CA\u51C4\u51C5\u51C8\u51CE\u5261\u525A\u5252\u525E\u525F\u5255\u5262\u52CD\u530E\u539E\u5526\u54E2\u5517\u5512\u54E7\u54F3\u54E4\u551A\u54FF\u5504\u5508\u54EB\u5511\u5505\u54F1"],["d140","\u550A\u54FB\u54F7\u54F8\u54E0\u550E\u5503\u550B\u5701\u5702\u57CC\u5832\u57D5\u57D2\u57BA\u57C6\u57BD\u57BC\u57B8\u57B6\u57BF\u57C7\u57D0\u57B9\u57C1\u590E\u594A\u5A19\u5A16\u5A2D\u5A2E\u5A15\u5A0F\u5A17\u5A0A\u5A1E\u5A33\u5B6C\u5BA7\u5BAD\u5BAC\u5C03\u5C56\u5C54\u5CEC\u5CFF\u5CEE\u5CF1\u5CF7\u5D00\u5CF9\u5E29\u5E28\u5EA8\u5EAE\u5EAA\u5EAC\u5F33\u5F30\u5F67\u605D\u605A\u6067"],["d1a1","\u6041\u60A2\u6088\u6080\u6092\u6081\u609D\u6083\u6095\u609B\u6097\u6087\u609C\u608E\u6219\u6246\u62F2\u6310\u6356\u632C\u6344\u6345\u6336\u6343\u63E4\u6339\u634B\u634A\u633C\u6329\u6341\u6334\u6358\u6354\u6359\u632D\u6347\u6333\u635A\u6351\u6338\u6357\u6340\u6348\u654A\u6546\u65C6\u65C3\u65C4\u65C2\u664A\u665F\u6647\u6651\u6712\u6713\u681F\u681A\u6849\u6832\u6833\u683B\u684B\u684F\u6816\u6831\u681C\u6835\u682B\u682D\u682F\u684E\u6844\u6834\u681D\u6812\u6814\u6826\u6828\u682E\u684D\u683A\u6825\u6820\u6B2C\u6B2F\u6B2D\u6B31\u6B34\u6B6D\u8082\u6B88\u6BE6\u6BE4"],["d240","\u6BE8\u6BE3\u6BE2\u6BE7\u6C25\u6D7A\u6D63\u6D64\u6D76\u6D0D\u6D61\u6D92\u6D58\u6D62\u6D6D\u6D6F\u6D91\u6D8D\u6DEF\u6D7F\u6D86\u6D5E\u6D67\u6D60\u6D97\u6D70\u6D7C\u6D5F\u6D82\u6D98\u6D2F\u6D68\u6D8B\u6D7E\u6D80\u6D84\u6D16\u6D83\u6D7B\u6D7D\u6D75\u6D90\u70DC\u70D3\u70D1\u70DD\u70CB\u7F39\u70E2\u70D7\u70D2\u70DE\u70E0\u70D4\u70CD\u70C5\u70C6\u70C7\u70DA\u70CE\u70E1\u7242\u7278"],["d2a1","\u7277\u7276\u7300\u72FA\u72F4\u72FE\u72F6\u72F3\u72FB\u7301\u73D3\u73D9\u73E5\u73D6\u73BC\u73E7\u73E3\u73E9\u73DC\u73D2\u73DB\u73D4\u73DD\u73DA\u73D7\u73D8\u73E8\u74DE\u74DF\u74F4\u74F5\u7521\u755B\u755F\u75B0\u75C1\u75BB\u75C4\u75C0\u75BF\u75B6\u75BA\u768A\u76C9\u771D\u771B\u7710\u7713\u7712\u7723\u7711\u7715\u7719\u771A\u7722\u7727\u7823\u782C\u7822\u7835\u782F\u7828\u782E\u782B\u7821\u7829\u7833\u782A\u7831\u7954\u795B\u794F\u795C\u7953\u7952\u7951\u79EB\u79EC\u79E0\u79EE\u79ED\u79EA\u79DC\u79DE\u79DD\u7A86\u7A89\u7A85\u7A8B\u7A8C\u7A8A\u7A87\u7AD8\u7B10"],["d340","\u7B04\u7B13\u7B05\u7B0F\u7B08\u7B0A\u7B0E\u7B09\u7B12\u7C84\u7C91\u7C8A\u7C8C\u7C88\u7C8D\u7C85\u7D1E\u7D1D\u7D11\u7D0E\u7D18\u7D16\u7D13\u7D1F\u7D12\u7D0F\u7D0C\u7F5C\u7F61\u7F5E\u7F60\u7F5D\u7F5B\u7F96\u7F92\u7FC3\u7FC2\u7FC0\u8016\u803E\u8039\u80FA\u80F2\u80F9\u80F5\u8101\u80FB\u8100\u8201\u822F\u8225\u8333\u832D\u8344\u8319\u8351\u8325\u8356\u833F\u8341\u8326\u831C\u8322"],["d3a1","\u8342\u834E\u831B\u832A\u8308\u833C\u834D\u8316\u8324\u8320\u8337\u832F\u8329\u8347\u8345\u834C\u8353\u831E\u832C\u834B\u8327\u8348\u8653\u8652\u86A2\u86A8\u8696\u868D\u8691\u869E\u8687\u8697\u8686\u868B\u869A\u8685\u86A5\u8699\u86A1\u86A7\u8695\u8698\u868E\u869D\u8690\u8694\u8843\u8844\u886D\u8875\u8876\u8872\u8880\u8871\u887F\u886F\u8883\u887E\u8874\u887C\u8A12\u8C47\u8C57\u8C7B\u8CA4\u8CA3\u8D76\u8D78\u8DB5\u8DB7\u8DB6\u8ED1\u8ED3\u8FFE\u8FF5\u9002\u8FFF\u8FFB\u9004\u8FFC\u8FF6\u90D6\u90E0\u90D9\u90DA\u90E3\u90DF\u90E5\u90D8\u90DB\u90D7\u90DC\u90E4\u9150"],["d440","\u914E\u914F\u91D5\u91E2\u91DA\u965C\u965F\u96BC\u98E3\u9ADF\u9B2F\u4E7F\u5070\u506A\u5061\u505E\u5060\u5053\u504B\u505D\u5072\u5048\u504D\u5041\u505B\u504A\u5062\u5015\u5045\u505F\u5069\u506B\u5063\u5064\u5046\u5040\u506E\u5073\u5057\u5051\u51D0\u526B\u526D\u526C\u526E\u52D6\u52D3\u532D\u539C\u5575\u5576\u553C\u554D\u5550\u5534\u552A\u5551\u5562\u5536\u5535\u5530\u5552\u5545"],["d4a1","\u550C\u5532\u5565\u554E\u5539\u5548\u552D\u553B\u5540\u554B\u570A\u5707\u57FB\u5814\u57E2\u57F6\u57DC\u57F4\u5800\u57ED\u57FD\u5808\u57F8\u580B\u57F3\u57CF\u5807\u57EE\u57E3\u57F2\u57E5\u57EC\u57E1\u580E\u57FC\u5810\u57E7\u5801\u580C\u57F1\u57E9\u57F0\u580D\u5804\u595C\u5A60\u5A58\u5A55\u5A67\u5A5E\u5A38\u5A35\u5A6D\u5A50\u5A5F\u5A65\u5A6C\u5A53\u5A64\u5A57\u5A43\u5A5D\u5A52\u5A44\u5A5B\u5A48\u5A8E\u5A3E\u5A4D\u5A39\u5A4C\u5A70\u5A69\u5A47\u5A51\u5A56\u5A42\u5A5C\u5B72\u5B6E\u5BC1\u5BC0\u5C59\u5D1E\u5D0B\u5D1D\u5D1A\u5D20\u5D0C\u5D28\u5D0D\u5D26\u5D25\u5D0F"],["d540","\u5D30\u5D12\u5D23\u5D1F\u5D2E\u5E3E\u5E34\u5EB1\u5EB4\u5EB9\u5EB2\u5EB3\u5F36\u5F38\u5F9B\u5F96\u5F9F\u608A\u6090\u6086\u60BE\u60B0\u60BA\u60D3\u60D4\u60CF\u60E4\u60D9\u60DD\u60C8\u60B1\u60DB\u60B7\u60CA\u60BF\u60C3\u60CD\u60C0\u6332\u6365\u638A\u6382\u637D\u63BD\u639E\u63AD\u639D\u6397\u63AB\u638E\u636F\u6387\u6390\u636E\u63AF\u6375\u639C\u636D\u63AE\u637C\u63A4\u633B\u639F"],["d5a1","\u6378\u6385\u6381\u6391\u638D\u6370\u6553\u65CD\u6665\u6661\u665B\u6659\u665C\u6662\u6718\u6879\u6887\u6890\u689C\u686D\u686E\u68AE\u68AB\u6956\u686F\u68A3\u68AC\u68A9\u6875\u6874\u68B2\u688F\u6877\u6892\u687C\u686B\u6872\u68AA\u6880\u6871\u687E\u689B\u6896\u688B\u68A0\u6889\u68A4\u6878\u687B\u6891\u688C\u688A\u687D\u6B36\u6B33\u6B37\u6B38\u6B91\u6B8F\u6B8D\u6B8E\u6B8C\u6C2A\u6DC0\u6DAB\u6DB4\u6DB3\u6E74\u6DAC\u6DE9\u6DE2\u6DB7\u6DF6\u6DD4\u6E00\u6DC8\u6DE0\u6DDF\u6DD6\u6DBE\u6DE5\u6DDC\u6DDD\u6DDB\u6DF4\u6DCA\u6DBD\u6DED\u6DF0\u6DBA\u6DD5\u6DC2\u6DCF\u6DC9"],["d640","\u6DD0\u6DF2\u6DD3\u6DFD\u6DD7\u6DCD\u6DE3\u6DBB\u70FA\u710D\u70F7\u7117\u70F4\u710C\u70F0\u7104\u70F3\u7110\u70FC\u70FF\u7106\u7113\u7100\u70F8\u70F6\u710B\u7102\u710E\u727E\u727B\u727C\u727F\u731D\u7317\u7307\u7311\u7318\u730A\u7308\u72FF\u730F\u731E\u7388\u73F6\u73F8\u73F5\u7404\u7401\u73FD\u7407\u7400\u73FA\u73FC\u73FF\u740C\u740B\u73F4\u7408\u7564\u7563\u75CE\u75D2\u75CF"],["d6a1","\u75CB\u75CC\u75D1\u75D0\u768F\u7689\u76D3\u7739\u772F\u772D\u7731\u7732\u7734\u7733\u773D\u7725\u773B\u7735\u7848\u7852\u7849\u784D\u784A\u784C\u7826\u7845\u7850\u7964\u7967\u7969\u796A\u7963\u796B\u7961\u79BB\u79FA\u79F8\u79F6\u79F7\u7A8F\u7A94\u7A90\u7B35\u7B47\u7B34\u7B25\u7B30\u7B22\u7B24\u7B33\u7B18\u7B2A\u7B1D\u7B31\u7B2B\u7B2D\u7B2F\u7B32\u7B38\u7B1A\u7B23\u7C94\u7C98\u7C96\u7CA3\u7D35\u7D3D\u7D38\u7D36\u7D3A\u7D45\u7D2C\u7D29\u7D41\u7D47\u7D3E\u7D3F\u7D4A\u7D3B\u7D28\u7F63\u7F95\u7F9C\u7F9D\u7F9B\u7FCA\u7FCB\u7FCD\u7FD0\u7FD1\u7FC7\u7FCF\u7FC9\u801F"],["d740","\u801E\u801B\u8047\u8043\u8048\u8118\u8125\u8119\u811B\u812D\u811F\u812C\u811E\u8121\u8115\u8127\u811D\u8122\u8211\u8238\u8233\u823A\u8234\u8232\u8274\u8390\u83A3\u83A8\u838D\u837A\u8373\u83A4\u8374\u838F\u8381\u8395\u8399\u8375\u8394\u83A9\u837D\u8383\u838C\u839D\u839B\u83AA\u838B\u837E\u83A5\u83AF\u8388\u8397\u83B0\u837F\u83A6\u8387\u83AE\u8376\u839A\u8659\u8656\u86BF\u86B7"],["d7a1","\u86C2\u86C1\u86C5\u86BA\u86B0\u86C8\u86B9\u86B3\u86B8\u86CC\u86B4\u86BB\u86BC\u86C3\u86BD\u86BE\u8852\u8889\u8895\u88A8\u88A2\u88AA\u889A\u8891\u88A1\u889F\u8898\u88A7\u8899\u889B\u8897\u88A4\u88AC\u888C\u8893\u888E\u8982\u89D6\u89D9\u89D5\u8A30\u8A27\u8A2C\u8A1E\u8C39\u8C3B\u8C5C\u8C5D\u8C7D\u8CA5\u8D7D\u8D7B\u8D79\u8DBC\u8DC2\u8DB9\u8DBF\u8DC1\u8ED8\u8EDE\u8EDD\u8EDC\u8ED7\u8EE0\u8EE1\u9024\u900B\u9011\u901C\u900C\u9021\u90EF\u90EA\u90F0\u90F4\u90F2\u90F3\u90D4\u90EB\u90EC\u90E9\u9156\u9158\u915A\u9153\u9155\u91EC\u91F4\u91F1\u91F3\u91F8\u91E4\u91F9\u91EA"],["d840","\u91EB\u91F7\u91E8\u91EE\u957A\u9586\u9588\u967C\u966D\u966B\u9671\u966F\u96BF\u976A\u9804\u98E5\u9997\u509B\u5095\u5094\u509E\u508B\u50A3\u5083\u508C\u508E\u509D\u5068\u509C\u5092\u5082\u5087\u515F\u51D4\u5312\u5311\u53A4\u53A7\u5591\u55A8\u55A5\u55AD\u5577\u5645\u55A2\u5593\u5588\u558F\u55B5\u5581\u55A3\u5592\u55A4\u557D\u558C\u55A6\u557F\u5595\u55A1\u558E\u570C\u5829\u5837"],["d8a1","\u5819\u581E\u5827\u5823\u5828\u57F5\u5848\u5825\u581C\u581B\u5833\u583F\u5836\u582E\u5839\u5838\u582D\u582C\u583B\u5961\u5AAF\u5A94\u5A9F\u5A7A\u5AA2\u5A9E\u5A78\u5AA6\u5A7C\u5AA5\u5AAC\u5A95\u5AAE\u5A37\u5A84\u5A8A\u5A97\u5A83\u5A8B\u5AA9\u5A7B\u5A7D\u5A8C\u5A9C\u5A8F\u5A93\u5A9D\u5BEA\u5BCD\u5BCB\u5BD4\u5BD1\u5BCA\u5BCE\u5C0C\u5C30\u5D37\u5D43\u5D6B\u5D41\u5D4B\u5D3F\u5D35\u5D51\u5D4E\u5D55\u5D33\u5D3A\u5D52\u5D3D\u5D31\u5D59\u5D42\u5D39\u5D49\u5D38\u5D3C\u5D32\u5D36\u5D40\u5D45\u5E44\u5E41\u5F58\u5FA6\u5FA5\u5FAB\u60C9\u60B9\u60CC\u60E2\u60CE\u60C4\u6114"],["d940","\u60F2\u610A\u6116\u6105\u60F5\u6113\u60F8\u60FC\u60FE\u60C1\u6103\u6118\u611D\u6110\u60FF\u6104\u610B\u624A\u6394\u63B1\u63B0\u63CE\u63E5\u63E8\u63EF\u63C3\u649D\u63F3\u63CA\u63E0\u63F6\u63D5\u63F2\u63F5\u6461\u63DF\u63BE\u63DD\u63DC\u63C4\u63D8\u63D3\u63C2\u63C7\u63CC\u63CB\u63C8\u63F0\u63D7\u63D9\u6532\u6567\u656A\u6564\u655C\u6568\u6565\u658C\u659D\u659E\u65AE\u65D0\u65D2"],["d9a1","\u667C\u666C\u667B\u6680\u6671\u6679\u666A\u6672\u6701\u690C\u68D3\u6904\u68DC\u692A\u68EC\u68EA\u68F1\u690F\u68D6\u68F7\u68EB\u68E4\u68F6\u6913\u6910\u68F3\u68E1\u6907\u68CC\u6908\u6970\u68B4\u6911\u68EF\u68C6\u6914\u68F8\u68D0\u68FD\u68FC\u68E8\u690B\u690A\u6917\u68CE\u68C8\u68DD\u68DE\u68E6\u68F4\u68D1\u6906\u68D4\u68E9\u6915\u6925\u68C7\u6B39\u6B3B\u6B3F\u6B3C\u6B94\u6B97\u6B99\u6B95\u6BBD\u6BF0\u6BF2\u6BF3\u6C30\u6DFC\u6E46\u6E47\u6E1F\u6E49\u6E88\u6E3C\u6E3D\u6E45\u6E62\u6E2B\u6E3F\u6E41\u6E5D\u6E73\u6E1C\u6E33\u6E4B\u6E40\u6E51\u6E3B\u6E03\u6E2E\u6E5E"],["da40","\u6E68\u6E5C\u6E61\u6E31\u6E28\u6E60\u6E71\u6E6B\u6E39\u6E22\u6E30\u6E53\u6E65\u6E27\u6E78\u6E64\u6E77\u6E55\u6E79\u6E52\u6E66\u6E35\u6E36\u6E5A\u7120\u711E\u712F\u70FB\u712E\u7131\u7123\u7125\u7122\u7132\u711F\u7128\u713A\u711B\u724B\u725A\u7288\u7289\u7286\u7285\u728B\u7312\u730B\u7330\u7322\u7331\u7333\u7327\u7332\u732D\u7326\u7323\u7335\u730C\u742E\u742C\u7430\u742B\u7416"],["daa1","\u741A\u7421\u742D\u7431\u7424\u7423\u741D\u7429\u7420\u7432\u74FB\u752F\u756F\u756C\u75E7\u75DA\u75E1\u75E6\u75DD\u75DF\u75E4\u75D7\u7695\u7692\u76DA\u7746\u7747\u7744\u774D\u7745\u774A\u774E\u774B\u774C\u77DE\u77EC\u7860\u7864\u7865\u785C\u786D\u7871\u786A\u786E\u7870\u7869\u7868\u785E\u7862\u7974\u7973\u7972\u7970\u7A02\u7A0A\u7A03\u7A0C\u7A04\u7A99\u7AE6\u7AE4\u7B4A\u7B3B\u7B44\u7B48\u7B4C\u7B4E\u7B40\u7B58\u7B45\u7CA2\u7C9E\u7CA8\u7CA1\u7D58\u7D6F\u7D63\u7D53\u7D56\u7D67\u7D6A\u7D4F\u7D6D\u7D5C\u7D6B\u7D52\u7D54\u7D69\u7D51\u7D5F\u7D4E\u7F3E\u7F3F\u7F65"],["db40","\u7F66\u7FA2\u7FA0\u7FA1\u7FD7\u8051\u804F\u8050\u80FE\u80D4\u8143\u814A\u8152\u814F\u8147\u813D\u814D\u813A\u81E6\u81EE\u81F7\u81F8\u81F9\u8204\u823C\u823D\u823F\u8275\u833B\u83CF\u83F9\u8423\u83C0\u83E8\u8412\u83E7\u83E4\u83FC\u83F6\u8410\u83C6\u83C8\u83EB\u83E3\u83BF\u8401\u83DD\u83E5\u83D8\u83FF\u83E1\u83CB\u83CE\u83D6\u83F5\u83C9\u8409\u840F\u83DE\u8411\u8406\u83C2\u83F3"],["dba1","\u83D5\u83FA\u83C7\u83D1\u83EA\u8413\u83C3\u83EC\u83EE\u83C4\u83FB\u83D7\u83E2\u841B\u83DB\u83FE\u86D8\u86E2\u86E6\u86D3\u86E3\u86DA\u86EA\u86DD\u86EB\u86DC\u86EC\u86E9\u86D7\u86E8\u86D1\u8848\u8856\u8855\u88BA\u88D7\u88B9\u88B8\u88C0\u88BE\u88B6\u88BC\u88B7\u88BD\u88B2\u8901\u88C9\u8995\u8998\u8997\u89DD\u89DA\u89DB\u8A4E\u8A4D\u8A39\u8A59\u8A40\u8A57\u8A58\u8A44\u8A45\u8A52\u8A48\u8A51\u8A4A\u8A4C\u8A4F\u8C5F\u8C81\u8C80\u8CBA\u8CBE\u8CB0\u8CB9\u8CB5\u8D84\u8D80\u8D89\u8DD8\u8DD3\u8DCD\u8DC7\u8DD6\u8DDC\u8DCF\u8DD5\u8DD9\u8DC8\u8DD7\u8DC5\u8EEF\u8EF7\u8EFA"],["dc40","\u8EF9\u8EE6\u8EEE\u8EE5\u8EF5\u8EE7\u8EE8\u8EF6\u8EEB\u8EF1\u8EEC\u8EF4\u8EE9\u902D\u9034\u902F\u9106\u912C\u9104\u90FF\u90FC\u9108\u90F9\u90FB\u9101\u9100\u9107\u9105\u9103\u9161\u9164\u915F\u9162\u9160\u9201\u920A\u9225\u9203\u921A\u9226\u920F\u920C\u9200\u9212\u91FF\u91FD\u9206\u9204\u9227\u9202\u921C\u9224\u9219\u9217\u9205\u9216\u957B\u958D\u958C\u9590\u9687\u967E\u9688"],["dca1","\u9689\u9683\u9680\u96C2\u96C8\u96C3\u96F1\u96F0\u976C\u9770\u976E\u9807\u98A9\u98EB\u9CE6\u9EF9\u4E83\u4E84\u4EB6\u50BD\u50BF\u50C6\u50AE\u50C4\u50CA\u50B4\u50C8\u50C2\u50B0\u50C1\u50BA\u50B1\u50CB\u50C9\u50B6\u50B8\u51D7\u527A\u5278\u527B\u527C\u55C3\u55DB\u55CC\u55D0\u55CB\u55CA\u55DD\u55C0\u55D4\u55C4\u55E9\u55BF\u55D2\u558D\u55CF\u55D5\u55E2\u55D6\u55C8\u55F2\u55CD\u55D9\u55C2\u5714\u5853\u5868\u5864\u584F\u584D\u5849\u586F\u5855\u584E\u585D\u5859\u5865\u585B\u583D\u5863\u5871\u58FC\u5AC7\u5AC4\u5ACB\u5ABA\u5AB8\u5AB1\u5AB5\u5AB0\u5ABF\u5AC8\u5ABB\u5AC6"],["dd40","\u5AB7\u5AC0\u5ACA\u5AB4\u5AB6\u5ACD\u5AB9\u5A90\u5BD6\u5BD8\u5BD9\u5C1F\u5C33\u5D71\u5D63\u5D4A\u5D65\u5D72\u5D6C\u5D5E\u5D68\u5D67\u5D62\u5DF0\u5E4F\u5E4E\u5E4A\u5E4D\u5E4B\u5EC5\u5ECC\u5EC6\u5ECB\u5EC7\u5F40\u5FAF\u5FAD\u60F7\u6149\u614A\u612B\u6145\u6136\u6132\u612E\u6146\u612F\u614F\u6129\u6140\u6220\u9168\u6223\u6225\u6224\u63C5\u63F1\u63EB\u6410\u6412\u6409\u6420\u6424"],["dda1","\u6433\u6443\u641F\u6415\u6418\u6439\u6437\u6422\u6423\u640C\u6426\u6430\u6428\u6441\u6435\u642F\u640A\u641A\u6440\u6425\u6427\u640B\u63E7\u641B\u642E\u6421\u640E\u656F\u6592\u65D3\u6686\u668C\u6695\u6690\u668B\u668A\u6699\u6694\u6678\u6720\u6966\u695F\u6938\u694E\u6962\u6971\u693F\u6945\u696A\u6939\u6942\u6957\u6959\u697A\u6948\u6949\u6935\u696C\u6933\u693D\u6965\u68F0\u6978\u6934\u6969\u6940\u696F\u6944\u6976\u6958\u6941\u6974\u694C\u693B\u694B\u6937\u695C\u694F\u6951\u6932\u6952\u692F\u697B\u693C\u6B46\u6B45\u6B43\u6B42\u6B48\u6B41\u6B9B\uFA0D\u6BFB\u6BFC"],["de40","\u6BF9\u6BF7\u6BF8\u6E9B\u6ED6\u6EC8\u6E8F\u6EC0\u6E9F\u6E93\u6E94\u6EA0\u6EB1\u6EB9\u6EC6\u6ED2\u6EBD\u6EC1\u6E9E\u6EC9\u6EB7\u6EB0\u6ECD\u6EA6\u6ECF\u6EB2\u6EBE\u6EC3\u6EDC\u6ED8\u6E99\u6E92\u6E8E\u6E8D\u6EA4\u6EA1\u6EBF\u6EB3\u6ED0\u6ECA\u6E97\u6EAE\u6EA3\u7147\u7154\u7152\u7163\u7160\u7141\u715D\u7162\u7172\u7178\u716A\u7161\u7142\u7158\u7143\u714B\u7170\u715F\u7150\u7153"],["dea1","\u7144\u714D\u715A\u724F\u728D\u728C\u7291\u7290\u728E\u733C\u7342\u733B\u733A\u7340\u734A\u7349\u7444\u744A\u744B\u7452\u7451\u7457\u7440\u744F\u7450\u744E\u7442\u7446\u744D\u7454\u74E1\u74FF\u74FE\u74FD\u751D\u7579\u7577\u6983\u75EF\u760F\u7603\u75F7\u75FE\u75FC\u75F9\u75F8\u7610\u75FB\u75F6\u75ED\u75F5\u75FD\u7699\u76B5\u76DD\u7755\u775F\u7760\u7752\u7756\u775A\u7769\u7767\u7754\u7759\u776D\u77E0\u7887\u789A\u7894\u788F\u7884\u7895\u7885\u7886\u78A1\u7883\u7879\u7899\u7880\u7896\u787B\u797C\u7982\u797D\u7979\u7A11\u7A18\u7A19\u7A12\u7A17\u7A15\u7A22\u7A13"],["df40","\u7A1B\u7A10\u7AA3\u7AA2\u7A9E\u7AEB\u7B66\u7B64\u7B6D\u7B74\u7B69\u7B72\u7B65\u7B73\u7B71\u7B70\u7B61\u7B78\u7B76\u7B63\u7CB2\u7CB4\u7CAF\u7D88\u7D86\u7D80\u7D8D\u7D7F\u7D85\u7D7A\u7D8E\u7D7B\u7D83\u7D7C\u7D8C\u7D94\u7D84\u7D7D\u7D92\u7F6D\u7F6B\u7F67\u7F68\u7F6C\u7FA6\u7FA5\u7FA7\u7FDB\u7FDC\u8021\u8164\u8160\u8177\u815C\u8169\u815B\u8162\u8172\u6721\u815E\u8176\u8167\u816F"],["dfa1","\u8144\u8161\u821D\u8249\u8244\u8240\u8242\u8245\u84F1\u843F\u8456\u8476\u8479\u848F\u848D\u8465\u8451\u8440\u8486\u8467\u8430\u844D\u847D\u845A\u8459\u8474\u8473\u845D\u8507\u845E\u8437\u843A\u8434\u847A\u8443\u8478\u8432\u8445\u8429\u83D9\u844B\u842F\u8442\u842D\u845F\u8470\u8439\u844E\u844C\u8452\u846F\u84C5\u848E\u843B\u8447\u8436\u8433\u8468\u847E\u8444\u842B\u8460\u8454\u846E\u8450\u870B\u8704\u86F7\u870C\u86FA\u86D6\u86F5\u874D\u86F8\u870E\u8709\u8701\u86F6\u870D\u8705\u88D6\u88CB\u88CD\u88CE\u88DE\u88DB\u88DA\u88CC\u88D0\u8985\u899B\u89DF\u89E5\u89E4"],["e040","\u89E1\u89E0\u89E2\u89DC\u89E6\u8A76\u8A86\u8A7F\u8A61\u8A3F\u8A77\u8A82\u8A84\u8A75\u8A83\u8A81\u8A74\u8A7A\u8C3C\u8C4B\u8C4A\u8C65\u8C64\u8C66\u8C86\u8C84\u8C85\u8CCC\u8D68\u8D69\u8D91\u8D8C\u8D8E\u8D8F\u8D8D\u8D93\u8D94\u8D90\u8D92\u8DF0\u8DE0\u8DEC\u8DF1\u8DEE\u8DD0\u8DE9\u8DE3\u8DE2\u8DE7\u8DF2\u8DEB\u8DF4\u8F06\u8EFF\u8F01\u8F00\u8F05\u8F07\u8F08\u8F02\u8F0B\u9052\u903F"],["e0a1","\u9044\u9049\u903D\u9110\u910D\u910F\u9111\u9116\u9114\u910B\u910E\u916E\u916F\u9248\u9252\u9230\u923A\u9266\u9233\u9265\u925E\u9283\u922E\u924A\u9246\u926D\u926C\u924F\u9260\u9267\u926F\u9236\u9261\u9270\u9231\u9254\u9263\u9250\u9272\u924E\u9253\u924C\u9256\u9232\u959F\u959C\u959E\u959B\u9692\u9693\u9691\u9697\u96CE\u96FA\u96FD\u96F8\u96F5\u9773\u9777\u9778\u9772\u980F\u980D\u980E\u98AC\u98F6\u98F9\u99AF\u99B2\u99B0\u99B5\u9AAD\u9AAB\u9B5B\u9CEA\u9CED\u9CE7\u9E80\u9EFD\u50E6\u50D4\u50D7\u50E8\u50F3\u50DB\u50EA\u50DD\u50E4\u50D3\u50EC\u50F0\u50EF\u50E3\u50E0"],["e140","\u51D8\u5280\u5281\u52E9\u52EB\u5330\u53AC\u5627\u5615\u560C\u5612\u55FC\u560F\u561C\u5601\u5613\u5602\u55FA\u561D\u5604\u55FF\u55F9\u5889\u587C\u5890\u5898\u5886\u5881\u587F\u5874\u588B\u587A\u5887\u5891\u588E\u5876\u5882\u5888\u587B\u5894\u588F\u58FE\u596B\u5ADC\u5AEE\u5AE5\u5AD5\u5AEA\u5ADA\u5AED\u5AEB\u5AF3\u5AE2\u5AE0\u5ADB\u5AEC\u5ADE\u5ADD\u5AD9\u5AE8\u5ADF\u5B77\u5BE0"],["e1a1","\u5BE3\u5C63\u5D82\u5D80\u5D7D\u5D86\u5D7A\u5D81\u5D77\u5D8A\u5D89\u5D88\u5D7E\u5D7C\u5D8D\u5D79\u5D7F\u5E58\u5E59\u5E53\u5ED8\u5ED1\u5ED7\u5ECE\u5EDC\u5ED5\u5ED9\u5ED2\u5ED4\u5F44\u5F43\u5F6F\u5FB6\u612C\u6128\u6141\u615E\u6171\u6173\u6152\u6153\u6172\u616C\u6180\u6174\u6154\u617A\u615B\u6165\u613B\u616A\u6161\u6156\u6229\u6227\u622B\u642B\u644D\u645B\u645D\u6474\u6476\u6472\u6473\u647D\u6475\u6466\u64A6\u644E\u6482\u645E\u645C\u644B\u6453\u6460\u6450\u647F\u643F\u646C\u646B\u6459\u6465\u6477\u6573\u65A0\u66A1\u66A0\u669F\u6705\u6704\u6722\u69B1\u69B6\u69C9"],["e240","\u69A0\u69CE\u6996\u69B0\u69AC\u69BC\u6991\u6999\u698E\u69A7\u698D\u69A9\u69BE\u69AF\u69BF\u69C4\u69BD\u69A4\u69D4\u69B9\u69CA\u699A\u69CF\u69B3\u6993\u69AA\u69A1\u699E\u69D9\u6997\u6990\u69C2\u69B5\u69A5\u69C6\u6B4A\u6B4D\u6B4B\u6B9E\u6B9F\u6BA0\u6BC3\u6BC4\u6BFE\u6ECE\u6EF5\u6EF1\u6F03\u6F25\u6EF8\u6F37\u6EFB\u6F2E\u6F09\u6F4E\u6F19\u6F1A\u6F27\u6F18\u6F3B\u6F12\u6EED\u6F0A"],["e2a1","\u6F36\u6F73\u6EF9\u6EEE\u6F2D\u6F40\u6F30\u6F3C\u6F35\u6EEB\u6F07\u6F0E\u6F43\u6F05\u6EFD\u6EF6\u6F39\u6F1C\u6EFC\u6F3A\u6F1F\u6F0D\u6F1E\u6F08\u6F21\u7187\u7190\u7189\u7180\u7185\u7182\u718F\u717B\u7186\u7181\u7197\u7244\u7253\u7297\u7295\u7293\u7343\u734D\u7351\u734C\u7462\u7473\u7471\u7475\u7472\u7467\u746E\u7500\u7502\u7503\u757D\u7590\u7616\u7608\u760C\u7615\u7611\u760A\u7614\u76B8\u7781\u777C\u7785\u7782\u776E\u7780\u776F\u777E\u7783\u78B2\u78AA\u78B4\u78AD\u78A8\u787E\u78AB\u789E\u78A5\u78A0\u78AC\u78A2\u78A4\u7998\u798A\u798B\u7996\u7995\u7994\u7993"],["e340","\u7997\u7988\u7992\u7990\u7A2B\u7A4A\u7A30\u7A2F\u7A28\u7A26\u7AA8\u7AAB\u7AAC\u7AEE\u7B88\u7B9C\u7B8A\u7B91\u7B90\u7B96\u7B8D\u7B8C\u7B9B\u7B8E\u7B85\u7B98\u5284\u7B99\u7BA4\u7B82\u7CBB\u7CBF\u7CBC\u7CBA\u7DA7\u7DB7\u7DC2\u7DA3\u7DAA\u7DC1\u7DC0\u7DC5\u7D9D\u7DCE\u7DC4\u7DC6\u7DCB\u7DCC\u7DAF\u7DB9\u7D96\u7DBC\u7D9F\u7DA6\u7DAE\u7DA9\u7DA1\u7DC9\u7F73\u7FE2\u7FE3\u7FE5\u7FDE"],["e3a1","\u8024\u805D\u805C\u8189\u8186\u8183\u8187\u818D\u818C\u818B\u8215\u8497\u84A4\u84A1\u849F\u84BA\u84CE\u84C2\u84AC\u84AE\u84AB\u84B9\u84B4\u84C1\u84CD\u84AA\u849A\u84B1\u84D0\u849D\u84A7\u84BB\u84A2\u8494\u84C7\u84CC\u849B\u84A9\u84AF\u84A8\u84D6\u8498\u84B6\u84CF\u84A0\u84D7\u84D4\u84D2\u84DB\u84B0\u8491\u8661\u8733\u8723\u8728\u876B\u8740\u872E\u871E\u8721\u8719\u871B\u8743\u872C\u8741\u873E\u8746\u8720\u8732\u872A\u872D\u873C\u8712\u873A\u8731\u8735\u8742\u8726\u8727\u8738\u8724\u871A\u8730\u8711\u88F7\u88E7\u88F1\u88F2\u88FA\u88FE\u88EE\u88FC\u88F6\u88FB"],["e440","\u88F0\u88EC\u88EB\u899D\u89A1\u899F\u899E\u89E9\u89EB\u89E8\u8AAB\u8A99\u8A8B\u8A92\u8A8F\u8A96\u8C3D\u8C68\u8C69\u8CD5\u8CCF\u8CD7\u8D96\u8E09\u8E02\u8DFF\u8E0D\u8DFD\u8E0A\u8E03\u8E07\u8E06\u8E05\u8DFE\u8E00\u8E04\u8F10\u8F11\u8F0E\u8F0D\u9123\u911C\u9120\u9122\u911F\u911D\u911A\u9124\u9121\u911B\u917A\u9172\u9179\u9173\u92A5\u92A4\u9276\u929B\u927A\u92A0\u9294\u92AA\u928D"],["e4a1","\u92A6\u929A\u92AB\u9279\u9297\u927F\u92A3\u92EE\u928E\u9282\u9295\u92A2\u927D\u9288\u92A1\u928A\u9286\u928C\u9299\u92A7\u927E\u9287\u92A9\u929D\u928B\u922D\u969E\u96A1\u96FF\u9758\u977D\u977A\u977E\u9783\u9780\u9782\u977B\u9784\u9781\u977F\u97CE\u97CD\u9816\u98AD\u98AE\u9902\u9900\u9907\u999D\u999C\u99C3\u99B9\u99BB\u99BA\u99C2\u99BD\u99C7\u9AB1\u9AE3\u9AE7\u9B3E\u9B3F\u9B60\u9B61\u9B5F\u9CF1\u9CF2\u9CF5\u9EA7\u50FF\u5103\u5130\u50F8\u5106\u5107\u50F6\u50FE\u510B\u510C\u50FD\u510A\u528B\u528C\u52F1\u52EF\u5648\u5642\u564C\u5635\u5641\u564A\u5649\u5646\u5658"],["e540","\u565A\u5640\u5633\u563D\u562C\u563E\u5638\u562A\u563A\u571A\u58AB\u589D\u58B1\u58A0\u58A3\u58AF\u58AC\u58A5\u58A1\u58FF\u5AFF\u5AF4\u5AFD\u5AF7\u5AF6\u5B03\u5AF8\u5B02\u5AF9\u5B01\u5B07\u5B05\u5B0F\u5C67\u5D99\u5D97\u5D9F\u5D92\u5DA2\u5D93\u5D95\u5DA0\u5D9C\u5DA1\u5D9A\u5D9E\u5E69\u5E5D\u5E60\u5E5C\u7DF3\u5EDB\u5EDE\u5EE1\u5F49\u5FB2\u618B\u6183\u6179\u61B1\u61B0\u61A2\u6189"],["e5a1","\u619B\u6193\u61AF\u61AD\u619F\u6192\u61AA\u61A1\u618D\u6166\u61B3\u622D\u646E\u6470\u6496\u64A0\u6485\u6497\u649C\u648F\u648B\u648A\u648C\u64A3\u649F\u6468\u64B1\u6498\u6576\u657A\u6579\u657B\u65B2\u65B3\u66B5\u66B0\u66A9\u66B2\u66B7\u66AA\u66AF\u6A00\u6A06\u6A17\u69E5\u69F8\u6A15\u69F1\u69E4\u6A20\u69FF\u69EC\u69E2\u6A1B\u6A1D\u69FE\u6A27\u69F2\u69EE\u6A14\u69F7\u69E7\u6A40\u6A08\u69E6\u69FB\u6A0D\u69FC\u69EB\u6A09\u6A04\u6A18\u6A25\u6A0F\u69F6\u6A26\u6A07\u69F4\u6A16\u6B51\u6BA5\u6BA3\u6BA2\u6BA6\u6C01\u6C00\u6BFF\u6C02\u6F41\u6F26\u6F7E\u6F87\u6FC6\u6F92"],["e640","\u6F8D\u6F89\u6F8C\u6F62\u6F4F\u6F85\u6F5A\u6F96\u6F76\u6F6C\u6F82\u6F55\u6F72\u6F52\u6F50\u6F57\u6F94\u6F93\u6F5D\u6F00\u6F61\u6F6B\u6F7D\u6F67\u6F90\u6F53\u6F8B\u6F69\u6F7F\u6F95\u6F63\u6F77\u6F6A\u6F7B\u71B2\u71AF\u719B\u71B0\u71A0\u719A\u71A9\u71B5\u719D\u71A5\u719E\u71A4\u71A1\u71AA\u719C\u71A7\u71B3\u7298\u729A\u7358\u7352\u735E\u735F\u7360\u735D\u735B\u7361\u735A\u7359"],["e6a1","\u7362\u7487\u7489\u748A\u7486\u7481\u747D\u7485\u7488\u747C\u7479\u7508\u7507\u757E\u7625\u761E\u7619\u761D\u761C\u7623\u761A\u7628\u761B\u769C\u769D\u769E\u769B\u778D\u778F\u7789\u7788\u78CD\u78BB\u78CF\u78CC\u78D1\u78CE\u78D4\u78C8\u78C3\u78C4\u78C9\u799A\u79A1\u79A0\u799C\u79A2\u799B\u6B76\u7A39\u7AB2\u7AB4\u7AB3\u7BB7\u7BCB\u7BBE\u7BAC\u7BCE\u7BAF\u7BB9\u7BCA\u7BB5\u7CC5\u7CC8\u7CCC\u7CCB\u7DF7\u7DDB\u7DEA\u7DE7\u7DD7\u7DE1\u7E03\u7DFA\u7DE6\u7DF6\u7DF1\u7DF0\u7DEE\u7DDF\u7F76\u7FAC\u7FB0\u7FAD\u7FED\u7FEB\u7FEA\u7FEC\u7FE6\u7FE8\u8064\u8067\u81A3\u819F"],["e740","\u819E\u8195\u81A2\u8199\u8197\u8216\u824F\u8253\u8252\u8250\u824E\u8251\u8524\u853B\u850F\u8500\u8529\u850E\u8509\u850D\u851F\u850A\u8527\u851C\u84FB\u852B\u84FA\u8508\u850C\u84F4\u852A\u84F2\u8515\u84F7\u84EB\u84F3\u84FC\u8512\u84EA\u84E9\u8516\u84FE\u8528\u851D\u852E\u8502\u84FD\u851E\u84F6\u8531\u8526\u84E7\u84E8\u84F0\u84EF\u84F9\u8518\u8520\u8530\u850B\u8519\u852F\u8662"],["e7a1","\u8756\u8763\u8764\u8777\u87E1\u8773\u8758\u8754\u875B\u8752\u8761\u875A\u8751\u875E\u876D\u876A\u8750\u874E\u875F\u875D\u876F\u876C\u877A\u876E\u875C\u8765\u874F\u877B\u8775\u8762\u8767\u8769\u885A\u8905\u890C\u8914\u890B\u8917\u8918\u8919\u8906\u8916\u8911\u890E\u8909\u89A2\u89A4\u89A3\u89ED\u89F0\u89EC\u8ACF\u8AC6\u8AB8\u8AD3\u8AD1\u8AD4\u8AD5\u8ABB\u8AD7\u8ABE\u8AC0\u8AC5\u8AD8\u8AC3\u8ABA\u8ABD\u8AD9\u8C3E\u8C4D\u8C8F\u8CE5\u8CDF\u8CD9\u8CE8\u8CDA\u8CDD\u8CE7\u8DA0\u8D9C\u8DA1\u8D9B\u8E20\u8E23\u8E25\u8E24\u8E2E\u8E15\u8E1B\u8E16\u8E11\u8E19\u8E26\u8E27"],["e840","\u8E14\u8E12\u8E18\u8E13\u8E1C\u8E17\u8E1A\u8F2C\u8F24\u8F18\u8F1A\u8F20\u8F23\u8F16\u8F17\u9073\u9070\u906F\u9067\u906B\u912F\u912B\u9129\u912A\u9132\u9126\u912E\u9185\u9186\u918A\u9181\u9182\u9184\u9180\u92D0\u92C3\u92C4\u92C0\u92D9\u92B6\u92CF\u92F1\u92DF\u92D8\u92E9\u92D7\u92DD\u92CC\u92EF\u92C2\u92E8\u92CA\u92C8\u92CE\u92E6\u92CD\u92D5\u92C9\u92E0\u92DE\u92E7\u92D1\u92D3"],["e8a1","\u92B5\u92E1\u92C6\u92B4\u957C\u95AC\u95AB\u95AE\u95B0\u96A4\u96A2\u96D3\u9705\u9708\u9702\u975A\u978A\u978E\u9788\u97D0\u97CF\u981E\u981D\u9826\u9829\u9828\u9820\u981B\u9827\u98B2\u9908\u98FA\u9911\u9914\u9916\u9917\u9915\u99DC\u99CD\u99CF\u99D3\u99D4\u99CE\u99C9\u99D6\u99D8\u99CB\u99D7\u99CC\u9AB3\u9AEC\u9AEB\u9AF3\u9AF2\u9AF1\u9B46\u9B43\u9B67\u9B74\u9B71\u9B66\u9B76\u9B75\u9B70\u9B68\u9B64\u9B6C\u9CFC\u9CFA\u9CFD\u9CFF\u9CF7\u9D07\u9D00\u9CF9\u9CFB\u9D08\u9D05\u9D04\u9E83\u9ED3\u9F0F\u9F10\u511C\u5113\u5117\u511A\u5111\u51DE\u5334\u53E1\u5670\u5660\u566E"],["e940","\u5673\u5666\u5663\u566D\u5672\u565E\u5677\u571C\u571B\u58C8\u58BD\u58C9\u58BF\u58BA\u58C2\u58BC\u58C6\u5B17\u5B19\u5B1B\u5B21\u5B14\u5B13\u5B10\u5B16\u5B28\u5B1A\u5B20\u5B1E\u5BEF\u5DAC\u5DB1\u5DA9\u5DA7\u5DB5\u5DB0\u5DAE\u5DAA\u5DA8\u5DB2\u5DAD\u5DAF\u5DB4\u5E67\u5E68\u5E66\u5E6F\u5EE9\u5EE7\u5EE6\u5EE8\u5EE5\u5F4B\u5FBC\u619D\u61A8\u6196\u61C5\u61B4\u61C6\u61C1\u61CC\u61BA"],["e9a1","\u61BF\u61B8\u618C\u64D7\u64D6\u64D0\u64CF\u64C9\u64BD\u6489\u64C3\u64DB\u64F3\u64D9\u6533\u657F\u657C\u65A2\u66C8\u66BE\u66C0\u66CA\u66CB\u66CF\u66BD\u66BB\u66BA\u66CC\u6723\u6A34\u6A66\u6A49\u6A67\u6A32\u6A68\u6A3E\u6A5D\u6A6D\u6A76\u6A5B\u6A51\u6A28\u6A5A\u6A3B\u6A3F\u6A41\u6A6A\u6A64\u6A50\u6A4F\u6A54\u6A6F\u6A69\u6A60\u6A3C\u6A5E\u6A56\u6A55\u6A4D\u6A4E\u6A46\u6B55\u6B54\u6B56\u6BA7\u6BAA\u6BAB\u6BC8\u6BC7\u6C04\u6C03\u6C06\u6FAD\u6FCB\u6FA3\u6FC7\u6FBC\u6FCE\u6FC8\u6F5E\u6FC4\u6FBD\u6F9E\u6FCA\u6FA8\u7004\u6FA5\u6FAE\u6FBA\u6FAC\u6FAA\u6FCF\u6FBF\u6FB8"],["ea40","\u6FA2\u6FC9\u6FAB\u6FCD\u6FAF\u6FB2\u6FB0\u71C5\u71C2\u71BF\u71B8\u71D6\u71C0\u71C1\u71CB\u71D4\u71CA\u71C7\u71CF\u71BD\u71D8\u71BC\u71C6\u71DA\u71DB\u729D\u729E\u7369\u7366\u7367\u736C\u7365\u736B\u736A\u747F\u749A\u74A0\u7494\u7492\u7495\u74A1\u750B\u7580\u762F\u762D\u7631\u763D\u7633\u763C\u7635\u7632\u7630\u76BB\u76E6\u779A\u779D\u77A1\u779C\u779B\u77A2\u77A3\u7795\u7799"],["eaa1","\u7797\u78DD\u78E9\u78E5\u78EA\u78DE\u78E3\u78DB\u78E1\u78E2\u78ED\u78DF\u78E0\u79A4\u7A44\u7A48\u7A47\u7AB6\u7AB8\u7AB5\u7AB1\u7AB7\u7BDE\u7BE3\u7BE7\u7BDD\u7BD5\u7BE5\u7BDA\u7BE8\u7BF9\u7BD4\u7BEA\u7BE2\u7BDC\u7BEB\u7BD8\u7BDF\u7CD2\u7CD4\u7CD7\u7CD0\u7CD1\u7E12\u7E21\u7E17\u7E0C\u7E1F\u7E20\u7E13\u7E0E\u7E1C\u7E15\u7E1A\u7E22\u7E0B\u7E0F\u7E16\u7E0D\u7E14\u7E25\u7E24\u7F43\u7F7B\u7F7C\u7F7A\u7FB1\u7FEF\u802A\u8029\u806C\u81B1\u81A6\u81AE\u81B9\u81B5\u81AB\u81B0\u81AC\u81B4\u81B2\u81B7\u81A7\u81F2\u8255\u8256\u8257\u8556\u8545\u856B\u854D\u8553\u8561\u8558"],["eb40","\u8540\u8546\u8564\u8541\u8562\u8544\u8551\u8547\u8563\u853E\u855B\u8571\u854E\u856E\u8575\u8555\u8567\u8560\u858C\u8566\u855D\u8554\u8565\u856C\u8663\u8665\u8664\u879B\u878F\u8797\u8793\u8792\u8788\u8781\u8796\u8798\u8779\u8787\u87A3\u8785\u8790\u8791\u879D\u8784\u8794\u879C\u879A\u8789\u891E\u8926\u8930\u892D\u892E\u8927\u8931\u8922\u8929\u8923\u892F\u892C\u891F\u89F1\u8AE0"],["eba1","\u8AE2\u8AF2\u8AF4\u8AF5\u8ADD\u8B14\u8AE4\u8ADF\u8AF0\u8AC8\u8ADE\u8AE1\u8AE8\u8AFF\u8AEF\u8AFB\u8C91\u8C92\u8C90\u8CF5\u8CEE\u8CF1\u8CF0\u8CF3\u8D6C\u8D6E\u8DA5\u8DA7\u8E33\u8E3E\u8E38\u8E40\u8E45\u8E36\u8E3C\u8E3D\u8E41\u8E30\u8E3F\u8EBD\u8F36\u8F2E\u8F35\u8F32\u8F39\u8F37\u8F34\u9076\u9079\u907B\u9086\u90FA\u9133\u9135\u9136\u9193\u9190\u9191\u918D\u918F\u9327\u931E\u9308\u931F\u9306\u930F\u937A\u9338\u933C\u931B\u9323\u9312\u9301\u9346\u932D\u930E\u930D\u92CB\u931D\u92FA\u9325\u9313\u92F9\u92F7\u9334\u9302\u9324\u92FF\u9329\u9339\u9335\u932A\u9314\u930C"],["ec40","\u930B\u92FE\u9309\u9300\u92FB\u9316\u95BC\u95CD\u95BE\u95B9\u95BA\u95B6\u95BF\u95B5\u95BD\u96A9\u96D4\u970B\u9712\u9710\u9799\u9797\u9794\u97F0\u97F8\u9835\u982F\u9832\u9924\u991F\u9927\u9929\u999E\u99EE\u99EC\u99E5\u99E4\u99F0\u99E3\u99EA\u99E9\u99E7\u9AB9\u9ABF\u9AB4\u9ABB\u9AF6\u9AFA\u9AF9\u9AF7\u9B33\u9B80\u9B85\u9B87\u9B7C\u9B7E\u9B7B\u9B82\u9B93\u9B92\u9B90\u9B7A\u9B95"],["eca1","\u9B7D\u9B88\u9D25\u9D17\u9D20\u9D1E\u9D14\u9D29\u9D1D\u9D18\u9D22\u9D10\u9D19\u9D1F\u9E88\u9E86\u9E87\u9EAE\u9EAD\u9ED5\u9ED6\u9EFA\u9F12\u9F3D\u5126\u5125\u5122\u5124\u5120\u5129\u52F4\u5693\u568C\u568D\u5686\u5684\u5683\u567E\u5682\u567F\u5681\u58D6\u58D4\u58CF\u58D2\u5B2D\u5B25\u5B32\u5B23\u5B2C\u5B27\u5B26\u5B2F\u5B2E\u5B7B\u5BF1\u5BF2\u5DB7\u5E6C\u5E6A\u5FBE\u5FBB\u61C3\u61B5\u61BC\u61E7\u61E0\u61E5\u61E4\u61E8\u61DE\u64EF\u64E9\u64E3\u64EB\u64E4\u64E8\u6581\u6580\u65B6\u65DA\u66D2\u6A8D\u6A96\u6A81\u6AA5\u6A89\u6A9F\u6A9B\u6AA1\u6A9E\u6A87\u6A93\u6A8E"],["ed40","\u6A95\u6A83\u6AA8\u6AA4\u6A91\u6A7F\u6AA6\u6A9A\u6A85\u6A8C\u6A92\u6B5B\u6BAD\u6C09\u6FCC\u6FA9\u6FF4\u6FD4\u6FE3\u6FDC\u6FED\u6FE7\u6FE6\u6FDE\u6FF2\u6FDD\u6FE2\u6FE8\u71E1\u71F1\u71E8\u71F2\u71E4\u71F0\u71E2\u7373\u736E\u736F\u7497\u74B2\u74AB\u7490\u74AA\u74AD\u74B1\u74A5\u74AF\u7510\u7511\u7512\u750F\u7584\u7643\u7648\u7649\u7647\u76A4\u76E9\u77B5\u77AB\u77B2\u77B7\u77B6"],["eda1","\u77B4\u77B1\u77A8\u77F0\u78F3\u78FD\u7902\u78FB\u78FC\u78F2\u7905\u78F9\u78FE\u7904\u79AB\u79A8\u7A5C\u7A5B\u7A56\u7A58\u7A54\u7A5A\u7ABE\u7AC0\u7AC1\u7C05\u7C0F\u7BF2\u7C00\u7BFF\u7BFB\u7C0E\u7BF4\u7C0B\u7BF3\u7C02\u7C09\u7C03\u7C01\u7BF8\u7BFD\u7C06\u7BF0\u7BF1\u7C10\u7C0A\u7CE8\u7E2D\u7E3C\u7E42\u7E33\u9848\u7E38\u7E2A\u7E49\u7E40\u7E47\u7E29\u7E4C\u7E30\u7E3B\u7E36\u7E44\u7E3A\u7F45\u7F7F\u7F7E\u7F7D\u7FF4\u7FF2\u802C\u81BB\u81C4\u81CC\u81CA\u81C5\u81C7\u81BC\u81E9\u825B\u825A\u825C\u8583\u8580\u858F\u85A7\u8595\u85A0\u858B\u85A3\u857B\u85A4\u859A\u859E"],["ee40","\u8577\u857C\u8589\u85A1\u857A\u8578\u8557\u858E\u8596\u8586\u858D\u8599\u859D\u8581\u85A2\u8582\u8588\u8585\u8579\u8576\u8598\u8590\u859F\u8668\u87BE\u87AA\u87AD\u87C5\u87B0\u87AC\u87B9\u87B5\u87BC\u87AE\u87C9\u87C3\u87C2\u87CC\u87B7\u87AF\u87C4\u87CA\u87B4\u87B6\u87BF\u87B8\u87BD\u87DE\u87B2\u8935\u8933\u893C\u893E\u8941\u8952\u8937\u8942\u89AD\u89AF\u89AE\u89F2\u89F3\u8B1E"],["eea1","\u8B18\u8B16\u8B11\u8B05\u8B0B\u8B22\u8B0F\u8B12\u8B15\u8B07\u8B0D\u8B08\u8B06\u8B1C\u8B13\u8B1A\u8C4F\u8C70\u8C72\u8C71\u8C6F\u8C95\u8C94\u8CF9\u8D6F\u8E4E\u8E4D\u8E53\u8E50\u8E4C\u8E47\u8F43\u8F40\u9085\u907E\u9138\u919A\u91A2\u919B\u9199\u919F\u91A1\u919D\u91A0\u93A1\u9383\u93AF\u9364\u9356\u9347\u937C\u9358\u935C\u9376\u9349\u9350\u9351\u9360\u936D\u938F\u934C\u936A\u9379\u9357\u9355\u9352\u934F\u9371\u9377\u937B\u9361\u935E\u9363\u9367\u9380\u934E\u9359\u95C7\u95C0\u95C9\u95C3\u95C5\u95B7\u96AE\u96B0\u96AC\u9720\u971F\u9718\u971D\u9719\u979A\u97A1\u979C"],["ef40","\u979E\u979D\u97D5\u97D4\u97F1\u9841\u9844\u984A\u9849\u9845\u9843\u9925\u992B\u992C\u992A\u9933\u9932\u992F\u992D\u9931\u9930\u9998\u99A3\u99A1\u9A02\u99FA\u99F4\u99F7\u99F9\u99F8\u99F6\u99FB\u99FD\u99FE\u99FC\u9A03\u9ABE\u9AFE\u9AFD\u9B01\u9AFC\u9B48\u9B9A\u9BA8\u9B9E\u9B9B\u9BA6\u9BA1\u9BA5\u9BA4\u9B86\u9BA2\u9BA0\u9BAF\u9D33\u9D41\u9D67\u9D36\u9D2E\u9D2F\u9D31\u9D38\u9D30"],["efa1","\u9D45\u9D42\u9D43\u9D3E\u9D37\u9D40\u9D3D\u7FF5\u9D2D\u9E8A\u9E89\u9E8D\u9EB0\u9EC8\u9EDA\u9EFB\u9EFF\u9F24\u9F23\u9F22\u9F54\u9FA0\u5131\u512D\u512E\u5698\u569C\u5697\u569A\u569D\u5699\u5970\u5B3C\u5C69\u5C6A\u5DC0\u5E6D\u5E6E\u61D8\u61DF\u61ED\u61EE\u61F1\u61EA\u61F0\u61EB\u61D6\u61E9\u64FF\u6504\u64FD\u64F8\u6501\u6503\u64FC\u6594\u65DB\u66DA\u66DB\u66D8\u6AC5\u6AB9\u6ABD\u6AE1\u6AC6\u6ABA\u6AB6\u6AB7\u6AC7\u6AB4\u6AAD\u6B5E\u6BC9\u6C0B\u7007\u700C\u700D\u7001\u7005\u7014\u700E\u6FFF\u7000\u6FFB\u7026\u6FFC\u6FF7\u700A\u7201\u71FF\u71F9\u7203\u71FD\u7376"],["f040","\u74B8\u74C0\u74B5\u74C1\u74BE\u74B6\u74BB\u74C2\u7514\u7513\u765C\u7664\u7659\u7650\u7653\u7657\u765A\u76A6\u76BD\u76EC\u77C2\u77BA\u78FF\u790C\u7913\u7914\u7909\u7910\u7912\u7911\u79AD\u79AC\u7A5F\u7C1C\u7C29\u7C19\u7C20\u7C1F\u7C2D\u7C1D\u7C26\u7C28\u7C22\u7C25\u7C30\u7E5C\u7E50\u7E56\u7E63\u7E58\u7E62\u7E5F\u7E51\u7E60\u7E57\u7E53\u7FB5\u7FB3\u7FF7\u7FF8\u8075\u81D1\u81D2"],["f0a1","\u81D0\u825F\u825E\u85B4\u85C6\u85C0\u85C3\u85C2\u85B3\u85B5\u85BD\u85C7\u85C4\u85BF\u85CB\u85CE\u85C8\u85C5\u85B1\u85B6\u85D2\u8624\u85B8\u85B7\u85BE\u8669\u87E7\u87E6\u87E2\u87DB\u87EB\u87EA\u87E5\u87DF\u87F3\u87E4\u87D4\u87DC\u87D3\u87ED\u87D8\u87E3\u87A4\u87D7\u87D9\u8801\u87F4\u87E8\u87DD\u8953\u894B\u894F\u894C\u8946\u8950\u8951\u8949\u8B2A\u8B27\u8B23\u8B33\u8B30\u8B35\u8B47\u8B2F\u8B3C\u8B3E\u8B31\u8B25\u8B37\u8B26\u8B36\u8B2E\u8B24\u8B3B\u8B3D\u8B3A\u8C42\u8C75\u8C99\u8C98\u8C97\u8CFE\u8D04\u8D02\u8D00\u8E5C\u8E62\u8E60\u8E57\u8E56\u8E5E\u8E65\u8E67"],["f140","\u8E5B\u8E5A\u8E61\u8E5D\u8E69\u8E54\u8F46\u8F47\u8F48\u8F4B\u9128\u913A\u913B\u913E\u91A8\u91A5\u91A7\u91AF\u91AA\u93B5\u938C\u9392\u93B7\u939B\u939D\u9389\u93A7\u938E\u93AA\u939E\u93A6\u9395\u9388\u9399\u939F\u938D\u93B1\u9391\u93B2\u93A4\u93A8\u93B4\u93A3\u93A5\u95D2\u95D3\u95D1\u96B3\u96D7\u96DA\u5DC2\u96DF\u96D8\u96DD\u9723\u9722\u9725\u97AC\u97AE\u97A8\u97AB\u97A4\u97AA"],["f1a1","\u97A2\u97A5\u97D7\u97D9\u97D6\u97D8\u97FA\u9850\u9851\u9852\u98B8\u9941\u993C\u993A\u9A0F\u9A0B\u9A09\u9A0D\u9A04\u9A11\u9A0A\u9A05\u9A07\u9A06\u9AC0\u9ADC\u9B08\u9B04\u9B05\u9B29\u9B35\u9B4A\u9B4C\u9B4B\u9BC7\u9BC6\u9BC3\u9BBF\u9BC1\u9BB5\u9BB8\u9BD3\u9BB6\u9BC4\u9BB9\u9BBD\u9D5C\u9D53\u9D4F\u9D4A\u9D5B\u9D4B\u9D59\u9D56\u9D4C\u9D57\u9D52\u9D54\u9D5F\u9D58\u9D5A\u9E8E\u9E8C\u9EDF\u9F01\u9F00\u9F16\u9F25\u9F2B\u9F2A\u9F29\u9F28\u9F4C\u9F55\u5134\u5135\u5296\u52F7\u53B4\u56AB\u56AD\u56A6\u56A7\u56AA\u56AC\u58DA\u58DD\u58DB\u5912\u5B3D\u5B3E\u5B3F\u5DC3\u5E70"],["f240","\u5FBF\u61FB\u6507\u6510\u650D\u6509\u650C\u650E\u6584\u65DE\u65DD\u66DE\u6AE7\u6AE0\u6ACC\u6AD1\u6AD9\u6ACB\u6ADF\u6ADC\u6AD0\u6AEB\u6ACF\u6ACD\u6ADE\u6B60\u6BB0\u6C0C\u7019\u7027\u7020\u7016\u702B\u7021\u7022\u7023\u7029\u7017\u7024\u701C\u702A\u720C\u720A\u7207\u7202\u7205\u72A5\u72A6\u72A4\u72A3\u72A1\u74CB\u74C5\u74B7\u74C3\u7516\u7660\u77C9\u77CA\u77C4\u77F1\u791D\u791B"],["f2a1","\u7921\u791C\u7917\u791E\u79B0\u7A67\u7A68\u7C33\u7C3C\u7C39\u7C2C\u7C3B\u7CEC\u7CEA\u7E76\u7E75\u7E78\u7E70\u7E77\u7E6F\u7E7A\u7E72\u7E74\u7E68\u7F4B\u7F4A\u7F83\u7F86\u7FB7\u7FFD\u7FFE\u8078\u81D7\u81D5\u8264\u8261\u8263\u85EB\u85F1\u85ED\u85D9\u85E1\u85E8\u85DA\u85D7\u85EC\u85F2\u85F8\u85D8\u85DF\u85E3\u85DC\u85D1\u85F0\u85E6\u85EF\u85DE\u85E2\u8800\u87FA\u8803\u87F6\u87F7\u8809\u880C\u880B\u8806\u87FC\u8808\u87FF\u880A\u8802\u8962\u895A\u895B\u8957\u8961\u895C\u8958\u895D\u8959\u8988\u89B7\u89B6\u89F6\u8B50\u8B48\u8B4A\u8B40\u8B53\u8B56\u8B54\u8B4B\u8B55"],["f340","\u8B51\u8B42\u8B52\u8B57\u8C43\u8C77\u8C76\u8C9A\u8D06\u8D07\u8D09\u8DAC\u8DAA\u8DAD\u8DAB\u8E6D\u8E78\u8E73\u8E6A\u8E6F\u8E7B\u8EC2\u8F52\u8F51\u8F4F\u8F50\u8F53\u8FB4\u9140\u913F\u91B0\u91AD\u93DE\u93C7\u93CF\u93C2\u93DA\u93D0\u93F9\u93EC\u93CC\u93D9\u93A9\u93E6\u93CA\u93D4\u93EE\u93E3\u93D5\u93C4\u93CE\u93C0\u93D2\u93E7\u957D\u95DA\u95DB\u96E1\u9729\u972B\u972C\u9728\u9726"],["f3a1","\u97B3\u97B7\u97B6\u97DD\u97DE\u97DF\u985C\u9859\u985D\u9857\u98BF\u98BD\u98BB\u98BE\u9948\u9947\u9943\u99A6\u99A7\u9A1A\u9A15\u9A25\u9A1D\u9A24\u9A1B\u9A22\u9A20\u9A27\u9A23\u9A1E\u9A1C\u9A14\u9AC2\u9B0B\u9B0A\u9B0E\u9B0C\u9B37\u9BEA\u9BEB\u9BE0\u9BDE\u9BE4\u9BE6\u9BE2\u9BF0\u9BD4\u9BD7\u9BEC\u9BDC\u9BD9\u9BE5\u9BD5\u9BE1\u9BDA\u9D77\u9D81\u9D8A\u9D84\u9D88\u9D71\u9D80\u9D78\u9D86\u9D8B\u9D8C\u9D7D\u9D6B\u9D74\u9D75\u9D70\u9D69\u9D85\u9D73\u9D7B\u9D82\u9D6F\u9D79\u9D7F\u9D87\u9D68\u9E94\u9E91\u9EC0\u9EFC\u9F2D\u9F40\u9F41\u9F4D\u9F56\u9F57\u9F58\u5337\u56B2"],["f440","\u56B5\u56B3\u58E3\u5B45\u5DC6\u5DC7\u5EEE\u5EEF\u5FC0\u5FC1\u61F9\u6517\u6516\u6515\u6513\u65DF\u66E8\u66E3\u66E4\u6AF3\u6AF0\u6AEA\u6AE8\u6AF9\u6AF1\u6AEE\u6AEF\u703C\u7035\u702F\u7037\u7034\u7031\u7042\u7038\u703F\u703A\u7039\u7040\u703B\u7033\u7041\u7213\u7214\u72A8\u737D\u737C\u74BA\u76AB\u76AA\u76BE\u76ED\u77CC\u77CE\u77CF\u77CD\u77F2\u7925\u7923\u7927\u7928\u7924\u7929"],["f4a1","\u79B2\u7A6E\u7A6C\u7A6D\u7AF7\u7C49\u7C48\u7C4A\u7C47\u7C45\u7CEE\u7E7B\u7E7E\u7E81\u7E80\u7FBA\u7FFF\u8079\u81DB\u81D9\u820B\u8268\u8269\u8622\u85FF\u8601\u85FE\u861B\u8600\u85F6\u8604\u8609\u8605\u860C\u85FD\u8819\u8810\u8811\u8817\u8813\u8816\u8963\u8966\u89B9\u89F7\u8B60\u8B6A\u8B5D\u8B68\u8B63\u8B65\u8B67\u8B6D\u8DAE\u8E86\u8E88\u8E84\u8F59\u8F56\u8F57\u8F55\u8F58\u8F5A\u908D\u9143\u9141\u91B7\u91B5\u91B2\u91B3\u940B\u9413\u93FB\u9420\u940F\u9414\u93FE\u9415\u9410\u9428\u9419\u940D\u93F5\u9400\u93F7\u9407\u940E\u9416\u9412\u93FA\u9409\u93F8\u940A\u93FF"],["f540","\u93FC\u940C\u93F6\u9411\u9406\u95DE\u95E0\u95DF\u972E\u972F\u97B9\u97BB\u97FD\u97FE\u9860\u9862\u9863\u985F\u98C1\u98C2\u9950\u994E\u9959\u994C\u994B\u9953\u9A32\u9A34\u9A31\u9A2C\u9A2A\u9A36\u9A29\u9A2E\u9A38\u9A2D\u9AC7\u9ACA\u9AC6\u9B10\u9B12\u9B11\u9C0B\u9C08\u9BF7\u9C05\u9C12\u9BF8\u9C40\u9C07\u9C0E\u9C06\u9C17\u9C14\u9C09\u9D9F\u9D99\u9DA4\u9D9D\u9D92\u9D98\u9D90\u9D9B"],["f5a1","\u9DA0\u9D94\u9D9C\u9DAA\u9D97\u9DA1\u9D9A\u9DA2\u9DA8\u9D9E\u9DA3\u9DBF\u9DA9\u9D96\u9DA6\u9DA7\u9E99\u9E9B\u9E9A\u9EE5\u9EE4\u9EE7\u9EE6\u9F30\u9F2E\u9F5B\u9F60\u9F5E\u9F5D\u9F59\u9F91\u513A\u5139\u5298\u5297\u56C3\u56BD\u56BE\u5B48\u5B47\u5DCB\u5DCF\u5EF1\u61FD\u651B\u6B02\u6AFC\u6B03\u6AF8\u6B00\u7043\u7044\u704A\u7048\u7049\u7045\u7046\u721D\u721A\u7219\u737E\u7517\u766A\u77D0\u792D\u7931\u792F\u7C54\u7C53\u7CF2\u7E8A\u7E87\u7E88\u7E8B\u7E86\u7E8D\u7F4D\u7FBB\u8030\u81DD\u8618\u862A\u8626\u861F\u8623\u861C\u8619\u8627\u862E\u8621\u8620\u8629\u861E\u8625"],["f640","\u8829\u881D\u881B\u8820\u8824\u881C\u882B\u884A\u896D\u8969\u896E\u896B\u89FA\u8B79\u8B78\u8B45\u8B7A\u8B7B\u8D10\u8D14\u8DAF\u8E8E\u8E8C\u8F5E\u8F5B\u8F5D\u9146\u9144\u9145\u91B9\u943F\u943B\u9436\u9429\u943D\u943C\u9430\u9439\u942A\u9437\u942C\u9440\u9431\u95E5\u95E4\u95E3\u9735\u973A\u97BF\u97E1\u9864\u98C9\u98C6\u98C0\u9958\u9956\u9A39\u9A3D\u9A46\u9A44\u9A42\u9A41\u9A3A"],["f6a1","\u9A3F\u9ACD\u9B15\u9B17\u9B18\u9B16\u9B3A\u9B52\u9C2B\u9C1D\u9C1C\u9C2C\u9C23\u9C28\u9C29\u9C24\u9C21\u9DB7\u9DB6\u9DBC\u9DC1\u9DC7\u9DCA\u9DCF\u9DBE\u9DC5\u9DC3\u9DBB\u9DB5\u9DCE\u9DB9\u9DBA\u9DAC\u9DC8\u9DB1\u9DAD\u9DCC\u9DB3\u9DCD\u9DB2\u9E7A\u9E9C\u9EEB\u9EEE\u9EED\u9F1B\u9F18\u9F1A\u9F31\u9F4E\u9F65\u9F64\u9F92\u4EB9\u56C6\u56C5\u56CB\u5971\u5B4B\u5B4C\u5DD5\u5DD1\u5EF2\u6521\u6520\u6526\u6522\u6B0B\u6B08\u6B09\u6C0D\u7055\u7056\u7057\u7052\u721E\u721F\u72A9\u737F\u74D8\u74D5\u74D9\u74D7\u766D\u76AD\u7935\u79B4\u7A70\u7A71\u7C57\u7C5C\u7C59\u7C5B\u7C5A"],["f740","\u7CF4\u7CF1\u7E91\u7F4F\u7F87\u81DE\u826B\u8634\u8635\u8633\u862C\u8632\u8636\u882C\u8828\u8826\u882A\u8825\u8971\u89BF\u89BE\u89FB\u8B7E\u8B84\u8B82\u8B86\u8B85\u8B7F\u8D15\u8E95\u8E94\u8E9A\u8E92\u8E90\u8E96\u8E97\u8F60\u8F62\u9147\u944C\u9450\u944A\u944B\u944F\u9447\u9445\u9448\u9449\u9446\u973F\u97E3\u986A\u9869\u98CB\u9954\u995B\u9A4E\u9A53\u9A54\u9A4C\u9A4F\u9A48\u9A4A"],["f7a1","\u9A49\u9A52\u9A50\u9AD0\u9B19\u9B2B\u9B3B\u9B56\u9B55\u9C46\u9C48\u9C3F\u9C44\u9C39\u9C33\u9C41\u9C3C\u9C37\u9C34\u9C32\u9C3D\u9C36\u9DDB\u9DD2\u9DDE\u9DDA\u9DCB\u9DD0\u9DDC\u9DD1\u9DDF\u9DE9\u9DD9\u9DD8\u9DD6\u9DF5\u9DD5\u9DDD\u9EB6\u9EF0\u9F35\u9F33\u9F32\u9F42\u9F6B\u9F95\u9FA2\u513D\u5299\u58E8\u58E7\u5972\u5B4D\u5DD8\u882F\u5F4F\u6201\u6203\u6204\u6529\u6525\u6596\u66EB\u6B11\u6B12\u6B0F\u6BCA\u705B\u705A\u7222\u7382\u7381\u7383\u7670\u77D4\u7C67\u7C66\u7E95\u826C\u863A\u8640\u8639\u863C\u8631\u863B\u863E\u8830\u8832\u882E\u8833\u8976\u8974\u8973\u89FE"],["f840","\u8B8C\u8B8E\u8B8B\u8B88\u8C45\u8D19\u8E98\u8F64\u8F63\u91BC\u9462\u9455\u945D\u9457\u945E\u97C4\u97C5\u9800\u9A56\u9A59\u9B1E\u9B1F\u9B20\u9C52\u9C58\u9C50\u9C4A\u9C4D\u9C4B\u9C55\u9C59\u9C4C\u9C4E\u9DFB\u9DF7\u9DEF\u9DE3\u9DEB\u9DF8\u9DE4\u9DF6\u9DE1\u9DEE\u9DE6\u9DF2\u9DF0\u9DE2\u9DEC\u9DF4\u9DF3\u9DE8\u9DED\u9EC2\u9ED0\u9EF2\u9EF3\u9F06\u9F1C\u9F38\u9F37\u9F36\u9F43\u9F4F"],["f8a1","\u9F71\u9F70\u9F6E\u9F6F\u56D3\u56CD\u5B4E\u5C6D\u652D\u66ED\u66EE\u6B13\u705F\u7061\u705D\u7060\u7223\u74DB\u74E5\u77D5\u7938\u79B7\u79B6\u7C6A\u7E97\u7F89\u826D\u8643\u8838\u8837\u8835\u884B\u8B94\u8B95\u8E9E\u8E9F\u8EA0\u8E9D\u91BE\u91BD\u91C2\u946B\u9468\u9469\u96E5\u9746\u9743\u9747\u97C7\u97E5\u9A5E\u9AD5\u9B59\u9C63\u9C67\u9C66\u9C62\u9C5E\u9C60\u9E02\u9DFE\u9E07\u9E03\u9E06\u9E05\u9E00\u9E01\u9E09\u9DFF\u9DFD\u9E04\u9EA0\u9F1E\u9F46\u9F74\u9F75\u9F76\u56D4\u652E\u65B8\u6B18\u6B19\u6B17\u6B1A\u7062\u7226\u72AA\u77D8\u77D9\u7939\u7C69\u7C6B\u7CF6\u7E9A"],["f940","\u7E98\u7E9B\u7E99\u81E0\u81E1\u8646\u8647\u8648\u8979\u897A\u897C\u897B\u89FF\u8B98\u8B99\u8EA5\u8EA4\u8EA3\u946E\u946D\u946F\u9471\u9473\u9749\u9872\u995F\u9C68\u9C6E\u9C6D\u9E0B\u9E0D\u9E10\u9E0F\u9E12\u9E11\u9EA1\u9EF5\u9F09\u9F47\u9F78\u9F7B\u9F7A\u9F79\u571E\u7066\u7C6F\u883C\u8DB2\u8EA6\u91C3\u9474\u9478\u9476\u9475\u9A60\u9C74\u9C73\u9C71\u9C75\u9E14\u9E13\u9EF6\u9F0A"],["f9a1","\u9FA4\u7068\u7065\u7CF7\u866A\u883E\u883D\u883F\u8B9E\u8C9C\u8EA9\u8EC9\u974B\u9873\u9874\u98CC\u9961\u99AB\u9A64\u9A66\u9A67\u9B24\u9E15\u9E17\u9F48\u6207\u6B1E\u7227\u864C\u8EA8\u9482\u9480\u9481\u9A69\u9A68\u9B2E\u9E19\u7229\u864B\u8B9F\u9483\u9C79\u9EB7\u7675\u9A6B\u9C7A\u9E1D\u7069\u706A\u9EA4\u9F7E\u9F49\u9F98\u7881\u92B9\u88CF\u58BB\u6052\u7CA7\u5AFA\u2554\u2566\u2557\u2560\u256C\u2563\u255A\u2569\u255D\u2552\u2564\u2555\u255E\u256A\u2561\u2558\u2567\u255B\u2553\u2565\u2556\u255F\u256B\u2562\u2559\u2568\u255C\u2551\u2550\u256D\u256E\u2570\u256F\u2593"]]');

},{}],"9TDg5":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["8740","\u43F0\u4C32\u4603\u45A6\u4578\uD85C\uDE67\u4D77\u45B3\uD85F\uDCB1\u4CE2\uD85F\uDCC5\u3B95\u4736\u4744\u4C47\u4C40\uD850\uDEBF\uD84D\uDE17\uD85C\uDF52\uD85B\uDE8B\uD85C\uDCD2\u4C57\uD868\uDF51\u474F\u45DA\u4C85\uD85F\uDC6C\u4D07\u4AA4\u46A1\uD85A\uDF23\u7225\uD856\uDE54\uD846\uDE63\uD84F\uDE06\uD84F\uDF61\u664D\u56FB"],["8767","\u7D95\u591D\uD862\uDFB9\u3DF4\u9734\uD85E\uDFEF\u5BDB\uD847\uDD5E\u5AA4\u3625\uD867\uDEB0\u5AD1\u5BB7\u5CFC\u676E\u8593\uD866\uDD45\u7461\u749D\u3875\uD847\uDD53\uD84D\uDE9E\uD858\uDC21\u3EEC"],["87a1","\uD856\uDCDE\u3AF5\u7AFC\u9F97\uD850\uDD61\uD862\uDD0D\uD84C\uDDEA\uD842\uDE8A\uD84C\uDE5E\u430A\u8484\u9F96\u942F\u4930\u8613\u5896\u974A\u9218\u79D0\u7A32\u6660\u6A29\u889D\u744C\u7BC5\u6782\u7A2C\u524F\u9046\u34E6\u73C4\uD857\uDDB9\u74C6\u9FC7\u57B3\u492F\u544C\u4131\uD84D\uDE8E\u5818\u7A72\uD85E\uDF65\u8B8F\u46AE\uD85B\uDE88\u4181\uD857\uDD99\u7BAE\uD849\uDCBC\u9FC8\uD849\uDCC1\uD849\uDCC9\uD849\uDCCC\u9FC9\u8504\uD84D\uDDBB\u40B4\u9FCA\u44E1\uD86B\uDDFF\u62C1\u706E\u9FCB"],["8840","\u31C0",4,"\uD840\uDD0C\u31C5\uD840\uDCD1\uD840\uDCCD\u31C6\u31C7\uD840\uDCCB\uD847\uDFE8\u31C8\uD840\uDCCA\u31C9\u31CA\u31CB\u31CC\uD840\uDD0E\u31CD\u31CE\u0100\xc1\u01CD\xc0\u0112\xc9\u011A\xc8\u014C\xd3\u01D1\xd2\u0FFF\xca\u0304\u1EBE\u0FFF\xca\u030C\u1EC0\xca\u0101\xe1\u01CE\xe0\u0251\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA"],["88a1","\u01DC\xfc\u0FFF\xea\u0304\u1EBF\u0FFF\xea\u030C\u1EC1\xea\u0261\u23DA\u23DB"],["8940","\uD868\uDFA9\uD844\uDD45"],["8943","\u650A"],["8946","\u4E3D\u6EDD\u9D4E\u91DF"],["894c","\uD85D\uDF35\u6491\u4F1A\u4F28\u4FA8\u5156\u5174\u519C\u51E4\u52A1\u52A8\u533B\u534E\u53D1\u53D8\u56E2\u58F0\u5904\u5907\u5932\u5934\u5B66\u5B9E\u5B9F\u5C9A\u5E86\u603B\u6589\u67FE\u6804\u6865\u6D4E\u70BC\u7535\u7EA4\u7EAC\u7EBA\u7EC7\u7ECF\u7EDF\u7F06\u7F37\u827A\u82CF\u836F\u89C6\u8BBE\u8BE2\u8F66\u8F67\u8F6E"],["89a1","\u7411\u7CFC\u7DCD\u6946\u7AC9\u5227"],["89ab","\u918C\u78B8\u915E\u80BC"],["89b0","\u8D0B\u80F6\uD842\uDDE7"],["89b5","\u809F\u9EC7\u4CCD\u9DC9\u9E0C\u4C3E\uD867\uDDF6\uD85C\uDC0E\u9E0A\uD868\uDD33\u35C1"],["89c1","\u6E9A\u823E\u7519"],["89c5","\u4911\u9A6C\u9A8F\u9F99\u7987\uD861\uDC6C\uD847\uDDCA\uD841\uDDD0\uD84A\uDEE6\u4E24\u4E81\u4E80\u4E87\u4EBF\u4EEB\u4F37\u344C\u4FBD\u3E48\u5003\u5088\u347D\u3493\u34A5\u5186\u5905\u51DB\u51FC\u5205\u4E89\u5279\u5290\u5327\u35C7\u53A9\u3551\u53B0\u3553\u53C2\u5423\u356D\u3572\u3681\u5493\u54A3\u54B4\u54B9\u54D0\u54EF\u5518\u5523\u5528\u3598\u553F\u35A5\u35BF\u55D7\u35C5"],["8a40","\uD85F\uDD84\u5525"],["8a43","\uD843\uDC42\uD843\uDD15\uD854\uDD2B\u5590\uD84B\uDCC6\u39EC\uD840\uDF41\u8E46\uD853\uDDB8\uD865\uDCE5\u4053\uD860\uDCBE\u777A\uD84B\uDC38\u3A34\u47D5\uD860\uDD5D\uD85A\uDDF2\uD853\uDDEA\u64DD\uD843\uDD7C\uD843\uDFB4\uD843\uDCD5\uD844\uDCF4\u648D\u8E7E\uD843\uDE96\uD843\uDC0B\uD843\uDF64\uD84B\uDCA9\uD860\uDE56\uD851\uDCD3"],["8a64","\uD843\uDD46\uD866\uDE4D\uD860\uDCE9\u47F4\uD853\uDEA7\uD84B\uDCC2\u9AB2\u3A67\uD865\uDDF4\u3FED\u3506\uD854\uDEC7\uD865\uDFD4\uD85E\uDCC8\uD84B\uDD44\u9D6E\u9815"],["8a76","\u43D9\uD858\uDCA5\u64B4\u54E3\uD84B\uDD4C\uD84A\uDFCA\uD844\uDC77\u39FB\uD844\uDC6F"],["8aa1","\uD859\uDEDA\uD859\uDF16\uD85E\uDDA0\u64EA\uD854\uDC52\uD843\uDC43\u8E68\uD848\uDDA1\uD862\uDF4C\uD841\uDF31"],["8aac","\u480B\uD840\uDDA9\u3FFA\u5873\uD84B\uDD8D"],["8ab2","\uD851\uDDC8\uD841\uDCFC\uD858\uDC97\uD843\uDF4C\uD843\uDD96\u5579\u40BB\u43BA"],["8abb","\u4AB4\uD84A\uDE66\uD844\uDC9D\u81AA\u98F5\uD843\uDD9C\u6379\u39FE\uD849\uDF75\u8DC0\u56A1\u647C\u3E43"],["8ac9","\uD869\uDE01\uD843\uDE09\uD84A\uDECF\uD84B\uDCC9"],["8ace","\uD844\uDCC8\uD84E\uDDC2\u3992\u3A06\uD860\uDE9B\u3578\uD857\uDE49\uD848\uDCC7\u5652\uD843\uDF31\uD84B\uDCB2\uD865\uDF20\u34BC\u6C3D\uD853\uDE3B"],["8adf","\uD85D\uDD74\uD84B\uDE8B\uD848\uDE08\uD869\uDE5B\uD863\uDCCD\uD843\uDE7A\uD843\uDC34\uD85A\uDC1C\u7F93\uD844\uDCCF\uD84A\uDC03\uD84A\uDD39\u35FB\uD854\uDDE3\uD843\uDE8C\uD843\uDF8D\uD843\uDEAA\u3F93\uD843\uDF30\uD843\uDD47\uD844\uDD4F\uD843\uDE4C"],["8af6","\uD843\uDEAB\uD842\uDFA9\uD843\uDD48\uD844\uDCC0\uD844\uDD3D\u3FF9\uD849\uDE96\u6432\uD843\uDFAD"],["8b40","\uD84C\uDFF4\uD85D\uDE39\uD84A\uDFCE\uD843\uDD7E\uD843\uDD7F\uD84B\uDC51\uD84B\uDC55\u3A18\uD843\uDE98\uD844\uDCC7\uD843\uDF2E\uD869\uDE32\uD85A\uDF50\uD863\uDCD2\uD863\uDD99\uD863\uDCCA\u95AA\u54CC\u82C4\u55B9"],["8b55","\uD867\uDEC3\u9C26\u9AB6\uD85D\uDF5E\uD84B\uDDEE\u7140\u816D\u80EC\u5C1C\uD859\uDD72\u8134\u3797\u535F\uD860\uDCBD\u91B6\uD843\uDEFA\uD843\uDE0F\uD843\uDE77\uD843\uDEFB\u35DD\uD853\uDDEB\u3609\uD843\uDCD6\u56AF\uD849\uDFB5\uD844\uDCC9\uD843\uDE10\uD843\uDE78\uD844\uDC78\uD844\uDD48\uD860\uDE07\uD845\uDC55\uD843\uDE79\uD853\uDE50\uD84B\uDDA4\u5A54\uD844\uDC1D\uD844\uDC1E\uD844\uDCF5\uD844\uDCF6\u579C\uD843\uDE11"],["8ba1","\uD85D\uDE94\uD860\uDECD\uD843\uDFB5\uD843\uDE7B\uD854\uDD7E\u3703\uD843\uDFB6\uD844\uDD80\uD854\uDED8\uD868\uDEBD\uD852\uDDDA\uD846\uDC3A\uD850\uDD77\uD860\uDE7C\u5899\u5268\u361A\uD855\uDF3D\u7BB2\u5B68\u4800\u4B2C\u9F27\u49E7\u9C1F\u9B8D\uD856\uDF74\uD84C\uDD3D\u55FB\u35F2\u5689\u4E28\u5902\uD846\uDFC1\uD87E\uDC78\u9751\uD840\uDC86\u4E5B\u4EBB\u353E\u5C23\u5F51\u5FC4\u38FA\u624C\u6535\u6B7A\u6C35\u6C3A\u706C\u722B\u4E2C\u72AD\uD852\uDCE9\u7F52\u793B\u7CF9\u7F53\uD858\uDE6A\u34C1"],["8bde","\uD858\uDF4B\u8002\u8080\uD859\uDE12\uD85A\uDD51\u535D\u8864\u89C1\uD85E\uDCB2\u8BA0\u8D1D\u9485\u9578\u957F\u95E8\uD863\uDE0F\u97E6\u9875\u98CE\u98DE\u9963\uD866\uDC10\u9C7C\u9E1F\u9EC4\u6B6F\uF907\u4E37\uD840\uDC87\u961D\u6237\u94A2"],["8c40","\u503B\u6DFE\uD867\uDC73\u9FA6\u3DC9\u888F\uD850\uDD4E\u7077\u5CF5\u4B20\uD854\uDDCD\u3559\uD857\uDD30\u6122\uD862\uDE32\u8FA7\u91F6\u7191\u6719\u73BA\uD84C\uDE81\uD868\uDD07\u3C8B\uD846\uDD80\u4B10\u78E4\u7402\u51AE\uD861\uDF0F\u4009\u6A63\uD868\uDEBA\u4223\u860F\uD842\uDE6F\u7A2A\uD866\uDD47\uD862\uDEEA\u9755\u704D\u5324\uD848\uDC7E\u93F4\u76D9\uD862\uDDE3\u9FA7\u77DD\u4EA3\u4FF0\u50BC\u4E2F\u4F17\u9FA8\u5434\u7D8B\u5892\u58D0\uD847\uDDB6\u5E92\u5E99\u5FC2\uD849\uDF12\u658B"],["8ca1","\uD84C\uDFF9\u6919\u6A43\uD84F\uDC63\u6CFF"],["8ca7","\u7200\uD851\uDD05\u738C\u3EDB\uD852\uDE13\u5B15\u74B9\u8B83\uD857\uDCA4\uD855\uDE95\u7A93\u7BEC\u7CC3\u7E6C\u82F8\u8597\u9FA9\u8890\u9FAA\u8EB9\u9FAB\u8FCF\u855F\u99E0\u9221\u9FAC\uD863\uDDB9\uD845\uDC3F\u4071\u42A2\u5A1A"],["8cc9","\u9868\u676B\u4276\u573D"],["8cce","\u85D6\uD852\uDD7B\u82BF\uD85C\uDD0D\u4C81\uD85B\uDD74\u5D7B\uD85A\uDF15\uD85B\uDFBE\u9FAD\u9FAE\u5B96\u9FAF\u66E7\u7E5B\u6E57\u79CA\u3D88\u44C3\uD84C\uDE56\uD849\uDF96\u439A\u4536"],["8ce6","\u5CD5\uD84E\uDF1A\u8AF9\u5C78\u3D12\uD84D\uDD51\u5D78\u9FB2\u7157\u4558\uD850\uDCEC\uD847\uDE23\u4C77\u3978\u344A\uD840\uDDA4\uD85B\uDC41\u8ACC\u4FB4\uD840\uDE39\u59BF\u816C\u9856\uD866\uDCFA\u5F3B"],["8d40","\uD842\uDF9F"],["8d42","\uD848\uDDC1\uD862\uDD6D\u4102\u46BB\uD864\uDC79\u3F07\u9FB3\uD868\uDDB5\u40F8\u37D6\u46F7\uD85B\uDC46\u417C\uD861\uDEB2\uD85C\uDFFF\u456D\u38D4\uD855\uDC9A\u4561\u451B\u4D89\u4C7B\u4D76\u45EA\u3FC8\uD852\uDF0F\u3661\u44DE\u44BD\u41ED\u5D3E\u5D48\u5D56\u3DFC\u380F\u5DA4\u5DB9\u3820\u3838\u5E42\u5EBD\u5F25\u5F83\u3908\u3914\u393F\u394D\u60D7\u613D\u5CE5\u3989\u61B7\u61B9\u61CF\u39B8\u622C\u6290\u62E5\u6318\u39F8\u56B1"],["8da1","\u3A03\u63E2\u63FB\u6407\u645A\u3A4B\u64C0\u5D15\u5621\u9F9F\u3A97\u6586\u3ABD\u65FF\u6653\u3AF2\u6692\u3B22\u6716\u3B42\u67A4\u6800\u3B58\u684A\u6884\u3B72\u3B71\u3B7B\u6909\u6943\u725C\u6964\u699F\u6985\u3BBC\u69D6\u3BDD\u6A65\u6A74\u6A71\u6A82\u3BEC\u6A99\u3BF2\u6AAB\u6AB5\u6AD4\u6AF6\u6B81\u6BC1\u6BEA\u6C75\u6CAA\u3CCB\u6D02\u6D06\u6D26\u6D81\u3CEF\u6DA4\u6DB1\u6E15\u6E18\u6E29\u6E86\uD862\uDDC0\u6EBB\u6EE2\u6EDA\u9F7F\u6EE8\u6EE9\u6F24\u6F34\u3D46\uD84F\uDF41\u6F81\u6FBE\u3D6A\u3D75\u71B7\u5C99\u3D8A\u702C\u3D91\u7050\u7054\u706F\u707F\u7089\uD840\uDF25\u43C1\u35F1\uD843\uDED8"],["8e40","\uD84F\uDED7\u57BE\uD85B\uDED3\u713E\uD855\uDFE0\u364E\u69A2\uD862\uDFE9\u5B74\u7A49\uD856\uDCE1\uD865\uDCD9\u7A65\u7A7D\uD856\uDDAC\u7ABB\u7AB0\u7AC2\u7AC3\u71D1\uD859\uDC8D\u41CA\u7ADA\u7ADD\u7AEA\u41EF\u54B2\uD857\uDC01\u7B0B\u7B55\u7B29\uD854\uDF0E\uD857\uDCFE\u7BA2\u7B6F\u839C\uD856\uDFB4\uD85B\uDC7F\u7BD0\u8421\u7B92\u7BB8\uD857\uDD20\u3DAD\uD857\uDC65\u8492\u7BFA\u7C06\u7C35\uD857\uDCC1\u7C44\u7C83\uD852\uDC82\u7CA6\u667D\uD851\uDD78\u7CC9\u7CC7\u7CE6\u7C74\u7CF3\u7CF5\u7CCE"],["8ea1","\u7E67\u451D\uD85B\uDE44\u7D5D\uD85B\uDED6\u748D\u7D89\u7DAB\u7135\u7DB3\u7DD2\uD850\uDC57\uD858\uDC29\u7DE4\u3D13\u7DF5\uD845\uDFF9\u7DE5\uD860\uDF6D\u7E1D\uD858\uDD21\uD858\uDD5A\u7E6E\u7E92\u432B\u946C\u7E27\u7F40\u7F41\u7F47\u7936\uD858\uDED0\u99E1\u7F97\uD858\uDF51\u7FA3\uD845\uDE61\uD840\uDC68\u455C\uD84D\uDF66\u4503\uD860\uDF3A\u7FFA\uD859\uDC89\u8005\u8008\u801D\u8028\u802F\uD868\uDC87\uD85B\uDCC3\u803B\u803C\u8061\uD849\uDF14\u4989\uD859\uDE26\uD84F\uDDE3\uD859\uDEE8\u6725\u80A7\uD862\uDE48\u8107\u811A\u58B0\uD849\uDEF6\u6C7F\uD859\uDC98\uD853\uDFB8\u64E7\uD845\uDC8A\u8218\uD846\uDC5E\u6A53\uD852\uDE65\uD852\uDE95\u447A\u8229\uD842\uDF0D\uD85A\uDE52\uD84F\uDD7E\u4FF9\uD845\uDCFD\u84E2\u8362\uD85A\uDF0A\uD852\uDDA7\uD84D\uDD30\uD845\uDF73\uD84F\uDDF8\u82AA\u691B\uD87E\uDD94\u41DB"],["8f40","\u854B\u82D0\u831A\uD843\uDE16\uD845\uDFB4\u36C1\uD84C\uDD7D\uD84D\uDD5A\u827B\u82E2\u8318\uD84F\uDE8B\uD85B\uDDA3\uD85A\uDF05\uD85A\uDF97\uD84D\uDDCE\u3DBF\u831D\u55EC\u8385\u450B\uD85B\uDDA5\u83AC\u83C1\u83D3\u347E\uD85B\uDED4\u6A57\u855A\u3496\uD85B\uDE42\uD84B\uDEEF\u8458\uD856\uDFE4\u8471\u3DD3\u44E4\u6AA7\u844A\uD84F\uDCB5\u7958\u84A8\uD85A\uDF96\uD85B\uDE77\uD85B\uDE43\u84DE\u840F\u8391\u44A0\u8493\u84E4\uD857\uDC91\u4240\uD857\uDCC0\u4543\u8534\u5AF2\uD85B\uDE99\u4527\u8573\u4516\u67BF\u8616"],["8fa1","\uD861\uDE25\uD861\uDE3B\u85C1\uD85C\uDC88\u8602\uD845\uDD82\uD85C\uDCCD\uD87E\uDDB2\u456A\u8628\u3648\uD846\uDCA2\u53F7\uD85C\uDF9A\u867E\u8771\uD868\uDCF8\u87EE\uD84B\uDC27\u87B1\u87DA\u880F\u5661\u866C\u6856\u460F\u8845\u8846\uD85D\uDDE0\uD84F\uDDB9\uD85D\uDDE4\u885E\u889C\u465B\u88B4\u88B5\u63C1\u88C5\u7777\uD85D\uDF0F\u8987\u898A\u89A6\u89A9\u89A7\u89BC\uD862\uDE25\u89E7\uD85E\uDD24\uD85E\uDEBD\u8A9C\u7793\u91FE\u8A90\uD85E\uDE59\u7AE9\uD85E\uDF3A\uD84F\uDF8F\u4713\uD85E\uDF38\u717C\u8B0C\u8B1F\uD855\uDC30\uD855\uDD65\u8B3F\u8B4C\u8B4D\u8AA9\uD852\uDE7A\u8B90\u8B9B\u8AAF\uD845\uDEDF\u4615\u884F\u8C9B\uD85F\uDD54\uD85F\uDD8F\uD87E\uDDD4\u3725\uD85F\uDD53\u8CD6\uD85F\uDD98\uD85F\uDDBD\u8D12\u8D03\uD846\uDD10\u8CDB\u705C\u8D11\uD853\uDCC9\u3ED0\u8D77"],["9040","\u8DA9\uD860\uDC02\uD844\uDC14\uD852\uDD8A\u3B7C\uD860\uDDBC\uD85C\uDD0C\u7AE7\u8EAD\u8EB6\u8EC3\u92D4\u8F19\u8F2D\uD860\uDF65\uD861\uDC12\u8FA5\u9303\uD868\uDE9F\uD842\uDE50\u8FB3\u492A\uD862\uDDDE\uD861\uDD3D\uD84F\uDDBB\u5EF8\uD84C\uDE62\u8FF9\uD868\uDC14\uD861\uDEBC\uD861\uDD01\uD848\uDF25\u3980\uD85B\uDED7\u9037\uD861\uDD3C\uD85E\uDEBE\u9061\uD861\uDD6C\uD861\uDE0B\u90A8\uD861\uDF13\u90C4\uD861\uDEE6\u90AE\u90FD\u9167\u3AF0\u91A9\u91C4\u7CAC\uD862\uDD33\uD847\uDE89\u920E\u6C9F\u9241\u9262\uD855\uDDB9\u92B9\uD862\uDEC6\uD84F\uDC9B\uD862\uDF0C\uD855\uDDDB"],["90a1","\uD843\uDD31\u932C\u936B\uD862\uDEE1\uD862\uDFEB\u708F\u5AC3\uD862\uDEE2\uD862\uDEE5\u4965\u9244\uD862\uDFEC\uD863\uDC39\uD862\uDFFF\u9373\u945B\u8EBC\u9585\u95A6\u9426\u95A0\u6FF6\u42B9\uD849\uDE7A\uD861\uDED8\uD844\uDE7C\uD84F\uDE2E\u49DF\u6C1C\u967B\u9696\u416C\u96A3\uD85B\uDED5\u61DA\u96B6\u78F5\uD862\uDEE0\u96BD\u53CC\u49A1\uD85B\uDCB8\uD840\uDE74\uD859\uDC10\uD864\uDCAF\uD864\uDCE5\uD852\uDED1\uD846\uDD15\uD84C\uDF0A\u9731\u8642\u9736\u4A0F\u453D\u4585\uD852\uDEE9\u7075\u5B41\u971B\u975C\uD864\uDDD5\u9757\u5B4A\uD864\uDDEB\u975F\u9425\u50D0\uD84C\uDCB7\uD84C\uDCBC\u9789\u979F\u97B1\u97BE\u97C0\u97D2\u97E0\uD855\uDC6C\u97EE\u741C\uD865\uDC33\u97FF\u97F5\uD865\uDC1D\uD85E\uDD7A\u4AD1\u9834\u9833\u984B\u9866\u3B0E\uD85C\uDD75\u3D51\uD841\uDE30\uD850\uDD5C"],["9140","\uD855\uDF06\u98CA\u98B7\u98C8\u98C7\u4AFF\uD85B\uDD27\uD845\uDED3\u55B0\u98E1\u98E6\u98EC\u9378\u9939\uD852\uDE29\u4B72\uD866\uDC57\uD866\uDD05\u99F5\u9A0C\u9A3B\u9A10\u9A58\uD855\uDF25\u36C4\uD864\uDCB1\uD866\uDFD5\u9AE0\u9AE2\uD866\uDF05\u9AF4\u4C0E\u9B14\u9B2D\uD861\uDE00\u5034\u9B34\uD85A\uDDA8\u38C3\uD84C\uDC7D\u9B50\u9B40\uD867\uDD3E\u5A45\uD846\uDC63\u9B8E\uD850\uDE4B\u9C02\u9BFF\u9C0C\uD867\uDE68\u9DD4\uD867\uDFB7\uD868\uDD92\uD868\uDDAB\uD868\uDCE1\uD868\uDD23\uD868\uDDDF\u9D7E\u9D83\uD868\uDD34\u9E0E\u6888"],["91a1","\u9DC4\uD848\uDD5B\uD868\uDD93\uD868\uDE20\uD846\uDD3B\uD868\uDE33\u9D39\uD868\uDCB9\uD868\uDEB4\u9E90\u9E95\u9E9E\u9EA2\u4D34\u9EAA\u9EAF\uD850\uDF64\u9EC1\u3B60\u39E5\u3D1D\u4F32\u37BE\uD863\uDC2B\u9F02\u9F08\u4B96\u9424\uD85B\uDDA2\u9F17\u9F16\u9F39\u569F\u568A\u9F45\u99B8\uD864\uDC8B\u97F2\u847F\u9F62\u9F69\u7ADC\u9F8E\u7216\u4BBE\uD852\uDD75\uD852\uDDBB\u7177\uD852\uDDF8\uD850\uDF48\uD852\uDE51\u739E\uD862\uDFDA\uD846\uDCFA\u799F\uD862\uDD7E\uD863\uDE36\u9369\u93F3\uD862\uDE44\u92EC\u9381\u93CB\uD862\uDD6C\uD851\uDCB9\u7217\u3EEB\u7772\u7A43\u70D0\uD851\uDC73\uD850\uDFF8\u717E\uD845\uDFEF\u70A3\uD846\uDCBE\uD84D\uDD99\u3EC7\uD846\uDC85\uD855\uDC2F\uD845\uDFF8\u3722\uD845\uDEFB\uD846\uDC39\u36E1\uD845\uDF74\uD846\uDCD1\uD857\uDF4B\u3723\uD845\uDEC0\u575B\uD852\uDE25\uD844\uDFFE\uD844\uDEA8"],["9240","\uD844\uDFC6\uD845\uDCB6\u8503\uD84D\uDEA6\u8503\u8455\uD852\uDD94\uD85C\uDD65\uD84F\uDE31\uD855\uDD5C\uD84F\uDEFB\uD85C\uDC52\u44F4\uD84D\uDEEE\uD866\uDD9D\uD85B\uDF26\u67F9\u3733\u3C15\u3DE7\u586C\uD846\uDD22\u6810\u4057\uD84D\uDF3F\uD850\uDCE1\uD850\uDC8B\uD850\uDD0F\uD85B\uDC21\u54CB\u569E\uD859\uDEB1\u5692\uD843\uDFDF\uD842\uDFA8\uD843\uDE0D\u93C6\uD862\uDF13\u939C\u4EF8\u512B\u3819\uD851\uDC36\u4EBC\uD841\uDC65\uD840\uDF7F\u4F4B\u4F8A\uD855\uDE51\u5A68\uD840\uDDAB\uD840\uDFCB\u3999\uD840\uDF0A\uD841\uDC14\u3435\u4F29\uD840\uDEC0\uD863\uDEB3\uD840\uDE75\u8ADA\uD840\uDE0C\u4E98"],["92a1","\u50CD\u510D\u4FA2\u4F03\uD852\uDE0E\uD84F\uDE8A\u4F42\u502E\u506C\u5081\u4FCC\u4FE5\u5058\u50FC\u5159\u515B\u515D\u515E\u6E76\uD84D\uDD95\uD84F\uDE39\uD84F\uDEBF\u6D72\uD846\uDC84\uD84F\uDE89\u51A8\u51C3\uD841\uDDE0\u44DD\uD841\uDCA3\uD841\uDC92\uD841\uDC91\u8D7A\uD862\uDE9C\uD841\uDF0E\u5259\u52A4\uD842\uDC73\u52E1\u936E\u467A\u718C\uD850\uDF8C\uD843\uDC20\uD852\uDDAC\uD844\uDCE4\u69D1\uD843\uDE1D\u7479\u3EDE\u7499\u7414\u7456\u7398\u4B8E\uD852\uDEBC\uD850\uDC8D\u53D0\u3584\u720F\uD850\uDCC9\u55B4\uD840\uDF45\u54CD\uD842\uDFC6\u571D\u925D\u96F4\u9366\u57DD\u578D\u577F\u363E\u58CB\u5A99\uD862\uDE46\uD845\uDEFA\uD845\uDF6F\uD845\uDF10\u5A2C\u59B8\u928F\u5A7E\u5ACF\u5A12\uD856\uDD46\uD846\uDDF3\uD846\uDC61\uD850\uDE95\u36F5\u6D05\u7443\u5A21\uD857\uDE83"],["9340","\u5A81\uD862\uDFD7\uD841\uDC13\u93E0\u748C\uD844\uDF03\u7105\u4972\u9408\uD862\uDDFB\u93BD\u37A0\u5C1E\u5C9E\u5E5E\u5E48\uD846\uDD96\uD846\uDD7C\uD84E\uDEEE\u5ECD\u5B4F\uD846\uDD03\uD846\uDD04\u3701\uD846\uDCA0\u36DD\uD845\uDEFE\u36D3\u812A\uD862\uDE47\uD847\uDDBA\uD84D\uDC72\uD862\uDDA8\u5F0C\u5F0E\uD846\uDD27\uD845\uDFAB\u5A6B\uD845\uDF3B\u5B44\u8614\uD85D\uDDFD\u8860\u607E\uD84A\uDC60\uD849\uDE2B\u5FDB\u3EB8\uD849\uDDAF\uD849\uDDBE\uD864\uDC88\uD85B\uDF73\u61C0\uD840\uDC3E\uD840\uDC46\uD849\uDE1B\u6199\u6198\u6075\uD84B\uDC9B\uD84B\uDD07\uD851\uDED4\uD864\uDD4D"],["93a1","\u6471\uD851\uDE65\uD84A\uDF6A\u3A29\uD84A\uDF22\uD84D\uDC50\uD866\uDCEA\uD84B\uDE78\u6337\uD869\uDC5B\u64B6\u6331\u63D1\uD852\uDDE3\uD84B\uDD67\u62A4\uD84B\uDCA1\u643B\u656B\u6972\u3BF4\uD84C\uDC8E\uD84C\uDEAD\uD852\uDD89\uD84C\uDEAB\u550D\uD84C\uDEE0\uD846\uDCD9\uD865\uDC3F\u66CE\uD84C\uDE89\uD84C\uDDB3\u3AE0\u4190\uD855\uDD84\uD862\uDF22\uD855\uDD8F\uD845\uDEFC\uD855\uDD5B\uD855\uDC25\u78EE\uD84C\uDD03\uD846\uDC2A\uD84C\uDE34\u3464\uD84C\uDE0F\uD84C\uDD82\uD850\uDEC9\u668E\uD85B\uDD24\u666B\u4B93\u6630\uD85E\uDC70\uD847\uDDEB\u6663\uD84C\uDED2\uD84C\uDEE1\u661E\uD856\uDC72\u38D1\uD84E\uDC3A\uD84D\uDFBC\u3B99\uD84D\uDFA2\uD84C\uDFFE\u74D0\u3B96\u678F\uD851\uDE2A\u68B6\u681E\u3BC4\u6ABE\u3863\uD84D\uDFD5\uD851\uDC87\u6A33\u6A52\u6AC9\u6B05\uD846\uDD12\u6511\u6898\u6A4C\u3BD7\u6A7A\u6B57\uD84F\uDFC0\uD84F\uDC9A\u93A0\u92F2\uD862\uDFEA\uD862\uDECB"],["9440","\u9289\uD860\uDC1E\uD862\uDDDC\u9467\u6DA5\u6F0B\uD852\uDDEC\u6D67\uD84F\uDF7F\u3D8F\u6E04\uD850\uDC3C\u5A3D\u6E0A\u5847\u6D24\u7842\u713B\uD850\uDF1A\uD850\uDE76\u70F1\u7250\u7287\u7294\uD851\uDF8F\uD851\uDF25\u5179\uD852\uDEA4\uD841\uDDEB\u747A\uD84F\uDEF8\uD84D\uDE5F\uD852\uDE4A\uD852\uDD17\uD857\uDFE1\u3F06\u3EB1\uD852\uDEDF\uD863\uDC23\uD84F\uDF35\u60A7\u3EF3\u74CC\u743C\u9387\u7437\u449F\uD85B\uDDEA\u4551\u7583\u3F63\uD853\uDCD9\uD853\uDD06\u3F58\u7555\u7673\uD869\uDDC6\u3B19\u7468\uD862\uDECC\uD852\uDDAB\uD852\uDD8E\u3AFB"],["94a1","\u3DCD\uD852\uDE4E\u3EFF\uD852\uDDC5\uD852\uDCF3\u91FA\u5732\u9342\uD862\uDEE3\uD846\uDC64\u50DF\uD854\uDE21\uD854\uDDE7\u7778\uD84C\uDE32\u770E\u770F\u777B\uD851\uDE97\uD84D\uDF81\u3A5E\uD852\uDCF0\u7438\u749B\u3EBF\uD852\uDEBA\uD852\uDEC7\u40C8\uD852\uDE96\uD858\uDDAE\u9307\uD855\uDD81\u781E\u788D\u7888\u78D2\u73D0\u7959\uD85D\uDF41\uD855\uDEE3\u410E\u799B\u8496\u79A5\u6A2D\uD84F\uDEFA\u7A3A\u79F4\u416E\uD845\uDEE6\u4132\u9235\u79F1\uD843\uDD4C\uD852\uDD8C\uD840\uDE99\uD84F\uDDBA\uD845\uDF6E\u3597\u556B\u3570\u36AA\uD840\uDDD4\uD843\uDC0D\u7AE2\u5A59\uD849\uDEF5\uD856\uDEAF\uD856\uDE9C\u5A0D\uD840\uDE5B\u78F0\u5A2A\uD856\uDFC6\u7AFE\u41F9\u7C5D\u7C6D\u4211\uD856\uDFB3\uD857\uDEBC\uD857\uDEA6\u7CCD\uD852\uDDF9\uD845\uDFB0\u7C8E\u7C7C\u7CAE\u6AB2\u7DDC\u7E07\u7DD3\u7F4E\uD858\uDE61"],["9540","\uD858\uDD5C\uD85E\uDF48\u7D97\uD857\uDE82\u426A\uD85A\uDF75\uD842\uDD16\u67D6\uD840\uDC4E\uD84D\uDDCF\u57C4\uD859\uDC12\uD858\uDFF8\uD852\uDD62\u7FDD\u7B27\uD842\uDC2C\uD856\uDEE9\uD857\uDD43\u7B0C\uD857\uDE0E\u99E6\u8645\u9A63\u6A1C\uD84D\uDC3F\u39E2\uD852\uDDF7\uD859\uDDAD\u9A1F\uD859\uDDA0\u8480\uD85C\uDD27\uD85B\uDCD1\u44EA\u8137\u4402\u80C6\u8109\u8142\uD859\uDFB4\u98C3\uD85A\uDE42\u8262\u8265\uD85A\uDE51\u8453\uD85B\uDDA7\u8610\uD85C\uDE1B\u5A86\u417F\uD846\uDC40\u5B2B\uD846\uDCA1\u5AE4\uD846\uDCD8\u86A0\uD87E\uDDBC\uD84F\uDD8F\u882D\uD85D\uDC22\u5A02"],["95a1","\u886E\u4F45\u8887\u88BF\u88E6\u8965\u894D\uD855\uDE83\u8954\uD85D\uDF85\uD85D\uDF84\uD862\uDFF5\uD862\uDFD9\uD862\uDF9C\uD862\uDDF9\u3EAD\u84A3\u46F5\u46CF\u37F2\u8A3D\u8A1C\uD865\uDC48\u5F4D\u922B\uD850\uDE84\u65D4\u7129\u70C4\uD846\uDC45\u9D6D\u8C9F\u8CE9\uD85F\uDDDC\u599A\u77C3\u59F0\u436E\u36D4\u8E2A\u8EA7\uD853\uDC09\u8F30\u8F4A\u42F4\u6C58\u6FBB\uD848\uDF21\u489B\u6F79\u6E8B\uD845\uDFDA\u9BE9\u36B5\uD852\uDD2F\u90BB\u9097\u5571\u4906\u91BB\u9404\uD862\uDE4B\u4062\uD862\uDEFC\u9427\uD863\uDC1D\uD863\uDC3B\u84E5\u8A2B\u9599\u95A7\u9597\u9596\uD863\uDD34\u7445\u3EC2\uD852\uDCFF\uD852\uDE42\uD850\uDFEA\u3EE7\uD84C\uDE25\u968F\uD863\uDEE7\uD863\uDE66\uD863\uDE65\u3ECC\uD852\uDDED\uD852\uDE78\uD84F\uDFEE\u7412\u746B\u3EFC\u9741\uD864\uDCB0"],["9640","\u6847\u4A1D\uD864\uDC93\uD855\uDFDF\u975D\u9368\uD862\uDD89\uD863\uDC26\uD862\uDF2F\uD858\uDFBE\u92BA\u5B11\u8B69\u493C\u73F9\uD850\uDE1B\u979B\u9771\u9938\uD843\uDF26\u5DC1\uD862\uDFC5\uD852\uDEB2\u981F\uD865\uDCDA\u92F6\uD865\uDDD7\u91E5\u44C0\uD862\uDF50\uD852\uDE67\uD862\uDF64\u98DC\uD862\uDE45\u3F00\u922A\u4925\u8414\u993B\u994D\uD85E\uDF06\u3DFD\u999B\u4B6F\u99AA\u9A5C\uD862\uDF65\uD856\uDCC8\u6A8F\u9A21\u5AFE\u9A2F\uD866\uDCF1\u4B90\uD866\uDD48\u99BC\u4BBD\u4B97\u937D\u5872\uD844\uDF02\u5822\uD852\uDDB8"],["96a1","\uD845\uDCE8\u7844\uD849\uDF1F\uD84F\uDDB8\u68C5\u3D7D\u9458\u3927\u6150\uD849\uDF81\uD84A\uDD6B\u6107\u9C4F\u9C53\u9C7B\u9C35\u9C10\u9B7F\u9BCF\uD867\uDE2D\u9B9F\uD868\uDDF5\uD868\uDCFE\u9D21\u4CAE\uD850\uDD04\u9E18\u4CB0\u9D0C\uD868\uDDB4\uD868\uDCED\uD868\uDCF3\uD866\uDD2F\u9DA5\u84BD\uD85B\uDE12\uD85B\uDFDF\uD85A\uDF82\u85FC\u4533\uD85B\uDDA4\uD85B\uDE84\uD85B\uDDF0\u8420\u85EE\uD85B\uDE00\uD84D\uDFD7\uD858\uDC64\u79E2\uD84D\uDD9C\uD84D\uDE40\u492D\uD852\uDDDE\u3D62\u93DB\u92BE\u9348\uD840\uDEBF\u78B9\u9277\u944D\u4FE4\u3440\u9064\uD855\uDD5D\u783D\u7854\u78B6\u784B\uD845\uDF57\uD84C\uDDC9\uD852\uDD41\u369A\u4F72\u6FDA\u6FD9\u701E\u701E\u5414\uD850\uDDB5\u57BB\u58F3\u578A\u9D16\u57D7\u7134\u34AF\uD850\uDDAC\u71EB\uD85B\uDC40\uD853\uDF97\u5B28\uD845\uDFB5\uD862\uDE49"],["9740","\u610C\u5ACE\u5A0B\u42BC\uD851\uDC88\u372C\u4B7B\uD862\uDDFC\u93BB\u93B8\uD846\uDCD6\uD843\uDF1D\u8472\uD85B\uDCC0\uD845\uDC13\uD850\uDEFA\uD84B\uDC26\uD850\uDFC1\u5994\uD84F\uDDB7\uD859\uDF41\u7DA8\uD858\uDD5B\uD858\uDCA4\uD852\uDDB9\uD852\uDD8B\uD862\uDDFA\u92E5\u73E2\u3EE9\u74B4\uD862\uDF63\uD846\uDC9F\u3EE1\uD852\uDEB3\u6AD8\u73F3\u73FB\u3ED6\uD852\uDE3E\uD852\uDE94\uD845\uDFD9\uD852\uDE66\uD840\uDFA7\uD845\uDC24\uD852\uDDE5\u7448\uD852\uDD16\u70A5\uD852\uDD76\u9284\u73E6\u935F\uD841\uDCFE\u9331\uD862\uDECE\uD862\uDE16\u9386\uD862\uDFE7\uD855\uDDD5\u4935\uD862\uDE82\u716B"],["97a1","\uD852\uDD43\uD843\uDCFF\u56A4\uD841\uDE1A\uD842\uDFEB\uD843\uDCB8\u5502\u79C4\uD845\uDFFA\u7DFE\uD845\uDEC2\uD852\uDE50\uD846\uDC52\u452E\u9401\u370A\uD862\uDEC0\uD852\uDDAD\u59B0\uD846\uDCBF\uD846\uDC83\uD85D\uDC84\u5AA1\u36E2\uD84F\uDD5B\u36B0\u925F\u5A79\uD862\uDE81\uD846\uDC62\u9374\u3CCD\uD842\uDEB4\u4A96\u398A\u50F4\u3D69\u3D4C\uD844\uDF9C\u7175\u42FB\uD860\uDE18\u6E0F\uD864\uDCE4\u44EB\u6D57\uD85F\uDE4F\u7067\u6CAF\u3CD6\uD84F\uDFED\uD84F\uDE2D\u6E02\u6F0C\u3D6F\uD840\uDFF5\u7551\u36BC\u34C8\u4680\u3EDA\u4871\u59C4\u926E\u493E\u8F41\uD863\uDC1C\uD85A\uDFC0\u5812\u57C8\u36D6\uD845\uDC52\u70FE\uD850\uDF62\uD852\uDE71\uD84B\uDFE3\uD844\uDEB0\uD848\uDFBD\u68B9\u6967\uD844\uDF98\uD84D\uDCE5\uD85E\uDFF4\uD84D\uDEDF\uD862\uDE83\uD84D\uDFD6\uD84C\uDFFA\uD853\uDC9F\u6A1A\uD84D\uDEAD\uD85B\uDCB7\u843E\u44DF\u44CE"],["9840","\uD85B\uDD26\uD85B\uDD51\uD85B\uDC82\uD85B\uDFDE\u6F17\uD85C\uDD09\u833D\uD845\uDF3A\u83ED\uD85B\uDC80\uD85C\uDC53\uD845\uDFDB\u5989\u5A82\uD845\uDFB3\u5A61\u5A71\uD846\uDD05\uD850\uDDFC\u372D\u59EF\uD845\uDF3C\u36C7\u718E\u9390\u669A\uD850\uDEA5\u5A6E\u5A2B\uD850\uDE93\u6A2B\uD84F\uDEF9\uD85D\uDF36\uD851\uDC5B\uD850\uDECA\u711D\uD850\uDE59\uD862\uDDE1\u4FB0\uD85B\uDD28\u5CC2\uD851\uDCCE\uD85F\uDE4D\uD850\uDFBD\u6A0C\uD850\uDE56\uD844\uDF04\u70A6\u7133\uD850\uDFE9\u3DA5\u6CDF\uD87E\uDC25\uD852\uDE4F\u7E65\u59EB\u5D2F\u3DF3\u5F5C\uD852\uDE5D\uD845\uDFDF\u7DA4\u8426"],["98a1","\u5485\uD84E\uDEFA\uD84C\uDF00\uD840\uDE14\u577E\uD842\uDCD5\uD841\uDE19\u3FE5\uD847\uDF9E\uD868\uDEB6\u7003\uD864\uDD5B\u5D70\u738F\u7CD3\uD862\uDE59\uD865\uDC20\u4FC8\u7FE7\u72CD\u7310\uD85E\uDEF4\u7338\u7339\uD855\uDEF6\u7341\u7348\u3EA9\uD85E\uDF18\u906C\u71F5\uD852\uDCF2\u73E1\u81F6\u3ECA\u770C\u3ED1\u6CA2\u56FD\u7419\u741E\u741F\u3EE2\u3EF0\u3EF4\u3EFA\u74D3\u3F0E\u3F53\u7542\u756D\u7572\u758D\u3F7C\u75C8\u75DC\u3FC0\u764D\u3FD7\u7674\u3FDC\u767A\uD853\uDF5C\u7188\u5623\u8980\u5869\u401D\u7743\u4039\u6761\u4045\u35DB\u7798\u406A\u406F\u5C5E\u77BE\u77CB\u58F2\u7818\u70B9\u781C\u40A8\u7839\u7847\u7851\u7866\u8448\uD855\uDD35\u7933\u6803\u7932\u4103"],["9940","\u4109\u7991\u7999\u8FBB\u7A06\u8FBC\u4167\u7A91\u41B2\u7ABC\u8279\u41C4\u7ACF\u7ADB\u41CF\u4E21\u7B62\u7B6C\u7B7B\u7C12\u7C1B\u4260\u427A\u7C7B\u7C9C\u428C\u7CB8\u4294\u7CED\u8F93\u70C0\uD843\uDCCF\u7DCF\u7DD4\u7DD0\u7DFD\u7FAE\u7FB4\u729F\u4397\u8020\u8025\u7B39\u802E\u8031\u8054\u3DCC\u57B4\u70A0\u80B7\u80E9\u43ED\u810C\u732A\u810E\u8112\u7560\u8114\u4401\u3B39\u8156\u8159\u815A"],["99a1","\u4413\u583A\u817C\u8184\u4425\u8193\u442D\u81A5\u57EF\u81C1\u81E4\u8254\u448F\u82A6\u8276\u82CA\u82D8\u82FF\u44B0\u8357\u9669\u698A\u8405\u70F5\u8464\u60E3\u8488\u4504\u84BE\u84E1\u84F8\u8510\u8538\u8552\u453B\u856F\u8570\u85E0\u4577\u8672\u8692\u86B2\u86EF\u9645\u878B\u4606\u4617\u88AE\u88FF\u8924\u8947\u8991\uD85E\uDD67\u8A29\u8A38\u8A94\u8AB4\u8C51\u8CD4\u8CF2\u8D1C\u4798\u585F\u8DC3\u47ED\u4EEE\u8E3A\u55D8\u5754\u8E71\u55F5\u8EB0\u4837\u8ECE\u8EE2\u8EE4\u8EED\u8EF2\u8FB7\u8FC1\u8FCA\u8FCC\u9033\u99C4\u48AD\u98E0\u9213\u491E\u9228\u9258\u926B\u92B1\u92AE\u92BF"],["9a40","\u92E3\u92EB\u92F3\u92F4\u92FD\u9343\u9384\u93AD\u4945\u4951\u9EBF\u9417\u5301\u941D\u942D\u943E\u496A\u9454\u9479\u952D\u95A2\u49A7\u95F4\u9633\u49E5\u67A0\u4A24\u9740\u4A35\u97B2\u97C2\u5654\u4AE4\u60E8\u98B9\u4B19\u98F1\u5844\u990E\u9919\u51B4\u991C\u9937\u9942\u995D\u9962\u4B70\u99C5\u4B9D\u9A3C\u9B0F\u7A83\u9B69\u9B81\u9BDD\u9BF1\u9BF4\u4C6D\u9C20\u376F\uD846\uDFC2\u9D49\u9C3A"],["9aa1","\u9EFE\u5650\u9D93\u9DBD\u9DC0\u9DFC\u94F6\u8FB6\u9E7B\u9EAC\u9EB1\u9EBD\u9EC6\u94DC\u9EE2\u9EF1\u9EF8\u7AC8\u9F44\uD840\uDC94\uD840\uDEB7\uD840\uDFA0\u691A\u94C3\u59AC\uD841\uDCD7\u5840\u94C1\u37B9\uD841\uDDD5\uD841\uDE15\uD841\uDE76\uD845\uDEBA\u5757\u7173\uD842\uDEC2\uD842\uDECD\uD842\uDFBF\u546A\uD87E\uDC3B\uD842\uDFCB\u549E\uD842\uDFFB\uD843\uDC3B\uD843\uDC53\uD843\uDC65\uD843\uDC7C\u60E7\uD843\uDC8D\u567A\uD843\uDCB5\uD843\uDCDD\uD843\uDCED\uD843\uDD6F\uD843\uDDB2\uD843\uDDC8\u6955\u9C2F\u87A5\uD843\uDE04\uD843\uDE0E\uD843\uDED7\uD843\uDF90\uD843\uDF2D\uD843\uDE73\u5C20\uD843\uDFBC\u5E0B\uD844\uDC5C\uD844\uDC4F\uD844\uDC76\u671E\uD844\uDC7B\uD844\uDC88\uD844\uDC96\u3647\uD844\uDCBF\uD844\uDCD3\uD844\uDD2F\uD844\uDD3B\u5364\u84AD\uD844\uDEE3\uD844\uDF75\uD844\uDF36\u8B81\uD845\uDD77\uD845\uDE19\uD845\uDFC3\uD845\uDFC7\u4E78\u70BB\uD846\uDC2D\uD846\uDD6A"],["9b40","\uD846\uDE2D\uD846\uDE45\uD847\uDC2A\uD847\uDC70\uD847\uDCAC\uD847\uDEC8\u62C3\uD847\uDED5\uD847\uDF15\u7198\u6855\uD848\uDC45\u69E9\u36C8\uD848\uDE7C\uD848\uDFD7\uD848\uDFFA\uD849\uDF2A\uD84A\uDC71\uD84A\uDD4F\u82FD\uD84A\uDD67\uD84A\uDD93\uD84A\uDED5\u89A5\uD84A\uDEE8\u8FA0\uD84A\uDF0E\u97B8\uD84A\uDF3F\u9847\u9ABD\uD84B\uDC4C"],["9b62","\uD84B\uDC88\uD84B\uDCB7\uD856\uDFE8\uD84B\uDD08\uD84B\uDD12\uD84B\uDDB7\uD84B\uDD95\uD84B\uDE42\uD84B\uDF74\uD84B\uDFCC\uD84C\uDC33\uD84C\uDC66\uD84C\uDF1F\uD84C\uDFDE\u5FB1\u6648\u66BF\uD85E\uDE79\uD84D\uDD67\uD84D\uDDF3\u7201\uD852\uDDBA\u77D7\uD84D\uDE1A\uD84D\uDF16\u7E87\uD840\uDF46\u58B5\u670E"],["9ba1","\u6918\uD84E\uDEA7\uD85D\uDE57\uD857\uDFE2\uD84F\uDE11\uD84F\uDEB9\uD85D\uDDFE\uD848\uDC9A\u48D0\u4AB8\uD850\uDD19\uD862\uDE9A\uD850\uDEEE\uD850\uDF0D\uD850\uDC3B\uD850\uDF34\uD850\uDF96\uD852\uDE45\uD841\uDDCA\u51D2\uD841\uDE11\u599F\uD847\uDEA8\u3BBE\uD84F\uDCFF\uD851\uDC04\uD851\uDCD6\u5788\uD851\uDE74\u399B\uD851\uDF2F\uD861\uDDE8\uD866\uDDC9\u3762\uD848\uDDC3\u8B5E\uD862\uDF4E\u99D6\uD852\uDC12\uD852\uDCFB\uD852\uDE15\u7209\uD852\uDEC0\uD843\uDC78\u5965\uD853\uDEA5\uD853\uDF86\uD841\uDF79\u8EDA\uD854\uDC2C\u528F\u573F\u7171\uD854\uDE99\uD855\uDC19\uD84F\uDF4A\uD852\uDEA7\u55BC\uD855\uDC46\uD855\uDC6E\uD85A\uDF52\u91D4\u3473\uD855\uDD3F\uD85D\uDE32\uD855\uDD5E\u4718\uD855\uDD62\uD855\uDD66\uD855\uDFC7\uD852\uDD3F\uD856\uDC5D\u5066\u34FB\uD84C\uDFCC\u60DE\uD856\uDD03\u477C\uD862\uDD48\uD856\uDEAE\uD856\uDF89\uD857\uDC06\uD847\uDD90\u57A1\u7151\u6FB6\uD858\uDD02\uD85F\uDC12\u9056\uD858\uDDB2\uD853\uDF9A\u8B62\uD859\uDC02\uD859\uDC4A"],["9c40","\u5D5B\uD85A\uDFF7\u8F36\uD859\uDC84\uD846\uDD1C\u8AEA\uD852\uDDF6\uD859\uDC88\uD84F\uDFEF\uD859\uDD12\u4BC0\uD859\uDDBF\uD859\uDEB5\uD849\uDF1B\u9465\uD855\uDFE1\u6195\u5A27\uD87E\uDCCD\u4FBB\u56B9\uD851\uDD21\uD859\uDEFC\u4E6A\uD852\uDD34\u9656\u6D8F\uD85B\uDCBD\u3618\u8977\uD859\uDF99\uD85A\uDC6E\uD859\uDC11\uD85A\uDC5E\u71DF\uD85A\uDCC7\u7B42\uD864\uDCC0\uD842\uDE11\uD85A\uDD26\u9104\uD85A\uDD39\u7A45\u9DF0\uD85A\uDDFA\u9A26\uD85A\uDE2D\u365F\uD859\uDC69\uD840\uDC21\u7983\uD85A\uDE34\uD85A\uDF5B\u5D2C\uD84D\uDD19\u83CF\uD85A\uDF9D\u46D0\uD85B\uDCA4\u753B\u8865\uD85B\uDDAE\u58B6"],["9ca1","\u371C\uD849\uDD8D\uD85C\uDC4B\uD85C\uDDCD\u3C54\uD85C\uDE80\uD85C\uDE85\u9281\uD848\uDD7A\uD85C\uDE8B\u9330\uD85C\uDEE6\uD852\uDDD0\u6C39\u949F\uD85D\uDC50\uD843\uDEF8\u8827\u88F5\uD84A\uDD26\uD861\uDC73\uD845\uDFB1\u6EB8\uD852\uDE2A\uD846\uDC20\u39A4\u36B9\u5C10\u79E3\u453F\u66B6\uD867\uDCAD\uD866\uDCA4\u8943\uD85D\uDFCC\uD85E\uDC58\u56D6\u40DF\uD845\uDE0A\u39A1\uD84D\uDF2F\uD860\uDCE8\uD844\uDFC5\u71AD\u8366\uD85E\uDDDD\uD864\uDDA8\u5A67\u4CB7\uD85C\uDCAF\uD862\uDDAB\uD85E\uDDFD\uD85E\uDE0A\uD85E\uDF0B\uD85F\uDD66\uD850\uDD7A\u7B43\u797E\uD860\uDC09\u6FB5\uD868\uDEDF\u6A03\uD860\uDF18\u53A2\uD85B\uDE07\u93BF\u6836\u975D\uD860\uDD6F\uD860\uDC23\uD85A\uDDB5\uD844\uDFED\uD84C\uDE2F\uD860\uDC48\u5D85\uD863\uDC30\uD860\uDC83\u5715\u9823\uD862\uDD49\u5DAB\uD852\uDD88\u65BE\u69D5\u53D2\uD852\uDEA5\uD84F\uDF81\u3C11\u6736\uD860\uDC90\uD860\uDCF4\uD860\uDD2E\uD847\uDFA1\uD860\uDD4F"],["9d40","\uD860\uDD89\uD860\uDDAF\uD860\uDE1A\uD860\uDF06\uD860\uDF2F\uD860\uDF8A\u35CA\uD861\uDC68\uD861\uDEAA\u48FA\u63E6\uD862\uDD56\u7808\u9255\uD862\uDDB8\u43F2\uD862\uDDE7\u43DF\uD862\uDDE8\uD862\uDF46\uD862\uDFD4\u59F8\uD863\uDC09\u8F0B\uD863\uDFC5\uD864\uDCEC\u7B51\uD864\uDD10\uD864\uDD3C\u3DF7\uD864\uDD5E\uD852\uDECA\u8FD0\u728F\u568B\uD865\uDCE7\uD865\uDDE9\uD865\uDDB0\uD865\uDDB8\uD865\uDF32\uD866\uDCD1\uD866\uDD49\uD866\uDD6A\uD866\uDDC3\uD866\uDE28\uD866\uDF0E\uD867\uDD5A\uD867\uDD9B\u7E9F\uD867\uDEF8\uD867\uDF23\u4CA4\u9547\uD868\uDE93\u71A2\uD868\uDEFF\u4D91\u9012\uD869\uDDCB\u4D9C\uD843\uDC9C\u8FBE\u55C1"],["9da1","\u8FBA\uD849\uDCB0\u8FB9\uD852\uDE93\u4509\u7E7F\u6F56\u6AB1\u4EEA\u34E4\uD862\uDF2C\uD85E\uDC9D\u373A\u8E80\uD845\uDFF5\uD860\uDC24\uD862\uDF6C\uD862\uDF99\uD85E\uDE3E\uD859\uDEAF\u3DEB\uD85D\uDE55\uD84F\uDCB7\uD855\uDE35\uD856\uDD56\u4E9A\uD857\uDE81\uD858\uDE58\u56BF\uD843\uDE6D\u8E0E\u5B6D\uD84F\uDE88\uD853\uDC9E\u63DE\u62D0\uD845\uDFF6\uD846\uDC7B\u6530\u562D\uD857\uDC4A\u541A\uD854\uDF11\u3DC6\uD867\uDD98\u4C7D\u5622\u561E\u7F49\uD857\uDED8\u5975\uD84F\uDD40\u8770\u4E1C\uD843\uDFEA\uD843\uDD49\uD84D\uDEBA\u8117\u9D5E\u8D18\u763B\u9C45\u764E\u77B9\u9345\u5432\u8148\u82F7\u5625\u8132\u8418\u80BD\u55EA\u7962\u5643\u5416\uD843\uDE9D\u35CE\u5605\u55F1\u66F1\uD860\uDEE2\u362D\u7534\u55F0\u55BA\u5497\u5572\uD843\uDC41\uD843\uDC96\u5ED0\uD854\uDD48\uD843\uDE76\uD84B\uDC62"],["9e40","\uD843\uDEA2\u9EAB\u7D5A\u55DE\uD844\uDC75\u629D\u976D\u5494\u8CCD\u71F6\u9176\u63FC\u63B9\u63FE\u5569\uD84A\uDF43\u9C72\uD84B\uDEB3\u519A\u34DF\uD843\uDDA7\u51A7\u544D\u551E\u5513\u7666\u8E2D\uD85A\uDC8A\u75B1\u80B6\u8804\u8786\u88C7\u81B6\u841C\uD844\uDCC1\u44EC\u7304\uD851\uDF06\u5B90\u830B\uD85A\uDC93\u567B\uD849\uDEF4\uD85F\uDD2F\uD850\uDDA3\uD85F\uDD73\uD85B\uDED0\uD85C\uDEB6\u9170\uD844\uDDD9\u9208\uD84F\uDCFC\uD869\uDEA9\uD843\uDEAC\uD843\uDEF9\u7266\uD847\uDCA2\u474E\uD853\uDFC2\uD85F\uDFF9\uD843\uDFEB\u40FA"],["9ea1","\u9C5D\u651F\uD84B\uDDA0\u48F3\uD851\uDFE0\uD867\uDD7C\uD843\uDFEC\uD843\uDE0A\u6062\uD85D\uDDA3\uD843\uDFED"],["9ead","\uD858\uDC48\uD844\uDD87\u71A3\u7E8E\u9D50\u4E1A\u4E04\u3577\u5B0D\u6CB2\u5367\u36AC\u39DC\u537D\u36A5\uD851\uDE18\u589A\uD852\uDF6E\u822D\u544B\u57AA\uD856\uDE95\uD842\uDD79"],["9ec5","\u3A52\uD849\uDC65\u7374\uD867\uDEAC\u4D09\u9BED\uD84F\uDCFE\uD867\uDF30\u4C5B\uD853\uDFA9\uD865\uDD9E\uD867\uDFDE\u845C\uD84F\uDDB6\uD85C\uDEB2\uD859\uDFB3\uD84D\uDF20\u632E\u7D25\uD84F\uDEF7\uD84F\uDE2C\u3A2A\u9008\u52CC\u3E74\u367A\u45E9\uD841\uDC8E\u7640\u5AF0\uD843\uDEB6\u787A\uD85F\uDF2E\u58A7\u40BF\u567C\u9B8B\u5D74\u7654\uD869\uDC34\u9E85\u4CE1\u75F9\u37FB\u6119\uD84C\uDCDA\uD850\uDFF2"],["9ef5","\u565D\uD844\uDEA9\u57A7\uD852\uDD63\uD867\uDE06\u5234\uD85C\uDCAE\u35AD\u6C4A\u9D7C"],["9f40","\u7C56\u9B39\u57DE\uD845\uDF6C\u5C53\u64D3\uD865\uDCD0\uD858\uDF35\uD85C\uDD64\u86AD\uD843\uDD28\uD85B\uDD22\uD852\uDEE2\uD843\uDD71"],["9f4f","\u51FE\uD847\uDF0F\u5D8E\u9703\uD847\uDDD1\u9E81\u904C\u7B1F\u9B02\u5CD1\u7BA3\u6268\u6335\u9AFF\u7BCF\u9B2A\u7C7E\u9B2E\u7C42\u7C86\u9C15\u7BFC\u9B09\u9F17\u9C1B\uD852\uDD3E\u9F5A\u5573\u5BC3\u4FFD\u9E98\u4FF2\u5260\u3E06\u52D1\u5767\u5056\u59B7\u5E12\u97C8\u9DAB\u8F5C\u5469\u97B4\u9940\u97BA\u532C\u6130"],["9fa1","\u692C\u53DA\u9C0A\u9D02\u4C3B\u9641\u6980\u50A6\u7546\uD845\uDF6D\u99DA\u5273"],["9fae","\u9159\u9681\u915C"],["9fb2","\u9151\uD863\uDE97\u637F\uD85B\uDD23\u6ACA\u5611\u918E\u757A\u6285\uD840\uDFFC\u734F\u7C70\uD857\uDC21\uD84F\uDCFD"],["9fc1","\uD852\uDD19\u76D6\u9B9D\u4E2A\uD843\uDCD4\u83BE\u8842"],["9fc9","\u5C4A\u69C0\u50ED\u577A\u521F\u5DF5\u4ECE\u6C31\uD840\uDDF2\u4F39\u549C\u54DA\u529A\u8D82\u35FE\u5F0C\u35F3"],["9fdb","\u6B52\u917C\u9FA5\u9B97\u982E\u98B4\u9ABA\u9EA8\u9E84\u717A\u7B14"],["9fe7","\u6BFA\u8818\u7F78"],["9feb","\u5620\uD869\uDE4A\u8E77\u9F53"],["9ff0","\u8DD4\u8E4F\u9E1C\u8E01\u6282\uD860\uDF7D\u8E28\u8E75\u7AD3\uD852\uDE77\u7A3E\u78D8\u6CEA\u8A67\u7607"],["a040","\uD862\uDE5A\u9F26\u6CCE\u87D6\u75C3\uD868\uDEB2\u7853\uD87E\uDC40\u8D0C\u72E2\u7371\u8B2D\u7302\u74F1\u8CEB\uD852\uDEBB\u862F\u5FBA\u88A0\u44B7"],["a055","\uD846\uDC3B\uD85B\uDE05"],["a058","\u8A7E\uD849\uDD1B"],["a05b","\u60FD\u7667\u9AD7\u9D44\u936E\u9B8F\u87F5"],["a063","\u880F\u8CF7\u732C\u9721\u9BB0\u35D6\u72B2\u4C07\u7C51\u994A\uD858\uDD59\u6159\u4C04\u9E96\u617D"],["a073","\u575F\u616F\u62A6\u6239\u62CE\u3A5C\u61E2\u53AA\uD84C\uDFF5\u6364\u6802\u35D2"],["a0a1","\u5D57\uD862\uDFC2\u8FDA\uD863\uDE39"],["a0a6","\u50D9\uD847\uDD46\u7906\u5332\u9638\uD843\uDF3B\u4065"],["a0ae","\u77FE"],["a0b0","\u7CC2\uD857\uDF1A\u7CDA\u7A2D\u8066\u8063\u7D4D\u7505\u74F2\u8994\u821A\u670C\u8062\uD85D\uDC86\u805B\u74F0\u8103\u7724\u8989\uD859\uDFCC\u7553\uD85B\uDED1\u87A9\u87CE\u81C8\u878C\u8A49\u8CAD\u8B43\u772B\u74F8\u84DA\u3635\u69B2\u8DA6"],["a0d4","\u89A9\u7468\u6DB9\u87C1\uD850\uDC11\u74E7\u3DDB\u7176\u60A4\u619C\u3CD1\u7162\u6077"],["a0e2","\u7F71\uD862\uDF2D\u7250\u60E9\u4B7E\u5220\u3C18\uD84F\uDCC7\uD857\uDED7\uD85D\uDE56\uD855\uDD31\uD846\uDD44\uD844\uDEFE\uD866\uDD03\uD85B\uDDDC\uD85C\uDCAD\u5CC1\uD858\uDDAD\uD862\uDE0F\uD84D\uDE77\uD840\uDCEE\uD85A\uDC46\uD853\uDF0E\u4562\u5B1F\uD858\uDF4C\u9F50\u9EA6\uD858\uDE6B"],["a3c0","\u2400",31,"\u2421"],["c6a1","\u2460",9,"\u2474",9,"\u2170",9,"\u4E36\u4E3F\u4E85\u4EA0\u5182\u5196\u51AB\u52F9\u5338\u5369\u53B6\u590A\u5B80\u5DDB\u2F33\u5E7F\u5EF4\u5F50\u5F61\u6534\u65E0\u7592\u7676\u8FB5\u96B6\xa8\u02C6\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\uFF3B\uFF3D\u273D\u3041",23],["c740","\u3059",58,"\u30A1\u30A2\u30A3\u30A4"],["c7a1","\u30A5",81,"\u0410",5,"\u0401\u0416",4],["c840","\u041B",26,"\u0451\u0436",25,"\u21E7\u21B8\u21B9\u31CF\uD840\uDCCC\u4E5A\uD840\uDC8A\u5202\u4491"],["c8a1","\u9FB0\u5188\u9FB1\uD85D\uDE07"],["c8cd","\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u309B\u309C\u2E80\u2E84\u2E86\u2E87\u2E88\u2E8A\u2E8C\u2E8D\u2E95\u2E9C\u2E9D\u2EA5\u2EA7\u2EAA\u2EAC\u2EAE\u2EB6\u2EBC\u2EBE\u2EC6\u2ECA\u2ECC\u2ECD\u2ECF\u2ED6\u2ED7\u2EDE\u2EE3"],["c8f5","\u0283\u0250\u025B\u0254\u0275\u0153\xf8\u014B\u028A\u026A"],["f9fe","\uFFED"],["fa40","\uD841\uDD47\u92DB\uD841\uDDDF\uD84F\uDFC5\u854C\u42B5\u73EF\u51B5\u3649\uD852\uDD42\uD862\uDDE4\u9344\uD846\uDDDB\u82EE\uD84F\uDCC8\u783C\u6744\u62DF\uD852\uDD33\uD862\uDDAA\uD840\uDEA0\uD85A\uDFB3\uD844\uDF05\u4FAB\uD849\uDCED\u5008\uD85B\uDD29\uD85E\uDE84\uD84D\uDE00\uD852\uDEB1\uD849\uDD13\u5029\uD840\uDF7E\u5FA4\uD840\uDF80\uD840\uDF47\u6EDB\uD841\uDC1F\u507D\u5101\u347A\u510E\u986C\u3743\u8416\uD852\uDDA4\uD841\uDC87\u5160\uD84C\uDFB4\u516A\uD842\uDFFF\uD848\uDCFC\uD840\uDEE5\uD849\uDD30\uD841\uDD8E\uD84C\uDE33\uD846\uDD83\u5B82\u877D\uD841\uDDB3\uD84F\uDC99\u51B2\u51B8"],["faa1","\u9D34\u51C9\u51CF\u51D1\u3CDC\u51D3\uD852\uDEA6\u51B3\u51E2\u5342\u51ED\u83CD\u693E\uD84D\uDF2D\u5F7B\u520B\u5226\u523C\u52B5\u5257\u5294\u52B9\u52C5\u7C15\u8542\u52E0\u860D\uD85A\uDF13\u5305\uD862\uDEDE\u5549\u6ED9\uD84F\uDF80\uD842\uDD54\uD84F\uDFEC\u5333\u5344\uD842\uDFE2\u6CCB\uD845\uDF26\u681B\u73D5\u604A\u3EAA\u38CC\uD845\uDEE8\u71DD\u44A2\u536D\u5374\uD861\uDEAB\u537E\u537F\uD845\uDD96\uD845\uDE13\u77E6\u5393\uD862\uDE9B\u53A0\u53AB\u53AE\u73A7\uD855\uDF72\u3F59\u739C\u53C1\u53C5\u6C49\u4E49\u57FE\u53D9\u3AAB\uD842\uDF8F\u53E0\uD84F\uDFEB\uD84B\uDDA3\u53F6\uD843\uDC77\u5413\u7079\u552B\u6657\u6D5B\u546D\uD85A\uDF53\uD843\uDD74\u555D\u548F\u54A4\u47A6\uD845\uDF0D\uD843\uDEDD\u3DB4\uD843\uDD4D"],["fb40","\uD862\uDDBC\uD849\uDE98\u5547\u4CED\u542F\u7417\u5586\u55A9\u5605\uD846\uDCD7\uD850\uDC3A\u4552\uD851\uDC35\u66B3\uD844\uDCB4\u5637\u66CD\uD84C\uDE8A\u66A4\u66AD\u564D\u564F\u78F1\u56F1\u9787\u53FE\u5700\u56EF\u56ED\uD862\uDF66\u3623\uD844\uDE4F\u5746\uD850\uDDA5\u6C6E\u708B\u5742\u36B1\uD85B\uDC7E\u57E6\uD845\uDC16\u5803\uD845\uDC54\uD850\uDF63\u5826\uD852\uDFF5\u585C\u58AA\u3561\u58E0\u58DC\uD844\uDE3C\u58FB\u5BFF\u5743\uD868\uDD50\uD850\uDE78\u93D3\u35A1\u591F\u68A6\u36C3\u6E59"],["fba1","\uD845\uDE3E\u5A24\u5553\uD845\uDE92\u8505\u59C9\uD843\uDD4E\uD85B\uDC81\uD85B\uDD2A\uD845\uDFDC\u59D9\uD845\uDFFB\uD845\uDFB2\uD85B\uDDA6\u6D71\uD846\uDC28\uD845\uDED5\u59F9\uD85B\uDE45\u5AAB\u5A63\u36E6\uD852\uDDA9\u5A77\u3708\u5A96\u7465\u5AD3\uD85B\uDFA1\uD849\uDD54\u3D85\uD846\uDD11\u3732\uD845\uDEB8\u5E83\u52D0\u5B76\u6588\u5B7C\uD85E\uDE0E\u4004\u485D\uD840\uDE04\u5BD5\u6160\uD846\uDE34\uD856\uDDCC\uD841\uDDA5\u5BF3\u5B9D\u4D10\u5C05\uD846\uDF44\u5C13\u73CE\u5C14\uD847\uDCA5\uD85A\uDF28\u5C49\u48DD\u5C85\u5CE9\u5CEF\u5D8B\uD847\uDDF9\uD847\uDE37\u5D10\u5D18\u5D46\uD847\uDEA4\u5CBA\u5DD7\u82FC\u382D\uD852\uDD01\uD848\uDC49\uD848\uDD73\u8287\u3836\u3BC2\u5E2E\u6A8A\u5E75\u5E7A\uD851\uDCBC\uD843\uDCD3\u53A6\u4EB7\u5ED0\u53A8\uD845\uDF71\u5E09\u5EF4\uD861\uDC82"],["fc40","\u5EF9\u5EFB\u38A0\u5EFC\u683E\u941B\u5F0D\uD840\uDDC1\uD87E\uDC94\u3ADE\u48AE\uD844\uDF3A\u5F3A\uD85A\uDC88\uD848\uDFD0\u5F58\uD849\uDC71\u5F63\u97BD\uD85B\uDE6E\u5F72\u9340\uD862\uDE36\u5FA7\u5DB6\u3D5F\uD854\uDE50\uD847\uDF6A\uD85C\uDCF8\uD849\uDE68\u91D6\uD840\uDE9E\uD862\uDE29\u6031\u6685\uD846\uDC77\u3963\u3DC7\u3639\u5790\uD849\uDFB4\u7971\u3E40\u609E\u60A4\u60B3\uD852\uDD82\uD852\uDD8F\uD85E\uDE53\u74A4\u50E1\u5AA0\u6164\u8424\u6142\uD87E\uDCA6\uD85B\uDED2\u6181\u51F4\uD841\uDE56\u6187\u5BAA\uD84F\uDFB7"],["fca1","\uD84A\uDC5F\u61D3\uD862\uDF9D\uD866\uDD5D\u61D0\u3932\uD84A\uDD80\uD84A\uDCC1\u6023\u615C\u651E\u638B\uD840\uDD18\u62C5\uD845\uDF70\u62D5\uD84B\uDE0D\u636C\uD852\uDDDF\u3A17\u6438\u63F8\uD844\uDF8E\uD845\uDFFC\u6490\u6F8A\uD84B\uDE36\u9814\uD850\uDC8C\uD855\uDF1D\u64E1\u64E5\u947B\u3A66\u643A\u3A57\u654D\u6F16\uD852\uDE28\uD852\uDE23\u6585\u656D\u655F\uD84C\uDC7E\u65B5\uD852\uDD40\u4B37\u65D1\u40D8\uD846\uDC29\u65E0\u65E3\u5FDF\uD84D\uDC00\u6618\uD84C\uDDF7\uD84C\uDDF8\u6644\uD84C\uDDA4\uD84C\uDDA5\u664B\uD843\uDE75\u6667\uD854\uDDE6\u6673\u6674\uD847\uDE3D\uD84C\uDE31\uD861\uDDF4\uD84C\uDDC8\uD854\uDF13\u77C5\uD84A\uDCF7\u99A4\u6702\uD850\uDF9C\uD852\uDE21\u3B2B\u69FA\uD84D\uDFC2\u675E\u6767\u6762\uD850\uDDCD\uD864\uDCED\u67D7\u44E9\u6822\u6E50\u923C\u6801\uD84C\uDFE6\uD85B\uDDA0\u685D"],["fd40","\uD84D\uDC6F\u69E1\u6A0B\uD862\uDEDF\u6973\u68C3\uD84D\uDDCD\u6901\u6900\u3D32\u3A01\uD84D\uDE3C\u3B80\u67AC\u6961\uD862\uDE4A\u42FC\u6936\u6998\u3BA1\uD840\uDFC9\u8363\u5090\u69F9\uD84D\uDE59\uD848\uDD2A\u6A45\uD84D\uDF03\u6A9D\u3BF3\u67B1\u6AC8\uD864\uDD9C\u3C0D\u6B1D\uD842\uDD23\u60DE\u6B35\u6B74\uD849\uDFCD\u6EB5\uD84E\uDEDB\uD840\uDFB5\uD846\uDD58\u3740\u5421\uD84E\uDF5A\u6BE1\uD84F\uDEFC\u6BDC\u6C37\uD849\uDC8B\uD852\uDCF1\uD85A\uDF51\u6C5A\u8226\u6C79\uD84F\uDDBC\u44C5\uD84F\uDDBD\uD850\uDDA4\uD852\uDD0C\uD852\uDD00"],["fda1","\uD84F\uDCC9\u36E5\u3CEB\uD843\uDD32\u9B83\uD84C\uDDF9\uD849\uDC91\u7F8F\u6837\uD85B\uDD25\uD85B\uDDA1\uD85B\uDDEB\u6D96\u6D5C\u6E7C\u6F04\uD852\uDD7F\uD850\uDC85\uD85B\uDE72\u8533\uD85B\uDF74\u51C7\u6C9C\u6E1D\u842E\uD862\uDF21\u6E2F\uD84F\uDE2F\u7453\uD84F\uDF82\u79CC\u6E4F\u5A91\uD84C\uDC4B\u6FF8\u370D\u6F9D\uD84F\uDE30\u6EFA\uD845\uDC97\uD850\uDC3D\u4555\u93F0\u6F44\u6F5C\u3D4E\u6F74\uD864\uDD70\u3D3B\u6F9F\uD850\uDD44\u6FD3\uD850\uDC91\uD850\uDD55\uD850\uDC39\uD84F\uDFF0\uD84F\uDFB4\uD850\uDD3F\u51DF\uD850\uDD56\uD850\uDD57\uD850\uDD40\uD858\uDDDD\u704B\u707E\u70A7\u7081\u70CC\u70D5\u70D6\u70DF\u4104\u3DE8\u71B4\u7196\uD850\uDE77\u712B\u7145\u5A88\u714A\u716E\u5C9C\uD850\uDF65\u714F\u9362\uD850\uDEC1\u712C\uD851\uDC5A\uD852\uDE27\uD852\uDE22\u71BA\uD862\uDFE8\u70BD\u720E"],["fe40","\u9442\u7215\u5911\u9443\u7224\u9341\uD855\uDE05\u722E\u7240\uD852\uDD74\u68BD\u7255\u7257\u3E55\uD84C\uDC44\u680D\u6F3D\u7282\u732A\u732B\uD852\uDC23\uD862\uDC2B\u48ED\uD862\uDC04\u7328\u732E\u73CF\u73AA\uD843\uDC3A\uD85A\uDE2E\u73C9\u7449\uD850\uDDE2\uD845\uDEE7\uD852\uDE24\u6623\u36C5\uD852\uDDB7\uD852\uDD8D\uD852\uDDFB\u73F7\u7415\u6903\uD852\uDE26\u7439\uD841\uDDC3\u3ED7\u745C\uD84A\uDCAD\u7460\uD863\uDEB2\u7447\u73E4\u7476\u83B9\u746C\u3730\u7474\u93F1\u6A2C\u7482\u4953\uD852\uDE8C"],["fea1","\uD850\uDD5F\uD852\uDE79\uD862\uDF8F\u5B46\uD863\uDC03\uD846\uDC9E\u74C8\uD846\uDD88\u750E\u74E9\u751E\uD863\uDED9\uD846\uDE4B\u5BD7\uD863\uDEAC\u9385\u754D\u754A\u7567\u756E\uD853\uDF82\u3F04\uD853\uDD13\u758E\u745D\u759E\u75B4\u7602\u762C\u7651\u764F\u766F\u7676\uD858\uDFF5\u7690\u81EF\u37F8\uD85A\uDD11\uD85A\uDD0E\u76A1\u76A5\u76B7\u76CC\uD85B\uDF9F\u8462\uD854\uDC9D\uD854\uDD7D\uD847\uDE1C\u771E\u7726\u7740\u64AF\uD854\uDE20\u7758\uD84C\uDEAC\u77AF\uD862\uDD64\uD862\uDD68\uD845\uDEC1\u77F4\u7809\uD844\uDF76\uD852\uDE12\u68CA\u78AF\u78C7\u78D3\u96A5\u792E\uD855\uDDE0\u78D7\u7934\u78B1\uD85D\uDE0C\u8FB8\u8884\uD862\uDF2B\uD858\uDC83\uD849\uDE1C\u7986\u8900\u6902\u7980\uD856\uDC57\u799D\uD85E\uDF39\u793C\u79A9\u6E2A\uD85C\uDD26\u3EA8\u79C6\uD864\uDD0D\u79D4"]]');

},{}],"3B7mW":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("f2dd5c5fa02b051c").Buffer;
// NOTE: Due to 'stream' module being pretty large (~100Kb, significant in browser environments),
// we opt to dependency-inject it instead of creating a hard dependency.
module.exports = function(streamModule) {
    var Transform = streamModule.Transform;
    // == Encoder stream =======================================================
    function IconvLiteEncoderStream(conv, options) {
        this.conv = conv;
        options = options || {};
        options.decodeStrings = false // We accept only strings, so we don't need to decode them.
        ;
        Transform.call(this, options);
    }
    IconvLiteEncoderStream.prototype = Object.create(Transform.prototype, {
        constructor: {
            value: IconvLiteEncoderStream
        }
    });
    IconvLiteEncoderStream.prototype._transform = function(chunk, encoding, done) {
        if (typeof chunk !== "string") return done(new Error("Iconv encoding stream needs strings as its input."));
        try {
            var res = this.conv.write(chunk);
            if (res && res.length) this.push(res);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteEncoderStream.prototype._flush = function(done) {
        try {
            var res = this.conv.end();
            if (res && res.length) this.push(res);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteEncoderStream.prototype.collect = function(cb) {
        var chunks = [];
        this.on("error", cb);
        this.on("data", function(chunk) {
            chunks.push(chunk);
        });
        this.on("end", function() {
            cb(null, Buffer.concat(chunks));
        });
        return this;
    };
    // == Decoder stream =======================================================
    function IconvLiteDecoderStream(conv, options) {
        this.conv = conv;
        options = options || {};
        options.encoding = this.encoding = "utf8" // We output strings.
        ;
        Transform.call(this, options);
    }
    IconvLiteDecoderStream.prototype = Object.create(Transform.prototype, {
        constructor: {
            value: IconvLiteDecoderStream
        }
    });
    IconvLiteDecoderStream.prototype._transform = function(chunk, encoding, done) {
        if (!Buffer.isBuffer(chunk) && !(chunk instanceof Uint8Array)) return done(new Error("Iconv decoding stream needs buffers as its input."));
        try {
            var res = this.conv.write(chunk);
            if (res && res.length) this.push(res, this.encoding);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteDecoderStream.prototype._flush = function(done) {
        try {
            var res = this.conv.end();
            if (res && res.length) this.push(res, this.encoding);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteDecoderStream.prototype.collect = function(cb) {
        var res = "";
        this.on("error", cb);
        this.on("data", function(chunk) {
            res += chunk;
        });
        this.on("end", function() {
            cb(null, res);
        });
        return this;
    };
    return {
        IconvLiteEncoderStream: IconvLiteEncoderStream,
        IconvLiteDecoderStream: IconvLiteDecoderStream
    };
};

},{"f2dd5c5fa02b051c":"254Bi"}],"kFRSF":[function(require,module,exports,__globalThis) {
// src/types.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ECI", ()=>ECI);
parcelHelpers.export(exports, "ErrorCorrectionLevel", ()=>ErrorCorrectionLevel);
parcelHelpers.export(exports, "MAX_VERSION", ()=>MAX_VERSION);
parcelHelpers.export(exports, "MIN_VERSION", ()=>MIN_VERSION);
parcelHelpers.export(exports, "Mode", ()=>Mode);
parcelHelpers.export(exports, "QRCode", ()=>QRCode);
parcelHelpers.export(exports, "toDataURL", ()=>toDataURL);
parcelHelpers.export(exports, "toSVG", ()=>toSVG);
parcelHelpers.export(exports, "toText", ()=>toText);
var ErrorCorrectionLevel;
((ErrorCorrectionLevel)=>{
    ErrorCorrectionLevel["LOW"] = "L";
    ErrorCorrectionLevel["MEDIUM"] = "M";
    ErrorCorrectionLevel["QUARTILE"] = "Q";
    ErrorCorrectionLevel["HIGH"] = "H";
})(ErrorCorrectionLevel ||= {});
var Mode;
((Mode)=>{
    Mode["NUMERIC"] = "numeric";
    Mode["ALPHANUMERIC"] = "alphanumeric";
    Mode["BYTE"] = "byte";
})(Mode ||= {});
var ECI;
((ECI)=>{
    ECI[ECI["ISO_8859_1"] = 3] = "ISO_8859_1";
    ECI[ECI["ISO_8859_2"] = 4] = "ISO_8859_2";
    ECI[ECI["UTF_8"] = 26] = "UTF_8";
})(ECI ||= {});
// src/constants.ts
var MIN_VERSION = 1;
var MAX_VERSION = 40;
var ECC_ORDER = [
    "L" /* LOW */ ,
    "M" /* MEDIUM */ ,
    "Q" /* QUARTILE */ ,
    "H" /* HIGH */ 
];
var ECC_FORMAT_BITS = {
    ["L" /* LOW */ ]: 1,
    ["M" /* MEDIUM */ ]: 0,
    ["Q" /* QUARTILE */ ]: 3,
    ["H" /* HIGH */ ]: 2
};
function eccIndex(level) {
    return ECC_ORDER.indexOf(level);
}
var ECC_CODEWORDS_PER_BLOCK = [
    [
        0,
        7,
        10,
        15,
        20,
        26,
        18,
        20,
        24,
        30,
        18,
        20,
        24,
        26,
        30,
        22,
        24,
        28,
        30,
        28,
        28,
        28,
        28,
        30,
        30,
        26,
        28,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30
    ],
    [
        0,
        10,
        16,
        26,
        18,
        24,
        16,
        18,
        22,
        22,
        26,
        30,
        22,
        22,
        24,
        24,
        28,
        28,
        26,
        26,
        26,
        26,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28
    ],
    [
        0,
        13,
        22,
        18,
        26,
        18,
        24,
        18,
        22,
        20,
        24,
        28,
        26,
        24,
        20,
        30,
        24,
        28,
        28,
        26,
        30,
        28,
        30,
        30,
        30,
        30,
        28,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30
    ],
    [
        0,
        17,
        28,
        22,
        16,
        22,
        28,
        26,
        26,
        24,
        28,
        24,
        28,
        22,
        24,
        24,
        30,
        28,
        28,
        26,
        28,
        30,
        24,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30
    ]
];
var ECC_BLOCKS = [
    [
        0,
        1,
        1,
        1,
        1,
        1,
        2,
        2,
        2,
        2,
        4,
        4,
        4,
        4,
        4,
        6,
        6,
        6,
        6,
        7,
        8,
        8,
        9,
        9,
        10,
        12,
        12,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        19,
        20,
        21,
        22,
        24,
        25
    ],
    [
        0,
        1,
        1,
        1,
        2,
        2,
        4,
        4,
        4,
        5,
        5,
        5,
        8,
        9,
        9,
        10,
        10,
        11,
        13,
        14,
        16,
        17,
        17,
        18,
        20,
        21,
        23,
        25,
        26,
        28,
        29,
        31,
        33,
        35,
        37,
        38,
        40,
        43,
        45,
        47,
        49
    ],
    [
        0,
        1,
        1,
        2,
        2,
        4,
        4,
        6,
        6,
        8,
        8,
        8,
        10,
        12,
        16,
        12,
        17,
        16,
        18,
        21,
        20,
        23,
        23,
        25,
        27,
        29,
        34,
        34,
        35,
        38,
        40,
        43,
        45,
        48,
        51,
        53,
        56,
        59,
        62,
        65,
        68
    ],
    [
        0,
        1,
        1,
        2,
        4,
        4,
        4,
        5,
        6,
        8,
        8,
        11,
        11,
        16,
        16,
        18,
        16,
        19,
        21,
        25,
        25,
        25,
        34,
        30,
        32,
        35,
        37,
        40,
        42,
        45,
        48,
        51,
        54,
        57,
        60,
        63,
        66,
        70,
        74,
        77,
        81
    ]
];
var CHAR_COUNT_BITS = {
    numeric: [
        10,
        12,
        14
    ],
    alphanumeric: [
        9,
        11,
        13
    ],
    byte: [
        8,
        16,
        16
    ]
};
var MODE_BITS = {
    numeric: 1,
    alphanumeric: 2,
    byte: 4
};
var ECI_MODE_BITS = 7;
var MAX_ECI = 999999;
var ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
function rawDataModules(version) {
    let result = (16 * version + 128) * version + 64;
    if (version >= 2) {
        const alignCount = Math.floor(version / 7) + 2;
        result -= (25 * alignCount - 10) * alignCount - 55;
        if (version >= 7) result -= 36;
    }
    return result;
}
function dataCodewords(version, level) {
    const ecc = eccIndex(level);
    return Math.floor(rawDataModules(version) / 8) - (ECC_CODEWORDS_PER_BLOCK[ecc]?.[version] ?? 0) * (ECC_BLOCKS[ecc]?.[version] ?? 0);
}
function alignmentPositions(version) {
    if (version === 1) return [];
    const count = Math.floor(version / 7) + 2;
    const size = version * 4 + 17;
    const step = version === 32 ? 26 : Math.ceil((size - 13) / (2 * count - 2)) * 2;
    const positions = [
        6
    ];
    for(let pos = size - 7; positions.length < count; pos -= step)positions.splice(1, 0, pos);
    return positions;
}
function versionGroup(version) {
    if (version <= 9) return 0;
    if (version <= 26) return 1;
    return 2;
}
// src/reed-solomon.ts
var PRIMITIVE = 285;
var EXP = new Uint8Array(256);
var LOG = new Uint8Array(256);
{
    let value = 1;
    for(let i = 0; i < 255; i++){
        EXP[i] = value;
        LOG[value] = i;
        value <<= 1;
        if (value & 256) value ^= PRIMITIVE;
    }
}function multiply(a, b) {
    if (a === 0 || b === 0) return 0;
    return EXP[(LOG[a] + LOG[b]) % 255];
}
function generatorPolynomial(degree) {
    const result = new Uint8Array(degree);
    result[degree - 1] = 1;
    let root = 1;
    for(let i = 0; i < degree; i++){
        for(let j = 0; j < degree; j++){
            result[j] = multiply(result[j], root);
            if (j + 1 < degree) result[j] = result[j] ^ result[j + 1];
        }
        root = multiply(root, 2);
    }
    return result;
}
var generators = new Map;
function generator(degree) {
    let polynomial = generators.get(degree);
    if (polynomial === undefined) {
        polynomial = generatorPolynomial(degree);
        generators.set(degree, polynomial);
    }
    return polynomial;
}
function encode(data, eccLength) {
    const divisor = generator(eccLength);
    const result = new Uint8Array(eccLength);
    for (const byte of data){
        const factor = byte ^ result[0];
        result.copyWithin(0, 1);
        result[eccLength - 1] = 0;
        for(let i = 0; i < eccLength; i++)result[i] = result[i] ^ multiply(divisor[i], factor);
    }
    return result;
}
// src/segment.ts
class BitBuffer {
    bits = [];
    get length() {
        return this.bits.length;
    }
    push(value, count) {
        for(let i = count - 1; i >= 0; i--)this.bits.push(value >>> i & 1);
    }
    append(other) {
        this.bits.push(...other.bits);
    }
    toBytes() {
        const bytes = new Uint8Array(Math.ceil(this.bits.length / 8));
        this.bits.forEach((bit, index)=>{
            if (bit === 1) bytes[index >>> 3] = bytes[index >>> 3] | 128 >>> index % 8;
        });
        return bytes;
    }
}
function numericSegment(digits) {
    const bits = new BitBuffer;
    for(let i = 0; i < digits.length; i += 3){
        const chunk = digits.slice(i, i + 3);
        bits.push(Number.parseInt(chunk, 10), chunk.length * 3 + 1);
    }
    return {
        mode: "numeric" /* NUMERIC */ ,
        length: digits.length,
        bits
    };
}
function alphanumericSegment(text) {
    const bits = new BitBuffer;
    for(let i = 0; i + 1 < text.length; i += 2){
        const high = ALPHANUMERIC_CHARSET.indexOf(text[i]);
        const low = ALPHANUMERIC_CHARSET.indexOf(text[i + 1]);
        bits.push(high * 45 + low, 11);
    }
    if (text.length % 2 === 1) bits.push(ALPHANUMERIC_CHARSET.indexOf(text[text.length - 1]), 6);
    return {
        mode: "alphanumeric" /* ALPHANUMERIC */ ,
        length: text.length,
        bits
    };
}
function byteSegment(data) {
    const bits = new BitBuffer;
    for (const byte of data)bits.push(byte, 8);
    return {
        mode: "byte" /* BYTE */ ,
        length: data.length,
        bits
    };
}
function segmentBitLength(segment, version) {
    const countBits = CHAR_COUNT_BITS[segment.mode][versionGroup(version)];
    return 4 + countBits + segment.bits.length;
}
function totalBitLength(segments, version) {
    return segments.reduce((sum, segment)=>sum + segmentBitLength(segment, version), 0);
}
function writeSegment(segment, version, out) {
    out.push(MODE_BITS[segment.mode], 4);
    out.push(segment.length, CHAR_COUNT_BITS[segment.mode][versionGroup(version)]);
    out.append(segment.bits);
}
function checkEci(designator) {
    if (!Number.isInteger(designator) || designator < 0 || designator > MAX_ECI) throw new RangeError(`eci must be an integer between 0 and ${MAX_ECI}.`);
}
function eciBitLength(designator) {
    if (designator < 128) return 12;
    if (designator < 16384) return 20;
    return 28;
}
function writeEci(designator, out) {
    out.push(ECI_MODE_BITS, 4);
    if (designator < 128) out.push(designator, 8);
    else if (designator < 16384) {
        out.push(2, 2);
        out.push(designator, 14);
    } else {
        out.push(6, 3);
        out.push(designator, 21);
    }
}
var MODE_ORDER = [
    "byte" /* BYTE */ ,
    "alphanumeric" /* ALPHANUMERIC */ ,
    "numeric" /* NUMERIC */ 
];
var SIXTHS = 6;
function utf8Length(codePoint) {
    if (codePoint < 128) return 1;
    if (codePoint < 2048) return 2;
    if (codePoint < 65536) return 3;
    return 4;
}
function isNumericCodePoint(codePoint) {
    return codePoint >= 48 && codePoint <= 57;
}
function isAlphanumericCodePoint(codePoint) {
    return ALPHANUMERIC_CHARSET.indexOf(String.fromCodePoint(codePoint)) !== -1;
}
function chooseModes(codePoints, version) {
    const headCosts = MODE_ORDER.map((mode)=>(4 + CHAR_COUNT_BITS[mode][versionGroup(version)]) * SIXTHS);
    const charModes = [];
    let previous = [
        ...headCosts
    ];
    for (const codePoint of codePoints){
        const modes = [
            null,
            null,
            null
        ];
        const costs = [
            Number.MAX_SAFE_INTEGER,
            Number.MAX_SAFE_INTEGER,
            Number.MAX_SAFE_INTEGER
        ];
        costs[0] = previous[0] + utf8Length(codePoint) * 8 * SIXTHS;
        modes[0] = "byte" /* BYTE */ ;
        if (isAlphanumericCodePoint(codePoint)) {
            costs[1] = previous[1] + 33;
            modes[1] = "alphanumeric" /* ALPHANUMERIC */ ;
        }
        if (isNumericCodePoint(codePoint)) {
            costs[2] = previous[2] + 20;
            modes[2] = "numeric" /* NUMERIC */ ;
        }
        for(let j = 0; j < MODE_ORDER.length; j++)for(let k = 0; k < MODE_ORDER.length; k++){
            const switched = Math.ceil(costs[k] / SIXTHS) * SIXTHS + headCosts[j];
            if (modes[k] !== null && (modes[j] === null || switched < costs[j])) {
                costs[j] = switched;
                modes[j] = MODE_ORDER[k];
            }
        }
        charModes.push(modes);
        previous = costs;
    }
    let end = 0;
    for(let i = 1; i < MODE_ORDER.length; i++)if (previous[i] < previous[end]) end = i;
    let current = MODE_ORDER[end];
    const result = [];
    for(let i = codePoints.length - 1; i >= 0; i--){
        const index = MODE_ORDER.indexOf(current);
        current = charModes[i][index];
        result.push(current);
    }
    return result.reverse();
}
function makeSegments(text, version) {
    if (text.length === 0) return [];
    const codePoints = [
        ...text
    ].map((character)=>character.codePointAt(0));
    const modes = chooseModes(codePoints, version);
    const segments = [];
    let start = 0;
    for(let i = 1; i <= codePoints.length; i++){
        if (i < codePoints.length && modes[i] === modes[start]) continue;
        const run = codePoints.slice(start, i).map((codePoint)=>String.fromCodePoint(codePoint)).join("");
        switch(modes[start]){
            case "numeric" /* NUMERIC */ :
                segments.push(numericSegment(run));
                break;
            case "alphanumeric" /* ALPHANUMERIC */ :
                segments.push(alphanumericSegment(run));
                break;
            default:
                segments.push(byteSegment(new TextEncoder().encode(run)));
                break;
        }
        start = i;
    }
    return segments;
}
// src/qrcode.ts
var PAD_CODEWORDS = [
    236,
    17
];
var PENALTY_N1 = 3;
var PENALTY_N2 = 3;
var PENALTY_N3 = 40;
var PENALTY_N4 = 10;
class QRCode {
    version;
    size;
    errorCorrectionLevel;
    mask;
    modules;
    reserved;
    constructor(version, level, codewords, mask){
        this.version = version;
        this.size = version * 4 + 17;
        this.errorCorrectionLevel = level;
        this.modules = Array.from({
            length: this.size
        }, ()=>new Array(this.size).fill(false));
        this.reserved = Array.from({
            length: this.size
        }, ()=>new Array(this.size).fill(false));
        this.drawFunctionPatterns();
        this.drawCodewords(codewords);
        this.mask = this.applyBestMask(mask);
        this.drawFormatBits(this.mask);
    }
    static encode(text, options = {}) {
        return QRCode.fromSegments((version)=>makeSegments(text, version), options);
    }
    static encodeBinary(data, options = {}) {
        const segments = [
            byteSegment(data)
        ];
        return QRCode.fromSegments(()=>segments, options);
    }
    static fromSegments(segmentsFor, options) {
        const requested = options.errorCorrectionLevel ?? "M" /* MEDIUM */ ;
        const minVersion = clampVersion(options.minVersion ?? MIN_VERSION, "minVersion");
        const maxVersion = clampVersion(options.maxVersion ?? MAX_VERSION, "maxVersion");
        const mask = options.mask ?? -1;
        const boost = options.boostEcc ?? true;
        const eci = options.eci;
        if (minVersion > maxVersion) throw new RangeError("minVersion cannot be greater than maxVersion.");
        if (mask < -1 || mask > 7) throw new RangeError("mask must be between 0 and 7, or -1 to choose automatically.");
        if (eci !== undefined) checkEci(eci);
        const headerBits = eci === undefined ? 0 : eciBitLength(eci);
        let version = minVersion;
        let segments = [];
        let usedBits = 0;
        for(;; version++){
            if (version > maxVersion) throw new RangeError(`Data is too long: it does not fit in a version ${maxVersion} symbol at error correction level ${requested}.`);
            segments = segmentsFor(version);
            usedBits = headerBits + totalBitLength(segments, version);
            if (usedBits <= dataCodewords(version, requested) * 8) break;
        }
        let level = requested;
        if (boost) {
            for (const candidate of ECC_ORDER)if (eccIndex(candidate) > eccIndex(level) && usedBits <= dataCodewords(version, candidate) * 8) level = candidate;
        }
        return new QRCode(version, level, buildCodewords(segments, version, level, eci), mask);
    }
    getModule(x, y) {
        if (x < 0 || y < 0 || x >= this.size || y >= this.size) return false;
        return this.modules[y]?.[x] ?? false;
    }
    toArray() {
        return this.modules.map((row)=>[
                ...row
            ]);
    }
    set(x, y, dark, isFunction) {
        const row = this.modules[y];
        const reservedRow = this.reserved[y];
        if (row === undefined || reservedRow === undefined) return;
        row[x] = dark;
        if (isFunction) reservedRow[x] = true;
    }
    drawFunctionPatterns() {
        for(let i = 0; i < this.size; i++){
            this.set(6, i, i % 2 === 0, true);
            this.set(i, 6, i % 2 === 0, true);
        }
        this.drawFinder(3, 3);
        this.drawFinder(this.size - 4, 3);
        this.drawFinder(3, this.size - 4);
        const positions = alignmentPositions(this.version);
        const last = positions.length - 1;
        for(let i = 0; i <= last; i++)for(let j = 0; j <= last; j++){
            const corner = i === 0 && j === 0 || i === 0 && j === last || i === last && j === 0;
            if (!corner) this.drawAlignment(positions[i], positions[j]);
        }
        this.drawFormatBits(0);
        this.drawVersionBits();
    }
    drawFinder(cx, cy) {
        for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
            const distance = Math.max(Math.abs(dx), Math.abs(dy));
            const x = cx + dx;
            const y = cy + dy;
            if (x >= 0 && x < this.size && y >= 0 && y < this.size) this.set(x, y, distance !== 2 && distance !== 4, true);
        }
    }
    drawAlignment(cx, cy) {
        for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.set(cx + dx, cy + dy, Math.max(Math.abs(dx), Math.abs(dy)) !== 1, true);
    }
    drawFormatBits(mask) {
        const data = ECC_FORMAT_BITS[this.errorCorrectionLevel] << 3 | mask;
        let remainder = data;
        for(let i = 0; i < 10; i++)remainder = remainder << 1 ^ (remainder >>> 9) * 1335;
        const bits = (data << 10 | remainder) ^ 21522;
        const bit = (i)=>(bits >>> i & 1) !== 0;
        for(let i = 0; i <= 5; i++)this.set(8, i, bit(i), true);
        this.set(8, 7, bit(6), true);
        this.set(8, 8, bit(7), true);
        this.set(7, 8, bit(8), true);
        for(let i = 9; i < 15; i++)this.set(14 - i, 8, bit(i), true);
        for(let i = 0; i < 8; i++)this.set(this.size - 1 - i, 8, bit(i), true);
        for(let i = 8; i < 15; i++)this.set(8, this.size - 15 + i, bit(i), true);
        this.set(8, this.size - 8, true, true);
    }
    drawVersionBits() {
        if (this.version < 7) return;
        let remainder = this.version;
        for(let i = 0; i < 12; i++)remainder = remainder << 1 ^ (remainder >>> 11) * 7973;
        const bits = this.version << 12 | remainder;
        for(let i = 0; i < 18; i++){
            const dark = (bits >>> i & 1) !== 0;
            const a = this.size - 11 + i % 3;
            const b = Math.floor(i / 3);
            this.set(a, b, dark, true);
            this.set(b, a, dark, true);
        }
    }
    drawCodewords(codewords) {
        let index = 0;
        for(let right = this.size - 1; right >= 1; right -= 2){
            if (right === 6) right = 5;
            for(let step = 0; step < this.size; step++)for(let column = 0; column < 2; column++){
                const x = right - column;
                const upward = (right + 1 & 2) === 0;
                const y = upward ? this.size - 1 - step : step;
                if (this.reserved[y]?.[x] === true) continue;
                const dark = index < codewords.length * 8 && (codewords[index >>> 3] >>> 7 - index % 8 & 1) !== 0;
                this.set(x, y, dark, false);
                index++;
            }
        }
    }
    static maskAt(pattern, x, y) {
        switch(pattern){
            case 0:
                return (x + y) % 2 === 0;
            case 1:
                return y % 2 === 0;
            case 2:
                return x % 3 === 0;
            case 3:
                return (x + y) % 3 === 0;
            case 4:
                return (Math.floor(x / 3) + Math.floor(y / 2)) % 2 === 0;
            case 5:
                return x * y % 2 + x * y % 3 === 0;
            case 6:
                return (x * y % 2 + x * y % 3) % 2 === 0;
            case 7:
                return ((x + y) % 2 + x * y % 3) % 2 === 0;
            default:
                throw new RangeError(`Invalid mask pattern: ${pattern}`);
        }
    }
    applyMask(pattern) {
        for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
            if (this.reserved[y]?.[x] === true) continue;
            const row = this.modules[y];
            if (row !== undefined) row[x] = row[x] !== QRCode.maskAt(pattern, x, y);
        }
    }
    applyBestMask(requested) {
        if (requested !== -1) {
            this.applyMask(requested);
            return requested;
        }
        let best = 0;
        let bestScore = Number.POSITIVE_INFINITY;
        for(let pattern = 0; pattern < 8; pattern++){
            this.applyMask(pattern);
            this.drawFormatBits(pattern);
            const score = this.penaltyScore();
            if (score < bestScore) {
                bestScore = score;
                best = pattern;
            }
            this.applyMask(pattern);
        }
        this.applyMask(best);
        return best;
    }
    penaltyScore() {
        let score = 0;
        for(let i = 0; i < this.size; i++){
            score += this.lineScore((j)=>this.getModule(j, i));
            score += this.lineScore((j)=>this.getModule(i, j));
        }
        for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
            const color = this.getModule(x, y);
            if (color === this.getModule(x + 1, y) && color === this.getModule(x, y + 1) && color === this.getModule(x + 1, y + 1)) score += PENALTY_N2;
        }
        let dark = 0;
        for(let y = 0; y < this.size; y++){
            for(let x = 0; x < this.size; x++)if (this.getModule(x, y)) dark++;
        }
        const total = this.size * this.size;
        const steps = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
        score += steps * PENALTY_N4;
        return score;
    }
    lineScore(at) {
        let score = 0;
        let runColor = false;
        let runLength = 0;
        const history = [
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        const addRun = (length)=>{
            if (history[0] === 0) length += this.size;
            history.pop();
            history.unshift(length);
        };
        const finderCount = ()=>{
            const n = history[1];
            const core = n > 0 && history[2] === n && history[3] === n * 3 && history[4] === n && history[5] === n;
            if (!core) return 0;
            return (history[0] >= n * 4 && history[6] >= n ? 1 : 0) + (history[6] >= n * 4 && history[0] >= n ? 1 : 0);
        };
        for(let i = 0; i < this.size; i++){
            const color = at(i);
            if (color === runColor) {
                runLength++;
                if (runLength === 5) score += PENALTY_N1;
                else if (runLength > 5) score += 1;
            } else {
                addRun(runLength);
                if (!runColor) score += finderCount() * PENALTY_N3;
                runColor = color;
                runLength = 1;
            }
        }
        if (runColor) {
            addRun(runLength);
            runLength = 0;
        }
        addRun(runLength + this.size);
        score += finderCount() * PENALTY_N3;
        return score;
    }
    correctableModules() {
        const ecc = eccIndex(this.errorCorrectionLevel);
        const perBlock = ECC_CODEWORDS_PER_BLOCK[ecc]?.[this.version] ?? 0;
        const blocks = ECC_BLOCKS[ecc]?.[this.version] ?? 0;
        return blocks * Math.floor(perBlock / 2) * 8;
    }
    placeLogo(logo) {
        const extent = logo.size ?? Math.floor(this.size * 0.2);
        const padding = logo.padding ?? 1;
        if (logo.content.length === 0) throw new RangeError("logo.content cannot be empty.");
        if (!(extent > 0)) throw new RangeError("logo.size must be positive.");
        if (!(padding >= 0)) throw new RangeError("logo.padding cannot be negative.");
        if (extent > this.size) throw new RangeError(`logo.size of ${extent} modules does not fit in a ${this.size} module symbol.`);
        const origin = (this.size - extent) / 2;
        const clearFrom = Math.max(0, Math.floor(origin - padding));
        const clearTo = Math.min(this.size, Math.ceil(origin + extent + padding));
        if (logo.skipChecks !== true) {
            if (clearFrom < 8) throw new RangeError(`A logo of ${extent} modules would cover a finder pattern, which a scanner needs to locate the symbol at all. ` + `Reduce logo.size or logo.padding, or encode more data so the symbol grows.`);
            const hidden = (clearTo - clearFrom) ** 2;
            const correctable = this.correctableModules();
            if (hidden > correctable) throw new RangeError(`A logo of ${extent} modules hides ${hidden} modules, more than the ${correctable} that error correction level ` + `${this.errorCorrectionLevel} can recover in a version ${this.version} symbol. Reduce logo.size, raise ` + `errorCorrectionLevel, or raise minVersion so the symbol has more room.`);
        }
        return {
            origin,
            extent,
            clearFrom,
            clearTo
        };
    }
    frameBand(frame, margin) {
        const band = frame.width ?? 4;
        if (!(band > 0)) throw new RangeError("frame.width must be positive.");
        if (margin < 1) throw new RangeError("a frame needs a quiet zone of at least 1 module to sit outside of, or a dark band merges into the edge of the symbol. Raise margin to 1 or more, or drop the frame.");
        return band;
    }
    toSVG(options = {}) {
        const margin = options.margin ?? 4;
        const scale = options.scale ?? 1;
        const dark = options.dark ?? "#000000";
        const light = options.light ?? "#ffffff";
        if (margin < 0) throw new RangeError("margin cannot be negative.");
        if (scale <= 0) throw new RangeError("scale must be positive.");
        const band = options.frame === undefined ? 0 : this.frameBand(options.frame, margin);
        const inner = (this.size + margin * 2) * scale;
        const extent = inner + band * scale * 2;
        const offset = band * scale;
        const placement = options.logo === undefined ? undefined : this.placeLogo(options.logo);
        const clearFrom = placement?.clearFrom ?? 0;
        const clearTo = placement?.clearTo ?? 0;
        const shift = margin + band;
        const parts = [];
        let penX = 0;
        let penY = 0;
        for(let y = this.size - 1; y >= 0; y--){
            const clearedRow = y >= clearFrom && y < clearTo;
            let start = -1;
            for(let x = 0; x <= this.size; x++){
                const cleared = clearedRow && x >= clearFrom && x < clearTo;
                const on = x < this.size && !cleared && this.getModule(x, y);
                if (on) {
                    if (start === -1) start = x;
                    continue;
                }
                if (start === -1) continue;
                const width = x - start;
                const column = start + shift;
                if (parts.length === 0) parts.push(`M${column} ${y + shift}.5h${width}`);
                else parts.push(`m${column - penX}-${penY - y}h${width}`);
                penX = column + width;
                penY = y;
                start = -1;
            }
        }
        const dimensions = options.size === undefined ? "" : ` width="${options.size}" height="${options.size}"`;
        const title = options.title === undefined ? "" : `<title>${escapeXml(options.title)}</title>`;
        const background = light === "transparent" ? "" : `<rect x="${offset}" y="${offset}" width="${inner}" height="${inner}" fill="${escapeXml(light)}"/>`;
        const declaration = options.xmlDeclaration === true ? `<?xml version="1.0" encoding="UTF-8"?>` : "";
        const logo = placement === undefined || options.logo === undefined ? "" : this.renderLogo(options.logo, placement, margin + band, scale, light);
        const frame = options.frame === undefined ? "" : renderFrame(options.frame, band, extent, scale);
        const transform = scale === 1 ? "" : ` transform="scale(${scale})"`;
        return `${declaration}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${extent} ${extent}"${dimensions} ` + `shape-rendering="crispEdges" role="img">${title}${frame}${background}` + `<path stroke="${escapeXml(dark)}"${transform} d="${parts.join("")}"/>${logo}</svg>`;
    }
    renderLogo(logo, placement, margin, scale, light) {
        const plateOffset = (placement.clearFrom + margin) * scale;
        const plateExtent = (placement.clearTo - placement.clearFrom) * scale;
        const offset = (placement.origin + margin) * scale;
        const extent = placement.extent * scale;
        const fill = logo.background ?? light;
        const plate = fill === "transparent" ? "" : `<rect x="${plateOffset}" y="${plateOffset}" width="${plateExtent}" height="${plateExtent}" fill="${escapeXml(fill)}"/>`;
        const box = `x="${offset}" y="${offset}" width="${extent}" height="${extent}"`;
        const art = logo.content.trimStart().startsWith("<") ? `<svg ${box} overflow="hidden" shape-rendering="auto">${logo.content}</svg>` : `<image ${box} shape-rendering="auto" preserveAspectRatio="xMidYMid meet" href="${escapeXml(logo.content)}"/>`;
        return plate + art;
    }
    toDataURL(options = {}) {
        return `data:image/svg+xml,${encodeURIComponent(this.toSVG(options))}`;
    }
    toString(options = {}) {
        const margin = options.margin ?? 2;
        const compact = options.compact ?? true;
        const inverse = options.inverse ?? false;
        const isDark = (x, y)=>{
            const outside = x < margin || y < margin || x >= this.size + margin || y >= this.size + margin;
            const dark = outside ? false : this.getModule(x - margin, y - margin);
            return inverse ? !dark : dark;
        };
        const width = this.size + margin * 2;
        const height = this.size + margin * 2;
        const lines = [];
        if (!compact) {
            for(let y = 0; y < height; y++){
                let line = "";
                for(let x = 0; x < width; x++)line += isDark(x, y) ? "\u2588\u2588" : "  ";
                lines.push(line);
            }
            return lines.join(`
`);
        }
        for(let y = 0; y < height; y += 2){
            let line = "";
            for(let x = 0; x < width; x++){
                const top = isDark(x, y);
                const bottom = y + 1 < height ? isDark(x, y + 1) : inverse;
                if (top && bottom) line += "\u2588";
                else if (top) line += "\u2580";
                else if (bottom) line += "\u2584";
                else line += " ";
            }
            lines.push(line);
        }
        return lines.join(`
`);
    }
}
function buildCodewords(segments, version, level, eci) {
    const capacityBits = dataCodewords(version, level) * 8;
    const bits = new BitBuffer;
    if (eci !== undefined) writeEci(eci, bits);
    for (const segment of segments)writeSegment(segment, version, bits);
    bits.push(0, Math.min(4, capacityBits - bits.length));
    bits.push(0, (8 - bits.length % 8) % 8);
    for(let i = 0; bits.length < capacityBits; i++)bits.push(PAD_CODEWORDS[i % 2], 8);
    const data = bits.toBytes();
    const ecc = eccIndex(level);
    const blockCount = ECC_BLOCKS[ecc]?.[version];
    const eccPerBlock = ECC_CODEWORDS_PER_BLOCK[ecc]?.[version];
    const totalCodewords = Math.floor(rawDataModules(version) / 8);
    const shortBlockLength = Math.floor(totalCodewords / blockCount) - eccPerBlock;
    const longBlockCount = totalCodewords % blockCount;
    const dataBlocks = [];
    const eccBlocks = [];
    for(let i = 0, offset = 0; i < blockCount; i++){
        const length = shortBlockLength + (i >= blockCount - longBlockCount ? 1 : 0);
        const block = data.subarray(offset, offset + length);
        offset += length;
        dataBlocks.push(block);
        eccBlocks.push(encode(block, eccPerBlock));
    }
    const result = new Uint8Array(totalCodewords);
    let index = 0;
    const longestBlock = shortBlockLength + (longBlockCount > 0 ? 1 : 0);
    for(let column = 0; column < longestBlock; column++){
        for (const block of dataBlocks)if (column < block.length) result[index++] = block[column];
    }
    for(let column = 0; column < eccPerBlock; column++)for (const block of eccBlocks)result[index++] = block[column];
    return result;
}
function clampVersion(version, name) {
    if (!Number.isInteger(version) || version < MIN_VERSION || version > MAX_VERSION) throw new RangeError(`${name} must be an integer between ${MIN_VERSION} and ${MAX_VERSION}.`);
    return version;
}
var FRAME_SHADES = {
    top: 0,
    left: 0.26,
    right: 0.5,
    bottom: 1
};
function parseHex(color) {
    const short = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/i.exec(color);
    if (short !== null) return [
        0,
        1,
        2
    ].map((i)=>Number.parseInt(short[i + 1].repeat(2), 16));
    const long = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(color);
    if (long === null) return;
    return [
        0,
        1,
        2
    ].map((i)=>Number.parseInt(long[i + 1], 16));
}
function mixHex(from, to, ratio) {
    const a = parseHex(from);
    const b = parseHex(to);
    if (a === undefined || b === undefined) throw new RangeError(`a shaded frame needs hexadecimal colors, so "${a === undefined ? from : to}" cannot be used. Pass a single color instead.`);
    const channel = (index)=>Math.round(a[index] + (b[index] - a[index]) * ratio).toString(16).padStart(2, "0");
    return `#${channel(0)}${channel(1)}${channel(2)}`;
}
function escapeXml(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function renderFrame(frame, band, extent, scale) {
    const fill = frame.fill ?? "#333333";
    const thickness = band * scale;
    const far = extent - thickness;
    let panels;
    if (typeof fill === "string") panels = `<rect width="${extent}" height="${extent}" fill="${escapeXml(fill)}"/>`;
    else {
        const sides = {
            top: `0,0 ${extent},0 ${far},${thickness} ${thickness},${thickness}`,
            right: `${extent},0 ${extent},${extent} ${far},${far} ${far},${thickness}`,
            bottom: `${extent},${extent} 0,${extent} ${thickness},${far} ${far},${far}`,
            left: `0,${extent} 0,0 ${thickness},${thickness} ${thickness},${far}`
        };
        panels = Object.keys(sides).map((side)=>`<polygon points="${sides[side]}" fill="${mixHex(fill.from, fill.to, FRAME_SHADES[side])}"/>`).join("");
    }
    const shared = frame.textColor ?? "#ffffff";
    const family = escapeXml(frame.fontFamily ?? "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif");
    const fontSize = frame.fontSize === undefined ? thickness * 0.7 : frame.fontSize * scale;
    const label = (value, y, color)=>value === undefined ? "" : `<text x="${extent / 2}" y="${y}" fill="${escapeXml(color)}" font-family="${family}" font-size="${fontSize}" ` + `text-anchor="middle" dominant-baseline="central">${escapeXml(value)}</text>`;
    const top = label(frame.title, thickness / 2, frame.titleColor ?? shared);
    const foot = label(frame.caption, extent - thickness / 2, frame.captionColor ?? shared);
    return `<g shape-rendering="auto">${panels}${top}${foot}</g>`;
}
function toSVG(text, options = {}) {
    return QRCode.encode(text, options).toSVG(options);
}
function toDataURL(text, options = {}) {
    return QRCode.encode(text, options).toDataURL(options);
}
function toText(text, options = {}) {
    return QRCode.encode(text, options).toString(options);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fn05Q":[function(require,module,exports,__globalThis) {
'use strict';
const { isValid: isValidIBAN, electronicFormat: serializeIBAN } = require("e56d6e703f7449b5");
const SERVICE_TAG = 'BCD';
const VERSION = '002';
const CHARACTER_SET = 1;
const IDENTIFICATION_CODE = 'SCT';
const assertNonEmptyString = (val, name)=>{
    if ('string' !== typeof val || !val) throw new Error(name + ' must be a non-empty string.');
};
const generateQrCode = (data)=>{
    if (!data) throw new Error('data must be an object.');
    // > AT-21 Name of the Beneficiary
    assertNonEmptyString(data.name, 'data.name');
    if (data.name.length > 70) throw new Error('data.name must have <=70 characters');
    // > AT-23 BIC of the Beneficiary Bank
    if ('bic' in data) {
        assertNonEmptyString(data.bic, 'data.bic');
        if (data.bic.length > 11) throw new Error('data.bic must have <=11 characters');
    // todo: validate more?
    }
    // > AT-20 Account number of the Beneficiary
    // > Only IBAN is allowed.
    assertNonEmptyString(data.iban, 'data.iban');
    if (!isValidIBAN(data.iban)) throw new Error('data.iban must be a valid iban code.');
    // > AT-04 Amount of the Credit Transfer in Euro
    // > Amount must be 0.01 or more and 999999999.99 or less
    if (data.amount !== null) {
        if ('number' !== typeof data.amount) throw new Error('data.amount must be a number or null.');
        if (data.amount < 0.01 || data.amount > 999999999.99) throw new Error('data.amount must be >=0.01 and <=999999999.99.');
    }
    // > AT-44 Purpose of the Credit Transfer
    if ('purposeCode' in data) {
        assertNonEmptyString(data.purposeCode, 'data.purposeCode');
        if (data.purposeCode.length > 4) throw new Error('data.purposeCode must have <=4 characters');
    // todo: validate against AT-44
    }
    // > AT-05 Remittance Information (Structured)
    // > Creditor Reference (ISO 11649 RF Creditor Reference may be used)
    if ('structuredReference' in data) {
        assertNonEmptyString(data.structuredReference, 'data.structuredReference');
        if (data.structuredReference.length > 35) throw new Error('data.structuredReference must have <=35 characters');
    // todo: validate against AT-05
    }
    // > AT-05 Remittance Information (Unstructured)
    if ('unstructuredReference' in data) {
        assertNonEmptyString(data.unstructuredReference, 'data.unstructuredReference');
        if (data.unstructuredReference.length > 140) throw new Error('data.unstructuredReference must have <=140 characters');
    }
    if ('structuredReference' in data && 'unstructuredReference' in data) throw new Error('Use either data.structuredReference or data.unstructuredReference.');
    // > Beneficiary to originator information
    if ('information' in data) {
        assertNonEmptyString(data.information, 'data.information');
        if (data.information.length > 70) throw new Error('data.information must have <=70 characters');
    }
    return [
        SERVICE_TAG,
        VERSION,
        CHARACTER_SET,
        IDENTIFICATION_CODE,
        data.bic,
        data.name,
        serializeIBAN(data.iban),
        data.amount === null ? '' : 'EUR' + data.amount.toFixed(2),
        data.purposeCode || '',
        data.structuredReference || '',
        data.unstructuredReference || '',
        data.information || ''
    ].join('\n');
};
module.exports = generateQrCode;

},{"e56d6e703f7449b5":"cd9oD"}],"cd9oD":[function(require,module,exports,__globalThis) {
(function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([
        'exports'
    ], factory);
    else if (typeof exports.nodeName !== 'string') // CommonJS
    factory(exports);
    else // Browser globals
    factory(root.IBAN = {});
})(this, function(exports1) {
    // Array.prototype.map polyfill
    // code from https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/map
    if (!Array.prototype.map) Array.prototype.map = function(fun /*, thisArg */ ) {
        "use strict";
        if (this === void 0 || this === null) throw new TypeError();
        var t = Object(this);
        var len = t.length >>> 0;
        if (typeof fun !== "function") throw new TypeError();
        var res = new Array(len);
        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
        for(var i = 0; i < len; i++)// NOTE: Absolute correctness would demand Object.defineProperty
        //       be used.  But this method is fairly new, and failure is
        //       possible only if Object.prototype or Array.prototype
        //       has a property |i| (very unlikely), so use a less-correct
        //       but more portable alternative.
        if (i in t) res[i] = fun.call(thisArg, t[i], i, t);
        return res;
    };
    var A = 'A'.charCodeAt(0), Z = 'Z'.charCodeAt(0);
    /**
     * Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
     * numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
     *
     * @param {string} iban the IBAN
     * @returns {string} the prepared IBAN
     */ function iso13616Prepare(iban) {
        iban = iban.toUpperCase();
        iban = iban.substr(4) + iban.substr(0, 4);
        return iban.split('').map(function(n) {
            var code = n.charCodeAt(0);
            if (code >= A && code <= Z) // A = 10, B = 11, ... Z = 35
            return code - A + 10;
            else return n;
        }).join('');
    }
    /**
     * Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
     *
     * @param iban
     * @returns {number}
     */ function iso7064Mod97_10(iban) {
        var remainder = iban, block;
        while(remainder.length > 2){
            block = remainder.slice(0, 9);
            remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
        }
        return parseInt(remainder, 10) % 97;
    }
    /**
     * Parse the BBAN structure used to configure each IBAN Specification and returns a matching regular expression.
     * A structure is composed of blocks of 3 characters (one letter and 2 digits). Each block represents
     * a logical group in the typical representation of the BBAN. For each group, the letter indicates which characters
     * are allowed in this group and the following 2-digits number tells the length of the group.
     *
     * @param {string} structure the structure to parse
     * @returns {RegExp}
     */ function parseStructure(structure) {
        // split in blocks of 3 chars
        var regex = structure.match(/(.{3})/g).map(function(block) {
            // parse each structure block (1-char + 2-digits)
            var format, pattern = block.slice(0, 1), repeats = parseInt(block.slice(1), 10);
            switch(pattern){
                case "A":
                    format = "0-9A-Za-z";
                    break;
                case "B":
                    format = "0-9A-Z";
                    break;
                case "C":
                    format = "A-Za-z";
                    break;
                case "F":
                    format = "0-9";
                    break;
                case "L":
                    format = "a-z";
                    break;
                case "U":
                    format = "A-Z";
                    break;
                case "W":
                    format = "0-9a-z";
                    break;
            }
            return '([' + format + ']{' + repeats + '})';
        });
        return new RegExp('^' + regex.join('') + '$');
    }
    /**
     *
     * @param iban
     * @returns {string}
     */ function electronicFormat(iban) {
        return iban.replace(NON_ALPHANUM, '').toUpperCase();
    }
    /**
     * Create a new Specification for a valid IBAN number.
     *
     * @param countryCode the code of the country
     * @param length the length of the IBAN
     * @param structure the structure of the underlying BBAN (for validation and formatting)
     * @param example an example valid IBAN
     * @constructor
     */ function Specification(countryCode, length, structure, example) {
        this.countryCode = countryCode;
        this.length = length;
        this.structure = structure;
        this.example = example;
    }
    /**
     * Lazy-loaded regex (parse the structure and construct the regular expression the first time we need it for validation)
     */ Specification.prototype._regex = function() {
        return this._cachedRegex || (this._cachedRegex = parseStructure(this.structure));
    };
    /**
     * Check if the passed iban is valid according to this specification.
     *
     * @param {String} iban the iban to validate
     * @returns {boolean} true if valid, false otherwise
     */ Specification.prototype.isValid = function(iban) {
        return this.length == iban.length && this.countryCode === iban.slice(0, 2) && this._regex().test(iban.slice(4)) && iso7064Mod97_10(iso13616Prepare(iban)) == 1;
    };
    /**
     * Convert the passed IBAN to a country-specific BBAN.
     *
     * @param iban the IBAN to convert
     * @param separator the separator to use between BBAN blocks
     * @returns {string} the BBAN
     */ Specification.prototype.toBBAN = function(iban, separator) {
        return this._regex().exec(iban.slice(4)).slice(1).join(separator);
    };
    /**
     * Convert the passed BBAN to an IBAN for this country specification.
     * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
     * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
     *
     * @param bban the BBAN to convert to IBAN
     * @returns {string} the IBAN
     */ Specification.prototype.fromBBAN = function(bban) {
        if (!this.isValidBBAN(bban)) throw new Error('Invalid BBAN');
        var remainder = iso7064Mod97_10(iso13616Prepare(this.countryCode + '00' + bban)), checkDigit = ('0' + (98 - remainder)).slice(-2);
        return this.countryCode + checkDigit + bban;
    };
    /**
     * Check of the passed BBAN is valid.
     * This function only checks the format of the BBAN (length and matching the letetr/number specs) but does not
     * verify the check digit.
     *
     * @param bban the BBAN to validate
     * @returns {boolean} true if the passed bban is a valid BBAN according to this specification, false otherwise
     */ Specification.prototype.isValidBBAN = function(bban) {
        return this.length - 4 == bban.length && this._regex().test(bban);
    };
    var countries = {};
    function addSpecification(IBAN) {
        countries[IBAN.countryCode] = IBAN;
    }
    addSpecification(new Specification("AD", 24, "F04F04A12", "AD1200012030200359100100"));
    addSpecification(new Specification("AE", 23, "F03F16", "AE070331234567890123456"));
    addSpecification(new Specification("AL", 28, "F08A16", "AL47212110090000000235698741"));
    addSpecification(new Specification("AT", 20, "F05F11", "AT611904300234573201"));
    addSpecification(new Specification("AZ", 28, "U04A20", "AZ21NABZ00000000137010001944"));
    addSpecification(new Specification("BA", 20, "F03F03F08F02", "BA391290079401028494"));
    addSpecification(new Specification("BE", 16, "F03F07F02", "BE68539007547034"));
    addSpecification(new Specification("BG", 22, "U04F04F02A08", "BG80BNBG96611020345678"));
    addSpecification(new Specification("BH", 22, "U04A14", "BH67BMAG00001299123456"));
    addSpecification(new Specification("BR", 29, "F08F05F10U01A01", "BR9700360305000010009795493P1"));
    addSpecification(new Specification("BY", 28, "A04F04A16", "BY13NBRB3600900000002Z00AB00"));
    addSpecification(new Specification("CH", 21, "F05A12", "CH9300762011623852957"));
    addSpecification(new Specification("CR", 22, "F04F14", "CR72012300000171549015"));
    addSpecification(new Specification("CY", 28, "F03F05A16", "CY17002001280000001200527600"));
    addSpecification(new Specification("CZ", 24, "F04F06F10", "CZ6508000000192000145399"));
    addSpecification(new Specification("DE", 22, "F08F10", "DE89370400440532013000"));
    addSpecification(new Specification("DK", 18, "F04F09F01", "DK5000400440116243"));
    addSpecification(new Specification("DO", 28, "U04F20", "DO28BAGR00000001212453611324"));
    addSpecification(new Specification("EE", 20, "F02F02F11F01", "EE382200221020145685"));
    addSpecification(new Specification("EG", 29, "F04F04F17", "EG800002000156789012345180002"));
    addSpecification(new Specification("ES", 24, "F04F04F01F01F10", "ES9121000418450200051332"));
    addSpecification(new Specification("FI", 18, "F06F07F01", "FI2112345600000785"));
    addSpecification(new Specification("FO", 18, "F04F09F01", "FO6264600001631634"));
    addSpecification(new Specification("FR", 27, "F05F05A11F02", "FR1420041010050500013M02606"));
    addSpecification(new Specification("GB", 22, "U04F06F08", "GB29NWBK60161331926819"));
    addSpecification(new Specification("GE", 22, "U02F16", "GE29NB0000000101904917"));
    addSpecification(new Specification("GI", 23, "U04A15", "GI75NWBK000000007099453"));
    addSpecification(new Specification("GL", 18, "F04F09F01", "GL8964710001000206"));
    addSpecification(new Specification("GR", 27, "F03F04A16", "GR1601101250000000012300695"));
    addSpecification(new Specification("GT", 28, "A04A20", "GT82TRAJ01020000001210029690"));
    addSpecification(new Specification("HR", 21, "F07F10", "HR1210010051863000160"));
    addSpecification(new Specification("HU", 28, "F03F04F01F15F01", "HU42117730161111101800000000"));
    addSpecification(new Specification("IE", 22, "U04F06F08", "IE29AIBK93115212345678"));
    addSpecification(new Specification("IL", 23, "F03F03F13", "IL620108000000099999999"));
    addSpecification(new Specification("IS", 26, "F04F02F06F10", "IS140159260076545510730339"));
    addSpecification(new Specification("IT", 27, "U01F05F05A12", "IT60X0542811101000000123456"));
    addSpecification(new Specification("IQ", 23, "U04F03A12", "IQ98NBIQ850123456789012"));
    addSpecification(new Specification("JO", 30, "A04F22", "JO15AAAA1234567890123456789012"));
    addSpecification(new Specification("KW", 30, "U04A22", "KW81CBKU0000000000001234560101"));
    addSpecification(new Specification("KZ", 20, "F03A13", "KZ86125KZT5004100100"));
    addSpecification(new Specification("LB", 28, "F04A20", "LB62099900000001001901229114"));
    addSpecification(new Specification("LC", 32, "U04F24", "LC07HEMM000100010012001200013015"));
    addSpecification(new Specification("LI", 21, "F05A12", "LI21088100002324013AA"));
    addSpecification(new Specification("LT", 20, "F05F11", "LT121000011101001000"));
    addSpecification(new Specification("LU", 20, "F03A13", "LU280019400644750000"));
    addSpecification(new Specification("LV", 21, "U04A13", "LV80BANK0000435195001"));
    addSpecification(new Specification("MC", 27, "F05F05A11F02", "MC5811222000010123456789030"));
    addSpecification(new Specification("MD", 24, "U02A18", "MD24AG000225100013104168"));
    addSpecification(new Specification("ME", 22, "F03F13F02", "ME25505000012345678951"));
    addSpecification(new Specification("MK", 19, "F03A10F02", "MK07250120000058984"));
    addSpecification(new Specification("MR", 27, "F05F05F11F02", "MR1300020001010000123456753"));
    addSpecification(new Specification("MT", 31, "U04F05A18", "MT84MALT011000012345MTLCAST001S"));
    addSpecification(new Specification("MU", 30, "U04F02F02F12F03U03", "MU17BOMM0101101030300200000MUR"));
    addSpecification(new Specification("NL", 18, "U04F10", "NL91ABNA0417164300"));
    addSpecification(new Specification("NO", 15, "F04F06F01", "NO9386011117947"));
    addSpecification(new Specification("PK", 24, "U04A16", "PK36SCBL0000001123456702"));
    addSpecification(new Specification("PL", 28, "F08F16", "PL61109010140000071219812874"));
    addSpecification(new Specification("PS", 29, "U04A21", "PS92PALS000000000400123456702"));
    addSpecification(new Specification("PT", 25, "F04F04F11F02", "PT50000201231234567890154"));
    addSpecification(new Specification("QA", 29, "U04A21", "QA30AAAA123456789012345678901"));
    addSpecification(new Specification("RO", 24, "U04A16", "RO49AAAA1B31007593840000"));
    addSpecification(new Specification("RS", 22, "F03F13F02", "RS35260005601001611379"));
    addSpecification(new Specification("SA", 24, "F02A18", "SA0380000000608010167519"));
    addSpecification(new Specification("SC", 31, "U04F04F16U03", "SC18SSCB11010000000000001497USD"));
    addSpecification(new Specification("SE", 24, "F03F16F01", "SE4550000000058398257466"));
    addSpecification(new Specification("SI", 19, "F05F08F02", "SI56263300012039086"));
    addSpecification(new Specification("SK", 24, "F04F06F10", "SK3112000000198742637541"));
    addSpecification(new Specification("SM", 27, "U01F05F05A12", "SM86U0322509800000000270100"));
    addSpecification(new Specification("ST", 25, "F08F11F02", "ST68000100010051845310112"));
    addSpecification(new Specification("SV", 28, "U04F20", "SV62CENR00000000000000700025"));
    addSpecification(new Specification("TL", 23, "F03F14F02", "TL380080012345678910157"));
    addSpecification(new Specification("TN", 24, "F02F03F13F02", "TN5910006035183598478831"));
    addSpecification(new Specification("TR", 26, "F05F01A16", "TR330006100519786457841326"));
    addSpecification(new Specification("UA", 29, "F25", "UA511234567890123456789012345"));
    addSpecification(new Specification("VA", 22, "F18", "VA59001123000012345678"));
    addSpecification(new Specification("VG", 24, "U04F16", "VG96VPVG0000012345678901"));
    addSpecification(new Specification("XK", 20, "F04F10F02", "XK051212012345678906"));
    // The following countries are not included in the official IBAN registry but use the IBAN specification
    // Angola
    addSpecification(new Specification("AO", 25, "F21", "AO69123456789012345678901"));
    // Burkina
    addSpecification(new Specification("BF", 27, "F23", "BF2312345678901234567890123"));
    // Burundi
    addSpecification(new Specification("BI", 16, "F12", "BI41123456789012"));
    // Benin
    addSpecification(new Specification("BJ", 28, "F24", "BJ39123456789012345678901234"));
    // Ivory
    addSpecification(new Specification("CI", 28, "U02F22", "CI70CI1234567890123456789012"));
    // Cameron
    addSpecification(new Specification("CM", 27, "F23", "CM9012345678901234567890123"));
    // Cape Verde
    addSpecification(new Specification("CV", 25, "F21", "CV30123456789012345678901"));
    // Algeria
    addSpecification(new Specification("DZ", 24, "F20", "DZ8612345678901234567890"));
    // Iran
    addSpecification(new Specification("IR", 26, "F22", "IR861234568790123456789012"));
    // Madagascar
    addSpecification(new Specification("MG", 27, "F23", "MG1812345678901234567890123"));
    // Mali
    addSpecification(new Specification("ML", 28, "U01F23", "ML15A12345678901234567890123"));
    // Mozambique
    addSpecification(new Specification("MZ", 25, "F21", "MZ25123456789012345678901"));
    // Senegal
    addSpecification(new Specification("SN", 28, "U01F23", "SN52A12345678901234567890123"));
    // The following are regional and administrative French Republic subdivision IBAN specification (same structure as FR, only country code vary)
    addSpecification(new Specification("GF", 27, "F05F05A11F02", "GF121234512345123456789AB13"));
    addSpecification(new Specification("GP", 27, "F05F05A11F02", "GP791234512345123456789AB13"));
    addSpecification(new Specification("MQ", 27, "F05F05A11F02", "MQ221234512345123456789AB13"));
    addSpecification(new Specification("RE", 27, "F05F05A11F02", "RE131234512345123456789AB13"));
    addSpecification(new Specification("PF", 27, "F05F05A11F02", "PF281234512345123456789AB13"));
    addSpecification(new Specification("TF", 27, "F05F05A11F02", "TF891234512345123456789AB13"));
    addSpecification(new Specification("YT", 27, "F05F05A11F02", "YT021234512345123456789AB13"));
    addSpecification(new Specification("NC", 27, "F05F05A11F02", "NC551234512345123456789AB13"));
    addSpecification(new Specification("BL", 27, "F05F05A11F02", "BL391234512345123456789AB13"));
    addSpecification(new Specification("MF", 27, "F05F05A11F02", "MF551234512345123456789AB13"));
    addSpecification(new Specification("PM", 27, "F05F05A11F02", "PM071234512345123456789AB13"));
    addSpecification(new Specification("WF", 27, "F05F05A11F02", "WF621234512345123456789AB13"));
    var NON_ALPHANUM = /[^a-zA-Z0-9]/g, EVERY_FOUR_CHARS = /(.{4})(?!$)/g;
    /**
     * Utility function to check if a variable is a String.
     *
     * @param v
     * @returns {boolean} true if the passed variable is a String, false otherwise.
     */ function isString(v) {
        return typeof v == 'string' || v instanceof String;
    }
    /**
     * Check if an IBAN is valid.
     *
     * @param {String} iban the IBAN to validate.
     * @returns {boolean} true if the passed IBAN is valid, false otherwise
     */ exports1.isValid = function(iban) {
        if (!isString(iban)) return false;
        iban = electronicFormat(iban);
        var countryStructure = countries[iban.slice(0, 2)];
        return !!countryStructure && countryStructure.isValid(iban);
    };
    /**
     * Convert an IBAN to a BBAN.
     *
     * @param iban
     * @param {String} [separator] the separator to use between the blocks of the BBAN, defaults to ' '
     * @returns {string|*}
     */ exports1.toBBAN = function(iban, separator) {
        if (typeof separator == 'undefined') separator = ' ';
        iban = electronicFormat(iban);
        var countryStructure = countries[iban.slice(0, 2)];
        if (!countryStructure) throw new Error('No country with code ' + iban.slice(0, 2));
        return countryStructure.toBBAN(iban, separator);
    };
    /**
     * Convert the passed BBAN to an IBAN for this country specification.
     * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
     * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
     *
     * @param countryCode the country of the BBAN
     * @param bban the BBAN to convert to IBAN
     * @returns {string} the IBAN
     */ exports1.fromBBAN = function(countryCode, bban) {
        var countryStructure = countries[countryCode];
        if (!countryStructure) throw new Error('No country with code ' + countryCode);
        return countryStructure.fromBBAN(electronicFormat(bban));
    };
    /**
     * Check the validity of the passed BBAN.
     *
     * @param countryCode the country of the BBAN
     * @param bban the BBAN to check the validity of
     */ exports1.isValidBBAN = function(countryCode, bban) {
        if (!isString(bban)) return false;
        var countryStructure = countries[countryCode];
        return countryStructure && countryStructure.isValidBBAN(electronicFormat(bban));
    };
    /**
     *
     * @param iban
     * @param separator
     * @returns {string}
     */ exports1.printFormat = function(iban, separator) {
        if (typeof separator == 'undefined') separator = ' ';
        return electronicFormat(iban).replace(EVERY_FOUR_CHARS, "$1" + separator);
    };
    exports1.electronicFormat = electronicFormat;
    /**
     * An object containing all the known IBAN specifications.
     */ exports1.countries = countries;
});

},{}],"19Xlw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    Print: {
        CustomerDetails: {
            VATNumber: {
                sl: 'ID za DDV:',
                en: 'VAT No.:',
                de: 'Umsatzsteuer-ID Nr.:'
            },
            TaxNumber: {
                sl: "Dav\u010Dna \u0161t.:",
                en: 'Tax number:',
                de: 'Steuernummer:'
            },
            CustomerInternalCode: {
                sl: "\u0160ifra stranke:",
                en: 'Customer ID:',
                de: 'Kunden Nr.:'
            }
        },
        MainInvoiceDetails: {
            TimestampFormat: {
                sl: 'DD.MM.YYYY \\o\\b HH:mm:ss',
                en: 'DD.MM.YYYY \\a\\t HH:mm:ss',
                de: 'DD.MM.YYYY \\u\\m HH:mm:ss'
            },
            DateFormat: {
                sl: 'DD.MM.YYYY',
                en: 'DD.MM.YYYY',
                de: 'DD.MM.YYYY'
            },
            ShortDateFormat: {
                sl: 'DD.MM.YY',
                en: 'DD.MM.YY',
                de: 'DD.MM.YY'
            },
            InvoiceTitles: {
                'cash-invoice': {
                    sl: "RA\u010CUN",
                    en: 'INVOICE',
                    de: 'RECHNUNG'
                },
                'invoice': {
                    sl: "RA\u010CUN",
                    en: 'INVOICE',
                    de: 'RECHNUNG'
                },
                'prepayment-invoice': {
                    sl: "AVANSNI RA\u010CUN",
                    en: 'PREPAYMENT',
                    de: 'AVANSZAHLUNG'
                },
                'credit-note': {
                    sl: 'DOBROPIS',
                    en: 'CREDIT NOTE',
                    de: 'GUTSCHRIFT'
                },
                'offer': {
                    sl: 'PONUDBA',
                    en: 'OFFER',
                    de: 'ANGEBOT'
                },
                'cash-register-invoice-income': {
                    sl: 'cash-register-invoice-income',
                    en: 'cash-register-invoice-income',
                    de: 'cash-register-invoice-income'
                },
                'cash-register-invoice-outlay': {
                    sl: 'cash-register-invoice-outlay',
                    en: 'cash-register-invoice-outlay',
                    de: 'cash-register-invoice-outlay'
                },
                'cash-register-journal': {
                    sl: 'cash-register-journal',
                    en: 'cash-register-journal',
                    de: 'cash-register-journal'
                },
                'gift-voucher': {
                    sl: 'gift-voucher',
                    en: 'gift-voucher',
                    de: 'gift-voucher'
                },
                'stock-acquisition': {
                    sl: 'stock-acquisition',
                    en: 'stock-acquisition',
                    de: 'stock-acquisition'
                },
                'stock-delivery-document': {
                    sl: 'stock-delivery-document',
                    en: 'stock-delivery-document',
                    de: 'stock-delivery-document'
                },
                'warehouse-transfer-order': {
                    sl: 'warehouse-transfer-order',
                    en: 'warehouse-transfer-order',
                    de: 'warehouse-transfer-order'
                },
                'delivery-report': {
                    sl: 'delivery-report',
                    en: 'delivery-report',
                    de: 'delivery-report'
                },
                'sales-invoice-book': {
                    sl: 'sales-invoice-book',
                    en: 'sales-invoice-book',
                    de: 'sales-invoice-book'
                },
                'proforma-invoice-book': {
                    sl: 'proforma-invoice-book',
                    en: 'proforma-invoice-book',
                    de: 'proforma-invoice-book'
                },
                'cash-prepayment-invoice': {
                    sl: "RA\u010CUN ZA PREDPLA\u010CILO",
                    en: 'PREPAYMENT INVOICE',
                    de: 'AVANSZAHLUNG'
                },
                'guest-book': {
                    sl: 'guest-book',
                    en: 'guest-book',
                    de: 'guest-book'
                },
                'delivery-note': {
                    sl: 'DOBAVNICA',
                    en: 'DELIVERY NOTE',
                    de: 'LIEFERSCHEIN'
                }
            },
            InvoiceNumber: {
                sl: "\u0160tevilka:",
                en: 'Number:',
                de: 'Nummer:'
            },
            Place: {
                sl: 'Kraj:',
                en: 'Place:',
                de: 'Ort:'
            },
            Timestamp: {
                sl: 'Datum:',
                en: 'Date:',
                de: 'Datum:'
            },
            ServiceDate: {
                sl: 'Opravljeno:',
                en: 'Service date:',
                de: "Durchgef\xfchrt:"
            },
            Reference: {
                sl: 'Referenca:',
                en: 'Reference:',
                de: 'Referenz:'
            },
            Refer: {
                sl: 'Sklic:',
                en: 'Refer.:',
                de: 'Bezugnahme::'
            },
            DeliveryNote: {
                sl: 'Dobavnica:',
                en: 'Delivery note:',
                de: 'Lieferschein:'
            },
            PaymentDate: {
                sl: 'Valuta:',
                en: 'Payment due:',
                de: "Zahlung f\xe4llig:"
            },
            DateOfPayment: {
                sl: "Datum pla\u010Dila:",
                en: 'Date of payment:',
                de: 'Zahlungsdatum:'
            },
            ValidityDate: {
                sl: 'Veljavnost:',
                en: 'Valid until:',
                de: "G\xfclting bis:"
            },
            Reservation: {
                sl: 'Rezervacija:',
                en: 'Reservation:',
                de: 'Reservierung:'
            },
            UserReceivedBy: {
                sl: 'Prevzel:',
                en: 'Prevzel:',
                de: 'Prevzel:'
            },
            UserIssuedBy: {
                sl: 'Izdal:',
                en: 'Izdal:',
                de: 'Izdal:'
            },
            UserFulfilledBy: {
                sl: 'Opravil:',
                en: 'Opravil:',
                de: 'Opravil:'
            },
            EstimatedServiceDate: {
                sl: 'Obdobje storitve (predvideno):',
                en: 'Date of service (estimated):',
                de: "Servicedatum (gesch\xe4tzt):"
            },
            Paid: {
                sl: "PLA\u010CANO",
                en: 'PAID',
                de: 'BEZAHLT'
            }
        },
        InvoiceItemsTable: {
            ItemInternalCode: {
                sl: "\u0160ifra",
                en: 'Code',
                de: 'Code'
            },
            ItemTitle: {
                sl: 'Opis artikla / storitve',
                en: 'Description',
                de: 'Beschreibung'
            },
            Quantity: {
                sl: 'Kol.',
                en: 'Qty.',
                de: 'Menge'
            },
            ItemMeasuringUnitCode: {
                sl: 'EM',
                en: 'Unit',
                de: 'Einheit'
            },
            Price: {
                sl: 'Cena\nz DDV',
                en: 'Unit price',
                de: "St\xfcckpreis"
            },
            Discount: {
                sl: 'Popust\n%',
                en: 'Discount\n%',
                de: 'Rabatt\n%'
            },
            AmountWithoutVAT: {
                sl: 'Vrednost\nbrez DDV',
                en: 'Amount\nexcl. VAT',
                de: 'Wert\no. MwSt.'
            },
            VAT: {
                sl: 'DDV\n%',
                en: 'VAT\n%',
                de: 'MwSt.\n%'
            },
            AmountWithVAT: {
                sl: 'Vrednost\nz DDV',
                en: 'Amount\nwith VAT',
                de: 'Wert\nmit MwSt.'
            }
        },
        TaxesTable: {
            TaxRate: {
                sl: 'Stopnja',
                en: 'VAT Rate',
                de: 'Steuersatz'
            },
            TaxBase: {
                sl: 'Osnova',
                en: 'Tax Base',
                de: 'Steuergrundlage'
            },
            TaxAmount: {
                sl: 'Davek',
                en: 'Tax',
                de: 'Steuer'
            },
            Total: {
                sl: 'Skupaj',
                en: 'Total',
                de: 'Gesamtsumme'
            },
            Nontaxable: {
                sl: "neobdav\u010Deno",
                en: 'non-taxable',
                de: 'nicht steuerpflichtig'
            }
        },
        InvoiceSums: {
            AmountWithoutVAT: {
                sl: 'Vrednost brez DDV EUR',
                en: 'Amount without Discount EUR',
                de: 'Wert ohne Rabatt EUR'
            },
            DiscountAmount: {
                sl: 'Popust EUR',
                en: 'Discount EUR',
                de: 'Rabatt EUR'
            },
            TaxBase: {
                sl: "Dav\u010Dna osnova EUR",
                en: 'Total Amount EUR',
                de: 'Bemessungsgrundlage EUR'
            },
            TaxAmount: {
                sl: 'Znesek davka EUR',
                en: 'VAT Amount EUR',
                de: 'Steuersumme EUR'
            },
            Total: {
                sl: "Skupaj za pla\u010Dilo EUR",
                en: 'TOTAL to be Paid EUR',
                de: 'Gesamtsumme EUR'
            },
            AdvancePaymentAmount: {
                sl: "Predpla\u010Dilo EUR",
                en: 'Paid in Advance EUR',
                de: 'Avanszahlung EUR'
            },
            RemainingAmount: {
                sl: "Ostane za pla\u010Dilo EUR",
                en: 'Remain to be Paid EUR',
                de: 'Restbetrag EUR'
            }
        },
        PaymentTypesTable: {
            Advance: {
                sl: 'Avans',
                en: 'Advance',
                de: 'Avans'
            },
            PaymentType: {
                sl: "Na\u010Din pla\u010Dila",
                en: "Na\u010Din pla\u010Dila",
                de: "Na\u010Din pla\u010Dila"
            }
        },
        AdditionalInvoiceDetails: {
            User: {
                sl: 'Blagajnik:',
                en: 'Blagajnik:',
                de: 'Blagajnik:'
            },
            InvoiceNumberInternal: {
                sl: "Interna \u0161t.:",
                en: "Interna \u0161t.:",
                de: "Interna \u0161t.:"
            },
            ZOI: {
                sl: 'ZOI:',
                en: 'ZOI:',
                de: 'ZOI:'
            },
            EOR: {
                sl: 'EOR:',
                en: 'EOR:',
                de: 'EOR:'
            },
            CopyCount: {
                sl: 'Kopija:',
                en: 'Copy:',
                de: 'Kopija:'
            }
        },
        AdditionalDescription: {
            Note: {
                sl: 'Opomba:',
                en: 'Opomba:',
                de: 'Opomba:'
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8GVuQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompanyDetails", ()=>CompanyDetails);
parcelHelpers.export(exports, "Logo", ()=>Logo);
parcelHelpers.export(exports, "CustomerDetails", ()=>CustomerDetails);
parcelHelpers.export(exports, "Footer", ()=>Footer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _translation = require("../../helpers/Translation");
var _translationDefault = parcelHelpers.interopDefault(_translation);
function CompanyDetails(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "company-details",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "emphasized mb-05-line font-large-1",
                children: props.company_data.subject_long_name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.company_data.subject_address
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.company_data.subject_post_code + ' ' + props.company_data.subject_city
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    props.company_data.subject_phone_1 === null || props.company_data.subject_phone_1.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: 'T: ' + props.company_data.subject_phone_1
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: ' '
                    }),
                    props.company_data.subject_phone_2 === null || props.company_data.subject_phone_2.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: 'M: ' + props.company_data.subject_phone_2
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: 'E: ' + props.company_data.subject_email + ' ' + 'W: ' + props.company_data.subject_website
            })
        ]
    });
}
function Logo(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "logo",
        children: props.company_data.logo == '' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: 'data:;base64,' + props.company_data.logo
        })
    });
}
function CustomerDetails(props) {
    let customer_name = ((props.item.customer_name ?? '') + ' ' + (props.item.customer_surname ?? '')).trim();
    if (props.item.customer_type == 'company') {
        if (props.item.customer_display_company_long_name_on_invoices && props.item.customer_company_long_name.length > 0) customer_name = props.item.customer_company_long_name ?? '';
        else customer_name = props.item.customer_company_name ?? '';
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "customer-details",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "emphasized font-large-1 mb-05-line",
                children: customer_name.trim()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.item.customer_address ?? ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: ((props.item.customer_post_code ?? '') + ' ' + (props.item.customer_post_office ?? '')).trim()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-2-line",
                children: props.customer_country === null || props.customer_country === undefined ? '' : props.customer_country.common_name_international
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-05-line",
                children: props.item.customer_vat_registered === null ? '' : (props.item.customer_vat_registered ? (0, _translationDefault.default).Print.CustomerDetails.VATNumber[props.lang] : (0, _translationDefault.default).Print.CustomerDetails.TaxNumber[props.lang]) + ' ' + props.item.customer_vat_prefix + props.item.customer_tax_number
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-small",
                children: props.item.customer_internal_code === null || props.item.customer_internal_code === undefined ? '' : (0, _translationDefault.default).Print.CustomerDetails.CustomerInternalCode[props.lang] + ' ' + (props.item.customer_internal_code ?? '')
            })
        ]
    });
}
function Footer(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: 'footer ' + (props.inline === true ? 'inline' : ''),
        children: props.settings.footer
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../helpers/Translation":"19Xlw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jqs5j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Journals);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _print = require("../../helpers/Print");
var _printDefault = parcelHelpers.interopDefault(_print);
var _translation = require("../../helpers/Translation");
var _translationDefault = parcelHelpers.interopDefault(_translation);
var _common = require("./Common");
function formatNumber(val, decimal_digit_count) {
    decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
    return Math.properRound(parseFloat(val), decimal_digit_count).toLocaleString(undefined, {
        minimumFractionDigits: decimal_digit_count,
        maximumFractionDigits: decimal_digit_count
    });
}
const typeTypeTitles = {
    'cash': 'Gotovina',
    'credit-card': 'Kartice',
    'bank-transfer': 'TRR',
    'gift-card': 'Bon',
    'other': 'Drugo'
};
const typeTypeValues = [
    'cash',
    'credit-card',
    'bank-transfer',
    'gift-card',
    'other'
];
const itemTypeTitles = {
    'item': 'Blago',
    'service': 'Storitev',
    'tourist_tax': "Turisti\u010Dna taksa"
};
const itemTypeValues = [
    'item',
    'service',
    'tourist_tax'
];
function BasicData(props) {
    let line1 = null;
    let line2 = null;
    if (props.is_journal_state) {
        line1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "print-journal-basic-data-2",
            children: "STANJE BLAGAJNE"
        });
        line2 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "print-journal-basic-data-3",
            children: (0, _momentDefault.default)(props.start_document_date).format('DD.MM.YYYY') + ' - ' + (0, _momentDefault.default)(props.end_document_date).format('DD.MM.YYYY')
        });
    } else if (props.document_number !== null && props.last_document_number === null && props.cash_register !== null) line1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "print-journal-basic-data-2",
        children: "BLAGAJNI\u0160KI DNEVNIK - " + (0, _momentDefault.default)(props.start_document_date).format('DD.MM.YYYY') + (props.document_number === null ? '' : " - \u0161t. " + props.document_number)
    });
    else if (props.document_number !== null && props.last_document_number !== null) {
        line1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "print-journal-basic-data-2",
            children: "BLAGAJNI\u0160KI DNEVNIK - ZBIRNIK"
        });
        line2 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "print-journal-basic-data-3",
            children: (0, _momentDefault.default)(props.start_document_date).format('DD.MM.YYYY') + ' - ' + (0, _momentDefault.default)(props.end_document_date).format('DD.MM.YYYY') + " \u2022 " + props.document_number + ' do ' + props.last_document_number
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "print-journal-basic-data",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-basic-data-1",
                children: props.cash_register.title
            }),
            line1,
            line2
        ]
    });
}
function IncomeExpenseTable(props) {
    const { items, documents, payment_types } = props;
    const grouped = {};
    const groupedTotals = {};
    const total = {
        income: 0,
        expense: 0
    };
    for(let i = 0; i < documents.length; i++){
        const doc = documents[i];
        if (doc.payment_types === null) continue;
        for(let j = 0; j < doc.payment_types.length; j++){
            const payment_type = doc.payment_types[j];
            const payment_type_item = payment_types[payment_type.id_payment_type];
            if (groupedTotals[payment_type_item.type] === undefined) groupedTotals[payment_type_item.type] = {
                income: 0,
                expense: 0
            };
            if (grouped[payment_type_item.type] === undefined) grouped[payment_type_item.type] = {};
            if (grouped[payment_type_item.type][payment_type.id_payment_type] === undefined) grouped[payment_type_item.type][payment_type.id_payment_type] = {
                income: 0,
                expense: 0
            };
            grouped[payment_type_item.type][payment_type.id_payment_type][doc.type] += payment_type.amount;
            groupedTotals[payment_type_item.type][doc.type] += payment_type.amount;
            total[doc.type] += payment_type.amount;
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "print-journal-income-expenses-table font-small",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-table-header-cell print-journal-income-expenses-table-cell",
                children: "Na\u010Din pla\u010Dila"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-table-header-cell print-journal-income-expenses-table-cell"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-table-header-cell print-journal-income-expenses-table-cell text-right",
                children: "Znesek (EUR)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-table-header-cell print-journal-income-expenses-table-cell"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-table-header-cell print-journal-income-expenses-table-cell"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-table-header-cell print-journal-income-expenses-table-cell text-right",
                children: "Znesek (EUR)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2",
                children: "Stari saldo"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2 text-right",
                children: formatNumber(props.start_balance)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2",
                children: "Novi saldo"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2 text-right",
                children: formatNumber(props.end_balance)
            }),
            typeTypeValues.map((type, idx)=>{
                if (grouped[type] === undefined) return null;
                const display_group = Object.keys(grouped[type]).length > 1;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        !display_group ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2 pl-2",
                                    children: idx == 0 ? 'PREJEMKI' : ''
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2',
                                    children: typeTypeTitles[type]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2 text-right',
                                    children: formatNumber(groupedTotals[type].income)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2 pl-2",
                                    children: idx == 0 ? 'IZDATKI' : ''
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2',
                                    children: typeTypeTitles[type]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: 'print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2 text-right',
                                    children: formatNumber(groupedTotals[type].expense)
                                })
                            ]
                        }),
                        Object.keys(grouped[type]).sort((id_payment_type_a, id_payment_type_b)=>{
                            return payment_types[id_payment_type_a].ord - payment_types[id_payment_type_b].ord;
                        }).map((id_payment_type)=>{
                            const payment_type = payment_types[id_payment_type];
                            const cls = display_group ? 'pl-2' : '';
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2 pl-2",
                                        children: idx == 0 ? 'PREJEMKI' : ''
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: 'print-journal-table-cell print-journal-income-expenses-table-cell ' + cls,
                                        children: payment_type.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: 'print-journal-table-cell print-journal-income-expenses-table-cell text-right ' + cls,
                                        children: formatNumber(grouped[type][id_payment_type].income)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "print-journal-table-cell print-journal-income-expenses-table-cell emphasized-2 pl-2",
                                        children: idx == 0 ? 'IZDATKI' : ''
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: 'print-journal-table-cell print-journal-income-expenses-table-cell ' + cls,
                                        children: payment_type.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: 'print-journal-table-cell print-journal-income-expenses-table-cell text-right ' + cls,
                                        children: formatNumber(grouped[type][id_payment_type].expense)
                                    })
                                ]
                            }, 'item-' + type + '-' + id_payment_type);
                        })
                    ]
                }, 'item-' + type);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell top-border"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell top-border emphasized-2",
                children: "SKUPAJ"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell top-border emphasized-2 text-right",
                children: formatNumber(total.income)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell top-border"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell top-border emphasized-2",
                children: "SKUPAJ"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-income-expenses-table-cell top-border emphasized-2 text-right",
                children: formatNumber(total.expense)
            })
        ]
    });
}
function CashierTable(props) {
    const { documents, users } = props;
    const grouped = {};
    const total = {
        income: 0,
        expense: 0
    };
    for(let i = 0; i < documents.length; i++){
        const doc = documents[i];
        if (doc.payment_types === null) continue;
        if (grouped[doc.id_user] === undefined) grouped[doc.id_user] = {
            income: 0,
            expense: 0
        };
        for(let j = 0; j < doc.payment_types.length; j++){
            const payment_type = doc.payment_types[j];
            grouped[doc.id_user][doc.type] += payment_type.amount;
            total[doc.type] += payment_type.amount;
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "print-journal-cashier-table font-small",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-cashier-table-cell",
                children: "Blagajnik"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-cashier-table-cell text-right",
                children: "Prejemki (EUR)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-cashier-table-cell text-right",
                children: "Izdatki (EUR)"
            }),
            Object.keys(grouped).map((id_user)=>{
                const user = users[id_user];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "print-journal-table-cell print-journal-cashier-table-cell",
                            children: user.name + ' ' + user.surname
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "print-journal-table-cell print-journal-cashier-table-cell text-right",
                            children: formatNumber(grouped[id_user].income)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "print-journal-table-cell print-journal-cashier-table-cell text-right",
                            children: formatNumber(grouped[id_user].expense)
                        })
                    ]
                }, 'item-' + id_user);
            }),
            Object.keys(grouped).length <= 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-cashier-table-cell top-border emphasized-2",
                        children: "SKUPAJ"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-cashier-table-cell top-border emphasized-2 text-right",
                        children: formatNumber(total.income)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-cashier-table-cell top-border emphasized-2 text-right",
                        children: formatNumber(total.expense)
                    })
                ]
            })
        ]
    });
}
function SalesSpecificationTable(props) {
    const { documents, tax_rates, customer_type, customers } = props;
    const grouped_docs = {
        natural: [],
        company: []
    };
    for(let i = 0; i < documents.length; i++){
        const customer = documents[i].id_customer === null ? null : customers[documents[i].id_customer] || null;
        const type = customer === null ? 'natural' : customer.type;
        grouped_docs[type].push(documents[i]);
    }
    const docs = customer_type === null ? documents : grouped_docs[customer_type];
    if (docs.length == 0) return null;
    if (customer_type !== null && (customer_type == 'natural' && grouped_docs['company'].length == 0 || customer_type == 'company' && grouped_docs['natural'].length == 0)) return null;
    const grouped = {};
    const grouped_total = {};
    const total = {
        amount: 0,
        tax_amount: 0
    };
    for(let i = 0; i < docs.length; i++){
        const doc = docs[i];
        if (doc.payment_types === null) continue;
        if (doc.invoices === null || doc.invoices === undefined || doc.invoices.length == 0) continue;
        for(let j = 0; j < doc.payment_types.length; j++){
            const payment_type = doc.payment_types[j];
            if (payment_type.item_type === null) continue;
            if (payment_type.id_tax_rate === null) continue;
            if (grouped[payment_type.item_type] === undefined) grouped[payment_type.item_type] = {};
            if (grouped_total[payment_type.item_type] === undefined) grouped_total[payment_type.item_type] = {
                amount: 0,
                tax_amount: 0
            };
            if (grouped[payment_type.item_type][payment_type.id_tax_rate] === undefined) grouped[payment_type.item_type][payment_type.id_tax_rate] = {
                amount: 0,
                tax_amount: 0,
                tax_rate: payment_type.tax_rate
            };
            grouped[payment_type.item_type][payment_type.id_tax_rate].amount += parseFloat(payment_type.full_amount);
        }
    }
    for(let item_type in grouped)for(let id_tax_rate in grouped[item_type]){
        const rounded_amount = Math.properRound(grouped[item_type][id_tax_rate].amount, 2);
        const rounded_tax_amount = Math.properRound(rounded_amount - rounded_amount / (1 + parseFloat(grouped[item_type][id_tax_rate].tax_rate) / 100), 2);
        grouped[item_type][id_tax_rate].amount = rounded_amount;
        grouped[item_type][id_tax_rate].tax_amount = rounded_tax_amount;
        grouped_total[item_type].amount += rounded_amount;
        grouped_total[item_type].tax_amount += rounded_tax_amount;
        total.amount += rounded_amount;
        total.tax_amount += rounded_tax_amount;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "print-journal-sales-specification-table font-small",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-sales-specification-table-cell",
                children: customer_type === null ? 'Specifikacija prodaje' : customer_type == 'natural' ? "Prodaja - kon\u010Dni kupci" : 'Prodaja - pravne osebe'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-sales-specification-table-cell text-right",
                children: "Dav\u010Dna stopnja"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-sales-specification-table-cell text-right",
                children: "Osnova (EUR)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-sales-specification-table-cell text-right",
                children: "Davek (EUR)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-sales-specification-table-cell text-right",
                children: "Skupaj (EUR)"
            }),
            itemTypeValues.map((item_type)=>{
                if (grouped[item_type] === undefined) return null;
                let items = [];
                const keys = Object.keys(grouped[item_type]).sort((a, b)=>{
                    return tax_rates[a].value - tax_rates[b].value;
                });
                for(let i = 0; i < keys.length; i++){
                    const id_tax_rate = keys[i];
                    const item = grouped[item_type][id_tax_rate];
                    const tax_rate = tax_rates[id_tax_rate];
                    let tax_rate_value = formatNumber(tax_rate.value) + ' %';
                    if (tax_rate.taxable == 'nontaxable') tax_rate_value = "neobdav\u010Deno";
                    else if (tax_rate.taxable == 'tax-exempt') tax_rate_value = "opro\u0161\u010Deno";
                    items = [
                        ...items,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-sales-specification-table-cell ' + (i == 0 ? 'mt-05' : ''),
                            children: i == 0 ? itemTypeTitles[item_type] : ''
                        }, 'spec-item-1-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-sales-specification-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: tax_rate_value
                        }, 'spec-item-2-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-sales-specification-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: formatNumber(item.amount - item.tax_amount)
                        }, 'spec-item-3-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-sales-specification-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: formatNumber(item.tax_amount)
                        }, 'spec-item-4-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-sales-specification-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: formatNumber(item.amount)
                        }, 'spec-item-5-' + i)
                    ];
                }
                if (keys.length > 1) items = [
                    ...items,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-sales-specification-table-cell emphasized",
                        children: 'Skupaj'
                    }, 'spec-item-6-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-sales-specification-table-cell emphasized text-right",
                        children: ''
                    }, 'spec-item-7-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-sales-specification-table-cell emphasized text-right",
                        children: formatNumber(grouped_total[item_type].amount - grouped_total[item_type].tax_amount)
                    }, 'spec-item-8-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-sales-specification-table-cell emphasized text-right",
                        children: formatNumber(grouped_total[item_type].tax_amount)
                    }, 'spec-item-9-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-sales-specification-table-cell emphasized text-right",
                        children: formatNumber(grouped_total[item_type].amount)
                    }, 'spec-item-10-total')
                ];
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                    children: items
                }, 'item-' + item_type);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-sales-specification-table-cell top-border emphasized-2",
                children: "SKUPAJ"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-sales-specification-table-cell top-border emphasized-2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-sales-specification-table-cell top-border emphasized-2 text-right",
                children: formatNumber(total.amount - total.tax_amount)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-sales-specification-table-cell top-border emphasized-2 text-right",
                children: formatNumber(total.tax_amount)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-sales-specification-table-cell top-border emphasized-2 text-right",
                children: formatNumber(total.amount)
            })
        ]
    });
}
function UsedAdvancePaymentsSummaryTable(props) {
    const { documents, tax_rates, id_advance_invoice_consumption_by_id_consumer_invoices, advance_invoice_consumptions, invoices } = props;
    const grouped = {};
    const grouped_total = {};
    const total = {
        amount: 0,
        tax_amount: 0
    };
    for(let i = 0; i < documents.length; i++){
        const doc = documents[i];
        if (doc.payment_types === null) continue;
        if (doc.invoices === null || doc.invoices === undefined || doc.invoices.length == 0) continue;
        for(let j = 0; j < doc.invoices.length; j++){
            const invoice = doc.invoices[j];
            const id_advance_invoice_consumptions = id_advance_invoice_consumption_by_id_consumer_invoices[invoice.id_invoice] ?? [];
            for(let z = 0; z < id_advance_invoice_consumptions.length; z++){
                const consumption = advance_invoice_consumptions[id_advance_invoice_consumptions[z]];
                const advance_invoice = invoices[consumption.advance_id_invoice];
                const invoice_items = advance_invoice.items ?? [];
                for(let x = 0; x < invoice_items.length; x++){
                    const invoice_item = invoice_items[x];
                    if (invoice_item.item_type === null) continue;
                    if (invoice_item.id_tax_rate === null) continue;
                    if (grouped[invoice_item.item_type] === undefined) grouped[invoice_item.item_type] = {};
                    if (grouped_total[invoice_item.item_type] === undefined) grouped_total[invoice_item.item_type] = {
                        amount: 0,
                        tax_amount: 0
                    };
                    if (grouped[invoice_item.item_type][invoice_item.id_tax_rate] === undefined) grouped[invoice_item.item_type][invoice_item.id_tax_rate] = {
                        amount: 0,
                        tax_amount: 0,
                        tax_rate: invoice_item.tax_rate
                    };
                    grouped[invoice_item.item_type][invoice_item.id_tax_rate].amount += parseFloat(consumption.amount) / parseFloat(advance_invoice.invoice_amount) * parseFloat(invoice_item.price) * parseFloat(invoice_item.quantity) * (1 - parseFloat(invoice_item.discount) / 100) * -1;
                }
            }
        }
    }
    if (Object.keys(grouped).length == 0) return null;
    for(let item_type in grouped)for(let id_tax_rate in grouped[item_type]){
        const rounded_amount = Math.properRound(grouped[item_type][id_tax_rate].amount, 2);
        const rounded_tax_amount = Math.properRound(rounded_amount - rounded_amount / (1 + parseFloat(grouped[item_type][id_tax_rate].tax_rate) / 100), 2);
        grouped[item_type][id_tax_rate].amount = rounded_amount;
        grouped[item_type][id_tax_rate].tax_amount = rounded_tax_amount;
        grouped_total[item_type].amount += rounded_amount;
        grouped_total[item_type].tax_amount += rounded_tax_amount;
        total.amount += rounded_amount;
        total.tax_amount += rounded_tax_amount;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "print-journal-sales-specification-table font-small",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-sales-specification-table-cell",
                children: "Specifikacija kori\u0161\u010Denih avansov"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-sales-specification-table-cell text-right",
                children: "Dav\u010Dna stopnja"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-sales-specification-table-cell text-right",
                children: "Osnova (EUR)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-sales-specification-table-cell text-right",
                children: "Davek (EUR)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-sales-specification-table-cell text-right",
                children: "Skupaj (EUR)"
            }),
            itemTypeValues.map((item_type)=>{
                if (grouped[item_type] === undefined) return null;
                let items = [];
                const keys = Object.keys(grouped[item_type]).sort((a, b)=>{
                    return tax_rates[a].value - tax_rates[b].value;
                });
                for(let i = 0; i < keys.length; i++){
                    const id_tax_rate = keys[i];
                    const item = grouped[item_type][id_tax_rate];
                    const tax_rate = tax_rates[id_tax_rate];
                    let tax_rate_value = formatNumber(tax_rate.value) + ' %';
                    if (tax_rate.taxable == 'nontaxable') tax_rate_value = "neobdav\u010Deno";
                    else if (tax_rate.taxable == 'tax-exempt') tax_rate_value = "opro\u0161\u010Deno";
                    items = [
                        ...items,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-sales-specification-table-cell ' + (i == 0 ? 'mt-05' : ''),
                            children: i == 0 ? itemTypeTitles[item_type] : ''
                        }, 'spec-item-1-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-sales-specification-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: tax_rate_value
                        }, 'spec-item-2-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-sales-specification-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: formatNumber(item.amount - item.tax_amount)
                        }, 'spec-item-3-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-sales-specification-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: formatNumber(item.tax_amount)
                        }, 'spec-item-4-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-sales-specification-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: formatNumber(item.amount)
                        }, 'spec-item-5-' + i)
                    ];
                }
                if (keys.length > 1) items = [
                    ...items,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-sales-specification-table-cell emphasized",
                        children: 'Skupaj'
                    }, 'spec-item-6-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-sales-specification-table-cell emphasized text-right",
                        children: ''
                    }, 'spec-item-7-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-sales-specification-table-cell emphasized text-right",
                        children: formatNumber(grouped_total[item_type].amount - grouped_total[item_type].tax_amount)
                    }, 'spec-item-8-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-sales-specification-table-cell emphasized text-right",
                        children: formatNumber(grouped_total[item_type].tax_amount)
                    }, 'spec-item-9-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-sales-specification-table-cell emphasized text-right",
                        children: formatNumber(grouped_total[item_type].amount)
                    }, 'spec-item-10-total')
                ];
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                    children: items
                }, 'item-' + item_type);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-sales-specification-table-cell top-border emphasized-2",
                children: "SKUPAJ"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-sales-specification-table-cell top-border emphasized-2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-sales-specification-table-cell top-border emphasized-2 text-right",
                children: formatNumber(total.amount - total.tax_amount)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-sales-specification-table-cell top-border emphasized-2 text-right",
                children: formatNumber(total.tax_amount)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-sales-specification-table-cell top-border emphasized-2 text-right",
                children: formatNumber(total.amount)
            })
        ]
    });
}
function UsedAdvancePaymentsTable(props) {
    const { documents, tax_rates, id_advance_invoice_consumption_by_id_consumer_invoices, advance_invoice_consumptions, invoices } = props;
    const grouped = {};
    const grouped_total = {};
    const total = {
        amount: 0,
        tax_amount: 0
    };
    const used_advance_invoices = [];
    for(let i = 0; i < documents.length; i++){
        const doc = documents[i];
        if (doc.payment_types === null) continue;
        if (doc.invoices === null || doc.invoices === undefined || doc.invoices.length == 0) continue;
        for(let j = 0; j < doc.invoices.length; j++){
            const invoice = doc.invoices[j];
            const id_advance_invoice_consumptions = id_advance_invoice_consumption_by_id_consumer_invoices[invoice.id_invoice] ?? [];
            for(let z = 0; z < id_advance_invoice_consumptions.length; z++){
                const consumption = advance_invoice_consumptions[id_advance_invoice_consumptions[z]];
                used_advance_invoices.push(consumption);
                if (grouped[consumption.advance_id_invoice] === undefined) grouped[consumption.advance_id_invoice] = {};
                if (grouped_total[consumption.advance_id_invoice] === undefined) grouped_total[consumption.advance_id_invoice] = {
                    amount: 0,
                    tax_amount: 0
                };
                for(let x = 0; x < consumption.taxes.length; x++){
                    const consumption_tax = consumption.taxes[x];
                    if (grouped[consumption.advance_id_invoice][consumption_tax.id_tax_rate] === undefined) grouped[consumption.advance_id_invoice][consumption_tax.id_tax_rate] = {
                        amount: 0,
                        tax_amount: 0
                    };
                    const amount = parseFloat(consumption_tax.amount);
                    const tax_amount = amount - amount / (1 + parseFloat(consumption_tax.tax_rate) / 100);
                    grouped[consumption.advance_id_invoice][consumption_tax.id_tax_rate].amount += amount;
                    grouped[consumption.advance_id_invoice][consumption_tax.id_tax_rate].tax_amount += tax_amount;
                    grouped_total[consumption.advance_id_invoice].amount += amount;
                    grouped_total[consumption.advance_id_invoice].tax_amount += tax_amount;
                    total.amount += amount;
                    total.tax_amount += tax_amount;
                }
            }
        }
    }
    if (used_advance_invoices.length == 0) return null;
    const sorted_ids = Object.keys(grouped);
    sorted_ids.sort((id_invoice_a, id_invoice_b)=>{
        const dir = 'DESC';
        const a = invoices[id_invoice_a].invoice_number_internal;
        const b = invoices[id_invoice_b].invoice_number_internal;
        return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "print-journal-advance-payments-table font-small",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-advance-payments-table-cell",
                children: "Seznam kori\u0161\u010Denih avansov"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-advance-payments-table-cell",
                children: "Datum"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-advance-payments-table-cell text-right",
                children: "Dav\u010Dna stopnja"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-advance-payments-table-cell text-right",
                children: "Osnova (EUR)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-advance-payments-table-cell text-right",
                children: "Davek (EUR)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-advance-payments-table-cell text-right",
                children: "Skupaj (EUR)"
            }),
            sorted_ids.map((advance_id_invoice)=>{
                let items = [];
                const keys = Object.keys(grouped[advance_id_invoice]).sort((a, b)=>{
                    return tax_rates[a].value - tax_rates[b].value;
                });
                for(let i = 0; i < keys.length; i++){
                    const id_tax_rate = keys[i];
                    const item = grouped[advance_id_invoice][id_tax_rate];
                    const advance_invoice = invoices[advance_id_invoice];
                    const tax_rate = tax_rates[id_tax_rate];
                    let tax_rate_value = formatNumber(tax_rate.value) + ' %';
                    if (tax_rate.taxable == 'nontaxable') tax_rate_value = "neobdav\u010Deno";
                    else if (tax_rate.taxable == 'tax-exempt') tax_rate_value = "opro\u0161\u010Deno";
                    items = [
                        ...items,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-advance-payments-table-cell ' + (i == 0 ? 'mt-05' : ''),
                            children: i == 0 ? advance_invoice.invoice_number : ''
                        }, 'spec-item-1-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-advance-payments-table-cell ' + (i == 0 ? 'mt-05' : ''),
                            children: (0, _momentDefault.default)(advance_invoice.invoice_date).format('DD. MM. YYYY')
                        }, 'spec-item-2-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-advance-payments-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: tax_rate_value
                        }, 'spec-item-3-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-advance-payments-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: formatNumber((item.amount - item.tax_amount) * -1)
                        }, 'spec-item-4-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-advance-payments-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: formatNumber(item.tax_amount * -1)
                        }, 'spec-item-5-' + i),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: 'print-journal-table-cell print-journal-advance-payments-table-cell text-right ' + (i == 0 ? 'mt-05' : ''),
                            children: formatNumber(item.amount * -1)
                        }, 'spec-item-6-' + i)
                    ];
                }
                if (keys.length > 1) items = [
                    ...items,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-advance-payments-table-cell emphasized",
                        children: 'Skupaj'
                    }, 'spec-item-7-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-advance-payments-table-cell emphasized",
                        children: ''
                    }, 'spec-item-8-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-advance-payments-table-cell emphasized text-right",
                        children: ''
                    }, 'spec-item-9-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-advance-payments-table-cell emphasized text-right",
                        children: formatNumber((grouped_total[advance_id_invoice].amount - grouped_total[advance_id_invoice].tax_amount) * -1)
                    }, 'spec-item-10-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-advance-payments-table-cell emphasized text-right",
                        children: formatNumber(grouped_total[advance_id_invoice].tax_amount * -1)
                    }, 'spec-item-11-total'),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-advance-payments-table-cell emphasized text-right",
                        children: formatNumber(grouped_total[advance_id_invoice].amount * -1)
                    }, 'spec-item-12-total')
                ];
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                    children: items
                }, 'item-' + advance_id_invoice);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-advance-payments-table-cell top-border emphasized-2",
                children: "SKUPAJ"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-advance-payments-table-cell top-border emphasized-2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-advance-payments-table-cell top-border emphasized-2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-advance-payments-table-cell top-border emphasized-2 text-right",
                children: formatNumber((total.amount - total.tax_amount) * -1)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-advance-payments-table-cell top-border emphasized-2 text-right",
                children: formatNumber(total.tax_amount * -1)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-cell print-journal-advance-payments-table-cell top-border emphasized-2 text-right",
                children: formatNumber(total.amount * -1)
            })
        ]
    });
}
function DetailedList(props) {
    const { documents, payment_types, users, customers } = props;
    const sorted_docs = documents.sort((a, b)=>{
        if (a.type == 'expense' && b.type != 'expense') return -1;
        if (a.type == 'income' && b.type != 'income') return 1;
        if (a.reference > b.reference) return -1;
        else if (a.reference < b.reference) return 1;
        return 0;
    });
    const results = [];
    results.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-documents-table font-small",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "print-journal-table-header-cell print-journal-documents-table-cell without-border span",
                    children: "Blagajni\u0161ki ra\u010Duni"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "print-journal-documents-table font-smaller",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-documents-table-cell",
                        children: "Tip"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-documents-table-cell",
                        children: "\u0160tevilka"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-documents-table-cell",
                        children: "\u0160t. dokumenta"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-documents-table-cell",
                        children: "Datum"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-documents-table-cell",
                        children: "\u0160ifra"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-documents-table-cell",
                        children: "Naziv stranke"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-documents-table-cell",
                        children: "Blagajnik"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-documents-table-cell",
                        children: "Na\u010Din pla\u010Dila"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-documents-table-cell text-right",
                        children: "Znesek"
                    })
                ]
            })
        ]
    }, "document-group-header"));
    const group_count = 100;
    for(let part_idx = 0; part_idx < Math.ceil(sorted_docs.length / group_count); part_idx++){
        const result = [];
        for(let idx = part_idx * group_count; idx < Math.min((part_idx + 1) * group_count, sorted_docs.length); idx++){
            const doc = sorted_docs[idx];
            const id_payment_types = [];
            let amount = 0;
            if (doc.payment_types !== null) for(let i = 0; i < doc.payment_types.length; i++){
                const payment_type = doc.payment_types[i];
                if (id_payment_types.indexOf(payment_type.id_payment_type) == -1) id_payment_types.push(payment_type.id_payment_type);
                amount += payment_type.amount;
            }
            const payment_type_titles = id_payment_types.map((id_payment_type)=>payment_types[id_payment_type].title);
            const customer = doc.id_customer === null ? null : customers[doc.id_customer] || null;
            const user = users[doc.id_user];
            const user_name = user.name.split(' ')[0];
            const user_surname = user.surname.length <= 1 ? user.surname : user.surname.substring(0, 1) + '.';
            result.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-documents-table-cell",
                        children: doc.type == 'income' ? 'Prejemek' : 'Izdatek'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-documents-table-cell",
                        children: doc.document_number
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-documents-table-cell",
                        children: doc.reference
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-documents-table-cell",
                        children: (0, _momentDefault.default)(doc.document_date).format('DD.MM.YYYY')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-documents-table-cell",
                        children: customer === null ? '' : customer.internal_code
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-documents-table-cell",
                        children: customer === null ? '' : customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-documents-table-cell",
                        children: user_name + ' ' + user_surname
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-documents-table-cell",
                        children: payment_type_titles.join(', ')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-documents-table-cell text-right",
                        children: formatNumber(amount)
                    })
                ]
            }, 'document-' + doc.id_cash_register_document));
        }
        results.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "print-journal-documents-table font-smaller",
            children: result
        }, 'document-group-' + part_idx));
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "print-journal-documents-table-container",
        children: results
    });
}
function ManualIncomeList(props) {
    const { documents, payment_types, users, customers } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ManualList, {
        title: "Prejemki, ki niso vezani na izdane ra\u010Dune",
        documents: documents.filter((doc)=>doc.manual && doc.type == 'income'),
        payment_types: payment_types,
        users: users,
        customers: customers
    });
}
function ManualOutcomeList(props) {
    const { documents, payment_types, users, customers } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ManualList, {
        title: "Ro\u010Dni izdatki iz blagajne",
        documents: documents.filter((doc)=>doc.manual && doc.type == 'expense'),
        payment_types: payment_types,
        users: users,
        customers: customers
    });
}
function ManualList(props) {
    const { title, documents, payment_types, users, customers } = props;
    if (documents.length == 0) return null;
    const sorted_docs = documents.sort((a, b)=>{
        if (a.created > b.created) return -1;
        else if (a.created < b.created) return 1;
        return 0;
    });
    const results = [];
    results.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-smaller emphasized-2 mb-05-line",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "print-journal-manual-documents-table font-smaller",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-manual-documents-table-cell",
                        children: "\u0160tevilka"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-manual-documents-table-cell",
                        children: "\u0160t. dokumenta"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-manual-documents-table-cell",
                        children: "Datum"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-manual-documents-table-cell",
                        children: "\u0160ifra"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-manual-documents-table-cell",
                        children: "Naziv stranke"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-manual-documents-table-cell",
                        children: "Blagajnik"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-manual-documents-table-cell",
                        children: "Na\u010Din pla\u010Dila"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-header-cell print-journal-manual-documents-table-cell text-right",
                        children: "Znesek"
                    })
                ]
            })
        ]
    }, "document-group-header"));
    const group_count = 100;
    let sum_amount = 0;
    for(let part_idx = 0; part_idx < Math.ceil(sorted_docs.length / group_count); part_idx++){
        const result = [];
        for(let idx = part_idx * group_count; idx < Math.min((part_idx + 1) * group_count, sorted_docs.length); idx++){
            const doc = sorted_docs[idx];
            const id_payment_types = [];
            let amount = 0;
            if (doc.payment_types !== null) for(let i = 0; i < doc.payment_types.length; i++){
                const payment_type = doc.payment_types[i];
                if (id_payment_types.indexOf(payment_type.id_payment_type) == -1) id_payment_types.push(payment_type.id_payment_type);
                amount += payment_type.amount;
            }
            const payment_type_titles = id_payment_types.map((id_payment_type)=>payment_types[id_payment_type].title);
            const customer = doc.id_customer === null ? null : customers[doc.id_customer] || null;
            const user = users[doc.id_user];
            const user_name = user.name.split(' ')[0];
            const user_surname = user.surname.length <= 1 ? user.surname : user.surname.substring(0, 1) + '.';
            sum_amount += amount;
            result.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-manual-documents-table-cell",
                        children: doc.document_number
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-manual-documents-table-cell",
                        children: doc.reference
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-manual-documents-table-cell",
                        children: (0, _momentDefault.default)(doc.document_date).format('DD.MM.YYYY')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-manual-documents-table-cell",
                        children: customer === null ? '' : customer.internal_code
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-manual-documents-table-cell",
                        children: customer === null ? '' : customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-manual-documents-table-cell",
                        children: user_name + ' ' + user_surname
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-manual-documents-table-cell",
                        children: payment_type_titles.join(', ')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-journal-table-cell print-journal-manual-documents-table-cell text-right",
                        children: formatNumber(amount)
                    })
                ]
            }, 'document-' + doc.id_cash_register_document));
        }
        results.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "print-journal-manual-documents-table font-smaller",
            children: result
        }, 'document-group-' + part_idx));
        results.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "print-journal-manual-documents-table font-smaller",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "print-journal-table-cell print-journal-manual-documents-table-cell top-border emphasized-2",
                    children: "SKUPAJ"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "print-journal-table-cell print-journal-manual-documents-table-cell top-border emphasized-2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "print-journal-table-cell print-journal-manual-documents-table-cell top-border emphasized-2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "print-journal-table-cell print-journal-manual-documents-table-cell top-border emphasized-2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "print-journal-table-cell print-journal-manual-documents-table-cell top-border emphasized-2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "print-journal-table-cell print-journal-manual-documents-table-cell top-border emphasized-2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "print-journal-table-cell print-journal-manual-documents-table-cell top-border emphasized-2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "print-journal-table-cell print-journal-manual-documents-table-cell top-border emphasized-2 text-right",
                    children: formatNumber(sum_amount)
                })
            ]
        }, "sum"));
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "print-journal-manual-documents-table-container",
        children: results
    });
}
function CompanyInvoicesTable(props) {
    const { documents, tax_rates, invoices, customers } = props;
    const doc_invoices = documents.filter((doc)=>{
        const customer = doc.id_customer === null ? null : customers[doc.id_customer] ?? null;
        return customer !== null && customer.type == 'company';
    }).map((doc)=>doc.invoices ?? []).flat().sort((a, b)=>a.invoice_number < b.invoice_number ? -1 : a.invoice_number > b.invoice_number ? 1 : 0);
    if (doc_invoices.length == 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "print-journal-company-invoices-table font-small",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-company-invoices-table-cell without-border span",
                children: "Izdani ra\u010Duni pravnim osebam"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-company-invoices-table-cell",
                children: "\u0160t. dok."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-company-invoices-table-cell",
                children: "Datum dok."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-company-invoices-table-cell",
                children: "\u0160ifra"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-company-invoices-table-cell",
                children: "Naziv"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-company-invoices-table-cell",
                children: "Dav\u010Dna \u0161t./ID za DDV"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-company-invoices-table-cell text-right",
                children: "Dav\u010Dna stopnja"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-company-invoices-table-cell text-right",
                children: "Osnova (EUR)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-company-invoices-table-cell text-right",
                children: "Davek (EUR)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "print-journal-table-header-cell print-journal-company-invoices-table-cell text-right",
                children: "Znesek (EUR)"
            }),
            doc_invoices.map((doc_invoice)=>{
                const invoice = invoices[doc_invoice.id_invoice];
                const invoice_items = invoice.items ?? [];
                const grouped_by_tax = {};
                for(let i = 0; i < invoice_items.length; i++){
                    const item = invoice_items[i];
                    const tax_rate = tax_rates[item.id_tax_rate];
                    const key = tax_rate.taxable == 'taxable' ? tax_rate.value : tax_rate.taxable;
                    if (grouped_by_tax[key] === undefined) grouped_by_tax[key] = {
                        tax_rate,
                        value: 0
                    };
                    grouped_by_tax[key].value += item.quantity * item.price * (1 - item.discount / 100);
                }
                const grouped_by_tax_items = Object.values(grouped_by_tax);
                const customer = customers[invoice.id_customer] ?? null;
                return Object.keys(grouped_by_tax).map((tax_key, idx)=>{
                    const item = grouped_by_tax[tax_key];
                    const tax_rate = item.tax_rate;
                    let tax_rate_value = formatNumber(tax_rate.value) + ' %';
                    if (tax_rate.taxable == 'nontaxable') tax_rate_value = "neobdav\u010Deno";
                    else if (tax_rate.taxable == 'tax-exempt') tax_rate_value = "opro\u0161\u010Deno";
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "print-journal-table-cell print-journal-company-invoices-table-cell nowrap",
                                children: idx > 0 ? '' : invoice.invoice_number
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "print-journal-table-cell print-journal-company-invoices-table-cell nowrap",
                                children: idx > 0 ? '' : (0, _momentDefault.default)(invoice.invoice_date).format('DD. MM. YYYY')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "print-journal-table-cell print-journal-company-invoices-table-cell nowrap",
                                children: idx > 0 || customer === null ? '' : customer.internal_code
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "print-journal-table-cell print-journal-company-invoices-table-cell",
                                children: idx > 0 || customer === null ? '' : customer.type == 'natural' ? customer.surname + ' ' + customer.name : customer.company_name
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "print-journal-table-cell print-journal-company-invoices-table-cell nowrap",
                                children: idx > 0 || customer === null ? '' : customer.vat_prefix + customer.tax_number
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "print-journal-table-cell print-journal-company-invoices-table-cell nowrap text-right",
                                children: tax_rate_value
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "print-journal-table-cell print-journal-company-invoices-table-cell nowrap text-right",
                                children: formatNumber(item.value / (1 + tax_rate.value / 100))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "print-journal-table-cell print-journal-company-invoices-table-cell nowrap text-right",
                                children: formatNumber(item.value - item.value / (1 + tax_rate.value / 100))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "print-journal-table-cell print-journal-company-invoices-table-cell nowrap text-right",
                                children: formatNumber(item.value)
                            }),
                            grouped_by_tax_items.length <= 1 || idx < grouped_by_tax_items.length - 1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "print-journal-table-cell print-journal-company-invoices-table-cell"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "print-journal-table-cell print-journal-company-invoices-table-cell"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "print-journal-table-cell print-journal-company-invoices-table-cell"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "print-journal-table-cell print-journal-company-invoices-table-cell"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "print-journal-table-cell print-journal-company-invoices-table-cell"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "print-journal-table-cell print-journal-company-invoices-table-cell text-right"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "print-journal-table-cell print-journal-company-invoices-table-cell text-right"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "print-journal-table-cell print-journal-company-invoices-table-cell text-right emphasized",
                                        children: "Skupaj"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "print-journal-table-cell print-journal-company-invoices-table-cell nowrap text-right emphasized",
                                        children: formatNumber(grouped_by_tax_items.reduce((acc, val)=>acc + val.value, 0))
                                    })
                                ]
                            })
                        ]
                    }, 'item-' + doc_invoice.id_invoice + '-' + tax_key);
                });
            })
        ]
    });
}
function Journal(props) {
    const { company_data, documents, documents_for_advance_payments, settings, lang, users, cash_register, payment_types, tax_rates, invoices, id_advance_invoice_consumption_by_id_consumer_invoices, advance_invoice_consumptions, customers, cash_registers, display_detailed_list, document_number, last_document_number, start_document_date, end_document_date, start_balance, end_balance, is_journal_state } = props;
    let cls = 'print-document print-journal';
    if (settings.logo_position == 'left') cls += ' reverse-logo';
    else if (settings.logo_position == 'hidden') cls += ' hide-logo';
    console.log({
        document_number
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cls,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "print-journal-main",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.CompanyDetails), {
                        lang: lang,
                        company_data: company_data
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.Logo), {
                        lang: lang,
                        company_data: company_data
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BasicData, {
                        cash_register: cash_register,
                        cash_registers: cash_registers,
                        document_number: document_number,
                        last_document_number: last_document_number,
                        start_document_date: start_document_date,
                        end_document_date: end_document_date,
                        is_journal_state: is_journal_state
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(IncomeExpenseTable, {
                        documents: documents,
                        payment_types: payment_types,
                        start_balance: start_balance,
                        end_balance: end_balance
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ManualIncomeList, {
                        documents: documents,
                        payment_types: payment_types,
                        users: users,
                        customers: customers
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ManualOutcomeList, {
                        documents: documents,
                        payment_types: payment_types,
                        users: users,
                        customers: customers
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CashierTable, {
                        documents: documents,
                        users: users
                    }),
                    is_journal_state ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(SalesSpecificationTable, {
                        documents: documents,
                        tax_rates: tax_rates,
                        customer_type: null,
                        customers: customers
                    }),
                    is_journal_state ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(SalesSpecificationTable, {
                        documents: documents,
                        tax_rates: tax_rates,
                        customer_type: "natural",
                        customers: customers
                    }),
                    is_journal_state ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(SalesSpecificationTable, {
                        documents: documents,
                        tax_rates: tax_rates,
                        customer_type: "company",
                        customers: customers
                    }),
                    is_journal_state ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(CompanyInvoicesTable, {
                        documents: documents,
                        tax_rates: tax_rates,
                        invoices: invoices,
                        customers: customers
                    }),
                    is_journal_state ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(UsedAdvancePaymentsSummaryTable, {
                        documents: documents_for_advance_payments,
                        tax_rates: tax_rates,
                        id_advance_invoice_consumption_by_id_consumer_invoices: id_advance_invoice_consumption_by_id_consumer_invoices,
                        advance_invoice_consumptions: advance_invoice_consumptions,
                        invoices: invoices
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(UsedAdvancePaymentsTable, {
                        documents: documents_for_advance_payments,
                        tax_rates: tax_rates,
                        id_advance_invoice_consumption_by_id_consumer_invoices: id_advance_invoice_consumption_by_id_consumer_invoices,
                        advance_invoice_consumptions: advance_invoice_consumptions,
                        invoices: invoices
                    }),
                    !display_detailed_list ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(DetailedList, {
                        documents: documents,
                        payment_types: payment_types,
                        users: users,
                        customers: customers
                    })
                ]
            }),
            null
        ]
    });
}
function Journals(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: props.pages.map((page, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Journal, {
                ...page
            }, idx))
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","moment":"1e4qG","../../helpers/Print":"f3loA","../../helpers/Translation":"19Xlw","./Common":"8GVuQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e2KKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CashRegisterDocument);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _print = require("../../helpers/Print");
var _printDefault = parcelHelpers.interopDefault(_print);
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _translation = require("../../helpers/Translation");
var _translationDefault = parcelHelpers.interopDefault(_translation);
var _common = require("./Common");
function formatNumber(val, decimal_digit_count) {
    decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
    return parseFloat(val).toLocaleString(undefined, {
        minimumFractionDigits: decimal_digit_count,
        maximumFractionDigits: decimal_digit_count
    });
}
function MainInvoiceDetails(props) {
    const title = props.item.type == 'income' ? 'BL. PREJEMEK' : 'BL. IZDATEK';
    const user = props.users[props.item.id_user];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "main-invoice-details",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    gridColumn: '1 / 3'
                },
                className: "font-large-6 deemphasized mb-05-line",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "emphasized mb-05-line font-large-1",
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.InvoiceNumber[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "emphasized mb-05-line font-large-1",
                children: props.item.document_number
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Blagajna"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.cash_registers[props.item.id_cash_register].title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Blagajnik"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: (user.name + ' ' + user.surname).trim()
            })
        ]
    });
}
function InvoiceItemsTable(props) {
    let items = [];
    items.push([
        "Na\u010Din pla\u010Dila",
        "Tip pla\u010Dila",
        'Opis',
        'Znesek'
    ]);
    const typeTypeTitles = {
        'cash': 'Gotovina',
        'credit-card': 'Kartice',
        'bank-transfer': 'TRR',
        'gift-card': 'Bon',
        'other': 'Drugo'
    };
    let sum = 0;
    for(let i = 0; i < (props.item.payment_types || []).length; i++){
        const payment_type_item = props.item.payment_types[i];
        const payment_type = props.payment_types[payment_type_item.id_payment_type];
        items.push([
            payment_type.title,
            typeTypeTitles[payment_type.type],
            payment_type_item.note,
            formatNumber(payment_type_item.amount, 2)
        ]);
        sum += parseFloat(payment_type_item.amount);
    }
    let bold_last_line = false;
    if (items.length > 1) {
        items.push([
            'Skupaj',
            '',
            '',
            formatNumber(sum, 2)
        ]);
        bold_last_line = true;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "cash-register-document-items-table",
        children: items.map((item, idx)=>{
            let cls = idx == 0 ? 'cell header-cell' : 'cell';
            if (idx == items.length - 1 && bold_last_line) cls += ' emphasized-2';
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls,
                        children: item[0]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls,
                        children: item[1]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls,
                        children: item[2]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls + ' text-right',
                        children: item[3]
                    })
                ]
            }, 'item-' + idx);
        })
    });
}
function AdditionalDescription(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "additional-description",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "mb-1-line",
            children: props.item.note
        })
    });
}
function CashRegisterDocument(props) {
    const { company_data, item, payment_types, cash_registers, users, customer_country, settings, lang } = props;
    let cls = 'print-document print-invoice';
    if (settings.logo_position == 'left') cls += ' reverse-logo';
    else if (settings.logo_position == 'hidden') cls += ' hide-logo';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cls,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "print-invoice-main",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.CompanyDetails), {
                        lang: lang,
                        company_data: company_data
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.Logo), {
                        lang: lang,
                        company_data: company_data
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.CustomerDetails), {
                        lang: lang,
                        item: item,
                        customer_country: customer_country
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MainInvoiceDetails, {
                        lang: lang,
                        item: item,
                        company_data: company_data,
                        cash_registers: cash_registers,
                        users: users,
                        payment_types: payment_types
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvoiceItemsTable, {
                        lang: lang,
                        item: item,
                        payment_types: payment_types
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdditionalDescription, {
                        lang: lang,
                        item: item
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.Footer), {
                lang: lang,
                settings: settings
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","moment":"1e4qG","../../helpers/Print":"f3loA","../../helpers/Invoice":"jffQW","../../helpers/Translation":"19Xlw","./Common":"8GVuQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"edPHv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Acquisition);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _print = require("../../helpers/Print");
var _printDefault = parcelHelpers.interopDefault(_print);
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _translation = require("../../helpers/Translation");
var _translationDefault = parcelHelpers.interopDefault(_translation);
var _common = require("./Common");
function formatNumber(val, decimal_digit_count) {
    decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
    let rounded_val = Math.properRound(parseFloat(val), decimal_digit_count);
    return rounded_val.toLocaleString(undefined, {
        minimumFractionDigits: decimal_digit_count,
        maximumFractionDigits: decimal_digit_count
    });
}
function CompanyDetails(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "print-acquisition-company-details",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.company_data.subject_long_name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: [
                    props.company_data.subject_address,
                    props.company_data.subject_post_code + ' ' + props.company_data.subject_city
                ].filter((x)=>x !== null && x.length > 0).join(', ')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: [
                    props.company_data.subject_phone_1 === null || props.company_data.subject_phone_1.length == 0 ? null : 'T: ' + props.company_data.subject_phone_1,
                    props.company_data.subject_phone_2 === null || props.company_data.subject_phone_2.length == 0 ? null : 'M: ' + props.company_data.subject_phone_2
                ].filter((x)=>x !== null && x.length > 0).join(', ')
            })
        ]
    });
}
function AcquisitionDetails(props) {
    const book_date = props.item.book_date === null ? null : (0, _momentDefault.default)(props.item.book_date);
    const delivery_note_date = props.item.delivery_note_date === null ? null : (0, _momentDefault.default)(props.item.delivery_note_date);
    const warehouse = props.warehouses[props.item.id_warehouse];
    const type_titles = {
        'acquisition': 'Prevzem',
        'write-off': 'Odpis zaloge',
        'reclamation': 'Reklamacija',
        'representation': 'Reprezentanca',
        'commission': 'Komisija',
        'debt-release': "Razdol\u017Enica",
        'internal-transfer': "Prenos med skladi\u0161\u010Di"
    };
    let type_title = type_titles[props.item.type];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "print-acquisition-acquisition-details",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    gridColumn: '1 / 3'
                },
                className: "font-large-6 deemphasized mb-05-line",
                children: "PREVZEM"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "emphasized mb-05-line font-large-1",
                children: "\u0160tevilka:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "emphasized mb-05-line font-large-1",
                children: props.item.document_number
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Datum prevzema:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: delivery_note_date === null ? '' : delivery_note_date.format('DD. MM. YYYY')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Datum knji\u017Eenja:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: book_date === null ? '' : book_date.format('DD. MM. YYYY')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "\u0160tevilka dobavnice:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.item.delivery_note_number
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Skladi\u0161\u010De:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: warehouse.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Vrsta prevzema:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: type_title
            })
        ]
    });
}
function ItemsTable(props) {
    let items = [];
    items.push([
        "\u0160ifra \u2022 EAN \u2022 Naziv"
    ]);
    items.push([
        'Kol.',
        'NC\nbrez DDV',
        'Nabavni\nDDV (%)',
        'NC\nz DDV',
        'Popust\n(%)',
        'NC s pop.\nbrez DDV',
        'NC s pop.\nz DDV',
        'Znesek\nbrez DDV',
        'Znesek\nz DDV',
        'Prodajni\nDDV (%)',
        'PC\nz DDV'
    ]);
    const item_items = [
        ...props.item.items
    ];
    /*item_items.sort((a, b) => {
		if      (a.ord < b.ord) return -1;
		else if (a.ord > b.ord) return  1;
		return 0;
	});*/ for(let i = 0; i < item_items.length; i++){
        const item = item_items[i];
        const item_item = props.items[item.id_item];
        const discount = item.purchase_discount;
        const quantity = item.quantity;
        const purchase_price_without_vat = item.purchase_price_without_vat;
        const purchase_vat = item.purchase_id_tax_rate === null || item.purchase_id_tax_rate == -1 ? 0 : props.tax_rates[item.purchase_id_tax_rate].value;
        let vat = item.id_tax_rate === null || item.id_tax_rate == -1 ? 0 : props.tax_rates[item.id_tax_rate].value;
        console.log({
            subitem: item
        });
        items.push([
            item_item.internal_code + " \u2022 " + (item_item.ean.length == 0 ? '' : item_item.ean + " \u2022 ") + item_item.title
        ]);
        items.push([
            formatNumber(quantity),
            formatNumber(purchase_price_without_vat, 4),
            formatNumber(purchase_vat),
            formatNumber(purchase_price_without_vat * (1 + purchase_vat / 100), 4),
            formatNumber(discount),
            formatNumber(purchase_price_without_vat * (1 - discount / 100), 4),
            formatNumber(purchase_price_without_vat * (1 - discount / 100) * (1 + purchase_vat / 100), 4),
            formatNumber(purchase_price_without_vat * quantity * (1 - discount / 100)),
            formatNumber(purchase_price_without_vat * quantity * (1 - discount / 100) * (1 + purchase_vat / 100)),
            formatNumber(vat),
            formatNumber(item.price)
        ]);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "print-acquisition-items-table-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "print-acquisition-items-table",
            children: items.map((item, idx)=>{
                const cls = idx <= 1 ? 'font-small print-acquisition-table-header-cell header-cell' : 'font-small print-acquisition-table-cell';
                if (item.length == 1) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: idx <= 1 ? cls : 'emphasized ' + cls,
                        style: {
                            gridColumn: '1 / 12'
                        },
                        children: item[0]
                    })
                }, 'item-' + idx);
                if (idx <= 1) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            style: {
                                whiteSpace: 'nowrap',
                                paddingLeft: '0.3cm'
                            },
                            dangerouslySetInnerHTML: {
                                __html: item[0].replaceAll('\n', '<br />')
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            dangerouslySetInnerHTML: {
                                __html: item[1].replaceAll('\n', '<br />')
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            dangerouslySetInnerHTML: {
                                __html: item[2].replaceAll('\n', '<br />')
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            dangerouslySetInnerHTML: {
                                __html: item[3].replaceAll('\n', '<br />')
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            dangerouslySetInnerHTML: {
                                __html: item[4].replaceAll('\n', '<br />')
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            dangerouslySetInnerHTML: {
                                __html: item[5].replaceAll('\n', '<br />')
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            dangerouslySetInnerHTML: {
                                __html: item[6].replaceAll('\n', '<br />')
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            dangerouslySetInnerHTML: {
                                __html: item[7].replaceAll('\n', '<br />')
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            dangerouslySetInnerHTML: {
                                __html: item[8].replaceAll('\n', '<br />')
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            dangerouslySetInnerHTML: {
                                __html: item[9].replaceAll('\n', '<br />')
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            dangerouslySetInnerHTML: {
                                __html: item[10].replaceAll('\n', '<br />')
                            }
                        })
                    ]
                }, 'item-' + idx);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right pb-02',
                            style: {
                                paddingLeft: '0.3cm'
                            },
                            children: item[0]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right pb-02',
                            children: item[1]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right pb-02',
                            children: item[2]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right pb-02',
                            children: item[3]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right pb-02',
                            children: item[4]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right pb-02',
                            children: item[5]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right pb-02',
                            children: item[6]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right pb-02',
                            children: item[7]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right pb-02',
                            children: item[8]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right pb-02',
                            children: item[9]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right pb-02',
                            children: item[10]
                        })
                    ]
                }, 'item-' + idx);
            })
        })
    });
}
function getSums(items, tax_rates) {
    const sums = {
        purchase_price_without_vat: 0,
        purchase_price_with_vat: 0,
        discount: 0,
        quantity: 0,
        count: 0
    };
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        const purchase_vat = item.purchase_id_tax_rate === null || item.purchase_id_tax_rate == -1 ? 0 : tax_rates[item.purchase_id_tax_rate].value;
        sums.purchase_price_without_vat += parseFloat(item.purchase_price_without_vat) * parseFloat(item.quantity);
        sums.purchase_price_with_vat += parseFloat(item.purchase_price_without_vat) * parseFloat(item.quantity) * (1 + parseFloat(purchase_vat) / 100);
        sums.discount += parseFloat(item.purchase_price_without_vat) * parseFloat(item.quantity) * (parseFloat(item.purchase_discount) / 100);
        sums.quantity += parseFloat(item.quantity);
        sums.count += 1;
    }
    return sums;
}
function Sums(props) {
    const sums = getSums(props.items, props.tax_rates);
    let print_items = [
        [
            sums.discount == 0 ? '' : 'Znesek popusta EUR',
            sums.discount == 0 ? '' : formatNumber(sums.discount, 2),
            false,
            'Znesek brez DDV EUR',
            formatNumber(sums.purchase_price_without_vat, 2),
            true
        ],
        [
            '',
            '',
            false,
            'Znesek davka EUR',
            formatNumber(sums.purchase_price_with_vat - sums.purchase_price_without_vat, 2),
            false
        ],
        [
            '',
            '',
            false,
            'Znesek z DDV EUR',
            formatNumber(sums.purchase_price_with_vat, 2),
            true
        ]
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "print-acquisition-sums",
        children: print_items.map((item, idx)=>{
            if (item === null) return null;
            let cls_1 = 'text-right ' + (item[2] ? 'emphasized' : '');
            let cls_2 = 'text-right ' + (item[5] ? 'emphasized' : '');
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls_1,
                        children: item[0]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls_1,
                        children: item[1]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls_2,
                        children: item[3]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: cls_2,
                        children: item[4]
                    })
                ]
            }, 'sum-' + idx);
        })
    });
}
function Counts(props) {
    const sums = getSums(props.items, props.tax_rates);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "print-acquisition-counts",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "\u0160tevilo vrstic:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: 'text-right',
                children: formatNumber(sums.count, 0)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Skupna koli\u010Dina:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: 'text-right',
                children: formatNumber(sums.quantity, 0)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
        ]
    });
}
function Note(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "print-acquisition-note",
        children: props.item.note.split('\n').map((line, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: line
            }, 'line-' + idx))
    });
}
function Acquisition(props) {
    const { item, items, tax_rates, warehouses, customers, countries, company_data } = props;
    let cls = 'print-document acquisition';
    const supplier = customers[item.supplier_id_customer];
    const supplier_country = supplier.id_country === null ? null : countries[supplier.id_country];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: cls,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "print-acquisition-main",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(CompanyDetails, {
                    company_data: company_data
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.CustomerDetails), {
                    lang: 'sl',
                    item: {
                        customer_name: supplier.name,
                        customer_surname: supplier.surname,
                        customer_type: supplier.type,
                        customer_display_company_long_name_on_invoices: supplier.display_company_long_name_on_invoices,
                        customer_company_long_name: supplier.company_long_name,
                        customer_company_name: supplier.company_name,
                        customer_address: supplier.address,
                        customer_post_code: supplier.post_code,
                        customer_post_office: supplier.post_office,
                        customer_vat_registered: supplier.vat_registered,
                        customer_vat_prefix: supplier.vat_prefix,
                        customer_tax_number: supplier.tax_number,
                        customer_internal_code: supplier.internal_code
                    },
                    customer_country: supplier_country
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AcquisitionDetails, {
                    item: item,
                    warehouses: warehouses
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Counts, {
                    items: item.items,
                    tax_rates: tax_rates
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Sums, {
                    items: item.items,
                    tax_rates: tax_rates
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ItemsTable, {
                    item: item,
                    tax_rates: tax_rates,
                    items: items
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Note, {
                    item: item
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","moment":"1e4qG","../../helpers/Print":"f3loA","../../helpers/Invoice":"jffQW","../../helpers/Translation":"19Xlw","./Common":"8GVuQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tfJP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeliveryNote);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _print = require("../../helpers/Print");
var _printDefault = parcelHelpers.interopDefault(_print);
var _invoice = require("../../helpers/Invoice");
var _invoiceDefault = parcelHelpers.interopDefault(_invoice);
var _translation = require("../../helpers/Translation");
var _translationDefault = parcelHelpers.interopDefault(_translation);
var _common = require("./Common");
function formatNumber(val, decimal_digit_count) {
    decimal_digit_count = decimal_digit_count === undefined ? 2 : decimal_digit_count;
    let rounded_val = Math.properRound(parseFloat(val), decimal_digit_count);
    return rounded_val.toLocaleString(undefined, {
        minimumFractionDigits: decimal_digit_count,
        maximumFractionDigits: decimal_digit_count
    });
}
function CustomerDetails(props) {
    let customer_name = ((props.customer.name ?? '') + ' ' + (props.customer.surname ?? '')).trim();
    if (props.customer.type == 'company') {
        if (props.customer.display_company_long_name_on_invoices && props.customer.company_long_name.length > 0) customer_name = props.customer.company_long_name ?? '';
        else customer_name = props.customer.company_name ?? '';
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "customer-details",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "emphasized font-large-1 mb-05-line",
                children: customer_name.trim()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.customer.address ?? ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: ((props.customer.post_code ?? '') + ' ' + (props.customer.post_office ?? '')).trim()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-2-line",
                children: props.customer_country === null || props.customer_country === undefined ? '' : props.customer_country.common_name_international
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-05-line",
                children: props.customer.vat_registered === null ? '' : (props.customer.vat_registered ? (0, _translationDefault.default).Print.CustomerDetails.VATNumber[props.lang] : (0, _translationDefault.default).Print.CustomerDetails.TaxNumber[props.lang]) + ' ' + props.customer.vat_prefix + props.customer.tax_number
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-small",
                children: props.customer.internal_code === null || props.customer.internal_code === undefined ? '' : (0, _translationDefault.default).Print.CustomerDetails.CustomerInternalCode[props.lang] + ' ' + (props.customer.internal_code ?? '')
            }),
            props.item.delivery_address.trim().length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "font-small mt-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "emphasized",
                        children: "Naslov za dostavo:"
                    }),
                    props.item.delivery_address.trim().split('\n').map((line, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: line
                        }, idx))
                ]
            })
        ]
    });
}
function MainInvoiceDetails(props) {
    // prepare data
    let place = null;
    place = props.company_data.subject_city;
    let timestamp_format = (0, _translationDefault.default).Print.MainInvoiceDetails.DateFormat[props.lang];
    const document_date_timestamp = props.item.document_date === null ? '' : (0, _momentDefault.default)(props.item.document_date).format(timestamp_format);
    const order_date_timestamp = props.item.order_date === null ? '' : (0, _momentDefault.default)(props.item.order_date).format(timestamp_format);
    const title = (0, _translationDefault.default).Print.MainInvoiceDetails.InvoiceTitles['delivery-note'];
    // prepare user fragment
    let user_fragment = null;
    let user = null;
    for(let id_user in props.users)if (props.users[id_user].username == props.item.username_creator) {
        user = props.users[id_user];
        break;
    }
    if (user !== null) user_fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.UserIssuedBy[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: (user.name + ' ' + (user.surname.length == 0 ? '' : user.surname.substring(0, 1) + '.')).trim()
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "main-invoice-details",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    gridColumn: '1 / 3'
                },
                className: "font-large-6 deemphasized mb-05-line",
                children: title === undefined ? '' : title[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "emphasized mb-05-line font-large-1",
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.InvoiceNumber[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "emphasized mb-05-line font-large-1",
                children: props.item.document_number
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: (0, _translationDefault.default).Print.MainInvoiceDetails.Place[props.lang]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: place
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: 'Datum dobavnice'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: document_date_timestamp
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "\u0160t. naro\u010Dila"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.item.order_number
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Datum naro\u010Dila"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: order_date_timestamp
            }),
            user_fragment
        ]
    });
}
function InvoiceItemsTable(props) {
    let items = [];
    items.push([
        (0, _translationDefault.default).Print.InvoiceItemsTable.ItemInternalCode[props.lang],
        'EAN',
        (0, _translationDefault.default).Print.InvoiceItemsTable.ItemTitle[props.lang],
        (0, _translationDefault.default).Print.InvoiceItemsTable.Quantity[props.lang],
        (0, _translationDefault.default).Print.InvoiceItemsTable.ItemMeasuringUnitCode[props.lang]
    ]);
    const item_items = props.item.items;
    const sum_by_measuring_unit = {};
    for(let i = 0; i < item_items.length; i++){
        const item = item_items[i];
        const item_item = props.items[item.id_item];
        const measuring_unit = props.measuring_units[item_item.id_measuring_unit];
        items.push([
            item_item.internal_code,
            item_item.ean,
            item_item.title,
            formatNumber(item.quantity, measuring_unit.decimal_digit_count),
            measuring_unit.title
        ]);
        if (sum_by_measuring_unit[measuring_unit.id_measuring_unit] === undefined) sum_by_measuring_unit[measuring_unit.id_measuring_unit] = {
            measuring_unit,
            quantity: 0
        };
        sum_by_measuring_unit[measuring_unit.id_measuring_unit].quantity += parseFloat(item.quantity);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "delivery-note-items-table",
        children: [
            items.map((item, idx)=>{
                const cls = idx == 0 ? 'cell header-cell' : 'cell';
                if (item.length == 1) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' second-description-cell font-small',
                            children: item[0]
                        })
                    ]
                }, 'item-' + idx);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' wrap',
                            children: item[0]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' wrap',
                            children: item[1]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' wrap',
                            children: item[2]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' text-right',
                            children: item[3]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls,
                            children: item[4]
                        })
                    ]
                }, 'item-' + idx);
            }),
            Object.values(sum_by_measuring_unit).map((item, idx)=>{
                const cls = idx == 0 ? 'first' : '';
                const measuring_unit = item.measuring_unit;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' cell sum wrap title',
                            children: idx == 0 ? "Skupna koli\u010Dina" : ''
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' cell sum text-right',
                            children: formatNumber(item.quantity, measuring_unit.decimal_digit_count)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: cls + ' cell sum',
                            children: measuring_unit.title
                        })
                    ]
                }, 'sum-' + idx);
            })
        ]
    });
}
function AdditionalDescription(props) {
    let print_final_text = props.settings.print_final_text;
    if (props.lang == 'en') print_final_text = props.settings.print_final_text_en;
    else if (props.lang == 'de') print_final_text = props.settings.print_final_text_de;
    print_final_text = print_final_text || '';
    print_final_text = print_final_text.replaceAll('<right>', '<div style="text-align: right;">').replaceAll('</right>', '</div>');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "additional-description",
        children: [
            props.item.note === null || props.item.note.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-1-line",
                children: props.item.note
            }),
            props.lang != 'sl' || props.settings.subject_vat_registered !== false ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-1-line",
                children: props.settings.subject_vat_registered_reason
            }),
            print_final_text === undefined || print_final_text.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-1-line",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: print_final_text
                    }
                })
            })
        ]
    });
}
function DeliveryNote(props) {
    const { company_data, item, payment_types, id_advance_invoice_consumption_by_id_consumer_invoices, invoices, advance_invoice_consumptions, users, invoice_fiscal_verifications, customer, customer_country, settings, lang, items, measuring_units } = props;
    let cls = 'print-document print-delivery-note';
    if (settings.logo_position == 'left') cls += ' reverse-logo';
    else if (settings.logo_position == 'hidden') cls += ' hide-logo';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: cls,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "print-delivery-note-main",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.CompanyDetails), {
                        lang: lang,
                        company_data: company_data
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.Logo), {
                        lang: lang,
                        company_data: company_data
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CustomerDetails, {
                        lang: lang,
                        item: item,
                        customer: customer,
                        customer_country: customer_country
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MainInvoiceDetails, {
                        lang: lang,
                        item: item,
                        company_data: company_data,
                        users: users
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvoiceItemsTable, {
                        lang: lang,
                        item: item,
                        items: items,
                        measuring_units: measuring_units
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdditionalDescription, {
                        lang: lang,
                        item: item,
                        settings: settings
                    })
                ]
            }),
            !settings.print_footer_a4 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.Footer), {
                lang: lang,
                settings: settings
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","moment":"1e4qG","../../helpers/Print":"f3loA","../../helpers/Invoice":"jffQW","../../helpers/Translation":"19Xlw","./Common":"8GVuQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g9BKl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API_URL", ()=>API_URL);
parcelHelpers.export(exports, "WS_CHANGES_URL", ()=>WS_CHANGES_URL);
parcelHelpers.export(exports, "WS_PRINT_URL", ()=>WS_PRINT_URL);
parcelHelpers.export(exports, "ENVIRONMENT", ()=>ENVIRONMENT);
parcelHelpers.export(exports, "HONEY_BADGER_API_KEY", ()=>HONEY_BADGER_API_KEY);
parcelHelpers.export(exports, "HONEY_BADGER_REVISION", ()=>HONEY_BADGER_REVISION);
const API_URL = "https://{client}.api.assistpro.eu/";
const WS_CHANGES_URL = "wss://ws.assistpro.eu:9997/changes";
const WS_PRINT_URL = "ws://127.0.0.1:9998/Print";
const ENVIRONMENT = "production";
const HONEY_BADGER_API_KEY = "7cf74bdb";
const HONEY_BADGER_REVISION = "2026-10-25T08:22:05.428Z";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e9soj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _appSlice = require("../slices/AppSlice");
var _localStorageHelper = require("../helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
class LabelPrinterWatcher extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            current_item: null
        };
        this.init = this.init.bind(this);
        this.cleanup = this.cleanup.bind(this);
        this.processQueue = this.processQueue.bind(this);
    }
    componentWillUnmount() {
        this.cleanup();
    }
    async init() {
        console.log('init label print');
        // wait to allow the whole app to load
        await new Promise((r)=>setTimeout(r, 3000));
        dymo.label.framework.init();
        const env = dymo.label.framework.checkEnvironment();
        console.log({
            env
        });
        // wait for 2 seconds before fetching printers
        // why 2 seconds? not sure, maybe 1 second is enough
        // probably has to do with waiting for init to do its stuff
        await new Promise((r)=>setTimeout(r, 2000));
        const printers = dymo.label.framework.getPrinters();
        console.log({
            printers
        });
        this.props.setLabelPrinters(printers.map((x)=>x.name));
        this.props.setLabelPrinterConnectedStatus(true);
        this.processQueue();
    }
    cleanup() {
        this.props.setLabelPrinterConnectedStatus(false);
    }
    componentDidUpdate(prevProps) {
        //if (this.props.ws_print_url != prevProps.ws_print_url) {
        //	this.cleanup();
        //	this.ws = this.init();
        //}
        console.log(JSON.stringify(this.props.label_printer_queue));
        if (this.props.label_printer_queue != prevProps.label_printer_queue) this.processQueue();
    }
    componentDidMount() {
        this.init();
    }
    async processQueue() {
        console.log('processQueue: queue length is ' + this.props.label_printer_queue.length);
        if (this.state.current_item !== null || this.props.label_printer_queue.length == 0) return;
        const printer_name = (0, _localStorageHelperDefault.default).GetValue(this.props.client + '__label_printer_name');
        if (printer_name === undefined || printer_name === null || printer_name.length == 0) return;
        let item_data = this.props.label_printer_queue[0];
        console.log({
            item_data
        });
        this.setState({
            current_item: item_data
        });
        if (item_data.type == 'item') {
            const label_contents = atob(this.props.general_settings.label_printer_item_template);
            const label = dymo.label.framework.openLabelXml(label_contents.trim().replace("\xef\xbb\xbf", '').replaceAll('{INTERNAL_CODE}', item_data.item.item.internal_code).replaceAll('{EAN}', item_data.item.item.ean).replaceAll('{NAME}', item_data.item.item.title).replaceAll('{PRICE}', parseFloat(item_data.item.price).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })));
            label.print(printer_name);
        } else if (item_data.type == 'person') {
            const label_contents = atob(this.props.general_settings.label_printer_person_template);
            console.log({
                item_data
            });
            const label = dymo.label.framework.openLabelXml(label_contents.trim().replace("\xef\xbb\xbf", '').replaceAll('{NAME}', item_data.item.item.type == 'natural' ? item_data.item.item.surname + ' ' + item_data.item.item.name : item_data.item.item.company_name).replaceAll('{ADDRESS}', item_data.item.item.address.trim()).replaceAll('{POST_CODE}', item_data.item.item.post_code.trim()).replaceAll('{POST_OFFICE}', item_data.item.item.post_office.trim()).replaceAll('{COUNTRY}', this.props.countries[item_data.item.item.id_country] === undefined ? '' : this.props.countries[item_data.item.item.id_country].official_name_local));
            label.print(printer_name);
        }
        this.props.removeItemFromLabelPrinterQueue();
        this.setState({
            current_item: null
        });
    }
    render() {
        return null;
    }
}
exports.default = (0, _reactRedux.connect)((state)=>{
    return {
        api_url: state.ConstantsSlice.api_url,
        ws_print_url: state.ConstantsSlice.ws_print_url,
        client: state.ConstantsSlice.client,
        label_printer_queue: state.AppSlice.label_printer_queue,
        general_settings: state.SettingsSlice.general,
        users: state.UserSlice.users,
        token: state.UserSlice.token,
        countries: state.CodeTablesSlice.countries
    };
}, (dispatch)=>{
    return {
        dispatch,
        setLabelPrinterConnectedStatus: (connected)=>dispatch((0, _appSlice.setLabelPrinterConnectedStatus)({
                connected
            })),
        enqueueItemOnLabelPrinterQueue: (data)=>dispatch((0, _appSlice.enqueueItemOnLabelPrinterQueue)(data)),
        requeueItemOnLabelPrinterQueue: (data)=>dispatch((0, _appSlice.requeueItemOnLabelPrinterQueue)(data)),
        removeItemFromLabelPrinterQueue: (data)=>dispatch((0, _appSlice.removeItemFromLabelPrinterQueue)(data)),
        setLabelPrinters: (data)=>dispatch((0, _appSlice.setLabelPrinters)({
                printers: data
            }))
    };
})(LabelPrinterWatcher);

},{"react":"9njXz","react-redux":"5DyKE","moment":"1e4qG","../slices/AppSlice":"aByTQ","../helpers/LocalStorageHelper":"9I9tm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4w2Vj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@blueprintjs/core");
var _localStorageHelper = require("../helpers/LocalStorageHelper");
var _localStorageHelperDefault = parcelHelpers.interopDefault(_localStorageHelper);
var _resultComponents = require("./code_tables/ResultComponents");
function Results(props) {
    const { log } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "results mt-4 mb-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "results-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 1,
                        title: "\u010Cas"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 2,
                        title: "AssistPRO latency"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 3,
                        title: "AssistPRO status"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 4,
                        title: "AssistPRO napaka"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 5,
                        title: "Drug stre\u017Enik latency"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 6,
                        title: "Drug stre\u017Enik status"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                        columnIdx: 7,
                        title: "Drug stre\u017Enik napaka"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results-table",
                children: log.map((item)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 1,
                                child: item.ts
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 2,
                                child: item.assistpro_latency + ' ms'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 3,
                                child: item.assistpro_status
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 4,
                                child: item.assistpro_error_message
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 5,
                                child: item.other_latency + ' ms'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 6,
                                child: item.other_status
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                columnIdx: 7,
                                child: item.other_error_message
                            })
                        ]
                    }, item.ts);
                })
            })
        ]
    });
}
class HealthLog extends (0, _react.Component) {
    constructor(props){
        super(props);
    }
    render() {
        let log_str = (0, _localStorageHelperDefault.default).GetValue('health_log');
        if (log_str === null || log_str === undefined) log_str = '[]';
        let log = JSON.parse(log_str);
        log = log.slice(-5000);
        log.reverse();
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col flex-grow health-log-list",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-1 pl-4 pr-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-grow overflow-y-auto",
                        style: {
                            flexBasis: '0'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                            log: log
                        })
                    })
                })
            })
        });
    }
}
HealthLog.propTypes = {};
function mapStateToProps(state) {
    return {};
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(HealthLog);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","@blueprintjs/core":"6Mq52","../helpers/LocalStorageHelper":"9I9tm","./code_tables/ResultComponents":"1eVlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imQtD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _core = require("@blueprintjs/core");
var _datetime2 = require("@blueprintjs/datetime2");
/*import { deleteInvoice } from '../../slices/BusinessSlice';
import {
	deleteInvoice as apiDeleteInvoice,
	fiscallyVerifyInvoices,
	increaseInvoicePrintCount,
	loadInvoiceFiscalVerificationsByIds,
} from '../../api/Business';*/ var _reservationSlice = require("../../slices/ReservationSlice");
var _reservations = require("../../api/Reservations");
var _reservation = require("../reservations/Reservation");
var _reservationDefault = parcelHelpers.interopDefault(_reservation);
var _documentSlice = require("../../slices/DocumentSlice");
var _documents = require("../../api/Documents");
var _resultComponents = require("../code_tables/ResultComponents");
var _peopleCountInput = require("../reservations/PeopleCountInput");
var _peopleCountInputDefault = parcelHelpers.interopDefault(_peopleCountInput);
var _utils = require("./Utils");
var _reservationHelper = require("../../helpers/ReservationHelper");
var _reservationHelperDefault = parcelHelpers.interopDefault(_reservationHelper);
var _utils1 = require("../../utils");
function Results(props) {
    const { table_items, table_items_sort_ids, table_items_sort_field, table_items_sort_direction, setTableItemsSort, openAddEditItemDialog, tableItemsFilters, originalTableItemsFilters, handleFilterChange, table_items_checked_ids, rowCheckStateChanged, allRowsCheckStateChanged, customers, countries, calculateDayCount, getAccommodationTitle, general_settings, openQuickEditCheckInOutDialog, openQuickEditPeopleDialog, reservation_request_accommodations, getCustomerInfo, public_accommodation_places } = props;
    const sort_props = {
        setTableItemsSort: setTableItemsSort,
        tableItemsSortField: table_items_sort_field,
        tableItemsSortDirection: table_items_sort_direction
    };
    const check_count = table_items_sort_ids.filter((id)=>table_items_checked_ids[id] === true).length;
    const all_checked = table_items_sort_ids.length == check_count;
    const statuses = {
        'new': {
            ord: 1,
            visible: true,
            key: 'new',
            title: 'Novo'
        },
        'processed': {
            ord: 2,
            visible: true,
            key: 'processed',
            title: 'Obdelano'
        },
        'confirmed': {
            ord: 3,
            visible: true,
            key: 'confirmed',
            title: 'Potrjeno'
        },
        'closed': {
            ord: 4,
            visible: true,
            key: 'closed',
            title: 'Zaprto'
        },
        'canceled': {
            ord: 5,
            visible: true,
            key: 'canceled',
            title: 'Stornirano'
        }
    };
    const items_by_ids = {};
    for(let type in reservation_request_accommodations)for(let id in reservation_request_accommodations[type].accommodation_items)items_by_ids[id] = reservation_request_accommodations[type].accommodation_items[id];
    let group = 0;
    let prev_internal_code = null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results mt-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table overflow-y-scroll sticky-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 1,
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                checked: check_count > 0,
                                indeterminate: !all_checked && check_count > 0,
                                onChange: (event)=>allRowsCheckStateChanged(event.target.checked)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 2,
                            ...sort_props,
                            title: "\u0160ifra",
                            fieldName: "internal_code"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 3,
                            title: "Vrsta namestitve"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 4,
                            title: "Prihod - odhod (dnevi)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 5,
                            title: "Nosilec povpra\u0161evanja"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 6,
                            title: "Osebe"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 7,
                            ...sort_props,
                            title: "Znesek",
                            fieldName: "amount"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 8,
                            title: "Status"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 9,
                            title: "Storitve"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeader), {
                            columnIdx: 10,
                            title: "Opomba"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.ResultHeaderWithSort), {
                            columnIdx: 11,
                            ...sort_props,
                            title: "Datum prejema",
                            fieldName: "created"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 1,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 2,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.internal_code,
                                onChange: (event)=>handleFilterChange('internal_code', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 3,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 4,
                            cls: "filters-col",
                            child: null
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 5,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.TextFilter), {
                                value: tableItemsFilters.customer,
                                onChange: (event)=>handleFilterChange('customer', event)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 6,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 7,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 8,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.MultiSelectFilter), {
                                    empty_title: "Izberi",
                                    value_field: "key",
                                    title_field: "title",
                                    items: statuses,
                                    filtered_keys: tableItemsFilters.statuses,
                                    displayFilter: (x)=>x.visible,
                                    displaySort: (a, b)=>a.ord - b.ord,
                                    onFilterChange: (values)=>handleFilterChange('statuses', values)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 9,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 10,
                            cls: "filters-col"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            columnIdx: 11,
                            cls: "filters-col",
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.DateRangeFilter), {
                                filter_values: tableItemsFilters.created,
                                original_start_date: originalTableItemsFilters.created[0],
                                original_end_date: originalTableItemsFilters.created[1],
                                onFilterChange: (values)=>handleFilterChange('created', values),
                                short_year: true
                            }),
                            ...sort_props
                        }),
                        table_items_sort_ids.map((id, idx)=>{
                            const item = table_items[id];
                            let reservation_status_for_coloring = item.status;
                            if (item.status == 'canceled') reservation_status_for_coloring = 'reversed';
                            let cls = '';
                            cls += 'status-' + reservation_status_for_coloring;
                            let customer_info = getCustomerInfo(item, general_settings, countries, customers);
                            customer_info = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: customer_info
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: 'T: '
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: item.customer_phone + ' '
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    paddingLeft: 16
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                    children: 'E: '
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: 'mailto:' + item.customer_email,
                                                children: item.customer_email
                                            })
                                        ]
                                    })
                                ]
                            });
                            let accommodation = null;
                            if (item.id_public_accommodation_place !== null) accommodation = public_accommodation_places[item.id_public_accommodation_place];
                            else for(let key in reservation_request_accommodations){
                                const acc = reservation_request_accommodations[key].accommodation_items[item.id_accommodation_item_place_raw];
                                if (acc !== undefined) {
                                    accommodation = acc;
                                    break;
                                }
                            }
                            let services_info = null;
                            if (accommodation !== null) {
                                const services_html = (0, _utils.getReservationRequestItemServices)(item, accommodation, 'services', true);
                                const additional_services_html = (0, _utils.getReservationRequestItemServices)(item, accommodation, 'additional_services', true);
                                services_info = [];
                                if (services_html !== null) services_info.push(services_html);
                                if (additional_services_html !== null) services_info.push(additional_services_html);
                            }
                            // figure out group coloring
                            const next_id = idx + 1 == table_items_sort_ids.length ? null : table_items_sort_ids[idx + 1];
                            const next_item = next_id === null ? null : table_items[next_id];
                            // last item
                            if (next_item === null) {
                                if (prev_internal_code !== null && prev_internal_code !== item.internal_code) group = 0;
                            } else {
                                // first item, in same group as next item
                                if (prev_internal_code === null && next_item.internal_code === item.internal_code) group++;
                                else if (prev_internal_code !== item.internal_code && next_item.internal_code === item.internal_code) group = group == 1 ? 2 : 1;
                                else if (prev_internal_code !== item.internal_code && next_item.internal_code !== item.internal_code) group = 0;
                            }
                            prev_internal_code = item.internal_code;
                            cls += ' group-' + group;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 1,
                                        cls: cls,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Checkbox), {
                                            checked: table_items_checked_ids[id] === true,
                                            onChange: (event)=>rowCheckStateChanged(id, event.target.checked)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 2,
                                        cls: cls,
                                        child: item.internal_code
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 3,
                                        cls: cls,
                                        child: getAccommodationTitle(item)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 4,
                                        cls: cls,
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "quick-edit-check-in-out",
                                            onClick: ()=>openQuickEditCheckInOutDialog(item.id_reservation_request),
                                            children: (0, _momentDefault.default)(item.check_in).format('DD.MM.YYYY') + ' - ' + (0, _momentDefault.default)(item.check_out).format('DD.MM.YYYY') + ' (' + calculateDayCount(item) + ')'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 5,
                                        cls: cls + ' customer-info',
                                        child: customer_info
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 6,
                                        cls: cls + ' person-count text-right',
                                        child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "quick-edit-person-count",
                                            onClick: ()=>openQuickEditPeopleDialog(item.id_reservation_request),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: item.guest_adult_count + item.guest_child_2_count + item.guest_child_1_count
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: ' (' + [
                                                        item.guest_adult_count,
                                                        item.guest_child_2_count,
                                                        item.guest_child_1_count
                                                    ].join(' / ') + ')'
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 7,
                                        cls: cls + ' text-right',
                                        child: item.total_amount.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) + ' EUR'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 8,
                                        cls: cls,
                                        child: statuses[item.status].title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 9,
                                        cls: cls + ' note text-center',
                                        child: services_info === null || services_info.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                            content: services_info,
                                            position: "left",
                                            popoverClassName: "reservation-requests-list--tooltip-note",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                icon: "comment"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 10,
                                        cls: cls + ' note text-center',
                                        child: item.customer_note === null || item.customer_note.length == 0 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tooltip), {
                                            content: item.customer_note,
                                            position: "left",
                                            popoverClassName: "reservation-requests-list--tooltip-note",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Icon), {
                                                icon: "comment"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                                        columnIdx: 11,
                                        cls: cls,
                                        child: (0, _momentDefault.default)(item.created).format('DD. MM. YYYY HH:mm:ss')
                                    })
                                ]
                            }, 'result--result-' + id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "results borderless mb-4 pr-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "results-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            cls: "sum",
                            columnIdx: 1,
                            span: 3,
                            child: "\u0160tevilo zapisov: " + table_items_sort_ids.length
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            cls: "sum",
                            columnIdx: 4,
                            child: null
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            cls: "sum",
                            columnIdx: 5,
                            child: null
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            cls: "sum text-right",
                            columnIdx: 6,
                            child: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-bold",
                                        children: table_items_sort_ids.map((id, idx)=>table_items[id].guest_adult_count + table_items[id].guest_child_2_count + table_items[id].guest_child_1_count).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: ' (' + table_items_sort_ids.map((id, idx)=>table_items[id].guest_adult_count).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        }) + ' / ' + table_items_sort_ids.map((id, idx)=>table_items[id].guest_child_2_count).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        }) + ' / ' + table_items_sort_ids.map((id, idx)=>table_items[id].guest_child_1_count).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        }) + ')'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            cls: "sum font-bold text-right",
                            columnIdx: 7,
                            child: table_items_sort_ids.map((id, idx)=>table_items[id].total_amount).reduce((acc, val)=>acc + val, 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) + ' EUR'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            cls: "sum",
                            columnIdx: 8,
                            child: null
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            cls: "sum",
                            columnIdx: 9,
                            child: null
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            cls: "sum",
                            columnIdx: 10,
                            child: null
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultComponents.Result), {
                            cls: "sum",
                            columnIdx: 11,
                            child: null
                        })
                    ]
                })
            })
        ]
    });
}
function AccommodationSelectorDialog(props) {
    const { isOpen, onClose, accommodations, accommodation_items, accommodation_item_places, reservation_request, reservations, public_accommodation_place } = props;
    const acc_items = Object.values(accommodation_items); //.filter(x => x.id_accommodation == '6c2fd01c-f8d1-4061-97bd-6820408122aa');
    const acc_item_places = Object.values(accommodation_item_places);
    const [expandedIds, setExpandedIds] = (0, _react.useState)(acc_items.map((item)=>item.id_accommodation_item));
    const toggleExpanded = (id, expand)=>{
        if (expand === undefined) {
            const idx = expandedIds.indexOf(id);
            expand = idx === -1;
        }
        if (expand) setExpandedIds([
            ...expandedIds,
            id
        ]);
        else {
            const idx = expandedIds.indexOf(id);
            if (idx === -1) return;
            let items = [
                ...expandedIds
            ];
            items.splice(idx, 1);
            setExpandedIds(items);
        }
    };
    const reservations_by_id_accommodation_item_place = {};
    for(let id_reservation in reservations){
        const reservation = reservations[id_reservation];
        if (reservations_by_id_accommodation_item_place[reservation.id_accommodation_item_place] === undefined) reservations_by_id_accommodation_item_place[reservation.id_accommodation_item_place] = [];
        reservations_by_id_accommodation_item_place[reservation.id_accommodation_item_place].push(reservation);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
        isOpen: isOpen,
        onClose: ()=>onClose(null),
        className: "reservation-requests-list--accommodation-selector-dialog",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col flex-grow",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                    fixedToTop: false,
                    className: "bp5-dark",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                children: "Izbor"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                            align: (0, _core.Alignment).RIGHT,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                minimal: true,
                                icon: "cross",
                                onClick: ()=>onClose(null)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _core.Classes).DIALOG_BODY,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex flex-row content-start justify-between overflow-y-scroll",
                        children: !isOpen ? null : acc_items.sort((a, b)=>a.ord - b.ord).map((item)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Tree), {
                                    className: "tree-top-node",
                                    contents: [
                                        {
                                            id: item.id_accommodation_item,
                                            icon: expandedIds.indexOf(item.id_accommodation_item) !== -1 ? 'folder-open' : 'folder-close',
                                            label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: accommodations[item.id_accommodation].title
                                                    }),
                                                    item.title == 'default' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: item.title
                                                    })
                                                ]
                                            }),
                                            hasCaret: false,
                                            isExpanded: expandedIds.indexOf(item.id_accommodation_item) !== -1,
                                            childNodes: acc_item_places.filter((x)=>x.id_accommodation_item == item.id_accommodation_item).sort((a, b)=>a.ord - b.ord).map((subitem)=>{
                                                const accommodation_item_place = accommodation_item_places[subitem.id_accommodation_item_place];
                                                const is_same_type = public_accommodation_place === null ? // old way
                                                reservation_request.id_accommodation_item_place_raw == 'camp-motorhome' && accommodation_item_place.tags.indexOf('online-for-motorhome') !== -1 || reservation_request.id_accommodation_item_place_raw == 'camp-tent' && accommodation_item_place.tags.indexOf('online-for-tent') !== -1 || reservation_request.id_accommodation_item_place_raw == 'camp-caravan' && accommodation_item_place.tags.indexOf('online-for-caravan') !== -1 : // new way
                                                public_accommodation_place.accommodation_tag == 'online-for-motorhome' && accommodation_item_place.tags.indexOf('online-for-motorhome') !== -1 || public_accommodation_place.accommodation_tag == 'online-for-tent' && accommodation_item_place.tags.indexOf('online-for-tent') !== -1 || public_accommodation_place.accommodation_tag == 'online-for-caravan' && accommodation_item_place.tags.indexOf('online-for-caravan') !== -1;
                                                const overlapping_reservation = (0, _reservationHelperDefault.default).FindOverlappingReservation({
                                                    id_reservation: -1,
                                                    id_accommodation_item_place: subitem.id_accommodation_item_place,
                                                    check_in: reservation_request.check_in,
                                                    check_out: reservation_request.check_out
                                                }, reservations_by_id_accommodation_item_place[subitem.id_accommodation_item_place] ?? []);
                                                return {
                                                    id: subitem.id_accommodation_item_place,
                                                    icon: null,
                                                    label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: 'text-white text-center pt-1 pb-1 ' + (overlapping_reservation === null ? !is_same_type ? 'bg-blue-500' : 'bg-green-500' : 'bg-red-600'),
                                                        children: subitem.title
                                                    })
                                                };
                                            })
                                        }
                                    ],
                                    onNodeClick: (item, path)=>{
                                        if (path.length == 1) toggleExpanded(item.id);
                                        else if (path.length == 2) onClose(item.id);
                                    },
                                    onNodeCollapse: (item)=>toggleExpanded(item.id, false),
                                    onNodeExpand: (item)=>toggleExpanded(item.id, true)
                                })
                            }, 'item-' + item.id_accommodation_item);
                        })
                    })
                })
            ]
        })
    });
}
class ReservationRequestsList extends (0, _react.Component) {
    constructor(props){
        super(props);
        this._ismounted = false;
        this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
        this.setTableItemsSort = this.setTableItemsSort.bind(this);
        this.refreshTableItemsSort = this.refreshTableItemsSort.bind(this);
        this.filterTableItems = this.filterTableItems.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.calculateDayCount = this.calculateDayCount.bind(this);
        this.getAccommodationTitle = this.getAccommodationTitle.bind(this);
        this.changeStatus = this.changeStatus.bind(this);
        this.openReservationDialog = this.openReservationDialog.bind(this);
        this.closeReservationDialog = this.closeReservationDialog.bind(this);
        this.delReservation = this.delReservation.bind(this);
        this.confirmReservationRequest = this.confirmReservationRequest.bind(this);
        this.cancelReservationRequest = this.cancelReservationRequest.bind(this);
        this.askCancelReservationRequest = this.askCancelReservationRequest.bind(this);
        this.openQuickEditCheckInOutDialog = this.openQuickEditCheckInOutDialog.bind(this);
        this.closeQuickEditCheckInOutDialog = this.closeQuickEditCheckInOutDialog.bind(this);
        this.openQuickEditPeopleDialog = this.openQuickEditPeopleDialog.bind(this);
        this.closeQuickEditPeopleDialog = this.closeQuickEditPeopleDialog.bind(this);
        this.openAccommodationSelectionDialog = this.openAccommodationSelectionDialog.bind(this);
        this.closeAccommodationSelectionDialog = this.closeAccommodationSelectionDialog.bind(this);
        this.openSelectNewStatusDialog = this.openSelectNewStatusDialog.bind(this);
        this.closeSelectNewStatusDialog = this.closeSelectNewStatusDialog.bind(this);
        this.clearSelection = this.clearSelection.bind(this);
        this.openReviewReservationRequestConfirmationDialog = this.openReviewReservationRequestConfirmationDialog.bind(this);
        this.closeReviewReservationRequestConfirmationDialog = this.closeReviewReservationRequestConfirmationDialog.bind(this);
        this.openReviewReservationCancellationDialog = this.openReviewReservationCancellationDialog.bind(this);
        this.closeReviewReservationCancellationDialog = this.closeReviewReservationCancellationDialog.bind(this);
        this.openReviewReservationAskCancellationDialog = this.openReviewReservationAskCancellationDialog.bind(this);
        this.closeReviewReservationAskCancellationDialog = this.closeReviewReservationAskCancellationDialog.bind(this);
        this.calculatePublicAccommodationPlaces = this.calculatePublicAccommodationPlaces.bind(this);
        this.openCreateReservationDialog = this.openCreateReservationDialog.bind(this);
        const table_items_filters = {
            internal_code: '',
            accommodation: '',
            check_in_out: [
                null,
                null
            ],
            customer: '',
            statuses: [],
            created: [
                (0, _momentDefault.default)().subtract(3, 'days').toDate(),
                null
            ]
        };
        const { table_items, table_items_sort_ids, table_items_filtered_ids } = this.updateTableItemsFromProps(props, {
            table_items_filters,
            table_items_sort_field: 'internal_code',
            table_items_sort_direction: 'DESC'
        });
        console.log({
            table_items_sort_ids
        });
        this.state = {
            table_items,
            table_items_sort_ids,
            table_items_filtered_ids,
            table_items_sort_field: 'internal_code',
            table_items_sort_direction: 'DESC',
            table_items_filters,
            original_table_items_filters: {
                ...table_items_filters
            },
            table_items_checked_ids: {},
            button_confirm_loading: false,
            reservation_dialog_open: false,
            current_reservation: null,
            current_id_reservation_request: null,
            quick_edit_check_in_out_id_reservation_request: null,
            quick_edit_check_in_out_check_in: null,
            quick_edit_check_in_out_check_out: null,
            quick_edit_people_id_reservation_request: null,
            quick_edit_people_adult: null,
            quick_edit_people_child_1: null,
            quick_edit_people_child_2: null,
            accommodation_selection_dialog_open: false,
            accommodation_selection_dialog_id: null,
            accommodation_selection_dialog_public_accommodation_place: null,
            select_new_status_dialog_open: false,
            review_reservation_request_confirmation_dialog_open: false,
            review_reservation_request_confirmation_dialog_with_prepayment: false,
            review_reservation_request_confirmation_dialog_text: false,
            review_reservation_cancellation_dialog_open: false,
            review_reservation_cancellation_dialog_text: false,
            review_reservation_ask_cancellation_dialog_open: false,
            review_reservation_ask_cancellation_dialog_text: false,
            public_accommodation_places: this.calculatePublicAccommodationPlaces()
        };
    }
    componentDidMount() {
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.reservation_requests != prevProps.reservation_requests) this.setState(this.updateTableItemsFromProps(this.props, this.state));
        if (this.props.public_accommodations != prevProps.public_accommodations) this.setState({
            public_accommodation_places: this.calculatePublicAccommodationPlaces()
        });
    }
    calculatePublicAccommodationPlaces() {
        const public_accommodation_places = {};
        for(let group in this.props.public_accommodations)for(let id_accommodation_item in this.props.public_accommodations[group].accommodation_items)public_accommodation_places[id_accommodation_item] = this.props.public_accommodations[group].accommodation_items[id_accommodation_item];
        return public_accommodation_places;
    }
    updateTableItemsFromProps(props, state) {
        const filtered_items = {};
        for(let id_reservation_request in props.reservation_requests){
            const item = props.reservation_requests[id_reservation_request];
            filtered_items[item.id_reservation_request] = item;
        }
        const ids = Object.keys(filtered_items);
        let sort_ids = [];
        if (state !== undefined && state.table_items_sort_ids !== undefined) for(let i = 0; i < state.table_items_sort_ids.length; i++){
            const id = state.table_items_sort_ids[i];
            if (ids.indexOf(id) != -1) sort_ids.push(id);
        }
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            if (sort_ids.indexOf(id) == -1) sort_ids.push(id);
        }
        const new_state = {
            reservation_requests: props.reservation_requests,
            table_items: filtered_items,
            table_items_sort_ids: sort_ids,
            table_items_filtered_ids: ids,
            table_items_sort_field: state.table_items_sort_field,
            table_items_sort_direction: state.table_items_sort_direction
        };
        const { table_items_filtered_ids, table_items_filters, table_items_sort_ids } = this.filterTableItems(state.table_items_filters, new_state, true);
        new_state.table_items_filtered_ids = table_items_filtered_ids;
        new_state.table_items_filters = table_items_filters;
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    setTableItemsSort(field) {
        let direction = 'ASC';
        if (this.state.table_items_sort_field == field) direction = this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC';
        this.setState({
            table_items_sort_field: field,
            table_items_sort_direction: direction
        });
        this.refreshTableItemsSort(field, direction);
    }
    refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
        state = state || this.state;
        table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
        const ids = table_items_filtered_ids;
        ids.sort((a_key, b_key)=>{
            let a = '';
            let b = '';
            let dir = direction;
            /*if (state.table_items[a_key].draft != state.table_items[b_key].draft) {
				a = state.table_items[a_key].draft;
				b = state.table_items[b_key].draft;
				dir = 'DESC';
			}
			else if (field == 'id_customer') {
				const customer_a = this.props.customers[state.table_items[a_key].id_customer];
				const customer_b = this.props.customers[state.table_items[b_key].id_customer];
				
				if (customer_a === undefined && customer_b === undefined) {
					a = 0;
					b = 0;
				}
				else {
					a = customer_a === undefined ? '' : (customer_a.name + ' ' + customer_a.surname);
					b = customer_b === undefined ? '' : (customer_b.name + ' ' + customer_b.surname);
					
					return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
				}
			}
			else if (field == 'username') {
				a = state.table_items[a_key][field];
				b = state.table_items[b_key][field];
				
				return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
			}
			else if (field == 'customer_internal_code') {
				const customer_a = this.props.customers[state.table_items[a_key].id_customer];
				const customer_b = this.props.customers[state.table_items[b_key].id_customer];
				
				if (customer_a === undefined && customer_b === undefined) {
					a = 0;
					b = 0;
				}
				else {
					a = customer_a === undefined ? 0 : customer_a.internal_code;
					b = customer_b === undefined ? 0 : customer_b.internal_code;
				}
			}
			else if (field == 'cash_register_internal_code') {
				const cash_register_a = this.props.cash_registers[state.table_items[a_key].id_cash_register];
				const cash_register_b = this.props.cash_registers[state.table_items[b_key].id_cash_register];
				
				if (cash_register_a === undefined && cash_register_b === undefined) {
					a = 0;
					b = 0;
				}
				else {
					a = cash_register_a === undefined ? 0 : cash_register_a.internal_code;
					b = cash_register_b === undefined ? 0 : cash_register_b.internal_code;
				}
			}*/ if (field == 'amount') {
                a = state.table_items[a_key].total_amount;
                b = state.table_items[b_key].total_amount;
            } else {
                a = state.table_items[a_key][field];
                b = state.table_items[b_key][field];
            }
            return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
        });
        const new_state = {
            table_items_sort_ids: ids
        };
        if (!return_only) this.setState(new_state);
        return new_state;
    }
    toIsoString(date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    }
    filterTableItems(filters, state, return_only) {
        state = state || this.state;
        const filters_internal_code = filters.internal_code.toUpperCase();
        const filters_accommodation = filters.accommodation.toUpperCase();
        const filters_check_in_out_start = filters.check_in_out[0] === null ? null : this.toIsoString(filters.check_in_out[0]);
        const filters_check_in_out_end = filters.check_in_out[1] === null ? null : this.toIsoString(filters.check_in_out[1]);
        const filters_customer = filters.customer.toUpperCase();
        const filters_statuses = filters.statuses;
        const filters_created_start = filters.created[0] === null ? null : this.toIsoString(filters.created[0]);
        const filters_created_end = filters.created[1] === null ? null : this.toIsoString(filters.created[1]);
        const ids = Object.keys(state.table_items);
        const filtered_ids = ids.filter((id)=>{
            const item = state.table_items[id];
            if (filters_internal_code != '' && item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) return false;
            if (filters_statuses.length > 0) {
                if (filters_statuses.indexOf(item.status) == -1) return false;
            }
            if (filters_created_start !== null && (0, _momentDefault.default)(item.created).format('YYYY-MM-DD') < filters_created_start) return false;
            if (filters_created_end !== null && (0, _momentDefault.default)(item.created).format('YYYY-MM-DD') > filters_created_end) return false;
            if (filters_customer.length > 0 && (item.customer_name + ' ' + item.customer_surname).toUpperCase().indexOf(filters_customer) == -1) return false;
            return true;
        });
        const new_state = {
            table_items_filtered_ids: filtered_ids,
            table_items_filters: filters
        };
        if (!return_only) this.setState(new_state);
        const { table_items_sort_ids } = this.refreshTableItemsSort(state.table_items_sort_field, state.table_items_sort_direction, filtered_ids, {
            table_items_filtered_ids: new_state,
            table_items_filters: new_state,
            table_items: state.table_items
        }, return_only);
        new_state.table_items_sort_ids = table_items_sort_ids;
        return new_state;
    }
    handleFilterChange(field_name, event) {
        const new_filters = {
            internal_code: this.state.table_items_filters.internal_code,
            accommodation: this.state.table_items_filters.accommodation,
            check_in_out: this.state.table_items_filters.check_in_out,
            customer: this.state.table_items_filters.customer,
            statuses: this.state.table_items_filters.statuses,
            created: this.state.table_items_filters.created
        };
        let val = event;
        val;
        if (val instanceof Date) ;
        else if (Array.isArray(val)) ;
        else if (val instanceof Object) val = event.target.value;
        new_filters[field_name] = val;
        this.filterTableItems(new_filters);
    }
    calculateDayCount(item) {
        let count = 0;
        if (item.prices === null) return 0;
        for(let price_key in item.prices.main)for(let date_key in item.prices.main[price_key])count = Math.max(count, item.prices.main[price_key][date_key].day_count);
        return count;
    }
    getAccommodationTitle(item) {
        if (item.id_public_accommodation_place !== null && this.state.public_accommodation_places[item.id_public_accommodation_place] !== undefined) return this.state.public_accommodation_places[item.id_public_accommodation_place].title.sl;
        const titles = {
            'camp-tent': "Kampirno mesto - \u0161otor",
            'camp-motorhome': 'Kampirno mesto - avtodom',
            'camp-caravan': 'Kampirno mesto - kamp prikolica'
        };
        if ([
            'camp-tent',
            'camp-motorhome',
            'camp-caravan'
        ].indexOf(item.id_accommodation_item_place_raw) !== -1) return titles[item.id_accommodation_item_place_raw] ?? '';
        if (item.id_accommodation_item_place === null) return '';
        const accommodation_item_place = this.props.accommodation_item_places[item.id_accommodation_item_place];
        const accommodation_item = this.props.accommodation_items[accommodation_item_place.id_accommodation_item];
        const accommodation = this.props.accommodations[accommodation_item.id_accommodation];
        return accommodation.title + " \u2022 " + (accommodation_item.title == 'default' ? '' : accommodation_item.title + " \u2022 ") + accommodation_item_place.title;
    }
    async changeStatus(id_reservation_requests, status) {
        await (0, _reservations.changeReservationRequestStatus)(this.props.api_url, this.props.dispatch, this.props.token, id_reservation_requests, status);
    }
    async confirmReservationRequest(id_reservation_requests, prepayment, text) {
        await (0, _reservations.confirmReservationRequest)(this.props.api_url, this.props.dispatch, this.props.token, id_reservation_requests, prepayment, text);
    }
    async cancelReservationRequest(id_reservation_requests, text) {
        await (0, _reservations.cancelReservationRequest)(this.props.api_url, this.props.dispatch, this.props.token, id_reservation_requests, text);
    }
    async askCancelReservationRequest(id_reservation_requests, text) {
        await (0, _reservations.askCancelReservationRequest)(this.props.api_url, this.props.dispatch, this.props.token, id_reservation_requests, text);
    }
    openReservationDialog(id_reservation_request, id_accommodation_item_place) {
        const reservation_request = this.state.table_items[id_reservation_request];
        if (id_accommodation_item_place === undefined) id_accommodation_item_place = reservation_request.id_accommodation_item_place;
        let accommodation = null;
        if (reservation_request.id_public_accommodation_place !== null) accommodation = this.state.public_accommodation_places[reservation_request.id_public_accommodation_place];
        else for(let key in this.props.reservation_request_accommodations){
            const acc = this.props.reservation_request_accommodations[key].accommodation_items[reservation_request.id_accommodation_item_place_raw];
            if (acc !== undefined) {
                accommodation = acc;
                break;
            }
        }
        // if you change note generation, change it in PublicReservationsServiceProvider@postSaveReservation as well
        let note_items = [
            "Povpra\u0161evanje \u0161t. " + reservation_request.internal_code + '  ' + (0, _momentDefault.default)(reservation_request.check_in).format('DD.MM.YYYY') + '-' + (0, _momentDefault.default)(reservation_request.check_out).format('DD.MM.YYYY') + '  ' + (0, _momentDefault.default)(reservation_request.created).format('DD.MM.YYYY HH:mm:ss'),
            'Odrasli (' + this.props.general_settings.reservation_child_age_limit_2 + '+): ' + reservation_request.guest_adult_count + ' - Otroci (' + this.props.general_settings.reservation_child_age_limit_1 + '-' + this.props.general_settings.reservation_child_age_limit_2 + '): ' + reservation_request.guest_child_2_count + ' - Otroci (0-' + this.props.general_settings.reservation_child_age_limit_1 + '): ' + reservation_request.guest_child_1_count,
            ''
        ];
        if (accommodation !== null) {
            const services_text = (0, _utils.getReservationRequestItemServices)(reservation_request, accommodation, 'services', false);
            const additional_services_text = (0, _utils.getReservationRequestItemServices)(reservation_request, accommodation, 'additional_services', false);
            note_items.push(((services_text ?? '').trim() + '\n' + (additional_services_text ?? '').trim()).trim());
        }
        let payment_note = 'Znesek rezervacije: ' + reservation_request.total_amount.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + " \u20AC";
        if (this.props.public_accommodation_settings.prepayment_enabled) payment_note += "  Predpla\u010Dilo (30%): " + (reservation_request.total_amount * 0.3).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + " \u20AC";
        note_items.push(payment_note);
        if (reservation_request.customer_note.length > 0) {
            note_items.push('');
            note_items.push(reservation_request.customer_note.trim() + '\n');
        }
        this.setState({
            reservation_dialog_open: true,
            current_reservation: {
                id_reservation: -1,
                id_accommodation_item_place: id_accommodation_item_place,
                internal_code: '',
                id_customer: -1,
                check_in: reservation_request.check_in,
                check_out: reservation_request.check_out,
                guest_adult_count: reservation_request.guest_adult_count,
                guest_child_1_count: reservation_request.guest_child_1_count,
                guest_child_2_count: reservation_request.guest_child_2_count,
                note: note_items.filter((x)=>x !== null).join('\n'),
                status: 'new',
                status_2: null,
                id_channel: (Object.values(this.props.channels).find((x)=>x.internal_code == 'w') ?? {
                    id_channel: -1
                }).id_channel,
                custom_status: '',
                deleted: false,
                guests_checked_in: false,
                items: {}
            },
            current_id_reservation_request: id_reservation_request
        });
    }
    closeReservationDialog() {
        this.setState({
            reservation_dialog_open: false
        });
        this.clearSelection();
    }
    delReservation(id_reservation) {
        this.props.dispatch((0, _reservationSlice.deleteReservation)(id_reservation));
    }
    openQuickEditCheckInOutDialog(id_reservation_request) {
        const item = this.state.table_items[id_reservation_request];
        this.setState({
            quick_edit_check_in_out_id_reservation_request: id_reservation_request,
            quick_edit_check_in_out_check_in: item.check_in,
            quick_edit_check_in_out_check_out: item.check_out
        });
    }
    async closeQuickEditCheckInOutDialog(save) {
        if (save) {
            const item = {
                ...this.state.table_items[this.state.quick_edit_check_in_out_id_reservation_request],
                check_in: this.state.quick_edit_check_in_out_check_in,
                check_out: this.state.quick_edit_check_in_out_check_out
            };
            this.props.dispatch((0, _reservationSlice.addReservationRequest)({
                item
            }));
            await (0, _reservations.saveReservationRequest)(this.props.api_url, this.props.token, item);
        }
        this.setState({
            quick_edit_check_in_out_id_reservation_request: null
        });
    }
    openQuickEditPeopleDialog(id_reservation_request) {
        const item = this.state.table_items[id_reservation_request];
        this.setState({
            quick_edit_people_id_reservation_request: id_reservation_request,
            quick_edit_people_adult: item.guest_adult_count,
            quick_edit_people_child_1: item.guest_child_1_count,
            quick_edit_people_child_2: item.guest_child_2_count
        });
    }
    async closeQuickEditPeopleDialog(save) {
        if (save) {
            const item = {
                ...this.state.table_items[this.state.quick_edit_people_id_reservation_request],
                guest_adult_count: this.state.quick_edit_people_adult,
                guest_child_1_count: this.state.quick_edit_people_child_1,
                guest_child_2_count: this.state.quick_edit_people_child_2
            };
            this.props.dispatch((0, _reservationSlice.addReservationRequest)({
                item
            }));
            await (0, _reservations.saveReservationRequest)(this.props.api_url, this.props.token, item);
        }
        this.setState({
            quick_edit_people_id_reservation_request: null
        });
    }
    getMomentFormatter(format) {
        // note that locale argument comes from locale prop and may be undefined
        return {
            formatDate: (date, locale)=>(0, _momentDefault.default)(date).locale(locale).format(format)
        };
    }
    getMaxDate() {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 10);
        return date;
    }
    openAccommodationSelectionDialog(id, public_accommodation_place) {
        this.setState({
            accommodation_selection_dialog_open: true,
            accommodation_selection_dialog_id: id,
            accommodation_selection_dialog_public_accommodation_place: public_accommodation_place
        });
    }
    closeAccommodationSelectionDialog(id) {
        this.setState({
            accommodation_selection_dialog_open: false,
            accommodation_selection_dialog_public_accommodation_place: null
        });
        if (id !== null) this.openReservationDialog(this.state.accommodation_selection_dialog_id, id);
    }
    openSelectNewStatusDialog() {
        this.setState({
            select_new_status_dialog_open: true
        });
    }
    async closeSelectNewStatusDialog(status) {
        this.setState({
            select_new_status_dialog_open: false
        });
        if (status !== false) {
            const check_ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
            await this.changeStatus(check_ids, status);
        }
        this.clearSelection();
    }
    openReviewReservationRequestConfirmationDialog(with_prepayment) {
        this.setState({
            review_reservation_request_confirmation_dialog_open: true,
            review_reservation_request_confirmation_dialog_with_prepayment: with_prepayment,
            review_reservation_request_confirmation_dialog_text: ''
        });
    }
    async closeReviewReservationRequestConfirmationDialog(confirm) {
        this.setState({
            review_reservation_request_confirmation_dialog_open: false
        });
        if (confirm) {
            this.setState({
                button_confirm_loading: true
            });
            await this.confirmReservationRequest(this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true), this.state.review_reservation_request_confirmation_dialog_with_prepayment, this.state.review_reservation_request_confirmation_dialog_text);
            this.setState({
                button_confirm_loading: false
            });
        }
        this.clearSelection();
    }
    openReviewReservationCancellationDialog() {
        this.setState({
            review_reservation_cancellation_dialog_open: true,
            review_reservation_cancellation_dialog_text: ''
        });
    }
    async closeReviewReservationCancellationDialog(confirm) {
        this.setState({
            review_reservation_cancellation_dialog_open: false
        });
        if (confirm) {
            this.setState({
                button_confirm_loading: true
            });
            await this.cancelReservationRequest(this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true), this.state.review_reservation_cancellation_dialog_text);
            this.setState({
                button_confirm_loading: false
            });
        }
        this.clearSelection();
    }
    openReviewReservationAskCancellationDialog() {
        this.setState({
            review_reservation_ask_cancellation_dialog_open: true,
            review_reservation_ask_cancellation_dialog_text: ''
        });
    }
    async closeReviewReservationAskCancellationDialog(confirm) {
        this.setState({
            review_reservation_ask_cancellation_dialog_open: false
        });
        if (confirm) {
            this.setState({
                button_confirm_loading: true
            });
            await this.askCancelReservationRequest(this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true), this.state.review_reservation_ask_cancellation_dialog_text);
            this.setState({
                button_confirm_loading: false
            });
        }
        this.clearSelection();
    }
    clearSelection() {
        const table_items_checked_ids = {};
        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = false;
        this.setState({
            table_items_checked_ids
        });
    }
    getCustomerInfo(reservation, general_settings, countries, customers) {
        let customer_id_country = reservation.customer_id_country;
        let customer_name = reservation.customer_name;
        let customer_surname = reservation.customer_surname;
        if (customer_id_country === undefined) {
            const customer = customers[reservation.id_customer];
            customer_id_country = customer.id_country;
            customer_name = customer.name;
            customer_surname = customer.surname;
        }
        let customer_info = customer_name + ' ' + customer_surname + ' (' + countries[customer_id_country].iso_3166_1_a2 + ')';
        if (general_settings.scanner_change_case == 'uppercase') customer_info = customer_info.toUpperCase();
        if (general_settings.scanner_change_case == 'lowercase') customer_info = customer_info.toLowerCase();
        if (general_settings.scanner_change_case == 'title-case') // from https://stackoverflow.com/a/37931321
        customer_info = customer_info.replace(/\S+/g, (str)=>str.charAt(0).toUpperCase() + str.substr(1).toLowerCase());
        return customer_info;
    }
    openCreateReservationDialog() {
        const check_ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        if (this.state.table_items[check_ids[0]].id_public_accommodation_place !== null) {
            const public_accommodation_place = this.state.public_accommodation_places[this.state.table_items[check_ids[0]].id_public_accommodation_place];
            if (public_accommodation_place !== undefined && public_accommodation_place.accommodation_tag !== null) this.openAccommodationSelectionDialog(check_ids[0], public_accommodation_place);
            else this.openReservationDialog(check_ids[0]);
        } else if (this.state.table_items[check_ids[0]].id_accommodation_item_place !== null) this.openReservationDialog(check_ids[0]);
        else this.openAccommodationSelectionDialog(check_ids[0], null);
    }
    render() {
        const check_ids = this.state.table_items_sort_ids.filter((id)=>this.state.table_items_checked_ids[id] === true);
        const check_count = check_ids.length;
        const check_reservation_docs = check_ids.map((id)=>this.props.document_associations[id]);
        const all_check_reservation_ids_found = check_reservation_docs.every((x)=>x !== undefined);
        let initial_customer_query = null;
        if (this.state.reservation_dialog_open) {
            const reservation_request = this.state.table_items[this.state.current_id_reservation_request];
            initial_customer_query = {
                name: reservation_request.customer_name,
                surname: reservation_request.customer_surname,
                email: reservation_request.customer_email,
                id_country: reservation_request.customer_id_country,
                phone: reservation_request.customer_phone,
                post_office: reservation_request.customer_post_code_name,
                address: reservation_request.customer_address
            };
            if (this.props.general_settings.scanner_change_case == 'uppercase') {
                initial_customer_query.name = initial_customer_query.name.toUpperCase();
                initial_customer_query.surname = initial_customer_query.surname.toUpperCase();
            }
            if (this.props.general_settings.scanner_change_case == 'lowercase') {
                initial_customer_query.name = initial_customer_query.name.toLowerCase();
                initial_customer_query.surname = initial_customer_query.surname.toLowerCase();
            }
            if (this.props.general_settings.scanner_change_case == 'title-case') {
                // from https://stackoverflow.com/a/37931321
                initial_customer_query.name = initial_customer_query.name.replace(/\S+/g, (str)=>str.charAt(0).toUpperCase() + str.substr(1).toLowerCase());
                initial_customer_query.surname = initial_customer_query.surname.replace(/\S+/g, (str)=>str.charAt(0).toUpperCase() + str.substr(1).toLowerCase());
            }
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                !this.state.reservation_dialog_open ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reservationDefault.default), {
                    closeReservation: this.closeReservationDialog,
                    deleteReservation: this.delReservation,
                    reservation: this.state.current_reservation,
                    savedReservationCallback: async (reservation)=>{
                        if (this.state.current_id_reservation_request !== null) {
                            await this.changeStatus([
                                this.state.current_id_reservation_request
                            ], 'processed');
                            const item = {
                                id_document_association: (0, _uuidDefault.default).v4(),
                                source_id_document: reservation.id_reservation,
                                source_type: 'reservation',
                                target_id_document: this.state.current_id_reservation_request,
                                target_type: 'reservation-request'
                            };
                            const new_item = await (0, _documents.saveDocumentAssociation)(this.props.api_url, item, this.props.token);
                            if (new_item !== null) this.props.dispatch((0, _documentSlice.addDocumentAssociation)({
                                item: new_item,
                                token: this.props.token
                            }));
                        }
                    },
                    initial_customer_query: initial_customer_query
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: this.state.quick_edit_check_in_out_id_reservation_request !== null,
                    onClose: ()=>this.closeQuickEditCheckInOutDialog(false),
                    className: "dialog--note-popup-data",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                fixedToTop: false,
                                className: "bp5-dark",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: "Prihod - odhod"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        align: (0, _core.Alignment).RIGHT,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: ()=>this.closeQuickEditCheckInOutDialog(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_BODY,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datetime2.DateRangeInput3), {
                                    dateFnsLocaleLoader: (0, _utils1.loadDateFnsLocale),
                                    dateFnsFormat: 'dd. MM. yyyy',
                                    locale: "sl",
                                    allowSingleDayRange: true,
                                    contiguousCalendarMonths: false,
                                    shortcuts: false,
                                    startInputProps: {
                                        placeholder: 'Od',
                                        className: 'from-until'
                                    },
                                    endInputProps: {
                                        placeholder: 'Do',
                                        className: 'from-until'
                                    },
                                    minDate: new Date('1900-01-01'),
                                    maxDate: this.getMaxDate(),
                                    selectAllOnFocus: true,
                                    onChange: (selected_range)=>{
                                        this.setState({
                                            quick_edit_check_in_out_check_in: (0, _momentDefault.default)(selected_range[0]).toISOString(true),
                                            quick_edit_check_in_out_check_out: (0, _momentDefault.default)(selected_range[1]).toISOString(true)
                                        });
                                    },
                                    value: [
                                        (0, _momentDefault.default)(this.state.quick_edit_check_in_out_check_in).toDate(),
                                        (0, _momentDefault.default)(this.state.quick_edit_check_in_out_check_out).toDate()
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            onClick: ()=>this.closeQuickEditCheckInOutDialog(false),
                                            children: "Prekli\u010Di"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.closeQuickEditCheckInOutDialog(true),
                                            children: "Shrani"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: this.state.quick_edit_people_id_reservation_request !== null,
                    onClose: ()=>this.closeQuickEditPeopleDialog(false),
                    className: "dialog--note-popup-data",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                fixedToTop: false,
                                className: "bp5-dark",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: "Osebe"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        align: (0, _core.Alignment).RIGHT,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: ()=>this.closeQuickEditPeopleDialog(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_BODY,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-row content-start justify-between pt-3",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _peopleCountInputDefault.default), {
                                        adult_title: 'Odrasli',
                                        child_1_title: '0-' + this.props.general_settings.reservation_child_age_limit_1 + ' let',
                                        child_2_title: this.props.general_settings.reservation_child_age_limit_1 + '-' + this.props.general_settings.reservation_child_age_limit_2 + ' let',
                                        adult_count: this.state.quick_edit_people_adult,
                                        child_1_count: this.state.quick_edit_people_child_1,
                                        child_2_count: this.state.quick_edit_people_child_2,
                                        onChangeAdultCount: (val)=>{
                                            this.setState({
                                                quick_edit_people_adult: val
                                            });
                                        },
                                        onChangeChild1Count: (val)=>{
                                            this.setState({
                                                quick_edit_people_child_1: val
                                            });
                                        },
                                        onChangeChild2Count: (val)=>{
                                            this.setState({
                                                quick_edit_people_child_2: val
                                            });
                                        },
                                        disabled: false
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            onClick: ()=>this.closeQuickEditPeopleDialog(false),
                                            children: "Prekli\u010Di"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.closeQuickEditPeopleDialog(true),
                                            children: "Shrani"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccommodationSelectorDialog, {
                    isOpen: this.state.accommodation_selection_dialog_open,
                    onClose: this.closeAccommodationSelectionDialog,
                    accommodations: this.props.accommodations,
                    accommodation_items: this.props.accommodation_items,
                    accommodation_item_places: this.props.accommodation_item_places,
                    reservation_request: this.props.reservation_requests[this.state.accommodation_selection_dialog_id],
                    reservations: this.props.reservations,
                    public_accommodation_place: this.state.accommodation_selection_dialog_public_accommodation_place
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: this.state.select_new_status_dialog_open,
                    onClose: ()=>this.closeSelectNewStatusDialog(false),
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                fixedToTop: false,
                                className: "bp5-dark",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: "Sprememba statusa"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        align: (0, _core.Alignment).RIGHT,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: ()=>this.closeSelectNewStatusDialog(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_BODY,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-row content-start justify-between pt-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            onClick: ()=>this.closeSelectNewStatusDialog('new'),
                                            children: "Novo"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            onClick: ()=>this.closeSelectNewStatusDialog('processed'),
                                            children: "Obdelano"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            onClick: ()=>this.closeSelectNewStatusDialog('confirmed'),
                                            children: "Potrjeno"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            onClick: ()=>this.closeSelectNewStatusDialog('closed'),
                                            children: "Zaprto"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            onClick: ()=>this.closeSelectNewStatusDialog('canceled'),
                                            children: "Stornirano"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: this.state.review_reservation_request_confirmation_dialog_open,
                    onClose: ()=>this.closeReviewReservationRequestConfirmationDialog(false),
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                fixedToTop: false,
                                className: "bp5-dark",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: "Potrditev povpra\u0161evanj" + (this.state.review_reservation_request_confirmation_dialog_with_prepayment ? '' : " (brez predpla\u010Dila)")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        align: (0, _core.Alignment).RIGHT,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: ()=>this.closeReviewReservationRequestConfirmationDialog(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_BODY,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: "Potrdili boste naslednja povpra\u0161evanja:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: check_ids.map((id)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: this.state.table_items[id].internal_code + " \u2022 " + this.getCustomerInfo(this.state.table_items[id], this.props.general_settings, this.props.countries, this.props.customers)
                                                    }, id))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: "Dodatni tekst (neobvezno):"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                    className: "w-full",
                                                    growVertically: true,
                                                    large: true,
                                                    value: this.state.review_reservation_request_confirmation_dialog_text,
                                                    onChange: (event)=>this.setState({
                                                            review_reservation_request_confirmation_dialog_text: event.target.value
                                                        })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            onClick: ()=>this.closeReviewReservationRequestConfirmationDialog(false),
                                            children: "Prekli\u010Di"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.closeReviewReservationRequestConfirmationDialog(true),
                                            children: 'Potrdi' + (this.state.review_reservation_request_confirmation_dialog_with_prepayment ? '' : " brez predpla\u010Dila")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: this.state.review_reservation_cancellation_dialog_open,
                    onClose: ()=>this.closeReviewReservationCancellationDialog(false),
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                fixedToTop: false,
                                className: "bp5-dark",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: "Stornacija povpra\u0161evanj"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        align: (0, _core.Alignment).RIGHT,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: ()=>this.closeReviewReservationCancellationDialog(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_BODY,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: "Stornirali boste naslednja povpra\u0161evanja:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: check_ids.map((id)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: this.state.table_items[id].internal_code + " \u2022 " + this.getCustomerInfo(this.state.table_items[id], this.props.general_settings, this.props.countries, this.props.customers)
                                                    }, id))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: "Dodatni tekst (neobvezno):"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                    className: "w-full",
                                                    growVertically: true,
                                                    large: true,
                                                    value: this.state.review_reservation_cancellation_dialog_text,
                                                    onChange: (event)=>this.setState({
                                                            review_reservation_cancellation_dialog_text: event.target.value
                                                        })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            onClick: ()=>this.closeReviewReservationCancellationDialog(false),
                                            children: "Prekli\u010Di"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.closeReviewReservationCancellationDialog(true),
                                            children: "Potrdi"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Dialog), {
                    isOpen: this.state.review_reservation_ask_cancellation_dialog_open,
                    onClose: ()=>this.closeReviewReservationAskCancellationDialog(false),
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Navbar), {
                                fixedToTop: false,
                                className: "bp5-dark",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Heading, {
                                            children: "Vpra\u0161aj glede stornacije"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Navbar).Group, {
                                        align: (0, _core.Alignment).RIGHT,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            icon: "cross",
                                            onClick: ()=>this.closeReviewReservationAskCancellationDialog(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _core.Classes).DIALOG_BODY,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: "Poslali boste vpra\u0161anja glede naslednjih povpra\u0161evanj:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: check_ids.map((id)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: this.state.table_items[id].internal_code + " \u2022 " + this.getCustomerInfo(this.state.table_items[id], this.props.general_settings, this.props.countries, this.props.customers)
                                                    }, id))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: "Dodatni tekst (neobvezno):"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.TextArea), {
                                                    className: "w-full",
                                                    growVertically: true,
                                                    large: true,
                                                    value: this.state.review_reservation_ask_cancellation_dialog_text,
                                                    onChange: (event)=>this.setState({
                                                            review_reservation_ask_cancellation_dialog_text: event.target.value
                                                        })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _core.Classes).DIALOG_FOOTER,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _core.Classes).DIALOG_FOOTER_ACTIONS,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            minimal: true,
                                            onClick: ()=>this.closeReviewReservationAskCancellationDialog(false),
                                            children: "Prekli\u010Di"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: (0, _core.Intent).PRIMARY,
                                            onClick: ()=>this.closeReviewReservationAskCancellationDialog(true),
                                            children: "Potrdi"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col flex-grow reservation-requests-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pl-4 pt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "mr-2 align-middle",
                                    children: [
                                        !this.props.public_accommodation_settings.prepayment_enabled ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            disabled: check_count == 0,
                                            loading: this.state.button_confirm_loading,
                                            onClick: ()=>this.openReviewReservationRequestConfirmationDialog(true),
                                            children: "Potrdi povpra\u0161evanje"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "success",
                                            disabled: check_count == 0,
                                            loading: this.state.button_confirm_loading,
                                            onClick: ()=>this.openReviewReservationRequestConfirmationDialog(false),
                                            children: "Potrdi povpra\u0161evanje (brez predpla\u010Dila)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    className: "mr-2 align-middle",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "primary",
                                        disabled: check_count != 1,
                                        onClick: ()=>this.openCreateReservationDialog(this.state.table_items[check_ids[0]]),
                                        children: "Ustvari rezervacijo"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ButtonGroup), {
                                    className: "mr-2 align-middle",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                        intent: "warning",
                                        disabled: check_count == 0,
                                        onClick: this.openSelectNewStatusDialog,
                                        children: "Spremeni status"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.ButtonGroup), {
                                    className: "mr-2 align-middle",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "danger",
                                            disabled: check_count == 0,
                                            loading: this.state.button_confirm_loading,
                                            onClick: this.openReviewReservationCancellationDialog,
                                            children: "Storniraj povpra\u0161evanje"
                                        }),
                                        !this.props.public_accommodation_settings.prepayment_enabled ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                                            intent: "danger",
                                            disabled: check_count == 0,
                                            loading: this.state.button_confirm_loading,
                                            onClick: this.openReviewReservationAskCancellationDialog,
                                            children: "Vpra\u0161aj glede stornacije"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 pl-4 pr-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-grow",
                                style: {
                                    flexBasis: '0'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Results, {
                                    table_items: this.state.table_items,
                                    table_items_sort_ids: this.state.table_items_sort_ids,
                                    table_items_sort_field: this.state.table_items_sort_field,
                                    table_items_sort_direction: this.state.table_items_sort_direction,
                                    setTableItemsSort: this.setTableItemsSort,
                                    openAddEditItemDialog: ()=>{},
                                    tableItemsFilters: this.state.table_items_filters,
                                    originalTableItemsFilters: this.state.original_table_items_filters,
                                    handleFilterChange: this.handleFilterChange,
                                    table_items_checked_ids: this.state.table_items_checked_ids,
                                    rowCheckStateChanged: (id, state)=>{
                                        let table_items_checked_ids = this.state.table_items_checked_ids;
                                        if (state === false) delete table_items_checked_ids[id];
                                        else table_items_checked_ids[id] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    allRowsCheckStateChanged: (state)=>{
                                        const table_items_checked_ids = {};
                                        for(let i = 0; i < this.state.table_items_sort_ids.length; i++)table_items_checked_ids[this.state.table_items_sort_ids[i]] = state;
                                        this.setState({
                                            table_items_checked_ids
                                        });
                                    },
                                    customers: this.props.customers,
                                    countries: this.props.countries,
                                    calculateDayCount: this.calculateDayCount,
                                    getAccommodationTitle: this.getAccommodationTitle,
                                    general_settings: this.props.general_settings,
                                    openQuickEditCheckInOutDialog: this.openQuickEditCheckInOutDialog,
                                    openQuickEditPeopleDialog: this.openQuickEditPeopleDialog,
                                    reservation_request_accommodations: this.props.reservation_request_accommodations,
                                    getCustomerInfo: this.getCustomerInfo,
                                    public_accommodation_places: this.state.public_accommodation_places
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
ReservationRequestsList.propTypes = {};
function mapStateToProps(state) {
    return {
        reservation_requests: state.ReservationSlice.reservation_requests,
        reservation_request_accommodations: state.ReservationSlice.reservation_request_accommodations,
        reservations: state.ReservationSlice.reservations,
        public_accommodations: state.ReservationSlice.public_accommodations,
        public_accommodation_settings: state.ReservationSlice.public_accommodation_settings,
        customers: state.CodeTablesSlice.customers,
        countries: state.CodeTablesSlice.countries,
        accommodations: state.CodeTablesSlice.accommodations,
        accommodation_items: state.CodeTablesSlice.accommodation_items,
        accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
        channels: state.CodeTablesSlice.channels,
        general_settings: state.SettingsSlice.general,
        api_url: state.BusinessSlice.api_url,
        token: state.UserSlice.token,
        document_associations: state.DocumentSlice.document_associations_id_documents
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReservationRequestsList);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"5DyKE","uuid":"b52pV","moment":"1e4qG","@blueprintjs/core":"6Mq52","@blueprintjs/datetime2":"2mpOL","../../slices/ReservationSlice":"kTPna","../../api/Reservations":"8B3n3","../reservations/Reservation":"a8Yu8","../../slices/DocumentSlice":"6gdAm","../../api/Documents":"hSEi5","../code_tables/ResultComponents":"1eVlZ","../reservations/PeopleCountInput":"g0Iaj","./Utils":"akfaO","../../helpers/ReservationHelper":"ibz2t","../../utils":"kh8Vf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"akfaO":[function(require,module,exports,__globalThis) {
// if you change this function, change it in PublicReservationsServiceRequest as well
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getReservationRequestItemServices", ()=>getReservationRequestItemServices);
var _jsxRuntime = require("react/jsx-runtime");
function getReservationRequestItemServices(item, accommodation, type, return_html) {
    const lang = 'sl';
    let services_info = null;
    if (accommodation[type] !== null) {
        const item_services = item[type] ?? {};
        const items = accommodation[type].filter((x)=>item_services[x.key] !== undefined);
        let results = items.length == 0 ? null : items.map((service)=>{
            let val = null;
            if (service.type == 'bool') {
                if (!item_services[service.key]) return null;
            } else if (service.type == 'count') {
                val = item_services[service.key] ?? 0;
                if (val == 0) return null;
            } else if (service.type == 'counts') {
                const vals = item_services[service.key] === null || item_services[service.key] === undefined ? [] : service.values.filter((val)=>item_services[service.key][val.key] !== undefined);
                if (vals.length == 0) return null;
                val = vals.map((val)=>{
                    if (return_html) return val.title[lang] + ': <span class=\'strong\'>' + item_services[service.key][val.key] + '</span>';
                    return val.title[lang] + ': ' + item_services[service.key][val.key];
                }).join(', ');
            }
            if (return_html) return service.title[lang] + (val === null ? '' : ': <span class=\'strong\'>' + val + '</span>');
            return service.title[lang] + (val === null ? '' : ': ' + val);
        });
        if (results !== null) {
            if (return_html) {
                results = results.map((x, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: x
                        }
                    }, 'service-' + idx));
                services_info = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: results
                });
            } else services_info = results.join('\n');
        }
    }
    return services_info;
}

},{"react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jDyVS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditInvoiceDialogHelperCloseDialog", ()=>EditInvoiceDialogHelperCloseDialog);
parcelHelpers.export(exports, "EditInvoiceDialogHelperComponent", ()=>EditInvoiceDialogHelperComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _uuid = require("uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _react = require("@honeybadger-io/react");
var _waitFiscalVerificationDialog = require("./business/WaitFiscalVerificationDialog");
var _waitFiscalVerificationDialogDefault = parcelHelpers.interopDefault(_waitFiscalVerificationDialog);
var _editInvoiceDialog = require("./business/EditInvoiceDialog");
var _editInvoiceDialogDefault = parcelHelpers.interopDefault(_editInvoiceDialog);
var _invoiceCreator = require("../helpers/InvoiceCreator");
var _invoiceCreatorDefault = parcelHelpers.interopDefault(_invoiceCreator);
var _businessSlice = require("../slices/BusinessSlice");
var _documentSlice = require("../slices/DocumentSlice");
var _appSlice = require("../slices/AppSlice");
var _business = require("../api/Business");
var _cashRegisters = require("../api/CashRegisters");
async function EditInvoiceDialogHelperCloseDialog(dispatch, token, api_url, document_types, setWaitFiscalVerificationDialogIdInvoice, openInvoiceDialog, item, open_create_invoice_type, finish_invoice) {
    if (item !== undefined) {
        dispatch((0, _businessSlice.addInvoice)({
            item,
            token
        }));
        const new_items = await (0, _business.saveInvoice)(api_url, item, token, dispatch);
        if (new_items !== null) {
            if (new_items.invoices !== undefined) dispatch((0, _businessSlice.addInvoices)(new_items.invoices));
            if (new_items.document_associations !== undefined) dispatch((0, _documentSlice.addDocumentAssociations)(new_items.document_associations));
            if (new_items.advance_invoice_consumptions !== undefined) dispatch((0, _businessSlice.addAdvanceInvoiceConsumptions)(new_items.advance_invoice_consumptions));
            if (finish_invoice && document_types[item.invoice_type].fiscal_verification_enabled) setWaitFiscalVerificationDialogIdInvoice(item.id_invoice);
        }
    }
    if (open_create_invoice_type !== undefined) {
        const new_item = (0, _invoiceCreatorDefault.default).Duplicate(item);
        new_item.id_invoice = (0, _uuidDefault.default).v4();
        new_item.invoice_number = '';
        new_item.invoice_number_internal = '';
        new_item.invoice_type = open_create_invoice_type;
        new_item.draft = true;
        new_item.reference = item.invoice_number_internal;
        new_item.original_id_invoice = item.id_invoice;
        new_item.original_invoice_type = item.invoice_type;
        new_item.note = '';
        if (open_create_invoice_type == 'prepayment-invoice') {
            new_item.invoice_date = (0, _momentDefault.default)().format('YYYY-MM-DD');
            new_item.payment_date = (0, _momentDefault.default)().format('YYYY-MM-DD');
        }
        for(let i = 0; i < new_item.payments.length; i++)new_item.payments[i].id_invoice_payment = null;
        for(let i = 0; i < new_item.items.length; i++)new_item.items[i].id_invoice_item = (0, _uuidDefault.default).v4();
        setTimeout(()=>{
            openInvoiceDialog(new_item, open_create_invoice_type);
        }, 1000);
    }
}
function EditInvoiceDialogHelperComponent(props) {
    const { invoice_dialog_open, closeInvoiceDialog, invoice_dialog_item, invoice_dialog_type, invoice_dialog_advance_invoices_amounts, wait_fiscal_verification_dialog_id_invoice, invoices, general_settings, dispatch, setWaitFiscalVerificationDialogIdInvoice } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            invoice_dialog_open === false ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editInvoiceDialogDefault.default), {
                closeEditInvoiceDialog: closeInvoiceDialog,
                item: invoice_dialog_item,
                type: invoice_dialog_type,
                selected_advance_invoices_amounts: invoice_dialog_advance_invoices_amounts
            }),
            wait_fiscal_verification_dialog_id_invoice === null ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _waitFiscalVerificationDialogDefault.default), {
                closeWaitFiscalVerificationDialog: (print)=>{
                    setWaitFiscalVerificationDialogIdInvoice(null);
                    if (print) {
                        const invoice = invoices[wait_fiscal_verification_dialog_id_invoice];
                        if (wait_fiscal_verification_dialog_id_invoice === undefined || invoice === undefined) (0, _react.Honeybadger).notify('Invoice or id are null', {
                            name: 'Warning',
                            wait_fiscal_verification_dialog_id_invoice,
                            invoice
                        });
                        console.log({
                            auto_print_type: general_settings.auto_print_type,
                            invoice
                        });
                        if (general_settings.auto_print_type == 'a4') dispatch((0, _appSlice.enqueueInvoiceOnA4PrinterQueue)({
                            type: 'invoice',
                            lang: 'sl',
                            invoice
                        }));
                        else if (general_settings.auto_print_type == 'pos') dispatch((0, _appSlice.enqueueInvoiceOnPosPrinterQueue)({
                            type: 'invoice',
                            invoice
                        }));
                    }
                },
                id_invoice: wait_fiscal_verification_dialog_id_invoice
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","uuid":"b52pV","@honeybadger-io/react":"jFoJ4","./business/WaitFiscalVerificationDialog":"bvSNl","./business/EditInvoiceDialog":"kxL93","../helpers/InvoiceCreator":"d7VsE","../slices/BusinessSlice":"47JXm","../slices/DocumentSlice":"6gdAm","../slices/AppSlice":"aByTQ","../api/Business":"fC7Hd","../api/CashRegisters":"ixrrZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lj4sn":[function(require,module,exports,__globalThis) {
// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "register", ()=>register);
parcelHelpers.export(exports, "unregister", ()=>unregister);
const isLocalhost = Boolean(window.location.hostname === 'localhost' || // [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function register(config) {
    if ('serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL("/", window.location.href);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener('load', ()=>{
            const swUrl = `${"/"}/service-worker.js`;
            if (isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(()=>{
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA");
                });
            } else // Is not localhost. Just register service worker
            registerValidSW(swUrl, config);
        });
    }
}
function registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                        // Execute callback
                        if (config && config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log('Content is cached for offline use.');
                        // Execute callback
                        if (config && config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error('Error during service worker registration:', error);
    });
}
function checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get('content-type');
        if (response.status === 404 || contentType != null && contentType.indexOf('javascript') === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
    }).catch(()=>{
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function unregister() {
    if ('serviceWorker' in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}]},["f6pFz","7zcRT"], "7zcRT", "parcelRequire94c2")

//# sourceMappingURL=index.4842bf58.js.map
